(function () {
    "use strict";

    angular.module("app.report.mpp_cost_report_detail", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.mpp_cost_report_detail", {
            url: "/mpp-cost/detail",
            views: {
                report: {
                    templateUrl: "app/main/report/mpp/cost/detail/detail.html",
                    controller: "MppReportCostDetailController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.mpp_cost_report_detail")
        .controller("MppReportCostDetailController", Controller);

    Controller.$inject = ["$stateParams", "$timeout", "$window", "$localStorage"];

    /* @ngInject */
    function Controller($stateParams, $timeout, $window, $localStorage) {
        var vm = this;
        vm.count = 0;
        vm.listReport = [];
        vm.getDataFromObj = getCostElement;
        vm.search = '';
        activate();

        function activate() {
            if ($stateParams.obj) {
                vm.listReport = $stateParams.obj.list;
                vm.years = $stateParams.obj.years;
            } else {
                if ($localStorage.reportCostDetail) {
                    vm.listReport = $localStorage.reportCostDetail;
                    vm.years = $localStorage.reportCostDetailYears;
                }
            }
            angular.element(document.body).block();
            $timeout(function () {
                angular.element(document.body).unblock();
            }, 2000);
        }

        function getCostElement(data, key) {
            var ctr = data.length;
            for (var i = 0; i < ctr; i++) {
                if (data[i][key] > 0) {
                    return data[i][key];
                }
            }
            return 0;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.behaviour_performance_team.set-behaviour', [])
        .config(config);

     config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
      $stateProvider
             .state('app.pms_behaviour_performance_team_set_behaviour', {
                url    : '/pms/behaviour-performance-team/set-behaviour/set-behaviour/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/behaviour-performance-team/set-behaviour/set-behaviour.html',
                        controller : 'BehaviourperformancesetteamController as vm'
                    }
                }
            });   

                
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.pms.behaviour_performance_team.set-behaviour')
        .controller('inputBehaviourperformancesetteamController', inputBehaviourperformancesetteamController);
    
    /* @ngInject */
    inputBehaviourperformancesetteamController.$inject=['$mdDialog','$http','nik','effectiveDate','resultDate','resultDateAlias','listInput','config','Form','AppAPI','Auth'];
    function inputBehaviourperformancesetteamController($mdDialog,$http,nik,effectiveDate,resultDate,resultDateAlias,listInput,config,Form,AppAPI,Auth){
      var vm =this;
      
      var Behivor = AppAPI.Behivorteam();
      vm.loadData = loadData;
      vm.saveData=saveData;
      vm.listBid = [];
      vm.cancel=cancel;
      vm.effectiveDate=effectiveDate;
      vm.resultDate=resultDate;
      vm.resultDateAlias=resultDateAlias;
      vm.nik=nik;

      Form.initialForm();

        // set constructor form
        Form.setObject(Behivor);

        // set form to controller
        vm.Form = Form;
       
        loadData();

        function loadData() {
          angular.element.blockUI();
          var dataPromise = Behivor.query({action:'viewRefDataInputTeam',nik:nik,resultDate:resultDate});
          dataPromise.$promise.then(fetchData);
          dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
          vm.listInput = data;
          vm.Form.objForm.list=data;
          loadLevelData();
          angular.element.unblockUI();
        }

        function errorFetch() {
          vm.listInput = [];
          angular.element.unblockUI();
        }

        vm.setToken=Auth.setToken;

        function saveData(ev,formController) {
          vm.Form.objForm.resultDate=vm.resultDate;
          vm.Form.objForm.effectiveDate=vm.effectiveDate;
          vm.Form.objForm.nik=vm.nik;
          var promise= Form.saveData('saveinputteam', formController, Behivor);
          promise.then(successSaveData);
          promise.catch(failedSaveData);
        }

        function successSaveData() {
          vm.messageTheme='green';
        }

        function failedSaveData() {
          vm.messageTheme='red';
        }

        function loadLevelData() {
          var dataPromise = Behivor.query({action:'viewleveldata'});
          dataPromise.$promise.then(fetchLevelData);
          dataPromise.$promise.catch(errorLevelFetch);
        }

        function fetchLevelData(data) {
          vm.listInputLevel = data;
          angular.element.unblockUI();
        }

        function errorLevelFetch() {
          vm.listInputLevel = [];
          angular.element.unblockUI();
        }
        
        // function hide() {
        //   $mdDialog.hide();
        // }
       
        function cancel(){
       	  $mdDialog.cancel();
        }       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.pms.behaviour_performance_team.set-behaviour')
        .controller('editBehaviourperformancesetteamController', editBehaviourperformancesetteamController);

    
    /* @ngInject */
    editBehaviourperformancesetteamController.$inject=['$mdDialog','$http','resultA','resultB','resultC','resultD','nik','resultDateAlias','effectiveDate','resultDate','listInput','config','Form','AppAPI','Auth','$timeout'];
    function editBehaviourperformancesetteamController($mdDialog,$http,resultA,resultB,resultC,resultD,nik,resultDateAlias,effectiveDate,resultDate,listInput,config,Form,AppAPI,Auth,$timeout) 
    {
       
         var vm =this;
      
       var Behivor = AppAPI.Behivor();
       vm.loadData = loadData;
       vm.saveData=saveData;
       vm.listBid = [];
       vm.cancel=cancel;
       vm.effectiveDate=effectiveDate;
       vm.resultDate=resultDate;
       vm.nik=nik;
       vm.Input=listInput;
       vm.resultDateAlias=resultDateAlias;
       vm.showLevelDetail = showLevelDetail;

       Form.initialForm();
         // set constructor form
        Form.setObject(Behivor);

        // set form to controller
        vm.Form = Form;

       
      
       

       
       loadData();

        function loadData() {
           angular.element.blockUI();
           var dataPromise = Behivor.query({action:'viewRefDataInputTeam',nik:nik,resultDate:resultDate});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listInput = data;
             vm.Form.objForm.list=data;
             vm.Form.objForm.list[0].resultN1=parseInt(resultA);
       vm.Form.objForm.list[1].resultN1=parseInt(resultB);
       vm.Form.objForm.list[2].resultN1=parseInt(resultC);
       vm.Form.objForm.list[3].resultN1=parseInt(resultD);

          loadLevelData();

            // angular.element.unblockUI();

        }

        function errorFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadLevelData() {
           var dataPromise = Behivor.query({action:'viewleveldata'});
           dataPromise.$promise.then(fetchLevelData);
           dataPromise.$promise.catch(errorLevelFetch); 
        }

        function fetchLevelData(data) {
            vm.listInputLevel = data;
            angular.element.unblockUI();

        }

        function errorLevelFetch() {
            vm.listInputLevel = [];
            angular.element.unblockUI();
        }

        function showLevelDetail(behivor, level) {
            // vm.listLevelDetails = [];
            // for(var i = 0; i <= (vm.listLevel.length - 1); i++) {
            //     for(var ii = 0; ii <= (vm.listLevel[i].details.length - 1); ii++) {
            //         if(typeof(vm.listLevel[i].details[ii]) !== undefined) {                        
            //             vm.listLevelDetails.push(vm.listLevel[i].details[ii]);                        
            //             //if(vm.listLevel[i].details[ii].level === level) {
            //             //     vm.listLevelDetails.push(vm.listLevel[i].details[ii]);
            //             //}
            //         }
            //     }
            // }

            var el = document.getElementsByClassName("lists-level-details");
            for (var i = 0; i <= (el.length - 1); ++i) {
                el[i].setAttribute('style','');
            }

            var el = document.getElementsByClassName("lists-level-details-"+ behivor + '' +level);
            for (var i = 0; i <= (el.length - 1); ++i) {
                el[i].setAttribute('style','background-color: #BCECDD;');
            }

        }


 vm.setToken=Auth.setToken;

          function saveData(ev,formController)
        {
            vm.Form.objForm.resultDate=vm.resultDate;
            vm.Form.objForm.effectiveDate=vm.effectiveDate;
            vm.Form.objForm.nik=vm.nik;

          var promise= Form.saveData('updateinputteam', formController, Behivor);

          promise.then(successSaveData);
          promise.catch(failedSaveData);
        }

         function successSaveData()
        {
          vm.messageTheme='green';

          $timeout(function() {
            $mdDialog.cancel();
          }, 1000);

        }

        function failedSaveData()
        {
          vm.messageTheme='red';
        }
        

        ////////////////
        function hide()
        {
          $mdDialog.hide();
        }
       
        function cancel()
        {
       	  $mdDialog.cancel();
        }

       
    }
})();
(function () {
    "use strict";

    angular.module('app.mtx.transaksi.mtx-monitoring-score', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_transaksi_mtx_monitoring_score', {
                url: '/mtx/transaksi/mtx-monitoring-score',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/transaksi/mtx-monitoring-score/mtx-monitoring-score.html',
                        controller: 'MtxMonitoringScoreController as vm'
                    }
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.transaksi.mtx-monitoring-score')
        .controller('exportDataController', exportDataController);

    /* @ngInject */
    exportDataController.$inject = [
        '$mdDialog',
        '$http',
        'config',
        'Form',
        'AppAPI',
        'Auth',
        '$mdToast',
        '$element',
        'FileUploader',
        '$localStorage',
        '$scope',
        '$location',
        '$window'
    ];

    function exportDataController(
        $mdDialog,
        $http,
        config,
        Form,
        AppAPI,
        Auth,
        $mdToast,
        $element,
        FileUploader,
        $localStorage,
        $scope,
        $location,
        $window
    ) {
        var vm = this;
        Form.initialForm();
        var Mtx = AppAPI.Mtx();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.fileDataUpload = false;
        vm.upload = upload;
        vm.ExportDataExcel = ExportDataExcel;
        vm.saveDataCandidate = saveDataCandidate;


        function closeModal() {
            $mdDialog.hide();
        }

        function setTimeStamp(date) {
            if (date == null || date == undefined || date == '') {
                var dataTimeStamp = (new Date().getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            } else {
                var dataTimeStamp = (new Date(date).getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            }

        }

        function ExportDataExcel() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/mtx/monitoringExportPdf', '_blank');
            }, function () {
                $window.alert('gagal load token');
            });
        }


        vm.showNote = showNote;
        function showNote(data) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(data)
                    .position('top right')
                    .hideDelay(5000)
                    .theme("warn-toast")
            );
        }

    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.master.mtx-import-emp-assestment', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_master_mtx_import_emp_assestment', {
                url: '/mtx/master/mtx-import-emp-assestment',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/master/mtx-import-emp-assestment/mtx-import-emp-assestment.html',
                        controller: 'MtxImportEmpAssestmentScoreController as vm'
                    }
                }
            });

    }
}());

(function () {
    "use strict";

    angular
        .module('app.mtx.master.mtx-import-emp-assestment')
        .controller(
            "UploadEmpAssesment",
            UploadEmpAssesment
        );

    UploadEmpAssesment.$inject = [
        "$mdDialog",
        "$localStorage",
        "FileUploader",
        "config",
        "Auth",
        "$location",
        "$window",
        'mtx_category_id',
        'sub_area_id'
    ];

    /* @ngInject */
    function UploadEmpAssesment(
        $mdDialog,
        $localStorage,
        FileUploader,
        config,
        Auth,
        $location,
        $window,
        mtx_category_id,
        sub_area_id
    ) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.uploadFile = uploadFile;
        vm.viewMoreInfo = viewMoreInfo;
        vm.DownloadTemplate = DownloadTemplate;
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.pesan = "";
        vm.isMoreInfo = false;
        vm.sub_area_id = sub_area_id;
        vm.mtx_category_id = mtx_category_id;
        var uploadFile = (vm.FileUploader = new FileUploader({
            url: config.api + "api/mtx/uploadfileMtxAssesment",
            removeAfterUpload: true,
            alias: "fileimportmtxassesment",
            formData: [{ action: "uploadfileMtxAssesment", mtx_category_id: vm.mtx_category_id, sub_area_id: vm.sub_area_id }],
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        }));

        uploadFile.onSuccessItem = function (data, status, headers, config) {
            if (status.status == 0) {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }

            vm.uploadNotif = status.pesan;
            if ("moreInfo" in status && status.moreInfo.length > 0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }

            vm.uploadSuccess = true;
            vm.uploadError = false;
            vm.pesan = "Success Upload Data Employee Map Category";
            angular.element("#uploadFile").val("");
        };

        uploadFile.onErrorItem = function (item) {
            var obj = JSON.parse(item._xhr.response);
            vm.pesan = obj.pesan;
            vm.uploadSuccess = false;
            vm.uploadError = true;
        };

        // function uploadFile() {
        //     return false;
        // }

        function closeModal() {
            $mdDialog.hide();
        }

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        "://" +
                        host +
                        config.port +
                        config.api +
                        "api/checklistattendancegw/downloadtemplate",
                        "_blank"
                    );
                },
                function () {
                    $window.alert("Failed load token");
                }
            );
        }

        function viewMoreInfo() {
            $mdDialog.show({
                controller: "logFailGwController",
                controllerAs: "vm",
                templateUrl: "app/main/cb/ghk-gw/log-fail.html",
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: vm.detailInfo
                }
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.master.mtx-category', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_master_mtx_category', {
                url: '/mtx/master/mtx-category',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/master/mtx-category/mtx-category.html',
                        controller: 'MtxCategoryController as vm'
                    }
                }
            });

    }
}());

(function () {
    "use strict";

    angular
        .module("app.mtx.master.mtx-category")
        .controller("logFailUploadfileController", logFailUploadfileController);

    logFailUploadfileController.$inject = [
        "$localStorage",
        "DataService",
        "$mdDialog",
        "Form",
        "AppAPI",
        "$log",
        "config",
        "Auth",
        "$mdToast",
        "data"
    ];

    /* @ngInject */
    function logFailUploadfileController(
        $localStorage,
        DataService,
        $mdDialog,
        Form,
        AppAPI,
        $log,
        config,
        Auth,
        $mdToast,
        data
    ) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.logFail = data;
        console.log(data);
        function closeModal() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mtx.master.mtx-import-emp-assestment')
        .controller('exportDataController', exportDataController);

    /* @ngInject */
    exportDataController.$inject = [
        '$mdDialog',
        '$http',
        'config',
        'Form',
        'AppAPI',
        'Auth',
        '$mdToast',
        '$element',
        'FileUploader',
        '$localStorage',
        '$scope',
        '$location',
        '$window'
    ];

    function exportDataController(
        $mdDialog,
        $http,
        config,
        Form,
        AppAPI,
        Auth,
        $mdToast,
        $element,
        FileUploader,
        $localStorage,
        $scope,
        $location,
        $window
    ) {
        var vm = this;
        Form.initialForm();
        var Mtx = AppAPI.Mtx();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.fileDataUpload = false;
        vm.upload = upload;
        vm.ExportDataExcel = ExportDataExcel;
        vm.saveDataCandidate = saveDataCandidate;


        function closeModal() {
            $mdDialog.hide();
        }

        function setTimeStamp(date) {
            if (date == null || date == undefined || date == '') {
                var dataTimeStamp = (new Date().getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            } else {
                var dataTimeStamp = (new Date(date).getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            }

        }

        function ExportDataExcel() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/mtx/monitoringExportPdf', '_blank');
            }, function () {
                $window.alert('gagal load token');
            });
        }


        vm.showNote = showNote;
        function showNote(data) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(data)
                    .position('top right')
                    .hideDelay(5000)
                    .theme("warn-toast")
            );
        }

    }
})();

(function () {
    "use strict";

    angular
        .module('app.mtx.master.mtx-category')
        .controller(
            "UploadEmpToCategoryController",
            UploadEmpToCategoryController
        );

    UploadEmpToCategoryController.$inject = [
        "$mdDialog",
        "$localStorage",
        "FileUploader",
        "config",
        "Auth",
        "$location",
        "$window",
        'mtx_category_id',
        'sub_area_id'
    ];

    /* @ngInject */
    function UploadEmpToCategoryController(
        $mdDialog,
        $localStorage,
        FileUploader,
        config,
        Auth,
        $location,
        $window,
        mtx_category_id,
        sub_area_id
    ) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.uploadFile = uploadFile;
        vm.viewMoreInfo = viewMoreInfo;
        vm.DownloadTemplate = DownloadTemplate;
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.pesan = "";
        vm.isMoreInfo = false;
        vm.sub_area_id = sub_area_id;
        vm.mtx_category_id = mtx_category_id;
        var uploadFile = (vm.FileUploader = new FileUploader({
            url: config.api + "api/mtx/uploadfile",
            removeAfterUpload: true,
            alias: "filechecklistattendance",
            formData: [{ action: "uploadfile", mtx_category_id: vm.mtx_category_id, sub_area_id: vm.sub_area_id }],
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        }));

        uploadFile.onSuccessItem = function (data, status, headers, config) {
            if (status.status == 0) {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }

            vm.uploadNotif = status.pesan;
            if ("moreInfo" in status && status.moreInfo.length > 0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }

            vm.uploadSuccess = true;
            vm.uploadError = false;
            vm.pesan = "Success Upload Data Employee Map Category";
            angular.element("#uploadFile").val("");
        };

        uploadFile.onErrorItem = function (item) {
            var obj = JSON.parse(item._xhr.response);
            vm.pesan = obj.pesan;
            vm.uploadSuccess = false;
            vm.uploadError = true;
        };

        // function uploadFile() {
        //     return false;
        // }

        function closeModal() {
            $mdDialog.hide();
        }

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        "://" +
                        host +
                        config.port +
                        config.api +
                        "api/checklistattendancegw/downloadtemplate",
                        "_blank"
                    );
                },
                function () {
                    $window.alert("Failed load token");
                }
            );
        }

        function viewMoreInfo() {
            $mdDialog.show({
                controller: "logFailGwController",
                controllerAs: "vm",
                templateUrl: "app/main/cb/ghk-gw/log-fail.html",
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: vm.detailInfo
                }
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mtx.master.mtx-category")
        .controller("logFailUploadfileController", logFailUploadfileController);

    logFailUploadfileController.$inject = [
        "$localStorage",
        "DataService",
        "$mdDialog",
        "Form",
        "AppAPI",
        "$log",
        "config",
        "Auth",
        "$mdToast",
        "data"
    ];

    /* @ngInject */
    function logFailUploadfileController(
        $localStorage,
        DataService,
        $mdDialog,
        Form,
        AppAPI,
        $log,
        config,
        Auth,
        $mdToast,
        data
    ) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.logFail = data;
        console.log(data);
        function closeModal() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    "use strict";

    angular.module("app.mpp.report.cost", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mpp_report_cost_user", {
            url: "/report/costuser",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp/report/cost/cost.html",
                    controller: "MppReportCostUserController as vm"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.mpp.report.cost')
        .controller('MppReportCostUserDetailController', Controller);

    Controller.$inject = [
        'AppAPI',
        '$mdDialog',
        '$localStorage',
        '$state',
        'years',
        'layerID',
        '$timeout',
        'costCenter',
        'company',
        'empType',
        '$scope'
    ];

    /* @ngInject */
    function Controller(
        AppAPI,
        $mdDialog,
        $localStorage,
        $state,
        years,
        layerID,
        $timeout,
        costCenter,
        company,
        empType,
        $scope
    ) {
        var vm = this;
        var endpoint = new AppAPI.MppReportCost();
        vm.isWaiting = true;
        vm.showMessage = false;
        vm.closeDialog = closeDialog;
        vm.getDataFromObj = getCostElement;
        vm.listCost = [];
        vm.openNewTab = openNewTab;
        vm.search = '';
        vm.years = years;

        activate();

        function activate() {
            getDataDetail();
        }

        function getDataDetail() {
            var response = endpoint.query({
                action: 'getDetailCost',
                years: years,
                layerID: layerID,
                costCenter: costCenter,
                company: company,
                empType: empType
            });
            response.$promise.then(fetchResponseDataDetail);
            response.$promise.catch(catchResponseDataDetail);
        }

        function getCostElement(data, key) {
            var ctr = data.length;
            for (var i = 0; i < ctr; i++) {
                if (data[i][key] > 0) {
                    return data[i][key];
                }
            }
            return 0;
        }

        function fetchResponseDataDetail(response) {
            vm.listReport = response;
            $localStorage.reportCostDetail = vm.listReport;
            $localStorage.reportCostDetailYears = vm.years;
            $timeout(function() {
                vm.isWaiting = false;
            }, 2000);
            // console.log(response);
        }

        function catchResponseDataDetail(error) {
            vm.isWaiting = false;
            vm.showMessage = true;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function openNewTab() {
            $state.goNewTab('app.report.mpp_cost_report_detail', {
                obj: {
                    list: vm.listReport,
                    years: vm.years
                }
            });
        }

        $scope.$on('$destroy', function() {
            delete $localStorage.reportCostDetail;
            delete $localStorage.reportCostDetailYears;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.jic.emp_jic', ['app.jic.emp_jic.add', 'app.jic.emp_jic.edit', 'app.jic.emp_jic.revisied'])
        .config(config);

    config.$inject = ['$stateProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.emp_jic', {
                url: '/jic/emp_jic',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/jic/empjic/empjic.html',
                        controller: 'EmpJicController as vm'
                    }
                }
            });
    }
})();
(function () {
    'use strict';
    angular
        .module('app.jic.emp_jic')
        .controller('LookUpLayerController', LookUpLayerController);

    /** @ngInject */
    LookUpLayerController.$inject = ['$stateParams', '$mdDialog', '$localStorage', 'AppAPI', 'Auth', 'id'];
    /** @ngInject */
    function LookUpLayerController($stateParams, $mdDialog, $localStorage, AppAPI, Aut, id) {

        var vm = this;
        vm.cancel = cancel;
        var EmpJic = AppAPI.EmpJic();

        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.selectedCange = selectedCange;
        vm.company = id.company;
        vm.divisi = id.divisi;
        vm.department = id.department;
        vm.loadLayerData = loadLayerData;
        vm.chooseEmployee = chooseEmployee;
        vm.isLoadingLoadEmployee = true;
        vm.directReport = null;
        vm.disable = id.disable;

        // console.log(id);

        loadDataBU();
        loadDataDivision(vm.company)
        loadDataDepartment(vm.divisi, 0);
        loadLayerData();
        // activate(); 

        ////////////////////////////////////

        // function activate()
        // {
        //   var loadBu=loadDataBU();
        //   loadBu.then(function()
        //   {
        //     var loadDivsi=loadDataDivision(vm.company);
        //     loadDivsi.then(function(){
        //       var loadDept=loadDataDepartment(vm.divisi,0);
        //       loadDept.then(function(){
        //         loadLayerData();
        //       });
        //     });
        //   });
        // }

        function cancel() {
            $mdDialog.hide();
        }

        function loadDataDepartment(iddivisi, isChange) {
            vm.isLoadingLoadEmployee = true;
            var response = EmpJic.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            vm.isLoadingLoadEmployee = false;
        }

        function errorDepartment() {
            vm.listDepartment = [];
            vm.isLoadingLoadEmployee = false;
        }

        function loadDataDivision(idbu) {
            vm.isLoadingLoadEmployee = true;
            var response = EmpJic.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            vm.isLoadingLoadEmployee = false;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
            vm.isLoadingLoadEmployee = false;
        }

        function loadDataBU() {
            vm.isLoadingLoadEmployee = true;
            var response = EmpJic.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
            vm.isLoadingLoadEmployee = false;

        }

        function errorFetchBU() {
            vm.listBU = [];
            vm.isLoadingLoadEmployee = false;
        }

        function loadLayerData() {
            vm.saveProcess = true;
            vm.isLoadingLoadEmployee = true;
            var response = EmpJic.query({
                action: "getLayerData",
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                search: vm.searchParam,
                directreport: vm.directReport
            }
            );
            response.$promise.then(fetchEmp);
            response.$promise.catch(errorFetchEmp);

        }

        function fetchEmp(data) {
            vm.empList = data;
            vm.isLoadingLoadEmployee = false;
        }

        function errorFetchEmp() {
            vm.isLoadingLoadEmployee = false;
        }

        function selectedCange(v) {
            switch (v) {
                case 'dept':
                    loadLayerData();
                    break;
                case 'div':
                    vm.directReport=null;
                    loadDataDepartment(vm.divisi, 0);
                    break;
                case 'comp':
                    loadDataDivision(vm.company);
                    break;
            }
        }

        function chooseEmployee(item) {
            $localStorage.seleEctedJob = item;
            $localStorage.seleEctedJob.filter = {
                division_id: vm.divisi,
                company: vm.company,
                directReport: vm.directReport,
                department_id: vm.department
            };
            $mdDialog.hide($localStorage.seleEctedJob);
        }


    }
})();

(function () {
    'use strict';
    angular
        .module('app.jic.emp_jic')
        .controller('EmpJicLookupStafEmployeeController', EmpJicLookupStafEmployeeController);

    EmpJicLookupStafEmployeeController.$inject = [
        '$localStorage',
        '$mdDialog',
        'AppAPI',
        'Form',
        'DataService'
    ];
    /** @ngInject */
    function EmpJicLookupStafEmployeeController(
        $localStorage,
        $mdDialog,
        AppAPI,
        Form,
        DataService
    ) {

        var vm = this;
        var EmpJic = AppAPI.EmpJic();

        Form.initialForm();
        Form.setObject(EmpJic);
        vm.Form = Form;
        vm.cancel = cancel;
        vm.nik = $localStorage.user;
        vm.chooseEmployee = chooseEmployee;
        vm.selectedEmployee = {};
        vm.employeeLists = [];
        vm.loadData = loadData;
        vm.close = close;
        vm.DataTable = new DataService();
        vm.DataTable.jumDataPerPage = 5;
        vm.DataTable.searchParam = '';
        $localStorage.selectedEmployee = {};

        loadData(1);

        function loadData(pageno) {

            var response = vm.DataTable.loadData(EmpJic, pageno, {
                action: 'getEmployee',
                nik_atasan: vm.nik
            });

            response.then(function (data) {
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    // var exist = exists(vm.DataTable.list[i], $localStorage.selectedEmployee);
                    if (vm.DataTable.list[i] == $localStorage.selectedEmployee) {
                        vm.DataTable.list[i].selected = true;
                    }
                }
                vm.isLoadingLoadEmployee = false;
            });

            response.catch(function (error) {
                vm.employeeLists = [];
                vm.isLoadingLoadEmployee = false;
            });

        }

        function chooseEmployee(item) {
            $localStorage.selectedEmployee = item;
            $mdDialog.hide($localStorage.selectedEmployee);
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('app.jic.emp_jic')
        .controller('EmpJicLookupEmployeeAtasanController', EmpJicLookupEmployeeAtasanController);

    EmpJicLookupEmployeeAtasanController.$inject = ['$stateParams', '$mdDialog', '$localStorage', 'AppAPI', 'Auth', 'id'];
    /** @ngInject */
    function EmpJicLookupEmployeeAtasanController($stateParams, $mdDialog, $localStorage, AppAPI, Aut, id) {

        var vm = this;
        vm.cancel = cancel;
        var EmpJic = AppAPI.EmpJic();
        var EmpJic = AppAPI.EmpJic();

        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.selectedCange = selectedCange;
        vm.company = id.company;
        vm.divisi = id.divisi;
        vm.department = id.department;
        vm.loadEmployeeData = loadEmployeeData;
        vm.chooseEmployee = chooseEmployee;
        vm.loadEmployeeData = loadEmployeeData;
        vm.isLoadingLoadEmployee = false;

        // console.log(id);

        loadDataBU();
        loadDataDivision(vm.company)
        loadDataDepartment(vm.divisi, 0);
        loadEmployeeData();

        ////////////////////////////////////

        function cancel() {
            $mdDialog.hide();
        }

        function loadDataDepartment(iddivisi, isChange) {
            vm.isLoadingLoadEmployee = true;

            var response = EmpJic.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            vm.isLoadingLoadEmployee = false;
            loadEmployeeData();
        }

        function errorDepartment() {
            vm.listDepartment = [];
            vm.isLoadingLoadEmployee = false;
        }

        function loadDataDivision(idbu) {
            vm.saveProcess = true;
            var response = EmpJic.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            vm.isLoadingLoadEmployee = false;
            // vm.listDivision.push(data); 
            // loadData(1); 
        }

        function errorDivisiBU() {
            vm.listDivision = [];
            vm.isLoadingLoadEmployee = false;
        }

        function loadDataBU() {
            vm.saveProcess = true;
            var response = EmpJic.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
            vm.isLoadingLoadEmployee = false;

        }

        function errorFetchBU() {
            vm.listBU = [];
            vm.isLoadingLoadEmployee = false;
        }

        function loadEmployeeData() {
            vm.isLoadingLoadEmployee = true;
            vm.saveProcess = true;
            var response = EmpJic.query({
                action: "getemployeeAtasan",
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                search: vm.searchParam
            }
            );
            response.$promise.then(fetchEmp);
            response.$promise.catch(errorFetchEmp);

        }

        function fetchEmp(data) {
            vm.empList = data;
            vm.isLoadingLoadEmployee = false;
        }

        function errorFetchEmp() {
            vm.Form.objForm.directReport = null;
            vm.isLoadingLoadEmployee = false;
        }

        function selectedCange(v) {
            switch (v) {
                case 'dept':
                    loadEmployeeData();
                    break;
                case 'div':
                    loadDataDepartment(vm.divisi, 0);
                    break;
                case 'comp':
                    loadDataDivision(vm.company);
                    break;
            }
        }

        function chooseEmployee(item) {
            $localStorage.selectedEmployee = item;
            $mdDialog.hide($localStorage.selectedEmployee);
        }

    }
})();  

(function () {
    'use strict';

    angular
        .module('app.employee.employe_admin', [])
        .config(config);

    config.$inject = ['$stateProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.employee_employe_admin', {
                url: '/employee/employe-production',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employee/employe-admin/employe-admin.html',
                        controller: 'EmployeAdminController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe_admin')
        .controller('HasilCheckDataGroupShiftController', HasilCheckDataGroupShiftController);

    HasilCheckDataGroupShiftController.$inject = ['$state', '$mdDialog', 'config', '$localStorage', '$timeout', 'AppAPI', 'Auth', 'FileUploader', '$location', '$window', 'dataUpload', '$mdToast'];

    /* @ngInject */
    function HasilCheckDataGroupShiftController($state, $mdDialog, config, $localStorage, $timeout, AppAPI, Auth, FileUploader, $location, $window, dataUpload, $mdToast) {
        var vm = this;
        var EMP = AppAPI.Employe();


        vm.closeModal = closeModal;
        vm.listDataUpload = dataUpload;
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.updateAll = updateAll;
        vm.selected =[];

        function closeModal() {
            $mdDialog.hide();
        }

        function updateAll() {
            angular.element.blockUI();
            var dataSimpan =vm.selected;
            // for (var i = 0; i < vm.listDataUpload.length; i++) {
            //     if (vm.listDataUpload[i].check) {
            //         dataSimpan.push(vm.listDataUpload[i])
            //     }
            // }

            if (dataSimpan.length > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var emp = new EMP();
                    emp.data = dataSimpan;
                    emp.action = "saveDataEmpGroupShiftAdmin";
                    var response = emp.$save();
                    response.then(function (data) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent('Data Berhasil disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                        );
                        angular.element.unblockUI();
                        closeModal();
                    });
                    response.catch(function (data) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent('Data Gagal disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                        );
                        angular.element.unblockUI();
                    });
                });
            } else {
                angular.element.unblockUI();
            }

        }

        vm.toggle = function (item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        }
        else {
          list.push(item);
        }
      };

      vm.exists = function (item, list) {
        return list.indexOf(item) > -1;
      };

      vm.isIndeterminate = function() {
        return (vm.selected.length !== 0 &&
            vm.selected.length !== vm.listDataUpload.length);
      };

      vm.isChecked = function() {
        return vm.selected.length === vm.listDataUpload.length;
      };

      vm.toggleAll = function() {
        if (vm.selected.length === vm.listDataUpload.length) {
          vm.selected = [];
        } else if (vm.selected.length === 0 || vm.selected.length > 0) {
          vm.selected = vm.listDataUpload.slice(0);
        }
      };


    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe_admin')
        .controller('HasilCheckDataAtasanController', HasilCheckDataAtasanController);

    HasilCheckDataAtasanController.$inject = ['$state', '$mdDialog', 'config', '$localStorage', '$timeout', 'AppAPI', 'Auth', 'FileUploader', '$location', '$window', 'dataUpload', '$mdToast'];

    /* @ngInject */
    function HasilCheckDataAtasanController($state, $mdDialog, config, $localStorage, $timeout, AppAPI, Auth, FileUploader, $location, $window, dataUpload, $mdToast) {
        var vm = this;
        var EMP = AppAPI.Employe();


        vm.closeModal = closeModal;
        vm.listDataUpload = dataUpload;
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.updateAll = updateAll; 
        vm.selected =[];
        // console.log(vm.listDataUpload);

        function closeModal() {
            $mdDialog.hide();
        }

        function updateAll() {
            // console.log('emp');

            angular.element.blockUI();
            var dataSimpan = vm.selected;
            // for (var i = 0; i < vm.listDataUpload.length; i++) {
            //     if (vm.listDataUpload[i].check) {
            //         dataSimpan.push(vm.listDataUpload[i])
            //     }
            // }


            if (dataSimpan.length > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var emp = new EMP();
                    emp.data = dataSimpan;
                    emp.action = "saveDataEmpAtasanAdmin";
                    var response = emp.$save();
                    response.then(function (data) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent('Data Berhasil disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                        );
                        angular.element.unblockUI();
                        closeModal();
                    });
                    response.catch(function (data) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent('Data Gagal disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                        );
                        angular.element.unblockUI();
                    });
                });
            } else {
                angular.element.unblockUI();
            }

        }

       vm.toggle = function (item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        }
        else {
          list.push(item);
        }
      };

      vm.exists = function (item, list) {
        return list.indexOf(item) > -1;
      };

      vm.isIndeterminate = function() {
        return (vm.selected.length !== 0 &&
            vm.selected.length !== vm.listDataUpload.length);
      };

      vm.isChecked = function() {
        return vm.selected.length === vm.listDataUpload.length;
      };

      vm.toggleAll = function() {
        if (vm.selected.length === vm.listDataUpload.length) {
          vm.selected = [];
        } else if (vm.selected.length === 0 || vm.selected.length > 0) {
          vm.selected = vm.listDataUpload.slice(0);
        }
      };


    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe_admin')
        .controller('HasilCheckDataController', HasilCheckDataController);

    HasilCheckDataController.$inject = ['$state', '$mdDialog', 'config', '$localStorage', '$timeout', 'AppAPI', 'Auth', 'FileUploader', '$location', '$window', 'dataUpload', '$mdToast'];

    /* @ngInject */
    function HasilCheckDataController($state, $mdDialog, config, $localStorage, $timeout, AppAPI, Auth, FileUploader, $location, $window, dataUpload, $mdToast) {
        var vm = this;
        var EMP = AppAPI.Employe();


        vm.closeModal = closeModal;
        vm.listDataUpload = dataUpload;
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.updateAll = updateAll;
        vm.selected =[];

        function closeModal() {
            $mdDialog.hide();
        }

        function updateAll() {
            // console.log('buil');

            angular.element.blockUI();
            var dataSimpan = vm.selected;
            // for (var i = 0; i < vm.listDataUpload.length; i++) {
            //     if (vm.listDataUpload[i].check) {
            //         dataSimpan.push(vm.listDataUpload[i])
            //     }
            // }

            if (dataSimpan.length > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var emp = new EMP();
                    emp.data = dataSimpan;
                    emp.action = "saveDataBuildingAdmin";
                    var response = emp.$save();
                    response.then(function (data) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent('Data Berhasil disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                        );
                        angular.element.unblockUI();
                        closeModal();
                    });
                    response.catch(function (data) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent('Data Gagal disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                        );
                        angular.element.unblockUI();
                    });
                });
            } else {
                angular.element.unblockUI();
            }

        }

        vm.toggle = function (item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        }
        else {
          list.push(item);
        }
      };

      vm.exists = function (item, list) {
        return list.indexOf(item) > -1;
      };

      vm.isIndeterminate = function() {
        return (vm.selected.length !== 0 &&
            vm.selected.length !== vm.listDataUpload.length);
      };

      vm.isChecked = function() {
        return vm.selected.length === vm.listDataUpload.length;
      };

      vm.toggleAll = function() {
        if (vm.selected.length === vm.listDataUpload.length) {
          vm.selected = [];
        } else if (vm.selected.length === 0 || vm.selected.length > 0) {
          vm.selected = vm.listDataUpload.slice(0);
        }
      };




    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe', [])
        .config(config);

    config.$inject = ['$stateProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider) {

        // State 
        $stateProvider
            .state('app.employee_employe_input', {
                url: '/employee/employe/input-employe',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employee/employe/input-employe/input-employe.html',
                        controller: 'InputemployeController as vm'
                    }
                }
            })

            .state('app.employee_employe_edit', {
                url: '/employee/employe/edit-employe/:id',
                abstract: true,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employee/employe/input-employe/edit-employe.html',
                        controller: 'EditemployeController as vm',
                        css: ['app/main/employee/employe/input-employe/edit-employe.scss']
                    }
                }
            })

            .state('app.employee_myemploye_edit', {
                url: '/employee/employe/edit-myemploye/:id',
                abstract: true,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employee/employe/input-employe/edit-myemploye.html',
                        controller: 'EditmyemployeController as vm',
                        css: ['app/main/employee/employe/input-employe/edit-employe.scss']
                    }
                }
            })

            .state('app.employee_employe_edit.profile', {
                url: '/profile/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/profile/input-profile.html',
                controller: 'ProfileemployeController as vm'
            })

            .state('app.employee_myemploye_edit.profile', {
                url: '/myprofile/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/profile/input-profile.html',
                controller: 'ProfileemployeController as vm'
            })

            .state('app.employee_employe_edit.address', {
                url: '/address/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/address/input-address.html',
                controller: 'AddressemployeController as vm'
            })

            .state('app.employee_myemploye_edit.address', {
                url: '/address/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/address/input-address.html',
                controller: 'AddressemployeController as vm'
            })

            .state('app.employee_employe_edit.dependent', {
                url: '/dependent/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/dependent/list-dependent.html',
                controller: 'DependentemployeController as vm'
            })

            .state('app.employee_myemploye_edit.dependent', {
                url: '/dependent/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/dependent/list-dependent.html',
                controller: 'DependentemployeController as vm'
            })

            .state('app.employee_employe_edit.employements', {
                url: '/employements/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/employement/list-employement.html',
                controller: 'EmployementsemployeController as vm'
            })

            .state('app.employee_myemploye_edit.employements', {
                url: '/employements/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/employement/list-employement.html',
                controller: 'EmployementsemployeController as vm'
            })

            .state('app.employee_employe_edit.worklocation', {
                url: '/worklocation/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/worklocation/list-worklocation.html',
                controller: 'WorklocationemployeController as vm'
            })

            .state('app.employee_myemploye_edit.worklocation', {
                url: '/worklocation/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/worklocation/list-worklocation.html',
                controller: 'WorklocationemployeController as vm'
            })

            .state('app.employee_employe_edit.status', {
                url: '/status/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/status/list-status.html',
                controller: 'StatusemployeController as vm'
            })

            .state('app.employee_myemploye_edit.status', {
                url: '/status/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/status/list-status.html',
                controller: 'StatusemployeController as vm'
            })

            .state('app.employee_employe_edit.skjic', {
                url: '/skjic/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/skjic/list-skjic.html',
                controller: 'SkjicemployeController as vm'
            })

            .state('app.employee_myemploye_edit.skjic', {
                url: '/skjic/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/skjic/list-skjic.html',
                controller: 'SkjicemployeController as vm'
            })

            .state('app.employee_employe_edit.termination', {
                url: '/termination/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/termination/termination.html',
                controller: 'TerminationemployeController as vm'
            })

            .state('app.employee_myemploye_edit.termination', {
                url: '/termination/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/termination/termination.html',
                controller: 'TerminationemployeController as vm'
            })

            .state('app.employee_employe_edit.emergency', {
                url: '/emergency/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/emergency/list-emergency.html',
                controller: 'EmergencyemployeController as vm'
            })

            .state('app.employee_myemploye_edit.emergency', {
                url: '/emergency/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/emergency/list-emergency.html',
                controller: 'EmergencyemployeController as vm'
            })

            .state('app.employee_employe_edit.imigration', {
                url: '/imigration/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/imigration/list-imigration.html',
                controller: 'ImigrationemployeController as vm'
            })

            .state('app.employee_employe_edit.education', {
                url: '/education/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/education/list-education.html',
                controller: 'EducationemployeController as vm'
            })

            .state('app.employee_myemploye_edit.education', {
                url: '/education/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/education/list-education.html',
                controller: 'EducationemployeController as vm'
            })

            .state('app.employee_employe_edit.language', {
                url: '/language/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/language/list-language.html',
                controller: 'LanguageemployeController as vm'
            })

            .state('app.employee_myemploye_edit.language', {
                url: '/language/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/language/list-language.html',
                controller: 'LanguageemployeController as vm'
            })

            .state('app.employee_employe_edit.experience', {
                url: '/experience/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/experience/list-experience.html',
                controller: 'ExperienceemployeController as vm'
            })

            .state('app.employee_myemploye_edit.experience', {
                url: '/experience/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/experience/list-experience.html',
                controller: 'ExperienceemployeController as vm'
            })

            .state('app.employee_employe_edit.certification', {
                url: '/certification/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/certification/list-certification.html',
                controller: 'CertificationemployeController as vm'
            })

            .state('app.employee_myemploye_edit.certification', {
                url: '/certification/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/certification/list-certification.html',
                controller: 'CertificationemployeController as vm'
            })

            .state('app.employee_employe_edit.training', {
                url: '/training/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/training/list-training.html',
                controller: 'TrainingemployeController as vm'
            })

            .state('app.employee_myemploye_edit.training', {
                url: '/training/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/training/list-training.html',
                controller: 'TrainingemployeController as vm'
            })

            .state('app.employee_employe_edit.bank', {
                url: '/bank/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/bank/input-bank.html',
                controller: 'BankemployeController as vm'
            })

            .state('app.employee_myemploye_edit.bank', {
                url: '/bank/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/bank/input-bank.html',
                controller: 'BankemployeController as vm'
            })

            .state('app.employee_employe_edit.tax', {
                url: '/tax/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/tax/input-tax.html',
                controller: 'TaxemployeController as vm'
            })

            .state('app.employee_myemploye_edit.tax', {
                url: '/tax/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/tax/input-tax.html',
                controller: 'TaxemployeController as vm'
            })

            .state('app.employee_employe_edit.document', {
                url: '/document/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/document/list-document.html',
                controller: 'DocumentemployeController as vm'
            })

            .state('app.employee_myemploye_edit.document', {
                url: '/document/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/document/list-document.html',
                controller: 'DocumentemployeController as vm'
            })

            .state('app.employee_myemploye_edit.usermanual', {
                url: '/user-manual',
                templateUrl: 'app/main/employee/employe/input-employe/user-manual/user-manual.html',
                controller: 'UsermanualController as vm'
            })

            .state('app.employee_myemploye_edit.joindate', {
                url: '/join-date/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/join-date/join-date.html',
                controller: 'JoindateController as vm'
            })

            .state('app.employee_employe_edit.joindate', {
                url: '/join-date-edit/:nik',
                templateUrl: 'app/main/employee/employe/input-employe/join-date/join-date-edit.html',
                controller: 'JoindateeditController as vm'
            })

        // .state('app.employee_employe_edit.promotion', {
        //     url    : '/promotion',
        //     templateUrl: 'app/main/employee/employe/input-employe/promotion/list-promotion.html',
        //     controller : 'PromotionemployeController as vm'
        // })

        // .state('app.employee_myemploye_edit.promotion', {
        //     url    : '/promotion',
        //     templateUrl: 'app/main/employee/employe/input-employe/promotion/list-promotion.html',
        //     controller : 'PromotionemployeController as vm'
        // })

        ;


    }
})();

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('WorklocationemployeController', WorklocationemployeController);


    WorklocationemployeController.$inject=['$stateParams','$document','$mdDialog','$log','Auth','Form','AppAPI','DTColumnDefBuilder','EmployeeService','DataService','$element','$filter', '$localStorage'];
    /** @ngInject */
    function WorklocationemployeController($stateParams,$document,$mdDialog,$log,Auth,Form,AppAPI,DTColumnDefBuilder,EmployeeService,DataService,$element,$filter,$localStorage)
    {
        
        var vm = this;
        vm.listJum = [2,5,25,50,75,100,200];
        vm.DataTable = new DataService();
        vm.viewData = viewData;
        vm.translateTemporary = translateTemporary;

        vm.showStateMove = $localStorage.empsite == 'RK' ? true : false;

        var translate = $filter('translate');
        
        EmployeeService.title = translate('MYPROFILE.MENU.WORKLOCATION');
        vm.EmployeeService = EmployeeService; 
        
        // initial form
        Form.initialForm(false);

        var Employe=  AppAPI.Employe();
        var Worklocation = AppAPI.Worklocation(); 
        vm.employe=employe;

        // set constructor form
        Form.setObject(Worklocation);

         
        // set form to controller
        vm.Form = Form; 
        vm.Form.objForm.is_temporary = '0';

        employe();
        function employe()
        {
            var response=Employe.get({action:'viewdetail',id:$stateParams.id});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye); 
        }
      
        function fetchEmploye(data) {
            vm.Form.objForm.title=data.title;
            vm.Form.objForm.firstName=data.firstName;
            vm.Form.objForm.middleName=data.middleName;
            vm.Form.objForm.lastName=data.lastName;
            vm.Form.objForm.empId=data.id; 
            vm.empId = data.id;
            vm.Form.objForm.photoAddress=data.photoAddress;
            vm.Form.objForm.effectiveDate=new Date();
        }

        function errorFetchEmploye() {
            console.log('error');
        }
       
        var response= Worklocation.query({action:'get_location'});
            response.$promise.then(function(data){
             vm.listMenu=data;
          });

          response.$promise.catch(function(data){
            // $log.info(data);
          });

        vm.openInputWorklocation = openInputWorklocation;
        vm.editInputWorklocation = editInputWorklocation;
        vm.closeModal = closeModal;

        vm.listData=[];
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listDataSelected=[];

        vm.saveData=saveData;
        vm.deleteData=deleteData;

        
        viewData(1);
        vm.dtOptions = {
            dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
          DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData(pageno) {
           angular.element.blockUI();
           var resp=vm.DataTable.loadData(Worklocation,pageno,{action:'viewData',emp_id:$stateParams.id});
           resp.then(function(){
            angular.element.unblockUI();
           });
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
           vm.listDataSelected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
           vm.listDataSelected=[];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }
       

        function openInputWorklocation(ev)
        {
            $mdDialog.show({
                controller         : 'WorklocationemployeController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/employe/input-employe/worklocation/input-worklocation.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData(1);
                    employe();
                }
            });
        }

        function editInputWorklocation(ev, id)
        {
            $mdDialog.show({
                controller         : 'WorklocationemployeeditController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/employe/input-employe/worklocation/input-worklocation.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData(1);
                    employe();
                },
                locals:{
                  id:id
                }
            });
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {
            vm.Form.objForm.effectiveDate_reformat = formController.effectiveDate.$viewValue;
            var promise= Form.saveData('save', formController, Worklocation);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function deleteData(ev) {
       
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=Worklocation.delete({action:'deleteworklocation',data:angular.toJson(vm.listDataSelected)});

                    response.$promise.then(viewData);
                }, function() {

                });
            });
      
       
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function translateTemporary(txt, placement) {
            if(placement == '1') {
                return 'Placement';
            } else {
                return txt == '1' ? 'Temporarily Moved' : 'Permanently Moved';
            }
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('WorklocationemployeeditController', WorklocationemployeeditController);

    /** @ngInject */
    WorklocationemployeeditController.$inject=['$mdDialog','id','AppAPI','Auth','Form','$element','$localStorage'];
    /** @ngInject */
    function WorklocationemployeeditController($mdDialog,id,AppAPI,Auth,Form,$element,$localStorage)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Worklocation=AppAPI.Worklocation();

	    // set constructor form
	    Form.setObject(Worklocation);

	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewDetail',id:id.id});
        response.then(changeDate);

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;

      vm.showStateMove = $localStorage.empsite == 'RK';

	    vm.messageTheme='pink';
         var response= Worklocation.query({action:'get_location'});
            response.$promise.then(function(data){
             vm.listMenu=data;
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

		vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function changeDate(data) {
           vm.Form.objForm.effectiveDate=new Date(data.effectiveDate);
           vm.Form.objForm.typeOfFamily=data.type_of_family;
           vm.Form.objForm.firstNameD=data.first_name;
           vm.Form.objForm.lastNameD=data.last_name;
           vm.Form.objForm.birthPlace=data.birth_place;
           vm.Form.objForm.photoAddress='';

           vm.Form.objForm.is_temporary='0';
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }


        function saveData(ev, formController) {
        	vm.Form.objForm.firstName=vm.Form.objForm.firstNameD;
        	vm.Form.objForm.effectiveDate_reformat = formController.effectiveDate.$viewValue;
           	vm.Form.objForm.lastName=vm.Form.objForm.lastNameD;
            var promise= Form.updateData('update',formController,Worklocation, Form.objForm.id,'viewDetail');
            promise.then(function(){
	            showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }
    }
    
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('UsermanualController', UsermanualController);


    UsermanualController.$inject=['$state','$stateParams','$timeout','Form','AppAPI','$document','EmployeeService','$filter'];
    /** @ngInject */
    function UsermanualController($state,$stateParams,$timeout,Form,AppAPI,$document,EmployeeService,$filter)
    {
        
        var vm = this;
        var translate = $filter('translate');

        EmployeeService.title = translate('MYPROFILE.MENU.USERMANUAL');

        vm.activeItem = [{
            label: 'Profile',
            link: 'app.employee_myemploye_edit.usermanual'
        }];

         // initial form
         Form.initialForm();

         var Profiles=  AppAPI.Profiles();
         var Employe= AppAPI.Employe();

         // set constructor form
         Form.setObject(Profiles);

         // set form to controller
         vm.Form = Form; 
         vm.tutorial_type='ebook';
         var urll=btoa('manual_user_database_employee.pdf');
         vm.url = 'assets/tutorial/'+atob(urll)+((vm.tutorial_type === 'ebook')?'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;':'')
  
         employe(); 

        
        function employe()
        {
            var response=Employe.get({action:'viewdetail',id:$stateParams.id});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }
         
        function fetchEmploye(data) { 
            console.log(data);
            vm.Form.objForm.photoAddress=data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        


    }
})();  

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('TrainingemployeController', TrainingemployeController);


    TrainingemployeController.$inject = ['$state', '$stateParams', '$document', '$mdDialog', '$localStorage', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'EmployeeService', 'FileUploader', 'config', '$filter'];
    /** @ngInject */
    function TrainingemployeController($state, $stateParams, $document, $mdDialog, $localStorage, Auth, Form, AppAPI, DTColumnDefBuilder, EmployeeService, FileUploader, config, $filter) {

        var vm = this;
        var translate = $filter('translate');

        EmployeeService.title = translate('MYPROFILE.MENU.TRAINING');

        vm.activeItem = [{
            label: 'Training',
            link: 'app.employee_employe_edit.training'
        }];

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();
        var Training = AppAPI.Training();
        var Profiles = AppAPI.Profiles();

        // set constructor form
        Form.setObject(Training);

        // set form to controller
        vm.Form = Form;

        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        checkCompletion();
        vm.viewMenus = viewMenus;
        vm.completion = false;
        vm.changeCertificate = changeCertificate;
        vm.cert = false;

        employe();

        function employe() {
            var response = Employe.get({ action: 'viewdetail', id: $stateParams.id });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.firstName = data.firstName;
            vm.Form.objForm.middleName = data.middleName;
            vm.Form.objForm.lastName = data.lastName;
            vm.Form.objForm.empId = data.id;
            vm.empId = data.id;
            vm.Form.objForm.photoAddress = data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        vm.openInputTraining = openInputTraining;
        vm.editInputTraining = editInputTraining;
        vm.closeModal = closeModal;

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.saveData = saveData;
        vm.deleteData = deleteData;

        var Employe = AppAPI.Employe();
        viewData();
        // vm.dtOptions = {
        //     dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
        //     autoWidth : false,
        //     responsive: true,
        //     pagingType: 'full_numbers'
        // };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Training.query({ action: 'viewData', emp_id: $stateParams.id });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            vm.listDataSelected = [];
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            console.log(div);

            div.isChecked = !div.isChecked;
        }


        function openInputTraining(ev) {
            $mdDialog.show({
                controller: 'TrainingemployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/training/input-training.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    employe();
                }
            });
        }

        function editInputTraining(ev, id) {
            $mdDialog.show({
                controller: 'TrainingemployeeditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/training/input-training.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    employe();
                },
                locals: {
                    id: id
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, Training);
            promise.then(function (data) {
                showDialog(ev, data);
            });
        }

        function showDialog(ev, data) {
            var translate = $filter('translate');
            var Message = translate(data.pesan);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(Message)
                    .textContent(Message)
                    .ariaLabel(Message)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Training.delete({ action: 'deletetraining', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                }, function () {

                });
            });


        }

        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({ action: 'checkCompletionData', id: $stateParams.id });
            resp.$promise.then(fetchDataCompletion);
            resp.$promise.catch(errorFetchDataCompletion);
            // vm.listOtselected=[];
        }

        function fetchDataCompletion(data) {
            vm.listCompletion = data[0];
            if (vm.listCompletion.profiles && vm.listCompletion.address && vm.listCompletion.dependents
                && vm.listCompletion.doc_ktp && vm.listCompletion.doc_ijazah && vm.listCompletion.doc_sim && vm.listCompletion.education
                && vm.listCompletion.experience && vm.listCompletion.bank && vm.listCompletion.tax) {
                vm.completion = true;
            }
        }

        function errorFetchDataCompletion() {
            vm.listCompletion = [];
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go('app.employee_myemploye_edit.' + id, { id: $stateParams.id });
        }

        function changeCertificate() {

            if (vm.Form.objForm.isCertificate == 1) {
                vm.cert = true;
            } else {
                vm.cert = false;
            }

        }


        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/training/uploadsertifikat',
            removeAfterUpload: true,
            alias: 'image',
            onBeforeUploadItem: function (item) {
                var dt = new Date(item.formData[0].startDate);
                var et = new Date(item.formData[0].finishDate);

                var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                var newdate1 = dt.getFullYear() + '-' + (et.getMonth() + 1) + '-' + et.getDate();
                item.formData[0].start_date = newdate;
                item.formData[0].end_date = newdate1;
                vm.Form.objForm.startDate = newdate;
                vm.Form.objForm.finishDate = newdate1;
                angular.element.blockUI();

            },
            formData: [
                vm.Form.objForm
            ],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
                angular.element.unblockUI();
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            },
            onSuccessItem: function (item, response, status, headers) {
                if (response.error) {
                    vm.message = {
                        ariaLabel: 'Upload file has been failed',
                        textContent: response.pesan
                    }
                } else {
                    vm.message = {
                        ariaLabel: 'Upload file has been successfully',
                        textContent: response.pesan
                    }
                }
                showDialog();
                $timeout(function () {
                    vm.notif.error = false;
                    vm.notif.success = false;
                    vm.Form.objForm = {};
                }, 3000);
                angular.element.unblockUI();
            },
            onError: function () {
                vm.notif.error = 'Internal server error'
                vm.notif.success = false;
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            }
        });

        uploaderPhoto.filters.push({
            name: 'syncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                vm.sizefile = item.size;

                return true;
            }
        });



    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('TrainingemployeeditController', TrainingemployeeditController);

    /** @ngInject */
    TrainingemployeeditController.$inject=['$state','$mdDialog','id','AppAPI','Auth','Form','$stateParams'];
    /** @ngInject */
    function TrainingemployeeditController($state,$mdDialog,id,AppAPI,Auth,Form,$stateParams)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Training=AppAPI.Training();
	    var Profiles=AppAPI.Profiles();

	    // set constructor form
	    Form.setObject(Training);

	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewDetail',id:id.id});
        response.then(changeDate);

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;

	    vm.messageTheme='pink';

	    vm.Completed=false;
        vm.viewCompletion=viewCompletion;
        vm.checkCompletion=checkCompletion;
        checkCompletion();
        vm.viewMenus=viewMenus;


        function changeDate(data) {
           vm.Form.objForm.trainingDate=new Date(data.training_date);
           vm.Form.objForm.startDate=new Date(data.start_date);
           vm.Form.objForm.finishDate=new Date(data.finish_date);
           vm.Form.objForm.specificationOfTraining=data.specification_of_training;
           vm.Form.objForm.isCertificate=data.is_certificate;
           vm.Form.objForm.typeOfTraining=data.type_of_training;
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updatetraining', formController, Employe);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/
        function saveData(ev, formController) {
            var promise= Form.updateData('update',formController,Training, Form.objForm.id,'viewDetail');
            promise.then(function(){
	            // showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }

	    function viewCompletion()
        {
            if(!vm.Completed){
                vm.Completed=true;
            }else{
                vm.Completed=false;
            }
        }

        function  checkCompletion() {
            var resp=Profiles.query({action:'checkCompletionData',id:$stateParams.id});
            resp.$promise.then(fetchData);
            resp.$promise.catch(errorFetchData);
            // vm.listOtselected=[];
        }

        function fetchData(data) {
          vm.listCompletion=data[0];
        }

        function errorFetchData() {
          vm.listCompletion=[];
        }

        function viewMenus(id)
        {
            vm.Completed=false;
            $state.go('app.employee_myemploye_edit.'+id);
        }
    } 
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('TerminationemployeController', TerminationemployeController);


    TerminationemployeController.$inject=['$stateParams','$timeout','Form','AppAPI','Auth','$mdDialog','EmployeeService','$element'];
    /** @ngInject */
    function TerminationemployeController($stateParams,$timeout,Form,AppAPI,Auth,$mdDialog,EmployeeService,$element)
    {
        
        var vm = this;

        EmployeeService.title = 'Termination';

         // initial form
         Form.initialForm(false);

         var Employe=  AppAPI.Employe();
         var Termination=  AppAPI.Termination(); 
         vm.employe=employe;
         vm.DataOffBoarding=[];
         vm.terminated=terminated;

         // set constructor form
         Form.setObject(Termination);
         getType();

         // set form to controller
        angular.element.blockUI();

        vm.Form = Form; 

        var mainData=Termination.get({action:'viewData',id:$stateParams.id,nik:$stateParams.nik});
        mainData.$promise.then(solveData);
        mainData.$promise.catch(errorFetchMain); 

        function solveData(data)
        {
            vm.Form.objForm.nik=data.nik;
            vm.Form.objForm.reason=data.reason;
            vm.Form.objForm.terminationType=data.type;
            vm.Form.objForm.id=data.id;
            if(data.inactive_date !='0000-00-00'){
                vm.Form.objForm.inactive_date=new Date(data.inactive_date);
            }else{
                vm.Form.objForm.inactive_date=null;
            }
            vm.DataOffBoarding=data; 
            angular.element.unblockUI();
        }

        function errorFetchMain() {
            console.log('error');
            angular.element.unblockUI();
        }
        
        vm.saveData=saveData;
        vm.stateEdit=false; 
        vm.ChangeState=ChangeState;
        vm.CancelTerminate=CancelTerminate;

        vm.clearMeesage=clearMeesage;  
        

        employe();

        function employe()
        {
           var response=Employe.get({action:'viewdetail',id:$stateParams.id});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye); 
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title=data.title;
            vm.Form.objForm.firstName=data.firstName;
            vm.Form.objForm.middleName=data.middleName;
            vm.Form.objForm.lastName=data.lastName;
            vm.Form.objForm.empId=data.id;
            vm.empId = data.id;
            vm.Form.objForm.photoAddress=data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        function ChangeState()
        {
          switch(vm.stateEdit){
            case true:
              vm.stateEdit=false;
              break;
            case false:
              vm.stateEdit=true;
              break;
          }
        }
              
        function getType()
        {
            var response=Termination.query({action:'getTerminationType'});
            response.$promise.then(fetchTerminationType);
            response.$promise.catch(errorFetchTerminationType);
        }
         
        function fetchTerminationType(data) {
            vm.terminationTypeList = data;
        }

        function errorFetchTerminationType() {
            vm.terminationTypeList = [];
        }

        function saveData(formController) {
            angular.element.blockUI();
            vm.Form.objForm.id=$stateParams.id;
            vm.Form.objForm.inactive_date= formController.inactive_date.$viewValue;
            var response=Form.updateData('save',formController,Termination,$stateParams.id,'viewData');

         response.then(function(data){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             if(data.inactive_date !='0000-00-00'){
                vm.Form.objForm.inactive_date=new Date(data.inactive_date);
             }else{
                 vm.Form.objForm.inactive_date='';
             }

             $timeout(function() {
                 vm.Form.tampilPesan=false;
                 employe();
                vm.stateEdit=false; 
                var response=vm.Form.objForm.$get({action:'viewData',id:$stateParams.id,nik:$stateParams.nik}); 
                response.then(changeDate);
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function CancelTerminate(ev) {
       
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Cancel Termination Employement?')
                .textContent('Data termination will be deleted.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=Termination.delete({action:'delete',data:angular.toJson(vm.DataOffBoarding)}); 
                    response.$promise.then(function(data){
                        employe();
                        vm.Form.tampilPesan=true;
                        vm.Form.pesan = data.pesan;
                        vm.messageTheme='blue'; 
                        var response=vm.Form.objForm.$get({action:'viewData',id:$stateParams.id,nik:$stateParams.nik}); 
                        response.then(changeDate);
                        angular.element.unblockUI();
                    },function(){                        
                      employe(); 
                      var response=vm.Form.objForm.$get({action:'viewData',id:$stateParams.id,nik:$stateParams.nik}); 
                        response.then(changeDate);
                      vm.messageTheme='pink';
                      angular.element.unblockUI();
                    }); 
                }, function() {

                });
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function terminated() {
          if(vm.DataOffBoarding.inactive_date =='0000-00-00' && vm.DataOffBoarding.type == '' && vm.DataOffBoarding.reason == ''){
            return false;
          }else{
            return true;   
          }
        }
    }
})();  

(function () {
  'use strict';

  angular
    .module('app.employee.employe.input-employe')
    .controller('TaxemployeController', TaxemployeController);

  TaxemployeController.$inject = [
    '$state',
    '$stateParams',
    '$timeout',
    'Form',
    'AppAPI',
    'EmployeeService',
    'FileUploader',
    'config',
    '$localStorage',
    '$filter',
    '$mdDialog'
  ];
  /** @ngInject */
  function TaxemployeController(
    $state,
    $stateParams,
    $timeout,
    Form,
    AppAPI,
    EmployeeService,
    FileUploader,
    config,
    $localStorage,
    $filter,
    $mdDialog
  ) {
    var vm = this;
    var translate = $filter('translate');

    EmployeeService.title = translate('MYPROFILE.MENU.TAX');

    // initial form
    Form.initialForm(false);

    var Tax = AppAPI.Tax();
    var Employe = AppAPI.Employe();
    var Profiles = AppAPI.Profiles();
    var Document = AppAPI.Document();

    // set constructor form
    Form.setObject(Tax);

    // set form to controller
    vm.Form = Form;

    angular.element.blockUI();
    var response = vm.Form.objForm.$get({ action: 'viewTax', id: $stateParams.id });
    response.then(function (){
      angular.element.unblockUI();
    });

    vm.stateEdit = false;

    vm.ChangeState = ChangeState;
    vm.saveData = saveData;
    // vm.Form.objForm.

    vm.clearMeesage = clearMeesage;
    vm.Form.objForm.taxStatus = '00';

    vm.Completed = false;
    vm.viewCompletion = viewCompletion;
    vm.checkCompletion = checkCompletion;
    checkCompletion();
    vm.viewMenus = viewMenus;
    vm.country = $localStorage.country;
    vm.completion = false;
    vm.fileSizeError = false;
    vm.uploadNpwp = uploadNpwp;
    vm.UploadNpwpStateSucces = false;
    vm.UploadNpwpStateError = false;
    vm.upload = upload;
    vm.stateView = false;
    vm.closeModal = closeModal;
    vm.viewComment = viewComment;
    vm.viewNpwp = viewNpWp;
    vm.taxStatusList = [];

    var empID = $stateParams.id;

    vm.empID = empID;

    employe();

    loadDataNpwp();

    function ChangeState() {
      loadDataNpwp();
      switch (vm.stateEdit) {
        case true:
          vm.stateEdit = false;
          break;
        case false:
          vm.stateEdit = true;
          break;
      }
    }

    function employe() {
      angular.element.blockUI();
      var response = Employe.get({ action: 'viewdetail', id: $stateParams.id });
      response.$promise.then(fetchEmploye);
      response.$promise.catch(errorFetchEmploye);
    }

    function fetchEmploye(data) {
      vm.Form.objForm.title=data.title;
      vm.Form.objForm.firstName=data.firstName;
      vm.Form.objForm.middleName=data.middleName;
      vm.Form.objForm.lastName=data.lastName;
      vm.Form.objForm.empId=data.id;
      vm.empId = data.id;
      vm.Form.objForm.photoAddress = data.photoAddress;
      getTaxCode(data.nationality);
    }

    function errorFetchEmploye() {
      console.log('error');
    }

    function getTaxCode(country) {
      var response = Tax.query({ action: 'getTaxCode', country_id: country});
      response.$promise.then(fetchTaxCode);
      response.$promise.catch(errorFetchTaxCode);
    }

    function fetchTaxCode(data) {
      vm.taxStatusList = data;
        angular.element.unblockUI();
    }

    function errorFetchTaxCode() {
      console.log('error');
      angular.element.unblockUI();
    }

    function uploadNpwp(ev) {
      $mdDialog.show({
        controller: 'TaxemployeController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/employe/input-employe/tax/tax-upload.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          viewData();
          vm.stateEdit = false;
        }
      });
    }

    function upload() {
      var resp = vm.FileUploaderNpwp.uploadAll();
    }

    var uploaderNpwp = (vm.FileUploaderNpwp = new FileUploader({
      url: config.api + 'api/documents/uploadnpwp',
      removeAfterUpload: true,
      alias: 'npwp',
      onBeforeUploadItem: function () {
        angular.element.blockUI();
      },
      formData: [
        {
          action: 'uploadnpwp',
          documentNo: vm.documentNo,
          typeOfDocument: 'npwp',
          expiredDate: '9999-12-31',
          issuedDate: vm.issuedDate,
          description: vm.description
        }
      ],
      onAfterAddingAll: function () {
        vm.UploadNpwpStateSucces = false;
        vm.UploadNpwpStateError = false;
        angular.element.unblockUI();
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      },
      onSuccessItem: function (item, response, status, headers) {
        showDialog();
        angular.element.unblockUI();
      },
      onErrorItem: function (item, response, status, headers) {
        angular.element.unblockUI();
      }
    }));

    function showDialog() {

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
        )
        .then(function () {
          vm.Form.objForm = new Tax();
          var response = vm.Form.objForm.$get({ action: 'viewTax', id: $stateParams.id });
          response.then(function () {
            vm.messageTheme = 'blue';

            closeModal();
            $timeout(function () {
              vm.Form.tampilPesan = false;
              vm.stateEdit = false;
            }, 3000);
          });
        });
    }

    uploaderNpwp.filters.push({
      name: 'enforceMaxFileSize',
      fn: function (item) {
        vm.itemSize = formatBytes(item.size);
        if (item.size > 2097152) {
          vm.fileSizeError = true;
          return false;
        } else {
          vm.fileSizeError = false;
          return true;
        }
      }
    });

    function formatBytes(bytes) {
      if (bytes < 1024) return bytes + ' Bytes';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
      else return (bytes / 1073741824).toFixed(3) + ' GB';
    }

    function loadDataNpwp() {
      var npwp = Document.query({
        action: 'viewData',
        emp_id: empID,
        type: 'npwp'
      });

      npwp.$promise.then(function (data) {
        if (data.length > 0) {
          vm.stateview = true;
          vm.doc = data[0].link;
        } else {
          vm.stateview = false;
        }
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(formController) {
      angular.element.blockUI();
      var response = Form.updateData('updatetax', formController, Tax, $stateParams.id, 'viewTax');

      response.then(function () {
        vm.messageTheme = 'blue';
        angular.element.unblockUI();
        formController.$setPristine();

        $timeout(function () {
          vm.Form.tampilPesan = false;
          employe();
          vm.stateEdit = false;
        }, 3000);
      });

      response.catch(function () {
        vm.messageTheme = 'pink';
        angular.element.unblockUI();
      });
    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }

    function viewCompletion() {
      // console.log(vm.Completed);
      if (!vm.Completed) {
        vm.Completed = true;
      } else {
        vm.Completed = false;
      }
    }

    function checkCompletion() {
      var resp = Profiles.query({ action: 'checkCompletionData', id: $stateParams.id });
      // console.log(resp);
      resp.$promise.then(fetchData);
      resp.$promise.catch(errorFetchData);
      // vm.listOtselected=[];
    }

    function fetchData(data) {
      vm.listCompletion = data[0];
      // console.log(vm.listCompletion);
      if (
        vm.listCompletion.profiles &&
        vm.listCompletion.address &&
        vm.listCompletion.dependents &&
        vm.listCompletion.doc_ktp &&
        vm.listCompletion.doc_ijazah &&
        vm.listCompletion.doc_sim &&
        vm.listCompletion.education &&
        vm.listCompletion.experience &&
        vm.listCompletion.bank &&
        vm.listCompletion.tax
      ) {
        vm.completion = true;
      }
    }

    function errorFetchData() {
      vm.listCompletion = [];
    }

    function viewMenus(id) {
      // console.log(id);
      vm.Completed = false;
      $state.go('app.employee_myemploye_edit.' + id, { id: $stateParams.id });
    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'DependentViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/employe/input-employe/dependent/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          var response = vm.Form.objForm.$get({ action: 'viewTax', id: $stateParams.id });
          response.then(changeDate);
        },
        locals: {
          id: id,
          constructor: Tax
        }
      });
    }

    function viewNpWp(ev) {
      $mdDialog.show({
        controller: 'TaxemployeController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/employe/input-employe/tax/view-doc.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          viewData();
        }
      });
    }
  }
})();

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('StatusemployeController', StatusemployeController);


    StatusemployeController.$inject=['$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','EmployeeService','DataService'];
    /** @ngInject */
    function StatusemployeController($stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,EmployeeService,DataService)
    {
        
        var vm = this;

        vm.listJum = [2,5,25,50,75,100,200];
        vm.DataTable = new DataService();
        vm.viewData = viewData;

        EmployeeService.title = 'Status';
        vm.EmployeeService = EmployeeService; 
        
        // initial form
        Form.initialForm(false);

        var Employe=  AppAPI.Employe();
        var Status = AppAPI.Status(); 
        vm.employe=employe;
        vm.arrayNik = [];
        vm.stateEdit = 0;

        // set constructor form
        Form.setObject(Status);

         
        // set form to controller
        vm.Form = Form; 

        employe();
        function employe()
        {
           var response=Employe.get({action:'viewdetail',id:$stateParams.id});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye); 
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title=data.title;
            vm.Form.objForm.firstName=data.firstName;
            vm.Form.objForm.middleName=data.middleName;
            vm.Form.objForm.lastName=data.lastName;
            vm.Form.objForm.empId=data.id;
            vm.empId = data.id;
            vm.Form.objForm.photoAddress=data.photoAddress;
            vm.arrayNik=data.array_nik;
            vm.Form.objForm.nik = data.array_nik[0];
            vm.Form.objForm.status = 'Contract';
            var d = new Date();
            var year = d.getFullYear();
            var month = d.getMonth();
            var day = d.getDate();
            var c = new Date(year + 1, month, day);
            c.setDate(c.getDate()-1);
            vm.Form.objForm.startDate=d;
            vm.Form.objForm.endDate=c;
        }

        function errorFetchEmploye() {
            console.log('error');
        }
      
        vm.openInputStatus = openInputStatus;
        vm.editInputStatus = editInputStatus;
        vm.closeModal = closeModal;

        vm.listData=[];
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listDataSelected=[];

        vm.saveData=saveData;
        vm.deleteData=deleteData;
        
        viewData(1);
        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
          DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData(pageno) {
            unCheckAll();
           angular.element.blockUI();
           var resp=vm.DataTable.loadData(Status,pageno,{action:'viewData',emp_id:$stateParams.id});
           resp.then(function(){
            angular.element.unblockUI();
           });
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
           vm.listDataSelected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
           vm.listDataSelected=[];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }
       

        function openInputStatus(ev)
        {
            $mdDialog.show({
                controller: 'StatusemployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/status/input-status.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                    employe();
                }
            });
        }

        function editInputStatus(ev, id)
        {
            $mdDialog.show({
                controller: 'StatusemployeeditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/status/input-status.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                    employe();
                },
                locals:{
                  id:id
                }
            });
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, Status);
            promise.then(function(data){
                showDialog(ev,data);
            });
        }

        function showDialog(ev,data) 
        {
            $mdDialog
            .show(
                $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(data.status)
                .textContent(data.message)
                .ariaLabel(data.status)
                .ok('OK')
                .targetEvent(ev)
            )
            .then(function() {
                closeModal();
                viewData();
            });
        }

        function deleteData(ev) {
       
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=Status.delete({action:'deletestatus',data:angular.toJson(vm.listDataSelected)});

                    response.$promise.then(viewData);
                }, function() {

                });
            });
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('StatusemployeeditController', StatusemployeeditController);

    /** @ngInject */
    StatusemployeeditController.$inject=['$mdDialog','id','AppAPI','Auth','Form'];
    /** @ngInject */
    function StatusemployeeditController($mdDialog,id,AppAPI,Auth,Form)
    {        
        var vm = this;
	    // initial form
	    Form.initialForm(false);

	    // get constructor form
	    var Status=AppAPI.Status();

	    // set constructor form
	    Form.setObject(Status);

	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewDetail',id:id});
        response.then(changeDate);

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;
	    vm.arrayNik = [];
	    vm.stateEdit = 1;

	    vm.messageTheme='pink';

        function changeDate(data) {
           vm.Form.objForm.startDate=new Date(data.startDate);
           vm.Form.objForm.endDate=new Date(data.endDate);
           vm.Form.objForm.noSk=data.no_sk;
           vm.Form.objForm.arrayNik=data.array_nik;
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

        function saveData(ev, formController) {
        	vm.Form.objForm.firstName=vm.Form.objForm.firstNameD;
           	vm.Form.objForm.lastName=vm.Form.objForm.lastNameD;
            var promise= Form.updateData('update',formController,Status, {id : Form.objForm.id, status : vm.Form.objForm.status},'viewDetail');
            promise.then(function(){
	            showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }

    }
    
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('SkjicemployeController', SkjicemployeController);


    SkjicemployeController.$inject=['$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','EmployeeService','DataService'];
    /** @ngInject */
    function SkjicemployeController($stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,EmployeeService,DataService)
    {
        
        var vm = this;

        vm.listJum = [2,5,25,50,75,100,200];
        vm.DataTable = new DataService();
        vm.viewData = viewData;

        EmployeeService.title = 'SK JIC';
		vm.EmployeeService = EmployeeService; 
        
        // initial form
        Form.initialForm(false);

        var Employe=  AppAPI.Employe();
        var Skjic = AppAPI.Skjic(); 
        vm.employe=employe;

        // set constructor form
        Form.setObject(Skjic);

         
        // set form to controller
        vm.Form = Form; 

        employe();
        function employe()
        {
           var response=Employe.get({action:'viewdetail',id:$stateParams.id});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye); 
        }
      
        

        function fetchEmploye(data) {
            // console.log(data);
            vm.Form.objForm.title=data.title;
            vm.Form.objForm.firstName=data.firstName;
            vm.Form.objForm.middleName=data.middleName;
            vm.Form.objForm.lastName=data.lastName;
            vm.Form.objForm.empId=data.id;
            vm.empId = data.id;
            vm.Form.objForm.photoAddress=data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }


        

        vm.openInputSkjic = openInputSkjic;
        vm.editInputSkjic = editInputSkjic;
        vm.closeModal = closeModal;

        vm.listData=[];
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listDataSelected=[];

        vm.saveData=saveData;
        vm.deleteData=deleteData;

        viewData(1);
        vm.dtOptions = {
            dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
          DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData(pageno) {
           angular.element.blockUI();
           var resp=vm.DataTable.loadData(Skjic,pageno,{action:'viewData',emp_id:$stateParams.id});
           resp.then(function(){
            angular.element.unblockUI();
           });
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
           vm.listDataSelected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
           vm.listDataSelected=[];
        }

        function checkone(div) {
            console.log(div);

            div.isChecked = !div.isChecked;
        }
       

        function openInputSkjic(ev)
        {
            $mdDialog.show({
                controller         : 'SkjicemployeController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/employe/input-employe/skjic/input-skjic.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData(1);
                    employe();
                }
            });
        }

        function editInputSkjic(ev, id)
        {
            $mdDialog.show({
                controller         : 'SkjicemployeeditController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/employe/input-employe/skjic/input-skjic.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData(1);
                    employe();
                },
                locals:{
                  id:id
                }
            });
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {
            vm.Form.objForm.firstName=vm.Form.objForm.firstNameD;
            vm.Form.objForm.lastName=vm.Form.objForm.lastNameD;
            var promise= Form.saveData('save', formController, Skjic);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function deleteData(ev) {
       
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=Skjic.delete({action:'deleteskjic',data:angular.toJson(vm.listDataSelected)});

                    response.$promise.then(viewData);
                }, function() {

                });
            });
      
       
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('SkjicemployeeditController', SkjicemployeeditController);

    /** @ngInject */
    SkjicemployeeditController.$inject=['$mdDialog','id','AppAPI','Auth','Form'];
    /** @ngInject */
    function SkjicemployeeditController($mdDialog,id,AppAPI,Auth,Form)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Skjic=AppAPI.Skjic();

	    // set constructor form
	    Form.setObject(Skjic);

	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewDetail',id:id.id});
        response.then(changeDate);

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;

	    vm.messageTheme='pink';
  


        function changeDate(data) {
           vm.Form.objForm.skDate=new Date(data.sk_date);
           vm.Form.objForm.noSk=data.sk_no;
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }


        function saveData(ev, formController) {
        	vm.Form.objForm.firstName=vm.Form.objForm.firstNameD;
           	vm.Form.objForm.lastName=vm.Form.objForm.lastNameD;
            var promise= Form.updateData('update',formController,Skjic, Form.objForm.id,'viewDetail');
            promise.then(function(){
	            showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }
    }
    
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('ShiftsettingController', ShiftsettingController);


    ShiftsettingController.$inject=['$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','EmployeeService'];
    /** @ngInject */
    function ShiftsettingController($stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,EmployeeService)
    {
        
        var vm = this;

        EmployeeService.title = 'Shift Setting';
        vm.EmployeeService = EmployeeService;
        
        // initial form
        Form.initialForm();

        var Employe=  AppAPI.Employe();
        var Employeshift = AppAPI.Employeshift();
        vm.nik="";
        // set constructor form
        Form.setObject(Employeshift);

        // set form to controller
        vm.Form = Form;

        employe();
      
        function employe()
        {
            var response=Employe.get({action:'viewdetail',id:$stateParams.id});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }
         
        function fetchEmploye(data) {
            vm.Form.objForm.title=data.title;
            vm.Form.objForm.firstName=data.firstName;
            vm.Form.objForm.lastName=data.lastName;
            vm.Form.objForm.empId=data.id; 
            vm.empId = data.id;
            vm.nik=data.nik; 
            vm.Form.objForm.photo_address=data.photoAddress;
            viewData();
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        vm.openInputEducation = openInputEducation;
        vm.editInputEducation = editInputEducation;
        vm.closeModal = closeModal;

        vm.listData=[];
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listDataSelected=[];
 
        vm.deleteData=deleteData;

        
        
        vm.dtOptions = {
            dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
          DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Employeshift.query({action:'viewdata',nik:vm.nik});
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
           vm.listDataSelected=angular.copy(vm.listData);
        }

        function unCheckAll() {
           vm.listDataSelected=[];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }
       

        function openInputEducation(ev)
        {
            $mdDialog.show({
                controller         : 'InputshiftsettingController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/employe/input-employe/shiftsetting/input-shiftsetting.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                    employe();
                }
            });
        }

        function editInputEducation(ev, id)
        {
            $mdDialog.show({
                controller         : 'EmployeshifteditController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/employe/input-employe/shiftsetting/input-shiftsetting.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                    employe();
                },
                locals:{
                  id:id
                }
            });
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        } 

        function deleteData(ev) {
       
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=Employeshift.delete({action:'deleteshiftemploye',data:angular.toJson(vm.listDataSelected)});

                    response.$promise.then(viewData);
                }, function() {

                });
            });
      
       
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('InputshiftsettingController', InputshiftsettingController);


    InputshiftsettingController.$inject=['$stateParams','$localStorage','$timeout','$mdDialog','$document','Form','AppAPI'];
    /** @ngInject */
    function InputshiftsettingController($stateParams,$localStorage,$timeout,$mdDialog,$document,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Employe=  AppAPI.Employe();
         var Bank=  AppAPI.Bank();
         var Employeshift = AppAPI.Employeshift();   

         // set constructor form
         Form.setObject(Employeshift);

         // set form to controller
        vm.Form = Form; 
         
        vm.saveData=saveData;
        vm.stateEdit=false; 
        vm.ChangeState=ChangeState;
        vm.changeRefshift=changeRefshift;
        vm.closeModal = closeModal; 

        vm.clearMeesage=clearMeesage;   
        employe();
 
        function ChangeState()
        {
          switch(vm.stateEdit){
            case true:
              vm.stateEdit=false;
              break;
            case false:
              vm.stateEdit=true;
              break;
          }
        } 


        function changeRefshift(c)
        {

          var obj=c.split('-'); 
          if(obj[1] ==3)
          {
            vm.shift1=true;
            vm.shift2=true;
            vm.shift3=true;
          }else if(obj[1] ==2)
          {
            vm.shift1=true;
            vm.shift2=true;
            vm.shift3=false;
          }else if(obj[1] ==1)
          {
            vm.shift1=true;
            vm.shift2=false;
            vm.shift3=false;
          }  
          
        }


        function employe()
        {
            var response=Employe.get({action:'viewdetail',id:$stateParams.id});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }
         
        function fetchEmploye(data) {
            // vm.Form.objForm.title=data.title;
            // vm.Form.objForm.firstName=data.lastName;
            // vm.Form.objForm.lastName=data.lastName;
            // vm.Form.objForm.empId=data.id; 
            vm.nik = data.nik;
            vm.Form.objForm.photo_address=data.photoAddress;
            vm.Form.objForm.nik=data.nik;
            LoadLocation();
        }

        function LoadLocation() {
            var response=Employeshift.query({action:'getLocationshift',nik:vm.nik});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

          function fetchLocation(data) {
            vm.listLocation=data;
          }

        function errorFetchLocation() {
            vm.listLocation=[];
          }

        function errorFetchEmploye() {
            console.log('error');
        }

        function saveData(ev,formController) {
             vm.Form.objForm.title=vm.Form.objForm.eduTitle;
            var promise= Form.saveData('save', formController, Employeshift);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('EmployeshifteditController', EmployeshifteditController);

    /** @ngInject */
    EmployeshifteditController.$inject=['$mdDialog','id','AppAPI','Auth','Form'];
    /** @ngInject */
    function EmployeshifteditController($mdDialog,id,AppAPI,Auth,Form)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Employeshift=AppAPI.Employeshift();

	    // set constructor form
	    Form.setObject(Employeshift);
	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewdetail',id:id.id});
        response.then(changeDate);

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken; 
	    vm.messageTheme='pink';
	    vm.changeRefshift=changeRefshift;
	    LoadLocation();

	    
        function changeDate(data) {
        	vm.shift1=false;
	        vm.shift2=false;
	        vm.shift3=false;
        	var cycle=data.location.split('-');
            vm.Form.objForm.effective_date=new Date(data.effective_date);
            if(cycle[1] =='3')
	          {
	            vm.shift1=true;
	            vm.shift2=true;
	            vm.shift3=true;
	          }else if(cycle[1] =='2')
	          {
	            vm.shift1=true;
	            vm.shift2=true;
	            vm.shift3=false;
	          }else if(cycle[1] =='1')
	          {
	            vm.shift1=true;
	            vm.shift2=false;
	            vm.shift3=false;
	          }
	         
        }

        function changeRefshift(c)
        {
          vm.Form.objForm.start_template="";
          var obj=c.split('-'); 
          if(obj[1] ==3)
          {
            vm.shift1=true;
            vm.shift2=true;
            vm.shift3=true;
          }else if(obj[1] ==2)
          {
            vm.shift1=true;
            vm.shift2=true;
            vm.shift3=false;
          }else if(obj[1] ==1)
          {
            vm.shift1=true;
            vm.shift2=false;
            vm.shift3=false;
          }   
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updateeducation', formController, Employe);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/
        function saveData(ev, formController) {
            var promise= Form.updateData('update',formController,Employeshift, Form.objForm.id,'viewdetail');
            promise.then(function(){
	            showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }

	    function LoadLocation() {
            var response=Employeshift.query({action:'getLocationshift',nik:id.nik});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

          function fetchLocation(data) {
            vm.listLocation=data;
          }

        function errorFetchLocation() {
            vm.listLocation=[];
          }
    }
    
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('PromotionemployeController', PromotionemployeController);


    PromotionemployeController.$inject=['$stateParams','$document','$localStorage','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','EmployeeService','DataService'];
    /** @ngInject */
    function PromotionemployeController($stateParams,$document,$localStorage,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,EmployeeService,DataService)
    {
        
        var vm = this;

        vm.EmployeeService = EmployeeService;        
        EmployeeService.title = 'Promotion';
        vm.viewData = viewData;

        vm.listJum = [2,5,25,50,75,100,200];
        vm.DataTable = new DataService(); //inisialisasi class DataService
        
        // initial form
        Form.initialForm();

        var Employe=  AppAPI.Employe();
        var Promotion=  AppAPI.Promotion();
        var Employements = AppAPI.Employements();
        vm.employe = employe;

        // set constructor form
        Form.setObject(Promotion);

         
        // set form to controller
        vm.Form = Form; 
        vm.company=$localStorage.empsite; 
        vm.groupLogin=$localStorage.group;
        vm.user=$localStorage.user;
        vm.Form.objForm.nik=null;
        vm.nik=false;
        vm.Form.objForm.hiredate=null;
        vm.hiredate=false;
        vm.Form.objForm.jointdate=null;
        vm.jointdate=false;
        vm.divisi=null;
        vm.department=null; 
        vm.saveProcess=false;
        vm.data = null;

        vm.selected = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.items = [];
        
        vm.openInputPromotion = openInputPromotion;
        vm.editInputPromotion = editInputPromotion;
        vm.closeModal = closeModal;
        vm.deleteData=deleteData;
        
        
        employe();
        employements();

        //////////////////////////////

        function employe() {
            var response=Employe.get({action:'viewdetail',id:$stateParams.id});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye); 
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title=data.title;
            vm.Form.objForm.firstName=data.firstName;
            vm.Form.objForm.lastName=data.lastName;
            vm.Form.objForm.empId=$stateParams.id;
            vm.Form.objForm.photoAddress=''; 
            vm.empId = data.id;
            vm.Form.objForm.photoAddress=data.photoAddress;
            vm.Form.objForm.nik = data.nik
            vm.data = data
            viewData(1);
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        function employements() {
            var response=Employements.get({action:'getEmployement',id:$stateParams.id});
            response.$promise.then(fetchEmployements);
            response.$promise.catch(errorFetchEmployements); 
        }

        function fetchEmployements(data) {
            vm.data = data;
        }

        function errorFetchEmployements() {
            console.log('error');
        }
        
        function viewData(pageno) {
            angular.element.blockUI();
            var dataPromise=vm.DataTable.loadData(Promotion,pageno,{action:'viewData', nik : vm.Form.objForm.nik});

            dataPromise.then(function(data) {
                vm.selected = [];
                vm.items = data.list;
            });

        }

        function openInputPromotion(ev) {
            $mdDialog.show({
                controller         : 'PromotionemployeinputController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/employe/input-employe/promotion/input-promotion.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData(1);
                    employe();
                },
                locals:{
                    data:vm.data
                }
            });
        }

        function editInputPromotion(ev, data) {
            $mdDialog.show({
                controller         : 'PromotionemployeeditController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/employe/input-employe/promotion/edit-promotion.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData(1);
                    employe();
                },
                locals:{
                  data:data
                }
            });
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function showDialog(ev) {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function deleteData(ev) {
       
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=Promotion.delete({action:'deletepromotion',data:angular.toJson(vm.selected)});
                    response.$promise.then( function(resData) {
                        angular.element.unblockUI();
                        var title = 'Success Delete Data';
                        var textContent = 'Process Delete data was Success';
                        var ariaLabel = 'Success Delete Data';
                        showDialogMessage(title,textContent,ariaLabel);
                        employe();
                        employements();
                    });
                    response.$promise.catch( function() {
                        angular.element.unblockUI();
                        var title = 'Delete Data Failed';
                        var textContent = 'Process delete data promotion has been failed.';
                        var ariaLabel = 'Delete Data Failed';
                        showDialogMessage(title,textContent,ariaLabel,ev);
                    })
                }, function() {

                });
            });
        }

        function showDialogMessage(title,textContent,ariaLabel,ev) {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(title)
            .textContent(textContent)
            .ariaLabel(ariaLabel)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function isIndeterminate() {
          return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
        }

        function isChecked() {
          return vm.selected.length === vm.items.length;
        }

        function toggleAll() {
          if (vm.selected.length === vm.items.length) {
            vm.selected = [];
          } else if (vm.selected.length === 0 || vm.selected.length > 0) {
            vm.selected = vm.items.slice(0);
          }
        }

        function toggle(item, list) {
          var idx = list.indexOf(item);
          if (idx > -1) {
            list.splice(idx, 1);
          } else {
            list.push(item);
          }
        }

        function exists(item, list) {
          return list.indexOf(item) > -1;
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('PromotionemployeinputController', PromotionemployeinputController);

    /** @ngInject */
    PromotionemployeinputController.$inject=['$stateParams','$mdDialog','$localStorage','AppAPI','Auth','Form','data','$q','filterFilter'];
    /** @ngInject */
    function PromotionemployeinputController($stateParams,$mdDialog,$localStorage,AppAPI,Auth,Form,data,$q,filterFilter)
    {
        
      var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Promotion=AppAPI.Promotion(); 
	    var Employements=AppAPI.Employements(); 
      var Attendancereport=AppAPI.Attendancereport();

	    // set constructor form
	    Form.setObject(Promotion);

	    // set form to controller
	    vm.Form = Form; 

	    vm.closeModal=closeModal;
	    // vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;
	    // vm.company=$localStorage.empsite;
	    vm.Form.objForm.nik=null;
      vm.nik=true;
      vm.divisi=null;
      vm.department=null; 
      vm.getJobTitle=getJobTitle;
      vm.getLevelCategory=getLevelCategory; 
      vm.saveProcess=false;
      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      vm.loadJfmSub =  loadJfmSub;
      vm.loadGedung = loadGedung;
      vm.selectedItem = null;
      vm.searchText = null;
      vm.querySearchDeferred = querySearchDeferred;
      vm.getJfm = getJfm;
      vm.addAllowance = addAllowance;
      vm.delListAllowance=delListAllowance;

      vm.messageTheme = 'pink';
      vm.listAllowance = [];
      vm.grade = ['1A','1B','1C','2A','2B','2C','3A','3B','3C','4A','4B','4C','5A','5B','5C','6A','6B','6C','7'];
      vm.level = ['001','002','003','004','005','006','007','008'];
      vm.category = ['Non-Staff','Staff','Supervisory','Managerial'];
      vm.actResult = [
        {id:1, description:'pass'},
        {id:2, description:'failed'},
        {id:3, description:'progress'}
      ];

      ////////////////////////////////////

      changeDate();

      function changeDate() {
        loadJfm();
        loadDataBU();
        loadSubArea();
        vm.Form.objForm.acting = false;
        vm.Form.objForm.nik = data.nik;
        var posID=data.abreviation;
        vm.company=posID.substring(0,2)
        vm.divisi=posID.substring(2,4);
        vm.department=posID.substring(4,6); 
        loadDataOldJob();
        loadDataSalaryComponent();
        loadDataDivision(vm.company);
        loadDataDepartment(vm.divisi); 
        getJobTitle(); 
      }

      function addAllowance() {
        var obj = {};
        obj["Amount"] = vm.Amount;
        obj["ID_SalaryComponent"] = vm.ID_SalaryComponent;
        obj["ID_employee"] = vm.Form.objForm.nik;
        obj["effective_date"] = vm.Form.objForm.effectiveDate;
        vm.listAllowance.push(obj);
      }

      function delListAllowance(idx)
      {
       vm.listAllowance.splice(idx,1);
      }

	    function closeModal() {
	      $mdDialog.hide();
      }

      function getJfm() {
        var jt = vm.Form.objForm.jobTitle;
        vm.Form.objForm.jfm = jt.substring(7,9);
        vm.Form.objForm.jfmSub = jt.substring(9,12);
      }

      function saveData(ev,formController) {
        var str = vm.Form.objForm.jobTitle;
        var words = str.split("-");
        vm.Form.objForm.jobTitle = words[1];
        vm.Form.objForm.abreviation = words[0];
        vm.Form.objForm.company = vm.company;
        vm.Form.objForm.department = vm.department;
        vm.Form.objForm.division = vm.divisi;
        vm.Form.objForm.directReport = formController.nik.$viewValue;
        vm.Form.objForm.allowance = vm.listAllowance;
        vm.Form.objForm.old_emp_grade = vm.listOldJob.emp_grade;
        vm.Form.objForm.old_abreviation = data.abreviation;
        vm.Form.objForm.old_direct_report = data.direct_report;

        if (vm.Form.objForm.acting == false) {
          vm.Form.objForm.acting = 0;
        } else {
          vm.Form.objForm.acting = 1;
        }

        var promise= Form.saveData('save', formController, Promotion);
        promise.then(function(){
            showDialog(ev);
        });
      }

      function showDialog(ev) {
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Success Save Data')
        .textContent('Process Data was Success.')
        .ariaLabel('Success Save Data')
        .ok('OK')
        .targetEvent(ev)
        ).then(function(){
            closeModal();
        });
      }

      function loadDataOldJob() {
        vm.saveProcess=true;
        var response=Promotion.query({action:'viewOldJob',id:vm.Form.objForm.nik});
        response.$promise.then(fetchOldJob);
        response.$promise.catch(errorOldJob);
      }

      function fetchOldJob(data) {
        vm.listOldJob=data[0];
        vm.saveProcess=false;
      }

      function errorOldJob(data) {
        vm.listOldJob=[];
        vm.saveProcess=false;
      }

      function loadDataSalaryComponent() {
        vm.saveProcess=true;
        var response=Promotion.query({action:'viewSalaryComponent'});
        response.$promise.then(fetchSalaryComponent);
        response.$promise.catch(errorSalaryComponent);
      }

      function fetchSalaryComponent(data) {
        vm.listSalaryComponent=data;
        vm.saveProcess=false;
      }

      function errorSalaryComponent(data) {
        vm.listSalaryComponent=[];
        vm.saveProcess=false;
      }

      function loadDataDepartment(iddivisi) {
        vm.saveProcess=true;
        var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listDepartment=data;
        vm.saveProcess=false;
      }

      function errorDepartment() {
        vm.listDepartment=[];
        vm.saveProcess=false;
      }
      
      function loadDataDivision(idbu) {
        vm.saveProcess=true;
        var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
        empList();
      }

      function fetchDivisiBU(data) {
        vm.listDivision=data;
        vm.saveProcess=false;
      }

      function errorDivisiBU() {
        vm.listDivision=[];
        vm.saveProcess=false;
      } 

      function loadDataBU() {
        vm.saveProcess=true;
        var response=Attendancereport.query({action:'viewBu'});
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
        vm.listBU=data;
        vm.saveProcess=false;
      }

      function errorFetchBU() {
        vm.listBU=[];
        vm.saveProcess=false;
      }

      function getJobTitle() {
        vm.saveProcess=true;
        var response=Employements.query({action:'getJobTitle',company:vm.company,divisi:vm.divisi,department:vm.department});
        response.$promise.then(fetchJobTitle);
        response.$promise.catch(errorJobTitle);
      }

      function fetchJobTitle(data) {
        vm.listJobTitle=data;
        vm.saveProcess=false;
      }

      function errorJobTitle() {
        vm.listJobTitle=[];
        vm.saveProcess=false;
      }

      function getLevelCategory(grade) {
        vm.saveProcess=true;
        vm.Form.objForm.empCategory=null;
        vm.Form.objForm.jobLevel=null;
        var response=Employements.query({action:'getLevelCategory',grade:grade});
        response.$promise.then(fetchLevel);
        response.$promise.catch(errorFtechLevel);

      }

      function fetchLevel(data) {
        vm.Form.objForm.empCategory=data[0].description;
        vm.Form.objForm.jobLevel=data[0].level;
        vm.saveProcess=false;
      }

      function errorFtechLevel() {
        vm.Form.objForm.empCategory=null;
        vm.saveProcess=false;
      }

      function loadSubArea() {
        var response=Promotion.query({action:'viewSubArea'});
        response.$promise.then(fetchSubArea);
        response.$promise.catch(errorFetchSubArea);
      }
  
      function fetchSubArea(data) {
        vm.listSubArea=data;
      }
  
      function errorFetchSubArea() {
        vm.listSubArea=[];
      }

      function loadGedung(id_sub) {
        var response=Promotion.query({action:'viewGedung',id:id_sub});
        response.$promise.then(fetchGedung);
        response.$promise.catch(errorFetchGedung);
      }

      function fetchGedung(data) {
        vm.listGedung=data;
      }

      function errorFetchGedung() {
        vm.listGedung=[];
      }

      function loadJfm() {
        var response=Promotion.query({action:'viewJfm'});
        response.$promise.then(fetchJfm);
        response.$promise.catch(errorFetchJfm);
      }

      function fetchJfm(data) {
        vm.listJfm=data;
      }

      function errorFetchJfm() {
        vm.listJfm=[];
      }

      function loadJfmSub(id_jfm) {
        var response=Promotion.query({action:'viewJfmSub',id:id_jfm});
        response.$promise.then(fetchJfmSub);
        response.$promise.catch(errorFetchJfmSub);
      }

      function fetchJfmSub(data) {
        vm.listJfmSub=data;
      }

      function errorFetchJfmSub() {
        vm.listJfmSub=[];
      }

      function empList() {
        var response = Promotion.query({
            action: 'viewListEmployee',
            company: vm.company
        });
        response.$promise.then(fetchDataEmpList);
      }
  
      function fetchDataEmpList(data) {
        vm.empListData = data;
      }

      function querySearchDeferred(query) {
        var deferred = $q.defer();
        setTimeout(function() {
            var data = vm.empListData;
            if (query) {
                deferred.resolve(filterFilter(data, query));
            } else {
                deferred.reject([{ nik: 'none', name: 'none' }]);
            }
        }, 200);
        return deferred.promise;
      }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('PromotionemployeeditController', PromotionemployeeditController);

    /** @ngInject */
    PromotionemployeeditController.$inject=['$mdDialog','$localStorage','data','AppAPI','Auth','Form','$q','filterFilter','$stateParams','$scope'];
    /** @ngInject */
    function PromotionemployeeditController($mdDialog,$localStorage,data,AppAPI,Auth,Form,$q,filterFilter,$stateParams,$scope)
    {
        var vm = this;
        // $scope.my = {}
        // initial form
        Form.initialForm();

        // get constructor form
        var Promotion=AppAPI.Promotion(); 
        var Employements=AppAPI.Employements(); 
        var Attendancereport=AppAPI.Attendancereport();

        // set constructor form
        Form.setObject(Promotion);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal=closeModal;
        // vm.id=id;
        vm.updateData=updateData;
        vm.setToken=Auth.setToken;

        // vm.company=$localStorage.empsite;
        vm.Form.objForm.nik=null;
        
          vm.nik=true;
          vm.divisi=null;
          vm.department=null; 
          vm.getJobTitle=getJobTitle;
          vm.getLevelCategory=getLevelCategory; 
          vm.saveProcess=false;
          vm.loadDataDivision=loadDataDivision;
          vm.loadDataDepartment=loadDataDepartment;
          vm.loadJfmSub =  loadJfmSub;
          vm.loadGedung = loadGedung;
          vm.selectedItem = null;
          vm.searchText = null;
          vm.querySearchDeferred = querySearchDeferred;
          vm.getJfm = getJfm;
          vm.addAllowance = addAllowance;
          vm.delListAllowance=delListAllowance;

          vm.messageTheme = 'pink';
          vm.listAllowance = [];
          vm.grade = ['1A','1B','1C','2A','2B','2C','3A','3B','3C','4A','4B','4C','5A','5B','5C','6A','6B','6C','7'];
          vm.level = ['001','002','003','004','005','006','007','008'];
          vm.category = ['Non-Staff','Staff','Supervisory','Managerial'];
          vm.actResult = [
            {id:1, description:'pass'},
            {id:2, description:'failed'},
            {id:3, description:'progress'}
          ];

          ////////////////////////////////////
          vm.Form.objForm.nik = data.nik;
          vm.Form.objForm.skNo = data.skNo;
          // vm.Form.objForm.company = 
          vm.Form.objForm.jobTitle = data.jobTitle;
          vm.company = data.to_company;
          vm.divisi = data.to_division;
          vm.department = data.to_department;
          vm.Form.objForm.effectiveDate = new Date(data.effectiveDate);
          vm.Form.objForm.jobGrade = data.jobGrade;
          vm.Form.objForm.empGrade = data.empGrade;
          vm.Form.objForm.subArea = data.to_sub_area;
          vm.Form.objForm.gedung = data.to_gedung;
          vm.Form.objForm.empCategory = data.emp_category;
          vm.Form.objForm.jobLevel = data.job_level;
          vm.Form.objForm.jfm = data.jfm;
          vm.Form.objForm.jfmSub = data.jfmSub;
          vm.Form.objForm.acting = data.acting;
          vm.selectedItem = data.directReport;
          vm.Form.objForm.acting = data.acting;
          vm.Form.objForm.jobTitle = data.job_title;
          vm.Form.objForm.description = data.description;
          vm.Form.objForm.act_startDate = new Date(data.start_date);
          vm.Form.objForm.act_endDate = new Date(data.end_date);

          if ( data.acting_result == 'pass' ) {
            vm.Form.objForm.act_result = 1
          } else if ( data.acting_result == 'failed' ) {
            vm.Form.objForm.act_result = 2
          } else if ( data.acting_result == 'progress' ) {
            vm.Form.objForm.act_result = 3
          } else {
            vm.Form.objForm.act_result = data.acting_result;  
          }

          //  $scope.$watch('my.promotionForm', function(newVal) {
          //   // console.info('myForm watch');
          //   my.promotionForm.setPristine();
          //   // newVal.$setPrestine()
            
          
          // });

          changeDate();

          function changeDate() {
            loadJfm();
            loadDataBU();
            loadSubArea();
            // vm.Form.objForm.acting = false;
            // vm.Form.objForm.nik = data.nik;
            
            var posID=data.abreviation;
            // vm.company=posID.substring(0,2)
            // vm.divisi=posID.substring(2,4);
            // vm.department=posID.substring(4,6);
            loadDetailPromotion(); 
            loadDataOldJob();
            loadDataSalaryComponent();
            loadDataDivision(vm.company);
            loadDataDepartment(vm.divisi); 
            getJobTitle();
            loadGedung(vm.Form.objForm.subArea); 
          }

          function loadDetailPromotion()
          {
            var response=Promotion.query({action:'viewDetail',id:data.id});
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorDetail);
          }

          function fetchDetail(data) {
            vm.listAllowance = [];
            angular.forEach(data, function(value, key) {
              var obj = {};
              obj["Amount"] = value.amount;
              obj["ID_SalaryComponent"] = value.id_salary_component;
              obj["ID_employee"] = value.id_employee;
              obj["effective_date"] = new Date(value.effective_date);
              vm.listAllowance.push(obj);
            });
            vm.saveProcess=false;
          
          }

          function errorDetail(data) {
            vm.proAllowance=[];
            vm.saveProcess=false;
          }

          function addAllowance() {
            var obj = {};
            obj["Amount"] = vm.Amount;
            obj["ID_SalaryComponent"] = vm.ID_SalaryComponent;
            obj["ID_employee"] = vm.Form.objForm.nik;
            obj["effective_date"] = vm.Form.objForm.effectiveDate;
            vm.listAllowance.push(obj);
          }

          function delListAllowance(idx)
          {
           vm.listAllowance.splice(idx,1);
          }

            function closeModal() {
              $mdDialog.hide();
          }

          function getJfm() {
            var jt = vm.Form.objForm.jobTitle;
            vm.Form.objForm.jfm = jt.substring(7,9);
            vm.Form.objForm.jfmSub = jt.substring(9,12);
          }

          function updateData(ev,formController) {
            var str = vm.Form.objForm.jobTitle;
            var words = str.split("-");
            vm.Form.objForm.jobTitle = words[1];
            vm.Form.objForm.abreviation = words[0];
            vm.Form.objForm.company = vm.company;
            vm.Form.objForm.department = vm.department;
            vm.Form.objForm.division = vm.divisi;
            vm.Form.objForm.directReport = formController.nik.$viewValue;
            vm.Form.objForm.allowance = vm.listAllowance;
            vm.Form.objForm.old_emp_grade = vm.listOldJob.emp_grade;
            vm.Form.objForm.id = data.id;

            if (vm.Form.objForm.acting == false) {
              vm.Form.objForm.acting = 0;
            } else {
              vm.Form.objForm.acting = 1;
            }

            var promise= Form.saveData('update', formController, Promotion);
            promise.then(function(){
                showDialog(ev);
            });
          }

          function showDialog(ev) {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          }

          function loadDataOldJob() {
            vm.saveProcess=true;
            var response=Promotion.query({action:'viewOldJob',id:vm.Form.objForm.nik});
            response.$promise.then(fetchOldJob);
            response.$promise.catch(errorOldJob);
          }

          function fetchOldJob(data) {
            vm.listOldJob=data[0];
            vm.saveProcess=false;
          }

          function errorOldJob(data) {
            vm.listOldJob=[];
            vm.saveProcess=false;
          }

          function loadDataSalaryComponent() {
            vm.saveProcess=true;
            var response=Promotion.query({action:'viewSalaryComponent'});
            response.$promise.then(fetchSalaryComponent);
            response.$promise.catch(errorSalaryComponent);
          }

          function fetchSalaryComponent(data) {
            vm.listSalaryComponent=data;
            vm.saveProcess=false;
          }

          function errorSalaryComponent(data) {
            vm.listSalaryComponent=[];
            vm.saveProcess=false;
          }

          function loadDataDepartment(iddivisi) {
            vm.saveProcess=true;
            var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            vm.saveProcess=false;
          }

          function errorDepartment() {
            vm.listDepartment=[];
            vm.saveProcess=false;
          }
          
          function loadDataDivision(idbu) {
            vm.saveProcess=true;
            var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
            empList();
          }

          function fetchDivisiBU(data) {
            vm.listDivision=data;
            vm.saveProcess=false;
          }

          function errorDivisiBU() {
            vm.listDivision=[];
            vm.saveProcess=false;
          } 

          function loadDataBU() {
            vm.saveProcess=true;
            var response=Attendancereport.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
            vm.saveProcess=false;
          }

          function errorFetchBU() {
            vm.listBU=[];
            vm.saveProcess=false;
          }

          function getJobTitle() {
            vm.saveProcess=true;
            var response=Employements.query({action:'getJobTitle',company:vm.company,divisi:vm.divisi,department:vm.department});
            response.$promise.then(fetchJobTitle);
            response.$promise.catch(errorJobTitle);
          }

          function fetchJobTitle(data) {
            vm.listJobTitle=data;
            vm.saveProcess=false;
          }

          function errorJobTitle() {
            vm.listJobTitle=[];
            vm.saveProcess=false;
          }

          function getLevelCategory(grade) {
            vm.saveProcess=true;
            vm.Form.objForm.empCategory=null;
            vm.Form.objForm.jobLevel=null;
            var response=Employements.query({action:'getLevelCategory',grade:grade});
            response.$promise.then(fetchLevel);
            response.$promise.catch(errorFtechLevel);

          }

          function fetchLevel(data) {
            vm.Form.objForm.empCategory=data[0].description;
            vm.Form.objForm.jobLevel=data[0].level;
            vm.saveProcess=false;
          }

          function errorFtechLevel() {
            vm.Form.objForm.empCategory=null;
            vm.saveProcess=false;
          }

          function loadSubArea() {
            var response=Promotion.query({action:'viewSubArea'});
            response.$promise.then(fetchSubArea);
            response.$promise.catch(errorFetchSubArea);
          }
      
          function fetchSubArea(data) {
            vm.listSubArea=data;
          }
      
          function errorFetchSubArea() {
            vm.listSubArea=[];
          }

          function loadGedung(id_sub) {
            var response=Promotion.query({action:'viewGedung',id:id_sub});
            response.$promise.then(fetchGedung);
            response.$promise.catch(errorFetchGedung);
          }

          function fetchGedung(data) {
            vm.listGedung=data;
          }

          function errorFetchGedung() {
            vm.listGedung=[];
          }

          function loadJfm() {
            var response=Promotion.query({action:'viewJfm'});
            response.$promise.then(fetchJfm);
            response.$promise.catch(errorFetchJfm);
          }

          function fetchJfm(data) {
            vm.listJfm=data;
          }

          function errorFetchJfm() {
            vm.listJfm=[];
          }

          function loadJfmSub(id_jfm) {
            var response=Promotion.query({action:'viewJfmSub',id:id_jfm});
            response.$promise.then(fetchJfmSub);
            response.$promise.catch(errorFetchJfmSub);
          }

          function fetchJfmSub(data) {
            vm.listJfmSub=data;
          }

          function errorFetchJfmSub() {
            vm.listJfmSub=[];
          }

          function empList() {
            var response = Promotion.query({
                action: 'viewListEmployee',
                company: vm.company
            });
            response.$promise.then(fetchDataEmpList);
          }
      
          function fetchDataEmpList(data) {
            vm.empListData = data;
          }

          function querySearchDeferred(query) {
            var deferred = $q.defer();
            setTimeout(function() {
                var data = vm.empListData;
                if (query) {
                    deferred.resolve(filterFilter(data, query));
                } else {
                    deferred.reject([{ nik: 'none', name: 'none' }]);
                }
            }, 200);
            return deferred.promise;
          }
        
    }
    
})();  

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .directive("ngUploadChange", function () {
            return {
                scope: {
                    ngUploadChange: "&"
                },
                link: function ($scope, $element, $attrs) {
                    $element.on("change", function (event) {
                        $scope.$apply(function () {
                            $scope.ngUploadChange({ $event: event })
                        })
                    })
                    $scope.$on("$destroy", function () {
                        $element.off();
                    });
                }
            }
        })
        .controller('ProfileemployeController', ProfileemployeController)

    ProfileemployeController.$inject = ['$state', '$stateParams', '$timeout', 'Form', 'AppAPI', 'EmployeeService', '$mdDialog', 'FileUploader', 'config', '$localStorage'];
    /** @ngInject */
    function ProfileemployeController($state, $stateParams, $timeout, Form, AppAPI, EmployeeService, $mdDialog, FileUploader, config, $localStorage) {

        var vm = this;

        EmployeeService.title = 'Profile';

        vm.activeItem = [{
            label: 'Profile',
            link: 'app.employee_employe_edit.profile'
        }];

        // initial form
        Form.initialForm();

        var Profiles = AppAPI.Profiles();
        var Employe = AppAPI.Employe();
        var Profiles = AppAPI.Profiles();

        // set constructor form
        Form.setObject(Profiles);

        // set form to controller
        vm.Form = Form;
        vm.stateEdit = false;
        vm.ChangeState = ChangeState;
        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        vm.completion = false;
        vm.country = $localStorage.country;
        checkCompletion();
        employe();
        LoadCountry();
        vm.viewMenus = viewMenus;
        vm.profileId = $stateParams.id;
        vm.showUpload = false;
        vm.setShowUpload = setShowUpload;
        vm.changeFile = changeFile;
        vm.canUpdate = true;

        var response = vm.Form.objForm.$get({ action: 'viewdetail', id: $stateParams.id });
        response.then(changeDate);

        vm.title = ['Mr', 'Mrs', 'Miss', 'Ms'];
        vm.jenkel = ['L', 'P'];

        vm.fullname = '';
        vm.listCountry = [];

        vm.saveProfile = saveProfile;

        vm.clearMeesage = clearMeesage;
        vm.viewComment = viewComment;

        function setShowUpload() {
            vm.showUpload = true;
            if (vm.Form.objForm.maritalStatus == 'Lajang') {
                vm.showUpload = false;
            }
        }

        function changeFile(event) {
            vm.canUpdate = true;
        }

        function changeDate(data) {
            if ($localStorage.country != 'IDN') {
                if (data.jenkel == 'L') {
                    vm.maritalStatuses = [{ id: 'Lajang', value: 'Single' },
                    { id: 'Menikah', value: 'Married' },
                    { id: 'Duda', value: 'Divorce' }];
                } else {
                    vm.maritalStatuses = [{ id: 'Lajang', value: 'Single' },
                    { id: 'Menikah', value: 'Married' },
                    { id: 'Janda', value: 'Divorce' }];
                }
            } else {
                if (data.jenkel == 'L') {
                    vm.maritalStatuses = [{ id: 'Lajang', value: 'Belum Menikah' },
                    { id: 'Menikah', value: 'Menikah' },
                    { id: 'Duda', value: 'Duda' }];
                } else {
                    vm.maritalStatuses = [{ id: 'Lajang', value: 'Belum Menikah' },
                    { id: 'Menikah', value: 'Menikah' },
                    { id: 'Janda', value: 'Janda' }];
                }
            }
            vm.Form.objForm.dateOfBirth = new Date(data.dateOfBirth);
            vm.Form.objForm.dateJoin = new Date(data.dateJoin);
            vm.Form.objForm.height = parseFloat(data.height);
            if (data.lastName == null && data.middleName == null) {
                vm.fullname = data.firstName;
            } else if (data.middleName == null) {
                vm.fullname = data.firstName + ' ' + data.lastName;
            } else {
                vm.fullname = data.firstName + ' ' + data.middleName + ' ' + data.lastName;
            }
            if (data.nationality == null) {
                data.nationality = '';
            }
            vm.Form.objForm.maritalStatus = data.maritalStatus;
        }

        function LoadCountry() {
            var response = Profiles.query({ action: 'getCountry' });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listCountry = data;
        }

        function errorFetchCountry() {
            vm.listCountry = [];
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function ChangeState() {
            switch (vm.stateEdit) {
                case true:
                    vm.stateEdit = false;
                    break;
                case false:
                    vm.stateEdit = true;
                    break;
            }
        }

        function saveProfile(formController) {
            if (typeof $("#uploadData")[0] != 'undefined') {
                var vidFileLength = $("#uploadData")[0].files.length;
                if (vidFileLength === 0) {
                    vm.Form.tampilPesan = true;
                    vm.Form.pesan = 'MENU.MAIN.PLEASECHOOSEAFILE';
                } else {
                    angular.element.blockUI();
                    var str = vm.fullname;
                    var words = str.split(" ");

                    for (var i = 0; i < words.length - 1; i++) {
                        words[i] += " ";
                    }

                    if (words.length >= 3) {
                        vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                        vm.Form.objForm.middleName = words[1].replace(/\s/g, '');
                        vm.Form.objForm.lastName = str.substring(words[0].length + words[1].length);
                    } else if (words.length == 2) {
                        vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                        vm.Form.objForm.middleName = null;
                        vm.Form.objForm.lastName = words[1].replace(/\s/g, '');
                    } else {
                        vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                        vm.Form.objForm.middleName = null;
                        vm.Form.objForm.lastName = null;
                    }

                    if ($localStorage.country == 'MYS' && vm.Form.objForm.maritalStatus == 'Duda') {
                        if (vm.Form.objForm.title == 'Mr') {
                            vm.Form.objForm.maritalStatus = 'Duda';
                        } else {
                            vm.Form.objForm.maritalStatus = 'Janda';
                        }
                    }
                    vm.Form.objForm.firstName = words[0].replace(/\s/g, '');

                    var response = Form.updateData('updatedata', formController, Profiles, $stateParams.id, 'viewdetail');
                    response.then(function () {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.uploader.uploadAll();
                        vm.showUpload = false;
                        vm.Form.objForm.dateOfBirth = new Date(vm.Form.objForm.dateOfBirth);
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                            vm.stateEdit = false;
                        }, 3000);
                    });

                    response.catch(function () {
                        vm.messageTheme = 'pink';
                        angular.element.unblockUI();
                    });
                }
            } else {
                angular.element.blockUI();
                var str = vm.fullname;
                var words = str.split(" ");

                for (var i = 0; i < words.length - 1; i++) {
                    words[i] += " ";
                }

                if (words.length >= 3) {
                    vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                    vm.Form.objForm.middleName = words[1].replace(/\s/g, '');
                    vm.Form.objForm.lastName = str.substring(words[0].length + words[1].length);
                } else if (words.length == 2) {
                    vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                    vm.Form.objForm.middleName = null;
                    vm.Form.objForm.lastName = words[1].replace(/\s/g, '');
                } else {
                    vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                    vm.Form.objForm.middleName = null;
                    vm.Form.objForm.lastName = null;
                }

                if ($localStorage.country == 'MYS' && vm.Form.objForm.maritalStatus == 'Duda') {
                    if (vm.Form.objForm.title == 'Mr') {
                        vm.Form.objForm.maritalStatus = 'Duda';
                    } else {
                        vm.Form.objForm.maritalStatus = 'Janda';
                    }
                }
                vm.Form.objForm.firstName = words[0].replace(/\s/g, '');

                var response = Form.updateData('updatedata', formController, Profiles, $stateParams.id, 'viewdetail');
                response.then(function () {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();
                    vm.uploader.uploadAll();
                    vm.showUpload = false;
                    vm.Form.objForm.dateOfBirth = new Date(vm.Form.objForm.dateOfBirth);
                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                        vm.stateEdit = false;
                    }, 3000);
                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    angular.element.unblockUI();
                });
            }
        }


        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({ action: 'checkCompletionData', id: $stateParams.id });
            resp.$promise.then(fetchData);
            resp.$promise.catch(errorFetchData);
            // vm.listOtselected=[];
        }

        function fetchData(data) {
            vm.listCompletion = data[0];
            if (vm.listCompletion.profiles && vm.listCompletion.address && vm.listCompletion.dependents
                && vm.listCompletion.doc_ktp && vm.listCompletion.doc_ijazah && vm.listCompletion.doc_sim && vm.listCompletion.education
                && vm.listCompletion.experience && vm.listCompletion.bank && vm.listCompletion.tax) {
                vm.completion = true;
            }
        }

        function errorFetchData() {
            vm.listCompletion = [];
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go('app.employee_myemploye_edit.' + id, { id: $stateParams.id });
        }

        function employe() {
            var response = Employe.get({ action: 'viewdetail', id: $stateParams.id });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.photoAddress = data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'DependentViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/dependent/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    var response = vm.Form.objForm.$get({ action: 'viewdetail', id: $stateParams.id });
                    response.then(changeDate);
                },
                locals: {
                    id: id,
                    constructor: Profiles
                }
            });
        }

        var uploader = vm.uploader = new FileUploader({
            url: config.api + 'api/profiles/uploadmartialdoc',
            removeAfterUpload: true,
            alias: 'martialdoc',
        });

        // a sync filter
        uploader.filters.push({
            name: 'syncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        // an async filter
        uploader.filters.push({
            name: 'asyncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options, deferred) {
                setTimeout(deferred.resolve, 1e3);
            }
        });
    }
})();  

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('LanguageemployeController', LanguageemployeController);


    LanguageemployeController.$inject = ['$state', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'EmployeeService', '$filter'];
    /** @ngInject */
    function LanguageemployeController($state, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, EmployeeService, $filter) {

        var vm = this;
        var translate = $filter('translate');

        EmployeeService.title = translate('MYPROFILE.MENU.LANGUAGE');

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();
        var Language = AppAPI.Language();
        var Profiles = AppAPI.Profiles();

        // set constructor form
        Form.setObject(Language);

        // set form to controller
        vm.Form = Form;
        vm.completion = false;

        employe();
        viewLang();

        vm.openInputLanguage = openInputLanguage;
        vm.editInputLanguage = editInputLanguage;
        vm.closeModal = closeModal;

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.saveData = saveData;
        vm.deleteData = deleteData;

        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        checkCompletion();
        vm.viewMenus = viewMenus;


        viewData();
        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Language.query({ action: 'viewData', emp_id: $stateParams.id });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function employe() {
            var response = Employe.get({ action: 'viewdetail', id: $stateParams.id });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.firstName = data.firstName;
            vm.Form.objForm.middleName = data.middleName;
            vm.Form.objForm.lastName = data.lastName;
            vm.Form.objForm.empId = data.id;
            vm.empId = data.id;
            vm.Form.objForm.photoAddress = data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        function viewLang() {
            angular.element.blockUI();
            var dataPromise = Language.query({ action: 'viewLang' });
            dataPromise.$promise.then(fetchDataLang);
            dataPromise.$promise.catch(errorFetchLang);
        }

        function fetchDataLang(data) {
            vm.listLang = data;
            angular.element.unblockUI();
        }

        function errorFetchLang() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }


        function openInputLanguage(ev) {
            $mdDialog.show({
                controller: 'LanguageemployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/language/input-language.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    employe();
                }
            });
        }

        function editInputLanguage(ev, id) {
            $mdDialog.show({
                controller: 'LanguageemployeeditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/language/input-language.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    employe();
                },
                locals: {
                    id: id
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.typeOfLanguage = '-';
            var promise = Form.saveData('save', formController, Language);
            promise.then(function (data) {
                showDialog(ev, data);
            });
        }

        function showDialog(ev, data) {
            var $translate = $filter('translate');
            var Message = $translate(data.pesan);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(Message)
                    .textContent(Message)
                    .ariaLabel(Message)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Language.delete({ action: 'deletelanguage', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                }, function () {

                });
            });


        }

        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({ action: 'checkCompletionData', id: $stateParams.id });
            resp.$promise.then(fetchDataCompletion);
            resp.$promise.catch(errorFetchDataCompletion);
            // vm.listOtselected=[];
        }

        function fetchDataCompletion(data) {
            vm.listCompletion = data[0];
            if (vm.listCompletion.profiles && vm.listCompletion.address && vm.listCompletion.dependents
                && vm.listCompletion.doc_ktp && vm.listCompletion.doc_ijazah && vm.listCompletion.doc_sim && vm.listCompletion.education
                && vm.listCompletion.experience && vm.listCompletion.bank && vm.listCompletion.tax) {
                vm.completion = true;
            }
        }

        function errorFetchDataCompletion() {
            vm.listCompletion = [];
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go('app.employee_myemploye_edit.' + id, { id: $stateParams.id });
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('LanguageemployeeditController', LanguageemployeeditController);

    /** @ngInject */
    LanguageemployeeditController.$inject=['$mdDialog','id','AppAPI','Auth','Form','$filter'];
    /** @ngInject */
    function LanguageemployeeditController($mdDialog,id,AppAPI,Auth,Form,$filter)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Language=AppAPI.Language();

	    // set constructor form
	    Form.setObject(Language);

	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewDetail',id:id.id});
        response.then(SetData);
	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;

		vm.messageTheme='pink';
		
		viewLang();

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

	    function SetData(data){
	    	vm.Form.objForm.languageCode=data.language_code;
	    	vm.Form.objForm.typeOfLanguage=data.type_of_language;
		}
		
		function viewLang() {
            angular.element.blockUI();
            var dataPromise = Language.query({action:'viewLang'});
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch); 
         }
 
         function fetchData(data) {
             vm.listLang = data;
             angular.element.unblockUI();
         }
 
         function errorFetch() {
             vm.listData = [];
             angular.element.unblockUI();
         }


/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updatelanguage', formController, Employe);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/
        function saveData(ev, formController) {
			vm.Form.objForm.typeOfLanguage='-';
            var promise= Form.updateData('update',formController,Language, Form.objForm.id,'viewDetail');
            promise.then(function(data){
	            // showDialog(ev,data);
            });
        }

	    function showDialog(ev,data) {
			var $translate = $filter('translate');
			var Message = $translate(data.pesan);
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title(Message)
	        .textContent(Message)
	        .ariaLabel(Message)
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        // closeModal();
		    });
	    }
    }
    
})();  

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('JoindateController', JoindateController);

    JoindateController.$inject = [
        '$state',
        '$scope',
        '$localStorage',
        '$stateParams',
        '$timeout',
        'Form',
        'AppAPI',
        'Auth',
        '$mdDialog',
        '$http',
        'config',
        '$filter',
        'EmployeeService',
        '$mdToast'
    ];
    /** @ngInject */
    function JoindateController(
        $state,
        $scope,
        $localStorage,
        $stateParams,
        $timeout,
        Form,
        AppAPI,
        Auth,
        $mdDialog,
        $http,
        config,
        $filter,
        EmployeeService,
        $mdToast
    ) {
        var vm = this;
        var translate = $filter('translate');

        EmployeeService.title = 'Employe Join Date';

        // initial form
        Form.initialForm();

        var Employe = AppAPI.Employe();
        // set constructor form

        // set form to controller
        vm.Form = Form;
        vm.country = $localStorage.country;
        vm.closeModal = closeModal;
        vm.Completed = false;
        vm.stateEdit = false;
        vm.ChangeState = ChangeState;
        vm.ChangeJoinDate = ChangeJoinDate;

        loadData();

        function loadData() {
            var response = Employe.query({
                action: "viewDataEmpJoinDate",
                id: $stateParams.id
            });
            response.$promise.then(SetData);
            response.$promise.catch(errorFetchData);
        }

        function SetData(data) {
            if (data.length > 0) {
                if (data[0].join_date) {
                    vm.Form.objForm.join_date = new Date(data[0].join_date);
                }

                if (data[0].effective_date) {
                    vm.Form.objForm.effective_date = new Date(data[0].effective_date);
                }

                if (data[0].nikeffective) {
                    vm.Form.objForm.nikeffective = new Date(data[0].nikeffective);
                }

                vm.Form.objForm.title = data[0].title;
                vm.Form.objForm.firstName = data[0].first_name;
                vm.Form.objForm.middleName = data[0].middle_name;
                vm.Form.objForm.lastName = data[0].last_name;
            }
        }

        function errorFetchData() {
            console.log('error');
        }

        function ChangeState() {
            switch (vm.stateEdit) {
                case true:
                    loadData();
                    vm.stateEdit = false;
                    break;
                case false:
                    vm.stateEdit = true;
                    break;
            }
        }

        function ChangeJoinDate() {
            var joinDateEmp = new Employe();
            joinDateEmp.id = $stateParams.id;
            joinDateEmp.join_date = vm.Form.objForm.join_date;
            joinDateEmp.effective_date = vm.Form.objForm.effective_date;
            joinDateEmp.action = "changeJoinDateEmp";
            var response = joinDateEmp.$save();
            response.then(function () {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Data Berhasil disimpan')
                    .position('top right')
                    .hideDelay(3000)
                    .theme("success-toast")
                );
                vm.stateEdit = false;
                loadData();
            });
            response.catch(function () {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Data Gagal disimpan')
                    .position('top right')
                    .hideDelay(3000)
                    .theme("error-toast")
                );
                vm.stateEdit = false;
                loadData();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('JoindateeditController', JoindateeditController);

    JoindateeditController.$inject = [
        '$state',
        '$scope',
        '$localStorage',
        '$stateParams',
        '$timeout',
        'Form',
        'AppAPI',
        'Auth',
        '$mdDialog',
        '$http',
        'config',
        '$filter',
        'EmployeeService',
        '$mdToast'
    ];
    /** @ngInject */
    function JoindateeditController(
        $state,
        $scope,
        $localStorage,
        $stateParams,
        $timeout,
        Form,
        AppAPI,
        Auth,
        $mdDialog,
        $http,
        config,
        $filter,
        EmployeeService,
        $mdToast
    ) {
        var vm = this;
        var translate = $filter('translate');

        EmployeeService.title = 'Employe Join Date';

        // initial form
        Form.initialForm();

        var Employe = AppAPI.Employe();
        // set constructor form

        // set form to controller
        vm.Form = Form;
        vm.country = $localStorage.country;
        vm.closeModal = closeModal;
        vm.Completed = false;
        vm.stateEdit = false;
        vm.ChangeState = ChangeState;
        vm.ChangeJoinDate = ChangeJoinDate;

        loadData();

        function loadData() {
            var response = Employe.query({
                action: "viewDataEmpJoinDate",
                id: $stateParams.id
            });
            response.$promise.then(SetData);
            response.$promise.catch(errorFetchData);
        }

        function SetData(data) {
            if (data.length > 0) {
                if (data[0].join_date) 
                {
                    vm.Form.objForm.join_date = new Date(data[0].join_date);
                }

                if (data[0].effective_date) 
                {
                    vm.Form.objForm.effective_date = new Date(data[0].effective_date);
                }

                if (data[0].nikeffective) 
                {
                    vm.Form.objForm.nikeffective = new Date(data[0].nikeffective);
                }

                vm.Form.objForm.title = data[0].title;
                vm.Form.objForm.firstName = data[0].first_name;
                vm.Form.objForm.middleName = data[0].middle_name;
                vm.Form.objForm.lastName = data[0].last_name;
            }
        }

        function errorFetchData() {
            console.log('error');
        }

        function ChangeState() {
            switch (vm.stateEdit) {
                case true:
                    loadData();
                    vm.stateEdit = false;
                    break;
                case false:
                    vm.stateEdit = true;
                    break;
            }
        }

        function ChangeJoinDate(formController) {
            var joinDateEmp = new Employe();
            joinDateEmp.id = $stateParams.id;
            joinDateEmp.join_date = formController.join_date.$viewValue;
            joinDateEmp.effective_date = formController.effective_date.$viewValue;
            joinDateEmp.nikeffective = formController.nikeffective.$viewValue;
            joinDateEmp.action = "changeJoinDateEmp";
            var response = joinDateEmp.$save();
            response.then(function () {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Data Berhasil disimpan')
                    .position('top right')
                    .hideDelay(3000)
                    .theme("success-toast")
                );
                vm.stateEdit = false;
                loadData();
            });
            response.catch(function () {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Data Gagal disimpan')
                    .position('top right')
                    .hideDelay(3000)
                    .theme("error-toast")
                );
                vm.stateEdit = false;
                loadData();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }
    }
})();

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('ImigrationemployeController', ImigrationemployeController);


    ImigrationemployeController.$inject=['$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','EmployeeService'];
    /** @ngInject */
    function ImigrationemployeController($stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,EmployeeService)
    {
        
        var vm = this;

        EmployeeService.title = 'Imigration';
        
        // initial form
        Form.initialForm();

        var Employe=  AppAPI.Employe();

        // set constructor form
        Form.setObject(Employe);

        // set form to controller
        vm.Form = Form;

        employe();

        function employe()
        {
            var response=Employe.get({action:'viewdetail',id:$stateParams.id});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title=data.title;
            vm.Form.objForm.firstName=data.lastName;
            vm.Form.objForm.lastName=data.lastName;
            vm.Form.objForm.empId=data.id;
            vm.Form.objForm.photoAddress=''; 
            vm.empId = data.id;
        }

        function errorFetchEmploye() {
            console.log('error');
        }
      
        
        vm.empId = vm.Form.objForm.id;

        vm.openInputImigration = openInputImigration;
        vm.editInputImigration = editInputImigration;
        vm.closeModal = closeModal;

        vm.listData=[];
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listDataSelected=[];

        vm.saveData=saveData;
        vm.deleteData=deleteData;

        var Employe = AppAPI.Employe();
        viewData();
        vm.dtOptions = {
            dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
          DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData() {
           angular.element.blockUI();
           var dataPromise = Employe.query({action:'viewallimigration',id:$stateParams.id});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
           vm.listDataSelected=angular.copy(vm.listData);
        }

        function unCheckAll() {
           vm.listDataSelected=[];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }
       

        function openInputImigration(ev)
        {
            $mdDialog.show({
                controller         : 'ImigrationemployeController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/employe/input-employe/imigration/input-imigration.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true
            });
        }

        function editInputImigration(ev, id)
        {
            $mdDialog.show({
                controller         : 'ImigrationemployeeditController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/employe/input-employe/imigration/input-imigration.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals:{
                  id:id
                }
            });
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {
            var promise= Form.saveData('saveimigration', formController, Employe);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function deleteData(ev) {
       
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=Employe.delete({action:'deleteimigration',data:angular.toJson(vm.listDataSelected)});

                    response.$promise.then(viewData);
                }, function() {

                });
            });
      
       
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('ImigrationemployeeditController', ImigrationemployeeditController);

    /** @ngInject */
    ImigrationemployeeditController.$inject=['$mdDialog','id','AppAPI','Auth','Form'];
    /** @ngInject */
    function ImigrationemployeeditController($mdDialog,id,AppAPI,Auth,Form)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Employe=AppAPI.Employe();

	    // set constructor form
	    Form.setObject(Employe);

	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewimigration',id:id.id});
        response.then(changeDate);

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;

	    vm.messageTheme='pink';


        function changeDate(data) {
           vm.Form.objForm.expDate=new Date(data.expDate);
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updateimigration', formController, Employe);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/
        function saveData(ev, formController) {
            var promise= Form.updateData('updateimigration',formController,Employe, Form.objForm.id,'viewimigration');
            promise.then(function(){
	            showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }
    }
    
})();  

(function () {
  'use strict';

  angular
    .module('app.employee.employe.input-employe')
    .controller('LookUpLayerController', LookUpLayerController);

  /** @ngInject */
  LookUpLayerController.$inject = ['$stateParams', '$mdDialog', '$localStorage', 'AppAPI', 'Auth', 'id'];
  /** @ngInject */
  function LookUpLayerController($stateParams, $mdDialog, $localStorage, AppAPI, Aut, id) {

    var vm = this;
    vm.cancel = cancel;
    var Employements = AppAPI.Employements();
    var Attendancereport = AppAPI.Attendancereport();

    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.selectedCange = selectedCange;
    vm.company = id.company;
    vm.divisi = id.divisi;
    vm.department = id.department;
    vm.loadLayerData = loadLayerData;
    vm.chooseEmployee = chooseEmployee;
    vm.isLoadingLoadEmployee = true;
    vm.directReport = id.directReport;

    // console.log(id);

    loadDataBU();
    loadDataDivision(vm.company)
    loadDataDepartment(vm.divisi, 0);
    loadLayerData();
    // activate(); 

    ////////////////////////////////////

    // function activate()
    // {
    //   var loadBu=loadDataBU();
    //   loadBu.then(function()
    //   {
    //     var loadDivsi=loadDataDivision(vm.company);
    //     loadDivsi.then(function(){
    //       var loadDept=loadDataDepartment(vm.divisi,0);
    //       loadDept.then(function(){
    //         loadLayerData();
    //       });
    //     });
    //   });
    // }

    function cancel() {
      $mdDialog.hide();
    }

    function loadDataDepartment(iddivisi, isChange) {
      vm.isLoadingLoadEmployee = true;
      var response = Attendancereport.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
      vm.isLoadingLoadEmployee = false;
    }

    function errorDepartment() {
      vm.listDepartment = [];
      vm.isLoadingLoadEmployee = false;
    }

    function loadDataDivision(idbu) {
      vm.isLoadingLoadEmployee = true;
      var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
      vm.listDivision = data;
      vm.isLoadingLoadEmployee = false;
    }

    function errorDivisiBU() {
      vm.listDivision = [];
      vm.isLoadingLoadEmployee = false;
    }

    function loadDataBU() {
      vm.isLoadingLoadEmployee = true;
      var response = Attendancereport.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
      vm.isLoadingLoadEmployee = false;

    }

    function errorFetchBU() {
      vm.listBU = [];
      vm.isLoadingLoadEmployee = false;
    }

    function loadLayerData() {
      vm.saveProcess = true;
      vm.isLoadingLoadEmployee = true;
      var response = Employements.query({
        action: "getLayerData",
        company: vm.company,
        divisi: vm.divisi,
        department: vm.department,
        search: vm.searchParam,
        directreport: vm.directReport
      }
      );
      response.$promise.then(fetchEmp);
      response.$promise.catch(errorFetchEmp);

    }

    function fetchEmp(data) {
      vm.empList = data;
      vm.isLoadingLoadEmployee = false;
    }

    function errorFetchEmp() {
      vm.isLoadingLoadEmployee = false;
    }

    function selectedCange(v) {
      switch (v) {
        case 'dept':
          loadLayerData();
          break;
        case 'div':
          loadDataDepartment(vm.divisi, 0);
          break;
        case 'comp':
          loadDataDivision(vm.company);
          break;
      }
    }

    function chooseEmployee(item) {
      $localStorage.seleEctedJob = item;
      $mdDialog.hide($localStorage.seleEctedJob);
    }

  }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('LookUpEmployeeController', LookUpEmployeeController);

    /** @ngInject */
    LookUpEmployeeController.$inject=['$stateParams','$mdDialog','$localStorage','AppAPI','Auth','id'];
    /** @ngInject */
    function LookUpEmployeeController($stateParams,$mdDialog,$localStorage,AppAPI,Aut,id)
    {
        
      var vm = this;
	    vm.cancel=cancel;
      var Employements=AppAPI.Employements(); 
      var Attendancereport=AppAPI.Attendancereport();
 
      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      vm.selectedCange=selectedCange;
      vm.company=id.company;
      vm.divisi=id.divisi;
      vm.department=id.department;
      vm.loadEmployeeData=loadEmployeeData;
      vm.chooseEmployee=chooseEmployee;
      vm.loadEmployeeData=loadEmployeeData;
      vm.isLoadingLoadEmployee=false;

      // console.log(id);

      loadDataBU();
      loadDataDivision(vm.company)
      loadDataDepartment(vm.divisi,0);
      loadEmployeeData();

      ////////////////////////////////////

      function cancel()
      {
        $mdDialog.hide();
      }

      function loadDataDepartment(iddivisi,isChange) 
      { 
        vm.isLoadingLoadEmployee=true;
        
        var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) 
      {
        vm.listDepartment=data;  
        vm.isLoadingLoadEmployee=false;
        loadEmployeeData();
      }

      function errorDepartment() {
        vm.listDepartment=[]; 
        vm.isLoadingLoadEmployee=false;
      }
      
      function loadDataDivision(idbu) {
         vm.saveProcess=true;
         var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
      }

      function fetchDivisiBU(data) {
       vm.listDivision=data; 
       vm.isLoadingLoadEmployee=false;
       // vm.listDivision.push(data); 
       // loadData(1); 
      }

      function errorDivisiBU() {
        vm.listDivision=[];
        vm.isLoadingLoadEmployee=false;
      } 

      function loadDataBU() {
         vm.saveProcess=true;
        var response=Attendancereport.query({action:'viewBu'});
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
        vm.listBU=data;
        vm.isLoadingLoadEmployee=false;

      }

      function errorFetchBU() {
        vm.listBU=[];
        vm.isLoadingLoadEmployee=false;
      }

      function loadEmployeeData()
      {
        vm.isLoadingLoadEmployee=true;
         vm.saveProcess=true;
          var response=Employements.query({
                action: "getemployee",
                company:vm.company,
                divisi:vm.divisi,
                department:vm.department,
                search:vm.searchParam
              }
            );
          response.$promise.then(fetchEmp);
          response.$promise.catch(errorFetchEmp);

      }

      function fetchEmp(data) {
        vm.empList=data;
        vm.isLoadingLoadEmployee=false;
      }

      function errorFetchEmp() {
        vm.Form.objForm.directReport=null;
        vm.isLoadingLoadEmployee=false;
      }

      function selectedCange(v)
      {
        switch(v)
        {
          case 'dept':
            loadEmployeeData();
          break;
          case 'div':
            loadDataDepartment(vm.divisi,0);
          break;
          case 'comp':
            loadDataDivision(vm.company);
          break;
        }
      }

      function chooseEmployee(item)
      {
        $localStorage.selectedEmployee = item;
        $mdDialog.hide($localStorage.selectedEmployee);
      }

    } 
})();  

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('EmployementsemployeController', EmployementsemployeController);


    EmployementsemployeController.$inject = ['$stateParams', '$document', '$localStorage', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'EmployeeService', 'DataService', '$filter'];
    /** @ngInject */
    function EmployementsemployeController($stateParams, $document, $localStorage, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, EmployeeService, DataService, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.EmployeeService = EmployeeService;
        EmployeeService.title = 'Job';
        vm.viewData = viewData;

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService(); //inisialisasi class DataService

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();
        var Employements = AppAPI.Employements();
        var Attendancereport = AppAPI.Attendancereport();
        vm.employe = employe;

        // set constructor form
        Form.setObject(Employements);


        // set form to controller
        vm.Form = Form;
        vm.company = $localStorage.empsite;
        vm.groupLogin = $localStorage.group;
        vm.user = $localStorage.user;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.Form.objForm.nik = null;
        vm.nik = false;
        vm.Form.objForm.hiredate = null;
        vm.hiredate = false;
        vm.Form.objForm.jointdate = null;
        vm.jointdate = false;
        vm.divisi = null;
        vm.department = null;
        vm.getJobTitle = getJobTitle;
        vm.getLevelCategory = getLevelCategory;
        vm.saveProcess = false;
        vm.changeNik = changeNik;
        employe();
        loadDataBU();
        loadDataDivision(vm.company);
        vm.ActingProcess=ActingProcess;

        //////////////////////////////
        function employe() {
            var response = Employe.get({ action: 'viewdetail', id: $stateParams.id });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }



        function fetchEmploye(data) {
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.firstName = data.firstName;
            vm.Form.objForm.middleName = data.middleName;
            vm.Form.objForm.lastName = data.lastName;
            vm.Form.objForm.empId = $stateParams.id;
            vm.Form.objForm.photoAddress = '';
            vm.empId = data.id;
            vm.Form.objForm.photoAddress = data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }



        vm.grade = ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A', '6B', '6C', '7'];
        vm.level = ['001', '002', '003', '004', '005', '006', '007', '008'];
        vm.category = ['Non-Staff', 'Staff', 'Supervisory', 'Managerial'];

        vm.openInputEmployement = openInputEmployement;
        vm.editInputEmployement = editInputEmployement;
        vm.closeModal = closeModal;

        vm.listData = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.saveData = saveData;
        vm.deleteData = deleteData;


        viewData(1);
        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData(pageno) {
            angular.element.blockUI();
            var dataPromise = vm.DataTable.loadData(Employements, pageno, { action: 'viewData', emp_id: $stateParams.id });
            dataPromise.then(function(){
                angular.element.unblockUI();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            console.log(div);

            div.isChecked = !div.isChecked;
        }


        function openInputEmployement(ev) {
            $mdDialog.show({
                controller: 'EmployementsemployeinputController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/employement/input-employement.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {
                    viewData(1);
                    employe();
                }
            });
        }

        function editInputEmployement(ev, id) {
            $mdDialog.show({
                controller: 'EmployementsemployeeditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/employement/input-employement.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData(1);
                    employe();
                },
                locals: {
                    id: id
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            // vm.Form.objForm.firstName=vm.Form.objForm.firstNameD;
            //  vm.Form.objForm.lastName=vm.Form.objForm.firstNameD;
            var promise = Form.saveData('save', formController, Employements);
            promise.then(function () {
                showDialog(ev);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function deleteData(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Employements.delete({ action: 'deleteemployements', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(function () {
                        viewData(1);
                        employe();
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#contentDialog')))
                                .clickOutsideToClose(true)
                                .title('Success Delete Data')
                                .textContent('Process Delete was Success.')
                                .ariaLabel('Success Delete Data')
                                .ok('OK')
                                .targetEvent(ev)
                        ).then();
                    });
                }, function () {

                });
            });


        }

        function loadDataDepartment(iddivisi) {
            vm.saveProcess = true;
            var response = Attendancereport.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            vm.saveProcess = false;

            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
            vm.saveProcess = false;
        }

        function loadDataDivision(idbu) {
            vm.saveProcess = true;
            var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            vm.saveProcess = false;
            // vm.listDivision.push(data); 
            // loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
            vm.saveProcess = false;
        }

        function loadDataBU() {
            vm.saveProcess = true;
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
            vm.saveProcess = false;

        }

        function errorFetchBU() {
            vm.listBU = [];
            vm.saveProcess = false;
        }

        function getJobTitle() {
            vm.saveProcess = true;
            var response = Employements.query({ action: 'getJobTitle', company: vm.company, divisi: vm.divisi, department: vm.department });
            response.$promise.then(fetchJobTitle);
            response.$promise.catch(errorJobTitle);
        }

        function fetchJobTitle(data) {
            vm.listJobTitle = data;
            vm.saveProcess = false;

        }

        function errorJobTitle() {
            vm.listJobTitle = [];
            vm.saveProcess = false;
        }

        function getLevelCategory(grade) {
            vm.saveProcess = true;
            vm.Form.objForm.empCategory = null;
            vm.Form.objForm.jobLevel = null;
            var response = Employements.query({ action: 'getLevelCategory', grade: grade });
            response.$promise.then(fetchLevel);
            response.$promise.catch(errorFtechLevel);

        }
        function fetchLevel(data) {
            vm.Form.objForm.empCategory = data[0].description;
            vm.Form.objForm.jobLevel = data[0].level;
            vm.saveProcess = false;

        }

        function errorFtechLevel() {
            vm.Form.objForm.empCategory = null;
            vm.saveProcess = false;
        }

        function changeNik(ev) {
            $mdDialog.show({
                controller: 'EmployementschangenikController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/employement/change-nik.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    // employe();
                }
            });
        }

        function ActingProcess(ev,data,act)
        {
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            // console.log(act);
            switch(act)
            {
                case 'failed':
                var promise = Auth.setToken();
                promise.then(function (){
                    var conf= $mdDialog.confirm()
                    .title('Are you sure?')
                    .textContent("Promotion failed will be remove acting job")
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no); 
                    $mdDialog.show(conf).then(function () 
                    { 
                        // angular.element.blockUI();
                        var response = Employements.delete({ action: 'failedacting', data: angular.toJson(data)});
                        response.$promise.then(viewData);
                    }, function () {
                        console.log('cancel');
                    }); 
                }); 
                break;
                case 'pass':
                var promise = Auth.setToken();
                promise.then(function (){
                    var conf= $mdDialog.confirm()
                    .title('Are you sure?')
                    .textContent("Promotion pass will be remove acting job")
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no); 
                    $mdDialog.show(conf).then(function () 
                    { 
                        // angular.element.blockUI();
                        var response = Employements.delete({ action: 'passActing', data: angular.toJson(data)});

                        response.$promise.then(viewData);
                    }, function () {
                        console.log('cancel');
                    });
                });  
                break;
            }
            // if(act=='remove')
            // {
                
            // }
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('EmployementsemployeinputController', EmployementsemployeinputController);

    /** @ngInject */
    EmployementsemployeinputController.$inject=['$stateParams','$mdDialog','$localStorage','AppAPI','Auth','Form','FileUploader','config'];
    /** @ngInject */
    function EmployementsemployeinputController($stateParams,$mdDialog,$localStorage,AppAPI,Auth,Form,FileUploader,config)
    {
        
      var vm = this;
	    // initial form
	    Form.initialForm(false);

	    // get constructor form
	    var Employements=AppAPI.Employements(); 
      var Attendancereport=AppAPI.Attendancereport();

	    // set constructor form
	    Form.setObject(Employements);

	    // set form to controller
	    vm.Form = Form; 

	    vm.closeModal=closeModal;
	    // vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;
	    // vm.company=$localStorage.empsite;
	    vm.Form.objForm.nik=null;
      vm.nik=true;
      vm.Form.objForm.hiredate=null;
      vm.hiredate=true;
      vm.Form.objForm.jointdate=null;
      vm.jointdate=true;
      vm.divisi=null;
      vm.department=null; 
      vm.getJobTitle=getJobTitle;
      vm.getLevelCategory=getLevelCategory; 
      vm.saveProcess=false;
      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      vm.changeCategory=changeCategory; 
      
      vm.searchTerm = '';
      vm.clearSearchTerm = clearSearchTerm;
      vm.searchTermLayer = '';
      vm.clearSearchTermLayer = clearSearchTermLayer;

      vm.getemployee=getemployee;
      vm.getOrgLayer=getOrgLayer;
      vm.changeDirect=changeDirect;

	    vm.messageTheme='red';
      vm.grade = ['1A','1B','1C','2A','2B','2C','3A','3B','3C','4A','4B','4C','5A','5B','5C','6A','6B','6C','7'];
      vm.category = [];
      vm.orgLayer = [];
      vm.checkIsNeddFile = checkIsNeddFile
      vm.company='';
      vm.divisi='';
      vm.chooseJob=chooseJob;
      vm.isLayerOverlap=false;
      vm.selectedCange=selectedCange;
      vm.upload = upload;
      vm.lookupEmployee=lookupEmployee; 
      vm.lookupJobTitle=lookupJobTitle;
      vm.cancel=cancel;
        // employe();
        getActionType();
    
        ////////////////////////////////////

      var response=vm.Form.objForm.$get({action:'getEmployement',id:$stateParams.id});
      response.then(changeDate);

      function changeDate(data) 
       {
          // console.log(data);
            loadDataBU(); 
           // vm.Form.objForm.effectiveDate=new Date(data.effectiveDate);
           if(data.nik!==null){
              // vm.Form.objForm.jointdate=new Date(data.joint_date);
              vm.Form.objForm.jointdate=new Date(data.effective_date);
              vm.Form.objForm.hiredate=new Date(data.hired_date);
              vm.Form.objForm.jobGrade=data.job_grade;
              vm.Form.objForm.empGrade=data.emp_grade;
              vm.Form.objForm.jobLevel=data.job_level;
              vm.Form.objForm.empCategory=data.emp_category;
              vm.Form.objForm.jobTitle=data.mpp_detail_id;
              vm.Form.objForm.effectiveDate=new Date();
              vm.Form.objForm.empCategoryItem=[];
              vm.Form.objForm.mppDetailId=data.mpp_detail_id;
              vm.Form.objForm.orgLayerId=data.org_layer_id;
              vm.Form.objForm.layerParentId=data.layerParentId;
              vm.Form.objForm.empId=$stateParams.id;
              vm.Form.objForm.id=null;
              vm.Form.objForm.jobTitleName=data.abreviation+'-'+data.job_title;
              vm.Form.objForm.directReport=data.directReport;
              $localStorage.seleEctedJob={'mpp_detail_id':data.mpp_detail_id,
                                          'jobTitleName':data.abreviation+'-'+data.job_title,
                                          'abreviation':data.abreviation,
                                          'description':data.job_title,
                                          'org_layer_id':data.org_layer_id
                                        };

              var posID=data.abreviation;
              vm.company=posID.substring(0,2)
              vm.divisi=posID.substring(2,4);
              vm.department=posID.substring(4,6); 
              loadDataDivision(vm.company);
              loadDataDepartment(vm.divisi,false); 
              // getJobTitle(); 
              // getLevelCategory(data.emp_grade, data.job_level);
              getOrgLayer(vm.Form.objForm.layerParentId);
              // getemployee(data.layerParentId);
           } 
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

    function saveData(ev,formController) {
            vm.Form.objForm.empId=$stateParams.id;
            vm.Form.objForm.jobLevel = vm.Form.objForm.empCategoryItem.level;
            vm.Form.objForm.effectiveDate = vm.Form.objForm.effectiveDate;
            vm.Form.objForm.empCategory = vm.Form.objForm.empCategoryItem.description;
            vm.Form.objForm.newNik = vm.Form.objForm.nik;

            var promise= Form.saveData('save', formController, Employements);
            promise.then(function(){
                showDialog(ev);
            });
        }

    function showDialog(ev) {
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Success Save Data')
        .textContent('Process Data was Success.')
        .ariaLabel('Success Save Data')
        .ok('OK')
        .targetEvent(ev)
        ).then(function(){
            closeModal();
        });
    }

	    function loadDataDepartment(iddivisi,isChange) {
            vm.saveProcess=true;
            if(isChange){
              vm.listJobTitle = [];
              vm.Form.objForm.jobTitle = 'set';
            }
             var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            vm.saveProcess=false;

            getemployee();
          }

          function errorDepartment() {
            vm.listDepartment=[];
            vm.saveProcess=false;
          }
          
          function loadDataDivision(idbu) {
             vm.saveProcess=true;
             var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           vm.saveProcess=false;
           // vm.listDivision.push(data); 
           // loadData(1); 
          }

          function errorDivisiBU() {
            vm.listDivision=[];
            vm.saveProcess=false;
          } 

          function loadDataBU() {
             vm.saveProcess=true;
            var response=Attendancereport.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
            vm.saveProcess=false;

          }

          function errorFetchBU() {
            vm.listBU=[];
            vm.saveProcess=false;
          }

          function getJobTitle()
          {
            vm.saveProcess=true;
            var response=Employements.query({action:'getJobTitle',company:vm.company,divisi:vm.divisi,department:vm.department});
            response.$promise.then(fetchJobTitle);
            response.$promise.catch(errorJobTitle);
          }

          function fetchJobTitle(data) {
            vm.listJobTitle=data;
             vm.saveProcess=false;

          }

          function errorJobTitle() {
            vm.listJobTitle=[];
             vm.saveProcess=false;
          }

          function getLevelCategory(grade, level)
          {
              vm.saveProcess=true;
              var response=Employements.query({action:'getLevelCategory',grade:grade, level:level});
              response.$promise.then(fetchLevel);
              response.$promise.catch(errorFetchLevel);

          }
          function fetchLevel(data) {
            for(var i=0; i< data.length; i++) {
              if(vm.Form.objForm.jobLevel == data[i].main_level) {
                vm.Form.objForm.empCategoryItem = data[i];
              }
            }
            vm.category=data;
            vm.saveProcess=false;
          }

          function errorFetchLevel() {
            vm.Form.objForm.empCategory=null;
            vm.saveProcess=false;
          } 

          function changeCategory(g) {
            vm.Form.objForm.jobLevel=g.level;
            vm.Form.objForm.empCategory=g.description;
          }

          function clearSearchTerm() {
              vm.searchTerm = '';
          }

          function clearSearchTermLayer() {
              vm.searchTermLayer = '';
          }

          function getOrgLayer(ls)
          {
            // console.log(ls);
              vm.saveProcess=true;
              var response=Employements.query({action:'getOrgLayer',id:ls});
              response.$promise.then(fetchOrgLayer);
              response.$promise.catch(errorFetchOrgLayer);

          }
          function fetchOrgLayer(data) {
            vm.orgLayer=data;
            vm.saveProcess=false;
          }

          function errorFetchOrgLayer() {
            vm.Form.objForm.layer_id=null;
            vm.saveProcess=false;
          } 


         function getemployee()
          {
              vm.saveProcess=true;
              var response=Employements.query({
                    action: "getemployee",
                    company:vm.company,
                    divisi:vm.divisi,
                    department:vm.department,
                    search:vm.Form.objForm.directReport
                  }
                );
              response.$promise.then(fetchEmp);
              response.$promise.catch(errorFetchEmp);

          }

          function fetchEmp(data) {
            var empList=data;
            vm.saveProcess=false;
            angular.forEach(empList, function(value)
            {
              if(vm.Form.objForm.directReport==value.nik)
              {
                $localStorage.selectedEmployee=value;
                vm.Form.objForm.directReportName=value.nik+'-'+value.nama;
              }
            });
            // getOrgLayer(vm.Form.objForm.orgLayerId);
          }

          function errorFetchEmp() {
            vvm.Form.objForm.directReport=null;
            vm.saveProcess=false;
          }

      function changeDirect()
      {
        var obj=vm.empList; 
        var org_layer_id=null;
        vm.Form.objForm.jobTitle=null;
        angular.forEach(obj, function(value)
        { 
            if(value.nik==vm.Form.objForm.directReport)
            {
              org_layer_id=value.org_layer_id; 
            }
        });

        if(org_layer_id!=null)
        {
           getOrgLayer(org_layer_id);
        }

      }

      function checkIsNeddFile() {
        if (vm.isNeddUploadFile == false || typeof vm.isNeddUploadFile === 'undefined') {
          vm.isChecked = true
        } else {
          vm.isChecked = false
        }
      }

      function chooseJob(ev)
      {
        var jt=vm.Form.objForm.jobTitle;
        var obj=vm.orgLayer;
        // console.log(jt);
        // console.log(vm.orgLayer);
        angular.forEach(obj, function(value)
        {
          if(jt==value.mpp_detail_id)
          {
            if(value.fullfilmentType=='Fullfilement')
            {
              vm.isLayerOverlap=true;
              // var confirm = $mdDialog.confirm()
              //         .title('Employee job overlap, are you sure for cointinue?')
              //         .textContent('Employee setup more than manpower target')
              //         .ariaLabel('Lucky day')
              //         .targetEvent(ev)
              //         .clickOutsideToClose(true)
              //         .parent(angular.element(document.body))
              //         .ok('Continue!')
              //         .cancel(closeModal);
              //   $mdDialog.show(confirm).then(function() {
              //     vm.status = 'You decided to get rid of your debt.';
              //   }, function() {
              //     vm.status = 'You decided to keep your debt.';
              //   });
            }
            vm.Form.objForm.abreviation=value.abreviation;
            vm.Form.objForm.mppDetailId=value.mpp_detail_id;
            vm.Form.objForm.job_title=value.description;
            vm.Form.objForm.orgLayerId=value.org_layer_id;
          }
        });
      } 

      function selectedCange(v)
      {
        switch(v)
        {
          case 'dept':
            // vm.Form.objForm.directReport=null;
            // vm.Form.objForm.jobTitle=null;
          break;
          case 'div':
            vm.department=null;
            // vm.Form.objForm.directReport=null;
            // vm.Form.objForm.jobTitle=null;
          break;
          case 'comp':
            vm.divisi=null;
            vm.department=null;
            // vm.Form.objForm.directReport=null;
            // vm.Form.objForm.jobTitle=null;
          break;
        }
      }

      function upload(form) {
        var resp = vm.FileUploaderPhoto.uploadAll();
        // console.log('test');
      }

      var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
        url: config.api + 'api/employements/upload',
        removeAfterUpload: true,
        alias: 'fileName',
        onSuccessItem: function (item, response, status, headers) {
          vm.isLayerOverlap=false;
          vm.Form.tampilPesan=true;
          vm.UploadPhotoStateSucces=true;
          angular.element.unblockUI();
          var ev = '';
          // showDialogInfo(ev, response);
        }, onErrorItem: function (item, response, status, headers) {
          vm.isLayerOverlap=false;
          vm.Form.tampilPesan=true;
          vm.UploadPhotoStateError=true;
          angular.element.unblockUI();
          var ev = '';
          // showDialogInfo(ev, response);
        }
      });

      function lookupEmployee(ev)
      {
        $mdDialog.show({
                controller: 'LookUpEmployeeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/employement/lookupemployement.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple:true,
                onRemoving: function (element, removePromise) 
                {
                    // console.log('testttasdtas');
                    // console.log(removePromise);
                    // console.log($localStorage.selectedEmployee);
                    var empSelected=$localStorage.selectedEmployee;
                    vm.Form.objForm.directReportName=empSelected.nik+'-'+empSelected.nama;
                    vm.Form.objForm.directReport=empSelected.nik;
                },
                locals:{
                  id:{company:vm.company,divisi:vm.divisi,department:vm.department}
                }
            });
      }

      function lookupJobTitle(ev)
      {
        vm.isLayerOverlap=false; 
         $mdDialog.show({
                controller: 'LookUpLayerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/employement/lookupLayer.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple:true,
                onRemoving: function (element, removePromise) 
                {
                    // console.log('testttasdtas');
                    // console.log(removePromise);
                    // console.log($localStorage.seleEctedJob);
                    var layerSelected=$localStorage.seleEctedJob;
                    vm.Form.objForm.jobTitleName=layerSelected.jobTitleName;
                    vm.Form.objForm.jobTitle=layerSelected.mpp_detail_id;
                    if(layerSelected.fullfilmentType=='Fullfilement')
                    {
                      vm.isLayerOverlap=true; 
                    }
                    vm.Form.objForm.abreviation=layerSelected.abreviation;
                    vm.Form.objForm.mppDetailId=layerSelected.mpp_detail_id;
                    vm.Form.objForm.job_title=layerSelected.description;
                    vm.Form.objForm.orgLayerId=layerSelected.org_layer_id;
                   
                },
                locals:{
                  id:{company:vm.company,divisi:vm.divisi,department:vm.department,directReport:vm.Form.objForm.directReport}
                }
            });
      }

      function cancel()
      {
        $mdDialog.hide();
      }

      function getActionType() {
             vm.saveProcess=true;
              var response=Employements.query({
                    action: "getActionType" 
                  }
                );
              response.$promise.then(fetchActionType);
              response.$promise.catch(errorFetchActionType);
          }

          function fetchActionType(data) {
            vm.listActionType=data;
            vm.saveProcess=false;

          }

          function errorFetchActionType() {
            vm.listActionType=[];
            vm.saveProcess=false;
          }

    } 
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('EmployementsemployeeditController', EmployementsemployeeditController);

    /** @ngInject */
    EmployementsemployeeditController.$inject=['$mdDialog','$localStorage','id','AppAPI','Auth','Form','FileUploader','config'];
    /** @ngInject */
    function EmployementsemployeeditController($mdDialog,$localStorage,id,AppAPI,Auth,Form,FileUploader,config)
    {
        
      var vm = this;
	    // initial form
	    Form.initialForm(false);

	    // get constructor form
	    var Employements=AppAPI.Employements(); 
      var Attendancereport=AppAPI.Attendancereport();

	    // set constructor form
	    Form.setObject(Employements);

	    // set form to controller
	    vm.Form = Form; 

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;
	    // vm.company=$localStorage.empsite;
	    vm.Form.objForm.nik=null;
      vm.nik=true;
      vm.Form.objForm.hiredate=null;
      vm.hiredate=true;
      vm.Form.objForm.jointdate=null;
      vm.jointdate=true;
      vm.divisi=null;
      vm.department=null; 
      vm.getJobTitle=getJobTitle;
      vm.getLevelCategory=getLevelCategory; 
      vm.saveProcess=false;
      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      vm.changeCategory=changeCategory;

      vm.searchTerm = '';
      vm.clearSearchTerm = clearSearchTerm;
      vm.searchTermLayer = '';
      vm.clearSearchTermLayer = clearSearchTermLayer;
      vm.getemployee=getemployee;
      vm.getOrgLayer=getOrgLayer;
      vm.changeDirect=changeDirect;

	    vm.messageTheme='pink';
      vm.grade = ['1A','1B','1C','2A','2B','2C','3A','3B','3C','4A','4B','4C','5A','5B','5C','6A','6B','6C','7'];
      vm.category = [];
      vm.orgLayer = [];
      vm.checkIsNeddFile = checkIsNeddFile
      vm.company='';
      vm.divisi='';
      vm.chooseJob=chooseJob;
      vm.isLayerOverlap=false;
      vm.selectedCange=selectedCange;
      vm.upload = upload;
      vm.lookupEmployee=lookupEmployee; 
      vm.lookupJobTitle=lookupJobTitle;
      vm.UploadPhotoStateSucces=false;
      vm.UploadPhotoStateError=false; 
        // employe();
        getActionType();
    
        ////////////////////////////////////

      var response=vm.Form.objForm.$get({action:'viewDetail',id:id.id});
      response.then(changeDate);

      function changeDate(data) {
          loadDataBU(); 
          vm.Form.objForm.effectiveDate=new Date(data.effectiveDate);
          vm.Form.objForm.jointdate=new Date(data.effective_date);
          vm.Form.objForm.hiredate=new Date(data.hired_date);
          vm.Form.objForm.jobGrade=data.job_grade;
          vm.Form.objForm.empGrade=data.emp_grade;
          vm.Form.objForm.jobLevel=data.job_level;
          vm.Form.objForm.empCategory=data.emp_category;
          vm.Form.objForm.jobTitle=data.mpp_detail_id;
          vm.Form.objForm.empCategoryItem=[];
          vm.Form.objForm.mppDetailId=data.mpp_detail_id;
          vm.Form.objForm.orgLayerID=data.org_layer_id;
          vm.Form.objForm.layerParentId=data.layerParentId; 
          vm.Form.objForm.jobTitleName=data.abreviation+'-'+data.job_title;
          vm.Form.objForm.directReport=data.directReport;



         $localStorage.seleEctedJob={'mpp_detail_id':data.mpp_detail_id,
                                          'jobTitleName':data.abreviation+'-'+data.job_title,
                                          'abreviation':data.abreviation,
                                          'description':data.job_title,
                                          'org_layer_id':data.org_layer_id
                                        };

          var posID=data.abreviation;
          vm.company=posID.substring(0,2)
          vm.divisi=posID.substring(2,4);
          vm.department=posID.substring(4,6);
          // vm.Form.objForm.jobTitle=posID+'-'+vm.Form.objForm.jobTitle;
          loadDataDivision(vm.company);
          loadDataDepartment(vm.divisi,false);
          getOrgLayer(vm.Form.objForm.layerParentId); 
          // getJobTitle();
          // console.log(data.job_level);
          // getLevelCategory(data.emp_grade, data.job_level);
          // getOrgLayer();
      }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

        function saveData(ev, formController) {
            vm.Form.objForm.jobLevel = vm.Form.objForm.empCategoryItem.level;
            vm.Form.objForm.effectiveDate = vm.Form.objForm.effectiveDate;
            vm.Form.objForm.empCategory = vm.Form.objForm.empCategoryItem.description;
            vm.Form.objForm.newNik = vm.Form.objForm.nik;

            var promise= Form.updateData('update',formController,Employements, Form.objForm.id,'viewDetail');
            promise.then(function(){
	            showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }

	    function loadDataDepartment(iddivisi,isChange) {
            vm.saveProcess=true;
            if(isChange){
              vm.listJobTitle = [];
              vm.Form.objForm.jobTitle = 'set';
            }
             var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            vm.saveProcess=false;

            getemployee();
          }

          function errorDepartment() {
            vm.listDepartment=[];
            vm.saveProcess=false;
          }
          
          function loadDataDivision(idbu) {
             vm.saveProcess=true;
             var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           vm.saveProcess=false;
           // vm.listDivision.push(data); 
           // loadData(1); 
          }

          function errorDivisiBU() {
            vm.listDivision=[];
            vm.saveProcess=false;
          } 

          function loadDataBU() {
             vm.saveProcess=true;
            var response=Attendancereport.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
            vm.saveProcess=false;

          }

          function errorFetchBU() {
            vm.listBU=[];
            vm.saveProcess=false;
          }

          function getJobTitle()
          {
              vm.saveProcess=true;
              var response=Employements.query({action:'getJobTitle',company:vm.company,divisi:vm.divisi,department:vm.department});
              response.$promise.then(fetchJobTitle);
              response.$promise.catch(errorJobTitle);
          }

          function fetchJobTitle(data) {
            vm.listJobTitle=data;
             vm.saveProcess=false;

          }

          function errorJobTitle() {
            vm.listJobTitle=[];
             vm.saveProcess=false;
          }

          function getLevelCategory(grade, level)
          {
              vm.saveProcess=true;
              var response=Employements.query({action:'getLevelCategory',grade:grade, level:level});
              response.$promise.then(fetchLevel);
              response.$promise.catch(errorFtechLevel);

          }
          function fetchLevel(data) {
            for(var i=0; i< data.length; i++) {
              if(vm.Form.objForm.jobLevel == data[i].main_level) {
                vm.Form.objForm.empCategoryItem = data[i];
              }
            }
            vm.category=data;
            vm.saveProcess=false;

          }

          function errorFtechLevel() {
            vm.Form.objForm.empCategory=null;
             vm.saveProcess=false;
          } 

          function changeCategory(g) {
            vm.Form.objForm.jobLevel=g.level;
            vm.Form.objForm.empCategory=g.description;
          }

          function clearSearchTerm() {
              vm.searchTerm = '';
          }

          function clearSearchTermLayer() {
              vm.searchTermLayer = '';
          }

          function getOrgLayer(ls)
          {
            // console.log(ls);
              vm.saveProcess=true;
              var response=Employements.query({action:'getOrgLayer',id:ls});
              response.$promise.then(fetchOrgLayer);
              response.$promise.catch(errorFetchOrgLayer);

          }
          function fetchOrgLayer(data) {
            vm.orgLayer=data;
            vm.saveProcess=false;
          }

          function errorFetchOrgLayer() {
            vm.Form.objForm.layer_id=null;
            vm.saveProcess=false;
          } 


         function getemployee()
          {
              vm.saveProcess=true;
              var response=Employements.query({
                    action: "getemployee",
                    company:vm.company,
                    divisi:vm.divisi,
                    department:vm.department,
                    search:vm.Form.objForm.directReport
                  }
                );
              response.$promise.then(fetchEmp);
              response.$promise.catch(errorFetchEmp);

          }

          function fetchEmp(data) {
            var empList=data;
            vm.saveProcess=false;
            angular.forEach(empList, function(value)
            {
              if(vm.Form.objForm.directReport==value.nik)
              {
                $localStorage.selectedEmployee=value;
                vm.Form.objForm.directReportName=value.nik+'-'+value.nama;
              }
            });
          }

          function errorFetchEmp() {
            vvm.Form.objForm.directReport=null;
            vm.saveProcess=false;
          }

      function changeDirect()
      {
        var obj=vm.empList; 
        var org_layer_id=null;
        vm.Form.objForm.jobTitle=null;
        angular.forEach(obj, function(value)
        { 
            if(value.nik==vm.Form.objForm.directReport)
            {
              org_layer_id=value.org_layer_id; 
            }
        });

        if(org_layer_id!=null)
        {
           getOrgLayer(org_layer_id);
        }

      }

      function checkIsNeddFile() {
        if (vm.isNeddUploadFile == false || typeof vm.isNeddUploadFile === 'undefined') {
          vm.isChecked = true
        } else {
          vm.isChecked = false
        }
      }

      function chooseJob(ev)
      {
        var jt=vm.Form.objForm.jobTitle;
        var obj=vm.orgLayer;
        // console.log(jt);
        // console.log(vm.orgLayer);
        angular.forEach(obj, function(value)
        {
          if(jt==value.mpp_detail_id)
          {
            if(value.fullfilmentType=='Fullfilement')
            {
              vm.isLayerOverlap=true; 
            }
            vm.Form.objForm.abreviation=value.abreviation;
            vm.Form.objForm.mppDetailId=value.mpp_detail_id;
            vm.Form.objForm.job_title=value.description;
            vm.Form.objForm.orgLayerId=value.org_layer_id;
          }
        });
      } 

      function selectedCange(v)
      {
        switch(v)
        {
          case 'dept':
            vm.Form.objForm.directReport=null;
            vm.Form.objForm.jobTitle=null;
          break;
          case 'div':
            vm.department=null;
            vm.Form.objForm.directReport=null;
            vm.Form.objForm.jobTitle=null;
          break;
          case 'comp':
            vm.divisi=null;
            vm.department=null;
            vm.Form.objForm.directReport=null;
            vm.Form.objForm.jobTitle=null;
          break;
        }
      }

      function upload(form) {
        var resp = vm.FileUploaderPhoto.uploadAll();
        // console.log('test');
      }

      var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
        url: config.api + 'api/employements/upload',
        removeAfterUpload: true,
        alias: 'fileName',
        onSuccessItem: function (item, response, status, headers) {
          vm.isLayerOverlap=false;
          vm.Form.tampilPesan=true;
          vm.UploadPhotoStateSucces=true;
          angular.element.unblockUI();
          var ev = '';
          // showDialogInfo(ev, response);
        }, onErrorItem: function (item, response, status, headers) {
          vm.isLayerOverlap=false;
          vm.Form.tampilPesan=true;
          vm.UploadPhotoStateError=true;
          angular.element.unblockUI();
          var ev = '';
          // showDialogInfo(ev, response);
        }
      });

      function lookupEmployee(ev)
      {
        $mdDialog.show({
                controller: 'LookUpEmployeeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/employement/lookupemployement.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple:true,
                onRemoving: function (element, removePromise) 
                {
                    // console.log('testttasdtas');
                    // console.log(removePromise);
                    // console.log($localStorage.selectedEmployee);
                    var empSelected=$localStorage.selectedEmployee;
                    vm.Form.objForm.directReportName=empSelected.nik+'-'+empSelected.nama;
                    vm.Form.objForm.directReport=empSelected.nik;
                },
                locals:{
                  id:{company:vm.company,divisi:vm.divisi,department:vm.department}
                }
            });
      }

      function lookupJobTitle(ev)
      {
        vm.isLayerOverlap=false; 
         $mdDialog.show({
                controller: 'LookUpLayerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/employement/lookupLayer.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple:true,
                onRemoving: function (element, removePromise) 
                {
                    // console.log('testttasdtas');
                    // console.log(removePromise);
                    // console.log($localStorage.seleEctedJob);
                    var layerSelected=$localStorage.seleEctedJob;
                    vm.Form.objForm.jobTitleName=layerSelected.jobTitleName;
                    vm.Form.objForm.jobTitle=layerSelected.mpp_detail_id;
                    if(layerSelected.fullfilmentType=='Fullfilement')
                    {
                      vm.isLayerOverlap=true; 
                    }
                    vm.Form.objForm.abreviation=layerSelected.abreviation;
                    vm.Form.objForm.mppDetailId=layerSelected.mpp_detail_id;
                    vm.Form.objForm.job_title=layerSelected.description;
                    vm.Form.objForm.orgLayerID=layerSelected.org_layer_id;

                    
                   
                },
                locals:{
                  id:{company:vm.company,
                      divisi:vm.divisi,
                      department:vm.department,
                      directReport:vm.Form.objForm.directReport,
                      listDivision:vm.listDivision,
                      listDepartment:vm.listDepartment
                    }
                }
            });
      }

        function getActionType() {
             vm.saveProcess=true;
              var response=Employements.query({
                    action: "getActionType" 
                  }
                );
              response.$promise.then(fetchActionType);
              response.$promise.catch(errorFetchActionType);
          }

          function fetchActionType(data) {
            vm.listActionType=data;
            vm.saveProcess=false;

          }

          function errorFetchActionType() {
            vm.listActionType=[];
            vm.saveProcess=false;
          }

    }
    
})();  

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('EmployementschangenikController', EmployementschangenikController);

    /** @ngInject */
    EmployementschangenikController.$inject = ['$stateParams', '$mdDialog', '$localStorage', 'AppAPI', 'Auth', 'Form'];
    /** @ngInject */
    function EmployementschangenikController($stateParams, $mdDialog, $localStorage, AppAPI, Auth, Form) {

        var vm = this;
        // initial form
        Form.initialForm();

        // get constructor form
        var Employements = AppAPI.Employements();
        var Attendancereport = AppAPI.Attendancereport();

        // set constructor form
        Form.setObject(Employements);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        // vm.id=id;
        vm.saveData = saveData;
        vm.setToken = Auth.setToken;
        // vm.company=$localStorage.empsite;
        vm.Form.objForm.nik = null;
        vm.nik = true;
        vm.Form.objForm.hiredate = null;
        vm.hiredate = true;
        vm.Form.objForm.jointdate = null;
        vm.jointdate = true;
        vm.divisi = null;
        vm.department = null;
        vm.saveProcess = false;
        vm.getLevelCategory = getLevelCategory;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.getJobTitle = getJobTitle

        vm.messageTheme = 'pink';
        vm.employeType = ['contract', 'permanent'];
        vm.grade = ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A', '6B', '6C', '7'];
        vm.level = ['001', '002', '003', '004', '005', '006', '007', '008'];
        vm.category = ['Non-Staff', 'Staff', 'Supervisory', 'Managerial'];
        vm.lookupEmployee=lookupEmployee; 
        vm.lookupJobTitle=lookupJobTitle;
        vm.cancel=cancel; 

        // employe();

        ////////////////////////////////////

        var response = vm.Form.objForm.$get({ action: 'getEmployement', id: $stateParams.id });
        response.then(changeDate);

        function changeDate(data) {
            console.log(data);
            if (data.nik !== null) {
                vm.Form.objForm.oldNik = data.nik;
                vm.Form.objForm.flag_app = data.flag_app;
                vm.gw = data.flag_app == 'HRIS' ? true : false;
                vm.Form.objForm.jointdate = new Date(data.joint_date);
                vm.Form.objForm.hiredate = new Date(data.hired_date);
                var posID = data.abreviation;
                vm.company = posID.substring(0, 2)
                vm.divisi = posID.substring(2, 4);
                vm.department = posID.substring(4, 6);
                // loadDataDivision(vm.company);
                // loadDataDepartment(vm.divisi, false);
                // getJobTitle();
                // loadDataBU();
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.empId = $stateParams.id;

            var promise = Form.saveData('changeNik', formController, Employements);
            promise.then(function (response) {
                angular.element.unblockUI();
                showDialog(ev, response);
            });
            promise.catch(function (response) {
                angular.element.unblockUI();
            });
        }

        function showDialog(ev, response) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(response.status)
                    .textContent(response.pesan)
                    .ariaLabel(response.status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function getLevelCategory(grade) {
            vm.saveProcess = true;
            vm.Form.objForm.empCategory = null;
            vm.Form.objForm.jobLevel = null;
            var response = Employements.query({ action: 'getLevelCategory', grade: grade });
            response.$promise.then(fetchLevel);
            response.$promise.catch(errorFtechLevel);

        }

        function fetchLevel(data) {
            vm.Form.objForm.empCategory = data[0].description;
            vm.Form.objForm.jobLevel = data[0].level;
            vm.saveProcess = false;
        }

        function errorFtechLevel() {
            vm.Form.objForm.empCategory = null;
            vm.saveProcess = false;
        }

        function loadDataDivision(idbu) {
            vm.saveProcess = true;
            var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function loadDataDepartment(iddivisi, isChange) {
            vm.saveProcess = true;
            if (isChange) {
                vm.listJobTitle = [];
                vm.Form.objForm.jobTitle = 'set';
            }
            var response = Attendancereport.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            // if(isChange){
            //     vm.listJobTitle = [];
            //     vm.Form.objForm.jobTitle;
            //   }
            vm.saveProcess = false;
        }

        function errorDepartment() {
            vm.listDepartment = [];
            vm.saveProcess = false;
        }

        function loadDataDivision(idbu) {
            vm.saveProcess = true;
            var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            vm.saveProcess = false;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
            vm.saveProcess = false;
        }

        function getJobTitle() {
            vm.saveProcess = true;
            var response = Employements.query({ action: 'getJobTitle', company: vm.company, divisi: vm.divisi, department: vm.department });
            response.$promise.then(fetchJobTitle);
            response.$promise.catch(errorJobTitle);
        }

        function fetchJobTitle(data) {
            vm.listJobTitle = data;
            vm.saveProcess = false;

        }

        function errorJobTitle() {
            vm.listJobTitle = [];
            vm.saveProcess = false;
        }

        function loadDataBU() {
            vm.saveProcess = true;
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
            vm.saveProcess = false;

        }

        function errorFetchBU() {
            vm.listBU = [];
            vm.saveProcess = false;
        }

        function cancel()
      {
        $mdDialog.hide();
      }


        function lookupEmployee(ev)
      {
        $mdDialog.show({
                controller: 'LookUpEmployeeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/employement/lookupemployement.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple:true,
                onRemoving: function (element, removePromise) 
                {
                    // console.log('testttasdtas');
                    // console.log(removePromise);
                    // console.log($localStorage.selectedEmployee);
                    var empSelected=$localStorage.selectedEmployee;
                    vm.Form.objForm.directReportName=empSelected.nik+'-'+empSelected.nama;
                    vm.Form.objForm.directReport=empSelected.nik;
                },
                locals:{
                  id:{company:vm.company,divisi:vm.divisi,department:vm.department}
                }
            });
      }

      function lookupJobTitle(ev)
      {
        vm.isLayerOverlap=false; 
         $mdDialog.show({
                controller: 'LookUpLayerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/employement/lookupLayer.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple:true,
                onRemoving: function (element, removePromise) 
                {
                    // console.log('testttasdtas');
                    // console.log(removePromise);
                    // console.log($localStorage.seleEctedJob);
                    var layerSelected=$localStorage.seleEctedJob;
                    vm.Form.objForm.jobTitleName=layerSelected.jobTitleName;
                    vm.Form.objForm.jobTitle=layerSelected.mpp_detail_id;
                    if(layerSelected.fullfilmentType=='Fullfilement')
                    {
                      vm.isLayerOverlap=true; 
                    }
                    vm.Form.objForm.abreviation=layerSelected.abreviation;
                    vm.Form.objForm.mppDetailId=layerSelected.mpp_detail_id;
                    vm.Form.objForm.job_title=layerSelected.description;
                    vm.Form.objForm.orgLayerId=layerSelected.org_layer_id;
                    vm.Form.objForm.jobGrade=layerSelected.jobGrade;
                   
                },
                locals:{
                  id:{company:vm.company,divisi:vm.divisi,department:vm.department,directReport:vm.Form.objForm.directReport}
                }
            });
      }

    }

})();  

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('EmergencyemployeController', EmergencyemployeController);


    EmergencyemployeController.$inject = ['$state', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'EmployeeService', '$filter'];
    /** @ngInject */
    function EmergencyemployeController($state, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, EmployeeService, $filter) {

        var vm = this;

        var translate = $filter('translate');

        EmployeeService.title = translate('MYPROFILE.MENU.EMERGENCYCONTACT');

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();
        var Emergency = AppAPI.Emergency();
        vm.employe = employe;
        var Profiles = AppAPI.Profiles();

        // set constructor form
        Form.setObject(Emergency);

        // set form to controller
        vm.Form = Form;

        // var response=vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
        // vm.empId = vm.Form.objForm.id;
        employe();
        function employe() {
            var response = Employe.get({ action: 'viewdetail', id: $stateParams.id });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }
        function fetchEmploye(data) {
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.firstName = data.firstName;
            vm.Form.objForm.middleName = data.middleName;
            vm.Form.objForm.lastName = data.lastName;
            vm.Form.objForm.empId = data.id;
            vm.Form.objForm.photoAddress = data.photoAddress;
            vm.empId = data.id;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        vm.openInputEmergency = openInputEmergency;
        vm.editInputEmergency = editInputEmergency;
        vm.closeModal = closeModal;

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.saveData = saveData;
        vm.deleteData = deleteData;
        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        checkCompletion();
        vm.viewMenus = viewMenus;
        vm.completion = false;


        var Emergency = AppAPI.Emergency();
        viewData();
        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Emergency.query({ action: 'viewData', emp_id: $stateParams.id });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }


        function openInputEmergency(ev) {
            $mdDialog.show({
                controller: 'EmergencyemployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/emergency/input-emergency.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    employe();
                }
            });
        }

        function editInputEmergency(ev, id) {
            $mdDialog.show({
                controller: 'EmergencyemployeeditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/emergency/input-emergency.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    employe();
                },
                locals: {
                    id: id
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var str = vm.fullname;
            var words = str.split(" ");
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
            vm.Form.objForm.lastName = str.substring(words[0].length);
            var promise = Form.saveData('save', formController, Emergency);
            promise.then(function (data) {
                showDialog(ev, data);
            });
        }

        function showDialog(ev, data) {
            var $translate = $filter('translate');
            var Message = $translate(data.pesan);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(Message)
                    .textContent(Message)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                viewData();
                closeModal();
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Employe.delete({ action: 'deleteemergency', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                }, function () {

                });
            });


        }
        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({ action: 'checkCompletionData', id: $stateParams.id });
            resp.$promise.then(fetchDataCompletion);
            resp.$promise.catch(errorFetchDataCompletion);
            // vm.listOtselected=[];
        }

        function fetchDataCompletion(data) {
            vm.listCompletion = data[0];
            if (vm.listCompletion.profiles && vm.listCompletion.address && vm.listCompletion.dependents
                && vm.listCompletion.doc_ktp && vm.listCompletion.doc_ijazah && vm.listCompletion.doc_sim && vm.listCompletion.education
                && vm.listCompletion.experience && vm.listCompletion.bank && vm.listCompletion.tax) {
                vm.completion = true;
            }
        }

        function errorFetchDataCompletion() {
            vm.listCompletion = [];
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go('app.employee_myemploye_edit.' + id, { id: $stateParams.id });
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('EmergencyemployeeditController', EmergencyemployeeditController);

    /** @ngInject */
    EmergencyemployeeditController.$inject=['$mdDialog','id','AppAPI','Auth','Form','$stateParams'];
    /** @ngInject */
    function EmergencyemployeeditController($mdDialog,id,AppAPI,Auth,Form,$stateParams)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Emergency=AppAPI.Emergency();
	    var Employe=  AppAPI.Employe();

	    // set constructor form
	    Form.setObject(Emergency);

	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewDetail',id:id.id});
        response.then(SetData);

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;

	    vm.messageTheme='pink';
	    employe();


	    function SetData(data) {  
           vm.Form.objForm.phoneNumber=data.phone_number;
           vm.Form.objForm.typeOfFamily=data.type_of_family;
           vm.fullname=data.first_name+' '+data.last_name;
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updateemergency', formController, Employe);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/
        function saveData(ev, formController) {
			var str = vm.fullname;
            var words = str.split(" ");
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            vm.Form.objForm.firstName=words[0].replace(/\s/g, '');
			vm.Form.objForm.lastName=str.substring(words[0].length);
			
        	var promise= Form.updateData('update',formController,Emergency, Form.objForm.id,'viewDetail');
            promise.then(function(data){
	            showDialog(ev,data);
            });
        }

	    function showDialog(ev,data) {
			var $translate = $filter('translate');
			var Message = $translate(data.pesan);
			
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title(Message)
	        .textContent(Message)
	        .ariaLabel(Message)
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }

	    function employe()
        {
            var response=Employe.get({action:'viewdetail',id:$stateParams.id});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }
         
        function fetchEmploye(data) {
            vm.Form.objForm.photoAddress=data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

    } 
})();  

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('ExperienceemployeController', ExperienceemployeController);


    ExperienceemployeController.$inject = ['$state', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'EmployeeService', '$filter'];
    /** @ngInject */
    function ExperienceemployeController($state, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, EmployeeService, $filter) {

        var vm = this;

        var translate = $filter('translate');

        EmployeeService.title = translate('MYPROFILE.MENU.EXPERIENCE');

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();
        var Experience = AppAPI.Experience();
        var Profiles = AppAPI.Profiles();

        // set constructor form
        Form.setObject(Experience);

        // set form to controller
        vm.Form = Form;
        vm.completion = false;

        employe();

        function employe() {
            var response = Employe.get({ action: 'viewdetail', id: $stateParams.id });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.firstName = data.firstName;
            vm.Form.objForm.middleName = data.middleName;
            vm.Form.objForm.lastName = data.lastName;
            vm.Form.objForm.empId = data.id;
            vm.empId = data.id;
            vm.Form.objForm.photoAddress = data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        vm.openInputExperience = openInputExperience;
        vm.editInputExperience = editInputExperience;
        vm.closeModal = closeModal;

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.saveData = saveData;
        vm.deleteData = deleteData;

        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        checkCompletion();
        vm.viewMenus = viewMenus;


        viewData();
        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Experience.query({ action: 'viewData', emp_id: $stateParams.id });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            vm.listDataSelected = [];
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }


        function openInputExperience(ev) {
            $mdDialog.show({
                controller: 'ExperienceemployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/experience/input-experience.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    employe();
                    viewData();
                }
            });
        }

        function editInputExperience(ev, id) {
            $mdDialog.show({
                controller: 'ExperienceemployeeditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/experience/input-experience.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    employe();
                    viewData();
                },
                locals: {
                    id: id
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, Experience);
            promise.then(function (data) {
                showDialog(ev, data);
            });
        }

        function showDialog(ev, data) {
            var $translate = $filter('translate');
            var Message = $translate(data.pesan);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(Message)
                    .textContent(Message)
                    .ariaLabel(Message)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');


            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Experience.delete({ action: 'deleteexperience', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                }, function () {

                });
            });
        }

        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({ action: 'checkCompletionData', id: $stateParams.id });
            resp.$promise.then(fetchDataCompletion);
            resp.$promise.catch(errorFetchDataCompletion);
            // vm.listOtselected=[];
        }

        function fetchDataCompletion(data) {
            vm.listCompletion = data[0];
            if (vm.listCompletion.profiles && vm.listCompletion.address && vm.listCompletion.dependents
                && vm.listCompletion.doc_ktp && vm.listCompletion.doc_ijazah && vm.listCompletion.doc_sim && vm.listCompletion.education
                && vm.listCompletion.experience && vm.listCompletion.bank && vm.listCompletion.tax) {
                vm.completion = true;
            }
        }

        function errorFetchDataCompletion() {
            vm.listCompletion = [];
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go('app.employee_myemploye_edit.' + id, { id: $stateParams.id });
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('ExperienceemployeeditController', ExperienceemployeeditController);

    /** @ngInject */
    ExperienceemployeeditController.$inject=['$mdDialog','id','AppAPI','Auth','Form','$filter'];
    /** @ngInject */
    function ExperienceemployeeditController($mdDialog,id,AppAPI,Auth,Form,$filter)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Experience=AppAPI.Experience();

	    // set constructor form
	    Form.setObject(Experience);

	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewDetail',id:id.id});
        response.then(changeDate);

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;

	    vm.messageTheme='pink';


        function changeDate(data) {
           vm.Form.objForm.startDate=new Date(data.start_date);
           vm.Form.objForm.finishDate=new Date(data.finish_date);
           vm.Form.objForm.companyName=data.company_name;
           vm.Form.objForm.departmentName=data.department_name;
           vm.Form.objForm.sectionName=data.section_name;
           vm.Form.objForm.jobDescription=data.job_description;
           
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updateexperience', formController, Employe);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/
        function saveData(ev, formController) {
            var promise= Form.updateData('update',formController,Experience, Form.objForm.id,'viewDetail');
            promise.then(function(data){
	            // showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }
    }
    
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('UploadIjazahController', UploadIjazahController);

    /** @ngInject */
    UploadIjazahController.$inject=['$localStorage','$mdDialog','$stateParams','AppAPI','Auth','Form','config','FileUploader'];
    /** @ngInject */
    function UploadIjazahController($localStorage,$mdDialog,$stateParams,AppAPI,Auth,Form,config,FileUploader)
    {
        
      var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Document=AppAPI.Document();

	    // set constructor form
	    Form.setObject(Document);

	    // set form to controller
	    vm.Form = Form;
 

	    vm.closeModal=closeModal; 
	    vm.setToken=Auth.setToken;
      vm.goNav=goNav; 
      vm.uploadFile=uploadFile;
      vm.UploadPhotoStateSucces=false;
      vm.UploadPhotoStateError=false;
      vm.upload=upload;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck; 
      vm.Form.objForm.typeOfDocument='ijazah';
      vm.Form.objForm.empID=$stateParams.id;
      vm.ChangeDate=ChangeDate;
      // vm.Form.objForm.dataEdu=id;

	    vm.messageTheme='pink';
      
      function ChangeDate()
      {
        var d=new Date(vm.Form.objForm.issuedDate);
        vm.issuedDate=d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate();
      }
 
 
	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updateeducation', formController, Employe);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/

        function upload()
        {
            
             var resp=vm.FileUploaderPhoto.uploadAll();

        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({ 
           url:config.api+'api/education/uploadijazah', 
           removeAfterUpload:true,
           alias:'ijazah',
           onBeforeUploadItem :function(){
              angular.element.blockUI();
           }, 
           formData:[
              {
               action:'uploadktp',
               documentNo:vm.documentNo,
               typeOfDocument:vm.typeOfDocument,
               description:vm.description
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
                angular.element.unblockUI();
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth 
              },
            onSuccessItem:function(item, response, status, headers){
              showDialog();
              angular.element.unblockUI();
            }
        });

        function goNav(state) {
            $state.go(state);
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }

       

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }

        function isChecked()
        {
            vm.Form.objForm.ktpSeumurHidup=false;
            if(!vm.seumurhidupChecked){
              vm.Form.objForm.ktpSeumurHidup=true;
            }
        }

    function toggleCheck(event)
      {
          if ( event )
          {
              event.stopPropagation();
          }  
      }

    }
})();  

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('EducationemployeController', EducationemployeController);


    EducationemployeController.$inject = ['$state', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', '$http', 'EmployeeService', 'config', '$localStorage', '$filter'];
    /** @ngInject */
    function EducationemployeController($state, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, $http, EmployeeService, config, $localStorage, $filter) {

        var vm = this;

        var translate = $filter('translate');

        EmployeeService.title = translate('MYPROFILE.MENU.EDUCATION');

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();
        var Education = AppAPI.Education();
        var Profiles = AppAPI.Profiles();

        // set constructor form
        Form.setObject(Education);

        // set form to controller
        vm.Form = Form;
        vm.uploadIjazah = uploadIjazah;
        vm.completion = false;
        vm.getUniversity = getUniversity;
        vm.selectedItemChanged = selectedItemChanged;
        vm.viewComment = viewComment;

        employe();

        function employe() {
            var response = Employe.get({ action: 'viewdetail', id: $stateParams.id });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.firstName = data.firstName;
            vm.Form.objForm.middleName = data.middleName;
            vm.Form.objForm.lastName = data.lastName;
            vm.Form.objForm.empId = data.id;
            vm.empId = data.id;
            vm.Form.objForm.photoAddress = data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        vm.openInputEducation = openInputEducation;
        vm.editInputEducation = editInputEducation;
        vm.closeModal = closeModal;

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.pendidikan = ['SMP', 'SMA Sederajat', 'D1', 'D2', 'D3', 'D4', 'S1', 'S2', 'S3'];
        if ($localStorage.country == 'MYS') {
            vm.pendidikan = ['UPRS', 'PMR', 'SPM', 'STPM', 'FOUNDATION', 'A LEVEL', 'DIPLOMA', 'BACHELOR', 'MASTER', 'PHD'];
        }
        vm.saveData = saveData;
        vm.deleteData = deleteData;
        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        checkCompletion();
        vm.viewMenus = viewMenus;
        vm.viewIjazah = viewIjazah;


        viewData();
        getJurusan();
        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function getUniversity(searchText) {
            vm.Form.objForm.schoolID = 0;
            return $http
                .get(config.api + 'api/education?action=getUniversity&id=' + searchText)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        vm.Form.objForm.schoolID = '0';
                    }
                    return item.data;
                });
        }

        function getJurusan() {
            $http.get(config.api + 'api/education?action=getJurusan')
                .then(function (item) {
                    vm.jurusan = item.data;
                });
        }

        function selectedItemChanged(sc) {

            vm.Form.objForm.schoolID = 0;
            if (typeof sc !== 'undefined') {
                vm.Form.objForm.schoolName = sc.schoolName;
                vm.Form.objForm.schoolID = sc.schoolID;
            }
        }

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Education.query({ action: 'viewData', emp_id: $stateParams.id });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data[0].data;
            vm.doc = data[0].ijazah;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }


        function openInputEducation(ev) {
            $mdDialog.show({
                controller: 'EducationemployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/education/input-education.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    employe();
                }
            });
        }

        function editInputEducation(ev, id) {
            $mdDialog.show({
                controller: 'EducationemployeeditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/education/input-education.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    employe();
                },
                locals: {
                    id: id
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.title = vm.Form.objForm.eduTitle;
            var promise = Form.saveData('save', formController, Education);

            promise.then(function () {
                vm.messageTheme = 'blue';
                angular.element.unblockUI();
                formController.$setPristine();

                $timeout(function () {
                    vm.Form.tampilPesan = false;
                    vm.stateEdit = false;
                }, 3000);
            });
            promise.catch(function () {
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function deleteData(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Education.delete({ action: 'deleteeducation', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                }, function () {

                });
            });


        }

        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({ action: 'checkCompletionData', id: $stateParams.id });
            resp.$promise.then(fetchDataCompletion);
            resp.$promise.catch(errorFetchDataCompletion);
            // vm.listOtselected=[];
        }

        function fetchDataCompletion(data) {
            vm.listCompletion = data[0];
            if (vm.listCompletion.profiles && vm.listCompletion.address && vm.listCompletion.dependents
                && vm.listCompletion.doc_ktp && vm.listCompletion.doc_ijazah && vm.listCompletion.doc_sim && vm.listCompletion.education
                && vm.listCompletion.experience && vm.listCompletion.bank && vm.listCompletion.tax) {
                vm.completion = true;
            }
        }

        function errorFetchDataCompletion() {
            vm.listCompletion = [];
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go('app.employee_myemploye_edit.' + id, { id: $stateParams.id });
        }

        function uploadIjazah(ev) {
            $mdDialog.show({
                controller: 'UploadIjazahController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/education/upload-ijazah.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    employe();
                    viewData();
                }
            });
        }

        function viewIjazah(ev) {
            // $mdDialog.show({
            //     controller         : 'EducationemployeController',
            //     controllerAs       : 'vm',
            //     templateUrl        : 'app/main/employee/employe/input-employe/education/view-ijazah.html',
            //     parent: angular.element(document.body),
            //     targetEvent: ev,
            //     clickOutsideToClose:true,
            //     fullscreen: true,
            //     onRemoving:function(element, removePromise)
            //     {
            //         employe();
            //         viewData();
            //     }
            // });
            var name = vm.doc;

            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/empdocument/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            }
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'DependentViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/dependent/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listOtselected = [];
                },
                locals: {
                    id: id,
                    constructor: Education
                }
            });
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.employee.employe.input-employe')
    .controller('EducationemployeeditController', EducationemployeeditController);

  /** @ngInject */
  EducationemployeeditController.$inject = ['$mdDialog', 'id', 'AppAPI', 'Auth', 'Form', '$http', 'config', '$localStorage', '$filter'];
  /** @ngInject */
  function EducationemployeeditController($mdDialog, id, AppAPI, Auth, Form, $http, config, $localStorage, $filter) {
    var vm = this;

    var translate = $filter('translate');
    // initial form
    Form.initialForm();

    // get constructor form
    var Education = AppAPI.Education();

    // set constructor form
    Form.setObject(Education);

    // set form to controller
    vm.Form = Form;

    var response = vm.Form.objForm.$get({ action: 'viewDetail', id: id.id, status: id.status_approval });
    response.then(changeDate);

    vm.closeModal = closeModal;
    vm.id = id;
    vm.saveData = saveData;
    vm.setToken = Auth.setToken;
    vm.getUniversity = getUniversity;
    vm.jurusan = [];

    vm.pendidikan = ['SMP', 'SMA Sederajat', 'D1', 'D2', 'D3', 'D4', 'S1', 'S2', 'S3'];
    if ($localStorage.country == 'MYS') {
      vm.pendidikan = ['UPRS', 'PMR', 'SPM', 'STPM', 'FOUNDATION', 'A LEVEL', 'DIPLOMA', 'BACHELOR', 'MASTER', 'PHD'];
    }

    vm.messageTheme = 'pink';

    function changeDate(data) {
      vm.Form.objForm.startStudy = new Date(data.start_study);
      vm.Form.objForm.finishStudy = new Date(data.finish_study);
      vm.Form.objForm.oldId = data.id;
      vm.Form.objForm.schoolName = data.school_name;
      vm.Form.objForm.finalGrade = data.final_grade;
      vm.Form.objForm.eduTitle = data.title;
      vm.Form.objForm.pendidikan = data.tingkat_pendidikan;
    }

    getJurusan();

    function closeModal() {
      $mdDialog.hide();
    }

    function getJurusan() {
      $http.get(config.api + 'api/education?action=getJurusan')
        .then(function (item) {
          vm.jurusan = item.data;
        });
    }

    function getUniversity(searchText) {
      vm.Form.objForm.schoolID = 0;
      return $http
        .get(config.api + 'api/education?action=getUniversity&id=' + searchText)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            vm.Form.objForm.schoolID = '0';
          }
          return item.data;
        });
    }

    function showDialogInfo(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          viewData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('update', formController, Education);
      promise.then(function (data) {
        showDialogInfo(ev, data);
      });
    }

    function showDialog(ev) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          closeModal();
        });
    }
  }
})();

(function () {
    "use strict";

    angular
        .module("app.employee.employe.input-employe")
        .controller("DocumentemployeController", DocumentemployeController);

    DocumentemployeController.$inject = [
        "$state",
        "$stateParams",
        "$http",
        "$localStorage",
        "$document",
        "$mdDialog",
        "Auth",
        "Form",
        "AppAPI",
        "DTColumnDefBuilder",
        "config",
        "FileUploader",
        "$filter",
        "EmployeeService"
    ];
    /** @ngInject */
    function DocumentemployeController(
        $state,
        $stateParams,
        $http,
        $localStorage,
        $document,
        $mdDialog,
        Auth,
        Form,
        AppAPI,
        DTColumnDefBuilder,
        config,
        FileUploader,
        $filter,
        EmployeeService
    ) {
        var vm = this;

        var translate = $filter('translate');
        var customSort = $filter('customSort');

        EmployeeService.title = translate('MYPROFILE.MENU.DOCUMENT');

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();
        var Document = AppAPI.Document();
        var Profiles = AppAPI.Profiles();
        var Dependents = AppAPI.Dependents();

        // set constructor form
        Form.setObject(Document);

        // set form to controller
        vm.Form = Form;

        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        vm.Form.objForm.ktpSeumurHidup = false;
        vm.viewMenus = viewMenus;
        vm.completion = false;
        vm.changeTypeDoc = changeTypeDoc;
        vm.editDocumen = editDocumen;
        vm.openInputEducation = openInputEducation;
        // vm.editInputEducation = editInputEducation;
        vm.closeModal = closeModal;
        vm.uploadFile = uploadFile;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        vm.upload = upload;
        vm.viewDokumen = viewDokumen;

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];
        vm.fileSizeError = false;

        vm.saveData = saveData;
        vm.deleteData = deleteData;
        vm.listDoc = [];

        activate();

        function activate() {
            checkCompletion();
            employe();
            viewDoc();
            viewData();
            getDependent();
        }

        function employe() {
            var response = Employe.get({
                action: "viewdetail",
                id: $stateParams.id
            });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.firstName = data.firstName;
            vm.Form.objForm.middleName = data.middleName; 
            vm.Form.objForm.lastName = data.lastName;
            vm.Form.objForm.empId = data.id;
            vm.empId = data.id;
            vm.Form.objForm.photoAddress = data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log("error");
        }

        function viewDoc() {
            angular.element.blockUI();
            var dataPromise = Document.query({
                action: "listTypedoc"
            });
            dataPromise.$promise.then(fetchDoc);
            dataPromise.$promise.catch(errorFetchdoc);
        }

        function fetchDoc(data) {
            var tempData = data;
            for(var i=0; i<tempData.length; i++) {
                tempData[i].typename = translate(tempData[i].typename);
            };
            vm.listDoc = customSort(tempData, ['typename']);
            angular.element.unblockUI();
        }

        function errorFetchdoc() {
            vm.listDoc = [];
            angular.element.unblockUI();
        }

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Document.query({
                action: "viewData",
                emp_id: $stateParams.id
            });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }

        function openInputEducation(ev) {
            $mdDialog
                .show({
                    controller: "DocumentemployeController",
                    controllerAs: "vm",
                    templateUrl:
                        "app/main/employee/employe/input-employe/document/input-document.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                .then(function () {
                    employe();
                    viewData();
                });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function upload() {
            var resp = vm.FileUploaderPhoto.uploadAll();
        }

        function uploadFile() {
            return false;
        }

        var uploaderPhoto = (vm.FileUploaderPhoto = new FileUploader({
            url: config.api + "api/document/upload",
            removeAfterUpload: true,
            alias: "ijazah",
            onBeforeUploadItem: function (item) {
                var id = new Date(item.formData[0].issuedDate);
                var id1 =
                    id.getFullYear() +
                    "-" +
                    (id.getMonth() + 1) +
                    "-" +
                    id.getDate();
                item.formData[0].issuedDate = id1;
                if (item.formData[0].expiredDate != undefined) {
                    var ed = new Date(item.formData[0].expiredDate);
                    var ed1 =
                        ed.getFullYear() +
                        "-" +
                        (ed.getMonth() + 1) +
                        "-" +
                        ed.getDate();
                    item.formData[0].expiredDate = ed1;
                }
                angular.element.blockUI();
            },
            formData: [
                {
                    action: "uploadijazah",
                    documentNo: vm.documentNo,
                    typeOfDocument: vm.typeOfDocument,
                    description: vm.description
                }
            ],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
                angular.element.unblockUI();
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            },
            onSuccessItem: function (item, response, status, headers) {
                showDialogInfo('ev', response);
                angular.element.unblockUI();
            }
        }));

        uploaderPhoto.filters.push({
            name: "enforceMaxFileSize",
            fn: function (item) {
                vm.itemSize = formatBytes(item.size);
                if (item.size > 2097152) {
                    vm.fileSizeError = true;
                    return false;
                } else {
                    vm.fileSizeError = false;
                    return true;
                }
            }
        });

        function formatBytes(bytes) {
            if (bytes < 1024) return bytes + " Bytes";
            else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + " KB";
            else if (bytes < 1073741824)
                return (bytes / 1048576).toFixed(3) + " MB";
            else return (bytes / 1073741824).toFixed(3) + " GB";
        }

        function saveData(ev, formController) {
            var promise = Form.saveData("save", formController, Document);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });
        }

        function showDialog(ev) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title("Success Save Data")
                        .textContent("Process Data was Success.")
                        .ariaLabel("Success Save Data")
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function () {
                    closeModal();
                });
        }

        function deleteData(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel("delete dialog")
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = Document.delete({
                            action: "deletedocument",
                            data: angular.toJson(vm.listDataSelected)
                        });

                        response.$promise.then(function (resp) {
                            dialogClose();
                            angular.element.unblockUI();
                            showDialogInfo(ev, resp);
                        });
                    },
                    function () { }
                );
            });
        }

        function viewDokumen(ev, name) {
            $mdDialog
                .show({
                    controller: "DocumentEmployeeViewController",
                    controllerAs: "vm",
                    templateUrl:
                        "app/main/employee/employe/input-employe/document/view-document.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        imgName: name
                    }
                })
                .then(function () {
                    employe();
                    viewData();
                });
        }

        function editDocumen(ev, data) {
            $mdDialog
                .show({
                    controller: "DocumentemployeeditController",
                    controllerAs: "vm",
                    templateUrl:
                        "app/main/employee/employe/input-employe/document/edit-document.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: data
                    }
                })
                .then(function (data) {
                    console.log(data);
                    showResponseDialog(ev, data);
                });
        }

        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({
                action: "checkCompletionData",
                id: $stateParams.id
            });
            resp.$promise.then(fetchDataCompletion);
            resp.$promise.catch(errorFetchDataCompletion);
        }

        function fetchDataCompletion(data) {
            vm.listCompletion = data[0];
            if (
                vm.listCompletion.profiles &&
                vm.listCompletion.address &&
                vm.listCompletion.dependents &&
                vm.listCompletion.doc_ktp &&
                vm.listCompletion.doc_ijazah &&
                vm.listCompletion.doc_sim &&
                vm.listCompletion.education &&
                vm.listCompletion.experience &&
                vm.listCompletion.bank &&
                vm.listCompletion.tax
            ) {
                vm.completion = true;
            }
        }

        function errorFetchDataCompletion() {
            vm.listCompletion = [];
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go("app.employee_myemploye_edit." + id, {
                id: $stateParams.id
            });
        }

        function showResponseDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.pesan)
                        .ariaLabel(data.title)
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function () {
                    closeModal();
                    employe();
                    viewData();
                });
        }

        function changeTypeDoc() {
            var typeDoc = vm.Form.objForm.typeOfDocument;
            switch (typeDoc) {
                case "1":
                    vm.reqno = true;
                    vm.docSeumurhidup = true;
                    vm.Form.objForm.expiredDate = new Date("9999-12-31");
                    vm.Form.objForm.docSeumurhidup = true;
                    vm.minDate = vm.Form.objForm.expiredDate;
                    break;
                case "2":
                    vm.reqno = true;
                    vm.docSeumurhidup = false;
                    vm.Form.objForm.docSeumurhidup = false;
                    vm.Form.objForm.documentNo = null;
                    vm.Form.objForm.expiredDate = null;
                    break;
                case "5":
                case "10":
                case "8":
                    vm.reqno = false;
                    vm.Form.objForm.documentNo = "00";
                    vm.docSeumurhidup = true;
                    vm.Form.objForm.expiredDate = new Date("9999-12-31");
                    vm.Form.objForm.docSeumurhidup = true;
                    vm.minDate = vm.Form.objForm.expiredDate;
                    break;
                case "12":
                case "13":
                case "14":
                    vm.reqno = false;
                    vm.Form.objForm.documentNo = "00";
                    vm.docSeumurhidup = true;
                    vm.Form.objForm.expiredDate = new Date("9999-12-31");
                    vm.minDate = vm.Form.objForm.expiredDate;
                    break;
                default:
                    vm.reqno = true;
                    vm.Form.objForm.documentNo = null;
                    vm.docSeumurhidup = false;
                    vm.Form.objForm.docSeumurhidup = false;
                    vm.Form.objForm.expiredDate = null;
                    break;
            }
        }

        function getDependent() {
            var request = Dependents.query({
                action: "viewData",
                emp_id: $stateParams.id
            });
            request.$promise.then(function (response) {
                vm.dependents = [];
                if (response.length > 0) {
                    for (var i = 0; i < response[0].data.length; i++) {
                        if (
                            response[0].data[i].type_of_family.toLowerCase() ==
                            "anak" ||
                            response[0].data[i].type_of_family.toLowerCase() ==
                            "child"
                        ) {
                            vm.dependents.push(response[0].data[i]);
                        }
                    }
                }
            });

            request.$promise.catch(function (error) { });
        }

        function showDialogInfo(ev, data) {
            var expmess = data.pesan.split("_");
            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    viewData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller(
            'DocumentEmployeeViewController',
            DocumentEmployeeViewController
        );

    /** @ngInject */
    DocumentEmployeeViewController.$inject = [
        '$localStorage',
        '$mdDialog',
        'imgName',
        'AppAPI',
        'Auth',
        'Form',
        'config',
        '$http',
        '$sce',
        '$timeout'
    ];
    /** @ngInject */
    function DocumentEmployeeViewController(
        $localStorage,
        $mdDialog,
        imgName,
        AppAPI,
        Auth,
        Form,
        config,
        $http,
        $sce,
        $timeout
    ) {
        var vm = this;
        vm.isPDF = false;
        vm.closeModal = closeModal;
        vm.doc = imgName;
        vm.downloadDoc = downloadDoc;
        vm.trusted = false;
        vm.loading = true;

        if(vm.doc && vm.doc != '-' && vm.doc != null) {
            angular.element.blockUI();
            var request = new XMLHttpRequest();
            request.open('HEAD', 'api/empdocument/' + vm.doc, false);
            request.send();
            if(request.status == 200) {
                vm.trusted = true;
            } else {
                vm.trusted = false;
            }

            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
                vm.url =
                    'api/empdocument/' +
                    vm.doc +
                    '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
            } else {
                vm.doc_type = false;
            }

            vm.loading = false;
            angular.element.unblockUI();
        } else {
            vm.doc = '/document-not-found.png';
        }

        // getImages(imgName);

        // function getImages(filename) {
        //     var apiCall = $http.get(config.api + 'api/empdocument/' + filename, {
        //         responseType: "arraybuffer"
        //     });
        //     apiCall
        //         .success(function (response) {
        //             var blobFile = new Blob([response], {
        //                 type: 'application/pdf'
        //             });
        //             var fileURL = URL.createObjectURL(blobFile);
        //             vm.fileURL = $sce.trustAsResourceUrl(fileURL)
        //         }).error(function (error) {
        //             vm.fileURL = '/assets/images/avatars/profile.jpg';

        //         })
        // }

        function closeModal() {
            $mdDialog.hide();
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/empdocument/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                })
                    .success(function(data, status, headers) {
                        headers = headers();
                        var filename = name;
                        var contentType = headers['content-type'];

                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([data], { type: contentType });
                            var url = window.URL.createObjectURL(blob);

                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute('download', filename);

                            var clickEvent = new MouseEvent('click', {
                                view: window,
                                bubbles: true,
                                cancelable: false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                    })
                    .error(function(data) {
                        console.log(data);
                    });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector('#contentDialog')
                                )
                            )
                            .clickOutsideToClose(true)
                            .title('Document Not Found')
                            .textContent('Document not Found')
                            .ariaLabel('Failed Save Data')
                            .ok('OK')
                            .targetEvent(ev)
                    )
                    .then(function() {
                        // closeModal();
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('DocumentemployeeditController', DocumentemployeeditController);

    /** @ngInject */
    DocumentemployeeditController.$inject = [
        '$localStorage',
        '$mdDialog',
        'reffData',
        'AppAPI',
        'Auth',
        'Form',
        '$filter',
        'config',
        'FileUploader'
    ];

    /** @ngInject */
    function DocumentemployeeditController(
        $localStorage,
        $mdDialog,
        reffData,
        AppAPI,
        Auth,
        Form,
        $filter,
        config,
        FileUploader
    ) {

        var vm = this;

        var translate = $filter('translate');
        var customSort = $filter('customSort');

        // get constructor form
        var Documents = AppAPI.Document();

        vm.closeModal = closeModal;
        vm.setToken = Auth.setToken;
        vm.updateData = updateData;
        vm.hideExpiredDate = false;
        vm.expiredDate = new Date();
        vm.payload = {};

        vm.listDoc = [];

        activate();

        function activate() {
            viewDoc();
        }

        function setValue(data, typeDoc) {
            vm.payload.typeOfDocuments = data.typenames;
            vm.payload.typeOfDocument = data.typename;
            if (data.expired_date == "9999-12-31" || data.expired_date == "0000-00-00") {
                vm.hideExpiredDate = true;
            } else {
                vm.expiredDate = new Date(data.expired_date);
            }
            vm.payload.id = data.id;
            vm.payload.documentNo = data.documentNo;
            vm.payload.description = data.description;
        }

        function viewDoc() {
            angular.element.blockUI();
            var dataPromise = Documents.query({
                action: 'listTypedoc'
            });
            dataPromise.$promise.then(fetchDoc);
            dataPromise.$promise.catch(errorFetchdoc);
        }

        function fetchDoc(data) {
            var tempData = data;
            for(var i=0; i<tempData.length; i++) {
                tempData[i].typename = translate(tempData[i].typename);
            };
            vm.listDoc = customSort(tempData, ['typename']);
            setValue(reffData, data);
            angular.element.unblockUI();
        }

        function errorFetchdoc() {
            vm.listDoc = [];
            angular.element.unblockUI();
        }


        function closeModal() {
            $mdDialog.cancel();
        }

        function updateData(ev, formController) {
            if (vm.hideExpiredDate) {
                vm.payload.expiredDate = '9999-12-31';
            } else {
                var tempDate = angular.copy(vm.expiredDate);
                vm.payload.expiredDate = moment(tempDate).format('YYYY-MMMM-DD');
            }
            var setToken = Auth.setToken();
            setToken.then(function () {
                var request = Documents.save({
                    action: 'update',
                    id: vm.payload.id,
                    expiredDate: vm.payload.expiredDate,
                    documentNo: vm.payload.documentNo,
                    description: vm.payload.description,
                    typeOfDocument: reffData.documentTypeId
                });
                request.$promise.then(function (data) {
                    formController.$setPristine();

                    showDialogInfo(ev, data);
                });

                request.$promise.catch(function (data) {
                    formController.$setPristine();
                    showDialogInfo(ev, data);
                });
            })
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }

})();

(function() {
  'use strict';

  angular
    .module('app.employee.employe.input-employe')
    .controller('DependentemployeViewSklController', DependentemployeViewSklController);

  /** @ngInject */
  DependentemployeViewSklController.$inject = [
    '$mdDialog',
    'id',
    'AppAPI',
    'Auth',
    'Form',
    'config',
    '$http'
  ];
  /** @ngInject */
  function DependentemployeViewSklController(
    $mdDialog,
    id,
    AppAPI,
    Auth,
    Form,
    config,
    $http
  ) {
    var vm = this;


    vm.downloadDoc = downloadDoc;
    vm.closeModal = closeModal;

    function closeModal() {
      $mdDialog.hide();
    }

    vm.doc = id.link_skl;
    setupView();

    function setupView() {
      if (vm.doc.slice(-3) === 'pdf') {
        vm.doc_type = true;
    } else {
        vm.doc_type = false;
    }
    vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
    }

    function downloadDoc(ev) {
      var name = vm.doc;
      if (name !== null && name !== '-') {
        $http({
          method: 'GET',
          url: config.api + 'api/empdocument/' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        })
          .success(function(data, status, headers) {
            headers = headers();
            var filename = name;
            var contentType = headers['content-type'];

            var linkElement = document.createElement('a');
            try {
              var blob = new Blob([data], { type: contentType });
              var url = window.URL.createObjectURL(blob);

              linkElement.setAttribute('href', url);
              linkElement.setAttribute('download', filename);

              var clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false
              });
              linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
              console.log(ex);
            }
          })
          .error(function(data) {
            console.log(data);
          });
      } else {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Document Not Found')
              .textContent('Document not Found')
              .ariaLabel('Failed Save Data')
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            // closeModal();
          });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.employee.employe.input-employe')
    .controller('UploadSklController', UploadSklController);

  /** @ngInject */
  UploadSklController.$inject = [
    '$localStorage',
    '$mdDialog',
    '$stateParams',
    'AppAPI',
    'Auth',
    'Form',
    'config',
    'FileUploader',
    'firstName',
    'lastName'
  ];
  /** @ngInject */
  function UploadSklController(
    $localStorage,
    $mdDialog,
    $stateParams,
    AppAPI,
    Auth,
    Form,
    config,
    FileUploader,
    firstName,
    lastName
  ) {
    var vm = this;
    // initial form
    Form.initialForm();

    // get constructor form
    var Document = AppAPI.Document();

    // set constructor form
    Form.setObject(Document);

    // set form to controller
    vm.Form = Form;

    vm.closeModal = closeModal;
    vm.setToken = Auth.setToken;
    vm.uploadFile = uploadFile;
    vm.UploadPhotoStateSucces = false;
    vm.UploadPhotoStateError = false;
    vm.upload = upload;
    vm.Form.objForm.empID = $stateParams.id;
    console.log($stateParams);
    vm.fileSizeError = false;
    vm.firstName = firstName;
    vm.lastName = lastName;

    vm.messageTheme = 'pink';

    function closeModal() {
      $mdDialog.hide();
    }

    function upload() {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = (vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/documents/uploadskl',
      removeAfterUpload: true,
      alias: 'skl',
      onBeforeUploadItem: function() {
        angular.element.blockUI();
      },
      onAfterAddingAll: function() {
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        angular.element.unblockUI();
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      },
      onSuccessItem: function(item, response, status, headers) {
        angular.element.unblockUI();
        vm.UploadPhotoStateSucces = true;
        vm.UploadPhotoStateError = false;
      },
      onErrorItem: function(item, response, status, headers) {
        angular.element.unblockUI();
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = true;
      }
    }));

    uploaderPhoto.filters.push({
      name: 'enforceMaxFileSize',
      fn: function(item) {
        vm.itemSize = formatBytes(item.size);
        if (item.size > 2097152) {
          vm.fileSizeError = true;
          return false;
        } else {
          vm.fileSizeError = false;
          return true;
        }
      }
    });

    function formatBytes(bytes) {
      if (bytes < 1024) return bytes + ' Bytes';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
      else return (bytes / 1073741824).toFixed(3) + ' GB';
    }

    function uploadFile() {
      return false;
    }

    function showDialog(ev) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          closeModal();
        });
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('UploadEmpKKController', UploadEmpKKController);

    /** @ngInject */
    UploadEmpKKController.$inject=['$localStorage','$mdDialog','$stateParams','AppAPI','Auth','Form','config','FileUploader'];
    /** @ngInject */
    function UploadEmpKKController($localStorage,$mdDialog,$stateParams,AppAPI,Auth,Form,config,FileUploader)
    {

      var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Document=AppAPI.Document();

	    // set constructor form
	    Form.setObject(Document);

	    // set form to controller
        vm.Form = Form;

        vm.Form.objForm.expiredDate = '9999-12-31';

	    vm.closeModal=closeModal;
	    vm.setToken=Auth.setToken;
        vm.goNav=goNav;
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;
        vm.upload=upload;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.Form.objForm.typeOfDocument='kk';
        vm.Form.objForm.empID=$stateParams.id;
        vm.ChangeDate=ChangeDate;
        vm.ChangeDateExp=ChangeDateExp;
        vm.fileSizeError = false;
        // vm.Form.objForm.dataEdu=id;

	    vm.messageTheme='pink';

      function ChangeDate()
      {
        var d=new Date(vm.Form.objForm.issuedDate);
        vm.issuedDate=d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate();
      }

      function ChangeDateExp()
      {
        var d=new Date(vm.Form.objForm.expiredDate);
        vm.expiredDate=d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate();
      }


	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updateeducation', formController, Employe);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/

        function upload()
        {

             var resp=vm.FileUploaderPhoto.uploadAll();

        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/dependents/uploadkk',
           removeAfterUpload:true,
           alias:'kk',
           onBeforeUploadItem :function(){
              angular.element.blockUI();
           },
           formData:[
              {
               action:'uploadkk',
               documentNo:vm.documentNo,
               typeOfDocument:vm.typeOfDocument,
               description:vm.description
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
                angular.element.unblockUI();
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              },
            onSuccessItem:function(item, response, status, headers){
                showDialog();
                angular.element.unblockUI();
            }
        });

        uploaderPhoto.filters.push({
            name: 'syncFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                vm.sizefile=item.size;

                return true;
            }
        });
        // uploaderPhoto.filters.push({
        //   name: 'enforceMaxFileSize',
        //   fn: function(item) {
        //     vm.itemSize = formatBytes(item.size);
        //     if (item.size > 2097152) {
        //       vm.fileSizeError = true;
        //       return false;
        //     } else {
        //       vm.fileSizeError = false;
        //       return true;
        //     }
        //   }
        // });

        function formatBytes(bytes) {
          if (bytes < 1024) return bytes + ' Bytes';
          else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
          else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
          else return (bytes / 1073741824).toFixed(3) + ' GB';
        }

        function goNav(state) {
            $state.go(state);
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }



	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }

        function isChecked()
        {
            vm.Form.objForm.ktpSeumurHidup=false;
            if(!vm.seumurhidupChecked){
              vm.Form.objForm.ktpSeumurHidup=true;
            }
        }

    function toggleCheck(event)
      {
          if ( event )
          {
              event.stopPropagation();
          }
      }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('DependentViewRejectCommentController', DependentViewRejectCommentController);

    DependentViewRejectCommentController.$inject = ['$localStorage','id','constructor','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function DependentViewRejectCommentController($localStorage,id,constructor,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        
        Form.initialForm();
        // set constructor form
        Form.setObject(constructor);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        
    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Tax);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('DependentemployeController', DependentemployeController)
        .directive('validFile',function(){
          return {
            require:'ngModel',
            link:function(scope,el,attrs,ngModel){
              //change event is fired when file is selected
              el.bind('change',function(){
                scope.$apply(function(){
                  ngModel.$setViewValue(el.val());
                  ngModel.$render();
                });
              });
            }
          }
        });


    DependentemployeController.$inject = ['$state', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', '$http', 'config', 'EmployeeService', '$filter', '$localStorage', 'FileUploader'];
    /** @ngInject */
    function DependentemployeController($state, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, $http, config, EmployeeService, $filter, $localStorage, FileUploader) {

        var vm = this;
        var translate = $filter('translate');
        EmployeeService.title = translate('MYPROFILE.MENU.DEPENDENT');

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();
        var Dependents = AppAPI.Dependents();
        vm.employe = employe;
        var Profiles = AppAPI.Profiles();

        // set constructor form
        Form.setObject(Dependents);


        // set form to controller
        vm.Form = Form;
        vm.completion = false;
        vm.downloadDoc = downloadDoc;
        vm.uploadSkl = uploadSkl;
        vm.familyCheck = familyCheck;
        vm.isLaw = true;
        vm.viewComment = viewComment;
        vm.viewSkl = viewSkl;
        vm.country = $localStorage.country;
        vm.fileSizeError = false;
        vm.berlakuSeumurHidup = berlakuSeumurHidup;
        vm.ktpSeumurHidup = false;
        vm.typeOfFamilyData = '';

        vm.dateOfBirth = '1970-01-01';
        vm.issuedDateData = '1970-01-01';
        vm.expiredDateData = '1970-01-01';
        vm.fullname = '';
        vm.description = '-';
        vm.saveReturn = null;

        employe();

        function employe() {
            var response = Employe.get({ action: 'viewdetail', id: $stateParams.id });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.firstName = data.firstName;
            vm.Form.objForm.middleName = data.middleName;
            vm.Form.objForm.lastName = data.lastName;
            vm.Form.objForm.empId = data.id;
            vm.Form.objForm.photoAddress = '';
            vm.empId = data.id;
            vm.Form.objForm.photoAddress = data.photoAddress;
            vm.gd = data.gender;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        if ($localStorage.country == 'IDN') {
            vm.gender = [{
                'id': 'L',
                'name': 'L'
            },
            {
                'id': 'P',
                'name': 'P'
            },];
        } else {
            vm.gender = [
                {
                    'id': 'L',
                    'name': 'MALE'
                },
                {
                    'id': 'P',
                    'name': 'FEMALE'
                },
            ];
        }

        vm.openInputDependent = openInputDependent;
        vm.editInputDependent = editInputDependent;
        vm.closeModal = closeModal;

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.saveData = saveData;
        vm.deleteData = deleteData;
        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        checkCompletion();
        vm.viewMenus = viewMenus;
        vm.uploadKK = uploadKK;
        vm.viewKK = viewKK;

        viewData();
        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Dependents.query({ action: 'viewData', emp_id: $stateParams.id });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data[0].data;
            vm.doc = data[0].kk;
            vm.status = data[0].status;
            angular.element.unblockUI();
            var array_family = [];
            data[0].data.forEach(function (element) {
                array_family.push(element.type_of_family.toLowerCase());
            });

            if (data[0].status.toLowerCase() == 'lajang') {
                vm.keluarga = [
                    { id: "ayah", value: "Father" },
                    { id: "ibu", value: "Mother" }
                ];
                for (var i = 0; i < vm.keluarga.length; i++) {
                    for (var j = 0; j < array_family.length; j++) {
                        if (vm.keluarga[i]['value'].toLowerCase() == array_family[j]) {
                            vm.keluarga.splice(i, 1);
                            break;
                        }
                    }
                }
                var isEmpty = function (x) { if (x != null) { return true } else { return false } }
                var newArray = vm.keluarga.filter(isEmpty);
                vm.keluarga = newArray;
            } else {
                if (data[0].gender == 'L') {
                    vm.keluarga = [
                        { id: "istri", value: "Wife" },
                        { id: "ayah", value: "Father" },
                        { id: "ibu", value: "Mother" },
                        { id: "ayah mertua", value: "Father in-laws" },
                        { id: "ibu mertua", value: "Mother in-laws" }
                    ];
                } else {
                    vm.keluarga = [
                        { id: "suami", value: "Husband" },
                        { id: "ayah", value: "Father" },
                        { id: "ibu", value: "Mother" },
                        { id: "ayah mertua", value: "Father in-laws" },
                        { id: "ibu mertua", value: "Mother in-laws" }
                    ];
                }
                var lenTemp = 0;
                for (var i = 0; i < vm.keluarga.length; i++) {
                    for (var j = 0; j < array_family.length; j++) {
                        if (vm.keluarga[i]['value'].toLowerCase() == array_family[j]) {
                            delete vm.keluarga[i];
                            lenTemp += 1;
                            break;
                        }
                    }
                }
                vm.keluarga.push({ id: "anak", value: "Child" });
                var isEmpty = function (x) { if (x != null) { return true } else { return false } }
                var newArray = vm.keluarga.filter(isEmpty);
                vm.keluarga = newArray;
            }
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = 'api/empdocument/' + vm.doc + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function array_flip(trans) {
            var key, tmp_ar = {};

            for (key in trans) {
                if (trans.hasOwnProperty(key)) {
                    tmp_ar[trans[key]] = key;
                }
            }

            return tmp_ar;
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }

        function openInputDependent(ev) {
            $mdDialog.show({
                controller: 'DependentemployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/dependent/input-dependent.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    employe();
                }
            });
        }

        function editInputDependent(ev, id) {
            $mdDialog.show({
                controller: 'DependentemployeeditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/dependent/edit-dependents.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    employe();
                },
                locals: {
                    id: id,
                    st: vm.status,
                    gd: vm.gd,
                    uploadSkl: vm.uploadSkl
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            angular.element.blockUI();

            var dateOfBirthDate = changeDateFormat(vm.Form.objForm.dateOfBirth);
            var str = vm.Form.objForm.fullname;
            var words = str.split(" ");
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
            vm.Form.objForm.lastName = str.substring(words[0].length);
            vm.Form.objForm.dateOfBirth_formated = dateOfBirthDate;
            vm.typeOfFamilyData = angular.copy(vm.Form.objForm.typeOfFamily);

            if(vm.Form.objForm.dateOfBirth) {
                vm.dateOfBirth = changeDateFormat(vm.Form.objForm.dateOfBirth);
            }

            if(vm.Form.objForm.issuedDate) {
                vm.issuedDateData = changeDateFormat(vm.Form.objForm.issuedDate);
            }

            if(vm.Form.objForm.expiredDate) {
                vm.expiredDateData = changeDateFormat(vm.Form.objForm.expiredDate);
            }

            vm.fullname = vm.Form.objForm.fullname;

            if(vm.Form.objForm.expiredDate) {
                vm.description = vm.Form.objForm.description;
            }

            var promise = Form.saveData('save', formController, Dependents);
            promise.then(function (data) {
                vm.saveReturn = data;
                if(vm.typeOfFamilyData == 'anak' || vm.typeOfFamilyData == 'istri' || vm.typeOfFamilyData == 'suami') {
                    vm.FileUpload.uploadAll();
                } else {
                    showDialog(ev, vm.saveReturn);
                }
            });
        }

        function changeDateFormat(date){
            var monthTmp = "" + (date.getMonth()+1);
            var monthPad = "00";
            var month = monthPad.substring(0, monthPad.length - monthTmp.length) + monthTmp;

            var dayTmp = "" + date.getDate();
            var dayPad = "00";
            var day = dayPad.substring(0, dayPad.length - dayTmp.length) + dayTmp;

            var year = date.getFullYear();
            return year+"-"+month+"-"+day;
        }

        function showDialog(ev, data) {
            var $translate = $filter('translate');
            var Message = $translate(data.pesan);
            var Status = $translate(data.status);

            var Title = 'Success Save Data';

            if(Status) {
                Title = 'Failed Save Data';
            }

            $mdDialog
            .show(
                $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(Title)
                .textContent(Message)
                .ariaLabel(Title)
                .ok('OK')
                .targetEvent(ev)
                )
            .then(function () {
                if(Status) {
                    closeModal();
                }
                angular.element.unblockUI();
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Dependents.delete({ action: 'deletedependents', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(function (resp) {
                        viewData(1);
                        dialogClose();
                        angular.element.unblockUI();
                        showDialogInfo(ev, resp);
                    });
                }, function () {

                });
            });
        }

        function showDialogInfo(ev, data) {
            var expmess = data.pesan.split("_");
            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({ action: 'checkCompletionData', id: $stateParams.id });
            resp.$promise.then(fetchDataCompletion);
            resp.$promise.catch(errorFetchDataCompletion);
            // vm.listOtselected=[];

        }

        function fetchDataCompletion(data) {
            vm.listCompletion = data[0];
            if (vm.listCompletion.profiles && vm.listCompletion.address && vm.listCompletion.dependents
                && vm.listCompletion.doc_ktp && vm.listCompletion.doc_ijazah && vm.listCompletion.doc_sim && vm.listCompletion.education
                && vm.listCompletion.experience && vm.listCompletion.bank && vm.listCompletion.tax) {
                vm.completion = true;
            }
        }

        function errorFetchDataCompletion() {
            vm.listCompletion = [];
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go('app.employee_myemploye_edit.' + id, { id: $stateParams.id });
        }

        function uploadKK(ev) {
            $mdDialog.show({
                controller: 'UploadEmpKKController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/dependent/upload-kk.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    employe();
                    viewData();
                }
            });
        }

        function uploadSkl(ev, firstName, lastName) {
            $mdDialog.show({
                controller: 'UploadSklController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/dependent/upload-surat-keterangan-lahir.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    firstName: firstName,
                    lastName: lastName
                }
            }).then(function (data) {
                viewData();
            });
        }

        function viewKK(ev) {
            $mdDialog.show({
                controller: 'DependentemployeController',
                controllerAs: 'vm',
                templateUrl:
                    "app/main/employee/employe/input-employe/document/view-document.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true
            });

        }

        function viewSkl(ev, linkSkl) {
            $mdDialog.show({
                controller: 'DependentemployeViewSklController',
                controllerAs: 'vm',
                templateUrl:
                    "app/main/employee/employe/input-employe/document/view-document.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    id: linkSkl
                },
                onRemoving: function (element, removePromise) {
                    employe();
                    viewData();
                }
            });
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/empdocument/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Document Not Found')
                        .textContent('Document not Found')
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }

        function familyCheck(data) {
            if (data == 'ayah mertua' || data == 'ibu mertua') {
                vm.isLaw = false;
            }

            if(vm.Form.objForm.typeOfFamily=='anak' || vm.Form.objForm.typeOfFamily=='istri' || vm.Form.objForm.typeOfFamily=='suami') {
                vm.Form.objForm.issuedDate = null;
                vm.Form.objForm.expiredDate = null;
                vm.Form.objForm.docnumber = null;
                vm.Form.objForm.description = null;

                angular.element('#uploadPhoto').val('');
                angular.element('#uploadPhoto2').val('');

                vm.ktpSeumurHidup = false;
            }
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'DependentViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/dependent/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listOtselected = [];
                },
                locals: {
                    id: id,
                    constructor: Dependents
                }
            });
        }

        var uploaderPhoto = vm.FileUpload = new FileUploader({
            url: config.api + "api/documents/uploadchild",
            removeAfterUpload: true,
            alias: "skl",
            onBeforeUploadItem: function(item) {
                item.formData[0].dateOfBirth = vm.dateOfBirth;
                item.formData[0].issuedDate = vm.issuedDateData;
                item.formData[0].expiredDate = vm.expiredDateData;

                var strData = vm.fullname;
                var wordsData = strData.split(" ");
                for (var i = 0; i < wordsData.length - 1; i++) {
                    wordsData[i] += " ";
                }

                item.formData[0].firstName = wordsData[0].replace(/\s/g, '');
                item.formData[0].lastName = strData.substring(wordsData[0].length);

                item.formData[0].ktpSeumurHidup = vm.ktpSeumurHidup;
                item.formData[0].description = vm.description;

                if((vm.typeOfFamilyData=='istri' || vm.typeOfFamilyData=='suami') && vm.country=='IDN') {
                    item.url = config.api + "api/documents/uploadktp";
                    item.alias = "ktp";
                    item.formData[0].typeOfDocument = 'KTP PASANGAN';
                } else if(vm.typeOfFamilyData.typeOfFamily=='anak' && vm.country=='IDN') {
                    item.url = config.api + "api/documents/uploadchild";
                    item.alias = "skl";
                    item.formData[0].typeOfDocument = 'SKL';
                }
            },
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;

                angular.element.unblockUI();
            },
            headers: {
                tokenAuth:$localStorage.tokenAuth
            },
            onSuccessItem: function(item, status) {
                if ( status.status == 0 ) {
                    vm.uploadSuccess = false;
                    vm.uploadError   = true;
                } else {
                    vm.uploadSuccess = true;
                    vm.uploadError   = false;
                }

                var tempNotif = status.message;

                vm.uploadNotif = tempNotif;
                if ('moreInfo' in status && status.moreInfo.length>0) {
                    vm.isMoreInfo = true;
                    vm.detailInfo = status.moreInfo;
                }
                angular.element('#uploadPhoto').val('');
                angular.element('#uploadPhoto2').val('');    

                showDialog(ev, {message: 'Success save and success upload data', status: 'Success'});

                angular.element.unblockUI();
            },
            onErrorItem: function (item, response, status, headers) {
                vm.uploadSuccess = false;
                vm.uploadError = true;

                showDialog(ev, {message: 'Success save but failed upload data', status: 'Success And Failed'});

                angular.element.unblockUI();
            }
        });

        uploaderPhoto.filters.push({
            name: "enforceMaxFileSize",
            fn: function (item) {
                vm.itemSize = formatBytes(item.size);
                if (item.size > 2097152) {
                    vm.fileSizeError = true;
                    return false;
                } else {
                    vm.fileSizeError = false;
                    return true;
                }
            }
        });

        function formatBytes(bytes) {
            if (bytes < 1024) return bytes + " Bytes";
            else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + " KB";
            else if (bytes < 1073741824)
                return (bytes / 1048576).toFixed(3) + " MB";
            else return (bytes / 1073741824).toFixed(3) + " GB";
        }

        function berlakuSeumurHidup() {
            vm.ktpSeumurHidup = vm.Form.objForm.ktpSeumurHidup;

            if(vm.ktpSeumurHidup) {
                vm.Form.objForm.expiredDate = null;
            } else {
                vm.Form.objForm.expiredDate = new Date();
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.employee.employe.input-employe')
    .controller('DependentemployeeditController', DependentemployeeditController)
    .directive('validFile',function(){
      return {
        require:'ngModel',
        link:function(scope,el,attrs,ngModel){
          //change event is fired when file is selected
          el.bind('change',function(){
            scope.$apply(function(){
              ngModel.$setViewValue(el.val());
              ngModel.$render();
            });
          });
        }
      }
    });

  /** @ngInject */
  DependentemployeeditController.$inject = [
    '$mdDialog',
    'id',
    'AppAPI',
    'Auth',
    'Form',
    'st',
    'gd',
    'config',
    '$localStorage',
    '$filter',
    '$http',
    'FileUploader'
  ];
  /** @ngInject */
  function DependentemployeeditController(
    $mdDialog,
    id,
    AppAPI,
    Auth,
    Form,
    st,
    gd,
    config,
    $localStorage,
    $filter,
    $http,
    FileUploader
  ) {
    var vm = this;
    // initial form
    Form.initialForm(false);

    // get constructor form
    var Dependents = AppAPI.Dependents();

    // set constructor form
    Form.setObject(Dependents);

    // set form to controller
    vm.Form = Form;

    angular.element.blockUI();

    var response = vm.Form.objForm.$get({ action: 'viewDetail', id: id.id, status: id.status_approval });
    response.then(changeDate);

    vm.closeModal = closeModal;
    vm.saveData = saveData;
    vm.setToken = Auth.setToken;
    vm.viewSkl = viewSkl;
    vm.Form.objForm.typeOfFamily = null;

    vm.country = $localStorage.country;
    vm.viewDokumen = viewDokumen;

    vm.messageTheme = 'pink';

    if ($localStorage.country == 'IDN') {
      vm.gender = [{
        'id': 'L',
        'name': 'L'
      },
      {
        'id': 'P',
        'name': 'P'
      },];

    } else {
      vm.gender = [
        {
          'id': 'L',
          'name': 'MALE'
        },
        {
          'id': 'P',
          'name': 'FEMALE'
        },
      ];
    }

    vm.sklStatus = id.link_skl == null || id.link_skl == '' ? false : true;

    function changeDate(data) {
      vm.Form.objForm.dateOfBirth = new Date(data.date_of_birth);
      vm.Form.objForm.typeOfFamily = data.type_of_family;
      vm.Form.objForm.fullname = data.first_name + " " + data.last_name;
      vm.Form.objForm.birthPlace = data.birth_place;
      vm.Form.objForm.photoAddress = '';

      if (st.toLowerCase() == 'lajang') {
        vm.keluarga = [{ id: 'ayah', value: 'Father' }, { id: 'ibu', value: 'Mother' }];
      } else {
        if (gd == 'L') {
          vm.keluarga = [
            { id: 'anak', value: 'Child' },
            { id: 'istri', value: 'Wife' },
            { id: 'ayah', value: 'Father' },
            { id: 'ibu', value: 'Mother' },
            { id: 'ayah mertua', value: 'Father in-laws' },
            { id: 'ibu mertua', value: 'Mother in-laws' }
          ];
        } else {
          vm.keluarga = [
            { id: 'anak', value: 'Child' },
            { id: 'suami', value: 'Husband' },
            { id: 'ayah', value: 'Father' },
            { id: 'ibu', value: 'Mother' },
            { id: 'ayah mertua', value: 'Father in-laws' },
            { id: 'ibu mertua', value: 'Mother in-laws' }
          ];
        }
      }
      
      angular.element.unblockUI();
    }

    function closeModal() {
      $mdDialog.hide();
    }

    // function saveData(ev, formController) {
    //   angular.element.blockUI();

    //   vm.Form.objForm.firstName = vm.Form.objForm.firstNameD;
    //   vm.Form.objForm.lastName = vm.Form.objForm.lastNameD;
    //   var promise = Form.saveData('update', formController, Dependents);
    //   promise.then(function (data) {
    //     showDialog(ev, data);
    //   });
    // }

    function saveData(ev, formController) {
      angular.element.blockUI();

      var dateOfBirthDate = changeDateFormat(vm.Form.objForm.dateOfBirth);
      if((vm.Form.objForm.typeOfFamily=='anak' || vm.Form.objForm.typeOfFamily=='istri' || vm.Form.objForm.typeOfFamily=='suami') && vm.country=='IDN') {
        vm.FileUpload.uploadAll();
      } else {
        updateData(ev, formController)
      }
    }

    function updateData(ev, formController) {
      var str = vm.Form.objForm.fullname;
      var words = str.split(" ");
      for (var i = 0; i < words.length - 1; i++) {
          words[i] += " ";
      }

      vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
      vm.Form.objForm.lastName = str.substring(words[0].length);
      vm.Form.objForm.dateOfBirth_formated = dateOfBirthDate;
      var promise = Form.saveData('update', formController, Dependents);
      promise.then(function (data) {
        showDialog(ev, data);
      });
    }

    function changeDateFormat(date){
      var monthTmp = "" + (date.getMonth()+1);
      var monthPad = "00";
      var month = monthPad.substring(0, monthPad.length - monthTmp.length) + monthTmp;

      var dayTmp = "" + date.getDate();
      var dayPad = "00";
      var day = dayPad.substring(0, dayPad.length - dayTmp.length) + dayTmp;

      var year = date.getFullYear();
      return year+"-"+month+"-"+day;
    }

    function viewSkl(ev) {
      $mdDialog.show({
        controller: 'DependentemployeViewSklController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/employe/input-employe/dependent/view-skl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          id: id
        },
        clickOutsideToClose: true,
        fullscreen: true
      });
    }

    function showDialog(ev, data) {
      var $translate = $filter('translate');
      var Message = $translate(data.pesan);
      var Status = $translate(data.status);

      var Title = 'Success Save Data';

      if(Status) {
        Title = 'Failed Save Data';
      }

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(Title)
            .textContent(Message)
            .ariaLabel(Title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          if(Status) {
            closeModal();
          }
          angular.element.blockUI();
        });
    }

    var uploaderPhoto = vm.FileUpload = new FileUploader({
        url: config.api + "api/documents/uploadchild",
        removeAfterUpload: true,
        alias: "skl",
        onBeforeUploadItem: function(item) {
            item.formData[0].dateOfBirth = changeDateFormat(vm.Form.objForm.dateOfBirth);

            var str = item.formData[0].fullname;
            var words = str.split(" ");
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            item.formData[0].firstName = words[0].replace(/\s/g, '');
            item.formData[0].lastName = str.substring(words[0].length);

            if((vm.Form.objForm.typeOfFamily=='istri' || vm.Form.objForm.typeOfFamily=='suami') && vm.country=='IDN') {
                item.url = config.api + "api/documents/uploadktp";
                item.alias = "ktp";
            } else if(vm.Form.objForm.typeOfFamily=='anak' && vm.country=='IDN') {
                item.url = config.api + "api/documents/uploadchild";
                item.alias = "skl";
            }
        },
        onAfterAddingAll: function () {
            vm.uploadSuccess = false;
            vm.uploadError = false;

            angular.element.unblockUI();
        },
        headers: {
            tokenAuth:$localStorage.tokenAuth
        },
        onSuccessItem: function(item, status) {
            if ( status.status == 0 ) {
                vm.uploadSuccess = false;
                vm.uploadError   = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError   = false;
            }

            var tempNotif = status.message.split("||");

            vm.uploadNotif = tempNotif[0];
            if ('moreInfo' in status && status.moreInfo.length>0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }
            angular.element('#uploadPhoto').val('');

            angular.element.unblockUI();
        },
        onErrorItem: function (item, response, status, headers) {
            vm.uploadSuccess = false;
            vm.uploadError = true;
            angular.element.unblockUI();
        }
    });

    uploaderPhoto.filters.push({
        name: "enforceMaxFileSize",
        fn: function (item) {
            vm.itemSize = formatBytes(item.size);
            if (item.size > 2097152) {
                vm.fileSizeError = true;
                return false;
            } else {
                vm.fileSizeError = false;
                return true;
            }
        }
    });

    function formatBytes(bytes) {
        if (bytes < 1024) return bytes + " Bytes";
        else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + " KB";
        else if (bytes < 1073741824)
            return (bytes / 1048576).toFixed(3) + " MB";
        else return (bytes / 1073741824).toFixed(3) + " GB";
    }

    function viewDokumen(ev, name) {
        $mdDialog
            .show({
                controller: "DocumentEmployeeViewController",
                controllerAs: "vm",
                templateUrl:
                    "app/main/employee/employe/input-employe/document/view-document.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                locals: {
                    imgName: name
                }
            })
            .then(function () {
                employe();
                viewData();
            });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.employee.employe.input-employe')
    .controller('UploadKtpEmpController', UploadKtpEmpController);

  /** @ngInject */
  UploadKtpEmpController.$inject = [
    '$localStorage',
    '$mdDialog',
    '$stateParams',
    'AppAPI',
    'Auth',
    'Form',
    'config',
    'FileUploader'
  ];
  /** @ngInject */
  function UploadKtpEmpController(
    $localStorage,
    $mdDialog,
    $stateParams,
    AppAPI,
    Auth,
    Form,
    config,
    FileUploader
  ) {
    var vm = this;
    // initial form
    Form.initialForm();

    // get constructor form
    var Document = AppAPI.Document();

    // set constructor form
    Form.setObject(Document);

    // set form to controller
    vm.Form = Form;

    vm.closeModal = closeModal;
    vm.setToken = Auth.setToken;
    vm.goNav = goNav;
    vm.uploadFile = uploadFile;
    vm.UploadPhotoStateSucces = false;
    vm.UploadPhotoStateError = false;
    vm.upload = upload;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.seumurhidupChecked = false;
    vm.ktpSeumurHidup = false;
    vm.typeOfDocument = 'ktp';
    vm.empID = $stateParams.id;
    vm.messageTheme = 'pink';
    vm.fileSizeError = false;

    function closeModal() {
      $mdDialog.hide();
    }

    function upload() {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = (vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/documents/uploadktp',
      removeAfterUpload: true,
      alias: 'ktp',
      onBeforeUploadItem: function() {
        angular.element.blockUI();
      },
      formData: [
        {
          action: 'uploadktp',
          documentNo: vm.documentNo,
          typeOfDocument: vm.typeOfDocument,
          description: vm.description,
          expiredDate:vm.expiredDate
        }
      ],
      onAfterAddingAll: function() {
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        angular.element.unblockUI();
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      },
      onSuccessItem: function(item, response, status, headers) {
        showDialog();
        angular.element.unblockUI();
      }
    }));

    uploaderPhoto.filters.push({
      name: 'syncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options) {
          vm.sizefile=item.size; 
          return true;
      }
    });

    // uploaderPhoto.filters.push({
    //   name: 'enforceMaxFileSize',
    //   fn: function(item) {
    //     vm.itemSize = formatBytes(item.size);
    //     if (item.size > 2097152) {
    //       vm.fileSizeError = true;
    //       return false;
    //     } else {
    //       vm.fileSizeError = false;
    //       return true;
    //     }
    //   }
    // });

    function formatBytes(bytes) {
      if (bytes < 1024) return bytes + ' Bytes';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
      else return (bytes / 1073741824).toFixed(3) + ' GB';
    }

    function goNav(state) {
      $state.go(state);
      vm.activeItem = state;
    }

    function uploadFile() {
      return false;
    }

    function showDialog(ev) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          closeModal();
        });
    }

    function isChecked() {
      vm.Form.objForm.ktpSeumurHidup = false;
      if (vm.seumurhidupChecked) {
        vm.Form.objForm.ktpSeumurHidup = true;
        vm.ktpSeumurHidup = true;
        vm.forever = true;
        vm.expiredDate = '9999-12-31'
      }
    }

    function toggleCheck(event) {
      if (event) {
        event.stopPropagation();
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('AddressemployeController', AddressemployeController);

    AddressemployeController.$inject = [
        '$state',
        '$scope',
        '$localStorage',
        '$stateParams',
        '$timeout',
        'Form',
        'AppAPI',
        'Auth',
        '$mdDialog',
        '$http',
        'config',
        '$filter',
        'EmployeeService'
    ];
    /** @ngInject */
    function AddressemployeController(
        $state,
        $scope,
        $localStorage,
        $stateParams,
        $timeout,
        Form,
        AppAPI,
        Auth,
        $mdDialog,
        $http,
        config,
        $filter,
        EmployeeService
    ) {
        var vm = this;
        var translate = $filter('translate');
        
        EmployeeService.title = translate('MYPROFILE.MENU.ADDRESS');

        // initial form
        Form.initialForm(false);

        var Address = AppAPI.Address();
        var Lokasi = AppAPI.Infolokasi();
        var Employe = AppAPI.Employe();
        var Profiles = AppAPI.Profiles();
        var Ktp = AppAPI.Document();

        // set constructor form
        Form.setObject(Address);

        // set form to controller
        vm.Form = Form;
        vm.loadKab = loadKab;
        vm.loadKec = loadKec;
        vm.loadKabKtp = loadKabKtp;
        vm.loadKecKtpe = loadKecKtp;
        vm.country = $localStorage.country;
        //  vm.loadKelurahan=loadKelurahan;
        //  vm.loadKelurahanKtp=loadKelurahanKtp;
        //  vm.viewData=viewData;
        //  vm.loadKtp=loadKtp;
        vm.viewDoc = viewDoc;
        vm.downloadDoc = downloadDoc;
        vm.closeModal = closeModal;
        vm.checkKTP = false;

        vm.listProvince = [];
        vm.listKab = [];
        vm.listKec = [];
        // vm.listKelurahan=[];
        // vm.listKelurahanKtp=[];

        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        vm.viewMenus = viewMenus;
        vm.Uploadktp = Uploadktp;
        vm.saveAddress = saveAddress;
        // vm.Form.objForm.
        vm.clearMeesage = clearMeesage;
        vm.stateEdit = false;
        vm.ChangeState = ChangeState;
        vm.alamatsekarang = alamatsekarang;
        vm.completion = false;

        loadData();
        checkCompletion();
        employe();
        viewData();
        loadKtp();

        function loadData() {
            var response = vm.Form.objForm.$get({
                action: 'viewAddress',
                id: $stateParams.id
            });
            response.then(SetData);
        }

        function SetData(data) {
            if (data.addressKtp == null) {
                vm.Form.objForm.alamatsekarangdigunakan = 'noktp';
            } else if (
                data.addressKtp == data.addressCurrent &&
                data.provinsiKtp == data.provinsiCurrent
            ) {
                vm.Form.objForm.alamatsekarangdigunakan = 'ktp';
            } else {
                vm.Form.objForm.alamatsekarangdigunakan = 'noktp';
            }
        }

        function employe() {
            var response = Employe.get({
                action: 'viewdetail',
                id: $stateParams.id
            });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title=data.title;
            vm.Form.objForm.firstName=data.firstName;
            vm.Form.objForm.middleName=data.middleName;
            vm.Form.objForm.lastName=data.lastName;
            vm.Form.objForm.empId=data.id;
            vm.empId = data.id;
            vm.Form.objForm.photo_address = data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        function ChangeState() {
            switch (vm.stateEdit) {
                case true:
                    vm.stateEdit = false;
                    loadData();
                    loadKtp();
                    break;
                case false:
                    vm.stateEdit = true;
                    vm.Form.objForm.alamatsekarangdigunakan = null;
                    vm.Form.objForm.addressCurrent = '';
                    vm.Form.objForm.phoneCurrent = '';
                    // vm.Form.objForm.rtCurrent='';
                    // vm.Form.objForm.rwCurrent='';
                    vm.Form.objForm.provinsiCurrent = '';
                    vm.Form.objForm.kabKotaCurrent = '';
                    vm.Form.objForm.kodePosCurrent = '';
                    vm.Form.objForm.kecCurrent = '';
                    vm.Form.objForm.kelurahanCurrent = '';
                    break;
            }
        }

        // ===== watch =======

        $scope.$watch('vm.Form.objForm.provinsiCurrent', watchProv);
        $scope.$watch('vm.Form.objForm.kabKotaCurrent', watchKab);

        $scope.$watch('vm.Form.objForm.provinsiKtp', watchProvKtp);
        $scope.$watch('vm.Form.objForm.kabKotaKtp', watchKabKtp);

        function watchProv() {
            var prov = vm.Form.objForm.provinsiCurrent;
            if (prov != null || prov != undefined) {
                loadKab(prov);
            }
        }

        function watchKab() {
            var kab = vm.Form.objForm.kabKotaCurrent;
            if (vm.country!='MYS' && (kab != null || kab != undefined)) {
                loadKec(kab);
            }
        }

        function watchProvKtp() {
            var prov = vm.Form.objForm.provinsiKtp;
            if (prov != null || prov != undefined) {
                loadKabKtp(prov);
            }
        }

        function watchKabKtp() {
            var kab = vm.Form.objForm.kabKotaKtp;
            if (vm.country!='MYS' && (kab != null || kab != undefined)) {
                loadKecKtp(kab);
            }
        }

        // =====end watch===

        function viewData() {
            angular.element.blockUI();
            var resp = Lokasi.query({ action: 'infoPropinsi' });
            resp.$promise.then(fetchDataProv);
            resp.$promise.catch(errorFetchProv);
        }

        function fetchDataProv(data) {
            vm.listProvince = data;
            angular.element.unblockUI();
        }

        function errorFetchProv() {
            vm.listProvince = [];
            angular.element.unblockUI();
        }

        function loadKab(prov) {
            angular.element.blockUI();
            var dataPromise = Lokasi.query({
                action: 'infoKabupaten',
                kode: prov
            });
            dataPromise.$promise.then(fetchKab);
            dataPromise.$promise.catch(errorFetchKab);
        }

        function fetchKab(data) {
            vm.listKab = data;
            angular.element.unblockUI();
        }

        function errorFetchKab() {
            vm.listKab = [];
            angular.element.unblockUI();
        }

        function loadKec(kab) {
            var dataPromise = Lokasi.query({
                action: 'viewKecamatan',
                kode: kab
            });
            dataPromise.$promise.then(fetchKec);
            dataPromise.$promise.catch(errorFetchKec);
        }

        function fetchKec(data) {
            vm.listKec = data;
            angular.element.unblockUI();
        }

        function errorFetchKec() {
            vm.listKec = [];
            angular.element.unblockUI();
        }

        // function loadKelurahan(kec)
        // {
        //     var dataPromise = Lokasi.query({action:'viewKelurahan',kode:kec});
        //    dataPromise.$promise.then(fetchKelurahan);
        //    dataPromise.$promise.catch(errorFetchKelurahan);
        // }

        // function fetchKelurahan(data) {
        //     vm.listKelurahan = data;
        //     // console.log(vm.listKelurahan);
        //     angular.element.unblockUI();
        // }

        // function errorFetchKelurahan() {
        //     vm.listKelurahan = [];
        //     angular.element.unblockUI();
        // }

        //KTP
        function loadKabKtp(prov) {
            angular.element.blockUI();
            var dataPromise = Lokasi.query({
                action: 'infoKabupaten',
                kode: prov
            });
            dataPromise.$promise.then(fetchKabKtp);
            dataPromise.$promise.catch(errorFetchKabKtp);
        }

        function fetchKabKtp(data) {
            vm.listKabKtp = data;
            angular.element.unblockUI();
        }

        function errorFetchKabKtp() {
            vm.listKabKtp = [];
            angular.element.unblockUI();
        }

        function loadKecKtp(kab) {
            if(vm.country!='MYS'){
                var dataPromise = Lokasi.query({
                    action: 'viewKecamatan',
                    kode: kab
                });
                dataPromise.$promise.then(fetchKecKtp);
                dataPromise.$promise.catch(errorFetchKecKtp);
            }
        }

        function fetchKecKtp(data) {
            vm.listKecKtp = data;
            angular.element.unblockUI();
        }

        function errorFetchKecKtp() {
            vm.listKecKtp = [];
            angular.element.unblockUI();
        }

        // function loadKelurahanKtp(kec)
        // {
        //     var dataPromise = Lokasi.query({action:'viewKelurahan',kode:kec});
        //     dataPromise.$promise.then(fetchKelurahanKtp);
        //     dataPromise.$promise.catch(errorFetchKelurahanKtp);
        // }

        // function fetchKelurahanKtp(data) {
        //     vm.listKelurahanKtp = data;
        //     // console.log(vm.listKelurahan);
        //     angular.element.unblockUI();
        // }

        // function errorFetchKelurahanKtp() {
        //     vm.listKelurahanKtp = [];
        //     angular.element.unblockUI();
        // }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveAddress(formController) {
            angular.element.blockUI();
            var response = Form.updateData(
                'updateaddress',
                formController,
                Address,
                $stateParams.id,
                'viewAddress'
            );

            response.then(function() {
                vm.messageTheme = 'blue';
                angular.element.unblockUI();
                formController.$setPristine();

                $timeout(function() {
                    vm.Form.tampilPesan = false;
                    vm.stateEdit = false;
                }, 3000);
            });

            response.catch(function() {
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            });
        }

        function alamatsekarang() {
            switch (vm.Form.objForm.alamatsekarangdigunakan) {
                case 'ktp':
                    vm.Form.objForm.addressCurrent = vm.Form.objForm.addressKtp;
                    vm.Form.objForm.phoneCurrent = vm.Form.objForm.phoneKtp;
                    // vm.Form.objForm.rtCurrent=vm.Form.objForm.rtKtp;
                    // vm.Form.objForm.rwCurrent=vm.Form.objForm.rwKtp
                    vm.Form.objForm.provinsiCurrent = vm.Form.objForm.provinsiKtp;
                    vm.Form.objForm.kabKotaCurrent = vm.Form.objForm.kabKotaKtp;
                    vm.Form.objForm.kecCurrent = vm.Form.objForm.kecKtp;
                    vm.Form.objForm.kelurahanCurrent = vm.Form.objForm.kelurahanKtp;
                    vm.Form.objForm.kodePosCurrent = vm.Form.objForm.kodePosKtp;
                    break;
                case 'noktp':
                    vm.Form.objForm.addressCurrent = '';
                    vm.Form.objForm.phoneCurrent = '';
                    // vm.Form.objForm.rtCurrent='';
                    // vm.Form.objForm.rwCurrent='';
                    vm.Form.objForm.provinsiCurrent = '';
                    vm.Form.objForm.kabKotaCurrent = '';
                    vm.Form.objForm.kecCurrent = '';
                    vm.Form.objForm.kelurahanCurrent = '';
                    vm.Form.objForm.kodePosCurrent = '';
                    break;
            }
        }

        function loadKtp() {
            var resp = Ktp.query({
                action: 'viewData',
                emp_id: $stateParams.id,
                type: 'ktp'
            });
            resp.$promise.then(fetchKtp);
            resp.$promise.catch(errorFetchKtp);
        }

        function fetchKtp(data) {
            vm.listKtp = data[0];
            if (vm.listKtp) {
                vm.doc = vm.listKtp.link;
                if (vm.doc != null) {
                    if (vm.doc.slice(-3) === 'pdf') {
                        vm.doc_type = true;
                        vm.url =
                            'api/empdocument/' +
                            vm.doc +
                            '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
                    } else {
                        vm.doc_type = false;
                    }
                }
            }

            // if (vm.listKtp.link) {
            //     if (vm.doc.slice(-3) === 'pdf') {
            //         vm.doc_type = true;
            //         vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
            //     } else {
            //         vm.doc_type = false;
            //     }
            // }
        }

        function errorFetchKtp() {
            vm.listKtp = [];
        }

        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({
                action: 'checkCompletionData',
                id: $stateParams.id
            });
            resp.$promise.then(fetchData);
            resp.$promise.catch(errorFetchData);
            // vm.listOtselected=[];
        }

        function fetchData(data) {
            vm.listCompletion = data[0];
            vm.checkKTP = data[0].doc_ktp;
            if (
                vm.listCompletion.profiles &&
                vm.listCompletion.address &&
                vm.listCompletion.dependents &&
                vm.listCompletion.doc_ktp &&
                vm.listCompletion.doc_ijazah &&
                vm.listCompletion.doc_sim &&
                vm.listCompletion.education &&
                vm.listCompletion.experience &&
                vm.listCompletion.bank &&
                vm.listCompletion.tax
            ) {
                vm.completion = true;
            }
        }

        function errorFetchData() {
            vm.listCompletion = [];
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go('app.employee_myemploye_edit.' + id, {
                id: $stateParams.id
            });
        }

        function Uploadktp(ev) {
            $mdDialog.show({
                controller: 'UploadKtpEmpController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/employee/employe/input-employe/address/upload-ktp.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    employe();
                    viewData();
                    loadKtp();
                    loadData();
                    checkCompletion();
                    vm.stateEdit = false;
                }
            });
        }

        function viewDoc(ev) {
            $mdDialog.show({
                controller: 'AddressemployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/alamat/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    viewData();
                }
            });
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/empdocument/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                })
                    .success(function(data, status, headers) {
                        headers = headers();
                        var filename = name;
                        var contentType = headers['content-type'];

                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([data], { type: contentType });
                            var url = window.URL.createObjectURL(blob);

                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute('download', filename);

                            var clickEvent = new MouseEvent('click', {
                                view: window,
                                bubbles: true,
                                cancelable: false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                    })
                    .error(function(data) {
                        console.log(data);
                    });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector('#contentDialog')
                                )
                            )
                            .clickOutsideToClose(true)
                            .title('Document Not Found')
                            .textContent('Document not Found')
                            .ariaLabel('Failed Save Data')
                            .ok('OK')
                            .targetEvent(ev)
                    )
                    .then(function() {
                        // closeModal();
                    });
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('CertificationemployeController', CertificationemployeController);


    CertificationemployeController.$inject = ['$state', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'EmployeeService', 'FileUploader', 'config', '$localStorage', '$filter', '$timeout', '$location', '$window'];
    /** @ngInject */
    function CertificationemployeController($state, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, EmployeeService, FileUploader, config, $localStorage, $filter, $timeout, $location, $window) {

        var vm = this;
        var translate = $filter('translate');

        EmployeeService.title = translate('MYPROFILE.MENU.CERTIFICATION');

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();
        var Certification = AppAPI.Certification();
        var Profiles = AppAPI.Profiles();

        // set constructor form
        Form.setObject(Certification);

        // set form to controller
        vm.Form = Form;
        vm.completion = false;

        vm.viewDetailComponents = viewDetailComponents;

        employe();

        function employe() {
            var response = Employe.get({
                action: 'viewdetail',
                id: $stateParams.id
            });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.firstName = data.firstName;
            vm.Form.objForm.middleName = data.middleName;
            vm.Form.objForm.lastName = data.lastName;
            vm.Form.objForm.empId = data.id;
            vm.empId = data.id;
            vm.Form.objForm.photoAddress = data.photoAddress;
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        vm.openInputCertification = openInputCertification;
        vm.editInputCertification = editInputCertification;
        vm.closeModal = closeModal;

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.saveData = saveData;
        vm.deleteData = deleteData;

        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        checkCompletion();
        vm.viewMenus = viewMenus;

        var Employe = AppAPI.Employe();
        viewData();
        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Certification.query({
                action: 'viewData',
                emp_id: $stateParams.id
            });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            vm.listDataSelected = [];
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = [];
            for (var i; i < vm.listData.length; i++) {
                if (!vm.listData[i].source_id) {
                    vm.listDataSelected.push(vm.listData[i]);
                }
            }
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }


        function openInputCertification(ev) {
            $mdDialog.show({
                controller: 'CertificationemployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/certification/input-certification.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true
            });
        }

        function editInputCertification(ev, id) {
            if (!id.source_id) {
                $mdDialog.show({
                    controller: 'CertificationemployeeditController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/employee/employe/input-employe/certification/input-certification.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        id: id
                    }
                });
            } else {
                var Message = 'Internal Certification, Cannot Edit.';
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Cannot Edit')
                    .textContent(Message)
                    .ariaLabel(Message)
                    .ok('OK')
                    .targetEvent(ev)
                ).then(function () {
                    closeModal();
                });
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, Certification);
            promise.then(function (data) {
                // showDialog(ev,data);
            });
        }

        function showDialog(ev, data) {
            // console.log(data)
            // var $translate = $filter('translate');
            // var Message = $translate(data.pesan);
            var Message = 'Success';
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(Message)
                .textContent(Message)
                .ariaLabel(Message)
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Certification.delete({
                        action: 'deletecertification',
                        data: angular.toJson(vm.listDataSelected)
                    });

                    response.$promise.then(viewData);
                }, function () {

                });
            });


        }

        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({
                action: 'checkCompletionData',
                id: $stateParams.id
            });
            resp.$promise.then(fetchDataCompletion);
            resp.$promise.catch(errorFetchDataCompletion);
            // vm.listOtselected=[];
        }

        function fetchDataCompletion(data) {
            vm.listCompletion = data[0];
            if (vm.listCompletion.profiles && vm.listCompletion.address && vm.listCompletion.dependents &&
                vm.listCompletion.doc_ktp && vm.listCompletion.doc_ijazah && vm.listCompletion.doc_sim && vm.listCompletion.education &&
                vm.listCompletion.experience && vm.listCompletion.bank && vm.listCompletion.tax) {
                vm.completion = true;
            }
        }

        function errorFetchDataCompletion() {
            vm.listCompletion = [];
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go('app.employee_myemploye_edit.' + id, {
                id: $stateParams.id
            });
        }
        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/certification/uploadsertifikat',
            removeAfterUpload: true,
            alias: 'image',
            onBeforeUploadItem: function (item) {
                var dt = new Date(item.formData[0].startDate);
                var et = new Date(item.formData[0].finishDate);
                var sd = new Date(item.formData[0].certificationDate);

                var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                var newdate1 = dt.getFullYear() + '-' + (et.getMonth() + 1) + '-' + et.getDate();
                var newdate3 = sd.getFullYear() + '-' + (sd.getMonth() + 1) + '-' + sd.getDate();
                item.formData[0].start_date = newdate;
                item.formData[0].end_date = newdate1;
                item.formData[0].certification_Date = newdate3;
                vm.Form.objForm.startDate = newdate;
                vm.Form.objForm.finishDate = newdate1;
                vm.Form.objForm.certificationDate = newdate3;
                angular.element.blockUI();

            },
            formData: [
                vm.Form.objForm
            ],
            onAfterAddingAll: function (data) {
                vm.Form.tampilPesan = false;
                angular.element.unblockUI();
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            },
            onSuccessItem: function (item, response, status, headers) {
                vm.Form.tampilPesan = true;
                vm.Form.pesam = response.pesan
                if (response.error) {
                    vm.message = {
                        ariaLabel: 'Upload file has been failed',
                        textContent: response.pesan
                    }
                } else {
                    vm.message = {
                        ariaLabel: 'Upload file has been successfully',
                        textContent: response.pesan
                    }
                }
                angular.element.unblockUI();
                showDialog();
                viewData();
                $timeout(function () {
                    vm.notif.error = false;
                    vm.notif.success = false;
                    vm.Form.objForm = {};
                }, 3000);
            },
            onError: function () {
                vm.Form.tampilPesan = true;
                vm.Form.pesam = 'Internal server error'
                vm.notif.error = 'Internal server error'
                vm.notif.success = false;
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            }
        });

        uploaderPhoto.filters.push({
            name: 'syncFilter',
            fn: function (item /*{File|FileLikeObject}*/ , options) {
                vm.sizefile = item.size;
                return true;
            }
        });


        function viewDetailComponents(ev, ls) {
            angular.element.blockUI();
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                angular.element.unblockUI();
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/certificate/viewpdf/' + ls.nik + '/' + ls.code_class + '/' + $localStorage.tokenAuth, '_blank');
            }, function () {
                angular.element.unblockUI();
                $window.alert('gagal load token');
            });
        }
    }

})();

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('CertificationemployeeditController', CertificationemployeeditController);

    /** @ngInject */
    CertificationemployeeditController.$inject=['$mdDialog','id','AppAPI','Auth','Form','FileUploader'];
    /** @ngInject */
    function CertificationemployeeditController($mdDialog,id,AppAPI,Auth,Form,FileUploader)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Certification=AppAPI.Certification();

	    // set constructor form
	    Form.setObject(Certification);

	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewDetail',id:id.id});
        response.then(changeDate);

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;

	    vm.messageTheme='pink';


        function changeDate(data) {
           vm.Form.objForm.certificationDate=new Date(data.certification_date);
           vm.Form.objForm.startDate=new Date(data.start_date);
           vm.Form.objForm.finishDate=new Date(data.finish_date);
           vm.Form.objForm.institutionName=data.institution_name;
           vm.Form.objForm.certificationNumber=data.certification_number;
           vm.Form.objForm.typeOfCertification=data.type_of_certification;
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updatecertification', formController, Employe);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/
        function saveData(ev, formController) {
            var promise= Form.updateData('update',formController,Certification, Form.objForm.id,'viewDetail');
            promise.then(function(data){
	            // showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }
    }
    
})();  

(function() {
    'use strict';
    angular
      .module('app.employee.employe.input-employe')
      .controller('BankViewController', BankViewController);
  
    BankViewController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'data',
      '$sce'
    ];
    /** @ngInject */
    function BankViewController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      data,
      $sce
    ) {
        var vm = this;
        var Document = AppAPI.Document(); 
        var Profiles = AppAPI.Profiles();
        vm.Form = Form;
        vm.info = data;
        vm.dialogClose = dialogClose;
        vm.doc_type=false;
        
        activate();
  
        function activate() {
            if(data.link!=null){
                vm.doc_type = false;            
                vm.doc = data.link;
                vm.url = 'api/empdocument/'+data.link+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
            }
        
        }

        function dialogClose() {
            $mdDialog.hide();
        // $window.location.reload();
        }
    }
  })();
(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('BankemployeController', BankemployeController);


    BankemployeController.$inject = ['$state', '$stateParams', '$timeout', 'Form', 'AppAPI', 'EmployeeService', '$scope', 'FileUploader', 'config', '$localStorage', '$mdDialog', '$document', '$filter'];
    /** @ngInject */
    function BankemployeController($state, $stateParams, $timeout, Form, AppAPI, EmployeeService, $scope, FileUploader, config, $localStorage, $mdDialog, $document, $filter) {
        var vm = this;
        var translate = $filter('translate');

        EmployeeService.title = translate('MYPROFILE.MENU.BANK');

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();
        var Bank = AppAPI.Bank();
        var Profiles = AppAPI.Profiles();

        // set constructor form
        Form.setObject(Bank);

        $scope.hasUpload = false;
        vm.uploadAccMandiri = uploadAccMandiri;
        vm.uploadAccMandiriStateSucces = false;
        vm.uploadAccMandiriStateError = false;
        vm.upload = upload;
        vm.hasUpload = false;
        var empID = $localStorage.empno;
        vm.country = $localStorage.country;
        vm.empID = empID;
        vm.documentNo = '00';
        vm.closeModal = closeModal;
        vm.viewDokumen = viewDokumen

        // set form to controller
        vm.Form = Form;
        angular.element.blockUI();
        var response = vm.Form.objForm.$get({
            action: 'viewBank',
            id: $stateParams.id
        });

        response.then(function (data) {
            vm.canEdit = data.disabledEdit;
            vm.Form.objForm.bankName = vm.Form.objForm.bankName;
            vm.Form.objForm.bank_code = vm.Form.objForm.bank_code;
        })

        vm.saveData = saveData;
        vm.stateEdit = false;
        vm.ChangeState = ChangeState;
        // vm.Form.objForm.

        vm.clearMeesage = clearMeesage;
        vm.canEdit = true;

        vm.Completed = false;
        vm.viewCompletion = viewCompletion;
        vm.checkCompletion = checkCompletion;
        checkCompletion();
        vm.viewMenus = viewMenus;
        vm.completion = false;


        vm.check = {};

        vm.message = {
            uplodFailed: 'Failed Upload data',
            uploadSuccess: 'Success Upload data'
        }

        vm.listCurrency = [{
            currency: 'IDR'
        },
        {
            currency: 'USD'
        },
        {
            currency: 'MYR'
        }
            ,
        {
            currency: 'THB'
        }
        ];

        employe();
        LoadBankCode()

        function LoadBankCode() {
            var response = Bank.query({
                action: 'getBankCode'
            });
            response.$promise.then(fetchBankCode);
            response.$promise.catch(errorFetchBankCode);
        }

        function fetchBankCode(data) {
            vm.listBankCode = data;
            angular.element.unblockUI();
        }

        function errorFetchBankCode() {
            vm.listBankCode = [];
            angular.element.unblockUI();
        }

        function loadData() {
            angular.element.blockUI();
            var response = vm.Form.objForm.$get({
                action: 'viewBank',
                id: empID
            });
            response.then(changeDate);
        }

        function changeDate(data) {
            vm.Form.objForm.dateOfBirth = new Date(data.dateOfBirth);
            vm.Form.objForm.dateJoin = new Date(data.dateJoin);
            vm.Form.objForm.bankName = data.bankName;
            vm.Form.objForm.currency = data.currency;
            vm.Form.objForm.link = data.link;
            vm.canEdit = data.disabledEdit;
            if (vm.Form.objForm.accountNumber !== null) {
                vm.documentNo = vm.Form.objForm.accountNumber;
            }
            vm.description = 'Account Mandiri';
            angular.element.unblockUI();
        }

        function ChangeState() {
            switch (vm.stateEdit) {
                case true:
                    vm.stateEdit = false;
                    break;
                case false:
                    vm.stateEdit = true;
                    break;
            }
        }

        function employe() {
            var response = Employe.get({
                action: 'viewdetail',
                id: $stateParams.id
            });
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
        }

        function fetchEmploye(data) {
            vm.Form.objForm.title=data.title;
            vm.Form.objForm.firstName=data.firstName;
            vm.Form.objForm.middleName=data.middleName;
            vm.Form.objForm.lastName=data.lastName;
            vm.Form.objForm.empId=data.id;
            vm.empId = data.id;
            vm.Form.objForm.photoAddress = data.photoAddress;
            // loadData();
            console.log('test');
        }

        function errorFetchEmploye() {
            console.log('error');
        }

        function saveData(formController) {
            angular.element.blockUI();
            var response = Form.updateData('updatebank', formController, Bank, $stateParams.id, 'viewBank');

            response.then(function () {
                vm.messageTheme = 'blue';
                angular.element.unblockUI();
                formController.$setPristine();

                $timeout(function () {
                    vm.Form.tampilPesan = false;
                    employe();
                    vm.stateEdit = false;
                }, 3000);

            });

            response.catch(function () {
                vm.messageTheme = 'pink';
                angular.element.unblockUI();

            });


        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function viewCompletion() {
            if (!vm.Completed) {
                vm.Completed = true;
            } else {
                vm.Completed = false;
            }
        }

        function checkCompletion() {
            var resp = Profiles.query({
                action: 'checkCompletionData',
                id: $stateParams.id
            });
            resp.$promise.then(fetchData);
            resp.$promise.catch(errorFetchData);
            // vm.listOtselected=[];
        }

        function fetchData(data) {
            vm.listCompletion = data[0];
            vm.check = data[0];
            if (vm.listCompletion.profiles && vm.listCompletion.address && vm.listCompletion.dependents &&
                vm.listCompletion.doc_ktp && vm.listCompletion.doc_ijazah && vm.listCompletion.doc_sim && vm.listCompletion.education &&
                vm.listCompletion.experience && vm.listCompletion.bank && vm.listCompletion.tax) {
                vm.completion = true;
            }
        }

        function errorFetchData() {
            vm.listCompletion = [];
            vm.check = {};
        }

        function viewMenus(id) {
            vm.Completed = false;
            $state.go('app.employee_myemploye_edit.' + id, {
                id: $stateParams.id
            });
        }

        function uploadAccMandiri(ev) {
            $mdDialog.show({
                controller: 'BankemployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/bank/upload.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                    checkCompletion();
                }
            });
        }

        function upload() {
            var resp = vm.FileUploaderAccMandiri.uploadAll();
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function showDialog() {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Upload Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Upload Data')
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function viewDokumen(ev, data) {
            $mdDialog.show({
                controller: 'BankViewController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/bank/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    data: data
                }
            });
        }

        var uploaderNpwp = (vm.FileUploaderAccMandiri = new FileUploader({
            url: config.api + 'api/documents/upload',
            removeAfterUpload: true,
            alias: 'ijazah',
            onBeforeUploadItem: function () {
                angular.element.blockUI();
            },
            formData: [{
                action: 'uploadijazah',
                documentNo: vm.documentNo,
                typeOfDocument: '10',
                expiredDate: '9999-12-31',
                description: vm.description
            }],
            onAfterAddingAll: function () {
                vm.UploadNpwpStateSucces = false;
                vm.UploadNpwpStateError = false;
                angular.element.unblockUI();
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            },
            onSuccessItem: function (item, response, status, headers) {
                angular.element.unblockUI();

                if (response.error) {
                    vm.message.uplodFailed = response.pesan;
                    vm.uploadAccMandiriStateSucces = false;
                    vm.uploadAccMandiriStateError = true;
                    $scope.hasUpload = false;
                } else {
                    vm.message.uploadSuccess = response.pesan;
                    vm.uploadAccMandiriStateSucces = true;
                    vm.uploadAccMandiriStateError = false;
                    $timeout(function () {
                        vm.hasUpload = true;
                        $scope.hasUpload = true;
                    }, 3000);

                    showDialog();
                }

            },
            onErrorItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                vm.message.uplodFailed = 'Upload failed';
                vm.uploadAccMandiriStateSucces = false;
                vm.uploadAccMandiriStateError = true;
                $scope.hasUpload = false;
            }
        }));
    }
})();

(function () {
    "use strict";

    angular.module("app.wfh.wfhadmin", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.wfh_wfhadmin", {
            url: "/wfh/wfhadmin",
            views: {
                "content@app": {
                    templateUrl: "app/main/wfh/wfhadmin/wfhadmin.html",
                    controller: "WfhAdminController as vm"
                }
            }
        });

    }

    // function config($stateProvider) {
    //     $stateProvider.state("app.wfhmain", {
    //         url: "/wfh/wfh-main",
    //         views: {
    //             "content@app": {
    //                 templateUrl: "app/main/wfh/wfh-main/wfh-main.html",
    //                 controller: "WfhMainController as vm"
    //             }
    //         }
    //     });

    // }


})();

(function () {
    'use strict';

    angular
        .module('app.wfh.wfhadmin')
        .controller('viewDataActivityAdminController', viewDataActivityAdminController);

    /* @ngInject */
    viewDataActivityAdminController.$inject = [
        '$mdDialog',
        '$http',
        'config',
        'Form',
        'AppAPI',
        'Auth',
        'DataTeam',
        '$mdToast',
        'DataService',
        '$element'
    ];

    function viewDataActivityAdminController(
        $mdDialog,
        $http,
        config,
        Form,
        AppAPI,
        Auth,
        DataTeam,
        $mdToast,
        DataService,
        $element
    ) {
        var vm = this;
        Form.initialForm();

        vm.DataTeam = DataTeam;
        vm.closeModal = closeModal;
        vm.saveData = saveData;
        var WfhFe = AppAPI.Wfhadmin();
        Form.initialForm();
        Form.setObject(WfhFe);
        vm.Form = Form;
        vm.start_date = vm.DataTeam.date;
        vm.end_date = vm.DataTeam.date;
        vm.DataTableActivity = new DataService();

        vm.loadData = loadData;
        vm.loadDependent= loadDependent;

        loadData(1);
        loadDependent();

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            vm.Form.objForm.activity = vm.DataTableActivity.list;
            var promise = Form.saveData('updateCommentActivity', formController, WfhFe);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function loadData(pageno) {
            vm.DataTableActivity.loadData(WfhFe, pageno, {
                action: 'getActivity',
                checking_date: vm.DataTeam.date,
                end_date: vm.DataTeam.date,
                nik: vm.DataTeam.nik
            });
        }

        function dateNow(date) {
            if (date && date != '') {
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
            } else {
                var d = new Date(),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
            }


            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }

        // function loadDependent() {  
        //     vm.DataTableDependents.loadData(WfhFe, pageno, {
        //     action: 'getDependent',
        //     checking_date: vm.DataTeam.date,
        //     nik     : vm.DataTeam.nik
        //     }).then(function () {
        //         vm.initial = true;
        //     }); 
        // }

        function loadDependent() {
            var promises = WfhFe.query({
                action: 'getDependent',
                checking_date: vm.DataTeam.date,
                nik     : vm.DataTeam.nik
            });
            promises.$promise.then(fetchCountTeam);
            promises.$promise.catch(errorFetch);
        }

        function fetchCountTeam(data) {
            console.log(data);
            vm.DataTableDependents =data[0].aData;
            console.log(vm.DataTableDependents);
        }

        function errorFetch() {
            vm.DataTableDependents=[];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.wfh.wfhadmin')
        .controller('UpdateHealthStatuController', UpdateHealthStatuController);

    /* @ngInject */
    UpdateHealthStatuController.$inject = [
        '$mdDialog',
        '$http',
        '$localStorage',
        'config',
        'Form',
        'AppAPI',
        'Auth',
        '$mdToast',
        'DataService',
        '$element'
    ];

    function UpdateHealthStatuController(
        $mdDialog,
        $http,
        $localStorage,
        config,
        Form,
        AppAPI,
        Auth,
        $mdToast,
        DataService,
        $element
    ) {
        var vm = this;

        vm.DataTableDependents = new DataService();

        Form.initialForm();

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        var WfhFe = AppAPI.Wfhadmin();
        Form.initialForm();
        Form.setObject(WfhFe);
        vm.Form = Form;
        vm.loadData = loadData; 
        vm.getEmployee = getEmployee;
        // loadData(1);
        vm.company = $localStorage.empsite;
        vm.selectedItemChanged = selectedItemChanged;
        vm.dateNow=dateNow;

        vm.countCheckedStatus = countCheckedStatus;
        vm.tabChange = tabChange;
        vm.tabIndex = 1;
        vm.initial = false;
        vm.statusHealth = [{
                value: 'fix',
                label: 'fix'
            },
            {
                value: 'unfix',
                label: 'unfix'
            },
            {
                value: 'sick',
                label: 'sick'
            }
        ]

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            vm.Form.objForm.health_status = vm.DataTableDependents.list;
            vm.Form.objForm.index_update_type = vm.tabIndex;
            vm.Form.objForm.date = dateNow(vm.date);
            var promise = Form.saveData('updateHealthStatus', formController, WfhFe);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function loadData(pageno) {
            // console.log(vm.Form.objForm.empno+' / '+vm.date);
            if(vm.Form.objForm.empno !=='undefined' || vm.date !=='undefined')
            {
                var dt=dateNow(vm.date);
                vm.DataTableDependents.loadData(WfhFe, pageno, {
                action: 'getDependent',
                checking_date: dt,
                nik     : vm.Form.objForm.empno
                }).then(function () {
                    vm.initial = true;
                });
            }  
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function countCheckedStatus() {
            var totalMorning = 0;
            var totalAfternoon = 0;
            if (vm.initial) {
                for (var i = 0; i < vm.DataTableDependents.list.length; i++) {
                    if (vm.DataTableDependents.list[i].status) {
                        if (vm.DataTableDependents.list[i].status.morning) {
                            totalMorning += 1;
                        }
                        if (vm.DataTableDependents.list[i].status.afternoon) {
                            totalAfternoon += 1;
                        }
                    }
                }
            }

            return {
                totalMorning: totalMorning,
                totalAfternoon: totalAfternoon
            };
        }

        function dateNow(d) {
            var d = d,
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }

        function tabChange(index) {
            vm.tabIndex = index;
        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/wfhadmin?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

         function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined' && employee != null) {
                // console.log('pertama: ', employee)
                // console.log('kedua: ', employee.empno)
                vm.Form.objForm.empno = employee.empno; 
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;
                loadData(1); 
            }

        }

         
    }
})();

(function () {
    'use strict';

    angular
        .module('app.wfh.wfhadmin')
        .controller('AdminAddActivityController', AdminAddActivityController);

    AdminAddActivityController.$inject = ['$q', '$mdDialog','$localStorage', 'Form', 'AppAPI', '$element', '$log', '$http', 'config', '$mdToast', '$filter'];

    /* @ngInject */
    function AdminAddActivityController ($q, $mdDialog,$localStorage, Form, AppAPI, $element, $log, $http, config, $mdToast, $filter) {
        var vm = this;
        vm.saveData = saveData;
        var WfhFe = AppAPI.Wfhadmin();
        Form.initialForm();
        Form.setObject(WfhFe);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.data = null;
        vm.listdatastemp = [];
        vm.getActivity=getActivity;
        vm.getEmployee = getEmployee;
        vm.dateNow=dateNow;
        vm.company = $localStorage.empsite;

        vm.bu = JSON.parse(localStorage.getItem('ngStorage-empsite'));

        vm.is_setTime = false;

        if (vm.bu == 'PM') {
            vm.is_setTime = true;
        }

        vm.statusProgress = [{
                value: 'hold',
                label: 'Hold'
            },
            {
                value: 'progress',
                label: 'Progress'
            },
            {
                value: 'done',
                label: 'Done'
            }
        ]

        // getActivity();

        vm.listActivity = [
            //     {
            //     'id': null,
            //     'activity_name': '',
            //     'note': '',
            //     'status': 'progress',
            //     'start_time': new Date(),
            //     'end_time': new Date()
            // }
        ];

        vm.listRemove = [];

        vm.addRow = addRow
        vm.removeRow = removeRow

        vm.clearSearch = function () {
            vm.searchProduct = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });


        function addRow() {
            var row = {
                'id': null,
                'activity_name': '',
                'note': '',
                'status': 'progress',
                'start_time': null,
                'end_time': null
            };
            vm.listActivity.push(row)
        }

        function removeRow(data, index) {
            vm.listRemove.push(data);
            vm.listActivity.splice(index, 1);
        }


        function getActivity() {
             console.log(vm.Form.objForm.empno+' / '+vm.date);
            if(vm.Form.objForm.empno !=='undefined' || vm.date !=='undefined')
            {
                var dt=dateNow(vm.date); 
                var response = WfhFe.query({
                    action: 'getActivity',
                      nik : vm.Form.objForm.empno
                }); checking_date: dt,

                response.$promise.then(fetchActivity);
                response.$promise.catch(errorFetchActivity);
            }  

           
        }

        function fetchActivity(data) {
            vm.listActivity = data[0].aData;

            for (var i = 0; i < vm.listActivity.length; i++) {
                vm.listActivity[i].start_time = new Date(vm.listActivity[i].start_time);
                vm.listActivity[i].end_time = new Date(vm.listActivity[i].end_time);
            }

            if (vm.listActivity.length == 0) {
                addRow();
            }
        }

        function errorFetchActivity() {
            vm.listActivity = [];
            if (vm.listActivity.length == 0) {
                addRow();
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {

            var error = 0;
            for (var i = 0; i < vm.listActivity.length; i++) {
                if (!vm.listActivity[i].activity_name || vm.listActivity[i].activity_name == '') {
                    error += 1;
                }
                if (vm.is_setTime) {
                    if (!vm.listActivity[i].start_time || vm.listActivity[i].start_time == '') {
                        error += 1;
                    }

                    if (!vm.listActivity[i].end_time || vm.listActivity[i].end_time == '') {
                        error += 1;
                    }

                }
            }

            if (error == 0) {
                
                vm.Form.objForm.activity = vm.listActivity;
                vm.Form.objForm.activity_delete = vm.listRemove; 
                vm.Form.objForm.nik =vm.nik.empno; 
                var promise = Form.saveData('saveActivity', formController, WfhFe);
                promise.then(function (data) {
                    showDialog(ev, data);
                });
                promise.catch(function (data) {
                    ShowFailed(ev, data)
                });
            } else {
                if (vm.is_setTime) {
                    ShowFailedValidasi(ev, 'Please Check Your Activity. Activity Name, Start - End Time Is required !');
                } else {
                    ShowFailedValidasi(ev, 'Please Check Your Activity. Activity Name Is required !');
                }
            }


        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailedValidasi(ev, data) {

            $mdToast.show(
                $mdToast.simple()
                .textContent(data)
                .position('top right')
                .hideDelay(5000)
                .theme("warn-toast")
            );

        }

        function setTimeStamp(date) {
            if (date == null || date == undefined || date == '') {
                var dataTimeStamp = (new Date().getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            } else {
                var dataTimeStamp = (new Date(date).getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            }
        }

        function dateNow(d) {
            var d = d,
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/wfhadmin?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

         function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined' && employee != null) {
                // console.log('pertama: ', employee)
                // console.log('kedua: ', employee.empno)
                vm.Form.objForm.empno = employee.empno; 
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;
                getActivity(1); 
            }

        }

    }
})();

(function () {
    "use strict";

    angular.module("app.wfh.wfh-main", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.wfh_wfh-main", {
            url: "/wfh/wfh-main",
            views: {
                "content@app": {
                    templateUrl: "app/main/wfh/wfh-main/wfh-main.html",
                    controller: "WfhMainController as vm"
                }
            }
        });

    }

    // function config($stateProvider) {
    //     $stateProvider.state("app.wfhmain", {
    //         url: "/wfh/wfh-main",
    //         views: {
    //             "content@app": {
    //                 templateUrl: "app/main/wfh/wfh-main/wfh-main.html",
    //                 controller: "WfhMainController as vm"
    //             }
    //         }
    //     });

    // }


})();

(function () {
    'use strict';

    angular
        .module('app.wfh.wfh-main')
        .controller('DialogStatusTeamController', DialogStatusTeamController);

    /* @ngInject */
    DialogStatusTeamController.$inject = [
        '$mdDialog',
        '$http',
        'config',
        'Form',
        'AppAPI',
        'Auth',
        'DataTeam',
        '$mdToast',
        'DataService',
        '$element'
    ];

    function DialogStatusTeamController(
        $mdDialog,
        $http,
        config,
        Form,
        AppAPI,
        Auth,
        DataTeam,
        $mdToast,
        DataService,
        $element
    ) {
        var vm = this;
        Form.initialForm();

        vm.DataTeam = DataTeam;
        vm.closeModal = closeModal;
        vm.saveData = saveData;
        var WfhFe = AppAPI.WfhFe();
        Form.initialForm();
        Form.setObject(WfhFe);
        vm.Form = Form;
        vm.start_date = new Date();
        vm.end_date = new Date();
        vm.DataTableActivity = new DataService();

        vm.loadData = loadData;

        loadData(1);

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            vm.Form.objForm.activity = vm.DataTableActivity.list;
            var promise = Form.saveData('updateCommentActivity', formController, WfhFe);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function loadData(pageno) {
            vm.DataTableActivity.loadData(WfhFe, pageno, {
                action: 'getActivity',
                checking_date: dateNow(vm.start_date),
                end_date: dateNow(vm.end_date),
                nik: vm.DataTeam.nik
            });
        }

        function dateNow(date) {
            if (date && date != '') {
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
            } else {
                var d = new Date(),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
            }


            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.wfh.wfh-main')
        .controller('DialogHealthStatuController', DialogHealthStatuController);

    /* @ngInject */
    DialogHealthStatuController.$inject = [
        '$mdDialog',
        '$http',
        'config',
        'Form',
        'AppAPI',
        'Auth',
        '$mdToast',
        'DataService',
        '$element'
    ];

    function DialogHealthStatuController(
        $mdDialog,
        $http,
        config,
        Form,
        AppAPI,
        Auth,
        $mdToast,
        DataService,
        $element
    ) {
        var vm = this;

        vm.DataTableDependents = new DataService();

        Form.initialForm();

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        var WfhFe = AppAPI.WfhFe();
        Form.initialForm();
        Form.setObject(WfhFe);
        vm.Form = Form;
        vm.loadData = loadData;
        loadData(1);

        vm.countCheckedStatus = countCheckedStatus;
        vm.tabChange = tabChange;
        vm.tabIndex = 1;
        vm.initial = false;
        vm.statusHealth = [{
                value: 'fix',
                label: 'fix'
            },
            {
                value: 'unfix',
                label: 'unfix'
            },
            {
                value: 'sick',
                label: 'sick'
            }
        ]

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            vm.Form.objForm.health_status = vm.DataTableDependents.list;
            vm.Form.objForm.index_update_type = vm.tabIndex;
            var promise = Form.saveData('updateHealthStatus', formController, WfhFe);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function loadData(pageno) {
            vm.DataTableDependents.loadData(WfhFe, pageno, {
                action: 'getDependent',
                checking_date: dateNow()
            }).then(function () {
                vm.initial = true;
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function countCheckedStatus() {
            var totalMorning = 0;
            var totalAfternoon = 0;
            if (vm.initial) {
                for (var i = 0; i < vm.DataTableDependents.list.length; i++) {
                    if (vm.DataTableDependents.list[i].status) {
                        if (vm.DataTableDependents.list[i].status.morning) {
                            totalMorning += 1;
                        }
                        if (vm.DataTableDependents.list[i].status.afternoon) {
                            totalAfternoon += 1;
                        }
                    }
                }
            }

            return {
                totalMorning: totalMorning,
                totalAfternoon: totalAfternoon
            };
        }

        function dateNow() {
            var d = new Date(),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }

        function tabChange(index) {
            vm.tabIndex = index;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.wfh.wfh-main')
        .controller('DialogExportDataController', DialogExportDataController);

    /* @ngInject */
    DialogExportDataController.$inject = [
        '$mdDialog',
        '$http',
        'config',
        'Form',
        'AppAPI',
        'Auth',
        '$mdToast',
        'DataService',
        '$element',
        '$location',
        '$window'
    ];

    function DialogExportDataController(
        $mdDialog,
        $http,
        config,
        Form,
        AppAPI,
        Auth,
        $mdToast,
        DataService,
        $element,
        $location,
        $window
    ) {
        var vm = this;

        vm.DataTableDependents = new DataService();

        Form.initialForm();

        vm.closeModal = closeModal;
        vm.exportData = exportData;
        var WfhFe = AppAPI.WfhFe();
        Form.initialForm();
        Form.setObject(WfhFe);
        vm.Form = Form;

        vm.tabIndex = 1;
        vm.initial = false;
        vm.items = ['Health Status', 'Activity'];
        vm.selected = [];
        vm.exportForm = {
            start_date: new Date(),
            end_date: new Date()
        }

        vm.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }

            if (vm.selected.indexOf('Activity') > -1) {
                vm.is_Activity = true;
            } else {
                vm.exportForm = {
                    start_date: new Date(),
                    end_date: new Date()
                }
                vm.is_Activity = false;
            }

            if (vm.selected.indexOf('Health Status') > -1) {
                vm.is_HealtStatus = true;
            } else {
                vm.is_HealtStatus = false;
            }
        };
        vm.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };
        vm.isIndeterminate = function () {
            return (vm.selected.length !== 0 &&
                vm.selected.length !== vm.items.length);
        };
        vm.isChecked = function () {
            return vm.selected.length === vm.items.length;
        };
        vm.toggleAll = function () {
            if (vm.selected.length === vm.items.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.items.slice(0);
            }

            if (vm.selected.indexOf('Activity') > -1) {
                vm.is_Activity = true;
            } else {
                vm.exportForm = {
                    start_date: new Date(),
                    end_date: new Date()
                }
                vm.is_Activity = false;
            }

            if (vm.selected.indexOf('Health Status') > -1) {
                vm.is_HealtStatus = true;
            } else {
                vm.is_HealtStatus = false;
            }

        };

        function closeModal() {
            $mdDialog.hide();
        }

        function exportData() {

            if (!vm.exportForm.end_date) {
                vm.exportForm.end_date = vm.exportForm.start_date;
            }

            if (!vm.exportForm.end_date) {
                vm.exportForm.end_date = vm.exportForm.start_date;
            }

            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/wfhfe/wfhStatusDependentTeamExportExcel/' + dateNow(vm.exportForm.start_date) + '/' + dateNow(vm.exportForm.end_date) + '/' + vm.is_Activity + '/' + vm.is_HealtStatus + '/' + data.token, '_blank');
                closeModal();
            }, function () {
                $window.alert('gagal load token')
            });

        }

        function dateNow(date) {
            if (date && date != '') {
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
            } else {
                var d = new Date(),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
            }


            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.wfh.wfh-main')
        .controller('DialogAddActivityController', DialogAddActivityController);

    DialogAddActivityController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', '$element', '$log', '$http', 'config', '$mdToast', '$filter'];

    /* @ngInject */
    function DialogAddActivityController($q, $mdDialog, Form, AppAPI, $element, $log, $http, config, $mdToast, $filter) {
        var vm = this;
        vm.saveData = saveData;
        var WfhFe = AppAPI.WfhFe();
        Form.initialForm();
        Form.setObject(WfhFe);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.data = null;
        vm.listdatastemp = [];

        vm.bu = JSON.parse(localStorage.getItem('ngStorage-empsite'));

        vm.is_setTime = false;

        if (vm.bu == 'PM') {
            vm.is_setTime = true;
        }

        vm.statusProgress = [{
                value: 'hold',
                label: 'Hold'
            },
            {
                value: 'progress',
                label: 'Progress'
            },
            {
                value: 'done',
                label: 'Done'
            }
        ]

        getActivity();

        vm.listActivity = [
            //     {
            //     'id': null,
            //     'activity_name': '',
            //     'note': '',
            //     'status': 'progress',
            //     'start_time': new Date(),
            //     'end_time': new Date()
            // }
        ];

        vm.listRemove = [];

        vm.addRow = addRow
        vm.removeRow = removeRow

        vm.clearSearch = function () {
            vm.searchProduct = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });


        function addRow() {
            var row = {
                'id': null,
                'activity_name': '',
                'note': '',
                'status': 'progress',
                'start_time': null,
                'end_time': null
            };
            vm.listActivity.push(row)
        }

        function removeRow(data, index) {
            vm.listRemove.push(data);
            vm.listActivity.splice(index, 1);
        }


        function getActivity() {
            var response = WfhFe.query({
                action: 'getActivity',
                checking_date: dateNow()
            });
            response.$promise.then(fetchActivity);
            response.$promise.catch(errorFetchActivity);
        }

        function fetchActivity(data) {
            vm.listActivity = data[0].aData;

            for (var i = 0; i < vm.listActivity.length; i++) {
                vm.listActivity[i].start_time = new Date(vm.listActivity[i].start_time);
                vm.listActivity[i].end_time = new Date(vm.listActivity[i].end_time);
            }

            if (vm.listActivity.length == 0) {
                addRow();
            }
        }

        function errorFetchActivity() {
            vm.listActivity = [];
            if (vm.listActivity.length == 0) {
                addRow();
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {

            var error = 0;
            for (var i = 0; i < vm.listActivity.length; i++) {
                if (!vm.listActivity[i].activity_name || vm.listActivity[i].activity_name == '') {
                    error += 1;
                }
                if (vm.is_setTime) {
                    if (!vm.listActivity[i].start_time || vm.listActivity[i].start_time == '') {
                        error += 1;
                    }

                    if (!vm.listActivity[i].end_time || vm.listActivity[i].end_time == '') {
                        error += 1;
                    }

                }
            }

            if (error == 0) {
                vm.Form.objForm.activity = vm.listActivity;
                vm.Form.objForm.activity_delete = vm.listRemove;
                var promise = Form.saveData('saveActivity', formController, WfhFe);
                promise.then(function (data) {
                    showDialog(ev, data);
                });
                promise.catch(function (data) {
                    ShowFailed(ev, data)
                });
            } else {
                if (vm.is_setTime) {
                    ShowFailedValidasi(ev, 'Please Check Your Activity. Activity Name, Start - End Time Is required !');
                } else {
                    ShowFailedValidasi(ev, 'Please Check Your Activity. Activity Name Is required !');
                }
            }


        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailedValidasi(ev, data) {

            $mdToast.show(
                $mdToast.simple()
                .textContent(data)
                .position('top right')
                .hideDelay(5000)
                .theme("warn-toast")
            );

        }

        function setTimeStamp(date) {
            if (date == null || date == undefined || date == '') {
                var dataTimeStamp = (new Date().getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            } else {
                var dataTimeStamp = (new Date(date).getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            }
        }

        function dateNow() {
            var d = new Date(),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.utility.user.input-user', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.utility_user_input-user', {
                url    : '/utility/user/input-user',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/user/input-user/input-user.html',
                        controller : 'InputuserController as vm'
                    }
                }
            })

        $stateProvider
            .state('app.utility_user_edit-user', {
                url    : '/utility/user/edit-user/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/user/input-user/input-user.html',
                        controller : 'EdituserController as vm'
                    }
                }
            })


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.utility.user.input-user')
        .controller('InputuserController', InputuserController);


    InputuserController.$inject=['$state','$stateParams','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function InputuserController($state,$stateParams,$localStorage,$timeout,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var User=  AppAPI.User();
         var Group=  AppAPI.Group();

         // set constructor form
         Form.setObject(User);

         // set form to controller
         vm.Form = Form;
         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[
                    {link:'app.utility_user',name:'User',active:'0'},
                    {link:'#',name:'Input User',active:'0'}
                    ];

        var response= Group.query({action:'listGroupSelect'});
          response.$promise.then(function(data){
             vm.listGroupSelect=data;
             // console.log(vm.listGroupSelect);
          });
       
        vm.saveData=saveData;
        vm.back=back;
        vm.clearMeesage=clearMeesage;
        vm.reloadToken=reloadToken; 
        // console.log( vm.Form.objForm.menu_id);

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, User);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.utility_user');
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.utility.user.input-user')
        .controller('EdituserController', EdituserController);


    EdituserController.$inject=['$state','$localStorage','$log','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EdituserController($state,$localStorage,$log,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var User=  AppAPI.User();
         var Group=  AppAPI.Group();

         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[
                    {link:'app.utility_user',name:'User',active:'0'},
                    {link:'#',name:'Edit User',active:'0'}
                    ]; 

         // set constructor form
         Form.setObject(User);

         // set form to controller
         vm.Form = Form;

            

      
          vm.Form.objForm.$get({action:'detail',id:$stateParams.id});
       
        vm.saveData=saveData;
        vm.back=back;

        vm.clearMeesage=clearMeesage;


        var response= Group.query({action:'listGroupSelect'});
          response.$promise.then(function(data){
             vm.listGroupSelect=data;
             // console.log(vm.listGroupSelect);
          });

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('update',formController,User,$stateParams.id,'detail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.utility_user');
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.utility.permission.input-action', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.utility_permission_input-action', {
                url    : '/utility/permission/input-action/:menuid',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/permission/input-action/input-action.html',
                        controller : 'InputactionController as vm'
                    }
                }
            })

            


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.utility.permission.input-action')
        .controller('InputactionController', InputactionController);


    InputactionController.$inject=['$stateParams','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function InputactionController($stateParams,$localStorage,$timeout,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Module=  AppAPI.Module();

         // set constructor form
         Form.setObject(Module);

         // set form to controller
         vm.Form = Form;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;
        vm.reloadToken=reloadToken;
        vm.Form.objForm.menu_id=$stateParams.menuid;
        // console.log( vm.Form.objForm.menu_id);

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save_action', formController, Module);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.utility.permission.add-permission', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.utility_permission_add-permission', {
                url    : '/utility/permission/add-permission/:group',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/permission/add-permission/add-permission.html',
                        controller : 'AddpermissionController as vm'
                    }
                }
            })

            


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.utility.permission.add-permission')
        .controller('AddpermissionController', AddpermissionController);


    AddpermissionController.$inject=['$stateParams','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function AddpermissionController($stateParams,$localStorage,$timeout,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Module=  AppAPI.Module();

         // set constructor form
         Form.setObject(Module);

         // set form to controller
         vm.Form = Form;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;
        vm.reloadToken=reloadToken;
        vm.Form.objForm.group=$stateParams.group;
        console.log( vm.Form.objForm.group);

        var res = Module.query({
                        action: 'get_module',
                        groupid:vm.Form.objForm.group
                  });
        res.$promise.then(function(data){
               vm.listModule=data;
               console.log(listModule);
            });
        res.$promise.catch(function(data){
              console.log(data);
        });



        //////////////

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save_action', formController, Module);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.utility.modules.input-modules', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.utility_modules_input-modules', {
                url    : '/utility/modules/input-modules',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/modules/input-modules/input-modules.html',
                        controller : 'InputmodulesController as vm'
                    }
                }
            })
        $stateProvider
            .state('app.utility_modules_edit-modules', {
                url    : '/utility/modules/edit-modules/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/modules/input-modules/input-modules.html',
                        controller : 'EditmodulesController as vm'
                    }
                }
            })

        $stateProvider
            .state('app.utility_modules_modules-action', {
                url    : '/utility/modules/modules-action/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/modules/input-modules/modules-action.html',
                        controller : 'ModulesactionController as vm'
                    }
                }
            })

            


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.utility.modules.input-modules')
        .controller('ModulesactionController', ModulesactionController);


    ModulesactionController.$inject=['$state','$stateParams','$log','$mdDialog','AppAPI','Auth','DataService','Form'];
    /** @ngInject */
    function ModulesactionController($state,$stateParams,$log,$mdDialog,AppAPI,Auth,DataService,Form)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.modulesAction=modulesAction; 
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listModulSelected=[];
        vm.saveData=saveData;
        vm.deleteModul=deleteModul;
        var modulesID=$stateParams.id;

        var Group=AppAPI.Group();
        var Modules=AppAPI.Modules();

        // set constructor form
        Form.setObject(Modules);

        // set form to controller
        vm.Form = Form;
        vm.Form.objForm.modules_id=modulesID;

        vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[ 
                    {link:'app.utility_modules',name:'Modules',active:'0'},
                    {link:'#',name:'Modules Action',active:'0'}
                    ];

        vm.InputAction=InputAction;
        vm.editAction=editAction;
        vm.closeModal=closeModal;

        var response= Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
             vm.listGroupSelect=data;
             // console.log(vm.listGroupSelect);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

        // Data
        loadData(1);
        // Methods

        ////////// 

        // function loadData(pageno){
        //    vm.DataTable.loadData(Modules,pageno,{action:'view_action',modulesID:''});
        //    // console.log('test');
        // }

        function loadData(pageno) {
         var response= Modules.query({action:'view_action',modulesID:modulesID});
        response.$promise.then(function(data){
           vm.list=data;
        });
        response.$promise.catch(function(data){
          console.log(data);
        });

        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 
        function modulesAction(id){
          // console.log(id);
          $state.go('app.utility_modules_modules_action',{id:id});
        }


      function InputAction(ev)
      {
        // console.log('modulesID'); 
        $mdDialog.show({
            controller         : 'ModulesactionController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/utility/modules/input-modules/input-modules-action.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
        });
      }

      function editAction(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditModulesactionController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/utility/modules/input-modules/input-modules-action.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

      function closeModal()
        {
            $mdDialog.hide();
        }

      function clearMeesage() {
          vm.Form.tampilPesan=false;
      }

      function saveData(ev,formController) {
        var res=Auth.setToken();
         res.then(function(){
            var promise= Form.saveData('savemodulesaction', formController, Modules);
            promise.then(function(){
                showDialog(ev);
            });
         });
            
        }

        function showDialog(ev) {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
                loadData(1);
            });
        }

      function deleteModul(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

          $mdDialog.show(confirm).then(function() {
              angular.element.blockUI();
             var response=Modules.delete({action:'deleteaction',data:angular.toJson(vm.listModulSelected)});

             response.$promise.then(loadData(1)); 
             angular.element.blockUI();
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
       });
  
   
    }
    }
})();

(function () 
{
    'use strict';

    angular
        .module('app.utility.modules.input-modules')
        .controller('InputmodulesController', InputmodulesController);


    InputmodulesController.$inject=['$state','$stateParams','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function InputmodulesController($state,$stateParams,$localStorage,$timeout,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Modules=  AppAPI.Modules();

         // set constructor form
         Form.setObject(Modules);

         // set form to controller
         vm.Form = Form;

         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[
                    {link:'app.utility_modules',name:'Modules',active:'0'},
                    {link:'#',name:'Input Modules',active:'0'}
                    ];

       
        vm.saveData=saveData;
        vm.back=back;

        vm.clearMeesage=clearMeesage;
        vm.reloadToken=reloadToken; 
        // console.log( vm.Form.objForm.menu_id);
        // 
        var response= Modules.query({action:'get_menu'});
            response.$promise.then(function(data){
             vm.listMenu=data;
            // console.log(vm.listParent);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });


        function saveData(formController) {
        angular.element.blockUI(); //untuk nampilin loading animation
         var response=Form.saveData('save', formController, Modules);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.utility_modules');
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.utility.modules.input-modules')
        .controller('EditmodulesController', EditmodulesController);


    EditmodulesController.$inject=['$state','$localStorage','$log','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditmodulesController($state,$localStorage,$log,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Modules=  AppAPI.Modules();

         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[
                    {link:'app.utility_modules',name:'Modules',active:'0'},
                    {link:'#',name:'Input Modules',active:'0'}
                    ];

         // set constructor form
         Form.setObject(Modules);

         // set form to controller
         vm.Form = Form;

        var response= Modules.query({action:'get_menu'});
            response.$promise.then(function(data){
             vm.listMenu=data;
            // console.log(vm.listParent);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

      
          vm.Form.objForm.$get({action:'detail',id:$stateParams.id});
       
        vm.saveData=saveData;
        vm.back=back;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('update',formController,Modules,$stateParams.id,'detail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.utility_modules');
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.utility.modules.input-modules')
        .controller('EditModulesactionController', EditModulesactionController);

    /** @ngInject */
    EditModulesactionController.$inject=['$mdDialog','id','AppAPI','Auth','Form'];
    /** @ngInject */
    function EditModulesactionController($mdDialog,id,AppAPI,Auth,Form)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Modules=AppAPI.Modules();

	    // set constructor form
	    Form.setObject(Modules);

	    // set form to controller
	    vm.Form = Form;

        var response=vm.Form.objForm.$get({action:'viewmodulesaction',id:id.id});
         

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
	    vm.setToken=Auth.setToken;

	    vm.messageTheme='pink';


         
	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updateeducation', formController, Modules);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/
        function saveData(ev, formController) {
            var promise= Form.updateData('updatemodulesaction',formController,Modules, Form.objForm.id,'viewmodulesaction');
            promise.then(function(){
	            showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }
    }
    
})();  

(function ()
{
    'use strict';

    angular
        .module('app.utility.modul.input-modul', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.utility_modul_input-modul', {
                url    : '/utility/modul/input-modul',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/modul/input-modul/input-modul.html',
                        controller : 'InputmodulController as vm'
                    }
                }
            })
        $stateProvider
            .state('app.utility_modul_edit-modul', {
                url    : '/utility/modul/edit-modul/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/modul/input-modul/input-modul.html',
                        controller : 'EditmodulController as vm'
                    }
                }
            })

            


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.utility.modul.input-modul')
        .controller('InputmodulController', InputmodulController);


    InputmodulController.$inject=['$state','$stateParams','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function InputmodulController($state,$stateParams,$localStorage,$timeout,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Module=  AppAPI.Module();

         // set constructor form
         Form.setObject(Module);

         // set form to controller
         vm.Form = Form;

         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[
                    {link:'app.utility_modul',name:'Module',active:'0'},
                    {link:'#',name:'Input Module',active:'0'}
                    ];

       
        vm.saveData=saveData;
        vm.back=back;

        vm.clearMeesage=clearMeesage;
        vm.reloadToken=reloadToken;
        vm.Form.objForm.link='-';
        vm.Form.objForm.icon='-';
        vm.Form.objForm.type='menu';
        vm.Form.objForm.link_parent='-';
        vm.Form.objForm.state='-';
        vm.Form.objForm.collapse='-';
        // console.log( vm.Form.objForm.menu_id);
        // 
        var response= Module.query({action:'get_parent'});
            response.$promise.then(function(data){
             vm.listParent=data;
            // console.log(vm.listParent);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });


        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Module);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.utility_modul');
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.utility.modul.input-modul')
        .controller('EditmodulController', EditmodulController);


    EditmodulController.$inject=['$state','$localStorage','$log','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditmodulController($state,$localStorage,$log,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Module=  AppAPI.Module();

         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[
                    {link:'app.utility_modul',name:'Module',active:'0'},
                    {link:'#',name:'Input Module',active:'0'}
                    ];

         // set constructor form
         Form.setObject(Module);

         // set form to controller
         vm.Form = Form;

           var response= Module.query({action:'get_parent'});
            response.$promise.then(function(data){
             vm.listParent=data;
            // console.log(vm.listParent);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

      
          vm.Form.objForm.$get({action:'detail',id:$stateParams.id});
       
        vm.saveData=saveData;
        vm.back=back;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('update',formController,Module,$stateParams.id,'detail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.utility_modul');
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.utility.menu.input-menu', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.utility_menu_input-menu', {
                url    : '/utility/menu/input-menu',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/menu/input-menu/input-menu.html',
                        controller : 'InputmenuController as vm'
                    }
                }
            })
        $stateProvider
            .state('app.utility_menu_edit-menu', {
                url    : '/utility/menu/edit-menu/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/menu/input-menu/input-menu.html',
                        controller : 'EditmenuController as vm'
                    }
                }
            })

            


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.utility.menu.input-menu')
        .controller('InputmenuController', InputmenuController);


    InputmenuController.$inject=['$state','$stateParams','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function InputmenuController($state,$stateParams,$localStorage,$timeout,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Menu=  AppAPI.Menu();

         // set constructor form
         Form.setObject(Menu);

         // set form to controller
         vm.Form = Form;
         vm.Form.objForm.hassub=false;
         vm.Form.objForm.group=false;

         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[
                    {link:'app.utility_modul',name:'Menu',active:'0'},
                    {link:'#',name:'Input Menu',active:'0'}
                    ];

       
        vm.saveData=saveData;
        vm.back=back;

        vm.clearMeesage=clearMeesage;
        vm.reloadToken=reloadToken;
        
        var response= Menu.query({action:'get_parent'});
            response.$promise.then(function(data){
             vm.listParent=data;
            // console.log(vm.listParent);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });


        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Menu);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.utility_menu');
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.utility.menu.input-menu')
        .controller('EditmenuController', EditmenuController);


    EditmenuController.$inject=['$state','$localStorage','$log','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditmenuController($state,$localStorage,$log,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Menu=  AppAPI.Menu();

         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[
                    {link:'app.utility_menu',name:'Menu',active:'0'},
                    {link:'#',name:'Input Menu',active:'0'}
                    ];

         // set constructor form
         Form.setObject(Menu);

         // set form to controller
         vm.Form = Form;

           var response= Menu.query({action:'get_parent'});
            response.$promise.then(function(data){
             vm.listParent=data;
            // console.log(vm.listParent);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

      
          vm.Form.objForm.$get({action:'detail',id:$stateParams.id});
       
        vm.saveData=saveData;
        vm.back=back;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('update',formController,Menu,$stateParams.id,'detail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.utility_menu');
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.ta.passwordecheckin.input-password-echeckin', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State 
    $stateProvider
        .state('app.ta_passwordecheckin_input-password-echeckin', {
            url    : '/ta/passwordecheckin/input-password-echeckin',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/ta/passwordecheckin/input-password-echeckin/input-password-echeckin.html',
                    controller : 'InputpasswordecheckinController as vm'
                }
            }
        })

    $stateProvider
        .state('app.ta_passwordecheckin_edit-password-echeckin', {
            url    : '/ta/passwordecheckin/edit-password-echeckin/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/ta/passwordecheckin/input-password-echeckin/input-password-echeckin.html',
                    controller : 'EditpasswordecheckinController as vm'
                }
            }
        })
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.ta.passwordecheckin.input-password-echeckin')
        .controller('InputpasswordecheckinController', InputpasswordecheckinController);


    InputpasswordecheckinController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputpasswordecheckinController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var EcheckinPass=  AppAPI.EcheckinPass();

         // set constructor form
         Form.setObject(EcheckinPass);

         // set form to controller
         vm.Form = Form;

        vm.title = ['Mr','Mrs','Miss','Ms'];
        vm.jenkel = ['L','P'];
        vm.stat = false;
       
        vm.saveData=saveData;
        vm.setJenisKelamin = setJenisKelamin;
        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            // angular.element.blockUI();
            var str = vm.fullname;
            var words = str.split(" ");
            
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            if (words.length >= 3) {
                vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                vm.Form.objForm.middleName = words[1].replace(/\s/g, '');
                vm.Form.objForm.lastName = str.substring(words[0].length+words[1].length);
            } else if (words.length == 2) {
                vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                vm.Form.objForm.middleName = null;
                vm.Form.objForm.lastName = words[1].replace(/\s/g, '');
            } else {
                vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                vm.Form.objForm.middleName = null;
                vm.Form.objForm.lastName = null;
            }

            // console.log(vm.Form.objForm.firstName);
            // console.log(vm.Form.objForm.middleName);
            // console.log(vm.Form.objForm.lastName);

         var response=Form.saveData('save', formController, EcheckinPass); 
         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function setJenisKelamin() {
            var type = vm.Form.objForm.title;
            switch(type) {
                case 'Mr':
                    vm.Form.objForm.jenkel = 'L';
                    vm.jenkelReadOnly = 'true';
                    break;
                case 'Mrs':
                case 'Miss':
                case 'Ms':
                    vm.Form.objForm.jenkel = 'P';
                    vm.jenkelReadOnly = 'true';
                    break;
                default:
                    vm.Form.objForm.jenkel = null;
                    vm.jenkelReadOnly = 'false';
                    break;
            }

        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.ta.passwordecheckin.input-password-echeckin')
        .controller('EditpasswordecheckinController', EditpasswordecheckinController);


    EditpasswordecheckinController.$inject=['$state','$localStorage','$log','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditpasswordecheckinController($state,$localStorage,$log,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var EcheckinPass =  AppAPI.EcheckinPass();

         vm.Breadhome="app.ta";
         vm.Breadlist=[
                    {link:'app.ta',name:'TA',active:'0'},
                    {link:'#',name:'Edit Password-Echeckin',active:'0'}
                    ];

         // set constructor form
         Form.setObject(EcheckinPass);

         // set form to controller
         vm.Form = Form;
         vm.title = ['Mr','Mrs','Miss','Ms'];
         vm.jenkel = ['L','P'];
         vm.stat = true;

        var resp=vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
        resp.then(setData)
       
        vm.saveData=saveData;
        vm.setJenisKelamin = setJenisKelamin;

        vm.back=back;
        vm.jenkelReadOnly = 'true';

        vm.clearMeesage=clearMeesage;

        function setData(data)
        {
            vm.Form.objForm.ktpOld=data.noktp;
            // console.log(data);
            if ((data.lastName == null && data.middleName == null) || (data.lastName == '' && data.middleName == '')) {
                vm.fullname = data.firstName;
            } else if (data.middleName == null || data.middleName == '') {
                vm.fullname = data.firstName+' '+data.lastName;
            } else {
                vm.fullname = data.firstName+' '+data.middleName+' '+data.lastName;
            }
            if(data.nationality == null) {
                data.nationality = '';
            }
        }

        function saveData(formController) {
            angular.element.blockUI();
            var str = vm.fullname;
            var words = str.split(" ");
            
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            if (words.length >= 3) {
                vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                vm.Form.objForm.middleName = words[1].replace(/\s/g, '');
                vm.Form.objForm.lastName = str.substring(words[0].length+words[1].length);
            } else if (words.length == 2) {
                vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                vm.Form.objForm.middleName = null;
                vm.Form.objForm.lastName = words[1].replace(/\s/g, '');
            } else {
                vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                vm.Form.objForm.middleName = null;
                vm.Form.objForm.lastName = null;
            }
            var response=Form.updateData('update',formController,EcheckinPass,vm.Form.objForm.noktp,'viewdetail');

            response.then(function() {
                vm.messageTheme='blue';
                angular.element.unblockUI();
                formController.$setPristine();
                $timeout(function() {
                
                    vm.Form.tampilPesan=false;
                
                }, 3000);
            });

            response.catch(function() {
                vm.messageTheme='pink';
                angular.element.unblockUI();
            });
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.utility_menu');
        }

        function setJenisKelamin() {
            var type = vm.Form.objForm.title;
            switch(type) {
                case 'Mr':
                    vm.Form.objForm.jenkel = 'L';
                    vm.jenkelReadOnly = 'true';
                    break;
                case 'Mrs':
                case 'Miss':
                case 'Ms':
                    vm.Form.objForm.jenkel = 'P';
                    vm.jenkelReadOnly = 'true';
                    break;
                default:
                    vm.Form.objForm.jenkel = null;
                    vm.jenkelReadOnly = 'false';
                    break;
            }

        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.ta.echeckin-list', [])
        .config(config);

         config.$inject=['$stateProvider'];

    /** @ngInject */
   /** @ngInject */
   function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.ta_echeckin_list', {
                url    : '/ta/echeckin-list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/ta/echeckin-list/echeckin-list.html',
                        controller : 'EcheckinListController as vm'
                    }
                }
            });




    }
})();

(function() {
  'use strict';

  angular.module('app.ta.echeckin-list').controller('ViewPhotoController', ViewPhotoController);

  ViewPhotoController.$inject = [
    '$localStorage',
    '$http',
    '$location',
    '$window',
    '$stateParams',
    '$document',
    '$mdDialog',
    'Auth',
    'Form',
    'AppAPI',
    'DTColumnDefBuilder',
    'Echeckin',
    'config',
    'id'
  ];

  /* @ngInject */
  function ViewPhotoController(
    $localStorage,
    $http,
    $location,
    $window,
    $stateParams,
    $document,
    $mdDialog,
    Auth,
    Form,
    AppAPI,
    DTColumnDefBuilder,
    Echeckin,
    config,
    id
  ) {
    var vm = this;

    vm.id = id;
    vm.closeModal = closeModal;
    vm.downloadDoc = downloadDoc;
    vm.stateview = false;

    // var Document = AppAPI.Document();

    loadDataNpwp();

    function activate() {
      // loadDataNpwp();
    }

    function loadDataNpwp() {
      /* var npwp = Document.query({
        action: 'viewData',
        emp_id: id.user_id,
        type: 'ktp'
      });

      npwp.$promise.then(function(data) {
        // console.log(data);
        if (data.length > 0) {
          vm.stateview = true; */
          vm.doc = id.photo_address;
          if (vm.doc.slice(-3) === 'pdf') {
            vm.doc_type = true;
            vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
          } else {
            vm.doc_type = false;
          }
        /* } else {
          vm.stateview = false;
        } */
      // });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function downloadDoc(ev) {
      var name = vm.doc;
      // console.log(link);
      if (name !== null && name !== '-') {
        $http({
          method: 'GET',
          url: config.api + 'api/empdocument/' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        })
          .success(function(data, status, headers) {
            headers = headers();
            // console.log(data);
            var filename = name;
            var contentType = headers['content-type'];

            var linkElement = document.createElement('a');
            try {
              var blob = new Blob([data], { type: contentType });
              var url = window.URL.createObjectURL(blob);

              linkElement.setAttribute('href', url);
              linkElement.setAttribute('download', filename);

              var clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false
              });
              linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
              console.log(ex);
            }
          })
          .error(function(data) {
            console.log(data);
          });
      } else {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Document Not Found')
              .textContent('Document not Found')
              .ariaLabel('Failed Save Data')
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            // closeModal();
          });
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.ta.echeckin-list').controller('ViewNpwpController', ViewNpwpController);

  ViewNpwpController.$inject = [
    '$localStorage',
    '$http',
    '$location',
    '$window',
    '$stateParams',
    '$document',
    '$mdDialog',
    'Auth',
    'Form',
    'AppAPI',
    'DTColumnDefBuilder',
    'Echeckin',
    'config',
    'id'
  ];

  /* @ngInject */
  function ViewNpwpController(
    $localStorage,
    $http,
    $location,
    $window,
    $stateParams,
    $document,
    $mdDialog,
    Auth,
    Form,
    AppAPI,
    DTColumnDefBuilder,
    Echeckin,
    config,
    id
  ) {
    var vm = this;

    vm.closeModal = closeModal;
    vm.downloadDoc = downloadDoc;

    var Document = AppAPI.Document();

    activate();

    function activate() {
      loadDataNpwp();
    }

    function loadDataNpwp() {
      var npwp = Document.query({
        action: 'viewData',
        emp_id: id.user_id,
        type: 'npwp'
      });

      npwp.$promise.then(function(data) {
        console.log(data);
        if (data.length > 0) {
          vm.stateview = true;
          vm.doc = data[0].link;
          if (vm.doc.slice(-3) === 'pdf') {
            vm.doc_type = true;
            vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
          } else {
            vm.doc_type = false;
          }
        } else {
          vm.stateview = false;
        }
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function downloadDoc(ev) {
      var name = vm.doc;
      // console.log(link);
      if (name !== null && name !== '-') {
        $http({
          method: 'GET',
          url: config.api + 'api/empdocument/' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        })
          .success(function(data, status, headers) {
            headers = headers();
            // console.log(data);
            var filename = name;
            var contentType = headers['content-type'];

            var linkElement = document.createElement('a');
            try {
              var blob = new Blob([data], { type: contentType });
              var url = window.URL.createObjectURL(blob);

              linkElement.setAttribute('href', url);
              linkElement.setAttribute('download', filename);

              var clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false
              });
              linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
              console.log(ex);
            }
          })
          .error(function(data) {
            console.log(data);
          });
      } else {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Document Not Found')
              .textContent('Document not Found')
              .ariaLabel('Failed Save Data')
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            // closeModal();
          });
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.ta.echeckin-list').controller('ViewKtpController', ViewKtpController);

  ViewKtpController.$inject = [
    '$localStorage',
    '$http',
    '$location',
    '$window',
    '$stateParams',
    '$document',
    '$mdDialog',
    'Auth',
    'Form',
    'AppAPI',
    'DTColumnDefBuilder',
    'Echeckin',
    'config',
    'id'
  ];

  /* @ngInject */
  function ViewKtpController(
    $localStorage,
    $http,
    $location,
    $window,
    $stateParams,
    $document,
    $mdDialog,
    Auth,
    Form,
    AppAPI,
    DTColumnDefBuilder,
    Echeckin,
    config,
    id
  ) {
    var vm = this;

    vm.closeModal = closeModal;
    vm.downloadDoc = downloadDoc;
    vm.stateview = false;

    var Document = AppAPI.Document();

    activate();

    function activate() {
      loadDataNpwp();
    }

    function loadDataNpwp() {
      var npwp = Document.query({
        action: 'viewData',
        emp_id: id.user_id,
        type: 'ktp'
      });

      npwp.$promise.then(function(data) {
        console.log(data);
        if (data.length > 0) {
          vm.stateview = true;
          vm.doc = data[0].link;
          if (vm.doc.slice(-3) === 'pdf') {
            vm.doc_type = true;
            vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
          } else {
            vm.doc_type = false;
          }
        } else {
          vm.stateview = false;
        }
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function downloadDoc(ev) {
      var name = vm.doc;
      // console.log(link);
      if (name !== null && name !== '-') {
        $http({
          method: 'GET',
          url: config.api + 'api/empdocument/' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        })
          .success(function(data, status, headers) {
            headers = headers();
            // console.log(data);
            var filename = name;
            var contentType = headers['content-type'];

            var linkElement = document.createElement('a');
            try {
              var blob = new Blob([data], { type: contentType });
              var url = window.URL.createObjectURL(blob);

              linkElement.setAttribute('href', url);
              linkElement.setAttribute('download', filename);

              var clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false
              });
              linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
              console.log(ex);
            }
          })
          .error(function(data) {
            console.log(data);
          });
      } else {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Document Not Found')
              .textContent('Document not Found')
              .ariaLabel('Failed Save Data')
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            // closeModal();
          });
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.ta.echeckin-list').controller('ViewJamsostekController', ViewJamsostekController);

  ViewJamsostekController.$inject = [
    '$localStorage',
    '$http',
    '$location',
    '$window',
    '$stateParams',
    '$document',
    '$mdDialog',
    'Auth',
    'Form',
    'AppAPI',
    'DTColumnDefBuilder',
    'Echeckin',
    'config',
    'id'
  ];

  /* @ngInject */
  function ViewJamsostekController(
    $localStorage,
    $http,
    $location,
    $window,
    $stateParams,
    $document,
    $mdDialog,
    Auth,
    Form,
    AppAPI,
    DTColumnDefBuilder,
    Echeckin,
    config,
    id
  ) {
    var vm = this;

    vm.closeModal = closeModal;
    vm.downloadDoc = downloadDoc;

    var Document = AppAPI.Document();

    activate();

    function activate() {
      loadData();
    }

    function loadData() {
      var npwp = Document.query({
        action: 'viewData',
        emp_id: id.user_id,
        type: 'jamsostek'
      });

      npwp.$promise.then(function(data) {
        console.log(data)
        if (data.length > 0) {
          vm.stateview = true;
          vm.doc = data[0].link;
          if (vm.doc.slice(-3) === 'pdf') {
            vm.doc_type = true;
            vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
          } else {
            vm.doc_type = false;
          }
        } else {
          vm.stateview = false;
        }
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function downloadDoc(ev) {
      var name = vm.doc;
      
      if (name !== null && name !== '-') {
        $http({
          method: 'GET',
          url: config.api + 'api/empdocument/' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        })
          .success(function(data, status, headers) {
            headers = headers();
            
            var filename = name;
            var contentType = headers['content-type'];

            var linkElement = document.createElement('a');
            try {
              var blob = new Blob([data], { type: contentType });
              var url = window.URL.createObjectURL(blob);

              linkElement.setAttribute('href', url);
              linkElement.setAttribute('download', filename);

              var clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false
              });
              linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
              console.log(ex);
            }
          })
          .error(function(data) {
            console.log(data);
          });
      } else {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Document Not Found')
              .textContent('Document not Found')
              .ariaLabel('Failed Save Data')
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            // closeModal();
          });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
      .module('app.ta.echeckin-list')
      .controller('ViewDocController', ViewDocController);

  ViewDocController.$inject = ['$localStorage','$http','$location','$window','$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','Echeckin','config','img'];

  /* @ngInject */
  function ViewDocController($localStorage,$http,$location,$window,$stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,Echeckin,config,img) {
      var vm = this;

      vm.closeModal = closeModal;
      vm.downloadDoc = downloadDoc;

      function closeModal()
      {
          $mdDialog.hide();
      }

      loadImage();

      function loadImage()
      {
          vm.doc = img;
          if (vm.doc.slice(-3) === 'pdf') {
              vm.doc_type = true;
          } else {
              vm.doc_type = false;
          }
          vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
      }

      function downloadDoc(ev)
      {
          var name=vm.doc;
          // console.log(link);
          if(name !==null && name !=='-')
          {
              $http({
                  method: 'GET',
                  url: config.api+'api/empdocument/'+name,
                  params: { name: name },
                  responseType: 'arraybuffer'
              }).success(function (data, status, headers) {
                  headers = headers();
                  // console.log(data);
                  var filename = name;
                  var contentType = headers['content-type'];

                  var linkElement = document.createElement('a');
                  try {
                      var blob = new Blob([data], { type: contentType });
                      var url = window.URL.createObjectURL(blob);

                      linkElement.setAttribute('href', url);
                      linkElement.setAttribute("download", filename);

                      var clickEvent = new MouseEvent("click", {
                          "view": window,
                          "bubbles": true,
                          "cancelable": false
                      });
                      linkElement.dispatchEvent(clickEvent);
                  } catch (ex) {
                      console.log(ex);
                  }
              }).error(function (data) {
                  console.log(data);
              });
          } else {
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Document Not Found')
              .textContent('Document not Found')
              .ariaLabel('Failed Save Data')
              .ok('OK')
              .targetEvent(ev)
              ).then(function(){
                  // closeModal();
              });
          }
      }
  }
})();

(function () 
{
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('TrainingDetailController', TrainingDetailController);

    TrainingDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','id'];
    /** @ngInject */
    function TrainingDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,id)
    {
        var vm = this;
        var Training = AppAPI.Training(); 

        vm.closeModal = closeModal;
        vm.name = id.title+' '+id.firstName;

        vm.listData=[];
        
        viewData();

        function viewData() {
           angular.element.blockUI();
           var dataPromise = Training.query({action:'viewData',emp_id:id.user_id});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }
        
        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('TaxDetailController', TaxDetailController);

    TaxDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','id'];
    /** @ngInject */
    function TaxDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,id)
    {
        var vm = this;
        var Tax = AppAPI.Tax(); 
        var Document = AppAPI.Document(); 

        vm.closeModal = closeModal;
        vm.name = id.title+' '+id.firstName;
        vm.downloadDoc = downloadDoc;

        Form.initialForm();
        Form.setObject(Tax);
        vm.Form = Form;
        
        var response=vm.Form.objForm.$get({action:'viewTax',id:id.user_id});
        response.then(changeDate);

        function changeDate(data) {
            if(data.taxNumber == '-') {
                vm.optionNpwp = '0';
            } else if (!data.taxNumber) {
                vm.optionNpwp = null;
            } else {
                vm.optionNpwp = '1';
                loadDocument();
            }
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadDocument() {

            var npwp = Document.query({
                action: 'viewData',
                emp_id: id.user_id,
                type: 'npwp'
            });

            npwp.$promise.then(function(data) {
                if (data.length > 0) {
                    vm.stateview = true;
                    vm.doc = data[0].link;
                    vm.url = 'api/empdocument/'+vm.doc;
                    if (vm.doc.slice(-3) === 'pdf') {
                        vm.doc_type = true;
                        vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
                    } else {
                        vm.doc_type = false;
                    }
                } else {
                    vm.stateview = false;
                }
            });
        }

        function downloadDoc(ev) {
            var img = vm.doc;
            
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/empdocument/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                })
                .success(function(data, status, headers) {
                    console.log(data)
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                      var blob = new Blob([data], { type: contentType });
                      var url = window.URL.createObjectURL(blob);

                      linkElement.setAttribute('href', url);
                      linkElement.setAttribute('download', filename);

                      var clickEvent = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: false
                      });
                      linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                      console.log(ex);
                    }
                })
                .error(function(data) {
                        console.log(data);
                });
            } else {
                $mdDialog
                    .show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('#contentDialog')))
                      .clickOutsideToClose(true)
                      .title('Document Not Found')
                      .textContent('Document not Found')
                      .ariaLabel('Failed Save Data')
                      .ok('OK')
                      .targetEvent(ev)
                    )
                    .then(function() {
                        // closeModal();
                    });
            }
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('LanguageDetailController', LanguageDetailController);

    LanguageDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','id'];
    /** @ngInject */
    function LanguageDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,id)
    {
        var vm = this;
        var Language = AppAPI.Language(); 

        vm.closeModal = closeModal;
        vm.name = id.title+' '+id.firstName;

        vm.listData=[];
        
        viewData();

        function viewData() {
           angular.element.blockUI();
           var dataPromise = Language.query({action:'viewData',emp_id:id.user_id});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }
        
        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('ExperiencesDetailController', ExperiencesDetailController);

    ExperiencesDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','id'];
    /** @ngInject */
    function ExperiencesDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,id)
    {
        var vm = this;
        var Experience = AppAPI.Experience(); 

        vm.closeModal = closeModal;
        vm.name = id.title+' '+id.firstName;

        vm.listData=[];
        
        viewData();

        function viewData() {
           angular.element.blockUI();
           var dataPromise = Experience.query({action:'viewData',emp_id:id.user_id});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }
        
        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('EmergencyDetailController', EmergencyDetailController);

    EmergencyDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','id'];
    /** @ngInject */
    function EmergencyDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,id)
    {
        var vm = this;
        var Emergency = AppAPI.Emergency(); 

        vm.closeModal = closeModal;
        vm.name = id.title+' '+id.firstName;

        vm.listData=[];
        
        viewData();

        function viewData() {
           angular.element.blockUI();
           var dataPromise = Emergency.query({action:'viewData',emp_id:id.user_id});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }
        
        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('EducationDetailController', EducationDetailController);

    EducationDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','id'];
    /** @ngInject */
    function EducationDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,id)
    {
        var vm = this;
        var Education = AppAPI.Education();

        vm.closeModal = closeModal;
        vm.name = id.title+' '+id.firstName;
        vm.viewDokumen = viewDokumen;

        vm.listData=[];
        vm.listIjazah=[];

        viewData();

        function viewData() {
           angular.element.blockUI();
           var dataPromise = Education.query({action:'viewData',emp_id:id.user_id});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            angular.element.unblockUI();
            vm.listData = data[0].data;
            vm.ijazah = data[0].ijazah;
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function viewDokumen(ev, img)
        {
            $mdDialog.show({
                multiple : true,
                controller         : 'ViewDocController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ta/echeckin-list/details/view-document.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                locals:{
                  img: img
                }
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('DependentDetailController', DependentDetailController);

    DependentDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','id'];
    /** @ngInject */
    function DependentDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,id)
    {
        var vm = this;
        var Dependents = AppAPI.Dependents();

        vm.closeModal = closeModal;
        vm.name = id.title+' '+id.firstName;
        vm.viewDokumen = viewDokumen;

        vm.listData=[];
        vm.listIjazah=[];

        viewData();

        function viewData() {
           angular.element.blockUI();
           var dataPromise = Dependents.query({action:'viewData',emp_id:id.user_id});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            angular.element.unblockUI();
            vm.listData = data[0].data;
            vm.doc=data[0].kk;
            vm.status=data[0].status;
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function viewDokumen(ev)
        {
            $mdDialog.show({
                multiple : true,
                controller         : 'ViewDocController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ta/echeckin-list/details/view-document.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                locals:{
                  img: vm.doc
                }
            });
        }

    }
})();

(function () 
{
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('CertificateDetailController', CertificateDetailController);

    CertificateDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','id'];
    /** @ngInject */
    function CertificateDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,id)
    {
        var vm = this;
        var Education = AppAPI.Education(); 

        vm.closeModal = closeModal;
        vm.name = id.title+' '+id.firstName;
        vm.downloadDoc = downloadDoc;

        vm.listData=[];
        vm.doc_type=false;
        
        viewData();

        function viewData() {
           angular.element.blockUI();
           var dataPromise = Education.query({action:'viewData',emp_id:id.user_id});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            angular.element.unblockUI();
            vm.ijazah = data[0].ijazah;
            if (vm.ijazah.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = 'api/empdocument/'+data[0].ijazah+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
            console.log(vm.url);
            console.log(vm.doc_type);
        }
        
        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function downloadDoc(ev)
        {
            var name=vm.ijazah;
            // console.log(link);
            if(name !==null && name !=='-')
            {
                $http({
                    method: 'GET',
                    url: config.api+'api/empdocument/'+name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];
             
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);
             
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
             
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Document Not Found')
                .textContent('Document not Found')
                .ariaLabel('Failed Save Data')
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    // closeModal();
                });
            }
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('BankDetailController', BankDetailController);

    BankDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','id'];
    /** @ngInject */
    function BankDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,id)
    {
        var vm = this;
        var Bank = AppAPI.Bank();
        var Document = AppAPI.Document();  
        Form.initialForm();
        Form.setObject(Bank);
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.name = id.title+' '+id.firstName;

        var response=vm.Form.objForm.$get({action:'viewBank',id:id.user_id});
        response.then(changeDate);
        function changeDate(data) {
            if(data.link!=null && data.link!='-')
            {
                loadDocument();
            }
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadDocument() 
        { 
            var bank = Document.query({
                action: 'viewData',
                emp_id: id.user_id,
                type: 'mandiri'
            });

            bank.$promise.then(function(data) {
                // console.log(data);
                if (data.length > 0) {
                    vm.stateview = true;
                    vm.doc = data[0].link;
                    vm.url = 'api/empdocument/'+vm.doc;
                    if (vm.doc.slice(-3) === 'pdf') {
                        vm.doc_type = true;
                        vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
                    } else {
                        vm.doc_type = false;
                    }
                } else {
                    vm.stateview = false;
                }
            });
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/empdocument/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                })
                .success(function(data, status, headers) {
                    // console.log(data)
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                      var blob = new Blob([data], { type: contentType });
                      var url = window.URL.createObjectURL(blob);

                      linkElement.setAttribute('href', url);
                      linkElement.setAttribute('download', filename);

                      var clickEvent = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: false
                      });
                      linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                      console.log(ex);
                    }
                })
                .error(function(data) {
                        console.log(data);
                });
            } else {
                $mdDialog
                    .show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('#contentDialog')))
                      .clickOutsideToClose(true)
                      .title('Document Not Found')
                      .textContent('Document not Found')
                      .ariaLabel('Failed Save Data')
                      .ok('OK')
                      .targetEvent(ev)
                    )
                    .then(function() {
                        // closeModal();
                    });
            }
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('OtherdocumentDetailController', OtherdocumentDetailController);

    OtherdocumentDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','id'];
    /** @ngInject */
    function OtherdocumentDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,id)
    {
        var vm = this;
        var Document = AppAPI.Document();

        vm.closeModal = closeModal;
        vm.name = id.title+' '+id.firstName;
        vm.viewDokumen = viewDokumen;

        vm.listData=[];

        viewData();

        function viewData() {
           angular.element.blockUI();
           var dataPromise = Document.query({action:'viewData',emp_id:id.user_id,type:'ktp'});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            console.log(data);
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function viewDokumen(ev, img)
        {
            $mdDialog.show({
                controller         : 'ViewDocController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ta/echeckin-list/details/view-document.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                },
                locals:{
                  img:img
                }
            });
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();

(function () {
    "use strict";

    angular.module("app.report.jic.sk_tetap", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.jic.sk_tetap", {
            url: "/sk-tetap",
            views: {
                jicReport: {
                    templateUrl: "app/main/report/jic/sk-tetap/sk-tetap.html",
                    controller: "JicReportTetapPrintController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.jic.sk_tetap")
        .controller("JicReportPromosiTetapPrintController", Controller);

    Controller.$inject = ["$stateParams", "$timeout", "$window", "$localStorage"];

    /* @ngInject */
    function Controller($stateParams, $timeout, $window, $localStorage) {
        var vm = this;
        activate();

        vm.item = {
            "id": 1,
            "month": 12,
            "year": 2018,
            "name": "CHOERUL UMAM",
            "nik": "17000010",
            "position": "WEB DEVELOPER",
            "grade": "A3",
            "location": "Bandung",
            "effective_date": "01-01-2019",
            "approved_by": "SUHENDRA"
        }

        function activate() {
            console.log('sk_tetap');
            $timeout(function () {
                $window.print();
            }, 2000);
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.report.jic.sk_promosi_lulus", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.jic.sk_promosi_lulus", {
            url: "/sk-promosi-lulus",
            views: {
                jicReport: {
                    templateUrl: "app/main/report/jic/sk-promosi-lulus/sk-promosi-lulus.html",
                    controller: "JicReportPromosiLulusPrintController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.jic.sk_promosi_lulus")
        .controller("JicReportPromosiLulusPrintController", Controller);

    Controller.$inject = ["$stateParams", "$timeout", "$window", "$localStorage"];

    /* @ngInject */
    function Controller($stateParams, $timeout, $window, $localStorage) {
        var vm = this;
        activate();

        vm.item = {
            "id": 1,
            "month": 12,
            "year": 2018,
            "name": "CHOERUL UMAM",
            "nik": "17000010",
            "new_position": "WEB DEVELOPER",
            "original_org_unit": "KSNI",
            "new_grade": "A3",
            "effective_date": "01-01-2019",
            "approved_by": "SUHENDRA",
            "end_date": "02-02-2019"
        }

        function activate() {
            console.log('sk_promosi_lulus');
            $timeout(function () {
                $window.print();
            }, 2000);
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.report.jic.sk_promosi_lanjutan", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.jic.sk_promosi_lanjutan", {
            url: "/sk-promosi-lanjutan",
            views: {
                jicReport: {
                    templateUrl: "app/main/report/jic/sk-promosi-lanjutan/sk-promosi-lanjutan.html",
                    controller: "JicReportPromosiLanjutanPrintController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.jic.sk_promosi_lanjutan")
        .controller("JicReportPromosiLanjutanPrintController", Controller);

    Controller.$inject = ["$stateParams", "$timeout", "$window", "$localStorage"];

    /* @ngInject */
    function Controller($stateParams, $timeout, $window, $localStorage) {
        var vm = this;
        vm.item = {
            "id": 1,
            "month": 12,
            "year": 2018,
            "name": "CHOERUL UMAM",
            "nik": "17000010",
            "original_org_unit": "KSNI",
            "new_position": "WEB DEVELOPER",
            "new_grade": "A3",
            "target_grade": "B3",
            "final_grade": "D3",
            "effective_date": "01-01-2019",
            "approved_by": "SUHENDRA",
            "end_date": "02-02-2019"
        }



        activate();

        function activate() {
            console.log('sk_promosi_lanjutan');
            $timeout(function () {
                $window.print();
            }, 2000);
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.report.jic.sk_promosi_extend", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.jic.sk_promosi_extend", {
            url: "/sk-promosi-extend",
            views: {
                jicReport: {
                    templateUrl: "app/main/report/jic/sk-promosi-extend/sk-promosi-extend.html",
                    controller: "JicReportPromosiExtendPrintController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.jic.sk_promosi_extend")
        .controller("JicReportPromosiExtendPrintController", Controller);

    Controller.$inject = ["$stateParams", "$timeout", "$window", "$localStorage"];

    /* @ngInject */
    function Controller($stateParams, $timeout, $window, $localStorage) {
        var vm = this;

        activate();

        vm.item = {
            "id": 1,
            "month": 12,
            "year": 2018,
            "name": "CHOERUL UMAM",
            "nik": "17000010",
            "original_position": "WEB DEVELOPER",
            "original_org_unit": "KSNI",
            "old_position": "WEB DEVELOPER",
            "new_position": "WEB DEVELOPER",
            "old_grade": "A3",
            "target_grade": "B3",
            "final_grade": "D3",
            "effective_date": "01-01-2019",
            "approved_by": "SUHENDRA",
            "end_date": "02-02-2019"
        }

        function activate() {
            console.log('sk_promosi_extend');
            $timeout(function () {
                $window.print();
            }, 2000);
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.report.jic.sk_promosi_awal", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.jic.sk_promosi_awal", {
            url: "/sk-promosi-awal/{id}",
            views: {
                jicReport: {
                    templateUrl: "app/main/report/jic/sk-promosi-awal/sk-promosi-awal.html",
                    controller: "JicReportPromosiAwalPrintController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.jic.sk_promosi_awal')
        .controller('JicReportPromosiAwalPrintController', Controller);

    Controller.$inject = ["$q", "$stateParams", "$timeout", "$window", "$localStorage", "AppAPI"];

    /* @ngInject */
    function Controller($q, $stateParams, $timeout, $window, $localStorage, AppAPI) {
        var vm = this;
        var EmpJic = AppAPI.EmpJic();
        vm.id = $stateParams.id;
        vm.allowance = $stateParams.allowance;
        vm.item = {};
        vm.module_name = vm.constructor.name;

        loadApproval().then(function () {

            // activate();

        });

        function loadApproval() {
            var defer = $q.defer();
            var response = EmpJic.query({
                action: 'getPrintSK',
                id: vm.id,
                action_id: 1
            });
            response.$promise.then(function (res) {
                console.log('res', res);

                vm.item = {
                    "pengajuan_id": res[0].pengajuan_id,
                    "id": res[0].id,
                    "no_sk": res[0].no_sk,
                    "month": res[0].bulan,
                    "year": res[0].tahun,
                    "fullname": res['0'].fullname,
                    "nik": res[0].nik,
                    "jabatan_lama": res[0].jabatan_lama,
                    "org_unit": res[0].org_unit,
                    "org_unit_lama": res[0].org_unit_lama,
                    "jabatan_baru": res[0].jabatan_baru,
                    "effective_date": res[0].tgl_penetapan,
                    "masa_acting_awal": res[0].konduite.masa_acting_awal,
                    "masa_acting_akhir": res[0].konduite.masa_acting_akhir,
                    "grade_lama": res[0].grade_lama,
                    "grade_dituju": res[0].grade_dituju,
                    "grade_baru": res[0].grade_baru,
                    "allowance": res[0].allowance,
                    "print": res[0].print
                    // "reasons": res[0].reasons
                }

                console.log('vm.item', vm.item);

                defer.resolve(res);
            });
            response.$promise.catch(function (err) {
                console.log('err', err);
                defer.reject(err);
            });
            return defer.promise;
        }

        // vm.item = {
        //     "id": 1,
        //     "month": 12,
        //     "year": 2018,
        //     "name": "CHOERUL UMAM",
        //     "nik": "17000010",
        //     "original_position": "WEB DEVELOPER",
        //     "old_org_unit": "KSNI",
        //     "new_org_unit": "KSNI",
        //     "old_position": "WEB DEVELOPER",
        //     "new_position": "WEB DEVELOPER",
        //     "old_place": "Bandung",
        //     "new_place": "Bandung",
        //     "effective_date": "01-01-2019",
        //     "approved_by": "SUHENDRA"

        // }

        function activate() {
            console.log('sk_promosi_awal');
            $timeout(function () {
                $window.print();
            }, 2000);
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.report.jic.sk_penugasan", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.jic.sk_penugasan", {
            url: "/sk-penugasan",
            views: {
                jicReport: {
                    templateUrl: "app/main/report/jic/sk-penugasan/sk-penugasan.html",
                    controller: "JicReportPenugasanPrintController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.jic.sk_penugasan")
        .controller("JicReportPenugasanPrintController", Controller);

    Controller.$inject = ["$stateParams", "$timeout", "$window", "$localStorage"];

    /* @ngInject */
    function Controller($stateParams, $timeout, $window, $localStorage) {
        var vm = this;

        activate();

        vm.item = {
            "id": 1,
            "month": 12,
            "year": 2018,
            "employee": [{
                    "name": "CHOERUL UMAM",
                    "nik": "17000010",
                    "grade": "A3",
                    "job_position": "WEB DEVELOPER",
                    "location": "bandung"
                },
                {
                    "name": "CHOERUL UMAM",
                    "nik": "17000010",
                    "grade": "A3",
                    "job_position": "WEB DEVELOPER",
                    "location": "bandung"
                },
                {
                    "name": "CHOERUL UMAM",
                    "nik": "17000010",
                    "grade": "A3",
                    "job_position": "WEB DEVELOPER",
                    "location": "bandung"
                }
            ],
            "effective_date": "01-01-2019",
            "end_date": "02-02-2019",
            "approved_by": "SUHENDRA"
        }



        function activate() {
            console.log('sk_penugasan');
            $timeout(function () {
                $window.print();
            }, 2000);
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.report.jic.sk_mutasi", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.jic.sk_mutasi", {
            url: "/sk-mutasi/:id",
            views: {
                jicReport: {
                    templateUrl: "app/main/report/jic/sk-mutasi/sk-mutasi.html",
                    controller: "JicReportMutasiPrintController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.jic.sk_mutasi")
        .controller("JicReportMutasiPrintController", Controller);

    Controller.$inject = ["$q", "$stateParams", "$timeout", "$window", "$localStorage", "AppAPI"];

    /* @ngInject */
    function Controller($q, $stateParams, $timeout, $window, $localStorage, AppAPI) {
        var vm = this;

        var EmpJic = AppAPI.EmpJic();
        vm.id = $stateParams.id;
        vm.item = {};
        vm.module_name = vm.constructor.name;

        loadApproval().then(function () {

            // activate();

        });


        function loadApproval() {
            var defer = $q.defer();
            var response = EmpJic.query({
                action: 'getPrintSK',
                id: vm.id,
                action_id: 3
            });
            response.$promise.then(function (res) {

                console.log('res', res);

                vm.item = {
                    "pengajuan_id": res[0].pengajuan_id,
                    "id": res[0].id,
                    "no_sk": res[0].no_sk,
                    "month": res[0].bulan,
                    "year": res[0].tahun,
                    "fullname": res['0'].fullname,
                    "nik": res[0].nik,
                    "jabatan_lama": res[0].jabatan_lama,
                    "org_unit": res[0].department_baru,
                    "jabatan_baru": res[0].jabatan_baru,
                    "effective_date": res[0].effective_date,
                    "grade_lama": res[0].grade_lama,
                    "grade_dituju": res[0].grade_dituju,
                    "grade_baru": res[0].grade_baru,
                    "allowance": res[0].allowance,
                    "print": res[0].print
                    // "reasons": res[0].reasons
                }

                // vm.item = {
                //     "id": res[0].id,
                //     "pengajuan_id": res[0].pengajuan_id,
                //     "month": res[0].bulan,
                //     "year": res[0].tahun,
                //     "fullname": res['0'].fullname,
                //     "nik": res[0].nik,
                //     "jabatan_lama": res[0].jabatan_lama,
                //     "grade_lama": res[0].grade_lama,
                //     "jabatan_baru": res[0].jabatan_baru,
                //     "target_grade": res[0].grade_baru,
                //     // "city": "Bandung",
                //     "effective_date": res[0].effective_date,
                //     // "approved_by": "SUHENDRA",
                //     "print": res[0].print
                //     // "reasons": res[0].reasons
                // }

                defer.resolve(res);
            });
            response.$promise.catch(function (err) {
                console.log('err', err);
                defer.reject(err);
            });
            return defer.promise;
        }

        // vm.item = {
        //     "id": 1,
        //     "month": 12,
        //     "year": 2018,
        //     "name": "CHOERUL UMAM",
        //     "nik": "17000010",
        //     "original_position": "WEB DEVELOPER",
        //     "old_org_unit": "KSNI",
        //     "new_org_unit": "KSNI",
        //     "old_position": "WEB DEVELOPER",
        //     "new_position": "WEB DEVELOPER",
        //     "old_place": "Bandung",
        //     "new_place": "Bandung",
        //     "effective_date": "01-01-2019",
        //     "approved_by": "SUHENDRA"

        // }

        function activate() {
            console.log('sk_mutasi');
            $timeout(function () {
                $window.print();
            }, 2000);
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.report.jic.sk_demosi", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.jic.sk_demosi", {
            url: "/sk-demosi/{id}",
            views: {
                jicReport: {
                    templateUrl: "app/main/report/jic/sk-demosi/sk-demosi.html",
                    controller: "JicReportDemosiPrintController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.jic.sk_demosi")
        .controller("JicReportDemosiPrintController", Controller);

    Controller.$inject = ["$q", "$stateParams", "$timeout", "$window", "$localStorage", "AppAPI"];

    /* @ngInject */
    function Controller($q, $stateParams, $timeout, $window, $localStorage, AppAPI) {
        var vm = this;
        var EmpJic = AppAPI.EmpJic();
        vm.id = $stateParams.id;
        vm.item = {};
        vm.module_name = vm.constructor.name;

        loadApproval().then(function () {

            // activate();

        });


        function loadApproval() {
            var defer = $q.defer();
            var response = EmpJic.query({
                action: 'getPrintSK',
                id: vm.id,
                action_id: 2
            });
            response.$promise.then(function (res) {
                console.log('res', res);

                vm.item = {
                    "id": res[0].id,
                    "no_sk": res[0].no_sk,
                    "pengajuan_id": res[0].pengajuan_id,
                    "month": res[0].bulan,
                    "year": res[0].tahun,
                    "fullname": res['0'].fullname,
                    "nik": res[0].nik,
                    "org_unit": res[0].org_unit,
                    "org_unit_lama": res[0].org_unit_lama,
                    "jabatan_lama": res[0].jabatan_lama,
                    "jabatan_baru": res[0].jabatan_baru,
                    "grade_lama": res[0].grade_lama,
                    "grade_dituju": res[0].grade_dituju,
                    "grade_baru": res[0].grade_baru,
                    "effective_date": res[0].tgl_penetapan,
                    "print": res[0].print
                }

                defer.resolve(res);
            });
            response.$promise.catch(function (err) {
                console.log('err', err);
                defer.reject(err);
            });
            return defer.promise;
        }

        function activate() {
            // console.log('sk_demosi');
            $timeout(function () {
                $window.print();
            }, 2000);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report", [
            "app.report.mpp_cost_report",
            "app.report.mpp_cost_report_detail",
            "app.report.mpp_hc_report",
            "app.report.jic",
            "app.report.correspondence"
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report", {
            url: "/report",
            abstract: true,
            views: {
                "main@": {
                    templateUrl: "app/core/layouts/content-only.html",
                    controller: "MainController as vm"
                },
                "content@app.report": {
                    templateUrl: "app/main/report/report.html",
                    controller: "ReportController as vm"
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report")
        .controller("MppReportHeadCountController", Controller);

    Controller.$inject = ["$stateParams", "$timeout", "$window", "$localStorage"];

    /* @ngInject */
    function Controller($stateParams, $timeout, $window, $localStorage) {
        var vm = this;
        vm.count = 0;

        vm.totalCurrEmp = 0;
        vm.totalNextEmp = 0;
        vm.totalNextEmpInternal = 0;
        vm.totalNextEmpExternal = 0;
        vm.totalNextEmpMutation = 0;
        vm.totalNextEmpTermination = 0;
        vm.totalPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        vm.getTotalRight = getTotalRight;
        vm.totalRightBottom = 0;

        activate();

        function activate() {
            if ($stateParams.obj) {
                vm.years = $stateParams.obj.years;
                vm.listReport = $stateParams.obj.list;
                setTotal(vm.listReport);
            } else {
                if ($localStorage.reportHC) {
                    vm.listReport = $localStorage.reportHC;
                    setTotal(vm.listReport);
                }
            }
            angular.element(document.body).block();
            $timeout(function () {
                angular.element(document.body).unblock();
                $timeout(function () {
                    $window.print();
                }, 8000);
            }, 2000);
        }

        function setTotal(data) {
            var ctr = data.length;
            vm.totalCurrEmp = 0;
            vm.totalNextEmp = 0;
            vm.totalNextEmpInternal = 0;
            vm.totalNextEmpExternal = 0;
            vm.totalNextEmpMutation = 0;
            vm.totalNextEmpTermination = 0;
            vm.totalPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            vm.totalRightBottom = 0;
            for (var i = 0; i < ctr; i++) {
                vm.totalCurrEmp += Number(data[i].curr.total);
                vm.totalNextEmp += Number(data[i].next.total);
                vm.totalNextEmpInternal += Number(data[i].next.internal);
                vm.totalNextEmpExternal += Number(data[i].next.external);
                vm.totalNextEmpMutation += Number(data[i].next.mutation);
                vm.totalNextEmpTermination += Number(data[i].next.termination);
                for (var j = 0; j < data[i].next.listPerMonth.length; j++) {
                    vm.totalPerMonth[j] += Number(data[i].next.listPerMonth[j]);
                }
            }
            vm.totalRightBottom = vm.totalCurrEmp + vm.totalNextEmp + vm.totalNextEmpExternal + vm.totalNextEmpInternal + vm.totalNextEmpMutation + vm.totalNextEmpTermination + vm.totalPerMonth.reduce(add, 0);
        }

        function add(a, b) {
            return a + b;
        }

        function getTotalRight(data) {
            // var main = Number(data.curr.total) + Number(data.next.total) + Number(data.next.internal) + Number(data.next.external) + Number(data.next.mutation) + Number(data.next.termination);
            var month = data.next.listPerMonth.reduce(add, 0);
            var sum = Math.round(Number(month) / 12);
            return sum;
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.report.mpp_cost_report", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.mpp-cost", {
            url: "/mpp-cost",
            views: {
                report: {
                    templateUrl: "app/main/report/mpp/cost/costreport.html",
                    controller: "MppReportCostPrintController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("app.report.mpp_cost_report")
        .filter("roundedMoney", function() {
            return function(number) {
                if (number !== "undefined") {
                    var num=Math.round(number);
                   // number = (number / Math.pow(10, 6)).toFixed(1);
                    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
                }
            };
        });
})();

(function () {
    "use strict";

    angular
        .module("app.report")
        .controller("MppReportCostPrintController", Controller);

    Controller.$inject = ["$stateParams", "$timeout", "$window", "$localStorage"];

    /* @ngInject */
    function Controller($stateParams, $timeout, $window, $localStorage) {
        var vm = this;
        vm.count = 0;
        vm.listReport = [];
        activate();

        function activate() {
            if ($stateParams.obj) {
                vm.years = $stateParams.obj.years;
                vm.listReport = $stateParams.obj.list;
            } else {
                if ($localStorage.reportCost) {
                    vm.listReport = $localStorage.reportCost;
                }
            }
            angular.element(document.body).block();
            $timeout(function () {
                angular.element(document.body).unblock();
                $timeout(function () {
                    $window.print();
                }, 2000);
            }, 2000);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.visa", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.correspondence.visa", {
            url: "/visa/print?=:data",
            views: {
                correspondenceReport: {
                    templateUrl: "app/main/report/correspondence/visa/visa.html",
                    controller: "CorrespondenceReportVisaController as vm"
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.visa")
        .controller("CorrespondenceReportVisaController", Controller);

    Controller.$inject = ["$stateParams"];

    /* @ngInject */
    function Controller($stateParams) {
        var vm = this;
        vm.item = JSON.parse(decodeURIComponent($stateParams.data));
        vm.getMonth = getMonthFromFinishedDate;
        vm.getYear = getYearFromFinishedDate;
        vm.getFinishedDate = getFinishedDate;

        activate();

        vm.monthLib = [
            '-', 'Januari', 'Februari', 'Maret', 'April', 'Mei',
            'Juni', 'Juli', 'Agustus', 'September', 'Oktober',
            'November', 'Desember'
        ];

        function activate() {
            document.title = "VISA" + moment(vm.item.finished_at).format('Ymd') + moment().format('Ymd') + vm.item.requestor;
        }

        function getMonthFromFinishedDate(iDate) {
            return new Date(iDate).getMonth();
        }

        function getYearFromFinishedDate(iDate) {
            return new Date(iDate).getFullYear();
        }

        function getFinishedDate(iDate) {
            return moment(iDate).format('DD MMMM YYYY');
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_promosi_tetap", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.correspondence.sk_promosi_tetap", {
            url: "/sk-promosi-tetap/print?=:data",
            views: {
                correspondenceReport: {
                    templateUrl: "app/main/report/correspondence/sk-promosi-tetap/sk-promosi-tetap.html",
                    controller: "CorrespondenceReportSkPromosiTetapController as vm"
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_promosi_tetap")
        .controller("CorrespondenceReportSkPromosiTetapController", Controller);

    Controller.$inject = ["$stateParams", "$document"];

    /* @ngInject */
    function Controller($stateParams, $document) {
        var vm = this;
        vm.item = JSON.parse(decodeURIComponent($stateParams.data));
        vm.getMonth = getMonthFromFinishedDate;
        vm.getYear = getYearFromFinishedDate;
        vm.getFinishedDate = getFinishedDate;
        vm.getEffectiveDate = getEffectiveDate;
        vm.getNumberID = getNumberID;

        activate();

        vm.monthLib = [
            '-', 'Januari', 'Februari', 'Maret', 'April', 'Mei',
            'Juni', 'Juli', 'Agustus', 'September', 'Oktober',
            'November', 'Desember'
        ];

        vm.romanianNumber = [
            'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
        ];

        function getNumberID(num) {
            var s = "0000000" + num;
            return s.substr(s.length - 3);
        }

        function activate() {
            document.title = "surat_keputusan_promosi_tetap" + vm.item.nik;
        }

        function getMonthFromFinishedDate(iDate) {
            var month = moment(iDate).format('M');
            return vm.romanianNumber[month - 1];
        }

        function getYearFromFinishedDate(iDate) {
            return moment(iDate).format('Y');
        }

        function getFinishedDate(iDate) {
            var d = moment(iDate);
            var month = d.format('M');
            var year = d.format('Y');
            return d.format('D') + ' ' + vm.monthLib[month] + ' ' + year;
        }

        function getEffectiveDate(iDate) {
            return moment(iDate).format('dd-mmmm-yyyy');
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_promosi_lulus", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.correspondence.sk_promosi_lulus", {
            url: "/sk-promosi-lulus/print?=:data",
            views: {
                correspondenceReport: {
                    templateUrl: "app/main/report/correspondence/sk-promosi-lulus/sk-promosi-lulus.html",
                    controller: "CorrespondenceReportSkPromosiLulusController as vm"
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_promosi_lulus")
        .controller("CorrespondenceReportSkPromosiLulusController", Controller);

    Controller.$inject = ["$stateParams", "$document"];

    /* @ngInject */
    function Controller($stateParams, $document) {
        var vm = this;
        vm.item = JSON.parse(decodeURIComponent($stateParams.data));
        vm.getMonth = getMonthFromFinishedDate;
        vm.getYear = getYearFromFinishedDate;
        vm.getFinishedDate = getFinishedDate;
        vm.getEffectiveDate = getEffectiveDate;
        vm.getNumberID = getNumberID;

        activate();

        vm.monthLib = [
            '-', 'Januari', 'Februari', 'Maret', 'April', 'Mei',
            'Juni', 'Juli', 'Agustus', 'September', 'Oktober',
            'November', 'Desember'
        ];

        vm.romanianNumber = [
            'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
        ];

        console.log(vm.items);

        function getNumberID(num) {
            var s = "0000000" + num;
            return s.substr(s.length - 3);
        }

        function activate() {
            document.title = "surat_keputusan_promosi_lulus" + vm.item.nik;
        }

        function getMonthFromFinishedDate(iDate) {
            var month = moment(iDate).format('M');
            return vm.romanianNumber[month - 1];
        }

        function getYearFromFinishedDate(iDate) {
            return moment(iDate).format('Y');
        }

        function getFinishedDate(iDate) {
            var d = moment(iDate);
            var month = d.format('M');
            var year = d.format('Y');
            return d.format('D') + ' ' + vm.monthLib[month] + ' ' + year;
        }

        function getEffectiveDate(iDate) {
            return moment(iDate).format('dd-mmmm-yyyy');
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_promosi_lanjutan", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.correspondence.sk_promosi_lanjutan", {
            url: "/sk-promosi-lanjutan/print?=:data",
            views: {
                correspondenceReport: {
                    templateUrl: "app/main/report/correspondence/sk-promosi-lanjutan/sk-promosi-lanjutan.html",
                    controller: "CorrespondenceReportSkPromosiLanjutanController as vm"
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_promosi_lanjutan")
        .controller("CorrespondenceReportSkPromosiLanjutanController", Controller);

    Controller.$inject = ["$stateParams", "$document"];

    /* @ngInject */
    function Controller($stateParams, $document) {
        var vm = this;
        vm.item = JSON.parse(decodeURIComponent($stateParams.data));
        vm.getMonth = getMonthFromFinishedDate;
        vm.getYear = getYearFromFinishedDate;
        vm.getFinishedDate = getFinishedDate;
        vm.getEffectiveDate = getEffectiveDate;
        vm.getNumberID = getNumberID;

        activate();

        vm.monthLib = [
            '-', 'Januari', 'Februari', 'Maret', 'April', 'Mei',
            'Juni', 'Juli', 'Agustus', 'September', 'Oktober',
            'November', 'Desember'
        ];

        vm.romanianNumber = [
            'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
        ];

        function getNumberID(num) {
            var s = "0000000" + num;
            return s.substr(s.length - 3);
        }

        function activate() {
            document.title = "surat_keputusan_promosi_lanjutan" + vm.item.nik;
        }

        function getMonthFromFinishedDate(iDate) {
            var month = moment(iDate).format('M');
            return vm.romanianNumber[month - 1];
        }

        function getYearFromFinishedDate(iDate) {
            return moment(iDate).format('Y');
        }

        function getFinishedDate(iDate) {
            var d = moment(iDate);
            var month = d.format('M');
            var year = d.format('Y');
            return d.format('D') + ' ' + vm.monthLib[month] + ' ' + year;
        }

        function getEffectiveDate(iDate) {
            return moment(iDate).format('dd-mmmm-yyyy');
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_promosi_extend", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.correspondence.sk_promosi_extend", {
            url: "/sk-promosi-extend/print?=:data",
            views: {
                correspondenceReport: {
                    templateUrl: "app/main/report/correspondence/sk-promosi-extend/sk-promosi-extend.html",
                    controller: "CorrespondenceReportSkPromosiExtendController as vm"
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_promosi_extend")
        .controller("CorrespondenceReportSkPromosiExtendController", Controller);

    Controller.$inject = ["$stateParams", "$document"];

    /* @ngInject */
    function Controller($stateParams, $document) {
        var vm = this;
        vm.item = JSON.parse(decodeURIComponent($stateParams.data));
        vm.getMonth = getMonthFromFinishedDate;
        vm.getYear = getYearFromFinishedDate;
        vm.getFinishedDate = getFinishedDate;
        vm.getEffectiveDate = getEffectiveDate;
        vm.getNumberID = getNumberID;

        activate();

        vm.monthLib = [
            '-', 'Januari', 'Februari', 'Maret', 'April', 'Mei',
            'Juni', 'Juli', 'Agustus', 'September', 'Oktober',
            'November', 'Desember'
        ];

        vm.romanianNumber = [
            'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
        ];

        function getNumberID(num) {
            var s = "0000000" + num;
            return s.substr(s.length - 3);
        }

        function activate() {
            document.title = "surat_keputusan_promosi_extend" + vm.item.nik;
        }

        function getMonthFromFinishedDate(iDate) {
            var month = moment(iDate).format('M');
            return vm.romanianNumber[month - 1];
        }

        function getYearFromFinishedDate(iDate) {
            return moment(iDate).format('Y');
        }

        function getFinishedDate(iDate) {
            var d = moment(iDate);
            var month = d.format('M');
            var year = d.format('Y');
            return d.format('D') + ' ' + vm.monthLib[month] + ' ' + year;
        }

        function getEffectiveDate(iDate) {
            return moment(iDate).format('dd-mmmm-yyyy');
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_penugasan_single", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.correspondence.sk_penugasan_single", {
            url: "/sk-penugasan-single/print?=:data",
            views: {
                correspondenceReport: {
                    templateUrl: "app/main/report/correspondence/sk-penugasan-single/sk-penugasan-single.html",
                    controller: "CorrespondenceReportSkPenugasanSingleController as vm"
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_penugasan_single")
        .controller("CorrespondenceReportSkPenugasanSingleController", Controller);

    Controller.$inject = ["$stateParams", "$document"];

    /* @ngInject */
    function Controller($stateParams, $document) {
        var vm = this;
        vm.item = JSON.parse(decodeURIComponent($stateParams.data));
        vm.getMonth = getMonthFromFinishedDate;
        vm.getYear = getYearFromFinishedDate;
        vm.getFinishedDate = getFinishedDate;
        vm.getEffectiveDate = getEffectiveDate;
        vm.getNumberID = getNumberID;

        activate();

        vm.monthLib = [
            '-', 'Januari', 'Februari', 'Maret', 'April', 'Mei',
            'Juni', 'Juli', 'Agustus', 'September', 'Oktober',
            'November', 'Desember'
        ];

        vm.romanianNumber = [
            'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
        ];

        function getNumberID(num) {
            var s = "0000000" + num;
            return s.substr(s.length - 3);
        }

        function activate() {
            document.title = "surat_keputusan_penugasan" + vm.item.id;
        }

        function getMonthFromFinishedDate(iDate) {
            var month = moment(iDate).format('M');
            return vm.romanianNumber[month - 1];
        }

        function getYearFromFinishedDate(iDate) {
            return moment(iDate).format('Y');
        }

        function getFinishedDate(iDate) {
            var d = moment(iDate);
            var month = d.format('M');
            var year = d.format('Y');
            return d.format('D') + ' ' + vm.monthLib[month] + ' ' + year;
        }

        function getEffectiveDate(iDate) {
            return moment(iDate).format('dd-mmmm-yyyy');
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.sk_penugasan_multiple", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.correspondence.sk_penugasan_multiple", {
            url: "/sk-penugasan-multiple/print?=:data",
            views: {
                correspondenceReport: {
                    templateUrl: "app/main/report/correspondence/sk-penugasan-multiple/sk-penugasan-multiple.html",
                    controller: "CorrespondenceReportSkPenugasanMultipleController as vm"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.report.correspondence.sk_penugasan_multiple')
        .controller('CorrespondenceReportSkPenugasanMultipleController', Controller);

    Controller.$inject = ['$stateParams', '$document'];

    /* @ngInject */
    function Controller($stateParams, $document) {
        var vm = this;
        vm.item = JSON.parse(decodeURIComponent($stateParams.data));
        vm.getMonth = getMonthFromFinishedDate;
        vm.getYear = getYearFromFinishedDate;
        vm.getFinishedDate = getFinishedDate;
        vm.getEffectiveDate = getEffectiveDate;
        vm.getNumberID = getNumberID;

        activate();

        vm.monthLib = [
            '-',
            'Januari',
            'Februari',
            'Maret',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Agustus',
            'September',
            'Oktober',
            'November',
            'Desember'
        ];

        vm.romanianNumber = [
            'I',
            'II',
            'III',
            'IV',
            'V',
            'VI',
            'VII',
            'VIII',
            'IX',
            'X'
        ];

        function getNumberID(num) {
            var s = '0000000' + num;
            return s.substr(s.length - 3);
        }

        function activate() {
            document.title = 'surat_keputusan_penugasan_multiple' + vm.item.id;
            if (
                vm.item.employeeLists.length > 4 &&
                vm.item.employeeLists.length < 6
            ) {
                var el = document.getElementsByClassName('normal-tbl');
                var table = angular.element(el);
                table.addClass('dense-1');
            } else if (vm.item.employeeLists.length > 6) {
                var el = document.getElementsByClassName('normal-tbl');
                var table = angular.element(el);
                table.addClass('dense-2');
            }
        }

        function getMonthFromFinishedDate(iDate) {
            var month = moment(iDate).format('M');
            return vm.romanianNumber[month - 1];
        }

        function getYearFromFinishedDate(iDate) {
            return moment(iDate).format('Y');
        }

        function getFinishedDate(iDate) {
            var d = moment(iDate);
            var month = d.format('M');
            var year = d.format('Y');
            return d.format('D') + ' ' + vm.monthLib[month] + ' ' + year;
        }

        function getEffectiveDate(iDate) {
            return moment(iDate).format('dd-mmmm-yyyy');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.report.correspondence.pma', [])
        .filter('titleCase', function() {
            return function(input) {
                input = input || '';
                return input.replace(/\w\S*/g, function(txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            };
        })
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.report.correspondence.pma', {
            url: '/print-letter/print?=:data',
            views: {
                correspondenceReport: {
                    templateUrl:
                        'app/main/report/correspondence/correspondence-pma/correspondence-pma.html',
                    controller: 'CorrespondenceReportPmaController as vm'
                }
            }
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("app.report.correspondence.pma")
        .controller("CorrespondenceReportPmaController", Controller);

    Controller.$inject = [
        "$stateParams",
        "$document",
        "AppAPI",
        "$http",
        "config",
        "$localStorage"
    ];

    /* @ngInject */
    function Controller(
        $stateParams,
        $document,
        AppAPI,
        $http,
        config,
        $localStorage
    ) {
        var vm = this;
        var endpoint = AppAPI.IndisciplinaryRequest();
        // vm.item = JSON.parse(decodeURIComponent($stateParams.data));
        vm.getMonth = getMonthFromFinishedDate;
        vm.getYear = getYearFromFinishedDate;
        vm.formatDate = formatDate;
        vm.getEffectiveDate = getEffectiveDate;
        vm.getNumberID = getNumberID;
        vm.toIndonesianName = toIndonesianName;
        vm.getScorsingDate = getScorsingDate;
        vm.warningLetterState = warningLetterState;
        vm.employeeCallingLetterState = employeeCallingLetterState;

        activate();

        vm.monthLib = [
            "-",
            "Januari",
            "Februari",
            "Maret",
            "April",
            "Mei",
            "Juni",
            "Juli",
            "Agustus",
            "September",
            "Oktober",
            "November",
            "Desember"
        ];

        vm.romanianNumber = [
            "I",
            "II",
            "III",
            "IV",
            "V",
            "VI",
            "VII",
            "VIII",
            "IX",
            "X",
            "XI",
            "XII"
        ];

        function getNumberID(num) {
            var s = "0000000" + num;
            return s.substr(s.length - 3);
        }

        function activate() {
            document.title = "printed" + "_" + moment().format("YYYY_MM_DD");
            loadData($stateParams.data);
        }

        function loadData(item) {
            var request = $http.get(
                config.api + "api/indisciplinary/getDataPrint?data=" + item
            );
            request.then(function(response) {
                vm.items = response.data;
            });
            request.catch(function(response) {
                vm.items = [];
            });
        }

        function getMonthFromFinishedDate(iDate) {
            var month = moment(iDate).format("M");
            return vm.romanianNumber[month - 1];
        }

        function getYearFromFinishedDate(iDate) {
            return moment(iDate).format("Y");
        }

        function formatDate(iDate) {
            var d = moment(iDate);
            var month = d.format("M");
            var year = d.format("Y");
            return d.format("D") + " " + vm.monthLib[month] + " " + year;
        }

        function getScorsingDate(iDate, skorsingMonth) {
            var scorsingDate = moment(iDate)
                .add(skorsingMonth, "M")
                .format("YYYY-MM-DD");
            console.log(scorsingDate);
            return formatDate(scorsingDate);
        }

        function getEffectiveDate(iDate) {
            return moment(iDate).format("dd-mmmm-yyyy");
        }

        function toIndonesianName(idx) {
            var libs = [
                "(SATU)",
                "(DUA)",
                "(TIGA)",
                "(EMPAT)",
                "(LIMA)",
                "(ENAM)",
                "(TUJUH)",
                "(DELAPAN)",
                "(SEMBILAN)",
                "(SEPULUH)",
                "(SEBELAS)",
                "(DUA BELAS)"
            ];
            return libs[idx - 1];
        }

        function warningLetterState(company, letter) {
            var isEnabled = false;
            var isMultiple = company.indexOf("_") !== -1;
            var arrCompany = [];
            if (isMultiple) {
                arrCompany = company.split("_");
            } else {
                arrCompany.push(company);
            }
            var companyUser = $localStorage.empsite;
            for (var i = 0; i < arrCompany.length; i++) {
                if (arrCompany[i] == companyUser) {
                    if (letter == "SP1" || letter == "SP2" || letter == "SP3") {
                        isEnabled = true;
                        break;
                    }
                }
            }
            return isEnabled;
        }

        function employeeCallingLetterState(company, letter) {
            var isEnabled = false;
            var isMultiple = company.indexOf("_") !== -1;
            var arrCompany = [];
            if (isMultiple) {
                arrCompany = company.split("_");
            } else {
                arrCompany.push(company);
            }
            var companyUser = $localStorage.empsite;
            for (var i = 0; i < arrCompany.length; i++) {
                if (arrCompany[i] == companyUser) {
                    if (
                        letter == "SURAT_PEMANGGILAN_1" ||
                        letter == "SURAT_PEMANGGILAN_2" ||
                        letter == "SURAT_PEMANGGILAN_3"
                    ) {
                        isEnabled = true;
                        break;
                    }
                }
            }
            return isEnabled;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.report.correspondence.company_certificate", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.correspondence.company_certificate", {
            url: "/company-certificate/print?=:data",
            views: {
                correspondenceReport: {
                    templateUrl: "app/main/report/correspondence/company-certificate/company-certificate.html",
                    controller: "CorrespondenceReportCompanyCertificateController as vm"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.report.correspondence.company_certificate')
        .controller('CorrespondenceReportCompanyCertificateController', Controller);

    Controller.$inject = ['$stateParams', '$document'];

    /* @ngInject */
    function Controller($stateParams, $document) {
        var vm = this;
        vm.item = JSON.parse(decodeURIComponent($stateParams.data));
        vm.getMonth = getMonthFromFinishedDate;
        vm.getYear = getYearFromFinishedDate;
        vm.getFinishedDate = getFinishedDate;
        vm.getEffectiveDate = getEffectiveDate;
        vm.getNumberID = getNumberID;

        activate();

        console.log(vm.item);

        vm.monthLib = [
            '-',
            'Januari',
            'Februari',
            'Maret',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Agustus',
            'September',
            'Oktober',
            'November',
            'Desember'
        ];

        vm.romanianNumber = [
            'I',
            'II',
            'III',
            'IV',
            'V',
            'VI',
            'VII',
            'VIII',
            'IX',
            'X'
        ];

        function getNumberID(num) {
            var s = '0000000' + num;
            return s.substr(s.length - 3);
        }

        function activate() {
            document.title = 'surat_keterangan_perusahaan_' + vm.item.requestor;
        }

        function getMonthFromFinishedDate(iDate) {
            var month = moment(iDate).format('M');
            return vm.romanianNumber[month - 1];
        }

        function getYearFromFinishedDate(iDate) {
            return moment(iDate).format('Y');
        }

        function getFinishedDate(iDate) {
            var d = moment(iDate);
            var month = d.format('M');
            var year = d.format('Y');
            return d.format('D') + ' ' + vm.monthLib[month] + ' ' + year;
        }

        function getEffectiveDate(iDate) {
            return moment(iDate).format('dd-mmmm-yyyy');
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.mpn-gw.request', ['ui.tinymce', 'ngMaterial', 'ngMessages']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.mpn_gw_request', {
                url: '/mpngw/request/:layer_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mpn-gw/request/request.html',
                        controller: 'MpnGwRequestController as vm'
                    }
                }
            })

            .state('app.mpn_gw_list', {
                url: '/mpngw/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mpn-gw/request/list.html',
                        controller: 'MpnGwListController as vm'
                    }
                }
            })

            .state('app.mpn_gw_detail', {
                url: '/mpngw/detail/:id/:tipe',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mpn-gw/request/detail.html',
                        controller: 'MpnGwDetailController as vm'
                    }
                }
            })

            .state('app.mpn_gw_edit', {
                url: '/mpngw/edit/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mpn-gw/request/request.html',
                        controller: 'MpnGwRequestController as vm'
                    }
                }
            });
    }



})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.request')
        .controller('ProductionUploadController', ProductionUploadController);

    ProductionUploadController.$inject = ['$mdDialog', '$localStorage', '$window', '$location', 'FileUploader', 'config'];

    /* @ngInject */
    function ProductionUploadController($mdDialog, $localStorage, $window, $location, FileUploader, config) {
        var vm = this;
        vm.closeModal = closeModal;
        vm.uploadFile = uploadFile;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        vm.downloadFormat = downloadFormat;

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/productions/uploadExcel',
            removeAfterUpload: true,
            alias: 'fileupload',
            formData: [{
                action: 'fileupload'
            }],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        uploaderPhoto.onSuccessItem = function (response, result) {
            vm.UploadPhotoStateSucces = true;
            vm.UploadPhotoStateError = false;
        };

        uploaderPhoto.onErrorItem = function () {
            vm.UploadPhotoStateSucces = false;
            vm.UploadPhotoStateError = true;
        };

        function uploadFile() {
            return false;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function downloadFormat() {
            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.api + 'api/productions/exportExcel/', '_blank');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.production-products.production', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.production_create', {
                url: '/productionproduct/product/create',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/production-products/production/production-create/production-create.html',
                        controller: 'ProductionCreateController as vm'
                    }
                }
            })

            .state('app.production_list', {
                url: '/productionproduct/product/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/production-products/production/production-list.html',
                        controller: 'ProductionListController as vm'
                    }
                }
            })

            .state('app.production_list_non_production', {
                url: '/productionproduct/product_non_production/create',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/production-products/production/production-list-nonproduction.html',
                        controller: 'ProductionListNonproductionController as vm'
                    }
                }
            })
            
            .state('app.production_list_non_production_view', {
                url: '/productionproduct/product_non_production/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/production-products/production/production-list-nonproduction-view.html',
                        controller: 'ProductionListNonproductionViewController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('app.production-products.production')
        .controller('ProductionEditController', ProductionEditController);

    ProductionEditController.$inject = [
        '$timeout',
        '$mdDialog',
        'AppAPI',
        'Auth',
        'Form',
        'data'
    ];

    function ProductionEditController(
        $timeout,
        $mdDialog,
        AppAPI,
        Auth,
        Form,
        data
    ) {
        var vm = this;
        var endpoint = new AppAPI.Productions();
        // console.log(data);
        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;
        vm.edit = true;
        var data=data;
        vm.Form.objForm.production_date = new Date(data.production_date);
        vm.Form.objForm.id = data.id;
        vm.Form.objForm.line = data.gedung_sector_line_id;
        vm.Form.objForm.shift = data.shift_type;
        vm.Form.objForm.workingHour = parseInt(data.working_hours);
        vm.Form.objForm.product = data.product_id;

        vm.Form.objForm.gedung = data.building_id;
        vm.Form.objForm.sector = data.sector_id;
        vm.Form.objForm.tolerance = 95;

        vm.shiftList = [{
            id: "pagi",
            description: "Pagi"
        },
        {
            id: "siang",
            description: "Siang"
        },
        {
            id: "malam",
            description: "Malam"
        }
        ];

        loadDataProduct();
        loadDataGedung();
        loadSector(data.building_id);
        loadLine(data.sector_id);

        vm.loadSector = loadSector;
        vm.loadLine = loadLine;
        vm.reloadToken = reloadToken;
        vm.saveData = saveData;
        vm.closeModal = closeModal;

        function loadDataProduct() {
            vm.listProduct = [];
            var response = endpoint.query({
                action: "getproduct"
            });
            response.$promise.then(function (data) {
                vm.listProduct = data;
            });
            response.$promise.catch(function (data) {
                vm.listProduct = [];
            });
        }

        function loadDataGedung() {
            vm.listGedung = [];
            var response = endpoint.query({
                action: "getgedung"
            });
            response.$promise.then(function (data) {
                vm.listGedung = data;
            });
            response.$promise.catch(function (data) {
                vm.listGedung = [];
            });
        }

        function loadSector(id) {
            vm.listSector = [];
            var response = endpoint.query({
                action: "getsector",
                id: id
            });
            response.$promise.then(function (data) {
                vm.listSector = data;
            });
            response.$promise.catch(function (data) {
                vm.listSector = [];
            });
        }

        function loadLine(id) {
            vm.listLine = [];
            var response = endpoint.query({
                action: "getline",
                id: id
            });
            response.$promise.then(function (data) {
                vm.listLine = data;
            });
            response.$promise.catch(function (data) {
                vm.listLine = [];
            });
        }

        function reloadToken() {
            Auth.setToken();
        }

        function saveData(formController) {
            angular.element.blockUI();

            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                angular.element.blockUI();
                var promise = Form.saveData('update', formController, endpoint);

                promise.then(function () {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

                promise.catch(function () {
                    vm.messageTheme = 'pink';
                    angular.element.unblockUI();
                });
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.production-products.production')
        .controller('ProductionCreateController', ProductionCreateController);

    ProductionCreateController.$inject = [
        '$timeout',
        '$mdDialog',
        'AppAPI',
        'Auth',
        'Form'
    ];

    function ProductionCreateController(
        $timeout,
        $mdDialog,
        AppAPI,
        Auth,
        Form
    ) {
        var vm = this;
        var endpoint = new AppAPI.Productions();

        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;
        vm.edit = false;
        vm.shiftList = [{
            id: "pagi",
            description: "Pagi"
        },
        {
            id: "siang",
            description: "Siang"
        },
        {
            id: "malam",
            description: "Malam"
        }
        ];

        loadDataProduct();
        loadDataGedung();

        vm.Form.objForm.tolerance = 95;
        vm.Form.objForm.id = '';

        vm.loadSector = loadSector;
        vm.loadLine = loadLine;
        vm.reloadToken = reloadToken;
        vm.saveData = saveData;
        vm.closeModal = closeModal;

        function loadDataProduct() {
            vm.listProduct = [];
            var response = endpoint.query({
                action: "getproduct"
            });
            response.$promise.then(function (data) {
                vm.listProduct = data;
            });
            response.$promise.catch(function (data) {
                vm.listProduct = [];
            });
        }

        function loadDataGedung() {
            vm.listGedung = [];
            var response = endpoint.query({
                action: "getgedung"
            });
            response.$promise.then(function (data) {
                vm.listGedung = data;
            });
            response.$promise.catch(function (data) {
                vm.listGedung = [];
            });
        }

        function loadSector(id) {
            vm.listSector = [];
            var response = endpoint.query({
                action: "getsector",
                id: id
            });
            response.$promise.then(function (data) {
                vm.listSector = data;
            });
            response.$promise.catch(function (data) {
                vm.listSector = [];
            });
        }

        function loadLine(id) {
            vm.listLine = [];
            var response = endpoint.query({
                action: "getline",
                id: id
            });
            response.$promise.then(function (data) {
                vm.listLine = data;
            });
            response.$promise.catch(function (data) {
                vm.listLine = [];
            });
        }

        function reloadToken() {
            Auth.setToken();
        }

        function saveData(formController) {
            angular.element.blockUI();

            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                angular.element.blockUI();
                var promise = Form.saveData('save', formController, endpoint);

                promise.then(function () {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

                promise.catch(function () {
                    vm.messageTheme = 'pink';
                    angular.element.unblockUI();
                });
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pms.talent_review_admin.talent-review-9box', ['ngDragDrop'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.pms_talent_review_admin_9box', {
                url: '/pms/talent-review-admin-9box',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pms/talent-review-admin/talent-review-9box/talent-review-9box.html',
                        controller: 'TalentReview9BoxController as vm'
                    }
                }
            });



    }
})();
(function () {
    'use strict';

    angular
        .module('app.pms.talent_review_admin.talent-review-9box')
        .controller('TalentReview9BoxController', TalentReview9BoxController);


    TalentReview9BoxController.$inject = ['$state', '$localStorage', '$document', '$http', '$scope', 'config', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', 'FileUploader', 'Form', '$window', '$timeout', '$mdToast'];
    /** @ngInject */
    function TalentReview9BoxController($state, $localStorage, $document, $http, $scope, config, $log, $mdDialog, AppAPI, Auth, DataService, FileUploader, Form, $window, $timeout, $mdToast) {

        var vm = this;
        var TalentReview = AppAPI.TalentReview();

        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [
            { link: '#', name: 'Team Perf. Mgt. / ', active: '0' }
        ];

        vm.is_color = false;

        vm.ninebox1AList = [];
        vm.ninebox2AList = [];
        vm.ninebox3AList = [];
        vm.ninebox1BList = [];
        vm.ninebox2BList = [];
        vm.ninebox3BList = [];
        vm.ninebox1CList = [];
        vm.ninebox2CList = [];
        vm.ninebox3CList = [];

        vm.saveNineBoxToDraft = saveNineBoxToDraft;
        vm.saveSubmitNineBox = saveSubmitNineBox;
        vm.resetNineBox = resetNineBox;
        vm.saveData = saveData;
        vm.status = '';

        Form.initialForm();
        Form.setObject(TalentReview);
        vm.Form = Form;
        vm.setToken = Auth.setToken;
        vm.loadData = loadData;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataAtasan = loadDataAtasan;

        vm.optionsEvents = {
            accept: function (dragEl) {
                var data = angular.element(dragEl[0]).data();
                var item = data.$scope.item;
                return false;
            }
        };

        loadDataBU();

        function loadDataBU() {
            var response = TalentReview.query({ action: 'viewBu' });
            response.$promise.then(function (data) {
                vm.listBu = data;
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDataDivision(idbu) {

            vm.divisi = '';
            vm.department = '';
            var response = TalentReview.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(function (data) {
                vm.listDivisi = data;
                vm.listDepartment = [];
            });
            response.$promise.catch(function () {
                vm.listDivisi = [];
                angular.element.unblockUI();
            });
        }

        function loadDataDepartment(iddivisi) {
            vm.department = '';
            var response = TalentReview.query({ action: 'viewDivisiDept', idbu: vm.bu, iddivisi: iddivisi });
            response.$promise.then(function (data) {
                vm.listDepartment = data;
            });
            response.$promise.catch(function errorDepartment() {
                vm.listDepartment = [];
                angular.element.unblockUI();
            });
        }

        function loadDataAtasan() {
            var response = TalentReview.query({ action: 'viewAtasanLists', bu: vm.bu, divisi: vm.divisi, department: vm.department });
            response.$promise.then(function (data) {
                vm.listAtasan = data;
                vm.nik_atasan = '';
            });
            response.$promise.catch(function errorDepartment() {
                vm.listAtasan = [];
                vm.nik_atasan = '';
                angular.element.unblockUI();
            });
        }

        // set 9-box table layout fixed square
        setTimeout(function () {
            fixedSquare();
        }, 20);

        var appWindow = angular.element($window);
        appWindow.bind('resize', function () {
            fixedSquare();
        });

        function fixedSquare() {
            var widthninebox = angular.element(document.querySelectorAll(".nine-box-area")[0]).prop('offsetWidth');
            vm.heightninebox = angular.element(document.querySelectorAll(".nine-box-area")[0]).clientHeight = widthninebox;
        }

        function saveNineBoxToDraft(e) {
            var datas = {};
            datas['_1A'] = vm.ninebox1AList;
            datas['_2A'] = vm.ninebox2AList;
            datas['_3A'] = vm.ninebox3AList;
            datas['_1B'] = vm.ninebox1BList;
            datas['_2B'] = vm.ninebox2BList;
            datas['_3B'] = vm.ninebox3BList;
            datas['_1C'] = vm.ninebox1CList;
            datas['_2C'] = vm.ninebox2CList;
            datas['_3C'] = vm.ninebox3CList;

            vm.Form.objForm.is_draft = true;
            vm.Form.objForm.data = datas;

            var form = angular.element(document.getElementById('frmSaveNineBox'));
            $timeout(function () {
                form.triggerHandler("submit");
            });

        };

        function saveSubmitNineBox(e) {
            var datas = {};
            datas['_1A'] = vm.ninebox1AList;
            datas['_2A'] = vm.ninebox2AList;
            datas['_3A'] = vm.ninebox3AList;
            datas['_1B'] = vm.ninebox1BList;
            datas['_2B'] = vm.ninebox2BList;
            datas['_3B'] = vm.ninebox3BList;
            datas['_1C'] = vm.ninebox1CList;
            datas['_2C'] = vm.ninebox2CList;
            datas['_3C'] = vm.ninebox3CList;

            vm.Form.objForm.is_draft = false;
            vm.Form.objForm.data = datas;

            var form = angular.element(document.getElementById('frmSaveNineBox'));
            $timeout(function () {
                form.triggerHandler("submit");
            });
        };

        function saveData(ev, formController) {

            var promise = Form.saveData('save9box', formController, TalentReview);

            promise.then(successSaveData);
            promise.catch(failedSaveData);

        }

        function successSaveData() {
            vm.Form.tampilPesan = false;
            vm.messageTheme = 'green';

            $mdToast.show(
                $mdToast.simple()
                    .textContent(vm.Form.pesan)
                    .position('top right')
                    .hideDelay(3000)
                    .theme("success-toast")
            );

            vm.setToken();

        }

        function failedSaveData() {
            vm.messageTheme = 'red';

            vm.setToken();
        }

        function resetNineBox(e) {
            vm.ninebox1AList = [];
            vm.ninebox2AList = [];
            vm.ninebox3AList = [];
            vm.ninebox1BList = [];
            vm.ninebox2BList = [];
            vm.ninebox3BList = [];
            vm.ninebox1CList = [];
            vm.ninebox2CList = [];
            vm.ninebox3CList = [];
            loadData(1);
        }

        loadData(1);

        function loadData(pageno) {
            angular.element('#talentReviewView').block({ message: 'please wait..' });
            var tahun = vm.tahun;
            var bulan = vm.bulan;
            var resp = TalentReview.query({ action: 'viewdataninebox', tahun: tahun, bulan: bulan, nik: vm.nik_atasan, bu: vm.bu, divisi: vm.divisi, department: vm.department });
            resp.$promise.then(fetchTalentReviewData);
            resp.$promise.catch(errFetchTalentReviewData);
        }

        function errFetchTalentReviewData(data) {
            vm.listTalentReviewNineBox = [];
            angular.element('#talentReviewView').unblock();
        }

        function fetchTalentReviewData(data) {
            vm.listTalentReviewNineBox = data;
            vm.listTalentReviewNineBoxTmp = data;


            console.log('vm.listTalentReviewNineBox', vm.listTalentReviewNineBox);

            setTimeout(function () {

                for (var i = 0; i <= (data.length - 1); i++) {

                    if (vm.status === '') {
                        if (data[i].status !== '') {
                            vm.status = data[i].status;
                        }
                    }

                    if (typeof (data[i].ninebox_code) !== 'undefined' && data[i].ninebox_code !== null) {

                        if (data[i].ninebox_code === '1A') {
                            vm.ninebox1AList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '1B') {
                            vm.ninebox1BList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '1C') {
                            vm.ninebox1CList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '2A') {
                            vm.ninebox2AList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '2B') {
                            vm.ninebox2BList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '2C') {
                            vm.ninebox2CList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '3A') {
                            vm.ninebox3AList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '3B') {
                            vm.ninebox3BList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '3C') {
                            vm.ninebox3CList.push(data[i]);
                        }


                    } else {

                        if (typeof (data[i].emp_potential) !== undefined && typeof (data[i].result_adjustment) !== undefined) {

                            if (data[i].emp_potential.summary_id === 3) {

                                if (data[i].result_adjustment[0].result2 === 'A') {
                                    vm.ninebox1AList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B+') {
                                    vm.ninebox1BList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B') {
                                    vm.ninebox1BList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C+') {
                                    vm.ninebox1CList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C') {
                                    vm.ninebox1CList.push(data[i]);
                                }

                            }
                            if (data[i].emp_potential.summary_id === 2) {

                                if (data[i].result_adjustment[0].result2 === 'A') {
                                    vm.ninebox2AList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B+') {
                                    vm.ninebox2BList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B') {
                                    vm.ninebox2BList.push(data[i]);
                                    console.log(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C+') {
                                    vm.ninebox2CList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C') {
                                    vm.ninebox2CList.push(data[i]);
                                }

                            }
                            if (data[i].emp_potential.summary_id === 1) {

                                if (data[i].result_adjustment[0].result2 === 'A') {
                                    vm.ninebox3AList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B+') {
                                    vm.ninebox3BList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B') {
                                    vm.ninebox3BList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C+') {
                                    vm.ninebox3CList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C') {
                                    vm.ninebox3CList.push(data[i]);
                                }

                            }
                        }
                    }
                }

            }, 50);

            // vm.ninebox3AList.push({nik: '02010010'});

            angular.element('#talentReviewView').unblock();
        }

        var resViewBu = TalentReview.query({ action: 'viewDivisiByMgrData' });
        resViewBu.$promise.then(function (data) {
            vm.listDivision = data;
        });

        resViewBu.$promise.catch(function (data) {
            $log.info(data);
        });

    }
})();

(function () {
    'use strict';
    angular.module('app.pms.talent_review_admin.set-projection-member', []).config(config);
    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) { }
})();
(function () {
    'use strict';
    angular.module('app.pms.talent_review_admin.set-projection-member').controller('SetProjectionMemberController', SetProjectionMemberController);
    SetProjectionMemberController.$inject = ['$state', '$stateParams', '$mdDialog', '$mdToast', 'data', '$localStorage', '$timeout', 'Form', 'AppAPI', 'Auth'];
    /** @ngInject */
    function SetProjectionMemberController($state, $stateParams, $mdDialog, $mdToast, data, $localStorage, $timeout, Form, AppAPI, Auth) {
        var vm = this;
        var TalentReview = AppAPI.TalentReview();
        vm.hide = hide;
        vm.cancel = cancel;
        vm.data = data;
        vm.projection = (typeof (vm.data.talent) !== 'undefined') ? vm.data.talent.projection : '';
        vm.saveData = saveData;

        Form.initialForm();
        Form.setObject(TalentReview);
        vm.Form = Form;
        vm.setToken = Auth.setToken;

        function saveData(ev, formController) {

            vm.Form.objForm.nik = vm.data.nik;
            vm.Form.objForm.projection = vm.projection;

            var promise = Form.saveData('setProjection', formController, TalentReview);

            promise.then(successSaveData);
            promise.catch(failedSaveData);

        }

        function successSaveData() {
            vm.Form.tampilPesan = false;
            vm.messageTheme = 'green';

            $mdToast.show(
                $mdToast.simple()
                    .textContent(vm.Form.pesan)
                    .position('top right')
                    .hideDelay(3000)
                    .theme("success-toast")
            );

            $mdDialog.cancel();

            vm.setToken();

        }

        function failedSaveData() {
            vm.messageTheme = 'red';

            vm.setToken();
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pms.talent_review_admin.input-talent-review-member', [
        ])
        .config(config);

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {



    }
})();
(function () {
    'use strict';

    angular.module('app.pms.talent_review_admin.input-talent-review-member')
        .controller('InputTalentReviewMemberController', InputTalentReviewMemberController);

    InputTalentReviewMemberController.$inject = ['$state', '$stateParams', '$mdDialog', 'data', '$localStorage', '$timeout', 'Form', 'AppAPI', 'Auth'];
    /** @ngInject */
    function InputTalentReviewMemberController($state, $stateParams, $mdDialog, data, $localStorage, $timeout, Form, AppAPI, Auth) {

        var vm = this;
        vm.hide = hide;
        vm.cancel = cancel;
        vm.data = data;

        console.log('data', data);

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.talent_review.talent-review-9box', ['ngDragDrop'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_talent_review_9box', {
                url    : '/pms/talent-review-9box',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/talent-review/talent-review-9box/talent-review-9box.html',
                        controller : 'TalentReview9BoxController as vm'
                    }
                }
            });

   

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pms.talent_review.talent-review-9box')
        .controller('TalentReview9BoxController', TalentReview9BoxController);


    TalentReview9BoxController.$inject = ['$state', '$localStorage', '$document', '$http', '$scope', 'config', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', 'FileUploader', 'Form', '$window', '$timeout', '$mdToast'];
    /** @ngInject */
    function TalentReview9BoxController($state, $localStorage, $document, $http, $scope, config, $log, $mdDialog, AppAPI, Auth, DataService, FileUploader, Form, $window, $timeout, $mdToast) {

        var vm = this;
        var TalentReview = AppAPI.TalentReview();

        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [
            { link: '#', name: 'Team Perf. Mgt. / ', active: '0' }
        ];

        vm.is_color = false;

        vm.ninebox1AList = [];
        vm.ninebox2AList = [];
        vm.ninebox3AList = [];
        vm.ninebox1BList = [];
        vm.ninebox2BList = [];
        vm.ninebox3BList = [];
        vm.ninebox1CList = [];
        vm.ninebox2CList = [];
        vm.ninebox3CList = [];

        vm.saveNineBoxToDraft = saveNineBoxToDraft;
        vm.saveSubmitNineBox = saveSubmitNineBox;
        vm.resetNineBox = resetNineBox;
        vm.saveData = saveData;
        vm.status = '';

        Form.initialForm();
        Form.setObject(TalentReview);
        vm.Form = Form;
        vm.setToken = Auth.setToken;

        vm.optionsEvents = {
            accept: function (dragEl) {
                var data = angular.element(dragEl[0]).data();
                var item = data.$scope.item;
                //console.log('data', dragEl[0]);
                // console.log('vm.ninebox3AList', vm.ninebox3AList);
                // console.log('vm.ninebox2AList', vm.ninebox2AList);
                // console.log('vm.ninebox3BList', vm.ninebox3BList);
                //console.log('dragEl', dragEl);
                // if (vm.ninebox1AList.length >= 2) {
                //   return false;
                // } else {
                //   return true;
                // }
                return false;
            }
        };

        // set 9-box table layout fixed square
        setTimeout(function () {
            fixedSquare();
        }, 20);

        var appWindow = angular.element($window);
        appWindow.bind('resize', function () {
            fixedSquare();
        });

        function fixedSquare() {
            var widthninebox = angular.element(document.querySelectorAll(".nine-box-area")[0]).prop('offsetWidth');
            vm.heightninebox = angular.element(document.querySelectorAll(".nine-box-area")[0]).clientHeight = widthninebox;
        }

        function saveNineBoxToDraft(e) {
            var datas = {};
            datas['_1A'] = vm.ninebox1AList;
            datas['_2A'] = vm.ninebox2AList;
            datas['_3A'] = vm.ninebox3AList;
            datas['_1B'] = vm.ninebox1BList;
            datas['_2B'] = vm.ninebox2BList;
            datas['_3B'] = vm.ninebox3BList;
            datas['_1C'] = vm.ninebox1CList;
            datas['_2C'] = vm.ninebox2CList;
            datas['_3C'] = vm.ninebox3CList;

            vm.Form.objForm.is_draft = true;
            vm.Form.objForm.data = datas;

            var form = angular.element(document.getElementById('frmSaveNineBox'));
            $timeout(function () {
                form.triggerHandler("submit");
            });

        };

        function saveSubmitNineBox(e) {
            var datas = {};
            datas['_1A'] = vm.ninebox1AList;
            datas['_2A'] = vm.ninebox2AList;
            datas['_3A'] = vm.ninebox3AList;
            datas['_1B'] = vm.ninebox1BList;
            datas['_2B'] = vm.ninebox2BList;
            datas['_3B'] = vm.ninebox3BList;
            datas['_1C'] = vm.ninebox1CList;
            datas['_2C'] = vm.ninebox2CList;
            datas['_3C'] = vm.ninebox3CList;

            vm.Form.objForm.is_draft = false;
            vm.Form.objForm.data = datas;

            var form = angular.element(document.getElementById('frmSaveNineBox'));
            $timeout(function () {
                form.triggerHandler("submit");
            });
        };

        function saveData(ev, formController) {

            var promise = Form.saveData('save9box', formController, TalentReview);

            promise.then(successSaveData);
            promise.catch(failedSaveData);

        }

        function successSaveData() {
            vm.Form.tampilPesan = false;
            vm.messageTheme = 'green';

            $mdToast.show(
                $mdToast.simple()
                    .textContent(vm.Form.pesan)
                    .position('top right')
                    .hideDelay(3000)
                    .theme("success-toast")
            );

            vm.setToken();

        }

        function failedSaveData() {
            vm.messageTheme = 'red';

            vm.setToken();
        }

        function resetNineBox(e) {
            vm.ninebox1AList = [];
            vm.ninebox2AList = [];
            vm.ninebox3AList = [];
            vm.ninebox1BList = [];
            vm.ninebox2BList = [];
            vm.ninebox3BList = [];
            vm.ninebox1CList = [];
            vm.ninebox2CList = [];
            vm.ninebox3CList = [];
            loadData(1);
        }

        loadData(1);

        function loadData(pageno) {
            angular.element('#talentReviewView').block({ message: 'please wait..' });
            var tahun = vm.tahun;
            var bulan = vm.bulan;
            var resp = TalentReview.query({ action: 'viewdataninebox', tahun: tahun, bulan: bulan, nik: vm.nik });
            resp.$promise.then(fetchTalentReviewData);
            resp.$promise.catch(errFetchTalentReviewData);
        }

        function errFetchTalentReviewData(data) {
            vm.listTalentReviewNineBox = [];
            angular.element('#talentReviewView').unblock();
        }

        function fetchTalentReviewData(data) {
            vm.listTalentReviewNineBox = data;
            vm.listTalentReviewNineBoxTmp = data;


            console.log('vm.listTalentReviewNineBox', vm.listTalentReviewNineBox);

            setTimeout(function () {

                for (var i = 0; i <= (data.length - 1); i++) {

                    if (vm.status === '') {
                        if (data[i].status !== '') {
                            vm.status = data[i].status;
                        }
                    }

                    if (typeof (data[i].ninebox_code) !== 'undefined' && data[i].ninebox_code !== null) {

                        if (data[i].ninebox_code === '1A') {
                            vm.ninebox1AList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '1B') {
                            vm.ninebox1BList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '1C') {
                            vm.ninebox1CList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '2A') {
                            vm.ninebox2AList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '2B') {
                            vm.ninebox2BList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '2C') {
                            vm.ninebox2CList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '3A') {
                            vm.ninebox3AList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '3B') {
                            vm.ninebox3BList.push(data[i]);
                        }
                        if (data[i].ninebox_code === '3C') {
                            vm.ninebox3CList.push(data[i]);
                        }


                    } else {

                        if (typeof (data[i].emp_potential) !== undefined && typeof (data[i].result_adjustment) !== undefined) {

                            if (data[i].emp_potential.summary_id === 3) {

                                if (data[i].result_adjustment[0].result2 === 'A') {
                                    vm.ninebox1AList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B+') {
                                    vm.ninebox1BList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B') {
                                    vm.ninebox1BList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C+') {
                                    vm.ninebox1CList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C') {
                                    vm.ninebox1CList.push(data[i]);
                                }

                            }
                            if (data[i].emp_potential.summary_id === 2) {

                                if (data[i].result_adjustment[0].result2 === 'A') {
                                    vm.ninebox2AList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B+') {
                                    vm.ninebox2BList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B') {
                                    vm.ninebox2BList.push(data[i]);
                                    console.log(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C+') {
                                    vm.ninebox2CList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C') {
                                    vm.ninebox2CList.push(data[i]);
                                }

                            }
                            if (data[i].emp_potential.summary_id === 1) {

                                if (data[i].result_adjustment[0].result2 === 'A') {
                                    vm.ninebox3AList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B+') {
                                    vm.ninebox3BList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'B') {
                                    vm.ninebox3BList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C+') {
                                    vm.ninebox3CList.push(data[i]);
                                }
                                if (data[i].result_adjustment[0].result2 === 'C') {
                                    vm.ninebox3CList.push(data[i]);
                                }

                            }
                        }
                    }
                }

            }, 50);

            // vm.ninebox3AList.push({nik: '02010010'});

            angular.element('#talentReviewView').unblock();
        }

        var resViewBu = TalentReview.query({ action: 'viewDivisiByMgrData' });
        resViewBu.$promise.then(function (data) {
            vm.listDivision = data;
        });

        resViewBu.$promise.catch(function (data) {
            $log.info(data);
        });

    }
})();

(function() {
    'use strict';
    angular.module('app.pms.talent_review.set-projection-member', []).config(config);
    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {}
})();
(function() {
    'use strict';
    angular.module('app.pms.talent_review.set-projection-member').controller('SetProjectionMemberController', SetProjectionMemberController);
    SetProjectionMemberController.$inject = ['$state', '$stateParams', '$mdDialog', '$mdToast', 'data', '$localStorage', '$timeout', 'Form', 'AppAPI', 'Auth'];
    /** @ngInject */
    function SetProjectionMemberController($state, $stateParams, $mdDialog, $mdToast, data, $localStorage, $timeout, Form, AppAPI, Auth) {
        var vm           = this;
        var TalentReview = AppAPI.TalentReview();
        vm.hide          = hide;
        vm.cancel        = cancel;
        vm.data          = data;
        vm.projection    = (typeof(vm.data.talent) !== 'undefined') ? vm.data.talent.projection : '';
        vm.saveData      = saveData;

        Form.initialForm();
        Form.setObject(TalentReview);
        vm.Form          = Form;
        vm.setToken      = Auth.setToken;

        function saveData(ev, formController) {   

            vm.Form.objForm.nik = vm.data.nik;
            vm.Form.objForm.projection = vm.projection;
        
            var promise = Form.saveData('setProjection', formController, TalentReview);

            promise.then(successSaveData);
            promise.catch(failedSaveData);           

        }

        function successSaveData() {
            vm.Form.tampilPesan = false;
            vm.messageTheme='green';

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.Form.pesan)
                .position('top right')
                .hideDelay(3000)
                .theme("success-toast")
            );

            $mdDialog.cancel();

            vm.setToken();
            
        }

        function failedSaveData() {
            vm.messageTheme='red';

            vm.setToken();
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.talent_review.input-talent-review-member', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     
      
    }
})();
(function () {
    'use strict';

    angular.module('app.pms.talent_review.input-talent-review-member')
           .controller('InputTalentReviewMemberController', InputTalentReviewMemberController);

    InputTalentReviewMemberController.$inject=['$state','$stateParams','$mdDialog','data','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function InputTalentReviewMemberController($state,$stateParams,$mdDialog,data,$localStorage,$timeout,Form,AppAPI,Auth) {
        
        var vm  = this;
        vm.hide = hide;
        vm.cancel = cancel;
        vm.data = data;

        console.log('data', data);

        function hide() {
            $mdDialog.hide();
        }
       
        function cancel() {
            $mdDialog.cancel();
        }

    }

})();  

(function ()
{
    'use strict';

    angular
        .module('app.pms.reports', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider','menuProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider,menuProvider)
    {


        // State
        $stateProvider
            .state('app.pms_report_kpi', {
                url    : '/pms/reports/kpi',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/reports/kpi/kpi.html',
                        controller:'KpireportskpiController as vm'
                    }
                }
            }); 

         // State
        $stateProvider
            .state('app.pms_report_kpinonpeople', {
                url    : '/pms/reports/kpinonpeople',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/reports/kpi/kpinonpeople.html',
                        controller:'KpireportsnonpeopleController as vm'
                    }
                }
            });     

             // State
        $stateProvider
            .state('app.pms_report_kpipeople', {
                url    : '/pms/reports/kpipeople',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/reports/kpi/kpipeople.html',
                        controller:'KpireportspeopleController as vm'
                    }
                }
            });   

         // State
        $stateProvider
            .state('app.pms_report_pa', {
                url    : '/pms/reports/pa',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/reports/kpi/pa.html',
                        controller:'PaController as vm'
                    }
                }
            });    


               // State
        $stateProvider
            .state('app.pms_report_chart', {
                url    : '/pms/reports/charts',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/reports/kpi/chart.html',
                        controller:'ChartController as vm'
                    }
                }
            });   

               // State
        $stateProvider
            .state('app.pms_report_chart_bu', {
                url    : '/pms/reports/charts-bu',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/reports/kpi/chartbu.html',
                        controller:'ChartbuController as vm'
                    }
                }
            });                 

       //  msNavigationServiceProvider.saveItem('pms.reports.kpi', {
       //      title    : 'KPI',
       //      icon     : 'icon-file',
       //      state    : 'app.pms_report_kpi',
       //      weight   : 2,  
       //       hidden:function(){
       //         return menuProvider.checkRule('145');
       //      }
           
          
       // });
 
           //    msNavigationServiceProvider.saveItem('pms.reports.kpinonpeople', {
           //  title    : 'KPI Non People',
           //  icon     : 'icon-file',
           //  state    : 'app.pms_report_kpinonpeople',
           //  weight   : 2,  
           // hidden:function(){
           //     return menuProvider.checkRule('146');
           //  }
       
           // });

           //       msNavigationServiceProvider.saveItem('pms.reports.kpipeople', {
           //  title    : 'KPI People',
           //  icon     : 'icon-file',
           //  state    : 'app.pms_report_kpipeople',
           //  weight   : 2,  
           //  hidden:function(){
           //     return menuProvider.checkRule('149');
           //  }
       
           // });


           //  msNavigationServiceProvider.saveItem('pms.reports.pa', {
           //  title    : 'Performance Value',
           //  icon     : 'icon-file',
           //  state    : 'app.pms_report_pa',
           //  weight   : 2,  
           //   hidden:function(){
           //     return menuProvider.checkRule('144');
           //  }
       
           // });     


           //  msNavigationServiceProvider.saveItem('pms.reports.charts', {
           //  title    : 'Charts PA',
           //  icon     : 'icon-chart-bar',
           //  state    : 'app.pms_report_chart',
           //  weight   : 2,  
           //   hidden:function(){
           //     return menuProvider.checkRule('147');
           //  }
       
           // });    

           //  msNavigationServiceProvider.saveItem('pms.reports.chartsbu', {
           //  title    : 'Charts PA By BU',
           //  icon     : 'icon-chart-bar',
           //  state    : 'app.pms_report_chart_bu',
           //  weight   : 2,  
           //  hidden:function(){
           //     return menuProvider.checkRule('148');
           //  }
       
           // });            
 
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.reports')
        .controller('PaController', PaController);

          PaController.$inject=['$window','$location','$localStorage','AppAPI','DataService','config','Auth'];
    /** @ngInject */
    function PaController($window,$location,$localStorage,AppAPI,DataService,config,Auth)
    {

     var vm                = this;
     vm.listJum            = [2,5,25,50,75,100,200];
     vm.DataTable          = new DataService();
     var KPI               = AppAPI.Reportpa();
     vm.loadData           = loadData;
     vm.ExportToExcel      = ExportToExcel;
     vm.loadDataDivision   = loadDataDivision;
     vm.loadDataDepartment = loadDataDepartment;
     vm.bu                 = 'all';
     vm.divisi             = 'all';
     vm.department         = 'all';
     vm.periodeSelected    = 'yearly';
     vm.loadData           = loadData;
     var today             = new Date();
     var year              = today.getFullYear();
     vm.yearSelected       = year;
     vm.years              = [{year:2020,selected:true},{year:2019,selected:false},{year:2018,selected:false},{year:2017,selected:false},{year:2016,selected:false},{year:2015,selected:false}];
     vm.periode            = [{periode:'Q1'},{periode:'Q2'},{periode:'Q3'},{periode:'Q4'}];

     vm.empsite            = $localStorage.empsite;
     vm.group              = $localStorage.group;
     vm.showMpp            = showMpp;

checkSelectedYear();
      loadData(1);
       loadDataBU();


function showMpp(year) {
   vm.yearSelected=year;
           checkSelectedYear();
           loadData();
      }
function checkSelectedYear()
        {

           // var lengthYear=vm.years
            angular.forEach(vm.years,function(obj){
               if(obj.year===vm.yearSelected)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }
      function loadData(pageno)
      {
          vm.DataTable.loadData(KPI,pageno,{action:'viewdatapa',bu:vm.bu,divisi:vm.divisi,department:vm.department,year:vm.yearSelected,periode:vm.periodeSelected});
      }

      // function loadDataDivision(idbu) {
      //    var response=KPI.query({action:'viewDivisiBu',idbu:idbu,year:vm.yearSelected,periode:vm.periodeSelected});
      //   response.$promise.then(fetchDivisiBU);
      //   response.$promise.catch(errorDivisiBU);
      // }

      function loadDataDivision(idbu) {
         var response=KPI.query({action:'viewDivisiBu',idbu:idbu});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
      }

      // function loadDataDepartment(iddivisi) {
      //    var response=KPI.query({action:'viewDivisiDept',idbu:vm.bu,iddivisi:iddivisi,year:vm.yearSelected,periode:vm.periodeSelected});
      //   response.$promise.then(fetchDepartment);
      //   response.$promise.catch(errorDepartment);
      // }

      function loadDataDepartment(iddivisi) {
         var response=KPI.query({action:'viewDivisiDept',idbu:vm.bu,iddivisi:iddivisi});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listDepartment=data;
        loadData(1);
      }

      function errorDepartment() {
        vm.listDepartment=[];
      }

      function fetchDivisiBU(data) {
       vm.listDivisi=data;
       loadData(1);
      }

      function errorDivisiBU() {
        vm.listDivisi=[];
      }

      // function loadDataBU(year) {
      //   var response=KPI.query({action:'viewBu',year:year,periode:vm.periodeSelected});
      //   response.$promise.then(fetchBU);
      //   response.$promise.catch(errorFetchBU);
      // }

      function loadDataBU() {
        var response=KPI.query({action:'viewBu'});
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
        vm.listBu=data;

        if(vm.group === '110' || vm.group === '116') {
          vm.bu = vm.empsite;
          loadDataDivision(vm.bu);
        }

      }

      function errorFetchBU() {
        vm.listBu=[];
      }

      function ExportToExcel() {
                   var token=Auth.setTokenPromise();
                      token.then(function(data){
                              var protocol=$location.protocol();
                              var host=$location.host();
                             $window.open(protocol+'://'+host+config.api+'api/kpi/exportexcel/'+vm.bu+'/'+vm.divisi+'/'+vm.department+'/'+vm.yearSelected+'/'+vm.periodeSelected+'/'+data.token, '_blank');
                      },function(){

                          $window.alert('gagal load token');
                      });
      }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.reports')
        .controller('KpireportspeopleController', KpireportspeopleController);

          KpireportspeopleController.$inject=['AppAPI','DataService'];
    /** @ngInject */
    function KpireportspeopleController(AppAPI,DataService)
    {
      
      var vm =this;
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
     var KPI=AppAPI.Reportkpipeople();
     vm.loadData=loadData;

      loadData(1);

      function loadData(pageno)
      {
          vm.DataTable.loadData(KPI,pageno,{action:'viewdatakpipeople'});
      }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.reports')
        .controller('KpireportsnonpeopleController', KpireportsnonpeopleController);

          KpireportsnonpeopleController.$inject=['AppAPI','DataService'];
    /** @ngInject */
    function KpireportsnonpeopleController(AppAPI,DataService)
    {
      
      var vm =this;
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
     var KPI=AppAPI.Reportkpinonpeople();
     vm.loadData=loadData;

      loadData(1);

      function loadData(pageno)
      {
          vm.DataTable.loadData(KPI,pageno,{action:'viewdatanonpeople'});
      }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.reports')
        .controller('KpireportskpiController', KpireportskpiController);

          KpireportskpiController.$inject=['AppAPI','DataService'];
    /** @ngInject */
    function KpireportskpiController(AppAPI,DataService)
    {
      
      var vm =this;
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
     var KPI=AppAPI.Reportkpi();
     vm.loadData=loadData;

      loadData(1);

      function loadData(pageno)
      {
          vm.DataTable.loadData(KPI,pageno,{action:'viewdatakpi'});
      }

    }
})();

(function ()
{
    'use strict';
 
    angular
        .module('app.pms.reports')
        .controller('ChartbuController', ChartbuController);

          ChartbuController.$inject=['AppAPI','DataService'];
    /** @ngInject */
    function ChartbuController(AppAPI,DataService)
    {
      
      var vm =this;
      var Division = AppAPI.Division();
      var Kpi = AppAPI.Reportchartpabu();
      vm.viewDataBu=viewDataBu;
      vm.viewDataDivisi=viewDataDivisi;
      vm.viewDataDepartment=viewDataDepartment;
      
      var responseBu=Kpi.query({action:'viewBu'});
      responseBu.$promise.then(fetchBu);
      responseBu.$promise.catch(errorFetchBu);

      function viewDivisi(idbu) {
        var responseDivisi=Kpi.query({action:'viewDivisiBu',idbu:idbu});
      responseDivisi.$promise.then(fetchDivisi);
      responseDivisi.$promise.catch(errorFetchDivisi);
      }

      function viewDeptDivisi(idbu,iddiv) {
        var responseDept=Kpi.query({action:'viewDivisiDept',idbu:idbu,iddivisi:iddiv});
      responseDept.$promise.then(fetchDivDept);
      responseDept.$promise.catch(errorFetchDivDept);
      }
      function viewDataDivisi(id,name) {
        angular.element('#chartByDivisi').block();
        vm.nameDivisi=name;
        var newid=vm.idBU+'-'+id;
         vm.idDivisi=id;
         viewDeptDivisi(vm.idBU,id);
         var response=Kpi.get({action:'viewAllChart',id:newid,type:'bu'});
         response.$promise.then(fetchDataDivisiChart);
         response.$promise.catch(errorFetchDataDivisiChart);
      }


      function viewDataDepartment(id,name) {
        angular.element('#chartByDept').block();
        vm.nameDepartment=name;
        var newid=vm.idBU+'-'+vm.idDivisi+'-'+id;
         var response=Kpi.get({action:'viewAllChart',id:newid,type:'bu'});
         response.$promise.then(fetchDataDeptChart);
         response.$promise.catch(errorFetchDataDeptChart);
      }

      function fetchDataDivisiChart(data) {
           vm.dataMutudiv= [data.mutu1];
           vm.dataAdj1div=[data.adj1];
            vm.dataAdj2div=[data.adj2];
        var ticks = data.tick;
        vm.optionsBadjdiv={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1div={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2div={
           title:'After Adjustment 2',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         angular.element('#chartByDivisi').unblock();
      }

      function errorFetchDataDivisiChart() {
         angular.element('#chartByDivisi').unblock();
      }

      function fetchBu(data) {
        vm.listBu=data;
      }

      function errorFetchBu() {
        vm.listBu=[];
        vm.listDivisi=[];
        vm.listDepartment=[];
      }

       function fetchDivisi(data) {
        vm.listDivisi=data;
      }

      function errorFetchDivisi() {
        vm.listDivisi=[];
        vm.listDepartment=[];
      }


        function fetchDivDept(data) {
        vm.listDepartment=data;
      }

      function errorFetchDivDept() {
        vm.listDepartment=[];
      }

      function viewDataBu(id,name) {
        angular.element('#chartByBu').block();
        vm.namaBu=name;
        vm.idBU=id;
        viewDivisi(id);
        var response=Kpi.get({action:'viewAllChart',id:id,type:'bu'});
         response.$promise.then(fetchDataBuChart);
         response.$promise.catch(errorFetchDataBuChart);
      }

      function fetchDataBuChart(data) {
         vm.dataMutuBu= [data.mutu1];
           vm.dataAdj1Bu=[data.adj1];
            vm.dataAdj2Bu=[data.adj2];
        var ticks = data.tick;
        vm.optionsBadjBu={
          title:'Before Adjustment',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1Bu={
           title:'After Adjustment 1',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2Bu={
           title:'After Adjustment 2',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };
          angular.element('#chartByBu').unblock();
        
      }

      function errorFetchDataBuChart(data) {
       angular.element('#chartByBu').unblock();
      }


      function fetchDataDeptChart(data) {
           vm.dataMutuDept= [data.mutu1];
           vm.dataAdj1Dept=[data.adj1];
            vm.dataAdj2Dept=[data.adj2];
        var ticks = data.tick;
        vm.optionsBadjDept={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1Dept={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2Dept={
           title:'After Adjustment 2',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         angular.element('#chartByDept').unblock();
      }

      function errorFetchDataDeptChart() {
         angular.element('#chartByDept').unblock();
      }
    }
})();

(function ()
{
    'use strict';
 
    angular
        .module('app.pms.reports')
        .controller('ChartController', ChartController);

          ChartController.$inject=['AppAPI','DataService'];
    /** @ngInject */
    function ChartController(AppAPI,DataService)
    {
      
      var vm =this;
      var Division = AppAPI.Division();
      var Kpi = AppAPI.Reportchartpa();
      vm.viewDataDivision=viewDataDivision;
      
      
      var responseDivision=Kpi.query({action:'viewDivision'});
      responseDivision.$promise.then(fetchDivision);
      responseDivision.$promise.catch(errorFetchDivision);

       loadDataPa();
      function loadDataPa() {
        angular.element('#allChart').block();
         var response=Kpi.get({action:'viewAllChart',id:'all',type:'group'});
         response.$promise.then(fetchDataAllChart);
         response.$promise.catch(errorFetchDataAllChart);
      }

      function fetchDataAllChart(data) {
           vm.dataMutu= [data.mutu1];
           vm.dataAdj1=[data.adj1];
            vm.dataAdj2=[data.adj2];
            vm.dataAll=[data.mutu1,data.adj1,data.adj2];
        var ticks = data.tick;
        vm.optionsBadj={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2={
           title:'After Adjustment 2',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

        vm.optionsAadjAll={
           title:'After Adjustment 2',
           seriesColors:['#E91E63','#FF9800','#4CAF50'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                }
            }
        };

          angular.element('#allChart').unblock();
      }

      function errorFetchDataAllChart() {
        angular.element('#allChart').unblock();
      }

      function fetchDivision(data) {
        vm.listDivision=data;
      }

      function errorFetchDivision() {
        vm.listDivision=[];
      }

      function viewDataDivision(id,name) {
        angular.element('#chartPaByDIvision').block();
        vm.DivisionName=name;
        var response=Kpi.get({action:'viewAllChart',id:id,type:'group'});
         response.$promise.then(fetchDataDivisionChart);
         response.$promise.catch(errorFetchDataDivisionChart);
      }

      function fetchDataDivisionChart(data) {
         vm.dataMutuDiv= [data.mutu1];
           vm.dataAdj1Div=[data.adj1];
            vm.dataAdj2Div=[data.adj2];
        var ticks = data.tick;
        vm.optionsBadjDiv={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1Div={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2Div={
           title:'After Adjustment 2',
          seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };
          angular.element('#chartPaByDIvision').unblock();
        
      }

      function errorFetchDataDivisionChart(data) {
       angular.element('#chartPaByDIvision').unblock();
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_team.set-team-member', [])
        .config(config);

     config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
      $stateProvider
             .state('app.pms_kpi_team_set_team_member', {
                url    : '/pms/kpi-team/set-team-member/set-team-member/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi-team/set-team-member/set-team-member.html',
                        controller : 'SetteammemberController as vm'
                    }
                }
            });   

             $stateProvider
             .state('app.pms_kpi_team_set_team_memberD', {
                url    : '/pms/kpi-team/set-team-member/set-team-memberD/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi-team/set-team-member/set-team-memberD.html',
                        controller : 'SetteammemberDController as vm'
                    }
                }
            });     
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_team.set-team-member')
        .controller('SetteammemberDController', SetteammemberDController)


    SetteammemberDController.$inject=['DataService','$state','$mdDialog','AppAPI','Auth','Form','$localStorage','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function SetteammemberDController(DataService,$state,$mdDialog,AppAPI,Auth,Form,$localStorage,DTColumnDefBuilder,$timeout,$stateParams)
    {
        
    var vm = this;
    vm.username=$localStorage.user;
    // initial form
    Form.initialForm();
    vm.nik=$stateParams.id;
    //vm.approveKS=approveKS;
    vm.closeKpi=closeKpi;
    vm.select=select;
    vm.toggleSelectedAll=toggleSelectedAll;
    vm.viewScales=viewScales;
    vm.isChecked=isChecked;
     vm.toggleCheck = toggleCheck;
    vm.listKSSelected=[];
    var teamMember=AppAPI.teamMember();
    var teamMembern2=AppAPI.Kpiteam();
    vm.DataTable= new DataService();
    vm.showKpi=showKpi;
    vm.loadData=loadData;
    var today = new Date();
    var year = today.getFullYear();
    vm.yearSelected=year;
    vm.years=[{year:2017,selected:false},{year:2016,selected:false},{year:2015,selected:false}];
    checkSelectedYear();
    loadData(1);
    loadDataEff();
    loadPA();

 

        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers',
            paging:false,
            searching:false
        };

  function checkSelectedYear()
        {

           // var lengthYear=vm.years
            angular.forEach(vm.years,function(obj){
               if(obj.year===vm.yearSelected)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }  

  
   function showKpi(year)
        {   
            vm.listKSSelected=[];
           vm.yearSelected=year;
           checkSelectedYear();
           loadData(1);
           loadPA();
        }           

function isChecked(ks)
        {
            return vm.listKSSelected.indexOf(ks) > -1;
        }

function toggleCheck(ks, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listKSSelected.indexOf(ks);

            if ( idx > -1 )
            {
                vm.listKSSelected.splice(idx, 1);
            }
            else
            {
                vm.listKSSelected.push(ks);
            }
        }

function loadData(pageno)
      {
        var KpiScales=AppAPI.KpiScales();
          vm.DataTable.loadData(KpiScales,pageno,{action:'viewdatayearnonapp',eff:vm.yearSelected,id:vm.nik});
         // loadDataEff();
         vm.listKSSelected=[];
      }


         function viewScales(ev,kpi) {
           $mdDialog.show({
              controller: 'SetteammemberscaleController',
              controllerAs:'vm',
              templateUrl: 'app/main/pms/kpi-team/set-team-member/set-team-member-scale.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              locals:{
                kpi:kpi
              }
            });
    }
    

     function loadDataEff() {
         angular.element.blockUI();
        var buPromise=teamMember.query({action:'viewdetail',id:$stateParams.id});
        buPromise.$promise.then(fetchEff);
        buPromise.$promise.catch(errorFetchEff); 
         
      }

      function fetchEff(data) {
        vm.listkpi=data;  

        angular.forEach(vm.listkpi, function(value, key) {

      });  


         angular.element.unblockUI();
        
      }

      function errorFetchEff() {
        vm.listkpi=[];
         angular.element.unblockUI();
      }

      function select(ks){
        return vm.listKSSelected;
      }

    function closeKpi()
    {
        $mdDialog.hide();
    }

    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listKSSelected=angular.copy(vm.listkpi);

    }

    function unCheckAll() {
       vm.listKSSelected=[];
    }


function loadPA()
        {
            if(vm.yearSelected==year){
                vm.addCon=true;
            }else{
                 vm.addCon=false;
            }
          var response=teamMembern2.query({action:'viewpapeopleteam',year:vm.yearSelected,nik:vm.nik});
          response.$promise.then(fetchKpi);
          response.$promise.catch(errorFetchKpi);
        }

         function fetchKpi(data)
        {
           vm.listPA=data;
        }

        function errorFetchKpi()
        {
           vm.listPA=[];
        }
     /*function approveKS(ev) {

        if (!vm.listKSSelected.length){

             vm.tampilPesan=true;
             vm.pesan='Please Checkbox!';
             vm.messageTheme='blue';
             $timeout(function() {
                 vm.tampilPesan=false;
             }, 3000);
      
        }else{
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to Approve this list?')
          .textContent('All data your selected will be approve.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');
    $mdDialog.show({
            multiple: true
       });      
    $mdDialog.show(confirm).then(function() {
          angular.element.blockUI();

       var response=teamMember.delete({action:'approve',data:angular.toJson(vm.listKSSelected)});
       response.$promise.then(loadData);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
   // }}
   
    }*/
}


})();

(function () {
  'use strict';

  angular
    .module('app.pms.kpi_team.set-team-member')
    .controller('SetteammemberController', SetteammemberController)


  SetteammemberController.$inject = ['DataService', '$state', '$mdDialog', '$localStorage', '$window', 'AppAPI', 'Auth', 'Form', 'DTColumnDefBuilder', '$timeout', '$stateParams', '$filter'];
  /** @ngInject */
  function SetteammemberController(DataService, $state, $mdDialog, $localStorage, $window, AppAPI, Auth, Form, DTColumnDefBuilder, $timeout, $stateParams, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.username = $localStorage.user;
    // initial form
    Form.initialForm();
    var KPI = AppAPI.Kpi();
    vm.nik = $stateParams.id;
    vm.approveKS = approveKS;
    vm.UnApproved = UnApproved;
    vm.closeKpi = closeKpi;
    vm.select = select;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.viewScales = viewScales;
    vm.viewResult = viewResult;
    vm.isChecked = isChecked;
    vm.editKPI = editKPI;
    vm.toggleCheck = toggleCheck;
    vm.listKSSelected = [];
    var teamMember = AppAPI.Kpiteam();
    vm.DataTable = new DataService();
    vm.showKpi = showKpi;
    vm.loadData = loadData;
    var today = new Date();
    var year = today.getFullYear();
    vm.yearSelected = year;
    vm.approvedPA = approvedPA;
    vm.years = [{ year: 2020, selected: false }, { year: 2019, selected: false }, { year: 2018, selected: false }, { year: 2017, selected: false }, { year: 2016, selected: false }, { year: 2015, selected: false }];
    checkSelectedYear();
    loadData(1);
    loadDataEff();
    loadPA();


    vm.dtOptions = {
      dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
      autoWidth: false,
      responsive: true,
      pagingType: 'full_numbers',
      paging: false,
      searching: false
    };

    function checkSelectedYear() {
      angular.forEach(vm.years, function (obj) {
        if (obj.year === vm.yearSelected) {
          obj.selected = true;
        } else {
          obj.selected = false;
        }
      });
    }

    function editKPI(ev, kpi) {
      kpi.dariAtasan = true;
      $mdDialog.show({
        controller: 'editkpiController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pms/kpi/inputkpi/inputkpi.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          kpi: kpi,
          expireDate: vm.expireDate,
          maxweight: vm.totalweight,
          months: monthName,
          years: vm.yearSelected
        },
        onRemoving: function (element, removePromise) {
          loadData();
        },
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function showKpi(year) {
      vm.listKSSelected = [];
      vm.yearSelected = year;
      checkSelectedYear();
      loadData(1);
      loadPA();
    }

    function isChecked(ks) {
      return vm.listKSSelected.indexOf(ks) > -1;
    }

    function showKpi(year) {
      vm.listKSSelected = [];
      vm.yearSelected = year;
      checkSelectedYear();
      loadData(1);
      loadPA();
    }

    function isChecked(ks) {
      return vm.listKSSelected.indexOf(ks) > -1;
    }

    function toggleCheck(ks, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listKSSelected.indexOf(ks);

      if (idx > -1) {
        vm.listKSSelected.splice(idx, 1);
      }
      else {
        vm.listKSSelected.push(ks);
      }
    }


    function loadData(pageno) {
      var KpiScales = AppAPI.KpiScales();
      var resp = vm.DataTable.loadDatas(KpiScales, pageno, { action: 'viewdatayear', eff: vm.yearSelected, id: vm.nik });

      resp.then(function (data) {
        vm.totalweight = 100 - parseFloat(data.bobotavailable);
        vm.expireDate = data.expireDate;
      });

      vm.listKSSelected = [];
    }

    function viewScales(ev, kpi) {
      $mdDialog.show({
        controller: 'SetteammemberscaleController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pms/kpi-team/set-team-member/set-team-member-scale.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          kpi: kpi
        }
      });
    }

    function viewResult(ev, kpi) {
      $mdDialog.show({
        controller: 'SetteammemberresultController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pms/kpi-team/set-team-member/set-team-member-result.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          kpi: kpi,
          year: vm.yearSelected,
          nik: vm.nik
        }
      });
    }

    function loadDataEff() {
      angular.element.blockUI();
      var buPromise = teamMember.query({ action: 'viewdetail', id: $stateParams.id });
      buPromise.$promise.then(fetchEff);
      buPromise.$promise.catch(errorFetchEff);
    }

    function fetchEff(data) {
      vm.listkpi = data;

      angular.forEach(vm.listkpi, function (value, key) {

      });

      angular.element.unblockUI();

    }

    function errorFetchEff() {
      vm.listkpi = [];
      angular.element.unblockUI();
    }

    function select(ks) {
      return vm.listKSSelected;
    }

    function closeKpi() {
      $mdDialog.hide();
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listKSSelected = angular.copy(vm.listkpi);
    }

    function unCheckAll() {
      vm.listKSSelected = [];
    }

    function loadPA() {
      if (vm.yearSelected == year) {
        vm.addCon = true;
      } else {
        vm.addCon = false;
      }
      var response = teamMember.query({ action: 'viewpapeopleteam', year: vm.yearSelected, nik: vm.nik });
      response.$promise.then(fetchKpi);
      response.$promise.catch(errorFetchKpi);
    }

    function fetchKpi(data) {
      vm.listPA = data;
    }

    function errorFetchKpi() {
      vm.listPA = [];
    }

    function approveKS(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirmMes = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var confirm = $mdDialog.confirm()
          .title(confirmMes)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);
        $mdDialog.show({
          multiple: true
        });
        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var tm = new teamMember();
          tm.data = [];
          tm.action = 'approve';
          var jum = vm.listKSSelected.length, i, ids = [];

          for (i = 0; i < jum; i++) {
            tm.data.push({ id: vm.listKSSelected[i].id });
          }
          var idtx = encodeURIComponent(angular.toJson(ids));
          var response = tm.$save();

          //var response=tm.$delete({action:'approve'});
          response.then(loadData);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
      // }
    }

    function approvedPA(periode) {
      var pa = new teamMember();
      pa.action = 'approvedPA';
      pa.periode = periode;
      pa.nik = vm.nik;
      pa.year = vm.yearSelected;
      var confirmMes = translate('KPI.MESSAGE.CONFPAAPP');
      var confirm = $window.confirm(confirmMes);
      if (confirm) {
        var promise = pa.$save();

        promise.then(successApp);
        promise.catch(errApp);
      }
    }
    function successApp() {
      var confirmMes = translate('PAYROLL.MESSAGE.SUCCESS');
      $window.alert(confirmMes);
      loadPA();
    }

    function errApp() {
      var confirmMes = translate('PAYROLL.MESSAGE.FAILED');
      $window.alert(confirmMes);
    }

    function UnApproved(ev, idks) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirmMes = translate('KPI.MESSAGE.CONFUNAPP');
        var note = translate('KPI.MESSAGE.UNAPPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');
        var confirm = $mdDialog.confirm()
          .title(confirmMes)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.unblockUI();
          var response = teamMember.delete({ action: 'unapproved', id: idks });
          // console.log(response);
          response.$promise.then(function () {
            loadData(1);
          });
          response.$promise.catch(function () {
            loadData(1);
          });
        }, function () {

        });
      });
    }

    var monthName = [
      { view: "Januari", value: "01" },
      { view: "Februari", value: "02" },
      { view: "Maret", value: "03" },
      { view: "April", value: "04" },
      { view: "Mei", value: "05" },
      { view: "Juni", value: "06" },
      { view: "Juli", value: "07" },
      { view: "Agustus", value: "08" },
      { view: "September", value: "09" },
      { view: "Oktober", value: "10" },
      { view: "November", value: "11" },
      { view: "Desember", value: "12" }
    ];
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_team.set-team-member')
        .controller('SetteammemberscaleController', SetteammemberscaleController)


    SetteammemberscaleController.$inject=['kpi','$state','$mdDialog','AppAPI','Auth','Form','$localStorage','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function SetteammemberscaleController(kpi,$state,$mdDialog,AppAPI,Auth,Form,$localStorage,DTColumnDefBuilder,$timeout,$stateParams)
    {
        
    var vm = this;
    vm.username=$localStorage.user;
    // initial form
    Form.initialForm();
    vm.kpi=kpi;
    vm.nik=$stateParams.id;
    vm.closeKpi=closeKpi;
    var teamMember=AppAPI.Kpiteam();
    loadDataEffJudul();
    loadDataEff();

        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers',
            paging:false,
            searching:false
        };

     
      function loadDataEffJudul() {
         angular.element.blockUI();
        var buPromise2=teamMember.query({action:'viewdetailks',id:vm.kpi,nik:vm.nik});
        buPromise2.$promise.then(fetchEffJudul);
        buPromise2.$promise.catch(errorFetchEffJudul); 
         
      }

      function fetchEffJudul(data) {
      	 vm.kpidesc=data[0].kpi;
      	 vm.uom=data[0].uom;
      	 vm.bobot=data[0].bobot;
      	 vm.target=data[0].target;
         angular.element.unblockUI();
        
      }

      function errorFetchEffJudul() {
         angular.element.unblockUI();
      }   

     function loadDataEff() {
         angular.element.blockUI();
        var buPromise=teamMember.query({action:'viewdetailks',id:vm.kpi,nik:vm.nik});
        buPromise.$promise.then(fetchEff);
        buPromise.$promise.catch(errorFetchEff); 
         
      }

      function fetchEff(data) {
         vm.listkpiscale=data;    
         angular.element.unblockUI();
        
      }

      function errorFetchEff() {
        vm.listkpiscale=[];
         angular.element.unblockUI();
      }



      function select(ks){
        return vm.listKSSelected;
      }

    function closeKpi()
    {
        $mdDialog.hide();
    }

  
   
}


})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_team.set-team-member')
        .controller('SetteammemberresultController', SetteammemberresultController)


    SetteammemberresultController.$inject=['kpi','$state','nik','year','$mdDialog','AppAPI','Auth','Form','$localStorage','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function SetteammemberresultController(kpi,$state,nik,year,$mdDialog,AppAPI,Auth,Form,$localStorage,DTColumnDefBuilder,$timeout,$stateParams)
    {

     var vm = this;
        vm.username=nik;
        vm.kpi=kpi;
        vm.year=year;
        vm.hide=hide;
        vm.cancel=cancel;
        vm.isDisabled=false;
        vm.kpiScaleDetail = [];


        vm.messageTheme='';
         // initial form
        Form.initialForm();

         // get constructor form
        var kpiResult=AppAPI.kpiResult();
        var Kpi = AppAPI.Kpi();

         // set constructor form
        Form.setObject(kpiResult);

        // set form to controller
        vm.Form = Form;

        vm.Form.objForm.kpiId=0;
        vm.setToken=Auth.setToken;

        loadData();
        getKpiScaleDetail();

        ////////////////
        function hide()
        {
            $mdDialog.hide();
        }

       function cancel()
       {
          $mdDialog.cancel();
       }

       function getKpiScaleDetail(){
        var response = Kpi.query({
          action:'viewkpiscaledetail',
          id: vm.kpi.kpi_scale_id
        });
        response.$promise.then(function(data){
          vm.kpiScaleDetail = data;
        });

        response.$promise.catch(function(data){
          vm.kpiScaleDetail = [];
        });
      }

 function loadData()
        {
          var response=kpiResult.query({action:'viewdata',id:vm.kpi.id,year:vm.year,nik:vm.username});
          response.$promise.then(fetchKpiResult);
          response.$promise.catch(errorFetchKpiResult);
        }

        function fetchKpiResult(data)
        {
           vm.listKpiResult=data;
        }

        function errorFetchKpiResult()
        {
           vm.listKpiResult=[];
        }



}


})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.masterkpi.set-kpi-scales', [])
        .config(config);

    /** @ngInject */
    function config()
    {
       

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.masterkpi.set-kpi-scales')
        .controller('SetkpiscalesController', SetkpiscalesController);


    SetkpiscalesController.$inject=['$mdDialog','kpi','AppAPI','Auth','Form'];
    /** @ngInject */
    function SetkpiscalesController($mdDialog,kpi,AppAPI,Auth,Form)
    {
        
    var vm = this;

    // initial form
    Form.initialForm();

    // get constructor form
    var KpiScales=AppAPI.KpiScales();

    // set constructor form
    Form.setObject(KpiScales);

    // set form to controller
    vm.Form = Form;

     vm.closeKpiScalesModal=closeKpiScalesModal;
     vm.kpi=kpi;
     vm.saveKpiScales=saveKpiScales;
     vm.setToken=Auth.setToken;

     vm.messageTheme='pink';


     function closeKpiScalesModal()
     {
        $mdDialog.hide();
     }

     function saveKpiScales(ev,formController) {
        Form.objForm.kpiId=kpi.id;
        var promise= Form.saveData('save', formController, KpiScales);
        promise.then(function(){
            showDialog(ev);
        });
     }

     function showDialog(ev) {
        $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialogSetKPI')))
        .clickOutsideToClose(true)
        .title('Success Save KPI Scales')
        .textContent('Process Set KPI Scales was Success.')
        .ariaLabel('Success Save KPI Scales')
        .ok('OK')
        .targetEvent(ev)
    ).then(function(){
        closeKpiScalesModal();
    });
    }
}
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.masterkpi.manage-kpi-scales', [])
        .config(config);

    config.$inject=['$stateProvider']
    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.pms_masterkpi.edit_scale_kpi', {
                url    : '/pms/master-kpi/edit-scale-kpi',
                views  : {
                    'editscalekpi@content@app': {
                        template: '<h1>test</h1>'
                    }
                }
            });


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.masterkpi.manage-kpi-scales')
        .controller('ManagekpiscalesController', ManagekpiscalesController);


    ManagekpiscalesController.$inject=['$mdDialog','kpi','AppAPI','Auth','Form'];
    /** @ngInject */
    function ManagekpiscalesController($mdDialog,kpi,AppAPI,Auth,Form)
    {
        
    var vm = this;

    // get constructor form
    var KpiScales=AppAPI.KpiScales();
    
     // initial form
    Form.initialForm();

    // get constructor form
    var KpiScales=AppAPI.KpiScales();

    // set constructor form
    Form.setObject(KpiScales);

    // set form to controller
    vm.Form = Form;

     vm.closeKpiScalesModal=closeKpiScalesModal;
     vm.kpi=kpi;
     vm.saveKpiScales=saveKpiScales;
     vm.setToken=Auth.setToken;
     viewKpiScales();
     vm.messageTheme='pink';
     vm.EditScale=EditScale;
     vm.ViewScaleState=ViewScaleState;
     vm.viewScaleState=true;
     vm.judulForm=' Manage KPI Scales';
   
     function viewKpiScales() {
         var response=KpiScales.query({action:'viewdata',id:kpi.id});
         response.$promise.then(fetchDataKpiScales);
         response.$promise.catch(errorFetchKpiScales);

     }

     function fetchDataKpiScales(data) {
         vm.scales=data;
     }

     function errorFetchKpiScales() {
         vm.scales=[];
     }

     function closeKpiScalesModal()
     {
        $mdDialog.hide();
     }

     function saveKpiScales(ev,formController) {
        Form.objForm.kpiId=kpi.id;
        var promise= Form.saveData('save', formController, KpiScales);
        promise.then(function(){
            showDialog(ev);
        });
     }

     function showDialog(ev) {
        $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialogSetKPI')))
        .clickOutsideToClose(true)
        .title('Success Save KPI Scales')
        .textContent('Process Set KPI Scales was Success.')
        .ariaLabel('Success Save KPI Scales')
        .ok('OK')
        .targetEvent(ev)
    ).then(function(){
        closeKpiScalesModal();
    });
    }

    function EditScale() {
        vm.viewScaleState=false;
         vm.judulForm=' Edit KPI Scales';

    }

    function ViewScaleState() {
        vm.viewScaleState=true;
         vm.judulForm=' Manage KPI Scales';
    }
}
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.masterkpi.input', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_masterkpi_input', {
                url    : '/pms/master-kpi/input',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/master-kpi/input-kpi/input-kpi.html',
                        controller : 'InputkpiController as vm'
                    }
                }
            });

      

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.masterkpi.input')
        .controller('InputkpiController', InputkpiController);


    InputkpiController.$inject=['$localStorage'];
    /** @ngInject */
    function InputkpiController($localStorage)
    {
        
        var vm = this;
        vm.theme='forest';
        vm.messageTheme='pink';
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi-scales.input-kpi-scales', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.pms_kpi_scales_input', {
                url    : '/pms/kpi-scales/input-kpi-scales',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi-scales/input-kpi-scales/input-kpi-scales.html',
                        controller : 'InputkpiscalesController as vm'
                    }
                }
            })

             .state('app.pms_kpi_scales_edit', {
                url    : '/pms/kpi-scales/edit-kpi-scales/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi-scales/input-kpi-scales/input-kpi-scales.html',
                        controller : 'EditkpiscalesController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.pms.kpi-scales.input-kpi-scales')
        .controller('InputkpiscalesController', InputkpiscalesController);



     InputkpiscalesController.$inject=['$http','config','DTColumnDefBuilder','AppAPI','Auth','Form','$mdDialog','$stateParams','$localStorage','$state'];
    /** @ngInject */
    function InputkpiscalesController($http,config,DTColumnDefBuilder,AppAPI,Auth,Form,$mdDialog,$stateParams,$localStorage,$state)
    {
        
            
var vm = this;
 vm.username=$localStorage.user;
 // initial form
    Form.initialForm();

    // get constructor form
    var KpiScales=AppAPI.KpiScales();

    // set constructor form
    Form.setObject(KpiScales);

    // set form to controller
    vm.Form = Form; 
    vm.setToken=Auth.setToken;
  vm.contacts = [];
  vm.filterSelected = true;
   vm.isDisabled    = false;
   //vm.Form.objForm.type='text';
//loadDataKpi();

  vm.newContact = {};
  vm.searchString = '';
  vm.getContactsByFullName = getContactsByFullName;
  vm.selectedItemChanged = selectedItemChanged;
  vm.searchTextChange   = searchTextChange;
  vm.saveKpiScales = saveKpiScales;
  
    /**
     * Search for contacts.
     */
    /* function loadDataKpi() {
        angular.element.blockUI();
            var KPI=AppAPI.Kpi();
        var kpiPromise=KPI.query({action:'viewdatauser',id:vm.username});
        //kpiPromise.$promise.then(fetchDataKpi);
        kpiPromise.$promise.then(fetchDataKpi);
        kpiPromise.$promise.catch(errorFetchKpi);
       }


        function fetchDataKpi(data) {
            vm.contacts=data;
             angular.element.unblockUI();
        }

        function errorFetchKpi() {
            vm.contacts=[];
             angular.element.unblockUI();
        }*/


  /*function getContactsByFullName(kpi){

    vm.kpi=kpi;
    return vm.contacts;
  }*/


  function getContactsByFullName(kpi){

    return $http
      .get(config.api + 'api/kpi?action=viewdatauser&id=' + kpi)
      .then(function(item) {
        // Map the response object to the data object.
        if(item.data.length===''){
          cleartext();
          Form.objForm.kpiId='0';
        }   
          return item.data;
      });
}


  function selectedItemChanged(){
    vm.newContact.id = vm.selectedContact.id;
    angular.element.blockUI();
       var response= vm.Form.objForm.$get({action:'viewdetail',id:vm.newContact.id});
          response.then(changeDate);
  }

  function changeDate(data) {

  // vm.Form.objForm.effectiveDate=new Date(data.effective_date);
          angular.element.unblockUI();


  }

  function searchTextChange(text) {
    var text_le=text.length;
    if(text_le<2){
      cleartext();
     }
  }

  function cleartext(){
      //vm.Form.objForm.type='text';
      vm.Form.objForm.kpi=null;
      vm.Form.objForm.description=null;
      vm.Form.objForm.scale1=null;
      vm.Form.objForm.scale2=null;
      vm.Form.objForm.scale3=null;
      vm.Form.objForm.scale4=null;
      vm.Form.objForm.scale5=null;
      vm.Form.objForm.start1=null;
      vm.Form.objForm.start2=null;
      vm.Form.objForm.start3=null;
      vm.Form.objForm.start4=null;
      vm.Form.objForm.start5=null;
      vm.Form.objForm.finish1=null;
      vm.Form.objForm.finish2=null;
      vm.Form.objForm.finish3=null;
      vm.Form.objForm.finish4=null;
      vm.Form.objForm.finish5=null;
      vm.Form.objForm.target=null;
      vm.Form.objForm.effectiveDate=null;
      vm.Form.objForm.bobot=null;
      vm.Form.objForm.uom=null;
      vm.newContact.id='';
  }

   function saveKpiScales(ev,formController) {
      Form.objForm.kpiId='0'; 
      Form.objForm.kpi=vm.searchString;     
      Form.objForm.username=vm.username;
      
        /* $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .textContent(Form.objForm.kpiId + "&" + vm.kpi+ "&" + vm.searchString )
        .ok('OK')
    );*/
       var promise= Form.saveData('save', formController, KpiScales);
        promise.then(function(){
            showDialog(ev);
            $state.go('app.pms_kpi_scales');
        });
     }

     function showDialog(ev) {
        $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Success Save KPI Scales')
        .textContent('Process Set KPI Scales was Success.')
        .ariaLabel('Success Save KPI Scales')
        .ok('OK')
        .targetEvent(ev)
    ).then(function(){
        closeKpiScalesModal();
    });
    }

    function closeKpiScalesModal(){
       $mdDialog.hide();
    }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.pms.kpi-scales.input-kpi-scales')
        .controller('EditkpiscalesController', EditkpiscalesController);


     EditkpiscalesController.$inject=['DTColumnDefBuilder','AppAPI','Auth','Form','$mdDialog','$stateParams','$localStorage','$state'];
    /** @ngInject */
    function EditkpiscalesController(DTColumnDefBuilder,AppAPI,Auth,Form,$mdDialog,$stateParams,$localStorage,$state)
    {
        
       var vm = this;
 vm.username=$localStorage.user;
 // initial form
    Form.initialForm();

    // get constructor form
    var KpiScales=AppAPI.KpiScales();

    // set constructor form
    Form.setObject(KpiScales);

    // set form to controller
    vm.Form = Form;
   

    vm.setToken=Auth.setToken;
  vm.contacts = [];
  vm.filterSelected = true;
   vm.isDisabled    = true;
   //vm.Form.objForm.type='text';
loadDataKpi();

  vm.newContact = {};
  vm.searchString = '';
  vm.getContactsByFullName = getContactsByFullName;
  vm.selectedItemChanged = selectedItemChanged;
  vm.searchTextChange   = searchTextChange;
  vm.saveKpiScales = saveKpiScales;

  
  var resp=vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
  resp.then(resp_awal);
  function resp_awal(data){
    vm.Form.objForm.effectiveDate=new Date(data.effective_date);
    vm.searchString=data.kpi;
    vm.newContact.id=data.id;
  }



    /**
     * Search for contacts.
     */
     function loadDataKpi() {
        angular.element.blockUI();
            var KPI=AppAPI.Kpi();
        var kpiPromise=KPI.query({action:'viewdatauser',id:vm.username});
        //kpiPromise.$promise.then(fetchDataKpi);
        kpiPromise.$promise.then(fetchDataKpi);
        kpiPromise.$promise.catch(errorFetchKpi);
       }


        function fetchDataKpi(data) {
            vm.contacts=data;
             angular.element.unblockUI();
        }

        function errorFetchKpi() {
            vm.contacts=[];
             angular.element.unblockUI();
        }


  function getContactsByFullName(kpi){
    vm.kpi=kpi;
    return vm.contacts;
  }

  function selectedItemChanged(){
    vm.newContact.id = vm.selectedContact.id;
    //vm.newContact.kpi = vm.selectedContact.kpi;
       // $log.info('Item changed to ' + JSON.stringify(item));
       var response= vm.Form.objForm.$get({action:'viewdetail',id:vm.newContact.id});
          response.then(changeDate);
  }

  function changeDate(data) {

   vm.Form.objForm.effectiveDate=new Date(data.effective_date);
   
  }

  function searchTextChange(text) {
    var text_le=text.length;
    if(text_le<2){
      //vm.Form.objForm.type='text';
      vm.Form.objForm.kpi=null;
      vm.Form.objForm.description=null;
      vm.Form.objForm.scale1=null;
      vm.Form.objForm.scale2=null;
      vm.Form.objForm.scale3=null;
      vm.Form.objForm.scale4=null;
      vm.Form.objForm.scale5=null;
      vm.Form.objForm.start1=null;
      vm.Form.objForm.start2=null;
      vm.Form.objForm.start3=null;
      vm.Form.objForm.start4=null;
      vm.Form.objForm.start5=null;
      vm.Form.objForm.finish1=null;
      vm.Form.objForm.finish2=null;
      vm.Form.objForm.finish3=null;
      vm.Form.objForm.finish4=null;
      vm.Form.objForm.finish5=null;
      vm.Form.objForm.target=null;
      vm.Form.objForm.bobot=null;
      vm.Form.objForm.effectiveDate=null;
      vm.newContact.id='';
     }
  }

   function saveKpiScales(ev,formController) {
    if(vm.newContact.id==''){
      Form.objForm.kpiId='0';
    }else{
      Form.objForm.kpiId=vm.newContact.id;     
    }
      Form.objForm.kpi=vm.kpi;     
      Form.objForm.username=vm.username;
      
        /* $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .textContent(Form.objForm.kpiId)
        .ok('OK')
    );*/
        var promise= Form.saveData('save', formController, KpiScales);
        promise.then(function(){
            showDialog(ev);
         $state.go('app.pms_kpi_scales');
        });
     }

     function showDialog(ev) {
        $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Success Save KPI Scales')
        .textContent('Process Set KPI Scales was Success.')
        .ariaLabel('Success Save KPI Scales')
        .ok('OK')
        .targetEvent(ev)
    ).then(function(){
        closeKpiScalesModal();
    });
    }

    function closeKpiScalesModal(){
       $mdDialog.hide();
    }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_nabati.set-team-all', [])
        .config(config);

     config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
      $stateProvider
             .state('app.pms_kpi_nabati_set_team_all', {
                url    : '/pms/kpi-nabati/set-team-all/set-team-all/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi-nabati/set-team-all/set-team-all.html',
                        controller : 'SetteamallController as vm'
                    }
                }
            });       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pms.kpi_nabati.set-team-all')
        .controller('SetteamallController', SetteamallController)


    SetteamallController.$inject = ['DataService', '$state', '$mdDialog', 'AppAPI', 'Auth', 'Form', '$localStorage', 'DTColumnDefBuilder', '$timeout', '$stateParams'];
    /** @ngInject */
    function SetteamallController(DataService, $state, $mdDialog, AppAPI, Auth, Form, $localStorage, DTColumnDefBuilder, $timeout, $stateParams) {

        var vm = this;
        vm.username = $localStorage.user;
        // initial form
        Form.initialForm();
        vm.nik = $stateParams.id;
        vm.approveKS = approveKS;
        vm.closeKpi = closeKpi;
        vm.select = select;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.viewScales = viewScales;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listKSSelected = [];
        var teamMember = AppAPI.teamMember();
        vm.DataTable = new DataService();
        vm.showKpi = showKpi;
        // vm.loadData=loadData;
        var today = new Date();
        var year = today.getFullYear();
        // vm.yearSelected=year;
        // vm.yearSelected='2018'; //untuk sementara data tahun di fix
        vm.removeApproval = removeApproval;
        vm.years = [{
            year: 2019,
            selected: true
        }, {
            year: 2018,
            selected: true
        }, {
            year: 2017,
            selected: false
        }, {
            year: 2016,
            selected: false
        }, {
            year: 2015,
            selected: false
        }];
        checkSelectedYear();
        //loadData(1);
        loadDataEff();


        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: 'full_numbers',
            paging: false,
            searching: false
        };

        function checkSelectedYear() {

            // var lengthYear=vm.years
            angular.forEach(vm.years, function (obj) {
                if (obj.year === vm.yearSelected) {
                    obj.selected = true;
                } else {
                    obj.selected = false;
                }
            });
        }


        function showKpi(year) {
            vm.listKSSelected = [];
            vm.yearSelected = year;
            checkSelectedYear();
            loadDataEff(1);
        }

        function isChecked(ks) {
            return vm.listKSSelected.indexOf(ks) > -1;
        }

        function toggleCheck(ks, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listKSSelected.indexOf(ks);

            if (idx > -1) {
                vm.listKSSelected.splice(idx, 1);
            } else {
                vm.listKSSelected.push(ks);
            }
        }

        // function loadData(pageno)
        //       {
        //         var KpiScales=AppAPI.KpiScales();
        //         var OKpi= new KpiScales();
        //          var response=OKpi.$query({action:'viewdatayearall',eff:vm.yearSelected,id:vm.nik});
        //          response.then(successFetchKPI);
        //          response.catch(errorFetchKPI);
        //          // vm.DataTable.loadData(KpiScales,pageno,{action:'viewdatayearall',eff:vm.yearSelected,id:vm.nik});
        //          // loadDataEff();
        //          vm.listKSSelected=[];
        //       }

        //       function successFetchKPI(data) {
        //         //console.log(data);
        //         vm.listkpi=data;

        //       }

        //       function errorFetchKPI(data) {
        //         vm.listkpi=[];
        //       }


        function viewScales(ev, kpi) {
            $mdDialog.show({
                controller: 'SetteamallscaleController',
                controllerAs: 'vm',
                templateUrl: 'app/main/pms/kpi-nabati/set-team-all/set-team-all-scale.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    kpi: kpi
                }
            });
        }


        function loadDataEff() {
            angular.element.blockUI();
            var buPromise = teamMember.query({
                action: 'viewdetailEff',
                id: $stateParams.id,
                year: vm.yearSelected
            });
            buPromise.$promise.then(fetchEff);
            buPromise.$promise.catch(errorFetchEff);

        }

        function fetchEff(data) {
            vm.listkpi = data;

            //   angular.forEach(vm.listkpi, function(value, key) {

            // });  


            angular.element.unblockUI();

        }

        function errorFetchEff() {
            vm.listkpi = [];
            angular.element.unblockUI();
        }

        function select(ks) {
            return vm.listKSSelected;
        }

        function closeKpi() {
            $mdDialog.hide();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listKSSelected = angular.copy(vm.listkpi);

        }

        function unCheckAll() {
            vm.listKSSelected = [];
        }

        function approveKS(ev) {

            /*        if (!vm.listKSSelected.length){

                         vm.tampilPesan=true;
                         vm.pesan='Please Checkbox!';
                         vm.messageTheme='blue';
                         $timeout(function() {
                             vm.tampilPesan=false;
                         }, 3000);
                  
                    }else{*/
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to Approve this list?')
                    .textContent('All data your selected will be approved.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });
                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();

                    var response = teamMember.delete({
                        action: 'approve',
                        data: angular.toJson(vm.listKSSelected)
                    });
                    response.$promise.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
            // }

        }


        function removeApproval(id, kpi, ev) {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete  KPI Approval ?')
                .textContent('This KPI (' + kpi + ') approval will be deleted and cannot recovered. Are You Sure ?')
                .ariaLabel('delete kpi')
                .targetEvent(ev)
                .ok('Yes, Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {

                var promise = Auth.setToken();
                promise.then(function () {
                    var response = teamMember.delete({
                        action: 'unapproved',
                        id: id
                    });
                    response.$promise.then(loadData);
                });

            });
        }
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_nabati.set-team-all')
        .controller('SetteamallscaleController', SetteamallscaleController)


    SetteamallscaleController.$inject=['kpi','$state','$mdDialog','AppAPI','Auth','Form','$localStorage','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function SetteamallscaleController(kpi,$state,$mdDialog,AppAPI,Auth,Form,$localStorage,DTColumnDefBuilder,$timeout,$stateParams)
    {
        
    var vm = this;
    vm.username=$localStorage.user;
    // initial form
    Form.initialForm();
    vm.kpi=kpi;
    vm.closeKpi=closeKpi;
    vm.nik=$stateParams.id;
    var teamMember=AppAPI.teamMember();
    loadDataEffJudul();
    //loadDataEff();

        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers',
            paging:false,
            searching:false
        };

     
      function loadDataEffJudul() {
         angular.element.blockUI();
        var buPromise2=teamMember.query({action:'viewdetailks',id:vm.kpi,nik:vm.nik});
        buPromise2.$promise.then(fetchEffJudul);
        buPromise2.$promise.catch(errorFetchEffJudul); 
         
      }

      function fetchEffJudul(data) {
        vm.listkpiscale=data;  
        vm.kpidesc=data[0].kpi;
        vm.uom=data[0].uom;
        vm.bobot=data[0].bobot;
        vm.target=data[0].target;
        angular.element.unblockUI();
        
      }

      function errorFetchEffJudul() {
         angular.element.unblockUI();
      }   

     function loadDataEff() {
         angular.element.blockUI();
        var buPromise=teamMember.query({action:'viewdetailks',id:vm.kpi,nik:vm.nik});
        buPromise.$promise.then(fetchEff);
        buPromise.$promise.catch(errorFetchEff); 
         
      }

      function fetchEff(data) {
         vm.listkpiscale=data;    
         angular.element.unblockUI();
        
      }

      function errorFetchEff() {
        vm.listkpiscale=[];
         angular.element.unblockUI();
      }



      function select(ks){
        return vm.listKSSelected;
      }

    function closeKpi()
    {
        $mdDialog.hide();
    }

  
   
}


})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi', [])
        .config(config);

         config.$inject=['$stateProvider','$mdThemingProvider'];

    /** @ngInject */
   /** @ngInject */
   function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pms_kpi', {
                url    : '/pms/kpi',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi/kpi.html',
                        controller : 'KpiController as vm'
                    }
                }
            });

       
        // Translation
      //  $translatePartialLoaderProvider.addPart('app/main/pms/kpi-scales');

    }
})();
(function () {
  'use strict';

  angular
    .module('app.pms.kpi')
    .controller('inputscaleController', inputscaleController);


  /* @ngInject */
  inputscaleController.$inject = ['$mdDialog', '$http', 'kpi', 'config', 'Form', 'AppAPI', 'Auth'];
  function inputscaleController($mdDialog, $http, kpi, config, Form, AppAPI, Auth) {
    var vm = this;
    vm.kpi = kpi;
    vm.hide = hide;
    vm.cancel = cancel;
    /*        vm.listScale=[
             {
              description:'description',
              min:'min',
              max:'max'
             }
            ];
    */
    vm.isDisabled = false;
    vm.saveKpiScale = saveKpiScale;
    vm.messageTheme = '';
    // initial form
    Form.initialForm();

    // get constructor form
    var KpiScales = AppAPI.Kpi();

    // set constructor form
    Form.setObject(KpiScales);

    // set form to controller
    vm.Form = Form;

    loadData();

    vm.Form.objForm.kpiId = vm.kpi.kpi_scale_id;
    vm.setToken = Auth.setToken;

    ////////////////
    function hide() {
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    }


    function loadData() {
      var response = KpiScales.query({ action: 'viewkpiscaledetail', id: vm.kpi.kpi_scale_id });
      response.$promise.then(fetchKpiScale);
      response.$promise.catch(errorFetchKpiScale);
    }

    function fetchKpiScale(data) {
      vm.Form.objForm.listScale = data;
    }

    function errorFetchKpiScale() {
      vm.Form.objForm.listScale = [
        {
          description: null,
          min: null,
          max: null
        },
        {
          description: null,
          min: null,
          max: null
        },
        {
          description: null,
          min: null,
          max: null
        },
        {
          description: null,
          min: null,
          max: null
        },
        {
          description: null,
          min: null,
          max: null
        }
      ];
    }



    function saveKpiScale(ev, formController) {
      var promise = Form.saveData('savekpiscale', formController, KpiScales);

      promise.then(successSaveKpiScale);
      promise.catch(failedSaveKpiScale);
    }

    function successSaveKpiScale() {
      vm.messageTheme = 'green';
    }

    function failedSaveKpiScale() {
      vm.messageTheme = 'red';

    }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_result', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_kpi_result', {
                url    : '/pms/kpi-result',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi-result/kpi-result.html',
                        controller : 'KpiresultController as vm'
                    }
                }
            });
    }
})();
(function() {
  'use strict';

  angular.module('app.pms.kpi_result')
         .controller('inputresultController', inputresultController);

  /* @ngInject */
  inputresultController.$inject = [
    '$mdDialog',
    '$http',
    'kpi',
    'year',
    'config',
    'Form',
    'AppAPI',
    'Auth'
  ];
  function inputresultController(
    $mdDialog,
    $http,
    kpi,
    year,
    config,
    Form,
    AppAPI,
    Auth
  ) {
    var vm = this;
    vm.kpi = kpi;
    vm.year = year;
    vm.hide = hide;
    vm.cancel = cancel;
    vm.isDisabled = false;
    vm.saveKpiResult = saveKpiResult;
    vm.messageTheme = '';
    vm.kpiScaleDetail = [];
    vm.min = 0;
    vm.max = 0;

    // initial form
    Form.initialForm();

    // get constructor form
    var kpiResult = AppAPI.kpiResult();
    var Kpi = AppAPI.Kpi();

    // set constructor form
    Form.setObject(kpiResult);

    // set form to controller
    vm.Form = Form;

    getKpiScaleDetail();

    vm.Form.objForm.kpiId = 0;
    vm.setToken = Auth.setToken;

    ////////////////
    function hide() {
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    }

    vm.items = [
      { id: '01', value: 'Januari' },
      { id: '02', value: 'Februari' },
      { id: '03', value: 'Maret' },
      { id: '04', value: 'April' },
      { id: '05', value: 'Mei' },
      { id: '06', value: 'Juni' },
      { id: '07', value: 'Juli' },
      { id: '08', value: 'Agustus' },
      { id: '09', value: 'September' },
      { id: '10', value: 'Oktober' },
      { id: '11', value: 'November' },
      { id: '12', value: 'Desember' }
    ];
    //vm.items = 'Januari';

    function saveKpiResult(ev, formController) {
      vm.Form.objForm.kpiId = vm.kpi.id;
      vm.Form.objForm.year = vm.year;
      vm.Form.objForm.kpiScaleId = vm.kpi.kpi_scale_id;
      vm.Form.objForm.valueCategory = vm.kpi.value_category;
      vm.Form.objForm.resultDate2 = vm.year + '' + vm.Form.objForm.resultDate;

      var promise = Form.saveData('save', formController, kpiResult);

      promise.then(successsaveKpiResult);
      promise.catch(failedsaveKpiResult);
    }

    function getKpiScaleDetail(){
      var response = Kpi.query({
        action:'viewkpiscaledetail',
        id: vm.kpi.kpi_scale_id
      });

      response.$promise.then(function(data){
        console.log(data);
        vm.kpiScaleDetail = data;
        if (vm.kpi.value_category == "increase") {
          vm.min = data[0].min;
          vm.max = data[data.length - 1].max;
        } else {
          vm.min = data[data.length - 1].max;
          vm.max = data[0].min;
        }
      });

      response.$promise.catch(function(data){
        vm.kpiScaleDetail = [];
      });
    }

    function successsaveKpiResult() {
      vm.messageTheme = 'green';
    }

    function failedsaveKpiResult() {
      vm.messageTheme = 'red';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.pms.kpi_result')
    .controller('editresultController', editresultController);


  /* @ngInject */
  editresultController.$inject = ['$mdDialog', '$window', '$http', '$log', 'kpi', 'year', 'config', 'Form', 'AppAPI', 'Auth', '$localStorage', '$filter'];
  function editresultController($mdDialog, $window, $http, $log, kpi, year, config, Form, AppAPI, Auth, $localStorage, $filter) {
    var vm = this;

    var translate = $filter('translate');

    vm.username = $localStorage.user;
    vm.kpi = kpi;
    vm.year = year;
    vm.hide = hide;
    vm.cancel = cancel;
    vm.isDisabled = false;
    vm.editstate = false;
    vm.UpdateResult = UpdateResult;
    vm.cancelUpdateResult = cancelUpdateResult;
    vm.deleteResult = deleteResult;
    vm.messageTheme = '';
    vm.kpiScaleDetail = [];
    // initial form
    Form.initialForm();
    vm.stateEdit = false;

    // get constructor form
    var kpiResult = AppAPI.kpiResult();
    var Kpi = AppAPI.Kpi();
    // set constructor form
    Form.setObject(kpiResult);

    // set form to controller
    vm.Form = Form;

    vm.Form.objForm.kpiId = 0;
    vm.setToken = Auth.setToken;
    vm.items = [{ "id": "01", "value": "Januari" },
    { "id": "02", "value": "Februari" },
    { "id": "03", "value": "Maret" },
    { "id": "04", "value": "April" },
    { "id": "05", "value": "Mei" },
    { "id": "06", "value": "Juni" },
    { "id": "07", "value": "Juli" },
    { "id": "08", "value": "Agustus" },
    { "id": "09", "value": "September" },
    { "id": "10", "value": "Oktober" },
    { "id": "11", "value": "November" },
    { "id": "12", "value": "Desember" }
    ];
    vm.editResult = editResult;
    loadData();
    getKpiScaleDetail();

    ////////////////

    function editResult(idx) {
      switch (vm.listKpiResult[idx].stateEdit) {
        case false:
          vm.listKpiResult[idx].stateEdit = true;
          break;
        case true:
          vm.listKpiResult[idx].stateEdit = false;
          break;
        default:
          vm.listKpiResult[idx].stateEdit = false;
          break;
      }
    }
    function hide() {
      $mdDialog.hide();
    }

    function getKpiScaleDetail() {
      var response = Kpi.query({
        action: 'viewkpiscaledetail',
        id: vm.kpi.kpi_scale_id
      });
      response.$promise.then(function (data) {
        vm.kpiScaleDetail = data;
      });

      response.$promise.catch(function (data) {
        vm.kpiScaleDetail = [];
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function cancelUpdateResult(idx) {
      vm.listKpiResult[idx].stateEdit = false;
    }

    function loadData() {
      var response = kpiResult.query({ action: 'viewdata', id: vm.kpi.id, year: vm.year, nik: vm.username });
      response.$promise.then(fetchKpiResult);
      response.$promise.catch(errorFetchKpiResult);
    }

    function fetchKpiResult(data) {
      vm.listKpiResult = data;
    }

    function errorFetchKpiResult() {
      vm.listKpiResult = [];
    }

    function UpdateResult(idx) {
      var ev = '';
      var result = vm.listKpiResult[idx].result;
      var kpiValue = vm.listKpiResult[idx].kpiValue;
      var bulan = vm.listKpiResult[idx].bulan;
      var idResult = vm.listKpiResult[idx].idResult;

      var resp = Auth.setToken();
      resp.then(function () {
        var rs = new kpiResult();
        rs.result = result;
        rs.idResult = idResult;
        rs.action = 'updatedata';
        rs.kpiValue = kpiValue;
        rs.bulan = bulan;
        rs.year = vm.year;
        rs.valueCategory = vm.kpi.value_category;
        rs.kpiScaleId = vm.kpi.kpi_scale_id;
        var res = rs.$save();
        res.then(function (rdata) {
          showDialogInfo(ev, rdata)
          vm.listKpiResult[idx].stateEdit = false;
          loadData();
        }, function (err) {
          showDialogInfo(ev, err);
        });
        // console.log(act);
      });
    }

    function deleteResult(idx) {
      var ev = '';
      var idResult = vm.listKpiResult[idx].idResult;

      var message = translate('PAYROLL.MESSAGE.CONFDEL');
      var note = translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      if (confirm) {
        var resp = Auth.setToken();
        resp.then(function () {
          var confirm = $mdDialog
            .confirm()
            .title(message)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);

          $mdDialog.show(confirm).then(
            function () {
              angular.element.blockUI();
              var rs = new kpiResult();
              var res = rs.$delete({ idResult: idResult, action: 'deletedata' });
              res.then(function (data) {
                angular.element.unblockUI();
                if (data.status == 1) {
                  data.status = 'PAYROLL.MESSAGE.SUCCESS';
                  showDialogInfo(ev, data);
                } else {
                  data.status = 'PAYROLL.MESSAGE.FAILED';
                  showDialogInfo(ev, data);
                }
              });
              res.catch(function (data) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
                showDialogInfo(ev, data.data);
                angular.element.unblockUI();
              });
            },
            function () {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        });
      }
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var message = translate(data.pesan);
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.pms.kpi')
    .controller('inputkpiController', inputkpiController);

  /* @ngInject */
  inputkpiController.$inject = [
    '$mdDialog',
    '$http',
    'year',
    'maxweight',
    'config',
    'Form',
    'AppAPI',
    'Auth',
    'months'
  ];
  function inputkpiController(
    $mdDialog,
    $http,
    year,
    maxweight,
    config,
    Form,
    AppAPI,
    Auth,
    months
  ) {
    var vm = this;
    vm.title = 'Controller';
    vm.hide = hide;
    vm.cancel = cancel;
    vm.year = year;
    vm.maxweight = maxweight;
    vm.getKpi = getKpi;
    vm.selectedItemChanged = selectedItemChanged;
    vm.isDisabled = false;
    vm.saveKpiPeople = saveKpiPeople;
    vm.messageTheme = '';
    vm.stateEdit = false;
    vm.saveProcess = false;
    vm.months = months;
    vm.expiredMonths = [];
    vm.setExpiredMonths = setExpiredMonths;
    vm.check = [];
    vm.resetFieldScales = resetFieldScales;



    // initial form
    Form.initialForm();

    // get constructor form
    var KpiScales = AppAPI.Kpi();

    // set constructor form
    Form.setObject(KpiScales);

    // set form to controller
    vm.Form = Form;

    vm.Form.objForm.kpiId = 0;
    vm.setToken = Auth.setToken;

    vm.Form.objForm.listScale = [
      {
        description: null,
        min: 0,
        max: 0
      },
      {
        description: null,
        min: 0,
        max: 0
      },
      {
        description: null,
        min: 0,
        max: 0
      },
      {
        description: null,
        min: 0,
        max: 0
      },
      {
        description: null,
        min: 0,
        max: 0
      }
    ];

    vm.Form.objForm.valueCategory = "increase";
    vm.Form.objForm.targetID = 3;
    ////////////////
    function hide() {
      $mdDialog.hide();
    }

    function setExpiredMonths(data) {
      vm.expiredMonths = [];
      var index = 0;
      for (index = 0; index < vm.months.length; index++) {
        if (parseInt(data) - 1 <= index) {
          vm.expiredMonths.push({
            view: vm.months[index].view,
            value: vm.months[index].value // MAKE ALL TO BE STRING
          });
        }
      }
    }

    function resetFieldScales() {
      for (var i = 0; i < vm.Form.objForm.listScale.length; i++) {
        vm.Form.objForm.listScale[i].min = 0;
        vm.Form.objForm.listScale[i].max = 0;
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function getKpi(searchText) {
      return $http
        .get(config.api + 'api/kpi?action=searchKpi&id=' + searchText)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            Form.objForm.kpiId = '0';
          }
          return item.data;
        });
    }

    function selectedItemChanged(kpi) {
      vm.Form.objForm.kpiId = 0;
      vm.Form.objForm.description = '';
      vm.isDisabled = false;
      vm.Form.objForm.kpi = vm.searchString;
      if (typeof kpi !== 'undefined') {
        vm.Form.objForm.description = kpi.description;
        vm.Form.objForm.kpiId = kpi.id;
        vm.Form.objForm.kpi = kpi.kpi;
        vm.isDisabled = true;
      }
    }

    function saveKpiPeople(ev, formController) {
      vm.saveProcess = true;
      vm.Form.objForm.years = vm.year;
      var promise = Form.saveData('saveKpiPeople', formController, KpiScales);
      promise.then(successSaveKpiPeople);
      promise.catch(failedSaveKpiPeople);
    }

    function successSaveKpiPeople(data) {
      vm.messageTheme = 'green';
      vm.saveProcess = false;
    }

    function failedSaveKpiPeople(data) {
      vm.messageTheme = 'red';
      vm.saveProcess = false;
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('app.pms.kpi')
    .controller('editkpiController', editkpiController);

  /* @ngInject */
  editkpiController.$inject = [
    '$scope',
    '$mdDialog',
    '$http',
    'years',
    'kpi',
    'maxweight',
    'expireDate',
    'config',
    'Form',
    'AppAPI',
    'Auth',
    '$filter',
    'months'
  ];
  function editkpiController(
    $scope,
    $mdDialog,
    $http,
    years,
    kpi,
    maxweight,
    expireDate,
    config,
    Form,
    AppAPI,
    Auth,
    $filter,
    months
  ) {
    var vm = this;
    var translate = $filter('translate');
    vm.title = 'Controller';
    vm.hide = hide;
    vm.cancel = cancel;
    vm.kpi = kpi;
    vm.ableToEdit = 'dariAtasan' in kpi ? true : false;
    vm.maxweight = maxweight;
    vm.expireDate = new Date(expireDate);
    vm.getKpi = getKpi;
    vm.selectedItemChanged = selectedItemChanged;
    vm.isDisabled = false;
    vm.saveKpiPeople = saveKpiPeople;
    vm.messageTheme = '';
    vm.Detail = [];
    vm.stateEdit = true;
    vm.saveProcess = false;
    vm.months = months;
    vm.expiredMonths = [];
    vm.setExpiredMonths = setExpiredMonths;
    vm.checkValue = checkValue;
    vm.isFalseSetting = false;
    // initial form
    Form.initialForm();

    // get constructor form
    var KpiScales = AppAPI.Kpi();

    // set constructor form
    Form.setObject(KpiScales);

    vm.Approved = vm.kpi.approval;

    // set form to controller
    vm.Form = Form;

    var response = vm.Form.objForm.$get({ action: 'viewkpipeopledetail', id: vm.kpi.kpi_scale_id });
    response.then(changeDate);

    vm.Form.objForm.kpiId = vm.kpi.kpi_scale_id;
    vm.setToken = Auth.setToken;

    ////////////////
    function changeDate(data) {
      vm.expiredMonths = months;
      vm.Form.objForm.years = years;
      vm.Form.objForm.effectiveDate = data.effectiveDate.substring(5, 7);
      vm.Form.objForm.expiredDate = data.expiredDate.substring(5, 7);
      vm.maxweight += parseFloat(data.bobot, 10);

      angular.forEach(data.listScale, function (obj) {
        if (data.valueCategory == 'increase' && obj.min > obj.max) {
          vm.isFalseSetting = true;
          return true;
        }
        if (data.valueCategory == 'decrease' && obj.min < obj.max) {
          vm.isFalseSetting = true;
          return true;
        }
      });
    }
    function hide() {
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function getKpi(searchText) {
      return $http
        .get(config.api + 'api/kpi?action=searchKpi&id=' + searchText)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === 0) {
            vm.Form.objForm.kpiId = '0';
          }
          return item.data;
        });
    }

    function selectedItemChanged(kpi) {
      vm.Form.objForm.kpiId = 0;
      vm.Form.objForm.description = '';
      vm.isDisabled = false;
      vm.Form.objForm.kpi = vm.searchString;
      if (typeof kpi !== 'undefined') {
        vm.Form.objForm.description = kpi.description;
        vm.Form.objForm.kpiId = kpi.id;
        vm.Form.objForm.kpi = kpi.kpi;
        vm.isDisabled = true;
      }
    }

    function saveKpiPeople(ev, formController) {
      vm.Form.objForm.employement_nik = vm.kpi.employement_nik;
      vm.saveProcess = true;
      var promise = Form.saveData(
        'updatekpipeople',
        formController,
        KpiScales
      );

      promise.then(successSaveKpiPeople);
      promise.catch(failedSaveKpiPeople);
    }

    function successSaveKpiPeople(data) {
      vm.messageTheme = 'green';
      vm.Form.objForm.effectiveDate = vm.Form.objForm.effectiveDate;
      vm.Form.objForm.expiredDate = vm.Form.objForm.expiredDate;
      vm.saveProcess = false;
      var ev = ''
      showDialogInfo(ev, data);
    }

    function failedSaveKpiPeople() {
      vm.messageTheme = 'red';
      vm.Form.objForm.effectiveDate = vm.Form.objForm.effectiveDate;
      vm.Form.objForm.expiredDate = vm.Form.objForm.expiredDate;
      vm.saveProcess = false;
    }

    function setExpiredMonths(data) {
      vm.expiredMonths = [];

      var index = 0;
      for (index = 0; index < vm.months.length; index++) {
        if (parseInt(data) - 1 <= index) {
          vm.expiredMonths.push({
            view: vm.months[index].view,
            value: vm.months[index].value // MAKE ALL TO BE STRING
          });
        }
      }
    }

    function showDialogInfo(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function checkValue(min, max) {
      if (vm.Form.objForm.valueCategory == 'decrease' && min > max) {
        vm.isFalseSetting = false;
      } else {
        vm.isFalseSetting = true;
      }
      if (vm.Form.objForm.valueCategory == 'increase' && min < max) {
        vm.isFalseSetting = false;
      } else {
        vm.isFalseSetting = true;
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.job_code_profile.input-job-code-profile', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.pms_job_code_profile_input', {
                url    : '/pms/job_code_profile/input',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/job-code-profile/input-job-code-profile/input-job-code-profile.html',
                        controller : 'InputJobCodeProfileController as vm'
                    }
                }
            })
        $stateProvider
            .state('app.pms_competency_job_edit', {
                url    : '/pms/competency_job/edit-competency_job/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/competency-job/input-competency_job/input-competency_job.html',
                        controller : 'EditCompetencyJobController as vm'
                    }
                }
            })
       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function () {
    'use strict';

    angular.module('app.pms.job_code_profile.input-job-code-profile')
           .controller('InputJobCodeProfileController', InputJobCodeProfileController);

    InputJobCodeProfileController.$inject=['$state','$stateParams','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function InputJobCodeProfileController($state,$stateParams,$localStorage,$timeout,Form,AppAPI,Auth) {
        
        var vm = this;

        // initial form
        Form.initialForm();

        var CompetencyJob=  AppAPI.CompetencyJob();

        // set constructor form
        Form.setObject(CompetencyJob);

        // set form to controller
        vm.Form = Form;

        vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
            {link:'app.pms_competency_job',name:'Competency Job',active:'0'},
            {link:'#',name:'Input Competency Job',active:'0'}
        ];

        vm.saveData=saveData;
        vm.back=back;

        vm.clearMeesage=clearMeesage;
        vm.reloadToken=reloadToken; 
        // console.log( vm.Form.objForm.menu_id);
        // 
        var response = CompetencyJob.query({action:'get_jobcode'});
            response.$promise.then(function(data){
            vm.listJobCode=data;
            // console.log(vm.listJobCode);
        });

        response.$promise.catch(function(data){
            $log.info(data);
        });        

        function saveData(formController) {
            angular.element.blockUI();
            var response=Form.saveData('save', formController, CompetencyJob);

            response.then(function(){
                vm.messageTheme='blue';
                angular.element.unblockUI();
                formController.$setPristine();
                $timeout(function() {
                    vm.Form.tampilPesan=false;
                }, 3000);

            });

            response.catch(function(){
                vm.messageTheme='pink';
                angular.element.unblockUI();
            });

        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.pms_competency_job');
        }
    }

})();  

(function ()
{
    'use strict';

    angular
        .module('app.pms.idp.set_idp_member', [
        ])
        .config(config);

    config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/pms/emp/idp-member');

        // State
        $stateProvider
        .state('app.pms_idp_member', {
            url    : '/pms/set_idp_member/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/idp/set-idp-member/set-idp-member.html',
                    controller : 'SetIdpMemberController as vm'
                }
            }
        });

        // $translatePartialLoaderProvider.addPart('app/main/pms/competency');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.pms.idp.set_idp_member')
        .controller('SetIdpMemberController', SetIdpMemberController);

    SetIdpMemberController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService', '$document', '$mdToast', 'Form', '$stateParams'];
    /** @ngInject */
    function SetIdpMemberController($state,$log,$mdDialog,AppAPI,Auth,DataService, $document, $mdToast, Form, $stateParams) {
        
        var vm               = this;
        var Idp              = AppAPI.Idp();
        var CompetencyTeam = AppAPI.CompetencyTeam();

        vm.nik               = $stateParams.id;
        vm.inputData         = inputData;
        vm.remaining         = 0;
        vm.development_year  = '2016';
        vm.addDevelopment    = addDevelopment;
        vm.removeDevelopment = removeDevelopment;
        vm.addImprovement    = addImprovement;
        vm.removeImprovement = removeImprovement;
        vm.setReq            = setReq;
        vm.setGap            = setGap;
        vm.saveData          = saveData;
      
        vm.developmentCategoryList = [
            {id:0, name:'-'},
            {id:1, name:'EDUCATION'},
            {id:2, name:'EXPOSURE'},
            {id:3, name:'EXPERIENCE'}
        ];

        vm.improvementLevelList = [
            {level: 1},
            {level: 2},
            {level: 3},
            {level: 4},
            {level: 5}
        ]

        vm.developmentLists = [
            {id: '',
             idp_id: '',
             activities: '',
             activity_time: '',
             institution: '',
             from_beg: '',
             timestamp: ''
            }
        ];

        vm.improvementLists = [
            {   
                id: '',
                idp_id: '',
                area_for_improvement: '',
                development_category_id: '',
                req: '',
                act: '',
                gap: '',
                disabled: '',
                development_plan: '',
                timestamp: ''
            }
        ];

        Form.initialForm();
        Form.setObject(Idp);
        vm.Form     = Form;
        vm.setToken = Auth.setToken;

        loadJobCodeProfile();

        function addDevelopment() {
            vm.developmentLists.push(
                {id: '',
                 idp_id: '',
                 activities: '',
                 activity_time: '',
                 institution: '',
                 from_beg: '',
                 timestamp: ''
                }
            );
        }

        function removeDevelopment(d) {
            if(d.id === '') {
                var index = vm.developmentLists.indexOf(d);
                vm.developmentLists.splice(index, 1);
            }
        }

        function addImprovement() {
            vm.improvementLists.push(
                {   
                    id: '',
                    idp_id: '',
                    area_for_improvement: '',
                    development_category_id: '',
                    req: '',
                    act: '',
                    gap: '',
                    disabled: '',
                    development_plan: '',
                    timestamp: ''
                }
            );
        }

        function removeImprovement(i) {
            if(i.id === '') {
                var index = vm.improvementLists.indexOf(i);
                vm.improvementLists.splice(index, 1);
            }
        }

        loadEmployeeProfileData();

        function loadEmployeeProfileData() {
           angular.element.blockUI();
           var promises = Idp.query({action:'get_profile',nik:vm.nik});
           promises.$promise.then(fetchEmployeeProfileData);
           promises.$promise.catch(errorFetchEmployeeProfile); 
        }

        function fetchEmployeeProfileData(data) {
            if(typeof(data[0]) !== 'undefined') {
                vm.profile = data;
                loadData();
            }
        }

        function errorFetchEmployeeProfile() {
            vm.profile = {};
            angular.element.unblockUI();
        }

        function loadData() {
           angular.element.blockUI();
           var dataPromise = Idp.query({action:'viewDetail', nik:vm.nik});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {  

           // console.log('data', data);  
           // 
            
            vm.aspiration = data[0].aspiration; 
            vm.last_update = data[0].timestamp;

            if(typeof(data[0].development) !== 'undefined') {
                vm.developmentLists = data[0].development;
            } 

            if(typeof(data[0].improvement) !== 'undefined') {
                vm.improvementLists = data[0].improvement;
            }       

            // vm.remaining = data.length;
            
            // vm.listInput = [];
            // var group_tmp = '';
            // for(var i = 0; i <= (data.length - 1); i++) {
            //     if(group_tmp !== data[i].competency_category_id) {
            //         if(typeof(vm.listInput[data[i].competency_category_id]) !== undefined) {
            //             vm.listInput[data[i].competency_category_id] = {
            //                 category_id: data[i].competency_category_id,
            //                 category_name: data[i].competency_category_name,
            //                 details: []
            //             };
            //         }
            //     }
            //     group_tmp = data[i].competency_category_id;
            // }

            // for(var ii = 0; ii <= (data.length - 1); ii++) {                
            //     if(typeof(vm.listInput[data[ii].competency_category_id]) !== undefined) {
            //         if(data[ii].self_level !== null) {
            //             vm.remaining -= 1;
            //         }
            //         vm.listInput[data[ii].competency_category_id].details.push(data[ii]);                    
            //     }
            // }

            // vm.totalResult = 0;
            // angular.forEach(vm.listInput,function(obj){
            //    vm.totalResult += obj.result;
            // });
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadJobCodeProfile() {
            var jobCodeProfile = CompetencyTeam.query({action:'get_jobcodeprofile',nik:vm.nik});
                jobCodeProfile.$promise.then(fetchDataJobCodeProfile);
                jobCodeProfile.$promise.catch(errorFetchJobCodeProfile); 
        }

        function fetchDataJobCodeProfile(data) {

            vm.jobCodeProfileLists = data;
            vm.job_code = data[0].job_code;

            //vm.remaining = data.length;

            
            // vm.jobCodeProfileLists = [];
            // var group_tmp = '';
            // for(var i = 0; i <= (data.length - 1); i++) {
            //     if(group_tmp !== data[i].competency_category_id) {
            //         if(typeof(vm.jobCodeProfileLists[data[i].competency_category_id]) !== undefined) {
            //             vm.jobCodeProfileLists[data[i].competency_category_id] = {
            //                 category_id: data[i].competency_category_id,
            //                 category_name: data[i].competency_category_name,
            //                 details: []
            //             };
            //         }
            //     }
            //     group_tmp = data[i].competency_category_id;
            // }

            // for(var ii = 0; ii <= (data.length - 1); ii++) {                
            //     if(typeof(vm.jobCodeProfileLists[data[ii].competency_category_id]) !== undefined) {
            //         if(data[ii].self_level !== null) {
            //             vm.remaining -= 1;
            //         }
            //         vm.jobCodeProfileLists[data[ii].competency_category_id].details.push(data[ii]);                    
            //     }
            // }

            // vm.totalResult = 0;
            // angular.forEach(vm.jobCodeProfileLists,function(obj){
            //    vm.totalResult += obj.result;
            // });
            // angular.element.unblockUI();
        }

        function errorFetchJobCodeProfile() {
            vm.jobCodeProfileLists = [];
        }

        function setReq(competency, im) {
            // console.log('competency', competency);
            // console.log('im', im);
     
            var index = vm.jobCodeProfileLists.findIndex(function(c) {
              return c.id == competency;
            })
            
            im.req = vm.jobCodeProfileLists[index].req_level;

            setGap(im);
        }

        function saveData(ev, formController) {  

            vm.Form.objForm.nik = vm.nik;   
            vm.Form.objForm.aspiration = vm.aspiration;   
            vm.Form.objForm.development = vm.developmentLists;   
            vm.Form.objForm.improvement = vm.improvementLists;   
            vm.Form.objForm.job_code = vm.job_code;

            var promise = Form.saveData('save', formController, Idp);

            promise.then(successSaveData);
            promise.catch(failedSaveData);           

        }

        function successSaveData() {
            vm.Form.tampilPesan = false;
            vm.messageTheme = 'green';

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.Form.pesan)
                .position('top right')
                .hideDelay(3000)
                .theme("success-toast")
            );

            loadData();

            vm.setToken();
            
        }

        function failedSaveData() {
            vm.messageTheme = 'red';
            vm.setToken();
        }

        function inputData(ev, input)
        {
      
            $mdDialog.show({
                controller: 'inputSetIdpMemberController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/emp-idp/input-emp-idp/input-emp-idp.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    listInput:vm.listInput,
                    input: input                   
                },
                onRemoving:function(element, removePromise)
                {
                    loadData();
                    //checkSelectedPeriod();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function setGap(im) {
            im.gap = im.act - im.req;
        }

    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.pms.emp_potential.set-emp-potential-member', [])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    function config($stateProvider)
    {
       
        // State 
        $stateProvider
        .state('app.pms_emp_potential_set_potential_member', {
            url    : '/pms/emp-potential/set-potential-member/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/emp-potential/set-potential-member/set-potential-member.html',
                    controller : 'SetEmpPotentialMemberController as vm'
                }
            }
        });   
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.emp_potential.set-emp-potential-member')
        .controller('SetEmpPotentialMemberController', SetEmpPotentialMemberController)
        .directive('mdButtonsTogglePotential', SetEmpPotentialMemberDirective);


    SetEmpPotentialMemberController.$inject=['DataService','$state','$mdDialog','$mdToast','$localStorage','$window','AppAPI','Auth','Form','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function SetEmpPotentialMemberController(DataService,$state,$mdDialog,$mdToast,$localStorage,$window,AppAPI,Auth,Form,DTColumnDefBuilder,$timeout,$stateParams)
    {

        var vm             = this;
        var EmpPotential   = AppAPI.EmpPotential();
        vm.username        = $localStorage.user;
        vm.nik             = $stateParams.id;
        vm.profile         = {};
        vm.score           = {};
        vm.inputData       = inputData;
        vm.setRating       = setRating;
        vm.saveData        = saveData;
        vm.setSummaryClass = setSummaryClass;
        vm.ratingLists     = [];
        vm.remaining       = 0;
        vm.languageList    = [
            {value: 'ID', label: 'Indonesia'},
            {value: 'EN', label: 'English'}
        ];
        vm.isDisabled      = true;
        vm.selected        = 'ID';
        vm.language        = 'ID';
        vm.changeLanguage  = changeLanguage;
        vm.currentYear     = new Date().getFullYear();
        vm.years           = [{year: 2017},{year: 2018},{year: 2019},{year: 2020},{year: 2021},{year: 2022},{year: 2023},{year: 2024},{year: 2025},{year: 2026},{year: 2027},{year: 2028},{year: 2029},{year: 2030}];
        vm.loadData        = loadData;

	    Form.initialForm();

        Form.setObject(EmpPotential);
        
        vm.Form = Form;

        vm.setToken=Auth.setToken;

        // $timeout(function() {
        //     Form.setObject(EmpPotential);
        //     console.log('test1', Form.objForm.$get());
        // }, 1000);

	    loadData();
        
        function changeLanguage(lang) {
            console.log('lang', lang);
            vm.language = lang;
        }
    	
    	function loadData() {
           angular.element.blockUI();
           var promises = EmpPotential.query({
               action: 'get_profile',
               nik: vm.nik,
               period: vm.Form.period
           });
           promises.$promise.then(fetchData);
           promises.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
        	if(typeof(data[0]) !== 'undefined') {
	        	vm.profile = data;
	        	loadQuestionerData();
	        }
        }

        function errorFetch() {
            vm.profile = {};
            angular.element.unblockUI();
        }

        function loadQuestionerData() {
           angular.element.blockUI();
           var dataPromise = EmpPotential.query({
               action: 'get_questioner',
               nik: vm.nik,
               period: vm.Form.period
           });
           dataPromise.$promise.then(fetchQuestionerData);
           dataPromise.$promise.catch(errorQuestionerFetch); 
        }

        function fetchQuestionerData(data) {

            vm.remaining = data.length;
            
            vm.listInput = [];
            var group_tmp = '';
            for(var i = 0; i <= (data.length - 1); i++) {
                if(group_tmp !== data[i].questioner_category_id) {
                    if(typeof(vm.listInput[data[i].questioner_category_id]) !== undefined) {
                        vm.listInput[data[i].questioner_category_id] = {
                            category_id: data[i].questioner_category_id,
                            category_name: data[i].questioner_category_name,
                            category_name_en: data[i].questioner_category_name_en,
                            category_description: data[i].questioner_category_description,
                            category_description_en: data[i].questioner_category_description_en,
                            category_instruction: data[i].questioner_category_instruction,
                            category_instruction_en: data[i].questioner_category_instruction_en,
                            details: []
                        };
                    }
                }
                group_tmp = data[i].questioner_category_id;
            }

            for(var ii = 0; ii <= (data.length - 1); ii++) {   

                if(data[ii].rating !== null) {
                    vm.remaining -= 1;
                }        

                if(typeof(vm.listInput[data[ii].questioner_category_id]) !== undefined) {
                    vm.listInput[data[ii].questioner_category_id].details.push(data[ii]);                    
                }
            }

            vm.totalResult = 0;
            angular.forEach(vm.listInput,function(obj){
               vm.totalResult += obj.result;
            });
            angular.element.unblockUI();

            loadCalculatedScoreData();
        }

        function errorQuestionerFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadCalculatedScoreData() {
           angular.element.blockUI();
           var promises = EmpPotential.query({
               action: 'get_calculatescore',
               nik: vm.nik,
               period: vm.Form.period
           });
           promises.$promise.then(fetchCalculatedScoreData);
           promises.$promise.catch(errorCalculatedScoreFetch); 
        }

        function fetchCalculatedScoreData(data) {
                vm.score = data[0];   
                vm.remaining = vm.score.remaining;

                angular.element.unblockUI();

                // load rating list
                setTimeout(function() {
                    var responseRating = EmpPotential.query({
                        action: 'get_questioner_rating',
                        period: vm.Form.period
                    });
                    responseRating.$promise.then(function(data){
                        vm.ratingLists = data;
                    });

                    responseRating.$promise.catch(function(data){
                        $log.info(data);
                    });

                }, 20);

        }

        function errorCalculatedScoreFetch() {
            vm.score = {};
            angular.element.unblockUI();
        }

        function setSummaryClass(summary_id) {
            var summary_color = '';
            switch(summary_id) {
                case 1:
                    summary_color = 'red-700-fg';
                break;
                case 2:
                    summary_color = 'blue-700-fg';
                break;
                case 3:
                    summary_color = 'green-700-fg';
                break;
            }

            return summary_color;
        }

        function setRating(input) {
            //console.log('Form', Form);
          //  console.log('setRating.input', input);
          //  
          //  
          //           
          
            Form.setObject(EmpPotential);
          
            if(!input.nik) {
                input.nik = vm.nik;
            };

            vm.Form.objForm.rating = input.rating;
            vm.Form.objForm.questioner_id = input.questioner_id;
            vm.Form.objForm.questioner_category_id = input.questioner_category_id; 
            vm.Form.objForm.nik = input.nik;   
            vm.Form.objForm.period = vm.Form.period;  
            setRatingLabel(input.rating);
            //vm.Form.objForm.rating_label = input.rating_label;

            //$('form[name="frmEmployeePotntial"]').submit();
            var form = angular.element(document.getElementById('frmEmployeePotential_'+input.questioner_id));
            //form[0].triggerHandler("submit");
            $timeout(function () {
                form.triggerHandler("submit");
            });

          // saveData(form[0]);

          //  var promise = Form.saveData('save', input, EmpPotential);
          //  console.log('promise', promise);
            // promise.then(successSaveData);
            // promise.catch(failedSaveData);
          
        }

        function setRatingLabel(rating) {
            for(var i = 0; i < vm.ratingLists.length; i++) {
                if(vm.ratingLists[i].rate_value === rating) {
                    vm.Form.objForm.rating_label = vm.ratingLists[i].rate_label;
                }
            }
        }

        function saveData(ev, formController) {   


            //var formController = new FormData(document.forms.namedItem(formController));  

            //var f = document.createElement(formController);// Create a form
           // document.body.appendChild(f);          // Add it to the document body
            //f.action = "/cgi-bin/some.cgi";        // Add action and method attributes
           // f.method = "POST"
            //f.submit();     
            // var promise = EmpPotential.save({
            //     action: 'save',                
            // });            
            var promise = Form.saveData('save', formController, EmpPotential);

            // alert(123);
            // exit();

            // return false;

           promise.then(successSaveData);
           promise.catch(failedSaveData);           

        }

        function successSaveData() {
            vm.Form.tampilPesan = false;
            vm.messageTheme='green';

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.Form.pesan)
                .position('top right')
                .hideDelay(3000)
                .theme("success-toast")
            );

            loadCalculatedScoreData();

            // $timeout(function() {
            //     vm.Form.tampilPesan = false;
            // }, 2000);

            vm.setToken();
            
        }

        function failedSaveData() {
            vm.messageTheme='red';

            vm.setToken();
        }

        function inputData(ev, input)
        {

            if(!input.nik) {
                input.nik = vm.nik;
            };

            $mdDialog.show({
                controller: 'inputEmpPotentialMemberController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/emp-potential/set-potential-member/set-input-potential-member.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    listInput:vm.listInput,
                    input: input,
                    period: vm.Form.period
                },
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

    };

    function SetEmpPotentialMemberDirective() {

        return {
            template: '<div layout="row" layout-align="center center">' +
            '<md-button ng-repeat="option in items" class="md-group md-raised" ng-class="{\'{{selectedClass}}\': option.value == ngModel,left: $index == 0, right: $last}" ng-click="change(option.value)" ng-bind="option.label" ng-disabled="ngDisabled"></md-button></div>',
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                ngModel: '=',
                items: '=',
                ngDisabled: '=',
                selectedClass: '@?'
            },
            link: function(scope, elem, attrs){
                if(angular.isUndefined(scope.selectedClass)){
                    scope.selectedClass = 'md-primary';
                }

                angular.forEach(scope.items, function(value, key){
                    if(!angular.isObject(value)){
                        scope.items[key] = {value: value, label: value};
                    }
                });

                scope.change = function(key){
                    scope.ngModel = key;
                };
            }
        };
   
    }

})();
(function () {
    'use strict';

    angular.module('app.pms.emp_potential.set-emp-potential-member')
           .controller('inputEmpPotentialMemberController', inputEmpPotentialMemberController);

    inputEmpPotentialMemberController.$inject=['$state','$stateParams','$mdDialog','input','period','$localStorage','$timeout','Form','AppAPI','Auth','$log'];
    /** @ngInject */
    function inputEmpPotentialMemberController($state,$stateParams,$mdDialog,input,period,$localStorage,$timeout,Form,AppAPI,Auth, $log) {
        
        var vm                   = this;

        var EmpPotential         = AppAPI.EmpPotential();
        vm.loadData              = loadData;
        vm.saveData              = saveData;
        vm.input                 = input;       
        vm.setRatingLabel       = setRatingLabel;
        vm.listRating             = [];
        vm.cancel                = cancel;
        vm.listLevelDetails      = [];
        //vm.effectiveDate       = effectiveDate;
        vm.inputOn               = 1;
        Form.initialForm();

        console.log('input', input);

         // set constructor form
        Form.setObject(EmpPotential);

        vm.setToken=Auth.setToken;

        // set form to controller
        vm.Form = Form;

        vm.Form.objForm.questioner_category_id = vm.input.questioner_category_id;
        vm.Form.objForm.questioner_id = vm.input.questioner_id;
        vm.Form.objForm.nik = vm.input.nik;
        vm.Form.objForm.rating = vm.input.rating;
        vm.Form.objForm.rating_label = vm.input.rating_label;
        vm.Form.objForm.period = period;

        setTimeout(function() {
            var response = EmpPotential.query({action:'get_questioner_rating', category_id: vm.input.questioner_category_id});
            response.$promise.then(function(data){
                vm.listRating=data;

                // showLevelDetail(vm.mgr_level);

            });

            response.$promise.catch(function(data){
                $log.info(data);
            });
        }, 20);

        function setRatingLabel(rating) {
            for(var i = 0; i < vm.listRating.length; i++) {
                if(vm.listRating[i].rate_value === rating) {
                    vm.Form.objForm.rating_label = vm.listRating[i].rate_label;
                }
            }
        }

        loadData();

        function loadData() {
           angular.element.blockUI();
           var dataPromise = EmpPotential.query({action:'viewdata'});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listInput = data;
            angular.element.unblockUI();

        }

        function errorFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }        

        function saveData(ev,formController) {        

            // vm.Form.objForm.job_code            = vm.jobCode;
            // vm.Form.objForm.job_code_profile_id = vm.jobCodeProfileId;
            // vm.Form.objForm.emp_nik = vm.emp_nik;

            var promise = Form.saveData('save', formController, EmpPotential);

            promise.then(successSaveData);
            promise.catch(failedSaveData);

        }

        function successSaveData() {
            vm.messageTheme='green';

            setTimeout(function() {
                $mdDialog.cancel();
            }, 500);
            
        }

        function failedSaveData() {
            vm.messageTheme='red';
        }
        

        ////////////////
        function hide() {
            $mdDialog.hide();
        }
       
        function cancel() {
            $mdDialog.cancel();
        }


    }

})();  

(function ()
{
    'use strict';

    angular
        .module('app.pms.emp_job_code.input-emp-job-code', [])
        .config(config);

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
      
    }
})();
(function () {
    'use strict';

    angular.module('app.pms.emp_job_code.input-emp-job-code')
           .controller('InputEmpJobCodeController', InputEmpJobCodeController);

    InputEmpJobCodeController.$inject=['$state','$stateParams','$mdDialog','data','$localStorage','$timeout','Form','AppAPI','Auth','$log'];
    /** @ngInject */
    function InputEmpJobCodeController($state,$stateParams,$mdDialog,data,$localStorage,$timeout,Form,AppAPI,Auth,$log) {
        
        var vm                   = this;

        var EmpJobCode           = AppAPI.EmpJobCode();
        vm.loadData              = loadData;
        vm.saveData              = saveData;
        vm.data                  = data;        
        vm.cancel                = cancel;
        vm.hide                  = hide;
        vm.listLevelDetails      = [];
        vm.inputOn               = 1;
        Form.initialForm();

         // set constructor form
        Form.setObject(EmpJobCode);

        vm.setToken=Auth.setToken;

        // set form to controller
        vm.Form = Form;
        vm.Form.objForm.nik = vm.data.nik;
        vm.Form.objForm.job_code = vm.data.job_code;
        vm.Form.objForm.old_job_code = vm.data.job_code;

        // setTimeout(function() {
        //     var response = EmpJobCode.query({action:'get_jobcode'});
        //     response.$promise.then(function(data){
        //         vm.listJobCode=data;

        //     });

        //     response.$promise.catch(function(data){
        //         $log.info(data);
        //     });

        // }, 20);

        loadData();

        function loadData() {
           angular.element.blockUI();
           var dataPromise = EmpJobCode.query({action:'get_jobcode'});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listJobCode = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }        

        function saveData(ev,formController) {   

            console.log('vm.Form.objForm.job_code', vm.Form.objForm.job_code);     
         
            var promise = Form.saveData('save', formController, EmpJobCode);

            promise.then(successSaveData);
            promise.catch(failedSaveData);

        }

        function successSaveData() {
            vm.messageTheme='green';

            setTimeout(function() {
                $mdDialog.cancel();
            }, 500);
            
        }

        function failedSaveData() {
            vm.messageTheme='red';
        }
        
        function hide() {
            $mdDialog.hide();
        }
       
        function cancel() {
            $mdDialog.cancel();
        }


    }

})();  

(function ()
{
    'use strict';

    angular
        .module('app.pms.edp.set_edp_member', [
        ])
        .config(config);

    config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/pms/emp/edp-member');

        // State
        $stateProvider
        .state('app.pms_edp_member', {
            url    : '/pms/set_edp_member/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/edp/set-edp-member/set-edp-member.html',
                    controller : 'SetEdpMemberController as vm'
                }
            }
        });

        // $translatePartialLoaderProvider.addPart('app/main/pms/competency');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.pms.edp.set_edp_member')
        .controller('SetEdpMemberController', SetEdpMemberController);

    SetEdpMemberController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function SetEdpMemberController($state,$log,$mdDialog,AppAPI,Auth,DataService, $document) {
        
        var vm               = this;     
        var Edp           = AppAPI.Edp();    
        var CompetencyReview = AppAPI.CompetencyReview();  

        vm.inputData = inputData;
        vm.remaining = 0;
        vm.development_year = '2016';
        vm.addDevelopment = addDevelopment;
        vm.removeDevelopment = removeDevelopment;
        vm.addImprovement = addImprovement;
        vm.removeImprovement = removeImprovement;
        vm.setReq = setReq;
        vm.setGap = setGap;
        vm.developmentCategoryList = [
            {id:0, name:'-'},
            {id:1, name:'EDUCATION'},
            {id:2, name:'EXPOSURE'},
            {id:3, name:'EXPERIENCE'}
        ];

        vm.improvementLevelList = [
            {level: 1},
            {level: 2},
            {level: 3},
            {level: 4},
            {level: 5}
        ]

        vm.developmentLists = [
            {id: '',
             edp_id: '',
             activities: '',
             time: '',
             institution: '',
             from_beg: '',
             timestamp: ''
            }
        ];

        vm.improvementLists = [
            {   
                id: '',
                edp_id: '',
                area_for_improvement: '',
                idp_development_category_id: '',
                req: '',
                act: '',
                gap: '',
                disabled: '',
                development_plan: '',
                timestamp: ''
            }
        ];


        loadJobCodeProfile();

        function addDevelopment() {
            vm.developmentLists.push(
                {id: '',
                 edp_id: '',
                 activities: '',
                 time: '',
                 institution: '',
                 from_beg: '',
                 timestamp: ''
                }
            );
        }

        function removeDevelopment(d) {
            if(d.id === '') {
                var index = vm.developmentLists.indexOf(d);
                vm.developmentLists.splice(index, 1);
            }
        }

        function addImprovement() {
            vm.improvementLists.push(
                {   
                    id: '',
                    edp_id: '',
                    area_for_improvement: '',
                    idp_development_category_id: '',
                    req: '',
                    act: '',
                    gap: '',
                    disabled: '',
                    development_plan: '',
                    timestamp: ''
                }
            );
        }

        function removeImprovement(i) {
            if(i.id === '') {
                var index = vm.improvementLists.indexOf(i);
                vm.improvementLists.splice(index, 1);
            }
        }

        loadData();

        function loadData() {
           angular.element.blockUI();
           var dataPromise = Edp.query({action:'viewData'});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {            

            vm.remaining = data.length;
            
            vm.listInput = [];
            var group_tmp = '';
            for(var i = 0; i <= (data.length - 1); i++) {
                if(group_tmp !== data[i].competency_category_id) {
                    if(typeof(vm.listInput[data[i].competency_category_id]) !== undefined) {
                        vm.listInput[data[i].competency_category_id] = {
                            category_id: data[i].competency_category_id,
                            category_name: data[i].competency_category_name,
                            details: []
                        };
                    }
                }
                group_tmp = data[i].competency_category_id;
            }

            for(var ii = 0; ii <= (data.length - 1); ii++) {                
                if(typeof(vm.listInput[data[ii].competency_category_id]) !== undefined) {
                    if(data[ii].self_level !== null) {
                        vm.remaining -= 1;
                    }
                    vm.listInput[data[ii].competency_category_id].details.push(data[ii]);                    
                }
            }

            vm.totalResult = 0;
            angular.forEach(vm.listInput,function(obj){
               vm.totalResult += obj.result;
            });
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadJobCodeProfile() {
            var jobCodeProfile = CompetencyReview.query({action:'get_jobcodeprofile'});
                jobCodeProfile.$promise.then(fetchDataJobCodeProfile);
                jobCodeProfile.$promise.catch(errorFetchJobCodeProfile); 
        }

        function fetchDataJobCodeProfile(data) {

            vm.jobCodeProfileLists = data;

            //vm.remaining = data.length;

            
            // vm.jobCodeProfileLists = [];
            // var group_tmp = '';
            // for(var i = 0; i <= (data.length - 1); i++) {
            //     if(group_tmp !== data[i].competency_category_id) {
            //         if(typeof(vm.jobCodeProfileLists[data[i].competency_category_id]) !== undefined) {
            //             vm.jobCodeProfileLists[data[i].competency_category_id] = {
            //                 category_id: data[i].competency_category_id,
            //                 category_name: data[i].competency_category_name,
            //                 details: []
            //             };
            //         }
            //     }
            //     group_tmp = data[i].competency_category_id;
            // }

            // for(var ii = 0; ii <= (data.length - 1); ii++) {                
            //     if(typeof(vm.jobCodeProfileLists[data[ii].competency_category_id]) !== undefined) {
            //         if(data[ii].self_level !== null) {
            //             vm.remaining -= 1;
            //         }
            //         vm.jobCodeProfileLists[data[ii].competency_category_id].details.push(data[ii]);                    
            //     }
            // }

            // vm.totalResult = 0;
            // angular.forEach(vm.jobCodeProfileLists,function(obj){
            //    vm.totalResult += obj.result;
            // });
            // angular.element.unblockUI();
        }

        function errorFetchJobCodeProfile() {
            vm.jobCodeProfileLists = [];
        }

        function setReq(competency, im) {
            console.log('competency', competency);
            console.log('im', im);
     
            var index = vm.jobCodeProfileLists.findIndex(function(c) {
              return c.id == competency;
            })
            
            im.req = vm.jobCodeProfileLists[index].req_level;

            setGap(im);
        }

        function inputData(ev, input)
        {
      
            $mdDialog.show({
                controller: 'inputSetEdpMemberController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/emp-idp/input-emp-idp/input-emp-idp.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    listInput:vm.listInput,
                    input: input                   
                },
                onRemoving:function(element, removePromise)
                {
                    loadData();
                    //checkSelectedPeriod();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function setGap(im) {
            im.gap = im.act - im.req;
        }

    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.pms.cr_progress.set-team-all', [])
        .config(config);

     config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
      $stateProvider
             .state('app.pms_cr_progress_set_team_all', {
                url    : '/pms/cr-progress/set-team-all/set-team-all/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/cr-progress/set-team-all/set-team-all.html',
                        controller : 'CrProgressSetteamallController as vm'
                    }
                }
            });       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.cr_progress.set-team-all')
        .controller('CrProgressSetteamallController', CrProgressSetteamallController)


    CrProgressSetteamallController.$inject=['DataService','$state','$mdDialog','AppAPI','Auth','Form','$localStorage','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function CrProgressSetteamallController(DataService,$state,$mdDialog,AppAPI,Auth,Form,$localStorage,DTColumnDefBuilder,$timeout,$stateParams)
    {
        
    var vm = this;
    vm.username=$localStorage.user;
    // initial form
    Form.initialForm();
    vm.nik=$stateParams.id;
    vm.approveKS=approveKS;
    vm.closeKpi=closeKpi;
    vm.select=select;
    vm.toggleSelectedAll=toggleSelectedAll;
    vm.viewScales=viewScales;
    vm.isChecked=isChecked;
     vm.toggleCheck = toggleCheck;
    vm.listKSSelected=[];
    var teamMember=AppAPI.teamMember();
    vm.DataTable= new DataService();
    vm.showKpi=showKpi;
    vm.loadData=loadData;
    var today = new Date();
    var year = today.getFullYear();
    vm.yearSelected=year;
    vm.removeApproval=removeApproval;
    vm.years=[{year:2020,selected:true},{year:2018,selected:false},{year:2018,selected:false},{year:2017,selected:false},{year:2016,selected:false},{year:2015,selected:false}];
    checkSelectedYear();
    loadData(1);
    loadDataEff();
 

        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers',
            paging:false,
            searching:false
        };

  function checkSelectedYear()
        {

           // var lengthYear=vm.years
            angular.forEach(vm.years,function(obj){
               if(obj.year===vm.yearSelected)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }  

  
   function showKpi(year)
        {   
            vm.listKSSelected=[];
           vm.yearSelected=year;
           checkSelectedYear();
           loadData(1);
        }           

function isChecked(ks)
        {
            return vm.listKSSelected.indexOf(ks) > -1;
        }

function toggleCheck(ks, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listKSSelected.indexOf(ks);

            if ( idx > -1 )
            {
                vm.listKSSelected.splice(idx, 1);
            }
            else
            {
                vm.listKSSelected.push(ks);
            }
        }

function loadData(pageno)
      {
        var KpiScales=AppAPI.KpiScales();
          vm.DataTable.loadData(KpiScales,pageno,{action:'viewdatayearall',eff:vm.yearSelected,id:vm.nik});
         // loadDataEff();
         vm.listKSSelected=[];
      }


         function viewScales(ev,kpi) {
           $mdDialog.show({
              controller: 'CrProgressSetteamallscaleController',
              controllerAs:'vm',
              templateUrl: 'app/main/pms/cr-progress/set-team-all/set-team-all-scale.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              locals:{
                kpi:kpi
              }
            });
    }
    

     function loadDataEff() {
         angular.element.blockUI();
        var buPromise=teamMember.query({action:'viewdetail',id:$stateParams.id});
        buPromise.$promise.then(fetchEff);
        buPromise.$promise.catch(errorFetchEff); 
         
      }

      function fetchEff(data) {
        vm.listkpi=data;  

        angular.forEach(vm.listkpi, function(value, key) {

      });  


         angular.element.unblockUI();
        
      }

      function errorFetchEff() {
        vm.listkpi=[];
         angular.element.unblockUI();
      }

      function select(ks){
        return vm.listKSSelected;
      }

    function closeKpi()
    {
        $mdDialog.hide();
    }

    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listKSSelected=angular.copy(vm.listkpi);

    }

    function unCheckAll() {
       vm.listKSSelected=[];
    }

     function approveKS(ev) {

/*        if (!vm.listKSSelected.length){

             vm.tampilPesan=true;
             vm.pesan='Please Checkbox!';
             vm.messageTheme='blue';
             $timeout(function() {
                 vm.tampilPesan=false;
             }, 3000);
      
        }else{*/
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to Approve this list?')
          .textContent('All data your selected will be approved.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');
    $mdDialog.show({
            multiple: true
       });      
    $mdDialog.show(confirm).then(function() {
          angular.element.blockUI();

       var response=teamMember.delete({action:'approve',data:angular.toJson(vm.listKSSelected)});
       response.$promise.then(loadData);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
   // }
   
    }


    function removeApproval(id,kpi,ev) {
      var confirm = $mdDialog.confirm()
          .title('Would you like to delete  KPI Approval ?')
          .textContent('This KPI ('+kpi+') approval will be deleted and cannot recovered. Are You Sure ?')
          .ariaLabel('delete kpi')
          .targetEvent(ev)
          .ok('Yes, Delete')
          .cancel('Cancel');

    $mdDialog.show(confirm).then(function() {

        var promise =Auth.setToken();
        promise.then(function(){
           var response=teamMember.delete({action:'unapproved',id:id});
             response.$promise.then(loadData);
        });
      
    });
    }
}


})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.cr_progress.set-team-all')
        .controller('CrProgressSetteamallscaleController', CrProgressSetteamallscaleController)


    CrProgressSetteamallscaleController.$inject=['kpi','$state','$mdDialog','AppAPI','Auth','Form','$localStorage','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function CrProgressSetteamallscaleController(kpi,$state,$mdDialog,AppAPI,Auth,Form,$localStorage,DTColumnDefBuilder,$timeout,$stateParams)
    {
        
    var vm = this;
    vm.username=$localStorage.user;
    // initial form
    Form.initialForm();
    vm.kpi=kpi;
    vm.closeKpi=closeKpi;
    vm.nik=$stateParams.id;
    var teamMember=AppAPI.teamMember();
    loadDataEffJudul();
    loadDataEff();

        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers',
            paging:false,
            searching:false
        };

     
      function loadDataEffJudul() {
         angular.element.blockUI();
        var buPromise2=teamMember.query({action:'viewdetailks',id:vm.kpi,nik:vm.nik});
        buPromise2.$promise.then(fetchEffJudul);
        buPromise2.$promise.catch(errorFetchEffJudul); 
         
      }

      function fetchEffJudul(data) {
      	 vm.kpidesc=data[0].kpi;
      	 vm.uom=data[0].uom;
      	 vm.bobot=data[0].bobot;
      	 vm.target=data[0].target;
         angular.element.unblockUI();
        
      }

      function errorFetchEffJudul() {
         angular.element.unblockUI();
      }   

     function loadDataEff() {
         angular.element.blockUI();
        var buPromise=teamMember.query({action:'viewdetailks',id:vm.kpi,nik:vm.nik});
        buPromise.$promise.then(fetchEff);
        buPromise.$promise.catch(errorFetchEff); 
         
      }

      function fetchEff(data) {
         vm.listkpiscale=data;    
         angular.element.unblockUI();
        
      }

      function errorFetchEff() {
        vm.listkpiscale=[];
         angular.element.unblockUI();
      }



      function select(ks){
        return vm.listKSSelected;
      }

    function closeKpi()
    {
        $mdDialog.hide();
    }

  
   
}


})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.competency_team.set-competency-review-member', [])
        .config(config);

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
        // State 
        $stateProvider
        .state('app.pms_competency_team_set_competency_review_member', {
            url    : '/pms/competency-team/set-competency-review-member/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/competency-team/set-competency-review-member/set-competency-review-member.html',
                    controller : 'SetCompetencyReviewMemberController as vm'
                }
            }
        });   
                
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function () {
    'use strict';

    angular.module('app.pms.competency_team.set-competency-review-member')
           .controller('inputCompetencyReviewMemberController', inputCompetencyReviewMemberController)
           .directive('mdButtonsToggle', inputCompetencyReviewMemberDirective);

    inputCompetencyReviewMemberController.$inject=['$state','$stateParams','$mdDialog','$mdToast','input','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function inputCompetencyReviewMemberController($state,$stateParams,$mdDialog,$mdToast,input,$localStorage,$timeout,Form,AppAPI,Auth) {
        
        var vm                     = this;

        var CompetencyReview       = AppAPI.CompetencyReview();
        var CompetencyTeam         = AppAPI.CompetencyTeam();
        vm.loadData                = loadData;
        vm.saveData                = saveData;
        vm.jobCode                 = input.job_code;
        vm.jobCodeProfileId        = input.id;
        vm.competencyCode          = input.competency_code;
        vm.competency_id           = input.competency_id;
        vm.competency              = input.competency;
        vm.competencyDescription   = input.competency_description;
        vm.competencyDescriptionEn = input.competency_description_en;
        vm.mgr_level               = input.mgr_level;
        vm.req_level               = input.req_level;
        vm.self_level              = input.self_level;
        vm.emp_nik                 = input.emp_nik;
        vm.mgr_comments            = input.mgr_comments;
        vm.showLevelDetail         = showLevelDetail;
        vm.listBid                 = [];
        vm.listLevel               = [];
        vm.cancel                  = cancel;
        vm.listLevelDetails        = [];
        //vm.effectiveDate         = effectiveDate;
        vm.inputOn                 = 1;
        vm.languageList            = [
            {value: 'ID', label: 'Indonesia'},
            {value: 'EN', label: 'English'}
        ];
        vm.isDisabled              = true;
        vm.selected                = 'ID';
        vm.language                = 'ID';
        vm.changeLanguage          = changeLanguage;

        Form.initialForm();

        console.log('input', input);

         // set constructor form
        Form.setObject(CompetencyTeam);

        vm.setToken=Auth.setToken;

        // set form to controller
        vm.Form = Form;

        vm.Form.objForm.job_code = input.job_code;
        vm.Form.objForm.job_code_profile_id = input.id;
        vm.Form.objForm.emp_nik = input.emp_nik;
        vm.Form.objForm.mgr_level = input.mgr_level;
        vm.Form.objForm.mgr_comments = input.mgr_comments;
        vm.Form.objForm.status = input.status_id;
        vm.Form.objForm.period = input.period;

        setTimeout(function() {
            var response = CompetencyReview.query({action:'get_levels', competencyId: vm.competency_id});
            response.$promise.then(function(data){
                vm.listLevel=data;

                showLevelDetail(vm.mgr_level);

            });

            response.$promise.catch(function(data){
                $log.info(data);
            });
        }, 20);
       
        function showLevelDetail(level) {
            vm.listLevelDetails = [];
            for(var i = 0; i <= (vm.listLevel.length - 1); i++) {
                for(var ii = 0; ii <= (vm.listLevel[i].details.length - 1); ii++) {
                    if(typeof(vm.listLevel[i].details[ii]) !== undefined) {   
            
                        vm.listLevelDetails.push(vm.listLevel[i].details[ii]);  
                    
                                    
                        //if(vm.listLevel[i].details[ii].level === level) {
                        //     vm.listLevelDetails.push(vm.listLevel[i].details[ii]);
                        //}
                    }
                }
            }

            var el = document.getElementsByClassName("lists-level-details");
            for (var i = 0; i <= (el.length - 1); ++i) {
                el[i].setAttribute('style','border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-right: 1px solid rgba(0, 0, 0, 0.12);');
            }

            var el = document.getElementsByClassName("lists-level-details-"+level);
            for (var i = 0; i <= (el.length - 1); ++i) {
                el[i].setAttribute('style','background-color: #BCECDD; border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-right: 1px solid rgba(0, 0, 0, 0.12);');
            }

        }

        loadData();

        function loadData() {
           angular.element.blockUI();
           var dataPromise = CompetencyTeam.query({action:'viewdata'});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listInput = data;
            angular.element.unblockUI();

        }

        function errorFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }        

        function saveData(ev,formController) {        

            vm.Form.objForm.job_code            = vm.jobCode;
            vm.Form.objForm.job_code_profile_id = vm.jobCodeProfileId;
            vm.Form.objForm.emp_nik = vm.emp_nik;
            vm.Form.objForm.period = input.period;

            var promise = Form.saveData('save', formController, CompetencyTeam);

            promise.then(successSaveData);
            promise.catch(failedSaveData);

        }

        function successSaveData() {
            vm.messageTheme='green';

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.Form.pesan)
                .position('top right')
                .hideDelay(3000)
                .theme("success-toast")
            );

            setTimeout(function() {
                $mdDialog.cancel();
            }, 500);
            
        }

        function failedSaveData() {
            vm.messageTheme='red';
        }
        

        ////////////////
        function hide() {
            $mdDialog.hide();
        }
       
        function cancel() {
            $mdDialog.cancel();
        }

        function changeLanguage(lang) {
            console.log('lang', lang);
            vm.language = lang;

            showLevelDetail(vm.Form.objForm.mgr_level);

        }


    };

    function inputCompetencyReviewMemberDirective() {

        return {
            template: '<div layout="row" layout-align="center center">' +
            '<md-button ng-repeat="option in items" class="md-group md-raised" ng-class="{\'{{selectedClass}}\': option.value == ngModel,left: $index == 0, right: $last}" ng-click="change(option.value)" ng-bind="option.label" ng-disabled="ngDisabled"></md-button></div>',
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                ngModel: '=',
                items: '=',
                ngDisabled: '=',
                selectedClass: '@?'
            },
            link: function(scope, elem, attrs){
                if(angular.isUndefined(scope.selectedClass)){
                    scope.selectedClass = 'md-primary';
                }

                angular.forEach(scope.items, function(value, key){
                    if(!angular.isObject(value)){
                        scope.items[key] = {value: value, label: value};
                    }
                });

                scope.change = function(key){
                    scope.ngModel = key;
                };
            }
        };
   
    }

})();  

(function () {
    'use strict';

    angular
        .module('app.pms.competency_team.set-competency-review-member')
        .controller('SetCompetencyReviewMemberController', SetCompetencyReviewMemberController)


    SetCompetencyReviewMemberController.$inject = ['DataService', '$state', '$mdDialog', '$mdToast', '$localStorage', '$window', 'AppAPI', 'Auth', 'Form', 'DTColumnDefBuilder', '$timeout', '$stateParams'];
    /** @ngInject */
    function SetCompetencyReviewMemberController(DataService, $state, $mdDialog, $mdToast, $localStorage, $window, AppAPI, Auth, Form, DTColumnDefBuilder, $timeout, $stateParams) {

        var vm = this;
        var CompetencyTeam = AppAPI.CompetencyTeam();
        vm.username = $localStorage.user;
        vm.nik = $stateParams.id;
        vm.profile = {};
        vm.career_aspiration = '';
        vm.inputData = inputData;
        vm.setStrength = setStrength;
        vm.saveDataStrength = saveDataStrength;
        vm.saveAspirationData = saveAspirationData;
        vm.remaining = 0;
        vm.mgr_remaining = 0;
        vm.maxStrength = 3;
        vm.maxImprovement = 3;
        vm.strengthLists = [
            { id: 0, name: '-' },
            { id: 1, name: 'Strength' },
            { id: 2, name: 'Area for Improvement' }
        ];
        vm.loadData = loadData;
        vm.currentYear = new Date().getFullYear();
        vm.years = [{ year: 2017 }, { year: 2018 }, { year: 2019 }, { year: 2020 }, { year: 2021 }, { year: 2022 }, { year: 2023 }, { year: 2024 }, { year: 2025 }, { year: 2026 }, { year: 2027 }, { year: 2028 }, { year: 2029 }, { year: 2030 }];
        Form.initialForm();
        vm.showRemaining = false;

        // set constructor form
        Form.setObject(CompetencyTeam);
        vm.Form = Form;

        vm.setToken = Auth.setToken;

        loadData();

        function loadData() {
            angular.element.blockUI();
            var promises = CompetencyTeam.query({ action: 'get_profile', nik: vm.nik });
            promises.$promise.then(fetchData);
            promises.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            if (typeof (data[0]) !== 'undefined') {
                vm.profile = data;
                loadJobCodeProfileData();
            }
        }

        function errorFetch() {
            vm.profile = {};
            angular.element.unblockUI();
        }

        function showRemaining() {

            if (vm.listInput.length > 0) {
                console.log('vm.listInput[1]', vm.listInput[1]);
                if (vm.listInput[1].details[0].bypass_cr_self == 1) {
                    vm.showRemaining = true;
                } else {
                    if (vm.remaining === 0 && vm.mgr_remaining > 0 && vm.listInput.length > 0) {
                        vm.showRemaining = true;
                    } else {
                        vm.showRemaining = false;
                    }
                }
            }

        }

        function loadJobCodeProfileData() {
            //angular.element.blockUI();
            var dataPromise = CompetencyTeam.query({
                action: 'get_jobcodeprofile',
                nik: vm.nik,
                period: vm.Form.period
            });
            dataPromise.$promise.then(fetchJobCodeProfileData);
            dataPromise.$promise.catch(errorJobCodeProfileFetch);
        }

        function fetchJobCodeProfileData(data) {

            vm.maxStrength = 3;
            vm.maxImprovement = 3;

            vm.remaining = data.length;
            vm.mgr_remaining = data.length;
            if (typeof (data[0]) !== 'undefined') {
                vm.job_code = data[0].job_code;
            }

            vm.listInput = [];
            var group_tmp = '';
            for (var i = 0; i <= (data.length - 1); i++) {
                if (typeof (data[i].competency_category_id) !== undefined) {
                    if (group_tmp !== data[i].competency_category_id) {
                        if (typeof (vm.listInput[data[i]]) != undefined) {

                            vm.listInput[data[i].competency_category_id] = {
                                category_id: data[i].competency_category_id,
                                category_name: data[i].competency_category_name,
                                details: []
                            };


                        }
                    }
                    group_tmp = data[i].competency_category_id;
                }
            }

            for (var ii = 0; ii <= (data.length - 1); ii++) {
                if (typeof (vm.listInput[data[ii]]) !== undefined) {

                    if (data[ii].status_id === '1') {
                        vm.maxStrength -= 1;
                        if (vm.maxStrength < 0) {
                            vm.maxStrength = 0;
                        }
                    }

                    if (data[ii].status_id === '2') {
                        vm.maxImprovement -= 1;
                        if (vm.maxImprovement < 0) {
                            vm.maxImprovement = 0;
                        }
                    }

                    if (data[ii].self_level !== null) {
                        vm.remaining -= 1;
                    }

                    if (typeof (data[ii].mgr_level) !== 'undefined') {
                        vm.mgr_remaining -= 1;
                    }
                    vm.listInput[data[ii].competency_category_id].details.push(data[ii]);
                }
            }


            //console.log('vm.maxStrength', vm.maxStrength);
            //console.log('vm.maxImprovement', vm.maxImprovement);

            vm.totalResult = 0;
            angular.forEach(vm.listInput, function (obj) {
                vm.totalResult += obj.result;
            });
            angular.element.unblockUI();

            loadCompetencyReviewData();

        }

        function errorJobCodeProfileFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadCompetencyReviewData() {
            //angular.element.blockUI();
            var dataPromise = CompetencyTeam.query({
                action: 'getCompetencyReviewData',
                nik: vm.nik,
                period: vm.Form.period
            });
            dataPromise.$promise.then(fetchCompetencyReviewData);
            dataPromise.$promise.catch(errorFetchCompetencyReview);

        }

        function fetchCompetencyReviewData(data) {
            if (typeof (data[0]) !== 'undefined') {
                vm.career_aspiration = data[0].career_aspiration;
            }

            showRemaining();

            vm.setToken();
            angular.element.unblockUI();
        }

        function errorFetchCompetencyReview() {
            vm.messageTheme = 'red';
        }

        function setStrength(input) {

            if (input.status_id === '1' && vm.maxStrength <= 0) {
                input.status_id = 0;
                vm.messageTheme = 'red';
                vm.Form.tampilPesan = true;
                vm.Form.pesan = 'Limited only 3 of Strength';

                $timeout(function () {
                    vm.Form.tampilPesan = false;
                    vm.Form.pesan = '';
                }, 8000);

                return false;
            }

            if (input.status_id === '2' && vm.maxImprovement <= 0) {
                input.status_id = 0;
                vm.messageTheme = 'red';
                vm.Form.tampilPesan = true;
                vm.Form.pesan = 'Limited only 3 of Area for Improvement';

                $timeout(function () {
                    vm.Form.tampilPesan = false;
                    vm.Form.pesan = '';
                }, 8000);

                return false;
            }

            if (input.status_id === '0' || (vm.maxStrength > 0 || vm.maxImprovement > 0)) {

                vm.Form.objForm.job_code = input.job_code;
                vm.Form.objForm.job_code_profile_id = input.id;
                vm.Form.objForm.emp_nik = input.emp_nik;
                vm.Form.objForm.status = input.status_id;
                vm.Form.objForm.mgr_level = input.mgr_level;
                vm.Form.objForm.mgr_comments = input.mgr_comments;
                vm.Form.objForm.period = vm.Form.period;

                vm.maxStrength -= 1;

                var form = angular.element(document.getElementById('formCompetencyReviewMember_' + input.id));
                $timeout(function () {
                    form.triggerHandler("submit");
                });
            }

        }

        function saveDataStrength(ev, formController) {

            // vm.Form.objForm.job_code            = vm.jobCode;
            // vm.Form.objForm.job_code_profile_id = vm.jobCodeProfileId;
            // vm.Form.objForm.emp_nik = vm.emp_nik;

            var promiseSaveStrength = Form.saveData('save', formController, CompetencyTeam);

            promiseSaveStrength.then(successSaveDataStrength);
            promiseSaveStrength.catch(failedSaveDataStrength);

        }

        function successSaveDataStrength() {
            vm.messageTheme = 'green';

            $mdToast.show(
                $mdToast.simple()
                    .textContent(vm.Form.pesan)
                    .position('top right')
                    .hideDelay(3000)
                    .theme("success-toast")
            );

            loadJobCodeProfileData();

            vm.setToken();

            // setTimeout(function() {
            //     $mdDialog.cancel();
            // }, 500);

        }

        function failedSaveDataStrength() {
            vm.messageTheme = 'red';

            vm.setToken();
        }

        function saveAspirationData(ev, formController) {

            vm.Form.objForm.career_aspiration = vm.career_aspiration;
            vm.Form.objForm.job_code = vm.job_code;
            vm.Form.objForm.nik = vm.nik;
            vm.Form.objForm.period = vm.Form.period;

            var promise = Form.saveData('saveAspiration', formController, CompetencyTeam);

            promise.then(successSaveAspirationData);
            promise.catch(failedSaveAspirationData);

        }

        function successSaveAspirationData() {
            vm.Form.tampilPesan = false;
            $mdToast.show(
                $mdToast.simple()
                    .textContent(vm.Form.pesan)
                    .position('top right')
                    .hideDelay(3000)
                    .theme("success-toast")
            );

        }

        function failedSaveAspirationData() {
            vm.Form.tampilPesan = true;
            vm.messageTheme = 'red';
        }

        function inputData(ev, input) {
            input.period = vm.Form.period;
            $mdDialog.show({
                controller: 'inputCompetencyReviewMemberController',
                controllerAs: 'vm',
                templateUrl: 'app/main/pms/competency-team/set-competency-review-member/set-input-competency-review-member.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    listInput: vm.listInput,
                    input: input
                },
                onRemoving: function (element, removePromise) {
                    loadJobCodeProfileData();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.competency_review.input-competency-review', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        
    }
})();
(function () {
    'use strict';

    angular.module('app.pms.competency_review.input-competency-review')
           .controller('inputCompetencyReviewController', inputCompetencyReviewController)
           .directive('mdButtonsToggle2', inputCompetencyReviewDirective);

    inputCompetencyReviewController.$inject=['$state','$stateParams','$mdDialog','input','$localStorage','$timeout','Form','AppAPI','Auth','$log'];
    /** @ngInject */
    function inputCompetencyReviewController($state,$stateParams,$mdDialog,input,$localStorage,$timeout,Form,AppAPI,Auth, $log) {
        
        var vm                     = this;

        var CompetencyReview       = AppAPI.CompetencyReview();
        //vm.loadData                = loadData;
        vm.saveData                = saveData;
        vm.jobCode                 = input.job_code;
        vm.jobCodeProfileId        = input.id;
        vm.competencyCode          = input.competency_code;
        vm.competency_id           = input.competency_id;
        vm.competency              = input.competency;
        vm.competencyDescription   = input.competency_description;
        vm.competencyDescriptionEn = input.competency_description_en;
        vm.self_level              = input.self_level;
        vm.req_level               = input.req_level;
        vm.comments                = input.comments;
        vm.showLevelDetail         = showLevelDetail;
        vm.listBid                 = [];
        vm.listLevel               = [];
        vm.cancel                  = cancel;
        vm.listLevelDetails        = [];
        //vm.effectiveDate         = effectiveDate;
        vm.inputOn                 = 1;

        vm.languageList            = [
            {value: 'ID', label: 'Indonesia'},
            {value: 'EN', label: 'English'}
        ];
        vm.isDisabled = true;
        vm.selected = 'ID';
        vm.language              = 'ID'; 
        vm.changeLanguage        = changeLanguage;

        Form.initialForm();

         // set constructor form
        Form.setObject(CompetencyReview);

        vm.setToken=Auth.setToken;

        // set form to controller
        vm.Form = Form;

        vm.Form.objForm.job_code = input.job_code;
        vm.Form.objForm.job_code_profile_id = input.id;
        vm.Form.objForm.self_level = input.self_level;
        vm.Form.objForm.comments = input.comments;

        setTimeout(function() {
            var response = CompetencyReview.query({action:'get_levels', competencyId: vm.competency_id});
            response.$promise.then(function(data){
                vm.listLevel=data;

                showLevelDetail(vm.self_level);

            });

            response.$promise.catch(function(data){
                $log.info(data);
            });
        }, 20);
       
        function showLevelDetail(level) {
            vm.listLevelDetails = [];
            for(var i = 0; i <= (vm.listLevel.length - 1); i++) {
                for(var ii = 0; ii <= (vm.listLevel[i].details.length - 1); ii++) {
                    if(typeof(vm.listLevel[i].details[ii]) !== undefined) {                        
                        vm.listLevelDetails.push(vm.listLevel[i].details[ii]);                        
                        //if(vm.listLevel[i].details[ii].level === level) {
                        //     vm.listLevelDetails.push(vm.listLevel[i].details[ii]);
                        //}
                    }
                }
            }

            var el = document.getElementsByClassName("lists-level-details");
            for (var i = 0; i <= (el.length - 1); ++i) {
                el[i].setAttribute('style','border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-right: 1px solid rgba(0, 0, 0, 0.12);');
            }

            var el = document.getElementsByClassName("lists-level-details-"+level);
            for (var i = 0; i <= (el.length - 1); ++i) {
                el[i].setAttribute('style','background-color: #BCECDD; border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-right: 1px solid rgba(0, 0, 0, 0.12);');
            }

        }

        // loadData();

        // function loadData() {
        //    angular.element.blockUI();
        //    var dataPromise = CompetencyReview.query({action:'viewdata'});
        //    dataPromise.$promise.then(fetchData);
        //    dataPromise.$promise.catch(errorFetch); 
        // }

        // function fetchData(data) {
        //     vm.listInput = data;
        //     angular.element.unblockUI();

        // }

        // function errorFetch() {
        //     vm.listInput = [];
        //     angular.element.unblockUI();
        // }        

        function saveData(ev,formController) {        

            vm.Form.objForm.job_code            = vm.jobCode;
            vm.Form.objForm.job_code_profile_id = vm.jobCodeProfileId;
            vm.Form.objForm.job_code_profile_id = vm.jobCodeProfileId;

            var promise = Form.saveData('save', formController, CompetencyReview);

            promise.then(successSaveData);
            promise.catch(failedSaveData);

        }

        function successSaveData() {
            vm.messageTheme='green';

            setTimeout(function() {
                $mdDialog.cancel();
            }, 500);
            
        }

        function failedSaveData() {
            vm.messageTheme='red';
        }
        

        ////////////////
        function hide() {
            $mdDialog.hide();
        }
       
        function cancel() {
            $mdDialog.cancel();
        }

        function changeLanguage(lang) {
            console.log('lang', lang);
            vm.language = lang;
        }


    };

    function inputCompetencyReviewDirective() {

        return {
            template: '<div layout="row" layout-align="center center">' +
            '<md-button ng-repeat="option in items" class="md-group md-raised" ng-class="{\'{{selectedClass}}\': option.value == ngModel,left: $index == 0, right: $last}" ng-click="change(option.value)" ng-bind="option.label" ng-disabled="ngDisabled"></md-button></div>',
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                ngModel: '=',
                items: '=',
                ngDisabled: '=',
                selectedClass: '@?'
            },
            link: function(scope, elem, attrs){
                if(angular.isUndefined(scope.selectedClass)){
                    scope.selectedClass = 'md-primary';
                }

                angular.forEach(scope.items, function(value, key){
                    if(!angular.isObject(value)){
                        scope.items[key] = {value: value, label: value};
                    }
                });

                scope.change = function(key){
                    scope.ngModel = key;
                };
            }
        };
   
    }

})();  

(function() {
    'use strict';

    angular
        .module('app.pms.behaviour_performance_team.set-behaviour')
        .controller('BehaviourperformancesetteamController', BehaviourperformancesetteamController);

    
    /* @ngInject */
     BehaviourperformancesetteamController.$inject=['$localStorage','AppAPI','$mdDialog','$window','Form','Auth','$stateParams'];
    /** @ngInject */
    function BehaviourperformancesetteamController($localStorage,AppAPI,$mdDialog,$window,Form,Auth,$stateParams)
    {
        
         var vm = this;
        vm.username=$localStorage.nama;
        vm.addData = addData;
        vm.editData = editData;
        vm.nik=$stateParams.id;
        var Behivor = AppAPI.Behivorteam();
        vm.loadData = loadData;
        vm.checkSelectedPeriod=checkSelectedPeriod;
        vm.showBehivor=showBehivor;
        vm.deleteData=deleteData;
        loadConfig();
        checkSelectedPeriod();

        function checkSelectedPeriod()
        {
            angular.forEach(vm.listPeriod,function(obj){
               if(obj.effectiveDate===vm.currentDate)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }

        function showBehivor(rDate)
        {
           vm.currentDate=rDate;
           checkSelectedPeriod();
           loadData();
        }

        function loadData() {
           angular.element.blockUI();
           var dataPromise = Behivor.query({action:'viewinputdatateam',nik:vm.nik,rDate:vm.currentDate});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listInput = data;
            vm.totalResult = 0;
            angular.forEach(vm.listInput,function(obj){
               vm.totalResult += obj.result;
            });

            loadLevelData();
            
            //angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadConfig() {
           angular.element.blockUI();
           var dataPromise = Behivor.query({action:'viewconfigdata'});
           dataPromise.$promise.then(fetchConfig);
           dataPromise.$promise.catch(errorConfig); 
        }

        function fetchConfig(data) {
            vm.listPeriod = data;
            angular.forEach(vm.listPeriod,function(obj){
               vm.currentDate = obj.effectiveDate;
            });
            loadData(vm.currentDate);

            angular.element.unblockUI();
        }

        function errorConfig() {
            vm.listPeriod = [];
            angular.element.unblockUI();
        }


        function loadLevelData() {
           var dataPromise = Behivor.query({action:'viewleveldata'});
           dataPromise.$promise.then(fetchLevelData);
           dataPromise.$promise.catch(errorLevelFetch); 
        }

        function fetchLevelData(data) {
            vm.listInputLevel = data;
            angular.element.unblockUI();

        }

        function errorLevelFetch() {
            vm.listInputLevel = [];
            angular.element.unblockUI();
        }

        function showLevelDetail(behivor, level) {
            // vm.listLevelDetails = [];
            // for(var i = 0; i <= (vm.listLevel.length - 1); i++) {
            //     for(var ii = 0; ii <= (vm.listLevel[i].details.length - 1); ii++) {
            //         if(typeof(vm.listLevel[i].details[ii]) !== undefined) {                        
            //             vm.listLevelDetails.push(vm.listLevel[i].details[ii]);                        
            //             //if(vm.listLevel[i].details[ii].level === level) {
            //             //     vm.listLevelDetails.push(vm.listLevel[i].details[ii]);
            //             //}
            //         }
            //     }
            // }

            var el = document.getElementsByClassName("lists-level-details");
            for (var i = 0; i <= (el.length - 1); ++i) {
                el[i].setAttribute('style','');
            }

            var el = document.getElementsByClassName("lists-level-details-"+ behivor + '' +level);
            for (var i = 0; i <= (el.length - 1); ++i) {
                el[i].setAttribute('style','background-color: #BCECDD;');
            }

        }

        function addData(ev,resultDate,id,resultDateAlias)
        {
            $mdDialog.show({
                controller: 'inputBehaviourperformancesetteamController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/behaviour-performance-team/set-behaviour/input-behaviour/input-behaviour.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    listInput:vm.listInput,
                    effectiveDate:vm.currentDate,
                    resultDate:resultDate,
                    resultDateAlias:resultDateAlias,
                    nik:vm.nik,
                    idTSTEResult:id

                },
                onRemoving:function(element, removePromise)
                {
                    loadData(vm.currentDate);
                    checkSelectedPeriod();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }
     
        function editData(ev,resultDate,id,resultA,resultB,resultC,resultD,resultDateAlias)
        {
            $mdDialog.show({
                controller   : 'editBehaviourperformancesetteamController',
                controllerAs : 'vm',
                templateUrl  : 'app/main/pms/behaviour-performance-team/set-behaviour/input-behaviour/input-behaviour.html',
                parent       : angular.element(document.body),
                targetEvent  : ev,
                clickOutsideToClose:true,
               locals:{
                    listInput:vm.listInput,
                    effectiveDate:vm.currentDate,
                    resultDate:resultDate,
                    resultDateAlias:resultDateAlias,
                    nik:vm.nik,
                    resultA:resultA,
                    resultB:resultB,
                    resultC:resultC,
                    resultD:resultD
                },
                onRemoving : function(element, removePromise)
                {
                    loadData(vm.currentDate);
                    checkSelectedPeriod();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function deleteData(ev,resultDate) {
            var promise =Auth.setToken();
            promise.then(function(){
           var confirm = $mdDialog.confirm()
              .title('Would you like to delete this data?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES,Delete')
              .cancel('No');

        $mdDialog.show(confirm).then(function() {
            angular.element.unblockUI();
           var response=Behivor.delete({action:'deletetste',resultDate:resultDate,nik:vm.nik});

           response.$promise.then(function(){
            $window.alert('Success delete TSTE');
            loadConfig();
           });

           response.$promise.catch(function(){
            $window.alert('failed delete TSTE');
           });
        });
          
        })
        }
     
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.behaviour_performance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_behaviour_performance', {
                url    : '/pms/behaviour-performance',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/behaviour-performance/behaviour-performance.html',
                        controller : 'BehaviourperformanceController as vm'
                    }
                }
            });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.pms.behaviour_performance')
    .controller('inputbehaviourperformanceController', inputbehaviourperformanceController);


  /* @ngInject */
  inputbehaviourperformanceController.$inject = ['$mdDialog', '$http', 'effectiveDate', 'listInput', 'config', 'Form', 'AppAPI', 'Auth', '$timeout'];
  function inputbehaviourperformanceController($mdDialog, $http, effectiveDate, listInput, config, Form, AppAPI, Auth, $timeout) {

    var vm = this;

    var Behivor = AppAPI.Behivor();
    vm.loadData = loadData;
    vm.saveData = saveData;
    vm.listBid = [];
    vm.cancel = cancel;
    vm.effectiveDate = effectiveDate;
    vm.showLevelDetail = showLevelDetail;
    vm.inputOn = 1;
    Form.initialForm();

    vm.languageList = [
      { value: 'ID', label: 'Indonesia' },
      { value: 'EN', label: 'English' }
    ];
    vm.isDisabled = true;
    vm.selected = 'ID';
    vm.language = 'ID';

    // set constructor form
    Form.setObject(Behivor);

    // set form to controller
    vm.Form = Form;

    loadData();

    function loadData() {
      angular.element.blockUI();
      var dataPromise = Behivor.query({ action: 'viewrefdata', effectiveDate: effectiveDate });
      dataPromise.$promise.then(fetchData);
      dataPromise.$promise.catch(errorFetch);
    }

    function fetchData(data) {
      vm.listInput = data[0].rs;
      vm.items = data[0].rsperiode;
      loadLevelData();
      //angular.element.unblockUI();            
    }

    function errorFetch() {
      vm.listInput = [];
      angular.element.unblockUI();
    }

    function loadLevelData() {
      var dataPromise = Behivor.query({ action: 'viewleveldata' });
      dataPromise.$promise.then(fetchLevelData);
      dataPromise.$promise.catch(errorLevelFetch);
    }

    function fetchLevelData(data) {
      vm.listInputLevel = data;
      angular.element.unblockUI();
    }

    function errorLevelFetch() {
      vm.listInputLevel = [];
      angular.element.unblockUI();
    }

    function showLevelDetail(behivor, level) {
      var el = document.getElementsByClassName("lists-level-details");
      for (var i = 0; i <= (el.length - 1); ++i) {
        el[i].setAttribute('style', '');
      }

      var el = document.getElementsByClassName("lists-level-details-" + behivor + '' + level);
      for (var i = 0; i <= (el.length - 1); ++i) {
        el[i].setAttribute('style', 'background-color: #BCECDD;');
      }
    }

    vm.setToken = Auth.setToken;

    function saveData(ev, formController) {
      vm.Form.objForm.effectiveDate = vm.effectiveDate;
      var promise = Form.saveData('saveinputsingle', formController, Behivor);
      promise.then(successSaveData);
      promise.catch(failedSaveData);
    }

    function successSaveData() {
      vm.messageTheme = 'green';
      $timeout(function () {
        $mdDialog.cancel();
      }, 800);
    }

    function failedSaveData() {
      vm.messageTheme = 'red';
    }

    function hide() {
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.pms.behaviour_performance_team.set-behaviour')
    .controller('editbehaviourperformanceController', editbehaviourperformanceController);


  /* @ngInject */
  editbehaviourperformanceController.$inject = ['$mdDialog', '$http', 'resultA', 'resultB', 'resultC', 'resultD', 'resultDateAlias', 'effectiveDate', 'resultDate', 'listInput', 'config', 'Form', 'AppAPI', 'Auth', '$timeout'];
  function editbehaviourperformanceController($mdDialog, $http, resultA, resultB, resultC, resultD, resultDateAlias, effectiveDate, resultDate, listInput, config, Form, AppAPI, Auth, $timeout) {

    var vm = this;

    var Behivor = AppAPI.Behivor();
    vm.loadData = loadData;
    vm.saveData = saveData;
    vm.listBid = [];
    vm.cancel = cancel;
    vm.effectiveDate = effectiveDate;
    vm.resultDate = resultDate;
    vm.Input = listInput;
    vm.resultDateAlias = resultDateAlias;
    vm.showLevelDetail = showLevelDetail;
    vm.inputOn = 0;
    vm.title = "Edit";
    Form.initialForm();

    vm.languageList = [
      { value: 'ID', label: 'Indonesia' },
      { value: 'EN', label: 'English' }
    ];
    vm.isDisabled = true;
    vm.selected = 'ID';
    vm.language = 'ID';
    // set constructor form
    Form.setObject(Behivor);

    // set form to controller
    vm.Form = Form;
    vm.Form.objForm.result = [];
    vm.Form.objForm.result[1] = parseInt(resultA);
    vm.Form.objForm.result[2] = parseInt(resultB);
    vm.Form.objForm.result[3] = parseInt(resultC);
    vm.Form.objForm.result[4] = parseInt(resultD);




    loadData();

    function loadData() {
      angular.element.blockUI();
      var dataPromise = Behivor.query({ action: 'viewrefdata', effectiveDate: effectiveDate });
      dataPromise.$promise.then(fetchData);
      dataPromise.$promise.catch(errorFetch);
    }

    function fetchData(data) {
      vm.listInput = data[0].rs;
      vm.items = data[0].rsperiode;

      loadLevelData();

      //angular.element.unblockUI();

    }

    function errorFetch() {
      vm.listInput = [];
      angular.element.unblockUI();
    }

    function loadLevelData() {
      var dataPromise = Behivor.query({ action: 'viewleveldata' });
      dataPromise.$promise.then(fetchLevelData);
      dataPromise.$promise.catch(errorLevelFetch);
    }

    function fetchLevelData(data) {
      console.log('data', data);
      vm.listInputLevel = data;
      angular.element.unblockUI();

    }

    function errorLevelFetch() {
      vm.listInputLevel = [];
      angular.element.unblockUI();
    }

    function showLevelDetail(behivor, level) {
      // vm.listLevelDetails = [];
      // for(var i = 0; i <= (vm.listLevel.length - 1); i++) {
      //     for(var ii = 0; ii <= (vm.listLevel[i].details.length - 1); ii++) {
      //         if(typeof(vm.listLevel[i].details[ii]) !== undefined) {                        
      //             vm.listLevelDetails.push(vm.listLevel[i].details[ii]);                        
      //             //if(vm.listLevel[i].details[ii].level === level) {
      //             //     vm.listLevelDetails.push(vm.listLevel[i].details[ii]);
      //             //}
      //         }
      //     }
      // }

      var el = document.getElementsByClassName("lists-level-details");
      for (var i = 0; i <= (el.length - 1); ++i) {
        el[i].setAttribute('style', '');
      }

      var el = document.getElementsByClassName("lists-level-details-" + behivor + '' + level);
      for (var i = 0; i <= (el.length - 1); ++i) {
        el[i].setAttribute('style', 'background-color: #BCECDD;');
      }

    }


    vm.setToken = Auth.setToken;




    function saveData(ev, formController) {
      vm.Form.objForm.resultDate = vm.resultDate;
      vm.Form.objForm.resultDateAlias = resultDateAlias;
      vm.Form.objForm.effectiveDate = vm.effectiveDate;

      var promise = Form.saveData('updateinputsingle', formController, Behivor);

      promise.then(successSaveData);
      promise.catch(failedSaveData);
    }

    function successSaveData() {
      vm.messageTheme = 'green';

      $timeout(function () {
        $mdDialog.cancel();
      }, 1000);
    }

    function failedSaveData() {
      vm.messageTheme = 'red';
    }


    ////////////////
    function hide() {
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    }


  }
})();
(function() {
    'use strict';

    angular
        .module('app.pkwt', [
            'app.pkwt.management_ir',
            'app.pkwt.management_ta',
            'angularUtils.directives.dirPagination'
        ])
        .config(config);

    /** @ngInject */
    function config() {}
})();

(function() {
    'use strict';

    angular.module('app.pkwt').controller('PkwtRulesFormController', Controller);

    Controller.$inject = [
        'config',
        '$mdDialog',
        'AppAPI',
        '$window',
        '$location',
        'Auth',
        'REF_DATA'
    ];
    /** @ngInject */
    function Controller(
        config,
        $mdDialog,
        AppAPI,
        $window,
        $location,
        Auth,
        REF_DATA
    ) {
        var vm = this;
        var endpoint = AppAPI.PkwtManagementTa();
        vm.hide = hide;
        vm.isLoading = false;
        vm.loadData = loadData;
        vm.list = [];
        vm.data = angular.copy(REF_DATA);
        vm.loaBindingList = [
            '-',
            'gaji_pokok',
            'tunjangan_jabatan',
            'uang_makan',
            'uang_transport',
            'sewa_motor',
            'bensin',
            'tunjangan_komunikasi',
            'tunjangan_fungsional',
            'tunjangan_kos',
            'tunjangan_kemahalan',
            'tunjangan_kost'
        ];

        vm.isEditMode = false;
        vm.save = save;
        vm.messsage = '';
        vm.isError = false;

        activate();

        function activate() {
            console.log(vm.data);
            loadData();
        }

        function loadData() {
            vm.isLoading = true;
            var request = endpoint.query({
                action: 'getListLoaRules',
                positionID: vm.data.positionID,
                grade: vm.data.grade
            });

            request.$promise.then(function(res) {
                vm.isLoading = false;
                vm.list = res;
            });

            request.$promise.catch(function(res) {
                vm.isLoading = false;
                vm.list = [];
            });
        }

        function hide() {
            $mdDialog.hide();
        }

        function save() {
            vm.isLoading = true;
            vm.isEditMode = !vm.isEditMode;
            Auth.setToken().then(function() {
                var request = endpoint.save({
                    action: 'updateLoaRules',
                    data: vm.list,
                });

                request.$promise.then(function(res) {
                    vm.isLoading = false;
                    vm.message = res.message;
                    vm.isError = false;
                });

                request.$promise.catch(function(err) {
                    vm.isLoading = false;
                    vm.message = err.data.message;
                    vm.isError = true;
                });
            });
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.pkwt")
        .controller("PkwtRulesCreateController", Controller);

    Controller.$inject = [
        "config",
        "$mdDialog",
        "AppAPI",
        "$window",
        "$location",
        "Auth"
    ];
    /** @ngInject */
    function Controller(config, $mdDialog, AppAPI, $window, $location, Auth) {
        var vm = this;
        var endpoint = AppAPI.PkwtManagementTa();
        vm.isLoading = false;
        vm.loaBindingList = [
            "-",
            "gaji_pokok",
            "tunjangan_jabatan",
            "uang_makan",
            "uang_transport",
            "sewa_motor",
            "bensin",
            "tunjangan_komunikasi",
            "tunjangan_fungsional",
            "tunjangan_kos",
            "tunjangan_kemahalan",
            "tunjangan_kost"
        ];
        vm.isEditMode = false;
        vm.positionID = null;
        vm.grade = null;
        vm.list = [];
        vm.flex = 70;
        vm.searchText = "";
        vm.listGrade = [];

        // method
        vm.loadLoaBuilder = loadLoaBuilder;
        vm.querySearch = querySearch;
        vm.getItemText = getItemText;
        vm.selectedItemChange = selectedItemChange;
        vm.hide = hide;
        vm.save = save;
        vm.onChangeMain = onChangeMain;

        activate();

        function activate() {
            getListGrade();
        }

        function loadLoaBuilder() {
            vm.isLoading = true;
            var request = endpoint.query({
                action: "getLoaBuilder",
                positionID: vm.positionID,
                grade: vm.grade
            });
            request.$promise.then(function(res) {
                vm.flex = 90;
                vm.isLoading = false;
                vm.list = res;
            });
            request.$promise.catch(function(res) {
                vm.flex = 90;
                vm.isLoading = false;
                vm.list = [];
            });
        }

        function getListGrade() {
            var request = endpoint.query({ action: "getListGrade" });
            request.$promise.then(function(res) {
                vm.listGrade = res;
            });
            request.$promise.catch(function(res) {
                vm.listGrade = [];
            });
        }

        function querySearch(search) {
            var request = endpoint.query({
                action: "getListJobTitle",
                search: search
            });
            return request.$promise.then(function(response) {
                return response;
            });
        }

        function getItemText(item) {
            return item.positionID + " - " + item.description;
        }

        function selectedItemChange(item) {
            if (item) {
                vm.positionID = item.positionID;
                onChangeMain();
            }
        }

        function onChangeMain() {
            vm.list = [];
            vm.flex = 60;
        }

        function hide() {
            $mdDialog.hide();
        }

        function save(ev) {
            vm.isLoading = true;
            console.log(ev);
            Auth.setToken().then(function() {
                var request = endpoint.save({
                    action: "createLoaRules",
                    data: vm.list,
                    positionID: vm.positionID,
                    grade: vm.grade
                });

                request.$promise.then(function(res) {
                    vm.isLoading = false;
                    responseDialog(ev, res.title, res.message);
                });

                request.$promise.catch(function(err) {
                    vm.isLoading = false;
                    vm.message = err.data.message;
                    vm.isError = true;
                });
            });
        }

        function responseDialog(ev, title, message) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(title)
                        .textContent(message)
                        .multiple(true)
                        .ariaLabel("Alert Dialog")
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function() {
                    hide();
                });
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.pkwt")
        .controller("UpdateFormPkwtTaController", Controller);

    Controller.$inject = [
        "$state",
        "$mdDialog",
        "AppAPI",
        "REF_DATA",
        "Auth",
        "$timeout",
        "$scope"
    ];
    /** @ngInject */
    function Controller(
        $state,
        $mdDialog,
        AppAPI,
        REF_DATA,
        Auth,
        $timeout,
        $scope
    ) {
        var vm = this;
        var endpoint = AppAPI.PkwtManagementTa();
        vm.areaCodeLetter = "XXXXXX";
        vm.monthLetter = "XX";
        vm.yearLetter = "XXXX";
        vm.searchText = "";
        vm.pkwtType = "PKWT";
        vm.data = angular.copy(REF_DATA);
        vm.tempRelease = new Date(vm.data.release_date);
        vm.tempStart = new Date(vm.data.start_contract);
        vm.tempEnd = new Date(vm.data.end_contract);
        vm.contractPeriod = vm.data.contract_duration;
        vm.letterOrder = vm.data.letter_order;
        vm.letterNumber = vm.data.letter_number;
        vm.selectedArea = {
            code_area: vm.data.code_area,
            area_name: vm.data.area_name,
            sub_area_id: vm.data.sub_area_id
        };

        vm.birthDate = new Date(vm.data.birth_date);
        vm.loa = {};
        vm.loaFillable = [
            "gaji_pokok",
            "tunjangan_jabatan",
            "uang_makan",
            "uang_transport",
            "sewa_motor",
            "bensin",
            "tunjangan_komunikasi",
            "tunjangan_fungsional",
            "tunjangan_kemahalan",
            "tunjangan_kos",
            "has_thr",
            "status_pernikahan",
            "gender"
        ];

        // METHOD
        vm.hide = hide;
        vm.querySearch = querySearch;
        vm.getItemText = getItemText;
        vm.selectedItemChange = selectedItemChange;
        vm.getHighlight = getHighlight;
        vm.renderPkwtNumber = renderPkwtNumber;
        vm.update = update;
        vm.onChangeContractPeriod = onChangeContractPeriod;
        vm.getLoa = getLoa;
        vm.isFillable = isFillable;
        vm.parseLabel = parseLabel;
        vm.isLoadingLoa = false;
        vm.inputType = inputType;

        vm.querySearchPositionId = querySearchPositionId;
        vm.getItemTextPositionId = getItemTextPositionId;
        vm.selectedItemChangePositionId = selectedItemChangePositionId;
        vm.getHighlightPositionId = getHighlightPositionId;

        ///////////// MAIN ////////////////

        activate();

        function activate() {
            console.log(vm.data);
            getLoa();
        }

        function querySearch(search) {
            var request = endpoint.query({
                action: "searchArea",
                search: search
            });
            return request.$promise.then(function(response) {
                return response;
            });
        }

        function getItemText(item) {
            return item.code_area + " - " + item.area_name;
        }

        function selectedItemChange(item) {
            if (item) {
                renderPkwtNumber();
            }
        }

        function getHighlight(item) {
            return getItemText(item);
        }

        ////

        function querySearchPositionId(search) {
            var request = endpoint.query({
                action: "getListJobTitle",
                search: search
            });
            return request.$promise.then(function(response) {
                return response;
            });
        }

        function getItemTextPositionId(item) {
            return item.positionID + " - " + item.description;
        }

        function selectedItemChangePositionId(item) {
            if (item) {
                vm.data.job_title = item.description;
                vm.loa.positionID = item.positionID;
            }
        }

        function getHighlightPositionId(item) {
            return getItemTextPositionId(item);
        }

        ////

        function renderPkwtNumber() {
            var releaseDate = getReleaseDate();
            var month = releaseDate.month;
            var year = releaseDate.year;
            var code = vm.selectedArea.code_area;
            vm.letterNumber =
                pad(vm.letterOrder, 3) +
                "/HC-PMA/" +
                "PK-" +
                code +
                "/" +
                month +
                "/" +
                year;
        }

        function getReleaseDate() {
            var response = {
                month: "XX",
                year: "XXXX"
            };
            if (vm.tempRelease) {
                var temp = angular.copy(vm.tempRelease);
                var month = moment(temp).format("MM");
                var year = moment(temp).format("YYYY");
                response.month = toRomanianMonth(month);
                response.year = year;
            }
            return response;
        }

        function onChangeContractPeriod() {
            var end = angular.copy(vm.tempEnd);
            if (vm.data.contract_duration) {
                var add = moment(end).add(vm.data.contract_duration, "months");
                vm.tempEnd = new Date(add);
            }
        }

        function update(ev, form) {
            var payload = {};
            var endContract = angular.copy(vm.tempEnd);
            var startContract = angular.copy(vm.tempStart);
            var releaseDate = angular.copy(vm.tempRelease);
            var birthDate = angular.copy(vm.birthDate);

            // set data to payloads
            Object.keys(vm.data).forEach(function(key) {
                if (key !== "pkwt_childs") {
                    payload[key] = vm.data[key];
                }
            });

            // set area to payloads
            Object.keys(vm.selectedArea).forEach(function(key) {
                if (key === "area_name") {
                    payload["sub_area_name"] = vm.selectedArea[key];
                } else {
                    payload[key] = vm.selectedArea[key];
                }
            });

            payload.birth_date = moment(birthDate).format("YYYY-MM-DD");
            payload.start_contract = moment(startContract).format("YYYY-MM-DD");
            payload.end_contract = moment(endContract).format("YYYY-MM-DD");
            payload.release_date = moment(releaseDate).format("YYYY-MM-DD");
            payload.loa = vm.loa;

            vm.isLoading = true;

            Auth.setToken().then(function() {
                var request = endpoint.save({
                    action: "update",
                    data: payload
                });
                request.$promise.then(function(res) {
                    form.$setUntouched();
                    form.$setPristine();
                    vm.success = true;
                    vm.message = res.message;
                    vm.isLoading = false;
                    vm.showMessage = true;
                    vm.saveProccess = false;
                });

                request.$promise.catch(function(res) {
                    form.$setUntouched();
                    form.$setPristine();
                    vm.success = false;
                    vm.message = res.message;
                    vm.isLoading = false;
                    vm.showMessage = true;
                    vm.saveProccess = false;
                });
            });
        }

        function getLoa() {
            vm.isLoadingLoa = true;
            var request = endpoint.get({
                action: "getLoa",
                pkwt_detail_id: vm.data.pkwt_detail_id
            });
            request.$promise.then(function(res) {
                vm.loa = res;
                vm.selectedPositionId = {
                    positionID: res.positionID,
                    description: vm.data.job_title
                };
                vm.isLoadingLoa = false;
            });
            request.$promise.catch(function(err) {
                vm.loa = {};
                vm.isLoadingLoa = false;
            });
        }

        // HELPERS

        function hide() {
            $mdDialog.hide();
        }

        function toRomanianMonth(month) {
            switch (month) {
                case "01":
                    return "I";
                case "02":
                    return "II";
                case "03":
                    return "III";
                case "04":
                    return "IV";
                case "05":
                    return "V";
                case "06":
                    return "VI";
                case "07":
                    return "VII";
                case "08":
                    return "VIII";
                case "09":
                    return "IX";
                case "10":
                    return "X";
                case "11":
                    return "XI";
                case "12":
                    return "XII";
            }
        }

        function parseLabel(key) {
            var tmp = angular.copy(key);
            if (tmp.includes("_")) {
                return tmp.split("_").join(" ");
            }
            return tmp;
        }

        function isFillable(key) {
            var found = false;
            for (var i = 0; i < vm.loaFillable.length; i++) {
                if (key == vm.loaFillable[i]) {
                    found = true;
                    break;
                }
            }
            return found;
        }

        function pad(num, max) {
            if (num) {
                if (num.length < max) {
                    if (num < 10) {
                        return "00".concat(num);
                    } else {
                        return "0".concat(num);
                    }
                }
            }
            return num;
        }

        function inputType(key) {
            var response = {
                type: "normal",
                opt: []
            };
            switch (key) {
                case "has_thr":
                    response.type = "select";
                    response.opt = [
                        { id: 1, desc: "Ya" },
                        { id: 0, desc: "Tidak" }
                    ];
                    break;
                case "status_pernikahan":
                    response.type = "select";
                    response.opt = [
                        { id: "L0", desc: "L0" },
                        { id: "K0", desc: "K0" },
                        { id: "K1", desc: "K1" },
                        { id: "K2", desc: "K2" },
                        { id: "K3", desc: "K3" }
                    ];
                    break;
                case "gender":
                    response.type = "select";
                    response.opt = [
                        { id: "L", desc: "Laki-laki" },
                        { id: "P", desc: "Perempuan" }
                    ];
                    break;
            }

            return response;
        }
    }
})();

(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.taxmalaysiacomponent', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_taxmalaysiacomponent', {
                url    : '/new-payroll/taxmalaysia',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/taxmalaysia/taxmalaysiaComponent.html',
                    controller : 'TaxmalaysiaComponentController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.taxmalaysiacomponent')
        .controller('ManageTaxMalaysiaController', ManageTaxMalaysiaController);

    ManageTaxMalaysiaController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', '$element', '$log', 'dataTaxMalaysia', '$http', 'config'];

    /* @ngInject */
    function ManageTaxMalaysiaController($q, $mdDialog, Form, AppAPI, $element, $log, dataTaxMalaysia, $http, config) {
        var vm = this;
        vm.saveData = saveData;
        var TaxMalaysia = AppAPI.TaxMalaysia();
        Form.initialForm();
        Form.setObject(TaxMalaysia);
        vm.Form = Form;
        vm.dataTaxMalaysia = dataTaxMalaysia;
        vm.label = 'Add';

        if (vm.dataTaxMalaysia) {
            vm.label = 'Edit';
            vm.Form.objForm.start_salary = parseFloat(vm.dataTaxMalaysia.start_salary);
            vm.Form.objForm.end_salary = parseFloat(vm.dataTaxMalaysia.end_salary);
            vm.Form.objForm.tax_status = vm.dataTaxMalaysia.tax_status;
            vm.Form.objForm.amount = parseFloat(vm.dataTaxMalaysia.amount);
            vm.Form.objForm.id = vm.dataTaxMalaysia.id;
        }

        console.log(vm.dataTaxMalaysia);

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            if (vm.dataTaxMalaysia) {
                updateData(ev, formController);
            } else {
                var promise = Form.saveData('save', formController, TaxMalaysia);
                promise.then(function (data) {
                    showDialog(ev, data);
                });
                promise.catch(function (data) {
                    ShowFailed(ev, data)
                });
            }

        }

        function updateData(ev, formController) {
            var promise = Form.saveData('update', formController, TaxMalaysia);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();

(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.staffreport-mgr', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_staff_report_mgr', {
                url    : '/new-payroll/report/staff-report-mgr',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/staff-report-mgr/staffreportmgr.html',
                    controller : 'StaffReportMgrController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.staffreport-mgr')
        .controller('StaffReportMgrController', StaffReportMgrController);

    StaffReportMgrController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function StaffReportMgrController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('1');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewStaffReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.staffreport', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_staff_report', {
                url    : '/new-payroll/report/staff-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/staff-report/staffreport.html',
                    controller : 'StaffReportController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.staffreport')
        .controller('StaffReportController', StaffReportController);

    StaffReportController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function StaffReportController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('0');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewStaffReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.staff-and-salary-report-mgr', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_staff_and_salary_report_mgr', {
                url    : '/new-payroll/report/staff-and-salary-report-management',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/staff-and-salary-report-mgr/staffandsalaryreportmgr.html',
                    controller : 'StaffAndSalaryReportMgrController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.staff-and-salary-report-mgr')
        .controller('StaffAndSalaryReportMgrController', StaffAndSalaryReportMgrController);

    StaffAndSalaryReportMgrController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function StaffAndSalaryReportMgrController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('1'); -mgr
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewStaffAndSalaryReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.staff-and-salary-report', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_staff_and_salary_report', {
                url    : '/new-payroll/report/staff-and-salary-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/staff-and-salary-report/staffandsalaryreport.html',
                    controller : 'StaffAndSalaryReportController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.staff-and-salary-report')
        .controller('StaffAndSalaryReportController', StaffAndSalaryReportController);

    StaffAndSalaryReportController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function StaffAndSalaryReportController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('0');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewStaffAndSalaryReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.socsoreport-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_socso_report_mgr', {
                url    : '/new-payroll/report/socso-report-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/socso-report-mgr/socsoreport.html',
                    controller : 'SocsoReportMgrController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.socsoreport-mgr')
        .controller('SocsoReportMgrController', SocsoReportMgrController);

    SocsoReportMgrController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window','$element'];

    /* @ngInject */
    function SocsoReportMgrController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window,$element) {
       
       var vm = this;
       var LaporanGaji=AppAPI.NewLaporanGaji();
       
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

       vm.changeCompany = changeCompany;
       vm.company = $localStorage.empsite;

       LoadPeriod();
       LoadCompany()
       LoadDivisi(vm.company);
       
       vm.country = $localStorage.country;
        
        vm.reqWil    = false;
        vm.reqArea   = true;
        vm.LoadRegional  = loadRegional;
        vm.LoadCabang    = loadCabang;
        vm.LoadWilayah   = loadWilayah;
    
        loadWilayah();
       
        vm.LoadArea = LoadArea
        LoadDefaultArea(vm.company);

        function LoadPeriod() {
            var response=LaporanGaji.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanGaji.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
             vm.listarea=[];
             var resp=LaporanGaji.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadDepartment(company,divisi) {
        var response=LaporanGaji.query({action:'getDepartment', idbu:company, iddivisi:divisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       
       function LoadDefaultArea(companyid) 
       {
               var response=LaporanGaji.query({action:'getArea', companyid:companyid});
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
               vm.listarea=data;
       }

       function errorFetchArea() {
               vm.listarea=[];
       } 

       function LoadDivisi(companyid) {
            var response=LaporanGaji.query({action:'getDivisi', idbu:companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid,vm.divisi);
            LoadArea(companyid);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 
       
       function ExportLaporanGajitoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var department = vm.department;
            var wilayah = vm.wilayah;
            var regional = vm.regional;
            var cabang = vm.cabang;
            var area = vm.area;
            var divisi = vm.divisi;
            var isMgr = true;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewSocso/lgexportexcel/' + period  + '/' + company  + '/' + divisi + '/' + department  + '/' + area + '/' + $localStorage.lang + '/' + wilayah + '/' + regional + '/' + cabang + '/' + isMgr + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
        
        //new filter
        function LoadArea(company,cabangid) 
        {
            loadWilayah();
            var response=LaporanGaji.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadWilayah() {
          var response=LaporanGaji.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=LaporanGaji.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=LaporanGaji.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.socsoreport', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_socso_report', {
                url    : '/new-payroll/report/socso-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/socso-report/socsoreport.html',
                    controller : 'SocsoReportController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
     'use strict';

     angular
          .module('app.payroll-new.report.socsoreport')
          .controller('SocsoReportController', SocsoReportController);

     SocsoReportController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

     /* @ngInject */
     function SocsoReportController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

          var vm = this;
          var LaporanGaji = AppAPI.NewLaporanGaji();

          vm.DataTable = new DataService();
          vm.LoadPeriod = LoadPeriod;
          vm.LoadDepartment = LoadDepartment;
          vm.LoadCompany = LoadCompany;
          vm.LoadArea = LoadArea;
          vm.LoadDivisi = LoadDivisi;
          vm.listJum = [2, 5, 25, 50, 75, 100, 200];
          vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

          vm.changeCompany = changeCompany;
          vm.company = $localStorage.empsite;

          LoadPeriod();
          LoadCompany()
          LoadDivisi(vm.company);

          vm.country = $localStorage.country;

          vm.reqWil = false;
          vm.reqArea = true;
          vm.LoadRegional = loadRegional;
          vm.LoadCabang = loadCabang;
          vm.LoadWilayah = loadWilayah;

          loadWilayah();

          vm.LoadArea = LoadArea
          LoadDefaultArea(vm.company);

          function LoadPeriod() {
               var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
               response.$promise.then(fetchPeriod);
               response.$promise.catch(errorFetchPeriod);
          }

          function fetchPeriod(data) {
               vm.listperiod = data;
          }

          function errorFetchPeriod() {
               vm.listperiod = [];
          }

          function LoadCompany() {
               var response = LaporanGaji.query({ action: 'getCompany' });
               response.$promise.then(fetchCompany);
               response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
               vm.listcompany = data;
          }

          function errorFetchCompany() {
               vm.listcompany = [];
          }

          function changeCompany(id) {
               vm.listarea = [];
               var resp = LaporanGaji.query({ action: 'getSpecificArea', companyid: id })
               resp.$promise.then(fetchspecificarea);
               resp.$promise.catch(errorfetchspecificarea);
          }

          function fetchspecificarea(data) {
               vm.listarea = data;
          }

          function errorfetchspecificarea() {
               vm.listarea = [];
          }

          function LoadDepartment(company, divisi) {
               var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
               response.$promise.then(fetchDepartment);
               response.$promise.catch(errorFetchDepartment);
          }

          function fetchDepartment(data) {
               vm.listdepartment = data;
          }

          function errorFetchDepartment() {
               vm.listdepartment = [];
          }

          function LoadDefaultArea(companyid) {
               var response = LaporanGaji.query({ action: 'getArea', companyid: companyid });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function LoadDivisi(companyid) {
               var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
               response.$promise.then(fetchDivisi);
               response.$promise.catch(errorFetchDivisi);
               LoadDepartment(companyid, vm.divisi);
               LoadArea(companyid);
          }

          function fetchDivisi(data) {
               vm.listdivisi = data;
          }

          function errorFetchDivisi() {
               vm.listdivisi = [];
          }

          function ExportLaporanGajitoExcel(form) {
               var token = Auth.setTokenPromise();
               var period = vm.period;
               var company = vm.company;
               var department = vm.department;
               var wilayah = vm.wilayah;
               var regional = vm.regional;
               var cabang = vm.cabang;
               var area = vm.area;
               var divisi = vm.divisi;
               var isMgr = false;

               token.then(function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewSocso/lgexportexcel/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + $localStorage.lang + '/' + wilayah + '/' + regional + '/' + cabang + '/' + isMgr + '/' + data.token, '_blank');
               }, function () {
                    $window.alert('gagal load token')
               });
          }

          vm.clearSearchTerm = function () {
               vm.searchTerm = '';
          };

          $element.find('input').on('keydown', function (ev) {
               ev.stopPropagation();
          });

          //new filter
          function LoadArea(company, cabangid) {
               loadWilayah();
               var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function loadWilayah() {
               var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
               response.$promise.then(fetchWilayah);
               response.$promise.catch(errorFetchWilayah);
          }

          function fetchWilayah(data) {
               vm.listWilayah = data;
          }

          function errorFetchWilayah() {
               vm.listWilayah = [];
          }

          function loadRegional(id) {
               vm.listarea = [];
               vm.reqWil = true;
               vm.reqArea = false;
               var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
               response.$promise.then(fetchRegional);
               response.$promise.catch(errorFetchRegional);
          }

          function fetchRegional(data) {
               vm.listRegional = data;
          }

          function errorFetchRegional() {
               vm.listRegional = [];
          }

          function loadCabang(id) {
               var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
               response.$promise.then(fetchCabang);
               response.$promise.catch(errorFetchCabang);
          }

          function fetchCabang(data) {
               vm.listCabang = data;
          }

          function errorFetchCabang() {
               vm.listCabang = [];
          }
     }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.sapreport', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_sapreport', {
                url    : '/new-payroll/report/sapreport',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/sapreport/sapreport.html',
                    controller : 'NewSAPReportController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.sapreport')
        .controller('NewSAPReportController', NewSAPReportController);

    NewSAPReportController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function NewSAPReportController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var SAPReport=AppAPI.NewSAPReport();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadDivisi = LoadDivisi;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportSAPReporttoExcel = ExportSAPReporttoExcel;
       vm.company = $localStorage.empsite

      LoadPeriod();
      LoadCompany();
      LoadDivisi(vm.company);

      function LoadPeriod() {
          var response=SAPReport.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=SAPReport.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function LoadDivisi(companyid) {
            var response=SAPReport.query({action:'getDivisi', idbu:companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 
       
       function ExportSAPReporttoExcel(form) {
            var token = Auth.setTokenPromise();
            
            var period = vm.period;
            var company = vm.company;
            var divisi = vm.divisi;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewSapreport/exportexcel/' + period  + '/' + company  + '/' + divisi  + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.perubahanupah', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_perubahanupah', {
                url    : '/new-payroll/report/perubahanupah',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/perubahanupah/perubahanupah.html',
                    controller : 'NewLaporanPerubahanUpahController as vm'
                    }
                }
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.perubahanupah')
        .controller('NewLaporanPerubahanUpahController', NewLaporanPerubahanUpahController);

    NewLaporanPerubahanUpahController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function NewLaporanPerubahanUpahController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var PerubahanUpah=AppAPI.NewPerubahanUpah();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanDetailBPJStoExcel = ExportLaporanDetailBPJStoExcel;
       vm.company = $localStorage.empsite;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=PerubahanUpah.query({action:'getPeriod',type:'perubahanupah'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=PerubahanUpah.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportLaporanDetailBPJStoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.period;
            var company = vm.company;
            // var department = vm.department;
            // var area = vm.area;

            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewLaporanbpjstk/puexportexcel/' + period  + '/' + company  + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.laporanbpjstk', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_detailbpjs', {
                url    : '/new-payroll/report/laporanbpjstk',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/laporanbpjstk/laporanbpjstk.html',
                    controller : 'NewLaporanBpjsTkController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.laporanbpjstk')
        .controller('NewLaporanPerubahanGajiController', NewLaporanPerubahanGajiController);

    NewLaporanPerubahanGajiController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function NewLaporanPerubahanGajiController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var PerubahanGaji=AppAPI.NewPerubahanGaji();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportPerubahanGajitoExcel = ExportPerubahanGajitoExcel;
       vm.company = $localStorage.empsite;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=PerubahanGaji.query({action:'getPeriod',type:'pergaji'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=PerubahanGaji.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportPerubahanGajitoExcel(form) {
            var token = Auth.setTokenPromise();
            
            var period = vm.period;
            var company = vm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewLaporanbpjskes/pgexportexcel/' + period  + '/' + company  + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.pendaftaranbpjs', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_daftarbpjs', {
                url    : '/new-payroll/report/pendaftaranbpjs',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/pendaftaranbpjs/pendaftaranbpjs.html',
                    controller : 'NewPendaftaranBpjsController as vm'
                    }
                }
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.pendaftaranbpjs')
        .controller('NewPendaftaranBpjsController', NewPendaftaranBpjsController);

    NewPendaftaranBpjsController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function NewPendaftaranBpjsController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       var vm = this;
       var PendaftaranBpjs=AppAPI.NewPendaftaranBpjs();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportPendaftaranBpjstoExcel = ExportPendaftaranBpjstoExcel;
       vm.company = $localStorage.empsite;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=PendaftaranBpjs.query({action:'getPeriod',type:'regbpjs'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=PendaftaranBpjs.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportPendaftaranBpjstoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.period;
            var company = vm.company;
            // var department = vm.department;
            var area = vm.area;

            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewLaporanbpjstk/regbpjsexportexcel/' + period  + '/' + company + '/' + $localStorage.lang + '/' + data.token, '_blank');
                
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.pcbreport-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_pcb_report_mgr', {
                url    : '/new-payroll/report/pcb-report-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/pcb-report-mgr/pcbreport.html',
                    controller : 'PcbReportMgrController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.pcbreport-mgr')
        .controller('PcbReportMgrController', PcbReportMgrController);

    PcbReportMgrController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window','$element'];

    /* @ngInject */
    function PcbReportMgrController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window,$element) {
       
       var vm = this;
       var LaporanGaji=AppAPI.NewLaporanGaji();
       
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

       vm.changeCompany = changeCompany;
       vm.company = $localStorage.empsite;

       LoadPeriod();
       LoadCompany()
       LoadDivisi(vm.company);
       
       vm.country = $localStorage.country;
        
        vm.reqWil    = false;
        vm.reqArea   = true;
        vm.LoadRegional  = loadRegional;
        vm.LoadCabang    = loadCabang;
        vm.LoadWilayah   = loadWilayah;
    
        loadWilayah();
       
        vm.LoadArea = LoadArea
        LoadDefaultArea(vm.company);

        function LoadPeriod() {
            var response=LaporanGaji.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanGaji.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
             vm.listarea=[];
             var resp=LaporanGaji.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadDepartment(company,divisi) {
        var response=LaporanGaji.query({action:'getDepartment', idbu:company, iddivisi:divisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       
       function LoadDefaultArea(companyid) 
       {
               var response=LaporanGaji.query({action:'getArea', companyid:companyid});
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
               vm.listarea=data;
       }

       function errorFetchArea() {
               vm.listarea=[];
       } 

       function LoadDivisi(companyid) {
            var response=LaporanGaji.query({action:'getDivisi', idbu:companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid,vm.divisi);
            LoadArea(companyid);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 
       
       function ExportLaporanGajitoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var department = vm.department;
            var wilayah = vm.wilayah;
            var regional = vm.regional;
            var cabang = vm.cabang;
            var area = vm.area;
            var divisi = vm.divisi;
            var isMgr = true;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewPcb/lgexportexcel/' + period  + '/' + company  + '/' + divisi + '/' + department  + '/' + area + '/' + $localStorage.lang + '/' + wilayah + '/' + regional + '/' + cabang + '/' + isMgr + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
        
        //new filter
        function LoadArea(company,cabangid) 
        {
            loadWilayah();
            var response=LaporanGaji.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadWilayah() {
          var response=LaporanGaji.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=LaporanGaji.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=LaporanGaji.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.pcbreport', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_pcb_report', {
                url    : '/new-payroll/report/pcb-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/pcb-report/pcbreport.html',
                    controller : 'PcbReportController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
     'use strict';

     angular
          .module('app.payroll-new.report.pcbreport')
          .controller('PcbReportController', PcbReportController);

     PcbReportController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

     /* @ngInject */
     function PcbReportController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

          var vm = this;
          var LaporanGaji = AppAPI.NewLaporanGaji();

          vm.DataTable = new DataService();
          vm.LoadPeriod = LoadPeriod;
          vm.LoadDepartment = LoadDepartment;
          vm.LoadCompany = LoadCompany;
          vm.LoadArea = LoadArea;
          vm.LoadDivisi = LoadDivisi;
          vm.listJum = [2, 5, 25, 50, 75, 100, 200];
          vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

          vm.changeCompany = changeCompany;
          vm.company = $localStorage.empsite;

          LoadPeriod();
          LoadCompany()
          LoadDivisi(vm.company);

          vm.country = $localStorage.country;

          vm.reqWil = false;
          vm.reqArea = true;
          vm.LoadRegional = loadRegional;
          vm.LoadCabang = loadCabang;
          vm.LoadWilayah = loadWilayah;

          loadWilayah();

          vm.LoadArea = LoadArea
          LoadDefaultArea(vm.company);

          function LoadPeriod() {
               var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
               response.$promise.then(fetchPeriod);
               response.$promise.catch(errorFetchPeriod);
          }

          function fetchPeriod(data) {
               vm.listperiod = data;
          }

          function errorFetchPeriod() {
               vm.listperiod = [];
          }

          function LoadCompany() {
               var response = LaporanGaji.query({ action: 'getCompany' });
               response.$promise.then(fetchCompany);
               response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
               vm.listcompany = data;
          }

          function errorFetchCompany() {
               vm.listcompany = [];
          }

          function changeCompany(id) {
               vm.listarea = [];
               var resp = LaporanGaji.query({ action: 'getSpecificArea', companyid: id })
               resp.$promise.then(fetchspecificarea);
               resp.$promise.catch(errorfetchspecificarea);
          }

          function fetchspecificarea(data) {
               vm.listarea = data;
          }

          function errorfetchspecificarea() {
               vm.listarea = [];
          }

          function LoadDepartment(company, divisi) {
               var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
               response.$promise.then(fetchDepartment);
               response.$promise.catch(errorFetchDepartment);
          }

          function fetchDepartment(data) {
               vm.listdepartment = data;
          }

          function errorFetchDepartment() {
               vm.listdepartment = [];
          }

          function LoadDefaultArea(companyid) {
               var response = LaporanGaji.query({ action: 'getArea', companyid: companyid });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function LoadDivisi(companyid) {
               var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
               response.$promise.then(fetchDivisi);
               response.$promise.catch(errorFetchDivisi);
               LoadDepartment(companyid, vm.divisi);
               LoadArea(companyid);
          }

          function fetchDivisi(data) {
               vm.listdivisi = data;
          }

          function errorFetchDivisi() {
               vm.listdivisi = [];
          }

          function ExportLaporanGajitoExcel(form) {
               var token = Auth.setTokenPromise();
               var period = vm.period;
               var company = vm.company;
               var department = vm.department;
               var wilayah = vm.wilayah;
               var regional = vm.regional;
               var cabang = vm.cabang;
               var area = vm.area;
               var divisi = vm.divisi;
               var isMgr = false;

               token.then(function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewPcb/lgexportexcel/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + $localStorage.lang + '/' + wilayah + '/' + regional + '/' + cabang + '/' + isMgr + '/' + data.token, '_blank');
               }, function () {
                    $window.alert('gagal load token')
               });
          }

          vm.clearSearchTerm = function () {
               vm.searchTerm = '';
          };

          $element.find('input').on('keydown', function (ev) {
               ev.stopPropagation();
          });

          //new filter
          function LoadArea(company, cabangid) {
               loadWilayah();
               var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function loadWilayah() {
               var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
               response.$promise.then(fetchWilayah);
               response.$promise.catch(errorFetchWilayah);
          }

          function fetchWilayah(data) {
               vm.listWilayah = data;
          }

          function errorFetchWilayah() {
               vm.listWilayah = [];
          }

          function loadRegional(id) {
               vm.listarea = [];
               vm.reqWil = true;
               vm.reqArea = false;
               var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
               response.$promise.then(fetchRegional);
               response.$promise.catch(errorFetchRegional);
          }

          function fetchRegional(data) {
               vm.listRegional = data;
          }

          function errorFetchRegional() {
               vm.listRegional = [];
          }

          function loadCabang(id) {
               var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
               response.$promise.then(fetchCabang);
               response.$promise.catch(errorFetchCabang);
          }

          function fetchCabang(data) {
               vm.listCabang = data;
          }

          function errorFetchCabang() {
               vm.listCabang = [];
          }
     }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.payslip', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_payslip', {
                url    : '/new-payroll/report/payslip',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/payslip/payslip.html',
                    controller : 'NewPayslipController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
     'use strict';

     angular
          .module('app.payroll-new.report.payslip')
          .controller('NewPayslipController', NewPayslipController);

     NewPayslipController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$http', 'Form', '$element'];

     /* @ngInject */
     function NewPayslipController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $http, Form, $element) {

          var vm = this;

          Form.initialForm();

          var Payslip = AppAPI.NewPayslip();
          var PayrollProcess = AppAPI.NewPayrollProcess();
          var LaporanGaji = AppAPI.NewLaporanGaji();

          Form.setObject(Payslip);

          vm.Form = Form;

          vm.DataTable = new DataService();
          vm.LoadPeriod = LoadPeriod;
          vm.LoadDepartment = LoadDepartment;
          vm.LoadCompany = LoadCompany;
          vm.LoadArea = LoadArea;
          vm.listJum = [2, 5, 25, 50, 75, 100, 200];
          vm.ExportPaysliptoPdf = ExportPaysliptoPdf;
          vm.country = $localStorage.country;

          vm.getEmployee = getEmployee;
          vm.stateEdit = false;
          vm.selectedItemChanged = selectedItemChanged;
          vm.Form.objForm.empno = '';
          vm.Form.objForm.company = $localStorage.empsite
          vm.LoadArea = LoadArea
          LoadPeriod();
          LoadDepartment();
          LoadCompany();
          LoadArea(vm.Form.objForm.company);
          LoadCountry();

          function LoadCountry() {
               var response = PayrollProcess.query({
                    action: 'getCountry'
               });
               response.$promise.then(fetchCountry);
               response.$promise.catch(errorFetchCountry);
          }

          function fetchCountry(data) {
               vm.listcountry = data;
          }

          function errorFetchCountry() {
               vm.listcountry = [];
          }

          function selectedItemChanged(employee) {
               vm.Form.objForm.empno = '';
               vm.Form.objForm.fullname = '';
               vm.isDisabled = false;
               vm.Form.objForm.fullname = vm.searchString;
               if (typeof employee !== 'undefined') {
                    vm.Form.objForm.empno = employee.empno;
                    vm.Form.objForm.fullname = employee.fullname;
                    vm.isDisabled = true;

               }
          }

          function getEmployee(searchText) {

               return $http
                    .get(config.api + 'api/payrollnew/report/NewPayslip?action=searchEmployee&id=' + searchText + '&company=' + vm.Form.objForm.company)
                    .then(function (item) {
                         // Map the response object to the data object.
                         if (item.data.length === '') {
                              Form.objForm.empno = '';
                         }
                         return item.data;
                    });
          }

          function LoadPeriod() {
               var response = Payslip.query({ action: 'getPeriod' });
               response.$promise.then(fetchPeriod);
               response.$promise.catch(errorFetchPeriod);
          }

          function fetchPeriod(data) {
               vm.listperiod = data;
          }

          function errorFetchPeriod() {
               vm.listperiod = [];
          }

          function LoadCompany() {
               var response = Payslip.query({ action: 'getCompany' });
               response.$promise.then(fetchCompany);
               response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
               vm.listcompany = data;
          }

          function errorFetchCompany() {
               vm.listcompany = [];
          }

          function LoadDepartment() {
               var response = Payslip.query({ action: 'getDepartment' });
               response.$promise.then(fetchDepartment);
               response.$promise.catch(errorFetchDepartment);
          }

          function fetchDepartment(data) {
               vm.listdepartment = data;
          }

          function errorFetchDepartment() {
               vm.listdepartment = [];
          }


          function LoadArea(companyid) {
               var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function ExportPaysliptoPdf(ev, formController) {
               var token = Auth.setTokenPromise();
               var empno = "undefined";
               var period = vm.Form.objForm.period;
               var company = vm.Form.objForm.company;
               var department = vm.Form.objForm.department;
               var area = vm.Form.objForm.area;
               var password = encodeURIComponent(window.btoa(vm.Form.objForm.password));
               if (vm.Form.objForm.empno != '')
                    empno = vm.Form.objForm.empno;//vm.empno;

               token.then(function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewPayslip/exportpdf/' + period + '/' + company + '/' + department + '/' + area + '/' + empno + '/' + password + '/' + $localStorage.lang + '/' + vm.country + '/' + data.token, '_blank');
               }, function () {
                    $window.alert('gagal load token')
               });
          }

          vm.clearSearchTerm = function () {
               vm.searchTerm = '';
          };

          $element.find('input').on('keydown', function (ev) {
               ev.stopPropagation();
          });
     }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.costcentresummaryreport-mgr', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_payroll_costcentre_report_mgr', {
                url    : '/new-payroll/report/payroll-costcentre-report-management',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/payroll-costcentre-report-mgr/payrollcostcentrereportmgr.html',
                    controller : 'PayrollCostcentreReportMgrController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.costcentresummaryreport-mgr')
        .controller('PayrollCostcentreReportMgrController', PayrollCostcentreReportMgrController);

    PayrollCostcentreReportMgrController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function PayrollCostcentreReportMgrController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }


        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('1');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewPayrollCostCentreReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.costcentresummaryreport', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_payroll_costcentre_report', {
                url    : '/new-payroll/report/payroll-costcentre-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/payroll-costcentre-report/payrollcostcentrereport.html',
                    controller : 'PayrollCostcentreReportController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.costcentresummaryreport')
        .controller('PayrollCostcentreReportController', PayrollCostcentreReportController);

    PayrollCostcentreReportController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function PayrollCostcentreReportController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }


        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('0');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewPayrollCostCentreReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.overtimereport-mgr', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_overtime_report_mgr', {
                url    : '/new-payroll/report/overtime-report-management',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/overtime-report-mgr/overtimereportmgr.html',
                    controller : 'OvertimeReportMgrController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.overtimereport-mgr')
        .controller('OvertimeReportMgrController', OvertimeReportMgrController);

    OvertimeReportMgrController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function OvertimeReportMgrController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }


        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('1');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewOvertimeReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.overtimereport', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_overtime_report', {
                url    : '/new-payroll/report/overtime-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/overtime-report/overtimereport.html',
                    controller : 'OvertimeReportController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.overtimereport')
        .controller('OvertimeReportController', OvertimeReportController);

    OvertimeReportController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function OvertimeReportController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }


        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('0');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewOvertimeReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.nonaktif', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_nonaktif', {
                url    : '/new-payroll/report/nonaktif',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/nonaktif/nonaktif.html',
                    controller : 'NewLaporanNonAktifontroller as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.nonaktif')
        .controller('NewLaporanNonAktifontroller', NewLaporanNonAktifontroller);

    NewLaporanNonAktifontroller.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function NewLaporanNonAktifontroller($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var NonAktif=AppAPI.NewNonAktif();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportNonAktiftoExcel = ExportNonAktiftoExcel;
       vm.company = $localStorage.empsite;

        LoadPeriod();
        LoadCompany();

      function LoadPeriod() {
          var response=NonAktif.query({action:'getPeriod',type:'nonaktif'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=NonAktif.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportNonAktiftoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.period;
            var company = vm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewLaporanbpjskes/naexportexcel/' + period  + '/' + company  + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.laporanthr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_laporanthr', {
                url    : '/new-payroll/report/laporanthr',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/laporanthr/laporanthr.html',
                    controller : 'NewLaporanTHRController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.laporanthr')
        .controller('NewLaporanTHRController', NewLaporanTHRController);

    NewLaporanTHRController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window','$element'];

    /* @ngInject */
    function NewLaporanTHRController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window,$element) {
       
       var vm = this;
       var LaporanThr=AppAPI.NewLaporanThr();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanThrtoExcel = ExportLaporanThrtoExcel;

       vm.changeCompany = changeCompany;
       vm.company = $localStorage.empsite;

       LoadPeriod();
       LoadCompany()
       LoadArea(vm.company);

      function LoadPeriod() {
          var response=LaporanThr.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanThr.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
             vm.listarea=[];
             var resp=LaporanThr.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadArea(company) 
       {
          var response=LaporanThr.query({action:'getArea', companyid:company});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) 
       {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
 
       
       function ExportLaporanThrtoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var area = vm.area;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewLaporanthr/lgexportexcel/' + period  + '/' + company  + '/' + area  + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.laporanpajaka1', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_laporanpajak1721a1', {
                url    : '/new-payroll/report/laporanpajaka1',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/laporanpajaka1/laporanpajaka1.html',
                    controller : 'NewLaporanPajakA1Controller as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.laporanpajaka1')
        .controller('NewLaporanPajakA1Controller', NewLaporanPajakA1Controller);

    NewLaporanPajakA1Controller.$inject = ['$localStorage','AppAPI','$mdDialog', 'Form', 'Auth', '$location', '$window', 'config', '$http'];

    /* @ngInject */
    function NewLaporanPajakA1Controller($localStorage,AppAPI,$mdDialog, Form, Auth, $location, $window, config, $http) {
       
       var vm = this;
       Form.initialForm();

       var LaporanPajakA1=AppAPI.NewLaporanPajakA1();

       Form.setObject(LaporanPajakA1);

       vm.Form = Form; 

       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.LoadKPP = LoadKPP;

       vm.changeCompany = changeCompany;
       vm.ExportLaporantoExcel = ExportLaporantoExcel;
       
       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;     
       vm.empno = '';
       vm.company = $localStorage.empsite;
       
       LoadPeriod();
       //LoadDepartment();
       LoadCompany();
       //LoadArea();
       //LoadDivisi();
       LoadKPP();

       function selectedItemChanged(employee)
      {
               
              vm.empno='';
               vm.fullname='';
               vm.isDisabled=false;
               vm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.empno=employee.empno;
                vm.fullname=employee.fullname;
                vm.isDisabled=true;

              }
              
           console.log(vm.empno);
      }

      function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/report/laporanpajak?action=searchEmployee&id=' + searchText)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
      }

       function LoadPeriod() {
          var response=LaporanPajakA1.query({action:'getPeriod',a1:true});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanPajakA1.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function LoadDepartment() {
          var response=LaporanPajakA1.query({action:'getDepartment'});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       

       function LoadArea() {
          var response=LaporanPajakA1.query({action:'getArea'});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }   

        function changeCompany(id)
       { 
            console.log(id);
             vm.listarea=[];
             var resp=LaporanPajakA1.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadDivisi() {
            var response=LaporanPajakA1.query({action:'getDivisi'});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 

       function LoadKPP() {
          var response=LaporanPajakA1.query({action:'getKPP'});
          response.$promise.then(fetchKPP);
          response.$promise.catch(errorFetchKPP);
       }

       function fetchKPP(data) {
            vm.listkpp=data;
       }

       function errorFetchKPP() {
            vm.listkpp=[];
       }   

       function ExportLaporantoExcel(form) {
            var token = Auth.setTokenPromise();
            //var empno = "undefined";
            // console.log(typeof vm.bu);
            var period = vm.period;
            var company = vm.company;
            var kpp = vm.kpp;
            /*var divisi = vm.divisi;
            var department = vm.department;
            var area = vm.area;
            if(vm.empno != '')
               empno = vm.empno;//vm.empno;
            */
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewLaporanpajak/lpa1exportexcel/' +  period  + '/' + company  + '/' + kpp  + '/' + $localStorage.lang + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });;
      }
            

       
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.laporanpajak', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_laporanpajak1721', {
                url    : '/new-payroll/report/laporanpajak',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/laporanpajak/laporanpajak.html',
                    controller : 'NewLaporanPajakController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.laporanpajak')
        .controller('NewLaporanPajakController', NewLaporanPajakController);

    NewLaporanPajakController.$inject = ['$localStorage','AppAPI','$mdDialog', 'Form', 'Auth', '$location', '$window', 'config', '$http'];

    /* @ngInject */
    function NewLaporanPajakController($localStorage,AppAPI,$mdDialog, Form, Auth, $location, $window, config, $http) {
       
       var vm = this;
       Form.initialForm();

       var LaporanPajak=AppAPI.NewLaporanPajak();

       Form.setObject(LaporanPajak);

       vm.Form = Form; 

       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.LoadKPP = LoadKPP;

       vm.changeCompany = changeCompany;
       vm.ExportLaporantoExcel = ExportLaporantoExcel;
      
       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;     
       vm.empno = '';
       vm.company = $localStorage.empsite;

       LoadPeriod();
       //LoadDepartment();
       LoadCompany();
       //LoadArea();
       //LoadDivisi();
       LoadKPP();

       function selectedItemChanged(employee)
      {
               
              vm.empno='';
               vm.fullname='';
               vm.isDisabled=false;
               vm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.empno=employee.empno;
                vm.fullname=employee.fullname;
                vm.isDisabled=true;

              }
      }

      function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/report/laporanpajak?action=searchEmployee&id=' + searchText)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
      }

       function LoadPeriod() {
          var response=LaporanPajak.query({action:'getPeriod',a1:false});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanPajak.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function LoadDepartment() {
          var response=LaporanPajak.query({action:'getDepartment'});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       

       function LoadArea() {
          var response=LaporanPajak.query({action:'getArea'});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }   
       
       function changeCompany(id)
       { 
             vm.listarea=[];
             var resp=LaporanPajak.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadKPP() {
          var response=LaporanPajak.query({action:'getKPP'});
          response.$promise.then(fetchKPP);
          response.$promise.catch(errorFetchKPP);
       }

       function fetchKPP(data) {
            vm.listtaxloc=data;
       }

       function errorFetchKPP() {
            vm.listtaxloc=[];
       }   
       

       function LoadDivisi() {
            var response=LaporanPajak.query({action:'getDivisi'});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 

       function ExportLaporantoExcel(form) {
            var token = Auth.setTokenPromise();
            //var empno = "undefined";
            var period = vm.period;
            var company = vm.company;
            var kpp = vm.kpp;
            /*var divisi = vm.divisi;
            var department = vm.department;
            var area = vm.area;
            if(vm.empno != '')
               empno = vm.empno;//vm.empno;
            */
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewLaporanpajak/lpexportexcel/' +  period  + '/' + company  + '/' + kpp  + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
      }
            

       
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.laporanlembur', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_laporanlembur', {
                url    : '/new-payroll/report/laporanlembur',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/laporanlembur/laporanlembur.html',
                    controller : 'NewLaporanLemburController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.laporanlembur')
        .controller('NewLaporanLemburController', NewLaporanLemburController);

    NewLaporanLemburController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function NewLaporanLemburController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var LaporanLembur=AppAPI.NewLaporanLembur();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.ExportLaporantoExcel = ExportLaporantoExcel;
       vm.company = $localStorage.empsite;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=LaporanLembur.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

      function LoadCompany() {
          var response=LaporanLembur.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

      function ExportLaporantoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.period;
            var company = vm.company;
            /*var department = vm.department;
            var area = vm.area;*/

            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewLaporanlembur/exportexcel/' + period  + '/' + company + '/' + $localStorage.lang + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }

       
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.laporangajidetail', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_laporangajidetail', {
                url    : '/new-payroll/report/laporangajidetail',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/laporangajidetail/laporangajidetail.html',
                    controller : 'NewLaporanGajiDetailController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.laporangajidetail')
        .controller('NewLaporanGajiDetailController', NewLaporanGajiDetailController);

    NewLaporanGajiDetailController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function NewLaporanGajiDetailController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window, $element) {
       
       var vm = this;
       var LaporanGaji=AppAPI.NewLaporanGajiDetail();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

       vm.changeCompany = changeCompany;
       vm.company = $localStorage.empsite;

       LoadPeriod();
       LoadCompany()
       LoadArea(vm.company);

      function LoadPeriod() 
      {
          var response=LaporanGaji.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanGaji.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
             vm.listarea=[];
             var resp=LaporanGaji.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadArea(company) {
          var response=LaporanGaji.query({action:'getArea', companyid:company});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function ExportLaporanGajitoExcel(form) 
       {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var area = vm.area;
            
            token.then(function(data) 
            {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewLaporangajidetail/lgexportexcel/' + period  + '/' + company  + '/' + area + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.laporangaji', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_laporangaji', {
                url    : '/new-payroll/report/laporangaji',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/laporangaji/laporangaji.html',
                    controller : 'NewLaporanGajiController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.laporangaji')
        .controller('NewLaporanGajiController', NewLaporanGajiController);

    NewLaporanGajiController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window','$element'];

    /* @ngInject */
    function NewLaporanGajiController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window,$element) {
       
       var vm = this;
       var LaporanGaji=AppAPI.NewLaporanGaji();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

       vm.changeCompany = changeCompany;
       vm.company = $localStorage.empsite;

       LoadPeriod();
       LoadCompany()
       LoadDivisi(vm.company);
       
       vm.country = $localStorage.country;
        if(vm.country=='MYS'){
            vm.reqWil    = false;
            vm.reqArea   = true;
            vm.LoadRegional  = loadRegional;
            vm.LoadCabang    = loadCabang;
            vm.LoadWilayah   = loadWilayah;
     
            loadWilayah();
        }
        vm.LoadArea = LoadArea
        LoadDefaultArea(vm.company);

      function LoadPeriod() {
          var response=LaporanGaji.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanGaji.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
             vm.listarea=[];
             var resp=LaporanGaji.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadDepartment(company,divisi) {
        var response=LaporanGaji.query({action:'getDepartment', idbu:company, iddivisi:divisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       
       function LoadDefaultArea(companyid) 
       {
               var response=LaporanGaji.query({action:'getArea', companyid:companyid});
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
               vm.listarea=data;
       }

       function errorFetchArea() {
               vm.listarea=[];
       } 

       function LoadDivisi(companyid) {
            var response=LaporanGaji.query({action:'getDivisi', idbu:companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid,vm.divisi);
            LoadArea(companyid);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 
       
       function ExportLaporanGajitoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var department = vm.department;
            var wilayah = vm.wilayah;
            var regional = vm.regional;
            var cabang = vm.cabang;
            var area = vm.area;
            var divisi = vm.divisi;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewLaporangaji/lgexportexcel/' + period  + '/' + company  + '/' + divisi + '/' + department  + '/' + area + '/' + $localStorage.lang + '/' + wilayah + '/' + regional + '/' + cabang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
        
        //new filter
        function LoadArea(company,cabangid) 
        {
            loadWilayah();
            var response=LaporanGaji.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadWilayah() {
          var response=LaporanGaji.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=LaporanGaji.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=LaporanGaji.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.laporanbpjstk')
        .controller('NewLaporanBpjsTkController', NewLaporanBpjsTkController);

    NewLaporanBpjsTkController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function NewLaporanBpjsTkController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var LaporanBpjsTk=AppAPI.NewLaporanbpjstk();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanDetailBPJStoExcel = ExportLaporanDetailBPJStoExcel;
       vm.company = $localStorage.empsite;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=LaporanBpjsTk.query({action:'getPeriod',type:'laporan'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanBpjsTk.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportLaporanDetailBPJStoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.period;
            var company = vm.company;
            // var department = vm.department;
            // var area = vm.area;

            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewLaporanbpjstk/exportexcel/' + period  + '/' + company  + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.laporanbpjstk')
        .controller('NewLaporanKeluarBpjsController', NewLaporanKeluarBpjsController);

    NewLaporanKeluarBpjsController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function NewLaporanKeluarBpjsController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var KeluarBpjs=AppAPI.NewKeluarBpjs();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportKeluarBPJStoExcel = ExportKeluarBPJStoExcel;
       vm.company = $localStorage.empsite;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=KeluarBpjs.query({action:'getPeriod',type:'keluarbpjs'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=KeluarBpjs.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportKeluarBPJStoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.period;
            var company = vm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewLaporanbpjstk/bkexportexcel/' + period  + '/' + company  + '/' + $localStorage.lang + '/' + data.token, '_blank');
                
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.individualsummaryreport-mgr', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_payroll_individual_report_mgr', {
                url    : '/new-payroll/report/individual-summary-report-management',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/individual-summary-report-mgr/individualsummaryreportmgr.html',
                    controller : 'IndividualSummaryReportMgrController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.individualsummaryreport-mgr')
        .controller('IndividualSummaryReportMgrController', IndividualSummaryReportMgrController);

    IndividualSummaryReportMgrController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function IndividualSummaryReportMgrController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('1');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewIndividualSummaryReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.individualsummaryreport', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_payroll_individual_report', {
                url    : '/new-payroll/report/individual-summary-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/individual-summary-report/individualsummaryreport.html',
                    controller : 'IndividualSummaryReportController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.individualsummaryreport')
        .controller('IndividualSummaryReportController', IndividualSummaryReportController);

    IndividualSummaryReportController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function IndividualSummaryReportController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('0');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewIndividualSummaryReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.gajicostcentre', []).config(config);

   config.$inject=['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
    .state('app.payroll_new_gajicostcentre', {
      url    : '/new-payroll/report/gajicostcentre',
      views  : {
        'content@app' : {
          templateUrl: 'app/main/payroll-new/report/gajicostcentre/gajicostcentre.html',
          controller : 'NewGajiCostCentreController as vm'
        }
      }
    });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.gajicostcentre')
        .controller('NewGajiCostCentreController', NewGajiCostCentreController);

    NewGajiCostCentreController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','$document', '$location', '$window'];

    /* @ngInject */
    function NewGajiCostCentreController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,$document,$location,$window) {
       
       var vm = this;
       var dt = new Date();
       var year = dt.getFullYear();
       var GajiCostCentre =AppAPI.NewGajiCostCentre();

       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;        
       vm.ExporttoExcel = ExporttoExcel;
       vm.company = $localStorage.empsite;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=GajiCostCentre.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=GajiCostCentre.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 
       
       function ExporttoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewGajicostcentre/exportexcel/' + period  + '/' + company  + '/' + $localStorage.lang  +  '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.laporanbpjstk')
        .controller('NewFormulirBpjsController', NewFormulirBpjsController);

    NewFormulirBpjsController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function NewFormulirBpjsController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var FormulirBpjs=AppAPI.NewFormulirBpjs();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportFormulirBPJStoExcel = ExportFormulirBPJStoExcel;
       vm.company = $localStorage.empsite;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=FormulirBpjs.query({action:'getPeriod',type:'formulir'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=FormulirBpjs.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportFormulirBPJStoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.period;
            var company = vm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewLaporanbpjstk/fbexportpdf/' + period  + '/' + company  + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.espttax', []).config(config);

   config.$inject=['$stateProvider'];

	function config($stateProvider) {
		$stateProvider
		.state('app.payroll_new_espttax', {
			url    : '/new-payroll/report/espttax',
			views  : {
				'content@app' : {
					templateUrl: 'app/main/payroll-new/report/espttax/espttax.html',
					controller : 'NewEspttaxController as vm'
				}
			}
		});
   }
}());
(function() {
	'use strict';
	
	angular
	.module('app.payroll-new.report.espttax')
	.controller('NewEspttaxController', NewEspttaxController);
	
	NewEspttaxController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','$document', '$location', '$window'];
	
	/* @ngInject */
	function NewEspttaxController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,$document,$location,$window){
		var vm = this;
		//var dt = new Date();
		//var year = dt.getFullYear();
		var Espttax=AppAPI.NewEspttax();
		//vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];
		vm.ExportEsptTaxtoExcel = ExportEsptTaxtoExcel;
		
		vm.LoadPeriod = LoadPeriod;
		vm.LoadCompany = LoadCompany;  
		vm.company = $localStorage.empsite;
		
		LoadPeriod();
		LoadCompany();
		
		function LoadPeriod() {
			var response=Espttax.query({action:'getPeriod'});
			response.$promise.then(fetchPeriod);
			response.$promise.catch(errorFetchPeriod);
		}
		
		function fetchPeriod(data) {
			vm.listperiod=data;
		}
		
		function errorFetchPeriod() {
			vm.listperiod=[];
		} 
		
		function LoadCompany() {
			var response=Espttax.query({action:'getCompany'});
			response.$promise.then(fetchCompany);
			response.$promise.catch(errorFetchCompany);
		}
		
		function fetchCompany(data) {
            vm.listcompany=data;
		}
		
		function errorFetchCompany() {
			vm.listcompany=[];
		}
		
		function ExportEsptTaxtoExcel(form) {
			var token = Auth.setTokenPromise();
			var period = vm.period;
			var company = vm.company;
			
			token.then(function(data) {
				var protocol = $location.protocol();
				var host = $location.host();
				$window.open(protocol + '://' + host + config.api + 'api/payrollnew/report/NewEspttax/lgexportexcel/' + period  + '/' +  company + '/' + $localStorage.lang + '/' + data.token, '_blank');
				
			}, function() {
				$window.alert('gagal load token')
			});
        }
	}
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.epfreport-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_epf_report_mgr', {
                url    : '/new-payroll/report/epf-report-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/epf-report-mgr/epfreport.html',
                    controller : 'EpfReportMgrController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
     'use strict';

     angular
          .module('app.payroll-new.report.epfreport-mgr')
          .controller('EpfReportMgrController', EpfReportMgrController);

     EpfReportMgrController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

     /* @ngInject */
     function EpfReportMgrController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

          var vm = this;
          var LaporanGaji = AppAPI.NewLaporanGaji();

          vm.DataTable = new DataService();
          vm.LoadPeriod = LoadPeriod;
          vm.LoadDepartment = LoadDepartment;
          vm.LoadCompany = LoadCompany;
          vm.LoadArea = LoadArea;
          vm.LoadDivisi = LoadDivisi;
          vm.listJum = [2, 5, 25, 50, 75, 100, 200];
          vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

          vm.changeCompany = changeCompany;
          vm.company = $localStorage.empsite;

          LoadPeriod();
          LoadCompany()
          LoadDivisi(vm.company);

          vm.country = $localStorage.country;

          vm.reqWil = false;
          vm.reqArea = true;
          vm.LoadRegional = loadRegional;
          vm.LoadCabang = loadCabang;
          vm.LoadWilayah = loadWilayah;

          loadWilayah();

          vm.LoadArea = LoadArea
          LoadDefaultArea(vm.company);

          function LoadPeriod() {
               var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
               response.$promise.then(fetchPeriod);
               response.$promise.catch(errorFetchPeriod);
          }

          function fetchPeriod(data) {
               vm.listperiod = data;
          }

          function errorFetchPeriod() {
               vm.listperiod = [];
          }

          function LoadCompany() {
               var response = LaporanGaji.query({ action: 'getCompany' });
               response.$promise.then(fetchCompany);
               response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
               vm.listcompany = data;
          }

          function errorFetchCompany() {
               vm.listcompany = [];
          }

          function changeCompany(id) {
               vm.listarea = [];
               var resp = LaporanGaji.query({ action: 'getSpecificArea', companyid: id })
               resp.$promise.then(fetchspecificarea);
               resp.$promise.catch(errorfetchspecificarea);
          }

          function fetchspecificarea(data) {
               vm.listarea = data;
          }

          function errorfetchspecificarea() {
               vm.listarea = [];
          }

          function LoadDepartment(company, divisi) {
               var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
               response.$promise.then(fetchDepartment);
               response.$promise.catch(errorFetchDepartment);
          }

          function fetchDepartment(data) {
               vm.listdepartment = data;
          }

          function errorFetchDepartment() {
               vm.listdepartment = [];
          }

          function LoadDefaultArea(companyid) {
               var response = LaporanGaji.query({ action: 'getArea', companyid: companyid });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function LoadDivisi(companyid) {
               var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
               response.$promise.then(fetchDivisi);
               response.$promise.catch(errorFetchDivisi);
               LoadDepartment(companyid, vm.divisi);
               LoadArea(companyid);
          }

          function fetchDivisi(data) {
               vm.listdivisi = data;
          }

          function errorFetchDivisi() {
               vm.listdivisi = [];
          }

          function ExportLaporanGajitoExcel(form) {
               var token = Auth.setTokenPromise();
               var period = vm.period;
               var company = vm.company;
               var department = vm.department;
               var wilayah = vm.wilayah;
               var regional = vm.regional;
               var cabang = vm.cabang;
               var area = vm.area;
               var divisi = vm.divisi;
               var isMgr = true;

               token.then(function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewEpf/lgexportexcel/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + $localStorage.lang + '/' + wilayah + '/' + regional + '/' + cabang + '/' + isMgr + '/' + data.token, '_blank');
               }, function () {
                    $window.alert('gagal load token')
               });
          }

          vm.clearSearchTerm = function () {
               vm.searchTerm = '';
          };

          $element.find('input').on('keydown', function (ev) {
               ev.stopPropagation();
          });

          //new filter
          function LoadArea(company, cabangid) {
               loadWilayah();
               var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function loadWilayah() {
               var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
               response.$promise.then(fetchWilayah);
               response.$promise.catch(errorFetchWilayah);
          }

          function fetchWilayah(data) {
               vm.listWilayah = data;
          }

          function errorFetchWilayah() {
               vm.listWilayah = [];
          }

          function loadRegional(id) {
               vm.listarea = [];
               vm.reqWil = true;
               vm.reqArea = false;
               var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
               response.$promise.then(fetchRegional);
               response.$promise.catch(errorFetchRegional);
          }

          function fetchRegional(data) {
               vm.listRegional = data;
          }

          function errorFetchRegional() {
               vm.listRegional = [];
          }

          function loadCabang(id) {
               var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
               response.$promise.then(fetchCabang);
               response.$promise.catch(errorFetchCabang);
          }

          function fetchCabang(data) {
               vm.listCabang = data;
          }

          function errorFetchCabang() {
               vm.listCabang = [];
          }
     }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.epfreport', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_epf_report', {
                url    : '/new-payroll/report/epf-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/epf-report/epfreport.html',
                    controller : 'EpfReportController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
     'use strict';

     angular
          .module('app.payroll-new.report.epfreport')
          .controller('EpfReportController', EpfReportController);

     EpfReportController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

     /* @ngInject */
     function EpfReportController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

          var vm = this;
          var LaporanGaji = AppAPI.NewLaporanGaji();

          vm.DataTable = new DataService();
          vm.LoadPeriod = LoadPeriod;
          vm.LoadDepartment = LoadDepartment;
          vm.LoadCompany = LoadCompany;
          vm.LoadArea = LoadArea;
          vm.LoadDivisi = LoadDivisi;
          vm.listJum = [2, 5, 25, 50, 75, 100, 200];
          vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

          vm.changeCompany = changeCompany;
          vm.company = $localStorage.empsite;

          LoadPeriod();
          LoadCompany()
          LoadDivisi(vm.company);

          vm.country = $localStorage.country;

          vm.reqWil = false;
          vm.reqArea = true;
          vm.LoadRegional = loadRegional;
          vm.LoadCabang = loadCabang;
          vm.LoadWilayah = loadWilayah;

          loadWilayah();

          vm.LoadArea = LoadArea
          LoadDefaultArea(vm.company);

          function LoadPeriod() {
               var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
               response.$promise.then(fetchPeriod);
               response.$promise.catch(errorFetchPeriod);
          }

          function fetchPeriod(data) {
               vm.listperiod = data;
          }

          function errorFetchPeriod() {
               vm.listperiod = [];
          }

          function LoadCompany() {
               var response = LaporanGaji.query({ action: 'getCompany' });
               response.$promise.then(fetchCompany);
               response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
               vm.listcompany = data;
          }

          function errorFetchCompany() {
               vm.listcompany = [];
          }

          function changeCompany(id) {
               vm.listarea = [];
               var resp = LaporanGaji.query({ action: 'getSpecificArea', companyid: id })
               resp.$promise.then(fetchspecificarea);
               resp.$promise.catch(errorfetchspecificarea);
          }

          function fetchspecificarea(data) {
               vm.listarea = data;
          }

          function errorfetchspecificarea() {
               vm.listarea = [];
          }

          function LoadDepartment(company, divisi) {
               var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
               response.$promise.then(fetchDepartment);
               response.$promise.catch(errorFetchDepartment);
          }

          function fetchDepartment(data) {
               vm.listdepartment = data;
          }

          function errorFetchDepartment() {
               vm.listdepartment = [];
          }

          function LoadDefaultArea(companyid) {
               var response = LaporanGaji.query({ action: 'getArea', companyid: companyid });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function LoadDivisi(companyid) {
               var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
               response.$promise.then(fetchDivisi);
               response.$promise.catch(errorFetchDivisi);
               LoadDepartment(companyid, vm.divisi);
               LoadArea(companyid);
          }

          function fetchDivisi(data) {
               vm.listdivisi = data;
          }

          function errorFetchDivisi() {
               vm.listdivisi = [];
          }

          function ExportLaporanGajitoExcel(form) {
               var token = Auth.setTokenPromise();
               var period = vm.period;
               var company = vm.company;
               var department = vm.department;
               var wilayah = vm.wilayah;
               var regional = vm.regional;
               var cabang = vm.cabang;
               var area = vm.area;
               var divisi = vm.divisi;
               var isMgr = false;

               token.then(function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewEpf/lgexportexcel/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + $localStorage.lang + '/' + wilayah + '/' + regional + '/' + cabang + '/' + isMgr + '/' + data.token, '_blank');
               }, function () {
                    $window.alert('gagal load token')
               });
          }

          vm.clearSearchTerm = function () {
               vm.searchTerm = '';
          };

          $element.find('input').on('keydown', function (ev) {
               ev.stopPropagation();
          });

          //new filter
          function LoadArea(company, cabangid) {
               loadWilayah();
               var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function loadWilayah() {
               var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
               response.$promise.then(fetchWilayah);
               response.$promise.catch(errorFetchWilayah);
          }

          function fetchWilayah(data) {
               vm.listWilayah = data;
          }

          function errorFetchWilayah() {
               vm.listWilayah = [];
          }

          function loadRegional(id) {
               vm.listarea = [];
               vm.reqWil = true;
               vm.reqArea = false;
               var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
               response.$promise.then(fetchRegional);
               response.$promise.catch(errorFetchRegional);
          }

          function fetchRegional(data) {
               vm.listRegional = data;
          }

          function errorFetchRegional() {
               vm.listRegional = [];
          }

          function loadCabang(id) {
               var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
               response.$promise.then(fetchCabang);
               response.$promise.catch(errorFetchCabang);
          }

          function fetchCabang(data) {
               vm.listCabang = data;
          }

          function errorFetchCabang() {
               vm.listCabang = [];
          }
     }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.eisreport-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_eis_report_mgr', {
                url    : '/new-payroll/report/eis-report-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/eis-report-mgr/eisreport.html',
                    controller : 'EisReportMgrController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.eisreport-mgr')
        .controller('EisReportMgrController', EisReportMgrController);

    EisReportMgrController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window','$element'];

    /* @ngInject */
    function EisReportMgrController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window,$element) {
       
       var vm = this;
       var LaporanGaji=AppAPI.NewLaporanGaji();
       
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

       vm.changeCompany = changeCompany;
       vm.company = $localStorage.empsite;

       LoadPeriod();
       LoadCompany()
       LoadDivisi(vm.company);
       
       vm.country = $localStorage.country;
        
        vm.reqWil    = false;
        vm.reqArea   = true;
        vm.LoadRegional  = loadRegional;
        vm.LoadCabang    = loadCabang;
        vm.LoadWilayah   = loadWilayah;
    
        loadWilayah();
       
        vm.LoadArea = LoadArea
        LoadDefaultArea(vm.company);

        function LoadPeriod() {
            var response=LaporanGaji.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanGaji.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
             vm.listarea=[];
             var resp=LaporanGaji.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadDepartment(company,divisi) {
        var response=LaporanGaji.query({action:'getDepartment', idbu:company, iddivisi:divisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       
       function LoadDefaultArea(companyid) 
       {
               var response=LaporanGaji.query({action:'getArea', companyid:companyid});
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
               vm.listarea=data;
       }

       function errorFetchArea() {
               vm.listarea=[];
       } 

       function LoadDivisi(companyid) {
            var response=LaporanGaji.query({action:'getDivisi', idbu:companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid,vm.divisi);
            LoadArea(companyid);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 
       
       function ExportLaporanGajitoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var department = vm.department;
            var wilayah = vm.wilayah;
            var regional = vm.regional;
            var cabang = vm.cabang;
            var area = vm.area;
            var divisi = vm.divisi;
            var isMgr = true;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewEis/lgexportexcel/' + period  + '/' + company  + '/' + divisi + '/' + department  + '/' + area + '/' + $localStorage.lang + '/' + wilayah + '/' + regional + '/' + cabang + '/' + isMgr + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
        
        //new filter
        function LoadArea(company,cabangid) 
        {
            loadWilayah();
            var response=LaporanGaji.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadWilayah() {
          var response=LaporanGaji.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=LaporanGaji.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=LaporanGaji.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.eisreport', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_eis_report', {
                url    : '/new-payroll/report/eis-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/eis-report/eisreport.html',
                    controller : 'EisReportController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
     'use strict';

     angular
          .module('app.payroll-new.report.eisreport')
          .controller('EisReportController', EisReportController);

     EisReportController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

     /* @ngInject */
     function EisReportController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

          var vm = this;
          var LaporanGaji = AppAPI.NewLaporanGaji();

          vm.DataTable = new DataService();
          vm.LoadPeriod = LoadPeriod;
          vm.LoadDepartment = LoadDepartment;
          vm.LoadCompany = LoadCompany;
          vm.LoadArea = LoadArea;
          vm.LoadDivisi = LoadDivisi;
          vm.listJum = [2, 5, 25, 50, 75, 100, 200];
          vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

          vm.changeCompany = changeCompany;
          vm.company = $localStorage.empsite;

          LoadPeriod();
          LoadCompany()
          LoadDivisi(vm.company);

          vm.country = $localStorage.country;

          vm.reqWil = false;
          vm.reqArea = true;
          vm.LoadRegional = loadRegional;
          vm.LoadCabang = loadCabang;
          vm.LoadWilayah = loadWilayah;

          loadWilayah();

          vm.LoadArea = LoadArea
          LoadDefaultArea(vm.company);

          function LoadPeriod() {
               var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
               response.$promise.then(fetchPeriod);
               response.$promise.catch(errorFetchPeriod);
          }

          function fetchPeriod(data) {
               vm.listperiod = data;
          }

          function errorFetchPeriod() {
               vm.listperiod = [];
          }

          function LoadCompany() {
               var response = LaporanGaji.query({ action: 'getCompany' });
               response.$promise.then(fetchCompany);
               response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
               vm.listcompany = data;
          }

          function errorFetchCompany() {
               vm.listcompany = [];
          }

          function changeCompany(id) {
               vm.listarea = [];
               var resp = LaporanGaji.query({ action: 'getSpecificArea', companyid: id })
               resp.$promise.then(fetchspecificarea);
               resp.$promise.catch(errorfetchspecificarea);
          }

          function fetchspecificarea(data) {
               vm.listarea = data;
          }

          function errorfetchspecificarea() {
               vm.listarea = [];
          }

          function LoadDepartment(company, divisi) {
               var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
               response.$promise.then(fetchDepartment);
               response.$promise.catch(errorFetchDepartment);
          }

          function fetchDepartment(data) {
               vm.listdepartment = data;
          }

          function errorFetchDepartment() {
               vm.listdepartment = [];
          }

          function LoadDefaultArea(companyid) {
               var response = LaporanGaji.query({ action: 'getArea', companyid: companyid });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function LoadDivisi(companyid) {
               var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
               response.$promise.then(fetchDivisi);
               response.$promise.catch(errorFetchDivisi);
               LoadDepartment(companyid, vm.divisi);
               LoadArea(companyid);
          }

          function fetchDivisi(data) {
               vm.listdivisi = data;
          }

          function errorFetchDivisi() {
               vm.listdivisi = [];
          }

          function ExportLaporanGajitoExcel(form) {
               var token = Auth.setTokenPromise();
               var period = vm.period;
               var company = vm.company;
               var department = vm.department;
               var wilayah = vm.wilayah;
               var regional = vm.regional;
               var cabang = vm.cabang;
               var area = vm.area;
               var divisi = vm.divisi;
               var isMgr = false;

               token.then(function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewEis/lgexportexcel/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + $localStorage.lang + '/' + wilayah + '/' + regional + '/' + cabang + '/' + isMgr + '/' + data.token, '_blank');
               }, function () {
                    $window.alert('gagal load token')
               });
          }

          vm.clearSearchTerm = function () {
               vm.searchTerm = '';
          };

          $element.find('input').on('keydown', function (ev) {
               ev.stopPropagation();
          });

          //new filter
          function LoadArea(company, cabangid) {
               loadWilayah();
               var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid });
               response.$promise.then(fetchArea);
               response.$promise.catch(errorFetchArea);
          }

          function fetchArea(data) {
               vm.listarea = data;
          }

          function errorFetchArea() {
               vm.listarea = [];
          }

          function loadWilayah() {
               var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
               response.$promise.then(fetchWilayah);
               response.$promise.catch(errorFetchWilayah);
          }

          function fetchWilayah(data) {
               vm.listWilayah = data;
          }

          function errorFetchWilayah() {
               vm.listWilayah = [];
          }

          function loadRegional(id) {
               vm.listarea = [];
               vm.reqWil = true;
               vm.reqArea = false;
               var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
               response.$promise.then(fetchRegional);
               response.$promise.catch(errorFetchRegional);
          }

          function fetchRegional(data) {
               vm.listRegional = data;
          }

          function errorFetchRegional() {
               vm.listRegional = [];
          }

          function loadCabang(id) {
               var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
               response.$promise.then(fetchCabang);
               response.$promise.catch(errorFetchCabang);
          }

          function fetchCabang(data) {
               vm.listCabang = data;
          }

          function errorFetchCabang() {
               vm.listCabang = [];
          }
     }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.deductionreport-mgr', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_deduction_report_mgr', {
                url    : '/new-payroll/report/deduction-report-management',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/deduction-report-mgr/deductionreportmgr.html',
                    controller : 'DeductionReportMgrController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.deductionreport-mgr')
        .controller('DeductionReportMgrController', DeductionReportMgrController);

    DeductionReportMgrController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function DeductionReportMgrController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('1');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewDeductionReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.deductionreport', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_deduction_report', {
                url    : '/new-payroll/report/deduction-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/deduction-report/deductionreport.html',
                    controller : 'DeductionReportController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.deductionreport')
        .controller('DeductionReportController', DeductionReportController);

    DeductionReportController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function DeductionReportController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('0');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewDeductionReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.daftarmutasi', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_daftarmutasi', {
                url    : '/new-payroll/report/daftarmutasi',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/daftarmutasi/daftarmutasi.html',
                    controller : 'NewLaporanDaftarMutasiController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.daftarmutasi')
        .controller('NewLaporanDaftarMutasiController', NewLaporanDaftarMutasiController);

    NewLaporanDaftarMutasiController.$inject = ['$state','$localStorage','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function NewLaporanDaftarMutasiController($state,$localStorage,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var DaftarMutasi=AppAPI.NewDaftarMutasi();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportDaftarMutasitoExcel = ExportDaftarMutasitoExcel;
       vm.company = $localStorage.empsite;
       
      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=DaftarMutasi.query({action:'getPeriod',type:'mutasi'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=DaftarMutasi.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportDaftarMutasitoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.period;
            var company = vm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/payrollnew/report/NewLaporanbpjskes/dmexportexcel/' + period  + '/' + company + '/' + $localStorage.lang  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.bonusreport-mgr', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_bonus_report_mgr', {
                url    : '/new-payroll/report/bonus-report-management',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/bonus-report-mgr/bonusreportmgr.html',
                    controller : 'BonusReportMgrController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.bonusreport-mgr')
        .controller('BonusReportMgrController', BonusReportMgrController);

    BonusReportMgrController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function BonusReportMgrController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }
        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('1');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewBonusReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.bonusreport', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_bonus_report', {
                url    : '/new-payroll/report/bonus-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/bonus-report/bonusreport.html',
                    controller : 'BonusReportController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.bonusreport')
        .controller('BonusReportController', BonusReportController);

    BonusReportController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function BonusReportController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('0');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewBonusReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.banktransfer', []).config(config);

   config.$inject=['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
    .state('app.payroll_new_banktransfer', {
      url    : '/new-payroll/report/banktransfer',
      views  : {
        'content@app' : {
          templateUrl: 'app/main/payroll-new/report/banktransfer/banktransfer.html',
          controller : 'NewBanktransferController as vm'
        }
      }
    });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.banktransfer')
        .controller('NewBanktransferController', NewBanktransferController);

    NewBanktransferController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function NewBanktransferController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, $document, $location, $window, $element) {

        var vm = this;
        var dt = new Date();
        var year = dt.getFullYear();
        var Banktransfer = AppAPI.NewBanktransfer();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadSBU = LoadSBU;
        vm.LoadCompany = LoadCompany;
        vm.ExportBankTransfertoExcel = ExportBankTransfertoExcel;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.SBU = 'all';
        LoadPeriod();
        LoadCompany();
        LoadCountry();
        LoadSBU(vm.company);

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = Banktransfer.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadSBU(companyId) {
            var response = Banktransfer.query({ action: 'getSBU', companyid: companyId });
            response.$promise.then(fetchSBU);
            response.$promise.catch(errorFetchSBU);
        }

        function fetchSBU(data) {
            vm.listSBU = data;
        }

        function errorFetchSBU() {
            vm.listSBU = [];
        }

        function LoadCompany() {
            var response = Banktransfer.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function ExportBankTransfertoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var SBU = vm.SBU;
            var country = vm.country;

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewBanktransfer/lbtexportexcel/' + period + '/' + SBU + '/' + $localStorage.lang + '/' + country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.analisacostcentre', []).config(config);

   config.$inject=['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
    .state('app.payroll_new_analisacostcentre', {
      url    : '/payroll-new/report/analisacostcentre',
      views  : {
        'content@app' : {
          templateUrl: 'app/main/payroll-new/report/analisacostcentre/analisacostcentre.html',
          controller : 'NewAnalisaCostCentreController as vm'
        }
      }
    });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.report.analisacostcentre')
        .controller('NewAnalisaCostCentreController', NewAnalisaCostCentreController);

    NewAnalisaCostCentreController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','$document', '$location', '$window'];

    /* @ngInject */
    function NewAnalisaCostCentreController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,$document,$location,$window) {
       
       var vm = this;
       var dt = new Date();
       var year = dt.getFullYear();
       var AnalisaCostCentre =AppAPI.NewAnalisaCostCentre();

       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;        
       vm.ExporttoExcel = ExporttoExcel;
       vm.company = $localStorage.empsite;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=AnalisaCostCentre.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=AnalisaCostCentre.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 
       
       function ExporttoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/payrollnew/report/NewAnalisacostcentre/exportexcel/' + period  + '/' + company  + '/' + $localStorage.lang +  '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.allowancereport-mgr', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_allowance_report_mgr', {
                url    : '/new-payroll/report/allowance-report-management',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/allowance-report-mgr/allowancereportmgr.html',
                    controller : 'AllowanceReportMgrController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.allowancereport-mgr')
        .controller('AllowanceReportMgrController', AllowanceReportMgrController);

    AllowanceReportMgrController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function AllowanceReportMgrController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('1');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewAllowanceReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.allowancereport', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) {
   	 $stateProvider
            .state('app.payroll_new_allowance_report', {
                url    : '/new-payroll/report/allowance-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/allowance-report/allowancereport.html',
                    controller : 'AllowanceReportController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.report.allowancereport')
        .controller('AllowanceReportController', AllowanceReportController);

    AllowanceReportController.$inject = ['$localStorage', 'config', 'AppAPI', 'Auth', '$location', '$window', '$element'];

    /* @ngInject */
    function AllowanceReportController($localStorage, config, AppAPI, Auth, $location, $window, $element) {
        var vm = this;
        var LaporanGaji = AppAPI.NewLaporanGaji();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.ExportData = ExportData;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.reqWil = false;
        vm.reqArea = true;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.LoadArea = LoadArea
        vm.LoadDefaultArea = LoadDefaultArea

        LoadDefaultArea(vm.company);
        loadWilayah();
        LoadPeriod();
        LoadCompany()
        LoadDivisi(vm.company);

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPeriod() {
            var response = LaporanGaji.query({ action: 'getPeriod', country: vm.country });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, divisi) {
            var response = LaporanGaji.query({ action: 'getDepartment', idbu: company, iddivisi: divisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = LaporanGaji.query({ action: 'getArea', companyid: companyid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = LaporanGaji.query({ action: 'getDivisi', idbu: companyid });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            LoadArea(companyid);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function ExportData(isPdf) {
            var token = Auth.setTokenPromise();
            var period = encrypt(vm.period);
            var company = encrypt(vm.company);
            var department = encrypt(vm.department);
            var wilayah = encrypt(vm.wilayah);
            var regional = encrypt(vm.regional);
            var cabang = encrypt(vm.cabang);
            var area = encrypt(vm.area);
            var language = encrypt($localStorage.lang);
            var divisi = encrypt(vm.divisi);
            var action = encrypt('downloadReport');
            var isMgr = encrypt('0');
            var isPdf = encrypt(isPdf);

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewAllowanceReport/exportData/' + period + '/' + company + '/' + divisi + '/' + department + '/' + area + '/' + language + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + isMgr + '/' + isPdf + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function encrypt(param) {
            return encodeURIComponent(window.btoa(param))
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        //new filter
        function LoadArea(company, cabangid) {
            loadWilayah();
            var response = LaporanGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid, country: vm.country });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = LaporanGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = LaporanGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = LaporanGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.payrollprocess', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) 
   {
   	    $stateProvider
            .state('app.payroll_new_payrollprocess', {
                url    : '/new-payroll/payrollprocess',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/payrollprocess/payrollprocess.html',
                    controller : 'NewPayrollProcessController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.payrollprocess')
        .controller('dataStatusPayrollController', dataStatusPayrollController);

    /* @ngInject */
    dataStatusPayrollController.$inject = [
        '$mdDialog',
        '$http',
        'config',
        'Form',
        'AppAPI',
        'Auth',
        'DataStatusPayroll',
        '$mdToast',
        '$element',
        '$scope'
    ];

    function dataStatusPayrollController(
        $mdDialog,
        $http,
        config,
        Form,
        AppAPI,
        Auth,
        DataStatusPayroll,
        $mdToast,
        $element,
        $scope
    ) {
        var vm = this;
        vm.closeModal = closeModal;
        vm.DataStatusPayroll = DataStatusPayroll;
        console.log(DataStatusPayroll);

        function closeModal() {
            $mdDialog.hide();
        }

        $scope.answer = function (answer) {
                $mdDialog.hide(answer)
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.payroll-new.laporanprosespayroll.payrolldetails', [])
        .config(config);

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
        // State 
        $stateProvider
        .state('app.payroll_new_details', {
            url    : '/payroll-new/laporanprosespayroll/payrolldetails/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/payroll-new/laporanprosespayroll/payrolldetails/payrolldetails.html',
                    controller : 'NewSetPayrollDetailController as vm'
                }
            }
        });   
                
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.laporanprosespayroll.payrolldetails')
        .controller('NewSetPayrollDetailController', NewSetPayrollDetailController);

    NewSetPayrollDetailController.$inject = ['DataService','$state','$mdDialog','$mdToast','$localStorage','$window','AppAPI','Auth','Form','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function NewSetPayrollDetailController(DataService,$state,$mdDialog,$mdToast,$localStorage,$window,AppAPI,Auth,Form,DTColumnDefBuilder,$timeout,$stateParams) {
          var vm = this;
          var str = $stateParams.id.split("#");
          vm.nik = str[0];//$stateParams.id;
          vm.period = str[1];//$stateParams.id[1];
          vm.payrollview = {};
          var Laporanprosespayroll= AppAPI.LaporanProsesPayroll();

          Form.initialForm();

          // set constructor form
          Form.setObject(Laporanprosespayroll);

          // set form to controller
          vm.Form = Form; 
          vm.setToken=Auth.setToken;
          
          loadData();
          

          function loadData() {
           angular.element.blockUI();
           var promises = Laporanprosespayroll.query({action:'viewdetail',id:vm.nik, period: vm.period});
           promises.$promise.then(fetchPayrollData);
           promises.$promise.catch(errorPayrollFetch); 
          }

          function fetchPayrollData(data) {

              vm.payrollview = data; 
                           
          }

          function errorPayrollFetch() {

              vm.payrollview = {};
              angular.element.unblockUI();
          }

        
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.bpjsmalaysiaepfcomponent', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_bpjsmalaysiaepfcomponent', {
                url    : '/new-payroll/bpjsmalaysiaepf',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/bpjsmalaysiaepf/bpjsmalaysiaepfComponent.html',
                    controller : 'BpjsmalaysiaepfComponentController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.bpjsmalaysiaepfcomponent')
        .controller('ManageEpfController', ManageEpfController);

    ManageEpfController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', '$element', '$log', 'dataEis', '$http', 'config'];

    /* @ngInject */
    function ManageEpfController($q, $mdDialog, Form, AppAPI, $element, $log, dataEis, $http, config) {
        var vm = this;
        vm.saveData = saveData;
        var BpjsMalaysiaEpf = AppAPI.BpjsMalaysiaEpf();
        Form.initialForm();
        Form.setObject(BpjsMalaysiaEpf);
        vm.Form = Form;
        vm.dataEis = dataEis;
        vm.label = 'Add';

        if (vm.dataEis) {
            vm.label = 'Edit';
            vm.Form.objForm.start_salary = parseFloat(vm.dataEis.start_salary);
            vm.Form.objForm.end_salary = parseFloat(vm.dataEis.end_salary);
            vm.Form.objForm.ee_value = parseFloat(vm.dataEis.ee_value);
            vm.Form.objForm.er_value = parseFloat(vm.dataEis.er_value);
            vm.Form.objForm.id = vm.dataEis.id;
        }

        console.log(vm.dataEis);

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            if (vm.dataEis) {
                updateData(ev, formController);
            } else {
                var promise = Form.saveData('save', formController, BpjsMalaysiaEpf);
                promise.then(function (data) {
                    showDialog(ev, data);
                });
                promise.catch(function (data) {
                    ShowFailed(ev, data)
                });
            }

        }

        function updateData(ev, formController) {
            var promise = Form.saveData('update', formController, BpjsMalaysiaEpf);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();

(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.bpjsmalaysiaeiscomponent', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_bpjsmalaysiaeiscomponent', {
                url    : '/new-payroll/bpjsmalaysiaeis',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/bpjsmalaysiaeis/bpjsmalaysiaeisComponent.html',
                    controller : 'BpjsmalaysiaeisComponentController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.bpjsmalaysiaeiscomponent')
        .controller('ManageEisController', ManageEisController);

    ManageEisController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', '$element', '$log', 'dataEis', '$http', 'config'];

    /* @ngInject */
    function ManageEisController($q, $mdDialog, Form, AppAPI, $element, $log, dataEis, $http, config) {
        var vm = this;
        vm.saveData = saveData;
        var BpjsMalaysiaEis = AppAPI.BpjsMalaysiaEis();
        Form.initialForm();
        Form.setObject(BpjsMalaysiaEis);
        vm.Form = Form;
        vm.dataEis = dataEis;
        vm.label = 'Add';

        if (vm.dataEis) {
            vm.label = 'Edit';
            vm.Form.objForm.start_salary = parseFloat(vm.dataEis.start_salary);
            vm.Form.objForm.end_salary = parseFloat(vm.dataEis.end_salary);
            vm.Form.objForm.ee_value = parseFloat(vm.dataEis.ee_value);
            vm.Form.objForm.er_value = parseFloat(vm.dataEis.er_value);
            vm.Form.objForm.id = vm.dataEis.id;
        }

        console.log(vm.dataEis);

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            if (vm.dataEis) {
                updateData(ev, formController);
            } else {
                var promise = Form.saveData('save', formController, BpjsMalaysiaEis);
                promise.then(function (data) {
                    showDialog(ev, data);
                });
                promise.catch(function (data) {
                    ShowFailed(ev, data)
                });
            }

        }

        function updateData(ev, formController) {
            var promise = Form.saveData('update', formController, BpjsMalaysiaEis);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();

(function () {
    "use strict";
    /**
     *  Module
     *
     * Description
     */
    angular.module('app.payroll-pma.report.reportcostnonmgr', []).config(config);

    config.$inject = ['$stateProvider'];


    function config($stateProvider) {

        $stateProvider
            .state('app.payroll_reportcostnonmgr', {
                url: '/payroll/report/reportcost-nonmgr',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/payroll-pma/report/reportcost/reportcost.html',
                        controller: 'ReportCostNonMgrController as vm'
                    }
                }

            });
    }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-pma.report.reportcostnonmgr')
        .controller('ReportCostNonMgrController', ReportCostNonMgrController);

    ReportCostNonMgrController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function ReportCostNonMgrController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

        var vm = this;
        var ReportCost = AppAPI.ReportCostNonMgr();
        var EstimasiGaji = AppAPI.EstimasiGaji();
        vm.DataTable = new DataService();
        vm.LoadPeriod = LoadPeriod;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.ExportReportCosttoExcel = ExportReportCosttoExcel;
        vm.viewReportCosttoExcel = viewReportCosttoExcel;

        vm.company = $localStorage.empsite;
        vm.loadDivision = loadDivision;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;

        vm.reqWil = false;
        vm.reqArea = true;
        vm.area = 'all';
        vm.isAll = false;

        LoadPeriod();
        LoadCompany()
        loadWilayah();
        LoadAreaDefault(vm.company);

        function LoadAreaDefault(company) {
            var response = EstimasiGaji.query({ action: 'getArea', companyid: company, ismultiple: true });
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

        function fetchAreaDefault(data) {
            vm.listarea = data;
        }

        function errorFetchAreaDefault() {
            vm.listarea = [];
        }

        function LoadPeriod() {
            var response = ReportCost.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = ReportCost.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadArea(company, cabangid) {
            loadDivision(company);
            loadWilayah();
            var response = ReportCost.query({ action: 'getArea', companyid: company, cabangid: cabangid });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadDivision(company) {
            var response = ReportCost.query({ action: 'getDivision', companyid: company });
            response.$promise.then(fetchDivision);
            response.$promise.catch(errorFetchDivision);
        }

        function fetchDivision(data) {
            vm.listDivision = data;
        }

        function errorFetchDivision() {
            vm.listDivision = [];
        }

        function loadWilayah() {
            var response = ReportCost.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = ReportCost.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = ReportCost.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function ExportReportCosttoExcel(form) {
            var includeCost = vm.cost == true ? encodeURIComponent(window.btoa('1')) : encodeURIComponent(window.btoa('0'));
            var token = Auth.setTokenPromise();
            var startPeriod = encodeURIComponent(window.btoa(vm.startPeriod));
            var endPeriod = encodeURIComponent(window.btoa(vm.endPeriod));
            var company = encodeURIComponent(window.btoa(vm.company));
            var area = encodeURIComponent(window.btoa(vm.area));
            var division = encodeURIComponent(window.btoa(vm.division));
            var wilayah = encodeURIComponent(window.btoa(vm.wilayah));
            var regional = encodeURIComponent(window.btoa(vm.regional));
            var cabang = encodeURIComponent(window.btoa(vm.cabang));
            var action = encodeURIComponent(window.btoa('downloadDataHRIS'));

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/reportcostnonmgr/lgexportexcel/' + startPeriod + '/' + endPeriod + '/' + company + '/' + area + '/' + division + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + includeCost + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function viewReportCosttoExcel(form) {
            angular.element.blockUI();
            var includeCost = vm.cost == true ? encodeURIComponent(window.btoa('1')) : encodeURIComponent(window.btoa('0'));
            var token = Auth.setTokenPromise();
            var startPeriod = encodeURIComponent(window.btoa(vm.startPeriod));
            var endPeriod = encodeURIComponent(window.btoa(vm.endPeriod));
            var company = encodeURIComponent(window.btoa(vm.company));
            var area = encodeURIComponent(window.btoa(vm.area));
            var division = encodeURIComponent(window.btoa(vm.division));
            var wilayah = encodeURIComponent(window.btoa(vm.wilayah));
            var regional = encodeURIComponent(window.btoa(vm.regional));
            var cabang = encodeURIComponent(window.btoa(vm.cabang));
            var type = encodeURIComponent(window.btoa('downloadDataHRIS'));

            var response = ReportCost.query({
                action: 'viewData',
                startPeriod: startPeriod,
                endPeriod: endPeriod,
                company: company,
                area: area,
                division: division,
                wilayah: wilayah,
                regional: regional,
                includeCost: includeCost,
                type: type,
                cabang: cabang
            });
            response.$promise.then(fetchData);
            response.$promise.catch(errorFetchData);
        }

        function fetchData(data) {
            angular.element.unblockUI();
            vm.listData = data;
        }

        function errorFetchData() {
            angular.element.unblockUI();
            vm.listData = [];
        }

        vm.selectArea = selectArea;
        function selectArea(area) {
            console.log(area);
            console.log(typeof area != "undefined" && area.indexOf(0) != -1);
            if (typeof area != "undefined" && area.indexOf(0) != -1) {
                if ((vm.listarea.length - 1) == area.length) {
                    var index = area.indexOf(0);
                    if (index > -1) {
                        vm.area.splice(index, 1);
                    }
                    vm.isAll = false;
                } else {
                    vm.isAll = true;
                    vm.area = [];
                    for (var i = 0; i <= (vm.listarea.length - 1); i++) {
                        vm.area.push(vm.listarea[i].id);
                    }
                }
            } else {
                if (vm.isAll) {
                    vm.area = [];
                    vm.isAll = false;
                } else if (typeof area != "undefined" && (vm.listarea.length - 1) == area.length) {
                    vm.area.push(0);
                    vm.isAll = true;
                }
            }
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    "use strict";
    /**
     *  Module
     *
     * Description
     */
    angular.module('app.payroll-pma.report.reportcostmgr', []).config(config);

    config.$inject = ['$stateProvider'];


    function config($stateProvider) {

        $stateProvider
            .state('app.payroll_reportcostmgr', {
                url: '/payroll/report/reportcost-mgr',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/payroll-pma/report/reportcost/reportcost.html',
                        controller: 'ReportCostMgrController as vm'
                    }
                }

            });
    }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-pma.report.reportcostmgr')
        .controller('ReportCostMgrController', ReportCostMgrController);

    ReportCostMgrController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function ReportCostMgrController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

        var vm = this;
        var ReportCost = AppAPI.ReportCostMgr();
        var EstimasiGaji = AppAPI.EstimasiGaji();
        vm.DataTable = new DataService();
        vm.LoadPeriod = LoadPeriod;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.ExportReportCosttoExcel = ExportReportCosttoExcel;
        vm.viewReportCosttoExcel = viewReportCosttoExcel;

        vm.company = $localStorage.empsite;
        vm.loadDivision = loadDivision;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;

        vm.reqWil = false;
        vm.reqArea = true;
        vm.area = 'all';
        vm.isAll = false;

        LoadPeriod();
        LoadCompany()
        loadWilayah();
        LoadAreaDefault(vm.company);

        function LoadAreaDefault(company) {
            var response = EstimasiGaji.query({ action: 'getArea', companyid: company, ismultiple: true });
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

        function fetchAreaDefault(data) {
            vm.listarea = data;
        }

        function errorFetchAreaDefault() {
            vm.listarea = [];
        }

        function LoadPeriod() {
            var response = ReportCost.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = ReportCost.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadArea(company, cabangid) {
            loadDivision(company);
            loadWilayah();
            var response = ReportCost.query({ action: 'getArea', companyid: company, cabangid: cabangid });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadDivision(company) {
            var response = ReportCost.query({ action: 'getDivision', companyid: company });
            response.$promise.then(fetchDivision);
            response.$promise.catch(errorFetchDivision);
        }

        function fetchDivision(data) {
            vm.listDivision = data;
        }

        function errorFetchDivision() {
            vm.listDivision = [];
        }

        function loadWilayah() {
            var response = ReportCost.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = ReportCost.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = ReportCost.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function ExportReportCosttoExcel(form) {
            var includeCost = vm.cost == true ? encodeURIComponent(window.btoa('1')) : encodeURIComponent(window.btoa('0'));
            var token = Auth.setTokenPromise();
            var startPeriod = encodeURIComponent(window.btoa(vm.startPeriod));
            var endPeriod = encodeURIComponent(window.btoa(vm.endPeriod));
            var company = encodeURIComponent(window.btoa(vm.company));
            var area = encodeURIComponent(window.btoa(vm.area));
            var division = encodeURIComponent(window.btoa(vm.division));
            var wilayah = encodeURIComponent(window.btoa(vm.wilayah));
            var regional = encodeURIComponent(window.btoa(vm.regional));
            var cabang = encodeURIComponent(window.btoa(vm.cabang));
            var action = encodeURIComponent(window.btoa('downloadDataSAP'));

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/reportcostmgr/lgexportexcel/' + startPeriod + '/' + endPeriod + '/' + company + '/' + area + '/' + division + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + includeCost + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function viewReportCosttoExcel(form) {
            angular.element.blockUI();
            var includeCost = vm.cost == true ? encodeURIComponent(window.btoa('1')) : encodeURIComponent(window.btoa('0'));
            var token = Auth.setTokenPromise();
            var startPeriod = encodeURIComponent(window.btoa(vm.startPeriod));
            var endPeriod = encodeURIComponent(window.btoa(vm.endPeriod));
            var company = encodeURIComponent(window.btoa(vm.company));
            var area = encodeURIComponent(window.btoa(vm.area));
            var division = encodeURIComponent(window.btoa(vm.division));
            var wilayah = encodeURIComponent(window.btoa(vm.wilayah));
            var regional = encodeURIComponent(window.btoa(vm.regional));
            var cabang = encodeURIComponent(window.btoa(vm.cabang));
            var type = encodeURIComponent(window.btoa('downloadDataSAP'));

            var response = ReportCost.query({
                action: 'viewData',
                startPeriod: startPeriod,
                endPeriod: endPeriod,
                company: company,
                area: area,
                division: division,
                wilayah: wilayah,
                regional: regional,
                includeCost: includeCost,
                type: type,
                cabang: cabang
            });
            response.$promise.then(fetchData);
            response.$promise.catch(errorFetchData);
        }

        function fetchData(data) {
            angular.element.unblockUI();
            vm.listData = data;
        }

        function errorFetchData() {
            angular.element.unblockUI();
            vm.listData = [];
        }

        vm.selectArea = selectArea;
        function selectArea(area) {
            if (typeof area != "undefined" && area.indexOf(0) != -1) {
                if ((vm.listarea.length - 1) == area.length) {
                    var index = area.indexOf(0);
                    if (index > -1) {
                        vm.area.splice(index, 1);
                    }
                    vm.isAll = false;
                } else {
                    vm.isAll = true;
                    vm.area = [];
                    for (var i = 0; i <= (vm.listarea.length - 1); i++) {
                        vm.area.push(vm.listarea[i].id);
                    }
                }
            } else {
                if (vm.isAll) {
                    vm.area = [];
                    vm.isAll = false;
                } else if (typeof area != "undefined" && (vm.listarea.length - 1) == area.length) {
                    vm.area.push(0);
                    vm.isAll = true;
                }
            }
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    "use strict";
    /**
     *  Module
     *
     * Description
     */
    angular.module('app.payroll-pma.report.reportcostarea', []).config(config);

    config.$inject = ['$stateProvider'];


    function config($stateProvider) {

        $stateProvider
            .state('app.payroll_reportcostarea', {
                url: '/payroll/report/reportcostarea',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/payroll-pma/report/reportcostarea/reportcostarea.html',
                        controller: 'ReportCostAreaController as vm'
                    }
                }

            });
    }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-pma.report.reportcostarea')
        .controller('ReportCostAreaController', ReportCostAreaController);

    ReportCostAreaController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function ReportCostAreaController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

        var vm = this;
        var ReportCost = AppAPI.ReportCostArea();
        var EstimasiGaji = AppAPI.EstimasiGaji();
        vm.DataTable = new DataService();
        vm.LoadPeriod = LoadPeriod;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.ExportReportCosttoExcel = ExportReportCosttoExcel;
        vm.viewReportCosttoExcel = viewReportCosttoExcel;

        vm.company = $localStorage.empsite;
        vm.loadDivision = loadDivision;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;

        vm.reqWil = false;
        vm.reqArea = true;
        vm.area = 'all';

        LoadPeriod();
        LoadCompany()
        loadWilayah();
        LoadAreaDefault(vm.company);

        function LoadAreaDefault(company) {
            var response = EstimasiGaji.query({ action: 'getArea', companyid: company, ismultiple: true });
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

        function fetchAreaDefault(data) {
            vm.listarea = data;
        }

        function errorFetchAreaDefault() {
            vm.listarea = [];
        }

        function LoadPeriod() {
            var response = ReportCost.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = ReportCost.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadArea(company, cabangid) {
            loadDivision(company);
            loadWilayah();
            var response = ReportCost.query({ action: 'getArea', companyid: company, cabangid: cabangid, ismultiple: true });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadDivision(company) {
            var response = ReportCost.query({ action: 'getDivision', companyid: company });
            response.$promise.then(fetchDivision);
            response.$promise.catch(errorFetchDivision);
        }

        function fetchDivision(data) {
            vm.listDivision = data;
        }

        function errorFetchDivision() {
            vm.listDivision = [];
        }

        function loadWilayah() {
            var response = ReportCost.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = ReportCost.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = ReportCost.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function ExportReportCosttoExcel(form) {
            var includeCost = vm.cost == true ? encodeURIComponent(window.btoa('1')) : encodeURIComponent(window.btoa('0'));
            var token = Auth.setTokenPromise();
            var period = encodeURIComponent(window.btoa(vm.period));
            var company = encodeURIComponent(window.btoa(vm.company));
            var area = encodeURIComponent(window.btoa(vm.area));
            var division = encodeURIComponent(window.btoa(vm.division));
            var wilayah = encodeURIComponent(window.btoa(vm.wilayah));
            var regional = encodeURIComponent(window.btoa(vm.regional));
            var cabang = encodeURIComponent(window.btoa(vm.cabang));
            var action = encodeURIComponent(window.btoa('downloadData'));

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/reportcostperarea/lgexportexcel/' + period + '/' + company + '/' + area + '/' + division + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + includeCost + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function viewReportCosttoExcel(form) {
            angular.element.blockUI();
            var includeCost = vm.cost == true ? encodeURIComponent(window.btoa('1')) : encodeURIComponent(window.btoa('0'));
            var token = Auth.setTokenPromise();
            var period = encodeURIComponent(window.btoa(vm.period));
            var company = encodeURIComponent(window.btoa(vm.company));
            var area = encodeURIComponent(window.btoa(vm.area));
            var division = encodeURIComponent(window.btoa(vm.division));
            var wilayah = encodeURIComponent(window.btoa(vm.wilayah));
            var regional = encodeURIComponent(window.btoa(vm.regional));
            var cabang = encodeURIComponent(window.btoa(vm.cabang));
            var type = encodeURIComponent(window.btoa('downloadData'));

            var response = ReportCost.query({
                action: 'viewData',
                period: period,
                company: company,
                area: area,
                division: division,
                wilayah: wilayah,
                regional: regional,
                includeCost: includeCost,
                type: type,
                cabang: cabang
            });
            response.$promise.then(fetchData);
            response.$promise.catch(errorFetchData);
        }

        function fetchData(data) {
            angular.element.unblockUI();
            vm.listData = data;
        }

        function errorFetchData() {
            angular.element.unblockUI();
            vm.listData = [];
        }

        vm.selectArea = selectArea;
        function selectArea(area) {
            if (typeof area != "undefined" && area.indexOf(0) != -1) {
                if ((vm.listarea.length - 1) == area.length) {
                    var index = area.indexOf(0);
                    if (index > -1) {
                        vm.area.splice(index, 1);
                    }
                    vm.isAll = false;
                } else {
                    vm.isAll = true;
                    vm.area = [];
                    for (var i = 0; i <= (vm.listarea.length - 1); i++) {
                        vm.area.push(vm.listarea[i].id);
                    }
                }
            } else {
                if (vm.isAll) {
                    vm.area = [];
                    vm.isAll = false;
                } else if (typeof area != "undefined" && (vm.listarea.length - 1) == area.length) {
                    vm.area.push(0);
                    vm.isAll = true;
                }
            }
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    "use strict";
    /**
     *  Module
     *
     * Description
     */
    angular.module('app.payroll-pma.report.reportcost', []).config(config);

    config.$inject = ['$stateProvider'];


    function config($stateProvider) {

        $stateProvider
            .state('app.payroll_reportcost', {
                url: '/payroll/report/reportcost',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/payroll-pma/report/reportcost/reportcost.html',
                        controller: 'ReportCostController as vm'
                    }
                }

            });
    }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-pma.report.reportcost')
        .controller('ReportCostController', ReportCostController);

    ReportCostController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function ReportCostController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

        var vm = this;
        var ReportCost = AppAPI.ReportCost();
        var EstimasiGaji = AppAPI.EstimasiGaji();
        vm.DataTable = new DataService();
        vm.LoadPeriod = LoadPeriod;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.ExportReportCosttoExcel = ExportReportCosttoExcel;
        vm.viewReportCosttoExcel = viewReportCosttoExcel;

        vm.company = $localStorage.empsite;
        vm.loadDivision = loadDivision;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;

        vm.reqWil = false;
        vm.reqArea = true;
        vm.area = 'all';
        vm.isAll = false;

        LoadPeriod();
        LoadCompany()
        loadWilayah();
        LoadAreaDefault(vm.company);

        function LoadAreaDefault(company) {
            var response = EstimasiGaji.query({ action: 'getArea', companyid: company, ismultiple: true });
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

        function fetchAreaDefault(data) {
            vm.listarea = data;
        }

        function errorFetchAreaDefault() {
            vm.listarea = [];
        }

        function LoadPeriod() {
            var response = ReportCost.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = ReportCost.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadArea(company, cabangid) {
            loadDivision(company);
            loadWilayah();
            var response = ReportCost.query({ action: 'getArea', companyid: company, cabangid: cabangid, ismultiple: true });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadDivision(company) {
            var response = ReportCost.query({ action: 'getDivision', companyid: company });
            response.$promise.then(fetchDivision);
            response.$promise.catch(errorFetchDivision);
        }

        function fetchDivision(data) {
            vm.listDivision = data;
        }

        function errorFetchDivision() {
            vm.listDivision = [];
        }

        function loadWilayah() {
            var response = ReportCost.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = ReportCost.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = ReportCost.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function ExportReportCosttoExcel(form) {
            var includeCost = vm.cost == true ? encodeURIComponent(window.btoa('1')) : encodeURIComponent(window.btoa('0'));
            var token = Auth.setTokenPromise();
            var startPeriod = encodeURIComponent(window.btoa(vm.startPeriod));
            var endPeriod = encodeURIComponent(window.btoa(vm.endPeriod));
            var company = encodeURIComponent(window.btoa(vm.company));
            var area = encodeURIComponent(window.btoa(vm.area));
            var division = encodeURIComponent(window.btoa(vm.division));
            var wilayah = encodeURIComponent(window.btoa(vm.wilayah));
            var regional = encodeURIComponent(window.btoa(vm.regional));
            var cabang = encodeURIComponent(window.btoa(vm.cabang));
            var action = encodeURIComponent(window.btoa('downloadData'));

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/reportcost/lgexportexcel/' + startPeriod + '/' + endPeriod + '/' + company + '/' + area + '/' + division + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + includeCost + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function viewReportCosttoExcel(form) {
            angular.element.blockUI();
            var includeCost = vm.cost == true ? encodeURIComponent(window.btoa('1')) : encodeURIComponent(window.btoa('0'));
            var token = Auth.setTokenPromise();
            var startPeriod = encodeURIComponent(window.btoa(vm.startPeriod));
            var endPeriod = encodeURIComponent(window.btoa(vm.endPeriod));
            var company = encodeURIComponent(window.btoa(vm.company));
            var area = encodeURIComponent(window.btoa(vm.area));
            var division = encodeURIComponent(window.btoa(vm.division));
            var wilayah = encodeURIComponent(window.btoa(vm.wilayah));
            var regional = encodeURIComponent(window.btoa(vm.regional));
            var cabang = encodeURIComponent(window.btoa(vm.cabang));
            var type = encodeURIComponent(window.btoa('downloadData'));

            var response = ReportCost.query({
                action: 'viewData',
                startPeriod: startPeriod,
                endPeriod: endPeriod,
                company: company,
                area: area,
                division: division,
                wilayah: wilayah,
                regional: regional,
                includeCost: includeCost,
                type: type,
                cabang: cabang
            });
            response.$promise.then(fetchData);
            response.$promise.catch(errorFetchData);
        }

        function fetchData(data) {
            angular.element.unblockUI();
            vm.listData = data;
        }

        function errorFetchData() {
            angular.element.unblockUI();
            vm.listData = [];
        }

        vm.selectArea = selectArea;
        function selectArea(area) {
            if (typeof area != "undefined" && area.indexOf(0) != -1) {
                if ((vm.listarea.length - 1) == area.length) {
                    var index = area.indexOf(0);
                    if (index > -1) {
                        vm.area.splice(index, 1);
                    }
                    vm.isAll = false;
                } else {
                    vm.isAll = true;
                    vm.area = [];
                    for (var i = 0; i <= (vm.listarea.length - 1); i++) {
                        vm.area.push(vm.listarea[i].id);
                    }
                }
            } else {
                if (vm.isAll) {
                    vm.area = [];
                    vm.isAll = false;
                } else if (typeof area != "undefined" && (vm.listarea.length - 1) == area.length) {
                    vm.area.push(0);
                    vm.isAll = true;
                }
            }
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-pma.report.rekapgaji', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) 
   {
   	 $stateProvider
        .state('app.payroll_rekapgaji_pma', {
            url    : '/payroll-pma/report/rekapgaji',
            views  : {
                'content@app' : {
                templateUrl: 'app/main/payroll-pma/report/rekapgaji/rekapgaji.html',
                controller : 'RekapGajipmaController as vm'
                }
            }
        });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-pma.report.rekapgaji')
        .controller('RekapGajipmaController', RekapGajipmaController);

    RekapGajipmaController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function RekapGajipmaController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window, $element) 
    {   
        var vm = this;
        var RekapGaji=AppAPI.RekapGajipma();
        vm.DataTable= new DataService();
        vm.LoadPeriod = LoadPeriod;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.ExportRekapGajitoExcel = ExportRekapGajitoExcel;

        vm.company = $localStorage.empsite;

        LoadPeriod();
        LoadCompany()
        LoadArea(vm.company);

        function LoadPeriod()
        {
          var response=RekapGaji.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
                vm.listperiod=data;
        }

        function errorFetchPeriod() {
                vm.listperiod=[];
        } 

        function LoadCompany() {
            var response=RekapGaji.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
                vm.listcompany=data;
        }

        function errorFetchCompany() {
                vm.listcompany=[];
        } 

        function LoadArea(company) {
            var response=RekapGaji.query({action:'getArea', companyid:company});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
                vm.listarea=data;
        }

        function errorFetchArea() {
                vm.listarea=[];
        }  
       
        function ExportRekapGajitoExcel(form) 
        {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var area = vm.area;
            
            token.then(function(data) 
            {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollpma/report/rekapgajipma/lgexportexcel/' + period  + '/' + company  + '/' + area + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-pma.report.laporanthr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payrollpma_laporanthr', {
                url    : '/payroll-pma/report/laporanthr',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-pma/report/laporanthr/laporanthr.html',
                    controller : 'LaporanTHRController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-pma.report.laporanthr')
        .controller('LaporanTHRController', LaporanTHRController);

    LaporanTHRController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function LaporanTHRController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

        var vm = this;
        var LaporanThr = AppAPI.LaporanThr();
        vm.DataTable = new DataService();
        vm.LoadPeriod = LoadPeriod;
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.ExportLaporanThrtoExcel = ExportLaporanThrtoExcel;

        vm.changeCompany = changeCompany;
        vm.company = $localStorage.empsite;

        LoadPeriod();
        LoadCompany()
        LoadArea(vm.company);

        function LoadPeriod() {
            var response = LaporanThr.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = LaporanThr.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = LaporanThr.query({ action: 'getSpecificArea', companyid: id })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadArea(company) {
            var response = LaporanThr.query({ action: 'getArea', companyid: company });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }


        function ExportLaporanThrtoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var area = vm.area;

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollpma/report/laporanthr/lgexportexcel/' + period + '/' + company + '/' + area + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-pma.report.laporangajidetail', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_laporangaji_detail_pma', {
                url    : '/payroll-pma/report/laporangajidetail',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-pma/report/laporangajidetail/laporangajidetail.html',
                    controller : 'LaporanGajiDetailpmaController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-pma.report.laporangajidetail')
        .controller('LaporanGajiDetailpmaController', LaporanGajiDetailpmaController);

    LaporanGajiDetailpmaController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function LaporanGajiDetailpmaController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window, $element) {
       
       var vm = this;
       var LaporanGaji=AppAPI.LaporanGajiDetailpma();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

       vm.changeCompany = changeCompany;
       vm.company = $localStorage.empsite;

       LoadPeriod();
       LoadCompany()
       LoadArea(vm.company);

      function LoadPeriod() 
      {
          var response=LaporanGaji.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanGaji.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
             vm.listarea=[];
             var resp=LaporanGaji.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadArea(company) {
          var response=LaporanGaji.query({action:'getArea', companyid:company});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function ExportLaporanGajitoExcel(form) 
       {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var area = vm.area;
            
            token.then(function(data) 
            {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/payrollpma/report/laporangajidetailpma/lgexportexcel/' + period  + '/' + company  + '/' + area + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-pma.report.laporangaji', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_laporangaji_pma', {
                url    : '/payroll-pma/report/laporangaji',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-pma/report/laporangaji/laporangaji.html',
                    controller : 'LaporanGajipmaController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-pma.report.laporangaji')
        .controller('LaporanGajipmaController', LaporanGajipmaController);

    LaporanGajipmaController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window','$element'];

    /* @ngInject */
    function LaporanGajipmaController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window,$element) {
       
       var vm = this;
       var LaporanGaji=AppAPI.LaporanGajipma();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

       vm.changeCompany = changeCompany;
       vm.company = $localStorage.empsite;

       LoadPeriod();
       LoadCompany()
       LoadDivisi(vm.company);
       LoadArea(vm.company);

      function LoadPeriod() {
          var response=LaporanGaji.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanGaji.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
             vm.listarea=[];
             var resp=LaporanGaji.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadDepartment(company,divisi) {
        var response=LaporanGaji.query({action:'getDepartment', idbu:company, iddivisi:divisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       

       function LoadArea(company) {
          var response=LaporanGaji.query({action:'getArea', companyid:company});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  

       function LoadDivisi(companyid) {
            var response=LaporanGaji.query({action:'getDivisi', idbu:companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid,vm.divisi);
            LoadArea(companyid);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 
       
       function ExportLaporanGajitoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var department = vm.department;
            var area = vm.area;
            var divisi = vm.divisi;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/payrollpma/report/laporangajipma/lgexportexcel/' + period  + '/' + company  + '/' + divisi + '/' + department  + '/' + area + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-pma.report.jurnalgaji', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_jurnalgaji_pma', {
                url    : '/payroll-pma/report/jurnalgaji',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-pma/report/jurnalgaji/jurnalgaji.html',
                    controller : 'JurnalGajipmaController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-pma.report.jurnalgaji')
        .controller('JurnalGajipmaController', JurnalGajipmaController);

    JurnalGajipmaController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function JurnalGajipmaController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window, $element) {
       
       var vm = this;
       var JurnalGaji=AppAPI.JurnalGajipma();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportJurnalGajitoExcel = ExportJurnalGajitoExcel;

       vm.company = $localStorage.empsite;

       LoadPeriod();
       LoadCompany()
       LoadArea(vm.company);

      function LoadPeriod() 
      {
          var response=JurnalGaji.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=JurnalGaji.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function LoadArea(company) {
          var response=JurnalGaji.query({action:'getArea', companyid:company});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function ExportJurnalGajitoExcel(form) 
       {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            var company = vm.company;
            var area = vm.area;
            
            token.then(function(data) 
            {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollpma/report/jurnalgajipma/lgexportexcel/' + period  + '/' + company  + '/' + area + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    "use strict";
    /**
     *  Module
     *
     * Description
     */
    angular.module('app.payroll-pma.report.estimasigaji', []).config(config);

    config.$inject = ['$stateProvider'];


    function config($stateProvider) {

        $stateProvider
            .state('app.payroll_estimasigaji', {
                url: '/payroll/report/estimasi-gaji',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/payroll-pma/report/estimasigaji/estimasigaji.html',
                        controller: 'EstimasiGajiController as vm'
                    }
                }

            });
    }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-pma.report.estimasigaji')
        .controller('EstimasiGajiController', EstimasiGajiController);

    EstimasiGajiController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function EstimasiGajiController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window, $element) {

        var vm = this;
        var EstimasiGaji = AppAPI.EstimasiGaji();
        vm.DataTable = new DataService();
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.LoadSpecificArea = LoadSpecificArea;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.ExportEstimasiGajitoExcel = ExportEstimasiGajitoExcel;

        vm.company = $localStorage.empsite;
        vm.LoadRegional = loadRegional;
        vm.LoadCabang = loadCabang;
        vm.LoadWilayah = loadWilayah;
        vm.setFilter = setFilter;

        vm.filterType = 'by_date';

        vm.reqWil = false;
        vm.reqArea = true;

        vm.listfilterType = [
            {
                'id': 'by_date',
                'name': 'By Date',
            },
            {
                'id': 'by_period',
                'name': 'By Period',
            }
        ];

        LoadCompany();
        loadWilayah();
        LoadAreaDefault(vm.company);
        LoadPeriod();

        function setFilter() {
            if (vm.filterType == 'by_date') {
                vm.period = "undefined"
            } else {
                vm.date = "NaN-NaN-NaN-"
            }
        }

        function LoadPeriod() {
            var response = EstimasiGaji.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listPeriod = data;
        }

        function errorFetchPeriod() {
            vm.listPeriod = [];
        }

        function LoadCompany() {
            var response = EstimasiGaji.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadSpecificArea(company, cabangid) {
            var response = EstimasiGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function LoadArea(company, cabangid) {
            loadWilayah();
            vm.listRegional = [];
            vm.listCabang = [];
            var response = EstimasiGaji.query({ action: 'getArea', companyid: company, cabangid: cabangid });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadAreaDefault(company) {
            var response = EstimasiGaji.query({ action: 'getArea', companyid: company });
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

        function fetchAreaDefault(data) {
            vm.listarea = data;
        }

        function errorFetchAreaDefault() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = EstimasiGaji.query({ action: 'getWilayah', companyid: vm.company });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = EstimasiGaji.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = EstimasiGaji.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function ExportEstimasiGajitoExcel(form) {
            var token = Auth.setTokenPromise();
            var company = vm.company;
            var area = vm.area;

            var dt = new Date(vm.date);
            var dtM = (dt.getMonth() + 1);
            var dtD = dt.getDate();
            if (dtM < 10) {
                dtM = '0' + dtM
            }
            if (dtD < 10) {
                dtD = '0' + dtD;
            }

            var newdate = dt.getFullYear() + '-' + dtM + '-' + dtD;

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/estimasigaji/lgexportexcel/' + newdate + '/' + company + '/' + area + '/' + vm.wilayah + '/' + vm.regional + '/' + vm.cabang + '/' + vm.period + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-pma.report.banktransferthr', []).config(config);

   config.$inject=['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
    .state('app.payroll_bank_transferthr_pma', {
      url    : '/payroll-pma/report/banktransfer-thr',
      views  : {
        'content@app' : {
          templateUrl: 'app/main/payroll-pma/report/banktransferthr/banktransferthr.html',
          controller : 'BanktransferthrpmaController as vm'
        }
      }
    });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-pma.report.banktransferthr')
        .controller('BanktransferthrpmaController', BanktransferthrpmaController);

    BanktransferthrpmaController.$inject = ['$localStorage', '$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function BanktransferthrpmaController($localStorage, $state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, $document, $location, $window, $element) {

        var vm = this;
        var dt = new Date();
        var year = dt.getFullYear();
        var Banktransfer = AppAPI.Banktransferthrpma();

        vm.LoadPeriod = LoadPeriod;
        vm.LoadSBU = LoadSBU;
        vm.LoadCompany = LoadCompany;
        vm.ExportBankTransfertoExcel = ExportBankTransfertoExcel;
        vm.company = $localStorage.empsite;
        LoadPeriod();
        LoadCompany();
        LoadSBU(vm.company);

        function LoadPeriod() {
            var response = Banktransfer.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadSBU(companyId) {
            var response = Banktransfer.query({ action: 'getSBU', companyid: companyId });
            response.$promise.then(fetchSBU);
            response.$promise.catch(errorFetchSBU);
        }

        function fetchSBU(data) {
            vm.listSBU = data;
        }

        function errorFetchSBU() {
            vm.listSBU = [];
        }

        function LoadCompany() {
            var response = Banktransfer.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function ExportBankTransfertoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.Form.objForm.period;
            var SBU = vm.Form.objForm.SBU;

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollpma/report/banktransferthrpma/lbtexportexcel/' + period + '/' + SBU + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-pma.report.banktransfer', []).config(config);

   config.$inject=['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
    .state('app.payroll_bank_transfer_pma', {
      url    : '/payroll-pma/report/banktransfer',
      views  : {
        'content@app' : {
          templateUrl: 'app/main/payroll-pma/report/banktransfer/banktransfer.html',
          controller : 'BanktransferpmaController as vm'
        }
      }
    });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-pma.report.banktransfer')
        .controller('BanktransferpmaController', BanktransferpmaController);

    BanktransferpmaController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','$document', '$location', '$window', '$element'];

    /* @ngInject */
    function BanktransferpmaController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,$document,$location,$window,$element) {
       
       var vm = this;
       var dt = new Date();
       var year = dt.getFullYear();
       var Banktransfer=AppAPI.Banktransferpma();

       vm.LoadPeriod    = LoadPeriod;
       vm.LoadSBU       = LoadSBU;       
       vm.LoadCompany   = LoadCompany;
       vm.ExportBankTransfertoExcel = ExportBankTransfertoExcel;
       vm.company = $localStorage.empsite;
      LoadPeriod();
      LoadCompany();
      LoadSBU(vm.company);

      function LoadPeriod() {
          var response=Banktransfer.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadSBU(companyId) {
          var response=Banktransfer.query({action:'getSBU',companyid:companyId});
          response.$promise.then(fetchSBU);
          response.$promise.catch(errorFetchSBU);
       }

       function fetchSBU(data) {
            vm.listSBU=data;
       }

       function errorFetchSBU() {
            vm.listSBU=[];
       } 
       
       function LoadCompany() {
            var response=Banktransfer.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany=data;
        }

        function errorFetchCompany() {
            vm.listcompany=[];
        }
        
       function ExportBankTransfertoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.Form.objForm.period;
            var SBU = vm.Form.objForm.SBU;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/payrollpma/report/banktransferpma/lbtexportexcel/' + period  + '/' + SBU  +  '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.sapreport', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_sapreport', {
                url    : '/payroll/report/sapreport',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/sapreport/sapreport.html',
                    controller : 'SAPReportController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.sapreport')
        .controller('SAPReportController', SAPReportController);

    SAPReportController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function SAPReportController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var SAPReport=AppAPI.SAPReport();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadDivisi = LoadDivisi;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportSAPReporttoExcel = ExportSAPReporttoExcel;

      LoadPeriod();
      LoadCompany();
      LoadDivisi();

      function LoadPeriod() {
          var response=SAPReport.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=SAPReport.query({action:'getCompany', company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function LoadDivisi() {
            var response=SAPReport.query({action:'getDivisi'});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 
       
       function ExportSAPReporttoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            var divisi = vm.Form.objForm.divisi;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/sapreport/exportexcel/' + period  + '/' + company  + '/' + divisi  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.perubahanupah', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_perubahanupah', {
                url    : '/payroll/report/perubahanupah',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/perubahanupah/perubahanupah.html',
                    controller : 'LaporanPerubahanUpahController as vm'
                    }
                }
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.perubahanupah')
        .controller('LaporanPerubahanUpahController', LaporanPerubahanUpahController);

    LaporanPerubahanUpahController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function LaporanPerubahanUpahController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var PerubahanUpah=AppAPI.PerubahanUpah();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanDetailBPJStoExcel = ExportLaporanDetailBPJStoExcel;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=PerubahanUpah.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=PerubahanUpah.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportLaporanDetailBPJStoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            var department = vm.Form.objForm.department;
            var area = vm.Form.objForm.area;

            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanbpjstk/puexportexcel/' + period  + '/' + company  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.laporanbpjstk', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_detailbpjs', {
                url    : '/payroll/report/laporanbpjstk',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/laporanbpjstk/laporanbpjstk.html',
                    controller : 'LaporanBpjsTkController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.laporanbpjstk')
        .controller('LaporanPerubahanGajiController', LaporanPerubahanGajiController);

    LaporanPerubahanGajiController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function LaporanPerubahanGajiController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var PerubahanGaji=AppAPI.PerubahanGaji();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportPerubahanGajitoExcel = ExportPerubahanGajitoExcel;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=PerubahanGaji.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=PerubahanGaji.query({action:'getCompany', company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportPerubahanGajitoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanbpjskes/pgexportexcel/' + period  + '/' + company  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.pendaftaranbpjs', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_daftarbpjs', {
                url    : '/payroll/report/pendaftaranbpjs',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/pendaftaranbpjs/pendaftaranbpjs.html',
                    controller : 'PendaftaranBpjsController as vm'
                    }
                }
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.pendaftaranbpjs')
        .controller('PendaftaranBpjsController', PendaftaranBpjsController);

    PendaftaranBpjsController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function PendaftaranBpjsController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var PendaftaranBpjs=AppAPI.PendaftaranBpjs();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportPendaftaranBpjstoExcel = ExportPendaftaranBpjstoExcel;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=PendaftaranBpjs.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=PendaftaranBpjs.query({action:'getCompany', company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportPendaftaranBpjstoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            var department = vm.Form.objForm.department;
            var area = vm.Form.objForm.area;

            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanbpjstk/regbpjsexportexcel/' + period  + '/' + company  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.payslip', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_payslip', {
                url    : '/payroll/report/payslip',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/payslip/payslip.html',
                    controller : 'PayslipController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.payslip')
        .controller('PayslipController', PayslipController);

    PayslipController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window','$http', 'Form'];

    /* @ngInject */
    function PayslipController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window, $http, Form) {
       
       var vm = this;

       Form.initialForm();

       var Payslip=AppAPI.Payslip();

       Form.setObject(Payslip);

       vm.Form = Form; 

       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportPaysliptoPdf = ExportPaysliptoPdf;
       
       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;     
       vm.Form.objForm.empno = '';

      LoadPeriod();
      LoadDepartment();
      LoadCompany();
      LoadArea();

      function selectedItemChanged(employee)
      {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;

              }
              
           console.log(vm.Form.objForm.empno);
      }

      function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/report/payslip?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
      }

      function LoadPeriod() {
          var response=Payslip.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=Payslip.query({action:'getCompany', company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function LoadDepartment() {
          var response=Payslip.query({action:'getDepartment'});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       

       function LoadArea(companyid) {
          var response=Payslip.query({action:'getArea', companyid:companyid});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }   
       
       function ExportPaysliptoPdf(ev,formController) {
            var token = Auth.setTokenPromise();
            var empno = "undefined";
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            var department = vm.Form.objForm.department;
            var area = vm.Form.objForm.area;
            if(vm.Form.objForm.empno != '')
               empno = vm.Form.objForm.empno;//vm.empno;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/payslip/exportpdf/' + period + '/' + company + '/' + department + '/' + area + '/' + empno + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.nonaktif', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_nonaktif', {
                url    : '/payroll/report/nonaktif',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/nonaktif/nonaktif.html',
                    controller : 'LaporanNonAktifontroller as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.nonaktif')
        .controller('LaporanNonAktifontroller', LaporanNonAktifontroller);

    LaporanNonAktifontroller.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function LaporanNonAktifontroller($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var NonAktif=AppAPI.NonAktif();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportNonAktiftoExcel = ExportNonAktiftoExcel;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=NonAktif.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=NonAktif.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportNonAktiftoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanbpjskes/naexportexcel/' + period  + '/' + company  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.laporanpajaka1', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_laporanpajak1721a1', {
                url    : '/payroll/report/laporanpajaka1',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/laporanpajaka1/laporanpajaka1.html',
                    controller : 'LaporanPajakA1Controller as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.laporanpajaka1')
        .controller('LaporanPajakA1Controller', LaporanPajakA1Controller);

    LaporanPajakA1Controller.$inject = ['$localStorage','AppAPI','$mdDialog', 'Form', 'Auth', '$location', '$window', 'config', '$http'];

    /* @ngInject */
    function LaporanPajakA1Controller($localStorage,AppAPI,$mdDialog, Form, Auth, $location, $window, config, $http) {
       
       var vm = this;
       Form.initialForm();

       var LaporanPajakA1=AppAPI.LaporanPajakA1();

       Form.setObject(LaporanPajakA1);

       vm.Form = Form; 

       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.LoadKPP = LoadKPP;

       vm.changeCompany = changeCompany;
       vm.ExportLaporantoExcel = ExportLaporantoExcel;
       
       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;     
       vm.Form.objForm.empno = '';

       LoadPeriod();
       //LoadDepartment();
       LoadCompany();
       //LoadArea();
       //LoadDivisi();
       LoadKPP();

       function selectedItemChanged(employee)
      {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;

              }
              
           console.log(vm.Form.objForm.empno);
      }

      function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/report/laporanpajak?action=searchEmployee&id=' + searchText)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
      }

       function LoadPeriod() {
          var response=LaporanPajakA1.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanPajakA1.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function LoadDepartment() {
          var response=LaporanPajakA1.query({action:'getDepartment'});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       

       function LoadArea() {
          var response=LaporanPajakA1.query({action:'getArea'});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }   

        function changeCompany(id)
       { 
            console.log(id);
             vm.listarea=[];
             var resp=LaporanPajakA1.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadDivisi() {
            var response=LaporanPajakA1.query({action:'getDivisi'});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 

       function LoadKPP() {
          var response=LaporanPajakA1.query({action:'getKPP'});
          response.$promise.then(fetchKPP);
          response.$promise.catch(errorFetchKPP);
       }

       function fetchKPP(data) {
            vm.listkpp=data;
       }

       function errorFetchKPP() {
            vm.listkpp=[];
       }   

       function ExportLaporantoExcel(form) {
            var token = Auth.setTokenPromise();
            //var empno = "undefined";
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            var kpp = vm.Form.objForm.kpp;
            /*var divisi = vm.Form.objForm.divisi;
            var department = vm.Form.objForm.department;
            var area = vm.Form.objForm.area;
            if(vm.Form.objForm.empno != '')
               empno = vm.Form.objForm.empno;//vm.empno;
            */
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanpajak/lpa1exportexcel/' +  period  + '/' + company  + '/' + kpp  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });;
      }
            

       
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.laporanpajak', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_laporanpajak1721', {
                url    : '/payroll/report/laporanpajak',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/laporanpajak/laporanpajak.html',
                    controller : 'LaporanPajakController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.laporanpajak')
        .controller('LaporanPajakController', LaporanPajakController);

    LaporanPajakController.$inject = ['$localStorage','AppAPI','$mdDialog', 'Form', 'Auth', '$location', '$window', 'config', '$http'];

    /* @ngInject */
    function LaporanPajakController($localStorage,AppAPI,$mdDialog, Form, Auth, $location, $window, config, $http) {
       
       var vm = this;
       Form.initialForm();

       var LaporanPajak=AppAPI.LaporanPajak();

       Form.setObject(LaporanPajak);

       vm.Form = Form; 

       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.LoadKPP = LoadKPP;

       vm.changeCompany = changeCompany;
       vm.ExportLaporantoExcel = ExportLaporantoExcel;
      
       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;     
       vm.Form.objForm.empno = '';

       LoadPeriod();
       //LoadDepartment();
       LoadCompany();
       //LoadArea();
       //LoadDivisi();
       LoadKPP();

       function selectedItemChanged(employee)
      {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;

              }
              
           console.log(vm.Form.objForm.empno);
      }

      function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/report/laporanpajak?action=searchEmployee&id=' + searchText)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
      }

       function LoadPeriod() {
          var response=LaporanPajak.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanPajak.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function LoadDepartment() {
          var response=LaporanPajak.query({action:'getDepartment'});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       

       function LoadArea() {
          var response=LaporanPajak.query({action:'getArea'});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }   
       
       function changeCompany(id)
       { 
            console.log(id);
             vm.listarea=[];
             var resp=LaporanPajak.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadKPP() {
          var response=LaporanPajak.query({action:'getKPP'});
          response.$promise.then(fetchKPP);
          response.$promise.catch(errorFetchKPP);
       }

       function fetchKPP(data) {
            vm.listtaxloc=data;
       }

       function errorFetchKPP() {
            vm.listtaxloc=[];
       }   
       

       function LoadDivisi() {
            var response=LaporanPajak.query({action:'getDivisi'});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 

       function ExportLaporantoExcel(form) {
            var token = Auth.setTokenPromise();
            //var empno = "undefined";
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            var kpp = vm.Form.objForm.kpp;
            /*var divisi = vm.Form.objForm.divisi;
            var department = vm.Form.objForm.department;
            var area = vm.Form.objForm.area;
            if(vm.Form.objForm.empno != '')
               empno = vm.Form.objForm.empno;//vm.empno;
            */
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanpajak/lpexportexcel/' +  period  + '/' + company  + '/' + kpp  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
      }
            

       
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.laporanlembur', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_laporanlembur', {
                url    : '/payroll/report/laporanlembur',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/laporanlembur/laporanlembur.html',
                    controller : 'LaporanLemburController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.laporanlembur')
        .controller('LaporanLemburController', LaporanLemburController);

    LaporanLemburController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function LaporanLemburController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var LaporanLembur=AppAPI.LaporanLembur();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.ExportLaporantoExcel = ExportLaporantoExcel;
       
      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=LaporanLembur.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

      function LoadCompany() {
          var response=LaporanLembur.query({action:'getCompany', company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

      function ExportLaporantoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            /*var department = vm.Form.objForm.department;
            var area = vm.Form.objForm.area;*/

            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanlembur/exportexcel/' + period  + '/' + company + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }

       
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.laporangaji', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_laporangaji', {
                url    : '/payroll/report/laporangaji',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/laporangaji/laporangaji.html',
                    controller : 'LaporanGajiController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.laporangaji')
        .controller('LaporanGajiController', LaporanGajiController);

    LaporanGajiController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function LaporanGajiController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var LaporanGaji=AppAPI.LaporanGaji();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanGajitoExcel = ExportLaporanGajitoExcel;

       vm.changeCompany = changeCompany;

       LoadPeriod();
       LoadDepartment();
       LoadCompany();
       LoadArea();
       LoadDivisi();

      function LoadPeriod() {
          var response=LaporanGaji.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanGaji.query({action:'getCompany', company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
            console.log(id);
             vm.listarea=[];
             var resp=LaporanGaji.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadDepartment(iddivisi) {
          var response=LaporanGaji.query({action:'getDepartment', idbu:$localStorage.empsite, iddivisi:iddivisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }      
       

       function LoadArea() {
          //console.log(companyid);
          var response=LaporanGaji.query({action:'getArea', companyid:$localStorage.empsite});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  

       function LoadDivisi(companyid) {
            var response=LaporanGaji.query({action:'getDivisi', idbu:companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 
       
       function ExportLaporanGajitoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            var department = vm.Form.objForm.department;
            var area = vm.Form.objForm.area;
            var divisi = vm.Form.objForm.divisi;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                console.log(host);
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporangaji/lgexportexcel/' + period  + '/' + company  + '/' + divisi + '/' + department  + '/' + area + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.report.laporanbpjstk')
        .controller('LaporanBpjsTkController', LaporanBpjsTkController);

    LaporanBpjsTkController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function LaporanBpjsTkController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var LaporanBpjsTk=AppAPI.LaporanBpjsTk();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportLaporanDetailBPJStoExcel = ExportLaporanDetailBPJStoExcel;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=LaporanBpjsTk.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=LaporanBpjsTk.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportLaporanDetailBPJStoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            var department = vm.Form.objForm.department;
            var area = vm.Form.objForm.area;

            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanbpjstk/exportexcel/' + period  + '/' + company  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.report.laporanbpjstk')
        .controller('LaporanKeluarBpjsController', LaporanKeluarBpjsController);

    LaporanKeluarBpjsController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function LaporanKeluarBpjsController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var KeluarBpjs=AppAPI.KeluarBpjs();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportKeluarBPJStoExcel = ExportKeluarBPJStoExcel;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=KeluarBpjs.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=KeluarBpjs.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportKeluarBPJStoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanbpjstk/bkexportexcel/' + period  + '/' + company  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.gajicostcentre', []).config(config);

   config.$inject=['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
    .state('app.payroll_gajicostcentre', {
      url    : '/payroll/report/gajicostcentre',
      views  : {
        'content@app' : {
          templateUrl: 'app/main/payroll/report/gajicostcentre/gajicostcentre.html',
          controller : 'GajiCostCentreController as vm'
        }
      }
    });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.gajicostcentre')
        .controller('GajiCostCentreController', GajiCostCentreController);

    GajiCostCentreController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','$document', '$location', '$window'];

    /* @ngInject */
    function GajiCostCentreController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,$document,$location,$window) {
       
       var vm = this;
       var dt = new Date();
       var year = dt.getFullYear();
       var GajiCostCentre =AppAPI.GajiCostCentre();

       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;        
       vm.ExporttoExcel = ExporttoExcel;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=GajiCostCentre.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=GajiCostCentre.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 
       
       function ExporttoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/gajicostcentre/exportexcel/' + period  + '/' + company  +  '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.report.laporanbpjstk')
        .controller('FormulirBpjsController', FormulirBpjsController);

    FormulirBpjsController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function FormulirBpjsController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var FormulirBpjs=AppAPI.FormulirBpjs();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportFormulirBPJStoExcel = ExportFormulirBPJStoExcel;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=FormulirBpjs.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=FormulirBpjs.query({action:'getCompany', company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportFormulirBPJStoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanbpjstk/fbexportpdf/' + period  + '/' + company  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.espttax', []).config(config);

   config.$inject=['$stateProvider'];

	function config($stateProvider) {
		$stateProvider
		.state('app.payroll_espttax', {
			url    : '/payroll/report/espttax',
			views  : {
				'content@app' : {
					templateUrl: 'app/main/payroll/report/espttax/espttax.html',
					controller : 'EspttaxController as vm'
				}
			}
		});
   }
}());
(function() {
	'use strict';
	
	angular
	.module('app.payroll.report.espttax')
	.controller('EspttaxController', EspttaxController);
	
	EspttaxController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','$document', '$location', '$window'];
	
	/* @ngInject */
	function EspttaxController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,$document,$location,$window){
		var vm = this;
		//var dt = new Date();
		//var year = dt.getFullYear();
		var Espttax=AppAPI.Espttax();
		//vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];
		vm.ExportEsptTaxtoExcel = ExportEsptTaxtoExcel;
		
		vm.LoadPeriod = LoadPeriod;
		vm.LoadCompany = LoadCompany;  
		
		LoadPeriod();
		LoadCompany();
		
		function LoadPeriod() {
			var response=Espttax.query({action:'getPeriod'});
			response.$promise.then(fetchPeriod);
			response.$promise.catch(errorFetchPeriod);
		}
		
		function fetchPeriod(data) {
			vm.listperiod=data;
		}
		
		function errorFetchPeriod() {
			vm.listperiod=[];
		} 
		
		function LoadCompany() {
			var response=Espttax.query({action:'getCompany',company:$localStorage.empsite});
			response.$promise.then(fetchCompany);
			response.$promise.catch(errorFetchCompany);
		}
		
		function fetchCompany(data) {
            vm.listcompany=data;
		}
		
		function errorFetchCompany() {
			vm.listcompany=[];
		}
		
		function ExportEsptTaxtoExcel(form) {
			var token = Auth.setTokenPromise();
			var period = vm.Form.objForm.period;
			var company = vm.Form.objForm.company;
			
			token.then(function(data) {
				var protocol = $location.protocol();
				var host = $location.host();
				$window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/espttax/lgexportexcel/' + period  + '/' +  company + '/' + data.token, '_blank');
				console.log(config.api);
			}, function() {
				$window.alert('gagal load token')
			});
        }
	}
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.daftarmutasi', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_daftarmutasi', {
                url    : '/payroll/report/daftarmutasi',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/daftarmutasi/daftarmutasi.html',
                    controller : 'LaporanDaftarMutasiController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.daftarmutasi')
        .controller('LaporanDaftarMutasiController', LaporanDaftarMutasiController);

    LaporanDaftarMutasiController.$inject = ['$state','$localStorage','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window'];

    /* @ngInject */
    function LaporanDaftarMutasiController($state,$localStorage,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window) {
       
       var vm = this;
       var DaftarMutasi=AppAPI.DaftarMutasi();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExportDaftarMutasitoExcel = ExportDaftarMutasitoExcel;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=DaftarMutasi.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=DaftarMutasi.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       
       function ExportDaftarMutasitoExcel(form) {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/laporanbpjskes/dmexportexcel/' + period  + '/' + company  + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.banktransfer', []).config(config);

   config.$inject=['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
    .state('app.payroll_banktransfer', {
      url    : '/payroll/report/banktransfer',
      views  : {
        'content@app' : {
          templateUrl: 'app/main/payroll/report/banktransfer/banktransfer.html',
          controller : 'BanktransferController as vm'
        }
      }
    });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.banktransfer')
        .controller('BanktransferController', BanktransferController);

    BanktransferController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','$document', '$location', '$window'];

    /* @ngInject */
    function BanktransferController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,$document,$location,$window) {
       
       var vm = this;
       var dt = new Date();
       var year = dt.getFullYear();
       var Banktransfer=AppAPI.Banktransfer();

       vm.LoadPeriod = LoadPeriod;
       vm.LoadSBU = LoadSBU;        
       vm.ExportBankTransfertoExcel = ExportBankTransfertoExcel;

      LoadPeriod();
      LoadSBU();

      function LoadPeriod() {
          var response=Banktransfer.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadSBU() {
          var response=Banktransfer.query({action:'getSBU'});
          response.$promise.then(fetchSBU);
          response.$promise.catch(errorFetchSBU);
       }

       function fetchSBU(data) {
            vm.listSBU=data;
       }

       function errorFetchSBU() {
            vm.listSBU=[];
       } 
       
       function ExportBankTransfertoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.Form.objForm.period;
            var SBU = vm.Form.objForm.SBU;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/banktransfer/lbtexportexcel/' + period  + '/' + SBU  +  '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.analisacostcentre', []).config(config);

   config.$inject=['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
    .state('app.payroll_analisacostcentre', {
      url    : '/payroll/report/analisacostcentre',
      views  : {
        'content@app' : {
          templateUrl: 'app/main/payroll/report/analisacostcentre/analisacostcentre.html',
          controller : 'AnalisaCostCentreController as vm'
        }
      }
    });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.report.analisacostcentre')
        .controller('AnalisaCostCentreController', AnalisaCostCentreController);

    AnalisaCostCentreController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','$document', '$location', '$window'];

    /* @ngInject */
    function AnalisaCostCentreController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,$document,$location,$window) {
       
       var vm = this;
       var dt = new Date();
       var year = dt.getFullYear();
       var AnalisaCostCentre =AppAPI.AnalisaCostCentre();

       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;        
       vm.ExporttoExcel = ExporttoExcel;

      LoadPeriod();
      LoadCompany();

      function LoadPeriod() {
          var response=AnalisaCostCentre.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=AnalisaCostCentre.query({action:'getCompany',company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 
       
       function ExporttoExcel(form) {
            var token = Auth.setTokenPromise();
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.company;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/report/analisacostcentre/exportexcel/' + period  + '/' + company  +  '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.payroll.laporanprosespayroll.payrolldetails', [])
        .config(config);

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
        // State 
        $stateProvider
        .state('app.payroll_details', {
            url    : '/payroll/laporanprosespayroll/payrolldetails/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/payroll/laporanprosespayroll/payrolldetails/payrolldetails.html',
                    controller : 'SetPayrollDetailController as vm'
                }
            }
        });   
                
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.laporanprosespayroll.payrolldetails')
        .controller('SetPayrollDetailController', SetPayrollDetailController);

    SetPayrollDetailController.$inject = ['DataService','$state','$mdDialog','$mdToast','$localStorage','$window','AppAPI','Auth','Form','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function SetPayrollDetailController(DataService,$state,$mdDialog,$mdToast,$localStorage,$window,AppAPI,Auth,Form,DTColumnDefBuilder,$timeout,$stateParams) {
          var vm = this;
          var str = $stateParams.id.split("#");
          vm.nik = str[0];//$stateParams.id;
          vm.period = str[1];//$stateParams.id[1];
          vm.payrollview = {};
          var Laporanprosespayroll= AppAPI.LaporanProsesPayroll();

          Form.initialForm();

          // set constructor form
          Form.setObject(Laporanprosespayroll);

          // set form to controller
          vm.Form = Form; 
          vm.setToken=Auth.setToken;
          
          loadData();
          

          function loadData() {
           angular.element.blockUI();
           var promises = Laporanprosespayroll.query({action:'viewdetail',id:vm.nik, period: vm.period});
           promises.$promise.then(fetchPayrollData);
           promises.$promise.catch(errorPayrollFetch); 
          }

          function fetchPayrollData(data) {

              vm.payrollview = data; 
                           
          }

          function errorPayrollFetch() {

              vm.payrollview = {};
              angular.element.unblockUI();
          }

        
    }
})();
(function () {
  'use strict';

  angular
    .module('app.offboarding.form_registration', [])
    .config(config);

  config.$inject = ['$stateProvider', '$mdThemingProvider'];

  function config($stateProvider) {
    
    /** @ngInject */
    $stateProvider
      .state('app.input_employee_ofb_registration', {
        url: '/offboarding/registration/input-employee',
        views: {
          'content@app': {
            templateUrl: 'app/main/offboarding/registration/form-registration/form-employee-registration.html',
            controller: 'InputEmployeeRegistrationController as vm'
          }
        }
      })

      .state('app.input_ofb_registration_n1', {
        url: '/offboarding/registration/input-n1',
        views: {
          'content@app': {
            templateUrl: 'app/main/offboarding/registration/form-registration/form-registration.html',
            controller: 'InputRegistrationN1Controller as vm'
          }
        }
      })

      .state('app.input_ofb_registration', {
        url: '/offboarding/registration/input',
        views: {
          'content@app': {
            templateUrl: 'app/main/offboarding/registration/form-registration/form-registration.html',
            controller: 'InputRegistrationController as vm'
          }
        }
      })      

      .state('app.edit_ofb_registration', {
        url: '/offboarding/registration/edit/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/offboarding/registration/form-registration/form-registration.html',
            controller: 'EditRegistrationController as vm'
          }
        }
      });
      
  }
})();
(function () {
    'use strict';
    angular
        .module('app.offboarding.form_registration')
        .controller('InputRegistrationController', InputRegistrationController);

    InputRegistrationController.$inject = ['$localStorage', '$http', '$timeout', 'Form', 'AppAPI', 'FileUploader', 'config', 'Auth', 'DataService'];

    function InputRegistrationController($localStorage, $http, $timeout, Form, AppAPI, FileUploader, config, Auth, DataService) {
        var vm = this;
        var OfbRegistration = AppAPI.OfbRegistration();
        var Attendance = AppAPI.Attendance();
        vm.DataTable = new DataService();
        vm.reason = ["Resign",
            "End of Contract (Voluntary)",
            "End of Contract (Non Voluntary)",
            "Dismissal / Head Count Reduction",
            "Low Performance",
            "Transfer / Demotion / Promotion",
            "Termination",
            "Pass Away",
            "Exit Without Notice",
            "Retire",
            "Long Personal Leave",
            "Divesture"
        ];
        vm.searchText = {
            'employee': null
        };
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.reloadToken = reloadToken;
        Form.initialForm();
        Form.setObject(OfbRegistration);
        vm.Form = Form;
        vm.saveData = saveData;
        vm.selectedItemChange = selectedItemChange;
        vm.querySearchEmployee = querySearchEmployee;

        vm.company = $localStorage.empsite;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadEmployee = loadEmployee;
        vm.Form.objForm.tipe = 2;
        vm.clearMeesage = clearMeesage;
        vm.type = "admin";

        vm.listNik = [];
        vm.listEmployee = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        loadCompany();

        function reloadToken() {
            Auth.setToken();
        }

        function saveData(ev, formController) {
            angular.forEach(vm.listEmployee, function (value) {
                vm.listNik.push(value.nik);
            });

            vm.Form.objForm.effectiveDate = new Date(formController.effectiveDate.$viewValue);

            vm.Form.objForm.nik = vm.listEmployee;
            var promise = Form.saveData('save', formController, OfbRegistration);
            angular.element.blockUI(); //munculin loading please wait
            promise.then(function () {
                vm.uploader.uploadAll();

                vm.messageTheme = 'blue';
                angular.element.unblockUI();
                formController.$setPristine();

                $timeout(function () {
                    vm.Form.tampilPesan = false;
                }, 3000);

                vm.nama = "";
                vm.effectiveDate = "";
                vm.emp_category = "";
                vm.emp_grade = "";
                vm.job_title = "";
            });

            promise.catch(function () {
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            });
        }

        var uploader = vm.uploader = new FileUploader({
            url: config.api + 'api/ofb/registration/uploadDokumenMasal',
            removeAfterUpload: true,
            alias: 'SPD',
        });

        // an async filter
        uploader.filters.push({
            name: 'asyncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options, deferred) {
                setTimeout(deferred.resolve, 1e3);
            }
        });

        uploader.filters.push({
            name: 'syncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function querySearchEmployee(query) {
            return $http
                .get(config.api + 'api/ofb/registration?action=getListEmployee&search=' + query)
                .then(function (item) {
                    if (item.data.length === 0) {
                        vm.searchText.employee = query;
                    }
                    return item.data;
                });
        }

        function selectedItemChange(item) {
            if (item) {
                vm.nama = item.name;
                vm.Form.objForm.nik = item.nik;
                var response = OfbRegistration.query({
                    action: 'getEmpJob',
                    empId: item.emp_profile_id,
                    offset: 0,
                    jumPage: 1,
                    search: ""
                });
                response.$promise.then(jobInfo);
            }
        }

        function jobInfo(param) {
            vm.Form.objForm.direct_report = param[0].direct_report;
            vm.effectiveDate = param[0].effective_date;
            vm.emp_category = param[0].emp_category;
            vm.job_title = param[0].job_title;
            vm.Form.objForm.grade = param[0].emp_grade;
        }


        function loadCompany() {
            var response = OfbRegistration.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendance.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendance.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadEmployee(pageno) {
            var resp = vm.DataTable.loadData(OfbRegistration, pageno, {
                action: 'viewDataEmployee',
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                type: vm.type,
                search: vm.search
            });

            resp.then(processInfo);
            resp.catch(errorProcessInfo);
        }

        function processInfo(data) {
            vm.list = data.list;
        }

        function errorProcessInfo() {
            vm.list = [];
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listEmployee = angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listEmployee = [];
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('app.offboarding.form_registration')
        .controller('InputRegistrationN1Controller', InputRegistrationN1Controller);

    InputRegistrationN1Controller.$inject = ['$localStorage', '$http', '$timeout', 'Form', 'AppAPI', 'FileUploader', 'config', 'Auth', 'DataService'];

    function InputRegistrationN1Controller($localStorage, $http, $timeout, Form, AppAPI, FileUploader, config, Auth, DataService) {
        var vm = this;
        var OfbRegistration = AppAPI.OfbRegistration();
        var Attendance = AppAPI.Attendance();
        vm.DataTable = new DataService();
        vm.reason = ["Resign",
            "End of Contract (Voluntary)",
            "End of Contract (Non Voluntary)",
            "Dismissal / Head Count Reduction",
            "Low Performance",
            "Transfer / Demotion / Promotion",
            "Termination",
            "Pass Away",
            "Exit Without Notice",
            "Retire",
            "Long Personal Leave",
            "Divesture"
        ];
        vm.searchText = {
            'employee': null
        };
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.reloadToken = reloadToken;
        Form.initialForm();
        Form.setObject(OfbRegistration);
        vm.Form = Form;
        vm.saveData = saveData;

        vm.company = $localStorage.empsite;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadEmployee = loadEmployee;
        vm.Form.objForm.tipe = 3;
        vm.clearMeesage = clearMeesage;

        vm.listEmployee = [];
        vm.listNik = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.type = "n1";

        loadCompany();
        loadEmployee();

        function reloadToken() {
            Auth.setToken();
        }

        function saveData(ev, formController) {

            angular.forEach(vm.listEmployee, function (value) {
                vm.listNik.push(value.nik);
            });

            vm.Form.objForm.nik = vm.listEmployee;
            vm.Form.objForm.effectiveDate = new Date(formController.effectiveDate.$viewValue);

            var promise = Form.saveData('save', formController, OfbRegistration);
            angular.element.blockUI(); //munculin loading please wait
            promise.then(function () {
                vm.uploader.uploadAll();

                vm.messageTheme = 'blue';
                angular.element.unblockUI();
                formController.$setPristine();

                $timeout(function () {
                    vm.Form.tampilPesan = false;
                }, 3000);

                vm.nama = "";
                vm.effectiveDate = "";
                vm.emp_category = "";
                vm.emp_grade = "";
                vm.job_title = "";
            });

            promise.catch(function () {
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            });
        }

        var uploader = vm.uploader = new FileUploader({
            url: config.api + 'api/ofb/registration/uploadDokumenMasal',
            removeAfterUpload: true,
            alias: 'SPD',
        });

        // an async filter
        uploader.filters.push({
            name: 'asyncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options, deferred) {
                setTimeout(deferred.resolve, 1e3);
            }
        });

        uploader.filters.push({
            name: 'syncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function loadCompany() {
            var response = OfbRegistration.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendance.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendance.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadEmployee(pageno) {
            var resp = vm.DataTable.loadData(OfbRegistration, pageno, {
                action: 'viewDataEmployee',
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                type: vm.type,
                search: vm.search
            });

            resp.then(processInfo);
            resp.catch(errorProcessInfo);
        }

        function processInfo(data) {
            vm.list = data.list;
        }

        function errorProcessInfo() {
            vm.list = [];
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listEmployee = angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listEmployee = [];
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('app.offboarding.form_registration')
        .controller('InputEmployeeRegistrationController', InputEmployeeRegistrationController);

    InputEmployeeRegistrationController.$inject = ['$localStorage', '$state', '$timeout', 'Form', 'AppAPI', 'FileUploader', 'config', 'Auth'];

    function InputEmployeeRegistrationController($localStorage, $state, $timeout, Form, AppAPI, FileUploader, config, Auth) {
        var vm = this;
        var OfbRegistration = AppAPI.OfbRegistration();
        vm.reason = ["Resign",
            "End of Contract (Voluntary)",
            "End of Contract (Non Voluntary)",
            "Dismissal / Head Count Reduction",
            "Low Performance",
            "Transfer / Demotion / Promotion",
            "Termination",
            "Pass Away",
            "Exit Without Notice",
            "Retire",
            "Long Personal Leave",
            "Divesture"
        ];

        vm.reloadToken = reloadToken;
        Form.initialForm();
        Form.setObject(OfbRegistration);
        vm.Form = Form;
        vm.saveData = saveData;

        vm.Form.objForm.tipe = 1;
        vm.clearMeesage = clearMeesage;
        vm.changeFile = changeFile;


        cekOffboarding();

        function loadJobInfo() {
            var response = OfbRegistration.query({
                action: 'getEmpJob',
                empId: $localStorage.empno,
                offset: 0,
                jumPage: 1,
                search: ""
            });
            response.$promise.then(jobInfo);
            // response.$promise.catch(errorFetchBU);
        }

        function cekOffboarding() {
            var response = OfbRegistration.query({
                action: 'cekOffboarding',
                nik: $localStorage.user
            });
            response.$promise.then(myOffboarding);
            response.$promise.catch(errorCek);
        }

        function myOffboarding(data) {
            $state.go('app.ofb-registration_detail', {
                id: data[0].id
            });
        }

        function errorCek() {
            loadJobInfo();
        }

        function jobInfo(param) {
            vm.Form.objForm.nik = $localStorage.user;
            vm.Form.objForm.direct_report = param[0].direct_report;
            vm.Form.objForm.grade = param[0].emp_grade;
            vm.nama = $localStorage.nama;
            vm.effectiveDate = param[0].effective_date;
            vm.emp_category = param[0].emp_category;
            vm.job_title = param[0].job_title;
        }

        function reloadToken() {
            Auth.setToken();
        }

        function saveData(ev, formController) {
            angular.element.blockUI(); //munculin loading please wait

            vm.Form.objForm.effectiveDate = new Date(formController.effectiveDate.$viewValue);
            var promise = Form.saveData('save', formController, OfbRegistration);
            promise.then(function () {
                vm.uploader.uploadAll();

                vm.messageTheme = 'blue';
                angular.element.unblockUI();
                formController.$setPristine();

                $timeout(function () {
                    vm.Form.tampilPesan = false;
                }, 3000);

                vm.nama = "";
                vm.effectiveDate = "";
                vm.emp_category = "";
                vm.emp_grade = "";
                vm.job_title = "";
            });

            promise.catch(function () {
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            });
            // registration / detail / 1  
        }

        var uploader = vm.uploader = new FileUploader({
            url: config.api + 'api/ofb/registration/uploadDokumen',
            removeAfterUpload: true,
            alias: 'SPD',
        });

        // an async filter
        uploader.filters.push({
            name: 'asyncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options, deferred) {
                setTimeout(deferred.resolve, 1e3);
            }
        });

        uploader.filters.push({
            name: 'syncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function changeFile(event) {
            vm.canUpdate = true;
        }
    }

})();


(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_reff_checklist', [
     ])
    .config(config);

     config.$inject = ['$stateProvider', '$mdThemingProvider'];
  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state('app.ofb-reff_checklist', {
        url: '/ofb/reff-checklist',
        views: {
          'content@app': {
            templateUrl: 'app/main/offboarding/reff-checklist/ofb-reff-checklist.html',
            controller: 'OfbReffChecklistController as vm'
          }
        }
      });
      
  }

})();
(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_reff_checklist')
    .controller('InputrefcheckController', InputrefcheckController);
  InputrefcheckController.$inject = ['$mdDialog', 'Form', 'AppAPI'];
  function InputrefcheckController($mdDialog, Form, AppAPI) {
    var vm = this;
    vm.title = "Input Checklist Reference";
    vm.approvalType = [];
    vm.closeModal = closeModal;
    vm.saveData = saveData;

    var OfbRefCheck = AppAPI.OfbRefCheck();

    getApprovalType();
    getBu();
    Form.initialForm();

    Form.setObject(OfbRefCheck);
    vm.Form = Form;
    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      angular.element.blockUI();
      var response = Form.saveData('save', formController, OfbRefCheck);

      response.then(function () {
        vm.messageTheme = 'blue';
        angular.element.unblockUI();
        formController.$setPristine();
        $timeout(function () {
          vm.Form.tampilPesan = false;
        }, 3000);

      });
      response.catch(function () {
        vm.messageTheme = 'pink';
        angular.element.unblockUI();

      });
    }

    function getApprovalType() {
      var promise = OfbRefCheck.query({
        action: "getApprovalType"
      });
      promise.$promise.then(function (data) {
        vm.approvalType = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.approvalType = [];
      });
    }

    function getBu() {
      var promise = OfbRefCheck.query({
        action: "getBu"
      });
      promise.$promise.then(function (data) {
        vm.bu = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.bu = [];
      });
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_reff_checklist')
    .controller('EditrefcheckController', EditrefcheckController);

  EditrefcheckController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'refcheck'];

  function EditrefcheckController($mdDialog, Form, AppAPI, refcheck) {
    var vm = this;
    vm.title = "Edit Checklist Reference";
    vm.approvalType = [];
    vm.closeModal = closeModal;
    vm.saveData = saveData;

    var OfbRefCheck = AppAPI.OfbRefCheck();

    getApprovalType();
    getBu();
    Form.initialForm();

    Form.setObject(OfbRefCheck);
    vm.Form = Form;

    vm.Form.objForm.description = refcheck.description;
    vm.Form.objForm.approvalType = refcheck.approval_type;
    vm.Form.objForm.id = refcheck.id;
    vm.Form.objForm.bu = refcheck.bu;

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      angular.element.blockUI();
      var response = Form.saveData('update', formController, OfbRefCheck);

      response.then(function () {
        vm.messageTheme = 'blue';
        angular.element.unblockUI();
        formController.$setPristine();
        $timeout(function () {
          vm.Form.tampilPesan = false;
        }, 3000);

      });
      response.catch(function () {
        vm.messageTheme = 'pink';
        angular.element.unblockUI();

      });
    }

    function getApprovalType() {
      var promise = OfbRefCheck.query({
        action: "getApprovalType"
      });
      promise.$promise.then(function (data) {
        vm.approvalType = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.approvalType = [];
      });
    }

    function getBu() {
      var promise = OfbRefCheck.query({
        action: "getBu"
      });
      promise.$promise.then(function (data) {
        vm.bu = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.bu = [];
      });
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_reff_checklist')
    .controller('InputapprovaltypeController', InputapprovaltypeController);
  InputapprovaltypeController.$inject = ['$mdDialog', '$timeout', 'Form', 'AppAPI'];

  function InputapprovaltypeController($mdDialog, $timeout, Form, AppAPI) {
    var vm = this;
    vm.title = "Input Approval Type";
    vm.closeModal = closeModal;
    vm.saveData = saveData;

    var OfbRefCheck = AppAPI.OfbRefCheck();

    Form.initialForm();

    Form.setObject(OfbRefCheck);
    vm.Form = Form;

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      angular.element.blockUI();
      var response = Form.saveData('saveApprovalType', formController, OfbRefCheck);

      response.then(function () {
        vm.messageTheme = 'blue';
        angular.element.unblockUI();
        formController.$setPristine();
        $timeout(function () {
          vm.Form.tampilPesan = false;
        }, 3000);

      });
      response.catch(function () {
        vm.messageTheme = 'pink';
        angular.element.unblockUI();

      });
    }
  }

})();
(function () {
  'use strict';

  angular
  .module('app.offboarding.ofb_handover',[])
  .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
    .state('app.ofb-handover',{
      url : '/ofb/handover',
      views : {
        'content@app' : {
          templateUrl : 'app/main/offboarding/handover/handover.html',
          controller  : "OfbhandoverController as vm"
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_handover')
    .controller('InputhandoverController', InputhandoverController);

  InputhandoverController.$inject = ['$localStorage', '$mdDialog', '$http', '$timeout', 'id', 'Form', 'AppAPI', 'config', 'Auth'];

  function InputhandoverController($localStorage, $mdDialog, $http, $timeout, id, Form, AppAPI, config, Auth) {
    var vm = this;
    var Ofbhandover = AppAPI.Ofbhandover();
    var OfbRegistration = AppAPI.OfbRegistration();
    vm.tambah = tambah;
    vm.hapus = hapus
    vm.informations = [{ "item": "" }];
    vm.reloadToken = reloadToken;
    vm.saveData = saveData;
    vm.selectedItemChange = selectedItemChange;
    vm.querySearchEmployee = querySearchEmployee;

    vm.closeModal = closeModal;
    loadEmpInDivision();
    Form.initialForm();
    Form.setObject(Ofbhandover);
    vm.Form = Form;

    vm.Form.objForm.idRegistration = id;

    function tambah() {
      var itemToClone = { "item": "" };
      vm.informations.push(itemToClone);
    }

    function hapus(itemIndex) {
      vm.informations.splice(itemIndex, 1);
    }

    function reloadToken() {
      Auth.setToken();
    }

    function saveData(ev, formInput) {
      angular.element.blockUI();
      var promise = Form.saveData('save', formInput, Ofbhandover);
      promise.then(function () {
        vm.messageTheme = 'blue';
        angular.element.unblockUI();
        formInput.$setPristine();

        $timeout(function () {
          vm.Form.tampilPesan = false;
        }, 3000);
      });

      promise.catch(function () {
        vm.messageTheme = 'pink';
        angular.element.unblockUI();
      });
    }

    function closeModal() {
      $mdDialog.cancel();
    }

    function querySearchEmployee(query) {
      return $http
        .get(config.api + 'api/ofb/registration?action=getListEmployee&search=' + query)
        .then(function (item) {
          if (item.data.length === 0) {
            vm.searchText.employee = query;
          }
          return item.data;
        });
    }

    function selectedItemChange() {
      var item = vm.receiver;
      console.log(item);
      if (item) {
        // vm.nama = item.name;
        var response = OfbRegistration.query({ action: 'getEmpJob', empId: item, offset: 0, jumPage: 1, search: "" });
        response.$promise.then(jobInfo);
      }
    }

    function jobInfo(param) {
      vm.Form.objForm.nik = param[0].nik;
      vm.job_title = param[0].job_title;
    }


    function loadEmpInDivision() {
      var nik = $localStorage.user;
      return $http
        .get(config.api + 'api/ofb/handover/getEmpInDivision?nik=' + nik)
        .then(function (item) {
          vm.listReceiver = item.data;
        });
    }
  }

})();
(function() {
    'use strict';

    angular
        .module('app.offboarding.ofb_exit_interview_user', [])
        .config(config)
        .directive('format', [
            '$filter',
            function($filter) {
                return {
                    require: '?ngModel',
                    link: function(scope, elem, attrs, ctrl) {
                        if (!ctrl) return;

                        ctrl.$formatters.unshift(function(a) {
                            return $filter(attrs.format)(ctrl.$modelValue, 'Rp ');
                        });

                        elem.bind('blur', function(event) {
                            var plainNumber = elem
                                .val()
                                .replace(/[^\d|\-+|\.+]/g, '');
                            elem.val($filter(attrs.format)(plainNumber, 'Rp '));
                        });
                    }
                };
            }
        ]);

    config.$inject = ['$stateProvider'];
    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.ofb-exit-interview-user', {
            url: '/ofb/exinuser/:nik',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/offboarding/exit-interview/user/exinuser.html',
                    controller: 'ExitInterviewUserController as vm'
                }
            }
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("app.offboarding.ofb_exit_interview_user")
        .controller("ExitInterviewUserController", Controller);

    Controller.$inject = [
        "$mdDialog",
        "Auth",
        "AppAPI",
        "DataService",
        "Form",
        "$state",
        "$timeout",
        "$stateParams",
        "$localStorage",
        "$scope"
    ];
    /** @ngInject */
    function Controller(
        $mdDialog,
        Auth,
        AppAPI,
        DataService,
        Form,
        $state,
        $timeout,
        $stateParams,
        $localStorage,
        $scope
    ) {
        var vm = this;

        if ($stateParams.nik != "") {
            vm.nik = $stateParams.nik;
        } else {
            vm.nik = $localStorage.user;
        }

        vm.myNik = $localStorage.user;

        var endpoint = AppAPI.OfbExitInterview(false);
        vm.questions = [];
        vm.switchChar = switchChar;
        vm.empInfo = [];
        vm.empHistory = [];
        vm.changeDateFormat = changeDateFormat;
        vm.saveData = saveData;
        vm.status = 0;
        vm.isReadOnly = false;
        vm.findInArray = findInArray;
        vm.isUpdate = false;
        vm.approval = approval;
        vm.changeCheck = changeCheck;
        vm.currExitInterviewId = 0;
        vm.updateData = updateData;
        vm.isRequesting = false;
        vm.isLoading = true;
        vm.changeCheckSingleOther = changeCheckSingleOther;
        vm.isLoading = false;
        vm.isCheckboxReady = false;
        vm.onlyOneChecked = onlyOneChecked;

        if (vm.myNik != vm.nik) {
            vm.isReadOnly = true;
        }

        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(endpoint);

        // set form to controller
        vm.Form = Form;

        // vm.Form.objForm.answers = [];

        activate();

        function activate() {
            getInformationData();
        }

        function getExitInterviewData() {
            var response = endpoint.query({
                action: "getExitIntQuestion"
            });
            response.$promise.then(function(data) {
                setValue(vm.result);
            });
            response.$promise.catch(function(err) {
                // vm.questions = [];
            });
        }

        function switchChar(num) {
            var chars = [
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "z"
            ];

            return chars[num];
        }

        function setValue(result) {
            if (result.status == 1) {
                result.data.forEach(function(val) {
                    vm.questions.forEach(function(question) {
                        if (val.question_id == question.id) {
                            switch (question.variety) {
                                case "single":
                                case "multiple":
                                case "single-w-other":
                                case "custom":
                                    question.detail = val.scheme;
                                    if (question.is_have_comment === "1") {
                                        question.comment = val.comment;
                                    }
                                    break;
                                case "essay":
                                    question.answer = val.scheme;
                                    if (question.is_have_comment === "1") {
                                        question.comment = val.comment;
                                    }
                                    break;
                            }
                        }
                    });
                });
            }
        }

        function getInformationData() {
            vm.isLoading = true;
            var response = endpoint.get({
                action: "getInformation",
                nik: vm.nik
            });
            response.$promise.then(function(data) {
                vm.status = data.status;
                vm.result = data.result;
                vm.empHistory = data.history;
                vm.isUpdate = data.isUpdate;
                vm.currExitInterviewId = data.exitInterviewId;
                $timeout(function() {
                    vm.empInfo = data.current;
                    vm.isLoading = false;
                }, 3000);
                getQuestion();
            });
            response.$promise.catch(function(err) {
                console.log(err);
                vm.status = 0;
                vm.empInfo = [];
                vm.empHistory = [];
            });
        }

        function changeDateFormat(d) {
            var dt = new Date(d);
            var formatted = moment(dt).format("MM/DD/YYYY");
            return formatted;
        }

        function isSingleValid(detail) {
            var isFinalValid = { status: false, data: null };
            for (var k = 0; k < detail.length; k++) {
                var isValid1 = false;
                for (var l = 0; l < detail[k].answer.type1.length; l++) {
                    if (detail[k].answer.type1[l].val) {
                        isValid1 = true;
                        break;
                    }
                }
                var isValid2 = false;
                for (var l = 0; l < detail[k].answer.type2.length; l++) {
                    if (detail[k].answer.type2[l].val) {
                        isValid2 = true;
                        break;
                    }
                }

                detail[k].isNotValid = !isValid1 || !isValid2;
                if (isValid1 && isValid2) {
                    isFinalValid.status = true;
                    isFinalValid.data = detail[k].detail;
                    break;
                }
            }
            return isFinalValid;
        }

        function isMultipleValid(detail) {
            var isValid = { status: false, data: null };
            console.log(detail);
            for (var j = 0; j < detail.length; j++) {
                if (detail[j].selected) {
                    detail[j].isNotValid = false;
                    isValid.status = true;
                    isValid.data = detail[j].detail;
                    break;
                } else {
                    detail[j].isNotValid = true;
                }
            }
            return isValid;
        }

        function saveData(Form, e) {
            var validated = { status: true, data: null };
            for (var i = 0; i < vm.questions.length; i++) {
                var validator = { status: false, data: null };
                switch (vm.questions[i].variety) {
                    case "multiple":
                        validator = isMultipleValid(vm.questions[i].detail);
                        break;
                    case "single":
                        validator = isSingleValid(vm.questions[i].detail);
                        break;

                    default:
                        validator.status = true;
                        validator.data = null;
                        break;
                }
                if (!validator.status) {
                    validated.status = false;
                    validated.data = vm.questions[i].question;
                    break;
                }
            }

            if (!validated.status) {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("Perhatian")
                        .textContent(
                            "Pertanyaan " + validated.data + " belum terisi"
                        )
                        .ariaLabel("Alert")
                        .ok("Ok")
                        .targetEvent(e)
                );
                return;
            }

            if (Form.$invalid) {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("Perhatian")
                        .textContent("Ada field yang belum terisi")
                        .ariaLabel("Alert")
                        .ok("Ok")
                        .targetEvent(e)
                );
                return;
            }

            angular.element.blockUI();
            vm.isRequesting = true;
            var request = Auth.setToken();
            request.then(function() {
                var response = endpoint.save({
                    action: "storeExitInterview",
                    exit_date: vm.empInfo.exit_date,
                    answer: vm.questions
                });

                response.$promise.then(function(res) {
                    angular.element.unblockUI();
                    responseDialog(e, res, 1);
                });
                response.$promise.catch(function(reason) {
                    angular.element.unblockUI();
                    responseDialog(e, reason, 0);
                });
            });
        }

        function updateData(Form, e) {
            vm.isRequesting = true;

            angular.element.blockUI();

            var request = Auth.setToken();
            request.then(function() {
                var response = endpoint.save({
                    action: "updateExitInterview",
                    exitInterviewId: vm.currExitInterviewId,
                    answer: vm.questions
                });

                response.$promise.then(function(res) {
                    angular.element.unblockUI();
                    responseDialog(e, res, 1);
                });
                response.$promise.catch(function(reason) {
                    angular.element.unblockUI();
                    responseDialog(e, reason, 0);
                });
            });
        }

        function responseDialog(e, data, type) {
            vm.isRequesting = false;

            var title = "Failed";
            var message = "There is Something wrong";
            if (type == 1) {
                title = data.status;
                message = data.message;
            }
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(title)
                        .textContent(message)
                        .ariaLabel("Alert")
                        .ok("Ok")
                        .targetEvent(e)
                )
                .then(function() {
                    $state.reload();
                });
        }

        function approval(status, id) {
            var OfbRegistration = AppAPI.OfbRegistration();
            Form.setObject(OfbRegistration);

            vm.FormApproval = Form;

            var responses = vm.FormApproval.objForm.$get({
                action: "setApprovalExitClearance",
                status: status,
                id: id,
                catatan: ""
            });
            responses.then(function(data) {
                activate();
            });
        }

        function getQuestion() {
            var response = endpoint.query({
                action: "getExitIntQuestion"
            });
            response.$promise.then(function(data) {
                var temp = angular.copy(data);
                temp.forEach(function(val, key) {
                    if (val.variety === "custom") {
                        temp[key].detail = JSON.parse(val.detail);
                    }
                    vm.questions.push(val);
                });
                setValue(vm.result);
            });
            response.$promise.catch(function(err) {
                vm.questions = [];
            });
        }

        function changeCheck(parent, index, isChecked, type) {
            console.log(parent);
            if (isChecked) {
                for (var i = 0; i < parent.answer[type].length; i++) {
                    if (i !== index) {
                        parent.answer[type][i].val = false;
                    }
                }
            } else {
                parent.answer[type][index].val = true;
            }

            var isValid1 = false;
            for (var l = 0; l < parent.answer.type1.length; l++) {
                if (parent.answer.type1[l].val) {
                    isValid1 = true;
                    break;
                }
            }
            var isValid2 = false;
            for (var l = 0; l < parent.answer.type2.length; l++) {
                if (parent.answer.type2[l].val) {
                    isValid2 = true;
                    break;
                }
            }

            if (isValid1 && isValid2) {
                parent.isNotValid = false;
            } else {
                parent.isNotValid = true;
            }
        }

        function changeCheckSingleOther(parent, index, isChecked) {
            if (isChecked) {
                for (var i = 0; i < parent.length; i++) {
                    if (i !== index) {
                        parent[i].selected = false;
                    }
                }
            } else {
                parent[index].selected = true;
            }
        }

        function findInArray(arr, key) {
            var response = false;
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] === key) {
                    response = true;
                    break;
                }
            }
            return response;
        }

        function onlyOneChecked(item, index) {
            console.log(index);
            var ctr = item.detail.length;
            for (var i = 0; i < ctr; i++) {
                if (index !== i) {
                    item.detail[i].selected = false;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.offboarding.ofb_exit_interview_admin', []).config(config);

    config.$inject = ['$stateProvider'];
    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.ofb-exit-interview-admin', {
            url: '/ofb/exit-interview-admin',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/offboarding/exit-interview/admin/exinadmin.html',
                    controller: 'ExitInterviewAdminController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.offboarding.ofb_exit_interview_admin')
        .controller('ExitInterviewAdminExportController', Controller);

    Controller.$inject = [
        '$state',
        'DataService',
        'AppAPI',
        'Auth',
        '$window',
        '$location',
        'config',
        '$mdDialog'
    ];

    /** @ngInject */
    function Controller(
        $state,
        DataService,
        AppAPI,
        Auth,
        $window,
        $location,
        config,
        $mdDialog
    ) {
        var vm = this;
        var endpoint = AppAPI.OfbExitInterview(true);
        vm.tempStartDate = new Date();
        vm.tempEndDate;
        vm.exportExcel = exportExcel;
        vm.hide = hideDialog;

        function exportExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    var tmpStartDate = angular.copy(vm.tempStartDate);
                    var tmpEndDate = angular.copy(vm.tempEndDate);
                    var startDate = moment(tmpStartDate).format('YYYY-MM-DD');
                    var endDate = moment(tmpEndDate).format('YYYY-MM-DD');

                    $window.open(
                        protocol +
                            '://' +
                            host +
                            config.api +
                            'api/ofb/exitinterview/exinadmin/exportExitInterview/' +
                            '/' +
                            startDate +
                            '/' +
                            endDate +
                            '/' +
                            data.token,
                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.offboarding.ofb_exit_interview_admin')
        .controller('ExitInterviewAdminController', Controller);

    Controller.$inject = [
        '$state',
        'DataService',
        'AppAPI',
        'Auth',
        '$window',
        '$location',
        'config',
        '$mdDialog'
    ];

    /** @ngInject */
    function Controller(
        $state,
        DataService,
        AppAPI,
        Auth,
        $window,
        $location,
        config,
        $mdDialog
    ) {
        var vm = this;
        var endpoint = AppAPI.OfbExitInterview(true);
        vm.DataTable = new DataService();
        vm.listJum = [5, 10, 20, 25, 50];
        vm.DataTable.jumDataPerPage = 20;
        vm.loadData = loadData;
        vm.showFormExport = showFormExport;
        vm.selectedEmpType = { name: 'All', value: 'all' };
        vm.empType = [
            { name: 'All', value: 'all' },
            { name: 'GW', value: 'HRIS' },
            { name: 'STAFF', value: 'SAP' }
        ];
        vm.years = ['all', 2019, 2020, 2021];
        vm.year = 'all';
        vm.exitInterview = exitInterview;

        activate();

        function activate() {
            loadData(1);
        }

        function loadData(pageno) {
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'view',
                empType: vm.selectedEmpType.value,
                year: vm.year
            });
        }

        function showFormExport(ev) {
            $mdDialog
                .show({
                    controller: 'ExitInterviewAdminExportController as vm',
                    templateUrl:
                        'app/main/offboarding/exit-interview/admin/export.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                .then(function () {
                    loadData(1);
                });
        }

        function exitInterview(nik) {
            $state.go('app.ofb-exit-interview-user', {
                nik: nik
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_reff_checklist')
    .controller('InputapprovalgroupController', InputapprovalgroupController);
  InputapprovalgroupController.$inject = ['$mdDialog', '$timeout', 'Form', 'AppAPI'];
  function InputapprovalgroupController($mdDialog, $timeout, Form, AppAPI) {
    var vm = this;
    vm.title = "Input Approval Group";
    vm.approvalType = [];
    vm.closeModal = closeModal;
    vm.saveData = saveData;

    var OfbApprovalGroup = AppAPI.OfbApprovalGroup();
    var OfbRefCheck = AppAPI.OfbRefCheck();
    vm.getSubArea = getSubArea;

    getBu();
    getApprovalType();

    Form.initialForm();

    Form.setObject(OfbApprovalGroup);
    vm.Form = Form;
    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      angular.element.blockUI();
      var response = Form.saveData('save', formController, OfbApprovalGroup);

      response.then(function () {
        vm.messageTheme = 'blue';
        angular.element.unblockUI();
        formController.$setPristine();
        $timeout(function () {
          vm.Form.tampilPesan = false;
        }, 3000);

      });
      response.catch(function () {
        vm.messageTheme = 'pink';
        angular.element.unblockUI();

      });
    }

    function getApprovalType() {
      var promise = OfbRefCheck.query({
        action: "getApprovalType"
      });
      promise.$promise.then(function (data) {
        vm.approvalType = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.approvalType = [];
      });
    }

    function getBu() {
      var promise = OfbRefCheck.query({
        action: "getBu"
      });
      promise.$promise.then(function (data) {
        vm.bu = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.bu = [];
      });
    }

    function getSubArea() {
      vm.subareaList = [];
      var promise = OfbRefCheck.query({
        action: "getSubarea",
        bu: vm.Form.objForm.bu
      });
      promise.$promise.then(function (data) {
        vm.subareaList = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.subareaList = [];
      });
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_reff_checklist')
    .controller('EditapprovalgroupController', EditapprovalgroupController);
  EditapprovalgroupController.$inject = ['$mdDialog', '$timeout', 'Form', 'AppAPI', 'refcheck'];
  function EditapprovalgroupController($mdDialog, $timeout, Form, AppAPI, refcheck) {
    var vm = this;
    vm.title = "Edit Approval Group";
    vm.approvalType = [];
    vm.closeModal = closeModal;
    vm.saveData = saveData;

    var OfbApprovalGroup = AppAPI.OfbApprovalGroup();
    var OfbRefCheck = AppAPI.OfbRefCheck();
    vm.getSubArea = getSubArea;

    getBu();
    getApprovalType();

    Form.initialForm();

    Form.setObject(OfbApprovalGroup);
    vm.Form = Form;

    vm.Form.objForm.status = false;
    vm.Form.objForm.nik = refcheck.nik;
    vm.Form.objForm.approvalType = refcheck.approval_type;
    vm.Form.objForm.id = refcheck.id;
    vm.Form.objForm.bu = refcheck.company;
    vm.Form.objForm.sub_area_id = refcheck.sub_area_id;

    getSubArea();


    if (refcheck.status == 1) {
      vm.Form.objForm.status = true;
    }

    console.log(vm.Form.objForm);
    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      angular.element.blockUI();
      var response = Form.saveData('update', formController, OfbApprovalGroup);

      response.then(function () {
        vm.messageTheme = 'blue';
        angular.element.unblockUI();
        formController.$setPristine();
        $timeout(function () {
          vm.Form.tampilPesan = false;
        }, 3000);

      });
      response.catch(function () {
        vm.messageTheme = 'pink';
        angular.element.unblockUI();

      });
    }

    function getApprovalType() {
      var promise = OfbRefCheck.query({
        action: "getApprovalType"
      });
      promise.$promise.then(function (data) {
        vm.approvalType = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.approvalType = [];
      });
    }

    function getBu() {
      var promise = OfbRefCheck.query({
        action: "getBu"
      });
      promise.$promise.then(function (data) {
        vm.bu = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.bu = [];
      });
    }

    function getSubArea() {
      vm.subareaList = [];
      var promise = OfbRefCheck.query({
        action: "getSubarea",
        bu: vm.Form.objForm.bu
      });
      promise.$promise.then(function (data) {
        vm.subareaList = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.subareaList = [];
      });
    }
  }

})();
(function () {
    'use strict';

    angular
        .module('app.mtx.transaksi.mtx-monitoring-score')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxMonitoringScoreController', MtxMonitoringScoreController);

    MtxMonitoringScoreController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast',
        '$location',
        '$window',
        'config'
    ];

    function MtxMonitoringScoreController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast,
        $location,
        $window,
        config
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';
        vm.totalEmp = 0;
        vm.totalEmpHasCategory = 0;

        vm.type = 0;
        vm.activityId = null;
        vm.process = '';
        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        // load bt
        vm.loadData = loadData;
        reset();
        // loadDropdownMainCategory();
        loadDropdownBu();
        vm.loadDropdownGroupByCompany = loadDropdownGroupByCompany;
        vm.loadDropdownSubArea = loadDropdownSubArea;
        vm.viewDataEmployementBySubArea = viewDataEmployementBySubArea;
        vm.loadDropdownMainCategory = loadDropdownMainCategory;
        vm.loadDropdownCategoryByMainCategory = loadDropdownCategoryByMainCategory;
        vm.loadDropdownEmp = loadDropdownEmp;
        vm.loadDropdownMainActivity = loadDropdownMainActivity;
        vm.loadDropdownActivity = loadDropdownActivity;

        function loadData(type, activity, dataEvent) {
            vm.type = type;
            vm.activityId = activity;
            angular.element.blockUI();
            // vm.activity = JSON.parse(vm.Form.objForm.mtx_category_id);
            var params = {
                action: 'viewDataMonitoringMtxScoreSkill',
                mtx_categori_id: vm.Form.objForm.mtx_category_id,
                sub_area_id: vm.Form.objForm.sub_area_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                var datas = data[0];
                if (vm.type == 0) {
                    var headerProcess = [];
                    var empList = [];
                    vm.process = '';
                    var skillCount = 0;
                    for (var j = 0; j < datas.aData.length; j++) {
                        for (var i = 0; i < datas.activity.length; i++) {
                            if (datas.activity[i].activity_name != '#' && datas.activity[i].mtx_main_activity_id == datas.aData[j].id) {
                                headerProcess.push({
                                    skill_name: datas.activity[i].activity_name,
                                    mtx_activity_id: datas.activity[i].id,
                                    level_view: 'nilai',
                                    main_activity_id: datas.aData[j].id,
                                    no: datas.activity[i].no
                                })
                                skillCount++;
                            }
                        }
                        headerProcess.push({
                            skill_name: datas.aData[j].main_activity_name,
                            main_activity_id: datas.aData[j].id,
                            level_view: 'score',
                            no: '#',
                            background: '#eee'
                        })
                    }


                    for (var j = 0; j < datas.aDataEmp.length; j++) {
                        var detail = [];
                        var countSkill = 0;
                        // for (var k = 0; k < headerProcess.length; k++) {
                        for (var i = 0; i < datas.aDataEmp[j].detail.length; i++) {
                            for (var k = 0; k < datas.aDataEmp[j].detail[i].detail.length; k++) {
                                detail.push({
                                    level: parseInt(datas.aDataEmp[j].detail[i].detail[k].level_warna),
                                    indikator_total_nilai: datas.aDataEmp[j].detail[i].detail[k].indikator_total_nilai
                                })

                                if (datas.aDataEmp[j].detail[i].detail[k].indikator_total_nilai != '0') {
                                    countSkill++;
                                }
                            }
                            detail.push({
                                level: parseInt(datas.aDataEmp[j].detail[i].level_warna),
                                indikator_total_nilai: datas.aDataEmp[j].detail[i].indikator_total_nilai,
                                background: '#eee'
                            })
                        }

                        empList.push({
                            emp_name: datas.aDataEmp[j].emp_name,
                            employemeny_nik: datas.aDataEmp[j].employemeny_nik,
                            detail: detail,
                            countSkill: countSkill
                        });
                    }

                    vm.listData = {
                        skill_activity: headerProcess,
                        colspan: headerProcess.length,
                        aDataEmp: empList,
                        skillCount: skillCount
                    }

                    console.log(vm.listData);
                } else if (vm.type == 1 && vm.activityId) {
                    var headerProcess = [];
                    var empList = [];
                    var skillCount = 0;
                    vm.process = dataEvent.skill_name;

                    // for (var j = 0; j < datas.aData.length; j++) {
                    for (var i = 0; i < datas.skill_activity.length; i++) {
                        if (datas.skill_activity[i].mtx_activity_id == vm.activityId) {
                            headerProcess.push({
                                skill_name: datas.skill_activity[i].skill_name,
                                no: datas.skill_activity[i].no
                            })
                            skillCount++;
                        }
                    }
                    headerProcess.push({
                        skill_name: 'Flag',
                        no: '#'
                    })
                    // }


                    for (var j = 0; j < datas.aDataEmp.length; j++) {
                        var detail = [];
                        var countSkill = 0;
                        for (var i = 0; i < datas.aDataEmp[j].detail.length; i++) {
                            for (var k = 0; k < datas.aDataEmp[j].detail[i].detail.length; k++) {
                                if (datas.aDataEmp[j].detail[i].detail[k].process_id == vm.activityId) {
                                    for (var l = 0; l < datas.aDataEmp[j].detail[i].detail[k].detail.length; l++) {
                                        detail.push({
                                            level: datas.aDataEmp[j].detail[i].detail[k].detail[l].level_warna,
                                            indikator_total_nilai: datas.aDataEmp[j].detail[i].detail[k].detail[l].indikator_total_nilai
                                        })

                                        if (datas.aDataEmp[j].detail[i].detail[k].detail[l].indikator_total_nilai != '0') {
                                            countSkill++;
                                        }
                                    }
                                    detail.push({
                                        level: datas.aDataEmp[j].detail[i].detail[k].level_warna,
                                        indikator_total_nilai: datas.aDataEmp[j].detail[i].detail[k].indikator_total_nilai,
                                        background: '#eee'
                                    });

                                }
                            }

                        }

                        empList.push({
                            emp_name: datas.aDataEmp[j].emp_name,
                            employemeny_nik: datas.aDataEmp[j].employemeny_nik,
                            detail: detail,
                            countSkill: countSkill
                        });
                    }

                    vm.listData = {
                        skill_activity: headerProcess,
                        colspan: headerProcess.length,
                        aDataEmp: empList,
                        skillCount: skillCount
                    }
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listData = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownBu() {
            angular.element.blockUI();
            var params = {
                action: 'viewDataCompany'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listBu = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownSubArea(company_id) {
            angular.element.blockUI();
            loadDropdownGroupByCompany(company_id);
            var params = {
                action: 'viewDataSubarea',
                company_id: company_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listSubArea = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listSubArea = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownGroupByCompany(company_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: '',
                company_id: company_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory(company_id, group_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: company_id,
                group_id: group_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        function viewDataEmployementBySubArea(sub_area_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataEmployementBySubArea',
                sub_area: sub_area_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.totalEmp = data[0].aData[0].total;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.totalEmp = 0;
                angular.element.unblockUI();
            });
        }

        function loadDropdownCategoryByMainCategory(main_category_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxCategoryByMainCategory',
                main_category_id: main_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownEmp(sub_area_id, mtx_category_id) {
            angular.element.blockUI();
            loadDropdownMainActivity(mtx_category_id);
            var params = {
                action: 'viewDataEmpBySubAreaAndCategory',
                sub_area_id: sub_area_id,
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listEmployee = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listEmployee = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainActivity(mtx_category_id) {
            var params = {
                action: 'viewDataMtxMainActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainActivity = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownActivity(main_activity_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                main_activity_id: main_activity_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listActivity = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.activity_id = vm.activity.id;
            vm.Form.objForm.data_mtx_score = vm.listData;
            var response = Form.saveData('saveDataMtxSkillScore', formController, Mtx);
            response.then(function (data) {
                if (data.data == true) {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();
                    vm.Form.pesan = 'Data EMP Matrix Score berhasil disimpan';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.Form.pesan)
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                    );
                    reset();
                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 3000);
                } else {
                    angular.element.unblockUI();
                    vm.Form.tampilPesan = false;
                }

            });

            response.catch(function () {
                vm.messageTheme = 'pink';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Data EMP Matrix Score gagal disimpan')
                        .position('top right')
                        .hideDelay(3000)
                        .theme("error-toast")
                );
                angular.element.unblockUI();
            });
        }


        function reset() {
            vm.listData = [];
        }

        vm.exportData = exportData;
        function exportData() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/mtx/monitoringExportPdf/' + vm.Form.objForm.mtx_category_id + '/' + vm.type + '/' + vm.activityId, '_blank');
            }, function () {
                $window.alert('gagal load token');
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.transaksi.mtx-assesment-setting', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_transaksi_mtx_assesment_setting', {
                url: '/mtx/transaksi/mtx-assesment-setting',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/transaksi/mtx-assesment-setting/mtx-assesment-setting.html',
                        controller: 'MtxAssesmentSettingController as vm'
                    }
                }
            });

    }
}());


(function () {
    'use strict';

    angular
        .module('app.mtx.transaksi.mtx-assesment-setting')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxAssesmentSettingController', MtxAssesmentSettingController);

    MtxAssesmentSettingController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast',
        '$http',
        'config'
    ];

    function MtxAssesmentSettingController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast,
        $http,
        config
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';
        vm.totalEmp = 0;
        vm.totalEmpHasCategory = 0;

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            for (var i = 0; i < vm.listData.length; i++) {
                for (var j = 0; j < vm.listData[i].skill_indikator.length; j++) {
                    vm.listData[i].skill_indikator[j].validasi = true;
                }
            }
        }

        function unCheckAll() {
            for (var i = 0; i < vm.listData.length; i++) {
                for (var j = 0; j < vm.listData[i].skill_indikator.length; j++) {
                    vm.listData[i].skill_indikator[j].validasi = false;
                }
            }
        }

        // load bt
        vm.loadData = loadData;
        reset();
        // loadDropdownMainCategory();
        loadDropdownBu();
        vm.loadDropdownGroupByCompany = loadDropdownGroupByCompany;
        vm.loadDropdownSubArea = loadDropdownSubArea;
        vm.viewDataEmployementBySubArea = viewDataEmployementBySubArea;
        vm.loadDropdownMainCategory = loadDropdownMainCategory;
        vm.loadDropdownCategoryByMainCategory = loadDropdownCategoryByMainCategory;
        vm.loadDropdownEmp = loadDropdownEmp;
        vm.loadDropdownMainActivity = loadDropdownMainActivity;
        vm.loadDropdownActivity = loadDropdownActivity;

        function loadData() {
            angular.element.blockUI();
            vm.activity = JSON.parse(vm.Form.objForm.mtx_activity_id);
            var params = {
                action: 'viewDataMtxScoreSkillSetting',
                mtx_activity_id: vm.activity.id,
                nik: vm.Form.objForm.nik,
                score_by: vm.Form.objForm.score_by.nik
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listData = data[0].aData;
                for (var i = 0; i < vm.listData.length; i++) {
                    for (var j = 0; j < vm.listData[i].skill_indikator.length; j++) {
                        vm.listData[i].skill_indikator[j].validasi = (vm.listData[i].skill_indikator[j].assesment_id) ? true : false;
                    }
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listData = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownBu() {
            angular.element.blockUI();
            var params = {
                action: 'viewDataCompany'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listBu = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownSubArea(company_id) {
            angular.element.blockUI();
            loadDropdownGroupByCompany(company_id);
            var params = {
                action: 'viewDataSubarea',
                company_id: company_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listSubArea = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listSubArea = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownGroupByCompany(company_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: '',
                company_id: company_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory(company_id, group_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: company_id,
                group_id: group_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        function viewDataEmployementBySubArea(sub_area_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataEmployementBySubArea',
                sub_area: sub_area_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.totalEmp = data[0].aData[0].total;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.totalEmp = 0;
                angular.element.unblockUI();
            });
        }

        function loadDropdownCategoryByMainCategory(main_category_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxCategoryByMainCategory',
                main_category_id: main_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownEmp(sub_area_id, mtx_category_id) {
            angular.element.blockUI();
            loadDropdownMainActivity(mtx_category_id);
            var params = {
                action: 'viewDataEmpBySubAreaAndCategory',
                sub_area_id: sub_area_id,
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listEmployee = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listEmployee = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainActivity(mtx_category_id) {
            var params = {
                action: 'viewDataMtxMainActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainActivity = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownActivity(main_activity_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                main_activity_id: main_activity_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listActivity = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            console.log(vm.Form.objForm.score_by);
            vm.Form.objForm.activity_id = vm.activity.id;
            vm.Form.objForm.data_mtx_score = vm.listData;
            var response = Form.saveData('saveDataMtxSkillScoreSetting', formController, Mtx);
            response.then(function (data) {
                if (data.data == true) {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();
                    vm.Form.pesan = 'Data EMP Matrix Score berhasil disimpan';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.Form.pesan)
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                    );
                    reset();
                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 3000);
                } else {
                    angular.element.unblockUI();
                    vm.Form.tampilPesan = false;
                }

            });

            response.catch(function () {
                vm.messageTheme = 'pink';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Data EMP Matrix Score gagal disimpan')
                        .position('top right')
                        .hideDelay(3000)
                        .theme("error-toast")
                );
                angular.element.unblockUI();
            });
        }


        function reset() {
            vm.listData = [];
        }

        vm.lookupEmployee = lookupEmployee;

        function lookupEmployee(searchText) {
            if (searchText.length > 3) {
                return $http
                    .get(config.api + 'api/mtx?action=searchEmployee&search=' + searchText + '&sub_area=' + vm.Form.objForm.sub_area_id)
                    .then(function (res) {
                        console.log('res', res);
                        var datas = [];
                        for (var i = 0; i < res.data[0].aData.length; i++) {
                            datas.push(res.data[0].aData[i]);
                        }
                        return datas;
                    }).catch(function (err) {
                        console.log('err', err);
                    });
            }
        }

        vm.selectAllEmployee = function () {
            if (!vm.selectAllEmp) {
                vm.selectAllEmp = true;
                vm.Form.objForm.nik = [];
                for (var i = 0; i < vm.listEmployee.length; i++) {
                    vm.Form.objForm.nik.push(vm.listEmployee[i].nik);

                }
            } else {
                vm.selectAllEmp = false;
                vm.Form.objForm.nik = [];
            }

        };

    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.transaksi.mtx-assesment-list-monitoring', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_transaksi_mtx_assesment_list_monitoring', {
                url: '/mtx/transaksi/mtx-assesment-list-monitoring',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/transaksi/mtx-assesment-list-monitoring/mtx-assesment-list-monitoring.html',
                        controller: 'MtxAssesmentListMonitoringController as vm'
                    }
                },
                params: {
                    obj: null
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.transaksi.mtx-assesment-list-monitoring')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxAssesmentListMonitoringController', MtxAssesmentListMonitoringController);

    MtxAssesmentListMonitoringController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast',
        '$http',
        'config',
        '$stateParams'
    ];

    function MtxAssesmentListMonitoringController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast,
        $http,
        config,
        $stateParams
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = {
            bu: null,
            sub_area_id: null,
            group_id: null,
            mtx_main_category_id: null,
            mtx_category_id: null,
            nik: null,
            mtx_main_activity_id: null,
            mtx_activity_id: null,
            score_by: null,
            status: 'All'
        };
        vm.totalEmp = 0;
        vm.totalEmpHasCategory = 0;
        vm.isCollapse = false;
        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        // load bt
        vm.loadData = loadData;

        // if (!$stateParams.obj) {
        //     $state.go('app.mtx_transaksi_mtx_assesment_list_monitoring_category');
        // } else {
        // vm.Form.objForm.mtx_categoy_id = $stateParams.obj.mtx_category_id;
        loadData();
        // }

        loadDropdownBu();
        vm.loadDropdownGroupByCompany = loadDropdownGroupByCompany;
        vm.loadDropdownSubArea = loadDropdownSubArea;
        vm.viewDataEmployementBySubArea = viewDataEmployementBySubArea;
        vm.loadDropdownMainCategory = loadDropdownMainCategory;
        vm.loadDropdownCategoryByMainCategory = loadDropdownCategoryByMainCategory;
        vm.loadDropdownEmp = loadDropdownEmp;
        vm.loadDropdownMainActivity = loadDropdownMainActivity;
        vm.loadDropdownActivity = loadDropdownActivity;

        function loadData() {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxScoreSkillEmpListMonitoring',
                mtx_category_id: null,
                search: vm.search
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listData = data[0].aData;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listData = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.activity_id = vm.activity.id;
            vm.Form.objForm.data_mtx_score = vm.listData;
            var response = Form.saveData('saveDataMtxSkillScore', formController, Mtx);
            response.then(function (data) {
                if (data.data == true) {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();
                    vm.Form.pesan = 'Data EMP Matrix Score berhasil disimpan';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.Form.pesan)
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                    );
                    reset();
                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 3000);
                } else {
                    angular.element.unblockUI();
                    vm.Form.tampilPesan = false;
                }

            });

            response.catch(function () {
                vm.messageTheme = 'pink';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Data EMP Matrix Score gagal disimpan')
                        .position('top right')
                        .hideDelay(3000)
                        .theme("error-toast")
                );
                angular.element.unblockUI();
            });
        }


        function reset() {
            vm.listData = [];
        }

        vm.viewDataAssesment = viewDataAssesment;

        function viewDataAssesment(data) {
            $state.go('app.mtx_transaksi_mtx_assesment', {
                obj: data
            });
        }

        vm.lookupEmployee = lookupEmployee;

        function lookupEmployee(searchText) {
            if (searchText.length > 3) {
                return $http
                    .get(config.api + 'api/mtx?action=searchEmployee&search=' + searchText)
                    .then(function (res) {
                        console.log('res', res);
                        var datas = [];
                        for (var i = 0; i < res.data[0].aData.length; i++) {
                            datas.push(res.data[0].aData[i]);
                        }
                        return datas;
                    }).catch(function (err) {
                        console.log('err', err);
                    });
            }
        }

        function loadDropdownBu() {
            angular.element.blockUI();
            var params = {
                action: 'viewDataCompany'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listBu = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownSubArea(company_id) {
            angular.element.blockUI();
            loadDropdownGroupByCompany(company_id);
            var params = {
                action: 'viewDataSubarea',
                company_id: company_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listSubArea = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listSubArea = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownGroupByCompany(company_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: '',
                company_id: company_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory(company_id, group_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: company_id,
                group_id: group_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        function viewDataEmployementBySubArea(sub_area_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataEmployementBySubArea',
                sub_area: sub_area_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.totalEmp = data[0].aData[0].total;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.totalEmp = 0;
                angular.element.unblockUI();
            });
        }

        function loadDropdownCategoryByMainCategory(main_category_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxCategoryByMainCategory',
                main_category_id: main_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownEmp(sub_area_id, mtx_category_id) {
            angular.element.blockUI();
            loadDropdownMainActivity(mtx_category_id);
            var params = {
                action: 'viewDataEmpBySubAreaAndCategory',
                sub_area_id: sub_area_id,
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listEmployee = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listEmployee = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainActivity(mtx_category_id) {
            var params = {
                action: 'viewDataMtxMainActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainActivity = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownActivity(main_activity_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                main_activity_id: main_activity_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listActivity = [];
                angular.element.unblockUI();
            });
        }

        vm.showDetail = showDetail;



        function showDetail($event, data) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxScoreSkillDetail',
                nik: data.employemeny_nik,
                score_by: data.score_by,
                mtx_activity_id: data.mtx_activity_id,
                type: 'scoring'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {

                $mdDialog.show({
                    parent: angular.element(document.body),
                    targetEvent: $event,
                    templateUrl: 'app/main/mtx/transaksi/mtx-assesment-list-monitoring/detail-assesment.html',
                    locals: {
                        items: data[0].aData
                    },
                    clickOutsideToClose: true,
                    fullscreen: true, // Only for -xs, -sm breakpoints.
                    controller: DialogController,
                    onRemoving: function (event, promise) {
                        console.log('onRemoving', event, promise, $mdDialog)
                    },
                    preserveScope: true
                }).then(function (response) {
                    data[type] = response;
                }).catch(function (responseIfRejected) {

                }).finally(function () {
                });

                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                angular.element.unblockUI();
            });



            function DialogController($scope, $mdDialog, items) {
                $scope.listDataDetail = items;

                for (var i = 0; i < $scope.listDataDetail.length; i++) {
                    for (var k = 0; k < $scope.listDataDetail[i].skill.length; k++) {
                        if ($scope.listDataDetail[i].skill[k].skill_indikator.length == 0) {
                            $scope.listDataDetail[i].skill.splice(k, 1);
                            k--;
                        } else {
                            for (var j = 0; j < $scope.listDataDetail[i].skill[k].skill_indikator.length; j++) {
                                $scope.listDataDetail[i].skill[k].skill_indikator[j].validasi = ($scope.listDataDetail[i].skill[k].skill_indikator[j].score == '5') ? true : false;
                            }
                        }
                    }
                }

                console.log($scope.listDataDetail);
                $scope.closeDialog = function () {
                    $mdDialog.hide($scope.description);
                }
                $scope.countCekIndikator = countCekIndikator;
                function countCekIndikator(data, index) {
                    var cek = 0;
                    for (var i = 0; i < data.skill[index].skill_indikator.length; i++) {
                        if (data.skill[index].skill_indikator[i].validasi) {
                            cek++;
                        }
                    }

                    return cek;
                }
            }




        }



    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.transaksi.mtx-assesment-list-category', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_transaksi_mtx_assesment_list_category', {
                url: '/mtx/transaksi/mtx-assesment-list-category',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/transaksi/mtx-assesment-list-category/mtx-assesment-list-category.html',
                        controller: 'MtxAssesmentListCategoryController as vm'
                    }
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.transaksi.mtx-assesment-list-category')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxAssesmentListCategoryController', MtxAssesmentListCategoryController);

    MtxAssesmentListCategoryController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast',
        '$http',
        'config'
    ];

    function MtxAssesmentListCategoryController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast,
        $http,
        config
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';
        vm.totalEmp = 0;
        vm.totalEmpHasCategory = 0;
        vm.isCollapse = false;

        vm.listAssesmentCategory = [
            // {
            //     mtx_name_category: 'Nextar',
            //     mtx__main_name_category: 'Biscuit',
            //     mtx_category_id: 1,
            //     count_assesment: 50,
            //     count_assesment_process: 10,
            // },
            // {
            //     mtx_name_category: 'Bismut',
            //     mtx__main_name_category: 'Biscuit',
            //     mtx_category_id: 2,
            //     count_assesment: 100,
            //     count_assesment_process: 40,
            // },
            // {
            //     mtx_name_category: 'Nextar',
            //     mtx__main_name_category: 'Biscuit',
            //     mtx_category_id: 1,
            //     count_assesment: 50,
            //     count_assesment_process: 10,
            // },
            // {
            //     mtx_name_category: 'Bismut',
            //     mtx__main_name_category: 'Biscuit',
            //     mtx_category_id: 2,
            //     count_assesment: 100,
            //     count_assesment_process: 40,
            // },
            // {
            //     mtx_name_category: 'Nextar',
            //     mtx__main_name_category: 'Biscuit',
            //     mtx_category_id: 1,
            //     count_assesment: 50,
            //     count_assesment_process: 10,
            // },
            // {
            //     mtx_name_category: 'Bismut',
            //     mtx__main_name_category: 'Biscuit',
            //     mtx_category_id: 2,
            //     count_assesment: 100,
            //     count_assesment_process: 40,
            // },
            // {
            //     mtx_name_category: 'Nextar',
            //     mtx__main_name_category: 'Biscuit',
            //     mtx_category_id: 1,
            //     count_assesment: 50,
            //     count_assesment_process: 10,
            // },
            // {
            //     mtx_name_category: 'Bismut',
            //     mtx__main_name_category: 'Biscuit',
            //     mtx_category_id: 2,
            //     count_assesment: 100,
            //     count_assesment_process: 40,
            // },
            // {
            //     mtx_name_category: 'Nextar',
            //     mtx__main_name_category: 'Biscuit',
            //     mtx_category_id: 1,
            //     count_assesment: 50,
            //     count_assesment_process: 10,
            // },
            // {
            //     mtx_name_category: 'Bismut',
            //     mtx__main_name_category: 'Biscuit',
            //     mtx_category_id: 2,
            //     count_assesment: 100,
            //     count_assesment_process: 40,
            // }
        ]

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        // load bt
        vm.loadData = loadData;
        loadData();
        function loadData() {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxAssesmentCategory',
                search: (vm.search) ? vm.search.nik : ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listAssesmentCategory = data[0].aData;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listAssesmentCategory = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.activity_id = vm.activity.id;
            vm.Form.objForm.data_mtx_score = vm.listData;
            var response = Form.saveData('saveDataMtxSkillScore', formController, Mtx);
            response.then(function (data) {
                if (data.data == true) {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();
                    vm.Form.pesan = 'Data EMP Matrix Score berhasil disimpan';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.Form.pesan)
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                    );
                    reset();
                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 3000);
                } else {
                    angular.element.unblockUI();
                    vm.Form.tampilPesan = false;
                }

            });

            response.catch(function () {
                vm.messageTheme = 'pink';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Data EMP Matrix Score gagal disimpan')
                        .position('top right')
                        .hideDelay(3000)
                        .theme("error-toast")
                );
                angular.element.unblockUI();
            });
        }


        function reset() {
            vm.listData = [];
        }

        vm.viewDataAssesment = viewDataAssesment;

        function viewDataAssesment(data) {
            $state.go('app.mtx_transaksi_mtx_assesment_list', {
                obj: data
            });
        }





    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.transaksi.mtx-assesment-list', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_transaksi_mtx_assesment_list', {
                url: '/mtx/transaksi/mtx-assesment-list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/transaksi/mtx-assesment-list/mtx-assesment-list.html',
                        controller: 'MtxAssesmentListController as vm'
                    }
                },
                params: {
                    obj: null
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.transaksi.mtx-assesment-list')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxAssesmentListController', MtxAssesmentListController);

    MtxAssesmentListController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast',
        '$http',
        'config',
        '$stateParams'
    ];

    function MtxAssesmentListController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast,
        $http,
        config,
        $stateParams
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';
        vm.totalEmp = 0;
        vm.totalEmpHasCategory = 0;
        vm.isCollapse = false;
        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        // load bt
        vm.loadData = loadData;

        if (!$stateParams.obj) {
            $state.go('app.mtx_transaksi_mtx_assesment_list_category');
        } else {
            vm.Form.objForm.mtx_categoy_id = $stateParams.obj.mtx_category_id;
            loadData();
        }

        loadData();
        function loadData() {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxScoreSkillEmpList',
                mtx_category_id: vm.Form.objForm.mtx_categoy_id,
                search: (vm.search) ? vm.search.nik : ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listData = data[0].aData;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listData = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.activity_id = vm.activity.id;
            vm.Form.objForm.data_mtx_score = vm.listData;
            var response = Form.saveData('saveDataMtxSkillScore', formController, Mtx);
            response.then(function (data) {
                if (data.data == true) {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();
                    vm.Form.pesan = 'Data EMP Matrix Score berhasil disimpan';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.Form.pesan)
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                    );
                    reset();
                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 3000);
                } else {
                    angular.element.unblockUI();
                    vm.Form.tampilPesan = false;
                }

            });

            response.catch(function () {
                vm.messageTheme = 'pink';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Data EMP Matrix Score gagal disimpan')
                        .position('top right')
                        .hideDelay(3000)
                        .theme("error-toast")
                );
                angular.element.unblockUI();
            });
        }


        function reset() {
            vm.listData = [];
        }

        vm.viewDataAssesment = viewDataAssesment;

        function viewDataAssesment(data) {
            $state.go('app.mtx_transaksi_mtx_assesment', {
                obj: data
            });
        }

        vm.lookupEmployee = lookupEmployee;

        function lookupEmployee(searchText) {
            if (searchText.length > 3) {
                return $http
                    .get(config.api + 'api/mtx?action=searchEmployee&search=' + searchText)
                    .then(function (res) {
                        console.log('res', res);
                        var datas = [];
                        for (var i = 0; i < res.data[0].aData.length; i++) {
                            datas.push(res.data[0].aData[i]);
                        }
                        return datas;
                    }).catch(function (err) {
                        console.log('err', err);
                    });
            }
        }

    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.transaksi.mtx-assesment-approval', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_transaksi_mtx_assesment_approval', {
                url: '/mtx/transaksi/mtx-assesment-approval',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/transaksi/mtx-assesment-approval/mtx-assesment-approval.html',
                        controller: 'MtxAssesmentApprovalController as vm'
                    }
                },
                params: {
                    obj: null
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.transaksi.mtx-assesment-approval')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxAssesmentApprovalController', MtxAssesmentApprovalController);

    MtxAssesmentApprovalController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast',
        '$http',
        'config',
        '$stateParams'
    ];

    function MtxAssesmentApprovalController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast,
        $http,
        config,
        $stateParams
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';
        vm.totalEmp = 0;
        vm.totalEmpHasCategory = 0;
        vm.isCollapse = false;
        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        // load bt
        vm.loadData = loadData;

        loadData();
        function loadData() {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxApproval',
                mtx_category_id: 19,
                search: (vm.search) ? vm.search.nik : ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listData = data[0].aData;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listData = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.activity_id = vm.activity.id;
            vm.Form.objForm.data_mtx_score = vm.listData;
            var response = Form.saveData('saveDataMtxSkillScore', formController, Mtx);
            response.then(function (data) {
                if (data.data == true) {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();
                    vm.Form.pesan = 'Data EMP Matrix Score berhasil disimpan';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.Form.pesan)
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                    );
                    reset();
                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 3000);
                } else {
                    angular.element.unblockUI();
                    vm.Form.tampilPesan = false;
                }

            });

            response.catch(function () {
                vm.messageTheme = 'pink';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Data EMP Matrix Score gagal disimpan')
                        .position('top right')
                        .hideDelay(3000)
                        .theme("error-toast")
                );
                angular.element.unblockUI();
            });
        }


        function reset() {
            vm.listData = [];
        }

        vm.viewDataAssesment = viewDataAssesment;

        function viewDataAssesment(data) {
            $state.go('app.mtx_transaksi_mtx_assesment', {
                obj: data
            });
        }

        vm.lookupEmployee = lookupEmployee;

        function lookupEmployee(searchText) {
            if (searchText.length > 3) {
                return $http
                    .get(config.api + 'api/mtx?action=searchEmployee&search=' + searchText)
                    .then(function (res) {
                        console.log('res', res);
                        var datas = [];
                        for (var i = 0; i < res.data[0].aData.length; i++) {
                            datas.push(res.data[0].aData[i]);
                        }
                        return datas;
                    }).catch(function (err) {
                        console.log('err', err);
                    });
            }
        }

        vm.viewDataDetailScore = viewDataDetailScore

        function viewDataDetailScore($event, data) {



            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                templateUrl: 'app/main/mtx/transaksi/mtx-assesment-approval/mtx-assesment-approval-detail.html',
                locals: {
                    items: data
                },
                clickOutsideToClose: true,
                fullscreen: true, // Only for -xs, -sm breakpoints.
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                }
            }
        }

        vm.approve = approve;

        function approve(ev, dataApprove, status_approve) {
            var attr = angular.element(ev.target).attr('atribute');
            var promise = Auth.setToken();
            if (status_approve == '1') {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to Approve this list?')
                    .textContent('You are is the last approval, Data your selected will be approve.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });
                promise.then(function () {
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var atp = new Mtx();

                        atp.data = {
                            status_approve: status_approve,
                            comment: '-',
                            dataApprove: dataApprove
                        };
                        atp.action = 'approveMtx';
                        var response = atp.$save();
                        response.then(function (data) {
                            successApproved(ev, data);
                            angular.element.unblockUI();
                        });
                        response.catch(function (data) {
                            failedApproved(ev, data);
                            angular.element.unblockUI();
                        });
                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            } else if (status_approve == '0') {
                var confirm = $mdDialog.prompt()
                    .title('Are you sure you want to reject approval?')
                    .textContent('Please Set Reason of Rejection Approval.')
                    .placeholder('Reason')
                    .ariaLabel('Reason')
                    .initialValue('Rejected')
                    .targetEvent(ev)
                    .ok('Submit')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function (result) {
                    if (!result || result == '') {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Please Set Reason of Rejection Approval')
                                .position('top right')
                                .hideDelay(3000)
                                .theme("warn-toast")
                        );
                    } else {
                        angular.element.blockUI();
                        var atp = new Mtx();
                        atp.data = {
                            status_approve: status_approve,
                            comment: result,
                            dataApprove: dataApprove
                        };
                        atp.action = 'approveMtx';
                        var response = atp.$save();
                        response.then(function (data) {
                            successApproved(ev, data);
                            angular.element.unblockUI();
                        });
                        response.catch(function (data) {
                            failedApproved(ev, data);
                            angular.element.unblockUI();
                        });
                    }

                }, function () { });
            }

        }

        function successApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Thanks for Approval')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                loadData(1);
                // viewDataATp();
            });
        }

        function failedApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Approval')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                loadData(1);
                // viewDataATp();
            });
        }


    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.transaksi.mtx-assesment', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_transaksi_mtx_assesment', {
                url: '/mtx/transaksi/mtx-assesment',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/transaksi/mtx-assesment/mtx-assesment.html',
                        controller: 'MtxAssesmentController as vm'
                    }
                },
                params: {
                    obj: null
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.transaksi.mtx-assesment')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxAssesmentController', MtxAssesmentController);

    MtxAssesmentController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast',
        '$stateParams'
    ];

    function MtxAssesmentController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast,
        $stateParams
    ) {



        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';
        vm.totalEmp = 0;
        vm.totalEmpHasCategory = 0;
        vm.isCollapse = false;
        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }



        // load bt
        vm.loadData = loadData;
        // reset();
        if (!$stateParams.obj) {
            $state.go('app.mtx_transaksi_mtx_assesment_list');
        } else {
            vm.Form.objForm.emp_name = $stateParams.obj.emp_name;
            vm.Form.objForm.nik = $stateParams.obj.employemeny_nik;
            loadData();
        }
        // loadDropdownMainCategory();
        loadDropdownBu();
        vm.loadDropdownGroupByCompany = loadDropdownGroupByCompany;
        vm.loadDropdownSubArea = loadDropdownSubArea;
        vm.viewDataEmployementBySubArea = viewDataEmployementBySubArea;
        vm.loadDropdownMainCategory = loadDropdownMainCategory;
        vm.loadDropdownCategoryByMainCategory = loadDropdownCategoryByMainCategory;
        vm.loadDropdownEmp = loadDropdownEmp;
        vm.loadDropdownMainActivity = loadDropdownMainActivity;
        vm.loadDropdownActivity = loadDropdownActivity;

        function loadData() {
            angular.element.blockUI();
            // vm.activity = JSON.parse(vm.Form.objForm.mtx_activity_id);
            var params = {
                action: 'viewDataMtxScoreSkill',
                // mtx_activity_id: vm.activity.id,
                nik: vm.Form.objForm.nik,
                type: 'scoring'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listData = data[0].aData;
                for (var i = 0; i < vm.listData.length; i++) {
                    for (var k = 0; k < vm.listData[i].skill.length; k++) {
                        if (vm.listData[i].skill[k].skill_indikator.length == 0) {
                            vm.listData[i].skill.splice(k, 1);
                            k--;
                        } else {
                            for (var j = 0; j < vm.listData[i].skill[k].skill_indikator.length; j++) {
                                vm.listData[i].skill[k].skill_indikator[j].validasi = (vm.listData[i].skill[k].skill_indikator[j].score == '5') ? true : false;
                            }
                        }
                    }
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listData = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownBu() {
            angular.element.blockUI();
            var params = {
                action: 'viewDataCompany'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listBu = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownSubArea(company_id) {
            angular.element.blockUI();
            loadDropdownGroupByCompany(company_id);
            var params = {
                action: 'viewDataSubarea',
                company_id: company_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listSubArea = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listSubArea = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownGroupByCompany(company_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: '',
                company_id: company_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory(company_id, group_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: company_id,
                group_id: group_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        function viewDataEmployementBySubArea(sub_area_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataEmployementBySubArea',
                sub_area: sub_area_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.totalEmp = data[0].aData[0].total;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.totalEmp = 0;
                angular.element.unblockUI();
            });
        }

        function loadDropdownCategoryByMainCategory(main_category_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxCategoryByMainCategory',
                main_category_id: main_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownEmp(sub_area_id, mtx_category_id) {
            angular.element.blockUI();
            loadDropdownMainActivity(mtx_category_id);
            var params = {
                action: 'viewDataEmpBySubAreaAndCategory',
                sub_area_id: sub_area_id,
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listEmployee = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listEmployee = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainActivity(mtx_category_id) {
            var params = {
                action: 'viewDataMtxMainActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainActivity = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownActivity(main_activity_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                main_activity_id: main_activity_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listActivity = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.data_mtx_score = vm.listData;
            var response = Form.saveData('saveDataMtxSkillScore', formController, Mtx);
            response.then(function (data) {
                if (data.data == true) {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();
                    vm.Form.pesan = 'Data EMP Matrix Score berhasil disimpan';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.Form.pesan)
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                    );
                    reset();
                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 3000);
                } else {
                    angular.element.unblockUI();
                    vm.Form.tampilPesan = false;
                }

            });

            response.catch(function () {
                vm.messageTheme = 'pink';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Data EMP Matrix Score gagal disimpan')
                        .position('top right')
                        .hideDelay(3000)
                        .theme("error-toast")
                );
                angular.element.unblockUI();
            });
        }


        function reset() {
            vm.listData = [];
            $state.go('app.mtx_transaksi_mtx_assesment_list');
        }

        vm.countCekIndikator = countCekIndikator;

        function countCekIndikator(data, index) {
            var cek = 0;
            for (var i = 0; i < data.skill[index].skill_indikator.length; i++) {
                if (data.skill[index].skill_indikator[i].validasi) {
                    cek++;
                }
            }

            return cek;
        }
    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.master.mtx-sub-area-has-category', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_master_mtx_sub_area_has_category', {
                url: '/mtx/master/mtx-sub-area-has-category',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/master/mtx-sub-area-has-category/mtx-sub-area-has-category.html',
                        controller: 'MtxSubAreaHasCategoryController as vm'
                    }
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.master.mtx-sub-area-has-category')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxSubAreaHasCategoryController', MtxSubAreaHasCategoryController);

    MtxSubAreaHasCategoryController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast'
    ];

    function MtxSubAreaHasCategoryController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;

        vm.Form.objForm.mtx_category_id = [];

        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.editData = editData;
        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }





        // load bt
        vm.loadData = loadData;
        reset();
        loadDropdownBu();
        vm.loadDropdownSubArea = loadDropdownSubArea;
        vm.viewDataEmployementBySubArea = viewDataEmployementBySubArea;

        function loadData(pageno, sub_area) {
            angular.element.blockUI();
            vm.DataTable.loadData(Mtx, pageno, {
                action: 'viewDataMtxSubAreaHasCategory',
                search: vm.search,
                sub_area: (sub_area) ? sub_area : 'All'
            });

            console.log(vm.DataTable)
        }

        function loadDropdownBu() {
            var params = {
                action: 'viewDataCompany'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listBu = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownSubArea(company_id) {
            loadDropdownMainCategory(company_id);
            var params = {
                action: 'viewDataSubarea',
                company_id: company_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listSubArea = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listSubArea = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory(company_id) {
            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: company_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function viewDataEmployementBySubArea(sub_area_id) {
            var params = {
                action: 'viewDataEmployementBySubArea',
                sub_area: sub_area_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                // vm.listCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                // vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            if (vm.listDataSelected.length > 0) {
                vm.Form.objForm.mtx_category_id = [];
                vm.Form.objForm.sub_area_id = vm.listDataSelected[0].sub_area_id;
                vm.Form.objForm.mtx_category_id.push(vm.listDataSelected[0].mtx_category_id);
                vm.Form.objForm.bu = vm.listDataSelected[0].bu_id;
                vm.Form.objForm.id = vm.listDataSelected[0].id;
                deleteData(ev, formController);
            } else {
                angular.element.blockUI();

                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;
                var response = Form.saveData('saveDataMasterMtxSubAreaHasCategory', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data EMP Matrix Sub Area Has Category berhasil disimpan';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data EMP Matrix Sub Area Has Category gagal disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });
            }
        }

        function editData(data) {
            reset();
            vm.manageMasterForm.postMethod = 'Update';
            vm.Form.objForm.sub_area_id = data.sub_area_id;
            vm.Form.objForm.bu = data.bu_id;
            vm.Form.objForm.mtx_category_id.push(data.mtx_category_id);
            vm.Form.objForm.id = data.id;
            loadDropdownSubArea(data.bu_id);
            loadDropdownMainCategory(data.bu_id);
        }

        function deleteData(ev, formController) {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

            $mdDialog.show(confirm).then(function () {
                angular.element.blockUI();

                vm.Form.objForm.data = [];
                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;

                for (var i = 0; i < vm.listDataSelected.length; i++) {
                    vm.Form.objForm.data.push({
                        id: vm.listDataSelected[i].id
                    })
                }

                var response = Form.saveData('deleteDataMasterMtxSubAreaHasCategory', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data Master Matrix Sub Area Has Category berhasil dihapus';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data Master Matrix Sub Area Has Category gagal dihapus')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });

            }, function () {
                // $scope.status = 'You decided to keep your debt.';
            });


        }

        function reset() {
            loadData(1, 'All');
            vm.listDataSelected = [];
            vm.manageMasterForm = {
                postMethod: 'Save',
                mtx_category_id: null,
                sub_area_id: null,
                id: null
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.master.mtx-skill-activity', ['ui.tinymce']).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_master_mtx_skill_activity', {
                url: '/mtx/master/mtx-skill-activity',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/master/mtx-skill-activity/mtx-skill-activity.html',
                        controller: 'MtxSkillActivityController as vm'
                    }
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.master.mtx-skill-activity')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxSkillActivityController', MtxSkillActivityController);

    MtxSkillActivityController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast'
    ];

    function MtxSkillActivityController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast
    ) {



        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];




        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.editData = editData;
        vm.saveData = saveData;
        vm.reset = reset;
        vm.addScore = addScore;
        vm.deletListScore = deletListScore;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();


        vm.mtxActivityScore = 0;
        vm.mtxSkillIndikator = 0;
        vm.tableActivityScoreAktif = true;
        vm.tableSkillIndikatorAktif = true;

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }





        // load bt
        vm.loadData = loadData;


        reset();
        loadDropdownActivity();

        function loadData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(Mtx, pageno, {
                action: 'viewDataMtxSkillActivity',
                searchFilter: vm.search
            });

            console.log(vm.DataTable)
        }

        function loadDropdownActivity() {
            var params = {
                action: 'viewDataMtxActivity',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listActivity = data[0].aData;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listActivity = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            if (vm.listDataSelected.length > 0) {
                vm.Form.objForm.mtx_activity_id = vm.listDataSelected[0].mtx_activity_id;
                vm.Form.objForm.skill_name = vm.listDataSelected[0].skill_name;
                vm.Form.objForm.order_no = vm.listDataSelected[0].order_no;
                vm.Form.objForm.id = vm.listDataSelected[0].id;

                deleteData(ev, formController);
            } else {
                angular.element.blockUI();

                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;
                var response = Form.saveData('saveDataMasterMtxSkillActivity', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data EMP Matrix Activity berhasil disimpan';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data EMP Matrix Activity gagal disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });
            }
        }

        function editData(data) {
            reset();
            vm.manageMasterForm.postMethod = 'Update';
            vm.Form.objForm.skill_name = data.skill_name;
            vm.Form.objForm.mtx_activity_id = data.mtx_activity_id;
            vm.Form.objForm.order_no = parseInt(data.order_no);
            if (data.score.length > 0) {
                vm.Form.objForm.activity_score = [];
            }
            for (var i = 0; i < data.score.length; i++) {
                vm.Form.objForm.activity_score.push({
                    id: data.score[i].id,
                    level: parseInt(data.score[i].level),
                    mtx_skill_activity_id: data.score[i].mtx_skill_activity_id,
                    weight: parseFloat(data.score[i].weight * 100)
                })
            }

            for (var i = 0; i < data.skill_indikator.length; i++) {
                vm.Form.objForm.skill_indikator.push({
                    id: data.skill_indikator[i].id,
                    description: data.skill_indikator[i].description,
                    instruction_number: parseInt(data.skill_indikator[i].instruction_number),
                    order_no: parseInt(data.skill_indikator[i].order_no),
                    succession_criteria: data.skill_indikator[i].succession_criteria,
                    mtx_skill_indikator_id: data.skill_indikator[i].mtx_skill_indikator_id,
                })
            }

            vm.Form.objForm.id = data.id;
        }

        function deleteData(ev, formController) {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

            $mdDialog.show(confirm).then(function () {
                angular.element.blockUI();

                vm.Form.objForm.data = [];
                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;

                for (var i = 0; i < vm.listDataSelected.length; i++) {
                    vm.Form.objForm.data.push({
                        id: vm.listDataSelected[i].id
                    })
                }

                var response = Form.saveData('deleteDataMasterMtxSkillActivity', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data Master Matrix Activity berhasil dihapus';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data Master Matrix Activity gagal dihapus')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });

            }, function () {
                // $scope.status = 'You decided to keep your debt.';
            });


        }

        function reset() {
            vm.search = {
                group: 'All',
                main_category: 'All',
                category: 'All',
                main_activity: 'All',
                activity: 'All',
                skill_name: ''
            };
            loadData(1);
            loadDropdownGroup();
            loadDropdownMainCategory();
            loadDropdownCategory();
            loadDropdownMainActivity();
            vm.listDataSelected = [];
            vm.Form.objForm.activity_score = [
                {
                    level: 0,
                    weight: 0
                },
                {
                    level: 1,
                    weight: 50
                },
                {
                    level: 2,
                    weight: 75
                },
                {
                    level: 3,
                    weight: 100
                }
            ];
            vm.Form.objForm.skill_indikator = [];
            vm.manageMasterForm = {
                // postMethod: 'Save',
                postMethod: 'Save',
                mtx_activity_id: null,
                skill_name: null,
                order_no: null,
                activity_score: [],
                skill_indikator: [],
                id: null
            };

        }


        function addScore() {
            vm.Form.objForm.activity_score.push({
                level: null,
                weight: null
            })
        }


        function deletListScore(index) {
            vm.Form.objForm.activity_score.splice(index, 1);
        }

        vm.addSkillIndikator = addSkillIndikator;
        vm.deletListSkillIndikator = deletListSkillIndikator;

        function addSkillIndikator() {
            vm.Form.objForm.skill_indikator.push({
                description: null,
                instruction_number: null,
                id: null,
                mtx_skill_indikator_id: null
            })
        }


        function deletListSkillIndikator(index, ev) {
            if (vm.Form.objForm.skill_indikator[index].id) {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();

                    Mtx.get({
                        action: 'deleteDataMasterMtxSkillIndikator',
                        skill_delete: vm.Form.objForm.skill_indikator[index].id
                    }, function (mtx, getResponseHeaders) {
                        mtx.action = 'deleteDataMasterMtxSkillIndikator';
                        mtx.skill_delete = vm.Form.objForm.skill_indikator[index].id;
                        mtx.$save(function (mtx, putResponseHeaders) {
                            vm.messageTheme = 'blue';
                            vm.Form.pesan = 'Data Master Matrix Skill Indikator berhasil dihapus';
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(vm.Form.pesan)
                                    .position('top right')
                                    .hideDelay(3000)
                                    .theme("success-toast")
                            );
                            $timeout(function () {
                                vm.Form.tampilPesan = false;
                                vm.Form.objForm.skill_indikator.splice(index, 1);
                                angular.element.unblockUI();
                            }, 3000);
                        });
                        mtx.$promise.catch(errorFetch);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            } else {
                angular.element.unblockUI();
                vm.Form.objForm.skill_indikator.splice(index, 1);
            }

        }

        function errorFetch() {
            angular.element.unblockUI();

        }

        vm.setActivityScore = setActivityScore;

        function setActivityScore() {
            if (vm.tableActivityScoreAktif) {
                vm.tableActivityScoreAktif = false;
            } else {
                vm.tableActivityScoreAktif = true;
            }
        }

        vm.setSkillIndikator = setSkillIndikator;

        function setSkillIndikator() {
            if (vm.tableSkillIndikatorAktif) {
                vm.tableSkillIndikatorAktif = false;
            } else {
                vm.tableSkillIndikatorAktif = true;
            }
        }

        function loadDropdownGroup() {
            vm.listGroup = [];
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });
                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listGroup.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].group_name + '/' + data[0].aData[i].bu_name,
                        filter: data[0].aData[i].bu
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory() {
            vm.listMainCategory = [];



            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: 'All',
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });

                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listMainCategory.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].main_category_name + '/' + data[0].aData[i].bu_name,
                        filter: data[0].aData[i].bu
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownCategory() {
            vm.listCategory = [];
            var params = {
                action: 'viewDataDropdownMtxCategory',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCategory.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });

                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listCategory.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].main_category_name + '/' + data[0].aData[i].category_name,
                        filter: data[0].aData[i].mtx_main_category_id
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainActivity() {
            vm.listMainActivity = [];
            var params = {
                action: 'viewDataMtxMainActivity',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {

                vm.listMainActivity.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });

                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listMainActivity.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].category_name + '/' + data[0].aData[i].main_activity_name,
                        filter: data[0].aData[i].mtx_category_id
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainActivity = [];
                angular.element.unblockUI();
            });
        }

        vm.showFilterChecked = showFilterChecked;
        vm.showFilter = false;

        function showFilterChecked() {
            if (vm.showFilter) {
                vm.showFilter = false;
            } else {
                vm.showFilter = true;
            }
        }

        vm.showDetail = showDetail;

        function showDetail($event, text, type, data) {

            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                templateUrl: 'app/main/mtx/master/mtx-skill-activity/detail-description.html',
                locals: {
                    items: text
                },
                clickOutsideToClose: true,
                fullscreen: true, // Only for -xs, -sm breakpoints.
                controller: DialogController,
                onRemoving: function (event, promise) {
                    console.log('onRemoving', event, promise, $mdDialog)
                },
                preserveScope: true
            }).then(function (response) {
                data[type] = response;
            }).catch(function (responseIfRejected) {

            }).finally(function () {
            });

            function DialogController($scope, $mdDialog, items) {
                // $scope.tinymceOptions = {
                //     inline: false,
                //     plugins: 'example | table',
                //     menubar: 'example | table',
                //     toolbar: 'example | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol'
                // };
                $scope.description = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide($scope.description);
                }
            }




        }

    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.master.mtx-ref-group', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_master_mtx_ref_group', {
                url: '/mtx/master/mtx-ref-group',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/master/mtx-ref-group/mtx-ref-group.html',
                        controller: 'MtxRefGroupController as vm'
                    }
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.master.mtx-ref-group')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxRefGroupController', MtxRefGroupController);

    MtxRefGroupController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast'
    ];

    function MtxRefGroupController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.editData = editData;
        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }





        // load bt
        vm.loadData = loadData;
        reset();
        loadDropdownBu();

        function loadData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(Mtx, pageno, {
                action: 'viewDataMtxRefGroup',
                search: vm.search
            });

            console.log(vm.DataTable)
        }

        function loadDropdownBu() {
            var params = {
                action: 'viewDataCompany'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listBu = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            if (vm.listDataSelected.length > 0) {
                vm.Form.objForm.group_name = vm.listDataSelected[0].group_name;
                vm.Form.objForm.bu = vm.listDataSelected[0].bu;
                vm.Form.objForm.id = vm.listDataSelected[0].id;
                deleteData(ev, formController);
            } else {
                angular.element.blockUI();

                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;
                var response = Form.saveData('saveDataMasterMtxRefGroup', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data EMP Matrix Ref Group berhasil disimpan';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data EMP Matrix Ref Group gagal disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });
            }
        }

        function editData(data) {
            reset();
            vm.manageMasterForm.postMethod = 'Update';
            vm.Form.objForm.group_name = data.group_name;
            vm.Form.objForm.bu = data.bu;
            vm.Form.objForm.id = data.id;
        }

        function deleteData(ev, formController) {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

            $mdDialog.show(confirm).then(function () {
                angular.element.blockUI();

                vm.Form.objForm.data = [];
                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;

                for (var i = 0; i < vm.listDataSelected.length; i++) {
                    vm.Form.objForm.data.push({
                        id: vm.listDataSelected[i].id
                    })
                }

                var response = Form.saveData('deleteDataMasterMtxRefGroup', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data Master Matrix Ref Group berhasil dihapus';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data Master Matrix Ref Group gagal dihapus')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });

            }, function () {
                // $scope.status = 'You decided to keep your debt.';
            });


        }

        function reset() {
            loadData(1);
            vm.listDataSelected = [];
            vm.manageMasterForm = {
                postMethod: 'Save',
                group_name: null,
                bu: null,
                id: null
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.master.mtx-main-category', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_master_mtx_main_category', {
                url: '/mtx/master/mtx-main-category',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/master/mtx-main-category/mtx-main-category.html',
                        controller: 'MtxMainCategoryController as vm'
                    }
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.master.mtx-main-category')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxMainCategoryController', MtxMainCategoryController);

    MtxMainCategoryController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast'
    ];

    function MtxMainCategoryController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.editData = editData;
        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }





        // load bt
        vm.loadData = loadData;
        reset();
        loadDropdownBu();
        loadDropdownGroup();
        loadDropdownCountry();

        function loadData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(Mtx, pageno, {
                action: 'viewDataMtxMainCategory',
                search: vm.search
            });

            console.log(vm.DataTable)
        }

        function loadDropdownGroup() {
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownBu() {
            var params = {
                action: 'viewDataCompany'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listBu = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownCountry() {
            var params = {
                action: 'viewDataCountry'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCountry = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCountry = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            if (vm.listDataSelected.length > 0) {
                vm.Form.objForm.main_category_name = vm.listDataSelected[0].main_category_name;
                vm.Form.objForm.description = vm.listDataSelected[0].description;
                vm.Form.objForm.bu = vm.listDataSelected[0].bu;
                vm.Form.objForm.country_id = vm.listDataSelected[0].country_id;
                vm.Form.objForm.group_id = vm.listDataSelected[0].group_id;
                vm.Form.objForm.id = vm.listDataSelected[0].id;
                deleteData(ev, formController);
            } else {
                angular.element.blockUI();

                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;
                var response = Form.saveData('saveDataMasterMtxMainCategory', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data EMP Matrix Main Category berhasil disimpan';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data EMP Matrix Main Category gagal disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });
            }
        }

        function editData(data) {
            reset();
            vm.manageMasterForm.postMethod = 'Update';
            vm.Form.objForm.main_category_name = data.main_category_name;
            vm.Form.objForm.description = data.description;
            vm.Form.objForm.country_id = data.country_id;
            vm.Form.objForm.bu = data.bu;
            vm.Form.objForm.group_id = data.group_id;
            vm.Form.objForm.id = data.id;
        }

        function deleteData(ev, formController) {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

            $mdDialog.show(confirm).then(function () {
                angular.element.blockUI();

                vm.Form.objForm.data = [];
                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;

                for (var i = 0; i < vm.listDataSelected.length; i++) {
                    vm.Form.objForm.data.push({
                        id: vm.listDataSelected[i].id
                    })
                }

                var response = Form.saveData('deleteDataMasterMtxMainCategory', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data Master Matrix Main Category berhasil dihapus';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data Master Matrix Main Category gagal dihapus')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });

            }, function () {
                // $scope.status = 'You decided to keep your debt.';
            });


        }

        function reset() {
            loadData(1);
            vm.listDataSelected = [];
            vm.manageMasterForm = {
                postMethod: 'Save',
                main_category_name: null,
                description: null,
                bu: null,
                country_id: null,
                group_id: null,
                id: null
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.master.mtx-main-activity', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_master_mtx_main_activity', {
                url: '/mtx/master/mtx-main-activity',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/master/mtx-main-activity/mtx-main-activity.html',
                        controller: 'MtxMainActivityController as vm'
                    }
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.master.mtx-main-activity')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxMainActivityController', MtxMainActivityController);

    MtxMainActivityController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast'
    ];

    function MtxMainActivityController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.editData = editData;
        vm.saveData = saveData;
        vm.reset = reset;

        vm.addScore = addScore;
        vm.deletListScore = deletListScore;
        vm.tableActivityScoreAktif = true;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.mtxActivityScore = 0;

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }





        // load bt
        vm.loadData = loadData;
        reset();

        function loadData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(Mtx, pageno, {
                action: 'viewDataMtxMainActivity',
                searchFilter: vm.search
            });

            console.log(vm.DataTable)
        }

        function saveData(ev, formController) {
            if (vm.listDataSelected.length > 0) {
                vm.Form.objForm.mtx_category_id = vm.listDataSelected[0].mtx_category_id;
                vm.Form.objForm.main_activity_name = vm.listDataSelected[0].main_activity_name;
                vm.Form.objForm.id = vm.listDataSelected[0].id;
                deleteData(ev, formController);
            } else {
                angular.element.blockUI();

                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;
                var response = Form.saveData('saveDataMasterMtxMainActivity', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data EMP Matrix Main Activity berhasil disimpan';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data EMP Matrix Main Activity gagal disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });
            }
        }

        function editData(data) {
            reset();
            vm.manageMasterForm.postMethod = 'Update';
            vm.Form.objForm.main_activity_name = data.main_activity_name;
            vm.Form.objForm.mtx_category_id = data.mtx_category_id;
            vm.Form.objForm.id = data.id;

            if (data.score.length > 0) {
                vm.Form.objForm.activity_score = [];
            }
            for (var i = 0; i < data.score.length; i++) {
                vm.Form.objForm.activity_score.push({
                    id: data.score[i].id,
                    level: parseInt(data.score[i].level),
                    mtx_skill_activity_id: data.score[i].mtx_skill_activity_id,
                    weight: parseFloat(data.score[i].weight * 100)
                })
            }
        }

        function deleteData(ev, formController) {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

            $mdDialog.show(confirm).then(function () {
                angular.element.blockUI();

                vm.Form.objForm.data = [];
                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;

                for (var i = 0; i < vm.listDataSelected.length; i++) {
                    vm.Form.objForm.data.push({
                        id: vm.listDataSelected[i].id
                    })
                }

                var response = Form.saveData('deleteDataMasterMtxMainActivity', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data Master Matrix Main Activity berhasil dihapus';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data Master Matrix Main Activity gagal dihapus')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });

            }, function () {
                // $scope.status = 'You decided to keep your debt.';
            });


        }

        function reset() {
            vm.search = {
                group: 'All',
                main_category: 'All',
                category: 'All',
                main_activity_name: ''
            };
            loadData(1);
            loadDropdownGroup();
            loadDropdownMainCategory();
            loadDropdownCategory();
            loadDropdownMainActivity();
            vm.listDataSelected = [];

            vm.Form.objForm.activity_score = [
                {
                    level: 0,
                    weight: 0
                },
                {
                    level: 1,
                    weight: 50
                },
                {
                    level: 2,
                    weight: 75
                },
                {
                    level: 3,
                    weight: 100
                }
            ];

            vm.manageMasterForm = {
                postMethod: 'Save',
                mtx_category_id: null,
                main_activity_name: null,
                id: null
            };
        }

        function addScore() {
            vm.Form.objForm.activity_score.push({
                level: null,
                weight: null
            })
        }


        function deletListScore(index) {
            vm.Form.objForm.activity_score.splice(index, 1);
        }

        vm.setActivityScore = setActivityScore;

        function setActivityScore() {
            if (vm.tableActivityScoreAktif) {
                vm.tableActivityScoreAktif = false;
            } else {
                vm.tableActivityScoreAktif = true;
            }
        }

        function loadDropdownGroup() {
            vm.listGroup = [];
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });
                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listGroup.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].group_name + '/' + data[0].aData[i].bu_name,
                        filter: data[0].aData[i].bu
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory() {
            vm.listMainCategory = [];



            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: 'All',
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });

                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listMainCategory.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].main_category_name + '/' + data[0].aData[i].bu_name,
                        filter: data[0].aData[i].bu
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownCategory() {
            vm.listCategory = [];
            var params = {
                action: 'viewDataDropdownMtxCategory',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCategory.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });

                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listCategory.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].main_category_name + '/' + data[0].aData[i].category_name,
                        filter: data[0].aData[i].mtx_main_category_id
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainActivity() {
            vm.listMainActivity = [];
            var params = {
                action: 'viewDataMtxMainActivity',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {

                vm.listMainActivity.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });

                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listMainActivity.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].category_name + '/' + data[0].aData[i].main_activity_name,
                        filter: data[0].aData[i].mtx_category_id
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainActivity = [];
                angular.element.unblockUI();
            });
        }

        vm.showFilterChecked = showFilterChecked;
        vm.showFilter = false;

        function showFilterChecked() {
            if (vm.showFilter) {
                vm.showFilter = false;
            } else {
                vm.showFilter = true;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mtx.master.mtx-import-emp-assestment')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxImportEmpAssestmentScoreController', MtxImportEmpAssestmentScoreController);

    MtxImportEmpAssestmentScoreController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast',
        '$location',
        '$window',
        'config',
        '$document'
    ];

    function MtxImportEmpAssestmentScoreController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast,
        $location,
        $window,
        config,
        $document
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';
        vm.totalEmp = 0;
        vm.totalEmpHasCategory = 0;

        vm.type = 0;
        vm.activityId = null;
        vm.process = '';
        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        // load bt
        vm.loadData = loadData;
        reset();
        // loadDropdownMainCategory();
        loadDropdownBu();
        vm.loadDropdownGroupByCompany = loadDropdownGroupByCompany;
        vm.loadDropdownSubArea = loadDropdownSubArea;
        vm.viewDataEmployementBySubArea = viewDataEmployementBySubArea;
        vm.loadDropdownMainCategory = loadDropdownMainCategory;
        vm.loadDropdownCategoryByMainCategory = loadDropdownCategoryByMainCategory;
        vm.loadDropdownEmp = loadDropdownEmp;
        vm.loadDropdownMainActivity = loadDropdownMainActivity;
        vm.loadDropdownActivity = loadDropdownActivity;

        function loadData(type, activity, dataEvent) {
            vm.type = type;
            vm.activityId = activity;
            angular.element.blockUI();
            // vm.activity = JSON.parse(vm.Form.objForm.mtx_category_id);
            var params = {
                action: 'viewDataMonitoringMtxScoreSkill',
                mtx_categori_id: vm.Form.objForm.mtx_category_id,
                sub_area_id: vm.Form.objForm.sub_area_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                var datas = data[0];
                if (vm.type == 0) {
                    var headerProcess = [];
                    var empList = [];
                    vm.process = '';
                    var skillCount = 0;
                    for (var j = 0; j < datas.aData.length; j++) {
                        for (var i = 0; i < datas.activity.length; i++) {
                            if (datas.activity[i].activity_name != '#' && datas.activity[i].mtx_main_activity_id == datas.aData[j].id) {
                                headerProcess.push({
                                    skill_name: datas.activity[i].activity_name,
                                    mtx_activity_id: datas.activity[i].id,
                                    level_view: 'nilai',
                                    main_activity_id: datas.aData[j].id,
                                    no: datas.activity[i].no
                                })
                                skillCount++;
                            }
                        }
                        headerProcess.push({
                            skill_name: datas.aData[j].main_activity_name,
                            main_activity_id: datas.aData[j].id,
                            level_view: 'score',
                            no: '#',
                            background: '#eee'
                        })
                    }


                    for (var j = 0; j < datas.aDataEmp.length; j++) {
                        var detail = [];
                        var countSkill = 0;
                        // for (var k = 0; k < headerProcess.length; k++) {
                        for (var i = 0; i < datas.aDataEmp[j].detail.length; i++) {
                            for (var k = 0; k < datas.aDataEmp[j].detail[i].detail.length; k++) {
                                detail.push({
                                    level: datas.aDataEmp[j].detail[i].detail[k].level_warna,
                                    indikator_total_nilai: datas.aDataEmp[j].detail[i].detail[k].indikator_total_nilai
                                })

                                if (datas.aDataEmp[j].detail[i].detail[k].indikator_total_nilai != '0') {
                                    countSkill++;
                                }
                            }
                            detail.push({
                                level: datas.aDataEmp[j].detail[i].level_warna,
                                indikator_total_nilai: datas.aDataEmp[j].detail[i].indikator_total_nilai,
                                background: '#eee'
                            })
                        }

                        empList.push({
                            emp_name: datas.aDataEmp[j].emp_name,
                            employemeny_nik: datas.aDataEmp[j].employemeny_nik,
                            detail: detail,
                            countSkill: countSkill
                        });
                    }

                    vm.listData = {
                        skill_activity: headerProcess,
                        colspan: headerProcess.length,
                        aDataEmp: empList,
                        skillCount: skillCount
                    }

                    console.log(vm.listData);
                } else if (vm.type == 1 && vm.activityId) {
                    var headerProcess = [];
                    var empList = [];
                    var skillCount = 0;
                    vm.process = dataEvent.skill_name;

                    // for (var j = 0; j < datas.aData.length; j++) {
                    for (var i = 0; i < datas.skill_activity.length; i++) {
                        if (datas.skill_activity[i].mtx_activity_id == vm.activityId) {
                            headerProcess.push({
                                skill_name: datas.skill_activity[i].skill_name,
                                no: datas.skill_activity[i].no
                            })
                            skillCount++;
                        }
                    }
                    headerProcess.push({
                        skill_name: 'Flag',
                        no: '#'
                    })
                    // }


                    for (var j = 0; j < datas.aDataEmp.length; j++) {
                        var detail = [];
                        var countSkill = 0;
                        for (var i = 0; i < datas.aDataEmp[j].detail.length; i++) {
                            for (var k = 0; k < datas.aDataEmp[j].detail[i].detail.length; k++) {
                                if (datas.aDataEmp[j].detail[i].detail[k].process_id == vm.activityId) {
                                    for (var l = 0; l < datas.aDataEmp[j].detail[i].detail[k].detail.length; l++) {
                                        detail.push({
                                            level: datas.aDataEmp[j].detail[i].detail[k].detail[l].level_warna,
                                            indikator_total_nilai: datas.aDataEmp[j].detail[i].detail[k].detail[l].indikator_total_nilai
                                        })

                                        if (datas.aDataEmp[j].detail[i].detail[k].detail[l].indikator_total_nilai != '0') {
                                            countSkill++;
                                        }
                                    }
                                    detail.push({
                                        level: datas.aDataEmp[j].detail[i].detail[k].level_warna,
                                        indikator_total_nilai: datas.aDataEmp[j].detail[i].detail[k].indikator_total_nilai,
                                        background: '#eee'
                                    });

                                }
                            }

                        }

                        empList.push({
                            emp_name: datas.aDataEmp[j].emp_name,
                            employemeny_nik: datas.aDataEmp[j].employemeny_nik,
                            detail: detail,
                            countSkill: countSkill
                        });
                    }

                    vm.listData = {
                        skill_activity: headerProcess,
                        colspan: headerProcess.length,
                        aDataEmp: empList,
                        skillCount: skillCount
                    }
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listData = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownBu() {
            angular.element.blockUI();
            var params = {
                action: 'viewDataCompany'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listBu = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownSubArea(company_id) {
            angular.element.blockUI();
            loadDropdownGroupByCompany(company_id);
            var params = {
                action: 'viewDataSubarea',
                company_id: company_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listSubArea = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listSubArea = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownGroupByCompany(company_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: '',
                company_id: company_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory(company_id, group_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: company_id,
                group_id: group_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        function viewDataEmployementBySubArea(sub_area_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataEmployementBySubArea',
                sub_area: sub_area_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.totalEmp = data[0].aData[0].total;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.totalEmp = 0;
                angular.element.unblockUI();
            });
        }

        function loadDropdownCategoryByMainCategory(main_category_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxCategoryByMainCategory',
                main_category_id: main_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownEmp(sub_area_id, mtx_category_id) {
            angular.element.blockUI();
            loadDropdownMainActivity(mtx_category_id);
            var params = {
                action: 'viewDataEmpBySubAreaAndCategory',
                sub_area_id: sub_area_id,
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listEmployee = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listEmployee = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainActivity(mtx_category_id) {
            var params = {
                action: 'viewDataMtxMainActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainActivity = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownActivity(main_activity_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                main_activity_id: main_activity_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listActivity = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.activity_id = vm.activity.id;
            vm.Form.objForm.data_mtx_score = vm.listData;
            var response = Form.saveData('saveDataMtxSkillScore', formController, Mtx);
            response.then(function (data) {
                if (data.data == true) {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();
                    vm.Form.pesan = 'Data EMP Matrix Score berhasil disimpan';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.Form.pesan)
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                    );
                    reset();
                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 3000);
                } else {
                    angular.element.unblockUI();
                    vm.Form.tampilPesan = false;
                }

            });

            response.catch(function () {
                vm.messageTheme = 'pink';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Data EMP Matrix Score gagal disimpan')
                        .position('top right')
                        .hideDelay(3000)
                        .theme("error-toast")
                );
                angular.element.unblockUI();
            });
        }


        function reset() {
            vm.listData = [];
        }

        vm.exportData = exportData;
        function exportData() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/mtx/exportDataMasterIndikator/' + vm.Form.objForm.mtx_category_id, '_blank');
            }, function () {
                $window.alert('gagal load token');
            });
        }

        vm.uploadData = uploadData;

        function uploadData(ev) {
            $mdDialog.show({
                controller: "UploadEmpAssesment as vm",
                templateUrl: "app/main/mtx/master/mtx-import-emp-assestment/uploadfile/uploadfile.html",
                parent: angular.element($document.body),
                locals: {
                    mtx_category_id: vm.Form.objForm.mtx_category_id,
                    sub_area_id: vm.Form.objForm.sub_area_id
                },
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mtx.master.mtx-category')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxCategoryController', MtxCategoryController);

    MtxCategoryController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast',
        '$http',
        'config',
        '$document'
    ];

    function MtxCategoryController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast,
        $http,
        config,
        $document
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.editData = editData;
        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';
        vm.totalEmp = 0;
        vm.totalEmpHasCategory = 0;
        vm.tableEmpAktif = true;
        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }





        // load bt
        vm.loadData = loadData;
        reset();
        // loadDropdownMainCategory();
        loadDropdownBu();
        vm.loadDropdownSubArea = loadDropdownSubArea;
        vm.viewDataEmployementBySubArea = viewDataEmployementBySubArea;

        function loadData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(Mtx, pageno, {
                action: 'viewDataMtxCategory',
                searchFilter: vm.search
            });

            console.log(vm.DataTable)
        }

        function loadDropdownBu() {
            var params = {
                action: 'viewDataCompany'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listBu = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownSubArea(company_id) {
            loadDropdownMainCategory(company_id);
            var params = {
                action: 'viewDataSubarea',
                company_id: company_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listSubArea = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listSubArea = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory(company_id) {
            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: company_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        function viewDataEmployementBySubArea(sub_area_id) {
            var params = {
                action: 'viewDataEmployementBySubArea',
                sub_area: sub_area_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.totalEmp = data[0].aData[0].total;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.totalEmp = 0;
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            if (vm.listDataSelected.length > 0) {
                vm.Form.objForm.mtx_main_category_id = vm.listDataSelected[0].mtx_main_category_id;
                vm.Form.objForm.category_name = vm.listDataSelected[0].category_name;
                vm.Form.objForm.id = vm.listDataSelected[0].id;
                deleteData(ev, formController);
            } else {
                angular.element.blockUI();

                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;
                var response = Form.saveData('saveDataMasterMtxCategory', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data EMP Matrix Category berhasil disimpan';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data EMP Matrix Category gagal disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });
            }
        }

        function editData(data) {
            reset();
            vm.edit = true;
            vm.manageMasterForm.postMethod = 'Update';
            vm.Form.objForm.category_name = data.category_name;
            vm.Form.objForm.mtx_main_category_id = data.mtx_main_category_id;
            vm.Form.objForm.bu = data.bu;
            vm.Form.objForm.sub_area_id = data.sub_area_id;
            vm.Form.objForm.id = data.id;
            vm.totalEmpHasCategory = data.EmpHasCategoryTotal;
            vm.Form.objForm.EmpHasCategory = data.EmpHasCategory;
            vm.tableEmpAktif = true;
            loadDropdownSubArea(data.bu);
            viewDataEmployementBySubArea(data.sub_area_id);
        }

        function deleteData(ev, formController) {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

            $mdDialog.show(confirm).then(function () {
                angular.element.blockUI();

                vm.Form.objForm.data = [];
                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;

                for (var i = 0; i < vm.listDataSelected.length; i++) {
                    vm.Form.objForm.data.push({
                        id: vm.listDataSelected[i].id
                    })
                }

                var response = Form.saveData('deleteDataMasterMtxCategory', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data Master Matrix Category berhasil dihapus';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data Master Matrix Category gagal dihapus')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });

            }, function () {
                // $scope.status = 'You decided to keep your debt.';
            });


        }

        function reset() {
            vm.search = {
                group: 'All',
                main_category: 'All',
                sub_area: 'All',
                bu: 'All',
                category_name: ''
            };
            loadData(1);
            loadDropdownGroup();
            loadDropdownMainCategoryFilter();
            vm.listDataSelected = [];
            vm.manageMasterForm = {
                postMethod: 'Save',
                mtx_main_category_id: null,
                category_name: null,
                bu: null,
                sub_area_id: null,
                id: null
            };
            vm.edit = false;
        }

        vm.setEmployement = setEmployement;

        function setEmployement() {
            if (vm.tableEmpAktif) {
                vm.tableEmpAktif = false;
            } else {
                vm.tableEmpAktif = true;
            }
        }

        vm.addEmployement = addEmployement;

        function addEmployement() {
            vm.Form.objForm.EmpHasCategory.push({
                action_date: null,
                assign_by: null,
                assign_date: null,
                employement_nik: null,
                id: null,
                mtx_category_id: null,
                nama: null,
            })
        }

        vm.deleteEmpHasCategory = deleteEmpHasCategory;

        function deleteEmpHasCategory(index, data, formController, ev) {
            if (!data.id) {
                vm.Form.objForm.EmpHasCategory.splice(index, 1);
            } else {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    vm.Form.objForm.data = [];
                    vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;

                    vm.Form.objForm.data.push({
                        id: data.id
                    })
                    var response = Form.saveData('deleteDataEmpHasCategory', formController, Mtx);
                    response.then(function (data) {
                        if (data.data == true) {
                            vm.messageTheme = 'blue';
                            angular.element.unblockUI();
                            vm.Form.pesan = 'Data Master Matrix Emp Has Category berhasil dihapus';
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(vm.Form.pesan)
                                    .position('top right')
                                    .hideDelay(3000)
                                    .theme("success-toast")
                            );
                            $timeout(function () {
                                vm.Form.tampilPesan = false;
                            }, 3000);
                            // vm.Form.objForm.EmpHasCategory.splice(index, 1);
                        } else {
                            angular.element.unblockUI();
                            vm.Form.tampilPesan = false;
                        }

                    });

                    response.catch(function () {
                        vm.messageTheme = 'pink';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Data Master Matrix Emp Has Category gagal dihapus')
                                .position('top right')
                                .hideDelay(3000)
                                .theme("error-toast")
                        );
                        angular.element.unblockUI();
                    });

                }, function () {
                });
            }
        }

        vm.lookupEmployee = lookupEmployee;

        function lookupEmployee(searchText) {
            if (searchText.length > 3) {
                return $http
                    .get(config.api + 'api/mtx?action=searchEmployee&search=' + searchText + '&sub_area=' + vm.Form.objForm.sub_area_id)
                    .then(function (res) {
                        console.log('res', res);
                        var datas = [];
                        for (var i = 0; i < res.data[0].aData.length; i++) {
                            datas.push(res.data[0].aData[i]);
                        }
                        return datas;
                    }).catch(function (err) {
                        console.log('err', err);
                    });
            }
        }

        function setTimeStamp(date) {
            if (date == null || date == undefined || date == '') {
                var dataTimeStamp = (new Date().getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            } else {
                var dataTimeStamp = (new Date(date).getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            }
        }

        vm.changeNik = changeNik;

        function changeNik(index, data) {
            console.log(data);
            vm.Form.objForm.EmpHasCategory[index].employement_nik = vm.Form.objForm.EmpHasCategory[index].emp.nik;
            vm.Form.objForm.EmpHasCategory[index].nama = vm.Form.objForm.EmpHasCategory[index].emp.emp_name;
            // vm.Form.objForm.EmpHasCategory[index].push({
            //     action_date: null,
            //     assign_by: null,
            //     assign_date: null,
            //     employement_nik: null,
            //     id: null,
            //     mtx_category_id: null,
            //     nama: null,
            // })
        }

        vm.uploadData = uploadData;

        function uploadData(ev) {
            $mdDialog.show({
                controller: "UploadEmpToCategoryController as vm",
                templateUrl: "app/main/mtx/master/mtx-category/uploadfile/uploadfile.html",
                parent: angular.element($document.body),
                locals: {
                    mtx_category_id: vm.Form.objForm.id,
                    sub_area_id: vm.Form.objForm.sub_area_id
                },
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function loadDropdownGroup() {
            vm.listGroup = [];
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });
                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listGroup.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].group_name + '/' + data[0].aData[i].bu_name,
                        filter: data[0].aData[i].bu
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategoryFilter() {
            vm.listMainCategory = [];



            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: 'All',
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });

                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listMainCategory.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].main_category_name + '/' + data[0].aData[i].bu_name,
                        filter: data[0].aData[i].bu
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        vm.showFilterChecked = showFilterChecked;
        vm.showFilter = false;

        function showFilterChecked() {
            if (vm.showFilter) {
                vm.showFilter = false;
            } else {
                vm.showFilter = true;
            }
        }

    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.master.mtx-activity', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_master_mtx_activity', {
                url: '/mtx/master/mtx-activity',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/master/mtx-activity/mtx-activity.html',
                        controller: 'MtxActivityController as vm'
                    }
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.mtx.master.mtx-activity')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxActivityController', MtxActivityController);

    MtxActivityController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast'
    ];

    function MtxActivityController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast
    ) {
        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.editData = editData;
        vm.saveData = saveData;
        vm.reset = reset;
        vm.addScore = addScore;
        vm.deletListScore = deletListScore;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.mtxActivityScore = 0;
        vm.tableActivityScoreAktif = true;

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }






        // load bt
        vm.loadData = loadData;
        reset();

        function loadData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(Mtx, pageno, {
                action: 'viewDataMtxActivity',
                searchFilter: vm.search
            });

            console.log(vm.DataTable)
        }

        function loadDropdownMainActivity() {
            var params = {
                action: 'viewDataMtxMainActivity',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainActivity = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            if (vm.listDataSelected.length > 0) {
                vm.Form.objForm.mtx_main_activity_id = vm.listDataSelected[0].mtx_main_activity_id;
                vm.Form.objForm.activity_name = vm.listDataSelected[0].activity_name;
                vm.Form.objForm.id = vm.listDataSelected[0].id;
                deleteData(ev, formController);
            } else {
                angular.element.blockUI();

                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;
                var response = Form.saveData('saveDataMasterMtxActivity', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data EMP Matrix Activity berhasil disimpan';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data EMP Matrix Activity gagal disimpan')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });
            }
        }

        function editData(data) {
            reset();
            vm.manageMasterForm.postMethod = 'Update';
            vm.Form.objForm.activity_name = data.activity_name;
            vm.Form.objForm.mtx_main_activity_id = data.mtx_main_activity_id;
            vm.Form.objForm.id = data.id;
            if (data.score.length > 0) {
                vm.Form.objForm.activity_score = [];
            }
            for (var i = 0; i < data.score.length; i++) {
                vm.Form.objForm.activity_score.push({
                    id: data.score[i].id,
                    level: parseInt(data.score[i].level),
                    mtx_skill_activity_id: data.score[i].mtx_skill_activity_id,
                    weight: parseFloat(data.score[i].weight * 100)
                })
            }
        }

        function deleteData(ev, formController) {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

            $mdDialog.show(confirm).then(function () {
                angular.element.blockUI();

                vm.Form.objForm.data = [];
                vm.Form.objForm.postMethod = vm.manageMasterForm.postMethod;

                for (var i = 0; i < vm.listDataSelected.length; i++) {
                    vm.Form.objForm.data.push({
                        id: vm.listDataSelected[i].id
                    })
                }

                var response = Form.saveData('deleteDataMasterMtxActivity', formController, Mtx);
                response.then(function (data) {
                    if (data.data == true) {
                        vm.messageTheme = 'blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        vm.Form.pesan = 'Data Master Matrix Activity berhasil dihapus';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.Form.pesan)
                                .position('top right')
                                .hideDelay(3000)
                                .theme("success-toast")
                        );
                        reset();
                        $timeout(function () {
                            vm.Form.tampilPesan = false;
                        }, 3000);
                    } else {
                        vm.Form.tampilPesan = false;

                    }

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Data Master Matrix Activity gagal dihapus')
                            .position('top right')
                            .hideDelay(3000)
                            .theme("error-toast")
                    );
                    angular.element.unblockUI();
                });

            }, function () {
                // $scope.status = 'You decided to keep your debt.';
            });


        }

        function reset() {
            vm.search = {
                group: 'All',
                main_category: 'All',
                category: 'All',
                main_activity: 'All',
                activity_name: ''
            };
            loadData(1);
            loadDropdownGroup();
            loadDropdownMainCategory();
            loadDropdownCategory();
            loadDropdownMainActivity();
            vm.listDataSelected = [];

            vm.Form.objForm.activity_score = [
                {
                    level: 0,
                    weight: 0
                },
                {
                    level: 1,
                    weight: 50
                },
                {
                    level: 2,
                    weight: 75
                },
                {
                    level: 3,
                    weight: 100
                }
            ];
            vm.manageMasterForm = {
                postMethod: 'Save',
                mtx_main_activity_id: null,
                activity_score: [],
                activity_name: null,
                id: null
            };
        }

        function addScore() {
            vm.Form.objForm.activity_score.push({
                level: null,
                weight: null
            })
        }


        function deletListScore(index) {
            vm.Form.objForm.activity_score.splice(index, 1);
        }

        vm.setActivityScore = setActivityScore;

        function setActivityScore() {
            if (vm.tableActivityScoreAktif) {
                vm.tableActivityScoreAktif = false;
            } else {
                vm.tableActivityScoreAktif = true;
            }
        }

        function loadDropdownGroup() {
            vm.listGroup = [];
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });
                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listGroup.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].group_name + '/' + data[0].aData[i].bu_name,
                        filter: data[0].aData[i].bu
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory() {
            vm.listMainCategory = [];



            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: 'All',
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });

                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listMainCategory.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].main_category_name + '/' + data[0].aData[i].bu_name,
                        filter: data[0].aData[i].bu
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownCategory() {
            vm.listCategory = [];
            var params = {
                action: 'viewDataDropdownMtxCategory',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCategory.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });

                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listCategory.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].main_category_name + '/' + data[0].aData[i].category_name,
                        filter: data[0].aData[i].mtx_main_category_id
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainActivity() {
            vm.listMainActivity = [];
            var params = {
                action: 'viewDataMtxMainActivity',
                offset: 0,
                jumPage: 100,
                search: ''
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {

                vm.listMainActivity.push({
                    id: 'All',
                    label: 'All',
                    filter: 'All'
                });

                for (var i = 0; i < data[0].aData.length; i++) {
                    vm.listMainActivity.push({
                        id: data[0].aData[i].id,
                        label: data[0].aData[i].category_name + '/' + data[0].aData[i].main_activity_name,
                        filter: data[0].aData[i].mtx_category_id
                    });
                }
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainActivity = [];
                angular.element.unblockUI();
            });
        }

        vm.showFilterChecked = showFilterChecked;
        vm.showFilter = false;

        function showFilterChecked() {
            if (vm.showFilter) {
                vm.showFilter = false;
            } else {
                vm.showFilter = true;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module('app.mtx.dashboard.mtx-dashboard', []).config(config);
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.mtx_dashboard_mtx_dashboard', {
                url: '/mtx/dashboard/dashboard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtx/dashboard/dashboard/dashboard.html',
                        controller: 'MtxDashboardController as vm'
                    }
                },
                params: {
                    obj: null
                }
            });

    }
}());

(function () {
    'use strict';
    am4core.useTheme(am4themes_animated);

    angular
        .module('app.mtx.dashboard.mtx-dashboard')
        .directive('preventEnterSubmit', function () {
            return function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 == event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            };
        })
        .controller('MtxDashboardController', MtxDashboardController);

    MtxDashboardController.$inject = [
        'AppAPI',
        '$localStorage',
        'DataService',
        'Form',
        'Auth',
        '$mdDialog',
        '$timeout',
        '$state',
        '$mdToast',
        '$stateParams',
        '$scope'
    ];

    function MtxDashboardController(
        AppAPI,
        $localStorage,
        DataService,
        Form,
        Auth,
        $mdDialog,
        $timeout,
        $state,
        $mdToast,
        $stateParams,
        $scope
    ) {




        var vm = this,
            Mtx = AppAPI.Mtx();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        Form.initialForm();
        Form.setObject(Mtx);
        vm.Form = Form;
        vm.listModulSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;

        vm.saveData = saveData;
        vm.reset = reset;

        vm.userNik = JSON.parse(localStorage.getItem('ngStorage-user'));
        vm.DataTable = new DataService();

        vm.search = '';
        vm.totalEmp = 0;
        vm.totalEmpHasCategory = 0;
        vm.isCollapse = false;

        vm.isLoad = false;

        vm.listLevel = [{
            id: 1,
            description: 'Skill'
        },
        {
            id: 2,
            description: 'Activity'
        },
        {
            id: 3,
            description: 'Main Activity'
        },
        {
            id: 4,
            description: 'Category'
        }]

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }



        // load bt
        vm.loadData = loadData;
        // reset();
        // if (!$stateParams.obj) {
        //     // $state.go('app.mtx_dashboard_mtx_dashboard_list');
        // } else {
        //     vm.Form.objForm.emp_name = $stateParams.obj.emp_name;
        //     vm.Form.objForm.nik = $stateParams.obj.employemeny_nik;
        // loadData();
        // }
        // loadDropdownMainCategory();
        loadDropdownBu();
        vm.loadDropdownGroupByCompany = loadDropdownGroupByCompany;
        vm.loadDropdownSubArea = loadDropdownSubArea;
        vm.viewDataEmployementBySubArea = viewDataEmployementBySubArea;
        vm.loadDropdownMainCategory = loadDropdownMainCategory;
        vm.loadDropdownCategoryByMainCategory = loadDropdownCategoryByMainCategory;
        vm.loadDropdownEmp = loadDropdownEmp;
        vm.loadDropdownMainActivity = loadDropdownMainActivity;
        vm.loadDropdownActivity = loadDropdownActivity;

        vm.effective_date = new Date();

        vm.mtx_category_id = 'All';

        vm.selectedCategoryId = selectedCategoryId;

        function loadData() {
            vm.listDataInfoSector = [];
            var colorBackground = ['#b3e5fc', '#80cbc46e', '#c5e1a569', '#bcaaa463', '#b0bec580', '#c1f5be91', '#f7070747'];
            angular.element.blockUI();
            var params = {
                action: 'getDataDashboardMtx',
                bu: vm.bu,
                sub_area_id: vm.sub_area_id,
                mtx_category_id: vm.mtx_category_id,
                effective_date: vm.effective_date,
                level_chart: vm.level
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.isLoad = true;
                vm.chart = null;
                var widthCategory = 13.28;
                if (data[0].category.length < 7) {
                    widthCategory = (100 / data[0].category.length) - 1;
                }
                for (var i = 0; i < data[0].category.length; i++) {

                    if (i == 0) {
                        data[0].category[i].style = {
                            "cursor": "pointer",
                            "border-radius": "5px",
                            "background": '#2196F3'
                        }
                    } else {
                        data[0].category[i].style = {
                            "cursor": "pointer",
                            "border-radius": "5px",
                            "background": '#2196F3'
                        }
                    }
                }
                vm.listDataCategory = data[0].category;
                vm.listDataSector = data[0].sector;

                if (data[0].sector.length) {
                    vm.chartHide = false;
                    inisiaisasiChart(data[0].sector);
                } else {
                    vm.chartHide = true;
                    // inisiaisasiChartRk(data[0].chart);
                }


                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listDataCategory = [];
                vm.isLoad = false;
                angular.element.unblockUI();
            });
        }

        function selectedCategoryId(mtx_category_id) {
            vm.mtx_category_id = mtx_category_id;
            loadData();
        }


        function inisiaisasiChart(data) {
            vm.chart = am4core.create('chartdiv', am4charts.XYChart)
            vm.chart.scrollbarX = new am4core.Scrollbar();
            vm.chart.colors.step = 1;
            vm.chart.cursor = new am4charts.XYCursor();
            vm.chart.legend = new am4charts.Legend()
            vm.chart.legend.position = 'top'
            vm.chart.legend.paddingBottom = 20
            vm.chart.legend.labels.template.maxWidth = 95

            vm.xAxis = vm.chart.xAxes.push(new am4charts.CategoryAxis())
            vm.xAxis.dataFields.category = 'category'
            vm.xAxis.renderer.cellStartLocation = 0.1;
            vm.xAxis.renderer.cellEndLocation = 0.9;
            vm.xAxis.renderer.grid.template.location = 0;
            vm.xAxis.renderer.minGridDistance = 30;

            var label = vm.xAxis.renderer.labels.template;
            // label.wrap = true;
            label.truncate = true;
            label.maxWidth = 120;
            label.tooltipText = "{category}";
            label.rotation = 90;

            vm.yAxis = vm.chart.yAxes.push(new am4charts.ValueAxis());
            vm.yAxis.min = 0;

            getChart(data);

        }

        function inisiaisasiChartRk(data) {
            vm.chart = am4core.create('chartdiv', am4charts.XYChart)
            vm.chart.scrollbarX = new am4core.Scrollbar();
            vm.chart.colors.step = 1;
            vm.chart.cursor = new am4charts.XYCursor();
            vm.chart.legend = new am4charts.Legend()
            vm.chart.legend.position = 'top'
            vm.chart.legend.paddingBottom = 20
            vm.chart.legend.labels.template.maxWidth = 95

            var datas = [];
            var datasPersen = [];
            for (var i = 0; i < data.length; i++) {
                datas.push({
                    category: data[i].category,
                    value: data[i].total
                })
            }

            vm.chart.data = datas;

            var categoryAxis = vm.chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "category";
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.renderer.minGridDistance = 30;

            categoryAxis.renderer.labels.template.adapter.add("dy", function (dy, target) {
                if (target.dataItem && target.dataItem.index & 2 == 2) {
                    return dy + 25;
                }
                return dy;
            });

            var valueAxis = vm.chart.yAxes.push(new am4charts.ValueAxis());

            // Create series
            var series = vm.chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = "value";
            series.dataFields.categoryX = "category";
            series.name = "Level";
            series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
            series.columns.template.fillOpacity = .8;

            var columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;

        }

        function createSeriesColumn(value, name, persen) {
            var series = vm.chart.series.push(new am4charts.ColumnSeries())
            series.dataFields.valueY = value;
            series.dataFields.valuePersen = persen;
            series.dataFields.categoryX = 'category'
            series.name = name;
            series.tooltipText = name + ": {valueY.formatNumber('#')}[/] (" + "{valuePersen.formatNumber('#.00')}%[/]" + ")";
            if (value == 'green') {
                series.fill = am4core.color('#4CAF50');
                series.stroke = am4core.color('#4CAF50');
            }

            if (value == 'yellow') {
                series.fill = am4core.color('#FFEB3B');
                series.stroke = am4core.color('#FFEB3B');
            }

            if (value == 'red') {
                series.fill = am4core.color('#F44336');
                series.stroke = am4core.color('#F44336');
            }

            if (value == 'black') {
                series.fill = am4core.color('#212121');
                series.stroke = am4core.color('#212121');
            }

            series.events.on("hidden", arrangeColumns);
            series.events.on("shown", arrangeColumns);

            var bullet = series.bullets.push(new am4charts.LabelBullet())
            bullet.interactionsEnabled = false
            bullet.dy = 30;
            // bullet.label.text = '{valueY}'
            bullet.label.fill = am4core.color('#ffffff');

            return series;
        }


        function arrangeColumns() {

            var series = vm.chart.series.getIndex(0);

            var w = 1 - vm.xAxis.renderer.cellStartLocation - (1 - vm.xAxis.renderer.cellEndLocation);
            if (series.dataItems.length > 1) {
                var x0 = vm.xAxis.getX(series.dataItems.getIndex(0), "categoryX");
                var x1 = vm.xAxis.getX(series.dataItems.getIndex(1), "categoryX");
                var delta = ((x1 - x0) / vm.chart.series.length) * w;
                if (am4core.isNumber(delta)) {
                    var middle = vm.chart.series.length / 2;

                    var newIndex = 0;
                    vm.chart.series.each(function (series) {
                        if (!series.isHidden && !series.isHiding) {
                            series.dummyData = newIndex;
                            newIndex++;
                        }
                        else {
                            series.dummyData = vm.chart.series.indexOf(series);
                        }
                    })
                    var visibleCount = newIndex;
                    var newMiddle = visibleCount / 2;

                    vm.chart.series.each(function (series) {
                        var trueIndex = vm.chart.series.indexOf(series);
                        var newIndex = series.dummyData;

                        var dx = (newIndex - trueIndex + middle - newMiddle) * delta

                        series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                        series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                    })
                }
            }
        }

        function getChart(data) {

            var datas = [];
            var datasPersen = [];
            for (var i = 0; i < data.length; i++) {
                var line = ((data[i].green + data[i].yellow + data[i].red + data[i].black) / data[i].totalEmp) * 100;
                datasPersen.push(line);
                datas.push({
                    category: data[i].gedung_name + ' ' + data[i].sector_name,
                    green: data[i].green,
                    greenPersen: data[i].greenPersen,
                    yellow: data[i].yellow,
                    yellowPersen: data[i].yellowPersen,
                    red: data[i].red,
                    redPersen: data[i].redPersen,
                    black: data[i].black,
                    blackPersen: data[i].blackPersen,
                    line: line
                })

            }

            vm.chart.data = datas;

            createSeriesColumn('green', 'Green', 'greenPersen');
            createSeriesColumn('yellow', 'Yellow', 'yellowPersen');
            createSeriesColumn('red', 'Red', 'redPersen');
            createSeriesColumn('black', 'Black', 'blackPersen');

            var paretoValueAxis = vm.chart.yAxes.push(new am4charts.ValueAxis());
            var maxValue = Math.max.apply(null, datasPersen);

            paretoValueAxis.renderer.opposite = true;
            paretoValueAxis.min = 0;
            paretoValueAxis.max = maxValue + 5;
            paretoValueAxis.strictMinMax = true;
            paretoValueAxis.renderer.grid.template.disabled = true;
            paretoValueAxis.numberFormatter = new am4core.NumberFormatter();
            paretoValueAxis.numberFormatter.numberFormat = "#'%'"
            paretoValueAxis.cursorTooltipEnabled = false;

            // var lineSeries = vm.chart.series.push(new am4charts.LineSeries());
            // lineSeries.name = "index";
            // lineSeries.dataFields.valueY = "line";
            // lineSeries.dataFields.categoryX = "category";
            // lineSeries.yAxis = paretoValueAxis;
            // lineSeries.stroke = am4core.color("#2196F3");
            // lineSeries.strokeWidth = 3;
            // lineSeries.propertyFields.strokeDasharray = "lineDash";
            // lineSeries.tooltip.label.textAlign = "middle";

            // var bullet = lineSeries.bullets.push(new am4charts.Bullet());
            // bullet.fill = am4core.color("#fdd400"); // tooltips grab fill from parent by default
            // bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]";

            // lineSeries.bullets.push(new am4charts.CircleBullet());
            // lineSeries.strokeWidth = 2;
            // // lineSeries.stroke = new am4core.InterfaceColorSet().getFor("alternativeBackground");
            // lineSeries.strokeOpacity = 0.5;

            var paretoSeries = vm.chart.series.push(new am4charts.LineSeries())
            paretoSeries.dataFields.valueY = "line";
            paretoSeries.dataFields.categoryX = "category";
            paretoSeries.yAxis = paretoValueAxis;
            paretoSeries.tooltipText = "index: {valueY.formatNumber('#.0')}%[/]";
            paretoSeries.bullets.push(new am4charts.CircleBullet());
            paretoSeries.strokeWidth = 2;
            paretoSeries.stroke = new am4core.InterfaceColorSet().getFor("alternativeBackground");
            paretoSeries.strokeOpacity = 0.5;
            paretoSeries.tensionX = 0.8;

        }

        function getChartRK(data) {

            var datas = [];
            var datasPersen = [];
            for (var i = 0; i < data.length; i++) {
                datas.push({
                    category: data[i].category,
                    value: data[i].total
                })
            }

            vm.chart.data = datas;

            var categoryAxis = vm.chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "category";
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.renderer.minGridDistance = 30;

            categoryAxis.renderer.labels.template.adapter.add("dy", function (dy, target) {
                if (target.dataItem && target.dataItem.index & 2 == 2) {
                    return dy + 25;
                }
                return dy;
            });

            var valueAxis = vm.chart.yAxes.push(new am4charts.ValueAxis());

            // Create series
            var series = vm.chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = "value";
            series.dataFields.categoryX = "category";
            series.name = "Level";
            series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
            series.columns.template.fillOpacity = .8;

            var columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;
        }

        function loadDropdownBu() {
            angular.element.blockUI();
            var params = {
                action: 'viewDataCompany'
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listBu = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownSubArea(company_id) {
            angular.element.blockUI();
            loadDropdownGroupByCompany(company_id);
            var params = {
                action: 'viewDataSubarea',
                company_id: company_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listSubArea = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listSubArea = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownGroupByCompany(company_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxRefGroup',
                offset: 0,
                jumPage: 100,
                search: '',
                company_id: company_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listGroup = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listGroup = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainCategory(company_id, group_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxMainCategoryByCompany',
                company_id: company_id,
                group_id: group_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainCategory = [];
                angular.element.unblockUI();
            });
        }

        function viewDataEmployementBySubArea(sub_area_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataEmployementBySubArea',
                sub_area: sub_area_id,
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.totalEmp = data[0].aData[0].total;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.totalEmp = 0;
                angular.element.unblockUI();
            });
        }

        function loadDropdownCategoryByMainCategory(main_category_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxCategoryByMainCategory',
                main_category_id: main_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listCategory = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listCategory = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownEmp(sub_area_id, mtx_category_id) {
            angular.element.blockUI();
            loadDropdownMainActivity(mtx_category_id);
            var params = {
                action: 'viewDataEmpBySubAreaAndCategory',
                sub_area_id: sub_area_id,
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listEmployee = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listEmployee = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownMainActivity(mtx_category_id) {
            var params = {
                action: 'viewDataMtxMainActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                mtx_category_id: mtx_category_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listMainActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listMainActivity = [];
                angular.element.unblockUI();
            });
        }

        function loadDropdownActivity(main_activity_id) {
            angular.element.blockUI();
            var params = {
                action: 'viewDataMtxActivity',
                offset: 0,
                jumPage: 100,
                search: '',
                main_activity_id: main_activity_id
            };

            var response = Mtx.query(params);
            response.$promise.then(function (data) {
                vm.listActivity = data[0].aData;;
                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                vm.listActivity = [];
                angular.element.unblockUI();
            });
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.data_mtx_score = vm.listData;
            var response = Form.saveData('saveDataMtxSkillScore', formController, Mtx);
            response.then(function (data) {
                if (data.data == true) {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();
                    vm.Form.pesan = 'Data EMP Matrix Score berhasil disimpan';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.Form.pesan)
                            .position('top right')
                            .hideDelay(3000)
                            .theme("success-toast")
                    );
                    reset();
                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 3000);
                } else {
                    angular.element.unblockUI();
                    vm.Form.tampilPesan = false;
                }

            });

            response.catch(function () {
                vm.messageTheme = 'pink';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Data EMP Matrix Score gagal disimpan')
                        .position('top right')
                        .hideDelay(3000)
                        .theme("error-toast")
                );
                angular.element.unblockUI();
            });
        }


        function reset() {
            vm.listData = [];
            $state.go('app.mtx_dashboard_mtx_dashboard_list');
        }

        vm.countCekIndikator = countCekIndikator;

        function countCekIndikator(data, index) {
            var cek = 0;
            for (var i = 0; i < data.skill[index].skill_indikator.length; i++) {
                if (data.skill[index].skill_indikator[i].validasi) {
                    cek++;
                }
            }

            return cek;
        }

        vm.infoSector = infoSector;

        function infoSector(data, level, type, bg) {
            angular.element.blockUI();
            vm.informationSector = "Info " + data.sector_name + " (" + data[type] + ")";
            vm.bg = bg;
            vm.listDataInfoSector = [];

            for (var i = 0; i < data.aDataEmp.length; i++) {
                if (data.aDataEmp[i].status_warna == level) {
                    // data.aDataEmp[i].mtx_category_name=
                    vm.listDataInfoSector.push(data.aDataEmp[i]);
                }
            }
            angular.element.unblockUI();

            // var params = {
            //     action: 'viewDataInfoSector',
            //     sector_id: data.sector_id,
            //     level: level
            // };

            // var response = Mtx.query(params);
            // response.$promise.then(function (data) {
            //     vm.listDataInfoSector = data[0].aData;;
            //     angular.element.unblockUI();
            // });
            // response.$promise.catch(function () {
            //     vm.listDataInfoSector = [];
            //     angular.element.unblockUI();
            // });
        }
    }
})();

(function() {
    "use strict";

    angular.module("app.mpp.report.hc", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mpp_report_hc_user", {
            url: "/report/hcuser",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp/report/hc/hc.html",
                    controller: "MppReportHcUserController as vm"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.mpp.report.hc')
        .controller('MppReportHcUserController', Controller);

    Controller.$inject = [
        '$state',
        '$localStorage',
        'AppAPI',
        'Auth',
        '$stateParams',
        '$timeout',
        '$window',
        '$scope',
        '$location',
        'config'
    ];

    /* @ngInject */
    function Controller(
        $state,
        $localStorage,
        AppAPI,
        Auth,
        $stateParams,
        $timeout,
        $window,
        $scope,
        $location,
        config
    ) {
        var vm = this;
        var MppReport = new AppAPI.MppReportHCUser();
        var d = new Date();
        vm.years = [2018, 2019, 2020];
        vm.year = d.getFullYear() + 1;
        vm.count = 0;
        vm.disabledCompany = true;
        vm.getDataReport = getDataReport;
        vm.getDataLayers = getDataLayers;
        vm.showFilter = true;
        vm.layer = {};
        vm.printPDF = printPDF;
        vm.layers = [];
        vm.listReport = [];
        vm.companies = [];
        vm.company = {};
        vm.printExcel = printExcel;
        vm.totalCurrEmp = 0;
        vm.totalNextEmp = 0;
        vm.totalNextEmpInternal = 0;
        vm.totalNextEmpExternal = 0;
        vm.totalNextEmpMutation = 0;
        vm.totalNextEmpTermination = 0;
        vm.totalPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        vm.totalRightBottom = 0;

        vm.empType = [
            {
                name: 'ALL',
                value: 'all'
            },
            {
                name: 'STAFF',
                value: 'SAP'
            },
            {
                name: 'GENERAL WORKER',
                value: 'HRIS'
            }
        ];

        vm.selectedEmpType = 'all';

        activate();

        function activate() {
            getDataCompanies();
        }

        function getDataReport() {
            angular.element('#tableMpp').block();
            var response = MppReport.query({
                action: 'getDataReport',
                years: vm.year,
                layerID: vm.layer.id,
                empType: vm.selectedEmpType
            });
            response.$promise.then(fetchResponseDataReport);
            response.$promise.catch(catchResponseDataReport);
        }

        function fetchResponseDataReport(data) {
            vm.listReport = data;
            $localStorage.reportHC = data;
            setTotal(data);
            angular.element('#tableMpp').unblock();
        }

        function catchResponseDataReport(params) {
            vm.listReport = [];
            angular.element('#tableMpp').unblock();
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-hc', {
                obj: {
                    years: vm.year,
                    list: vm.listReport
                }
            });
        }

        function getDataCompanies() {
            var response = MppReport.query({
                action: 'getListCompany'
            });
            response.$promise.then(fetchResponseCompanies);
            response.$promise.catch(catchResponseCompanies);
        }

        function fetchResponseCompanies(response) {
            var uCompany = $localStorage.empsite;
            var ctr = response.length;
            for (var i = 0; i < ctr; i++) {
                if (uCompany == response[i]['id']) {
                    vm.company = {
                        id: response[i].id,
                        description: response[i].description
                    };
                    console.log('vm.company', vm.company);
                    break;
                }
                getDataLayers();
            }
            vm.companies = response;
        }

        function catchResponseCompanies(response) {
            vm.companies = [];
        }

        function getDataLayers() {
            var response = MppReport.query({
                action: 'getListLayer',
                years: vm.year
            });
            response.$promise.then(fetchResponseLayers);
            response.$promise.catch(catchResponseLayers);
        }

        function fetchResponseLayers(response) {
            vm.layers = response;
        }

        function catchResponseLayers(response) {
            vm.layers = [];
        }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            '://' +
                            host +
                            '/' +
                            config.api +
                            'api/mppreporthc/exportData/' +
                            vm.layer.id +
                            '/' +
                            vm.year +
                            '/' +
                            vm.selectedEmpType +
                            '/' +
                            data.token,
                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }

        $scope.$on('$destroy', function() {
            delete $localStorage.reportHC;
        });

        function setTotal(data) {
            var ctr = data.length;
            vm.totalCurrEmp = 0;
            vm.totalNextEmp = 0;
            vm.totalNextEmpInternal = 0;
            vm.totalNextEmpExternal = 0;
            vm.totalNextEmpMutation = 0;
            vm.totalNextEmpTermination = 0;
            vm.totalPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            vm.totalRightBottom = 0;
            for (var i = 0; i < ctr; i++) {
                vm.totalCurrEmp += Number(data[i].curr.total);
                vm.totalNextEmp += Number(data[i].next.total);
                vm.totalNextEmpInternal += Number(data[i].next.internal);
                vm.totalNextEmpExternal += Number(data[i].next.external);
                vm.totalNextEmpMutation += Number(data[i].next.mutation);
                vm.totalNextEmpTermination += Number(data[i].next.termination);
                for (var j = 0; j < data[i].next.listPerMonth.length; j++) {
                    vm.totalPerMonth[j] += Number(data[i].next.listPerMonth[j]);
                }
                vm.totalRightBottom += data[i].totalRightPerRow;
            }
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpp.report.cost")
        .controller("MppReportCostUserController", Controller);

    Controller.$inject = [
        "$state",
        "AppAPI",
        "$element",
        "$localStorage",
        "$mdDialog",
        "$scope",
        "$location",
        "Auth",
        "$window",
        "config"
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $mdDialog,
        $scope,
        $location,
        Auth,
        $window,
        config
    ) {
        var vm = this;
        var MppReportCost = new AppAPI.MppReportCostUser();
        var d = new Date();
        vm.years = [2018, 2019, 2020];
        vm.year = d.getFullYear() + 1;
        vm.count = 0;
        vm.costCenter = {
            id: "all",
            description: "ALL"
        };
        vm.searchTerm = "";
        vm.disabledCompany = true;
        vm.listCostCenter = [];
        vm.listReport = [];
        vm.showFilter = true;
        vm.getDataReport = getDataReport;
        vm.getDataCostCenter = getDataCostCenter;
        vm.getDataLayers = getDataLayers;
        vm.printPDF = printPDF;
        vm.layers = [];
        vm.companies = [];
        vm.company = {};
        vm.clearSearch = clearSearch;
        vm.showDetail = showDetail;
        vm.printExcel = printExcel;

        activate();

        function activate() {
            getDataCompanies();
        }

        function getDataReport() {
            angular.element("#costReport").block();
            var response = MppReportCost.query({
                action: "getDataReport",
                years: vm.year,
                company: vm.company.id,
                costCenter: vm.costCenter.id,
                layerID: vm.layer.id
            });
            response.$promise.then(fetchResponseDataReport);
            response.$promise.catch(catchResponseDataReport);
        }

        function printPDF() {
            $state.goNewTab("app.report.mpp-cost", {
                obj: {
                    years: vm.year,
                    list: vm.listReport
                }
            });
        }

        function clearSearch() {
            vm.searchTerm = "";
        }

        function fetchResponseDataReport(data) {
            vm.listReport = data;
            $localStorage.reportCost = vm.listReport;
            angular.element("#costReport").unblock();
        }

        function catchResponseDataReport(params) {
            angular.element("#costReport").unblock();
            vm.listReport = [];
        }

        function getDataCostCenter() {
            var response = MppReportCost.query({
                action: "getListCostCenter",
                years: vm.year,
                company: vm.company.id
            });
            response.$promise.then(fetchResponseCostCenter);
            response.$promise.catch(catchResponseCostCenter);
        }

        function fetchResponseCostCenter(response) {
            vm.listCostCenter = response;
        }

        function catchResponseCostCenter() {
            vm.listCostCenter = [];
        }

        function getDataLayers() {
            var response = MppReportCost.query({
                action: "getListLayer",
                years: vm.year,
                company: vm.company.id
            });
            response.$promise.then(fetchResponseLayers);
            response.$promise.catch(catchResponseLayers);
        }

        function fetchResponseLayers(response) {
            vm.layers = response;
        }

        function catchResponseLayers(response) {
            vm.layers = [];
        }

        function getDataCompanies() {
            var response = MppReportCost.query({
                action: "getListCompany"
            });
            response.$promise.then(fetchResponseCompanies);
            response.$promise.catch(catchResponseCompanies);
        }

        function fetchResponseCompanies(response) {
            var uCompany = $localStorage.empsite;
            var ctr = response.length;
            for (var i = 0; i < ctr; i++) {
                if (uCompany == response[i]['id']) {
                    vm.company = {
                        id: response[i].id,
                        description: response[i].description
                    };
                    getDataCostCenter();
                    break;
                }
            }
            vm.companies = response;
        }

        function catchResponseCompanies(response) {
            vm.companies = [];
        }

        function showDetail(ev) {
            $mdDialog
                .show({
                    controller: "MppReportCostUserDetailController",
                    controllerAs: "vm",
                    templateUrl: "app/main/mpp/report/cost/detail/detail.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        years: vm.year,
                        layerID: vm.layer.id,
                        costCenter: vm.costCenter.id,
                        company: vm.company.id
                    }
                });
        }

        $element.find("input").on("keydown", function (ev) {
            ev.stopPropagation();
        });


        $scope.$on('$destroy', function () {
            delete $localStorage.reportCost;
        });

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/mppreportcost/exportData/' + vm.year + '/' + vm.costCenter.id + '/' + vm.layer.id + '/' + vm.company.id + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.orgtable', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state('app.mpp_main.orgtable', {
        url: '/orgtable',
        views: {
          'mppView@app.mpp_main': {
            templateUrl: 'app/main/mpp/orgtable/orgtable.html',
            controller: 'OrgTableController as vm'
          }
        },
        params: {
          obj: null
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.orgtable')
    .controller('UploadMppController', UploadMppController);

  UploadMppController.$inject = ['$state', '$localStorage', '$mdDialog', 'AppAPI', 'Auth'];

  /* @ngInject */
  function UploadMppController($state, $localStorage, $mdDialog, AppAPI, Auth) {
    var vm          = this;
    var Mpp         = new AppAPI.Mpp();
    vm.dialogCancel = cancelDialog;
    vm.dialogClose  = closeDialog;

    function closeDialog() {
      $mdDialog.cancel();
    }

    function cancelDialog() {
      $mdDialog.hide();
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.mpp.orgtable')
    .controller('MppTransactionController', MppTransactionController);


  MppTransactionController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    '$state',
    'item',
    'Auth',
    'type',
    'year',
    '$http',
    'config',
    'actionType'
  ];

  /** @ngInject */
  function MppTransactionController(
    $mdDialog,
    $localStorage,
    AppAPI,
    $state,
    item,
    Auth,
    type,
    year,
    $http,
    config,
    actionType
  ) {
    var vm = this;
    var Mpp = AppAPI.Mpp();
    var Employement = AppAPI.Employement();
    vm.type = type;
    vm.actionType = actionType;
    vm.selectedNik = null;

    vm.searchText = '';
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.isNameShow = true;
    vm.isDuplicate = false;

    vm.organizationLayer = [];
    vm.dialogClose = closeDialog;
    vm.dialogCancel = cancelDialog;
    vm.saveData = saveData;
    vm.parentLayer = type === 1 ? item.listDetail[year] : [];
    vm.parentID = 0;
    vm.layer_id1 = 0;

    console.log(vm.parentLayer);
    console.log(item);
    console.log('type',type);

    vm.newComers = [
      'new hire',
      'new-hire-null',
      'transfer in',
      'stay'
    ];

    vm.update = [
      'stay',
      'promotion',
      'demotion',
    ];

    vm.delete = [
      'transfer out',
      'finish contract',
      'termination'
    ];

    vm.transferOut = [
      'stay',
      'promotion',
      'demotion',
      'new hire',
      'new-hire-null',
      'transfer in',
      'finish contract',
      'replacement'
    ]

    vm.stay = [
      'stay',
      'promotion',
      'demotion',
      'transfer out',
      'finish contract',
      'termination'
    ]


    activate();

    function activate() {
      switchType(type)
      if (type == 1) {
        getLayer(item.layer_id, 1);
        // getParentTo();
      } else {
        getOrganizationLayer();
      }
    }

    function switchType(type) {
      switch (type) {
        case 1:
          vm.transactionType = vm.newComers;
          vm.selectedType = vm.newComers[0];
          vm.name = 'CREATE RECORD';
          vm.nik = 'NEW HIRE, NEW-HIRE-NULL, TRANSFER IN';
          break;
        case 2:
          vm.transactionType = vm.transferOut;
          vm.selectedType = typeof (item.listDetail === 'undefined') ? item.transaction_type : item.listDetail[year][0].transaction_type;
          vm.name = 'CREATE RECORD';
          vm.nik = 'NEW HIRE, TRANSFER IN, REPLACEMENT';
          break;
        case 3:
          if (actionType == 'edit') {
            vm.transactionType = vm.newComers;
            vm.name = item.name ? item.name : 'EDIT RECORD';
            vm.nik = item.nik;
            vm.dateFulfil = new Date(item.date_fulfil);
            vm.selectedType = item.transaction_type;
          } else {
            var selected = angular.copy(vm.newComers);
            selected.splice(2, 1);
            vm.transactionType = selected;
            vm.name = item.name ? item.name : 'CREATE RECORD';
            vm.nik = "ADD TEAM MEMBER";
            vm.selectedType = selected[0];
          }
          break;
        case 4:
          vm.transactionType = vm.stay;
          vm.name = item.name;
          vm.nik = item.nik;
          vm.dateFulfil = item.date_fulfil == '1970-01-01' ? null : new Date(item.date_fulfil);
          vm.selectedType = typeof (item.listDetail === 'undefined') ? item.transaction_type : item.listDetail[year][0].transaction_type;
          break;
        case 5:
          vm.transactionType = vm.newComers;
          vm.selectedType = typeof (item.listDetail === 'undefined') ? item.transaction_type : item.listDetail[year][0].transaction_type;
          break;
        case 6:
          vm.transactionType = vm.newComers;
          vm.selectedType = typeof (item.listDetail === 'undefined') ? item.transaction_type : item.listDetail[year][0].transaction_type;
          break;
      }
    }

    function cancelDialog() {
      $mdDialog.cancel();
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function getOrganizationLayer() {
      var master = item.mpp_master_id;
      var response = Mpp.query({
        action: 'viewOrgLayer',
        mppMasterId: master,
        year: year
      });

      response.$promise.then(fetchDataOrganizationLayer);
      response.$promise.catch(fetchErrorOrganizationLayer);
    }

    function fetchDataOrganizationLayer(data) {
      vm.organizationLayer = data;
      getSelectedOrgLayer(data, item.layer_id);
    }

    function getSelectedOrgLayer(data, id) {
      for (var i = 0; i < data.length; i++) {
        var idLayer = data[i].id.split('-');
        console.log(idLayer);
        if (idLayer[0] == id) {
          vm.selectedOrgLayer = data[i].id;
          vm.parentID = idLayer[1];
          vm.layer_id1 = idLayer[0];
          break;
        }
      }
    }

    function getLayer(parentID, maxDepth) {
      var response = Employement.query({
        action: 'viewOrgChart',
        parentID: parentID,
        maxDepth: maxDepth
      });
      response.$promise.then(fetchlayer);
      response.$promise.catch(errorFetchLayer);
    }

    function fetchlayer(data) {
      vm.organizationLayer = data;
      console.log(data);
    }

    function errorFetchLayer(data) {
      vm.organizationLayer = [];
    }

    function fetchErrorOrganizationLayer(data) {
      vm.organizationLayer = [];
    }

    function saveData(form) {
      var transactionType = form.transactionType.$modelValue;
      var promise = Auth.setToken();
      if (transactionType == 'new hire' || transactionType == 'transfer in' || transactionType == 'stay' || transactionType == 'new-hire-null') {
        promise.then(function () {
          var response = Mpp.save({
            action: 'save',
            id: item.mpp_detail_id,
            dateFulfillSave: transactionType != 'stay' ? form.dateFulfil.$viewValue : '1970-01-01',
            transactionType: transactionType,
            parentLayerID: transactionType != 'stay' ? vm.selectedParentTo.layer_id : null,
            mppMasterIdParent: transactionType != 'stay' ? vm.selectedParentTo.mpp_master_id : null,
            parentLayerType: transactionType != 'stay' ? vm.selectedParentTo.type : null,
            parentID: transactionType != 'stay' ? vm.selectedParentTo.mpp_detail_id : null,
            quantity: transactionType !== 'stay' ? form.quantity.$viewValue :  null,
            layerID:  vm.selectedOrgLayer.id,
            actionType: actionType,
            isDuplicate: vm.isDuplicate,
            nikStay : vm.selectedNik
          });

          response.$promise.then(function (data) {
            closeDialog();
          });

          response.$promise.catch(function (data) {
            console.log(data);
          });

        });
      } else if (transactionType == 'finish contract' ||
        transactionType == 'transfer out' ||
        transactionType == 'termination') {

        promise.then(function () {
          var response = Mpp.save({
            action: 'save',
            dateFulfillSave: form.dateFulfil.$viewValue,
            transactionType: transactionType,
            id: item.mpp_detail_id,
            actionType: actionType
          });

          response.$promise.then(function (data) {
            closeDialog();
          });

          response.$promise.catch(function (data) {
            console.log(data);
          });

        });

      } else {

        promise.then(function () {
          var response = Mpp.save({
            action: 'save',
            dateFulfillSave: form.dateFulfil.$viewValue,
            transactionType: form.transactionType.$modelValue,
            id: item.mpp_detail_id,
            nik: item.nik,
            mppMasterId: item.mpp_master_id,
            layerID: vm.type == 1 ? vm.selectedOrgLayer.id : vm.selectedOrgLayer,
            actionType: actionType,
            isDuplicate : vm.isDuplicate,
            nikStay : vm.selectedNik
          });

          response.$promise.then(function (data) {
            closeDialog();
          });

          response.$promise.catch(function (data) {
            console.log(data);
          });

        });

      }
    }

    function querySearch(params) {
      return $http
        .get(config.api + 'api/mpp?action=getTeamMember&search=' + params)
        .then(function (item) {
          return item.data;
        });
    }

    function selectedItemChange(item) {
      if (item) {
        vm.selectedNik = item.nik;
      }
    }


    // function getParentTo() {
    //   var parent = item.parent;
    //   var response = Mpp.query({
    //     action: 'getParentTo',
    //     parentLayer: parent,
    //     year: year
    //   });

    //   response.$promise.then(fetchDataParentTo);
    //   response.$promise.catch(fetchErrorParentTo);
    // }

    // function fetchDataParentTo(data) {
    //   vm.parentLayer = data;
    // }

    // function fetchErrorParentTo() {
    //   vm.parentLayer = [];
    // }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.orgtable')
    .controller('MergeMppController', MergeMppController);

  MergeMppController.$inject = ['$state', '$localStorage', '$mdDialog', 'AppAPI', 'item', 'Auth'];

  /* @ngInject */
  function MergeMppController($state, $localStorage, $mdDialog, AppAPI, item, Auth) {
    var vm = this;
    var Mpp = new AppAPI.Mpp();
    vm.disableMerge = true;
    vm.mergeData = [];
    vm.data = [];
    vm.mergeMpp = mergeMpp;

    vm.dialogCancel = dialogCancel;

    activate();

    function activate() {
      getDataTotalDetail();
    }

    function dialogCancel() {
      $mdDialog.cancel();
    }

    function dialogClose(resp) {
      $mdDialog.hide(resp);
    }

    function getDataTotalDetail() {
      var response = Mpp.get({
        action: 'getTotalCurrentDetail',
        layer: item.layer_id,
        date: item.current.date
      });

      response.$promise.then(fetchDataTotalDetail);
      response.$promise.catch(catchDataTotalDetail);
    }

    function catchDataTotalDetail(err) {
      console.log(err);
    }

    function fetchDataTotalDetail(data) {
      var ctrMppEmployee = data.mpp_employee.length;
      var ctrMppTransaction = data.mpp_transaction.length;
      var ctr = 0;
      var served = 0;
      for (var i = 0; i < ctrMppEmployee; i++) {
        if (served !== ctrMppTransaction) {
          while (ctr < ctrMppTransaction) {
            var temp = {
              'nik': data.mpp_employee[i].nik,
              'name': data.mpp_employee[i].name,
              'joinDate': data.mpp_employee[i].joinDate,
              'layer_id': data.mpp_employee[i].layer_id,
              'mpp_detail_id': data.mpp_transaction[ctr].id,
              'transaction_type': data.mpp_transaction[ctr].transaction_type
            }
            if (!isExists(vm.data, 'nik', data.mpp_employee[i].nik)) {
              vm.data.push(temp);
              vm.mergeData.push(temp);
              served += 1;
            }
            ctr++;
            vm.disableMerge = false;
          }
        } else {
          vm.data.push({
            'nik': data.mpp_employee[i].nik,
            'name': data.mpp_employee[i].name,
            'joinDate': data.mpp_employee[i].joinDate,
            'layer_id': data.mpp_employee[i].layer_id,
            'mpp_detail_id': 0,
            'transaction_type': '-'
          });
        }
      }
    }

    function isExists(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return true;
        }
      }
      return false;
    }

    function mergeMpp() {
      var save = Auth.setToken();
      save.then(function () {
        var response = Mpp.save({
          action: 'mergeMpp',
          data: vm.mergeData
        });
        response.$promise.then(fetchResponseMerge);
        response.$promise.catch(catchResponseMerge);
      });
    }

    function fetchResponseMerge(data) {
      dialogClose(true);
    }

    function catchResponseMerge(data) {
      dialogClose(false)
    }




  }

})();

(function(){
  'use strict';

  angular
    .module('app.mpp.orgtable')
    .controller('CreateLayerMppController', Controller);

  Controller.$inject = ['$mdDialog', 'AppAPI', 'Form', 'Auth', 'collection'];

  /* @ngInject */
  function Controller($mdDialog, AppAPI, Form, Auth, collection) {
    var vm = this;

    // initial form
    Form.initialForm();

    // get constructor form
    var Mpp = AppAPI.Mpp();

    vm.layerID = collection.layer_id;
    vm.orgLevelID = collection.org_level_id;
    vm.classificationCode = [];
    vm.saveData = saveData;
    vm.hide=hide;
    vm.close = close;

    // set constructor form
    Form.setObject(Mpp);

    // set form to controller
    vm.Form = Form;

    console.log(collection);

    activate();

    function activate() {
      getEmpClassification();
      getCostCenter();
      getListOrgLevel();
      getBusinessTitle();
      getLocationMpp();
    }



    function saveData(formController) {
      console.log(vm.Form.objForm)
      console.log(formController);
      vm.Form.objForm.layer_id =  vm.layerID;
      var promise = Form.saveData('addLayer', formController, Mpp);
      promise.then(succesSave);
      promise.catch(failedSaveData);
    }

    function succesSave(data) {
      console.log(data);
    }

    function failedSaveData(data) {
      console.log(data);
    }

    function getEmpClassification() {
      var response = Mpp.query({
        action: 'getEmpClasification'
      });
      response.$promise.then(fetchResponseEmpClassification);
      response.$promise.catch(catchResponseEmpClassification);
    }

    function fetchResponseEmpClassification(data) {
      vm.classificationCode = data;
    }

    function catchResponseEmpClassification(data) {
      vm.classificationCode = [];
    }


    function getCostCenter() {
      var response = Mpp.query({
        action: 'getCostCenter'
      });
      response.$promise.then(fetchResponseCostCenter);
      response.$promise.catch(catchResponseCostCenter);
    }

    function fetchResponseCostCenter(data) {
      vm.costCenter = data;

    }

    function catchResponseCostCenter(data) {
      vm.costCenter = [];
    }


    function getListOrgLevel() {
      var response = Mpp.query({
        action: 'getListOrgLevel',
        org_level_id: vm.orgLevelID
      });
      response.$promise.then(fetchResponseOrgLevel);
      response.$promise.catch(catchResponseOrgLevel);
    }

    function fetchResponseOrgLevel(data) {
      vm.orgLevel = data;

    }

    function catchResponseOrgLevel(data) {
      vm.orgLevel = [];
    }


    function getBusinessTitle() {
      var response = Mpp.query({
        action: 'getBusinessTitle'
      });
      response.$promise.then(fetchResponseBusinessTitle);
      response.$promise.catch(catchResponseBusinessTitle);
    }

    function fetchResponseBusinessTitle(data) {
      vm.businessTitle = data;
    }

    function catchResponseBusinessTitle(data) {
      vm.businessTitle = [];
    }


    function getLocationMpp() {
      var response = Mpp.query({
        action: 'getLocationMpp'
      });
      response.$promise.then(fetchResponseLocation);
      response.$promise.catch(catchResponseLocation);
    }

    function fetchResponseLocation(data) {
      vm.location = data;
    }

    function catchResponseLocation(data) {
      vm.location = [];
    }

    function hide()
    {
      $mdDialog.hide();
    }

    function close() {
      $mdDialog.cancel();
    }


  }
})();

(function () {
    "use strict";

    angular.module("app.activity-foreman", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.activity_foreman", {
            url: "/activity_foreman",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp/activity-foreman/activity-foreman.html",
                    controller: "ActivityForemanController as vm"
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.activity-foreman')
        .controller('AddActivityForemanController', AddActivityForemanController);

    AddActivityForemanController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', '$element', '$log', 'productLists', '_data', '$http', 'config', '$mdToast', 'Auth'];

    /* @ngInject */
    function AddActivityForemanController($q, $mdDialog, Form, AppAPI, $element, $log, productLists, _data, $http, config, $mdToast, Auth) {
        var vm = this;
        vm.saveData = saveData;
        var EmpLinePosition = AppAPI.EmpLinePosition();
        var ActivityForeman = AppAPI.ActivityForeman();
        Form.initialForm();
        Form.setObject(ActivityForeman);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.productLists = productLists;
        vm.data = _data;
        vm.selectedProdukGetMPP = selectedProdukGetMPP;
        vm.selectedEmployee = selectedEmployee;
        vm.selectedProduct = selectedProduct;
        vm.selectedEffectiveDate = selectedEffectiveDate;
        vm.searchProduct;
        vm.lookupEmployee = lookupEmployee;
        vm.loadProduct = loadProduct;
        vm.mppStandardLists = [];
        vm.listDataSector = [];
        vm.selectedSector = selectedSector;
        vm.selectedLine = selectedLine;
        vm.loadMppStandard = loadMppStandard;
        vm.changePortion = changePortion;
        vm.changeNik = changeNik;
        vm.removeItem = removeItem;
        vm.maxWorking = 8;
        vm.jumEmployee = 0;
        getSupportActivity();
        vm.listdatastemp = [];
        vm.supportActivities = [{
            'id': null,
            'activity_id': '',
            'production_product_id': '',
            'nik': '',
            'portion': '',
            'request': false
        }];

        vm.addRow = addRow
        vm.removeRow = removeRow

        vm.portionList = [{
                'value': '25',
                'label': '25%'
            },
            {
                'value': '50',
                'label': '50%'
            },
            {
                'value': '75',
                'label': '75%'
            },
            {
                'value': '100',
                'label': '100%'
            }
        ];
        vm.clearSearch = function () {
            vm.searchProduct = '';
        };
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        if (vm.data) {
            vm.Form.objForm.effective_date = new Date(vm.data.production_date);
        };

        getSectorSpv();
        lookupAllEmployee();
        loadLinePosition().then(function (data) {
            if (vm.data) {
                vm.Form.objForm.line_position = vm.data.line_id;
                selectedProdukGetMPP(vm.data.line_id).then(function (data2) {
                    vm.Form.objForm.product = vm.data.product_id;
                    selectedProduct(vm.data.product_id);
                });
            }
        });


        function getSupportActivity() {
            var response = EmpLinePosition.query({
                action: 'getSupportActivity'
            });
            response.$promise.then(fetchSupportActivity);
            response.$promise.catch(errorFetchSupportActivity);
        }

        function fetchSupportActivity(data) {
            vm.supportActivityList = data;
        }

        function errorFetchSupportActivity() {
            vm.supportActivityList = [];
        }


        function loadLinePosition() {
            var defer = $q.defer();
            var response = EmpLinePosition.query({
                action: 'getLineForeman',
                search: ''
            });
            response.$promise.then(function (data) {
                vm.listLineForeman = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject();
            });
            return defer.promise;
        }

        function selectedProdukGetMPP(product) {
            var defer = $q.defer();
            vm.mppStandardLists = [];
            var response = ActivityForeman.query({
                action: 'getMPPStandarBy',
                product_id: product.id,
                production_date: setTimeStamp(vm.Form.objForm.effective_date),
                search: ''
            });
            response.$promise.then(function (data) {
                vm.listProduct = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject();
            });
            return defer.promise;
        }

        function selectedEffectiveDate() {
            vm.Form.objForm.line_position = '';
            if (vm.Form.objForm.product && vm.Form.objForm.line_position) {
                loadMppStandard(vm.Form.objForm.product);
            }
        }

        function selectedProduct(id) {
            // loadMppStandard(id);
            if (vm.productLists) {
                var product = vm.productLists.find(function (t) {
                    if (t.id === id) {
                        return t;
                    }
                });
                return product;
            }
        }

        function selectedEmployee(item, mppIndex, mppStandarIndex) {
            vm.mppStandardLists[mppIndex].mpp_standar[mppStandarIndex].nik = item.nik + ', ' + item.fullname
        }

        function loadMppStandard(product_id) {
            if (product_id) {
                angular.element.blockUI();
                var response = ActivityForeman.query({
                    action: 'getMppStandardByProductMachine',
                    product_id: product_id.id,
                    line_id: vm.Form.objForm.line_position,
                    effective_date: setTimeStamp(vm.Form.objForm.effective_date)
                });
                response.$promise.then(function (data) {
                    var listPosition = removeDuplicates(data);
                    vm.mppStandardLists = [];
                    vm.mppStandardListsTemp = [];
                    var productionProductId = 0;
                    for (var i = 0; i < listPosition.length; i++) {
                        vm.mppStandardLists[i] = {
                            position_group: listPosition[i].position_group,
                            mpp_standar: []
                        }
                        for (var j = 0; j < data.length; j++) {
                            if (data[j].position_group == listPosition[i].position_group) {
                                if (vm.data) {
                                    if (vm.data.mpp_standard_id == data[j].id) {
                                        data[j].is_focus = true;
                                    }
                                };

                                if (data[j].nikemp) {
                                    data[j].nik = {
                                        nik: data[j].nikemp,
                                        fullname: data[j].fullname
                                    }

                                    data[j].portion = parseInt(data[j].portion);
                                }
                                data[j].portion_mpp = parseInt(parseFloat(data[j].portion_mpp))
                                data[j].request = false;

                                vm.mppStandardLists[i].mpp_standar.push(data[j]);
                                vm.mppStandardListsTemp.push(data[j]);
                            }

                        }
                    }
                    countEmployeeUses();

                    // setDataSupport(productionProductId);
                    angular.element.unblockUI();

                    // vm.resultfullJobNik = vm.fullJobNik.reduce(function (r, a) {
                    //     r[a.nik] = r[a.nik] || [];
                    //     r[a.nik].push(a.portion);

                    //     return r;
                    // }, Object.create(null));
                });
                response.$promise.catch(function (data) {
                    angular.element.unblockUI();
                    $log.info(data);
                });
            }

        }

        function changeNik(data, from, index, indexGroup) {
            if (data.nik) {
                data.request = false;
                var indexGrops = indexGroup;
                if (indexGroup > 0) {
                    indexGroup = vm.mppStandardLists[indexGroup - 1].mpp_standar.length;
                }

                var listDataS = vm.mppStandardLists;
                var listData = [];

                for (var i = 0; i < listDataS.length; i++) {
                    for (var j = 0; j < listDataS[i].mpp_standar.length; j++) {
                        listData.push(listDataS[i].mpp_standar[j])
                    }
                }

                vm.listdatastemp = listData;
                var indexSameNik = [];
                var indexSupport = [];
                indexSameNik = getAllIndexes(listData, 'mpp', data.nik.nik);
                indexSupport = getAllIndexes(vm.supportActivities, 'support', data.nik.nik);
                if (indexSameNik.length > 0 || indexSupport.length > 0) {
                    var portion = 0;
                    for (var j = 0; j < indexSameNik.length; j++) {
                        if (from == 'mpp') {
                            if ((index + indexGroup) != indexSameNik[j].index) {
                                if (indexSameNik[j].portion) {
                                    portion += parseInt(indexSameNik[j].portion);
                                }
                            }
                        } else {
                            if (indexSameNik[j].portion) {
                                portion += parseInt(indexSameNik[j].portion);
                            }
                        }
                    }
                    for (var i_s = 0; i_s < indexSupport.length; i_s++) {
                        if (from == 'support') {
                            if (index != indexSupport[i_s].index) {
                                if (indexSupport[i_s].portion) {
                                    portion += parseInt(indexSupport[i_s].portion);
                                }
                            }
                        } else {
                            if (indexSupport[i_s].portion) {
                                portion += parseInt(indexSupport[i_s].portion);
                            }
                        }

                    }
                    if (portion == 50) {
                        data.portion = 50;
                    }
                    if (portion == 75) {
                        data.portion = 25;
                    }
                    if (portion == 25) {
                        data.portion = 75;
                    }

                    if (portion == 0) {
                        if (from == 'mpp') {
                            data.portion = parseInt(vm.mppStandardLists[indexGrops].mpp_standar[index].portion_mpp);
                        } else {
                            data.portion = 100;
                        }
                    }
                } else {
                    data.portion = 0;
                }



            }
            countEmployeeUses();

        }

        function countEmployeeUses() {
            var listDataS = vm.mppStandardLists;
            var listData = [];

            for (var i = 0; i < listDataS.length; i++) {
                for (var j = 0; j < listDataS[i].mpp_standar.length; j++) {
                    listData.push(listDataS[i].mpp_standar[j])
                }
            }
            for (var i = 0; i < vm.supportActivities.length; i++) {
                listData.push(vm.supportActivities[i]);
            }

            var numberEmployeeAvailable = vm.jumEmployee.jumTemp;
            var numberEmployeeUsed = removeDuplicatesEmployess(listData);

            if (numberEmployeeAvailable > 0) {
                vm.jumEmployee.count = numberEmployeeUsed.length;
                vm.jumEmployee.countKur = vm.jumEmployee.jumTemp - numberEmployeeUsed.length;
            }
        }

        function changePortion(data, from, index, indexGroup) {
            if (data.nik) {
                data.request = false;
                if (indexGroup > 0) {
                    indexGroup = vm.mppStandardLists[indexGroup - 1].mpp_standar.length;
                }

                var listDataS = vm.mppStandardLists;
                var listData = [];

                for (var i = 0; i < listDataS.length; i++) {
                    for (var j = 0; j < listDataS[i].mpp_standar.length; j++) {
                        listData.push(listDataS[i].mpp_standar[j])
                    }
                }

                var indexSameNik = [];
                var indexSupport = [];
                indexSameNik = getAllIndexes(listData, 'mpp', data.nik.nik);
                indexSupport = getAllIndexes(vm.supportActivities, 'support', data.nik.nik);
                if (indexSameNik.length > 0 || indexSupport.length > 0) {
                    var portion = 0;
                    for (var j = 0; j < indexSameNik.length; j++) {
                        if (from == 'mpp') {
                            if ((index + indexGroup) != indexSameNik[j].index) {
                                if (indexSameNik[j].portion) {
                                    portion += parseInt(indexSameNik[j].portion);
                                }
                            }
                        } else {
                            if (indexSameNik[j].portion) {
                                portion += parseInt(indexSameNik[j].portion);
                            }
                        }
                    }
                    for (var i_s = 0; i_s < indexSupport.length; i_s++) {
                        if (from == 'support') {
                            if (index != indexSupport[i_s].index) {
                                if (indexSupport[i_s].portion) {
                                    portion += parseInt(indexSupport[i_s].portion);
                                }
                            }
                        } else {
                            if (indexSupport[i_s].portion) {
                                portion += parseInt(indexSupport[i_s].portion);
                            }
                        }
                    }

                    var portionSum = parseInt(data.portion) + portion;

                    if (portionSum > 100) {
                        data.portion = 0;
                    }
                }
            }
        }

        function setDataSupport(productId) {
            var response = EmpLinePosition.query({
                action: 'loadDataSupport',
                product_id: productId
            });
            response.$promise.then(fetchDataSupport);
            response.$promise.catch(errorFetchDataSupport);
        }

        function fetchDataSupport(data) {
            vm.supportActivities = [{
                'id': null,
                'activity_id': '',
                'production_product_id': '',
                'nik': '',
                'portion': '',
                'request': false
            }];
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    data[i].nik = {
                        nik: data[i].nik,
                        fullname: data[i].fullname
                    }
                    var temp = {
                        'nik': data[i].nik.nik,
                        'portion': data[i].portion
                    };
                    vm.fullJobNik.push(temp);
                }

                vm.supportActivities = data;
            }
            countEmployeeUses();

        }

        function errorFetchDataSupport() {
            vm.supportActivities = [{
                'id': null,
                'activity_id': '',
                'production_product_id': '',
                'nik': '',
                'portion': '',
                'request': false
            }];
        }

        function lookupEmployee(searchText) {
            // if (searchText.length > 3) {
            return $http
                .get(config.api + 'api/emplineposition?action=searchEmployee&search=' + searchText + '&effective_date=' + setTimeStamp(vm.Form.objForm.effective_date) + '&line_id=' + vm.Form.objForm.line_position)
                .then(function (res) {
                    console.log('res', res);
                    var datas = [];
                    for (var i = 0; i < res.data.length; i++) {
                        // var index = indexOf(res.data[i].nik);
                        // var listDataS = vm.mppStandardLists;
                        // var listData = [];

                        // for (var i = 0; i < listDataS.length; i++) {
                        //     for (var j = 0; j < listDataS[i].mpp_standar.length; j++) {
                        //         listData.push(listDataS[i].mpp_standar[j])
                        //     }
                        // }

                        var index = [];
                        var indexSupport = [];
                        index = getAllIndexes(vm.listdatastemp, 'mpp', res.data[i].nik);
                        indexSupport = getAllIndexes(vm.supportActivities, 'support', res.data[i].nik);

                        if (index.length > 0 || indexSupport.length > 0) {
                            var portion = 0;
                            for (var j = 0; j < index.length; j++) {
                                if (index[j].portion) {
                                    portion += parseInt(index[j].portion);
                                }
                            }
                            for (var i_s = 0; i_s < indexSupport.length; i_s++) {
                                if (indexSupport[i_s].portion) {
                                    portion += parseInt(indexSupport[i_s].portion);
                                }
                            }
                            if (portion != 100) {
                                datas.push(res.data[i]);
                            }
                        } else {
                            datas.push(res.data[i]);
                        }
                    }
                    return datas;
                }).catch(function (err) {
                    console.log('err', err);
                });
            // }
        }

        function lookupAllEmployee() {

            var response = EmpLinePosition.query({
                action: 'searchEmployee',
                effective_date: setTimeStamp(vm.Form.objForm.effective_date),
                line_id: vm.Form.objForm.line_position
            });
            response.$promise.then(fetchDataAllEmployee);
            response.$promise.catch(errorFetchDataAllEmployee);
        }

        function fetchDataAllEmployee(data) {
            vm.jumEmployee = {
                count: data.length,
                jumTemp: data.length,
                countKur: data.length
            };
        }

        function errorFetchDataAllEmployee() {

        }

        function getAllIndexes(arr, from, val) {
            var indexes = [],
                i = -1;
            while ((i = arr.map(function (e) {
                    if (e.nik) {
                        return e.nik.nik;
                    } else {
                        return 1
                    }
                }).indexOf(val, i + 1)) != -1) {
                if (from == 'mpp') {
                    indexes.push({
                        index: i,
                        portion: vm.mppStandardListsTemp[i].portion
                    });
                } else {
                    indexes.push({
                        index: i,
                        portion: vm.supportActivities[i].portion
                    });
                }

            }
            return indexes;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.mpp_standar = vm.mppStandardLists;
            vm.Form.objForm.support = vm.supportActivities;
            var promise = Form.saveData('save', formController, ActivityForeman);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

        function removeDuplicates(arr) {
            var unique_array = []
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] != undefined) {
                    if (unique_array.map(function (e) {
                            return e.position_group;
                        }).indexOf(arr[i].position_group) == -1) {
                        unique_array.push(arr[i])
                    }
                }
            }
            return unique_array
        }

        function setTimeStamp(date) {
            if (date == null || date == undefined || date == '') {
                var dataTimeStamp = (new Date().getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            } else {
                var dataTimeStamp = (new Date(date).getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            }

        }

        function loadProduct(search) {
            return $http
                .get(config.api + 'api/emplineposition?action=getProduct&search=' + search)
                .then(function (res) {
                    var datas = [];
                    for (var i = 0; i < res.data.length; i++) {
                        if (vm.productTemp) {
                            if (res.data[i].id != vm.productTemp.id) {
                                datas.push(res.data[i]);
                            }
                        } else {
                            datas.push(res.data[i]);
                        }

                    }
                    return datas;
                }).catch(function (err) {
                    console.log('err', err);
                });
        }

        function getSectorSpv() {
            var defer = $q.defer();
            vm.mppStandardLists = [];
            vm.Form.objForm.product = null;
            var response = ActivityForeman.query({
                action: 'getSectorSpv'
            });
            response.$promise.then(function (data) {
                // vm.listProduct = data;
                vm.listDataSector = data[0].aData;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject();
            });
            return defer.promise;
        }


        function selectedSector(sector) {
            var defer = $q.defer();
            vm.mppStandardLists = [];
            vm.Form.objForm.product = null;
            var response = ActivityForeman.query({
                action: 'getLineIdBySector',
                gedung_sector_id: sector
            });
            response.$promise.then(function (data) {
                vm.listLineForeman = data[0].aData;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject();
            });
            return defer.promise;
        }

        function selectedLine(line_id) {
            vm.productTemp = null;
            angular.element.blockUI();
            var defer = $q.defer();
            vm.mppStandardLists = [];
            vm.Form.objForm.product = null;
            var response = ActivityForeman.query({
                action: 'checkProductionProduct',
                line_id: line_id,
                effective_date: setTimeStamp(vm.Form.objForm.effective_date)
            });
            response.$promise.then(function (data) {
                if (data[0].aData.length > 0) {

                    if (parseInt(data[0].aData[0].working_hours) >= 8) {
                        vm.supportActivities = [];

                        var datasupport = data[0].aData[0].production_support;
                        vm.Form.objForm.product = data[0].aData[0];
                        vm.Form.objForm.product_qty = parseInt(data[0].aData[0].product_qty);
                        vm.Form.objForm.pp_id = data[0].aData[0].pp_id;
                        vm.Form.objForm.working_hours = parseInt(data[0].aData[0].working_hours);
                        vm.supportActivities = data[0].aData[0].production_support;
                        for (var i = 0; i < datasupport.length; i++) {
                            vm.supportActivities[i] = datasupport[i];
                            vm.supportActivities[i].portion = parseInt(datasupport[i].portion);
                            vm.supportActivities[i].nik = {
                                nik: datasupport[i].nik,
                                fullname: datasupport[i].fullname
                            }
                        }
                    } else {
                        vm.productTemp = data[0].aData[0];
                        vm.Form.objForm.working_hours = 8 - parseInt(data[0].aData[0].working_hours);
                        vm.maxWorking = 8 - parseInt(data[0].aData[0].working_hours);
                        vm.supportActivities = [];
                        vm.Form.objForm.pp_id = '';
                    }

                } else {
                    vm.Form.objForm.working_hours = 8;
                    vm.maxWorking = 8;
                    vm.supportActivities = [];
                    vm.Form.objForm.pp_id = '';
                }
                angular.element.unblockUI();
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                angular.element.unblockUI();
                $log.info(data);
                defer.reject();
            });
            return defer.promise;
        }

        function addRow() {

            var error = [];

            for (var i = 0; i < vm.supportActivities.length; i++) {
                if (!vm.supportActivities[i].nik || vm.supportActivities[i].portion == '' || vm.supportActivities[i].activity_id == '') {
                    error.push(i);
                }
            }
            if (error.length > 0) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Data Support Activity Belum Lengkap')
                    .position('top right')
                    .hideDelay(3000)
                    .theme("warn-toast")
                );
            } else {
                var row = {
                    'id': null,
                    'activity_id': '',
                    'production_product_id': '',
                    'nik': '',
                    'portion': '',
                    'request': false
                };
                vm.supportActivities.push(row);
            }

        }

        function removeRow(data, index, ev) {
            if (data.id) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var response = ActivityForeman.delete({
                        action: 'deletePpSupport',
                        data: data.id
                    });
                    response.$promise.then(vm.supportActivities.splice(index, 1));
                });
            } else {
                vm.supportActivities.splice(index, 1);
            }
            // removeItem(data, data.nik, index);
        }


        function removeItem(data, nik, index) {
            if (typeof nik != "undefined") {
                var idx = findIndex('nik', nik, vm.fullJobNik);
                vm.fullJobNik.splice(idx, 1);
                if (typeof vm.resultfullJobNik[nik][1] != "undefined") {
                    vm.resultfullJobNik[nik].splice(1, 1);
                }
                var idxtemp = vm.tempChangePortion.indexOf(nik + '_' + index)
                vm.tempChangePortion.splice(idxtemp, 1);

                data.portion = 0;
            }
        }

        function removeDuplicatesEmployess(arr) {
            var unique_array = []
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].nik) {
                    if (unique_array.map(function (e) {
                            return e.nik.nik;
                        }).indexOf(arr[i].nik.nik) == -1) {
                        unique_array.push(arr[i])
                    }
                }
            }
            return unique_array
        }



    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.master-data.update-finger-reason.input', [
        ])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State 
        $stateProvider
            .state('app.masterdata_update_finger_reason_input', {
                url    : '/master-data/update-finger-reason/input',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/update-finger-reason/input/input.html',
                        controller : 'InputUpdateFingerReasonController as vm'
                    }
                }
            })

             .state('app.masterdata_update_finger_reason_edit', {
                url    : '/master-data/update-finger-reason/edit/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/update-finger-reason/input/input.html',
                        controller : 'EditUpdateFingerReasonController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.master-data.update-finger-reason.input')
        .controller('InputUpdateFingerReasonController', InputUpdateFingerReason);


    InputUpdateFingerReason.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputUpdateFingerReason($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var UpdateFingerReason=  AppAPI.UpdateFingerReason();

         // set constructor form
         Form.setObject(UpdateFingerReason);

         // set form to controller
         vm.Form = Form;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, UpdateFingerReason);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.master-data.update-finger-reason.input')
        .controller('EditUpdateFingerReasonController', EditUpdateFingerReasonController);


    EditUpdateFingerReasonController.$inject=['$localStorage','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditUpdateFingerReasonController($localStorage,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var UpdateFingerReason=  AppAPI.UpdateFingerReason();

         // set constructor form
         Form.setObject(UpdateFingerReason);

         // set form to controller
         vm.Form = Form;

      
          vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('updatedata',formController,UpdateFingerReason,$stateParams.id,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.master-data.level.input-level', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.masterdata_level_input', {
                url    : '/master-data/level/input-level',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/level/input-level/input-level.html',
                        controller : 'InputlevelController as vm'
                    }
                }
            })

             .state('app.masterdata_level_edit', {
                url    : '/master-data/level/edit-level/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/level/input-level/input-level.html',
                        controller : 'EditlevelController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.master-data.level.input-level')
        .controller('InputlevelController', InputlevelController);


    InputlevelController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputlevelController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Level=  AppAPI.Level();

         // set constructor form
         Form.setObject(Level);

         // set form to controller
         vm.Form = Form;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Level);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.master-data.level.input-level')
        .controller('EditlevelController', EditlevelController);


    EditlevelController.$inject=['$localStorage','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditlevelController($localStorage,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Level=  AppAPI.Level();

         // set constructor form
         Form.setObject(Level);

         // set form to controller
         vm.Form = Form;

      
          vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('updatedata',formController,Level,$stateParams.id,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.master-data.job-title.input-jobtitle', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.masterdata_jobtitle_input', {
                url    : '/master-data/job-title/input-jobtitle',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/job-title/input-jobtitle/input-jobtitle.html',
                        controller : 'InputjobtitleController as vm'
                    }
                }
            })

             .state('app.masterdata_jobtitle_edit', {
                url    : '/master-data/job-title/edit-jobtitle/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/job-title/input-jobtitle/input-jobtitle.html',
                        controller : 'EditjobtitleController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/jobtitle');
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.master-data.job-title.input-jobtitle')
        .controller('InputjobtitleController', InputjobtitleController);


    InputjobtitleController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputjobtitleController($localStorage,$timeout,Form,AppAPI)
    {

        var vm = this;

         // initial form
         Form.initialForm();

         var Jobtitle=  AppAPI.Jobtitle();

         // set constructor form
         Form.setObject(Jobtitle);

         // set form to controller
         vm.Form = Form;


        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
            vm.Form.objForm.id = vm.Form.objForm.positionid;
         var response=Form.saveData('save', formController, Jobtitle);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.master-data.job-title.input-jobtitle')
        .controller('EditjobtitleController', EditjobtitleController);


    EditjobtitleController.$inject=['$localStorage','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditjobtitleController($localStorage,$stateParams,$timeout,Form,AppAPI)
    {

        var vm = this;

         // initial form
         Form.initialForm();

         var Jobtitle=  AppAPI.Jobtitle();

         // set constructor form
         Form.setObject(Jobtitle);

         // set form to controller
         vm.Form = Form;


          vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});

        vm.saveData=saveData;

        console.log(vm.Form.objForm);

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
            vm.Form.objForm.id = vm.Form.objForm.positionid;
         var response=Form.updateData('updatedata',formController,Jobtitle,$stateParams.id,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.master-data.jfm.input-jfm', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.masterdata_jfm_input', {
                url    : '/master-data/jfm/input-jfm',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/jfm/input-jfm/input-jfm.html',
                        controller : 'InputjfmController as vm'
                    }
                }
            })

             .state('app.masterdata_jfm_edit', {
                url    : '/master-data/jfm/edit-jfm/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/jfm/input-jfm/input-jfm.html',
                        controller : 'EditjfmController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/jfm');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.master-data.jfm.input-jfm')
        .controller('InputjfmController', InputjfmController);


    InputjfmController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputjfmController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Jfm=  AppAPI.Jfm();

         // set constructor form
         Form.setObject(Jfm);

         // set form to controller
         vm.Form = Form;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Jfm);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.master-data.jfm.input-jfm')
        .controller('EditjfmController', EditjfmController);


    EditjfmController.$inject=['$localStorage','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditjfmController($localStorage,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Jfm=  AppAPI.Jfm();

         // set constructor form
         Form.setObject(Jfm);

         // set form to controller
         vm.Form = Form;

      
          vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('updatedata',formController,Jfm,$stateParams.id,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.master-data.division.input-division', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.masterdata_division_input', {
                url    : '/master-data/division/input-division',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/division/input-division/input-division.html',
                        controller : 'InputdivisionController as vm'
                    }
                }
            })

             .state('app.masterdata_division_edit', {
                url    : '/master-data/division/edit-division/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/division/input-division/input-division.html',
                        controller : 'EditdivisionController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/division');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.master-data.division.input-division')
        .controller('InputdivisionController', InputdivisionController);


    InputdivisionController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputdivisionController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Division=  AppAPI.Division();

         // set constructor form
         Form.setObject(Division);

         // set form to controller
         vm.Form = Form;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Division);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.master-data.division.input-division')
        .controller('EditdivisionController', EditdivisionController);


    EditdivisionController.$inject=['$localStorage','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditdivisionController($localStorage,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Division=  AppAPI.Division();

         // set constructor form
         Form.setObject(Division);

         // set form to controller
         vm.Form = Form;

      
          vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('updatedata',formController,Division,$stateParams.id,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.master-data.department.input-department', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.masterdata_department_input', {
                url    : '/master-data/department/input-department',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/department/input-department/input-department.html',
                        controller : 'InputdepartmentController as vm'
                    }
                }
            })

             .state('app.masterdata_department_edit', {
                url    : '/master-data/department/edit-department/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/department/input-department/input-department.html',
                        controller : 'EditdepartmentController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/department');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.master-data.department.input-department')
        .controller('InputdepartmentController', InputdepartmentController);


    InputdepartmentController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputdepartmentController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Department=  AppAPI.Department();

         // set constructor form
         Form.setObject(Department);

         // set form to controller
         vm.Form = Form;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Department);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.master-data.department.input-department')
        .controller('EditdepartmentController', EditdepartmentController);


    EditdepartmentController.$inject=['$localStorage','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditdepartmentController($localStorage,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Department=  AppAPI.Department();

         // set constructor form
         Form.setObject(Department);

         // set form to controller
         vm.Form = Form;

      
          vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('updatedata',formController,Department,$stateParams.id,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.master-data.department-division.input-department-division', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.masterdata_department_division_input', {
                url    : '/master-data/department-division/input-department-division',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/department-division/input-department-division/input-department-division.html',
                        controller : 'InputdepartmentdivisionController as vm'
                    }
                }
            })

             .state('app.masterdata_department_divsion_edit', {
                url    : '/master-data/department/edit-department/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/department-division/input-department-division/input-department-division.html',
                        controller : 'EditdepartmentdivisionController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/department');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.master-data.department-division.input-department-division')
        .controller('InputdepartmentdivisionController', InputdepartmentdivisionController);


    InputdepartmentdivisionController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputdepartmentdivisionController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var DivisionDepartment=  AppAPI.DivisionDepartment();

         // set constructor form
         Form.setObject(DivisionDepartment);

         // set form to controller
         vm.Form = Form;
         vm.state='input';
         vm.loadDataDivision=loadDataDivision;
         vm.loadDataDepartment=loadDataDepartment;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        loadDataDivision();
        loadDataDepartment();
        loadDataCountry();
        loadDataCompany();

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, DivisionDepartment);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function loadDataDivision() {
            vm.listDivision = [];
            var response = DivisionDepartment.query({
                action: "getdivisions",
                bu: vm.company
            });
            response.$promise.then(function (data) {
                vm.listDivision = data;
            });
            response.$promise.catch(function (data) {
                vm.listDivision = [];
            });
        }

        function loadDataDepartment() {
            vm.listDepartment = [];
            var response = DivisionDepartment.query({
                action: "getdepartments" 
            });
            response.$promise.then(function (data) {
                vm.listDepartment = data;
            });
            response.$promise.catch(function (data) {
                vm.listDepartment = [];
            });
        }

        function loadDataCountry() {
            vm.listCountry= [];
            var response = DivisionDepartment.query({
                action: "getCountry" 
            });
            response.$promise.then(function (data) {
                vm.listCountry = data;
            });
            response.$promise.catch(function (data) {
                vm.listCountry = [];
            });
        }

        function loadDataCompany() {
            vm.listCompany= [];
            var response = DivisionDepartment.query({
                action: "getCompany" 
            });
            response.$promise.then(function (data) {
                vm.listCompany = data;
            });
            response.$promise.catch(function (data) {
                vm.listCompany = [];
            });
        }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.master-data.department-division.input-department-division')
        .controller('EditdepartmentdivisionController', EditdepartmentdivisionController);


    EditdepartmentdivisionController.$inject=['$localStorage','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditdepartmentdivisionController($localStorage,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Department=  AppAPI.Department();

         // set constructor form
         Form.setObject(Department);

         // set form to controller
         vm.Form = Form;
         vm.state='edit';

      
          vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('updatedata',formController,Department,$stateParams.id,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.master-data.business-unit.input-bu', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.masterdata_business_unit_input', {
                url    : '/master-data/business-unit/input-bu',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/business-unit/input-bu/input-bu.html',
                        controller : 'InputbuController as vm'
                    }
                }
            })

             .state('app.masterdata_business_unit_edit', {
                url    : '/master-data/business-unit/edit-bu/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/business-unit/input-bu/input-bu.html',
                        controller : 'EditbuController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.master-data.business-unit.input-bu')
        .controller('InputbuController', InputbuController);


    InputbuController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputbuController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var BU=  AppAPI.BU();

         // set constructor form
         Form.setObject(BU);

         // set form to controller
         vm.Form = Form;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, BU);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.master-data.business-unit.input-bu')
        .controller('EditbuController', EditbuController);


    EditbuController.$inject=['$localStorage','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditbuController($localStorage,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var BU=  AppAPI.BU();

         // set constructor form
         Form.setObject(BU);

         // set form to controller
         vm.Form = Form;

      
          vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('updatedata',formController,BU,$stateParams.id,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () {
    'use strict';

    angular
        .module('app.jic.emp_jic.revisied', [])
        .config(config);

    /** @ngInject */
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.emp_jic_revisied', {
                url: '/jic/emp_jic/revisied/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/jic/empjic/revisied/empjic-revisied.html',
                        controller: 'EmpJicRevisiedController as vm'
                    }
                },
                params: {
                    obj: null
                }
            });
    }
})();

(function () {
    "use strict";
    angular
        .module("app.jic.emp_jic.revisied")
        .controller("EmpJicRevisiedController", Controller);

    Controller.$inject = [
        "$state",
        "$stateParams",
        "$window",
        "$localStorage",
        "$document",
        "$mdDialog",
        "AppAPI",
        "DataService",
        "config",
        "Auth",
        "Form",
        "$log",
        "$timeout",
        "$http"
    ];
    /** @ngInject */
    function Controller(
        $state,
        $stateParams,
        $window,
        $localStorage,
        $document,
        $mdDialog,
        AppAPI,
        DataService,
        config,
        Auth,
        Form,
        $log,
        $timeout,
        $http
    ) {
        var vm = this;
        var EmpJic = AppAPI.EmpJic();

        vm.pengajuan_id = $stateParams.id;
        vm.DataTable = new DataService();
        vm.DataTable.jumDataPerPage = 5;
        vm.DataTable.searchParam = "";

        Form.initialForm();
        Form.setObject(EmpJic);

        vm.Form = Form;
        vm.cancel = cancel;

        vm.allowBusinessTitle = false;
        vm.allowJobTitle = false;
        vm.allowSalaryAdjustment = false;
        vm.allowSubareaBaru = false;

        vm.acting_start = new Date();
        vm.acting_end = new Date();
        // vm.valid_date = new Date();
        vm.selectedEmployee = {};
        vm.isSelected = false;
        vm.isLoadEmployee = false;
        vm.selectEmployee = selectEmployee;
        vm.loadList = false;
        vm.approvalType = [];
        vm.filterApproval = null;
        vm.loadData = loadData;
        vm.poolActions = [];
        vm.actionsLists = [];
        vm.isAdminPersonel = isAdminPersonel;
        vm.setMasaActing = setMasaActing;
        vm.isPersonalia = false;
        vm.setAction = setAction;
        vm.saveData = saveData;
        vm.selectedItemChange = selectedItemChange;
        vm.querySearch = querySearch;
        vm.addNewReason = addNewReason;
        vm.removeAdditionalReason = removeAdditionalReason;

        vm.isMutation = 0;
        vm.allowJabatanBaru = false;
        vm.allowGolonganBaru = false;

        vm.setSelectedReasons = setSelectedReasons;

        vm.originGrades = ['1A', '2A', '3A', '1B', '2B', '3B', '1C', '2C', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A'];
        vm.grades = angular.copy(vm.originGrades);

        activate();

        function activate() {
            loadPengajuanData();
            loadReasonsData().then(function () {
                loadSelectedReasons(vm.pengajuan_id);
            });
            loadActionsData();
            loadDataApprovedAs();
            loadSubAreaData();
            loadBuData();
        }

        function checkIsPersonalia() {
            var response = EmpJic.query({
                action: "isApprovalAdmin",
                nik: $localStorage.user,
                pengajuan_employee_id: vm.selectedEmployee.id
            });
            response.$promise.then(function (res) {
                // // console.log("res", res);
                if (res == "1") {
                    vm.isPersonalia = true;
                }
            });
            response.$promise.catch(function (err) {
                vm.isPersonalia = false;
            });
        }

        function isAdminPersonel() {
            if ($localStorage.group == 10 || vm.isPersonalia == true) {
                return true;
            }
            return false;
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function loadData(pageno) {
            var response = vm.DataTable.loadData(EmpJic, pageno, {
                action: "getEmployeeProposedList",
                pengajuanId: vm.pengajuan_id,
                approval_type: vm.filterApproval
            });

            response.then(function (data) {
                // initial select first employee
                selectEmployee(vm.DataTable.list[0]);
                vm.isLoadingLoadEmployee = false;
            });

            response.catch(function (error) {
                vm.employeeLists = [];
                vm.isLoadingLoadEmployee = false;
            });
        }

        function loadPengajuanData() {
            var dataPromise = EmpJic.query({
                action: "viewDetail",
                id: vm.pengajuan_id
            });
            dataPromise.$promise.then(function (rdata) {
                if (typeof rdata != "undefined") {
                    vm.pengajuanData = rdata[0];

                    if (rdata[0].job_title.length > 0) {
                        vm.selectedJobTitle = rdata[0].job_title[0];
                        // selectedItemChange(rdata[0].job_title[0]);
                    }
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log("Error load pengajuan data: ", err);
            });
        }

        function loadDataApprovedAs() {
            var dataPromise = EmpJic.query({
                action: "getDataApprovedAsRevisied",
                pengajuanID: vm.pengajuan_id
            });
            dataPromise.$promise.then(function (rdata) {
                // console.log('rdata', rdata);
                if (typeof rdata !== "undefined") {
                    vm.approvalType = rdata;
                    vm.filterApproval = vm.approvalType[0].approval_type;
                    loadData(1);
                    // console.log(vm.approvalType);
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log("error loadDataApprovedAs", err);
            });
        }

        /************* START LOAD REASONS ************/
        function loadReasonsData() {
            var dataPromise = EmpJic.query({
                action: 'viewReasons',
            });
            dataPromise.$promise.then(function (rdata) {
                if (typeof (rdata) !== 'undefined') {
                    vm.reasonsLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.reasonsLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log(err);
            });
            return dataPromise.$promise;
        }
        /************* END LOAD REASONS ************/

        /************* START LOAD SUBAREA ************/
        function loadSubAreaData() {
            var dataPromise = EmpJic.query({
                action: 'viewSubArea'
            });
            dataPromise.$promise.then(function (rdata) {
                // console.log('rdata', rdata);
                if (typeof (rdata) !== 'undefined') {
                    vm.subAreaLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.subAreaLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {

            });
        }
        /************* END LOAD SUBAREA ************/

        function loadSelectedReasons(pengajuan_id) {

            console.log('vm.reasonsLists', vm.reasonsLists);

            var dataPromise = EmpJic.query({
                action: "getPengajuanReasons",
                id: pengajuan_id
            });
            dataPromise.$promise.then(function (rdata) {

                console.log('rdata', rdata);

                if (typeof rdata !== "undefined") {
                    vm.newReasonsLists = [];
                    vm.reasonsLists.find(function (val) {
                        rdata.find(function (val2) {
                            if (parseInt(val.id) == parseInt(val2.reason_id)) {
                                val.checked = true;
                            }
                        });
                        vm.newReasonsLists.push(val);
                    });

                    rdata.find(function (val2) {
                        if (val2.is_other == '1') {
                            val2.name = val2.reason;
                            val2.checked = true;
                            vm.newReasonsLists.push(val2);
                        }
                    });

                    vm.reasonsLists = vm.newReasonsLists;
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log("error loadReasons", err);
            });
        }

        function selectEmployee(item) {
            vm.isSelected = true;
            setValue(item);
            actionsMapping(item);
            vm.loadList = false;
            $timeout(function () {
                setDefaultActions();
            }, 2000);
        }

        function loadActionsData() {
            var dataPromise = EmpJic.query({
                action: "viewActions"
            });
            dataPromise.$promise.then(function (rdata) {
                //console.log('rdata', rdata);
                if (typeof rdata !== "undefined") {
                    rdata.find(function (val) {
                        val.checked = false;
                        val.disabled = true;
                    });
                    vm.poolActions = rdata;
                }
                vm.isLoadEmployee = false;
            });

            dataPromise.$promise.catch(function (err) { });
        }

        function actionsMapping(item) {
            var actions = angular.copy(vm.poolActions);
            vm.actionsLists = [];
            actions.map(function (val) {
                item.actions.map(function (act) {
                    if (val.id == act.action_id) {
                        val.checked = true;
                    }
                });
                vm.actionsLists.push(val);
            });
            vm.isLoadEmployee = false;
        }

        function setValue(data) {
            // console.log('setValue/data', data);
            data.entity_id = data.company_id;
            data.country_id = data.country;
            vm.selectedEmployee = data;
            // vm.selectedJobTitle = data.jabatan_baru;

            vm.Form.objForm.gol_baru = data.grade_baru;
            //vm.selectedEmployee.emp_grade = data.grade_baru;
            vm.selectedGradeBaru = vm.selectedEmployee.grade_baru;

            vm.absensi = vm.selectedEmployee.absensi
                ? JSON.parse(vm.selectedEmployee.absensi)
                : {
                    ijin: 0,
                    sakit: 0,
                    alpha: 0
                };

            vm.konduiteAddition = {
                teguran: vm.selectedEmployee.teguran
                    ? vm.selectedEmployee.teguran
                    : "",
                surat_peringatan: vm.selectedEmployee.surat_peringatan
                    ? vm.selectedEmployee.surat_peringatan
                    : ""
            };

            vm.acting_start = ""; //new Date(data.masa_acting_akhir);
            vm.acting_end = ""; //new Date(data.masa_acting_awal);

            vm.Form.objForm.tgl_pengajuan = new Date(
                vm.selectedEmployee.tgl_pengajuan
            );

            vm.Form.objForm.job_title = data.job_title;

            vm.Form.objForm.bu = data.bu;

            vm.Form.objForm.division_id = data.division_id;
            vm.Form.objForm.department_baru_id = data.department_baru_id;

            loadDataDivision(vm.Form.objForm.bu);
            loadDataDepartment(vm.Form.objForm.division_id, true);


            vm.isLoadEmployee = true;
        }

        function setMasaActing() {
            vm.acting_start = vm.valid_date;
            var tp = angular.copy(vm.acting_start);
            var mundur_6bulan = moment(tp).add(6, "months");
            var acting_end = new Date(mundur_6bulan);
            vm.acting_end = acting_end;
        }

        function saveData(e, formController) {

            vm.selectedReason = [];
            for (var i = 0; i <= (vm.reasonsLists.length - 1); i++) {
                if (vm.reasonsLists[i].checked) {
                    vm.selectedReason.push(vm.reasonsLists[i]);
                }
            }

            vm.selectedAction = [];
            for (var i = 0; i <= (vm.actionsLists.length - 1); i++) {
                if (vm.actionsLists[i].checked) {
                    vm.selectedAction.push(vm.actionsLists[i]);
                }
            }

            vm.Form.objForm.subAreaBaru = vm.selectedSubArea;
            vm.Form.objForm.subarea_baru_id = (!vm.isMutation) ? vm.selectedEmployee.sub_area_id : vm.selectedSubArea.subarea_id;

            var setToken = Auth.setToken();
            setToken.then(function () {
                var store = EmpJic.save({
                    action: "updateRevisied",
                    id: vm.pengajuanData.id,
                    action_type: vm.selectedEmployee.action_type,
                    pengajuan_id: vm.pengajuan_id,
                    nik: vm.selectedEmployee.nik,
                    tgl_pengajuan: vm.pengajuanData.tgl_pengajuan,
                    gol_baru: vm.Form.objForm.gol_baru,
                    subarea_baru_id: vm.Form.objForm.subarea_baru_id,
                    atasan_baru: vm.pengajuanData.atasan_baru,
                    status_kerja_baru: vm.pengajuanData.status_kerja_baru,
                    reason: vm.selectedReason,
                    actions: vm.selectedAction,
                    employees: vm.selectedEmployee,
                    atasanBaru: vm.selectedEmployee.nik_atasan_baru,
                    department_baru_id: vm.Form.objForm.department_baru_id,
                    job_title: vm.Form.objForm.job_title
                });

                store.$promise.then(function (data) {
                    showDialog(e, data);

                });

                store.$promise.catch(function (data) {
                    showDialog(e, data);
                });
            });

            setToken.catch(function (err) {
                console.log(err);
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.pesan)
                        .ariaLabel(data.title)
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function () {
                    closeModal();
                });
        }

        function closeModal() {
            $mdDialog.hide();
            loadData(1);
            $state.go("app.emp_jic");
        }

        function setAction(ev, idx) {
            vm.selectedAction = [];
            if (vm.actionsLists[idx].id == 1) {
                if (vm.actionsLists[idx].checked) {
                    vm.allowJabatanBaru = true;
                    vm.allowGolonganBaru = false;
                    vm.actionsLists[1].checked = false;
                } else {
                    vm.allowJabatanBaru = false;
                }
            }

            if (vm.actionsLists[idx].id == 2) {
                if (vm.actionsLists[idx].checked) {
                    vm.allowJabatanBaru = false;
                    vm.allowGolonganBaru = true;
                    vm.actionsLists[0].checked = false;
                } else {
                    vm.allowGolonganBaru = false;
                }
            }

            if (vm.actionsLists[idx].id == 3) {
                if (vm.actionsLists[idx].checked && (vm.allowJabatanBaru == false && vm.allowGolonganBaru == false)) {
                    vm.isMutation = 1;
                } else {
                    vm.isMutation = 0;
                }
            }

            if (vm.allowJabatanBaru) {
                var newGrades = [];
                var lockGrades = true;
                var tmpGrade = angular.copy(vm.originGrades);
                tmpGrade.find(function (val) {
                    if (!lockGrades) {
                        newGrades.push(val);
                    }
                    if (val == vm.selectedEmployee.emp_grade) {
                        lockGrades = false;
                    }
                });
                vm.grades = newGrades;
            }

            if (vm.allowGolonganBaru) {
                var newGrades = [];
                var lockGrades = false;
                var tmpGrade = angular.copy(vm.originGrades);
                tmpGrade.find(function (val) {
                    if (val == vm.selectedEmployee.emp_grade) {
                        lockGrades = true;
                    }
                    if (!lockGrades) {
                        newGrades.push(val);
                    }
                });
                vm.grades = newGrades;
            }

        }

        function setDefaultActions() {

            vm.selectedGradeBaru = vm.selectedEmployee.grade_baru;

            vm.actionsLists.find(function (val) {

                if (val.id == 1) {
                    if (val.checked) {
                        vm.allowJabatanBaru = true;
                        vm.allowGolonganBaru = false;
                        vm.actionsLists[1].checked = false;
                    } else {
                        vm.allowJabatanBaru = false;
                    }
                }

                if (val.id == 2) {
                    if (val.checked) {
                        vm.allowJabatanBaru = false;
                        vm.allowGolonganBaru = true;
                        vm.actionsLists[0].checked = false;
                    } else {
                        vm.allowGolonganBaru = false;
                    }
                }

                if (val.id == 3) {
                    if (val.checked && (vm.allowJabatanBaru == false && vm.allowGolonganBaru == false)) {
                        vm.isMutation = 1;
                    } else {
                        vm.isMutation = 0;
                    }
                }

                if (vm.allowJabatanBaru) {
                    var newGrades = [];
                    var lockGrades = true;
                    var tmpGrade = angular.copy(vm.originGrades);
                    console.log('tmpGrade', tmpGrade);
                    tmpGrade.find(function (val) {
                        // if (!lockGrades) {
                        //     newGrades.push(val);
                        // }
                        if (val > vm.selectedEmployee.grade_lama) {
                            newGrades.push(val);
                        }
                    });
                    vm.grades = newGrades.sort();
                }

                if (vm.allowGolonganBaru) {
                    var newGrades = [];
                    var lockGrades = false;
                    var tmpGrade = angular.copy(vm.originGrades);
                    // console.log('tmpGrade', tmpGrade);
                    tmpGrade.find(function (val) {
                        if (val < vm.selectedEmployee.grade_lama) {
                            lockGrades = true;
                            newGrades.push(val);
                        }
                    });
                    vm.grades = newGrades.sort();
                }

            });

            // $timeout(function () {
            //     vm.Form.objForm.gol_baru = vm.selectedEmployee.grade_baru;
            //     vm.selectedEmployee.emp_grade = vm.selectedEmployee.grade_baru;
            //     vm.selectedGradeBaru = vm.selectedEmployee.grade_baru;
            // }, 5000);

        }

        function selectedItemChange(item) {
            if (item) {
                vm.Form.objForm.job_title = item;
                vm.Form.objForm.department_baru_id = item.department_id;
                vm.Form.objForm.department_name = item.department_name;
                vm.Form.objForm.division_id = item.division_id;
                vm.Form.objForm.division_name = item.division_name;
                loadListAtasanBaru(item);
            }
        }

        function loadListAtasanBaru(jobTitle) {
            var dataPromise = EmpJic.query({
                action: 'getDataListDirectReport',
                layerId: jobTitle.direct_report
            });
            dataPromise.$promise.then(function (rdata) {
                vm.listAtasanBaru = rdata;
                vm.atasanBaru = rdata[0];
            });
            dataPromise.$promise.catch(function (err) {
                vm.listAtasanBaru = '';
            });
        }

        function querySearch(params) {
            return $http
                .get(config.api + 'api/jic/empjic?action=getDataListLayer&search=' + params + '&isMutation=' + vm.isMutation)
                .then(function (item) {
                    return item.data;
                });
        }

        function addNewReason(reason) {

            if (reason == '' || reason.length == 0) {
                return false;
            }

            vm.reasonsLists.push({
                id: '',
                name: reason,
                checked: true,
                isAdditional: true
            });
            vm.additionalReason = '';

            setSelectedReasons();

        }

        function removeAdditionalReason(idx, item) {
            vm.reasonsLists.splice(idx, 1);
            setSelectedReasons();
        }

        // function setSelectedReasons() {
        //     vm.selectedReason = [];
        //     for (var i = 0; i <= (vm.reasonsLists.length - 1); i++) {
        //         if (vm.reasonsLists[i].checked == true) {
        //             vm.selectedReason.push(vm.reasonsLists[i]);
        //         }
        //     }
        // }

        function setSelectedReasons(item) {

            console.log('item', item);

            if (item.id == 2 && item.checked == true) {
                vm.alasanPergantianKaryawan = true;
            } else {
                vm.alasanPergantianKaryawan = false;
            }

            vm.selectedReason = [];
            for (var i = 0; i <= (vm.reasonsLists.length - 1); i++) {
                if (vm.reasonsLists[i].checked == true) {
                    vm.selectedReason.push(vm.reasonsLists[i]);
                }
            }
        }

        function loadBuData() {
            var dataPromise = EmpJic.query({
                action: 'viewBu'
            });
            dataPromise.$promise.then(function (rdata) {
                // console.log('rdata', rdata);
                if (typeof (rdata) !== 'undefined') {
                    vm.buLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.buLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {

            });
        }

        vm.loadDataDivision = loadDataDivision;

        function loadDataDivision(idbu) {
            vm.saveProcess = true;
            var response = EmpJic.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            vm.saveProcess = false;
            // vm.listDivision.push(data); 
            // loadData(1); 
        }

        function errorDivisiBU() {
            vm.listDivision = [];
            vm.saveProcess = false;
        }

        vm.loadDataDepartment = loadDataDepartment;

        function loadDataDepartment(iddivisi, isChange) {
            vm.saveProcess = true;
            if (isChange) {
                vm.listJobTitle = [];
                vm.Form.objForm.jobTitle = 'set';
            }
            var response = EmpJic.query({ action: 'viewDivisiDept', idbu: vm.Form.objForm.bu, iddivisi: iddivisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            vm.saveProcess = false;
        }

        function errorDepartment() {
            vm.listDepartment = [];
            vm.saveProcess = false;
        }

        vm.lookupEmployee = lookupEmployee;

        function lookupEmployee(ev) {

            ev.preventDefault();

            var dialog = $mdDialog.show({
                controller: 'EmpJicLookupEmployeeAtasanController',
                controllerAs: 'vm',
                templateUrl: 'app/main/jic/empjic/add/lookup-atasan/lookup-atasan.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    id: { company: vm.selectedEmployee.bu, divisi: vm.selectedEmployee.division_id, department: vm.selectedEmployee.department_baru_id }
                }
            }).then(function (response) {
                if (response) {
                    vm.selectedEmployee.nik_atasan_baru = response.nik;
                    vm.Form.objForm.nik_atasan_baru = response.nik;
                    vm.selectedEmployee.nama_atasan_baru = response.nama;
                }
            }).catch(function (responseIfRejected) {

            }).finally(function () {
            });
        }

        vm.lookupJobTitle = lookupJobTitle;

        function lookupJobTitle(ev) {
            vm.isLayerOverlap = false;
            $mdDialog.show({
                controller: 'LookUpLayerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/jic/empjic/add/lookup-layer/lookup-layer.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {

                },
                locals: {
                    id: { company: vm.Form.objForm.bu, divisi: vm.Form.objForm.division_id, department: vm.Form.objForm.department_baru_id, directReport: vm.selectedEmployee.nik_atasan_baru, disable: false }
                }
            }).then(function (response) {
                console.log(response);
                if (response) {
                    vm.Form.objForm.job_title = response;
                    vm.Form.objForm.department_name = response.department_name;
                    vm.Form.objForm.division_name = response.division_name;

                    vm.Form.objForm.division_id = response.filter.division_id;
                    vm.Form.objForm.department_baru_id = response.filter.department_id;
                    loadDataDivision(vm.Form.objForm.bu);
                    loadDataDepartment(vm.Form.objForm.division_id, false);
                }
            }).catch(function (responseIfRejected) {

            }).finally(function () {
            });
        }


    }
})();

(function () {
    'use strict';
    angular
        .module('app.jic.emp_jic')
        .controller('EmpJicPrintSKController', EmpJicPrintSKController);

    EmpJicPrintSKController.$inject = ['$state', 'pengajuanData', '$mdDialog', 'AppAPI', 'Form', 'Auth'];
    /** @ngInject */
    function EmpJicPrintSKController($state, pengajuanData, $mdDialog, AppAPI, Form, Auth) {
        var vm = this;
        var EmpJic = AppAPI.EmpJic();

        Form.initialForm();
        Form.setObject(EmpJic);
        vm.Form = Form;
        vm.cancel = cancel;
        vm.data = pengajuanData;
        vm.printPDF = printPDF;

        loadData();

        function loadData() {
            var response = EmpJic.query({
                action: 'viewDetail',
                id: vm.data.id,
            });
            response.$promise.then(function (res) {
                if (typeof (res[0]) != 'undefined') {
                    vm.data = res[0];
                    if (typeof (res[0].employees) != 'undefined') {
                        vm.employeeLists = res[0].employees;

                        console.log('vm.employeeLists', vm.employeeLists);

                    }
                    if (typeof (res[0].actions) != 'undefined') {
                        vm.actionsLists = res[0].actions;
                    }
                }
            });
            response.$promise.catch(function (err) {
                console.log('err', err);
            });
        }

        function printPDF(ev, module_name, already_print, item) {
            if (module_name == 'sk_promosi_awal' && already_print == 0 && item.allowance === '') {

                var confirm = $mdDialog.prompt()
                    .title('Promotion Allowance')
                    .textContent('Please entry the Promotion Allowance')
                    //.placeholder('Rp.')
                    //.ariaLabel('Dog name')
                    //.initialValue('promotion_allowance')
                    .targetEvent(ev)
                    // .required(true)
                    .ok('Submit!')
                    .cancel('Cancel');

                $mdDialog.show(confirm).then(function (result) {

                    var setToken = Auth.setToken();
                    setToken.then(function () {
                        var store = EmpJic.save({
                            action: 'storeTempAllowance',
                            action_type: 'sk_promosi_awal',
                            pengajuan_employee_id: item.id,
                            allowance: result
                        });
                        store.$promise.then(function (data) {

                            $state.goNewTab("app.report.jic." + module_name, {
                                id: item.id,
                            });

                        });
                        store.$promise.catch(function (data) {
                            console.log(data);
                        });
                    });
                    setToken.catch(function (err) {
                        console.log(err)
                    });

                    //  $scope.status = 'You decided to name your dog ' + result + '.';
                }, function () {
                    console.log('cancel');
                });

            } else {
                $state.goNewTab("app.report.jic." + module_name, {
                    id: item.id,
                });
            }
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.jic.emp_jic.edit', [])
        .config(config);

    /** @ngInject */
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.emp_jic_edit', {
                url: '/jic/emp_jic/edit/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/jic/empjic/edit/empjic-edit.html',
                        controller: 'EmpJicEditController as vm'
                    }
                },
                params: {
                    obj: null
                }
            });
    }
})();

(function () {
    "use strict";
    angular
        .module("app.jic.emp_jic.edit")
        .controller("EmpJicEditController", Controller);

    Controller.$inject = [
        "$state",
        "$stateParams",
        "$window",
        "$localStorage",
        "$document",
        "$mdDialog",
        "AppAPI",
        "DataService",
        "config",
        "Auth",
        "Form",
        "$log",
        "$timeout",
        "$http"
    ];
    /** @ngInject */
    function Controller(
        $state,
        $stateParams,
        $window,
        $localStorage,
        $document,
        $mdDialog,
        AppAPI,
        DataService,
        config,
        Auth,
        Form,
        $log,
        $timeout,
        $http
    ) {
        var vm = this;
        var EmpJic = AppAPI.EmpJic();

        vm.pengajuan_id = $stateParams.id;
        vm.DataTable = new DataService();
        vm.DataTable.jumDataPerPage = 5;
        vm.DataTable.searchParam = "";

        Form.initialForm();
        Form.setObject(EmpJic);

        vm.Form = Form;
        vm.cancel = cancel;

        vm.allowBusinessTitle = false;
        vm.allowJobTitle = false;
        vm.allowSalaryAdjustment = false;
        vm.allowSubareaBaru = false;

        vm.acting_start = new Date();
        vm.acting_end = new Date();
        // vm.valid_date = new Date();
        vm.selectedEmployee = {};
        vm.isSelected = false;
        vm.isLoadEmployee = false;
        vm.selectEmployee = selectEmployee;
        vm.loadList = false;
        vm.approvalType = [];
        vm.filterApproval = null;
        vm.loadData = loadData;
        vm.poolActions = [];
        vm.actionsLists = [];
        vm.isAdminPersonel = isAdminPersonel;
        vm.setMasaActing = setMasaActing;
        vm.isPersonalia = false;
        vm.setAction = setAction;
        vm.saveData = saveData;
        vm.selectedItemChange = selectedItemChange;
        vm.querySearch = querySearch;
        vm.addNewReason = addNewReason;
        vm.removeAdditionalReason = removeAdditionalReason;

        vm.isMutation = 0;
        vm.allowJabatanBaru = false;
        vm.allowGolonganBaru = false;

        vm.setSelectedReasons = setSelectedReasons;

        vm.originGrades = ['1A', '2A', '3A', '1B', '2B', '3B', '1C', '2C', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A'];
        vm.grades = angular.copy(vm.originGrades);

        activate();

        function activate() {
            loadPengajuanData();
            loadReasonsData().then(function () {
                loadSelectedReasons(vm.pengajuan_id);
            });
            loadActionsData();
            loadDataApprovedAs();
            loadSubAreaData();
        }

        function checkIsPersonalia() {
            var response = EmpJic.query({
                action: "isApprovalAdmin",
                nik: $localStorage.user,
                pengajuan_employee_id: vm.selectedEmployee.id
            });
            response.$promise.then(function (res) {
                // // console.log("res", res);
                if (res == "1") {
                    vm.isPersonalia = true;
                }
            });
            response.$promise.catch(function (err) {
                vm.isPersonalia = false;
            });
        }

        function isAdminPersonel() {
            if ($localStorage.group == 10 || vm.isPersonalia == true) {
                return true;
            }
            return false;
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function loadData(pageno) {
            var response = vm.DataTable.loadData(EmpJic, pageno, {
                action: "getEmployeeProposedList",
                pengajuanId: vm.pengajuan_id,
                approval_type: vm.filterApproval
            });

            response.then(function (data) {
                // initial select first employee
                selectEmployee(vm.DataTable.list[0]);
                vm.isLoadingLoadEmployee = false;
            });

            response.catch(function (error) {
                vm.employeeLists = [];
                vm.isLoadingLoadEmployee = false;
            });
        }

        function loadPengajuanData() {
            var dataPromise = EmpJic.query({
                action: "viewDetail",
                id: vm.pengajuan_id
            });
            dataPromise.$promise.then(function (rdata) {
                if (typeof rdata != "undefined") {
                    vm.pengajuanData = rdata[0];
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log("Error load pengajuan data: ", err);
            });
        }

        function loadDataApprovedAs() {
            var dataPromise = EmpJic.query({
                action: "getDataApprovedAs",
                pengajuanID: vm.pengajuan_id
            });
            dataPromise.$promise.then(function (rdata) {
                // console.log('rdata', rdata);
                if (typeof rdata !== "undefined") {
                    vm.approvalType = rdata;
                    vm.filterApproval = vm.approvalType[0].approval_type;
                    loadData(1);
                    // console.log(vm.approvalType);
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log("error loadDataApprovedAs", err);
            });
        }

        /************* START LOAD REASONS ************/
        function loadReasonsData() {
            var dataPromise = EmpJic.query({
                action: 'viewReasons',
            });
            dataPromise.$promise.then(function (rdata) {
                if (typeof (rdata) !== 'undefined') {
                    vm.reasonsLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.reasonsLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log(err);
            });
            return dataPromise.$promise;
        }
        /************* END LOAD REASONS ************/

        /************* START LOAD SUBAREA ************/
        function loadSubAreaData() {
            var dataPromise = EmpJic.query({
                action: 'viewSubArea'
            });
            dataPromise.$promise.then(function (rdata) {
                // console.log('rdata', rdata);
                if (typeof (rdata) !== 'undefined') {
                    vm.subAreaLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.subAreaLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {

            });
        }
        /************* END LOAD SUBAREA ************/

        function loadSelectedReasons(pengajuan_id) {

            console.log('vm.reasonsLists', vm.reasonsLists);

            var dataPromise = EmpJic.query({
                action: "getPengajuanReasons",
                id: pengajuan_id
            });
            dataPromise.$promise.then(function (rdata) {

                console.log('rdata', rdata);

                if (typeof rdata !== "undefined") {
                    vm.newReasonsLists = [];
                    vm.reasonsLists.find(function (val) {
                        rdata.find(function (val2) {
                            if (parseInt(val.id) == parseInt(val2.reason_id)) {
                                val.checked = true;
                            }
                        });
                        vm.newReasonsLists.push(val);
                    });

                    rdata.find(function (val2) {
                        if (val2.is_other == '1') {
                            val2.name = val2.reason;
                            val2.checked = true;
                            vm.newReasonsLists.push(val2);
                        }
                    });

                    vm.reasonsLists = vm.newReasonsLists;
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log("error loadReasons", err);
            });
        }

        function selectEmployee(item) {
            vm.isSelected = true;
            setValue(item);
            actionsMapping(item);
            vm.loadList = false;
            $timeout(function () {
                setDefaultActions();
            }, 2000);
        }

        function loadActionsData() {
            var dataPromise = EmpJic.query({
                action: "viewActions"
            });
            dataPromise.$promise.then(function (rdata) {
                //console.log('rdata', rdata);
                if (typeof rdata !== "undefined") {
                    rdata.find(function (val) {
                        val.checked = false;
                        val.disabled = true;
                    });
                    vm.poolActions = rdata;
                }
                vm.isLoadEmployee = false;
            });

            dataPromise.$promise.catch(function (err) { });
        }

        function actionsMapping(item) {
            var actions = angular.copy(vm.poolActions);
            vm.actionsLists = [];
            actions.map(function (val) {
                item.actions.map(function (act) {
                    if (val.id == act.action_id) {
                        val.checked = true;
                    }
                });
                vm.actionsLists.push(val);
            });
            vm.isLoadEmployee = false;
        }

        function setValue(data) {
            // console.log('setValue/data', data);
            vm.selectedEmployee = data;
            vm.selectedJobTitle = data.jabatan_baru;

            vm.Form.objForm.gol_baru = data.grade_baru;
            //vm.selectedEmployee.emp_grade = data.grade_baru;
            vm.selectedGradeBaru = vm.selectedEmployee.grade_baru;

            vm.absensi = vm.selectedEmployee.absensi
                ? JSON.parse(vm.selectedEmployee.absensi)
                : {
                    ijin: 0,
                    sakit: 0,
                    alpha: 0
                };

            vm.konduiteAddition = {
                teguran: vm.selectedEmployee.teguran
                    ? vm.selectedEmployee.teguran
                    : "",
                surat_peringatan: vm.selectedEmployee.surat_peringatan
                    ? vm.selectedEmployee.surat_peringatan
                    : ""
            };

            vm.acting_start = ""; //new Date(data.masa_acting_akhir);
            vm.acting_end = ""; //new Date(data.masa_acting_awal);

            vm.Form.objForm.tgl_pengajuan = new Date(
                vm.selectedEmployee.tgl_pengajuan
            );
            vm.isLoadEmployee = true;
        }

        function setMasaActing() {
            vm.acting_start = vm.valid_date;
            var tp = angular.copy(vm.acting_start);
            var mundur_6bulan = moment(tp).add(6, "months");
            var acting_end = new Date(mundur_6bulan);
            vm.acting_end = acting_end;
        }

        function saveData(e, formController) {

            vm.selectedReason = [];
            for (var i = 0; i <= (vm.reasonsLists.length - 1); i++) {
                if (vm.reasonsLists[i].checked) {
                    vm.selectedReason.push(vm.reasonsLists[i]);
                }
            }

            vm.selectedAction = [];
            for (var i = 0; i <= (vm.actionsLists.length - 1); i++) {
                if (vm.actionsLists[i].checked) {
                    vm.selectedAction.push(vm.actionsLists[i]);
                }
            }

            vm.layer_id_baru = vm.pengajuanData.layer_id_baru;
            if (typeof (vm.listAtasanBaru[0]) != 'undefined') {
                vm.layer_id_baru = vm.listAtasanBaru[0].layer_id;
            }

            vm.jabatan_baru = vm.pengajuanData.jabatan_baru;
            if (typeof (vm.selectedJobTitle.description) != 'undefined') {
                vm.jabatan_baru = vm.selectedJobTitle.description;
            }

            var setToken = Auth.setToken();
            setToken.then(function () {
                var store = EmpJic.save({
                    action: "update",
                    id: vm.pengajuanData.id,
                    action_type: vm.selectedEmployee.action_type,
                    pengajuan_id: vm.pengajuan_id,
                    nik: vm.selectedEmployee.nik,
                    tgl_pengajuan: vm.pengajuanData.tgl_pengajuan,
                    jabatan_baru: vm.jabatan_baru,
                    gol_baru: vm.Form.objForm.gol_baru,
                    subarea_baru_id: vm.Form.objForm.subarea_baru_id,
                    atasan_baru: vm.pengajuanData.atasan_baru,
                    status_kerja_baru: vm.pengajuanData.status_kerja_baru,
                    reason: vm.selectedReason,
                    actions: vm.selectedAction,
                    employees: vm.selectedEmployee,
                    atasanBaru: vm.atasanBaru,
                    department_baru_id: vm.Form.objForm.department_baru_id,
                    layer_id_baru: vm.layer_id_baru
                });

                store.$promise.then(function (data) {
                    showDialog(e, data);

                });

                store.$promise.catch(function (data) {
                    showDialog(e, data);
                });
            });

            setToken.catch(function (err) {
                console.log(err);
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.pesan)
                        .ariaLabel(data.title)
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function () {
                    closeModal();
                });
        }

        function closeModal() {
            $mdDialog.hide();
            loadData(1);
        }

        function setAction(ev, idx) {
            vm.selectedAction = [];
            if (vm.actionsLists[idx].id == 1) {
                if (vm.actionsLists[idx].checked) {
                    vm.allowJabatanBaru = true;
                    vm.allowGolonganBaru = false;
                    vm.actionsLists[1].checked = false;
                } else {
                    vm.allowJabatanBaru = false;
                }
            }

            if (vm.actionsLists[idx].id == 2) {
                if (vm.actionsLists[idx].checked) {
                    vm.allowJabatanBaru = false;
                    vm.allowGolonganBaru = true;
                    vm.actionsLists[0].checked = false;
                } else {
                    vm.allowGolonganBaru = false;
                }
            }

            if (vm.actionsLists[idx].id == 3) {
                if (vm.actionsLists[idx].checked && (vm.allowJabatanBaru == false && vm.allowGolonganBaru == false)) {
                    vm.isMutation = 1;
                } else {
                    vm.isMutation = 0;
                }
            }

            if (vm.allowJabatanBaru) {
                var newGrades = [];
                var lockGrades = true;
                var tmpGrade = angular.copy(vm.originGrades);
                tmpGrade.find(function (val) {
                    if (!lockGrades) {
                        newGrades.push(val);
                    }
                    if (val == vm.selectedEmployee.emp_grade) {
                        lockGrades = false;
                    }
                });
                vm.grades = newGrades;
            }

            if (vm.allowGolonganBaru) {
                var newGrades = [];
                var lockGrades = false;
                var tmpGrade = angular.copy(vm.originGrades);
                tmpGrade.find(function (val) {
                    if (val == vm.selectedEmployee.emp_grade) {
                        lockGrades = true;
                    }
                    if (!lockGrades) {
                        newGrades.push(val);
                    }
                });
                vm.grades = newGrades;
            }

        }

        function setDefaultActions() {

            vm.selectedGradeBaru = vm.selectedEmployee.grade_baru;

            vm.actionsLists.find(function (val) {

                if (val.id == 1) {
                    if (val.checked) {
                        vm.allowJabatanBaru = true;
                        vm.allowGolonganBaru = false;
                        vm.actionsLists[1].checked = false;
                    } else {
                        vm.allowJabatanBaru = false;
                    }
                }

                if (val.id == 2) {
                    if (val.checked) {
                        vm.allowJabatanBaru = false;
                        vm.allowGolonganBaru = true;
                        vm.actionsLists[0].checked = false;
                    } else {
                        vm.allowGolonganBaru = false;
                    }
                }

                if (val.id == 3) {
                    if (val.checked && (vm.allowJabatanBaru == false && vm.allowGolonganBaru == false)) {
                        vm.isMutation = 1;
                    } else {
                        vm.isMutation = 0;
                    }
                }

                if (vm.allowJabatanBaru) {
                    var newGrades = [];
                    var lockGrades = true;
                    var tmpGrade = angular.copy(vm.originGrades);
                    console.log('tmpGrade', tmpGrade);
                    tmpGrade.find(function (val) {
                        if (!lockGrades) {
                            newGrades.push(val);
                        }
                        if (val == vm.selectedEmployee.emp_grade) {
                            lockGrades = false;
                        }
                    });
                    vm.grades = newGrades;
                }

                if (vm.allowGolonganBaru) {
                    var newGrades = [];
                    var lockGrades = false;
                    var tmpGrade = angular.copy(vm.originGrades);
                    // console.log('tmpGrade', tmpGrade);
                    tmpGrade.find(function (val) {
                        if (val == vm.selectedEmployee.emp_grade) {
                            lockGrades = true;
                        }
                        if (!lockGrades) {
                            newGrades.push(val);
                        }
                    });
                    vm.grades = newGrades;
                }

            });

            // $timeout(function () {
            //     vm.Form.objForm.gol_baru = vm.selectedEmployee.grade_baru;
            //     vm.selectedEmployee.emp_grade = vm.selectedEmployee.grade_baru;
            //     vm.selectedGradeBaru = vm.selectedEmployee.grade_baru;
            // }, 5000);

        }

        function selectedItemChange(item) {
            console.log('item', item);
            if (item) {
                vm.Form.objForm.job_title = item;
                vm.Form.objForm.department_baru_id = item.department_id;
                vm.Form.objForm.department_name = item.department_name;
                loadListAtasanBaru(item);
            }
        }

        function loadListAtasanBaru(jobTitle) {
            var dataPromise = EmpJic.query({
                action: 'getDataListDirectReport',
                layerId: jobTitle.direct_report
            });
            dataPromise.$promise.then(function (rdata) {
                vm.listAtasanBaru = rdata;
                vm.atasanBaru = rdata[0];
                vm.pengajuanData.atasan_baru = vm.atasanBaru;
            });
            dataPromise.$promise.catch(function (err) {
                vm.listAtasanBaru = '';
            });
        }

        function querySearch(params) {
            return $http
                .get(config.api + 'api/jic/empjic?action=getDataListLayer&search=' + params + '&isMutation=' + vm.isMutation)
                .then(function (item) {
                    return item.data;
                });
        }

        function addNewReason(reason) {

            if (reason == '' || reason.length == 0) {
                return false;
            }

            vm.reasonsLists.push({
                id: '',
                name: reason,
                checked: true,
                isAdditional: true
            });
            vm.additionalReason = '';

            setSelectedReasons();

        }

        function removeAdditionalReason(idx, item) {
            vm.reasonsLists.splice(idx, 1);
            setSelectedReasons();
        }

        // function setSelectedReasons() {
        //     vm.selectedReason = [];
        //     for (var i = 0; i <= (vm.reasonsLists.length - 1); i++) {
        //         if (vm.reasonsLists[i].checked == true) {
        //             vm.selectedReason.push(vm.reasonsLists[i]);
        //         }
        //     }
        // }

        function setSelectedReasons(item) {

            console.log('item', item);

            if (item.id == 2 && item.checked == true) {
                vm.alasanPergantianKaryawan = true;
            } else {
                vm.alasanPergantianKaryawan = false;
            }

            vm.selectedReason = [];
            for (var i = 0; i <= (vm.reasonsLists.length - 1); i++) {
                if (vm.reasonsLists[i].checked == true) {
                    vm.selectedReason.push(vm.reasonsLists[i]);
                }
            }
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.jic.emp_jic')
        .controller('EmpJicDelegasiController', EmpJicDelegasiController);

    EmpJicDelegasiController.$inject = ['pengajuanData', '$mdDialog', 'AppAPI', 'config', 'Form', '$http'];
    /** @ngInject */
    function EmpJicDelegasiController(pengajuanData, $mdDialog, AppAPI, config, Form, $http) {
        var vm = this;
        var EmpJic = AppAPI.EmpJic();
        Form.initialForm();
        Form.setObject(EmpJic);
        vm.Form = Form;
        vm.cancel = cancel;
        vm.data = pengajuanData;
        vm.saveData = saveData;
        vm.querySearch = querySearch;
        vm.selectedItem = selectedItem;
        vm.isSubmit = false;

        loadData();

        function loadData() {
            var response = EmpJic.query({
                action: 'viewDelegasi',
                id: vm.data.id,
            });
            response.$promise.then(function (res) {
                vm.approvalLists = res;
            });
            response.$promise.catch(function (err) {
                console.log('err', err);
            });
        }

        function saveData(ev, frmController) {

            vm.isSubmit = true;

            var store = EmpJic.save({
                action: 'saveDelegasi',
                approvals: vm.approvalLists,
                pengajuan_id: vm.data.id
            });

            store.$promise.then(function (res) {
                console.log('res', res);
                vm.messageTheme = 'green';
                setTimeout(function () {
                    $mdDialog.cancel();
                }, 500);
                vm.isSubmit = false;
            });

            store.$promise.catch(function (err) {
                console.log('err', err);
                vm.messageTheme = 'red';
                vm.isSubmit = false;
            });

        }

        function querySearch(params) {
            return $http
                .get(config.api + 'api/jic/empjic?action=searchEmployeeDelegasi&search=' + params)
                .then(function (item) {
                    return item.data;
                });
        }

        function selectedItem(list, item) {
            item.delegasi = list;
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.jic.emp_jic')
        .controller('EmpJicAddController', EmpJicAddController);

    EmpJicAddController.$inject = [
        '$localStorage',
        '$mdDialog',
        'AppAPI',
        'config',
        'Form',
        '$http',
        'Auth',
        '$state',
        '$element'
    ];

    /** @ngInject */
    function EmpJicAddController(
        $localStorage,
        $mdDialog,
        AppAPI,
        config,
        Form,
        $http,
        Auth,
        $state,
        $element
    ) {
        var vm = this;
        var EmpJic = AppAPI.EmpJic();
        vm.saveData = saveData;
        vm.addNewReason = addNewReason;
        vm.removeAdditionalReason = removeAdditionalReason;
        vm.checkEmployee = checkEmployee;
        vm.selectedReason = [];
        vm.selectedAction = [];
        vm.employeeLists = [];
        vm.listAtasanBaru = [];
        vm.selectedEmployee = {};
        vm.selectedEmployeeLists = [];
        vm.employee = {};
        vm.setAction = setAction;
        vm.setSelectedReasons = setSelectedReasons;
        vm.nik = $localStorage.user;
        vm.statusKerjaLists = ['', 'Permanent', 'Contract', 'Probation'];
        vm.isLoadingLoadEmployee = false;
        vm.lookupStafEmployee = lookupStafEmployee;
        vm.isRemoveAction = false;
        vm.deleteEmpSelected = deleteEmpSelected;
        vm.loadListLayer = loadListLayer;
        vm.loadListAtasanBaru = loadListAtasanBaru;
        vm.searchTerm = '';
        vm.querySearch = querySearch;
        vm.searchTermAtasanBaru = '';
        vm.selectedItemChange = selectedItemChange;
        vm.clearSearchTerm = clearSearchTerm;
        vm.reloadToken = reloadToken;
        vm.isAllowAdd = false;
        vm.isSubmit = false;

        Form.setObject(EmpJic);
        vm.Form = Form;

        vm.tgl_pengajuan = new Date(moment());

        vm.isMutation = 0;
        vm.allowJabatanBaru = false;
        vm.allowGolonganBaru = false;

        vm.originGrades = ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A', '6B', '6C', '7'];
        vm.grades = angular.copy(vm.originGrades);

        vm.levels = ['001', '002', '003', '004', '005', '006', '007'];

        vm.reasonsLists = [];
        vm.reasonsEmployeeChanges = {};

        vm.alasanPergantianKaryawan = false;
        vm.queryReasonPositionSearch = queryReasonPositionSearch;
        vm.selectedReasonPositionChanged = selectedReasonPositionChanged;
        vm.queryReasonEmployeeSearch = queryReasonEmployeeSearch;
        vm.selectedIReasonEmployeeChanged = selectedIReasonEmployeeChanged;

        vm.searchSubAreaTerm = '';
        vm.searchSubAreaClicked = searchSubAreaClicked;
        vm.isReasonsInformationCompleted = isReasonsInformationCompleted;

        // if ($localStorage.group >= 5) {
        //     vm.isAllowAdd = true;
        // }

        vm.loadSubAreaData = loadSubAreaData;
        vm.Form.objForm.gol_baru=null;

        loadActionData();
        loadWorkStatusData();
        loadBuData();
        loadSubAreaData(vm.Form.objForm.bu);
        loadDataDivision(vm.Form.objForm.bu);

        loadListLayer();
        loadReasonsData();

        vm.clearSearchSubAreaTerm = function () {
            vm.searchSubAreaTerm = '';
        };
        // The md-select directive eats keydown events for some quick select
        // logic. Since we have a search input here, we don't need that logic.
        setTimeout(function () {
            $element.find('input').on('keydown', function (ev) {
                console.log('ev', ev);
                ev.stopPropagation();
            });
        }, 200);

        // vm.fixedSearcSubArea = fixedSearcSubArea;
        // function fixedSearcSubArea(ev) {
        //     console.log('ev', ev);
        //     ev.stopPropagation();
        // }

        function isReasonsInformationCompleted() {
            if (vm.alasanPergantianKaryawan) {

                console.log('vm.selectedReasonEmployee', vm.selectedReasonEmployee);
                console.log('vm.reasonsEmployeeChanges', vm.reasonsEmployeeChanges);
                if (vm.selectedReasonEmployee) {
                    if (vm.reasonsEmployeeChanges.reason && vm.reasonsEmployeeChanges.effective_date) {
                        return true;
                    }
                } else {
                    return false;
                }

            }

            if (!vm.alasanPergantianKaryawan && vm.selectedReason.length > 0) {
                return true;
            }

            return false;
        }

        function checkEmployee(item) {
            var exist = vm.selectedEmployeeLists.indexOf(item);
            if (exist == -1) {
                item.allowJabatanBaru = true;
                item.allowGolonganBaru = true;
                item.actionsLists = angular.copy(vm.actionsLists);
                vm.selectedEmployeeLists.push(item);
            } else {
                if (item.selected == false) {
                    vm.selectedEmployeeLists.splice(item, 1);
                }
            }
        }

        function deleteEmpSelected() {
            for (var i = vm.selectedEmployeeLists.length - 1; i >= 0; i--) {
                for (var j = vm.employeeLists.length - 1; j >= 0; j--) {
                    if (vm.selectedEmployeeLists[i] && vm.employeeLists[j]) {
                        if (vm.selectedEmployeeLists[i].nik == vm.employeeLists[j].nik) {
                            vm.employeeLists.splice(j, 1);
                            vm.selectedEmployeeLists.splice(i, 1);
                        }
                    }
                }

            }
        }

        /************* START LOAD ACTION TYPE ************/
        function loadActionData() {
            var dataPromise = EmpJic.query({
                action: 'viewActions',
            });
            dataPromise.$promise.then(function (rdata) {
                if (typeof (rdata) !== 'undefined') {
                    vm.actionLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.actionLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log(err);
            });
        }
        /************* END LOAD ACTION TYPE ************/

        /************* START LOAD REASONS ************/
        function loadReasonsData() {
            var dataPromise = EmpJic.query({
                action: 'viewReasons',
            });
            dataPromise.$promise.then(function (rdata) {
                if (typeof (rdata) !== 'undefined') {
                    vm.reasonsLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.reasonsLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log(err);
            });
        }
        /************* END LOAD REASONS ************/

        /************* START LOAD WORK STATUS ************/
        function loadWorkStatusData() {
            var dataPromise = EmpJic.query({
                action: 'viewWorkStatus'
            });
            dataPromise.$promise.then(function (rdata) {
                if (typeof (rdata) !== 'undefined') {
                    vm.workStatusLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.workStatusLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log(err);
            });
        }
        /************* END LOAD WORK STATUS ************/

        /************* START LOAD SUBAREA ************/
        function loadSubAreaData(company_id) {
            var dataPromise = EmpJic.query({
                action: 'viewSubArea',
                company_id: (company_id) ? company_id : ''
            });
            dataPromise.$promise.then(function (rdata) {
                // console.log('rdata', rdata);
                if (typeof (rdata) !== 'undefined') {
                    vm.subAreaLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.subAreaLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {

            });
        }
        /************* END LOAD SUBAREA ************/

        /************* START BUSINESS UNIT ************/
        function loadBuData() {
            var dataPromise = EmpJic.query({
                action: 'viewBu'
            });
            dataPromise.$promise.then(function (rdata) {
                // console.log('rdata', rdata);
                if (typeof (rdata) !== 'undefined') {
                    vm.buLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.buLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {

            });
        }
        /************* END LOAD SUBAREA ************/

        function addNewReason(reason) {

            if (reason == '' || reason.length == 0) {
                return false;
            }

            vm.reasonsLists.push({
                id: '',
                name: reason,
                checked: true,
                isAdditional: true
            });
            vm.additionalReason = '';

            setSelectedReasons();

        }

        function removeAdditionalReason(idx, item) {
            vm.reasonsLists.splice(idx, 1);
            setSelectedReasons();
        }

        function setAction(ev, idx) {
            vm.selectedAction = [];
            if (vm.actionLists[idx].id == 1) {
                if (vm.actionLists[idx].checked) {
                    vm.allowJabatanBaru = true;
                    vm.allowGolonganBaru = false;
                    vm.actionLists[1].checked = false;
                } else {
                    vm.allowJabatanBaru = false;
                }
            }

            if (vm.actionLists[idx].id == 2) {
                if (vm.actionLists[idx].checked) {
                    vm.allowJabatanBaru = false;
                    vm.allowGolonganBaru = true;
                    vm.actionLists[0].checked = false;
                } else {
                    vm.allowGolonganBaru = false;
                }
            }

            if (vm.actionLists[idx].id == 3) {
                if (vm.actionLists[idx].checked) {

                    if (typeof (vm.actionLists[3]) !== 'undefined') {
                        vm.actionLists[3].checked = false;
                    }
                    vm.isMutation = 1;
                    vm.Form.objForm.gol_baru = vm.selectedEmployee.emp_grade;
                    vm.selectedEmployee.nik_atasan_baru=null;
                    vm.selectedEmployee.nama_atasan_baru=null;
                    vm.Form.objForm.bu=null;
                    vm.Form.objForm.division_id=null;
                    vm.Form.objForm.department_baru_id=null;
                    vm.Form.objForm.job_title.jobTitleName=null;

                    $element.find('input').on('keydown', function (ev) {
                        ev.stopPropagation();
                    });

                } else {
                    vm.Form.objForm.bu = vm.selectedEmployee.entity_id;
                    vm.Form.objForm.division_id = vm.selectedEmployee.division_id;
                    vm.Form.objForm.department_baru_id = vm.selectedEmployee.department_id;
                    vm.selectedEmployee.nik_atasan_baru = vm.selectedEmployee.nik_atasan;
                    vm.selectedEmployee.nama_atasan_baru = vm.selectedEmployee.nama_atasan;
                    vm.Form.objForm.nik_atasan_baru = vm.selectedEmployee.nik_atasan;
                    vm.Form.objForm.job_title.jobTitleName=null;

                    if (typeof (vm.actionLists[3]) !== 'undefined') {
                        if (!vm.actionLists[3].checked) {
                            vm.isMutation = 0;
                        }
                    } else {
                        vm.isMutation = 0;
                    }
                }
                loadSubAreaData(vm.Form.objForm.bu);
                loadDataDivision(vm.Form.objForm.bu);
                loadDataDepartment(vm.Form.objForm.division_id,true);
            }

            if (typeof (vm.actionLists[3]) !== 'undefined') {
                if (vm.actionLists[idx].id == 4) {
                    if (vm.actionLists[idx].checked) {

                        vm.actionLists[2].checked = false;
                        vm.isMutation = 1;
                        vm.Form.objForm.gol_baru = vm.selectedEmployee.emp_grade;

                        $element.find('input').on('keydown', function (ev) {
                            ev.stopPropagation();
                        });

                    } else {
                        if (!vm.actionLists[2].checked) {
                            vm.isMutation = 0;
                        }
                    }
                }
            }

            if (vm.allowJabatanBaru) {
                var newGrades = [];
                var lockGrades = true;
                var tmpGrade = angular.copy(vm.originGrades);
                tmpGrade.find(function (val) {
                    if (!lockGrades) {
                        newGrades.push(val);
                    }
                    if (val == vm.selectedEmployee.emp_grade) {
                        lockGrades = false;
                    }
                });
                vm.grades = newGrades;
            }

            if (vm.allowGolonganBaru) {
                var newGrades = [];
                var lockGrades = false;
                var tmpGrade = angular.copy(vm.originGrades);
                tmpGrade.find(function (val) {
                    if (val == vm.selectedEmployee.emp_grade) {
                        lockGrades = true;
                    }
                    if (!lockGrades) {
                        newGrades.push(val);
                    }
                });
                vm.grades = newGrades;
            }

            if (!vm.isMutation) {
                vm.Form.objForm.bu = vm.selectedEmployee.entity_id;
                loadDataDivision(vm.Form.objForm.bu);
            }

            $element.find('input').on('keydown', function (ev) {
                ev.stopPropagation();
            });

        }

        function searchSubAreaClicked(ev) {
            console.log('clicked', ev);
            // setTimeout(function() {
            //     $element.find('input').on('keydown', function (ev) {
            //         ev.stopPropagation();
            //     });
            // }, 1000);
        }

        function setSelectedReasons(item) {




            vm.selectedReason = [];
            for (var i = 0; i <= (vm.reasonsLists.length - 1); i++) {
                if (vm.reasonsLists[i].checked == true) {
                    vm.selectedReason.push(vm.reasonsLists[i]);
                }
            }

 
            var indexGanti = vm.reasonsLists.findIndex(function f(x) {
                return x.id == 2 && x.checked == true
            }); 

            if (indexGanti != -1) {
                vm.alasanPergantianKaryawan = true;
            } else {
                vm.alasanPergantianKaryawan = false;
            }

            console.log('isReasonsInformationCompleted', isReasonsInformationCompleted());

        }


        function saveData(ev, formController) {

            vm.isSubmit = true;
            var tempDate = angular.copy(vm.tgl_pengajuan);

            vm.selectedAction = [];
            for (var i = 0; i <= (vm.actionLists.length - 1); i++) {
                if (vm.actionLists[i].checked) {
                    vm.selectedAction.push(vm.actionLists[i]);
                }
            }

            vm.selectedEmployeeLists = angular.copy(vm.employeeLists);
            vm.Form.objForm.tgl_pengajuan = moment(tempDate).format('YYYY-MM-DD');
            vm.Form.objForm.action_type = vm.selectedActionType;
            vm.Form.objForm.reason = vm.selectedReason;
            vm.Form.objForm.reasonsEmployeeChanges = vm.reasonsEmployeeChanges;
            vm.Form.objForm.actions = vm.selectedAction;
            vm.Form.objForm.employees = vm.selectedEmployee;
            vm.Form.objForm.atasanBaru = vm.atasanBaru;
            vm.Form.objForm.subAreaBaru = vm.selectedSubArea;
            vm.Form.objForm.subarea_baru_id = (!vm.isMutation) ? vm.selectedEmployee.sub_area_id : vm.selectedSubArea.subarea_id;
            
            if (!vm.isMutation) 
            {
                vm.Form.objForm.bu = vm.selectedEmployee.entity_id;
            }

            var promise = Form.saveData('save', formController, EmpJic);
            promise.then(function (res) 
            {
                vm.messageTheme = 'green';
                vm.isSubmit = false;
                setTimeout(function () {
                    $state.go('app.emp_jic');
                }, 1000);
            });
            promise.catch(function (err) {
                vm.isSubmit = false;
                vm.messageTheme = 'red';
            });

        }

        function lookupStafEmployee(ev) {

            ev.preventDefault();

            var dialog = $mdDialog.show({
                controller: 'EmpJicLookupStafEmployeeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/jic/empjic/add/lookup-employee/lookup-employee.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {}
            });

            dialog.then(function (data) {
                vm.selectedEmployee = data;

                var newGrades = [];

                if (vm.allowJabatanBaru) {
                    var lockGrades = true;
                    vm.originGrades.find(function (val) {
                        if (!lockGrades) {
                            newGrades.push(val);
                        }
                        if (val == vm.selectedEmployee.emp_grade) {
                            lockGrades = false;
                        }
                    });
                } else {
                    var lockGrades = false;
                    vm.originGrades.find(function (val) {
                        if (val == vm.selectedEmployee.emp_grade) {
                            lockGrades = true;
                        }
                        if (!lockGrades) {
                            newGrades.push(val);
                        }
                    });
                }

                vm.grades = newGrades;

                if (vm.isMutation) {
                    vm.Form.objForm.gol_baru = vm.selectedEmployee.emp_grade;
                }
                vm.Form.objForm.bu = vm.selectedEmployee.entity_id;
                vm.Form.objForm.division_id = vm.selectedEmployee.division_id;
                vm.Form.objForm.department_baru_id = vm.selectedEmployee.department_id;
                vm.selectedEmployee.nik_atasan_baru = vm.selectedEmployee.nik_atasan;
                vm.selectedEmployee.nama_atasan_baru = vm.selectedEmployee.nama_atasan;
                vm.Form.objForm.nik_atasan_baru = vm.selectedEmployee.nik_atasan;
                loadSubAreaData(vm.Form.objForm.bu);
                loadDataDivision(vm.Form.objForm.bu);
                loadDataDepartment(vm.Form.objForm.division_id, true);
            })
        }

        /************* START LOAD ACTIONS ************/
        function loadListLayer() {
            var dataPromise = EmpJic.query({
                action: 'getDataListLayer',
                isMutation: vm.isMutation
            });
            dataPromise.$promise.then(function (rdata) {
                vm.listLayer = rdata;
            });
            dataPromise.$promise.catch(function (err) {
                vm.listLayer = '';
            });
        }

        function loadListAtasanBaru(jobTitle) {
            var dataPromise = EmpJic.query({
                action: 'getDataListDirectReport',
                layerId: jobTitle.direct_report
            });
            dataPromise.$promise.then(function (rdata) {
                vm.listAtasanBaru = rdata;
                vm.atasanBaru = rdata[0];
            });
            dataPromise.$promise.catch(function (err) {
                vm.listAtasanBaru = '';
            });
        }

        function clearSearchTerm(type) {
            switch (type) {
                case 'jobTitle':
                    vm.searchTermJobTitle = '';
                    break;
                case 'businessTitle':
                    vm.searchTermBusinessTitle = '';
                    break;
                case 'atasanBaru':
                    vm.searchTermAtasanBaru = '';
                    break;
            }
        }

        function querySearch(params) {
            return $http
                .get(config.api + 'api/jic/empjic?action=getLayerData&search=' + params +
                    '&company=' + vm.Form.objForm.bu +
                    '&divisi=' + vm.Form.objForm.division_id +
                    '&department=' + vm.Form.objForm.department_baru_id
                )
                .then(function (item) {
                    return item.data;
                });
        }

        function queryReasonPositionSearch(params) {
            return $http
                .get(config.api + 'api/jic/empjic?action=getDataListLayer&search=' + params)
                .then(function (item) {
                    return item.data;
                });
        }

        function queryReasonEmployeeSearch(params) {
            return $http
                .get(config.api + 'api/jic/empjic?action=searchEmployee&search=' + params)
                .then(function (item) {
                    return item.data;
                });
        }

        function selectedItemChange(item) {
            if (item) {
                vm.Form.objForm.job_title = item;
                // vm.Form.objForm.department_baru_id = item.department_id;
                vm.Form.objForm.department_name = item.department_name;
                // vm.Form.objForm.division_id = item.division_id;
                vm.Form.objForm.division_name = item.division_name;
                loadListAtasanBaru(item);
            }
        }

        function selectedReasonPositionChanged(item) {
            if (item) {
                vm.reasonsEmployeeChanges.position = item;
            }
        }

        function selectedIReasonEmployeeChanged(item) {
            if (item) {
                vm.reasonsEmployeeChanges.employee = item;
                vm.reasonsEmployeeChanges.position = {
                    id: item.layer_id,
                    description: item.org_layer_description
                }
            }
        }

        function reloadToken() {
            Auth.setToken();
        }

        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;

        function loadDataDepartment(iddivisi, isChange) {
            vm.saveProcess = true;
            if (isChange) {
                vm.listJobTitle = [];
                vm.Form.objForm.jobTitle = 'set';
            }
            var response = EmpJic.query({ action: 'viewDivisiDept', idbu: vm.Form.objForm.bu, iddivisi: iddivisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            vm.saveProcess = false;
        }

        function errorDepartment() {
            vm.listDepartment = [];
            vm.saveProcess = false;
        }

        function loadDataDivision(idbu) {
            vm.saveProcess = true;
            var response = EmpJic.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            vm.saveProcess = false;
            // vm.listDivision.push(data); 
            // loadData(1); 
        }

        function errorDivisiBU() {
            vm.listDivision = [];
            vm.saveProcess = false;
        }

        vm.selectedCange = selectedCange;

        function selectedCange(v) {
            switch (v) {
                case 'dept':
                    vm.selectedJobTitle = null;
                    vm.Form.objForm.job_title = null;
                    // vm.Form.objForm.directReport = null;
                    // vm.Form.objForm.jobTitle = null;
                    break;
                case 'div':
                    vm.Form.objForm.department_baru_id = null;
                    vm.selectedJobTitle = null;
                    vm.Form.objForm.job_title = null;
                    // vm.Form.objForm.directReport = null;
                    // vm.Form.objForm.jobTitle = null;
                    break;
                case 'comp':
                    vm.Form.objForm.division_id = null;
                    vm.Form.objForm.department_baru_id = null;
                    vm.selectedJobTitle = null;
                    vm.Form.objForm.job_title = null;
                    // vm.Form.objForm.directReport = null;
                    // vm.Form.objForm.jobTitle = null;
                    break;
            }
        }

        vm.lookupEmployee = lookupEmployee;

        function lookupEmployee(ev) {

            ev.preventDefault();

            var dialog = $mdDialog.show({
                controller: 'EmpJicLookupEmployeeAtasanController',
                controllerAs: 'vm',
                templateUrl: 'app/main/jic/empjic/add/lookup-atasan/lookup-atasan.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    id: { company: vm.Form.objForm.bu, divisi: vm.Form.objForm.division_id, department: vm.Form.objForm.department_baru_id }
                }
            }).then(function (response) {
                if (response) {
                    vm.selectedEmployee.nik_atasan_baru = response.nik;
                    vm.Form.objForm.nik_atasan_baru = response.nik;
                    vm.selectedEmployee.nama_atasan_baru = response.nama;
                }
            }).catch(function (responseIfRejected) {

            }).finally(function () {
            });
        }


        vm.lookupJobTitle = lookupJobTitle;

        function lookupJobTitle(ev) {
            vm.isLayerOverlap = false;
            $mdDialog.show({
                controller: 'LookUpLayerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/jic/empjic/add/lookup-layer/lookup-layer.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {

                },
                locals: {
                    id: { company: vm.Form.objForm.bu, divisi: vm.Form.objForm.division_id, department: vm.Form.objForm.department_baru_id, directReport: vm.selectedEmployee.nik_atasan_baru, disable: false }
                }
            }).then(function (response) {
                console.log(response);
                if (response) {
                    vm.Form.objForm.job_title = response;
                    vm.Form.objForm.department_name = response.department_name;
                    vm.Form.objForm.division_name = response.division_name;

                    vm.Form.objForm.division_id = response.filter.division_id;
                    vm.Form.objForm.department_baru_id = response.filter.department_id;
                    loadDataDivision(vm.Form.objForm.bu);
                    loadDataDepartment(vm.Form.objForm.division_id, false);
                }
            }).catch(function (responseIfRejected) {

            }).finally(function () {
            });
        }

        vm.checkValidasiForm = checkValidasiForm;

        function checkValidasiForm() {
            if (!vm.selectedEmployee.nik) {
                return false;
            }

            if (!vm.Form.objForm.bu && !vm.isMutation) {
                return false;
            }

            if (!vm.Form.objForm.division_id) {
                return false;
            }

            if (!vm.Form.objForm.department_baru_id) {
                return false;
            }

            if (!vm.selectedEmployee.nik_atasan_baru) {
                return false;
            }

            if (vm.Form.objForm.job_title) {
                if (!vm.Form.objForm.job_title.jobTitleName) {
                    return false;
                }
            }

            // if ((vm.isMutation && (vm.allowJabatanBaru == true || vm.allowGolonganBaru == true)) || (vm.allowJabatanBaru == true || vm.allowGolonganBaru == true) && !vm.Form.objForm.gol_baru) {
            //     return false;
            // }

            if (!vm.selectedSubArea && vm.isMutation) {
                return false;
            }

            return true;

        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.hrbp.kpi_nabati.set-team-all', [])
        .config(config);

     config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
      $stateProvider
             .state('app.hrbp_kpi_nabati_set_team_all', {
                url    : '/hrbp/kpi-nabati/set-team-all/set-team-all/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/hrbp/kpi-nabati/set-team-all/set-team-all.html',
                        controller : 'HrbpSetteamallController as vm'
                    }
                }
            });       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hrbp.kpi_nabati.set-team-all')
        .controller('HrbpSetteamallController', HrbpSetteamallController)


    HrbpSetteamallController.$inject=['DataService','$state','$mdDialog','AppAPI','Auth','Form','$localStorage','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function HrbpSetteamallController(DataService,$state,$mdDialog,AppAPI,Auth,Form,$localStorage,DTColumnDefBuilder,$timeout,$stateParams)
    {
        
    var vm = this;
    vm.username=$localStorage.user;
    // initial form
    Form.initialForm();
    vm.nik=$stateParams.id;
    vm.approveKS=approveKS;
    vm.closeKpi=closeKpi;
    vm.select=select;
    vm.toggleSelectedAll=toggleSelectedAll;
    vm.viewScales=viewScales;
    vm.isChecked=isChecked;
     vm.toggleCheck = toggleCheck;
    vm.listKSSelected=[];
    var teamMember=AppAPI.teamMember();
    vm.DataTable= new DataService();
    vm.showKpi=showKpi;
    vm.loadData=loadData;
    var today = new Date();
    var year = today.getFullYear();
    vm.yearSelected=year;
    vm.removeApproval=removeApproval;
    vm.years=[{year:2017,selected:false},{year:2016,selected:false},{year:2015,selected:false}];
    checkSelectedYear();
    loadData(1);
    loadDataEff();
 

        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers',
            paging:false,
            searching:false
        };

  function checkSelectedYear()
        {

           // var lengthYear=vm.years
            angular.forEach(vm.years,function(obj){
               if(obj.year===vm.yearSelected)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }  

  
   function showKpi(year)
        {   
            vm.listKSSelected=[];
           vm.yearSelected=year;
           checkSelectedYear();
           loadData(1);
        }           

function isChecked(ks)
        {
            return vm.listKSSelected.indexOf(ks) > -1;
        }

function toggleCheck(ks, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listKSSelected.indexOf(ks);

            if ( idx > -1 )
            {
                vm.listKSSelected.splice(idx, 1);
            }
            else
            {
                vm.listKSSelected.push(ks);
            }
        }

function loadData(pageno)
      {
        var KpiScales=AppAPI.KpiScales();
          vm.DataTable.loadData(KpiScales,pageno,{action:'viewdatayearall',eff:vm.yearSelected,id:vm.nik});
         // loadDataEff();
         vm.listKSSelected=[];
      }


         function viewScales(ev,kpi) {
           $mdDialog.show({
              controller: 'HrbpSetteamallscaleController',
              controllerAs:'vm',
              templateUrl: 'app/main/hrbp/kpi-nabati/set-team-all/set-team-all-scale.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              locals:{
                kpi:kpi
              }
            });
    }
    

     function loadDataEff() {
         angular.element.blockUI();
        var buPromise=teamMember.query({action:'viewdetail',id:$stateParams.id});
        buPromise.$promise.then(fetchEff);
        buPromise.$promise.catch(errorFetchEff); 
         
      }

      function fetchEff(data) {
        vm.listkpi=data;  

        angular.forEach(vm.listkpi, function(value, key) {

      });  


         angular.element.unblockUI();
        
      }

      function errorFetchEff() {
        vm.listkpi=[];
         angular.element.unblockUI();
      }

      function select(ks){
        return vm.listKSSelected;
      }

    function closeKpi()
    {
        $mdDialog.hide();
    }

    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listKSSelected=angular.copy(vm.listkpi);

    }

    function unCheckAll() {
       vm.listKSSelected=[];
    }

     function approveKS(ev) {

/*        if (!vm.listKSSelected.length){

             vm.tampilPesan=true;
             vm.pesan='Please Checkbox!';
             vm.messageTheme='blue';
             $timeout(function() {
                 vm.tampilPesan=false;
             }, 3000);
      
        }else{*/
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to Approve this list?')
          .textContent('All data your selected will be approved.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');
    $mdDialog.show({
            multiple: true
       });      
    $mdDialog.show(confirm).then(function() {
          angular.element.blockUI();

       var response=teamMember.delete({action:'approve',data:angular.toJson(vm.listKSSelected)});
       response.$promise.then(loadData);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
   // }
   
    }


    function removeApproval(id,kpi,ev) {
      var confirm = $mdDialog.confirm()
          .title('Would you like to delete  KPI Approval ?')
          .textContent('This KPI ('+kpi+') approval will be deleted and cannot recovered. Are You Sure ?')
          .ariaLabel('delete kpi')
          .targetEvent(ev)
          .ok('Yes, Delete')
          .cancel('Cancel');

    $mdDialog.show(confirm).then(function() {

        var promise =Auth.setToken();
        promise.then(function(){
           var response=teamMember.delete({action:'unapproved',id:id});
             response.$promise.then(loadData);
        });
      
    });
    }
}


})();

(function ()
{
    'use strict';

    angular
        .module('app.hrbp.kpi_nabati.set-team-all')
        .controller('HrbpSetteamallscaleController', HrbpSetteamallscaleController)


    HrbpSetteamallscaleController.$inject=['kpi','$state','$mdDialog','AppAPI','Auth','Form','$localStorage','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function HrbpSetteamallscaleController(kpi,$state,$mdDialog,AppAPI,Auth,Form,$localStorage,DTColumnDefBuilder,$timeout,$stateParams)
    {
        
    var vm = this;
    vm.username=$localStorage.user;
    // initial form
    Form.initialForm();
    vm.kpi=kpi;
    vm.closeKpi=closeKpi;
    vm.nik=$stateParams.id;
    var teamMember=AppAPI.teamMember();
    loadDataEffJudul();
    loadDataEff();

        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers',
            paging:false,
            searching:false
        };

     
      function loadDataEffJudul() {
         angular.element.blockUI();
        var buPromise2=teamMember.query({action:'viewdetailks',id:vm.kpi,nik:vm.nik});
        buPromise2.$promise.then(fetchEffJudul);
        buPromise2.$promise.catch(errorFetchEffJudul); 
         
      }

      function fetchEffJudul(data) {
      	 vm.kpidesc=data[0].kpi;
      	 vm.uom=data[0].uom;
      	 vm.bobot=data[0].bobot;
      	 vm.target=data[0].target;
         angular.element.unblockUI();
        
      }

      function errorFetchEffJudul() {
         angular.element.unblockUI();
      }   

     function loadDataEff() {
         angular.element.blockUI();
        var buPromise=teamMember.query({action:'viewdetailks',id:vm.kpi,nik:vm.nik});
        buPromise.$promise.then(fetchEff);
        buPromise.$promise.catch(errorFetchEff); 
         
      }

      function fetchEff(data) {
         vm.listkpiscale=data;    
         angular.element.unblockUI();
        
      }

      function errorFetchEff() {
        vm.listkpiscale=[];
         angular.element.unblockUI();
      }



      function select(ks){
        return vm.listKSSelected;
      }

    function closeKpi()
    {
        $mdDialog.hide();
    }

  
   
}


})();

(function () {
    'use strict';

    angular.module('app.pms.job_code_profile.input-job-code-profile')
           .controller('InputJobCodeProfileController', InputJobCodeProfileController);

    InputJobCodeProfileController.$inject=['$state','$stateParams','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function InputJobCodeProfileController($state,$stateParams,$localStorage,$timeout,Form,AppAPI,Auth) {
        
        var vm = this;

        // initial form
        Form.initialForm();

        var CompetencyJob=  AppAPI.CompetencyJob();

        // set constructor form
        Form.setObject(CompetencyJob);

        // set form to controller
        vm.Form = Form;

        vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
            {link:'app.pms_competency_job',name:'Competency Job',active:'0'},
            {link:'#',name:'Input Competency Job',active:'0'}
        ];

        vm.saveData=saveData;
        vm.back=back;

        vm.clearMeesage=clearMeesage;
        vm.reloadToken=reloadToken; 
        // console.log( vm.Form.objForm.menu_id);
        // 
        var response = CompetencyJob.query({action:'get_jobcode'});
            response.$promise.then(function(data){
            vm.listJobCode=data;
            // console.log(vm.listJobCode);
        });

        response.$promise.catch(function(data){
            $log.info(data);
        });        

        function saveData(formController) {
            angular.element.blockUI();
            var response=Form.saveData('save', formController, CompetencyJob);

            response.then(function(){
                vm.messageTheme='blue';
                angular.element.unblockUI();
                formController.$setPristine();
                $timeout(function() {
                    vm.Form.tampilPesan=false;
                }, 3000);

            });

            response.catch(function(){
                vm.messageTheme='pink';
                angular.element.unblockUI();
            });

        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.pms_competency_job');
        }
    }

})();  

(function () {
  'use strict';

  angular
      .module('app.employee.town', [
        'app.employee.town.input-town',
        'app.employee.town.update-town'
      ])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_town', {
              url: '/employee/town',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/town/town.html',
                      controller: 'TownController as vm'
                  }
              }
          });
  }
})();

(function() {
    'use strict';

    angular
        .module('app.employee.town')
        .controller('UploadfileTownController', UploadfileTownController);

    UploadfileTownController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadfileTownController($mdDialog,$localStorage,FileUploader,config) {
        var vm = this;
        
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;
        vm.pesan="";

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
            url:config.api+'api/town/uploadfile', 
            removeAfterUpload:true,
            alias:'filetown',
            formData:[
                {
                action:'uploadfile'
                }
            ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
            },
            headers:{
                tokenAuth:$localStorage.tokenAuth
            }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            vm.pesan='Success Upload Data';
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function(item)
        {
            var obj= JSON.parse(item._xhr.response);
            vm.pesan=obj.pesan;
            vm.UploadPhotoStateSucces=false;
            vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }
    }
})();
(function () {
  'use strict';

  angular
      .module('app.employee.town.update-town', [])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_town_update-town', {
              url: '/employee/town/update-town',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/town/update-town/update-town.html',
                      controller: 'UpdateTownController as vm'
                  }
              }
          });
  }
})();

(function() {
    'use strict';
    angular
        .module('app.employee.town.update-town')
        .controller('UpdateTownController', UpdateTownController);

    UpdateTownController.$inject = [
        '$state',
        '$mdDialog',
        '$localStorage',
        '$window',
        '$timeout',
        'AppAPI',
        'Auth',
        'Form',
        'listCountry',
        'loadData',
        'dataUpdate'
    ];

    /** @ngInject */
    function UpdateTownController(
        $state,
        $mdDialog,
        $localStorage,
        $window,
        $timeout,
        AppAPI,
        Auth,
        Form,
        listCountry,
        loadData,
        dataUpdate
    ) {
        var vm = this;
        var Town = AppAPI.Town();
        vm.listCountry = listCountry;
        vm.dialogClose = dialogClose;
        vm.Form = Form;
        vm.updateData = updateData;

        activate();
        function activate() {
            Form.initialForm();
            Form.setObject(Town);
            vm.country = dataUpdate.country_id;
            vm.town = dataUpdate.town;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.pesan)
                        .ariaLabel(data.title)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    loadData(1);
                });
        }

        function updateData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.id      = dataUpdate.id;
            vm.Form.objForm.country = formController.country.$viewValue;
            vm.Form.objForm.town    = formController.town.$viewValue;
            
            var response = Form.saveData('updateData', formController, Town);
            response.then(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                dialogClose()
                showDialogInfo(ev, data);
            });

            response.catch(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                dialogClose()
                showDialogInfo(ev, data);
            });
        }
    }
})();

(function () {
  'use strict';

  angular
      .module('app.employee.town.input-town', [])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_town_input-town', {
              url: '/employee/town/input-town',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/town/input-town/input-town.html',
                      controller: 'InputTownController as vm'
                  }
              }
          });
  }
})();

(function() {
    'use strict';
    angular
        .module('app.employee.town.input-town')
        .controller('InputTownController', InputTownController);

    InputTownController.$inject = [
        '$state',
        '$mdDialog',
        '$localStorage',
        '$window',
        '$timeout',
        'AppAPI',
        'Auth',
        'Form',
        'listCountry',
        'loadData'
    ];
    /** @ngInject */
    function InputTownController(
        $state,
        $mdDialog,
        $localStorage,
        $window,
        $timeout,
        AppAPI,
        Auth,
        Form,
        listCountry,
        loadData
    ) {
        var vm = this;
        var Town = AppAPI.Town();
        vm.selected = [];
        vm.listCountry = listCountry;
        vm.dialogClose = dialogClose;
        vm.saveData = saveData;
        vm.Form = Form;
        activate();

        function activate() {
            Form.initialForm();
            Form.setObject(Town);
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.town = formController.town.$viewValue;
            vm.Form.objForm.country = formController.country.$viewValue;
            var response = Form.saveData('saveData', formController, Town);
            response.then(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                dialogClose();
                showDialogInfo(ev, data);
            });

            response.catch(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                dialogClose();
                showDialogInfo(ev, data);
            });
        }
        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.pesan)
                        .ariaLabel(data.title)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    loadData(1);
                });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.team-assignment', [])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
      // Translation
        // $translatePartialLoaderProvider.addPart('app/main/employee/employe');

        // State
        $stateProvider
            .state('app.employee_team_assignment', {
                url    : '/employee/team-assignment',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/team-assignment/team-assignment.html',
                        controller : 'TeamassignmentController as vm'
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employee.team-assignment')
        .controller('UploadfileAssignmentController', UploadfileAssignmentController);

    UploadfileAssignmentController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'DataService', 'AppAPI', '$filter', 'Auth', '$location', '$window'];

    /* @ngInject */
    function UploadfileAssignmentController($mdDialog, $localStorage, FileUploader, config, DataService, AppAPI, $filter, Auth, $location, $window) {
        var vm = this;
        var translate = $filter('translate');
        var Teamassignment = AppAPI.Teamassignment();

        vm.uploadSuccess = vm.uploadError = vm.isMoreInfo = false;
        vm.uploadNotif = '';
        vm.DownloadTemplate = DownloadTemplate;
        vm.viewMoreInfo = viewMoreInfo
        vm.dialogClose = dialogClose
        vm.detailInfo = [];

        vm.FileUploader = new FileUploader({
            url: config.api + 'api/teamassignment/uploadfile',
            removeAfterUpload: true,
            alias: 'fileassignment',
            formData: [{
                action: 'uploadfile'
            }],
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUploader.onSuccessItem = function (data, status, headers, config) {
            if (status.status == 0) {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }

            var expmess = status.pesan.split("_");
            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(status.pesan);
            }
            vm.uploadNotif = message

            if ('moreInfo' in status && status.moreInfo.length > 0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }

            angular.element('#uploadCutOff').val('');

        };

        vm.FileUploader.onErrorItem = function () {
            vm.uploadSuccess = false;
            vm.uploadError = true;

        };

        function dialogClose() {
            $mdDialog.hide();
        }

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/teamassignment/downloadtemplate', '_blank');
            }, function () {
                $window.alert('gagal load token');
            });
        }

        function viewMoreInfo(detail) {
            $mdDialog.show({
                controller: 'logFailGwController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: detail
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employee.team-assignment')
        .controller('DownloadfileAssignmentController', DownloadfileAssignmentController);

    DownloadfileAssignmentController.$inject = ['$mdDialog', '$localStorage', '$location', '$window', 'config', 'DataService', 'AppAPI', '$filter', 'tglmulaiData', 'tglakhirData', 'Auth'];

    /* @ngInject */
    function DownloadfileAssignmentController($mdDialog, $localStorage, $location, $window, config, DataService, AppAPI, $filter, tglmulaiData, tglakhirData, Auth) {
        var vm = this;
        var translate = $filter('translate');
        var Teamassignment = AppAPI.Teamassignment();

        vm.downloadAll = downloadAll;
        vm.dialogClose = dialogClose;

        if(tglmulaiData != null && tglakhirData != null) {
            vm.tglmulai = new Date(tglmulaiData);
            vm.tglakhir = new Date(tglakhirData);
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function downloadAll() {
            var tglStart = null;
            var tglEnd = null;

            if(vm.tglmulai != null && vm.tglakhir != null) {
                var startYear = vm.tglmulai.getFullYear();
                var startMonthPre = vm.tglmulai.getMonth() + 1;
                var startMonth = startMonthPre < 10 ? '0' + startMonthPre : startMonthPre;
                var startDate = vm.tglmulai.getDate();

                var endYear = vm.tglakhir.getFullYear();
                var endMonthPre = vm.tglakhir.getMonth() + 1;
                var endMonth = endMonthPre < 10 ? '0' + endMonthPre : endMonthPre;
                var endDate = vm.tglakhir.getDate();

                tglStart=startYear + '-' + startMonth + '-' + startDate;
                tglEnd=endYear + '-' + endMonth + '-' + endDate;
            }

            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/teamassignment/exportexcel/' + tglStart + '/' + tglEnd, '_blank');
            }, function () {
                $window.alert('gagal load token');
            });
        }
    }
})();
(function () {
  'use strict';

  angular
      .module('app.employee.subarea.update-subarea', [])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_subarea_update-subarea', {
              url: '/employee/subarea/update-subarea',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/subarea/update-subarea/update-subarea.html',
                      controller: 'UpdateSubareaController as vm'
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.employee.subarea.update-subarea')
    .controller('UpdateSubareaController', UpdateSubareaController);

  UpdateSubareaController.$inject = [
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'listBU',
    'townList',
    'loadData',
    'dataUpdate'
  ];
  /** @ngInject */
  function UpdateSubareaController(
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    listBU,
    townList,
    loadData,
    dataUpdate
  ) {
    var vm = this;
    var ApiSubarea = AppAPI.Subarea();
    vm.company = $localStorage.empsite;
    vm.listBU = listBU;
    vm.townList = townList;
    vm.dialogClose = dialogClose;
    vm.Form = Form;
    vm.town = dataUpdate.town_id;
    vm.updateSubArea = updateSubArea;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(ApiSubarea);
      vm.company = dataUpdate.company_id;
      vm.subarea = dataUpdate.description;
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          loadData(1);
        });
    }

    function updateSubArea(ev, formController) {
      angular.element.blockUI();
      vm.Form.objForm.id            = dataUpdate.id;
      vm.Form.objForm.description   = formController.subarea.$viewValue;
      vm.Form.objForm.town          = formController.town.$viewValue;
      var response = Form.saveData('updateDataSubArea', formController, ApiSubarea);
      response.then(function(data) {
          angular.element.unblockUI();
          formController.$setPristine();
          dialogClose()
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          formController.$setPristine();
          dialogClose()
          showDialogInfo(ev, data);
      });
    }


  }
})();

(function () {
  'use strict';

  angular
      .module('app.employee.subarea.input-subarea', [])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_subarea_input-subarea', {
              url: '/employee/subarea/input-subarea',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/subarea/input-subarea/input-subarea.html',
                      controller: 'InputSubareaController as vm'
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.employee.subarea.input-subarea')
    .controller('InputSubareaController', InputSubareaController);

  InputSubareaController.$inject = [
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'listBU',
    'loadData'
  ];
  /** @ngInject */
  function InputSubareaController(
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    listBU,
    loadData
  ) {
    var vm = this;
    var ApiSubarea = AppAPI.Subarea();
    vm.company = $localStorage.empsite;
    vm.countryCountryCode = $localStorage.country;
    vm.selected = [];
    vm.listBU = listBU;
    vm.dialogClose = dialogClose;
    vm.saveDataSubarea = saveDataSubarea;
    vm.Form = Form;
    vm.townList = [];

    vm.searchTermCountry = '';
    vm.clearSearchTermCountry = clearSearchTermCountry;

    vm.searchTermTown = '';
    vm.clearSearchTermTown = clearSearchTermTown;

    var pendingSearch, cancelSearch = angular.noop;
    var lastSearch;
    self.delayedQuerySearch = delayedQuerySearch;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(ApiSubarea);

      loadDataCountry();
    }

    function saveDataSubarea(ev, formController) {
      angular.element.blockUI();
      vm.Form.objForm.company = formController.company.$viewValue;
      vm.Form.objForm.description = formController.subarea.$viewValue;
      vm.Form.objForm.town = formController.town.$viewValue;
      var response = Form.saveData('saveDataSubArea', formController, ApiSubarea);
      response.then(function(data) {
          angular.element.unblockUI();
          formController.$setPristine();
          dialogClose();
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          formController.$setPristine();
          dialogClose();
          showDialogInfo(ev, data);
      });
    }
    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          loadData(1);
        });
    }

    function loadDataCountry() {
        angular.element.blockUI();
        var response=ApiSubarea.query({action:'getCountry'});
        response.$promise.then(fetchCountry);
        response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
        angular.element.unblockUI();
        vm.listCountry=data;

        for(var i = 0; i < data.length; i++) {
          if(data[i].countrycode == vm.countryCountryCode) {
            vm.country = data[i];
            loadTownList(vm.country.id);
          }
        }
    }

    function errorFetchCountry() {
        angular.element.unblockUI();
        vm.listCountry=[];
    }

    function clearSearchTermCountry() {
      vm.searchTermCountry = '';
    }

    function loadTownList(country_id) {
      var response = ApiSubarea.query({ action: 'getTownList', country_id: country_id });
      response.$promise.then(fetchTown);
      response.$promise.catch(errorFetchTown);
    }

    function fetchTown(data) {
        vm.townList = data;
    }

    function errorFetchTown() {
        vm.townList = [];
    }

    function clearSearchTermTown() {
      vm.searchTermTown = '';
    }

    function delayedQuerySearch(criteria) {
      if (!pendingSearch || !debounceSearch())  {
        cancelSearch();

        return $http
            .get(config.api + 'api/subarea?action=searchEmployee&id=' + criteria + '&company=' + vm.company)
            .then(function (item) {
                // Map the response object to the data object.
                if (item.data.length === '') {
                    Form.objForm.empno = '';
                }
                return item.data;
            });
      }

      return pendingSearch;
    }

    function refreshDebounce() {
      lastSearch = 0;
      pendingSearch = null;
      cancelSearch = angular.noop;
    }

    /**
     * Debounce if querying faster than 300ms
     */
    function debounceSearch() {
      var now = new Date().getMilliseconds();
      lastSearch = lastSearch || now;

      return ((now - lastSearch) < 300);
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.profiles.input-profiles', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.employee_profiles_input', {
                url    : '/employee/profiles/input-profiles',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/profiles/input-profiles/input-profiles.html',
                        controller : 'InputprofilesController as vm'
                    }
                }
            })

             .state('app.employee_profiles_edit', {
                url    : '/employee/profiles/edit-profiles/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/profiles/input-profiles/input-profiles.html',
                        controller : 'EditprofilesController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/employee/profiles');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.employee.profiles.input-profiles')
        .controller('InputprofilesController', InputprofilesController);


    InputprofilesController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputprofilesController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Profiles=  AppAPI.Profiles();

         // set constructor form
         Form.setObject(Profiles);

         // set form to controller
         vm.Form = Form;

        vm.title = ['Mr','Mrs','Miss','Ms'];
        vm.jenkel = ['L','P'];
        vm.maritalStatuses = ['Lajang','Menikah','Duda','Janda'];
       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Profiles);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.profiles.input-profiles')
        .controller('EditprofilesController', EditprofilesController);


    EditprofilesController.$inject=['$localStorage','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditprofilesController($localStorage,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Profiles=  AppAPI.Profiles();

         // set constructor form
         Form.setObject(Profiles);

         // set form to controller
         vm.Form = Form;

        vm.title = ['Mr','Mrs','Miss','Ms'];
        vm.jenkel = ['L','P'];
        vm.maritalStatuses = ['Lajang','Menikah','Duda','Janda'];
      
          var response=vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
          response.then(changeDate);
       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;


        function changeDate(data) {

        vm.Form.objForm.dateJoin=new Date(data.dateJoin);
        vm.Form.objForm.dateOfBirth=new Date(data.dateOfBirth);

   
        }


        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('updatedata',formController,Profiles,$stateParams.id,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             vm.Form.objForm.dateJoin=new Date(vm.Form.objForm.dateJoin);
              vm.Form.objForm.dateOfBirth=new Date(vm.Form.objForm.dateOfBirth);
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () {
    'use strict';

    angular
        .module('app.employee.hr_completion', ['app.employee.hr_completion_form'])
        .config(config);

    config.$inject = ['$stateProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.hr_completion', {
                url: '/employee/hr_completion',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employee/hr-completion/hr-completion.html',
                        controller: 'HrCompletionController as vm'
                    }
                }
            });
    }
})();
(function () {
  'use strict';
  angular
    .module('app.employee.hr_completion')
    .controller('UploadHrCompletionController', UploadHrCompletionController);

  UploadHrCompletionController.$inject = [
    '$state',
    '$mdDialog',
    'config',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'infoDialog',
    'FileUploader',
    '$location'
  ];
  /** @ngInject */
  function UploadHrCompletionController(
    $state,
    $mdDialog,
    config,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    infoDialog,
    FileUploader,
    $location

  ) {
    var vm = this;
    vm.dialogClose = dialogClose;
    vm.infoDialog = infoDialog;
    vm.uploadHrCompletionSuccess = false;
    vm.uploadHrCompletionError = false;

    var protocol = $location.protocol();
    var host = $location.host();
    vm.downloadTemplateURL = protocol + '://' + host + config.port + config.api + 'api/uploadhrcompletion/download_template_upload_hr_completion.xlsx';

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.FileUploaderHrCompletion = new FileUploader({
      url: config.api + 'api/hrcompletion/uploadDataHrCompletion',
      removeAfterUpload: true,
      alias: 'fileHrCompletion',
      formData: [{
        action: 'uploadDataHrCompletion'
      }],
      onAfterAddingAll: function () {
        vm.uploadHrCompletionSuccess = false;
        vm.uploadHrCompletionError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUploaderHrCompletion.onSuccessItem = function (item) {
      vm.uploadHrCompletionSuccess = true;
      vm.uploadHrCompletionError = false;
      angular.element('#uploadEmpLabor').val('');
      setTimeout(function (item) {
        dialogClose();
      }, 1000);
    };

    vm.FileUploaderHrCompletion.onErrorItem = function () {
      vm.uploadHrCompletionSuccess = false;
      vm.uploadHrCompletionError = true;
      setTimeout(function (item) {
        dialogClose();
      }, 2000);
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.hr_completion_form', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.employee_hr_completion_form', {
                url: '/employee/hr-completion/form',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employee/hr-completion/coompletion-form/completion-form.html',
                        controller: 'HrCompletionFormController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.employee.hr_completion_form')
    .controller('HrCompletionFormController', HrCompletionFormController);

  HrCompletionFormController.$inject = [
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    '_data',
    'loadData'
  ];
  /** @ngInject */
  function HrCompletionFormController(
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    _data,
    loadData
  ) {
    var vm = this;
    var ApiHrCompletion = AppAPI.HrCompletion();
    vm.company = $localStorage.empsite;
    vm.selected = [];
    vm.dialogClose = dialogClose;
    vm.saveDataSubarea = saveDataSubarea;
    vm.Form = Form;
    vm.data = _data;
    vm.laborCategoryLists = [
      { value: 'direct', label: 'Direct' },
      { value: 'indirect', label: 'Indirect' },
      { value: 'indirectdc', label: 'Indirect DC' }
    ]
    vm.changedAbbreviation = changedAbbreviation;
    vm.loadGedung = loadGedung;
    vm.loadSector = loadSector;
    vm.loadLine = loadLine;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(ApiHrCompletion);
      loadData();
      loadCostCenterCB();
      loadCostCenterNonCB();
      loadSubArea();
      loadOtParam();
      loadTaxParam();
      loadTaxLocation();
      loadJamsostek();
      loadAbbreviation();
      loadGedung('');
    }

    function loadData() {

      vm.nikAtasan = vm.data.nikAtasan;
      vm.gedung = vm.data.gedung_id;
      loadSector(vm.gedung);
      vm.sector = vm.data.sector;
      vm.costCenterCB = vm.data.costCenterCB;
      vm.costCenterNonCB = vm.data.costCenterNonCB;
      // vm.contract2 = vm.data.contract2;
      // vm.finishContract2 = vm.data.finishContract2;
      // vm.contract3 = vm.data.contract3;
      // vm.finishContract3 = vm.data.finishContract3;
      // vm.contract4 = vm.data.contract4;
      // vm.finishContract4 = vm.data.finishContract4;
      vm.noSkTetap = vm.data.noSkTetap;
      vm.skPerubahan1 = vm.data.skPerubahan1;
      // vm.tglPerubahan1 = vm.data.tglPerubahan1;
      vm.skPerubahan2 = vm.data.skPerubahan2;
      // vm.tglPerubahan2 = vm.data.tglPerubahan2;
      vm.skPerubahan4 = vm.data.skPerubahan4;
      // vm.tglPerubahan4 = vm.data.tglPerubahan4;
      vm.skPerubahan3 = vm.data.skPerubahan3;
      // vm.tglPerubahan3 = vm.data.tglPerubahan3;
      // vm.statusDate = vm.data.statusDate;
      vm.eyeGlass = vm.data.eyeGlass;
      vm.eyeGlass = vm.data.eyeGlass;
      vm.bankCode = vm.data.bankCode;
      vm.noRekening = vm.data.noRekening;
      vm.workLocation = vm.data.workLocation;
      vm.personalSubArea = vm.data.personalSubArea;
      vm.Ot = vm.data.Ot;
      vm.tax_code = vm.data.tax_code;
      vm.tax_location = vm.data.tax_location;

      vm.contract2 = new Date(vm.data.contract2);
      vm.contract3 = new Date(vm.data.contract3);
      vm.contract4 = new Date(vm.data.contract4);
      vm.finishContract2 = new Date(vm.data.finishContract2);
      vm.finishContract3 = new Date(vm.data.finishContract3);
      vm.finishContract4 = new Date(vm.data.finishContract4);
      vm.statusDate = new Date(vm.data.statusDate);
      vm.tglPerubahan1 = new Date(vm.data.tglPerubahan1);
      vm.tglPerubahan2 = new Date(vm.data.tglPerubahan2);
      vm.tglPerubahan3 = new Date(vm.data.tglPerubahan3);
      vm.tglPerubahan4 = new Date(vm.data.tglPerubahan4);

    }

    function loadCostCenterCB() {

      var company = vm.data.positionID.substr(0, 2);
      var promises = ApiHrCompletion.query({ action: 'getCostCenter', cctype: 'cnb', company: company });

      promises.$promise.then(function (data) {
        vm.costCenterCBList = data;
      });

      promises.$promise.catch(function () {
        vm.costCenterCBList = [];
      });

    }

    function loadCostCenterNonCB() {

      var company = vm.data.positionID.substr(0, 2);
      var promises = ApiHrCompletion.query({ action: 'getCostCenter', cctype: 'noncnb', company: company });

      promises.$promise.then(function (data) {
        vm.costCenterNonCBList = data;
      });

      promises.$promise.catch(function () {
        vm.costCenterNonCBList = [];
      });

    }

    function loadSubArea() {

      var company = vm.data.positionID.substr(0, 2);
      var promises = ApiHrCompletion.query({ action: 'getSubArea', company: company });

      promises.$promise.then(function (data) {
        vm.subAreaLists = data;
      });

      promises.$promise.catch(function () {
        vm.subAreaLists = [];
      });

    }

    function loadGedung(sub_area_id) {

      var promises = ApiHrCompletion.query({ action: 'getGedung', sub_area_id: sub_area_id });

      promises.$promise.then(function (data) {
        vm.gedungLists = data;
      });

      promises.$promise.catch(function () {
        vm.gedungLists = [];
      });

    }

    function loadSector(gedung_id) {

      var promises = ApiHrCompletion.query({ action: 'getSector', gedung_id: gedung_id });

      promises.$promise.then(function (data) {
        vm.sectorLists = data;
      });

      promises.$promise.catch(function () {
        vm.sectorLists = [];
      });

    }

    function loadLine(gedung_sector_id) {

      var promises = ApiHrCompletion.query({ action: 'getLine', gedung_sector_id: gedung_sector_id });

      promises.$promise.then(function (data) {
        vm.lineLists = data;
      });

      promises.$promise.catch(function () {
        vm.lineLists = [];
      });

    }

    function loadOtParam() {

      var promises = ApiHrCompletion.query({ action: 'getOtParam' });

      promises.$promise.then(function (data) {
        vm.otParamLists = data;
      });

      promises.$promise.catch(function () {
        vm.otParamLists = [];
      });

    }

    function loadAbbreviation() {

      var promises = ApiHrCompletion.query({ action: 'getAbbreviation' });

      promises.$promise.then(function (data) {
        vm.abbbreviationLists = data;
      });

      promises.$promise.catch(function () {
        vm.abbbreviationLists = [];
      });

    }

    function loadJamsostek() {

      var promises = ApiHrCompletion.query({ action: 'getJamsostek' });

      promises.$promise.then(function (data) {
        vm.jamsostekLists = data;
      });

      promises.$promise.catch(function () {
        vm.jamsostekLists = [];
      });

    }

    function loadTaxParam() {

      var promises = ApiHrCompletion.query({ action: 'getTaxParam' });

      promises.$promise.then(function (data) {
        vm.taxParamLists = data;
      });

      promises.$promise.catch(function () {
        vm.taxParamLists = [];
      });

    }

    function loadTaxLocation() {

      var promises = ApiHrCompletion.query({ action: 'getTaxLocation' });

      promises.$promise.then(function (data) {
        vm.taxLocationLists = data;
      });

      promises.$promise.catch(function () {
        vm.taxLocationLists = [];
      });

    }

    function changedAbbreviation(ab) {

      var item = vm.abbbreviationLists.find(function (val) {
        if (val.positionID === ab) {
          return val;
        }
      });

      vm.job_title = item.description;
    }

    function saveDataSubarea(ev, formController) {
      angular.element.blockUI();

      var contract2 = angular.copy(vm.contract2);
      var contract3 = angular.copy(vm.contract3);
      var contract4 = angular.copy(vm.contract4);

      var finishContract2 = angular.copy(vm.finishContract2);
      var finishContract3 = angular.copy(vm.finishContract3);
      var finishContract4 = angular.copy(vm.finishContract4);

      var statusDate = angular.copy(vm.statusDate);

      var tglPerubahan1 = angular.copy(vm.tglPerubahan1);
      var tglPerubahan2 = angular.copy(vm.tglPerubahan2);
      var tglPerubahan3 = angular.copy(vm.tglPerubahan3);
      var tglPerubahan4 = angular.copy(vm.tglPerubahan4);

      vm.Form.objForm.id = vm.data.id;
      vm.Form.objForm.nikAtasan = vm.nikAtasan;
      vm.Form.objForm.costCenterCB = vm.costCenterCB;
      vm.Form.objForm.costCenterNonCB = vm.costCenterNonCB;
      vm.Form.objForm.contract2 = moment(contract2).format('YYYY-MM-DD');
      vm.Form.objForm.finishContract2 = moment(finishContract2).format('YYYY-MM-DD');
      vm.Form.objForm.contract3 = moment(contract3).format('YYYY-MM-DD');
      vm.Form.objForm.finishContract3 = moment(finishContract3).format('YYYY-MM-DD');
      vm.Form.objForm.contract4 = moment(contract4).format('YYYY-MM-DD');
      vm.Form.objForm.finishContract4 = moment(finishContract4).format('YYYY-MM-DD');
      vm.Form.objForm.noSkTetap = vm.noSkTetap;
      vm.Form.objForm.skPerubahan1 = vm.skPerubahan1;
      vm.Form.objForm.tglPerubahan1 = moment(tglPerubahan1).format('YYYY-MM-DD');
      vm.Form.objForm.skPerubahan2 = vm.skPerubahan2;
      vm.Form.objForm.tglPerubahan2 = moment(tglPerubahan2).format('YYYY-MM-DD');
      vm.Form.objForm.skPerubahan4 = vm.skPerubahan4;
      vm.Form.objForm.tglPerubahan4 = moment(tglPerubahan4).format('YYYY-MM-DD');
      vm.Form.objForm.skPerubahan3 = vm.skPerubahan3;
      vm.Form.objForm.tglPerubahan3 = moment(tglPerubahan3).format('YYYY-MM-DD');
      vm.Form.objForm.statusDate = moment(statusDate).format('YYYY-MM-DD');
      vm.Form.objForm.eyeGlass = vm.eyeGlass;
      vm.Form.objForm.eyeGlass = vm.eyeGlass;
      vm.Form.objForm.bankCode = vm.bankCode;
      vm.Form.objForm.noRekening = vm.noRekening;
      vm.Form.objForm.workLocation = vm.personalSubArea;
      vm.Form.objForm.personalSubArea = vm.personalSubArea;
      vm.Form.objForm.Ot = vm.Ot;
      vm.Form.objForm.tax_code = vm.tax_code;
      vm.Form.objForm.tax_location = vm.tax_location;
      vm.Form.objForm.dlidl_category = vm.dlidl_category;
      vm.Form.objForm.job_title = vm.job_title;
      vm.Form.objForm.abbreviation = vm.abbreviation;
      vm.Form.objForm.gedung = vm.gedung;
      vm.Form.objForm.sector = vm.sector;
      vm.Form.objForm.mpn_id = vm.mpn_id;
      vm.Form.objForm.line_id = vm.data.line_id;

      var response = Form.saveData('saveHRComplletion', formController, ApiHrCompletion);
      response.then(function (data) {
        angular.element.unblockUI();
        formController.$setPristine();
        dialogClose();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        formController.$setPristine();
        dialogClose();
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          loadData(1);
        });
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.employement.input-employement', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.employee_employement_input', {
                url    : '/employee/employement/input-employement',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/employement/input-employement/input-employement.html',
                        controller : 'InputemployementController as vm'
                    }
                }
            })

             .state('app.employee_employement_edit', {
                url    : '/employee/employement/edit-employement/:nik',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/employement/input-employement/input-employement.html',
                        controller : 'EditemployementController as vm'
                    }
                }
            });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/employee/employement');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.employee.employement.input-employement')
        .controller('InputemployementController', InputemployementController);


    InputemployementController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputemployementController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Employement=  AppAPI.Employement();

         // set constructor form
         Form.setObject(Employement);

         // set form to controller
         vm.Form = Form;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Employement);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.employee.employement.input-employement')
        .controller('EditemployementController', EditemployementController);


    EditemployementController.$inject=['$localStorage','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditemployementController($localStorage,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Employement=  AppAPI.Employement();

         // set constructor form
         Form.setObject(Employement);

         // set form to controller
         vm.Form = Form;

      
          vm.Form.objForm.$get({action:'viewdetail',nik:$stateParams.nik});
       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('updatedata',formController,Employement,$stateParams.nik,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () {
  'use strict';

  angular
      .module('app.employee.emplabortype.upload-employee-labor-type', [])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_employee_labor_type_upload', {
              url: '/employee/emplabortype/upload-employee-labor-type',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/employee-labor-type/upload-employee-labor-type/upload-employee-labor-type.html',
                      controller: 'UploadEmpLaborTypeController as vm'
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.employee.emplabortype.upload-employee-labor-type')
    .controller('UploadEmpLaborTypeController', UploadEmpLaborTypeController);

  UploadEmpLaborTypeController.$inject = [
    '$state',
    '$mdDialog',
    'config',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'infoDialog',
    'FileUploader'
  ];
  /** @ngInject */
  function UploadEmpLaborTypeController(
    $state,
    $mdDialog,
    config,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    infoDialog,
    FileUploader

  ) {
    var vm = this;
    vm.dialogClose = dialogClose;
    vm.infoDialog = infoDialog;
    vm.uploadEmpLaborStateSuccess = false;
    vm.uploadEmpLaborStateError = false;

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.FileUploaderEmpLabor = new FileUploader({
      url: config.api + 'api/employelabortype/uploadDataEmpLabor',
      removeAfterUpload: true,
      alias: 'fileEmpLabor',
      formData: [{
          action: 'uploadDataEmpLaborType'
      }],
      onAfterAddingAll: function() {
        vm.uploadEmpLaborStateSuccess = false;
        vm.uploadEmpLaborStateError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUploaderEmpLabor.onSuccessItem = function(item) {
      vm.uploadEmpLaborStateSuccess = true;
      vm.uploadEmpLaborStateError   = false;
      angular.element('#uploadEmpLabor').val('');
      setTimeout(function(item){
        dialogClose();
      }, 1000);
    };

    vm.FileUploaderEmpLabor.onErrorItem = function() {
      vm.uploadEmpLaborStateSuccess = false;
      vm.uploadEmpLaborStateError = true;
      setTimeout(function(item){
        dialogClose();
      }, 2000);
    };
  }
})();

(function () {
  'use strict';

  angular
      .module('app.employee.emplabortype.update-employee-labor-type', [])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_employee_labor_type_update', {
              url: '/employee/emplabortype/update-employee-labor-type',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/employee-labor-type/update-employee-labor-type/update-employee-labor-type.html',
                      controller: 'UpdateEmpLaborTypeController as vm'
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.employee.emplabortype.update-employee-labor-type')
    .controller('UpdateEmpLaborTypeController', UpdateEmpLaborTypeController);

  UpdateEmpLaborTypeController.$inject = [
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'infoDialog',
    'dataUpdate'
  ];
  /** @ngInject */
  function UpdateEmpLaborTypeController(
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    infoDialog,
    dataUpdate

  ) {
    var vm = this;
    var ApiLaborType = AppAPI.EmpLaborType();
    vm.labortype = ['direct', 'indirect'];
    vm.name = dataUpdate.name;
    vm.effectiveDate = new Date(dataUpdate.effective_date);
    vm.selectedLaborType = dataUpdate.labor_type;
    vm.nik = dataUpdate.nik;
    vm.dialogClose = dialogClose;
    vm.infoDialog = infoDialog;
    vm.updateEmpLabor = updateEmpLabor;
    vm.Form = Form;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(ApiLaborType);
    }

    function updateEmpLabor(ev, formController) {
      angular.element.blockUI();
      console.log(formController);
      vm.Form.objForm.id            = dataUpdate.id;
      vm.Form.objForm.nik           = dataUpdate.nik;
      vm.Form.objForm.effectiveDate = formController.effectiveDate.$viewValue;
      vm.Form.objForm.labortype     = formController.labortype.$viewValue;
      var response = Form.saveData('updateDataEmpLaborType', formController, ApiLaborType);
      response.then(function(data) {
          angular.element.unblockUI();
          formController.$setPristine();
          vm.infoDialog(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          formController.$setPristine();
          vm.infoDialog(ev, data);
      });
  }

    function dialogClose() {
      $mdDialog.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
      .module('app.employee.emplabortype.input-employee-labor-type', [])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_employee_labor_type_input', {
              url: '/employee/emplabortype/input-employee-labor-type',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/employee-labor-type/input-employee-labor-type/input-employee-labor-type.html',
                      controller: 'InputEmpLaborTypeController as vm'
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.employee.emplabortype.input-employee-labor-type')
    .controller('InputEmpLaborTypeController', InputEmpLaborTypeController);

  InputEmpLaborTypeController.$inject = [
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'infoDialog',
    '$q',
    'filterFilter'
  ];
  /** @ngInject */
  function InputEmpLaborTypeController(
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    infoDialog,
    $q,
    filterFilter
  ) {
    var vm = this;
    var Attendancereport = AppAPI.Attendancereport();
    var ApiHoliday = AppAPI.NationalHoliday();
    var ApiLaborType = AppAPI.EmpLaborType();
    vm.company = $localStorage.empsite ? $localStorage.empsite : "KS";
    vm.labortype = ['direct', 'indirect'];
    vm.empListData = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.selectedEmp = [];
    vm.querySearchDeferred = querySearchDeferred;
    vm.empList = empList;
    vm.saveDataEmpLabor = saveDataEmpLabor;
    vm.infoDialog = infoDialog;
    vm.Form = Form;
    vm.dialogClose = dialogClose;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(ApiLaborType);
      loadDataBU();
      empList();
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function loadDataBU() {
      var response = Attendancereport.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    function empList() {
      var response = ApiLaborType.query({
          action: 'viewListEmployee',
          company: vm.company
      });
      response.$promise.then(fetchDataEmpList);
    }

    function fetchDataEmpList(data) {
      vm.empListData = [];
      vm.empListData = data;
    }

    function querySearchDeferred(query) {
        var deferred = $q.defer();
        setTimeout(function() {
            var data = vm.empListData;
            if (query) {
                deferred.resolve(filterFilter(data, query));
            } else {
                deferred.reject([{ nik: 'none', name: 'none' }]);
            }
        }, 200);
        return deferred.promise;
    }

    function saveDataEmpLabor(ev, formController) {
      angular.element.blockUI();
      console.log(formController);
      vm.Form.objForm.nik = formController.nik.$viewValue;
      vm.Form.objForm.effectiveDate = formController.effectiveDate.$viewValue;
      vm.Form.objForm.labortype = formController.labortype.$viewValue;
      var response = Form.saveData('saveDataEmpLaborType', formController, ApiLaborType);
      response.then(function(data) {
          angular.element.unblockUI();
          formController.$setPristine();
          vm.infoDialog(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          formController.$setPristine();
          vm.infoDialog(ev, data);
      });
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe_admin')
        .controller('UploadEditGroupShiftController', UploadEditGroupShiftController);

    UploadEditGroupShiftController.$inject = ['$state', '$mdDialog', 'config', '$localStorage', '$timeout', 'AppAPI', 'Auth', 'FileUploader', '$location', '$window'];

    /* @ngInject */
    function UploadEditGroupShiftController($state, $mdDialog, config, $localStorage, $timeout, AppAPI, Auth, FileUploader, $location, $window) {
        var vm = this;

        vm.closeModal = closeModal
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.DownloadTemplate = DownloadTemplate;
        vm.FileUpload = new FileUploader({
            url: config.api + 'api/employe/uploadEditEmpGroupShiftAdmin',
            removeAfterUpload: true,
            alias: 'fileupload',
            formData: [{
                action: 'uploadEditEmpGroupShiftAdmin'
            }],
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
            if (status.status == 'Failed') {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                checkDataUpload(status.data);
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }
            vm.uploadNotif = status.message;
            angular.element('#uploadCutOff').val('');
        };

        vm.FileUpload.onErrorItem = function () {
            vm.uploadSuccess = false;
            vm.uploadError = true;
        };

        function closeModal() {
            $mdDialog.hide();
        }

        function DownloadTemplate(type) {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/employe/downloadtemplate?type=' +
                        type,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function checkDataUpload(data, ev) {
            $mdDialog.show({
                controller: 'HasilCheckDataGroupShiftController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe-admin/upload-edit-group-shift/hasil-check-data-group-shift/hasil-check-data-group-shift.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals: {
                    dataUpload: data,
                },
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                }
            });

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe_admin')
        .controller('UploadEditAtasanController', UploadEditAtasanController);

    UploadEditAtasanController.$inject = ['$state', '$mdDialog', 'config', '$localStorage', '$timeout', 'AppAPI', 'Auth', 'FileUploader', '$location', '$window'];

    /* @ngInject */
    function UploadEditAtasanController($state, $mdDialog, config, $localStorage, $timeout, AppAPI, Auth, FileUploader, $location, $window) {
        var vm = this;

        vm.closeModal = closeModal
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.DownloadTemplate = DownloadTemplate;
        vm.FileUpload = new FileUploader({
            url: config.api + 'api/employe/uploadEditEmpAtasanAdmin',
            removeAfterUpload: true,
            alias: 'fileupload',
            formData: [{
                action: 'uploadEditEmpAtasanAdmin'
            }],
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
            if (status.status == 'Failed') {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                checkDataUpload(status.data);
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }
            vm.uploadNotif = status.message;
            angular.element('#uploadCutOff').val('');
        };

        vm.FileUpload.onErrorItem = function () {
            vm.uploadSuccess = false;
            vm.uploadError = true;
        };

        function closeModal() {
            $mdDialog.hide();
        }

        function DownloadTemplate(type) {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/employe/downloadtemplate?type=' +
                        type,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function checkDataUpload(data, ev) {
            $mdDialog.show({
                controller: 'HasilCheckDataAtasanController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe-admin/upload-edit-atasan/hasil-check-data-atasan/hasil-check-data-atasan.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals: {
                    dataUpload: data,
                },
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                }
            });

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe_admin')
        .controller('UploadBuildingController', UploadBuildingController);

    UploadBuildingController.$inject = ['$state', '$mdDialog', 'config', '$localStorage', '$timeout', 'AppAPI', 'Auth', 'FileUploader', '$location', '$window'];

    /* @ngInject */
    function UploadBuildingController($state, $mdDialog, config, $localStorage, $timeout, AppAPI, Auth, FileUploader, $location, $window) {
        var vm = this;

        vm.closeModal = closeModal
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.DownloadTemplate = DownloadTemplate;
        vm.FileUpload = new FileUploader({
            url: config.api + 'api/employe/uploagedungBuildingEmpAdmin',
            removeAfterUpload: true,
            alias: 'fileupload',
            formData: [{
                action: 'uploagedungBuildingEmpAdmin'
            }],
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
            if (status.status == 'Failed') {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                checkDataUpload(status.data);
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }
            vm.uploadNotif = status.message;
            angular.element('#uploadCutOff').val('');
        };

        vm.FileUpload.onErrorItem = function () {
            vm.uploadSuccess = false;
            vm.uploadError = true;
        };

        function closeModal() {
            $mdDialog.hide();
        }

        function DownloadTemplate(type) {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/employe/downloadtemplate?type=' +
                        type,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function checkDataUpload(data, ev) {
            $mdDialog.show({
                controller: 'HasilCheckDataController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe-admin/upload-building/hasil-check-data/hasil-check-data.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals: {
                    dataUpload: data,
                },
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                }
            });

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe_admin')
        .controller('SearchEmployeController', SearchEmployeController);

    SearchEmployeController.$inject = ['$state', '$mdDialog', 'config', '$localStorage', '$timeout', 'AppAPI', 'Auth', 'FileUploader', '$location', '$window', '$mdToast'];

    /* @ngInject */
    function SearchEmployeController($state, $mdDialog, config, $localStorage, $timeout, AppAPI, Auth, FileUploader, $location, $window, $mdToast) {
        var vm = this;
        var EMP = AppAPI.Employe();


        vm.closeModal = closeModal;
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';

        vm.loadDataMember = loadDataMember;
        vm.listDataEmpSearch = [];

        function loadDataMember() {
            angular.element.blockUI();
            var request = EMP.query({
                action: "getInfoEmployee",
                search: vm.searchMember,
                offset: 0,
                jumPage: 25,
                date: new Date()
            });
            request.$promise.then(function (res) {
                angular.element.unblockUI();
                vm.listDataEmpSearch = res;
            });
            request.$promise.catch(function (res) {
                angular.element.unblockUI();
                vm.listDataEmpSearch = [];
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.employe', ['app.employee.employe.input-employe',
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.employee_employe', {
                url    : '/employee/employe',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/employe/employe.html',
                        controller : 'EmployeController as vm',
                        css: ['app/main/employee/employe/employe-menu.scss']
                    }
                }
            });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.employee.employe')
        .controller('UploadfileController', UploadfileController);

    UploadfileController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window'];

    /* @ngInject */
    function UploadfileController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window) 
    {
        var vm = this;
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.DownloadTemplate = downloadTemplate;
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        vm.detailInfo = []
        vm.closeModal = closeModal

        vm.FileUpload= new FileUploader({
            url:config.api+'api/profiles/uploadfile', 
            removeAfterUpload:true,
            alias:'fileprofiles',
            formData:[
              {
               action:'uploadfile'
              }
            ],
            onAfterAddingAll:function(){
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers:{
                tokenAuth:$localStorage.tokenAuth
            }
        }); 

        vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
            if ( status.status == 0 ) {
                vm.uploadSuccess = false;
                vm.uploadError   = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError   = false;
            }
    
            vm.uploadNotif = status.pesan
            if ('moreInfo' in status && status.moreInfo.length>0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }
            angular.element('#FileUpload').val('');
        };

        vm.FileUpload.onErrorItem=function(item)
        {
            vm.uploadSuccess = false;
            vm.uploadError = true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function downloadTemplate(type)
        {
            var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                $window.open(protocol+'://'+host+config.api+'api/employe/downloadtemplate?type='+type, '_blank');
            },function(){
            
                $window.alert('gagal load token');
            });
        }

        function viewMoreInfo()
        {
            $mdDialog.show({
                controller         : 'logFailGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose:false,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                    data:vm.detailInfo
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.employee.employe')
        .controller('UploadEditKaryawanController', UploadEditKaryawanController);

    UploadEditKaryawanController.$inject = [
        '$mdDialog',
        '$localStorage',
        'FileUploader',
        'config',
        'Auth',
        '$location',
        '$window'
    ];

    /* @ngInject */
    function UploadEditKaryawanController(
        $mdDialog,
        $localStorage,
        FileUploader,
        config,
        Auth,
        $location,
        $window
    ) {
        var vm = this;
        // vm.openUploadPhoto=openUploadPhoto;

        vm.listUploadType = [
            { id: 1, description: 'Upload Status' },
            { id: 2, description: 'Upload Grade' },
            { id: 3, description: 'Upload Termination' },
            { id: 4, description: 'Upload Sub Area' },
            { id: 5, description: 'Upload Rekening Number' },
            { id: 6, description: 'Update Document' }
        ];

        vm.closeModal = closeModal;
        vm.uploadSuccessStatus = vm.uploadErrorStatus = vm.isMoreInfoStatus = vm.uploadSuccessGrade = vm.uploadErrorGrade = vm.isMoreInfoGrade = vm.uploadSuccessTermination = vm.uploadErrorTermination = vm.isMoreInfoTermination = vm.uploadSuccessSubarea = vm.uploadErrorSubarea = vm.isMoreInfoSubarea = vm.uploadSuccessRekening = vm.uploadErrorRekening = vm.isMoreInfoRekening = false;
        vm.uploadNotifStatus = vm.uploadNotifGrade = vm.uploadNotifTermination = vm.uploadNotifSubarea = vm.uploadNotifRekening =
            '';
        vm.DownloadTemplate = DownloadTemplate;
        vm.viewMoreInfo = viewMoreInfo;
        vm.detailInfoStatus = vm.detailInfoGrade = vm.detailInfoTermination = vm.detailInfoSubarea = vm.detailInfoRekening = [];

        // Upload Update Status
        vm.FileUploadStatus = new FileUploader({
            url: config.api + 'api/employe/uploadcontract',
            removeAfterUpload: true,
            alias: 'filecontract',
            formData: [
                {
                    action: 'uploadcontract'
                }
            ],
            onAfterAddingAll: function() {
                vm.uploadSuccessStatus = vm.uploadErrorStatus = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUploadStatus.onSuccessItem = function(data, status, headers, config) {
            // console.log(status);
            if (status.status == 0) {
                vm.uploadSuccessStatus = false;
                vm.uploadErrorStatus = true;
            } else {
                vm.uploadSuccessStatus = true;
                vm.uploadErrorStatus = false;
            }
            vm.uploadNotifStatus = status.pesan;
            if ('moreInfo' in status && status.moreInfo.length > 0) {
                vm.isMoreInfoStatus = true;
                vm.detailInfoStatus = status.moreInfo;
            }
        };

        vm.FileUploadStatus.onErrorItem = function() {
            vm.uploadSuccessStatus = false;
            vm.uploadErrorStatus = true;
        };

        // Upload Update Grade
        vm.FileUploadGrade = new FileUploader({
            url: config.api + 'api/employe/uploadgrade',
            removeAfterUpload: true,
            alias: 'filegrade',
            formData: [
                {
                    action: 'uploadgrade'
                }
            ],
            onAfterAddingAll: function() {
                vm.uploadSuccessGrade = vm.uploadErrorGrade = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUploadGrade.onSuccessItem = function(data, status, headers, config) {
            if (status.status == 0) {
                vm.uploadSuccessGrade = false;
                vm.uploadErrorGrade = true;
            } else {
                vm.uploadSuccessGrade = true;
                vm.uploadErrorGrade = false;
            }
            vm.uploadNotifGrade = status.pesan;
            if ('moreInfo' in status && status.moreInfo.length > 0) {
                vm.isMoreInfoGrade = true;
                vm.detailInfoGrade = status.moreInfo;
            }
        };

        vm.FileUploadGrade.onErrorItem = function() {
            vm.uploadSuccessGrade = false;
            vm.uploadErrorGrade = true;
        };

        // Upload Update Termination
        vm.FileUploadTermination = new FileUploader({
            url: config.api + 'api/employe/uploadtermination',
            removeAfterUpload: true,
            alias: 'filetermination',
            formData: [
                {
                    action: 'uploadtermination'
                }
            ],
            onAfterAddingAll: function() {
                vm.uploadSuccessTermination = vm.uploadErrorTermination = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUploadTermination.onSuccessItem = function(
            data,
            status,
            headers,
            config
        ) {
            if (status.status == 0) {
                vm.uploadSuccessTermination = false;
                vm.uploadErrorTermination = true;
            } else {
                vm.uploadSuccessTermination = true;
                vm.uploadErrorTermination = false;
            }
            vm.uploadNotifTermination = status.pesan;
            if ('moreInfo' in status && status.moreInfo.length > 0) {
                vm.isMoreInfoTermination = true;
                vm.detailInfoTermination = status.moreInfo;
            }
        };

        vm.FileUploadTermination.onErrorItem = function() {
            vm.uploadSuccessTermination = false;
            vm.uploadErrorTermination = true;
        };

        // Upload Update Subarea
        vm.FileUploadSubarea = new FileUploader({
            url: config.api + 'api/employe/uploadsubarea',
            removeAfterUpload: true,
            alias: 'filesubarea',
            formData: [
                {
                    action: 'uploadsubarea'
                }
            ],
            onAfterAddingAll: function() {
                vm.uploadSuccessSubarea = vm.uploadErrorSubarea = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUploadSubarea.onSuccessItem = function(
            data,
            status,
            headers,
            config
        ) {
            if (status.status == 0) {
                vm.uploadSuccessSubarea = false;
                vm.uploadErrorSubarea = true;
            } else {
                vm.uploadSuccessSubarea = true;
                vm.uploadErrorSubarea = false;
            }
            vm.uploadNotifSubarea = status.pesan;
            if ('moreInfo' in status && status.moreInfo.length > 0) {
                vm.isMoreInfoSubarea = true;
                vm.detailInfoSubarea = status.moreInfo;
            }
        };

        vm.FileUploadSubarea.onErrorItem = function() {
            vm.uploadSuccessSubarea = false;
            vm.uploadErrorSubarea = true;
        };

        // Upload Update Rekening
        vm.FileUploadRekening = new FileUploader({
            url: config.api + 'api/employe/uploadrekening',
            removeAfterUpload: true,
            alias: 'fileupload',
            formData: [
                {
                    action: 'uploadrekening'
                }
            ],
            onAfterAddingAll: function() {
                vm.uploadSuccessRekening = vm.uploadErrorRekening = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUploadRekening.onSuccessItem = function(
            data,
            status,
            headers,
            config
        ) {
            if (status.status == 0) {
                vm.uploadSuccessRekening = false;
                vm.uploadErrorRekening = true;
            } else {
                vm.uploadSuccessRekening = true;
                vm.uploadErrorRekening = false;
            }
            vm.uploadNotifRekening = status.pesan;
            if ('moreInfo' in status && status.moreInfo.length > 0) {
                vm.isMoreInfoRekening = true;
                vm.detailInfoRekening = status.moreInfo;
            }
        };

        vm.FileUploadRekening.onErrorItem = function() {
            vm.uploadSuccessRekening = false;
            vm.uploadErrorRekening = true;
        };

        vm.FileuploadDocument = new FileUploader({
            url: config.api + 'api/employe/uploadbpjs',
            removeAfterUpload: true,
            alias: 'fileupload',
            formData: [
                {
                    action: 'uploaddocument'
                }
            ],
            onAfterAddingAll: function() {
                vm.uploadSuccessRekening = vm.uploadErrorRekening = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileuploadDocument.onSuccessItem = function(
            data,
            status,
            headers,
            config
        ) {
            if (status.status == 0) {
                vm.uploadSuccessDocument = false;
                vm.uploadErrorDocument = true;
            } else {
                vm.uploadSuccessDocument = true;
                vm.uploadErrorDocument = false;
            }
            vm.uploadNotifDocument = status.pesan;
            if ('moreInfo' in status && status.moreInfo.length > 0) {
                vm.isMoreInfoDocument = true;
                vm.detailInfoDocument = status.moreInfo;
            }
        };

        vm.FileuploadDocument.onErrorItem = function() {
            vm.uploadSuccessDocument = false;
            vm.uploadErrorDocument = true;
        };

        function uploadFile() {
            return false;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function DownloadTemplate(type) {
            var token = Auth.setTokenPromise();
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            '://' +
                            host +
                            config.api +
                            'api/employe/downloadtemplate?type=' +
                            type,
                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }

        function viewMoreInfo(detail) {
            $mdDialog.show({
                controller: 'logFailGwController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: detail
                }
            });
        }
    }
})();

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('InputemployeController', InputemployeController);


    InputemployeController.$inject=['$state','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputemployeController($state,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

        // initial form
        Form.initialForm();

        var Employe=  AppAPI.Employe();

        // set constructor form
        Form.setObject(Employe);

        // set form to controller
        vm.Form = Form;
       
        vm.title = ['Mr','Mrs','Miss','Ms'];
        vm.jenkel = ['L','P'];
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function changeDate(data) {
           vm.Form.objForm.dateJoin=new Date(data.dateJoin);
        }

        
        function saveData(formController) {
            angular.element.blockUI();
            var response=Form.updateData('save',formController,Employe,$stateParams.id,'viewdetail');

            response.then(function(){
                vm.messageTheme='blue';
                angular.element.unblockUI();
                formController.$setPristine();
                vm.Form.objForm.date_of_birth=new Date(vm.Form.objForm.date_of_birth);
                $timeout(function() {
                    vm.Form.tampilPesan=false;
                }, 3000);
            });

            response.catch(function(){
                vm.messageTheme='pink';
                angular.element.unblockUI();
            });
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function(){
    'use strict';

    angular
        .module('app.employee.employe')
        .service('EmployeeService', service)

    service.$inject = ['$http'];

    function service($http) {
        this.title = 'Profile'
        this.status = false;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('EditmyemployeController', EditmyemployeController);


    EditmyemployeController.$inject = ['$state', '$window', '$localStorage', '$stateParams', '$timeout', '$document', '$mdDialog', '$mdSidenav', 'Form', 'AppAPI', 'config', 'FileUploader', 'EmployeeService', '$filter', '$http'];
    /** @ngInject */
    function EditmyemployeController($state, $window, $localStorage, $stateParams, $timeout, $document, $mdDialog, $mdSidenav, Form, AppAPI, config, FileUploader, EmployeeService, $filter, $http) {

        var vm = this;

        var translate = $filter('translate');

        vm.EmployeeService = EmployeeService;
        EmployeeService.status = false;


        // initial form
        Form.initialForm();

        var Employe = AppAPI.Employe();
        // var Profiles= AppAPI.Profiles();

        // set constructor form
        Form.setObject(Employe);

        // set form to controller
        vm.Form = Form;

        vm.Form.objForm.tolbarrbtn = false;

        vm.toggleSidenav = toggleSidenav;

        vm.checkPhoto = false;
        vm.PhotoProfile = 'assets/images/avatars/profile.jpg';
        vm.currentImage = [];
        vm.failPhoto = false;
        vm.downloadImage = downloadImage;

        // vm.Completed=false;
        // vm.viewCompletion=viewCompletion;
        // vm.checkCompletion=checkCompletion;
        // checkCompletion();
        // vm.viewMenus=viewMenus;
        loadData();

        function loadData() {
            var response = vm.Form.objForm.$get({
                action: 'viewdetail',
                id: $stateParams.id
            });
            response.then(changeDate);
        }

        //  vm.saveData=saveData;

        //  vm.clearMeesage=clearMeesage;
        vm.activeItem = (vm.activeItem !== '' ? $state.current.name : 'app.employee_myemploye_edit.profile');
        // vm.sideMenu = [
        // {
        //     label: 'Profile',
        //     link: 'app.employee_employe_edit.profile',
        //     action:'viewdetail',
        //     module:'profiles'
        // },{
        //     label: 'Address',
        //     link: 'app.employee_employe_edit.address',
        //     action:'viewAddress',
        //     module:'address'
        // },{
        //     label: 'Dependent',
        //     link: 'app.employee_employe_edit.dependent',
        //     action:'viewdetail',
        //     module:'dependents'
        // },{
        //     label: 'Emergency Contact',
        //     link: 'app.employee_employe_edit.emergency',
        //     action:'viewdetail',
        //     module:'emergency'
        // },{
        //     label: 'Education',
        //     link: 'app.employee_employe_edit.education'
        // },{
        //     label: 'Language',
        //     link: 'app.employee_employe_edit.language'
        // },{
        //     label: 'Experience',
        //     link: 'app.employee_employe_edit.experience'
        // },{
        //     label: 'Certification',
        //     link: 'app.employee_employe_edit.certification'
        // },{
        //     label: 'Training',
        //     link: 'app.employee_employe_edit.training'
        // },{
        //     label: 'Bank',
        //     link: 'app.employee_employe_edit.bank'
        // },{
        //     label: 'Tax',
        //     link: 'app.employee_employe_edit.tax'
        // },{
        //     label: 'Document',
        //     link: 'app.employee_employe_edit.document'
        // }
        // ];

        vm.profileMenu = [{
            label: 'MYPROFILE.MENU.PROFILE',
            link: 'app.employee_myemploye_edit.profile',
            action: 'viewdetail',
            module: 'profiles'
        }, {
            label: 'MYPROFILE.MENU.ADDRESS',
            link: 'app.employee_myemploye_edit.address',
            action: 'viewAddress',
            module: 'address'
        }, {
            label: 'MYPROFILE.MENU.DEPENDENT',
            link: 'app.employee_myemploye_edit.dependent',
            action: 'viewdetail',
            module: 'dependents'
        }, {
            label: 'MYPROFILE.MENU.EMERGENCYCONTACT',
            link: 'app.employee_myemploye_edit.emergency',
            action: 'viewdetail',
            module: 'emergency'
        }, {
            label: 'MYPROFILE.MENU.EDUCATION',
            link: 'app.employee_myemploye_edit.education'
        }, {
            label: 'MYPROFILE.MENU.LANGUAGE',
            link: 'app.employee_myemploye_edit.language'
        }, {
            label: 'MYPROFILE.MENU.EXPERIENCE',
            link: 'app.employee_myemploye_edit.experience'
        }, {
            label: 'MYPROFILE.MENU.CERTIFICATION',
            link: 'app.employee_myemploye_edit.certification'
        }, {
            label: 'MYPROFILE.MENU.TRAINING',
            link: 'app.employee_myemploye_edit.training'
        }, {
            label: 'MYPROFILE.MENU.BANK',
            link: 'app.employee_myemploye_edit.bank'
        }, {
            label: 'MYPROFILE.MENU.TAX',
            link: 'app.employee_myemploye_edit.tax'
        }, {
            label: 'MYPROFILE.MENU.DOCUMENT',
            link: 'app.employee_myemploye_edit.document'
        }, {
            label: 'MYPROFILE.MENU.USERMANUAL',
            link: 'app.employee_myemploye_edit.usermanual'
        }];

        vm.employementMenu = [{

                label: 'MYPROFILE.MENU.JOB',
                link: 'app.employee_myemploye_edit.employements',
                action: 'viewdetail',
                module: 'employements'
            },
            {

                label: 'Join Date',
                link: 'app.employee_myemploye_edit.joindate',
                action: 'viewAddress',
                module: 'address'
            }, {
                label: 'MYPROFILE.MENU.WORKLOCATION',
                link: 'app.employee_myemploye_edit.worklocation',
                action: 'viewdetail',
                module: 'worklocation'
            }, {
                label: 'MYPROFILE.MENU.STATUS',
                link: 'app.employee_myemploye_edit.status',
                action: 'viewdetail',
                module: 'status'
            }, {
                label: 'SK JIC',
                link: 'app.employee_myemploye_edit.skjic',
                action: 'viewdetail',
                module: 'skjic'
            }
            // ,{
            //     label: 'Shift Setting',
            //     link: 'app.employee_myemploye_edit.shiftsetting',
            //     action:'viewdetail',
            //     module:'employesetting'
            // } 
        ];

        var allowMenu = $localStorage.listMenu1;
        // filterMenu(allowMenu);



        vm.goNav = goNav;
        vm.uploadFile = uploadFile;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;

        vm.openUploadPhoto = openUploadPhoto;
        vm.closeDialog = closeDialog;
        vm.checkPhoto = false;
        vm.PhotoProfile = 'assets/images/avatars/profile.jpg';



        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/employe/uploadPhoto',
            removeAfterUpload: true,
            alias: 'profilephoto',
            formData: [{
                action: 'uploadPhoto'
            }],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
                closeDialog();
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        // function filterMenu(objMenu) {
        //     var jum=objMenu.length,i,listMenuEmp=[],sideMenuLength=vm.sideMenu.length,j;
        //     for (i = 0;i<jum;i++) {
        //       if(objMenu[i].menuname==='employees.Employee')
        //       {
        //           listMenuEmp=objMenu[i].roles;
        //           break;
        //       }
        //     }

        //     for(i=0;i<sideMenuLength;i++)
        //     {

        //     }

        //     console.log(listMenuEmp);
        // }

        function downloadImage() {
            $http({
                method: 'GET',
                url: 'api/empdocument/' + vm.Form.objForm.photoAddress,
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();

                var filename = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([data], {
                        type: contentType
                    });
                    var url = window.URL.createObjectURL(blob);

                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", vm.Form.objForm.photoAddress);

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).error(function (data) {
                console.log(data);
            });
        }

        function getCurrentImage(filename) {
            var urlFilename = config.api + 'api/empdocument/' + filename;
            if (!filename || filename === '-') {
                urlFilename = '/assets/images/avatars/profile.jpg';
                vm.failPhoto = true;
            }

            var apiCall = $http.get(urlFilename, {
                responseType: "blob"
            });

            apiCall
                .success(function (file) {
                    var mimetype = file.type;
                    var createFile = new File([file], filename, {
                        type: mimetype
                    });
                    var current = new FileUploader.FileItem(vm.FileUploaderPhoto, {});
                    current._file = createFile;
                    current.progress = 100;
                    current.isUploaded = true;
                    current.isSuccess = true;
                    vm.FileUploaderPhoto.queue.push(current);
                }).error(function (error) {
                    var handler = $http.get('/assets/images/avatars/unprofile.jpg', {
                        responseType: "blob"
                    });
                    handler.success(function (file) {
                        var mimetype = file.type;
                        var createFile = new File([file], filename, {
                            type: mimetype
                        });
                        var defaultImg = new FileUploader.FileItem(vm.FileUploaderPhoto, {});
                        defaultImg._file = createFile;
                        defaultImg.progress = 100;
                        defaultImg.isUploaded = true;
                        defaultImg.isSuccess = true;
                        vm.FileUploaderPhoto.queue.push(defaultImg);
                        vm.failPhoto = true;
                    });
                })
        }

        function changeDate(data) {
            vm.Form.objForm.dateOfBirth = new Date(data.dateOfBirth);
            if (data.photoAddress && data.photoAddress !== '-') {
                vm.checkPhoto = true;
                vm.PhotoProfile = 'api/empdocument/' + data.photoAddress;
            }
            getCurrentImage(data.photoAddress);
        }

        function goNav(state) {
            $state.go(state, {
                nik: $localStorage.currentNik
            });
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }

        function openUploadPhoto(ev) {

            // vm.PhotoProfile = 'assets/images/avatars/profile.jpg';
            $mdDialog.show({
                controller: 'EditemployeController as vm',
                templateUrl: 'app/main/employee/employe/input-employe/profile/upload-photo.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    // $state.go('app.employee_myemploye_edit.profile',{id:$localStorage.empno});
                    loadData();
                }
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        uploaderPhoto.onSuccessItem = function (item) {
            vm.UploadPhotoStateSucces = true;
            vm.UploadPhotoStateError = false;
            // console.log(item);
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem = function () {
            vm.UploadPhotoStateSucces = false;
            vm.UploadPhotoStateError = true;
        };

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        // function viewCompletion()
        // {
        //     // console.log(vm.Completed);
        //    if(!vm.Completed){
        //     vm.Completed=true;
        //    }else{
        //     vm.Completed=false;
        //    }
        // }

        // function  checkCompletion() {
        //     var resp=Profiles.query({action:'checkCompletionData',id:$stateParams.id});
        //     // console.log(resp);
        //   resp.$promise.then(fetchData);
        //   resp.$promise.catch(errorFetchData);
        //   // vm.listOtselected=[];
        // }

        // function fetchData(data) {
        //   vm.listCompletion=data[0];
        //   console.log(vm.listCompletion);
        // }

        // function errorFetchData() {
        //   vm.listCompletion=[];
        // }

        // function viewMenus(id)
        // {
        //     // console.log(id);
        //     vm.Completed=false;
        //     $state.go('app.employee_myemploye_edit.'+id);
        // }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('EditemployeController', EditemployeController);


    EditemployeController.$inject = ['$state', '$window', '$localStorage', '$stateParams', '$timeout', '$document', '$mdDialog', '$mdSidenav', 'Form', 'AppAPI', 'config', 'FileUploader', 'EmployeeService', '$scope', '$http'];
    /** @ngInject */
    function EditemployeController($state, $window, $localStorage, $stateParams, $timeout, $document, $mdDialog, $mdSidenav, Form, AppAPI, config, FileUploader, EmployeeService, $scope, $http) {

        var vm = this;

        EmployeeService.status = true;

        // initial form
        Form.initialForm(false);

        var Employe = AppAPI.Employe();

        // set constructor form
        Form.setObject(Employe);

        // set form to controller
        vm.Form = Form;

        vm.Form.objForm.tolbarrbtn = false;

        vm.toggleSidenav = toggleSidenav;

        vm.checkPhoto = false;
        vm.PhotoProfile = 'assets/images/avatars/profile.jpg';
        vm.currentImage = [];
        vm.failPhoto = false;
        vm.downloadImage = downloadImage;
        vm.getSelectedMenu=getSelectedMenu;
        vm.jumpToNik=jumpToNik;

        // vm.searchTextChange=searchTextChange;
        vm.selectedItemChanged=selectedItemChanged;
        vm.getEmployee=getEmployee;
        vm.id=null;
        vm.empsno = '';
        vm.empno = '';
        vm.empid = '';
        vm.fullname = '';
        vm.searchString = '';

        loadData();

        //  vm.saveData=saveData;

        //  vm.clearMeesage=clearMeesage;
        vm.activeItem = (vm.activeItem !== '' ? $state.current.name : 'app.employee_employe_edit.profile');

        vm.selectedMenu = vm.activeItem; 

        // vm.sideMenu = [
        // {
        //     label: 'Profile',
        //     link: 'app.employee_employe_edit.profile',
        //     action:'viewdetail',
        //     module:'profiles'
        // },{
        //     label: 'Address',
        //     link: 'app.employee_employe_edit.address',
        //     action:'viewAddress',
        //     module:'address'
        // },{
        //     label: 'Dependent',
        //     link: 'app.employee_employe_edit.dependent',
        //     action:'viewdetail',
        //     module:'dependents'
        // },{
        //     label: 'Emergency Contact',
        //     link: 'app.employee_employe_edit.emergency',
        //     action:'viewdetail',
        //     module:'emergency'
        // },{
        //     label: 'Education',
        //     link: 'app.employee_employe_edit.education'
        // },{
        //     label: 'Language',
        //     link: 'app.employee_employe_edit.language'
        // },{
        //     label: 'Experience',
        //     link: 'app.employee_employe_edit.experience'
        // },{
        //     label: 'Certification',
        //     link: 'app.employee_employe_edit.certification'
        // },{
        //     label: 'Training',
        //     link: 'app.employee_employe_edit.training'
        // },{
        //     label: 'Bank',
        //     link: 'app.employee_employe_edit.bank'
        // },{
        //     label: 'Tax',
        //     link: 'app.employee_employe_edit.tax'
        // },{
        //     label: 'Document',
        //     link: 'app.employee_employe_edit.document'
        // }
        // ];

        vm.profileMenu = [{
            label: 'MYPROFILE.MENU.PROFILE',
            link: 'app.employee_employe_edit.profile',
            action: 'viewdetail',
            module: 'profiles'
        }, {
            label: 'MYPROFILE.MENU.ADDRESS',
            link: 'app.employee_employe_edit.address',
            action: 'viewAddress',
            module: 'address'
        }, {
            label: 'MYPROFILE.MENU.DEPENDENT',
            link: 'app.employee_employe_edit.dependent',
            action: 'viewdetail',
            module: 'dependents'
        }, {
            label: 'MYPROFILE.MENU.EMERGENCYCONTACT',
            link: 'app.employee_employe_edit.emergency',
            action: 'viewdetail',
            module: 'emergency'
        }, {
            label: 'MYPROFILE.MENU.EDUCATION',
            link: 'app.employee_employe_edit.education'
        }, {
            label: 'MYPROFILE.MENU.LANGUAGE',
            link: 'app.employee_employe_edit.language'
        }, {
            label: 'MYPROFILE.MENU.EXPERIENCE',
            link: 'app.employee_employe_edit.experience'
        }, {
            label: 'MYPROFILE.MENU.CERTIFICATION',
            link: 'app.employee_employe_edit.certification'
        }, {
            label: 'MYPROFILE.MENU.TRAINING',
            link: 'app.employee_employe_edit.training'
        }, {
            label: 'MYPROFILE.MENU.BANK',
            link: 'app.employee_employe_edit.bank'
        }, {
            label: 'MYPROFILE.MENU.TAX',
            link: 'app.employee_employe_edit.tax'
        }, {
            label: 'MYPROFILE.MENU.DOCUMENT',
            link: 'app.employee_employe_edit.document'
        }];

        vm.employementMenu = [
            // {
            //     label: 'Employements',
            //     link: 'app.employee_employe_edit.employement',
            //     action:'viewdetail',
            //     module:'employements'
            // },
            {

                label: 'MYPROFILE.MENU.JOB',
                link: 'app.employee_employe_edit.employements',
                action: 'viewdetail',
                module: 'employements'
            },
            {

                label: 'KPI.LABEL.JOINDATE',
                link: 'app.employee_employe_edit.joindate',
                action: 'viewAddress',
                module: 'address'
            }, {
                label: 'Work Location',
                link: 'app.employee_employe_edit.worklocation',
                action: 'viewdetail',
                module: 'worklocation'
            }, {
                label: 'KPI.LABEL.STATUS',
                link: 'app.employee_employe_edit.status',
                action: 'viewdetail',
                module: 'status'
            }, {
                label: 'SK JIC',
                link: 'app.employee_employe_edit.skjic',
                action: 'viewdetail',
                module: 'skjic'
            }, {
                label: 'KPI.LABEL.TERMINATION',
                link: 'app.employee_employe_edit.termination',
                action: 'viewdetail',
                module: 'termination'
            }

        ];

        var allowMenu = $localStorage.listMenu1;
        // filterMenu(allowMenu);

        vm.goNav = goNav;
        vm.uploadFile = uploadFile;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;

        vm.openUploadPhoto = openUploadPhoto;
        vm.closeDialog = closeDialog;

        vm.FileUploaderPhoto = new FileUploader({
            headers: {
                tokenAuth: $localStorage.tokenAuth
            },
            url: config.api + 'api/employe/uploadPhoto',
            removeAfterUpload: true,
            alias: 'profilephoto',
            formData: [{
                action: 'uploadPhoto'
            }],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            onAfterAddingFile: function (file) {
                var idxFile = this.getIndexOfItem(file);
                console.log(idxFile);
                if (idxFile > 0) {
                    this.removeFromQueue(0);
                }
                this.addToQueue(file);
            },
            onSuccessItem: function (item) {
                vm.UploadPhotoStateSucces = true;
                vm.UploadPhotoStateError = false;
            },
            onErrorItem: function (item) {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = true;
            }
        });

        function downloadImage() {
            $http({
                method: 'GET',
                url: 'api/empdocument/' + vm.Form.objForm.photoAddress,
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();

                var filename = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([data], {
                        type: contentType
                    });
                    var url = window.URL.createObjectURL(blob);

                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", vm.Form.objForm.photoAddress);

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).error(function (data) {
                console.log(data);
            });
        }

        function getCurrentImage(filename) {
            var urlFilename = config.api + 'api/empdocument/' + filename;
            if (!filename || filename === '-') {
                urlFilename = '/assets/images/avatars/profile.jpg';
                vm.failPhoto = true;
            }

            var apiCall = $http.get(urlFilename, {
                responseType: "blob"
            });
            
            apiCall
                .success(function (file) {
                    var mimetype = file.type;
                    var createFile = new File([file], filename, {
                        type: mimetype
                    });
                    var current = new FileUploader.FileItem(vm.FileUploaderPhoto, {});
                    current._file = createFile;
                    current.progress = 100;
                    current.isUploaded = true;
                    current.isSuccess = true;
                    vm.FileUploaderPhoto.queue.push(current);
                }).error(function (error) {
                    var handler = $http.get('/assets/images/avatars/unprofile.jpg', {
                        responseType: "blob"
                    });
                    handler.success(function (file) {
                        var mimetype = file.type;
                        var createFile = new File([file], filename, {
                            type: mimetype
                        });
                        var defaultImg = new FileUploader.FileItem(vm.FileUploaderPhoto, {});
                        defaultImg._file = createFile;
                        defaultImg.progress = 100;
                        defaultImg.isUploaded = true;
                        defaultImg.isSuccess = true;
                        vm.FileUploaderPhoto.queue.push(defaultImg);
                        vm.failPhoto = true;
                    });
                })
        }

        // function filterMenu(objMenu) {
        //     var jum=objMenu.length,i,listMenuEmp=[],sideMenuLength=vm.sideMenu.length,j;
        //     for (i = 0;i<jum;i++) {
        //       if(objMenu[i].menuname==='employees.Employee')
        //       {
        //           listMenuEmp=objMenu[i].roles;
        //           break;
        //       }
        //     }

        //     for(i=0;i<sideMenuLength;i++)
        //     {

        //     }

        //     console.log(listMenuEmp);
        // }
        function loadData() {
            var response = vm.Form.objForm.$get({
                action: 'viewdetail',
                id: $stateParams.id
            });
            response.then(changeDate);
        }

        function changeDate(data) {
            vm.Form.objForm.dateOfBirth = new Date(data.dateOfBirth);
            vm.Form.objForm.photoAddress = data.photoAddress;
            if (data.photoAddress && data.photoAddress !== '-') {
                vm.checkPhoto = true;
                vm.PhotoProfile = 'api/empdocument/' + data.photoAddress;
            }
            getCurrentImage(data.photoAddress);
        }

        function goNav(state) {
            $state.go(state, {
                nik: $localStorage.currentNik
            });
            vm.activeItem = state;
            vm.selectedMenu = vm.activeItem;
        }

        function uploadFile() {
            return false;
        }

        function openUploadPhoto(ev) {
            $mdDialog.show({
                controller: 'EditemployeController as vm',
                templateUrl: 'app/main/employee/employe/input-employe/profile/upload-photo.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function getSelectedMenu() {

        }

        // function searchTextChange(searchText) {
        //    vm.Form.objForm.empno = '';
        //    vm.Form.objForm.fullname = '';
        //    vm.isDisabled = false;
        //    vm.Form.objForm.fullname = searchText;
        // }

        function selectedItemChanged(employee) {
            vm.empno = '';
            vm.empid = '';
            vm.fullname = '';
            vm.isDisabled = false;
            if (typeof employee !== 'undefined') {
                vm.empno = employee.empno;
                vm.empid = employee.empid;
                vm.fullname = employee.fullname;
                vm.isDisabled = true;
            }
        }

        function getEmployee(searchText) {
            var company = $localStorage.empsite;
            return $http
                .get(config.api + 'api/employe?action=searchEmployeeData&id=' + searchText + '&company=' + company)
                .then(function (item) {
                     // Map the response object to the data object.
                     if (item.data.length === '') {
                        vm.empno = '';
                        vm.empid = '';
                        vm.fullname = '';
                     }
                     return item.data;
                });
        }

        function jumpToNik(e, formData) {
            $localStorage.currentNik = encodeURIComponent(window.btoa(vm.empno));
            $state.go(vm.selectedMenu, {
                id: encodeURIComponent(window.btoa(vm.empid)),
                nik: encodeURIComponent(window.btoa(vm.empno))
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.correspondence.requirement", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.correspondence.requirement", {
            url: "/requirement",
            views: {
                "content@app": {
                    templateUrl: "app/main/correspondence/requirement/requirement.html",
                    controller: "CorrespondenceRequirementController as vm"
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.correspondence.requirement')
        .controller('CorrespondenceRequirementFormController', Controller);

    Controller.$inject = [
        'AppAPI',
        'Auth',
        '$mdDialog',
        'Form',
        'dialogType',
        'reffData',
        '$timeout'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        dialogType,
        reffData,
        $timeout
    ) {
        var vm = this;
        var Endpoint = AppAPI.Correspondence().administrator;
        vm.loadingProgress = true;
        vm.searchTerm = "";
        vm.create = false;
        vm.update = false;
        vm.setToken = Auth.setToken;
        vm.storeRequest = storeRequest;
        vm.updateRequest = updateRequest;
        vm.hide = hideDialog;
        vm.setToken = Auth.setToken;
        vm.success = false;
        vm.saveProcess = false;
        vm.updateProcess = false;
        vm.dialogType = dialogType;
        vm.reffData = reffData;
        vm.requirements = [];


        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(Endpoint);

        // set form to controller
        vm.Form = Form;

        activate();

        function activate(params) {
            getRequirement();
        }

        function initComponents() {
            vm.create = true;
            if (dialogType == 'edit') {
                setValue(reffData);
                vm.update = true;
                vm.create = false;
            }
            $timeout(function () {
                vm.loadingProgress = false;
            }, 1000);
        }

        function getRequirement() {
            var response = Endpoint.query({
                action: 'getRequirement'
            });
            response.$promise.then(function (data) {
                initComponents();
                vm.requirements = data;
            });
            response.$promise.catch(function (err) {
                vm.requirements = [];
            });
        }

        function setValue(data) {
            vm.Form.objForm.id = data.id;
            vm.Form.objForm.name = data.name;
            vm.Form.objForm.status = data.status;
        }

        function storeRequest(ev, formController) {
            vm.saveProcess = true;
            vm.loadingProgress = true;
            var promise = Form.saveData('storeDataRequestRequirement', formController, Endpoint);
            promise.then(function (data) {
                vm.success = true;
                vm.saveProcess = false;
                vm.loadingProgress = false;
            });
            promise.catch(function (error) {
                vm.success = false;
                vm.saveProcess = false;
                vm.loadingProgress = false;
            });
        }

        function updateRequest(ev, formController) {
            vm.updateProcess = true;
            var promise = Form.saveData('updateDataRequestRequirement', formController, Endpoint);
            promise.then(function (data) {
                vm.success = true;
                vm.updateProcess = false;
            });
            promise.catch(function (error) {
                vm.success = false;
                vm.updateProcess = false;
            });
        }

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("app.correspondence.requestor", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.correspondence.requestor", {
            url: "/requestor",
            views: {
                "content@app": {
                    templateUrl: "app/main/correspondence/requestor/requestor.html",
                    controller: "CorrespondenceRequestorController as vm"
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.correspondence.requestor')
        .controller('CorrespondenceRequestorFormController', Controller);

    Controller.$inject = [
        'AppAPI',
        '$state',
        '$localStorage',
        'Auth',
        '$mdDialog',
        'Form',
        'dialogType',
        'reffData',
        'requestType',
        'countryCodes',
        'requirements',
        'groupUser',
        '$element',
        'isAdmin',
        '$timeout'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $state,
        $localStorage,
        Auth,
        $mdDialog,
        Form,
        dialogType,
        reffData,
        requestType,
        countryCodes,
        requirements,
        groupUser,
        $element,
        isAdmin,
        $timeout
    ) {
        var vm = this;
        var Endpoint = groupUser == 'user' ? AppAPI.Correspondence().requestor : AppAPI.Correspondence().administrator;
        vm.loadingProgress = true;
        vm.requestType = [];
        vm.searchTerm = "";
        vm.create = false;
        vm.update = false;
        vm.clearSearchTerm = clearSearchTerm;
        vm.storeRequest = storeRequest;
        vm.updateRequest = updateRequest;
        vm.tmpTravelStartDate = new Date();
        vm.tmpTravelEndDate = null;
        vm.hide = hideDialog;
        vm.setToken = Auth.setToken;
        vm.success = false;
        vm.saveProcess = false;
        vm.updateProcess = false;
        vm.dialogType = dialogType;
        vm.readOnly = dialogType == 'view';
        vm.reffData = reffData;
        vm.requirements = requirements;
        vm.isAdmin = isAdmin;


        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(Endpoint);

        // set form to controller
        vm.Form = Form;

        initComponents();

        function initComponents() {
            vm.create = true;
            if (dialogType == 'edit' || dialogType == 'view') {
                setValue(reffData);
                vm.update = true;
                vm.create = false;
            }
            vm.requestType = requestType;
            vm.countryCodes = countryCodes;

            $timeout(function () {
                vm.loadingProgress = false;
            }, 1000);
        }

        function setValue(data) {
            vm.Form.objForm.id = data.id;
            vm.Form.objForm.requestor = data.requestor;
            vm.Form.objForm.name = data.name;
            vm.Form.objForm.request_type = data.request_type;
            vm.Form.objForm.travel_destination = data.travel_destination;
            vm.tmpTravelStartDate = data.travel_start_date != '1970-01-01' ? new Date(data.travel_start_date) : new Date();
            vm.tmpTravelEndDate = data.travel_end_date != '1970-01-01' ? new Date(data.travel_end_date) : null;
            vm.Form.objForm.passport = data.passport;
            vm.Form.objForm.requirement = data.requirement;
            vm.Form.objForm.reason = data.reason;
            vm.Form.objForm.finished_at = data.finished_at;
            vm.Form.objForm.administrator = data.administrator;
        }

        function clearSearchTerm() {
            vm.searchTerm = "";
        }

        function storeRequest(ev, formController) {
            vm.saveProcess = true;
            vm.loadingProgress = true;
            if (vm.Form.objForm.request_type > 1) {
                vm.Form.objForm.requirement = "-";
                vm.Form.objForm.reason = "-";
                vm.Form.objForm.finished_at = "1970-01-01 00:00:00";
                vm.Form.objForm.travel_start_date = moment(vm.tmpTravelStartDate).format('YYYY-MM-DD');
                vm.Form.objForm.travel_end_date = moment(vm.tmpTravelEndDate).format('YYYY-MM-DD');
            } else {
                vm.Form.objForm.reason = "-";
                vm.Form.objForm.finished_at = "1970-01-01 00:00:00";
                vm.Form.objForm.travel_destination = "-";
                vm.Form.objForm.travel_start_date = "1970-01-01";
                vm.Form.objForm.travel_end_date = "1970-01-01";
                vm.Form.objForm.passport = "-";
            }
            var promise = Form.saveData('storeRequestData', formController, Endpoint);
            promise.then(function (data) {
                vm.success = true;
                vm.saveProcess = false;
                vm.loadingProgress = false;
            });
            promise.catch(function (error) {
                vm.success = false;
                vm.saveProcess = false;
                vm.loadingProgress = false;
            });
        }

        function updateRequest(ev, formController) {
            vm.updateProcess = true;
            if (vm.Form.objForm.request_type > 1) {
                vm.Form.objForm.requirement = "-";
                vm.Form.objForm.reason = "-";
                vm.Form.objForm.finished_at = "1970-01-01 00:00:00";
                vm.Form.objForm.travel_start_date = moment(vm.tmpTravelStartDate).format('YYYY-MM-DD');
                vm.Form.objForm.travel_end_date = moment(vm.tmpTravelEndDate).format('YYYY-MM-DD');
            } else {
                vm.Form.objForm.reason = "-";
                vm.Form.objForm.finished_at = "1970-01-01 00:00:00";
                vm.Form.objForm.travel_destination = "-";
                vm.Form.objForm.travel_start_date = "1970-01-01";
                vm.Form.objForm.travel_end_date = "1970-01-01";
                vm.Form.objForm.passport = "-";
            }
            var promise = Form.saveData('updateRequest', formController, Endpoint);
            promise.then(function (data) {
                vm.success = true;
                vm.updateProcess = false;
            });
            promise.catch(function (error) {
                vm.success = false;
                vm.updateProcess = false;
            });
        }

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("app.correspondence.decision_letter", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.correspondence.decision_letter", {
            url: "/decision-letter",
            views: {
                "content@app": {
                    templateUrl: "app/main/correspondence/decision-letter/decision-letter.html",
                    controller: "CorrespondenceDecisionLetterController as vm"
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.correspondence.decision_letter')
        .controller('CorrespondenceDecisionFormController', Controller);

    Controller.$inject = [
        'AppAPI',
        'Auth',
        '$mdDialog',
        'Form',
        'dialogType',
        'reffData',
        '$timeout',
        '$http',
        'config'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        dialogType,
        reffData,
        $timeout,
        $http,
        config
    ) {
        var vm = this;
        var Endpoint = AppAPI.Correspondence().administrator;
        vm.loadingProgress = true;
        vm.searchTerm = "";
        vm.create = false;
        vm.update = false;
        vm.setToken = Auth.setToken;
        vm.storeRequest = storeRequest;
        vm.updateRequest = updateRequest;
        vm.hide = hideDialog;
        vm.setToken = Auth.setToken;
        vm.success = false;
        vm.saveProcess = false;
        vm.updateProcess = false;
        vm.dialogType = dialogType;
        vm.reffData = reffData;
        vm.decisionTypeList = [];
        vm.querySearch = querySearch;
        vm.querySearchPosition = querySearchPosition;
        vm.selectedItemChangePosition = selectedItemChangePosition;
        vm.selectedItemChange = selectedItemChange;
        vm.searchText = '';
        vm.selectedNik = null;
        vm.selectedPosition = null;
        vm.searchTextPosition = '';
        vm.grades = ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A'];
        vm.subArea = [];
        vm.allowDate = false;
        vm.allowEffectiveDate = false;
        vm.allowSubArea = false;
        vm.allowGradeTarget = false;
        vm.startDate = new Date();
        vm.endDate = moment(vm.endDate).add(1, 'd').toDate();
        vm.effectiveDate = new Date();
        vm.read = false;

        vm.switchAction = switchAction;


        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(Endpoint);

        // set form to controller
        vm.Form = Form;

        activate();

        function activate(params) {
            getDecisionType();
        }

        function initComponents() {
            getSubArea();
            vm.create = true;
            if (dialogType == 'view') {
                setValue(reffData);
                vm.update = false;
                vm.create = false;
                vm.read = true;
            }
            $timeout(function () {
                vm.loadingProgress = false;
            }, 1000);
        }

        function getDecisionType() {
            var response = Endpoint.query({
                action: 'getDataDecisionType',
                type: 'promosi'
            });
            response.$promise.then(function (data) {
                initComponents();
                vm.decisionTypeList = data;
            });
            response.$promise.catch(function (err) {
                vm.decisionTypeList = [];
            });
        }

        function getSubArea() {
            var response = Endpoint.query({
                action: 'getDataSubArea'
            });
            response.$promise.then(function (data) {
                vm.subArea = data;
            });
            response.$promise.catch(function (err) {
                vm.subArea = [];
            });
        }

        function setValue(data) {
            vm.Form.objForm.id = data.id;
            vm.Form.objForm.decision_type = {
                'id': data.decision_type,
                'name': data.decision_type_name,
                'code': data.decision_type_code,
                'description': data.decision_type_description,
                'type': data.decision_type_type
            }
            vm.Form.objForm.name = data.name;
            vm.Form.objForm.status = data.status;
            vm.selectedPosition = {
                'description': data.position_new
            };
            vm.Form.objForm.grade_new = data.grade_new;
            vm.Form.objForm.grade_target = data.grade_target;
            vm.startDate = new Date(data.start_date);
            vm.endDate = new Date(data.end_date);
            vm.effectiveDate = new Date(data.effective_date);
            vm.selectedEmployee = {
                "nik": data.nik,
                "name": data.name,
                "grade": data.grade_old,
                "org_unit": data.org_unit,
                "job_title": data.position_old,
                "sub_area_name": data.sub_area_name
            }
            vm.Form.objForm.location = data.location;
        }


        function switchAction(decisionType) {
            console.log(decisionType);
            switch (decisionType.code) {
                case 'promosi-extend':
                    vm.allowEffectiveDate = false;
                    vm.allowDate = true;
                    vm.allowSubArea = false;
                    vm.allowGradeTarget = true;
                    break;
                case 'promosi-lanjutan':
                    vm.allowEffectiveDate = false;
                    vm.allowDate = true;
                    vm.allowSubArea = false;
                    vm.allowGradeTarget = true;
                    break;
                case 'promosi-lulus':
                    vm.allowEffectiveDate = true;
                    vm.allowDate = false;
                    vm.allowSubArea = false;
                    vm.allowGradeTarget = false;
                    break;
                case 'promosi-tetap':
                    vm.allowEffectiveDate = true;
                    vm.allowDate = false;
                    vm.allowSubArea = true;
                    vm.allowGradeTarget = false;
                    break;
            }
        }

        function storeRequest(ev, formController) {
            makePayloads(vm.Form.objForm.decision_type.code);
            vm.saveProcess = true;
            vm.loadingProgress = true;
            var promise = Form.saveData('storeDataDecision', formController, Endpoint);
            promise.then(function (data) {
                vm.success = true;
                vm.saveProcess = false;
                vm.loadingProgress = false;
            });
            promise.catch(function (error) {
                vm.success = false;
                vm.saveProcess = false;
                vm.loadingProgress = false;
            });
        }

        function makePayloads(type) {

            var tempEffectiveDate = angular.copy(vm.effectiveDate);
            var tempStartDate = angular.copy(vm.startDate);
            var tempEndDate = angular.copy(vm.endDate);
            switch (type) {
                case 'promosi-extend':
                case 'promosi-lanjutan':
                    vm.Form.objForm.start_date = moment(tempStartDate).format('YYYY-MM-DD');
                    vm.Form.objForm.end_date = moment(tempEndDate).format('YYYY-MM-DD');
                    break;
                case 'promosi-lulus':
                case 'promosi-tetap':
                    vm.Form.objForm.effective_date = moment(tempEffectiveDate).format('YYYY-MM-DD');
                    break;
            }
        }

        function updateRequest(ev, formController) {
            vm.updateProcess = true;
            var promise = Form.saveData('updateDataRequestRequirement', formController, Endpoint);
            promise.then(function (data) {
                vm.success = true;
                vm.updateProcess = false;
            });
            promise.catch(function (error) {
                vm.success = false;
                vm.updateProcess = false;
            });
        }

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }

        function querySearch(params) {
            return $http
                .get(config.api + 'api/correspondence/correspondenceadmin?action=getDataEmployee&search=' + params)
                .then(function (item) {
                    return item.data;
                });
        }

        function selectedItemChange(item) {
            if (item) {
                vm.selectedNik = item;
                vm.Form.objForm.nik = item.nik;
                vm.Form.objForm.org_unit = item.org_unit;
                vm.Form.objForm.grade_old = item.grade;
                vm.Form.objForm.grade_last = item.grade;
                vm.Form.objForm.position_old = item.job_title;
                vm.Form.objForm.sub_area_id = item.sub_area_id;
                vm.Form.objForm.sub_area_name = item.sub_area_name;

                var existingIndex = vm.grades.indexOf(item.grade);

                if (dialogType == 'create') {
                    switch (vm.Form.objForm.decision_type.code) {
                        case 'promosi-extend':
                            vm.Form.objForm.grade_new = item.grade;
                            if (existingIndex != -1) {
                                vm.Form.objForm.grade_target = vm.grades[existingIndex + 3];
                            }
                            break;
                        case 'promosi-lanjutan':
                            if (existingIndex != -1) {
                                vm.Form.objForm.grade_new = vm.grades[existingIndex + 3];
                                vm.Form.objForm.grade_target = vm.grades[existingIndex + 3];
                            }
                            break;
                        case 'promosi-lulus':
                            if (existingIndex != -1) {
                                vm.Form.objForm.grade_new = vm.grades[existingIndex + 3];
                            }
                            break;
                        case 'promosi-tetap':
                            vm.Form.objForm.grade_new = item.grade;
                            vm.Form.objForm.location = getEmployeeSubArea(vm.subArea, item.sub_area_id);
                            vm.selectedPosition = item.job_title;
                            vm.Form.objForm.position_new = item.job_title;
                            break;
                    }

                }
                console.log('selectedChange', vm.Form.objForm);
            }
        }

        function getEmployeeSubArea(pool, id) {
            var response = {};
            for (var i = 0; i < pool.length; i++) {
                if (pool[i].id == id) {
                    response = pool[i].description;
                    break;
                }
            }
            return response;
        }

        function querySearchPosition(params) {
            return $http
                .get(config.api + 'api/correspondence/correspondenceadmin?action=getDataPosition&search=' + params)
                .then(function (item) {
                    return item.data;
                });
        }

        function selectedItemChangePosition(item) {
            if (item) {
                vm.selectedPosition = item;
                vm.Form.objForm.position_new = item.description;
            }
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("app.correspondence.assignment_letter", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.correspondence.assignment_letter", {
            url: "/assignment-letter",
            views: {
                "content@app": {
                    templateUrl: "app/main/correspondence/assignment-letter/assignment-letter.html",
                    controller: "CorrespondenceAssignmentLetterController as vm"
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.correspondence.assignment_letter')
        .controller('CorrespondenceAssignmentFormController', Controller);

    Controller.$inject = [
        'AppAPI',
        'Auth',
        '$mdDialog',
        'Form',
        'dialogType',
        'reffData',
        '$timeout',
        '$http',
        'config'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        dialogType,
        reffData,
        $timeout,
        $http,
        config
    ) {
        var vm = this;
        var Endpoint = AppAPI.Correspondence().administrator;
        vm.loadingProgress = true;
        vm.searchTerm = "";
        vm.create = false;
        vm.update = false;
        vm.setToken = Auth.setToken;
        vm.storeRequest = storeRequest;
        vm.updateRequest = updateRequest;
        vm.hide = hideDialog;
        vm.setToken = Auth.setToken;
        vm.dialogType = dialogType;
        vm.reffData = reffData;
        vm.decisionTypeList = [];
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchText = '';
        vm.grades = ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A'];
        vm.subArea = [];
        vm.startDate = new Date();
        vm.endDate = moment(vm.endDate).add(1, 'd').toDate();
        vm.effectiveDate = new Date();
        vm.read = false;
        vm.employeeLists = [];
        vm.getSubArea = getSubArea;
        vm.removeItem = removeItem;
        vm.isErrorEmployee = false;


        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(Endpoint);

        // set form to controller
        vm.Form = Form;

        activate();

        function activate(params) {
            getDecisionType();
        }

        function initComponents() {
            vm.create = true;
            if (dialogType == 'view') {
                setValue(reffData);
                vm.update = false;
                vm.create = false;
                vm.read = true;
            }
            $timeout(function () {
                vm.loadingProgress = false;
            }, 1000);
        }

        function getDecisionType() {
            var response = Endpoint.query({
                action: 'getDataDecisionType',
                type: 'penugasan'
            });
            response.$promise.then(function (data) {
                initComponents();
                vm.decisionTypeList = data;
            });
            response.$promise.catch(function (err) {
                vm.decisionTypeList = [];
            });
        }

        function getSubArea() {
            var response = Endpoint.query({
                action: 'getDataSubArea'
            });
            response.$promise.then(function (data) {
                vm.subArea = data;
            });
            response.$promise.catch(function (err) {
                vm.subArea = [];
            });
        }

        function setValue(data) {
            getSubArea();
            vm.Form.objForm.id = data.id;
            vm.Form.objForm.decision_type = {
                'id': data.decision_type,
                'name': data.decision_type_name,
                'code': data.decision_type_code,
                'description': data.decision_type_description,
                'type': data.decision_type_type
            }
            vm.Form.objForm.status = data.status;
            vm.startDate = new Date(data.start_date);
            vm.endDate = new Date(data.end_date);
            vm.employeeLists = data.employeeLists;
            vm.Form.objForm.location = data.location;
        }

        function storeRequest(ev, formController) {
            makePayloads();
            vm.saveProcess = true;
            vm.loadingProgress = true;
            var promise = Form.saveData('storeDataDecision', formController, Endpoint);
            promise.then(function (data) {
                vm.success = true;
                vm.saveProcess = false;
                vm.loadingProgress = false;
            });
            promise.catch(function (error) {
                vm.success = false;
                vm.saveProcess = false;
                vm.loadingProgress = false;
            });
        }

        function makePayloads() {
            var tempStartDate = angular.copy(vm.startDate);
            var tempEndDate = angular.copy(vm.endDate);

            if (vm.employeeLists.length > 1) {
                vm.Form.objForm.decision_type = findDataOnObj(vm.decisionTypeList, 'penugasan-multiple');
            } else {
                vm.Form.objForm.decision_type = findDataOnObj(vm.decisionTypeList, 'penugasan-single');
            }

            vm.Form.objForm.employeeLists = vm.employeeLists;
            vm.Form.objForm.start_date = moment(tempStartDate).format('YYYY-MM-DD');
            vm.Form.objForm.end_date = moment(tempEndDate).format('YYYY-MM-DD');
        }

        function findDataOnObj(pool, keyword) {
            var response = {};
            for (var i = 0; i < pool.length; i++) {
                if (pool[i].code == keyword) {
                    response = pool[i];
                    break;
                }
            }
            return response;
        }

        function updateRequest(ev, formController) {
            vm.updateProcess = true;
            var promise = Form.saveData('updateDataRequestRequirement', formController, Endpoint);
            promise.then(function (data) {
                vm.success = true;
                vm.updateProcess = false;
            });
            promise.catch(function (error) {
                vm.success = false;
                vm.updateProcess = false;
            });
        }

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }

        function querySearch(params) {
            return $http
                .get(config.api + 'api/correspondence/correspondenceadmin?action=getDataEmployee&search=' + params)
                .then(function (item) {
                    return item.data;
                });
        }

        function selectedItemChange(item) {
            if (item) {
                vm.isErrorEmployee = false;
                vm.employeeLists.push(item);
            }
        }

        function removeItem(item) {
            var exists = vm.employeeLists.map(function (e) {
                return e.nik;
            }).indexOf(item.nik);

            if (exists !== -1) {
                vm.employeeLists.splice(exists, 1);
            }
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.type-shift-matrix', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_type_shift_matrix', {
                url    : '/cb/type-shift-matrix',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/type-shift-matrix/index.html',
                        controller : 'TypeShiftMatrixController as vm'
                    }
                }
            });
      
    }
})(); 
(function() {
  'use strict';
  angular
    .module('app.cb.type-shift-matrix')
    .controller('UploadTypeShiftMatrixController', UploadTypeShiftMatrixController);

  UploadTypeShiftMatrixController.$inject = [
    '$state',
    '$mdDialog',
    'config',
    '$localStorage',
    '$timeout',
    'AppAPI',
    'Auth',
    'FileUploader',
    '$location',
    '$window'
  ];
  /** @ngInject */
  function UploadTypeShiftMatrixController(
    $state,
    $mdDialog,
    config,
    $localStorage,
    $timeout,
    AppAPI,
    Auth,
    FileUploader,
    $location,
    $window
    ) {
    
    var vm = this;

    // vm.uploadCutOffStateSuccess = false;
    // vm.uploadCutOffStateError = false;
    // vm.dialogClose = dialogClose;

    vm.notif = {
        success: false,
        error: false
      }
    vm.messageTheme=''

    vm.closeModal=closeModal;
    vm.ExportToExcel = ExportToExcel

    vm.FileUploaderMatrix = new FileUploader({
      url: config.api + 'api/typeshiftmatrix/upload',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
          action: 'upload'
      }],
      onAfterAddingAll: function() {
        // vm.uploadCutOffStateSuccess = false;
        // vm.uploadCutOffStateError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUploaderMatrix.onSuccessItem = function(fileItem, response, status) {

      if ( response.status == 0 ) {
          vm.notif.error = response.pesan;
          vm.notif.success = false;
          vm.messageTheme='pink';
        } else {
          vm.notif.error = false;
          vm.notif.success = response.pesan;
          vm.messageTheme='green';
          data.$setPristine();
        }
      
      $timeout(function() {
        vm.notif.error=false; 
        vm.notif.success=false; 
      }, 6000);

    };
    
    vm.FileUploaderMatrix.onErrorItem = function(res) {
      vm.notif.error = 'Upload data has been failed.';
      vm.notif.success = false;
      vm.messageTheme='pink';

      $timeout(function() {
        vm.notif.error=false; 
        vm.notif.success=false; 
      }, 6000);

    };

    function closeModal() {
      $mdDialog.hide();
    }

    function ExportToExcel() 
    {
      var token=Auth.setTokenPromise();
      token.then(function(data){
              var protocol=$location.protocol();
              var host=$location.host();
             $window.open(protocol+'://'+host+'/'+config.api+'api/typeshiftmatrix/downloadTemplate ', '_blank');
      },function(){
  
          $window.alert('gagal load token');
      });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.type-shift-matrix')
        .controller('EditTypeShiftMatrixController', EditTypeShiftMatrixController);


    EditTypeShiftMatrixController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$log','$localStorage','Form','$timeout','data'];
    /** @ngInject */
    function EditTypeShiftMatrixController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$log,$localStorage,Form,$timeout,data)
    {

      var vm = this;
      // initial form
      Form.initialForm();
      var TypeShiftMatrix=AppAPI.TypeShiftMatrix(); 
      
      // set constructor form
      Form.setObject(TypeShiftMatrix);

      // set form to controller
      vm.Form = Form; 
      vm.closeModal=closeModal;
      vm.saveData=saveData;
      vm.setToken=Auth.setToken;

      vm.notif = {
          success: false,
          error: false
        }
      vm.messageTheme=''

      ///////////////////

      setData();

      function setData()
      {
        vm.Form.objForm.id = data.id
        vm.Form.objForm.nik = data.nik
        vm.Form.objForm.date_off = new Date(data.date_off);
      }
      
      function closeModal() {
        $mdDialog.hide();
      }

      function saveData(ev,data) {
        angular.element.blockUI();
        var promise= Form.saveData('update',data, TypeShiftMatrix);
          promise.then(function(response){
              if ( response.status == 0 ) {
                vm.notif.error = response.pesan;
                vm.notif.success = false;
                vm.messageTheme='pink';
              } else {
                vm.notif.error = false;
                vm.notif.success = response.pesan;
                vm.messageTheme='green';
                data.$setPristine();
              }
            
            $timeout(function() {
              vm.notif.error=false; 
              vm.notif.success=false; 
            }, 6000);
            angular.element.unblockUI();
          })
          .catch(function (response) {
            vm.notif.error = 'Internal server error'
            vm.notif.success = false;
            vm.messageTheme='pink';
            angular.element.unblockUI();
          });
      }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.type-shift-matrix')
        .controller('CreateTypeShiftMatrixController', CreateTypeShiftMatrixController);


    CreateTypeShiftMatrixController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$log','$localStorage','Form','$timeout'];
    /** @ngInject */
    function CreateTypeShiftMatrixController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$log,$localStorage,Form,$timeout)
    {

      var vm = this;
      // initial form
      Form.initialForm();
      var TypeShiftMatrix=AppAPI.TypeShiftMatrix(); 
      
      // set constructor form
      Form.setObject(TypeShiftMatrix);

      // set form to controller
      vm.Form = Form; 
      vm.closeModal=closeModal;
      vm.saveData=saveData;
      vm.setToken=Auth.setToken;

      vm.notif = {
          success: false,
          error: false
        }
      vm.messageTheme=''
      
      ///////////////////

      function closeModal() {
        $mdDialog.hide();
      }

      function saveData(ev,data) {
        angular.element.blockUI();
        var promise= Form.saveData('save',data, TypeShiftMatrix);
          promise.then(function(response){
              if ( response.status == 0 ) {
                vm.notif.error = response.pesan;
                vm.notif.success = false;
                vm.messageTheme='pink';
              } else {
                vm.notif.error = false;
                vm.notif.success = response.pesan;
                vm.messageTheme='green';
                data.$setPristine();
              }
            
            $timeout(function() {
              vm.notif.error=false; 
              vm.notif.success=false; 
            }, 6000);
            angular.element.unblockUI();
          })
          .catch(function (response) {
            vm.notif.error = 'Internal server error'
            vm.notif.success = false;
            vm.messageTheme='pink';
            angular.element.unblockUI();
          });
      }

    }
})();

(function()
{
	angular
		.module('app.cb.sic.input-sic', [])
		.config(config);
		
	config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
	  /** @ngInject */
   /** @ngInject */
    
	function config($stateProvider, $translatePartialLoaderProvider)
	{
		$stateProvider
			.state('app.cb_sic_input-sic', {
				url : '/cb/store-incharge/input-sic',
				views : {
					'content@app' : {
						templateUrl : 'app/main/cb/store-incharge/input-sic/input-sic.html',
						controller	: 'InputsicController as vm'
					}
				}
			})
		
		$stateProvider
			.state('app.cb_sic_edit-sic', {
				url : '/cb/store-incharge/edit-sic/:id',
				views : {
					'content@app' : {
						templateUrl : 'app/main/cb/store-incharge/input-sic/input-sic.html',
						controller	: 'EditsicController as vm'
					}
				}
			})
	}
})();
(function () {
    'use strict';

    angular
        .module('app.cb.sic.input-sic')
        .controller('InputsicController', InputsicController);

    InputsicController.$inject = ['$state', '$stateParams', '$localStorage', '$timeout', 'Form', 'AppAPI', 'Auth'];
    /** @ngInject */
    function InputsicController($state, $stateParams, $localStorage, $timeout, Form, AppAPI, Auth) {
        var vm = this;

        // initial form
        Form.initialForm();

        var StoreIncharge = AppAPI.StoreIncharge();

        // set constructor form
        Form.setObject(StoreIncharge);

        // set form to controller
        vm.Form = Form

        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [{
                link: 'app.cb.store-incharge',
                name: 'SM',
                active: '0'
            },
            {
                link: '#',
                name: 'Input SM',
                active: '0'
            }
        ];

        vm.saveData = saveData;
        vm.back = back;
        vm.edit = false;

        vm.clearMessage = clearMessage;
        vm.reloadToken = reloadToken;

        loadSubArea();

        function saveData(ev, formController) {
            angular.element.blockUI(); //untuk nampilin loading animation

            var formLast = angular.copy(vm.Form.objForm);
            vm.Form.objForm.sic_effective_date_parsed = formController['sic_effective_date'].$viewValue;

            var response = Form.saveData('save', formController, StoreIncharge);

            response.then(function (data) {
                vm.Form.objForm = formLast;
                angular.element.unblockUI();
                showDialog(vm.Form.pesan, ev);
            });

            response.catch(function () {
                angular.element.unblockUI();
                showDialogFailed(vm.Form.pesan, ev);
            });
        }

        function showDialog(message, ev) {
            $mdDialog.show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save')
                    .textContent(message)
                    .ariaLabel('Success Save')
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    $state.go('app.cb_store-incharge', {});
                });
        }

        function showDialogFailed(message, ev) {
            $mdDialog.show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save')
                    .textContent(message)
                    .ariaLabel('Failed Save')
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    Auth.setToken();
                });
        }


        function clearMessage() {
            vm.Form.tampilPesan = false;
        }

        function reloadToken() {
            Auth.setToken();
        }

        function back() {
            $state.transitionTo('app.cb_store-incharge');
        }

        function loadSubArea() {
            var response = StoreIncharge.query({
                action: 'viewSubArea'
            });

            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.sic.input-sic')
        .controller('EditsicController', EditsicController);

    EditsicController.$inject = ['$state', '$stateParams', '$localStorage', '$log', '$timeout', 'Form', 'AppAPI', 'Auth', '$mdDialog'];
    /** @ngInject */
    function EditsicController($state, $stateParams, $localStorage, $log, $timeout, Form, AppAPI, Auth, $mdDialog) {
        var vm = this;

        // initial form
        Form.initialForm(false);

        var StoreIncharge = AppAPI.StoreIncharge();
        vm.listModulSelected = [];
        // set constructor form
        Form.setObject(StoreIncharge);

        // set form to controller
        vm.Form = Form

        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [{
                link: 'app.cb.store-incharge',
                name: 'SIC',
                active: '0'
            },
            {
                link: '#',
                name: 'Edit SIC',
                active: '0'
            }
        ];

        angular.element.blockUI();
        var response = vm.Form.objForm.$get({
            action: 'detailEdit',
            id: $stateParams.id
        });

        response.then(function (data) {
            vm.Form.objForm.sic_effective_date = new Date(data.sic_effective_date);
            loadSubArea();
        });

        response.catch(function () {
            vm.messageTheme = 'pink';
            angular.element.unblockUI();
        });

        vm.saveData = saveData;
        vm.back = back;
        vm.edit = true;

        vm.clearMessage = clearMessage;
        vm.reloadToken = reloadToken;

        function saveData(ev, formController) {
            angular.element.blockUI(); //untuk nampilin loading animation

            var formLast = angular.copy(vm.Form.objForm);
            vm.Form.objForm.sic_effective_date_parsed = formController['sic_effective_date'].$viewValue;

            var response = Form.saveData('update', formController, StoreIncharge);

            response.then(function (data) {
                vm.Form.objForm = formLast;
                angular.element.unblockUI();
                showDialog(vm.Form.pesan, ev);
            });

            response.catch(function () {
                angular.element.unblockUI();
                showDialogFailed(vm.Form.pesan, ev);
            });
        }

        function showDialog(message, ev) {
            $mdDialog.show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save')
                    .textContent(message)
                    .ariaLabel('Success Save')
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    $state.go('app.cb_store-incharge', {});
                });
        }

        function showDialogFailed(message, ev) {
            $mdDialog.show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save')
                    .textContent(message)
                    .ariaLabel('Failed Save')
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    Auth.setToken();
                });
        }

        function clearMessage() {
            vm.Form.tampilPesan = false;
        }

        function reloadToken() {
            Auth.setToken();
        }

        function back() {
            $state.transitionTo('app.cb_store-incharge');
        }

        function loadSubArea() {
            var response = StoreIncharge.query({
                action: 'viewSubArea'
            });

            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
            angular.element.unblockUI();
        }

        function errorfetchArea(data) {
            vm.subArea = [];
            angular.element.unblockUI();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.cb.replacement-holiday', []).config(config);

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.cb_replacement_holiday', {
            url: '/cb/replacement_holiday',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/cb/replacement-holiday/replacement-holiday.html',
                    controller: 'ReplacementHolidayController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.replacement-holiday')
        .controller('ReplacementHolidayUploadController', Controller);

    Controller.$inject = [
        '$state',
        '$localStorage',
        '$document',
        '$http',
        '$scope',
        'config',
        '$log',
        '$mdDialog',
        'AppAPI',
        'Auth',
        'DataService',
        'FileUploader'
    ];
    /** @ngInject */
    function Controller(
        $state,
        $localStorage,
        $document,
        $http,
        $scope,
        config,
        $log,
        $mdDialog,
        AppAPI,
        Auth,
        DataService,
        FileUploader
    ) {
        var vm = this;
        vm.closeModal = closeModal;
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        vm.detailInfo = []
        
        function closeModal() {
            $mdDialog.hide();
        }
        
        vm.FileUpload = new FileUploader({
            url: config.api + 'api/replacement/replaceNationalHoliday',
            removeAfterUpload: true,
            alias: 'fileatt',
            formData: [{
                action: 'upload'
            }],
            onAfterAddingAll: function() {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
            if ( status.status == 0 ) {
                vm.uploadSuccess = false;
                vm.uploadError   = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError   = false;
            }

            vm.uploadNotif = status.pesan
            if ('moreInfo' in status && status.moreInfo.length>0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }
            
            angular.element('#uploadCutOff').val('');
        
        };

        vm.FileUpload.onErrorItem = function() {
            vm.uploadSuccess = false;
            vm.uploadError = true;
        };

        function closeModal()
        {
            $mdDialog.hide();
        }

        function viewMoreInfo()
        {
            $mdDialog.show({
                controller         : 'logFailGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                data:vm.detailInfo
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.passwordecheckingw', ['app.cb.passwordecheckingw.input-password-echeckingw'])
        .config(config);

         config.$inject=['$stateProvider'];

    /** @ngInject */
   /** @ngInject */
   function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.cb_passwordecheckingw', {
                url    : '/cb/passwordecheckingw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/passwordecheckingw/passwordecheckingw.html',
                        controller : 'PasswordecheckingwController as vm'
                    }
                }
            });

       
        

    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.passwordecheckingw')
        .controller('UploadfilegwController', UploadfilegwController);

    UploadfilegwController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadfilegwController($mdDialog,$localStorage,FileUploader,config) {
        var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        ////////////////

       

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/passwordecheckingw/uploadfile', 
           removeAfterUpload:true,
           alias:'file',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.passwordecheckingw.input-password-echeckingw', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State 
    $stateProvider
        .state('app.cb_passwordecheckingw_input-password-echeckingw', {
            url    : '/cb/passwordecheckingw/input-password-echeckingw',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/cb/passwordecheckingw/input-password-echeckingw/input-password-echeckingw.html',
                    controller : 'InputpasswordecheckingwController as vm'
                }
            }
        })

    $stateProvider
        .state('app.cb_passwordecheckingw_edit-password-echeckingw', {
            url    : '/cb/passwordecheckingw/edit-password-echeckingw/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/cb/passwordecheckingw/input-password-echeckingw/input-password-echeckingw.html',
                    controller : 'EditpasswordecheckingwController as vm'
                }
            }
        })
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.cb.passwordecheckingw.input-password-echeckingw')
        .controller('InputpasswordecheckingwController', InputpasswordecheckingwController);


    InputpasswordecheckingwController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputpasswordecheckingwController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var EcheckinPassGw=  AppAPI.EcheckinPassGw();

         // set constructor form
         Form.setObject(EcheckinPassGw);

         // set form to controller
         vm.Form = Form;

        vm.title = ['Mr','Mrs','Miss','Ms'];
        vm.jenkel = ['L','P']; 
       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, EcheckinPassGw);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.cb.passwordecheckingw.input-password-echeckingw')
        .controller('EditpasswordecheckingwController', EditpasswordecheckingwController);


    EditpasswordecheckingwController.$inject=['$state','$localStorage','$log','$stateParams','$timeout','Form','AppAPI'];
    /** @ngInject */
    function EditpasswordecheckingwController($state,$localStorage,$log,$stateParams,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var EcheckinPassGw =  AppAPI.EcheckinPassGw();

         vm.Breadhome="app.cb";
         vm.Breadlist=[
                    {link:'app.cb',name:'CB',active:'0'},
                    {link:'#',name:'Edit Password-Echeckingw',active:'0'}
                    ];

         // set constructor form
         Form.setObject(EcheckinPassGw);

         // set form to controller
         vm.Form = Form;
         vm.title = ['Mr','Mrs','Miss','Ms'];
         vm.jenkel = ['L','P']; 

        var resp=vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
        resp.then(setData)
       
        vm.saveData=saveData;
        vm.back=back;

        vm.clearMeesage=clearMeesage;

        function setData(data)
        {
            
            vm.Form.objForm.ktpOld=data.noktp;
        }

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.updateData('update',formController,EcheckinPassGw,vm.Form.objForm.noktp,'viewdetail');

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             back();
             }, 3000);
         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.cb_passwordecheckingw');
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.cb.overtime.input-overtime', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.cb_overtime_input-overtime', {
                url    : '/cb/overtime/input-overtime',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/overtime/input-overtime/input-overtime.html',
                        controller : 'InputovertimeController as vm'
                    }
                }
            }) 

            


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.cb.overtime.input-overtime')
        .controller('InputovertimeController', InputovertimeController); 
    InputovertimeController.$inject=['$state','$stateParams','$mdDialog','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function InputovertimeController($state,$stateParams,$mdDialog,$localStorage,$timeout,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Overtime=  AppAPI.Overtime();

         // set constructor form
         Form.setObject(Overtime);

         // set form to controller
         vm.Form = Form; 
         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[
                    {link:'app.cb.overtime',name:'Overtime',active:'0'},
                    {link:'#',name:'Input Overtime',active:'0'}
                    ];
        vm.openInputemployeOT = openInputemployeOT;
        var Attendance=AppAPI.Overtime();
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;
        vm.closeModal = closeModal;
        vm.loadDataEmployee=loadDataEmployee;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listDataSelected=[];
        var listEmp=[];
        vm.LoaDemp=LoaDemp;
        vm.checkone=checkone;
        vm.AddemployeSelected=AddemployeSelected;
        vm.Form.objForm.nik=[];
        vm.Form.objForm.empno=[];
        // vm.Form.objForm.reason=[];

        vm.hour=[];
        for(var h=0;h<24;h++){
            if(h<10){
                vm.hour[h]='0'+h; 
            }else{
                vm.hour[h]=h;
            }
        }

        vm.minute=[];
        for(var h=0;h<60;h++){
            if(h<10){
                vm.minute[h]='0'+h; 
            }else{
                vm.minute[h]=h;
            }
        }

        // console.log(vm.minute);
        loadDataBU(); 
       
        vm.saveData=saveData;
        vm.back=back; 
        vm.clearMeesage=clearMeesage;
        vm.reloadToken=reloadToken;
        

        
        
        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Overtime);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function openInputemployeOT(ev)
        {
            $mdDialog.show({
                controller         : 'InputovertimeController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/overtime/input-overtime/input-employeot.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element,removePromise)
                {
                   LoaDemp(vm.listDataSelected);
                },
                onShowing: function (){
                    
                }
            });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        } 

        function back(){
            $state.transitionTo('app.cb_overtime');
        } 

        function loadDataDepartment(iddivisi) {
             var response=Attendance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }
          
          function loadDataDivision(idbu) {
             var response=Attendance.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          } 

          function loadDataBU() {
            var response=Attendance.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }

          function loadDataEmployee()
          {
            var company=vm.company; 
            var divisi=vm.divisi;
            var department=vm.department;

            var response=Attendance.query({action:'searchEmp',company:company,divisi:divisi,department:department});
            response.$promise.then(fetchEmploye);
            response.$promise.catch(errorFetchEmploye);
          }

          function fetchEmploye(data) {
            vm.listEmploye=data;
          }

          function errorFetchEmploye() {
            vm.listEmploye=[];
          }


        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
           vm.listDataSelected=angular.copy(vm.listEmploye);
        }

        function unCheckAll() {
           vm.listDataSelected=[];
        }

        function checkone(emp) {
            // console.log(emp); 
            emp.isChecked = !emp.isChecked;
        }

        function AddemployeSelected()
        {
            var ls=vm.listDataSelected;
            $.each(ls,function(i,val){
                vm.Form.objForm.nik[i]=ls[i].nik;
                var tr='<tr><td>'+ls[i].nik+'</td> <td>'+ls[i].empname+'</td><td><input type="text" name="reason" ng-model="vm.Form.objForm.reason['+i+']" placeholder="reason"/></td></tr>';
                 angular.element('table#listOT > tbody').append(tr);
            }); 
            closeModal(); 
        }

        function LoaDemp(listEmp)
        {
            vm.listEmpSelected=listEmp;
        }
    }
})();  

(function() {
  'use strict';

  angular
      .module('app.cb.nationalholiday.input-national-holiday', [])
      .config(config);

  config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
  /** @ngInject */
  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
      // State
      $stateProvider.state('app.cb_nationalholiday_input-national-holiday', {
          url: '/cb/nationalholiday/input',
          views: {
              'content@app': {
                  templateUrl: 'app/main/cb/national-holiday/input-national-holiday.html',
                  controller: 'InputNationalHolidayController as vm'
              }
          }
      });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.cb.nationalholiday.input-national-holiday')
    .controller('InputNationalHolidayController', InputNationalHolidayController);

  InputNationalHolidayController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$mdToast',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'items',
    'loadData'
  ];
  /** @ngInject */
  function InputNationalHolidayController(
    DataService,
    $state,
    $mdDialog,
    $mdToast,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    items,
    loadData
  ) {
    var vm = this;
    var ApiHoliday = AppAPI.NationalHoliday();
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.selected = items;
    vm.dialogClose = dialogClose;
    vm.saveDataHoliday = saveDataHoliday;
    vm.Form = Form;
    vm.locationSelected = [];
    activate();

    function activate() {
      vm.selected = [];
      vm.items = items;
      Form.initialForm();
      Form.setObject(ApiHoliday);
    }

    vm.toggle = function (item, list) {
      var idx = vm.locationSelected.indexOf(item);
      if (idx > -1) {
        vm.locationSelected.splice(idx, 1);
      }
      else {
        vm.locationSelected.push(item);
      }
      console.log(vm.locationSelected);

    };

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.exists = function (item, list) {
      return vm.locationSelected.indexOf(item) > -1;
    };

    vm.isIndeterminate = function () {
      return (vm.locationSelected.length !== 0 &&
        vm.locationSelected.length !== vm.items.length);
    };

    function isChecked() {
      return vm.locationSelected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.locationSelected.length === vm.items.length) {
        vm.locationSelected = [];
      } else if (vm.locationSelected.length === 0 || vm.locationSelected.length > 0) {
        vm.locationSelected = vm.items.slice(0);
      }

      console.log(vm.locationSelected);

    }

    function saveDataHoliday(ev, formController) {
      angular.element.blockUI();
      var selectedSubArea = [];

      if (vm.locationSelected.length == vm.items.length) {
        selectedSubArea[0] = '0';
      } else {
        for (var index = 0; index < vm.locationSelected.length; index++) {
          if (vm.locationSelected[index].sub_area_id != 0) {
            selectedSubArea.push(vm.locationSelected[index].id);
          }
        }
      }

      console.log(selectedSubArea);

      vm.Form.objForm.subarea = selectedSubArea;
      vm.Form.objForm.tanggal = formController.holidaydate.$viewValue;
      vm.Form.objForm.deskripsi = formController.holidayname.$viewValue;
      var response = Form.saveData('saveDataHoliday', formController, ApiHoliday);
      response.then(function (data) {
        angular.element.unblockUI();
        formController.$setPristine();
        showDialogSuccess(ev, data);
        vm.selected = [];
        loadData(1);
      });

      response.catch(function (data) {
        showDialogFailed(ev, data);
        angular.element.unblockUI();
        vm.selected = [];
        loadData(1);
      });

      function showDialogFailed(ev, data) {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Failed Save Data')
              .textContent(data.pesan)
              .ariaLabel('Failed Save Data')
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function () {
            dialogClose();
            loadData(1);
          });
        console.log(data);
      }

      function showDialogSuccess(ev, data) {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Success Save Data')
              .textContent(data.pesan)
              .ariaLabel('Failed Save Data')
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function () {
            dialogClose();
            loadData(1);
          });
        console.log(data);
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.leavehold.update-leave-hold', [])
        .config(config);

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.cb_leavehold_update-leave-hold', {
            url: '/cb/leavehold/update-leave-hold',
            views: {
                'content@app': {
                    templateUrl: 'app/main/cb/leavehold/update-leave-hold/update-leave-hold.html',
                    controller: 'UpdateLeaveHoldController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.cb.leavehold.update-leave-hold')
        .controller('UpdateLeaveHoldController', UpdateLeaveHoldController);

    UpdateLeaveHoldController.$inject = [
        'DataService',
        '$state',
        '$mdDialog',
        '$localStorage',
        '$window',
        '$timeout',
        'AppAPI',
        'Auth',
        'Form',
        'dataUpdate'
    ];
    /** @ngInject */
    function UpdateLeaveHoldController(
        DataService,
        $state,
        $mdDialog,
        $localStorage,
        $window,
        $timeout,
        AppAPI,
        Auth,
        Form,
        dataUpdate
    ) {
        var vm = this;
        var EMP = AppAPI.Employe();
        var Attendancereport = AppAPI.Attendancereport();
        var LeaveHold = AppAPI.LeaveHold();
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.items = [];
        vm.divisi = 'all';
        vm.department = 'all';
        vm.updateLeaveHold = updateLeaveHold;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;
        vm.company = $localStorage.empsite;
        vm.user = $localStorage.user;
        vm.selected = [];
        vm.dataUpdate = dataUpdate;
        vm.dialogClose = dialogClose;

        Form.initialForm();
        Form.setObject(LeaveHold);
        vm.Form = Form;

        activate();

        function activate() {
            loadDataBU();
            loadDataDivision(vm.company);
            loadSubArea();
            loadData(1);
            minDate();
            vm.startdate = new Date(dataUpdate.start_date);
            vm.enddate = new Date(dataUpdate.end_date);
            vm.selectedSubarea = dataUpdate.sub_area_id;
            vm.description = dataUpdate.description;
        }

        function updateLeaveHold(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.subarea = formController.subarea.$viewValue;
            vm.Form.objForm.start = formController.startdate.$viewValue;
            vm.Form.objForm.end = formController.enddate.$viewValue;
            vm.Form.objForm.description = formController.description.$viewValue;
            vm.Form.objForm.id          = dataUpdate.id;
            var response = Form.saveData('updateDataGroupLeaveHold', formController, LeaveHold);
            response.then(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                showDialogSuccess(ev, data);
            });

            response.catch(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                showDialogFailed(ev, data);
            });
        }

        function loadData(pageno) {
            var resp = vm.DataTables.loadData(LeaveHold, pageno, {
                action: 'viewDataLeaveHold',
                company: vm.company,
                department: vm.department,
                divisi: vm.divisi
            });

            resp.then(function(data) {
                vm.items = data.list;
                vm.selected = [];
            });
        }

        function reloadToken() {
            Auth.setToken();
        }

        function showDialogSuccess(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Success Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Success Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    dialogClose();
                });
        }

        function showDialogFailed(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Failed Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetcDataNikEmployee(data) {
            vm.empSubareaList = data;
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = Attendancereport.query({ action: 'viewSubArea' });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        function minDate() {
            var response = LeaveHold.query({
                action: 'viewTimeServer'
            });
            response.$promise.then(fetchDataMinDate);
        }

        function fetchDataMinDate(data) {
            var time = new Date(data[0].date);
            vm.HoldMinDate = time;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.leavehold.input-leave-hold', [])
        .config(config);

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.cb_leavehold_input-leave-hold', {
            url: '/cb/leavehold/input-leave-hold',
            views: {
                'content@app': {
                    templateUrl: 'app/main/cb/leavehold/input-leave-hold/input-leave-hold.html',
                    controller: 'InputLeaveHoldController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.cb.leavehold.input-leave-hold')
        .controller('InputLeaveHoldController', InputLeaveHoldController);

    InputLeaveHoldController.$inject = [
        'DataService',
        '$state',
        '$mdDialog',
        '$localStorage',
        '$timeout',
        'AppAPI',
        'Auth',
        'loadData',
        'Form'
    ];
    /** @ngInject */
    function InputLeaveHoldController(
        DataService,
        $state,
        $mdDialog,
        $localStorage,
        $timeout,
        AppAPI,
        Auth,
        loadData,
        Form
    ) {
        var vm = this;
        Form.initialForm();

        var EMP = AppAPI.Employe();
        var Attendancereport = AppAPI.Attendancereport();
        var LeaveHold = AppAPI.LeaveHold();
        var HoldDate = new Date();

        Form.setObject(LeaveHold);

        vm.Form = Form;
        vm.empSubarea = empSubarea;
        vm.empSubareaList = {};

        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;

        vm.company = $localStorage.empsite;
        vm.user = $localStorage.user;
        vm.divisi = 'all';
        vm.department = 'all';
        vm.divdeptdisabled = false;
        vm.saveLeaveHold = saveLeaveHold;
        vm.dialogClose = dialogClose;

        activate();

        function activate() {
            loadDataBU();
            loadDataDivision(vm.company);
            loadSubArea();
            minDate();
        }

        function empSubarea(id) {
            var response = LeaveHold.query({
                action: 'viewEmpSubArea',
                id: id
            });
            response.$promise.then(fetcDataNikEmployee);
        }

        function saveLeaveHold(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.subid = formController.subarea.$viewValue;
            vm.Form.objForm.start = formController.startdate.$viewValue;
            vm.Form.objForm.end = formController.enddate.$viewValue;
            vm.Form.objForm.company = formController.company.$viewValue;
            vm.Form.objForm.divisi  = formController.divisi.$viewValue;
            vm.Form.objForm.department = formController.department.$viewValue;
            vm.Form.objForm.description = formController.description.$viewValue;
            var response = Form.saveData('saveDataLeaveHold', formController, LeaveHold);
            response.then(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.pesan)
                        .ariaLabel(data.title)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    loadData(1);
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function minDate() {
            var response = LeaveHold.query({
                action: 'viewTimeServer'
            });
            response.$promise.then(fetchDataMinDate);
        }

        function fetchDataMinDate(data) {
            var time = new Date(data[0].date);
            vm.HoldMinDate = time;
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetcDataNikEmployee(data) {
            vm.empSubareaList = data;
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = Attendancereport.query({ action: 'viewSubArea' });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.leavehold.detail-leave-hold', [])
        .config(config);

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.cb_leavehold_detail-leave-hold', {
            url: '/cb/leavehold/detail-leave-hold',
            views: {
                'content@app': {
                    templateUrl: 'app/main/cb/leavehold/detail-leave-hold/detail-leave-hold.html',
                    controller: 'DetailLeaveHoldController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.cb.leavehold.detail-leave-hold')
        .controller('DetailLeaveHoldController', DetailLeaveHoldController);

    DetailLeaveHoldController.$inject = [
        'DataService',
        '$state',
        '$mdDialog',
        '$localStorage',
        '$timeout',
        'AppAPI',
        'Auth',
        'Form',
        'groupInfo'
    ];
    /** @ngInject */
    function DetailLeaveHoldController(
        DataService,
        $state,
        $mdDialog,
        $localStorage,
        $timeout,
        AppAPI,
        Auth,
        Form,
        groupInfo
    ) {
        var vm = this;
        var LeaveHold = AppAPI.LeaveHold();
        vm.deleteLeavehold = deleteData;
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.items = [];
        vm.selected = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.groupInfo = groupInfo;
        vm.dialogClose = dialogClose;
        // vm.toggleAll = toggleAll;

        activate();

        function activate() {
            loadData(1);
        }

        function loadData(pageno) {
            var resp = vm.DataTables.loadData(LeaveHold, pageno, {
                action: 'viewDataLeaveHold',
                gid   : vm.groupInfo.id
            });

            resp.then(function(data) {
                vm.items = data.list;
                vm.selected = [];
            });
        }

        function reloadToken() {
            Auth.setToken();
        }

        function showDialogSuccess(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Success Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Success Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    dialogClose();
                });
        }

        function deleteData(ev) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent('Data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        var response = ApiHoliday.delete({
                            action: 'deleteDataHoliday',
                            data: angular.toJson(vm.selected)
                        });
                        response.$promise.then(loadData);
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialogFailed(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Failed Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        // Toggle checkbox
        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
        }

        function isChecked() {
            return vm.selected.length === vm.items.length;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.joinholiday.input-join-holiday', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.cb_joinholiday_input-join-holiday', {
                url: '/cb/joinholiday/input-join-holiday',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cb/join-holiday/input-join-holiday/input-join-holiday.html',
                        controller: 'InputJoinHolidayController as vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.cb.joinholiday.input-join-holiday')
        .controller('InputJoinHolidayController', InputJoinHolidayController);

    InputJoinHolidayController.$inject = [
        'DataService',
        '$state',
        '$mdDialog',
        '$mdToast',
        '$localStorage',
        '$window',
        '$timeout',
        'AppAPI',
        'Auth',
        'Form',
        'loadData'
    ];
    /** @ngInject */
    function InputJoinHolidayController(
        DataService,
        $state,
        $mdDialog,
        $mdToast,
        $localStorage,
        $window,
        $timeout,
        AppAPI,
        Auth,
        Form,
        loadData
    ) {
        var vm = this;
        var JoinHoliday = AppAPI.JoinHoliday();
        var EMP = AppAPI.Employe();
        var Attendancereport = AppAPI.Attendancereport();
        var LeaveHold = AppAPI.LeaveHold();
        var HoldDate = new Date();

        Form.initialForm();

        Form.setObject(JoinHoliday);

        vm.Form = Form;
        vm.empSubarea = empSubarea;
        vm.empSubareaList = {};

        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;

        vm.company = $localStorage.empsite;
        vm.user = $localStorage.user;
        vm.divisi = 'all';
        vm.department = 'all';
        vm.divdeptdisabled = false;
        vm.saveDataJoinHoliday = saveDataJoinHoliday;
        vm.dialogClose = dialogClose;

        activate();

        function activate() {
            loadDataBU();
            loadDataDivision(vm.company);
            loadSubArea();
            minDate();
        }

        function empSubarea(id) {
            var response = LeaveHold.query({
                action: 'viewEmpSubArea',
                id: id
            });
            response.$promise.then(fetcDataNikEmployee);
        }

        function saveDataJoinHoliday(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.subid = formController.subarea.$viewValue;
            vm.Form.objForm.start = formController.startdate.$viewValue;
            vm.Form.objForm.end = formController.enddate.$viewValue;
            vm.Form.objForm.company = formController.company.$viewValue;
            vm.Form.objForm.divisi  = formController.divisi.$viewValue;
            vm.Form.objForm.department = formController.department.$viewValue;
            vm.Form.objForm.description = formController.description.$viewValue;
            var response = Form.saveData('saveDataJoinHoliday', formController, JoinHoliday);
            response.then(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function(data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.pesan)
                        .ariaLabel(data.title)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    loadData(1);
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function minDate() {
            var response = LeaveHold.query({
                action: 'viewTimeServer'
            });
            response.$promise.then(fetchDataMinDate);
        }

        function fetchDataMinDate(data) {
            var time = new Date(data[0].date);
            vm.HoldMinDate = time;
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetcDataNikEmployee(data) {
            vm.empSubareaList = data;
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = Attendancereport.query({ action: 'viewSubArea' });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employee-certificates', [])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.cb_employee_certificates', {
                url    : '/cb/employee_certificates',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employee-certificates/employee-certificates.html',
                        controller : 'EmployeeCertificatesController as vm',
                        css: ['app/main/cb/employee-certificates/employee-certificates.scss']
                    }
                }
            })
            .state('app.cb_employee_certificates_configurations', {
                url    : '/cb/employee_certificates_configurations',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employee-certificates/employee-certificates-configurations.html',
                        controller : 'EmployeeCertificatesConfigurationsController as vm'
                    }
                }
            })
            .state('app.cb_employee_certificates_programs', {
                url    : '/cb/employee_certificates_programs',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employee-certificates/employee-certificates-programs.html',
                        controller : 'EmployeeCertificatesProgramsController as vm'
                    }
                }
            });
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.cb.employee-certificates')
        .controller('InputEmployeeCertificatesController', InputEmployeeCertificatesController);


    InputEmployeeCertificatesController.$inject=['$state','$stateParams','$localStorage','$timeout','Form','AppAPI','Auth','$mdDialog','$filter','id','$log'];
    /** @ngInject */
    function InputEmployeeCertificatesController($state,$stateParams,$localStorage,$timeout,Form,AppAPI,Auth,$mdDialog,$filter,id,$log)
    {
        
        var vm = this;

        // initial form
        Form.initialForm(false);
        
        var Certificate = AppAPI.Certificate(); //memanggil api modules dari api
        var Certificateclassrooms = AppAPI.Certificateclassrooms(); //memanggil api modules dari api
        var Certificateprograms = AppAPI.Certificateprograms(); //memanggil api modules dari api

        // set constructor form
        Form.setObject(Certificate);

        vm.Form = Form;

        vm.closeModal = closeModal;

        // set form to controller       
        vm.addPeserta = addPeserta;
        vm.cancelPeserta = cancelPeserta;

        vm.selectedItem = null;
        vm.searchText = null;

        vm.querySearch = querySearch; 
        vm.listEmp = [];
        vm.loading = true;

        vm.searchTextChange = searchTextChange;
        vm.selectedItemChange = selectedItemChange;

        vm.LoadClassrooms = LoadClassrooms;
        vm.lookUpComponents = lookUpComponents;
        vm.listComponents = [];
        vm.listClassrooms = [];

        vm.saveData=saveData;

        vm.state = 'Input';

        if(id) {
            vm.state = 'Edit';            
        }

        vm.old_class_id = null;
        vm.old_program_id = null;
        vm.components = [];

        vm.disableAll = false;
        vm.disableForEdit = false;
        vm.listCurrentComponents = [];
        vm.listDeletedComponents = [];

        angular.element.blockUI();
        
        loadEmp();

        function addPeserta(e) {
            vm.Form.objForm.pesertas.push(angular.copy(initPesertas));
        }
        
        function cancelPeserta(e, idx) {
            if (vm.Form.objForm.pesertas[idx]) {
                if(id) {
                    vm.listDeleted.push(vm.Form.objForm.pesertas[idx].id);
                }

                vm.Form.objForm.pesertas.splice(idx, 1);
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function loadEmp() {
            var response = Certificate.query({
                action: 'getEmployeTeam'
            });
            response.$promise.then(fetchEmp);
            response.$promise.catch(errorFetchEmp);
        }

        function fetchEmp(data) {
            vm.listEmp = data;
            vm.loading = false;

            LoadProgram();
        }

        function errorFetchEmp() {
            vm.listEmp = [];
            vm.loading = false;
        }

        function querySearch (query) {
            var results = query ? vm.listEmp.filter(createFilterFor(query)) : vm.listEmp,
            deferred;
            if (self.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(item) {
                var nik = item.nik;
                var nama = item.nama.toLowerCase();
                
                return (nik.indexOf(lowercaseQuery) === 0) || (nama.indexOf(lowercaseQuery) >= 0);
            };

        }

        function searchTextChange(text) {
            $log.info('Text changed to ' + text);
        }

        function selectedItemChange(item) {
            vm.Form.objForm.nik = item.nik;
            vm.Form.objForm.employee = item;

        }

        function LoadProgram() {
            var response = Certificateprograms.query({
                action: 'getPrograms',
                country: 'all'
            });
            response.$promise.then(fetchProgram);
            response.$promise.catch(errorFetchProgram);
        }

        function fetchProgram(data) {
            vm.listPrograms = data;

            if(id) {
                var responseDetail = vm.Form.objForm.$get({ action: 'viewDetail', id: id, form: 1});
                responseDetail.then(function(data) {
                    vm.Form.objForm.id = id;

                    vm.Form.objForm.start_date = new Date(vm.Form.objForm.start_date);
                    vm.Form.objForm.end_date = new Date(vm.Form.objForm.end_date);

                    vm.Form.objForm.id_program = data.old_program_id;
                    vm.Form.objForm.old_id_program = data.old_program_id;
                    vm.Form.objForm.old_id_class = data.old_class_id;

                    vm.old_program_id = data.old_program_id;
                    vm.old_class_id = data.old_class_id;
                    vm.components = data.components;

                    if(data.approval_status != '0' && data.approval_status != '1') {
                        vm.disableAll = true;
                    } else {
                        vm.disableForEdit = true;
                    }

                    for (var i = 0; i < vm.listEmp.length; i++) {
                        if(vm.listEmp[i].nik == data.nik) {
                            vm.selectedItem = vm.listEmp[i];
                        }
                    }

                    LoadClassrooms(data.old_program_id);

                    angular.element.unblockUI();
                });

                responseDetail.catch(function() {
                    $mdDialog
                        .show(
                            $mdDialog
                            .alert()
                            .parent(angular.element(document.querySelector('#contentDialog')))
                            .clickOutsideToClose(true)
                            .title('Failed')
                            .textContent('Failed Get Data')
                            .ariaLabel('Failed')
                            .ok('OK')
                            .targetEvent(ev)
                            )
                        .then(function () {
                            closeModal();
                            angular.element.unblockUI();
                        });
                });
            } else {
                angular.element.unblockUI();
            }
        }

        function errorFetchProgram() {
            vm.listPrograms = [];
            angular.element.unblockUI();
        }

        function LoadClassrooms(idProgram) {
            angular.element.blockUI();
            vm.listClassrooms = [];
            vm.listComponents = [];

            if(id) {
                if(idProgram != vm.old_program_id) {
                    vm.listDeletedComponents = vm.components;
                } else {
                    vm.listDeletedComponents = [];
                }
            }

            var response = Certificateclassrooms.query({
                action: 'getClassrooms',
                id_program: idProgram
            });
            response.$promise.then(fetchClassrooms);
            response.$promise.catch(errorFetchClassrooms);
        }

        function fetchClassrooms(data) {
            vm.listClassrooms = data;

            if(id) {
                for(var i=0;i < vm.listClassrooms.length; i++) {
                    if(vm.listClassrooms[i].id == vm.old_class_id) {
                        vm.Form.objForm.configuration = JSON.stringify(vm.listClassrooms[i]);

                        vm.listComponents = vm.listClassrooms[i].components;
                        vm.Form.objForm.component_value = [];
                        for(var j=0;j < vm.listComponents.length; j++) {
                            for(var k=0;k < vm.components.length; k++) {
                                if(vm.listComponents[j].id == vm.components[k].id) {
                                    vm.Form.objForm.component_value[j] = vm.components[k].value;
                                }
                            }    
                        }
                    }
                }
            }

            angular.element.unblockUI();
        }

        function errorFetchClassrooms() {
            vm.listClassrooms = [];
            angular.element.unblockUI();
        }

        function lookUpComponents(configuration) {
            var configuration = JSON.parse(configuration); 
            vm.listComponents = configuration.components;

            if(id) {
                if(configuration.id != vm.old_class_id) {
                    vm.listDeletedComponents = vm.components;
                } else {
                    vm.listDeletedComponents = [];
                }
            }
        }

        function saveData(ev, formController) {
            angular.element.blockUI();

            vm.Form.objForm.start_date_reformated = changeDateFormat(vm.Form.objForm.start_date);
            vm.Form.objForm.end_date_reformated = changeDateFormat(vm.Form.objForm.end_date);

            if(id) {
                vm.Form.objForm.listDeletedComponents = vm.listDeletedComponents;
                var response = Form.saveData('updateData', formController, Certificate);
            } else {
                var response = Form.saveData('save', formController, Certificate);
            }

            response.then(function(data){
                var $translate = $filter('translate');
                var Message = $translate(data.pesan);
                var Status = $translate(data.status);

                var Title = 'Success Save Data';

                if(Status) {
                    Title = 'Failed Save Data';
                }

                $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(Title)
                    .textContent(Message)
                    .ariaLabel(Title)
                    .ok('OK')
                    .targetEvent(ev)
                    )
                .then(function () {
                    if(Status) {
                        closeModal();
                    }
                    angular.element.unblockUI();
                });
            });

            response.catch(function(){
                vm.messageTheme='pink';
                angular.element.unblockUI();
            });
        }

        function changeDateFormat(date) {
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var year = date.getFullYear();
            return year + "-" + month + "-" + day;
        } 
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.cb.employee-certificates')
        .controller('InputEmployeeCertificatesProgramsController', InputEmployeeCertificatesProgramsController);


    InputEmployeeCertificatesProgramsController.$inject=['$state','$stateParams','$localStorage','$timeout','Form','AppAPI','Auth','$mdDialog','$filter','id'];
    /** @ngInject */
    function InputEmployeeCertificatesProgramsController($state,$stateParams,$localStorage,$timeout,Form,AppAPI,Auth,$mdDialog,$filter,id)
    {
        
        var vm = this;

        // initial form
        Form.initialForm(false);
        
        var Certificateprograms = AppAPI.Certificateprograms(); //memanggil api modules dari api

        // set constructor form
        Form.setObject(Certificateprograms);

        vm.Form = Form;
        vm.Form.objForm.country = $localStorage.country;

        // set form to controller       
        vm.saveData=saveData;

        vm.closeModal=closeModal;

        vm.searchTerm = '';
        vm.clearSearchTerm = clearSearchTerm;

        vm.state = 'Input';
            
        angular.element.blockUI();
        if(id) {
            var responseDetail = vm.Form.objForm.$get({ action: 'viewDetail', id: id});
            responseDetail.then(function() {
                vm.Form.objForm.id = id;
            });
            
            vm.state = 'Edit';
        }

        LoadCountry();

        function saveData(ev, formController) {

            if(id) {
                angular.element.blockUI();
                var response = Form.saveData('updateData', formController, Certificateprograms);
            } else {
                angular.element.blockUI();
                var response = Form.saveData('save', formController, Certificateprograms);
            }

            response.then(function(data){
                var $translate = $filter('translate');
                var Message = $translate(data.pesan);
                var Status = $translate(data.status);

                var Title = 'Success Save Data';

                if(Status) {
                    Title = 'Failed Save Data';
                }

                $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(Title)
                    .textContent(Message)
                    .ariaLabel(Title)
                    .ok('OK')
                    .targetEvent(ev)
                    )
                .then(function () {
                    if(Status) {
                        closeModal();
                    }
                    angular.element.unblockUI();
                });
            });

            response.catch(function(){
                vm.messageTheme='pink';
                angular.element.unblockUI();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function LoadCountry() {
            var response = Certificateprograms.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
			angular.element.unblockUI();
        }

        function errorFetchCountry() {
            vm.listcountry = [];
			angular.element.unblockUI();
        }

        function clearSearchTerm() {
            vm.searchTerm = '';
        };

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.cb.employee-certificates')
        .controller('InputEmployeeCertificatesConfigurationsController', InputEmployeeCertificatesConfigurationsController);


    InputEmployeeCertificatesConfigurationsController.$inject=['$state','$stateParams','$localStorage','$timeout','Form','AppAPI','Auth','$mdDialog','$filter','id'];
    /** @ngInject */
    function InputEmployeeCertificatesConfigurationsController($state,$stateParams,$localStorage,$timeout,Form,AppAPI,Auth,$mdDialog,$filter,id)
    {
        
        var vm = this;

        // initial form
        Form.initialForm(false);
        
        var Certificateclassrooms = AppAPI.Certificateclassrooms(); //memanggil api modules dari api
        var Certificateprograms = AppAPI.Certificateprograms(); //memanggil api modules dari api

        // set constructor form
        Form.setObject(Certificateclassrooms);

        vm.Form = Form;
        vm.Form.objForm.country = $localStorage.country;

        var initComponents = {
            id: null,
            description: '',
            passing_grade: 0
        };

        vm.Form.objForm.components = [angular.copy(initComponents)];

        // set form to controller       
        vm.addComponent = addComponent;
        vm.cancelComponent = cancelComponent;
        vm.saveData=saveData;

        vm.lookUpProgram=lookUpProgram;

        vm.closeModal=closeModal;

        vm.searchTerm = '';
        vm.clearSearchTerm = clearSearchTerm;

        vm.textProgram = '';

        var dateVar = new Date();
        vm.yearClass = dateVar.getFullYear();
        vm.shortCode = '[PCode]';

        vm.listDeleted = [];

        vm.Form.objForm.code_class = vm.shortCode + vm.yearClass + 'XXX';
        vm.oldPrefixCodeClass = '';
        vm.oldCodeClass = '';

        vm.state = 'Input';

        if(id) {
            vm.state = 'Edit';            
        }

        angular.element.blockUI();
        LoadProgram();

        function saveData(ev, formController) {

            vm.Form.objForm.listDeleted = vm.listDeleted;

            if(id) {
                angular.element.blockUI();
                var response = Form.saveData('updateData', formController, Certificateclassrooms);
            } else {
                angular.element.blockUI();
                var response = Form.saveData('save', formController, Certificateclassrooms);
            }

            response.then(function(data){
                var $translate = $filter('translate');
                var Message = $translate(data.pesan);
                var Status = $translate(data.status);

                var Title = 'Success Save Data';

                if(Status) {
                    Title = 'Failed Save Data';
                }

                $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(Title)
                    .textContent(Message)
                    .ariaLabel(Title)
                    .ok('OK')
                    .targetEvent(ev)
                    )
                .then(function () {
                    if(Status) {
                        closeModal();
                    }
                    angular.element.unblockUI();
                });
            });

            response.catch(function(){
                vm.messageTheme='pink';
                angular.element.unblockUI();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearSearchTerm() {
            vm.searchTerm = '';
        }

        function addComponent(e) {
            vm.Form.objForm.components.push(angular.copy(initComponents));
        }
        
        function cancelComponent(e, idx) {
            if (vm.Form.objForm.components[idx]) {
                if(id) {
                    vm.listDeleted.push(vm.Form.objForm.components[idx].id);
                }

                vm.Form.objForm.components.splice(idx, 1);
            }
        }

        function LoadProgram() {
            var response = Certificateprograms.query({
                action: 'getPrograms',
                country: 'all'
            });
            response.$promise.then(fetchProgram);
            response.$promise.catch(errorFetchProgram);
        }

        function fetchProgram(data) {
            vm.listPrograms = data;

            if(id) {
                var responseDetail = vm.Form.objForm.$get({ action: 'viewDetail', id: id});
                responseDetail.then(function(data) {
                    vm.Form.objForm.id = id;
                    vm.shortCode = vm.Form.objForm.code_class.substring( 0, vm.Form.objForm.code_class.length - 7);
                    vm.oldPrefixCodeClass = vm.Form.objForm.code_class.substring( 0, vm.Form.objForm.code_class.length - 3);
                    vm.oldCodeClass = vm.Form.objForm.code_class;
                    angular.element.unblockUI();
                });
            } else {
                angular.element.unblockUI();
            }
        }

        function errorFetchProgram() {
            vm.listPrograms = [];
            angular.element.unblockUI();
        }

        function lookUpProgram(idProgram) {
            vm.textProgram = '';
            for(var i = 0; i < vm.listPrograms.length; i++) {
                if(vm.listPrograms[i].id == idProgram) {
                    vm.textProgram = vm.listPrograms[i].groupProgram; 

                    dateVar = new Date();
                    vm.yearClass = dateVar.getFullYear();

                    vm.shortCode = vm.listPrograms[i].short_code;

                    if(vm.shortCode + '' + vm.yearClass == vm.oldPrefixCodeClass) {
                        vm.Form.objForm.code_class = vm.oldCodeClass;
                    } else {
                        vm.Form.objForm.code_class = vm.shortCode + vm.yearClass + 'XXX';
                    }
                }
            }
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-overtime.input-employe-ot', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_employe_overtime_input_employe_ot', {
                url    : '/cb/employe-overtime/input-employe-ot',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employe-overtime/input-employe-ot/input-employe-ot.html',
                        controller : 'EmployeotinputController as vm'
                    }
                }
            })
            .state('app.cb_employe_overtime_edit_employe_ot', {
                url    : '/cb/employe-overtime/edit-employe-ot/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employe-overtime/input-employe-ot/edit-employe-ot.html',
                        controller : 'EditemployeotController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    "use strict";

    angular
        .module("app.cb.employe-overtime.input-employe-ot")
        .controller("EmployeotinputController", EmployeotinputController)
        .config(function($mdDateLocaleProvider) {
            $mdDateLocaleProvider.formatDate = function(date) {
                var day = date.getDate();
                var monthIndex = date.getMonth();
                var year = date.getFullYear();

                return day + "/" + (monthIndex + 1) + "/" + year;
            };
        });

    EmployeotinputController.$inject = [
        "$state",
        "$localStorage",
        "$timeout",
        "Form",
        "AppAPI",
        "Auth",
        "$log",
        "$scope"
    ];
    /** @ngInject */
    function EmployeotinputController(
        $state,
        $localStorage,
        $timeout,
        Form,
        AppAPI,
        Auth,
        $log,
        $scope
    ) {
        var vm = this;

        // initial form
        Form.initialForm();

        var EmployeOT = AppAPI.Employeot();

        // set constructor form
        Form.setObject(EmployeOT);

        // set form to controller
        vm.Form = Form;
        vm.reloadToken = reloadToken;
        vm.back = back;
        vm.stateEdit = false;
        vm.saveData = saveData;
        vm.Form.objForm.nik = $localStorage.user;
        vm.clearMeesage = clearMeesage;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected = [];
        vm.changeOTType = changeOTType;
        vm.Form.objForm.resthour = 0;
        vm.getEmployelist = getEmployeList;
        vm.minHour = 0;
        /*=====================*/

        function getEmployeList() {
            if (
                typeof vm.ot_type !== "undefined" &&
                typeof vm.ot_date !== "undefined" &&
                typeof vm.ot_date !== "undefined"
            ) {
                var response = EmployeOT.query({
                    action: "getEmployelist",
                    nik: $localStorage.user,
                    type: vm.ot_type,
                    start: vm.ot_date,
                    end: vm.ot_date
                });

                response.$promise.then(function(data) {
                    angular.element.unblockUI();
                    vm.listemploye = data;
                    // console.log(vm.listemploye);
                });

                response.$promise.catch(function(data) {
                    $log.info(data);
                });
            }
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }

            // console.log(state);
        }

        function checkAll() {
            vm.listOtselected = angular.copy(vm.listemploye);
        }

        function unCheckAll() {
            vm.listOtselected = [];
        }

        function isChecked(ls) {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if (idx > -1) {
                vm.listOtselected.splice(idx, 1);
            } else {
                vm.listOtselected.push(ls);
            }
            // console.log('tes');
        }

        function saveData(formController) {
            angular.element.blockUI();
            vm.Form.objForm.listotemploye = vm.listOtselected;
            vm.Form.objForm.ot_date = formController.ot_date.$viewValue;
            vm.Form.objForm.ot_type = formController.ot_type.$viewValue;
            vm.Form.objForm.start_time = formController.start_time.$viewValue;
            vm.Form.objForm.end_time = formController.end_time.$viewValue;
            vm.Form.objForm.resthour = formController.resthour.$viewValue;
            vm.Form.objForm.reason = formController.reason.$viewValue;
            vm.Form.objForm.isafter = vm.isafter;

            var response = Form.saveData("save", formController, EmployeOT);
            response.then(function(data) {
                vm.messageTheme = "blue";
                angular.element.unblockUI();
                formController.$setPristine();
                $timeout(function() {
                    vm.Form.tampilPesan = false;
                    if ("status" in data && data.status == "1") {
                        back();
                    }
                }, 5000);
                vm.listOtselected = [];
            });

            response.catch(function(data) {
                vm.messageTheme = "pink";
                angular.element.unblockUI();
                vm.listOtselected = [];
            });
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function reloadToken() {
            Auth.setToken();
        }

        function back() {
            $state.transitionTo("app.cb_employe_overtime");
        }

        function changeOTType() {
            // vm.Form.objForm.isafter=null;
        }

        $scope.$watch("vm.start_time", function(nVal, oVal) {
            if (nVal) {
                if (!vm.end_time) {
                    return;
                }
                var diff = getDiffHours(
                    parseDate(nVal),
                    parseDate(vm.end_time)
                );
                setMinHour(diff);
            }
        });

        $scope.$watch("vm.end_time", function(nVal, oVal) {
            if (nVal) {
                if (!vm.start_time) {
                    return;
                }
                var diff = getDiffHours(
                    parseDate(vm.start_time),
                    parseDate(nVal)
                );
                setMinHour(diff);
            }
        });

        function getDiffHours(start, end) {
            // console.log("start", start);
            // console.log("end", end);

            var t1 = moment(start);
            var t2 = moment(end);
            var diff = moment.duration(t2.diff(t1));
            return diff.asHours();
        }

        function setMinHour(diff) {
            var company = $localStorage.empSite; 
            // console.log(diff);
            if (company === "RK") {
                if(vm.Form.objForm.ot_type=='NORMAL'){
                    if (diff > 3) {
                    vm.minHour = 1;
                    }
                }else{
                    if (diff <= 5) {
                    vm.minHour = 0;
                    } else if (diff > 5) {
                        vm.minHour = 1;
                    } else if (diff >= 12) {
                        vm.minHour = 2;
                    }
                } 
            } else {
                 if(vm.Form.objForm.ot_type=='NORMAL'){
                    if (diff <= 3) 
                    {
                        vm.minHour = 0;
                    } else if (diff > 3) {
                        vm.minHour = 1;
                    }
                }else{
                    if (diff <5) 
                    {
                        vm.minHour = 0;
                    } else if (diff > 5) {
                        vm.minHour = 1;
                    }
                }
                
            }
        }

        function parseDate(dt) {
            var splitted = dt.split(" ");
            var dateSplit = splitted[0].split("/");
            var dtGlue =
                dateSplit[2] +
                "-" +
                dateSplit[1] +
                "-" +
                dateSplit[0] +
                " " +
                splitted[1] +
                ":00";
            return dtGlue;
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.cb.employe-overtime.input-employe-ot")
        .controller("EditemployeotController", EditemployeotController)
        .config(function($mdDateLocaleProvider) {
            $mdDateLocaleProvider.formatDate = function(date) {
                var day = date.getDate();
                var monthIndex = date.getMonth();
                var year = date.getFullYear();

                return day + "/" + (monthIndex + 1) + "/" + year;
            };
        });

    EditemployeotController.$inject = [
        "$localStorage",
        "$stateParams",
        "$state",
        "$timeout",
        "Form",
        "AppAPI",
        "Auth",
        "$scope"
    ];
    /** @ngInject */
    function EditemployeotController(
        $localStorage,
        $stateParams,
        $state,
        $timeout,
        Form,
        AppAPI,
        Auth,
        $scope
    ) {
        var vm = this;

        // initial form
        Form.initialForm();

        var EmployeOT = AppAPI.Employeot();

        // set constructor form
        Form.setObject(EmployeOT);

        // set form to controller
        vm.Form = Form;

        vm.saveData = saveData;
        vm.reloadToken = reloadToken;
        vm.back = back;
        vm.changeDate = changeDate;
        vm.ChangeGrouptype = ChangeGrouptype;
        vm.isdisabled = true;
        vm.stateEdit = true;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.isChecked = isChecked;
        vm.viewdetail = viewdetail;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected = [];
        vm.listemployeOt = [];
        vm.getEmployelist = getEmployeList;
        vm.minHour = 0;

        /*=====================*/
        viewdetail();
        getEmployeList();
        function getEmployeList() {
            if (
                typeof vm.Form.objForm.ot_type !== "undefined" &&
                typeof vm.Form.objForm.ot_date !== "undefined" &&
                typeof vm.Form.objForm.ot_date !== "undefined"
            ) {
                var response = EmployeOT.query({
                    action: "getEmployelist",
                    nik: $localStorage.user,
                    type: vm.Form.objForm.ot_type,
                    start: vm.Form.objForm.ot_date,
                    end: vm.Form.objForm.ot_date
                });

                response.$promise.then(function(data) {
                    angular.element.unblockUI();
                    vm.listemploye = data;
                });

                response.$promise.catch(function(data) {
                    $log.info(data);
                });
            }
        }

        //////////////////////////////
        function viewdetail() {
            var response = vm.Form.objForm.$get({
                action: "viewdetail",
                id: $stateParams.id
            });
            response.then(changeDate);
        }

        function changeDate() {
            vm.Form.objForm.ot_date = new Date(vm.Form.objForm.ot_date);
            vm.Form.objForm.resthour = parseInt(vm.Form.objForm.rest_hour);
            vm.isHasApproved = vm.Form.objForm.isHasApproved;

            var response = EmployeOT.query({
                action: "getEmployelist",
                nik: $localStorage.user,
                type: vm.Form.objForm.ot_type,
                start: vm.Form.objForm.ot_date,
                end: vm.Form.objForm.ot_date
            });
            response.$promise.then(function(data) {
                vm.listemploye = data;
                vm.listot = vm.Form.objForm.listot;
                vm.empot = [];
                vm.empotold = [];
                var jum = vm.listemploye.length;
                var olen = vm.listot.length;
                var i = 0;
                var o = 0;
                for (i = 0; i < jum; i++) {
                    for (o = 0; o < olen; o++) {
                        if (vm.listemploye[i].nik == vm.listot[o].nik) {
                            vm.empot.push(vm.listemploye[i]);
                            vm.empotold.push(vm.listemploye[i]);
                        }
                    }
                }
            });

            response.$promise.catch(function(data) {
                $log.info(data);
            });

            // var res=EmployeOT.query({action:'getListOtdate',tgl:vm.Form.objForm.ot_date})
            // res.$promise.then(function(data){
            //  vm.listotdate=data;
            // });
        }

        function ChangeGrouptype() {
            var resp = EmployeOT.query({
                action: "getListEmployeOt",
                group: vm.Form.objForm.optgroup
            });
            resp.$promise.then(function(data) {
                vm.listemployeOt = data[0].emplist;
                vm.Form.objForm.reason = data[0].reason;
                vm.empot = [];
                vm.empotold = [];
                var jum = vm.listemployeOt.length;
                var i = 0;
                for (i = 0; i < jum; i++) {
                    if (vm.listemployeOt[i].idot > 0) {
                        vm.empot.push(vm.listemployeOt[i]);
                        vm.empotold.push(vm.listemployeOt[i]);
                    }
                }
            });
        }

        vm.clearMeesage = clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
            vm.Form.objForm.listotemployenew = vm.empot;
            vm.Form.objForm.listotemployeold = vm.empotold;
            vm.Form.objForm.resthour = parseInt(vm.Form.objForm.rest_hour);
            vm.Form.objForm.isHasApproved = vm.Form.objForm.isHasApproved;

            var response = Form.saveData(
                "saveupdate",
                formController,
                EmployeOT
            );
            response.then(function() {
                vm.messageTheme = "blue";
                angular.element.unblockUI();
                formController.$setPristine();
                $timeout(function() {
                    vm.Form.tampilPesan = false;
                    back();
                }, 5000);
                vm.listOtselected = [];
            });

            response.catch(function() {
                vm.messageTheme = "pink";
                angular.element.unblockUI();
                vm.listOtselected = [];
            });
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listOtselected = angular.copy(vm.listemployeOt);
        }

        function unCheckAll() {
            vm.listOtselected = [];
        }

        function isChecked(ls) {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if (idx > -1) {
                vm.listOtselected.splice(idx, 1);
            } else {
                vm.listOtselected.push(ls);
            }
        }

        function reloadToken() {
            Auth.setToken();
        }

        function back() {
            $state.transitionTo("app.cb_employe_overtime");
        }

        $scope.$watch("vm.Form.objForm.start_time", function(nVal, oVal) {
            if (nVal) {
                if (!vm.Form.objForm.end_time) {
                    return;
                }
                var diff = getDiffHours(
                    parseDate(nVal),
                    parseDate(vm.Form.objForm.end_time)
                );
                setMinHour(diff);
            }
        });

        $scope.$watch("vm.Form.objForm.end_time", function(nVal, oVal) {
            if (nVal) {
                if (!vm.Form.objForm.start_time) {
                    return;
                }
                var diff = getDiffHours(
                    parseDate(vm.Form.objForm.start_time),
                    parseDate(nVal)
                );
                setMinHour(diff);
            }
        });

        function getDiffHours(start, end) {
            console.log("start", start);
            console.log("end", end);

            var t1 = moment(start);
            var t2 = moment(end);
            var diff = moment.duration(t2.diff(t1));
            console.log("diff", diff);
            return diff.asHours();
        }

        function setMinHour(diff) {
            var company = $localStorage.empSite;
            // console.log(diff);
            if (company === "RK") {
                if(vm.Form.objForm.ot_type=='NORMAL'){
                    if (diff > 3) {
                    vm.minHour = 1;
                    }
                }else{
                    if (diff <= 5) {
                    vm.minHour = 0;
                    } else if (diff > 5) {
                        vm.minHour = 1;
                    } else if (diff >= 12) {
                        vm.minHour = 2;
                    }
                } 
            } else {
                 if(vm.Form.objForm.ot_type=='NORMAL'){
                    if (diff <= 3) 
                    {
                        vm.minHour = 0;
                    } else if (diff > 3) {
                        vm.minHour = 1;
                    }
                }else{
                    if (diff <=5) 
                    {
                        vm.minHour = 0;
                    } else if (diff > 5) {
                        vm.minHour = 1;
                    }
                }
                
            }
            // console.log(vm.minHour);
        }

        function parseDate(dt) {
            var splitted = dt.split(" ");
            var dateSplit = splitted[0].split("/");
            var dtGlue =
                dateSplit[2] +
                "-" +
                dateSplit[1] +
                "-" +
                dateSplit[0] +
                " " +
                splitted[1] +
                ":00";
            return dtGlue;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-outlet-ot.input-emp-outlet-ot', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_employe_outlet-ot_input_emp_outlet_ot', {
                url    : '/cb/employe-outlet-overtime/input-employe-outlet-overtime',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employe-outlet-ot/input-emp-outlet-ot/input-emp-outlet-ot.html',
                        controller : 'EmployeoutletotinputController as vm'
                    }
                }
            });
            // .state('app.cb_employe_overtime_edit_employe_ot', {
            //     url    : '/cb/employe-overtime/edit-employe-ot/:id',
            //     views  : {
            //         'content@app': {
            //             templateUrl: 'app/main/cb/employe-overtime/input-employe-ot/edit-employe-ot.html',
            //             controller : 'EditemployeotController as vm'
            //         }
            //     }
            // });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () 
{
    'use strict';

    angular
        .module('app.cb.employe-outlet-ot.input-emp-outlet-ot')
        .controller('EmployeoutletotinputController', EmployeoutletotinputController)
        .config(function($mdDateLocaleProvider) {
            $mdDateLocaleProvider.formatDate = function(date) {
          
              var day = date.getDate();
              var monthIndex = date.getMonth();
              var year = date.getFullYear();
          
              return day + '/' + (monthIndex + 1) + '/' + year;
          
            };
          });


    EmployeoutletotinputController.$inject=['$state','$localStorage','$timeout','Form','AppAPI','Auth','$log'];
    /** @ngInject */
    function EmployeoutletotinputController($state,$localStorage,$timeout,Form,AppAPI,Auth,$log)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var EmployeOT=  AppAPI.Employeotoutlet();

         // set constructor form
         Form.setObject(EmployeOT);

         // set form to controller
        vm.Form = Form;
        vm.reloadToken=reloadToken;
        vm.back=back;
        vm.stateEdit=false; 
        vm.saveData=saveData;
        vm.Form.objForm.nik=$localStorage.user; 
        vm.clearMeesage=clearMeesage;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.changeEmpType=changeEmpType;
        vm.listOtselected=[];
        vm.getEmplist=getEmplist;
        vm.setRestHour = setRestHour;
        vm.Form.objForm.empType='crew';
        vm.Form.objForm.isHasApproved=false;
        vm.cekStatus = cekStatus;
        /*=====================*/
        
        function addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        }

        function changeDateFormat(date){
            var month = date.getMonth()+1;
            var day = date.getDate();
            var year = date.getFullYear();
            return month+"/"+day+"/"+year;
        }

        function setRestHour(){
            if((typeof vm.Form.objForm.ot_date!='undefined')&&(typeof vm.Form.objForm.start_time!='undefined')&&(typeof vm.Form.objForm.end_time!='undefined'))
            {
                var ot_date1 = changeDateFormat(vm.Form.objForm.ot_date);
                var ot_date2 = ot_date1;
                
                var tempDate1 = ot_date1+" "+vm.Form.objForm.start_time+":00";
                var time1 = vm.Form.objForm.start_time.substr(0,2);
                var time2 = vm.Form.objForm.end_time.substr(0,2);
                if(time2<time1){
                    var temp_ot_date2 = addDays(ot_date1,1);
                    var ot_date2 = changeDateFormat(temp_ot_date2);
                }
                
                var tempDate2 = ot_date2+" "+vm.Form.objForm.end_time+":00";
                var date1 = new Date(tempDate1).getTime();
                var date2 = new Date(tempDate2).getTime();
                
                var date = ((date2-date1)/1000)/60;
                vm.maxHour = 2;
                
                if(date>=360){
                    vm.Form.objForm.rest_hour = date > 2 ? vm.maxHour : date;
                    vm.minHour = 1;
                }else{
                    vm.Form.objForm.rest_hour = 0;
                    vm.minHour = 0;
                }
                changeEmpType();
            }
        }

        function changeEmpType()
        {
          var crewtype=vm.Form.objForm.empType;
          getEmplist(crewtype);
          vm.listOtselected=[];
        }

        function getEmplist(crewtype)
        {
          if(typeof(vm.Form.objForm.ot_type)!=="undefined" && typeof(vm.Form.objForm.empType)!=="undefined" && typeof(vm.Form.objForm.ot_date)!=="undefined")
          {
            angular.element.blockUI();
            vm.ot_date=changeDateFormat(vm.Form.objForm.ot_date);
            var response= EmployeOT.query({action:'getEmployelist',nik:$localStorage.user,crewtype:crewtype,type:vm.Form.objForm.ot_type,start:vm.ot_date,end:vm.ot_date});
                response.$promise.then(function(data){
                vm.listemploye=data;
              angular.element.unblockUI();
            });
    
            response.$promise.catch(function(data){
                $log.info(data);
              angular.element.unblockUI();
            }); 
          }
        }
        


        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
           vm.listOtselected=angular.copy(vm.listemploye);
        }

        function unCheckAll() {
           vm.listOtselected=[];
        }

        function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
          {
              if ( event )
              {
                  event.stopPropagation();
              }

              var idx = vm.listOtselected.indexOf(ls);

              if ( idx > -1 )
              {
                  vm.listOtselected.splice(idx, 1);
              }
              else
              {
                  vm.listOtselected.push(ls);
              }
          }

        

        function saveData(formController) { 
            angular.element.blockUI();
            vm.Form.objForm.listotemploye=vm.listOtselected; 
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;
            vm.Form.objForm.resthour = vm.rest_hour;
            vm.Form.objForm.ot_date=new Date(formController.ot_date.$viewValue);
            var response=Form.saveData('save', formController, EmployeOT); 
            response.then(function(data){
                 vm.messageTheme='blue';
                 angular.element.unblockUI();
                 formController.$setPristine();
                 $timeout(function() {
                     vm.Form.tampilPesan=false;
                 }, 3000);
                 vm.listOtselected=[];
            });

              response.catch(function(data){
                vm.messageTheme='pink';
                angular.element.unblockUI();
                vm.listOtselected=[];
            });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.cb_emp_outlet_ot');
        }

        function cekStatus(status) {
          return ((status.trim()).toLowerCase()).substr(0, 8) == 'parttime';
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-absence.input-employe-absence', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_employe_absence_input_employe_absence', {
                url    : '/cb/employe-absence/input-employe-absence',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employe-absence/input-employe-absence/input-employe-absence.html',
                        controller : 'EmployeabsenceinputController as vm'
                    }
                }
            })
            .state('app.cb_employe_absence_edit_employe_absence', {
                url    : '/cb/employe-absence/edit-employe-absence/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employe-absence/input-employe-absence/input-employe-absence.html',
                        controller : 'EditemployeabsenceController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
  'use strict';

  angular
    .module('app.cb.employe-absence.input-employe-absence')
    .controller('EmployeabsenceinputController', EmployeabsenceinputController);


  EmployeabsenceinputController.$inject = ['$state', '$localStorage', '$http', '$mdDialog', '$log', 'config', '$timeout', 'Form', 'AppAPI', 'FileUploader', 'Auth', '$scope', '$filter'];
  /** @ngInject */
  function EmployeabsenceinputController($state, $localStorage, $http, $mdDialog, $log, config, $timeout, Form, AppAPI, FileUploader, Auth, $scope, $filter) {

    var vm = this;

    var translate = $filter('translate');
    // initial form
    Form.initialForm();

    var Employeabsence = AppAPI.Employeabsence();
    var Attendanceemploye = AppAPI.Attendanceemploye();

    // set constructor form
    Form.setObject(Employeabsence);

    // set form to controller
    vm.Form = Form;
    vm.isDisabled = false;
    vm.querySearch = querySearch;
    vm.selectedItemChanged = selectedItemChanged;
    vm.ChangeDayType = ChangeDayType;
    vm.enddaterequire = true;
    vm.timerequire = true;
    vm.timedisabled = true;
    vm.Form.objForm.daytype = 'fullday';
    vm.Form.objForm.start_time = '00:00:00';
    vm.Form.objForm.end_time = '00:00:00';
    vm.ChangeAbsenceType = ChangeAbsenceType;
    vm.uploadFile = uploadFile;
    vm.UploadPhotoStateSucces = false;
    vm.UploadPhotoStateError = false;
    vm.upload = upload;
    vm.closeModal = closeModal;
    vm.checkDocumentRequest = checkDocumentRequest;
    vm.changeLeaveUsed = changeLeaveUsed;

    vm.saveData = saveData;
    vm.Form.objForm.nik = $localStorage.user;
    vm.requestdocument = 0;
    vm.clearMeesage = clearMeesage;
    vm.reloadToken = reloadToken;
    vm.back = back;
    vm.saveProcess = true;
    vm.leavBalance = 0;
    vm.viewLeaveBalance = viewLeaveBalance;
    vm.personalleaveonly = personalleaveonly;
    vm.changeLeaveType = changeLeaveType;
    vm.getAbsenceType = getAbsenceType;
    vm.changeStartDate = changeStartDate;
    vm.hideEndDate = false;
    vm.endDateDisabled = false;
    vm.startDateDisabled = true;
    vm.limitDay = 0;
    vm.selectday = false;
    vm.infoSpecificleave = false;
    vm.excludeType = '';


    /* ================== */

    function upload(form) {
      // vm.saveProcess=true;
      angular.element.blockUI();
      var check = Employeabsence.query({
        action: 'checkFinger',
        startDate: vm.Form.objForm.start_date,
        endDate: vm.Form.objForm.end_date
      });
      check.$promise.then(function (response) {
        angular.element.unblockUI();
        if (response[0].is_working == 1) {
          var note = translate('PAYROLL.MESSAGE.CHECKFINGER');
          var yes = translate('PAYROLL.MESSAGE.YES');
          var no = translate('PAYROLL.MESSAGE.NO');

          angular.element.unblockUI();
          var confirm = $mdDialog
            .confirm()
            .title('Attention !')
            .textContent(note)
            .ariaLabel('dialog')
            .ok(yes)
            .cancel(no);

          $mdDialog.show(confirm).then(
            function () {
              var resp = vm.FileUploaderPhoto.uploadAll();
            },
            function () {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        } else {
          var resp = vm.FileUploaderPhoto.uploadAll();
        }
      });
      check.$promise.catch(function () {
        angular.element.unblockUI();
      });
    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/employeabsence/upload',
      removeAfterUpload: true,
      alias: 'ijazah',
      onBeforeUploadItem: function (item) {
        vm.saveProcess = true;
        vm.isDisabled = true;
        angular.element.blockUI();
        var dt = new Date(item.formData[0].start_date);
        var et = new Date(item.formData[0].end_date);


        var abs_code = vm.Form.objForm.abs_code;
        var abs_code1 = abs_code.split('-');
        // vm.Form.objForm.abs_code=abs_code1[0];
        item.formData[0].abs_code = abs_code1[0];
        // console.log(item.formData[0].abs_code);
        var dtM = (dt.getMonth() + 1);
        var dtD = dt.getDate();
        var etM = (et.getMonth() + 1);
        var etD = et.getDate();
        if (dtM < 10) {
          dtM = '0' + dtM
        }
        if (dtD < 10) {
          dtD = '0' + dtD;
        }

        if (etM < 10) {
          etM = '0' + etM
        }
        if (etD < 10) {
          etD = '0' + etD;
        }

        var newdate = dt.getFullYear() + '-' + dtM + '-' + dtD;
        var newdate1 = et.getFullYear() + '-' + etM + '-' + etD;
        item.formData[0].start_date = newdate;
        item.formData[0].end_date = newdate1;
        // console.log(newdate);


      },
      formData: [
        {
          action: 'uploadijazah',
          documentNo: vm.documentNo,
          typeOfDocument: vm.typeOfDocument,
          description: vm.description
        }
      ],
      onAfterAddingAll: function () {
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        angular.element.unblockUI();
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      },
      onSuccessItem: function (item, response, status, headers) {
        // console.log(item);
        // console.log(response.pesan);
        // console.log(status);
        if (response.status == 1) {
          vm.messageTheme = 'blue';
        } else {
          vm.messageTheme = 'pink';
        }

        vm.Form.tampilPesan = true;
        vm.Form.pesan = response.pesan;

        angular.element.unblockUI();
        vm.saveProcess = false;
      }, onErrorItem: function (item, response, status, headers) {
        if (response.status == 1) {
          vm.messageTheme = 'blue';
        } else {
          vm.messageTheme = 'pink';
        }

        vm.Form.tampilPesan = true;
        vm.Form.pesan = response.pesan;

        angular.element.unblockUI();
        vm.saveProcess = false;
      }
    });

    function ChangeAbsenceType(ls) {
      // console.log(vm.Form.objForm.abs_code); 
      vm.saveProcess = true;
      vm.leavBalance = 0;
      vm.Form.objForm.start_date = null;
      vm.Form.objForm.end_date = null;
      vm.limitDay = 0;
      vm.selectday = false;
      vm.infoSpecificleave = false;
      var absType = ls.split("-");
      var abs = absType[0];
      vm.limitDay = vm.limitDay + parseFloat(absType[1]);
      vm.listjumday = [];
      vm.usedayleave = null;
      vm.startDateDisabled = false;

      if (vm.leaveType == 'specific') {
        for (var i = 0; i < vm.limitDay; i++) {
          vm.listjumday.push(i + 1);
        }
        vm.infoSpecificleave = true;
        vm.startDateDisabled = true;
      }
      // console.log(vm.limitDay);
      // console.log(vm.listjumday);
      if (abs === 'Z304') {
        vm.timedisabled = false;
        vm.Form.objForm.daytype = 'halfday';
      }


      if (abs == 'Z303') {
        vm.saveProcess = true;
        vm.isdisabled = true;
        var leave = Attendanceemploye.query({ action: 'getLeaveBalance' });
        leave.$promise.then(function (data) {
          vm.leavBalance = data[0].leavebalance;
          vm.saveProcess = false;
        });
        leave.$promise.catch(function (data) {
          vm.leavBalance = 0;
          vm.saveProcess = false;
        });
        if (vm.leavBalance == 0) {
          vm.isdisabled = false;
        }

      }

      if (abs == 'Z307') {
        vm.leaveused = 'useall';
        vm.startDateDisabled = false;
        vm.isdisabled = false;
        vm.usedayleave = vm.limitDay;
      }

      if (abs == 'Z308') {
        vm.leaveused = 'useall';
        vm.startDateDisabled = false;
        vm.isdisabled = false;
        vm.usedayleave = vm.limitDay;
      }

      checkDocumentRequest(abs);
    }

    function checkDocumentRequest(abs) {
      console.log(abs);
      var abssence = Employeabsence.query({ action: 'getDocumentRequest', abs_code: abs });
      abssence.$promise.then(function (data) {
        vm.requestdocument = data[0].request
        // console.log(vm.requestdocument);
        vm.saveProcess = false;
      });

      abssence.$promise.catch(function (data) {
        $log.info(data);
      });
    }

    $scope.$watch('vm.Form.objForm.abs_code', function () {
      if ((typeof vm.Form.objForm.abs_code != 'undefined') && (vm.Form.objForm.abs_code !== null)) {
        vm.excludeType = vm.Form.objForm.abs_code.substr(0, 4);
      }
    });

    function getAbsenceType(leaveType) {
      vm.Form.objForm.abs_code = null;
      var response = Employeabsence.query({ action: 'getAbsenceType', leaveType: leaveType });
      response.$promise.then(function (data) {
        vm.listAbsenceType = data;
        // console.log(vm.listParent);
        vm.saveProcess = false;
      });

      response.$promise.catch(function (data) {
        $log.info(data);
        vm.saveProcess = false;
      });
    }


    function saveData(formController) {
      angular.element.blockUI();
      var check = Employeabsence.query({
        action: 'checkFinger',
        startDate: vm.Form.objForm.start_date,
        endDate: vm.Form.objForm.end_date
      });
      check.$promise.then(function (response) {
        angular.element.unblockUI();
        if (response[0].is_working == 1) {
          var note = translate('PAYROLL.MESSAGE.CHECKFINGER');
          var yes = translate('PAYROLL.MESSAGE.YES');
          var no = translate('PAYROLL.MESSAGE.NO');

          angular.element.unblockUI();
          var confirm = $mdDialog
            .confirm()
            .title('Attention !')
            .textContent(note)
            .ariaLabel('dialog')
            .ok(yes)
            .cancel(no);

          $mdDialog.show(confirm).then(
            function () {
              angular.element.blockUI();
              vm.saveProcess = true;
              vm.Form.objForm.start_date = new Date(formController.start_date.$viewValue);
              vm.Form.objForm.end_date = new Date(formController.end_date.$viewValue);
              var abs_code = vm.Form.objForm.abs_code;
              var abs_code1 = abs_code.split('-');
              vm.Form.objForm.abs_code = abs_code1[0];

              var response = Form.saveData('save', formController, Employeabsence);

              response.then(function () {
                angular.element.unblockUI();
                vm.messageTheme = 'blue';
                vm.saveProcess = false;
                formController.$setPristine();
                $timeout(function () {
                  vm.Form.tampilPesan = false;
                }, 3000);

              });

              response.catch(function () {
                angular.element.unblockUI();
                vm.messageTheme = 'pink';
                vm.saveProcess = false;

              });
            },
            function () {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        } else {
          angular.element.blockUI();
          vm.saveProcess = true;
          vm.Form.objForm.start_date = new Date(formController.start_date.$viewValue);
          vm.Form.objForm.end_date = new Date(formController.end_date.$viewValue);
          var abs_code = vm.Form.objForm.abs_code;
          var abs_code1 = abs_code.split('-');
          vm.Form.objForm.abs_code = abs_code1[0];

          var response = Form.saveData('save', formController, Employeabsence);

          response.then(function () {
            angular.element.unblockUI();
            vm.messageTheme = 'blue';
            vm.saveProcess = false;
            formController.$setPristine();
            $timeout(function () {
              vm.Form.tampilPesan = false;
            }, 3000);

          });

          response.catch(function () {
            angular.element.unblockUI();
            vm.messageTheme = 'pink';
            vm.saveProcess = false;

          });
        }
      });
      check.$promise.catch(function () {
        angular.element.unblockUI();
      });
    }

    function uploadFile() {
      return false;
    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }

    function querySearch(query) {
      return $http
        .get(config.api + 'api/employeabsence?action=searcabsenceType&id=' + query)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {

          }
          return item.data;
        });
    }

    function selectedItemChanged(item) {
      // vm.emp_no='';
      // vm.emp_name=vm.searchString;
      if (typeof item !== 'undefined') {
        vm.description = item.description;
        vm.abs_code = item.abs_code;
        vm.isDisabled = true;
        // console.log(vm.description);
      }
      //
    }

    function ChangeDayType() {
      if (vm.Form.objForm.daytype === 'halfday') {
        vm.Form.objForm.end_date = vm.Form.objForm.start_date;
        vm.enddaterequire = false;
        vm.timerequire = true;
        vm.timedisabled = false;
      } else {
        vm.enddaterequire = true;
        vm.timerequire = false;
        vm.timedisabled = true;
      }
      // console.log(vm.Form.objForm.daytype);
    }

    function showDialog() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Save Data')
          .textContent('Process Data was Success.')
          .ariaLabel('Success Save Data')
          .ok('OK')
          .targetEvent()
      ).then(function () {
        closeModal();
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function reloadToken() {
      Auth.setToken();
    }

    function back() {
      $state.transitionTo('app.cb_employe_absence');
    }

    function viewLeaveBalance() {
      closeModal();
      $state.go('app.cb_leave_balance');
    }

    function personalleaveonly() {
      vm.leavBalance = 0;
      vm.isdisabled = false;
    }

    function changeLeaveType() {
      vm.saveProcess = true;
      vm.leavBalance = 0;
      vm.limitDay = 0;
      vm.selectday = false;
      vm.infoSpecificleave = false;
      vm.hideEndDate = false;
      vm.Form.objForm.start_date = null;
      vm.Form.objForm.end_date = null;
      vm.usedayleave = null;
      if (vm.leaveType == 'specific') {
        vm.hideEndDate = true;
        vm.startDateDisabled = true;
      }

      getAbsenceType(vm.leaveType);
    }

    function changeStartDate() {
      vm.isdisabled = false;
      var sd = vm.Form.objForm.start_date;
      var sdM = (sd.getMonth() + 1);
      var abs_code = vm.Form.objForm.abs_code;
      var abs_code1 = abs_code.split('-');

      if (sdM < 10) {
        sdM = '0' + sdM;
      }
      var sd1 = sd.getFullYear(sd) + '-' + sdM + '-' + sd.getDate();

      if (vm.leaveType == 'specific') {

        var res = Employeabsence.query({ action: 'getEndDateSpecificleave', absence_code: abs_code1[0], startDate: sd1, usedayleave: vm.usedayleave });
        res.$promise.then(getEndDateSuccess);
        res.$promise.catch(getEndDateFailed);
      }
    }

    function getEndDateSuccess(data) {
      // console.log(data[0].endDate);
      vm.Form.objForm.end_date = new Date(data[0].endDate);
      vm.hideEndDate = false;
      vm.endDateDisabled = true;
      vm.isdisabled = false;
      // console.log(data);
    }

    function getEndDateFailed() {
      vm.isdisabled = true;
    }

    function changeLeaveUsed(leaveused) {
      vm.selectday = false;
      vm.usedayleave = null;
      vm.Form.objForm.start_date = null;
      vm.Form.objForm.end_date = null;
      vm.startDateDisabled = true;
      if (leaveused == 'notuseall') {
        vm.selectday = true;
      } else {
        vm.usedayleave = vm.limitDay;
      }
      vm.startDateDisabled = false;

    }



  }
})();

(function () 
{
    'use strict';

    angular
        .module('app.cb.employe-absence.input-employe-absence')
        .controller('EditemployeabsenceController', EditemployeabsenceController);


    EditemployeabsenceController.$inject=['$state','$localStorage','$http','config','$stateParams','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function EditemployeabsenceController($state,$localStorage,$http,config,$stateParams,$timeout,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Employeabsence=  AppAPI.Employeabsence();

         // set constructor form
         Form.setObject(Employeabsence);

         // set form to controller
        vm.Form = Form;
        vm.isDisabled    = false; 
        vm.querySearch   = querySearch;
        vm.selectedItemChanged = selectedItemChanged;
        vm.ChangeDayType=ChangeDayType;
        vm.enddaterequire=true;
        vm.requestdocument='0'; 
        vm.saveData=saveData;
        vm.Form.objForm.nik=$localStorage.user;
        vm.reloadToken=reloadToken;
        vm.back=back;

        ////////////////////////

        var response= Employeabsence.query({action:'getAbsenceType'});
            response.$promise.then(function(data){
             vm.listAbsenceType=data;
            // console.log(vm.listParent);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

        var response=vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
        response.then(changeDate);

        function changeDate(data)
        {
            vm.Form.objForm.start_date=new Date(data.start_date);
            vm.Form.objForm.end_date=new Date(data.end_date);
            vm.abs_code=data.absence_type;
            vm.Form.objForm.abs_code=data.absence_type;
            vm.description=data.type_name;
            if(data.start_date==data.end_date && (data.start_time!=null || data.end_time!=null)){
                vm.Form.objForm.daytype='halfday';
                vm.timedisabled=false;
            }else{
                vm.Form.objForm.daytype='fullday'
                vm.timedisabled=true;
            }

        }

        vm.clearMeesage=clearMeesage;

        function saveData(formController) { 
            angular.element.blockUI(); 
         var response=Form.updateData('update', formController, Employeabsence,$stateParams.id,'viewdetail');

         response.then(function(data){
             vm.messageTheme='blue';
             console.log(data);
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function querySearch (query) { 
           return $http
          .get(config.api + 'api/employeabsence?action=searcabsenceType&id=' + query)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){

            }   
              return item.data;
          });
        }

        function selectedItemChanged(item) {
          // vm.emp_no='';
          // vm.emp_name=vm.searchString;
          if(typeof item!=='undefined')
          {  
            vm.description=item.description;
            vm.abs_code=item.abs_code; 
            vm.isDisabled=true; 
            console.log(vm.description);
          }
          //
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.cb_employe_absence');
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.cb.emp-join-holiday.input-join-holiday', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_cb_employe_join_holiday_input_join_holiday', {
                url    : '/cb/employe-join-holiday/input-join-holiday',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/emp-join-holiday/input-join-holiday/input-join-holiday.html',
                        controller : 'InputJoinHolidayController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () 
{
    'use strict';

    angular
        .module('app.cb.emp-join-holiday.input-join-holiday')
        .controller('InputJoinHolidayController', InputJoinHolidayController);


    InputJoinHolidayController.$inject=['$state','$localStorage','$timeout','Form','AppAPI','Auth','$log'];
    /** @ngInject */
    function InputJoinHolidayController($state,$localStorage,$timeout,Form,AppAPI,Auth,$log)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Empjoinholiday=  AppAPI.Empjoinholiday();

         // set constructor form
         Form.setObject(Empjoinholiday);

         // set form to controller
        vm.Form = Form;
        vm.reloadToken=reloadToken;
        vm.back=back;
        vm.stateEdit=false; 
        vm.saveData=saveData; 
        vm.clearMeesage=clearMeesage;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected=[];
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;

        loadDataBU();
        /*=====================*/

         


        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }

            // console.log(state);
        }

        function checkAll() {
           vm.listOtselected=angular.copy(vm.listemploye);
        }

        function unCheckAll() {
           vm.listOtselected=[];
        }

        function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
          {
              if ( event )
              {
                  event.stopPropagation();
              }

              var idx = vm.listOtselected.indexOf(ls);

              if ( idx > -1 )
              {
                  vm.listOtselected.splice(idx, 1);
              }
              else
              {
                  vm.listOtselected.push(ls);
              }
              // console.log('tes');
          }

        

        function saveData(formController) { 
            angular.element.blockUI();
            vm.Form.objForm.listotemploye=vm.listOtselected; 
            // console.log(vm.Form.objForm.listotemploye);
            var response=Form.saveData('save', formController, Empjoinholiday); 
            response.then(function(data){
                 vm.messageTheme='blue';
                 angular.element.unblockUI();
                 formController.$setPristine();
                 $timeout(function() {
                     vm.Form.tampilPesan=false;
                 }, 3000);
                 vm.listOtselected=[];
            });

              response.catch(function(data){
                vm.messageTheme='pink';
                angular.element.unblockUI();
                vm.listOtselected=[];
            });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.cb_emp_join_holiday');
        }

        function loadDataDepartment(iddivisi) {
             var response=Empjoinholiday.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }
          
          function loadDataDivision(idbu) {
             var response=Empjoinholiday.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          } 

          function loadDataBU() {
            var response=Empjoinholiday.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.cb.emp-ghk.input-ghk', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_emp_ghk_input_ghk', {
                url    : '/cb/employe-ghk/input-employe-ghk',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/emp-ghk/input-ghk/input-ghk.html',
                        controller : 'GhkinputController as vm'
                    }
                }
            })
            .state('app.cb_emp_ghk_edit_ghk', {
                url    : '/cb/employe-ghk/edit-employe-ghk/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/emp-ghk/input-ghk/input-ghk.html',
                        controller : 'GhkeditController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () 
{
    'use strict';

    angular
        .module('app.cb.emp-ghk.input-ghk')
        .controller('GhkinputController', GhkinputController);


    GhkinputController.$inject=['$state','$localStorage','$http','config','$timeout','$interval','Form','AppAPI','Auth'];
    /** @ngInject */
    function GhkinputController($state,$localStorage,$http,config,$timeout,$interval,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Employeghk=  AppAPI.Employeghk();

         // set constructor form
         Form.setObject(Employeghk);

         // set form to controller
        vm.Form = Form; 
        vm.reloadToken=reloadToken;
        vm.back=back;
        vm.changeRefshift=changeRefshift; 

        LoadLocationshift();

       
        vm.saveData=saveData;
        vm.Form.objForm.nik=$localStorage.user;


        // =====================

        function changeRefshift(id)
        { 
            vm.listLocationdetail=[];
            var resp=Employeghk.query({action:'getDetailshift',id:id})
            resp.$promise.then(fetchdetailshift);
            resp.$promise.catch(errorfetchdetailshift);
           
          
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function LoadLocationshift() {
            var response=Employeghk.query({action:'getLocationshift',nik:$localStorage.user});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

          function fetchLocation(data) {
            vm.listLocation=data;
          }

        function errorFetchLocation() {
            vm.listLocation=[];
          } 

         
         
        function saveData(formController) { 
            angular.element.blockUI(); 
         var response=Form.saveData('save', formController, Employeghk);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        } 
        
        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.cb_emp-ghk');
        }
    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.cb.emp-ghk.input-ghk')
        .controller('GhkeditController', GhkeditController);


    GhkeditController.$inject=['$state','$localStorage','$stateParams','$http','config','$timeout','$interval','Form','AppAPI','Auth'];
    /** @ngInject */
    function GhkeditController($state,$localStorage,$stateParams,$http,config,$timeout,$interval,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Employeghk=  AppAPI.Employeghk();

         // set constructor form
         Form.setObject(Employeghk);

         // set form to controller
        vm.Form = Form; 
        vm.reloadToken=reloadToken;
        vm.back=back; 


       
        vm.saveData=saveData;
        vm.Form.objForm.nik=$localStorage.user;

        var response=vm.Form.objForm.$get({action:'viewdetail',id:$stateParams.id});
        response.then(changeDate);

        function changeDate(data)
        {
             vm.Form.objForm.kerjadate=new Date(data.workday);
             vm.Form.objForm.liburdate=new Date(data.holiday);

        }

         
        function saveData(formController) { 
            angular.element.blockUI(); 
         var response=Form.saveData('save', formController, Employeghk);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        } 
        
        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.cb_emp-ghk');
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.cb.download-attendance', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.cb_download-attendance', {
                url    : '/cd/download-attendance',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/download-attendance/download-attendance.html',
                        controller : 'DownloadAttendanceController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('reportCicoController', reportCicoController);

    reportCicoController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','FileUploader','config','Auth','$window','$location'];

    /* @ngInject */
    function reportCicoController($localStorage,$mdDialog,Form,AppAPI,$log,FileUploader,config,Auth,$window,$location) {
      var vm = this;
      Form.initialForm();

      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      var Attendancereport=AppAPI.Attendancereport();
      vm.company=$localStorage.empsite;
      vm.groupLogin=$localStorage.group;
      vm.download=download;
      vm.closeModal=closeModal;
      vm.flag_app = 'SAP';
      vm.selectedSubarea = '';
      vm.loadSubArea=loadSubArea;

      vm.start_date = vm.end_date = null;

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();

      var isAdminPlant = false;
      if(vm.groupLogin == 11) {
        isAdminPlant = true;
      }

      if(vm.tgl >=25 && vm.tgl <=31)
      {
        vm.bulan=vm.bulan+1;
      }

      if(vm.bulan < 10) {
        vm.bulan='0'+vm.bulan;
      }

      vm.divisi='all';
      vm.department='all';
      vm.typeEmp = [
        {
          "view"  : "All",
          "value" : "all"
        },
        {
          "view"  : "Staff",
          "value" : "SAP"
        },
        {
          "view"  : "General Worker",
          "value" : "HRIS"
        }
      ];

      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];

      getPeriode();
      loadDataBU();
      //////////////////////////
      function changeDateFormat(date){
        var monthTmp = "" + (date.getMonth()+1);
        var monthPad = "00";
        var month = monthPad.substring(0, monthPad.length - monthTmp.length) + monthTmp;

        var dayTmp = "" + date.getDate();
        var dayPad = "00";
        var day = dayPad.substring(0, dayPad.length - dayTmp.length) + dayTmp;

        var year = date.getFullYear();
        return year+"-"+month+"-"+day;
      }

      function closeModal() {
        $mdDialog.hide();
      }

      function getPeriode(){ 
        var res=Attendancereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.start_date=new Date(data[0]['periode_start']);
        vm.end_date=new Date(data[0]['periode_end']);
        // vm.periode=data[0]['periode'];
        // console.log(vm.periode);
        // loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }

      function loadDataDepartment(iddivisi) {
           var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
          vm.listDepartment=data;

          // loadData(1);
        }

        function errorDepartment() {
          vm.listDepartment=[];
        }

        function loadDataDivision(idbu) {
           var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
          response.$promise.then(fetchDivisiBU);
          response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
         vm.listDivision=data;
         loadDataDepartment(vm.divisi);
         // vm.listDivision.push(data);
         // loadData(1);
        }

        function errorDivisiBU() {
          vm.listDivision=[];
          errorDepartment();
        }

        function loadDataBU() {
          var response=Attendancereport.query({action:'viewBu'});
          response.$promise.then(fetchBU);
          response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
          vm.listBU=data;
          loadSubArea();
          loadDataDivision(vm.company); 
        }

        function errorFetchBU() {
          vm.listBU=[];
          errorfetchArea();
          errorDivisiBU();
        }

        function download()
        {
          var company=vm.company;
          var divisi=vm.divisi;
          var department=vm.department;
          var start_date= changeDateFormat(vm.start_date);
          var end_date= changeDateFormat(vm.end_date);
          var token=Auth.setTokenPromise();
          var subarea=vm.selectedSubarea;
          var empType=vm.flag_app;

          token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host(); 
                  $window.open(protocol+'://'+host+config.api+'api/attendancereport/exporttxt/'+company+'/'+divisi+'/'+department+'/'+start_date+'/'+end_date+'/'+subarea+'/'+empType, '_blank');
            },function(){

                $window.alert('gagal load token');
            });
        }

        function  loadSubArea()
        {
          var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
          if(isAdminPlant) {
            if(vm.subArea.length > 0) {
              vm.selectedSubarea = vm.subArea[0].subarea_id;
            }
          }
        }

      function errorfetchArea(data)
      {
        vm.subArea=[];
      }

      function closeModal()
      {
          $mdDialog.hide();
      }
    }
})();

(function () {
  'use strict';

  angular
      .module('app.cb.cutoffperiode.upload-cut-off-periode', [])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.cb_cutoffperiode.upload-cut-off-periode', {
              url: '/cb/cutoffperiode/upload-cut-off-periode',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/cb/cut-off-periode/upload-cut-off-periode/upload-cut-off-periode.html',
                      controller: 'UploadCutOffPeriodeController as vm'
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.cb.cutoffperiode.upload-cut-off-periode')
    .controller('UploadCutOffPeriodeController', UploadCutOffPeriodeController);

  UploadCutOffPeriodeController.$inject = [
    '$state',
    '$mdDialog',
    'config',
    '$localStorage',
    '$timeout',
    'AppAPI',
    'Auth',
    'FileUploader',
    'dialogClose',
    'loadData'
  ];
  /** @ngInject */
  function UploadCutOffPeriodeController(
    $state,
    $mdDialog,
    config,
    $localStorage,
    $timeout,
    AppAPI,
    Auth,
    FileUploader,
    dialogClose,
    loadData
  ) {
    var vm = this;

    vm.uploadCutOffStateSuccess = false;
    vm.uploadCutOffStateError = false;
    vm.dialogClose = dialogClose;

    vm.FileUploaderCutOff = new FileUploader({
      url: config.api + 'api/cutoffperiode/uploadDataCutOffPeriode',
      removeAfterUpload: true,
      alias: 'filecutoff',
      formData: [{
          action: 'uploadDataCutOffPeriode'
      }],
      onAfterAddingAll: function() {
        vm.uploadCutOffStateSuccess = false;
        vm.uploadCutOffStateError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUploaderCutOff.onSuccessItem = function(item) {
      vm.uploadCutOffStateSuccess = true;
      vm.uploadCutOffStateError   = false;
      angular.element('#uploadCutOff').val('');
      setTimeout(function(item){
        dialogClose();
        loadData(1);
      }, 1000);
    };

    vm.FileUploaderCutOff.onErrorItem = function() {
      vm.uploadCutOffStateSuccess = false;
      vm.uploadCutOffStateError = true;
      setTimeout(function(item){
        dialogClose();
        loadData(1);
      }, 2000);
    };
  }
})();

(function () {
  'use strict';

  angular
      .module('app.cb.cutoffperiode.input-cut-off-periode', [])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.cb_cutoffperiode.input-cut-off-periode', {
              url: '/cb/cutoffperiode/input-cut-off-periode',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/cb/cut-off-periode/input-cut-off-periode/input-cut-off-periode.html',
                      controller: 'InputCutOffPeriodeController as vm'
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
      .module('app.cb.cutoffperiode.input-cut-off-periode')
      .controller('InputCutOffPeriodeController', InputCutOffPeriodeController);

  InputCutOffPeriodeController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'loadData',
      'subArea',
      'listBU',
      'dialogClose',
      'company'
  ];
  /** @ngInject */
  function InputCutOffPeriodeController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      loadData,
      subArea,
      listBU,
      dialogClose,
      company
  ) {
      var vm = this;
      var apiCutOff = AppAPI.CutOffPeriode();
      var Attendancereport = AppAPI.Attendancereport();
      var ApiHoliday = AppAPI.NationalHoliday();
      vm.subArea = subArea;
      vm.listBU = listBU;
      vm.loadData = loadData;
      vm.dialogClose = dialogClose;
      vm.company = company;
      vm.Form = Form;
      vm.saveCutOffPeriode = saveCutOffPeriode;

      activate();

      function activate() {
        Form.initialForm();
        Form.setObject(apiCutOff);
      }

      function saveCutOffPeriode(ev, formController) {
        angular.element.blockUI();
        vm.Form.objForm.subarea = formController.subarea.$viewValue;
        vm.Form.objForm.startPeriode = formController.startPeriode.$viewValue;
        vm.Form.objForm.endPeriode = formController.endPeriode.$viewValue;
        vm.Form.objForm.company = formController.company.$viewValue;
        vm.Form.objForm.effectiveDate = formController.effectiveDate.$viewValue;
        var response = Form.saveData('saveDataCutOffPeriode', formController, apiCutOff);
        response.then(function(data) {
            angular.element.unblockUI();
            formController.$setPristine();
            showDialogInfo(ev, data);
        });

        response.catch(function(data) {
            angular.element.unblockUI();
            formController.$setPristine();
            showDialogInfo(ev, data);
        });
      }

      function showDialogInfo(ev, data) {
        $mdDialog
            .show(
                $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.pesan)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
            )
            .then(function() {
                loadData(1);
                dialogClose();
            });
      }
    }


})();

(function () {
  'use strict';

  angular
      .module('app.cb.cutoffperiode.edit-cut-off-periode', [])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.cb_cutoffperiode.edit-cut-off-periode', {
              url: '/cb/cutoffperiode/edit-cut-off-periode',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/cb/cut-off-periode/edit-cut-off-periode/edit-cut-off-periode.html',
                      controller: 'EditCutOffPeriodeController as vm'
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
      .module('app.cb.cutoffperiode.edit-cut-off-periode')
      .controller('EditCutOffPeriodeController', EditCutOffPeriodeController);

  EditCutOffPeriodeController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'loadData',
      'subArea',
      'listBU',
      'dialogClose',
      'company',
      'updateData'
  ];
  /** @ngInject */
  function EditCutOffPeriodeController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      loadData,
      subArea,
      listBU,
      dialogClose,
      company,
      updateData
  ) {
      var vm = this;
      var apiCutOff = AppAPI.CutOffPeriode();
      var Attendancereport = AppAPI.Attendancereport();
      var ApiHoliday = AppAPI.NationalHoliday();
      vm.subArea = subArea;
      vm.listBU = listBU;
      vm.loadData = loadData;
      vm.dialogClose = dialogClose;
      vm.company = company;
      vm.Form = Form;
      vm.endPeriode = parseInt(updateData.end_periode);
      vm.startPeriode = parseInt(updateData.start_periode);
      vm.selectedSubarea = updateData.sub_area_id;
      vm.effectiveDate = new Date(updateData.effective_date);
      vm.updateCutOffPeriode = updateCutOffPeriode;

      activate();

      function activate() {
        Form.initialForm();
        Form.setObject(apiCutOff);
      }

      function updateCutOffPeriode(ev, formController) {
        angular.element.blockUI();
        vm.Form.objForm.startPeriode = formController.startPeriode.$viewValue;
        vm.Form.objForm.endPeriode = formController.endPeriode.$viewValue;
        vm.Form.objForm.effectiveDate = formController.effectiveDate.$viewValue;
        vm.Form.objForm.nik = updateData.nik;
        vm.Form.objForm.id = updateData.id;
        var response = Form.saveData('updateDataCutOffPeriode', formController, apiCutOff);
        response.then(function(data) {
            angular.element.unblockUI();
            formController.$setPristine();
            showDialogInfo(ev, data);
        });

        response.catch(function(data) {
            angular.element.unblockUI();
            formController.$setPristine();
            showDialogInfo(ev, data);
        });
      }

      function showDialogInfo(ev, data) {
        $mdDialog
            .show(
                $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.pesan)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
            )
            .then(function() {
                loadData(1);
                dialogClose();
            });
      }
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.checklist-attendance-gw', ['app.cb.checklist-attendance-gw.input-checklist'
        ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
        // State
        $stateProvider
            .state('app.cb_checklist_attendance_gw', {
                url    : '/cb/checklist-attendance-gw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/checklist-attendance-gw/checklist-attendance-gw.html',
                        controller : 'ChecklistAttendanceController as vm'
                    }
                }
            });
    }
})();
(function() {
    "use strict";

    angular
        .module("app.cb.checklist-attendance-gw")
        .controller(
            "UploadfileChecklistAttendanceController",
            UploadfileChecklistAttendanceController
        );

    UploadfileChecklistAttendanceController.$inject = [
        "$mdDialog",
        "$localStorage",
        "FileUploader",
        "config",
        "Auth",
        "$location",
        "$window"
    ];

    /* @ngInject */
    function UploadfileChecklistAttendanceController(
        $mdDialog,
        $localStorage,
        FileUploader,
        config,
        Auth,
        $location,
        $window
    ) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.uploadFile = uploadFile;
        vm.viewMoreInfo = viewMoreInfo;
        vm.DownloadTemplate = DownloadTemplate;
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.pesan = "";
        vm.isMoreInfo = false;

        var uploadFile = (vm.FileUploader = new FileUploader({
            url: config.api + "api/checklistattendancegw/uploadfile",
            removeAfterUpload: true,
            alias: "filechecklistattendance",
            formData: [{ action: "uploadfile" }],
            onAfterAddingAll: function() {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        }));

        uploadFile.onSuccessItem = function(data, status, headers, config) {
            if (status.status == 0) {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }

            vm.uploadNotif = status.pesan;
            if ("moreInfo" in status && status.moreInfo.length > 0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }

            vm.uploadSuccess = true;
            vm.uploadError = false;
            vm.pesan = "Success Upload Data Checklist Attendance";
            angular.element("#uploadFile").val("");
        };

        uploadFile.onErrorItem = function(item) {
            var obj = JSON.parse(item._xhr.response);
            vm.pesan = obj.pesan;
            vm.uploadSuccess = false;
            vm.uploadError = true;
        };

        // function uploadFile() {
        //     return false;
        // }

        function closeModal() {
            $mdDialog.hide();
        }

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            "://" +
                            host +
                            config.port +
                            config.api +
                            "api/checklistattendancegw/downloadtemplate",
                        "_blank"
                    );
                },
                function() {
                    $window.alert("Failed load token");
                }
            );
        }

        function viewMoreInfo() {
            $mdDialog.show({
                controller: "logFailGwController",
                controllerAs: "vm",
                templateUrl: "app/main/cb/ghk-gw/log-fail.html",
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: vm.detailInfo
                }
            });
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.cb.checklist-attendance-gw")
        .controller("logFailUploadfileController", logFailUploadfileController);

    logFailUploadfileController.$inject = [
        "$localStorage",
        "DataService",
        "$mdDialog",
        "Form",
        "AppAPI",
        "$log",
        "config",
        "Auth",
        "$mdToast",
        "data"
    ];

    /* @ngInject */
    function logFailUploadfileController(
        $localStorage,
        DataService,
        $mdDialog,
        Form,
        AppAPI,
        $log,
        config,
        Auth,
        $mdToast,
        data
    ) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.logFail = data;
        console.log(data);
        function closeModal() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    "use strict"
    angular
        .module("app.cb.checklist-attendance-gw")
        .controller(
            "UpdatechecklistController",
            UpdatechecklistController
        );

    UpdatechecklistController.$inject = [
        "$mdDialog",
        "$timeout",
        "Auth",
        "Form",
        "AppAPI",
        "data"
    ];

    function UpdatechecklistController(
        $mdDialog,
        $timeout,
        Auth,
        Form,
        AppAPI,
        data
    ) {

        var vm = this;
        var endpoint = AppAPI.ChecklistAttendanceGw();
        vm.data = data;
        vm.closeModal = closeModal;
        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;
        vm.saveData = saveData;

        vm.Form.objForm.attendance_code_in = data.tab_in;
        vm.Form.objForm.attendance_in_update = false;
        vm.Form.objForm.attendance_code_in_old = data.tab_in;
        vm.Form.objForm.attendance_code_out = data.tab_out;
        vm.Form.objForm.attendance_out_update = false;
        vm.Form.objForm.attendance_code_out_old = data.tab_out;
        vm.Form.objForm.id_in = data.tab_in_id;
        vm.Form.objForm.id_out = data.tab_out_id;
        vm.Form.objForm.tab_in_version = data.tab_in_version;
        vm.Form.objForm.tab_out_version = data.tab_out_version;
        vm.Form.objForm.working_date = data.working_date;

        getListAttCode();

        function closeModal() {
            $mdDialog.hide();
        }

        function getListAttCode() {
            var response = endpoint.query({
                action: "getListAttCode"
            });
            response.$promise.then(function (res) {
                vm.listAttCode = res;
                // console.log('res', res);
            });
            response.$promise.catch(function (err) {
                console.log('err', err);
            });
        }

        function saveData(formController) {
            var promiseAuth = Auth.setToken();
            if (vm.Form.objForm.attendance_code_in != vm.Form.objForm.attendance_code_in_old) {
                if (vm.Form.objForm.id_in != null) {
                    vm.Form.objForm.attendance_in_update = true;
                }
            }

            if (vm.Form.objForm.attendance_code_out != vm.Form.objForm.attendance_code_out_old) {
                if (vm.Form.objForm.id_out != null) {
                    vm.Form.objForm.attendance_out_update = true;
                }
            }
            promiseAuth.then(function () {
                angular.element.blockUI();
                var promise = Form.saveData('updatechecklistattendance', formController, endpoint);
                promise.then(function () {
                    angular.element.unblockUI();
                    vm.messageTheme = 'blue';
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });
                promise.catch(function () {
                    vm.messageTheme = 'red';
                    angular.element.unblockUI();
                });
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.checklist-attendance-gw.input-checklist', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.cb_checklist_attendance_gw_input_checklist', {
                url    : '/cb/checklist-attendance-gw/input-checklist',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/checklist-attendance-gw/input-checklist/input-checklist.html',
                        controller : 'InputCheklistController as vm'
                    }
                }
            }) 
      
    }
})();
(function () {
    "use strict";

    angular
        .module("app.cb.checklist-attendance-gw.input-checklist")
        .controller("InputCheklistController", InputCheklistController);

    InputCheklistController.$inject = [
        "$state",
        "$mdDialog",
        "DataService",
        "AppAPI",
        "Auth",
        "GeneralService",
        "$localStorage",
        "$window",
        "$location",
        "$http",
        "config",
        "$filter",
        "$document"
    ];
    /** @ngInject */
    function InputCheklistController(
        $state,
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        GeneralService,
        $localStorage,
        $window,
        $location,
        $http,
        config,
        $filter,
        $document
    ) {
        var vm = this;
        var translate = $filter('translate');
        vm.listJum = [2, 5, 10, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.DataTable.jumDataPerPage = 10;
        vm.loadData = loadData;
        var ChecklistAttendanceGw = AppAPI.ChecklistAttendanceGw();
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.Checklist = Checklist;
        vm.uploadData = uploadData;
        vm.listGedung = [];
        vm.listSector = [];
        vm.listType = [{
            id: 'I0',
            name: 'IN'
        }, {
            id: 'O0',
            name: 'Out'
        }];
        vm.getListGedung = getListGedung;
        vm.getShiftLocation = getShiftLocation;
        vm.getSector = getSector;
        vm.gedung = "";
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.selectAll = false;
        //vm.objGedung = "";
        vm.setIsTime = setIsTime;
        vm.isTime = false;
        vm.changeAttCode = changeAttCode;
        vm.changeLine = changeLine;
        vm.copylistAttCode = copylistAttCode;
        vm.clearSelectedAttCode = clearSelectedAttCode;
        vm.setTotalDaysOT = setTotalDaysOT;
        vm.listSelected = [];
        vm.showSelected = showSelected;
        vm.getline = getLine;


        // loadData(1);
        getFilterData();
        getShiftLocation();
        getListGedung();
        getListAttCode();
        getListShiftGroup();

        // var keys = Object.keys(vm.listAttCode);
        // // $scope.radioModel = 'middle';

        // vm.selectAttCode = function (id) {
        //     vm.attCode = keys[id];
        // };

        function getLine(gedungId, id) {
            var response = ChecklistAttendanceGw.query({
                action: "getLines",
                gedung_id: gedungId,
                id: id
            });
            response.$promise.then(fetchLine);
            response.$promise.catch(errorFetchLine);
        }

        function fetchLine(data) {
            vm.listLines = data;
        }

        function errorFetchLine() {
            vm.listLines = [];
        }

        function getFilterData() {
            vm.gedung = vm.sector = vm.shift = "";
            vm.working_date = new Date(moment().format('YYYY/MM/DD'));
            if ('checklistAttGw_filter' in $localStorage) {
                vm.filterData = $localStorage.checklistAttGw_filter;
                vm.gedung = vm.filterData.gedung;
                vm.sector = vm.filterData.sector;
                vm.shift = vm.filterData.shift;
                getLine(vm.gedung, vm.sector)
                setIsTime(vm.shift);
                vm.working_date = new Date(vm.filterData.working_date);
            }
        }

        function showDialogMessage(ev, title, textContent, ok) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(textContent)
                    .ok(ok)
                    .targetEvent(ev)
                )
                .then(function () {});
        }

        function loadData(pageno) 
        {
            angular.element.blockUI(pageno);
            var response = vm.DataTable.loadData(
                ChecklistAttendanceGw,
                pageno, {
                    action: "viewdata",
                    search: vm.searchParam,
                    gedung: vm.gedung,
                    working_date: vm.working_date,
                    sector: vm.sector,
                    shiftGroup: vm.shiftGroup,
                    shift :vm.shift,
                    type: vm.type,
                    line: vm.line
                }
            );
            console.log(response);
            angular.element.unblockUI(pageno);
            response.then(function (data) 
            {

                data.list.find(function (val) {
                    val.listAttCode = vm.copylistAttCode(vm.listAttCode);
                    for (var i = 0; i <= (vm.listSelected.length - 1); i++) {
                        if (val.nik == vm.listSelected[i].nik) {

                            val.checked = true;
                            val.attCode = vm.listSelected[i].attCode;
                            val.attCodes = vm.listSelected[i].attCodes;
                            val.listAttCode = vm.listSelected[i].listAttCode;
                            val.listAttCode.find(function (val2) {
                                for (var ii = 0; ii <= (vm.listSelected[i].listAttCode.length - 1); ii++) 
                                {
                                    if (val2.code == vm.listSelected[i].listAttCode[ii].code) {
                                        if (vm.listSelected[i].listAttCode[ii].checked) {
                                            val2.checked = true;
                                        }
                                    }
                                }
                            });
                            val.isRequiredTotalDaysOT = vm.listSelected[i].isRequiredTotalDaysOT;
                            val.totalDaysOT = vm.listSelected[i].totalDaysOT;
                            // val = vm.listSelected[i];
                        }
                    }
                }); 
            }); 
            vm.selectAll = false;
        }

        function setSelectedList() {
            console.log('vm.DataTable.list', vm.DataTable.list);
            // vm.DataTable.list.find(function (val) {
            //     console.log('val', val);
            // });
        }

        function copylistAttCode(listAttCode) {
            return angular.copy(listAttCode);
        }

        function changeAttCode(idx, item, team) {
            team.listAttCode.find(function (val) {
                if (item.code != val.code) {
                    val.checked = false;
                } else {
                    val.checked = true;
                }
            });

            if (item.code == 'L') {
                team.isRequiredTotalDaysOT = true;
            } else {
                team.isRequiredTotalDaysOT = false;
            }
            team.attCode = item.code;
            team.attCodes = item;
            team.totalDaysOT = '';

            //vm.listSelected = getUnique(vm.listSelected, 'nik');

            if (item.code == 'L') {
                team.checked = false;
                vm.listSelected.splice(idx, 1);
            } else {
                team.checked = true;
                vm.listSelected.push(team);
            }

            vm.listSelected = [];
            vm.DataTable.list.find(function (val) {
                if (val.checked) {
                    vm.listSelected.push(val);
                }
            });

        }

        function changeLine(item, team) {
            team.line = item.id;
            team.linename = item.name;
            team.lines.find(function (val) {
                // console.log(item.id);
                // console.log(val.id);
                if (item.id != val.id) {
                    val.checked = false;
                } else {
                    val.checked = true;
                }
            });
        }

        // function getUnique(arr, comp) {
        //     var unique = arr
        //         .map(e => e[comp])
        //         // store the keys of the unique objects
        //         .map((e, i, final) => final.indexOf(e) === i && i)
        //         // eliminate the dead keys & store unique objects
        //         .filter(e => arr[e]).map(e => arr[e]);
        //     return unique;
        // }

        function setTotalDaysOT(idx, team) {
            if (team.totalDaysOT > 0) {
                team.checked = true;
                vm.listSelected.push(team);
            } else {
                team.checked = false;
                vm.listSelected.splice(idx, 1);
            }
        }

        function clearSelectedAttCode(ev, idx, team) {
            if (ev) {
                ev.stopPropagation();
            }

            team.listAttCode.find(function (val) {
                val.checked = false;
            });
            team.attCode = '';
            delete team.line;
            team.lines.find(function (val) {
                val.checked = false;
            });

            team.attCodes = '';
            team.totalDaysOT = '';
            team.isRequiredTotalDaysOT = false;
            team.checked = false;

            //vm.listSelected = getUnique(vm.listSelected, 'nik');
            if (idx > -1) {
                vm.listSelected.splice(idx, 1);
            }

            vm.listSelected = [];
            vm.DataTable.list.find(function (val) {
                if (val.checked) {
                    vm.listSelected.push(val);
                }
            });

        }

        function isChecked(ls) {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if (idx > -1) {
                vm.listSelected.splice(idx, 1);
            } else {
                vm.listSelected.push(ls);
            }
        }

        function toggleSelectedAll(state) {
            console.log(state);
            if (vm.listSelected.length === vm.DataTable.list.length) {
                vm.listSelected = [];
            } else if (
                vm.listSelected.length === 0 ||
                vm.listSelected.length > 0
            ) {
                vm.listSelected = vm.DataTable.list.slice(0);
            }
        }

        function Checklist(ev) {
            var jum = vm.listSelected.length,
                i,
                ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog
                        .confirm()
                        .title("Would you like to Check this list?")
                        .textContent("All data your selected will be check.")
                        .ariaLabel("delete dialog")
                        .targetEvent(ev)
                        .ok("YES")
                        .cancel("no");
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(
                        function () {
                            vm.selectAll = false;
                            var checkAttendance = new ChecklistAttendanceGw();
                            checkAttendance.data = [];
                            checkAttendance.action = "checklist";
                            checkAttendance.gedung = vm.gedung;
                            checkAttendance.sector = vm.sector;
                            checkAttendance.working_date = vm.working_date;
                            checkAttendance.shift = vm.shift;
                            checkAttendance.startTime = vm.startTime;
                            checkAttendance.endTime = vm.endTime;
                            checkAttendance.type = vm.type;
                            // checkAttendance.isStartSameDate = vm.isStartSameDate;
                            for (i = 0; i < jum; i++) {
                                var listData = angular.copy(vm.listSelected[i]);
                                if (listData.attCode == 'L' && listData.totalDaysOT != '') {
                                    listData.attendance_code = listData.attCode + '' + listData.totalDaysOT;
                                } else {
                                    listData.attendance_code = listData.attCode;
                                }
                                delete listData.listAttCode;
                                delete listData.attCodes;
                                delete listData.attCode;
                                delete listData.totalDaysOT;
                                checkAttendance.data.push({
                                    listData: listData
                                });
                            }
                            var response = checkAttendance.$save();
                            response.then(function (data) {
                                showDialog(ev, data);
                                vm.listSelected.length = 0;
                            });
                            response.catch(function (data) {
                                showDialog(ev, data);
                            });
                        },
                        function () {
                            //
                        }
                    );
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title("Attention!")
                        .textContent("No data selected")
                        .ariaLabel("Attention")
                        .ok("close")
                        .targetEvent(ev)
                    )
                    .then(function () {
                        loadData();
                    });
            }
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok("OK")
                    .targetEvent(ev)
                )
                .then(function () {
                    loadData(1);
                    vm.listSelected = [];
                    angular.element.unblockUI();
                });
        }

        function ShowFailed(ev) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title("Failed Check Data")
                    .textContent("Please Recheck Your Data.")
                    .ariaLabel("Failed Check Data")
                    .ok("OK")
                    .targetEvent(ev)
                )
                .then(function () {
                    loadData(1);
                    vm.listSelected = [];
                    angular.element.unblockUI();
                });
        }

        function uploadData(ev) {
            $mdDialog.show({
                controller: "UploadfileChecklistAttendanceController as vm",
                templateUrl: "app/main/cb/checklist-attendance-gw/uploadfile/uploadfile.html",
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function getListGedung() {
            var response = ChecklistAttendanceGw.query({
                action: "getSelectListGedung"
            });
            response.$promise.then(fetchGedung);
            response.$promise.catch(errorFetchGedung);
        }

        function fetchGedung(data) {
            vm.listGedung = data;
        }

        function errorFetchGedung() {
            vm.listGedung = [];
        }

        function getShiftLocation() {
            var response = ChecklistAttendanceGw.query({
                action: "getShiftBylocation"
            });
            response.$promise.then(fetchShift);
            response.$promise.catch(errorFetchShift);
        }

        function fetchShift(data) {
            vm.listShift = data;
        }

        function errorFetchShift() {
            vm.listShift = [];
        }

        function getSector(objGedung) {
            var obj = JSON.parse(objGedung);
            vm.gedung = obj.gedung_id;
            var response = ChecklistAttendanceGw.query({
                action: "getSelectListSector",
                id: vm.gedung
            });
            response.$promise.then(fetchSector);
            response.$promise.catch(errorFetchSector);
        }

        function fetchSector(data) {
            vm.listSector = data;
            // vm.sector = vm.filterData.sector;
        }

        function errorFetchSector() {
            vm.listSector = [];
        }

        function getListAttCode() {
            var response = ChecklistAttendanceGw.query({
                action: "getListAttCode"
            });
            response.$promise.then(function (res) {
                vm.listAttCode = res;
                // console.log('res', res);
            });
            response.$promise.catch(function (err) {
                console.log('err', err);
            });
        }

        function setIsTime(shift) {
            if (shift == "Non Group") {
                vm.isTime = true;
            } else {
                vm.isTime = false;
            }
        }

        function showSelected(ev) {
            $mdDialog.show({
                controller: "InputCheklistSelectedController as vm",
                templateUrl: "app/main/cb/checklist-attendance-gw/input-checklist/input-checklist-selected.html",
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    listSelected: vm.listSelected,
                    timeOT: {
                        startTime: vm.startTime,
                        endTime: vm.endTime
                    }
                },
                onShowing: function () {
                    $localStorage.checklistAttGw_listSelected = vm.listSelected;
                },
                onRemoving: function (element, removePromise) {
                    vm.listSelected = $localStorage.checklistAttGw_listSelected;
                    loadData(1);
                }
            });
        }

        function getListShiftGroup() {
            var response = ChecklistAttendanceGw.query({
                action: "getShiftGroup"
            });
            response.$promise.then(fetchShiftGroup);
            response.$promise.catch(errorFetchShiftGroup);
        }

        function fetchShiftGroup(data) {
            vm.listShiftGroup = data;
        }

        function errorFetchShiftGroup() {
            vm.listShiftGroup = [];
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.cb.checklist-attendance-gw.input-checklist")
        .controller("InputCheklistSelectedController", InputCheklistSelectedController);

    InputCheklistSelectedController.$inject = ["$state", "$mdDialog", "AppAPI", "Auth", "listSelected", "$localStorage", "timeOT"];
    /** @ngInject */
    function InputCheklistSelectedController($state, $mdDialog, AppAPI, Auth, listSelected, $localStorage, timeOT) {
        var vm = this;
        var ChecklistAttendanceGw = AppAPI.ChecklistAttendanceGw();
        vm.closeModal = closeModal;
        vm.listSelected = listSelected;
        vm.saveSelected = saveSelected;
        vm.removeSelected = removeSelected;
        vm.checkedList = [];
        vm.checkList = checkList;
        vm.startTime = timeOT.startTime;
        vm.endTime = timeOT.endTime;

        getFilterData();
        // console.log('vm.listSelected', vm.listSelected);

        function getFilterData() {
            vm.filterData = $localStorage.checklistAttGw_filter;
            vm.gedung = vm.filterData.gedung;
            vm.sector = vm.filterData.sector;
            vm.shift = vm.filterData.shift;
            vm.working_date = new Date(vm.filterData.working_date);
        }

        function saveSelected(ev) {
            // var ygDipilih = [];
            // vm.listSelected.find(function (val) {
            //     if (val.confirm === true) {
            //         ygDipilih.push(val);
            //     }
            // });

            Checklist(ev);
            //console.log('vm.checkedList', vm.checkedList);

        }

        function checkList(idx, item) {
            if (item.confirm) {
                vm.checkedList.push(item);
            } else {
                vm.checkedList.splice(idx, 1);
            }

        }

        function removeSelected() {
            var sisaList = [];
            vm.listSelected.find(function (val) {
                var ada = vm.checkedList.find(function (val2) {
                    if (val.nik == val2.nik) {
                        return true;
                    }
                });
                if (!ada) {
                    sisaList.push(val);
                }
            });
            vm.listSelected = sisaList;
            $localStorage.checklistAttGw_listSelected = sisaList;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function Checklist(ev) {
            var jum = vm.checkedList.length,
                i,
                ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog
                        .confirm()
                        .title("Would you like to Check this list?")
                        .textContent("All data your selected will be check.")
                        .ariaLabel("delete dialog")
                        .targetEvent(ev)
                        .ok("YES")
                        .cancel("no");
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(
                        function () {
                            vm.selectAll = false;
                            var checkAttendance = new ChecklistAttendanceGw();
                            checkAttendance.data = [];
                            checkAttendance.action = "checklist";
                            checkAttendance.gedung = vm.gedung;
                            checkAttendance.sector = vm.sector;
                            checkAttendance.working_date = vm.working_date;
                            checkAttendance.shift = vm.shift;
                            checkAttendance.startTime = vm.startTime;
                            checkAttendance.endTime = vm.endTime;
                            // checkAttendance.isStartSameDate = vm.isStartSameDate;
                            for (i = 0; i < jum; i++) {
                                var listData = angular.copy(vm.checkedList[i]);
                                if (listData.attCode == 'L' && listData.totalDaysOT != '') {
                                    listData.attendance_code = listData.attCode + '' + listData.totalDaysOT;
                                } else {
                                    listData.attendance_code = listData.attCode;
                                }
                                delete listData.listAttCode;
                                delete listData.attCodes;
                                delete listData.attCode;
                                delete listData.totalDaysOT;
                                checkAttendance.data.push({
                                    listData: listData
                                });
                            }
                            var response = checkAttendance.$save();
                            response.then(function () {

                                removeSelected();

                                showDialog(ev);
                                // vm.checkedList.length = 0;
                            });
                            response.catch(function () {
                                ShowFailed(ev);
                            });
                        },
                        function () {
                            //
                        }
                    );
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector("#contentDialog")
                                )
                            )
                            .clickOutsideToClose(true)
                            .title("Attention!")
                            .textContent("No data selected")
                            .ariaLabel("Attention")
                            .ok("close")
                            .targetEvent(ev)
                    )
                    .then(function () {
                        loadData();
                    });
            }
        }

        function showDialog(ev) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title("Success Approve Data")
                        .textContent("Process Data was Success.")
                        .ariaLabel("Success Approve Data")
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function () {
                    // loadData(1);
                    // vm.checkedList = [];
                    angular.element.unblockUI();
                });
        }

        function ShowFailed(ev) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title("Failed Check Data")
                        .textContent("Please Recheck Your Data.")
                        .ariaLabel("Failed Check Data")
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function () {
                    //loadData(1);
                    // vm.checkedList = [];
                    angular.element.unblockUI();
                });
        }

    }

})();

(function () {
    "use strict"
    angular
        .module("app.cb.checklist-attendance-gw")
        .controller(
            "ChangeshiftController",
            ChangeshiftController
        );

    ChangeshiftController.$inject = [
        "$mdDialog",
        "$timeout",
        "Auth",
        "Form",
        "AppAPI",
        "data"
    ];

    function ChangeshiftController(
        $mdDialog,
        $timeout,
        Auth,
        Form,
        AppAPI,
        data
    ) {

        var vm = this;
        var endpoint = AppAPI.ChecklistAttendanceGw();
        vm.data = data;
        vm.closeModal = closeModal;
        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;
        vm.saveData = saveData;

        vm.Form.objForm.attendance_code_in = data.tab_in;

        getListAttCode();

        function closeModal() {
            $mdDialog.hide();
        }

        function getListAttCode() {
            var response = endpoint.query({
                action: "getListAttCode"
            });
            response.$promise.then(function (res) {
                vm.listAttCode = res;
                // console.log('res', res);
            });
            response.$promise.catch(function (err) {
                console.log('err', err);
            });
        }

        function saveData(formController, ev) {
            // var promiseAuth = Auth.setToken();
            // var confirm = $mdDialog
            //     .prompt()
            //     .title("Would you like to Replace Shift this list?")
            //     .textContent("All data your selected will be Replace.")
            //     .targetEvent(ev)
            //     .parent(angular.element(document.body))
            //     .ok("YES")
            //     .cancel("no");
            // $mdDialog.show(confirm).then(
            //     function (comment) {
            changeShit('comment', vm.data);
            //     },
            //     function () {
            //         $scope.status = "You didn't name your dog.";
            //     }
            // );
        }

        function changeShit(comment, data, ev) {
            console.log(comment, data);
            var checkAttendance = new endpoint();
            checkAttendance.comment = vm.Form.objForm.comment;
            checkAttendance.data = data;
            checkAttendance.type = vm.Form.objForm.changeShift;
            checkAttendance.action = "changeShift";
            var response = checkAttendance.$save();
            response.then(function () {
                showDialog(ev);
                closeModal();
            });
            response.catch(function () {
                ShowFailed(ev);
            });
        }

        function showDialog(ev) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title("Success Approve Data")
                    .textContent("Process Data was Success.")
                    .ariaLabel("Success Approve Data")
                    .ok("OK")
                    .targetEvent(ev)
                )
                .then(function () {
                    angular.element.unblockUI();
                });
        }

        function ShowFailed(ev) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title("Failed Check Data")
                    .textContent("Please Recheck Your Data.")
                    .ariaLabel("Failed Check Data")
                    .ok("OK")
                    .targetEvent(ev)
                )
                .then(function () {
                    angular.element.unblockUI();
                });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.hrservices.attendance.attendancelist.input-attendancelist', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.attendance_attendancelist_input-attendancelist', {
                url    : '/attendance/attendancelist/input-attendancelist',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/hrservices/attendance/attendancelist/input-attendancelist/input-attendancelist.html',
                        controller : 'InputattendancelistController as vm'
                    }
                }
            }) 

            


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.hrservices.attendance.attendancelist.input-attendancelist')
        .controller('InputattendancelistController', InputattendancelistController); 
    InputattendancelistController.$inject=['$state','$stateParams','$localStorage','$timeout','Form','AppAPI','Auth'];
    /** @ngInject */
    function InputattendancelistController($state,$stateParams,$localStorage,$timeout,Form,AppAPI,Auth)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Module=  AppAPI.Module();

         // set constructor form
         Form.setObject(Module);

         // set form to controller
         vm.Form = Form; 
         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[
                    {link:'app.utility_modul',name:'Module',active:'0'},
                    {link:'#',name:'Input Attendance',active:'0'}
                    ];

       
        vm.saveData=saveData;
        vm.back=back; 
        vm.clearMeesage=clearMeesage;
        vm.reloadToken=reloadToken;
        vm.Form.objForm.link='-';
        vm.Form.objForm.icon='-';
        vm.Form.objForm.type='menu';
        vm.Form.objForm.link_parent='-';
        vm.Form.objForm.state='-';
        vm.Form.objForm.collapse='-';
        // console.log( vm.Form.objForm.menu_id);
        // 
        var response= Module.query({action:'get_parent'});
            response.$promise.then(function(data){
             vm.listParent=data;
            // console.log(vm.listParent);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });


        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Module);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        } 

        function back(){
            $state.transitionTo('app.utility_modul');
        } 
    }
})();  

(function()
{
	angular
		.module('app.cb.am.input-am', [])
		.config(config);
		
	config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
	  /** @ngInject */
   /** @ngInject */
    
	function config($stateProvider, $translatePartialLoaderProvider)
	{
		$stateProvider
			.state('app.cb_am_input-am', {
				url : '/cb/area-manager/input-am',
				views : {
					'content@app' : {
						templateUrl : 'app/main/cb/area-manager/input-am/input-am.html',
						controller	: 'InputAmController as vm'
					}
				}
			})
		
		$stateProvider
			.state('app.cb_am_edit-am', {
				url : '/cb/area-manager/edit-am/:id',
				views : {
					'content@app' : {
						templateUrl : 'app/main/cb/area-manager/input-am/input-am.html',
						controller	: 'EditAmController as vm'
					}
				}
			})
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.cb.am.input-am')
		.controller('InputAmController', InputAmController);
		
	InputAmController.$inject=['$state', '$stateParams', '$localStorage', '$timeout', 'Form', 'AppAPI', 'Auth'];
	/** @ngInject */
	function InputAmController($state, $stateParams, $localStorage, $timeout, Form, AppAPI, Auth)
	{
		var vm = this;
		
		// initial form
		Form.initialForm(false);
		
		var AreaManager=AppAPI.AreaManager(); 
		
		// set constructor form
        Form.setObject(AreaManager);
		 
		// set form to controller
		vm.Form = Form
		
		vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
                    {link:'app.cb_area-manager',name:'AM',active:'0'},
                    {link:'#',name:'Input AM',active:'0'}
                    ];
					
		vm.saveData = saveData;
		vm.back = back;
		
		vm.clearMessage = clearMessage;
		vm.reloadToken = reloadToken;

		vm.clearMessage();
		
		function saveData(formController) {
			angular.element.blockUI(); //untuk nampilin loading animation
			var response = Form.saveData('save', formController, AreaManager);
			
			response.then(function() {
				vm.messageTheme = 'blue';
				angular.element.unblockUI();
				formController.$setPristine();
				$timeout(function() {
					vm.Form.tampilPesan = false;
				}, 3000);
			});
			
			response.catch(function() {
				vm.messageTheme = 'pink';
				angular.element.unblockUI();
			});
		}
		
		function clearMessage() {
			vm.Form.tampilPesan=false;
		}
		
		function reloadToken() {
			Auth.setToken();
		}
		
		function back() {
			$state.transitionTo('app.cb_area-manager');
		}
	}
})();
(function()
{
	'use strict';
	
	angular
		.module('app.cb.am.input-am')
		.controller('EditAmController', EditAmController);
		
	EditAmController.$inject=['$state', '$stateParams', '$localStorage', '$log', '$timeout', 'Form', 'AppAPI'];
	/** @ngInject */
	function EditAmController($state, $stateParams, $localStorage, $log, $timeout, Form, AppAPI)
	{
		var vm = this;
		
		// initial form
		Form.initialForm();
		
		var AreaManager=AppAPI.AreaManager(); 
		vm.listModulSelected=[];
		// set constructor form
        Form.setObject(AreaManager);
		 
		// set form to controller
		vm.Form = Form
		
		vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
                    {link:'app.cb_area-manager',name:'AM',active:'0'},
                    {link:'#',name:'Edit AM',active:'0'}
                    ];
		
		var response = vm.Form.objForm.$get({action : 'detailEdit', id:$stateParams.id});
		
		response.then(function(data){
			vm.Form.objForm.effective_date = new Date(data.effective_date);	
		});
				
		vm.saveData = saveData;
		vm.back = back;
		
		vm.clearMessage = clearMessage;
		vm.reloadToken = reloadToken;
		
		function saveData(formController) {
			angular.element.blockUI(); //untuk nampilin loading animation
			var response = Form.updateData('update', formController, AreaManager, $stateParams.id, 'detailEdit');
			
			response.then(function(data) {
				vm.Form.objForm.effective_date = new Date(data.effective_date);
				vm.messageTheme = 'blue';
				angular.element.unblockUI();
				formController.$setPristine();
				
				$timeout(function() {
					vm.Form.tampilPesan = false;
				}, 3000);
			});
			
			response.catch(function() {
				vm.messageTheme = 'pink';
				angular.element.unblockUI();
			});
		}
		
		function clearMessage() {
			vm.Form.tampilPesan=false;
		}
		
		function reloadToken() {
			Auth.setToken();
		}
		
		function back() {
			$state.transitionTo('app.cb_area-manager');
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.area-manager', ['app.cb.am.input-am'])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_area-manager', {
                url    : '/cb/area-manager',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/area-manager/area-manager.html',
                        controller : 'areaManagerController as vm'
                    }
                }
            });
			
		$stateProvider
            .state('app.cb_area-manager-detail', {
                url    : '/cb/area-manager-detail/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/area-manager/detail/am-detail.html',
                        controller : 'areaManagerDetailController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () 
{
    'use strict';

    angular
        .module('app.cb.area-manager')
        .controller('EditAMDetailController', EditAMDetailController);

    /** @ngInject */
    EditAMDetailController.$inject=['$mdDialog','id','AppAPI','Auth','Form'];
    /** @ngInject */
    function EditAMDetailController($mdDialog,id,AppAPI,Auth,Form)
    {
        
        var vm = this;
	    // initial form
	    Form.initialForm(false);

	    // get constructor form
	    var AreaManager=AppAPI.AreaManager();

	    // set constructor form
	    Form.setObject(AreaManager);

	    // set form to controller
	    vm.Form = Form;

	    angular.element.blockUI();
		loadSubArea();

	    vm.closeModal=closeModal;
	    vm.id=id;
	    vm.saveData=saveData;
		
		vm.loadSubArea = loadSubArea;
		vm.selectedSubarea = '0';
		
	    vm.setToken=Auth.setToken;

	    vm.messageTheme='pink';

	    vm.clearMessage = clearMessage;

	    vm.clearSearchTermSA = clearSearchTermSA;
	    vm.searchTermSA = '';
         
	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updateeducation', formController, Modules);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/
        function saveData(ev, formController) {
        	angular.element.blockUI();
        	vm.Form.objForm.date_formatted = formController.effective_date.$viewValue;
            var promise= Form.saveData('updateDetail',formController,AreaManager);
            promise.then(function(){
        		angular.element.unblockUI();
	            showDialog(ev);
            });
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title('Success Save Data')
	        .textContent('Process Data was Success.')
	        .ariaLabel('Success Save Data')
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }
		
		function loadSubArea()
        {
          var response=AreaManager.query({
			  action: 'getSubArea'
		  });
		  
          response.$promise.then(fetchArea);
          response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
          var responseDet=vm.Form.objForm.$get({action:'viewEditDetail',id:id.id});
	        responseDet.then(function(){
	        	vm.Form.objForm.effective_date = new Date(vm.Form.objForm.effective_date);
	        	angular.element.unblockUI();
	        });

        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
    		angular.element.unblockUI();
        }
		
		function clearMessage() {
			vm.Form.tampilPesan=false;
		}

		function clearSearchTermSA() {
			vm.searchTermSA = '';
		}
    }
    
})();  

(function ()
{
    'use strict';

    angular
        .module('app.cb.area-manager')
        .controller('areaManagerDetailController', areaManagerDetailController);


    areaManagerDetailController.$inject=['$state','$stateParams','$log','$mdDialog','AppAPI','Auth','DataService','Form'];
    /** @ngInject */
    function areaManagerDetailController($state,$stateParams,$log,$mdDialog,AppAPI,Auth,DataService,Form)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        // vm.DataTable= new DataService();
        vm.loadData=loadData;
        // vm.modulesAction=modulesAction; 
        // vm.toggleSelectedAll=toggleSelectedAll;
        vm.listAMDetSelected=[];
        vm.saveData=saveData;
        vm.deleteData=deleteData;
		    vm.loadSubArea = loadSubArea;
		    vm.selectedSubarea = '0';
		
        var AMid=$stateParams.id;

        // var Group=AppAPI.Group();
        var AreaManager=AppAPI.AreaManager();

        // set constructor form
        Form.setObject(AreaManager);

        // set form to controller
        vm.Form = Form;
        vm.Form.objForm.emp_area_manager_id=AMid;

        vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[ 
                    {link:'app.cb_area-manager',name:'Area Manager',active:'0'},
                    {link:'#',name:'Area Manager Detail',active:'0'}
                    ];

        vm.InputAmDetail=InputAmDetail;
        vm.editAmDetail=editAmDetail;
        vm.closeModal=closeModal;
        vm.toggle = toggle;
        vm.back = back;
        vm.list = [];
        vm.info = [];

        /* var response= Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
             vm.listGroupSelect=data;
             // console.log(vm.listGroupSelect);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          }); */

        // Data
        loadData(1);
		    loadSubArea();
        // Methods

        ////////// 

        // function loadData(pageno){
        //    vm.DataTable.loadData(Modules,pageno,{action:'view_action',modulesID:''});
        //    // console.log('test');
        // }

        function loadData(pageno) {
          angular.element.blockUI();
          var response= AreaManager.query({action:'viewDetail',id:AMid});
          response.$promise.then(function(data){
            vm.list = data[0].area;
            vm.info = data[0].info;
            angular.element.unblockUI();
          });
          response.$promise.catch(function(data){
             vm.list = [];
             vm.info = [];
            angular.element.unblockUI();
          });
        }


      function InputAmDetail(ev)
      {
        // console.log('modulesID'); 
        $mdDialog.show({
            controller         : 'areaManagerDetailController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/area-manager/detail/input-am-detail.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            }
        });
      }

      function editAmDetail(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditAMDetailController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/area-manager/detail/input-am-detail.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{
                  id:id
            }
        });
      }

      function closeModal()
        {
            $mdDialog.hide();
        }

      function clearMeesage() {
          vm.Form.tampilPesan=false;
      }

      function saveData(ev,formController) {
        vm.Form.objForm.date_formatted = formController.effective_date.$viewValue;
        var res=Auth.setToken();
         res.then(function(){
            var promise= Form.saveData('saveDetail', formController, AreaManager);
            promise.then(function(){
                showDialog(ev);
            });
         });
            
        }

        function showDialog(ev) {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
                loadData(1);
            });
        }

      function deleteData(ev) {
   
		  var promise=Auth.setToken();
		   promise.then(function(){
				  var confirm = $mdDialog.confirm()
			  .title('Would you like to delete this list?')
			  .textContent('All data your selected will be deleted and can not recovered.')
			  .ariaLabel('delete dialog')
			  .targetEvent(ev)
			  .ok('YES')
			  .cancel('no');

			  $mdDialog.show(confirm).then(function() {
				 angular.element.blockUI();
				 var response=AreaManager.delete({action:'deleteDetail',data:angular.toJson(vm.listAMDetSelected)});

				 response.$promise.then(function(){
					 angular.element.unblockUI();
					 loadData(1);
				 }); 
			  }, function() {
			   // $scope.status = 'You decided to keep your debt.';
			  });
		   });
  
   
		}
		
		function  loadSubArea()
        {
          var response=AreaManager.query({
			  action: 'getSubArea'
		  });
		  
          response.$promise.then(fetchArea);
          response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }

        function toggle(item, list) {
          var idx = list.indexOf(item);
          if (idx > -1) {
            list.splice(idx, 1);
          }
          else {
            list.push(item);
          }
        }
    
        function back() {
          $state.transitionTo('app.cb_area-manager');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.annual-leave-rules', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_annual_leave_rules', {
                url    : '/cb/annual-leave-rules',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/annual-leave-rules/index.html',
                        controller : 'AnnualLeaveRulesController as vm'
                    }
                }
            });
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.annual-leave-rules')
        .controller('EditAnnualLeaveRulesController', EditAnnualLeaveRulesController);


    EditAnnualLeaveRulesController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$log','$localStorage','Form','$timeout','data'];
    /** @ngInject */
    function EditAnnualLeaveRulesController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$log,$localStorage,Form,$timeout,data)
    {

      var vm = this;
      // initial form
      Form.initialForm();
      var AnnualLeaveRules=AppAPI.AnnualLeaveRules(); 
      var Attendancereport=AppAPI.Attendancereport();
      var levelGrade=AppAPI.Level();

      // set constructor form
      Form.setObject(AnnualLeaveRules);

      // set form to controller
      vm.Form = Form; 
      vm.closeModal=closeModal;
      vm.saveData=saveData;
      vm.setToken=Auth.setToken;

      vm.notif = {
          success: false,
          error: false
        }
      vm.messageTheme=''

      vm.listBU=[];
      vm.listCountry = [];
      vm.listEmpGrade = [];
      
      ///////////////////

      loadDataBU();
      loadDataCountry();
      loadDataGrade();

      setData();

      function setData()
      {
        vm.Form.objForm.id = data.id
        vm.Form.objForm.company = data.bu_id
        vm.Form.objForm.country = data.country_id
        vm.Form.objForm.emp_grade = data.emp_grade
        vm.Form.objForm.service_month_start = parseInt(data.service_month_start)
        vm.Form.objForm.service_month_end = parseInt(data.service_month_end)
        vm.Form.objForm.step_anniversary = parseInt(data.step_anniversary)
        vm.Form.objForm.annual_leave_total = parseInt(data.annual_leave_total)
        vm.Form.objForm.pay_leave_carry = data.is_pay_leave_carry
        vm.Form.objForm.max_carry = parseInt(data.max_carry)
        vm.Form.objForm.rule_pay = data.rule_pay
        vm.Form.objForm.effective_date = new Date(data.effective_date);
      }

      function loadDataBU() {
        var response=Attendancereport.query({action:'viewBu'})
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
        vm.listBU=data;
      }

      function errorFetchBU() {
        vm.listBU=[];
      }

      function loadDataCountry() {
        var response=AnnualLeaveRules.query({action:'getCountry'})
        response.$promise.then(fetchCountry);
        response.$promise.catch(errorFetchCountry);
      }

      function fetchCountry(data) {
        vm.listCountry=data;
      }

      function errorFetchCountry() {
        vm.listCountry=[];
      }

      function loadDataGrade() {
        var response=AnnualLeaveRules.query({action:'getListGrade'})
        response.$promise.then(fetchGrade);
        response.$promise.catch(errorFetchGrade);
      }

      function fetchGrade(data) {
        vm.listEmpGrade=data;
      }

      function errorFetchGrade() {
        vm.listEmpGrade=[];
      }

      function closeModal() {
        $mdDialog.hide();
      }

      function saveData(ev,data) {
        angular.element.blockUI();
        var promise= Form.saveData('update',data, AnnualLeaveRules);
          promise.then(function(response){
              if ( response.status == 0 ) {
                vm.notif.error = response.pesan;
                vm.notif.success = false;
                vm.messageTheme='pink';
              } else {
                vm.notif.error = false;
                vm.notif.success = response.pesan;
                vm.messageTheme='green';
                data.$setPristine();
              }
            
            $timeout(function() {
              vm.notif.error=false; 
              vm.notif.success=false; 
            }, 3000);
            angular.element.unblockUI();
          })
          .catch(function (response) {
            vm.notif.error = 'Internal server error'
            vm.notif.success = false;
            vm.messageTheme='pink';
            angular.element.unblockUI();
          });
      }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.annual-leave-rules')
        .controller('CreateAnnualLeaveRulesController', CreateAnnualLeaveRulesController);


    CreateAnnualLeaveRulesController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$log','$localStorage','Form','$timeout'];
    /** @ngInject */
    function CreateAnnualLeaveRulesController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$log,$localStorage,Form,$timeout)
    {

      var vm = this;
      // initial form
      Form.initialForm();
      var AnnualLeaveRules=AppAPI.AnnualLeaveRules(); 
      var Attendancereport=AppAPI.Attendancereport();
      var levelGrade=AppAPI.Level();

      // set constructor form
      Form.setObject(AnnualLeaveRules);

      // set form to controller
      vm.Form = Form; 
      vm.closeModal=closeModal;
      vm.saveData=saveData;
      vm.setToken=Auth.setToken;

      vm.notif = {
          success: false,
          error: false
        }
      vm.messageTheme=''

      vm.listBU=[];
      vm.listCountry = [];
      vm.listEmpGrade = [];
      
      ///////////////////

      loadDataBU();
      loadDataCountry();
      loadDataGrade();

      function loadDataBU() {
        var response=Attendancereport.query({action:'viewBu'})
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
        vm.listBU=data;
      }

      function errorFetchBU() {
        vm.listBU=[];
      }

      function loadDataCountry() {
        var response=AnnualLeaveRules.query({action:'getCountry'})
        response.$promise.then(fetchCountry);
        response.$promise.catch(errorFetchCountry);
      }

      function fetchCountry(data) {
        vm.listCountry=data;
      }

      function errorFetchCountry() {
        vm.listCountry=[];
      }

      function loadDataGrade() {
        var response=AnnualLeaveRules.query({action:'getListGrade'})
        response.$promise.then(fetchGrade);
        response.$promise.catch(errorFetchGrade);
      }

      function fetchGrade(data) {
        vm.listEmpGrade=data;
      }

      function errorFetchGrade() {
        vm.listEmpGrade=[];
      }

      function closeModal() {
        $mdDialog.hide();
      }

      function saveData(ev,data) {
        angular.element.blockUI();
        var promise= Form.saveData('saveData',data, AnnualLeaveRules);
          promise.then(function(response){
              if ( response.status == 0 ) {
                vm.notif.error = response.pesan;
                vm.notif.success = false;
                vm.messageTheme='pink';
              } else {
                vm.notif.error = false;
                vm.notif.success = response.pesan;
                vm.messageTheme='green';
                data.$setPristine();
              }
            
            $timeout(function() {
              vm.notif.error=false; 
              vm.notif.success=false; 
            }, 3000);
            angular.element.unblockUI();
          })
          .catch(function (response) {
            vm.notif.error = 'Internal server error'
            vm.notif.success = false;
            vm.messageTheme='pink';
            angular.element.unblockUI();
          });
      }

    }
})();

(function()
{
	angular
		.module('app.cb.am-team-assignment.input-am-team-assignment', [])
		.config(config);
		
	config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
   /** @ngInject */
    
	function config($stateProvider, $translatePartialLoaderProvider)
	{
        $stateProvider
            .state('app.cb_am_team_input_assignment', {
                url    : '/cb/am_team-input-assignment',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-team-assignment/input-am-team-assignment/input-am-team-assignment.html',
                        controller : 'AmInputTeamAssignmentController as vm'
                    }
                }
            })
            .state('app.cb_am_team_nso_input_assignment', {
                url    : '/cb/am_team-nso-input-assignment',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-team-assignment/input-am-team-assignment/input-am-team-nso-assignment.html',
                        controller : 'AmInputNSOTeamAssignmentController as vm'
                    }
                }
            });
	}
})();
(function () {
    'use strict';

    angular
        .module('app.cb.am-team-assignment.input-am-team-assignment')
        .controller('AmInputNSOTeamAssignmentController', AmInputNSOTeamAssignmentController)
        .directive('customRepeatDirective', function () {
            return function (scope, element, attrs) {
                if (scope.$last) {
                    angular.element.unblockUI();
                }
            };
        });
    /* @ngInject */
    AmInputNSOTeamAssignmentController.$inject = ['$localStorage', 'Form', 'AppAPI', 'config', 'Auth', '$timeout', '$mdDialog'];

    /* @ngInject */
    function AmInputNSOTeamAssignmentController($localStorage, Form, AppAPI, config, Auth, $timeout, $mdDialog) {
        var vm = this;        

        angular.element.blockUI();

        var Teamassignment = AppAPI.Teamassignment(); 
        Form.initialForm(false);
        Form.setObject(Teamassignment);
        vm.Form = Form;

        var initemployee = {
            nik: null,
            new_employee: true,
            benefits: [],
            benefit: [],
            distance: {id: null}
        };

        vm.Form.objForm.employee = [angular.copy(initemployee)];

        vm.selectedItem = [];
        vm.searchText = [];
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.getEmptyDataNULL = getEmptyDataNULL;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadDirectName = loadDirectName;

        vm.reloadToken = reloadToken;

        vm.addEmployee = addEmployee;
        vm.cancelEmployee = cancelEmployee;
        vm.textLength = 0;
        vm.getStrLength = getStrLength;
        vm.getMinLength = getMinLength;
        vm.getDetailDirectReport = getDetailDirectReport;
        vm.saveData = saveData;
        vm.directReportNamChanged = directReportNamChanged;
        vm.reinitEndDate = reinitEndDate;

        vm.clearSearchTermSA = clearSearchTermSA;
        vm.searchTermSA = '';

        vm.clearSearchTermCCC = clearSearchTermCCC;
        vm.searchTermCCC = '';

        vm.clearSearchTermCCNC = clearSearchTermCCNC;
        vm.searchTermCCNC = '';

        vm.tujanganAvail = [];

        vm.company = $localStorage.empsite;

        var init_date = new Date();
        vm.initDate = new Date(init_date.setDate(init_date.getDate() + 14));

        loadEmp();
        loadDescription();
        loadDataBU();
        loadSubArea();

        angular.element.unblockUI();

        function loadDirectName() {
            var codeCDD = vm.Form.objForm.company_id + vm.Form.objForm.dvision_id + vm.Form.objForm.department_id;
            var subAreaID = vm.Form.objForm.sub_area_id;
            var response = Teamassignment.query({
                action: 'viewDirectReportName',
                cddcode: vm.codeCDD,
                sub_area_id: subAreaID,
                start_date: !vm.Form.objForm.startDate ? '' : changeDateFormat(vm.Form.objForm.startDate)
            });
            response.$promise.then(fetchDirectName);
            response.$promise.catch(errorDirectName);
        }

        function fetchDirectName(data) {
            vm.listDirectName = data;
            initCostCenter(vm.Form.objForm.sub_area_id);
        }

        function errorDirectName() {
            vm.listDirectName = [];
        }

        function loadEmp() {
            var response = Teamassignment.query({
                action: 'getEmployeTeam',
                start_date: !vm.Form.objForm.startDate ? '' : changeDateFormat(vm.Form.objForm.startDate)
            });
            response.$promise.then(fetchEmp);
            response.$promise.catch(errorFetchEmp);
        }

        function fetchEmp(data) {
            vm.listEmp = data;
        }

        function errorFetchEmp() {
            vm.listEmp = [];
        }

        function loadDescription() {
            var response = Teamassignment.query({
                action: 'viewDescriptionCostCenter'
            });
            response.$promise.then(fetchDescription);
            response.$promise.catch(errorDescription);
        }

        function fetchDescription(data) {
            vm.listcnb = data[0].cnb;
            vm.listnoncnb = data[0].noncnb;
        }

        function errorDescription() {
            vm.listcnb = [];
            vm.listnoncnb = [];
        }

        function loadDataDepartment(iddivisi) {
            var response = Teamassignment.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Teamassignment.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Teamassignment.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = Teamassignment.query({
                action: 'viewSubArea'
            });
            response.$promise.then(fetchSubArea);
            response.$promise.catch(errorFetchSubArea);
        }

        function fetchSubArea(data) {
            vm.listSubArea = data;
        }

        function errorFetchSubArea() {
            vm.listSubArea = [];
        }

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            var results = query ? vm.listEmp.filter(createFilterFor(query)) : vm.listEmp,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        function searchTextChange(idx) {
            var keys = Object.keys(vm.Form.objForm.employee[idx]);
            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != 'new_employee') {
                    vm.Form.objForm.employee[idx][keys[i]] = null;
                } else {
                    vm.Form.objForm.employee[idx]['new_employee'] = false;
                }
            }
        }

        function selectedItemChange(item, idx) {
            if (item) {
                angular.element.blockUI();

                var keys = Object.keys(item);
                for (var i = 0; i < keys.length; i++) {
                    if (keys[i] != 'new_employee') {
                        vm.Form.objForm.employee[idx][keys[i]] = item[keys[i]];
                    }

                    if (idx == 0) {
                        if (keys[i] == 'company_id') {
                            vm.Form.objForm.company_id = item[keys[i]];
                            loadDataDivision(item[keys[i]]);
                        }

                        if (keys[i] == 'dvision_id') {
                            vm.Form.objForm.dvision_id = item[keys[i]];
                            console.log(item[keys[i]]);
                            loadDataDepartment(item[keys[i]]);
                        }

                        if (keys[i] == 'department_id') {
                            vm.Form.objForm.department_id = item[keys[i]];
                        }
                    }
                }

                vm.Form.objForm.employee[idx].nik = item.nik;

                angular.element.unblockUI();
                
            } else {
                vm.Form.objForm.employee[idx] = angular.copy(initemployee);
            }
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(data) {
                return (data.display.toLowerCase().indexOf(lowercaseQuery) > -1);
            };

        }

        function reloadToken() {
            Auth.setToken();
        }

        function getEmptyDataNULL(value) {
            return typeof value != 'undefined' && value != null && value != '' ? false : true;
        }

        function getDataAvail(idx) {
            return vm.tujanganAvail.includes(idx);
        }

        function cancelEmployee(e, idx) {
            if (vm.Form.objForm.employee[idx]) {
                vm.Form.objForm.employee.splice(idx, 1);
            }
        }

        function reinitEndDate(date) {
            var var_date = angular.copy(date);
            vm.initDate = new Date(var_date.setDate(var_date.getDate() + 14));
            const diffTime = Math.abs(vm.initDate - var_date);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            if (!vm.Form.objForm.endDate || diffDays < 14) {
                vm.Form.objForm.endDate = angular.copy(vm.initDate);
            }

            loadEmp();
        }

        function addEmployee(e) {
            vm.Form.objForm.employee.push(angular.copy(initemployee));
        }

        function getStrLength(textLength) {
            vm.textLength = typeof vm.Form.objForm.description != 'undefined' ? vm.Form.objForm.description.length : 0;
        }

        function getMinLength(textLength) {
            return typeof textLength != 'undefined' ? (textLength.length < 25 ? 'Masih dibawah 50 karakter' : textLength.length) : 'Masih dibawah 25 karakter';
        }

        function getDetailDirectReport(data) {
            if(typeof data != 'undefined') {
                if(data.am_state == '1') {
                    return '(AREA MANAGER)';
                }

                if(data.sic_state == '1') {
                    return '(' + 'STORE MANAGER - ' + data.area_name + ')';
                }

                return '(' + data.job_description + ' - ' + data.area_name + ')';
            }

            return '';
        }

        function initCostCenter(sub_area_id) {
            for (var i = 0; i < vm.listSubArea.length; i++) {
                if (vm.listSubArea[i].id == sub_area_id) {
                    for (var j = 0; j < vm.listcnb.length; j++) {
                        if (vm.listSubArea[i].description.trim() == vm.listcnb[j].description.trim()) {
                            vm.Form.objForm.cost_center_cnb = vm.listcnb[j].id;
                        }
                    }

                    for (var j = 0; j < vm.listnoncnb.length; j++) {
                        if (vm.listSubArea[i].description.trim() == vm.listnoncnb[j].description.trim()) {
                            vm.Form.objForm.cost_center_noncnb = vm.listnoncnb[j].id;
                        }
                    }
                }
            }
        }

        function changeDateFormat(date) {
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var year = date.getFullYear();
            return year + "-" + month + "-" + day;
        }

        function reloadToken() {
            Auth.setToken();
        }

        function getEmptyDataNIK(value) {
            console.log(value);
            return typeof value != 'undefined' && value != null && value != '' ? false : true;
        }

        function getDetailDirectReport(data) {
            if(typeof data != 'undefined') {
                if(data.am_state == '1') {
                    return '(AREA MANAGER)';
                }

                if(data.sic_state == '1') {
                    return '(' + 'STORE MANAGER - ' + data.area_name + ')';
                }

                return '(' + data.job_description + ' - ' + data.area_name + ')';
            }

            return '';
        }

        function saveData(ev, formController) {
            angular.element.blockUI();

            vm.Form.objForm.startDate_resolved = changeDateFormat(vm.Form.objForm.startDate);
            vm.Form.objForm.endDate_resolved = changeDateFormat(vm.Form.objForm.endDate);

            var response = Form.saveData('saveData', formController, Teamassignment);
            response.then(function (data) {
                vm.messageTheme = 'blue';
                formController.$setPristine();
                vm.Form.objForm.employee = [angular.copy(initemployee)];                
                vm.selectedItem = [];
                vm.searchText = [];

                if (data.status == 1) {
                    showDialog();
                } else {
                    showFailed(ev,data);
                }
                $timeout(function () {
                    vm.Form.tampilPesan = false;
                }, 3000);
                angular.element.unblockUI();
            });
            response.catch(function (data) {
                showFailed(ev,data);
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            });
        }

        function showDialog() {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success Save Data')
                .textContent('Process Data was Success.')
                .ariaLabel('Success Save Data')
                .ok('OK')
                .targetEvent()
            ).then(function () {
                // closeModal();
            });
        }        

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Save Data')
                .textContent(data.pesan)
                .ariaLabel('Failed Save Data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
        }

        function directReportNamChanged() {
            for (var i = 0; i < vm.listDirectName.length; i++) {
                if (vm.Form.objForm.directReport == vm.listDirectName[i].nik) {
                    vm.Form.objForm.directReport_type = 'employee';
                    if (vm.listDirectName[i].sic_id) {
                        vm.Form.objForm.directReport_type = 'sic';
                    }
                    if (vm.listDirectName[i].am_id) {
                        vm.Form.objForm.directReport_type = 'area manager';
                    }
                }
            }
        }

        function clearSearchTermSA() {
            vm.searchTermSA = '';
        }

        function clearSearchTermCCC() {
            vm.searchTermCCC = '';
        }

        function clearSearchTermCCNC() {
            vm.searchTermCCNC = '';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.am-team-assignment.input-am-team-assignment')
        .controller('AmInputTeamAssignmentController', AmInputTeamAssignmentController)
        .directive('customRepeatDirective', function () {
            return function (scope, element, attrs) {
                if (scope.$last) {
                    angular.element.unblockUI();
                }
            };
        });
    /* @ngInject */
    AmInputTeamAssignmentController.$inject = ['$localStorage', 'Form', 'AppAPI', 'config', 'Auth', '$timeout', '$mdDialog'];

    /* @ngInject */
    function AmInputTeamAssignmentController($localStorage, Form, AppAPI, config, Auth, $timeout, $mdDialog) {
        var vm = this;        

        angular.element.blockUI();

        var Teamassignment = AppAPI.Teamassignment(); 
        Form.initialForm(false);
        Form.setObject(Teamassignment);
        vm.Form = Form;

        var initemployee = {
            nik: null,
            new_employee: false,
            benefits: [],
            benefit: [],
            distance: {id: null}
        };

        vm.Form.objForm.employee = [angular.copy(initemployee)];

        vm.selectedItem = [];
        vm.searchText = [];
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.getEmptyDataNULL = getEmptyDataNULL;
        vm.onChangeDistance = onChangeDistance;
        vm.getDataAvail = getDataAvail;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadDirectName = loadDirectName;
        vm.reinitEndDate = reinitEndDate;

        vm.reloadToken = reloadToken;

        vm.addEmployee = addEmployee;
        vm.cancelEmployee = cancelEmployee;
        vm.textLength = 0;
        vm.getStrLength = getStrLength;
        vm.getMinLength = getMinLength;
        vm.getDetailDirectReport = getDetailDirectReport;
        vm.saveData = saveData;
        vm.directReportNamChanged = directReportNamChanged;

        vm.clearSearchTermSA = clearSearchTermSA;
        vm.searchTermSA = '';

        vm.clearSearchTermCCC = clearSearchTermCCC;
        vm.searchTermCCC = '';

        vm.clearSearchTermCCNC = clearSearchTermCCNC;
        vm.searchTermCCNC = '';

        vm.tujanganAvail = [];

        vm.company = $localStorage.empsite;
        
        var init_date = new Date();
        vm.initDate = new Date(init_date.setDate(init_date.getDate() + 14));

        loadEmp();
        loadDescription();
        loadDataBU();
        loadSubArea();
        loadDistances();
        loadBenefitsTitle();

        function loadDirectName() {
            var codeCDD = vm.Form.objForm.company_id + vm.Form.objForm.dvision_id + vm.Form.objForm.department_id;
            var subAreaID = vm.Form.objForm.sub_area_id;
            var response = Teamassignment.query({
                action: 'viewDirectReportName',
                cddcode: vm.codeCDD,
                sub_area_id: subAreaID,
                start_date: !vm.Form.objForm.startDate ? '' : changeDateFormat(vm.Form.objForm.startDate)
            });
            response.$promise.then(fetchDirectName);
            response.$promise.catch(errorDirectName);
        }

        function fetchDirectName(data) {
            vm.listDirectName = data;
            initCostCenter(vm.Form.objForm.sub_area_id);
        }

        function errorDirectName() {
            vm.listDirectName = [];
        }

        function loadEmp() {
            var response = Teamassignment.query({
                action: 'getEmployeTeam',
                start_date: !vm.Form.objForm.startDate ? '' : changeDateFormat(vm.Form.objForm.startDate)
            });
            response.$promise.then(fetchEmp);
            response.$promise.catch(errorFetchEmp);
        }

        function fetchEmp(data) {
            vm.listEmp = data;
        }

        function errorFetchEmp() {
            vm.listEmp = [];
        }

        function loadDescription() {
            var response = Teamassignment.query({
                action: 'viewDescriptionCostCenter'
            });
            response.$promise.then(fetchDescription);
            response.$promise.catch(errorDescription);
        }

        function fetchDescription(data) {
            vm.listcnb = data[0].cnb;
            vm.listnoncnb = data[0].noncnb;
        }

        function errorDescription() {
            vm.listcnb = [];
            vm.listnoncnb = [];
        }

        function loadDataDepartment(iddivisi) {
            var response = Teamassignment.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Teamassignment.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Teamassignment.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = Teamassignment.query({
                action: 'viewSubArea'
            });
            response.$promise.then(fetchSubArea);
            response.$promise.catch(errorFetchSubArea);
        }

        function fetchSubArea(data) {
            vm.listSubArea = data;
        }

        function errorFetchSubArea() {
            vm.listSubArea = [];
        }

        function loadDistances() {
            var response = Teamassignment.query({
                action: 'getDistances'
            });
            response.$promise.then(fetchDistances);
            response.$promise.catch(errorDistances);
        }

        function fetchDistances(data) {
            vm.listDistances = data;
            // vm.tujanganAvail = [];

            // for (var i = 0; i < vm.Form.objForm.employee.length; i++) {
            //     vm.Form.objForm.employee[i].distance = null;
            // }

            // for (var i = 0; i < data.length; i++) {
            //     vm.listDistances.push(data[i]);
            //     vm.tujanganAvail = data[i].groups;
            // }
        }

        function errorDistances() {
            vm.listDistances = [];
        }

        function loadBenefitsTitle() { 
            var response = Teamassignment.query({
                action: 'getBenefits',
                iddistance: null,
                nik: null,
                emp_grade: null,
                idx: null
            });
            response.$promise.then(fetchBenefitsTitle);
            response.$promise.catch(errorBenefitsTitle);
        }

        function fetchBenefitsTitle(data) {
            vm.listBenefitsTitle = data[0].benefits;
        }

        function errorBenefitsTitle() {
            vm.listBenefitsTitle = [];
            angular.element.unblockUI();
        }

        function loadBenefitsData(distance, nik, emp_grade, idx) { 
            angular.element.blockUI();
            
            var response = Teamassignment.query({
                action: 'getBenefits',
                iddistance: distance.id,
                nik: nik,
                emp_grade: emp_grade,
                idx: idx
            });
            response.$promise.then(fetchBenefitsData);
            response.$promise.catch(errorBenefitsData);
        }

        function fetchBenefitsData(data) {
            vm.Form.objForm.employee[parseInt(data[0].idx)].benefits = data[0].benefits;
                
            for (var i = 0; i < data[0].benefits.length; i++) {
                vm.Form.objForm.employee[parseInt(data[0].idx)].benefits[i].benefits.unshift({
                    id : 0,
                    description : 'None',
                    description_en : '',
                    amount : 0,
                    unit : '',
                    grade : 'None',
                    effective_date : '',
                    grouping : data[0].benefits[i].id,
                    company : vm.company,
                    code : '',
                    amount_formated : 0
                });

                if(data[0].nik) {
                    vm.Form.objForm.employee[parseInt(data[0].idx)].benefit = [];
                    for (var j = 0; j < data[0].benefits[i].benefits.length; j++) {
                        if(data[0].emp_grade == data[0].benefits[i].benefits[j].grade) {
                            vm.Form.objForm.employee[parseInt(data[0].idx)].benefit[i] = data[0].benefits[i].benefits[j].id;
                        }
                    }
                } else {
                    vm.Form.objForm.employee[parseInt(data[0].idx)].benefit[i] = null;
                }
            }

            angular.element.unblockUI();
        }

        function errorBenefitsData() {
            // vm.listBenefitsData = [];

            angular.element.unblockUI();
        }

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            var results = query ? vm.listEmp.filter(createFilterFor(query)) : vm.listEmp,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        function searchTextChange(idx) {
            var keys = Object.keys(vm.Form.objForm.employee[idx]);
            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != 'new_employee') {
                    vm.Form.objForm.employee[idx][keys[i]] = null;
                } else {
                    vm.Form.objForm.employee[idx]['new_employee'] = false;
                }
            }
        }

        function selectedItemChange(item, idx) {
            if (item) {
                angular.element.blockUI();

                var keys = Object.keys(item);
                for (var i = 0; i < keys.length; i++) {
                    if (keys[i] != 'new_employee') {
                        vm.Form.objForm.employee[idx][keys[i]] = item[keys[i]];
                    }

                    if (idx == 0) {
                        if (keys[i] == 'company_id') {
                            vm.Form.objForm.company_id = item[keys[i]];
                            loadDataDivision(item[keys[i]]);
                        }

                        if (keys[i] == 'dvision_id') {
                            vm.Form.objForm.dvision_id = item[keys[i]];
                            loadDataDepartment(item[keys[i]]);
                        }

                        if (keys[i] == 'department_id') {
                            vm.Form.objForm.department_id = item[keys[i]];
                        }
                    }
                }

                vm.Form.objForm.employee[idx].nik = item.nik;
                
                if (item.nik) {
                    vm.Form.objForm.employee[idx].distance = vm.listDistances[vm.listDistances.length - 1];
                } else {
                    vm.Form.objForm.employee[idx].distance = {id: null};
                }

                if (typeof vm.Form.objForm.employee[idx].distance === undefined || vm.Form.objForm.employee[idx].distance == null) {
                    vm.Form.objForm.employee[idx].distance = {id: null};
                    vm.Form.objForm.employee[idx].benefits = [];
                } else {
                    onChangeDistance(idx);
                }
            } else {
                vm.Form.objForm.employee[idx] = angular.copy(initemployee);
            }
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(data) {
                return (data.display.toLowerCase().indexOf(lowercaseQuery) > -1);
            };

        }

        function reloadToken() {
            Auth.setToken();
        }

        function getEmptyDataNULL(value) {
            return typeof value != 'undefined' && value != null && value != '' ? false : true;
        }

        function onChangeDistance(idx) {
            loadBenefitsData(vm.Form.objForm.employee[idx].distance, vm.Form.objForm.employee[idx].nik, vm.Form.objForm.employee[idx].emp_grade, idx);
        }

        function getDataAvail(idx) {
            return vm.tujanganAvail.includes(idx);
        }

        function cancelEmployee(e, idx) {
            if (vm.Form.objForm.employee[idx]) {
                vm.Form.objForm.employee.splice(idx, 1);
            }
        }

        function reinitEndDate(date) {
            var var_date = angular.copy(date);
            vm.initDate = new Date(var_date.setDate(var_date.getDate() + 14));
            const diffTime = Math.abs(vm.initDate - var_date);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            if (!vm.Form.objForm.endDate || diffDays < 14) {
                vm.Form.objForm.endDate = angular.copy(vm.initDate);
            }

            loadEmp();
        }

        function addEmployee(e) {
            vm.Form.objForm.employee.push(angular.copy(initemployee));
        }

        function getStrLength(textLength) {
            vm.textLength = typeof vm.Form.objForm.description != 'undefined' ? vm.Form.objForm.description.length : 0;
        }

        function getMinLength(textLength) {
            return typeof textLength != 'undefined' ? (textLength.length < 25 ? 'Masih dibawah 50 karakter' : textLength.length) : 'Masih dibawah 25 karakter';
        }

        function getDetailDirectReport(data) {
            if(typeof data != 'undefined') {
                if(data.am_state == '1') {
                    return '(AREA MANAGER)';
                }

                if(data.sic_state == '1') {
                    return '(' + 'STORE MANAGER - ' + data.area_name + ')';
                }

                return '(' + data.job_description + ' - ' + data.area_name + ')';
            }

            return '';
        }

        function initCostCenter(sub_area_id) {
            for (var i = 0; i < vm.listSubArea.length; i++) {
                if (vm.listSubArea[i].id == sub_area_id) {
                    for (var j = 0; j < vm.listcnb.length; j++) {
                        if (vm.listSubArea[i].description.trim() == vm.listcnb[j].description.trim()) {
                            vm.Form.objForm.cost_center_cnb = vm.listcnb[j].id;
                        }
                    }

                    for (var j = 0; j < vm.listnoncnb.length; j++) {
                        if (vm.listSubArea[i].description.trim() == vm.listnoncnb[j].description.trim()) {
                            vm.Form.objForm.cost_center_noncnb = vm.listnoncnb[j].id;
                        }
                    }
                }
            }
        }

        function changeDateFormat(date) {
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var year = date.getFullYear();
            return year + "-" + month + "-" + day;
        }

        function reloadToken() {
            Auth.setToken();
        }

        function getEmptyDataNIK(value) {
            console.log(value);
            return typeof value != 'undefined' && value != null && value != '' ? false : true;
        }

        function getDetailDirectReport(data) {
            if(typeof data != 'undefined') {
                if(data.am_state == '1') {
                    return '(AREA MANAGER)';
                }

                if(data.sic_state == '1') {
                    return '(' + 'STORE MANAGER - ' + data.area_name + ')';
                }

                return '(' + data.job_description + ' - ' + data.area_name + ')';
            }

            return '';
        }

        function saveData(ev, formController) {
            angular.element.blockUI();

            vm.Form.objForm.startDate_resolved = changeDateFormat(vm.Form.objForm.startDate);
            vm.Form.objForm.endDate_resolved = changeDateFormat(vm.Form.objForm.endDate);

            var response = Form.saveData('saveData', formController, Teamassignment);
            response.then(function (data) {
                vm.messageTheme = 'blue';
                formController.$setPristine();
                vm.Form.objForm.employee = [angular.copy(initemployee)];
                vm.selectedItem = [];
                vm.searchText = [];

                if (data.status == 1) {
                    showDialog();
                } else {
                    showFailed(ev,data);
                }
                $timeout(function () {
                    vm.Form.tampilPesan = false;
                }, 3000);
                angular.element.unblockUI();
            });
            response.catch(function () {
                showFailed(ev,data);
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            });
        }

        function showDialog() {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success Save Data')
                .textContent('Process Data was Success.')
                .ariaLabel('Success Save Data')
                .ok('OK')
                .targetEvent()
            ).then(function () {
                // closeModal();
            });
        }        

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Save Data')
                .textContent(data.pesan)
                .ariaLabel('Failed Save Data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
        }

        function directReportNamChanged() {
            for (var i = 0; i < vm.listDirectName.length; i++) {
                if (vm.Form.objForm.directReport == vm.listDirectName[i].nik) {
                    vm.Form.objForm.directReport_type = 'employee';
                    if (vm.listDirectName[i].sic_id) {
                        vm.Form.objForm.directReport_type = 'sic';
                    }
                    if (vm.listDirectName[i].am_id) {
                        vm.Form.objForm.directReport_type = 'area manager';
                    }
                }
            }
        }

        function clearSearchTermSA() {
            vm.searchTermSA = '';
        }

        function clearSearchTermCCC() {
            vm.searchTermCCC = '';
        }

        function clearSearchTermCCNC() {
            vm.searchTermCCNC = '';
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.am-team-assignment', ['app.cb.am-team-assignment.input-am-team-assignment'])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
      // Translation
        // $translatePartialLoaderProvider.addPart('app/main/employee/employe');

        // State
        $stateProvider
            .state('app.cb_am_team_assignment', {
                url    : '/cb/am_team-assignment',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-team-assignment/am-team-assignment.html',
                        controller : 'AmteamassignmentController as vm',
                        css: ['app/main/cb/am-team-assignment/am-team-assignment.scss']
                    }
                }
            });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.am-team-assignment')
        .controller('AmuploadfileAssignmentController', AmuploadfileAssignmentController);

    AmuploadfileAssignmentController.$inject = ['$mdDialog','$localStorage','FileUploader','config','DataService','AppAPI'];

    /* @ngInject */
    function AmuploadfileAssignmentController($mdDialog,$localStorage,FileUploader,config,DataService,AppAPI) {
        var vm = this;
        
        var Teamassignment = AppAPI.Teamassignment();

        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;
        vm.pesan="";
        vm.DataTable = new DataService();

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/teamassignment/uploadfile', 
           removeAfterUpload:true,
           alias:'fileassignment',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            vm.pesan='Success Upload Data Assignment';
            loadData(1);
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function(item)
        {
            var obj= JSON.parse(item._xhr.response);
            vm.pesan=obj.pesan;
            vm.UploadPhotoStateSucces=false;
            vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            loadData(1);
            $mdDialog.hide();
        }

        function loadData(pageno)
        {
            var resp=vm.DataTable.loadData(Teamassignment,pageno,{action:'viewData'});
        }
    }
})();
(function()
{
	angular
		.module('app.cb.sic.am-input-sic', [])
		.config(config);
		
	config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
	  /** @ngInject */
   /** @ngInject */
    
	function config($stateProvider, $translatePartialLoaderProvider)
	{
		$stateProvider
			.state('app.cb_sic_am-input-sic', {
				url : '/cb/am-store-incharge/am-input-sic',
				views : {
					'content@app' : {
						templateUrl : 'app/main/cb/am-store-incharge/am-input-sic/am-input-sic.html',
						controller	: 'AminputsicController as vm'
					}
				}
			})
		
		$stateProvider
			.state('app.cb_sic_am-edit-sic', {
				url : '/cb/am-store-incharge/am-edit-sic/:id',
				views : {
					'content@app' : {
						templateUrl : 'app/main/cb/am-store-incharge/am-input-sic/am-input-sic.html',
						controller	: 'AmeditsicController as vm'
					}
				}
			})
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.cb.sic.am-input-sic')
		.controller('AminputsicController', AminputsicController);
		
	AminputsicController.$inject=['$state', '$stateParams', '$localStorage', '$timeout', 'Form', 'AppAPI', 'Auth', '$filter'];
	/** @ngInject */
	function AminputsicController($state, $stateParams, $localStorage, $timeout, Form, AppAPI, Auth, $filter)
	{
		var vm = this;
		
		// initial form
		Form.initialForm();
		
		var AMStoreIncharge=AppAPI.AMStoreIncharge(); 
		
		// set constructor form
        Form.setObject(AMStoreIncharge);
		 
		// set form to controller
		vm.Form = Form
		
		vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
	                    {link:'app.cb.am-store-incharge',name:'SIC',active:'0'},
	                    {link:'#',name:'Input SIC',active:'0'}
                    ];
					
		vm.saveData = saveData;
        vm.querySearch = querySearch;
        vm.selectedItem = null;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.checkItemEmpty = checkItemEmpty;
		vm.back = back;
		vm.edit = false;
		vm.item = {};
		
		vm.clearMessage = clearMessage;
		vm.reloadToken = reloadToken;

        vm.searchTermSA = '';
      	vm.clearSearchTermSA = clearSearchTermSA;

        loadEmp();
		loadSubArea();

        function loadEmp() {
            var response=AMStoreIncharge.query({action:'getEmployeTeam'});
            response.$promise.then(fetchEmp);
            response.$promise.catch(errorFetchEmp);
        }
    
        function fetchEmp(data) {
            vm.listEmp=data;
        }
    
        function errorFetchEmp() {
            vm.listEmp=[];
        }
		
		function querySearch (query) {
        	var results = query ? vm.listEmp.filter(createFilterFor(query)) : vm.listEmp, deferred;
          	if (vm.simulateQuery) {
	            deferred = $q.defer();
	            $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
	            return deferred.promise;
          	} else {
            	return results;
          	}
        }

		function createFilterFor(query) {
          	var lowercaseQuery = query.toLowerCase();

          	return function filterFn(data) {
            	return (data.display.toLowerCase().indexOf(lowercaseQuery) > -1);
          	};
        }

        function searchTextChange() {
          	vm.Form.objForm.sic_nik = null;
  			vm.item = {};
        }

        function selectedItemChange(item) {
        	clearMessage();
        	if(typeof item != 'undefined') {
            	vm.Form.objForm.sic_nik = item.nik;	
            	vm.item = item;
        	} else {
          		vm.Form.objForm.sic_nik = null;
      			vm.item = {};
        	}
        }
		
		function saveData(formController) {
			angular.element.blockUI(); //untuk nampilin loading animation
            
            vm.Form.objForm.sic_effective_date_parsed = $filter('date')(Date.parse(formController.sic_effective_date.$modelValue), 'yyyy-MM-dd');

			var response = Form.saveData('save', formController, AMStoreIncharge);
			
			response.then(function() {
				vm.messageTheme = 'blue';
				angular.element.unblockUI();
				formController.$setPristine();
				$timeout(function() {
					vm.Form.tampilPesan = false;
				}, 3000);
			});
			
			response.catch(function() {
				vm.messageTheme = 'pink';
				angular.element.unblockUI();
			});
		}
		
		function clearMessage() {
			vm.Form.tampilPesan = false;
		}
		
		function reloadToken() {
			Auth.setToken();
		}
		
		function back() {
			$state.transitionTo('app.cb_am-store-incharge');
		}

		function loadSubArea() {
          var response = AMStoreIncharge.query({
			  action: 'viewSubArea'
		  });
		  
          response.$promise.then(fetchArea);
          response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
          vm.listSubArea = data;
        }

        function errorfetchArea(data) {
          vm.listSubArea = [];
        }
		
      	function clearSearchTermSA() {
	        vm.searchTermSA = '';
    	}

        function checkItemEmpty() {
            return angular.equals(vm.item, {});
        }
	}
})();
(function()
{
	'use strict';
	
	angular
		.module('app.cb.sic.am-input-sic')
		.controller('AmeditsicController', AmeditsicController);
		
	AmeditsicController.$inject=['$state', '$stateParams', '$localStorage', '$log', '$timeout', 'Form', 'AppAPI'];
	/** @ngInject */
	function AmeditsicController($state, $stateParams, $localStorage, $log, $timeout, Form, AppAPI)
	{
		var vm = this;
		
		// initial form
		Form.initialForm();
		
		var StoreIncharge=AppAPI.AMStoreIncharge(); 
		vm.listModulSelected=[];
		// set constructor form
        Form.setObject(StoreIncharge);
		 
		// set form to controller
		vm.Form = Form;

		vm.subarea_id = null;
		
		vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
                    {link:'app.cb.am-store-incharge',name:'SIC',active:'0'},
                    {link:'#',name:'Edit SIC',active:'0'}
                    ];
		
		var response = vm.Form.objForm.$get({action : 'detailEdit', id:$stateParams.id});
		
		response.then(function(data){
			vm.Form.objForm.sic_effective_date = new Date(data.sic_effective_date);

			vm.subarea_id = data.sic_subarea;	
			loadSubArea();
		});
				
		vm.saveData = saveData;
		vm.back = back;
		vm.edit = true;
		
		vm.clearMessage = clearMessage;
		vm.reloadToken = reloadToken;
				
		function saveData(formController) {
			angular.element.blockUI(); //untuk nampilin loading animation
			var response = Form.updateData('update', formController, StoreIncharge, $stateParams.id, 'detailEdit');
			
			response.then(function(data) {
				vm.Form.objForm.sic_effective_date = new Date(data.sic_effective_date);
				vm.messageTheme = 'blue';
				angular.element.unblockUI();
				formController.$setPristine();
				
				$timeout(function() {
					vm.Form.tampilPesan = false;
				}, 3000);
			});
			
			response.catch(function() {
				vm.messageTheme = 'pink';	
				angular.element.unblockUI();
		  		$state.go('app.cb_am-store-incharge', {});
			});
		}
		
		function clearMessage() {
			vm.Form.tampilPesan=false;
		}
		
		function reloadToken() {
			Auth.setToken();
		}
		
		function back() {
			$state.transitionTo('app.cb_am-store-incharge');
		}

		function loadSubArea(defaultVal) {
          var response=StoreIncharge.query({
			  action: 'viewSubArea'
		  });

          response.$promise.then(function (data) {
			vm.listSubArea = data;
			vm.Form.objForm.sic_subarea = vm.subarea_id;
          });
          response.$promise.catch(errorfetchArea);
        }

        function errorfetchArea(data) {
          vm.listSubArea=[];
        }
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.admin-department.input', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_admin_department_input', {
                url    : '/cb/admin-department/input',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/admin-department/input/input.html',
                        controller : 'AdminDepartmentInputController as vm'
                    }
                }
            })
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.admin-department.input')
        .controller('AdminDepartmentInputController', AdminDepartmentInputController);


    AdminDepartmentInputController.$inject=['$state','$mdDialog','$localStorage','$timeout','Form','AppAPI','Auth','$log','DataService'];
    /** @ngInject */
    function AdminDepartmentInputController($state,$mdDialog,$localStorage,$timeout,Form,AppAPI,Auth,$log,DataService)
    {

        var vm = this;

        // initial form
        Form.initialForm();

        var AdminDepartment = AppAPI.AdminDepartment();
        var Completeness=AppAPI.Completeness();

        // set constructor form
        Form.setObject(AdminDepartment);

        // set form to controller
        vm.Form = Form;

        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.closeModal=closeModal;

        vm.listSubArea = [];
        vm.listGedung = [];
        vm.getListGedung = getListGedung
        vm.getListSector = getListSector
        vm.getListGroupShift = getListGroupShift
        vm.sector = [];
        vm.toggle = toggle;
        vm.exists = exists; 
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.selectedSector = [];

        vm.save = save
        vm.notif = {
            success: false,
            error: false
          }
        vm.messageTheme=''

        vm.Form.objForm.department_id = ''
        vm.isSector = false;
        vm.isSectorStatus = isSectorStatus;
        vm.reloadToken=reloadToken;
        vm.back=back;
        vm.stateEdit=false;
        // vm.saveData=saveData;
        // vm.Form.objForm.nik=$localStorage.user;
        vm.clearMeesage=clearMeesage;
        // vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        // vm.toggleCheck = toggleCheck;
        vm.listOtselected=[];
        vm.changeOTType=changeOTType;
        // vm.Form.objForm.resthour = 0;
        /*=====================*/

        getListSubArea();
        getListGroupShift();

        function getListSubArea() {
          var response= AdminDepartment.query({action:'getSelectListArea'});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
          vm.listSubArea=data;
        }

        function errorFetchArea() {
          vm.listSubArea=[];
        } 

        function getListGedung(subareaId)
        {
          var response= AdminDepartment.query({action:'getSelectListGedung',sub_area_id:subareaId});
          response.$promise.then(fetchGedung);
          response.$promise.catch(errorFetchGedung);
        }

        function fetchGedung(data) {
          vm.listGedung=data;
        }

        function errorFetchGedung() {
          vm.listGedung=[];
        } 

        // function getSelectListEmployee(pageno)
        // {
        //   var resp=vm.DataTable.loadData(AdminDepartment,pageno,{action:'getSelectListEmployee',gedung_id:vm.Form.objForm.gedung});
        // }

        function save(ev,formController) {
            angular.element.blockUI();
            var promise=Form.saveData('save', formController, AdminDepartment);
            promise.then(function(response){
                if ( response.status == 0 ) {
                  vm.notif.error = response.pesan;
                  vm.notif.success = false;
                  vm.messageTheme='pink';
                } else {
                  vm.notif.error = false;
                  vm.notif.success = response.pesan;
                  vm.messageTheme='green';
                  formController.$setPristine();
                }
              
              $timeout(function() {
                vm.notif.error=false; 
                vm.notif.success=false; 
              }, 6000);
              angular.element.unblockUI();
            })
            .catch(function (response) {
              vm.notif.error = 'Internal server error'
              vm.notif.success = false;
              vm.messageTheme='pink';
              angular.element.unblockUI();
            });
        }

        function closeModal() {
          $mdDialog.hide();
        } 
 

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.cb_employe_overtime');
        }

        function changeOTType()
        {
          // vm.Form.objForm.isafter=null;
        }
        
        function isSectorStatus(param)
        {
            if(param=="all"){
                vm.isSector = false;
            }else{
                vm.isSector = true;
            }
        }

        function getListSector(buildingId)
        {
            angular.element.blockUI();
            var resp=Completeness.query({action:'viewSector',buildingId:buildingId});
            resp.$promise.then(function(data) {
                vm.listSector = data
                vm.Form.objForm.sector_id = 'all';
                angular.element.unblockUI();
            });
            resp.$promise.catch(function(data){
                vm.listSector = []
                angular.element.unblockUI();
            });    
        }

        function getListGroupShift()
        {
          var response= AdminDepartment.query({action:'getListGroupShift'});
          response.$promise.then(fetchGroupShift);
          response.$promise.catch(errorFetchGroupShift);
        }

        function fetchGroupShift(data) {
          vm.listGroupShift=data;
        }

        function errorFetchGroupShift() {
          vm.listGroupShift=[];
        } 

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        } 

        function isChecked() {
            return vm.selectedSector.length === vm.sector.length;
        }

        function toggleAll() {
            if (vm.selectedSector.length === vm.sector.length) {
                vm.selectedSector = [];
            } else if (
                vm.selectedSector.length === 0 ||
                vm.selectedSector.length > 0
            ) {
                vm.selectedSector = vm.sector.slice(0);
            }
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.behivor.ref', [])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.behivor_ref', {
                url    : '/behivor/ref',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/behivor/ref/ref.html',
                        controller : 'RefController as vm'
                    }
                }
            });

        
    }
})();
(function() {
    'use strict';

    angular
        .module('app.behivor.ref')
        .controller('inputrefController', inputrefController);

    
    /* @ngInject */
    inputrefController.$inject=['$mdDialog','$http','config','Form','AppAPI','Auth'];
    function inputrefController($mdDialog,$http,config,Form,AppAPI,Auth) 
    {
        var vm = this;
        vm.title = 'Controller';
        vm.hide=hide;
        vm.cancel=cancel;
        vm.isDisabled=false;
        vm.saveData=saveData;
        vm.messageTheme='';

         // initial form
        Form.initialForm();

         // get constructor form
        var Behivor=AppAPI.Behivor();

         // set constructor form
        Form.setObject(Behivor);

        // set form to controller
        vm.Form = Form; 

        vm.setToken=Auth.setToken;

        ////////////////
        function hide()
        {
          $mdDialog.hide();
        }
       
        function cancel()
        {
       	  $mdDialog.cancel();
        }

        function saveData(ev,formController)
        {
          var promise= Form.saveData('saveref', formController, Behivor);

          promise.then(successSaveData);
          promise.catch(failedSaveData);
        }

        function successSaveData()
        {
          vm.messageTheme='green';
        }

        function failedSaveData()
        {
          vm.messageTheme='red';
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.behivor.ref')
        .controller('editrefController', editrefController);

    
    /* @ngInject */
    editrefController.$inject=['$mdDialog','$http','ref','config','Form','AppAPI','Auth'];
    function editrefController($mdDialog,$http,ref,config,Form,AppAPI,Auth) 
    {
        var vm = this;
        vm.title = 'Controller';
        vm.hide=hide;
        vm.cancel=cancel;
        vm.ref=ref;
        vm.isDisabled=false;
        vm.saveData=saveData;
        vm.messageTheme='';

         // initial form
        Form.initialForm();

         // get constructor form
        var Behivor=AppAPI.Behivor();

         // set constructor form
        Form.setObject(Behivor);

        // set form to controller
        vm.Form = Form; 

        var response=vm.Form.objForm.$get({action:'viewrefdetail',id:vm.ref.id});

        vm.setToken=Auth.setToken;

        ////////////////
        function hide()
        {
          $mdDialog.hide();
        }
       
        function cancel()
        {
          $mdDialog.cancel();
        }

        function saveData(ev,formController)
        {
          var promise= Form.updateData('updateref', formController, Behivor, vm.ref.id, 'viewrefdetail');

          promise.then(successSaveData);
          promise.catch(failedSaveData);
        }

        function successSaveData()
        {
          vm.messageTheme='green';
        }

        function failedSaveData()
        {
          vm.messageTheme='red';
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.behivor.input', [])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.behivor_input', {
                url    : '/behivor/input',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/behivor/input/input.html',
                        controller : 'InputController as vm'
                    }
                }
            });

        
    }
})();
(function() {
    'use strict';

    angular
        .module('app.behivor.input')
        .controller('inputinputController', inputinputController);

    
    /* @ngInject */
    inputinputController.$inject=['$mdDialog','$http','listInput','config','Form','AppAPI','Auth'];
    function inputinputController($mdDialog,$http,listInput,config,Form,AppAPI,Auth) 
    {
        var vm = this;
        vm.title = 'Input';
        vm.hide=hide;
        vm.cancel=cancel;
        vm.isDisabled=false;
        vm.saveData=saveData;
        vm.messageTheme='';
        vm.listInput = listInput;
        vm.listBid = [];
        vm.effectiveDate = '';

         // initial form
        Form.initialForm();

         // get constructor form
        var Behivor=AppAPI.Behivor();

         // set constructor form
        Form.setObject(Behivor);

        // set form to controller
        vm.Form = Form;
        angular.forEach(vm.listInput,function(obj, key){
            vm.listBid[key] = obj.bId;
            vm.effectiveDate = obj.effectiveDate;
        });

        vm.Form.objForm.bId = vm.listBid;
        vm.Form.objForm.effectiveDate = vm.effectiveDate;

        vm.setToken=Auth.setToken;

        ////////////////
        function hide()
        {
          $mdDialog.hide();
        }
       
        function cancel()
        {
       	  $mdDialog.cancel();
        }

        function saveData(ev,formController)
        {
          var promise= Form.saveData('saveinput', formController, Behivor);

          promise.then(successSaveData);
          promise.catch(failedSaveData);
        }

        function successSaveData()
        {
          vm.messageTheme='green';
        }

        function failedSaveData()
        {
          vm.messageTheme='red';
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.behivor.input')
        .controller('editinputController', editinputController);

    
    /* @ngInject */
    editinputController.$inject=['$mdDialog','$http','listInput','config','Form','AppAPI','Auth'];
    function editinputController($mdDialog,$http,listInput,config,Form,AppAPI,Auth) 
    {
        var vm = this;
        vm.title = 'Edit';
        vm.hide=hide;
        vm.cancel=cancel;
        vm.isDisabled=false;
        vm.saveData=saveData;
        vm.messageTheme='';
        vm.listInput = listInput;
        vm.listBid = [];
        vm.listId = [];
        vm.effectiveDate = '';

         // initial form
        Form.initialForm();

         // get constructor form
        var Behivor=AppAPI.Behivor();

         // set constructor form
        Form.setObject(Behivor);

        // set form to controller
        vm.Form = Form; 
        angular.forEach(vm.listInput,function(obj, key){
            vm.listBid[key] = obj.bId;
            vm.listId[key] = obj.id;
            vm.effectiveDate = obj.effectiveDate;
        });

        vm.Form.objForm.bId = vm.listBid;
        vm.Form.objForm.id = vm.listId;
        vm.Form.objForm.effectiveDate = vm.effectiveDate;

        vm.setToken=Auth.setToken;

        ////////////////
        function hide()
        {
          $mdDialog.hide();
        }
       
        function cancel()
        {
          $mdDialog.cancel();
        }

        function saveData(ev,formController)
        {
          var promise= Form.saveData('updateinput', formController, Behivor);

          promise.then(successSaveData);
          promise.catch(failedSaveData);
        }

        function successSaveData(data)
        {
          vm.messageTheme='green';
          vm.Form.objForm.effectiveDate=new Date(data.effectiveDate);
          vm.listSelected = data.refId;
        }

        function failedSaveData()
        {
          vm.messageTheme='red';
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.behivor.config', [])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.behivor_config', {
                url    : '/behivor/config',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/behivor/config/config.html',
                        controller : 'ConfigController as vm'
                    }
                }
            });

        
    }
})();
(function() {
    'use strict';

    angular
        .module('app.behivor.config')
        .controller('inputconfigController', inputconfigController);

    
    /* @ngInject */
    inputconfigController.$inject=['$mdDialog','$http','listRef','config','Form','AppAPI','Auth'];
    function inputconfigController($mdDialog,$http,listRef,config,Form,AppAPI,Auth) 
    {
        var vm = this;
        vm.title = 'New';
        vm.hide=hide;
        vm.cancel=cancel;
        vm.isDisabled=false;
        vm.saveData=saveData;
        vm.messageTheme='';
        vm.listSelected = [];
        vm.listRef = listRef;

         // initial form
        Form.initialForm();

         // get constructor form
        var Behivor=AppAPI.Behivor();

         // set constructor form
        Form.setObject(Behivor);

        // set form to controller
        vm.Form = Form; 

        vm.setToken=Auth.setToken;

        ////////////////
        function hide()
        {
          $mdDialog.hide();
        }
       
        function cancel()
        {
       	  $mdDialog.cancel();
        }

        function saveData(ev,formController)
        {
          var promise= Form.saveData('saveconfig', formController, Behivor);

          promise.then(successSaveData);
          promise.catch(failedSaveData);
        }

        function successSaveData()
        {
          vm.messageTheme='green';
        }

        function failedSaveData()
        {
          vm.messageTheme='red';
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.behivor.config')
        .controller('editconfigController', editconfigController);

    
    /* @ngInject */
    editconfigController.$inject=['$mdDialog','$http','cfg','listRef','config','Form','AppAPI','Auth'];
    function editconfigController($mdDialog,$http,cfg,listRef,config,Form,AppAPI,Auth) 
    {
        var vm = this;
        vm.title = 'Edit';
        vm.hide=hide;
        vm.cancel=cancel;
        vm.cfg=cfg;
        vm.isDisabled=false;
        vm.saveData=saveData;
        vm.messageTheme='';
        vm.listSelected = [];
        vm.listRef = listRef;

         // initial form
        Form.initialForm();

         // get constructor form
        var Behivor=AppAPI.Behivor();

         // set constructor form
        Form.setObject(Behivor);

        // set form to controller
        vm.Form = Form; 

        var response=vm.Form.objForm.$get({action:'viewconfigdetail',id:vm.cfg.idCfg});
        response.then(changeDate);

        vm.setToken=Auth.setToken;

        ////////////////
        function changeDate(data) {
           vm.Form.objForm.effectiveDate=new Date(data.effectiveDate);
           vm.Form.objForm.oldDate=new Date(data.effectiveDate);
           vm.listSelected = data.refId;
        }

        function hide()
        {
          $mdDialog.hide();
        }
       
        function cancel()
        {
          $mdDialog.cancel();
        }

        function saveData(ev,formController)
        {
          var promise= Form.updateData('updateconfig', formController, Behivor, vm.cfg.idCfg, 'viewconfigdetail');

          promise.then(successSaveData);
          promise.catch(failedSaveData);
        }

        function successSaveData(data)
        {
          vm.messageTheme='green';
          vm.Form.objForm.effectiveDate=new Date(data.effectiveDate);
          vm.listSelected = data.refId;
        }

        function failedSaveData()
        {
          vm.messageTheme='red';
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'angular-jwt'
            ]);
})();
(function () {
    "use strict";

    angular.module("app.core").directive("chartTurnOver", chartTurnOver);

    /** @ngInject */
    function chartTurnOver($document) {
        return {
            restrict: "E",
            scope: {
                chartId: "=chartId",
            },
            template: "<div id='chartTurOver'></div>",
            replace: true,
            link: function ($scope) {
                var chart = am4core.create("chartTurOver", am4charts.XYChart);
                var months = [
                    "jan",
                    "feb",
                    "mar",
                    "apr",
                    "mei",
                    "jun",
                    "jul",
                    "aug",
                    "sep",
                    "oct",
                    "nov",
                    "dec",
                ];

                chart.paddingRight = 20;

                function randNumber(min, max) {
                    return Math.floor(Math.random() * (max - min + 1)) + min;
                }

                var data = [];
                var visits = 0;
                var num = [
                    12.5,
                    10.3,
                    4.4,
                    10,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                ];
                for (var i = 0; i < 12; i++) {
                    visits = num[i];
                    data.push({
                        month: months[i],
                        value: visits,
                    });
                }

                chart.data = data;
                chart.cursor = new am4charts.XYCursor();

                var categoryAxis = chart.xAxes.push(
                    new am4charts.CategoryAxis()
                );
                categoryAxis.dataFields.category = "month";
                categoryAxis.title.text = "Month";
                categoryAxis.renderer.minGridDistance = 20;

                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.title.text = "Turn Over Rate";
                valueAxis.min = 0;
                valueAxis.extraMax = 0.2;

                var series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.valueY = "value";
                series.dataFields.categoryX = "month";
                series.name = "rate";
                series.tooltipText = "{name}: [bold]{valueY}[/]";
                series.strokeWidth = 2;
                series.fill = am4core.color("#009688");
                series.stroke = am4core.color("#009688");
                series.yAxis = valueAxis;
                series.tensionX = 0.8;
                series.showOnInit = false;

                var circleBullet = series.bullets.push(
                    new am4charts.CircleBullet()
                );
                circleBullet.circle.stroke = am4core.color("#fff");
                circleBullet.circle.strokeWidth = 2;

                var labelBullet = series.bullets.push(
                    new am4charts.LabelBullet()
                );
                labelBullet.label.text = "{value} %";
                labelBullet.label.dy = -20;
                labelBullet.label.fill = am4core.color("#009688");

                $scope.$on("$destroy", function () {
                    chart.dispose();
                });
            },
        };
    }
})();

(function () {
    "use strict";

    angular.module("app.core").directive("peopleCostChart", peopleCostChart);

    /** @ngInject */
    function peopleCostChart($document) {
        return {
            restrict: "E",
            scope: {
                chartId: "=chartId",
            },
            template: "<div id='peoplecost'></div>",
            replace: true,
            link: function ($scope) {
                var chart = am4core.create("peoplecost", am4charts.XYChart);
                var months = [
                    "jan",
                    "feb",
                    "mar",
                    "apr",
                    "mei",
                    "jun",
                    "jul",
                    "aug",
                    "sep",
                    "oct",
                    "nov",
                    "dec",
                ];

                chart.paddingRight = 20;

                function randNumber(min, max) {
                    return Math.floor(Math.random() * (max - min + 1)) + min;
                }

                var data = [];
                var hcActual = 0;
                var hcPlanning = 0;
                var costActual = 0;
                var costPlanning = 0;
                var listHC = [5923, 5783, 5634, 5792, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                var listHCPlan = [5983, 5763, 5734, 5799, 5799, 5799, 5799, 5899, 5899, 5690, 5690, 5790, 5685];
                var listHCCost = [2051661232, 2061201232, 2151761232, 2871691032, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                var listHCCostPlan = [2051771232, 2065261232, 2151761232, 2871691032, 2871691032, 2871691032, 2871691032, 2871691032, 2871691032, 2871691032, 2420691032, 2850691032, 2861691032];
                for (var i = 0; i < 12; i++) {
                    hcActual = listHC[i];
                    hcPlanning = listHCPlan[i];
                    costActual = listHCCost[i];
                    costPlanning = listHCCostPlan[i];
                    data.push({
                        month: months[i],
                        hcActual: hcActual,
                        hcPlanning: hcPlanning,
                        costActual: costActual,
                        costPlanning: costPlanning,
                    });
                }

                chart.data = data;
                chart.cursor = new am4charts.XYCursor();

                var categoryAxes = chart.xAxes.push(
                    new am4charts.CategoryAxis()
                );
                categoryAxes.dataFields.category = "month";
                categoryAxes.title.text = "Months";
                categoryAxes.title.fill = am4core.color("#000");
                categoryAxes.renderer.labels.template.fill = am4core.color(
                    "#000"
                );
                categoryAxes.renderer.minGridDistance = 20;

                var headcountAxes = chart.yAxes.push(new am4charts.ValueAxis());
                headcountAxes.title.text = "Headcounts";
                headcountAxes.renderer.labels.template.fill = am4core.color(
                    "#000"
                );
                headcountAxes.title.fill = am4core.color("#000");

                headcountAxes.renderer.grid.template.strokeOpacity = 0.2;
                headcountAxes.renderer.grid.template.stroke = am4core.color(
                    "#000"
                );
                headcountAxes.renderer.grid.template.strokeWidth = 1;

                var costAxes = chart.yAxes.push(new am4charts.ValueAxis());
                costAxes.title.text = "Costs (million)";
                costAxes.renderer.opposite = true;
                costAxes.renderer.labels.template.fill = am4core.color("#000");
                costAxes.title.fill = am4core.color("#000");

                var hcPlanningSeries = chart.series.push(
                    new am4charts.ColumnSeries()
                );
                hcPlanningSeries.dataFields.valueY = "hcPlanning";
                hcPlanningSeries.dataFields.categoryX = "month";
                hcPlanningSeries.name = "Headcount Planning";
                hcPlanningSeries.tooltipText = "{name}: [bold]{valueY}[/]";
                hcPlanningSeries.fill = am4core.color("#8BC34A");
                hcPlanningSeries.fillOpacity = 0.5;
                hcPlanningSeries.stroke = am4core.color("#8BC34A");
                hcPlanningSeries.showOnInit = false;

                var hcActualSeries = chart.series.push(
                    new am4charts.ColumnSeries()
                );
                hcActualSeries.dataFields.valueY = "hcActual";
                hcActualSeries.dataFields.categoryX = "month";
                hcActualSeries.name = "Headcount Actual";
                hcActualSeries.tooltipText = "{name}: [bold]{valueY}[/]";
                hcActualSeries.fill = am4core.color("#00BCD4");
                hcActualSeries.fillOpacity = 0.5;
                hcActualSeries.stroke = am4core.color("#00BCD4");
                hcActualSeries.showOnInit = false;

                var costPlanningSeries = chart.series.push(
                    new am4charts.LineSeries()
                );
                costPlanningSeries.dataFields.valueY = "costPlanning";
                costPlanningSeries.dataFields.categoryX = "month";
                costPlanningSeries.name = "Cost Planning";
                costPlanningSeries.tooltipText = "{name}: [bold]{valueY}[/]";
                costPlanningSeries.strokeWidth = 2;
                costPlanningSeries.fill = am4core.color("#FFC107");
                costPlanningSeries.stroke = am4core.color("#FFC107");
                costPlanningSeries.yAxis = costAxes;
                costPlanningSeries.tensionX = 0.8;
                costPlanningSeries.showOnInit = false;

                var costPlanningBullet = costPlanningSeries.bullets.push(
                    new am4charts.CircleBullet()
                );
                costPlanningBullet.circle.stroke = am4core.color("#000");
                costPlanningBullet.circle.strokeWidth = 2;

                var costActualSeries = chart.series.push(
                    new am4charts.LineSeries()
                );
                costActualSeries.dataFields.valueY = "costActual";
                costActualSeries.dataFields.categoryX = "month";
                costActualSeries.name = "Cost Actual";
                costActualSeries.tooltipText = "{name}: [bold]{valueY}[/]";
                costActualSeries.strokeWidth = 2;
                costActualSeries.fill = am4core.color("#E64A19");
                costActualSeries.stroke = am4core.color("#E64A19");
                costActualSeries.yAxis = costAxes;
                costActualSeries.tensionX = 0.8;
                costActualSeries.showOnInit = false;

                var costActualBullet = costActualSeries.bullets.push(
                    new am4charts.CircleBullet()
                );
                costActualBullet.circle.stroke = am4core.color("#000");
                costActualBullet.circle.strokeWidth = 2;

                // Add legend
                chart.legend = new am4charts.Legend();
                chart.legend.labels.template.fill = am4core.color("#000");
                chart.legend.fontSize = 10;
                chart.legend.position = "top";

                $scope.$on("$destroy", function () {
                    chart.dispose();
                });
            },
        };
    }
})();

(function () {
    "use strict";

    angular.module("app.core").directive("peformanceChart", peformanceChart);

    /** @ngInject */
    function peformanceChart($document) {
        return {
            restrict: "E",
            scope: {
                chartId: "=chartId",
                data: "=data",
            },
            template: "<div id={{chartId}}></div>",
            replace: true,
            link: function ($scope) {
                setTimeout(function () {
                    var chart = am4core.create(
                        $scope.chartId,
                        am4charts.GaugeChart
                    );
                    chart.hiddenState.properties.opacity = 0;
                    chart.fontSize = 11;
                    chart.innerRadius = -15;
                    chart.resizable = true;

                    var axis = chart.xAxes.push(new am4charts.ValueAxis());
                    axis.min = 0;
                    axis.max = 100;
                    axis.strictMinMax = true;

                    axis.renderer.grid.template.disabled = true;
                    axis.renderer.labels.template.bent = true;
                    axis.renderer.labels.template.radius = 10;
                    // axis.renderer.labels.template.fill = am4core.color("#fff");
                    axis.renderer.labels.template.fontWeight = "bold";
                    axis.renderer.labels.template.fillOpacity = 0.8;
                    axis.renderer.ticks.template.length = 10;

                    var ranges = [
                        {
                            min: 0,
                            max: 25,
                            color: "#545454",
                            label: "Very Dissatisfied",
                        },
                        {
                            min: 25,
                            max: 50,
                            color: "#DC6A67",
                            label: "Dissatisfied",
                        },
                        {
                            min: 50,
                            max: 75,
                            color: "#DCD268",
                            label: "Satisfied",
                        },
                        {
                            min: 75,
                            max: 100,
                            color: "#7CDD68",
                            label: "Very Satisfied",
                        },
                    ];

                    ranges.map(function (val) {
                        var range = axis.axisRanges.create();
                        range.axisFill.fill = am4core.color(val.color);
                        range.axisFill.fillOpacity = 1;
                        range.axisFill.zIndex = -1;
                        range.value = val.min;
                        range.endValue = val.max;
                        range.grid.strokeOpacity = 0;
                        range.label.fontSize = "0.9em";
                    });

                    var hand = chart.hands.push(new am4charts.ClockHand());
                    hand.value = $scope.data.percentage;
                    hand.innerRadius = am4core.percent(60);
                    hand.startWidth = 5;
                    hand.width = 5;
                    hand.pin.disabled = true;
                    hand.stroke = am4core.color("#fff");
                    hand.strokeOpacity = 0.5;

                    var labelPrimary = chart.radarContainer.createChild(
                        am4core.Label
                    );
                    labelPrimary.isMeasured = false;
                    labelPrimary.paddingBottom = 0;
                    labelPrimary.fontSize = 30;
                    labelPrimary.horizontalCenter = "middle";
                    labelPrimary.verticalCenter = "bottom";
                    labelPrimary.text =
                        "[#80ADF6]" + $scope.data.percentage + "%[/]";

                    var gradeValue = ranges.find(function (val) {
                        return (
                            $scope.data.percentage > val.min &&
                            $scope.data.percentage < val.max
                        );
                    });

                    var labelGap = gradeValue.label;
                    var label = chart.radarContainer.createChild(am4core.Label);
                    label.isMeasured = false;
                    label.fontSize = 12;
                    label.paddingBottom = 15;
                    label.horizontalCenter = "middle";
                    // label.verticalCenter = "bottom";
                    label.text = labelGap;

                    var title = chart.titles.create();
                    title.text = $scope.data.title;
                    title.fontSize = 16;
                });

                $scope.$on("$destroy", function () {
                    chart.dispose();
                });
            },
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.wfh.wfhadmin')
        .controller('WfhAdminController', WfhAdminController);

    WfhAdminController.$inject = ['AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', 'FileUploader', 'config', '$localStorage', '$document', '$http', '$location', '$window', '$element', '$filter'];

    function WfhAdminController(AppAPI, DataService, $mdDialog, Form, Auth, FileUploader, config, $localStorage, $document, $http, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/wfhadmin';
        Form.initialForm();

        var endPoint = AppAPI.Wfhadmin();

        Form.setObject(endPoint);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200]; 
        vm.closeModal = closeModal; 
        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.changeCompany = changeCompany;
        vm.LoadDivisi = LoadDivisi; 
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.start_date = new Date();
        vm.end_date = new Date();
        vm.divisi = vm.department = vm.area = 'all';
        vm.status = ["all"];
        vm.isAll = false;
        vm.updateHealthStatus = updateHealthStatus;
        vm.AddActivity=AddActivity;
        vm.viewActivity=viewActivity;

        vm.selectedDatas = [];
        vm.autocompleteDemoRequireMatch = true;
        vm.transformChip = transformChip;
        vm.upload=upload;
        vm.DownloadTemplate=DownloadTemplate;
        vm.uploadSuccess = vm.uploadError = vm.isMoreInfo = false;
        vm.uploadNotif = '';
        vm.closeModal=closeModal;
        vm.dialogClose=dialogClose;
        vm.viewMoreInfo = viewMoreInfo;

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }

            // Otherwise, create a new one
            return { name: chip, type: 'new' };
        }

        vm.Form.objForm.empno = '';
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.arr_area = [];
        vm.listStatus = [
            {
                'id': 'all',
                'name': 'All',
            },
            {
                'id': 'fix',
                'name': 'Fit',
            },
            {
                'id': 'unfix',
                'name': 'Unfit',
            },
            {
                'id': 'sick',
                'name': 'Sick',
            },
        ];

        //loadData(1);
        LoadCompany();
        LoadDivisi(vm.company);
        LoadDefaultArea(vm.company);

        vm.items = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;

        LoadCountry();

        function LoadCountry() {
            var response = endPoint.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return vm.lisPayrollEmployeeSelected.length !== 0 && vm.lisPayrollEmployeeSelected.length !== vm.items.length;
        }

        function isChecked() {
            return vm.lisPayrollEmployeeSelected.length === vm.items.length && vm.items.length != 0;
        }

        function toggleAll() {
            if (vm.lisPayrollEmployeeSelected.length === vm.items.length) {
                vm.lisPayrollEmployeeSelected = [];
            } else if (vm.lisPayrollEmployeeSelected.length === 0 || vm.lisPayrollEmployeeSelected.length > 0) {
                vm.lisPayrollEmployeeSelected = vm.items.slice(0);
            }
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadData(pageno) {
            vm.arrNik = [];
            if (vm.selectedDatas.length > 0) {
                for (var i = 0; i < vm.selectedDatas.length; i++) {
                    vm.arrNik.push('"' + vm.selectedDatas[i].empno + '"');
                }
            }

            vm.arrStatus = [];
            if (vm.status.length > 0) {
                for (var i = 0; i < vm.status.length; i++) {
                    vm.arrStatus.push('"' + vm.status[i] + '"');
                }
            }

            var resp = vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewData',
                company: vm.company,
                country: vm.country,
                department: vm.department,
                area: vm.area,
                startDate: vm.start_date,
                endDate: vm.end_date,
                divisi: vm.divisi,
                status: vm.arrStatus.toString(),
                nik: vm.arrNik.toString()
            });

            resp.then(function (data) {
                console.log(vm.selectedDatas);
                angular.element.unblockUI();
                vm.lisPayrollEmployeeSelected = [];
                vm.items = data.list;
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined' && employee != null) {
                console.log('pertama: ', employee)
                console.log('kedua: ', employee.empno)
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/wfhreport?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = endPoint.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = PayrollEmployee.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(company, divisi) {
            var response = endPoint.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: divisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = endPoint.query({
                action: 'getArea',
                companyid: companyid,
                regionalid: ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
            LoadDivisi(companyid)

        }

        function LoadDivisi(company) {
            var response = endPoint.query({
                action: 'getDivision',
                idbu: company
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(company, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisPayrollEmployeeSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisPayrollEmployeeSelected = [];
        } 

        function closeModal() {
            $mdDialog.hide();
        }

        function dialogClose() {
          $mdDialog.hide();
        }

        vm.selectStatus = selectStatus;
        function selectStatus(status) {
            if (typeof status != "undefined" && status.indexOf('all') != -1) {
                if ((vm.listStatus.length - 1) == status.length) {
                    var index = status.indexOf('all');
                    if (index > -1) {
                        vm.status.splice(index, 1);
                    }
                    vm.isAll = false;
                } else {
                    vm.isAll = true;
                    vm.status = [];
                    for (var i = 0; i <= (vm.listStatus.length - 1); i++) {
                        vm.status.push(vm.listStatus[i].id);
                    }
                }
            } else {
                if (vm.isAll) {
                    vm.status = [];
                    vm.isAll = false;
                } else if (typeof status != "undefined" && (vm.listStatus.length - 1) == status.length) {
                    vm.status.push('all');
                    vm.isAll = true;
                }
            }
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function updateHealthStatus(ev) {

            angular.element.unblockUI();
            $mdDialog.show({
                controller: 'UpdateHealthStatuController',
                controllerAs: 'vm',
                templateUrl: 'app/main/wfh/wfhadmin/dialog-health-status/dialog-health-status.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });

        }

        function AddActivity(ev) {

            angular.element.unblockUI();
            $mdDialog.show({
                controller: 'AdminAddActivityController',
                controllerAs: 'vm',
                templateUrl: 'app/main/wfh/wfhadmin/dialog-add-activity/dialog-add-activity.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });

        }

         function viewActivity(ev,nik,date,name) {

            angular.element.unblockUI();
            $mdDialog.show({
                controller: 'viewDataActivityAdminController',
                controllerAs: 'vm',
                templateUrl: 'app/main/wfh/wfhadmin/dialog-status-team/dialog-status-team.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    DataTeam:{nik:nik,date:date,name:name}
                },
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });

        }

        function upload(ev) {
          $mdDialog.show({
            controller: 'WfhAdminController',
            controllerAs: 'vm',
            templateUrl: 'app/main/wfh/wfhadmin/upload-form.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        }

        function DownloadTemplate() {
          var token = Auth.setTokenPromise();
          token.then(function (data) {
            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.port + config.api + 'api/wfhadmin/downloadtemplate', '_blank');
          }, function () {
            $window.alert('gagal load token');
          });
        }

        vm.FileUploader = new FileUploader({
          url: config.api + 'api/wfhadmin/uploadfile',
          removeAfterUpload: true,
          alias: 'fileupload',
          formData: [{
            action: 'uploadfile'
          }],
          onAfterAddingAll: function () {
            vm.uploadSuccess = false;
            vm.uploadError = false;
          },
          headers: {
            tokenAuth: $localStorage.tokenAuth
          }
        });

        vm.FileUploader.onSuccessItem = function (data, status, headers, config) {
          if (status.status == 0) {
            vm.uploadSuccess = false;
            vm.uploadError = true;
          } else {
            vm.uploadSuccess = true;
            vm.uploadError = false;
          }

          var expmess = status.pesan.split("_");
          if (expmess.length > 1) {
            var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
          } else {
            var message = translate(status.pesan);
          }
          vm.uploadNotif = message

          if ('moreInfo' in status && status.moreInfo.length > 0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
          }

          angular.element('#uploadCutOff').val('');

        };

        vm.FileUploader.onErrorItem = function () {
          vm.uploadSuccess = false;
          vm.uploadError = true;

        };

         function viewMoreInfo(detail) {
              $mdDialog.show({
                controller: 'logFailGwController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                  loadData(1);
                },
                locals: {
                  data: detail
                }
              });
            }
    }
})();
//
(function () {
    'use strict';

    angular
        .module('app.wfh.wfh-main')
        .controller('WfhMainController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$scope',
        'Auth',
        '$location',
        '$window',
        'config',
        'DataService',
        '$mdDialog',
        '$log',
        '$http',
        '$stateParams',
        '$q'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $scope,
        Auth,
        $location,
        $window,
        config,
        DataService,
        $mdDialog,
        $log,
        $http,
        $stateParams,
        $q
    ) {
        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        var WfhFe = new AppAPI.WfhFe();
        vm.indexTab = 1;
        vm.DataTableListTeam = new DataService();
        vm.DataTableDependents = new DataService();
        vm.DataTableActivity = new DataService();

        vm.CheckDetailStatusTeam = CheckDetailStatusTeam;
        vm.AddActivity = AddActivity;
        vm.updateHealthStatus = updateHealthStatus;
        vm.loadData = loadData;
        vm.tabChange = tabChange;


        vm.countTeam = 0
        vm.start_date = new Date();
        vm.start_date_activity = new Date();
        vm.end_date = new Date();
        tabChange(1);
        initialisasi();

        function initialisasi() {
            var promises = WfhFe.query({
                action: 'countDataListTeam',
                offset: 0,
                jumPage: 100,
                checking_date: dateNow(vm.start_date)
            });
            promises.$promise.then(fetchCountTeam);
            promises.$promise.catch(errorFetch);
        }

        function fetchCountTeam(data) {
            vm.countTeam = data[0].aData[0]['Total'];
        }

        function errorFetch() {
            // angular.element.unblockUI();
        }

        function loadData(pageno) {
            if (vm.indexTab == 1) {
                vm.DataTableDependents.loadData(WfhFe, pageno, {
                    action: 'getDependent',
                    checking_date: dateNow(vm.start_date)
                });
            } else if (vm.indexTab == 2) {
                vm.DataTableActivity.loadData(WfhFe, pageno, {
                    action: 'getActivity',
                    checking_date: dateNow(vm.start_date_activity),
                    end_date: dateNow(vm.end_date)
                });
            } else if (vm.indexTab == 3) {
                vm.DataTableListTeam.loadData(WfhFe, pageno, {
                    action: 'viewDataListTeam',
                    checking_date: dateNow(vm.start_date),
                });
            }
        }

        function tabChange(index) {
            vm.indexTab = index;
            loadData(1);
        }

        // vm.DataTableListTeam = [{
        //         no: 1,
        //         nik: 123456,
        //         emp_name: 'Yunita Hasibuan',
        //         img: 'https://image.cnbcfm.com/api/v1/image/106327338-1578520610213nour.jpg?v=1578524760&w=678&h=381',
        //         activity: 5,
        //         dependent: 2,
        //         last_update: 1584591149,
        //         dependent_list: [{
        //                 no: 1,
        //                 name: 'Yunita Hasibuan',
        //                 person_status: 'Employee',
        //                 status_morning: 'fix',
        //                 comment_afternoon: 'unfix'
        //             },
        //             {
        //                 no: 2,
        //                 name: 'John Doe',
        //                 person_status: 'Spouse',
        //                 status_morning: 'unfix',
        //                 comment_afternoon: 'sick'
        //             },
        //             {
        //                 no: 3,
        //                 name: 'Rudi',
        //                 person_status: 'Child',
        //                 status_morning: 'fix',
        //                 comment_afternoon: 'sick'
        //             }
        //         ],
        //         activity_list: [{
        //                 no: 1,
        //                 activity_name: 'Business Trip',
        //                 note: 'Contoh noted Business Trip',
        //                 status: 'Hold',
        //                 comment: null,
        //                 last_update: 1584587549
        //             },
        //             {
        //                 no: 2,
        //                 activity_name: 'Talentpool',
        //                 note: 'Contoh noted Talentpool',
        //                 status: 'Hold',
        //                 comment: null,
        //                 last_update: 1584591149
        //             },
        //             {
        //                 no: 3,
        //                 activity_name: 'WHF',
        //                 note: 'Contoh noted WHF',
        //                 status: 'Progress',
        //                 comment: null,
        //                 last_update: 1584591149
        //             }
        //         ]
        //     },
        //     {
        //         no: 2,
        //         nik: 123456,
        //         emp_name: 'Andrew',
        //         img: 'https://goodmenproject.com/wp-content/uploads/2017/09/Screen-Shot-2017-09-09-at-9.18.08-AM.jpg',
        //         activity: 8,
        //         dependent: 0,
        //         last_update: 1584587549,
        //         dependent_list: [{
        //             no: 1,
        //             name: 'Andrew',
        //             person_status: 'Employee',
        //             status_morning: 'fix',
        //             comment_afternoon: 'unfix'
        //         }],
        //         activity_list: [{
        //                 no: 1,
        //                 activity_name: 'Business Trip',
        //                 note: 'Contoh noted Business Trip',
        //                 status: 'Hold',
        //                 comment: null,
        //                 last_update: 1584587549
        //             },
        //             {
        //                 no: 2,
        //                 activity_name: 'Talentpool',
        //                 note: 'Contoh noted Talentpool',
        //                 status: 'Hold',
        //                 comment: null,
        //                 last_update: 1584591149
        //             },
        //             {
        //                 no: 3,
        //                 activity_name: 'WHF',
        //                 note: 'Contoh noted WHF',
        //                 status: 'Progress',
        //                 comment: null,
        //                 last_update: 1584591149
        //             }
        //         ]
        //     }
        // ]

        // vm.DataTableActivity = [{
        //         no: 1,
        //         activity_name: 'Business Trip',
        //         note: 'Contoh noted Business Trip',
        //         status: 'Hold',
        //         comment: '-',
        //         last_update: 1584587549
        //     },
        //     {
        //         no: 2,
        //         activity_name: 'Talentpool',
        //         note: 'Contoh noted Talentpool',
        //         status: 'Hold',
        //         comment: '-',
        //         last_update: 1584591149
        //     },
        //     {
        //         no: 3,
        //         activity_name: 'WHF',
        //         note: 'Contoh noted WHF',
        //         status: 'Progress',
        //         comment: '-',
        //         last_update: 1584591149
        //     }
        // ]


        // vm.DataTableDependents = [{
        //         no: 1,
        //         name: 'John Doe',
        //         person_status: 'Employee',
        //         status_morning: 'fix',
        //         comment_afternoon: 'unfix'
        //     },
        //     {
        //         no: 2,
        //         name: 'Yunita',
        //         person_status: 'Spouse',
        //         status_morning: 'unfix',
        //         comment_afternoon: 'sick'
        //     },
        //     {
        //         no: 3,
        //         name: 'Rudi',
        //         person_status: 'Child',
        //         status_morning: 'fix',
        //         comment_afternoon: 'sick'
        //     }
        // ]


        function CheckDetailStatusTeam(team, ev) {

            angular.element.unblockUI();
            $mdDialog.show({
                controller: 'DialogStatusTeamController',
                controllerAs: 'vm',
                templateUrl: 'app/main/wfh/wfh-main/dialog-status-team/dialog-status-team.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    DataTeam: team,
                },
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });

        }

        function AddActivity(ev) {

            angular.element.unblockUI();
            $mdDialog.show({
                controller: 'DialogAddActivityController',
                controllerAs: 'vm',
                templateUrl: 'app/main/wfh/wfh-main/dialog-add-activity/dialog-add-activity.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });

        }

        function updateHealthStatus(ev) {

            angular.element.unblockUI();
            $mdDialog.show({
                controller: 'DialogHealthStatuController',
                controllerAs: 'vm',
                templateUrl: 'app/main/wfh/wfh-main/dialog-health-status/dialog-health-status.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });

        }

        function dateNow(date) {
            if (date && date != '') {
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
            } else {
                var d = new Date(),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
            }


            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }

        vm.exportDataDependent = exportDataDependent;

        function exportDataDependent(ev) {

            angular.element.unblockUI();
            $mdDialog.show({
                controller: 'DialogExportDataController',
                controllerAs: 'vm',
                templateUrl: 'app/main/wfh/wfh-main/dialog-export-data/dialog-export-data.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                onRemoving: function (element, removePromise) {
                    // loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });


        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.utility.user', ['app.utility.user.input-user'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.utility_user', {
                url    : '/utility/user',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/user/user.html',
                        controller : 'UserController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.utility.user')
        .controller('UserController', UserController);


    UserController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService'];
    /** @ngInject */
    function UserController($state,$log,$mdDialog,AppAPI,Auth,DataService)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.loadData=loadData;
        vm.DataTable= new DataService();
        vm.editData=editData; 
        vm.reloadToken=Auth.setToken; 
        var User=AppAPI.User();
        vm.resetPassword=resetPassword;

         vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[ 
                    {link:'#',name:'Utility',active:'0'},
                    {link:'#',name:'User',active:'0'}
                    ];

        // Data
 
        // Methods
        loadData(1);
        ////////// 

        function loadData(pageno) {
        //  var response= User.query({action:'viewdata',search:vm.DataTable.searchParam});
        // response.$promise.then(function(data){
        //    vm.list=data;
        // });
        // response.$promise.catch(function(data){
        //   console.log(data);
        // });
          vm.DataTable.loadData(User,pageno,{action:'viewdata'});

        }

        function editData(id){
          $state.go('app.utility_user_edit-user',{id:id});
        }
         
        function resetPassword(ev,id)
        {
           var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to reset user password?')
              .textContent('Inform to user if already reset.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

            $mdDialog.show(confirm).then(function() {
                angular.element.unblockUI();
                var response=User.delete({action:'delete',id:id});

                response.$promise.then(loadData);
                }, function() {

                });
            });
        }

         
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.utility.permission', ['app.utility.permission.input-action','app.utility.permission.add-permission'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {

        // State
        $stateProvider
            .state('app.utility_permission', {
                url    : '/utility/permission',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/permission/permission.html',
                        controller : 'PermissionController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.utility.permission')
        .controller('PermissionController', PermissionController);


    PermissionController.$inject=['$state','$log','$mdDialog','AppAPI','Auth'];
    /** @ngInject */
    function PermissionController($state,$log,$mdDialog,AppAPI,Auth)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.loadData=loadData;
        vm.changeaction=changeaction;
        vm.reloadToken=Auth.setToken;
        vm.inputaction=inputaction;
        vm.AddPermission=AddPermission;
        var Group=AppAPI.Group();
        var Module=AppAPI.Module();

        var response= Group.query({action:'listGroupSelect'});
          response.$promise.then(function(data){
             vm.listGroupSelect=data;
             // console.log(vm.listGroupSelect);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

        // Data
 
        // Methods

        ////////// 

        function loadData(){
          var IDgroup=vm.group.id;
          var res= Module.query({action:'get_module_by_id',groupid:IDgroup});
          res.$promise.then(function(data){
            $log.log(data);
            vm.listModul=data;
          });
          res.$promise.catch(function(data){
            console.log(data);
          });
        }

        function changeaction(action,groupid){
          var resp= Auth.setToken();
          resp.then(function(){
            var act=new Module();
            act.item=action;
            act.action='save_module_action';
            act.groupID=groupid;
            var res=act.$save();
            res.then(function(rdata){
              $log.info(rdata.pesan);
              vm.reloadToken();
            },function(err){
              $log.log(err);
            });
            // console.log(act);
          });  
        }

        function inputaction(menuid){
          $state.go('app.utility_permission_input-action',{menuid:menuid});
          // console.log(menuid);
        }

        function AddPermission(group){ 
          if(group!==undefined){
             // console.log(group);
             $state.go('app.utility_permission_add-permission',{group:group.id});
          }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.utility.modules', ['app.utility.modules.input-modules'])
        .config(config);

      config.$inject=['$stateProvider'];
      /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.utility_modules', {
                url    : '/utility/modules',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/modules/modules.html',
                        controller : 'ModulesController as vm'
                    }
                }
            });


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.utility.modules')
        .controller('ModulesController', ModulesController);


    ModulesController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService'];
    //AppAPI untuk koneksi ambil data ke api
    //Auth untuk mendapatkan authentikasi mendapatkan token, setiap hubungan ke API wajib token
    //DataService untuk pagination dan datatable
    
    /** @ngInject */
    function ModulesController($state,$log,$mdDialog,AppAPI,Auth,DataService)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService(); //inisialisasi class DataService
        vm.loadData=loadData;
        vm.modulesAction=modulesAction; 
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listModulSelected=[];
        vm.deleteModul=deleteModul;
        vm.editData=editData;
        vm.searchResultClick=searchResultClick;
        var Group=AppAPI.Group();
        var Modules=AppAPI.Modules();//memanggil api modules dari api
        
        vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[ 
                    {link:'#',name:'Modules',active:'0'}
                    ];

        var response= Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
             vm.listGroupSelect=data;
             // console.log(vm.listGroupSelect);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

        // Data
        loadData(1);
        // Methods

        ////////// 

        function loadData(pageno){
           vm.DataTable.loadData(Modules,pageno,{action:'viewdata'});
           // console.log('test');
        }

        // function loadData(pageno) {
        //  var response= Modules.query({action:'viewdata',search:vm.DataTable.searchParam});
        // response.$promise.then(function(data){
        //    vm.list=data;
        // });
        // response.$promise.catch(function(data){
        //   console.log(data);
        // });

        // }

        function searchResultClick() {
          console.log('test');
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 
        function modulesAction(id){
          // console.log(id);
          $state.go('app.utility_modules_modules-action',{id:id});
        }

        function editData(id){
          // console.log(id);
          $state.go('app.utility_modules_edit-modules',{id:id});
        }

        function deleteModul(ev) {
   
          var promise=Auth.setToken();
           promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

              $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                 var response=Modules.delete({action:'delete',data:angular.toJson(vm.listModulSelected)});

                 response.$promise.then(loadData(1)); 
              }, function() {
               // $scope.status = 'You decided to keep your debt.';
              });
           });
  
   
    }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.utility.modul', ['app.utility.modul.input-modul'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.utility_modul', {
                url    : '/utility/modul',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/modul/modul.html',
                        controller : 'ModulController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.utility.modul')
        .controller('ModulController', ModulController);


    ModulController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService'];
    /** @ngInject */
    function ModulController($state,$log,$mdDialog,AppAPI,Auth,DataService)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.editData=editData; 
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listModulSelected=[];
        vm.deleteModul=deleteModul;
        var Group=AppAPI.Group();
        var Module=AppAPI.Module();

        vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[ 
                    {link:'#',name:'Module',active:'0'}
                    ];

        var response= Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
             vm.listGroupSelect=data;
             // console.log(vm.listGroupSelect);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

        // Data
        loadData(1);
        // Methods

        ////////// 

        // function loadData(pageno){
        //    vm.DataTable.loadData(Module,pageno,{action:'viewdata'});
        //    // console.log('test');
        // }

        function loadData(pageno) {
         var response= Module.query({action:'viewdata',search:vm.DataTable.searchParam});
        response.$promise.then(function(data){
           vm.list=data;
        });
        response.$promise.catch(function(data){
          console.log(data);
        });

        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 
        function editData(id){
          // console.log(id);
          $state.go('app.utility_modul_edit-modul',{id:id});
        }

        function deleteModul(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

          $mdDialog.show(confirm).then(function() {
              angular.element.blockUI();
             var response=Module.delete({action:'delete',data:angular.toJson(vm.listModulSelected)});

             response.$promise.then(loadData(1)); 
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
       });
  
   
    }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.utility.menu', ['app.utility.menu.input-menu'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.utility_menu', {
                url    : '/utility/menu',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/menu/menu.html',
                        controller : 'MenuController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.utility.menu')
        .controller('MenuController', MenuController);


    MenuController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService'];
    /** @ngInject */
    function MenuController($state,$log,$mdDialog,AppAPI,Auth,DataService)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.editData=editData; 
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listModulSelected=[];
        vm.deleteModul=deleteModul;
        var Group=AppAPI.Group();
        var Menu=AppAPI.Menu();

        vm.Breadhome="app.pms_dashboard";
         vm.Breadlist=[ 
                    {link:'#',name:'Menu',active:'0'}
                    ];

        var response= Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
             vm.listGroupSelect=data;
             // console.log(vm.listGroupSelect);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

        // Data
        loadData(1);
        // Methods

        ////////// 

        // function loadData(pageno){
        //    vm.DataTable.loadData(Module,pageno,{action:'viewdata'});
        //    // console.log('test');
        // }

        function loadData(pageno) {
          angular.element.blockUI();
         var response= Menu.query({action:'viewdata',search:vm.DataTable.searchParam});
        response.$promise.then(function(data){
           vm.list=data;
           angular.element.unblockUI();
        });
        response.$promise.catch(function(data){
          console.log(data);
          angular.element.unblockUI();
        });

        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 
        function editData(id){
          // console.log(id);
          $state.go('app.utility_menu_edit-menu',{id:id});
        }

        function deleteModul(ev) { 
        
            var promise=Auth.setToken();
            promise.then(function(){
               var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

              $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=Menu.delete({action:'delete',data:angular.toJson(vm.listModulSelected)});
                response.$promise.then(loadData(1)); 
              },function() { 

              });
            }); 

        // console.log(vm.listModulSelected.length);
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.utility.group_permission', [
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.utility_group_permission', {
                url    : '/utility/group-permission',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/utility/grouppermission/grouppermission.html',
                        controller : 'GroupPermissionController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.utility.group_permission')
        .controller('GroupPermissionController', GroupPermissionController);


    GroupPermissionController.$inject=['$state','$log','$mdDialog','AppAPI','Auth'];
    /** @ngInject */
    function GroupPermissionController($state,$log,$mdDialog,AppAPI,Auth)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.loadData=loadData;
        vm.changeaction=changeaction;
        vm.reloadToken=Auth.setToken;
        vm.inputaction=inputaction;
        vm.AddPermission=AddPermission;
        var Group=AppAPI.Group();
        var Grouppermission=AppAPI.Grouppermission();
         

        var response= Group.query({action:'listGroupSelect'});
          response.$promise.then(function(data){
             vm.listGroupSelect=data;
             // console.log(vm.listGroupSelect);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

          vm.submenushow=false;
          vm.showmenu=showmenu;
          vm.enableGroup=enableGroup;
          vm.toogleSubChild=toogleSubChild;
          vm.visibleSubChild=[];


        // Data
 
        // Methods

        ////////// 

        function toogleSubChild(idx) {
            switch(vm.visibleSubChild[idx])
            {
                case true :
                vm.visibleSubChild[idx]=false;
                vm.icon='icon-minus';
                break;
                case false :
                vm.visibleSubChild[idx]=true;
                 vm.icon='icon-plus';
                break;
                default:
                   vm.visibleSubChild[idx]=true;
                    vm.icon='icon-minus';
                break;
            }

        }
        
        function loadData(){ 
          var IDgroup=vm.group.id;
          var res= Grouppermission.query({action:'get_module_by_id',groupid:IDgroup});
          res.$promise.then(function(data){
            vm.listModul=data;
          });
          res.$promise.catch(function(data){
           // vm.listModul=[];
          });
        }

        function changeaction(action,groupid){
          var resp= Auth.setToken();
          resp.then(function(){
            var act=new Grouppermission();
            act.item=action;
            act.action='savegroupaction';
            act.groupID=groupid;
            var res=act.$save();
            res.then(function(rdata){
              $log.info(rdata.pesan);
              vm.reloadToken();
              loadData();
            },function(err){
              $log.log(err);
              loadData();
            });
            // console.log(act);
          });  
        }

        function inputaction(menuid){
          $state.go('app.utility_permission_input-action',{menuid:menuid});
          // console.log(menuid);
        }

        function AddPermission(group){ 
          if(group!==undefined){
             // console.log(group);
             $state.go('app.utility_permission_add-permission',{group:group.id});
          }
        }

        function showmenu(index){
          var el=angular.element('.menu_'+index);
            el.attr('ng-show','true');
          // console.log();
          // console.log(index);
        }

        function enableGroup(statgroup,menuiD,groupID)
        {
          // console.log(menuiD+' / '+groupID);
          var resp= Auth.setToken();
          resp.then(function(){
            var act=new Grouppermission(); 
            act.action='save_groupmenu';
            act.groupID=groupID;
            act.menuiD=menuiD;
            act.statgroup=statgroup;
            var res=act.$save();
            res.then(function(rdata){
              $log.info(rdata.pesan);
              vm.reloadToken();
              loadData();
            },function(err){
              $log.log(err);
              loadData();
            });
            // console.log(act);
          });  
        }
    }
})();

// (function ()
// {
//     'use strict';

//     angular
//         .module('app.grouppermission')
//         .factory('Grouppermission', apiService);
//         apiService.$inject = ['$resource','config'];
//     /** @ngInject */
//     function apiService($resource,config)
//     {  

//        return $resource(config.api+'api/grouppermission'); 
//   }
// })();
(function () {
    'use strict';

    angular
        .module('app.shortleavegw.shortleavegwlist', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];

    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.short_leave_gw_list', {
                url: '/shortleavegw/list-gw',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/short-leave-gw/short-leave-gw-list/gw-list.html',
                        controller: 'ShortleavegwlistController as vm'
                    }
                }
            })

    }
})();

(function () {
    'use strict';

    angular
        .module('app.shortleavegw.shortleavegwlist')
        .controller('ShortleavegwlistController', ShortleavegwlistController);

    ShortleavegwlistController.$inject = [
        "AppAPI",
        "DataService",
        "Auth",
        "config",
        "$localStorage",
        "$state",
        "$mdDialog",
        "$timeout"
    ];

    function ShortleavegwlistController(
        AppAPI,
        DataService,
        Auth,
        config,
        $localStorage,
        $state,
        $mdDialog,
        $timeout
    ) {
        var vm = this;
        var endpoint = new AppAPI.ShortLeaveGw();

        vm.company = $localStorage.empsite;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.getLine = getLine;
        vm.breakin = breakin;
        vm.breakout = breakout;

        vm.workingDate = new Date();

        viewData(1);
        getLine();

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewdata',
                date: vm.workingDate,
                line: vm.line
            });
        }

        function getLine() {
            vm.listLine = [];

            var promise = endpoint.query({
                action: "getline",
                nik: $localStorage.user,
                date: vm.workingDate
            });

            promise.$promise.then(function (dataList) {
                vm.listLine = dataList
            });
            promise.$promise.catch(function (err) {
                console.log(err);
                vm.listLine = [];
            })

        }

        function breakin(ev, nik) {
            angular.element.blockUI();
            var promise = endpoint.query({
                action: "setshortleave",
                nik: nik,
                date: vm.workingDate,
                type: '30'
            });

            promise.$promise.then(function (data) {
                vm.tampilPesan = true;
                vm.tampilPesan = "Success";
                vm.messageTheme = 'blue';
                angular.element.unblockUI();
                viewData(1);
                $timeout(function () {
                    vm.tampilPesan = false;
                }, 9000);
            });
            promise.$promise.catch(function (err) {
                vm.tampilPesan = true;
                vm.tampilPesan = "Failed";
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
                viewData(1);
                $timeout(function () {
                    vm.tampilPesan = false;
                }, 9000);
            })
        }

        function breakout(ev, nik) {
            angular.element.blockUI();
            var promise = endpoint.query({
                action: "setshortleave",
                nik: nik,
                date: vm.workingDate,
                type: '20'
            });

            promise.$promise.then(function (data) {
                vm.tampilPesan = true;
                vm.tampilPesan = "Success";
                vm.messageTheme = 'blue';
                angular.element.unblockUI();
                viewData(1);
                $timeout(function () {
                    vm.tampilPesan = false;
                }, 9000);
            });
            promise.$promise.catch(function (err) {
                vm.tampilPesan = true;
                vm.tampilPesan = "Failed";
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
                viewData(1);
                $timeout(function () {
                    vm.tampilPesan = false;
                }, 9000);
            })
        }


    }

})();

(function () {
  "use strict";

  angular.module('app.structure_area.wilayah_sales', []).config(config);

  config.$inject = ['$stateProvider'];
  function config($stateProvider) {

    $stateProvider
      .state('app.wilayah_sales', {
        url: '/structure_area/wilayah_sales',
        views: {
          'content@app': {
            templateUrl: 'app/main/structure-area/wilayah-sales/wilayah-sales.html',
            controller: 'WilayahSalesController as vm'
          }
        }

      });

  }
}());
(function () {
    'use strict';

    angular
        .module('app.structure_area.wilayah_sales')
        .controller('WilayahSalesController', WilayahSalesController);

    WilayahSalesController.$inject = ['$q', 'DataService', 'AppAPI', '$mdDialog', 'Auth', '$localStorage'];

    /* @ngInject */
    function WilayahSalesController($q, DataService, AppAPI, $mdDialog, Auth, $localStorage) {

        var vm = this;
        vm.groupWilayahLists = [
            { name: '-- Group Wilayah', value: '' },
            { name: 'DP1', value: 'DP1' },
            { name: 'DP2', value: 'DP2' },
            { name: 'DP3', value: 'DP3' },
            { name: 'LP1', value: 'LP1' },
            { name: 'LP2', value: 'LP2' },
            { name: 'ALL', value: 'ALL' },
            { name: 'INDIRECT', value: 'INDIRECT' }
        ];
        vm.salesTypeLists = [
            { name: '-- Sales Type', value: '' },
            { name: 'GT', value: 'GT' },
            { name: 'MT', value: 'MT' },
            { name: 'EDD', value: 'EDD' },
            { name: 'DT', value: 'DT' },
            { name: 'HQ', value: 'HQ' },
            { name: 'OTH', value: 'OTH' }
        ];
        vm.countryLists = [
            { name: '-- Country', value: '' },
            { name: 'Indonesia', value: 'IDN' },
            { name: 'Malaysia', value: 'MYS' },
            { name: 'China', value: 'CHN' },
            { name: 'India', value: 'IND' }
        ];
        vm.businessUnitLists = [
            { name: '-- Business Unit', value: '' },
            { name: 'Nabati Food PTE LTD', value: 'EN' },
            { name: 'Kieber', value: 'KI' },
            { name: 'KSNI', value: 'KS' },
            { name: 'PMA', value: 'PM' },
            { name: 'RKI', value: 'RK' }
        ];

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.groupWilayah = '';
        vm.salesType = '';
        vm.country = '';
        vm.bu = '';
        vm.DataTable = new DataService();
        var WilayahSales = AppAPI.WilayahSales();
        vm.loadData = loadData;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;
        vm.isAdmin = (parseInt($localStorage.group) === 1) ? true : false;

        loadData('1');

        function loadData(pageno) {

            console.log('pageno', pageno);

            var params = {
                action: 'viewdata',
                group_wilayah: vm.groupWilayah,
                sales_type: vm.salesType,
                country: vm.country,
                bu: vm.bu
            };
            var response = vm.DataTable.loadData(WilayahSales, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                console.log('res', res);
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        function add(ev) {
            $mdDialog.show({
                controller: 'InputWilayahSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/wilayah-sales/wilayah-sales-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    groupWilayahLists: vm.groupWilayahLists,
                    salesTypeLists: vm.salesTypeLists
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'UpdateWilayahSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/wilayah-sales/wilayah-sales-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    groupWilayahLists: vm.groupWilayahLists,
                    salesTypeLists: vm.salesTypeLists
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = WilayahSales.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
                    response.$promise.then(loadData);
                }, function () {
                });
            });
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.wilayah_sales')
        .controller('UpdateWilayahSalesController', UpdateWilayahSalesController);

    UpdateWilayahSalesController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'groupWilayahLists', 'salesTypeLists', 'data'];

    /* @ngInject */
    function UpdateWilayahSalesController($mdDialog, Form, AppAPI, groupWilayahLists, salesTypeLists, data) {
        var vm = this;
        vm.saveData = saveData;
        var WilayahSales = AppAPI.WilayahSales();
        Form.initialForm();
        Form.setObject(WilayahSales);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.groupWilayahLists = groupWilayahLists;
        vm.salesTypeLists = salesTypeLists;

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.code_wilayah = data.code_wilayah;
        vm.Form.objForm.description = data.description;
        vm.Form.objForm.group_wilayah = data.group_wilayah;
        vm.Form.objForm.sales_type = data.sales_type;

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, WilayahSales);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.wilayah_sales')
        .controller('InputWilayahSalesController', InputWilayahSalesController);

    InputWilayahSalesController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', 'groupWilayahLists', 'salesTypeLists'];

    /* @ngInject */
    function InputWilayahSalesController($localStorage, $mdDialog, Form, AppAPI, $log, FileUploader, config, groupWilayahLists, salesTypeLists) {
        var vm = this;
        vm.saveData = saveData;
        var WilayahSales = AppAPI.WilayahSales();
        Form.initialForm();
        Form.setObject(WilayahSales);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.groupWilayahLists = groupWilayahLists;
        vm.salesTypeLists = salesTypeLists;

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, WilayahSales);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
  "use strict";

  angular.module('app.structure_area.regional_sales', []).config(config);

  config.$inject = ['$stateProvider'];
  function config($stateProvider) {

    $stateProvider
      .state('app.regional_sales', {
        url: '/structure_area/regional_sales',
        views: {
          'content@app': {
            templateUrl: 'app/main/structure-area/regional-sales/regional-sales.html',
            controller: 'RegionalSalesController as vm'
          }
        }

      });

  }
}());
(function () {
    'use strict';

    angular
        .module('app.structure_area.regional_sales')
        .controller('RegionalSalesController', RegionalSalesController);

    RegionalSalesController.$inject = ['$q', 'DataService', 'AppAPI', '$mdDialog', 'Auth', '$log'];

    /* @ngInject */
    function RegionalSalesController($q, DataService, AppAPI, $mdDialog, Auth, $log) {

        var vm = this;
        vm.wilayahSalesLists = [];
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.wilayahSales = '';
        vm.DataTable = new DataService();
        var RegionalSales = AppAPI.RegionalSales();
        vm.loadData = loadData;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        ////////////////
        var response = RegionalSales.query({ action: 'getWilayahSales' });
        response.$promise.then(function (data) {
            // data.map(function (val) {
            //     vm.wilayahSalesLists.push(val);
            // });
            vm.wilayahSalesLists = data;
        });
        response.$promise.catch(function (data) {
            $log.info(data);
        });

        loadData('1');

        function loadData(pageno) {
            var params = {
                action: 'viewdata',
                wilayah_sales_id: vm.wilayahSales,
            };
            var response = vm.DataTable.loadData(RegionalSales, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                console.log('res', res);
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        function add(ev) {
            $mdDialog.show({
                controller: 'InputRegionalSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/regional-sales/regional-sales-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    wilayahSalesLists: vm.wilayahSalesLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'UpdateRegionalSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/regional-sales/regional-sales-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    wilayahSalesLists: vm.wilayahSalesLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = RegionalSales.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
                    response.$promise.then(loadData);
                }, function () {
                });
            });
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.regional_sales')
        .controller('UpdateRegionalSalesController', UpdateRegionalSalesController);

    UpdateRegionalSalesController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'wilayahSalesLists', 'data'];

    /* @ngInject */
    function UpdateRegionalSalesController($mdDialog, Form, AppAPI, wilayahSalesLists, data) {
        var vm = this;
        vm.saveData = saveData;
        var RegionalSales = AppAPI.RegionalSales();
        Form.initialForm();
        Form.setObject(RegionalSales);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.wilayahSalesLists = wilayahSalesLists;

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.code_region = data.code_region;
        vm.Form.objForm.description = data.description;
        vm.Form.objForm.wilayah_sales_id = data.wilayah_sales_id;

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, RegionalSales);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.regional_sales')
        .controller('InputRegionalSalesController', InputRegionalSalesController);

    InputRegionalSalesController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'wilayahSalesLists'];

    /* @ngInject */
    function InputRegionalSalesController($mdDialog, Form, AppAPI, wilayahSalesLists) {
        var vm = this;
        vm.saveData = saveData;
        var RegionalSales = AppAPI.RegionalSales();
        Form.initialForm();
        Form.setObject(RegionalSales);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.wilayahSalesLists = wilayahSalesLists;

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, RegionalSales);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
  "use strict";

  angular.module('app.structure_area.area_sales_status', []).config(config);

  config.$inject = ['$stateProvider'];
  function config($stateProvider) {

    $stateProvider
      .state('app.area_sales_status', {
        url: '/structure_area/area_sales_status',
        views: {
          'content@app': {
            templateUrl: 'app/main/structure-area/area-sales-status/area-sales-status.html',
            controller: 'AreaSalesStatusController as vm'
          }
        }

      });

  }
}());
(function () {
    'use strict';

    angular
        .module('app.structure_area.area_sales_status')
        .controller('AreaSalesStatusController', AreaSalesStatusController);

    AreaSalesStatusController.$inject = ['$q', 'DataService', 'AppAPI', '$mdDialog', 'Auth', '$log'];

    /* @ngInject */
    function AreaSalesStatusController($q, DataService, AppAPI, $mdDialog, Auth, $log) {

        var vm = this;
        vm.wilayahSalesLists = [];
        vm.regionalSalesLists = [];
        vm.cabangSalesLists = [];
        vm.areaSalesLists = [];
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.wilayahSales = '';
        vm.regionalSales = '';
        vm.cabangSales = '';
        vm.areaSales = '';
        vm.DataTable = new DataService();
        var AreaSalesStatus = AppAPI.AreaSalesStatus();
        vm.loadData = loadData;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.setStatus = setStatus;
        vm.changeRegional = changeRegional;
        vm.changeWilayah = changeWilayah;

        // var resAreaSales = AreaSalesStatus.query({ action: 'getAreaSales' });
        // resAreaSales.$promise.then(function (data) {
        //     vm.areaSalesLists = data;
        //     setTimeout(function () {
        //         vm.areaSales = '';
        //     }, 2000);
        // });
        // resAreaSales.$promise.catch(function (data) {
        //     $log.info(data);
        // });

        loadWilayahSales();
        loadRegionalSales('');
        loadCabangSales('');
        loadData('1');

        function loadData(pageno) {
            var params = {
                action: 'viewdata',
                cabang_sales_id: vm.cabangSales,
                regional_sales_id: vm.regionalSales,
                wilayah_sales_id: vm.wilayahSales,
            };
            var response = vm.DataTable.loadData(AreaSalesStatus, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                console.log('res', res);
            });
        }

        function loadWilayahSales() {
            var resWilayahSales = AreaSalesStatus.query({ action: 'getWilayahSales' });
            resWilayahSales.$promise.then(function (data) {
                vm.wilayahSalesLists = data;
                vm.wilayahSales = '';
            });
            resWilayahSales.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function loadRegionalSales(wilayah_sales_id) {
            if (wilayah_sales_id === '') {
                wilayah_sales_id = vm.wilayahSales;
            }
            var resRegionalSales = AreaSalesStatus.query({ action: 'getRegionalSales', wilayah_sales_id: wilayah_sales_id });
            resRegionalSales.$promise.then(function (data) {
                vm.regionalSalesLists = data;
                vm.regionalSales = '';
            });
            resRegionalSales.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function loadCabangSales(regional_sales_id) {
            if (regional_sales_id === '') {
                regional_sales_id = vm.regionalSales;
            }
            var resCabangSales = AreaSalesStatus.query({ action: 'getCabangSales', regional_sales_id: regional_sales_id });
            resCabangSales.$promise.then(function (data) {
                vm.cabangSalesLists = data;
                vm.cabangSales = '';
            });
            resCabangSales.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function changeWilayah(wilayah_sales_id) {
            loadRegionalSales(wilayah_sales_id);
            loadData(1);
        }

        function changeRegional(regional_sales_id) {
            loadCabangSales(regional_sales_id);
            loadData(1);
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        function setStatus(ev, data, year, month) {

            data.year = year;
            data.month = month;
            console.log('data', data);

            $mdDialog.show({
                controller: 'UpdateAreaSalesStatusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/area-sales-status/area-sales-status-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.area_sales_status')
        .controller('UpdateAreaSalesStatusController', UpdateAreaSalesStatusController);

    UpdateAreaSalesStatusController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'data'];

    /* @ngInject */
    function UpdateAreaSalesStatusController($mdDialog, Form, AppAPI, data) {
        var vm = this;
        vm.saveData = saveData;
        var AreaSalesStatus = AppAPI.AreaSalesStatus();
        Form.initialForm();
        Form.setObject(AreaSalesStatus);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.areaSalesLists = []; // areaSalesLists;
        vm.areaStatusLists = [
            { value: 'CB', name: 'CB' },
            { value: 'DP', name: 'DP' },
            { value: 'CP+', name: 'CP+' },
            { value: 'CP', name: 'CP' },
            { value: 'ST', name: 'ST' }
        ];
        vm.data = data;

        var dmin = new Date(data.year + '-' + data.month + '-01');
        data.minDate = new Date(
            dmin.getFullYear(),
            dmin.getMonth(),
            1
        );

        var maxday = moment(data.year + '-' + data.month + '-01').add('months', 1).date(0).format('DD');
        var dmax = new Date(data.year + '-' + data.month + '-' + maxday);
        data.maxDate = new Date(
            dmax.getFullYear(),
            dmax.getMonth(),
            maxday
        );

        var areaSalesStatus = vm.data.status[data.year + '-' + data.month];
        if (areaSalesStatus !== undefined) {
            vm.Form.objForm.id = areaSalesStatus[0].id;
            vm.Form.objForm.area_status = areaSalesStatus[0].area_status;
            vm.Form.objForm.parent_id = areaSalesStatus[0].parent_id;
            vm.Form.objForm.effective_date = new Date(areaSalesStatus[0].effective_date);
        }

        vm.Form.objForm.area_sales_id = data.id;
        vm.Form.objForm.parent_id = data.parent_id;

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, AreaSalesStatus);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.area_sales_status')
        .controller('InputAreaSalesStatusController', InputAreaSalesStatusController);

    InputAreaSalesStatusController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'areaSalesLists'];

    /* @ngInject */
    function InputAreaSalesStatusController($mdDialog, Form, AppAPI, areaSalesLists) {
        var vm = this;
        vm.saveData = saveData;
        var AreaSalesStatus = AppAPI.AreaSalesStatus();
        Form.initialForm();
        Form.setObject(AreaSalesStatus);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.areaSalesLists = areaSalesLists;
        vm.areaStatusLists = [
            { value: 'CB', name: 'CB' },
            { value: 'DP', name: 'DP' },
            { value: 'CP+', name: 'CP+' },
            { value: 'CP', name: 'CP' },
            { value: 'ST', name: 'ST' },
            { value: 'SD', name: 'SD' },
            { value: 'NS', name: 'NS' }
        ];

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, AreaSalesStatus);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
  "use strict";

  angular.module('app.structure_area.cabang_sales', []).config(config);

  config.$inject = ['$stateProvider'];
  function config($stateProvider) {

    $stateProvider
      .state('app.cabang_sales', {
        url: '/structure_area/cabang_sales',
        views: {
          'content@app': {
            templateUrl: 'app/main/structure-area/cabang-sales/cabang-sales.html',
            controller: 'CabangSalesController as vm'
          }
        }

      });

  }
}());
(function () {
    'use strict';

    angular
        .module('app.structure_area.cabang_sales')
        .controller('CabangSalesController', CabangSalesController);

    CabangSalesController.$inject = ['$q', 'DataService', 'AppAPI', '$mdDialog', 'Auth', '$log'];

    /* @ngInject */
    function CabangSalesController($q, DataService, AppAPI, $mdDialog, Auth, $log) {

        var vm = this;
        vm.regionalSalesLists = [];
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.regionalSales = '';
        vm.DataTable = new DataService();
        var CabangSales = AppAPI.CabangSales();
        vm.loadData = loadData;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        ////////////////
        var response = CabangSales.query({ action: 'getRegionalSales' });
        response.$promise.then(function (data) {
            // data.map(function (val) {
            //     vm.regionalSalesLists.push(val);
            // });
            vm.regionalSalesLists = data;
        });
        response.$promise.catch(function (data) {
            $log.info(data);
        });

        loadData('1');

        function loadData(pageno) {
            var params = {
                action: 'viewdata',
                regional_sales_id: vm.regionalSales,
            };
            var response = vm.DataTable.loadData(CabangSales, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                console.log('res', res);
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        function add(ev) {
            $mdDialog.show({
                controller: 'InputCabangSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/cabang-sales/cabang-sales-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    regionalSalesLists: vm.regionalSalesLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'UpdateCabangSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/cabang-sales/cabang-sales-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    regionalSalesLists: vm.regionalSalesLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = CabangSales.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
                    response.$promise.then(loadData);
                }, function () {
                });
            });
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.cabang_sales')
        .controller('UpdateCabangSalesController', UpdateCabangSalesController);

    UpdateCabangSalesController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'regionalSalesLists', 'data'];

    /* @ngInject */
    function UpdateCabangSalesController($mdDialog, Form, AppAPI, regionalSalesLists, data) {
        var vm = this;
        vm.saveData = saveData;
        var CabangSales = AppAPI.CabangSales();
        Form.initialForm();
        Form.setObject(CabangSales);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.regionalSalesLists = regionalSalesLists;

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.code_cabang = data.code_cabang;
        vm.Form.objForm.description = data.description;
        vm.Form.objForm.regional_sales_id = data.regional_sales_id;

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, CabangSales);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.cabang_sales')
        .controller('InputCabangSalesController', InputCabangSalesController);

    InputCabangSalesController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'regionalSalesLists'];

    /* @ngInject */
    function InputCabangSalesController($mdDialog, Form, AppAPI, regionalSalesLists) {
        var vm = this;
        vm.saveData = saveData;
        var CabangSales = AppAPI.CabangSales();
        Form.initialForm();
        Form.setObject(CabangSales);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.regionalSalesLists = regionalSalesLists;

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, CabangSales);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
  "use strict";

  angular.module('app.structure_area.emp_area_sales', []).config(config);

  config.$inject = ['$stateProvider'];
  function config($stateProvider) {

    $stateProvider
      .state('app.emp_area_sales', {
        url: '/structure_area/emp_area_sales',
        views: {
          'content@app': {
            templateUrl: 'app/main/structure-area/emp-area-sales/emp-area-sales.html',
            controller: 'EmpAreaSalesController as vm'
          }
        }

      });

  }
}());
(function () {
    'use strict';

    angular
        .module('app.structure_area.emp_area_sales')
        .controller('EmpAreaSalesController', EmpAreaSalesController);

    EmpAreaSalesController.$inject = ['$q', 'DataService', 'AppAPI', '$mdDialog', 'Auth', '$log', '$filter'];

    /* @ngInject */
    function EmpAreaSalesController($q, DataService, AppAPI, $mdDialog, Auth, $log, $filter) {

        var vm = this;

        var translate = $filter('translate');

        vm.areaSalesLists = [];
        vm.wilayahSalesLists = [];
        vm.regionalSalesLists = [];
        vm.cabangSalesLists = [];
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.areaSales = '';
        vm.wilayahSales = '';
        vm.regionalSales = '';
        vm.cabangSales = '';
        vm.DataTable = new DataService();
        var EmpAreaSales = AppAPI.EmpAreaSales();
        var RegionalSales = AppAPI.RegionalSales();
        var CabangSales = AppAPI.CabangSales();
        var AreaSales = AppAPI.AreaSales();
        vm.loadData = loadData;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;
        vm.importExcel = importExcel;

        var response = RegionalSales.query({ action: 'getWilayahSales' });
        response.$promise.then(function (data) {
            vm.wilayahSalesLists = data;
        });
        response.$promise.catch(function (data) {
            $log.info(data);
        });

        var response = CabangSales.query({ action: 'getRegionalSales' });
        response.$promise.then(function (data) {
            vm.regionalSalesLists = data;
        });
        response.$promise.catch(function (data) {
            $log.info(data);
        });

        var response = AreaSales.query({ action: 'getCabangSales' });
        response.$promise.then(function (data) {
            vm.cabangSalesLists = data;
        });
        response.$promise.catch(function (data) {
            $log.info(data);
        });

        var response = EmpAreaSales.query({ action: 'getAreaSales' });
        response.$promise.then(function (data) {
            vm.areaSalesLists = data;
        });
        response.$promise.catch(function (data) {
            $log.info(data);
        });

        loadData('1');

        function loadData(pageno) {
            var params = {
                action: 'viewdata',
                area_sales_id: vm.areaSales,
                cabang_sales_id: vm.cabangSales,
                regional_sales_id: vm.regionalSales,
                wilayah_sales_id: vm.wilayahSales
            };
            var response = vm.DataTable.loadData(EmpAreaSales, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                res.list.map(function (val) {
                    val.effective_date = new Date(val.effective_date);
                });
                console.log('res', res);
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        function add(ev) {
            $mdDialog.show({
                controller: 'InputEmpAreaSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/emp-area-sales/emp-area-sales-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    areaSalesLists: vm.areaSalesLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'UpdateEmpAreaSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/emp-area-sales/emp-area-sales-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    areaSalesLists: vm.areaSalesLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function remove(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = EmpAreaSales.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data);
                    });
                    promise.catch(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data)
                    });
                }, function () {
                });
            });
        }

        function importExcel(ev) {
            $mdDialog.show({
                controller: 'ImportEmpAreaSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/emp-area-sales/emp-area-sales-import.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    loadData();
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.emp_area_sales')
        .controller('ImportEmpAreaSalesController', ImportEmpAreaSalesController);

    ImportEmpAreaSalesController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config'];

    /* @ngInject */
    function ImportEmpAreaSalesController($mdDialog, $localStorage, FileUploader, config) {
        var vm = this;
        // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal = closeModal;
        vm.uploadFile = uploadFile;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        vm.downloadTemplateURL = config.api + 'api/structurearea/empareasales/templateexcel';
        ////////////////



        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/structurearea/empareasales/importexcel',
            removeAfterUpload: true,
            alias: 'excelfile',
            formData: [
                {
                    action: 'importexcel'
                }
            ],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        uploaderPhoto.onSuccessItem = function (item) {
            vm.UploadPhotoStateSucces = true;
            vm.UploadPhotoStateError = false;
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem = function () {
            vm.UploadPhotoStateSucces = false;
            vm.UploadPhotoStateError = true;
        };

        function uploadFile() {
            return false;
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.emp_area_sales')
        .controller('UpdateEmpAreaSalesController', UpdateEmpAreaSalesController);

    UpdateEmpAreaSalesController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'areaSalesLists', 'data', '$log', '$http', 'config', '$filter'];

    /* @ngInject */
    function UpdateEmpAreaSalesController($mdDialog, Form, AppAPI, areaSalesLists, data, $log, $http, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        var EmpAreaSales = AppAPI.EmpAreaSales();
        Form.initialForm();
        Form.setObject(EmpAreaSales);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.areaSalesLists = areaSalesLists;
        vm.frmEPSA = {};
        vm.saveEmpPersonalSubArea = saveEmpPersonalSubArea;
        vm.updateEmpPersonalSubArea = updateEmpPersonalSubArea;
        vm.subareaLists = [];

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.nik = data.nik;
        vm.Form.objForm.effective_date = data.effective_date;
        vm.Form.objForm.sub_area_id = data.sub_area_id;
        vm.empPersonalSubareaLists = data.emp_personal_sub_area;
        vm.toggleShowEditEPSA = toggleShowEditEPSA;

        vm.lookupSubarea = lookupSubarea;
        vm.selectedsubarea = '';
        vm.keywordsSubarea = '';

        var response = EmpAreaSales.query({ action: 'getSubArea' });
        response.$promise.then(function (data) {
            vm.subareaLists = data;
        });
        response.$promise.catch(function (data) {
            $log.info(data);
        });

        function toggleShowEditEPSA(item) {
            vm.selectedEmpPersonalSubAreaEdit = item.sub_area_id;
            vm.frmEPSA = angular.copy(item);
            vm.frmEPSA.effective_date = new Date(vm.frmEPSA.effective_date);
            vm.showEditEPSA = 1;
            vm.showAddEPSA = 0;
        }

        function lookupSubarea(params) {
            return $http
                .get(config.api + 'api/structurearea/empareasales?action=lookupSubarea&search=' + params)
                .then(function (item) {
                    return item.data;
                });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveEmpPersonalSubArea(ev, frm) {

            frm.sub_area_id = vm.selectedsubarea.id;

            var empAreaSales = new EmpAreaSales();
            empAreaSales.action = 'saveEmpPersonalSubarea';
            empAreaSales.sub_area_id = frm.sub_area_id;
            empAreaSales.effective_date = frm.effective_date;
            empAreaSales.nik = data.nik;
            var promise = empAreaSales.$save();
            promise.then(function (data) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Home Base')
                        .textContent(data.pesan)
                        .ariaLabel('Success add new home base')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    vm.showAddEPSA = 0;
                });
            });
            promise.catch(function (data) {
                console.log('data', data);
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Home Base')
                        .textContent(data.data.pesan)
                        .ariaLabel('Failed add new home base')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {

                });
            });

        }

        function updateEmpPersonalSubArea(ev, frm) {
            var empAreaSales = new EmpAreaSales();
            empAreaSales.action = 'updateEmpPersonalSubArea';
            empAreaSales.sub_area_id = frm.sub_area_id;
            empAreaSales.effective_date = frm.effective_date;
            empAreaSales.nik = data.nik;
            empAreaSales.id = frm.id;
            var promise = empAreaSales.$save();
            promise.then(function (data) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Home Base')
                        .textContent(data.pesan)
                        .ariaLabel('Success add new home base')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    vm.showAddEPSA = 0;
                });
            });
            promise.catch(function (data) {
                console.log('data', data);
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Home Base')
                        .textContent(data.data.pesan)
                        .ariaLabel('Failed add new home base')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {

                });
            });

        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, EmpAreaSales);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });
            promise.catch(function (data) {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.emp_area_sales')
        .controller('InputEmpAreaSalesController', InputEmpAreaSalesController);

    InputEmpAreaSalesController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'areaSalesLists', '$http', 'config', '$element', '$filter'];

    /* @ngInject */
    function InputEmpAreaSalesController($mdDialog, Form, AppAPI, areaSalesLists, $http, config, $element, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        var EmpAreaSales = AppAPI.EmpAreaSales();
        Form.initialForm();
        Form.setObject(EmpAreaSales);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.areaSalesLists = areaSalesLists;
        vm.selectedEmployee = '';
        vm.keywordsEmployee = '';
        vm.lookupEmployees = lookupEmployees;
        vm.selectedsubarea = '';
        vm.keywordsSubarea = '';
        vm.selectedAreaSales = selectedAreaSales;
        vm.selectedEmployeeChange = selectedEmployeeChange;

        vm.searchAreaSales;
        vm.clearSearchAreaSales = function () {
            vm.searchAreaSales = '';
        };
        // The md-select directive eats keydown events for some quick select
        // logic. Since we have a search input here, we don't need that logic.
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function lookupEmployees(params) {
            return $http
                .get(config.api + 'api/structurearea/empareasales?action=lookupEmployees&search=' + params)
                .then(function (item) {
                    return item.data;
                });
        }

        function selectedEmployeeChange(item) {
            console.log('item', item);
        }

        function selectedAreaSales(id) {
            var areaSales = vm.areaSalesLists.find(function (t) {
                if (t.id === id) {
                    return t;
                }
            });
            vm.Form.objForm.sub_area_id = areaSales.sub_area_id;
            // console.log('areaSales', areaSales);
        }

        function saveData(ev, formController) {
            vm.Form.objForm.nik = vm.selectedEmployee.nik;
            var promise = Form.saveData('save', formController, EmpAreaSales);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });
            promise.catch(function (data) {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function () {
  "use strict";

  angular.module('app.structure_area.area_sales', []).config(config);

  config.$inject = ['$stateProvider'];
  function config($stateProvider) {

    $stateProvider
      .state('app.area_sales', {
        url: '/structure_area/area_sales',
        views: {
          'content@app': {
            templateUrl: 'app/main/structure-area/area-sales/area-sales.html',
            controller: 'AreaSalesController as vm'
          }
        }

      });

  }
}());
(function () {
    'use strict';

    angular
        .module('app.structure_area.area_sales')
        .controller('AreaSalesController', AreaSalesController);

    AreaSalesController.$inject = ['$q', 'DataService', 'AppAPI', '$mdDialog', 'Auth', '$log'];

    /* @ngInject */
    function AreaSalesController($q, DataService, AppAPI, $mdDialog, Auth, $log) {

        var vm = this;
        vm.cabangSalesLists = [];
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.cabangSales = '';
        vm.DataTable = new DataService();
        var AreaSales = AppAPI.AreaSales();
        vm.loadData = loadData;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        ////////////////
        var response = AreaSales.query({ action: 'getCabangSales' });
        response.$promise.then(function (data) {
            // data.map(function (val) {
            //     vm.cabangSalesLists.push(val);
            // });
            vm.cabangSalesLists = data;
        });
        response.$promise.catch(function (data) {
            $log.info(data);
        });

        loadData('1');

        function loadData(pageno) {
            var params = {
                action: 'viewdata',
                cabang_sales_id: vm.cabangSales,
            };
            var response = vm.DataTable.loadData(AreaSales, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                console.log('res', res);
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        function add(ev, parentData) {
            $mdDialog.show({
                controller: 'InputAreaSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/area-sales/area-sales-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    parentData: parentData
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'UpdateAreaSalesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/structure-area/area-sales/area-sales-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    cabangSalesLists: vm.cabangSalesLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = AreaSales.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
                    response.$promise.then(loadData);
                }, function () {
                });
            });
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.area_sales')
        .controller('UpdateAreaSalesController', UpdateAreaSalesController);

    UpdateAreaSalesController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', 'cabangSalesLists', 'data', '$element', '$log'];

    /* @ngInject */
    function UpdateAreaSalesController($q, $mdDialog, Form, AppAPI, cabangSalesLists, data, $element, $log) {
        var vm = this;
        vm.saveData = saveData;
        var AreaSales = AppAPI.AreaSales();
        var RegionalSales = AppAPI.RegionalSales();
        var CabangSales = AppAPI.CabangSales();
        Form.initialForm();
        Form.setObject(AreaSales);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.cabangSalesLists = cabangSalesLists;

        vm.cabangSalesLists = [
            { name: '-- Cabang Sales', value: '' }
        ];
        vm.wilayahSalesLists = [
            { name: '-- Wilayah Sales', value: '' }
        ];
        vm.regionalSalesLists = [
            { name: '-- Regional Sales', value: '' }
        ];
        vm.loadWilayah = loadWilayah;
        vm.loadRegional = loadRegional;
        vm.loadCabang = loadCabang;
        vm.lookupSubArea = lookupSubArea;
        vm.selectedSubArea = '';
        vm.salesTypeLists = [
            { name: '-- Sales Type', value: '' },
            { name: 'GT', value: 'GT' },
            { name: 'MT', value: 'MT' },
            { name: 'EDD', value: 'EDD' },
            { name: 'OTH', value: 'OTH' }
        ];

        vm.selectedAreaSales = selectedAreaSales;
        vm.loadAreaSales = loadAreaSales;
        vm.searchAreaSales;
        vm.clearSearchAreaSales = function () {
            vm.searchAreaSales = '';
        };
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function selectedAreaSales(id) {
            var areaSales = vm.areaSalesLists.find(function (t) {
                if (t.id === id) {
                    return t;
                }
            });
            console.log('areaSales', areaSales);
            return areaSales;
        }

        console.log('data', data);

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.code_area = data.code_area;
        vm.Form.objForm.description = data.description;
        vm.Form.objForm.cabang_sales_id = data.cabang_sales_id;
        vm.Form.objForm.sales_type = data.sales_type;
        loadWilayah(data.sales_type).then(function () {
            vm.Form.objForm.wilayah_sales_id = data.wilayah_sales_id;
            loadRegional(data.wilayah_sales_id).then(function () {
                vm.Form.objForm.regional_sales_id = data.regional_sales_id;
                loadCabang(data.regional_sales_id).then(function () {
                    vm.Form.objForm.cabang_sales_id = data.cabang_sales_id;
                });
            });
        });

        // vm.Form.objForm.wilayah_sales_id = data.wilayah_sales_id;
        // vm.Form.objForm.regional_sales_id = data.regional_sales_id;
        // vm.Form.objForm.cabang_sales_id = data.cabang_sales_id;

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function loadAreaSales() {
            var response = AreaSales.query({
                action: 'getParent',
                salesType: vm.Form.objForm.sales_type,
                wilayahSales: vm.Form.objForm.wilayah_sales_id,
                regionalSales: vm.Form.objForm.regional_sales_id,
                cabangSales: vm.Form.objForm.cabang_sales_id
            });
            response.$promise.then(function (data) {
                vm.areaSalesLists = data;
            });
            response.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function loadWilayah(salesType) {
            var defer = $q.defer();
            vm.Form.objForm.wilayah_sales_id = '';

            if (vm.Form.objForm.sales_type === 'MT' && vm.Form.objForm.is_homebase === false) {
                loadAreaSales();
            }

            if (salesType === '') {
                vm.wilayahSalesLists = [
                    { name: '-- Wilayah Sales', value: '' }
                ];
                defer.resolve();
                return false;
            }
            var response = RegionalSales.query({ action: 'getWilayahSales', salesType: salesType });
            response.$promise.then(function (data) {
                vm.wilayahSalesLists = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject(data);
            });
            return defer.promise;
        }

        function loadRegional(wilayahSales) {
            var defer = $q.defer();
            vm.Form.objForm.regional_sales_id = '';

            if (vm.Form.objForm.sales_type === 'MT' && vm.Form.objForm.is_homebase === false) {
                loadAreaSales();
            }

            if (wilayahSales === '') {
                vm.regionalSalesLists = [
                    { name: '-- Regional Sales', value: '' }
                ];
                defer.resolve();
                return false;
            }
            var response = CabangSales.query({ action: 'getRegionalSales', wilayahSales: wilayahSales });
            response.$promise.then(function (data) {
                vm.regionalSalesLists = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject(data);
            });
            return defer.promise;
        }

        function loadCabang(regionalSales) {
            var defer = $q.defer();
            vm.Form.objForm.cabang_sales_id = '';

            if (vm.Form.objForm.sales_type === 'MT' && vm.Form.objForm.is_homebase === false) {
                loadAreaSales();
            }

            if (regionalSales === '') {
                vm.cabangSalesLists = [
                    { name: '-- Cabang Sales', value: '' }
                ];
                defer.resolve();
                return false;
            }
            var response = AreaSales.query({ action: 'getCabangSales', regionalSales: regionalSales });
            response.$promise.then(function (data) {
                vm.cabangSalesLists = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject(data);
            });
            return defer.promise;
        }

        function lookupSubArea(params) {
            var sales_type = vm.Form.objForm.sales_type;

            return $http
                .get(config.api + 'api/structurearea/areasales?action=lookupSubarea&search=' + params + '&salesType=' + sales_type)
                .then(function (item) {
                    return item.data;
                });
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, AreaSales);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.structure_area.area_sales')
        .controller('InputAreaSalesController', InputAreaSalesController);

    InputAreaSalesController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', 'parentData', '$element', '$log'];

    /* @ngInject */
    function InputAreaSalesController($q, $mdDialog, Form, AppAPI, $http, config, parentData, $element, $log) {
        var vm = this;
        vm.saveData = saveData;
        var AreaSales = AppAPI.AreaSales();
        var RegionalSales = AppAPI.RegionalSales();
        var CabangSales = AppAPI.CabangSales();
        Form.initialForm();
        Form.setObject(AreaSales);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.cabangSalesLists = [
            { name: '-- Cabang Sales', value: '' }
        ];
        vm.wilayahSalesLists = [
            { name: '-- Wilayah Sales', value: '' }
        ];
        vm.regionalSalesLists = [
            { name: '-- Regional Sales', value: '' }
        ];
        vm.loadWilayah = loadWilayah;
        vm.loadRegional = loadRegional;
        vm.loadCabang = loadCabang;
        vm.lookupSubArea = lookupSubArea;
        vm.selectedSubArea = '';
        vm.salesTypeLists = [
            { name: '-- Sales Type', value: '' },
            { name: 'GT', value: 'GT' },
            { name: 'MT', value: 'MT' },
            { name: 'EDD', value: 'EDD' },
            { name: 'OTH', value: 'OTH' }
        ];
        vm.parentData = parentData;
        if (vm.parentData) {
            vm.Form.objForm.sales_type = vm.parentData.sales_type;
            loadWilayah(vm.parentData.sales_type).then(function () {
                vm.Form.objForm.wilayah_sales_id = vm.parentData.wilayah_sales_id;
                loadRegional(vm.parentData.wilayah_sales_id).then(function () {
                    vm.Form.objForm.regional_sales_id = vm.parentData.regional_sales_id;
                    loadCabang(vm.parentData.regional_sales_id).then(function () {
                        vm.Form.objForm.cabang_sales_id = vm.parentData.cabang_sales_id;
                    });
                });
            });
        }

        vm.selectedAreaSales = selectedAreaSales;
        vm.loadAreaSales = loadAreaSales;
        vm.searchAreaSales;
        vm.clearSearchAreaSales = function () {
            vm.searchAreaSales = '';
        };
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function selectedAreaSales(id) {
            var areaSales = vm.areaSalesLists.find(function (t) {
                if (t.id === id) {
                    return t;
                }
            });
            console.log('areaSales', areaSales);
            return areaSales;
        }

        function loadAreaSales() {
            var response = AreaSales.query({
                action: 'getParent',
                salesType: vm.Form.objForm.sales_type,
                wilayahSales: vm.Form.objForm.wilayah_sales_id,
                regionalSales: vm.Form.objForm.regional_sales_id,
                cabangSales: vm.Form.objForm.cabang_sales_id
            });
            response.$promise.then(function (data) {
                vm.areaSalesLists = data;
            });
            response.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function loadWilayah(salesType) {
            var defer = $q.defer();
            vm.Form.objForm.wilayah_sales_id = '';

            if (vm.Form.objForm.sales_type === 'MT' && vm.Form.objForm.is_homebase === false) {
                loadAreaSales();
            }

            if (salesType === '') {
                vm.wilayahSalesLists = [
                    { name: '-- Wilayah Sales', value: '' }
                ];
                defer.resolve();
                return false;
            }
            var response = RegionalSales.query({ action: 'getWilayahSales', salesType: salesType });
            response.$promise.then(function (data) {
                vm.wilayahSalesLists = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject(data);
            });
            return defer.promise;
        }

        function loadRegional(wilayahSales) {
            var defer = $q.defer();
            vm.Form.objForm.regional_sales_id = '';

            if (vm.Form.objForm.sales_type === 'MT' && vm.Form.objForm.is_homebase === false) {
                loadAreaSales();
            }

            if (wilayahSales === '') {
                vm.regionalSalesLists = [
                    { name: '-- Regional Sales', value: '' }
                ];
                defer.resolve();
                return false;
            }
            var response = CabangSales.query({ action: 'getRegionalSales', wilayahSales: wilayahSales });
            response.$promise.then(function (data) {
                vm.regionalSalesLists = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject(data);
            });
            return defer.promise;
        }

        function loadCabang(regionalSales) {
            var defer = $q.defer();
            vm.Form.objForm.cabang_sales_id = '';

            if (vm.Form.objForm.sales_type === 'MT' && vm.Form.objForm.is_homebase === false) {
                loadAreaSales();
            }

            if (regionalSales === '') {
                vm.cabangSalesLists = [
                    { name: '-- Cabang Sales', value: '' }
                ];
                defer.resolve();
                return false;
            }
            var response = AreaSales.query({ action: 'getCabangSales', regionalSales: regionalSales });
            response.$promise.then(function (data) {
                vm.cabangSalesLists = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject(data);
            });
            return defer.promise;
        }

        function lookupSubArea(params) {
            var sales_type = vm.Form.objForm.sales_type;

            return $http
                .get(config.api + 'api/structurearea/areasales?action=lookupSubarea&search=' + params + '&salesType=' + sales_type)
                .then(function (item) {
                    return item.data;
                });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {

            if (vm.parentData) {
                vm.Form.objForm.parent_id = vm.parentData.id;
            }

            var promise = Form.saveData('save', formController, AreaSales);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function() {
	"use strict";

	angular.module('app.travel.travel-managment', []).config(config);
	config.$inject = ['$stateProvider'];

	function config($stateProvider){

		$stateProvider
			.state('app.travel_managment',{
				url 	: '/travel/travel-managment',
				views : {
					'content@app' :{
						templateUrl	: 'app/main/travel/travel-managment/travel-managment.html',
						controller 	: 'TravelManagmentController as vm'
					}

				}

			});
	}
	
}());
(function() {
	'use strict';

	angular
		.module('app.travel.travel-managment')
		.controller('TravelManagmentController', TravelManagmentController);

	TravelManagmentController.$inject = ['AppAPI', '$localStorage', 'DataService', 'Form', 'Auth'];

	function TravelManagmentController(AppAPI, $localStorage, DataService, Form, Auth) {
			var vm = this;

	}

})();
(function() {
	"use strict";

	angular.module('app.travel.travel-list', []).config(config);
	config.$inject = ['$stateProvider'];

	function config($stateProvider){

		$stateProvider
			.state('app.travel_list',{
				url 	: '/travel/travel-list',
				views : {
					'content@app' :{
						templateUrl	: 'app/main/travel/travel-list/travel-list.html',
						controller 	: 'TravelListController as vm'
					}

				}

			});
	}
	
}());
(function() {
	'use strict';

	angular
		.module('app.travel.travel-list')
		.controller('TravelListController', TravelListController);

	TravelListController.$inject = ['AppAPI', '$localStorage', 'DataService', 'Form', 'Auth'];

	function TravelListController(AppAPI, $localStorage, DataService, Form, Auth) {
			var vm = this;

			var Insurance=AppAPI.Insurance();
			
			vm.loadDataDivision=loadDataDivision;
			vm.loadDataDepartment=loadDataDepartment;
			loadDataBU();
			loadDataDivision(vm.company);
			loadDataDepartment(vm.divisi);




      // load bu
      function loadDataBU(){
      	var response = Insurance.query({action:'viewBU'});
      	response.$promise.then(fetchBU);
      	response.$promise.catch(errorFetchBU);
      }

	    function fetchBU(data) {
	      vm.listBU=data;
	    }

	    function errorFetchBU() {
	      vm.listBU=[];
	    }


			// load division
		  function loadDataDivision(idbu) {
	      var response=Insurance.query({action:'viewDivisiBu',idbu:idbu});
	      response.$promise.then(fetchDivisiBU);
	      response.$promise.catch(errorDivisiBU);
	    }

	    function fetchDivisiBU(data) {
	     vm.listDivision=data;
	    }

	    function errorDivisiBU() {
	      vm.listDivision=[];
	    }

	    // load department
	    function loadDataDepartment(iddivisi) {
	      var response=Insurance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
	      response.$promise.then(fetchDepartment);
	      response.$promise.catch(errorDepartment);
	    }

	    function fetchDepartment(data) {
	      vm.listDepartment=data;
	    }

	    function errorDepartment() {
	      vm.listDepartment=[];
	    }


	}

})();
(function () {
  'use strict';

  angular
      .module('app.tiket.tiket-approval', [])
       .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.tiket_approval', {
              url: '/tiket/approval',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/tiket/tiket-approval/tiket-approval.html',
                      controller: 'TiketApprovalController as vm'
                  }
              }
          });
  }
 })();

(function() {
  'use strict';
  angular
    .module('app.tiket.tiket-approval')
    .controller('TiketApprovalController', TiketApprovalController);

  TiketApprovalController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    '$q',
    'filterFilter'
  ];
  /** @ngInject */
  function TiketApprovalController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    $q,
    filterFilter
  ) {
    var vm = this; 
    vm.loadData=loadData
    vm.listJum=[2,5,25,50,75,100,200];
    vm.DataTable= new DataService();
    vm.loadData=loadData; 
    var TiketApproval=AppAPI.TiketApproval();
    var nik= $localStorage.user;
    vm.isChecked=isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected=[];
    vm.approveData=approveData;
    vm.Reject=Reject;
    vm.viewComment=viewComment;
    vm.UnReject=UnReject;
    vm.UnApproved=UnApproved; 
    vm.viewDetail=viewDetail;

    var date=new Date();
    vm.type='waiting approval';
    vm.listType=['waiting approval','approved','rejected']; 
    vm.toggleSelectedAll=toggleSelectedAll;

    /////////////////////
    
    loadData(1);

    function viewDetail(ev, data) 
    {
      $mdDialog.show({
          controller         : 'viewTiketDetailController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/tiket/tiket/view-detail.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:false,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals : { 
              data : data
          }
      });
    }
    
    function loadData(pageno)
    { 
      vm.listOtselected=[];
      var resp=vm.DataTable.loadData(TiketApproval,pageno,{action:'viewdata',type:vm.type});
      vm.listGhk=[];
    } 

    function isChecked(ls)
    {
        return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event)
    {
        if ( event )
        {
            event.stopPropagation();
        }

        var idx = vm.listOtselected.indexOf(ls);

        if ( idx > -1 )
        {
            vm.listOtselected.splice(idx, 1);
        }
        else
        {
            vm.listOtselected.push(ls);
        }
    }

    function toggleSelectedAll(state)
    {
      switch(state)
      {
          case true:
          checkAll();
          break;
          case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() 
    {
       vm.listOtselected=angular.copy(vm.DataTable.list);
    }

    function unCheckAll() 
    {
      vm.listOtselected=[];
    }

    function approveData(ev)
    {
      var jum=vm.listOtselected.length,i,ids=[];
      if(jum>0)
      {
        var promise=Auth.setToken();
        promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
            });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var TA= new TiketApproval();
                TA.data=[];
                TA.action='approve';
                TA.nik=nik;   
                for (i=0;i<jum;i++) {
                  TA.data.push(vm.listOtselected[i]);
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=TA.$save(); 
                response.then(function(data){
                  angular.element.unblockUI();
                  if (data.status == 1) {
                    successApproved(ev,data);
                  } else {
                    failedApproved(ev,data);
                  }
                });
                response.catch(function(data){
                  // console.log(data.data);
                  failedApproved(ev,data.data);
                  angular.element.unblockUI();
                });
            }, function() {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      }else{
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Attention!')
        .textContent('No data selected')
        .ariaLabel('Attention')
        .ok('close')
        .targetEvent(ev)
        ).then(function(){
            loadData();
        });
      } 
    }

    function successApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
            if ('moreInfo' in data && data.moreInfo.length>0) {
              $mdDialog.show({
                  controller         : 'logFailGwController',
                  controllerAs       : 'vm',
                  templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                  parent: angular.element(document.body),
                  clickOutsideToClose:true,
                  fullscreen: true,
                  onRemoving:function(element, removePromise)
                  {
                      loadData(1);
                  },
                  locals:{
                    data:data.moreInfo
                  }
              });
            }else{
              loadData(1);
            }
          });
        
      }

      function failedApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

    function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          $mdDialog.show({
              controller         : 'TicketRejectCommentController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/tiket/tiket-approval/comment-reject.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData();
                  vm.listOtselected=[];
              },
              locals:{
                id:vm.listOtselected
              }
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

    function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'TicketViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/tiket/tiket-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              vm.listOtselected=[];
          },
          locals:{
            id:id
          }
      });
    }

    function UnReject(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
          var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
          angular.element.blockUI();
          var response=TiketApproval.delete({action:'unreject',data:angular.toJson(id)});
          response.$promise.then(function(data){
            succesUnreject(ev,data);
          });
          response.$promise.catch(function(){
            angular.element.unblockUI();
            failedUnapproved(ev,data);
          });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

    function UnApproved(ev,id)
      {
        var promise=Auth.setToken();
         promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

         $mdDialog.show(confirm).then(function() {
         angular.element.blockUI();
         var response=TiketApproval.delete({action:'unapproved',data:angular.toJson(id)});
          
          response.$promise.then(function(data){
            if (data.status == 1) {
              successApproved(ev,data);
            } else {
              failedApproved(ev,data);
            }
          });
           response.$promise.catch(function(data){
            failedUnapproved(ev,data);
           });
          angular.element.unblockUI();
            }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
         });
      }

      function succesUnapproved(ev,data)
      {
        if(data.hasil=='expired'){
          showFailedUnapproved();
        }else{
          showDialog();
        }
        loadData();
      } 

      function succesUnreject(ev,data)
      {
        if(data.hasil=='expired'){
          showFailedUnreject();
        }else{
          showDialogUnreject();
        }
        loadData();
      }

      function failedUnapproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.data)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
      }

      function showFailedUnapproved() {
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Failed Unapproved Data')
        .textContent('Transaction Locked By System.')
        .ariaLabel('Transaction Locked By System')
        .ok('OK')
        ).then(function(){
            $mdDialog.hide();
        });
      }

      function showFailedUnreject() {
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Failed Unreject Data')
        .textContent('Transaction Locked By System.')
        .ariaLabel('Transaction Locked By System')
        .ok('OK')
        ).then(function(){
            $mdDialog.hide();
        });
      }

      function showDialog() {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
          ).then(function(){
            $mdDialog.hide();
          });
      }

      function showDialogUnreject() {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Process Data')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
          ).then(function(){
            $mdDialog.hide();
          });
      }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.tiket.tiket-approval')
        .controller('TicketViewRejectCommentController', TicketViewRejectCommentController);

    TicketViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$sce'];

    /* @ngInject */
    function TicketViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$sce) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var TiketApproval = AppAPI.TiketApproval();

        // set constructor form
        Form.setObject(TiketApproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;

        vm.getHtml =  function(html){
            return $sce.trustAsHtml(html);
        };
        function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, TiketApproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.tiket.tiket-approval')
        .controller('TicketRejectCommentController', TicketRejectCommentController);

    TicketRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function TicketRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) 
    {
        var vm = this; 
        // initial form
        Form.initialForm();

        var TiketApproval = AppAPI.TiketApproval();

        // set constructor form
        Form.setObject(TiketApproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;

        function saveData(ev,formController)
        { 
            var promise= Form.saveData('reject', formController, TiketApproval);
            promise.then(function(data){
                if (data.status == 1) {
                    successApproved(ev,data);
                } else {
                    failedApproved(ev,data);
                }
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success save data')
            .textContent(data.pesan)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    // loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed')
            .textContent(data.pesan)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                // loadData();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.tiket.tiket', ['ui.tinymce'])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.tiket', {
                url: '/tiket',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/tiket/tiket/tiket.html',
                        controller: 'TiketController as vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.tiket.tiket')
        .controller('viewTiketDetailController', viewTiketDetailController);

    viewTiketDetailController.$inject = ['$mdDialog','data','$localStorage','config','AppAPI','DataService','Auth'];

    /* @ngInject */
    function viewTiketDetailController($mdDialog,data,$localStorage,config,AppAPI,DataService,Auth) {
        var vm = this; 

        var Tiket = AppAPI.Tiket();
        var TiketApproval = AppAPI.TiketApproval();
        vm.DataTable= new DataService();
        vm.closeModal=closeModal;
        vm.approved=approved;
        vm.rejected=rejected;
        vm.UnReject=UnReject;
        vm.UnApproved=UnApproved;
        vm.showAlert = false;
        
        loadTiketDetail();

        function loadTiketDetail() {
            var response=Tiket.query({action:'viewDetail',detail_id:data.id});
            response.$promise.then(fetchTiketDetail);
            response.$promise.catch(errorFetchTiketDetail);
        }

        function fetchTiketDetail(data) {
            vm.title = data[0].title
            vm.description = (data[0].description == null || data[0].description === "") ? '<p>-</p>' : data[0].description
            vm.deliverable = data[0].deliverable
            vm.targetFinish = new Date(data[0].target_finish)
            vm.submitDate = new Date(data[0].submit_date)
            vm.ticketStatus = data[0].tiket_status
            vm.approvalStatus = data[0].approval_status
            vm.targetDepartment = data[0].target_department
            vm.approvalBy = data[0].name
            vm.service = data[0].service
            vm.approvalComment = ((data[0].comment == null || data[0].comment === "")&&data[0].is_requested) ? '<p>-</p>' : data[0].comment
            
            vm.priority = data[0].priority
            vm.isRequested = data[0].is_requested
            var approvaDate = new Date(data[0].approval_date);
            var dd = approvaDate.getDate();
            var mm = approvaDate.getMonth() + 1; //January is 0!

            var yyyy = approvaDate.getFullYear();
            if (dd < 10) {
            dd = '0' + dd;
            } 
            if (mm < 10) {
            mm = '0' + mm;
            } 
            var approvaDate = dd + '/' + mm + '/' + yyyy;
            vm.approvalDate = vm.approvalStatus=='Waiting Approval' ? '-' : approvaDate
        }

        function errorFetchTiketDetail() {
            vm.targetDepartmentList=[];
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function approved(ev)
        {
            var promise=Auth.setToken();
            promise.then(function(){
                angular.element.blockUI();
                vm.objForm = new TiketApproval();
                vm.objForm.action='approve';
                vm.objForm.id = data.id;
                vm.objForm.comment = vm.approvalComment;
                var response = vm.objForm.$save();
                response.then(function(data){
                angular.element.unblockUI();
                if (data.status == 1) {
                    successApproved(ev,data);
                } else {
                    failedApproved(ev,data);
                }
                });
                response.catch(function(data){
                    failedApproved(ev,data.data);
                    angular.element.unblockUI();
                });
            });
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Thanks for Approval')
            .textContent(data.pesan)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                $mdDialog.show({
                    controller         : 'logFailGwController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        //
                    },
                    locals:{
                        data:data.moreInfo
                    }
                });
                }else{

                }
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Approval')
            .textContent(data.pesan)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
            });
            
        }

        function rejected(ev)
        {
            if(vm.approvalComment == null || vm.approvalComment === ""){
                vm.showAlert=true;
            }else{
                var promise=Auth.setToken();
                promise.then(function(){
                    angular.element.blockUI();
                    vm.objForm = new TiketApproval();
                    vm.objForm.action='reject';
                    vm.objForm.id = data.id;
                    vm.objForm.comment = vm.approvalComment;
                    var response = vm.objForm.$save();
                    response.then(function(data){
                    angular.element.unblockUI();
                    if (data.status == 1) {
                        successApproved(ev,data);
                    } else {
                        failedApproved(ev,data);
                    }
                    });
                    response.catch(function(data){
                        failedApproved(ev,data.data);
                        angular.element.unblockUI();
                    });
                });
            }
        }

        function UnReject(ev)
        {
            var promise=Auth.setToken();
            promise.then(function(){
                angular.element.blockUI();
                data.comment = vm.approvalComment;
                var response=TiketApproval.delete({action:'unreject',data:angular.toJson(data)});
                response.$promise.then(function(data){
                    succesUnreject(ev,data);
                });
                response.$promise.catch(function(){
                    angular.element.unblockUI();
                    failedUnapproved(ev,data);
                });
                }, function() {
            });
        }
        
        function UnApproved(ev)
        {
            var promise=Auth.setToken();
            promise.then(function(){
                angular.element.blockUI();
                data.comment = vm.approvalComment;
                var response=TiketApproval.delete({action:'unapproved',data:angular.toJson(data)});
                
                response.$promise.then(function(data){
                    if (data.status == 1) {
                    successApproved(ev,data);
                    } else {
                    failedApproved(ev,data);
                    }
                });
                response.$promise.catch(function(data){
                    failedUnapproved(ev,data);
                });
                angular.element.unblockUI();
            });
        }

        function succesUnapproved(ev,data)
        {
            if(data.hasil=='expired'){
                showFailedUnapproved();
            }else{
                showDialog();
            }
        } 

        function succesUnreject(ev,data)
        {
            if(data.hasil=='expired'){
                showFailedUnreject();
            }else{
                showDialogUnreject();
            }
        }

        function failedUnapproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Approval')
            .textContent(data.data)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
            });
        }

        function showFailedUnapproved() {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Unapproved Data')
            .textContent('Transaction Locked By System.')
            .ariaLabel('Transaction Locked By System')
            .ok('OK')
            ).then(function(){
                $mdDialog.hide();
            });
        }

        function showFailedUnreject() {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Unreject Data')
            .textContent('Transaction Locked By System.')
            .ariaLabel('Transaction Locked By System')
            .ok('OK')
            ).then(function(){
                $mdDialog.hide();
            });
        }

        function showDialogUnreject() {
            $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Success Process Data')
              .textContent('Process Data was Success.')
              .ariaLabel('Attention')
              .ok('close')
              ).then(function(){
                $mdDialog.hide();
              });
          }
    }
})();
(function() {
  'use strict';
  angular
    .module('app.tiket.tiket')
    .controller('TiketController', TiketController);

  TiketController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth', 
    '$q',
    'filterFilter',
    'config',
    'FileUploader',
    'Approvalinfo',
    'Newsinfo'
  ];
  /** @ngInject */
  function TiketController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth, 
    $q,
    filterFilter,
    config,
    FileUploader,
    Approvalinfo,
    Newsinfo
  ) {
    var vm = this;
    var Tiket = AppAPI.Tiket();
    
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData; 
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = []; 
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company=$localStorage.empsite;
    vm.viewDetail=viewDetail;
    vm.viewComment=viewComment;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(Tiket, pageno, {
        action: 'viewData'
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'TiketInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/tiket/tiket/tiket-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) 
    {
      $mdDialog.show({
          controller         : 'viewTiketDetailController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/tiket/tiket/view-detail.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:false,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              //
          },
          locals : { 
              data : data
          }
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'TiketEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/tiket/tiket/tiket-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data : data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = Tiket.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.messages)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'TicketViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/tiket/tiket-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              vm.listOtselected=[];
          },
          locals:{
            id:id
          }
      });
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('app.tiket.tiket')
    .controller('TiketInputController', TiketInputController);

  TiketInputController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'filterFilter',
    'config'
  ];
  /** @ngInject */
  function TiketInputController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    filterFilter,
    config
  ) {
    var vm = this;
    var Tiket = AppAPI.Tiket();
    vm.loadTiketDepartmentService = loadTiketDepartmentService;
    
    loadTiketDepartment();

    function loadTiketDepartment() {
          var response=Tiket.query({action:'viewTiketDepartment'});
          response.$promise.then(fetchTiketDepartment);
          response.$promise.catch(errorFetchTiketDepartment);
    }
    
    function fetchTiketDepartment(data) {
          vm.targetDepartmentList=data;
    }

    function errorFetchTiketDepartment() {
          vm.targetDepartmentList=[];
    }

    function loadTiketDepartmentService(id) {
          var response=Tiket.query({action:'viewTiketDepartmentService',tiket_department_id:id});
          response.$promise.then(fetchTiketDepartmentService);
          response.$promise.catch(errorFetchTiketDepartmentService);
    }

    function fetchTiketDepartmentService(data) {
          vm.targetDepartmentServiceList=data;
    }

    function errorFetchTiketDepartmentService() {
          vm.targetDepartmentServiceList=[];
    }

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(Tiket); 
    vm.dialogClose = dialogClose;
    vm.saveData=saveData;
    vm.priority = [
      {'value':'low','name':'Low','class':'priority-low'},
      {'value':'middle','name':'Middle','class':'priority-middle'},
      {'value':'high','name':'High','class':'priority-high'}
    ];
    
    vm.tinymceOptions = {
      height: 250,
      theme: 'modern',
      plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
      toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
      templates: [
        { title: 'template 1', content: 'Template 1' },
        { title: 'template 2', content: 'Template 2' }
      ],
    };
    activate();

    function activate() {
      vm.selected = []; 
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, Tiket);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine(); 
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.messages)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();

(function() {
    'use strict';
    angular
      .module('app.tiket.tiket')
      .controller('TiketEditController', TiketEditController);
  
    TiketEditController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'data',
      'config',
      'FileUploader'
    ];
    /** @ngInject */
    function TiketEditController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      data,
      config,
      FileUploader
    ) {
      var vm = this;
      var Tiket = AppAPI.Tiket();

      vm.loadTiketDepartmentService = loadTiketDepartmentService;
      vm.Form = Form;
      vm.info = data;
      vm.saveData = updateData;
      vm.dialogClose = dialogClose;
      vm.company=$localStorage.empsite;
      vm.tinymceOptions = {
        height: 250,
        theme: 'modern',
        plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
        toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
        templates: [
          { title: 'template 1', content: 'Template 1' },
          { title: 'template 2', content: 'Template 2' }
        ],
      };
      vm.priority = [
        {'value':'low','name':'Low','class':'priority-low'},
        {'value':'middle','name':'Middle','class':'priority-middle'},
        {'value':'high','name':'High','class':'priority-high'}
      ];

      activate();
      
      function activate() 
      {
        Form.initialForm();
        Form.setObject(Tiket);

        vm.Form.objForm.id=data.id;
        vm.Form.objForm.title=data.title;
        vm.Form.objForm.description=data.description;
        vm.Form.objForm.deliverable=data.deliverable;
        vm.Form.objForm.target_department_id=data.target_department_id;
        vm.Form.objForm.service_id=data.service_id;
        vm.Form.objForm.priority=data.priority;
        vm.Form.objForm.submit_date=new Date(data.submit_date);
        vm.Form.objForm.target_finish=new Date(data.target_finish);
      }
      
      loadTiketDepartment();
      loadTiketDepartmentService(data.target_department_id);

      function loadTiketDepartment() {
        var response=Tiket.query({action:'viewTiketDepartment'});
        response.$promise.then(fetchTiketDepartment);
        response.$promise.catch(errorFetchTiketDepartment);
      }

      function fetchTiketDepartment(data) {
        vm.targetDepartmentList=data;
      }

      function errorFetchTiketDepartment() {
        vm.targetDepartmentList=[];
      }
      
      function loadTiketDepartmentService(id) {
            var response=Tiket.query({action:'viewTiketDepartmentService',tiket_department_id:id});
            response.$promise.then(fetchTiketDepartmentService);
            response.$promise.catch(errorFetchTiketDepartmentService);
      }

      function fetchTiketDepartmentService(data) {
            vm.targetDepartmentServiceList=data;
      }

      function errorFetchTiketDepartmentService() {
            vm.targetDepartmentServiceList=[];
      }
      
      function updateData(ev, frm) 
      {
        angular.element.blockUI();
        var response = Form.saveData('update', frm, Tiket);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();

            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.messages)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }
    }
  })();
  
(function ()
{
    'use strict';

    angular
        .module('app.ta.passwordecheckin', ['app.ta.passwordecheckin.input-password-echeckin'])
        .config(config);

         config.$inject=['$stateProvider'];

    /** @ngInject */
   /** @ngInject */
   function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.ta_passwordecheckin', {
                url    : '/ta/passwordecheckin',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/ta/passwordecheckin/passwordecheckin.html',
                        controller : 'PasswordecheckinController as vm'
                    }
                }
            });

       
        

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ta.passwordecheckin')
        .controller('PasswordecheckinController', PasswordecheckinController);


    PasswordecheckinController.$inject=['$state','$localStorage','$http','$scope','$document','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function PasswordecheckinController($state,$localStorage,$http,$scope,$document,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.editData=editData; 
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listModulSelected=[];   
        var EcheckinPass=AppAPI.EcheckinPass();  

        

        vm.Breadhome="app.ta";
        vm.Breadlist=[ 
                    {link:'#',name:'TA / ',active:'0'}
                    ]; 
         


        

        loadData(1);
        ////////// 

        function loadData(pageno){
           vm.DataTable.loadData(EcheckinPass,pageno,{action:'viewdata'});
           // console.log('test');
        }

         

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 

        function editData(id){ 
          $state.go('app.ta_passwordecheckin_edit-password-echeckin',{id:id});
          // console.log('test');
        }
  

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ta.helpdesk', [])
        .config(config);

         config.$inject=['$stateProvider'];

    /** @ngInject */
   /** @ngInject */
   function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.ta_helpdesk', {
                url    : '/ta/helpdesk',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/ta/helpdesk/index.html',
                        controller : 'HelpdeskListController as vm'
                    }
                }
            });

       
        

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ta.helpdesk')
        .controller('HelpdeskListController', HelpdeskListController);


    HelpdeskListController.$inject=['$state','$localStorage','$location','$http' ,'$scope','$document','$window','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function HelpdeskListController($state,$localStorage,$location,$http ,$scope,$document,$window,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {
        var vm = this;
        var helpdesk=AppAPI.Helpdesk();

        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listModulSelected=[];
        vm.delete = deleteData;
        vm.edit = editData;
        

        

        vm.Breadhome="app.ta";
        vm.Breadlist=[
            {
                link:'#',
                name:'TA / ',
                active:'0'
            }
        ];

        loadData(1);
        //////////

        function closeModal()
        {
            $mdDialog.hide();
        }

        
        function loadData(pageno){
           vm.DataTable.loadData(helpdesk,pageno,{action:'viewdata'});
        }



        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

        function checkAll() {
            vm.listModulSelected=angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listModulSelected=[];
        }

        function deleteData(ev,id)
        {
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=helpdesk.delete({action:'delete',data:id});
                    vm.DataTable.searchParam = '';
                    loadData(1);
                }, function() {
                });
            });
        }

        function editData(ev,data)
        {
            $mdDialog.show({
                controller         : 'EditHelpdeskController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ta/helpdesk/edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  data:data
                }
            });


        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.ta.helpdesk')
        .controller('EditHelpdeskController', EditHelpdeskController);

    EditHelpdeskController.$inject = ['$localStorage','$timeout','$mdDialog','Form','AppAPI','config','FileUploader','data'];

    /* @ngInject */
    function EditHelpdeskController($localStorage,$timeout,$mdDialog,Form,AppAPI,config,FileUploader,data) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        var Helpdesk=AppAPI.Helpdesk();

        // set constructor form
        Form.initialForm();
        Form.setObject(Helpdesk);
        vm.Form = Form;
        vm.url = false;
        vm.closeModal = closeModal;
        vm.Form.objForm.data = data

        vm.notif = {
          success: false,
          error: false
        }
        vm.messageTheme='green';
        if ( data.image !== "0" ) {
          vm.url = 'api/document/'+data.image;
        } else {
          vm.url = false;
        }

        if ( vm.Form.objForm.data.status == 'Open' ) {
            vm.Form.objForm.data.status = 0;
        } else if ( vm.Form.objForm.data.status == 'Pending' ) {
            vm.Form.objForm.data.status = 1;
        } else if ( vm.Form.objForm.data.status == 'On Progress' ) {
            vm.Form.objForm.data.status = 2;
        } else if ( vm.Form.objForm.data.status == 'Close' ) {
            vm.Form.objForm.data.status = 3;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formControl) {
          angular.element.blockUI();
          // var promise = Form.updateData('update',formControl,Helpdesk,formControl.id);
          var promise= Form.saveData('update',formControl, Helpdesk);
            promise.then(function(response){
                if ( response.error ) {
                  vm.notif.error = response.pesan;
                  vm.notif.success = false;
                  vm.messageTheme='pink';
                } else {
                  vm.notif.error = false;
                  vm.notif.success = response.pesan;
                  vm.messageTheme='green';
                }
              formControl.$setPristine();
              $timeout(function() {
                vm.notif.error=false; 
                vm.notif.success=false;
                closeModal(); 
              }, 3000);
              angular.element.unblockUI();
            })
            .catch(function (response) {
              vm.notif.error = 'Internal server error'
              vm.notif.success = false;
              vm.messageTheme='pink';
              angular.element.unblockUI();
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent()
            ).then(function(){
                closeModal();
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.ta.handover', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.handover_gw', {
            url: '/handover_gw',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ta/handover-gw/handover-gw.html',
                    controller: 'HandoverGwController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.ta.handover')
        .controller('TrainingGwRescheduleController', Controller);

    Controller.$inject = ['$state', '$mdDialog', 'AppAPI', 'reffData', 'Form'];
    /** @ngInject */
    function Controller($state, $mdDialog, AppAPI, reffData, Form) {
        var vm = this;
        var endpoint = AppAPI.HandoverGw();
        vm.hide = hide;
        vm.submit = submit;

        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(endpoint);

        // set form to controller
        vm.Form = Form;

        vm.tempDate = reffData.reschedule
            ? new Date(reffData.reschedule)
            : new Date();

        function submit(form) {
            var dt = angular.copy(vm.tempDate);
            vm.Form.objForm.taCompletionId = reffData.id;
            vm.Form.objForm.rescheduleDate = moment(dt).format('YYYY-MM-DD');
            var request = Form.saveData('rescheduleTraining', form, endpoint);
            request.then(function(response) {
                console.log(response);
            });
            request.catch(function(error) {
                console.log(error);
            });
        }

        function hide() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.ta.handover")
        .controller("TrainingGwHandoverController", Controller);

    Controller.$inject = [
        "$state",
        "$mdDialog",
        "AppAPI",
        "reffData",
        "isSingle",
        "Form",
        "$timeout",
    ];
    /** @ngInject */
    function Controller(
        $state,
        $mdDialog,
        AppAPI,
        reffData,
        isSingle,
        Form,
        $timeout
    ) {
        var vm = this;
        var endpoint = AppAPI.HandoverGw();
        vm.hide = hide;
        vm.submit = submit;
        vm.querySearch = querySearch;
        vm.searchText = "";
        vm.getItemText = getItemText;
        vm.selectedItemChange = selectedItemChange;
        vm.tempDate = new Date();
        vm.employee = "";
        vm.overrideJoinDate = 0;

        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(endpoint);

        // set form to controller
        vm.Form = Form;

        function submit(form) {
            var dt = angular.copy(vm.tempDate);
            vm.Form.objForm.hand_over_to = vm.employee;
            vm.Form.objForm.hand_over_date = moment(dt).format("YYYY-MM-DD");
            vm.Form.objForm.override_join_date = vm.overrideJoinDate;

            if (isSingle) {
                vm.Form.objForm.employee = [
                    {
                        id: reffData.id,
                    },
                ];
            } else {
                vm.Form.objForm.employee = reffData;
            }

            var request = Form.saveData("setHandover", form, endpoint);
            request.then(function (response) {
                $timeout(function () {
                    hide();
                }, 2000);
            });
            request.catch(function (error) {
                console.log(error);
            });
        }

        function hide() {
            $mdDialog.hide();
        }

        function selectedItemChange(item) {
            if (item) {
                console.log("item", item);
                console.log("employee", vm.employee);
            }
        }

        function querySearch(search) {
            var request = endpoint.query({
                action: "getDataEmployee",
                search: search,
            });
            return request.$promise.then(function (response) {
                return response;
            });
        }

        function getItemText(item) {
            if (item) {
                return item.nik + " - " + item.name;
            }
            return "";
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.ta.handover')
        .controller('HandoverGwController', HandoverGwController);

    HandoverGwController.$inject = [
        '$state',
        '$mdDialog',
        'AppAPI',
        'DataService',
        'Auth'
    ];
    /** @ngInject */
    function HandoverGwController($state, $mdDialog, AppAPI, DataService, Auth) {
        var vm = this;
        var endpoint = AppAPI.HandoverGw();
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.trainingDate = new Date();
        vm.loadData = loadData;
        vm.isConfirm = '0';
        vm.isTraining = 'ALL';
        vm.status = 'ALL';
        vm.isConfirmList = [
            { id: '0', description: 'Belum Handover' },
            { id: '1', description: 'Sudah Handover' }
        ];
        vm.isTrainingList = [
            { id: 'ALL', description: 'ALL' },
            { id: '0', description: 'Belum Training' },
            { id: '1', description: 'Sudah Training' }
        ];

        vm.statusList = [
            { id: 'ALL', description: 'ALL' },
            { id: 'hadir', description: 'Hadir' },
            { id: 'tidak_hadir', description: 'Tidak Hadir' },
            { id: 'menunggu', description: 'Menunggu' }
        ];

        vm.showForm = showForm;
        vm.handover = handover;
        vm.removeHandover = removeHandover;
        vm.selected = [];
        vm.toggle = toggle;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.exists = exists;
        vm.DataTables.list = [];

        activate();

        function activate() {
            loadData(1);
        }

        function loadData(pageNo) {
            var trainingDt = angular.copy(vm.trainingDate);
            var resp = vm.DataTables.loadData(endpoint, pageNo, {
                action: 'viewData',
                training_date: moment(trainingDt).format('YYYY-MM-DD'),
                is_confirm: vm.isConfirm,
                is_training: vm.isTraining,
                status: vm.status
            });
            resp.then(function(res) {
                console.log(res);
            });
            resp.catch(function(err) {
                console.log(err);
            });
        }

        function showForm(ev, item) {
            $mdDialog
                .show({
                    controller: 'TrainingGwRescheduleController as vm',
                    templateUrl: 'app/main/ta/handover-gw/reschedule.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function handover(ev, item, isSingle) {
            $mdDialog
                .show({
                    controller: 'TrainingGwHandoverController as vm',
                    templateUrl: 'app/main/ta/handover-gw/handover.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item,
                        isSingle: isSingle
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function removeHandover(ev, item) {
            var response = Auth.setToken();
            response.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Remove Handover')
                    .textContent(
                        'Are you sure want to remove ' +
                            item.nik +
                            ' - ' +
                            item.name +
                            ' from this handover ?'
                    )
                    .ariaLabel('handover')
                    .targetEvent(ev)
                    .ok('Yes')
                    .cancel('No');

                $mdDialog.show(confirm).then(function() {
                    var request = endpoint.save({
                        action: 'removeHandover',
                        new_emp_handover_id: item.new_emp_handover_id,
                        ta_completion_id: item.id
                    });

                    request.$promise.then(function(res) {
                        console.log(res);
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Success')
                                .textContent(res.pesan)
                                .ariaLabel('Alert Dialog Demo')
                                .ok('OK')
                                .targetEvent(ev)
                        );
                        loadData(1);
                    });
                    request.$promise.catch(function(err) {
                        console.log(err);
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Failed')
                                .textContent(err.pesan)
                                .ariaLabel('Alert Dialog Demo')
                                .ok('OK')
                                .targetEvent(ev)
                        );
                        loadData(1);
                    });
                });
            });
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return (
                vm.selected.length !== 0 &&
                vm.selected.length !== vm.DataTables.list.length
            );
        }

        function isChecked() {
            return vm.selected.length === vm.DataTables.list.length;
        }

        function toggleAll() {
            if (vm.selected.length === vm.DataTables.list.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.DataTables.list.slice(0);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.ta.echeckin-list')
        .controller('UpdateJDController', UpdateJDController);

    UpdateJDController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','config','FileUploader','id'];

    /* @ngInject */
    function UpdateJDController($localStorage,$mdDialog,Form,AppAPI,config,FileUploader,id) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Echeckinlist = AppAPI.Echeckinlist();

        // set constructor form
        Form.setObject(Echeckinlist);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        var response=vm.Form.objForm.$get({action:'viewdetail',id:id.noktp});
        response.then(setData);

        function setData(data)
        {
            if(!data.dateJoin) {
                vm.dateJoin = new Date();
            } else {
              vm.dateJoin = new Date(data.dateJoin);
            }
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController) {
          vm.Form.objForm.dateJoin = formController.dateJoin.$viewValue;
          vm.Form.objForm.userID = id.user_id;
            // var promise = Form.updateData('updatejoindate', formController, Echeckinlist, id.noktp, 'viewdetail');
          var promise = Form.saveData('updatejoindate', formController, Echeckinlist);
          promise.then(function(data){
              showDialog(ev,data);
          });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent()
            ).then(function(){
                closeModal();
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.ta.echeckin-list')
    .controller('EcheckinListController', EcheckinListController);

  EcheckinListController.$inject = [
    '$state',
    '$localStorage',
    '$location',
    '$http',
    '$scope',
    '$document',
    '$window',
    'config',
    '$log',
    '$mdDialog',
    'AppAPI',
    'Auth',
    'DataService',
    'FileUploader'
  ];
  /** @ngInject */
  function EcheckinListController(
    $state,
    $localStorage,
    $location,
    $http,
    $scope,
    $document,
    $window,
    config,
    $log,
    $mdDialog,
    AppAPI,
    Auth,
    DataService,
    FileUploader
  ) {
    var vm = this;
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.listModulSelected = [];
    vm.ExportToExcel = ExportToExcel;
    vm.ExportFromViewToExcel = ExportFromViewToExcel;
    var Echeckinlist = AppAPI.Echeckinlist();
    vm.CompletionData = CompletionData;
    vm.JoinDate = JoinDate;
    vm.closeModal = closeModal;
    vm.deleteData = deleteData;
    vm.viewTax = viewTax;
    vm.viewBank = viewBank;
    vm.viewTraining = viewTraining;
    vm.viewLanguage = viewLanguage;
    vm.viewEducation = viewEducation;
    vm.viewDependent = viewDependent;
    vm.viewDependent = viewDependent;
    vm.viewEmergency = viewEmergency;
    vm.viewExperiences = viewExperiences;
    vm.viewCertificate = viewCertificate;
    vm.viewKtp = viewKtp;
    vm.viewPhoto = viewPhoto;
    vm.viewJamsostek = viewJamsostek;
    vm.disabledSubmitTa = disabledSubmitTa;
    vm.group = $localStorage.group;
    vm.updateSubmitTA = updateSubmitTA;
    vm.updateSubmitPA = updateSubmitPA;


    vm.Breadhome = 'app.ta';
    vm.Breadlist = [
      {
        link: '#',
        name: 'TA / ',
        active: '0'
      }
    ];

    loadData(1);
    //////////

    function closeModal() {
      $mdDialog.hide();
    }

    function CompletionData(ev, id) {
      $mdDialog.show({
        controller: 'CompletionController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/completion-data.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          id: id
        }
      });
    }

    function JoinDate(ev, id) {
      $mdDialog.show({
        controller: 'UpdateJDController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/join-date.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          id: id
        }
      });
    }

    function viewEducation(ev, id) {
      $mdDialog.show({
        controller: 'EducationDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/education-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewExperiences(ev, id) {
      $mdDialog.show({
        controller: 'ExperiencesDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/experience-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewDependent(ev, id) {
      $mdDialog.show({
        controller: 'DependentDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/dependent-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewBank(ev, id) {
      $mdDialog.show({
        controller: 'BankDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/bank-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewTax(ev, id) {
      $mdDialog.show({
        controller: 'TaxDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/tax-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewEmergency(ev, id) {
      $mdDialog.show({
        controller: 'EmergencyDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/emergency-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewLanguage(ev, id) {
      $mdDialog.show({
        controller: 'LanguageDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/language-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewTraining(ev, id) {
      $mdDialog.show({
        controller: 'TrainingDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/training-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewCertificate(ev, id) {
      $mdDialog.show({
        controller: 'CertificateDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/certificate-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewNpwp(ev, id) {
      $mdDialog.show({
        controller: 'ViewNpwpController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/view-npwp.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewJamsostek(ev, id) {
      $mdDialog.show({
        controller: 'ViewJamsostekController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/view-jamsostek.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewPhoto(ev, id) {
      $mdDialog.show({
        controller: 'ViewPhotoController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/view-photo.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function viewKtp(ev, id) {
      $mdDialog.show({
        controller: 'ViewKtpController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ta/echeckin-list/details/view-ktp.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          id: id
        }
      });
    }

    function loadData(pageno) {
      vm.DataTable.loadData(Echeckinlist, pageno, { action: 'viewdata' });
      // console.log(vm.DataTable);
    }

    function disabledSubmitTa(data) {
      // console.log(data);
      if (data.submit_ta == 1) {
        return false;
      }
      if (
        data.bank > 0 &&
        data.dependents > 0 &&
        data.education > 0 &&
        data.experiences > 0 &&
        data.emergency > 0 &&
        data.ijazah > 0 &&
        data.jamsostek > 0 &&
        data.otherdocument > 0 &&
        data.tax != 0
      ) {
        return false;
      } else {
        return true;
      }
    }

    function updateSubmitTA(ev, id) {
      // console.log(id);
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to submit this data ?')
          .textContent('Data your selected will be submitted.')
          .ariaLabel('submit dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();
            var response = Echeckinlist.save({
              action: 'updateSubmitTA',
              id: id
            });
            response.$promise.then(function (data) {
              angular.element.unblockUI();
              loadData();
              closeModal();
              showDialog();
            });
            response.$promise.catch(function (data) {
              angular.element.unblockUI();
              loadData();
              closeModal();
              showDialog();
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function updateSubmitPA(ev, id) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to submit this data ?')
          .textContent('Data your selected will be submitted.')
          .ariaLabel('submit dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();
            var response = Echeckinlist.save({
              action: 'updateSubmitPA',
              id: id
            });
            response.$promise.then(function (data) {
              angular.element.unblockUI();
              loadData();
              closeModal();
              showDialog();
            });
            response.$promise.catch(function(){
              angular.element.unblockUI();
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialog(ev) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title("Success Submit Data")
          .textContent("Congratulations, Data Has Been Submited")
          .ariaLabel("Submtted")
          .ok('OK')
          .targetEvent()
      ).then(function () {
        closeModal();
      });
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
      //console.log(vm.listModulSelected);
    }

    function checkAll() {
      vm.listModulSelected = angular.copy(vm.list);
    }

    function unCheckAll() {
      vm.listModulSelected = [];
    }

    function ExportToExcel(id) {
      var token = Auth.setTokenPromise();
      token.then(
        function (data) {
          var protocol = $location.protocol();
          var host = $location.host();
          $window.open(
            protocol + '://' + host + config.port + config.api + 'api/echeckinlist/exportexcel/' + id + '/' + data.token,
            '_blank'
          );
        },
        function () {
          $window.alert('gagal load token');
        }
      );
    }

    function ExportFromViewToExcel() {
      var token = Auth.setTokenPromise();
      token.then(
        function (data) {
          var offsite = vm.DataTable.jumDataPerPage;
          var search = vm.DataTable.searchParam;
          var protocol = $location.protocol();
          var host = $location.host();
          $window.open(
            protocol + '://' + host + config.port + config.api + 'api/echeckinlist/exportexcelfromview/' + offsite + '/' + search + '/' + data.token,
            '_blank'
          );
        },
        function () {
          $window.alert('gagal load token');
        }
      );
    }

    function deleteData(ev, emp_id) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();
            var response = Echeckinlist.delete({ action: 'delete', data: emp_id });
            vm.DataTable.searchParam = '';
            loadData(1);
          },
          function () { }
        );
      });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.ta.echeckin-list').controller('CompletionController', CompletionController);

    CompletionController.$inject = [
        '$localStorage',
        'id',
        '$mdDialog',
        'Form',
        'AppAPI',
        '$log',
        'FileUploader',
        'config',
        '$scope'
    ];

    /* @ngInject */
    function CompletionController(
        $localStorage,
        id,
        $mdDialog,
        Form,
        AppAPI,
        $log,
        FileUploader,
        config,
        $scope
    ) {
        var vm = this;
        // initial form
        Form.initialForm();

        var Echeckinlist = AppAPI.Echeckinlist();
        var Attendancereport = AppAPI.Attendancereport();

        // set constructor form
        Form.setObject(Echeckinlist);
        vm.isMpnNumber = id.isMpnNumber == true ? true : false;
        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveDataTA = saveDataTA;
        vm.saveDataService = saveDataService;
        vm.getMonitoringOfTask = getMonitoringOfTask;
        vm.applicantRange = [];
        vm.completionTA = id.completion_ta;
        vm.completionPA = id.completion_pa;
        vm.Form.objForm.user_id = id.user_id;
        vm.company = $localStorage.empsite == '' ? 'KS' : $localStorage.empsite;
        vm.personalSubarea = [];
        vm.personalOfficer = [];
        vm.group = $localStorage.group;
        vm.empGroup = [];
        vm.tempData = [];
        vm.mpnNumberInc='';

        console.log(id); 

        vm.reason = ['Hiring', 'Rehiring', 'Transfer Non SAP', 'Hiring For Recruitment'];
        vm.contractStatus = ['Contract', 'Permanent'];
        vm.timeMgmt = [{
                view: '1 - Time evaluation of actual times',
                values: 1
            },
            {
                view: '2 - PDC time evaluation',
                values: 2
            },
            {
                view: '7 - Time evaluation without payroll integration',
                values: 7
            },
            {
                view: '8 - External services',
                values: 8
            },
            {
                view: '9 - Time evaluation of planned times',
                values: 9
            },
            {
                view: '0 - No time evaluation',
                values: 0
            }
        ];

        vm.bloods = ['A', 'AB', 'B', 'O'];

        vm.workSchedule = [{
                view: '5+2 Schedule',
                values: '52'
            },
            {
                view: '6+1 Schedule',
                values: '61'
            } 
        ];

        vm.listDays = [{
                view: 'Sunday',
                values: 'Sun'
            },
            {
                view: 'Monday',
                values: 'Mon'
            },
            {
                view: 'Tuesday',
                values: 'Tue'
            },
            {
                view: 'Wednesday',
                values: 'Wed'
            },
            {
                view: 'Thursday',
                values: 'Thu'
            },
            {
                view: 'Friday',
                values: 'Fri'
            },
            {
                view: 'Saturday',
                values: 'Sat'
            }   

        ];

        detailCompletion();

        //////////////// 

        function detailCompletion() {
            var response = Echeckinlist.query({
                action: 'viewCompletionDetail',
                empId: id.user_id
            });
            response.$promise.then(function (data) {
                vm.tempData = data;
                fillData(data);
            });
        }

        function activate() {
            getApplicantRange();
            getPersonalSubarea();
            getPersonalOfficer();
            loadDataBU();

            
            // getMpnNumber();
        }

        function loadDataBU() {
            var response = Attendancereport.query({
                action: 'viewBu'
            });
            response.$promise.then(function (data) {
                vm.empGroup = data;
            });
            response.$promise.catch(function (data) {
                vm.empGroup = [];
            });
        }

        function saveDataTA(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.flagTA = id.completion_ta;
            vm.Form.objForm.candidateName = id.name;
            vm.Form.objForm.candidateBirthDay = id.date_of_birth;
            var promise = Form.saveData('savecompletion', formController, Echeckinlist);
            promise.then(function (data) {
                angular.element.unblockUI();
            });

            promise.catch(function (data) {
                angular.element.unblockUI();
            });
        }

        function fillData(data) {
            // console.log(data);
            if (data.length != 0) {
                vm.group_ta = data[0].group_ta;
                vm.group_pa = data[0].group_pa;

                // console.log(vm.group_ta+' / '+vm.group_pa);

                if (data[0].group_ta == true) {
                    vm.Form.objForm.empGroup = data[0].employee_group;
                    vm.Form.objForm.applicantRange = data[0].applicant_range;
                    vm.Form.objForm.personalSubarea = data[0].personel_subarea;
                    vm.Form.objForm.personalOfficer = data[0].personel_officer;
                    vm.Form.objForm.workSchedule = data[0].work_schedule_rule;
                    vm.Form.objForm.priority = data[0].priority;
                    vm.Form.objForm.bloodType = data[0].bloodType;
                    vm.Form.objForm.vacancyID = data[0].vacancyID;
                    vm.Form.objForm.mpnNumber=data[0].mpnNumber;
                    vm.Form.objForm.contract = data[0].contract_status;

                    vm.Form.objForm.join_date= new Date(data[0].join_date);
                    if (data[0].join_date == null) {
                        vm.Form.objForm.join_date = null;
                    }


                    vm.Form.objForm.startContract = new Date(data[0].start_contract);
                    if (data[0].start_contract == null) {
                        vm.Form.objForm.startContract = null;
                    }

                    vm.Form.objForm.endContract = new Date(data[0].end_contract);
                    if (data[0].start_contract == null) {
                        vm.Form.objForm.endContract = null;
                    }

                } else { 

                    vm.Form.objForm.workSchedule = data[0].work_schedule_rule;
                    vm.Form.objForm.timeMgmt = data[0].time_mgt_status;
                    vm.Form.objForm.monitoring = data[0].monitoring_of_task;
                    vm.Form.objForm.reason = data[0].reason_for_action;
                    vm.Form.objForm.directreport = data[0].directreport;
                    vm.Form.objForm.isHalfday = data[0].isHalfday;
                    vm.Form.objForm.halfDayName =data[0].halfDayName;
                    vm.Form.objForm.offDayName = data[0].offDayname
                }

                getMpnNumber(data[0].mpnNumber);
                getWorkSchedule(data[0].subArea);
                activate();
            }
        }

        function saveDataService(ev, formController) {
           
            vm.Form.objForm.flagPA = id.completion_pa;
            angular.element.blockUI();
            var promise = Form.saveData('saveCompletionService', formController, Echeckinlist);
            promise.then(function (data) {
                formController.$setPristine();
                angular.element.unblockUI();
            });

            promise.catch(function (data) {
                formController.$setPristine();
                angular.element.unblockUI();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        

        function objSize(obj) {
            var size = 0,
                key;
            for (key in obj) {
                if (obj.hasOwnProperty(key)) size++;
            }
            return size;
        }

        $scope.$watch('vm.Form.objForm.contract', function (newValue, oldValue) {
            if (newValue == 'Permanent') {
                var time = new Date('9999-12-31');
                vm.Form.objForm.endContract =
                    time.getFullYear() + '-' + ('0' + time.getMonth()).slice(-2) + '-' + time.getDate();
                vm.Form.objForm.monitoring =
                    time.getFullYear() + '-' + ('0' + time.getMonth()).slice(-2) + '-' + time.getDate();
            }
        });

        function getMonitoringOfTask(time) {
            var subTwoMonth = moment(time).subtract(2, 'months');
            vm.Form.objForm.monitoring =
                subTwoMonth.format('YYYY') +
                '-' +
                subTwoMonth.format('MM') +
                '-' +
                subTwoMonth.format('DD');
        }

        function getApplicantRange() {
            var response = Echeckinlist.query({
                action: 'getApplicantRange'
            });
            response.$promise.then(function (data) {
                vm.applicantRange = data;
            });
            response.$promise.catch(function (data) {
                vm.applicantRange = [];
            });
        }

        function getPersonalSubarea() {
            var response = Echeckinlist.query({
                action: 'getPersonalSubarea',
                companyId: vm.company
            });
            response.$promise.then(function (data) {
                vm.personalSubarea = data;
                // console.log(vm.personalSubarea);
            });
            response.$promise.catch(function () {
                vm.personalSubarea = [];
            });
        }

        function getPersonalOfficer() {
            var response = Echeckinlist.query({
                action: 'getPersonalOfficer',
                companyId: vm.company
            });
            response.$promise.then(function (data) {
                vm.personalOfficer = data;
                // console.log(vm.personalOfficer);
            });
            response.$promise.catch(function () {
                vm.personalOfficer = [];
            });
        }

        function getMpnNumber(mpnNumber) {
            var response = Echeckinlist.query({
                action: 'getMpnNumber',
                mpnNumber:mpnNumber
            });
            response.$promise.then(function (data) {
                vm.mpnNumber = data;
                // console.log(vm.mpnNumber);
            });
            response.$promise.catch(function () {
                vm.mpnNumber = [];
            });
        }

         function getWorkSchedule(subArea) {
            var response = Echeckinlist.query({
                action: 'getWorkSchedule',
                sub_area:subArea
            });
            response.$promise.then(function (data) {
                vm.workSchedule = data;
                // console.log(vm.mpnNumber);
            });
            response.$promise.catch(function () {
                vm.workSchedule = [];
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.sfa.sfa_user', [ ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.sfa_user', {
        url: '/sfa/sfa-user',
        views: {
          'content@app': {
            templateUrl: 'app/main/sfa/sfa-user/sfa-user.html',
            controller: 'SfaUserController as vm'
          }
        }
      });
  }

})();
(function () {
  'use strict';

  angular
    .module('app.sfa.sfa_user')
    .controller('SfaUserController', SfaUserController);

  SfaUserController.$inject = ['$state', '$localStorage', '$http', '$scope', 'config', '$log', '$mdDialog', 'Auth', 'AppAPI','DataService'];
    /** @ngInject */
  function SfaUserController($state, $localStorage, $http, $scope, config, $log, $mdDialog, Auth, AppAPI, DataService) {
    var vm = this;
    var UserSFA = AppAPI.UserSFA();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    vm.search = "";

    vm.listUser = [];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.listModulSelected = [];
    vm.editUser = editUser;
    vm.deleteUser = deleteUser;

    loadData(1);

    function loadData(pageno) {
      var resp = vm.DataTable.loadData(UserSFA, pageno, { action: 'viewdata'});
      resp.then(processInfo);
      resp.catch(errorProcessInfo);
    }

    function processInfo(data) {
      vm.listUser = data.list;
    }

    function errorProcessInfo() {
      vm.listUser = [];
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listModulSelected = angular.copy(vm.listUser);
    }

    function unCheckAll() {
      vm.listModulSelected = [];
    }

    function editUser(id) {
      $state.go('app.edit_sfa_user', { id: id });
    }

    function deleteUser(ev) {

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = UserSFA.delete({ action: 'delete', data: angular.toJson(vm.listModulSelected) });

          response.$promise.then(loadData(1));
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });


    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.sfa.form_sfa_user', [ ])
    .config(config);

  config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {

    // State 
    $stateProvider
      .state('app.input_sfa_user', {
        url: '/sfa/form-sfa-user/input',
        views: {
          'content@app': {
            templateUrl: 'app/main/sfa/form-sfa-user/form-sfa-user.html',
            controller: 'InputSfaController as vm'
          }
        }
      })

      .state('app.edit_sfa_user', {
        url: '/sfa/form-sfa-user/edit/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/sfa/form-sfa-user/form-sfa-user.html',
            controller: 'EditSfaController as vm'
          }
        }
      });



    // Translation
    // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');

  }
})();
(function () {
  'use strict';

  angular
    .module('app.sfa.form_sfa_user')
    .controller('InputSfaController', InputSfaController);


  InputSfaController.$inject = ['$localStorage', '$timeout', 'Form', 'AppAPI'];
  /** @ngInject */
  function InputSfaController($localStorage, $timeout, Form, AppAPI) {

    var vm = this;

    // initial form
    Form.initialForm();

    var UserSFA = AppAPI.UserSFA();

    // set constructor form
    Form.setObject(UserSFA);

    // set form to controller
    vm.Form = Form;


    vm.saveData = saveData;

    vm.clearMeesage = clearMeesage;

    function saveData(formController) {
      angular.element.blockUI();
      var response = Form.saveData('save', formController, UserSFA);

      response.then(function () {
        vm.messageTheme = 'blue';
        angular.element.unblockUI();
        formController.$setPristine();
        $timeout(function () {
          vm.Form.tampilPesan = false;
        }, 3000);

      });

      response.catch(function () {
        vm.messageTheme = 'pink';
        angular.element.unblockUI();

      });


    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }
  }
})();  

(function () {
  'use strict';

  angular
    .module('app.sfa.form_sfa_user')
    .controller('EditSfaController', EditSfaController);


  EditSfaController.$inject = ['$localStorage', '$stateParams', '$timeout', 'Form', 'AppAPI'];
  /** @ngInject */
  function EditSfaController($localStorage, $stateParams, $timeout, Form, AppAPI) {

    var vm = this;

    // initial form
    Form.initialForm();

    var UserSFA = AppAPI.UserSFA();

    // set constructor form
    Form.setObject(UserSFA);

    // set form to controller
    vm.Form = Form;


    vm.Form.objForm.$get({ action: 'viewdetail', id: $stateParams.id });

    vm.saveData = saveData;

    vm.clearMeesage = clearMeesage;

    function saveData(formController) {
      angular.element.blockUI();
      var response = Form.updateData('update', formController, UserSFA, $stateParams.id, 'viewdetail');

      response.then(function () {
        vm.messageTheme = 'blue';
        angular.element.unblockUI();
        formController.$setPristine();
        $timeout(function () {
          vm.Form.tampilPesan = false;
        }, 3000);

      });

      response.catch(function () {
        vm.messageTheme = 'pink';
        angular.element.unblockUI();

      });

    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }
  }
})();  

(function () {
    "use strict";

    angular.module("app.report.jic", [
        "app.report.jic.sk_demosi",
        "app.report.jic.sk_mutasi",
        "app.report.jic.sk_promosi_awal",
        "app.report.jic.sk_promosi_extend",
        "app.report.jic.sk_promosi_lanjutan",
        "app.report.jic.sk_promosi_lulus",
        "app.report.jic.sk_penugasan",
        "app.report.jic.sk_tetap"
    ]).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.report.jic', {
                url: '/jic',
                views: {
                    "content@app.report": {
                        templateUrl: "app/main/report/jic/jic.html",
                        controller: "JicReportController as vm"
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.jic')
        .controller('JicReportController', controller);

    controller.$inject = ['$rootScope'];

    /** @ngInject */
    function controller($rootScope) {
        var vm = this;
        $rootScope.printLayout = true;
    }
})();

(function() {
    'use strict';

    angular
        .module('app.report.correspondence', [
            'app.report.correspondence.company_certificate',
            'app.report.correspondence.visa',
            'app.report.correspondence.sk_promosi_extend',
            'app.report.correspondence.sk_promosi_lanjutan',
            'app.report.correspondence.sk_promosi_lulus',
            'app.report.correspondence.sk_promosi_tetap',
            'app.report.correspondence.sk_penugasan_single',
            'app.report.correspondence.sk_penugasan_multiple',
            'app.report.correspondence.pma'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.report.correspondence', {
            url: '/correspondence',
            views: {
                'content@app.report': {
                    templateUrl:
                        'app/main/report/correspondence/correspondence.html',
                    controller: 'CorrespondenceReportController as vm'
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.report.correspondence')
        .controller('CorrespondenceReportController', controller);

    controller.$inject = ['$scope', '$stateParams', '$window', '$document'];

    /** @ngInject */
    function controller($scope, $stateParams, $window, $document) {
        var vm = this;
        var head = angular.element(document.querySelector('#pageSizeSetting'));
        var body = angular
            .element(document)
            .find('body')
            .eq(0)
            .removeClass();
        vm.pageSize = 'A4';
        vm.pageOrientation = 'potrait';
        vm.print = printPage;

        activate();

        function activate() {
            body.addClass(vm.pageSize + ' ' + vm.pageOrientation);
        }

        function printPage() {
            $window.print();
        }

        $scope.$watch('vm.pageSize', function(newValue, oldValue) {
            if (newValue != oldValue) {
                body.removeClass(oldValue);
                body.addClass(newValue);
                head[0].innerHTML =
                    '@page { size : ' + newValue + ' ' + vm.pageOrientation + '}';
            }
        });

        $scope.$watch('vm.pageOrientation', function(newValue, oldValue) {
            if (newValue != oldValue) {
                body.removeClass(oldValue).addClass(newValue);
                head[0].innerHTML =
                    '@page { size : ' + vm.pageSize + ' ' + newValue + '}';
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.production-products.production')
        .controller('ProductionListController', ProductionListController);

    ProductionListController.$inject = [
        '$mdDialog',
        '$window',
        '$location',
        'AppAPI',
        'DataService',
        'config'
    ];

    function ProductionListController(
        $mdDialog,
        $window,
        $location,
        AppAPI,
        DataService,
        config
    ) {
        var vm = this;
        var endpoint = new AppAPI.Productions();

        vm.shiftList = [{
            id: "pagi",
            description: "Pagi"
        },
        {
            id: "siang",
            description: "Siang"
        },
        {
            id: "malam",
            description: "Malam"
        }
        ];

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        loadDataProduct();
        loadDataGedung();
        // viewData(1);

        vm.loadSector = loadSector;
        vm.loadLine = loadLine;
        vm.upload = upload;

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.downloadReport = downloadReport;
        vm.create = create;

        vm.delete = deleteProduction;
        vm.edit = editProduction;

        function loadDataProduct() {
            vm.listProduct = [];
            var response = endpoint.query({
                action: "getproduct"
            });
            response.$promise.then(function (data) {
                vm.listProduct = data;
            });
            response.$promise.catch(function (data) {
                vm.listProduct = [];
            });
        }

        function loadDataGedung() {
            vm.listGedung = [];
            var response = endpoint.query({
                action: "getgedung"
            });
            response.$promise.then(function (data) {
                vm.listGedung = data;
            });
            response.$promise.catch(function (data) {
                vm.listGedung = [];
            });
        }

        function loadSector(id) {
            vm.listSector = [];
            var response = endpoint.query({
                action: "getsector",
                id: id
            });
            response.$promise.then(function (data) {
                vm.listSector = data;
            });
            response.$promise.catch(function (data) {
                vm.listSector = [];
            });
        }

        function loadLine(id) {
            vm.listLine = [];
            var response = endpoint.query({
                action: "getline",
                id: id
            });
            response.$promise.then(function (data) {
                vm.listLine = data;
            });
            response.$promise.catch(function (data) {
                vm.listLine = [];
            });
        }

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewdata',
                date: vm.workingDate,
                line: vm.line,
                gedung: vm.gedung,
                sector: vm.sector,
                product: vm.product,
                shift: vm.shift
            });
        }

        function upload(ev) {
            $mdDialog.show({
                controller: 'ProductionUploadController',
                controllerAs: 'vm',
                templateUrl: 'app/main/production-products/production/production-create/production-upload.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {}
            }).then(function (data) { });
        }

        function downloadReport() {
            var date = convert(vm.workingDate);
            var protocol = $location.protocol();
            var host = $location.host();
            var gedung = 0;
            var sector = 0;
            var product = 0;

            if (vm.gedung != null) {
                gedung = vm.gedung;
            }

            if (vm.sector != null) {
                sector = vm.sector;
            }

            if (vm.product != null) {
                product = vm.product;
            }

            $window.open(protocol + '://' + host + config.api + 'api/productions/exportReport/' + date + '/' + gedung + '/' + sector + '/' + product + '/', '_blank');
        }

        function convert(str) {
            var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [date.getFullYear(), mnth, day].join("-");
        }

        function create(ev) {
            $mdDialog.show({
                controller: 'ProductionCreateController',
                controllerAs: 'vm',
                templateUrl: 'app/main/production-products/production/production-create/production-create-popup.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {}
            }).then(function () {
                viewData(1);
            });
        }

        function deleteProduction(ev, id) {

        }

        function editProduction(ev, data) {
            $mdDialog.show({
                controller: 'ProductionEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/production-products/production/production-create/production-create-popup.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data
                }
            }).then(function () {
                viewData(1);
            });
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.production-products.production')
    .controller('ProductionListNonproductionController', ProductionListNonproductionController);

  ProductionListNonproductionController.$inject = [
    '$mdDialog',
    '$window',
    '$location',
    '$timeout',
    'AppAPI',
    'config',
    'Form',
    'Auth'
  ];

  function ProductionListNonproductionController(
    $mdDialog,
    $window,
    $location,
    $timeout,
    AppAPI,
    config,
    Form,
    Auth
  ) {
    var vm = this;
    var endpoint = new AppAPI.Productions();
    vm.loadDataProduct = loadDataProduct;
    vm.create = create;
    vm.statEdit = false;
    vm.editMpp = editMpp
    vm.cancel = cancel;
    vm.hapus = hapus;
    vm.tambah = tambah;
    vm.myDate = new Date();
    vm.minDate = vm.myDate;

    Form.initialForm();
    Form.setObject(endpoint);
    vm.Form = Form;
    vm.listType = ['foreman', 'worker'];
    vm.listPosition = ['packaging', 'processing'];
    vm.listGender = ['Male', 'Female', 'Any'];
    vm.list = [];
    vm.Form.objForm.standard = [];

    loadDataProduct();

    vm.minDate = new Date(
      vm.myDate.getFullYear(),
      vm.myDate.getMonth(),
      vm.myDate.getDate()
    );

    function loadDataProduct() {
      vm.listProduct = [];
      var response = endpoint.query({
        action: "getproductnonproduction",
        date: vm.startDate
      });
      response.$promise.then(function (data) {
        vm.list = data;
        vm.Form.objForm.standard = [];
        for (var i = 0; i < vm.list.length; i++) {
          vm.Form.objForm.product_id = vm.list[i].product_id;
          var qty = Number(vm.list[i].qty);
          var itemObj = { "position_name": vm.list[i].position_name, "gender": vm.list[i].gender, "mpp_type": vm.list[i].mpp_type, "position_group": vm.list[i].position_group, "qty": qty };
          vm.Form.objForm.standard.push(itemObj);
        }

      });

      response.$promise.catch(function (data) {
        vm.Form.objForm.standard = [];
        vm.list = [];
      });
    }

    function create(ev, formInput) {
      angular.element.blockUI();
      var promiseAuth = Auth.setToken();

      promiseAuth.then(function () {
        var promise = Form.saveData('savemppstandard', formInput, endpoint);
        promise.then(function () {
          vm.messageTheme = 'blue';
          angular.element.unblockUI();
          formInput.$setPristine();
          loadDataProduct();
          vm.statEdit = false;

          $timeout(function () {
            vm.Form.tampilPesan = false;
          }, 3000);
        });

        promise.catch(function () {
          vm.messageTheme = 'pink';
          angular.element.unblockUI();
          loadDataProduct();
          vm.statEdit = false;

          $timeout(function () {
            vm.Form.tampilPesan = false;
          }, 3000);
        });
      });
    }

    function editMpp() {
      vm.statEdit = true;
    }

    function cancel() {
      vm.statEdit = false;
    }

    function tambah() {
      var itemObj = { "position_name": "", "gender": "", "mpp_type": "", "position_group": "", "qty": "" };
      vm.Form.objForm.standard.push(itemObj);
    }

    function hapus(itemIndex) {
      vm.Form.objForm.standard.splice(itemIndex, 1);
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('app.production-products.production')
    .controller('ProductionListNonproductionViewController', ProductionListNonproductionViewController);

  ProductionListNonproductionViewController.$inject = [
    '$mdDialog',
    '$window',
    '$location',
    '$timeout',
    "DataService",
    'AppAPI',
    'config',
    'Auth'
  ];

  function ProductionListNonproductionViewController(
    $mdDialog,
    $window,
    $location,
    $timeout,
    DataService,
    AppAPI,
    config,
    Auth
  ) {
    var vm = this;
    var endpoint = new AppAPI.Productions();
    vm.loadDataProduct = loadDataProduct;
    vm.hapus = hapus;
    vm.DataTable = new DataService();
    vm.listSelected = [];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.deleteMpp = deleteMpp;

    loadDataProduct();

    function loadDataProduct(pageno) {
      angular.element.blockUI();
      vm.DataTable.loadData(endpoint, pageno, {
        action: 'viewproductnonproduction'
      });
    }

    function hapus(itemIndex) {
      vm.Form.objForm.standard.splice(itemIndex, 1);
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listSelected = [];
      vm.listSelected = angular.copy(vm.DataTable.list);
    }

    function unCheckAll() {
      vm.listSelected = [];
    }

    function deleteMpp(ev) {
      var promiseAuth = Auth.setToken();

      promiseAuth.then(function () {

        var response = endpoint.delete({
          action: 'deletemppstandard',
          data: angular.toJson(vm.listSelected)
        });

        response.$promise.then(function (data) {

          var confirm = $mdDialog.confirm()
            .title('Success.!')
            .textContent(data.pesan)
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Close')

          $mdDialog.show(confirm).then(function () {
            loadDataProduct();
            $mdDialog.cancel();
          });

        });

      });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.upload-data', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.pms_upload_data', {
                url    : '/pms/upload-data',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/upload-data/upload-data.html',
                        controller : 'UploaddatapmsController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.pms.upload-data')
        .controller('UploaddatapmsController', UploaddatapmsController);

    UploaddatapmsController.$inject = ['$localStorage','FileUploader','config','Auth'];

    /* @ngInject */
    function UploaddatapmsController($localStorage,FileUploader,config,Auth) {
        var vm = this;
        vm.UploadKPINonPeopleStateSucces=false;
        vm.UploadKPINonPeopleStateError=false;

         vm.UploadKPIPeopleStateSucces=false;
        vm.UploadKPIPeopleStateError=false;

        vm.UploadKPITSTEStateSucces=false;
        vm.UploadKPITSTEStateError=false;

         vm.UploadKPIAdjustmentStateSucces=false;
        vm.UploadKPIAdjustmentStateError=false;

          vm.UploadKPIPaStateSucces=false;
        vm.UploadKPIPaStateError=false;

         vm.UploadKPIKaryawanStateSucces=false;
        vm.UploadKPIKaryawanStateError=false;

       var uploaderNonPeople= vm.FileUploaderNonPeople= new FileUploader({
        	url:config.api+'api/uploaddatapms',
        	removeAfterUpload:true,
        	alias:'kpinonpeople',
        	formData:[
               {
               	action:'uploadDataKPINonPeople'
               }
        	],
        	onAfterAddingAll:function(){
                vm.UploadKPINonPeopleStateSucces=false;
                vm.UploadKPINonPeopleStateError=false;
			 },
        	 headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        });


        var uploaderPeople= vm.FileUploaderPeople= new FileUploader({
        	url:config.api+'api/uploaddatapms',
        	removeAfterUpload:true,
        	alias:'kpipeople',
        	formData:[
               {
               	action:'uploadDataKPIPeople'
               }
        	],
        	onAfterAddingAll:function(){
                vm.UploadKPIPeopleStateSucces=false;
                vm.UploadKPIPeopleStateError=false;
			 },
        	 headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        });


         var uploaderTSTE= vm.FileUploaderTSTE= new FileUploader({
        	url:config.api+'api/uploaddatapms',
        	removeAfterUpload:true,
        	alias:'kpitste',
        	formData:[
               {
               	action:'uploadDataKPITSTE'
               }
        	],
        	onAfterAddingAll:function(){
                vm.UploadKPITSTEStateSucces=false;
                vm.UploadKPITSTEStateError=false;
			 },
        	 headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        });

          var uploaderAdjustment= vm.FileUploaderAdjustment= new FileUploader({
        	url:config.api+'api/uploaddatapms',
        	removeAfterUpload:true,
        	alias:'kpiadjustment',
        	formData:[
               {
               	action:'uploadDataKPIAdjustment'
               }
        	],
        	onAfterAddingAll:function(){
                vm.UploadKPIAdjustmentStateSucces=false;
                vm.UploadKPIAdjustmentStateError=false;
			 },
        	 headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        });

           var uploaderPa= vm.FileUploaderPa= new FileUploader({
          url:config.api+'api/uploaddatapms',
          removeAfterUpload:true,
          alias:'kpipa',
          formData:[
               {
                action:'uploadDataKPIPa'
               }
          ],
          onAfterAddingAll:function(){
                vm.UploadKPIPaStateSucces=false;
                vm.UploadKPIPaStateError=false;
       },
           headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        });

           var uploaderKaryawan= vm.FileUploaderKaryawan= new FileUploader({
          url:config.api+'api/uploaddatapms',
          removeAfterUpload:true,
          alias:'kpikaryawan',
          formData:[
               {
                action:'uploadDataKPIKaryawan'
               }
          ],
          onAfterAddingAll:function(){
                vm.UploadKPIKaryawanStateSucces=false;
                vm.UploadKPIKaryawanStateError=false;
       },
           headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        });


         uploaderNonPeople.onSuccessItem = function(item) {
            vm.UploadKPINonPeopleStateSucces=true;
            vm.UploadKPINonPeopleStateError=false;
            angular.element('#uploadFileNonPeople').val('');
        };

        uploaderNonPeople.onErrorItem=function()
        {
        	 vm.UploadKPINonPeopleStateSucces=false;
             vm.UploadKPINonPeopleStateError=true;
        };

        uploaderPeople.onSuccessItem = function(item) {
            vm.UploadKPIPeopleStateSucces=true;
            vm.UploadKPIPeopleStateError=false;
            angular.element('#uploadFilePeople').val('');
        };

        uploaderPeople.onErrorItem=function()
        {
        	 vm.UploadKPIPeopleStateSucces=false;
             vm.UploadKPIPeopleStateError=true;
        };

        uploaderTSTE.onSuccessItem = function(item) {
            vm.UploadKPITSTEStateSucces=true;
            vm.UploadKPITSTEStateError=false;
            angular.element('#uploadFileTSTE').val('');
        };

        uploaderTSTE.onErrorItem=function()
        {
        	 vm.UploadKPITSTEStateSucces=false;
             vm.UploadKPITSTEStateError=true;
        };

         uploaderAdjustment.onSuccessItem = function(item) {
            vm.UploadKPIAdjustmentStateSucces=true;
            vm.UploadKPIAdjustmentStateError=false;
            angular.element('#uploadFileAdjustment').val('');
        };

        uploaderAdjustment.onErrorItem=function()
        {
        	 vm.UploadKPIAdjustmentStateSucces=false;
             vm.UploadKPIAdjustmentStateError=true;
        };


        uploaderPa.onSuccessItem = function(item) {
            vm.UploadKPIPaStateSucces=true;
            vm.UploadKPIPaStateError=false;
            angular.element('#uploadFilePa').val('');
        };

        uploaderPa.onErrorItem=function()
        {
           vm.UploadKPIPaStateSucces=false;
             vm.UploadKPIPaStateError=true;
        };

        uploaderKaryawan.onSuccessItem = function(item) {
            vm.UploadKPIKaryawanStateSucces=true;
            vm.UploadKPIKaryawanStateError=false;
            angular.element('#uploadFilekaryawan').val('');
        };

        uploaderKaryawan.onErrorItem=function()
        {
           vm.UploadKPIKaryawanStateSucces=false;
             vm.UploadKPIKaryawanStateError=true;
        };
         

      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.tutorial2', [
        ])
        .config(config);

    config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
        // State
        $stateProvider
        .state('app.pms_tutorial2', {
            url    : '/pms/tutorial2',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/tutorial2/tutorial2.html',
                    controller : 'Tutorial2Controller as vm'
                }
            }
        });

        $stateProvider
        .state('app.pms_tutorial2_view', {
            url    : '/pms/tutorial2_view/:tutorial_type/:url',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/tutorial2/tutorial2-view.html',
                    controller : 'Tutorial2ViewController as vm'
                }
            }
        });

        // $translatePartialLoaderProvider.addPart('app/main/pms/competency');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.pms.tutorial2')
        .controller('Tutorial2Controller', Tutorial2Controller);

    Tutorial2Controller.$inject = ['$state', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', '$document'];
    /** @ngInject */
    function Tutorial2Controller($state, $log, $mdDialog, AppAPI, Auth, DataService, $document) {

        var vm = this;

        vm.tutorialList = [
            {
                id: 1,
                title: 'KPI.LABEL.PERFORMVIDEO',
                cover: 'Performance-Management-Tutorial.jpg',
                cover_height: '200px',
                type: 'video',
                url: btoa('Performance-Management-Tutorial.mp4')
            },
            {
                id: 2,
                title: 'KPI.LABEL.PERFORMMANUAL',
                cover: 'manual-user-cover.jpg',
                cover_height: '300px',
                type: 'ebook',
                url: btoa('manual-user-PMS-05-04-2018.pdf')
            }
        ];

    }


})();
(function () {
    'use strict';

    angular
        .module('app.pms.tutorial2')
        .controller('Tutorial2ViewController', Tutorial2ViewController);

    Tutorial2ViewController.$inject=['$state','$stateParams','$log','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function Tutorial2ViewController($state,$stateParams,$log,$mdDialog,AppAPI,Auth,DataService, $document) {
        
        var vm = this;        

        vm.tutorial_type = $stateParams.tutorial_type;
        vm.url = 'assets/tutorial/'+atob($stateParams.url)+((vm.tutorial_type === 'ebook')?'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;':'');        

    }


 })();
(function ()
{
    'use strict';

    angular
        .module('app.pms.tutorial', [
        ])
        .config(config);

    config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
        // State
        $stateProvider
        .state('app.pms_tutorial', {
            url    : '/pms/tutorial',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/tutorial/tutorial.html',
                    controller : 'TutorialController as vm'
                }
            }
        });

        $stateProvider
        .state('app.pms_tutorial_view', {
            url    : '/pms/tutorial_view/:tutorial_type/:url',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/tutorial/tutorial-view.html',
                    controller : 'TutorialViewController as vm'
                }
            }
        });

        // $translatePartialLoaderProvider.addPart('app/main/pms/competency');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.pms.tutorial')
        .controller('TutorialController', TutorialController);

    TutorialController.$inject = ['$state', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', '$document'];
    /** @ngInject */
    function TutorialController($state, $log, $mdDialog, AppAPI, Auth, DataService, $document) {

        var vm = this;

        vm.tutorialList = [
            {
                id: 1,
                title: 'Talent Management: Competency Review Nabati Group',
                cover: 'NABATI_-_COMPETENCY_REVIEW_R4.jpg',
                cover_height: '200px',
                type: 'video',
                url: btoa('NABATI_-_COMPETENCY_REVIEW_R4.mp4')
            },
            {
                id: 2,
                title: 'Competency Review System User Manual',
                cover: 'manual-user_Competency_Review-Final.png',
                cover_height: '300px',
                type: 'ebook',
                url: btoa('manual-user_Competency_Review-Final.pdf')
            }

        ];

    }


})();
(function () {
    'use strict';

    angular
        .module('app.pms.tutorial')
        .controller('TutorialViewController', TutorialViewController);

    TutorialViewController.$inject=['$state','$stateParams','$log','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function TutorialViewController($state,$stateParams,$log,$mdDialog,AppAPI,Auth,DataService, $document) {
        
        var vm = this;        

        vm.tutorial_type = $stateParams.tutorial_type;
        console.log($stateParams.url);
        vm.url = 'assets/tutorial/'+atob($stateParams.url)+((vm.tutorial_type === 'ebook')?'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;':'');        

    }


 })();
(function () {
    'use strict';

    angular
        .module('app.pms.talent_review_admin', ['app.pms.talent_review_admin.input-talent-review-member',
            'app.pms.talent_review_admin.talent-review-9box',
            'app.pms.talent_review_admin.set-projection-member'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.pms_talent_review_admin', {
                url: '/pms/talent-review-admin',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pms/talent-review-admin/talent-review-admin.html',
                        controller: 'TalentReviewAdminController as vm'
                    }
                }
            });



    }
})();
(function () {
    'use strict';

    angular
        .module('app.pms.talent_review_admin')
        .controller('TalentReviewAdminController', TalentReviewAdminController);


    TalentReviewAdminController.$inject = ['$state', '$localStorage', '$document', '$http', '$scope', 'config', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', 'FileUploader', '$location', '$window'];
    /** @ngInject */
    function TalentReviewAdminController($state, $localStorage, $document, $http, $scope, config, $log, $mdDialog, AppAPI, Auth, DataService, FileUploader, $location, $window) {

        var vm = this;
        var TalentReview = AppAPI.TalentReview();
        var date = new Date();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.tahun = date.getFullYear();
        vm.setTalentReviewMember = setTalentReviewMember;
        vm.setProjectionwMember = setProjectionwMember;
        vm.ExportAllEmployeetoExcel = ExportAllEmployeetoExcel;
        vm.group = $localStorage.group;
        vm.bulan = date.getMonth() + 1;
        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }
        vm.listDivision = [];

        vm.listtahun = [2017,2018,2019,2020,2021];
        vm.listbulan = [{ name: 'January', value: '01' },
        { name: 'February', value: '02' },
        { name: 'Maret', value: '03' },
        { name: 'April', value: '04' },
        { name: 'Mei', value: '05' },
        { name: 'June', value: '06' },
        { name: 'July', value: '07' },
        { name: 'August', value: '08' },
        { name: 'September', value: '09' },
        { name: 'October', value: '10' },
        { name: 'November', value: '11' },
        { name: 'Desember', value: '12' }];

        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [
            { link: '#', name: 'Team Perf. Mgt. / ', active: '0' }
        ];
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadDataAtasan = loadDataAtasan;

        console.log('vm.group', vm.group);

        loadDataBU();

        function loadDataBU() {
            var response = TalentReview.query({ action: 'viewBu' });
            response.$promise.then(function (data) {
                vm.listBu = data;
            });
            response.$promise.catch(function () {
                vm.listBu = [];
                angular.element.unblockUI();
            });
        }

        function loadDataDivision(idbu) {

            vm.divisi = '';
            vm.department = '';
            var response = TalentReview.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(function (data) {
                vm.listDivisi = data;
                vm.listDepartment = [];
            });
            response.$promise.catch(function () {
                vm.listDivisi = [];
                angular.element.unblockUI();
            });
        }

        function loadDataDepartment(iddivisi) {
            vm.department = '';
            var response = TalentReview.query({ action: 'viewDivisiDept', idbu: vm.bu, iddivisi: iddivisi });
            response.$promise.then(function (data) {
                vm.listDepartment = data;
            });
            response.$promise.catch(function errorDepartment() {
                vm.listDepartment = [];
                angular.element.unblockUI();
            });
        }

        function loadDataAtasan() {
            var response = TalentReview.query({ action: 'viewAtasanLists', bu: vm.bu, divisi: vm.divisi, department: vm.department });
            response.$promise.then(function (data) {
                vm.listAtasan = data;
                vm.nik_atasan = '';
            });
            response.$promise.catch(function errorDepartment() {
                vm.listAtasan = [];
                vm.nik_atasan = '';
                angular.element.unblockUI();
            });
        }

        function loadData(pageno) {
            angular.element('#talentReviewView').block({ message: 'please wait..' });
            var tahun = vm.tahun;
            var bulan = vm.bulan;

            var resp = TalentReview.query({ action: 'viewdata', tahun: tahun, bulan: bulan, nik: vm.nik_atasan, bu: vm.bu, divisi: vm.divisi, department: vm.department });
            resp.$promise.then(fetchTalentReviewData);
            resp.$promise.catch(errFetchTalentReviewData);
        }

        function errFetchTalentReviewData(data) {
            vm.listTalentReview = [];
            angular.element('#talentReviewView').unblock();
        }

        function fetchTalentReviewData(data) {
            vm.listTalentReview = data;
            angular.element('#talentReviewView').unblock();
        }

        var resViewBu = TalentReview.query({ action: 'viewDivisiByMgrData' });
        resViewBu.$promise.then(function (data) {
            vm.listDivision = data;
        });

        resViewBu.$promise.catch(function (data) {
            $log.info(data);
        });

        function setTalentReviewMember(ev, mdata) {
            // console.log('data', data);
            $mdDialog.show({
                controller: 'InputTalentReviewMemberController',
                controllerAs: 'vm',
                templateUrl: 'app/main/pms/talent-review/input-talent-review-member/input-talent-review-member.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    data: mdata
                },
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }


        function setProjectionwMember(ev, mdata) {
            // console.log('data', data);
            $mdDialog.show({
                controller: 'SetProjectionMemberController',
                controllerAs: 'vm',
                templateUrl: 'app/main/pms/talent-review/set-projection-member/set-projection-member.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    data: mdata
                },
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function ExportAllEmployeetoExcel() {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var bu = "-";
            var divisi = "-";
            var department = "-";
            if (vm.bu !== "") {
                bu = vm.bu;
            }
            if (vm.divisi !== "") {
                divisi = vm.divisi;
            }
            if (vm.department !== "") {
                department = vm.department;
            }
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/talentreview/trexportexcel/' + bu + '/' + divisi + '/' + department + '/' + data.token, '_blank');
                console.log(config.api);
            }, function () {
                $window.alert('gagal load token')
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.talent_review', ['app.pms.talent_review.input-talent-review-member', 
                                          'app.pms.talent_review.talent-review-9box',
                                          'app.pms.talent_review.set-projection-member'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_talent_review', {
                url    : '/pms/talent-review',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/talent-review/talent-review.html',
                        controller : 'TalentReviewController as vm'
                    }
                }
            });

   

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pms.talent_review')
        .controller('TalentReviewController', TalentReviewController);


    TalentReviewController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader','$location','$window'];
    /** @ngInject */
    function TalentReviewController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader,$location,$window)
    {
        
        var vm                   = this;
        var TalentReview         = AppAPI.TalentReview();
        var date                 = new Date();
        vm.listJum               = [2,5,25,50,75,100,200];
        vm.DataTable             = new DataService();
        vm.loadData              = loadData;
        vm.tahun                 = date.getFullYear();
        vm.setTalentReviewMember = setTalentReviewMember;
        vm.setProjectionwMember  = setProjectionwMember;
        vm.ExportAllEmployeetoExcel = ExportAllEmployeetoExcel;
        vm.group                 = $localStorage.group;
        vm.bulan                 = date.getMonth()+1;
        if(vm.bulan < 10){
            vm.bulan             = '0'+vm.bulan;
        }
        vm.listDivision          = [];

        vm.listtahun             = [2014,2015,2016,2017,2018,2019,2020,2021];
        vm.listbulan             = [{name:'January',value:'01'},
                      {name:'February',value:'02'},
                      {name:'Maret',value:'03'},
                      {name:'April',value:'04'},
                      {name:'Mei',value:'05'},
                      {name:'June',value:'06'},
                      {name:'July',value:'07'},
                      {name:'August',value:'08'},
                      {name:'September',value:'09'},
                      {name:'October',value:'10'},
                      {name:'November',value:'11'},
                      {name:'Desember',value:'12'}]; 

        vm.Breadhome             = "app.pms_dashboard";
        vm.Breadlist             = [
            {link:'#',name:'Team Perf. Mgt. / ',active:'0'}
        ]; 

        console.log('vm.group', vm.group);

        loadData(1);

        function loadData(pageno) {
            angular.element('#talentReviewView').block({message:'please wait..'});
            var tahun=vm.tahun; 
            var bulan=vm.bulan; 
            var resp=TalentReview.query({action:'viewdata',tahun:tahun,bulan:bulan,nik:vm.nik});
            resp.$promise.then(fetchTalentReviewData);
            resp.$promise.catch(errFetchTalentReviewData);                 
        }

        function errFetchTalentReviewData(data) {
            vm.listTalentReview=[];
            angular.element('#talentReviewView').unblock();
        }

        function fetchTalentReviewData(data) {
            vm.listTalentReview=data;
            angular.element('#talentReviewView').unblock();
        }

        var resViewBu= TalentReview.query({action:'viewDivisiByMgrData'});
        resViewBu.$promise.then(function(data){
            vm.listDivision=data;
        });

        resViewBu.$promise.catch(function(data){
            $log.info(data);
        });

        function setTalentReviewMember(ev, mdata) {
            // console.log('data', data);
            $mdDialog.show({
                controller: 'InputTalentReviewMemberController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/talent-review/input-talent-review-member/input-talent-review-member.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    data: mdata                   
                },
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }


        function setProjectionwMember(ev, mdata) {
            // console.log('data', data);
            $mdDialog.show({
                controller: 'SetProjectionMemberController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/talent-review/set-projection-member/set-projection-member.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    data: mdata                   
                },
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function ExportAllEmployeetoExcel() {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var bu = "-";
            var divisi = "-";
            var department = "-";
            if (vm.bu !== "") {
                bu = vm.bu;
            }
            if (vm.divisi !== "") {
                divisi = vm.divisi;
            }
            if (vm.department !== "") {
                department = vm.department;
            }
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/talentreview/trexportexcel/' + bu + '/' + divisi + '/' + department + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
 
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.permissionpms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_permissionpms', {
                url    : '/pms/permission',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/permissionpms/permissionpms.html',
                        controller : 'PermissionpmsController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.permissionpms')
        .controller('PermissionpmsController', PermissionpmsController);


    PermissionpmsController.$inject=['$state','$log','$mdDialog','AppAPI','Auth'];
    /** @ngInject */
    function PermissionpmsController($state,$log,$mdDialog,AppAPI,Auth)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200]; 
        vm.changeaction=changeaction;
        vm.reloadToken=Auth.setToken;
        vm.inputaction=inputaction;
        vm.AddPermission=AddPermission;
        var Group=AppAPI.Group();
        var Module=AppAPI.Module();

        // var response= Group.query({action:'listGroupSelect'});
        //   response.$promise.then(function(data){
        //      vm.listGroupSelect=data;
        //      // console.log(vm.listGroupSelect);
        //   });

        //   response.$promise.catch(function(data){
        //     $log.info(data);
        //   });

        // Data
 
        // Methods
        // loadData();

        ////////// 

        // function loadData(){ 
          var res= Module.query({action:'get_modul_pms'});
          res.$promise.then(function(data){
            $log.log(data);
            vm.listModul=data;
          });
          res.$promise.catch(function(data){
            console.log(data);
          });
        // }

        function changeaction(action,groupid){
          var resp= Auth.setToken();
          resp.then(function(){
            var act=new Module();
            act.item=action;
            act.action='save_module_action';
            act.groupID=groupid;
            var res=act.$save();
            res.then(function(rdata){
              $log.info(rdata.pesan);
              vm.reloadToken();
            },function(err){
              $log.log(err);
            });
            // console.log(act);
          });  
        }

        function inputaction(menuid){
          $state.go('app.utility_permission_input-action',{menuid:menuid});
          console.log(menuid);
        }

        function AddPermission(group){
          console.log(group);
        }
    }
})();

(function ()
{
    'use strict';

    angular
       .module('app.pms.password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_password', {
                url    : '/pms/password',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/password/password.html',
                        controller : 'PasswordController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.password')
        .controller('PasswordController', PasswordController);

     PasswordController.$inject=['$state','$resource','$mdDialog','Auth','AppAPI','config','GeneralService','$localStorage','$timeout','Form'];   

    /** @ngInject */
    function PasswordController($state,$resource,$mdDialog,Auth,AppAPI,config,GeneralService,$localStorage,$timeout,Form)
    {
        var vm = this;
        
         vm.username=$localStorage.user;

         // initial form
         Form.initialForm();

         var Password=  AppAPI.Password();

         // set constructor form
         Form.setObject(Password);

         // set form to controller
         vm.Form = Form;

        vm.saveDataPass=saveDataPass;

        vm.clearMeesage=clearMeesage;

        function saveDataPass(ev,formController) {

            Form.objForm.username=vm.username;
            if(Form.objForm.password==Form.objForm.confirm_password){
                  angular.element.blockUI();
                     var response=Form.saveData('save', formController, Password);
                     response.then(function(){
                         vm.messageTheme='blue';
                          showDialogPass(ev);
                           angular.element.unblockUI();
                     });

            }else{
                $mdDialog.show(
                $mdDialog.alert()
                .textContent('Password Not Match!')
                 .ok('OK')
                 );  
            }

        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
            

        function closeDialogPass()
     {
        $mdDialog.hide();
        logout();
     }

     function showDialogPass(ev) {
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Success Save Password')
            .textContent('Process Set Password was Success. Please login again')
            .ariaLabel('Success Save Password')
            .ok('OK')
            .targetEvent(ev)
        ).then(function(){
            closeDialogPass();
        });
    }

    function logout()
        {
            angular.element.blockUI();
            
                     var Logout=AppAPI.Logout();
                     var objLogout= new Logout();

                     var promise=objLogout.$logout();
                          promise.then(function(rdata){
                            var resultNum=parseInt(rdata.status);
                            if(resultNum===1)
                            {
                                  GeneralService.clearStorage();
                             // $location.path('/');
                              $state.go('app.login.emplogin');
                              angular.element.unblockUI();
                            }else
                            {
                              $window.alert('failed proses logout');
                              angular.element.unblockUI();
                            }
                          },function(){
                             $window.alert('failed proses logout');
                              angular.element.unblockUI();
                          });
        }
       
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_result')
        .controller('PapeopleController', PapeopleController);


    PapeopleController.$inject=['$localStorage','AppAPI','$mdDialog'];
    /** @ngInject */
    function PapeopleController($localStorage,AppAPI,$mdDialog)
    {

       var vm =this;
       var today = new Date();
       var year = today.getFullYear();
       vm.yearSelected=year;
       vm.showKpi=showKpi;
       vm.addCon=false;
       var KPI = AppAPI.Papeople();
        vm.years=[{year:2020, selected:true},{year:2019, selected:false},{year:2018, selected:false},{year:2017,selected:false},{year:2016,selected:false},{year:2015,selected:false}];

        checkSelectedYear();
         loadData();
        function checkSelectedYear()
        {

           // var lengthYear=vm.years
            angular.forEach(vm.years,function(obj){
               if(obj.year===vm.yearSelected)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }


        function loadData()
        {
          // console.log($localStorage);
            if(vm.yearSelected==year){
                vm.addCon=true;
            }else{
                 vm.addCon=false;
            }
          var response=KPI.query({action:'viewpapeople',year:vm.yearSelected,nik:$localStorage.user});
          response.$promise.then(fetchKpi);
          response.$promise.catch(errorFetchKpi);
        }

        function fetchKpi(data)
        {
           vm.listPA=data;
        }

        function errorFetchKpi()
        {
           vm.listPA=[];
        }

        function showKpi(year)
        {
           vm.yearSelected=year;
           checkSelectedYear();
           loadData();
        }







    }
})();

(function ()
{
    'use strict';

    angular
       .module('app.pms.mpp', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pms_mpp', {
                url    : '/pms/pms_mpp',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/mpp/mpp.html',
                        controller : 'MppController as vm'
                    }
                }
            });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.pms.mpp')
        .controller('mppIncreaseDialogController', mppIncreaseDialogController);

    
    /* @ngInject */
    mppIncreaseDialogController.$inject=['$mdDialog'];
    function mppIncreaseDialogController($mdDialog) {
        var vm = this;
        vm.title = 'Controller';
        vm.hide=hide;
        vm.cancel=cancel;


        ////////////////
        function hide()
        {
        	  $mdDialog.hide();
        }
       
       function cancel()
       {
       	  $mdDialog.cancel();
       }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.mpp')
        .controller('MppController', MppController);


    MppController.$inject=['$mdDialog','$localStorage','AppAPI'];
    /** @ngInject */
    function MppController($mdDialog,$localStorage,AppAPI)
    {
        var vm=this;
        var Mpp=AppAPI.Mpp();
        vm.username=$localStorage.nama;
        var today = new Date();
        var year = today.getFullYear();
        vm.yearSelected=year;
        vm.loadData=loadData;
        vm.showMpp=showMpp;
        vm.increaseEmp=increaseEmp;
        vm.years=[{year:2019,selected:true},{year:2018,selected:true},{year:2017,selected:false},{year:2016,selected:false},{year:2015,selected:false}];
        // Data


        loadData(vm.yearSelected);
        checkSelectedYear();
 
        // Methods

        //////////

        function showMpp(year)
        {
            vm.yearSelected=year;
            checkSelectedYear();
            loadData(year);
        }

        function increaseEmp(ev)
        {
            $mdDialog.show({
                  controller: 'mppIncreaseDialogController',
                  controllerAs:'vm',
                  templateUrl: 'app/main/pms/mpp/mppincreasedialog.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: true // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {
                
                }, function() {
                  
                });
        }
        function checkSelectedYear()
        {

           // var lengthYear=vm.years
            angular.forEach(vm.years,function(obj){
               if(obj.year===vm.yearSelected)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }
        function loadData(year)
        {
            angular.element('#mppTable').block();
            var response=Mpp.query({action:'viewdata'});
            response.$promise.then(fetchDataMpp);
            response.$promise.catch(errorFetchMpp);
        }

        function fetchDataMpp(data)
        {
            vm.dataMpp=data;
            angular.element('#mppTable').unblock();
        }

        function errorFetchMpp()
        {
             angular.element('#mppTable').unblock();
            vm.dataMpp=[];
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_team', ['app.pms.kpi_team.set-team-member'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_kpi_team', {
                url    : '/pms/kpi-team',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi-team/kpi-team.html',
                        controller : 'KpiteamController as vm'
                    }
                }
            });

       

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_team')
        .controller('KpiteamController', KpiteamController);


    KpiteamController.$inject=['DataService','$state','$localStorage','AppAPI','DTColumnDefBuilder','$mdDialog'];
    /** @ngInject */
    function KpiteamController(DataService,$state,$localStorage,AppAPI,DTColumnDefBuilder,$mdDialog)
    {
        
        var vm=this;

        vm.username=$localStorage.nama;
        vm.user=$localStorage.user;
        
        vm.setView=setView;
        vm.setViewD=setViewD;
         var teamMember=AppAPI.Kpiteam();
        vm.DataTable= new DataService();

        vm.loadData=loadData;

        vm.icon = "icon-plus";
        vm.result = false;
        vm.toogleSubChild=toogleSubChild;
        vm.visibleSubChild=[];

        loadData(1);


         function loadData(pageno) {          

            vm.DataTable.loadData(teamMember,pageno,{action:'viewdata',id:vm.user});

        }

        function toogleSubChild(idx) {
            switch(vm.visibleSubChild[idx])
            {
                case true :
                vm.visibleSubChild[idx]=false;
                vm.icon='icon-minus';
                break;
                case false :
                vm.visibleSubChild[idx]=true;
                 vm.icon='icon-plus';
                break;
                default:
                   vm.visibleSubChild[idx]=true;
                    vm.icon='icon-minus';
                break;
            }

        }


         function setView(nik) {
            $state.go('app.pms_kpi_team_set_team_member',{id:nik});
        }

        function setViewD(nik) {
            $state.go('app.pms_kpi_team_set_team_memberD',{id:nik});
        }

        
        // Data
        
        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.masterkpi', ['app.pms.masterkpi.input','app.pms.masterkpi.set-kpi-scales','app.pms.masterkpi.manage-kpi-scales'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_masterkpi', {
                url    : '/pms/master-kpi',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/master-kpi/master-kpi.html',
                        controller : 'MasterkpiController as vm'
                    }
                }
            });

    

    }
})();
(function () {
  'use strict';

  angular
    .module('app.pms.masterkpi')
    .controller('MasterkpiController', MasterkpiController);


  MasterkpiController.$inject = ['DTColumnDefBuilder', 'AppAPI', '$mdDialog', 'DataService', '$filter'];
  /** @ngInject */
  function MasterkpiController(DTColumnDefBuilder, AppAPI, $mdDialog, DataService, $filter) {

    var vm = this;
    vm.listKpiSelected = [];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.isOpen = false;
    vm.setScales = setScales;
    vm.viewKpiScales = viewKpiScales;

    var Kpimaster = AppAPI.Kpimaster();
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    var translate = $filter('translate');

    loadDataKpi();
    // Data
    /*  vm.employees = Employees.data;*/

    vm.dtOptions = {
      dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
      autoWidth: false,
      responsive: true,
      pagingType: 'full_numbers'
    };

    vm.dtColumnDefs = [
      DTColumnDefBuilder.newColumnDef(0).notSortable(),
      DTColumnDefBuilder.newColumnDef(1).notSortable(),
      DTColumnDefBuilder.newColumnDef(2).notSortable()
    ];

    // Data

    // Methods

    //////////

    function loadDataKpi(pageno) {
      angular.element.blockUI();

      var kpiPromise = vm.DataTables.loadData(Kpimaster, pageno, {
        action: 'viewdata'
      });
      kpiPromise.then(fetchDataKpi);
      kpiPromise.catch(errorFetchKpi);
    }


    function fetchDataKpi(data) {
      angular.element.unblockUI();
      vm.selected = [];
      vm.listKpi = data.list;
    }

    function errorFetchKpi() {
      angular.element.unblockUI();
      vm.listKpi = [];
    }


    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listKpiSelected = angular.copy(vm.listKpi);
    }

    function unCheckAll() {
      vm.listKpiSelected = [];
    }


    function setScales(ev, kpi) {
      $mdDialog.show({
        controller: 'SetkpiscalesController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pms/master-kpi/set-kpi-scales/set-kpi-scales.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          kpi: kpi
        }
      });
    }

    function viewKpiScales(ev, kpi) {
      $mdDialog.show({
        controller: 'ManagekpiscalesController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pms/master-kpi/manage-kpi-scales/manage-kpi-scales.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          kpi: kpi
        }
      });
    }




  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi-scales', ['app.pms.kpi-scales.input-kpi-scales'
        ])
        .config(config);

         config.$inject=['$stateProvider'];

    /** @ngInject */
   /** @ngInject */
   function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pms_kpi_scales', {
                url    : '/pms/kpi-scales',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi-scales/kpi-scales.html',
                        controller : 'KpiscalesController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi-scales')
        .controller('KpiscalesController', KpiscalesController);


    KpiscalesController.$inject=['$state','$mdDialog','DTColumnDefBuilder','AppAPI','Auth','$localStorage','DataService'];
    /** @ngInject */
    function KpiscalesController($state,$mdDialog,DTColumnDefBuilder,AppAPI,Auth,$localStorage,DataService)
    {
        
       var vm =this;
       vm.username=$localStorage.user;
      vm.DataTable= new DataService();
     var KPI=AppAPI.Kpi();
     vm.loadData=loadData;
     vm.eff='all';
     vm.loadData=loadData;
      var KpiScales=AppAPI.KpiScales();
      loadData(1);
      loadDataEff();

         vm.listKS=[];
         vm.toggleSelectedAll=toggleSelectedAll;
         vm.listKSSelected=[];
         vm.editData=editData;
         vm.deleteKS=deleteKS;
     

      function loadData(pageno)
      {
          vm.DataTable.loadData(KpiScales,pageno,{action:'viewdata',eff:vm.eff,id:vm.username});
          loadDataEff();
      }

        
      function loadDataEff() {
        var buPromise=KpiScales.query({action:'viewdataeff',id:vm.username});
        buPromise.$promise.then(fetchEff);
        buPromise.$promise.catch(errorFetchEff); 
      }

      function fetchEff(data) {
        vm.listEff=data;
      }

      function errorFetchEff() {
        vm.listEff=[];
      }



    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listKSSelected=angular.copy(vm.DataTable.list);
    }

    function unCheckAll() {
       vm.listKSSelected=[];
    }

    function editData(id) {
        $state.go('app.pms_kpi_scales_edit',{id:id});
    }

    function deleteKS(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=KpiScales.delete({action:'delete',data:angular.toJson(vm.listKSSelected)});

       response.$promise.then(loadData);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }
     
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_nabati', ['app.pms.kpi_nabati.set-team-all'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_kpi_nabati', {
                url    : '/pms/kpi-nabati',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi-nabati/kpi-nabati.html',
                        controller : 'KpinabatiController as vm'
                    }
                }
            });
        // State
        $stateProvider
            .state('app.pms_kpi_nabati_result', {
                url    : '/pms/kpi-nabati-result/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/kpi-nabati/kpi-nabati-result.html',
                        controller : 'KpiNabatiresultController as vm'
                    }
                }
            });

    }
})();
(function () {
    'use strict';
    angular.module('app.pms.kpi_nabati').controller('KpinabatiController', KpinabatiController);
    KpinabatiController.$inject = ['DataService', '$state', '$window', '$localStorage', '$location', 'AppAPI', 'DTColumnDefBuilder', '$mdDialog', 'Auth', 'config'];
    /** @ngInject */
    function KpinabatiController(DataService, $state, $window, $localStorage, $location, AppAPI, DTColumnDefBuilder, $mdDialog, Auth, config) {
        var vm = this;
        var KPI = AppAPI.teamMember();
        vm.username = $localStorage.nama;
        vm.user = $localStorage.user;
        vm.empsite = $localStorage.empsite;
        vm.group = $localStorage.group;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.setView = setView;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.bu = '';
        vm.divisi = '';
        vm.department = '';
        vm.periode = '';
        vm.ExporttoExcel = ExporttoExcel;
        vm.year = new Date().getFullYear();
        vm.years = [{ year: 2020, selected: true }, { year: 2019, selected: false }, { year: 2018, selected: false }, { year: 2017, selected: false }, { year: 2016, selected: false }, { year: 2015, selected: false }];
        vm.listPeriode = [
            { id: '01', value: 'Yearly' },
            { id: 'Q1', value: 'Q1' },
            { id: 'Q2', value: 'Q2' },
            { id: 'Q3', value: 'Q3' },
            { id: 'Q4', value: 'Q4' },
            { id: 'all', value: 'all' }
        ]



        // loadData(1);
        loadDataBU();

        function loadData(pageno) {
            var teamMember = AppAPI.teamMember();
            vm.DataTable.loadData(teamMember, pageno, {
                action: 'viewdataall',
                id: 0,
                bu: vm.bu,
                divisi: vm.divisi,
                department: vm.department,
                periode: vm.periode,
                year: vm.year
            });
        }

        function setView(nik) {
            // $state.go('app.pms_kpi_nabati_set_team_all', {
            //     id: nik
            // });
            $state.go('app.pms_kpi_nabati_result', {
                id: nik
            });
        }

        function loadDataDivision(idbu) {
            vm.divisi = '';
            vm.department = '';
            var response = KPI.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivisi = data;
            vm.listDepartment = [];
            loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivisi = [];
        }

        function loadDataBU() {
            var KPI = AppAPI.teamMember();
            var response = KPI.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBu = data;

            if (vm.group === '110' || vm.group === '116' || vm.group === '118') {
                vm.bu = vm.empsite;
                loadDataDivision(vm.bu);
            }
        }

        function errorFetchBU() {
            vm.listBu = [];
        }
        // Data
        // Methods
        function loadDataDepartment(iddivisi) {
            vm.department = '';
            var response = KPI.query({
                action: 'viewDivisiDept',
                idbu: vm.bu,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function fetchDivisiBU(data) {
            vm.listDivisi = data;
            loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivisi = [];
        }

        function ExporttoExcel() {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var bu = "-";
            var divisi = "-";
            var department = "-";
            if (vm.bu !== "") {
                bu = vm.bu;
            }
            if (vm.divisi !== "") {
                divisi = vm.divisi;
            }
            if (vm.department !== "") {
                department = vm.department;
            }
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/kpi/kpiexportexcel/' + bu + '/' + divisi + '/' + department + '/' + vm.periode + '/' + vm.year + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
            // console.log(vm.bu+'  /   '+vm.divisi+'   /  '+vm.department);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_nabati')
        .controller('KpiNabatiresultController', KpiNabatiresultController);


    KpiNabatiresultController.$inject=['$localStorage','AppAPI','$mdDialog','$stateParams'];
    /** @ngInject */
    function KpiNabatiresultController($localStorage,AppAPI,$mdDialog,$stateParams)
    {

        var vm =this;
        var today = new Date();
        
        var year = today.getFullYear();
        // var year = '2018'; //sementara di fix

        vm.yearSelected=year;
        vm.showKpi=showKpi;
        vm.addResult=addResult;
        vm.editKpiResult=editKpiResult;
        vm.addCon=false;
        vm.viewScales=viewScales;
        
        vm.nik = vm.nik=$stateParams.id;
        vm.info = 1;
        var KPI = AppAPI.kpiResult();
        vm.years=[{year:2020,selected:true},{year:2019,selected:false},{year:2018,selected:false},{year:2017,selected:false},{year:2016,selected:false},{year:2015,selected:false}];

        checkSelectedYear();
        loadData();
        loadPA();

        function checkSelectedYear()
        {
           // var lengthYear=vm.years
            angular.forEach(vm.years,function(obj){
               if(obj.year===vm.yearSelected)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }

        function loadData()
        {
            if(vm.yearSelected==year){
                vm.addCon=true;
            }else{
                 vm.addCon=false;
            }
            var response=KPI.query({action:'viewkpipeopleresult',year:vm.yearSelected,nik:vm.nik});
            
            response.$promise.then(fetchKpi);
            response.$promise.catch(errorFetchKpi);
        }

        function fetchKpi(data)
        {
            vm.listKpi=data;
        }

        function errorFetchKpi()
        {
            vm.listKpi=[];
        }

        function showKpi(year)
        {
            vm.yearSelected=year;
            checkSelectedYear();
            loadData();
            loadPA();
        }

        function addResult(ev, kpi)
        {
            $mdDialog.show({
                controller: 'inputresultController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/kpi-result/inputresult/inputresult.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    kpi:kpi,
                    year:vm.yearSelected
                },
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function editKpiResult(ev, kpi)
        {
            $mdDialog.show({
                controller: 'editresultController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/kpi-result/inputresult/editresult.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    kpi:kpi,
                    year:vm.yearSelected
                },
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }


        function loadPA()
        {
            if(vm.yearSelected==year){
                vm.addCon=true;
            }else{
                vm.addCon=false;
            }
            var response=KPI.query({action:'viewpapeople',year:vm.yearSelected,nik:vm.nik});
            console.log(response);
            response.$promise.then(fetchPa);
            response.$promise.catch(errorFetchPa);
        }

        function fetchPa(data)
        {
            vm.listPA=data;
            var jum=data.length;
            for (var i=0;i<jum;i++) {
                vm.info = data[i].info;
            }
        }

        function errorFetchPa()
        {
           vm.listPA=[];
           vm.info = "failed fetch data PA";
        }
        
        function viewScales(ev,kpi) {
            $mdDialog.show({
               controller: 'SetteamallscaleController',
               controllerAs:'vm',
               templateUrl: 'app/main/pms/kpi-nabati/set-team-all/set-team-all-scale.html',
               parent: angular.element(document.body),
               targetEvent: ev,
               clickOutsideToClose:true,
               fullscreen: true,
               locals:{
                 kpi:kpi
               }
             });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.kpi_result')
        .controller('KpiresultController', KpiresultController);


    KpiresultController.$inject=['$localStorage','AppAPI','$mdDialog'];
    /** @ngInject */
    function KpiresultController($localStorage,AppAPI,$mdDialog)
    {

       var vm =this;
       var today = new Date();
       var year = today.getFullYear();
       vm.yearSelected=year;
       vm.showKpi=showKpi;
       vm.addResult=addResult;
       vm.editKpiResult=editKpiResult;
       vm.addCon=false;
       vm.nik = $localStorage.user;
       vm.info = 1;
       var KPI = AppAPI.kpiResult();
       vm.years=[{year:2020,selected:false},{year:2019,selected:false},{year:2018,selected:false},{year:2017,selected:false},{year:2016,selected:false},{year:2015,selected:false}];

        checkSelectedYear();
         loadData();
         loadPA();

        function checkSelectedYear()
        {

           // var lengthYear=vm.years
            angular.forEach(vm.years,function(obj){
               if(obj.year===vm.yearSelected)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }

        function loadData()
        {
            if(vm.yearSelected==year){
                vm.addCon=true;
            }else{
                 vm.addCon=false;
            }
          var response=KPI.query({action:'viewkpipeopleresult',year:vm.yearSelected});
          console.log(response);
          response.$promise.then(fetchKpi);
          response.$promise.catch(errorFetchKpi);
        }

        function fetchKpi(data)
        {
           vm.listKpi=data;
        }

        function errorFetchKpi()
        {
           vm.listKpi=[];
        }

        function showKpi(year)
        {
           vm.yearSelected=year;
           checkSelectedYear();
           loadData();
                loadPA();
        }

        function addResult(ev, kpi)
        {
           $mdDialog.show({
                  controller: 'inputresultController',
                  controllerAs:'vm',
                  templateUrl: 'app/main/pms/kpi-result/inputresult/inputresult.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  locals:{
                    kpi:kpi,
                    year:vm.yearSelected
                  },
                  onRemoving:function(element, removePromise)
                  {
                    loadData();
                  },
                  fullscreen: true // Only for -xs, -sm breakpoints.
                });
        }

         function editKpiResult(ev, kpi)
        {
           $mdDialog.show({
                  controller: 'editresultController',
                  controllerAs:'vm',
                  templateUrl: 'app/main/pms/kpi-result/inputresult/editresult.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  locals:{
                    kpi:kpi,
                    year:vm.yearSelected
                  },
                  onRemoving:function(element, removePromise)
                  {
                    loadData();
                  },
                  fullscreen: true // Only for -xs, -sm breakpoints.
                });
        }


       function loadPA()
        {
            if(vm.yearSelected==year){
                vm.addCon=true;
            }else{
                 vm.addCon=false;
            }
          var response=KPI.query({action:'viewpapeople',year:vm.yearSelected,nik:vm.nik});
          console.log(response);
          response.$promise.then(fetchPa);
          response.$promise.catch(errorFetchPa);
        }

        function fetchPa(data)
        {
           vm.listPA=data;
           var jum=data.length;
           for (var i=0;i<jum;i++) {
            vm.info = data[i].info;
           }
        }

        function errorFetchPa()
        {
           vm.listPA=[];
           vm.info = "failed fetch data PA";
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('app.pms.kpi')
        .directive('checkTargetSettingValueMin', checkTarget);


    /* @ngInject */
    function checkTarget () {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'EA',
            require:'ngModel',
            scope: {
            	validatedVal:"=checkTargetSettingValueMin",
            	type:"=valueCategory"
            }
        };
        return directive;

        function link(scope, element, attrs,ngModel) {
        	ngModel.$validators.targetSettingMin=function(modelValue)
        	{
        		if(scope.type==='increase')
        		{
        			return modelValue <= scope.validatedVal;
        			
        		}else
        		{
        			return modelValue >= scope.validatedVal;
        			
        		}
        	}

        	scope.$watch('validatedVal',function(){
        		ngModel.$validate();
        	});

        	scope.$watch('type',function(){
        		ngModel.$validate();
        	});
        }
    }


   

})();
(function () {
  'use strict';

  angular
    .module('app.pms.kpi')
    .controller('KpiController', KpiController);


  KpiController.$inject = ['$localStorage', '$mdDialog', 'AppAPI', 'Auth', '$filter'];
  /** @ngInject */
  function KpiController($localStorage, $mdDialog, AppAPI, Auth, $filter) {
    var vm = this;

    var translate = $filter('translate');

    vm.username = $localStorage.nama;
    var today = new Date();
    var year = today.getFullYear();
    vm.yearSelected = year;
    vm.showKpi = showKpi;
    vm.addKPI = addKPI;
    vm.editKPI = editKPI;
    vm.deleteKPI = deleteKPI;
    vm.setScale = setScale;
    var KPI = AppAPI.Kpi();
    vm.nik = $localStorage.user; 
    
    vm.years = [{ year: 2020, selected: false },{ year: 2019, selected: false }, { year: 2018, selected: false }, { year: 2017, selected: false }, { year: 2016, selected: false }, { year: 2015, selected: false }];

    checkSelectedYear();
    loadData();
    // loadPA();

    function checkSelectedYear() {

      // var lengthYear=vm.years
      angular.forEach(vm.years, function (obj) {
        if (obj.year === vm.yearSelected) {
          obj.selected = true;
        } else {
          obj.selected = false;
        }
      });
    }

    function setScale(kpi, ev) {
      $mdDialog.show({
        controller: 'inputscaleController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pms/kpi/inputscale/inputscale.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          kpi: kpi
        },
        onRemoving: function (element, removePromise) {
          loadData();
          hide();
        },
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function loadData() {
      angular.element('#tb-kpi-setting').block({ message: ' <span>Loading...</span>' });
      var response = KPI.query({ action: 'viewkpipeople', year: vm.yearSelected });
      response.$promise.then(fetchKpi);
      response.$promise.catch(errorFetchKpi);
    }

    function fetchKpi(data) {
      // vm.totalweight = 100;
      vm.listKpi = data[0].rsKpiPeople;
      vm.totalweight = 100 - parseFloat(data[0].bobotavailable);
      vm.expireDate = data[0].expireDate;

      angular.element('#tb-kpi-setting').unblock();
    }

    function errorFetchKpi() {
      vm.listKpi = [];
      angular.element('#tb-kpi-setting').unblock();
      //angular.element.unblockUI();
    }

    function showKpi(year) {
      vm.yearSelected = year;
      checkSelectedYear();
      loadData();
      // loadPA();
    }

    function addKPI(ev) {
      $mdDialog.show({
        controller: 'inputkpiController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pms/kpi/inputkpi/inputkpi.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          year: vm.yearSelected,
          maxweight: vm.totalweight,
          months: monthName
        },
        onRemoving: function (element, removePromise) {
          loadData();
          hide();
        },
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editKPI(ev, kpi) {
      $mdDialog.show({
        controller: 'editkpiController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pms/kpi/inputkpi/inputkpi.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          kpi: kpi,
          expireDate: vm.expireDate,
          maxweight: vm.totalweight,
          months: monthName,
          years: vm.yearSelected
        },
        onRemoving: function (element, removePromise) {
          loadData();
          hide();
        },
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function loadPA() {
      if (vm.yearSelected == year) {
        vm.addCon = true;
      } else {
        vm.addCon = false;
      }
      var response = KPI.query({ action: 'viewpapeople', year: vm.yearSelected, nik: vm.nik });
      response.$promise.then(fetchPa);
      response.$promise.catch(errorFetchPa);
    }

    function fetchPa(data) {
      vm.listPA = data;
    }

    function errorFetchPa() {
      vm.listPA = [];
    }

    function deleteKPI(ev, kpi) {
      angular.element('#tb-kpi-setting').block();
      var confirmdel = translate('PAYROLL.MESSAGE.CONFDEL');
      var note = translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(confirmdel)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.unblockUI();
          var response = KPI.delete({ action: 'deletekpipeople', data: kpi });
          angular.element('#tb-kpi-setting').unblock();
          response.$promise.then(function (data) {
            angular.element.unblockUI();
            if (data.status == 1) {
              data.status = 'PAYROLL.MESSAGE.SUCCESS';
              showDialogInfo(ev, data);
              loadData();
            } else {
              data.status = 'PAYROLL.MESSAGE.FAILED';
              showDialogInfo(ev, data);
              loadData();
            }
          });
        }, function () {
          angular.element('#tb-kpi-setting').unblock();

          angular.element.unblockUI();
          showDialogInfo(ev, data.data);
        });
      });

      function dialogClose() {
        $mdDialog.hide();
      }

      function showDialogInfo(ev, data) {
        var message = translate(data.pesan);
        var status = translate(data.status);
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel(status)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function () {
            dialogClose();
            loadData(1);
          });
      }

    }

    var monthName = [
      { view: "Januari", value: "01" },
      { view: "Februari", value: "02" },
      { view: "Maret", value: "03" },
      { view: "April", value: "04" },
      { view: "Mei", value: "05" },
      { view: "Juni", value: "06" },
      { view: "Juli", value: "07" },
      { view: "Agustus", value: "08" },
      { view: "September", value: "09" },
      { view: "Oktober", value: "10" },
      { view: "November", value: "11" },
      { view: "Desember", value: "12" }
    ];

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.job_code_profile', ['app.pms.job_code_profile.input-job-code-profile'
        ])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
        .state('app.pms_job_code_profile', {
            url    : '/pms/job-code-profile',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/job-code-profile/job-code-profile.html',
                    controller : 'JobCodeProfileController as vm'
                }
            }
        });

    }

})();
(function() {
    'use strict';

    angular
        .module('app.pms.job_code_profile')
        .controller('UploadProfileController', UploadProfileController);

    UploadProfileController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadProfileController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        ////////////////

       

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/jobcodeprofile/uploadprofile', 
           removeAfterUpload:true,
           alias:'filejobcodeprofile',
           formData:[
              {
               action:'uploadprofile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pms.job_code_profile')
        .controller('JobCodeProfileController', JobCodeProfileController);

    JobCodeProfileController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService','$document'];
    /** @ngInject */
    function JobCodeProfileController($state,$log,$mdDialog,AppAPI,Auth,DataService,$document) {
        
        var Group            = AppAPI.Group();
        var JobCodeProfile       = AppAPI.JobCodeProfile();
        var vm               = this;
        vm.listJum           = [2,5,25,50,75,100,200];
        vm.DataTable         = new DataService();
        vm.loadData          = loadData;
        vm.modulesAction     = modulesAction;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listModulSelected = [];
        vm.deleteModul       = deleteModul;
        vm.editData          = editData;        
        vm.Breadhome         = "app.pms_job_code_profile";
        vm.Breadlist         = [
            {link:'#',name:'JobCodeProfile',active:'0'}
        ];

        var response = Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
            vm.listGroupSelect=data;
            // console.log(vm.listGroupSelect);
        });

        response.$promise.catch(function(data){
            $log.info(data);
        });

        // Data
        loadData(1);
        // Methods

        ////////// 

        function loadData(pageno){
           vm.DataTable.loadData(JobCodeProfile,pageno,{action:'viewData'});
           // console.log('test');
        }

        vm.openUploadProfile=openUploadProfile;
        function openUploadProfile(ev) {
            console.log('ev', ev);
            $mdDialog.show({
                controller         : 'UploadProfileController as vm',
                templateUrl        : 'app/main/pms/job-code-profile/upload-job-code-profile.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }


        // function loadData(pageno) {
        //  var response= JobCodeProfile.query({action:'viewdata',search:vm.DataTable.searchParam});
        // response.$promise.then(function(data){
        //    vm.list=data;
        // });
        // response.$promise.catch(function(data){
        //   console.log(data);
        // });

        // }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

        function checkAll() {
            vm.listModulSelected=angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listModulSelected=[];
        } 

        function modulesAction(id){
            // console.log(id);
            $state.go('app.utility_modules_modules-action',{id:id});
        }

        function editData(id){
            // console.log(id);
            $state.go('app.pms_job_code_profile_edit',{id:id});
        }

        function deleteModul(ev) {
   
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data your selected will be deleted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=JobCodeProfile.delete({action:'delete',data:angular.toJson(vm.listModulSelected)});

                response.$promise.then(loadData(1)); 
            }, function() {
            // $scope.status = 'You decided to keep your debt.';
            });
        });
  
   
    }

    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.pms.idp', ['app.pms.idp.set_idp_member'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_idp', {
                url    : '/pms/idp',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/idp/idp.html',
                        controller : 'IdpController as vm'
                    }
                }
            });

       
        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/pms/idp/idp-member');
        // Navigation
  /*  msNavigationServiceProvider.saveItem('pms', {
        title : 'PMS',
        group : true,
        weight: 1,
        hidden:function(){return false;}
    });
    // Apps.Dashboards
    msNavigationServiceProvider.saveItem('pms.dashboard', {
         title    : 'Dashboard',
            icon     : 'icon-tile-four',
            state    : 'app.pms_dashboard',
            weight   : 1,
             hidden:function(){return false;}
    });
       */

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.idp')
        .controller('IdpController', IdpController);


    IdpController.$inject=['DataService','$state','$localStorage','AppAPI','DTColumnDefBuilder','$mdDialog'];
    /** @ngInject */
    function IdpController(DataService,$state,$localStorage,AppAPI,DTColumnDefBuilder,$mdDialog)
    {
        
        var vm             = this;
        var teamMember     = AppAPI.Idp();

        vm.username        = $localStorage.nama;
        vm.user            = $localStorage.user;
        vm.setView         = setView;
        vm.setViewD        = setViewD;                 
        vm.loadData        = loadData;
        vm.icon            = "icon-plus";
        vm.result          = false;
        vm.toogleSubChild  = toogleSubChild;
        vm.visibleSubChild = [];
        vm.DataTable       = new DataService();

        loadData(1);


        function loadData(pageno) {          

        vm.DataTable.loadData(teamMember,pageno,{action:'viewdata',id:vm.user});

        }

        function toogleSubChild(idx) {
            switch(vm.visibleSubChild[idx])
            {
                case true :
                vm.visibleSubChild[idx]=false;
                vm.icon='icon-minus';
                break;
                case false :
                vm.visibleSubChild[idx]=true;
                 vm.icon='icon-plus';
                break;
                default:
                   vm.visibleSubChild[idx]=true;
                    vm.icon='icon-minus';
                break;
            }

        }


         function setView(nik) {
            $state.go('app.pms_idp_member',{id:nik});
        }

        function setViewD(nik) {
            $state.go('app.pms_idp_memberD',{id:nik});
        }

        
        // Data
        
        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.employe_apraisal', [])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
      // Translation
        // $translatePartialLoaderProvider.addPart('app/main/pms/emp-apraisal');

        // State
        $stateProvider
            .state('app.pms_employe_apraisal', {
                url    : '/pms/employe-apraisal',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/emp-apraisal/index.html',
                        controller : 'EmployeApraisalController as vm'
                    }
                }
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.employe_apraisal')
        .controller('EmployeApraisalController', EmployeApraisalController);


    EmployeApraisalController.$inject=['$state','$window','$localStorage','$location','$document','$mdDialog','AppAPI','DataService','config','Auth','Form'];
    /** @ngInject */
    function EmployeApraisalController($state,$window,$localStorage,$location,$document,$mdDialog,AppAPI,DataService,config,Auth,Form)

    {
        var vm = this;
        // initial form
        Form.initialForm();

        var EMP = AppAPI.EmployeApraisal();
        var Attendancereport=AppAPI.Attendancereport();
        
        Form.setObject(EMP);

        // set form to controller
        vm.Form = Form;

        vm.listJum =[2,5,25,50,75,100,200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.setQuarter = setQuarter

        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;
        vm.loadSubArea=loadSubArea;

        vm.company='';
        vm.groupLogin=$localStorage.group;
        vm.user=$localStorage.user;
        vm.eCheckin=false;
        vm.viewEcheckin=false;
        vm.divisi='all';
        vm.department='all';
        vm.divdeptdisabled=false;
        vm.upload=true;
        vm.exportToExcel = exportToExcel

        vm.Breadhome="app.pms";
        vm.Breadlist=[
            {
                link:'#',
                name:'TA / ',
                active:'0'
            }
        ];

        vm.typeEmp = [
          {
            "view"  : "Staff",
            "value" : "SAP"
          },
          {
            "view"  : "General Worker",
            "value" : "HRIS"
          }
        ];

        loadData(1);
        loadDataBU();
        loadSubArea();

        function loadData(pageno)
        {
          vm.DataTable.loadData(EMP,pageno,{action:'viewdata',company:vm.company,divisi:vm.divisi,department:vm.department,echeckin:vm.viewEcheckin,subarea:vm.subarea,emptype:vm.employeeType});
        }

        function setQuarter(ev,data)
        {

            $mdDialog.show({
                controller         : 'EditEmployeApraisalController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/pms/emp-apraisal/edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  data:data
                }
            });
        }

        function loadDataBU() {
            var response=Attendancereport.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU=data;
        }

        function errorFetchBU() {
            vm.listBU=[];
        }

        function loadDataDivision(idbu) {
            var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
           vm.listDivision=data;
        }

        function errorDivisiBU() {
            vm.listDivision=[];
        }

        function loadDataDepartment(iddivisi) {
            var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment=data;
        }

        function errorDepartment() {
            vm.listDepartment=[];
        }

        function  loadSubArea()
        {
            var response=Attendancereport.query({action:'viewSubArea'});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
            vm.subArea=data;
        }

        function errorfetchArea(data)
        {
            vm.subArea=[];
        }

        function exportToExcel(ev) {
            $mdDialog.show({
                controller         : 'DownloadEmployeApraisalController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/pms/emp-apraisal/download.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.pms.employe_apraisal')
        .controller('EditEmployeApraisalController', EditEmployeApraisalController);

    EditEmployeApraisalController.$inject = ['$localStorage','$timeout','$mdDialog','Form','AppAPI','config','FileUploader','data'];

    /* @ngInject */
    function EditEmployeApraisalController($localStorage,$timeout,$mdDialog,Form,AppAPI,config,FileUploader,data) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        var Helpdesk=AppAPI.EmployeApraisal();

        // set constructor form
        Form.initialForm();
        Form.setObject(Helpdesk);
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.Form.objForm.data = data

        vm.notif = {
          success: false,
          error: false
        }
        vm.messageTheme='green';

        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formControl) {
          angular.element.blockUI();
          // var promise = Form.updateData('update',formControl,Helpdesk,formControl.id);
          var promise= Form.saveData('update',formControl, Helpdesk);
            promise.then(function(response){
                if ( response.error ) {
                  vm.notif.error = response.pesan;
                  vm.notif.success = false;
                  vm.messageTheme='pink';
                } else {
                  vm.notif.error = false;
                  vm.notif.success = response.pesan;
                  vm.messageTheme='green';
                }
              formControl.$setPristine();
              $timeout(function() {
                vm.notif.error=false; 
                vm.notif.success=false;
                closeModal(); 
              }, 3000);
              angular.element.unblockUI();
            })
            .catch(function (response) {
              vm.notif.error = 'Internal server error'
              vm.notif.success = false;
              vm.messageTheme='pink';
              angular.element.unblockUI();
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent()
            ).then(function(){
                closeModal();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.pms.employe_apraisal')
        .controller('DownloadEmployeApraisalController', DownloadEmployeApraisalController);

    DownloadEmployeApraisalController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','FileUploader','config','Auth','$window','$location'];

    /* @ngInject */
    function DownloadEmployeApraisalController($localStorage,$mdDialog,Form,AppAPI,$log,FileUploader,config,Auth,$window,$location) {
      var vm = this;
      Form.initialForm();

      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      var Attendancereport=AppAPI.Attendancereport();
      vm.company=$localStorage.empsite;
      vm.groupLogin=$localStorage.group;
      vm.download=download;
      vm.closeModal=closeModal;
      vm.typeEmp = [
        {
          "view"  : "Staff",
          "value" : "SAP"
        },
        {
          "view"  : "General Worker",
          "value" : "HRIS"
        }
      ];

      loadDataBU();
      loadDataDivision(vm.company);

      vm.divisi='all';
      vm.department='all';
      vm.listStatus=['active','non active'];
      vm.typeContract=['contract','permanent'];
      vm.empApraisalType = ''

      //////////////////////////


      function closeModal() {
        $mdDialog.hide();
      }


      function loadDataDepartment(iddivisi) {
           var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
          vm.listDepartment=data;

          // loadData(1);
        }

        function errorDepartment() {
          vm.listDepartment=[];
        }

        function loadDataDivision(idbu) {
           var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
          response.$promise.then(fetchDivisiBU);
          response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
         vm.listDivision=data;
         // vm.listDivision.push(data);
         // loadData(1);
        }

        function errorDivisiBU() {
          vm.listDivision=[];
        }

        function loadDataBU() {
          var response=Attendancereport.query({action:'viewBu'});
          response.$promise.then(fetchBU);
          response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
          vm.listBU=data;
        }

        function errorFetchBU() {
          vm.listBU=[];
        }

        function download()
        {

          var company=vm.company;
          var divisi=vm.divisi;
          var department=vm.department;
          var startrange=vm.startrange;
          var endrange=vm.endrange;
          var status='';
          var startRangeJoin='';
          var endRangeJoin='';
          var contract='';
          var empType = '';
          var empApraisalType = vm.empApraisalType;

          if(divisi !=='all')
          {
           var company=company+divisi;
          }

          if(department !=='all')
          {
           var company = company+department;
          }

          if(typeof(startrange) !=='undefined' && typeof(endrange) !=='undefined')
          {
            var d1=new Date(startrange);
            var d2=new Date(endrange);
            var d1M=(d1.getMonth()+1);
            var d2M=(d2.getMonth()+1);
            var d1D=d1.getDate();
            var d2D=d2.getDate();
            if(d1M <10)
            {
                d1M='0'+d1M;
            }
            if(d2M < 10)
            {
               d2M='0'+d2M;
            }

            if(d1D < 10)
            {
              d1D='0'+d1D;
            }

            if(d2D < 10)
            {
              d2D='0'+d2D;
            }
            var startRangeJoin=d1.getFullYear()+'-'+d1M+'-'+d1D;
            var endRangeJoin=d2.getFullYear()+'-'+d2M+'-'+d2D;
          }

          if(typeof(vm.status) !=='undefined')
          {
             status=vm.status;
          }

          if(typeof(vm.contract) !=='undefined')
          {
             contract=vm.contract;
          }

          if (typeof vm.employeeType !== "undefined") {
            empType = vm.employeeType;
          }

          var token=Auth.setTokenPromise();
              token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
              $window.open(protocol+'://'+host+config.api+'api/employeapraisal/exportexcel?company='+company+'&startRangeJoin='+startRangeJoin+'&endRangeJoin='+endRangeJoin+'&status='+status+'&contract='+contract+'&empType='+empType+'&empApraisalType='+empApraisalType+'&token='+data.token, '_blank');
              },function(){
                $window.alert('gagal load token');
              });
        }



      function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.emp_potential', ['app.pms.emp_potential.set-emp-potential-member'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_emp_potential', {
                url    : '/pms/emp-potential',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/emp-potential/emp-potential.html',
                        controller : 'EmpPotentialController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.emp_potential')
        .controller('EmpPotentialController', EmpPotentialController);


    EmpPotentialController.$inject=['DataService','$state','$localStorage','AppAPI','DTColumnDefBuilder','$mdDialog'];
    /** @ngInject */
    function EmpPotentialController(DataService,$state,$localStorage,AppAPI,DTColumnDefBuilder,$mdDialog)
    {
        
        var vm             = this;
        var EmpPotential     = AppAPI.EmpPotential();

        vm.username        = $localStorage.nama;
        vm.user            = $localStorage.user;
        vm.setView         = setView;
        vm.setViewD        = setViewD;                 
        vm.loadData        = loadData;
        vm.icon            = "icon-plus";
        vm.result          = false;
        vm.toogleSubChild  = toogleSubChild;
        vm.visibleSubChild = [];
        vm.DataTable       = new DataService();
        vm.period = new Date().getFullYear();
        vm.periodLists     = [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035];

        loadData(1);


        function loadData(pageno) {          

            vm.DataTable.loadData(EmpPotential,pageno,{action:'viewdata',id:vm.user, period: vm.period});

        }

        function toogleSubChild(idx) {

            var response = EmpPotential.query({
                action: 'viewdata',
                id: vm.DataTable.list[idx].nik
            });
            response.$promise.then(function (data) {

                var listAnak = data[0].aData;

                if (listAnak.length > 0) {
                    vm.DataTable.list[idx].listAnak = listAnak;

                    switch (vm.visibleSubChild[idx]) {
                        case true:
                            vm.visibleSubChild[idx] = false;
                            vm.icon = 'icon-minus';
                            break;
                        case false:
                            vm.visibleSubChild[idx] = true;
                            vm.icon = 'icon-plus';
                            break;
                        default:
                            vm.visibleSubChild[idx] = true;
                            vm.icon = 'icon-minus';
                            break;
                    }

                }

            });
            response.$promise.catch(function (data) {
                $log.info(data);
            });            

        }


         function setView(nik) {
            $state.go('app.pms_emp_potential_set_potential_member',{id:nik});
        }

        function setViewD(nik) {
            $state.go('app.pms_emp_potential_set_potential_member',{id:nik});
        }

        
        // Data
        
        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.competency', ['app.utility.modules.input-modules'
        ])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
        .state('app.pms_competency', {
            url    : '/pms/competency',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/competency/competency.html',
                    controller : 'CompetencyController as vm'
                }
            }
        });


    }

})();
(function() {
    'use strict';

    angular
        .module('app.pms.competency')
        .controller('UploadEmpJobCodeController', UploadEmpJobCodeController);

    UploadEmpJobCodeController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadEmpJobCodeController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        ////////////////

       

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/empjobcode/uploadempjobcode',
           removeAfterUpload:true,
           alias:'fileempjobcode',
           formData:[
              {
               action:'uploadempjobcode'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.emp_job_code', ['app.pms.emp_job_code.input-emp-job-code'
        ])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
        .state('app.pms_emp_job_code', {
            url    : '/pms/emp_job_code',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/emp-job-code/emp-job-code.html',
                    controller : 'EmpJobCodeController as vm'
                }
            }
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.pms.emp_job_code')
        .controller('EmpJobCodeController', EmpJobCodeController);

    EmpJobCodeController.$inject=['$state','$log','$localStorage','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function EmpJobCodeController($state,$log,$localStorage,$mdDialog,AppAPI,Auth,DataService, $document) {

       var Group               = AppAPI.Group();
       var EmpJobCode          = AppAPI.EmpJobCode();
       var vm                  = this;
       vm.listJum              = [2,5,25,50,75,100,200];
       vm.DataTable            = new DataService();
       vm.loadData             = loadData;
       vm.modulesAction        = modulesAction;
       vm.toggleSelectedAll    = toggleSelectedAll;
       vm.listModulSelected    = [];
       vm.setJobCode           = setJobCode;
       vm.openUploadEmpJobCode = openUploadEmpJobCode;
       vm.bu                   = '';
       vm.divisi               = '';
       vm.department           = '';
       vm.empsite              = $localStorage.empsite;
       vm.group                = $localStorage.group;
       vm.loadDataDivision     = loadDataDivision;
       vm.loadDataDepartment   = loadDataDepartment;
       vm.Breadhome            = "app.pms_emp_job_code";
       vm.Breadlist            = [
            {link:'#',name:'EmpJobCode',active:'0'}
        ];

        var response = Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
            vm.listGroupSelect=data;
        });

        response.$promise.catch(function(data){
            $log.info(data);
        });

        loadData(1);
        loadDataBU();

        function loadData(pageno){
           vm.DataTable.loadData(EmpJobCode,pageno,{action:'viewData',bu:vm.bu,divisi:vm.divisi,department:vm.department});
        }

        function loadDataBU() {
            var response=EmpJobCode.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBu=data;

            if(vm.group === '110' || vm.group === '116' || vm.group === '118') {
                vm.bu = vm.empsite;
                loadDataDivision(vm.bu);
            }

        }

        function errorFetchBU() {
            vm.listBu=[];
        }

        function loadDataDivision(idbu) {

            vm.divisi='';
            vm.department='';
            var response=EmpJobCode.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
           vm.listDivisi=data;
           vm.listDepartment=[];
           loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivisi=[];
        }

        function loadDataDepartment(iddivisi) {
            vm.department='';
            var response=EmpJobCode.query({action:'viewDivisiDept',idbu:vm.bu,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment=data;
            loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment=[];
        }
        
        function openUploadEmpJobCode(ev) {
            $mdDialog.show({
                controller         : 'UploadEmpJobCodeController as vm',
                templateUrl        : 'app/main/pms/emp-job-code/upload-emp-job-code.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
            vm.listModulSelected=angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listModulSelected=[];
        } 

        function modulesAction(id){
            // console.log(id);
            $state.go('app.utility_modules_modules-action',{id:id});
        }

        function setJobCode(ev, data)
        {

            $mdDialog.show({
                controller: 'InputEmpJobCodeController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/emp-job-code/input-emp-job-code/input-emp-job-code.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    data: data                   
                },
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.pms.edp', ['app.pms.edp.set_edp_member'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_edp', {
                url    : '/pms/edp',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/edp/edp.html',
                        controller : 'EdpController as vm'
                    }
                }
            });

       
        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/pms/edp/edp-member');
        // Navigation
  /*  msNavigationServiceProvider.saveItem('pms', {
        title : 'PMS',
        group : true,
        weight: 1,
        hidden:function(){return false;}
    });
    // Apps.Dashboards
    msNavigationServiceProvider.saveItem('pms.dashboard', {
         title    : 'Dashboard',
            icon     : 'icon-tile-four',
            state    : 'app.pms_dashboard',
            weight   : 1,
             hidden:function(){return false;}
    });
       */

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.edp')
        .controller('EdpController', EdpController);


    EdpController.$inject=['DataService','$state','$localStorage','AppAPI','DTColumnDefBuilder','$mdDialog'];
    /** @ngInject */
    function EdpController(DataService,$state,$localStorage,AppAPI,DTColumnDefBuilder,$mdDialog)
    {
        
        var vm             = this;
        var teamMember     = AppAPI.Edp();

        vm.username        = $localStorage.nama;
        vm.user            = $localStorage.user;
        vm.setView         = setView;
        vm.setViewD        = setViewD;                 
        vm.loadData        = loadData;
        vm.icon            = "icon-plus";
        vm.result          = false;
        vm.toogleSubChild  = toogleSubChild;
        vm.visibleSubChild = [];
        vm.DataTable       = new DataService();

        loadData(1);


        function loadData(pageno) {          

        vm.DataTable.loadData(teamMember,pageno,{action:'viewdata',id:vm.user});

        }

        function toogleSubChild(idx) {
            switch(vm.visibleSubChild[idx])
            {
                case true :
                vm.visibleSubChild[idx]=false;
                vm.icon='icon-minus';
                break;
                case false :
                vm.visibleSubChild[idx]=true;
                 vm.icon='icon-plus';
                break;
                default:
                   vm.visibleSubChild[idx]=true;
                    vm.icon='icon-minus';
                break;
            }

        }


         function setView(nik) {
            $state.go('app.pms_edp_member',{id:nik});
        }

        function setViewD(nik) {
            $state.go('app.pms_edp_memberD',{id:nik});
        }

        
        // Data
        
        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.ebook', ['app.pms.ebook_view'
        ])
        .config(config);

    config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
        // State
        $stateProvider
        .state('app.pms_ebook', {
            url    : '/pms/ebook',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/ebook/ebook.html',
                    controller : 'EbookController as vm'
                }
            }
        });

        // $stateProvider
        // .state('app.pms_ebook_view', {
        //     url    : '/pms/ebook_view/:id/:url',
        //     views  : {
        //         'content@app': {
        //             templateUrl: 'app/main/pms/ebook/ebook-view.html',
        //             controller : 'EbookViewController as vm'
        //         }
        //     }
        // });

        // $translatePartialLoaderProvider.addPart('app/main/pms/competency');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.pms.ebook')
        .controller('EbookController', EbookController);

    EbookController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function EbookController($state,$log,$mdDialog,AppAPI,Auth,DataService, $document) {
        
        var vm = this;
        vm.ebookLists = [
            {
                id: 1,
                title: 'System Of Reference : Job Codes & Competencies',
                subtitle: 'v1.0',
                cover: '1.SystemofReference_JobCodesandCompetencies_EngV1.0.jpg',
                cover_height: '350px',
                url: btoa('1.SystemofReference_JobCodesandCompetencies_EngV1.0.pdf')
            },
            {
                id: 2,
                title: 'Levels of Proficiency : Nabati Competencies',
                subtitle: 'v1.0',
                cover: '2.LevelsofProficiency_NabatiCompetencies_EngV1.0.jpg',
                cover_height: '350px',
                url: btoa('2.LevelsofProficiency_NabatiCompetencies_EngV1.0.pdf')
            },
            {
                id: 3,
                title: 'Competency Profiles',
                subtitle: 'v1.0',
                cover: '3.CompetencyProfile_JobCodeandCompetencies_EngV1.0.jpg',
                cover_height: '350px',
                url: btoa('3.CompetencyProfile_JobCodeandCompetencies_EngV1.0.pdf')
            }
        ];

    }


 })();
(function () {
    'use strict';

    angular
        .module('app.pms.ebook')
        .controller('EbookViewController', EbookViewController);

    EbookViewController.$inject=['$state','$stateParams','$log','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function EbookViewController($state,$stateParams,$log,$mdDialog,AppAPI,Auth,DataService, $document) {
        
        var vm = this;

        vm.url = 'assets/ebook/'+atob($stateParams.url)+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';        


    }


 })();
(function ()
{
    'use strict';

    angular
        .module('app.pms.dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_dashboard', {
                url    : '/pms/dashboard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/dashboard/dashboard.html',
                        controller : 'DashboardController as vm'
                    }
                }
            });

       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/pms/dashboard');
        // Navigation
  /*  msNavigationServiceProvider.saveItem('pms', {
        title : 'PMS',
        group : true,
        weight: 1,
        hidden:function(){return false;}
    });
    // Apps.Dashboards
    msNavigationServiceProvider.saveItem('pms.dashboard', {
         title    : 'Dashboard',
            icon     : 'icon-tile-four',
            state    : 'app.pms_dashboard',
            weight   : 1,
             hidden:function(){return false;}
    });
       */

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.dashboard')
        .controller('DashboardController', DashboardController);


    DashboardController.$inject=['$state','$localStorage','AppAPI','DTColumnDefBuilder','$mdDialog'];
    /** @ngInject */
    function DashboardController($state,$localStorage,AppAPI,DTColumnDefBuilder,$mdDialog)
    {
        
        var vm=this;
        console.log('$localStorage', $localStorage);
        vm.username=$localStorage.nama; 
        vm.user=$localStorage.user;
        // console.log('asdasdasdaa');
 

        // Data
        
        // Methods

        //////////
 
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.cr_progress', ['app.pms.cr_progress.set-team-all'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_cr_progress', {
                url    : '/pms/cr-progress',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/cr-progress/cr-progress.html',
                        controller : 'CrProgressController as vm'
                    }
                }
            });
    }
})();
(function() {
    'use strict';
    angular.module('app.pms.cr_progress').controller('CrProgressController', CrProgressController);
    CrProgressController.$inject = ['DataService', '$state', '$window', '$localStorage', '$location', 'AppAPI', 'DTColumnDefBuilder', '$mdDialog', 'Auth', 'config'];
    /** @ngInject */
    function CrProgressController(DataService, $state, $window, $localStorage, $location, AppAPI, DTColumnDefBuilder, $mdDialog, Auth, config) {
        var vm                = this;
        var KPI               = AppAPI.CrProgress();
        vm.username           = $localStorage.nama;
        vm.user               = $localStorage.user;
        vm.empsite            = $localStorage.empsite;
        vm.group              = $localStorage.group;
        vm.listJum            = [2, 5, 25, 50, 75, 100, 200];
        vm.setView            = setView;
        vm.DataTable          = new DataService();
        vm.loadData           = loadData;
        vm.loadDataDivision   = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.bu                 = '';
        vm.divisi             = '';
        vm.department         = '';        
        vm.ExporttoExcel      = ExporttoExcel;

        loadData(1);
        loadDataBU();

        function loadData(pageno) {
            var CrProgress = AppAPI.CrProgress();
            vm.DataTable.loadData(CrProgress, pageno, {
                action: 'viewdataall',
                id: 0,
                bu: vm.bu,
                divisi: vm.divisi,
                department: vm.department
            });
        }

        function setView(nik) {
            $state.go('app.pms_kpi_nabati_set_team_all', {
                id: nik
            });
        }

        function loadDataDivision(idbu) {
            vm.divisi = '';
            vm.department = '';
            var response = KPI.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivisi = data;
            vm.listDepartment = [];
            loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivisi = [];
        }

        function loadDataBU() {
            var KPI = AppAPI.CrProgress();
            var response = KPI.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBu = data;

            if(vm.group === '110' || vm.group === '116') {
                vm.bu = vm.empsite;
                loadDataDivision(vm.bu);
            }
        }

        function errorFetchBU() {
            vm.listBu = [];
        }
        // Data
        // Methods
        function loadDataDepartment(iddivisi) {
            vm.department = '';
            var response = KPI.query({
                action: 'viewDivisiDept',
                idbu: vm.bu,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function fetchDivisiBU(data) {
            vm.listDivisi = data;
            loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivisi = [];
        }

        function ExporttoExcel() {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var bu = "-";
            var divisi = "-";
            var department = "-";
            if (vm.bu !== "") {
                bu = vm.bu;
            }
            if (vm.divisi !== "") {
                divisi = vm.divisi;
            }
            if (vm.department !== "") {
                department = vm.department;
            }
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/crprogress/crexportexcel/' + bu + '/' + divisi + '/' + department + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
            // console.log(vm.bu+'  /   '+vm.divisi+'   /  '+vm.department);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.competency_team', ['app.pms.competency_team.set-competency-review-member'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_competency_team', {
                url    : '/pms/competency-team',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/competency-team/competency-team.html',
                        controller : 'CompetencyTeamController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.competency_team')
        .controller('CompetencyTeamController', CompetencyTeamController);


    CompetencyTeamController.$inject=['DataService','$state','$localStorage','AppAPI','DTColumnDefBuilder','$mdDialog', '$log'];
    /** @ngInject */
    function CompetencyTeamController(DataService,$state,$localStorage,AppAPI,DTColumnDefBuilder,$mdDialog, $log)
    {
        
        var vm             = this;
        var CompetencyTeam     = AppAPI.CompetencyTeam();

        vm.username        = $localStorage.nama;
        vm.user            = $localStorage.user;
        vm.setView         = setView;
        vm.setViewD        = setViewD;                 
        vm.loadData        = loadData;
        vm.icon            = "icon-plus";
        vm.result          = false;
        vm.toogleSubChild  = toogleSubChild;
        vm.visibleSubChild = [];
        vm.DataTable       = new DataService();

        loadData(1);


        function loadData(pageno) {          

            vm.DataTable.loadData(CompetencyTeam,pageno,{action:'viewdata',id:vm.user});

        }

        function toogleSubChild(idx) {

            var response = CompetencyTeam.query({
                action: 'viewdata',
                id: vm.DataTable.list[idx].nik
            });
            response.$promise.then(function (data) {
                
                var listAnak = data[0].aData;

                console.log('listAnak', listAnak);

                if (listAnak.length > 0) {
                    vm.DataTable.list[idx].listAnak = listAnak;

                    switch (vm.visibleSubChild[idx]) {
                        case true:
                            vm.visibleSubChild[idx] = false;
                            vm.icon = 'icon-minus';
                            break;
                        case false:
                            vm.visibleSubChild[idx] = true;
                            vm.icon = 'icon-plus';
                            break;
                        default:
                            vm.visibleSubChild[idx] = true;
                            vm.icon = 'icon-minus';
                            break;
                    }

                }                                
                
            });
            response.$promise.catch(function (data) {
                $log.info(data);
            });            

        }


         function setView(nik) {
            $state.go('app.pms_competency_team_set_competency_review_member',{id:nik});
        }

        function setViewD(nik) {
            $state.go('app.pms_competency_team_set_competency_review_member',{id:nik});
        }

        
        // Data
        
        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.competency_review', ['app.pms.competency_review.input-competency-review'])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
        .state('app.pms_competency_review', {
            url    : '/pms/competency_review',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/competency-review/competency-review.html',
                    controller : 'CompetencyReviewController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pms.competency_review')
        .controller('CompetencyReviewController', CompetencyReviewController);

    CompetencyReviewController.$inject=['$state','$log','$mdDialog','$mdToast','AppAPI','Auth','DataService', '$document', 'Form'];
    /** @ngInject */
    function CompetencyReviewController($state,$log,$mdDialog,$mdToast,AppAPI,Auth,DataService, $document, Form) {
        
        var vm               = this;     
        var CompetencyReview = AppAPI.CompetencyReview();    
        vm.Breadhome         = "app.pms_competency_review";
        vm.Breadlist         = [
            {link:'#', name:'Competency Review', active:'0'}
        ];
        vm.inputData = inputData;
        vm.cr = {};
        vm.career_aspiration = (typeof(vm.cr.career_aspiration) !== 'undefined')?vm.cr.career_aspiration:'';
        vm.saveAspirationData = saveAspirationData;
        vm.remaining = 0;

        Form.initialForm();
        Form.setObject(CompetencyReview);
        vm.setToken=Auth.setToken;
        vm.Form = Form;

        loadData();

        function loadData() {
           angular.element.blockUI();
           var dataPromise = CompetencyReview.query({action:'get_jobcodeprofile'});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {

            if(typeof(data[0]) !== 'undefined') {
                vm.job_code = data[0].job_code;
            }
            
            vm.remaining = data.length;
            
            vm.listInput = [];
            var group_tmp = '';
            for(var i = 0; i <= (data.length - 1); i++) {
                if(group_tmp !== data[i].competency_category_id) {
                    if(typeof(vm.listInput[data[i].competency_category_id]) !== undefined) {
                        vm.listInput[data[i].competency_category_id] = {
                            category_id: data[i].competency_category_id,
                            category_name: data[i].competency_category_name,
                            details: []
                        };
                    }
                }
                group_tmp = data[i].competency_category_id;
            }

            for(var ii = 0; ii <= (data.length - 1); ii++) {                
                if(typeof(vm.listInput[data[ii].competency_category_id]) !== undefined) {
                    if(data[ii].self_level !== null) {
                        vm.remaining -= 1;
                    }
                    vm.listInput[data[ii].competency_category_id].details.push(data[ii]);                    
                }
            }

            vm.totalResult = 0;
            angular.forEach(vm.listInput,function(obj){
               vm.totalResult += obj.result;
            });
            //angular.element.unblockUI();
            loadCompetencyReviewData();
        }

        function errorFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadCompetencyReviewData() {
           angular.element.blockUI();
           var dataPromise = CompetencyReview.query({action:'getCompetencyReviewData'});
           dataPromise.$promise.then(fetchCompetencyReviewData);
           dataPromise.$promise.catch(errorFetchCompetencyReview); 
        }

        function fetchCompetencyReviewData(data) {
            if(typeof(data[0]) !== 'undefined') {
                vm.cr = data[0];
                vm.career_aspiration = vm.cr.career_aspiration;
            }
            angular.element.unblockUI();
        }

        function errorFetchCompetencyReview() {
            vm.cr = {};
            angular.element.unblockUI();
        }

        function saveAspirationData(ev,formController) {        

            vm.Form.objForm.career_aspiration   = vm.career_aspiration;
            vm.Form.objForm.job_code   = vm.job_code;

            var promise = Form.saveData('saveAspiration', formController, CompetencyReview);

            promise.then(successSaveAspirationData);
            promise.catch(failedSaveAspirationData);

        }

        function successSaveAspirationData() {
            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.Form.pesan)
                .position('top right')
                .hideDelay(3000)
                .theme("success-toast")
            );
        }

        function failedSaveAspirationData() {
            vm.messageTheme='red';
        }

        function inputData(ev, input)
        {
      
            $mdDialog.show({
                controller: 'inputCompetencyReviewController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/competency-review/input-competency-review/input-competency-review.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    listInput:vm.listInput,
                    input: input                   
                },
                onRemoving:function(element, removePromise)
                {
                    loadData();
                    //checkSelectedPeriod();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

    }

})();


(function() {
    'use strict';

    angular
        .module('app.pms.competency')
        .controller('UploadCompetencyController', UploadCompetencyController);

    UploadCompetencyController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadCompetencyController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        ////////////////

       

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/competency/uploadcompetency',
           removeAfterUpload:true,
           alias:'filecompetency',
           formData:[
              {
               action:'uploadcompetency'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pms.competency')
        .controller('CompetencyController', CompetencyController);

    CompetencyController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function CompetencyController($state,$log,$mdDialog,AppAPI,Auth,DataService, $document) {
        
        var Group            = AppAPI.Group();
        var Competency       = AppAPI.Competency();
        var vm               = this;
        vm.listJum           = [2,5,25,50,75,100,200];
        vm.DataTable         = new DataService();
        vm.loadData          = loadData;
        vm.modulesAction     = modulesAction;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listModulSelected = [];
        // vm.deleteModul       = deleteModul;
        vm.editData          = editData;        
        vm.Breadhome         = "app.pms_competency";
        vm.Breadlist         = [
            {link:'#',name:'Competency',active:'0'}
        ];

        var response = Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
            vm.listGroupSelect=data;
            // console.log(vm.listGroupSelect);
        });

        response.$promise.catch(function(data){
            $log.info(data);
        });

        // Data
        loadData(1);
        // Methods

        ////////// 

        function loadData(pageno){
           vm.DataTable.loadData(Competency,pageno,{action:'viewData'});
           // console.log('test');
        }

        vm.openUploadComeptency=openUploadComeptency;
        function openUploadComeptency(ev) {
            $mdDialog.show({
                controller         : 'UploadCompetencyController as vm',
                templateUrl        : 'app/main/pms/competency/upload-competency.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        // function loadData(pageno) {
        //  var response= Competency.query({action:'viewdata',search:vm.DataTable.searchParam});
        // response.$promise.then(function(data){
        //    vm.list=data;
        // });
        // response.$promise.catch(function(data){
        //   console.log(data);
        // });

        // }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

        function checkAll() {
            vm.listModulSelected=angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listModulSelected=[];
        } 

        function modulesAction(id){
            // console.log(id);
            $state.go('app.utility_modules_modules-action',{id:id});
        }

        function editData(id){
            // console.log(id);
            $state.go('app.pms_job_code_profile_edit',{id:id});
        }

    //     function deleteModul(ev) {
   
    //     var promise=Auth.setToken();
    //     promise.then(function(){
    //         var confirm = $mdDialog.confirm()
    //         .title('Would you like to delete this list?')
    //         .textContent('All data your selected will be deleted and can not recovered.')
    //         .ariaLabel('delete dialog')
    //         .targetEvent(ev)
    //         .ok('YES')
    //         .cancel('no');

    //         $mdDialog.show(confirm).then(function() {
    //             angular.element.blockUI();
    //             var response=Competency.delete({action:'delete',data:angular.toJson(vm.listModulSelected)});

    //             response.$promise.then(loadData(1)); 
    //         }, function() {
    //         // $scope.status = 'You decided to keep your debt.';
    //         });
    //     });
  
   
    // }

    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.pms.behaviour_performance_team', ['app.pms.behaviour_performance_team.set-behaviour'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_behaviour_performance_team', {
                url    : '/pms/behaviour-performance-team',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/behaviour-performance-team/behaviour-performance-team.html',
                        controller : 'BehaviourperformanceteamController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.behaviour_performance_team')
        .controller('BehaviourperformanceteamController', BehaviourperformanceteamController);


    BehaviourperformanceteamController.$inject=['$localStorage','AppAPI','$mdDialog','Form','Auth','DataService','$state'];
    /** @ngInject */
    function BehaviourperformanceteamController($localStorage,AppAPI,$mdDialog,Form,Auth,DataService,$state)
    {
        
         var vm=this;

        vm.username=$localStorage.nama;
        vm.user=$localStorage.user;
        
        vm.setView=setView;
        vm.setViewD=setViewD;
         var teamMember=AppAPI.Behivorteam();
        vm.DataTable= new DataService();

        vm.loadData=loadData;

        vm.icon = "icon-plus";
        vm.result = false;
        vm.toogleSubChild=toogleSubChild;
        vm.visibleSubChild=[];

        loadData(1);


         function loadData(pageno) {          

        vm.DataTable.loadData(teamMember,pageno,{action:'viewdata',id:vm.user});

        }

        function toogleSubChild(idx) {
            switch(vm.visibleSubChild[idx])
            {
                case true :
                vm.visibleSubChild[idx]=false;
                vm.icon='icon-minus';
                break;
                case false :
                vm.visibleSubChild[idx]=true;
                 vm.icon='icon-plus';
                break;
                default:
                   vm.visibleSubChild[idx]=true;
                    vm.icon='icon-minus';
                break;
            }

        }


         function setView(nik) {
            $state.go('app.pms_behaviour_performance_team_set_behaviour',{id:nik});
        }

        function setViewD(nik) {
            $state.go('app.pms_kpi_team_set_team_memberD',{id:nik});
        }
        
     
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pms.behaviour_performance')
        .controller('BehaviourperformanceController', BehaviourperformanceController);


    BehaviourperformanceController.$inject=['$localStorage','AppAPI','$mdDialog','Form','Auth'];
    /** @ngInject */
    function BehaviourperformanceController($localStorage,AppAPI,$mdDialog,Form,Auth)
    {
        
         var vm = this;
        vm.username=$localStorage.nama;
        vm.addData = addData;
        vm.editData = editData;

        var Behivor = AppAPI.Behivor();
        vm.loadData = loadData;
        vm.checkSelectedPeriod=checkSelectedPeriod;
        vm.showBehivor=showBehivor;

        loadConfig();
        checkSelectedPeriod();

        function checkSelectedPeriod()
        {
            angular.forEach(vm.listPeriod,function(obj){
               if(obj.effectiveDate===vm.currentDate)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }

        function showBehivor(rDate)
        {
           vm.currentDate=rDate;
           checkSelectedPeriod();
           loadData();
        }

        function loadData() {
           angular.element.blockUI();
           var dataPromise = Behivor.query({action:'viewinputdatasingle',rDate:vm.currentDate});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listInput = data;
            vm.totalResult = 0;
            angular.forEach(vm.listInput,function(obj){
               vm.totalResult += obj.result;
            });
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadConfig() {
           angular.element.blockUI();
           var dataPromise = Behivor.query({action:'viewconfigdata'});
           dataPromise.$promise.then(fetchConfig);
           dataPromise.$promise.catch(errorConfig); 
        }

        function fetchConfig(data) {
            vm.listPeriod = data;
            angular.forEach(vm.listPeriod,function(obj){
               vm.currentDate = obj.effectiveDate;
            });
            loadData(vm.currentDate);

            angular.element.unblockUI();
        }

        function errorConfig() {
            vm.listPeriod = [];
            angular.element.unblockUI();
        }

        function addData(ev)
        {
            $mdDialog.show({
                controller: 'inputbehaviourperformanceController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/behaviour-performance/input-behaviour/input-behaviour.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    listInput:vm.listInput,
                    effectiveDate:vm.currentDate
                },
                onRemoving:function(element, removePromise)
                {
                    loadData(vm.currentDate);
                    checkSelectedPeriod();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }
     
         function editData(ev,resultDate,id,resultA,resultB,resultC,resultD,resultDateAlias)
        {
            $mdDialog.show({
                controller   : 'editbehaviourperformanceController',
                controllerAs : 'vm',
                templateUrl  : 'app/main/pms/behaviour-performance/input-behaviour/input-behaviour.html',
                parent       : angular.element(document.body),
                targetEvent  : ev,
                clickOutsideToClose:true,
                locals : {
                    listInput:vm.listInput,
                    effectiveDate:vm.currentDate,
                    resultDate:resultDate,
                    resultDateAlias:resultDateAlias,
                     resultA:resultA,
                    resultB:resultB,
                    resultC:resultC,
                    resultD:resultD
                },
                onRemoving : function(element, removePromise)
                {
                    loadData(vm.currentDate);
                    checkSelectedPeriod();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }
        
     
    }
})();

(function() {
    'use strict';

    angular.module('app.pkwt').controller('ViewPkwtController', Controller);

    Controller.$inject = [
        'config',
        '$mdDialog',
        'AppAPI',
        'refData',
        '$window',
        '$location',
        'Auth',
        '$sce'
    ];
    /** @ngInject */
    function Controller(
        config,
        $mdDialog,
        AppAPI,
        reffData,
        $window,
        $location,
        Auth,
        $sce
    ) {
        var vm = this;
        var endpoint = AppAPI.PkwtManagementIr();
        vm.hide = hide;
        vm.data = reffData;
        vm.getUrl = getUrl;

        activate();

        function activate() {}

        function hide() {
            $mdDialog.hide();
        }

        function getUrl() {
            var protocol = $location.protocol();
            var host = $location.host();
            var url =
                protocol +
                '://' +
                host +
                config.port +
                config.api +
                'api/printhelper/printPkwt?id[]=' +
                vm.data.pkwt_detail_id;
            return $sce.trustAsResourceUrl(url);
        }
    }
})();

(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.salarycomponent', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_salarycomponent', {
                url    : '/new-payroll/salarycomponent',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/salarycomponent/salarycomponent.html',
                    controller : 'NewSalaryComponentController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.salarycomponent')
        .controller('NewSalaryComponentController', NewSalaryComponentController);

    NewSalaryComponentController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth', '$filter'];

    /* @ngInject */
    function NewSalaryComponentController(AppAPI,DataService,$mdDialog, Form, Auth, $filter) 
    {   
        var vm = this;
        var translate = $filter('translate');

        var basePath = 'app/main/payroll-new/salarycomponent';
        var SalaryComponent=AppAPI.NewSalaryComponent();
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.inputSalaryComponent= inputSalaryComponent;
        vm.lisSalaryComponentSelected=[];
        vm.DeleteSalaryComponent=DeleteSalaryComponent;
        vm.editSalaryComponent=editSalaryComponent;
        vm.listSalcom=[];

        loadData(1);

        function loadData(pageno) 
        {
            vm.DataTable.loadData(SalaryComponent,pageno,{action:'viewdata'});
        }

        function inputSalaryComponent(ev)
        {
            $mdDialog.show({
                    controller         : 'InputNewSalaryComponentController',
                    controllerAs       : 'vm',
                    templateUrl        : basePath+'/input-salarycomponent.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    }
                }); 
        }

        function editSalaryComponent(ev,id)
        {
            $mdDialog.show({
                controller         : 'EditNewSalaryComponentController',
                controllerAs       : 'vm',
                templateUrl        : basePath+'/input-salarycomponent.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    },
                locals:{
                    id:id
                    }
            });
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() 
        {
            vm.lisSalaryComponentSelected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() 
        {
            vm.lisSalaryComponentSelected=[];
        } 
       
        function closeModal()
        {
            $mdDialog.hide();
        }

        function DeleteSalaryComponent(ev) 
        { 
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note    = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes     = translate('PAYROLL.MESSAGE.YES');
            var no      = translate('PAYROLL.MESSAGE.NO');

            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function() 
                {
                    angular.element.blockUI();
                    var response=SalaryComponent.delete({action:'delete',data:angular.toJson(vm.lisSalaryComponentSelected)});

                    response.$promise.then(loadData);
                    response.$promise.catch(ErrDel);

                    loadData(1);
                }, function() {
                    // 
                });
            });

            function ErrDel()
            {
                alert("Sorry, Data can't delete. other transactions using this data");
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.salarycomponent')
        .controller('InputNewSalaryComponentController', InputNewSalaryComponentController);

    InputNewSalaryComponentController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$filter'];

    /* @ngInject */
    function InputNewSalaryComponentController($localStorage,$mdDialog,Form,AppAPI,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;
    
        Form.initialForm();

        var Salarycomponent= AppAPI.NewSalaryComponent();

        // set constructor form
        Form.setObject(Salarycomponent);

        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal; 
        vm.liststatus = ['Allowance', 'Deduction'];
        vm.listtype = ['Fix', 'Non Fix', 'System', 'Formula'];
        vm.listthp = ['Yes', 'No'];
        vm.saveData=saveData;
        vm.changeType = changeType;
        vm.LoadAllPayroll = LoadAllPayroll;

        vm.isAllEmpList = [
            {'value' : '1','label' : 'Yes'},
            {'value' : '0','label' : 'No'}
        ];

        LoadAllPayroll();
          
        function changeType(id)
        {
            document.getElementById('formula').style.backgroundColor = "white";
            if(id != 'Formula')
            {
                document.getElementById('formula').disabled = true;
                document.getElementById('formula').style.backgroundColor = "lightgrey";
            }else{
                document.getElementById('formula').disabled = false;
            }
        }

        function LoadAllPayroll()
        {
            var response=Salarycomponent.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) 
        {
            vm.listallpayroll=data;
        }

        function errorFetchAllPayroll() 
        {
            vm.listallpayroll=[];
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('save', formController, Salarycomponent);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(errorSave);
        }

        function errorSave()
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Error Save Data, Data already exist')
            .textContent('Save Data was Failed.')
            .ariaLabel('Data already exist')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status = translate(data.status);
            
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.salarycomponent')
        .controller('EditNewSalaryComponentController', EditNewSalaryComponentController);

    EditNewSalaryComponentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$filter'];

    /* @ngInject */
    function EditNewSalaryComponentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var Salarycomponent = AppAPI.NewSalaryComponent();

        // set constructor form
        Form.setObject(Salarycomponent);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.liststatus = ['Allowance', 'Deduction'];
        vm.listtype = ['Fix', 'Non Fix', 'System', 'Formula'];
        vm.listthp = ['Yes', 'No'];
        vm.saveData=saveData;

        vm.changeType = changeType;
        vm.LoadAllPayroll = LoadAllPayroll;
        vm.isAllEmpList = [
            {'value' : '1','label' : 'Yes'},
            {'value' : '0','label' : 'No'}
        ];
        LoadAllPayroll();

        function changeType(id)
        {
            if(id != 'Formula')
            {
                document.getElementById('formula').disabled = true;
                document.getElementById('formula').style.backgroundColor = "lightgrey";
            }else{
                 document.getElementById('formula').disabled = false;
                 document.getElementById('formula').style.backgroundColor = "white";
            }
        }

        function LoadAllPayroll()
        {
            var response=Salarycomponent.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) 
        {
            vm.listallpayroll=data;
        }

        function errorFetchAllPayroll() 
        {
            vm.listallpayroll=[];
        }
          
        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeData);

        function ChangeData(data)
        {
            if(data.type != 'Formula')
            {
                document.getElementById('formula').disabled = true;
                document.getElementById('formula').style.backgroundColor = "lightgrey";
            }
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, Salarycomponent);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
               ShowFailed(ev,data);   
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status = translate(data.status);
           
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) 
        {
            var message = translate(data.pesan);
            var status = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.pkwt').controller('PkwtRulesController', Controller);

    Controller.$inject = [
        'config',
        '$mdDialog',
        'AppAPI',
        '$window',
        '$location',
        'Auth',
        'DataService'
    ];
    /** @ngInject */
    function Controller(
        config,
        $mdDialog,
        AppAPI,
        $window,
        $location,
        Auth,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.PkwtManagementTa();
        vm.DataTables = new DataService();
        vm.hide = hide;
        vm.isLoading = false;
        vm.DataTables.jumDataPerPage = 5;
        vm.DataTables.list = [];
        vm.loadData = loadData;
        vm.showFormDialog = showFormDialog;
        vm.showFormCreateDialog = showFormCreateDialog;
        vm.deleteRules = deleteRules;

        activate();

        function activate() {
            loadData(1);
        }

        function hide() {
            $mdDialog.hide();
        }

        function loadData(pageNo) {
            vm.isLoading = true;
            vm.DataTables.loadData(endpoint, pageNo, {
                action: 'getLoaRules'
            }).then(function() {
                vm.isLoading = false;
            });
        }

        function showFormDialog(ev, ref) {
            $mdDialog
                .show({
                    controller: 'PkwtRulesFormController as vm',
                    templateUrl:
                        'app/main/pkwt/pkwt-rules/pkwt-rules-form/pkwt-rules-form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    multiple: true,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        REF_DATA: ref
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function showFormCreateDialog(ev) {
            $mdDialog
                .show({
                    controller: 'PkwtRulesCreateController as vm',
                    templateUrl:
                        'app/main/pkwt/pkwt-rules/pkwt-rules-create/pkwt-rules-create.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    multiple: true,
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                .then(function() {
                    loadData(1);
                });
        }

        function deleteRules(ev, item) {
            var response = Auth.setToken();
            console.log(item);
            response.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Confirmation')
                    .textContent(
                        'Do you want to delete ' +
                            item.positionID +
                            ' | ' +
                            item.grade +
                            ' ?'
                    )
                    .ariaLabel('confirmation')
                    .targetEvent(ev)
                    .multiple(true)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(function() {
                    var request = endpoint.save({
                        action: 'deleteLoaRules',
                        positionID: item.positionID,
                        grade: item.grade
                    });

                    request.$promise.then(function(res) {
                        $mdDialog
                            .show(
                                $mdDialog
                                    .alert()
                                    .parent(angular.element(document.body))
                                    .clickOutsideToClose(true)
                                    .title('Success')
                                    .multiple(true)
                                    .textContent(res.message)
                                    .ariaLabel('Alert Dialog Demo')
                                    .ok('OK')
                                    .targetEvent(ev)
                            )
                            .then(function() {
                                loadData(1);
                            });
                    });
                    request.$promise.catch(function(err) {
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Failed')
                                .multiple(true)
                                .textContent(err.data.message)
                                .ariaLabel('Alert Dialog Demo')
                                .ok('OK')
                                .targetEvent(ev)
                        );
                        loadData(1);
                    });
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.pkwt').controller('PkwtViewMoreController', Controller);

    Controller.$inject = ['$mdDialog', 'refData', '$scope'];
    /** @ngInject */
    function Controller($mdDialog, refData, $scope) {
        var vm = this;
        vm.hide = hide;
        vm.data = refData;
        vm.numPages = numPages;
        vm.filtered = [];
        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.totalItems = vm.data.length;

        activate();

        function activate() {
            $scope.$watch('vm.currentPage + vm.numPerPage', function() {
                var begin = (vm.currentPage - 1) * vm.numPerPage;
                var end = begin + vm.numPerPage;
                vm.filtered = vm.data.slice(begin, end);
            });
        }

        function hide() {
            $mdDialog.hide();
        }

        function numPages() {
            return Math.ceil(vm.data.length / vm.numPerPage);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.pkwt').controller('PkwtUploadController', Controller);

    Controller.$inject = [
        'config',
        '$mdDialog',
        'AppAPI',
        '$window',
        '$location',
        'Auth',
        'FileUploader',
        '$localStorage'
    ];
    /** @ngInject */
    function Controller(
        config,
        $mdDialog,
        AppAPI,
        $window,
        $location,
        Auth,
        FileUploader,
        $localStorage
    ) {
        var vm = this;
        vm.hide = hide;
        vm.messages = '';
        vm.isUploaded = false;
        vm.detail = [];
        vm.viewMore = viewMore;

        activate();

        function activate() {}

        function hide() {
            $mdDialog.hide();
        }

        function viewMore(ev) {
            $mdDialog.show({
                controller: 'PkwtViewMoreController as vm',
                templateUrl: 'app/main/pkwt/pkwt-upload/view-more.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    refData: vm.detail
                }
            });
        }

        vm.uploadFile = new FileUploader({
            url: config.api + 'api/pkwt/pkwtmanagementta/upload',
            removeAfterUpload: true,
            alias: 'file',
            formData: [
                {
                    action: 'upload'
                }
            ],
            onAfterAddingAll: function() {
                vm.isUploaded = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.uploadFile.onSuccessItem = function(item) {
            var obj = JSON.parse(item._xhr.response);
            vm.messages = 'Success : ' + obj.success + ' Errors ' + obj.errors;
            vm.detail = obj.details;
            vm.isUploaded = true;
            angular.element('#uploaderPhoto').val('');
        };

        vm.uploadFile.onErrorItem = function(item) {
            console.log(item);
            var obj = JSON.parse(item._xhr.response);
            vm.messages = obj;
            vm.isUploaded = true;
        };
    }
})();

(function() {
    'use strict';

    angular.module('app.pkwt').controller('PkwtFormController', Controller);

    Controller.$inject = [
        '$state',
        '$mdDialog',
        'AppAPI',
        'REF_DATA',
        'IS_EDIT',
        'FROM_DIALOG',
        'Auth',
        '$timeout',
        '$scope'
    ];
    /** @ngInject */
    function Controller(
        $state,
        $mdDialog,
        AppAPI,
        REF_DATA,
        IS_EDIT,
        FROM_DIALOG,
        Auth,
        $timeout,
        $scope
    ) {
        var vm = this;
        var endpoint = AppAPI.PkwtManagementIr();
        vm.pkwtTypeList = [
            { id: 'PKWT', description: 'PKWT' },
            { id: 'PKWT_AMANDEMEN', description: 'PKWT AMANDEMEN' },
            { id: 'PKWT_PERPANJANGAN', description: 'PKWT PERPANJANGAN' },
            {
                id: 'PKWT_PERPANJANGAN_AMANDEMEN',
                description: 'PKWT PERPANJANGAN AMANDEMEN'
            }
        ];
        vm.areaCodeLetter = 'XXXXXX';
        vm.monthLetter = 'XX';
        vm.yearLetter = 'XXXX';
        vm.formTitle = 'CREATE PKWT';
        vm.searchText = '';
        vm.pkwtType = 'PKWT';
        vm.data = REF_DATA;
        vm.pkwtSubject;
        vm.tempRelease = new Date();
        vm.tempStart = new Date();
        vm.contractPeriod = 6;
        vm.amandemenOrder = 0;
        vm.letterOrder = 0;
        vm.letterNumber = 'XXX/HC-PMA/PK-XXXXXX/XX/XXXX';
        vm.pkwtSubject = {
            label: 'Cari Karyawan',
            value: undefined,
            error: 'Karyawan Wajib Diisi'
        };
        vm.isEdit = IS_EDIT;
        vm.isFromDialog = FROM_DIALOG;

        // METHOD
        vm.hide = hide;
        vm.onChangePkwtType = onChangePkwtType;
        vm.querySearch = querySearch;
        vm.getItemText = getItemText;
        vm.selectedItemChange = selectedItemChange;
        vm.getHighlight = getHighlight;
        vm.renderPkwtNumber = renderPkwtNumber;
        vm.submit = submit;
        vm.update = update;

        ///////////// MAIN ////////////////

        activate();

        function activate() {
            initFormOptions();
        }

        function initFormOptions() {
            if (IS_EDIT) {
                console.log(vm.data);
                vm.isLoading = true;
                vm.pkwtType = vm.data.pkwt_type;
                vm.letterNumber = vm.data.letter_nymber;
                vm.tempRelease = new Date(vm.data.release_date);
                vm.tempStart = new Date(vm.data.start_contract);
                vm.contractPeriod = vm.data.contract_duration;
                vm.letterOrder = vm.data.letter_order;
                onChangePkwtType();
                initSearch(
                    vm.data.nik,
                    vm.pkwtType,
                    vm.data.pkwt_detail_id,
                    true
                ).then(function(response) {
                    vm.isLoading = false;
                    vm.pkwtSubject.value = response[0];
                });
            }

            if (FROM_DIALOG) {
                vm.isLoading = true;
                console.log(vm.data);
                switch (vm.data.pkwt_type) {
                    case 'PKWT':
                        vm.pkwtType = 'PKWT_AMANDEMEN';
                        break;
                    case 'PKWT_AMANDEMEN':
                        if (vm.data.amandemen_order == 3) {
                            vm.pkwtType = 'PKWT_PERPANJANGAN';
                        }
                        break;
                    case 'PKWT_PERPANJANGAN':
                        vm.pkwtType = 'PKWT_PERPANJANGAN_AMANDEMEN';
                        break;
                }
                onChangePkwtType();
                querySearch(vm.data.letter_number)
                    .then(function(response) {
                        if (response.length > 0) {
                            vm.pkwtSubject.value = response[0];
                            vm.amandemenOrder = response[0].amandemen_order;
                            vm.letterOrder = response[0].letter_order;
                        }
                        vm.isLoading = false;
                    })
                    .catch(function(response) {
                        vm.isLoading = false;
                    });
            }
        }

        function onChangePkwtType() {
            var inTitle = IS_EDIT ? 'UPDATE ' : 'CREATE ';
            vm.searchText = '';
            switch (vm.pkwtType) {
                case 'PKWT':
                    vm.formTitle = inTitle + 'PKWT';
                    vm.pkwtSubject.label = 'Cari Karyawan';
                    vm.pkwtSubject.error = 'Karyawan Wajib Diisi';
                    vm.pkwtSubject.value = undefined;
                    break;
                case 'PKWT_AMANDEMEN':
                    vm.formTitle = inTitle + 'PKWT AMANDEMEN';
                    vm.pkwtSubject.label = 'Cari Surat PKWT';
                    vm.pkwtSubject.error = 'Surat PKWT Wajib Diisi';
                    vm.pkwtSubject.value = undefined;
                    break;
                case 'PKWT_PERPANJANGAN':
                    vm.formTitle = inTitle + 'PKWT PERPANJANGAN';
                    vm.pkwtSubject.label = 'Cari Surat PKWT Amandemen';
                    vm.pkwtSubject.error = 'Surat PKWT Amandemen Wajib Diisi';
                    vm.pkwtSubject.value = undefined;
                    break;
                case 'PKWT_PERPANJANGAN_AMANDEMEN':
                    vm.formTitle = inTitle + 'PKWT PERPANJANGAN AMANDEMEN';
                    vm.pkwtSubject.label = 'Cari Surat PKWT Perpanjangan';
                    vm.pkwtSubject.error = 'Surat PKWT Perpanjangan Wajib Diisi';
                    vm.pkwtSubject.value = undefined;
                    break;
            }
        }

        function querySearch(search) {
            var request = endpoint.query({
                action: 'searchSubject',
                search: search,
                pkwt_type: vm.pkwtType,
                pkwt_detail_id: 0,
                is_update: false
            });
            return request.$promise.then(function(response) {
                return response;
            });
        }

        function initSearch(search, pkwtType, pkwt_detail_id, is_update) {
            var request = endpoint.query({
                action: 'searchSubject',
                search: search,
                pkwt_type: pkwtType,
                pkwt_detail_id: pkwt_detail_id,
                is_update: true
            });
            return request.$promise;
        }

        function getItemText(item) {
            var text = '';
            switch (vm.pkwtType) {
                case 'PKWT':
                    text =
                        item.employee.nik +
                        ' - ' +
                        item.employee.name +
                        ' - ' +
                        item.employee.job_title;
                    break;
                case 'PKWT_AMANDEMEN':
                case 'PKWT_PERPANJANGAN':
                case 'PKWT_PERPANJANGAN_AMANDEMEN':
                    text = item.letter_number;
                    break;
            }
            return text;
        }

        function selectedItemChange(item) {
            if (item) {
                if (vm.pkwtType !== 'PKWT') {
                    if (IS_EDIT) {
                        vm.amandemenOrder = vm.data.amandemen_order;
                        vm.letterOrder = vm.data.letter_order;
                    } else {
                        vm.amandemenOrder = item.amandemen_order;
                        vm.letterOrder = item.letter_order;
                    }
                }
                renderPkwtNumber();
            }
        }

        function getHighlight(item) {
            return getItemText(item);
        }

        function renderPkwtNumber() {
            var releaseDate = getReleaseDate();
            var month = releaseDate.month;
            var year = releaseDate.year;
            var code = vm.pkwtSubject.value.employee
                ? vm.pkwtSubject.value.employee.code_area
                : 'XXXXX';
            vm.letterNumber =
                'XXX' + '/HC-PMA/' + 'PK-' + code + '/' + month + '/' + year;
        }

        function getReleaseDate() {
            var response = {
                month: 'XX',
                year: 'XXXX'
            };
            if (vm.tempRelease) {
                var temp = angular.copy(vm.tempRelease);
                var month = moment(temp).format('MM');
                var year = moment(temp).format('YYYY');
                response.month = toRomanianMonth(month);
                response.year = year;
            }
            return response;
        }

        function submit(form) {
            console.log(form);
            var payload = {
                release_date: form.release_date.$viewValue,
                letter_order: parseInt(vm.letterOrder),
                letter_number: form.letter_number.$viewValue,
                start_contract: form.start_contract.$viewValue,
                contract_duration: vm.contractPeriod,
                pkwt_type: vm.pkwtType,
                amandemen_order: vm.amandemenOrder,
                emp_type_id: vm.pkwtSubject.value.emp_type_id,
                parent_id: 0,
                pkwt_main_id: 0
            };

            if (vm.pkwtType !== 'PKWT') {
                payload.parent_id = vm.pkwtSubject.value.id;
                payload.pkwt_main_id = vm.pkwtSubject.value.pkwt_main_id;
            }

            Object.keys(vm.pkwtSubject.value.employee).forEach(function(key) {
                payload[key] = vm.pkwtSubject.value.employee[key];
            });

            vm.isLoading = true;

            Auth.setToken().then(function() {
                var request = endpoint.save({ action: 'submit', data: payload });
                request.$promise.then(function(res) {
                    form.$setUntouched();
                    form.$setPristine();
                    vm.success = true;
                    vm.message = res.message;
                    vm.isLoading = false;
                    vm.showMessage = true;
                    vm.saveProccess = false;
                    vm.pkwtSubject.value = undefined;
                    vm.searchText = '';
                });

                request.$promise.catch(function(res) {
                    form.$setUntouched();
                    form.$setPristine();
                    vm.success = false;
                    vm.message = res.data.message;
                    vm.isLoading = false;
                    vm.showMessage = true;
                    vm.saveProccess = false;
                });
            });

            console.log(payload);
        }

        function update(ev, form) {
            console.log(form);
            var payload = {
                release_date: form.release_date.$viewValue,
                letter_order: parseInt(vm.letterOrder),
                letter_number: form.letter_number.$viewValue,
                start_contract: form.start_contract.$viewValue,
                contract_duration: vm.contractPeriod,
                pkwt_type: vm.pkwtType,
                amandemen_order: vm.amandemenOrder,
                parent_id: vm.data.parent_id,
                id: vm.data.pkwt_detail_id,
                pkwt_main_id: vm.data.pkwt_main_id,
                emp_contract_id: REF_DATA.emp_contract_id
            };

            Object.keys(vm.pkwtSubject.value.employee).forEach(function(key) {
                payload[key] = vm.pkwtSubject.value.employee[key];
            });

            vm.isLoading = true;

            Auth.setToken().then(function() {
                var request = endpoint.save({ action: 'update', data: payload });
                request.$promise.then(function(res) {
                    form.$setUntouched();
                    form.$setPristine();
                    vm.success = true;
                    vm.message = res.message;
                    vm.isLoading = false;
                    vm.showMessage = true;
                    vm.saveProccess = false;
                });

                request.$promise.catch(function(res) {
                    form.$setUntouched();
                    form.$setPristine();
                    vm.success = false;
                    vm.message = res.message;
                    vm.isLoading = false;
                    vm.showMessage = true;
                    vm.saveProccess = false;
                });
            });

            console.log(payload);
        }

        // HELPERS

        function hide() {
            $mdDialog.hide();
        }

        function toRomanianMonth(month) {
            switch (month) {
                case '01':
                    return 'I';
                case '02':
                    return 'II';
                case '03':
                    return 'III';
                case '04':
                    return 'IV';
                case '05':
                    return 'V';
                case '06':
                    return 'VI';
                case '07':
                    return 'VII';
                case '08':
                    return 'VIII';
                case '09':
                    return 'IX';
                case '10':
                    return 'X';
                case '11':
                    return 'XI';
                case '12':
                    return 'XII';
            }
        }

        function pad(num, max) {
            if (num) {
                if (num.length < max) {
                    if (num < 10) {
                        return '00'.concat(num);
                    } else {
                        return '0'.concat(num);
                    }
                }
            }
            return num;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.pkwt').controller('PkwtChildsController', Controller);

    Controller.$inject = [
        'config',
        '$mdDialog',
        'AppAPI',
        'REF_DATA',
        '$window',
        '$location',
        'IS_DELETE',
        'Auth'
    ];
    /** @ngInject */
    function Controller(
        config,
        $mdDialog,
        AppAPI,
        REF_DATA,
        $window,
        $location,
        IS_DELETE,
        Auth
    ) {
        var vm = this;
        var endpoint = AppAPI.PkwtManagementIr();
        vm.hide = hide;
        vm.data = angular.copy(REF_DATA);
        vm.list = {
            amandemenPerpanjangan: [],
            perpanjangan: [],
            amandemen: []
        };
        vm.isLoading = false;
        vm.getTableTitle = getTableTitle;
        vm.viewPkwt = viewPkwt;
        vm.showAction = showAction;
        vm.deleteAction = deleteAction;
        vm.checkDisabled = checkDisabled;
        vm.isDelete = IS_DELETE;
        vm.info = {
            title: 'Information',
            message: 'Berikut ini list amandemen yang telah di lakukan pada PKWT ini'
        };
        vm.menuAction = menuAction;
        vm.printOut = printOut;

        activate();

        function activate() {
            loadData();
            if (vm.isDelete) {
                vm.info.message =
                    'Untuk menghapus surat ini anda harus menghapus amandemennya terlebih dahulu';
            }
        }

        function hide() {
            $mdDialog.hide();
        }

        function loadData() {
            vm.isLoading = true;
            var request = endpoint.get({
                action: 'amandemenList',
                id: vm.data.pkwt_detail_id
            });
            request.$promise.then(function(res) {
                vm.isLoading = false;
                vm.list = {
                    amandemenPerpanjangan: res.amandemen_perpanjangan,
                    perpanjangan: res.perpanjangan,
                    amandemen: res.amandemen
                };
            });
            request.$promise.catch(function() {
                vm.isLoading = false;
                vm.list = {
                    amandemenPerpanjangan: [],
                    perpanjangan: [],
                    amandemen: []
                };
            });
        }

        function getTableTitle(key) {
            var title = '';
            switch (key) {
                case 'amandemen':
                    title = 'List Data Amandemen';
                    break;
                case 'perpanjangan':
                    title = 'List Data Perpanjangan';
                    break;
                case 'amandemenPerpanjangan':
                    title = 'List Data Amandemen Perpanjangan';
                    break;
            }
            return title;
        }

        function viewPkwt(ev, item) {
            $mdDialog
                .show({
                    controller: 'ViewPkwtController as vm',
                    templateUrl: 'app/main/pkwt/view-pkwt/view-pkwt.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    multiple: true,
                    fullscreen: true,
                    locals: {
                        refData: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function showAction(ev, isEdit, item, fromDialog) {
            $mdDialog
                .show({
                    controller: 'PkwtFormController as vm',
                    templateUrl: 'app/main/pkwt/pkwt-form/pkwt-form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    multiple: true,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        IS_EDIT: isEdit,
                        REF_DATA: item,
                        FROM_DIALOG: fromDialog
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function menuAction(ev, type) {
            switch (type) {
                case 'amandemen':
                    var item = vm.data;
                    showAction(ev, false, item, true);
                    break;
                case 'perpanjangan':
                    var item = vm.list.amandemen[0];
                    showAction(ev, false, item, true);
                    break;
                case 'amandemenPerpanjangan':
                    var item = vm.list.perpanjangan[0];
                    showAction(ev, false, item, true);
                    break;
            }
        }

        function deleteAction(ev, item) {
            var response = Auth.setToken();
            response.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Confirmation')
                    .textContent('Do you want to delete this ?')
                    .ariaLabel('confirmation')
                    .multiple(true)
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(function() {
                    var request = endpoint.delete({
                        action: 'delete',
                        pkwt_main_id: item.pkwt_main_id,
                        pkwt_detail_id: item.pkwt_detail_id
                    });

                    request.$promise.then(function(res) {
                        $mdDialog
                            .show(
                                $mdDialog
                                    .alert()
                                    .parent(angular.element(document.body))
                                    .clickOutsideToClose(true)
                                    .title('Success')
                                    .multiple(true)
                                    .textContent(res.message)
                                    .ariaLabel('Alert Dialog Demo')
                                    .ok('OK')
                                    .targetEvent(ev)
                            )
                            .then(function() {
                                loadData(1);
                            });
                    });
                    request.$promise.catch(function(err) {
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Failed')
                                .multiple(true)
                                .textContent(err.message)
                                .ariaLabel('Alert Dialog Demo')
                                .ok('OK')
                                .targetEvent(ev)
                        );
                        loadData(1);
                    });
                });
            });
        }

        function checkDisabled(key, idx) {
            var response = false;
            switch (key) {
                case 'amandemen':
                    if (
                        vm.list.perpanjangan.length > 0 ||
                        vm.list.amandemenPerpanjangan.length > 0
                    ) {
                        response = true;
                    } else {
                        if (idx > 0) {
                            response = false;
                        }
                    }
                    break;
                case 'perpanjangan':
                    if (vm.list.amandemenPerpanjangan.length > 0) {
                        response = true;
                    }
                    break;
                case 'amandemenPerpanjangan':
                    response = false;
                    break;
            }
            return response;
        }

        function printOut(ev) {
            var protocol = $location.protocol();
            var host = $location.host();
            var params = [];

            Object.keys(vm.list).forEach(function(key) {
                vm.list[key].map(function(val) {
                    params.push(val.pkwt_detail_id);
                });
            });

            if (params.length == 0) {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(angular.element(document.body))
                            .clickOutsideToClose(true)
                            .title('Information')
                            .multiple(true)
                            .textContent('Cannot Print, Because Data Is Empty')
                            .ariaLabel('Alert Dialog Demo')
                            .ok('OK')
                            .targetEvent(ev)
                    )
                    .then(function() {
                        loadData(1);
                    });
                return;
            }

            $window.open(
                protocol +
                    '://' +
                    host +
                    config.port +
                    config.api +
                    'api/printhelper/printPkwt?id[]=' +
                    params
            );
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.pkwt.management_ta', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.pkwt_management_ta', {
            url: '/pkwt/ta',
            views: {
                'content@app': {
                    templateUrl: 'app/main/pkwt/management-ta/management-ta.html',
                    controller: 'PkwtManagementTaController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.pkwt.management_ta')
        .controller('PkwtManagementTaController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$mdDialog',
        '$scope',
        '$location',
        'Auth',
        '$window',
        'config',
        'DataService'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $mdDialog,
        $scope,
        $location,
        Auth,
        $window,
        config,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.PkwtManagementTa();
        vm.DataTables = new DataService();
        vm.isCollapse = true;
        vm.pkwtType = 'PKWT';
        vm.selected = [];
        vm.listJum = [5, 10, 25, 50];
        vm.DataTables.jumDataPerPage;
        vm.DataTables.list = [];
        vm.pkwtTypeList = [
            { id: 'PKWT', description: 'PKWT' },
            { id: 'PKWT_AMANDEMEN', description: 'PKWT AMANDEMEN' },
            { id: 'PKWT_PERPANJANGAN', description: 'PKWT PERPANJANGAN' },
            {
                id: 'PKWT_PERPANJANGAN_AMANDEMEN',
                description: 'PKWT PERPANJANGAN AMANDEMEN'
            }
        ];
        vm.printStatus = 'all';
        vm.printStatusList = [
            { id: 'all', description: 'Semuanya' },
            { id: 1, description: 'Sudah Print' },
            { id: 0, description: 'Belum Print' }
        ];

        vm.loadData = loadData;
        vm.showCreateForm = showCreateForm;
        vm.deletePkwt = deletePkwt;
        vm.printOut = printOut;
        vm.toggle = toggle;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.exists = exists;
        vm.viewPkwt = viewPkwt;
        vm.uploadPkwt = uploadPkwt;
        vm.updatePkwtForm = updatePkwtForm;
        vm.showRulesForm = showRulesForm;

        activate();

        function activate() {
            loadData(1);
        }

        function loadData(pageNo) {
            vm.selected = [];
            vm.DataTables.loadData(endpoint, pageNo, {
                action: 'viewData',
                pkwt_type: vm.pkwtType,
                is_printed: vm.printStatus,
                is_ta: true
            });
        }

        function showCreateForm(ev, isEdit, refData) {
            $mdDialog
                .show({
                    controller: 'PkwtFormController as vm',
                    templateUrl: 'app/main/pkwt/pkwt-form/pkwt-form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    multiple: true,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        IS_EDIT: isEdit,
                        REF_DATA: refData
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function showRulesForm(ev) {
            $mdDialog
                .show({
                    controller: 'PkwtRulesController as vm',
                    templateUrl: 'app/main/pkwt/pkwt-rules/pkwt-rules.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    multiple: true,
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                .then(function() {
                    loadData(1);
                });
        }

        function deletePkwt(ev, item) {
            var response = Auth.setToken();
            console.log(item);
            response.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Confirmation')
                    .textContent('Do you want to delete this ?')
                    .ariaLabel('confirmation')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(function() {
                    var request = endpoint.delete({
                        action: 'delete',
                        pkwt_main_id: item.pkwt_main_id,
                        pkwt_detail_id: item.pkwt_detail_id
                    });

                    request.$promise.then(function(res) {
                        $mdDialog
                            .show(
                                $mdDialog
                                    .alert()
                                    .parent(angular.element(document.body))
                                    .clickOutsideToClose(true)
                                    .title('Success')
                                    .textContent(res.message)
                                    .ariaLabel('Alert Dialog Demo')
                                    .ok('OK')
                                    .targetEvent(ev)
                            )
                            .then(function() {
                                loadData(1);
                            });
                    });
                    request.$promise.catch(function(err) {
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Failed')
                                .textContent(err.message)
                                .ariaLabel('Alert Dialog Demo')
                                .ok('OK')
                                .targetEvent(ev)
                        );
                        loadData(1);
                    });
                });
            });
        }

        function printOut(isSingle, id, isLoa) {
            var protocol = $location.protocol();
            var host = $location.host();
            var params = [];
            var url = protocol + '://' + host + config.port + config.api;
            if (isSingle) {
                params = [id];
            } else {
                vm.selected.map(function(val) {
                    params.push(val.pkwt_detail_id);
                });
            }

            if (!isLoa) {
                url += 'api/printhelper/printPkwt?id[]=' + params;
            } else {
                url += 'api/printhelper/printLoa?id[]=' + params;
            }
            $window.open(url);
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return (
                vm.selected.length !== 0 &&
                vm.selected.length !== vm.DataTables.list.length
            );
        }

        function isChecked() {
            return vm.selected.length === vm.DataTables.list.length;
        }

        function toggleAll() {
            if (vm.selected.length === vm.DataTables.list.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.DataTables.list.slice(0);
            }
        }

        function viewPkwt(ev, refData) {
            $mdDialog
                .show({
                    controller: 'ViewPkwtController as vm',
                    templateUrl: 'app/main/pkwt/view-pkwt/view-pkwt.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        refData: refData
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function updatePkwtForm(ev, refData) {
            $mdDialog
                .show({
                    controller: 'UpdateFormPkwtTaController as vm',
                    templateUrl:
                        'app/main/pkwt/management-ta/update-form/update-form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        REF_DATA: refData
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function uploadPkwt(ev) {
            $mdDialog
                .show({
                    controller: 'PkwtUploadController as vm',
                    templateUrl: 'app/main/pkwt/pkwt-upload/pkwt-upload.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    multiple: true,
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                .then(function() {
                    loadData(1);
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.pkwt.management_ir', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.pkwt_management_ir', {
            url: '/pkwt/ir',
            views: {
                'content@app': {
                    templateUrl: 'app/main/pkwt/management-ir/management-ir.html',
                    controller: 'PkwtManagementIRController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.pkwt.management_ir')
        .controller('PkwtManagementIRController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$mdDialog',
        '$scope',
        '$location',
        'Auth',
        '$window',
        'config',
        'DataService'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $mdDialog,
        $scope,
        $location,
        Auth,
        $window,
        config,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.PkwtManagementIr();
        vm.DataTables = new DataService();
        vm.isCollapse = true;
        vm.pkwtType = 'PKWT';
        vm.selected = [];
        vm.listJum = [5, 10, 25, 50];
        vm.DataTables.jumDataPerPage;
        vm.DataTables.list = [];
        vm.pkwtTypeList = [
            { id: 'PKWT', description: 'PKWT' },
            { id: 'PKWT_AMANDEMEN', description: 'PKWT AMANDEMEN' },
            { id: 'PKWT_PERPANJANGAN', description: 'PKWT PERPANJANGAN' },
            {
                id: 'PKWT_PERPANJANGAN_AMANDEMEN',
                description: 'PKWT PERPANJANGAN AMANDEMEN'
            }
        ];
        vm.printStatus = 'all';
        vm.printStatusList = [
            { id: 'all', description: 'Semuanya' },
            { id: 1, description: 'Sudah Print' },
            { id: 0, description: 'Belum Print' }
        ];

        vm.loadData = loadData;
        vm.showCreateForm = showCreateForm;
        vm.deletePkwt = deletePkwt;
        vm.printOut = printOut;
        vm.toggle = toggle;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.exists = exists;
        vm.viewPkwt = viewPkwt;
        vm.viewAmandemen = viewAmandemen;

        activate();

        function activate() {
            loadData(1);
        }

        function loadData(pageNo) {
            vm.selected = [];
            vm.DataTables.loadData(endpoint, pageNo, {
                action: 'viewData',
                pkwt_type: vm.pkwtType,
                is_printed: vm.printStatus
            });
        }

        function showCreateForm(ev, isEdit, refData) {
            $mdDialog
                .show({
                    controller: 'PkwtFormController as vm',
                    templateUrl: 'app/main/pkwt/pkwt-form/pkwt-form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    multiple: true,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        IS_EDIT: isEdit,
                        REF_DATA: refData,
                        FROM_DIALOG: false
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function deletePkwt(ev, item) {
            console.log(item);
            if (item.has_childs) {
                viewAmandemen(ev, item, true);
            } else {
                deleteAction(ev, item);
            }
        }

        function viewAmandemen(ev, item, isDelete) {
            $mdDialog
                .show({
                    controller: 'PkwtChildsController as vm',
                    templateUrl: 'app/main/pkwt/pkwt-childs/pkwt-childs.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    multiple: true,
                    clickOutsideToClose: false,
                    fullscreen: true,
                    locals: {
                        REF_DATA: item,
                        IS_DELETE: isDelete
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function deleteAction(ev, item) {
            var response = Auth.setToken();
            response.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Confirmation')
                    .textContent('Do you want to delete this ?')
                    .ariaLabel('confirmation')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(function() {
                    var request = endpoint.delete({
                        action: 'delete',
                        pkwt_main_id: item.pkwt_main_id,
                        pkwt_detail_id: item.pkwt_detail_id
                    });

                    request.$promise.then(function(res) {
                        $mdDialog
                            .show(
                                $mdDialog
                                    .alert()
                                    .parent(angular.element(document.body))
                                    .clickOutsideToClose(true)
                                    .title('Success')
                                    .textContent(res.message)
                                    .ariaLabel('Alert Dialog Demo')
                                    .ok('OK')
                                    .targetEvent(ev)
                            )
                            .then(function() {
                                loadData(1);
                            });
                    });
                    request.$promise.catch(function(err) {
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Failed')
                                .textContent(err.message)
                                .ariaLabel('Alert Dialog Demo')
                                .ok('OK')
                                .targetEvent(ev)
                        );
                        loadData(1);
                    });
                });
            });
        }

        function printOut(isSingle, id) {
            var protocol = $location.protocol();
            var host = $location.host();
            var params = [];
            if (isSingle) {
                params = [id];
            } else {
                vm.selected.map(function(val) {
                    params.push(val.pkwt_detail_id);
                });
            }
            $window.open(
                protocol +
                    '://' +
                    host +
                    config.port +
                    config.api +
                    'api/printhelper/printPkwt?id[]=' +
                    params
            );
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return (
                vm.selected.length !== 0 &&
                vm.selected.length !== vm.DataTables.list.length
            );
        }

        function isChecked() {
            return vm.selected.length === vm.DataTables.list.length;
        }

        function toggleAll() {
            if (vm.selected.length === vm.DataTables.list.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.DataTables.list.slice(0);
            }
        }

        function viewPkwt(ev, refData) {
            $mdDialog
                .show({
                    controller: 'ViewPkwtController as vm',
                    templateUrl: 'app/main/pkwt/view-pkwt/view-pkwt.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        refData: refData
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.payroll-new.uploadfixnonfix-mgr', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.payroll_new_uploadfixnonfix_mgr', {
                url    : '/new-payroll/uploadfixnonfix-manager',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/payroll-new/uploadfixnonfix-mgr/upload-data.html',
                        controller : 'NewUploaddatafixnonfixMgrController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';
    angular
      .module('app.payroll-new.uploadfixnonfix-mgr')
      .controller('NewUploaddatafixnonfixMgrController', NewUploaddatafixnonfixMgrController);
  
    NewUploaddatafixnonfixMgrController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function NewUploaddatafixnonfixMgrController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
  
      vm.uploadSuccessFix = vm.uploadSuccessNonFix = vm.uploadErrorFix = vm.uploadErrorNonFix = vm.isMoreInfoFix = vm.isMoreInfoNonFix = false;
      vm.uploadNotifFix = vm.uploadNotifNonFix = '';
      vm.DownloadTemplateFix = DownloadTemplateFix;
      vm.DownloadTemplateNonFix = DownloadTemplateNonFix;
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfoFix = vm.detailInfoNonFix = []
      
      vm.FileUploaderFixEntry = new FileUploader({
        url: config.api + 'api/payrollnew/NewFixentry/uploadfile',
        removeAfterUpload: true,
        alias: 'filesalary',
        formData: [{
            action: 'uploadfilefixentry',
            isMgr: true
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccessFix = false;
          vm.uploadErrorFix = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUploaderFixEntry.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccessFix = false;
          vm.uploadErrorFix   = true;
        } else {
          vm.uploadSuccessFix = true;
          vm.uploadErrorFix   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotifFix = message
        
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfoFix = true;
            vm.detailInfoFix = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUploaderFixEntry.onErrorItem = function(data, message) {
        vm.uploadSuccessFix = false;
        vm.uploadErrorFix = true;
        vm.uploadNotifFix = message
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplateFix()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewFixentry/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
      
      vm.FileUploaderNonFixEntry = new FileUploader({
        url: config.api + 'api/payrollnew/NewNonfixentry/uploadfilenonfixentry',
        removeAfterUpload: true,
        alias: 'filenonfixentry',
        formData: [{
            action: 'uploadfilenonfixentry',
            isMgr: true
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccessFix = false;
          vm.uploadErrorFix = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUploaderNonFixEntry.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccessNonFix = false;
          vm.uploadErrorNonFix   = true;
        } else {
          vm.uploadSuccessNonFix = true;
          vm.uploadErrorNonFix   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotifNonFix = message
        
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfoNonFix = true;
            vm.detailInfoNonFix = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUploaderNonFixEntry.onErrorItem = function(data, message) {
        vm.uploadSuccessNonFix = false;
        vm.uploadErrorNonFix = true;
        vm.uploadNotifNonFix = message
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplateNonFix()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewNonfixentry/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }

      function viewMoreInfo(detail)
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:detail
          }
        });
      }
    }
  })();
(function ()
{
    'use strict';

    angular
        .module('app.payroll-new.uploadfixnonfix', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.payroll_new_uploadfixnonfix', {
                url    : '/new-payroll/uploadfixnonfix',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/payroll-new/uploadfixnonfix/upload-data.html',
                        controller : 'NewUploaddatafixnonfixController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';
    angular
      .module('app.payroll-new.uploadfixnonfix')
      .controller('NewUploaddatafixnonfixController', NewUploaddatafixnonfixController);
  
    NewUploaddatafixnonfixController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function NewUploaddatafixnonfixController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
  
      vm.uploadSuccessFix = vm.uploadSuccessNonFix = vm.uploadErrorFix = vm.uploadErrorNonFix = vm.isMoreInfoFix = vm.isMoreInfoNonFix = false;
      vm.uploadNotifFix = vm.uploadNotifNonFix = '';
      vm.DownloadTemplateFix = DownloadTemplateFix;
      vm.DownloadTemplateNonFix = DownloadTemplateNonFix;
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfoFix = vm.detailInfoNonFix = []
      
      vm.FileUploaderFixEntry = new FileUploader({
        url: config.api + 'api/payrollnew/NewFixentry/uploadfile',
        removeAfterUpload: true,
        alias: 'filesalary',
        formData: [{
            action: 'uploadfilefixentry'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccessFix = false;
          vm.uploadErrorFix = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUploaderFixEntry.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccessFix = false;
          vm.uploadErrorFix   = true;
        } else {
          vm.uploadSuccessFix = true;
          vm.uploadErrorFix   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotifFix = message
        
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfoFix = true;
            vm.detailInfoFix = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUploaderFixEntry.onErrorItem = function(data, message) {
        vm.uploadSuccessFix = false;
        vm.uploadErrorFix = true;
        vm.uploadNotifFix = message
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplateFix()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewFixentry/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
      
      vm.FileUploaderNonFixEntry = new FileUploader({
        url: config.api + 'api/payrollnew/NewNonfixentry/uploadfilenonfixentry',
        removeAfterUpload: true,
        alias: 'filenonfixentry',
        formData: [{
            action: 'uploadfilenonfixentry'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccessFix = false;
          vm.uploadErrorFix = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUploaderNonFixEntry.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccessNonFix = false;
          vm.uploadErrorNonFix   = true;
        } else {
          vm.uploadSuccessNonFix = true;
          vm.uploadErrorNonFix   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotifNonFix = message
        
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfoNonFix = true;
            vm.detailInfoNonFix = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUploaderNonFixEntry.onErrorItem = function(data, message) {
        vm.uploadSuccessNonFix = false;
        vm.uploadErrorNonFix = true;
        
        vm.uploadNotifNonFix = message
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplateNonFix()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewNonfixentry/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }

      function viewMoreInfo(detail)
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:detail
          }
        });
      }
    }
  })();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.thrprocess', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_thrprocess', {
                url    : '/new-payroll/thrprocess',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/thrprocess/thrprocess.html',
                    controller : 'NewThrProcessController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.thrprocess')
        .controller('NewThrProcessController', NewThrProcessController);

    NewThrProcessController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth','$http','config','$element'];

    /* @ngInject */
    function NewThrProcessController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth, $http,config,$element)
    {
       
        var vm = this;
        var dt = new Date();
        var year = dt.getFullYear()-1;

        Form.initialForm();
        
        var ThrProcess=AppAPI.NewThrProcess();

        Form.setObject(ThrProcess);

        vm.Form = Form; 

        vm.changeCompany = changeCompany;
        vm.company = $localStorage.empsite
        
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;     

        vm.Form.objForm.period = new Date();
        vm.Form.objForm.area = '';
        vm.Form.objForm.empno = '';
        
        vm.LoadArea = LoadArea
        
        LoadCompany();
        LoadPeriod()
        LoadArea(vm.company);

        function LoadCompany() {
                var response=ThrProcess.query({action:'getCompany'});
                response.$promise.then(fetchCompany);
                response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
                vm.listcompany=data;
        }

        function errorFetchCompany() {
                vm.listcompany=[];
        } 

        function changeCompany(id)
        { 
                vm.listarea=[];
                var resp=ThrProcess.query({action:'getSpecificArea',companyid:id})
                resp.$promise.then(fetchspecificarea);
                resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data)
        {
                vm.listarea=data;
        }

        function errorfetchspecificarea()
        {
                vm.listarea=[];
        }
       
        function LoadArea(companyid) {
                var response=ThrProcess.query({action:'getArea', companyid:companyid});
                response.$promise.then(fetchArea);
                response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
                vm.listarea=data;
        }

        function errorFetchArea() {
                vm.listarea=[];
        } 

        function selectedItemChanged(employee)
        {   
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;
            }
        }

        function getEmployee(searchText)
        {
           return $http
                    .get(config.api + 'api/payrollnew/NewThrprocess?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                    .then(function(item) {
                        // Map the response object to the data object.
                        if(item.data.length==='')
                        {
                            Form.objForm.empno='';
                        } 
                        return item.data;
                    });
        }

        function loadData(pageno) 
        {
            vm.DataTable.loadData(ThrProcess,pageno,{action:'viewdata'});
        }

        function LoadPeriod() 
        {
            var response=ThrProcess.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) 
        {
            vm.listperiod=data;
        }

        function errorFetchPeriod() 
        {
            vm.listperiod=[];
        }

        function saveData(ev,formController) 
        {       
            var period = vm.Form.objForm.period;
            var company = vm.company;
            
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to process THR?')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
            
                $mdDialog.show(confirm).then(function() 
                {
                    angular.element('#attView').block({message:' <span>Loading...</span>'});

                    angular.element.blockUI();
                    vm.Form.objForm.companyid=vm.company;
                    var response=Form.saveData('save', formController, ThrProcess);
                    
                    response.then(fetchThr);
                    response.catch(errorFetchThr);
                        
                    // var check = PayrollProcess.query({action:'check', period: period, company:company });
                    // check.$promise.then(statusClosed);
                    // check.$promise.catch(function(){
                        
                    // });
                }, function() {
                    angular.element('#attView').unblock(); 
                });
            });
        }

        function fetchThr(data)
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function errorFetchThr()
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed THR Process')
            .textContent('Process Data was Fail.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        } 

        function statusClosed()
        {
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Periode has been Closed, Thr Can not be Proccesed')
            .textContent('Process Data was Fail.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        }        

        function statusThr()
        {
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Sorry, Another user still processing this THR.')
            .textContent('Try again in 15 minutes later.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
           //angular.element.unblockUI();
        }  

        function showDialog(ev) 
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success Save Data')
                .textContent('Process Data was Success.')
                .ariaLabel('Success Save Data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
       
       function closeModal()
       {
            $mdDialog.hide();
       }

       vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.taxparameter', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) 
   {
   	    $stateProvider
            .state('app.payroll_new_taxparameter', {
                url    : '/new-payroll/taxparameter',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/taxparameter/taxparameter.html',
                    controller : 'NewTaxParameterController as vm'
                    }
                }
            });
    }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.taxparameter')
        .controller('NewTaxParameterController', NewTaxParameterController);

    NewTaxParameterController.$inject = ['AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', '$filter', '$localStorage', '$element'];

    /* @ngInject */
    function NewTaxParameterController(AppAPI, DataService, $mdDialog, Form, Auth, $filter, $localStorage, $element) {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/taxparameter';

        var TaxParameter = AppAPI.NewTaxParameter();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputTaxParameter = inputTaxParameter;
        vm.lisTaxParameterSelected = [];
        vm.DeleteTaxParameter = DeleteTaxParameter;
        vm.editTaxParameter = editTaxParameter;
        vm.country = $localStorage.country;

        vm.header = 'PAYROLL.MENU.TAXPARAMETER';
        if (vm.country == "MYS") {
            vm.header = 'PAYROLL.MENU.TAXPARAMETERMYS';
        }

        loadData(1);

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function loadData(pageno) {
            vm.DataTable.loadData(TaxParameter, pageno, { action: 'viewdata', country: vm.country });
        }

        function inputTaxParameter(ev) {
            var template = basePath + '/input-taxparameter.html';
            if (vm.country == 'MYS') {
                var template = basePath + '/input-taxparameter-mys.html';
            }
            $mdDialog.show({
                controller: 'InputNewtaxparameterController',
                controllerAs: 'vm',
                templateUrl: template,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    country: vm.country
                }
            });
        }

        function editTaxParameter(ev, id) {
            var template = basePath + '/input-taxparameter.html';
            if (vm.country == 'MYS') {
                var template = basePath + '/input-taxparameter-mys.html';
            }

            $mdDialog.show({
                controller: 'EditNewtaxparameterController',
                controllerAs: 'vm',
                templateUrl: template,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id,
                    country: vm.country,
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisTaxParameterSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisTaxParameterSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteTaxParameter(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = TaxParameter.delete({ action: 'delete', country: vm.country, data: angular.toJson(vm.lisTaxParameterSelected) });

                    response.$promise.then(loadData);
                }, function () {
                    //
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.taxparameter')
        .controller('InputNewtaxparameterController', InputNewtaxparameterController);

    InputNewtaxparameterController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$filter', '$element', 'country'];

    /* @ngInject */
    function InputNewtaxparameterController($localStorage, $mdDialog, Form, AppAPI, $filter, $element, country) {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData = saveData;

        Form.initialForm();

        var TaxParameter = AppAPI.NewTaxParameter();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(TaxParameter);

        // set orm to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.LoadSalcom = LoadSalcom;
        vm.LoadAllPayroll = LoadAllPayroll;
        vm.Form.objForm.biayajabatanmax = 0;
        vm.Form.objForm.pkp1_limit = 0;
        vm.Form.objForm.pkp2_limit = 0;
        vm.Form.objForm.pkp3_limit = 0;
        vm.Form.objForm.pkp4_limit = 0;
        vm.Form.objForm.nonnpwp_pinalty = 0;
        vm.saveData = saveData;
        vm.Form.objForm.country = country;
        vm.changePayrollCode = changePayrollCode;

        LoadSalcom();
        LoadAllPayroll();
        LoadCountry()

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function changePayrollCode() {
            LoadSalcom();
            LoadAllPayroll();
        }

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadSalcom() {
            var response = TaxParameter.query({ action: 'getSalcom', country: vm.Form.objForm.country });
            response.$promise.then(fetchSalcom);
            response.$promise.catch(errorFetchSalcom);
        }

        function fetchSalcom(data) {
            vm.listSalcom = data;
        }

        function errorFetchSalcom() {
            vm.listSalcom = [];
        }

        function LoadAllPayroll() {
            var response = TaxParameter.query({ action: 'getAllPayroll', country: vm.Form.objForm.country });
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) {
            vm.listallpayroll = data;
        }

        function errorFetchAllPayroll() {
            vm.listallpayroll = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, TaxParameter);
            promise.then(SaveSucces);
            promise.catch(errorSave);
        }

        function SaveSucces(data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function errorSave(data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.taxparameter')
        .controller('EditNewtaxparameterController', EditNewtaxparameterController);

    EditNewtaxparameterController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter', '$element', 'country'];

    /* @ngInject */
    function EditNewtaxparameterController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter, $element, country) {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var TaxParameter = AppAPI.NewTaxParameter();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(TaxParameter);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.LoadSalcom = LoadSalcom;
        vm.LoadAllPayroll = LoadAllPayroll;
        vm.saveData = saveData;

        LoadCountry()

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadSalcom() {
            var response = TaxParameter.query({ action: 'getSalcom', country: country });
            response.$promise.then(fetchSalcom);
            response.$promise.catch(errorFetchSalcom);
        }

        function fetchSalcom(data) {
            vm.listSalcom = data;
        }

        function errorFetchSalcom() {
            vm.listSalcom = [];
        }

        function LoadAllPayroll() {
            var response = TaxParameter.query({ action: 'getAllPayroll', country: country });
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) {
            vm.listallpayroll = data;
        }

        function errorFetchAllPayroll() {
            vm.listallpayroll = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id, country: country });

        res.then(ChangeData);

        function ChangeData(data) {
            vm.Form.objForm.country = country;
            LoadSalcom();
            LoadAllPayroll();

            vm.Form.objForm.nonnpwp_pinalty = parseFloat(data.nonnpwp_pinalty);
            if (country != 'MYS') {
                vm.Form.objForm.pkp1_limit = parseFloat(data.pkp1_limit);
                vm.Form.objForm.pkp1 = parseFloat(data.pkp1);
                vm.Form.objForm.pkp2_limit = parseFloat(data.pkp2_limit);
                vm.Form.objForm.pkp2 = parseFloat(data.pkp2);
                vm.Form.objForm.pkp3_limit = parseFloat(data.pkp3_limit);
                vm.Form.objForm.pkp3 = parseFloat(data.pkp3);
                vm.Form.objForm.pkp4_limit = parseFloat(data.pkp4_limit);
                vm.Form.objForm.pkp4 = parseFloat(data.pkp4);
            } else {
                vm.Form.objForm.eis_max = parseFloat(data.eis_max);
                vm.Form.objForm.unpaid_leave_max = parseFloat(data.unpaid_leave_max);
                vm.Form.objForm.epf_max = parseFloat(data.epf_max);
                vm.Form.objForm.socso_max = parseFloat(data.socso_max);
                vm.Form.objForm.biayajabatanmax = parseFloat(data.biayajabatanmax);
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, TaxParameter);
            promise.then(function (data) {
                showDialog(ev, data);

            });
            promise.catch(function (data) {
                ShowFailed(ev, data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.taxmalaysiacomponent')
        .controller('TaxmalaysiaComponentController', TaxmalaysiaComponentController);

    TaxmalaysiaComponentController.$inject = ['AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', '$filter'];

    /* @ngInject */
    function TaxmalaysiaComponentController(AppAPI, DataService, $mdDialog, Form, Auth, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/taxmalaysia';
        var TaxMalaysia = AppAPI.TaxMalaysia();
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.listDataSelected = [];
        vm.showFilter = true;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;
        vm.toggleSelectedAll = toggleSelectedAll;

        loadData(1);

        function loadData(pageno) {
            vm.DataTable.loadData(TaxMalaysia, pageno, {
                action: 'viewdata',
                start_salary: (vm.start_salary) ? vm.start_salary : null,
                end_salary: (vm.end_salary) ? vm.end_salary : null
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function add(ev) {
            $mdDialog.show({
                controller: 'ManageTaxMalaysiaController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/taxmalaysia/manage/manage-tax-malaysia.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dataTaxMalaysia: null,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'ManageTaxMalaysiaController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/taxmalaysia/manage/manage-tax-malaysia.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dataTaxMalaysia: data,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = TaxMalaysia.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listDataSelected)
                    });
                    response.$promise.then(loadData);
                }, function () {});
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function setTimeStamp(date) {
            if (date == null || date == undefined || date == '') {
                var dataTimeStamp = (new Date().getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            } else {
                var dataTimeStamp = (new Date(date).getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            }

        }
    }
})();

(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.taxlocation', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) 
   {
        $stateProvider
                .state('app.payroll_new_taxlocation', {
                    url    : '/new-payroll/taxlocation',
                    views  : {
                        'content@app' : {
                        templateUrl: 'app/main/payroll-new/taxlocation/taxlocation.html',
                        controller : 'NewTaxLocationController as vm'
                        }
                    }
                    
                });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.taxlocation')
        .controller('NewTaxLocationController', NewTaxLocationController);

    NewTaxLocationController.$inject = ['AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', '$filter', '$localStorage', '$element'];

    /* @ngInject */
    function NewTaxLocationController(AppAPI, DataService, $mdDialog, Form, Auth, $filter, $localStorage, $element) {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/taxlocation';

        var TaxLocation = AppAPI.NewTaxLocation();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputTaxLocation = inputTaxLocation;
        vm.lisTaxLocationSelected = [];
        vm.DeleteTaxLocation = DeleteTaxLocation;
        vm.editTaxLocation = editTaxLocation;
        vm.country = $localStorage.country;

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        loadData(1);

        function loadData(pageno) {
            vm.DataTable.loadData(TaxLocation, pageno, { action: 'viewdata', country: vm.country });
        }

        function inputTaxLocation(ev) {
            $mdDialog.show({
                controller: 'InputNewtaxlocationController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-taxlocation.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editTaxLocation(ev, id) {
            $mdDialog.show({
                controller: 'EditNewtaxlocationController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-taxlocation.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listaxlocationSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listaxlocationSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteTaxLocation(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = TaxLocation.delete({ action: 'delete', data: angular.toJson(vm.lisTaxLocationSelected) });

                    response.$promise.then(loadData);
                }, function () {
                    // 
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.taxlocation')
        .controller('InputNewtaxlocationController', InputNewtaxlocationController);

    InputNewtaxlocationController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$filter', '$element'];

    /* @ngInject */
    function InputNewtaxlocationController($localStorage, $mdDialog, Form, AppAPI, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var TaxLocation = AppAPI.NewTaxLocation();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(TaxLocation);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.Form.objForm.branchnpwpno = '';
        vm.Form.objForm.branchsignername = '';
        vm.Form.objForm.branchsignernpwp = '';
        vm.Form.objForm.branchaddress = '';
        vm.Form.objForm.branchcity = '';
        vm.Form.objForm.country = $localStorage.country;

        vm.saveData = saveData;


        vm.branch = 'PAYROLL.MENU.BRANCHNPWP';
        vm.sigher = 'PAYROLL.MENU.TAXSIGNERNPWP';
        if (vm.country == 'MYS') {
            vm.branch = 'PAYROLL.MENU.BRANCHPCB';
            vm.sigher = 'PAYROLL.MENU.TAXSIGNERPCB';
        }

        vm.Form.objForm.country = $localStorage.country;

        LoadCountry();

        function closeModal() {
            $mdDialog.hide();
        }

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, TaxLocation);
            promise.then(SaveSucces);
            promise.catch(errorSave);
        }

        function SaveSucces(data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function errorSave(data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.taxlocation')
        .controller('EditNewtaxlocationController', EditNewtaxlocationController);

    EditNewtaxlocationController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter', '$element'];

    /* @ngInject */
    function EditNewtaxlocationController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var TaxLocation = AppAPI.NewTaxLocation();

        // set constructor form
        Form.setObject(TaxLocation);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.Form.objForm.branchnpwpno = '';
        vm.Form.objForm.branchsignername = '';
        vm.Form.objForm.branchsignernpwp = '';
        vm.Form.objForm.branchaddress = '';
        vm.Form.objForm.branchcity = '';
        vm.saveData = saveData;

        vm.closeModal = closeModal;

        vm.country = $localStorage.country;

        vm.branch = 'PAYROLL.MENU.BRANCHNPWP';
        vm.sigher = 'PAYROLL.MENU.TAXSIGNERNPWP';
        if (vm.country == 'MYS') {
            vm.branch = 'PAYROLL.MENU.BRANCHPCB';
            vm.sigher = 'PAYROLL.MENU.TAXSIGNERPCB';
        }

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, TaxLocation);
            promise.then(function (data) {
                showDialog(ev, data);

            });
            promise.catch(function (data) {
                ShowFailed(ev, data)

            });


        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }


        function ShowFailed(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
    "use strict";
    /**
     *  Module
     *
     * Description
     */
    angular.module('app.payroll-new.publishthr', []).config(config);

    config.$inject=['$stateProvider'];

    function config($stateProvider) {

    $stateProvider
        .state('app.payroll_new_publishthr', {
            url    : '/new-payroll/publishthr',
            views  : {
                'content@app' : {
                templateUrl: 'app/main/payroll-new/publishthr/publishthr.html',
                controller : 'NewPublishThrController as vm'
                }
            }
                
        });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.publishthr')
        .controller('viewDetailNewPublishThrController', viewDetailNewPublishThrController);

        viewDetailNewPublishThrController.$inject = ['$mdDialog','data','$localStorage','config','AppAPI','DataService'];

    /* @ngInject */
    function viewDetailNewPublishThrController($mdDialog,data,$localStorage,config,AppAPI,DataService) {
        var vm = this; 

        var PublishThr = AppAPI.NewPublishThr();
        vm.closeModal=closeModal;
        vm.listData=data.logReader;

        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.items = [];

        loadData(1);

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadData(pageno) {
        var resp = vm.DataTables.loadData(PublishThr, pageno, {
            action: 'viewDetail',period:data.period,companyid:data.companyid,sub_area_id:data.sub_area_id,status:data.publish_status
        });
    
        resp.then(function(data) {
            vm.items = data.list;
        });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.publishthr')
        .controller('NewPublishThrController', NewPublishThrController);

    NewPublishThrController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth','$http','config','$element','$document'];

    /* @ngInject */
    function NewPublishThrController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth, $http,config,$element,$document) 
    {   
        var vm = this;
        var dt = new Date();
        var year = dt.getFullYear()-1;

        Form.initialForm();
        
        var PublishThr=AppAPI.NewPublishThr();

        Form.setObject(PublishThr);

        vm.Form = Form; 
        vm.company = $localStorage.empsite
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.viewDetail = viewDetail;
        vm.stateEdit=false;
        vm.processData = processData;
        vm.loadData = loadData
        vm.selectedItemChanged=selectedItemChanged;   
        vm.publish = publish;  
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        
        vm.Form.objForm.period = new Date();
        vm.Form.objForm.area = '';
        vm.Form.objForm.empno = '';
        
        vm.LoadArea = LoadArea
        vm.statusList = [{'id':'0','name':'Unpublish'},{'id':'1','name':'Publish'}]
        LoadCompany();
        LoadPeriod()
        LoadArea(vm.company);
        loadData(1);
        function loadData(pageno) {
                var resp = vm.DataTables.loadData(PublishThr, pageno, {
                    action: 'viewData',period:vm.period,company:vm.company,area:vm.area,status:vm.status,publishDate:vm.publishDate
                });
        
                resp.then(function(data) {
                    vm.selected = [];
                    vm.items = data.list;
                });
            }

        function LoadCompany() 
        {
                var response=PublishThr.query({action:'getCompany'});
                response.$promise.then(fetchCompany);
                response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) 
        {
                vm.listcompany=data;
        }

        function errorFetchCompany() 
        {
                vm.listcompany=[];
        } 
        
        function LoadArea(companyid) 
        {
                var response=PublishThr.query({action:'getArea', companyid:companyid});
                response.$promise.then(fetchArea);
                response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
                vm.listarea=data;
        }

        function errorFetchArea() {
                vm.listarea=[];
        } 

        function selectedItemChanged(employee)
        {        
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;
            }
        }

        function getEmployee(searchText)
        {
        return $http
            .get(config.api + 'api/payrollnew/NewPayrollprocess?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
            .then(function(item) {
                // Map the response object to the data object.
                if(item.data.length===''){
                Form.objForm.empno='';
                } 
                return item.data;
            });
        }

        function LoadPeriod()
        {
            var response=PublishThr.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) 
        {
                vm.listperiod=data;
        }

        function errorFetchPeriod() 
        {
                vm.listperiod=[];
        }

        function publish(ev) 
        {
            $mdDialog.show({
              controller: 'NewPublishThrController',
              controllerAs: 'vm',
              templateUrl: 'app/main/payroll-new/publishthr/form-input.html',
              parent: angular.element($document.body),
              targetEvent: ev,
              onRemoving: function(element, removePromise) {
                loadData(1);
              },
              clickOutsideToClose: true,
              fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function saveData(ev,formController)
        {       
                var period = vm.Form.objForm.period;
                var company = vm.company;
                
                var promise=Auth.setToken();
                promise.then(function(){
                    angular.element.blockUI();
                    vm.Form.objForm.companyid=vm.company;
                    var response=Form.saveData('save', formController, PublishThr);
                        response.then(fetchPublishThr);
                        response.catch(errorFetchPublishThr);
                });
        }

        function fetchPublishThr(data)
        {
            angular.element.unblockUI();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            showDialogInfo(data);
        }

        function showDialogInfo(data) 
        {
            $mdDialog
              .show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('#contentDialog')))
                  .clickOutsideToClose(true)
                  .title(data.title)
                  .textContent(data.messages)
                  .ariaLabel(data.title)
                  .ok('OK')
              )
              .then(function() {
                closeModal();
                loadData(1);
              });
          }

        function errorFetchPublishThr()
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed THR Process')
                .textContent('Process Data was Fail.')
                .ariaLabel('Failed Save Data')
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }     

        function closeModal()
        {
                $mdDialog.hide();
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function processData(ev,ls,type)
        {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                .confirm()
                .title('Would you like to '+ type +' this data ?')
                .textContent('')
                .ariaLabel('process dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        
                        vm.objForm = new PublishThr();
                        vm.objForm.action='save';
                        vm.objForm.type = type;
                        vm.objForm.period = ls.period;
                        vm.objForm.companyid = ls.companyid;
                        vm.objForm.sub_area_id = ls.sub_area_id;
                        var response = vm.objForm.$save();
                        
                        response.then(function(resp) {
                            closeModal();
                            angular.element.unblockUI();
                            showDialogInfo(resp);
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function viewDetail(ev,data)
        {
            $mdDialog.show({
                controller         : 'viewDetailNewPublishThrController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll-new/publishthr/view-detail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  data:data
                }
            }); 
        }
    }
})();
(function() {
    "use strict";
    /**
     *  Module
     *
     * Description
     */
    angular.module('app.payroll-new.publishpayslip', []).config(config);

    config.$inject=['$stateProvider'];

    function config($stateProvider) {

    $stateProvider
        .state('app.payroll_new_publishpayslip', {
            url    : '/new-payroll/publishpayslip',
            views  : {
                'content@app' : {
                templateUrl: 'app/main/payroll-new/publishpayslip/publishpayslip.html',
                controller : 'NewPublishPayslipController as vm'
                }
            }
                
        });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.publishpayslip')
        .controller('viewDetailNewPublishPayslipController', viewDetailNewPublishPayslipController);

        viewDetailNewPublishPayslipController.$inject = ['$mdDialog','data','$localStorage','config','AppAPI','DataService'];

    /* @ngInject */
    function viewDetailNewPublishPayslipController($mdDialog,data,$localStorage,config,AppAPI,DataService) {
        var vm = this; 

        var PublishPayslip = AppAPI.NewPublishPayslip();
        vm.closeModal=closeModal;
        vm.listData=data.logReader;

        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.items = [];

        loadData(1);

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadData(pageno) {
        var resp = vm.DataTables.loadData(PublishPayslip, pageno, {
            action: 'viewDetail',period:data.period,companyid:data.companyid,sub_area_id:data.sub_area_id,status:data.publish_status
        });
    
        resp.then(function(data) {
            vm.items = data.list;
        });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.publishpayslip')
        .controller('NewPublishPayslipController', NewPublishPayslipController);

    NewPublishPayslipController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth','$http','config','$element','$document','$filter'];

    /* @ngInject */
    function NewPublishPayslipController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth, $http,config,$element,$document,$filter) 
    {   
        var vm = this;
        var translate = $filter('translate');

        var dt = new Date();
        var year = dt.getFullYear()-1;

        Form.initialForm();
        
        var PublishPayslip=AppAPI.NewPublishPayslip();

        Form.setObject(PublishPayslip);

        vm.Form = Form; 
        vm.company = $localStorage.empsite
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.viewDetail = viewDetail;
        vm.stateEdit=false;
        vm.processData = processData;
        vm.loadData = loadData
        vm.selectedItemChanged=selectedItemChanged;   
        vm.publish = publish;  
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        
        vm.Form.objForm.period = new Date();
        vm.Form.objForm.area = '';
        vm.Form.objForm.empno = '';
        
        vm.country = $localStorage.country;
        vm.reqArea   = true;
        if(vm.country=='MYS'){
            vm.reqWil    = false;
            vm.LoadRegional  = loadRegional;
            vm.LoadCabang    = loadCabang;
            vm.LoadWilayah   = loadWilayah;
     
            loadWilayah();
        }

        vm.LoadArea = LoadArea
        vm.statusList = [{'id':'0','name':'Unpublish'},{'id':'1','name':'Publish'}]
        LoadCompany();
        LoadPeriod()
        LoadDefaultArea(vm.company);
        loadData(1);
        function loadData(pageno) {
                var resp = vm.DataTables.loadData(PublishPayslip, pageno, {
                    action: 'viewData',period:vm.period,company:vm.company,area:vm.area,status:vm.status,publishDate:vm.publishDate
                });
        
                resp.then(function(data) {
                    vm.selected = [];
                    vm.items = data.list;
                });
            }

        function LoadCompany() 
        {
                var response=PublishPayslip.query({action:'getCompany'});
                response.$promise.then(fetchCompany);
                response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) 
        {
                vm.listcompany=data;
        }

        function errorFetchCompany() 
        {
                vm.listcompany=[];
        } 
        
        function LoadDefaultArea(companyid) 
        {
                var response=PublishPayslip.query({action:'getArea', companyid:companyid});
                response.$promise.then(fetchArea);
                response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
                vm.listarea=data;
        }

        function errorFetchArea() {
                vm.listarea=[];
        } 

        function selectedItemChanged(employee)
        {        
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;
            }
        }

        function getEmployee(searchText)
        {
        return $http
            .get(config.api + 'api/payrollnew/NewPayrollprocess?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
            .then(function(item) {
                // Map the response object to the data object.
                if(item.data.length===''){
                Form.objForm.empno='';
                } 
                return item.data;
            });
        }

        function LoadPeriod()
        {
            var response=PublishPayslip.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) 
        {
                vm.listperiod=data;
        }

        function errorFetchPeriod() 
        {
                vm.listperiod=[];
        }

        function publish(ev) 
        {
            $mdDialog.show({
              controller: 'NewPublishPayslipController',
              controllerAs: 'vm',
              templateUrl: 'app/main/payroll-new/publishpayslip/form-input.html',
              parent: angular.element($document.body),
              targetEvent: ev,
              onRemoving: function(element, removePromise) {
                loadData(1);
              },
              clickOutsideToClose: true,
              fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function saveData(ev,formController)
        {       
                var period = vm.Form.objForm.period;
                var company = vm.company;
                
                var promise=Auth.setToken();
                promise.then(function(){
                    // var confirm = $mdDialog.confirm()
                    //                     .title('Would you like to publish?')
                    //                     .ariaLabel('delete dialog')
                    //                     .targetEvent(ev)
                    //                     .ok('YES')
                    //                     .cancel('no');
                
                // $mdDialog.show(confirm).then(function() {
                    
                    angular.element.blockUI();
                    vm.Form.objForm.companyid=vm.company;
                    vm.Form.objForm.wilayah=vm.wilayah;
                    vm.Form.objForm.regional=vm.regional;
                    vm.Form.objForm.cabang=vm.cabang;
                    var response=Form.saveData('save', formController, PublishPayslip);
                        response.then(fetchPublishPayslip);
                        response.catch(errorFetchPublishPayslip);
                // }, function() {
                //         angular.element.unblockUI();
                // });
                });
        }

        function fetchPublishPayslip(data)
        {
            angular.element.unblockUI();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            showDialogInfo(data);
        }

        function showDialogInfo(data) 
        {
            var expmess = data.pesan.split("_");
            if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
            }else{
                var message = translate(data.pesan);
            }

            $mdDialog
              .show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('#contentDialog')))
                  .clickOutsideToClose(true)
                  .title(data.title)
                  .textContent(message)
                  .ariaLabel(data.title)
                  .ok('OK')
              )
              .then(function() {
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/payroll-new/publishpayslip/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
              });
          }

        function errorFetchPublishPayslip()
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Payroll Process')
                .textContent('Process Data was Fail.')
                .ariaLabel('Failed Save Data')
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }     

        function closeModal()
        {
                $mdDialog.hide();
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function processData(ev,ls,type)
        {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                .confirm()
                .title('Would you like to '+ type +' this data ?')
                .textContent('')
                .ariaLabel('process dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        
                        vm.objForm = new PublishPayslip();
                        vm.objForm.action='save';
                        vm.objForm.type = type;
                        vm.objForm.period = ls.period;
                        vm.objForm.companyid = ls.companyid;
                        vm.objForm.sub_area_id = ls.sub_area_id;
                        var response = vm.objForm.$save();
                        
                        response.then(function(resp) {
                            angular.element.unblockUI();
                            showDialogInfo(resp);
                            loadData(1);
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function viewDetail(ev,data)
        {
            $mdDialog.show({
                controller         : 'viewDetailNewPublishPayslipController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll-new/publishpayslip/view-detail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  data:data
                }
            }); 
        }

        //new filter
        function LoadArea(company,cabangid) 
        {
            loadWilayah();
            var response=PublishPayslip.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadWilayah() {
          var response=PublishPayslip.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=PublishPayslip.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=PublishPayslip.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.ptkp', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) 
   {
   	    $stateProvider
            .state('app.payroll_new_ptkp', {
                url    : '/new-payroll/ptkp',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/ptkp/ptkp.html',
                    controller : 'NewPtkpController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.ptkp')
        .controller('NewPtkpController', NewPtkpController);

    NewPtkpController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth', '$filter'];

    /* @ngInject */
    function NewPtkpController(AppAPI,DataService,$mdDialog, Form, Auth, $filter) 
    {       
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/ptkp';

        var Ptkp=AppAPI.NewPtkp();
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.inputPtkp= inputPtkp;
        vm.lisPtkpSelected=[];
        vm.DeletePtkp=DeletePtkp;
        vm.editPtkp=editPtkp;

        loadData(1);

        function loadData(pageno) 
        {
            vm.DataTable.loadData(Ptkp,pageno,{action:'viewdata'});
        }

        function inputPtkp(ev)
        {
            $mdDialog.show({
                    controller         : 'InputNewPtkpController',
                    controllerAs       : 'vm',
                    templateUrl        : basePath+'/input-ptkp.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    }
                }); 
        }

        function editPtkp(ev,id)
        {
            $mdDialog.show({
                controller         : 'EditNewPtkpController',
                controllerAs       : 'vm',
                templateUrl        : basePath+'/input-ptkp.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                    id:id
                }
            });
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() 
        {
            vm.lisPtkpSelected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() 
        {
            vm.lisPtkpSelected=[];
        } 

        function closeModal()
        {
            $mdDialog.hide();
        }

        function DeletePtkp(ev) 
        { 
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note    = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes     = translate('PAYROLL.MESSAGE.YES');
            var no      = translate('PAYROLL.MESSAGE.NO');

            var promise=Auth.setToken();
                promise.then(function(){
                    var confirm = $mdDialog.confirm()
                        .title(message)
                        .textContent(note)
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok(yes)
                        .cancel(no);

                    $mdDialog.show(confirm).then(function() {
                        angular.element.blockUI();
                    var response=Ptkp.delete({action:'delete',data:angular.toJson(vm.lisPtkpSelected)});

                    response.$promise.then(loadData);
                }, function() {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.ptkp')
        .controller('InputNewPtkpController', InputNewPtkpController);

    InputNewPtkpController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$filter'];

    /* @ngInject */
    function InputNewPtkpController($localStorage,$mdDialog,Form,AppAPI,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;

        Form.initialForm();

        var Ptkp= AppAPI.NewPtkp();

        // set constructor form
        Form.setObject(Ptkp);

        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.Form.objForm.effective_date = new Date();
        
        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('save', formController, Ptkp);
            promise.then(SaveSucces);
            promise.catch(SaveSucces);
        }

        function SaveSucces(data)
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.ptkp')
        .controller('EditNewPtkpController', EditNewPtkpController);

    EditNewPtkpController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$filter'];

    /* @ngInject */
    function EditNewPtkpController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var Ptkp = AppAPI.NewPtkp();

        // set constructor form
        Form.setObject(Ptkp);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);    
            vm.Form.objForm.amount = parseInt(data.amount);
        }

            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() 
        {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, Ptkp);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(function(data){
                showDialog(ev,data)  
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.prorateparameter', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) 
   {
   	    $stateProvider
            .state('app.payroll_new_prorateparameter', {
                url    : '/new-payroll/prorateparameter',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/prorateparameter/prorateparameter.html',
                    controller : 'NewProrateparameterController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.prorateparameter')
        .controller('NewProrateparameterController', NewProrateparameterController);

    NewProrateparameterController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth', '$filter'];

    /* @ngInject */
    function NewProrateparameterController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth, $filter) 
    {   
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/prorateparameter';
        var ProrateParameter=AppAPI.NewProrateparameter();
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.inputProrateParameter= inputProrateParameter;
        vm.lisProrateParameterSelected=[];
        vm.DeleteProrateParameter=DeleteProrateParameter;
        vm.editProrateParameter=editProrateParameter;

        loadData(1);

        function loadData(pageno) 
        {
            vm.DataTable.loadData(ProrateParameter,pageno,{action:'viewdata'});
        }

        function inputProrateParameter(ev)
        {
            $mdDialog.show({
                    controller         : 'InputNewProrateparameterController',
                    controllerAs       : 'vm',
                    templateUrl        : basePath+'/input-prorateparameter.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    }
                }); 
        }

        function editProrateParameter(ev,id)
        {
            $mdDialog.show({
                controller         : 'EditNewProrateparameterController',
                controllerAs       : 'vm',
                templateUrl        : basePath+'/input-prorateparameter.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                    id:id
                }
            });
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() 
        {
            vm.lisprorateparameterSelected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() 
        {
            vm.lisprorateparameterSelected=[];
        } 

        function closeModal()
        {
            $mdDialog.hide();
        }

        function DeleteProrateParameter(ev) 
        { 
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note    = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes     = translate('PAYROLL.MESSAGE.YES');
            var no      = translate('PAYROLL.MESSAGE.NO');

            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                .title(message)
                .textContent(note)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=ProrateParameter.delete({action:'delete',data:angular.toJson(vm.lisProrateParameterSelected)});

                    response.$promise.then(loadData);
                }, function() {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.prorateparameter')
        .controller('InputNewProrateparameterController', InputNewProrateparameterController);

    InputNewProrateparameterController.$inject = ['$localStorage','$mdDialog','Form','AppAPI', '$filter'];

    /* @ngInject */
    function InputNewProrateparameterController($localStorage,$mdDialog,Form,AppAPI,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;

        Form.initialForm();

        var ProrateParameter= AppAPI.NewProrateparameter();
        // set constructor form
        Form.setObject(ProrateParameter);

        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal; 
        vm.LoadSalcom = LoadSalcom;
        vm.LoadAllPeriod = LoadAllPeriod;
        vm.LoadCompany = LoadCompany;
        vm.listtype = ['Working Days', 'Fix Days', 'Calendar Days','Working Days Actual'];
        vm.amountTypes = [
        {'value' : 'daily','label' : 'Daily'},
        {'value' : 'monthly','label' : 'Monthly'}
        ];
        vm.changePayrollBase = changePayrollBase;
        vm.changePayrollPost = changePayrollPost; 
        vm.saveData=saveData;
        vm.Form.objForm.fixdays = 0;
        vm.changeType = changeType;

        LoadSalcom();
        LoadAllPeriod();
        LoadCompany();

        function changeType(id)
        {
            if(id != 'Fix Days')
            {
                document.getElementById('fixdays').disabled = true;
                document.getElementById('fixdays').style.backgroundColor = "lightgrey";
            }else{
                document.getElementById('fixdays').style.backgroundColor = "white";
                document.getElementById('fixdays').disabled = false;
            }    
          
        }

        function changePayrollBase(id)
        { 
            var resp=ProrateParameter.query({action:'getDetailSalcom',id:id})
            resp.$promise.then(fetchdetailsalcom);
            resp.$promise.catch(errorfetchdetailsalcom);
        }

        function fetchdetailsalcom(data)
        {
            vm.Form.objForm.payrollbasedesc = data[0].name;
        }

        function errorfetchdetailsalcom()
        {
            vm.Form.objForm.payrollbasedesc = [];
        }

        function changePayrollPost(id)
        { 
            var resp=ProrateParameter.query({action:'getDetailSalcom',id:id})
            resp.$promise.then(fetchdetailpayrollpost);
            resp.$promise.catch(errorfetchdetailpayrollpost);
        }

        function fetchdetailpayrollpost(data)
        {
            vm.Form.objForm.payrollpostdesc = data[0].name;
        }

        function errorfetchdetailpayrollpost()
        {
            vm.Form.objForm.payrollpostdesc = [];
        }

        function LoadSalcom() 
        {
            var response=ProrateParameter.query({action:'getPayrollCode'});
            response.$promise.then(fetchSalcom);
            response.$promise.catch(errorFetchSalcom);
        }

        function fetchSalcom(data) 
        {
            vm.listsalcom=data;
        }

        function errorFetchSalcom() 
        {
            vm.listsalcom=[];
        } 

        function LoadAllPeriod() 
        {
            var response=ProrateParameter.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPeriod);
            response.$promise.catch(errorFetchAllPeriod);
        }

        function fetchAllPeriod(data) 
        {
            vm.listallperiod=data;
        }

        function errorFetchAllPeriod() 
        {
            vm.listallperiod=[];
        } 

        function LoadCompany() 
        {
            var response=ProrateParameter.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) 
        {
            vm.listcompany=data;
        }

        function errorFetchCompany() 
        {
            vm.listcompany=[];
        }
        
        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('save', formController, ProrateParameter);
            promise.then(SaveSucces);
            promise.catch(errorSave);
        }

        function SaveSucces(data)
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                ).then(function(){
                    closeModal();
                });
        }

        function errorSave(data)
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);
            
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel('Data already exist')
                .ok('OK')
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.prorateparameter')
        .controller('EditNewProrateparameterController', EditNewProrateparameterController);

    EditNewProrateparameterController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$filter'];

    /* @ngInject */
    function EditNewProrateparameterController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var ProrateParameter = AppAPI.NewProrateparameter();

        // set constructor form
        Form.setObject(ProrateParameter);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadSalcom = LoadSalcom;
        vm.LoadAllPeriod = LoadAllPeriod;
        vm.LoadCompany = LoadCompany;
        vm.listtype = ['Working Days', 'Fix Days', 'Calendar Days','Working Days Actual'];
        vm.changePayrollBase = changePayrollBase;
        vm.saveData=saveData;
        vm.changeType = changeType;
        vm.amountTypes = [
            {'value' : 'daily','label' : 'Daily'},
            {'value' : 'monthly','label' : 'Monthly'}
        ];
          
        LoadSalcom();
        LoadAllPeriod();
        LoadCompany();

        function changeType(id)
        {
            if(id != 'Fix Days')
            {
                document.getElementById('fixdays').disabled = true;
                document.getElementById('fixdays').style.backgroundColor = "lightgrey";
            }else{
              document.getElementById('fixdays').style.backgroundColor = "white";
              document.getElementById('fixdays').disabled = false;
            
            }    
          
        }

        function changePayrollBase(id)
        { 
            var resp=ProrateParameter.query({action:'getDetailSalcom',id:id})
            resp.$promise.then(fetchdetailsalcom);
            resp.$promise.catch(errorfetchdetailsalcom);
        }

        function fetchdetailsalcom(data)
        {
            //vm.listPositiondetail=data;
            vm.Form.objForm.payrollbasedesc = data[0].name;
        }

        function errorfetchdetailsalcom()
        {
            //vm.listPositiondetail=[];
            vm.Form.objForm.payrollbasedesc = [];
        }

        function changePayrollPost(id)
        { 
            var resp=ProrateParameter.query({action:'getDetailSalcom',id:id})
            resp.$promise.then(fetchdetailpayrollpost);
            resp.$promise.catch(errorfetchdetailpayrollpost);
        }

        function fetchdetailpayrollpost(data)
        {
            vm.Form.objForm.payrollpostdesc = data[0].name;
        }

        function errorfetchdetailpayrollpost()
        {
            vm.Form.objForm.payrollpostdesc = [];
        }

        function LoadSalcom() 
        {
        var response=ProrateParameter.query({action:'getPayrollCode'});
        response.$promise.then(fetchSalcom);
        response.$promise.catch(errorFetchSalcom);
        }

        function fetchSalcom(data) 
        {
            vm.listsalcom=data;
        }

        function errorFetchSalcom() 
        {
            vm.listsalcom=[];
        } 

        function LoadAllPeriod() 
        {
            var response=ProrateParameter.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPeriod);
            response.$promise.catch(errorFetchAllPeriod);
        }

        function fetchAllPeriod(data) 
        {
            vm.listallperiod=data;
        }

        function errorFetchAllPeriod() 
        {
            vm.listallperiod=[];
        } 
          
        function LoadCompany() 
        {
            var response=ProrateParameter.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) 
        {
            vm.listcompany=data;
        }

        function errorFetchCompany() 
        {
            vm.listcompany=[];
        }

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeData);

        function ChangeData(data)
        {
            vm.Form.objForm.fixdays = parseInt(data.fixdays);

            if(data.type != 'Fix Days')
            {
                document.getElementById('fixdays').disabled = true;
                document.getElementById('fixdays').style.backgroundColor = "lightgrey";
            }   
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() 
        {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, ProrateParameter);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
                showDialog(ev,data)  
               
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.payrollprocess')
        .controller('NewPayrollProcessController', NewPayrollProcessController);

    NewPayrollProcessController.$inject = ['$localStorage', 'AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', '$http', 'config', '$element', '$filter', '$scope'];

    /* @ngInject */
    function NewPayrollProcessController($localStorage, AppAPI, DataService, $mdDialog, Form, Auth, $http, config, $element, $filter, $scope) {

        var vm = this;
        var dt = new Date();
        var year = dt.getFullYear() - 1;

        var translate = $filter('translate');

        Form.initialForm();

        var PayrollProcess = AppAPI.NewPayrollProcess();

        Form.setObject(PayrollProcess);

        vm.Form = Form;

        vm.changeCompany = changeCompany;
        vm.country = $localStorage.country;
        vm.company = $localStorage.empsite
        vm.disabledPeriod = true;
        vm.saveData = saveData;
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.disableProcess = disableProcess;

        vm.Form.objForm.period = new Date();
        vm.Form.objForm.area = '';
        vm.Form.objForm.empno = '';

        vm.LoadArea = LoadArea

        LoadCountry();
        LoadCompany();
        LoadPeriod()
        LoadArea(vm.company);
        disableProcess();
        LoadItem(vm.period, vm.country, vm.company, vm.area);

        function disableProcess() {
            if (typeof vm.country == 'undefined' || typeof vm.company == 'undefined' || typeof vm.period == 'undefined' || typeof vm.area == 'undefined') {
                vm.disableButton = true;
            } else {
                vm.disableButton = false;
                LoadItem(vm.period, vm.country, vm.company, vm.area);
            }
        }

        function LoadItem(period, country, company, area) {
            var response = PayrollProcess.query({
                action: 'getProcessItem',
                period: period,
                area: area,
                country: country,
                company: company
            });
            response.$promise.then(fetchItem);
            response.$promise.catch(errorFetchItem);
        }

        function fetchItem(data) {
            vm.listData = data;
        }

        function errorFetchItem() {
            vm.listData = [];
        }

        function LoadCompany() {
            var response = PayrollProcess.query({
                action: 'getCompany',
                company: vm.company
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = PayrollProcess.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadArea(companyid) {
            disableProcess();
            var response = PayrollProcess.query({
                action: 'getArea',
                companyid: companyid,
                countryid: vm.country
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname;
                vm.isDisabled = true;
            }
        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/payrollnew/NewPayrollprocess?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function loadData(pageno) {
            vm.DataTable.loadData(PayrollProcess, pageno, {
                action: 'viewdata'
            });
        }

        function LoadPeriod() {
            angular.element.blockUI();
            var response = PayrollProcess.query({
                action: 'getPeriod'
            });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
            angular.element.unblockUI();
            vm.disabledPeriod = false;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function saveData(ev, target, isLastProcess, indexOrder) {
            var period = vm.period;

            var message = translate('PAYROLL.MESSAGE.CONFIRMPAYPROC');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            if (indexOrder == 1) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title(message)
                        .ariaLabel('dialog')
                        .targetEvent(ev)
                        .ok(yes)
                        .cancel(no);

                    $mdDialog.show(confirm).then(function () {
                        angular.element('#attView').block({
                            message: ' <span>Loading...</span>'
                        });
                        var periodTahun = period.substr(0, 4);
                        var periodBulan = period.substr(4, 2);

                        var monthStart = (parseInt(periodBulan) - 1);
                        var yearStart = periodTahun;
                        if (monthStart == 0) {
                            yearStart = periodTahun - 1;
                            monthStart = 12;
                        }

                        var startDate = yearStart + '-' + ("0" + monthStart).slice(-2) + '-' + 20;
                        var endDate = periodTahun + '-' + ("0" + periodBulan).slice(-2) + '-' + 19;
                        angular.element.blockUI();
                        var check = PayrollProcess.query({
                            action: 'checkDataPayroll',
                            startDate: startDate,
                            endDate: endDate,
                            companyid: vm.company,
                            country: vm.country,
                            area: (vm.area) ? vm.area : 0
                        });
                        check.$promise.then(function (dataStatusPayroll) {
                            angular.element.unblockUI();
                            $mdDialog.show({
                                controller: 'dataStatusPayrollController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/payroll-new/payrollprocess/data-status-payroll/data-status-payroll.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: false,
                                locals: {
                                    DataStatusPayroll: dataStatusPayroll,
                                },
                                onRemoving: function (element, removePromise) {
                                    LoadCompany();
                                    LoadPeriod()
                                    LoadArea(vm.company);
                                },
                                fullscreen: true // Only for -xs, -sm breakpoints.
                            }).then(function (answer) {
                                if (answer == 'proceed') {
                                    angular.element.blockUI();
                                    vm.objForm = new PayrollProcess();
                                    vm.objForm.action = 'save';
                                    vm.objForm.is_last_process = isLastProcess;
                                    vm.objForm.target = target;
                                    vm.objForm.index_order = indexOrder;
                                    vm.objForm.period = vm.period;
                                    vm.objForm.companyid = vm.company;
                                    vm.objForm.countryid = vm.country;
                                    vm.objForm.area = vm.area;
                                    vm.objForm.empno = vm.Form.objForm.empno
                                    var response = vm.objForm.$save();

                                    response.then(fetchPayroll);
                                    response.catch(errorFetchPayroll);
                                }
                            },
                                function () {
                                    console.log('You cancelled the dialog.');
                                });
                        });
                        check.$promise.catch(function () {
                            angular.element.blockUI();

                            vm.objForm = new PayrollProcess();
                            vm.objForm.action = 'save';
                            vm.objForm.period = vm.period;
                            vm.objForm.companyid = vm.company;
                            vm.objForm.countryid = vm.country;
                            vm.objForm.area = vm.area;
                            vm.objForm.target = target;
                            vm.objForm.index_order = indexOrder;
                            vm.objForm.is_last_process = isLastProcess;
                            vm.objForm.empno = vm.Form.objForm.empno
                            var response = vm.objForm.$save();

                            response.then(fetchPayroll);
                            response.catch(errorFetchPayroll);
                        });
                    }, function () {
                        angular.element('#attView').unblock();

                    });
                });
            } else {
                angular.element.blockUI();
                vm.objForm = new PayrollProcess();
                vm.objForm.action = 'save';
                vm.objForm.is_last_process = isLastProcess;
                vm.objForm.target = target;
                vm.objForm.index_order = indexOrder;
                vm.objForm.period = vm.period;
                vm.objForm.companyid = vm.company;
                vm.objForm.countryid = vm.country;
                vm.objForm.area = vm.area;
                vm.objForm.empno = vm.Form.objForm.empno
                var response = vm.objForm.$save();

                response.then(fetchPayroll);
                response.catch(errorFetchPayroll);
            }
        }

        function fetchPayroll(data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(message)
                    .ok('OK')
            ).then(function () {
                disableProcess();
                closeModal();
            });
        }

        function errorFetchPayroll() {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Payroll Process')
                    .textContent('Process Data was Fail.')
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
            ).then(function () {
                disableProcess();
                closeModal();
            });
            angular.element.unblockUI();
        }

        function statusClosed() {
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period = '';
            vm.company = '';
            vm.Form.objForm.area = '';
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Periode has been Closed, Payroll Can not be Proccesed')
                    .textContent('Process Data was Fail.')
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function statusPayroll() {
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period = '';
            vm.company = '';
            vm.Form.objForm.area = '';
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Sorry, Another user still processing this Payroll.')
                    .textContent('Try again in 15 minutes later.')
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
            angular.element.unblockUI();
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();

(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.positionrate', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) 
   {
   	    $stateProvider
            .state('app.payroll_new_positionrate', {
                url    : '/new-payroll/positionrate',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/positionrate/positionrate.html',
                    controller : 'NewPositionRateController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.positionrate')
        .controller('NewPositionRateController', NewPositionRateController);

    NewPositionRateController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth', '$filter'];

    /* @ngInject */
    function NewPositionRateController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth, $filter) 
    {   
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/positionrate';

        var PositionRate=AppAPI.NewPositionRate();
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.inputPositionRate= inputPositionRate;
        vm.lisPositionRateSelected=[];
        vm.DeletePositionRate=DeletePositionRate;
        vm.editPositionRate=editPositionRate;
        
        loadData(1);

        function loadData(pageno) 
        {
            vm.DataTable.loadData(PositionRate,pageno,{action:'viewdata'});
        }

        function inputPositionRate(ev)
        {
            $mdDialog.show({
                    controller         : 'InputNewpositionrateController',
                    controllerAs       : 'vm',
                    templateUrl        : basePath+'/input-positionrate.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    }
                }); 
        }

        function editPositionRate(ev,id)
        {
            $mdDialog.show({
                controller         : 'EditNewpositionrateController',
                controllerAs       : 'vm',
                templateUrl        : basePath+'/input-positionrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                    id:id
                }
            });
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() 
        {
            vm.lispositionrateSelected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() 
        {
            vm.lispositionrateSelected=[];
        } 
       
        function closeModal()
        {
            $mdDialog.hide();
        }

        function DeletePositionRate(ev) 
        { 
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note    = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes     = translate('PAYROLL.MESSAGE.YES');
            var no      = translate('PAYROLL.MESSAGE.NO');

            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                .title(message)
                .textContent(note)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=PositionRate.delete({action:'delete',data:angular.toJson(vm.lisPositionRateSelected)});

                    response.$promise.then(loadData);
                }, function() {
                    //
                });
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.positionrate')
        .controller('InputNewpositionrateController', InputNewpositionrateController);

    InputNewpositionrateController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$filter'];

    /* @ngInject */
    function InputNewpositionrateController($localStorage,$mdDialog,Form,AppAPI,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData=saveData;

        Form.initialForm();

        var PositionRate= AppAPI.NewPositionRate();

        // set constructor form
        Form.setObject(PositionRate);

        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal; 
        vm.changeCompany = changeCompany;
        vm.LoadPosition = LoadPosition;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadCompany = LoadCompany;
        vm.changePosition = changePosition;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.Form.objForm.effective_date = new Date();
        vm.Form.objForm.flag_prorate = 0;
        vm.Form.objForm.amount = 0;

        LoadPayroll();
        LoadCompany();
         
        function changePosition(id)
        { 
            vm.listPositiondetail=[];
            var resp=PositionRate.query({action:'getDetailPosition',id:id})
            resp.$promise.then(fetchdetailposition);
            resp.$promise.catch(errorfetchdetailposition);
        }

        function fetchdetailposition(data)
        {
            vm.Form.objForm.positiondesc = data[0].name;
        }

        function errorfetchdetailposition()
        {
            vm.Form.objForm.positiondesc = [];
        }

        function changePayroll(id)
        { 
            vm.listPayrolldetail=[];
            var resp=PositionRate.query({action:'getDetailPayroll',id:id})
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
            vm.Form.objForm.payrolldesc=data[0].name;
        }

        function errorfetchdetailpayroll()
        {
            vm.Form.objForm.payrolldesc=[];
        }

        function LoadPayroll() 
        {
            var response=PositionRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) 
        {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() 
        {
            vm.listpayrollcode=[];
        } 

        function changeCompany(companyId)
        { 
            vm.Form.objForm.positioncode = '';
            LoadPosition(companyId);
        }

        function LoadPosition(companyId) 
        {
            var response=PositionRate.query({action:'getPosition', company:companyId});
            response.$promise.then(fetchPosition);
            response.$promise.catch(errorFetchPosition);
        }

        function fetchPosition(data) 
        {
            vm.listposition=data;
        }

        function errorFetchPosition() 
        {
            vm.listposition=[];
        } 

        function LoadCompany() 
        {
            var response=PositionRate.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) 
        {
            vm.listcompany=data;
        }

        function errorFetchCompany() 
        {
            vm.listcompany=[];
        } 

        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('save', formController, PositionRate);
            
            promise.then(SaveSucces);
            promise.catch(errorSave);
        }

        function SaveSucces(data)
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function errorSave(data)
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel('Data already exist')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.positionrate')
        .controller('EditNewpositionrateController', EditNewpositionrateController);

    EditNewpositionrateController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$filter'];

    /* @ngInject */
    function EditNewpositionrateController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var PositionRate = AppAPI.NewPositionRate();

        // set constructor form
        Form.setObject(PositionRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadPosition = LoadPosition;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadCompany = LoadCompany;
        vm.changeCompany = changeCompany;
        vm.saveData=saveData;

        LoadPayroll();
        LoadCompany();
        
        function LoadPayroll() 
        {
            var response=PositionRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) 
        {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() 
        {
            vm.listpayrollcode=[];
        } 

        function changeCompany(companyId)
        { 
            vm.Form.objForm.positioncode = '';
            LoadPosition(companyId);
        }

        function LoadPosition(companyId) 
        {
            var response=PositionRate.query({action:'getPosition', company:companyId});
            response.$promise.then(fetchPosition);
            response.$promise.catch(errorFetchPosition);
        }

        function fetchPosition(data) 
        {
            vm.listposition=data;
        }

        function errorFetchPosition() 
        {
            vm.listposition=[];
        } 

        function LoadCompany() 
        {
            var response=PositionRate.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) 
        {
            vm.listcompany=data;
        }

        function errorFetchCompany() 
        {
            vm.listcompany=[];
        } 

        vm.closeModal = closeModal;   
        
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data)
        {
            LoadPosition(data.companyid);
            vm.Form.objForm.effective_date = new Date(data.effective_date);    
            vm.Form.objForm.amount = parseInt(data.amount);
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() 
        {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, PositionRate);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    closeModal();
                });
        }

       
        function ShowFailed(ev,data) 
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.payrollemployee', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_employee', {
                url    : '/new-payroll/payrollemployee',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/payrollemployee/payrollemployee.html',
                    controller : 'NewPayrollEmployeeController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.payrollemployee')
      .controller('NewUploademployeeController', NewUploademployeeController);
  
    NewUploademployeeController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function NewUploademployeeController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/NewPayrollemployee/uploadfile',
        removeAfterUpload: true,
        alias: 'fileemp',
        formData: [{
            action: 'upload'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewPayrollemployee/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function () {
    'use strict';

    angular
        .module('app.payroll-new.payrollemployee')
        .controller('NewPayrollEmployeeController', NewPayrollEmployeeController);

    NewPayrollEmployeeController.$inject = ['AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', 'FileUploader', 'config', '$localStorage', '$document', '$http', '$location', '$window', '$element', '$filter'];

    function NewPayrollEmployeeController(AppAPI, DataService, $mdDialog, Form, Auth, FileUploader, config, $localStorage, $document, $http, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/payrollemployee';
        Form.initialForm();

        var PayrollEmployee = AppAPI.NewPayrollEmployee();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        Form.setObject(PayrollEmployee);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputPayrollEmployee = inputPayrollEmployee;
        vm.lisPayrollEmployeeSelected = [];
        vm.DeletePayrollEmployee = DeletePayrollEmployee;
        vm.editPayrollEmployee = editPayrollEmployee;
        vm.openUploadEmployee = openUploadEmployee;
        vm.closeModal = closeModal;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.changeCompany = changeCompany;
        vm.LoadDivisi = LoadDivisi;
        vm.DownloadEmployee = DownloadEmployee;
        vm.company = $localStorage.empsite
        vm.country = $localStorage.country
        vm.lbpjscode = 'PAYROLL.MENU.BPJSCODE';

        vm.Form.objForm.empno = '';
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.arr_area = [];
        if (vm.country == 'MYS') {
            vm.lbpjscode = 'PAYROLL.MENU.BPJSCODEMYS';
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;

            loadWilayah();
        }

        //loadData(1);
        LoadCompany();
        LoadDivisi(vm.company);
        LoadDefaultArea(vm.company);

        vm.items = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return vm.lisPayrollEmployeeSelected.length !== 0 && vm.lisPayrollEmployeeSelected.length !== vm.items.length;
        }

        function isChecked() {
            return vm.lisPayrollEmployeeSelected.length === vm.items.length && vm.items.length != 0;
        }

        function toggleAll() {
            if (vm.lisPayrollEmployeeSelected.length === vm.items.length) {
                vm.lisPayrollEmployeeSelected = [];
            } else if (vm.lisPayrollEmployeeSelected.length === 0 || vm.lisPayrollEmployeeSelected.length > 0) {
                vm.lisPayrollEmployeeSelected = vm.items.slice(0);
            }
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }


            var resp = vm.DataTable.loadData(PayrollEmployee, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                country: vm.country,
                department: department,
                area: area,
                wilayah: vm.wilayah,
                regional: vm.regional,
                cabang: vm.cabang,
                divisi: divisi
            });

            resp.then(function (data) {
                angular.element.unblockUI();
                vm.lisPayrollEmployeeSelected = [];
                vm.items = data.list;
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/payrollnew/NewPayrollemployee?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = PayrollEmployee.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = PayrollEmployee.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(company, divisi) {
            var response = PayrollEmployee.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: divisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: companyid,
                regionalid: ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
            LoadDivisi(companyid)

        }

        function LoadDivisi(company) {
            var response = PayrollEmployee.query({
                action: 'getDivisi',
                idbu: company
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(company, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function inputPayrollEmployee(ev) {
            $mdDialog.show({
                controller: 'InputNewpayrollemployeeController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-payrollemployee.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    country: vm.country
                }
            });
        }

        function editPayrollEmployee(ev, id) {
            $mdDialog.show({
                controller: 'EditNewpayrollemployeeController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-payrollemployee.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id,
                    country: vm.country
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisPayrollEmployeeSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisPayrollEmployeeSelected = [];
        }


        function openUploadEmployee(ev) {
            $mdDialog.show({
                controller: 'NewUploademployeeController as vm',
                templateUrl: basePath + '/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }


        function DeletePayrollEmployee(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = PayrollEmployee.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisPayrollEmployeeSelected)
                    });

                    response.$promise.then(loadData);
                    response.$promise.catch(ErrDel);

                    loadData(1);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function DownloadEmployee(companyid, divisiid, departmentid, areaid, idemployee, wilayah, regional, cabang) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var country = vm.country;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewPayrollemployee/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + wilayah + '/' + regional + '/' + cabang + '/' + country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }


        function ErrDel() {
            alert("Sorry, Data can't delete. other transactions using this data");

        }

        function closeModal() {
            $mdDialog.hide();
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
//
(function () {
  'use strict';

  angular
    .module('app.payroll-new.payrollemployee')
    .controller('InputNewpayrollemployeeController', InputNewpayrollemployeeController);

  InputNewpayrollemployeeController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$filter', '$element', 'country'];

  /* @ngInject */
  function InputNewpayrollemployeeController($localStorage, $mdDialog, Form, AppAPI, $http, config, $filter, $element, country) {
    var vm = this;
    var translate = $filter('translate');
    vm.saveData = saveData;

    Form.initialForm();

    var Payrollemployee = AppAPI.NewPayrollEmployee();
    var PayrollProcess = AppAPI.NewPayrollProcess();

    // set constructor form
    Form.setObject(Payrollemployee);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    //vm.LoadEmpGroup = LoadEmpGroup;
    //vm.LoadCutoff = LoadCutoff;
    vm.LoadJamsostek = LoadJamsostek;
    vm.LoadTax = LoadTax;
    vm.LoadPTKP = LoadPTKP;
    vm.LoadOT = LoadOT;
    vm.LoadTaxLoc = LoadTaxLoc;
    vm.saveData = saveData;
    vm.Form.objForm.npwpno = '';
    vm.Form.objForm.cutoffcode = '';
    vm.Form.objForm.ptkpcode = '';

    vm.Form.objForm.empno = '';
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.changePayrollCode = changePayrollCode;

    vm.Form.objForm.country = country
    vm.lbpjscode = 'PAYROLL.MENU.BPJSCODE';
    vm.required = false;
    if (vm.Form.objForm.country == 'MYS') {
      vm.required = true;
      vm.lbpjscode = 'PAYROLL.MENU.BPJSCODEMYS';
    }

    LoadJamsostek();
    LoadTax();
    LoadPTKP();
    LoadOT();
    LoadTaxLoc();
    LoadEncashmentLeave();
    LoadCountry();

    function changePayrollCode() {
      LoadJamsostek();
      LoadTax();
      LoadPTKP();
      LoadOT();
      LoadTaxLoc();
      LoadEncashmentLeave();
    }

    function LoadCountry() {
      var response = PayrollProcess.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }

    function selectedItemChanged(employee) {

      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function getEmployee(searchText) {

      return $http
        .get(config.api + 'api/payrollnew/NewPayrollemployee?action=searchEmployee&id=' + searchText)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            Form.objForm.empno = '';
          }
          return item.data;
        });
    }

    /*function LoadEmpGroup() {
      var response=Payrollemployee.query({action:'getEmpGroup'});
      response.$promise.then(fetchEmpGroup);
      response.$promise.catch(errorFetchEmpGroup);
    }

    function fetchEmpGroup(data) {
      vm.listempgroup=data;
    }

    function errorFetchEmpGroup() {
      vm.listempgroup=[];
    } 

    function LoadCutoff() {
      var response=Payrollemployee.query({action:'getCutOffCode'});
      response.$promise.then(fetchCutOff);
      response.$promise.catch(errorFetchCutOff);
    }

    function fetchCutOff(data) {
      vm.listcutoffcode=data;
    }

    function errorFetchCutOff() {
      vm.listcutoffcode=[];
    } */

    function LoadJamsostek() {
      var response = Payrollemployee.query({ action: 'getJamsostek', country: vm.Form.objForm.country });
      response.$promise.then(fetchJamsostek);
      response.$promise.catch(errorFetchJamsostek);
    }

    function fetchJamsostek(data) {
      vm.listjamsostekcode = data;
    }

    function errorFetchJamsostek() {
      vm.listjamsostekcode = [];
    }

    function LoadTax() {
      var response = Payrollemployee.query({ action: 'getTax', country: vm.Form.objForm.country });
      response.$promise.then(fetchTax);
      response.$promise.catch(errorFetchTax);
    }

    function fetchTax(data) {
      vm.listtaxcode = data;
    }

    function errorFetchTax() {
      vm.listtaxcode = [];
    }

    function LoadPTKP() {
      var response = Payrollemployee.query({ action: 'getPTKP', country: vm.Form.objForm.country });
      response.$promise.then(fetchPTKP);
      response.$promise.catch(errorFetchPTKP);
    }

    function fetchPTKP(data) {
      vm.listptkp = data;
    }

    function errorFetchPTKP() {
      vm.listptkp = [];
    }

    function LoadOT() {
      var response = Payrollemployee.query({ action: 'getOTCode' });
      response.$promise.then(fetchOTCode);
      response.$promise.catch(errorFetchOTCode);
    }

    function fetchOTCode(data) {
      vm.listot = data;
    }

    function errorFetchOTCode() {
      vm.listot = [];
    }

    function LoadTaxLoc() {
      var response = Payrollemployee.query({ action: 'getTaxLocation', country: vm.Form.objForm.country });
      response.$promise.then(fetchTaxLoc);
      response.$promise.catch(errorFetchTaxLoc);
    }

    function fetchTaxLoc(data) {
      vm.listtaxlocation = data;
    }

    function errorFetchTaxLoc() {
      vm.listtaxlocation = [];
    }

    function LoadEncashmentLeave() {
      var response = Payrollemployee.query({ action: 'getEncashmentLeave', country: vm.Form.objForm.country });
      response.$promise.then(fetchEncashmentLeave);
      response.$promise.catch(errorFetchEncashmentLeave);
    }

    function fetchEncashmentLeave(data) {
      vm.listEncashmentLeave = data;
    }

    function errorFetchEncashmentLeave() {
      vm.listEncashmentLeave = [];
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, Payrollemployee);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(errorSave);
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }

    function errorSave(data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }
    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

  }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.payrollemployee')
        .controller('EditNewpayrollemployeeController', EditNewpayrollemployeeController);

    EditNewpayrollemployeeController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$http', '$filter', '$element', 'country'];

    /* @ngInject */
    function EditNewpayrollemployeeController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $http, $filter, $element, country) {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Payrollemployee = AppAPI.NewPayrollEmployee();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(Payrollemployee);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        //vm.LoadGroup = LoadGroup;
        //vm.LoadCutoff = LoadCutoff;
        vm.LoadJamsostek = LoadJamsostek;
        vm.LoadTax = LoadTax;
        vm.LoadPTKP = LoadPTKP;
        vm.LoadOT = LoadOT;
        vm.LoadTaxLoc = LoadTaxLoc;
        vm.saveData = saveData;
        vm.Form.objForm.npwpno = '';
        vm.Form.objForm.cutoffcode = '';
        vm.Form.objForm.ptkpcode = '';
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.country = country
        vm.changePayrollCode = changePayrollCode;

        vm.lbpjscode = 'PAYROLL.MENU.BPJSCODE';
        vm.required = false;
        if (vm.country == 'MYS') {
            vm.required = true;
            vm.lbpjscode = 'PAYROLL.MENU.BPJSCODEMYS';
        }
        LoadCountry()

        function changePayrollCode() {
            LoadJamsostek();
            LoadTax();
            LoadPTKP();
            LoadOT();
            LoadTaxLoc();
            LoadEncashmentLeave();
        }

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewPayrollemployee?action=searchEmployee&id=' + searchText)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadGroup() {
            var response = Payrollemployee.query({ action: 'getEmpGroup' });
            response.$promise.then(fetchGroup);
            response.$promise.catch(errorFetchGroup);
        }

        function fetchGroup(data) {
            vm.listempgroup = data;
        }

        function errorFetchGroup() {
            vm.listempgroup = [];
        }

        function LoadCutoff() {
            var response = Payrollemployee.query({ action: 'getCutOffCode' });
            response.$promise.then(fetchCutOff);
            response.$promise.catch(errorFetchCutOff);
        }

        function fetchCutOff(data) {
            vm.listcutoffcode = data;
        }

        function errorFetchCutOff() {
            vm.listcutoffcode = [];
        }

        function LoadJamsostek() {
            var response = Payrollemployee.query({ action: 'getJamsostek', country: country });
            response.$promise.then(fetchJamsostek);
            response.$promise.catch(errorFetchJamsostek);
        }

        function fetchJamsostek(data) {
            vm.listjamsostekcode = data;
        }

        function errorFetchJamsostek() {
            vm.listjamsostekcode = [];
        }

        function LoadTax() {
            var response = Payrollemployee.query({ action: 'getTax', country: country });
            response.$promise.then(fetchTax);
            response.$promise.catch(errorFetchTax);
        }

        function fetchTax(data) {
            vm.listtaxcode = data;
        }

        function errorFetchTax() {
            vm.listtaxcode = [];
        }

        function LoadPTKP() {
            var response = Payrollemployee.query({ action: 'getPTKP', country: country });
            response.$promise.then(fetchPTKP);
            response.$promise.catch(errorFetchPTKP);
        }

        function fetchPTKP(data) {
            vm.listptkp = data;
        }

        function errorFetchPTKP() {
            vm.listptkp = [];
        }

        function LoadOT() {
            var response = Payrollemployee.query({ action: 'getOTCode' });
            response.$promise.then(fetchOTCode);
            response.$promise.catch(errorFetchOTCode);
        }

        function fetchOTCode(data) {
            vm.listot = data;
        }

        function errorFetchOTCode() {
            vm.listot = [];
        }

        function LoadTaxLoc() {
            var response = Payrollemployee.query({ action: 'getTaxLocation', country: country });
            response.$promise.then(fetchTaxLocation);
            response.$promise.catch(errorFetchTaxLocation);
        }

        function fetchTaxLocation(data) {
            vm.listtaxlocation = data;
        }

        function errorFetchTaxLocation() {
            vm.listtaxlocation = [];
        }

        function LoadEncashmentLeave() {
            var response = Payrollemployee.query({ action: 'getEncashmentLeave', country: country });
            response.$promise.then(fetchEncashmentLeave);
            response.$promise.catch(errorFetchEncashmentLeave);
        }

        function fetchEncashmentLeave(data) {
            vm.listEncashmentLeave = data;
        }

        function errorFetchEncashmentLeave() {
            vm.listEncashmentLeave = [];
        }

        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });
        res.then(ChangeData);

        function ChangeData(data) {
            LoadJamsostek();
            LoadTax();
            LoadPTKP();
            LoadOT();
            LoadTaxLoc();
            LoadEncashmentLeave();
            vm.Form.objForm.country = country;
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name;
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {

            var promise = Form.saveData('update', formController, Payrollemployee);
            promise.then(function (data) {
                showDialog(ev, data);

            });
            promise.catch(function (data) {
                showDialog(ev, data)

            });


        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.otparameter', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) 
   {
   	    $stateProvider
            .state('app.payroll_new_otparameter', {
                url    : '/new-payroll/otparameter',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/otparameter/otparameter.html',
                    controller : 'NewOtParameterController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.otparameter')
        .controller('NewOtParameterController', NewOtParameterController);

    NewOtParameterController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth', '$filter'];

    /* @ngInject */
    function NewOtParameterController(AppAPI,DataService,$mdDialog, Form, Auth, $filter) 
    {       
        var vm = this;
        var translate = $filter('translate'); 
        var basePath = 'app/main/payroll-new/otparameter';

        var OtParameter=AppAPI.NewOtParameter();
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.inputOtParameter= inputOtParameter;
        vm.lisOtParameterSelected=[];
        vm.DeleteOtParameter=DeleteOtParameter;
        vm.editOtParameter=editOtParameter;

        loadData(1);

        function loadData(pageno) 
        {
            vm.DataTable.loadData(OtParameter,pageno,{action:'viewdata'});
        }

        function inputOtParameter(ev)
        {
            $mdDialog.show({
                    controller         : 'InputNewotparameterController',
                    controllerAs       : 'vm',
                    templateUrl        : basePath+'/input-otparameter.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    }
                }); 
        }

        function editOtParameter(ev,id)
        {
            $mdDialog.show({
                controller         : 'EditNewotparameterController',
                controllerAs       : 'vm',
                templateUrl        : basePath+'/input-otparameter.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                    id:id
                }
            });
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() 
        {
             vm.lisOtParameterSelected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() 
        {
            vm.lisOtParameterSelected=[];
        } 

        function closeModal()
        {
            $mdDialog.hide();
        }

        function DeleteOtParameter(ev) 
        { 
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note    = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes     = translate('PAYROLL.MESSAGE.YES');
            var no      = translate('PAYROLL.MESSAGE.NO');

            var promise=Auth.setToken();
            promise.then(function(){
                  var confirm = $mdDialog.confirm()
                .title(message)
                .textContent(note)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=OtParameter.delete({action:'delete',data:angular.toJson(vm.lisOtParameterSelected)});

                response.$promise.then(loadData);
                }, function() {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.otparameter', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_otparameter', {
                url    : '/payroll/otparameter',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/otparameter/otparameter.html',
                    controller : 'OtParameterController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.otparameter')
        .controller('InputNewotparameterController', InputNewotparameterController);

    InputNewotparameterController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$filter'];

    /* @ngInject */
    function InputNewotparameterController($localStorage,$mdDialog,Form,AppAPI,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData=saveData;

        Form.initialForm();

        var OtParameter= AppAPI.NewOtParameter();

        // set constructor form
        Form.setObject(OtParameter);

        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal; 
        vm.Form.objForm.multiple1 = 0;
        vm.Form.objForm.multiple2 = 0;
        vm.Form.objForm.multiple3 = 0;
        vm.Form.objForm.multiple4 = 0;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadAllPayroll = LoadAllPayroll;
        vm.saveData=saveData;
        vm.Form.objForm.formula = 0;

        vm.country = $localStorage.country;

        LoadPayroll();

        LoadAllPayroll();
          
        function LoadPayroll() 
        {
            var response=OtParameter.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) 
        {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() 
        {
            vm.listpayrollcode=[];
        } 

        function LoadAllPayroll() 
        {
            var response=OtParameter.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) 
        {
            vm.listallpayroll=data;
        }

        function errorFetchAllPayroll() 
        {
            vm.listallpayroll=[];
        } 

        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('save', formController, OtParameter);
            promise.then(SaveSucces);
            promise.catch(errorSave);
        }

        function SaveSucces(data)
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                ).then(function(){
                    closeModal();
                });
        }

        function errorSave(data)
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel('Data already exist')
                .ok('OK')
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.otparameter')
        .controller('EditNewotparameterController', EditNewotparameterController);

    EditNewotparameterController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$filter'];

    /* @ngInject */
    function EditNewotparameterController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var OtParameter = AppAPI.NewOtParameter();

        // set constructor form
        Form.setObject(OtParameter);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.LoadPayroll = LoadPayroll;

        vm.country = $localStorage.country;
        
        LoadPayroll();
          
        function LoadPayroll() 
        {
            var response=OtParameter.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) 
        {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() 
        {
            vm.listpayrollcode=[];
        } 

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(ChangeDate);

        function ChangeDate(data)
        {
            vm.Form.objForm.multiple1 = parseFloat(data.multiple1);
            vm.Form.objForm.multiple2 = parseFloat(data.multiple2);
            vm.Form.objForm.multiple3 = parseFloat(data.multiple3);
            vm.Form.objForm.multiple4 = parseFloat(data.multiple4);
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() 
        {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, OtParameter);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(function(data){
                showDialog(ev,data)  
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.nonfixentry-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_nonfixentry_mgr', {
                url    : '/new-payroll/nonfixentry-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/nonfixentry-mgr/nonfixentry.html',
                    controller : 'NewNonFixEntryMgrController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.nonfixentry-mgr')
      .controller('UploadNewNonFixEntryMgrController', UploadNewNonFixEntryMgrController);
  
    UploadNewNonFixEntryMgrController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function UploadNewNonFixEntryMgrController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/NewNonfixentry/uploadfilenonfixentry',
        removeAfterUpload: true,
        alias: 'filenonfixentry',
        formData: [{
            action: 'uploadfilenonfixentry',
            isMgr: true
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
  
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function(data, status) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        vm.uploadNotif = status
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewNonfixentry/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function () {
    'use strict';

    angular
        .module('app.payroll-new.nonfixentry-mgr')
        .controller('NewNonFixEntryMgrController', NewNonFixEntryMgrController);

    NewNonFixEntryMgrController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewNonFixEntryMgrController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var NonFixEntry = AppAPI.NewNonFixEntry();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();


        Form.setObject(NonFixEntry);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputNonFixEntry = inputNonFixEntry;
        vm.lisNonFixEntrySelected = [];
        vm.arr_area = [];
        vm.DeleteNonFixEntry = DeleteNonFixEntry;
        vm.editNonFixEntry = editNonFixEntry;
        vm.downloadAllowanceNonFix = downloadAllowanceNonFix;
        vm.changeCompany = changeCompany;
        vm.openUpload = openUpload;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.company = $localStorage.empsite

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');

        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        };

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(NonFixEntry, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                isMgr: true,
                divisi: divisi
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewNonfixentry?action=searchEmployee&id=' + searchText + '&company=' + vm.company + '&isMgr=true')
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = NonFixEntry.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = NonFixEntry.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(companyid, divisi) {
            var response = NonFixEntry.query({
                action: 'getDepartment',
                idbu: companyid,
                iddivisi: divisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = NonFixEntry.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function inputNonFixEntry(ev) {
            $mdDialog.show({
                controller: 'InputNewnonfixentryMgrController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/nonfixentry/input-nonfixentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editNonFixEntry(ev, id) {
            $mdDialog.show({
                controller: 'EditNewnonfixentryMgrController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/nonfixentry/edit-nonfixentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisNonFixEntrySelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisNonFixEntrySelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, NonFixEntry);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteNonFixEntry(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = NonFixEntry.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisNonFixEntrySelected)
                    });

                    response.$promise.then(function (data){
                        angular.element.unblockUI();
                        successDialog(ev,data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data){
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function successDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }
        
        function downloadAllowanceNonFix(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = true;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewNonfixentry/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + data.token, '_blank');
                //$window.open(protocol + '://' + host + config.api + 'api/payroll/nonfixentry/exportexcel/' + nik  + '/' + company  + '/' + department + '/'+ area + '/' + divisi + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadNewNonFixEntryMgrController as vm',
                templateUrl: 'app/main/payroll-new/nonfixentry/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.nonfixentry-mgr')
        .controller('InputNewnonfixentryMgrController', InputNewnonfixentryMgrController);

    InputNewnonfixentryMgrController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$scope','$filter'];

    /* @ngInject */
    function InputNewnonfixentryMgrController($localStorage,$mdDialog,Form,AppAPI,$http,config, $scope,$filter) {
          var vm = this;
          var translate = $filter('translate');
          var dt = new Date();
          var year = dt.getFullYear();
          vm.saveData=saveData;

          Form.initialForm();

          var NonFixEntry= AppAPI.NewNonFixEntry();


          // set constructor form
          Form.setObject(NonFixEntry);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.saveData=saveData;
          vm.getEmployee=getEmployee;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

          vm.Form.objForm.empno='';
          vm.Form.objForm.start_date = new Date();
          vm.Form.objForm.end_date = new Date();
          vm.amountTypes = [
            {'value' : 'daily','label' : 'Daily'},
            {'value' : 'monthly','label' : 'Monthly'}
          ];
          vm.isProrate = [
            {'value' : '1','label' : 'Yes'},
            {'value' : '0','label' : 'No'}
          ];
          
          LoadPayroll();
          /*LoadCutOffPeriod();*/
         
          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewNonfixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=NonFixEntry.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=NonFixEntry.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          /*
          function LoadCutOffPeriod() {
            var response=NonFixEntry.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
          }

          function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
          }

          function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
          } 
          */
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, NonFixEntry);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(function (data){
              errorDialog(data);
            });
          }

        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

          function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

         $scope.isDisabled = true;


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.nonfixentry-mgr')
        .controller('EditNewnonfixentryMgrController', EditNewnonfixentryMgrController);

    EditNewnonfixentryMgrController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function EditNewnonfixentryMgrController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var NonFixEntry = AppAPI.NewNonFixEntry();

        // set constructor form
        Form.setObject(NonFixEntry);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;
        vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

        vm.amountTypes = [
            {'value' : 'daily','label' : 'Daily'},
            {'value' : 'monthly','label' : 'Monthly'}
        ];
        vm.isProrate = [
            {'value' : '1','label' : 'Yes'},
            {'value' : '0','label' : 'No'}
        ];

        LoadPayroll();
        /*LoadCutOffPeriod();*/
         
        function selectedItemChanged(employee)
        {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
        }

        function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewNonfixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
        }

        function changePayroll(id)
        { 
              var resp=NonFixEntry.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=NonFixEntry.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        /*
        function LoadCutOffPeriod() {
            var response=NonFixEntry.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
        }

        function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
        }

        function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
        } 

        */
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.start_date = new Date(data.start_date); 
            vm.Form.objForm.end_date = new Date(data.end_date); 
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, NonFixEntry);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
               errorDialog(data)
            });


        }

        function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.nonfixentry', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_nonfixentry', {
                url    : '/new-payroll/nonfixentry',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/nonfixentry/nonfixentry.html',
                    controller : 'NewNonFixEntryController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.nonfixentry')
      .controller('UploadNewNonFixEntryController', UploadNewNonFixEntryController);
  
    UploadNewNonFixEntryController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function UploadNewNonFixEntryController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/NewNonfixentry/uploadfilenonfixentry',
        removeAfterUpload: true,
        alias: 'filenonfixentry',
        formData: [{
            action: 'uploadfilenonfixentry'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
  
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function(data, status) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
        vm.uploadNotif = status
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewNonfixentry/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function () {
    'use strict';

    angular
        .module('app.payroll-new.nonfixentry')
        .controller('NewNonFixEntryController', NewNonFixEntryController);

    NewNonFixEntryController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewNonFixEntryController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var NonFixEntry = AppAPI.NewNonFixEntry();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        Form.setObject(NonFixEntry);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputNonFixEntry = inputNonFixEntry;
        vm.lisNonFixEntrySelected = [];
        vm.arr_area = [];
        vm.DeleteNonFixEntry = DeleteNonFixEntry;
        vm.editNonFixEntry = editNonFixEntry;
        vm.downloadAllowanceNonFix = downloadAllowanceNonFix;
        vm.changeCompany = changeCompany;
        vm.openUpload = openUpload;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.company = $localStorage.empsite

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');

        vm.country = $localStorage.country;

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        if (vm.country == 'MYS' && vm.company == 'EN') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        };

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(NonFixEntry, pageno, {
                action: 'viewdata',
                nik: nik,
                country: vm.country,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewNonfixentry?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = NonFixEntry.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = NonFixEntry.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(companyid, divisi) {
            var response = NonFixEntry.query({
                action: 'getDepartment',
                idbu: companyid,
                iddivisi: divisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = NonFixEntry.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function inputNonFixEntry(ev) {
            $mdDialog.show({
                controller: 'InputNewnonfixentryController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/nonfixentry/input-nonfixentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    country: vm.country
                }
            });
        }

        function editNonFixEntry(ev, id) {
            $mdDialog.show({
                controller: 'EditNewnonfixentryController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/nonfixentry/edit-nonfixentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisNonFixEntrySelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisNonFixEntrySelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, NonFixEntry);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteNonFixEntry(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = NonFixEntry.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisNonFixEntrySelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function downloadAllowanceNonFix(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = false;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewNonfixentry/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + vm.country + '/' + data.token, '_blank');
                //$window.open(protocol + '://' + host + config.api + 'api/payroll/nonfixentry/exportexcel/' + nik  + '/' + company  + '/' + department + '/'+ area + '/' + divisi + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadNewNonFixEntryController as vm',
                templateUrl: 'app/main/payroll-new/nonfixentry/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();
(function () {
  'use strict';

  angular
    .module('app.payroll-new.nonfixentry')
    .controller('InputNewnonfixentryController', InputNewnonfixentryController);

  InputNewnonfixentryController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter', '$element', 'country'];

  /* @ngInject */
  function InputNewnonfixentryController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter, $element, country) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;

    Form.initialForm();

    var NonFixEntry = AppAPI.NewNonFixEntry();
    var PayrollProcess = AppAPI.NewPayrollProcess();

    // set constructor form
    Form.setObject(NonFixEntry);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.LoadPayroll = LoadPayroll;
    vm.changePayroll = changePayroll;
    vm.saveData = saveData;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.listperiod = [year + '01', year + '02', year + '03', year + '04', year + '05', year + '06', year + '07', year + '08', year + '09', year + '10', year + '11', year + '12'];

    vm.Form.objForm.country = country;
    vm.Form.objForm.empno = '';
    vm.Form.objForm.start_date = new Date();
    vm.Form.objForm.end_date = new Date();
    vm.amountTypes = [
      { 'value': 'daily', 'label': 'Daily' },
      { 'value': 'monthly', 'label': 'Monthly' }
    ];
    vm.isProrate = [
      { 'value': '1', 'label': 'Yes' },
      { 'value': '0', 'label': 'No' }
    ];

    vm.changePayrollCode = changePayrollCode;
    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
    LoadCountry()
    function LoadCountry() {
      var response = PayrollProcess.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }
    LoadPayroll();

    function changePayrollCode() {
      LoadPayroll();
    }

    function selectedItemChanged(employee) {

      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }

      console.log(vm.Form.objForm.empno);
    }

    function getEmployee(searchText) {

      return $http
        .get(config.api + 'api/payrollnew/NewNonfixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            Form.objForm.empno = '';
          }
          return item.data;
        });
    }

    function changePayroll(id) {
      var resp = NonFixEntry.query({ action: 'getDetailPayroll', id: id })
      resp.$promise.then(fetchdetailpayroll);
      resp.$promise.catch(errorfetchdetailpayroll);
    }

    function fetchdetailpayroll(data) {
      //vm.listPositiondetail=data;
      vm.Form.objForm.payrolldesc = data[0].name;
    }

    function errorfetchdetailpayroll() {
      //vm.listPositiondetail=[];
      vm.Form.objForm.payrolldesc = [];
    }

    function LoadPayroll() {
      var response = NonFixEntry.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
      response.$promise.then(fetchPayrollCode);
      response.$promise.catch(errorFetchPayrollCode);
    }

    function fetchPayrollCode(data) {
      vm.listpayrollcode = data;
    }

    function errorFetchPayrollCode() {
      vm.listpayrollcode = [];
    }

    /*
    function LoadCutOffPeriod() {
      var response=NonFixEntry.query({action:'getCutOffPeriod'});
      response.$promise.then(fetchCutOffPeriod);
      response.$promise.catch(errorFetchCutOffPeriod);
    }

    function fetchCutOffPeriod(data) {
      vm.listcutoff=data;
    }

    function errorFetchCutOffPeriod() {
      vm.listcutoff=[];
    } 
    */
    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, NonFixEntry);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }

    $scope.isDisabled = true;


  }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.nonfixentry')
        .controller('EditNewnonfixentryController', EditNewnonfixentryController);

    EditNewnonfixentryController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$http', '$filter', '$element'];

    /* @ngInject */
    function EditNewnonfixentryController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $http, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var NonFixEntry = AppAPI.NewNonFixEntry();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(NonFixEntry);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData = saveData;
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.listperiod = [year + '01', year + '02', year + '03', year + '04', year + '05', year + '06', year + '07', year + '08', year + '09', year + '10', year + '11', year + '12'];

        vm.amountTypes = [
            { 'value': 'daily', 'label': 'Daily' },
            { 'value': 'monthly', 'label': 'Monthly' }
        ];
        vm.isProrate = [
            { 'value': '1', 'label': 'Yes' },
            { 'value': '0', 'label': 'No' }
        ];

        vm.changePayrollCode = changePayrollCode;
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
        LoadCountry()
        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function changePayrollCode() {
            LoadPayroll();
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewNonfixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function changePayroll(id) {
            var resp = NonFixEntry.query({ action: 'getDetailPayroll', id: id })
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data) {
            //vm.listPositiondetail=data;
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll() {
            //vm.listPositiondetail=[];
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response = NonFixEntry.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode = data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode = [];
        }

        /*
        function LoadCutOffPeriod() {
            var response=NonFixEntry.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
        }

        function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
        }

        function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
        } 

        */
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });

        res.then(ChangeDate);

        function ChangeDate(data) {
            LoadPayroll();
            vm.Form.objForm.start_date = new Date(data.start_date);
            vm.Form.objForm.end_date = new Date(data.end_date);
            vm.Form.objForm.amount = parseInt(data.amount);
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {

            var promise = Form.saveData('update', formController, NonFixEntry);
            promise.then(function (data) {
                showDialog(ev, data);

            });
            promise.catch(function (data) {
                errorDialog(data)

            });


        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }


        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.laporanprosespayroll', ['app.payroll-new.laporanprosespayroll.payrolldetails']).config(config);

   //config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_payrollv', {
                url    : '/new-payroll/laporanprosespayroll',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/laporanprosespayroll/laporanprosespayroll.html',
                    controller : 'NewLaporanProsesPayrollController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.laporanprosespayroll')
        .controller('NewLaporanProsesPayrollController', NewLaporanProsesPayrollController);

    NewLaporanProsesPayrollController.$inject = ['$localStorage', 'AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', '$http', 'config', '$state', '$element', '$filter'];

    /* @ngInject */
    function NewLaporanProsesPayrollController($localStorage, AppAPI, DataService, $mdDialog, Form, Auth, $http, config, $state, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var Laporanprosespayroll = AppAPI.NewLaporanProsesPayroll();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();

        Form.setObject(Laporanprosespayroll);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.lisSalaryComponentSelected = [];
        vm.arr_area = [];
        vm.showData = showData;
        vm.LoadPeriod = LoadPeriod;
        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.setView = setView;
        vm.loadData = loadData;
        vm.LoadDivisi = LoadDivisi;
        vm.LoadArea = LoadArea;
        vm.company = $localStorage.empsite

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        vm.Form.objForm.empno = '';

        LoadPeriod();
        LoadCompany();
        LoadDivisi(vm.company);

        LoadArea(vm.company, '', '');

        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }


        function loadData(pageno) {
            var nik = '';
            var period = '';
            var company = '';
            var department = '';
            var divisi = '';
            var area = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.period) != 'undefined')
                period = vm.period;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(Laporanprosespayroll, pageno, {
                action: 'viewdata',
                nik: nik,
                period: period,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewLaporanprosespayroll?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }


        function LoadPeriod() {
            var response = Laporanprosespayroll.query({
                action: 'getPeriod'
            });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod = data;
        }

        function errorFetchPeriod() {
            vm.listperiod = [];
        }

        function LoadCompany() {
            var response = Laporanprosespayroll.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = Laporanprosespayroll.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = Laporanprosespayroll.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function showData(ev, formController) {
            $mdDialog.show({
                controller: 'NewShowpayrollController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/laporanprosespayroll/show-payroll.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: formController
                }
            });
        }



        function closeModal() {
            $mdDialog.hide();
        }

        function setView(nik, period) {
            var arrEmp = nik + '#' + period;
            $state.go('app.payroll_details', {
                id: arrEmp
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.jamsostek', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) 
   {
        $stateProvider.state('app.payroll_new_jamsostek', {
                    url    : '/new-payroll/jamsostek',
                    views  : {
                        'content@app' : {
                        templateUrl: 'app/main/payroll-new/jamsostek/jamsostek.html',
                        controller : 'NewJamsostekController as vm'
                        }
                    }
                    
                });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.jamsostek')
        .controller('NewJamsostekController', NewJamsostekController);

    NewJamsostekController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth', '$filter','$localStorage'];

    /* @ngInject */
    function NewJamsostekController(AppAPI,DataService,$mdDialog, Form, Auth, $filter, $localStorage) 
    {       
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/jamsostek';

        var Jamsostek=AppAPI.NewJamsostek();
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.inputJamsostek= inputJamsostek;
        vm.lisJamsostekSelected=[];
        vm.DeleteJamsostek=DeleteJamsostek;
        vm.editJamsostek=editJamsostek;
        vm.country = $localStorage.country;

        vm.header = 'PAYROLL.MENU.BPJSPARAMETER';
        if(vm.country=='MYS'){
            vm.header = 'PAYROLL.MENU.BPJSPARAMETERMYS';
        }
        loadData(1);

        function loadData(pageno) {

            vm.DataTable.loadData(Jamsostek,pageno,{action:'viewdata'});
        }
        
        function inputJamsostek(ev)
        {
            var template = basePath+'/input-jamsostek.html';
            if(vm.country=='MYS'){
                var template = basePath+'/input-jamsostekmys.html';
            }
            $mdDialog.show({
                    controller         : 'InputNewjamsostekController',
                    controllerAs       : 'vm',
                    templateUrl        : template,
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    }
                }); 
        }

        function editJamsostek(ev,id)
        {
            var template = basePath+'/input-jamsostek.html';
            if(vm.country=='MYS'){
                var template = basePath+'/input-jamsostekmys.html';
            }
            $mdDialog.show({
                controller         : 'EditNewjamsostekController',
                controllerAs       : 'vm',
                templateUrl        : template,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                    id:id
                }
            });
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() 
        {
            vm.lisJamsostekSelected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() 
        {
            vm.lisJamsostekSelected=[];
        }
       
        function closeModal()
        {
            $mdDialog.hide();
        }

        function DeleteJamsostek(ev) 
        { 
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note    = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes     = translate('PAYROLL.MESSAGE.YES');
            var no      = translate('PAYROLL.MESSAGE.NO');

            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                        .title(message)
                        .textContent(note)
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok(yes)
                        .cancel(no);

                $mdDialog.show(confirm).then(function() {
                        angular.element.blockUI();
                        var response=Jamsostek.delete({action:'delete',data:angular.toJson(vm.lisJamsostekSelected)});

                        response.$promise.then(loadData);
                }, function() {
                    // 
                });
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.jamsostek')
        .controller('InputNewjamsostekController', InputNewjamsostekController);

    InputNewjamsostekController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$filter'];

    /* @ngInject */
    function InputNewjamsostekController($localStorage,$mdDialog,Form,AppAPI,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData=saveData;

        Form.initialForm();

        var Jamsostek= AppAPI.NewJamsostek();

        // set constructor form
        Form.setObject(Jamsostek);

        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal; 
        vm.LoadSalcom = LoadSalcom;
        vm.LoadAllPayroll = LoadAllPayroll;
        vm.country = $localStorage.country;

        if(vm.country == 'MYS'){
            vm.Form.objForm.ee_socso = 0;
            vm.Form.objForm.er_socso = 0;
            vm.Form.objForm.ee_eis = 0;
            vm.Form.objForm.er_eis = 0;
            vm.Form.objForm.ee_epf = 0;
            vm.Form.objForm.er_epf = 0;
        }else{
            vm.Form.objForm.jkkemppct = 0;
            vm.Form.objForm.jkkcomppct = 0;
            vm.Form.objForm.jkmemppct = 0;
            vm.Form.objForm.jkmcomppct = 0;
            vm.Form.objForm.jhtemppct = 0;
            vm.Form.objForm.jhtcomppct = 0;
            vm.Form.objForm.bpjskesemppct = 0;
            vm.Form.objForm.jpemppct = 0;
            vm.Form.objForm.jpcomppct = 0;
        }
        
        //formula
        vm.Form.objForm.ratebpjs = '';
        
        vm.saveData=saveData;
        
        LoadSalcom();
        LoadAllPayroll();
          
        function LoadSalcom()
        {
            var response=Jamsostek.query({action:'getSalcom'});
            response.$promise.then(fetchSalcom);
            response.$promise.catch(errorFetchSalcom);
        }

        function fetchSalcom(data) 
        {
            vm.listsalcom=data;
        }

        function errorFetchSalcom() 
        {
            vm.listsalcom=[];
        } 

        function LoadAllPayroll()
        {
            var response=Jamsostek.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) 
        {
            vm.listallpayroll=data;
        }

        function errorFetchAllPayroll() 
        {
            vm.listallpayroll=[];
        } 

        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('save', formController, Jamsostek);
            promise.then(function(data){
                showDialog(ev,data);
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.jamsostek')
        .controller('EditNewjamsostekController', EditNewjamsostekController);

    EditNewjamsostekController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$filter'];

    /* @ngInject */
    function EditNewjamsostekController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var Jamsostek = AppAPI.NewJamsostek();

        // set constructor form
        Form.setObject(Jamsostek);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadSalcom = LoadSalcom;
        vm.LoadAllPayroll = LoadAllPayroll;
        vm.saveData=saveData;
        vm.country = $localStorage.country;

        LoadSalcom();
        LoadAllPayroll();

        function LoadSalcom()
        {
            var response=Jamsostek.query({action:'getSalcom'});
            response.$promise.then(fetchSalcom);
            response.$promise.catch(errorFetchSalcom);
        }

        function fetchSalcom(data) 
        {
            vm.listsalcom=data;
        }

        function errorFetchSalcom() 
        {
            vm.listsalcom=[];
        } 

        function LoadAllPayroll()
        {
            var response=Jamsostek.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) 
        {
            vm.listallpayroll=data;
        }

        function errorFetchAllPayroll() 
        {
            vm.listallpayroll=[];
        }
        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});

        res.then(ChangeData);

        function ChangeData(data)
        {
            if(vm.country == 'MYS'){
                vm.Form.objForm.ee_socso = parseFloat(data.ee_socso);
                vm.Form.objForm.er_socso = parseFloat(data.er_socso);
                vm.Form.objForm.ee_eis = parseFloat(data.ee_eis);
                vm.Form.objForm.er_eis = parseFloat(data.er_eis);
                vm.Form.objForm.ee_epf = parseFloat(data.ee_epf);
                vm.Form.objForm.er_epf = parseFloat(data.er_epf);
            }else{
                vm.Form.objForm.jkkemppct = parseFloat(data.jkkemppct);
                vm.Form.objForm.jkkcomppct = parseFloat(data.jkkcomppct);
                vm.Form.objForm.jkmemppct = parseFloat(data.jkmemppct);
                vm.Form.objForm.jkmcomppct = parseFloat(data.jkmcomppct);
                vm.Form.objForm.jhtemppct = parseFloat(data.jhtemppct);
                vm.Form.objForm.jhtcomppct = parseFloat(data.jhtcomppct);
                vm.Form.objForm.bpjskesemppct = parseFloat(data.bpjskesemppct);
                vm.Form.objForm.bpjskescomppct = parseFloat(data.bpjskescomppct);
                vm.Form.objForm.bpjsmaxrate = parseFloat(data.bpjsmaxrate);
                vm.Form.objForm.jpemppct = parseFloat(data.jpemppct);
                vm.Form.objForm.jpcomppct = parseFloat(data.jpcomppct);
                vm.Form.objForm.jpmaxrate = parseFloat(data.jpmaxrate);
            }
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() 
        {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, Jamsostek);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
                showDialog(ev,data)  
               
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.groupentry', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_groupentry', {
                url    : '/new-payroll/groupentry',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/groupentry/groupentry.html',
                    controller : 'NewGroupEntryController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
  'use strict';

  angular
    .module('app.payroll-new.groupentry')
    .controller('InputNewgroupentryController', InputNewgroupentryController);

  InputNewgroupentryController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$filter', '$element', 'country'];

  /* @ngInject */
  function InputNewgroupentryController($localStorage, $mdDialog, Form, AppAPI, $filter, $element, country) {
    var vm = this;
    var translate = $filter('translate');
    vm.saveData = saveData;

    Form.initialForm();

    var GroupEntry = AppAPI.NewGroupentry();
    var PayrollProcess = AppAPI.NewPayrollProcess();

    // set constructor form
    Form.setObject(GroupEntry);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    vm.LoadPayroll = LoadPayroll;
    vm.LoadGroup = LoadGroup;
    vm.changeGroup = changeGroup;
    vm.changePayroll = changePayroll;
    vm.saveData = saveData;
    vm.changePayrollCode = changePayrollCode;
    vm.Form.objForm.effective_date = new Date();
    vm.Form.objForm.flag_prorate = 0;
    vm.Form.objForm.country = country;

    LoadPayroll();
    LoadGroup();
    LoadCountry();

    function LoadCountry() {
      var response = PayrollProcess.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }

    function changePayrollCode() {
      LoadPayroll();
    }

    function changeGroup(id) {
      // console.log(id);
      var resp = GroupEntry.query({ action: 'getDetailGroup', id: id })
      resp.$promise.then(fetchdetailgroup);
      resp.$promise.catch(errorfetchdetailgroup);
    }

    function fetchdetailgroup(data) {
      //vm.listPositiondetail=data;
      vm.Form.objForm.groupdesc = data[0].name;
    }

    function errorfetchdetailgroup() {
      //vm.listPositiondetail=[];
      vm.Form.objForm.groupdesc = [];
    }

    function changePayroll(id) {
      // console.log(id);
      var resp = GroupEntry.query({ action: 'getDetailPayroll', id: id })
      resp.$promise.then(fetchdetailpayroll);
      resp.$promise.catch(errorfetchdetailpayroll);
    }

    function fetchdetailpayroll(data) {
      //vm.listPositiondetail=data;
      vm.Form.objForm.payrolldesc = data[0].name;
    }

    function errorfetchdetailpayroll() {
      //vm.listPositiondetail=[];
      vm.Form.objForm.payrolldesc = [];
    }

    function LoadPayroll() {
      var response = GroupEntry.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
      response.$promise.then(fetchPayrollCode);
      response.$promise.catch(errorFetchPayrollCode);
    }

    function fetchPayrollCode(data) {
      vm.listpayroll = data;
    }

    function errorFetchPayrollCode() {
      vm.listpayroll = [];
    }

    function LoadGroup() {
      var response = GroupEntry.query({ action: 'getGroup' });
      response.$promise.then(fetchGroup);
      response.$promise.catch(errorFetchGroup);
    }

    function fetchGroup(data) {
      vm.listgroup = data;
    }

    function errorFetchGroup() {
      vm.listgroup = [];
    }


    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, GroupEntry);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(errorSave);
    }

    function errorSave(data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel('Data already exist')
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.groupentry')
        .controller('NewGroupEntryController', NewGroupEntryController);

    NewGroupEntryController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$filter', '$element'];

    /* @ngInject */
    function NewGroupEntryController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $filter, $element) {

        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/groupentry';
        var GroupEntry = AppAPI.NewGroupentry();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputGroupEntry = inputGroupEntry;
        vm.lisGroupEntrySelected = [];
        vm.DeleteGroupEntry = DeleteGroupEntry;
        vm.editGroupEntry = editGroupEntry;

        vm.country = $localStorage.country;

        loadData(1);

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });


        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function loadData(pageno) {

            vm.DataTable.loadData(GroupEntry, pageno, { action: 'viewdata', country: vm.country });
        }



        function inputGroupEntry(ev) {
            $mdDialog.show({
                controller: 'InputNewgroupentryController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-groupentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    country: vm.country
                }
            });
        }

        function editGroupEntry(ev, id) {
            $mdDialog.show({
                controller: 'EditNewgroupentryController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/groupentry/input-groupentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
            //console.log(vm.listModulSelected);
        }

        function checkAll() {
            vm.lisgroupentrySelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisgroupentrySelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteGroupEntry(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = GroupEntry.delete({ action: 'delete', data: angular.toJson(vm.lisGroupEntrySelected) });

                    response.$promise.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.payroll-new.groupentry')
    .controller('EditNewgroupentryController', EditNewgroupentryController);

  EditNewgroupentryController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter', '$element'];

  /* @ngInject */
  function EditNewgroupentryController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter, $element) {
    var vm = this;
    var translate = $filter('translate');
    vm.saveData = saveData;

    // initial form
    Form.initialForm();

    var GroupEntry = AppAPI.NewGroupentry();
    var PayrollProcess = AppAPI.NewPayrollProcess();

    // set constructor form
    Form.setObject(GroupEntry);

    // set form to controller
    vm.Form = Form;
    vm.LoadPayroll = LoadPayroll;
    vm.LoadGroup = LoadGroup;
    vm.changeGroup = changeGroup;
    vm.changePayroll = changePayroll;
    vm.saveData = saveData;
    vm.changePayrollCode = changePayrollCode;

    LoadGroup();

    LoadCountry();

    function LoadCountry() {
      var response = PayrollProcess.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }

    function changePayrollCode() {
      LoadPayroll();
    }

    function changeGroup(id) {
      // console.log(id);
      var resp = GroupEntry.query({ action: 'getDetailGroup', id: id })
      resp.$promise.then(fetchdetailgroup);
      resp.$promise.catch(errorfetchdetailgroup);
    }

    function fetchdetailgroup(data) {
      //vm.listPositiondetail=data;
      vm.Form.objForm.groupdesc = data[0].name;
    }

    function errorfetchdetailgroup() {
      //vm.listPositiondetail=[];
      vm.Form.objForm.groupdesc = [];
    }

    function changePayroll(id) {
      // console.log(id);
      var resp = GroupEntry.query({ action: 'getDetailPayroll', id: id })
      resp.$promise.then(fetchdetailpayroll);
      resp.$promise.catch(errorfetchdetailpayroll);
    }

    function fetchdetailpayroll(data) {
      //vm.listPositiondetail=data;
      vm.Form.objForm.payrolldesc = data[0].name;
    }

    function errorfetchdetailpayroll() {
      //vm.listPositiondetail=[];
      vm.Form.objForm.payrolldesc = [];
    }

    function LoadPayroll() {
      var response = GroupEntry.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
      response.$promise.then(fetchPayrollCode);
      response.$promise.catch(errorFetchPayrollCode);
    }

    function fetchPayrollCode(data) {
      vm.listpayroll = data;
    }

    function errorFetchPayrollCode() {
      vm.listpayroll = [];
    }

    function LoadGroup() {
      var response = GroupEntry.query({ action: 'getGroup' });
      response.$promise.then(fetchGroup);
      response.$promise.catch(errorFetchGroup);
    }

    function fetchGroup(data) {
      vm.listgroup = data;
    }

    function errorFetchGroup() {
      vm.listgroup = [];
    }

    // console.log(id.listFingerLength);

    vm.closeModal = closeModal;

    ////////////////  
    var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });
    res.then(ChangeDate);

    function ChangeDate(data) {
      LoadPayroll();
      vm.Form.objForm.effective_date = new Date(data.effective_date);
      vm.Form.objForm.amount = parseInt(data.amount);
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }

    function saveData(ev, formController) {

      var promise = Form.saveData('update', formController, GroupEntry);
      promise.then(function (data) {
        showDialog(ev, data);

      });
      promise.catch(function (data) {
        showDialog(ev, data)

      });


    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      // console.log(ev);
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }


    function ShowFailed(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Save Data')
          .textContent(data.data.pesan)
          .ariaLabel('Failed Save Data')
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
      // console.log(data.data.pesan);
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.graderate', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_graderate', {
                url    : '/new-payroll/graderate',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/graderate/graderate.html',
                    controller : 'NewGradeRateController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.graderate')
        .controller('InputNewgraderateController', InputNewgraderateController);

    InputNewgraderateController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$filter', '$element'];

    /* @ngInject */
    function InputNewgraderateController($localStorage, $mdDialog, Form, AppAPI, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData = saveData;

        Form.initialForm();

        var GradeRate = AppAPI.NewGradeRate();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(GradeRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadGrade = LoadGrade;
        vm.LoadCompany = LoadCompany;
        vm.changePayroll = changePayroll;
        vm.saveData = saveData;
        vm.Form.objForm.effective_date = new Date();
        vm.Form.objForm.flag_prorate = 0;
        vm.Form.objForm.amount = 0;
        vm.company = $localStorage.empsite;
        vm.changePayrollCode = changePayrollCode;
        vm.Form.objForm.country = $localStorage.country;

        LoadPayroll();
        LoadCountry();
        LoadCompany();
        LoadDefaultArea(vm.company);
        LoadGrade(vm.company);
        vm.Form.objForm.companyid = vm.company

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function changePayrollCode() {
            LoadPayroll();
            LoadAllPayroll();
        }

        function LoadDefaultArea(companyid) {
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: companyid,
                regionalid: '',
                isForm: true,
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);

        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function changePayroll(id) {
            var resp = GradeRate.query({ action: 'getDetailPayroll', id: id })
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data) {
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll() {
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response = GradeRate.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode = data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode = [];
        }

        function LoadCompany() {
            var response = GradeRate.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadGrade(companyId) {
            LoadDefaultArea(companyId);
            var response = GradeRate.query({ action: 'getGrade', company: companyId });
            response.$promise.then(fetchGrade);
            response.$promise.catch(errorFetchGrade);
        }

        function fetchGrade(data) {
            vm.listgrade = data;
        }

        function errorFetchGrade() {
            vm.listgrade = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }


        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, GradeRate);
            promise.then(SaveSucces);
            promise.catch(errorSave);
        }

        function SaveSucces(data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function errorSave(data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel('Data already exist')
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }


        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.graderate')
        .controller('NewGradeRateController', NewGradeRateController);

    NewGradeRateController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$filter', '$element'];

    /* @ngInject */
    function NewGradeRateController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');

        var basePath = 'app/main/payroll-new/graderate';
        var GradeRate = AppAPI.NewGradeRate();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputGradeRate = inputGradeRate;
        vm.lisGradeRateSelected = [];
        vm.DeleteGradeRate = DeleteGradeRate;
        vm.editGradeRate = editGradeRate;
        vm.arr_area = [];
        loadData(1);
        LoadCompany();

        vm.reqArea = true;

        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.country = $localStorage.country;
        if (vm.country == 'MYS') {
            vm.lbpjscode = 'PAYROLL.MENU.BPJSCODEMYS';
            vm.reqWil = false;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;

            loadWilayah();
        }

        LoadDefaultArea(vm.company);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }
        function loadData(pageno) {
            var nik = '';
            var company = '';
            var area = '';

            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }

            vm.DataTable.loadData(GradeRate, pageno, {
                action: 'viewdata',
                company: vm.company,
                country: vm.country,
                area: area,
                wilayah: vm.wilayah,
                regional: vm.regional,
                cabang: vm.cabang
            });
        }

        function inputGradeRate(ev) {
            $mdDialog.show({
                controller: 'InputNewgraderateController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-graderate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editGradeRate(ev, id) {
            $mdDialog.show({
                controller: 'EditNewgraderateController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-graderate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisGradeRateSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisGradeRateSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteGradeRate(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = GradeRate.delete({ action: 'delete', data: angular.toJson(vm.lisGradeRateSelected) });

                    response.$promise.then(loadData);
                }, function () {
                    //
                });
            });
        }

        // new filter
        function LoadArea(company, cabangid, regionalid) {
            if (vm.country == 'MYS')
                loadWilayah();

            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function LoadCompany() {
            var response = PayrollEmployee.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDefaultArea(companyid) {
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: companyid,
                regionalid: ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);

        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.graderate')
        .controller('EditNewgraderateController', EditNewgraderateController);

    EditNewgraderateController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter', '$element'];

    /* @ngInject */
    function EditNewgraderateController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var GradeRate = AppAPI.NewGradeRate();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(GradeRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadGrade = LoadGrade;
        vm.LoadCompany = LoadCompany;
        vm.changePayroll = changePayroll;
        vm.saveData = saveData;
        vm.changePayrollCode = changePayrollCode;
        vm.Form.objForm.country = $localStorage.country;

        vm.company = $localStorage.empsite;

        LoadCountry();
        LoadCompany();
        LoadDefaultArea(vm.company);

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function changePayrollCode() {
            LoadPayroll();
            LoadAllPayroll();
        }

        function LoadDefaultArea(companyid) {
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: companyid,
                regionalid: '',
                isForm: true,
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function changePayroll(id) {
            var resp = GradeRate.query({ action: 'getDetailPayroll', id: id })
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data) {
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll() {
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response = GradeRate.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode = data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode = [];
        }

        function LoadCompany() {
            var response = GradeRate.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadGrade(companyId) {
            var response = GradeRate.query({ action: 'getGrade', company: companyId });
            response.$promise.then(fetchGrade);
            response.$promise.catch(errorFetchGrade);
        }

        function fetchGrade(data) {
            vm.listgrade = data;
        }

        function errorFetchGrade() {
            vm.listgrade = [];
        }

        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });
        res.then(ChangeDate);

        function ChangeDate(data) {
            LoadGrade(data.companyid);
            vm.Form.objForm.effective_date = new Date(data.effective_date);
            vm.Form.objForm.amount = parseInt(data.amount);
            LoadPayroll();
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, GradeRate);
            promise.then(function (data) {
                showDialog(ev, data);

            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }


        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.fixentry', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_fixentry', {
                url    : '/new-payroll/fixentry',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/fixentry/fixentry.html',
                    controller : 'NewFixEntryController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.fixentry')
      .controller('NewUploadNewFixEntryController', NewUploadNewFixEntryController);
  
    NewUploadNewFixEntryController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function NewUploadNewFixEntryController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) {
      var vm = this;
      var translate = $filter('translate');

      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/NewFixentry/uploadfile',
        removeAfterUpload: true,
        alias: 'filesalary',
        formData: [{
            action: 'uploadfile'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function(data, status) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        vm.uploadNotif = status
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewFixentry/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function () {
  'use strict';

  angular
    .module('app.payroll-new.fixentry')
    .controller('InputNewfixentryController', InputNewfixentryController);

  InputNewfixentryController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$filter', '$element', 'country'];

  /* @ngInject */
  function InputNewfixentryController($localStorage, $mdDialog, Form, AppAPI, $http, config, $filter, $element, country) {
    var vm = this;
    var translate = $filter('translate');
    vm.saveData = saveData;

    Form.initialForm();

    var FixEntry = AppAPI.NewFixEntry();
    var PayrollProcess = AppAPI.NewPayrollProcess();

    // set constructor form
    Form.setObject(FixEntry);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    vm.LoadPayroll = LoadPayroll;
    vm.changePayroll = changePayroll;
    vm.getEmployee = getEmployee;
    vm.saveData = saveData;
    vm.Form.objForm.country = country;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.changePayrollCode = changePayrollCode;
    vm.Form.objForm.effective_date = new Date();
    vm.Form.objForm.amount = 0;
    vm.Form.objForm.empno = '';
    vm.Form.objForm.flag_acting = 0;
    vm.amountTypes = [
      { 'value': 'daily', 'label': 'Daily' },
      { 'value': 'monthly', 'label': 'Monthly' }
    ];

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
    LoadCountry()
    function LoadCountry() {
      var response = PayrollProcess.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }
    LoadPayroll();

    function changePayrollCode() {
      LoadPayroll();
    }

    function selectedItemChanged(employee) {

      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }

    }

    function getEmployee(searchText) {

      return $http
        .get(config.api + 'api/payrollnew/NewFixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            Form.objForm.empno = '';
          }
          return item.data;
        });
    }

    function changePayroll(id) {
      var resp = FixEntry.query({ action: 'getDetailPayroll', id: id })
      resp.$promise.then(fetchdetailpayroll);
      resp.$promise.catch(errorfetchdetailpayroll);
    }

    function fetchdetailpayroll(data) {
      //vm.listPositiondetail=data;
      vm.Form.objForm.payrolldesc = data[0].name;
    }

    function errorfetchdetailpayroll() {
      //vm.listPositiondetail=[];
      vm.Form.objForm.payrolldesc = [];
    }

    function LoadPayroll() {
      var response = FixEntry.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
      response.$promise.then(fetchPayrollCode);
      response.$promise.catch(errorFetchPayrollCode);
    }

    function fetchPayrollCode(data) {
      vm.listpayrollcode = data;
    }

    function errorFetchPayrollCode() {
      vm.listpayrollcode = [];
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, FixEntry);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data)
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }


    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }


  }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.fixentry')
        .controller('NewFixEntryController', NewFixEntryController);

    NewFixEntryController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewFixEntryController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/fixentry';
        Form.initialForm();
        var FixEntry = AppAPI.NewFixEntry();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        Form.setObject(FixEntry);
        vm.Form = Form;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputFixEntry = inputFixEntry;
        vm.lisFixEntrySelected = [];
        vm.arr_area = [];
        vm.DeleteFixEntry = DeleteFixEntry;
        vm.editFixEntry = editFixEntry;
        vm.downloadInputSalary = downloadInputSalary;
        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.changeCompany = changeCompany;
        vm.LoadDivisi = LoadDivisi;
        vm.openUpload = openUpload;
        vm.company = $localStorage.empsite

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        vm.Form.objForm.empno = '';



        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');
        vm.country = $localStorage.country;

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        if (vm.country == 'MYS' && vm.company == 'EN') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }


        function LoadCompany() {
            var response = FixEntry.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = FixEntry.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = FixEntry.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }


        function LoadDivisi(companyid) {
            var response = FixEntry.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewFixentry?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }


        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(FixEntry, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                country: vm.country,
                department: department,
                area: area,
                divisi: divisi
            });
        }

        function inputFixEntry(ev) {
            $mdDialog.show({
                controller: 'InputNewfixentryController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-fixentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    country: vm.country
                }
            });
        }

        function editFixEntry(ev, id) {
            $mdDialog.show({
                controller: 'EditNewfixentryController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-fixentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id,
                    country: vm.country,
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisFixEntrySelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisFixEntrySelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, FixEntry);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteFixEntry(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = FixEntry.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisFixEntrySelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'NewUploadNewFixEntryController as vm',
                templateUrl: basePath + '/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function downloadInputSalary(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = false;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewFixentry/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.fixentry')
        .controller('EditNewfixentryController', EditNewfixentryController);

    EditNewfixentryController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$http', '$filter', '$element'];

    /* @ngInject */
    function EditNewfixentryController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $http, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var FixEntry = AppAPI.NewFixEntry();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(FixEntry);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData = saveData;
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.changePayrollCode = changePayrollCode;
        vm.amountTypes = [
            { 'value': 'daily', 'label': 'Daily' },
            { 'value': 'monthly', 'label': 'Monthly' }
        ];

        LoadPayroll();
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
        LoadCountry()
        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function changePayrollCode() {
            LoadPayroll();
        }
        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

            console.log(vm.Form.objForm.empno);
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewFixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function changePayroll(id) {
            var resp = FixEntry.query({ action: 'getDetailPayroll', id: id })
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data) {
            //vm.listPositiondetail=data;
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll() {
            //vm.listPositiondetail=[];
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response = FixEntry.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode = data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode = [];
        }


        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });
        res.then(ChangeDate);

        function ChangeDate(data) {
            LoadPayroll();
            vm.Form.objForm.effective_date = new Date(data.effective_date);
            vm.Form.objForm.amount = parseInt(data.amount);
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {

            var promise = Form.saveData('update', formController, FixEntry);
            promise.then(function (data) {
                showDialog(ev, data);

            });
            promise.catch(function (data) {
                errorDialog(data)
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.fixentry-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_fixentry_mgr', {
                url    : '/new-payroll/fixentry-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/fixentry-mgr/fixentry.html',
                    controller : 'NewFixEntryMgrController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.fixentry-mgr')
      .controller('NewUploadNewFixEntryMgrController', NewUploadNewFixEntryMgrController);
  
    NewUploadNewFixEntryMgrController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function NewUploadNewFixEntryMgrController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) {
      var vm = this;
      var translate = $filter('translate');

      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/NewFixentry/uploadfile',
        removeAfterUpload: true,
        alias: 'filesalary',
        formData: [{
            action: 'uploadfile',
            isMgr: true
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function(data, status) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        vm.uploadNotif = status
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewFixentry/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function() {
    'use strict';

    angular
        .module('app.payroll-new.fixentry-mgr')
        .controller('InputNewfixentryMgrController', InputNewfixentryMgrController);

    InputNewfixentryMgrController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$filter'];

    /* @ngInject */
    function InputNewfixentryMgrController($localStorage,$mdDialog,Form,AppAPI,$http,config,$filter) {
          var vm = this;
          var translate = $filter('translate');
          vm.saveData=saveData;

          Form.initialForm();

          var FixEntry= AppAPI.NewFixEntry();


          // set constructor form
          Form.setObject(FixEntry);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.getEmployee=getEmployee;
          vm.saveData=saveData;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.Form.objForm.effective_date = new Date();
          vm.Form.objForm.amount = 0;
          vm.Form.objForm.empno='';
          vm.Form.objForm.flag_acting = 0;
          vm.amountTypes = [
            {'value' : 'daily','label' : 'Daily'},
            {'value' : 'monthly','label' : 'Monthly'}
          ];
          
          LoadPayroll();
         
          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewFixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=FixEntry.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=FixEntry.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, FixEntry);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(function(data){
              angular.element.unblockUI();
              errorSave(data);
          });
          }

          function errorSave(data)
          {
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Failed')
              .textContent(data.data)
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }


          function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.fixentry-mgr')
        .controller('NewFixEntryMgrController', NewFixEntryMgrController);

    NewFixEntryMgrController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewFixEntryMgrController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/fixentry';
        Form.initialForm();
        var FixEntry = AppAPI.NewFixEntry();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();

        Form.setObject(FixEntry);
        vm.Form = Form;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputFixEntry = inputFixEntry;
        vm.lisFixEntrySelected = [];
        vm.arr_area = [];
        vm.DeleteFixEntry = DeleteFixEntry;
        vm.editFixEntry = editFixEntry;
        vm.downloadInputSalary = downloadInputSalary;
        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.changeCompany = changeCompany;
        vm.LoadDivisi = LoadDivisi;
        vm.openUpload = openUpload;
        vm.company = $localStorage.empsite

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        vm.Form.objForm.empno = '';



        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');
        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }


        function LoadCompany() {
            var response = FixEntry.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = FixEntry.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = FixEntry.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }


        function LoadDivisi(companyid) {
            var response = FixEntry.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewFixentry?action=searchEmployee&id=' + searchText + '&company=' + vm.company + '&isMgr=true')
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }


        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(FixEntry, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi,
                isMgr: true
            });
        }

        function inputFixEntry(ev) {
            $mdDialog.show({
                controller: 'InputNewfixentryMgrController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-fixentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editFixEntry(ev, id) {
            $mdDialog.show({
                controller: 'EditNewfixentryMgrController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-fixentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisFixEntrySelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisFixEntrySelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, FixEntry);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteFixEntry(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = FixEntry.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisFixEntrySelected)
                    });

                    response.$promise.then(function(data){
                        angular.element.unblockUI();
                        showDialog(ev,data);
                        loadData(1);
                    });
                    response.$promise.catch(function(data){
                        angular.element.unblockUI();
                        errorSave(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
        
        function errorSave(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'NewUploadNewFixEntryMgrController as vm',
                templateUrl: basePath + '/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function downloadInputSalary(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = true;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewFixentry/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.fixentry-mgr')
        .controller('EditNewfixentryMgrController', EditNewfixentryMgrController);

    EditNewfixentryMgrController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function EditNewfixentryMgrController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var FixEntry = AppAPI.NewFixEntry();

        // set constructor form
        Form.setObject(FixEntry);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;
        vm.amountTypes = [
            {'value' : 'daily','label' : 'Daily'},
            {'value' : 'monthly','label' : 'Monthly'}
        ];
        
        LoadPayroll();
       
        function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewFixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

        function changePayroll(id)
        { 
            var resp=FixEntry.query({action:'getDetailPayroll',id:id})
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
            //vm.listPositiondetail=data;
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
            //vm.listPositiondetail=[];
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=FixEntry.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

       
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);    
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, FixEntry);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
                angular.element.unblockUI();
                errorProcess(data);
            });
        }

        function errorProcess(data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed')
            .textContent(data.data)
            .ariaLabel('Data already exist')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function showDialog(ev,data) {
          // console.log(ev);
          var message = translate(data.pesan);
            var status  = translate(data.status);
            
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function () {
    "use strict";
    /**
     *  Module
     *
     * Description
     */
    angular.module('app.payroll-new.encashment-leave-paramenter', []).config(config);

    config.$inject = ['$stateProvider'];


    function config($stateProvider) {
        $stateProvider
            .state('app.payroll_new_echashment_leave_parameter', {
                url: '/new-payroll/encashment-leave-paramenter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/payroll-new/encashment-leave-paramenter/encashment-leave-paramenter.html',
                        controller: 'NewEncashmentLeaveParameterController as vm'
                    }
                }

            });
    }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.encashment-leave-paramenter')
        .controller('InputNewEncashmentLeaveParameterController', InputNewEncashmentLeaveParameterController);

    InputNewEncashmentLeaveParameterController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$filter'];

    /* @ngInject */
    function InputNewEncashmentLeaveParameterController($localStorage, $mdDialog, Form, AppAPI, $filter) {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData = saveData;

        Form.initialForm();

        var EncashmentLeave = AppAPI.EncashmentLeave();

        // set constructor form
        Form.setObject(EncashmentLeave);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadAllPayroll = LoadAllPayroll;
        vm.saveData = saveData;
        vm.Form.objForm.formula = '';
        vm.Form.objForm.fix_days = 0;
        vm.changeType = changeType;

        vm.country = $localStorage.country;

        LoadPayroll();
        LoadAllPayroll();
        LoadTypes();

        function changeType(id) {
            if (id != 2) {
                document.getElementById('fixdays').disabled = true;
                document.getElementById('fixdays').style.backgroundColor = "lightgrey";
            } else {
                document.getElementById('fixdays').style.backgroundColor = "white";
                document.getElementById('fixdays').disabled = false;
            }
        }

        function LoadPayroll() {
            var response = EncashmentLeave.query({ action: 'getPayrollCode' });
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode = data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode = [];
        }

        function LoadAllPayroll() {
            var response = EncashmentLeave.query({ action: 'getAllPayroll' });
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) {
            vm.listallpayroll = data;
        }

        function errorFetchAllPayroll() {
            vm.listallpayroll = [];
        }

        function LoadTypes() {
            var response = EncashmentLeave.query({ action: 'getTypes' });
            response.$promise.then(fetchTypes);
            response.$promise.catch(errorFetchTypes);
        }

        function fetchTypes(data) {
            vm.listTypes = data;
        }

        function errorFetchTypes() {
            vm.listTypes = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, EncashmentLeave);
            promise.then(SaveSucces);
            promise.catch(errorSave);
        }

        function SaveSucces(data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function errorSave(data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel('Data already exist')
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.encashment-leave-paramenter')
        .controller('NewEncashmentLeaveParameterController', NewEncashmentLeaveParameterController);

    NewEncashmentLeaveParameterController.$inject = ['AppAPI', 'DataService', '$mdDialog', 'Auth', '$filter'];

    /* @ngInject */
    function NewEncashmentLeaveParameterController(AppAPI, DataService, $mdDialog, Auth, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/encashment-leave-paramenter';

        var EncashmentLeave = AppAPI.EncashmentLeave();
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputEncashmentLeave = inputEncashmentLeave;
        vm.lisEncashmentLeaveSelected = [];
        vm.DeleteEncashmentLeave = DeleteEncashmentLeave;
        vm.editEncashmentLeave = editEncashmentLeave;

        loadData(1);

        function loadData(pageno) {
            vm.DataTable.loadData(EncashmentLeave, pageno, { action: 'viewdata' });
        }

        function inputEncashmentLeave(ev) {
            $mdDialog.show({
                controller: 'InputNewEncashmentLeaveParameterController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-encashment-leave-paramenter.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editEncashmentLeave(ev, id) {
            $mdDialog.show({
                controller: 'EditNewEncashmentLeaveParameterController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-encashment-leave-paramenter.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisEncashmentLeaveSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisEncashmentLeaveSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteEncashmentLeave(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = EncashmentLeave.delete({ action: 'delete', data: angular.toJson(vm.lisEncashmentLeaveSelected) });

                    response.$promise.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.encashment-leave-paramenter')
        .controller('EditNewEncashmentLeaveParameterController', EditNewEncashmentLeaveParameterController);

    EditNewEncashmentLeaveParameterController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$filter'];

    /* @ngInject */
    function EditNewEncashmentLeaveParameterController($localStorage, id, $mdDialog, Form, AppAPI, $filter) {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var EncashmentLeave = AppAPI.EncashmentLeave();

        // set constructor form
        Form.setObject(EncashmentLeave);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadAllPayroll = LoadAllPayroll;
        vm.changeType = changeType;

        vm.country = $localStorage.country;

        LoadPayroll();
        LoadAllPayroll();
        LoadTypes();

        function LoadTypes() {
            var response = EncashmentLeave.query({ action: 'getTypes' });
            response.$promise.then(fetchTypes);
            response.$promise.catch(errorFetchTypes);
        }

        function fetchTypes(data) {
            vm.listTypes = data;
        }

        function errorFetchTypes() {
            vm.listTypes = [];
        }

        function changeType(id) {
            if (id != 2) {
                document.getElementById('fixdays').disabled = true;
                document.getElementById('fixdays').style.backgroundColor = "lightgrey";
            } else {
                document.getElementById('fixdays').style.backgroundColor = "white";
                document.getElementById('fixdays').disabled = false;
            }
        }

        function LoadAllPayroll() {
            var response = EncashmentLeave.query({ action: 'getAllPayroll' });
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) {
            vm.listallpayroll = data;
        }

        function errorFetchAllPayroll() {
            vm.listallpayroll = [];
        }

        function LoadPayroll() {
            var response = EncashmentLeave.query({ action: 'getPayrollCode' });
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode = data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode = [];
        }

        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });

        res.then(ChangeDate);

        function ChangeDate(data) {
            vm.Form.objForm.fix_days = parseInt(data.fix_days);
            changeType(data.type)
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, EncashmentLeave);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                showDialog(ev, data)
            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.payroll-new.encashment-leave', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.payroll_new_encashment_leave', {
        url: '/new-payroll/encashment-leave',
        views: {
          'content@app': {
            templateUrl: 'app/main/payroll-new/encashment-leave/encashment-leave.html',
            controller: 'NewEncashmentLeaveController as vm'
          }
        }
      });
  }
}());
(function () {
  'use strict';
  angular
    .module('app.payroll-new.encashment-leave')
    .controller('UploadNewEncashmentLeaveController', UploadNewEncashmentLeaveController);

  UploadNewEncashmentLeaveController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadNewEncashmentLeaveController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/payrollnew/NewEncashmentLeaveManagement/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewEncashmentLeaveManagement/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';

  angular
    .module('app.payroll-new.encashment-leave')
    .controller('InputNewEncashmentLeaveController', InputNewEncashmentLeaveController);

  InputNewEncashmentLeaveController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter'];

  /* @ngInject */
  function InputNewEncashmentLeaveController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;

    Form.initialForm();

    var EncashmentLeaveManagement = AppAPI.EncashmentLeaveManagement();

    // set constructor form
    Form.setObject(EncashmentLeaveManagement);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.saveData = saveData;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;

    vm.Form.objForm.empno = '';
    vm.Form.objForm.start_date = new Date();
    vm.Form.objForm.end_date = new Date();

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;
      }
    }

    LoadMonth();
    LoadYear();

    function LoadMonth() {
      var response = EncashmentLeaveManagement.query({ action: 'getMonth' });
      response.$promise.then(fetchMonth);
      response.$promise.catch(errorFetchMonth);
    }

    function fetchMonth(data) {
      vm.listMonth = data;
    }

    function errorFetchMonth() {
      vm.listMonth = [];
    }

    function LoadYear() {
      var response = EncashmentLeaveManagement.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/payrollnew/NewEncashmentLeaveManagement?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            Form.objForm.empno = '';
          }
          return item.data;
        });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, EncashmentLeaveManagement);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    $scope.isDisabled = true;
  }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.encashment-leave')
        .controller('NewEncashmentLeaveController', NewEncashmentLeaveController);

    NewEncashmentLeaveController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewEncashmentLeaveController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var EncashmentLeaveManagement = AppAPI.EncashmentLeaveManagement();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();


        Form.setObject(EncashmentLeaveManagement);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputEncashmentLeaveManagement = inputEncashmentLeaveManagement;
        vm.lisEncashmentLeaveManagementSelected = [];
        vm.arr_area = [];
        vm.DeleteEncashmentLeaveManagement = DeleteEncashmentLeaveManagement;
        vm.editEncashmentLeaveManagement = editEncashmentLeaveManagement;
        vm.downloadData = downloadData;
        vm.changeCompany = changeCompany;
        vm.openUpload = openUpload;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.company = $localStorage.empsite

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');

        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        };

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function loadData(pageno) {
            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(EncashmentLeaveManagement, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi
            });
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/payrollnew/NewEncashmentLeaveManagement?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = EncashmentLeaveManagement.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = EncashmentLeaveManagement.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(companyid, divisi) {
            var response = EncashmentLeaveManagement.query({
                action: 'getDepartment',
                idbu: companyid,
                iddivisi: divisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = EncashmentLeaveManagement.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function inputEncashmentLeaveManagement(ev) {
            $mdDialog.show({
                controller: 'InputNewEncashmentLeaveController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/encashment-leave/input-encashment-leave.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editEncashmentLeaveManagement(ev, id) {
            $mdDialog.show({
                controller: 'EditNewEncashmentLeaveController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/encashment-leave/input-encashment-leave.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisEncashmentLeaveManagementSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisEncashmentLeaveManagementSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteEncashmentLeaveManagement(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = EncashmentLeaveManagement.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisEncashmentLeaveManagementSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function downloadData(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewEncashmentLeaveManagement/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadNewEncashmentLeaveController as vm',
                templateUrl: 'app/main/payroll-new/encashment-leave/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.encashment-leave')
        .controller('EditNewEncashmentLeaveController', EditNewEncashmentLeaveController);

    EditNewEncashmentLeaveController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', 'config', '$http', '$filter'];

    /* @ngInject */
    function EditNewEncashmentLeaveController($localStorage, id, $mdDialog, Form, AppAPI, config, $http, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var EncashmentLeaveManagement = AppAPI.EncashmentLeaveManagement();

        // set constructor form
        Form.setObject(EncashmentLeaveManagement);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.saveData = saveData;
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        LoadMonth();
        LoadYear();

        function LoadMonth() {
            var response = EncashmentLeaveManagement.query({ action: 'getMonth' });
            response.$promise.then(fetchMonth);
            response.$promise.catch(errorFetchMonth);
        }

        function fetchMonth(data) {
            vm.listMonth = data;
        }

        function errorFetchMonth() {
            vm.listMonth = [];
        }

        function LoadYear() {
            var response = EncashmentLeaveManagement.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;
            }
        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/payrollnew/NewEncashmentLeaveManagement?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });

        res.then(ChangeDate);

        function ChangeDate(data) {
            vm.Form.objForm.start_date = new Date(data.start_date);
            vm.Form.objForm.end_date = new Date(data.end_date);
            vm.Form.objForm.amount = parseInt(data.amount);
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, EncashmentLeaveManagement);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                errorDialog(data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.deductionfix-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_deductionfix_mgr', {
                url    : '/new-payroll/deductionfix-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/deductionfix-mgr/deductionfix.html',
                    controller : 'NewDeductionFixMgrController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.deductionfix-mgr')
        .controller('UploadNewDeductionNonFixMgrController', UploadNewDeductionNonFixMgrController);

    UploadNewDeductionNonFixMgrController.$inject = ['$mdDialog','$localStorage','FileUploader','config','$filter','Auth','$location','$window'];

    /* @ngInject */
    function UploadNewDeductionNonFixMgrController($mdDialog,$localStorage,FileUploader,config,$filter,Auth,$location,$window) {
         var vm = this;
         var translate = $filter('translate');
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        vm.detailInfo = []

        //////////////// 
        vm.DownloadTemplate = DownloadTemplate;
        function DownloadTemplate()
        {
            var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                    $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewDeductionnonfix/downloadtemplate', '_blank');
            },function(){
                
                $window.alert('gagal load token');
            });
        }
        
        var uploaderPhoto= vm.FileUpload= new FileUploader({
           url:config.api+'api/payrollnew/NewDeductionnonfix/uploadfile', 
           removeAfterUpload:true,
           alias:'fileemp',
           formData:[
              {
               action:'uploadfile',
               isMgr:true
              }
           ],
            onAfterAddingAll:function(){
                vm.uploadSuccess = false;
                vm.uploadError = false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(data, status, headers, config) {
            if ( status.status == 0 ) {
                vm.uploadSuccess = false;
                vm.uploadError   = true;
              } else {
                vm.uploadSuccess = true;
                vm.uploadError   = false;
              }
        
              var expmess = status.pesan.split("_");
              if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
              }else{
                  var message = translate(status.pesan);
              }
              vm.uploadNotif = message
              if ('moreInfo' in status && status.moreInfo.length>0) {
                  vm.isMoreInfo = true;
                  vm.detailInfo = status.moreInfo;
              }
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function(data, status)
        {
            vm.uploadSuccess = false;
            vm.uploadError = true;
            
            vm.uploadNotif = status
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function viewMoreInfo()
        {
          $mdDialog.show({
            controller         : 'logFailGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{
              data:vm.detailInfo
            }
          });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.deductionnonfix-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_deductionnonfix_mgr', {
                url    : '/new-payroll/deductionnonfix-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/deductionnonfix-mgr/deductionnonfix.html',
                    controller : 'NewDeductionNonFixMgrController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.deductionnonfix-mgr')
        .controller('InputNewdeductionnonfixMgrController', InputNewdeductionnonfixMgrController);

    InputNewdeductionnonfixMgrController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$scope','$filter'];

    /* @ngInject */
    function InputNewdeductionnonfixMgrController($localStorage,$mdDialog,Form,AppAPI,$http,config, $scope, $filter) {
          var vm = this;
          var translate = $filter('translate');
          var dt = new Date();
          var year = dt.getFullYear();
          vm.saveData=saveData;

          Form.initialForm();

          var DeductionNonFix= AppAPI.NewDeductionNonFix();


          // set constructor form
          Form.setObject(DeductionNonFix);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.saveData=saveData;
          vm.getEmployee=getEmployee;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

          vm.amountTypes = [
            {'value' : 'daily','label' : 'Daily'},
            {'value' : 'monthly','label' : 'Monthly'}
          ];
          vm.isProrate = [
            {'value' : '1','label' : 'Yes'},
            {'value' : '0','label' : 'No'}
          ];
          
          vm.Form.objForm.empno='';
          vm.Form.objForm.start_date = new Date();
          vm.Form.objForm.end_date = new Date();
          vm.Form.objForm.amount = 0;
          LoadPayroll();
          /*LoadCutOffPeriod();*/
         
          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewDeductionnonfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=DeductionNonFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=DeductionNonFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          /*
          function LoadCutOffPeriod() {
            var response=DeductionNonFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
          }

          function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
          }

          function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
          } 
          */
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, DeductionNonFix);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(function(data){
              errorDialog(data)     
            });
          }

          function errorDialog(data)
          {
              $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.querySelector('#contentDialog')))
                  .clickOutsideToClose(true)
                  .title('Failed')
                  .textContent(data.data)
                  .ariaLabel(data.data)
                  .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function errorSave(data){
            var message = translate(data.pesan);
            var status  = translate(data.status);

              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

         $scope.isDisabled = true;


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.deductionnonfix-mgr')
        .controller('EditNewdeductionnonfixMgrController', EditNewdeductionnonfixMgrController);

    EditNewdeductionnonfixMgrController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function EditNewdeductionnonfixMgrController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var DeductionNonFix = AppAPI.NewDeductionNonFix();

        // set constructor form
        Form.setObject(DeductionNonFix);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;
        vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];
        vm.amountTypes = [
            {'value' : 'daily','label' : 'Daily'},
            {'value' : 'monthly','label' : 'Monthly'}
          ];
          vm.isProrate = [
            {'value' : '1','label' : 'Yes'},
            {'value' : '0','label' : 'No'}
          ];
        LoadPayroll();
        /*LoadCutOffPeriod();*/
         
        function selectedItemChanged(employee)
        {
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
        }

        function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewDeductionnonfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
        }

        function changePayroll(id)
        { 
              var resp=DeductionNonFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=DeductionNonFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        /*
        function LoadCutOffPeriod() {
            var response=DeductionNonFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
        }

        function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
        }

        function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
        } 

        */
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.start_date = new Date(data.start_date); 
            vm.Form.objForm.end_date = new Date(data.end_date); 
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  
            var promise= Form.saveData('update', formController, DeductionNonFix);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
                errorDialog(data)     
            });


        }

        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.deductionnonfix-mgr')
        .controller('NewDeductionNonFixMgrController', NewDeductionNonFixMgrController);

    NewDeductionNonFixMgrController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewDeductionNonFixMgrController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');
        Form.initialForm();
        var DeductionNonFix = AppAPI.NewDeductionNonFix();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();

        Form.setObject(DeductionNonFix);

        vm.Form = Form;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputDeductionNonFix = inputDeductionNonFix;
        vm.lisDeductionNonFixSelected = [];
        vm.arr_area = [];
        vm.DeleteDeductionNonFix = DeleteDeductionNonFix;
        vm.editDeductionNonFix = editDeductionNonFix;
        vm.downloadDeductionNonFix = downloadDeductionNonFix;
        vm.changeCompany = changeCompany;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.openUpload = openUpload;
        vm.company = $localStorage.empsite

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');

        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadNewDeductionNonFixMgrController as vm',
                templateUrl: 'app/main/payroll-new/deductionnonfix/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(DeductionNonFix, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                isMgr: true,
                divisi: divisi
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewDeductionnonfix?action=searchEmployee&id=' + searchText + '&company=' + vm.company + '&isMgr=true')
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = DeductionNonFix.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = DeductionNonFix.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = DeductionNonFix.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = DeductionNonFix.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function inputDeductionNonFix(ev) {
            $mdDialog.show({
                controller: 'InputNewdeductionnonfixMgrController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/deductionnonfix/input-deductionnonfix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editDeductionNonFix(ev, id) {
            $mdDialog.show({
                controller: 'EditNewdeductionnonfixMgrController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/deductionnonfix/edit-deductionnonfix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisDeductionNonFixSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisDeductionNonFixSelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, DeductionNonFix);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteDeductionNonFix(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = DeductionNonFix.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisDeductionNonFixSelected)
                    });

                    response.$promise.then(function(data){
                        angular.element.unblockUI();
                        successDialog(ev,data);
                        loadData(1);
                    });
                    response.$promise.catch(function(data){
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function successDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function openUploadEmployee(ev) {
            $mdDialog.show({
                controller: 'UploadNewDeductionNonFixMgrController as vm',
                templateUrl: 'app/main/payroll-new/deductionnonfix/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function downloadDeductionNonFix(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = true;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewDeductionnonfix/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.deductionfix', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_deductionfix', {
                url    : '/new-payroll/deductionfix',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/deductionfix/deductionfix.html',
                    controller : 'NewDeductionFixController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.deductionfix')
        .controller('UploadNewDeductionNonFixController', UploadNewDeductionNonFixController);

    UploadNewDeductionNonFixController.$inject = ['$mdDialog','$localStorage','FileUploader','config','$filter','Auth','$location','$window'];

    /* @ngInject */
    function UploadNewDeductionNonFixController($mdDialog,$localStorage,FileUploader,config,$filter,Auth,$location,$window) {
         var vm = this;
         var translate = $filter('translate');
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        vm.detailInfo = []

        //////////////// 
        vm.DownloadTemplate = DownloadTemplate;
        function DownloadTemplate()
        {
            var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                    $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewDeductionnonfix/downloadtemplate', '_blank');
            },function(){
                
                $window.alert('gagal load token');
            });
        }

        var uploaderPhoto= vm.FileUpload= new FileUploader({
           url:config.api+'api/payrollnew/NewDeductionnonfix/uploadfile', 
           removeAfterUpload:true,
           alias:'fileemp',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.uploadSuccess = false;
                vm.uploadError = false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(data, status, headers, config) {
            if ( status.status == 0 ) {
                vm.uploadSuccess = false;
                vm.uploadError   = true;
              } else {
                vm.uploadSuccess = true;
                vm.uploadError   = false;
              }
        
              var expmess = status.pesan.split("_");
              if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
              }else{
                  var message = translate(status.pesan);
              }
              vm.uploadNotif = message
              if ('moreInfo' in status && status.moreInfo.length>0) {
                  vm.isMoreInfo = true;
                  vm.detailInfo = status.moreInfo;
              }
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function(data,status)
        {
            vm.uploadSuccess = false;
            vm.uploadError = true;
            
            vm.uploadNotif = status
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function viewMoreInfo()
        {
          $mdDialog.show({
            controller         : 'logFailGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{
              data:vm.detailInfo
            }
          });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.deductionnonfix', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_deductionnonfix', {
                url    : '/new-payroll/deductionnonfix',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/deductionnonfix/deductionnonfix.html',
                    controller : 'NewDeductionNonFixController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
  'use strict';

  angular
    .module('app.payroll-new.deductionnonfix')
    .controller('InputNewdeductionnonfixController', InputNewdeductionnonfixController);

  InputNewdeductionnonfixController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter', '$element', 'country'];

  /* @ngInject */
  function InputNewdeductionnonfixController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter, $element, country) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;

    Form.initialForm();

    var DeductionNonFix = AppAPI.NewDeductionNonFix();
    var PayrollProcess = AppAPI.NewPayrollProcess();

    // set constructor form
    Form.setObject(DeductionNonFix);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.LoadPayroll = LoadPayroll;
    vm.changePayroll = changePayroll;
    vm.saveData = saveData;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.listperiod = [year + '01', year + '02', year + '03', year + '04', year + '05', year + '06', year + '07', year + '08', year + '09', year + '10', year + '11', year + '12'];

    vm.amountTypes = [
      { 'value': 'daily', 'label': 'Daily' },
      { 'value': 'monthly', 'label': 'Monthly' }
    ];
    vm.isProrate = [
      { 'value': '1', 'label': 'Yes' },
      { 'value': '0', 'label': 'No' }
    ];

    vm.Form.objForm.country = country;
    vm.Form.objForm.empno = '';
    vm.Form.objForm.start_date = new Date();
    vm.Form.objForm.end_date = new Date();
    vm.Form.objForm.amount = 0;

    vm.changePayrollCode = changePayrollCode;
    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
    LoadCountry()
    function LoadCountry() {
      var response = PayrollProcess.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }
    LoadPayroll();

    function changePayrollCode() {
      LoadPayroll();
    }
    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function getEmployee(searchText) {

      return $http
        .get(config.api + 'api/payrollnew/NewDeductionnonfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            Form.objForm.empno = '';
          }
          return item.data;
        });
    }

    function changePayroll(id) {
      var resp = DeductionNonFix.query({ action: 'getDetailPayroll', id: id })
      resp.$promise.then(fetchdetailpayroll);
      resp.$promise.catch(errorfetchdetailpayroll);
    }

    function fetchdetailpayroll(data) {
      //vm.listPositiondetail=data;
      vm.Form.objForm.payrolldesc = data[0].name;
    }

    function errorfetchdetailpayroll() {
      //vm.listPositiondetail=[];
      vm.Form.objForm.payrolldesc = [];
    }

    function LoadPayroll() {
      var response = DeductionNonFix.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
      response.$promise.then(fetchPayrollCode);
      response.$promise.catch(errorFetchPayrollCode);
    }

    function fetchPayrollCode(data) {
      vm.listpayrollcode = data;
    }

    function errorFetchPayrollCode() {
      vm.listpayrollcode = [];
    }

    /*
    function LoadCutOffPeriod() {
      var response=DeductionNonFix.query({action:'getCutOffPeriod'});
      response.$promise.then(fetchCutOffPeriod);
      response.$promise.catch(errorFetchCutOffPeriod);
    }

    function fetchCutOffPeriod(data) {
      vm.listcutoff=data;
    }

    function errorFetchCutOffPeriod() {
      vm.listcutoff=[];
    } 
    */
    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, DeductionNonFix);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data)
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function errorSave(data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel('Data already exist')
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }

    $scope.isDisabled = true;


  }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.deductionnonfix')
        .controller('EditNewdeductionnonfixController', EditNewdeductionnonfixController);

    EditNewdeductionnonfixController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$http', '$filter', '$element'];

    /* @ngInject */
    function EditNewdeductionnonfixController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $http, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var DeductionNonFix = AppAPI.NewDeductionNonFix();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(DeductionNonFix);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData = saveData;
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.listperiod = [year + '01', year + '02', year + '03', year + '04', year + '05', year + '06', year + '07', year + '08', year + '09', year + '10', year + '11', year + '12'];
        vm.amountTypes = [
            { 'value': 'daily', 'label': 'Daily' },
            { 'value': 'monthly', 'label': 'Monthly' }
        ];
        vm.isProrate = [
            { 'value': '1', 'label': 'Yes' },
            { 'value': '0', 'label': 'No' }
        ];

        vm.changePayrollCode = changePayrollCode;
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
        LoadCountry()
        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function changePayrollCode() {
            LoadPayroll();
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;
            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewDeductionnonfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function changePayroll(id) {
            var resp = DeductionNonFix.query({ action: 'getDetailPayroll', id: id })
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data) {
            //vm.listPositiondetail=data;
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll() {
            //vm.listPositiondetail=[];
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response = DeductionNonFix.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode = data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode = [];
        }

        /*
        function LoadCutOffPeriod() {
            var response=DeductionNonFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
        }

        function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
        }

        function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
        } 

        */
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });

        res.then(ChangeDate);

        function ChangeDate(data) {
            LoadPayroll();
            vm.Form.objForm.start_date = new Date(data.start_date);
            vm.Form.objForm.end_date = new Date(data.end_date);
            vm.Form.objForm.amount = parseInt(data.amount);
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, DeductionNonFix);
            promise.then(function (data) {
                showDialog(ev, data);

            });
            promise.catch(function (data) {
                errorDialog(data)
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }


        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.deductionnonfix')
        .controller('NewDeductionNonFixController', NewDeductionNonFixController);

    NewDeductionNonFixController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewDeductionNonFixController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');
        Form.initialForm();
        var DeductionNonFix = AppAPI.NewDeductionNonFix();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        Form.setObject(DeductionNonFix);

        vm.Form = Form;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputDeductionNonFix = inputDeductionNonFix;
        vm.lisDeductionNonFixSelected = [];
        vm.arr_area = [];
        vm.DeleteDeductionNonFix = DeleteDeductionNonFix;
        vm.editDeductionNonFix = editDeductionNonFix;
        vm.downloadDeductionNonFix = downloadDeductionNonFix;
        vm.changeCompany = changeCompany;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.openUpload = openUpload;
        vm.company = $localStorage.empsite

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');

        vm.country = $localStorage.country;

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        if (vm.country == 'MYS' && vm.company == 'EN') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadNewDeductionNonFixController as vm',
                templateUrl: 'app/main/payroll-new/deductionnonfix/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(DeductionNonFix, pageno, {
                action: 'viewdata',
                nik: nik,
                country: vm.country,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewDeductionnonfix?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = DeductionNonFix.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = DeductionNonFix.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = DeductionNonFix.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = DeductionNonFix.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function inputDeductionNonFix(ev) {
            $mdDialog.show({
                controller: 'InputNewdeductionnonfixController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/deductionnonfix/input-deductionnonfix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    country: vm.country
                }
            });
        }

        function editDeductionNonFix(ev, id) {
            $mdDialog.show({
                controller: 'EditNewdeductionnonfixController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/deductionnonfix/input-deductionnonfix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisDeductionNonFixSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisDeductionNonFixSelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, DeductionNonFix);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteDeductionNonFix(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = DeductionNonFix.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisDeductionNonFixSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function openUploadEmployee(ev) {
            $mdDialog.show({
                controller: 'UploadNewDeductionNonFixController as vm',
                templateUrl: 'app/main/payroll-new/deductionnonfix/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function downloadDeductionNonFix(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = false;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewDeductionnonfix/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + vm.country + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.deductionfix-mgr')
        .controller('UploadNewDeductionFixMgrController', UploadNewDeductionFixMgrController);

    UploadNewDeductionFixMgrController.$inject = ['$mdDialog','$localStorage','FileUploader','config','$filter'];

    /* @ngInject */
    function UploadNewDeductionFixMgrController($mdDialog,$localStorage,FileUploader,config,$filter) {
         var vm = this;
         var translate = $filter('translate');
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        //////////////// 
        
        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/payrollnew/NewDeductionfix/uploadfile', 
           removeAfterUpload:true,
           alias:'fileemp',
           formData:[
              {
               action:'uploadfile',
               isMgr:true
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function(data,status)
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;

             vm.uploadNotif = status
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.deductionfix-mgr')
        .controller('NewInputdeductionfixMgrController', NewInputdeductionfixMgrController);

    NewInputdeductionfixMgrController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$scope','$filter'];

    /* @ngInject */
    function NewInputdeductionfixMgrController($localStorage,$mdDialog,Form,AppAPI,$http,config, $scope, $filter) {
          var vm = this;
          var translate = $filter('translate');
          var dt = new Date();
          var year = dt.getFullYear();
          vm.saveData=saveData;

          Form.initialForm();

          var DeductionFix= AppAPI.NewDeductionFix();


          // set constructor form
          Form.setObject(DeductionFix);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.saveData=saveData;
          vm.getEmployee=getEmployee;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

          vm.Form.objForm.empno='';
          vm.Form.objForm.flag_prorate = 0;
          vm.Form.objForm.effective_date = new Date();
          vm.Form.objForm.amount = 0;
          
          LoadPayroll();
          /*LoadCutOffPeriod();*/
         
          function selectedItemChanged(employee)
         {  
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewDeductionfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=DeductionFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=DeductionFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          /*
          function LoadCutOffPeriod() {
            var response=DeductionFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
          }

          function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
          }

          function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
          } 
          */
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, DeductionFix);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(function(data){
              errorDialog(data)     
            });
          }

          function errorDialog(data)
          {
              $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.querySelector('#contentDialog')))
                  .clickOutsideToClose(true)
                  .title('Failed')
                  .textContent(data.data)
                  .ariaLabel(data.data)
                  .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function errorSave(data){
            var message = translate(data.pesan);
            var status  = translate(data.status);

              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

         $scope.isDisabled = true;


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.deductionfix-mgr')
        .controller('EditNewdeductionfixMgrController', EditNewdeductionfixMgrController);

    EditNewdeductionfixMgrController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function EditNewdeductionfixMgrController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var DeductionFix = AppAPI.NewDeductionFix();

        // set constructor form
        Form.setObject(DeductionFix);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;
        vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

        LoadPayroll();
        /*LoadCutOffPeriod();*/
         
        function selectedItemChanged(employee)
        {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
        }

        function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewDeductionfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
        }

        function changePayroll(id)
        { 
              var resp=DeductionFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=DeductionFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        /*
        function LoadCutOffPeriod() {
            var response=DeductionFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
        }

        function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
        }

        function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
        } 

        */
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.effective_date = new Date(data.effective_date); 
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  
            var promise= Form.saveData('update', formController, DeductionFix);
            promise.then(function(data){
                showDialog(ev,data);
                
            });
            promise.catch(function(data){
                errorDialog(data)     
            });
        }

        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.deductionfix-mgr')
        .controller('NewDeductionFixMgrController', NewDeductionFixMgrController);

    NewDeductionFixMgrController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewDeductionFixMgrController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');
        Form.initialForm();

        var DeductionFix = AppAPI.NewDeductionFix();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();

        Form.setObject(DeductionFix);

        vm.Form = Form;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputDeductionFix = inputDeductionFix;
        vm.lisDeductionFixSelected = [];
        vm.arr_area = [];
        vm.DeleteDeductionFix = DeleteDeductionFix;
        vm.editDeductionFix = editDeductionFix;
        vm.downloadDeductionFix = downloadDeductionFix;
        vm.changeCompany = changeCompany;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.company = $localStorage.empsite

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');

        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(DeductionFix, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                isMgr: true,
                divisi: divisi
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewDeductionfix?action=searchEmployee&id=' + searchText + '&company=' + vm.company + '&isMgr=true')
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = DeductionFix.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = DeductionFix.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = DeductionFix.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = DeductionFix.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function inputDeductionFix(ev) {
            $mdDialog.show({
                controller: 'NewInputdeductionfixMgrController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/deductionfix/input-deductionfix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editDeductionFix(ev, id) {
            $mdDialog.show({
                controller: 'EditNewdeductionfixMgrController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/deductionfix/input-deductionfix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisDeductionFixSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisDeductionFixSelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, DeductionFix);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteDeductionFix(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = DeductionFix.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisDeductionFixSelected)
                    });

                    response.$promise.then(function(data){
                        angular.element.unblockUI();
                        successDialog(ev,data);
                        loadData(1);
                    });
                    response.$promise.catch(function(data){
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function successDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function openUploadEmployee(ev) {
            $mdDialog.show({
                controller: 'UploadNewDeductionFixMgrController as vm',
                templateUrl: 'app/main/payroll-new/deductionfix/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function downloadDeductionFix(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = true;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewDeductionfix/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.deductionfix')
        .controller('UploadNewDeductionFixController', UploadNewDeductionFixController);

    UploadNewDeductionFixController.$inject = ['$mdDialog','$localStorage','FileUploader','config','$filter'];

    /* @ngInject */
    function UploadNewDeductionFixController($mdDialog,$localStorage,FileUploader,config,$filter) {
         var vm = this;
         var translate = $filter('translate');
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        //////////////// 
        
        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/payrollnew/NewDeductionfix/uploadfile', 
           removeAfterUpload:true,
           alias:'fileemp',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function(data,status)
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
             vm.uploadNotif = status
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.deductionfix')
        .controller('NewInputdeductionfixController', NewInputdeductionfixController);

    NewInputdeductionfixController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$scope','$filter'];

    /* @ngInject */
    function NewInputdeductionfixController($localStorage,$mdDialog,Form,AppAPI,$http,config, $scope, $filter) {
          var vm = this;
          var translate = $filter('translate');
          var dt = new Date();
          var year = dt.getFullYear();
          vm.saveData=saveData;

          Form.initialForm();

          var DeductionFix= AppAPI.NewDeductionFix();


          // set constructor form
          Form.setObject(DeductionFix);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.saveData=saveData;
          vm.getEmployee=getEmployee;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

          vm.Form.objForm.empno='';
          vm.Form.objForm.flag_prorate = 0;
          vm.Form.objForm.effective_date = new Date();
          vm.Form.objForm.amount = 0;
          
          LoadPayroll();
          /*LoadCutOffPeriod();*/
         
          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewDeductionfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=DeductionFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=DeductionFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          /*
          function LoadCutOffPeriod() {
            var response=DeductionFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
          }

          function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
          }

          function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
          } 
          */
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, DeductionFix);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(function(data){
              errorDialog(data)     
            });
          }

          function errorDialog(data)
          {
              $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.querySelector('#contentDialog')))
                  .clickOutsideToClose(true)
                  .title('Failed')
                  .textContent(data.data)
                  .ariaLabel(data.data)
                  .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function errorSave(data){
            var message = translate(data.pesan);
            var status  = translate(data.status);

              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

         $scope.isDisabled = true;


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.deductionfix')
        .controller('EditNewdeductionfixController', EditNewdeductionfixController);

    EditNewdeductionfixController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function EditNewdeductionfixController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var DeductionFix = AppAPI.NewDeductionFix();

        // set constructor form
        Form.setObject(DeductionFix);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;
        vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

        LoadPayroll();
        /*LoadCutOffPeriod();*/
         
        function selectedItemChanged(employee)
        {      
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
        }

        function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewDeductionfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
        }

        function changePayroll(id)
        { 
              var resp=DeductionFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=DeductionFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        /*
        function LoadCutOffPeriod() {
            var response=DeductionFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
        }

        function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
        }

        function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
        } 

        */
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.effective_date = new Date(data.effective_date); 
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  
            var promise= Form.saveData('update', formController, DeductionFix);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
                errorDialog(data)
            });
        }

        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.deductionfix')
        .controller('NewDeductionFixController', NewDeductionFixController);

    NewDeductionFixController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewDeductionFixController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');
        Form.initialForm();

        var DeductionFix = AppAPI.NewDeductionFix();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();

        Form.setObject(DeductionFix);

        vm.Form = Form;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputDeductionFix = inputDeductionFix;
        vm.lisDeductionFixSelected = [];
        vm.arr_area = [];
        vm.DeleteDeductionFix = DeleteDeductionFix;
        vm.editDeductionFix = editDeductionFix;
        vm.downloadDeductionFix = downloadDeductionFix;
        vm.changeCompany = changeCompany;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.company = $localStorage.empsite

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');

        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }

        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(DeductionFix, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewDeductionfix?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = DeductionFix.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = DeductionFix.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = DeductionFix.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = DeductionFix.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function inputDeductionFix(ev) {
            $mdDialog.show({
                controller: 'NewInputdeductionfixController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/deductionfix/input-deductionfix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editDeductionFix(ev, id) {
            $mdDialog.show({
                controller: 'EditNewdeductionfixController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/deductionfix/input-deductionfix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisDeductionFixSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisDeductionFixSelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, DeductionFix);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteDeductionFix(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = DeductionFix.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisDeductionFixSelected)
                    });

                    response.$promise.then(function(data){
                        angular.element.unblockUI();
                        successDialog(ev,data);
                        loadData(1);
                    });
                    response.$promise.catch(function(data){
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function successDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function openUploadEmployee(ev) {
            $mdDialog.show({
                controller: 'UploadNewDeductionFixController as vm',
                templateUrl: 'app/main/payroll-new/deductionfix/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function downloadDeductionFix(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = false;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewDeductionfix/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.closepayroll', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_closepayroll', {
                url    : '/payroll/closepayroll',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/closepayroll/closepayroll.html',
                    controller : 'ClosePayrollController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.closepayroll')
        .controller('InputNewClosePayrollController', InputNewClosePayrollController);

    InputNewClosePayrollController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$filter'];

    /* @ngInject */
    function InputNewClosePayrollController($localStorage,$mdDialog,Form,AppAPI,$filter) {
          var vm = this;
          var translate = $filter('translate');
          vm.saveData=saveData;

          Form.initialForm();

          var ClosePayroll= AppAPI.NewClosePayroll();


          // set constructor form
          Form.setObject(ClosePayroll);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.saveData=saveData;
          vm.liststatus = ['OPEN', 'CLOSED'];
          vm.LoadCompany = LoadCompany;
          vm.LoadPeriod = LoadPeriod;

          LoadCompany();
          LoadPeriod();

          function LoadCompany() {
            var response=ClosePayroll.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
            vm.listcompany=data;
          }

          function errorFetchCompany() {
            vm.listcompany=[];
          } 

          function LoadPeriod() {
            var response=ClosePayroll.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
          }

          function fetchPeriod(data) {
            vm.listperiod=data;
          }

          function errorFetchPeriod() {
            vm.listperiod=[];
          } 
                    
          function closeModal()
          {
            $mdDialog.hide();
          }


          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, ClosePayroll);
            promise.then(function(data){
                showDialog(ev,data);
            });
          }

          function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.closepayroll', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_closepayroll', {
                url    : '/new-payroll/closepayroll',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/closepayroll/closepayroll.html',
                    controller : 'NewClosePayrollController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.closepayroll')
        .controller('EditNewClosePayrollController', EditNewClosePayrollController);

    EditNewClosePayrollController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config', '$filter'];

    /* @ngInject */
    function EditNewClosePayrollController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var ClosePayroll = AppAPI.NewClosePayroll();

        // set constructor form
        Form.setObject(ClosePayroll);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.liststatus = ['OPEN', 'CLOSED'];
        vm.LoadCompany = LoadCompany;
        vm.LoadPeriod = LoadPeriod;

        LoadCompany();
        LoadPeriod();

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);  
            vm.Form.objForm.amount = parseInt(data.amount);  
        }
            
        function LoadCompany() {
            var response=ClosePayroll.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany=data;
        }

        function errorFetchCompany() {
            vm.listcompany=[];
        } 

        function LoadPeriod() {
            var response=ClosePayroll.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod=data;
        }

        function errorFetchPeriod() {
            vm.listperiod=[];
        } 

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, ClosePayroll);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               showDialog(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.closepayroll')
        .controller('NewClosePayrollController', NewClosePayrollController);

    NewClosePayrollController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth','$filter'];

    /* @ngInject */
    function NewClosePayrollController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth, $filter) {
       
       var vm = this;
       var translate = $filter('translate');
       var ClosePayroll=AppAPI.NewClosePayroll();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputClosePayroll= inputClosePayroll;
       vm.lisClosePayrollSelected=[];
       vm.DeleteClosePayroll=DeleteClosePayroll;
       vm.editClosePayroll=editClosePayroll;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(ClosePayroll,pageno,{action:'viewdata'});
       }

       

       function inputClosePayroll(ev)
      {
          $mdDialog.show({
                controller         : 'InputNewClosePayrollController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll-new/closepayroll/input-closepayroll.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editClosePayroll(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditNewClosePayrollController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll-new/closepayroll/input-closepayroll.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisClosePayrollSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisClosePayrollSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, ClosePayroll);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteClosePayroll(ev) { 
        var message = translate('PAYROLL.MESSAGE.CONFDEL');
        var note    = translate('PAYROLL.MESSAGE.DELNOTE');
        var yes     = translate('PAYROLL.MESSAGE.YES');
        var no      = translate('PAYROLL.MESSAGE.NO');
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title(message)
              .textContent(note)
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok(yes)
              .cancel(no);

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=ClosePayroll.delete({action:'delete',data:angular.toJson(vm.lisClosePayrollSelected)});

           response.$promise.then(loadData);
           response.$promise.catch(ErrDel);

           loadData(1);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }

      function ErrDel(){
         alert("Sorry, Data can't delete. other transactions using this data");
        
      }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.cartransaction', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_cartransaction', {
                url    : '/new-payroll/cartransaction',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/cartransaction/cartransaction.html',
                    controller : 'NewCarTransactionController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.cartransaction')
      .controller('UploadNewcartransactionController', UploadNewcartransactionController);
  
    UploadNewcartransactionController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function UploadNewcartransactionController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/NewCartransaction/uploadfile',
        removeAfterUpload: true,
        alias: 'filecartransaction',
        formData: [{
            action: 'uploadfile'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
  
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewCartransaction/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function() {
    'use strict';

    angular
        .module('app.payroll-new.cartransaction')
        .controller('InputNewcartransactionController', InputNewcartransactionController);

    InputNewcartransactionController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$scope','$filter'];

    /* @ngInject */
    function InputNewcartransactionController($localStorage,$mdDialog,Form,AppAPI,$http,config,$scope,$filter) {
          var vm = this;
          var translate = $filter('translate');
          var dt = new Date();
          var year = dt.getFullYear();
          vm.saveData=saveData;

          Form.initialForm();

          var CarTransaction= AppAPI.NewCarTransaction();


          // set constructor form
          Form.setObject(CarTransaction);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.saveData=saveData;
          vm.LoadCartype = LoadCartype;
          vm.changeCartype = changeCartype;
          vm.getEmployee=getEmployee;
          vm.selectedItemChanged=selectedItemChanged;          
          vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];
          vm.Form.objForm.amount = 0;
          
          LoadCartype();

          function selectedItemChanged(employee) {
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined') {
              vm.Form.objForm.empno=employee.empno;
              vm.Form.objForm.fullname=employee.fullname
              vm.isDisabled=true;
            }
            console.log(vm.Form.objForm.empno);
          }

          function getEmployee(searchText) {
            return $http
            .get(config.api + 'api/payrollnew/NewCartransaction?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
            .then(function(item) {
              // Map the response object to the data object.
              if(item.data.length===''){
                Form.objForm.empno='';
              }   
              return item.data;
            });
          }

          function changeCartype(id) { 
            var resp=CarTransaction.query({action:'getDetailCartype',id:id})
            resp.$promise.then(fetchdetailcartype);
            resp.$promise.catch(errorfetchdetailcartype);
          }

          function fetchdetailcartype(data) {
            vm.Form.objForm.cartypedesc = data[0].name;
          }

          function errorfetchdetailcartype() {
            vm.Form.objForm.cartypedesc = [];
          }

          function LoadCartype() {
            var response=CarTransaction.query({action:'getCartype'});
            response.$promise.then(fetchCartype);
            response.$promise.catch(errorFetchCartype);
          }

          function fetchCartype(data) {
            vm.listcartype=data;
          }

          function errorFetchCartype() {
            vm.listcartype=[];
          }

          function closeModal() {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, CarTransaction);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(errorSave);
          }

          function errorSave(data){
            var message = translate(data.pesan);
            var status  = translate(data.status);
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel(status)
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.cartransaction')
        .controller('EditNewcartransactionController', EditNewcartransactionController);

    EditNewcartransactionController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function EditNewcartransactionController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var CarTransaction = AppAPI.NewCarTransaction();

        // set constructor form
        Form.setObject(CarTransaction);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;    
        vm.LoadCartype = LoadCartype;
        vm.changeCartype = changeCartype;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;         
        vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

        LoadCartype();        
         
        function selectedItemChanged(employee){
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined'){
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;
            }
            console.log(vm.Form.objForm.empno);
        }

        function getEmployee(searchText){
            return $http
            .get(config.api + 'api/payrollnew/NewCartransaction?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
            .then(function(item) {
                if(item.data.length===''){
                    Form.objForm.empno='';
                }   
                return item.data;
            });
        }

        function changeCartype(id) { 
           var resp=CarTransaction.query({action:'getDetailCartype',id:id})
           resp.$promise.then(fetchdetailcartype);
           resp.$promise.catch(errorfetchdetailcartype);
        }

          function fetchdetailcartype(data) {
            vm.Form.objForm.cartypedesc = data[0].name;
          }

          function errorfetchdetailcartype() {
            vm.Form.objForm.cartypedesc = [];
          }

          function LoadCartype() {
            var response=CarTransaction.query({action:'getCartype'});
            response.$promise.then(fetchCartype);
            response.$promise.catch(errorFetchCartype);
          }

          function fetchCartype(data) {
            vm.listcartype=data;
          }

          function errorFetchCartype() {
            vm.listcartype=[];
          }

        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(SelectData);

        function SelectData(data){
            vm.Form.objForm.amount = parseInt(data.amount);  
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  
          var promise= Form.saveData('update', formController, CarTransaction);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               showDialog(ev,data)  
               
            });
        }

        function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.cartransaction')
        .controller('NewCarTransactionController', NewCarTransactionController);

    NewCarTransactionController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth', '$document', 'FileUploader','$http','config','$element','$filter'];

    /* @ngInject */
    function NewCarTransactionController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth, $document, FileUploader,$http,config, $element,$filter) {
       
       var vm = this;
       var translate = $filter('translate');
       Form.initialForm();
       
       var CarTransaction=AppAPI.NewCarTransaction();
       
       Form.setObject(CarTransaction);

       vm.Form = Form; 

       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputCarTransaction= inputCarTransaction;
       vm.lisCarTransactionSelected=[];
       vm.DeleteCarTransaction=DeleteCarTransaction;
       vm.editCarTransaction=editCarTransaction;
       vm.openUploadCarTransaction=openUploadCarTransaction;
       
       vm.LoadCompany = LoadCompany;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.changeCompany = changeCompany;

       vm.getEmployee=getEmployee;
       vm.selectedItemChanged=selectedItemChanged;  
       vm.company = $localStorage.empsite   

       LoadCompany();
       LoadDivisi(vm.company);
       LoadArea(vm.company);

       function loadData(pageno) {

          var nik = '';
          var company = '';
          var department = '';
          var area = '';
          var divisi = '';

          if(typeof(vm.Form.objForm.empno) != 'undefined')
              nik = vm.Form.objForm.empno;
          if(typeof(vm.company) != 'undefined')
            company = vm.company;
          if(typeof($localStorage.empsite) != '')
            company = $localStorage.empsite;
          if(typeof(vm.department) != 'undefined')
            department = vm.department;
          if(typeof(vm.area) != 'undefined')
            area = vm.area;
          if(typeof(vm.divisi) != 'undefined')
            divisi = vm.divisi;

          vm.DataTable.loadData(CarTransaction,pageno,{action:'viewdata',nik:nik, company:vm.company, department:department, area:area,divisi:divisi});
       }

       function selectedItemChanged(employee) {
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined') {
              vm.Form.objForm.empno=employee.empno;
              vm.Form.objForm.fullname=employee.fullname
              vm.isDisabled=true;
            }
        }

        function getEmployee(searchText) {
            return $http
            .get(config.api + 'api/payrollnew/NewCartransaction?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
            .then(function(item) {
              // Map the response object to the data object.
              if(item.data.length===''){
                Form.objForm.empno='';
              }   
              return item.data;
            });
        }

        function LoadCompany() {
            var response=CarTransaction.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
            console.log(id);
             vm.listarea=[];
             var resp=CarTransaction.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadDepartment(companyid,divisi) {
            var response=CarTransaction.query({action:'getDepartment', idbu:companyid, iddivisi:divisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }

       function LoadArea(companyId) {
            var response=CarTransaction.query({action:'getArea', companyid: companyId});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 
       
       function LoadDivisi(companyid) {
            var response=CarTransaction.query({action:'getDivisi', idbu: companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid,vm.divisi);
            LoadArea(companyid);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       }

       function openUploadCarTransaction(ev)
       {
            $mdDialog.show({
                controller         : 'UploadNewcartransactionController as vm',
                templateUrl        : 'app/main/payroll-new/cartransaction/upload-file.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            });
       }


       function inputCarTransaction(ev)
      {
          $mdDialog.show({
                controller         : 'InputNewcartransactionController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll-new/cartransaction/input-cartransaction.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editCarTransaction(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditNewcartransactionController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/cartransaction/input-cartransaction.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisCarTransactionSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisCarTransactionSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, CarTransaction);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteCarTransaction(ev) { 
        var message = translate('PAYROLL.MESSAGE.CONFDEL');
        var note    = translate('PAYROLL.MESSAGE.DELNOTE');
        var yes     = translate('PAYROLL.MESSAGE.YES');
        var no      = translate('PAYROLL.MESSAGE.NO');
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title(message)
              .textContent(note)
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok(yes)
              .cancel(no);

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=CarTransaction.delete({action:'delete',data:angular.toJson(vm.lisCarTransactionSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.carrate', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) 
   {
   	    $stateProvider
            .state('app.payroll_new_carrate', {
                url    : '/new-payroll/carrate',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/carrate/carrate.html',
                    controller : 'NewCarRateController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-new.carrate')
        .controller('InputNewcarrateController', InputNewcarrateController);

    InputNewcarrateController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$filter'];

    /* @ngInject */
    function InputNewcarrateController($localStorage,$mdDialog,Form,AppAPI,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData=saveData;
        vm.changePayroll=changePayroll;

        Form.initialForm();

        var CarRate= AppAPI.NewCarRate();
        var GradeRate= AppAPI.NewGradeRate();

        // set constructor form
        Form.setObject(CarRate);

        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.Form.objForm.effective_date = new Date
        vm.Form.objForm.flag_prorate = 0;   
        vm.LoadCompany = LoadCompany;
        vm.Form.objForm.amount = 0;
        
        LoadPayroll();
        LoadCompany();

        function changePayroll(id)
        { 
            var resp=GradeRate.query({action:'getDetailPayroll',id:id})
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() 
        {
            var response=GradeRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) 
        {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        }

        function LoadCompany() 
        {
            var response=CarRate.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) 
        {
            vm.listcompany=data;
        }

        function errorFetchCompany() 
        {
            vm.listcompany=[];
        } 
                
        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('save', formController, CarRate);
            promise.then(SaveSucces);
            promise.catch(SaveSucces);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function SaveSucces(data) 
        {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.carrate')
        .controller('EditNewcarrateController', EditNewcarrateController);

    EditNewcarrateController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config', '$filter'];

    /* @ngInject */
    function EditNewcarrateController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var CarRate = AppAPI.NewCarRate();
        var GradeRate= AppAPI.NewGradeRate();

        // set constructor form
        Form.setObject(CarRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.LoadCompany = LoadCompany;
        vm.changePayroll = changePayroll;

        LoadPayroll();
        changePayroll(id);
        LoadCompany();
        
        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function changePayroll(id)
        { 
            var resp=GradeRate.query({action:'getDetailPayroll',id:id})
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() 
        {
            var response=GradeRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) 
        {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        }

        function ChangeDate(data)
        {
            vm.Form.objForm.effective_date = new Date(data.effective_date);  
            vm.Form.objForm.amount = parseInt(data.amount);  
        }
            
        function LoadCompany() 
        {
            var response=CarRate.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) 
        {
            vm.listcompany=data;
        }

        function errorFetchCompany() 
        {
            vm.listcompany=[];
        } 

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() 
        {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, CarRate);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(function(data){
               showDialog(ev,data)  
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status = translate(data.status);
            
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    closeModal();
                });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.carrate', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_carrate', {
                url    : '/payroll/carrate',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/carrate/carrate.html',
                    controller : 'CarRateController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.carrate')
        .controller('NewCarRateController', NewCarRateController);

    NewCarRateController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth', '$filter'];

    /* @ngInject */
    function NewCarRateController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth, $filter) 
    {   
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/carrate';

        var CarRate=AppAPI.NewCarRate();
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.inputCarRate= inputCarRate;
        vm.lisCarRateSelected=[];
        vm.DeleteCarRate=DeleteCarRate;
        vm.editCarRate=editCarRate;

        loadData(1);

        function loadData(pageno) 
        {
            vm.DataTable.loadData(CarRate,pageno,{action:'viewdata'});
        }

        function inputCarRate(ev)
        {
            $mdDialog.show({
                    controller         : 'InputNewcarrateController',
                    controllerAs       : 'vm',
                    templateUrl        : basePath+'/input-carrate.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    }
                }); 
        }

        function editCarRate(ev,id)
        {
            $mdDialog.show({
                controller         : 'EditNewcarrateController',
                controllerAs       : 'vm',
                templateUrl        : basePath+'/input-carrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                    id:id
                }
            });
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() 
        {
            vm.lisCarRateSelected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() 
        {
            vm.lisCarRateSelected=[];
        } 
       
        function closeModal()
        {
            $mdDialog.hide();
        }

        function DeleteCarRate(ev) 
        {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note    = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes     = translate('PAYROLL.MESSAGE.YES');
            var no      = translate('PAYROLL.MESSAGE.NO'); 

            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                .title(message)
                .textContent(note)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=CarRate.delete({action:'delete',data:angular.toJson(vm.lisCarRateSelected)});

                response.$promise.then(loadData);
                response.$promise.catch(ErrDel);

                loadData(1);
            }, function() {
                // $scope.status = 'You decided to keep your debt.';
            });
            });
        }

        function ErrDel()
        {
            alert("Sorry, Data can't delete. other transactions using this data");
            
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.bpjsmalaysiasocsocomponent', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_bpjsmalaysiasocsocomponent', {
                url    : '/new-payroll/bpjsmalaysiasocso',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/bpjsmalaysiasocso/bpjsmalaysiasocsoComponent.html',
                    controller : 'BpjsmalaysiasocsoComponentController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
  'use strict';
  angular
    .module('app.payroll-new.bpjsmalaysiasocsocomponent')
    .controller('BpjsmalaysiasocsoInputComponentController', BpjsmalaysiasocsoInputComponentController);

  BpjsmalaysiasocsoInputComponentController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'filterFilter',
    '$filter',
    '$element',
    '$http',
    'config'
  ];
  /** @ngInject */
  function BpjsmalaysiasocsoInputComponentController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    filterFilter,
    $filter,
    $element,
    $http,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.BpjsMalaysiaSocso();
    var $translate = $filter('translate');

    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint); 
    vm.dialogClose = dialogClose;
    vm.saveData=saveData;

    activate();

    function activate() {
      vm.selected = []; 
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine(); 
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status  = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();

(function() {
    'use strict';
    angular
      .module('app.payroll-new.bpjsmalaysiasocsocomponent')
      .controller('BpjsmalaysiasocsoEditComponentController', BpjsmalaysiasocsoEditComponentController);
  
    BpjsmalaysiasocsoEditComponentController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'data',
      'config',
      '$element',
      '$http',
      '$filter'
    ];
    /** @ngInject */
    function BpjsmalaysiasocsoEditComponentController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      data,
      config,
      $element,
      $http,
      $filter
    ) {
      var vm = this;
      var endPoint = AppAPI.BpjsMalaysiaSocso();
      var $translate = $filter('translate');

      vm.Form = Form;
      vm.info = data;
      vm.saveData = updateData;
      vm.dialogClose = dialogClose;
      vm.company=$localStorage.empsite;

      activate();
      
      function activate() 
      {
        Form.initialForm();
        Form.setObject(endPoint);
        
        vm.Form.objForm.id=data.id;
        vm.Form.objForm.start_salary=parseFloat(data.start_salary);
        vm.Form.objForm.end_salary=parseFloat(data.end_salary);
        vm.Form.objForm.ee_value=parseFloat(data.ee_value);
        vm.Form.objForm.er_value=parseFloat(data.er_value);
        vm.Form.objForm.er1_value=parseFloat(data.er1_value);
      }
      
      function updateData(ev, frm) 
      {
        angular.element.blockUI();
        var response = Form.saveData('update', frm, endPoint);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();

            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        var message = $translate(data.pesan);
        var status  = $translate(data.status);
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel(status)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }

      vm.clearSearchTerm = function() {
        vm.searchTerm = '';
    };
    
    $element.find('input').on('keydown', function(ev) {
        ev.stopPropagation();
    });
    }
  })();
  
(function () {
    'use strict';

    angular
        .module('app.payroll-new.bpjsmalaysiasocsocomponent')
        .controller('BpjsmalaysiasocsoComponentController', BpjsmalaysiasocsoComponentController);

    BpjsmalaysiasocsoComponentController.$inject = ['AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', '$filter', '$document'];

    /* @ngInject */
    function BpjsmalaysiasocsoComponentController(AppAPI, DataService, $mdDialog, Form, Auth, $filter, $document) {
        var vm = this;
        var $translate = $filter('translate');
        var basePath = 'app/main/payroll-new/bpjsmalaysiasocso/';

        var BpjsMalaysiaSocso = AppAPI.BpjsMalaysiaSocso();
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.lisSalaryComponentSelected = [];
        vm.listSalcom = [];
        vm.showFilter = true;

        vm.selected = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.items = [];
        vm.addData = addData; 
        vm.selectedItem = null;
        vm.searchText = null;
        vm.editData = editData;
        vm.deleteData = deleteData;
        
        loadData(1);

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(BpjsMalaysiaSocso, pageno, {
                action: 'viewdata',
                start_salary: (vm.start_salary) ? vm.start_salary : null,
                end_salary: (vm.end_salary) ? vm.end_salary : null
            });

            resp.then(function(data) {
                vm.selected = [];
                vm.items = data.list;
              });
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
              list.splice(idx, 1);
            } else {
              list.push(item);
            }
          }
      
          function exists(item, list) {
            return list.indexOf(item) > -1;
          }
      
          function isIndeterminate() {
            return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
          }
      
          function isChecked() {
            return vm.selected.length === vm.items.length;
          }
      
          function toggleAll() {
            if (vm.selected.length === vm.items.length) {
              vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
              vm.selected = vm.items.slice(0);
            }
          }
        
          function addData(ev) {
            $mdDialog.show({
              controller: 'BpjsmalaysiasocsoInputComponentController',
              controllerAs: 'vm',
              templateUrl: basePath+'form-input.html',
              parent: angular.element($document.body),
              targetEvent: ev,
              onRemoving: function(element, removePromise) {
                loadData(1);
              },
              clickOutsideToClose: true,
              fullscreen: true // Only for -xs, -sm breakpoints.
            });
          }
      
          function editData(ev, data) {
            $mdDialog.show({
              controller: 'BpjsmalaysiasocsoEditComponentController',
              controllerAs: 'vm',
              templateUrl: basePath+'form-input.html',
              parent: angular.element($document.body),
              targetEvent: ev,
              onRemoving: function() {
                loadData(1);
              },
              locals: {
                data : data
              },
              clickOutsideToClose: true,
              fullscreen: true // Only for -xs, -sm breakpoints.
            });
          }
      
          function deleteData(ev) {
            var message = $translate('PAYROLL.MESSAGE.CONFDEL');
            var note    = $translate('PAYROLL.MESSAGE.DELNOTE');
            var yes     = $translate('PAYROLL.MESSAGE.YES');
            var no      = $translate('PAYROLL.MESSAGE.NO');
      
            var promise = Auth.setToken();
            promise.then(function() {
              var confirm = $mdDialog
                .confirm()
                .title(message)
                .textContent(note)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);
      
              $mdDialog.show(confirm).then(
                function() {
                  var data = [];
                  for (var index = 0; index < vm.selected.length; index++) {
                    data.push(vm.selected[index].id);
                  }
                  angular.element.blockUI();
                  var response = BpjsMalaysiaSocso.delete({
                    action: 'delete',
                    data: angular.toJson(data)
                  });
                  response.$promise.then(function(resp) {
                    closeModal();
                    angular.element.unblockUI();
                    showDialogInfo(ev, resp);
                  });
                },
                function() {
                  // $scope.status = 'You decided to keep your debt.';
                }
              );
            });
          }

        function closeModal() {
            $mdDialog.hide();
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                    checkAll();
                break;
                case false:
                    unCheckAll();
                break;
            }
        }

        function checkAll() 
        {
            vm.selected=angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.selected=[];
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.bpjsmalaysiaepfcomponent')
        .controller('BpjsmalaysiaepfComponentController', BpjsmalaysiaepfComponentController);

    BpjsmalaysiaepfComponentController.$inject = ['AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', '$filter'];

    /* @ngInject */
    function BpjsmalaysiaepfComponentController(AppAPI, DataService, $mdDialog, Form, Auth, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/bpjsmalaysiaepf';
        var BpjsMalaysiaEpf = AppAPI.BpjsMalaysiaEpf();
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.listDataSelected = [];
        vm.showFilter = true;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;
        vm.toggleSelectedAll = toggleSelectedAll;
        loadData(1);

        function loadData(pageno) {
            vm.DataTable.loadData(BpjsMalaysiaEpf, pageno, {
                action: 'viewdata',
                start_salary: (vm.start_salary) ? vm.start_salary : null,
                end_salary: (vm.end_salary) ? vm.end_salary : null
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function add(ev) {
            $mdDialog.show({
                controller: 'ManageEpfController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/bpjsmalaysiaepf/manage/manage-epf.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dataEis: null,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'ManageEpfController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/bpjsmalaysiaepf/manage/manage-epf.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dataEis: data,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = BpjsMalaysiaEpf.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listDataSelected)
                    });
                    response.$promise.then(loadData);
                }, function () {});
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.payroll-new.bpjsmalaysiaeiscomponent')
        .controller('BpjsmalaysiaeisComponentController', BpjsmalaysiaeisComponentController);

    BpjsmalaysiaeisComponentController.$inject = ['AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', '$filter'];

    /* @ngInject */
    function BpjsmalaysiaeisComponentController(AppAPI, DataService, $mdDialog, Form, Auth, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/bpjsmalaysiaeis';
        var BpjsMalaysiaEis = AppAPI.BpjsMalaysiaEis();
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.listDataSelected = [];
        vm.showFilter = true;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;
        vm.toggleSelectedAll = toggleSelectedAll;

        loadData(1);

        function loadData(pageno) {
            vm.DataTable.loadData(BpjsMalaysiaEis, pageno, {
                action: 'viewdata',
                start_salary: (vm.start_salary) ? vm.start_salary : null,
                end_salary: (vm.end_salary) ? vm.end_salary : null
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function add(ev) {
            $mdDialog.show({
                controller: 'ManageEisController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/bpjsmalaysiaeis/manage/manage-eis.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dataEis: null,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'ManageEisController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/bpjsmalaysiaeis/manage/manage-eis.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dataEis: data,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = BpjsMalaysiaEis.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listDataSelected)
                    });
                    response.$promise.then(loadData);
                }, function () {});
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

    }
})();

(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.bonus-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_bonus_mgr', {
                url    : '/new-payroll/bonus-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/bonus-mgr/bonus.html',
                    controller : 'bonusMgrController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.bonus-mgr')
      .controller('NewUploadBonusMgrController', NewUploadBonusMgrController);
  
    NewUploadBonusMgrController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function NewUploadBonusMgrController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) 
    {
      var vm = this;
      var translate = $filter('translate');

      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/NewBonus/uploadfile',
        removeAfterUpload: true,
        alias: 'filesalary',
        formData: [{
            action: 'uploadfile',
            isMgr: true
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewBonus/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function() {
    'use strict';

    angular
        .module('app.payroll-new.bonus-mgr')
        .controller('InputBonusMgrController', InputBonusMgrController);

    InputBonusMgrController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$filter'];

    /* @ngInject */
    function InputBonusMgrController($localStorage,$mdDialog,Form,AppAPI,$http,config,$filter) {
          var vm = this;
          var translate = $filter('translate');
          
          vm.saveData=saveData;

          Form.initialForm();

          var endPoint= AppAPI.NewBonus();

          // set constructor form
          Form.setObject(endPoint);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.getEmployee=getEmployee;
          vm.saveData=saveData;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.Form.objForm.pay = new Date();
          vm.Form.objForm.amount = 0;
          vm.Form.objForm.empno='';
          vm.Form.objForm.year = '';
         
          var date = new Date();
          var year=date.getFullYear();

          vm.years = [
            {'id' : (year-1), 'name' : (year-1)},
            {'id' : year, 'name' : year},
            {'id' : (year+1), 'name' : (year+1)},
          ]

          function selectedItemChanged(employee)
          {
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         }

          function getEmployee(searchText){
            return $http
            .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
            .then(function(item) {
              // Map the response object to the data object.
              if(item.data.length===''){
                Form.objForm.empno='';
              }   
                return item.data;
            });
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, endPoint);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(errorSave);
          }

          function errorSave(data){
            var message = translate(data.pesan);
            var status  = translate(data.status);

              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev,data) 
          {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.bonus-mgr')
        .controller('EditBonusMgrController', EditBonusMgrController);

    EditBonusMgrController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function EditBonusMgrController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var endPoint = AppAPI.NewBonus();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;

        var date = new Date();
        var year=date.getFullYear();

        vm.years = [
            {'id' : (year-1), 'name' : (year-1)},
            {'id' : year, 'name' : year},
            {'id' : (year+1), 'name' : (year+1)},
        ]
        
        function selectedItemChanged(employee)
        {       
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;
            }
        }

        function getEmployee(searchText)
        {
           return $http
            .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
            .then(function(item) {
                if(item.data.length===''){
                Form.objForm.empno='';
                }   
                return item.data;
            });
        }

        vm.closeModal = closeModal;   
        
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.pay = new Date(data.pay_date);    
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.fullname;
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, endPoint);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
               showDialog(ev,data)                 
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);
            
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.bonus-mgr')
        .controller('bonusMgrController', bonusMgrController);

    bonusMgrController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function bonusMgrController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/bonus';

        Form.initialForm();
        
        var New13Salary = AppAPI.New13Salary();
        var endPoint = AppAPI.NewBonus();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();

        Form.setObject(endPoint);
        
        vm.Form = Form;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.input = input;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.edit = edit;
        vm.download = download;
        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.openUpload = openUpload;
        vm.company = $localStorage.empsite

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        vm.Form.objForm.empno = '';

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');
        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function LoadArea(company, cabangid, regionalid) 
        {
            LoadDivisi(company);
            loadWilayah();
            
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }


        function LoadCompany() {
            var response = New13Salary.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = New13Salary.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }


        function LoadDivisi(companyid) {
            var response = New13Salary.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function selectedItemChanged(employee) 
        {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) 
        {
            return $http
                .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + vm.company + '&isMgr=true')
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function loadData(pageno) 
        {
            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }

            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi,
                isMgr: true
            });
        }

        function input(ev) 
        {
            $mdDialog.show({
                controller: 'InputBonusMgrController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function edit(ev, id) {
            $mdDialog.show({
                controller: 'EditBonusMgrController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, New13Salary);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'NewUploadBonusMgrController as vm',
                templateUrl: basePath + '/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function download(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = true;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewBonus/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.bonus', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_bonus', {
                url    : '/new-payroll/bonus',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/bonus/bonus.html',
                    controller : 'bonusController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.bonus')
      .controller('NewUploadBonusController', NewUploadBonusController);
  
    NewUploadBonusController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function NewUploadBonusController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) 
    {
      var vm = this;
      var translate = $filter('translate');

      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/NewBonus/uploadfile',
        removeAfterUpload: true,
        alias: 'filesalary',
        formData: [{
            action: 'uploadfile'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewBonus/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function() {
    'use strict';

    angular
        .module('app.payroll-new.bonus')
        .controller('InputBonusController', InputBonusController);

    InputBonusController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$filter'];

    /* @ngInject */
    function InputBonusController($localStorage,$mdDialog,Form,AppAPI,$http,config,$filter) {
          var vm = this;
          var translate = $filter('translate');
          
          vm.saveData=saveData;

          Form.initialForm();

          var endPoint= AppAPI.NewBonus();

          // set constructor form
          Form.setObject(endPoint);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.getEmployee=getEmployee;
          vm.saveData=saveData;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.Form.objForm.pay = new Date();
          vm.Form.objForm.amount = 0;
          vm.Form.objForm.empno='';
          vm.Form.objForm.year = '';
         
          var date = new Date();
          var year=date.getFullYear();

          vm.years = [
            {'id' : (year-1), 'name' : (year-1)},
            {'id' : year, 'name' : year},
            {'id' : (year+1), 'name' : (year+1)},
          ]

          function selectedItemChanged(employee)
          {
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         }

          function getEmployee(searchText){
            return $http
            .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
            .then(function(item) {
              // Map the response object to the data object.
              if(item.data.length===''){
                Form.objForm.empno='';
              }   
                return item.data;
            });
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, endPoint);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(errorSave);
          }

          function errorSave(data){
            var message = translate(data.pesan);
            var status  = translate(data.status);

              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev,data) 
          {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.bonus')
        .controller('EditBonusController', EditBonusController);

    EditBonusController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function EditBonusController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var endPoint = AppAPI.NewBonus();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;

        var date = new Date();
        var year=date.getFullYear();

        vm.years = [
            {'id' : (year-1), 'name' : (year-1)},
            {'id' : year, 'name' : year},
            {'id' : (year+1), 'name' : (year+1)},
        ]
        
        function selectedItemChanged(employee)
        {       
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;
            }
        }

        function getEmployee(searchText)
        {
           return $http
            .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
            .then(function(item) {
                if(item.data.length===''){
                Form.objForm.empno='';
                }   
                return item.data;
            });
        }

        vm.closeModal = closeModal;   
        
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.pay = new Date(data.pay_date);    
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.fullname;
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, endPoint);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
               showDialog(ev,data)                 
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);
            
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.bonus')
        .controller('bonusController', bonusController);

    bonusController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function bonusController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/bonus';

        Form.initialForm();
        
        var New13Salary = AppAPI.New13Salary();
        var endPoint = AppAPI.NewBonus();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();

        Form.setObject(endPoint);
        
        vm.Form = Form;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.input = input;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.edit = edit;
        vm.download = download;
        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.openUpload = openUpload;
        vm.company = $localStorage.empsite

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        vm.Form.objForm.empno = '';

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');
        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function LoadArea(company, cabangid, regionalid) 
        {
            LoadDivisi(company);
            loadWilayah();
            
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }


        function LoadCompany() {
            var response = New13Salary.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = New13Salary.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }


        function LoadDivisi(companyid) {
            var response = New13Salary.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function selectedItemChanged(employee) 
        {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) 
        {
            return $http
                .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function loadData(pageno) 
        {
            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }

            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi
            });
        }

        function input(ev) 
        {
            $mdDialog.show({
                controller: 'InputBonusController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function edit(ev, id) {
            $mdDialog.show({
                controller: 'EditBonusController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, New13Salary);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'NewUploadBonusController as vm',
                templateUrl: basePath + '/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function download(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewBonus/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.allowancefix-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_allowancefix_mgr', {
                url    : '/new-payroll/allowancefix-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/allowancefix-mgr/allowancefix.html',
                    controller : 'NewAllowanceFixMgrController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.allowancefix-mgr')
      .controller('UploadNewAllowanceFixMgrController', UploadNewAllowanceFixMgrController);
  
    UploadNewAllowanceFixMgrController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function UploadNewAllowanceFixMgrController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/NewAllowancefix/uploadfile',
        removeAfterUpload: true,
        alias: 'filesalary',
        formData: [{
            action: 'uploadfile',
            isMgr: true
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
  
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function(data, status) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        vm.uploadNotif = status
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewAllowancefix/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function() {
    'use strict';

    angular
        .module('app.payroll-new.allowancefix-mgr')
        .controller('InputNewallowancefixMgrController', InputNewallowancefixMgrController);

    InputNewallowancefixMgrController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$filter'];

    /* @ngInject */
    function InputNewallowancefixMgrController($localStorage,$mdDialog,Form,AppAPI,$http,config,$filter) {
          var vm = this;
          var translate = $filter('translate');
          vm.saveData=saveData;

          Form.initialForm();

          var AllowanceFix= AppAPI.NewAllowanceFix();


          // set constructor form
          Form.setObject(AllowanceFix);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.getEmployee=getEmployee;
          vm.saveData=saveData;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.Form.objForm.effective_date = new Date();
          vm.amountTypes = [
            {'value' : 'daily','label' : 'Daily'},
            {'value' : 'monthly','label' : 'Monthly'}
          ];
          
          vm.Form.objForm.empno='';
          vm.Form.objForm.flag_prorate = 0;
          vm.Form.objForm.amount = 0;
          
          LoadPayroll();
         
          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewAllowancefix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=AllowanceFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=AllowanceFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, AllowanceFix);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(function(data){
                errorDialog(data);
            });
          }

          function errorDialog(data)
          {
              $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.querySelector('#contentDialog')))
                  .clickOutsideToClose(true)
                  .title('Failed')
                  .textContent(data.data)
                  .ariaLabel(data.data)
                  .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }
          
          function showDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function errorSave(data){
          var message = translate(data.pesan);
            var status  = translate(data.status);

              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.allowancefix-mgr')
        .controller('EditNewallowancefixMgrController', EditNewallowancefixMgrController);

    EditNewallowancefixMgrController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function EditNewallowancefixMgrController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var AllowanceFix = AppAPI.NewAllowanceFix();

        // set constructor form
        Form.setObject(AllowanceFix);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;
        vm.amountTypes = [
            {'value' : 'daily','label' : 'Daily'},
            {'value' : 'monthly','label' : 'Monthly'}
        ];
        LoadPayroll();
       
        function selectedItemChanged(employee)
         {
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollnew/NewAllowancefix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

        function changePayroll(id)
        { 
            var resp=AllowanceFix.query({action:'getDetailPayroll',id:id})
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
            //vm.listPositiondetail=data;
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
            //vm.listPositiondetail=[];
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=AllowanceFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

       
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);    
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, AllowanceFix);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               errorDialog(data)
            });


        }
        
        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }
        
        function showDialog(ev,data) {
          // console.log(ev);
          var message = translate(data.pesan);
            var status  = translate(data.status);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.allowancefix-mgr')
        .controller('NewAllowanceFixMgrController', NewAllowanceFixMgrController);

    NewAllowanceFixMgrController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewAllowanceFixMgrController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var AllowanceFix = AppAPI.NewAllowanceFix();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();

        Form.setObject(AllowanceFix);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputAllowanceFix = inputAllowanceFix;
        vm.lisAllowanceFixSelected = [];
        vm.arr_area = [];
        vm.DeleteAllowanceFix = DeleteAllowanceFix;
        vm.editAllowanceFix = editAllowanceFix;
        vm.downloadInputSalary = downloadInputSalary;
        vm.changeCompany = changeCompany;
        vm.openUpload = openUpload;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.company = $localStorage.empsite

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');

        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }
        
        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }


        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(AllowanceFix, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi,
                isMgr: true
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewAllowancefix?action=searchEmployee&id=' + searchText + '&company=' + vm.company + '&isMgr=true')
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = AllowanceFix.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = AllowanceFix.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(companyid, divisi) {
            var response = AllowanceFix.query({
                action: 'getDepartment',
                idbu: companyid,
                iddivisi: divisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = AllowanceFix.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            // LoadArea(companyid, '', '');
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function inputAllowanceFix(ev) {
            $mdDialog.show({
                controller: 'InputNewallowancefixMgrController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/allowancefix/input-allowancefix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editAllowanceFix(ev, id) {
            $mdDialog.show({
                controller: 'EditNewallowancefixMgrController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/allowancefix/input-allowancefix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
            //console.log(vm.listModulSelected);
        }

        function checkAll() {
            vm.lisAllowanceFixSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisAllowanceFixSelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, AllowanceFix);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteAllowanceFix(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = AllowanceFix.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisAllowanceFixSelected)
                    });

                    response.$promise.then(function(data){
                        angular.element.unblockUI();
                        successDialog(ev,data)
                        loadData(1);
                    });
                    response.$promise.catch(function (data){
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function successDialog(ev,data) {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function errorDialog(data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed')
                .textContent(data.data)
                .ariaLabel(data.data)
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }
        
        function downloadInputSalary(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = true;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewAllowancefix/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + data.token, '_blank');

            }, function () {
                $window.alert('gagal load token')
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadNewAllowanceFixMgrController as vm',
                templateUrl: 'app/main/payroll-new/allowancefix/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.allowancefix', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_allowancefix', {
                url    : '/new-payroll/allowancefix',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/allowancefix/allowancefix.html',
                    controller : 'NewAllowanceFixController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.allowancefix')
      .controller('UploadNewAllowanceFixController', UploadNewAllowanceFixController);
  
    UploadNewAllowanceFixController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function UploadNewAllowanceFixController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/NewAllowancefix/uploadfile',
        removeAfterUpload: true,
        alias: 'filesalary',
        formData: [{
            action: 'uploadfile'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
  
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/NewAllowancefix/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function () {
  'use strict';

  angular
    .module('app.payroll-new.allowancefix')
    .controller('InputNewallowancefixController', InputNewallowancefixController);

  InputNewallowancefixController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$filter', '$element', 'country'];

  /* @ngInject */
  function InputNewallowancefixController($localStorage, $mdDialog, Form, AppAPI, $http, config, $filter, $element, country) {
    var vm = this;
    var translate = $filter('translate');
    vm.saveData = saveData;

    Form.initialForm();

    var AllowanceFix = AppAPI.NewAllowanceFix();
    var PayrollProcess = AppAPI.NewPayrollProcess();

    // set constructor form
    Form.setObject(AllowanceFix);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    vm.LoadPayroll = LoadPayroll;
    vm.changePayroll = changePayroll;
    vm.getEmployee = getEmployee;
    vm.saveData = saveData;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.changePayrollCode = changePayrollCode;
    vm.Form.objForm.effective_date = new Date();
    vm.Form.objForm.country = country;
    vm.amountTypes = [
      { 'value': 'daily', 'label': 'Daily' },
      { 'value': 'monthly', 'label': 'Monthly' }
    ];

    vm.Form.objForm.empno = '';
    vm.Form.objForm.flag_prorate = 0;
    vm.Form.objForm.amount = 0;

    LoadPayroll();

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
    LoadCountry()
    function LoadCountry() {
      var response = PayrollProcess.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }

    function changePayrollCode() {
      LoadPayroll();
    }

    function selectedItemChanged(employee) {

      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function getEmployee(searchText) {

      return $http
        .get(config.api + 'api/payrollnew/NewAllowancefix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            Form.objForm.empno = '';
          }
          return item.data;
        });
    }

    function changePayroll(id) {
      var resp = AllowanceFix.query({ action: 'getDetailPayroll', id: id })
      resp.$promise.then(fetchdetailpayroll);
      resp.$promise.catch(errorfetchdetailpayroll);
    }

    function fetchdetailpayroll(data) {
      //vm.listPositiondetail=data;
      vm.Form.objForm.payrolldesc = data[0].name;
    }

    function errorfetchdetailpayroll() {
      //vm.listPositiondetail=[];
      vm.Form.objForm.payrolldesc = [];
    }

    function LoadPayroll() {
      var response = AllowanceFix.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
      response.$promise.then(fetchPayrollCode);
      response.$promise.catch(errorFetchPayrollCode);
    }

    function fetchPayrollCode(data) {
      vm.listpayrollcode = data;
    }

    function errorFetchPayrollCode() {
      vm.listpayrollcode = [];
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, AllowanceFix);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data)
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }

    function errorSave(data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel('Data already exist')
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }


  }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.allowancefix')
        .controller('EditNewallowancefixController', EditNewallowancefixController);

    EditNewallowancefixController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$http', '$filter', '$element'];

    /* @ngInject */
    function EditNewallowancefixController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $http, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var AllowanceFix = AppAPI.NewAllowanceFix();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(AllowanceFix);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData = saveData;
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.changePayrollCode = changePayrollCode;
        vm.amountTypes = [
            { 'value': 'daily', 'label': 'Daily' },
            { 'value': 'monthly', 'label': 'Monthly' }
        ];

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
        LoadCountry()
        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function changePayrollCode() {
            LoadPayroll();
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewAllowancefix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function changePayroll(id) {
            var resp = AllowanceFix.query({ action: 'getDetailPayroll', id: id })
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data) {
            //vm.listPositiondetail=data;
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll() {
            //vm.listPositiondetail=[];
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response = AllowanceFix.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode = data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode = [];
        }
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });
        res.then(ChangeDate);

        function ChangeDate(data) {
            LoadPayroll();
            vm.Form.objForm.effective_date = new Date(data.effective_date);
            vm.Form.objForm.amount = parseInt(data.amount);
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {

            var promise = Form.saveData('update', formController, AllowanceFix);
            promise.then(function (data) {
                showDialog(ev, data);

            });
            promise.catch(function (data) {
                errorDialog(data)
            });


        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }


        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.allowancefix')
        .controller('NewAllowanceFixController', NewAllowanceFixController);

    NewAllowanceFixController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function NewAllowanceFixController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var AllowanceFix = AppAPI.NewAllowanceFix();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        Form.setObject(AllowanceFix);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputAllowanceFix = inputAllowanceFix;
        vm.lisAllowanceFixSelected = [];
        vm.arr_area = [];
        vm.DeleteAllowanceFix = DeleteAllowanceFix;
        vm.editAllowanceFix = editAllowanceFix;
        vm.downloadInputSalary = downloadInputSalary;
        vm.changeCompany = changeCompany;
        vm.openUpload = openUpload;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.company = $localStorage.empsite

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');

        vm.country = $localStorage.country;

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        if (vm.country == 'MYS' && vm.country == "EN") {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }


        function loadData(pageno) {

            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }
            vm.DataTable.loadData(AllowanceFix, pageno, {
                action: 'viewdata',
                nik: nik,
                country: vm.country,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/payrollnew/NewAllowancefix?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = AllowanceFix.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = AllowanceFix.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(companyid, divisi) {
            var response = AllowanceFix.query({
                action: 'getDepartment',
                idbu: companyid,
                iddivisi: divisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function LoadDivisi(companyid) {
            var response = AllowanceFix.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
            // LoadArea(companyid, '', '');
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function inputAllowanceFix(ev) {
            $mdDialog.show({
                controller: 'InputNewallowancefixController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/allowancefix/input-allowancefix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    country: vm.country
                }
            });
        }

        function editAllowanceFix(ev, id) {
            $mdDialog.show({
                controller: 'EditNewallowancefixController',
                controllerAs: 'vm',
                templateUrl: 'app/main/payroll-new/allowancefix/input-allowancefix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
            //console.log(vm.listModulSelected);
        }

        function checkAll() {
            vm.lisAllowanceFixSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisAllowanceFixSelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, AllowanceFix);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteAllowanceFix(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = AllowanceFix.delete({
                        action: 'delete',
                        country: vm.country,
                        data: angular.toJson(vm.lisAllowanceFixSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    })
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
        function downloadInputSalary(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = false;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/NewAllowancefix/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + vm.country + '/' + data.token, '_blank');

            }, function () {
                $window.alert('gagal load token')
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadNewAllowanceFixController as vm',
                templateUrl: 'app/main/payroll-new/allowancefix/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.absentrate', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_absentrate', {
                url    : '/payroll/absentrate',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/absentrate/absentrate.html',
                    controller : 'AbsentRateController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.absentrate')
        .controller('ViewsalarycomponentController', ViewsalarycomponentController);

    ViewsalarycomponentController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function ViewsalarycomponentController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var AbsentRate= AppAPI.AbsentRate();


          // set constructor form
          Form.setObject(AbsentRate);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.viewSalcom= viewSalcom;
          vm.LoadPayroll = LoadPayroll;
          vm.saveData=saveData;
          //vm.exists = exists; 
          //vm.toggle = toggle; 

          LoadPayroll();
        
          /*function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
              list.splice(idx, 1);
            }
            else {
              list.push(item);
            }
          }

          function exists(item, list){
             return list.indexOf(item) > -1;
          }*/
          
          function LoadPayroll() {
            var response=AbsentRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          function closeModal(ev)
          {
            $mdDialog.hide();

            $mdDialog.show({
                controller         : 'InputabsentrateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/absentrate/input-absentrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, AbsentRate);
            promise.then(function(){
                showDialog(ev);
            });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal(ev);
            });
        }

        function viewSalcom(ev)
      {
          $mdDialog.show({
                controller         : 'ViewSalaryComponentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/absentrate/view-salarycomponent.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: false,    
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.absentrate', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) 
   {
   	    $stateProvider
            .state('app.payroll_new_absentrate', {
                url    : '/new-payroll/absentrate',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/absentrate/absentrate.html',
                    controller : 'NewAbsentRateController as vm'
                    }
                }
                  
            });
   }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll-new.absentrate')
        .controller('InputNewabsentrateController', InputNewabsentrateController);

    InputNewabsentrateController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$element', '$filter'];

    /* @ngInject */
    function InputNewabsentrateController($localStorage, $mdDialog, Form, AppAPI, $element, $filter) {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData = saveData;

        Form.initialForm();

        var AbsentRate = AppAPI.NewAbsentRate();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(AbsentRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.LoadAttendance = LoadAttendance;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadCompany = LoadCompany;
        vm.loadPosition = LoadPosition;
        vm.saveData = saveData;
        vm.changePayrollCode = changePayrollCode;
        vm.Form.objForm.country = $localStorage.country;

        vm.Form.objForm.effective_date = new Date();
        vm.Form.objForm.flag_prorate = 0;

        //formula
        vm.Form.objForm.formula = 0;

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        LoadPayroll();
        LoadAllPayroll();
        LoadAttendance();
        LoadCountry();
        LoadCompany();

        function changePayrollCode() {
            LoadPayroll();
            LoadAllPayroll();
        }

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPayroll() {
            var response = AbsentRate.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode = data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode = [];
        }

        function LoadAllPayroll() {
            var response = AbsentRate.query({ action: 'getAllPayroll', country: vm.Form.objForm.country });
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) {
            vm.listallpayroll = data;
        }

        function errorFetchAllPayroll() {
            vm.listallpayroll = [];
        }

        function LoadPosition(companyId) {
            var response = AbsentRate.query({ action: 'getPosition', company: companyId });
            response.$promise.then(fetchPosition);
            response.$promise.catch(errorFetchPosition);
        }

        function fetchPosition(data) {
            vm.listposition = data;
        }

        function errorFetchPosition() {
            vm.listposition = [];
        }


        function LoadAttendance() {
            var response = AbsentRate.query({ action: 'getAttendanceCode' });
            response.$promise.then(fetchAttendance);
            response.$promise.catch(errorFetchAttendance);
        }

        function fetchAttendance(data) {
            vm.listattendancecode = data;
        }

        function errorFetchAttendance() {
            vm.listattendancecode = [];
        }

        function LoadCompany() {
            var response = AbsentRate.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, AbsentRate);
            promise.then(SaveSucces);
            promise.catch(errorSaveData);
        }

        function SaveSucces(data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function errorSave() {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Error Save Data, Data already exist')
                    .textContent('Save Data was Failed.')
                    .ariaLabel('Data already exist')
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function errorSaveData() {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Error Save Data')
                    .textContent('Save Data was Failed.')
                    .ariaLabel('Data already exist')
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.absentrate')
        .controller('EditNewabsentrateController', EditNewabsentrateController);

    EditNewabsentrateController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$element', '$filter'];

    /* @ngInject */
    function EditNewabsentrateController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $element, $filter) {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var AbsentRate = AppAPI.NewAbsentRate();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        // set constructor form
        Form.setObject(AbsentRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.LoadAttendance = LoadAttendance;
        vm.LoadPosition = LoadPosition;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadCompany = LoadCompany;
        vm.changePayrollCode = changePayrollCode;
        vm.saveData = saveData;
        vm.Form.objForm.country = $localStorage.country;

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        LoadAttendance();
        LoadCompany();
        LoadCountry();

        function changePayrollCode() {
            LoadPayroll();
            LoadAllPayroll();
        }

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function LoadPayroll() {
            var response = AbsentRate.query({ action: 'getPayrollCode', country: vm.Form.objForm.country });
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode = data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode = [];
        }

        function LoadAllPayroll() {
            var response = AbsentRate.query({ action: 'getAllPayroll', country: vm.Form.objForm.country });
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) {
            vm.listallpayroll = data;
        }

        function errorFetchAllPayroll() {
            vm.listallpayroll = [];
        }

        function LoadPosition(companyId) {
            var response = AbsentRate.query({ action: 'getPosition', company: companyId });
            response.$promise.then(fetchPosition);
            response.$promise.catch(errorFetchPosition);
        }

        function fetchPosition(data) {
            vm.listposition = data;
        }

        function errorFetchPosition() {
            vm.listposition = [];
        }


        function LoadAttendance() {
            var response = AbsentRate.query({ action: 'getAttendanceCode' });
            response.$promise.then(fetchAttendance);
            response.$promise.catch(errorFetchAttendance);
        }

        function fetchAttendance(data) {
            vm.listattendancecode = data;
        }

        function errorFetchAttendance() {
            vm.listattendancecode = [];
        }

        function LoadCompany() {
            var response = AbsentRate.query({ action: 'getCompany' });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });
        res.then(ChangeDate);

        function ChangeDate(data) {
            LoadPosition(data.companyname);
            vm.Form.objForm.effective_date = new Date(data.effective_date);
            LoadPayroll();
            LoadAllPayroll();
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, AbsentRate);
            promise.then(function (data) {
                showDialog(ev, data);

            });
            promise.catch(function (data) {
                ShowFailed(ev, data)

            });
            //});
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.absentrate')
        .controller('NewAbsentRateController', NewAbsentRateController);

    NewAbsentRateController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$filter', '$element'];

    /* @ngInject */
    function NewAbsentRateController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/absentrate';

        var AbsentRate = AppAPI.NewAbsentRate();
        var PayrollProcess = AppAPI.NewPayrollProcess();

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputAbsentRate = inputAbsentRate;
        vm.lisAbsentRateSelected = [];
        vm.DeleteAbsentRate = DeleteAbsentRate;
        vm.editAbsentRate = editAbsentRate;
        vm.country = $localStorage.country;

        loadData(1);

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function loadData(pageno) {
            vm.DataTable.loadData(AbsentRate, pageno, { action: 'viewdata', country: vm.country });
        }

        function inputAbsentRate(ev) {
            $mdDialog.show({
                controller: 'InputNewabsentrateController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-absentrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editAbsentRate(ev, id) {
            $mdDialog.show({
                controller: 'EditNewabsentrateController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-absentrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisAbsentRateSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisAbsentRateSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteAbsentRate(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = AbsentRate.delete({ action: 'delete', data: angular.toJson(vm.lisAbsentRateSelected) });

                    response.$promise.then(loadData);
                }, function () {
                    //     
                });
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.13salary-mgr', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_13salary_mgr', {
                url    : '/new-payroll/13th-salary-manager',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/13salary-mgr/13salary.html',
                    controller : 'New13salaryMgrController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.13salary-mgr')
      .controller('NewNewUpload13salaryMgrController', NewNewUpload13salaryMgrController);
  
    NewNewUpload13salaryMgrController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function NewNewUpload13salaryMgrController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) 
    {
      var vm = this;
      var translate = $filter('translate');

      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/New13thSalary/uploadfile',
        removeAfterUpload: true,
        alias: 'filesalary',
        formData: [{
            action: 'uploadfile',
            isMgr: true
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/New13thSalary/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function() {
    'use strict';

    angular
        .module('app.payroll-new.13salary-mgr')
        .controller('Input13salaryMgrController', Input13salaryMgrController);

    Input13salaryMgrController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$filter'];

    /* @ngInject */
    function Input13salaryMgrController($localStorage,$mdDialog,Form,AppAPI,$http,config,$filter) {
          var vm = this;
          var translate = $filter('translate');
          vm.saveData=saveData;

          Form.initialForm();

          var endPoint= AppAPI.New13Salary();

          // set constructor form
          Form.setObject(endPoint);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.getEmployee=getEmployee;
          vm.saveData=saveData;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.Form.objForm.pay = new Date();
          vm.Form.objForm.amount = 0;
          vm.Form.objForm.empno='';
          vm.Form.objForm.year = '';
         
          var date = new Date();
          var year=date.getFullYear();

          vm.years = [
            {'id' : (year-1), 'name' : (year-1)},
            {'id' : year, 'name' : year},
            {'id' : (year+1), 'name' : (year+1)},
          ]

          function selectedItemChanged(employee)
          {
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         }

          function getEmployee(searchText){
            return $http
            .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
            .then(function(item) {
              // Map the response object to the data object.
              if(item.data.length===''){
                Form.objForm.empno='';
              }   
                return item.data;
            });
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, endPoint);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(errorSave);
          }

          function errorSave(data){
            var message = translate(data.pesan);
            var status  = translate(data.status);

              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev,data) 
          {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.13salary-mgr')
        .controller('Edit13salaryMgrController', Edit13salaryMgrController);

    Edit13salaryMgrController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function Edit13salaryMgrController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var endPoint = AppAPI.New13Salary();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;

        var date = new Date();
        var year=date.getFullYear();

        vm.years = [
            {'id' : (year-1), 'name' : (year-1)},
            {'id' : year, 'name' : year},
            {'id' : (year+1), 'name' : (year+1)},
        ]
        
        function selectedItemChanged(employee)
        {       
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;
            }
        }

        function getEmployee(searchText)
        {
           return $http
            .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite + '&isMgr=true')
            .then(function(item) {
                if(item.data.length===''){
                Form.objForm.empno='';
                }   
                return item.data;
            });
        }

        vm.closeModal = closeModal;   
        
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.pay = new Date(data.pay_date);    
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.fullname;
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, endPoint);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
               showDialog(ev,data)                 
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);
            
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.13salary-mgr')
        .controller('New13salaryMgrController', New13salaryMgrController);

    New13salaryMgrController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function New13salaryMgrController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/13salary';

        Form.initialForm();
        
        var endPoint = AppAPI.New13Salary();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();

        Form.setObject(endPoint);
        
        vm.Form = Form;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.input = input;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.edit = edit;
        vm.download = download;
        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.openUpload = openUpload;
        vm.company = $localStorage.empsite

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        vm.Form.objForm.empno = '';

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');
        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function LoadArea(company, cabangid, regionalid) 
        {
            LoadDivisi(company);
            loadWilayah();
            
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }


        function LoadCompany() {
            var response = endPoint.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = endPoint.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }


        function LoadDivisi(companyid) {
            var response = endPoint.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function selectedItemChanged(employee) 
        {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) 
        {
            return $http
                .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + vm.company + '&isMgr=true')
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function loadData(pageno) 
        {
            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }

            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi,
                isMgr: true
            });
        }

        function input(ev) 
        {
            $mdDialog.show({
                controller: 'Input13salaryMgrController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function edit(ev, id) {
            $mdDialog.show({
                controller: 'Edit13salaryMgrController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, endPoint);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'NewNewUpload13salaryMgrController as vm',
                templateUrl: basePath + '/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function download(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;
            var isMgr = true;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/New13thSalary/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + isMgr + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.13salary', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_13salary', {
                url    : '/new-payroll/13th-salary',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/13salary/13salary.html',
                    controller : 'New13salaryController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';
    angular
      .module('app.payroll-new.13salary')
      .controller('NewNewUpload13salaryController', NewNewUpload13salaryController);
  
    NewNewUpload13salaryController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter'];
    /** @ngInject */
    function NewNewUpload13salaryController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter) 
    {
      var vm = this;
      var translate = $filter('translate');

      vm.closeModal = closeModal
  
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.isMoreInfo = false
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/payrollnew/New13thSalary/uploadfile',
        removeAfterUpload: true,
        alias: 'filesalary',
        formData: [{
            action: 'uploadfile'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUpload.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/payrollnew/New13thSalary/downloadtemplate', '_blank');
          },function(){
            
              $window.alert('gagal load token');
          });
      }
  
      function viewMoreInfo()
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:vm.detailInfo
          }
        });
      }
    }
  })();  
(function() {
    'use strict';

    angular
        .module('app.payroll-new.13salary')
        .controller('Input13salaryController', Input13salaryController);

    Input13salaryController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$filter'];

    /* @ngInject */
    function Input13salaryController($localStorage,$mdDialog,Form,AppAPI,$http,config,$filter) {
          var vm = this;
          var translate = $filter('translate');
          vm.saveData=saveData;

          Form.initialForm();

          var endPoint= AppAPI.New13Salary();

          // set constructor form
          Form.setObject(endPoint);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.getEmployee=getEmployee;
          vm.saveData=saveData;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.Form.objForm.pay = new Date();
          vm.Form.objForm.amount = 0;
          vm.Form.objForm.empno='';
          vm.Form.objForm.year = '';
         
          var date = new Date();
          var year=date.getFullYear();

          vm.years = [
            {'id' : (year-1), 'name' : (year-1)},
            {'id' : year, 'name' : year},
            {'id' : (year+1), 'name' : (year+1)},
          ]

          function selectedItemChanged(employee)
          {
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         }

          function getEmployee(searchText){
            return $http
            .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
            .then(function(item) {
              // Map the response object to the data object.
              if(item.data.length===''){
                Form.objForm.empno='';
              }   
                return item.data;
            });
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, endPoint);
            promise.then(function(data){
                showDialog(ev,data);
            });
            promise.catch(errorSave);
          }

          function errorSave(data){
            var message = translate(data.pesan);
            var status  = translate(data.status);

              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev,data) 
          {
            var message = translate(data.pesan);
            var status  = translate(data.status);

           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll-new.13salary')
        .controller('Edit13salaryController', Edit13salaryController);

    Edit13salaryController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http','$filter'];

    /* @ngInject */
    function Edit13salaryController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http,$filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var endPoint = AppAPI.New13Salary();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;

        var date = new Date();
        var year=date.getFullYear();

        vm.years = [
            {'id' : (year-1), 'name' : (year-1)},
            {'id' : year, 'name' : year},
            {'id' : (year+1), 'name' : (year+1)},
        ]
        
        function selectedItemChanged(employee)
        {       
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;
            }
        }

        function getEmployee(searchText)
        {
           return $http
            .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
            .then(function(item) {
                if(item.data.length===''){
                Form.objForm.empno='';
                }   
                return item.data;
            });
        }

        vm.closeModal = closeModal;   
        
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.pay = new Date(data.pay_date);    
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.fullname;
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            var promise= Form.saveData('update', formController, endPoint);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
            promise.catch(function(data){
               showDialog(ev,data)                 
            });
        }

        function showDialog(ev,data) 
        {
            var message = translate(data.pesan);
            var status  = translate(data.status);
            
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new.13salary')
        .controller('New13salaryController', New13salaryController);

    New13salaryController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function New13salaryController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) 
    {
        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/payroll-new/13salary';

        Form.initialForm();
        
        var endPoint = AppAPI.New13Salary();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();

        Form.setObject(endPoint);
        
        vm.Form = Form;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.input = input;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.edit = edit;
        vm.download = download;
        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.LoadDivisi = LoadDivisi;
        vm.openUpload = openUpload;
        vm.company = $localStorage.empsite

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        vm.Form.objForm.empno = '';

        LoadCompany();
        LoadDivisi(vm.company);
        LoadArea(vm.company, '', '');
        vm.country = $localStorage.country;

        if (vm.country == 'MYS') {
            vm.reqWil = false;
            vm.reqArea = true;
            vm.LoadRegional = loadRegional;
            vm.LoadCabang = loadCabang;
            vm.LoadWilayah = loadWilayah;
            loadWilayah();
        }

        function LoadArea(company, cabangid, regionalid) 
        {
            LoadDivisi(company);
            loadWilayah();
            
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadRegional(id) {
            vm.listarea = [];
            vm.reqWil = true;
            vm.reqArea = false;
            var response = PayrollEmployee.query({
                action: 'getRegional',
                wilayahid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchRegional);
            response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional = data;
            var arrRegional = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrRegional.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, '', arrRegional);
        }

        function errorFetchRegional() {
            vm.listRegional = [];
        }

        function loadCabang(id) {
            var response = PayrollEmployee.query({
                action: 'getCabang',
                regionalid: id,
                companyid: vm.company
            });
            response.$promise.then(fetchCabang);
            response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang = data;
            var arrCabang = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    arrCabang.push('"' + data[i].id + '"');
                }
            }
            LoadArea(vm.company, arrCabang, '');
        }

        function errorFetchCabang() {
            vm.listCabang = [];
        }


        function LoadCompany() {
            var response = endPoint.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function LoadDepartment(company, iddivisi) {
            var response = endPoint.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }


        function LoadDivisi(companyid) {
            var response = endPoint.query({
                action: 'getDivisi',
                idbu: companyid
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(companyid, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function selectedItemChanged(employee) 
        {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) 
        {
            return $http
                .get(config.api + 'api/payrollnew/New13thSalary?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function loadData(pageno) 
        {
            var nik = '';
            var company = '';
            var department = '';
            var area = '';
            var divisi = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;
            if (typeof ($localStorage.empsite) != '')
                company = $localStorage.empsite;
            if (typeof (vm.department) != 'undefined')
                department = vm.department;
            if (typeof (vm.area) != 'undefined')
                area = vm.area;
            if (typeof (vm.divisi) != 'undefined')
                divisi = vm.divisi;
            if (typeof (vm.area) == 'undefined') {
                if (vm.arr_area.length > 0) {
                    area = vm.arr_area.toString();
                } else {
                    area = vm.area;
                }
            }

            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                nik: nik,
                company: vm.company,
                department: department,
                area: area,
                divisi: divisi
            });
        }

        function input(ev) 
        {
            $mdDialog.show({
                controller: 'Input13salaryController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function edit(ev, id) {
            $mdDialog.show({
                controller: 'Edit13salaryController',
                controllerAs: 'vm',
                templateUrl: basePath + '/input-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, endPoint);
            promise.then(function () {
                showDialog(ev);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'NewNewUpload13salaryController as vm',
                templateUrl: basePath + '/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function download(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;

            if (nik == '') nik = 'undefined';

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/New13thSalary/exportexcel/' + nik + '/' + company + '/' + department + '/' + area + '/' + divisi + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-pma.thrprocess', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payrollpma_thrprocess', {
                url    : '/payroll-pma/thrprocess',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-pma/thrprocess/thrprocess.html',
                    controller : 'ThrProcessController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-pma.thrprocess')
        .controller('ThrProcessController', ThrProcessController);

    ThrProcessController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth','$http','config','$element'];

    /* @ngInject */
    function ThrProcessController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth, $http,config,$element)
    {
       
        var vm = this;
        var dt = new Date();
        var year = dt.getFullYear()-1;

        Form.initialForm();
        
        var ThrProcess=AppAPI.ThrProcess();

        Form.setObject(ThrProcess);

        vm.Form = Form; 

        vm.changeCompany = changeCompany;
        vm.company = $localStorage.empsite
        
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;     

        vm.Form.objForm.period = new Date();
        vm.Form.objForm.area = '';
        vm.Form.objForm.empno = '';
        
        vm.LoadArea = LoadArea
        
        LoadCompany();
        LoadPeriod()
        LoadArea(vm.company);

        function LoadCompany() {
                var response=ThrProcess.query({action:'getCompany', company: vm.company});
                response.$promise.then(fetchCompany);
                response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
                vm.listcompany=data;
        }

        function errorFetchCompany() {
                vm.listcompany=[];
        } 

        function changeCompany(id)
        { 
                vm.listarea=[];
                var resp=ThrProcess.query({action:'getSpecificArea',companyid:id})
                resp.$promise.then(fetchspecificarea);
                resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data)
        {
                vm.listarea=data;
        }

        function errorfetchspecificarea()
        {
                vm.listarea=[];
        }
       
        function LoadArea(companyid) {
                var response=ThrProcess.query({action:'getArea', companyid:companyid});
                response.$promise.then(fetchArea);
                response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
                vm.listarea=data;
        }

        function errorFetchArea() {
                vm.listarea=[];
        } 

        function selectedItemChanged(employee)
        {   
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;
            }
        }

        function getEmployee(searchText)
        {
           return $http
                    .get(config.api + 'api/payrollpma/thrprocess?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                    .then(function(item) {
                        // Map the response object to the data object.
                        if(item.data.length==='')
                        {
                            Form.objForm.empno='';
                        } 
                        return item.data;
                    });
        }

        function loadData(pageno) 
        {
            vm.DataTable.loadData(ThrProcess,pageno,{action:'viewdata'});
        }

        function LoadPeriod() 
        {
            var response=ThrProcess.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) 
        {
            vm.listperiod=data;
        }

        function errorFetchPeriod() 
        {
            vm.listperiod=[];
        }

        function saveData(ev,formController) 
        {       
            var period = vm.Form.objForm.period;
            var company = vm.company;
            
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to process THR?')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
            
                $mdDialog.show(confirm).then(function() 
                {
                    angular.element('#attView').block({message:' <span>Loading...</span>'});

                    angular.element.blockUI();
                    vm.Form.objForm.companyid=vm.company;
                    var response=Form.saveData('save', formController, ThrProcess);
                    
                    response.then(fetchThr);
                    response.catch(errorFetchThr);
                        
                    // var check = PayrollProcess.query({action:'check', period: period, company:company });
                    // check.$promise.then(statusClosed);
                    // check.$promise.catch(function(){
                        
                    // });
                }, function() {
                    angular.element('#attView').unblock(); 
                });
            });
        }

        function fetchThr(data)
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function errorFetchThr()
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed THR Process')
            .textContent('Process Data was Fail.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        } 

        function statusClosed()
        {
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Periode has been Closed, Thr Can not be Proccesed')
            .textContent('Process Data was Fail.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        }        

        function statusThr()
        {
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Sorry, Another user still processing this THR.')
            .textContent('Try again in 15 minutes later.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
           //angular.element.unblockUI();
        }  

        function showDialog(ev) 
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success Save Data')
                .textContent('Process Data was Success.')
                .ariaLabel('Success Save Data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
       
       function closeModal()
       {
            $mdDialog.hide();
       }

       vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-pma.payrollprocess', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_process_pma', {
                url    : '/payroll-pma/payrollprocess',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-pma/payrollprocess/payrollprocess.html',
                    controller : 'PayrollProcesspmaController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll-pma.payrollprocess')
        .controller('PayrollProcesspmaController', PayrollProcesspmaController);

    PayrollProcesspmaController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth','$http','config','$element'];

    /* @ngInject */
    function PayrollProcesspmaController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth, $http,config,$element) {
       
       var vm = this;
       var dt = new Date();
       var year = dt.getFullYear()-1;

       Form.initialForm();
      
       var PayrollProcess=AppAPI.PayrollProcesspma();

       Form.setObject(PayrollProcess);

       vm.Form = Form; 

       vm.changeCompany = changeCompany;
       
       vm.company = $localStorage.empsite
       
       vm.saveData=saveData;
       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;     

    //    vm.listperiod = [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

       vm.Form.objForm.period = new Date();
       vm.Form.objForm.area = '';
       vm.Form.objForm.empno = '';
      
       vm.LoadArea = LoadArea
       
       LoadCompany();
       LoadPeriod()
       LoadArea(vm.company);

       function LoadCompany() {
            var response=PayrollProcess.query({action:'getCompany', company: vm.company});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
             // console.log(id);
             vm.listarea=[];
             var resp=PayrollProcess.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadArea(companyid) {
            var response=PayrollProcess.query({action:'getArea', companyid:companyid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 

        function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;

              }
         }

         function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payrollpma/payrollprocesspma?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            } 
              return item.data;
          });
         }

       function loadData(pageno) {

          vm.DataTable.loadData(PayrollProcess,pageno,{action:'viewdata'});
       }

       function LoadPeriod() {
          var response=PayrollProcess.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       }


       function saveData(ev,formController) 
       {       
            //var response= Form.saveData('save', formController, PayrollProcess);
            var period = vm.Form.objForm.period;
            var company = vm.company;
            
            var promise=Auth.setToken();
            promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to process payroll?')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
            
              $mdDialog.show(confirm).then(function() {
                  angular.element('#attView').block({message:' <span>Loading...</span>'});

                  var check = PayrollProcess.query({action:'check', period: period, company:company });
                  check.$promise.then(statusClosed);
                  check.$promise.catch(function(){
                    angular.element.blockUI();
                    vm.Form.objForm.companyid=vm.company;
                    var response=Form.saveData('save', formController, PayrollProcess);
                      response.then(fetchPayroll);
                      response.catch(errorFetchPayroll);
                  });
              }, function() {
                  angular.element('#attView').unblock();
                  
              });
            });
       }

        function fetchPayroll(data)
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function errorFetchPayroll()
        {
            angular.element.unblockUI();
           angular.element('#attView').unblock();
           vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Payroll Process')
            .textContent('Process Data was Fail.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
           //angular.element.unblockUI();
        } 

        function statusClosed()
        {
           angular.element('#attView').unblock();
           vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Periode has been Closed, Payroll Can not be Proccesed')
            .textContent('Process Data was Fail.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
           //angular.element.unblockUI();
        }        

        function statusPayroll()
        {
           angular.element('#attView').unblock();
           vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Sorry, Another user still processing this Payroll.')
            .textContent('Try again in 15 minutes later.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
           //angular.element.unblockUI();
        }  
        function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
       
       function closeModal()
       {
            $mdDialog.hide();
       }

       vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
     
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.payroll.uploadfixnonfix', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.payroll_uploadfixnonfix', {
                url    : '/payroll/uploadfixnonfix',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/payroll/uploadfixnonfix/upload-data.html',
                        controller : 'UploaddatafixnonfixController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.uploadfixnonfix')
        .controller('UploaddatafixnonfixController', UploaddatafixnonfixController);

    UploaddatafixnonfixController.$inject = ['$localStorage','FileUploader','config','Auth'];

    /* @ngInject */
    function UploaddatafixnonfixController($localStorage,FileUploader,config,Auth) {
        var vm = this;
        
        vm.UploadFixEntryStateSucces=false;
        vm.UploadFixEntryStateError=false;

        vm.UploadNonFixEntryStateSucces=false;
        vm.UploadNonFixEntryStateError=false;

    
        var uploaderFixEntry= vm.FileUploaderFixEntry= new FileUploader({
          url:config.api+'api/payroll/fixentry/uploadfilefixentry',
          removeAfterUpload:true,
          alias:'filefixentry',
          formData:[
               {
                action:'uploadfilefixentry'
               }
          ],
          onAfterAddingAll:function(){
                vm.UploadFixEntryStateSucces=false;
                vm.UploadFixEntryStateError=false;
         },
             headers:{
                  tokenAuth:$localStorage.tokenAuth
                }
        });


        uploaderFixEntry.onSuccessItem = function(item) {
            vm.UploadFixEntryStateSucces=true;
            vm.UploadFixEntryStateError=false;
            angular.element('#uploadFileFixEntry').val('');
        };

        uploaderFixEntry.onErrorItem=function()
        {
        	 vm.UploadFixEntryStateSucces=false;
             vm.UploadFixEntryStateError=true;
        };
      
        var uploaderNonFixEntry= vm.FileUploaderNonFixEntry= new FileUploader({
          url:config.api+'api/payroll/nonfixentry/uploadfilenonfixentry',
          removeAfterUpload:true,
          alias:'filenonfixentry',
          formData:[
               {
                action:'uploadfilenonfixentry'
               }
          ],
          onAfterAddingAll:function(){
                vm.UploadNonFixEntryStateSucces=false;
                vm.UploadNonFixEntryStateError=false;
         },
             headers:{
                  tokenAuth:$localStorage.tokenAuth
                }
        });

        uploaderNonFixEntry.onSuccessItem = function(item) {
            vm.UploadNonFixEntryStateSucces=true;
            vm.UploadNonFixEntryStateError=false;
            angular.element('#uploadFileFixEntry').val('');
        };

        uploaderNonFixEntry.onErrorItem=function()
        {
           vm.UploadNonFixEntryStateSucces=false;
             vm.UploadNonFixEntryStateError=true;
        };
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.taxparameter', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_taxparameter', {
                url    : '/payroll/taxparameter',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/taxparameter/taxparameter.html',
                    controller : 'TaxParameterController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.taxparameter')
        .controller('TaxParameterController', TaxParameterController);

    TaxParameterController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function TaxParameterController(AppAPI,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var TaxParameter=AppAPI.TaxParameter();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputTaxParameter= inputTaxParameter;
       vm.lisTaxParameterSelected=[];
       vm.DeleteTaxParameter=DeleteTaxParameter;
       vm.editTaxParameter=editTaxParameter;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(TaxParameter,pageno,{action:'viewdata'});
       }

       

       function inputTaxParameter(ev)
      {
          $mdDialog.show({
                controller         : 'InputtaxparameterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/taxparameter/input-taxparameter.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editTaxParameter(ev,id)
      {
        $mdDialog.show({
            controller         : 'EdittaxparameterController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/taxparameter/input-taxparameter.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisTaxParameterSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisTaxParameterSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, TaxParameter);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteTaxParameter(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=TaxParameter.delete({action:'delete',data:angular.toJson(vm.lisTaxParameterSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.taxparameter')
        .controller('InputtaxparameterController', InputtaxparameterController);

    InputtaxparameterController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputtaxparameterController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var TaxParameter= AppAPI.TaxParameter();


          // set constructor form
          Form.setObject(TaxParameter);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadSalcom = LoadSalcom;
          vm.LoadAllPayroll = LoadAllPayroll;
          vm.Form.objForm.T01gross = 0;
          vm.Form.objForm.T03gross = 0;
          vm.Form.objForm.T04gross = 0;
          vm.Form.objForm.T05gross = 0;
          vm.Form.objForm.T06gross = 0;
          vm.Form.objForm.T07gross = 0;
          vm.Form.objForm.T10 = 0;
          vm.Form.objForm.biayajabatan = 0;
          vm.Form.objForm.biayajabatanmax = 0;
          vm.Form.objForm.pkp1_limit  = 0;
          vm.Form.objForm.pkp2_limit = 0;
          vm.Form.objForm.pkp3_limit = 0;
          vm.Form.objForm.pkp4_limit = 0;

          vm.saveData=saveData;
          

          LoadSalcom();
          LoadAllPayroll();

          function LoadSalcom(){
            var response=TaxParameter.query({action:'getSalcom'});
            response.$promise.then(fetchSalcom);
            response.$promise.catch(errorFetchSalcom);
          }

          function fetchSalcom(data) {
            vm.listSalcom=data;
          }

          function errorFetchSalcom() {
            vm.listSalcom=[];
          }

          function LoadAllPayroll(){
            var response=TaxParameter.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
          }

          function fetchAllPayroll(data) {
            vm.listallpayroll=data;
          }

          function errorFetchAllPayroll() {
            vm.listallpayroll=[];
          }

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, TaxParameter);
            /*promise.then(function(){
                showDialog(ev);
            });*/
            promise.then(SaveSucces);
            promise.catch(errorSave);
          }

          function SaveSucces(){
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.taxparameter')
        .controller('EdittaxparameterController', EdittaxparameterController);

    EdittaxparameterController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EdittaxparameterController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var TaxParameter = AppAPI.TaxParameter();

        // set constructor form
        Form.setObject(TaxParameter);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadSalcom = LoadSalcom;
        vm.LoadAllPayroll = LoadAllPayroll;
        vm.saveData=saveData;

        LoadSalcom();
        LoadAllPayroll();
        
        function LoadSalcom(){
            var response=TaxParameter.query({action:'getSalcom'});
            response.$promise.then(fetchSalcom);
            response.$promise.catch(errorFetchSalcom);
        }

        function fetchSalcom(data) {
             vm.listSalcom=data;
        }

        function errorFetchSalcom() {
            vm.listSalcom=[];
        }

        function LoadAllPayroll(){
            var response=TaxParameter.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) {
            vm.listallpayroll=data;
        }

        function errorFetchAllPayroll() {
            vm.listallpayroll=[];
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(ChangeData);

        function ChangeData(data){
            vm.Form.objForm.biayajabatan = parseFloat(data.biayajabatan);
            vm.Form.objForm.biayajabatanmax = parseFloat(data.biayajabatanmax);
            vm.Form.objForm.pkp1_limit = parseFloat(data.pkp1_limit);
            vm.Form.objForm.pkp1 = parseFloat(data.pkp1);
            vm.Form.objForm.pkp2_limit = parseFloat(data.pkp2_limit);
            vm.Form.objForm.pkp2 = parseFloat(data.pkp2);
            vm.Form.objForm.pkp3_limit = parseFloat(data.pkp3_limit);
            vm.Form.objForm.pkp3 = parseFloat(data.pkp3);
            vm.Form.objForm.pkp4_limit = parseFloat(data.pkp4_limit);
            vm.Form.objForm.pkp4 = parseFloat(data.pkp4);
            vm.Form.objForm.nonnpwp_pinalty = parseFloat(data.nonnpwp_pinalty);
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, TaxParameter);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.taxlocation', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_taxlocation', {
                url    : '/payroll/taxlocation',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/taxlocation/taxlocation.html',
                    controller : 'TaxLocationController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.taxlocation')
        .controller('TaxLocationController', TaxLocationController);

    TaxLocationController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function TaxLocationController(AppAPI,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var TaxLocation=AppAPI.TaxLocation();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputTaxLocation= inputTaxLocation;
       vm.lisTaxLocationSelected=[];
       vm.DeleteTaxLocation=DeleteTaxLocation;
       vm.editTaxLocation=editTaxLocation;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(TaxLocation,pageno,{action:'viewdata'});
       }

       

       function inputTaxLocation(ev)
      {
          $mdDialog.show({
                controller         : 'InputtaxlocationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/taxlocation/input-taxlocation.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editTaxLocation(ev,id)
      {
        $mdDialog.show({
            controller         : 'EdittaxlocationController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/taxlocation/input-taxlocation.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listaxlocationSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.listaxlocationSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, TaxLocation);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteTaxLocation(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=TaxLocation.delete({action:'delete',data:angular.toJson(vm.lisTaxLocationSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.taxlocation')
        .controller('InputtaxlocationController', InputtaxlocationController);

    InputtaxlocationController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputtaxlocationController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var TaxLocation= AppAPI.TaxLocation();


          // set constructor form
          Form.setObject(TaxLocation);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.Form.objForm.branchnpwpno = '';
          vm.Form.objForm.branchsignername = '';
          vm.Form.objForm.branchsignernpwp = '';
          vm.Form.objForm.branchaddress = '';
          vm.Form.objForm.branchcity = '';
          vm.saveData=saveData;
        

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, TaxLocation);
            /*promise.then(function(){
                showDialog(ev);
            });*/
            promise.then(SaveSucces);
            promise.catch(errorSave);
          }

          function SaveSucces(){
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.taxlocation')
        .controller('EdittaxlocationController', EdittaxlocationController);

    EdittaxlocationController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EdittaxlocationController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var TaxLocation = AppAPI.TaxLocation();

        // set constructor form
        Form.setObject(TaxLocation);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.Form.objForm.branchnpwpno = '';
        vm.Form.objForm.branchsignername = '';
        vm.Form.objForm.branchsignernpwp = '';
        vm.Form.objForm.branchaddress = '';
        vm.Form.objForm.branchcity = '';
        vm.saveData=saveData;
        
          
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, TaxLocation);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.syncemployee', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_syncemployee', {
                url    : '/payroll/syncemployee',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/syncemployee/syncemployee.html',
                    controller : 'SyncemployeeController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.syncemployee')
        .controller('SyncemployeeController', SyncemployeeController);

    SyncemployeeController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function SyncemployeeController(AppAPI,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var SyncEmployee=AppAPI.SyncEmployee();
       vm.ResyncEmployee= ResyncEmployee;
       vm.UpdateEmployee=UpdateEmployee;
       

       function ResyncEmployee()
      {
           var promise= Form.saveData('save');
            promise.then(function(){
                showDialog(ev);
            });
      }

      function UpdateEmployee()
      {
            var promise= Form.saveData('update');
            promise.then(function(){
                showDialog(ev);
            });
      }
      
    }
})();
(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.payroll.sync_pma', []).config(config);

  config.$inject = ['$stateProvider'];


  function config($stateProvider) {

    $stateProvider
      .state('app.payroll_sync_pma', {
        url: '/payroll/sync_pma',
        views: {
          'content@app': {
            templateUrl: 'app/main/payroll/sync-pma/sync-pma.html',
            controller: 'SyncPmaController as vm'
          }
        }

      });

    // Translation
    //$translatePartialLoaderProvider.addPart('app');
  }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll.sync_pma')
        .controller('SyncPmaController', SyncPmaController);

    SyncPmaController.$inject = ['$q', 'AppAPI', '$http', 'config', '$interval', '$timeout', '$location', '$anchorScroll', '$log', '$element', '$mdToast'];

    /* @ngInject */
    function SyncPmaController($q, AppAPI, $http, config, $interval, $timeout, $location, $anchorScroll, $log, $element, $mdToast) {

        var vm = this;
        var SyncPma = new AppAPI.SyncPma();
        vm.doSync = doSync;
        vm.determinateValue = 0;
        vm.showResult = showResult;
        vm.syncAll = syncAll;
        vm.employeeLists = [];
        vm.selectedSubArea = '';
        vm.searchText = '';
        vm.addEmployeeBySubArea = addEmployeeBySubArea;
        vm.isLoading = false;
        vm.syncData = syncData;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.selected = [];

        vm.determinateValue = 0;
        vm.interval = 100;

        loadSubArea();
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function loadSubArea() {
            var response = SyncPma.query({
                action: 'getSubArea'
            });
            response.$promise.then(function (data) {
                vm.sub_areaLists = data;
            });
            response.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function loadEmployeeBySubArea(sub_area_id) {
            var defer = $q.defer();
            var response = SyncPma.query({
                action: 'getEmployeeSubArea',
                sub_area_id: sub_area_id
            });
            response.$promise.then(function (data) {

                data.find(function (row) {
                    row.checked = true;
                });

                vm.employeeLists = data;

                defer.resolve(data);

            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject();
            });
            return defer.promise;
        }

        function addEmployeeBySubArea(SelectedSubArea) {
            loadEmployeeBySubArea(SelectedSubArea.id).then(function () {
                toggleAll();
                vm.toggle_all = true;
            });
        }

        function syncData(ev) {
            ev.preventDefault();
            var defer = $q.defer();
            var empNikList = '';
            vm.isLoading = true;

            vm.selected.find(function (emp) {
                empNikList += emp.nik + ',';
            });
            empNikList = empNikList.slice(0, -1);

            if (empNikList === '' && vm.employeeLists.length > 0) {
                return false;
            }

            $interval(function () {
                vm.determinateValue += 1;
                if (vm.determinateValue > 100) vm.determinateValue = 10;
            }, vm.interval, 0, true);

            var area = vm.selectedSubArea.id + '|' + vm.selectedSubArea.description;
            var response = SyncPma.get({
                action: 'synchronize',
                niks: empNikList,
                area: area
            });
            response.$promise.then(function (data) {

                vm.interval = 50;
                $timeout(function () {
                    vm.isLoading = false;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Syncrhonizing to PMA is successfully')
                            .position('top right')
                            .hideDelay(10000)
                            .theme("success-toast")
                    );

                }, 1000);

                defer.resolve(data);
            });
            response.$promise.catch(function (error) {

                console.log('synchronize error', error);

                // $log.info(data);

                vm.interval = 50;
                $timeout(function () {
                    vm.isLoading = false;
                }, 1000);

                defer.reject();
            });
            return defer.promise;
        }

        function doSync(ev, item) {
            ev.preventDefault();
            var defer = $q.defer();

            item.isLoading = true;
            item.showResult = false;
            item.showBtnResult = false;
            item.result = '';
            item.interval = 200;
            item.determinateValue = 0;

            $interval(function () {
                item.determinateValue += 1;
                if (item.determinateValue > 100) item.determinateValue = 10;
            }, item.interval, 0, true);

            $http.get(config.api + 'api/syncpma/synchronize?table=' + item.table).then(function (res) {
                if (res.status === 200) {
                    item.color = 'green';
                } else {
                    item.color = 'red';
                }

                item.interval = 50;
                $timeout(function () {
                    item.isLoading = false;
                    item.result = res.data;
                    item.showBtnResult = true;
                    defer.resolve();
                }, 1000);

            }).catch(function (err) {
                item.color = 'red';
                item.result = err.data;
                item.isLoading = false;
                item.showBtnResult = true;
                defer.reject();
            });
            defer.promise;
        }

        function showResult(ev, item) {
            ev.preventDefault();
            if (item.showResult) {
                item.showResult = false
            } else {
                item.showResult = true;
                $timeout(function () {
                    $location.hash(item.table);
                    $anchorScroll();
                }, 200)
            }
        }

        function syncAll(ev) {
            ev.preventDefault();
            var idx = 0;
            vm.tableNameLists.map(function (val) {
                if (idx === 0) {
                    doSync(ev, val);
                } else {
                    $timeout(function () {
                        doSync(ev, val);
                    }, 150 * idx);
                }
                idx++;
            });
        }

        function progressLoading(item) {
            var defer = $q.defer();
            console.log('item', item.isLoading);
            if (item.isLoading) {
                $timeout(function () {
                    item.determinateValue += 1;
                    if (item.determinateValue > 100) {
                        // item.determinateValue = 10;

                        progressLoading(item);
                        defer.resolve();
                    }
                }, 200, 0, true);
            } else {
                defer.reject();
            }
            defer.promise;
        }

        function toggle(ev, item) {
            var idx = vm.selected.indexOf(item);
            if (idx > -1) {
                vm.selected.splice(idx, 1);
                item.checked = false;
            } else {
                vm.selected.push(item);
                item.checked = true;
            }
            console.log('item', item);
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return vm.selected.length !== 0 && vm.selected.length !== vm.employeeLists.length;
        }

        function isChecked(item) {
            // console.log('item', item);
            // return vm.selected.length === vm.employeeLists.length;
            return vm.selected.indexOf(item) > -1;
        }

        function toggleAll() {
            if (vm.selected.length === vm.employeeLists.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.employeeLists.slice(0);
            }
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.shiftrate', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_shiftrate', {
                url    : '/payroll/shiftrate',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/shiftrate/shiftrate.html',
                    controller : 'ShiftRateController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.shiftrate')
        .controller('ShiftRateController', ShiftRateController);

    ShiftRateController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function ShiftRateController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var ShiftRate=AppAPI.ShiftRate();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputShiftRate= inputShiftRate;
       vm.lisShiftRateSelected=[];
       vm.DeleteShiftRate=DeleteShiftRate;
       vm.editShiftRate=editShiftRate;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(ShiftRate,pageno,{action:'viewdata', company: $localStorage.empsite});
       }

       

       function inputShiftRate(ev)
      {
          $mdDialog.show({
                controller         : 'InputshiftrateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/shiftrate/input-shiftrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editShiftRate(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditshiftrateController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/shiftrate/input-shiftrate.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisshiftrateSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisshiftrateSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, ShiftRate);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteShiftRate(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=ShiftRate.delete({action:'delete',data:angular.toJson(vm.lisShiftRateSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.shiftrate')
        .controller('InputshiftrateController', InputshiftrateController);

    InputshiftrateController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputshiftrateController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var ShiftRate= AppAPI.ShiftRate();


          // set constructor form
          Form.setObject(ShiftRate);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadPosition = LoadPosition;
          vm.LoadShift = LoadShift;
          vm.LoadPayroll = LoadPayroll;
          vm.LoadAllPayroll = LoadAllPayroll;
          vm.LoadCompany = LoadCompany;
          vm.changePosition = changePosition;
          vm.changeShift = changeShift;
          vm.saveData=saveData;

          vm.Form.objForm.effective_date = new Date();
          vm.Form.objForm.flag_prorate = 0;
          vm.Form.objForm.formula = 0;
      
          LoadPayroll();
          LoadAllPayroll();
          LoadPosition();
          LoadShift();
          LoadCompany();

          function changePosition(id)
          { 
              // console.log(id);
              //vm.listPositiondetail=[];
              var resp=ShiftRate.query({action:'getDetailPosition',id:id})
              resp.$promise.then(fetchdetailposition);
              resp.$promise.catch(errorfetchdetailposition);
          }

          function fetchdetailposition(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.posdesc = data[0].name;
          }

          function errorfetchdetailposition()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.posdesc = []; 
          }

          function changeShift(id)
          { 
              // console.log(id);
              //vm.listPositiondetail=[];
              var resp=ShiftRate.query({action:'getDetailShift',id:id})
              resp.$promise.then(fetchdetailshift);
              resp.$promise.catch(errorfetchdetailshift);
          }

          function fetchdetailshift(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.shiftdesc = data[0].name;
          }

          function errorfetchdetailshift()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.shiftdesc = [];
          }

          function LoadPayroll() {
            var response=ShiftRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          }

          function LoadAllPayroll() {
            var response=ShiftRate.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
          }

          function fetchAllPayroll(data) {
            vm.listallpayroll=data;
          }

          function errorFetchAllPayroll() {
            vm.listallpayroll=[];
          } 

          function LoadPosition() {
            var response=ShiftRate.query({action:'getPosition', company: $localStorage.empsite});
            response.$promise.then(fetchPosition);
            response.$promise.catch(errorFetchPosition);
          }

          function fetchPosition(data) {
            vm.listposition=data;
          }

          function errorFetchPosition() {
            vm.listposition=[];
          }

          function LoadShift() {
            var response=ShiftRate.query({action:'getShift'});
            response.$promise.then(fetchShift);
            response.$promise.catch(errorFetchShift);
          }

          function fetchShift(data) {
            vm.listshift=data;
          }

          function errorFetchShift() {
            vm.listshift=[];
          }

          function LoadCompany() {
            var response=ShiftRate.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
            vm.listcompany=data;
          }

          function errorFetchCompany() {
            vm.listcompany=[];
          }

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, ShiftRate);
            /*promise.then(function(){
                showDialog(ev);
            });*/
            promise.then(SaveSucces);
            promise.catch(errorSave);
          }

          function SaveSucces(){
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.shiftrate')
        .controller('EditshiftrateController', EditshiftrateController);

    EditshiftrateController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditshiftrateController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var ShiftRate = AppAPI.ShiftRate();

        // set constructor form
        Form.setObject(ShiftRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadPosition = LoadPosition;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadShift = LoadShift;
        vm.LoadCompany = LoadCompany;
        vm.changePosition = changePosition;
        vm.changeShift = changeShift;
        vm.saveData=saveData;

        LoadPayroll();
        LoadAllPayroll();
        LoadPosition();
        LoadShift();
        LoadCompany();

        function changePosition(id)
          { 
              // console.log(id);
              //vm.listPositiondetail=[];
              var resp=ShiftRate.query({action:'getDetailPosition',id:id})
              resp.$promise.then(fetchdetailposition);
              resp.$promise.catch(errorfetchdetailposition);
          }

          function fetchdetailposition(data)
          {
               //vm.listPositiondetail=data;
               if(data) 
               vm.Form.objForm.posdesc = data[0].name;
              else vm.Form.objForm.posdesc =  'All';
          }

          function errorfetchdetailposition()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.posdesc = []; 
          }

          function changeShift(id)
          { 
              // console.log(id);
              //vm.listPositiondetail=[];
              var resp=ShiftRate.query({action:'getDetailShift',id:id})
              resp.$promise.then(fetchdetailshift);
              resp.$promise.catch(errorfetchdetailshift);
          }

          function fetchdetailshift(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.shiftdesc = data[0].name;
          }

          function errorfetchdetailshift()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.shiftdesc = [];
          }

        function LoadPayroll() {
            var response=ShiftRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        function LoadAllPayroll() {
            var response=ShiftRate.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
        }

        function fetchAllPayroll(data) {
            vm.listallpayroll=data;
        }

        function errorFetchAllPayroll() {
            vm.listallpayroll=[];
        } 

        function LoadPosition() {
            var response=ShiftRate.query({action:'getPosition'});
            response.$promise.then(fetchPosition);
            response.$promise.catch(errorFetchPosition);
        }

        function fetchPosition(data) {
            vm.listposition=data;
        }

        function errorFetchPosition() {
            vm.listposition=[];
        } 

        function LoadShift() {
            var response=ShiftRate.query({action:'getShift'});
            response.$promise.then(fetchShift);
            response.$promise.catch(errorFetchShift);
        }

        function fetchShift(data) {
            vm.listshift=data;
        }

        function errorFetchShift() {
            vm.listshift=[];
        }
          
        function LoadCompany() {
            var response=ShiftRate.query({action:'getCompany'});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany=data;
        }

        function errorFetchCompany() {
            vm.listcompany=[];
        }
        
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);    

        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, ShiftRate);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.salarycomponent', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_salarycomponent', {
                url    : '/payroll/salarycomponent',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/salarycomponent/salarycomponent.html',
                    controller : 'SalaryComponentController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.salarycomponent')
        .controller('SalaryComponentController', SalaryComponentController);

    SalaryComponentController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function SalaryComponentController(AppAPI,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var SalaryComponent=AppAPI.SalaryComponent();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputSalaryComponent= inputSalaryComponent;
       vm.lisSalaryComponentSelected=[];
       vm.DeleteSalaryComponent=DeleteSalaryComponent;
       vm.editSalaryComponent=editSalaryComponent;
       vm.listSalcom=[];

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(SalaryComponent,pageno,{action:'viewdata'});
       }

       

       function inputSalaryComponent(ev)
      {
          $mdDialog.show({
                controller         : 'InputsalarycomponentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/salarycomponent/input-salarycomponent.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editSalaryComponent(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditsalarycomponentController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/salarycomponent/input-salarycomponent.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisSalaryComponentSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisSalaryComponentSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, SalaryComponent);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteSalaryComponent(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=SalaryComponent.delete({action:'delete',data:angular.toJson(vm.lisSalaryComponentSelected)});

           response.$promise.then(loadData);
           response.$promise.catch(ErrDel);

           loadData(1);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });

        function ErrDel(){
         alert("Sorry, Data can't delete. other transactions using this data");
        
        }
  
      }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.salarycomponent')
        .controller('InputsalarycomponentController', InputsalarycomponentController);

    InputsalarycomponentController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputsalarycomponentController($localStorage,$mdDialog,Form,AppAPI) {
          
      var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var Salarycomponent= AppAPI.SalaryComponent();


          // set constructor form
          Form.setObject(Salarycomponent);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.liststatus = ['Allowance', 'Deduction'];
          vm.listtype = ['Fix', 'Non Fix', 'System', 'Formula'];
          vm.listthp = ['Yes', 'No'];
          vm.saveData=saveData;
          vm.changeType = changeType;
          vm.LoadAllPayroll = LoadAllPayroll;

          LoadAllPayroll();
          
          function changeType(id){
              console.log(id);
              document.getElementById('formula').style.backgroundColor = "white";
              if(id != 'Formula')
              {
                document.getElementById('formula').disabled = true;
                document.getElementById('formula').style.backgroundColor = "lightgrey";
              }    
              else
                 document.getElementById('formula').disabled = false;
          }

          function LoadAllPayroll(){
            var response=Salarycomponent.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
          }

          function fetchAllPayroll(data) {
            vm.listallpayroll=data;
          }

          function errorFetchAllPayroll() {
            vm.listallpayroll=[];
          }

          function closeModal()
          {
            $mdDialog.hide();
          }

           function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, Salarycomponent);
            promise.then(function(){
                showDialog(ev);
            });
            promise.catch(errorSave);
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
         

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.salarycomponent')
        .controller('EditsalarycomponentController', EditsalarycomponentController);

    EditsalarycomponentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditsalarycomponentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Salarycomponent = AppAPI.SalaryComponent();

        // set constructor form
        Form.setObject(Salarycomponent);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.liststatus = ['Allowance', 'Deduction'];
        vm.listtype = ['Fix', 'Non Fix', 'System', 'Formula'];
        vm.listthp = ['Yes', 'No'];
        vm.saveData=saveData;

        vm.changeType = changeType;
        vm.LoadAllPayroll = LoadAllPayroll;

        LoadAllPayroll();

        function changeType(id){
            console.log(id);
            if(id != 'Formula')
            {
                document.getElementById('formula').disabled = true;
                document.getElementById('formula').style.backgroundColor = "lightgrey";
            }    
            else{
                 document.getElementById('formula').disabled = false;
                 document.getElementById('formula').style.backgroundColor = "white";
            }
        }

        function LoadAllPayroll(){
            var response=Salarycomponent.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
          }

          function fetchAllPayroll(data) {
            vm.listallpayroll=data;
          }

          function errorFetchAllPayroll() {
            vm.listallpayroll=[];
          }
          
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeData);

        function ChangeData(data){
            if(data.type != 'Formula')
            {
                document.getElementById('formula').disabled = true;
                document.getElementById('formula').style.backgroundColor = "lightgrey";
            }
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, Salarycomponent);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.ptkp', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_ptkp', {
                url    : '/payroll/ptkp',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/ptkp/ptkp.html',
                    controller : 'PtkpController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.ptkp')
        .controller('PtkpController', PtkpController);

    PtkpController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function PtkpController(AppAPI,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var Ptkp=AppAPI.Ptkp();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputPtkp= inputPtkp;
       vm.lisPtkpSelected=[];
       vm.DeletePtkp=DeletePtkp;
       vm.editPtkp=editPtkp;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(Ptkp,pageno,{action:'viewdata'});
       }

       

       function inputPtkp(ev)
      {
          $mdDialog.show({
                controller         : 'InputptkpController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/ptkp/input-ptkp.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editPtkp(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditptkpController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/ptkp/input-ptkp.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisPtkpSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisPtkpSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, Ptkp);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeletePtkp(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=Ptkp.delete({action:'delete',data:angular.toJson(vm.lisPtkpSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.ptkp')
        .controller('InputptkpController', InputptkpController);

    InputptkpController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputptkpController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var Ptkp= AppAPI.Ptkp();


          // set constructor form
          Form.setObject(Ptkp);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.saveData=saveData;
          vm.Form.objForm.effective_date = new Date();
          
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, Ptkp);
            /*promise.then(function(){
                showDialog(ev);
            });*/
            promise.then(SaveSucces);
            promise.catch(errorSave);
          }

          function SaveSucces(){
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.ptkp')
        .controller('EditptkpController', EditptkpController);

    EditptkpController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditptkpController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var Ptkp = AppAPI.Ptkp();

        // set constructor form
        Form.setObject(Ptkp);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;

        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);    
            vm.Form.objForm.amount = parseInt(data.amount);
        }

            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, Ptkp);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.prorateparameter', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_prorateparameter', {
                url    : '/payroll/prorateparameter',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/prorateparameter/prorateparameter.html',
                    controller : 'prorateparameterController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.prorateparameter')
        .controller('prorateparameterController', prorateparameterController);

    prorateparameterController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function prorateparameterController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var ProrateParameter=AppAPI.ProrateParameter();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputProrateParameter= inputProrateParameter;
       vm.lisProrateParameterSelected=[];
       vm.DeleteProrateParameter=DeleteProrateParameter;
       vm.editProrateParameter=editProrateParameter;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(ProrateParameter,pageno,{action:'viewdata',company:$localStorage.empsite});
       }

       

       function inputProrateParameter(ev)
      {
          $mdDialog.show({
                controller         : 'InputprorateparameterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/prorateparameter/input-prorateparameter.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editProrateParameter(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditprorateparameterController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/prorateparameter/input-prorateparameter.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisprorateparameterSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisprorateparameterSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, ProrateParameter);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteProrateParameter(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=ProrateParameter.delete({action:'delete',data:angular.toJson(vm.lisProrateParameterSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.prorateparameter')
        .controller('InputprorateparameterController', InputprorateparameterController);

    InputprorateparameterController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputprorateparameterController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var ProrateParameter= AppAPI.ProrateParameter();


          // set constructor form
          Form.setObject(ProrateParameter);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadSalcom = LoadSalcom;
          vm.LoadAllPeriod = LoadAllPeriod;
          vm.LoadCompany = LoadCompany;
          vm.listtype = ['Working Days', 'Fix Days', 'Calendar Days'];
          vm.changePayrollBase = changePayrollBase;
          vm.changePayrollPost = changePayrollPost; 
          vm.saveData=saveData;
          vm.Form.objForm.fixdays = 0;
          vm.changeType = changeType;

         LoadSalcom();
         LoadAllPeriod();
         LoadCompany();

         function changeType(id){
            console.log(id);
            if(id != 'Fix Days')
            {
                document.getElementById('fixdays').disabled = true;
                document.getElementById('fixdays').style.backgroundColor = "lightgrey";
            }
            else{
                document.getElementById('fixdays').style.backgroundColor = "white";
                document.getElementById('fixdays').disabled = false;
            }    
          
         }

          function changePayrollBase(id)
          { 
              // console.log(id);
              //vm.listPositiondetail=[];
              var resp=ProrateParameter.query({action:'getDetailSalcom',id:id})
              resp.$promise.then(fetchdetailsalcom);
              resp.$promise.catch(errorfetchdetailsalcom);
          }

          function fetchdetailsalcom(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrollbasedesc = data[0].name;
          }

          function errorfetchdetailsalcom()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrollbasedesc = [];
          }

          function changePayrollPost(id)
          { 
              // console.log(id);
              //vm.listPositiondetail=[];
              var resp=ProrateParameter.query({action:'getDetailSalcom',id:id})
              resp.$promise.then(fetchdetailpayrollpost);
              resp.$promise.catch(errorfetchdetailpayrollpost);
          }

          function fetchdetailpayrollpost(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrollpostdesc = data[0].name;
          }

          function errorfetchdetailpayrollpost()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrollpostdesc = [];
          }

          function LoadSalcom() {
            var response=ProrateParameter.query({action:'getPayrollCode'});
            response.$promise.then(fetchSalcom);
            response.$promise.catch(errorFetchSalcom);
          }

          function fetchSalcom(data) {
            vm.listsalcom=data;
          }

          function errorFetchSalcom() {
            vm.listsalcom=[];
          } 

          function LoadAllPeriod() {
            var response=ProrateParameter.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPeriod);
            response.$promise.catch(errorFetchAllPeriod);
          }

          function fetchAllPeriod(data) {
            vm.listallperiod=data;
          }

          function errorFetchAllPeriod() {
            vm.listallperiod=[];
          } 

          function LoadCompany() {
            var response=ProrateParameter.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
            vm.listcompany=data;
          }

          function errorFetchCompany() {
            vm.listcompany=[];
          }
          
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, ProrateParameter);
            /*promise.then(function(){
                showDialog(ev);
            });*/
            promise.then(SaveSucces);
            promise.catch(errorSave);
          }

          function SaveSucces(){
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.prorateparameter')
        .controller('EditprorateparameterController', EditprorateparameterController);

    EditprorateparameterController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditprorateparameterController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var ProrateParameter = AppAPI.ProrateParameter();

        // set constructor form
        Form.setObject(ProrateParameter);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadSalcom = LoadSalcom;
        vm.LoadAllPeriod = LoadAllPeriod;
        vm.LoadCompany = LoadCompany;
        vm.listtype = ['Working Days', 'Fix Days', 'Calendar Days'];
        vm.changePayrollBase = changePayrollBase;
        vm.saveData=saveData;
        vm.changeType = changeType;

        LoadSalcom();
        LoadAllPeriod();
        LoadCompany();

        function changeType(id){
            console.log(id);
            if(id != 'Fix Days')
            {
                document.getElementById('fixdays').disabled = true;
                document.getElementById('fixdays').style.backgroundColor = "lightgrey";
            }else{
              document.getElementById('fixdays').style.backgroundColor = "white";
              document.getElementById('fixdays').disabled = false;
            
            }    
          
        }

        function changePayrollBase(id)
          { 
              // console.log(id);
              //vm.listPositiondetail=[];
              var resp=ProrateParameter.query({action:'getDetailSalcom',id:id})
              resp.$promise.then(fetchdetailsalcom);
              resp.$promise.catch(errorfetchdetailsalcom);
          }

          function fetchdetailsalcom(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrollbasedesc = data[0].name;
          }

          function errorfetchdetailsalcom()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrollbasedesc = [];
          }

          function changePayrollPost(id)
          { 
              // console.log(id);
              //vm.listPositiondetail=[];
              var resp=ProrateParameter.query({action:'getDetailSalcom',id:id})
              resp.$promise.then(fetchdetailpayrollpost);
              resp.$promise.catch(errorfetchdetailpayrollpost);
          }

          function fetchdetailpayrollpost(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrollpostdesc = data[0].name;
          }

          function errorfetchdetailpayrollpost()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrollpostdesc = [];
          }

          function LoadSalcom() {
            var response=ProrateParameter.query({action:'getPayrollCode'});
            response.$promise.then(fetchSalcom);
            response.$promise.catch(errorFetchSalcom);
          }

          function fetchSalcom(data) {
            vm.listsalcom=data;
          }

          function errorFetchSalcom() {
            vm.listsalcom=[];
          } 

          function LoadAllPeriod() {
            var response=ProrateParameter.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPeriod);
            response.$promise.catch(errorFetchAllPeriod);
          }

          function fetchAllPeriod(data) {
            vm.listallperiod=data;
          }

          function errorFetchAllPeriod() {
            vm.listallperiod=[];
          } 
          
        function LoadCompany() {
            var response=ProrateParameter.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
            vm.listcompany=data;
          }

          function errorFetchCompany() {
            vm.listcompany=[];
          }
          
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeData);

        function ChangeData(data){
            vm.Form.objForm.fixdays = parseInt(data.fixdays);

            if(data.type != 'Fix Days')
            {
                document.getElementById('fixdays').disabled = true;
                document.getElementById('fixdays').style.backgroundColor = "lightgrey";
            }   
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, ProrateParameter);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.positionrate', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_positionrate', {
                url    : '/payroll/positionrate',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/positionrate/positionrate.html',
                    controller : 'PositionRateController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.positionrate')
        .controller('PositionRateController', PositionRateController);

    PositionRateController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function PositionRateController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var PositionRate=AppAPI.PositionRate();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputPositionRate= inputPositionRate;
       vm.lisPositionRateSelected=[];
       vm.DeletePositionRate=DeletePositionRate;
       vm.editPositionRate=editPositionRate;
       
      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(PositionRate,pageno,{action:'viewdata', company:$localStorage.empsite});
       }

       

       function inputPositionRate(ev)
      {
          $mdDialog.show({
                controller         : 'InputpositionrateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/positionrate/input-positionrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editPositionRate(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditpositionrateController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/positionrate/input-positionrate.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lispositionrateSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lispositionrateSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, PositionRate);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeletePositionRate(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=PositionRate.delete({action:'delete',data:angular.toJson(vm.lisPositionRateSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.positionrate')
        .controller('InputpositionrateController', InputpositionrateController);

    InputpositionrateController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputpositionrateController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var PositionRate= AppAPI.PositionRate();


          // set constructor form
          Form.setObject(PositionRate);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadPosition = LoadPosition;
          vm.LoadPayroll = LoadPayroll;
          vm.LoadCompany = LoadCompany;
          vm.changePosition = changePosition;
          vm.changePayroll = changePayroll;
          vm.saveData=saveData;
          vm.Form.objForm.effective_date = new Date();
          vm.Form.objForm.flag_prorate = 0;
           vm.Form.objForm.amount = 0;

          LoadPayroll();
          LoadPosition();
          LoadCompany();
         
           function changePosition(id)
          { 
              // console.log(id);
              vm.listPositiondetail=[];
              var resp=PositionRate.query({action:'getDetailPosition',id:id})
              resp.$promise.then(fetchdetailposition);
              resp.$promise.catch(errorfetchdetailposition);
          }

          function fetchdetailposition(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.positiondesc = data[0].name;
          }

          function errorfetchdetailposition()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.positiondesc = [];
          }


           function changePayroll(id)
          { 
              // console.log(id);
              vm.listPayrolldetail=[];
              var resp=PositionRate.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               vm.Form.objForm.payrolldesc=data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               vm.Form.objForm.payrolldesc=[];
          }

          function LoadPayroll() {
            var response=PositionRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          function LoadPosition() {
            var response=PositionRate.query({action:'getPosition', company:$localStorage.empsite});
            response.$promise.then(fetchPosition);
            response.$promise.catch(errorFetchPosition);
          }

          function fetchPosition(data) {
            vm.listposition=data;
          }

          function errorFetchPosition() {
            vm.listposition=[];
          } 

          function LoadCompany() {
            var response=PositionRate.query({action:'getCompany', company:$localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
            vm.listcompany=data;
          }

          function errorFetchCompany() {
            vm.listcompany=[];
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, PositionRate);
            /*promise.then(function(){
                showDialog(ev);
            });*/
            promise.then(SaveSucces);
            promise.catch(errorSave);
          }

          function SaveSucces(){
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.positionrate')
        .controller('EditpositionrateController', EditpositionrateController);

    EditpositionrateController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditpositionrateController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var PositionRate = AppAPI.PositionRate();

        // set constructor form
        Form.setObject(PositionRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadPosition = LoadPosition;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadCompany = LoadCompany;
        vm.saveData=saveData;

        LoadPayroll();
        LoadPosition();
        LoadCompany();
        
        function LoadPayroll() {
            var response=PositionRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        function LoadPosition() {
            var response=PositionRate.query({action:'getPosition', company:$localStorage.empsite});
            response.$promise.then(fetchPosition);
            response.$promise.catch(errorFetchPosition);
        }

        function fetchPosition(data) {
            vm.listposition=data;
        }

        function errorFetchPosition() {
            vm.listposition=[];
        } 

        function LoadCompany() {
            var response=PositionRate.query({action:'getCompany', company:$localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany=data;
        }

        function errorFetchCompany() {
            vm.listcompany=[];
        } 
          
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);    
            vm.Form.objForm.amount = parseInt(data.amount);
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, PositionRate);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.payrollprocess', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_payrollprocess', {
                url    : '/payroll/payrollprocess',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/payrollprocess/payrollprocess.html',
                    controller : 'PayrollProcessController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.payrollprocess')
        .controller('PayrollProcessController', PayrollProcessController);

    PayrollProcessController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth','$http','config'];

    /* @ngInject */
    function PayrollProcessController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth, $http,config) {
       
       var vm = this;
       var dt = new Date();
       var year = dt.getFullYear()-1;

       Form.initialForm();
      
       var PayrollProcess=AppAPI.PayrollProcess();

       Form.setObject(PayrollProcess);

       vm.Form = Form; 

       vm.changeCompany = changeCompany;
       //vm.LoadPeriod = LoadPeriod;
       
       vm.saveData=saveData;
       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;     

       vm.listperiod = [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

       vm.Form.objForm.period = new Date();
       vm.Form.objForm.area = '';
       vm.Form.objForm.companyid = '';
       vm.Form.objForm.empno = '';
      
       //loadData(1);
       //LoadPeriod();
       LoadCompany();
       LoadArea();

       function LoadCompany() {
            var response=PayrollProcess.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
             // console.log(id);
             vm.listarea=[];
             var resp=PayrollProcess.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadArea(companyid) {
            var response=PayrollProcess.query({action:'getArea', companyid:companyid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 

        function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;

              }
              
           console.log(vm.Form.objForm.empno);
         }

         function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/payrollprocess?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            } 
              return item.data;
          });
         }

       function loadData(pageno) {

          vm.DataTable.loadData(PayrollProcess,pageno,{action:'viewdata'});
       }

       /*function LoadPeriod() {
          var response=PayrollProcess.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       }*/ 


       function saveData(ev,formController) {  
            
            //var response= Form.saveData('save', formController, PayrollProcess);
            var period = vm.Form.objForm.period;
            var company = vm.Form.objForm.companyid;
            
            var promise=Auth.setToken();
            promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to process payroll?')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
            
              $mdDialog.show(confirm).then(function() {
                  angular.element('#attView').block({message:' <span>Loading...</span>'});
                  //var check = Form.saveData('check', data, PayrollProcess);
                  //comment, 09nov2018, requested by Nabati Team
                  /*var check = PayrollProcess.query({action:'check', period: period, company:company });
                  check.$promise.then(statusClosed);
                  check.$promise.catch(function(){
                    var status = PayrollProcess.query({action:'status', period:period, company:company});
                    status.$promise.then(statusPayroll);
                    status.$promise.catch(function(){
                      var response=Form.saveData('save', formController, PayrollProcess);
                      //console.log(response);
                      response.then(fetchPayroll);
                      response.catch(errorFetchPayroll);
                    });
                  });*/

                  var check = PayrollProcess.query({action:'check', period: period, company:company });
                  check.$promise.then(statusClosed);
                  check.$promise.catch(function(){
                    var response=Form.saveData('save', formController, PayrollProcess);
                      //console.log(response);
                      response.then(fetchPayroll);
                      response.catch(errorFetchPayroll);
                  });
              }, function() {
                  angular.element('#attView').unblock();
                  
              });
            });
       }

        function fetchPayroll(data)
        {
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.Form.objForm.companyid = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
        }

        function errorFetchPayroll()
        {
           angular.element('#attView').unblock();
           vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.Form.objForm.companyid = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Payroll Process')
            .textContent('Process Data was Fail.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
           //angular.element.unblockUI();
        } 

        function statusClosed()
        {
           angular.element('#attView').unblock();
           vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.Form.objForm.companyid = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Periode has been Closed, Payroll Can not be Proccesed')
            .textContent('Process Data was Fail.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
           //angular.element.unblockUI();
        }        

        function statusPayroll()
        {
           angular.element('#attView').unblock();
           vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.Form.objForm.companyid = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Sorry, Another user still processing this Payroll.')
            .textContent('Try again in 15 minutes later.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
           //angular.element.unblockUI();
        }  
        function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
       
       function closeModal()
       {
            $mdDialog.hide();
       }

     
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.payrollemployee', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_employee', {
                url    : '/payroll/payrollemployee',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/payrollemployee/payrollemployee.html',
                    controller : 'PayrollEmployeeController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.payrollemployee')
        .controller('UploademployeeController', UploademployeeController);

    UploademployeeController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploademployeeController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        //////////////// 
        
        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/payroll/payrollemployee/uploadfile', 
           removeAfterUpload:true,
           alias:'fileemp',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.payrollemployee')
        .controller('PayrollEmployeeController', PayrollEmployeeController);

    PayrollEmployeeController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth', 'FileUploader', 'config', '$localStorage', '$document', '$http', '$location','$window'];

    function PayrollEmployeeController(AppAPI,DataService,$mdDialog, Form, Auth, FileUploader, config, $localStorage, $document, $http, $location, $window) {

       var vm = this;

       Form.initialForm();

       var PayrollEmployee=AppAPI.PayrollEmployee();

       Form.setObject(PayrollEmployee);

       vm.Form = Form; 

       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputPayrollEmployee= inputPayrollEmployee;
       vm.lisPayrollEmployeeSelected=[];
       vm.DeletePayrollEmployee=DeletePayrollEmployee;
       vm.editPayrollEmployee=editPayrollEmployee;
       vm.openUploadEmployee=openUploadEmployee;
       vm.closeModal=closeModal; 
       vm.UploadPhotoStateSucces=false;
       vm.UploadPhotoStateError=false;
       vm.LoadCompany = LoadCompany;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadArea = LoadArea;
       vm.changeCompany = changeCompany;
       vm.LoadDivisi = LoadDivisi;
       vm.DownloadEmployee = DownloadEmployee;

       vm.Form.objForm.empno='';
       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;
       
       //loadData(1);
       LoadCompany();
       LoadDepartment();
       LoadDivisi();
       LoadArea();

       function loadData(pageno) {

          var nik = '';
          var company = ''; 
          var department = '';
          var area = '';
          var divisi = '';
    
          console.log($localStorage.empsite);
    
          if(typeof(vm.Form.objForm.empno) != 'undefined')
              nik = vm.Form.objForm.empno;
          if(typeof(vm.company) != 'undefined')
            company = vm.company;
          if(typeof($localStorage.empsite) != '')
            company = $localStorage.empsite;
          if(typeof(vm.company) != 'undefined')
            company = vm.company;
          if(typeof(vm.department) != 'undefined')
            department = vm.department;
          if(typeof(vm.area) != 'undefined')
            area = vm.area;
          if(typeof(vm.divisi) != 'undefined')
            divisi = vm.divisi;

          vm.DataTable.loadData(PayrollEmployee,pageno,{action:'viewdata', nik: nik, company:company, department:department, area:area, divisi:divisi});
       }

       function selectedItemChanged(employee)
       {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
       }

       function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/payrollemployee?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
      }

       function LoadCompany() {
            var response=PayrollEmployee.query({action:'getCompany', company:$localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
              console.log(id);
             vm.listarea=[];
             var resp=PayrollEmployee.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadDepartment() {
            var response=PayrollEmployee.query({action:'getDepartment'});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }

       function LoadArea(companyid) {
            var response=PayrollEmployee.query({action:'getArea', companyid:companyid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 

       function LoadDivisi() {
            var response=PayrollEmployee.query({action:'getDivisi'});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       } 

       function inputPayrollEmployee(ev)
      {
          $mdDialog.show({
                controller         : 'InputpayrollemployeeController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/payrollemployee/input-payrollemployee.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editPayrollEmployee(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditpayrollemployeeController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/payrollemployee/input-payrollemployee.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

      function toggleSelectedAll(state)
      { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
      }

      function checkAll() {
             vm.lisPayrollEmployeeSelected=angular.copy(vm.DataTable.list);
      }

      function unCheckAll() {
             vm.lisPayrollEmployeeSelected=[];
      } 


      function openUploadEmployee(ev)
      {
            $mdDialog.show({
                controller         : 'UploademployeeController as vm',
                templateUrl        : 'app/main/payroll/payrollemployee/upload-file.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            });
      }

  
      function DeletePayrollEmployee(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=PayrollEmployee.delete({action:'delete',data:angular.toJson(vm.lisPayrollEmployeeSelected)});

           response.$promise.then(loadData);
           response.$promise.catch(ErrDel);

           loadData(1);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }

      function DownloadEmployee(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;

            if(nik == '') nik = 'undefined';
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/payrollemployee/exportexcel/' + nik  + '/' + company  + '/' + department + '/'+ area + '/' + divisi + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }


      function ErrDel(){
         alert("Sorry, Data can't delete. other transactions using this data");
        
      }

      function closeModal()
      {
          $mdDialog.hide();
      }


    }

 })();
 //
(function() {
    'use strict';

    angular
        .module('app.payroll.payrollemployee')
        .controller('InputpayrollemployeeController', InputpayrollemployeeController);

    InputpayrollemployeeController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config'];

    /* @ngInject */
    function InputpayrollemployeeController($localStorage,$mdDialog,Form,AppAPI,$http,config) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var Payrollemployee= AppAPI.PayrollEmployee();


          // set constructor form
          Form.setObject(Payrollemployee);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          //vm.LoadEmpGroup = LoadEmpGroup;
          //vm.LoadCutoff = LoadCutoff;
          vm.LoadJamsostek = LoadJamsostek;
          vm.LoadTax = LoadTax;
          vm.LoadPTKP = LoadPTKP;
          vm.LoadOT = LoadOT;
          vm.LoadTaxLoc = LoadTaxLoc;
          vm.saveData=saveData;
          vm.Form.objForm.npwpno = '';
          vm.Form.objForm.cutoffcode = '';
          vm.Form.objForm.ptkpcode = '';

          vm.Form.objForm.empno='';
          vm.getEmployee=getEmployee;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;

          /*LoadEmpGroup();
          LoadCutoff();*/
          LoadJamsostek();
          LoadTax();
          LoadPTKP();
          LoadOT();
          LoadTaxLoc();

          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/payrollemployee?action=searchEmployee&id=' + searchText)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          /*function LoadEmpGroup() {
            var response=Payrollemployee.query({action:'getEmpGroup'});
            response.$promise.then(fetchEmpGroup);
            response.$promise.catch(errorFetchEmpGroup);
          }

          function fetchEmpGroup(data) {
            vm.listempgroup=data;
          }

          function errorFetchEmpGroup() {
            vm.listempgroup=[];
          } 

          function LoadCutoff() {
            var response=Payrollemployee.query({action:'getCutOffCode'});
            response.$promise.then(fetchCutOff);
            response.$promise.catch(errorFetchCutOff);
          }

          function fetchCutOff(data) {
            vm.listcutoffcode=data;
          }

          function errorFetchCutOff() {
            vm.listcutoffcode=[];
          } */

          function LoadJamsostek() {
            var response=Payrollemployee.query({action:'getJamsostek'});
            response.$promise.then(fetchJamsostek);
            response.$promise.catch(errorFetchJamsostek);
          }

          function fetchJamsostek(data) {
            vm.listjamsostekcode=data;
          }

          function errorFetchJamsostek() {
            vm.listjamsostekcode=[];
          } 

          function LoadTax() {
            var response=Payrollemployee.query({action:'getTax'});
            response.$promise.then(fetchTax);
            response.$promise.catch(errorFetchTax);
          }

          function fetchTax(data) {
            vm.listtaxcode=data;
          }

          function errorFetchTax() {
            vm.listtaxcode=[];
          } 

          function LoadPTKP() {
            var response=Payrollemployee.query({action:'getPTKP'});
            response.$promise.then(fetchPTKP);
            response.$promise.catch(errorFetchPTKP);
          }

          function fetchPTKP(data) {
            vm.listptkp=data;
          }

          function errorFetchPTKP() {
            vm.listptkp=[];
          } 

          function LoadOT() {
            var response=Payrollemployee.query({action:'getOTCode'});
            response.$promise.then(fetchOTCode);
            response.$promise.catch(errorFetchOTCode);
          }

          function fetchOTCode(data) {
            vm.listot=data;
          }

          function errorFetchOTCode() {
            vm.listot=[];
          }

          function LoadTaxLoc() {
            var response=Payrollemployee.query({action:'getTaxLocation'});
            response.$promise.then(fetchTaxLoc);
            response.$promise.catch(errorFetchTaxLoc);
          }

          function fetchTaxLoc(data) {
            vm.listtaxlocation=data;
          }

          function errorFetchTaxLoc() {
            vm.listtaxlocation=[];
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, Payrollemployee);
            promise.then(function(){
                showDialog(ev);
            });
            promise.catch(errorSave);
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.payrollemployee')
        .controller('EditpayrollemployeeController', EditpayrollemployeeController);

    EditpayrollemployeeController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config', '$http'];

    /* @ngInject */
    function EditpayrollemployeeController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config, $http) {
        var vm = this;
        vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Payrollemployee = AppAPI.PayrollEmployee();

        // set constructor form
        Form.setObject(Payrollemployee);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        //vm.LoadGroup = LoadGroup;
        //vm.LoadCutoff = LoadCutoff;
        vm.LoadJamsostek = LoadJamsostek;
        vm.LoadTax = LoadTax;
        vm.LoadPTKP = LoadPTKP;
        vm.LoadOT = LoadOT;
        vm.LoadTaxLoc = LoadTaxLoc;
        vm.saveData=saveData;
        vm.Form.objForm.npwpno = '';
        vm.Form.objForm.cutoffcode = '';
        vm.Form.objForm.ptkpcode = '';
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;

        //LoadGroup();
        //LoadCutoff();
        LoadJamsostek();
        LoadTax();
        LoadPTKP();
        LoadOT();
        LoadTaxLoc();

        function selectedItemChanged(employee)
        {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
        }

        function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/payrollemployee?action=searchEmployee&id=' + searchText)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
        }

        function LoadGroup() {
           var response=Payrollemployee.query({action:'getEmpGroup'});
           response.$promise.then(fetchGroup);
           response.$promise.catch(errorFetchGroup);
        }

        function fetchGroup(data) {
            vm.listempgroup=data;
        }

        function errorFetchGroup() {
            vm.listempgroup=[];
        } 

        function LoadCutoff() {
           var response=Payrollemployee.query({action:'getCutOffCode'});
           response.$promise.then(fetchCutOff);
           response.$promise.catch(errorFetchCutOff);
        }

        function fetchCutOff(data) {
            vm.listcutoffcode=data;
        }

        function errorFetchCutOff() {
            vm.listcutoffcode=[];
        } 

        function LoadJamsostek() {
            var response=Payrollemployee.query({action:'getJamsostek'});
            response.$promise.then(fetchJamsostek);
            response.$promise.catch(errorFetchJamsostek);
        }

        function fetchJamsostek(data) {
            vm.listjamsostekcode=data;
        }

        function errorFetchJamsostek() {
            vm.listjamsostekcode=[];
        } 

        function LoadTax() {
            var response=Payrollemployee.query({action:'getTax'});
            response.$promise.then(fetchTax);
            response.$promise.catch(errorFetchTax);
        }

        function fetchTax(data) {
            vm.listtaxcode=data;
        }

        function errorFetchTax() {
            vm.listtaxcode=[];
        } 

        function LoadPTKP() {
            var response=Payrollemployee.query({action:'getPTKP'});
            response.$promise.then(fetchPTKP);
            response.$promise.catch(errorFetchPTKP);
        }

        function fetchPTKP(data) {
            vm.listptkp=data;
        }

        function errorFetchPTKP() {
            vm.listptkp=[];
        } 

        function LoadOT() {
            var response=Payrollemployee.query({action:'getOTCode'});
            response.$promise.then(fetchOTCode);
            response.$promise.catch(errorFetchOTCode);
        }

        function fetchOTCode(data) {
            vm.listot=data;
        }

        function errorFetchOTCode() {
            vm.listot=[];
        } 

        function LoadTaxLoc() {
            var response=Payrollemployee.query({action:'getTaxLocation'});
            response.$promise.then(fetchTaxLocation);
            response.$promise.catch(errorFetchTaxLocation);
        }

        function fetchTaxLocation(data) {
            vm.listtaxlocation=data;
        }

        function errorFetchTaxLocation() {
            vm.listtaxlocation=[];
        } 

        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeData);

        function ChangeData(data){
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }
        
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, Payrollemployee);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.otparameter')
        .controller('OtParameterController', OtParameterController);

    OtParameterController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function OtParameterController(AppAPI,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var OtParameter=AppAPI.OtParameter();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputOtParameter= inputOtParameter;
       vm.lisOtParameterSelected=[];
       vm.DeleteOtParameter=DeleteOtParameter;
       vm.editOtParameter=editOtParameter;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(OtParameter,pageno,{action:'viewdata'});
       }

       

       function inputOtParameter(ev)
      {
          $mdDialog.show({
                controller         : 'InputotparameterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/otparameter/input-otparameter.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editOtParameter(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditotparameterController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/otparameter/input-otparameter.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisOtParameterSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisOtParameterSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, OtParameter);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteOtParameter(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=OtParameter.delete({action:'delete',data:angular.toJson(vm.lisOtParameterSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.otparameter')
        .controller('InputotparameterController', InputotparameterController);

    InputotparameterController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputotparameterController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var OtParameter= AppAPI.OtParameter();


          // set constructor form
          Form.setObject(OtParameter);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.Form.objForm.multiple1 = 0;
          vm.Form.objForm.multiple2 = 0;
          vm.Form.objForm.multiple3 = 0;
          vm.Form.objForm.multiple4 = 0;
          vm.LoadPayroll = LoadPayroll;
          vm.LoadAllPayroll = LoadAllPayroll;
          vm.saveData=saveData;
          vm.Form.objForm.formula = 0;

          LoadPayroll();

          LoadAllPayroll();
          
          function LoadPayroll() {
            var response=OtParameter.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          function LoadAllPayroll() {
            var response=OtParameter.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
          }

          function fetchAllPayroll(data) {
            vm.listallpayroll=data;
          }

          function errorFetchAllPayroll() {
            vm.listallpayroll=[];
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, OtParameter);
            /*promise.then(function(){
                showDialog(ev);
            });*/
            promise.then(SaveSucces);
            promise.catch(errorSave);
          }

          function SaveSucces(){
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.otparameter')
        .controller('EditotparameterController', EditotparameterController);

    EditotparameterController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditotparameterController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var OtParameter = AppAPI.OtParameter();

        // set constructor form
        Form.setObject(OtParameter);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.LoadPayroll = LoadPayroll;
        
        LoadPayroll();
          
        function LoadPayroll() {
            var response=OtParameter.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 


        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.multiple1 = parseFloat(data.multiple1);
            vm.Form.objForm.multiple2 = parseFloat(data.multiple2);
            vm.Form.objForm.multiple3 = parseFloat(data.multiple3);
            vm.Form.objForm.multiple4 = parseFloat(data.multiple4);
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, OtParameter);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.nonfixentry', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_nonfixentry', {
                url    : '/payroll/nonfixentry',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/nonfixentry/nonfixentry.html',
                    controller : 'NonFixEntryController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.nonfixentry')
        .controller('UploadNonFixEntryController', UploadNonFixEntryController);

    UploadNonFixEntryController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadNonFixEntryController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        //////////////// 
        
        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/payroll/nonfixentry/uploadfile', 
           removeAfterUpload:true,
           alias:'fileemp',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.nonfixentry')
        .controller('NonFixEntryController', NonFixEntryController);

    NonFixEntryController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth', '$document', '$http','config', '$location', '$window'];

    /* @ngInject */
    function NonFixEntryController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth, $document,$http, config, $location, $window) {
       
       var vm = this;
       
       Form.initialForm();

       var NonFixEntry=AppAPI.NonFixEntry();

       Form.setObject(NonFixEntry);

       vm.Form = Form; 

       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputNonFixEntry= inputNonFixEntry;
       vm.lisNonFixEntrySelected=[];
       vm.DeleteNonFixEntry=DeleteNonFixEntry;
       vm.editNonFixEntry=editNonFixEntry;
       vm.downloadAllowanceNonFix=downloadAllowanceNonFix;
       vm.changeCompany = changeCompany;

       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;
       vm.Form.objForm.empno='';

       vm.LoadCompany = LoadCompany;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;

      //loadData(1);
      LoadCompany();
      LoadDepartment();
      LoadDivisi();
      LoadArea();

       function loadData(pageno) {

          var nik = '';
          var company = '';
          var department = '';
          var area = '';
          var divisi = '';

          if(typeof(vm.Form.objForm.empno) != 'undefined')
              nik = vm.Form.objForm.empno;
          if(typeof(vm.company) != 'undefined')
            company = vm.company;
          if(typeof($localStorage.empsite) != '')
            company = $localStorage.empsite;
          if(typeof(vm.department) != 'undefined')
            department = vm.department;
          if(typeof(vm.area) != 'undefined')
            area = vm.area;
          if(typeof(vm.divisi) != 'undefined')
            divisi = vm.divisi;

          vm.DataTable.loadData(NonFixEntry,pageno,{action:'viewdata', nik:nik, company:company, department:department, area:area,divisi:divisi});
       }

       function selectedItemChanged(employee)
       {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
        }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/nonfixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }
       
       function LoadCompany() {
            var response=NonFixEntry.query({action:'getCompany', company:$localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
            console.log(id);
             vm.listarea=[];
             var resp=NonFixEntry.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadDepartment() {
            var response=NonFixEntry.query({action:'getDepartment'});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }

       function LoadArea(companyid) {
            var response=NonFixEntry.query({action:'getArea', companyid:companyid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 

       function LoadDivisi() {
            var response=NonFixEntry.query({action:'getDivisi'});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       }
       
       function inputNonFixEntry(ev)
      {
          $mdDialog.show({
                controller         : 'InputnonfixentryController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/nonfixentry/input-nonfixentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editNonFixEntry(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditnonfixentryController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/nonfixentry/edit-nonfixentry.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisNonFixEntrySelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisNonFixEntrySelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, NonFixEntry);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteNonFixEntry(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=NonFixEntry.delete({action:'delete',data:angular.toJson(vm.lisNonFixEntrySelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }

      function downloadAllowanceNonFix(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;

            if(nik == '') nik = 'undefined';
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/nonfixentry/exportexcel/' + nik  + '/' + company  + '/' + department + '/'+ area + '/' + divisi + '/' + data.token, '_blank');
                //$window.open(protocol + '://' + host + config.api + 'api/payroll/nonfixentry/exportexcel/' + nik  + '/' + company  + '/' + department + '/'+ area + '/' + divisi + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.nonfixentry')
        .controller('InputnonfixentryController', InputnonfixentryController);

    InputnonfixentryController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$scope'];

    /* @ngInject */
    function InputnonfixentryController($localStorage,$mdDialog,Form,AppAPI,$http,config, $scope) {
          var vm = this;
          var dt = new Date();
          var year = dt.getFullYear();
          vm.saveData=saveData;

          Form.initialForm();

          var NonFixEntry= AppAPI.NonFixEntry();


          // set constructor form
          Form.setObject(NonFixEntry);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.saveData=saveData;
          vm.getEmployee=getEmployee;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

          vm.Form.objForm.empno='';
          vm.Form.objForm.start_date = new Date();
          vm.Form.objForm.end_date = new Date();

          LoadPayroll();
          /*LoadCutOffPeriod();*/
         
          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/nonfixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=NonFixEntry.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=NonFixEntry.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          /*
          function LoadCutOffPeriod() {
            var response=NonFixEntry.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
          }

          function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
          }

          function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
          } 
          */
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, NonFixEntry);
            promise.then(function(){
                showDialog(ev);
            });
            promise.catch(errorSave);
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data')
              .textContent('Save Data was Failed.')
              .ariaLabel('Error Save Data')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

         $scope.isDisabled = true;


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.nonfixentry')
        .controller('EditnonfixentryController', EditnonfixentryController);

    EditnonfixentryController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http'];

    /* @ngInject */
    function EditnonfixentryController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http) {
        var vm = this;
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var NonFixEntry = AppAPI.NonFixEntry();

        // set constructor form
        Form.setObject(NonFixEntry);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;
        vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

        LoadPayroll();
        /*LoadCutOffPeriod();*/
         
        function selectedItemChanged(employee)
        {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
        }

        function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/nonfixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
        }

        function changePayroll(id)
        { 
              var resp=NonFixEntry.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=NonFixEntry.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        /*
        function LoadCutOffPeriod() {
            var response=NonFixEntry.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
        }

        function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
        }

        function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
        } 

        */
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.start_date = new Date(data.start_date); 
            vm.Form.objForm.end_date = new Date(data.end_date); 
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, NonFixEntry);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.laporanprosespayroll', ['app.payroll.laporanprosespayroll.payrolldetails']).config(config);

   //config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_payrollv', {
                url    : '/payroll/laporanprosespayroll',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/laporanprosespayroll/laporanprosespayroll.html',
                    controller : 'LaporanProsesPayrollController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.laporanprosespayroll')
        .controller('LaporanProsesPayrollController', LaporanProsesPayrollController);

    LaporanProsesPayrollController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth','$http','config', '$state'];

    /* @ngInject */
    function LaporanProsesPayrollController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth,$http,config, $state) {
       
       var vm = this;

       Form.initialForm();
       
       var Laporanprosespayroll=AppAPI.LaporanProsesPayroll();

       Form.setObject(Laporanprosespayroll);

       vm.Form = Form;

       vm.DataTable= new DataService();
       vm.listJum=[2,5,25,50,75,100,200];
       vm.lisSalaryComponentSelected=[];
       vm.showData = showData;
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadDepartment = LoadDepartment;
       vm.setView = setView;
       vm.loadData = loadData;
       vm.LoadDivisi = LoadDivisi;
       vm.LoadArea = LoadArea;

       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;
       
       vm.Form.objForm.empno = '';
       
       //loadData(1);
       LoadPeriod();
       LoadDepartment();
       LoadCompany();
       LoadDivisi();
       LoadArea();

       function loadData(pageno) {
          var nik = '';
          var period = '';
          var company = '';
          var department = '';
          var divisi = '';
          var area = '';

          //console.log(typeof(vm.period));
          if(typeof(vm.Form.objForm.empno) != 'undefined')
              nik = vm.Form.objForm.empno;
          if(typeof(vm.period) != 'undefined')
              period = vm.period;
          if(typeof(vm.company) != 'undefined')
              company = vm.company;
          if(typeof($localStorage.empsite) != '')
              company = $localStorage.empsite;
          if(typeof(vm.department) != 'undefined')
              department = vm.department;
          if(typeof(vm.divisi) != 'undefined')
              divisi = vm.divisi;
          if(typeof(vm.area) != 'undefined')
              area = vm.area;

          vm.DataTable.loadData(Laporanprosespayroll,pageno,{action:'viewdata', nik: nik, period: period, company: company, department: department,area:area,divisi:divisi});
       }

        function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

         function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/laporanprosespayroll?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }


       function LoadPeriod() {
          var response=Laporanprosespayroll.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 

       function LoadCompany() {
          var response=Laporanprosespayroll.query({action:'getCompany', company:$localStorage.empsite});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function LoadDepartment() {
          var response=Laporanprosespayroll.query({action:'getDepartment'});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       } 

       function LoadArea(companyid) {
            var response=Laporanprosespayroll.query({action:'getArea', companyid:companyid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 

       function LoadDivisi() {
            var response=Laporanprosespayroll.query({action:'getDivisi'});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       }

        function showData(ev,formController) {
            $mdDialog.show({
            controller         : 'ShowpayrollController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/laporanprosespayroll/show-payroll.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:formController
                }
          });
        }

       

        function closeModal()
        {
            $mdDialog.hide();
        }

        function setView(nik, period) {
            var arrEmp = nik + '#' + period;
            $state.go('app.payroll_details',{id:arrEmp});
        }

     
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.jamsostek', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_jamsostek', {
                url    : '/payroll/jamsostek',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/jamsostek/jamsostek.html',
                    controller : 'JamsostekController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.jamsostek')
        .controller('JamsostekController', JamsostekController);

    JamsostekController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function JamsostekController(AppAPI,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var Jamsostek=AppAPI.Jamsostek();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputJamsostek= inputJamsostek;
       vm.lisJamsostekSelected=[];
       vm.DeleteJamsostek=DeleteJamsostek;
       vm.editJamsostek=editJamsostek;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(Jamsostek,pageno,{action:'viewdata'});
       }

       

       function inputJamsostek(ev)
      {
          $mdDialog.show({
                controller         : 'InputjamsostekController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/jamsostek/input-jamsostek.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editJamsostek(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditjamsostekController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/jamsostek/input-jamsostek.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisJamsostekSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisJamsostekSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, Jamsostek);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteJamsostek(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=Jamsostek.delete({action:'delete',data:angular.toJson(vm.lisJamsostekSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.jamsostek')
        .controller('InputjamsostekController', InputjamsostekController);

    InputjamsostekController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputjamsostekController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var Jamsostek= AppAPI.Jamsostek();


          // set constructor form
          Form.setObject(Jamsostek);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadSalcom = LoadSalcom;
          vm.LoadAllPayroll = LoadAllPayroll;
          vm.Form.objForm.jkkemppct = 0;
          vm.Form.objForm.jkkcomppct = 0;
          vm.Form.objForm.jkmemppct = 0;
          vm.Form.objForm.jkmcomppct = 0;
          vm.Form.objForm.jhtemppct = 0;
          vm.Form.objForm.jhtcomppct = 0;
          vm.Form.objForm.bpjskesemppct = 0;
          vm.Form.objForm.jpemppct = 0;
          vm.Form.objForm.jpcomppct = 0;
          
          //formula
          vm.Form.objForm.ratebpjs = 0;
          
          vm.saveData=saveData;
          
          LoadSalcom();
          LoadAllPayroll();
          
          function LoadSalcom(){
            var response=Jamsostek.query({action:'getSalcom'});
            response.$promise.then(fetchSalcom);
            response.$promise.catch(errorFetchSalcom);
          }

          function fetchSalcom(data) {
            vm.listsalcom=data;
          }

          function errorFetchSalcom() {
            vm.listsalcom=[];
          } 

          function LoadAllPayroll(){
            var response=Jamsostek.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
          }

          function fetchAllPayroll(data) {
            vm.listallpayroll=data;
          }

          function errorFetchAllPayroll() {
            vm.listallpayroll=[];
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, Jamsostek);
            promise.then(function(){
                showDialog(ev);
            });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.jamsostek')
        .controller('EditjamsostekController', EditjamsostekController);

    EditjamsostekController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditjamsostekController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Jamsostek = AppAPI.Jamsostek();

        // set constructor form
        Form.setObject(Jamsostek);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadSalcom = LoadSalcom;
        vm.LoadAllPayroll = LoadAllPayroll;
        vm.saveData=saveData;

        LoadSalcom();
        LoadAllPayroll();

        function LoadSalcom(){
           var response=Jamsostek.query({action:'getSalcom'});
           response.$promise.then(fetchSalcom);
           response.$promise.catch(errorFetchSalcom);
        }

        function fetchSalcom(data) {
           vm.listsalcom=data;
        }

        function errorFetchSalcom() {
           vm.listsalcom=[];
        } 

        function LoadAllPayroll(){
            var response=Jamsostek.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
          }

          function fetchAllPayroll(data) {
            vm.listallpayroll=data;
          }

          function errorFetchAllPayroll() {
            vm.listallpayroll=[];
          }
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});

        res.then(ChangeData);

        function ChangeData(data){
            vm.Form.objForm.jkkemppct = parseFloat(data.jkkemppct);
            vm.Form.objForm.jkkcomppct = parseFloat(data.jkkcomppct);
            vm.Form.objForm.jkmemppct = parseFloat(data.jkmemppct);
            vm.Form.objForm.jkmcomppct = parseFloat(data.jkmcomppct);
            vm.Form.objForm.jhtemppct = parseFloat(data.jhtemppct);
            vm.Form.objForm.jhtcomppct = parseFloat(data.jhtcomppct);
            vm.Form.objForm.bpjskesemppct = parseFloat(data.bpjskesemppct);
            vm.Form.objForm.bpjskescomppct = parseFloat(data.bpjskescomppct);
            vm.Form.objForm.bpjsmaxrate = parseFloat(data.bpjsmaxrate);
            vm.Form.objForm.jpemppct = parseFloat(data.jpemppct);
            vm.Form.objForm.jpcomppct = parseFloat(data.jpcomppct);
            vm.Form.objForm.jpmaxrate = parseFloat(data.jpmaxrate);
        }
        
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, Jamsostek);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.groupentry', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_groupentry', {
                url    : '/payroll/groupentry',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/groupentry/groupentry.html',
                    controller : 'GroupEntryController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.groupentry')
        .controller('InputgroupentryController', InputgroupentryController);

    InputgroupentryController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputgroupentryController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var GroupEntry= AppAPI.GroupEntry();


          // set constructor form
          Form.setObject(GroupEntry);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadPayroll = LoadPayroll;
          vm.LoadGroup = LoadGroup;
          vm.changeGroup = changeGroup;
          vm.changePayroll = changePayroll;      
          vm.saveData=saveData;
          vm.Form.objForm.effective_date = new Date();
          vm.Form.objForm.flag_prorate = 0;
          
          LoadPayroll();
          LoadGroup();

          function changeGroup(id)
          { 
              // console.log(id);
              var resp=GroupEntry.query({action:'getDetailGroup',id:id})
              resp.$promise.then(fetchdetailgroup);
              resp.$promise.catch(errorfetchdetailgroup);
          }

          function fetchdetailgroup(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.groupdesc = data[0].name;
          }

          function errorfetchdetailgroup()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.groupdesc = [];
          }

          function changePayroll(id)
          { 
              // console.log(id);
              var resp=GroupEntry.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=GroupEntry.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayroll=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayroll=[];
          } 

          function LoadGroup() {
            var response=GroupEntry.query({action:'getGroup'});
            response.$promise.then(fetchGroup);
            response.$promise.catch(errorFetchGroup);
          }

          function fetchGroup(data) {
            vm.listgroup=data;
          }

          function errorFetchGroup() {
            vm.listgroup=[];
          } 
          

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, GroupEntry);
            promise.then(function(){
                showDialog(ev);
            });
            promise.catch(errorSave);
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
        }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.groupentry')
        .controller('GroupEntryController', GroupEntryController);

    GroupEntryController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function GroupEntryController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var GroupEntry=AppAPI.GroupEntry();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputGroupEntry= inputGroupEntry;
       vm.lisGroupEntrySelected=[];
       vm.DeleteGroupEntry=DeleteGroupEntry;
       vm.editGroupEntry=editGroupEntry;
       
      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(GroupEntry,pageno,{action:'viewdata'});
       }

       

       function inputGroupEntry(ev)
      {
          $mdDialog.show({
                controller         : 'InputgroupentryController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/groupentry/input-groupentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editGroupEntry(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditgroupentryController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/groupentry/input-groupentry.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisgroupentrySelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisgroupentrySelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, groupentry);
            promise.then(function(){
                showDialog(ev);
            });
        }

        
       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteGroupEntry(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=GroupEntry.delete({action:'delete',data:angular.toJson(vm.lisGroupEntrySelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.groupentry')
        .controller('EditgroupentryController', EditgroupentryController);

    EditgroupentryController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditgroupentryController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var GroupEntry = AppAPI.GroupEntry();

        // set constructor form
        Form.setObject(GroupEntry);

        // set form to controller
        vm.Form = Form;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadGroup = LoadGroup;
        vm.changeGroup = changeGroup;
        vm.changePayroll = changePayroll;  
        vm.saveData=saveData;

        LoadPayroll();
        LoadGroup();

          function changeGroup(id)
          { 
              // console.log(id);
              var resp=GroupEntry.query({action:'getDetailGroup',id:id})
              resp.$promise.then(fetchdetailgroup);
              resp.$promise.catch(errorfetchdetailgroup);
          }

          function fetchdetailgroup(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.groupdesc = data[0].name;
          }

          function errorfetchdetailgroup()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.groupdesc = [];
          }

          function changePayroll(id)
          { 
              // console.log(id);
              var resp=GroupEntry.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=GroupEntry.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayroll=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayroll=[];
          } 

          function LoadGroup() {
            var response=GroupEntry.query({action:'getGroup'});
            response.$promise.then(fetchGroup);
            response.$promise.catch(errorFetchGroup);
          }

          function fetchGroup(data) {
            vm.listgroup=data;
          }

          function errorFetchGroup() {
            vm.listgroup=[];
          } 
          
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);    
            vm.Form.objForm.amount = parseInt(data.amount);  
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, GroupEntry);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.graderate', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_graderate', {
                url    : '/payroll/graderate',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/graderate/graderate.html',
                    controller : 'GradeRateController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.graderate')
        .controller('InputgraderateController', InputgraderateController);

    InputgraderateController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputgraderateController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var GradeRate= AppAPI.GradeRate();


          // set constructor form
          Form.setObject(GradeRate);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadPayroll = LoadPayroll;
          vm.LoadGrade = LoadGrade;
          vm.LoadCompany = LoadCompany;
          vm.changePayroll = changePayroll;
          vm.saveData=saveData;
          vm.Form.objForm.effective_date = new Date();
          vm.Form.objForm.flag_prorate = 0;
          vm.Form.objForm.amount = 0;

          LoadPayroll();
          LoadGrade();
          LoadCompany();

          function changePayroll(id)
          { 
              var resp=GradeRate.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=GradeRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          function LoadCompany() {
            var response=GradeRate.query({action:'getCompany', company:$localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
            vm.listcompany=data;
          }

          function errorFetchCompany() {
            vm.listcompany=[];
          } 

          function LoadGrade() {
            var response=GradeRate.query({action:'getGrade', company:$localStorage.empsite});
            response.$promise.then(fetchGrade);
            response.$promise.catch(errorFetchGrade);
          }

          function fetchGrade(data) {
            vm.listgrade=data;
          }

          function errorFetchGrade() {
            vm.listgrade=[];
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }


          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, GradeRate);
            /*promise.then(function(){
                showDialog(ev);
            });*/
            promise.then(SaveSucces);
            promise.catch(errorSave);
          }

          function SaveSucces(){
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }


          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.graderate')
        .controller('GradeRateController', GradeRateController);

    GradeRateController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function GradeRateController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var GradeRate=AppAPI.GradeRate();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputGradeRate= inputGradeRate;
       vm.lisGradeRateSelected=[];
       vm.DeleteGradeRate=DeleteGradeRate;
       vm.editGradeRate=editGradeRate;
       console.log($localStorage.empsite);
      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(GradeRate,pageno,{action:'viewdata',company:$localStorage.empsite});
       }

       

       function inputGradeRate(ev)
      {
          $mdDialog.show({
                controller         : 'InputgraderateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/graderate/input-graderate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editGradeRate(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditgraderateController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/graderate/input-graderate.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisGradeRateSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisGradeRateSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, GradeRate);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteGradeRate(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=GradeRate.delete({action:'delete',data:angular.toJson(vm.lisGradeRateSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.graderate')
        .controller('EditgraderateController', EditgraderateController);

    EditgraderateController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditgraderateController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var GradeRate = AppAPI.GradeRate();

        // set constructor form
        Form.setObject(GradeRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadPayroll = LoadPayroll;
        vm.LoadGrade = LoadGrade;
        vm.LoadCompany = LoadCompany;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;

        LoadPayroll();
        LoadGrade();
        LoadCompany();
          
        function changePayroll(id)
        { 
             var resp=GradeRate.query({action:'getDetailPayroll',id:id})
             resp.$promise.then(fetchdetailpayroll);
             resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
             //vm.listPositiondetail=data;
             vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
              //vm.listPositiondetail=[];
              vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
           var response=GradeRate.query({action:'getPayrollCode'});
           response.$promise.then(fetchPayrollCode);
           response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        function LoadCompany() {
            var response=GradeRate.query({action:'getCompany', company:$localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany=data;
        }

        function errorFetchCompany() {
            vm.listcompany=[];
        } 

        function LoadGrade() {
           var response=GradeRate.query({action:'getGrade', company:$localStorage.empsite});
           response.$promise.then(fetchGrade);
           response.$promise.catch(errorFetchGrade);
        }

        function fetchGrade(data) {
            vm.listgrade=data;
        }

        function errorFetchGrade() {
           vm.listgrade=[];
        } 


        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);  
            vm.Form.objForm.amount = parseInt(data.amount);  
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, GradeRate);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.fixentry', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_fixentry', {
                url    : '/payroll/fixentry',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/fixentry/fixentry.html',
                    controller : 'FixEntryController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.fixentry')
        .controller('UploadFixEntryController', UploadFixEntryController);

    UploadFixEntryController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadFixEntryController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        //////////////// 
        
        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/payroll/fixentry/uploadfile', 
           removeAfterUpload:true,
           alias:'filesalary',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.fixentry')
        .controller('InputfixentryController', InputfixentryController);

    InputfixentryController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config'];

    /* @ngInject */
    function InputfixentryController($localStorage,$mdDialog,Form,AppAPI,$http,config) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var FixEntry= AppAPI.FixEntry();


          // set constructor form
          Form.setObject(FixEntry);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.getEmployee=getEmployee;
          vm.saveData=saveData;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.Form.objForm.effective_date = new Date();
          vm.Form.objForm.amount = 0;
          vm.Form.objForm.empno='';
          vm.Form.objForm.flag_acting = 0;

          LoadPayroll();
         
          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/fixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=FixEntry.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=FixEntry.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, FixEntry);
            promise.then(function(){
                showDialog(ev);
            });
            promise.catch(errorSave);
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }


          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.fixentry')
        .controller('FixEntryController', FixEntryController);

    FixEntryController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth' , '$document', '$http', 'config', '$location', '$window'];

    /* @ngInject */
    function FixEntryController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth, $document, $http, config, $location, $window) {
       
       var vm = this;
       Form.initialForm();
       var FixEntry=AppAPI.FixEntry();
       Form.setObject(FixEntry);
       vm.Form = Form;
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputFixEntry= inputFixEntry;
       vm.lisFixEntrySelected=[];
       vm.DeleteFixEntry=DeleteFixEntry;
       vm.editFixEntry=editFixEntry;
       vm.downloadInputSalary=downloadInputSalary; 
       vm.LoadCompany = LoadCompany;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadArea = LoadArea;
       vm.changeCompany = changeCompany;
       vm.LoadDivisi = LoadDivisi;

       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;
       
       vm.Form.objForm.empno = '';
      //loadData(1);
       LoadCompany();
       LoadDepartment();
       LoadDivisi();
       LoadArea();

       function LoadCompany() {
            var response=FixEntry.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
              console.log(id);
             vm.listarea=[];
             var resp=FixEntry.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadDepartment(iddivisi) {
            var response=FixEntry.query({action:'getDepartment', idbu: $localStorage.empsite, iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }

       function LoadArea() {
            var response=FixEntry.query({action:'getArea', companyid:$localStorage.empsite});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 

       function LoadDivisi(companyid) {
            var response=FixEntry.query({action:'getDivisi', idbu:companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       }

       function selectedItemChanged(employee)
       {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
       }

       function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/fixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
       }

       
       function loadData(pageno) {

          var nik = '';
          var company = '';
          var department = '';
          var area = '';
          var divisi = '';

          if(typeof(vm.Form.objForm.empno) != 'undefined')
              nik = vm.Form.objForm.empno;
          if(typeof(vm.company) != 'undefined')
            company = vm.company;
          if(typeof($localStorage.empsite) != '')
            company = $localStorage.empsite;
          if(typeof(vm.department) != 'undefined')
            department = vm.department;
          if(typeof(vm.area) != 'undefined')
            area = vm.area;
          if(typeof(vm.divisi) != 'undefined')
            divisi = vm.divisi;
          
          vm.DataTable.loadData(FixEntry,pageno,{action:'viewdata', nik: nik, company : company, department: department, area: area,divisi:divisi});
       }

       function inputFixEntry(ev)
      {
          $mdDialog.show({
                controller         : 'InputfixentryController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/fixentry/input-fixentry.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editFixEntry(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditfixentryController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/fixentry/input-fixentry.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisFixEntrySelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisFixEntrySelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, FixEntry);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteFixEntry(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=FixEntry.delete({action:'delete',data:angular.toJson(vm.lisFixEntrySelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }

      function downloadInputSalary(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;

            if(nik == '') nik = 'undefined';
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/fixentry/exportexcel/' + nik  + '/' + company  + '/' + department + '/'+ area + '/' + divisi + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
      }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.fixentry')
        .controller('EditfixentryController', EditfixentryController);

    EditfixentryController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http'];

    /* @ngInject */
    function EditfixentryController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var FixEntry = AppAPI.FixEntry();

        // set constructor form
        Form.setObject(FixEntry);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;

        LoadPayroll();
       
        function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/fixentry?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

        function changePayroll(id)
        { 
            var resp=FixEntry.query({action:'getDetailPayroll',id:id})
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
            //vm.listPositiondetail=data;
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
            //vm.listPositiondetail=[];
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=FixEntry.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

       
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);    
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, FixEntry);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.employeegroup', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_employeegroup', {
                url    : '/payroll/employeegroup',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/employeegroup/employeegroup.html',
                    controller : 'EmployeeGroupController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.employeegroup')
        .controller('InputemployeegroupController', InputemployeegroupController);

    InputemployeegroupController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputemployeegroupController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var EmployeeGroup= AppAPI.EmployeeGroup();


          // set constructor form
          Form.setObject(EmployeeGroup);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          
          vm.saveData=saveData;
          
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, EmployeeGroup);
            /*promise.then(function(){
                showDialog(ev);
            });*/
            promise.then(SaveSucces);
            promise.catch(errorSave);
          }

          function SaveSucces(){
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.employeegroup')
        .controller('EmployeeGroupController', EmployeeGroupController);

    EmployeeGroupController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function EmployeeGroupController(AppAPI,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var EmployeeGroup=AppAPI.EmployeeGroup();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputEmpGroup= inputEmpGroup;
       vm.lisEmpGroupSelected=[];
       vm.DeleteEmpGroup=DeleteEmpGroup;
       vm.editEmpGroup=editEmpGroup;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(EmployeeGroup,pageno,{action:'viewdata'});
       }

       

       function inputEmpGroup(ev)
      {
          $mdDialog.show({
                controller         : 'InputemployeegroupController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/employeegroup/input-employeegroup.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editEmpGroup(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditemployeegroupController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/employeegroup/input-employeegroup.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisEmployeeGroupSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisEmployeeGroupSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, EmployeeGroup);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteEmpGroup(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=EmployeeGroup.delete({action:'delete',data:angular.toJson(vm.lisEmployeeGroupSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.employeegroup')
        .controller('EditemployeegroupController', EditemployeegroupController);

    EditemployeegroupController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditemployeegroupController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var EmployeeGroup = AppAPI.EmployeeGroup();

        // set constructor form
        Form.setObject(EmployeeGroup);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;

        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, EmployeeGroup);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.deductionfix', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_deductionfix', {
                url    : '/payroll/deductionfix',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/deductionfix/deductionfix.html',
                    controller : 'DeductionFixController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.deductionfix')
        .controller('UploadDeductionNonFixController', UploadDeductionNonFixController);

    UploadDeductionNonFixController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadDeductionNonFixController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        //////////////// 
        
        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/payroll/deductionnonfix/uploadfile', 
           removeAfterUpload:true,
           alias:'fileemp',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.deductionnonfix', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_deductionnonfix', {
                url    : '/payroll/deductionnonfix',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/deductionnonfix/deductionnonfix.html',
                    controller : 'DeductionNonFixController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.deductionnonfix')
        .controller('InputdeductionnonfixController', InputdeductionnonfixController);

    InputdeductionnonfixController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$scope'];

    /* @ngInject */
    function InputdeductionnonfixController($localStorage,$mdDialog,Form,AppAPI,$http,config, $scope) {
          var vm = this;
          var dt = new Date();
          var year = dt.getFullYear();
          vm.saveData=saveData;

          Form.initialForm();

          var DeductionNonFix= AppAPI.DeductionNonFix();


          // set constructor form
          Form.setObject(DeductionNonFix);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.saveData=saveData;
          vm.getEmployee=getEmployee;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

          vm.Form.objForm.empno='';
          vm.Form.objForm.start_date = new Date();
          vm.Form.objForm.end_date = new Date();
          vm.Form.objForm.amount = 0;
          LoadPayroll();
          /*LoadCutOffPeriod();*/
         
          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/deductionnonfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=DeductionNonFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=DeductionNonFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          /*
          function LoadCutOffPeriod() {
            var response=DeductionNonFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
          }

          function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
          }

          function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
          } 
          */
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, DeductionNonFix);
            promise.then(function(){
                showDialog(ev);
            });
            promise.catch(errorSave);
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

         $scope.isDisabled = true;


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.deductionnonfix')
        .controller('EditdeductionnonfixController', EditdeductionnonfixController);

    EditdeductionnonfixController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http'];

    /* @ngInject */
    function EditdeductionnonfixController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http) {
        var vm = this;
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var DeductionNonFix = AppAPI.DeductionNonFix();

        // set constructor form
        Form.setObject(DeductionNonFix);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;
        vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

        LoadPayroll();
        /*LoadCutOffPeriod();*/
         
        function selectedItemChanged(employee)
        {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
        }

        function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/deductionnonfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
        }

        function changePayroll(id)
        { 
              var resp=DeductionNonFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=DeductionNonFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        /*
        function LoadCutOffPeriod() {
            var response=DeductionNonFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
        }

        function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
        }

        function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
        } 

        */
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.start_date = new Date(data.start_date); 
            vm.Form.objForm.end_date = new Date(data.end_date); 
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, DeductionNonFix);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.deductionnonfix')
        .controller('DeductionNonFixController', DeductionNonFixController);

    DeductionNonFixController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window'];

    /* @ngInject */
    function DeductionNonFixController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth, $document, $http, config, $location, $window) {
       
       var vm = this;
       Form.initialForm();
       var DeductionNonFix=AppAPI.DeductionNonFix();
       Form.setObject(DeductionNonFix);

       vm.Form = Form; 
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputDeductionNonFix= inputDeductionNonFix;
       vm.lisDeductionNonFixSelected=[];
       vm.DeleteDeductionNonFix=DeleteDeductionNonFix;
       vm.editDeductionNonFix=editDeductionNonFix;
       vm.downloadDeductionNonFix=downloadDeductionNonFix;
       vm.changeCompany = changeCompany;

       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;
       vm.Form.objForm.empno='';

       vm.LoadCompany = LoadCompany;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;

       //loadData(1);
       LoadCompany();
       LoadDepartment();
       LoadDivisi();
       LoadArea();

       function loadData(pageno) {

          var nik = '';
          var company = '';
          var department = '';
          var area = '';
          var divisi = '';

          if(typeof(vm.Form.objForm.empno) != 'undefined')
              nik = vm.Form.objForm.empno;
          if(typeof(vm.company) != 'undefined')
            company = vm.company;
          if(typeof($localStorage.empsite) != '')
            company = $localStorage.empsite;
          if(typeof(vm.department) != 'undefined')
            department = vm.department;
          if(typeof(vm.area) != 'undefined')
            area = vm.area;
          if(typeof(vm.divisi) != 'undefined')
            divisi = vm.divisi;

          vm.DataTable.loadData(DeductionNonFix,pageno,{action:'viewdata', nik:nik, company:company, department:department, area:area, divisi:divisi});
       }

       function selectedItemChanged(employee)
       {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
        }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/deductionnonfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }
       
       function LoadCompany() {
            var response=DeductionNonFix.query({action:'getCompany',company:$localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
            console.log(id);
             vm.listarea=[];
             var resp=DeductionNonFix.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadDepartment(iddivisi) {
            var response=DeductionNonFix.query({action:'getDepartment', idbu:$localStorage.empsite, iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }

       function LoadArea() {
            var response=DeductionNonFix.query({action:'getArea', companyid:$localStorage.empsite});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 

       function LoadDivisi(companyid) {
            var response=DeductionNonFix.query({action:'getDivisi', idbu:companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       }

       function inputDeductionNonFix(ev)
      {
          $mdDialog.show({
                controller         : 'InputdeductionnonfixController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/deductionnonfix/input-deductionnonfix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editDeductionNonFix(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditdeductionnonfixController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/deductionnonfix/edit-deductionnonfix.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisDeductionNonFixSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisDeductionNonFixSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, DeductionNonFix);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteDeductionNonFix(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=DeductionNonFix.delete({action:'delete',data:angular.toJson(vm.lisDeductionNonFixSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }

      function openUploadEmployee(ev)
      {
            $mdDialog.show({
                controller         : 'UploadDeductionNonFixController as vm',
                templateUrl        : 'app/main/payroll/deductionnonfix/upload-file.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
      }

      function downloadDeductionNonFix(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;

            if(nik == '') nik = 'undefined';
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/deductionnonfix/exportexcel/' + nik  + '/' + company  + '/' + department + '/'+ area + '/' + divisi + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
      }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.deductionfix')
        .controller('UploadDeductionFixController', UploadDeductionFixController);

    UploadDeductionFixController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadDeductionFixController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        //////////////// 
        
        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/payroll/deductionfix/uploadfile', 
           removeAfterUpload:true,
           alias:'fileemp',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.deductionfix')
        .controller('InputdeductionfixController', InputdeductionfixController);

    InputdeductionfixController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$scope'];

    /* @ngInject */
    function InputdeductionfixController($localStorage,$mdDialog,Form,AppAPI,$http,config, $scope) {
          var vm = this;
          var dt = new Date();
          var year = dt.getFullYear();
          vm.saveData=saveData;

          Form.initialForm();

          var DeductionFix= AppAPI.DeductionFix();


          // set constructor form
          Form.setObject(DeductionFix);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.saveData=saveData;
          vm.getEmployee=getEmployee;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

          vm.Form.objForm.empno='';
          vm.Form.objForm.flag_prorate = 0;
          vm.Form.objForm.effective_date = new Date();
          vm.Form.objForm.amount = 0;
          
          LoadPayroll();
          /*LoadCutOffPeriod();*/
         
          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/deductionfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=DeductionFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=DeductionFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          /*
          function LoadCutOffPeriod() {
            var response=DeductionFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
          }

          function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
          }

          function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
          } 
          */
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, DeductionFix);
            promise.then(function(){
                showDialog(ev);
            });
            promise.catch(errorSave);
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

         $scope.isDisabled = true;


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.deductionfix')
        .controller('EditdeductionfixController', EditdeductionfixController);

    EditdeductionfixController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http'];

    /* @ngInject */
    function EditdeductionfixController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http) {
        var vm = this;
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var DeductionFix = AppAPI.DeductionFix();

        // set constructor form
        Form.setObject(DeductionFix);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;
        vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

        LoadPayroll();
        /*LoadCutOffPeriod();*/
         
        function selectedItemChanged(employee)
        {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
        }

        function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/deductionfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
        }

        function changePayroll(id)
        { 
              var resp=DeductionFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=DeductionFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        /*
        function LoadCutOffPeriod() {
            var response=DeductionFix.query({action:'getCutOffPeriod'});
            response.$promise.then(fetchCutOffPeriod);
            response.$promise.catch(errorFetchCutOffPeriod);
        }

        function fetchCutOffPeriod(data) {
            vm.listcutoff=data;
        }

        function errorFetchCutOffPeriod() {
            vm.listcutoff=[];
        } 

        */
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.effective_date = new Date(data.effective_date); 
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, DeductionFix);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.deductionfix')
        .controller('DeductionFixController', DeductionFixController);

    DeductionFixController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window'];

    /* @ngInject */
    function DeductionFixController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth, $document, $http, config,$location, $window) {
       
       var vm = this;
       Form.initialForm();

       var DeductionFix=AppAPI.DeductionFix();
       Form.setObject(DeductionFix);

       vm.Form = Form; 
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputDeductionFix= inputDeductionFix;
       vm.lisDeductionFixSelected=[];
       vm.DeleteDeductionFix=DeleteDeductionFix;
       vm.editDeductionFix=editDeductionFix;
       vm.downloadDeductionFix=downloadDeductionFix;
       vm.changeCompany = changeCompany;

       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;
       vm.Form.objForm.empno='';

       vm.LoadCompany = LoadCompany;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;

       //loadData(1);
       LoadCompany();
       LoadDepartment();
       LoadDivisi();
       LoadArea();

       function loadData(pageno) {

          var nik = '';
          var company = '';
          var department = '';
          var area = '';
          var divisi = '';

          if(typeof(vm.Form.objForm.empno) != 'undefined')
              nik = vm.Form.objForm.empno;
          if(typeof(vm.company) != 'undefined')
            company = vm.company;
          if(typeof($localStorage.empsite) != '')
            company = $localStorage.empsite;
          if(typeof(vm.department) != 'undefined')
            department = vm.department;
          if(typeof(vm.area) != 'undefined')
            area = vm.area;
          if(typeof(vm.divisi) != 'undefined')
            divisi = vm.divisi;
          
          vm.DataTable.loadData(DeductionFix,pageno,{action:'viewdata', nik:nik, company:company, department:department, area:area,divisi:divisi});
       }

       function selectedItemChanged(employee)
       {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
        }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/deductionfix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }
       
       function LoadCompany() {
            var response=DeductionFix.query({action:'getCompany', company:$localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
            console.log(id);
             vm.listarea=[];
             var resp=DeductionFix.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadDepartment(iddivisi) {
            var response=DeductionFix.query({action:'getDepartment', idbu:$localStorage.empsite,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }

       function LoadArea() {
            var response=DeductionFix.query({action:'getArea', companyid:$localStorage.empsite});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 
       
       function LoadDivisi(companyid) {
            var response=DeductionFix.query({action:'getDivisi', idbu: companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       }
       function inputDeductionFix(ev)
      {
          $mdDialog.show({
                controller         : 'InputdeductionfixController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/deductionfix/input-deductionfix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editDeductionFix(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditdeductionfixController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/deductionfix/input-deductionfix.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisDeductionFixSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisDeductionFixSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, DeductionFix);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteDeductionFix(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=DeductionFix.delete({action:'delete',data:angular.toJson(vm.lisDeductionFixSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }

      function openUploadEmployee(ev)
      {
            $mdDialog.show({
                controller         : 'UploadDeductionFixController as vm',
                templateUrl        : 'app/main/payroll/deductionfix/upload-file.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
      }

      function downloadDeductionFix(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;

            if(nik == '') nik = 'undefined';
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/deductionfix/exportexcel/' + nik  + '/' + company  + '/' + department + '/'+ area + '/' + divisi + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
      }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.cutoffparameter', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_cutoffparameter', {
                url    : '/payroll/cutoffparameter',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/cutoffparameter/cutoffperiodh.html',
                    controller : 'CutOffParameterController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.cutoffparameter')
        .controller('InputcutoffparameterController', InputcutoffparameterController);

    InputcutoffparameterController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputcutoffparameterController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var CutOffParameter= AppAPI.CutOffParameter();


          // set constructor form
          Form.setObject(CutOffParameter);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          
          vm.saveData=saveData;
          
          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, CutOffParameter);
            promise.then(function(){
                showDialog(ev);
            });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.cutoffparameter')
        .controller('EditcutoffparameterController', EditcutoffparameterController);

    EditcutoffparameterController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditcutoffparameterController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var CutOffParameter = AppAPI.CutOffParameter();

        // set constructor form
        Form.setObject(CutOffParameter);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
      
        vm.saveData=saveData;

    

        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});

        
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, CutOffParameter);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.cutoffparameter')
        .controller('CutOffParameterController', CutOffParameterController);

    CutOffParameterController.$inject = ['AppAPI','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function CutOffParameterController(AppAPI,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var CutOffParameter=AppAPI.CutOffParameter();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputCutOffParam= inputCutOffParam;
       vm.lisCutOffParamSelected=[];
       vm.DeleteCutOffParam=DeleteCutOffParam;
       vm.editCutOffParam=editCutOffParam;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(CutOffParameter,pageno,{action:'viewdata'});
       }

       

       function inputCutOffParam(ev)
      {
          $mdDialog.show({
                controller         : 'InputcutoffparameterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/cutoffparameter/input-cutoffperiodh.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editCutOffParam(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditcutoffparameterController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/cutoffparameter/input-cutoffperiodh.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisCutOffParamSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisCutOffParamSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, CutOffParameter);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteCutOffParam(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=CutOffParameter.delete({action:'delete',data:angular.toJson(vm.lisCutOffParamSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.closepayroll')
        .controller('InputClosePayrollController', InputClosePayrollController);

    InputClosePayrollController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputClosePayrollController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var ClosePayroll= AppAPI.ClosePayroll();


          // set constructor form
          Form.setObject(ClosePayroll);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.saveData=saveData;
          vm.liststatus = ['OPEN', 'CLOSED'];
          vm.LoadCompany = LoadCompany;
          vm.LoadPeriod = LoadPeriod;

          LoadCompany();
          LoadPeriod();

          function LoadCompany() {
            var response=ClosePayroll.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
            vm.listcompany=data;
          }

          function errorFetchCompany() {
            vm.listcompany=[];
          } 

          function LoadPeriod() {
            var response=ClosePayroll.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
          }

          function fetchPeriod(data) {
            vm.listperiod=data;
          }

          function errorFetchPeriod() {
            vm.listperiod=[];
          } 
                    
          function closeModal()
          {
            $mdDialog.hide();
          }


          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, ClosePayroll);
            promise.then(function(){
                showDialog(ev);
            });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.closepayroll')
        .controller('EditClosePayrollController', EditClosePayrollController);

    EditClosePayrollController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditClosePayrollController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var ClosePayroll = AppAPI.ClosePayroll();

        // set constructor form
        Form.setObject(ClosePayroll);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.liststatus = ['OPEN', 'CLOSED'];
        vm.LoadCompany = LoadCompany;
        vm.LoadPeriod = LoadPeriod;

        LoadCompany();
        LoadPeriod();

        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);  
            vm.Form.objForm.amount = parseInt(data.amount);  
        }
            
        function LoadCompany() {
            var response=ClosePayroll.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany=data;
        }

        function errorFetchCompany() {
            vm.listcompany=[];
        } 

        function LoadPeriod() {
            var response=ClosePayroll.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listperiod=data;
        }

        function errorFetchPeriod() {
            vm.listperiod=[];
        } 

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, ClosePayroll);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.closepayroll')
        .controller('ClosePayrollController', ClosePayrollController);

    ClosePayrollController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function ClosePayrollController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var ClosePayroll=AppAPI.ClosePayroll();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputClosePayroll= inputClosePayroll;
       vm.lisClosePayrollSelected=[];
       vm.DeleteClosePayroll=DeleteClosePayroll;
       vm.editClosePayroll=editClosePayroll;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(ClosePayroll,pageno,{action:'viewdata', company: $localStorage.empsite});
       }

       

       function inputClosePayroll(ev)
      {
          $mdDialog.show({
                controller         : 'InputClosePayrollController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/closepayroll/input-closepayroll.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editClosePayroll(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditClosePayrollController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/closepayroll/input-closepayroll.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisClosePayrollSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisClosePayrollSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, ClosePayroll);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteClosePayroll(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=ClosePayroll.delete({action:'delete',data:angular.toJson(vm.lisClosePayrollSelected)});

           response.$promise.then(loadData);
           response.$promise.catch(ErrDel);

           loadData(1);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }

      function ErrDel(){
         alert("Sorry, Data can't delete. other transactions using this data");
        
      }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.cartransaction', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_cartransaction', {
                url    : '/payroll/cartransaction',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/cartransaction/cartransaction.html',
                    controller : 'CarTransactionController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.cartransaction')
        .controller('UploadcartransactionController', UploadcartransactionController);

    UploadcartransactionController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadcartransactionController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadCarTransactionStateSucces=false;
        vm.UploadCarTransactionStateError=false;

        
        //////////////// 
        
        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/payroll/cartransaction/uploadfile', 
           removeAfterUpload:true,
           alias:'filecartransaction',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadCarTransactionStateSucces=false;
                vm.UploadCarTransactionStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadCarTransactionStateSucces=true;
            vm.UploadCarTransactionStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadCarTransactionStateSucces=false;
             vm.UploadCarTransactionStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.cartransaction')
        .controller('InputcartransactionController', InputcartransactionController);

    InputcartransactionController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config','$scope'];

    /* @ngInject */
    function InputcartransactionController($localStorage,$mdDialog,Form,AppAPI,$http,config,$scope) {
          var vm = this;
          var dt = new Date();
          var year = dt.getFullYear();
          vm.saveData=saveData;

          Form.initialForm();

          var CarTransaction= AppAPI.CarTransaction();


          // set constructor form
          Form.setObject(CarTransaction);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.saveData=saveData;
          vm.LoadCartype = LoadCartype;
          vm.changeCartype = changeCartype;
          vm.getEmployee=getEmployee;
          vm.selectedItemChanged=selectedItemChanged;          
          vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];
          vm.Form.objForm.amount = 0;
          
          LoadCartype();

          function selectedItemChanged(employee) {
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined') {
              vm.Form.objForm.empno=employee.empno;
              vm.Form.objForm.fullname=employee.fullname
              vm.isDisabled=true;
            }
            console.log(vm.Form.objForm.empno);
          }

          function getEmployee(searchText) {
            return $http
            .get(config.api + 'api/payroll/cartransaction?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
            .then(function(item) {
              // Map the response object to the data object.
              if(item.data.length===''){
                Form.objForm.empno='';
              }   
              return item.data;
            });
          }

          function changeCartype(id) { 
            var resp=CarTransaction.query({action:'getDetailCartype',id:id})
            resp.$promise.then(fetchdetailcartype);
            resp.$promise.catch(errorfetchdetailcartype);
          }

          function fetchdetailcartype(data) {
            vm.Form.objForm.cartypedesc = data[0].name;
          }

          function errorfetchdetailcartype() {
            vm.Form.objForm.cartypedesc = [];
          }

          function LoadCartype() {
            var response=CarTransaction.query({action:'getCartype'});
            response.$promise.then(fetchCartype);
            response.$promise.catch(errorFetchCartype);
          }

          function fetchCartype(data) {
            vm.listcartype=data;
          }

          function errorFetchCartype() {
            vm.listcartype=[];
          }

          function closeModal() {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, CarTransaction);
            promise.then(function(){
                showDialog(ev);
            });
            promise.catch(errorSave);
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data')
              .textContent('Save Data was Failed.')
              .ariaLabel('Error Save Data')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.cartransaction')
        .controller('EditcartransactionController', EditcartransactionController);

    EditcartransactionController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http'];

    /* @ngInject */
    function EditcartransactionController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http) {
        var vm = this;
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var CarTransaction = AppAPI.CarTransaction();

        // set constructor form
        Form.setObject(CarTransaction);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;    
        vm.LoadCartype = LoadCartype;
        vm.changeCartype = changeCartype;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;         
        vm.listperiod= [year+'01', year+'02', year+'03', year+'04', year+'05', year+'06', year+'07', year+'08', year+'09', year+'10', year+'11', year+'12'];

        LoadCartype();        
         
        function selectedItemChanged(employee){
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined'){
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;
            }
            console.log(vm.Form.objForm.empno);
        }

        function getEmployee(searchText){
            return $http
            .get(config.api + 'api/payroll/cartransaction?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
            .then(function(item) {
                if(item.data.length===''){
                    Form.objForm.empno='';
                }   
                return item.data;
            });
        }

        function changeCartype(id) { 
           var resp=CarTransaction.query({action:'getDetailCartype',id:id})
           resp.$promise.then(fetchdetailcartype);
           resp.$promise.catch(errorfetchdetailcartype);
        }

          function fetchdetailcartype(data) {
            vm.Form.objForm.cartypedesc = data[0].name;
          }

          function errorfetchdetailcartype() {
            vm.Form.objForm.cartypedesc = [];
          }

          function LoadCartype() {
            var response=CarTransaction.query({action:'getCartype'});
            response.$promise.then(fetchCartype);
            response.$promise.catch(errorFetchCartype);
          }

          function fetchCartype(data) {
            vm.listcartype=data;
          }

          function errorFetchCartype() {
            vm.listcartype=[];
          }

        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        
        res.then(SelectData);

        function SelectData(data){
            vm.Form.objForm.amount = parseInt(data.amount);  
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  
          var promise= Form.saveData('update', formController, CarTransaction);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });
        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.cartransaction')
        .controller('CarTransactionController', CarTransactionController);

    CarTransactionController.$inject = ['$localStorage','AppAPI','DataService','$mdDialog', 'Form', 'Auth', '$document', 'FileUploader','$http','config'];

    /* @ngInject */
    function CarTransactionController($localStorage,AppAPI,DataService,$mdDialog, Form, Auth, $document, FileUploader,$http,config) {
       
       var vm = this;
       Form.initialForm();
       
       var CarTransaction=AppAPI.CarTransaction();
       
       Form.setObject(CarTransaction);

       vm.Form = Form; 

       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputCarTransaction= inputCarTransaction;
       vm.lisCarTransactionSelected=[];
       vm.DeleteCarTransaction=DeleteCarTransaction;
       vm.editCarTransaction=editCarTransaction;
       vm.openUploadCarTransaction=openUploadCarTransaction;
       
       vm.LoadCompany = LoadCompany;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;
       vm.changeCompany = changeCompany;

       vm.getEmployee=getEmployee;
       vm.selectedItemChanged=selectedItemChanged;     

       LoadCompany();
       LoadDepartment();
       LoadDivisi();
       LoadArea();
       //loadData(1);

       function loadData(pageno) {

          var nik = '';
          var company = '';
          var department = '';
          var area = '';
          var divisi = '';

          if(typeof(vm.Form.objForm.empno) != 'undefined')
              nik = vm.Form.objForm.empno;
          if(typeof(vm.company) != 'undefined')
            company = vm.company;
          if(typeof($localStorage.empsite) != '')
            company = $localStorage.empsite;
          if(typeof(vm.department) != 'undefined')
            department = vm.department;
          if(typeof(vm.area) != 'undefined')
            area = vm.area;
          if(typeof(vm.divisi) != 'undefined')
            divisi = vm.divisi;

          vm.DataTable.loadData(CarTransaction,pageno,{action:'viewdata',nik:nik, company:company, department:department, area:area,divisi:divisi});
       }

       function selectedItemChanged(employee) {
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined') {
              vm.Form.objForm.empno=employee.empno;
              vm.Form.objForm.fullname=employee.fullname
              vm.isDisabled=true;
            }
            console.log(vm.Form.objForm.empno);
        }

        function getEmployee(searchText) {
            return $http
            .get(config.api + 'api/payroll/cartransaction?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
            .then(function(item) {
              // Map the response object to the data object.
              if(item.data.length===''){
                Form.objForm.empno='';
              }   
              return item.data;
            });
        }

        function LoadCompany() {
            var response=CarTransaction.query({action:'getCompany', company:$localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
            console.log(id);
             vm.listarea=[];
             var resp=CarTransaction.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }
       
       function LoadDepartment(iddivisi) {
            var response=CarTransaction.query({action:'getDepartment', idbu: vm.company, iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }

       function LoadArea() {
            var response=CarTransaction.query({action:'getArea', companyid: $localStorage.empsite});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 
       
       function LoadDivisi(companyid) {
            var response=CarTransaction.query({action:'getDivisi', idbu: companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       }

       function openUploadCarTransaction(ev)
       {
            $mdDialog.show({
                controller         : 'UploadcartransactionController as vm',
                templateUrl        : 'app/main/payroll/cartransaction/upload-file.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            });
       }


       function inputCarTransaction(ev)
      {
          $mdDialog.show({
                controller         : 'InputcartransactionController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/cartransaction/input-cartransaction.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editCarTransaction(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditcartransactionController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/cartransaction/input-cartransaction.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisCarTransactionSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisCarTransactionSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, CarTransaction);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteCarTransaction(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=CarTransaction.delete({action:'delete',data:angular.toJson(vm.lisCarTransactionSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.carrate')
        .controller('InputcarrateController', InputcarrateController);

    InputcarrateController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputcarrateController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var CarRate= AppAPI.CarRate();


          // set constructor form
          Form.setObject(CarRate);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.saveData=saveData;
          vm.Form.objForm.effective_date = new Date
          vm.Form.objForm.flag_prorate = 0;   
          vm.LoadCompany = LoadCompany;
          vm.Form.objForm.amount = 0;
          
          LoadCompany();

          function LoadCompany() {
            var response=CarRate.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
            vm.listcompany=data;
          }

          function errorFetchCompany() {
            vm.listcompany=[];
          } 
                    
          function closeModal()
          {
            $mdDialog.hide();
          }


          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, CarRate);
            promise.then(function(){
                showDialog(ev);
            });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.carrate')
        .controller('EditcarrateController', EditcarrateController);

    EditcarrateController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditcarrateController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var CarRate = AppAPI.CarRate();

        // set constructor form
        Form.setObject(CarRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.saveData=saveData;
        vm.LoadCompany = LoadCompany;

        LoadCompany();
        
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);  
            vm.Form.objForm.amount = parseInt(data.amount);  
        }
            
        function LoadCompany() {
            var response=CarRate.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany=data;
        }

        function errorFetchCompany() {
            vm.listcompany=[];
        } 

        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, CarRate);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.carrate')
        .controller('CarRateController', CarRateController);

    CarRateController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function CarRateController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var CarRate=AppAPI.CarRate();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputCarRate= inputCarRate;
       vm.lisCarRateSelected=[];
       vm.DeleteCarRate=DeleteCarRate;
       vm.editCarRate=editCarRate;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(CarRate,pageno,{action:'viewdata', company: $localStorage.empsite});
       }

       

       function inputCarRate(ev)
      {
          $mdDialog.show({
                controller         : 'InputcarrateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/carrate/input-carrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editCarRate(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditcarrateController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/carrate/input-carrate.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisCarRateSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisCarRateSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, CarRate);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteCarRate(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=CarRate.delete({action:'delete',data:angular.toJson(vm.lisCarRateSelected)});

           response.$promise.then(loadData);
           response.$promise.catch(ErrDel);

           loadData(1);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }

      function ErrDel(){
         alert("Sorry, Data can't delete. other transactions using this data");
        
      }
    }
})();
(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.payroll.attendance_sync', []).config(config);

  config.$inject = ['$stateProvider'];


  function config($stateProvider) {

    $stateProvider
      .state('app.payroll_attendance_sync', {
        url: '/payroll/attendance_sync',
        views: {
          'content@app': {
            templateUrl: 'app/main/payroll/attendance-sync/attendance-sync.html',
            controller: 'SyncAttendanceSyncController as vm'
          }
        }

      });

    // Translation
    //$translatePartialLoaderProvider.addPart('app');
  }
}());
(function () {
    'use strict';

    angular
        .module('app.payroll.attendance_sync')
        .controller('SyncAttendanceSyncController', SyncAttendanceSyncController);

    SyncAttendanceSyncController.$inject = ['$q', 'AppAPI', '$http', 'config', '$interval', '$timeout', '$location', '$anchorScroll', '$log', '$element', '$mdToast'];

    /* @ngInject */
    function SyncAttendanceSyncController($q, AppAPI, $http, config, $interval, $timeout, $location, $anchorScroll, $log, $element, $mdToast) {

        var vm = this;
        var SyncPma = new AppAPI.SyncPma();
        vm.doSync = doSync;
        vm.determinateValue = 0;
        vm.showResult = showResult;
        vm.syncAll = syncAll;
        vm.employeeLists = [];
        vm.selectedSubArea = '';
        vm.searchText = '';
        vm.addEmployeeBySubArea = addEmployeeBySubArea;
        vm.isLoading = false;
        vm.syncData = syncData;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.selected = [];
        vm.payrollPeriod = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        vm.payrollYears = [2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];

        vm.determinateValue = 0;
        vm.interval = 100;

        loadSubArea();
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function loadSubArea() {
            var response = SyncPma.query({
                action: 'getSubArea'
            });
            response.$promise.then(function (data) {
                vm.sub_areaLists = data;
            });
            response.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function loadEmployeeBySubArea(sub_area_id) {
            var defer = $q.defer();
            var response = SyncPma.query({
                action: 'getEmployeeSubArea',
                sub_area_id: sub_area_id
            });
            response.$promise.then(function (data) {

                data.find(function (row) {
                    row.checked = true;
                });

                vm.employeeLists = data;

                defer.resolve(data);

            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject();
            });
            return defer.promise;
        }

        function addEmployeeBySubArea(SelectedSubArea) {
            loadEmployeeBySubArea(SelectedSubArea.id).then(function () {
                toggleAll();
                vm.toggle_all = true;
            });
        }

        function syncData(ev) {
            ev.preventDefault();
            var defer = $q.defer();
            var empNikList = '';
            vm.isLoading = true;

            vm.selected.find(function (emp) {
                empNikList += emp.nik + ',';
            });
            empNikList = empNikList.slice(0, -1);

            if (empNikList === '' && vm.employeeLists.length > 0) {
                return false;
            }

            $interval(function () {
                vm.determinateValue += 1;
                if (vm.determinateValue > 100) vm.determinateValue = 10;
            }, vm.interval, 0, true);

            var area = vm.selectedSubArea.id + '|' + vm.selectedSubArea.description;
            var response = SyncPma.get({
                action: 'synchronize_attendance',
                niks: empNikList,
                payroll_period: vm.payroll_period,
                payroll_year: vm.payroll_year,
                area: area
            });
            response.$promise.then(function (data) {
                console.log('synchronize', data);

                vm.interval = 50;
                $timeout(function () {
                    vm.isLoading = false;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Syncrhonizing to PMA is successfully')
                            .position('top right')
                            .hideDelay(10000)
                            .theme("success-toast")
                    );

                }, 1000);

                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);

                vm.interval = 50;
                $timeout(function () {
                    vm.isLoading = false;
                }, 1000);

                defer.reject();
            });
            return defer.promise;
        }

        function doSync(ev, item) {
            ev.preventDefault();
            var defer = $q.defer();

            item.isLoading = true;
            item.showResult = false;
            item.showBtnResult = false;
            item.result = '';
            item.interval = 200;
            item.determinateValue = 0;

            $interval(function () {
                item.determinateValue += 1;
                if (item.determinateValue > 100) item.determinateValue = 10;
            }, item.interval, 0, true);

            $http.get(config.api + 'api/syncpma/synchronize?table=' + item.table).then(function (res) {
                if (res.status === 200) {
                    item.color = 'green';
                } else {
                    item.color = 'red';
                }

                item.interval = 50;
                $timeout(function () {
                    item.isLoading = false;
                    item.result = res.data;
                    item.showBtnResult = true;
                    defer.resolve();
                }, 1000);

            }).catch(function (err) {
                item.color = 'red';
                item.result = err.data;
                item.isLoading = false;
                item.showBtnResult = true;
                defer.reject();
            });
            defer.promise;
        }

        function showResult(ev, item) {
            ev.preventDefault();
            if (item.showResult) {
                item.showResult = false
            } else {
                item.showResult = true;
                $timeout(function () {
                    $location.hash(item.table);
                    $anchorScroll();
                }, 200)
            }
        }

        function syncAll(ev) {
            ev.preventDefault();
            var idx = 0;
            vm.tableNameLists.map(function (val) {
                if (idx === 0) {
                    doSync(ev, val);
                } else {
                    $timeout(function () {
                        doSync(ev, val);
                    }, 150 * idx);
                }
                idx++;
            });
        }

        function progressLoading(item) {
            var defer = $q.defer();
            console.log('item', item.isLoading);
            if (item.isLoading) {
                $timeout(function () {
                    item.determinateValue += 1;
                    if (item.determinateValue > 100) {
                        // item.determinateValue = 10;

                        progressLoading(item);
                        defer.resolve();
                    }
                }, 200, 0, true);
            } else {
                defer.reject();
            }
            defer.promise;
        }

        function toggle(ev, item) {
            var idx = vm.selected.indexOf(item);
            if (idx > -1) {
                vm.selected.splice(idx, 1);
                item.checked = false;
            } else {
                vm.selected.push(item);
                item.checked = true;
            }
            console.log('item', item);
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return vm.selected.length !== 0 && vm.selected.length !== vm.employeeLists.length;
        }

        function isChecked(item) {
            // console.log('item', item);
            // return vm.selected.length === vm.employeeLists.length;
            return vm.selected.indexOf(item) > -1;
        }

        function toggleAll() {
            if (vm.selected.length === vm.employeeLists.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.employeeLists.slice(0);
            }
        }

    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.allowancefix', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_allowancefix', {
                url    : '/payroll/allowancefix',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/allowancefix/allowancefix.html',
                    controller : 'AllowanceFixController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
    'use strict';

    angular
        .module('app.payroll.allowancefix')
        .controller('UploadAllowanceFixController', UploadAllowanceFixController);

    UploadAllowanceFixController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadAllowanceFixController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        //////////////// 
        
        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/payroll/allowancefix/uploadfile', 
           removeAfterUpload:true,
           alias:'fileemp',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.allowancefix')
        .controller('InputallowancefixController', InputallowancefixController);

    InputallowancefixController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$http','config'];

    /* @ngInject */
    function InputallowancefixController($localStorage,$mdDialog,Form,AppAPI,$http,config) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var AllowanceFix= AppAPI.AllowanceFix();


          // set constructor form
          Form.setObject(AllowanceFix);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.LoadPayroll = LoadPayroll;
          vm.changePayroll = changePayroll;
          vm.getEmployee=getEmployee;
          vm.saveData=saveData;
          vm.stateEdit=false;
          vm.selectedItemChanged=selectedItemChanged;
          vm.Form.objForm.effective_date = new Date();
          
          vm.Form.objForm.empno='';
          vm.Form.objForm.flag_prorate = 0;
          vm.Form.objForm.amount = 0;
          
          LoadPayroll();
         
          function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/allowancefix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

          function changePayroll(id)
          { 
              var resp=AllowanceFix.query({action:'getDetailPayroll',id:id})
              resp.$promise.then(fetchdetailpayroll);
              resp.$promise.catch(errorfetchdetailpayroll);
          }

          function fetchdetailpayroll(data)
          {
               //vm.listPositiondetail=data;
               vm.Form.objForm.payrolldesc = data[0].name;
          }

          function errorfetchdetailpayroll()
          {
               //vm.listPositiondetail=[];
               vm.Form.objForm.payrolldesc = [];
          }

          function LoadPayroll() {
            var response=AllowanceFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, AllowanceFix);
            promise.then(function(){
                showDialog(ev);
            });
            promise.catch(errorSave);
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.allowancefix')
        .controller('EditallowancefixController', EditallowancefixController);

    EditallowancefixController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$http'];

    /* @ngInject */
    function EditallowancefixController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$http) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var AllowanceFix = AppAPI.AllowanceFix();

        // set constructor form
        Form.setObject(AllowanceFix);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadPayroll = LoadPayroll;
        vm.changePayroll = changePayroll;
        vm.saveData=saveData;
        vm.getEmployee=getEmployee;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;

        LoadPayroll();
       
        function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
         }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/allowancefix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }

        function changePayroll(id)
        { 
            var resp=AllowanceFix.query({action:'getDetailPayroll',id:id})
            resp.$promise.then(fetchdetailpayroll);
            resp.$promise.catch(errorfetchdetailpayroll);
        }

        function fetchdetailpayroll(data)
        {
            //vm.listPositiondetail=data;
            vm.Form.objForm.payrolldesc = data[0].name;
        }

        function errorfetchdetailpayroll()
        {
            //vm.listPositiondetail=[];
            vm.Form.objForm.payrolldesc = [];
        }

        function LoadPayroll() {
            var response=AllowanceFix.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

       
        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);    
            vm.Form.objForm.amount = parseInt(data.amount);  
            vm.Form.objForm.fullname = data.empno + ' - ' + data.first_name + ' ' + data.middle_name + ' ' + data.last_name ;
        }
            
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  

          var promise= Form.saveData('update', formController, AllowanceFix);
            promise.then(function(data){
                showDialog(ev,data);
                 
            });
          promise.catch(function(data){
               ShowFailed(ev,data)  
               
            });


        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.allowancefix')
        .controller('AllowanceFixController', AllowanceFixController);

    AllowanceFixController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window'];

    /* @ngInject */
    function AllowanceFixController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth, $document, $http, config, $location, $window) {
       
       var vm = this;
      
       Form.initialForm();

       var AllowanceFix=AppAPI.AllowanceFix();

       Form.setObject(AllowanceFix);

       vm.Form = Form; 

       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputAllowanceFix= inputAllowanceFix;
       vm.lisAllowanceFixSelected=[];
       vm.DeleteAllowanceFix=DeleteAllowanceFix;
       vm.editAllowanceFix=editAllowanceFix;
       vm.downloadInputSalary=downloadInputSalary; 
       vm.changeCompany = changeCompany;

       vm.getEmployee=getEmployee;
       vm.stateEdit=false;
       vm.selectedItemChanged=selectedItemChanged;
       vm.Form.objForm.empno='';

       vm.LoadCompany = LoadCompany;
       vm.LoadDepartment = LoadDepartment;
       vm.LoadArea = LoadArea;
       vm.LoadDivisi = LoadDivisi;

       //loadData(1);
       LoadCompany();
       LoadDepartment();
       LoadDivisi();
       LoadArea();

       function loadData(pageno) {

          var nik = '';
          var company = '';
          var department = '';
          var area = '';
          var divisi = '';

          if(typeof(vm.Form.objForm.empno) != 'undefined')
              nik = vm.Form.objForm.empno;
          if(typeof(vm.company) != 'undefined')
            company = vm.company;
          if(typeof($localStorage.empsite) != '')
            company = $localStorage.empsite;
          if(typeof(vm.department) != 'undefined')
            department = vm.department;
          if(typeof(vm.area) != 'undefined')
            area = vm.area;
          if(typeof(vm.divisi) != 'undefined')
            divisi = vm.divisi;

          vm.DataTable.loadData(AllowanceFix,pageno,{action:'viewdata', nik:nik, company:company, department:department, area:area,divisi:divisi});
       }

       function selectedItemChanged(employee)
       {
               
              vm.Form.objForm.empno='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;

              }
         
           console.log(vm.Form.objForm.empno);
        }

          function getEmployee(searchText){

           return $http
          .get(config.api + 'api/payroll/allowancefix?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.empno='';
            }   
              return item.data;
          });
         }
       
       function LoadCompany() {
            var response=AllowanceFix.query({action:'getCompany', company:$localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function changeCompany(id)
       { 
            console.log(id);
             vm.listarea=[];
             var resp=AllowanceFix.query({action:'getSpecificArea',companyid:id})
             resp.$promise.then(fetchspecificarea);
             resp.$promise.catch(errorfetchspecificarea);
       }

       function fetchspecificarea(data)
       {
             vm.listarea=data;
       }

       function errorfetchspecificarea()
       {
             vm.listarea=[];
       }

       function LoadDepartment(iddivisi) {
            var response=AllowanceFix.query({action:'getDepartment', idbu:vm.company, iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
       }

       function fetchDepartment(data) {
            vm.listdepartment=data;
       }

       function errorFetchDepartment() {
            vm.listdepartment=[];
       }

       function LoadArea() {
            //console.log(companyid);
            var response=AllowanceFix.query({action:'getArea', companyid:$localStorage.empsite});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 
       
       function LoadDivisi(companyid) {
            var response=AllowanceFix.query({action:'getDivisi', idbu:companyid});
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
       }

       function fetchDivisi(data) {
            vm.listdivisi=data;
       }

       function errorFetchDivisi() {
            vm.listdivisi=[];
       }
       
       function inputAllowanceFix(ev)
      {
          $mdDialog.show({
                controller         : 'InputallowancefixController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/allowancefix/input-allowancefix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editAllowanceFix(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditallowancefixController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/allowancefix/input-allowancefix.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
              vm.lisAllowanceFixSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisAllowanceFixSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, AllowanceFix);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteAllowanceFix(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=AllowanceFix.delete({action:'delete',data:angular.toJson(vm.lisAllowanceFixSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }

      function downloadInputSalary(companyid, divisiid, departmentid, areaid, idemployee) {
            var token = Auth.setTokenPromise();
            var nik = idemployee;
            var company = companyid;
            var department = departmentid;
            var area = areaid;
            var divisi = divisiid;

            if(nik == '') nik = 'undefined';
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payroll/allowancefix/exportexcel/' + nik  + '/' + company  + '/' + department + '/'+ area + '/' + divisi + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.absentrate')
        .controller('ViewsalarycomponentController', ViewsalarycomponentController);

    ViewsalarycomponentController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function ViewsalarycomponentController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;

          Form.initialForm();

          var AbsentRate= AppAPI.AbsentRate();


          // set constructor form
          Form.setObject(AbsentRate);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.viewSalcom= viewSalcom;
          vm.LoadPayroll = LoadPayroll;
          vm.saveData=saveData;
          //vm.exists = exists; 
          //vm.toggle = toggle; 

          LoadPayroll();
        
          /*function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
              list.splice(idx, 1);
            }
            else {
              list.push(item);
            }
          }

          function exists(item, list){
             return list.indexOf(item) > -1;
          }*/
          
          function LoadPayroll() {
            var response=AbsentRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          function closeModal(ev)
          {
            $mdDialog.hide();

            $mdDialog.show({
                controller         : 'InputabsentrateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/absentrate/input-absentrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
          }

          function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, AbsentRate);
            promise.then(function(){
                showDialog(ev);
            });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal(ev);
            });
        }

        function viewSalcom(ev)
      {
          $mdDialog.show({
                controller         : 'ViewSalaryComponentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/absentrate/view-salarycomponent.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: false,    
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.absentrate')
        .controller('InputabsentrateController', InputabsentrateController);

    InputabsentrateController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputabsentrateController($localStorage,$mdDialog,Form,AppAPI) {
          var vm = this;
          vm.saveData=saveData;
          

          Form.initialForm();

          var AbsentRate= AppAPI.AbsentRate();


          // set constructor form
          Form.setObject(AbsentRate);

          // set form to controller
          vm.Form = Form; 
          vm.closeModal = closeModal; 
          vm.viewSalcom= viewSalcom;
          vm.LoadAttendance = LoadAttendance;
          vm.LoadPosition = LoadPosition;
          vm.LoadPayroll = LoadPayroll;
          vm.LoadCompany = LoadCompany;
          vm.saveData=saveData;

          vm.Form.objForm.effective_date = new Date();
          vm.Form.objForm.flag_prorate = 0;
          
          //formula
          vm.Form.objForm.formula = 0;

          LoadPayroll();
          LoadAllPayroll();
          LoadPosition();
          LoadAttendance();
          LoadCompany();

          function LoadPayroll() {
            var response=AbsentRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
          }

          function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
          }

          function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
          } 

          function LoadAllPayroll() {
            var response=AbsentRate.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
          }

          function fetchAllPayroll(data) {
            vm.listallpayroll=data;
          }

          function errorFetchAllPayroll() {
            vm.listallpayroll=[];
          } 

          function LoadPosition() {
            var response=AbsentRate.query({action:'getPosition', company: $localStorage.empsite});
            response.$promise.then(fetchPosition);
            response.$promise.catch(errorFetchPosition);
          }

          function fetchPosition(data) {
            vm.listposition=data;
          }

          function errorFetchPosition() {
            vm.listposition=[];
          } 


          function LoadAttendance() {
            var response=AbsentRate.query({action:'getAttendanceCode'});
            response.$promise.then(fetchAttendance);
            response.$promise.catch(errorFetchAttendance);
          }

          function fetchAttendance(data) {
            vm.listattendancecode=data;
          }

          function errorFetchAttendance() {
            vm.listattendancecode=[];
          }

          function LoadCompany() {
            var response=AbsentRate.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
          }

          function fetchCompany(data) {
            vm.listcompany=data;
          }

          function errorFetchCompany() {
            vm.listcompany=[];
          } 

          function closeModal()
          {
            $mdDialog.hide();
          }

          function saveData(ev,formController) {  

            /*var effective_date = vm.Form.objForm.effective_date;
            var company = vm.Form.objForm.companyname;
            var code = vm.Form.objForm.code;
            var payrollcode = vm.Form.objForm.payrollcode;
            var position = vm.Form.objForm.position;

            var response=AbsentRate.query({action:'check', effective_date:effective_date, company:company, code: code, payrollcode:payrollcode, position:position});
            response.$promise.then(errorSave);
            response.$promise.catch(function(){
                */var promise= Form.saveData('save', formController, AbsentRate);
                promise.then(SaveSucces);
                promise.catch(errorSaveData);
            //});
          }

          function SaveSucces(){
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                closeModal();
            });
          }

          function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function errorSaveData(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }

          function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function viewSalcom(ev)
        {
          $mdDialog.show({
                controller         : 'ViewsalarycomponentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/absentrate/view-salarycomponent.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
        }

      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.absentrate')
        .controller('EditabsentrateController', EditabsentrateController);

    EditabsentrateController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function EditabsentrateController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this;
        vm.saveData=saveData;
        
        // initial form
        Form.initialForm();

        var AbsentRate = AppAPI.AbsentRate();

        // set constructor form
        Form.setObject(AbsentRate);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.LoadAttendance = LoadAttendance;
        vm.LoadPosition = LoadPosition;
        vm.LoadPayroll = LoadPayroll;
        vm.LoadCompany = LoadCompany;
        vm.saveData=saveData;
        
        
        LoadPayroll();
        LoadAllPayroll();
        LoadPosition();
        LoadAttendance();
        LoadCompany();

        function LoadPayroll() {
            var response=AbsentRate.query({action:'getPayrollCode'});
            response.$promise.then(fetchPayrollCode);
            response.$promise.catch(errorFetchPayrollCode);
        }

        function fetchPayrollCode(data) {
            vm.listpayrollcode=data;
        }

        function errorFetchPayrollCode() {
            vm.listpayrollcode=[];
        } 

        function LoadAllPayroll() {
            var response=AbsentRate.query({action:'getAllPayroll'});
            response.$promise.then(fetchAllPayroll);
            response.$promise.catch(errorFetchAllPayroll);
          }

          function fetchAllPayroll(data) {
            vm.listallpayroll=data;
          }

          function errorFetchAllPayroll() {
            vm.listallpayroll=[];
          } 

        function LoadPosition() {
            var response=AbsentRate.query({action:'getPosition', company: $localStorage.empsite});
            response.$promise.then(fetchPosition);
            response.$promise.catch(errorFetchPosition);
        }

        function fetchPosition(data) {
            vm.listposition=data;
        }

        function errorFetchPosition() {
            vm.listposition=[];
        } 


        function LoadAttendance() {
            var response=AbsentRate.query({action:'getAttendanceCode'});
            response.$promise.then(fetchAttendance);
            response.$promise.catch(errorFetchAttendance);
        }

        function fetchAttendance(data) {
            vm.listattendancecode=data;
        }

        function errorFetchAttendance() {
            vm.listattendancecode=[];
        } 
          
        function LoadCompany() {
            var response=AbsentRate.query({action:'getCompany', company: $localStorage.empsite});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany=data;
        }

        function errorFetchCompany() {
            vm.listcompany=[];
        } 

        console.log(id);
        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;   
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewdetail',id:id});
        res.then(ChangeDate);

        function ChangeDate(data){
            vm.Form.objForm.effective_date = new Date(data.effective_date);    

        }
        
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  
            /*var effective_date = vm.Form.objForm.effective_date;
            var company = vm.Form.objForm.companyname;
            var code = vm.Form.objForm.code;
            var payrollcode = vm.Form.objForm.payrollcode;
            var position = vm.Form.objForm.position;

            var response=AbsentRate.query({action:'check', effective_date:effective_date, company:company, code: code, payrollcode:payrollcode, position:position});
            response.$promise.then(errorSave);
            response.$promise.catch(function(){

              */var promise= Form.saveData('update', formController, AbsentRate);
                promise.then(function(data){
                    showDialog(ev,data);
                     
                });
              promise.catch(function(data){
                   ShowFailed(ev,data)  
                   
                });
            //});
        }

        function showDialog(ev,data) {
          // console.log(ev);
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       
        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          // console.log(data.data.pesan);
        }

        function errorSave(){
              $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title('Error Save Data, Data already exist')
              .textContent('Save Data was Failed.')
              .ariaLabel('Data already exist')
              .ok('OK')
              ).then(function(){
                  closeModal();
              });
          }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.payroll.absentrate')
        .controller('AbsentRateController', AbsentRateController);

    AbsentRateController.$inject = ['AppAPI','$localStorage','DataService','$mdDialog', 'Form', 'Auth'];

    /* @ngInject */
    function AbsentRateController(AppAPI,$localStorage,DataService,$mdDialog, Form, Auth) {
       
       var vm = this;
       var AbsentRate=AppAPI.AbsentRate();
       vm.DataTable= new DataService();
       vm.loadData=loadData;
       vm.toggleSelectedAll=toggleSelectedAll; 
       vm.listJum=[2,5,25,50,75,100,200];
       vm.inputAbsentRate= inputAbsentRate;
       vm.lisAbsentRateSelected=[];
       vm.DeleteAbsentRate=DeleteAbsentRate;
       vm.editAbsentRate=editAbsentRate;

      loadData(1);

       function loadData(pageno) {

          vm.DataTable.loadData(AbsentRate,pageno,{action:'viewdata', company: $localStorage.empsite});
       }

       

       function inputAbsentRate(ev)
      {
          $mdDialog.show({
                controller         : 'InputabsentrateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/payroll/absentrate/input-absentrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            }); 
      }

      function editAbsentRate(ev,id)
      {
        $mdDialog.show({
            controller         : 'EditabsentrateController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/payroll/absentrate/input-absentrate.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
            locals:{
                  id:id
                }
        });
      }

       function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisAbsentRateSelected=angular.copy(vm.DataTable.list);
          }

          function unCheckAll() {
             vm.lisAbsentRateSelected=[];
          } 

        function saveData(ev,formController) {
            var promise= Form.saveData('save', formController, AbsentRate);
            promise.then(function(){
                showDialog(ev);
            });
        }

       
        function closeModal()
        {
            $mdDialog.hide();
        }

      function DeleteAbsentRate(ev) { 
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this list?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=AbsentRate.delete({action:'delete',data:angular.toJson(vm.lisAbsentRateSelected)});

           response.$promise.then(loadData);
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
         });
    
     
      }
    }
})();
(function () {
  'use strict';

  angular
      .module('app.onboarding.user.register', ['ui.tinymce'])
       .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.app_onboarding_user_register', {
              url: '/onboarding/user-register',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/onboarding/onboarding-user-register/onboarding-user-register.html',
                      controller: 'OnBoardUserRegisterController as vm'
                  }
              }
          });
  }
 })();

(function() {
  'use strict';
  angular
    .module('app.onboarding.user.register')
    .controller('OnBoardUserRegisterController', OnBoardUserRegisterController);

  OnBoardUserRegisterController.$inject = ['$document','DataService','$localStorage','$mdDialog','AppAPI','Auth','Form','config','FileUploader','$http'];
  /** @ngInject */
  function OnBoardUserRegisterController($document,DataService,$localStorage,$mdDialog,AppAPI,Auth,Form,config,FileUploader,$http) 
  {
    var vm = this;
    var Onboarding = AppAPI.Onboarding();

    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listSelected = [];
    vm.Form = Form;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.nik = $localStorage.user;
    vm.toggleCheck = toggleCheck;
    vm.update = false;
    vm.disable = false;
    
    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      Form.initialForm();
      Form.setObject(Onboarding);
    }
    
    function loadData(pageno) {
      var resp = vm.DataTables.loadDatas(Onboarding, pageno, {
        action: 'viewUserRegister'
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;  
        vm.admin = data.isAdmin;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'OnBoardUserRegisterFormController',
        controllerAs: 'vm',
        templateUrl: 'app/main/onboarding/onboarding-user-register/onboarding-user-register-form.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
          angular.element.unblockUI();
        },
        clickOutsideToClose: true,
        fullscreen: true
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'OnBoardUserRegisterEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/onboarding/onboarding-user-register/onboarding-user-register-form.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data  : data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) 
    {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = Onboarding.delete({
              action: 'deleteUserRegister',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.messages)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggleCheck(ls, event)
    {
        if ( event )
        {
            event.stopPropagation();
        }

        var idx = vm.listSelected.indexOf(ls);
        if ( idx > -1 )
        { 
            vm.disable = false;
            vm.buddy = null;
            vm.listSelected.splice(idx, 1);
        }
        else
        {
            vm.disable = true;
            vm.buddy = ls.nik;
            vm.listSelected.push(ls);
        }
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked(ls)
    {
        return vm.listSelected.indexOf(ls) > -1;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function() {
    'use strict';
    angular
      .module('app.onboarding.user.register')
      .controller('OnBoardUserRegisterFormController', OnBoardUserRegisterFormController);
  
    OnBoardUserRegisterFormController.$inject = ['$document','DataService','$localStorage','$mdDialog','AppAPI','Auth','Form','config','FileUploader','$http'];
    /** @ngInject */
    function OnBoardUserRegisterFormController($document,DataService,$localStorage,$mdDialog,AppAPI,Auth,Form,config,FileUploader,$http) 
    {
        var vm = this;
        var Onboarding = AppAPI.Onboarding();
    
        vm.saveData = saveData;
        vm.employeeList = vm.superOrdinateList = [];
        vm.Form = Form;
        vm.setSuperordinate = setSuperordinate;
        vm.dialogClose = dialogClose;
        vm.nik = $localStorage.user;
        vm.update = vm.disable = vm.isAdmin = false;
        vm.employee = vm.superordinate = vm.buddy = vm.subordinate = '';
        vm.endDisabled = vm.disSearch = true;
        vm.setEndDate = setEndDate;
        vm.setSearchBtn = setSearchBtn;
        vm.changeEmpList = changeEmpList
        var startDate, endDate = null

        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.empSelected =[];
        vm.listSelected =[];
        vm.canModify = vm.canDelete = 1;
        vm.AddEmployeeList=AddEmployeeList;
        vm.removeEmployee=removeEmployee;
        vm.clicker = clicker;
        vm.materials = [];
        vm.recursiveCheckedF = [];
        vm.recursiveChecked = [];

        function AddEmployeeList()
        {
            angular.element.blockUI();
            var obj=vm.listSelected;  
            angular.forEach(obj, function (value,key) 
            { 
               var ifSelected=checkIfExistInselected(value.nik,vm.empSelected);
               if(!ifSelected){
                    var emp = {
                            nik : value.nik,
                            nama : value.name
                        }
                 vm.empSelected.push(emp);
                 vm.listSelected=[];
               }
            });
            vm.selectAll=false;
            angular.element.unblockUI();
        }

        function checkIfExistInselected(value,arrSelected)
        {
             var ifSelected=false;
             var len=arrSelected.length;
             for (var i=0;i<len;i++)
             {
                if(arrSelected[i].nik==value){
                    ifSelected=true;
                }
             }

             return ifSelected;
        }

        function removeEmployee(ls)
        {
            var idx = vm.empSelected.indexOf(ls);
            if ( idx > -1 )
            {
                vm.empSelected.splice(idx, 1);
            }
        }

        function toggleSelectedAll()
        {
            angular.element.blockUI();
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
                vm.selectAll = false;
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
                vm.selectAll = true;
            }
            angular.element.unblockUI();
        }

        function isChecked(ls)
        {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if ( idx > -1 )
            { 
                vm.listSelected.splice(idx, 1);
            }
            else
            {
                vm.listSelected.push(ls);
            }
        }

        activate();
        function activate() {
            angular.element.blockUI();
            loadEmployee(startDate, endDate)
            loadMaterial()
            Form.initialForm();
            Form.setObject(Onboarding);
        }
        
        function setEndDate()
        {
            vm.endDisabled=false;
            vm.start = vm.startDate;
        }
        
        function setSearchBtn()
        {
            vm.disSearch = false;
        }

        function changeEmpList(start,end)
        {
            loadEmployee(start,end);
        }

        /** start load buddy **/
        function setSuperordinate() {
            var response = Onboarding.query({ action: 'viewSupportingComponentList',nik:vm.employee });
            response.$promise.then(fetchSupportingComponentList);
        }
        function fetchSupportingComponentList(data) {
            vm.superordinateList = data[0].data.superordinate;
        }
        function errorhviewSupportingComponentList() {
            vm.superordinateList = [];
        }
        /** end load buddy **/

        /** start load employement **/
        function loadEmployee(startDate,endDate) {
            angular.element.blockUI();
            var response = Onboarding.query({ action: 'viewEmployeeList',isUpdate:false,startDate:startDate,endDate:endDate });
            response.$promise.then(fetchEmployee);
            response.$promise.catch(errorFetchEmployee);
        }
        function fetchEmployee(data) {
            angular.element.unblockUI();
            vm.employeeList = data[0].data;
            vm.items        = data[0].data;
            vm.isAdmin      = data[0].isAdmin;
            vm.start        = new Date(data[0].start);
            vm.end          = new Date(data[0].end);
        }
        function errorFetchEmployee() {
            angular.element.unblockUI();
            vm.employeeList = [];
        }
        /** start load employement **/

        /** start load materi **/
        function loadMaterial() {
            angular.element.blockUI();
            var response = Onboarding.query({ action: 'getMaterial' });
            response.$promise.then(fetchMaterial);
            response.$promise.catch(errorFetchMaterial);
        }
        function fetchMaterial(data) {
            angular.element.unblockUI();
            vm.firstdayList     = data[0].data.firstday;
            vm.orientationList  = data[0].data.orientation;
        }
        function errorFetchMaterial() {
            angular.element.unblockUI();
            vm.firstdayList     = [];
            vm.orientationList  = [];
        }
        /** start load employement **/

        function saveData(ev, frm) {
            angular.element.blockUI();
            vm.Form.objForm.employee = vm.empSelected;
            vm.Form.objForm.material = vm.materials;
            var response = Form.saveData('saveUserRegister', frm, Onboarding);
            response.then(function(data) {
                angular.element.unblockUI();
                frm.$setPristine();

                showDialogInfo(ev, data);
            });
    
            response.catch(function(data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }
  
        function showDialogInfo(ev, data) {
            $mdDialog
            .show(
                $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(data.title)
                .textContent(data.messages)
                .ariaLabel(data.title)
                .ok('OK')
                .targetEvent(ev)
            )
            .then(function() {
                dialogClose();
            });
        }
  
        function dialogClose() {
            $mdDialog.hide();
        }

        function clicker(item,type)
        {
            if(item.child && item.child.length){
                item.child.forEach(function(e){
                    e.selected = item.selected;
                })
            }else{

            }

            if(type=='firstday'){
                vm.recursiveCheckedF = [];
                pushToFirstDay(vm.firstdayList);
            }else{
                vm.recursiveChecked = [];
                pushToOrientation(vm.orientationList);
            }
            
            if(vm.recursiveChecked.lenght>0){
                vm.materials = vm.recursiveChecked.concat(vm.recursiveCheckedF);
            }else{
                vm.materials = vm.recursiveCheckedF.concat(vm.recursiveChecked);
            }
        }

        var pushToFirstDay = function(ar){
            ar.forEach(function(e){
                if(e.selected) vm.recursiveCheckedF.push(e);
                if(e.child && e.child.length) pushToFirstDay(e.child);
            });
        }
        
        var pushToOrientation = function(ar){
            ar.forEach(function(e){
                if(e.selected) vm.recursiveChecked.push(e);
                if(e.child && e.child.length) pushToOrientation(e.child);
            });
        }
    }
  })();  
(function() {
    'use strict';
    angular
      .module('app.onboarding.user.register')
      .controller('OnBoardUserRegisterEditController', OnBoardUserRegisterEditController);
  
    OnBoardUserRegisterEditController.$inject = ['$mdDialog','AppAPI','Auth','Form','data'];
    /** @ngInject */
    function OnBoardUserRegisterEditController($mdDialog,AppAPI,Auth,Form,data) 
    {
      var vm = this;
      var Onboarding = AppAPI.Onboarding();

      vm.Form = Form;
      vm.saveData = updateData;
      vm.dialogClose = dialogClose;
      vm.update = true;
      vm.isAdmin = false;
      vm.setSupportList = setSupportList      
      activate();

      function activate() {
        // loadEmployee();
        vm.employee = data.nik;
        vm.employeeDisplay = data.nik+' - '+data.name;
        vm.superordinate = data.superordinate;
        vm.buddy = data.buddy;
        vm.subordinate = data.subordinate;
        setSuperordinate();

        Form.initialForm();
        Form.setObject(Onboarding);
      }

      function updateData(ev, frm) {
        angular.element.blockUI();
        
        vm.Form.objForm.id = data.id;
        vm.Form.objForm.buddy = vm.buddy;
        vm.Form.objForm.superordinate = vm.superordinate;
        vm.Form.objForm.subordinate = vm.subordinate;
        var response = Form.saveData('saveUserRegister', frm, Onboarding);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            
            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }

      function setSuperordinate() {
        var response = Onboarding.query({ action: 'viewSupportingComponentList',nik:vm.employee,superordinate:vm.superordinate });
        response.$promise.then(SupportingComponent);
        response.$promise.catch(errorSupportingComponent);
      }
  
      function SupportingComponent(data) {
        vm.superordinateList = data[0].data.superordinate;
        vm.buddyList = data[0].data.buddy;
        vm.subordinateList = data[0].data.subordinate;
      }
  
      function errorSupportingComponent() {
        vm.superordinateList = vm.superordinateList = vm.buddyList = [];
      }
      
      function loadEmployee() {
        var response = Onboarding.query({ action: 'viewEmployeeList',isUpdate:true });
        response.$promise.then(fetchEmployee);
        response.$promise.catch(errorFetchEmployee);
      }
      
      function fetchEmployee(data) {
        vm.employeeList = data[0].data;
        vm.isAdmin      = data[0].isAdmin;
      }
  
      function errorFetchEmployee() {
        vm.employeeList = [];
      }

      function setSuperordinateV2(nik) {
        var response = Onboarding.query({ action: 'viewBuddyList',nik:nik });
        response.$promise.then(fetchBuddy);
        response.$promise.catch(errorFetchBuddy);
      }
  
      function fetchBuddy(data) {
        vm.buddyList = data[0].data;
      }
  
      function errorFetchBuddy() {
        vm.buddyList = [];
      }

      function showDialogInfo(ev, data) {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.messages)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }

      function isChecked(ls)
      { 
        return vm.listSelected.indexOf(ls) > -1;
      }

      function setSupportList(nik,type){
        if(type=='subordinate'){
          vm.subordinateList.map(function (object,key) {  
            if (object.nik == nik) {
              vm.subordinateList.splice(key, 1);
            }
          });
        }else{
            vm.buddyList.map(function (object,key) {  
              if (object.nik == nik) {
                vm.buddyList.splice(key, 1);
              }
            });
        }
      }

      function removeKey(arrayName,key)
      {
        var x;
        var tmpArray = new Array();
        for(x in arrayName)
        {
          if(x!=key) { tmpArray[x] = arrayName[x]; }
        }
        return tmpArray;
      }

      function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listSelected.indexOf(ls);
          if ( idx > -1 )
          { 
              vm.disable = false;
              vm.buddy = null;
              vm.listSelected.splice(idx, 1);
          }
          else
          {
              vm.disable = true;
              vm.buddy = ls.nik;
              vm.listSelected.push(ls);
          }
      }
    }
  })();
  
(function() {
    'use strict';
    angular
      .module('app.onboarding.user.register')
      .controller('OnBoardUserRegisterDetailController', OnBoardUserRegisterDetailController);
  
    OnBoardUserRegisterDetailController.$inject = ['$mdDialog','AppAPI','Auth','data','$sce'];
    /** @ngInject */
    function OnBoardUserRegisterDetailController($mdDialog,AppAPI,Auth,data,$sce
    ) {
      var vm = this;
      var news = AppAPI.Onboarding();
      vm.dialogClose = dialogClose;
      vm.doc_type=false;
      activate();
  
      function activate() {
        if(data.file_path!=null){
          if (data.file_path.slice(-3) === 'pdf') {
              vm.doc_type = true;
              vm.video_type = false;
          }
          vm.url = 'api/'+data.file_path+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }
      }

      function dialogClose() {
        $mdDialog.hide();
        // $window.location.reload();
      }
    }
  })();
(function () {
  'use strict';

  angular
      .module('app.onboarding.upload.resource', ['ui.tinymce'])
       .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.app_onboarding_upload_resource', {
              url: '/onboarding/resource',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/onboarding/onboarding-upload-resource/onboarding-upload-resource.html',
                      controller: 'OnBoardUploadResourceController as vm'
                  }
              }
          });
  }
 })();

(function() {
  'use strict';
  angular
    .module('app.onboarding.upload.resource')
    .controller('OnBoardUploadResourceController', OnBoardUploadResourceController);

  OnBoardUploadResourceController.$inject = ['$document','DataService','$localStorage','$mdDialog','AppAPI','Auth','Form','config','FileUploader','$http'];
  /** @ngInject */
  function OnBoardUploadResourceController($document,DataService,$localStorage,$mdDialog,AppAPI,Auth,Form,config,FileUploader,$http) 
  {
    var vm = this;
    var Onboarding = AppAPI.Onboarding();

    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.saveData = saveData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listCategory = [];
    vm.Form = Form;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.group1=true;
    vm.viewDetail=viewDetail;
    vm.download=download;
    vm.nik = $localStorage.user;
    vm.show = vm.overview = vm.dashboard = vm.isCategory = true;

    vm.hide = hide;
    vm.listType = [ {slug: 'firstday',name:'First Day'},
                    {slug: 'orientation',name:'Orientation'}
                  ];
    
    vm.tinymceOptions = {
      height: 350,
      theme: 'modern',
      plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount  imagetools contextmenu colorpicker textpattern',
      toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat image',
      image_advtab: true,
      templates: [
        { title: 'template 1', content: 'Template 1' },
        { title: 'template 2', content: 'Template 2' }
      ],
      file_picker_types: 'image',
      file_picker_callback: function (callback, value, meta) {
        if (meta.filetype == 'image') {
          $('#upload').trigger('click');
          $('#upload').on('change', function () {
            var file = this.files[ 0 ];
            var reader = new FileReader();
            reader.onload = function (e) {
              callback(e.target.result, {
                alt: ''
              });
            };
            reader.readAsDataURL(file);
          });
        }
      }
    };
    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      Form.initialForm();
      Form.setObject(Onboarding);
    }

    function hide(type)
    {
      if(type=='firstday'){
        vm.show = false;
      }else{
        vm.show = true;
      }
      loadDataCategory(type);
    }

    function loadDataCategory(type) {
      var response = Onboarding.query({ action: 'viewOrientationSubCategory',type:type });
      response.$promise.then(fetchCategory);
      response.$promise.catch(errorFetchCategory);
    }

    function fetchCategory(data) {
      vm.listCategory = data[0].data;
    }

    function errorFetchCategory() {
      vm.listCategory = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadDatas(Onboarding, pageno, {
        action: 'viewUploadResource'
      });
      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;  
        vm.admin= data.isAdmin;
        
        if(!vm.admin){
          vm.DataTables.list.forEach(function(item,index){
            if(item.file_path==null){
              delete vm.DataTables.list[index]
            }
          })
          vm.DataTables.list = reindex_array_keys(vm.DataTables.list);
        }
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'OnBoardUploadResourceController',
        controllerAs: 'vm',
        templateUrl: 'app/main/onboarding/onboarding-upload-resource/onboarding-upload-resource-form.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
          angular.element.unblockUI();
        },
        clickOutsideToClose: false,
        fullscreen: true
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'OnBoardUploadResourceEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/onboarding/onboarding-upload-resource/onboarding-upload-resource-form.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data  : data,
          listNC : vm.listCategory
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) 
    {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = Onboarding.delete({
              action: 'deleteResource',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.title = vm.title;
      vm.Form.objForm.category = vm.category;
      vm.Form.objForm.description = vm.description;
      vm.Form.objForm.type = vm.type;
      var response = Form.saveData('saveResource', frm, Onboarding);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();

          vm.uploader.uploadAll();
          loadData(1);
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.messages)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    var uploader = vm.uploader = new FileUploader({
        url:config.api+'api/onboarding/uploadFile', 
        removeAfterUpload:true,
        alias:'onboardingDocument',    
    });

      // a sync filter
    uploader.filters.push({
      name: 'syncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options) {
          return this.queue.length < 10;
      }
    });

    // an async filter
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
          setTimeout(deferred.resolve, 1e3);
      }
    });

    function  viewDetail(ev, data) 
    {
      if(data.file_path==="" || data.file_path===null){
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('File Not Found')
          .textContent('File not Found')
          .ariaLabel('Failed Download File')
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
            loadData(1);
          });
      } else {
        $mdDialog.show({
            controller         : 'OnBoardUploadResourceDetailController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/onboarding/onboarding-upload-resource/onboarding-view-detail.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{ 
                data : data
            }
        });
      }
    }

    function download(ev, data)
    {
      if(data.file_path==="" || data.file_path===null){
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('File Not Found')
          .textContent('File not Found')
          .ariaLabel('Failed Download File')
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              // closeModal();
          });
      } else {
        var filePath = data.file_path.split("/");
        var name =  filePath[1];
        $http({
            method: 'GET',
            url: config.api+'api/'+data.file_path,
            params: { name: name },
            responseType: 'arraybuffer'
        }).success(function (data, status, headers) {
            headers = headers();
            var filename = name;
            var contentType = headers['content-type'];

            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([data], { type: contentType });
                var url = window.URL.createObjectURL(blob);

                linkElement.setAttribute('href', url);
                linkElement.setAttribute("download", filename);

                var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                });
                linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
                console.log(ex);
            }
        }).error(function (data) {
            console.log(data);
        });
      }
    }

    function inArray(param, array) {
      var length = array.length;
      for (var i = 0; i < length; i++) {
        if (array[i] == param)
          return true;
        }
      return false;
    }

    function reindex_array_keys(array, start){
      var temp = [];
      start = typeof start == 'undefined' ? 0 : start;
      start = typeof start != 'number' ? 0 : start;
      for(var i in array){
          temp[start++] = array[i];
      }
      return temp;
    }

  }
})();

(function() {
    'use strict';
    angular
      .module('app.onboarding.upload.resource')
      .controller('OnBoardUploadResourceEditController', OnBoardUploadResourceEditController);
  
    OnBoardUploadResourceEditController.$inject = ['$mdDialog','AppAPI','Auth','Form','data','listNC','config','FileUploader'];
    /** @ngInject */
    function OnBoardUploadResourceEditController($mdDialog,AppAPI,Auth,Form,data,listNC,config,FileUploader) 
    {
      var vm = this;
      var Onboarding = AppAPI.Onboarding();

      vm.Form = Form;
      vm.saveData = updateData;
      vm.dialogClose = dialogClose;
      vm.show = data.type=='firstday' ? false : true;
      vm.isCategory = true;
      vm.disabled = false;
      vm.dashboard = true;
      vm.listType = [ {slug: 'firstday',name:'First Day'},
                      {slug: 'orientation',name:'Orientation'}
                    ];
      if(data.type=='overview' || data.type=='dashboard'){
        vm.isCategory = false;
        vm.disabled = true;
        vm.listType = [ {slug: 'firstday',name:'First Day'},
                      {slug: 'orientation',name:'Orientation'},
                      {slug: 'overview',name:'Overview'},
                      {slug: 'dashboard',name:'Dashboard'}
                    ];
      }
      if(data.type=='dashboard'){
        vm.dashboard = false;
      }
      vm.overview = data.type=='overview' ? false : true;
      vm.dashboard = data.type=='dashboard' ? false : true;
      vm.hide = hide;
      
      vm.tinymceOptions = {
        height: 350,
        theme: 'modern',
        plugins: 'print preview fullpage searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample code table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount  imagetools contextmenu colorpicker textpattern',
        toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat image',
        image_advtab: true,
        templates: [
          { title: 'template 1', content: 'Template 1' },
          { title: 'template 2', content: 'Template 2' }
        ],
        file_picker_types: 'image',
        file_picker_callback: function (callback, value, meta) {
          if (meta.filetype == 'image') {
            $('#upload').trigger('click');
            $('#upload').on('change', function () {
              var file = this.files[ 0 ];
              var reader = new FileReader();
              reader.onload = function (e) {
                callback(e.target.result, {
                  alt: ''
                });
              };
              reader.readAsDataURL(file);
            });
          }
        }
      };
      
      activate();
      
      function hide(type)
      {
        if(type=='firstday'){
          vm.show = false;
        }else{
          vm.show = true;
        }
        
        if(type=='overview'){
          vm.overview = false;
        }else{
          vm.overview = true;
        }
        
        if(type=='dashboard'){
          vm.dashboard = false;
        }else{
          vm.dashboard = true;
        }
        loadDataCategory(type);
      }

      function activate() {
        vm.title   = data.item_name;
        vm.description = data.description;
        vm.file_path = data.file_path;
        vm.category = data.category_id;
        vm.type = data.type;
        loadDataCategory(vm.type);
        Form.initialForm();
        Form.setObject(Onboarding);
      }
      
      function loadDataCategory(type) {
        var response = Onboarding.query({ action: 'viewOrientationSubCategory',type:type });
        response.$promise.then(fetchCategory);
        response.$promise.catch(errorFetchCategory);
      }
  
      function fetchCategory(data) {
        vm.listCategory = data[0].data;
      }
  
      function errorFetchCategory() {
        vm.listCategory = [];
      }

      function updateData(ev, frm) {
        angular.element.blockUI();
        
        vm.Form.objForm.id = data.id;
        vm.Form.objForm.title = vm.title;
        vm.Form.objForm.category = vm.category;
        vm.Form.objForm.description = vm.description;
        vm.Form.objForm.type = vm.type;
        var response = Form.saveData('saveResource', frm, Onboarding);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            
            vm.uploader.uploadAll();

            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.messages)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }

      var uploader = vm.uploader = new FileUploader({
          url:config.api+'api/onboarding/uploadFile', 
          removeAfterUpload:true,
          alias:'onboardingDocument',    
      });

      // a sync filter
      uploader.filters.push({
        name: 'syncFilter',
        fn: function(item /*{File|FileLikeObject}*/, options) {
            return this.queue.length < 10;
        }
      });

      // an async filter
      uploader.filters.push({
        name: 'asyncFilter',
        fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
            setTimeout(deferred.resolve, 1e3);
        }
      });
    }
  })();
  
(function() {
    'use strict';
    angular
      .module('app.onboarding.upload.resource')
      .controller('OnBoardUploadResourceDetailController', OnBoardUploadResourceDetailController);
  
    OnBoardUploadResourceDetailController.$inject = ['$mdDialog','AppAPI','Auth','data','$sce','$localStorage'];
    /** @ngInject */
    function OnBoardUploadResourceDetailController($mdDialog,AppAPI,Auth,data,$sce,$localStorage) 
    {
      var vm = this;
      var Onboarding = AppAPI.Onboarding();
      vm.dialogClose = dialogClose;
      vm.processData = processData;
      vm.doc_type=false;
      vm.isOrientation = ('isOrientation' in data) ? true : false;
      activate();
  
      function activate() {
        if(data.file_path!=null){
          if (data.file_path.slice(-3) === 'pdf') {
              vm.doc_type = true;
              vm.video_type = false;
          }
          vm.url = 'api/'+data.file_path+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }
      }

      function dialogClose() {
        $mdDialog.hide();
        // $window.location.reload();
      }

      function processData()
      {
        var promise = Auth.setToken();
        promise.then(function() {

          vm.objForm = new Onboarding();
          vm.objForm.action='saveCategoryItem';
          vm.objForm.id=data.id;
          vm.objForm.category_id=data.categoryId;
          var promise2 = vm.objForm.$save();
          promise2.then(function(data)
          {
            if(!!data.messages)
            { 
              vm.objForm = new Onboarding();
              $localStorage.token=data.token;
            }     
            $mdDialog.hide();
          }); 
        });
      }
    }
  })();
(function ()
{
    'use strict';

    angular
        .module('app.onboarding.tutorial', [
        ])
        .config(config);

    config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
        // State
        $stateProvider
        .state('app.onboarding_tutorial', {
            url    : '/onboarding/tutorial',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/onboarding/onboarding-tutorial/tutorial.html',
                    controller : 'OnboardingTutorialController as vm'
                }
            }
        });

        $stateProvider
        .state('app.onboarding_view_tutorial', {
            url    : '/onboarding/view-tutorial/:url',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/onboarding/onboarding-tutorial/view-tutorial.html',
                    controller : 'OnboardingViewTutorialController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.onboarding.tutorial')
        .controller('OnboardingTutorialController', OnboardingTutorialController);

    OnboardingTutorialController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function OnboardingTutorialController($state,$log,$mdDialog,AppAPI,Auth,DataService, $document) 
    {    
        var vm = this;
        var Onboarding = AppAPI.Onboarding();

        vm.viewDetail = viewDetail;
        
        loadData()
        
        function loadData() {
            angular.element.blockUI();
            var dataPromise = Onboarding.query({action:'getTutorial'});
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch); 
        }
    
        function fetchData(data) {
            vm.tutorialList = data[0].data;
            
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.tutorialList = [];
            angular.element.unblockUI();
        }

        function viewDetail(ev, data) 
        {
            $mdDialog.show({
                controller: 'OnboardingViewTutorialController',
                controllerAs: 'vm',
                templateUrl: 'app/main/onboarding/onboarding-tutorial/oboarding-tutorial-view.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    //
                },
                locals: {
                    data: data
                }
            });
        }

        // vm.tutorialList = [
        //     {id: 1, 
        //      title: 'Tutorial New Employee dan se lorem ipsum dolor sir amet def',
        //      cover: 'onboarding-cover.jpeg',
        //      type: 'video',
        //      url: btoa('TUTORIAL-MPN-V1.mp4')            
        //     },
        //     {id: 2, 
        //      title: 'Tutorial Atasan',
        //      cover: 'onboarding-cover.jpeg',
        //      type: 'video',
        //      url: btoa('CREATE-MPN-V1.mp4')
        //     },
        //     {id: 3, 
        //     title: 'Tutorial Admin',
        //     cover: 'onboarding-cover.jpeg',
        //     type: 'video',
        //     url: btoa('RESPOND-MPN-REQUEST-V1.mp4')
        //     },
        //     {id: 4, 
        //     title: 'Tutorial Admin',
        //     cover: 'onboarding-cover.jpeg',
        //     type: 'video',
        //     url: btoa('RESPOND-MPN-REQUEST-V1.mp4')
        //     },
        //     {id: 5, 
        //     title: 'Tutorial Admin',
        //     cover: 'onboarding-cover.jpeg',
        //     type: 'video',
        //     url: btoa('RESPOND-MPN-REQUEST-V1.mp4')
        //     }

        // ];

    }


 })();
(function () {
    'use strict';

    angular
        .module('app.onboarding.tutorial')
        .controller('OnboardingViewTutorialController', OnboardingViewTutorialController);

    OnboardingViewTutorialController.$inject=['$state','$stateParams','$log','$mdDialog','AppAPI','Auth','DataService', '$document','data'];
    /** @ngInject */
    function OnboardingViewTutorialController($state,$stateParams,$log,$mdDialog,AppAPI,Auth,DataService, $document, data) 
    {    
        var vm = this;        

        activate();

        function activate() 
        {
            vm.title = data.title;
            vm.dialogClose = dialogClose;
            
            if (data.filename != null) 
            {
                if (data.filename.slice(-3) === "mp4") {
                    vm.video_type = true;
                    vm.doc_type = false;
                    vm.images = false;
                } else if (data.filename.slice(-3) === "pdf") {
                    vm.doc_type = true;
                    vm.video_type = false;
                    vm.images = false;
                } else {
                    vm.video_type = false;
                    vm.doc_type = false;
                    vm.images = true;
                    vm.doc = data.filename;
                }
                
                vm.url =
                    "api/onboardingdocument/" +
                    data.filename +
                    "?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;";
            }
        }

        function dialogClose() {
            $mdDialog.hide();
        }        
    }


 })();
(function ()
{
    'use strict';

    angular
        .module('app.onboarding.summary', ['dataGrid'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.app_onboarding_summary', {
                url    : '/onboarding/summary/:spv',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/onboarding/onboarding-summary/onboarding-summary.html',
                        controller: 'OnBoardSummaryController as vm'
                    }
                }
            });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.onboarding.summary')
        .controller('viewMyLearningSummaryController', viewMyLearningSummaryController);

    viewMyLearningSummaryController.$inject = ['$mdDialog','type','data','$state','$localStorage','AppAPI','Auth'];

    /* @ngInject */
    function viewMyLearningSummaryController($mdDialog,type,data,$state,$localStorage,AppAPI,Auth) 
    {
        var vm = this; 
        var Onboarding = AppAPI.Onboarding();
        Auth.setToken();
        vm.closeModal=closeModal;
        vm.status = '0';
        var actType = null

        if(type=="30day"){
            getLearning();
            vm.header = 'My 30 Days Learning Progress';
            vm.supervisor = true;
        }else if(type=="60day"){
            getLearning();
            vm.header = 'My 60 Days Learning Progress';
            vm.supervisor = true;
        }else if(type=="90day"){
            getLearning();
            vm.header = 'My 90 Days Learning Progress';
            vm.supervisor = true;
        }else if(type=="feedback"){
            getLearning();
            vm.header = 'System Feedback (end of third month)';
            vm.supervisor = true;
        }

        vm.isComplete       = false;
        vm.readyToSubmit    = true;
        vm.completedAt      = "";
        vm.empName          = data.name;
        vm.processLearning  = processLearning;
        vm.qs1 = vm.qs2 = vm.qs3 = vm.qs4 = vm.fg1 = vm.fg2 = vm.fg3 = vm.fg4 = "";
        vm.tinymceOptions = {
            height: 150,
            theme: 'modern',
            plugins: 'advlist lists',
            toolbar1: 'numlist',
            templates: [],
        };

        loadData();

        function closeModal()
        {
            $mdDialog.hide();
        }
        
        function review(id)
        {
            var id = encodeURIComponent(window.btoa(id));
            var subject = 'Review';
            $state.go('app.app_onboarding_review',{id: id,subject:subject});
        }

        function processLearning(ev,action,actType)
        {
            var promise = Auth.setToken();
            promise.then(function() {
                angular.element.blockUI();
                var registerId = data.register_id;
                vm.objForm = new Onboarding();
                vm.objForm.action=action;
                vm.objForm.register_id=data.register_id;
                vm.objForm.spv_comment=vm.spvComment;
                vm.objForm.type=type;
                if(actType!=null){
                    vm.objForm.actType='reject';
                }
                var promise = vm.objForm.$save();
                promise.then(function(data){
                    if(!!data.messages)
                    { 
                        vm.objForm = new Onboarding();
                        $localStorage.token=data.token;
                    }
                    showDialogInfo(ev, data);
                    
                    if(data.title=="Success"&&type=="90day"&&action=="submitComment"&&actType==null){
                        review(registerId)
                    }
                });
            });
        }

        function getLearning() {
            angular.element.blockUI();
            var reg = encodeURIComponent(window.btoa(data.register_id));
            var dataPromise = Onboarding.query({action:'viewLearning',type:type,register_id:reg,id:data.learningId});
            dataPromise.$promise.then(fetchLearning);
            dataPromise.$promise.catch(errorLearning); 
        }
        function fetchLearning(data) {
            vm.ojt = data[0].data[0];
            vm.discussionList = data[0].discussionList;
            vm.superordinate  = data[0].userInfo.superordinate;
            vm.spvName        = data[0].userInfo.spv_name;
            vm.subordinate    = data[0].userInfo.subordinate;
            vm.isSuperordinate = data[0].isSuperOrdinate;
            if(typeof vm.ojt!='undefined'){
                vm.completed=vm.ojt.is_completed==1 ? true : false;
                if(data[0].completed==true&& vm.ojt.readyToSubmit==true){
                    vm.isComplete = true;
                }
                vm.ans1 = vm.ojt.ans1;
                vm.ans2 = vm.ojt.ans2;
                vm.ans3 = vm.ojt.ans3;
                vm.ans4 = vm.ojt.ans4;
                vm.spvComment = vm.ojt.spv_comment;
                vm.status = vm.ojt.status;

                if(type=='feedback'){
                    vm.feedback = vm.ojt.qa;
                }
            }
            angular.element.unblockUI();
        }
        function errorLearning() {
            vm.ojt = {};
            angular.element.unblockUI();
        }

        function loadData() {
            angular.element.blockUI();
            var dataPromise = Onboarding.query({action:'viewLearningQuestion'});
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch); 
        }
    
        function fetchData(data) {
            vm.listData = data[0].data;
            
            vm.qs1 = vm.listData[0].description;
            vm.qs2 = vm.listData[1].description;
            vm.qs3 = vm.listData[2].description;
            vm.qs4 = vm.listData[3].description;
            vm.fg1 = vm.listData[0].flag;
            vm.fg2 = vm.listData[1].flag;
            vm.fg3 = vm.listData[2].flag;
            vm.fg4 = vm.listData[3].flag;
            
            var sumData = vm.listData.length;
            var sumDataEmp = 0;
            vm.listData.forEach(function(item,index){
              if(item.is_complete==1){
                sumDataEmp +=1;
              }
            });
            if(data[0].completed==true){
              vm.disableAct = true;
            }
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }
        
        function showDialogInfo(ev, data) 
        {
            angular.element.unblockUI();
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.messages)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function() {
                    closeModal();
                });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.onboarding.summary')
        .controller('OnbReviewerDetailController', OnbReviewerDetailController);

    OnbReviewerDetailController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','id'];

    /* @ngInject */
    function OnbReviewerDetailController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,id) {
        var vm = this; 

        var Onboarding = AppAPI.Onboarding(); 
        vm.closeModal=closeModal;
          
        loadDetail(id); 
        
        function closeModal()
        {
            $mdDialog.hide();
        }   

        function loadDetail(id)
        {
            var response= Onboarding.query({action:'viewData',register_id:id,type:'getReviewer'});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {
            vm.items = data[0].data;
        }

        function errorFetchDetail() {
            vm.items = [];
        }   
    }
})();
(function() {
    'use strict';
    angular
      .module('app.onboarding.summary')
      .controller('OnBoardSummaryController', OnBoardSummaryController);
  
    OnBoardSummaryController.$inject = ['$mdDialog','AppAPI','Auth','$state','$stateParams','Form','$localStorage','DataService','$location','$window','config'];
    /** @ngInject */
    function OnBoardSummaryController($mdDialog,AppAPI,Auth,$state,$stateParams,Form,$localStorage,DataService,$location,$window,config) 
    {
      var vm = this;
      var Onboarding  = AppAPI.Onboarding();
      vm.viewDetail   = viewDetail;
      vm.editData     = editData;
      vm.saveData     = saveData;
      vm.review       = review;
      vm.reviewer     = reviewer;
      vm.Input        = Input;
      vm.disableAct   = false;
      vm.spv          = window.atob(decodeURIComponent($stateParams.spv));
      vm.submitData   = submitData;
      vm.loadData     = loadData;
      vm.Form         = Form;
      vm.Export       = Export;
      vm.completeness = completeness;
      vm.listJum      = [2,5,25,50,75,100,200];
      vm.DataTable    = new DataService();
      Auth.setToken();

      loadData(1);

      function loadData(pageno)
      {
        var resp = vm.DataTable.loadDatas(Onboarding,pageno,{action:'viewSummary'});
        
        resp.then(function(data) {  
          vm.admin = data.isAdmin;
        });

      }

      function review(ev,id)
      {
          var id = encodeURIComponent(window.btoa(id));
          var subject = 'Review';
          $state.go('app.app_onboarding_review',{id: id,subject:subject});
      }

      function reviewer(ev,id)
      {
        var id = encodeURIComponent(window.btoa(id));
        var template = 'app/main/onboarding/onboarding-summary/detail-reviewer.html';
        $mdDialog.show({
          controller         : 'OnbReviewerDetailController',
          controllerAs       : 'vm',
          templateUrl        : template,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          locals:{
            id:id
          }
        });
      }
      
      function viewDetail(type,item,ev)
      {
        var template = 'app/main/onboarding/onboarding-summary/view-learning.html';
        $mdDialog.show({
          controller         : 'viewMyLearningSummaryController',
          controllerAs       : 'vm',
          templateUrl        : template,
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
            loadData();
          },
          locals:{ 
              data : item,
              type : type
          }
        }); 
      }

      function submitData(ev) 
      {
        var promise = Auth.setToken();
        promise.then(function() {
          var confirm = $mdDialog
            .confirm()
            .title('Are you sure want to submit ?')
            .textContent('No change can be made once this is clicked.')
            .ariaLabel('submit dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('NO');

          $mdDialog.show(confirm).then(
            function() {
              vm.objForm = new Onboarding();
              vm.objForm.action='submitDiscussion';
              vm.objForm.id = $stateParams.id;
              var promise = vm.objForm.$save();
              promise.then(function(data){
                if(!!data.messages)
                { 
                  vm.objForm = new Onboarding();
                  $localStorage.token=data.token;
                  showDialogInfo(ev, data);
                  loadData();
                }else
                {
                  showDialogInfo(ev, data);
                  loadData();
                }     
              });      
            },
            function() {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        });
      }

      function showDialogInfo(ev, data) 
      {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.messages)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            closeModal();
            loadData();
          });
      }

      function closeModal() {
        $mdDialog.hide();
      }

      function Input(ev)
      {
          $mdDialog.show({
              controller         : 'OnBoardSummaryController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/onboarding/onboarding-ojt-discussion/onboarding-ojt-discussion-form.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData();
              }
          }); 

      }

      function editData(ev,data)
      {
        $mdDialog.show({
              controller         : 'OnBoardOjtDiscussionEditController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/onboarding/onboarding-ojt-discussion/onboarding-ojt-discussion-form.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData();
              },
              locals:{
                data:data
              }
          });  
      }

      function saveData(ev, frm) {
        angular.element.blockUI();
        vm.objForm = new Onboarding();
        vm.objForm.action='saveDiscussion';
        vm.objForm.roles = vm.role;
        vm.objForm.skill_required = vm.skill;
        vm.objForm.action_plan = vm.actionplan;
        vm.objForm.target_date = vm.targetDate;
        vm.objForm.id = $stateParams.id;
        var promise = vm.objForm.$save();
        promise.then(function(data){
          if(!!data.messages)
          { 
            vm.objForm = new Onboarding();
            $localStorage.token=data.token;
          }

          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
          loadData();    
        });
      }

      function Export()
      {
        var token=Auth.setTokenPromise();
        token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                  $window.open(protocol+'://'+host+config.api+config.port+'api/onboarding/exportexcel', '_blank');
          },function(){

              $window.alert('gagal load token');
          });
      }

      /** start load completeness **/
      function completeness(id) 
      {
        var template = 'app/main/onboarding/onboarding-summary/completeness.html';
        $mdDialog.show({
          controller         : 'OnBoardCompletenessController',
          controllerAs       : 'vm',
          templateUrl        : template,
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          locals:{
            id:id
          }
        });
      }
      /** start load completeness **/
      
    }
  })();  
(function() {
    'use strict';

    angular
        .module('app.onboarding.summary')
        .controller('OnBoardCompletenessController', OnBoardCompletenessController);

    OnBoardCompletenessController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','id'];

    /* @ngInject */
    function OnBoardCompletenessController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,id) {
        var vm = this; 
        var Onboarding = AppAPI.Onboarding(); 
        
        vm.firstdayList = [];
        vm.orientationList = [];
        vm.closeModal=closeModal;
          
        completeness(id); 
        
        function closeModal() 
        {
            $mdDialog.hide();
        }

        function completeness(id) 
        {
            angular.element.blockUI();
            var response = Onboarding.query({ action: 'getMaterial',register_id:id });
            response.$promise.then(fetchMaterial);
            response.$promise.catch(errorFetchMaterial);
        }
        function fetchMaterial(data) {
            angular.element.unblockUI();
            vm.firstdayList     = data[0].data.firstday;
            vm.orientationList  = data[0].data.orientation;
        }
        function errorFetchMaterial() {
            angular.element.unblockUI();
            vm.firstdayList     = [];
            vm.orientationList  = [];
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.onboarding.review', ['dataGrid','ui.tinymce','chart.js'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.app_onboarding_review', {
                url    : '/onboarding/review/:id/:subject',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/onboarding/onboarding-review/onboarding-review.html',
                        controller: 'OnBoardReviewController as vm'
                    }
                }
            });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.onboarding.review')
        .controller('viewReviewController', viewReviewController);

    viewReviewController.$inject = ['$mdDialog','data','$localStorage','config','AppAPI','DataService'];

    /* @ngInject */
    function viewReviewController($mdDialog,data,$localStorage,config,AppAPI,DataService) {
        var vm = this; 

        var news = AppAPI.News();
        vm.closeModal=closeModal;
        vm.listData=data.logReader;

        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.items = [];

        // loadData(1);

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadData(pageno) {
        var resp = vm.DataTables.loadData(news, pageno, {
            action: 'viewReaderLog',news_id:data.id
        });
    
        resp.then(function(data) {
            vm.companyList=data.readerByCompany;
            vm.selected = [];
            vm.items = data.list;
        });
        }
    }
})();
(function() {
    'use strict';
    angular
      .module('app.onboarding.review')
      .controller('OnBoardReviewController', OnBoardReviewController);
  
    OnBoardReviewController.$inject = ['$mdDialog','AppAPI','Auth','$state','$stateParams','Form','$localStorage'];
    /** @ngInject */
    function OnBoardReviewController($mdDialog,AppAPI,Auth,$state,$stateParams,Form,$localStorage) 
    {
      var vm = this;
      var Onboarding  = AppAPI.Onboarding();
      vm.viewDetail   = viewDetail;
      vm.isComplete   = false;
      vm.isConfirm    = false;
      vm.subHeader    = $stateParams.subject;
      vm.saveData     = saveData;
      vm.submitData   = submitData;
      vm.back         = back;
      vm.Form         = Form;

      vm.tinymceOptions = {
          height: 100,
          theme: 'modern',
          plugins: 'advlist lists',
          toolbar1: 'numlist',
          templates: [],
      };
      Auth.setToken();

      loadData();
      
      function loadData() {
        angular.element.blockUI();
        var dataPromise = Onboarding.query({action:'viewData',type:'competency',actions:'review',register_id:$stateParams.id});
        dataPromise.$promise.then(fetchData);
        dataPromise.$promise.catch(errorFetch); 
      }

      function fetchData(data) {
        vm.listInput   = data[0].data;
        vm.admin       = data[0].is_admin;
        vm.score       = data[0].score;
        vm.employee    = data[0].employee;
        vm.scale       = data[0].scale;
        vm.chartLabels = data[0].chartLabels;
        vm.chartColors = data[0].chartColors;
        vm.series      = data[0].chartSeries;
        vm.chartData   = data[0].chartData;
        vm.totalPoint  = data[0].totalPoint;
        vm.options = {
          responsive: true,
        }
        if(vm.totalPoint>4.30){
          vm.result     = "Meeting all expectations, ready to contribute and take full responsibility of the job";
          vm.addResult  = "(fully onboard with potential)";
          vm.color      = "tx-color purple";
          vm.txColor    = "add-color black";
        }else if(vm.totalPoint>=3.51&&vm.totalPoint<=4.30){
          vm.result     = "Meeting expecation and understand the job requirement ; may need some guidance";
          vm.addResult  = "(fully onboard)";
          vm.color      = "tx-color green";
          vm.txColor    = "add-color black";
        }else if(vm.totalPoint>=2.85&&vm.totalPoint<=3.50){
          vm.result     = "Meeting expectation but with need guidance and coaching for development";
          vm.addResult  = "(fully onboard within 3 months)";
          vm.color      = "tx-color light-green";
          vm.txColor    = "add-color black";
        }else if(vm.totalPoint>=1.80&&vm.totalPoint<=2.84){
          vm.result     = "Have potential but need further coaching and guidance";
          vm.addResult  = "(fully onboard within 6 months to 1 year)";
          vm.color      = "tx-color orange";
          vm.txColor    = "add-color black";
        }else{
          vm.result     = "Not able to integrate to the organisation and perform in the level required by the job";
          vm.addResult  = "(not onboard)";
          vm.color      = "tx-color red";
          vm.txColor    = "add-color black";
        }
        vm.series.splice(0, 0, 'Standard');
        vm.chartData.splice(0, 0, ["3", "3", "3", "3", "3", "3"]);
        
        if(data[0].is_complete==true){
          vm.isComplete = true;
        }
        if(data[0].is_confirm==true){
          vm.isConfirm = true;
        }
        
        angular.element.unblockUI();
      }
      function errorFetch() {
        vm.listInput = [];
        angular.element.unblockUI();
      }

      function viewDetail(item,ev)
      {
        $mdDialog.show({
            controller         : 'viewOrientationController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/onboarding/onboarding-orientation/view-detail.html',
            parent: angular.element(document.body),
            clickOutsideToClose:false,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
              var promise = Auth.setToken();
              promise.then(function() {

                vm.objForm = new Onboarding();
                vm.objForm.action='saveCategoryItem';
                vm.objForm.id=item.id;
                vm.objForm.category_id=$stateParams.id;
                var promise2 = vm.objForm.$save();
                promise2.then(function(data)
                {
                  if(!!data.messages)
                  { 
                    vm.objForm = new Onboarding();
                    $localStorage.token=data.token;
                  }     
                  loadData();
                }); 
              });
            },
            locals:{ 
                data : item
            }
        }); 
      }

      function saveData(ev) 
      {
        var promise = Auth.setToken();
        promise.then(function() {
          vm.objForm = new Onboarding();
          vm.objForm.action='saveReview';
          vm.objForm.score = vm.score;
          vm.objForm.qualitative_id = vm.qlt;
          vm.objForm.comment = vm.comment;
          vm.objForm.register_id = $stateParams.id;
          var promise = vm.objForm.$save();
          promise.then(function(data)
          {
            if(!!data.messages)
            { 
              vm.objForm = new Onboarding();
              $localStorage.token=data.token;
            }     
            showDialogInfo(ev, data);
          });
        });
      }

      function submitData(ev,type) 
      {
        //validasi harus isi semua
        if(type=='spv' && (vm.score==null || Object.getOwnPropertyNames(vm.score).length<vm.scale)){
          var notification = {'title' : 'Failed','messages' : 'Please complete this form !'};
          showDialogConfirm(ev, notification);
        }else{
          var promise = Auth.setToken();
          promise.then(function() {
            var confirm = $mdDialog
              .confirm()
              .title('Are you sure want to submit ?')
              .textContent('No change can be made once this is clicked.')
              .ariaLabel('submit dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('NO');

            $mdDialog.show(confirm).then(
              function() {
                vm.objForm = new Onboarding();
                vm.objForm.action='submitReview';
                if(type=='admin'){
                  vm.objForm.action='confirmReview';
                }
                vm.objForm.register_id = $stateParams.id;
                vm.objForm.score = vm.score;
                vm.objForm.qualitative_id = vm.qlt;
                vm.objForm.comment = vm.comment;

                var promise = vm.objForm.$save();
                promise.then(function(data)
                {
                  if(!!data.messages)
                  { 
                    vm.objForm = new Onboarding();
                    $localStorage.token=data.token;
                  }
                  showDialogInfo(ev, data);
                });      
              },
              function() {
                // $scope.status = 'You decided to keep your debt.';
              }
            );
          });
        }
      }

      function back()
      {
          $state.go('app.app_onboarding_summary',{ subject: 'Summary'});
      }

      function showDialogInfo(ev, data) 
      {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.messages)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            closeModal();
            loadData();
          });
      }
      
      function showDialogConfirm(ev, data) 
      {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.messages)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            closeModal();
          });
      }

      function closeModal() {
        $mdDialog.hide();
      }
    }
  })();  
(function () {
  'use strict';

  angular
      .module('app.onboarding.resource.category', [])
       .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.app_onboarding_resource_category', {
              url: '/onboarding/resource-category',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/onboarding/onboarding-resource-category/onboarding-resource-category.html',
                      controller: 'OnBoardResourceCategoryController as vm'
                  }
              }
          });
  }
 })();

(function() {
  'use strict';
  angular
    .module('app.onboarding.resource.category')
    .controller('OnBoardResourceCategoryController', OnBoardResourceCategoryController);

  OnBoardResourceCategoryController.$inject = ['$document','DataService','$localStorage','$mdDialog','AppAPI','Auth','Form','config','FileUploader','$http'];
  /** @ngInject */
  function OnBoardResourceCategoryController($document,DataService,$localStorage,$mdDialog,AppAPI,Auth,Form,config,FileUploader,$http) 
  {
    var vm = this;
    var Onboarding = AppAPI.Onboarding();

    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.saveData = saveData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listCategory = [];
    vm.Form = Form;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.group1=true;
    
    vm.nik = $localStorage.user;
    vm.listType = [ {slug: 'firstday',name:'First Day'},
                    {slug: 'orientation',name:'Orientation'}
                  ];

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      Form.initialForm();
      Form.setObject(Onboarding);
    }

    function errorFetchCategory() {
      vm.listCategory = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadDatas(Onboarding, pageno, {
        action: 'viewResourceCategory'
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;  
        vm.admin = data.isAdmin;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'OnBoardResourceCategoryController',
        controllerAs: 'vm',
        templateUrl: 'app/main/onboarding/onboarding-resource-category/onboarding-resource-category-form.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
          angular.element.unblockUI();
        },
        clickOutsideToClose: true,
        fullscreen: true
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'OnBoardResourceCategoryEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/onboarding/onboarding-resource-category/onboarding-resource-category-form.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data  : data,
          listNC : vm.listCategory
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) 
    {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = Onboarding.delete({
              action: 'deleteResourceCategory',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.title = vm.title;
      vm.Form.objForm.description = vm.description;
      vm.Form.objForm.type = vm.type;
      var response = Form.saveData('saveResourceCategory', frm, Onboarding);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();

          loadData(1);
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.messages)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function() {
    'use strict';
    angular
      .module('app.onboarding.resource.category')
      .controller('OnBoardResourceCategoryEditController', OnBoardResourceCategoryEditController);
  
    OnBoardResourceCategoryEditController.$inject = ['$mdDialog','AppAPI','Auth','Form','data','listNC','config','FileUploader'];
    /** @ngInject */
    function OnBoardResourceCategoryEditController($mdDialog,AppAPI,Auth,Form,data,listNC,config,FileUploader) 
    {
      var vm = this;
      var Onboarding = AppAPI.Onboarding();

      vm.Form = Form;
      vm.saveData = updateData;
      vm.hasChild = data.hasChild==1 ? true : false;
      vm.dialogClose = dialogClose;
      vm.listType = [ {slug: 'firstday',name:'First Day'},
                      {slug: 'orientation',name:'Orientation'},
                      {slug: 'overview',name:'Overview'}
                    ];
      
      activate();

      function activate() {
        vm.disableTitle = data.item_name=='Working Tools, Equipment, Facility' ? true : false;
        vm.title   = data.item_name;
        vm.description = data.description;
        vm.type = data.type;
        Form.initialForm();
        Form.setObject(Onboarding);
      }

      function updateData(ev, frm) {
        angular.element.blockUI();
        
        vm.Form.objForm.id = data.id;
        vm.Form.objForm.title = vm.title;
        vm.Form.objForm.description = vm.description;
        vm.Form.objForm.type = vm.type;
        var response = Form.saveData('saveResourceCategory', frm, Onboarding);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            
            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.messages)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }
    }
  })();
  
(function() {
    'use strict';
    angular
      .module('app.onboarding.resource.category')
      .controller('OnBoardResourceCategoryDetailController', OnBoardResourceCategoryDetailController);
  
    OnBoardResourceCategoryDetailController.$inject = ['$mdDialog','AppAPI','Auth','data','$sce'];
    /** @ngInject */
    function OnBoardResourceCategoryDetailController($mdDialog,AppAPI,Auth,data,$sce
    ) {
      var vm = this;
      var news = AppAPI.Onboarding();
      vm.dialogClose = dialogClose;
      vm.doc_type=false;
      activate();
  
      function activate() {
        if(data.file_path!=null){
          if (data.file_path.slice(-3) === 'pdf') {
              vm.doc_type = true;
              vm.video_type = false;
          }
          vm.url = 'api/'+data.file_path+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }
      }

      function dialogClose() {
        $mdDialog.hide();
        // $window.location.reload();
      }
    }
  })();
(function ()
{
    'use strict';

    angular
        .module('app.onboarding.orientation', ['dataGrid'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.app_onboarding_orientation', {
                url    : '/onboarding/orientation',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/onboarding/onboarding-orientation/onboarding-orientation.html',
                        controller: 'OnBoardOrientationController as vm'
                    }
                }
            });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.onboarding.orientation')
        .controller('viewOrientationController', viewOrientationController);

    viewOrientationController.$inject = ['$mdDialog','data','$localStorage','config','AppAPI','DataService'];

    /* @ngInject */
    function viewOrientationController($mdDialog,data,$localStorage,config,AppAPI,DataService) {
        var vm = this; 

        var news = AppAPI.News();
        vm.closeModal=closeModal;
        vm.listData=data.logReader;

        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.items = [];

        // loadData(1);

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadData(pageno) {
        var resp = vm.DataTables.loadData(news, pageno, {
            action: 'viewReaderLog',news_id:data.id
        });
    
        resp.then(function(data) {
            vm.companyList=data.readerByCompany;
            vm.selected = [];
            vm.items = data.list;
        });
        }
    }
})();
(function() {
    'use strict';
    angular
      .module('app.onboarding.orientation')
      .controller('OnBoardOrientationController', OnBoardOrientationController);
  
    OnBoardOrientationController.$inject = ['AppAPI','Auth','$state'];
    /** @ngInject */
    function OnBoardOrientationController(AppAPI,Auth,$state) 
    {
      var vm = this;
      var Onboarding = AppAPI.Onboarding();
      vm.viewDetail = viewDetail;
      Auth.setToken();

      loadData();

      function loadData() {
        angular.element.blockUI();
        var dataPromise = Onboarding.query({action:'viewData',type:'orientation'});
        dataPromise.$promise.then(fetchData);
        dataPromise.$promise.catch(errorFetch); 
      }

      function fetchData(data) {
        vm.listInput = data[0].data;
        angular.element.unblockUI();
      }

      function errorFetch() {
        vm.listInput = [];
        angular.element.unblockUI();
      }

      function viewDetail(item,ev)
      {
        var id = encodeURIComponent(window.btoa(item.id));
        var subject = item.subject;
        $state.go('app.app_onboarding_orientation_detail',{id: id,subject:subject});
      }
    }
  })();  
(function ()
{
    'use strict';

    angular
        .module('app.onboarding.orientation.detail', ['dataGrid'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.app_onboarding_orientation_detail', {
                url    : '/onboarding/orientation/:id/:subject',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/onboarding/onboarding-orientation-detail/onboarding-orientation-detail.html',
                        controller: 'OnBoardOrientationDetailController as vm'
                    }
                }
            });

    }
})();
(function() {
    'use strict';
    angular
      .module('app.onboarding.orientation.detail')
      .controller('OnBoardOrientationDetailController', OnBoardOrientationDetailController);
  
    OnBoardOrientationDetailController.$inject = ['$mdDialog','AppAPI','Auth','$state','$stateParams','Form','$localStorage'];
    /** @ngInject */
    function OnBoardOrientationDetailController($mdDialog,AppAPI,Auth,$state,$stateParams,Form,$localStorage) 
    {
      var vm = this;
      var Onboarding  = AppAPI.Onboarding();
      vm.viewDetail   = viewDetail;
      vm.isComplete   = true;
      vm.subHeader    = $stateParams.subject;
      vm.submitData   = submitData;
      vm.Form         = Form;
      
      Auth.setToken();

      loadData();

      function loadData() {
        angular.element.blockUI();
        var dataPromise = Onboarding.query({action:'viewCategoryDetail',category_id:$stateParams.id,type:'orientation'});
        dataPromise.$promise.then(fetchData);
        dataPromise.$promise.catch(errorFetch); 
      }

      function fetchData(data) {
        vm.listInput = data[0].data;
        var sumData = vm.listInput.length;
        var sumDataEmp = 0;
        vm.listInput.forEach(function(item,index){
          if(item.is_complete==1){
            sumDataEmp +=1;
          }
        });
        if(sumData==sumDataEmp&&data[0].completed==true){
          vm.isComplete = true;
        }else if(sumData==sumDataEmp){
          vm.isComplete = false;
        }
        angular.element.unblockUI();
      }

      function errorFetch() {
        vm.listInput = [];
        angular.element.unblockUI();
      }

      function viewDetail(item,ev)
      {
        item.categoryId = $stateParams.id;
        item.isOrientation = true;
        $mdDialog.show({
            controller         : 'OnBoardUploadResourceDetailController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/onboarding/onboarding-upload-resource/onboarding-view-detail.html',
            parent: angular.element(document.body),
            clickOutsideToClose:false,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
              loadData();
            },
            locals:{ 
                data : item
            }
        }); 
      }

      function submitData(ev, frm) 
      {
        var promise = Auth.setToken();
        promise.then(function() {
          var confirm = $mdDialog
            .confirm()
            .title('Are you sure want to submit ?')
            .textContent('No change can be made once this is clicked.')
            .ariaLabel('submit dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('NO');

          $mdDialog.show(confirm).then(
            function() {
              vm.objForm = new Onboarding();
              vm.objForm.action='submitOrientation';
              vm.objForm.category_id = $stateParams.id;
              var promise = vm.objForm.$save();
              promise.then(function(data){
                if(!!data.messages)
                { 
                  vm.objForm = new Onboarding();
                  $localStorage.token=data.token;
                  showDialogInfo(ev, data);
                  loadData();
                }else
                {
                  showDialogInfo(ev, data);
                  loadData();
                }     
              });      
            },
            function() {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        });
      }

      function showDialogInfo(ev, data) 
      {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.messages)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            closeModal();
            loadData();
          });
      }

      function closeModal() {
        $mdDialog.hide();
      }
    }
  })();  
(function ()
{
    'use strict';

    angular
        .module('app.onboarding.ojt.discussion', ['dataGrid'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.app_onboarding_ojt_discussion', {
                url    : '/onboarding/ojt/discussion/:id/:subject',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/onboarding/onboarding-ojt-discussion/onboarding-ojt-discussion.html',
                        controller: 'OnBoardOjtDiscussionController as vm'
                    }
                }
            });

    }
})();
(function() {
    'use strict';
    angular
      .module('app.onboarding.ojt.discussion')
      .controller('OnBoardOjtJobdesController', OnBoardOjtJobdesController);
  
    OnBoardOjtJobdesController.$inject = ['AppAPI','$mdDialog'];
    /** @ngInject */
    function OnBoardOjtJobdesController(AppAPI,$mdDialog) 
    {
        var vm = this;
        var Onboarding  = AppAPI.Onboarding();
        vm.closeModal = closeModal;
      
        loadData();

        function loadData() {
            angular.element.blockUI();
            var dataPromise = Onboarding.query({action:'viewJobdesc'});
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listData = data[0].data.responsibilities;
            vm.whyDoes  = data[0].data.whyDoes;
            vm.whatCan  = data[0].data.whatCan;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            vm.whyDoes  = "";
            vm.whatCan  = "";
            angular.element.unblockUI();
        }

        function closeModal() {
            $mdDialog.hide();
        }
    }
})();  
(function() {
    'use strict';
    angular
      .module('app.onboarding.ojt.discussion')
      .controller('OnBoardOjtDiscussionController', OnBoardOjtDiscussionController);
  
    OnBoardOjtDiscussionController.$inject = ['$mdDialog','AppAPI','Auth','$state','$stateParams','Form','$localStorage'];
    /** @ngInject */
    function OnBoardOjtDiscussionController($mdDialog,AppAPI,Auth,$state,$stateParams,Form,$localStorage) 
    {
      var vm = this;
      var Onboarding  = AppAPI.Onboarding();
      vm.viewDetail   = viewDetail;
      vm.editData     = editData;
      vm.saveData     = saveData;
      vm.deleteData   = deleteData;
      vm.Input        = Input;
      vm.disableAct   = false
      vm.subHeader    = $stateParams.subject;
      vm.submitData   = submitData;
      vm.jobdes       = jobdes;
      vm.closeModal   = closeModal;
      vm.Form         = Form;
      vm.viewComment  = viewComment
      vm.isComment    = false;
      vm.targetList   = [ {'id':'30 Day','name':'30 Day'},
                          {'id':'60 Day','name':'60 Day'},
                          {'id':'90 Day','name':'90 Day'}];

      Auth.setToken();

      loadData();

      function loadData() {
        angular.element.blockUI();
        var dataPromise = Onboarding.query({action:'viewDiscussion',category_id:$stateParams.id});
        dataPromise.$promise.then(fetchData);
        dataPromise.$promise.catch(errorFetch); 
      }

      function fetchData(data) {
        vm.listData = data[0].data;
        var sumData = vm.listData.length;
        var sumDataEmp = 0;
        vm.listData.forEach(function(item,index){
          if(item.is_complete==1){
            sumDataEmp +=1;
          }
        });
        if(data[0].completed==true){
          vm.disableAct = true;
        }
        if(data[0].comment!=null){
          vm.isComment = true;
          vm.comment   = data[0].comment;
        }
        angular.element.unblockUI();
      }

      function errorFetch() {
        vm.listData = [];
        angular.element.unblockUI();
      }

      function viewDetail(item,ev)
      {
        $mdDialog.show({
            controller         : 'viewOrientationController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/onboarding/onboarding-orientation/view-detail.html',
            parent: angular.element(document.body),
            clickOutsideToClose:false,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
              var promise = Auth.setToken();
              promise.then(function() {

                vm.objForm = new Onboarding();
                vm.objForm.action='saveCategoryItem';
                vm.objForm.id=item.id;
                vm.objForm.category_id=$stateParams.id;
                var promise2 = vm.objForm.$save();
                promise2.then(function(data)
                {
                  if(!!data.messages)
                  { 
                    vm.objForm = new Onboarding();
                    $localStorage.token=data.token;
                  }     
                  loadData();
                }); 
              });
            },
            locals:{ 
                data : item
            }
        }); 
      }
      
      function jobdes(ev)
      {
        $mdDialog.show({
            controller         : 'OnBoardOjtJobdesController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/onboarding/onboarding-ojt-discussion/onboarding-ojt-jobdes.html',
            parent: angular.element(document.body),
            clickOutsideToClose:false,
            fullscreen: true
        }); 
      }

      function submitData(ev) 
      {
        angular.element.blockUI();
        var promise = Auth.setToken();
        promise.then(function() {
          var confirm = $mdDialog
            .confirm()
            .title('Are you sure want to submit ?')
            .textContent('No change can be made once this is clicked.')
            .ariaLabel('submit dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('NO');

          $mdDialog.show(confirm).then(
            function() {
              angular.element.blockUI();
              vm.objForm = new Onboarding();
              vm.objForm.action='submitDiscussion';
              vm.objForm.id = $stateParams.id;
              var promise = vm.objForm.$save();
              promise.then(function(data){
                if(!!data.messages)
                { 
                  vm.objForm = new Onboarding();
                  $localStorage.token=data.token;
                  angular.element.unblockUI();
                  showDialogInfo(ev, data);
                }else
                {
                  angular.element.unblockUI();
                  showDialogInfo(ev, data);
                }     
              });      
            },
            function() {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        });
      }

      function showDialogInfo(ev, data) 
      {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.messages)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            closeModal();
            loadData();
          });
      }

      function closeModal() {
        $mdDialog.hide();
      }

      function Input(ev)
      {
          $mdDialog.show({
              controller         : 'OnBoardOjtDiscussionController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/onboarding/onboarding-ojt-discussion/onboarding-ojt-discussion-form.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData();
              }
          }); 

      }

      function editData(ev,data)
      {
        $mdDialog.show({
              controller         : 'OnBoardOjtDiscussionEditController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/onboarding/onboarding-ojt-discussion/onboarding-ojt-discussion-form.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData();
              },
              locals:{
                data:data
              }
          });  
      }

      function saveData(ev, frm) {
        angular.element.blockUI();
        vm.objForm = new Onboarding();
        vm.objForm.action='saveDiscussion';
        vm.objForm.roles = vm.role;
        vm.objForm.skill_required = vm.skill;
        vm.objForm.action_plan = vm.actionplan;
        vm.objForm.result = vm.result;
        vm.objForm.target_date = vm.targetdate;
        vm.objForm.id = $stateParams.id;
        var promise = vm.objForm.$save();
        promise.then(function(data){
          if(!!data.messages)
          { 
            vm.objForm = new Onboarding();
            $localStorage.token=data.token;
          }

          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);  
        });
      }

      function deleteData(ev, id) 
      {
          var promise = Auth.setToken();
          promise.then(function() {
          var confirm = $mdDialog
              .confirm()
              .title('Are you sure want to delete ?')
              .textContent('Your selected data will be deleted and can not recovered.')
              .ariaLabel('Delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('NO');

          $mdDialog.show(confirm).then(
              function() {
              vm.objForm = new Onboarding();
              vm.objForm.action='deleteDiscussion';
              vm.objForm.id = $stateParams.id;
              vm.objForm.data_id = id;
              var promise = vm.objForm.$save();
              promise.then(function(data){
                  if(!!data.messages)
                  { 
                    vm.objForm = new Onboarding();
                    $localStorage.token=data.token;
                    showDialogInfo(ev, data);
                    loadData();
                  }else
                  {
                    showDialogInfo(ev, data);
                    loadData();
                  }     
              });      
              },
              function() {
              // $scope.status = 'You decided to keep your debt.';
              }
          );
          });
      }

    function viewComment(ev)
    {
        vm.obj = {};
        vm.obj.comment   = vm.comment;
        vm.obj.stateView = true;
        var template = 'app/main/onboarding/onboarding-discussion-approval/reject-comment.html';
        $mdDialog.show({
          controller         : 'OnbDiscussionRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : template,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
            loadData();
            vm.obj=[];
          },
          locals:{
            data:vm.obj
          }
        });
      }
    }
  })();  
(function() {
    'use strict';

    angular
        .module('app.onboarding.ojt.discussion')
        .controller('OnBoardOjtDiscussionEditController', OnBoardOjtDiscussionEditController);

    OnBoardOjtDiscussionEditController.$inject = ['$mdDialog','data','$localStorage','AppAPI','$state','$stateParams','Auth'];

    /* @ngInject */
    function OnBoardOjtDiscussionEditController($mdDialog,data,$localStorage,AppAPI,$state,$stateParams,Auth) {
        var vm = this; 

        var Onboarding = AppAPI.Onboarding();
        vm.closeModal=closeModal;

        function closeModal()
        {
            $mdDialog.hide();
        }

        vm.role = data.roles;
        vm.skill = data.skill_required;
        vm.actionplan = data.action_plan;
        vm.result = data.result;
        vm.targetdate = data.target_date;
        vm.targetList = [{'id':'30 Day','name':'30 Day'},
                         {'id':'60 Day','name':'60 Day'},
                         {'id':'90 Day','name':'90 Day'}];
        
        vm.saveData = saveData;

        function saveData(ev, frm) {
            var promise = Auth.setToken();
            promise.then(function() {
                angular.element.blockUI();
                vm.objForm = new Onboarding();
                vm.objForm.action='saveDiscussion';
                vm.objForm.roles = vm.role;
                vm.objForm.skill_required = vm.skill;
                vm.objForm.action_plan = vm.actionplan;
                vm.objForm.result = vm.result;
                vm.objForm.target_date = vm.targetdate;
                vm.objForm.id = $stateParams.id;
                vm.objForm.data_id = data.id;
                var promise = vm.objForm.$save();
                promise.then(function(data){
                if(!!data.messages)
                { 
                    vm.objForm = new Onboarding();
                    $localStorage.token=data.token;
                }
        
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
                loadData();    
                });
            });
        }

        function loadData() {
            angular.element.blockUI();
            var dataPromise = Onboarding.query({action:'viewDiscussion'});
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch); 
        }
    
        function fetchData(data) {
            vm.listData = data[0].data;
            var sumData = vm.listData.length;
            var sumDataEmp = 0;
            vm.listData.forEach(function(item,index){
              if(item.is_complete==1){
                sumDataEmp +=1;
              }
            });
            if(sumData==sumDataEmp&&data[0].completed==true){
              vm.isComplete = true;
              vm.disableAct = true;
            }else if(sumData==sumDataEmp){
              vm.isComplete = false;
            }
            angular.element.unblockUI();
        }
    
        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function showDialogInfo(ev, data) 
        {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.messages)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function() {
                    closeModal();
                    loadData();
                });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.onboarding.ojt', ['dataGrid','ui.tinymce'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.app_onboarding_ojt', {
                url    : '/onboarding/ojt',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/onboarding/onboarding-ojt/onboarding-ojt.html',
                        controller: 'OnBoardOjtController as vm'
                    }
                }
            });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.onboarding.ojt')
        .controller('viewOjtController', viewOjtController);

    viewOjtController.$inject = ['$mdDialog','type','data','$localStorage','AppAPI','Auth'];

    /* @ngInject */
    function viewOjtController($mdDialog,type,data,$localStorage,AppAPI,Auth) {
        var vm = this; 
        var Onboarding = AppAPI.Onboarding();
        Auth.setToken();
        vm.closeModal=closeModal;
        vm.discussionList = [];
        vm.status='3';

        if(type=="30day"){
            getLearning();
            vm.header = 'My 30 Days Learning Progress';
            vm.supervisor = true;
        }else if(type=="60day"){
            getLearning();
            vm.header = 'My 60 Days Learning Progress';
            vm.supervisor = true;
        }else if(type=="90day"){
            getLearning();
            vm.header = 'My 90 Days Learning Progress';
            vm.supervisor = true;
        }else if(type=="feedback"){
            getLearning();
            vm.header = 'System Feedback (end of third month)';
            vm.supervisor = true;
        }

        vm.isComplete    = false;
        vm.readyToSubmit = vm.readyToRead = true;
        vm.completedAt  = "";
        vm.processLearning = processLearning;
        vm.processFeedback = processFeedback;
        vm.qs1 = vm.qs2 = vm.qs3 = vm.qs4 = vm.fg1 = vm.fg2 = vm.fg3 = vm.fg4 = "";
        vm.tinymceOptions = {
            height: 150,
            theme: 'modern',
            plugins: 'advlist lists',
            toolbar1: 'numlist',
            templates: [],
        };

        loadData();

        function closeModal()
        {
            $mdDialog.hide();
        }
        
        function processLearning(ev,action)
        {
            var promise = Auth.setToken();
            promise.then(function() {
                angular.element.blockUI();
                vm.objForm = new Onboarding();
                if(typeof vm.ojt!='undefined'){
                    vm.objForm.register_id = vm.ojt.register_id;
                }
                if(action=='save'){
                    vm.objForm.action='saveLearning';
                }else if(action=='submit'){
                    vm.objForm.action='submitLearning';
                }else if(action=='completed'){
                    vm.objForm.action='completedLearning';

                }
                
                vm.objForm.id=data.id;
                vm.objForm.ans1=vm.ans1;
                vm.objForm.ans2=vm.ans2;
                vm.objForm.ans3=vm.ans3;
                vm.objForm.ans4=vm.ans4;
                vm.objForm.fg1=vm.fg1;
                vm.objForm.fg2=vm.fg2;
                vm.objForm.fg3=vm.fg3;
                vm.objForm.fg4=vm.fg4;
                vm.objForm.spv_comment=vm.spvComment;
                vm.objForm.type=type;
                if(action=='submit' && (vm.ans1==null || vm.ans1=="" || vm.ans2==null || vm.ans2=="" || vm.ans3==null || vm.ans3=="" || vm.ans4==null || vm.ans4=="")){
                    var notification = {'title' : 'Failed',
                                'messages' : 'Please complete this form !'}
                    
                    showDialogInfo(ev, notification)
                }else{
                    var promise = vm.objForm.$save();
                    promise.then(function(data){
                        if(!!data.messages)
                        { 
                            vm.objForm = new Onboarding();
                            $localStorage.token=data.token;
                            showDialogInfo(ev, data);
                        }
                    });       
                }
            });
        }

        function processFeedback(ev,frm)
        {
            var promise = Auth.setToken();
            promise.then(function() {
                vm.objForm = new Onboarding();
                vm.objForm.action='saveFeedback';
                vm.objForm.id=data.id;
                vm.objForm.feedback=vm.feedback;
                vm.objForm.type=type;
                var promise = vm.objForm.$save();
                promise.then(function(data){
                    if(!!data.messages)
                    { 
                        vm.objForm = new Onboarding();
                        $localStorage.token=data.token;
                    }
                    showDialogInfo(ev, data);
                });
            });
        }

        function getLearning() {
            angular.element.blockUI();
            var dataPromise = Onboarding.query({action:'viewLearning',type:type,id:data.id});
            dataPromise.$promise.then(fetchLearning);
            dataPromise.$promise.catch(errorLearning); 
        }
        function fetchLearning(data) {
            vm.ojt = data[0].data[0];
            vm.empName        = data[0].userInfo.emp_name;
            vm.spvName        = data[0].userInfo.spv_name;
            vm.superordinate  = data[0].userInfo.superordinate;
            vm.subordinate    = data[0].userInfo.subordinate;
            vm.discussionList = data[0].discussionList;
            if(typeof vm.ojt!='undefined'){
                vm.status=vm.ojt.status;
                vm.completed=vm.ojt.is_completed==1 ? true : false;
                if(data[0].completed==true&& vm.ojt.readyToSubmit==true){
                    vm.isComplete = vm.readyToSubmit = true;
                }else if(data[0].completed==false&& vm.ojt.readyToSubmit==true){
                    vm.readyToSubmit = false;
                }else if(data[0].completed==true&& vm.ojt.readyToSubmit==true&& vm.ojt.readyToRead==false){
                    vm.isComplete = vm.readyToSubmit = true;
                } 
                if(data[0].completed==true&& vm.ojt.readyToSubmit==true&& vm.ojt.readyToRead==true&& vm.ojt.is_read_comment==0){
                    vm.readyToRead = false;
                }
                vm.ans1 = vm.ojt.ans1;
                vm.ans2 = vm.ojt.ans2;
                vm.ans3 = vm.ojt.ans3;
                vm.ans4 = vm.ojt.ans4;
                vm.spvComment = vm.ojt.spv_comment;
                
                if(type=='feedback'){
                    vm.feedback = vm.ojt.qa;
                }
            }
            angular.element.unblockUI();
        }
        function errorLearning() {
            vm.ojt = {};
            angular.element.unblockUI();
        }

        function loadData() {
            angular.element.blockUI();
            var dataPromise = Onboarding.query({action:'viewLearningQuestion'});
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch); 
        }
    
        function fetchData(data) {
            vm.listData = data[0].data;
            
            vm.qs1 = vm.listData[0].description;
            vm.qs2 = vm.listData[1].description;
            vm.qs3 = vm.listData[2].description;
            vm.qs4 = vm.listData[3].description;
            vm.fg1 = vm.listData[0].flag;
            vm.fg2 = vm.listData[1].flag;
            vm.fg3 = vm.listData[2].flag;
            vm.fg4 = vm.listData[3].flag;
            
            var sumData = vm.listData.length;
            var sumDataEmp = 0;
            vm.listData.forEach(function(item,index){
              if(item.is_complete==1){
                sumDataEmp +=1;
              }
            });
            if(data[0].completed==true){
              vm.disableAct = true;
            }
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function showDialogInfo(ev, data) 
        {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.messages)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function() {
                    closeModal();
                });
        }
    }
})();
(function() {
    'use strict';
    angular
      .module('app.onboarding.ojt')
      .controller('OnBoardOjtController', OnBoardOjtController);
  
    OnBoardOjtController.$inject = ['$mdDialog','$localStorage','AppAPI','Auth','$state'];
    /** @ngInject */
    function OnBoardOjtController($mdDialog,$localStorage,AppAPI,Auth,$state) 
    {
      var vm = this;
      var Onboarding = AppAPI.Onboarding();
      vm.viewDetail = viewDetail;
      Auth.setToken();

      loadData();

      function loadData() {
        angular.element.blockUI();
        var dataPromise = Onboarding.query({action:'viewData',type:'ojt'});
        dataPromise.$promise.then(fetchData);
        dataPromise.$promise.catch(errorFetch); 
      }
      function fetchData(data) {
        vm.listInput = data[0].data;
        angular.element.unblockUI();
      }
      function errorFetch() {
        vm.listInput = [];
        angular.element.unblockUI();
      }

      function viewDetail(item,ev)
      {
        var type = item.type.split("-");
        if(item.is_complete_before==1&&item.expired==0){
          if(type[1]=='1on1'){
            var id = encodeURIComponent(window.btoa(item.id));
            var subject = item.subject;
            $state.go('app.app_onboarding_ojt_discussion',{id: id,subject:subject});
          }else if(type[1]=='feedback'){
            var template = 'app/main/onboarding/onboarding-ojt/view-feedback.html';
            $mdDialog.show({
              controller         : 'viewOjtController',
              controllerAs       : 'vm',
              templateUrl        : template,
              parent: angular.element(document.body),
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                loadData();
              },
              locals:{ 
                  data : item,
                  type : type[1]
              }
            });
          }else{
            var template = 'app/main/onboarding/onboarding-ojt/view-mylearning.html';
            $mdDialog.show({
              controller         : 'viewOjtController',
              controllerAs       : 'vm',
              templateUrl        : template,
              parent: angular.element(document.body),
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                loadData();
              },
              locals:{ 
                  data : item,
                  type : type[1]
              }
            });
          } 
        }
      }
    }
  })();  
(function ()
{
    'use strict';

    angular
        .module('app.onboarding.firstday', ['dataGrid'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.app_onboarding_firstday', {
                url    : '/onboarding/firstday',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/onboarding/onboarding-firstday/onboarding-firstday.html',
                        controller: 'OnBoardFirstdayController as vm'
                    }
                }
            });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.onboarding.firstday')
        .controller('viewFirstDayController', viewFirstDayController);

    viewFirstDayController.$inject = ['$mdDialog','data','$localStorage','AppAPI','Auth'];

    /* @ngInject */
    function viewFirstDayController($mdDialog,data,$localStorage,AppAPI,Auth) {
        var vm = this; 

        var Onboarding = AppAPI.Onboarding();
        vm.closeModal=closeModal;
        
        vm.isComplete = true;
        vm.loadData = loadData;
        vm.header = data.subject;
        vm.changeStatus = changeStatus;
        vm.submitData = submitData;
        vm.selected = [];
        vm.items = [];

        loadData();

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadData() {
            var id = encodeURIComponent(window.btoa(data.id));
            var dataPromise = Onboarding.query({action:'viewCategoryDetail',category_id:id,type:'firstday'});
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listInput = data[0].data;
            var sumData = vm.listInput.length;
            var sumDataEmp = 0;
            var tempData = {};
            vm.listInput.forEach(function(item,index){
                if(item.is_complete==1){
                    sumDataEmp +=1;
                    tempData[item.id] = true
                }
            });
            vm.changeComplete = tempData;
            vm.noChange = data[0].completed;
            if(sumData==sumDataEmp&&data[0].completed==true){
                vm.isComplete = true;
            }else if(sumData==sumDataEmp){
                vm.isComplete = false;
            }else{
                vm.isComplete = true;
            }
            // vm.isComplete = (vm.header=="Working Tools, Equipment, Facility") ? false : true;
            // angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listInput = [];
            // angular.element.unblockUI();
        }

        function changeStatus(item)
        {
            var id = encodeURIComponent(window.btoa(data.id));
            var promise = Auth.setToken();
            promise.then(function() {
                vm.objForm = new Onboarding();
                vm.objForm.action='saveCategoryItem';
                vm.objForm.type='firstDay';
                vm.objForm.id=item.id;
                vm.objForm.category_id=id;
                var promise2 = vm.objForm.$save();
                promise2.then(function(data)
                {
                    if(!!data.messages){ 
                        vm.objForm = new Onboarding();
                        $localStorage.token=data.token;
                    }     
                    loadData();
                }); 
            });
        }

        function submitData(ev, frm) 
        {
            var promise = Auth.setToken();
            promise.then(function() 
            {
                vm.objForm = new Onboarding();
                vm.objForm.action='saveData';
                vm.objForm.id=data.id;
                vm.objForm.type=data.type;
                vm.objForm.is_submit=true;
                var promise2 = vm.objForm.$save();
                promise2.then(function(data)
                {
                    showDialogInfo(ev, data);     
                    loadData();
                });      
            });
        }

        function showDialogInfo(ev, data) 
        {
            $mdDialog
            .show(
                $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(data.title)
                .textContent('Submit data has been successfully')
                .ariaLabel(data.title)
                .ok('OK')
                .targetEvent(ev)
            )
            .then(function() {
                closeModal();
                loadData();
            });
        }
    }
})();
(function() {
    'use strict';
    angular
      .module('app.onboarding.firstday')
      .controller('OnBoardFirstdayController', OnBoardFirstdayController);
  
    OnBoardFirstdayController.$inject = ['$document','$mdDialog','$localStorage','$window','$timeout','AppAPI','Auth','config','Approvalinfo','Newsinfo','$state'];
    /** @ngInject */
    function OnBoardFirstdayController($document,$mdDialog,$localStorage,$window,$timeout,AppAPI,Auth,config,Approvalinfo,Newsinfo,$state) 
    {
      var vm = this;
      var Onboarding = AppAPI.Onboarding();
      vm.viewDetail = viewDetail;
      Auth.setToken();

      loadData();

      function loadData() {
        angular.element.blockUI();
        var dataPromise = Onboarding.query({action:'viewData',type:'firstday'});
        dataPromise.$promise.then(fetchData);
        dataPromise.$promise.catch(errorFetch); 
      }

      function fetchData(data) {
        vm.listInput = data[0].data;
        angular.element.unblockUI();
      }

      function errorFetch() {
        vm.listInput = [];
        angular.element.unblockUI();
      }

      function viewDetail(item,ev)
      {
        $mdDialog.show({
            controller         : 'viewFirstDayController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/onboarding/onboarding-firstday/view-detail.html',
            parent: angular.element(document.body),
            clickOutsideToClose:false,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
              loadData();
            },
            locals:{ 
                data : item
            }
        }); 
      }
    }
  })();  
(function () {
  'use strict';

  angular
      .module('app.onboarding.feedback', [])
       .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.app_onboarding_feedback', {
              url: '/onboarding/feedback',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/onboarding/onboarding-feedback/onboarding-feedback.html',
                      controller: 'OnBoardFeedbackController as vm'
                  }
              }
          });
  }
 })();

(function() {
  'use strict';
  angular
    .module('app.onboarding.feedback')
    .controller('OnBoardFeedbackController', OnBoardFeedbackController);

  OnBoardFeedbackController.$inject = ['$document','DataService','$localStorage','$mdDialog','AppAPI','Auth','Form','config','FileUploader','$http','$sce'];
  /** @ngInject */
  function OnBoardFeedbackController($document,DataService,$localStorage,$mdDialog,AppAPI,Auth,Form,config,FileUploader,$http,$sce) 
  {
    var vm = this;
    var Onboarding = AppAPI.Onboarding();

    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.items = [];
    vm.searchText = null;
    vm.listSelected = [];
    vm.Form = Form;
    vm.dialogClose = dialogClose;
    
    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      Form.initialForm();
      Form.setObject(Onboarding);
    }
    
    function loadData(pageno) {
      // var resp = vm.DataTables.loadDatas(Onboarding, pageno, {
      //   action: 'viewLearning'
      // });

      // resp.then(function(data) {
      //   vm.selected = [];
      //   vm.items = data.list;  
      //   vm.admin = data.isAdmin;
      // });
      angular.element.blockUI();
      var dataPromise = Onboarding.query({action:'viewLearning',type:'feedback',isFeedback:'1'});
      dataPromise.$promise.then(fetchLearning);
      dataPromise.$promise.catch(errorLearning); 
    }
    function fetchLearning(data) {
      data[0].data.forEach(function(value){
        var newObj = {};
        newObj.nik = value.nik
        newObj.name = value.name
        newObj.feedback = $sce.trustAsHtml(value.qa)
        
        vm.items.push(newObj);
      })
      console.log(vm.items);
        
      angular.element.unblockUI();
    }
    function errorLearning() {
        vm.items = [];
        angular.element.unblockUI();
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.onboarding.discussion.approval', ['dataGrid'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.app_onboarding_discussion_approval', {
                url    : '/onboarding/discussion-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/onboarding/onboarding-discussion-approval/onboarding-discussion-approval.html',
                        controller: 'OnBoardDiscussionApprovalController as vm'
                    }
                }
            });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.onboarding.discussion.approval')
        .controller('OnbDiscussionRejectCommentController', OnbDiscussionRejectCommentController);

    OnbDiscussionRejectCommentController.$inject = ['$localStorage','data','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function OnbDiscussionRejectCommentController($localStorage,data,$mdDialog,Form,AppAPI,$log,FileUploader,config) 
    {
        var vm = this; 
        
        Form.initialForm();

        if('stateView' in data){
            vm.stateView = true;
            vm.viewComment = data.comment;
        }
        var Onboarding = AppAPI.Onboarding();

        vm.closeModal = closeModal;
        vm.saveData=saveData; 

        function saveData(ev,formController)
        { 
            angular.element.blockUI();
            var jum=data.length,i,ids=[];
            var Onboard= new Onboarding();
            Onboard.data=[];
            Onboard.action='updateDiscussionApproval';
            Onboard.type='reject';
            Onboard.comment=vm.comment;
            for (i=0;i<jum;i++) {
                Onboard.data.push({id:data[i].id});
            }
            var idtx=encodeURIComponent(angular.toJson(ids));
            var response=Onboard.$save(); 
            response.then(function(data){
                showDialogInfo(ev, data)
                angular.element.unblockUI();
            });
            response.catch(function(data){
                showDialogInfo(ev, data)
                angular.element.unblockUI();
            });
        }

        function showDialogInfo(ev, data) 
        {
            $mdDialog
            .show(
                $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(data.title)
                .textContent(data.messages)
                .ariaLabel(data.title)
                .ok('OK')
                .targetEvent(ev)
            )
            .then(function() {
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function() {
    'use strict';
    angular
      .module('app.onboarding.discussion.approval')
      .controller('OnBoardDiscussionApprovalController', OnBoardDiscussionApprovalController);
  
    OnBoardDiscussionApprovalController.$inject = ['$mdDialog','AppAPI','Auth','$state','$stateParams','Form','$localStorage','DataService','$location','$window','config'];
    /** @ngInject */
    function OnBoardDiscussionApprovalController($mdDialog,AppAPI,Auth,$state,$stateParams,Form,$localStorage,DataService,$location,$window,config) 
    {
      var vm = this;
      var Onboarding  = AppAPI.Onboarding();
      vm.viewDetail   = viewDetail;
      vm.disableAct   = false;
      vm.loadData     = loadData;
      vm.Form         = Form;
      vm.listJum      = [2,5,25,50,75,100,200];
      vm.DataTable    = new DataService();
      vm.toggleSelectedAll=toggleSelectedAll;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.approve = approve;
      vm.reject = reject;
      vm.status = '0';
      vm.listSelected=[];
      vm.appstatus = [{'value':'0','name':'Waiting Approval'},
                      {'value':'1','name':'Approved'},
                      {'value':'2','name':'Rejected'}];
      Auth.setToken();

      loadData(1);

      function loadData(pageno)
      {
        var resp = vm.DataTable.loadDatas(Onboarding,pageno,{action:'viewDiscussionApproval',status:vm.status});
        vm.listSelected=[];
      }

      function viewDetail(item,status,ev)
      {
        item.status = status;
        var template = 'app/main/onboarding/onboarding-discussion-approval/view-target.html';
        $mdDialog.show({
          controller         : 'onboardDiscApprovalController',
          controllerAs       : 'vm',
          templateUrl        : template,
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
            loadData();
          },
          locals:{ 
              data : item
          }
        }); 
      }

      function showDialogInfo(ev, data) 
      {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.messages)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            closeModal();
            loadData();
          });
      }

      function closeModal() {
        $mdDialog.hide();
      }

      function toggleSelectedAll(state)
      {
        // console.log(state);
          switch(state)
          {
              case true:
              checkAll();
              break;
              case false:
              unCheckAll();
              break;
          }
      }

      function checkAll() {
        vm.listSelected=angular.copy(vm.DataTable.list);
     }

     function unCheckAll() {
        vm.listSelected=[];
     }

     function isChecked(ls)
      {
          return vm.listSelected.indexOf(ls) > -1;
      }

    function toggleCheck(ls, event)
    {
      if ( event )
      {
          event.stopPropagation();
      }

      var idx = vm.listSelected.indexOf(ls);

      if ( idx > -1 )
      {
          vm.listSelected.splice(idx, 1);
      }
      else
      {
          vm.listSelected.push(ls);
      }
    }

    function approve(ev,type)
    {
      var jum=vm.listSelected.length,i,ids=[];
      if(jum>0)
      {
        var promise=Auth.setToken();
        promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('Approve dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
            multiple: true
          });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var Onboard= new Onboarding();
                Onboard.data=[];
                Onboard.action='updateDiscussionApproval';
                Onboard.type=type;
                for (i=0;i<jum;i++) {
                  Onboard.data.push({id:vm.listSelected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=Onboard.$save(); 
                response.then(function(data){
                  showDialogInfo(ev, data)
                  angular.element.unblockUI();
                });
                response.catch(function(data){
                  showDialogInfo(ev, data)
                  angular.element.unblockUI();
                });
            }, function() {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      }else{
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Attention!')
        .textContent('No data selected')
        .ariaLabel('Attention')
        .ok('close')
        .targetEvent(ev)
        ).then(function(){
            loadData();
        });
      } 
    }
    
    function reject(ev)
    {
      var jum=vm.listSelected.length,i,ids=[];
      if(jum>0)
      {
        var template = 'app/main/onboarding/onboarding-discussion-approval/reject-comment.html';
        $mdDialog.show({
          controller         : 'OnbDiscussionRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : template,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
            loadData();
            vm.listSelected=[];
          },
          locals:{
            data:vm.listSelected
          }
      });
      }else{
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Attention!')
        .textContent('No data selected')
        .ariaLabel('Attention')
        .ok('close')
        .targetEvent(ev)
        ).then(function(){
            loadData();
        });
      } 
    }
  }
  })();  
(function() {
    'use strict';

    angular
        .module('app.onboarding.discussion.approval')
        .controller('onboardDiscApprovalController', onboardDiscApprovalController);

    onboardDiscApprovalController.$inject = ['$mdDialog','data','$state','$localStorage','AppAPI','Auth'];

    /* @ngInject */
    function onboardDiscApprovalController($mdDialog,data,$state,$localStorage,AppAPI,Auth) 
    {
        var vm = this; 
        var Onboarding = AppAPI.Onboarding();
        Auth.setToken();
        vm.closeModal = closeModal;
        vm.status     = data.status;
        vm.approve    = approve;
        vm.reject     = reject;
      
        loadData();

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadData() {
            angular.element.blockUI();
            var dataPromise = Onboarding.query({action:'viewDiscussionApprovalDetail',id:data.id});
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch); 
        }
    
        function fetchData(data) {
            vm.listData = data[0].data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function approve(ev,type,message)
        {
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to process this list?')
                .textContent('This selected data will be '+message+'.')
                .ariaLabel('Approval dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                multiple: true
            });      
            $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var Onboard= new Onboarding();
                    Onboard.data=[];
                    Onboard.action='updateDiscussionApproval';
                    Onboard.type=type;
                    Onboard.data.push({id:data.id});

                    var response=Onboard.$save(); 
                    response.then(function(data){
                        showDialogInfo(ev, data)
                        angular.element.unblockUI();
                    });
                    response.catch(function(data){
                        showDialogInfo(ev, data)
                    angular.element.unblockUI();
                    });
                }, function() {
                // $scope.status = 'You decided to keep your debt.';
            });
            });
        }
    
        function reject(ev)
        {
            vm.listSelected = [data];
            var template = 'app/main/onboarding/onboarding-discussion-approval/reject-comment.html';
            $mdDialog.show({
                controller         : 'OnbDiscussionRejectCommentController',
                controllerAs       : 'vm',
                templateUrl        : template,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                    vm.listSelected=[];
                },
                locals:{
                    data:vm.listSelected
                }
            }); 
        }

        function showDialogInfo(ev, data) 
        {
            $mdDialog
            .show(
                $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(data.title)
                .textContent(data.messages)
                .ariaLabel(data.title)
                .ok('OK')
                .targetEvent(ev)
            )
            .then(function() {
                closeModal();
                loadData();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.onboarding.dashboard', ['dataGrid'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.app_onboarding', {
                url    : '/onboarding/dashboard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/onboarding/onboarding-dashboard/onboarding-dashboard.html',
                        controller: 'OnBoardDashboardController as vm'
                    }
                }
            });

    }
})();
(function() {
    'use strict';
    angular
      .module('app.onboarding.dashboard')
      .controller('OnBoardEmpProgressSummaryController', OnBoardEmpProgressSummaryController);
  
    OnBoardEmpProgressSummaryController.$inject = ['$mdDialog','AppAPI','Auth','$state','$stateParams','Form','$localStorage','DataService'];
    /** @ngInject */
    function OnBoardEmpProgressSummaryController($mdDialog,AppAPI,Auth,$state,$stateParams,Form,$localStorage,DataService) 
    {
      var vm = this;
      var Onboarding  = AppAPI.Onboarding();
      vm.loadData     = loadData;
      vm.closeModal   = closeModal;

      Auth.setToken();

      loadData(1);
        
      function closeModal() {
        $mdDialog.hide();
      }
      
      function loadData() {
        angular.element.blockUI();
        var dataPromise = Onboarding.query({action:'viewSummary'});
        dataPromise.$promise.then(fetchData);
        dataPromise.$promise.catch(errorFetch); 
      }

      function fetchData(data) {
        vm.listData = data[0].data;
        angular.element.unblockUI();
      }

      function errorFetch() {
        vm.listData = [];
        angular.element.unblockUI();
      }
    }
  })();  
(function() {
    'use strict';
    angular
      .module('app.onboarding.dashboard')
      .controller('OnBoardDashboardController', OnBoardDashboardController);
  
    OnBoardDashboardController.$inject = ['$document','$mdDialog','$localStorage','$window','$timeout','$state','$stateParams','AppAPI','Auth','config','Approvalinfo','Newsinfo'];
    /** @ngInject */
    function OnBoardDashboardController($document,$mdDialog,$localStorage,$window,$timeout,$state,$stateParams,AppAPI,Auth,config,Approvalinfo,Newsinfo
    ) {
        var vm = this;
        var Onboarding = AppAPI.Onboarding();
        vm.isSpv = true;

        vm.reviewProgress = review;
        vm.progressStatus = progressStatus;
        vm.orientationProgress = orientation;
        vm.firstDayProgress = firstDay;
        vm.ojtProgress = ojt;
        vm.loadOverview = loadOverview;
        vm.uploadResource = uploadResource;
        vm.closeModal   = closeModal;

        loadData();

        function loadData() {
          angular.element.blockUI();
          var dataPromise = Onboarding.query({action:'viewOnbPermission'});
          dataPromise.$promise.then(fetchData);
          dataPromise.$promise.catch(errorFetch); 
        }
  
        function fetchData(data) {
          vm.firstDay    = data[0].data.firstDay
          vm.orientation = data[0].data.orientation
          vm.review      = data[0].data.review;
          vm.employee    = data[0].data.employee;
          vm.overview    = data[0].data.overview;
          vm.dashboard   = data[0].data.dashboard;
          vm.onbOverview = data[0].data.onbOverview;
          vm.oriExp      = data[0].data.oriExp;
          vm.progress    = data[0].data.progress;
          vm.resource    = data[0].data.resource;
          vm.isAdmin     = data[0].data.isAdmin;
          vm.registerId  = data[0].data.registerId;
          vm.frdProgress = data[0].data.frdProgress;
          vm.oriProgress = data[0].data.oriProgress;
          vm.ojtProgressValue = data[0].data.ojtProgress;
          
          angular.element.unblockUI();
        }
  
        function errorFetch() {
          vm.listInput = [];
          angular.element.unblockUI();
        }

        function review()
        {
          if(vm.employee&&vm.review){
            var id = encodeURIComponent(window.btoa(vm.registerId));
            var subject = 'Review';
            $state.go('app.app_onboarding_review',{id: id,subject:subject});
          }
        }
        
        function progressStatus()
        {
            if(vm.employee){
                $mdDialog.show({
                    controller         : 'OnBoardEmpProgressSummaryController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/onboarding/onboarding-dashboard/onboarding-emp-progress.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose:false,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData();
                    }
                });
            }else{
              var spv   = encodeURIComponent(window.btoa(vm.isSpv));
              $state.go('app.app_onboarding_summary',{spv:spv});
            }
        }
        
        function firstDay()
        {
          if(vm.employee){
            $state.go('app.app_onboarding_firstday');
          }

        }
        
        function orientation()
        {
          if(vm.employee&&vm.oriExp){
            $state.go('app.app_onboarding_orientation');
          }
        }
        
        function ojt()
        {
            if(vm.employee){
              $state.go('app.app_onboarding_ojt');
            }
        }
        
        function uploadResource()
        {
            if(vm.resource){
              $state.go('app.app_onboarding_upload_resource');
            }
        }

        function closeModal() {
          $mdDialog.hide();
        }
        
        function  loadOverview() 
        {
          if(vm.onbOverview){
            var data = vm.overview;
            if(data.file_path==="" || data.file_path===null){
              $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('File Not Found')
                .textContent('File not Found')
                .ariaLabel('Failed Load File')
                .ok('OK')
                ).then(function(){
                  loadData(1);
                });
            } else {
              $mdDialog.show({
                  controller         : 'OnBoardUploadResourceDetailController',
                  controllerAs       : 'vm',
                  templateUrl        : 'app/main/onboarding/onboarding-upload-resource/onboarding-view-detail.html',
                  parent: angular.element(document.body),
                  clickOutsideToClose:false,
                  fullscreen: true,
                  onRemoving:function(element, removePromise)
                  {
                      loadData(1);
                  },
                  locals:{ 
                      data : data
                  }
              });
            }
          }
        }
    }
  })();  
(function () {
  'use strict';
  
  angular
    .module('app.offboarding.ofb_registration_list', [   
      'app.offboarding.form_registration'   
    ])
    .config(config);
  
    config.$inject = ['$stateProvider', '$mdThemingProvider'];
    
    /** @ngInject */
    function config($stateProvider) {
      $stateProvider
        .state('app.ofb-registration_list',{
          url: '/ofb/registration',
          views:{
            'content@app':{
              templateUrl:'app/main/offboarding/registration/ofb-registration-list.html',
              controller: 'OfbRegistrationListController as vm'
            }
          }
        })

        .state('app.ofb-registration_detail',{
          url: '/ofb/registration/detail/:id',
          views:{
            'content@app':{
              templateUrl:'app/main/offboarding/registration/ofb-registration-detail.html',
              controller: 'OfbRegistrationDetailController as vm'
            }
          }
        });
    }
    
})();
(function(){
  'use strict';

  angular
    .module('app.offboarding.ofb_registration_list')
    .controller('OfbviewdocController', OfbviewdocController);
  
  // OfbviewdocController.$inject = ['$mdDialog', 'doc', 'id', 'Form', 'AppAPI'];
  OfbviewdocController.$inject = ['$localStorage', '$mdDialog', 'doc', 'id', 'n1', 'status', 'Form', 'AppAPI'];

  // function OfbviewdocController($mdDialog, doc, id, Form, AppAPI) 
  function OfbviewdocController($localStorage, $mdDialog, doc, id, n1, status, Form, AppAPI) 
  {
    var vm = this;
    
    var OfbRegistration = AppAPI.OfbRegistration();
    Form.setObject(OfbRegistration);
    vm.Form = Form;

    vm.closeModal = closeModal;
    vm.doc_type = false;
    vm.doc = doc;
    vm.id = id;
    vm.approval = approval;
    vm.n1 = n1;
    vm.status = status;
    vm.user = $localStorage.user;
    fetchData();

    function fetchData() 
    {
      if (doc.slice(-3) === 'pdf') {
        vm.doc_type = true;
      } else {
        vm.doc_type = false;
      }
      vm.url = 'api/ofbdocument/' + vm.doc + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=false;'; 
      
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function approval(tipe, status) {
      var responses = vm.Form.objForm.$get({ action: "setApproval", status: status, approveBy: tipe, id: vm.id });
      responses.then(function (data) {
        closeModal();
      });
    }
  }

})();
(function() {
    'use strict';

    angular
        .module('app.offboarding.ofb_registration_list')
        .controller('OfbRegistrationListController', OfbRegistrationListController);

    OfbRegistrationListController.$inject = [
        '$localStorage',
        '$state',
        '$mdDialog',
        'Auth',
        'AppAPI',
        'DataService'
    ];

    function OfbRegistrationListController(
        $localStorage,
        $state,
        $mdDialog,
        Auth,
        AppAPI,
        DataService
    ) {
        var vm = this;
        vm.DataTable = new DataService();

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.company = $localStorage.empsite;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadData = loadData;
        vm.list = [];
        vm.detail = detail;
        vm.handover = handover;
        vm.loadHandover = loadHandover;
        vm.setClearance = setClearance;
        vm.grade = 'all';
        vm.empType = 'all';
        vm.listReason = [
            '',
            'Career development',
            'C & B and dissatisfaction with management',
            'Education',
            'Entrepreneur',
            'Family',
            'Healty',
            'Unemployement',
            'Out without news',
            'Died',
            'Breaking the rule',
            'Mutation'
        ];

        var OfbRegistration = AppAPI.OfbRegistration();
        var OfbRefCheck = AppAPI.OfbRefCheck();
        var Attendance = AppAPI.Attendance();

        loadCompany();
        loadData(1);

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(OfbRegistration, pageno, {
                action: 'viewData',
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                search: vm.nik,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                reason: vm.reason,
                grade: vm.grade,
                empType: vm.empType
            });

            resp.then(processInfo);
            resp.catch(errorProcessInfo);
        }

        function processInfo(data) {
            vm.list = data.list;
        }

        function errorProcessInfo() {
            vm.list = [];
        }

        function loadCompany() {
            var response = OfbRegistration.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendance.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendance.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function detail(id) {
            $state.go('app.ofb-registration_detail', { id: id });
        }

        function handover(id, ev) {
            $mdDialog.show({
                controller: 'InputhandoverController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/offboarding/handover/form-handover/form-handover.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function loadHandover(id, ev) {
            $mdDialog.show({
                controller: 'HandoverDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offboarding/handover/handover-detail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function setClearance(id, nik, ev) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to Set Exit Clearance ?')
                    .textContent('Exit Clearance will set for this item.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });
                $mdDialog.show(confirm).then(
                    function() {
                        // angular.element.blockUI();

                        var ot = new OfbRefCheck();
                        ot.action = 'setRefcheck';
                        ot.id = id;
                        ot.nik = nik;
                        var response = ot.$save();

                        response.then(function(data) {
                            successSet(ev, data);
                            angular.element.unblockUI();
                        });
                        response.catch(function(data) {
                            failedSet(ev, data.data, id, nik);
                            angular.element.unblockUI();
                        });
                    },
                    function() {}
                );
            });
        }

        function successSet(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Success')
                        .textContent(data.pesan)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                )
                .then(function() {
                    loadData(1);
                });
        }

        function failedSet(ev, data, id, nik) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed')
                        .textContent(data.pesan)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                )
                .then(function() {
                    deactiveApprovalGroup(id, nik);
                    // $state.go('app.ofb-approval_group');
                    // loadData(1);
                });
        }

        function deactiveApprovalGroup(id, nik) {
            $mdDialog.show({
                controller: 'DeactiveApprovalGroupController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/offboarding/approval-group/deactive-approval-group.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: false,
                onRemoving: function(element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id,
                    nik: nik
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.offboarding.ofb_registration_list')
        .controller('OfbRegistrationDetailController', OfbRegistrationDetailController);
    OfbRegistrationDetailController.$inject = ['$localStorage', '$location', '$state', '$mdDialog', '$stateParams', 'Auth', 'Form', 'AppAPI', 'config'];

    function OfbRegistrationDetailController($localStorage, $location, $state, $mdDialog, $stateParams, Auth, Form, AppAPI, config) {
        var vm = this;
        Form.initialForm();

        var OfbRegistration = AppAPI.OfbRegistration();
        var OfbRefCheck = AppAPI.OfbRefCheck();

        Form.setObject(OfbRegistration);
        vm.Form = Form;
        vm.viewDocument = viewDocument;
        vm.back = back;
        vm.myNik = $localStorage.user;
        vm.approval = approval;
        vm.clearance = 1;
        vm.terminate = terminate;

        vm.baseUrl = $location.$$protocol + '://' + $location.$$host + config.api;

        vm.itForm = itForm;
        vm.loadHandover = loadHandover;
        vm.exitInterview = exitInterview;
        // vm.handover = handover;
        vm.cancel = cancel;
        vm.setClearance = setClearance;
        vm.createHandover = createHandover;

        loadData();

        function loadData() {
            angular.element.unblockUI();
            var responses = vm.Form.objForm.$get({
                action: "viewdetail",
                id: $stateParams.id
            });

            responses.then(function (data) {
                cekExitClearance();
            });
        }

        function viewDocument(ev, dataDoc, id, n1, n1Status) {
            if (dataDoc) {

                $mdDialog.show({
                    controller: 'OfbviewdocController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/offboarding/registration/ofb-view-doc.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: false,
                    onRemoving: function (element, removePromise) {
                        loadData();
                    },
                    locals: {
                        doc: dataDoc,
                        id: id,
                        n1: n1,
                        status: n1Status
                    }
                });

            } else {
                alert("Attachment not found.");
            }

        }

        function back() {
            $window.history.back();
        }

        function approval(tipe, status) {
            var responses = vm.Form.objForm.$get({
                action: "setApproval",
                status: status,
                approveBy: tipe,
                id: $stateParams.id
            });
            responses.then(function (data) {
                loadData();
            });
        }

        function cancel(id, ev) {

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you cancel this request?')
                    .textContent('Your offboarding data will be canceled.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });
                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var responses = vm.Form.objForm.$delete({
                        action: "delete",
                        id: id
                    });
                    // $state.go('app.input_ofb_employee_registration');
                    responses.then(loadData);
                }, function () {

                });
            });

        }

        function itForm(data, ev) {
            $mdDialog.show({
                controller: 'ITFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offboarding/approval-exit-clearance/it-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    data: data
                }
            });
        }

        function loadHandover(id, idCheck, ev) {
            $mdDialog.show({
                controller: 'HandoverDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offboarding/handover/handover-detail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false,
                onRemoving: function (element, removePromise) {
                    Form.setObject(OfbRegistration);
                    vm.Form = Form;
                    loadData();
                },
                locals: {
                    id: id,
                    idCheck: idCheck
                }
            });
        }

        /*function handover(id, ev) {
          $mdDialog.show({
            controller: 'InputhandoverController',
            controllerAs: 'vm',
            templateUrl: 'app/main/offboarding/handover/form-handover/form-handover.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData();
            },
            locals: {
              id: id
            }
          });
        }*/

        function exitInterview(nik) {
            $state.go('app.ofb-exit-interview-user', {
                nik: nik
            });
        }

        function cekExitClearance() {
            var response = OfbRegistration.query({
                action: 'cekExitClearance',
                id: $stateParams.id
            });
            response.$promise.then(fetchExitClearance);
            response.$promise.catch(errorExitClearance);
        }

        function fetchExitClearance(data) {
            vm.clearance = data[0].total;
        }

        function terminate(data, ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you terminate this employee?')
                    .textContent('Data your selected will be terminate.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = OfbRegistration.query({
                        action: 'setTerminate',
                        empId: data.emp_profile_id,
                        reason: data.reason,
                        effectiveDate: data.effective_date,
                        reasonDesc: data.reason_description
                    });
                    console.log(response);
                    response.$promise.then(loadData);
                    response.$promise.catch(errorTerminate);
                }, function () {

                });
            });
        }

        function errorExitClearance() {
            vm.clearance = 0;
        }

        function setClearance(id, nik, ev) {

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to Set Exit Clearance ?')
                    .textContent('Exit Clearance will set for this item.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });
                $mdDialog.show(confirm).then(function () {
                    // angular.element.blockUI();

                    var ot = new OfbRefCheck();
                    ot.action = 'setRefcheck';
                    ot.id = id;
                    ot.nik = nik;
                    var response = ot.$save();

                    response.then(function (data) {
                        successSet(ev, data);
                        angular.element.unblockUI();
                    });

                    response.catch(function (data) {
                        failedSet(ev, data.data, id, nik);
                        angular.element.unblockUI();
                    });
                }, function () { });
            });

        }

        function successSet(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                loadData();
            });

        }

        function failedSet(ev, data, id, nik) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {

                deactiveApprovalGroup(id, nik);
                // $state.go('app.ofb-approval_group');
                // loadData();
            });
        }

        function deactiveApprovalGroup(id, nik) {
            $mdDialog.show({
                controller: 'DeactiveApprovalGroupController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offboarding/approval-group/deactive-approval-group.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: false,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id,
                    nik: nik
                }
            });
        }

        function createHandover(id, ev) {
            $mdDialog.show({
                controller: 'InputhandoverController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offboarding/handover/form-handover/form-handover.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }

        function errorTerminate() {
            angular.element.unblockUI();
            loadData();
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_varklaring', [])
    .config(config);

     config.$inject = ['$stateProvider'];
  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state('app.ofb-varklaring', {
        url: '/ofb/varklaring',
        views: {
          'content@app': {
            templateUrl: 'app/main/offboarding/varklaring/varklaring.html',
            controller: 'VarklaringController as vm'
          }
        }
      });

  }

})();

(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_varklaring')
    .controller('VarklaringController', Controller);

  Controller.$inject = [
    '$mdDialog',
    'Auth',
    'AppAPI',
    'DataService',
    'Form'
  ];
  /** @ngInject */
  function Controller(
    $mdDialog,
    Auth,
    AppAPI,
    DataService,
    Form
  ) {

    var vm = this;

    var endpoint = AppAPI.OfbExitInterview(false);


  }
})();

(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_reff_checklist')
    .controller('OfbReffChecklistController', OfbReffChecklistController);

  OfbReffChecklistController.$inject = ['$mdDialog', 'Auth', 'AppAPI', 'DataService'];
  /** @ngInject */
  function OfbReffChecklistController($mdDialog, Auth, AppAPI, DataService) {
    var vm = this;
    var OfbRefCheck = AppAPI.OfbRefCheck();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.DataTableApprovalType = new DataService();
    vm.loadData = loadData;
    vm.search = "";

    vm.listUser = [];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.listModulSelected = [];
    vm.listModulSelected2 = [];
    vm.editUser = editUser;
    vm.deleteItem = deleteItem;
    vm.input = input;
    vm.inputApprovalType = inputApprovalType;
    vm.deleteItemApprovalType = deleteItemApprovalType;

    loadData(1);
    loadDataApprovalType(1);

    function loadData(pageno) {
      var resp = vm.DataTable.loadData(OfbRefCheck, pageno, { action: 'viewdata' });
      resp.then(processInfo);
      resp.catch(errorProcessInfo);
    }

    function loadDataApprovalType(pageno) {
      var resp = vm.DataTableApprovalType.loadData(OfbRefCheck, pageno, { action: 'viewdataapprovaltype' });
    }

    function processInfo(data) {
      vm.listUser = data.list;
    }

    function errorProcessInfo() {
      vm.listUser = [];
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listModulSelected = angular.copy(vm.listUser);
    }

    function unCheckAll() {
      vm.listModulSelected = [];
    }

    function editUser(data) {
      $mdDialog.show({
        controller: 'EditrefcheckController',
        controllerAs: 'vm',
        templateUrl: 'app/main/offboarding/reff-checklist/form-ref-check/form-ref-check.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          refcheck: data
        },
        onRemoving: function (element, removePromise) {
          loadData();
        }
      });

    }

    function deleteItem(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = OfbRefCheck.delete({ action: 'delete', data: angular.toJson(vm.listModulSelected) });

          response.$promise.then(loadData(1));
        }, function () {

        });
      });

    }

    function deleteItemApprovalType(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = OfbRefCheck.delete({ action: 'deleteApprovalType', data: angular.toJson(vm.listModulSelected2) });

          response.$promise.then(loadData(1));
        }, function () {

        });
      });

    }

    function input(ev) {
      $mdDialog.show({
        controller: 'InputrefcheckController',
        controllerAs: 'vm',
        templateUrl: 'app/main/offboarding/reff-checklist/form-ref-check/form-ref-check.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        }
      });
    }

    function inputApprovalType(ev) {
      $mdDialog.show({
        controller: 'InputapprovaltypeController',
        controllerAs: 'vm',
        templateUrl: 'app/main/offboarding/reff-checklist/form-approval_type/form-approval-type.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        onRemoving: function (element, removePromise) {
          loadDataApprovalType(1);
        }
      });
    }

  }
})();
(function(){
  'use strict';

  angular
  .module('app.offboarding.ofb_handover')
  .controller('OfbhandoverController', OfbhandoverController);

  OfbhandoverController.$inject = ['$localStorage', '$state', '$mdDialog', 'Auth', 'AppAPI', 'DataService'];
  function OfbhandoverController($localStorage, $state, $mdDialog, Auth, AppAPI, DataService){
    var vm = this;

    vm.list = [];
    vm.DataTable = new DataService();

    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.company = $localStorage.empsite;
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.loadData = loadData;
    vm.loadDetail = loadDetail;
    vm.loadDetailOffboarding = loadDetailOffboarding;
    vm.viewDocument = viewDocument;
    vm.createHandover = createHandover;

    var OfbRegistration = AppAPI.OfbRegistration();
    var Attendance = AppAPI.Attendance();
    var Ofbhandover = AppAPI.Ofbhandover();

    vm.listReason = ["",
      "Career development",
      "C & B and dissatisfaction with management",
      "Education",
      "Entrepreneur",
      "Family",
      "Healty",
      "Unemployement",
      "Out without news",
      "Died",
      "Breaking the rule",
      "Mutation"];

    loadCompany();

    loadData(1);
  
    function loadData(pageno) {
      var resp = vm.DataTable.loadData(Ofbhandover, pageno, {
        action: 'viewData',
        company: vm.company,
        divisi: vm.divisi,
        department: vm.department,
        search: vm.nik,
        startDate: vm.tglmulai,
        endDate: vm.tglakhir,
        reason: vm.reason
      });

      resp.then(processInfo);
      resp.catch(errorProcessInfo);
    }

    function processInfo(data) {
      vm.list = data.list;
    }

    function errorProcessInfo() {
      vm.list = [];
    }

    function loadCompany() {
      var response = OfbRegistration.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    function loadDataDivision(idbu) {
      var response = Attendance.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
      vm.listDivision = data;
    }

    function errorDivisiBU() {
      vm.listDivision = [];
    }

    function loadDataDepartment(iddivisi) {
      var response = Attendance.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
    }

    function errorDepartment() {
      vm.listDepartment = [];
    }

    function loadDetail(id, ev) {
      var idCheck = "";
      $mdDialog.show({
        controller: 'HandoverDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/offboarding/handover/handover-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          id: id,
          idCheck: idCheck
        }
      });
    }

    function loadDetailOffboarding(id) {
      $state.go('app.ofb-registration_detail', { id: id });
    }

    function viewDocument(ev, dataDoc, id, n1, n1Status) {
      $mdDialog.show({
        controller: 'OfbviewdocController',
        controllerAs: 'vm',
        templateUrl: 'app/main/offboarding/registration/ofb-view-doc.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: false,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          doc: dataDoc,
          id: id,
          n1: n1,
          status: n1Status
        }
      });
    }

    function createHandover(id, ev) {
      $mdDialog.show({
        controller: 'InputhandoverController',
        controllerAs: 'vm',
        templateUrl: 'app/main/offboarding/handover/form-handover/form-handover.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id
        }
      });
    } 


  }
})();
(function(){
  'use strict';

  angular
    .module('app.offboarding.ofb_handover')
    .controller('HandoverDetailController', HandoverDetailController);
  HandoverDetailController.$inject = ['$localStorage','$mdDialog', 'id', 'idCheck', 'Form', 'AppAPI'];
  
  function HandoverDetailController($localStorage, $mdDialog, id, idCheck, Form, AppAPI) {
    var vm = this;
    var Ofbhandover = AppAPI.Ofbhandover();
    var OfbRegistration = AppAPI.OfbRegistration();

    Form.initialForm();
    Form.setObject(Ofbhandover);
    vm.Form = Form;
    vm.id = id;
    vm.closeModal = closeModal;
    vm.nik = $localStorage.user;
    vm.approval = approval;
    loadData();

    function closeModal() {
      $mdDialog.cancel();
    }

    function loadData() {
      var responses = vm.Form.objForm.$get({action:"viewDetail", id:id});
      responses.then(function(data){
        vm.status = vm.Form.objForm.receive_status;
        vm.receiver = vm.Form.objForm.receiver_nik;

        vm.n1Status = vm.Form.objForm.n1_status;
        vm.n1 = vm.Form.objForm.n1;
      });
    }

    function approval(status, id, tipe) {
      if(vm.receiver == vm.n1){
        tipe == 'n1receiver';
      }
      var responses = vm.Form.objForm.$get({ action: "setApproval", status: status, id: id, tipe:tipe, idCheck:idCheck});
      responses.then(function (data) {

      if(vm.receiver == vm.n1){
        approvalCheck(status, idCheck);
      }
      else{
        closeModal();
      }

      });
    }

    function approvalCheck(status, idCheck) {
      Form.initialForm();
      Form.setObject(OfbRegistration);
      vm.Form = Form;
  
      var responses = vm.Form.objForm.$get({ action: "setApprovalExitClearance", status: status, id: idCheck, catatan: "" });
      responses.then(function (data) {
        closeModal();
      });
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_approval_group', [
     ])
    .config(config);

     config.$inject = ['$stateProvider', '$mdThemingProvider'];
  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state('app.ofb-approval_group', {
        url: '/ofb/approval-group',
        views: {
          'content@app': {
            templateUrl: 'app/main/offboarding/approval-group/approval-group.html',
            controller: 'OfbApprovalGruopController as vm'
          }
        }
      });
      
  }

})();
(function () {
	'use strict';

	angular
		.module('app.offboarding.ofb_approval_group')
		.controller('DeactiveApprovalGroupController', DeactiveApprovalGroupController);

	DeactiveApprovalGroupController.$inject = ['$mdDialog', 'id', 'nik', 'Auth', 'AppAPI', 'DataService'];

	function DeactiveApprovalGroupController($mdDialog, id, nik, Auth, AppAPI, DataService){
		var vm = this;
		var OfbApprovalGroup = AppAPI.OfbApprovalGroup();
	    var OfbRefCheck = AppAPI.OfbRefCheck();

	    vm.nik = nik;
		vm.DataTable = new DataService();
		vm.listUser = [];

	    vm.toggleSelectedAll = toggleSelectedAll;
    	vm.listModulSelected = [];
		
		vm.closeModal = closeModal;
		vm.loadData = loadData;

		vm.deactiveItem = deactiveItem;
		vm.deactive = deactive;

	    vm.setClearance = setClearance; 

		loadData(1);

	    function toggleSelectedAll(state) {
	      switch (state) {
	        case true:
	          checkAll();
	          break;
	        case false:
	          unCheckAll();
	          break;
	      }
	    }

	    function checkAll() {
	      vm.listModulSelected = angular.copy(vm.listUser);
	    }

	    function unCheckAll() {
	      vm.listModulSelected = [];
	    }



		function loadData(pageno) {
			vm.listModulSelected = [];
			var resp = vm.DataTable.loadData(OfbApprovalGroup, pageno, {action:'viewdata'});
			resp.then(processInfo);
			resp.catch(errorProcessInfo);
		}

	    function processInfo(data) {
	      vm.listUser = data.list;
	    }

	    function errorProcessInfo() {
	      vm.listUser = [];
	    }

	    function closeModal() {
	      $mdDialog.hide();
	    }

	    function deactive(data){
			vm.listModulSelected.push(data);
			deactiveItem();
	    }

	    function deactiveItem() {
  	      var promise = Auth.setToken();
	      promise.then(function () {
	          var response = OfbApprovalGroup.delete({ action: 'deactivated', data:  angular.toJson(vm.listModulSelected) });

	          response.$promise.then(loadData(1));

	      });

	    }



    function setClearance(ev) {
      
      var promise = Auth.setToken();
      promise.then(function () {

          var ot = new OfbRefCheck();
          ot.action = 'setRefcheck';
          ot.id = id;
          ot.nik = nik;
          var response = ot.$save();

          response.then(function (data) {
            successSet(ev, data);
            angular.element.unblockUI();
          });
          response.catch(function (data) {
            failedSet(ev, data.data, id, nik);
            angular.element.unblockUI();
          });

      });

    }

    function successSet(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });

    }

    function failedSet(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData(1);
      });

    }








	}

})();
(function () {
  'use strict';

  angular
    .module('app.offboarding.ofb_approval_group')
    .controller('OfbApprovalGruopController', OfbApprovalGruopController);

  OfbApprovalGruopController.$inject = ['$mdDialog', 'Auth', 'AppAPI','DataService'];
    /** @ngInject */
  function OfbApprovalGruopController($mdDialog, Auth, AppAPI, DataService) {
    var vm = this;
    var OfbApprovalGroup = AppAPI.OfbApprovalGroup();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    vm.search = "";

    vm.listUser = [];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.listModulSelected = [];
    vm.editUser = editUser;
    vm.deleteItem = deleteItem;
    vm.input = input;
    vm.deactiveItem = deactiveItem;

    loadData(1);

    function loadData(pageno) {
      var resp = vm.DataTable.loadData(OfbApprovalGroup, pageno, { action: 'viewdata'});
      resp.then(processInfo);
      resp.catch(errorProcessInfo);
    }

    function processInfo(data) {
      vm.listUser = data.list;
    }

    function errorProcessInfo() {
      vm.listUser = [];
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listModulSelected = angular.copy(vm.listUser);
    }

    function unCheckAll() {
      vm.listModulSelected = [];
    }

    function editUser(data) {
      $mdDialog.show({
        controller: 'EditapprovalgroupController',
        controllerAs: 'vm',
        templateUrl: 'app/main/offboarding/approval-group/form-approval-group/form-approval-group.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          refcheck : data
        },
        onRemoving: function (element, removePromise) {
          loadData();
        }
      });

    }

    function deleteItem(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = OfbApprovalGroup.delete({ action: 'delete', data: angular.toJson(vm.listModulSelected) });

          response.$promise.then(loadData(1));
        }, function () {

        });
      });

    }

    function deactiveItem(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to deactivated this list?')
          .textContent('All data your selected will be deactivated.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = OfbApprovalGroup.delete({ action: 'deactivated', data: angular.toJson(vm.listModulSelected) });

          response.$promise.then(loadData(1));
        }, function () {

        });
      });

    }

    function input(ev) {
      $mdDialog.show({
        controller: 'InputapprovalgroupController',
        controllerAs: 'vm',
        templateUrl: 'app/main/offboarding/approval-group/form-approval-group/form-approval-group.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        onRemoving: function (element, removePromise) {
          loadData();
        }
      });
    }

  }
})();
(function (){
  'use strict';

  angular
    .module('app.offboarding.ofb_approval_exit_clearance',[

    ])
    .config(config);

    config.$inject = ['$stateProvider', '$mdThemingProvider'];

    function config($stateProvider) {
      $stateProvider
        .state('app.ofb-exit_clearance_approval',{
          url: '/ofb/exit-clearance',
          views:{
            'content@app':{
              templateUrl:'app/main/offboarding/approval-exit-clearance/approval-exit-clearance.html',
              controller:'OfbapprovalexitclearanceController as vm'
            }
          }
        })
    }

})();
(function(){
  'use strict';

  angular
    .module('app.offboarding.ofb_approval_exit_clearance')
    .controller('ITFormController', ITFormController);
  ITFormController.$inject = ['$mdDialog', 'data', 'Form', 'AppAPI'];
  
  function ITFormController($mdDialog, data, Form, AppAPI) {
    var vm = this;
    var OfbRegistration = AppAPI.OfbRegistration();
    var OfbRefCheck = AppAPI.OfbRefCheck();

    Form.initialForm();
    Form.setObject(OfbRegistration);
    vm.Form = Form;
    vm.data = data;
    vm.approval = approval;
    vm.closeModal = closeModal;
    vm.itForm = {};

    loadData();
    function loadData() {
      var response = OfbRefCheck.query({action:"viewdetail", id:data.id});
      response.$promise.then(showDetail);
    }

    function approval(status, id) {
      var responses = vm.Form.objForm.$get({ action: "setApprovalExitClearance", status: status, id: id, catatan: vm.itForm });
      responses.then(function (data) {
        closeModal();
      });
    }

    function closeModal() {
      $mdDialog.cancel();
    }

    function showDetail(data) {
      console.log(data);
      var catatan = JSON.parse(data[0].catatan);
      vm.status = data[0].status;
      vm.itForm.approved = data[0].approved;
      if(catatan){
        vm.itForm.email = catatan.email;
        vm.itForm.deletedEmail = new Date(catatan.deletedEmail);
        vm.itForm.forwardEmail = catatan.forwardEmail;
        vm.itForm.forwardEmailStart = new Date(catatan.forwardEmailStart);
        vm.itForm.forwardEmailEnd = new Date(catatan.forwardEmailEnd);
        vm.itForm.chat = catatan.chat;
        vm.itForm.deletedChat = new Date(catatan.deletedChat);
        vm.itForm.access = catatan.access;
        vm.itForm.deletedAccess = new Date(catatan.deletedAccess);
        vm.itForm.other = catatan.other;
        vm.itForm.deletedOther = new Date(catatan.deletedOther);
        vm.itForm.note = catatan.note;
      }
    }
  }

})();
(function(){
  'use strict';

  angular
    .module('app.offboarding.ofb_approval_exit_clearance')
    .controller('OfbapprovalexitclearanceController', OfbapprovalexitclearanceController);

  OfbapprovalexitclearanceController.$inject = ['$localStorage', '$state', '$mdDialog', 'Auth', 'AppAPI', 'DataService'];
  function OfbapprovalexitclearanceController($localStorage, $state, $mdDialog, Auth, AppAPI, DataService) {
    var vm = this;
    var OfbRegistration = AppAPI.OfbRegistration();
    var Attendance = AppAPI.Attendance();

    vm.list = [];
    vm.DataTable = new DataService();

    vm.listJum = [2, 5, 25, 50, 75, 100, 200]; 
    
    vm.appstatus = [{ name: 'Waiting Approval', value: '0' }, { name: 'Approved', value: '1' }, { name: 'Rejected', value: '2' }];
    vm.status = '';   
    
    vm.company = $localStorage.empsite;
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.loadData = loadData;
    vm.detail = detail;
    vm.listReason = ["",
      "Career development",
      "C & B and dissatisfaction with management",
      "Education",
      "Entrepreneur",
      "Family",
      "Healty",
      "Unemployement",
      "Out without news",
      "Died",
      "Breaking the rule",
      "Mutation"];

    loadCompany();

    loadData(1);

    function loadData(pageno) {
      var resp = vm.DataTable.loadData(OfbRegistration, pageno, {
        action: 'viewExitClearanceData',
        company: vm.company,
        divisi: vm.divisi,
        department: vm.department,
        search: vm.nik,
        startDate: vm.tglmulai,
        endDate: vm.tglakhir,
        reason: vm.reason,
        status: vm.status
      });

      resp.then(processInfo);
      resp.catch(errorProcessInfo);
    }

    function processInfo(data) {
      vm.list = data.list;
    }

    function errorProcessInfo() {
      vm.list = [];
    }

    function loadCompany() {
      var response = OfbRegistration.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    function loadDataDivision(idbu) {
      var response = Attendance.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
      vm.listDivision = data;
    }

    function errorDivisiBU() {
      vm.listDivision = [];
    }

    function loadDataDepartment(iddivisi) {
      var response = Attendance.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
    }

    function errorDepartment() {
      vm.listDepartment = [];
    }

    function detail(id, ev){
      $mdDialog.show({
        controller : 'ApprovalExitClearanceDetailController',
        controllerAs : 'vm',
        templateUrl: 'app/main/offboarding/approval-exit-clearance/approval-exit-clearance-detail.html',
        parent  : angular.element(document.body),
        targetEvent : ev,
        clickOutsideToClose : true,
        fullscreen  : true,
        onRemoving  : function(element, removePromise){
          loadData(1);
        },
        locals  : {
          id:id
        }
      });
    }
  
  }  
})();
(function(){
  'use strict';

  angular
    .module('app.offboarding.ofb_approval_exit_clearance')
    .controller('ApprovalExitClearanceDetailController', ApprovalExitClearanceDetailController);
  ApprovalExitClearanceDetailController.$inject = ['$mdDialog','$state', 'id', 'Form', 'AppAPI'];
  
  function ApprovalExitClearanceDetailController($mdDialog, $state, id, Form, AppAPI) {
    var vm = this;
    var OfbRegistration = AppAPI.OfbRegistration();

    Form.initialForm();
    Form.setObject(OfbRegistration);
    vm.Form = Form;
    vm.id = id;
    vm.closeModal = closeModal;
    vm.approval = approval;
    vm.itForm = itForm;
    vm.loadHandover = loadHandover;
    vm.exitInterview = exitInterview;
    
    loadData();

    function loadData() {
      var responses = vm.Form.objForm.$get({ action: "viewDetailExitClearance", id:id });
      responses.then(function (data) {
      });
    }

    function closeModal() {
      $mdDialog.cancel();
    }

    function approval(status, id) {
      var responses = vm.Form.objForm.$get({ action: "setApprovalExitClearance", status: status, id: id, catatan: "" });
      responses.then(function (data) {
        loadData();
      });
    }

    function itForm(data, ev) {
      $mdDialog.show({
        controller: 'ITFormController',
        controllerAs: 'vm',
        templateUrl: 'app/main/offboarding/approval-exit-clearance/it-form.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          
        },
        locals: {
          data: data
        }
      });
    }

    function loadHandover(id, idCheck, ev) {
      $mdDialog.show({
        controller: 'HandoverDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/offboarding/handover/handover-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          id: id,
          idCheck:idCheck
        }
      });
    }

    function exitInterview(nik) {
      console.log(nik);
      closeModal();
      $state.go('app.ofb-exit-interview-user',{nik:nik});
      // $state.go('app.insurance_emp-claim_detail', { id: id });
    }
  }  
})();
(function () {
    "use strict";

    angular.module("app.mppmgr", ["app.mppmgr.table"]).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mppmgr", {
            url: "/mppmgr",
            views: {
                "content@app": {
                    templateUrl: "app/main/mppmgr/mppmgr.html",
                    controller: "MppMgrController as vm",
                },
            },
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mppmgr")
        .controller("MppMgrViewMoreController", Controller);

    Controller.$inject = ["$mdDialog", "refData", "$scope"];
    /** @ngInject */
    function Controller($mdDialog, refData, $scope) {
        var vm = this;
        vm.hide = hide;
        vm.data = refData;
        vm.numPages = numPages;
        vm.filtered = [];
        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.totalItems = vm.data.length;

        activate();

        function activate() {
            $scope.$watch("vm.currentPage + vm.numPerPage", function () {
                var begin = (vm.currentPage - 1) * vm.numPerPage;
                var end = begin + vm.numPerPage;
                vm.filtered = vm.data.slice(begin, end);
            });
        }

        function hide() {
            $mdDialog.hide();
        }

        function numPages() {
            return Math.ceil(vm.data.length / vm.numPerPage);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mppmgr")
        .controller("MppMgrUploadController", Controller);

    Controller.$inject = [
        "config",
        "$mdDialog",
        "AppAPI",
        "$window",
        "$location",
        "Auth",
        "FileUploader",
        "$localStorage",
    ];
    /** @ngInject */
    function Controller(
        config,
        $mdDialog,
        AppAPI,
        $window,
        $location,
        Auth,
        FileUploader,
        $localStorage
    ) {
        var vm = this;
        vm.hide = hide;
        vm.messages = "";
        vm.isUploaded = false;
        vm.detail = [];
        vm.viewMore = viewMore;

        activate();

        function activate() {}

        function hide() {
            $mdDialog.hide();
        }

        function viewMore(ev) {
            $mdDialog.show({
                controller: "MppMgrViewMoreController as vm",
                templateUrl:
                    "app/main/mppmgr/mppmgr-upload/mppmgr-view-more.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    refData: vm.detail,
                },
            });
        }

        vm.uploadFile = new FileUploader({
            url: config.api + "api/mppmgr/uploadMpp",
            removeAfterUpload: true,
            alias: "file",
            formData: [
                {
                    action: "upload",
                },
            ],
            onAfterAddingAll: function () {
                vm.isUploaded = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth,
            },
        });

        vm.uploadFile.onSuccessItem = function (item) {
            var obj = JSON.parse(item._xhr.response);
            vm.messages = obj.message;
            vm.detail = obj.data;
            console.log(obj);
            vm.isUploaded = true;
            angular.element("#uploaderPhoto").val("");
        };

        vm.uploadFile.onErrorItem = function (item) {
            console.log(item);
            var obj = JSON.parse(item._xhr.response);
            vm.messages = obj;
            vm.isUploaded = true;
        };
    }
})();

(function () {
    "use strict";

    angular.module("app.mppmgr.table", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.mppmgr.table", {
            url: "/mpptable",
            views: {
                "mppMgrView@app.mppmgr": {
                    templateUrl:
                        "app/main/mppmgr/mppmgr-table/mppmgr-table.html",
                    controller: "MppMgrTableController as vm",
                },
            },
            params: {
                obj: null,
            },
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mppmgr.table")
        .controller("MppMgrTableController", Controller);

    Controller.$inject = [
        "$mdDialog",
        "$localStorage",
        "$scope",
        "AppAPI",
        "$state",
        "$stateParams",
        "Auth",
        "MppMgrService",
        "$window",
        "config",
        "$location",
    ];
    /** @ngInject */
    function Controller(
        $mdDialog,
        $localStorage,
        $scope,
        AppAPI,
        $state,
        $stateParams,
        Auth,
        MppMgrService,
        $window,
        config,
        $location
    ) {
        var vm = this;
        var Mpp = AppAPI.MppMgr();
        var Orgchart = new AppAPI.Orgchartemp();
        var nik = $localStorage.user;
        var dt = new Date();
        vm.params = {};
        vm.listData = [];
        vm.action = action;
        vm.months = [
            { id: 0, name: "Jan" },
            { id: 1, name: "Feb" },
            { id: 2, name: "Mar" },
            { id: 3, name: "Apr" },
            { id: 4, name: "Mei" },
            { id: 5, name: "Jun" },
            { id: 6, name: "Jul" },
            { id: 7, name: "Aug" },
            { id: 8, name: "Sep" },
            { id: 9, name: "Oct" },
            { id: 10, name: "Nov" },
            { id: 11, name: "Dec" },
        ];
        vm.year = dt.getFullYear();
        vm.prevYear = vm.year - 1;
        vm.stateShow = {
            curr: true,
            prev: true,
        };

        vm.onClickDownload = onClickDownload;
        vm.uploadMpp = uploadMpp;
        vm.onClickDownloadReport = onClickDownloadReport;
        vm.onClickDownloadSummary = onClickDownloadSummary;

        function loadLayer(layerId, depth, year) {
            angular.element("#orgchart-area").block();
            isLoadingTableData(true);
            var response = Mpp.query({
                action: "loadDataLayer",
                maxDepth: depth,
                layerId: layerId,
                year: year,
            });
            response.$promise.then(function (data) {
                data.sort(function (a, b) {
                    var keyA = parseInt(a.level),
                        keyB = parseInt(b.level);
                    // Compare the 2 dates
                    if (keyA < keyB) return -1;
                    if (keyA > keyB) return 1;
                    return 0;
                });
                vm.listData = data;
                isLoadingTableData(false);
                angular.element("#orgchart-area").unblock();
            });
            response.$promise.catch(function () {
                vm.listData = [];
                isLoadingTableData(false);
                angular.element("#orgchart-area").unblock();
            });
        }

        $scope.$on("PARENT::MPP_TABLE_LOAD_TABLE", function (e, data) {
            console.log("PARENT::MPP_TABLE_LOAD_TABLE", data);
            vm.params = data;
            vm.year = data.year;
            vm.prevYear = vm.year - 1;
            loadLayer(data.teamLayer.id, data.depth, data.year);
        });

        function isLoadingTableData(status) {
            $scope.$emit("CHILD::MPP_TABLE_IS_LOADING", status);
        }

        function action(e, data, type) {
            switch (type) {
                case "add":
                    $mdDialog
                        .show({
                            controller: "EditOrgChartController as vm",
                            templateUrl: "app/main/orgchart/edit-mpp.html",
                            parent: angular.element(document.body),
                            targetEvent: e,
                            clickOutsideToClose: false,
                            fullscreen: true,
                            locals: {
                                refData: {
                                    context: data,
                                },
                                year: vm.params.year,
                                layerID: vm.params.teamLayer.id,
                                listTeamLayer: vm.listData,
                            },
                        })
                        .then(function () {
                            loadStructure();
                            // viewListLayer();
                        });
                    break;
                case "edit":
                    $mdDialog
                        .show({
                            controller: "EditOrgChartController as vm",
                            templateUrl: "app/main/orgchart/edit-mpp.html",
                            parent: angular.element(document.body),
                            targetEvent: e,
                            clickOutsideToClose: false,
                            fullscreen: true,
                            locals: {
                                refData: {
                                    context: data,
                                },
                                year: vm.params.year,
                                layerID: vm.params.teamLayer.id,
                                listTeamLayer: vm.listData,
                            },
                        })
                        .then(function () {
                            loadStructure();
                            // viewListLayer();
                        });
                    break;
                case "delete":
                    var response = Auth.setToken();
                    response.then(function () {
                        var confirm = $mdDialog
                            .confirm()
                            .title("Delete Structure ?")
                            .textContent(
                                "Would you like to delete " +
                                    data.context.description +
                                    " layer from your structure ?"
                            )
                            .ariaLabel("delete structure")
                            .targetEvent(e)
                            .ok("Please do it!")
                            .cancel("No, Sorry");

                        $mdDialog.show(confirm).then(function () {
                            // deleteChart(data.context.id);
                        });
                    });
                    break;
                case "add_mpp":
                    $mdDialog
                        .show({
                            controller: "FormAddMppController as vm",
                            templateUrl: "app/main/orgchart/add-mpp.html",
                            parent: angular.element(document.body),
                            targetEvent: e,
                            clickOutsideToClose: false,
                            fullscreen: true,
                            locals: {
                                refData: {
                                    context: data,
                                },
                                year: vm.params.year,
                                layerID: vm.params.teamLayer.id,
                                listTeamLayer: vm.listData,
                            },
                        })
                        .then(function () {
                            loadLayer(
                                vm.params.teamLayer.id,
                                vm.params.depth,
                                vm.params.year
                            );
                            // viewListLayer();
                        });
                    break;
                default:
                    break;
            }
        }

        function onClickDownload() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            "://" +
                            host +
                            config.api +
                            "api/mppmgr/downloadTemplate/" +
                            vm.params.teamLayer.id +
                            "/" +
                            vm.year +
                            "/" +
                            vm.params.depth +
                            "/" +
                            data.token +
                            "/" +
                            nik,
                        "_blank"
                    );
                },
                function () {
                    $window.alert("gagal load token");
                }
            );
        }

        function onClickDownloadReport() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            "://" +
                            host +
                            config.api +
                            "api/mppmgr/downloadReport/" +
                            vm.params.teamLayer.id +
                            "/" +
                            vm.year +
                            "/" +
                            vm.params.depth +
                            "/" +
                            data.token +
                            "/" +
                            nik,
                        "_blank"
                    );
                },
                function () {
                    $window.alert("gagal load token");
                }
            );
        }

        function uploadMpp(ev) {
            $mdDialog
                .show({
                    controller: "MppMgrUploadController as vm",
                    templateUrl:
                        "app/main/mppmgr/mppmgr-upload/mppmgr-upload.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    multiple: true,
                    clickOutsideToClose: true,
                    fullscreen: true,
                })
                .then(function () {
                    loadData(1);
                });
        }
        
        function onClickDownloadSummary() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            "://" +
                            host +
                            config.api +
                            "api/mympp/downloadReport/" +
                            vm.params.teamLayer.id +
                            "/" +
                            vm.year +
                            "/" +
                            vm.params.depth +
                            "/" +
                            data.token,
                        "_blank"
                    );
                },
                function () {
                    $window.alert("gagal load token");
                }
            );
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.mppmgr.compare', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state('app.mppmgr.compare', {
        url: '/mppcompare',
        views: {
          'mppMgrView@app.mppmgr': {
            templateUrl: 'app/main/mppmgr/mppmgr-compare/mppmgr-compare.html',
            controller: 'MppMgrCompareController as vm'
          }
        },
        params: {
          obj: null
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.mppmgr.compare')
    .controller('MppMgrCompareController', Controller);

  Controller.$inject = ['$mdDialog', 'AppAPI', 'Auth', '$stateParams', 'MppMgrService', '$scope'];

  /* @ngInject */
  function Controller($mdDialog, AppAPI, Auth, $stateParams, MppMgrService, $scope) {
    var vm = this;
    var Mpp = new AppAPI.MppMgr();
    var date = new Date();
    vm.loadStructure = loadStructure;
    vm.options = {};
    vm.listBT = [];
    vm.layer = MppMgrService.getLayer();

    var i = 0,
      jum = 0,
      items = [],
      objItem;

    activate();

    function activate() {
      initComponents();
    }

    function initComponents() {
      if ($stateParams.obj !== null) {
        vm.layer = $stateParams.obj.layer;
        vm.year = $stateParams.obj.year;
        vm.idTeamLayer = $stateParams.obj.idTeamLayer;
      } else {
        vm.layer = MppMgrService.getLayer();
        vm.year = MppMgrService.getYears();
        vm.idTeamLayer = MppMgrService.getTeamLayer();
      }
      loadStructure();
    }


    function loadStructure() {
      angular.element('#orgchart-area').block();
      var response = Mpp.query({
        action: 'viewMppChartCompare',
        layer: vm.layer,
        year: vm.year,
        idTeamLayer: vm.idTeamLayer
      });
      response.$promise.then(loadOrgchart);
      response.$promise.catch(failedLoadChart);
    }


    function loadOrgchart(data) {
      jum = data.length;
      items = [];
      for (i = 0; i < jum; i++) {
        objItem = new primitives.orgdiagram.ItemConfig(data[i]);
        items.push(objItem);
      };

      angular.element('#orgchart-area').unblock();

      vm.options.items = items;
    }



    function failedLoadChart() {
      angular.element('#orgchart-area').unblock();
    }


    //        None: 0,
    // PageWidth: 1,
    // PageHeight: 2,
    // FitToPage: 3,
    // PrintPreview: 4,
    // AutoSize: 5,
    // SelectionOnly: 6


    var buttons = [];
    buttons.push(new primitives.orgdiagram.ButtonConfig("edit", "ui-icon-gear", "Edit"));
    buttons.push(new primitives.orgdiagram.ButtonConfig("delete", "ui-icon-close", "Delete"));
    buttons.push(new primitives.orgdiagram.ButtonConfig("add", "ui-icon-person", "Add"));
    buttons.push(new primitives.orgdiagram.ButtonConfig("create", "ui-icon-newwin", "Create" ))



    vm.options.cursorItem = 0;
    vm.options.buttons = buttons;
    vm.options.highlightItem = 0;
    vm.options.hasSelectorCheckbox = primitives.common.Enabled.False;
    vm.options.pageFitMode = 0;
    vm.options.templates = [getContactTemplate()];
    vm.options.defaultTemplateName = "contactTemplate";
    vm.options.connectors = "step";
    vm.options.linesColor = primitives.common.Colors.Teal;
    vm.options.onButtonClick = editMpp;

    function editMpp(e, data) {
      console.log(data.name);
      if (data.name === 'create') {
        showCreateLayerDialog(e, data);
        return;
      }

      switch (data.context.transaction_type) {
        case 'new hire':
        case 'transfer in':
          switch (data.name) {
            case 'edit':
              $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert')
                .textContent('This Action not allowed to used')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
              );
              break;
            case 'delete':
              var response = Auth.setToken();
              response.then(function () {
                var confirm = $mdDialog.confirm()
                  .title('Delete Structure ?')
                  .textContent('Would you like to delete ' + data.context.description + ' layer from your structure ?')
                  .ariaLabel('delete structure')
                  .targetEvent(e)
                  .ok('Please do it!')
                  .cancel('No, Sorry');

                $mdDialog.show(confirm).then(function () {
                  deleteChart(data.context.id);
                });
              });

              response.catch(function () {
                $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title('MPP Alert')
                  .textContent('Failed Load Token')
                  .ariaLabel('MPP alert')
                  .ok('Got it!')
                  .targetEvent(e)
                );
              });


              break;

            default:
              $mdDialog.show({
                  controller: 'EditmppController as vm',
                  templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
                  parent: angular.element(document.body),
                  targetEvent: e,
                  clickOutsideToClose: true,
                  fullscreen: true,
                  locals: {
                    data: data,
                    year: vm.year
                  }
                })
                .then(loadStructure);
              break;
          }


          break;

        case 'promoted':
        case 'replacement':
          switch (data.name) {
            case 'edit':
              $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert')
                .textContent('This Action not allowed to used')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
              );
              break;

            case 'delete':
              var response = Auth.setToken();
              response.then(function () {
                var confirm = $mdDialog.confirm()
                  .title('Cancel Action ?')
                  .textContent('Would you like to cancel ' + data.context.description + ' transanction ?')
                  .ariaLabel('cancel action')
                  .targetEvent(e)
                  .ok('Please do it!')
                  .cancel('No, Sorry');

                $mdDialog.show(confirm).then(function () {
                  cancelAction(data.context.id);
                });
              });

              response.catch(function () {
                $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title('MPP Alert')
                  .textContent('Failed Load Token')
                  .ariaLabel('MPP alert')
                  .ok('Got it!')
                  .targetEvent(e)
                );
              });

              break;

            default:
              $mdDialog.show({
                  controller: 'EditmppController as vm',
                  templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
                  parent: angular.element(document.body),
                  targetEvent: e,
                  clickOutsideToClose: true,
                  fullscreen: true,
                  locals: {
                    data: data,
                    year: vm.year
                  }
                })
                .then(loadStructure);
              break;
          }

          break;

        case 'promotion':
        case 'demotion':
          // all button not function
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title('MPP Alert')
            .textContent('This Action not allowed to used')
            .ariaLabel('MPP alert')
            .ok('Got it!')
            .targetEvent(e)
          );
          break;
        default:
          $mdDialog.show({
              controller: 'EditmppController as vm',
              templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
              parent: angular.element(document.body),
              targetEvent: e,
              clickOutsideToClose: true,
              fullscreen: true,
              locals: {
                data: data,
                year: vm.year
              }
            })
            .then(loadStructure);
          break;
      }


    }

    function deleteChart(id) {
      angular.element('#orgchart-area').block();
      var response = Mpp.delete({
        action: 'delete',
        id: id
      });
      response.$promise.then(successDelete);
      response.$promise.catch(failedDelete);
    }

    function cancelAction(id) {
      angular.element('#orgchart-area').block();
      var response = Mpp.delete({
        action: 'cancelAction',
        id: id
      });
      response.$promise.then(successCancel);
      response.$promise.catch(failedCancel);
    }

    function successDelete(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Delete Data')
        .textContent('Success Delete Data')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(loadStructure);

    }

    function successCancel(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Cancel Action')
        .textContent('Success Cancel Action')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(loadStructure);
    }

    function showCreateLayerDialog(ev, data) {
      $mdDialog.show({
        controller: 'CreateLayerController',
        controllerAs: 'vm',
        templateUrl: 'app/main/mpp/orgchart/create-layer.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          collection: data
        }
      }).then(loadStructure);
    }

    function failedDelete(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Delete data')
        .textContent('Failed delete data')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(function () {
        angular.element('#orgchart-area').unblock();
      });

    }

    function failedCancel(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Cancel Action')
        .textContent('Failed Cancel Action')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(function () {
        angular.element('#orgchart-area').unblock();
      });

    }

    function getContactTemplate() {
      var result = new primitives.orgdiagram.TemplateConfig();
      result.name = "contactTemplate";

      result.itemSize = new primitives.common.Size(225, 50);
      result.minimizedItemSize = new primitives.common.Size(10, 10);
      result.minimizedItemCornerRadius = 5;
      result.highlightPadding = new primitives.common.Thickness(2, 2, 2, 2);



      var itemTemplate = jQuery(
        '<div class="bp-item bp-corner-all bt-item-frame md-whiteframe-3dp" >' +
        '<div class="bp-item bp-photo-frame" style="top: -1px; left: -1px; width: 40px; height: 50px;border-radius:0px;">' +
        '<img name="photo" src="{{itemConfig.image}}" style="height: 50px; width:40px;" onerror="this.src=\'assets/images/avatars/profile.jpg\';" />' +
        '</div>'

        +
        '<div name="phone" class="bp-item" style="padding-left:45px;line-height: 110%;padding-top:2px;">' +
        '<div style="padding-bottom:0px;text-transform: uppercase !important; font-size:9px;">{{itemConfig.fullName}} </div>' +
        '<div style="border-top:1px dotted #000000;padding-top:1px;font-style:italic;text-transform: capitalize;font-size:9px;"> {{itemConfig.description}}</div>' +
        '</div>'
        // + '<div class="bp-item" style="top: 20px; left: 58px; width: 162px; height: 18px; font-size: 12px;">{{itemConfig.description}}</div>'
        //+ '<div name="description" class="bp-item" style="top: 35px; left: 58px; width: 162px; height: 36px; font-size: 10px;">{{itemConfig.email}}</div>'
        +
        '</div>'
      ).css({
        width: result.itemSize.width + "px",
        height: result.itemSize.height + "px"
      });


      result.itemTemplate = itemTemplate.wrap('<div>').parent().html();

      return result;
    }

    $scope.$on('mpp_mgr_years_updated', function (e, data) {
      vm.year = MppMgrService.getYears();
      vm.layer = MppMgrService.getLayer();
      vm.idTeamLayer = MppMgrService.getTeamLayer();
      loadStructure();
    })

  }
})();

(function () {
    "use strict";

    angular.module("app.mpp-report-hc-cc.admin", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mpp_report_hc_cc_admin", {
            url: "/mpp/report/hc-cc/admin",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp-report-hc-cc/admin/admin.html",
                    controller: "MppReportHeadcountCCAdminController as vm"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.mpp-report-hc-cc.admin')
        .controller('MppReportHeadcountCCUserController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$scope',
        'Auth',
        '$location',
        '$window',
        'config'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $scope,
        Auth,
        $location,
        $window,
        config
    ) {
        var vm = this;
        var MppReport = new AppAPI.MppReportHCCCUser();
        var d = new Date();
        vm.years = [2018, 2019, 2020];
        vm.year = d.getFullYear() + 1;
        vm.count = 0;
        vm.disabledCompany = true;
        vm.getDataReport = getDataReport;
        vm.getDataLayers = getDataLayers;
        vm.showFilter = true;
        vm.printPDF = printPDF;
        vm.layers = [];
        vm.layer = {
            id: 0,
            description: 'ALL'
        };
        vm.listReport = [];
        vm.companies = [];
        vm.company = {};
        vm.searchTerm = '';
        vm.clearSearch = clearSearch;
        vm.printExcel = printExcel;
        vm.getDataCostCenter = getDataCostCenter;
        vm.listCostCenter = [];
        vm.costCenter = {
            id: 'all',
            description: 'ALL'
        };
        vm.totalCurrEmp = 0;
        vm.totalNextEmp = 0;
        vm.totalNextEmpInternal = 0;
        vm.totalNextEmpExternal = 0;
        vm.totalNextEmpMutation = 0;
        vm.totalNextEmpTermination = 0;
        vm.totalPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        vm.totalRightBottom = 0;

        vm.empType = [
            {
                name: 'ALL',
                value: 'all'
            },
            {
                name: 'STAFF',
                value: 'SAP'
            },
            {
                name: 'GENERAL WORKER',
                value: 'HRIS'
            }
        ];

        vm.selectedEmpType = 'all';

        activate();

        function activate() {
            getDataCompanies();
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function getDataReport() {
            angular.element('#tableMpp').block();
            var response = MppReport.query({
                action: 'getDataReport',
                years: vm.year,
                costCenter: vm.costCenter.id,
                layerID: vm.layer.id,
                empType: vm.selectedEmpType
            });
            response.$promise.then(fetchResponseDataReport);
            response.$promise.catch(catchResponseDataReport);
        }

        function fetchResponseDataReport(data) {
            vm.listReport = data;
            $localStorage.reportHC = data;
            setTotal(data);
            angular.element('#tableMpp').unblock();
        }

        function catchResponseDataReport(params) {
            vm.listReport = [];
            angular.element('#tableMpp').unblock();
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-hc', {
                obj: {
                    years: vm.year,
                    list: vm.listReport
                }
            });
        }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            '://' +
                            host +
                            config.api +
                            'api/mppreporthccc/user/exportData' +
                            '/' +
                            vm.layer.id +
                            '/' +
                            vm.year +
                            '/' +
                            vm.costCenter.id +
                            '/' +
                            vm.selectedEmpType +
                            '/' +
                            data.token,
                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }

        function getDataCompanies() {
            var response = MppReport.query({
                action: 'getListCompany'
            });
            response.$promise.then(fetchResponseCompanies);
            response.$promise.catch(catchResponseCompanies);
        }

        function fetchResponseCompanies(response) {
            var uCompany = $localStorage.empsite;
            var ctr = response.length;
            for (var i = 0; i < ctr; i++) {
                if (uCompany == response[i]['id']) {
                    vm.company.id = response[i].id;
                    vm.company.description = response[i].description;
                    getDataCostCenter();
                    break;
                }
            }
            vm.companies = response;
        }

        function catchResponseCompanies(response) {
            vm.companies = [];
        }

        function getDataCostCenter() {
            var response = MppReport.query({
                action: 'getListCostCenter',
                years: vm.year,
                company: vm.company.id
            });
            response.$promise.then(fetchResponseCostCenter);
            response.$promise.catch(catchResponseCostCenter);
        }

        function fetchResponseCostCenter(response) {
            vm.listCostCenter = response;
        }

        function catchResponseCostCenter() {
            vm.listCostCenter = [];
        }

        function getDataLayers() {
            var response = MppReport.query({
                action: 'getListLayer',
                years: vm.year,
                costCenter: vm.costCenter.id
            });
            response.$promise.then(fetchResponseLayers);
            response.$promise.catch(catchResponseLayers);
        }

        function fetchResponseLayers(response) {
            var plain = response;
            vm.layers = plain.reverse();
        }

        function catchResponseLayers(response) {
            vm.layers = [];
        }

        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        $scope.$on('$destroy', function() {
            delete $localStorage.reportHC;
        });

        function setTotal(data) {
            var ctr = data.length;
            vm.totalCurrEmp = 0;
            vm.totalNextEmp = 0;
            vm.totalNextEmpInternal = 0;
            vm.totalNextEmpExternal = 0;
            vm.totalNextEmpMutation = 0;
            vm.totalNextEmpTermination = 0;
            vm.totalPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            vm.totalRightBottom = 0;
            for (var i = 0; i < ctr; i++) {
                vm.totalCurrEmp += Number(data[i].curr.total);
                vm.totalNextEmp += Number(data[i].next.total);
                vm.totalNextEmpInternal += Number(data[i].next.internal);
                vm.totalNextEmpExternal += Number(data[i].next.external);
                vm.totalNextEmpMutation += Number(data[i].next.mutation);
                vm.totalNextEmpTermination += Number(data[i].next.termination);
                for (var j = 0; j < data[i].next.listPerMonth.length; j++) {
                    vm.totalPerMonth[j] += Number(data[i].next.listPerMonth[j]);
                }
                vm.totalRightBottom += data[i].totalRightPerRow;
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.mppmgr.chart', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state('app.mppmgr.chart', {
        url: '/mppchart',
        views: {
          'mppMgrView@app.mppmgr': {
            templateUrl: 'app/main/mppmgr/mppmgr-chart/mppmgr-chart.html',
            controller: 'MppMgrChartController as vm'
          }
        },
        params: {
          obj: null
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.mppmgr.chart')
    .controller('MppMgrChartController', Controller);

  Controller.$inject = ['$mdDialog', 'AppAPI', 'Auth', '$stateParams', 'MppMgrService', '$scope'];

  /* @ngInject */
  function Controller($mdDialog, AppAPI, Auth, $stateParams, MppMgrService, $scope) {
    var vm             = this;
    var Mpp            = new AppAPI.MppMgr();
    var date           = new Date();
    vm.loadStructure   = loadStructure;
    vm.options         = {};
    vm.listBT          = [];
    vm.layer           = MppMgrService.getLayer();
    vm.selectedOptions = 'edit';
    vm.listSelection   = ['edit','create','delete','add'];
    vm.hide            = hide;
    vm.cancel          = cancel;

    var i = 0,
      jum = 0,
      items = [],
      objItem;

    activate();

    function activate() {
      initComponents();
    }

    function initComponents() {
      if ($stateParams.obj !== null) {
        vm.layer = $stateParams.obj.layer;
        vm.year = $stateParams.obj.year;
        vm.idTeamLayer = $stateParams.obj.idTeamLayer;
      } else {
        vm.layer = MppMgrService.getLayer();
        vm.year = MppMgrService.getYears();
        vm.idTeamLayer = MppMgrService.getTeamLayer();
      }
      loadStructure();
    }


    function loadStructure() {
      angular.element('#orgchart-area').block();
      var response = Mpp.query({
        action: 'viewMppChart',
        layer: vm.layer,
        year: vm.year,
        idTeamLayer: vm.idTeamLayer
      });
      response.$promise.then(loadOrgchart);
      response.$promise.catch(failedLoadChart);
    }


    function loadOrgchart(data) {
      jum = data.length;
      items = [];
      for (i = 0; i < jum; i++) {
        objItem = new primitives.orgdiagram.ItemConfig(data[i]);
        items.push(objItem);
      };

      angular.element('#orgchart-area').unblock();

      vm.options.items = items;
    }



    function failedLoadChart() {
      angular.element('#orgchart-area').unblock();
    }


    //        None: 0,
    // PageWidth: 1,
    // PageHeight: 2,
    // FitToPage: 3,
    // PrintPreview: 4,
    // AutoSize: 5,
    // SelectionOnly: 6


    var buttons = [];
    buttons.push(new primitives.orgdiagram.ButtonConfig("edit", "ui-icon-gear", "Edit"));
    buttons.push(new primitives.orgdiagram.ButtonConfig("delete", "ui-icon-close", "Delete"));
    buttons.push(new primitives.orgdiagram.ButtonConfig("add", "ui-icon-person", "Add"));
    // buttons.push(new primitives.orgdiagram.ButtonConfig("create", "ui-icon-newwin", "Create" ))



    vm.options.cursorItem = 0;
    vm.options.buttons = buttons;
    vm.options.highlightItem = 0;
    vm.options.hasSelectorCheckbox = primitives.common.Enabled.False;
    vm.options.pageFitMode = 1;
    vm.options.templates = [getContactTemplate()];
    vm.options.defaultTemplateName = "contactTemplate";
    vm.options.connectors = "step";
    vm.options.linesColor = primitives.common.Colors.Teal;
    vm.options.onButtonClick = editMpp;

    function showMenu(e, data) {
      $mdDialog.show({
        controller: 'MppMgrChartController as vm',
        templateUrl: 'app/main/mpp/orgchart/menu.html',
        parent: angular.element(document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        fullscreen: true
      }).then(function(payload){
        console.log(payload);
        data.name = payload;
        editMpp(e, data);
      }).catch(function(payload){
        console.log(payload);
      });
    }

    function hide(data) {
      $mdDialog.hide(data);
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function editMpp(e, data) {
      // if (data.name === 'create') {
      //   showCreateLayerDialog(e, data);
      //   return;
      // }

      switch (data.context.transaction_type) {
        case 'new hire':
        case 'transfer in':
          switch (data.name) {
            case 'edit':
              $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert')
                .textContent('This Action not allowed to used')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
              );
              break;
            case 'delete':
              var response = Auth.setToken();
              response.then(function () {
                var confirm = $mdDialog.confirm()
                  .title('Delete Structure ?')
                  .textContent('Would you like to delete ' + data.context.description + ' layer from your structure ?')
                  .ariaLabel('delete structure')
                  .targetEvent(e)
                  .ok('Please do it!')
                  .cancel('No, Sorry');

                $mdDialog.show(confirm).then(function () {
                  deleteChart(data.context.id);
                });
              });

              response.catch(function () {
                $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title('MPP Alert')
                  .textContent('Failed Load Token')
                  .ariaLabel('MPP alert')
                  .ok('Got it!')
                  .targetEvent(e)
                );
              });


              break;

            default:
              $mdDialog.show({
                  controller: 'EditmppController as vm',
                  templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
                  parent: angular.element(document.body),
                  targetEvent: e,
                  clickOutsideToClose: true,
                  fullscreen: true,
                  locals: {
                    data: data,
                    year: vm.year
                  }
                })
                .then(loadStructure);
              break;
          }


          break;

        case 'promoted':
        case 'replacement':
          switch (data.name) {
            case 'edit':
              $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert')
                .textContent('This Action not allowed to used')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
              );
              break;

            case 'delete':
              var response = Auth.setToken();
              response.then(function () {
                var confirm = $mdDialog.confirm()
                  .title('Cancel Action ?')
                  .textContent('Would you like to cancel ' + data.context.description + ' transanction ?')
                  .ariaLabel('cancel action')
                  .targetEvent(e)
                  .ok('Please do it!')
                  .cancel('No, Sorry');

                $mdDialog.show(confirm).then(function () {
                  cancelAction(data.context.id);
                });
              });

              response.catch(function () {
                $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title('MPP Alert')
                  .textContent('Failed Load Token')
                  .ariaLabel('MPP alert')
                  .ok('Got it!')
                  .targetEvent(e)
                );
              });

              break;

            default:
              $mdDialog.show({
                  controller: 'EditmppController as vm',
                  templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
                  parent: angular.element(document.body),
                  targetEvent: e,
                  clickOutsideToClose: true,
                  fullscreen: true,
                  locals: {
                    data: data,
                    year: vm.year
                  }
                })
                .then(loadStructure);
              break;
          }

          break;

        case 'promotion':
        case 'demotion':
          // all button not function
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title('MPP Alert')
            .textContent('This Action not allowed to used')
            .ariaLabel('MPP alert')
            .ok('Got it!')
            .targetEvent(e)
          );
          break;
        default:
          $mdDialog.show({
              controller: 'EditmppController as vm',
              templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
              parent: angular.element(document.body),
              targetEvent: e,
              clickOutsideToClose: true,
              fullscreen: true,
              locals: {
                data: data,
                year: vm.year
              }
            })
            .then(loadStructure);
          break;
      }


    }

    function deleteChart(id) {
      angular.element('#orgchart-area').block();
      var response = Mpp.delete({
        action: 'delete',
        id: id
      });
      response.$promise.then(successDelete);
      response.$promise.catch(failedDelete);
    }

    function cancelAction(id) {
      angular.element('#orgchart-area').block();
      var response = Mpp.delete({
        action: 'cancelAction',
        id: id
      });
      response.$promise.then(successCancel);
      response.$promise.catch(failedCancel);
    }

    function successDelete(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Delete Data')
        .textContent('Success Delete Data')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(loadStructure);

    }

    function successCancel(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Cancel Action')
        .textContent('Success Cancel Action')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(loadStructure);
    }

    function showCreateLayerDialog(ev, data) {
      $mdDialog.show({
        controller: 'CreateLayerController',
        controllerAs: 'vm',
        templateUrl: 'app/main/mpp/orgchart/create-layer.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          collection: data
        }
      }).then(loadStructure);
    }

    function failedDelete(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Delete data')
        .textContent('Failed delete data')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(function () {
        angular.element('#orgchart-area').unblock();
      });

    }

    function failedCancel(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Cancel Action')
        .textContent('Failed Cancel Action')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(function () {
        angular.element('#orgchart-area').unblock();
      });

    }

    function getContactTemplate() {
      var result = new primitives.orgdiagram.TemplateConfig();
      result.name = "contactTemplate";

      result.itemSize = new primitives.common.Size(225, 65);
      result.minimizedItemSize = new primitives.common.Size(10, 10);
      result.minimizedItemCornerRadius = 5;
      result.highlightPadding = new primitives.common.Thickness(2, 2, 2, 2);



      var itemTemplate = jQuery(
        '<div class="bp-item bp-corner-all bt-item-frame md-whiteframe-3dp" >' +
        '<div class="bp-item bp-photo-frame" style="width: 50px; height: 65px;border-radius:0px;">' +
        '<img name="photo" src="{{itemConfig.image}}" style="height: 65px; width:50px;" onerror="this.src=\'assets/images/avatars/profile.jpg\';" />' +
        '</div>'

        +
        '<div name="phone" class="bp-item" style="padding-left:65px;line-height: 110%;padding-top:2px;">' +
        '<div style="padding-bottom:0px;text-transform: uppercase !important; font-size:9px;">{{itemConfig.fullName}} </div>' +
        '<div style="border-top:1px dotted #000000;padding-top:1px;font-style:italic;text-transform: capitalize;font-size:9px;"> {{itemConfig.description}}</div>' +
        '</div>'
        // + '<div class="bp-item" style="top: 20px; left: 58px; width: 162px; height: 18px; font-size: 12px;">{{itemConfig.description}}</div>'
        //+ '<div name="description" class="bp-item" style="top: 35px; left: 58px; width: 162px; height: 36px; font-size: 10px;">{{itemConfig.email}}</div>'
        +
        '</div>'
      ).css({
        width: result.itemSize.width + "px",
        height: result.itemSize.height + "px"
      });


      result.itemTemplate = itemTemplate.wrap('<div>').parent().html();

      return result;
    }

    $scope.$on('mpp_mgr_years_updated', function (e, data) {
      vm.year = MppMgrService.getYears();
      vm.layer = MppMgrService.getLayer();
      vm.idTeamLayer = MppMgrService.getTeamLayer();
      loadStructure();
    })

  }
})();

(function() {
    'use strict';

    angular
        .module('app.mpp-report-hc-cc.admin')
        .controller('MppReportHeadcountCCAdminController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$scope',
        'Auth',
        '$location',
        '$window',
        'config'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $scope,
        Auth,
        $location,
        $window,
        config
    ) {
        var vm = this;
        var MppReport = new AppAPI.MppReportHCCCAdmin();
        var d = new Date();
        vm.years = [2018, 2019, 2020];
        vm.year = d.getFullYear() + 1;
        vm.count = 0;
        vm.getDataReport = getDataReport;
        vm.getDataLayers = getDataLayers;
        vm.showFilter = true;
        vm.printPDF = printPDF;
        vm.layers = [];
        vm.layer = {
            id: 0,
            description: 'ALL'
        };
        vm.listReport = [];
        vm.companies = [];
        vm.company = {};
        vm.searchTerm = '';
        vm.clearSearch = clearSearch;
        vm.printExcel = printExcel;
        vm.getDataCostCenter = getDataCostCenter;
        vm.listCostCenter = [];
        vm.costCenter = {
            id: 'all',
            description: 'ALL'
        };
        vm.totalCurrEmp = 0;
        vm.totalNextEmp = 0;
        vm.totalNextEmpInternal = 0;
        vm.totalNextEmpExternal = 0;
        vm.totalNextEmpMutation = 0;
        vm.totalNextEmpTermination = 0;
        vm.totalPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        vm.totalRightBottom = 0;

        vm.empType = [
            {
                name: 'ALL',
                value: 'all'
            },
            {
                name: 'STAFF',
                value: 'SAP'
            },
            {
                name: 'GENERAL WORKER',
                value: 'HRIS'
            }
        ];

        vm.selectedEmpType = 'all';

        activate();

        function activate() {
            getDataCompanies();
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function getDataReport() {
            angular.element('#tableMpp').block();
            var response = MppReport.query({
                action: 'getDataReport',
                years: vm.year,
                costCenter: vm.costCenter.id,
                layerID: vm.layer.id,
                empType: vm.selectedEmpType
            });
            response.$promise.then(fetchResponseDataReport);
            response.$promise.catch(catchResponseDataReport);
        }

        function fetchResponseDataReport(data) {
            vm.listReport = data;
            $localStorage.reportHC = data;
            setTotal(data);
            angular.element('#tableMpp').unblock();
        }

        function catchResponseDataReport(params) {
            vm.listReport = [];
            angular.element('#tableMpp').unblock();
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-hc', {
                obj: {
                    years: vm.year,
                    list: vm.listReport
                }
            });
        }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            '://' +
                            host +
                            config.api +
                            'api/mppreporthccc/admin/exportData' +
                            '/' +
                            vm.layer.id +
                            '/' +
                            vm.year +
                            '/' +
                            vm.costCenter.id +
                            '/' +
                            vm.selectedEmpType +
                            '/' +
                            data.token,
                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }

        function getDataCompanies() {
            var response = MppReport.query({
                action: 'getListCompany'
            });
            response.$promise.then(fetchResponseCompanies);
            response.$promise.catch(catchResponseCompanies);
        }

        function fetchResponseCompanies(response) {
            vm.companies = response;
        }

        function catchResponseCompanies(response) {
            vm.companies = [];
        }

        function getDataCostCenter() {
            var response = MppReport.query({
                action: 'getListCostCenter',
                years: vm.year,
                company: vm.company.id
            });
            response.$promise.then(fetchResponseCostCenter);
            response.$promise.catch(catchResponseCostCenter);
        }

        function fetchResponseCostCenter(response) {
            vm.listCostCenter = response;
        }

        function catchResponseCostCenter() {
            vm.listCostCenter = [];
        }

        function getDataLayers() {
            var response = MppReport.query({
                action: 'getListLayer',
                years: vm.year,
                company: vm.company.id
            });
            response.$promise.then(fetchResponseLayers);
            response.$promise.catch(catchResponseLayers);
        }

        function fetchResponseLayers(response) {
            var plain = response;
            vm.layers = plain.reverse();
        }

        function catchResponseLayers(response) {
            vm.layers = [];
        }

        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        $scope.$on('$destroy', function() {
            delete $localStorage.reportHC;
        });

        function setTotal(data) {
            var ctr = data.length;
            vm.totalCurrEmp = 0;
            vm.totalNextEmp = 0;
            vm.totalNextEmpInternal = 0;
            vm.totalNextEmpExternal = 0;
            vm.totalNextEmpMutation = 0;
            vm.totalNextEmpTermination = 0;
            vm.totalPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            vm.totalRightBottom = 0;
            for (var i = 0; i < ctr; i++) {
                vm.totalCurrEmp += Number(data[i].curr.total);
                vm.totalNextEmp += Number(data[i].next.total);
                vm.totalNextEmpInternal += Number(data[i].next.internal);
                vm.totalNextEmpExternal += Number(data[i].next.external);
                vm.totalNextEmpMutation += Number(data[i].next.mutation);
                vm.totalNextEmpTermination += Number(data[i].next.termination);
                for (var j = 0; j < data[i].next.listPerMonth.length; j++) {
                    vm.totalPerMonth[j] += Number(data[i].next.listPerMonth[j]);
                }
                vm.totalRightBottom += data[i].totalRightPerRow;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.timestudy-standard", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.timestudy_standard", {
            url: "/timestudy_standard",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp/timestudy-standard/timestudy-standard.html",
                    controller: "TimestudyStandardController as vm"
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.timestudy-standard')
        .controller('TimestudyStandardController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$scope',
        'Auth',
        '$location',
        '$window',
        'config',
        'DataService',
        '$mdDialog',
        '$log'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $scope,
        Auth,
        $location,
        $window,
        config,
        DataService,
        $mdDialog,
        $log
    ) {
        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        var TimestudyStandard = new AppAPI.TimestudyStandard();
        vm.DataTable = new DataService();
        vm.edit = edit;
        vm.add = add;
        vm.remove = remove;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listselected = [];
        vm.showFilter = true;
        vm.loadData = loadData;

        activate();

        function activate() {
            loadData('1');
            loadProduct();
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function loadData(pageno) {
            var params = {
                action: 'viewdata',
                product_id: vm.product,
            };
            var response = vm.DataTable.loadData(TimestudyStandard, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                console.log('res', res);
            });
        }

        function loadProduct() {
            var response = TimestudyStandard.query({
                action: 'getProduct'
            });
            response.$promise.then(function (data) {
                vm.productLists = data;
            });
            response.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function add(ev) {
            $mdDialog.show({
                controller: 'AddTimestudyStandardController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/timestudy-standard/timestudy-standard-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    productLists: vm.productLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'EditTimestudyStandardController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/timestudy-standard/timestudy-standard-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    productLists: vm.productLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-hc', {
                obj: {
                    years: vm.mppType,
                    list: vm.listReport
                }
            });
        }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/mppreporthccc/admin/exportData' +
                        '/' +
                        vm.layer.id +
                        '/' +
                        vm.mppType +
                        '/' +
                        vm.costCenter.id +
                        '/' +
                        vm.selectedEmpType +
                        '/' +
                        data.token,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = TimestudyStandard.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
                    response.$promise.then(loadData);
                }, function () {
                });
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        $scope.$on('$destroy', function () {
            delete $localStorage.reportHC;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.timestudy-standard')
        .controller('EditTimestudyStandardController', EditTimestudyStandardController);

    EditTimestudyStandardController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', 'data', '$element', '$log', 'productLists'];

    /* @ngInject */
    function EditTimestudyStandardController($q, $mdDialog, Form, AppAPI, data, $element, $log, productLists) {
        var vm = this;
        vm.saveData = saveData;
        var TimestudyStandard = AppAPI.TimestudyStandard();
        Form.initialForm();
        Form.setObject(TimestudyStandard);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.productLists = productLists;

        vm.selectedProduct = selectedProduct;
        vm.searchProduct;
        vm.clearSearch = function () {
            vm.searchProduct = '';
        };
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        console.log('data', data);

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.product = data.product_id;
        vm.Form.objForm.description = data.description;
        vm.Form.objForm.time_value = data.time_value;
        vm.Form.objForm.uom = data.uom;

        function selectedProduct(id) {
            var product = vm.productLists.find(function (t) {
                if (t.id === id) {
                    return t;
                }
            });
            return product;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.product_id = vm.Form.objForm.product;
            var promise = Form.saveData('update', formController, TimestudyStandard);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.timestudy-standard')
        .controller('AddTimestudyStandardController', AddTimestudyStandardController);

    AddTimestudyStandardController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', '$element', '$log', 'productLists'];

    /* @ngInject */
    function AddTimestudyStandardController($q, $mdDialog, Form, AppAPI, $element, $log, productLists) {
        var vm = this;
        vm.saveData = saveData;
        var TimestudyStandard = AppAPI.TimestudyStandard();
        Form.initialForm();
        Form.setObject(TimestudyStandard);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.productLists = productLists;

        vm.selectedProduct = selectedProduct;
        vm.searchProduct;
        vm.clearSearch = function () {
            vm.searchProduct = '';
        };
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function selectedProduct(id) {
            var product = vm.productLists.find(function (t) {
                if (t.id === id) {
                    return t;
                }
            });
            return product;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.product_id = vm.Form.objForm.product;
            var promise = Form.saveData('save', formController, TimestudyStandard);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.mpp.orgtable')
    .filter('shortenestMoney', function() {
      return function(number) {
        if (number !== 'undefined') {
          number = (number / Math.pow(10, 6)).toFixed(1);
          return number;
        }
      };
    });


})();

(function () {
  'use strict';

  angular
    .module('app.mpp.orgtable')
    .directive('mppTableViewport', mppTableViewport);

  function mppTableViewport($window) {

    var directive = {
      restrict: 'A',
      link: link,
      scope: {
        toggle: '@'
      }
    };

    return directive;

    /** @ngInject */

    function link(scope, element, attrs) {
      var w = angular.element($window);
      var mppToolbarArea = angular.element(document.body.querySelector('#mppToolbarArea'));
      var toolbar = angular.element(document.body.querySelector('#toolbar'));
      var elOrgTable = angular.element(element[0]);
      var elOrgTablePayment = angular.element(element[0].querySelector('#orgTablePayment'));
      var elOrgTableContent = angular.element(element[0].querySelector('#orgTableContent'));

      scope.getWindowsHeight = function () {
        return w.outerHeight();
      }

      scope.$watch(scope.getWindowsHeight, function (newVal) {
        var baseHeight = (newVal - toolbar.outerHeight()) - mppToolbarArea.outerHeight();
        elOrgTable.css('height', baseHeight);
        elOrgTableContent.css('height', baseHeight);
      }, true);


      attrs.$observe('toggle', function (status) {
        var baseHeight = element[0].clientHeight - mppToolbarArea.outerHeight();
        if (status === 'true') {
          elOrgTablePayment.css('height', baseHeight * (50 / 100));
          elOrgTableContent.css('height', baseHeight - (baseHeight * (50 / 100)));
        } else {
          elOrgTableContent.css('height', baseHeight);
        }
      });

      w.bind('resize', function () {
        scope.$apply();
      });

    }
  }
})();

(function() {
    "use strict";

    angular
        .module("app.mpp.orgtable")
        .controller("OrgTableController", Controller);

    Controller.$inject = [
        "$mdDialog",
        "$localStorage",
        "$scope",
        "AppAPI",
        "$state",
        "$stateParams",
        "Auth",
        "mppService"
    ];
    /** @ngInject */
    function Controller(
        $mdDialog,
        $localStorage,
        $scope,
        AppAPI,
        $state,
        $stateParams,
        Auth,
        mppService
    ) {
        var vm = this;
        var Mpp = AppAPI.Mpp();
        var today = new Date();
        var year = mppService.getYears();
        var months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        vm.username = $localStorage.nama;
        vm.user = $localStorage.user;
        vm.showTransaction = showTransaction;
        vm.selectedMaxDepth = 2;
        vm.layer = mppService.getTeamLayer();
        vm.convertMonth = convertMonth;
        vm.toggleChildren = toggleChildren;
        vm.showCreate = showCreate;
        vm.getDataMpp = getDataMpp;
        vm.getTotal = getTotal;
        vm.logicMonth = logicMonth;
        $localStorage.mppFlag = 0;
        vm.flagTrue = false;
        vm.tempMonth = 0;
        vm.dotStatus = dotStatus;
        vm.showMerge = showMerge;
        vm.showCancel = showCancel;
        vm.showDelete = showDelete;
        vm.toggleCollection = [];
        vm.flexHeaderCycle = flexHeaderCycle;
        vm.showUploadForm = showUploadForm;
        vm.listCost = [];
        vm.toggleMonthsVal = false;
        vm.toggleService = false;
        vm.togglePayment = false;
        vm.switchBackgroundMonth = switchBackgroundMonth;
        vm.showMoneyMonth = true;
        vm.disableAction = false;
        vm.isOneMpp = false;
        vm.showEmptyData = false;
        vm.showCreateLayer = showCreateLayer;
        $localStorage.lastLevelOpened = 1;
        vm.setColorStatus = setColorStatus;

        vm.flex = {
            style: {
                width: "100%"
            },
            top: {
                actual: {
                    flex_1: 0,
                    flex_2: 0,
                    flex_2_Offset: 0
                },
                current: {
                    flex_1: 0
                },
                future: {
                    flex_1: 0
                }
            },
            main: {
                businessTitle: {
                    show: true,
                    flex_1: 35,
                    order: 0
                },
                action: {
                    show: true,
                    flex_1: 5,
                    order: 2
                },
                actual: {
                    show: true,
                    flex_1: 15,
                    order: 3
                },
                current: {
                    show: true,
                    flex_1: 15,
                    order: 4
                },
                status: {
                    show: true,
                    flex_1: 5,
                    order: 5
                },
                future: {
                    show: true,
                    flex_1: 15,
                    order: 6
                },
                totalPerMonth: {
                    show: true,
                    flex_1: 5,
                    order: 7
                },
                month: {
                    show: false,
                    flex_1: 5,
                    order: 8
                },
                cost: {
                    show: false,
                    flex_1: "",
                    order: 9
                }
            }
        };

        activate();

        function activate() {
            isToggleCollection();
            collectToggleState();
            if ($stateParams.obj) {
                console.log($stateParams.obj);
                vm.yearSelected = $stateParams.obj.year;
                vm.layer = $stateParams.obj.idTeamLayer;
                vm.maxDepth = $stateParams.obj.layer;
                if ($stateParams.obj.flag === 2) {
                    vm.isOneMpp = true;
                }
            } else {
                vm.yearSelected = year;
                vm.layer = mppService.getTeamLayer();
                vm.maxDepth = 2;
                vm.isOneMpp = false;
                vm.isLayerID = false;
            }
            flexHeaderCycle();
            if (vm.isOneMpp) {
                getDataMppIsOne();
            } else {
                getDataMpp();
            }
        }

        function isToggleCollection() {
            if ($localStorage.toggleCollection) {
                vm.toggleCollection = $localStorage.toggleCollection;
            }
        }

        function collectToggleState() {
            vm.flex.main.month.show = mppService.getToggleMonth();
            vm.flex.main.cost.show = mppService.getToggleService();
            vm.togglePayment = mppService.getTogglePayment();
            vm.flex.main.actual.show = mppService.getToggleActual();
            vm.flex.main.current.show = mppService.getToggleCurrent();
            vm.flex.main.status.show = mppService.getToggleStatus();
            vm.flex.main.future.show = mppService.getToggleFuture();
            vm.flex.main.action.show = mppService.getToggleAction();
            vm.flex.main.totalPerMonth.show = mppService.getToggleTotalPerMonth();
        }

        $scope.$on("upload_mpp", function(e, data) {
            showUploadForm(e);
        });

        $scope.$on("switch_money", function(e, data) {
            vm.showMoneyMonth = data;
        });

        $scope.$on("filter_updated", function(e) {
            vm.flex.main.month.show = mppService.getToggleMonth();
            vm.flex.main.cost.show = mppService.getToggleService();
            vm.togglePayment = mppService.getTogglePayment();
            vm.flex.main.actual.show = mppService.getToggleActual();
            vm.flex.main.current.show = mppService.getToggleCurrent();
            vm.flex.main.status.show = mppService.getToggleStatus();
            vm.flex.main.future.show = mppService.getToggleFuture();
            vm.flex.main.action.show = mppService.getToggleAction();
            vm.flex.main.totalPerMonth.show = mppService.getToggleTotalPerMonth();
            flexHeaderCycle();
        });

        function toggleFinder() {
            if (
                !vm.flex.main.actual.show &&
                !vm.flex.main.current.show &&
                !vm.flex.main.status.show &&
                !vm.flex.main.future.show &&
                !vm.flex.main.action.show &&
                !vm.flex.main.totalPerMonth.show
            ) {
                return 1;
            } else if (
                vm.flex.main.actual.show &&
                vm.flex.main.current.show &&
                vm.flex.main.status.show &&
                vm.flex.main.future.show &&
                vm.flex.main.action.show &&
                vm.flex.main.totalPerMonth.show
            ) {
                return 2;
            } else {
                return 0;
            }
        }

        $scope.$watch(
            function() {
                return mppService.getLayer();
            },
            function(newVal) {
                year = newVal;
                vm.layer = mppService.getTeamLayer();
                if (!$stateParams.obj) {
                    getDataMpp();
                }
            }
        );

        function flexHeaderCycle() {
            if (vm.flex.main.month.show && vm.flex.main.cost.show) {
                vm.flex.style.width =
                    toggleFinder() === 1
                        ? "230%"
                        : toggleFinder() === 2
                            ? "250%"
                            : "210%";
                vm.flex.main.businessTitle.flex_1 =
                    toggleFinder() === 1 ? 20 : 15;
                vm.flex.main.action.flex_1 = 5;
                vm.flex.main.current.flex_1 = 5;
                vm.flex.main.future.flex_1 = 5;
                vm.flex.main.status.flex_1 = 5;
                vm.flex.main.actual.flex_1 = 5;
                vm.flex.main.totalPerMonth.flex_1 = 5;
                vm.flex.main.month.flex_1 =
                    toggleFinder() === 1 ? 35 : toggleFinder() === 2 ? 25 : 25;
                vm.flex.main.cost.flex_1 =
                    toggleFinder() === 2
                        ? 30
                        : toggleFinder() === 1
                            ? 35
                            : "grow";
                return;
            } else if (vm.flex.main.month.show && !vm.flex.main.cost.show) {
                vm.flex.style.width =
                    toggleFinder() === 1
                        ? "100%"
                        : toggleFinder() === 2
                            ? "150%"
                            : "150%";
                vm.flex.main.businessTitle.flex_1 =
                    toggleFinder() === 1 ? 30 : 20;
                vm.flex.main.action.flex_1 = 5;
                vm.flex.main.current.flex_1 = 5;
                vm.flex.main.future.flex_1 = 5;
                vm.flex.main.status.flex_1 = 5;
                vm.flex.main.actual.flex_1 = 5;
                vm.flex.main.totalPerMonth.flex_1 = 5;
                vm.flex.main.month.flex_1 =
                    toggleFinder() === 2
                        ? 50
                        : toggleFinder() === 1
                            ? "grow"
                            : "grow";
                return;
            } else if (!vm.flex.main.month.show && vm.flex.main.cost.show) {
                vm.flex.style.width = "170%";
                vm.flex.main.businessTitle.flex_1 =
                    toggleFinder() === 2 ? 20 : 15;
                vm.flex.main.action.flex_1 = 5;
                vm.flex.main.current.flex_1 = 5;
                vm.flex.main.future.flex_1 = 5;
                vm.flex.main.status.flex_1 = 5;
                vm.flex.main.actual.flex_1 = 5;
                vm.flex.main.totalPerMonth.flex_1 = 5;
                vm.flex.main.cost.flex_1 = "grow";
                return;
            } else {
                vm.flex.style.width = "100%";
                vm.flex.main.businessTitle.flex_1 =
                    toggleFinder() === 2 ? 40 : "noshrink";
                vm.flex.main.action.flex_1 = toggleFinder() === 2 ? 10 : "grow";
                vm.flex.main.current.flex_1 =
                    toggleFinder() === 2 ? 10 : "grow";
                vm.flex.main.status.flex_1 = toggleFinder() === 2 ? 10 : "grow";
                vm.flex.main.actual.flex_1 = toggleFinder() === 2 ? 10 : "grow";
                vm.flex.main.totalPerMonth.flex_1 =
                    toggleFinder() === 2 ? 10 : "grow";
                vm.flex.main.future.flex_1 = toggleFinder() === 2 ? 10 : "grow";
                return;
            }
        }

        function setColorStatus(item) {
            switch (item.status) {
                case "draft":
                    return "mpp-color-orange";
                case "progress":
                case "approved":
                    return "mpp-color-green";
                default:
                    return "mpp-color-orange";
            }
            // return 'mpp-color-orange';
        }

        function showCreate() {
            $state.go("app.pms_mpp.create");
        }

        function convertMonth(i) {
            return moment(i)
                .month(i)
                .format("MMMM");
        }

        function showTransaction(ev, item, type, action) {
            var transType = switchTransactionType(item, type);
            $mdDialog
                .show({
                    controller: "MppTransactionController",
                    controllerAs: "vm",
                    templateUrl:
                        "app/main/mpp/orgtable/transaction-mpp/transaction-mpp.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        item: item,
                        type: transType,
                        year: vm.yearSelected,
                        actionType: action
                    }
                })
                .then(getDataMpp);
        }

        function showUploadForm(ev) {
            $mdDialog.show({
                controller: "UploadMppController",
                controllerAs: "vm",
                templateUrl: "app/main/mpp/orgtable/upload-mpp/upload-mpp.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    year: vm.yearSelected
                }
            });
        }

        function switchTransactionType(item, type) {
            switch (type) {
                case 1:
                    return 1;
                case 2:
                    switch (item.transaction_type) {
                        case "promotion":
                            return 1;
                        case "transfer out":
                            return 2;
                        case "TBA":
                        case "transfer in":
                        case "new hire":
                        case "new-hire-null":
                            return 3;
                        case "stay":
                            return 4;
                        case "promoted":
                            return 5;
                        case "replacement":
                            return 6;
                        case "termination":
                            return 4;
                        default:
                            return 4;
                    }
                    break;
            }
        }

        function getDataMppIsOne() {
            angular.element("#orgTableContent").block();
            var response = Mpp.query({
                action: "viewMppChartTable",
                layer: vm.layer,
                maxDepth: vm.maxDepth,
                year: vm.yearSelected,
                isOneMpp: true,
                isLayerID: false
            });
            response.$promise.then(fetchDataMpp);
            response.$promise.catch(catchDataMpp);
        }

        function catchDataMpp(data) {
            console.log(data);
        }

        function getDataMpp() {
            angular.element("#orgTableContent").block();
            var response = Mpp.query({
                action: "viewMppChartTable",
                layer: vm.layer,
                maxDepth: vm.maxDepth,
                year: vm.yearSelected
            });
            response.$promise.then(fetchDataMpp);
            response.$promise.catch(catchErrorDataMpp);
        }

        function catchErrorDataMpp(data) {
            vm.rootLayer = [];
            angular.element("#orgTableContent").unblock();
        }

        function switchBackgroundMonth(parent, total) {
            if (parent !== 1) {
                if (total >= 1) {
                    return "mpp-transaction-type-background-green";
                } else {
                    return "mpp-transaction-type-background-grey";
                }
            }
            return "";
        }

        function fetchDataMpp(data) {
            console.log(data);
            vm.rootLayer = data;
            vm.disableAction = data[0].status === "draft" ? false : true;
            mppService.setApprovalStatus(data[0].status);
            var dt = new Date(data[0].current.date);
            vm.newDt =
                dt.getDate() +
                " " +
                months[dt.getMonth()] +
                " " +
                dt.getFullYear();
            for (var i = 0; i < vm.rootLayer.length; i++) {
                var exists = findToggleCollection(
                    vm.toggleCollection,
                    "id",
                    vm.rootLayer[i].id
                );
                if (exists) {
                    vm.rootLayer[i].childrenVisible = exists.childrenVisible;
                    vm.rootLayer[i].CollapseClass = exists.CollapseClass;
                    if (vm.rootLayer[i].isParent === 1) {
                        findChildren(vm.rootLayer[i].child);
                    }
                }
            }
            angular.element("#orgTableContent").unblock();
            vm.isOneMpp = false;
        }

        function findChildren(data) {
            for (var i = 0; i < data.length; i++) {
                var exists = findToggleCollection(
                    vm.toggleCollection,
                    "id",
                    data[i].id
                );
                if (exists) {
                    data[i].childrenVisible = exists.childrenVisible;
                    data[i].CollapseClass = exists.CollapseClass;
                    if (data[i].isParent === 1) {
                        findChildren(data[i].child);
                    }
                }
            }
        }

        function getDataChild(layerId, childContainer, level, id) {
            angular.element("#loadingBlock" + id).block();
            var response = Mpp.query({
                action: "viewMppChartTable",
                layer: layerId,
                maxDepth: level,
                year: vm.yearSelected,
                isLayerID: true
            });
            response.$promise.then(fetchDataChild).then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    var exists = findObjByKey(childContainer, "id", data[i].id);
                    data[i].level = data[i].level + level;
                    if (!exists) {
                        childContainer.push(data[i]);
                    } else {
                        adjustChildLevel(childContainer, level);
                    }
                }

                angular.element("#loadingBlock" + id).unblock();
            });

            response.$promise.catch(catchErrorDataChild);
        }

        function fetchDataChild(response) {
            angular.element("#mppChartTable").unblock();
            return response[0].child;
        }

        function catchErrorDataChild(response) {
            angular.element("#mppChartTable").unblock();
        }

        function adjustChildLevel(child, parentLevel) {
            child.forEach(function(value) {
                if (value.level < parentLevel) {
                    value.level = parentLevel + 1;
                }
            });
        }

        function toggleChildren(toggle) {
            toggle.childrenVisible = !toggle.childrenVisible;
            toggle.CollapseClass = toggle.childrenVisible
                ? "icon-chevron-down"
                : "icon-chevron-right";
            var exists = findToggleCollection(
                vm.toggleCollection,
                "id",
                toggle.id
            );
            if (!exists) {
                vm.toggleCollection.push({
                    id: toggle.id,
                    childrenVisible: toggle.childrenVisible,
                    CollapseClass: toggle.CollapseClass
                });
            } else {
                vm.toggleCollection[exists.index].childrenVisible =
                    toggle.childrenVisible;
                vm.toggleCollection[exists.index].CollapseClass =
                    toggle.CollapseClass;
            }
            if (toggle.child.length == 0) {
                if (toggle.isParent && toggle.childrenVisible) {
                    getDataChild(
                        toggle.layer_id,
                        toggle.child,
                        toggle.level,
                        toggle.id
                    );
                }
            }
            $localStorage.toggleCollection = vm.toggleCollection;
        }

        function findToggleCollection(array, key, value) {
            for (var i = 0; i < array.length; i++) {
                if (array[i][key] === value) {
                    var response = {
                        index: i,
                        id: array[i][key],
                        childrenVisible: array[i].childrenVisible,
                        CollapseClass: array[i].CollapseClass
                    };
                    return response;
                }
            }
            return null;
        }

        function findObjByKey(array, key, value) {
            for (var i = 0; i < array.length; i++) {
                if (array[i][key] === value) {
                    return true;
                }
            }
            return false;
        }

        function getTotal(item, date) {
            return item.total[date] ? item.total[date] : 1;
        }

        function dotStatus(type) {
            switch (type) {
                case "stay":
                    return "dot stay";
                case "transfer in":
                    return "dot transfer-in";
                case "replacement":
                    return "dot replacement";
                case "promotion":
                    return "dot promotion";
                case "promoted":
                    return "dot promotion";
                case "new hire":
                    return "dot new-hire";
                case "termination":
                    return "dot termination";
                case "transfer out":
                    return "dot transfer-out";
                case "demotion":
                    return "dot demotion";
                case "finish contract":
                    return "dot finish-contract";
                default:
                    return "dot stay";
            }
        }

        function logicMonth(item, date, status) {
            var temp = date.substring(5, 7);
            var final = pad(item + 1);

            if (status == "stay" || status == "promotion") {
                return 1;
            }

            if (temp == final) {
                $localStorage.mppFlag = 1;
                return 1;
            }

            if (item + 1 <= 12) {
                if ($localStorage.mppFlag === 1) {
                    if (item + 1 === 12) {
                        $localStorage.mppFlag = 0;
                    }
                    return 1;
                } else {
                    if (item + 1 === 12) {
                        $localStorage.mppFlag = 0;
                        if (
                            status != "termination" ||
                            status != "transfer out"
                        ) {
                            return 1;
                        }
                    }
                    return 0;
                }
            }
        }

        function showCancel(data, e) {
            var response = Auth.setToken();
            console.log("cancel", data);
            response.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title("Cancel Action ?")
                    .textContent(
                        "Would you like to cancel " +
                            data.transaction_type.toUpperCase() +
                            " transanction ?"
                    )
                    .ariaLabel("cancel action")
                    .targetEvent(e)
                    .ok("Please do it!")
                    .cancel("No, Sorry");

                $mdDialog.show(confirm).then(function() {
                    cancelAction(data.mpp_detail_id);
                });
            });
        }

        function showDelete(data, e) {
            var response = Auth.setToken();
            response.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title("Delete Structure ?")
                    .textContent(
                        "Would you like to delete " +
                            data.transaction_type.toUpperCase() +
                            " layer from your structure ?"
                    )
                    .ariaLabel("delete structure")
                    .targetEvent(e)
                    .ok("Please do it!")
                    .cancel("No, Sorry");

                $mdDialog.show(confirm).then(function() {
                    deleteChart(data.mpp_detail_id);
                });
            });
        }

        function deleteChart(id) {
            angular.element("#mppChartTable").block();
            var response = Mpp.delete({
                action: "delete",
                id: id
            });
            response.$promise.then(successDelete);
            response.$promise.catch(failedDelete);
        }

        function cancelAction(id) {
            angular.element("#mppChartTable").block();
            var response = Mpp.delete({
                action: "cancelAction",
                id: id
            });
            response.$promise.then(successCancel);
            response.$promise.catch(failedCancel);
        }

        function successDelete(e) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("MPP Alert Delete Data")
                        .textContent("Success Delete Data")
                        .ariaLabel("MPP alert")
                        .ok("Got it!")
                        .targetEvent(e)
                )
                .then(getDataMpp);
        }

        function successCancel(e) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("MPP Alert Cancel Action")
                        .textContent("Success Cancel Action")
                        .ariaLabel("MPP alert")
                        .ok("Got it!")
                        .targetEvent(e)
                )
                .then(getDataMpp);
        }

        function successMerge(e) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("MPP Alert Merge Data")
                        .textContent("Success Merge Data")
                        .ariaLabel("MPP alert")
                        .ok("Got it!")
                        .targetEvent(e)
                )
                .then(getDataMpp);
        }

        function failedMerge(e) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("MPP Alert Merge data")
                        .textContent("Failed merge data")
                        .ariaLabel("MPP alert")
                        .ok("Got it!")
                        .targetEvent(e)
                )
                .then(function() {
                    angular.element("#mppChartTable").unblock();
                });
        }

        function failedDelete(e) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("MPP Alert Delete data")
                        .textContent("Failed delete data")
                        .ariaLabel("MPP alert")
                        .ok("Got it!")
                        .targetEvent(e)
                )
                .then(function() {
                    angular.element("#mppChartTable").unblock();
                });
        }

        function failedCancel(e) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("MPP Alert Cancel Action")
                        .textContent("Failed Cancel Action")
                        .ariaLabel("MPP alert")
                        .ok("Got it!")
                        .targetEvent(e)
                )
                .then(function() {
                    angular.element("#mppChartTable").unblock();
                });
        }

        function pad(num) {
            return (num < 10 ? "0" : "") + num;
        }

        function showMerge(ev, item) {
            $mdDialog
                .show({
                    controller: "MergeMppController",
                    controllerAs: "vm",
                    templateUrl:
                        "app/main/mpp/orgtable/merge-mpp/merge-mpp.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        item: item,
                        year: vm.yearSelected
                    }
                })
                .then(function(status) {
                    if (status) {
                        successMerge(ev);
                    } else {
                        failedMerge(ev);
                    }
                });
        }

        function showCreateLayer(ev, data) {
            $mdDialog
                .show({
                    controller: "CreateLayerMppController",
                    controllerAs: "vm",
                    templateUrl:
                        "app/main/mpp/orgtable/create-layer-mpp/create-layer-mpp.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        collection: data
                    }
                })
                .then(getDataMpp);
        }

        $scope.$on("$destroy", function() {
            delete $localStorage.toggleCollection;
        });
    }
})();

(function () {
    "use strict";

    angular.module("app.product-machine-position", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.product_machine_position", {
            url: "/product_machine_position",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp/product-machine-position/product-machine-position.html",
                    controller: "ProductMachinePositionController as vm"
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.product-machine-position')
        .controller('ProductMachinePositionController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$scope',
        'Auth',
        '$location',
        '$window',
        'config',
        'DataService',
        '$mdDialog',
        '$log',
        '$http'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $scope,
        Auth,
        $location,
        $window,
        config,
        DataService,
        $mdDialog,
        $log,
        $http
    ) {
        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        var ProductMachinePosition = new AppAPI.ProductMachinePosition();
        vm.DataTable = new DataService();
        vm.edit = edit;
        vm.uploadNew = uploadNew;
        vm.remove = remove;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listselected = [];
        vm.showFilter = true;
        vm.loadData = loadData;
        vm.selectedProductChange = selectedProductChange;
        vm.loadProduct = loadProduct;
        vm.product = '';
        vm.searchProduct = '';

        activate();

        function activate() {
            loadProduct('');
            loadData('1');
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function loadProduct(searchText) {
            return $http
                .get(config.api + 'api/productmachineposition?action=getProduct&search=' + searchText)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.product = '';
                        vm.product_id = '';
                    }
                    return item.data;
                });
        }

        function loadData(pageno) {
            var params = {
                action: 'viewdata',
                product_id: vm.product_id,
            };
            var response = vm.DataTable.loadData(ProductMachinePosition, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                console.log('res', res);
            });
        }

        function selectedProductChange(data) {

            console.log('data', data);

            if (typeof data !== 'undefined') {
                vm.product_id = data.id;
            }
        }

        function uploadNew(ev, data) {
            $mdDialog.show({
                controller: 'AddProductMachinePositionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/product-machine-position/product-machine-position-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    productLists: vm.productLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'EditProductMachinePositionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/product-machine-position/product-machine-position-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    productLists: vm.productLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-hc', {
                obj: {
                    years: vm.mppType,
                    list: vm.listReport
                }
            });
        }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/mppreporthccc/admin/exportData' +
                        '/' +
                        vm.layer.id +
                        '/' +
                        vm.mppType +
                        '/' +
                        vm.costCenter.id +
                        '/' +
                        vm.selectedEmpType +
                        '/' +
                        data.token,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = ProductMachinePosition.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
                    response.$promise.then(loadData);
                }, function () {
                });
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        $scope.$on('$destroy', function () {
            delete $localStorage.reportHC;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.product-machine-position')
        .controller('EditProductMachinePositionController', EditProductMachinePositionController);

    EditProductMachinePositionController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', 'data', 'config', '$element', '$log', '$location', 'FileUploader', '$localStorage'];

    /* @ngInject */
    function EditProductMachinePositionController($q, $mdDialog, Form, AppAPI, data, config, $element, $log, $location, FileUploader, $localStorage) {
        var vm = this;
        vm.saveData = saveData;
        var ProductMachinePosition = AppAPI.ProductMachinePosition();
        Form.initialForm();
        Form.setObject(ProductMachinePosition);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.data = data;

        console.log('data', data);

        var protocol = $location.protocol();
        var host = $location.host();
        vm.existingLinkImage = protocol + '://' + host + config.api + 'api' + data.link_image;
        console.log('vm.existingLinkImage', vm.existingLinkImage);

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/productmachineposition/uploadfile',
            removeAfterUpload: true,
            alias: 'image_file',
            formData: [
                {
                    action: 'uploadfile',
                    product_id: vm.data.id
                }
            ],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        uploaderPhoto.onSuccessItem = function (item) {
            vm.UploadPhotoStateSucces = true;
            vm.UploadPhotoStateError = false;
            angular.element('#uploaderPhoto').val('');

            setTimeout(function () {
                closeModal();
            }, 2000);
        };

        uploaderPhoto.onErrorItem = function () {
            vm.UploadPhotoStateSucces = false;
            vm.UploadPhotoStateError = true;
        };

        function saveData(ev, formController) {
            vm.Form.objForm.product_id = vm.Form.objForm.product;
            var promise = Form.saveData('update', formController, ProductMachinePosition);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.product-machine-position')
        .controller('AddProductMachinePositionController', AddProductMachinePositionController);

    AddProductMachinePositionController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', '$element', '$log', 'data', 'FileUploader', 'config', '$localStorage'];

    /* @ngInject */
    function AddProductMachinePositionController($q, $mdDialog, Form, AppAPI, $element, $log, data, FileUploader, config, $localStorage) {
        var vm = this;
        vm.saveData = saveData;
        var ProductMachinePosition = AppAPI.ProductMachinePosition();
        Form.initialForm();
        Form.setObject(ProductMachinePosition);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.data = data;

        function closeModal() {
            $mdDialog.hide();
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/productmachineposition/uploadfile',
            removeAfterUpload: true,
            alias: 'image_file',
            formData: [
                {
                    action: 'uploadfile',
                    product_id: vm.data.id
                }
            ],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        uploaderPhoto.onSuccessItem = function (item) {
            vm.UploadPhotoStateSucces = true;
            vm.UploadPhotoStateError = false;
            angular.element('#uploaderPhoto').val('');

            setTimeout(function () {
                closeModal();
            }, 2000);

        };

        uploaderPhoto.onErrorItem = function () {
            vm.UploadPhotoStateSucces = false;
            vm.UploadPhotoStateError = true;
        };

        function saveData(ev, formController) {
            vm.Form.objForm.product_id = vm.Form.objForm.product;
            var promise = Form.saveData('save', formController, ProductMachinePosition);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.orgchart', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state('app.mpp_main.orgchart', {
        url: '/orgchart',
        views: {
          'mppView@app.mpp_main': {
            templateUrl: 'app/main/mpp/orgchart/orgchart.html',
            controller: 'OrgchartController as vm'
          }
        },
        params: {
          obj: null
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.orgchart')
    .controller('OrgchartController', Controller);

  Controller.$inject = ['$mdDialog', 'AppAPI', 'Auth', '$stateParams', 'mppService', '$scope'];

  /* @ngInject */
  function Controller($mdDialog, AppAPI, Auth, $stateParams, mppService, $scope) {
    var vm = this;
    var Mpp = new AppAPI.Mpp();
    var date = new Date();
    vm.loadStructure = loadStructure;
    vm.options = {};
    vm.listBT = [];
    vm.layer = mppService.getLayer();
    vm.selectedOptions = 'edit';
    vm.listSelection = ['edit','create','delete','add'];
    vm.hide = hide;
    vm.cancel = cancel;

    var i = 0,
      jum = 0,
      items = [],
      objItem;

    activate();

    function activate() {
      initComponents();
    }

    function initComponents() {
      if ($stateParams.obj !== null) {
        vm.layer = $stateParams.obj.layer;
        vm.year = $stateParams.obj.year;
        vm.idTeamLayer = $stateParams.obj.idTeamLayer;
      } else {
        vm.layer = mppService.getLayer();
        vm.year = mppService.getYears();
        vm.idTeamLayer = mppService.getTeamLayer();
      }
      loadStructure();
    }


    function loadStructure() {
      angular.element('#orgchart-area').block();
      var response = Mpp.query({
        action: 'viewMppChart',
        layer: vm.layer,
        year: vm.year,
        idTeamLayer: vm.idTeamLayer
      });
      response.$promise.then(loadOrgchart);
      response.$promise.catch(failedLoadChart);
    }


    function loadOrgchart(data) {
      jum = data.length;
      items = [];
      for (i = 0; i < jum; i++) {
        objItem = new primitives.orgdiagram.ItemConfig(data[i]);
        items.push(objItem);
      };

      angular.element('#orgchart-area').unblock();

      vm.options.items = items;
    }



    function failedLoadChart() {
      angular.element('#orgchart-area').unblock();
    }


    //        None: 0,
    // PageWidth: 1,
    // PageHeight: 2,
    // FitToPage: 3,
    // PrintPreview: 4,
    // AutoSize: 5,
    // SelectionOnly: 6


    var buttons = [];
    buttons.push(new primitives.orgdiagram.ButtonConfig("edit", "ui-icon-gear", "Edit"));
    buttons.push(new primitives.orgdiagram.ButtonConfig("delete", "ui-icon-close", "Delete"));
    buttons.push(new primitives.orgdiagram.ButtonConfig("add", "ui-icon-person", "Add"));
    // buttons.push(new primitives.orgdiagram.ButtonConfig("create", "ui-icon-newwin", "Create" ))



    vm.options.cursorItem = 0;
    vm.options.buttons = buttons;
    vm.options.highlightItem = 0;
    vm.options.hasSelectorCheckbox = primitives.common.Enabled.False;
    vm.options.pageFitMode = 1;
    vm.options.templates = [getContactTemplate()];
    vm.options.defaultTemplateName = "contactTemplate";
    vm.options.connectors = "step";
    vm.options.linesColor = primitives.common.Colors.Teal;
    vm.options.onButtonClick = editMpp;

    function showMenu(e, data) {
      $mdDialog.show({
        controller: 'OrgchartController as vm',
        templateUrl: 'app/main/mpp/orgchart/menu.html',
        parent: angular.element(document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        fullscreen: true
      }).then(function(payload){
        console.log(payload);
        data.name = payload;
        editMpp(e, data);
      }).catch(function(payload){
        console.log(payload);
      });
    }

    function hide(data) {
      $mdDialog.hide(data);
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function editMpp(e, data) {
      // if (data.name === 'create') {
      //   showCreateLayerDialog(e, data);
      //   return;
      // }

      switch (data.context.transaction_type) {
        case 'new hire':
        case 'transfer in':
          switch (data.name) {
            case 'edit':
              $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert')
                .textContent('This Action not allowed to used')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
              );
              break;
            case 'delete':
              var response = Auth.setToken();
              response.then(function () {
                var confirm = $mdDialog.confirm()
                  .title('Delete Structure ?')
                  .textContent('Would you like to delete ' + data.context.description + ' layer from your structure ?')
                  .ariaLabel('delete structure')
                  .targetEvent(e)
                  .ok('Please do it!')
                  .cancel('No, Sorry');

                $mdDialog.show(confirm).then(function () {
                  deleteChart(data.context.id);
                });
              });

              response.catch(function () {
                $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title('MPP Alert')
                  .textContent('Failed Load Token')
                  .ariaLabel('MPP alert')
                  .ok('Got it!')
                  .targetEvent(e)
                );
              });


              break;

            default:
              $mdDialog.show({
                  controller: 'EditmppController as vm',
                  templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
                  parent: angular.element(document.body),
                  targetEvent: e,
                  clickOutsideToClose: true,
                  fullscreen: true,
                  locals: {
                    data: data,
                    year: vm.year
                  }
                })
                .then(loadStructure);
              break;
          }


          break;

        case 'promoted':
        case 'replacement':
          switch (data.name) {
            case 'edit':
              $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert')
                .textContent('This Action not allowed to used')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
              );
              break;

            case 'delete':
              var response = Auth.setToken();
              response.then(function () {
                var confirm = $mdDialog.confirm()
                  .title('Cancel Action ?')
                  .textContent('Would you like to cancel ' + data.context.description + ' transanction ?')
                  .ariaLabel('cancel action')
                  .targetEvent(e)
                  .ok('Please do it!')
                  .cancel('No, Sorry');

                $mdDialog.show(confirm).then(function () {
                  cancelAction(data.context.id);
                });
              });

              response.catch(function () {
                $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title('MPP Alert')
                  .textContent('Failed Load Token')
                  .ariaLabel('MPP alert')
                  .ok('Got it!')
                  .targetEvent(e)
                );
              });

              break;

            default:
              $mdDialog.show({
                  controller: 'EditmppController as vm',
                  templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
                  parent: angular.element(document.body),
                  targetEvent: e,
                  clickOutsideToClose: true,
                  fullscreen: true,
                  locals: {
                    data: data,
                    year: vm.year
                  }
                })
                .then(loadStructure);
              break;
          }

          break;

        case 'promotion':
        case 'demotion':
          // all button not function
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title('MPP Alert')
            .textContent('This Action not allowed to used')
            .ariaLabel('MPP alert')
            .ok('Got it!')
            .targetEvent(e)
          );
          break;
        default:
          $mdDialog.show({
              controller: 'EditmppController as vm',
              templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
              parent: angular.element(document.body),
              targetEvent: e,
              clickOutsideToClose: true,
              fullscreen: true,
              locals: {
                data: data,
                year: vm.year
              }
            })
            .then(loadStructure);
          break;
      }


    }

    function deleteChart(id) {
      angular.element('#orgchart-area').block();
      var response = Mpp.delete({
        action: 'delete',
        id: id
      });
      response.$promise.then(successDelete);
      response.$promise.catch(failedDelete);
    }

    function cancelAction(id) {
      angular.element('#orgchart-area').block();
      var response = Mpp.delete({
        action: 'cancelAction',
        id: id
      });
      response.$promise.then(successCancel);
      response.$promise.catch(failedCancel);
    }

    function successDelete(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Delete Data')
        .textContent('Success Delete Data')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(loadStructure);

    }

    function successCancel(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Cancel Action')
        .textContent('Success Cancel Action')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(loadStructure);
    }

    function showCreateLayerDialog(ev, data) {
      $mdDialog.show({
        controller: 'CreateLayerController',
        controllerAs: 'vm',
        templateUrl: 'app/main/mpp/orgchart/create-layer.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          collection: data
        }
      }).then(loadStructure);
    }

    function failedDelete(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Delete data')
        .textContent('Failed delete data')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(function () {
        angular.element('#orgchart-area').unblock();
      });

    }

    function failedCancel(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Cancel Action')
        .textContent('Failed Cancel Action')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(function () {
        angular.element('#orgchart-area').unblock();
      });

    }

    function getContactTemplate() {
      var result = new primitives.orgdiagram.TemplateConfig();
      result.name = "contactTemplate";

      result.itemSize = new primitives.common.Size(225, 65);
      result.minimizedItemSize = new primitives.common.Size(10, 10);
      result.minimizedItemCornerRadius = 5;
      result.highlightPadding = new primitives.common.Thickness(2, 2, 2, 2);



      var itemTemplate = jQuery(
        '<div class="bp-item bp-corner-all bt-item-frame md-whiteframe-3dp" >' +
        '<div class="bp-item bp-photo-frame" style="width: 50px; height: 65px;border-radius:0px;">' +
        '<img name="photo" src="{{itemConfig.image}}" style="height: 65px; width:50px;" onerror="this.src=\'assets/images/avatars/profile.jpg\';" />' +
        '</div>'

        +
        '<div name="phone" class="bp-item" style="padding-left:65px;line-height: 110%;padding-top:2px;">' +
        '<div style="padding-bottom:0px;text-transform: uppercase !important; font-size:9px;">{{itemConfig.fullName}} </div>' +
        '<div style="border-top:1px dotted #000000;padding-top:1px;font-style:italic;text-transform: capitalize;font-size:9px;"> {{itemConfig.description}}</div>' +
        '</div>'
        // + '<div class="bp-item" style="top: 20px; left: 58px; width: 162px; height: 18px; font-size: 12px;">{{itemConfig.description}}</div>'
        //+ '<div name="description" class="bp-item" style="top: 35px; left: 58px; width: 162px; height: 36px; font-size: 10px;">{{itemConfig.email}}</div>'
        +
        '</div>'
      ).css({
        width: result.itemSize.width + "px",
        height: result.itemSize.height + "px"
      });


      result.itemTemplate = itemTemplate.wrap('<div>').parent().html();

      return result;
    }

    $scope.$on('years_updated', function (e, data) {
      vm.year = mppService.getYears();
      vm.layer = mppService.getLayer();
      vm.idTeamLayer = mppService.getTeamLayer();
      loadStructure();
    })

  }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.orgchart')
    .controller('EditmppController', Controller);

  Controller.$inject = ['$mdDialog', 'data', 'AppAPI', 'Form', 'Auth', 'year', '$scope', '$http', 'config'];

  /* @ngInject */
  function Controller($mdDialog, data, AppAPI, Form, Auth, year, $scope, $http, config) {
    var vm = this;
    var Employement = new AppAPI.Employement();
    var orgChart = new AppAPI.Orgchart();
    vm.showErrorEmployee = false;


    //  Tambahan variable
    vm.searchText = '';
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.isNameShow = true;

    vm.fullName = data.context.fullName;
    vm.description = data.context.description;
    vm.image = data.context.image;
    vm.parentDescription = data.parentItem.description;
    vm.joinDate = data.context.join_date;
    vm.losYear = data.context.los_year;
    vm.losMonth = data.context.los_month;
    vm.empType = data.context.emp_type;
    vm.getListMppLayer = getListMppLayer;
    // vm.transactionType=data.context.transaction_type;
    vm.hide = hide;
    vm.cancel = cancel;
    vm.actionLists = [];
    vm.menuName = data.name;
    vm.saveMpp = saveMpp;

    vm.saveProcess = false;

    // initial form
    Form.initialForm();

    // get constructor form
    var Mpp = AppAPI.Mpp();

    // set constructor form
    Form.setObject(Mpp);

    // set form to controller
    vm.Form = Form;

    vm.Form.objForm.id = data.context.id;
    vm.Form.objForm.parentID = data.context.parent;
    vm.Form.objForm.transactionType = data.context.transaction_type;
    vm.Form.objForm.actionType = data.name;
    vm.Form.objForm.isDuplicate = false;
    vm.Form.objForm.nik = data.context.nik;
    vm.Form.objForm.year = year;
    vm.Form.objForm.nikStay = null;
    vm.Form.objForm.dateFulfill = data.context.date_fulfil == '1970-01-01' ? null : new Date(data.context.date_fulfil);
    vm.setValue = setValue;
    vm.setToken = Auth.setToken;
    vm.modalTheme = 'modal-theme';
    switch (data.name) {
      case 'edit':
        vm.titleForm = 'UPDATE TEAM MEMBER';
        vm.Form.objForm.id = data.context.id;
        vm.Form.objForm.mppMasterId = data.context.mpp_master_id;
        vm.Form.objForm.nik = data.context.nik;
        vm.actionLists = [{
            value: 'stay',
            description: 'Stay'
          },
          {
            value: 'promotion',
            description: 'Promotion'
          },
          {
            value: 'demotion',
            description: 'Demotion'
          }
        ];
        getLayerMpp(data.context.mpp_master_id, year);
        break;
      case 'add':
        vm.titleForm = 'ADD TEAM MEMBER';
        vm.Form.objForm.parentID = data.context.id; // id detail baris / kotak yang di klik
        vm.Form.objForm.parentLayerID = data.context.layer_id; // layer id baris / kotak yang di klik
        vm.Form.objForm.mppMasterIdParent = data.context.mpp_master_id;
        vm.Form.objForm.parentLayerType = data.context.layer_type;
        getLayer(data.context.layer_id, 1);
        vm.Form.objForm.dateFulfill = null;
        vm.Form.objForm.id = data.context.id;
        vm.Form.objForm.transactionType = null;
        if (data.context.transaction_type == 'promoted') {
          vm.actionLists = [{
              value: 'new hire',
              description: 'New Hire'
            },
            {
              value: 'replacement',
              description: 'Replace this position'
            }
          ];
        } else {
          vm.actionLists = [{
              value: 'new hire',
              description: 'New Hire'
            },
            {
              value: 'transfer in',
              description: 'Transfer In'
            },
            {
              value: 'stay',
              description: 'Stay'
            }
          ];
        }


        vm.fullName = 'TBD';
        vm.description = '-';
        vm.parentDescription = data.context.description;
        vm.image = '-';
        vm.joinDate = '-';
        vm.losYear = '-';
        vm.losMonth = '-';
        vm.empType = '-';
        break;
      case 'delete':
        vm.titleForm = 'REDUCTION TEAM MEMBER';
        vm.modalTheme = 'modal-theme-red';
        vm.actionLists = [{
            value: 'finish contract',
            description: 'Finish Contract'
          },
          {
            value: 'termination',
            description: 'Termination'
          },
          {
            value: 'transfer out',
            description: 'Transfer Out'
          },
          {
            value: 'delete',
            description: 'Delete'
          }
        ];
        vm.listLayer = [];
        break;
    }

    function hide() {
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function setValue(type) {

      switch (data.name) {
        case 'add':
          if (type == 'replacement') {
            vm.isNameShow = true;
            vm.saveProcess = false;
            vm.showErrorEmployee = false;
            vm.Form.objForm.layerID = data.context.layer_id;
            vm.Form.objForm.parentLayerID = data.parentItem.layer_id;
            vm.parentDescription = data.parentItem.description;
            vm.Form.objForm.quantity = 1;
            vm.Form.objForm.parentID = data.context.parent;
            vm.Form.objForm.nik = data.context.nik;
          } else if (type == 'stay') { // Tambahan else if type stay
            vm.isNameShow = false;
            vm.saveProcess = false;
            vm.showErrorEmployee = false;
            vm.Form.objForm.parentLayerID = data.context.layer_id;
            vm.Form.objForm.layerID = null;
            vm.Form.objForm.nik = data.context.nik;
            vm.Form.objForm.mppMasterId = data.context.mpp_master_id;
            vm.parentDescription = data.context.description;
            vm.Form.objForm.quantity = null;
          } else {
            vm.isNameShow = true;
            vm.saveProcess = false;
            vm.showErrorEmployee = false;
            vm.Form.objForm.nik = data.context.nik;
            vm.Form.objForm.parentLayerID = data.context.layer_id;
            vm.Form.objForm.layerID = null;
            vm.parentDescription = data.context.description;
            vm.Form.objForm.quantity = null;
          }
          break;

        case 'edit':
          vm.modalTheme = 'modal-theme';
          if (type == 'demotion') {
            vm.modalTheme = 'modal-theme-red';
          }
          break;

        case 'delete':
          {
            vm.modalTheme = 'modal-theme-red';
          }
      }


    }

    function getLayer(parentID, maxDepth) {
      var response = orgChart.query({
        action: 'viewOrgChart',
        parentID: parentID,
        maxDepth: maxDepth
      });
      response.$promise.then(fetchlayer);
      response.$promise.catch(errorFetchLayer);
    }

    function getLayerMpp(mppMasterId, year) {
      var response = Mpp.query({
        action: 'viewOrgLayer',
        mppMasterId: mppMasterId,
        'year': year
      });
      response.$promise.then(fetchlayer);
      response.$promise.catch(errorFetchLayer);
    }

    function fetchlayer(data) {
      vm.listLayer = data;
    }

    function errorFetchLayer(data) {
      vm.listLayer = [];
    }

    function saveMpp(ev, formController) {

      var dateVal = typeof vm.Form.objForm.dateFulfill == 'undefined' ? '1970-01-01' : vm.Form.objForm.dateFulfill;
      var dt = new Date(dateVal);
      vm.Form.objForm.dateFulfillSave = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
      vm.saveProcess = true;
      vm.Form.objForm.years = vm.year;
      var promise = Form.saveData('save', formController, Mpp);
      promise.then(successSaveMpp);
      promise.catch(failedSaveMpp);

    }

    function successSaveMpp() {
      vm.success = true;
      vm.showErrorEmployee = false;
      vm.saveProcess = false;
    }

    function failedSaveMpp() {
      vm.success = false;
      vm.saveProcess = false;
    }

    // function getListMppMaster() {
    //   var response = Mpp.query({
    //     action: 'getListMppMaster',
    //     year: year
    //   });

    //   response.$promise.then(fetchDataMppMaster);
    //   response.$promise.catch(catchDataMppMaster);
    // }

    // function fetchDataMppMaster(data) {
    //   console.log(data);
    //   vm.mppMaster = data;
    // }

    // function catchDataMppMaster(data) {
    //   vm.mppMaster = [];
    // }


    function getListMppParent() {
      var response = Mpp.query({
        action: 'getListMppParent',
        years : year
      });

      response.$promise.then(fetchDataMppParent);
      response.$promise.catch(catchDataMppParent);
    }

    function fetchDataMppParent(data) {
      console.log(data);
      vm.mppParent = data;
    }

    function catchDataMppParent(data) {
      vm.mppParent = [];
    }

    function getListMppLayer(item) {
      console.log(item);
      var response = Mpp.query({
        action: 'getListMppLayer',
        parentLayerId: item.id
      });

      response.$promise.then(fetchDataMppLayer);
      response.$promise.catch(catchDataMppLayer);
    }

    function fetchDataMppLayer(data) {
      vm.layerDetail = data;
    }

    function catchDataMppLayer(data) {
      vm.layerDetail = [];
    }


    $scope.$watch('vm.Form.objForm.transactionType', function (newValue) {
      if (newValue === 'transfer out') {
        getListMppParent();
      }
    })


    // Tambahan function mulai dari sini

    function querySearch(params) {
      return $http
        .get(config.api + 'api/mpp?action=getTeamMember&search=' + params)
        .then(function (item) {
          return item.data;
        });
    }

    function selectedItemChange(item) {
      if (item) {
        var validation = orgChart.get({
          action : 'checkEmployeeExistsMppDetail',
          nik    : item.nik,
          years  : year
        });

        validation.$promise.then(function(response){
          if (response.status === 1) {
            vm.saveProcess = false;
            vm.showErrorEmployee = false;
            vm.Form.objForm.nikStay = item.nik;
          } else {
            vm.saveProcess = true;
            vm.showErrorEmployee = true;
            vm.messagesErrorEmployee = response.message;
          }
        });

      }
    }




  }
})();

(function(){
  'use strict';

  angular
    .module('app.mpp.orgchart')
    .controller('CreateLayerController', Controller);

  Controller.$inject = ['$mdDialog', 'AppAPI', 'Form', 'Auth', 'collection'];

  /* @ngInject */
  function Controller($mdDialog, AppAPI, Form, Auth, collection) {
    var vm = this;

    // initial form
    Form.initialForm();

    // get constructor form
    var Mpp = AppAPI.Mpp();

    vm.layerID = collection.context.layer_id;
    console.log(collection);
    vm.orgLevelID = collection.context.org_level_id;
    vm.classificationCode = [];
    vm.saveData = saveData;
    vm.hide=hide;

    // set constructor form
    Form.setObject(Mpp);

    // set form to controller
    vm.Form = Form;

    console.log(collection);

    activate();

    function activate() {
      getEmpClassification();
      getCostCenter();
      getListOrgLevel();
      getBusinessTitle();
      getLocationMpp();
    }



    function saveData(formController) {
      console.log(vm.Form.objForm)
      console.log(formController);
      vm.Form.objForm.layer_id =  vm.layerID;
      var promise = Form.saveData('addLayer', formController, Mpp);
      promise.then(succesSave);
      promise.catch(failedSaveData);
    }

    function succesSave(data) {
      console.log(data);
    }

    function failedSaveData(data) {
      console.log(data);
    }

    function getEmpClassification() {
      var response = Mpp.query({
        action: 'getEmpClasification'
      });
      response.$promise.then(fetchResponseEmpClassification);
      response.$promise.catch(catchResponseEmpClassification);
    }

    function fetchResponseEmpClassification(data) {
      vm.classificationCode = data;
    }

    function catchResponseEmpClassification(data) {
      vm.classificationCode = [];
    }


    function getCostCenter() {
      var response = Mpp.query({
        action: 'getCostCenter'
      });
      response.$promise.then(fetchResponseCostCenter);
      response.$promise.catch(catchResponseCostCenter);
    }

    function fetchResponseCostCenter(data) {
      vm.costCenter = data;

    }

    function catchResponseCostCenter(data) {
      vm.costCenter = [];
    }


    function getListOrgLevel() {
      var response = Mpp.query({
        action: 'getListOrgLevel',
        org_level_id: vm.orgLevelID
      });
      response.$promise.then(fetchResponseOrgLevel);
      response.$promise.catch(catchResponseOrgLevel);
    }

    function fetchResponseOrgLevel(data) {
      vm.orgLevel = data;

    }

    function catchResponseOrgLevel(data) {
      vm.orgLevel = [];
    }


    function getBusinessTitle() {
      var response = Mpp.query({
        action: 'getBusinessTitle'
      });
      response.$promise.then(fetchResponseBusinessTitle);
      response.$promise.catch(catchResponseBusinessTitle);
    }

    function fetchResponseBusinessTitle(data) {
      vm.businessTitle = data;
    }

    function catchResponseBusinessTitle(data) {
      vm.businessTitle = [];
    }


    function getLocationMpp() {
      var response = Mpp.query({
        action: 'getLocationMpp'
      });
      response.$promise.then(fetchResponseLocation);
      response.$promise.catch(catchResponseLocation);
    }

    function fetchResponseLocation(data) {
      vm.location = data;
    }

    function catchResponseLocation(data) {
      vm.location = [];
    }

    function hide()
    {
      $mdDialog.hide();
    }


  }
})();

(function () {
    "use strict";

    angular
        .module("app.mpp", [
            "app.mpp.orgchart",
            "app.mpp.orgtable",
            "app.mpp.approval",
            "app.mpp.compare-chart",
            "app.mpp.report",
            "app.mpp-standard",
            "app.timestudy-standard",
            "app.emp-line-position",
            "app.product-machine-position",
            "app.activity-foreman",
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mpp_main", {
            url: "/mpp",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp/mpp.html",
                    controller: "MppController as vm"
                }
            }
        });
    }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp')
    .controller('OrgLegendController', OrgLegendController);

  OrgLegendController.$inject = ['$mdToast'];

  /* @ngInject */
  function OrgLegendController($mdToast) {
    var vm  = this;
    vm.closeToast = closeToast;
    vm.tableLegend = [
      {'text' : 'stay', 'class' : 'stay'},
      {'text' : 'promotion', 'class' : 'promotion'},
      {'text' : 'termination', 'class' : 'termination'},
      {'text' : 'transfer out', 'class' : 'transfer-out'},
      {'text' : 'replacement', 'class' : 'replacement'},
      {'text' : 'demotion', 'class' : 'demotion'},
      {'text' : 'transfer in', 'class' : 'transfer-in'},
      {'text' : 'transfer out', 'class' : 'transfer-out'},
      {'text' : 'finish contract', 'class' : 'finish-contract'},
      {'text' : 'new hire', 'class' : 'promotion'}
    ];

    function closeToast() {
      $mdToast.hide();
    }

    console.log(vm.tableLegend);
  }

})();

(function () {
    "use strict";

    angular.module("app.mpp-standard", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mpp_standard", {
            url: "/mpp/standard",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp/mpp-standard/mpp-standard.html",
                    controller: "MppStandardController as vm"
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpp-standard')
        .controller('MppStandardController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$scope',
        'Auth',
        '$location',
        '$window',
        'config',
        'DataService',
        '$mdDialog',
        '$log',
        '$http'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $scope,
        Auth,
        $location,
        $window,
        config,
        DataService,
        $mdDialog,
        $log,
        $http
    ) {
        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        var MppStandard = new AppAPI.MppStandard();
        vm.DataTable = new DataService();
        vm.mppTypeLists = ['foreman', 'worker'];
        vm.mppMachineTypeLists = ['fox', 'swak'];
        vm.mppType = '';
        vm.positionGroupLists = ['processing', 'packaging'];
        vm.positionGroup = '';
        vm.edit = edit;
        vm.add = add;
        vm.remove = remove;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listselected = [];
        vm.showFilter = true;
        vm.loadData = loadData;

        vm.selectedProductChange = selectedProductChange;
        vm.loadProduct = loadProduct;
        vm.product = '';
        vm.searchProduct = '';

        activate();

        function activate() {
            // loadData('1');
            // loadProduct();
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function loadProduct(searchText) {
            return $http
                .get(config.api + 'api/mppstandard?action=getProduct&search=' + searchText)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.product = '';
                        vm.product_id = '';
                    }
                    return item.data;
                });
        }

        function selectedProductChange(data) {
            if (typeof data !== 'undefined') {
                vm.product_id = data.id;
                loadData(1);
            }
        }

        function loadData(pageno) {
            var params = {
                action: 'viewdata',
                product_id: vm.product_id,
                mpp_type: vm.mppType,
                position_group: vm.positionGroup,
                machine_type: vm.machine_type
            };
            var response = vm.DataTable.loadData(MppStandard, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                console.log('res', res);

                vm.processingCount = 0;
                vm.packagingCount = 0;

                res.list.find(function (row) {
                    if (row.position_group === 'processing' && row.mpp_type !== 'foreman') {
                        vm.processingCount += 1;
                    }
                    if (row.position_group === 'packaging' && row.mpp_type !== 'foreman') {
                        vm.packagingCount += 1;
                    }
                });

            });
        }

        // function loadProduct() {
        //     var response = MppStandard.query({
        //         action: 'getProduct'
        //     });
        //     response.$promise.then(function (data) {
        //         vm.productLists = data;
        //     });
        //     response.$promise.catch(function (data) {
        //         $log.info(data);
        //     });
        // }

        function add(ev) {
            $mdDialog.show({
                controller: 'AddMppStandardController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/mpp-standard/mpp-standard-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    mppTypeLists: vm.mppTypeLists,
                    positionGroupLists: vm.positionGroupLists
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'EditMppStandardController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/mpp-standard/mpp-standard-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    mppTypeLists: vm.mppTypeLists,
                    positionGroupLists: vm.positionGroupLists
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-hc', {
                obj: {
                    years: vm.mppType,
                    list: vm.listReport
                }
            });
        }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/mppreporthccc/admin/exportData' +
                        '/' +
                        vm.layer.id +
                        '/' +
                        vm.mppType +
                        '/' +
                        vm.costCenter.id +
                        '/' +
                        vm.selectedEmpType +
                        '/' +
                        data.token,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = MppStandard.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
                    response.$promise.then(loadData);
                }, function () {
                });
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        $scope.$on('$destroy', function () {
            delete $localStorage.reportHC;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpp-standard')
        .controller('EditMppStandardController', EditMppStandardController);

    EditMppStandardController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', 'data', '$element', '$log', 'mppTypeLists', 'positionGroupLists'];

    /* @ngInject */
    function EditMppStandardController($q, $mdDialog, Form, AppAPI, data, $element, $log, mppTypeLists, positionGroupLists) {
        var vm = this;
        vm.saveData = saveData;
        var MppStandard = AppAPI.MppStandard();
        Form.initialForm();
        Form.setObject(MppStandard);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.positionGroupLists = positionGroupLists;
        vm.mppTypeLists = mppTypeLists;

        vm.selectedProduct = selectedProduct;
        vm.loadProduct = loadProduct;
        vm.searchProduct;
        vm.clearSearch = function () {
            vm.searchProduct = '';
        };
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        // console.log('data', data);

        vm.Form.objForm.id = data.id;
        loadProduct().then(function () {
            vm.Form.objForm.product = data.product_id;
        });
        vm.Form.objForm.position_name = data.position_name;
        vm.Form.objForm.qty = data.qty;
        vm.Form.objForm.mpp_type = data.mpp_type;
        vm.Form.objForm.position_group = data.position_group;
        vm.Form.objForm.gender = data.gender;
        vm.Form.objForm.symbol_location = data.symbol_location;


        function loadProduct() {
            var defer = $q.defer();
            var response = MppStandard.query({
                action: 'getProduct'
            });
            response.$promise.then(function (data) {
                vm.productLists = data;
                defer.resolve();
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.rerject();
            });
            return defer.promise;
        }

        function selectedProduct(id) {
            var product = vm.productLists.find(function (t) {
                if (t.id === id) {
                    return t;
                }
            });
            return product;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.product_id = vm.Form.objForm.product;
            var promise = Form.saveData('update', formController, MppStandard);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.mpp-standard')
        .controller('AddMppStandardController', AddMppStandardController);

    AddMppStandardController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', '$element', '$log', 'mppTypeLists', 'positionGroupLists'];

    /* @ngInject */
    function AddMppStandardController($q, $mdDialog, Form, AppAPI, $element, $log, mppTypeLists, positionGroupLists) {
        var vm = this;
        vm.saveData = saveData;
        var MppStandard = AppAPI.MppStandard();
        Form.initialForm();
        Form.setObject(MppStandard);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.positionGroupLists = positionGroupLists;
        vm.mppTypeLists = mppTypeLists;

        vm.selectedProduct = selectedProduct;
        vm.loadProduct = loadProduct;
        vm.searchProduct;
        vm.Form.objForm.qty = 1;
        vm.clearSearch = function () {
            vm.searchProduct = '';
        };
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        loadProduct();

        function loadProduct() {
            var defer = $q.defer();
            var response = MppStandard.query({
                action: 'getProduct'
            });
            response.$promise.then(function (data) {
                vm.productLists = data;
                defer.resolve();
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.rerject();
            });
            return defer.promise;
        }

        function selectedProduct(id) {
            var product = vm.productLists.find(function (t) {
                if (t.id === id) {
                    return t;
                }
            });
            return product;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.product_machine_position_id = vm.Form.objForm.product;
            var promise = Form.saveData('save', formController, MppStandard);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    "use strict";

    angular.module("app.emp-line-position", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.emp_line_position", {
            url: "/emp_line_position",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp/emp-line-position/emp-line-position.html",
                    controller: "EmpLinePositionController as vm"
                }
            },
            params: {
                activity_foreman: null
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.emp-line-position')
        .controller('EmpLinePositionController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$scope',
        'Auth',
        '$location',
        '$window',
        'config',
        'DataService',
        '$mdDialog',
        '$log',
        '$http',
        '$stateParams',
        '$q'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $scope,
        Auth,
        $location,
        $window,
        config,
        DataService,
        $mdDialog,
        $log,
        $http,
        $stateParams,
        $q
    ) {
        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        var EmpLinePosition = new AppAPI.EmpLinePosition();
        var ActivityForeman = new AppAPI.ActivityForeman();
        vm.DataTable = new DataService();
        vm.edit = edit;
        vm.add = add;
        vm.remove = remove;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listselected = [];
        vm.showFilter = true;
        vm.loadData = loadData;
        vm.loadProduct = loadProduct;
        vm.searchProduct = '';
        vm.jumEmployee = {
            count: 0,
            jumTemp: 0
        }
        activate();
        if ($stateParams.activity_foreman) {
            var dataActivity = $stateParams.activity_foreman
            vm.effective_date = new Date(dataActivity.production_date);
            vm.product = {
                id: dataActivity.product_id,
                sku: dataActivity.sku,
                description: dataActivity.nama_produk
            };
            vm.line_id = dataActivity.gedung_sector_line_id;
            loadData(1);
        }

        function activate() {
            // loadData('1');
            // loadProduct();
            loadLinePosition();
        }


        function loadLinePosition() {
            var response = EmpLinePosition.query({
                action: 'getLineForeman',
                search: ''
            });
            response.$promise.then(function (data) {
                vm.listLineForeman = data;
            });
            response.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function loadData(pageno) {
            var params = {
                action: 'viewdata',
                product_id: vm.product.id,
                effective_date: (vm.effective_date) ? setTimeStamp(vm.effective_date) : null,
                line_id: vm.line_id
            };
            var response = vm.DataTable.loadData(EmpLinePosition, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                vm.processingCount = 0;
                vm.processingIsiCount = 0;
                vm.packagingCount = 0;
                vm.packagingIsiCount = 0;

                res.list.find(function (row) {
                    if (row.position_group === 'processing' && row.mpp_type !== 'foreman') {
                        vm.processingCount += 1;
                        if (row.nik) {
                            vm.processingIsiCount += 1;
                        }
                    }
                    if (row.position_group === 'packaging' && row.mpp_type !== 'foreman') {
                        vm.packagingCount += 1;
                        if (row.nik) {
                            vm.packagingIsiCount += 1;
                        }
                    }
                });
                getDataSupport(vm.effective_date, vm.line_id, vm.product.id);
                lookupAllEmployee();

                console.log('res', res);
            });
        }

        function loadProduct(search) {
            return $http
                .get(config.api + 'api/emplineposition?action=getProduct&search=' + search)
                .then(function (res) {
                    console.log('res', res);
                    var datas = [];
                    // for (var i = 0; i < res.data.length; i++) {
                    //     var index = vm.mppStandardListsTemp.map(function (e) {
                    //         if (e.nik) {
                    //             return e.nik.nik;
                    //         } else {
                    //             return 1
                    //         }
                    //     }).indexOf(res.data[i].nik);
                    //     if (index == -1) {
                    //         datas.push(res.data[i]);
                    //     }
                    // }
                    return res.data;
                }).catch(function (err) {
                    console.log('err', err);
                });
            // if (search.length > 2) {

            // var response = EmpLinePosition.query({
            //     action: 'getProduct',
            //     search: search
            // });
            // response.$promise.then(function (data) {
            //     return data;
            // });
            // response.$promise.catch(function (data) {
            //     $log.info(data);
            // });
            // }
        }

        function add(ev, item) {
            $mdDialog.show({
                controller: 'AddEmpLinePositionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/emp-line-position/emp-line-position-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    _data: item,
                    productLists: vm.productLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'EditEmpLinePositionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/emp-line-position/emp-line-position-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    productLists: vm.productLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-hc', {
                obj: {
                    years: vm.mppType,
                    list: vm.listReport
                }
            });
        }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/mppreporthccc/admin/exportData' +
                        '/' +
                        vm.layer.id +
                        '/' +
                        vm.mppType +
                        '/' +
                        vm.costCenter.id +
                        '/' +
                        vm.selectedEmpType +
                        '/' +
                        data.token,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = EmpLinePosition.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listselected)
                    });
                    response.$promise.then(loadData);
                }, function () {});
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        $scope.$on('$destroy', function () {
            delete $localStorage.reportHC;
        });

        function setTimeStamp(date) {
            if (date == null || date == undefined || date == '') {
                var dataTimeStamp = (new Date().getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            } else {
                var dataTimeStamp = (new Date(date).getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            }

        }

        function lookupAllEmployee() {

            var response = EmpLinePosition.query({
                action: 'searchEmployee',
                effective_date: setTimeStamp(vm.effective_date),
                line_id: vm.line_id
            });
            response.$promise.then(fetchDataAllEmployee);
            response.$promise.catch(errorFetchDataAllEmployee);
        }

        function fetchDataAllEmployee(data) {
            vm.jumEmployee = {
                count: data.length,
                jumTemp: data.length
            };
            countEmployeeUses();

        }

        function errorFetchDataAllEmployee() {

        }

        function countEmployeeUses() {

            var numberEmployeeAvailable = vm.jumEmployee.jumTemp;
            var numberEmployeeUsed = removeDuplicatesEmployess(vm.DataTable.list);

            if (numberEmployeeAvailable > 0) {
                vm.jumEmployee.count = numberEmployeeUsed.length
            }
        }

        function removeDuplicatesEmployess(arr) {
            var unique_array = []
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].nik) {
                    if (unique_array.map(function (e) {
                            return e.nik;
                        }).indexOf(arr[i].nik) == -1) {
                        unique_array.push(arr[i])
                    }
                }
            }
            return unique_array
        }

        function getDataSupport(effective_date, line_id, product) {
            vm.productTemp = null;
            angular.element.blockUI();
            var defer = $q.defer();
            vm.mppStandardLists = [];
            var response = ActivityForeman.query({
                action: 'checkProductionProduct',
                line_id: line_id,
                effective_date: setTimeStamp(effective_date)
            });
            response.$promise.then(function (data) {
                if (data[0].aData.length > 0) {

                    var datasupport = data[0].aData[0].production_support;
                    for (var i = 0; i < datasupport.length; i++) {
                        vm.DataTable.list.push({
                            no: vm.DataTable.list.length + i + 1,
                            product_name: data[0].aData[0].description,
                            position_name: datasupport[i].activity_name,
                            position_group: 'Support',
                            nik: datasupport[i].nik,
                            fullname: datasupport[i].fullname,
                            line_number: data[0].aData[0].line_number,
                            symbol_location: data[0].aData[0].symbol_location,
                            effective_date: data[0].aData[0].production_date
                        });
                    }

                }
                countEmployeeUses();

                angular.element.unblockUI();
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                angular.element.unblockUI();
                $log.info(data);
                defer.reject();
            });
            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.emp-line-position')
        .controller('EditEmpLinePositionController', EditEmpLinePositionController);

    EditEmpLinePositionController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', 'data', '$element', '$log', 'productLists', '$http', 'config'];

    /* @ngInject */
    function EditEmpLinePositionController($q, $mdDialog, Form, AppAPI, data, $element, $log, productLists, $http, config) {
        var vm = this;
        vm.saveData = saveData;
        var EmpLinePosition = AppAPI.EmpLinePosition();
        Form.initialForm();
        Form.setObject(EmpLinePosition);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.productLists = productLists;
        vm.loadMppStandard = loadMppStandard;
        vm.lookupEmployee = lookupEmployee;
        vm.selectedProduct = selectedProduct;
        vm.searchProduct;
        vm.selectedEmployee = selectedEmployee;
        vm.clearSearch = function () {
            vm.searchProduct = '';
        };
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        console.log('data', data);

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.product = data.product_id;
        vm.Form.objForm.mpp_standard_id = data.mpp_standard_id;
        vm.Form.objForm.nik = data.nik;
        vm.employee = data.nik + ', ' + data.fullname;
        vm.Form.objForm.effective_date = (data.effective_date) ? new Date(data.effective_date) : '';
        loadMppStandard(data.product_id);

        function selectedProduct(id) {
            loadMppStandard(id);
            var product = vm.productLists.find(function (t) {
                if (t.id === id) {
                    return t;
                }
            });
            return product;
        }

        function selectedEmployee(item) {
            vm.employee = item.nik + ', ' + item.fullname;
        }

        function loadMppStandard(product_id) {
            var response = EmpLinePosition.query({
                action: 'getMppStandard',
                product_id: product_id,
                line_id: vm.Form.objForm.line_position,
                effective_date: vm.Form.objForm.effective_date
            });
            response.$promise.then(function (data) {
                vm.mppStandardLists = data;
            });
            response.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function lookupEmployee(searchText) {
            if (searchText.length > 3) {
                return $http
                    .get(config.api + 'api/emplineposition?action=searchEmployee&search=' + searchText)
                    .then(function (res) {
                        console.log('res', res);
                        return res.data;
                    }).catch(function (err) {
                        console.log('err', err);
                    });
            }
        }

        function saveData(ev, formController) {
            // vm.Form.objForm.product_id = vm.Form.objForm.product;
            vm.Form.objForm.nik = vm.selectedNIK.nik;
            var promise = Form.saveData('update', formController, EmpLinePosition);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.emp-line-position')
        .controller('AddEmpLinePositionController', AddEmpLinePositionController);

    AddEmpLinePositionController.$inject = ['$q', '$mdDialog', 'Form', 'AppAPI', '$element', '$log', 'productLists', '_data', '$http', 'config'];

    /* @ngInject */
    function AddEmpLinePositionController($q, $mdDialog, Form, AppAPI, $element, $log, productLists, _data, $http, config) {
        var vm = this;
        vm.saveData = saveData;
        var EmpLinePosition = AppAPI.EmpLinePosition();
        var ActivityForeman = AppAPI.ActivityForeman();
        Form.initialForm();
        Form.setObject(ActivityForeman);
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.productLists = productLists;
        vm.data = _data;
        vm.selectedLinePosition = selectedLinePosition;
        vm.selectedEmployee = selectedEmployee;
        vm.selectedProduct = selectedProduct;
        vm.selectedEffectiveDate = selectedEffectiveDate;
        vm.searchProduct;
        vm.lookupEmployee = lookupEmployee;
        vm.mppStandardLists = [];
        vm.fullJobNik = [];
        vm.resultfullJobNik = [];
        vm.tempChangePortion = [];
        vm.willBeDeletedActivity = [];
        vm.changeNik = changeNik;
        vm.changePortion = changePortion;
        vm.removeItem = removeItem;
        vm.listdatastemp = [];

        getSupportActivity();

        vm.supportActivities = [{
            'id': null,
            'activity_id': '',
            'nik': '',
            'portion': ''
        }];

        vm.addRow = addRow
        vm.removeRow = removeRow

        vm.portionList = [{
                'value': '25',
                'label': '25%'
            },
            {
                'value': '50',
                'label': '50%'
            },
            {
                'value': '75',
                'label': '75%'
            },
            {
                'value': '100',
                'label': '100%'
            }
        ];
        vm.clearSearch = function () {
            vm.searchProduct = '';
        };
        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        if (vm.data) {
            vm.Form.objForm.effective_date = new Date(vm.data.production_date);
            vm.Form.objForm.gedung_id = vm.data.gedung_id;
            vm.Form.objForm.sector_id = vm.data.sector_id;
            vm.Form.objForm.production_product_id = vm.data.production_product_id;
        };

        loadLinePosition().then(function (data) {
            if (vm.data) {
                vm.Form.objForm.line_position = vm.data.line_id;
                setDataSupport(vm.data.production_product_id);
                selectedLinePosition(vm.data.line_id).then(function (data2) {
                    vm.Form.objForm.product = vm.data.product_id;
                    vm.Form.objForm.production_product_id = vm.data.production_product_id;
                    vm.Form.objForm.pp_id = vm.data.production_product_id;
                    selectedProduct(vm.data.product_id);
                });
            }
        });

        function addRow() {
            var row = {
                'id': null,
                'activity_id': '',
                'nik': '',
                'portion': ''
            };
            vm.supportActivities.push(row)
        }

        function removeRow(data, index) {
            if (data.id) {
                vm.willBeDeletedActivity.push(data.id);
            }
            vm.supportActivities.splice(index, 1);

            removeItem(data, data.nik, index);
        }

        function loadLinePosition() {
            var defer = $q.defer();
            var response = EmpLinePosition.query({
                action: 'getLineForeman',
                search: ''
            });
            response.$promise.then(function (data) {
                vm.listLineForeman = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject();
            });
            return defer.promise;
        }

        function getSupportActivity() {
            var response = EmpLinePosition.query({
                action: 'getSupportActivity'
            });
            response.$promise.then(fetchSupportActivity);
            response.$promise.catch(errorFetchSupportActivity);
        }

        function fetchSupportActivity(data) {
            vm.supportActivityList = data;
        }

        function errorFetchSupportActivity() {
            vm.supportActivityList = [];
        }

        function setDataSupport(productId) {
            var response = EmpLinePosition.query({
                action: 'loadDataSupport',
                product_id: productId
            });
            response.$promise.then(fetchDataSupport);
            response.$promise.catch(errorFetchDataSupport);
        }

        function fetchDataSupport(data) {
            vm.supportActivities = [{
                'id': null,
                'activity_id': '',
                'nik': '',
                'portion': ''
            }];
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    data[i].nik = {
                        nik: data[i].nik,
                        fullname: data[i].fullname
                    }
                    var temp = {
                        'nik': data[i].nik.nik,
                        'portion': data[i].portion
                    };
                    vm.fullJobNik.push(temp);
                }

                vm.supportActivities = data;
            }
        }

        function errorFetchDataSupport() {
            vm.supportActivities = [{
                'id': null,
                'activity_id': '',
                'nik': '',
                'portion': ''
            }];
        }

        function selectedLinePosition(line_id) {
            var defer = $q.defer();
            vm.mppStandardLists = [];
            vm.Form.objForm.product = null;
            var response = EmpLinePosition.query({
                action: 'getProductByLinePosition',
                line: line_id,
                production_date: setTimeStamp(vm.Form.objForm.effective_date),
                search: ''
            });
            response.$promise.then(function (data) {
                vm.listProduct = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                $log.info(data);
                defer.reject();
            });
            return defer.promise;
        }

        function selectedEffectiveDate() {
            if (vm.Form.objForm.product && vm.Form.objForm.line_position) {
                loadMppStandard(vm.Form.objForm.product);
            }
        }

        function selectedProduct(id) {
            loadMppStandard(id);
            if (vm.productLists) {
                var product = vm.productLists.find(function (t) {
                    if (t.id === id) {
                        return t;
                    }
                });
                return product;
            }
        }

        function selectedEmployee(item, mppIndex, mppStandarIndex) {
            vm.mppStandardLists[mppIndex].mpp_standar[mppStandarIndex].nik = item.nik + ', ' + item.fullname
        }

        function loadMppStandard(product_id) {
            angular.element.blockUI();
            var response = ActivityForeman.query({
                action: 'getMppStandardByProductMachine',
                product_id: product_id,
                line_id: vm.Form.objForm.line_position,
                effective_date: setTimeStamp(vm.Form.objForm.effective_date)
            });
            response.$promise.then(function (data) {
                var listPosition = removeDuplicates(data);
                vm.mppStandardLists = [];
                vm.mppStandardListsTemp = [];
                var productionProductId = 0;
                for (var i = 0; i < listPosition.length; i++) {
                    vm.mppStandardLists[i] = {
                        position_group: listPosition[i].position_group,
                        mpp_standar: []
                    }
                    for (var j = 0; j < data.length; j++) {
                        if (data[j].position_group == listPosition[i].position_group) {
                            if (vm.data) {
                                if (vm.data.mpp_standard_id == data[j].id) {
                                    data[j].is_focus = true;
                                }
                            };

                            if (data[j].nikemp) {
                                data[j].nik = {
                                    nik: data[j].nikemp,
                                    fullname: data[j].fullname
                                }

                                data[j].portion = parseInt(data[j].portion);
                            }
                            data[j].portion_mpp = parseInt(parseFloat(data[j].portion_mpp))
                            data[j].request = false;

                            vm.mppStandardLists[i].mpp_standar.push(data[j]);
                            vm.mppStandardListsTemp.push(data[j]);
                        }

                    }
                }
                setDataSupport(productionProductId);
                angular.element.unblockUI();

                vm.resultfullJobNik = vm.fullJobNik.reduce(function (r, a) {
                    r[a.nik] = r[a.nik] || [];
                    r[a.nik].push(a.portion);

                    return r;
                }, Object.create(null));
            });
            response.$promise.catch(function (data) {
                angular.element.unblockUI();
                $log.info(data);
            });
        }



        function changePortion(data, from, index, indexGroup) {
            if (data.nik) {
                data.request = false;
                if (indexGroup > 0) {
                    indexGroup = vm.mppStandardLists[indexGroup - 1].mpp_standar.length;
                }

                var listDataS = vm.mppStandardLists;
                var listData = [];

                for (var i = 0; i < listDataS.length; i++) {
                    for (var j = 0; j < listDataS[i].mpp_standar.length; j++) {
                        listData.push(listDataS[i].mpp_standar[j])
                    }
                }

                var indexSameNik = [];
                var indexSupport = [];
                indexSameNik = getAllIndexes(listData, 'mpp', data.nik.nik);
                indexSupport = getAllIndexes(vm.supportActivities, 'support', data.nik.nik);
                if (indexSameNik.length > 0 || indexSupport.length > 0) {
                    var portion = 0;
                    for (var j = 0; j < indexSameNik.length; j++) {
                        if (from == 'mpp') {
                            if ((index + indexGroup) != indexSameNik[j].index) {
                                if (indexSameNik[j].portion) {
                                    portion += parseInt(indexSameNik[j].portion);
                                }
                            }
                        } else {
                            if (indexSameNik[j].portion) {
                                portion += parseInt(indexSameNik[j].portion);
                            }
                        }
                    }
                    for (var i_s = 0; i_s < indexSupport.length; i_s++) {
                        if (from == 'support') {
                            if (index != indexSupport[i_s].index) {
                                if (indexSupport[i_s].portion) {
                                    portion += parseInt(indexSupport[i_s].portion);
                                }
                            }
                        } else {
                            if (indexSupport[i_s].portion) {
                                portion += parseInt(indexSupport[i_s].portion);
                            }
                        }
                    }

                    var portionSum = parseInt(data.portion) + portion;

                    if (portionSum > 100) {
                        data.portion = 0;
                    }
                }
            }
        }

        var findIndex = function (key, val, arr) {
            for (var i = 0, j = arr.length; i < j; i++) {
                if (arr[i][key] == val) {
                    return i;
                }
            }
            return -1;
        };

        function removeItem(data, nik, index) {
            if (typeof nik != "undefined" && typeof vm.resultfullJobNik[nik] != "undefined" && vm.resultfullJobNik[nik].length > 1) {
                var idx = findIndex('nik', nik, vm.fullJobNik);
                vm.fullJobNik.splice(idx, 1);
                if (typeof vm.resultfullJobNik[nik][1] != "undefined") {
                    vm.resultfullJobNik[nik].splice(1, 1);
                }
                var idxtemp = vm.tempChangePortion.indexOf(nik + '_' + index)
                vm.tempChangePortion.splice(idxtemp, 1);

                data.portion = 0;
            }
        }

        function lookupEmployee(searchText) {
            // if (searchText.length > 3) {
            return $http
                .get(config.api + 'api/emplineposition?action=searchEmployee&search=' + searchText + '&effective_date=' + setTimeStamp(vm.Form.objForm.effective_date) + '&line_id=' + vm.Form.objForm.line_position)
                .then(function (res) {
                    console.log('res', res);
                    var datas = [];
                    for (var i = 0; i < res.data.length; i++) {
                        // var index = indexOf(res.data[i].nik);
                        // var listDataS = vm.mppStandardLists;
                        // var listData = [];

                        // for (var i = 0; i < listDataS.length; i++) {
                        //     for (var j = 0; j < listDataS[i].mpp_standar.length; j++) {
                        //         listData.push(listDataS[i].mpp_standar[j])
                        //     }
                        // }

                        var index = [];
                        var indexSupport = [];
                        index = getAllIndexes(vm.listdatastemp, 'mpp', res.data[i].nik);
                        indexSupport = getAllIndexes(vm.supportActivities, 'support', res.data[i].nik);

                        if (index.length > 0 || indexSupport.length > 0) {
                            var portion = 0;
                            for (var j = 0; j < index.length; j++) {
                                if (index[j].portion) {
                                    portion += parseInt(index[j].portion);
                                }
                            }
                            for (var i_s = 0; i_s < indexSupport.length; i_s++) {
                                if (indexSupport[i_s].portion) {
                                    portion += parseInt(indexSupport[i_s].portion);
                                }
                            }
                            if (portion != 100) {
                                datas.push(res.data[i]);
                            }
                        } else {
                            datas.push(res.data[i]);
                        }
                    }
                    return datas;
                }).catch(function (err) {
                    console.log('err', err);
                });
            // }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.mpp_standar = vm.mppStandardLists;
            vm.Form.objForm.support = vm.supportActivities;
            vm.Form.objForm.willBeDeletedActivity = vm.willBeDeletedActivity;
            var promise = Form.saveData('saveLinePositionDashboardForeman', formController, ActivityForeman);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success save update data')
                .textContent(data.pesan)
                .ariaLabel('Success save update data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed save update data')
                .textContent(data.data.pesan)
                .ariaLabel('Failed save upate data')
                .ok('OK')
                .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function removeDuplicates(arr) {
            var unique_array = []
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] != undefined) {
                    if (unique_array.map(function (e) {
                            return e.position_group;
                        }).indexOf(arr[i].position_group) == -1) {
                        unique_array.push(arr[i])
                    }
                }
            }
            return unique_array
        }

        function setTimeStamp(date) {
            if (date == null || date == undefined || date == '') {
                var dataTimeStamp = (new Date().getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            } else {
                var dataTimeStamp = (new Date(date).getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            }
        }

        function changeNik(data, from, index, indexGroup) {
            if (data.nik) {
                data.request = false;
                var indexGrops = indexGroup;
                if (indexGroup > 0) {
                    indexGroup = vm.mppStandardLists[indexGroup - 1].mpp_standar.length;
                }

                var listDataS = vm.mppStandardLists;
                var listData = [];

                for (var i = 0; i < listDataS.length; i++) {
                    for (var j = 0; j < listDataS[i].mpp_standar.length; j++) {
                        listData.push(listDataS[i].mpp_standar[j])
                    }
                }

                vm.listdatastemp = listData;
                var indexSameNik = [];
                var indexSupport = [];
                indexSameNik = getAllIndexes(listData, 'mpp', data.nik.nik);
                indexSupport = getAllIndexes(vm.supportActivities, 'support', data.nik.nik);
                if (indexSameNik.length > 0 || indexSupport.length > 0) {
                    var portion = 0;
                    for (var j = 0; j < indexSameNik.length; j++) {
                        if (from == 'mpp') {
                            if ((index + indexGroup) != indexSameNik[j].index) {
                                if (indexSameNik[j].portion) {
                                    portion += parseInt(indexSameNik[j].portion);
                                }
                            }
                        } else {
                            if (indexSameNik[j].portion) {
                                portion += parseInt(indexSameNik[j].portion);
                            }
                        }
                    }
                    for (var i_s = 0; i_s < indexSupport.length; i_s++) {
                        if (from == 'support') {
                            if (index != indexSupport[i_s].index) {
                                if (indexSupport[i_s].portion) {
                                    portion += parseInt(indexSupport[i_s].portion);
                                }
                            }
                        } else {
                            if (indexSupport[i_s].portion) {
                                portion += parseInt(indexSupport[i_s].portion);
                            }
                        }

                    }
                    if (portion == 50) {
                        data.portion = 50;
                    }
                    if (portion == 75) {
                        data.portion = 25;
                    }
                    if (portion == 25) {
                        data.portion = 75;
                    }

                    if (portion == 0) {
                        if (from == 'mpp') {
                            data.portion = parseInt(vm.mppStandardLists[indexGrops].mpp_standar[index].portion_mpp);
                        } else {
                            data.portion = 100;
                        }
                    }
                } else {
                    data.portion = 0;
                }



            }
            // countEmployeeUses();

        }

        function getAllIndexes(arr, from, val) {
            var indexes = [],
                i = -1;
            while ((i = arr.map(function (e) {
                    if (e.nik) {
                        return e.nik.nik;
                    } else {
                        return 1
                    }
                }).indexOf(val, i + 1)) != -1) {
                if (from == 'mpp') {
                    indexes.push({
                        index: i,
                        portion: vm.mppStandardListsTemp[i].portion
                    });
                } else {
                    indexes.push({
                        index: i,
                        portion: vm.supportActivities[i].portion
                    });
                }

            }
            return indexes;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.compare-chart', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state('app.mpp_main.compare-chart', {
        url: '/compare-chart',
        views: {
          'mppView@app.mpp_main': {
            templateUrl: 'app/main/mpp/compare-chart/compare-chart.html',
            controller: 'CompareChartController as vm'
          }
        },
        params: {
          obj: null
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.compare-chart')
    .controller('CompareChartController', Controller);

  Controller.$inject = ['$mdDialog', 'AppAPI', 'Auth', '$stateParams', 'mppService', '$scope'];

  /* @ngInject */
  function Controller($mdDialog, AppAPI, Auth, $stateParams, mppService, $scope) {
    var vm = this;
    var Mpp = new AppAPI.Mpp();
    var date = new Date();
    vm.loadStructure = loadStructure;
    vm.options = {};
    vm.listBT = [];
    vm.layer = mppService.getLayer();

    var i = 0,
      jum = 0,
      items = [],
      objItem;

    activate();

    function activate() {
      initComponents();
    }

    function initComponents() {
      if ($stateParams.obj !== null) {
        vm.layer = $stateParams.obj.layer;
        vm.year = $stateParams.obj.year;
        vm.idTeamLayer = $stateParams.obj.idTeamLayer;
      } else {
        vm.layer = mppService.getLayer();
        vm.year = mppService.getYears();
        vm.idTeamLayer = mppService.getTeamLayer();
      }
      loadStructure();
    }


    function loadStructure() {
      angular.element('#orgchart-area').block();
      var response = Mpp.query({
        action: 'viewMppChartCompare',
        layer: vm.layer,
        year: vm.year,
        idTeamLayer: vm.idTeamLayer
      });
      response.$promise.then(loadOrgchart);
      response.$promise.catch(failedLoadChart);
    }


    function loadOrgchart(data) {
      jum = data.length;
      items = [];
      for (i = 0; i < jum; i++) {
        objItem = new primitives.orgdiagram.ItemConfig(data[i]);
        items.push(objItem);
      };

      angular.element('#orgchart-area').unblock();

      vm.options.items = items;
    }



    function failedLoadChart() {
      angular.element('#orgchart-area').unblock();
    }


    //        None: 0,
    // PageWidth: 1,
    // PageHeight: 2,
    // FitToPage: 3,
    // PrintPreview: 4,
    // AutoSize: 5,
    // SelectionOnly: 6


    var buttons = [];
    buttons.push(new primitives.orgdiagram.ButtonConfig("edit", "ui-icon-gear", "Edit"));
    buttons.push(new primitives.orgdiagram.ButtonConfig("delete", "ui-icon-close", "Delete"));
    buttons.push(new primitives.orgdiagram.ButtonConfig("add", "ui-icon-person", "Add"));
    buttons.push(new primitives.orgdiagram.ButtonConfig("create", "ui-icon-newwin", "Create" ))



    vm.options.cursorItem = 0;
    vm.options.buttons = buttons;
    vm.options.highlightItem = 0;
    vm.options.hasSelectorCheckbox = primitives.common.Enabled.False;
    vm.options.pageFitMode = 0;
    vm.options.templates = [getContactTemplate()];
    vm.options.defaultTemplateName = "contactTemplate";
    vm.options.connectors = "step";
    vm.options.linesColor = primitives.common.Colors.Teal;
    vm.options.onButtonClick = editMpp;

    function editMpp(e, data) {
      console.log(data.name);
      if (data.name === 'create') {
        showCreateLayerDialog(e, data);
        return;
      }

      switch (data.context.transaction_type) {
        case 'new hire':
        case 'transfer in':
          switch (data.name) {
            case 'edit':
              $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert')
                .textContent('This Action not allowed to used')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
              );
              break;
            case 'delete':
              var response = Auth.setToken();
              response.then(function () {
                var confirm = $mdDialog.confirm()
                  .title('Delete Structure ?')
                  .textContent('Would you like to delete ' + data.context.description + ' layer from your structure ?')
                  .ariaLabel('delete structure')
                  .targetEvent(e)
                  .ok('Please do it!')
                  .cancel('No, Sorry');

                $mdDialog.show(confirm).then(function () {
                  deleteChart(data.context.id);
                });
              });

              response.catch(function () {
                $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title('MPP Alert')
                  .textContent('Failed Load Token')
                  .ariaLabel('MPP alert')
                  .ok('Got it!')
                  .targetEvent(e)
                );
              });


              break;

            default:
              $mdDialog.show({
                  controller: 'EditmppController as vm',
                  templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
                  parent: angular.element(document.body),
                  targetEvent: e,
                  clickOutsideToClose: true,
                  fullscreen: true,
                  locals: {
                    data: data,
                    year: vm.year
                  }
                })
                .then(loadStructure);
              break;
          }


          break;

        case 'promoted':
        case 'replacement':
          switch (data.name) {
            case 'edit':
              $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert')
                .textContent('This Action not allowed to used')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
              );
              break;

            case 'delete':
              var response = Auth.setToken();
              response.then(function () {
                var confirm = $mdDialog.confirm()
                  .title('Cancel Action ?')
                  .textContent('Would you like to cancel ' + data.context.description + ' transanction ?')
                  .ariaLabel('cancel action')
                  .targetEvent(e)
                  .ok('Please do it!')
                  .cancel('No, Sorry');

                $mdDialog.show(confirm).then(function () {
                  cancelAction(data.context.id);
                });
              });

              response.catch(function () {
                $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title('MPP Alert')
                  .textContent('Failed Load Token')
                  .ariaLabel('MPP alert')
                  .ok('Got it!')
                  .targetEvent(e)
                );
              });

              break;

            default:
              $mdDialog.show({
                  controller: 'EditmppController as vm',
                  templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
                  parent: angular.element(document.body),
                  targetEvent: e,
                  clickOutsideToClose: true,
                  fullscreen: true,
                  locals: {
                    data: data,
                    year: vm.year
                  }
                })
                .then(loadStructure);
              break;
          }

          break;

        case 'promotion':
        case 'demotion':
          // all button not function
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title('MPP Alert')
            .textContent('This Action not allowed to used')
            .ariaLabel('MPP alert')
            .ok('Got it!')
            .targetEvent(e)
          );
          break;
        default:
          $mdDialog.show({
              controller: 'EditmppController as vm',
              templateUrl: 'app/main/mpp/orgchart/edit-mpp.html',
              parent: angular.element(document.body),
              targetEvent: e,
              clickOutsideToClose: true,
              fullscreen: true,
              locals: {
                data: data,
                year: vm.year
              }
            })
            .then(loadStructure);
          break;
      }


    }

    function deleteChart(id) {
      angular.element('#orgchart-area').block();
      var response = Mpp.delete({
        action: 'delete',
        id: id
      });
      response.$promise.then(successDelete);
      response.$promise.catch(failedDelete);
    }

    function cancelAction(id) {
      angular.element('#orgchart-area').block();
      var response = Mpp.delete({
        action: 'cancelAction',
        id: id
      });
      response.$promise.then(successCancel);
      response.$promise.catch(failedCancel);
    }

    function successDelete(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Delete Data')
        .textContent('Success Delete Data')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(loadStructure);

    }

    function successCancel(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Cancel Action')
        .textContent('Success Cancel Action')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(loadStructure);
    }

    function showCreateLayerDialog(ev, data) {
      $mdDialog.show({
        controller: 'CreateLayerController',
        controllerAs: 'vm',
        templateUrl: 'app/main/mpp/orgchart/create-layer.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          collection: data
        }
      }).then(loadStructure);
    }

    function failedDelete(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Delete data')
        .textContent('Failed delete data')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(function () {
        angular.element('#orgchart-area').unblock();
      });

    }

    function failedCancel(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Cancel Action')
        .textContent('Failed Cancel Action')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(function () {
        angular.element('#orgchart-area').unblock();
      });

    }

    function getContactTemplate() {
      var result = new primitives.orgdiagram.TemplateConfig();
      result.name = "contactTemplate";

      result.itemSize = new primitives.common.Size(225, 50);
      result.minimizedItemSize = new primitives.common.Size(10, 10);
      result.minimizedItemCornerRadius = 5;
      result.highlightPadding = new primitives.common.Thickness(2, 2, 2, 2);



      var itemTemplate = jQuery(
        '<div class="bp-item bp-corner-all bt-item-frame md-whiteframe-3dp" >' +
        '<div class="bp-item bp-photo-frame" style="top: -1px; left: -1px; width: 40px; height: 50px;border-radius:0px;">' +
        '<img name="photo" src="{{itemConfig.image}}" style="height: 50px; width:40px;" onerror="this.src=\'assets/images/avatars/profile.jpg\';" />' +
        '</div>'

        +
        '<div name="phone" class="bp-item" style="padding-left:45px;line-height: 110%;padding-top:2px;">' +
        '<div style="padding-bottom:0px;text-transform: uppercase !important; font-size:9px;">{{itemConfig.fullName}} </div>' +
        '<div style="border-top:1px dotted #000000;padding-top:1px;font-style:italic;text-transform: capitalize;font-size:9px;"> {{itemConfig.description}}</div>' +
        '</div>'
        // + '<div class="bp-item" style="top: 20px; left: 58px; width: 162px; height: 18px; font-size: 12px;">{{itemConfig.description}}</div>'
        //+ '<div name="description" class="bp-item" style="top: 35px; left: 58px; width: 162px; height: 36px; font-size: 10px;">{{itemConfig.email}}</div>'
        +
        '</div>'
      ).css({
        width: result.itemSize.width + "px",
        height: result.itemSize.height + "px"
      });


      result.itemTemplate = itemTemplate.wrap('<div>').parent().html();

      return result;
    }

    $scope.$on('years_updated', function (e, data) {
      vm.year = mppService.getYears();
      vm.layer = mppService.getLayer();
      vm.idTeamLayer = mppService.getTeamLayer();
      loadStructure();
    })

  }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.approval', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      .state('app.mpp_approval', {
        url: '/approval',
        views: {
          'content@app': {
            templateUrl: 'app/main/mpp/approval/approval.html',
            controller: 'MppApprovalController as vm'
          }
        },
        params: {
          obj: null
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.approval')
    .controller('MppApprovalController', MppApprovalController);

  MppApprovalController.$inject = ['$state', '$localStorage', 'AppAPI', 'Auth', '$mdDialog'];

  /* @ngInject */
  function MppApprovalController($state, $localStorage, AppAPI, Auth, $mdDialog) {
    var vm = this;
    var Mpp = new AppAPI.Mpp();
    var MppApproval = new AppAPI.MppApproval();
    var dt = new Date();
    vm.user = $localStorage.user;
    vm.disableRequestPanel = vm.user == '04000003' ? false : true;
    vm.years = [{
      year: dt.getFullYear() + 1,
      selected: true
    }, {
      year: dt.getFullYear(),
      selected: false
    }];
    vm.year = dt.getFullYear() + 1;
    vm.listApproval = [];
    vm.viewDetail = viewDetail;
    vm.showApprove = showApprove;
    vm.getData = getData;
    vm.requestorData = [];
    vm.getDataApproval = getDataApproval;
    vm.leadTime = leadTime;
    vm.showCancel = showCancel;
    vm.showHistory = showHistory;

    activate();


    function activate() {
      getDataApproval(vm.year);
      getRequestorData();
    }

    function leadTime(start, end) {
      if (!end || !start) {
        return 0;
      }
      var startDate = moment(start);
      var endDate = moment(end);

      var lead = endDate.from(startDate, true);
      return lead;
    }

    function getRequestorData() {
      var response = MppApproval.query({
        action: 'getRequestorData'
      });
      response.$promise.then(function (data) {
        vm.requestorData = data;
      });
      response.$promise.catch(function (err) {
        vm.requestorData = [];
      })
    }

    function getData() {
      var response = Mpp.query({
        action: 'viewListMppApproval',
        year: vm.year,
      });
      response.$promise.then(successResponse);
      response.$promise.catch(errorResponse);
    }


    function successResponse(data) {
      angular.element('#mppApprovalContent').unblock();
      vm.listApproval = data;
    }

    function errorResponse(data) {
      angular.element('#mppApprovalContent').unblock();
      vm.listApproval = [];
    }

    function getDataApproval(year) {
      angular.element('#mppApprovalContent').block();
      changeSelectedYears(year);
      var response = MppApproval.query({
        action: 'viewListMppApproval',
        year: vm.year,
      });
      response.$promise
        .then(successResponse);
      response.$promise.catch(errorResponse);
    }


    function getDataApprovalHistory(item) {
      angular.element('#mppApprovalHistory').block();
      var response = MppApproval.query({
        action: 'viewListMppApprovalHistory',
        mppId: item.mpp_master_id,
      });
      response.$promise.then(fetchApprovalHistory);
      response.$promise.catch(catchApprovalHistory);
    }

    function fetchApprovalHistory(data) {
      angular.element('#mppApprovalHistory').unblock();
      console.log(data);
      vm.listApprovalHistory = data;
    }

    function catchApprovalHistory(params) {
      angular.element('#mppApprovalHistory').unblock();
      vm.listApprovalHistory = [];
    }

    function changeSelectedYears(year) {
      vm.year = dt.getFullYear();
      if (angular.isObject(year)) {
        vm.year = year.year;
        angular.forEach(vm.years, function (key) {
          if (key.year === vm.year) {
            key.selected = true;
          } else {
            key.selected = false;
          }
          params
        });
      } else {
        vm.year = year;
      }
    }

    function viewDetail(item) {
      console.log('item', item);
      var data = {
        'layer': 1,
        'year': vm.year,
        'idTeamLayer': item.layer_id,
        'flag': 2
      }
      $state.go('app.mpp_main.orgtable', {
        obj: data
      });
    }

    function showHistory(data, e) {
      $mdDialog.show({
        controller: 'MppApprovalHistoryController as vm',
        templateUrl: 'app/main/mpp/approval/approval-history.html',
        parent: angular.element(document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          data: data,
        }
      });
    }


    function showApprove(data, e) {
      var response = Auth.setToken();
      response.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Approve Action ?')
          .textContent('Would you like to approve ' + data.description + ' MPP ?')
          .ariaLabel('cancel action')
          .targetEvent(e)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function () {
          approveMpp(data);
        });
      });
    }

    function showCancel(data, e) {
      var response = Auth.setToken();
      response.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Cancel Action')
          .textContent('Would you like to cancel approval ' + data.description + '?')
          .ariaLabel('cancel action')
          .targetEvent(e)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function () {
          cancelMpp(data, e);
        });
      });
    }

    function cancelMpp(item, e) {
      console.log(item);
      var save = Auth.setToken();
      save.then(function () {
        var response = MppApproval.save({
          action: 'cancel',
          id: item.id,
          mpp_master_id: item.mpp_master_id,
          next_approval: item.next_approval
        });
        response.$promise.then(function (data) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title('MPP Alert Cancel Approval')
            .textContent(data.message)
            .ariaLabel('MPP alert')
            .ok('Got it!')
            .targetEvent(e)
          ).then(function () {
            getDataApproval(vm.year);
          });
        });
        response.$promise.catch(function (data) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title('MPP Alert Cancel Approval')
            .textContent(data.message)
            .ariaLabel('MPP alert')
            .ok('Got it!')
            .targetEvent(e)
          ).then(function () {
            angular.element('#mppChartTable').unblock();
          });
        });
      });
    }

    function approveMpp(item) {
      console.log(item);
      var save = Auth.setToken();
      save.then(function () {
        var response = MppApproval.save({
          action: 'approve',
          id: item.id,
          mpp_master_id: item.mpp_master_id,
          next_approval: item.next_approval
        });
        response.$promise.then(successApprove);
        response.$promise.catch(failedApprove);
      });
    }

    function successApprove(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Approve Mpp')
        .textContent('Success Approve Mpp')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(function () {
        getDataApproval(vm.year);
      });
    }

    function failedApprove(e) {
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.body))
        .clickOutsideToClose(true)
        .title('MPP Alert Approve data')
        .textContent('Failed approve data')
        .ariaLabel('MPP alert')
        .ok('Got it!')
        .targetEvent(e)
      ).then(function () {
        angular.element('#mppChartTable').unblock();
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.mpp.approval')
    .controller('MppApprovalHistoryController', MppApprovalHistoryController);

    MppApprovalHistoryController.$inject = ['$state', '$localStorage', 'AppAPI', 'Auth', '$mdDialog', 'data'];

  /* @ngInject */
  function MppApprovalHistoryController($state, $localStorage, AppAPI, Auth, $mdDialog, data) {
    var vm = this;
    var MppApproval = new AppAPI.MppApproval();
    vm.listApprovalHistory = [];
    vm.closeDialog = closeDialog;

    activate();


    function activate() {
      getDataApprovalHistory();
      console.log(data);
    }


    function getDataApprovalHistory() {
      var response = MppApproval.query({
        action: 'viewListMppApprovalHistory',
        mppId: data.mpp_master_id,
      });
      response.$promise.then(fetchApprovalHistory);
      response.$promise.catch(catchApprovalHistory);
    }

    function fetchApprovalHistory(data) {
      angular.element('#mppApprovalHistory').unblock();
      console.log(data);
      vm.listApprovalHistory = data;
    }

    function catchApprovalHistory(params) {
      vm.listApprovalHistory = [];
    }

    function closeDialog() {
      $mdDialog.hide();
    }



  }

})();

(function () {
    'use strict';

    angular
        .module('app.activity-foreman')
        .controller('ActivityForemanController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$scope',
        'Auth',
        '$location',
        '$window',
        'config',
        'DataService',
        '$mdDialog',
        '$log',
        '$http'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $scope,
        Auth,
        $location,
        $window,
        config,
        DataService,
        $mdDialog,
        $log,
        $http
    ) {
        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        var EmpLinePosition = new AppAPI.EmpLinePosition();
        var ActivityForeman = new AppAPI.ActivityForeman();
        vm.DataTable = new DataService();
        vm.DataTableMember = new DataService();
        vm.edit = edit;
        vm.add = add;
        vm.remove = remove;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listselected = [];
        vm.showFilter = true;
        vm.loadData = loadData;
        vm.loadProduct = loadProduct;
        vm.searchProduct = '';
        vm.emp_line_position = emp_line_position;
        vm.tabChange = tabChange;

        vm.filterBy = filterBy;
        vm.filter = '';

        activate();

        function tabChange(idTab) {
            vm.tabId = idTab;
            vm.product = '';
            vm.line_id = '';
            if (idTab == 'activity') {
                (vm.effective_date) ? vm.effective_date = vm.effective_date: vm.effective_date = new Date();
                loadData(1);
            } else {
                loadDataMember(1);
            }
        }

        function activate() {
            // loadData('1');
            // loadProduct();
            loadLinePosition();
        }


        function loadLinePosition() {
            var response = EmpLinePosition.query({
                action: 'getLineForeman',
                search: ''
            });
            response.$promise.then(function (data) {
                vm.listLineForeman = data;
            });
            response.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function loadData(pageno) {
            if (vm.tabId == 'activity') {
                var params = {
                    action: 'viewdata',
                    product_id: (vm.product) ? vm.product.id : '',
                    effective_date: (vm.effective_date) ? setTimeStamp(vm.effective_date) : '',
                    line_id: (vm.line_id) ? vm.line_id : ''
                };
                var response = vm.DataTable.loadData(ActivityForeman, pageno, params);
                vm.listselected = [];
                response.then(function (res) {
                    vm.processingCount = 0;
                    vm.processingIsiCount = 0;
                    vm.packagingCount = 0;
                    vm.packagingIsiCount = 0;

                    res.list.find(function (row) {
                        if (row.position_group === 'processing' && row.mpp_type !== 'foreman') {
                            vm.processingCount += 1;
                            if (row.nik) {
                                vm.processingIsiCount += 1;
                            }
                        }
                        if (row.position_group === 'packaging' && row.mpp_type !== 'foreman') {
                            vm.packagingCount += 1;
                            if (row.nik) {
                                vm.packagingIsiCount += 1;
                            }
                        }
                    });

                    console.log('res', res);
                });
            } else {
                loadDataMember(1);
            }

        }

        function loadDataMember(pageno) {
            var params = {
                action: 'getDetailData',
                product_id: (vm.product) ? vm.product.id : '',
                effective_date: (vm.effective_date) ? setTimeStamp(vm.effective_date) : '',
                line_id: vm.line_id
            };
            var response = vm.DataTableMember.loadData(ActivityForeman, pageno, params);
            response.then(function (res) {
                console.log('res', res);
            });
        }

        function loadProduct(search) {
            return $http
                .get(config.api + 'api/emplineposition?action=getProduct&search=' + search)
                .then(function (res) {
                    console.log('res', res);
                    var datas = [];
                    // for (var i = 0; i < res.data.length; i++) {
                    //     var index = vm.mppStandardListsTemp.map(function (e) {
                    //         if (e.nik) {
                    //             return e.nik.nik;
                    //         } else {
                    //             return 1
                    //         }
                    //     }).indexOf(res.data[i].nik);
                    //     if (index == -1) {
                    //         datas.push(res.data[i]);
                    //     }
                    // }
                    return res.data;
                }).catch(function (err) {
                    console.log('err', err);
                });
            // if (search.length > 2) {

            // var response = ActivityForeman.query({
            //     action: 'getProduct',
            //     search: search
            // });
            // response.$promise.then(function (data) {
            //     return data;
            // });
            // response.$promise.catch(function (data) {
            //     $log.info(data);
            // });
            // }
        }

        function add(ev, item) {
            $mdDialog.show({
                controller: 'AddActivityForemanController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/activity-foreman/add/activity-foreman-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    _data: item,
                    productLists: vm.productLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'EditEmpLinePositionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/activity-foreman/activity-foreman-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data,
                    productLists: vm.productLists,
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-hc', {
                obj: {
                    years: vm.mppType,
                    list: vm.listReport
                }
            });
        }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/mppreporthccc/admin/exportData' +
                        '/' +
                        vm.layer.id +
                        '/' +
                        vm.mppType +
                        '/' +
                        vm.costCenter.id +
                        '/' +
                        vm.selectedEmpType +
                        '/' +
                        data.token,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = ActivityForeman.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listselected)
                    });
                    response.$promise.then(loadData);
                }, function () {});
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        $scope.$on('$destroy', function () {
            delete $localStorage.reportHC;
        });

        function setTimeStamp(date) {
            if (date == null || date == undefined || date == '') {
                var dataTimeStamp = (new Date().getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            } else {
                var dataTimeStamp = (new Date(date).getTime() / 1000);
                return dataTimeStamp.toFixed(0);
            }

        }

        function emp_line_position(activity) {
            $state.go('app.emp_line_position', {
                activity_foreman: activity
            });
        }

        function filterBy(key) {
            vm.filter = key;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.mpn-gw.request')
    .controller('RequestResetSLTGWController', RequestResetSLTGWController);

  function RequestResetSLTGWController(
    $mdDialog,
    mpn,
    Auth,
    AppAPI,
    Form
  ) {

    var vm = this;
    var endpoint = new AppAPI.MpnResetSLT();
    Form.initialForm();
    Form.setObject(endpoint);
    vm.Form = Form;
    vm.mpn = mpn;
    vm.submit = submit;
    vm.closeModal = closeModal;

    function closeModal() {
      $mdDialog.cancel();
    }

    function submit(formController) {
      angular.element.blockUI(); //munculin loading please wait
      vm.Form.objForm.mpn = vm.mpn;
      var promiseAuth = Auth.setToken();

      promiseAuth.then(function () {


        var response = Form.saveData('saveGw', formController, endpoint);

        response.then(function () {
          vm.messageTheme = 'blue';
          angular.element.unblockUI();
          formController.$setPristine();

          $timeout(function () {
            vm.Form.tampilPesan = false;
          }, 3000);

        });

        response.catch(function () {
          vm.messageTheme = 'pink';
          angular.element.unblockUI();
        });


      });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.mpn-gw.ta', ['ui.tinymce']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.mpn_gw_list_ta', {
                url: '/mpngw/list/ta',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mpn-gw/ta/list.html',
                        controller: 'MpnGwTaListController as vm'
                    }
                }
            });
    }



})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.ta')
        .controller('RecruitListController', RecruitListController);

    /** @ngInject */
    RecruitListController.$inject = ['$mdDialog', '$localStorage', '$location', '$window', 'FileUploader', 'config', 'AppAPI', 'id', 'tipe', 'workLocation', 'creator', 'taPic', 'taStatus', 'Auth'];

    function RecruitListController($mdDialog, $localStorage, $location, $window, FileUploader, config, AppAPI, id, tipe, workLocation, creator, taPic, taStatus, Auth) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;
        vm.id = id;
        vm.tipe = tipe;
        vm.closeModal = closeModal;
        vm.uploadFile = FileUploader;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        vm.downloadFormat = downloadFormat;
        vm.listSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.workLocation = workLocation;
        vm.creator = creator;
        vm.taPic = taPic;
        vm.confirm = confirm;
        vm.taStatus = taStatus;
        vm.reOpen = reOpen;
        vm.downloadPKWT = downloadPKWT;

        viewdata();
        vm.isConfirm = isConfirm_();

        function viewdata() {
            vm.data = [];
            var response = endpoint.query({
                action: "viewrecruit",
                id: vm.id
            });

            response.$promise.then(function (data) {
                vm.data = data;
            });

            response.$promise.catch(function () {
                vm.data = [];
            });
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/mpngw/uploadCandidate',
            removeAfterUpload: true,
            alias: 'filecandidate',
            formData: [{
                action: 'uploadCandidate'
            }],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        uploaderPhoto.onSuccessItem = function (response) {
            vm.UploadPhotoStateSucces = true;
            vm.UploadPhotoStateError = false;
            viewdata();
        };

        uploaderPhoto.onErrorItem = function () {
            vm.UploadPhotoStateSucces = false;
            vm.UploadPhotoStateError = true;
        };

        function closeModal() {
            $mdDialog.cancel();
        }

        function downloadFormat() {
            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.api + 'api/mpngw/exportExcellRecruit/' + vm.id, '_blank');
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = [];
            vm.listSelected = angular.copy(vm.data);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function isConfirm_() {
            var nik = $localStorage.user;

            if (vm.workLocation === "133" | vm.workLocation === "132") {
                if (nik === vm.creator) {
                    return 1;
                } else if (nik === vm.taPic) {
                    return 2;
                } else {
                    return 0;
                }

            } else {
                return 0;
            }

        }

        function confirm() {

            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {

                var response = endpoint.save({
                    action: 'setconfirm',
                    idMpn: vm.id,
                    data: vm.listSelected
                });

                response.$promise.then(closeModal());
            });
        }

        function reOpen($ev) {
            console.log(vm.listSelected);

        }

        function downloadPKWT() {
            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.api + 'api/mpngw/exportExcellPKWT/' + vm.id, '_blank');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.ta')
        .controller('MpnGwTaListController', MpnGwTaListController);

    MpnGwTaListController.$inject = [
        "AppAPI",
        "DataService",
        "Auth",
        "config",
        "$localStorage",
        "$state",
        "$mdDialog",
        "$location",
        "$window"
    ];

    function MpnGwTaListController(
        AppAPI,
        DataService,
        Auth,
        config,
        $localStorage,
        $state,
        $mdDialog,
        $location,
        $window
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;

        vm.company = $localStorage.empsite;
        vm.approvalStatus = "All";
        vm.budgetType = "All";

        vm.mpnStatus = "All";
        vm.listMpnStatus = ["OPEN", "CLOSE", "All"];

        vm.listSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        vm.listBudgetType = ["All", "Budgeted", "Unbudgeted"];
        vm.listApprovalStatus = ["Draft", "Waiting Approval", "Approved", "Rejected", "Revision", "All"];

        vm.loadDataDepartment = loadDataDepartment;
        vm.loadBt = loadBt;

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.viewDetail = viewDetail;
        vm.deleteRequest = deleteRequest;
        vm.edit = edit;
        vm.download = true;

        vm.listPIC = [];
        vm.clearSearchTerm = clearSearchTerm;
        vm.ketikSearch = ketikSearch;

        viewData();
        loadDataDivision();
        getPIC();

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewdataapproval',
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                approvalStatus: vm.approvalStatus,
                budgetType: vm.budgetType,
                btcode: vm.btcode,
                subAction: 'viewdatata',
                mpnStatus: vm.mpnStatus,
                pic: vm.pic
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = [];
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function loadDataDivision() {
            vm.listDivision = [];
            var response = endpoint.query({
                action: "getdivisions",
                bu: vm.company
            });
            response.$promise.then(function (data) {
                vm.listDivision = data;
            });
            response.$promise.catch(function (data) {
                vm.listDivision = [];
            });
        }

        function loadDataDepartment(iddivisi) {
            vm.listDepartment = [];
            var response = endpoint.query({
                action: "getdepartments",
                idDivisi: iddivisi
            });
            response.$promise.then(function (data) {
                vm.listDepartment = data;
            });
            response.$promise.catch(function (data) {
                vm.listDepartment = [];
            });
        }

        function loadBt(department) {
            vm.listBt = [];
            vm.listBt.push({
                id: 0,
                description: "OTHER"
            });

            var promise = endpoint.get({
                action: "getbusinesstitle",
                company: vm.company,
                divisi: vm.division,
                department: department,
                bu_only: true
            });

            promise.$promise.then(function (data) {

                vm.listBt = [];
                vm.listBt = data.business_title;
                vm.listBt.push({
                    id: 0,
                    description: "OTHER"
                });
            });

            promise.$promise.catch(function (err) {
                vm.listBt = [];
            });
        }

        function viewDetail(id) {
            $state.go("app.mpn_gw_detail", {
                id: id,
                tipe: "tapic"
            });
        }

        function deleteRequest(ev) {
            console.log(vm.listSelected);

            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {

                var response = endpoint.delete({
                    action: 'delete',
                    data: angular.toJson(vm.listSelected)
                });

                response.$promise.then(function (data) {

                    var confirm = $mdDialog.confirm()
                        .title('Success.!')
                        .textContent(data.pesan)
                        .ariaLabel('Lucky day')
                        .targetEvent(ev)
                        .ok('Close')

                    $mdDialog.show(confirm).then(function () {
                        viewData();
                        $mdDialog.cancel();
                    });

                });

            });
        }

        function edit(ev, id) {
            $state.go("app.mpn_gw_edit", {
                id: id
            });
        }

        vm.exportToExcel = function (ev) {
            var json = JSON.stringify({
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                approvalStatus: vm.approvalStatus,
                budgetType: vm.budgetType,
                btcode: vm.btcode
            });

            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.api + 'api/mpngw/exportExcel/' + json, '_blank');
        }

        function ketikSearch(ev) {
            ev.stopPropagation();
        }

        function clearSearchTerm() {
            vm.searchTerm = '';
        }

        function getPIC() {
            angular.element.blockUI();
            var RequestPromise = endpoint.query({
                action: "getpiclist"
            });
            RequestPromise.$promise.then(fetchDataRequest);
            RequestPromise.$promise.catch(errorFetchRequest);
        }

        function fetchDataRequest(data) {
            vm.listPIC = data;

            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.listPIC = [];
            angular.element.unblockUI();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.request')
        .controller('ViewDocController', ViewDocController);
    ViewDocController.$inject = ['$mdDialog', 'doc'];
    /** @ngInject */
    function ViewDocController($mdDialog, doc) {
        var vm = this;
        vm.closeModal = closeModal;
        vm.name = doc.mpn_number;
        vm.doc_type = false;

        fetchData();
        function fetchData() {
            if (doc.attachment_link.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
                vm.doc = doc.attachment_link;
            }
            vm.url = 'api/mpndocument/' + doc.attachment_link + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();  

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.request')
        .controller('MpnGwRequestController', MpnGwRequestController);

    MpnGwRequestController.$inject = [
        '$localStorage',
        '$stateParams',
        '$timeout',
        '$mdDialog',
        '$state',
        '$filter',
        'AppAPI',
        'Auth',
        'Form',
        'config',
        'FileUploader'
    ];

    /* @ngInject */
    function MpnGwRequestController(
        $localStorage,
        $stateParams,
        $timeout,
        $mdDialog,
        $state,
        $filter,
        AppAPI,
        Auth,
        Form,
        config,
        FileUploader
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;
        vm.showHints = false;
        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;
        vm.setSlt = setSlt;
        vm.myDate = new Date();
        vm.minDate = vm.myDate;
        vm.company = $localStorage.empsite;
        vm.slt = 20;
        vm.sltLabel = [10, 10, 25, 35, 60, 90];
        vm.Form.objForm.emp_grade = '-';
        vm.upload = upload;
        vm.nik = $localStorage.user;
        vm.Form.objForm.created_at = $filter('date')(vm.myDate, 'yyyy-MM-dd H:mm:ss');
        vm.cp = [
            {
                "description": "Corporate and Non Manufacturing",
                "person": [
                    { "name": "Puti Anggunsari", "mail": "puti.anggunsari@nabatisnack.co.id" },
                ]
            },

            {
                "description": "Manufacturing",
                "person": [
                    { "name": "Arie Fitra Nugraha", "mail": "peoplesource@nabatisnack.co.id" },
                ]
            }
        ];

        vm.ketikSearch = ketikSearch;
        vm.newMpp = false;
        vm.otherBT = false;
        vm.otherDivision = false;
        vm.otherDepartment = false;
        vm.setOtherDivision = setOtherDivision;
        vm.setOtherDepartment = setOtherDepartment;
        vm.setOtherBusinessTitle = setOtherBusinessTitle;
        vm.showError = false;
        vm.checkIsNeddFile = checkIsNeddFile;
        vm.viewDocument = viewDocument;

        vm.mppTypeList = ['Budgeted', "Unbudgeted"];
        vm.genderList = ["Any", "Male", "Female"];
        vm.gradeList = ["-",
            "1A", "1B", "1C", "2A", "2B", "2C",
            "3A", "3B", "3C", "4A", "4B", "4C",
            "5A", "5B", "5C", "6A", "6B", "6C", "7"
        ]

        vm.educationList = [
            "SMA / SMK Sederajat",
            "D3",
            "S1",
            "S2"
        ];

        if (vm.company == "EN") {
            vm.educationList = [
                "SPM",
                "STPM",
                "FOUNDATION",
                "A LEVEL",
                "DIPLOMA",
                "BACHELOR",
                "MASTER",
                "PHD"
            ];
        }

        if (vm.company == "RK") {
            vm.slt = 26;
            vm.sltLabel = [26, 26, 40, 54, 99, 150];
            vm.setSlt = setSltRKI;
            vm.cp = [
                {
                    "description": "RKI",
                    "person": [
                        { "name": "Fauzia Muslimah", "mail": "fauzia.muslimah@richeesefactory.com" },
                        { "name": "Nopi Yuliani", "mail": "talent.acquisition@richeesefactory.com" },
                        { "name": "Seizhar Hadi Putra", "mail": "seizhar@richeesefactory.com" },
                        { "name": "Pramodya Nabila Putri", "mail": "people.source@richeesefactory.com" },
                        { "name": "Agi Insan Kamil", "mail": "talent.acquisition1@richeesefactory.com" },
                        { "name": "Mario Tuhehay", "mail": "talent.acquisition2@richeesefactory.com" },
                    ]
                }
            ];
        }

        function setSlt() {
            switch (vm.Form.objForm.emp_grade) {
                case '1A':
                case '1B':
                case '1C':
                    vm.slt = 20;
                    break;

                case '2A':
                case '2B':
                case '2C':
                    vm.slt = 20;
                    break;

                case '3A':
                case '3B':
                case '3C':
                    vm.slt = 30;
                    break;

                case '4A':
                case '4B':
                case '4C':
                    vm.slt = 40;
                    break;

                case '5A':
                case '5B':
                case '5C':
                    vm.slt = 75;
                    break;

                case '6A':
                case '6B':
                case '6C':
                    vm.slt = 95;
                    break;
            }

            vm.minDate = new Date(
                vm.myDate.getFullYear(),
                vm.myDate.getMonth(),
                vm.myDate.getDate() + vm.slt
            );
        }

        function setSltRKI() {
            switch (vm.Form.objForm.emp_grade) {
                case '1A':
                case '1B':
                case '1C':
                    vm.slt = 26;
                    break;

                case '2A':
                case '2B':
                case '2C':
                    vm.slt = 26;
                    break;

                case '3A':
                case '3B':
                case '3C':
                    vm.slt = 40;
                    break;

                case '4A':
                case '4B':
                case '4C':
                    vm.slt = 54;
                    break;

                case '5A':
                case '5B':
                case '5C':
                    vm.slt = 99;
                    break;

                case '6A':
                case '6B':
                case '6C':
                    vm.slt = 100;
                    break;
            }

            vm.minDate = new Date(
                vm.myDate.getFullYear(),
                vm.myDate.getMonth(),
                vm.myDate.getDate() + vm.slt
            );
        }

        vm.tinymceOptions = {
            height: 250,
            theme: 'modern',
            plugins: 'print preview searchreplace autolink code directionality visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
            toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
            templates: [{
                title: 'template 1',
                content: 'Template 1'
            },
            {
                title: 'template 2',
                content: 'Template 2'
            }
            ]
        };

        vm.EmploymentStatus = ["Contract", "Permanent", "Internship", "Part Time"];

        vm.EmploymentExperience = [
            {
                id: 0,
                description: "None"
            },
            {
                id: 1,
                description: "Less than 1 year"
            },
            {
                id: 2,
                description: "1 - 3 year"
            },
            {
                id: 3,
                description: "More than 3 year"
            },
            {
                id: 4,
                description: "More than 5 year"
            }
        ];

        vm.loadDataDepartment = loadDataDepartment;
        vm.loadBt = loadBt;
        vm.saveData = saveData;
        vm.uploadReplacement = uploadReplacement;
        vm.postComment = postComment;
        vm.showComment = false;
        vm.updateData = updateData;
        vm.loadCompetency = loadCompetency;
        vm.bt = [];
        vm.clasificationList = [];
        vm.tmpFormController = {};
        vm.cekQty = cekQty;
        vm.Form.objForm.other_bt = false;
        vm.directReport = directReport;

        loadData();
        loadDataDivision();
        loadLocations();
        loadRule();
        loadClasification();

        vm.reason = "false";
        if (vm.company == "KS") {
            vm.reason = "true";
        }

        function loadData() {
            if ($stateParams.id !== undefined) {
                angular.element.blockUI();
                var RequestPromise = endpoint.get({
                    action: "viewdetail",
                    id: $stateParams.id
                });
                RequestPromise.$promise.then(fetchDataRequest);
                RequestPromise.$promise.catch(errorFetchRequest);
            } else {
                getProfile();
                vm.Form.objForm.clasification = 'DL';
                vm.Form.objForm.budget_type = 'Unbudgeted';
                vm.Form.objForm.qty_replacement = 0;
                vm.Form.objForm.gedung = 0;
                vm.Form.objForm.qty_new = 0;
                vm.Form.objForm.emp_grade = "1A";
                vm.Form.objForm.pref_gender = "Both";
                vm.Form.objForm.education = "SMA / SMK Sederajat";
            }
        }

        function fetchDataRequest(data) {
            vm.Form.objForm = data.mpn;
            vm.Form.objForm.mpn_replacement = data.replacement;
            vm.comment = data.comment;

            vm.Form.objForm.age_min = parseInt(vm.Form.objForm.age_min);
            vm.Form.objForm.age_max = parseInt(vm.Form.objForm.age_max);
            vm.Form.objForm.qty_replacement = parseInt(vm.Form.objForm.qty_replacement);
            vm.Form.objForm.qty_new = parseInt(vm.Form.objForm.qty_new);
            vm.Form.objForm.expected_join_date = new Date(vm.Form.objForm.expected_join_date);
            loadDataDepartment(vm.Form.objForm.division_id);
            loadBt(vm.Form.objForm.department_id);
            if (data.mpn.other_bt == '0') {
                vm.Form.objForm.other_bt = false;
            }

            vm.Form.objForm.attachment_link = data.mpn.attachment_link;
            vm.showComment = true;
            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.request = [];
            angular.element.unblockUI();
        }

        function loadDataDepartment(iddivisi) {
            setOtherDivision(iddivisi);
            if (iddivisi != '-1') {
                vm.listDepartment = [];
                var response = endpoint.query({
                    action: "getdepartments",
                    idDivisi: iddivisi
                });
                response.$promise.then(function (data) {
                    vm.listDepartment = data;
                });
                response.$promise.catch(function (data) {
                    vm.listDepartment = [];
                });
            }
        }

        function loadDataDivision() {
            vm.listDivision = [];
            var response = endpoint.query({
                action: "getdivisions",
                bu: vm.company
            });
            response.$promise.then(function (data) {
                vm.listDivision = data;
            });
            response.$promise.catch(function (data) {
                vm.listDivision = [];
            });
        }

        function loadBt(department) {
            setOtherDepartment(department);

            if (department != '-1') {
                vm.listBt = [];
                var promise = endpoint.get({
                    action: "getbusinesstitle",
                    company: vm.company,
                    divisi: vm.Form.objForm.division_id,
                    department: department,
                    bu_only: true
                });

                promise.$promise.then(function (data) {
                    vm.listBt = [];
                    vm.listBt = data.business_title;

                    if ($stateParams.layer_id !== undefined) {
                        vm.Form.objForm.layer_id = $stateParams.layer_id;
                        loadCompetency(vm.Form.objForm.layer_id);
                    }
                });

                promise.$promise.catch(function (err) {
                    vm.listBt = [];
                });
            }
        }

        function loadLocations() {
            vm.listLocations = [];
            var promise = endpoint.query({
                action: "getworklocations",
                status: 1
            });
            promise.$promise.then(function (data) {
                vm.listLocations = data;
            });
            promise.$promise.catch(function (err) {
                vm.listLocations = [];
            });
        }

        function getProfile() {

            var promise = endpoint.get({
                action: "getprofile",
                company: vm.company
            });

            promise.$promise.then(function (data) {
                vm.Form.objForm.division_id = data.employee_info.division_id;
                vm.Form.objForm.department_id = data.employee_info.department_id;
                vm.Form.objForm.work_location = data.employee_info.subArea;
                vm.is_head_div = data.employee_info.is_head_div;
                vm.layerList = data.layer;
                loadDataDepartment(data.employee_info.division_id);
                loadBt(data.employee_info.department_id);
            });
            promise.$promise.catch(function (err) {

            });
        }

        function saveData(ev, formController, tipe) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                vm.Form.objForm.current_status = tipe;
                angular.element.blockUI();
                var promise = Form.saveData('save', formController, endpoint);
                promise.then(function (data) {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    if (vm.isChecked) {
                        upload();
                    }

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

                promise.catch(function () {
                    vm.messageTheme = 'pink';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });
            });
        }

        function updateData(ev, formController, tipe) {
            var request = Auth.setToken();
            request.then(function () {
                vm.Form.objForm.current_status = tipe;
                var response = endpoint.save({
                    action: 'update',
                    mpn: vm.Form.objForm,
                    id: vm.Form.objForm.id
                });

                response.$promise.then(function (res) {
                    vm.succesForm = true;
                    vm.failedForm = false;
                    vm.tampilPesan = true;
                    vm.pesan = res;
                    $state.go("app.mpn_gw_detail", {
                        id: vm.Form.objForm.id,
                        tipe: "requestor"
                    });
                });
                response.$promise.catch(function (reason) {
                    vm.succesForm = false;
                    vm.failedForm = true;
                    vm.tampilPesan = true;
                    vm.pesan = pesan;
                });
            });
        }

        function uploadReplacement(ev) {
            $mdDialog.show({
                controller: 'ReplacementUploadController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/request/replacement.upload.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    company: vm.company,
                    divisi: vm.Form.objForm.division_id,
                    department: vm.Form.objForm.department_id,
                    dataReplacement: vm.Form.objForm.mpn_replacement,
                    workLocation: vm.Form.objForm.work_location,
                    bt: vm.bt,
                }
            }).then(function (data) {
                vm.Form.objForm.qty_replacement = data.length;
                vm.Form.objForm.mpn_replacement = data;

                var qtyTotal = parseInt(data.length) + parseInt(vm.Form.objForm.qty_new);

                if (qtyTotal > parseInt(vm.Form.objForm.max_qty)) {
                    vm.Form.objForm.budget_type = 'Unbudgeted';
                }
                else {
                    vm.Form.objForm.budget_type = 'Budgeted';
                }
            });
        }

        function postComment() {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                var response = endpoint.save({
                    action: 'comment',
                    comment: vm.newComment,
                    user: $localStorage.user,
                    id: vm.Form.objForm.id
                });
                response.$promise.then(function (data) {
                    var confirm = $mdDialog.confirm()
                        .title('Success.!')
                        .textContent(data.pesan)
                        .ariaLabel('Lucky day')
                        .ok('Close');

                    $mdDialog.show(confirm).then(function () {
                        loadData();
                        vm.newComment = "";
                        $mdDialog.cancel();
                    }, function () {
                        alert("cancel");
                    });
                });
            });
        }

        function loadCompetency(layer_id) {
            vm.setOtherBusinessTitle(layer_id);
            vm.Form.objForm.emp_grade = "-";
            if (layer_id != '-1') {
                vm.bt = vm.listBt.filter(function (item) {
                    return item.layer_id == layer_id;
                });
                vm.Form.objForm.business_title = vm.bt[0].id;
                vm.Form.objForm.clasification = vm.bt[0].clasification_code;

                var response = endpoint.get({
                    action: "getcompetencies",
                    business_title_id: vm.bt[0].id,
                    layer_id: layer_id,
                    department: vm.Form.objForm.department_id
                });

                response.$promise.then(function (data) {
                    vm.newMpp = data.mpp_type.new_mpp

                    vm.Form.objForm.budget_type = data.mpp_type.status;
                    vm.Form.objForm.max_qty = data.mpp_type.qty;
                    vm.Form.objForm.major = "";
                    vm.Form.objForm.emp_grade = data.job_code.grade;
                    vm.Form.objForm.major = data.job_code.req_education;
                    vm.Form.objForm.layer_id = vm.bt[0].layer_id;
                    setSlt();
                    var arrData = data.competency;
                    vm.Form.objForm.job_func = "";
                    angular.forEach(arrData, function (value, key) {
                        vm.Form.objForm.job_func +=
                            "<b>" +
                            value.competency +
                            "</b><br>" +
                            value.description +
                            "<br><br>";
                    });

                    arrData = [];

                    arrData = data.responsibilities;

                    if (arrData[0] === undefined) {
                        arrData[0] = {
                            job_desc: "",
                            area: "",
                            area_description: ""
                        }
                        vm.Form.objForm.qualification_note = '';
                    }
                    vm.Form.objForm.job_desc = "";
                    vm.Form.objForm.job_desc = arrData[0].job_desc + "<br><br>" + "<b>RESPONSIBILITIES INCLUDE</b><br>";
                    vm.Form.objForm.major = arrData[0].req_education;
                    vm.Form.objForm.qualification_note = "";
                    vm.Form.objForm.qualification_note = arrData[0].req_job_experience;

                    angular.forEach(arrData, function (value, key) {

                        vm.Form.objForm.job_desc +=
                            "<b>" +
                            value.area +
                            "</b><br>" +
                            value.area_description +
                            "<br><br>";
                    });

                    arrData = [];
                    vm.Form.objForm.qualification_note = '';
                    setAgeEducation(data.job_code.grade);
                });
                response.$promise.catch(function (data) {
                    vm.Form.objForm.job_desc = "";
                    vm.Form.objForm.job_func = "";
                    vm.Form.objForm.major = "";
                    vm.Form.objForm.qualification_note = "";

                    vm.Form.objForm.budget_type = 'Unbudgeted';
                    vm.Form.objForm.max_qty = 0;
                    vm.Form.objForm.major = "";
                    vm.Form.objForm.emp_grade = '';
                    vm.Form.objForm.major = '';
                    vm.Form.objForm.layer_id = '';

                    vm.Form.objForm.business_title = 0;
                    vm.Form.objForm.clasification = '';
                });
            }
        }

        function ketikSearch(ev) {
            ev.stopPropagation();
        }

        function loadRule() {
            vm.rule = [];
            var promise = endpoint.query({
                action: "getRule",
            });
            promise.$promise.then(function (data) {
                vm.rule = data[0];
            });
            promise.$promise.catch(function (err) {
                vm.rule = [];
            });
        }

        function loadClasification() {
            vm.clasificationList = [];

            var promise = endpoint.query({
                action: "getClasification",
            });
            promise.$promise.then(function (data) {
                vm.clasificationList = data;
            });
            promise.$promise.catch(function (err) {
                vm.clasificationList = [];
            });
        }

        function cekQty() {
            var qtyTotal = vm.Form.objForm.qty_replacement + vm.Form.objForm.qty_new;

            if (!vm.Form.objForm.other_bt && (qtyTotal > parseInt(vm.Form.objForm.max_qty))) {
                vm.Form.objForm.budget_type = 'Unbudgeted';
            }
            else {
                vm.Form.objForm.budget_type = 'Budgeted';
            }

            if (vm.Form.objForm.other_bt) {
                vm.Form.objForm.budget_type = 'Unbudgeted';
            }
        }

        function directReport(id) {
            vm.directList = [];
            var promise = endpoint.query({
                action: "getDirectReport",
                layer_id: id
            });

            promise.$promise.then(function (data) {
                vm.directList = [];
                vm.directList = data;
            });

            promise.$promise.catch(function (err) {
                vm.directList = [];
            });
        }

        function setOtherDivision(idDivisi) {
            if (idDivisi == '-1') {
                vm.Form.objForm.other_bt = true;
                vm.otherDivision = true;
                vm.otherDepartment = true;
                vm.otherBT = true;

                vm.Form.objForm.department_id = '-1';
            }
            else {
                vm.Form.objForm.other_bt = false;
                vm.otherDivision = false;
                vm.otherDepartment = false;
                vm.otherBT = false;
            }
        }

        function setOtherDepartment(idDepartment) {
            if (idDepartment == '-1') {
                vm.Form.objForm.other_bt = true;
                vm.otherDepartment = true;
                vm.otherBT = true;
            }
            else {
                vm.Form.objForm.other_bt = false;
                vm.otherDepartment = false;
                vm.otherBT = false;
            }
        }

        function setOtherBusinessTitle(idBt) {
            if (idBt == '-1') {
                vm.Form.objForm.other_bt = true;
                vm.otherBT = true;
            }
            else {
                vm.Form.objForm.other_bt = false;
                vm.otherBT = false;
            }
        }

        function setAgeEducation(grade) {
            switch (grade) {
                case '1A':
                case '1B':
                case '1C':
                case '2A':
                case '2B':
                case '2C':
                    vm.Form.objForm.age_min = 18;
                    vm.Form.objForm.age_max = 33;
                    vm.Form.objForm.education = "SMA / SMK Sederajat";
                    break;

                case '3A':
                    vm.Form.objForm.age_min = 21;
                    vm.Form.objForm.age_max = 25;
                    vm.Form.objForm.education = "S1";
                    break;
                case '3B':
                    vm.Form.objForm.age_min = 21;
                    vm.Form.objForm.age_max = 27;
                    vm.Form.objForm.education = "S1";
                    break;
                case '3C':
                    vm.Form.objForm.age_min = 21;
                    vm.Form.objForm.age_max = 30;
                    vm.Form.objForm.education = "S1";
                    break;

                case '4A':
                case '4B':
                    vm.Form.objForm.age_min = 25;
                    vm.Form.objForm.age_max = 35;
                    vm.Form.objForm.education = "S1";
                    break;
                case '4C':
                    vm.Form.objForm.age_min = 25;
                    vm.Form.objForm.age_max = 40;
                    vm.Form.objForm.education = "S1";
                    break;

                case '5A':
                    vm.Form.objForm.age_min = 27;
                    vm.Form.objForm.age_max = 40;
                    vm.Form.objForm.education = "S1";
                    break;
                case '5B':
                case '5C':
                    vm.Form.objForm.age_min = 30;
                    vm.Form.objForm.age_max = 45;
                    vm.Form.objForm.education = "S1";
                    break;

                case '6A':
                case '6B':
                case '6C':
                    vm.Form.objForm.age_min = 35;
                    vm.Form.objForm.age_max = 47;
                    vm.Form.objForm.education = "S1";
                    break;

                default:
                    break;
            }
        }

        function checkIsNeddFile() {
            if (vm.isNeddUploadFile == false || typeof vm.isNeddUploadFile === 'undefined') {
                vm.isChecked = true
            } else {
                vm.isChecked = false
            }
        }

        function upload() {
            var resp = vm.FileUploaderPhoto.uploadAll();
            angular.element.unblockUI();
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/mpngw/uploadAttachment',
            removeAfterUpload: true,
            alias: 'attachment',
            onBeforeUploadItem: function () {

            },
            formData: [
                {
                    action: 'uploadkk',
                    documentNo: vm.documentNo,
                    typeOfDocument: vm.typeOfDocument,
                    description: vm.description
                }
            ],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            },
            onSuccessItem: function (item, response, status, headers) {
                if (response.error) {
                    vm.message = {
                        ariaLabel: 'Upload file has been failed',
                        textContent: response.pesan
                    }
                } else {
                    vm.message = {
                        ariaLabel: 'Upload file has been successfully',
                        textContent: response.pesan
                    }
                }

                showDialog();
                angular.element.unblockUI();
            }
        });

        uploaderPhoto.filters.push({
            name: 'syncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                vm.sizefile = item.size;
                return true;
            }
        });

        function viewDocument(ev, dataDoc) {
            $mdDialog.show({
                controller: 'ViewDocController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/request/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false,
                locals: {
                    doc: dataDoc,
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.request')
        .controller('ReplacementUploadController', ReplacementUploadController);

    ReplacementUploadController.$inject = ['$mdDialog', '$localStorage', '$window', '$location', 'FileUploader', 'config', 'AppAPI', 'company', 'divisi', 'department', 'dataReplacement', 'workLocation', 'bt'];

    /* @ngInject */
    function ReplacementUploadController($mdDialog, $localStorage, $window, $location, FileUploader, config, AppAPI, company, divisi, department, dataReplacement, workLocation, bt) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;
        vm.closeModal = closeModal;
        vm.uploadFile = uploadFile;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        vm.company = company;
        vm.division_id = divisi;
        vm.department_id = department;
        vm.tambah = tambah;
        vm.dataReplacement = [];
        vm.dataReplacementFailed = [];
        vm.choose = choose;
        vm.selesai = selesai;
        vm.hapus = hapus;
        vm.downloadFormat = downloadFormat;
        vm.failed = 0;
        vm.downloadFailed = downloadFailed;
        vm.workLocation = workLocation;
        vm.bt = bt;
        vm.bt_ = angular.toJson(bt[0]);

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/mpngw/uploadReplacement',
            removeAfterUpload: true,
            alias: 'filereplacement',
            formData: [{
                action: 'uploadReplacement'
            }],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        uploaderPhoto.onSuccessItem = function (response, result) {
            var item = result.success;
            var itemFailed = result.failed;
            vm.UploadPhotoStateSucces = true;
            vm.UploadPhotoStateError = false;

            for (var i = 0; i < item.length; i++) {
                var data = {
                    nik: item[i].nik,
                    nama: item[i].nama,
                    replacement_type: item[i].reason,
                    effective_date: item[i].last_date,
                    positionID: item[i].positionID,
                    subarea: item[i].subarea,
                    subarea_id: item[i].sub_area_id,
                    gedung: item[i].gedung,
                    gedung_id: item[i].gedung_id,
                }

                vm.dataReplacement.push(data);
            }

            for (var j = 0; j < itemFailed.length; j++) {
                var dataFailed = {
                    nik: itemFailed[j].nik,
                    reason: itemFailed[j].reason
                }

                vm.dataReplacementFailed.push(dataFailed);
            }

            vm.failed = vm.dataReplacementFailed.length;
        };

        uploaderPhoto.onErrorItem = function () {
            vm.UploadPhotoStateSucces = false;
            vm.UploadPhotoStateError = true;
        };

        getReplacementType();

        function uploadFile() {
            return false;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function getReplacementType() {
            if (dataReplacement !== undefined) {
                vm.dataReplacement = dataReplacement;
            }

            vm.listReplacementType = [];
            var response = endpoint.query({
                action: "getreplacementtype"
            });
            response.$promise.then(function (data) {
                vm.listReplacementType = data;
            });
            response.$promise.catch(function (data) {
                vm.listReplacementType = [];
            });
        }

        function choose(emp) {
            vm.emp = "";
            vm.emp = emp;
        }

        vm.querySearch = function (query, index) {
            if (query !== null && query !== "" && (query + "").length >= 3) {

                var promise = endpoint.query({
                    action: "getemployee",
                    query: query,
                    bt: vm.bt
                });

                return promise.$promise.then(function (data) {
                    return data;
                });

                return promise.$promise.catch(function (err) {
                    return [];
                });

            }
            return [];
        }

        function tambah() {
            var data = {
                nik: vm.emp.nik,
                nama: vm.emp.nama,
                replacement_type: vm.replacement_type,
                effective_date: moment(vm.effective_date).format('YYYY-MM-DD'),
                positionID: vm.emp.positionID,
                subarea: vm.emp.subarea,
                subarea_id: vm.emp.sub_area_id,
                gedung: vm.emp.gedung,
                gedung_id: vm.emp.gedung_id,
            }

            vm.dataReplacement.push(data);
        }

        function selesai() {
            $mdDialog.hide(vm.dataReplacement);
        }

        function hapus(itemIndex) {
            vm.dataReplacement.splice(itemIndex, 1);
        }

        function downloadFormat() {
            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.api + 'api/mpngw/exportExcellReplacement/', '_blank');
        }

        function downloadFailed() {
            var protocol = $location.protocol();
            var host = $location.host();
            var data = angular.toJson(vm.dataReplacementFailed);
            var datanew = data.replace(/\//g, "-");
            console.log(data);
            $window.open(protocol + '://' + host + config.api + 'api/mpngw/exportExcellFailedReplacement/' + datanew + '/', '_blank');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.request')
        .controller('ReplacementListController', ReplacementListController);

    /** @ngInject */
    function ReplacementListController($mdDialog, data) {
        var vm = this;
        vm.data = data;
        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.request')
        .controller('MpnGwListController', MpnGwListController);

    MpnGwListController.$inject = [
        "AppAPI",
        "DataService",
        "Auth",
        "config",
        "$localStorage",
        "$state",
        "$mdDialog",
        "$location",
        "$window"
    ];

    function MpnGwListController(
        AppAPI,
        DataService,
        Auth,
        config,
        $localStorage,
        $state,
        $mdDialog,
        $location,
        $window
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;

        vm.company = $localStorage.empsite;
        vm.approvalStatus = "Draft";
        vm.budgetType = "All";
        vm.listSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        vm.listBudgetType = ["All", "Budgeted", "Unbudgeted"];
        vm.listApprovalStatus = [{
            "id": "Waiting Approval",
            "desc": "Waiting Approval"
        },
        {
            "id": "Approved",
            "desc": "Approved"
        },
        {
            "id": "Rejected",
            "desc": "Rejected"
        },
        {
            "id": "All",
            "desc": "All"
        },
        {
            "id": "Draft",
            "desc": "Draft"
        },
        {
            "id": "Revision",
            "desc": "Revision"
        },
        ];

        vm.loadDataDepartment = loadDataDepartment;
        vm.loadBt = loadBt;

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.viewDetail = viewDetail;
        vm.deleteRequest = deleteRequest;
        vm.edit = edit;

        viewData();
        loadDataDivision();

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewdata',
                subAction: 'viewdatarequest',
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                approvalStatus: vm.approvalStatus,
                budgetType: vm.budgetType,
                btcode: vm.btcode
            });

            angular.element.unblockUI();
        }

        vm.exportToExcel = function (ev) {
            var json = JSON.stringify({
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                approvalStatus: vm.approvalStatus,
                budgetType: vm.budgetType,
                btcode: vm.btcode
            });

            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.api + 'api/mpngw/exportExcel/' + json, '_blank');
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = [];
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function loadDataDivision() {
            vm.listDivision = [];
            var response = endpoint.query({
                action: "getdivisions",
                bu: vm.company
            });
            response.$promise.then(function (data) {
                vm.listDivision = data;
            });
            response.$promise.catch(function (data) {
                vm.listDivision = [];
            });
        }

        function loadDataDepartment(iddivisi) {
            vm.listDepartment = [];
            var response = endpoint.query({
                action: "getdepartments",
                idDivisi: iddivisi
            });
            response.$promise.then(function (data) {
                vm.listDepartment = data;
            });
            response.$promise.catch(function (data) {
                vm.listDepartment = [];
            });
        }

        function loadBt(department) {
            vm.listBt = [];
            vm.listBt.push({
                id: 0,
                description: "OTHER"
            });

            var promise = endpoint.get({
                action: "getbusinesstitle",
                company: vm.company,
                divisi: vm.division,
                department: department,
                bu_only: true
            });

            promise.$promise.then(function (data) {

                vm.listBt = [];
                vm.listBt = data.business_title;
                vm.listBt.push({
                    id: 0,
                    description: "OTHER"
                });
            });

            promise.$promise.catch(function (err) {
                vm.listBt = [];
            });
        }

        function viewDetail(id) {
            $state.go("app.mpn_gw_detail", {
                id: id,
                tipe: "requestor"
            });
        }

        function deleteRequest(ev) {
            var promiseAuth = Auth.setToken();
            var item = [];

            angular.forEach(vm.listSelected, function (value, key) {
                var val = { 'id': value.id };
                item.push(val);
            });

            promiseAuth.then(function () {

                var response = endpoint.delete({
                    action: 'delete',
                    data: angular.toJson(item)
                });

                response.$promise.then(function (data) {

                    var confirm = $mdDialog.confirm()
                        .title('Success.!')
                        .textContent(data.pesan)
                        .ariaLabel('Lucky day')
                        .targetEvent(ev)
                        .ok('Close')

                    $mdDialog.show(confirm).then(function () {
                        viewData();
                        $mdDialog.cancel();
                    });

                });

            });
        }

        function edit(ev, id) {
            $state.go("app.mpn_gw_edit", {
                id: id
            });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.request')
        .controller('MpnGwDetailController', MpnGwDetailController);

    MpnGwDetailController.$inject = [
        "$stateParams",
        "$state",
        "$mdDialog",
        "$localStorage",
        "Auth",
        "AppAPI"
    ];

    function MpnGwDetailController(
        $stateParams,
        $state,
        $mdDialog,
        $localStorage,
        Auth,
        AppAPI
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;
        var RequestResetSlt = AppAPI.MpnResetSLT();

        vm.showReplacement = showReplacement;
        vm.showRecruit = showRecruit;
        vm.back = back;
        vm.tipe = $stateParams.tipe;
        vm.approve = approve;
        vm.reject = reject;
        vm.submit = submit;
        vm.edit = edit;
        vm.setBudget = setBudget;
        vm.postComment = postComment;
        vm.setDelegate = setDelegate;
        vm.setPic = setPic;
        vm.stopRecruit = stopRecruit;
        vm.approveChangeHeadcount = approveChangeHeadcount;
        vm.company = $localStorage.empsite;
        vm.adminChangeQty = adminChangeQty;
        vm.resetSLT = resetSLT;
        vm.approveResetSLT = approveResetSLT;
        vm.rejectResetSLT = rejectResetSLT;
        vm.viewDocument = viewDocument;

        vm.sltLabel = [15, 15, 25, 35, 70, 90];
        vm.cp = ["Arie - peoplesource@nabatisnack.co.id", "Chandra - talentsource@nabatisnack.co.id", "Dias - humansource@nabatisnack.co.id", "Shinta - talent.mjk@nabatisnack.co.id"];

        if (vm.company == "RK") {
            vm.sltLabel = [26, 26, 40, 54, 99, 150];
            vm.cp = ["Fauzia Muslimah - fauzia.muslimah@richeesefactory.com", "Nopi Yuliani - talent.acquisition@richeesefactory.com", "Seizhar Hadi Putra - seizhar@richeesefactory.com", "Pramodya Nabila Putri - people.source@richeesefactory.com", "Agi Insan Kamil - talent.acquisition1@richeesefactory.com", "Mario Tuhehay - talent.acquisition2@richeesefactory.com"];
        }

        vm.formatDate = function (date) {
            if (date === null) {
                return "";
            }
            return new Date(date)
        }

        viewData();

        function viewData() {
            angular.element.blockUI();
            var RequestPromise = endpoint.get({
                action: "viewdetail",
                id: $stateParams.id
            });
            RequestPromise.$promise.then(fetchDataRequest);
            RequestPromise.$promise.catch(errorFetchRequest);
        }

        function fetchDataRequest(data) {

            vm.mpn = data.mpn;
            vm.replacement = data.replacement;
            vm.approval = data.approval;
            vm.comment = data.comment;
            vm.recruit = data.recruit;
            vm.approvalHeadcount = data.approvalHeadcount;
            vm.resetSLT = data.resetSLT

            vm.mpn.qty_new = parseInt(vm.mpn.qty_new);
            vm.mpn.qty_replacement = parseInt(vm.mpn.qty_replacement);
            vm.mpn.qty_total = parseInt(vm.mpn.qty_total);

            vm.mpn.final_qty_new = parseInt(vm.mpn.final_qty_new);
            vm.mpn.final_qty_replacement = parseInt(vm.mpn.final_qty_replacement);

            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.request = [];
            angular.element.unblockUI();
        }

        function showReplacement(ev) {
            $mdDialog.show({
                controller: 'ReplacementListController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/request/replacement.list.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {

                },
                locals: {
                    data: vm.replacement
                }
            });
        }

        function showRecruit(ev) {
            $mdDialog.show({
                controller: 'RecruitListController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/ta/recruit.list.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {

                },
                locals: {
                    id: vm.mpn.id,
                    tipe: vm.tipe,
                    workLocation: vm.mpn.work_location,
                    creator: vm.mpn.created_by,
                    taPic: vm.mpn.nik_pic,
                    taStatus: vm.mpn.ta_status
                }
            });
        }

        function back() {
            if (vm.tipe == 'requestor') {
                $state.go("app.mpn_gw_list");
            } else if (vm.tipe == 'tapic') {
                $state.go("app.mpn_gw_list_ta");
            } else if (vm.tipe == 'changeheadcount') {
                $state.go("app.mpn_gw_list_change_quantity");
            } else {
                $state.go("app.mpn_gw_list_approval");
            }
        }

        function approve(ev) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {

                var confirm = $mdDialog.confirm()
                    .title('Approve this?')
                    .textContent('MPN will be accepted.')
                    .ariaLabel('eccept dialog')
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endpoint.save({
                        action: 'approve',
                        mpn: vm.mpn,
                        app: vm.approval,
                        status: 2,
                        newBudget: vm.mpn.budget_type
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        var confirm = $mdDialog.confirm()
                            .title('Success.!')
                            .textContent(data.pesan)
                            .ariaLabel('Lucky day')
                            .ok('Close');

                        $mdDialog.show(confirm).then(function () {
                            viewData();
                            $mdDialog.cancel();
                        }, function () {
                            alert("cancel");
                            viewData();
                        });
                    });

                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function approveChangeHeadcount(ev) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {

                var confirm = $mdDialog.confirm()
                    .title('Approve this?')
                    .textContent('MPN will be accepted.')
                    .ariaLabel('eccept dialog')
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endpoint.save({
                        action: 'approvechangeheadcount',
                        mpn: vm.mpn,
                        app: vm.approvalHeadcount
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        var confirm = $mdDialog.confirm()
                            .title('Success.!')
                            .textContent(data.pesan)
                            .ariaLabel('Lucky day')
                            .ok('Close');

                        $mdDialog.show(confirm).then(function () {
                            viewData();
                            $mdDialog.cancel();
                        }, function () {
                            alert("cancel");
                            viewData();
                        });
                    });
                    response.$promise.catch(function () {
                        angular.element.unblockUI();
                        var confirm = $mdDialog.confirm()
                            .title('Failed.!')
                            .textContent(data.pesan)
                            .ariaLabel('Lucky day')
                            .ok('Close');

                        $mdDialog.show(confirm).then(function () {
                            viewData();
                            $mdDialog.cancel();
                        }, function () {
                            alert("cancel");
                            viewData();
                        });
                    });

                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function reject(ev, status) {
            $mdDialog.show({
                controller: 'RejectReviseController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/approval/reject.revise.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    vm.newComment = "";
                    if (status == 'Revice') {
                        back();
                    }
                },
                locals: {
                    mpn: vm.mpn,
                    approval: status
                }
            });
        }

        function submit(ev) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {

                var confirm = $mdDialog.confirm()
                    .title('Submit this draft?')
                    .textContent('MPN will be submit.')
                    .ariaLabel('eccept dialog')
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endpoint.save({
                        action: 'submitdraft',
                        mpn: vm.mpn.id
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        var confirm = $mdDialog.confirm()
                            .title('Success.!')
                            .textContent(data.pesan)
                            .ariaLabel('Lucky day')
                            .ok('Close');

                        $mdDialog.show(confirm).then(function () {
                            viewData();
                            $mdDialog.cancel();
                        }, function () {
                            alert("cancel");
                            viewData();
                        });
                    });

                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });

        }

        function edit(ev) {
            $state.go("app.mpn_gw_edit", {
                id: vm.mpn.id
            });
        }

        function setBudget(ev) {
            $mdDialog.show({
                controller: 'SetBudgetController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/approval/set.budget.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    var confirm = $mdDialog.confirm()
                        .title('Done.!')
                        .ariaLabel('Lucky day')
                        .ok('Close');

                    $mdDialog.show(confirm).then(function () {
                        viewData();
                        $mdDialog.cancel();
                    }, function () {
                        alert("cancel");
                    });

                },
                locals: {
                    mpn: vm.mpn,
                    approval: vm.approval
                }
            }).then(function () {

            });
        }

        function postComment() {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                var response = endpoint.save({
                    action: 'comment',
                    comment: vm.newComment,
                    user: $localStorage.user,
                    id: vm.mpn.id
                });
                response.$promise.then(function (data) {
                    var confirm = $mdDialog.confirm()
                        .title('Success.!')
                        .textContent(data.pesan)
                        .ariaLabel('Lucky day')
                        .ok('Close');

                    $mdDialog.show(confirm).then(function () {
                        viewData();
                        vm.newComment = "";
                        $mdDialog.cancel();
                    }, function () {
                        alert("cancel");
                    });
                });
            });
        }

        function setDelegate(ev, data) {
            $mdDialog.show({
                controller: 'SetDelegateController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/approval/set.delegate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {

                    var confirm = $mdDialog.confirm()
                        .title('Success.!')
                        .textContent(data.pesan)
                        .ariaLabel('Lucky day')
                        .ok('Close');

                    $mdDialog.show(confirm).then(function () {
                        viewData();
                        vm.newComment = "";
                        $mdDialog.cancel();
                    }, function () {
                        alert("cancel");
                    });
                    // viewData();
                },
                locals: {
                    idMpn: vm.mpn.id,
                    approval: data
                }
            });
        }

        function setPic(ev) {
            $mdDialog.show({
                controller: 'SetPicController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/approval/set.pic.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();

                    var confirm = $mdDialog.confirm()
                        .title('Success.!')
                        .textContent(data.pesan)
                        .ariaLabel('Lucky day')
                        .ok('Close');

                    $mdDialog.show(confirm).then(function () {
                        viewData();
                        $mdDialog.cancel();
                    }, function () {
                        alert("cancel");
                    });

                },
                locals: {
                    idMpn: vm.mpn.id,
                    workLocation: vm.mpn.work_location
                }
            });
        }

        function stopRecruit(ev) {
            $mdDialog.show({
                controller: 'ChangeQuantityController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/approval/change.quantity.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();

                    var confirm = $mdDialog.confirm()
                        .title('Success.!')
                        .textContent(data.pesan)
                        .ariaLabel('Lucky day')
                        .ok('Close');

                    $mdDialog.show(confirm).then(function () {
                        viewData();
                        $mdDialog.cancel();
                    }, function () {
                        alert("cancel");
                    });

                },
                locals: {
                    mpn: vm.mpn,
                    replacement: vm.replacement
                }
            });
        }

        function adminChangeQty(ev) {
            $mdDialog.show({
                controller: 'AdminchangeqtyController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/approval/admin.change.qty.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    mpn: vm.mpn,
                    dataReplacement: vm.replacement
                }
            }).then(function () {
                viewData();
            });
        }

        function resetSLT(data, ev) {
            $mdDialog.show({
                controller: 'RequestResetSLTGWController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/ta/request.resetslt.gw.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewDataRequest();
                    vm.newComment = "";
                },
                locals: {
                    mpn: data
                }
            });
        }

        function approveResetSLT(ev) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {

                var confirm = $mdDialog.confirm()
                    .title('Approve this?')
                    .textContent('SLT will be reset if you accept.')
                    .ariaLabel('eccept dialog')
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = RequestResetSlt.save({
                        action: 'approveResetGw',
                        mpn: vm.mpn
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        var confirm = $mdDialog.confirm()
                            .title('Success.!')
                            .textContent(data.pesan)
                            .ariaLabel('Lucky day')
                            .ok('Close');

                        $mdDialog.show(confirm).then(function () {
                            viewData();
                            $mdDialog.cancel();
                        }, function () {
                            alert("cancel");
                            viewData();
                        });
                    });
                    response.$promise.catch(function () {
                        angular.element.unblockUI();
                        var confirm = $mdDialog.confirm()
                            .title('Failed.!')
                            .textContent(data.pesan)
                            .ariaLabel('Lucky day')
                            .ok('Close');

                        $mdDialog.show(confirm).then(function () {
                            viewDataRequest();
                            $mdDialog.cancel();
                        }, function () {
                            alert("cancel");
                            viewDataRequest();
                        });
                    });

                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function rejectResetSLT(ev) {
            $mdDialog.show({
                controller: 'RejectResetSLTGwController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn/approval/reject.resetslt.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    vm.newComment = "";
                },
                locals: {
                    mpn: vm.mpn
                }
            });
        }

        function viewDocument(ev, dataDoc) {
            $mdDialog.show({
                controller: 'ViewDocController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn-gw/request/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false,
                locals: {
                    doc: dataDoc,
                }
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('app.mpn-gw.other-business-title', ['ui.tinymce', 'ngMaterial', 'ngMessages']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.mpn_gw_other_business_title', {
                url: '/mpngw/other-business-title',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mpn-gw/other-business-title/other-business-title.html',
                        controller: 'OtherBusinessTitleController as vm'
                    }
                }
            });
    }



})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.other-business-title')
        .controller('OtherBusinessTitleController', OtherBusinessTitleController);

    OtherBusinessTitleController.$inject = [
        "AppAPI",
        "DataService",
        "Auth",
        "config",
        "$localStorage",
        "$state",
        "$mdDialog",
        "$location",
        "$window"
    ];

    function OtherBusinessTitleController(
        AppAPI,
        DataService,
        Auth,
        config,
        $localStorage,
        $state,
        $mdDialog,
        $location,
        $window
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;

        vm.company = $localStorage.empsite;
        vm.approvalStatus = "Draft";
        vm.budgetType = "All";
        vm.listSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        vm.listBudgetType = ["All", "Budgeted", "Unbudgeted"];
        vm.listApprovalStatus = [{
            "id": "Waiting Approval",
            "desc": "Waiting Approval"
        },
        {
            "id": "Approved",
            "desc": "Approved"
        },
        {
            "id": "Rejected",
            "desc": "Rejected"
        },
        {
            "id": "All",
            "desc": "All"
        },
        {
            "id": "Draft",
            "desc": "Draft"
        },
        {
            "id": "Revision",
            "desc": "Revision"
        },
        ];

        vm.loadDataDepartment = loadDataDepartment;
        vm.loadBt = loadBt;

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.viewDetail = viewDetail;
        vm.deleteRequest = deleteRequest;
        vm.edit = edit;

        viewData();
        loadDataDivision();

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'getDataListApprovalOtherBusinessTitle'
            });
        }

        vm.exportToExcel = function (ev) {
            var json = JSON.stringify({
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                approvalStatus: vm.approvalStatus,
                budgetType: vm.budgetType,
                btcode: vm.btcode
            });

            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.api + 'api/mpngw/exportExcel/' + json, '_blank');
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = [];
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function loadDataDivision() {
            vm.listDivision = [];
            var response = endpoint.query({
                action: "getdivisions",
                bu: vm.company
            });
            response.$promise.then(function (data) {
                vm.listDivision = data;
            });
            response.$promise.catch(function (data) {
                vm.listDivision = [];
            });
        }

        function loadDataDepartment(iddivisi) {
            vm.listDepartment = [];
            var response = endpoint.query({
                action: "getdepartments",
                idDivisi: iddivisi
            });
            response.$promise.then(function (data) {
                vm.listDepartment = data;
            });
            response.$promise.catch(function (data) {
                vm.listDepartment = [];
            });
        }

        function loadBt(department) {
            vm.listBt = [];
            vm.listBt.push({
                id: 0,
                description: "OTHER"
            });

            var promise = endpoint.get({
                action: "getbusinesstitle",
                company: vm.company,
                divisi: vm.division,
                department: department,
                bu_only: true
            });

            promise.$promise.then(function (data) {

                vm.listBt = [];
                vm.listBt = data.business_title;
                vm.listBt.push({
                    id: 0,
                    description: "OTHER"
                });
            });

            promise.$promise.catch(function (err) {
                vm.listBt = [];
            });
        }

        function viewDetail(id) {
            $state.go("app.mpn_gw_detail", {
                id: id,
                tipe: "requestor"
            });
        }

        function deleteRequest(ev) {
            var promiseAuth = Auth.setToken();
            var item = [];

            angular.forEach(vm.listSelected, function (value, key) {
                var val = { 'id': value.id };
                item.push(val);
            });

            promiseAuth.then(function () {

                var response = endpoint.delete({
                    action: 'delete',
                    data: angular.toJson(item)
                });

                response.$promise.then(function (data) {

                    var confirm = $mdDialog.confirm()
                        .title('Success.!')
                        .textContent(data.pesan)
                        .ariaLabel('Lucky day')
                        .targetEvent(ev)
                        .ok('Close')

                    $mdDialog.show(confirm).then(function () {
                        viewData();
                        $mdDialog.cancel();
                    });

                });

            });
        }

        function edit(ev, id) {
            $state.go("app.mpn_gw_edit", {
                id: id
            });
        }

        vm.viewDetailApprove = viewDetailApprove;

        function viewDetailApprove(data, e) {
            $mdDialog.show({
                controller: 'ApprovalOtherBusinessTitle as vm',
                templateUrl: 'app/main/mpn-gw/other-business-title/approval-other-business-title.html',
                parent: angular.element(document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    data: data
                }
            }).then(function () {
                viewData();
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.other-business-title')
        .controller('ApprovalOtherBusinessTitle', Controller);

    Controller.$inject = [
        '$mdDialog',
        '$element',
        '$http',
        'data',
        'config',
        'AppAPI',
        'Form',
        'Auth',
        '$mdToast'
    ];

    /* @ngInject */
    function Controller(
        $mdDialog,
        $element,
        $http,
        data,
        config,
        AppAPI,
        Form,
        Auth,
        $mdToast
    ) {

        console.log(data);
        var vm = this;
        vm.hide = hide;
        vm.cancel = cancel;
        vm.getListDataDepartment = getListDataDepartment;
        vm.getBusinessTitle = getBusinessTitle;
        vm.getListDataJobTitle = getListDataJobTitle;
        vm.getListDataGroupCluster = getListDataGroupCluster;
        vm.changeDescription = changeDescription;
        vm.querySearchIndirect = querySearchDefferedIndirect;
        vm.getSubArea = getSubArea;
        vm.getCostCenter = getCostCenter;
        vm.clearSearchTerm = clearSearchTerm;

        var MpnGw = new AppAPI.MpnGw().request;
        var Mpp = AppAPI.Mpp();

        Form.initialForm();

        Form.setObject(Mpp);

        vm.listDataCountry = [];

        vm.dataApproval = data;
        vm.searchTermBT;

        vm.Form = Form;
        setInitialisasiData(vm.dataApproval)


        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function setInitialisasiData(data) {
            vm.country_id = data.country_id;
            vm.Form.objForm.entity_id = data.company_id;
            vm.Form.objForm.other_business_title = data.other_business_title;
            vm.Form.objForm.other_business_title_description = data.other_business_title_description;
            vm.Form.objForm.description = data.other_business_title_description;
            vm.Form.objForm.type = data.type;
            vm.Form.objForm.job_level = data.job_level;
            vm.Form.objForm.nodeType = data.nodeType;
            vm.Form.objForm.clasification_code = data.clasification_code;
            vm.Form.objForm.abreviation = data.positionID;
            vm.Form.objForm.org_level_id = data.org_level_id;
            vm.Form.objForm.listArea = data.work_location_id;
            vm.Form.objForm.cost_center_id = data.cost_center;
            vm.Form.objForm.create_by = data.create_by;
            vm.Form.objForm.layerReport = (data.layerReport_id) ? data.layerReport_id[0].org_layer_id : null;

            vm.Form.objForm.group_cluster = data.group_cluster;

            getListDataCompany();
            getCountry(data.country_id);
            getBusinessTitle(data.ndc_business_title);
            getListDataJobTitle(data.job_title_desc);
            getListOrgLevel();

            if (data.div_old && data.div_old != -1) {
                vm.Form.objForm.division_id = data.div_old;
                getListDataDivisi(data.company_id);
                getListDataDepartment(data.div_old)
            } else {
                if (data.division_id) {
                    vm.Form.objForm.division_id = data.division_id;
                    vm.dataApproval.div_old = data.division_id;
                    getListDataDivisi(data.company_id);
                    getListDataDepartment(data.division_id)
                } else {
                    vm.Form.objForm.division_new = data.new_division;
                }

                if (data.div_old == -1) {
                    vm.dataApproval.div_old = null;
                }
            }

            if (data.dept_old && data.dept_old != -1) {
                vm.Form.objForm.department_id = data.dept_old;
                // getListDataDepartment(data.company_id);
            } else {
                if (data.department_id) {
                    vm.Form.objForm.department_id = data.department_id;
                    vm.dataApproval.dept_old = data.department_id;
                } else {
                    vm.Form.objForm.department_new = data.new_department;
                }

                if (data.dept_old == -1) {
                    vm.dataApproval.dept_old = null;
                }
            }

            getNodeType(data.company_id);
            getEmpClassification(data.company_id);
            getCbu();
            getSubDomain();

            if (data.org_id_direction) {
                var none = {
                    'id': data.org_id_direction,
                    'description': data.org_desc_direction
                };
                if (!vm.Form.objForm.direct_report) {
                    vm.Form.objForm.direct_report = none;
                }
            }

            getListDataGroupCluster(data.company_id, 'cm');

            getProfile();

            if (vm.Form.objForm.layerReport) {
                directReport(vm.Form.objForm.layerReport);
                vm.Form.objForm.other_bt_direct_report = (data.layerReport_id) ? data.layerReport_id[0].id : null;
            }
        }

        function clearSearchTerm(f) {
            switch (f) {
                case 1:
                    vm.searchTermBT = '';
                    break;
                case 2:
                    vm.searchTermCBU = '';
                    break;
                case 3:
                    vm.searchTermSD = '';
                    break;
                case 4:
                    vm.searchTermSA = '';
                    break;
            }
        };

        function getNodeType(bu) {
            vm.nodeType = [{
                'id': 0,
                'description': 'Regular'
            },
            {
                'id': 1,
                'description': 'Assistant'
            },
            {
                'id': 4,
                'description': 'Sub Assistant'
            },
            {
                'id': 10,
                'description': 'Super Assistant'
            },

            {
                'id': 2,
                'description': 'Adviser'
            },
            {
                'id': 5,
                'description': 'Sub Adviser'
            },
            {
                'id': 9,
                'description': 'Super Adviser'
            },

            {
                'id': 6,
                'description': 'General Partner'
            },
            {
                'id': 7,
                'description': 'Limited Partner'
            },
            {
                'id': 8,
                'description': 'Adviser Partner'
            },
            ];
        }

        function getCountry(search) {
            var response = MpnGw.query({
                action: 'getDataCountry',
                search: search
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(catchCountry);
        }

        function fetchCountry(data) {
            vm.listDataCountry = data;
            if (vm.country_id) {
                var i = vm.listDataCountry.map(function (e) {
                    return e.countrycode;
                }).indexOf(vm.country_id);

                if (i != -1) {
                    vm.Form.objForm.country = vm.listDataCountry[i];
                }
            }
            getSubArea(vm.dataApproval.company_id);

            getCostCenter(vm.dataApproval.company_id);
        }

        function catchCountry(data) {
            vm.listDataCountry = [];
        }

        function getListDataCompany() {
            var response = MpnGw.query({
                action: 'getDataCompany'
            });
            response.$promise.then(fetchDataCompany);
            response.$promise.catch(catchDataCompany);
        }

        function fetchDataCompany(data) {
            vm.listDataCompany = data;
        }

        function catchDataCompany(data) {
            vm.listDataCompany = [];
        }

        function getListDataDivisi(id) {
            if (typeof id !== 'undefined') {
                var response = MpnGw.query({
                    action: 'getDataDivisi',
                    entity_id: id
                });
                response.$promise.then(fetchDivisi);
                response.$promise.catch(catchDivisi);
            }
        }

        function fetchDivisi(data) {
            vm.listDataDivisi = data;
        }

        function catchDivisi(data) {
            vm.listDataDivisi = [];
        }

        function getListDataDepartment(divisi_id) {
            // console.log(divisi_id);
            if (typeof divisi_id !== 'undefined') {
                var response = MpnGw.query({
                    action: 'getDataDepartment',
                    divisi_id: divisi_id
                });
                response.$promise.then(fetchDepartment);
                response.$promise.catch(catchDepartment);
            }
        }

        function fetchDepartment(data) {
            vm.listDataDepartment = data;
            vm.listDataDepartment.unshift({ id: "00", description: "Head" });
        }

        function catchDepartment(data) {
            vm.listDataDepartment = [];
        }

        function getBusinessTitle(search) {
            if (search) {
                if (search.length >= 3) {
                    var search = search;
                    if (search == 'all') {
                        search = '';
                    }
                    var response = MpnGw.query({
                        action: 'getDataBusinessTitle',
                        search: search,
                        id: (vm.Form.objForm.bt_code) ? vm.Form.objForm.bt_code.id : ''
                    });
                    response.$promise.then(fetchResponseBusinessTitle);
                    response.$promise.catch(catchResponseBusinessTitle);
                }
            }
        }

        function fetchResponseBusinessTitle(data) {
            vm.listBusinessTitle = data;
            if (!vm.searchTermBT) {
                var i = vm.listBusinessTitle.map(function (e) {
                    return e.id;
                }).indexOf(vm.dataApproval.bt_id);

                if (i != -1) {
                    vm.Form.objForm.bt_code = vm.listBusinessTitle[i];
                }
            }
        }

        function catchResponseBusinessTitle(data) {
            vm.listBusinessTitle = [];
        }

        function getListDataJobTitle(search) {

            if (search) {
                if (search.length >= 3) {
                    var search = search;
                    if (search == 'all') {
                        search = '';
                    }
                    var response = MpnGw.query({
                        action: 'getDataJobTitle',
                        search: search,
                        id: (vm.Form.objForm.abreviation) ? vm.Form.objForm.abreviation : '',
                        company_id: (vm.Form.objForm.entity_id) ? vm.Form.objForm.entity_id : ''
                    });
                    response.$promise.then(fetchJobtitle);
                    response.$promise.catch(catchJobTitle);
                }
            }

        }

        function fetchJobtitle(data) {
            vm.listDataJobTitle = data;
        }

        function catchJobTitle(data) {
            vm.listDataJobTitle = [];
        }

        function getListDataGroupCluster(data, from) {
            if (data !== 'undefined') {
                var id = data.substring(0, 2);
                if (from == 'cm') {
                    id = data;
                }
                var response = MpnGw.query({
                    action: 'getDataGroupCluster',
                    id: id
                });
                response.$promise.then(fetchGroupCluster);
                response.$promise.catch(catchGroupCluster);
            }
        }

        function fetchGroupCluster(data) {
            vm.listDataGroupCluster = data;
        }

        function catchGroupCluster(data) {
            vm.listDataGroupCluster = [];
        }

        function changeDescription(item) {
            vm.searchTermBT = '';
            if (item) {
                vm.Form.objForm.description = item.description;
                vm.Form.objForm.job_title_text = item.description;
                vm.Form.objForm.job_function = item.code.substring(0, 2);
                if (item.grade) {
                    vm.Form.objForm.job_level = item.grade;
                    vm.Form.objForm.job_level_set = true;
                } else {
                    vm.Form.objForm.job_level = null;
                    vm.Form.objForm.job_level_set = false;
                }
            }

        }

        function getListOrgLevel() {
            var response = Mpp.query({
                action: 'getListOrgLevel',
                org_level_id: 0
            });
            response.$promise.then(fetchResponseOrgLevel);
            response.$promise.catch(catchResponseOrgLevel);
        }

        function fetchResponseOrgLevel(data) {
            vm.orgLevel = data;

        }

        function catchResponseOrgLevel(data) {
            vm.orgLevel = [];
        }

        function querySearchDefferedIndirect(query) {
            return $http
                .get(config.api + 'api/mpngw/mpngwrequest?action=getListOrgLayer&search=' + query)
                .then(function (item) {
                    return item.data;
                });
        }

        function getEmpClassification(bu) {
            var response = MpnGw.query({
                action: 'getEmpClasification',
                bu: bu
            });
            response.$promise.then(fetchResponseEmpClassification);
            response.$promise.catch(catchResponseEmpClassification);
        }

        function fetchResponseEmpClassification(data) {
            vm.classificationCode = data;
        }

        function catchResponseEmpClassification(data) {
            vm.classificationCode = [];
        }

        function getCbu() {
            var response = MpnGw.query({
                action: 'getListCbu'
            });
            response.$promise.then(fetchCbu);
            response.$promise.catch(catchCbu);
        }

        function fetchCbu(data) {
            vm.listCbu = data;
        }

        function catchCbu(data) {
            vm.listCbu = [];
        }

        function getSubDomain() {
            var response = MpnGw.query({
                action: 'getListSubDomain'
            });
            response.$promise.then(fetchSubDomain);
            response.$promise.catch(catchSubDomain);
        }

        function fetchSubDomain(data) {
            vm.loadingProgress = false;
            vm.listSubDomain = data;
        }

        function catchSubDomain(data) {
            vm.loadingProgress = false;
            vm.listSubDomain = [];
        }

        function getSubArea(id) {
            // console.log(vm.listDataCountry);
            if (typeof id !== 'undefined') {
                var country_code = null;
                if (vm.Form.objForm.country) {
                    var i = vm.listDataCountry.map(function (e) {
                        return e.id;
                    }).indexOf(vm.Form.objForm.country.id);

                    if (i != -1) {
                        country_code = vm.listDataCountry[i].countrycode;
                    }
                }
                var response = MpnGw.query({
                    action: 'getListSubArea',
                    id: id,
                    country_code: country_code
                });
                response.$promise.then(fetchSubArea);
                response.$promise.catch(catchSubArea);
            }

        }

        function fetchSubArea(data) {

            vm.listSubarea = data;
            vm.listSubarea.unshift({
                description: "All Area",
                id: "0"
            });
        }

        function catchSubArea(data) {
            vm.listSubarea = [];
        }

        function getCostCenter(id) {
            if (typeof id !== 'undefined') {
                // getSubArea(id);
                var country_code = null;
                if (vm.Form.objForm.country) {
                    var i = vm.listDataCountry.map(function (e) {
                        return e.id;
                    }).indexOf(vm.Form.objForm.country.id);

                    if (i != -1) {
                        country_code = vm.listDataCountry[i].countrycode;
                    }
                }
                var response = MpnGw.query({
                    action: 'getCostCenter',
                    id: id,
                    country_code: country_code
                });
                response.$promise.then(fetchResponseCostCenter);
                response.$promise.catch(catchResponseCostCenter);
            }
        }

        function fetchResponseCostCenter(data) {
            vm.costCenter = data;

        }

        function catchResponseCostCenter(data) {
            vm.costCenter = [];
        }

        vm.approve = approve;


        function approve(ev, formController) {
            vm.saveProcess = true;
            vm.loadingProgress = true;

            var promiseAuth = Auth.setToken();
            promiseAuth.then(function () {
                var response = MpnGw.save({
                    action: 'approveOtherBusinessTitle',
                    dataApproval: vm.dataApproval,
                    data: vm.Form.objForm,
                    approval_type: vm.dataApproval.approval_type
                });
                response.$promise.then(successSaveMpp);
                response.$promise.catch(failedSaveMpp);
            });
        }

        function successSaveMpp() {
            vm.success = true;
            vm.saveProcess = false;
            vm.loadingProgress = false;
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Berhasil simpan data Approval')
                    .position('top right')
                    .hideDelay(3000)
                    .theme("success-toast")

            );
            hide();
        }

        function failedSaveMpp() {
            vm.success = false;
            vm.saveProcess = false;
            vm.loadingProgress = false;
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Gagal simpan data Approval')
                    .position('top right')
                    .hideDelay(3000)
                    .theme("error-toast")
            );
        }


        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }


        function getProfile() {

            var promise = MpnGw.get({
                action: "getProfileOBT",
                nik_request: vm.Form.objForm.create_by
            });

            promise.$promise.then(function (data) {
                // loadDataDepartment(data.employee_info.division_id);
                // loadBt(data.employee_info.department_id);
                // // loadGedung(data.employee_info.subArea);
                // vm.Form.objForm.division_id = data.employee_info.division_id;
                // vm.Form.objForm.department_id = data.employee_info.department_id;
                // vm.Form.objForm.work_location = data.employee_info.subArea;
                // vm.is_head_div = data.employee_info.is_head_div;
                vm.layerList = data.layer;
            });
            promise.$promise.catch(function (err) {

            });
        }

        vm.directReport = directReport;

        function directReport(id) {
            vm.directList = [];
            var promise = MpnGw.query({
                action: "getDirectReport",
                layer_id: id
            });

            promise.$promise.then(function (data) {
                console.log(data);

                vm.directList = [];
                vm.directList = data;
            });

            promise.$promise.catch(function (err) {
                vm.directList = [];
            });
        }

    }




})();

(function () {
    "use strict";

    angular
        .module("app.mpn-gw.dashboard", [
            "ui.tinymce",
            "ngMaterial",
            "ngMessages",
            "chart.js",
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state("app.mpn_gw_list_dashboard", {
                url: "/mpngw/list/dashboard",
                views: {
                    "content@app": {
                        templateUrl: "app/main/mpn-gw/dashboard/list.html",
                        controller: "MpnGwDashboardListController as vm",
                    },
                },
            })
            .state("app.mpn_gw_dashboard", {
                url: "/mpngw/dashboard",
                views: {
                    "content@app": {
                        templateUrl: "app/main/mpn-gw/dashboard/dashboard.html",
                        controller: "MpnGwDashboardController as vm",
                    },
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.dashboard')
        .controller('MpnGwDashboardListController', MpnGwDashboardListController);

    MpnGwDashboardListController.$inject = [
        "AppAPI",
        "DataService",
        "config",
        "$localStorage",
        "$state",
        "$location",
        "$window"
    ];

    function MpnGwDashboardListController(
        AppAPI,
        DataService,
        config,
        $localStorage,
        $state,
        $location,
        $window
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;

        vm.company = $localStorage.empsite;
        vm.approvalStatus = "All";
        vm.budgetType = "All";
        vm.readStatus = "0";
        vm.mpnStatus = "All";
        vm.listMpnStatus = ["OPEN", "CLOSE", "All"];
        vm.listReadStatus = [
            { 'value': '-', 'desc': 'All' },
            { 'value': '0', 'desc': 'Unread' },
            { 'value': '1', 'desc': 'Read' },

        ];

        vm.listSelected = [];
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        vm.listBudgetType = ["All", "Budgeted", "Unbudgeted"];
        vm.listApprovalStatus = ["Draft", "Waiting Approval", "Approved", "Rejected", "Revision", "All"];

        vm.loadDataDepartment = loadDataDepartment;
        vm.loadBt = loadBt;

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.viewDetail = viewDetail;
        vm.download = true;

        vm.listPIC = [];
        vm.clearSearchTerm = clearSearchTerm;
        vm.ketikSearch = ketikSearch;

        viewData();
        loadDataDivision();
        getPIC();
        getDataDashboarReport();

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewdatadashboard',
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                approvalStatus: vm.approvalStatus,
                budgetType: vm.budgetType,
                btcode: vm.btcode,
                mpnStatus: vm.mpnStatus,
                pic: vm.pic,
                readStatus: vm.readStatus,
            });
        }

        function loadDataDivision() {
            vm.listDivision = [];
            var response = endpoint.query({
                action: "getdivisions",
                bu: vm.company
            });
            response.$promise.then(function (data) {
                vm.listDivision = data;
            });
            response.$promise.catch(function (data) {
                vm.listDivision = [];
            });
        }

        function loadDataDepartment(iddivisi) {
            vm.listDepartment = [];
            var response = endpoint.query({
                action: "getdepartments",
                idDivisi: iddivisi
            });
            response.$promise.then(function (data) {
                vm.listDepartment = data;
            });
            response.$promise.catch(function (data) {
                vm.listDepartment = [];
            });
        }

        function loadBt(department) {
            vm.listBt = [];
            vm.listBt.push({
                id: 0,
                description: "OTHER"
            });

            var promise = endpoint.get({
                action: "getbusinesstitle",
                company: vm.company,
                divisi: vm.division,
                department: department,
                bu_only: true
            });

            promise.$promise.then(function (data) {

                vm.listBt = [];
                vm.listBt = data.business_title;
                vm.listBt.push({
                    id: 0,
                    description: "OTHER"
                });
            });

            promise.$promise.catch(function (err) {
                vm.listBt = [];
            });
        }

        function viewDetail(id) {
            $state.go("app.mpn_gw_detail", {
                id: id,
                tipe: "dashboard"
            });
        }

        vm.exportToExcel = function (ev) {
            var json = JSON.stringify({
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                approvalStatus: vm.approvalStatus,
                budgetType: vm.budgetType,
                btcode: vm.btcode
            });

            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.api + 'api/mpngw/exportExcel/' + json, '_blank');
        }

        function ketikSearch(ev) {
            ev.stopPropagation();
        }

        function clearSearchTerm() {
            vm.searchTerm = '';
        }

        function getPIC() {
            angular.element.blockUI();
            var RequestPromise = endpoint.query({
                action: "getpiclist"
            });
            RequestPromise.$promise.then(fetchDataRequest);
            RequestPromise.$promise.catch(errorFetchRequest);
        }

        function fetchDataRequest(data) {
            vm.listPIC = data;

            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.listPIC = [];
            angular.element.unblockUI();
        }

        function getDataDashboarReport() {
            angular.element.blockUI();
            var RequestPromise = endpoint.get({
                action: "dashboardreport"
            });
            RequestPromise.$promise.then(fetchDataDashboardReport);
            RequestPromise.$promise.catch(errorFetchDashboardReport);
        }

        function fetchDataDashboardReport(data) {
            console.log(data);

            vm.dashboard = data;

            angular.element.unblockUI();
        }

        function errorFetchDashboardReport() {
            vm.dashboard = [];
            angular.element.unblockUI();
        }

    }

})();

(function () {
    "use strict";
    am4core.useTheme(am4themes_animated);
    am4core.addLicense("CH211444723");

    angular
        .module("app.mpn-gw.dashboard")
        .controller("MpnGwDashboardController", MpnGwDashboardController);

    MpnGwDashboardController.$inject = [
        "AppAPI",
        "config",
        "$localStorage",
        "$state",
        "$location",
        "$window",
        "$scope",
    ];

    function MpnGwDashboardController(
        AppAPI,
        config,
        $localStorage,
        $state,
        $location,
        $window,
        $scope
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;
        vm.type = '0';
        vm.division = [];

        vm.viewDetail = viewDetail;
        vm.loadData = viewData;
        vm.loadDivision = loadDivision;
        vm.getChart = getChart;
        vm.getTitle = getTitle;
        vm.listChart = [];

        vm.listType = [
            { id: 0, desc: "Group Cluster" },
            { id: 1, desc: "Company" },
            { id: 2, desc: "Division" },
        ];

        viewData();
        getCompany();

        function getCompany() {
            var RequestPromise = endpoint.query({
                action: "getDataCompany",
            });
            RequestPromise.$promise.then(fetchDataCompany);
            RequestPromise.$promise.catch(errorFetchCompany);
        }

        function viewDetail(id) {
            $state.go("app.mpn_gw_detail", {
                id: id,
                tipe: "dashboard",
            });
        }

        function viewData() {
            angular.element.blockUI();
            var RequestPromise = endpoint.get({
                action: "dashboard",
                type: vm.type,
                company: vm.company,
                division: JSON.stringify(vm.divisi),
            });
            RequestPromise.$promise.then(fetchData);
            RequestPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.dashboard = data.table;
            var mtm = data.mtm;

            multipleChart(mtm);
            funnelChart(data.yearly[0].funnel);
            pieDiv(data.yearly[0].divisi);
            pieGrade(data.yearly[0].grade);
            // setChart(mtm);
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.dashboard = [];
            angular.element.unblockUI();
        }

        function fetchDataCompany(data) {
            vm.listCompany = data;
        }

        function errorFetchCompany() {
            vm.listCompany = [];
        }

        function loadDivision(id) {
            vm.divisi = [];
            vm.listDivision = [];
            var response = endpoint.query({
                action: "getdivisions",
                bu: id,
            });
            response.$promise.then(function (data) {
                vm.listDivision = data;
            });
            response.$promise.catch(function (data) {
                vm.listDivision = [];
            });
        }

        function setChart(mtm) {
            vm.lineChart = {
                labels: mtm.label,
                series: [
                    "All MPN Request",
                    "Approval Progress",
                    "TA Progress",
                    "MPN Done",
                ],
                data: [mtm.x1, mtm.x2, mtm.x3, mtm.x4],
                options: {
                    legend: {
                        display: true,
                    },
                    plugins: {
                        datalabels: {
                            display: true,
                            clamp: true,
                            anchor: "end",
                            align: "top",
                            color: "#fff",
                            font: {
                                size: "10",
                                weight: "400",
                            },
                            padding: {
                                left: 2,
                                right: 2,
                                top: 2,
                                bottom: 2,
                            },
                            textAlign: "end",
                            backgroundColor: "rgba(66, 179, 213, 1)",
                            borderRadius: "3",
                        },
                    },
                    tooltips: true,
                    radius: 5,
                    // scales: {
                    //     xAxes: [
                    //         {
                    //             stacked: true,
                    //         },
                    //     ],
                    //     yAxes: [
                    //         {
                    //             stacked: true,
                    //         },
                    //     ],
                    // },
                },
                colors: getColors(4),
            };
        }

        function getChart(id) {
            angular.element.blockUI();
            var response = endpoint.get({
                action: "dashboardChart",
                type: vm.type,
                company: vm.company,
                id: id,
                division: JSON.stringify(vm.divisi),
            });
            response.$promise.then(function (data) {
                multipleChart(data.mtm);
                funnelChart(data.yearly[0].funnel);
                pieDiv(data.yearly[0].divisi);
                pieGrade(data.yearly[0].grade);
            });
            response.$promise.catch(function (data) {
                // setChart(data)
            });
            angular.element.unblockUI();
        }

        function getColors(setsCount) {
            var gradient = {
                0: [255, 255, 255, 1],
                20: [220, 237, 200, 1],
                45: [66, 179, 213, 1],
                65: [26, 39, 62, 1],
                100: [0, 0, 0, 1],
            };
            var gradientKeys = Object.keys(gradient);
            gradientKeys.sort(function (a, b) {
                return +a - +b;
            });
            var chartColors = [];
            for (var i = 0; i < setsCount; i++) {
                var gradientIndex = (i + 1) * (100 / (setsCount + 1)); //Find where to get a color from the gradient
                for (var j = 0; j < gradientKeys.length; j++) {
                    var gradientKey = gradientKeys[j];
                    if (gradientIndex === +gradientKey) {
                        //Exact match with a gradient key - just get that color
                        chartColors[i] =
                            "rgba(" + gradient[gradientKey].toString() + ")";
                        break;
                    } else if (gradientIndex < +gradientKey) {
                        //It's somewhere between this gradient key and the previous
                        var prevKey = gradientKeys[j - 1];
                        var gradientPartIndex =
                            (gradientIndex - prevKey) / (gradientKey - prevKey); //Calculate where
                        var color = [];
                        for (var k = 0; k < 4; k++) {
                            //Loop through Red, Green, Blue and Alpha and calculate the correct color and opacity
                            color[k] =
                                gradient[prevKey][k] -
                                (gradient[prevKey][k] -
                                    gradient[gradientKey][k]) *
                                gradientPartIndex;
                            if (k < 3) color[k] = Math.round(color[k]);
                        }
                        chartColors[i] = "rgba(" + color.toString() + ")";
                        break;
                    }
                }
            }

            var colors = [];
            chartColors.map(function (val) {
                colors.push({
                    backgroundColor: val,
                    borderColor: "rgba(255,255,255,0)",
                });
            });

            return colors;
        }

        function funnelChart(data) {
            vm.chart = am4core.create("chartdiv", am4charts.SlicedChart);
            vm.chart.hiddenState.properties.opacity = 0;

            vm.chart.data = data;

            var series = vm.chart.series.push(new am4charts.FunnelSeries());
            series.colors.step = 2;
            series.dataFields.value = "value";
            series.dataFields.category = "name";

            series.alignLabels = true;
            series.orientation = "horizontal";
            series.bottomRatio = 1;
            series.labels.template.adapter.add("text", getValue);
            series.tooltip.label.adapter.add("text", getValue);
            series.legendSettings.valueText = "{valueY}";

            vm.chart.legend = new am4charts.Legend();
            vm.chart.legend.position = "top";
            vm.chart.legend.labels.template.text = "[bold {color}]{name}[/] : {value}";

            function getValue(text, target) {
                if (target.dataItem) {
                    return "{category}: " + target.dataItem.values.value.value;
                }
            }

            series.colors.list = [am4core.color("#009688")];
            vm.listChart.push(vm.chart);
        }

        function pieGrade(data) {
            // Create chart instance
            var chart = am4core.create("chartdivGrade", am4charts.PieChart);

            // Add data
            chart.data = data;
            chart.legend = new am4charts.Legend();

            // Add and configure Series
            var pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "grade";
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.slices.template.strokeWidth = 2;
            pieSeries.slices.template.strokeOpacity = 1;

            // This creates initial animation
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;
            vm.listChart.push(chart);
        }

        function pieDiv(data) {
            // Create chart instance
            var chart = am4core.create("chartdivDiv", am4charts.PieChart);

            // Add data
            chart.data = data;
            chart.legend = new am4charts.Legend();

            // Add and configure Series
            var pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "division";
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.slices.template.strokeWidth = 2;
            pieSeries.slices.template.strokeOpacity = 1;

            // This creates initial animation
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;
            vm.listChart.push(chart);
        }

        function multipleChart(data) {
            var chart = am4core.create("chartMultiple", am4charts.XYChart);

            // Export
            chart.exporting.menu = new am4core.ExportMenu();
            chart.legend = new am4charts.Legend();

            /* Create axes */
            var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "month";
            categoryAxis.renderer.minGridDistance = 30;

            /* Create value axis */
            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

            /* Create series */
            var columnSeries = chart.series.push(new am4charts.ColumnSeries());
            columnSeries.name = "Request";
            columnSeries.dataFields.valueY = "request";
            columnSeries.dataFields.categoryX = "month";

            columnSeries.columns.template.tooltipText =
                "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]";
            columnSeries.columns.template.propertyFields.fillOpacity =
                "fillOpacity";
            columnSeries.columns.template.propertyFields.stroke = "stroke";
            columnSeries.columns.template.propertyFields.strokeWidth =
                "strokeWidth";
            columnSeries.columns.template.propertyFields.strokeDasharray =
                "columnDash";
            columnSeries.tooltip.label.textAlign = "middle";

            var lineSeries = chart.series.push(new am4charts.LineSeries());
            lineSeries.name = "Done";
            lineSeries.dataFields.valueY = "done";
            lineSeries.dataFields.categoryX = "month";

            lineSeries.stroke = am4core.color("#fdd400");
            lineSeries.strokeWidth = 3;
            lineSeries.propertyFields.strokeDasharray = "lineDash";
            lineSeries.tooltip.label.textAlign = "middle";

            var bullet = lineSeries.bullets.push(new am4charts.Bullet());
            bullet.fill = am4core.color("#fdd400"); // tooltips grab fill from parent by default
            bullet.tooltipText =
                "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]";
            var circle = bullet.createChild(am4core.Circle);
            circle.radius = 4;
            circle.fill = am4core.color("#fff");
            circle.strokeWidth = 3;

            chart.data = data;
            vm.listChart.push(chart);
        }

        function getTitle() {
            switch (vm.type) {
                case '0':
                    return "Company";
                    break;
                case '1':
                    return "Division";
                    break;
                case '2':
                    return "Department";
                    break;
            }
        }

        $scope.$on("$destroy", function () {
            if (vm.listChart.length > 0) {
                for (var i = 0; i < vm.listChart.length; i++) {
                    vm.listChart[i].dispose();
                }
            }
        });
    }
})();

(function () {
  'use strict';

  angular.module('app.mpn-gw.mass-role', ['ngMaterial', 'ngMessages']).config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      .state('app.mpn_gw_mass_role', {
        url: '/mpngw/mass-role',
        views: {
          'content@app': {
            templateUrl: 'app/main/mpn-gw/mass-role/mass-role.html',
            controller: 'MassRoleController as vm'
          }
        }
      });
  }

})();
(function () {
  angular
    .module('app.mpn-gw.mass-role')
    .controller('MassRoleController', MassRoleController);

  MassRoleController.$inject = [
    "AppAPI",
    "DataService",
    "Auth",
    "config",
    "$localStorage",
    "$state",
    "$mdDialog"
  ]

  function MassRoleController(
    AppAPI,
    DataService,
    Auth,
    config,
    $localStorage,
    $state,
    $mdDialog
  ) {
    var vm = this;
    var endpoint = new AppAPI.MpnMassRole();
    vm.company = $localStorage.empsite;
    vm.listJum = [5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.deleteItem = deleteItem;
    vm.edit = edit;
    vm.listSelected = [];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.createItem = createItem;
    vm.DataTable = new DataService();
    vm.list = [];

    loadData();

    function loadData(pageno) {
      angular.element.blockUI();
      var resp = vm.DataTable.loadData(endpoint, pageno, {
        action: 'viewData',
        company: vm.company,
      });

      resp.then(processInfo);
      resp.catch(errorProcessInfo);
    }

    function processInfo(data) {
      vm.list = data.list;
    }

    function errorProcessInfo() {
      vm.list = [];
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listSelected = [];
      vm.listSelected = angular.copy(vm.DataTable.list);
    }

    function unCheckAll() {
      vm.listSelected = [];
    }

    function deleteItem(ev) {
      angular.element.blockUI();

      var promiseAuth = Auth.setToken();
      var item = [];

      angular.forEach(vm.listSelected, function (value, key) {
        var val = { 'id': value.id };
        item.push(val);
      });

      promiseAuth.then(function () {

        var response = endpoint.delete({
          action: 'delete',
          data: angular.toJson(item)
        });

        response.$promise.then(function (data) {

          var confirm = $mdDialog.confirm()
            .title('Success.!')
            .textContent(data.pesan)
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Close')

          $mdDialog.show(confirm).then(function () {
            loadData();
            $mdDialog.cancel();
          });
          angular.element.unblockUI();

        });
        response.$promise.catch(function (data) {

          var confirm = $mdDialog.confirm()
            .title('Failed.!')
            .textContent(data.pesan)
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Close')

          $mdDialog.show(confirm).then(function () {
            loadData();
            $mdDialog.cancel();
          });
          angular.element.unblockUI();

        });

      });
    }

    function edit(ev, id) {
      $state.go("app.mpn_gw_edit", {
        id: id
      });
    }

    function createItem(ev) {
      $mdDialog.show({
        controller: 'MassroleInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/mpn-gw/mass-role/mass-role-form.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        onRemoving: function (element, removePromise) {
          loadData();
        }
      });
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.mpn-gw.mass-role')
    .controller('MassroleInputController', MassroleInputController);

  MassroleInputController.$inject = ['$mdDialog', '$timeout', 'Form', 'AppAPI', 'Auth'];

  function MassroleInputController($mdDialog, $timeout, Form, AppAPI, Auth) {
    var vm = this;
    vm.title = "Input MPN Mass Role";
    vm.closeModal = closeModal;
    vm.saveData = saveData;
    var endpoint = new AppAPI.MpnMassRole();
    var OfbRefCheck = AppAPI.OfbRefCheck();

    Form.initialForm();
    Form.setObject(endpoint);

    vm.Form = Form;

    vm.states = loadAll();
    vm.searchText = null;
    vm.querySearch = querySearch;
    vm.reloadToken = reloadToken;

    getBu();

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promiseAuth = Auth.setToken();

      promiseAuth.then(function () {
        angular.element.blockUI();

        var response = Form.saveData('save', formController, endpoint);

        response.then(function () {
          vm.messageTheme = 'blue';
          angular.element.unblockUI();
          formController.$setPristine();
          $timeout(function () {
            vm.Form.tampilPesan = false;
          }, 3000);

        });
        response.catch(function () {
          vm.messageTheme = 'pink';
          angular.element.unblockUI();

        });

      });
    }

    function querySearch(query) {
      if (query !== null && query !== "" && (query + "").length >= 2) {

        var promise = endpoint.query({
          action: "getLayer",
          query: query,
          bu: vm.Form.objForm.bu
        });

        return promise.$promise.then(function (data) {
          return data;
        });

        return promise.$promise.catch(function (err) {
          return [];
        });

      }
      return [];
    }

    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';
      return allStates.split(/, +/g).map(function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    function getBu() {
      var promise = OfbRefCheck.query({
        action: "getBuMpn"
      });
      promise.$promise.then(function (data) {
        vm.listBu = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.listBu = [];
      });
    }

    function reloadToken() {
      Auth.setToken();
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.mpn-gw.mass-role')
    .controller('MassroleEditController', MassroleEditController);

  MassroleEditController.$inject = ['$mdDialog', '$timeout', 'Form', 'AppAPI'];

  function MassroleEditController($mdDialog, $timeout, Form, AppAPI) {
    var vm = this;
    vm.title = "Edit MPN Mass Role";
  }
})();
(function () {
    'use strict';

    angular.module('app.mpn-gw.approval', ['ui.tinymce']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.mpn_gw_list_approval', {
                url: '/mpngw/list/approval',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mpn-gw/approval/list.html',
                        controller: 'MpnGwListApprovalController as vm'
                    }
                }
            })

            .state('app.mpn_gw_list_change_quantity', {
                url: '/mpngw/list/change_quantity',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mpn-gw/approval/list.change.quantity.html',
                        controller: 'ListChangeQuantityController as vm'
                    }
                }
            })

        ;
    }



})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.approval')
        .controller('SetPicController', SetPicController);

    function SetPicController(
        $mdDialog,
        idMpn,
        workLocation,
        Auth,
        AppAPI
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;
        vm.idMpn = idMpn;
        vm.submit = submit;
        vm.closeModal = closeModal;
        vm.workLocation = workLocation;
        vm.listPIC = [];
        vm.clearSearchTerm = clearSearchTerm;
        vm.ketikSearch = ketikSearch;

        getPIC();

        function ketikSearch(ev) {
            ev.stopPropagation();
        }

        function clearSearchTerm() {
            vm.searchTerm = '';
        }

        function closeModal() {
            $mdDialog.cancel();
        }

        function submit(data, type) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {

                var note = "";
                if (vm.notes != null) {
                    note = vm.notes;
                }

                var response = endpoint.save({
                    action: 'setpic',
                    idMpn: vm.idMpn,
                    notes: note,
                    typeApp: type,
                    pic: vm.pic
                });

                response.$promise.then(closeModal());
            });
        }

        function getPIC() {
            angular.element.blockUI();
            var RequestPromise = endpoint.query({
                action: "getpic",
                workLocation: vm.workLocation
            });
            RequestPromise.$promise.then(fetchDataRequest);
            RequestPromise.$promise.catch(errorFetchRequest);
        }

        function fetchDataRequest(data) {
            vm.listPIC = data;

            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.listPIC = [];
            angular.element.unblockUI();
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.approval')
        .controller('SetDelegateController', SetDelegateController);

    function SetDelegateController(
        $mdDialog,
        idMpn,
        approval,
        Auth,
        AppAPI
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;
        vm.idMpn = idMpn;
        vm.approval = approval;
        vm.submit = submit;
        vm.closeModal = closeModal;
        vm.searchTerm;
        vm.clearSearchTerm = clearSearchTerm;
        vm.ketikSearch = ketikSearch;

        getDelegate();

        function ketikSearch(ev) {
            ev.stopPropagation();
        }

        function clearSearchTerm() {
            vm.searchTerm = '';
        }

        function closeModal() {
            $mdDialog.cancel();
        }

        function submit(data) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                var response = endpoint.save({
                    action: 'setDelegate',
                    idMpn: vm.idMpn,
                    app: vm.approval,
                    delegate: vm.delegate,
                    notes: vm.notes
                });

                response.$promise.then(closeModal());
            });
        }

        function getDelegate() {
            angular.element.blockUI();
            var RequestPromise = endpoint.query({
                action: "getDelegate",
                app_type: approval.approval_type
            });
            RequestPromise.$promise.then(fetchDataRequest);
            RequestPromise.$promise.catch(errorFetchRequest);
        }

        function fetchDataRequest(data) {
            vm.listDelegate = data;

            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.listDelegate = [];
            angular.element.unblockUI();
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.approval')
        .controller('SetBudgetController', SetBudgetController);

    function SetBudgetController(
        $mdDialog,
        $localStorage,
        mpn,
        approval,
        Auth,
        AppAPI
    ) {

        var vm = this;
        vm.mpn = mpn;
        vm.approval = approval;
        vm.budget_type = vm.mpn.budget_type;
        vm.notes = "";
        vm.company = $localStorage.empsite;

        var endpoint = new AppAPI.MpnGw().request;
        vm.submit = submit;


        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.cancel();
        }

        function submit(status) {
            var promiseAuth = Auth.setToken();
            var content = "";

            switch (status) {
                case 2:
                    content = "approve";
                    break;

                default:
                    content = "reject";
                    break;
            }

            promiseAuth.then(function () {

                var response = endpoint.save({
                    action: 'approve',
                    mpn: vm.mpn,
                    app: vm.approval,
                    newBudget: vm.budget_type,
                    notes: vm.notes,
                    status: status,
                    tipe: 'budget'
                });

                response.$promise.then(closeModal());

            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.approval')
        .controller('RejectReviseController', RejectReviseController);

    function RejectReviseController(
        $mdDialog,
        mpn,
        approval,
        Auth,
        AppAPI
    ) {

        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;
        vm.mpn = mpn;
        vm.approval = approval;
        vm.submit = submit;
        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.cancel();
        }

        function submit(status) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                var response = endpoint.save({
                    action: 'approve',
                    mpn: vm.mpn,
                    notes: vm.notes,
                    status: status
                });

                response.$promise.then(closeModal());
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.request')
        .controller('RejectResetSLTGwController', RejectResetSLTGwController);

    function RejectResetSLTGwController(
        $mdDialog,
        mpn,
        Auth,
        AppAPI
    ) {

        var vm = this;
        var endpoint = new AppAPI.MpnResetSLT();
        vm.mpn = mpn;
        vm.submit = submit;
        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.cancel();
        }

        function submit(status) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                var response = endpoint.save({
                    action: 'rejectResetSLT',
                    mpn: vm.mpn,
                    notes: vm.notes,
                    status: status
                });

                response.$promise.then(closeModal());
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.approval')
        .controller('MpnGwListApprovalController', MpnGwListApprovalController);

    MpnGwListApprovalController.$inject = [
        "AppAPI",
        "DataService",
        "$localStorage",
        "$state"
    ];

    function MpnGwListApprovalController(
        AppAPI,
        DataService,
        $localStorage,
        $state
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;

        vm.company = $localStorage.empsite;
        vm.approvalStatus = "Waiting Approval";
        vm.budgetType = "All";

        vm.mpnStatus = "All";
        vm.listMpnStatus = ["OPEN", "CLOSE", "All"];

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listData = [];
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        vm.listBudgetType = ["All", "Budgeted", "Unbudgeted"];
        vm.listApprovalStatus = ["Draft", "Waiting Approval", "Approved", "Rejected", "Revision", "All"];

        vm.loadDataDepartment = loadDataDepartment;
        vm.loadBt = loadBt;

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.viewDetail = viewDetail;

        viewData();
        loadDataDivision();

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewdataapproval',
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                approvalStatus: vm.approvalStatus,
                budgetType: vm.budgetType,
                btcode: vm.btcode,
                subAction: 'approval',
                mpnStatus: vm.mpnStatus
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listData = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listData = [];
        }

        function loadDataDivision() {
            vm.listDivision = [];
            var response = endpoint.query({
                action: "getdivisions",
                bu: vm.company
            });
            response.$promise.then(function (data) {
                vm.listDivision = data;
            });
            response.$promise.catch(function (data) {
                vm.listDivision = [];
            });
        }

        function loadDataDepartment(iddivisi) {
            vm.listDepartment = [];
            var response = endpoint.query({
                action: "getdepartments",
                idDivisi: iddivisi
            });
            response.$promise.then(function (data) {
                vm.listDepartment = data;
            });
            response.$promise.catch(function (data) {
                vm.listDepartment = [];
            });
        }

        function loadBt(department) {
            vm.listBt = [];
            vm.listBt.push({
                id: 0,
                description: "OTHER"
            });

            var promise = endpoint.get({
                action: "getbusinesstitle",
                company: vm.company,
                divisi: vm.division,
                department: department,
                bu_only: true
            });

            promise.$promise.then(function (data) {

                vm.listBt = [];
                vm.listBt = data.business_title;
                vm.listBt.push({
                    id: 0,
                    description: "OTHER"
                });
            });

            promise.$promise.catch(function (err) {
                vm.listBt = [];
            });
        }

        function viewDetail(id, appType) {
            var tipeApp = "";
            switch (appType) {
                case 'adm-personal':
                    tipeApp = "adm-personal";
                    break;

                default:
                    tipeApp = "approval";
                    break;
            }

            $state.go("app.mpn_gw_detail", {
                id: id,
                tipe: tipeApp
            });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.approval')
        .controller('ListChangeQuantityController', ListChangeQuantityController);

    ListChangeQuantityController.$inject = [
        "AppAPI",
        "DataService",
        "$localStorage",
        "$state"
    ];

    function ListChangeQuantityController(
        AppAPI,
        DataService,
        $localStorage,
        $state
    ) {
        var vm = this;
        var endpoint = new AppAPI.MpnGw().request;

        vm.company = $localStorage.empsite;
        vm.approvalStatus = 1;
        vm.budgetType = "All";
        vm.listData = [];
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.listBudgetType = ["All", "Budgeted", "Unbudgeted"];
        vm.listApprovalStatus = [{
                "id": 1,
                "desc": "Waiting Approval"
            },
            {
                "id": 2,
                "desc": "Approved"
            },
            {
                "id": 4,
                "desc": "Rejected"
            },
            {
                "id": "All",
                "desc": "All"
            },
        ];

        vm.loadDataDepartment = loadDataDepartment;
        vm.loadBt = loadBt;

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.viewDetail = viewDetail;

        viewData();
        loadDataDivision();

        function loadDataDivision() {
            vm.listDivision = [];
            var response = endpoint.query({
                action: "getdivisions",
                bu: vm.company
            });
            response.$promise.then(function (data) {
                vm.listDivision = data;
            });
            response.$promise.catch(function (data) {
                vm.listDivision = [];
            });
        }

        function loadDataDepartment(iddivisi) {
            vm.listDepartment = [];
            var response = endpoint.query({
                action: "getdepartments",
                idDivisi: iddivisi
            });
            response.$promise.then(function (data) {
                vm.listDepartment = data;
            });
            response.$promise.catch(function (data) {
                vm.listDepartment = [];
            });
        }

        function loadBt(department) {
            vm.listBt = [];
            vm.listBt.push({
                id: 0,
                description: "OTHER"
            });

            var promise = endpoint.get({
                action: "getbusinesstitle",
                company: vm.company,
                divisi: vm.division,
                department: department,
                bu_only: true
            });

            promise.$promise.then(function (data) {

                vm.listBt = [];
                vm.listBt = data.business_title;
                vm.listBt.push({
                    id: 0,
                    description: "OTHER"
                });
            });

            promise.$promise.catch(function (err) {
                vm.listBt = [];
            });
        }

        function viewDetail(id) {
            var tipeApp = "changeheadcount";

            $state.go("app.mpn_gw_detail", {
                id: id,
                tipe: tipeApp
            });
        }

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewdataapprovalheadcount',
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                approvalStatus: vm.approvalStatus,
                budgetType: vm.budgetType,
                btcode: vm.btcode
            });
        }

    }


})();

(function () {
    'use strict';

    angular
        .module('app.mpn-gw.approval')
        .controller('ChangeQuantityController', ChangeQuantityController);


    // .directive('changeQuantity', changeQuantity);

    //     var directive = {
    //         link: changeQuantity,
    //         restrict: 'EA',
    //         require: 'ngModel',
    //         scope: {
    //             otherModelValue: '=finalQtyNew'
    //         }
    //     };
    //     return directive;

    //     function changeQuantity(scope, element, attributes, ngModel) {
    //         ngModel.$validators.finalQtyNew = function (modelValue) {
    //             return modelValue === scope.otherModelValue;
    //         };

    //         scope.$watch('otherModelValue', function () {
    //             ngModel.$validate();
    //         });
    //     }    



    function ChangeQuantityController(
        $mdDialog,
        $scope,
        $timeout,
        mpn,
        replacement,
        Auth,
        AppAPI,
        Form
    ) {
        var vm = this;
        vm.mpn = mpn;
        vm.recruit = [];
        vm.replacement = replacement;

        vm.closeModal = closeModal;
        vm.submit = submit;
        vm.initForm = initForm;
        vm.tmpFormController = [];

        var endpoint = new AppAPI.MpnGw().request;

        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;

        vm.mpn.qty_replacement = parseInt(vm.mpn.qty_replacement);
        vm.mpn.qty_new = parseInt(vm.mpn.qty_new);
        vm.mpn.qty_total = parseInt(vm.mpn.qty_total);

        vm.mpn.totRecruitReplacement = parseInt(vm.mpn.totRecruitReplacement);
        vm.mpn.totRecruitNew = parseInt(vm.mpn.totRecruitNew);

        vm.Form.objForm.final_qty_replacement = vm.mpn.totRecruitReplacement;
        vm.Form.objForm.final_qty_new = vm.mpn.totRecruitNew;

        vm.Form.objForm.mpn_gw = vm.mpn;

        function closeModal() {
            $mdDialog.cancel();
        }

        function submit(formInputs) {
            var promiseAuth = Auth.setToken();
            promiseAuth.then(function () {
                angular.element.blockUI();

                var promise = Form.saveData('savechangequantity', formInputs, endpoint);
                promise.then(function () {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });
                promise.catch(function () {
                    vm.messageTheme = 'red';
                    angular.element.unblockUI();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

            });
        }

        function initForm(param) {
            if (param) {
                vm.tmpFormController = param;
                $scope.frmRequest = param;
                // console.log($scope.frmRequest.final_qty_new);

                if (vm.Form.objForm.final_qty_replacement < vm.mpn.qty_replacement) {
                    $scope.frmRequest.final_qty_new.$dirty = true;
                    $scope.frmRequest.final_qty_new.$touched = true;
                    $scope.frmRequest.final_qty_new.$untouched = false;
                    $scope.frmRequest.final_qty_new.$error.requiredReplacement = true;
                } else {
                    $scope.frmRequest.final_qty_new.$dirty = false;
                    $scope.frmRequest.final_qty_new.$touched = false;
                    $scope.frmRequest.final_qty_new.$untouched = true;
                    $scope.frmRequest.final_qty_new.$error.requiredReplacement = false;
                }
            }
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.mpn-gw.request')
    .controller('AdminchangeqtyController', AdminchangeqtyController);

  AdminchangeqtyController.$inject = ['$mdDialog', '$timeout', 'AppAPI', 'Form', 'Auth', 'mpn', 'dataReplacement'];

  function AdminchangeqtyController($mdDialog, $timeout, AppAPI, Form, Auth, mpn, dataReplacement) {
    var vm = this;
    var endpoint = new AppAPI.MpnGw().request;
    vm.closeModal = closeModal;
    vm.tambah = tambah;
    vm.choose = choose;
    vm.selesai = selesai;
    vm.hapus = hapus;
    vm.mpn = mpn;
    vm.dataReplacement = [];
    vm.submitForm = submitForm;
    vm.inputNew = inputNew;

    Form.initialForm();
    Form.setObject(endpoint);
    vm.Form = Form;

    getReplacementType();

    function closeModal() {
      $mdDialog.hide();
    }

    function getReplacementType() {
      if (dataReplacement !== undefined) {
        vm.dataReplacement = dataReplacement;
      }

      vm.Form.objForm.qty_new = vm.mpn.qty_new;
      vm.Form.objForm.qty_replace = vm.mpn.qty_replacement;
      vm.Form.objForm.qty_total = vm.mpn.qty_total;

      vm.listReplacementType = [];
      var response = endpoint.query({
        action: "getreplacementtype"
      });
      response.$promise.then(function (data) {
        vm.listReplacementType = data;
      });
      response.$promise.catch(function (data) {
        vm.listReplacementType = [];
      });
    }

    function choose(emp) {
      vm.emp = "";
      vm.emp = emp;
    }

    vm.querySearch = function (query, index) {
      if (query !== null && query !== "" && (query + "").length >= 3) {

        var promise = endpoint.query({
          action: "getemployee",
          company: vm.company,
          divisi: vm.division_id,
          department: vm.department_id,
          replacementType: vm.replacement_type,
          workLocation: vm.workLocation,
          query: query
        });

        return promise.$promise.then(function (data) {
          return data;
        });

        return promise.$promise.catch(function (err) {
          return [];
        });

      }
      return [];
    }

    function tambah() {
      var data = {
        nik: vm.emp.nik,
        nama: vm.emp.nama,
        replacement_type: vm.replacement_type,
        effective_date: moment(vm.effective_date).format('YYYY-MM-DD'),
        positionID: vm.emp.positionID,
        subarea: vm.emp.subarea,
        subarea_id: vm.emp.sub_area_id,
        gedung: vm.emp.gedung,
        gedung_id: vm.emp.gedung_id,
      }

      vm.dataReplacement.push(data);
      vm.Form.objForm.qty_total = parseInt(vm.Form.objForm.qty_new) + parseInt(vm.dataReplacement.length);
    }

    function selesai() {
      $mdDialog.hide();
    }

    function submitForm(formInputs) {
      console.log("submit");

      var promiseAuth = Auth.setToken();

      vm.Form.objForm.new_old = vm.mpn.qty_new;
      vm.Form.objForm.replacement_old = vm.mpn.qty_replacement;
      vm.Form.objForm.total_old = vm.mpn.qty_total;

      vm.Form.objForm.division_id = vm.mpn.division_id;
      vm.Form.objForm.department_id = vm.mpn.department_id;
      vm.Form.objForm.business_title = vm.mpn.business_title;

      vm.Form.objForm.id = vm.mpn.id;
      vm.Form.objForm.mpn_replacement = vm.dataReplacement;

      promiseAuth.then(function () {
        angular.element.blockUI();

        var promise = Form.saveData('savechangeqtyadmin', formInputs, endpoint);
        promise.then(function () {
          vm.messageTheme = 'blue';
          angular.element.unblockUI();

          $timeout(function () {
            vm.Form.tampilPesan = false;
          }, 9000);
        });

        promise.catch(function () {
          vm.messageTheme = 'red';
          angular.element.unblockUI();

          $timeout(function () {
            vm.Form.tampilPesan = false;
          }, 9000);
        });

      });
    }

    function hapus(itemIndex) {
      vm.dataReplacement.splice(itemIndex, 1);
      vm.Form.objForm.qty_replace = vm.dataReplacement.length;

      vm.Form.objForm.qty_total = parseInt(vm.Form.objForm.qty_new) + parseInt(vm.Form.objForm.qty_replace);
    }

    function inputNew() {
      vm.Form.objForm.qty_total = parseInt(vm.Form.objForm.qty_new) + parseInt(vm.dataReplacement.length);
    }

  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mpn.tutorial', [
        ])
        .config(config);

    config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
        // State
        $stateProvider
        .state('app.mpn_tutorial', {
            url    : '/mpn/tutorial',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/mpn/tutorial/tutorial.html',
                    controller : 'TutorialMPNController as vm'
                }
            }
        });

        $stateProvider
        .state('app.mpn_tutorial_view', {
            url    : '/mpn/tutorial_view/:tutorial_type/:url',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/mpn/tutorial/tutorial-view.html',
                    controller : 'TutorialMPNViewController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.mpn.tutorial')
        .controller('TutorialMPNController', TutorialMPNController);

    TutorialMPNController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function TutorialMPNController($state,$log,$mdDialog,AppAPI,Auth,DataService, $document) {
        
        var vm = this;

        vm.tutorialList = [
            {id: 1, 
             title: 'Tutorial MPN Online',
             cover: 'MPN-COVER.png',
             cover_height: '200px',
             type: 'video',
             url: btoa('TUTORIAL-MPN-V1.mp4')            
            },
            {id: 2, 
             title: 'How To Create MPN Online',
             cover: 'MPN-COVER.png',
             cover_height: '200px',
             type: 'video',
             url: btoa('CREATE-MPN-V1.mp4')
            },
            {id: 3, 
                title: 'How To Respond MPN Request',
                cover: 'MPN-COVER.png',
                cover_height: '200px',
                type: 'video',
                url: btoa('RESPOND-MPN-REQUEST-V1.mp4')
            }

        ];

    }


 })();
(function () {
    'use strict';

    angular
        .module('app.mpn.tutorial')
        .controller('TutorialMPNViewController', TutorialMPNViewController);

    TutorialMPNViewController.$inject=['$state','$stateParams','$log','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function TutorialMPNViewController($state,$stateParams,$log,$mdDialog,AppAPI,Auth,DataService, $document) {
        
        var vm = this;        

        vm.tutorial_type = $stateParams.tutorial_type;
        vm.url = 'assets/tutorial/'+atob($stateParams.url)+((vm.tutorial_type === 'ebook')?'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;':'');        

    }


 })();
(function () {
  "use strict";

  angular.module("app.mpn.request", []).config(config);

  config.$inject = ["$translatePartialLoaderProvider", "$stateProvider"];
  /** @ngInject */
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
    // Translation
    // $translatePartialLoaderProvider.addPart("app/main/mpn/request");

    // State
    $stateProvider
      .state("app.mpn", {
        url: "/mpn",
        views: {
          "content@app": {
            templateUrl: "app/main/mpn/request/views/index.html",
            controller: "RequestController as vm"
          }
        }
      })
      .state("app.mpn_request_input", {
        url: "/mpn/request/input-request",
        views: {
          "content@app": {
            templateUrl: "app/main/mpn/request/views/input-mpn-request.html",
            controller: "InputrequestController as vm"
          }
        }
      })
      .state("app.mpn_request_edit", {
        url: "/mpn/request/edit-request/:id",
        views: {
          "content@app": {
            templateUrl: "app/main/mpn/request/views/edit-mpn-request.html",
            controller: "EditrequestController as vm"
          }
        }
      })
      .state("app.mpn_request_view", {
        url: "/mpn/request/view-request/:id",
        views: {
          "content@app": {
            templateUrl: "app/main/mpn/request/views/view-mpn-request.html",
            controller: "ViewRequestController as vm"
          }
        }
      });
  }
})();

(function () {
  "use strict";

  angular
    .module("app.mpn.request")
    .controller("ViewRequestController", RequestController);

  RequestController.$inject = [
    "$state",
    "$stateParams",
    "$scope",
    "$mdDialog",
    "$window",
    "$location",
    "$localStorage",
    "config",
    "MPNService",
    "AppAPI",
    "Auth"
  ];
  /** @ngInject */
  function RequestController(
    $state,
    $stateParams,
    $scope,
    $mdDialog,
    $window,
    $location,
    $localStorage,
    config,
    MPNService,
    AppAPI,
    Auth
  ) {
    var vm = this;
    vm.request = {};
    vm.mpn_approval = [];
    vm.reset_approval = false;
    vm.approveResetSLT = approveResetSLT;
    vm.rejectResetSLT = rejectResetSLT;

    // Data
    var Request = AppAPI.Mpn();
    var RequestResetSlt = AppAPI.MpnResetSLT();

    // Methods
    viewDataRequest();

    $scope.$on('$stateChangeStart', function (event, next, current) {

      if (vm.request.id == null || vm.request.current_status == 'Draft' || vm.request.current_status == 'Revision') {
        var answer = confirm("Are you sure you want to navigate away from this page, your MPN status is Draft.");
        if (!answer) {
          event.preventDefault();
        }

        // var confirm = $mdDialog.confirm()
        //   .title('Are you sure you want to navigate away from this page?')
        //   .textContent('You have unpublished MPN Request.')
        //   .ariaLabel('publish dialog')
        //   .ok('YES')
        //   .cancel('NO');

        // $mdDialog.show(confirm).then(function () {
        // }, function () {
        //   event.preventDefault();
        // });
      }

    });

    vm.editRequest = function () {
      $state.go("app.mpn_request_edit", { id: $stateParams.id });
    }

    vm.publishRequest = function () {

      var confirm = $mdDialog.confirm()
        .title('Would you like to save and publish this request?')
        .textContent('1 MPN Form is eligible for 1 position title only with same grade, same work location and same employment status.\n' +
          'But requestor can request the quantity more than 1 person for each positions with different reasons (replacement or new).' +
          '\n\nThis operation cannot be undone, make sure your data is correct.')
        .ariaLabel('publish dialog')
        .ok('YES')
        .cancel('no');

      $mdDialog.show(confirm).then(function () {

        angular.element.blockUI();
        var promise = Auth.setToken();
        promise.then(function () {

          vm.request.action = "save";

          vm.request.is_need_approval = true;
          vm.request.current_status = "Waiting Approval";

          var response = Request.save("save", vm.request);

          angular.element.unblockUI();
          response.$promise.then(function (params) {

            if (params.id !== null) {
              vm.request.id = params.id;

              MPNService.save(vm.request);

              viewDataRequest();

              $state.go("app.mpn_request_view", { id: params.id });
            }

          });

          response.$promise.catch(function () {
            angular.element.unblockUI();
          });
        });

        promise.catch(function () {
          angular.element.unblockUI();
        });


      }, function () {
      });


    }

    $scope.formatDate = function (date) {
      if (date === null) {
        return "";
      }
      return new Date(date)
    }
    //////////

    function viewDataRequest() {
      angular.element.blockUI();
      var RequestPromise = Request.get({
        action: "viewdetail",
        id: $stateParams.id,
        type: "view"
      });
      RequestPromise.$promise.then(fetchDataRequest);
      RequestPromise.$promise.catch(errorFetchRequest);
    }

    function fetchDataRequest(data) {
      angular.element.unblockUI();
      vm.reset_approval = false;
      if (angular.isArray(data.mpn_mpn)) {
        vm.request = data.mpn_mpn[0];
      } else {
        vm.request = data.mpn_mpn;
      }

      vm.request.quantity_replacement = parseInt(vm.request.quantity_replacement);
      vm.request.quantity_new_position = parseInt(vm.request.quantity_new_position);

      vm.mpn_approval_history = data.mpn_approval_history;

      vm.mpn_approval = data.mpn_approval;

      vm.replacement = data.mpn_replacement;
      vm.total_lead_time = data.total_lead_time;
      vm.mpn_reset_slt = data.mpn_reset_slt;
      vm.mpn_reset_slt_approval = data.mpn_reset_slt_approval;

      if ($localStorage.user == data.mpn_reset_slt_approval.approved_by) {
        vm.reset_approval = true;
      }

    }

    function errorFetchRequest() {
      vm.request = [];
      angular.element.unblockUI();
    }

    vm.Pdf = function () {
      var token = Auth.setTokenPromise();

      token.then(function (data) {

        var protocol = $location.protocol();
        var host = $location.host();
        var port = $location.port();

        var json = JSON.stringify({
          t: data.token,
          i: vm.request.id,
        });

        $window.open(protocol + '://' + host + ':' + port + config.api + 'api/mpnapproval/pdf?filter=' + json, '_blank');

      }, function () {
        $window.alert('gagal load token')
      });
    }

    function approveResetSLT(ev) {
      var promiseAuth = Auth.setToken();

      promiseAuth.then(function () {

        var confirm = $mdDialog.confirm()
          .title('Approve this?')
          .textContent('SLT will be reset if you accept.')
          .ariaLabel('eccept dialog')
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = RequestResetSlt.save({
            action: 'approveReset',
            mpn: vm.request,
            app: vm.mpn_reset_slt_approval
          });

          response.$promise.then(function (data) {
            angular.element.unblockUI();
            var confirm = $mdDialog.confirm()
              .title('Success.!')
              .textContent(data.pesan)
              .ariaLabel('Lucky day')
              .ok('Close');

            $mdDialog.show(confirm).then(function () {
              viewDataRequest();
              $mdDialog.cancel();
            }, function () {
              alert("cancel");
              viewDataRequest();
            });
          });
          response.$promise.catch(function () {
            angular.element.unblockUI();
            var confirm = $mdDialog.confirm()
              .title('Failed.!')
              .textContent(data.pesan)
              .ariaLabel('Lucky day')
              .ok('Close');

            $mdDialog.show(confirm).then(function () {
              viewDataRequest();
              $mdDialog.cancel();
            }, function () {
              alert("cancel");
              viewDataRequest();
            });
          });

        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function rejectResetSLT(ev) {
      $mdDialog.show({
        controller: 'RejectResetSLTController',
        controllerAs: 'vm',
        templateUrl: 'app/main/mpn/approval/reject.resetslt.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          viewDataRequest();
          vm.newComment = "";
        },
        locals: {
          mpn: vm.request,
          app: vm.mpn_reset_slt_approval
        }
      });
    }

  }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.request")
        .controller("RequestController", RequestController);

    RequestController.$inject = [
        "$state",
        "$scope",
        "$mdDialog",
        "AppAPI",
        "Auth",
        "filterFilter",
        "DataService"
    ];
    /** @ngInject */
    function RequestController(
        $state,
        $scope,
        $mdDialog,
        AppAPI,
        Auth,
        filterFilter,
        DataService
    ) {
        var vm = this;
        vm.listRequest = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listRequestSelected = [];
        vm.editData = editData;
        vm.deleteRequest = deleteRequest;
        vm.migrasiDataMPN = migrasiDataMPN;
        vm.viewDetail = viewDetail;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = viewDataRequest;

        // Data
        var Request = AppAPI.Mpn();

        viewDataRequest();

        function viewDataRequest(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(Request, pageno, {
                action: 'viewdata'
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listRequestSelected = angular.copy(vm.DataTable.list);
            console.log(vm.listRequestSelected)
        }

        function unCheckAll() {
            vm.listRequestSelected = [];
        }

        $scope.model = {};
        $scope.model.allItemsSelected = false;

        $scope.selectEntity = function () {
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (!vm.DataTable.list[i].isChecked) {
                    $scope.model.allItemsSelected = false;
                    return;
                }
            }
            $scope.model.allItemsSelected = true;
        };

        $scope.selectAll = function () {
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                vm.DataTable.list[i].isChecked = $scope.model.allItemsSelected;
            }
        };

        function editData(id) {
            $state.go("app.mpn_request_edit", {
                id: id
            });
        }

        function viewDetail(id) {
            $state.go("app.mpn_request_view", {
                id: id
            });
        }

        function deleteRequest(ev) {

            vm.listRequestSelected = filterFilter(vm.DataTable.list, function (r) {
                return r.isChecked && r.current_status == 'Draft';
            });

            if (vm.listRequestSelected == null || vm.listRequestSelected.length == 0) {
                return;
            }

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title("Would you like to delete this list?")
                    .textContent(
                        "All data your selected will be deleted and can not recovered."
                    )
                    .ariaLabel("delete dialog")
                    .targetEvent(ev)
                    .ok("YES")
                    .cancel("no");

                var data = [];
                angular.forEach(vm.listRequestSelected, function (value, key) {
                    this.push(value.id);
                }, data);

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = Request.delete({
                            action: "delete",
                            data: angular.toJson(data)
                        });

                        response.$promise.then(viewDataRequest);
                        response.$promise.catch(function () {
                            viewDataRequest();
                            angular.element.unblockUI();

                        });
                    },
                    function () {
                        angular.element.unblockUI();
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        $scope.parseInt = function (num) {
            return parseInt(num);
        }

        $scope.formatDate = function (date) {
            if (date === null) {
                return "";
            }
            return new Date(date)
        }

        vm.createMPN = createMPN;

        function createMPN(ev) {

            var confirm = $mdDialog
                .confirm()
                .title("Disclaimer Create MPN Online")
                .htmlContent(
                    "1 MPN Form is eligible for 1 position title only with same grade, same work location and same employment status. <br>" +
                    "But requestor can request the quantity more than 1 person for each positions with different reasons(replacement or new)."
                )
                .ariaLabel("disclaimer dialog")
                .targetEvent(ev)
                .ok("OK")
                .cancel("CANCEL");


            $mdDialog.show(confirm).then(
                function () {
                    $state.go("app.mpn_request_input");
                },
                function () {
                    angular.element.unblockUI();
                    // $scope.status = 'You decided to keep your debt.';
                }
            );
        }

        vm.showJoinedDetail = function (mpn_number, ev) {
            $mdDialog.show({
                locals: {
                    mpn_number: mpn_number
                },
                controller: function JoinController($mdDialog, AppAPI, mpn_number) {
                    var vm = this;
                    vm.mpn_number = mpn_number;

                    var Request = AppAPI.Mpn();

                    vm.viewEmployeeList = function name(params) {

                        angular.element.blockUI();
                        var RequestPromise = Request.query({
                            action: "viewjoinedemployee",
                            mpn_number: vm.mpn_number
                        });

                        RequestPromise.$promise.then(function (data) {
                            vm.listEmployee = data;
                            angular.element.unblockUI();
                        });

                        RequestPromise.$promise.catch(function (data) {
                            vm.listEmployee = [];
                            angular.element.unblockUI();
                        });
                    }

                    vm.viewEmployeeList();

                    vm.cancel = function () {
                        $mdDialog.hide();
                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn/request/views/join-detail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true
            }).then(function (answer) {

            }, function () {

            });

        }

        function migrasiDataMPN(params) {
            angular.element.blockUI();

            Request.get({
                action: 'migrasiDataMpnApprovalToMpnNew',
            }, function (mpn, getResponseHeaders) {
                mpn.action = 'migrasiDataMpnApprovalToMpnNew';
                mpn.$save(function (mpn, putResponseHeaders) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Migrasi Data MPN Berhasil')
                        .position('top right')
                        .hideDelay(3000)
                        .theme("success-toast")
                    );
                    angular.element.unblockUI();
                });
                mpn.$promise.catch(errorFetch);
            });
        }

        function errorFetch() {
            angular.element.unblockUI();
        }


    }
})();

(function () {
  "use strict";

  angular
    .module("app.mpn.request")
    .controller("InputrequestController", InputrequestController);

  InputrequestController.$inject = [
    "$state",
    "$localStorage",
    "$filter",
    "MPNService",
    "Auth",
    "Form",
    "AppAPI"
  ];
  /** @ngInject */
  function InputrequestController(
    $state,
    $localStorage,
    $filter,
    MPNService,
    Auth,
    Form,
    AppAPI
  ) {
    var vm = this;

    vm.mpnRequest = {};
    vm.isDisableBt = false;
    if ($localStorage.empsite == "EN") {
      vm.isDisableBt = true;
      vm.mpnRequest.budget_type = "Unbudgeted";
    }
    vm.Form = Form;

    var MPN = AppAPI.Mpn();
    var OfbRefCheck = AppAPI.OfbRefCheck();

    getBu();

    vm.mpnRequest.mpn_new_jobcode = {};

    vm.loadDataDepartment = loadDataDepartment;

    vm.loadDataDivision = loadDataDivision;

    vm.loadCompetency = loadCompetency;

    vm.company = $localStorage.empsite;

    vm.saveData = saveData;

    vm.clearMeesage = clearMeesage;

    vm.grade_category = [];

    vm.grades = [];
    vm.getWorkLocations = getWorkLocations;

    vm.educations = [
      "SMA Sederajat",
      "SMA",
      "SMK",
      "D1",
      "D3",
      "D4",
      "S1",
      "S2",
      "S3",
      "LPK"
    ];

    vm.EmploymentStatus = ["Contract", "Permanent"];

    vm.tinymceOptions = {
      inline: false,
      plugins: 'advlist autolink link image lists charmap print preview',
      toolbar: 'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
      menubar: false
    };

    vm.groupedGrades = vm.grades.reduce(function (previous, current) {
      if (previous.indexOf(current.group) === -1) {
        previous.push(current.group);
      }

      return previous;
    }, []);

    vm.adjustJoinDate = function () {
      var times = {};
      if (!vm.mpnRequest.grade_category.is_need_experience) {
        // vm.mpnRequest.emp_grade = vm.mpnRequest.grade.grade;
      } else {
        vm.generateGrade();
        vm.mpnRequest.range = vm.mpnRequest.grade.range;
      }

      for (var i = 0; i < vm.grades.length; i++) {
        times[vm.grades[i].grade] = parseInt(vm.grades[i].lead_time) + 14;
      }

      var newDate = new Date(Date.now() + times[vm.mpnRequest.emp_grade] * 24 * 60 * 60 * 1000);
      vm.mpnRequest.expected_join_date = newDate;
      vm.hide_grade();
    }

    vm.resetQualification = function () {
      if (vm.mpnRequest.qualification_type === 'Fresh Graduated') {
        vm.mpnRequest.year_experience = null;
        vm.mpnRequest.age_min = null;
        vm.mpnRequest.age_max = null;
      }
    }

    vm.hide_grade = function () {
      if (vm.mpnRequest !== null && vm.mpnRequest.emp_grade !== undefined && vm.mpnRequest.emp_grade !== null) {
        var grade = vm.mpnRequest.emp_grade;
        if (grade.length > 1) {
          return parseInt(grade.charAt(0)) <= 1
        }
      }
      return false;
    }

    vm.querySearch = function (query, index) {
      if (query !== null && query !== "" && (query + "").length >= 3) {

        var promise = MPN.query({
          action: "getemployee",
          company: vm.company,
          divisi: vm.mpnRequest.division_id,
          department: vm.mpnRequest.department_id,
          replacement_type: vm.mpnRequest.mpn_replacement[index].replacement_type,
          query: query
        });

        return promise.$promise.then(function (data) {
          return data;
        });

        return promise.$promise.catch(function (err) {
          return [];
        });

      }
      return [];
    }

    function getEmployee() {
      var promise = MPN.query({
        action: "getemployee",
        company: vm.company,
        divisi: 'all',
        department: 'all'
      });
      promise.$promise.then(function (data) {
        vm.listEmployee = data;
      });
      promise.$promise.catch(function (err) {
        vm.listEmployee = [];
      });
    }

    function getProfile() {

      var promise = MPN.get({
        action: "getprofile",
        company: vm.company
      });

      promise.$promise.then(function (data) {
        vm.grades = {};
        vm.employee_info = {};
        vm.grade_category = [];

        vm.employee_info = data.employee_info;
        vm.grades = [];//data.grades;
        vm.grade_category = data.grade_category;

        vm.mpnRequest.division_id = data.employee_info.division_id;
        vm.mpnRequest.department_id = data.employee_info.department_id;
        vm.mpnRequest.work_location = data.employee_info.sub_area_id;

        if (data.employee_info !== null && data.employee_info.department_id !== null) {
          vm.loadBu(data.employee_info.department_id);
        }

      });
      promise.$promise.catch(function (err) {

      });
    }

    getProfile();

    vm.loadBu = loadBu;
    function loadBu(department) {

      vm.mpnRequest.business_title = null;
      vm.listBu = [];
      vm.listBu.push({
        id: 0,
        description: "OTHER"
      });

      var promise = MPN.get({
        action: "getbusinesstitle",
        company: vm.company,
        divisi: vm.mpnRequest.division_id,
        department: department,
        bu_only: true
      });
      promise.$promise.then(function (data) {

        vm.listBu = [];
        vm.listBu = data.business_title;
        vm.listBu.push({
          id: 0,
          description: "OTHER"
        });
      });
      promise.$promise.catch(function (err) {
        vm.listBu = [];
      });
    }

    vm.loadDept = loadDept;
    function loadDept() {

      vm.mpnRequest.business_title = null;
      vm.mpnRequest.department_id = null;

      vm.listDepartment = [];
      var promise = MPN.get({
        action: "getbusinesstitle",
        company: vm.company,
        divisi: vm.mpnRequest.division_id,
        department: '00',
        dept_only: true
      });
      promise.$promise.then(function (data) {
        vm.listDepartment = [];
        vm.listDepartment = data.department;
      });
      promise.$promise.catch(function (err) {
        vm.listDepartment = [];
      });
    }

    function getBusinessTitle() {

      var promise = MPN.get({
        action: "getbusinesstitle",
        company: vm.company,
        divisi: 'all',
        department: 'all'
      });
      promise.$promise.then(function (data) {
        vm.mpnRequest.mpn_new_position = {};

        //vm.listBu = data.business_title;

        vm.listDepartment = []
        if (angular.isArray(data.department)) {
          vm.listDepartment = data.department;
        } else {
          vm.listDepartment.push({
            id: data.employee_info.department_id,
            description: data.employee_info.department
          });
        }


        vm.listDivision = []
        vm.listDivision.push({
          id: data.employee_info.division_id,
          description: data.employee_info.division
        });

        if (vm.listBu === undefined || vm.listBu === null) {
          vm.listBu = [];
          vm.listBu.push({
            id: 0,
            description: "OTHER"
          });
        }

        vm.mpnRequest.division_id = data.employee_info.division_id;
        vm.mpnRequest.department_id = data.employee_info.department_id;

      });
      promise.$promise.catch(function (err) {
        vm.listBu = [];
        vm.listDepartment = []
        vm.listDivision = []
      });
    }


    function getJobTitles() {
      var promise = MPN.query({
        action: "getjobtitle",
        company: vm.company,
        divisi: 'all',
        department: 'all'
      });
      promise.$promise.then(function (data) {
        vm.listJobTitle = data;
      });
      promise.$promise.catch(function (err) {
        vm.listJobTitle = [];
      });
    }

    function getJobCodes() {
      var promise = MPN.query({
        action: "getjobcodes",
        status: 1
      });
      promise.$promise.then(function (data) {
        data.splice(0, 0, {
          id: 0,
          description: "OTHER"
        });

        vm.listJobCodes = data;
      });
      promise.$promise.catch(function (err) {
        vm.listJobCodes = [];
      });
    }

    function getWorkLocations() {
      var promise = MPN.query({ action: "getworklocations", status: 1, bu: vm.mpnRequest.bu });
      promise.$promise.then(function (data) {
        vm.listLocations = data;
      });
      promise.$promise.catch(function (err) {
        vm.listLocations = [];
      });
    }

    function loadDataDepartment(iddivisi) {
      var response = MPN.query({
        action: "getdepartments",
        bu: vm.company,
        iddivisi: iddivisi
      });
      response.$promise.then(function (data) {
        vm.listDepartment = data;
      });
      response.$promise.catch(function (data) {
        vm.listDepartment = [];
      });
    }

    function loadDataDivision() {
      var response = MPN.query({
        action: "getdivisions",
        bu: vm.company
      });
      response.$promise.then(function (data) {
        vm.listDivision = data;
      });
      response.$promise.catch(function (data) {
        vm.listDivision = [];
      });
    }

    function loadCompetency(business_title_id) {
      if (business_title_id < 1) {
        vm.mpnRequest.job_code = 0;
        vm.mpnRequest.mpn_new_jobcode.job_desc = "";
        vm.mpnRequest.mpn_new_jobcode.job_func = "";
        vm.mpnRequest.is_need_approval_grade = true;
        return;
      }
      var response = MPN.get({
        action: "getcompetencies",
        business_title_id: business_title_id
      });

      response.$promise.then(function (data) {

        vm.mpnRequest.job_code = data.job_code.id;
        vm.mpnRequest.job_code_text = data.job_code.code + " - " + data.job_code.description;

        var arrData = data.competency;
        vm.mpnRequest.mpn_new_jobcode.job_func = "";
        angular.forEach(arrData, function (value, key) {
          vm.mpnRequest.mpn_new_jobcode.job_func +=
            "<b>" +
            value.competency +
            "</b><br>" +
            value.description +
            "<br><br>";
        });

        arrData = [];

        arrData = data.responsibilities;

        if (arrData[0] === undefined) {
          arrData[0] = {
            job_desc: "",
            area: "",
            area_description: ""
          }
        }
        vm.mpnRequest.mpn_new_jobcode.job_desc = "";
        vm.mpnRequest.mpn_new_jobcode.job_desc = arrData[0].job_desc + "<br><br>" + "<b>RESPONSIBILITIES INCLUDE</b><br>"

        angular.forEach(arrData, function (value, key) {
          vm.mpnRequest.mpn_new_jobcode.job_desc +=
            "<b>" +
            value.area +
            "</b><br>" +
            value.area_description +
            "<br><br>";
        });

        arrData = [];

        var obj = $filter('filter')(vm.listBu, function (d) { return d.id == business_title_id; })[0];

        vm.mpnRequest.emp_grade = obj.grade;
        vm.mpnRequest.is_need_approval_grade = false;
      });

      response.$promise.catch(function (data) {
        vm.mpnRequest.mpn_new_jobcode.job_desc = "";
        vm.mpnRequest.mpn_new_jobcode.job_func = "";

        var obj = $filter('filter')(vm.listBu, function (d) { return d.id == business_title_id; })[0];
        vm.mpnRequest.emp_grade = obj.grade;
        vm.mpnRequest.is_need_approval_grade = true;
      });
    }

    vm.setPosition = function (e, i) {
      var emp = $filter('filter')(vm.listEmployee, { nik: e })[0];
      if (emp !== null) {
        vm.mpnRequest.mpn_replacement[i].positionID = emp.positionID;
      }
    }

    function saveData(event) {
      angular.element.blockUI();
      var promise = Auth.setToken();
      promise.then(function () {
        console.log(vm.mpnRequest);

        vm.mpnRequest.action = "save";

        var response = MPN.save("save", vm.mpnRequest);

        angular.element.unblockUI();
        response.$promise.then(function (params) {
          console.log(params);

          MPNService.save(vm.mpnRequest);
          if (params.status == 'failed') {
            alert(params.pesan);
          }
          else {
            alert(params.pesan);
            vm.mpnRequest.id = params.id;
            $state.go("app.mpn_request_view", { id: params.id });
          }
        });

        response.$promise.catch(function () {
          angular.element.unblockUI();
        });
      });

      promise.catch(function () {
        angular.element.unblockUI();
      });
    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }

    vm.resetGrade = resetGrade;

    function resetGrade() {
      vm.mpnRequest.emp_grade = "";
      vm.mpnRequest.grade = null;
      vm.current_grade = null;
      vm.is_grade_visible = false;
      vm.mpnRequest.is_need_approval_grade = false;
      vm.mpnRequest.sector = null;
    };

    vm.getGrade = getGrade;
    function getGrade() {
      vm.grades = [];
      vm.grades = vm.mpnRequest.grade_category.rules;

      if (vm.mpnRequest.business_title == "0") {
        switch (vm.mpnRequest.grade_category.description) {
          case "Staff":
            vm.gradesx = 3;
            break;

          case "Foreman":
            vm.gradesx = 3;
            break;

          case "Supervisor / Specialist / Asst. Manager":
            vm.gradesx = 4;
            break;

          case "Manager":
            vm.gradesx = 5;
            break;

          case "General Manager":
            vm.gradesx = 6;
            break;
        }

        vm.mpnRequest.emp_grade = vm.gradesx;
        vm.mpnRequest.is_need_approval_grade = true;
      }
    }

    vm.generateGrade = generateGrade;

    function generateGrade(showLabel) {
      if (parseInt(vm.mpnRequest.grade_category.value_type) === 0) {
        return;
      }

      if (parseInt(vm.mpnRequest.is_manufacturing) === 1) {

        if (parseInt(vm.mpnRequest.is_production) === 1 &&
          vm.mpnRequest.sector !== undefined && vm.mpnRequest.sector !== null) {

          var exp_grade = getGradeSize(vm.mpnRequest.grade.grade);
          var sec_grade = getGradeSize(vm.mpnRequest.sector.grade);

          if (exp_grade < sec_grade) {
            vm.current_grade = vm.mpnRequest.grade.grade;
          } else if (sec_grade < exp_grade) {
            vm.current_grade = vm.mpnRequest.sector.grade;
          } else {
            vm.current_grade = vm.mpnRequest.grade.grade;
          }
        } else {
          vm.current_grade = vm.mpnRequest.grade.grade;
        }
      } else {
        vm.current_grade = vm.mpnRequest.grade.grade;
      }

      if ((parseInt(vm.mpnRequest.is_manufacturing) === 0 || vm.mpnRequest.is_manufacturing === false) && vm.mpnRequest.grade !== null && (vm.mpnRequest.grade.grade === '5B' || vm.mpnRequest.grade.grade === '5C')) {
        vm.mpnRequest.is_need_approval_grade = true;
      } else if ((parseInt(vm.mpnRequest.is_manufacturing) === 1 || vm.mpnRequest.is_manufacturing === true)) {
        if (parseInt(vm.mpnRequest.is_production) === 0 || vm.mpnRequest.is_production === false && (vm.mpnRequest.grade.grade === '5B' || vm.mpnRequest.grade.grade === '5C')) {
          vm.mpnRequest.is_need_approval_grade = true;
        } else {
          vm.mpnRequest.is_need_approval_grade = false;
        }
      } else {
        vm.mpnRequest.is_need_approval_grade = false;
      }

      vm.is_grade_visible = true;
      vm.mpnRequest.emp_grade = vm.current_grade;
      vm.mpnRequest.is_need_approval_grade = true;
    }

    vm.allow_edit_division = allow_edit_division;
    function allow_edit_division() {
      if (vm.employee_info === undefined) {
        return true;
      }
      if (vm.employee_info.approval_info === undefined) {
        return true;
      }

      if (vm.employee_info.approval_info.group === 'CEO') {
        return false;
      }

      return vm.employee_info.department !== 'Talent Acquisition' ||
        vm.employee_info.approval_info.group !== 'Talent Acquisition Manager'

    }

    function getGradeSize(str) {
      var out = 0, len = str.length;
      if (!isNaN(str.charAt(0))) {
        out += (str.charCodeAt(1) - 64) * Math.pow(26, 2 - 1 - 1);
        out = str.charAt(0) + out;
      } else {
        for (pos = 0; pos < len; pos++) {
          out += (str.charCodeAt(pos) - 64) * Math.pow(26, len - pos - 1);
        }
      }
      return out;
    }

    activated();

    function activated() {
      getBusinessTitle();
      getJobTitles();
      // getWorkLocations();
      getJobCodes();
      loadDataDivision();
      getEmployee();
      vm.grades = [];
    }

    function getBu() {
      var promise = OfbRefCheck.query({
        action: "getBuMpn"
      });
      promise.$promise.then(function (data) {
        vm.bu = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.bu = [];
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.mpn.request")
    .controller("EditrequestController", EditrequestController);

  EditrequestController.$inject = [
    "$localStorage",
    "$stateParams",
    "$timeout",
    "$mdDialog",
    "$state",
    "$filter",
    "$http",
    "MPNService",
    "Form",
    "AppAPI",
    "Auth"
  ];
  /** @ngInject */
  function EditrequestController(
    $localStorage,
    $stateParams,
    $timeout,
    $mdDialog,
    $state,
    $filter,
    $http,
    MPNService,
    Form,
    AppAPI,
    Auth
  ) {
    var vm = this;

    vm.mpnRequest = {};
    vm.isDisableBt = false;
    if ($localStorage.empsite == "EN") {
      vm.isDisableBt = true;
      vm.mpnRequest.budget_type = "Unbudgeted";
    }
    vm.Form = Form;

    var MPN = AppAPI.Mpn();

    var OfbRefCheck = AppAPI.OfbRefCheck();

    getBu();

    vm.mpnRequest.mpn_new_jobcode = {};

    vm.loadDataDepartment = loadDataDepartment;

    vm.loadDataDivision = loadDataDivision;

    vm.loadCompetency = loadCompetency;

    vm.company = $localStorage.empsite;

    vm.saveData = saveData;

    vm.clearMeesage = clearMeesage;

    vm.grades = [];

    vm.getWorkLocations = getWorkLocations;

    vm.educations = [
      "SMP",
      "SMA Sederajat",
      "SMA",
      "SMK",
      "D1",
      "D2",
      "D3",
      "D4",
      "S1",
      "S2",
      "S3",
      "SMU",
      "D-3",
      "Diploma",
      "SD",
      "SLTP",
      "STM",
      "SMAN",
      "Paket C",
      "MA",
      "MAN",
      "Madrasah",
      "LPK"
    ];

    vm.EmploymentStatus = ["Contract", "Permanent"];

    vm.tinymceOptions = {
      inline: false,
      plugins: 'advlist autolink link image lists charmap print preview',
      toolbar: 'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
      menubar: false
    };

    vm.groupedGrades = vm.grades.reduce(function (previous, current) {
      if (previous.indexOf(current.group) === -1) {
        previous.push(current.group);
      }

      return previous;
    }, []);

    vm.adjustJoinDate = function () {
      var times = {};
      if (vm.mpnRequest.grade === undefined || vm.mpnRequest.grade === null) {
        vm.mpnRequest.grade = vm.mpnRequest.grade_category.rules[0];
      }
      if (!vm.mpnRequest.grade_category.is_need_experience) {
        vm.mpnRequest.emp_grade = vm.mpnRequest.grade.grade;
      } else {
        vm.generateGrade(false);
        vm.mpnRequest.range = vm.mpnRequest.grade.range;
      }

      for (var i = 0; i < vm.grades.length; i++) {
        times[vm.grades[i].grade] = parseInt(vm.grades[i].lead_time) + 14;
      }

      // var newDate = new Date(Date.now() + times[vm.mpnRequest.emp_grade] * 24 * 60 * 60 * 1000);
      // vm.mpnRequest.expected_join_date = 
      vm.mpnRequest.expected_join_date = new Date(vm.mpnRequest.expected_join_date);;
      vm.hide_grade();
    }

    vm.hide_grade = hide_grade;
    function hide_grade() {
      if (vm.mpnRequest !== null && vm.mpnRequest.emp_grade !== undefined && vm.mpnRequest.emp_grade !== null) {
        var grade = vm.mpnRequest.emp_grade;
        return parseInt(grade.charAt(0)) < 3 || parseInt(vm.mpnRequest.quantity_replacement) <= 0
      }
      return false;
    }

    vm.querySearch = function (query, index) {
      if (query !== null && query !== "" && (query + "").length >= 3) {

        var promise = MPN.query({
          action: "getemployee",
          company: vm.company,
          divisi: vm.mpnRequest.division_id,
          department: vm.mpnRequest.department_id,
          replacement_type: vm.mpnRequest.mpn_replacement[index].replacement_type,
          query: query
        });

        return promise.$promise.then(function (data) {
          return data;
        });

        return promise.$promise.catch(function (err) {
          return [];
        });

      }
      return [];
    }

    function getEmployee() {
      var promise = MPN.query({
        action: "getemployee",
        company: vm.company,
        divisi: 'all',
        department: 'all'
      });
      promise.$promise.then(function (data) {
        vm.listEmployee = data;
      });
      promise.$promise.catch(function (err) {
        vm.listEmployee = [];
      });
    }

    function getProfile() {

      var promise = MPN.get({
        action: "getprofile",
        company: vm.company
      });

      promise.$promise.then(function (data) {
        vm.grades = {};
        vm.employee_info = {};
        vm.employee_info = data.employee_info;
        vm.grades = [];//data.grades;

        setData();

        if (vm.mpnRequest.id === null) {
          vm.mpnRequest.division_id = data.employee_info.division_id;
          vm.mpnRequest.department_id = data.employee_info.department_id;
        }

      });
      promise.$promise.catch(function (err) {

      });
    }

    vm.loadBu = loadBu;
    function loadBu(department) {

      vm.listBu = [];

      var promise = MPN.get({
        action: "getbusinesstitle",
        company: vm.company,
        divisi: 'all',
        department: department,
        bu_only: true
      });
      promise.$promise.then(function (data) {

        vm.listBu = [];
        vm.listBu = data.business_title;
        vm.listBu.push({
          id: 0,
          description: "OTHER"
        });

        setData();
      });
      promise.$promise.catch(function (err) {
        vm.listBu = [];
      });
    }

    vm.loadDept = loadDept;
    function loadDept() {

      vm.mpnRequest.business_title = null;
      vm.mpnRequest.department_id = null;

      vm.listDepartment = [];
      var promise = MPN.get({
        action: "getbusinesstitle",
        company: vm.company,
        divisi: vm.mpnRequest.division_id,
        department: '00',
        dept_only: true
      });
      promise.$promise.then(function (data) {
        vm.listDepartment = [];
        vm.listDepartment = data.department;
      });
      promise.$promise.catch(function (err) {
        vm.listDepartment = [];
      });
    }

    function getBusinessTitle() {
      var promise = MPN.get({
        action: "getbusinesstitle",
        company: vm.company,
        divisi: 'all',
        department: 'all'
      });
      promise.$promise.then(function (data) {
        vm.mpnRequest.mpn_new_position = {};

        vm.listBu = data.business_title;
        vm.listDepartment = []
        if (angular.isArray(data.department)) {
          vm.listDepartment = data.department;
        } else {
          vm.listDepartment.push({
            id: data.employee_info.department_id,
            description: data.employee_info.department
          });
        }

        vm.listDivision = []
        vm.listDivision.push({
          id: data.employee_info.division_id,
          description: data.employee_info.division
        });

        vm.listBu.push({
          id: 0,
          description: "OTHER"
        });

        if (vm.mpnRequest.id === null) {
          vm.mpnRequest.division_id = data.employee_info.division_id;
          vm.mpnRequest.department_id = data.employee_info.department_id;
        }

      });
      promise.$promise.catch(function (err) {
        vm.listBu = [];
        vm.listDepartment = []
        vm.listDivision = []
      });
    }

    function getJobTitles() {
      var promise = MPN.query({
        action: "getjobtitle",
        company: vm.company,
        divisi: 'all',
        department: 'all'
      });
      promise.$promise.then(function (data) {
        vm.listJobTitle = data;
      });
      promise.$promise.catch(function (err) {
        vm.listJobTitle = [];
      });
    }

    function getJobCodes() {
      var promise = MPN.query({
        action: "getjobcodes",
        status: 1
      });
      promise.$promise.then(function (data) {
        data.splice(0, 0, {
          id: 0,
          description: "OTHER"
        });

        vm.listJobCodes = data;
      });
      promise.$promise.catch(function (err) {
        vm.listJobCodes = [];
      });
    }

    function getWorkLocations() {
      var promise = MPN.query({ action: "getworklocations", status: 1, bu: vm.mpnRequest.bu });
      promise.$promise.then(function (data) {
        vm.listLocations = data;
      });
      promise.$promise.catch(function (err) {
        vm.listLocations = [];
      });
    }

    function loadDataDepartment(iddivisi) {
      var response = MPN.query({
        action: "getdepartments",
        bu: vm.company,
        iddivisi: iddivisi
      });
      response.$promise.then(function (data) {
        vm.listDepartment = data;
      });
      response.$promise.catch(function (data) {
        vm.listDepartment = [];
      });
    }

    function loadDataDivision() {
      var response = MPN.query({
        action: "getdivisions",
        bu: vm.company
      });
      response.$promise.then(function (data) {
        vm.listDivision = data;
      });
      response.$promise.catch(function (data) {
        vm.listDivision = [];
      });
    }

    function loadCompetency(business_title_id) {
      if (business_title_id < 1) {
        vm.mpnRequest.job_code = 0;
        vm.mpnRequest.is_need_approval_grade = true;
        return;
      }
      var response = MPN.get({
        action: "getcompetencies",
        business_title_id: business_title_id
      });
      response.$promise.then(function (data) {
        vm.mpnRequest.job_code = data.job_code.id;
        vm.mpnRequest.job_code_text = data.job_code.code + " - " + data.job_code.description;

        var arrData = data.competency;
        vm.mpnRequest.mpn_new_jobcode.job_func = "";
        angular.forEach(arrData, function (value, key) {
          vm.mpnRequest.mpn_new_jobcode.job_func +=
            "<b>" +
            value.competency +
            "</b><br>" +
            value.description +
            "<br><br>";
        });

        arrData = [];

        arrData = data.responsibilities;

        if (arrData[0] === undefined) {
          arrData[0] = {
            job_desc: "",
            area: "",
            area_description: ""
          }
        }

        vm.mpnRequest.mpn_new_jobcode.job_desc = "";
        if (arrData[0].job_desc === undefined || arrData[0].job_desc === null || arrData[0].job_desc === "") {
        } else {
          vm.mpnRequest.mpn_new_jobcode.job_desc = arrData[0].job_desc + "<br><br>" + "<b>RESPONSIBILITIES INCLUDE</b><br>"
        }

        angular.forEach(arrData, function (value, key) {
          vm.mpnRequest.mpn_new_jobcode.job_desc +=
            "<b>" +
            value.area +
            "</b><br>" +
            value.area_description +
            "<br><br>";
        });

        arrData = [];

        var obj = $filter('filter')(vm.listBu, function (d) { return d.id == business_title_id; })[0];

        vm.mpnRequest.emp_grade = obj.grade;
        vm.mpnRequest.is_need_approval_grade = false;
      });
      response.$promise.catch(function (data) {
        vm.mpnRequest.mpn_new_jobcode.job_desc = "";
        vm.mpnRequest.mpn_new_jobcode.job_func = "";

      });
    }

    vm.setPosition = setPosition;
    function setPosition(e, i) {
      var emp = $filter('filter')(vm.listEmployee, { nik: e })[0];
      if (emp !== null) {
        vm.mpnRequest.mpn_replacement[i].positionID = emp.positionID;
      }
    }

    function saveData(event) {
      angular.element.blockUI();
      var promise = Auth.setToken();
      promise.then(function () {

        vm.mpnRequest.action = "save";

        var response = MPN.save("save", vm.mpnRequest);

        angular.element.unblockUI();
        response.$promise.then(function (params) {

          if (params.id !== null) {
            vm.mpnRequest.id = params.id;

            MPNService.save(vm.mpnRequest);

            $state.go("app.mpn_request_view", { id: params.id });
          }

        });

        response.$promise.catch(function () {
          angular.element.unblockUI();
        });
      });

      promise.catch(function () {
        angular.element.unblockUI();
      });
    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }

    function loadData() {
      angular.element.blockUI();
      var response = MPN.get({
        action: "viewdetail",
        id: $stateParams.id
      });
      response.$promise.then(function (data) {

        if (data.mpn_mpn != null) {
          data.mpn_mpn.expected_join_date = new Date(data.mpn_mpn.expected_join_date);
          vm.mpnRequest = data.mpn_mpn;
          vm.mpnRequest.quantity_replacement = parseInt(vm.mpnRequest.quantity_replacement);
          vm.mpnRequest.quantity_new_position = parseInt(vm.mpnRequest.quantity_new_position);
          vm.mpnRequest.age_min = parseInt(vm.mpnRequest.age_min);
          vm.mpnRequest.age_max = parseInt(vm.mpnRequest.age_max);
        }
        if (parseInt(vm.mpnRequest.business_title) > 0) {
          vm.mpnRequest.mpn_new_jobcode = {};
          loadCompetency(vm.mpnRequest.business_title);
        } else {
          vm.mpnRequest.mpn_new_jobcode = {};
          vm.mpnRequest.mpn_new_jobcode.job_desc = vm.mpnRequest.job_desc;
          vm.mpnRequest.mpn_new_jobcode.job_func = vm.mpnRequest.job_func;
        }

        vm.loadBu(vm.mpnRequest.department_id);

        if (angular.isArray(data.mpn_new_position)) {
          vm.mpnRequest.mpn_new_position = data.mpn_new_position[0];
        }

        if (angular.isArray(data.mpn_replacement)) {

          angular.forEach(data.mpn_replacement, function (value, key) {
            value.effective_date = new Date(value.effective_date);
          });

          vm.mpnRequest.mpn_replacement = data.mpn_replacement;
        }

        vm.grade_category = [];
        vm.grade_category = data.grade_category;
        vm.mpnRequest.bu = vm.mpnRequest.company_id;
        getWorkLocations();

        vm.mpnRequest.is_manufacturing = Boolean(Number(vm.mpnRequest.is_manufacturing));
        vm.mpnRequest.is_production = Boolean(Number(vm.mpnRequest.is_production));

        angular.forEach(vm.grade_category, function (value, key) {

          if (value.id === vm.mpnRequest.grade_category) {
            vm.mpnRequest.grade_category = value;
            vm.grades = [];
            vm.grades = vm.mpnRequest.grade_category.rules;
          }

          if (value.rules !== undefined && value.rules !== null) {
            angular.forEach(value.rules, function (s, k) {

              if (parseInt(vm.mpnRequest.grade_category.value_type) === 0) {
                if (vm.mpnRequest.emp_grade === s.grade) {
                  vm.mpnRequest.grade = s;
                }
              } else {
                if (s.range === vm.mpnRequest.exp) {
                  vm.mpnRequest.grade = s;
                } else if (s.grade === vm.mpnRequest.exp) {
                  vm.mpnRequest.grade = s;
                } else if (s.grade === vm.mpnRequest.emp_grade) {
                  vm.mpnRequest.grade = s;
                }
              }

            });
          }

          if (value.sectors !== undefined && value.sectors !== null) {

            angular.forEach(value.sectors, function (s, k) {

              if (s.grade === vm.mpnRequest.sector) {
                vm.mpnRequest.sector = s;
              }
            });

          }
        });

        if (vm.mpnRequest.grade === undefined) {
          vm.mpnRequest.grade = {};
        }

        vm.adjustJoinDate();

        angular.element.unblockUI();

      });

    }

    vm.resetGrade = resetGrade;

    function resetGrade() {
      vm.mpnRequest.emp_grade = "";
      vm.mpnRequest.grade = null;
      vm.current_grade = null;
      vm.is_grade_visible = false;
      vm.mpnRequest.is_need_approval_grade = false;
      vm.mpnRequest.sector = null;
    };

    vm.getGrade = getGrade;
    function getGrade() {

      vm.is_grade_visible = false;
      if ((parseInt(vm.mpnRequest.is_production) === 0 || vm.mpnRequest.is_production === false)
        && vm.mpnRequest.grade !== null && (vm.mpnRequest.grade.grade === '5B' || vm.mpnRequest.grade.grade === '5C')) {
        vm.mpnRequest.is_need_approval_grade = true;
      } else {
        vm.mpnRequest.is_need_approval_grade = false;
      }
      vm.grades = [];
      vm.grades = vm.mpnRequest.grade_category.rules;
      vm.mpnRequest.grade = vm.grades[0];


      if (vm.mpnRequest.business_title == "0") {
        switch (vm.mpnRequest.grade_category.description) {
          case "Staff":
            vm.gradesx = 3;
            break;

          case "Foreman":
            vm.gradesx = 3;
            break;

          case "Supervisor / Specialist / Asst. Manager":
            vm.gradesx = 4;
            break;

          case "Manager":
            vm.gradesx = 5;
            break;

          case "General Manager":
            vm.gradesx = 6;
            break;
        }

        vm.mpnRequest.emp_grade = vm.gradesx;
        vm.mpnRequest.is_need_approval_grade = true;
      }
    }

    vm.generateGrade = generateGrade;
    function generateGrade(showLabel) {
      vm.is_grade_visible = false;
      if (vm.mpnRequest.grade === undefined || vm.mpnRequest.grade === null) {
        return;
      }

      if (parseInt(vm.mpnRequest.grade_category.value_type) === 0) {
        return;
      }

      if (parseInt(vm.mpnRequest.is_manufacturing) === 1) {

        if (parseInt(vm.mpnRequest.is_production) === 1 &&
          vm.mpnRequest.sector !== undefined && vm.mpnRequest.sector !== null) {

          var exp_grade = getGradeSize(vm.mpnRequest.grade.grade);
          var sec_grade = getGradeSize(vm.mpnRequest.sector.grade);

          if (exp_grade < sec_grade) {
            vm.current_grade = vm.mpnRequest.grade.grade;
          } else if (sec_grade < exp_grade) {
            vm.current_grade = vm.mpnRequest.sector.grade;
          } else {
            vm.current_grade = vm.mpnRequest.grade.grade;
          }
        } else {
          vm.current_grade = vm.mpnRequest.grade.grade;
        }
      } else {
        vm.current_grade = vm.mpnRequest.grade.grade;
      }

      if ((parseInt(vm.mpnRequest.is_manufacturing) === 0 || vm.mpnRequest.is_manufacturing === false) && vm.mpnRequest.grade !== null && (vm.mpnRequest.grade.grade === '5B' || vm.mpnRequest.grade.grade === '5C')) {
        vm.mpnRequest.is_need_approval_grade = true;
      } else if ((parseInt(vm.mpnRequest.is_manufacturing) === 1 || vm.mpnRequest.is_manufacturing === true)) {
        if (parseInt(vm.mpnRequest.is_production) === 0 || vm.mpnRequest.is_production === false && (vm.mpnRequest.grade.grade === '5B' || vm.mpnRequest.grade.grade === '5C')) {
          vm.mpnRequest.is_need_approval_grade = true;
        } else {
          vm.mpnRequest.is_need_approval_grade = false;
        }
      } else {
        vm.mpnRequest.is_need_approval_grade = false;
      }

      vm.is_grade_visible = showLabel;
      vm.mpnRequest.emp_grade = vm.current_grade;
    }

    vm.allow_edit_division = allow_edit_division;
    function allow_edit_division() {
      if (vm.employee_info === undefined) {
        return true;
      }
      if (vm.employee_info.approval_info === undefined) {
        return true;
      }

      return vm.employee_info.department !== 'Talent Acquisition' ||
        vm.employee_info.approval_info.group !== 'Talent Acquisition Manager'

    }

    function getGradeSize(str) {
      var out = 0, len = str.length;
      if (!isNaN(str.charAt(0))) {
        out += (str.charCodeAt(1) - 64) * Math.pow(26, 2 - 1 - 1);
        out = str.charAt(0) + out;
      } else {
        for (pos = 0; pos < len; pos++) {
          out += (str.charCodeAt(pos) - 64) * Math.pow(26, len - pos - 1);
        }
      }
      return out;
    }

    function setData() {

    }

    getProfile();

    loadData();

    activated();

    function activated() {
      getBusinessTitle();
      getJobTitles();
      // getWorkLocations();
      getJobCodes();
      loadDataDivision();
      getEmployee();
      setData();
    }

    function getBu() {
      var promise = OfbRefCheck.query({
        action: "getBuMpn"
      });
      promise.$promise.then(function (data) {
        vm.bu = data;
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.bu = [];
      });
    }
  }
})();

(function () {
    "use strict";

    angular.module("app.mpn.approval", []).config(config);

    config.$inject = ["$translatePartialLoaderProvider", "$stateProvider"];
    /** @ngInject */
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        // Translation
        // $translatePartialLoaderProvider.addPart("app/main/mpn/approval");

        // State
        $stateProvider
            .state("app.mpn.approval", {
                url: "/mpn/approval",
                views: {
                    "content@app": {
                        templateUrl: "app/main/mpn/approval/views/index.html",
                        controller: "ApprovalController as vm"
                    }
                }
            }).state("app.mpn.request_view", {
                url: "/mpn/approval/view-request/:id",
                views: {
                    "content@app": {
                        templateUrl: "app/main/mpn/approval/views/detail.html",
                        controller: "ViewApprovalRequestController as vm"
                    }
                }
            });
    }
})();

(function () {
  'use strict';

  angular
    .module('app.mpn.approval')
    .controller('RequestResetSLTController', RequestResetSLTController);

  function RequestResetSLTController(
    $mdDialog,
    mpn,
    Auth,
    AppAPI,
    Form
  ) {

    var vm = this;
    var endpoint = new AppAPI.MpnResetSLT();
    Form.initialForm();
    Form.setObject(endpoint);
    vm.Form = Form;
    vm.mpn = mpn;
    vm.submit = submit;
    vm.closeModal = closeModal;


    console.log(vm.mpn);

    function closeModal() {
      $mdDialog.cancel();
    }

    function submit(formController) {
      angular.element.blockUI(); //munculin loading please wait
      vm.Form.objForm.mpn = vm.mpn;
      var promiseAuth = Auth.setToken();

      promiseAuth.then(function () {


        var response = Form.saveData('save', formController, endpoint);

        response.then(function () {
          vm.messageTheme = 'blue';
          angular.element.unblockUI();
          formController.$setPristine();

          $timeout(function () {
            vm.Form.tampilPesan = false;
          }, 3000);

        });

        response.catch(function () {
          vm.messageTheme = 'pink';
          angular.element.unblockUI();
        });


      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.mpn.request')
        .controller('RejectResetSLTController', RejectResetSLTController);

    function RejectResetSLTController(
        $mdDialog,
        mpn,
        app,
        Auth,
        AppAPI
    ) {

        var vm = this;
        var endpoint = new AppAPI.MpnResetSLT();
        vm.mpn = mpn;
        vm.approval = app;
        vm.submit = submit;
        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.cancel();
        }

        function submit(status) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                var response = endpoint.save({
                    action: 'rejectReset',
                    app: vm.approval,
                    notes: vm.notes,
                    status: status
                });

                response.$promise.then(closeModal());
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.approval")
        .controller("VacancyController", VacancyController);

    VacancyController.$inject = ["$mdDialog", "item"];
    /** @ngInject */
    function VacancyController($mdDialog, item) {
        var vm = this;
        vm.item = item;
        vm.vacancy_date = formatDate(item.vacancy_closed);

        function formatDate(date) {
            if (date === null) {
                return null;
            }
            return new Date(date)
        }

        vm.closeDialog = function (answer) {
            if (answer === 1) {
                var result = {
                    submit: true,
                    id: item.PK,
                    type: item.reason,
                    field: 'vacancy_closed',
                    mpn_mpn_id: item.mpn_mpn_id,
                    vacancy_closed: vm.vacancy_date
                }

                item.vacancy_closed = formatDate(vm.vacancy_date);
            } else {
                var result = {
                    submit: false
                }
            }
            $mdDialog.hide(result);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.approval")
        .controller("TaController", TaController);

    TaController.$inject = ["$mdDialog", "item"];
    /** @ngInject */
    function TaController($mdDialog, item) {
        var vm = this;
        vm.item = item;
        vm.ta_status = item.ta_status;

        vm.closeDialog = function (answer) {
            if (answer === 1) {
                var result = {
                    submit: true,
                    id: item.PK,
                    type: item.reason,
                    field: 'ta_status',
                    mpn_mpn_id: item.mpn_mpn_id,
                    ta_status: vm.ta_status
                }
                item.ta_status = vm.ta_status;
            } else {
                var result = {
                    submit: false
                }
            }
            $mdDialog.hide(result);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.approval")
        .controller("MpnStatusController", MpnStatusController);

    MpnStatusController.$inject = ["$mdDialog", "item"];
    /** @ngInject */
    function MpnStatusController($mdDialog, item) {
        var vm = this;
        vm.item = item;
        vm.mpn_status = item.mpn_status;

        vm.closeDialog = function (answer) {
            if (answer === 1) {
                var result = {
                    submit: true,
                    type: item.reason,
                    id: item.PK,
                    field: 'mpn_status',
                    mpn_mpn_id: item.mpn_mpn_id,
                    mpn_status: vm.mpn_status
                }
                item.mpn_status = vm.mpn_status;
            } else {
                var result = {
                    submit: false
                }
            }
            $mdDialog.hide(result);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.approval")
        .controller("DelegateTAController", DelegateTAController);

    DelegateTAController.$inject = ["$mdDialog", "$element", "items", "current_approval", "obj"];
    /** @ngInject */
    function DelegateTAController($mdDialog, $element, items, current_approval, obj) {
        var vm = this;
        vm.items = items;
        vm.current_approval = current_approval;

        vm.searchTerm;
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        vm.closeDialog = closeDialog;

        function closeDialog(answer) {
            if (answer === 1) {
                vm.current_approval.id = obj.id;
                vm.current_approval.app_type = "Delegate";
                vm.current_approval.notes = "This MPN was delegated from " + obj.app_nik + " - " + obj.approver + " to " + vm.current_approval.app_nik_delegate
            }
            $mdDialog.hide(answer);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.approval")
        .controller("BudgetTypeController", BudgetTypeController);

    BudgetTypeController.$inject = ["$mdDialog", "item", "current", "change"];
    /** @ngInject */
    function BudgetTypeController($mdDialog, item, current, change) {
        var vm = this;
        vm.Budgeted = "Budgeted";
        vm.Unbudgeted = "Unbudgeted";

        vm.item = item;
        vm.budget_type = item.budget_type;
        vm.current_budget_type = change ? (vm.item.budget_type == vm.Budgeted ? vm.Unbudgeted : vm.Budgeted) : vm.item.budget_type;
        vm.change = change;

        vm.message = "Would you like to update current budget type from " + vm.item.budget_type + " to " + vm.current_budget_type + "?";

        if (!change) {
            vm.message = "Would you like to commit and approve current budget type ( " + vm.item.budget_type + " ) for this MPN?";
        }

        vm.closeDialog = closeDialog;

        function closeDialog(answer) {
            if (answer === 1) {
                var result = {
                    submit: true,
                    type: "MPN",
                    id: vm.item.id,
                    pk: current.id,
                    field: 'budget_type',
                    mpn_mpn_id: vm.item.mpn_mpn_id,
                    budget_type: vm.current_budget_type,
                    created_by: vm.item.created_by,
                    business_title: vm.item.business_title,
                    is_need_approval_grade: vm.item.is_need_approval_grade,
                    reset_approval: vm.change,
                    emp_grade: vm.item.emp_grade
                }
                vm.item.budget_type = vm.current_budget_type;
            } else {
                var result = {
                    submit: false
                }
            }
            $mdDialog.hide(result);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.approval")
        .controller("ApprovalVerifikatorController", ApprovalVerifikatorController);

    ApprovalVerifikatorController.$inject = ["AppAPI", "$mdDialog", "request", "$element"];
    /** @ngInject */
    function ApprovalVerifikatorController(AppAPI, $mdDialog, request, $element) {
        var vm = this;
        var Request = AppAPI.Mpn();

        vm.listDataNdcBusinessTitle = [];
        vm.request = request;
        vm.closeDialog = closeDialog;
        vm.getNdcBusinessTitle = getNdcBusinessTitle;
        vm.searchBT = '';
        getNdcBusinessTitle();

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function closeDialog(answer) {
            vm.request = vm.request;
            $mdDialog.hide(answer);
        }

        function getNdcBusinessTitle() {
            var search = null;

            if (vm.searchBT.length > 3) {
                search = vm.searchBT;
            }

            if (search || vm.request.business_title) {
                var response = Request.query({
                    action: 'getNdcBusinessTitle',
                    search: search,
                    id: vm.request.business_title
                });

                response.$promise.then(function (data) {
                    vm.listDataNdcBusinessTitle = data;
                });
                response.$promise.catch(function () {
                    vm.listDataNdcBusinessTitle = [];
                });
            }

        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.approval")
        .controller("ApprovalTAController", ApprovalTAController);

    ApprovalTAController.$inject = ["AppAPI", "$mdDialog", "current_approval","grade"];
    /** @ngInject */
    function ApprovalTAController(AppAPI, $mdDialog, current_approval, grade) {
        var vm = this;
        var Request = AppAPI.MpnApproval();

        console.log(grade);

        vm.listPic = [];
        vm.current_approval = current_approval;
        vm.closeDialog = closeDialog;
        vm.grade = grade;

        getPIC();

        function closeDialog(answer) {
            vm.current_approval = vm.current_approval;
            $mdDialog.hide(answer);
        }

        function getPIC() {
            
            console.log(vm.grade);

            var hrbp = false;
            if (vm.grade === null || vm.grade === "") {
                hrbp = false;
            }

            if (vm.grade.charAt(0) < 3) {
                hrbp = true;
            }

            var response = Request.query({ 
                action: 'getpic', 
                add_hrbp: hrbp
            });
            
            response.$promise.then(function (data) {
                vm.listPic = data;
            });
            response.$promise.catch(function () {
                vm.listPic = [];
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.approval")
        .controller("ViewApprovalRequestController", ViewApprovalRequestController);

    ViewApprovalRequestController.$inject = [
        "$state",
        "$stateParams",
        "$mdDialog",
        "$window",
        "$location",
        "config",
        "AppAPI",
        "Auth"
    ];
    /** @ngInject */
    function ViewApprovalRequestController(
        $state,
        $stateParams,
        $mdDialog,
        $window,
        $location,
        config,
        AppAPI,
        Auth
    ) {
        var vm = this;
        vm.request = {};
        vm.current_approval = {};
        vm.current_approval.is_budget_type = "0";
        vm.mpn_approval = [];
        vm.replacement = [];
        vm.resetSLT = resetSLT;

        // Data
        var Request = AppAPI.MpnApproval();
        var RequestResetSlt = AppAPI.MpnResetSLT();

        // Methods
        getDelegations();
        viewDataRequest();

        vm.editRequest = function () {
            $state.go("app.mpn_request_edit", {
                id: $stateParams.id
            });
        }

        vm.isHRBP = isHRBP;

        function isHRBP() {
            return vm.current_approval.group === 'HR. Business Partner' &&
                vm.request.emp_grade.charAt(0) < 3;
        }

        vm.canApproveBudgetType = canApproveBudgetType;

        function canApproveBudgetType() {
            if (vm.current_approval === undefined) {
                return false;
            }
            if (vm.next_approval === undefined) {
                return false;
            }
            var a = ((vm.current_approval.is_budget_type === '1' && vm.current_approval.app_type === 'Waiting Approval' && (vm.next_approval.app_type === 'Waiting Approval' || vm.next_approval.app_type === 'None')));
            var b = ((vm.isHRBP() && vm.current_approval.app_type === 'Waiting Approval' && (vm.next_approval.app_type === 'Waiting Approval' || vm.next_approval.app_type === 'None')));

            // if (a) {
            //     return a;
            // }
            // if (b) {
            //     return b;
            // }
            return true;
        }

        vm.showPrompt = showPrompt;

        function showPrompt(app_type, ev, obj) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = null;

            if (app_type === 'Approved') {
                confirm = $mdDialog.confirm()
                    .title('Would you like to approval this request?')
                    .textContent('This operation cannot be undone, make sure your data is correct.')
                    .targetEvent(ev)
                    .ok('SUBMIT')
                    .cancel('CANCEL');

                if (vm.current_approval.group === 'Talent Acquisition Manager') {
                    var grade = vm.request.emp_grade;
                    confirm = null;
                    confirm = {
                        targetEvent: ev,
                        template: '<md-dialog aria-label="List dialog">' +
                            '  <md-dialog-content><h1>Would you like to approved this request?</h1>' +
                            '<h3>This operation cannot be undone, make sure your data is correct</h3>' +
                            '<div layout="row" layout-align="start center">' +
                            '<md-select style="width:100%" class="md-block" ng-model="vm.current_approval.nik_pic" name="nik_pic" placeholder="Select PIC">' +
                            '<md-option>NONE</md-option>' +
                            '<md-option ng-repeat="d in vm.listPic" value="{{d.nik}}">{{ d.description }}</md-option>' +
                            '</md-select></div>' +
                            '</md-dialog-content>' +
                            '  <md-dialog-actions>' +
                            '    <md-button ng-click="vm.closeDialog(0)" class="md-primary">' +
                            '      CANCEL' +
                            '    </md-button>' +
                            '    <md-button ng-click="vm.closeDialog(1)" class="md-primary">' +
                            '      SUBMIT' +
                            '    </md-button>' +
                            '  </md-dialog-actions>' +
                            '</md-dialog>',
                        locals: {
                            current_approval: vm.current_approval,
                            grade: grade
                        },
                        controller: 'ApprovalTAController',
                        controllerAs: 'vm'
                    };
                }

                if (vm.current_approval.approval_type === 'verificator') {
                    var grade = vm.request.emp_grade;
                    confirm = null;
                    confirm = {
                        targetEvent: ev,
                        template: '<md-dialog aria-label="List dialog">' +
                            '<md-dialog-content><h1>Would you like to approved this request?</h1>' +
                            '<h3>This operation cannot be undone, make sure your data is correct</h3>' +
                            '<div layout="row" layout-align="start center">' +
                            '<md-select style="width:100%" class="md-block" ng-model="vm.request.business_title_update" name="business_title" placeholder="Select Business Title">' +
                            '<md-select-header class="demo-select-header">' +
                            '<input ng-model="vm.searchBT" type="search" placeholder="Search for a Business Title.." class="demo-header-searchbox md-text" ng-keyup="vm.getNdcBusinessTitle(vm.searchBT)">' +
                            '</md-select-header>' +
                            '<md-option>NONE</md-option>' +
                            '<md-option ng-repeat="d in vm.listDataNdcBusinessTitle" value="{{d.id}}">{{ d.description }}</md-option>' +
                            '</md-select></div>' +
                            '<div layout="row" layout-align="start center">' +
                            '<md-radio-group ng-model="vm.request.budget_type_update">' +
                            '<md-radio-button value="Budgeted" class="md-primary">Budgeted</md-radio-button>' +
                            '<md-radio-button value="Unbudgeted">Un Budgeted</md-radio-button>' +
                            '</md-radio-group>' +
                            '</div>' +
                            '</md-dialog-content>' +
                            '<md-dialog-actions>' +
                            '<md-button ng-click="vm.closeDialog(0)" class="md-primary">' +
                            'CANCEL' +
                            '</md-button>' +
                            '<md-button ng-click="vm.closeDialog(1)" class="md-primary">' +
                            'SUBMIT' +
                            '</md-button>' +
                            '</md-dialog-actions>' +
                            '</md-dialog>',
                        locals: {
                            request: vm.request
                        },
                        controller: 'ApprovalVerifikatorController',
                        controllerAs: 'vm'
                    };
                }

            } else if (app_type === 'Revision' || app_type === 'Rejected') {

                var content = "Rejection will automatically rejecting the MPN form and it’s quantity.<br>" +
                    "Once MPN got rejected requestor have to re - create MPN all over again.<br></br>" +
                    "<b>Are you sure want to continue to reject ?</b><br>please write reasons why this mpn will be rejected"

                if (app_type === 'Revision') {
                    content = 'This operation cannot be undone, make sure your data is correct.<br><br>' +
                        "<b>You have to write the reason why this MPN need to be revised</b>"
                }

                confirm = $mdDialog.prompt()
                    .title('Confirmation')
                    .htmlContent(content)
                    .placeholder('Notes')
                    .ariaLabel('Notes')
                    .targetEvent(ev)
                    .ok('SUBMIT')
                    .cancel('CANCEL');
            } else if (app_type === 'Delegate') {
                confirm = {
                    targetEvent: ev,
                    template: '<md-dialog aria-label="List dialog">' +
                        ' <md-dialog-content><h1>Would you like to delegate this request?</h1><br>' +
                        '<h3>Please select employee to assign this task</h3>' +
                        '<div layout="row" layout-align="start center">' +
                        '<md-input-container style="width:100%">' +
                        '<label>Delegate To {{vm.current_approval.app_nik_delegate}} </label>' +
                        '<md-select ng-model="vm.current_approval.app_nik_delegate"' +
                        '        md-on-close="vm.clearSearchTerm()"' +
                        '        data-md-container-class="selectdemoSelectHeader">' +
                        '<md-select-header class="demo-select-header">' +
                        '<input ng-model="vm.searchTerm" type="search" placeholder="Search Employee.." class="demo-header-searchbox md-text">' +
                        '</md-select-header>' +
                        '<md-optgroup label="Employee">' +
                        '<md-option>NONE</md-option>' +
                        '<md-option ng-value="{{d.nik}}" ng-repeat="d in vm.items | filter:vm.searchTerm">{{d.description}}</md-option>' +
                        '</md-optgroup>' +
                        '</md-select>' +
                        '</md-input-container>' +
                        '</div>' +

                        '</md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="vm.closeDialog(0)" class="md-primary">' +
                        '      CANCEL' +
                        '    </md-button>' +
                        '    <md-button ng-click="vm.closeDialog(1)" class="md-primary">' +
                        '      SAVE' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                    locals: {
                        items: vm.listDelegation,
                        current_approval: vm.current_approval,
                        obj: obj
                    },
                    controller: 'DelegateTAController',
                    controllerAs: 'vm'
                };

            } else if (app_type === 'Budgeting') {
                confirm = {
                    targetEvent: ev,
                    template: '<md-dialog aria-label="List dialog">' +
                        '<md-dialog-content>' +
                        '<h3><md-icon md-font-icon="icon-help-circle" class="blue-500-fg"></md-icon> {{vm.message}}</h3>' +
                        '<h5><md-icon md-font-icon="icon-alert-circle" class="red-500-fg"></md-icon> Please make sure you have chosen the right action!</h5>' +
                        '</md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="vm.closeDialog(0)" class="md-primary">' +
                        '      CANCEL' +
                        '    </md-button>' +
                        '    <md-button ng-click="vm.closeDialog(1)" class="md-primary">' +
                        '      SAVE' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                    locals: {
                        item: vm.request,
                        current: vm.current_approval,
                        change: obj
                    },
                    controller: 'BudgetTypeController',
                    controllerAs: 'vm'
                };
            }

            $mdDialog.show(confirm).then(function (result) {
                if (result !== undefined && result === 0) {
                    return;
                }

                angular.element.blockUI();
                var promise = Auth.setToken();
                promise.then(function () {

                    vm.current_approval.app_type = app_type;
                    vm.current_approval.notes = (app_type === 'Delegate') ? vm.current_approval.notes : result;
                    vm.current_approval.mpnRequestorUpdate = vm.request;
                    vm.current_approval.app_date = new Date();
                    vm.current_approval.send_to = vm.send_to;
                    vm.current_approval.created_by = vm.request.created_by;
                    vm.current_approval.company_id = vm.request.company_id;
                    vm.current_approval.business_title = vm.request.business_title;
                    vm.current_approval.work_location = vm.request.work_location;
                    vm.current_approval.budget_type = vm.request.budget_type;

                    var response = Request.approvalstatus(vm.current_approval);

                    angular.element.unblockUI();
                    response.$promise.then(function (params) {
                        if (params.id !== null) {
                            viewDataRequest();
                        }
                    });

                    response.$promise.catch(function () {
                        angular.element.unblockUI();
                    });
                });

                promise.catch(function () {
                    angular.element.unblockUI();
                });


            }, function () {
                angular.element.unblockUI();
            });

        };

        vm.cancel = function cancel() {
            $mdDialog.cancel();
        }

        vm.formatDate = function (date) {
            if (date === null) {
                return "";
            }
            return new Date(date)
        }
        //////////

        function viewDataRequest() {
            vm.total = 0;

            angular.element.blockUI();
            var RequestPromise = Request.get({
                action: "viewdetail",
                id: $stateParams.id,
                type: "view"
            });
            RequestPromise.$promise.then(fetchDataRequest);
            RequestPromise.$promise.catch(errorFetchRequest);
        }

        function fetchDataRequest(data) {
            if (angular.isArray(data.mpn_mpn)) {
                vm.request = data.mpn_mpn[0];
                vm.request.budget_type_update = data.mpn_mpn[0].budget_type;
                vm.request.business_title_update = data.mpn_mpn[0].business_title;
            } else {
                vm.request = data.mpn_mpn;
                vm.request.budget_type_update = data.mpn_mpn.budget_type;
                vm.request.business_title_update = data.mpn_mpn.business_title;
            }

            vm.request.quantity_replacement = parseInt(vm.request.quantity_replacement);
            vm.request.quantity_new_position = parseInt(vm.request.quantity_new_position);


            vm.mpn_approval = data.mpn_approval;

            vm.current_approval = data.current_approval;

            vm.mpn_approval_history = data.mpn_approval_history;

            vm.replacement = data.mpn_replacement;

            vm.next_approval = data.next_approval;

            vm.total_lead_time = data.total_lead_time;

            vm.mpn_reset_slt = data.mpn_reset_slt;
            vm.is_allow_to_reset = data.is_allow_to_reset;

            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.request = [];
            angular.element.unblockUI();
        }

        function getDelegations() {
            var response = Request.query({
                action: 'getdelegations'
            });
            response.$promise.then(function (data) {
                vm.listDelegation = data;
            });
            response.$promise.catch(function () {
                vm.listDelegation = [];
            });
        }

        vm.Pdf = Pdf;

        function Pdf() {
            var token = Auth.setTokenPromise();

            token.then(function (data) {

                var protocol = $location.protocol();
                var host = $location.host();
                var port = $location.port();

                var json = JSON.stringify({
                    t: data.token,
                    i: vm.request.id,
                });

                $window.open(protocol + '://' + host + ':' + port + config.api + 'api/mpnapproval/pdf?filter=' + json, '_blank');

            }, function () {
                $window.alert('gagal load token')
            });
        }

        function resetSLT(data, ev) {
            $mdDialog.show({
                controller: 'RequestResetSLTController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpn/approval/request.resetslt.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewDataRequest();
                    vm.newComment = "";
                },
                locals: {
                    mpn: data
                }
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.approval")
        .controller("ViewApprovalModalRequestController", ViewApprovalModalRequestController);

    ViewApprovalModalRequestController.$inject = [
        "$state",
        "$stateParams",
        "$scope",
        "$mdDialog",
        "MPNService",
        "AppAPI",
        "Auth"
    ];
    /** @ngInject */
    function ViewApprovalModalRequestController(
        $state,
        $stateParams,
        $scope,
        $mdDialog,
        MPNService,
        AppAPI,
        Auth
    ) {
        var vm = this;
        vm.request = {};
        vm.current_approval = {};
        vm.mpn_approval = [];
        vm.replacement = [];

        // Data
        var Request = AppAPI.MpnApproval();

        vm.publishRequest = function () {

            var confirm = $mdDialog.confirm()
                .title('Would you like to approval this request?')
                .textContent('This operation cannot be undone, make sure your data is correct.')
                .ariaLabel('publish dialog')
                .ok('YES')
                .cancel('no');

            $mdDialog.show(confirm).then(function () {

                angular.element.blockUI();
                var promise = Auth.setToken();
                promise.then(function () {

                    vm.current_approval.app_date = new Date();

                    var response = Request.approvalstatus(vm.current_approval);

                    angular.element.unblockUI();
                    response.$promise.then(function (params) {
                        if (params.id !== null) {

                        }
                    });

                    response.$promise.catch(function () {
                        angular.element.unblockUI();
                    });
                });

                promise.catch(function () {
                    angular.element.unblockUI();
                });


            }, function () {
            });
        }

        vm.cancel = function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.approval")
        .controller("ApprovalController", ApprovalController);

    ApprovalController.$inject = [
        "$state",
        "$mdDialog",
        "$location",
        "$window",
        "$element",
        "$localStorage",
        "DTColumnDefBuilder",
        "AppAPI",
        "Auth",
        "DataService",
        'config'
    ];
    /** @ngInject */
    function ApprovalController(
        $state,
        $mdDialog,
        $location,
        $window,
        $element,
        $localStorage,
        DTColumnDefBuilder,
        AppAPI,
        Auth,
        DataService,
        config
    ) {
        var vm = this;
        vm.site = $localStorage.empsite;
        vm.nik = $localStorage.user;

        //vm.site='KS';
        vm.defaultval = '0';
        vm.defaulttext = 'All';
        if (vm.site === 'PM') {
            vm.defaultval = 'PM';
            vm.defaulttext = 'PMA';
        }
        vm.listRequest = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listRequestSelected = [];
        vm.editData = editData;
        vm.viewDetail = viewDetail;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.getBusinessTitle = getBusinessTitle;
        vm.load_mpn_number = load_mpn_number;
        vm.all_mpn=false;


        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.grades = [
            "1A",
            "1B",
            "1C",
            "2A",
            "2B",
            "2C",
            "3A",
            "3B",
            "3C",
            "4A",
            "4B",
            "4C",
            "5A",
            "5B",
            "5C",
            "6A",
            "6B",
            "6C"
        ];

        // Data
        var Request = AppAPI.MpnApproval();

        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: "full_numbers"
        };

        vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(1).notSortable()];

        getProfile();
        loadDataBU();
        getWorkLocations();
        getBusinessTitle();
        getPIC();


        vm.searchMpnNumber;
        vm.clearMpnSearch = function () {
            vm.searchMpnNumber = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function load_mpn_number() {

            // if (vm.is_pic) {
            //     vm.mpn_status = 'Approved';
            // }

            vm.mpn_numbers = [];
            var promise = Request.query({
                action: "getprofile",
                type: "mpn_number",
                status: vm.mpn_status
            });

            promise.$promise.then(function (data) {
                vm.mpn_numbers = data;
            });
            promise.$promise.catch(function (err) {
                vm.mpn_numbers = {};
            });
        }

        function getBusinessTitle() {

            vm.business_titles = [];
            var promise = Request.get({
                action: "getprofile",
                type: "business_title"
            });

            promise.$promise.then(function (data) {
                vm.business_titles = data.business_title;
            });
            promise.$promise.catch(function (err) {
                vm.business_titles = {};
            });
        }

        function getProfile() {

            var promise = Request.get({
                action: "getprofile",
                company: vm.company
            });

            promise.$promise.then(function (data) {
                vm.employee_info = {};
                vm.is_pic = false;
                vm.employee_info = data.employee_info;
                vm.is_pic = data.is_pic;

                vm.load_mpn_number();
            });
            promise.$promise.catch(function (err) {
                vm.employee_info = {};
                vm.is_pic = false;
            });
        }

        function getPIC() {

            var response = Request.query({
                action: 'getpic',
                add_hrbp: true
            });

            response.$promise.then(function (data) {
                vm.pic_list = data;
            });
            response.$promise.catch(function () {
                vm.pic_list = [];
            });
        }

        function loadData(pageno) {
            // if (vm.is_pic) {
            //     vm.mpn_status = 'Approved';
            // }
            vm.DataTable.loadData(Request, pageno, {
                action: 'viewdata',
                bu: vm.bu,
                divisi: vm.divisi,
                department: vm.department,
                emp_grade: vm.emp_grade,
                work_location: vm.work_location,
                created_by: vm.created_by,
                mpn_status: vm.mpn_status,
                mpn_number: vm.mpn_number,
                ta_mpn_status: vm.ta_mpn_status,
                ta_status: vm.ta_status,
                business_title: vm.business_title,
                nik_pic: vm.pic,
                reason: vm.reason,
                all_mpn: vm.all_mpn
            });
            angular.element.unblockUI();
        }

        function loadDataBU() {
            var response = Request.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBu = data;
        }

        function errorFetchBU() {
            vm.listBu = [];
            angular.element.unblockUI();
        }

        function loadDataDivision(idbu) {

            vm.divisi = '';
            vm.department = '';
            var response = Request.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivisi = data;
            vm.listDepartment = [];
            loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivisi = [];
            angular.element.unblockUI();
        }

        function loadDataDepartment(iddivisi) {
            vm.department = '';
            var response = Request.query({
                action: 'viewDivisiDept',
                idbu: vm.bu,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listRequestSelected = angular.copy(vm.listRequest);
        }

        function unCheckAll() {
            vm.listRequestSelected = [];
        }

        function editData(id) {
            $state.go("app.mpn_request_edit", {
                id: id
            });
        }

        function viewDetail(id) {
            $state.go("app.mpn.request_view", {
                id: id
            });
        }

        function getWorkLocations() {
            var promise = Request.query({
                action: "getworklocations",
                status: 1
            });
            promise.$promise.then(function (data) {
                vm.listLocation = data;
            });
            promise.$promise.catch(function (err) {
                vm.listLocation = [];
            });
        }

        vm.showPrompt = function (field, obj, ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = null;

            if (field === 'MPN_STATUS') {
                confirm = {
                    targetEvent: ev,
                    template: '<md-dialog aria-label="List dialog">' +
                        '  <md-dialog-content><h1>Would you like to update this mpn status?</h1><br>' +
                        '<div layout="row" layout-align="start center"><md-select style="width:100%" class="md-block" ng-model="vm.mpn_status" name="mpn_status" required placeholder="Set MPN Status">' +
                        '<md-option value="OPEN">OPEN</md-option>' +
                        '<md-option value="CLOSED">CLOSED</md-option>' +
                        '<md-option value="HOLD">HOLD</md-option>' +
                        '<md-option value="CANCEL">CANCEL</md-option>' +
                        '<md-option value="INTERNAL">INTERNAL</md-option>' +
                        '</md-select></div>' +
                        '</md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="vm.closeDialog(0)" class="md-primary">' +
                        '      CANCEL' +
                        '    </md-button>' +
                        '    <md-button ng-click="vm.closeDialog(1)" class="md-primary">' +
                        '      SAVE' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                    locals: {
                        item: obj
                    },
                    controller: 'MpnStatusController',
                    controllerAs: 'vm'
                };
            } else if (field === 'TA_STATUS') {
                confirm = {
                    targetEvent: ev,
                    template: '<md-dialog aria-label="List dialog">' +
                        '  <md-dialog-content><h1>Would you like to update this mpn status?</h1><br>' +
                        '<div layout="row" layout-align="start center"><md-select style="width:100%" class="md-block" ng-model="vm.ta_status" name="ta_status" required placeholder="Set TA Status">' +
                        '<md-option value="SOURCING">SOURCING</md-option>' +
                        '<md-option value="INTERVIEW">INTERVIEW</md-option>' +
                        '<md-option value="OFFERING">OFFERING</md-option>' +
                        '<md-option value="MEDICAL CHECK">MEDICAL CHECK</md-option>' +
                        '<md-option value="ONBOARDING">ONBOARDING</md-option>' +
                        '</md-select></div>' +
                        '</md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="vm.closeDialog(0)" class="md-primary">' +
                        '      CANCEL' +
                        '    </md-button>' +
                        '    <md-button ng-click="vm.closeDialog(1)" class="md-primary">' +
                        '      SAVE' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                    locals: {
                        item: obj
                    },
                    controller: 'TaController',
                    controllerAs: 'vm'
                };
            } else if (field === 'VACANCY_DATE') {
                confirm = {
                    targetEvent: ev,
                    template: '<md-dialog aria-label="List dialog">' +
                        '  <md-dialog-content><h1>Would you like to update this mpn status?</h1><br>' +
                        '<div layout="row" layout-align="start center">' +
                        '<md-input-container class="md-block" flex="50">' +
                        '<label> Vacancy Closed Date</label>' +
                        '<md-datepicker md-hide-icons="calendar" name="vacancy_date" ng-model="vm.vacancy_date" required></md-datepicker>' +
                        '</md-input-container>' +
                        '</div>' +
                        '</md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="vm.closeDialog(0)" class="md-primary">' +
                        '      CANCEL' +
                        '    </md-button>' +
                        '    <md-button ng-click="vm.closeDialog(1)" class="md-primary">' +
                        '      SAVE' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                    locals: {
                        item: obj
                    },
                    controller: 'VacancyController',
                    controllerAs: 'vm'
                };
            } else if (field === 'CANCEL_MPN') {
                confirm = $mdDialog.confirm()
                    .title('Confirmation')
                    .textContent('Would you like to cancel this MPN?')
                    .ariaLabel('publish dialog')
                    .ok('YES')
                    .cancel('NO');
            }

            $mdDialog.show(confirm).then(function (result) {

                if (typeof (result) == typeof (true)) {
                    result = {
                        submit: true,
                        id: obj.PK,
                        type: obj.reason,
                        field: 'cancel_mpn',
                        mpn_mpn_id: obj.mpn_mpn_id
                    };
                }

                if (result !== undefined && result.submit === false) {
                    return;
                }

                angular.element.blockUI();
                var promise = Auth.setToken();
                promise.then(function () {

                    var response = Request.updatestatus(result);

                    angular.element.unblockUI();
                    response.$promise.then(function (params) {
                        if (params.id !== null) {

                        }
                    });

                    response.$promise.catch(function () {
                        angular.element.unblockUI();
                    });
                });

                promise.catch(function () {
                    angular.element.unblockUI();
                });

            }, function () {
                angular.element.unblockUI();
            });

        };

        vm.exportToExcel = function (ev) {
            var token = Auth.setTokenPromise();

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                var port = $location.port();

                var json = JSON.stringify({
                    bu: vm.bu,
                    divisi: vm.divisi,
                    department: vm.department,
                    emp_grade: vm.emp_grade,
                    work_location: vm.work_location,
                    created_by: vm.created_by,
                    mpn_status: vm.mpn_status,
                    mpn_number: vm.mpn_number,
                    ta_mpn_status: vm.ta_mpn_status,
                    ta_status: vm.ta_status,
                    business_title: vm.business_title,
                    nik_pic: vm.pic,
                    reason: vm.reason,
                    all_mpn:vm.all_mpn,
                    token: data.token
                });

                $window.open(protocol + '://' + host + ':' + port + config.api + 'api/mpnapproval/exportexcel?filter=' + json, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

    }
})();

(function () {
    "use strict";

    angular.module("app.mpn.adminpms", []).config(config);

    config.$inject = ["$translatePartialLoaderProvider", "$stateProvider"];
    /** @ngInject */
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        // Translation
        //$translatePartialLoaderProvider.addPart("app/main/mpn/approval");

        // State
        $stateProvider
            .state("app.mpn.adminpms", {
                url: "/mpn/adminpms",
                views: {
                    "content@app": {
                        templateUrl: "app/main/mpn/adminpms/views/index.html",
                        controller: "RequestMPNController as vm"
                    }
                }
            }).state("app.mpn.adminpms.edit", {
                url: "/mpn/adminpms/edit-request/:id",
                views: {
                    "content@app": {
                        templateUrl: "app/main/mpn/adminpms/views/form.html",
                        controller: "EditrequestMPNController as vm"
                    }
                }
            })
            .state("app.mpn.adminpms.view", {
                url: "/mpn/adminpms/view-request/:id",
                views: {
                    "content@app": {
                        templateUrl: "app/main/mpn/adminpms/views/detail.html",
                        controller: "ViewRequestMPNController as vm"
                    }
                }
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.adminpms")
        .controller("ViewRequestMPNController", RequestMPNController);

    RequestMPNController.$inject = [
        "$state",
        "$stateParams",
        "$mdDialog",
        "$window",
        "$location",
        "config",
        "MPNService",
        "AppAPI",
        "Auth"
    ];
    /** @ngInject */
    function RequestMPNController(
        $state,
        $stateParams,
        $mdDialog,
        $window,
        $location,
        config,
        MPNService,
        AppAPI,
        Auth
    ) {
        var vm = this;
        vm.request = {};
        vm.mpn_approval = [];

        vm.grades = ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C', '4A', '4B', '4C', '5A', '5B', '5C'];

        // Data
        var Request = AppAPI.MpnApproval();

        // Methods
        viewDataRequest();

        vm.parseInt = function (num) {
            return parseInt(num);
        }

        vm.editRequest = function () {
            $state.go("app.mpn_request_edit", {
                id: $stateParams.id
            });
        }

        vm.showPrompt = showPrompt;

        function showPrompt($event, field, edit) {
            var parentEl = angular.element(document.body);
            var confirm = null;

            if (field === 'BUSINESS_TITLE') {
                confirm = {
                    parent: parentEl,
                    targetEvent: $event,
                    template: '<md-dialog aria-label="List dialog">' +
                        '<md-dialog-content><h1>Would you like to update business title for this mpn?</h1><br>' +
                        '<div ng-if="vm.IsEdit" layout-align="start center">' +
                        '<div layout="row">' +
                        '<md-input-container class="md-block" style="width:100%">' +
                        '<label>Business Titles</label>' +
                        '<md-select ng-model="vm.business_title_id" md-on-close="vm.clearSearchTerm()">' +
                        // '<md-select-header class="demo-select-header">' +
                        // '<input ng-model="vm.searchTerm" type="search" placeholder="Search Business Title" class="demo-header-searchbox md-text">' +
                        // '</md-select-header>' +
                        '<md-optgroup label="Business Title">' +
                        '<md-option ng-value="{{bt.id}}" ng-repeat="bt in vm.listBu | filter:vm.searchTerm">{{bt.description}}</md-option>' +
                        '</md-optgroup>' +
                        '</md-select>' +
                        '</md-input-container>' +
                        '</div>' +
                        '</div>' +

                        '<div layout="row">' +
                        '<md-input-container class="md-block" style="width:100%">' +
                        '<label>Comment</label> ' +
                        '<textarea name="notes"  ng-model="vm.notes" md-maxlength="200" max-rows="5"></textarea>' +
                        '</md-input-container>' +
                        '</div>' +

                        '</md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="vm.closeDialog(0,vm.IsEdit)" class="md-primary">' +
                        '      CANCEL' +
                        '    </md-button>' +
                        '    <md-button ng-click="vm.closeDialog(1,vm.IsEdit)" class="md-primary">' +
                        '      SAVE' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                    locals: {
                        item: vm.request,
                        edit: edit,
                        field: field
                    },
                    controller: 'UpdateBusinessTitleController',
                    controllerAs: 'vm'
                };
            } else if (field === 'GRADE') {
                confirm = $mdDialog.prompt()
                    .title('Confirmation')
                    .textContent('Would you like to change this grade?')
                    .placeholder('Comment')
                    .ariaLabel('publish dialog')
                    .ok('YES')
                    .cancel('NO');
            }

            $mdDialog.show(confirm).then(function (result) {

                if (result !== undefined && result.submit === false && field !== 'GRADE') {
                    return;
                }

                var request = {};

                if (field === 'GRADE') {
                    request = {
                        submit: true,
                        type: "MPN",
                        id: vm.request.id,
                        field: 'emp_grade',
                        mpn_mpn_id: vm.request.mpn_mpn_id,
                        emp_grade: vm.request.emp_grade,
                        app_type: 'Approved',
                        notes: result
                    }
                } else {
                    request = result;
                }

                angular.element.blockUI();
                var promise = Auth.setToken();
                promise.then(function () {

                    var response = Request.updatestatus(request);

                    angular.element.unblockUI();
                    response.$promise.then(function (params) {
                        if (params.id !== null) {
                            viewDataRequest();
                        }
                    });

                    response.$promise.catch(function () {
                        angular.element.unblockUI();
                    });
                });

                promise.catch(function () {
                    angular.element.unblockUI();
                });

            }, function () {
                angular.element.unblockUI();
            });

        };

        vm.approvedRequest = approvedRequest;

        function approvedRequest() {

            var confirm = $mdDialog.prompt()
                .title('Would you like to save and approved this request?')
                .textContent('This operation cannot be undone, make sure your data is correct.')
                .placeholder('Comment')
                .ariaLabel('publish dialog')
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function (notes) {

                angular.element.blockUI();
                var promise = Auth.setToken();
                promise.then(function () {

                    var result = {
                        submit: true,
                        action_type: 'APPROVE',
                        type: "MPN",
                        id: vm.request.id,
                        mpn_mpn_id: vm.request.mpn_mpn_id,
                        notes: notes,
                        app_type: 'Approved'
                    }

                    var response = Request.updatestatus(result);
                    angular.element.unblockUI();
                    response.$promise.then(function (params) {
                        if (params.id !== null) {
                            viewDataRequest();
                        }
                    });

                    response.$promise.catch(function () {
                        angular.element.unblockUI();
                    });


                });

                promise.catch(function () {
                    angular.element.unblockUI();
                });


            }, function () {});


        }

        vm.formatDate = function (date) {
            if (date === null) {
                return "";
            }
            return new Date(date)
        }
        //////////

        function viewDataRequest() {
            angular.element.blockUI();
            var RequestPromise = Request.get({
                action: "viewdetail",
                id: $stateParams.id,
                type: "view"
            });
            RequestPromise.$promise.then(fetchDataRequest);
            RequestPromise.$promise.catch(errorFetchRequest);
        }

        function fetchDataRequest(data) {
            if (angular.isArray(data.mpn_mpn)) {
                vm.request = data.mpn_mpn[0];
            } else {
                vm.request = data.mpn_mpn;
            }

            vm.request.quantity_replacement = parseInt(vm.request.quantity_replacement);
            vm.request.quantity_new_position = parseInt(vm.request.quantity_new_position);

            vm.mpn_approval_history = data.mpn_approval_history;

            vm.mpn_approval = data.mpn_approval;

            vm.replacement = data.mpn_replacement;

            vm.current_approval = data.current_approval;
            vm.next_approval = data.next_approval;
            vm.total_lead_time = data.total_lead_time;

            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.request = [];
            angular.element.unblockUI();
        }

        vm.Pdf = Pdf;

        function Pdf() {
            var token = Auth.setTokenPromise();

            token.then(function (data) {

                var protocol = $location.protocol();
                var host = $location.host();
                var port = $location.port();

                var json = JSON.stringify({
                    t: data.token,
                    i: vm.request.id,
                });

                $window.open(protocol + '://' + host + ':' + port + config.api + 'api/mpnapproval/pdf?filter=' + json, '_blank');

            }, function () {
                $window.alert('gagal load token')
            });
        }
    }
})();

(function () {
  "use strict";

  angular
    .module("app.mpn.adminpms")
    .controller("EditrequestMPNController", EditrequestMPNController);

  EditrequestMPNController.$inject = [
    "$localStorage",
    "$stateParams",
    "$timeout",
    "$mdDialog",
    "$state",
    "$filter",
    "$http",
    "MPNService",
    "Form",
    "AppAPI",
    "Auth"
  ];
  /** @ngInject */
  function EditrequestMPNController(
    $localStorage,
    $stateParams,
    $timeout,
    $mdDialog,
    $state,
    $filter,
    $http,
    MPNService,
    Form,
    AppAPI,
    Auth
  ) {
    var vm = this;

    var vm = this;

    vm.mpnRequest = {};

    vm.Form = Form;

    var MPN = AppAPI.Mpn();

    vm.mpnRequest.mpn_new_jobcode = {};

    vm.loadDataDepartment = loadDataDepartment;

    vm.loadDataDivision = loadDataDivision;

    vm.loadCompetency = loadCompetency;

    vm.company = $localStorage.empsite;

    vm.saveData = saveData;

    vm.clearMeesage = clearMeesage;

    vm.grades = [
      { name: "1A", group: "Operator/Helper/Driver", time: 21 },
      { name: "1B", group: "Operator/Helper/Driver", time: 21 },
      { name: "1C", group: "Operator/Helper/Driver", time: 21 },
      { name: "2A", group: "QC Inspector/Teknisi/Fomulasi/Clerk", time: 35 },
      { name: "2B", group: "QC Inspector/Teknisi/Fomulasi/Clerk", time: 35 },
      { name: "2C", group: "QC Inspector/Teknisi/Fomulasi/Clerk", time: 35 },
      { name: "3A", group: "Admin/Staff/Foreman", time: 56 },
      { name: "3B", group: "Admin/Staff/Foreman", time: 56 },
      { name: "3C", group: "Admin/Staff/Foreman", time: 56 },
      { name: "4A", group: "Analyst/Supervisor/Specialist/Asst.Manager", time: 70 },
      { name: "4B", group: "Analyst/Supervisor/Specialist/Asst.Manager", time: 70 },
      { name: "4C", group: "Analyst/Supervisor/Specialist/Asst.Manager", time: 70 },
      { name: "5A", group: "Manager", time: 112 },
      { name: "5B", group: "Manager", time: 112 },
      { name: "5C", group: "Manager", time: 112 },
      { name: "6A", group: "General Manager", time: 112 },
      { name: "6B", group: "General Manager", time: 112 },
      { name: "6C", group: "General Manager", time: 112 },
    ];

    vm.educations = [
      "SMP",
      "SMA Sederajat",
      "SMA",
      "SMK",
      "D1",
      "D2",
      "D3",
      "D4",
      "S1",
      "S2",
      "S3",
      "SMU",
      "D-3",
      "Diploma",
      "SD",
      "SLTP",
      "STM",
      "SMAN",
      "Paket C",
      "MA",
      "MAN",
      "Madrasah",
      "LPK"
    ];

    vm.EmploymentStatus = ["Contract", "Permanent"];

    vm.tinymceOptions = {
      inline: false,
      plugins: 'advlist autolink link image lists charmap print preview',
      toolbar: 'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
      menubar: false
    };

    vm.groupedGrades = vm.grades.reduce(function (previous, current) {
      if (previous.indexOf(current.group) === -1) {
        previous.push(current.group);
      }

      return previous;
    }, []);

    vm.querySearch = function (query, index) {
      if (query !== null && query !== "" && (query + "").length >= 3) {

        var promise = MPN.query({
          action: "getemployee",
          company: vm.company,
          divisi: 'all',
          department: 'all',
          replacement_type: vm.mpnRequest.mpn_replacement[index].replacement_type,
          query: query
        });

        return promise.$promise.then(function (data) {
          return data;
        });

        return promise.$promise.catch(function (err) {
          return [];
        });

      }
      return [];
    }

    function getEmployee() {
      var promise = MPN.query({
        action: "getemployee",
        company: vm.company,
        divisi: 'all',
        department: 'all'
      });
      promise.$promise.then(function (data) {
        vm.listEmployee = data;
      });
      promise.$promise.catch(function (err) {
        vm.listEmployee = [];
      });
    }

    function getProfile() {

      var promise = MPN.get({
        action: "getprofile",
        company: vm.company
      });

      promise.$promise.then(function (data) {
        vm.grades = {};
        vm.employee_info = {};

        vm.employee_info = data.employee_info;
        vm.grades = data.grades;

        vm.mpnRequest.division_id = data.employee_info.division_id;
        vm.mpnRequest.department_id = data.employee_info.department_id;

      });
      promise.$promise.catch(function (err) {

      });
    }

    getProfile();

    function getBusinessTitle() {
      var promise = MPN.get({
        action: "getbusinesstitle",
        company: vm.company,
        divisi: 'all',
        department: 'all'
      });
      promise.$promise.then(function (data) {
        vm.mpnRequest.mpn_new_position = {};

        vm.listBu = data.business_title;
        vm.listDepartment = []
        vm.listDepartment.push({
          id: data.employee_info.department_id,
          description: data.employee_info.department
        });

        vm.listDivision = []
        vm.listDivision.push({
          id: data.employee_info.division_id,
          description: data.employee_info.division
        });

        vm.listBu.push({
          id: 0,
          description: "OTHER"
        });

        vm.mpnRequest.division_id = data.employee_info.division_id;
        vm.mpnRequest.department_id = data.employee_info.department_id;

      });
      promise.$promise.catch(function (err) {
        vm.listBu = [];
        vm.listDepartment = []
        vm.listDivision = []
      });
    }

    function getJobTitles() {
      var promise = MPN.query({
        action: "getjobtitle",
        company: vm.company,
        divisi: 'all',
        department: 'all'
      });
      promise.$promise.then(function (data) {
        vm.listJobTitle = data;
      });
      promise.$promise.catch(function (err) {
        vm.listJobTitle = [];
      });
    }

    function getJobCodes() {
      var promise = MPN.query({
        action: "getjobcodes",
        status: 1
      });
      promise.$promise.then(function (data) {
        data.splice(0, 0, {
          id: 0,
          description: "OTHER"
        });

        vm.listJobCodes = data;
      });
      promise.$promise.catch(function (err) {
        vm.listJobCodes = [];
      });
    }

    function getWorkLocations() {
      var promise = MPN.query({ action: "getworklocations", status: 1 });
      promise.$promise.then(function (data) {
        vm.listLocations = data;
      });
      promise.$promise.catch(function (err) {
        vm.listLocations = [];
      });
    }

    function loadDataDepartment(iddivisi) {
      var response = MPN.query({
        action: "getdepartments",
        bu: vm.company,
        iddivisi: iddivisi
      });
      response.$promise.then(function (data) {
        vm.listDepartment = data;
      });
      response.$promise.catch(function (data) {
        vm.listDepartment = [];
      });
    }

    function loadDataDivision() {
      var response = MPN.query({
        action: "getdivisions",
        bu: vm.company
      });
      response.$promise.then(function (data) {
        vm.listDivision = data;
      });
      response.$promise.catch(function (data) {
        vm.listDivision = [];
      });
    }

    function loadCompetency(business_title_id) {
      if (business_title_id < 1) {
        vm.mpnRequest.job_code = 0;
        return;
      }
      var response = MPN.get({
        action: "getcompetencies",
        business_title_id: business_title_id
      });
      response.$promise.then(function (data) {

        vm.mpnRequest.job_code = data.job_code.id;
        vm.mpnRequest.job_code_text = data.job_code.code + " - " + data.job_code.description;

        var arrData = data.competency;
        vm.mpnRequest.mpn_new_jobcode.job_func = "";
        angular.forEach(arrData, function (value, key) {
          vm.mpnRequest.mpn_new_jobcode.job_func +=
            "<b>" +
            value.competency +
            "</b><br>" +
            value.description +
            "<br><br>";
        });

        arrData = [];

        arrData = data.responsibilities;

        if (arrData[0] === undefined) {
          arrData[0] = {
            job_desc: "",
            area: "",
            area_description: ""
          }
        }
        vm.mpnRequest.mpn_new_jobcode.job_desc = "";
        vm.mpnRequest.mpn_new_jobcode.job_desc = arrData[0].job_desc + "<br><br>" + "<b>RESPONSIBILITIES INCLUDE</b><br>"

        angular.forEach(arrData, function (value, key) {
          vm.mpnRequest.mpn_new_jobcode.job_desc +=
            "<b>" +
            value.area +
            "</b><br>" +
            value.area_description +
            "<br><br>";
        });

        arrData = [];
      });
      response.$promise.catch(function (data) {
        vm.mpnRequest.mpn_new_jobcode.job_desc = "";
        vm.mpnRequest.mpn_new_jobcode.job_func = "";

      });
    }

    vm.setPosition = function (e, i) {
      var emp = $filter('filter')(vm.listEmployee, { nik: e })[0];
      if (emp !== null) {
        vm.mpnRequest.mpn_replacement[i].positionID = emp.positionID;
      }
    }

    function saveData(event) {
      angular.element.blockUI();
      var promise = Auth.setToken();
      promise.then(function () {

        vm.mpnRequest.action = "save";

        var response = MPN.save("save", vm.mpnRequest);

        angular.element.unblockUI();
        response.$promise.then(function (params) {

          if (params.id !== null) {
            vm.mpnRequest.id = params.id;

            MPNService.save(vm.mpnRequest);

            $state.go("app.mpn_request_view", { id: params.id });
          }

        });

        response.$promise.catch(function () {
          angular.element.unblockUI();
        });
      });

      promise.catch(function () {
        angular.element.unblockUI();
      });
    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }

    function loadData() {
      angular.element.blockUI();
      var response = MPN.get({
        action: "viewdetail",
        id: $stateParams.id
      });
      response.$promise.then(function (data) {

        if (data.mpn_mpn != null) {
          data.mpn_mpn.expected_join_date = new Date(data.mpn_mpn.expected_join_date);
          vm.mpnRequest = data.mpn_mpn;
          vm.mpnRequest.quantity_replacement = parseInt(vm.mpnRequest.quantity_replacement);
          vm.mpnRequest.quantity_new_position = parseInt(vm.mpnRequest.quantity_new_position);
        }

        if (vm.mpnRequest.job_code > 0) {
          vm.mpnRequest.mpn_new_jobcode = {};
          loadCompetency(vm.mpnRequest.job_code);
        } else {
          vm.mpnRequest.mpn_new_jobcode = {};
          vm.mpnRequest.mpn_new_jobcode.job_desc = vm.mpnRequest.job_desc;
          vm.mpnRequest.mpn_new_jobcode.job_func = vm.mpnRequest.job_func;
        }

        if (angular.isArray(data.mpn_new_position)) {
          vm.mpnRequest.mpn_new_position = data.mpn_new_position[0];
        }

        if (angular.isArray(data.mpn_replacement)) {

          angular.forEach(data.mpn_replacement, function (value, key) {
            value.effective_date = new Date(value.effective_date);
          });

          vm.mpnRequest.mpn_replacement = data.mpn_replacement;
        }
        angular.element.unblockUI();

      });

    }

    loadData();

    activated();

    function activated() {
      getBusinessTitle();
      getJobTitles();
      getWorkLocations();
      getJobCodes();
      loadDataDivision();
      loadDataDepartment(1); //TODO: Change Division
      getEmployee();
    }
  }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.adminpms")
        .controller("RequestMPNController", RequestMPNController);

    RequestMPNController.$inject = [
        "$state",
        "$scope",
        "DTColumnDefBuilder",
        "AppAPI"
    ];
    /** @ngInject */
    function RequestMPNController(
        $state,
        $scope,
        DTColumnDefBuilder,
        AppAPI
    ) {
        var vm = this;
        vm.listRequest = [];

        vm.editData = editData;
        vm.viewDetail = viewDetail;

        // Data
        /*  vm.employees = Employees.data;*/
        var Request = AppAPI.MpnApproval();

        viewDataRequest();

        vm.dtOptions = {
            dom:
                '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: "full_numbers"
        };

        vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(1).notSortable()];

        // Data

        // Methods

        //////////

        function viewDataRequest() {
            angular.element.blockUI();
            var RequestPromise = Request.query({ action: "viewdatapms" });
            RequestPromise.$promise.then(fetchDataRequest);
            RequestPromise.$promise.catch(errorFetchRequest);
        }

        function fetchDataRequest(data) {
            vm.listRequest = data;
            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.listRequest = [];
            angular.element.unblockUI();
        }

        function editData(id) {
            $state.go("app.mpn.adminpms.edit", { id: id });
        }

        function viewDetail(id) {
            $state.go("app.mpn.adminpms.view", { id: id });
        }

        $scope.parseInt = function (num) {
            return parseInt(num);
        }

    }
})();
(function () {
    "use strict";

    angular
        .module("app.mpn.adminpms")
        .controller("UpdateBusinessTitleController", UpdateBusinessTitleController);

    UpdateBusinessTitleController.$inject = ["AppAPI", "$mdDialog", "$element", "item", "edit"];
    /** @ngInject */
    function UpdateBusinessTitleController(AppAPI, $mdDialog, $element, item, edit) {
        var vm = this;
        var Request = AppAPI.MpnApproval();

        vm.item = item;
        vm.job_code_id = 0;
        vm.business_title_id;
        vm.getBusinessTitle = getBusinessTitle;
        vm.IsEdit = edit;
        vm.notes = "";

        vm.searchTerm;
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function getBusinessTitle(job_code_id) {

            vm.listBu = [];

            var promise = Request.get({
                action: "getbusinesstitle",
                division_id: vm.item.division_id,
                department_id: vm.item.department_id,
                nik: vm.item.created_by
            });

            promise.$promise.then(function (data) {
                vm.listBu = data.business_title;
            });
            promise.$promise.catch(function (err) {
                vm.listBu = [];
            });
        }

        getBusinessTitle(null);

        vm.closeDialog = closeDialog;

        function closeDialog(answer, saveEdit) {
            if (answer === 1) {
                var bt_id = (saveEdit) ? vm.business_title_id : vm.item.business_title;
                var result = {
                    submit: true,
                    type: "MPN",
                    id: vm.item.id,
                    field: 'business_title_id',
                    mpn_mpn_id: vm.item.mpn_mpn_id,
                    business_title_id: bt_id,
                    job_code_id: vm.job_code_id,
                    app_type: "Approved",
                    notes: vm.notes
                }
                vm.item.mpn_status = vm.mpn_status;
            } else {
                var result = {
                    submit: false
                }
            }
            $mdDialog.hide(result);
        }
    }
})();
(function () {
    "use strict";

    angular.module("app.mpn.admin", []).config(config);

    config.$inject = ["$translatePartialLoaderProvider", "$stateProvider"];
    /** @ngInject */
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        // Translation
        //$translatePartialLoaderProvider.addPart("app/main/mpn/admin");

        // State
        $stateProvider
            .state("app.mpn.admin", {
                url: "/mpn/admin",
                views: {
                    "content@app": {
                        templateUrl: "app/main/mpn/admin/views/index.html",
                        controller: "RequestADMINController as vm"
                    }
                }
            }).state("app.mpn.admin.view", {
                url: "/mpn/admin/view-request/:id",
                views: {
                    "content@app": {
                        templateUrl: "app/main/mpn/admin/views/detail.html",
                        controller: "ViewRequestADMINController as vm"
                    }
                }
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.admin")
        .controller("ViewRequestADMINController", RequestMPNController);

    RequestMPNController.$inject = [
        "$state",
        "$stateParams",
        "$scope",
        "$mdDialog",
        "$window",
        "$location",
        "config",
        "MPNService",
        "AppAPI",
        "Auth"
    ];
    /** @ngInject */
    function RequestMPNController(
        $state,
        $stateParams,
        $scope,
        $mdDialog,
        $window,
        $location,
        config,
        MPNService,
        AppAPI,
        Auth
    ) {
        var vm = this;
        vm.request = {};
        vm.mpn_approval = [];

        // Data
        var Request = AppAPI.MpnApproval();

        // Methods
        viewDataRequest();

        vm.editRequest = editRequest;

        vm.showPrompt = showPrompt;

        function editRequest() {
            $state.go("app.mpn_request_edit", { id: $stateParams.id });
        };

        function showPrompt(field, change) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = null;

            if (field === 'BUDGET_TYPE') {
                confirm = {
                    template:
                        '<md-dialog aria-label="List dialog">' +
                        '<md-dialog-content>' +
                        '<h3><md-icon md-font-icon="icon-help-circle" class="blue-500-fg"></md-icon> {{vm.message}}</h3>' +
                        '<h5><md-icon md-font-icon="icon-alert-circle" class="red-500-fg"></md-icon> Please make sure you have chosen the right action!</h5>' +
                      
                        '<md-input-container class="md-block">' +
                        '<label>Comment</label> ' +
                        '<textarea name="notes"  ng-model="vm.notes" md-maxlength="200" max-rows="5"></textarea>' +
                        '</md-input-container>' +
                        
                        '</md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="vm.closeDialog(0)" class="md-primary">' +
                        '      CANCEL' +
                        '    </md-button>' +
                        '    <md-button ng-click="vm.closeDialog(1)" class="md-primary">' +
                        '      SAVE' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                    locals: {
                        item: vm.request,
                        change: change,
                        current_approval: vm.current_approval
                    },
                    controller: 'UpdateStatusController',
                    controllerAs: 'vm',
                };

            } else if (field === 'DELEGATION') {
                confirm = {
                    template:
                        '<md-dialog aria-label="List dialog">' +
                        ' <md-dialog-content><h1>Would you like to delegate this request?</h1><br>' +
                        '<h3>Please select employee to assign this task</h3>' +
                        '<div layout="row">' +
                        
                        '<md-input-container class="md-block"  style="width:100%">' +
                        '<label>Delegate To</label>' +
                        '<md-select ng-model="vm.current_approval.app_nik_delegate" md-on-close="vm.clearSearchTerm()">' +
                        '<md-select-header class="demo-select-header">' +
                        '<input ng-model="vm.searchTerm" type="search" placeholder="Search Employee.." class="demo-header-searchbox md-text">' +
                        '</md-select-header>' +
                        '<md-optgroup label="Employee">' +
                        '<md-option>NONE</md-option>' +
                        '<md-option ng-value="{{d.nik}}" ng-repeat="d in vm.listDelegation | filter:vm.searchTerm">{{d.description}}</md-option>' +
                        '</md-optgroup>' +
                        '</md-select>' +
                        '</md-input-container>' +
                        '</div>' +

                        '<div layout="row">' +
                        '<md-input-container class="md-block" style="width:100%">' +
                        '<label>Comment</label> ' +
                        '<textarea name="notes"  ng-model="vm.notes" md-maxlength="200" max-rows="5"></textarea>' +
                        '</md-input-container>' +
                        '</div>' +
                        '</md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="vm.closeDialog(0)" class="md-primary">' +
                        '      CANCEL' +
                        '    </md-button>' +
                        '    <md-button ng-click="vm.closeDialog(1)" class="md-primary">' +
                        '      SAVE' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                    locals: {
                        items: vm.listDelegation,
                        current_approval: vm.current_approval
                    },
                    controller: 'DelegateController',
                    controllerAs: 'vm'
                };
            }

            $mdDialog.show(confirm).then(function (result) {
                if (result !== undefined && result.submit === false) {
                    return;
                }

                angular.element.blockUI();
                var promise = Auth.setToken();
                promise.then(function () {

                    var response = Request.updatestatus(result);

                    angular.element.unblockUI();
                    response.$promise.then(function (params) {
                        if (params.id !== null) {
                            viewDataRequest();
                        }
                    });

                    response.$promise.catch(function () {
                        angular.element.unblockUI();
                    });
                });

                promise.catch(function () {
                    angular.element.unblockUI();
                });

            }, function () {
                angular.element.unblockUI();
            });

        };

        vm.publishRequest = publishRequest;

        function publishRequest() {

            var confirm = $mdDialog.confirm()
                .title('Would you like to save and publish this request?')
                .textContent('This operation cannot be undone, make sure your data is correct.')
                .ariaLabel('publish dialog')
                .ok('YES')
                .cancel('no');

            $mdDialog.show(confirm).then(saveRequest, function () { });
        }

        function saveRequest() {

            angular.element.blockUI();
            var promise = Auth.setToken();
            promise.then(function () {

                vm.request.action = "save";

                vm.request.current_status = "Waiting Approval";

                var response = Request.save("save", vm.request);

                angular.element.unblockUI();
                response.$promise.then(function (params) {

                    if (params.id !== null) {
                        vm.request.id = params.id;

                        MPNService.save(vm.request);

                        $state.go("app.mpn_request_view", { id: params.id });
                    }

                });

                response.$promise.catch(function () {
                    angular.element.unblockUI();
                });
            });

            promise.catch(function () {
                angular.element.unblockUI();
            });
        }

        vm.formatDate = formatDate;

        function formatDate(date) {
            if (date === null) {
                return "";
            }
            return new Date(date)
        }
        //////////

        function viewDataRequest() {
            angular.element.blockUI();
            var RequestPromise = Request.get({
                action: "viewdetail",
                id: $stateParams.id,
                type: "view"
            });
            RequestPromise.$promise.then(fetchDataRequest);
            RequestPromise.$promise.catch(errorFetchRequest);
        }

        function fetchDataRequest(data) {
            if (angular.isArray(data.mpn_mpn)) {
                vm.request = data.mpn_mpn[0];
            } else {
                vm.request = data.mpn_mpn;
            }

            vm.request.quantity_replacement = parseInt(vm.request.quantity_replacement);
            vm.request.quantity_new_position = parseInt(vm.request.quantity_new_position);

            vm.mpn_approval_history = data.mpn_approval_history;

            vm.mpn_approval = data.mpn_approval;

            vm.replacement = data.mpn_replacement;

            vm.current_approval = data.current_approval;
            vm.next_approval = data.next_approval;
            vm.total_lead_time = data.total_lead_time;

            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.request = [];
            angular.element.unblockUI();
        }

        vm.Pdf = Pdf;

        function Pdf() {
            var token = Auth.setTokenPromise();

            token.then(function (data) {

                var protocol = $location.protocol();
                var host = $location.host();
                var port = $location.port();

                var json = JSON.stringify({
                    t: data.token,
                    i: vm.request.id,
                });

                $window.open(protocol + '://' + host + ':' + port + config.api + 'api/mpnapproval/pdf?filter=' + json, '_blank');

            }, function () {
                $window.alert('gagal load token')
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpn.admin")
        .controller("RequestADMINController", RequestMPNController);

    RequestMPNController.$inject = [
        "$state",
        "$scope",
        "DTColumnDefBuilder",
        "AppAPI"
    ];
    /** @ngInject */
    function RequestMPNController(
        $state,
        $scope,
        DTColumnDefBuilder,
        AppAPI
    ) {
        var vm = this;
        vm.listRequest = [];

        vm.editData = editData;
        vm.viewDetail = viewDetail;
        vm.viewData = viewDataRequest;

        vm.mpn_status = 'Waiting Approval';

        // Data
        /*  vm.employees = Employees.data;*/
        var Request = AppAPI.MpnApproval();

        viewDataRequest();

        vm.dtOptions = {
            dom:
                '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: "full_numbers"
        };

        vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(1).notSortable()];

        // Data

        // Methods
        vm.formatDate = formatDate;
        function formatDate(date) {
            if (date === null) {
                return "";
            }
            return new Date(date)
        }

        function viewDataRequest() {
            angular.element.blockUI();
            var RequestPromise = Request.query({ action: "viewdataadmin", mpn_status: vm.mpn_status });
            RequestPromise.$promise.then(fetchDataRequest);
            RequestPromise.$promise.catch(errorFetchRequest);
        }

        function fetchDataRequest(data) {
            vm.listRequest = data;
            angular.element.unblockUI();
        }

        function errorFetchRequest() {
            vm.listRequest = [];
            angular.element.unblockUI();
        }

        function editData(id) {
            $state.go("app.mpn.admin.edit", { id: id });
        }

        function viewDetail(id) {
            $state.go("app.mpn.admin.view", { id: id });
        }

        $scope.parseInt = function (num) {
            return parseInt(num);
        }

    }
})();
(function () {
    "use strict";

    angular
        .module("app.mpn.admin")
        .controller("UpdateStatusController", UpdateStatusController);

    UpdateStatusController.$inject = ["$mdDialog", "item", "change", "current_approval"];
    /** @ngInject */
    function UpdateStatusController($mdDialog, item, change, current_approval) {
        var vm = this;

        vm.Budgeted = "Budgeted";
        vm.Unbudgeted = "Unbudgeted";

        vm.item = item;
        vm.current_approval = current_approval;
        vm.budget_type = item.budget_type;
        vm.current_budget_type = change ? (item.budget_type == vm.Budgeted ? vm.Unbudgeted : vm.Budgeted) : item.budget_type;
        vm.change = change;
        vm.notes = "";

        vm.message = "Would you like to update current budget type from " + item.budget_type + " to " + vm.current_budget_type + "?";

        if (!change) {
            vm.message = "Would you like to commit and approve current budget type ( " + item.budget_type + " ) for this MPN?";
        }

        vm.closeDialog = function (answer) {
            if (answer === 1) {
                var result = {
                    submit: true,
                    type: "MPN",
                    id: item.id,
                    pk: vm.current_approval.id,
                    field: 'budget_type',
                    mpn_mpn_id: item.mpn_mpn_id,
                    budget_type: vm.current_budget_type,
                    created_by: item.created_by,
                    business_title: item.business_title,
                    is_need_approval_grade: item.is_need_approval_grade,
                    reset_approval: vm.change,
                    emp_grade: item.emp_grade,
                    app_type: 'Approved',
                    app_nik: vm.current_approval.app_nik,
                    notes: vm.notes
                }
                item.budget_type = vm.current_budget_type;
            } else {
                var result = {
                    submit: false
                }
            }
            $mdDialog.hide(result);
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("app.mpn.admin")
        .controller("DelegateController", DelegateController);

    DelegateController.$inject = ["AppAPI", "$mdDialog", "$element", "items", "current_approval"];
    /** @ngInject */
    function DelegateController(AppAPI, $mdDialog, $element, items, current_approval) {
        var vm = this;
        var Request = AppAPI.MpnApproval();

        vm.items = items;
        vm.current_approval = current_approval;
        vm.searchTerm;
        vm.notes;

        getDelegations();

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function getDelegations() {
            var response = Request.query({ action: 'getdelegations' });
            response.$promise.then(function (data) {
                vm.listDelegation = data;
            });
            response.$promise.catch(function () {
                vm.listDelegation = [];
            });
        }

        vm.closeDialog = function (answer) {
            if (answer === 1) {
                var result = {
                    submit: true,
                    type: "DELEGATION",
                    id: vm.current_approval.id,
                    field: 'app_nik_delegate',
                    mpn_mpn_id: vm.current_approval.mpn_mpn_id,
                    budget_type: vm.current_budget_type,
                    created_by: vm.current_approval.created_by,
                    delegated_user: vm.current_approval.app_nik_delegate,
                    notes: vm.notes,
                    reset_approval: false,
                    app_type: 'Delegated'
                }
            } else {
                var result = {
                    submit: false
                }
            }
            $mdDialog.hide(result);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.master-data.update-finger-reason', ['app.master-data.update-finger-reason.input'
        ])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.masterdata_update_finger_reason', {
                url    : '/master-data/update-finger-reason',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/update-finger-reason/index.html',
                        controller : 'UpdateFingerReasonController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.master-data.update-finger-reason')
        .controller('UpdateFingerReasonController', UpdateFingerReasonController);


    UpdateFingerReasonController.$inject=['$state','$mdDialog','DTColumnDefBuilder','AppAPI','Auth'];
    /** @ngInject */
    function UpdateFingerReasonController($state,$mdDialog,DTColumnDefBuilder,AppAPI,Auth)
    {
        
        var vm = this;
         vm.listData=[];
         vm.toggleSelectedAll=toggleSelectedAll;
         vm.listDataSelected=[];
         vm.editData=editData;
         vm.delete=deleteData;

         
        // Data
      /*  vm.employees = Employees.data;*/
       var UpdateFingerReason=AppAPI.UpdateFingerReason();
        viewData();
        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

         vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1).notSortable()
    ];

        // Data
 
        // Methods

        //////////

        function viewData() {
          angular.element.blockUI();
           var buPromise=UpdateFingerReason.query({action:'viewdata'});
        buPromise.$promise.then(fetchDataBu);
        buPromise.$promise.catch(errorFetchBu); 
        }

        function fetchDataBu(data) {
            vm.listData=data;
            angular.element.unblockUI();
        }

        function errorFetchBu() {
            vm.listData=[];
            angular.element.unblockUI();
        }

       
    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listDataSelected=angular.copy(vm.listData);
    }

    function unCheckAll() {
       vm.listDataSelected=[];
    }

    function editData(id) {
        $state.go('app.masterdata_update_finger_reason_edit',{id:id});
    }

    function deleteData(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=UpdateFingerReason.delete({action:'delete',data:angular.toJson(vm.listDataSelected)});

       response.$promise.then(viewData);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }



    }
})();

(function() {
  'use strict';

  angular
    .module('app.master-data.school', [])
    .config(config);

  config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.masterdata_school', {
      url: '/master-data/school',
      views: {
        'content@app': {
          templateUrl: 'app/main/master-data/school/school.html',
          controller: 'SchoolController as vm'
        }
      }
    });

    // Translation
    // $translatePartialLoaderProvider.addPart('app');
  }
})();

(function () {
  'use strict';
  angular
    .module('app.master-data.school')
    .controller('SchoolController', SchoolController)

  SchoolController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form'
  ];
  /** @ngInject */
  function SchoolController(
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form
  ) {
    var vm = this;
    var ApiSchool = AppAPI.School();
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.Form = Form;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addSchool = addSchool;
    vm.saveDataSchool = saveDataSchool;
    vm.dialogClose = dialogClose;
    vm.editSchool = editSchool;
    vm.deleteDataSchool = deleteDataSchool;
    vm.loadData = loadData;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(ApiSchool);
      vm.selected = [];
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(ApiSchool, pageno, { action: 'loadDataSchool' });

      resp.then(function (data) {
        vm.items = data.list;
        vm.selected = [];
      });
      console.log(resp);
    }

    function addSchool(ev) {
      $mdDialog.show({
        controller: 'SchoolController',
        controllerAs: 'vm',
        templateUrl: 'app/main/master-data/school/input-school.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editSchool(ev, data) {
      $mdDialog.show({
        controller: 'EditSchoolController',
        controllerAs: 'vm',
        templateUrl: 'app/main/master-data/school/edit-school.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data : data,
          showDialog : showDialogInfo,
          dialogClose : dialogClose
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteDataSchool(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            console.log(data);
            var response = ApiSchool.delete({
              action: 'deleteDataSchool',
              data: angular.toJson(data)
            });
            response.$promise.then(function(data) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function saveDataSchool(ev, formController) {
      angular.element.blockUI();
      console.log(vm.Form);
      var response = Form.saveData('saveDataSchool', formController, ApiSchool);
      response.then(function (data) {
        angular.element.unblockUI();
        formController.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        formController.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    // Toggle checkbox
    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('app.master-data.school')
    .controller('EditSchoolController', EditSchoolController)

  EditSchoolController.$inject = [
    '$state',
    'data',
    'dialogClose',
    'showDialog',
    '$mdDialog',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form'
  ];
  /** @ngInject */
  function EditSchoolController(
    $state,
    data,
    dialogClose,
    showDialog,
    $mdDialog,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form
  ) {
    var vm = this;
    var ApiSchool = AppAPI.School();
    vm.Form = Form;
    vm.dialogClose = dialogClose;
    vm.updateDataSchool = updateDataSchool;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(ApiSchool);
      console.log(data);
      vm.Form.objForm.schoolName = data.school_name;
    }

    function updateDataSchool(ev, formController) {
      angular.element.blockUI();
      console.log(formController);
      vm.Form.objForm.id = data.id;
      var response = Form.saveData('updateDataSchool', formController, ApiSchool);
      response.then(function(data) {
        angular.element.unblockUI();
        formController.$setPristine();
        showDialog(ev, data);
      });

      response.catch(function(data) {
        angular.element.unblockUI();
        formController.$setPristine();
        showDialog(ev, data);
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.master-data.level', ['app.master-data.level.input-level'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.masterdata_level', {
                url    : '/master-data/level',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/level/level.html',
                        controller : 'LevelController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.master-data.level')
        .controller('LevelController', LevelController);


    LevelController.$inject=['$state','$mdDialog','DTColumnDefBuilder','AppAPI','Auth'];
    /** @ngInject */
    function LevelController($state,$mdDialog,DTColumnDefBuilder,AppAPI,Auth)
    {
        
        var vm = this;
         vm.listLevel=[];
         vm.toggleSelectedAll=toggleSelectedAll;
         vm.listLevelSelected=[];
         vm.editData=editData;
         vm.deleteLevel=deleteLevel;


        // Data
      /*  vm.employees = Employees.data;*/
       var Level=AppAPI.Level();
        viewDataLevel();
        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

         vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1).notSortable()
    ];

        // Data
 
        // Methods

        //////////

        function viewDataLevel() {
          angular.element.blockUI();
           var levelPromise=Level.query({action:'viewdata'});
        levelPromise.$promise.then(fetchDataLevel);
        levelPromise.$promise.catch(errorFetchLevel); 
        }

        function fetchDataLevel(data) {
            vm.listLevel=data;
            angular.element.unblockUI();
        }

        function errorFetchLevel() {
            vm.listLevel=[];
            angular.element.unblockUI();
        }

       
    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listLevelSelected=angular.copy(vm.listLevel);
    }

    function unCheckAll() {
       vm.listLevelSelected=[];
    }

      function editData(id) {
        $state.go('app.masterdata_level_edit',{id:id});
    }

      function deleteLevel(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=Level.delete({action:'delete',data:angular.toJson(vm.listLevelSelected)});

       response.$promise.then(viewDataLevel);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.master-data.job-title', ['app.master-data.job-title.input-jobtitle'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
       // State
        $stateProvider
            .state('app.masterdata_jobtitle', {
                url    : '/master-data/job-title',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/job-title/jobtitle.html',
                        controller : 'JobtitleController as vm'
                    }
                }
            });
    }
})();
(function() {
  'use strict';

  angular.module('app.master-data.job-title').controller('JobtitleController', JobtitleController);

  JobtitleController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth'];
  /** @ngInject */
  function JobtitleController($state, $mdDialog, DataService, AppAPI, Auth) {
    var vm = this;
    vm.listJobtitle = [];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.listJobtitleSelected = [];
    vm.editData = editData;
    vm.deleteJobtitle = deleteJobtitle;
    vm.DataTables = new DataService();
    vm.viewDataJobtitle = viewDataJobtitle;

    var Jobtitle = AppAPI.Jobtitle();
    viewDataJobtitle(1);

    function viewDataJobtitle(pageno) {
      angular.element.blockUI();
      var resp = vm.DataTables.loadData(Jobtitle, pageno, {
        action: 'viewdata'
      });

      resp.then(function(data) {
        vm.listJobtitle = data;
        // console.log(vm.listJobtitle);
        angular.element.unblockUI();
      });

      resp.catch(function(data) {
        vm.listJobtitle = [];
        angular.element.unblockUI();
      });
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listJobtitleSelected = angular.copy(vm.listJobtitle);
    }

    function unCheckAll() {
      vm.listJobtitleSelected = [];
    }

    function editData(id) {
      $state.go('app.masterdata_jobtitle_edit', { id: id });
    }

    function deleteJobtitle(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(
          function() {
            angular.element.blockUI();
            var response = Jobtitle.delete({
              action: 'delete',
              data: angular.toJson(vm.listJobtitleSelected)
            });

            response.$promise.then(viewDataJobtitle);
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }
  }
})();

(function () {
  "use strict";

  angular.module('app.master-data.job_code', []).config(config);

  config.$inject = ['$stateProvider'];
  function config($stateProvider) {

    $stateProvider
      .state('app.job_code', {
        url: '/master-data/job_code',
        views: {
          'content@app': {
            templateUrl: 'app/main/master-data/job-code/job-code.html',
            controller: 'JobCodeController as vm'
          }
        }

      });

  }
}());
(function () {
    'use strict';

    angular
        .module('app.master-data.job_code')
        .controller('JobCodeController', JobCodeController);

    JobCodeController.$inject = ['$q', '$localStorage', 'DataService', 'AppAPI', '$mdDialog', 'Auth', '$location', 'config', '$window'];

    /* @ngInject */
    function JobCodeController($q, $localStorage, DataService, AppAPI, $mdDialog, Auth, $location, config, $window) {

        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        var JobCode = AppAPI.JobCode();
        vm.loadData = loadData;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;
        vm.download = download;

        console.log('$localStorage', $localStorage);

        loadData('1');

        function loadData(pageno) {

            console.log('pageno', pageno);

            var params = {
                action: 'viewdata'
            };
            var response = vm.DataTable.loadData(JobCode, pageno, params);
            vm.listselected = [];
            response.then(function (res) {
                console.log('res', res);
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }
            var idx = vm.listselected.indexOf(ls);
            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        function add(ev) {
            $mdDialog.show({
                controller: 'InputJobCodeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/master-data/job-code/job-code-add.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function edit(ev, data) {
            $mdDialog.show({
                controller: 'UpdateJobCodeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/master-data/job-code/job-code-edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    data: data
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function remove(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = JobCode.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
                    response.$promise.then(loadData);
                }, function () {
                });
            });
        }

        function download(ev) {
            var token = Auth.setTokenPromise();
            token.then(function (data) {

                var protocol = $location.protocol();
                var port = $location.port();
                var host = $location.host() + ((port !== '') ? ':' + port : '');
                var config_api = config.api;
                if (config.api.substr(-1) === '/') {
                    config_api = config.api.substr(1, config.api.length);
                }
                var url = protocol + '://' + host + '/' + config_api + 'api/jobcode/download/' + data.token;
                $window.open(url, '_blank');
                console.log(config.api);
            }, function () {
                $window.alert('Gagal load token')
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.master-data.job_code')
        .controller('UpdateJobCodeController', UpdateJobCodeController);

    UpdateJobCodeController.$inject = ['$mdDialog', 'Form', 'AppAPI', 'data'];

    /* @ngInject */
    function UpdateJobCodeController($mdDialog, Form, AppAPI, data) {
        var vm = this;
        vm.saveData = saveData;
        var JobCode = AppAPI.JobCode();
        Form.initialForm();
        Form.setObject(JobCode);
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.code = data.code;
        vm.Form.objForm.description = data.description;

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, JobCode);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save update data')
                    .textContent(data.pesan)
                    .ariaLabel('Success save update data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save update data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed save upate data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.master-data.job_code')
        .controller('InputJobCodeController', InputJobCodeController);

    InputJobCodeController.$inject = ['$mdDialog', 'Form', 'AppAPI'];

    /* @ngInject */
    function InputJobCodeController($mdDialog, Form, AppAPI) {
        var vm = this;
        vm.saveData = saveData;
        var JobCode = AppAPI.JobCode();
        Form.initialForm();
        Form.setObject(JobCode);
        vm.Form = Form;
        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, JobCode);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                ShowFailed(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.master-data.jfm', ['app.master-data.jfm.input-jfm'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.masterdata_jfm', {
                url    : '/master-data/jfm',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/jfm/jfm.html',
                        controller : 'JfmController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.master-data.jfm')
        .controller('JfmController', JfmController);


   JfmController.$inject=['$state','$mdDialog','DTColumnDefBuilder','AppAPI','Auth'];
    /** @ngInject */
    function JfmController($state,$mdDialog,DTColumnDefBuilder,AppAPI,Auth)
    {
        
        var vm = this;
         vm.listJfm=[];
         vm.toggleSelectedAll=toggleSelectedAll;
         vm.listJfmSelected=[];
         vm.editData=editData;
         vm.deleteJfm=deleteJfm;  

        // Data
      /*  vm.employees = Employees.data;*/
       var Jfm=AppAPI.Jfm();
        viewDataJfm();
        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

         vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1).notSortable()
    ];

        // Data
 
        // Methods

        //////////

        function viewDataJfm() {
          angular.element.blockUI();
           var jfmPromise=Jfm.query({action:'viewdata'});
        jfmPromise.$promise.then(fetchDataJfm);
        jfmPromise.$promise.catch(errorFetchJfm); 
        }

        function fetchDataJfm(data) {
            vm.listJfm=data;
            angular.element.unblockUI();
        }

        function errorFetchJfm() {
            vm.listJfm=[];
            angular.element.unblockUI();
        }

       
    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listJfmSelected=angular.copy(vm.listJfm);
    }

    function unCheckAll() {
       vm.listJfmSelected=[];
    }

     function editData(id) {
        $state.go('app.masterdata_jfm_edit',{id:id});
    }

    function deleteJfm(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=Jfm.delete({action:'delete',data:angular.toJson(vm.listJfmSelected)});

       response.$promise.then(viewDataJfm);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    }
})();

(function() {
  'use strict';

  angular
    .module('app.master-data.gedung', [])
    .config(config);

  config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.masterdata_gedung', {
      url: '/master-data/gedung',
      views: {
        'content@app': {
          templateUrl: 'app/main/master-data/gedung/gedung.html',
          controller: 'GedungController as vm'
        }
      }
    });

    // Translation
    // $translatePartialLoaderProvider.addPart('app');
  }
})();

(function() {
  'use strict';
  angular
    .module('app.master-data.gedung')
    .controller('GedungController', GedungController)

  GedungController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form'
  ];
  /** @ngInject */
  function GedungController(
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form
  ) {
    var vm = this;
    var Attendancereport = AppAPI.Attendancereport();
    var ApiHoliday = AppAPI.NationalHoliday();
    var ApiLaborType = AppAPI.EmpLaborType();
    var ApiGedung = AppAPI.Gedung();
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.company = $localStorage.empsite ? $localStorage.empsite : 'KS';
    vm.loadSubArea = loadSubArea;
    vm.selectedSubarea = '0';
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addGedung = addGedung;
    vm.showDialogInfo = showDialogInfo;
    vm.dialogClose = dialogClose;
    vm.saveGedung = saveGedung;
    vm.deleteDataGedung = deleteDataGedung;
    vm.editGedung = editGedung;
    vm.Form = Form;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(ApiGedung);
      vm.selected = [];
      loadData(1);
      loadSubArea();
      loadDataBU();
    }

    function addGedung(ev) {
      $mdDialog.show({
        controller: 'GedungController',
        controllerAs: 'vm',
        templateUrl: 'app/main/master-data/gedung/input-gedung.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editGedung(ev, data) {
      $mdDialog.show({
        controller: 'EditGedungController',
        controllerAs: 'vm',
        templateUrl: 'app/main/master-data/gedung/edit-gedung.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        locals : {
          data : data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function loadData(pageno) {
      var subarea = vm.selectedSubarea == '0' ? 'all' : vm.selectedSubarea;
      var resp = vm.DataTables.loadData(ApiGedung, pageno, {
        action: 'viewData',
        company: vm.company,
        subarea: subarea
      });

      resp.then(function(data) {
        console.log(data);
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function deleteDataGedung(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = ApiGedung.delete({
              action: 'deleteData',
              data: angular.toJson(data)
            });
            response.$promise.then(function(data) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function saveGedung(ev, formController) {
      angular.element.blockUI();
      console.log(formController);
      vm.Form.objForm.subarea = formController.subarea.$viewValue;
      vm.Form.objForm.gedungname = formController.gedungName.$viewValue;
      var auth = Auth.setToken();
      auth.then(function () {
        var response = Form.saveData('saveData', formController, ApiGedung);
        response.then(function(data) {
          angular.element.unblockUI();
          formController.$setPristine();
          showDialogInfo(ev, data);
        });

        response.catch(function(data) {
          angular.element.unblockUI();
          formController.$setPristine();
          showDialogInfo(ev, data);
        });
      })

    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function loadDataBU() {
      var response = Attendancereport.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    function loadSubArea() {
      var response = ApiHoliday.query({
        action: 'loadDataSubArea',
        idbu: vm.company
      });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorfetchArea);
    }

    function fetchArea(data) {
      vm.subArea = data;
    }

    function errorfetchArea(data) {
      vm.subArea = [];
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

  }
})();

(function () {
    'use strict';
    angular
        .module('app.master-data.gedung')
        .controller('EditGedungController', EditGedungController)

    EditGedungController.$inject = [
        '$state',
        '$mdDialog',
        '$localStorage',
        '$window',
        '$timeout',
        'AppAPI',
        'Auth',
        'Form',
        'data'
    ];
    /** @ngInject */
    function EditGedungController(
        $state,
        $mdDialog,
        $localStorage,
        $window,
        $timeout,
        AppAPI,
        Auth,
        Form,
        data
    ) {
        var vm = this;
        var Attendancereport = AppAPI.Attendancereport();
        var ApiHoliday = AppAPI.NationalHoliday();
        var ApiGedung = AppAPI.Gedung();
        vm.company = data.company_id;
        vm.loadSubArea = loadSubArea;
        vm.selectedSubarea = data.sub_area_id;
        vm.gedung_name = data.gedung_name;
        vm.sector = data.sector;
        vm.showDialogInfo = showDialogInfo;
        vm.dialogClose = dialogClose;
        vm.Form = Form;
        vm.updateDataBorongan = updateDataBorongan;
        vm.removeSector = removeSector;
        vm.newSector = '';
        vm.addSector = addSector;
        vm.promiseSector = false;
        vm.messageSector = '';
        vm.successSector = false;

        activate();

        function activate() {
            Form.initialForm();
            Form.setObject(ApiGedung);
            loadSubArea();
            loadDataBU();
        }

        function updateDataBorongan(ev, formController) {
            angular.element.blockUI();
            console.log(formController);
            vm.Form.objForm.id = data.id;
            vm.Form.objForm.subarea = formController.subarea.$viewValue;
            vm.Form.objForm.gedungname = formController.gedungName.$viewValue;
            var auth = Auth.setToken();
            auth.then(function () {
                var response = Form.saveData('updateData', formController, ApiGedung);
                response.then(function (data) {
                    angular.element.unblockUI();
                    formController.$setPristine();
                    showDialogInfo(ev, data);
                });

                response.catch(function (data) {
                    angular.element.unblockUI();
                    formController.$setPristine();
                    showDialogInfo(ev, data);
                });
            });

        }

        function showDialogInfo(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.pesan)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function removeSector(sector, index) {
            angular.element("#custom-chips").block();
            var auth = Auth.setToken();
            auth.then(function () {
                var request = ApiGedung.save({
                    action: 'removeSector',
                    id: sector.id
                });

                request.$promise.then(function (response) {
                    angular.element("#custom-chips").unblock();
                    vm.sector.splice(index, 1);
                    vm.promiseSector = true;
                    vm.messageSector = response.message;
                    vm.successSector = true;

                    $timeout(function () {
                        vm.promiseSector = false;
                        vm.messageSector = '';
                        vm.successSector = false;
                    }, 2500);

                });

                request.$promise.catch(function (response) {

                    angular.element("#custom-chips").unblock();
                    vm.promiseSector = true;
                    vm.messageSector = response.message;
                    vm.successSector = true;

                    $timeout(function () {
                        vm.promiseSector = false;
                        vm.messageSector = '';
                        vm.successSector = false;
                    }, 2500);

                });

            })
        }

        function addSector() {
            angular.element("#custom-chips").block();
            var auth = Auth.setToken();
            auth.then(function () {
                var request = ApiGedung.save({
                    action: 'addSector',
                    sector_name: vm.newSector,
                    gedung_id: data.id
                });

                request.$promise.then(function (response) {
                    console.log(response.data);
                    angular.element("#custom-chips").unblock();
                    vm.sector.push(response.data);
                    vm.promiseSector = true;
                    vm.messageSector = response.message;
                    vm.successSector = true;

                    $timeout(function () {
                        vm.promiseSector = false;
                        vm.messageSector = '';
                        vm.successSector = false;
                    }, 2500);

                });

                request.$promise.catch(function (response) {

                    angular.element("#custom-chips").unblock();
                    vm.promiseSector = true;
                    vm.messageSector = response.message;
                    vm.successSector = true;

                    $timeout(function () {
                        vm.promiseSector = false;
                        vm.messageSector = '';
                        vm.successSector = false;
                    }, 2500);

                });

            })
        }


        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDataBU() {
            var response = Attendancereport.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = ApiHoliday.query({
                action: 'loadDataSubArea',
                idbu: vm.company
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.master-data.division', ['app.master-data.division.input-division'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.masterdata_division', {
                url    : '/master-data/division',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/division/division.html',
                        controller : 'DivisionController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.master-data.division')
        .controller('DivisionController', DivisionController);


    DivisionController.$inject=['$state','$mdDialog','DTColumnDefBuilder','AppAPI','Auth'];
    /** @ngInject */
    function DivisionController($state,$mdDialog,DTColumnDefBuilder,AppAPI,Auth)
    {

        var vm = this;
         vm.listDivision=[];
         vm.toggleSelectedAll=toggleSelectedAll;
         vm.listDivisionSelected=[];
         vm.editData=editData;
         vm.deleteDivision=deleteDivision;


         // Data
      /*  vm.employees = Employees.data;*/
       var Division=AppAPI.Division();
        viewDataDivision();
        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

         vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1).notSortable()
    ];

        // Data

        // Methods

        //////////

        function viewDataDivision() {
          angular.element.blockUI();
          var divisionPromise=Division.query({action:'viewdata'});
          divisionPromise.$promise.then(fetchDataDivision);
          divisionPromise.$promise.catch(errorFetchDivision);
        }

        function fetchDataDivision(data) {
            vm.listDivision=data;
            angular.element.unblockUI();
        }

        function errorFetchDivision() {
            vm.listDivision=[];
            angular.element.unblockUI();
        }


    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
      console.log(vm.listDivision);
       vm.listDivisionSelected=angular.copy(vm.listDivision);
    }

    function unCheckAll() {
       vm.listDivisionSelected=[];
    }

    function editData(id) {
        $state.go('app.masterdata_division_edit',{id:id});
    }

     function deleteDivision(ev) {

      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

          $mdDialog.show(confirm).then(function() {
              angular.element.blockUI();
             var response=Division.delete({action:'delete',data:angular.toJson(vm.listDivisionSelected)});

             response.$promise.then(viewDataDivision);
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
       });


    }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.master-data.department', ['app.master-data.department.input-department'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.masterdata_department', {
                url    : '/master-data/department',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/department/department.html',
                        controller : 'DepartmentController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.master-data.department')
        .controller('DepartmentController', DepartmentController);


    DepartmentController.$inject=['$state','$mdDialog','DTColumnDefBuilder','AppAPI','Auth'];
    /** @ngInject */
    function DepartmentController($state,$mdDialog,DTColumnDefBuilder,AppAPI,Auth)
    {
        
        var vm = this;
         vm.listDepartment=[];
         vm.toggleSelectedAll=toggleSelectedAll;
         vm.listDepartmentSelected=[];
         vm.editData=editData;
         vm.deleteDepartment=deleteDepartment;


        // Data
      /*  vm.employees = Employees.data;*/
       var Department=AppAPI.Department();
        viewDataDepartment();
        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

         vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1).notSortable()
    ];

        // Data
 
        // Methods

        //////////

        function viewDataDepartment() {
          angular.element.blockUI();
           var departmentPromise=Department.query({action:'viewdata'});
        departmentPromise.$promise.then(fetchDataDepartment);
        departmentPromise.$promise.catch(errorFetchDepartment); 
        }

        function fetchDataDepartment(data) {
            vm.listDepartment=data;
            angular.element.unblockUI();
        }

        function errorFetchDepartment() {
            vm.listDepartment=[];
            angular.element.unblockUI();
        }


       
    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listDepartmentSelected=angular.copy(vm.listDepartment);
    }

    function unCheckAll() {
       vm.listDepartmentSelected=[];
    }

      function editData(id) {
        $state.go('app.masterdata_department_edit',{id:id});
    }

     function deleteDepartment(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=Department.delete({action:'delete',data:angular.toJson(vm.listDepartmentSelected)});

       response.$promise.then(viewDataDepartment);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.master-data.department-division', ['app.master-data.department-division.input-department-division'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.masterdata_department_division', {
                url    : '/master-data/department-division',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/department-division/department-division.html',
                        controller : 'DepartmentdivisionController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.master-data.department-division')
        .controller('DepartmentdivisionController', DepartmentdivisionController);


    DepartmentdivisionController.$inject=['$state','$mdDialog','DTColumnDefBuilder','AppAPI','Auth'];
    /** @ngInject */
    function DepartmentdivisionController($state,$mdDialog,DTColumnDefBuilder,AppAPI,Auth)
    {
        
        var vm = this;
         vm.listDepartment=[];
         vm.toggleSelectedAll=toggleSelectedAll;
         vm.listDepartmentSelected=[];
         vm.editData=editData;
         vm.deleteDepartment=deleteDepartment;


        // Data
      /*  vm.employees = Employees.data;*/
       var Department=AppAPI.DivisionDepartment();
        viewDataDepartment();
        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

         vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1).notSortable()
    ];

        // Data
 
        // Methods

        //////////

        function viewDataDepartment() {
          angular.element.blockUI();
           var departmentPromise=Department.query({action:'viewdata'});
        departmentPromise.$promise.then(fetchDataDepartment);
        departmentPromise.$promise.catch(errorFetchDepartment); 
        }

        function fetchDataDepartment(data) {
            vm.listDepartment=data;
            angular.element.unblockUI();
        }

        function errorFetchDepartment() {
            vm.listDepartment=[];
            angular.element.unblockUI();
        }


       
    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listDepartmentSelected=angular.copy(vm.listDepartment);
    }

    function unCheckAll() {
       vm.listDepartmentSelected=[];
    }

      function editData(id) {
        $state.go('app.masterdata_department_edit',{id:id});
    }

     function deleteDepartment(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=Department.delete({action:'delete',data:angular.toJson(vm.listDepartmentSelected)});

       response.$promise.then(viewDataDepartment);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.master-data.cost-center', [])
        .config(config);

      config.$inject=['$stateProvider'];
      /** @ngInject */
    function config($stateProvider)
    {

        // State
        $stateProvider
            .state('app.masterdata_costcenter', {
                url    : '/master-data/cost-center',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/cost-center/cost-center.html',
                        controller : 'CostCenterController as vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.master-data.cost-center')
        .controller('EditCostCenterController', EditCostCenterController);

    EditCostCenterController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','config', '$timeout','edt'];

    /* @ngInject */
    function EditCostCenterController($localStorage,$mdDialog,Form,AppAPI,config,$timeout,edt) {
        var vm = this;
            vm.saveData=saveData;

        Form.initialForm();

        var Costcenter = AppAPI.Costcenter();
        var Overtime = AppAPI.Overtime();

        // set constructor form
        Form.setObject(Costcenter);

        vm.companyLogin = $localStorage.empsite;
        vm.countryLogin = $localStorage.country;
        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.searchTermCountry = '';
        vm.clearSearchTermCountry = clearSearchTermCountry;

        vm.edit = edt.id ? true : false;

        loadDataBU();
        
        if(edt.id) { 
            var response=vm.Form.objForm.$get({action:'viewDetail',id:edt.id});
            response.then(setData);
        }

        function setData(data)
        {
            vm.Form.objForm.id=edt.id;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadDataBU() {
            angular.element.blockUI();
            var response=Overtime.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }
    
        function fetchBU(data) {
            angular.element.unblockUI();
            vm.listBU=data;

            if(!edt.id) {
                vm.Form.objForm.company = vm.companyLogin;
            }
            loadDataGroup();
        }
    
        function errorFetchBU() {
            angular.element.unblockUI();
            vm.listBU=[];
        }

        function loadDataGroup() {
            angular.element.blockUI();
            var response=Costcenter.query({action:'getGroupCostCenter'});
            response.$promise.then(fetchGroup);
            response.$promise.catch(errorFetchGroup);
        }
    
        function fetchGroup(data) {
            angular.element.unblockUI();
            vm.listGroup=data;
            if(!edt.id) {
                for(var i=0; i<data.length; i++) {
                    if(data[i].bu == vm.companyLogin && data[i].country_id == vm.countryLogin) {
                        vm.Form.objForm.group_cost_id = data[i].id;
                    }
                }
            }
            loadDataCountry();
        }
    
        function errorFetchGroup() {
            angular.element.unblockUI();
            vm.listGroup=[];
        }

        function loadDataCountry() {
            angular.element.blockUI();
            var response=Costcenter.query({action:'getCountry'});
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }
    
        function fetchCountry(data) {
            angular.element.unblockUI();
            vm.listCountry=data;

            if(!edt.id) {
                vm.Form.objForm.country = vm.countryLogin ? vm.countryLogin : '';
            }
        }
    
        function errorFetchCountry() {
            angular.element.unblockUI();
            vm.listCountry=[];
        }
         
        function saveData(ev,formController) {
            angular.element.blockUI();
            if(edt.id) {
                var promise= Form.updateData('updateData', formController, Costcenter, edt.id, 'viewDetail');
                promise.then(function(){
                    showDialog(ev);
                    angular.element.unblockUI();
                });
            } else {
              var response = Form.saveData('save', formController, Costcenter);
              response.then(function() {
                vm.messageTheme = 'blue';
                angular.element.unblockUI();
                formController.$setPristine();
                $timeout(function() {
                  vm.Form.tampilPesan = false;
                }, 3000);
                showDialog(ev);
                angular.element.unblockUI();
              });
              response.catch(function() {
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
              });
            }
        }

        function showDialog() {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent()
            ).then(function(){
                closeModal();
            });
        }

        function clearSearchTermCountry() {
          vm.searchTermCountry = '';
        }
    }
})();
(function() {
  'use strict';

  angular
    .module('app.master-data.cost-center')
    .controller('CostCenterController', CostCenterController);

  CostCenterController.$inject = [
    '$state',
    '$log',
    '$mdDialog',
    '$window',
    '$location',
    'config',
    'AppAPI',
    'Auth',
    'DataService',
    '$localStorage',
    '$document',
    'Form',
    '$timeout'
  ];
  //AppAPI untuk koneksi ambil data ke api
  //Auth untuk mendapatkan authentikasi mendapatkan token, setiap huCostcenterngan ke API wajib token
  //DataService untuk pagination dan datatable

  /** @ngInject */
  function CostCenterController(
    $state,
    $log,
    $mdDialog,
    $window,
    $location,
    config,
    AppAPI,
    Auth,
    DataService,
    $localStorage,
    $document,
    Form,
    $timeout
  ) {
    var vm = this;
    var Costcenter = AppAPI.Costcenter(); //memanggil api modules dari api
    var Overtime = AppAPI.Overtime();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.costType = [{id: 'all', description: 'All'}, {id: 'cnb', description: 'CNB'}, {id: 'noncnb', description: 'Non CNB'}];
    vm.selectedType = vm.costType[0].id;
    vm.DataTable = new DataService(); //inisialisasi class DataService
    Form.initialForm();
    Form.setObject(Costcenter);
    vm.Form = Form;
    vm.loadData = loadData;
    vm.editData = editData;
    vm.closeModal = closeModal;
    vm.insertData = insertData;
    vm.ExportToExcel = ExportToExcel;

    vm.Breadhome = 'app.pms_dashboard';
    vm.Breadlist = [{ link: '#', name: 'Cost Center', active: '0' }];
    vm.edit1 = false;
    vm.onCollapse = onCollapse;

    loadDataBU();

    function loadData(pageno) {
      var resp = vm.DataTable.loadData(Costcenter, pageno, {
        action: 'viewData',
        company: vm.company,
        type: vm.selectedType
      });

      resp.then(function(data) {
        angular.element.unblockUI();
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function loadDataBU() {
      angular.element.blockUI();
      var response = Overtime.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }
 
    function fetchBU(data) {
      vm.listBU = data;
      vm.company = vm.listBU[0].id;
      loadData(1);
    }

    function errorFetchBU() {
      angular.element.unblockUI();
      vm.listBU = [];
    }

    function insertData(ev, data) {
      $mdDialog.show({
        controller: 'EditCostCenterController',
        controllerAs: 'vm',
        templateUrl: 'app/main/master-data/cost-center/input-cost-center.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        locals: {
          edt: {id: null}
        }
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'EditCostCenterController',
        controllerAs: 'vm',
        templateUrl: 'app/main/master-data/cost-center/input-cost-center.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        locals: {
          edt: data
        }
      });
    }

    function ExportToExcel() {
		  var search = vm.DataTable.searchParam;
		  if(!search) 
			  search = 0;
      
      var company = vm.company;
      var type = vm.selectedType;

        var token=Auth.setTokenPromise();
          token.then(function(data){
            var protocol=$location.protocol();
            var host=$location.host();
            $window.open(protocol+'://'+host+'/'+config.api+'api/costcenter/exportexcel/' + search + '/' + type + '/' + company, '_blank');
          },function(){      
            $window.alert('gagal load token');
          });
    }

    function onCollapse() {
      if(vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
        vm.DataTable.searchParam = '';
        vm.loadData(1);
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.master-data.business-unit', ['app.master-data.business-unit.input-bu'
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.masterdata_business_unit', {
                url    : '/master-data/business-unit',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/master-data/business-unit/business-unit.html',
                        controller : 'BusinessunitController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.master-data.business-unit')
        .controller('BusinessunitController', BusinessunitController);


    BusinessunitController.$inject=['$state','$mdDialog','DTColumnDefBuilder','AppAPI','Auth'];
    /** @ngInject */
    function BusinessunitController($state,$mdDialog,DTColumnDefBuilder,AppAPI,Auth)
    {
        
        var vm = this;
         vm.listBu=[];
         vm.toggleSelectedAll=toggleSelectedAll;
         vm.listBuSelected=[];
         vm.editData=editData;
         vm.deleteBu=deleteBu;

         
        // Data
      /*  vm.employees = Employees.data;*/
       var BU=AppAPI.BU();
        viewDataBu();
        vm.dtOptions = {
           dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth : false,
            responsive: true,
            pagingType: 'full_numbers'
        };

         vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(1).notSortable()
    ];

        // Data
 
        // Methods

        //////////

        function viewDataBu() {
          angular.element.blockUI();
           var buPromise=BU.query({action:'viewdata'});
        buPromise.$promise.then(fetchDataBu);
        buPromise.$promise.catch(errorFetchBu); 
        }

        function fetchDataBu(data) {
            console.log(data);
            vm.listBu=data;
            angular.element.unblockUI();
        }

        function errorFetchBu() {
            vm.listBu=[];
            angular.element.unblockUI();
        }

       
    function toggleSelectedAll(state)
    {
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listBuSelected=angular.copy(vm.listBu);
    }

    function unCheckAll() {
       vm.listBuSelected=[];
    }

    function editData(id) {
        $state.go('app.masterdata_business_unit_edit',{id:id});
    }

    function deleteBu(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=BU.delete({action:'delete',data:angular.toJson(vm.listBuSelected)});

       response.$promise.then(viewDataBu);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }



    }
})();

(function() {
  'use strict';

  angular
    .module('app.master-data.borongan', [])
    .config(config);

  config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.masterdata_borongan', {
      url: '/master-data/borongan',
      views: {
        'content@app': {
          templateUrl: 'app/main/master-data/borongan/borongan.html',
          controller: 'BoronganController as vm'
        }
      }
    });

    // Translation
    // $translatePartialLoaderProvider.addPart('app');
  }
})();

(function () {

  'use strict';

  angular
    .module('app.master-data.borongan')
    .controller('EditBoronganController', EditBoronganController)

  EditBoronganController.$inject = [
    'DataService',
    '$state',
    'loadData',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'edit',
    '$filter',
    'dialogClose'
  ];
  /** @ngInject */
  function EditBoronganController(
    DataService,
    $state,
    loadData,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    edit,
    $filter,
    dialogClose
  ) {

    var vm = this;
    var translate = $filter('translate');
    var borongan = AppAPI.Borongan();
    vm.Form = Form;
    vm.price = edit.price;
    vm.desc = edit.description;
    vm.name = edit.borongan_name;
    vm.saveDataBorongan = updateDataBorongan;
    vm.dialogClose = dialogClose;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(borongan);
    }

    function updateDataBorongan(ev, formController) {
      angular.element.blockUI();
      vm.Form.objForm.id = edit.id;
      vm.Form.objForm.borongan_name = formController.boronganName.$viewValue;
      vm.Form.objForm.description = formController.boronganDesc.$viewValue;
      vm.Form.objForm.price = formController.boronganPrice.$viewValue;
      var response = Form.saveData('updateDataBorongan', formController, borongan);
      response.then(function (data) {
        angular.element.unblockUI();
        formController.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        formController.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('app.master-data.borongan')
    .controller('BoronganController', BoronganController)
    .directive('blurToCurrency', function ($filter) {
      return {
        scope: {
          amount: '='
        },
        link: function (scope, el, attrs) {
          el.bind('focus', function () {
            el.val(scope.amount);
          });

          el.bind('input', function () {
            scope.amount = el.val();
            scope.$apply();
          });

          el.bind('blur', function () {
            el.val($filter('currency')(scope.amount, 'Rp ', 0));
          });
        }
      };
    });

  BoronganController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    '$filter',
    'Form'
  ];
  /** @ngInject */
  function BoronganController(
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    $filter,
    Form
  ) {
    var vm = this;
    var translate = $filter('translate');
    var borongan = AppAPI.Borongan();
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.items = [];
    vm.user = $localStorage.user;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.addBorongan = addBorongan;
    vm.saveDataBorongan = saveDataBorongan;
    vm.editDataBorongan = editDataBorongan;
    vm.dialogClose = dialogClose;
    vm.price = 0;
    vm.deleteDataBorongan = deleteDataBorongan;
    vm.Form = Form;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(borongan);
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(borongan, pageno, { action: 'viewDataBorongan' });

      resp.then(function (data) {
        vm.items = data.list;
        vm.selected = [];
      });
    }

    function addBorongan(ev) {
      $mdDialog.show({
        controller: 'BoronganController',
        controllerAs: 'vm',
        templateUrl: 'app/main/master-data/borongan/input-borongan.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteDataBorongan(ev) {
      var message = translate('PAYROLL.MESSAGE.CONFDEL');
      var note = translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = borongan.delete({
              action: 'deleteDataBorongan',
              data: angular.toJson(data)
            });
            response.$promise.then(function (data) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function saveDataBorongan(ev, formController) {
      angular.element.blockUI();
      vm.Form.objForm.borongan_name = formController.boronganName.$viewValue;
      vm.Form.objForm.description = formController.boronganDesc.$viewValue;
      vm.Form.objForm.price = formController.boronganPrice.$viewValue;
      var response = Form.saveData('saveDataBorongan', formController, borongan);
      response.then(function (data) {
        angular.element.unblockUI();
        formController.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        formController.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function editDataBorongan(ev, data) {
      $mdDialog.show({
        controller: 'EditBoronganController',
        controllerAs: 'vm',
        templateUrl: 'app/main/master-data/borongan/input-borongan.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          edit: data,
          dialogClose: dialogClose,
          loadData: loadData
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function reloadToken() {
      Auth.setToken();
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    // Toggle checkbox
    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function convertMoney() {
      return vm.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.machine.product-specification', ['ui.tinymce'])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.product_spesipication', {
                url: '/product-specification',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/machine/product-specification/product-specification.html',
                        controller: 'ProductSpecificationController as vm'
                    }
                }
            });
    }
})();

(function() {
  'use strict';
  angular
    .module('app.machine.product-specification')
    .controller('ProductSpecificationController', ProductSpecificationController);

  ProductSpecificationController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth', 
    '$q',
    'filterFilter',
    'config',
    '$filter',
    '$element',
    '$http'
  ];
  /** @ngInject */
  function ProductSpecificationController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth, 
    $q,
    filterFilter,
    config,
    $filter,
    $element,
    $http
  ) {
    var vm = this;
    var endPoint = AppAPI.MacProductSpecification();
    var $translate = $filter('translate');
    
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData; 
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = []; 
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company=$localStorage.empsite;
    activate();

    function activate() {
      vm.selected = [];
    }

    vm.getProduct=getProduct;
    vm.selectedItemChanged=selectedItemChanged;
    vm.stateEdit=false;

    function selectedItemChanged(data)
    {     
        vm.product_id='';
        vm.name='';
        vm.isDisabled=false;
        vm.name=vm.searchString; 
        if(typeof data!=='undefined')
        {
          vm.product_id=data.id;
          vm.name=data.name
          vm.isDisabled=true;

        }
    }

    function getProduct(searchText)
    {
      return $http
        .get(config.api + 'api/macproductspec?action=getProduct&id=' + searchText)
        .then(function(item) {
        // Map the response object to the data object.
        if(item.data.length===''){
          vm.product_id='';
        }   
         
        return item.data;
      });
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        product_id : vm.product_id
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'ProductSpecificationInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/machine/product-specification/product-specification-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'ProductSpecificationEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/machine/product-specification/product-specification-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data : data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note    = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes     = $translate('PAYROLL.MESSAGE.YES');
      var no      = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }


      vm.clearSearchTerm = function() {
          vm.searchTerm = '';
      };
      
      $element.find('input').on('keydown', function(ev) {
          ev.stopPropagation();
      });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.machine.product-specification')
    .controller('ProductSpecificationInputController', ProductSpecificationInputController);

  ProductSpecificationInputController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'filterFilter',
    '$filter',
    '$element',
    '$http',
    'config'
  ];
  /** @ngInject */
  function ProductSpecificationInputController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    filterFilter,
    $filter,
    $element,
    $http,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.MacProductSpecification();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint); 
    vm.dialogClose = dialogClose;
    vm.saveData=saveData;

    vm.getProduct=getProduct;
    vm.selectedItemChanged=selectedItemChanged;
    vm.stateEdit=false;

    function selectedItemChanged(data)
    {     
        vm.Form.objForm.product_id='';
        vm.Form.objForm.name='';
        vm.isDisabled=false;
        vm.Form.objForm.name=vm.searchString; 
        if(typeof data!=='undefined')
        {
          vm.Form.objForm.product_id=data.id;
          vm.Form.objForm.name=data.name
          vm.isDisabled=true;

        }
    }

    vm.tinymceOptions = {
      height: 200,
      theme: 'modern',
      plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
      toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent',
      templates: [
        { title: 'template 1', content: 'Template 1' },
        { title: 'template 2', content: 'Template 2' }
      ]
    };

    activate();

    function activate() {
      vm.selected = []; 
    }

    function getProduct(searchText)
    {
      return $http
        .get(config.api + 'api/macproductspec?action=getProduct&id=' + searchText)
        .then(function(item) {
        // Map the response object to the data object.
        if(item.data.length===''){
          Form.objForm.product_id='';
        }   
         
        return item.data;
      });
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine(); 
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status  = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function() {
      vm.searchTerm = '';
  };
  
  $element.find('input').on('keydown', function(ev) {
      ev.stopPropagation();
  });
  }
})();

(function() {
    'use strict';
    angular
      .module('app.machine.product-specification')
      .controller('ProductSpecificationEditController', ProductSpecificationEditController);
  
    ProductSpecificationEditController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'data',
      'config',
      '$element',
      '$http',
      '$filter'
    ];
    /** @ngInject */
    function ProductSpecificationEditController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      data,
      config,
      $element,
      $http,
      $filter
    ) {
      var vm = this;
      var endPoint = AppAPI.MacProductSpecification();
      var $translate = $filter('translate');

      vm.Form = Form;
      vm.info = data;
      vm.saveData = updateData;
      vm.dialogClose = dialogClose;
      vm.company=$localStorage.empsite;

      vm.tinymceOptions = {
        height: 200,
        theme: 'modern',
        plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
        toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent',
        templates: [
          { title: 'template 1', content: 'Template 1' },
          { title: 'template 2', content: 'Template 2' }
        ]
      };

      activate();

      vm.getProduct=getProduct;
      vm.selectedItemChanged=selectedItemChanged;
      vm.stateEdit=false;

      function selectedItemChanged(data)
      {     
          vm.Form.objForm.product_id='';
          vm.Form.objForm.name='';
          vm.isDisabled=false;
          vm.Form.objForm.name=vm.searchString; 
          if(typeof data!=='undefined')
          {
            vm.Form.objForm.product_id=data.id;
            vm.Form.objForm.name=data.name
            vm.isDisabled=true;

          }
      }
      
      function getProduct(searchText)
      {
        return $http
          .get(config.api + 'api/macproductspec?action=getProduct&id=' + searchText)
          .then(function(item) {
          // Map the response object to the data object.
          if(item.data.length===''){
            Form.objForm.product_id='';
          }   
          
          return item.data;
        });
      }
      
      function activate() 
      {
        Form.initialForm();
        Form.setObject(endPoint);
        getProduct(data.product_name)
        vm.Form.objForm.id=data.id;
        vm.Form.objForm.name=data.product_name;
        vm.Form.objForm.product_id=data.product_id;
        vm.Form.objForm.description=data.description;
        vm.Form.objForm.spec_value=parseFloat(data.spec_value);
        vm.Form.objForm.uom=data.uom;
      }
      
      function updateData(ev, frm) 
      {
        angular.element.blockUI();
        var response = Form.saveData('update', frm, endPoint);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();

            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        var message = $translate(data.pesan);
        var status  = $translate(data.status);
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel(status)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }

      vm.clearSearchTerm = function() {
        vm.searchTerm = '';
    };
    
    $element.find('input').on('keydown', function(ev) {
        ev.stopPropagation();
    });
    }
  })();
  
(function () {
    'use strict';

    angular
        .module('app.machine.output-specification', ['ui.tinymce'])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.output_spesipication', {
                url: '/output-specification',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/machine/output-specification/output-specification.html',
                        controller: 'OutputSpecificationController as vm'
                    }
                }
            });
    }
})();

(function() {
  'use strict';
  angular
    .module('app.machine.output-specification')
    .controller('OutputSpecificationController', OutputSpecificationController);

  OutputSpecificationController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth', 
    '$q',
    'filterFilter',
    'config',
    '$filter',
    '$element',
    '$http'
  ];
  /** @ngInject */
  function OutputSpecificationController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth, 
    $q,
    filterFilter,
    config,
    $filter,
    $element,
    $http
  ) {
    var vm = this;
    var endPoint = AppAPI.MacoutputSpecification();
    var $translate = $filter('translate');
    
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData; 
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = []; 
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company=$localStorage.empsite;
    activate();

    function activate() {
      vm.selected = [];
    }

    vm.getProduct=getProduct;
    vm.selectedItemChanged=selectedItemChanged;
    vm.stateEdit=false;

    function selectedItemChanged(data)
    {     
        vm.product_id='';
        vm.name='';
        vm.isDisabled=false;
        vm.name=vm.searchString; 
        if(typeof data!=='undefined')
        {
          vm.product_id=data.id;
          vm.name=data.name
          vm.isDisabled=true;

        }
    }

    function getProduct(searchText)
    {
      return $http
        .get(config.api + 'api/macproductspec?action=getProduct&id=' + searchText)
        .then(function(item) {
        // Map the response object to the data object.
        if(item.data.length===''){
          vm.product_id='';
        }   
         
        return item.data;
      });
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        product_id : vm.product_id
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'OutputSpecificationInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/machine/output-specification/output-specification-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'OutputSpecificationEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/machine/output-specification/output-specification-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data : data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note    = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes     = $translate('PAYROLL.MESSAGE.YES');
      var no      = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function() {
      vm.searchTerm = '';
  };
  
  $element.find('input').on('keydown', function(ev) {
      ev.stopPropagation();
  });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.machine.output-specification')
    .controller('OutputSpecificationInputController', OutputSpecificationInputController);

  OutputSpecificationInputController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'filterFilter',
    '$filter',
    '$element',
    '$http',
    'config'
  ];
  /** @ngInject */
  function OutputSpecificationInputController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    filterFilter,
    $filter,
    $element,
    $http,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.MacoutputSpecification();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint); 
    vm.dialogClose = dialogClose;
    vm.saveData=saveData;
    
    
    vm.getProduct=getProduct;
    vm.selectedItemChanged=selectedItemChanged;
    vm.stateEdit=false;

    function selectedItemChanged(data)
    {     
        vm.Form.objForm.product_id='';
        vm.Form.objForm.name='';
        vm.isDisabled=false;
        vm.Form.objForm.name=vm.searchString; 
        if(typeof data!=='undefined')
        {
          vm.Form.objForm.product_id=data.id;
          vm.Form.objForm.name=data.name
          vm.isDisabled=true;

        }
    }

    function getProduct(searchText)
    {
      return $http
        .get(config.api + 'api/macproductspec?action=getProduct&id=' + searchText)
        .then(function(item) {
        // Map the response object to the data object.
        if(item.data.length===''){
          Form.objForm.product_id='';
        }   
         
        return item.data;
      });
    }

    vm.tinymceOptions = {
      height: 200,
      theme: 'modern',
      plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
      toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent',
      templates: [
        { title: 'template 1', content: 'Template 1' },
        { title: 'template 2', content: 'Template 2' }
      ]
    };

    activate();

    function activate() {
      vm.selected = []; 
    }

    loadProduct();

    function loadProduct() {
          var response=endPoint.query({action:'getProduct'});
          response.$promise.then(fetchProduct);
          response.$promise.catch(errorFetchProduct);
    }
    
    function fetchProduct(data) {
          vm.productList=data;
    }

    function errorFetchProduct() {
          vm.productList=[];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine(); 
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status  = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function() {
          vm.searchTerm = '';
      };
      
      $element.find('input').on('keydown', function(ev) {
          ev.stopPropagation();
      });
  }
})();

(function() {
    'use strict';
    angular
      .module('app.machine.output-specification')
      .controller('OutputSpecificationEditController', OutputSpecificationEditController);
  
    OutputSpecificationEditController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'data',
      'config',
      '$element',
      '$http',
      '$filter'
    ];
    /** @ngInject */
    function OutputSpecificationEditController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      data,
      config,
      $element,
      $http,
      $filter
    ) {
      var vm = this;
      var endPoint = AppAPI.MacoutputSpecification();
      var $translate = $filter('translate');

      vm.Form = Form;
      vm.info = data;
      vm.saveData = updateData;
      vm.dialogClose = dialogClose;
      vm.company=$localStorage.empsite;

      vm.tinymceOptions = {
        height: 200,
        theme: 'modern',
        plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
        toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent',
        templates: [
          { title: 'template 1', content: 'Template 1' },
          { title: 'template 2', content: 'Template 2' }
        ]
      };

      activate();

      vm.getProduct=getProduct;
      vm.selectedItemChanged=selectedItemChanged;
      vm.stateEdit=false;

      function selectedItemChanged(data)
      {     
          vm.Form.objForm.product_id='';
          vm.Form.objForm.name='';
          vm.isDisabled=false;
          vm.Form.objForm.name=vm.searchString; 
          if(typeof data!=='undefined')
          {
            vm.Form.objForm.product_id=data.id;
            vm.Form.objForm.name=data.name
            vm.isDisabled=true;

          }
      }
      
      function getProduct(searchText)
      {
        return $http
          .get(config.api + 'api/macproductspec?action=getProduct&id=' + searchText)
          .then(function(item) {
          // Map the response object to the data object.
          if(item.data.length===''){
            Form.objForm.product_id='';
          }   
          
          return item.data;
        });
      }
      
      
      function activate() 
      {
        Form.initialForm();
        Form.setObject(endPoint);
        getProduct(data.product_name)
        vm.Form.objForm.id=data.id;
        vm.Form.objForm.name=data.product_name;
        vm.Form.objForm.product_id=data.product_id;
        vm.Form.objForm.description=data.description;
        vm.Form.objForm.spec_value=parseFloat(data.spec_value);
        vm.Form.objForm.uom=data.uom;
      }
      
      function updateData(ev, frm) 
      {
        angular.element.blockUI();
        var response = Form.saveData('update', frm, endPoint);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();

            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        var message = $translate(data.pesan);
        var status  = $translate(data.status);
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel(status)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }

      vm.clearSearchTerm = function() {
        vm.searchTerm = '';
    };
    
    $element.find('input').on('keydown', function(ev) {
        ev.stopPropagation();
    });
    }
  })();
  
(function () {
    'use strict';

    angular
        .module('app.machine.machine-line', ['ui.tinymce'])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.machine_line', {
                url: '/machine-line',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/machine/machine-line/machine-line.html',
                        controller: 'MachineLineController as vm'
                    }
                }
            });
    }
})();

(function() {
  'use strict';
  angular
    .module('app.machine.machine-line')
    .controller('MachineLineController', MachineLineController);

  MachineLineController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth', 
    '$q',
    'filterFilter',
    'config',
    '$filter',
    '$http'
  ];
  /** @ngInject */
  function MachineLineController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth, 
    $q,
    filterFilter,
    config,
    $filter,
    $http
  ) {
    var vm = this;
    var endPoint = AppAPI.MachineLine();
    var $translate = $filter('translate');
    
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData; 
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = []; 
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company=$localStorage.empsite;
    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData'
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'MachineLineInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/machine/machine-line/machine-line-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'MachineLineEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/machine/machine-line/machine-line-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data : data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note    = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes     = $translate('PAYROLL.MESSAGE.YES');
      var no      = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('app.machine.machine-line')
    .controller('MachineLineInputController', MachineLineInputController);

  MachineLineInputController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'filterFilter',
    '$filter',
    '$element',
    'config'
  ];
  /** @ngInject */
  function MachineLineInputController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    filterFilter,
    $filter,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.MachineLine();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint); 
    vm.dialogClose = dialogClose;
    vm.saveData=saveData;

    vm.getGedung = loadGedung
    vm.getSector = loadSector
    vm.getLine = loadSectorLine
    
    vm.tinymceOptions = {
      height: 200,
      theme: 'modern',
      plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
      toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent',
      templates: [
        { title: 'template 1', content: 'Template 1' },
        { title: 'template 2', content: 'Template 2' }
      ]
    };

    activate();

    function activate() {
      vm.selected = []; 
    }

    loadArea();

    function loadArea() 
    {
        var response=endPoint.query({action:'getArea'});
        response.$promise.then(fetchArea);
        response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.areaList=data;
    }

    function errorFetchArea() {
      vm.areaList=[];
    }

    function loadGedung(id) {
      var response=endPoint.query({action:'getGedung',subAreaId:id});
      response.$promise.then(fetchGedung);
      response.$promise.catch(errorFetchGedung);
    }
    
    function fetchGedung(data) {
          vm.gedungList=data;
    }

    function errorFetchGedung() {
          vm.gedungList=[];
    }

    function loadSector(id) {
      var response=endPoint.query({action:'getSector',gedungId:id});
      response.$promise.then(fetchSector);
      response.$promise.catch(errorFetchSector);
    }
    
    function fetchSector(data) {
          vm.sectorList=data;
    }

    function errorFetchSector() {
          vm.sectorList=[];
    }

    function loadSectorLine(id) {
      var response=endPoint.query({action:'getGedungSectorLine',gedungSectorId:id});
      response.$promise.then(fetchSectorLine);
      response.$promise.catch(errorFetchSectorLine);
    }
    
    function fetchSectorLine(data) {
          vm.gedungSectorList=data;
    }

    function errorFetchSectorLine() {
          vm.gedungSectorList=[];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine(); 
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status  = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function() {
        vm.searchTerm = '';
    };
    
    $element.find('input').on('keydown', function(ev) {
        ev.stopPropagation();
    });
  }
})();
(function() {
    'use strict';
    angular
      .module('app.machine.machine-line')
      .controller('MachineLineEditController', MachineLineEditController);
  
    MachineLineEditController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'data',
      'config',
      '$element',
      '$filter'
    ];
    /** @ngInject */
    function MachineLineEditController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      data,
      config,
      $element,
      $filter
    ) {
      var vm = this;
      var endPoint = AppAPI.MachineLine();
      var $translate = $filter('translate');

      vm.Form = Form;
      vm.info = data;
      vm.saveData = updateData;
      vm.dialogClose = dialogClose;
      vm.company=$localStorage.empsite;

      vm.tinymceOptions = {
        height: 200,
        theme: 'modern',
        plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
        toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent',
        templates: [
          { title: 'template 1', content: 'Template 1' },
          { title: 'template 2', content: 'Template 2' }
        ]
      };

      activate();

    function loadArea() 
    {
        var response=endPoint.query({action:'getArea'});
        response.$promise.then(fetchArea);
        response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.areaList=data;
    }

    function errorFetchArea() {
      vm.areaList=[];
    }

    function loadGedung(id) {
      var response=endPoint.query({action:'getGedung',subAreaId:id});
      response.$promise.then(fetchGedung);
      response.$promise.catch(errorFetchGedung);
    }
    
    function fetchGedung(data) {
          vm.gedungList=data;
    }

    function errorFetchGedung() {
          vm.gedungList=[];
    }

    function loadSector(id) {
      var response=endPoint.query({action:'getSector',gedungId:id});
      response.$promise.then(fetchSector);
      response.$promise.catch(errorFetchSector);
    }
    
    function fetchSector(data) {
          vm.sectorList=data;
    }

    function errorFetchSector() {
          vm.sectorList=[];
    }

    function loadSectorLine(id) {
      var response=endPoint.query({action:'getGedungSectorLine',gedungSectorId:id});
      response.$promise.then(fetchSectorLine);
      response.$promise.catch(errorFetchSectorLine);
    }
    
    function fetchSectorLine(data) {
          vm.gedungSectorList=data;
    }

    function errorFetchSectorLine() {
            vm.gedungSectorList=[];
  }
      
      function activate() 
      {
        Form.initialForm();
        Form.setObject(endPoint);

        vm.Form.objForm.id=data.id;
        vm.Form.objForm.gedung_sector_line_id=data.gedung_sector_line_id;
        vm.Form.objForm.machine_name=data.machine_name;
        vm.Form.objForm.description=data.description;

        vm.area = data.sub_area_id;
        vm.gedung = data.gedung_id;
        vm.sector = data.sector_id;

        loadArea();
        loadGedung(vm.area);
        loadSector(vm.gedung);
        loadSectorLine(vm.sector);
      }
      
      function updateData(ev, frm) 
      {
        angular.element.blockUI();
        var response = Form.saveData('update', frm, endPoint);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();

            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        var message = $translate(data.pesan);
        var status  = $translate(data.status);
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel(status)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }

      vm.clearSearchTerm = function() {
          vm.searchTerm = '';
      };
      
      $element.find('input').on('keydown', function(ev) {
          ev.stopPropagation();
      });
    }
  })();
  
(function () {
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.login', {
                url: '/login',
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.login': {
                        templateUrl: 'app/main/login/login.html',
                        controller: 'LoginController as vm'
                    }
                },
                bodyClass: 'login'
            }).
            state('app.login.emplogin', {
                url: '/emplogin',
                views: {
                    'loginArea': {
                        templateUrl: 'app/main/login/emplogin.html',
                        controller: 'EmploginController as vm'
                    }
                }

            }).
            state('app.login.candidatelogin', {
                url: '/candidate',
                views: {
                    'loginArea': {
                        controller: 'CheckinloginController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/login/echeckin/echeckin.html'
                    }
                }

            })
            .state('app.login.candidategwlogin', {
                url: '/candidategw',
                views: {
                    'loginArea': {
                        controller: 'CheckingwloginCtrl',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/login/echeckingw/echeckingw.html'
                    }
                }

            })
            .state('app.login.main', {
                url: '/main',
                views: {
                    'loginArea': {
                        controller: 'MainloginController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/login/mainlogin.html'
                    }
                }

            }).state('app.login.setpassword', {
                url: '/set-password',
                views: {
                    'loginArea': {
                        controller: 'SetPasswordController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/login/set-password.html'
                    }
                }

            });

        $stateProvider.state('app.auth', {
            url: '/auth?token&id',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.auth': {
                    template: "<div>{{vm.message}}</div>",
                    controllerAs: 'vm',
                    controller: function (
                        $scope,
                        $rootScope,
                        $stateParams,
                        $state,
                        $timeout,
                        isAuthenticated
                    ) {


                        var vm = this;
                        vm.message = 'HCPORTAL SSO ... Please Wait';

                        var isauth = isAuthenticated;

                       // console.log($stateParams.id);

                        if (!isauth) {
                            vm.message = 'Invalid Token';
                            $timeout(function () {
                                //  $state.go('app.login');
                                angular.element.blockUI();
                            }, 2000);
                        } else {
                            vm.message = "Token is verified, you'll be redirected";
                            $timeout(function () {
                                //  $state.go('app.dashboard');
                            }, 2000);
                        }

                    },
                    resolve: {
                        isAuthenticated: function (
                            $state,
                            $stateParams,
                            $timeout,
                            $mdDialog,
                            jwtHelper,
                            msNavigationService,
                            sessionService,
                            $q,
                            GeneralService,
                            AppAPI,
                            Auth,
                            Newslist,
                            Newsinfo,
                            Approvalinfo,
                            LoginService
                        ) {
                             var defer = $q.defer();
                            // $timeout(function(){
                            //      defer.resolve(true); 
                            // });

                            // clear storage 
                            GeneralService.clearStorage();
                            var vm = this;
                            var news = AppAPI.News();
                            Auth.setCookie();
                            // response.then(Auth.setToken);
                            var User = AppAPI.Login();
                            vm.user = new User();
                            //vm.wrongCredentials = false;
                            //vm.login = login;
                            vm.event = null;
                            //vm.loginEcheckIn = loginEcheckIn;
                            //vm.loginEcheckInGw = loginEcheckInGw;
                            LoginService.stateLogin = "Employee";
                            // vm.showDisclaimer = showDisclaimer;


                            // Methods
                            function countUnReadNews() {
                                var response = news.get({ action: "getCountUnReadNews" });
                                response.$promise.then(fetchUnreadNews);
                                response.$promise.catch(errorFetchNewsCategory);
                            }

                            function fetchUnreadNews(data) {
                                Newsinfo.getInfoNews = data;
                            }

                            function errorFetchNewsCategory() {
                                Newsinfo.getInfoNews = {};
                            }

                            function infoApproval() {
                                var ListApproval = AppAPI.InfoApproval();
                                var lsApproval = new ListApproval();
                                var promise = lsApproval.$get({ action: "viewData" });
                                promise.then(processInfo);
                                promise.catch(errorProcessInfo);
                            }

                            function processInfo(data) {
                                // vm.data=data;
                                GeneralService.setInfoApproval(data);
                                Approvalinfo.getInfoApproval = data;
                                // console.log(vm.data);
                            }

                            function errorProcessInfo() {
                                // vm.data=[];
                                Approvalinfo.getInfoApproval = {};
                            }

                            // Methods
                            function loadDataNewsCategory() {
                                var response = news.query({ action: "viewNewsList" });
                                response.$promise.then(fetchNewsCategory);
                                response.$promise.catch(errorFetchNewsCategory);
                            }

                            function fetchNewsCategory(data) {
                                Newslist.getListNews = data;
                            }

                            function errorFetchNewsCategory() {
                                Newslist.getListNews = [];
                            }


                            try {
                                // check if token is exists
                                if ($stateParams.token) {
                                  // console.log($stateParams.token);
                                    angular.element.blockUI();
                                   // var tkn = jwtHelper.decodeToken($stateParams.token);
                                    var generate = sessionService.generateNewToken(
                                        $stateParams.token,
                                      //  tkn.iss,
                                       // tkn.data.username,
                                        $stateParams.id
                                    );
                                    // console.log('resolved', generate);

                                    generate.then(function (data) {
                                                                              // sessionService.setToken(res.tokenJWT);
                                        GeneralService.setStorage(data);
                                        vm.group = data.group;
                                        var objMenu = angular.fromJson(data.menu1);
                                        // console.log(objMenu);
                                        var jumMenu = objMenu.length,
                                            i = 0;
                                        for (i; i < jumMenu; i++) {
                                            objMenu[i].options.weight = parseInt(objMenu[i].options.weight);
                                            msNavigationService.saveItem(
                                                objMenu[i].menuname,
                                                objMenu[i].options
                                            );
                                        }

                                        switch (vm.group) {
                                            case "1":
                                                $state.go("app.app_dashboard");
                                                break;
                                            case "99":
                                                $state.go("app.login.setpassword");
                                                break;
                                            case "2":
                                            case "6":
                                            case "7":
                                            case "8":
                                                $state.go("app.app_dashboard");
                                                break;
                                            case "3":
                                                $state.go("app.app_dashboard");
                                                break;
                                            default:
                                                // $state.go('app.pms_dashboard');
                                                 $state.go("app.app_dashboard");
                                        }

                                        if (vm.group != 99) {
                                            $timeout(function () {
                                                var response = news.query({ action: "viewNewsDetail" });
                                                response.$promise.then(function () {
                                                    if (data.length > 0) {
                                                        if (data[0].doc_path != null) {
                                                            $mdDialog.show({
                                                                controller: "NewsTabController",
                                                                controllerAs: "vm",
                                                                templateUrl:
                                                                    "app/quick-panel/tabs/news/news-view-doc.html",
                                                                parent: angular.element(document.body),
                                                                clickOutsideToClose: false,
                                                                fullscreen: true,
                                                                onRemoving: function (element, removePromise) {
                                                                    countUnReadNews();
                                                                    infoApproval();
                                                                    loadDataNewsCategory();
                                                                },
                                                                locals: {
                                                                    data: data[0],
                                                                },
                                                            });
                                                        } else {
                                                            $mdDialog.show({
                                                                controller: "NewsTabController",
                                                                controllerAs: "vm",
                                                                templateUrl:
                                                                    "app/quick-panel/tabs/news/news-detail.html",
                                                                parent: angular.element(document.body),
                                                                clickOutsideToClose: false,
                                                                fullscreen: true,
                                                                onRemoving: function (element, removePromise) {
                                                                    countUnReadNews();
                                                                    infoApproval();
                                                                    loadDataNewsCategory();
                                                                },
                                                                locals: {
                                                                    data: data[0],
                                                                },
                                                            });
                                                        }
                                                    }
                                                });
                                                response.$promise.catch(function () { });
                                            }, 3000);
                                        }

                                        angular.element.unblockUI();
                                        return defer.resolve(true);
                                    });

                                    generate.catch(function (err) {
                                        console.log(err);
                                        return defer.resolve(false);
                                    });
                                }
                            } catch (error) {
                                defer.resolve(false);
                            }
                            return defer.promise;
                        }
                    }
                }
            }
        });

    }


})();
(function() {
    'use strict';

    angular
        .module('app.login')
        .controller('CheckingwloginCtrl', CheckingwloginCtrl);

       CheckingwloginCtrl.$inject=['$mdDialog','$state','AppAPI','GeneralService','Auth']

    /* @ngInject */
    function CheckingwloginCtrl($mdDialog,$state,AppAPI,GeneralService,Auth) {
         var vm = this;
         var response= Auth.setCookie();
         response.then(Auth.setToken);
         var User=AppAPI.LoginEcheckInGw();
         vm.user = new User(); 
         vm.wrongCredentials=false;
         vm.login=login;
         vm.event=null;
         vm.cancel=cancel;
      //   Auth.setToken();

        ////////////////

        function cancel() {
          $mdDialog.hide();
        }


         function login(ev) {
            angular.element.blockUI();
             vm.event=ev;

            var promise= vm.user.$save();
            promise.then(SuccessLogin,FailedLogin);
            // console.log(vm.user);
        }

        function SuccessLogin(data)
        {
                angular.element.unblockUI();
                vm.wrongCredentials=false;
                GeneralService.setStorageCheckIn(data);
                vm.group=data.group;
                 vm.user = new User(); 
                 $mdDialog.hide();
                 $state.go('app.echeckingw');

 

                             
                
        }
        function FailedLogin (rdata) {
            vm.wrongCredentials=true;
            vm.pesan=rdata.data.pesan;
            angular.element.unblockUI();
            Auth.setToken();
            vm.user = new User(); 
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.querySelector('#login')))
                .clickOutsideToClose(true)
                .title('Error Login')
                .textContent(vm.pesan)
                .ariaLabel('Error Login')
                .ok('Got it!')
                .targetEvent(vm.event)
            );
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.login')
        .controller('CheckinloginController', CheckinloginController);

       CheckinloginController.$inject=['$mdDialog','$state','AppAPI','GeneralService','Auth','LoginService']

    /* @ngInject */
    function CheckinloginController($mdDialog,$state,AppAPI,GeneralService,Auth,LoginService) {
         var vm = this;
         var response= Auth.setCookie();
         response.then(Auth.setToken);
         var User=AppAPI.LoginEcheckIn(); 
         vm.user = new User(); 
         vm.wrongCredentials=false;
         vm.login=login;
         vm.event=null;
         vm.cancel=cancel;
         Auth.setToken();
         LoginService.stateLogin='E-Check In';


        ////////////////

        function cancel() {
          $mdDialog.hide();
        }


         function login(ev) {
            angular.element.blockUI();
             vm.event=ev;

            var promise= vm.user.$save();
            promise.then(SuccessLogin,FailedLogin);
            // console.log(vm.user);
        }

        function SuccessLogin(data)
        {
                angular.element.unblockUI();
                vm.wrongCredentials=false;
                GeneralService.setStorageCheckIn(data);
                vm.group=data.group;
                 vm.user = new User(); 
                 $mdDialog.hide();
                 $state.go('app.echeckin.dashboard');    
        }
        function FailedLogin (rdata) {
            vm.wrongCredentials=true;
            vm.pesan=rdata.data.pesan;
            angular.element.unblockUI();
            Auth.setToken();
            vm.user = new User(); 
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.querySelector('#login')))
                .clickOutsideToClose(true)
                .title('Error Login')
                .textContent(vm.pesan)
                .ariaLabel('Error Login')
                .ok('Got it!')
                .targetEvent(vm.event)
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.lock_transaction.input-lock-transaction', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.lock_transaction_input_lock_transaction', {
                url    : '/lock-transaction/input-lock-transaction',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/lock-transaction/input-lock-transaction/input-lock-transaction.html',
                        controller : 'InputlocktransactionController as vm'
                    }
                }
            })

            //  .state('app.employee_employement_edit', {
            //     url    : '/employee/employement/edit-employement/:nik',
            //     views  : {
            //         'content@app': {
            //             templateUrl: 'app/main/employee/employement/input-employement/input-employement.html',
            //             controller : 'EditemployementController as vm'
            //         }
            //     }
            // });


       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/employee/employement');
      
    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.lock_transaction.input-lock-transaction')
        .controller('InputlocktransactionController', InputlocktransactionController);


    InputlocktransactionController.$inject=['$localStorage','$timeout','Form','AppAPI'];
    /** @ngInject */
    function InputlocktransactionController($localStorage,$timeout,Form,AppAPI)
    {
        
        var vm = this;

         // initial form
         Form.initialForm();

         var Employement=  AppAPI.Employement();

         // set constructor form
         Form.setObject(Employement);

         // set form to controller
         vm.Form = Form;

       
        vm.saveData=saveData;

        vm.clearMeesage=clearMeesage;

        function saveData(formController) {
            angular.element.blockUI();
         var response=Form.saveData('save', formController, Employement);

         response.then(function(){
             vm.messageTheme='blue';
             angular.element.unblockUI();
             formController.$setPristine();
             $timeout(function() {
                 vm.Form.tampilPesan=false;
             }, 3000);

         });

          response.catch(function(){
             vm.messageTheme='pink';
              angular.element.unblockUI();

         });


        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
    }
})();  

(function () {
    'use strict'

    angular
        .module('app.job_evaluation.form_job_evaluation', [])
        .config(config);

    config.$inject = ['$stateProvider', '$mdThemingProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('app.job_evaluation_input', {
                url: '/job-evaluation/input/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/job-evaluation/form/form-job-evaluation.html',
                        controller: 'InputJobEvaluationController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.job_evaluation_view', {
                url: '/job-evaluation/view/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/job-evaluation/form/view-job-evaluation.html',
                        controller: 'InputJobEvaluationController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict'

    angular
        .module('app.job_evaluation.form_job_evaluation')
        .controller('InputJobEvaluationController', InputJobEvaluationController);

    InputJobEvaluationController.$inject = ['$localStorage', '$log', '$http', '$timeout', '$stateParams', 'Form', 'AppAPI', 'config', 'Auth'];

    function InputJobEvaluationController($localStorage, $log, $http, $timeout, $stateParams, Form, AppAPI, config, Auth) {
        var vm = this;
        var JobEvaluation = AppAPI.jobEvaluation();

        Form.initialForm();
        Form.setObject(JobEvaluation);
        vm.Form = Form;
        vm.job = new JobEvaluation();
        vm.jobEvaluation = new JobEvaluation();
        vm.job.id = $stateParams.id;

        vm.saveButton = false;
        vm.sumaryButton = true;

        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.company = $localStorage.empsite;
        vm.degreeConvertion = degreeConvertion;

        vm.jobCode = "";
        vm.searchText = null;
        vm.degreeConvertionParam = null;
        vm.convert = null;

        vm.saveData = saveData;

        vm.summaryResult = summaryResult;

        vm.job.$get({
            action: 'getEvaluationFactor',
            id: vm.job.id
        });

        getConvertionParam();

        function getConvertionParam() {
            return $http
                .get(config.api + 'api/jobevaluation/convertionParam')
                .then(function (data) {
                    vm.degreeConvertionParam = data.data;
                });
        }

        function querySearch(query) {
            return $http
                .get(config.api + 'api/jobevaluation/?action=getBusinessTitleList&search=' + query)
                .then(function (item) {
                    if (item.data.length === 0) {
                        vm.searchText.employee = query;
                    }
                    return item.data;
                });
        }

        function selectedItemChange(item) {
            vm.job.ndc_business_title_id = item.id;
            $log.info('Item changed to ' + JSON.stringify(item));
        }

        function degreeConvertion(degree, idx, idxd, e) {
            if (e.keyCode === 13) {
                var convert = getConvertion(degree);
                vm.job.factor[idx].subFactor[idxd].convertion = convert.convertion;

                getPoints(idx);
            }
        }

        function getConvertion(degree) {
            var convert = {};
            angular.forEach(vm.degreeConvertionParam, function (obj) {
                if (obj.degree == degree) {
                    convert = obj;
                }
            });

            return convert;
        }

        function getPoints(idx) {
            var x = "";
            var y = "";
            switch (idx) {
                case 0:
                    y = vm.job.factor[idx].subFactor[1].degree;
                    x = vm.job.factor[idx].subFactor[2].degree;
                    break;

                default:
                    y = vm.job.factor[idx].subFactor[0].degree;
                    x = vm.job.factor[idx].subFactor[1].degree;
                    break;
            }

            var responses = vm.jobEvaluation.$get({
                action: 'getPoints',
                y: y,
                x: x,
                level: vm.job.factor[0].subFactor[0].degree,
                factor: idx
            });

            responses.then(function (data) {
                vm.job.factor[idx].points = data.point;
            });
            responses.catch(function () {
                $log.info("point error");
            });
        }

        function summaryResult() {
            var totalPoint = 0;

            for (var i = 0; i < vm.job.factor.length; i++) {
                totalPoint += parseInt(vm.job.factor[i].points);
            }

            var responses = vm.jobEvaluation.$get({
                action: 'getSummary',
                totalPoints: totalPoint
            });

            responses.then(function (data) {
                vm.job.total_point = data.total_point;
                vm.job.position_class = data.position;
                vm.job.grade = data.grade;

                vm.saveButton = true;
            });
            responses.catch(function () {
                $log.info("point error");
            });
        }

        function saveData() {
            angular.element.blockUI();
            var promise = Auth.setToken();

            promise.then(function () {
                vm.jobEvaluation.action = "save";
                vm.jobEvaluation.data = vm.job;
                var response = vm.jobEvaluation.$save();

                vm.Form.tampilPesan = true;

                response.then(function () {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    vm.Form.pesan = "Success";

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 3000);

                });

                response.catch(function () {
                    vm.messageTheme = 'pink';
                    angular.element.unblockUI();
                });

            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.jic.emp_jic')
        .controller('EmpJicController', EmpJicController)
        .filter('capitalize', function () {
            return function (input) {
                return input.toUpperCase();
            }
        });


    EmpJicController.$inject = ['$state', '$localStorage', '$mdDialog', 'AppAPI', 'DataService', 'Form', '$filter', 'Auth'];
    /** @ngInject */
    function EmpJicController($state, $localStorage, $mdDialog, AppAPI, DataService, Form, $filter, Auth) {
        var vm = this;
        var EmpJic = AppAPI.EmpJic();
        var $translate = $filter('translate');

        Form.initialForm();
        Form.setObject(EmpJic);
        vm.Form = Form;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.lookupStafEmployee = lookupStafEmployee;
        vm.openInputEmployee = openInputEmployee;
        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.listData = [];
        vm.showAdd = showAdd;
        vm.company = $localStorage.empsite;
        vm.groupLogin = $localStorage.group;
        vm.user = $localStorage.user;
        vm.showPrint = showPrint;
        vm.isAllowPrint = isAllowPrint;
        vm.goToDetail = goToDetail;
        vm.isAdminPersonel = isAdminPersonel;
        vm.showDelegasi = showDelegasi;
        vm.classForStatus = classForStatus;
        vm.printPDF = printPDF;
        vm.addComma = addComma;
        vm.sort = {};
        vm.sortColumn = '';
        vm.sortOrder = '';
        vm.setSortBy = setSortBy;
        vm.isLoading = false;

        vm.filter = {
            start_date: null,
            end_date: null,
            action_type: null,
            approval_status: null
        }

        vm.approval_status_list = [{
            id: 1,
            desc: 'Waiting'
        },
        {
            id: 2,
            desc: 'Complete'
        },
        {
            id: 3,
            desc: 'Revised'
        },
        {
            id: 4,
            desc: 'Reject'
        }];

        function setSortBy(col, by) {
            vm.sort = {};
            if (by === 'asc') {
                by = 'desc';
            } else {
                by = 'asc';
            }
            vm.sort[col] = by;
            vm.sortColumn = col;
            vm.sortOrder = by;

            loadData();

        }

        function addComma(idx, actions) {
            if (idx < (actions.length - 1)) {
                return ', ';
            } else {
                return '';
            }
        }

        function classForStatus(status) {
            var colorClass = '';
            switch (status) {
                case '0':
                    colorClass = 'orange-700-fg';
                    break;
                case '1':
                    colorClass = 'green-700-fg';
                    break;
                case '2':
                    colorClass = 'red-700-fg';
                    break;
                default:
                    colorClass = '';
                    break;
            }
            return colorClass;
        }

        function printPDF() {
            $state.goNewTab("app.report.jic.sk_demosi");
        }

        activate();

        function activate() {
            loadData(1);
        }

        function isAllowApprove(isAllow) {
            if (isAllow > 0) {
                return true;
            }
            return false;
        }

        function isAllowPrint(item) {
            if ((item.diperiksa > 0 && item.diperiksa_pending > 0) ||
                (item.mengetahui > 0 && item.mengetahui_pending > 0) ||
                (item.menyetujui > 0 && item.menyetujui_pending > 0)
            ) {
                return true;
            }
            return false;
        }

        function isAdminPersonel() {
            if ($localStorage.group == 10) {
                return true;
            }
            return false;
        }

        function loadData(pageno) {
            vm.isLoading = true;
            var response = vm.DataTable.loadData(EmpJic, pageno, {
                action: 'viewdata',
                company: vm.company,
                sortColumn: vm.sortColumn,
                sortOrder: vm.sortOrder,
                search: vm.search,
                filter: vm.filter
            });
            response.then(function (data) {
                vm.isLoading = false;
            });
            response.catch(function (error) {
                vm.isLoading = false;
            });
        }

        function openInputEmployee(ev) {
            $mdDialog.show({
                controller: 'EmployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/input-employe-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true
            });
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, EmpJic);
            promise.then(function () {
                showDialog(ev);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function goToDetail(ev, idx, item) {
            $state.go('app.emp_jic.approval', {
                id: item.id
            });
        }

        function showPrint(ev, idx, item) {
            $mdDialog.show({
                controller: 'EmpJicPrintSKController',
                controllerAs: 'vm',
                templateUrl: 'app/main/jic/empjic/print-sk/print-sk.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    pengajuanData: item
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                },
            });

        }

        function showDelegasi(ev, idx, item) {
            $mdDialog.show({
                controller: 'EmpJicDelegasiController',
                controllerAs: 'vm',
                templateUrl: 'app/main/jic/empjic/delegasi/delegasi.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    pengajuanData: item
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                },
            });

        }

        function showAdd(ev) {
            $state.go('app.emp_jic_add');
        }

        function loadDataDepartment(iddivisi) {
            var response = EmpJic.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = EmpJic.get({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = EmpJic.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
            loadDataDivision(vm.company);
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = EmpJic.query({
                action: 'viewSubArea'
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        function lookupStafEmployee(ev) {
            $mdDialog.show({
                controller: 'EmpJicLookupStafEmployeeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/jic/empjic/lookup-employee.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {

                }
            });
        }
        getDropdownActionType();
        function getDropdownActionType() {
            angular.element.blockUI();
            var promises = EmpJic.query({
                action: 'viewActions',
            });
            promises.$promise.then(fetchDataActionType);
            promises.$promise.catch(errorFetch);
        }

        function fetchDataActionType(data) {
            vm.action_type_list = [];
            vm.action_type_list = data;
        }


        function errorFetch() {
            angular.element.unblockUI();
        }

        vm.showRevisied = showRevisied;

        function showRevisied(ev, idx, id) {
            $state.go('app.emp_jic_revisied', {
                id: id,
            });
        }

        vm.deleteJic = deleteJic;

        function deleteJic(ev, idx, ls) {
            var message = $translate('PAYROLL.MESSAGE.CONFDEL');
            var note = $translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = $translate('PAYROLL.MESSAGE.YES');
            var no = $translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(
                    function () {
                        var data = [];
                        data.push({ pengajuan_id: ls.id, pengajuan_employee_id: ls.status.pengajuan_employee_id });
                        angular.element.blockUI();
                        var response = EmpJic.delete({
                            action: 'deletePengajuan',
                            data: angular.toJson(data)
                        });
                        response.$promise.then(function (resp) {
                            dialogClose();
                            angular.element.unblockUI();
                            showDialogInfo(ev, resp);
                        }).catch(function (error) {
                            angular.element.unblockUI();
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialogInfo(ev, data) {
            var message = $translate(data.pesan);
            var status = $translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.jic.approval', [])
        .config(config);

    /** @ngInject */
    config.$inject = ['$stateProvider'];

    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.emp_jic.approval', {
                url: '/jic/approval/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/jic/approval/approval.html',
                        controller: 'JicApprovalController as vm'
                    }
                },
                params: {
                    obj: null
                }
            });
    }
})();

(function () {
    "use strict";
    angular
        .module("app.jic.approval")
        .controller("JicApprovalController", Controller)
        .directive('stickyText', function ($mdSticky, $compile) {
            var SELECT_TEMPLATE =
                '<div>Just for test</div>';

            return {
                restrict: 'E',
                replace: true,
                template: SELECT_TEMPLATE,
                link: function (scope, element) {
                    $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
                }
            };
        });

    Controller.$inject = [
        "$state",
        "$stateParams",
        "$window",
        "$localStorage",
        "$document",
        "$mdDialog",
        "AppAPI",
        "DataService",
        "config",
        "Auth",
        "Form",
        "$log",
        "$timeout",
        "$http"
    ];
    /** @ngInject */
    function Controller(
        $state,
        $stateParams,
        $window,
        $localStorage,
        $document,
        $mdDialog,
        AppAPI,
        DataService,
        config,
        Auth,
        Form,
        $log,
        $timeout,
        $http
    ) {
        var vm = this;
        var EmpJic = AppAPI.EmpJic();

        vm.pengajuan_id = $stateParams.id;
        vm.DataTable = new DataService();
        vm.DataTable.jumDataPerPage = 5;
        vm.DataTable.searchParam = "";

        Form.initialForm();
        Form.setObject(EmpJic);

        vm.Form = Form;
        vm.cancel = cancel;

        vm.allowBusinessTitle = false;
        vm.allowJobTitle = false;
        vm.allowSalaryAdjustment = false;
        vm.allowSubareaBaru = false;

        vm.lamaMasaActing = 6;
        vm.acting_start = new Date();
        vm.acting_end = new Date();
        // vm.valid_date = new Date();

        vm.selectedEmployee = {};
        vm.isSelected = false;
        vm.isLoadEmployee = false;
        vm.selectEmployee = selectEmployee;
        vm.approve = approve;
        vm.switchApprovalStatus = switchApprovalStatus;
        vm.loadList = false;
        vm.approvalType = [];
        vm.filterApproval = null;
        vm.loadData = loadData;
        vm.poolActions = [];
        vm.actionsLists = [];
        vm.isAdminPersonel = isAdminPersonel;
        vm.setMasaActing = setMasaActing;
        vm.isPersonalia = false;
        vm.isApprovedAll = isApprovedAll;
        vm.saveEffectiveDate = saveEffectiveDate;
        vm.diAjukanUntuk = '';
        vm.is_assessment_required = 0;
        vm.is_unbudgeted = 0;
        vm.showEdit = showEdit;
        vm.isAllowApproval = false;
        vm.addComma = addComma;
        vm.isSubmit = false;
        vm.isPromosi = false;
        vm.isMutasi = false;

        activate();

        vm.originGrades = ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A', '6B', '6C', '7'];
        vm.grades = angular.copy(vm.originGrades);

        function activate() {
            loadReasons(vm.pengajuan_id);
            loadActionsData();
            loadDataApprovedAs();
            loadBuData();
        }

        // function uppercase(str) {
        //     return angular.uppercase(str);
        // }

        function checkIsPersonalia() {
            var response = EmpJic.get({
                action: "isApprovalAdmin",
                nik: $localStorage.user,
                pengajuan_employee_id: vm.selectedEmployee.id
            });
            response.$promise.then(function (res) {
                console.log("res", res);
                if (res == "1") {
                    vm.isPersonalia = true;
                }
            });
            response.$promise.catch(function (err) {
                vm.isPersonalia = false;
            });
        }

        function isApprovedAll(item) {
            if (item.approval_status == 1 && item.is_last_approval == 1) {
                return true;
            }
            return false;
        }

        function isAdminPersonel() {
            if (vm.selectedEmployee.approval_type === 'hc-spv' || vm.isPersonalia == true) {
                return true;
            }
            return false;
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function loadData(pageno) {
            var response = vm.DataTable.loadData(EmpJic, pageno, {
                action: "getEmployeeProposedList",
                pengajuanId: vm.pengajuan_id,
                approval_type: vm.filterApproval
            });

            response.then(function (data) {
                // initial select first employee
                selectEmployee(vm.DataTable.list[0]);
                // console.log('data', data);

                // if (vm.valid_date) {
                //     setMasaActing();
                // }
                // vm.selectedJobTitle = vm.DataTable.list[0].job_title[0];


                vm.isLoadingLoadEmployee = false;
            });

            response.catch(function (error) {
                vm.employeeLists = [];
                vm.isLoadingLoadEmployee = false;
            });
        }

        function loadDataApprovedAs() {
            var dataPromise = EmpJic.query({
                action: "getDataApprovedAs",
                pengajuanID: vm.pengajuan_id
            });
            dataPromise.$promise.then(function (rdata) {

                console.log(rdata[0]);

                if (typeof (rdata) != 'undefined' && typeof (rdata[0]) != 'undefined') {
                    vm.approvalType = rdata;
                    vm.filterApproval = vm.approvalType[0].approval_type;
                    console.log(vm.approvalType);
                }

                loadData(1);

            });
            dataPromise.$promise.catch(function (err) {
                console.log("error loadDataApprovedAs", err);
            });
        }

        function loadReasons(pengajuan_id) {
            var dataPromise = EmpJic.query({
                action: "getPengajuanReasons",
                id: pengajuan_id
            });
            dataPromise.$promise.then(function (rdata) {
                if (typeof rdata !== "undefined") {
                    vm.reasonsLists = rdata;
                    // console.log(vm.reasonsLists)
                }
            });
            dataPromise.$promise.catch(function (err) {
                console.log("error loadReasons", err);
            });
        }

        function selectEmployee(item) {
            vm.isSelected = true;
            setValue(item);
            actionsMapping(item);
            vm.loadList = false;
        }

        function loadActionsData() {
            var dataPromise = EmpJic.query({
                action: "viewActions"
            });
            dataPromise.$promise.then(function (rdata) {
                if (typeof rdata !== "undefined") {
                    rdata.find(function (val) {
                        val.checked = false;
                        val.disabled = true;
                    });
                    vm.poolActions = rdata;
                }
                vm.isLoadEmployee = false;
            });

            dataPromise.$promise.catch(function (err) { });
        }

        function actionsMapping(item) {
            var actions = angular.copy(vm.poolActions);
            vm.actionsLists = [];
            // console.log('actions', actions);
            // console.log('itemActions', item);
            item.actions.map(function (val) {
                actions.map(function (act) {
                    if (act.id == val.action_id) {
                        act.checked = true;
                        vm.actionsLists.push(act);
                    }

                    if (3 == val.action_id) {
                        vm.isMutation = 1;
                    }
                });
            });
            vm.isLoadEmployee = false;
        }

        function setValue(data) {

            vm.selectedEmployee = data;
            vm.lamaMasaActing = vm.selectedEmployee.lama_masa_acting;

            vm.is_assessment_required = vm.selectedEmployee.is_assessment_required;

            vm.diAjukanUntuk = '';
            for (var i = 0; i <= (vm.selectedEmployee.actions.length - 1); i++) {
                vm.diAjukanUntuk += vm.selectedEmployee.actions[i].name + ', ';
                if (vm.selectedEmployee.actions[i].action_id == '1') {
                    vm.isPromosi = true;
                }
                if (vm.selectedEmployee.actions[i].action_id == '3') {
                    vm.isMutasi = true;
                }
            }
            vm.diAjukanUntuk = vm.diAjukanUntuk.substring(0, vm.diAjukanUntuk.length - 2);

            if (vm.selectedEmployee.outstandingApproval) {
                if (vm.selectedEmployee.outstandingApproval.nik == $localStorage.user && vm.selectedEmployee.outstandingApproval.status == '1') {
                    vm.isAllowApproval = true;
                }
            }

            checkIsPersonalia();

            if (vm.selectedEmployee.approval_type === 'hc-spv') {
                vm.absensi = vm.selectedEmployee.absensi
                    ? JSON.parse(vm.selectedEmployee.absensi)
                    : {
                        ijin: vm.selectedEmployee.izin,
                        sakit: vm.selectedEmployee.sakit,
                        alpha: vm.selectedEmployee.alpha
                    };
            } else {
                vm.absensi = vm.selectedEmployee.absensi
                    ? JSON.parse(vm.selectedEmployee.absensi)
                    : {
                        ijin: 0,
                        sakit: 0,
                        alpha: 0
                    };
            }

            vm.konduiteAddition = {
                teguran: vm.selectedEmployee.teguran
                    ? vm.selectedEmployee.teguran
                    : "",
                surat_peringatan: vm.selectedEmployee.surat_peringatan
                    ? vm.selectedEmployee.surat_peringatan
                    : ""
            };

            if (data.masa_acting_awal) {
                vm.acting_start = new Date(data.masa_acting_awal);
            } else {
                vm.acting_start = "";
            }
            if (data.masa_acting_akhir) {
                vm.acting_end = new Date(data.masa_acting_akhir);
            } else {
                vm.acting_end = "";
            }

            if (data.masa_berlaku !== null) {
                vm.valid_date = new Date(data.masa_berlaku);
            } else {
                vm.valid_date = '';
            }

            vm.konduitePeriode = {
                start: vm.selectedEmployee.awal_periode
                    ? new Date(vm.selectedEmployee.awal_periode)
                    : new Date(vm.selectedEmployee.tgl_konduite_awal),
                end: vm.selectedEmployee.akhir_periode
                    ? new Date(vm.selectedEmployee.akhir_periode)
                    : new Date(vm.selectedEmployee.tgl_konduite_akhir)
            };

            vm.Form.objForm.tgl_pengajuan = new Date(
                vm.selectedEmployee.tgl_pengajuan
            );

            vm.Form.objForm.job_title = data.job_title;

            vm.Form.objForm.bu = data.bu;

            vm.Form.objForm.division_id = data.division_id;
            vm.Form.objForm.department_baru_id = data.department_baru_id;

            loadDataDivision(vm.Form.objForm.bu);
            loadDataDepartment(vm.Form.objForm.division_id, true);

            vm.isLoadEmployee = true;

            setTimeout(function () {
                vm.promotion_allowance = vm.selectedEmployee.allowance;
            }, 200);
        }

        function getKonduteStart() {
            var tp = angular.copy(vm.selectedEmployee.tgl_pengajuan);
            var mundur_6bulan = moment(tp).subtract(6, "months");
            var kondute_start = new Date(mundur_6bulan);
            return kondute_start;
        }

        function showActionTypeField(id) {
            switch (parseInt(id)) {
                case 1:
                    vm.allowBusinessTitle = true;
                    break;
                case 2:
                    vm.allowJobTitle = true;
                    break;
                case 3:
                    vm.allowGolonganBaru = true;
                    break;
                case 4:
                    vm.allowSalaryAdjustment = true;
                    break;
                case 7:
                    vm.allowSubareaBaru = true;
                    break;
                default:
                    vm.allowBusinessTitle = false;
                    vm.allowJobTitle = false;
                    vm.allowSalaryAdjustment = false;
                    vm.allowSubareaBaru = false;
                    break;
            }
        }

        function switchApprovalStatus(status) {
            var response = {};
            switch (status) {
                case "1":
                    response.text = "APPROVED";
                    response.style = {
                        color: "#0f82b4",
                        "transform-text": "Uppercase",
                        "font-weight": 500
                    };
                    break;
                case "2":
                    response.text = "REJECTED";
                    response.style = {
                        color: "#9c0025",
                        "transform-text": "Uppercase",
                        "font-weight": 500
                    };
                    break;
                default:
                    response.text = "PENDING";
                    response.style = {
                        color: "#a2652b",
                        "transform-text": "Uppercase",
                        "font-weight": 500
                    };
            }
            return response;
        }

        function addComma(idx, actions) {
            console.log('actions', actions);
            if (actions) {
                if (idx < (actions.actions.length - 1)) {
                    return ', ';
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }

        function approve(ev, type) {
            vm.loadList = true;
            switch (type) {
                case 0:
                case 1:
                case 2:
                    updateData(ev, type, "-");
                    break;
                case 3:
                    showFormNotesRevised(ev, type);
                    // updateData(ev, type, "-");
                    break;
                case 4:
                    showFormNotes(ev, type);
                    break;
            }
        }

        function showFormNotes(ev, type) {
            var confirm = $mdDialog
                .prompt()
                .title("Would you give a notes?")
                .textContent("write a reject notes")
                .placeholder("notes")
                .ariaLabel("notes")
                .initialValue("-")
                .targetEvent(ev)
                .ok("OK")
                .cancel("NO");

            $mdDialog.show(confirm).then(
                function (result) {
                    updateData(ev, type, result);
                },
                function () {
                    updateData(ev, type, "no rejected comment");
                }
            );
        }

        function showFormNotesRevised(ev, type) {
            var confirm = $mdDialog
                .prompt()
                .title("Would you give a notes?")
                .textContent("write a revised notes")
                .placeholder("notes")
                .ariaLabel("notes")
                .initialValue("-")
                .targetEvent(ev)
                .ok("OK")
                .cancel("NO");

            $mdDialog.show(confirm).then(
                function (result) {
                    if (result != undefined && result != '' && result != '-') {
                        updateData(ev, type, result);
                    } else {
                        alert("Noted is required ");
                    }
                },
                function () {
                    // updateData(ev, type, "no revised comment");
                }
            );
        }

        function setMasaActing() {
            vm.acting_start = vm.valid_date;
            var tp = angular.copy(vm.acting_start);
            if (tp) {
                if (!vm.lamaMasaActing) {
                    vm.lamaMasaActing = 6;
                }
                var tglMasaActing = moment(tp).add(vm.lamaMasaActing, "months");
                tglMasaActing = moment(tglMasaActing).subtract(1, "days");
                var acting_end = new Date(tglMasaActing);
                vm.acting_end = acting_end;
            }
        }

        function saveEffectiveDate(e) {
            var setToken = Auth.setToken();
            setToken.then(function () {
                var temp_acting_start = angular.copy(vm.acting_start);
                var temp_acting_end = angular.copy(vm.acting_end);
                var temp_valid_date = angular.copy(vm.valid_date);
                var updateEffectiveDate = EmpJic.save({
                    action: "updateEffectiveDate",
                    pengajuan_id: vm.selectedEmployee.pengajuan_id,
                    pengajuan_employee_id: vm.selectedEmployee.pengajuan_employee_id,
                    masa_acting_awal: moment(temp_acting_start).format("YYYY-MM-DD"),
                    masa_acting_akhir: moment(temp_acting_end).format("YYYY-MM-DD"),
                    masa_berlaku: moment(temp_valid_date).format("YYYY-MM-DD"),
                });
                updateEffectiveDate.$promise.then(function (data) {
                    showDialog(e, data);
                });
                updateEffectiveDate.$promise.catch(function (data) {
                    showDialog(e, data);
                });
            });
            setToken.catch(function (err) {
                console.log(err);
            });
        }

        function updateData(e, type, notes) {

            vm.isSubmit = true;

            var isMutation = false;
            var n = vm.selectedEmployee.actions.length;
            for (var i = 0; i <= (n - 1); i++) {
                var action = vm.selectedEmployee.actions[i];
                if (action.action_id === 3) {
                    isMutation = true;
                }
            }

            var temp_acting_start = angular.copy(vm.acting_start);
            var temp_acting_end = angular.copy(vm.acting_end);
            var temp_valid_date = angular.copy(vm.valid_date);
            if (typeof (vm.konduitePeriode) != undefined) {
                var temp_start_periode = angular.copy(vm.konduitePeriode.start);
            }
            if (typeof (vm.konduitePeriode) != undefined) {
                var temp_end_periode = angular.copy(vm.konduitePeriode.end);
            }

            var konduite = {
                konduite_id: vm.selectedEmployee.konduite_id
                    ? vm.selectedEmployee.konduite_id
                    : 0,
                pengajuan_approval_id:
                    vm.selectedEmployee.pengajuan_approval_id,
                awal_periode: moment(temp_start_periode).format("YYYY-MM-DD"),
                akhir_periode: moment(temp_end_periode).format("YYYY-MM-DD"),
                absensi: JSON.stringify(vm.absensi),
                teguran: vm.konduiteAddition.teguran,
                surat_peringatan: vm.konduiteAddition.surat_peringatan,
                lama_masa_acting: vm.lamaMasaActing,
                masa_acting_awal: moment(temp_acting_start).format(
                    "YYYY-MM-DD"
                ),
                masa_acting_akhir: moment(temp_acting_end).format("YYYY-MM-DD"),
                masa_berlaku: moment(temp_valid_date).format("YYYY-MM-DD"),
                pengajuan_id: vm.selectedEmployee.pengajuan_id,
                pengajuan_employee_id: vm.selectedEmployee.pengajuan_employee_id,
            };

            var setToken = Auth.setToken();

            setToken.then(function () {
                var store = EmpJic.save({
                    action: "updateApprovalPengajuan",
                    action_type: vm.selectedEmployee.action_type,
                    pengajuan_id: vm.selectedEmployee.pengajuan_id,
                    pengajuan_approval_id:
                        vm.selectedEmployee.pengajuan_approval_id,
                    pengajuan_employee_id:
                        vm.selectedEmployee.pengajuan_employee_id,
                    is_last_approval: vm.selectedEmployee.is_last_approval,
                    notes: notes,
                    nik: vm.selectedEmployee.nik,
                    nik_atasan: vm.selectedEmployee.nik_atasan,
                    status: type,
                    approval_type: vm.selectedEmployee.approval_type,
                    approval_level: vm.selectedEmployee.approval_level,
                    approval_emp_job_id: vm.selectedEmployee.emp_job_pla_id
                        ? vm.selectedEmployee.emp_job_pla_id
                        : 0,
                    approval_sub_area_id: vm.selectedEmployee
                        .approval_sub_area_id
                        ? vm.selectedEmployee.approval_sub_area_id
                        : 0,
                    approval_employement_id: vm.selectedEmployee
                        .approval_employement_id
                        ? vm.selectedEmployee.approval_employement_id
                        : 0,
                    subarea_baru_id: vm.selectedEmployee.subarea_baru_id
                        ? vm.selectedEmployee.subarea_baru_id
                        : 0,
                    subarea_id: vm.selectedEmployee.subarea_baru_id
                        ? vm.selectedEmployee.subarea_baru_id
                        : 0,
                    konduite: konduite,
                    promotion_allowance: vm.promotion_allowance,
                    is_assessment_required: vm.is_assessment_required,
                    is_unbudgeted: vm.is_unbudgeted,
                    is_mutation: isMutation,
                    department_baru_id: vm.selectedEmployee.department_baru_id,
                    old_division_id: vm.selectedEmployee.old_division_id,
                    old_department_id: vm.selectedEmployee.old_department_id,
                    country: vm.selectedEmployee.country,
                    entity_id: vm.selectedEmployee.entity_id,
                    company_id: vm.selectedEmployee.company_id,
                    division_id: vm.selectedEmployee.division_id,
                    grade_baru: vm.selectedEmployee.grade_baru,
                    emp_grade_lama: vm.selectedEmployee.emp_grade,
                    job_title_baru: vm.Form.objForm.job_title,
                    nik_atasan_baru: vm.selectedEmployee.nik_atasan_baru,
                    subAreaBaru : {'company_id':vm.selectedEmployee.company_id_baru,'subarea_id':vm.selectedEmployee.subarea_baru_id}
                });

                store.$promise.then(function (data) {
                    showDialog(e, data);
                    vm.isSubmit = false;
                });

                store.$promise.catch(function (data) {
                    showDialog(e, data);
                    vm.isSubmit = false;
                });
            });

            setToken.catch(function (err) {
                console.log(err);
                vm.isSubmit = false;
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.pesan)
                        .ariaLabel(data.title)
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function () {
                    closeModal();
                });
        }

        function closeModal() {
            $mdDialog.hide();
            loadData(1);
            $state.go("app.emp_jic");
        }

        function showEdit(ev, idx, id) {
            $state.go('app.emp_jic_edit', {
                id: id,
            });
        }
        vm.selectedItemChange = selectedItemChange;
        function selectedItemChange(item) {
            if (item) {
                // vm.Form.objForm.job_title = item;
                // vm.Form.objForm.department_baru_id = item.department_id;
                // vm.Form.objForm.department_name = item.department_name;
                // vm.Form.objForm.division_id = item.division_id;
                // vm.Form.objForm.division_name = item.division_name;
                // loadListAtasanBaru(item);
            }
        }

        vm.querySearch = querySearch;
        vm.isMutation = 0;

        function querySearch(params) {
            return $http
                .get(config.api + 'api/jic/empjic?action=getDataListLayer_rev&search=' + params +
                    '&isMutation=' + vm.isMutation +
                    '&nik=' + vm.selectedEmployee.nik_atasan +
                    '&bu=' + vm.selectedEmployee.entity_id
                )
                .then(function (item) {
                    return item.data;
                });
        }

        vm.loadDataDivision = loadDataDivision;

        function loadDataDivision(idbu) {
            vm.saveProcess = true;
            var response = EmpJic.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            vm.saveProcess = false;
            // vm.listDivision.push(data); 
            // loadData(1); 
        }

        function errorDivisiBU() {
            vm.listDivision = [];
            vm.saveProcess = false;
        }

        vm.loadDataDepartment = loadDataDepartment;

        function loadDataDepartment(iddivisi, isChange) {
            vm.saveProcess = true;
            if (isChange) {
                vm.listJobTitle = [];
                vm.Form.objForm.jobTitle = 'set';
            }
            var response = EmpJic.query({ action: 'viewDivisiDept', idbu: vm.Form.objForm.bu, iddivisi: iddivisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            vm.saveProcess = false;
        }

        function errorDepartment() {
            vm.listDepartment = [];
            vm.saveProcess = false;
        }

        vm.lookupEmployee = lookupEmployee;

        function lookupEmployee(ev) {

            ev.preventDefault();

            var dialog = $mdDialog.show({
                controller: 'EmpJicLookupEmployeeAtasanController',
                controllerAs: 'vm',
                templateUrl: 'app/main/jic/empjic/add/lookup-atasan/lookup-atasan.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    id: { company: vm.selectedEmployee.bu, divisi: vm.selectedEmployee.division_id, department: vm.selectedEmployee.department_baru_id }
                }
            }).then(function (response) {
                if (response) {
                    vm.selectedEmployee.nik_atasan_baru = response.nik;
                    vm.Form.objForm.nik_atasan_baru = response.nik;
                    vm.selectedEmployee.nama_atasan_baru = response.nama;
                }
            }).catch(function (responseIfRejected) {

            }).finally(function () {
            });
        }

        vm.lookupJobTitle = lookupJobTitle;

        function lookupJobTitle(ev) {
            vm.isLayerOverlap = false;
            $mdDialog.show({
                controller: 'LookUpLayerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/jic/empjic/add/lookup-layer/lookup-layer.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {

                },
                locals: {
                    id: { company: vm.Form.objForm.bu, divisi: vm.Form.objForm.division_id, department: vm.Form.objForm.department_baru_id, directReport: vm.selectedEmployee.nik_atasan_baru, disable: true }
                }
            }).then(function (response) {
                console.log(response);
                if (response) {
                    vm.Form.objForm.job_title = response;
                    vm.Form.objForm.department_name = response.department_name;
                    vm.Form.objForm.division_name = response.division_name;

                    vm.Form.objForm.division_id = response.filter.division_id;
                    vm.Form.objForm.department_baru_id = response.filter.department_id;
                    loadDataDivision(vm.Form.objForm.bu);
                    loadDataDepartment(vm.Form.objForm.division_id, false);
                }
            }).catch(function (responseIfRejected) {

            }).finally(function () {
            });
        }

        function loadBuData() {
            var dataPromise = EmpJic.query({
                action: 'viewBu'
            });
            dataPromise.$promise.then(function (rdata) {
                // console.log('rdata', rdata);
                if (typeof (rdata) !== 'undefined') {
                    vm.buLists = [];
                    rdata.find(function (val) {
                        val.checked = false;
                        vm.buLists.push(val);
                    });
                }
            });
            dataPromise.$promise.catch(function (err) {

            });
        }


    }

})();

(function(){
  'use strict';

  angular
    .module('app.insurance.insurance-type',[] )
    .config(config);
  config.$inject = ['$stateProvider'];
  /** @ngInject **/

  function config($stateProvider) {

    // State list type
    $stateProvider
      .state('app.insurance_insurance-type_list',{
        url : '/insurance/type/list',
        views : {
          'content@app' : {
            templateUrl: 'app/main/insurance/insurance-type/insurance-type.html',
            controller : 'InsuranceTypeController as vm'
          },
        }
      });


    // State input type
    $stateProvider
      .state('app.insurance_insurance-type_input',{
        url   : '/insurance/type/input',
        views : {
          'content@app' : {
            templateUrl : 'app/main/insurance/insurance-type/input-insurance-type.html',
            controller  : 'InputInsuranceTypeController as vm'
          },
        }
      });

    // State edit type
    $stateProvider
      .state('app.insurance_insurance-type_edit', {
          url    : '/insurance/type/edit/:id',
          views  : {
              'content@app': {
                templateUrl: 'app/main/insurance/insurance-type/input-insurance-type.html',
                controller : 'InputInsuranceTypeController as vm'
              }
          }
      });

    // State detail plan
    $stateProvider
      .state('app.insurance_insurance-type_detail', {
        url  : '/insurance/type/detail/:id',
        views : {
          'content@app' : {
            templateUrl : 'app/main/insurance/insurance-type/insurance-type-detail.html',
            controller  : 'InsuranceTypeDetailController as vm'
          }
        }

      });  

      
  }


})();
(function(){
	'use strict';

	angular
		.module('app.insurance.insurance-type')
		.controller('InsuranceTypeController', InsuranceTypeController);

	InsuranceTypeController.$inject = ['$state', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService'];
	
	function InsuranceTypeController($state, $log, $mdDialog, AppAPI, Auth, DataService) {
		var vm = this;
		var Insurance = AppAPI.Insurance();

		vm.listJum = [2,5,25,50,75,100,200];
    vm.DataTable= new DataService();
    vm.loadData = loadData;
    vm.editData = editData;
    vm.detail = detail;
    vm.deleteList = deleteList;

    vm.listPlanSelected=[];

    loadData(1);


    function loadData(pageno) {
    	vm.DataTable.loadData(Insurance, pageno, {action:'viewType'});
    }

    function editData(data){
	    $state.go('app.insurance_insurance-type_edit',{id:data});
	  }

	  function detail(data) {
	  	$state.go('app.insurance_insurance-type_detail',{id:data});
	  }

	  function deleteList(ev) {
	  	var promise = Auth.setToken();
	  	promise.then(function(){
	  		var confirm = $mdDialog.confirm()
	  		.title('Would you like to delete this list?')
	  		.textContent('All data your selected will be deleted and can not recovered.')
				.ariaLabel('delete dialog')
				.targetEvent(ev)
				.ok('YES')
				.cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=Insurance.delete({action:'deleteType', data:angular.toJson(vm.listTypeSelected)});

           response.$promise.then(loadData(1)); 
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
        });


	  	});

	  }


	}	

})();
(function(){
	'use strict';

	angular
		.module('app.insurance.insurance-type')
		.controller('InsuranceTypeDetailController', InsuranceTypeDetailController);

		InsuranceTypeDetailController.$inject=['$state', '$log', '$timeout', '$stateParams', '$mdDialog', 'AppAPI' ,'Auth', 'Form', 'DataService'];

		function InsuranceTypeDetailController($state, $log, $timeout, $stateParams, $mdDialog, AppAPI, Auth, Form, DataService)	{
			
			var vm = this;
			var Insurance = AppAPI.Insurance();

			// initial form
			Form.initialForm();
			
			loadData();	

			// set Breadhome
			vm.Breadhome="app.pms_dashboard";
			vm.Breadlist=[
				{link:'app.insurance', name:'Insurance', active:'0'},
				{link:'#', name:'Insurance Type', active:'0'},
				{link:'#', name:'Insurance Type Detail', active:'0'}
			];

			vm.inputDetail = inputDetail;
			vm.deletePlanDetail = deletePlanDetail;

			function loadData(){	
				// set construct form
				Form.setObject(Insurance);

				// set form to controller
				vm.Form = Form;
				vm.Form.objForm.$get({action:'getType',id:$stateParams.id});
			}		

			function inputDetail(ev, id) {
				$mdDialog.show({
					controller : 'InputInsuranceTypeDetailController',
					controllerAs : 'vm',
					templateUrl :'app/main/insurance/insurance-type/input-insurance-type-detail.html',
					parent : angular.element(document.body),
					targetEvent : ev,
					clickOutsideToClose:false,
					onRemoving:function(element, removePromise){
						loadData();
					},
					locals:{
						id:id
					} 
				});
			}

			function deletePlanDetail(ev){
				var promise = Auth.setToken();
				promise.then( function(){
					var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

          $mdDialog.show(confirm).then( function(){
          	// angular.element.blockUI();
						var response=Insurance.delete({action:'deleteTypeDetail',data:angular.toJson(vm.listDetailSelected)});
						// response.$promise.then(loadData);
						loadData();
          }, function(){

          });
				});

			}





		}

})();	

(function(){
	'use strict';

	angular
		.module('app.insurance.insurance-type')
		.controller('InputInsuranceTypeController', InputInsuranceTypeController);

		InputInsuranceTypeController.$inject=['$state', '$log', '$localStorage' , '$timeout', '$stateParams', 'AppAPI' ,'Auth', 'Form'];

		function InputInsuranceTypeController($state, $log, $localStorage, $timeout, $stateParams, AppAPI, Auth, Form)	{

			var vm = this;	
			// initial form
			Form.initialForm();
			var Insurance = AppAPI.Insurance();

			// set construct form
			Form.setObject(Insurance);

			// set form to controller
			vm.Form = Form;

			if ($stateParams.id !== undefined) {
				vm.Form.objForm.$get({action:'getType',id:$stateParams.id});
			}


			vm.Breadhome="app.pms_dashboard";
			vm.Breadlist=[
				{link:'app.insurance', name:'Insurance', active:'0'},
				{link:'#', name:'Input Insurance Type', active:'0'}
			];

			vm.clearMeesage = clearMeesage;
			vm.reloadToken = reloadToken;
			vm.saveData = saveData;



			function clearMeesage() {
	      vm.Form.tampilPesan=false;
	    }

	    function reloadToken(){
	    	Auth.setToken();
	    }

	    function saveData(formController){
	    	angular.element.blockUI(); //munculin loading please wait
	    	var response = Form.saveData('saveType', formController, Insurance);

	    	response.then(function(){
	    		vm.messageTheme = 'blue';
	    		angular.element.unblockUI();
	    		formController.$setPristine();
	    		$timeout(function(){
	    			vm.Form.tampilPesan = false;
	    		}, 3000);

	    	});

	    	response.catch(function(){
	    		vm.messageTheme = 'pink';
	    		angular.element.unblockUI();
	    	});


	    }


		}

})();	

(function(){
  'use strict';

  angular
    .module('app.insurance.insurance-plan',[] )
    .config(config);
  config.$inject = ['$stateProvider'];
  /** @ngInject **/

  function config($stateProvider) {

    // State list plan
    $stateProvider
      .state('app.insurance_insurance-plan_list',{
        url : '/insurance/plan/list',
        views : {
          'content@app' : {
            templateUrl: 'app/main/insurance/insurance-plan/list.html',
            controller : 'ListController as vm'
          },
        }
      });


    // State input plan
    $stateProvider
      .state('app.insurance_insurance-plan_input',{
        url   : '/insurance/plan/input',
        views : {
          'content@app' : {
            templateUrl : 'app/main/insurance/insurance-plan/input.html',
            controller  : 'InputController as vm'
          },
        }
      });

    // State edit plan
    $stateProvider
      .state('app.insurance_insurance-plan_edit', {
          url    : '/insurance/plan/edit/:id',
          views  : {
              'content@app': {
                templateUrl: 'app/main/insurance/insurance-plan/input.html',
                controller : 'InputController as vm'
              }
          }
      });

    // State detail plan
    $stateProvider
      .state('app.insurance_insurance-plan_detail', {
        url  : '/insurance/plan/detail/:id',
        views : {
          'content@app' : {
            templateUrl : 'app/main/insurance/insurance-plan/detail.html',
            controller  : 'DetailController as vm'
          }
        }

      });  

      
  }


})();
(function(){
	'use strict';

	angular
		.module('app.insurance.insurance-plan')
		.controller('InputInsuranceTypeDetailController', InputInsuranceTypeDetailController);

	InputInsuranceTypeDetailController.$inject = ['$state','$localStorage', '$mdDialog', 'Form', 'AppAPI', 'id'];

	function InputInsuranceTypeDetailController($state, $localStorage, $mdDialog, Form, AppAPI, id){
		var vm = this;
		Form.initialForm();		

		var Insurance = AppAPI.Insurance();
		Form.setObject(Insurance);
		vm.Form = Form;
		vm.Form.objForm.insurance_claim_type_id = id;
		vm.closeModal = closeModal;
		vm.saveData = saveData;

		function saveData(ev, formController){
			var promise = Form.saveData('saveTypeDetail', formController, Insurance);
      promise.then(function(){
        showDialog(ev);
      });
		}

    function closeModal(){
      $mdDialog.hide();
    }

    function showDialog(ev) {
       $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Success Save Data')
        .textContent('Process Data was Success.')
        .ariaLabel('Success Save Data')
        .ok('OK')
        .targetEvent(ev)
        ).then(function(){
            closeModal();
            $state.go('app.insurance_insurance-type_detail',{id:id});
        });
    }

	}


})();
(function(){
	'use strict';

	angular
		.module('app.insurance.insurance-plan')
		.controller('ListController', ListController);

	ListController.$inject = ['$state', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService'];
	
	function ListController($state, $log, $mdDialog, AppAPI, Auth, DataService) {
		var vm = this;
		var Insurance = AppAPI.Insurance();

		vm.listJum = [2,5,25,50,75,100,200];
    vm.DataTable= new DataService();
    vm.loadData = loadData;
    vm.editData = editData;
    vm.detail = detail;
    vm.deleteList = deleteList;

    vm.listPlanSelected=[];

    loadData(1);


    function loadData(pageno) {
    	vm.DataTable.loadData(Insurance, pageno, {action:'viewPlan'});
    }

    function editData(data){
	    $state.go('app.insurance_insurance-plan_edit',{id:data});
	  }

	  function detail(data) {
	  	$state.go('app.insurance_insurance-plan_detail',{id:data});
	  }

	  function deleteList(ev) {
	  	var promise = Auth.setToken();
	  	promise.then(function(){
	  		var confirm = $mdDialog.confirm()
	  		.title('Would you like to delete this list?')
	  		.textContent('All data your selected will be deleted and can not recovered.')
				.ariaLabel('delete dialog')
				.targetEvent(ev)
				.ok('YES')
				.cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
           var response=Insurance.delete({action:'deletePlan', data:angular.toJson(vm.listPlanSelected)});

           response.$promise.then(loadData(1)); 
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
        });


	  	});

	  }


	}	

})();
(function(){
	'use strict';

	angular
		.module('app.insurance.insurance-plan')
		.controller('InputController', InputController);

		InputController.$inject=['$state', '$log', '$localStorage' , '$timeout', '$stateParams', 'AppAPI' ,'Auth', 'Form'];

		function InputController($state, $log, $localStorage, $timeout, $stateParams, AppAPI, Auth, Form)	{

			var vm = this;	
			// initial form
			Form.initialForm();
			var Insurance = AppAPI.Insurance();

			// set construct form
			Form.setObject(Insurance);

			// set form to controller
			vm.Form = Form;

			if ($stateParams.id !== undefined) {
				vm.Form.objForm.$get({action:'getPlan',id:$stateParams.id});
			}

			vm.clearMeesage = clearMeesage;
			vm.reloadToken = reloadToken;
			vm.saveData = saveData;

			function clearMeesage() {
	      vm.Form.tampilPesan=false;
	    }

	    function reloadToken(){
	    	Auth.setToken();
	    }

	    function saveData(formController){
	    	angular.element.blockUI(); //munculin loading please wait
	    	var response = Form.saveData('savePlan', formController, Insurance);

	    	response.then(function(){
	    		vm.messageTheme = 'blue';
	    		angular.element.unblockUI();
	    		formController.$setPristine();
	    		$timeout(function(){
	    			vm.Form.tampilPesan = false;
	    		}, 3000);

	    	});

	    	response.catch(function(){
	    		vm.messageTheme = 'pink';
	    		angular.element.unblockUI();
	    	});


	    }


		}

})();	

(function(){
	'use strict';

	angular
		.module('app.insurance.insurance-plan')
		.controller('InputPremiController', InputPremiController);

	InputPremiController.$inject = ['$state','$localStorage', '$mdDialog', 'Form', 'AppAPI', 'id'];

	function InputPremiController($state, $localStorage, $mdDialog, Form, AppAPI, id){
		var vm = this;
		vm.idPlan = id;
		Form.initialForm();	

		var Insurance = AppAPI.Insurance();
		Form.setObject(Insurance);
		vm.Form = Form;
		vm.Form.objForm.insurance_plan_id = id;
		vm.closeModal = closeModal;
		vm.saveData = saveData;

		function saveData(ev, formController){
			var promise = Form.saveData('savePlanPremi', formController, Insurance);
      promise.then(function(){
        showDialog(ev);
      });
		}

    function closeModal(){
      $mdDialog.hide();
    }

    function showDialog(ev) {
       $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Success Save Data')
        .textContent('Process Data was Success.')
        .ariaLabel('Success Save Data')
        .ok('OK')
        .targetEvent(ev)
        ).then(function(){
            closeModal();
            $state.go('app.insurance_insurance-plan_detail',{id:id});
        });
    }

	}


})();
(function(){
	'use strict';

	angular
		.module('app.insurance.insurance-plan')
		.controller('InputDetailController', InputDetailController);

	InputDetailController.$inject = ['$state','$localStorage', '$mdDialog', 'Form', 'AppAPI', 'id'];

	function InputDetailController($state, $localStorage, $mdDialog, Form, AppAPI, id){
		var vm = this;
		vm.idPlan = id;
		Form.initialForm();		

		var Insurance = AppAPI.Insurance();
		Form.setObject(Insurance);
		vm.Form = Form;
		vm.Form.objForm.insurance_plan_id = id;
		vm.closeModal = closeModal;
		vm.saveData = saveData;

		function saveData(ev, formController){
			var promise = Form.saveData('savePlanDetail', formController, Insurance);
      promise.then(function(){
        showDialog(ev);
      });
		}

    function closeModal(){
      $mdDialog.hide();
    }

    function showDialog(ev) {
       $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Success Save Data')
        .textContent('Process Data was Success.')
        .ariaLabel('Success Save Data')
        .ok('OK')
        .targetEvent(ev)
        ).then(function(){
            closeModal();
            $state.go('app.insurance_insurance-plan_detail',{id:id});
        });
    }

	}


})();
(function(){
	'use strict';

	angular
		.module('app.insurance.insurance-plan')
		.controller('DetailController', DetailController);

		DetailController.$inject=['$state', '$log', '$timeout', '$stateParams', '$mdDialog', 'AppAPI' ,'Auth', 'Form', 'DataService'];

		function DetailController($state, $log, $timeout, $stateParams, $mdDialog, AppAPI, Auth, Form, DataService)	{
			
			var vm = this;
			var Insurance = AppAPI.Insurance();

			// initial form
			Form.initialForm();
			
			loadData();	

			vm.inputDetail = inputDetail;
			vm.inputPremi = inputPremi;
			vm.deletePlanDetail = deletePlanDetail;
			vm.deletePremi = deletePremi;

			function loadData(){	
				// set construct form
				Form.setObject(Insurance);

				// set form to controller
				vm.Form = Form;
				vm.Form.objForm.$get({action:'getPlan',id:$stateParams.id});
			}		

			function inputDetail(ev, id) {
				$mdDialog.show({
					controller : 'InputDetailController',
					controllerAs : 'vm',
					templateUrl :'app/main/insurance/insurance-plan/input-detail.html',
					parent : angular.element(document.body),
					targetEvent : ev,
					clickOutsideToClose:false,
					onRemoving:function(element, removePromise){
						loadData();
					},
					locals:{
						id:id
					} 
				});
			}

			function inputPremi(ev, id) {
				$mdDialog.show({
					controller : 'InputPremiController',
					controllerAs : 'vm',
					templateUrl :'app/main/insurance/insurance-plan/input-premi.html',
					parent : angular.element(document.body),
					targetEvent : ev,
					clickOutsideToClose:false,
					onRemoving:function(element, removePromise){
						loadData();
					},
					locals:{
						id:id
					} 
				});
			}

			function deletePlanDetail(ev){
				var promise = Auth.setToken();
				promise.then( function(){
					var confirm = $mdDialog.confirm()
          .title('Would you like to delete this detail?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

          $mdDialog.show(confirm).then( function(){
          	// angular.element.blockUI();
						var response=Insurance.delete({action:'deletePlanDetail',data:angular.toJson(vm.listPlanDetailSelected)});
						// response.$promise.then(loadData);
						loadData();
          }, function(){

          });
				});
			}

			function deletePremi(ev){
				var promise = Auth.setToken();
				promise.then( function(){
					var confirm = $mdDialog.confirm()
          .title('Would you like to delete this premi?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

          $mdDialog.show(confirm).then( function(){
						var response=Insurance.delete({action:'deletePlanPremi',data:angular.toJson(vm.listPlanPremiSelected)});
						loadData();
          }, function(){

          });
				});
			}

		}

})();	

(function(){
	'use strict';

	angular
		.module('app.insurance.endorsment',[])
		.config(config);
	config.$inject = ['$stateProvider'];
	/** @ngInject **/
	function config($stateProvider) {
		// state list endorsment
		$stateProvider
			.state('app.endorsment-endorsment_list',{
				url : '/insurance/endorsment/list',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/endorsment/endorsment.html',
						controller  : 'EndorsmentController as vm'
					},
				}
			});

		$stateProvider
			.state('app.endorsment-endorsment_deactive',{
				url : '/insurance/endorsment/deactive',
				views : {
					'content@app' : {
						templateUrl :'app/main/insurance/endorsment/endorsment-deactive.html',
						controller  :'EndorsmentDeactiveController as vm'
					},
				}
			});	

		$stateProvider
			.state('app.endorsment-endorsment_list_employe',{
				url : '/insurance/endorsment/list_employe',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/endorsment/endorsment-employe.html',
						controller  : 'EndorsmentEmployeController as vm'
					},
				}
			});	

		$stateProvider
			.state('app.endorsment-endorsment_edit',{
				url : '/insurance/endorsment/edit/:status',
				views : {
					'content@app' : {
						templateUrl :'app/main/insurance/endorsment/endorsment-edit.html',
						controller  :'EndorsmentEditController as vm'
					},
				}
			});	

		$stateProvider
			.state('app.endorsment-set-register-number',{
				url : '/insurance/endorsment/setregisternumber/',
				views : {
					'content@app' : {
						templateUrl :'app/main/insurance/endorsment/endorsment-set-register-number.html',
						controller  :'EndorsmentSetRegisterNumberController as vm'
					}
				},

			});	


		$stateProvider
			.state('app.endorsment-log',{
				url : '/insurance/endorsment/endorsment_log',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/endorsment/endorsment-log.html',
						controller  : 'EndorsmentLogController as vm'
					}

				},
			});	

	}

})();

(function () {
    'use strict';

    angular
        .module('app.insurance.endorsment')
        .controller('UploadNoregController', UploadNoregController);

    UploadNoregController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'AppAPI'];

    /* @ngInject */
    function UploadNoregController($mdDialog, $localStorage, FileUploader, config, AppAPI) {
        var vm = this;
        // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal = closeModal;
        vm.uploadFile = uploadFile;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        var Insurance = AppAPI.Insurance();

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/insurance/uploadNoreg',
            removeAfterUpload: true,
            alias: 'fileNoreg',
            formData: [{
                action: 'uploadNoreg'
            }],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        uploaderPhoto.onSuccessItem = function (item) {
            vm.UploadPhotoStateSucces = true;
            vm.UploadPhotoStateError = false;
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem = function () {
            vm.UploadPhotoStateSucces = false;
            vm.UploadPhotoStateError = true;
        };

        function uploadFile() {
            return false;
        }

        function closeModal() {
            $mdDialog.hide();
        }


    }
})();

(function(){
  'use strict';

  angular
    .module('app.insurance.endorsment')
    .controller('EndorsmentController', EndorsmentController);

  EndorsmentController.$inject = ['$state', '$log', '$mdDialog', '$window', '$location', 'config', 'AppAPI', 'Auth'];
  function EndorsmentController($state, $log, $mdDialog, $window, $location, config, AppAPI, Auth) {
    var vm = this;
    var Insurance = AppAPI.Insurance();

    vm.data = [];
    vm.loadData = loadData;
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.acceptList = acceptList;

    // loadData();
		loadDataBU();
		loadDataDivision(vm.company);
		loadDataDepartment(vm.divisi);

    function loadData() {
      angular.element.blockUI();
      vm.listSelected = [];
      vm.selectAll = false;
      var response=Insurance.query({action : 'viewEndorsmentTransactionList', company : vm.company, divisi : vm.divisi, department : vm.department, nik : vm.nik });
        response.$promise.then(fetchData);
        response.$promise.catch(errorData);
    }

    function fetchData(data) {
      vm.data = data;
      angular.element.unblockUI();
    }

    function errorData() {
      vm.data = [];
      angular.element.unblockUI();
    }

    function toggleSelectedAll(state){
      switch(state) {
        case true:
          checkAll();
        break;

        case false:
          unCheckAll();
        break;
      }
    }

    function checkAll() {
       vm.listSelected=[];
       var data = vm.data;
       for (var i = 0; i < data.length; i++) {
         if (data[i]['bankAccount'] != "") {
           vm.listSelected.push(data[i]);
         }
       }
       // vm.listSelected=angular.copy(vm.data);
    }

    function unCheckAll() {
       vm.listSelected=[];
    }

    function acceptList(ev) {
      $mdDialog.show({
        controller         : 'EfectiveDateController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/insurance/endorsment/efective-date.html',
        parent: angular.element(document.body),
        clickOutsideToClose:true,
        fullscreen: true,
        onRemoving:function(element, removePromise){
          ExportToExcel(vm.listSelected);
          loadData();
        },
        locals:{
          data:vm.listSelected
        }
      });
    }

    function ExportToExcel() {
     
      var confirm = $mdDialog.confirm()
          .title('Download file')
          .textContent('Would you want download file?')
          .ariaLabel('delete dialog')
          .ok('YES')
          .cancel('no');
      $mdDialog.show({
            multiple: true
       });      
      $mdDialog.show(confirm).then(function() {     

        var token=Auth.setTokenPromise();
        token.then(function(){
            var protocol=$location.protocol();
            var host=$location.host();
            $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirPenambahan/'+token+'/download', '_blank');
        },function(){
            $window.alert('gagal load token');
        });

      }, function() { 

        var token=Auth.setTokenPromise();
        token.then(function(){
            var protocol=$location.protocol();
            var host=$location.host();
            $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirPenambahan/'+token+'/undownload', '_blank');
        },function(){
            $window.alert('gagal load token');
        });

      });
    }

    // load bu
    function loadDataBU(){
    	var response = Insurance.query({action:'viewBU'});
    	response.$promise.then(fetchBU);
    	response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU=data;
    }

    function errorFetchBU() {
      vm.listBU=[];
    }

		// load division
	  function loadDataDivision(idbu) {
      var response=Insurance.query({action:'viewDivisiBu',idbu:idbu});
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
     vm.listDivision=data;
    }

    function errorDivisiBU() {
      vm.listDivision=[];
    }

    // load department
    function loadDataDepartment(iddivisi) {
      var response=Insurance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment=data;
    }

    function errorDepartment() {
      vm.listDepartment=[];
    }

  }
})();

  (function(){
  'use strict';

  angular
    .module('app.insurance.endorsment')
    .controller('EndorsmentSetRegisterNumberController', EndorsmentSetRegisterNumberController);

  EndorsmentSetRegisterNumberController.$inject = ['$state', '$log', '$mdDialog', '$location', '$window', 'config', 'AppAPI', 'Auth'];
  function EndorsmentSetRegisterNumberController($state, $log, $mdDialog, $location, $window, config, AppAPI, Auth) {
    var vm = this;
    var Insurance = AppAPI.Insurance();

    vm.data = [];
    vm.loadData = loadData;
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.inputRegisterNumber = inputRegisterNumber;
    vm.uploadNoreg = uploadNoreg;
    vm.downloadFormatNoreg = downloadFormatNoreg;
    
    loadData();
		loadDataBU();
		loadDataDivision(vm.company);
		loadDataDepartment(vm.divisi);

    function loadData() {
      angular.element.blockUI();
      vm.listSelected = [];
      vm.selectAll = false;
      var response=Insurance.query({action : 'viewEmpInsuranceDetailUnregister', company : vm.company, divisi : vm.divisi, department : vm.department, nik : vm.nik, status:"" });
        response.$promise.then(fetchData);
    }

    function fetchData(data) {
      vm.data = data;
      angular.element.unblockUI();
    }

    function errorData() {
      vm.data = [];
      angular.element.unblockUI();
    }

    function inputRegisterNumber(data) {
      $mdDialog.show({
        controller         : 'RegisterNumberController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/insurance/emp-insurance/register-number.html',
        parent: angular.element(document.body),
        clickOutsideToClose:true,
        fullscreen: true,
        onRemoving:function(element, removePromise){
          loadData();
        },
        locals:{
          id:data.id,
          registerNumber:data.no_register
        }
      });
    }

    function uploadNoreg(ev) {
      $mdDialog.show({
          controller         : 'UploadNoregController as vm',
          templateUrl        : 'app/main/insurance/endorsment/upload-noreg.html',
          parent             : angular.element(document.body),
          targetEvent        : ev,
          clickOutsideToClose: true,
          onRemoving:function(element, removePromise){
            loadData();
          },
      });
    }

    function downloadFormatNoreg() {
      var protocol=$location.protocol();
      var host=$location.host();
      $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormatNoreg/', '_blank');
    }    

    // load bu
    function loadDataBU(){
    	var response = Insurance.query({action:'viewBU'});
    	response.$promise.then(fetchBU);
    	response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU=data;
    }

    function errorFetchBU() {
      vm.listBU=[];
    }

		// load division
	  function loadDataDivision(idbu) {
      var response=Insurance.query({action:'viewDivisiBu',idbu:idbu});
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
     vm.listDivision=data;
    }

    function errorDivisiBU() {
      vm.listDivision=[];
    }

    // load department
    function loadDataDepartment(iddivisi) {
      var response=Insurance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment=data;
    }

    function errorDepartment() {
      vm.listDepartment=[];
    }

  }
})();

(function () {
	'use strict';

	angular
		.module('app.insurance.endorsment')
		.controller('EndorsmentLogController', EndorsmentLogController);

	EndorsmentLogController.$inject = ['$state', '$log', '$window', '$location','$filter', 'config', 'AppAPI', 'Auth'];
	function EndorsmentLogController($state, $log,  $window, $location, $filter, config, AppAPI, Auth) {

		var vm = this;
		var Insurance = AppAPI.Insurance();

		vm.listType = ['Addition of Member', 'Reduction of Members', 'Grade Changes', 'Mariage Status Change', 'Bank Account Changes'];
		vm.download = download;

		function download() {
			angular.element.blockUI();

       var token = Auth.setTokenPromise();
       token.then(function () {
         var protocol = $location.protocol();
         var host = $location.host();
         $window.open(protocol + '://' + host + config.api + 'api/insurance/downloadExcelByperiod/' + token + '/' + vm.type + '/' + $filter('date')(vm.start_date, 'yyyy-MM-dd') + '/' + $filter('date')(vm.end_date, 'yyyy-MM-dd'), '_blank');
       }, function () {
         $window.alert('gagal load token');
       });


			angular.element.unblockUI();
		}
	

	}

})();
(function(){
  'use strict';

  angular
    .module('app.insurance.endorsment')
    .controller('EndorsmentEmployeController', EndorsmentEmployeController);

  EndorsmentEmployeController.$inject = ['$state', '$log', '$mdDialog', '$window', '$location', '$localStorage', 'config', 'AppAPI', 'Auth'];
  function EndorsmentEmployeController($state, $log, $mdDialog, $window, $location, $localStorage, config, AppAPI, Auth) {
    var vm = this;
    var Insurance = AppAPI.Insurance();

    vm.data = [];
    vm.loadData = loadData;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.submit = submit;
    vm.checkSelected=checkSelected;

    loadData();

    function loadData() {
      angular.element.blockUI();
      vm.listSelected = [];
      vm.selectAll = false;
      var response=Insurance.query({action : 'viewEndorsmentTransactionList', company : '', divisi : '', department : '', nik : $localStorage.user });
        response.$promise.then(fetchData);
    }

    function fetchData(data) {
      vm.data = data;
      angular.element.unblockUI();
    }

    function errorData() {
      vm.data = [];
      angular.element.unblockUI();
    }

    function toggleSelectedAll(state){
      switch(state) {
        case true:
          checkAll();
        break;

        case false:
          unCheckAll();
        break;
      }
    }

    function checkAll() {
       vm.listSelected=[];
       var data = vm.data,ln=data.length;
       for (var i = 0; i < ln; i++) {
         if (data[i]['bankAccount'] != "") {
          if(i<3)
          {
           vm.listSelected.push(data[i]);
          }
         }
       }
       // vm.listSelected=angular.copy(vm.data);
    }

    function checkSelected() {
      var ln=vm.listSelected.length;
      if(ln>3)
      {

        vm.listSelected.splice((ln-1),1);
        alert('your reached selected data, 3 allowed' + idx);
      }
    }

    function unCheckAll() {
       vm.listSelected=[];
    }

    function submit(ev) {
      var response=Insurance.save({action:'createEndorsment', data:angular.toJson(vm.listSelected), effectiveDate:'0000-00-00'} );

      response.$promise.then( function(data){

        var confirm = $mdDialog.confirm()
            .title('Success.!')
            .textContent(data.pesan)
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Close')

            $mdDialog.show(confirm).then(function() {
              loadData();
              $mdDialog.cancel();
            });

      });

    }


  }
})();

  (function(){
  'use strict';

  angular
    .module('app.insurance.endorsment')
    .controller('EndorsmentEditController', EndorsmentEditController);

  EndorsmentEditController.$inject = ['$state', '$log', '$mdDialog', '$stateParams', 'config', 'AppAPI', 'Auth'];
  function EndorsmentEditController($state, $log, $mdDialog, $stateParams, config, AppAPI, Auth) {
    var vm = this;
    var Insurance = AppAPI.Insurance();
    vm.status = '';
    if($stateParams.status != ''){
      vm.status = 'nonActive';
    }

    vm.data = [];
    vm.loadData = loadData;
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.acceptList = acceptList;

    // loadData();
		loadDataBU();
		loadDataDivision(vm.company);
		loadDataDepartment(vm.divisi);

    function loadData() {
      angular.element.blockUI();
      vm.listSelected = [];
      vm.selectAll = false;
      var response=Insurance.query({action : 'viewEmpInsuranceDetail', company : vm.company, divisi : vm.divisi, department : vm.department, nik : vm.nik, status : vm.status });
        response.$promise.then(fetchData);
    }

    function fetchData(data) {
      vm.data = data;
      angular.element.unblockUI();
    }

    function errorData() {
      vm.data = [];
      angular.element.unblockUI();
    }

    function toggleSelectedAll(state){
      switch(state) {
        case true:
          checkAll();
        break;

        case false:
          unCheckAll();
        break;
      }
    }

    function checkAll() {
       vm.listSelected=[];
       var data = vm.data;
       for (var i = 0; i < data.length; i++) {
         if (data[i]['bankAccount'] != "") {
           vm.listSelected.push(data[i]);
         }
       }
       // vm.listSelected=angular.copy(vm.data);
    }

    function unCheckAll() {
       vm.listSelected=[];
    }

    function acceptList(ev) {
      $mdDialog.show({
        controller         : 'DeactiveController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/insurance/endorsment/deactive.html',
        parent: angular.element(document.body),
        clickOutsideToClose:true,
        fullscreen: true,
        onRemoving:function(element, removePromise){
          loadData();
        },
        locals:{
          data:vm.listSelected
        }
      });
    }

    // load bu
    function loadDataBU(){
    	var response = Insurance.query({action:'viewBU'});
    	response.$promise.then(fetchBU);
    	response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU=data;
    }

    function errorFetchBU() {
      vm.listBU=[];
    }

		// load division
	  function loadDataDivision(idbu) {
      var response=Insurance.query({action:'viewDivisiBu',idbu:idbu});
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
     vm.listDivision=data;
    }

    function errorDivisiBU() {
      vm.listDivision=[];
    }

    // load department
    function loadDataDepartment(iddivisi) {
      var response=Insurance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment=data;
    }

    function errorDepartment() {
      vm.listDepartment=[];
    }

  }
})();

  (function(){
  'use strict';

  angular
    .module('app.insurance.endorsment')
    .controller('EndorsmentDeactiveController', EndorsmentDeactiveController);

  EndorsmentDeactiveController.$inject = ['$state', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth'];
  function EndorsmentDeactiveController($state, $log, $mdDialog, config, AppAPI, Auth) {
    var vm = this;
    var Insurance = AppAPI.Insurance();

    vm.data = [];
    vm.loadData = loadData;
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.acceptList = acceptList;

    // loadData();
		loadDataBU();
		loadDataDivision(vm.company);
		loadDataDepartment(vm.divisi);

    function loadData() {
      angular.element.blockUI();
      vm.listSelected = [];
      vm.selectAll = false;
      var response=Insurance.query({action : 'viewEmpInsuranceDetail', company : vm.company, divisi : vm.divisi, department : vm.department, nik : vm.nik, status:"" });
        response.$promise.then(fetchData);
    }

    function fetchData(data) {
      vm.data = data;
      angular.element.unblockUI();
    }

    function errorData() {
      vm.data = [];
      angular.element.unblockUI();
    }

    function toggleSelectedAll(state){
      switch(state) {
        case true:
          checkAll();
        break;

        case false:
          unCheckAll();
        break;
      }
    }

    function checkAll() {
       vm.listSelected=[];
       var data = vm.data;
       for (var i = 0; i < data.length; i++) {
         if (data[i]['bankAccount'] != "") {
           vm.listSelected.push(data[i]);
         }
       }
       // vm.listSelected=angular.copy(vm.data);
    }

    function unCheckAll() {
       vm.listSelected=[];
    }

    function acceptList(ev) {
      $mdDialog.show({
        controller         : 'DeactiveController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/insurance/endorsment/deactive.html',
        parent: angular.element(document.body),
        clickOutsideToClose:true,
        fullscreen: true,
        onRemoving:function(element, removePromise){
          loadData();
        },
        locals:{
          data:vm.listSelected
        }
      });
    }

    // load bu
    function loadDataBU(){
    	var response = Insurance.query({action:'viewBU'});
    	response.$promise.then(fetchBU);
    	response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU=data;
    }

    function errorFetchBU() {
      vm.listBU=[];
    }

		// load division
	  function loadDataDivision(idbu) {
      var response=Insurance.query({action:'viewDivisiBu',idbu:idbu});
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
     vm.listDivision=data;
    }

    function errorDivisiBU() {
      vm.listDivision=[];
    }

    // load department
    function loadDataDepartment(iddivisi) {
      var response=Insurance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment=data;
    }

    function errorDepartment() {
      vm.listDepartment=[];
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.insurance.endorsment')
    .controller('EfectiveDateController', EfectiveDateController);

  EfectiveDateController.$inject = ['$mdDialog', '$filter', 'data', 'AppAPI', 'Auth'];

  function EfectiveDateController($mdDialog, $filter, data, AppAPI, Auth) {
    var vm = this;
    var Insurance = AppAPI.Insurance();

    vm.data = data;
    vm.closeModal = closeModal;
    vm.submit = submit;
    vm.reloadToken = reloadToken;

    function closeModal() {
      $mdDialog.cancel();
    }

    function submit(ev) {
      var response=Insurance.save({action:'createEndorsment', data:angular.toJson(vm.data), effectiveDate:vm.effectiveDate} );
      $mdDialog.cancel();
    }

    function reloadToken(){
      Auth.setToken();
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app.insurance.endorsment')
    .controller('DeactiveController', DeactiveController);

  DeactiveController.$inject = ['$mdDialog', '$filter', '$window', '$location', '$mdDateLocale', 'data', 'AppAPI', 'Auth','config'];

  function DeactiveController($mdDialog, $filter, $window, $location, $mdDateLocale, data, AppAPI, Auth, config) {
    var vm = this;
    var Insurance = AppAPI.Insurance();

    vm.data = data;
    vm.closeModal = closeModal;
    vm.submit = submit;
    vm.reloadToken = reloadToken;

    function closeModal() {
      $mdDialog.cancel();
    }

    function submit(ev) {
      var response=Insurance.delete({action:'deleteEmpInsuranceDetail', data:angular.toJson(vm.data), tanggal:$filter('date')(vm.deactiveDate, 'yyyy-MM-dd'), reason:vm.description} );
      response.$promise.then( function(data){
        ExportToExcel();
      });

    }

    function reloadToken(){
      Auth.setToken();
    }

    function ExportToExcel() {
     
      var confirm = $mdDialog.confirm()
          .title('Download file')
          .textContent('Would you want download file?')
          .ariaLabel('delete dialog')
          .ok('YES')
          .cancel('no');
      $mdDialog.show({
            multiple: true
       });      
      $mdDialog.show(confirm).then(function() {     

        var token=Auth.setTokenPromise();
        token.then(function(){
            var protocol=$location.protocol();
            var host=$location.host();
            $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirPengurangan/'+token+'/'+$filter('date')(vm.deactiveDate, 'dd-MM-yyyy')+'/'+vm.description+'/download', '_blank');
            closeModal();
        },function(){
            $window.alert('gagal load token');
        });

      }, function() { 

        var token=Auth.setTokenPromise();
        token.then(function(){
            var protocol=$location.protocol();
            var host=$location.host();
            $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirPengurangan/'+token+'/'+$filter('date')(vm.deactiveDate, 'dd-MM-yyyy')+'/'+vm.description+'/undownload', '_blank');
            closeModal();
        },function(){
            $window.alert('gagal load token');
        });

      });
    }
    


  }

})();

(function(){
	'use strict';

	angular
		.module('app.insurance.emp-claim',[])
		.config(config);
	config.$inject = ['$stateProvider'];
	
	function config($stateProvider){
		
		$stateProvider
			.state('app.insurance_emp-claim_input',{
				url : '/insurance/claim/input',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/emp-claim/input-emp-claim.html',
						controller  : 'InputEmpClaimController	 as vm'
					},
				}
			});

			$stateProvider
			.state('app.insurance_emp-claim_edit',{
				url : '/insurance/claim/input/:id',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/emp-claim/input-emp-claim.html',
						controller  : 'InputEmpClaimController	 as vm'
					},
				}
			});
			
			$stateProvider
			.state('app.insurance_emp-claim_list',{
				url : '/insurance/claim/list',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/emp-claim/emp-claim.html',
						controller  : 'EmpClaimController	as vm'
					},
				}
			});

			$stateProvider
			.state('app.insurance_emp-claim_listEmploye',{
				url : '/insurance/claim/listEmploye',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/emp-claim/emp-claim-employe.html',
						controller  : 'EmpClaimEmployeController	as vm'
					},
				}
			});

			$stateProvider
			.state('app.insurance_emp-claim_detail',{
				url : '/insurance/claim/detail/:id',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/emp-claim/emp-claim-detail.html',
						controller 	: 'EmpClaimDetailController as vm'
					}
				}

			});

    $stateProvider
      .state('app.insurance-progress',{
        url: '/insurance-progress/:nik/:regNo/:registerDate/',
        views : {
          'content@app' : {
            templateUrl : 'app/main/insurance/insurance-progress.html',
            controller : 'InsuranceProgressController as vm'
          },
        }
      });  
	}	

})();
(function(){
	'use strict'

	angular
		.module('app.insurance.emp-claim')
		.controller('InputEmpClaimController', InputEmpClaimController);

		InputEmpClaimController.$inject = ['$state', '$mdDialog', '$log', '$localStorage', '$timeout', '$stateParams', 'AppAPI', 'Auth', 'Form', 'FileUploader', 'config'];
		function InputEmpClaimController($state, $mdDialog, $log, $localStorage, $timeout, $stateParams, AppAPI, Auth, Form, FileUploader, config) {
			var vm = this;

			var Insurance = AppAPI.Insurance();
			Form.initialForm();
			Form.setObject(Insurance);
			vm.empId = $localStorage.empno;
      vm.loadClaimTypeDetail = loadClaimTypeDetail;
      vm.clearMeesage = clearMeesage;
      vm.reloadToken = reloadToken;
      vm.saveData = saveData;
      vm.hapusDocs = hapusDocs;

			vm.Form = Form;

      vm.Form.objForm.empName = $localStorage.nama;
      vm.Form.objForm.nik = $localStorage.user;
      vm.Form.objForm.currency = "INDONESIA ( IDR )";

      loadData(); 

      function loadData(){
        if ($stateParams.id !== undefined) {
          var responses = vm.Form.objForm.$get({action:'getEmpInsuranceClaim', id:$stateParams.id});

          responses.then(function(data){
            var submitDate = new Date(data.submit_date);
            var receiptDate = new Date(data.receipt_date);
            vm.Form.objForm.submit_date = submitDate;
            vm.Form.objForm.receipt_date = receiptDate;
            loadClaimTypeDetail(data.claim_type_id);
          });
        }
        else{
          vm.Form.objForm.submit_date = new Date();
        }
      }

			loadEmpInsurance();
      loadClaimType();
      loadCountry();


      function loadEmpInsurance(param) {
        var response = Insurance.query({action:'getEmpInsurance', id:$localStorage.user, type:"get"});
        response.$promise.then(function(data){
          vm.claimRelationList = data[0].detail;
          // loadPlan(data[0].plan_code);
        });
      }

      function loadCountry(param) {
        var response = Insurance.query({action:'viewCountry'});
        response.$promise.then(function(data){
          vm.countryList = data[0];
        });
      }

      function hapusDocs(param) {
        var promise = Auth.setToken();
        promise.then(function(){
          var confirm = $mdDialog.confirm()
          .title('Would you like to delete this document?')
          .textContent('a document your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .ok('YES')
          .cancel('no');

          $mdDialog.show(confirm).then(function() {
            // angular.element.blockUI();
            var response=Insurance.delete({action:'deleteDocument', data:angular.toJson(param)});
            // angular.element.unblockUI();
            response.$promise.then(loadData(1)); 
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });   

        });

      }

      function loadClaimType() {
        var response = Insurance.query({action:'viewType', offset:'0', jumPage:'1000'});
        response.$promise.then( function(data){
          vm.claimTypeList = data[0].aData;
        });
      }

      function loadClaimTypeDetail(id) {
        var response = Insurance.query({action:'viewTypeDetail', id:id});
        response.$promise.then( function(data){
          vm.claimTypeDetailList = data[0];
        });
      }

      function clearMeesage() {
        vm.Form.tampilPesan=false;
      }

      function reloadToken(){
        Auth.setToken();
      }

      function saveData(formController){
        angular.element.blockUI(); //munculin loading please wait
        var response = Form.saveData('saveInsuranceClaim', formController, Insurance);

        response.then(function(){
          vm.messageTheme = 'blue';
          angular.element.unblockUI();
          formController.$setPristine();

          vm.uploader.uploadAll();

          $timeout(function(){
            vm.Form.tampilPesan = false;
          }, 3000);

        });

        response.catch(function(){
          vm.messageTheme = 'pink';
          angular.element.unblockUI();
        });

      }

      var uploader = vm.uploader = new FileUploader({
            url:config.api+'api/insurance/uploadFile', 
            removeAfterUpload:true,
            alias:'insuranceFile',    
      });

           // a sync filter
      uploader.filters.push({
          name: 'syncFilter',
          fn: function(item /*{File|FileLikeObject}*/, options) {
              return this.queue.length < 10;
          }
      });
    
      // an async filter
      uploader.filters.push({
          name: 'asyncFilter',
          fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
              setTimeout(deferred.resolve, 1e3);
          }
      });   


		}

})();
(function () {
    'use strict';
    angular
        .module('app.insurance.emp-claim')
        .controller('EmpClaimController', EmpClaimController);

    EmpClaimController.$inject = ['$state', '$log', '$mdDialog', '$localStorage', 'AppAPI', 'Auth', 'DataService'];

    function EmpClaimController($state, $log, $mdDialog, $localStorage, AppAPI, Auth, DataService) {
        var vm = this;
        var Insurance = AppAPI.Insurance();
        vm.DataTable = new DataService();
        // console.log($localStorage);
        vm.group = $localStorage.group;
        vm.user = $localStorage.user;

        vm.listSelected = [];

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.listStatus = ['all', 'waiting', 'accept', 'reject'];
        vm.loadData = loadData;
        vm.detail = detail;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.acceptList = acceptList;
        vm.rejectList = rejectList;
        vm.progress = progress;
        vm.timeLine = timeLine;

        // loadData(1);
        loadDataBU();
        loadDataDivision(vm.company);
        loadDataDepartment(vm.divisi);


        function loadData(pageno) {
            vm.listSelected = [];
            vm.DataTable.loadData(Insurance, pageno, {
                action: "viewEmpInsuranceClaim",
                nik: vm.nik,
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.start_date,
                endDate: vm.end_date,
                status: vm.status
            })
        }

        function detail(id) {
            $state.go('app.insurance_emp-claim_detail', {
                id: id
            });
        }

        function progress(data) {
            $state.go('app.insurance-progress', {
                nik: data.nik,
                regNo: data.no_register,
                registerDate: data.receipt_date
            });
        }

        function acceptList() {
            console.log(vm.listSelected);
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to eccept this list?')
                    .textContent('All data your selected will be accepted.')
                    .ariaLabel('eccept dialog')
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Insurance.save({
                        action: 'approval',
                        data: angular.toJson(vm.listSelected),
                        status: 'accept'
                    });

                    response.$promise.then(loadData(1));
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });

            });
        }

        function rejectList() {
            console.log(vm.listSelected);
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to accept this list?')
                    .textContent('All data your selected will be rejected.')
                    .ariaLabel('reject dialog')
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Insurance.save({
                        action: 'approval',
                        data: angular.toJson(vm.listSelected),
                        status: 'reject'
                    });

                    response.$promise.then(loadData(1));
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });

            });
        }

        function timeLine(ev, id) {
            $mdDialog.show({
                controller: 'ClaimTimelineController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insurance/emp-claim/claim-timeline.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }

        // load bu
        function loadDataBU() {
            var response = Insurance.query({
                action: 'viewBU'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        // load division
        function loadDataDivision(idbu) {
            var response = Insurance.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        // load department
        function loadDataDepartment(iddivisi) {
            var response = Insurance.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

    }
})();

(function(){
	'use strict';

	angular
		.module('app.insurance.emp-insurance',[])
		.config(config);
	config.$inject = ['$stateProvider'];

	function config($stateProvider) {
		// state list emp insurance
		$stateProvider
			.state('app.insurance_emp-insurance_list',{
				url : '/insurance/employe/list',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/emp-insurance/emp-insurance.html',
						controller  : 'EmpInsuranceController as vm' 

					},
				}
			});

		// state input emp insurance
		$stateProvider
			.state('app.insurance_emp-insurance_input',{
				url : '/insurance/employe/input',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/emp-insurance/input-emp-insurance.html',
						controller  : 'InputEmpInsuranceController as vm'

					},
				}
			})

		// state input emp insurance
		$stateProvider
			.state('app.insurance_emp-insurance_edit',{
				url : '/insurance/employe/input/:id',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/emp-insurance/input-emp-insurance.html',
						controller  : 'InputEmpInsuranceController as vm'

					},
				}
			})

		// state emp insurance detail
		$stateProvider
			.state('app.insurance_emp-insurance_detail',{
				url : '/insurance/employe/detail/:id',
				views : {
					'content@app' : {
						templateUrl : 'app/main/insurance/emp-insurance/emp-insurance-detail.html',
						controller  : 'EmpInsuranceDetailController as vm'

					},
				}
			})				
	}

})();
(function () 
{
    'use strict';

    angular
    .module('app.insurance.emp-insurance')
    .controller('EmpClaimViewDocController', EmpClaimViewDocController);
    EmpClaimViewDocController.$inject=['$mdDialog', 'doc','master'];
    /** @ngInject */
    function EmpClaimViewDocController($mdDialog, doc, master)
    {
        var vm = this;
        vm.closeModal = closeModal;
        vm.name = doc.name;
        vm.doc_type=false;

        fetchData();
        function fetchData() {
            if (doc.doc_location.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;            
                vm.doc = doc.doc_location;
            }
            vm.url = 'api/insurancedocument/'+doc.doc_location+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function closeModal(){
          $mdDialog.hide();
        }

    }
})();  

(function () {
    'use strict';
    angular
        .module('app.insurance.emp-claim')
        .controller('EmpClaimEmployeController', EmpClaimEmployeController);

    EmpClaimEmployeController.$inject = ['$state', '$log', '$mdDialog', '$localStorage', 'AppAPI', 'Auth', 'DataService'];

    function EmpClaimEmployeController($state, $log, $mdDialog, $localStorage, AppAPI, Auth, DataService) {
        var vm = this;
        var Insurance = AppAPI.Insurance();
        vm.DataTable = new DataService();
        vm.nik = $localStorage.user;
        vm.company = $localStorage.empsite;

        vm.listSelected = [];

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.listStatus = ['all', 'waiting', 'accept', 'reject'];
        vm.loadData = loadData;
        vm.detail = detail;
        vm.editData = editData;
        vm.progress = progress;
        vm.timeLine = timeLine;

        loadData(1);
        loadEmpInsurance();

        function loadData(pageno) {
            vm.DataTable.loadData(Insurance, pageno, {
                action: "viewEmpInsuranceClaim",
                nik: vm.nik,
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                startDate: vm.start_date,
                endDate: vm.end_date,
                status: vm.status
            })
        }

        function progress(data) {
            $state.go('app.insurance-progress', {
                nik: data.nik,
                regNo: data.no_register,
                registerDate: data.receipt_date
            });
        }


        function detail(id) {
            $state.go('app.insurance_emp-claim_detail', {
                id: id
            });
        }

        function editData(data) {
            $state.go('app.insurance_emp-claim_edit', {
                id: data
            });
        }


        function loadEmpInsurance() {
            var response = Insurance.query({
                action: 'getEmpInsurance',
                id: $localStorage.user,
                type: "get"
            });
            response.$promise.then(function (data) {
                vm.claimRelationList = data[0].detail;
                vm.noRegister = data[0].no_register;
                loadPlan(data[0].plan_code);
            });
        }

        function loadPlan(id) {

            var response = Insurance.query({
                action: 'getPlan',
                id: id,
                type: "get"
            });
            response.$promise.then(function (data) {
                vm.planInsuranceDetail = data[0].detail;
                vm.planDescription = data[0].description;
                vm.planAnnualInpatientClaims = data[0].annual_inpatient_claims;
                vm.planAnnualOutpatientClaims = data[0].annual_outpatient_claims;
                vm.planAnnualDentalClaims = data[0].annual_dental_claims;
                vm.planEyeglassesAnualClaims = data[0].eyeglasses_anual_claims;
            });
        }

        function timeLine(ev, id) {
            $mdDialog.show({
                controller: 'ClaimTimelineController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insurance/emp-claim/claim-timeline.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }


    }
})();

(function(){
  'use strict';

  angular
    .module('app.insurance.emp-insurance')
    .controller('EmpClaimDetailController', EmpClaimDetailController);

    EmpClaimDetailController.$inject =  ['$http','$state', '$mdDialog', '$log','$window', '$stateParams', '$localStorage', '$location', 'AppAPI', 'Form', 'config'];

    function EmpClaimDetailController($http,$state, $mdDialog, $log, $window, $stateParams, $localStorage, $location, AppAPI, Form, config) {
      var vm = this;
      var Insurance = AppAPI.Insurance();
      vm.viewDocument = viewDocument;
      Form.initialForm();
      Form.setObject(Insurance);
      vm.Form = Form;
      vm.back = back;
      vm.postComment = postComment;
      vm.download = downloadDoc;
      vm.checklist = checklist;
      vm.unchecklist = unchecklist;
      vm.group = $localStorage.group;
      vm.user = $localStorage.user;
      
      loadData(); 

      function back() {
        $window.history.back();
      }

      function loadData(){
        var responses = vm.Form.objForm.$get({action:'getEmpInsuranceClaim', id:$stateParams.id});
        responses.then(function(data){
          var submitDate = new Date(data.submit_date);
          var receiptDate = new Date(data.receipt_date);
          vm.Form.objForm.submit_date = submitDate;
          vm.Form.objForm.receipt_date = receiptDate;
        });
      }

	    function viewDocument(ev, dataDoc, dataMaster) {
        $mdDialog.show({
            controller         : 'EmpClaimViewDocController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/insurance/emp-claim/emp-claim-view-doc.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: false,
            locals:{
              doc:dataDoc,
              master : dataMaster
            }
        });
      }

      function postComment() {

        var response=Insurance.save({action:'saveEmpInsuranceClaimComment', comment:vm.comment, user:$localStorage.nama, id:vm.Form.objForm.id} );
        response.$promise.then( function(data){
          var confirm = $mdDialog.confirm()
              .title('Success.!')
              .textContent(data.pesan)
              .ariaLabel('Lucky day')
              .ok('Close');

              $mdDialog.show(confirm).then(function() {
                  loadData();
                  vm.comment = "";
                  $mdDialog.cancel();
              }, function() {
                alert("cancel");
              });
        });
      }

      function downloadDoc(data) {
        var name=data.doc_location;
        // console.log(link);
        if(name !==null && name !=='-') {
            $http({
                method: 'GET',
                url: config.api+'api/insurancedocument/'+name,
                params: { name: name },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();
                // console.log(data);
                var filename = name;
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);

                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).error(function (data) {
                console.log(data);
            });
        } 

        else {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Document Not Found')
            .textContent('Document not Found')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
        }
      }

      function checklist(id) {
          var confirm = $mdDialog.confirm()
              .title('Confirm.!')
              .textContent("are you sure.?")
              .ariaLabel('Lucky day')
              .cancel('Cancle')
              .ok('Confirm');

              $mdDialog.show(confirm).then(function() {

                var response=Insurance.save({action:'phisicalUpdate', id:id} );
                response.$promise.then( function(data){
                  loadData(); 
                  $mdDialog.cancel();
                });

              }, function() {
                loadData();
                $mdDialog.cancel();
              });
      }

      function unchecklist(id) {
          var confirm = $mdDialog.confirm()
              .title('Confirm.!')
              .textContent("are you sure.?")
              .ariaLabel('Lucky day')
              .cancel('Cancle')
              .ok('Confirm');

              $mdDialog.show(confirm).then(function() {

                var response=Insurance.save({action:'phisicalUpdateUncheck', id:id} );
                response.$promise.then( function(data){
                  loadData(); 
                  $mdDialog.cancel();
                });

              }, function() {
                loadData();
                $mdDialog.cancel();
              });
      }      

    }

})();

(function(){
	'use strict';

	angular
		.module('app.insurance.emp-claim')
		.controller('ClaimTimelineController', ClaimTimelineController);

	ClaimTimelineController.$inject = ['$state','$localStorage', '$mdDialog', 'Form', 'AppAPI', 'id'];

	function ClaimTimelineController($state, $localStorage, $mdDialog, Form, AppAPI, id){
		var vm = this;
		Form.initialForm();		

		var Insurance = AppAPI.Insurance();
		Form.setObject(Insurance);
		vm.Form = Form;
		vm.Form.objForm.insurance_plan_id = id;
		vm.closeModal = closeModal;

    loadData();
    
    function closeModal(){
      $mdDialog.hide();
    }

    function showDialog(ev) {
       $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Success Save Data')
        .textContent('Process Data was Success.')
        .ariaLabel('Success Save Data')
        .ok('OK')
        .targetEvent(ev)
        ).then(function(){
            closeModal();
            $state.go('app.insurance_insurance-plan_detail',{id:id});
        });
    }

    function loadData(){
      var responses = vm.Form.objForm.$get({action:'empInsuranceClaimTimeline', id:id});

      responses.then(function(data){
        console.log(data);
        vm.data = data;
      });

    }
	}


})();
(function() {
  'use strict';

  angular
    .module('app.insurance.emp-insurance')
    .controller('RegisterNumberController', RegisterNumberController);

  RegisterNumberController.$inject = ['$mdDialog', '$filter', '$window', '$location', '$mdDateLocale', 'id', 'registerNumber', 'AppAPI', 'Auth','config'];

  function RegisterNumberController($mdDialog, $filter, $window, $location, $mdDateLocale, id, registerNumber, AppAPI, Auth, config) {
    var vm = this;
    var Insurance = AppAPI.Insurance();
    
    vm.registerNumber = registerNumber;
    vm.id = id;
    
    // vm.data = data;
    vm.closeModal = closeModal;
    vm.submit = submit;
    vm.reloadToken = reloadToken;

    function closeModal() {
      $mdDialog.cancel();
    }

    function submit(ev) {
      var response=Insurance.save({action:'registerNumber', id:vm.id, regNumber:vm.registerNumber} );
      response.$promise.then( function(data){

        var confirm = $mdDialog.confirm()
            .title('Success.!')
            .textContent(data.pesan)
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Ok')

            $mdDialog.show(confirm).then(function() {

                closeModal();
            }, function() {
              
            });

      });

    }

    function reloadToken(){
      Auth.setToken();
    }

  }

})();

(function(){
	'use strict';

	angular
		.module('app.insurance.emp-insurance')
		.controller('InputEmpInsuranceController', InputEmpInsuranceController);

		InputEmpInsuranceController.$inject=['$state', '$log', '$localStorage', '$timeout', '$stateParams', 'AppAPI', 'Auth', 'Form'];
		
		function InputEmpInsuranceController($state, $log, $localStorage, $timeout, $stateParams, AppAPI, Auth, Form) {
			var vm = this;

			var Insurance = AppAPI.Insurance();
			Form.initialForm();
			Form.setObject(Insurance);

			vm.clearMeesage = clearMeesage;
			vm.reloadToken = reloadToken;

			vm.saveData = saveData;

			vm.loadEmploye = loadEmploye;
			
			vm.Form = Form;
			vm.Breadhome="app.pms_dashboard";
			vm.Breadlist=[
				{link:'app.insurance', name:'Insurance', active:'0'},
				{link:'#', name:'Input Employe Insurance', active:'0'}
			];

			if ($stateParams.id !== undefined) {
				var responses = vm.Form.objForm.$get({action:'getEmpInsurance',id:$stateParams.id});
				responses.then(function(data){
					loadEmploye(data.nik);
				})
			}

			loadPlan();

			function saveData(formController) {
				angular.element.blockUI();
				var response = Form.saveData('saveEmpInsurance', formController, Insurance);

				response.then( function(){
					vm.messageTheme = 'blue';
					angular.element.unblockUI();
					formController.$setPristine();
					$timeout(function(){
						vm.Form.tampilPesan = false;
					}, 3000);

				});
			}

			function clearMeesage() {
	      vm.Form.tampilPesan=false;
	    }

	    function reloadToken(){
	    	Auth.setToken();
	    }


	    // load plan
	    function loadPlan(){
	    	var response = Insurance.query({action:'viewPlan', limit:'0', jumPage:'1000'});
	    	response.$promise.then(fetchPlan);
	    }

	    function fetchPlan(data) {
	    	vm.listPlan = data[0].aData;
	    }

			function loadEmploye(param) {
				var response = Insurance.query({action:'viewEmploye', param:param});
				response.$promise.then(function(data){
					vm.Form.objForm.empName = data[0]['empName'];
					vm.Form.objForm.empId = data[0]['empId'];
					vm.Form.objForm.maternity = data[0]['maternity'];
				});
			}

		}
})();
(function(){
	'use strict';

	angular
		.module('app.insurance.emp-insurance')
		.controller('InputEmpInsuranceDetailController', InputEmpInsuranceDetailController);

	InputEmpInsuranceDetailController.$inject = ['$state','$localStorage', '$mdDialog', 'Form', 'AppAPI', 'id', 'empId'];

	function InputEmpInsuranceDetailController($state, $localStorage, $mdDialog, Form, AppAPI, id, empId){
		var vm = this;
		Form.initialForm();		

		var Insurance = AppAPI.Insurance();
		Form.setObject(Insurance);
		vm.Form = Form;
		vm.Form.objForm.emp_insurance_id = id;
		vm.closeModal = closeModal;
		vm.saveData = saveData;
    console.log(empId);
    loadDependant(empId);

		function saveData(ev, formController){
			var promise = Form.saveData('saveEmpInsuranceDetail', formController, Insurance);
      promise.then(function(){
        showDialog(ev);
      });
		}

    function closeModal(){
      $mdDialog.hide();
    }

    function showDialog(ev) {
       $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Success Save Data')
        .textContent('Process Data was Success.')
        .ariaLabel('Success Save Data')
        .ok('OK')
        .targetEvent(ev)
        ).then(function(){
            closeModal();
            $state.go('app.insurance_emp-insurance_detail',{id:id});
        });
    }

      function loadDependant(param) {
        var response = Insurance.query({action:'viewDependent', param:param});
        response.$promise.then(function(data){
          vm.listDependant = data[0];
        });
      }

	}


})();
(function(){
	'use strict';

	angular
		.module('app.insurance.emp-insurance')
		.controller('EmpInsuranceController', EmpInsuranceController);

	EmpInsuranceController.$inject = ['$state', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService'];

	function EmpInsuranceController($state, $log, $mdDialog, AppAPI, Auth, DataService){
		var vm = this;
		var Insurance = AppAPI.Insurance();
		vm.DataTable= new DataService();

		// set Breadhome
		vm.Breadhome="app.pms_dashboard";
		vm.Breadlist=[
			{link:'app.insurance', name:'Insurance', active:'0'},
			{link:'#', name:'List Employe insurance', active:'0'}
		];

		vm.listTypeSelected = [];

		vm.listJum = [2,5,25,50,75,100,200];
		vm.loadData = loadData;
		vm.editData = editData;
		vm.deleteList = deleteList;
		vm.loadDataDivision=loadDataDivision;
		vm.loadDataDepartment=loadDataDepartment;
		vm.detail = detail;


		loadData(1);
		loadDataBU();
		loadDataDivision(vm.company);
		loadDataDepartment(vm.divisi);

		function loadData(pageno) {
			vm.DataTable.loadData(Insurance, pageno, {
				action:'viewEmpInsurance',
				nik:vm.nik,
				company:vm.company,
				divisi:vm.divisi,
				department:vm.department
			});

		}

		function editData(data){
			$state.go('app.insurance_emp-insurance_edit',{id:data});
		}

		function deleteList(ev) {
			var promise = Auth.setToken();
			promise.then(function(){
				var confirm = $mdDialog.confirm()
				.title('Would you like to delete this list?')
	  		.textContent('All data your selected will be deleted and can not recovered.')
				.ariaLabel('delete dialog')
				.targetEvent(ev)
				.ok('YES')
				.cancel('no');

		    $mdDialog.show(confirm).then(function() {
          angular.element.blockUI();
          var response=Insurance.delete({action:'deleteEmpInsurance', data:angular.toJson(vm.listTypeSelected)});

          response.$promise.then(loadData(1));
        }, function() {
         // $scope.status = 'You decided to keep your debt.';
        });

			});
		}

		function detail(data) {
			$state.go('app.insurance_emp-insurance_detail',{id:data});
		}


    // load bu
    function loadDataBU(){
    	var response = Insurance.query({action:'viewBU'});
    	response.$promise.then(fetchBU);
    	response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU=data;
    }

    function errorFetchBU() {
      vm.listBU=[];
    }

		// load division
	  function loadDataDivision(idbu) {
      var response=Insurance.query({action:'viewDivisiBu',idbu:idbu});
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
     vm.listDivision=data;
    }

    function errorDivisiBU() {
      vm.listDivision=[];
    }

    // load department
    function loadDataDepartment(iddivisi) {
      var response=Insurance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment=data;
    }

    function errorDepartment() {
      vm.listDepartment=[];
    }

	}

})();

(function(){
	'use strict';

	angular
		.module('app.insurance.emp-insurance')
		.controller('EmpInsuranceDetailController', EmpInsuranceDetailController);

		EmpInsuranceDetailController.$inject =	['$state', '$log', '$timeout', '$stateParams', '$filter', '$mdDialog', 'AppAPI' ,'Auth', 'Form', 'DataService'];

		function EmpInsuranceDetailController($state, $log, $timeout, $stateParams, $filter, $mdDialog, AppAPI, Auth, Form, DataService) {
			var vm = this;
			var Insurance = AppAPI.Insurance();

			Form.initialForm();

			loadData();

			// set Breadhome
			vm.Breadhome="app.pms_dashboard";
			vm.Breadlist=[
				{link:'app.insurance', name:'Insurance', active:'0'},
				{link:'#', name:'Employe Insurance Detail', active:'0'}
			];

			function loadData(){
				// set construct form
				Form.setObject(Insurance);

				// set form to controller
				vm.Form = Form;
				vm.inputRegisterNumber =inputRegisterNumber;

				var response = vm.Form.objForm.$get({action:'getEmpInsurance',id:$stateParams.id});
				response.then(function(data){
					//console.log(data.detail);
					vm.claimRelationList = data.detail;
				  vm.ip = vm.Form.objForm.ip;
				  vm.op = vm.Form.objForm.op;
				  vm.de = vm.Form.objForm.de;
				  vm.eg = vm.Form.objForm.eg;
				});

			}

			function inputRegisterNumber(data) {
				$mdDialog.show({
	        controller         : 'RegisterNumberController',
	        controllerAs       : 'vm',
	        templateUrl        : 'app/main/insurance/emp-insurance/register-number.html',
	        parent: angular.element(document.body),
	        clickOutsideToClose:true,
	        fullscreen: true,
	        onRemoving:function(element, removePromise){
	          loadData();
	        },
	        locals:{
	          id:data.id,
	          registerNumber:data.no_register
	        }
	      });
			}

		}

})();

(function() {
    "use strict";

    angular.module("app.indisciplinary-validation", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.indisciplinary_validation", {
            url: "/indisciplinary-validation",
            views: {
                "content@app": {
                    templateUrl:
                        "app/main/indisciplinary-validation/indisciplinary-validation.html",
                    controller: "IndisciplinaryValidationController as vm"
                }
            }
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("app.indisciplinary-validation")
        .controller("FormIndisciplynaryValidationController", Controller);

    Controller.$inject = [
        "$state",
        "$mdDialog",
        "AppAPI",
        "REF_DATA",
        "Auth",
        "$timeout",
        "$scope",
        "$q"
    ];
    /** @ngInject */
    function Controller(
        $state,
        $mdDialog,
        AppAPI,
        REF_DATA,
        Auth,
        $timeout,
        $scope,
        $q
    ) {
        var vm = this;
        var endpoint = AppAPI.IndisciplinaryValidation();
        vm.letterList = [];
        vm.tempValidFrom = undefined;
        vm.tempValidTo = undefined;
        vm.data = angular.copy(REF_DATA);
        vm.letterTypeOfAction = [];
        vm.form = {};
        vm.success = false;
        vm.message = "";
        vm.isLoading = false;
        vm.showMessage = false;
        vm.saveProccess = false;
        vm.isValid = [
            { id: 0, name: "register" },
            { id: 1, name: "valid" },
            { id: 2, name: "invalid" }
        ];
        vm.template = [
            { id: 1, text: "Request is valid" },
            { id: 1, text: "There is adjustment in" }
        ];
        vm.setToken = setToken;

        // METHOD
        vm.hide = hide;
        vm.setForm = setForm;
        vm.onChangeLetter = onChangeLetter;
        vm.submit = submit;
        vm.confirmationDialog = confirmationDialog;
        vm.addTemplate = addTemplate;
        vm.cancel = cancel;

        ///////////// MAIN ////////////////

        activate();

        function activate() {
            initFormOptions();
        }

        function setForm(form) {
            vm.form = form;
        }

        function initFormOptions() {
            vm.isLoading = true;
            loadLetter()
                .then(setListLetter)
                .then(loadTypeOfAction)
                .then(setListTypeOfAction)
                .then(setValue)
                .catch(function(error) {
                    console.log(error);
                });
        }

        function addTemplate(item) {
            if (vm.data.notes) {
                vm.data.notes += item.text;
            } else {
                vm.data.notes = item.text;
            }
        }

        function setValue() {
            var defer = $q.defer();
            vm.tempValidFrom = new Date(vm.data.valid_from);
            vm.tempValidTo = new Date(vm.data.valid_to);
            $timeout(function() {
                defer.resolve();
                vm.isLoading = false;
            }, 1000);
            return defer.promise;
        }

        function loadLetter() {
            var request = endpoint.query({
                action: "getLetter"
            });
            return request.$promise;
        }

        function loadTypeOfAction() {
            var request = endpoint.query({
                action: "getLetterTypeOfAction",
                letter_code: vm.data.letter_code
            });
            return request.$promise;
        }

        function setListLetter(letters) {
            var defer = $q.defer();
            vm.letterList = letters;
            $timeout(function() {
                defer.resolve();
            }, 500);
            return defer.promise;
        }

        function setListTypeOfAction(actions) {
            var defer = $q.defer();
            console.log(actions);
            vm.letterTypeOfAction = actions;
            $timeout(function() {
                defer.resolve();
            }, 500);
            return defer.promise;
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function onChangeLetter(item) {
            vm.isLoading = true;
            adjustValidDate(item);
            loadTypeOfAction()
                .then(setListTypeOfAction)
                .then(function() {
                    vm.isLoading = false;
                    vm.form.type_of_action.$setValidity("required", false);
                })
                .catch(function() {
                    vm.isLoading = false;
                });
        }

        function adjustValidDate(letterCode) {
            var letter = {};
            for (var i = 0; i < vm.letterList.length; i++) {
                if (vm.letterList[i].code === letterCode) {
                    letter = vm.letterList[i];
                    break;
                }
            }
            var tmpValidFrom = angular.copy(vm.tempValidFrom);
            var addValidityPeriod = moment(tmpValidFrom)
                .add(letter.validity_period, "M")
                .format("YYYY-MM-DD");

            vm.tempValidTo = new Date(addValidityPeriod);
            vm.data.validity_period = letter.validity_period;
        }

        $scope.$watch("vm.tempValidFrom", function(nVal) {
            if (nVal) {
                var tmpValidFrom = angular.copy(vm.tempValidFrom);
                var addValidityPeriod = moment(tmpValidFrom)
                    .add(vm.data.validity_period, "M")
                    .format("YYYY-MM-DD");
                vm.tempValidTo = new Date(addValidityPeriod);
            }
        });

        function submit(ev, form) {
            vm.saveProccess = true;
            vm.isLoading = true;
            var payload = {
                id: vm.data.id,
                nik: vm.data.nik,
                letter_code: vm.data.letter_code,
                letter_type_of_action_id: vm.data.action_type_id,
                valid_from: form.temp_valid_from.$viewValue,
                valid_to: form.temp_valid_to.$viewValue,
                validity_period: vm.data.validity_period,
                reason: vm.data.reason,
                is_valid: vm.data.is_valid,
                notes: vm.data.notes,
                letter_number: vm.data.letter_number
            };

            Auth.setToken().then(function() {
                var request = endpoint.save({
                    action: "submit",
                    data: payload
                });

                request.$promise.then(function(res) {
                    form.$setUntouched();
                    form.$setPristine();
                    vm.success = true;
                    vm.message = res.message;
                    vm.isLoading = false;
                    vm.showMessage = true;
                    vm.saveProccess = false;
                    showDialog(ev, true, vm.message);
                });

                request.$promise.catch(function(res) {
                    form.$setUntouched();
                    form.$setPristine();
                    vm.success = false;
                    vm.message = res.data.message;
                    vm.isLoading = false;
                    vm.showMessage = true;
                    vm.saveProccess = false;
                    showDialog(ev, false, vm.message);
                });
            });
            console.log(payload);
        }

        function setToken() {
            Auth.setToken().then(function() {
                console.log("token set");
            });
        }

        function confirmationDialog(ev, ref) {
            var confirm = $mdDialog
                .confirm()
                .title("Confirmation")
                .textContent("Are you sure want to do this action ?")
                .ariaLabel("confirmation dialog")
                .targetEvent(ev)
                .multiple(true)
                .ok("YES")
                .cancel("NO");

            $mdDialog.show(confirm).then(function() {
                submit(ev, ref);
            });
        }

        function showDialog(ev, status, message) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? "Success" : "Failed")
                        .textContent(message)
                        .ariaLabel("Response Dialog")
                        .multiple(true)
                        .ok("OK")
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.indisciplinary-request', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.indisciplinary-request', {
            url: '/indisciplinary-request',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/indisciplinary-request/indisciplinary-request.html',
                    controller: 'IndisciplinaryRequestController as vm'
                }
            }
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("app.indisciplinary-request")
        .controller("IndisciplinaryRequestViewApprovalController", Controller);

    Controller.$inject = [
        "AppAPI",
        "Auth",
        "$mdDialog",
        "Form",
        "reffData",
        "$timeout",
        "$http",
        "config",
        "$localStorage"
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        reffData,
        $timeout,
        $http,
        config,
        $localStorage
    ) {
        var vm = this;
        var Endpoint = AppAPI.IndisciplinaryRequest();
        vm.hide = hideDialog;
        vm.approvalList = [];
        vm.switchStatusApproval = switchStatusApproval;
        vm.data = {};
        vm.documentData = reffData.document_filename
            ? reffData.document_filename
            : "no-data.pdf";
        vm.trustedFile =
            config.api + "api/indisciplinaryDocument/" + vm.documentData;
        vm.getStatus = getStatus;
        vm.getConfirmStatus = getConfirmStatus;

        console.log(reffData);

        activate();

        function activate() {
            vm.data = reffData;
        }

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }

        function switchStatusApproval(status) {
            switch (status) {
                case "0":
                    return "None";
                case "1":
                    return "Waiting Approval";
                case "2":
                    return "Approved";
                case "3":
                    return "Revised";
                case "4":
                    return "Rejected";
            }
        }

        function getStatus(status) {
            switch (status) {
                case "0":
                    return "<span class='blue-600-fg'>REGISTER</span>";
                case "1":
                    return "<span class='green-600-fg'>VALID</span>";
                case "2":
                    return "<span class='red-600-fg'>INVALID</span>";
            }
        }

        function getConfirmStatus(status) {
            switch (status) {
                case "0":
                    return "<span class='red-600-fg'>UNCONFIRMED</span>";
                case "1":
                    return "<span class='green-600-fg'>CONFIRMED</span>";
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.indisciplinary-request')
        .controller('IndisciplinaryUploadDocumentController', Controller);

    Controller.$inject = [
        'AppAPI',
        'Auth',
        '$mdDialog',
        'Form',
        'reffData',
        '$timeout',
        '$http',
        'config',
        '$localStorage',
        'FileUploader',
        '$sce'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        reffData,
        $timeout,
        $http,
        config,
        $localStorage,
        FileUploader,
        $sce
    ) {
        var vm = this;
        var Endpoint = AppAPI.IndisciplinaryRequest();
        vm.hide = hideDialog;
        vm.trustFile = trustFile;
        vm.documentData = reffData.document_filename
            ? reffData.document_filename
            : 'no-data.pdf';
        vm.trustedFile =
            config.api + 'api/indisciplinaryDocument/' + vm.documentData;

        console.log(vm.trustedFile);
        vm.URLHelper = URL;
        vm.options = {};
        vm.downloadDocument = downloadDocument;

        activate();

        function activate() {
            console.log(reffData);
        }

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }

        vm.fileUploadDocument = new FileUploader({
            headers: {
                tokenAuth: $localStorage.tokenAuth
            },
            url: config.api + 'api/indisciplinary/uploadDocument',
            removeAfterUpload: true,
            alias: 'document',
            formData: [
                {
                    action: 'uploadDocument',
                    id: reffData.id,
                    nik: reffData.nik,
                    subAreaId: reffData.sub_area_id,
                    validFrom: reffData.valid_from,
                    validTo: reffData.valid_to
                }
            ],
            onAfterAddingAll: function() {
                vm.UploadDocumentStateSucces = false;
                vm.UploadDocumentStateError = false;
            },
            onAfterAddingFile: function(file) {
                var fileURL = URL.createObjectURL(file._file);
                vm.trustedFile = $sce.trustAsResourceUrl(fileURL);
            },
            onSuccessItem: function(item) {
                vm.UploadDocumentStateSucces = true;
                vm.UploadDocumentStateError = false;
            },
            onErrorItem: function(item) {
                vm.UploadDocumentStateSucces = false;
                vm.UploadDocumentStateError = true;
            }
        });

        function downloadDocument() {
            $http({
                method: 'GET',
                url: 'api/indisciplinaryDocument/' + vm.documentData,
                responseType: 'arraybuffer'
            })
                .success(function(data, status, headers) {
                    headers = headers();

                    var filename = headers['x-filename'];
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute('download', vm.documentData);

                        var clickEvent = new MouseEvent('click', {
                            view: window,
                            bubbles: true,
                            cancelable: false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                })
                .error(function(data) {
                    console.log(data);
                });
        }

        function getCurrentImage(filename) {
            var apiCall = $http.get(config.api + 'api/empdocument/' + filename, {
                responseType: 'blob'
            });
            apiCall
                .success(function(file) {
                    var mimetype = file.type;
                    var createFile = new File([file], filename, {
                        type: mimetype
                    });
                    var current = new FileUploader.FileItem(
                        vm.fileUploadDocument,
                        {}
                    );
                    current._file = createFile;
                    current.progress = 100;
                    current.isUploaded = true;
                    current.isSuccess = true;
                    vm.fileUploadDocument.queue.push(current);
                })
                .error(function(error) {
                    var handler = $http.get('/assets/images/avatars/profile.jpg', {
                        responseType: 'blob'
                    });
                    handler.success(function(file) {
                        var mimetype = file.type;
                        var createFile = new File([file], filename, {
                            type: mimetype
                        });
                        var defaultDoc = new FileUploader.FileItem(
                            vm.fileUploadDocument,
                            {}
                        );
                        defaultDoc._file = createFile;
                        defaultDoc.progress = 100;
                        defaultDoc.isUploaded = true;
                        defaultDoc.isSuccess = true;
                        vm.fileUploadDocument.queue.push(defaultDoc);
                    });
                });
        }

        function trustFile(data) {
            var fileURL = URL.createObjectURL(data);
            return $sce.trustAsResourceUrl(fileURL);
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.indisciplinary-request")
        .controller("IndisciplinaryRequestFormController", Controller);

    Controller.$inject = [
        "AppAPI",
        "Auth",
        "$mdDialog",
        "Form",
        "dialogType",
        "reffData",
        "isAdmin",
        "$timeout",
        "$http",
        "config",
        "$localStorage",
        "$scope"
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        dialogType,
        reffData,
        isAdmin,
        $timeout,
        $http,
        config,
        $localStorage,
        $scope
    ) {
        var vm = this;
        var Endpoint = AppAPI.IndisciplinaryRequest();
        vm.loadingProgress = true;
        vm.searchTerm = "";
        vm.create = false;
        vm.update = false;
        vm.setToken = Auth.setToken;
        vm.hide = hideDialog;
        vm.dialogType = dialogType;
        vm.reffData = reffData;
        vm.loadingProgress = true;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.isEmployeeFound = false;
        vm.employee = {};
        vm.letter = [];
        vm.setLetterTypeOfAction = setLetterTypeOfAction;
        vm.letterTypeOfAction = [];
        vm.setTypeOfAction = setTypeOfAction;
        vm.isCheckedAction = isCheckedAction;
        vm.loadTypeOfAction = false;
        vm.isReady = false;
        vm.selectedTypeOfAction = null;

        vm.showFormEntity = {
            validFrom: false,
            validTo: false,
            concerning: false,
            reason: false,
            releaseDate: true,
            skorsingStartDate: false,
            skorsingLengthDate: false
        };

        vm.getLengthOfService = getLengthOfService;
        vm.validLabel = "";
        vm.messageAction = "";
        vm.isMessageAction = false;

        vm.success = false;

        vm.submit = submit;

        // initial form
        Form.initialForm();
        // set constructor form
        Form.setObject(Endpoint);
        // set form to controller
        vm.Form = Form;

        activate();

        function activate() {
            initComponents();
        }

        function initComponents() {
            $timeout(function(params) {
                vm.loadingProgress = false;
            }, 2000);
        }

        function selectedItemChange(item) {
            if (item) {
                // vm.isOtherAction = false;
                setAvailableLetter(item.nik);
            }
        }

        function querySearch(params) {
            var url = "indisciplinary";
            if (isAdmin) {
                url = "indisciplinaryadmin";
            }
            console.log("isAdmin", isAdmin);
            return $http
                .get(
                    config.api +
                        "api/" +
                        url +
                        "/findEmployee?search=" +
                        params +
                        "&company=" +
                        $localStorage.empsite
                )
                .then(function(item) {
                    return item.data;
                });
        }

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }

        function setAvailableLetter(nik) {
            vm.isReady = false;
            var request = Endpoint.get({
                action: "getAvailableLetter",
                nik: nik
            });
            request.$promise.then(function(response) {
                vm.isEmployeeFound = true;
                vm.employee = response.employeeInfo;
                vm.letter = response.letter;
                vm.baseImageUrl += vm.employee.photo_address;
                if (response.status) {
                    vm.messageAction = response.message;
                    vm.isMessageAction = true;
                }
            });
            request.$promise.catch(function(error) {
                console.log(error);
            });
        }

        function setLetterTypeOfAction(letterCode) {
            vm.isReady = false;
            vm.selectedTypeOfAction = null;
            vm.loadTypeOfAction = true;

            if (!vm.Form.objForm.letter_type) {
                vm.letterTypeOfAction = [];
            }

            var request = Endpoint.query({
                action: "getLetterTypeOfAction",
                letter_code: letterCode
            });

            request.$promise.then(function(response) {
                $timeout(function() {
                    vm.loadTypeOfAction = false;
                    vm.letterTypeOfAction = response;
                }, 1000);
            });

            request.$promise.catch(function(error) {
                $timeout(function() {
                    vm.loadTypeOfAction = false;
                    vm.letterTypeOfAction = [];
                }, 1000);
            });
        }

        function setTypeOfAction(item) {
            if (item.isChecked) {
                vm.selectedTypeOfAction = item;
                vm.letterTypeOfAction.map(function(val) {
                    if (item.id !== val.id) {
                        val.isChecked = false;
                    }
                });
            } else {
                item.isChecked = true;
            }
        }

        function isCheckedAction(action) {
            if (action.is_checked == "1") {
                return true;
            }
            return false;
        }

        $scope.$watch("vm.selectedTypeOfAction", function(newVal, oldVal) {
            if (newVal !== null) {
                vm.isReady = true;
                switch (newVal.letter_code) {
                    case "SURAT_TEGURAN":
                    case "SP1":
                    case "SP2":
                    case "SP3":
                    case "SURAT_REKOMENDASI_DEMOSI_RESIGN":
                    case "SURAT_REKOMENDASI_PERCEPATAN_PKWT":
                        vm.showFormEntity.validFrom = true;
                        vm.showFormEntity.validTo = true;
                        vm.showFormEntity.concerning = true;
                        vm.showFormEntity.reason = true;
                        vm.showFormEntity.releaseDate = true;
                        vm.showFormEntity.skorsingStartDate = false;
                        vm.showFormEntity.skorsingLengthDate = false;
                        break;
                    case "SURAT_SKORSING":
                        vm.showFormEntity.validFrom = false;
                        vm.showFormEntity.validTo = false;
                        vm.showFormEntity.concerning = true;
                        vm.showFormEntity.reason = true;
                        vm.showFormEntity.releaseDate = true;
                        vm.showFormEntity.skorsingStartDate = true;
                        vm.showFormEntity.skorsingLengthDate = true;
                        break;
                    case "PHK":
                        vm.showFormEntity.validFrom = true;
                        vm.showFormEntity.validTo = false;
                        vm.showFormEntity.concerning = false;
                        vm.showFormEntity.reason = false;
                        vm.showFormEntity.releaseDate = false;
                        vm.showFormEntity.skorsingStartDate = false;
                        vm.showFormEntity.skorsingLengthDate = false;
                        break;
                    default:
                        vm.showFormEntity.validFrom = true;
                        vm.showFormEntity.validTo = true;
                        break;
                }
            }
        });

        $scope.$watch("vm.tempValidFrom", function(nVal, oVal) {
            if (nVal) {
                var tempDate = moment(nVal)
                    .add(vm.Form.objForm.letter_type.validity_period, "M")
                    .format("YYYY-MM-DD");
                vm.tempValidTo = new Date(tempDate);
                vm.validLabel =
                    "<b><em>berlaku selama " +
                    vm.Form.objForm.letter_type.validity_period +
                    " Bulan</em></b>";
            }
        });

        $scope.$watch("vm.Form.objForm.letter_type", function(nVal, oVal) {
            if (nVal != oVal) {
                vm.tempValidFrom = undefined;
                vm.tempValidTo = undefined;
            }
        });

        function getLengthOfService(curr, join) {
            var a = moment(curr);
            var b = moment(join);
            var years = a.diff(b, "year");
            b.add(years, "years");
            var months = a.diff(b, "months");
            b.add(months, "months");
            var days = a.diff(b, "days");
            var dt = years + " tahun " + months + " bulan " + days + " hari";
            var fin =
                "karyawan ini telah bergabung selama " +
                dt +
                ", per tanggal hari ini";
            return fin;
        }

        function submit(ev, form) {
            vm.Form.objForm.employee = vm.employee;
            vm.Form.objForm.letter = form.letter_type.$viewValue;
            vm.Form.objForm.actionType = fetchLetterTypeOfAction();
            vm.Form.objForm.sub_area_id = vm.employee.sub_area_id;
            vm.Form.objForm.isAdmin = isAdmin;

            console.log(vm.Form.objForm);

            switch (vm.Form.objForm.letter.code) {
                case "SURAT_TEGURAN":
                case "SP1":
                case "SP2":
                case "SP3":
                    var tempValidFromDate = angular.copy(vm.tempValidFrom);
                    var tempValidToDate = angular.copy(vm.tempValidTo);
                    vm.Form.objForm.validFrom = moment(
                        tempValidFromDate
                    ).format("YYYY-MM-DD");
                    vm.Form.objForm.validTo = moment(tempValidToDate).format(
                        "YYYY-MM-DD"
                    );
                    vm.Form.objForm.reason = form.reason.$viewValue;
                    break;
                case "SURAT_SKORSING":
                    var tmp = angular.copy(vm.tempSkorsingStartDate);
                    vm.Form.objForm.skorsingStartDate = moment(tmp).format(
                        "YYYY-MM-DD"
                    );
                    vm.Form.objForm.validFrom =
                        vm.Form.objForm.skorsingStartDate;
                    vm.Form.objForm.validTo = moment(vm.Form.objForm.validFrom)
                        .add(vm.Form.objForm.skorsingDuration, "M")
                        .format("YYYY-MM-DD");
                    vm.Form.objForm.reason = form.reason.$viewValue;
                    break;
                case "PHK":
                    var tempValidFromDate = angular.copy(vm.tempValidFrom);
                    var tempValidToDate = new Date("1970-01-01");
                    vm.Form.objForm.validFrom = moment(
                        tempValidFromDate
                    ).format("YYYY-MM-DD");
                    vm.Form.objForm.validTo = moment(tempValidToDate).format(
                        "YYYY-MM-DD"
                    );
                    vm.Form.objForm.reason = "-";
                    break;
                default:
                    var tempValidFromDate = angular.copy(vm.tempValidFrom);
                    var tempValidToDate = angular.copy(vm.tempValidTo);
                    vm.Form.objForm.validFrom = moment(
                        tempValidFromDate
                    ).format("YYYY-MM-DD");
                    vm.Form.objForm.validTo = moment(tempValidToDate).format(
                        "YYYY-MM-DD"
                    );
                    vm.Form.objForm.reason = form.reason.$viewValue;
                    break;
            }

            var promise = Form.saveData("create", form, Endpoint);
            promise.then(function(success) {
                vm.success = true;
                vm.letterTypeOfAction = [];
                vm.searchText = "";
                vm.isEmployeeFound = false;
                vm.selectedEmployee = undefined;
                vm.isReady = false;
                $timeout(function() {
                    vm.Form.tampilPesan = false;
                }, 2500);
                console.log(success);
            });
            promise.catch(function(error) {
                vm.success = false;
                vm.letterTypeOfAction = [];
                console.log(error);
            });
        }

        function fetchLetterTypeOfAction() {
            var counter = vm.letterTypeOfAction.length;
            for (var i = 0; i < counter; i++) {
                if (vm.letterTypeOfAction[i].isChecked) {
                    return vm.letterTypeOfAction[i];
                }
            }
            return "none";
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.indisciplinary-request")
        .controller("IndisciplinaryRequestNotesController", Controller);

    Controller.$inject = [
        "$state",
        "$mdDialog",
        "AppAPI",
        "REF_DATA",
        "Auth",
        "$timeout",
        "$scope",
        "$q"
    ];
    /** @ngInject */
    function Controller(
        $state,
        $mdDialog,
        AppAPI,
        REF_DATA,
        Auth,
        $timeout,
        $scope,
        $q
    ) {
        var vm = this;
        var endpoint = AppAPI.IndisciplinaryRequest();
        vm.listNotes = [];
        vm.letterList = [];
        vm.tempValidFrom = undefined;
        vm.tempValidTo = undefined;
        vm.data = angular.copy(REF_DATA);
        vm.letterTypeOfAction = [];
        vm.form = {};
        vm.success = false;
        vm.message = "";
        vm.isLoading = false;
        vm.showMessage = false;
        vm.saveProccess = false;
        vm.isValid = [
            { id: 0, name: "register" },
            { id: 1, name: "valid" },
            { id: 2, name: "invalid" }
        ];
        vm.template = [
            { id: 1, text: "Request is valid" },
            { id: 1, text: "There is adjustment in" }
        ];
        vm.listNotes = [];
        vm.setToken = setToken;

        // METHOD
        vm.hide = hide;
        vm.setForm = setForm;
        vm.onChangeLetter = onChangeLetter;
        vm.submit = submit;
        vm.confirmationDialog = confirmationDialog;

        ///////////// MAIN ////////////////

        activate();

        function activate() {
            initFormOptions();
            loadNotes();
        }

        function setForm(form) {
            vm.form = form;
        }

        function initFormOptions() {
            vm.isLoading = true;
            loadLetter()
                .then(setListLetter)
                .then(loadTypeOfAction)
                .then(setListTypeOfAction)
                .then(setValue)
                .catch(function(error) {
                    console.log(error);
                });
        }

        function setValue() {
            var defer = $q.defer();
            vm.tempValidFrom = new Date(vm.data.valid_from);
            vm.tempValidTo = new Date(vm.data.valid_to);
            $timeout(function() {
                defer.resolve();
                vm.isLoading = false;
            }, 1000);
            return defer.promise;
        }

        function loadLetter() {
            var request = endpoint.query({
                action: "getLetter"
            });
            return request.$promise;
        }

        function loadTypeOfAction() {
            var request = endpoint.query({
                action: "getLetterTypeOfAction",
                letter_code: vm.data.letter_code
            });
            return request.$promise;
        }

        function setListLetter(letters) {
            var defer = $q.defer();
            vm.letterList = letters;
            vm.letterList.map(function(letter) {
                console.log(letter);
                if (letter.code === vm.data.letter_code) {
                    vm.data.validity_period = letter.validity_period;
                }
            });
            $timeout(function() {
                defer.resolve();
            }, 500);
            return defer.promise;
        }

        function setListTypeOfAction(actions) {
            var defer = $q.defer();
            console.log(actions);
            vm.letterTypeOfAction = actions;
            $timeout(function() {
                defer.resolve();
            }, 500);
            return defer.promise;
        }

        function hide() {
            $mdDialog.hide();
        }

        function onChangeLetter(item) {
            vm.isLoading = true;
            adjustValidDate(item);
            loadTypeOfAction()
                .then(setListTypeOfAction)
                .then(function() {
                    vm.isLoading = false;
                    vm.form.type_of_action.$setValidity("required", false);
                })
                .catch(function() {
                    vm.isLoading = false;
                });
        }

        function adjustValidDate(letterCode) {
            var letter = {};
            for (var i = 0; i < vm.letterList.length; i++) {
                if (vm.letterList[i].code === letterCode) {
                    letter = vm.letterList[i];
                    break;
                }
            }
            var tmpValidFrom = angular.copy(vm.tempValidFrom);
            var addValidityPeriod = moment(tmpValidFrom)
                .add(letter.validity_period, "M")
                .format("YYYY-MM-DD");

            vm.tempValidTo = new Date(addValidityPeriod);
            vm.data.validity_period = letter.validity_period;
        }

        $scope.$watch("vm.tempValidFrom", function(nVal) {
            if (nVal) {
                var tmpValidFrom = angular.copy(vm.tempValidFrom);
                var addValidityPeriod = moment(tmpValidFrom)
                    .add(vm.data.validity_period, "M")
                    .format("YYYY-MM-DD");
                vm.tempValidTo = new Date(addValidityPeriod);
            }
        });

        function submit(ev, form) {
            vm.saveProccess = true;
            var payload = {
                id: vm.data.id,
                nik: vm.data.nik,
                letter_code: vm.data.letter_code,
                letter_type_of_action_id: vm.data.letter_type_of_action_id,
                valid_from: form.temp_valid_from.$viewValue,
                valid_to: form.temp_valid_to.$viewValue,
                validity_period: vm.data.validity_period,
                reason: vm.data.reason,
                is_valid: 0,
                letter_number: vm.data.letter_number
            };

            console.log(payload);

            Auth.setToken().then(function() {
                var request = endpoint.save({
                    action: "update",
                    data: payload
                });

                request.$promise.then(function(res) {
                    form.$setUntouched();
                    form.$setPristine();
                    vm.success = true;
                    vm.message = res.message;
                    vm.isLoading = false;
                    vm.showMessage = true;
                    vm.saveProccess = false;
                    showDialog(ev, true, vm.message);
                });

                request.$promise.catch(function(res) {
                    form.$setUntouched();
                    form.$setPristine();
                    vm.success = false;
                    vm.message = res.data.message;
                    vm.isLoading = false;
                    vm.showMessage = true;
                    vm.saveProccess = false;
                    showDialog(ev, false, vm.message);
                });
            });
            console.log(payload);
        }

        function setToken() {
            Auth.setToken().then(function() {
                console.log("token set");
            });
        }

        function confirmationDialog(ev, ref) {
            var confirm = $mdDialog
                .confirm()
                .title("Confirmation")
                .textContent(
                    "Are you sure want to do this action ?, be careful you can only update again this request after validation"
                )
                .ariaLabel("confirmation dialog")
                .targetEvent(ev)
                .multiple(true)
                .ok("YES")
                .cancel("NO");

            $mdDialog.show(confirm).then(function() {
                submit(ev, ref);
            });
        }

        function showDialog(ev, status, message) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? "Success" : "Failed")
                        .textContent(message)
                        .ariaLabel("Response Dialog")
                        .multiple(true)
                        .ok("OK")
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function loadNotes() {
            var request = endpoint.query({
                action: "getConfirmationNotes",
                confirmation_id: REF_DATA.id
            });
            request.$promise.then(function(res) {
                vm.listNotes = res;
            });
            request.$promise.catch(function(err) {
                vm.listNotes = [];
            });
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.indisciplinary-request")
        .controller("IndisciplinaryRequestDetailController", Controller);

    Controller.$inject = [
        "AppAPI",
        "Auth",
        "$mdDialog",
        "Form",
        "reffData",
        "$timeout",
        "$http",
        "config",
        "$localStorage"
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        reffData,
        $timeout,
        $http,
        config,
        $localStorage
    ) {
        var vm = this;
        var Endpoint = AppAPI.IndisciplinaryRequest();
        vm.hide = hideDialog;
        vm.baseImageUrl = "/api/empdocument/";

        activate();

        function activate() {
            console.log(reffData);
            vm.baseImageUrl += reffData.photo_address;
        }

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.indisciplinary-approval', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.indisciplinary-approval', {
            url: '/indisciplinary-approval',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/indisciplinary-approval/indisciplinary-approval.html',
                    controller: 'IndisciplinaryApprovalController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.indisciplinary-approval')
        .controller('IndisciplinaryExportController', Controller);

    Controller.$inject = [
        'AppAPI',
        'Auth',
        '$mdDialog',
        'Form',
        '$timeout',
        '$http',
        'config',
        '$window',
        '$location',
        '$localStorage'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        $timeout,
        $http,
        config,
        $window,
        $location,
        $localStorage
    ) {
        var vm = this;
        var Endpoint = AppAPI.IndisciplinaryAdmin();
        vm.tempStartDate = new Date();
        vm.tempEndDate;
        vm.exportData = exportData;
        vm.hide = hideDialog;
        vm.listSubArea = [];
        vm.searchTerm = '';
        vm.clearSearch = clearSearch;
        vm.subArea = 0;

        activate();

        function activate() {
            console.log('test');
            getSubArea();
        }

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function getSubArea() {
            var request = Endpoint.query({ action: 'getSubArea' });
            request.$promise.then(function(response) {
                vm.listSubArea = response;
            });
            request.$promise.catch(function(error) {
                console.log(error);
            });
        }

        function exportData(params) {
            var token = Auth.setTokenPromise();
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    var tmpStartDate = angular.copy(vm.tempStartDate);
                    var tmpEndDate = angular.copy(vm.tempEndDate);
                    var startDate = moment(tmpStartDate).format('YYYY-MM-DD');
                    var endDate = moment(tmpEndDate).format('YYYY-MM-DD');

                    $window.open(
                        protocol +
                            '://' +
                            host +
                            config.api +
                            'api/indisciplinaryapproval/exportexcel/' +
                            vm.subArea +
                            '/' +
                            startDate +
                            '/' +
                            endDate +
                            '/' +
                            $localStorage.empsite,

                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.indisciplinary-alert', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.indiciplinary_alert', {
            url: '/indisciplinary-alert',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/indisciplinary-alert/indisciplinary-alert.html',
                    controller: 'IndisciplinaryAlertController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.indisciplinary-alert')
        .controller('IndisciplinaryAlertFormController', Controller);

    Controller.$inject = [
        'AppAPI',
        'Auth',
        '$mdDialog',
        'Form',
        'dialogType',
        'reffData',
        'isAdmin',
        '$timeout',
        '$http',
        'config',
        '$localStorage',
        '$scope'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        dialogType,
        reffData,
        isAdmin,
        $timeout,
        $http,
        config,
        $localStorage,
        $scope
    ) {
        var vm = this;
        var Endpoint = AppAPI.EmployeeAlert();
        vm.loadingProgress = true;
        vm.searchTerm = '';
        vm.create = false;
        vm.update = false;
        vm.setToken = Auth.setToken;
        vm.hide = hideDialog;
        vm.dialogType = dialogType;
        vm.reffData = reffData;
        
        vm.loadingProgress = true;
        vm.selectedItemChange = selectedItemChange;
        vm.isEmployeeFound = false;
        vm.employee = {};
        vm.letter = [];
        vm.setLetterTypeOfAction = setLetterTypeOfAction;
        vm.letterTypeOfAction = [];
        vm.setTypeOfAction = setTypeOfAction;
        vm.isCheckedAction = isCheckedAction;
        vm.loadTypeOfAction = false;
        vm.isReady = false;
        vm.selectedTypeOfAction = null;

        vm.showFormEntity = {
            validFrom: false,
            validTo: false,
            concerning: false,
            reason: false,
            releaseDate: true,
            skorsingStartDate: false,
            skorsingLengthDate: false
        };

        vm.getLengthOfService = getLengthOfService;
        vm.validLabel = '';
        vm.messageAction = '';
        vm.isMessageAction = false;

        vm.success = false;

        vm.submit = submit;

        // initial form
        Form.initialForm();
        // set constructor form
        Form.setObject(Endpoint);
        // set form to controller
        vm.Form = Form;

        activate();

        function activate() {
            initComponents();
            setData();
            selectedItemChange(reffData.nik)
        }

        function setData()
        {
            vm.Form.objForm.nik               = reffData.nik
            vm.Form.objForm.name              = reffData.name
            vm.Form.objForm.nik_atasan        = reffData.nik_atasan
            vm.Form.objForm.indisciplinary_id = reffData.indisciplinary_id
            vm.Form.objForm.photo_address     = reffData.photo_address
            vm.Form.objForm.letter_code       = reffData.letter_code
            vm.Form.objForm.sub_area_id       = reffData.sub_area_id
        }

        function initComponents() {
            $timeout(function(params) {
                vm.loadingProgress = false;
            }, 1500);
        }

        function selectedItemChange(item) {
            if (item) {
                // vm.isOtherAction = false;
                setAvailableLetter(item.nik);
            }
        }

        function hideDialog(ev) {
            $mdDialog.hide(ev);
        }

        function setAvailableLetter(nik) {
            vm.isReady = false;
            var request = Endpoint.get({
                action: 'getAvailableLetter',
                nik: nik
            });
            request.$promise.then(function(response) {
                vm.isEmployeeFound = true;
                vm.employee = response.employeeInfo;
                vm.letter = response.letter;
                vm.baseImageUrl += vm.employee.photo_address;
                if (response.status) {
                    vm.messageAction = response.message;
                    vm.isMessageAction = true;
                }
            });
            request.$promise.catch(function(error) {
                console.log(error);
            });
        }

        function setLetterTypeOfAction(letterCode,nik) {
            vm.isReady = false;
            vm.selectedTypeOfAction = null;
            vm.loadTypeOfAction = true;

            if (!vm.Form.objForm.letter_type) {
                vm.letterTypeOfAction = [];
            }

            var request = Endpoint.query({
                action: 'getLetterTypeOfAction',
                letter_code: letterCode,
                nik: nik
            });

            request.$promise.then(function(response) {
                $timeout(function() {
                    vm.loadTypeOfAction = false;
                    vm.letterTypeOfAction = response;
                }, 1000);
            });

            request.$promise.catch(function(error) {
                $timeout(function() {
                    vm.loadTypeOfAction = false;
                    vm.letterTypeOfAction = [];
                }, 1000);
            });

            // vm.isOtherAction = false;
        }

        function setTypeOfAction(item) {
            console.log(item);
            if (item.isChecked) {
                vm.selectedTypeOfAction = item;
                vm.letterTypeOfAction.map(function(val) {
                    if (item.id !== val.id) {
                        val.isChecked = false;
                    }
                });

                // if (item.id === '0') {
                //     vm.isOtherAction = true;
                // } else {
                //     vm.isOtherAction = false;
                // }
            } else {
                item.isChecked = true;
            }
        }

        function isCheckedAction(action) {
            if (action.is_checked == '1') {
                return true;
            }
            return false;
        }

        $scope.$watch('vm.selectedTypeOfAction', function(newVal, oldVal) {
            if (newVal !== null) {
                vm.isReady = true;
                vm.showFormEntity.validFrom = true;
                vm.showFormEntity.validTo = true;
                vm.showFormEntity.concerning = true;
                vm.showFormEntity.reason = true;
                vm.showFormEntity.releaseDate = true;
                vm.showFormEntity.skorsingStartDate = false;
                vm.showFormEntity.skorsingLengthDate = false;
            }
        });

        $scope.$watch('vm.tempValidFrom', function(nVal, oVal) {
            if (nVal) {
                vm.validLabel ='';
            }
        });

        $scope.$watch('vm.Form.objForm.letter_type', function(nVal, oVal) {
            if (nVal != oVal) {
                vm.tempValidFrom = undefined;
                vm.tempValidTo = undefined;
            }
        });

        function getLengthOfService(curr, join) {
            var a = moment(curr);
            var b = moment(join);
            var years = a.diff(b, 'year');
            b.add(years, 'years');
            var months = a.diff(b, 'months');
            b.add(months, 'months');
            var days = a.diff(b, 'days');
            var dt = years + ' tahun ' + months + ' bulan ' + days + ' hari';
            var fin =
                'karyawan ini telah bergabung selama ' +
                dt +
                ', per tanggal hari ini';
            return fin;
        }

        function submit(ev, form) {
            vm.Form.objForm.letter = form.letter_type.$viewValue;
            vm.Form.objForm.reason = form.reason.$viewValue;
            vm.Form.objForm.actionType = fetchLetterTypeOfAction();
            vm.Form.objForm.isAdmin = isAdmin;

            var tempValidFromDate = angular.copy(vm.tempValidFrom);
            var tempValidToDate = angular.copy(vm.tempValidTo);
            vm.Form.objForm.validFrom = moment(tempValidFromDate).format(
                'YYYY-MM-DD'
            );
            vm.Form.objForm.validTo = moment(tempValidToDate).format(
                'YYYY-MM-DD'
            );

            var promise = Form.saveData('create', form, Endpoint);
            promise.then(function(success) {
                vm.success = true;
                vm.letterTypeOfAction = [];
                vm.searchText = '';
                vm.isEmployeeFound = false;
                vm.selectedEmployee = undefined;
                vm.isReady = false;
                $timeout(function() {
                    vm.Form.tampilPesan = false;
                    hideDialog(ev)
                }, 3000);
            });
            promise.catch(function(error) {
                vm.success = false;
                vm.letterTypeOfAction = [];
            });
        }

        function fetchLetterTypeOfAction() {
            var counter = vm.letterTypeOfAction.length;
            for (var i = 0; i < counter; i++) {
                if (vm.letterTypeOfAction[i].isChecked) {
                    return vm.letterTypeOfAction[i];
                }
            }
            return 'none';
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.hrbp.kpi_nabati', ['app.hrbp.kpi_nabati.set-team-all'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.hrbp_kpi_nabati', {
                url    : '/hrbp/kpi-nabati',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/hrbp/kpi-nabati/kpi-nabati.html',
                        controller : 'HrbpKpinabatiController as vm'
                    }
                }
            });

       

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hrbp.kpi_nabati')
        .controller('HrbpKpinabatiController', HrbpKpinabatiController);


    HrbpKpinabatiController.$inject=['DataService','$state','$window','$localStorage','$location','AppAPI','DTColumnDefBuilder','$mdDialog','Auth','config'];
    /** @ngInject */
    function HrbpKpinabatiController(DataService,$state,$window,$localStorage,$location,AppAPI,DTColumnDefBuilder,$mdDialog,Auth,config)
    {
        
        var vm=this;
         var KPI=AppAPI.teamMember();

        vm.username=$localStorage.nama;
        vm.user=$localStorage.user;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.setView=setView;
        vm.DataTable= new DataService();
        vm.loadData=loadData;

       vm.loadDataDivision=loadDataDivision;
       vm.loadDataDepartment=loadDataDepartment;
       vm.bu='';
       vm.divisi='';
       vm.department='';

        vm.ExporttoExcel=ExporttoExcel;
         
        loadData(1);
        loadDataBU();



         function loadData(pageno) {          
            var teamMember=AppAPI.teamMember();
        vm.DataTable.loadData(teamMember,pageno,{action:'viewdataall',id:0,bu:vm.bu,divisi:vm.divisi,department:vm.department});

        }

         function setView(nik) {
            $state.go('app.hrbp_kpi_nabati_set_team_all',{id:nik});
        }


      function loadDataDivision(idbu) {
     vm.divisi='';
     vm.department='';
         var response=KPI.query({action:'viewDivisiBu',idbu:idbu});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
      }

       function fetchDivisiBU(data) {
       vm.listDivisi=data;
       vm.listDepartment=[];
       loadData(1);
      }

      function errorDivisiBU() {
        vm.listDivisi=[];
      }

        function loadDataBU() {
             var KPI=AppAPI.teamMember();
        var response=KPI.query({action:'viewBu'});
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
        vm.listBu=data;
      }

      function errorFetchBU() {
        vm.listBu=[];
      }

        
        // Data
        
        // Methods

      function loadDataDepartment(iddivisi) {
        vm.department='';
         var response=KPI.query({action:'viewDivisiDept',idbu:vm.bu,iddivisi:iddivisi});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listDepartment=data;
        loadData(1);
      }

      function errorDepartment() {
        vm.listDepartment=[];
      }

      function fetchDivisiBU(data) {
       vm.listDivisi=data;
       loadData(1);
      }

      function errorDivisiBU() {
        vm.listDivisi=[];
      }

      function ExporttoExcel(){  
        var token=Auth.setTokenPromise();
        // console.log(typeof vm.bu);
        var bu="-";
        var divisi="-";
        var department="-";
        if(vm.bu !==""){
          bu=vm.bu; 
        }
        if (vm.divisi !==""){
          divisi=vm.divisi;
        }
        if(vm.department !=="")
        {
          department=vm.department;
        }

        token.then(function(data){
          var protocol= $location.protocol();
          var host=$location.host(); 
          $window.open(protocol+'://'+host+'/'+config.api+'api/kpi/kpiexportexcel/'+bu+'/'+divisi+'/'+department+'/'+data.token, '_blank'); 
          console.log(config.api);
        },function(){
          $window.alert('gagal load token')
        });
        
        // console.log(vm.bu+'  /   '+vm.divisi+'   /  '+vm.department);
      

      }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.hrbp.performance-value', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.hrbp_performance_value', {
                url    : '/hrbp/performance-value',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/hrbp/performance-value/performance-value.html',
                        controller : 'HrBpPerformanceValueController as vm'
                    }
                }
            });

   

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hrbp.performance-value')
        .controller('HrBpPerformanceValueController', HrBpPerformanceValueController);

          HrBpPerformanceValueController.$inject=['$window','$location','AppAPI','DataService','config','Auth'];
    /** @ngInject */
    function HrBpPerformanceValueController($window,$location,AppAPI,DataService,config,Auth)
    {
      
      var vm =this;
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
     var KPI=AppAPI.Reportpa();
     var Attendance=AppAPI.Hrbpattendanceteam();
     vm.checkSelectedYear=checkSelectedYear;
     vm.loadData=loadData;
     vm.showKpi=showKpi;
     vm.ExportToExcel=ExportToExcel;
     vm.loadDataDivision=loadDataDivision;
     vm.loadDataDepartment=loadDataDepartment;
     vm.bu='all';
     vm.divisi='all';
     vm.department='all';
     vm.periodeSelected='yearly';
     vm.loadData=loadData;
     var today = new Date();
     var year = today.getFullYear();
     vm.yearSelected=year;
     vm.years=[{year:2019,selected:false},{year:2018,selected:false},{year:2017,selected:false},{year:2016,selected:false},{year:2015,selected:false}];
     vm.periode=[{periode:'Q1'},{periode:'Q2'},{periode:'Q3'},{periode:'Q4'}];
      loadData(1);
      loadDataBU();

      

      function loadData(pageno)
      {
          vm.DataTable.loadData(KPI,pageno,{action:'viewdatapa',bu:vm.bu,divisi:vm.divisi,department:vm.department,year:vm.yearSelected,periode:vm.periodeSelected});
      }

      // function loadDataDivision(idbu) {
      //    var response=KPI.query({action:'viewDivisiBu',idbu:idbu,year:vm.yearSelected,periode:vm.periodeSelected});
      //   response.$promise.then(fetchDivisiBU);
      //   response.$promise.catch(errorDivisiBU);
      // }

      function loadDataDivision(idbu) {
         var response=Attendance.query({action:'viewDivisiBu',idbu:idbu});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
      }

      // function loadDataDepartment(iddivisi) {
      //    var response=KPI.query({action:'viewDivisiDept',idbu:vm.bu,iddivisi:iddivisi,year:vm.yearSelected,periode:vm.periodeSelected});
      //   response.$promise.then(fetchDepartment);
      //   response.$promise.catch(errorDepartment);
      // }

      function loadDataDepartment(iddivisi) {
         var response=Attendance.query({action:'viewDivisiDept',idbu:vm.bu,iddivisi:iddivisi});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listDepartment=data;
        loadData(1);
      }

      function errorDepartment() {
        vm.listDepartment=[];
      }

      function fetchDivisiBU(data) {
       vm.listDivisi=data;
       loadData(1);
      }

      function errorDivisiBU() {
        vm.listDivisi=[];
      }

      function checkSelectedYear()
      {

         // var lengthYear=vm.years
          angular.forEach(vm.years,function(obj){
             if(obj.year===vm.yearSelected)
             {
              obj.selected=true;
             }else
             {
              obj.selected=false;
             }
          });
      }  


      // function loadDataBU(year) {
      //   var response=KPI.query({action:'viewBu',year:year,periode:vm.periodeSelected});
      //   response.$promise.then(fetchBU);
      //   response.$promise.catch(errorFetchBU);
      // }
       function showKpi(year)
        {
          vm.yearSelected=year;
          checkSelectedYear();
          loadData(1);
        }

      function loadDataBU() {
        var response=Attendance.query({action:'viewBu'});
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
        vm.listBu=data;
      }

      function errorFetchBU() {
        vm.listBu=[];
      }

      function ExportToExcel() {
                   var token=Auth.setTokenPromise();
                      token.then(function(data){
                              var protocol=$location.protocol();
                              var host=$location.host();
                             $window.open(protocol+'://'+host+config.api+'api/kpi/exportexcel/'+vm.bu+'/'+vm.divisi+'/'+vm.department+'/'+vm.yearSelected+'/'+vm.periodeSelected+'/'+data.token, '_blank');
                      },function(){
                        
                          $window.alert('gagal load token');
                      });
      }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.pms.job_code_profile')
        .controller('UploadProfileController', UploadProfileController);

    UploadProfileController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadProfileController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        ////////////////

       

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/jobcodeprofile/uploadprofile', 
           removeAfterUpload:true,
           alias:'filejobcodeprofile',
           formData:[
              {
               action:'uploadprofile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hrbp.job_code_profile', [
        ])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
        .state('app.hrbp_job_code_profile', {
            url    : '/hrbp/job-code-profile',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/hrbp/job-code-profile/job-code-profile.html',
                    controller : 'HrbpJobCodeProfileController as vm'
                }
            }
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.hrbp.job_code_profile')
        .controller('HrbpJobCodeProfileController', HrbpJobCodeProfileController);

    HrbpJobCodeProfileController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService','$document'];
    /** @ngInject */
    function HrbpJobCodeProfileController($state,$log,$mdDialog,AppAPI,Auth,DataService,$document) {
        
        var Group            = AppAPI.Group();
        var JobCodeProfile       = AppAPI.JobCodeProfile();
        var vm               = this;
        vm.listJum           = [2,5,25,50,75,100,200];
        vm.DataTable         = new DataService();
        vm.loadData          = loadData;
        vm.modulesAction     = modulesAction;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listModulSelected = [];
        vm.deleteModul       = deleteModul;
        vm.editData          = editData;        
        vm.Breadhome         = "app.pms_job_code_profile";
        vm.Breadlist         = [
            {link:'#',name:'JobCodeProfile',active:'0'}
        ];

        var response = Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
            vm.listGroupSelect=data;
            // console.log(vm.listGroupSelect);
        });

        response.$promise.catch(function(data){
            $log.info(data);
        });

        // Data
        loadData(1);
        // Methods

        ////////// 

        function loadData(pageno){
           vm.DataTable.loadData(JobCodeProfile,pageno,{action:'viewData'});
           // console.log('test');
        }

        vm.openUploadProfile=openUploadProfile;
        function openUploadProfile(ev) {
            console.log('ev', ev);
            $mdDialog.show({
                controller         : 'UploadProfileController as vm',
                templateUrl        : 'app/main/pms/job-code-profile/upload-job-code-profile.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }


        // function loadData(pageno) {
        //  var response= JobCodeProfile.query({action:'viewdata',search:vm.DataTable.searchParam});
        // response.$promise.then(function(data){
        //    vm.list=data;
        // });
        // response.$promise.catch(function(data){
        //   console.log(data);
        // });

        // }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

        function checkAll() {
            vm.listModulSelected=angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listModulSelected=[];
        } 

        function modulesAction(id){
            // console.log(id);
            $state.go('app.utility_modules_modules-action',{id:id});
        }

        function editData(id){
            // console.log(id);
            $state.go('app.pms_job_code_profile_edit',{id:id});
        }

        function deleteModul(ev) {
   
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data your selected will be deleted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=JobCodeProfile.delete({action:'delete',data:angular.toJson(vm.listModulSelected)});

                response.$promise.then(loadData(1)); 
            }, function() {
            // $scope.status = 'You decided to keep your debt.';
            });
        });
  
   
    }

    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.hrbp.hrbp-kpi-team', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.hrbp_hrbp_kpi_team', {
                url    : '/cb/hrbp-kpi-team',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/hrbp/hrbp-kpi-team/hrbp-kpi-team.html',
                        controller : 'HrbpKpiteamController as vm'
                    }
                }
            });

   

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hrbp.hrbp-kpi-team')
        .controller('HrbpKpiteamController', HrbpKpiteamController);


    HrbpKpiteamController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function HrbpKpiteamController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;   
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment; 
        var Kpiteam=AppAPI.Hrbpkpiteam();
        vm.company=$localStorage.empsite;
        vm.getEmp=getemp;
        vm.selectedItemChanged=selectedItemChanged;
        vm.disableEmp=disableEmp;
        var nik=null;
        
        loadCompany();
        loadDataDivision(vm.company) 
        vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[ 
                    {link:'#',name:'HRBP / ',active:'0'}
                    ];
        var today = new Date();
        var year = today.getFullYear();
        vm.yearSelected=year; 
        vm.years=[{year:2019,selected:false},{year:2018,selected:false},{year:2017,selected:false},{year:2016,selected:false},{year:2015,selected:false}];

          
         

          function loadDataDepartment(iddivisi) {
             var response=Kpiteam.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
            disableEmp();
          }

          function fetchDepartment(data) {
            vm.listDepartment=data; 
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }
         

          function loadDataDivision(idbu) {
             var response=Kpiteam.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
            disableEmp();
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data; 
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          }
          

          function loadCompany() {
            var response=Kpiteam.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
            disableEmp();
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          } 
          
         
        ////////// 

        function disableEmp(){
          vm.Disabled=false;
           // console.log(vm.company+' / '+vm.divisi+' / '+vm.department);
          if(typeof (vm.company)==='undefined' || typeof(vm.divisi)==='undefined' || typeof(vm.department)==='undefined')
          {
            vm.Disabled=true;
          }
        }
        

      function getemp(searchText){
          var company=vm.company; 
          var divisi=vm.divisi;
          var department=vm.department;
           return $http
          .get(config.api + 'api/hrbpkpiteam?action=searchEmp&id='+searchText+'&company='+company+'&divisi='+divisi+'&department='+department)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.nik=null;
            }   
              return item.data;
          });
         }

      function selectedItemChanged(item)
       { 
          // vm.nama=vm.searchString; 
          if(typeof item!=='undefined')
          {
            vm.DataTable.searchParam=item.nik;
            nik=item.nik;
            vm.nama=item.nama; 
          } 
         // console.log(vm.DataTable.searchParam);
       }
       

        function loadData(pageno)
        { 
          var resp=vm.DataTable.loadData(Kpiteam,pageno,{action:'viewdata',year:vm.year});
         // console.log(resp);
          // angular.element.unblockUI();
          resp.then(function(){
            loadDataEff();
            loadPA();
          });
        }

        function loadPA()
        {
            if(vm.yearSelected==year){
                vm.addCon=true;
            }else{
                 vm.addCon=false;
            }

          var response=Kpiteam.query({action:'viewpapeopleteam',year:vm.yearSelected,nik:nik});
          response.$promise.then(fetchKpi);
          response.$promise.catch(errorFetchKpi);
        }

        function fetchKpi(data)
        {
           vm.listPA=data;
        }

        function errorFetchKpi()
        {
           vm.listPA=[];
        }


        function loadDataEff() {
         angular.element.blockUI();
        var buPromise=Kpiteam.query({action:'viewdetail',id:vm.nik});
        buPromise.$promise.then(fetchEff);
        buPromise.$promise.catch(errorFetchEff); 
         
      }

      function fetchEff(data) {
        vm.listkpi=data;  

        angular.forEach(vm.listkpi, function(value, key) {

      });  


         angular.element.unblockUI();
        
      }

      function errorFetchEff() {
        vm.listkpi=[];
         angular.element.unblockUI();
      }

        

        function closeModal()
        {
            $mdDialog.hide();
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.hrbp.hrbp-attendance-team', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.hrbp_hrbp_attendance_team', {
                url    : '/cb/hrbp-attendance-team',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/hrbp/hrbp-attendance-team/hrbp-attendance-team.html',
                        controller : 'HrbpAttendanceteamController as vm'
                    }
                }
            });

   

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hrbp.hrbp-attendance-team')
        .controller('HrbpAttendanceteamController', HrbpAttendanceteamController);


    HrbpAttendanceteamController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function HrbpAttendanceteamController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;   
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment; 
        var Attendance=AppAPI.Hrbpattendanceteam();
        vm.company=$localStorage.empsite;
        vm.getEmp=getemp;
        vm.selectedItemChanged=selectedItemChanged;
        vm.disableEmp=disableEmp;
        
        loadCompany();
        loadDataDivision(vm.company)
        vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[ 
                    {link:'#',name:'C&B / ',active:'0'}
                    ]; 

          
         

          function loadDataDepartment(iddivisi) {
             var response=Attendance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
            disableEmp();
          }

          function fetchDepartment(data) {
            vm.listDepartment=data; 
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }
         

          function loadDataDivision(idbu) {
             var response=Attendance.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
            disableEmp();
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data; 
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          }
          

          function loadCompany() {
            var response=Attendance.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
            disableEmp();
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          } 
          
         
        ////////// 

        function disableEmp(){
          vm.Disabled=false;
           // console.log(vm.company+' / '+vm.divisi+' / '+vm.department);
          if(typeof (vm.company)==='undefined' || typeof(vm.divisi)==='undefined' || typeof(vm.department)==='undefined')
          {
            vm.Disabled=true;
          }
        }
        

      function getemp(searchText){
          var company=vm.company; 
          var divisi=vm.divisi;
          var department=vm.department;
           return $http
          .get(config.api + 'api/hrbpattendanceteam?action=searchEmp&id='+searchText+'&company='+company+'&divisi='+divisi+'&department='+department)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){
              Form.objForm.nik=null;
            }   
              return item.data;
          });
         }

      function selectedItemChanged(item)
       { 
          // vm.nama=vm.searchString; 
          if(typeof item!=='undefined')
          {
            vm.DataTable.searchParam=item.nik;
            vm.nik=item.nik;
            vm.nama=item.nama; 
          } 
         // console.log(vm.DataTable.searchParam);
       }
       

        function loadData(pageno)
        {
          var company=vm.company; 
          var divisi=vm.divisi;
          var department=vm.department;
          var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
          var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');
        
          var resp=vm.DataTable.loadData(Attendance,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
         // console.log(resp);
          // angular.element.unblockUI();
        }

        

        function closeModal()
        {
            $mdDialog.hide();
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.hrbp.emp-leave', [ ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    { 
        // State
        $stateProvider
            .state('app.hrbp_emp_leave', {
                url    : '/hrbp/employe-leave',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/hrbp/emp-leave/emp-leave.html',
                        controller : 'HrbpLeaveController as vm'
                    }
                }
            });  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hrbp.emp-leave')
        .controller('HrbpLeaveController', HrbpLeaveController);


    HrbpLeaveController.$inject=['$state','$window','$location','$localStorage','$document','$element','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService' ];
    /** @ngInject */
    function HrbpLeaveController($state,$window,$location,$localStorage,$document,$element,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService )
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData; 
        vm.toggleSelectedAll=toggleSelectedAll; 
        vm.ExportToExcel=ExportToExcel; 
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;  
        var Leavereport=AppAPI.Hrbpleavereport();
        var Attendance=AppAPI.Hrbpattendanceteam();
        var date=new Date();
        vm.tahun=date.getFullYear();
        vm.bulan=date.getMonth()+1;
        vm.getPeriode=getPeriode;
        vm.tgl=date.getDate();
        if(vm.tgl >=20 && vm.tgl <=31)
        {
          vm.bulan=vm.bulan+1;
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }
        vm.company=$localStorage.empsite;
        vm.optionSelected=optionSelected;
        // console.log('employesite > '+$localStorage.empsite);

        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();

        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[ 
                    {link:'#',name:'C&B / ',active:'0'}
                    ]; 
        vm.listtahun=  ['2017','2018','2019','2020','2021'];
        vm.listbulan=[{name:'January',value:'01'},
                      {name:'February',value:'02'},
                      {name:'Maret',value:'03'},
                      {name:'April',value:'04'},
                      {name:'Mei',value:'05'},
                      {name:'June',value:'06'},
                      {name:'July',value:'07'},
                      {name:'August',value:'08'},
                      {name:'September',value:'09'},
                      {name:'October',value:'10'},
                      {name:'November',value:'11'},
                      {name:'Desember',value:'12'}];

        vm.simulateQuery = false;
        vm.isDisabled    = false;  
        vm.closeModal=closeModal; 
        getPeriode();
 

        ////////// 
        vm.searchTerm;
        vm.clearSearchTerm = function() {
          vm.searchTerm = '';
        };
        // The md-select directive eats keydown events for some quick select
        // logic. Since we have a search input here, we don't need that logic.
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function getPeriode(){
          var res=Leavereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
          res.$promise.then(fetchPeriode);
          res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data)
        {
          vm.periode=data[0]['periode'];
          // console.log(vm.periode);
          // loadData(1);
        }

        function errorfetchPeriode(data)
        {
          console.log('error');
        }

         function loadDataDepartment(iddivisi) {
             var response=Attendance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }
          
          function loadDataDivision(idbu) {
             var response=Attendance.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          } 

          function loadDataBU() {
            var response=Attendance.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }

         

        function loadData(){
           angular.element('#attView').block({message:'please wait..'});
           var company=vm.company; 
           var divisi=vm.divisi;
           var department=vm.department;
           var tahun=vm.tahun;
           var bulan=vm.bulan; 
           if(typeof(vm.divisi)==='undefined')
           {
              divisi='all';
           }
           if(typeof(vm.department)==='undefined')
           {
              department='all';
           }

           // console.log(company+' / '+divisi+' / '+department+' / '+tahun+' / '+bulan);
           var response=Leavereport.query({action:'viewdata',company:company,divisi:divisi,department:department,tahun:tahun,bulan:bulan,subarea:vm.selectedSubarea});
              response.$promise.then(function(data){
                vm.listData=data;
                console.log(vm.listData);
                 angular.element('#attView').unblock();
              });
              response.$promise.catch(function(data){
                $log.info(data);
                vm.listData=[];
                 angular.element('#attView').unblock();
              });
        }

        // function loadData(pageno)
        // {
        //   var company=vm.company; 
        //   var divisi=vm.divisi;
        //   var department=vm.department;
        //   var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
        //   var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');
        
        //   var resp=vm.DataTable.loadData(Overtime,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
        //  // console.log(resp);
        //   // angular.element.unblockUI();
        // }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 
        
        
         

        function closeModal()
        {
            $mdDialog.hide();
        }

        function ExportToExcel()
        {
         var company=vm.company; 
         var divisi=vm.divisi;
         var department=vm.department;
         var tahun=vm.tahun;
         var bulan=vm.bulan;
         if(typeof(vm.divisi)==='undefined')
         {
            divisi='all';
         }
         if(typeof(vm.department)==='undefined')
         {
            department='all';
         }
          var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                   $window.open(protocol+'://'+host+config.api+'api/leavereport/exportexcel/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan, '_blank');
            },function(){
              
                $window.alert('gagal load token');
            });
        }

      function  loadSubArea()
      {
        var response=Attendance.query({action:'getHrbpArea'});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorfetchArea);
      }

      function fetchArea(data)
      {
        vm.subArea=data;
      }

      function errorfetchArea(data)
      {
        vm.subArea=[];
      }

      function optionSelected()
      {

        var arr=vm.selectedSubarea;

        console.log(arr.length);
      }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.pms.competency')
        .controller('UploadEmpJobCodeController', UploadEmpJobCodeController);

    UploadEmpJobCodeController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadEmpJobCodeController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        ////////////////

       

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/empjobcode/uploadempjobcode',
           removeAfterUpload:true,
           alias:'fileempjobcode',
           formData:[
              {
               action:'uploadempjobcode'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hrbp.emp_job_code', [
        ])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
        .state('app.hrbp_emp_job_code', {
            url    : '/hrbp/emp_job_code',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/hrbp/emp-job-code/emp-job-code.html',
                    controller : 'HrbpEmpJobCodeController as vm'
                }
            }
        });

        // $translatePartialLoaderProvider.addPart('app/main/pms/competency');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.hrbp.emp_job_code')
        .controller('HrbpEmpJobCodeController', HrbpEmpJobCodeController);

    HrbpEmpJobCodeController.$inject=['$state','$log','$localStorage','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function HrbpEmpJobCodeController($state,$log,$localStorage,$mdDialog,AppAPI,Auth,DataService, $document) {
        
        var Group            = AppAPI.Group();
        var EmpJobCode       = AppAPI.EmpJobCode();
        var Attendance       = AppAPI.Hrbpattendanceteam();
        var vm               = this;
        vm.listJum           = [2,5,25,50,75,100,200];
        vm.DataTable         = new DataService();
        vm.loadData          = loadData;
        vm.modulesAction     = modulesAction;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listModulSelected = [];
        vm.setJobCode          = setJobCode;   
        vm.openUploadEmpJobCode=openUploadEmpJobCode;  
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;   
        vm.Breadhome         = "app.hrbp_emp_job_code";
        vm.company=$localStorage.empsite;
        vm.Breadlist         = [
            {link:'#',name:'EmpJobCode',active:'0'}
        ];

        var response = Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
            vm.listGroupSelect=data;
        });

        response.$promise.catch(function(data){
            $log.info(data);
        });

        loadCompany();
        loadDataDivision(vm.company)
        loadData(1);
 
        ////////////////////////////

        function loadData(pageno){
           vm.DataTable.loadData(EmpJobCode,pageno,{action:'viewData',bu:vm.bu,divisi:vm.divisi,department:vm.department});
        }

        
        function openUploadEmpJobCode(ev) {
            $mdDialog.show({
                controller         : 'UploadEmpJobCodeController as vm',
                templateUrl        : 'app/main/pms/emp-job-code/upload-emp-job-code.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
            vm.listModulSelected=angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listModulSelected=[];
        } 

        function modulesAction(id){
            // console.log(id);
            $state.go('app.utility_modules_modules-action',{id:id});
        }

        function setJobCode(ev, data)
        {

            $mdDialog.show({
                controller: 'InputEmpJobCodeController',
                controllerAs:'vm',
                templateUrl: 'app/main/pms/emp-job-code/input-emp-job-code/input-emp-job-code.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    data: data                   
                },
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }


        function loadDataDepartment(iddivisi) {
             var response=Attendance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment); 
          }

          function fetchDepartment(data) {
            vm.listDepartment=data; 
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }
         

          function loadDataDivision(idbu) {
             var response=Attendance.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU); 
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data; 
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          }
          

          function loadCompany() {
            var response=Attendance.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU); 
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          } 

    }

})();


(function() {
    'use strict';

    angular
        .module('app.pms.competency')
        .controller('UploadCompetencyController', UploadCompetencyController);

    UploadCompetencyController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadCompetencyController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        ////////////////

       

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/competency/uploadcompetency',
           removeAfterUpload:true,
           alias:'filecompetency',
           formData:[
              {
               action:'uploadcompetency'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hrbp.competency', [
        ])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
        .state('app.hrbp_competency', {
            url    : '/hrbp/competency',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/hrbp/competency/competency.html',
                    controller : 'HrbpcompetencyController as vm'
                }
            }
        });

        // $translatePartialLoaderProvider.addPart('app/main/pms/competency');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.hrbp.competency')
        .controller('HrbpcompetencyController', HrbpcompetencyController);

    HrbpcompetencyController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService', '$document'];
    /** @ngInject */
    function HrbpcompetencyController($state,$log,$mdDialog,AppAPI,Auth,DataService, $document) {
        
        var Group            = AppAPI.Group();
        var Competency       = AppAPI.Competency();
        var vm               = this;
        vm.listJum           = [2,5,25,50,75,100,200];
        vm.DataTable         = new DataService();
        vm.loadData          = loadData;
        vm.modulesAction     = modulesAction;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listModulSelected = [];
        // vm.deleteModul       = deleteModul;
        vm.editData          = editData;        
        vm.Breadhome         = "app.pms_competency";
        vm.Breadlist         = [
            {link:'#',name:'Competency',active:'0'}
        ];

        var response = Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
            vm.listGroupSelect=data;
            // console.log(vm.listGroupSelect);
        });

        response.$promise.catch(function(data){
            $log.info(data);
        });

        // Data
        loadData(1);
        // Methods

        ////////// 

        function loadData(pageno){
           vm.DataTable.loadData(Competency,pageno,{action:'viewData'});
           // console.log('test');
        }

        vm.openUploadComeptency=openUploadComeptency;
        function openUploadComeptency(ev) {
            $mdDialog.show({
                controller         : 'UploadCompetencyController as vm',
                templateUrl        : 'app/main/pms/competency/upload-competency.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        // function loadData(pageno) {
        //  var response= Competency.query({action:'viewdata',search:vm.DataTable.searchParam});
        // response.$promise.then(function(data){
        //    vm.list=data;
        // });
        // response.$promise.catch(function(data){
        //   console.log(data);
        // });

        // }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

        function checkAll() {
            vm.listModulSelected=angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listModulSelected=[];
        } 

        function modulesAction(id){
            // console.log(id);
            $state.go('app.utility_modules_modules-action',{id:id});
        }

        function editData(id){
            // console.log(id);
            $state.go('app.pms_job_code_profile_edit',{id:id});
        }

    //     function deleteModul(ev) {
   
    //     var promise=Auth.setToken();
    //     promise.then(function(){
    //         var confirm = $mdDialog.confirm()
    //         .title('Would you like to delete this list?')
    //         .textContent('All data your selected will be deleted and can not recovered.')
    //         .ariaLabel('delete dialog')
    //         .targetEvent(ev)
    //         .ok('YES')
    //         .cancel('no');

    //         $mdDialog.show(confirm).then(function() {
    //             angular.element.blockUI();
    //             var response=Competency.delete({action:'delete',data:angular.toJson(vm.listModulSelected)});

    //             response.$promise.then(loadData(1)); 
    //         }, function() {
    //         // $scope.status = 'You decided to keep your debt.';
    //         });
    //     });
  
   
    // }

    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.hrbp.charts-bu', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.hrbp_charts_bu', {
                url    : '/hrbp/charts-bu',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/hrbp/charts-bu/charts-bu.html',
                        controller : 'HrbpChartsBuController as vm'
                    }
                }
            });

   

    }
})();
(function ()
{
    'use strict';
 
    angular
        .module('app.hrbp.charts-bu')
        .controller('HrbpChartsBuController', HrbpChartsBuController);

          HrbpChartsBuController.$inject=['AppAPI','DataService'];
    /** @ngInject */
    function HrbpChartsBuController(AppAPI,DataService)
    {
      
      var vm =this;
      var Division = AppAPI.Division();
      var Kpi = AppAPI.Reportchartpabu();
      var Attendance=AppAPI.Hrbpattendanceteam();
      vm.viewDataBu=viewDataBu;
      vm.viewDataDivisi=viewDataDivisi;
      vm.viewDataDepartment=viewDataDepartment;
      
      var responseBu=Attendance.query({action:'viewBu'});
      responseBu.$promise.then(fetchBu);
      responseBu.$promise.catch(errorFetchBu);

      function viewDivisi(idbu) {
        var responseDivisi=Attendance.query({action:'viewDivisiBu',idbu:idbu});
      responseDivisi.$promise.then(fetchDivisi);
      responseDivisi.$promise.catch(errorFetchDivisi);
      }

      function viewDeptDivisi(idbu,iddiv) {
        var responseDept=Attendance.query({action:'viewDivisiDept',idbu:idbu,iddivisi:iddiv});
      responseDept.$promise.then(fetchDivDept);
      responseDept.$promise.catch(errorFetchDivDept);
      }
      function viewDataDivisi(id,name) {
        angular.element('#chartByDivisi').block();
        vm.nameDivisi=name;
        var newid=vm.idBU+'-'+id;
         vm.idDivisi=id;
         viewDeptDivisi(vm.idBU,id);
         var response=Kpi.get({action:'viewAllChart',id:newid,type:'bu'});
         response.$promise.then(fetchDataDivisiChart);
         response.$promise.catch(errorFetchDataDivisiChart);
      }


      function viewDataDepartment(id,name) {
        angular.element('#chartByDept').block();
        vm.nameDepartment=name;
        var newid=vm.idBU+'-'+vm.idDivisi+'-'+id;
         var response=Kpi.get({action:'viewAllChart',id:newid,type:'bu'});
         response.$promise.then(fetchDataDeptChart);
         response.$promise.catch(errorFetchDataDeptChart);
      }

      function fetchDataDivisiChart(data) {
           vm.dataMutudiv= [data.mutu1];
           vm.dataAdj1div=[data.adj1];
            vm.dataAdj2div=[data.adj2];
        var ticks = data.tick;
        vm.optionsBadjdiv={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1div={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2div={
           title:'After Adjustment 2',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         angular.element('#chartByDivisi').unblock();
      }

      function errorFetchDataDivisiChart() {
         angular.element('#chartByDivisi').unblock();
      }

      function fetchBu(data) {
        vm.listBu=data;
      }

      function errorFetchBu() {
        vm.listBu=[];
        vm.listDivisi=[];
        vm.listDepartment=[];
      }

       function fetchDivisi(data) {
        vm.listDivisi=data;
      }

      function errorFetchDivisi() {
        vm.listDivisi=[];
        vm.listDepartment=[];
      }


        function fetchDivDept(data) {
        vm.listDepartment=data;
      }

      function errorFetchDivDept() {
        vm.listDepartment=[];
      }

      function viewDataBu(id,name) {
        angular.element('#chartByBu').block();
        vm.namaBu=name;
        vm.idBU=id;
        viewDivisi(id);
        var response=Kpi.get({action:'viewAllChart',id:id,type:'bu'});
         response.$promise.then(fetchDataBuChart);
         response.$promise.catch(errorFetchDataBuChart);
      }

      function fetchDataBuChart(data) {
         vm.dataMutuBu= [data.mutu1];
           vm.dataAdj1Bu=[data.adj1];
            vm.dataAdj2Bu=[data.adj2];
        var ticks = data.tick;
        vm.optionsBadjBu={
          title:'Before Adjustment',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1Bu={
           title:'After Adjustment 1',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2Bu={
           title:'After Adjustment 2',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };
          angular.element('#chartByBu').unblock();
        
      }

      function errorFetchDataBuChart(data) {
       angular.element('#chartByBu').unblock();
      }


      function fetchDataDeptChart(data) {
           vm.dataMutuDept= [data.mutu1];
           vm.dataAdj1Dept=[data.adj1];
            vm.dataAdj2Dept=[data.adj2];
        var ticks = data.tick;
        vm.optionsBadjDept={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1Dept={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2Dept={
           title:'After Adjustment 2',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         angular.element('#chartByDept').unblock();
      }

      function errorFetchDataDeptChart() {
         angular.element('#chartByDept').unblock();
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.hrbp.charts-pa', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.hrbp_charts_pa', {
                url    : '/hrbp/charts-pa',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/hrbp/charts-pa/charts-pa.html',
                        controller : 'ChartsPaController as vm'
                    }
                }
            });

   

    }
})();
(function ()
{
    'use strict';
 
    angular
        .module('app.hrbp.charts-pa')
        .controller('ChartsPaController', ChartsPaController);

          ChartsPaController.$inject=['AppAPI','DataService'];
    /** @ngInject */
    function ChartsPaController(AppAPI,DataService)
    {
      
      var vm =this;
      var Division = AppAPI.Division();
      var Kpi = AppAPI.Reportchartpa();
      vm.viewDataDivision=viewDataDivision;
      
      
      var responseDivision=Kpi.query({action:'viewDivision'});
      responseDivision.$promise.then(fetchDivision);
      responseDivision.$promise.catch(errorFetchDivision);

       loadDataPa();
      function loadDataPa() {
        angular.element('#allChart').block();
         var response=Kpi.get({action:'viewAllChart',id:'all',type:'group'});
         response.$promise.then(fetchDataAllChart);
         response.$promise.catch(errorFetchDataAllChart);
      }

      function fetchDataAllChart(data) {
           vm.dataMutu= [data.mutu1];
           vm.dataAdj1=[data.adj1];
            vm.dataAdj2=[data.adj2];
            vm.dataAll=[data.mutu1,data.adj1,data.adj2];
        var ticks = data.tick;
        vm.optionsBadj={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2={
           title:'After Adjustment 2',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

        vm.optionsAadjAll={
           title:'After Adjustment 2',
           seriesColors:['#E91E63','#FF9800','#4CAF50'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                }
            }
        };

          angular.element('#allChart').unblock();
      }

      function errorFetchDataAllChart() {
        angular.element('#allChart').unblock();
      }

      function fetchDivision(data) {
        vm.listDivision=data;
      }

      function errorFetchDivision() {
        vm.listDivision=[];
      }

      function viewDataDivision(id,name) {
        angular.element('#chartPaByDIvision').block();
        vm.DivisionName=name;
        var response=Kpi.get({action:'viewAllChart',id:id,type:'group'});
         response.$promise.then(fetchDataDivisionChart);
         response.$promise.catch(errorFetchDataDivisionChart);
      }

      function fetchDataDivisionChart(data) {
         vm.dataMutuDiv= [data.mutu1];
           vm.dataAdj1Div=[data.adj1];
            vm.dataAdj2Div=[data.adj2];
        var ticks = data.tick;
        vm.optionsBadjDiv={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1Div={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2Div={
           title:'After Adjustment 2',
          seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };
          angular.element('#chartPaByDIvision').unblock();
        
      }

      function errorFetchDataDivisionChart(data) {
       angular.element('#chartPaByDIvision').unblock();
      }
    }
})();

(function () {
  'use strict';

  angular
      .module('app.hcnews.hc-news-category', [])
       .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.hc_news_category', {
              url: '/hcnews/category',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/hcnews/hc-news-category/hc-news-category.html',
                      controller: 'HcNewsCategoryController as vm'
                  }
              }
          });
  }
 })();

(function() {
  'use strict';
  angular
    .module('app.hcnews.hc-news-category')
    .controller('HcNewsCategoryController', HcNewsCategoryController);

  HcNewsCategoryController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    '$q',
    'filterFilter'
  ];
  /** @ngInject */
  function HcNewsCategoryController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    $q,
    filterFilter
  ) {
    var vm = this;
    // var Attendancereport = AppAPI.Attendancereport();
    var category = AppAPI.NewsCategory();
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addDataNewsCategory = addDataNewsCategory;
    vm.saveData = saveData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.selectedEmp = [];
    vm.Form = Form;
    vm.editDataNewsCategory = editDataNewsCategory;
    vm.deleteDataNewsCategory = deleteDataNewsCategory;
    vm.dialogClose = dialogClose;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      Form.initialForm();
      Form.setObject(category);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(category, pageno, {
        action: 'viewData'
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addDataNewsCategory(ev) {
      $mdDialog.show({
        controller: 'HcNewsCategoryController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcnews/hc-news-category/hc-news-category-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editDataNewsCategory(ev, data) {
      $mdDialog.show({
        controller: 'EditHcNewsCategoryController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcnews/hc-news-category/hc-news-category-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data  : data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteDataNewsCategory(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = category.delete({
              action: 'deleteData',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.category_name = frm.category_name.$viewValue;
      var response = Form.saveData('saveData', frm, category);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function() {
    'use strict';
    angular
      .module('app.hcnews.hc-news-category')
      .controller('EditHcNewsCategoryController', EditHcNewsCategoryController);
  
    EditHcNewsCategoryController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'data'
    ];
    /** @ngInject */
    function EditHcNewsCategoryController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      data
    ) {
      var vm = this;
      var category = AppAPI.NewsCategory();
      vm.Form = Form;
      vm.info = data;
      vm.updateData = updateData;
      vm.dialogClose = dialogClose;
  
      activate();
  
      function activate() {
        vm.category_name = data.category_name
        Form.initialForm();
        Form.setObject(category);
      }
  
  
      function updateData(ev, frm) {
        angular.element.blockUI();
        vm.Form.objForm.id = data.id;
        vm.Form.objForm.category_name = frm.category_name.$viewValue;
        var response = Form.saveData('updateData', frm, category);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.pesan)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
            loadData(1);
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }
  
    }
  })();
  
(function () {
  'use strict';

  angular
      .module('app.hcnews.hc-news', ['ui.tinymce'])
       .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.hc_news', {
              url: '/hcnews',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/hcnews/hc-news/hc-news.html',
                      controller: 'HcNewsController as vm'
                  }
              }
          });
  }
 })();

(function() {
    'use strict';

    angular
        .module('app.hcnews.hc-news')
        .controller('viewReaderLogController', viewReaderLogController);

    viewReaderLogController.$inject = ['$mdDialog','data','$localStorage','config','AppAPI','DataService'];

    /* @ngInject */
    function viewReaderLogController($mdDialog,data,$localStorage,config,AppAPI,DataService) {
        var vm = this; 

        var news = AppAPI.News();
        vm.closeModal=closeModal;
        vm.listData=data.logReader;

        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.items = [];

        loadData(1);

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadData(pageno) {
        var resp = vm.DataTables.loadData(news, pageno, {
            action: 'viewReaderLog',news_id:data.id
        });
    
        resp.then(function(data) {
            vm.companyList=data.readerByCompany;
            vm.selected = [];
            vm.items = data.list;
        });
        }
    }
})();
(function() {
  'use strict';
  angular
    .module('app.hcnews.hc-news')
    .controller('HcNewsController', HcNewsController);

  HcNewsController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth', 
    '$q',
    'filterFilter',
    'config',
    'FileUploader',
    'Approvalinfo',
    'Newsinfo'
  ];
  /** @ngInject */
  function HcNewsController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth, 
    $q,
    filterFilter,
    config,
    FileUploader,
    Approvalinfo,
    Newsinfo
  ) {
    var vm = this;
    var news = AppAPI.News();
    var Attendancereport=AppAPI.Attendancereport();

    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addDataNews = addDataNews; 
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = []; 
    vm.editDataNews = editDataNews;
    vm.deleteDataNews = deleteDataNews;
    vm.dialogClose = dialogClose;
    vm.company=$localStorage.empsite;
    vm.group1=true;
    vm.viewNewsDetail=viewNewsDetail;
    vm.infoApproval=infoApproval;
    vm.unReadNews=Newsinfo;
    vm.viewReaderLog=viewReaderLog;
    
    vm.tinymceOptions = {
      height: 350,
      theme: 'modern',
      plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount  imagetools contextmenu colorpicker textpattern',
      toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat image',
      image_advtab: true,
      templates: [
        { title: 'template 1', content: 'Template 1' },
        { title: 'template 2', content: 'Template 2' }
      ],
      file_picker_types: 'image',
      file_picker_callback: function (callback, value, meta) {
        if (meta.filetype == 'image') {
          $('#upload').trigger('click');
          $('#upload').on('change', function () {
            var file = this.files[ 0 ];
            var reader = new FileReader();
            reader.onload = function (e) {
              callback(e.target.result, {
                alt: ''
              });
            };
            reader.readAsDataURL(file);
          });
        }
      }
    };
    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      // Form.initialForm();
      // Form.setObject(news);
      loadDataNewsCategory();
      loadDataBU();
      listUserCreator();
    }

    function loadDataNewsCategory() {
      var response = news.query({ action: 'viewNewsCategory' });
      response.$promise.then(fetchNewsCategory);
      response.$promise.catch(errorFetchNewsCategory);
    }

    function fetchNewsCategory(data) {
      vm.listNC = data;
    }

    function errorFetchNewsCategory() {
      vm.listNC = [];
    }

    function loadDataBU() {
      var response=news.query({action:'viewBU'});
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU=data;

    }

    function errorFetchBU() {
      vm.listBU=[];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(news, pageno, {
        action: 'viewData'
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addDataNews(ev) {
      $mdDialog.show({
        controller: 'HcNewsInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcnews/hc-news/hc-news-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editDataNews(ev, data) {
      $mdDialog.show({
        controller: 'EditHcNewsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcnews/hc-news/hc-news-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data  : data,
          listNC : vm.listNC
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteDataNews(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = news.delete({
              action: 'deleteData',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    // function saveData(ev, frm) {
    //   angular.element.blockUI();
    //   vm.Form.objForm.title = frm.title.$viewValue;
    //   vm.Form.objForm.category = frm.category.$viewValue;
    //   vm.Form.objForm.content = vm.content;
    //   vm.Form.objForm.company = vm.company;
    //   vm.Form.objForm.sap = vm.sap;
    //   vm.Form.objForm.isPublish = vm.isPublish;
    //   var response = Form.saveData('saveData', frm, news);
    //   response.then(function(data) {
    //       angular.element.unblockUI();
    //       frm.$setPristine();

    //       vm.uploader.uploadAll();

    //       showDialogInfo(ev, data);
    //   });

    //   response.catch(function(data) {
    //       angular.element.unblockUI();
    //       frm.$setPristine();
    //       showDialogInfo(ev, data);
    //   });
    // }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    var uploader = vm.uploader = new FileUploader({
        url:config.api+'api/hcnews/uploadFile', 
        removeAfterUpload:true,
        alias:'newsDocument',    
    });

      // a sync filter
    uploader.filters.push({
      name: 'syncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options) {
          return this.queue.length < 10;
      }
    });

    // an async filter
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
          setTimeout(deferred.resolve, 1e3);
      }
    });

    function  viewNewsDetail(ev, data) {
      if(data.content==null || data.content.length==0){
          $mdDialog.show({
              controller         : 'NewsTabController',
              controllerAs       : 'vm',
              templateUrl        : 'app/quick-panel/tabs/news/news-view-doc.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:false,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  countUnReadNews();
                  infoApproval();
                  loadDataNewsCategory();
              },
              locals:{ 
                  data : data
              }
          });
      }else{
          $mdDialog.show({
              controller         : 'NewsTabController',
              controllerAs       : 'vm',
              templateUrl        : 'app/quick-panel/tabs/news/news-detail.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:false,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  countUnReadNews();
                  infoApproval();
                  loadDataNewsCategory();
              },
              locals:{ 
                  data : data
              }
          });
      }
    }

    // Methods
    function countUnReadNews() {
        var response = news.get({ action: 'getCountUnReadNews' });
        response.$promise.then(fetchUnreadNews);
        response.$promise.catch(errorFetchNewsCategory);
    }

    function fetchUnreadNews(data) {
        Newsinfo.getInfoNews = data;
    }

    function errorFetchNewsCategory() {
        Newsinfo.getInfoNews = 0;
    }

    function infoApproval() {
      var ListApproval=AppAPI.InfoApproval();
      var lsApproval= new ListApproval();
      var promise=lsApproval.$get({action:'viewData'});
      promise.then(processInfo);
      promise.catch(errorProcessInfo);
    }

    function processInfo(data) {
      Approvalinfo.getInfoApproval=data;
    }

    function errorProcessInfo() {
      Approvalinfo.getInfoApproval={};
    }

    function listUserCreator() {
      var response = news.query({ action: 'viewUserCreator' });
      response.$promise.then(fetchUserCreator);
      response.$promise.catch(errorFetchUserCreator);
    }

    function fetchUserCreator(data) {
      vm.admin = data[0]==true ? true : false;
    }

    function errorFetchUserCreator() {
      vm.listUserCreator = [];
    }

    function viewReaderLog(item,ev)
    {
      $mdDialog.show({
              controller         : 'viewReaderLogController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/hcnews/hc-news/view-reader-log.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData(1);
              },
              locals:{
                data:item
              }
          }); 
    }

    function inArray(param, array) {
      var length = array.length;
      for (var i = 0; i < length; i++) {
        if (array[i] == param)
          return true;
        }
      return false;
     }
  }
})();

(function() {
  'use strict';
  angular
    .module('app.hcnews.hc-news')
    .controller('HcNewsInputController', HcNewsInputController);

  HcNewsInputController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    '$q',
    'filterFilter',
    'config',
    'FileUploader',
    'Approvalinfo',
    'Newsinfo'
  ];
  /** @ngInject */
  function HcNewsInputController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    $q,
    filterFilter,
    config,
    FileUploader,
    Approvalinfo,
    Newsinfo
  ) {
    var vm = this;
    var news = AppAPI.News();
    var Attendancereport=AppAPI.Attendancereport(); 
     
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = [];
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(news); 
    vm.dialogClose = dialogClose;
    vm.company=$localStorage.empsite;
    vm.group1=true; 
    vm.saveData=saveData;
    
    vm.tinymceOptions = {
      height: 350,
      theme: 'modern',
      plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount  imagetools contextmenu colorpicker textpattern',
      toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat image',
      image_advtab: true,
      templates: [
        { title: 'template 1', content: 'Template 1' },
        { title: 'template 2', content: 'Template 2' }
      ],
      file_picker_types: 'image',
      file_picker_callback: function (callback, value, meta) {
        if (meta.filetype == 'image') {
          $('#upload').trigger('click');
          $('#upload').on('change', function () {
            var file = this.files[ 0 ];
            var reader = new FileReader();
            reader.onload = function (e) {
              callback(e.target.result, {
                alt: ''
              });
            };
            reader.readAsDataURL(file);
          });
        }
      }
    };
    activate();

    function activate() {
      vm.selected = []; 
      loadDataNewsCategory();
      loadDataBU();
      listUserCreator();
    }

    function loadDataNewsCategory() {
      var response = news.query({ action: 'viewNewsCategory' });
      response.$promise.then(fetchNewsCategory);
      response.$promise.catch(errorFetchNewsCategory);
    }

    function fetchNewsCategory(data) {
      vm.listNC = data;
    }

    function errorFetchNewsCategory() {
      vm.listNC = [];
    }

    function loadDataBU() {
      var response=news.query({action:'viewBU'});
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU=data;

    }

    function errorFetchBU() {
      vm.listBU=[];
    }
  

    function saveData(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.title = frm.title.$viewValue;
      vm.Form.objForm.category = frm.category.$viewValue;
      vm.Form.objForm.content = vm.content;
      vm.Form.objForm.company = vm.company;
      vm.Form.objForm.sap = vm.sap;
      vm.Form.objForm.isPublish = vm.isPublish;
      var response = Form.saveData('saveData', frm, news);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine(); 
          vm.uploader.uploadAll();

          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

     

    var uploader = vm.uploader = new FileUploader({
        url:config.api+'api/hcnews/uploadFile', 
        removeAfterUpload:true,
        alias:'newsDocument',    
    });

      // a sync filter
    uploader.filters.push({
      name: 'syncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options) {
          return this.queue.length < 10;
      }
    });

    // an async filter
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
          setTimeout(deferred.resolve, 1e3);
      }
    });

     

    // Methods
    function countUnReadNews() {
        var response = news.get({ action: 'getCountUnReadNews' });
        response.$promise.then(fetchUnreadNews);
        response.$promise.catch(errorFetchNewsCategory);
    }

    function fetchUnreadNews(data) {
        Newsinfo.getInfoNews = data;
    }

    function errorFetchNewsCategory() {
        Newsinfo.getInfoNews = 0;
    }

     

    function listUserCreator() {
      var response = news.query({ action: 'viewUserCreator' });
      response.$promise.then(fetchUserCreator);
      response.$promise.catch(errorFetchUserCreator);
    }

    function fetchUserCreator(data) {
      vm.admin = data[0]==true ? true : false;
    }

    function errorFetchUserCreator() {
      vm.listUserCreator = [];
    } 

    function inArray(param, array) {
      var length = array.length;
      for (var i = 0; i < length; i++) {
        if (array[i] == param)
          return true;
        }
      return false;
     }
  }
})();

(function() {
    'use strict';
    angular
      .module('app.hcnews.hc-news')
      .controller('EditHcNewsController', EditHcNewsController);
  
    EditHcNewsController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'data',
      'listNC',
      'config',
      'FileUploader'
    ];
    /** @ngInject */
    function EditHcNewsController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      data,
      listNC,
      config,
      FileUploader
    ) {
      var vm = this;
      var news = AppAPI.News();
      var Attendancereport=AppAPI.Attendancereport();

      vm.Form = Form;
      vm.info = data;
      vm.updateData = updateData;
      vm.dialogClose = dialogClose;
      vm.listNC = listNC;
      vm.company=$localStorage.empsite;
      vm.tinymceOptions = {
        height: 350,
        theme: 'modern',
        plugins: 'print preview fullpage searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample code table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount  imagetools contextmenu colorpicker textpattern',
        toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat image',
        image_advtab: true,
        templates: [
          { title: 'template 1', content: 'Template 1' },
          { title: 'template 2', content: 'Template 2' }
        ],
        file_picker_types: 'image',
        file_picker_callback: function (callback, value, meta) {
          if (meta.filetype == 'image') {
            $('#upload').trigger('click');
            $('#upload').on('change', function () {
              var file = this.files[ 0 ];
              var reader = new FileReader();
              reader.onload = function (e) {
                callback(e.target.result, {
                  alt: ''
                });
              };
              reader.readAsDataURL(file);
            });
          }
        }
      };
      activate();
      
      function activate() {
        vm.title   = data.title;
        vm.content = data.content;
        vm.doc_path = data.doc_path;
        vm.group1= (data.content!=null) ? true:false;
        vm.selectedListNC = data.hc_news_category_id;
        vm.selectedIsPublish = data.is_publish;
        vm.selectedCompany = data.scope.split(", ");
        vm.selectedSap = data.sap.split(", ");

        Form.initialForm();
        Form.setObject(news);
        loadDataBU();
      }
      
      function loadDataBU() {
        var response=news.query({action:'viewBU'});
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }
  
      function fetchBU(data) {
        vm.listBU=data;
  
      }
  
      function errorFetchBU() {
        vm.listBU=[];
      }
  
      function updateData(ev, frm) {
        angular.element.blockUI();
        
        vm.Form.objForm.id = data.id;
        vm.Form.objForm.title = frm.title.$viewValue;
        vm.Form.objForm.category = frm.category.$viewValue;
        vm.Form.objForm.isPublish = frm.publish.$viewValue;
        vm.Form.objForm.content = vm.content;
        vm.Form.objForm.doc_path = vm.group1;
        vm.Form.objForm.company = vm.selectedCompany;
        vm.Form.objForm.sap = vm.selectedSap;
        var response = Form.saveData('updateData', frm, news);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();

            vm.uploader.uploadAll();

            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.pesan)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }

      var uploader = vm.uploader = new FileUploader({
          url:config.api+'api/hcnews/uploadFile', 
          removeAfterUpload:true,
          alias:'newsDocument',    
      });

      // a sync filter
      uploader.filters.push({
        name: 'syncFilter',
        fn: function(item /*{File|FileLikeObject}*/, options) {
            return this.queue.length < 10;
        }
      });

      // an async filter
      uploader.filters.push({
        name: 'asyncFilter',
        fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
            setTimeout(deferred.resolve, 1e3);
        }
      });
    }
  })();
  
(function () {
    'use strict';

    angular
        .module('app.gwmoving.gwlist', ['ui.tinymce', 'ngMaterial', 'ngMessages'])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */

    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.gwmovement_list_gw', {
                url: '/gwmovement/listgw',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/gw-moving/gw-list/gwlist.html',
                        controller: 'MovinggwlistController as vm'
                    }
                }
            })

            .state('app.gwmovement_history', {
                url: '/gwmovement/history',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/gw-moving/gw-list/transfer-history.html',
                        controller: 'TransferhistoryController as vm'
                    }
                }
            });



    }
})();

(function name() {
    'use strict';

    angular
        .module('app.gwmoving.gwlist')
        .controller('TransferController', TransferController);

    function TransferController($mdDialog, $timeout, AppAPI, Auth, Form, data, listLine) {
        var vm = this;
        var endpoint = new AppAPI.GwMoving();
        vm.data = data;
        vm.close = closeModal;
        vm.listLine = listLine;
        vm.saveData = saveData;

        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;

        vm.Form.objForm.nik = data.nik;
        vm.Form.objForm.nama = data.nama;
        vm.Form.objForm.sector_name = data.sector_name;
        vm.Form.objForm.line_number = "Line : " + data.line_number + ", Group : " + data.shift_group_name;

        function closeModal() {
            $mdDialog.cancel();
        }

        function saveData(ev, formController) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                angular.element.blockUI();
                var promise = Form.saveData('save', formController, endpoint);

                promise.then(function () {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

                promise.catch(function () {
                    vm.messageTheme = 'pink';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

            });
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.gwmoving.gwtransfer', [])
    .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */

  function config($translatePartialLoaderProvider, $stateProvider) {
    $stateProvider
      .state('app.gwtransfer_work_location', {
        url: '/gwmovement/transfer/work-location',
        views: {
          'content@app': {
            templateUrl: 'app/main/gw-moving/gw-transfer/transfer-work-location.html',
            controller: 'TransferworklocationController as vm'
          }
        }
      })

      ;

  }
})();

(function () {
  'use strict';
  angular
    .module('app.gwmoving.gwtransfer')
    .controller('TransferworklocationController', TransferworklocationController);

  TransferworklocationController.$inject = [
    "$mdDialog", "$localStorage", "$scope", "$timeout", "AppAPI", "Auth", "Form"
  ];

  function TransferworklocationController($mdDialog, $localStorage, $scope, $timeout, AppAPI, Auth, Form) {
    var vm = this;
    var endpoint = new AppAPI.MovingLocation();
    vm.reloadToken = reloadToken;
    vm.saveData = saveData;
    vm.loadProduct = loadProduct;
    vm.listSelected = [];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.getMppStandard = getMppStandard;
    vm.ketikSearch = ketikSearch;
    vm.listSubLine = ["all", "processing", "packaging"];
    vm.locationSelected = [];
    vm.setPosition = setPosition;
    Form.initialForm();
    Form.setObject(endpoint);
    vm.Form = Form;
    getEmployee();
    getLocation();
    vm.Form.objForm.data = "";
    vm.cekHeadCount = cekHeadCount;
    vm.oksubmit = true;
    vm.delete = deletePosition;
    function loadProduct(search) {
      return $http
        .get(config.api + 'api/emplineposition?action=getProduct&search=' + search)
        .then(function (res) {
          console.log('res', res);
          var datas = [];
          return res.data;
        }).catch(function (err) {
          console.log('err', err);
        });
    }

    function reloadToken() {
      Auth.setToken();
    }

    vm.getEmployeCek = getEmployeCek;
    function getEmployeCek() {
      getEmployee();
    }

    function saveData(ev, formInput) {
      var dataInput = [];
      angular.forEach(vm.listSelected, function (value, key) {
        var item = { "nik": value.nik, "startDate": vm.Form.objForm.effective_date, "endDate": "9999-01-01", "mppStandard": vm.Form.objForm.position, "location": vm.locationSelected, "subLine": vm.Form.objForm.subLine };
        dataInput.push(item);
      });
      vm.Form.objForm.data = dataInput;
      angular.element.blockUI();
      var request = Auth.setToken();
      request.then(function () {

        var response = Form.saveData('save', formInput, endpoint);
        response.then(function (res) {
          vm.messageTheme = 'blue';
          angular.element.unblockUI();
          $timeout(function () {
            getEmployee();
            getLocation();
            vm.Form.tampilPesan = false;
          }, 3000);
        });

        response.catch(function (reason) {
          vm.messageTheme = 'pink';
          angular.element.unblockUI();
          $timeout(function () {
            getEmployee();
            getLocation();
            vm.Form.tampilPesan = false;
          }, 3000);
        });
      });
    }

    function getEmployee() {
      vm.listSelected = [];
      vm.listEmployee = [];

      var promise = endpoint.query({
        action: "viewdata"
      });

      promise.$promise.then(function (dataList) {
        vm.listEmployee = dataList
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.listEmployee = [];
      })
    }

    function getMppStandard(tgl) {
      vm.listMppStandard = [];

      var promise = endpoint.query({
        action: "getmppstandard",
        date: tgl
      });

      promise.$promise.then(function (dataList) {
        vm.listMppStandard = dataList
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.listMppStandard = [];
      });
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listSelected = [];
      vm.listSelected = angular.copy(vm.listEmployee);
    }

    function unCheckAll() {
      vm.listSelected = [];
    }

    function ketikSearch(ev) {
      ev.stopPropagation();
    }

    function getLocation() {
      vm.listLocation = [];

      var promise = endpoint.query({
        action: "getlocation"
      });

      promise.$promise.then(function (dataList) {
        vm.listLocation = dataList[0];
      });
      promise.$promise.catch(function (err) {
        console.log(err);
        vm.listLocation = [];
      })
    }

    vm.toggle = function (item, list) {
      var idx = vm.locationSelected.indexOf(item);
      if (idx > -1) {
        vm.locationSelected.splice(idx, 1);
      }
      else {
        vm.locationSelected.push(item);
      }
    };

    vm.exists = function (item, list) {
      return vm.locationSelected.indexOf(item) > -1;
    };

    /* togle gedung */
    vm.toggleAll = function () {
      if (vm.locationSelected.length === vm.listLocation.gedung.length) {
        vm.locationSelected = [];
      } else if (vm.locationSelected.length === 0 || vm.locationSelected.length > 0) {
        vm.locationSelected = vm.listLocation.gedung.slice(0);
      }
    };

    vm.isIndeterminate = function () {
      return (vm.locationSelected.length !== 0 &&
        vm.locationSelected.length !== vm.listLocation.gedung.length);
    };

    vm.isChecked = function () {
      if (vm.listLocation.length == 0) {
        return false;
      }
      else {
        return vm.locationSelected.length === vm.listLocation.gedung.length;
      }

    };

    /* togle sector */
    vm.toggleAllSector = function () {
      if (vm.locationSelected.length === vm.listLocation.sector.length) {
        vm.locationSelected = [];
      } else if (vm.locationSelected.length === 0 || vm.locationSelected.length > 0) {
        vm.locationSelected = vm.listLocation.sector.slice(0);
      }
    };

    vm.isIndeterminateSector = function () {
      return (vm.locationSelected.length !== 0 &&
        vm.locationSelected.length !== vm.listLocation.sector.length);
    };

    vm.isCheckedSector = function () {
      if (vm.listLocation.length == 0) {
        return false;
      }
      else {
        return vm.locationSelected.length === vm.listLocation.sector.length;
      }

    };

    /* togle line */
    vm.toggleAllLine = function () {
      if (vm.locationSelected.length === vm.listLocation.line.length) {
        vm.locationSelected = [];
      } else if (vm.locationSelected.length === 0 || vm.locationSelected.length > 0) {
        vm.locationSelected = vm.listLocation.line.slice(0);
      }
    };

    vm.isIndeterminateLine = function () {
      return (vm.locationSelected.length !== 0 &&
        vm.locationSelected.length !== vm.listLocation.line.length);
    };

    vm.isCheckedLine = function () {
      if (vm.listLocation.length == 0) {
        return false;
      }
      else {
        return vm.locationSelected.length === vm.listLocation.line.length;
      }

    };

    function setPosition(position) {
      var objPosition = angular.fromJson(position);
      vm.Form.objForm.position = objPosition.id;
      vm.requireQty = objPosition.require_qty;
    }

    function cekHeadCount() {
      var selected = vm.listSelected.length;
      console.log(selected);
      if (selected <= vm.requireQty) {
        vm.oksubmit = false;
      }
      else {
        vm.oksubmit = true;
      }

    }

    function deletePosition(ev) {
      var mppWorkLocationId = [];

      angular.forEach(vm.listSelected, function (value) {
        if (value.mppWorkLocationId > 0) {
          var item = { "id": value.mppWorkLocationId };
          mppWorkLocationId.push(item);
        }
      });

      var promiseAuth = Auth.setToken();

      promiseAuth.then(function () {

        var response = endpoint.delete({
          action: 'delete',
          data: angular.toJson(mppWorkLocationId)
        });

        response.$promise.then(function (data) {
          console.log(data);
          var confirm = $mdDialog.confirm()
            .title(data.hasil)
            .textContent(data.pesan)
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Close')

          $mdDialog.show(confirm).then(function () {
            getEmployee();
            getLocation();
            $mdDialog.cancel();
          });

        });

      });
    }

  }
})();
(function name() {
    'use strict';

    angular
        .module('app.gwmoving.gwlist')
        .controller('RequesttransferController', RequesttransferController);

    function RequesttransferController($mdDialog, $timeout, AppAPI, Auth, Form, listLine) {
        var vm = this;
        var endpoint = new AppAPI.GwMoving();
        vm.close = closeModal;
        vm.listLine = listLine;
        vm.saveData = saveData;

        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;

        function closeModal() {
            $mdDialog.cancel();
        }

        function saveData(ev, formController) {
            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                angular.element.blockUI();
                var promise = Form.saveData('saverequest', formController, endpoint);

                promise.then(function () {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

                promise.catch(function () {
                    vm.messageTheme = 'pink';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.gwmoving.gwrequest', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */

    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.gwmovement_list_request_gw', {
                url: '/gwmovement/list-request-gw',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/gw-moving/gw-request/moving-gw-list-request.html',
                        controller: 'MovinggwlistrequestController as vm'
                    }
                }
            })

            .state('app.gwmovement_request_gw_detail', {
                url: '/gwmovement/request-gw-detail/:data',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/gw-moving/gw-request/moving-gw-request-detail.html',
                        controller: 'MovinggwrequestdetailController as vm'
                    }
                }
            })

        ;

    }
})();

(function () {
    'use strict'

    angular
        .module('app.gwmoving.gwrequest')
        .controller('MovinggwrequestdetailController', MovinggwrequestdetailController);

    MovinggwrequestdetailController.$inject = [
        "$stateParams",
        "$window",
        "$timeout",
        "AppAPI",
        "DataService",
        "Form",
        "Auth",
    ];

    function MovinggwrequestdetailController(
        $stateParams,
        $window,
        $timeout,
        AppAPI,
        DataService,
        Form,
        Auth
    ) {
        var vm = this;
        var endpoint = new AppAPI.GwMoving();
        vm.data = angular.fromJson($stateParams.data);

        vm.DataTable = new DataService();

        vm.listSelected = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        vm.loadDataLine = loadDataLine;
        vm.loadData = viewData;
        vm.saveData = saveData;

        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;

        // viewData(1);
        loadDataSector();
        loadDataGroup();
        loadDataDelegate();
        loadDataTransfer();

        function loadDataSector() {
            vm.listSector = [];
            var response = endpoint.query({
                action: "getsector",
                sector_id: vm.data.gedung_sector_id
            });
            response.$promise.then(function (data) {
                vm.listSector = data;
            });
            response.$promise.catch(function (data) {
                vm.listSector = [];
            });
        }

        function loadDataDelegate() {
            vm.listDelegate = [];
            var response = endpoint.query({
                action: "getdelegate",
                id: vm.data.id
            });
            response.$promise.then(function (data) {
                vm.listDelegate = data;
            });
            response.$promise.catch(function (data) {
                vm.listDelegate = [];
            });
        }

        function loadDataTransfer() {
            vm.listTransfer = [];
            var response = endpoint.query({
                action: "gettransfer",
                id: vm.data.id
            });
            response.$promise.then(function (data) {
                vm.listTransfer = data;
            });
            response.$promise.catch(function (data) {
                vm.listTransfer = [];
            });
        }

        function loadDataLine(id) {
            vm.line = '';
            vm.listLine = [];
            var response = endpoint.query({
                action: "getlinebysector",
                sector_id: id
            });
            response.$promise.then(function (data) {
                vm.listLine = data;
            });
            response.$promise.catch(function (data) {
                vm.listLine = [];
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = [];
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewdataspv',
                sector: vm.sector,
                line: vm.line,
                group: vm.group
            });
        }

        function saveData(ev, formController) {
            vm.Form.objForm.request = $stateParams.data;
            vm.Form.objForm.employe = vm.listSelected;

            var promiseAuth = Auth.setToken();

            promiseAuth.then(function () {
                angular.element.blockUI();
                var promise = Form.saveData('savedataspv', formController, endpoint);

                promise.then(function () {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    loadDataDelegate();
                    loadDataTransfer();
                    viewData(1);

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                        $window.history.back();
                    }, 6000);
                });

                promise.catch(function () {
                    vm.messageTheme = 'pink';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    loadDataDelegate();
                    loadDataTransfer();
                    viewData(1);

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

            });
        }

        function loadDataGroup() {
            vm.listGroup = [];
            var response = endpoint.query({
                action: "getgroup"
            });
            response.$promise.then(function (data) {
                vm.listGroup = data;
            });
            response.$promise.catch(function (data) {
                vm.listGroup = [];
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.gwmoving.gwrequest')
        .controller('MovinggwlistrequestController', MovinggwlistrequestController);

    MovinggwlistrequestController.$inject = [
        "$state",
        "$localStorage",
        "$mdDialog",
        "AppAPI",
        "DataService"
    ];

    function MovinggwlistrequestController(
        $state,
        $localStorage,
        $mdDialog,
        AppAPI,
        DataService
    ) {
        var vm = this;
        var endpoint = new AppAPI.GwMoving();

        vm.company = $localStorage.empsite;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.listStatus = [{
                id: 0,
                description: "Open"
            },
            {
                id: 1,
                description: "Close"
            },
            {
                id: 2,
                description: "All"
            },

        ];

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.viewDetail = viewDetail;
        vm.delegate = delegate;

        vm.user = $localStorage.username;

        viewData(1);

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewdatarequest',
                startDate: vm.startDate,
                endDate: vm.endDate,
                status: vm.status
            });
        }

        function viewDetail(data) {
            var datax = angular.toJson(data);
            $state.go("app.gwmovement_request_gw_detail", {
                data: datax
            });
        }

        function delegate(ev, data) {
            $mdDialog.show({
                controller: 'MovinggwrequestdelegateController',
                controllerAs: 'vm',
                templateUrl: 'app/main/gw-moving/gw-request/moving-gw-delegate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData(1);
                },
                locals: {
                    data: data,
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.gwmoving.gwrequest')
        .controller('MovinggwrequestdelegateController', MovinggwrequestdelegateController);

    function MovinggwrequestdelegateController(
        $mdDialog,
        $timeout,
        AppAPI,
        Auth,
        Form,
        data
    ) {
        var vm = this;
        var endpoint = new AppAPI.GwMoving();
        vm.close = closeModal;
        vm.saveData = saveData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.data = data;

        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;

        getSpvForSharing();

        function closeModal() {
            $mdDialog.cancel();
        }

        function saveData(ev, formController) {
            var promiseAuth = Auth.setToken();
            vm.Form.objForm.spv = vm.listSelected;
            vm.Form.objForm.requestId = vm.data.id;

            promiseAuth.then(function () {
                angular.element.blockUI();
                var promise = Form.saveData('savedelegate', formController, endpoint);

                promise.then(function () {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                        closeModal();
                    }, 9000);
                });

                promise.catch(function () {
                    vm.messageTheme = 'pink';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });
            })
        }

        function getSpvForSharing() {
            vm.listSpv = [];
            var response = endpoint.query({
                action: "getspvforsharing"
            });

            response.$promise.then(function (data) {
                vm.listSpv = data;
            });

            response.$promise.catch(function () {
                vm.listSpv = [];
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = [];
            vm.listSelected = angular.copy(vm.listSpv);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }


    }
})();

(function () {
	'use strict';

	angular
	.module('app.gwmoving.gwlist')
	.controller('TransferhistoryController', TransferhistoryController);

	TransferhistoryController.$inject = [
        "AppAPI",
        "DataService",
        "Auth",
        "config",
        "$localStorage",
        "$state"
	];

	function TransferhistoryController(
		AppAPI,
        DataService,
        Auth,
        config,
        $localStorage,
        $state
	) {
		var vm = this;
		var endpoint = new AppAPI.GwMoving();

        vm.company = $localStorage.empsite;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.getLine = getLine;

        viewData(1);
        getLine();

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewhistory',
                start_date: vm.startDate,
                end_date: vm.endDate,
                line: vm.line
            });
        }

        function getLine() {
            vm.listLine = [];

            var promise = endpoint.query({
                action: "getline",
                nik: $localStorage.user,
                date: vm.workingDate
            });

            promise.$promise.then(function (dataList) {
                vm.listLine = dataList
            });
            promise.$promise.catch(function (err) {
                console.log(err);
                vm.listLine = [];
            })
        }
	}
})();
(function () {
    'use strict';

    angular
        .module('app.gwmoving.gwlist')
        .controller('SetlinepositionController', SetlinepositionController);

    function SetlinepositionController($mdDialog, $timeout, AppAPI, Auth, Form, listLine) {
        var vm = this;
        var endpoint = new AppAPI.GwMoving();
        vm.close = closeModal;
        vm.listLine = listLine;
        vm.saveData = saveData;

        Form.initialForm();
        Form.setObject(endpoint);
        vm.Form = Form;
        vm.loadDataLinePosition = loadDataLinePosition;
        vm.listSelected = [];

        function closeModal() {
            $mdDialog.cancel();
        }

        function saveData(ev, formController) {
            var promiseAuth = Auth.setToken();
            vm.Form.objForm.data = vm.listSelected;

            promiseAuth.then(function () {
                angular.element.blockUI();
                var promise = Form.saveData('savelineposition', formController, endpoint);

                promise.then(function () {
                    vm.messageTheme = 'blue';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        loadDataLinePosition();
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

                promise.catch(function () {
                    loadDataLinePosition();
                    vm.messageTheme = 'pink';
                    angular.element.unblockUI();
                    formController.$setPristine();

                    $timeout(function () {
                        vm.Form.tampilPesan = false;
                    }, 9000);
                });

            });
        }

        function loadDataLinePosition() {
            vm.listLinePosition = [];
            vm.listGw = [];
            var response = endpoint.query({
                action: "getlineposition",
                date: vm.date,
                line: vm.line
            });
            response.$promise.then(function (data) {
                vm.listLinePosition = data[0].position;
                vm.listGw = data[0].gw;
            });
            response.$promise.catch(function () {
                vm.listLinePosition = [];
                vm.listGw = [];
            });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.gwmoving.gwlist')
        .controller('MovinggwlistController', MovinggwlistController);

    MovinggwlistController.$inject = [
        "AppAPI",
        "DataService",
        "Auth",
        "config",
        "$localStorage",
        "$state",
        "$mdDialog"
    ];

    function MovinggwlistController(
        AppAPI,
        DataService,
        Auth,
        config,
        $localStorage,
        $state,
        $mdDialog
    ) {
        var vm = this;
        var endpoint = new AppAPI.GwMoving();

        vm.company = $localStorage.empsite;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        vm.DataTable = new DataService();
        vm.loadData = viewData;
        vm.getLine = getLine;
        vm.transfer = transfer;
        vm.requestTransfer = requestTransfer;
        vm.setLinePosition = setLinePosition;

        viewData(1);
        getLine();

        function viewData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewdata',
                date: vm.workingDate,
                line: vm.line
            });
        }

        function getLine() {
            vm.listLine = [];

            var promise = endpoint.query({
                action: "getline",
                nik: $localStorage.user,
                date: vm.workingDate
            });

            promise.$promise.then(function (dataList) {
                vm.listLine = dataList
            });
            promise.$promise.catch(function (err) {
                console.log(err);
                vm.listLine = [];
            })
        }

        function transfer(ev, data) {
            $mdDialog.show({
                controller: 'TransferController',
                controllerAs: 'vm',
                templateUrl: 'app/main/gw-moving/gw-transfer/transfer.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData(1);
                },
                locals: {
                    data: data,
                    listLine: vm.listLine
                }
            });
        }

        function requestTransfer(ev) {
            $mdDialog.show({
                controller: 'RequesttransferController',
                controllerAs: 'vm',
                templateUrl: 'app/main/gw-moving/gw-request/request-transfer.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData(1);
                },
                locals: {
                    listLine: vm.listLine
                }
            });
        }

        function setLinePosition(ev) {
            $mdDialog.show({
                controller: 'SetlinepositionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/gw-moving/gw-list/set-line-position.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData(1);
                },
                locals: {
                    listLine: vm.listLine
                }
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.gwmoving.areacoverage', ['ngMaterial', 'ngMessages'])
    .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */

  function config($translatePartialLoaderProvider, $stateProvider) {
    $stateProvider
      .state('app.areacoverage_list', {
        url: '/areacoverage/list',
        views: {
          'content@app': {
            templateUrl: 'app/main/gw-moving/area-coverage/areacoverage-list.html',
            controller: 'AreacoveragelistController as vm'
          }
        }
      })

      .state('app.areacoverage_detail', {
        url: '/areacoverage/detail/:data',
        views: {
          'content@app': {
            templateUrl: 'app/main/gw-moving/area-coverage/areacoverage-list.html',
            controller: 'AreacoveragelistController as vm'
          }
        }
      });

  }
})();
(function () {
  'use strict';
  angular
    .module('app.gwmoving.areacoverage')
    .controller('AreacoveragelistController', AreacoveragelistController);
  AreacoveragelistController.inject = [
    "AppAPI",
    "DataService",
    "Auth",
    "config",
    "$localStorage",
    "$state",
    "$mdDialog"];
  function AreacoveragelistController(
    AppAPI,
    DataService,
    Auth,
    config,
    $localStorage,
    $state,
    $mdDialog) {
    var vm = this;
    var endpoint = new AppAPI.AreaCoverage();

    vm.company = $localStorage.empsite;
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];

    vm.DataTable = new DataService();
    vm.loadData = viewData;
    vm.viewDetail = viewDetail;
    vm.createArea = createArea;
    vm.getSector = getSector;
    vm.getLine = getLine;

    viewData(1);
    getGedung();

    function viewData(pageno) {
      angular.element.blockUI();
      vm.DataTable.loadData(endpoint, pageno, {
        action: 'viewdata',
        date: vm.workingDate,
        gedung: vm.gedung,
        sector: vm.sector,
        line: vm.line
      });
    }

    function viewDetail(ev, param) {
      $mdDialog.show({
        controller: 'AreacoveragedetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/gw-moving/area-coverage/areacoverage-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          viewData(1);
        },
        locals: {
          data: param
        }
      });
    }

    function createArea(ev) {
      $mdDialog.show({
        controller: 'AreacoveragecreateController',
        controllerAs: 'vm',
        templateUrl: 'app/main/gw-moving/area-coverage/areacoverage-create.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          viewData(1);
        },
        locals: {
        }
      });
    }

    function getGedung() {
      vm.listGedung = [];

      var promise = endpoint.query({
        action: "getgedung"
      });

      promise.$promise.then(function (dataList) {
        vm.listGedung = dataList;
      });
      promise.$promise.catch(function (err) {
        vm.listGedung = [];
      })
    }

    function getSector(param) {
      vm.listSector = [];
      var promise = endpoint.query({
        action: "getsector",
        param: param
      });

      promise.$promise.then(function (dataList) {
        vm.listSector = dataList;
      });
      promise.$promise.catch(function (err) {
        vm.listSector = [];
      })
    }

    function getLine(param) {
      vm.listLine = [];

      var promise = endpoint.query({
        action: "getline",
        param: param
      });

      promise.$promise.then(function (dataList) {
        vm.listLine = dataList;
      });
      promise.$promise.catch(function (err) {
        vm.listLine = [];
      })
    }

  }
})();
(function () {
  'use strict';
  angular
    .module('app.gwmoving.areacoverage')
    .controller('AreacoveragedetailController', AreacoveragedetailController);

  function AreacoveragedetailController(
    $mdDialog,
    Auth,
    AppAPI,
    data
  ) {
    var vm = this;
    var endpoint = new AppAPI.AreaCoverage();
    vm.dataHeader = data;
    vm.closeModal = closeModal;
    vm.deleteDetail = deleteDetail;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.listSelected = [];

    viewDetail();

    function closeModal() {
      $mdDialog.cancel();
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listSelected = [];
      vm.listSelected = angular.copy(vm.listDetail);
    }

    function unCheckAll() {
      vm.listSelected = [];
    }

    function viewDetail() {
      vm.listDetail = [];
      var response = endpoint.query({
        action: "getdetail",
        nik: data.nik
      });
      response.$promise.then(function (rs) {
        vm.listDetail = rs;
      });

      response.$promise.catch(function (rs) {
        vm.listDetail = [];
      });
    }

    function deleteDetail(ev) {
      var promiseAuth = Auth.setToken();

      promiseAuth.then(function () {

        var response = endpoint.delete({
          action: 'delete',
          data: angular.toJson(vm.listSelected)
        });

        response.$promise.then(function (data) {

          var confirm = $mdDialog.confirm()
            .title('Success.!')
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Close')

          $mdDialog.show(confirm).then(function () {
            viewDetail();
          });

        });

      });
    }

  }
})();
(function () {
  'use strict';
  angular
    .module('app.gwmoving.areacoverage')
    .controller('AreacoveragecreateController', AreacoveragecreateController);

  function AreacoveragecreateController(
    $mdDialog,
    $timeout,
    Auth,
    AppAPI,
    Form
  ) {
    var vm = this;
    var endpoint = new AppAPI.AreaCoverage();
    vm.locationSelected = [];
    vm.listLocation = [];
    vm.listRole = [];
    vm.closeModal = closeModal;
    vm.choose = choose;
    Form.initialForm();
    Form.setObject(endpoint);
    vm.Form = Form;
    vm.saveData = saveData;

    getLocation();
    getRole();

    function closeModal() {
      $mdDialog.cancel();
    }

    function getLocation() {
      vm.listLocation = [];

      var promise = endpoint.query({
        action: "getlocation"
      });

      promise.$promise.then(function (dataList) {
        vm.listLocation = dataList[0];
      });
      promise.$promise.catch(function (err) {
        vm.listLocation = [];
      })
    }

    function getRole() {
      vm.listRole = [];

      var promise = endpoint.query({
        action: "getrole"
      });

      promise.$promise.then(function (dataList) {
        vm.listRole = dataList;
      });
      promise.$promise.catch(function (err) {
        vm.listRole = [];
      })
    }

    vm.toggle = function (item, list) {
      var idx = vm.locationSelected.indexOf(item);
      if (idx > -1) {
        vm.locationSelected.splice(idx, 1);
      }
      else {
        vm.locationSelected.push(item);
      }
    };

    vm.exists = function (item, list) {
      return vm.locationSelected.indexOf(item) > -1;
    };

    /* togle gedung */
    vm.toggleAll = function () {
      if (vm.locationSelected.length === vm.listLocation.gedung.length) {
        vm.locationSelected = [];
      } else if (vm.locationSelected.length === 0 || vm.locationSelected.length > 0) {
        vm.locationSelected = vm.listLocation.gedung.slice(0);
      }
    };

    vm.isIndeterminate = function () {
      return (vm.locationSelected.length !== 0 &&
        vm.locationSelected.length !== vm.listLocation.gedung.length);
    };

    vm.isChecked = function () {
      if (vm.listLocation.length == 0) {
        return false;
      }
      else {
        return vm.locationSelected.length === vm.listLocation.gedung.length;
      }

    };

    /* togle sector */
    vm.toggleAllSector = function () {
      if (vm.locationSelected.length === vm.listLocation.sector.length) {
        vm.locationSelected = [];
      } else if (vm.locationSelected.length === 0 || vm.locationSelected.length > 0) {
        vm.locationSelected = vm.listLocation.sector.slice(0);
      }
    };

    vm.isIndeterminateSector = function () {
      return (vm.locationSelected.length !== 0 &&
        vm.locationSelected.length !== vm.listLocation.sector.length);
    };

    vm.isCheckedSector = function () {
      if (vm.listLocation.length == 0) {
        return false;
      }
      else {
        return vm.locationSelected.length === vm.listLocation.sector.length;
      }

    };

    /* togle line */
    vm.toggleAllLine = function () {
      if (vm.locationSelected.length === vm.listLocation.line.length) {
        vm.locationSelected = [];
      } else if (vm.locationSelected.length === 0 || vm.locationSelected.length > 0) {
        vm.locationSelected = vm.listLocation.line.slice(0);
      }
    };

    vm.isIndeterminateLine = function () {
      return (vm.locationSelected.length !== 0 &&
        vm.locationSelected.length !== vm.listLocation.line.length);
    };

    vm.isCheckedLine = function () {
      if (vm.listLocation.length == 0) {
        return false;
      }
      else {
        return vm.locationSelected.length === vm.listLocation.line.length;
      }

    };

    function choose(emp) {
      vm.emp = "";
      vm.emp = emp;
      vm.Form.objForm.nik = emp.nik;
    }

    vm.querySearch = function (query, index) {
      if (query !== null && query !== "" && (query + "").length >= 3) {

        var promise = endpoint.query({
          action: "getemployee",
          date: vm.Form.objForm.effective_date,
          query: query
        });

        return promise.$promise.then(function (data) {
          return data;
        });

        return promise.$promise.catch(function (err) {
          return [];
        });

      }
      return [];
    }

    function saveData(ev, formController) {
      vm.Form.objForm.location = vm.locationSelected;
      var promiseAuth = Auth.setToken();
      promiseAuth.then(function () {
        angular.element.blockUI();
        var promise = Form.saveData('save', formController, endpoint);

        promise.then(function () {
          vm.messageTheme = 'blue';
          angular.element.unblockUI();
          formController.$setPristine();

          $timeout(function () {
            vm.Form.tampilPesan = false;
          }, 9000);
        });

        promise.catch(function () {
          vm.messageTheme = 'pink';
          angular.element.unblockUI();
          formController.$setPristine();

          $timeout(function () {
            vm.Form.tampilPesan = false;
          }, 9000);
        });
      });
    }

  }
})();
(function () {
    'use strict';

    angular
        .module('app.employee.uploadgedung', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject = ['$stateProvider', 'msNavigationServiceProvider'];
    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.employee_employee_upload_gedung', {
                url: '/employee/upload-building',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employee/upload-building/upload-building.html',
                        controller: 'UploadBuildEmpingController as vm'
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employee.uploadgedung')
        .controller('UploadFormBuildingController', UploadFormBuildingController);

    UploadFormBuildingController.$inject = ['$state', '$mdDialog', 'config', '$localStorage', '$timeout', 'AppAPI', 'Auth', 'FileUploader', '$location', '$window', '$filter'];

    /* @ngInject */
    function UploadFormBuildingController($state, $mdDialog, config, $localStorage, $timeout, AppAPI, Auth, FileUploader, $location, $window, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.closeModal = closeModal
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.DownloadTemplate = DownloadTemplate;
        vm.FileUpload = new FileUploader({
            url: config.api + 'api/employe/uploagedung',
            removeAfterUpload: true,
            alias: 'fileupload',
            formData: [
                {
                    action: 'uploadgedung'
                }],
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
            if (status.status == 'Failed') {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }
            vm.uploadNotif = status.message
            angular.element('#uploadCutOff').val('');
        };

        vm.FileUpload.onErrorItem = function () {
            vm.uploadSuccess = false;
            vm.uploadError = true;
        };

        function closeModal() {
            $mdDialog.hide();
        }

        function DownloadTemplate(type) {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/employe/downloadtemplate?type=' +
                        type,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.uploadgedung')
        .controller('UploadBuildEmpingController', UploadBuildEmpingController);

    UploadBuildEmpingController.$inject = ['$state', '$window', '$location', '$localStorage', '$document', '$element', '$http', '$scope', 'config', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService'];

    /* @ngInject */
    function UploadBuildEmpingController($state, $window, $location, $localStorage, $document, $element, $http, $scope, config, $log, $mdDialog, AppAPI, Auth, DataService) {
        var vm = this;
        var Attendancereport = AppAPI.Attendancereport();
        var Building = AppAPI.Gedung();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.uploadBuilding = uploadBuilding;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;
        vm.loadData = loadData;
        vm.company = $localStorage.empsite;
        vm.groupLogin = $localStorage.group;
        vm.user = $localStorage.user;
        vm.divisi = 'all';
        vm.department = 'all';

        vm.typeEmp = [
            {
                "view": "Staff",
                "value": "SAP"
            },
            {
                "view": "General Worker",
                "value": "HRIS"
            }
        ];

        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();

        function uploadBuilding(ev) {
            $mdDialog.show({
                controller: 'UploadFormBuildingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/upload-building/upload-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                }
            });

        }

        function loadData(pageno) {
            vm.DataTable.loadData(Building, pageno, { action: 'viewGedungSector', company: vm.company, divisi: vm.divisi, department: vm.department, echeckin: vm.viewEcheckin, subarea: vm.subarea, emptype: vm.employeeType });
        }

        /** start load BU */
        function loadDataBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }
        /** end load BU */

        /** start load Division */
        function loadDataDivision(idbu) {
            var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }
        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }
        function errorDivisiBU() {
            vm.listDivision = [];
        }
        /** end load Division */

        /** start load Department */
        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }
        function fetchDepartment(data) {
            vm.listDepartment = data;
        }
        function errorDepartment() {
            vm.listDepartment = [];
        }
        /** end load Department */

        /** start load Sub Area */
        function loadSubArea() {
            var response = Attendancereport.query({ action: 'viewSubArea' });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }
        function fetchArea(data) {
            vm.subArea = data;
        }
        function errorfetchArea(data) {
            vm.subArea = [];
        }
        /** end load Sub Area */
    }
})();
(function() {
    'use strict';
    angular
        .module('app.employee.town')
        .controller('TownController', TownController);

    TownController.$inject = [
        'DataService',
        '$state',
        '$mdDialog',
        '$location',
        'config',
        '$localStorage',
        '$window',
        '$timeout',
        'AppAPI',
        'Auth',
        '$document',
        'Form'
    ];
    /** @ngInject */
    function TownController(
        DataService,
        $state,
        $mdDialog,
        $location,
        config,
        $localStorage,
        $window,
        $timeout,
        AppAPI,
        Auth,
        $document,
        Form
    ) {
        var vm = this;
        var Town = AppAPI.Town();
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.items = [];
        vm.addDataTown = addDataTown;
        vm.deleteData = deleteData;
        vm.updateData = updateData;
        vm.upload = upload;
        vm.country_id = "";
        
        activate();

        function activate() {
            vm.selected = [];
            loadData(1);
            loadDataCountry();
        }

        function loadData(pageno) {
            var resp = vm.DataTables.loadData(Town, pageno, {
                action: 'viewData', country:vm.country_id
            });

            resp.then(function(data) {
                vm.selected = [];
                vm.items = data.list;
            });
        }

        function showDialogInfo(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.pesan)
                        .ariaLabel(data.title)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function addDataTown(ev) {
            $mdDialog.show({
                controller: 'InputTownController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/town/input-town/input-town.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals: {
                    loadData: vm.loadData,
                    infoDialog: vm.showDialogInfo,
                    listCountry: vm.listCountry,
                },
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function updateData(ev, data) {
            $mdDialog.show({
                controller: 'UpdateTownController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/town/update-town/update-town.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals: {
                loadData: vm.loadData,
                infoDialog: vm.showDialogInfo,
                listCountry: vm.listCountry,
                dataUpdate: data
                },
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function upload(ev) {
            $mdDialog.show({
                controller         : 'UploadfileTownController as vm',
                templateUrl        : 'app/main/employee/town/uploadfile/uploadfile.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            });
        }
        
        function deleteData(ev) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent('Data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                    $mdDialog.show(confirm).then(
                        function() {
                            var data = [];
                            for (var index = 0; index < vm.selected.length; index++) {
                                data.push(vm.selected[index].id);
                            }
                            angular.element.blockUI();
                            var response = Town.delete({
                                action: 'deleteData',
                                data: angular.toJson(data)
                            });
                            response.$promise.then(function(data) {
                                dialogClose();
                                angular.element.unblockUI();
                                showDialogInfo(ev, data);
                            });
                        },
                        function() {
                            // $scope.status = 'You decided to keep your debt.';
                        }
                );
            });
        }

        function loadDataCountry() {
            var response = Town.query({ action: 'getListCountry' });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listCountry = data;
        }

        function errorFetchCountry() {
            vm.listCountry = [];
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
        }

        function isChecked() {
            return vm.selected.length === vm.items.length;
        }

        function toggleAll() {
            if (vm.selected.length === vm.items.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.items.slice(0);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.team-assignment')
        .controller('TeamassignmentController', TeamassignmentController);


    TeamassignmentController.$inject = ['$state', '$mdDialog', '$document', '$localStorage', 'DataService', 'AppAPI', 'Auth', 'GeneralService', 'Form', '$timeout', '$filter'];
    /** @ngInject */
    function TeamassignmentController($state, $mdDialog, $document, $localStorage, DataService, AppAPI, Auth, GeneralService, Form, $timeout, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var Teamassignment = AppAPI.Teamassignment(); //memanggil api modules dari api
        var Employe = AppAPI.Employe();
        var Employeecostcenter = AppAPI.Employeecostcenter();

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService(); //inisialisasi class DataService
        Form.initialForm(false);
        Form.setObject(Teamassignment);
        vm.Form = Form;
        vm.saveData = saveData;
        vm.loadData = loadData;
        vm.editData = editData;
        vm.insertData = insertData;
        vm.closeModal = closeModal;
        vm.company = $localStorage.empsite;
        vm.loadDirectName = loadDirectName;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.uploadAssignment = uploadAssignment;
        vm.downloadAssignment = downloadAssignment;
        vm.reset = reset;
        vm.disableNew = $localStorage.empsite == 'RK' ? 1 : 0;
        vm.disableNew = 0;
        vm.loadData=loadData;
        vm.onCollapse=onCollapse;

        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [
            { link: '#', name: 'Team Assignment', active: '0' }
        ];

        vm.listType = ["employee", "sic", "department"];

        loadData(1);

        if(!vm.disableNew) {
            loadEmp();
            loadDescription();
            loadDataBU();
            loadSubArea();
        }

        function loadDirectName() {
            angular.element.blockUI();
            vm.codeCDD = vm.Form.objForm.companyId + vm.Form.objForm.dvisionId + vm.Form.objForm.departmentId;
            var response = Teamassignment.query({ action: 'viewDirectReportName', cddcode: vm.codeCDD });
            response.$promise.then(fetchDirectName);
            response.$promise.catch(errorDirectName);
        }

        function fetchDirectName(data) {
            angular.element.unblockUI();
            vm.listDirectName = data;
        }

        function errorDirectName() {
            angular.element.unblockUI();
            vm.listDirectName = [];
        }

        function loadData(pageno) {
            var tglStart = null;
            var tglEnd = null;

            if(vm.tglmulai != null && vm.tglakhir != null) {
                var startYear = vm.tglmulai.getFullYear();
                var startMonthPre = vm.tglmulai.getMonth() + 1;
                var startMonth = startMonthPre < 10 ? '0' + startMonthPre : startMonthPre;
                var startDate = vm.tglmulai.getDate();

                var endYear = vm.tglakhir.getFullYear();
                var endMonthPre = vm.tglakhir.getMonth() + 1;
                var endMonth = endMonthPre < 10 ? '0' + endMonthPre : endMonthPre;
                var endDate = vm.tglakhir.getDate();

                tglStart=startYear + '-' + startMonth + '-' + startDate;
                tglEnd=endYear + '-' + endMonth + '-' + endDate;
            }

            angular.element.blockUI();
            var resp = vm.DataTable.loadData(Teamassignment, pageno, { action: 'viewDataList', start_date: tglStart, end_date: tglEnd});
            resp.then(function() {
                angular.element.unblockUI();
            });
        }

        function loadEmp() {
            var response = Employe.query({ action: 'getEmployeTeam' });
            response.$promise.then(fetchEmp);
            response.$promise.catch(errorFetchEmp);
        }

        function fetchEmp(data) {
            vm.listEmp = data;
        }

        function errorFetchEmp() {
            vm.listBU = [];
        }

        function loadDescription() {
            angular.element.blockUI();
            var response = Employeecostcenter.query({ action: 'viewDescriptionCostCenter' });
            response.$promise.then(fetchDescription);
            response.$promise.catch(errorDescription);
        }

        function fetchDescription(data) {
            angular.element.unblockUI();
            vm.listcnb = data[0].cnb;
            vm.listnoncnb = data[0].noncnb;
        }

        function errorDescription() {
            angular.element.unblockUI();
            vm.listcnb = [];
            vm.listnoncnb = [];
        }

        function loadDataDepartment(iddivisi) {
            angular.element.blockUI();
            var response = Teamassignment.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            angular.element.unblockUI();
            vm.listDepartment = data;
            // loadData(1);
        }

        function errorDepartment() {
            angular.element.unblockUI();
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            angular.element.blockUI();
            var response = Teamassignment.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            angular.element.unblockUI();
            vm.listDivision = data;
            // loadData(1);
        }

        function errorDivisiBU() {
            angular.element.unblockUI();
            vm.listDivision = [];
        }

        function loadDataBU() {
            angular.element.blockUI();
            var response = Teamassignment.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            angular.element.unblockUI();
            vm.listBU = data;
        }

        function errorFetchBU() {
            angular.element.unblockUI();
            vm.listBU = [];
        }

        function loadSubArea() {
            angular.element.blockUI();
            var response = Teamassignment.query({ action: 'viewSubArea' });
            response.$promise.then(fetchSubArea);
            response.$promise.catch(errorFetchSubArea);
        }

        function fetchSubArea(data) {
            angular.element.unblockUI();
            vm.listSubArea = data;
        }

        function errorFetchSubArea() {
            angular.element.unblockUI();
            vm.listSubArea = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            var response = Form.saveData('saveData', formController, Teamassignment);
            response.then(function (data) {
                vm.messageTheme = 'blue';
                angular.element.unblockUI();
                formController.$setPristine();
                showDialogInfo(ev, data);
                $timeout(function () {
                    vm.Form.tampilPesan = false;
                }, 3000);
            });
            response.catch(function () {
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
                showDialogInfo(ev, data);
            });
        }

        function showDialog() {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent()
            ).then(function () {
                closeModal();
            });
        }


        function insertData(ev) {
            $mdDialog.show({
                controller: 'TeamassignmentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/team-assignment/insert-team-assignment.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editData(ev, data) {
            $mdDialog.show({
                controller: 'EditTeamAssignmentontroller',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/team-assignment/insert-team-assignment.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    edt: data
                }
            });
        }

        function uploadAssignment(ev) {
            $mdDialog.show({
                controller: 'UploadfileAssignmentController as vm',
                templateUrl: 'app/main/employee/team-assignment/uploadfile/uploadfile.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        function downloadAssignment(ev) {
            $mdDialog.show({
                controller: 'DownloadfileAssignmentController as vm',
                templateUrl: 'app/main/employee/team-assignment/downloadfile/downloadfile.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    tglmulaiData: vm.tglmulai,
                    tglakhirData: vm.tglakhir
                },
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function reset(form) {
            vm.tglmulai = null;
            vm.tglakhir = null;


            form.$setPristine();
            form.$setUntouched();

            loadData(1);
        }

      function onCollapse() {
        if(vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
          vm.DataTable.searchParam = '';
          loadData(1);
        }
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.employee.team-assignment')
        .controller('EditTeamAssignmentontroller', EditTeamAssignmentontroller);
    /* @ngInject */
    EditTeamAssignmentontroller.$inject = ['$localStorage','$mdDialog','Form','AppAPI','config','edt'];

    /* @ngInject */
    function EditTeamAssignmentontroller($localStorage,$mdDialog,Form,AppAPI,config,edt) {
        var vm = this;
            vm.saveData=saveData;

        Form.initialForm();

        var Costcenter = AppAPI.Costcenter();

        // set constructor form
        Form.setObject(Costcenter);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.listType = [
            {id:1, type:'Hanya OT KHL'},
            {id:2, type:'Hanya OT Normal'},
            {id:3, type:'Semua Bisa'},
            {id:4, type:'Tidak Bisa OT'},
        ];
        
        var response=vm.Form.objForm.$get({action:'viewDetail',id:edt.id});
        response.then(setData);

        function setData(data)
        {
            vm.Form.objForm.id=edt.id;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }
         
        function saveData(ev,formController) {
            var promise= Form.updateData('updateData', formController, Costcenter, edt.id, 'viewDetail');
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog() {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent()
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function () {
  'use strict';

  angular
      .module('app.employee.subarea', [
        'app.employee.subarea.input-subarea',
        'app.employee.subarea.update-subarea'
      ])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_subarea', {
              url: '/employee/subarea',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/subarea/subarea.html',
                      controller: 'SubAreaController as vm',
                      css: ['app/main/employee/subarea/subarea.scss']
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.employee.subarea')
    .controller('SubAreaController', SubAreaController);

  SubAreaController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$location',
    'config',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form'
  ];
  /** @ngInject */
  function SubAreaController(
    DataService,
    $state,
    $mdDialog,
    $location,
    config,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form
  ) {
    var vm = this;
    var Attendancereport = AppAPI.Attendancereport();
    // var ApiHoliday = AppAPI.NationalHoliday();
    var ApiSubarea = AppAPI.Subarea();
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.company = $localStorage.empsite;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addDataSubArea = addDataSubArea;
    vm.deleteDataSubArea = deleteDataSubArea;
    vm.updateDataSubArea = updateDataSubArea;
    vm.ExportToExcel = ExportToExcel;
    vm.onCollapse = onCollapse;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      // loadSubArea();
      loadDataBU();
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(ApiSubarea, pageno, {
        action: 'viewListSubarea',
        company: vm.company
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function addDataSubArea(ev) {
      $mdDialog.show({
        controller: 'InputSubareaController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/subarea/input-subarea/input-subarea.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          loadData: vm.loadData,
          infoDialog: vm.showDialogInfo,
          listBU: vm.listBU
        },
        clickOutsideToClose: false,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function updateDataSubArea(ev, data) {
      $mdDialog.show({
        controller: 'UpdateSubareaController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/subarea/update-subarea/update-subarea.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          loadData: vm.loadData,
          infoDialog: vm.showDialogInfo,
          listBU: vm.listBU,
          dataUpdate: data,
          townList: vm.townList
        },
        clickOutsideToClose: false,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteDataSubArea(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = ApiSubarea.delete({
              action: 'deleteDataSubArea',
              data: angular.toJson(data)
            });
            response.$promise.then(function(data) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function loadDataBU() {
      var response = Attendancereport.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    // function loadSubArea() {
    //   var response = ApiHoliday.query({
    //     action: 'loadDataSubArea',
    //     idbu: vm.company
    //   });
    //   response.$promise.then(fetchArea);
    //   response.$promise.catch(errorfetchArea);
    // }

    // function fetchArea(data) {
    //   vm.subArea = data;
    // }

    // function errorfetchArea(data) {
    //   vm.subArea = [];
    // }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function ExportToExcel() {
		  var search = vm.DataTables.searchParam;
		  if(!search) 
			  search = 0;
      
      var company = vm.company;

        var token=Auth.setTokenPromise();
          token.then(function(data){
            var protocol=$location.protocol();
            var host=$location.host();
            $window.open(protocol+'://'+host+'/'+config.api+'api/subarea/exportexcel/' + search + '/' + company, '_blank');
          },function(){      
            $window.alert('gagal load token');
          });
    }

    function onCollapse() {
      if(vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
        vm.DataTable.searchParam = '';
        vm.loadData(1);
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.promotion', [])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.employee_promotion', {
                url    : '/employee/promotion',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/promotion/index.html',
                        controller : 'PromotionController as vm'
                    }
                }
            });
    }
})();
(function () {
  'use strict';
  angular
    .module('app.employee.promotion')
    .controller('UploadPromotionController', UploadPromotionController);

  UploadPromotionController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadPromotionController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.upload = upload
    vm.detailInfo = []

    function upload() {
      angular.element.blockUI();
      vm.FileUpload.uploadAll();
    }
    vm.FileUpload = new FileUploader({
      url: config.api + 'api/promotion/uploadfile',
      removeAfterUpload: true,
      alias: 'filepromotion',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function () {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/promotion/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
    'use strict';

    angular
        .module('app.employee.promotion')
        .controller('PromotionController', PromotionController);


    PromotionController.$inject = ['$stateParams', '$document', '$localStorage', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'EmployeeService', 'DataService'];
    /** @ngInject */
    function PromotionController($stateParams, $document, $localStorage, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, EmployeeService, DataService) {

        var vm = this;

        vm.EmployeeService = EmployeeService;
        EmployeeService.title = 'Promotion';
        vm.viewData = viewData;

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService(); //inisialisasi class DataService

        // initial form
        Form.initialForm();

        var Promotion = AppAPI.Promotion();
        var Attendancereport = AppAPI.Attendancereport();
        var PayrollProcess = AppAPI.NewPayrollProcess();
        var Subarea = AppAPI.Subarea();
        // vm.employe = employe;
        vm.UploadPromotion = UploadPromotion;

        // set constructor form
        Form.setObject(Promotion);

        vm.nik = 'all';


        // set form to controller
        vm.Form = Form;
        vm.company = $localStorage.empsite;
        vm.groupLogin = $localStorage.group;
        vm.user = $localStorage.user;
        vm.Form.objForm.nik = null;
        vm.Form.objForm.hiredate = null;
        vm.hiredate = false;
        vm.Form.objForm.jointdate = null;
        vm.jointdate = false;
        vm.saveProcess = false;
        vm.data = null;

        vm.divisi = 'all';
        vm.department = 'all';
        vm.divdeptdisabled = false;
        vm.budisabled = true;
        vm.dataSales = false;
        vm.wilayah = null;
        vm.region = null;
        vm.cabang = null;
        vm.area = null;

        vm.selected = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.items = [];

        vm.openInputPromotion = openInputPromotion;
        vm.editInputPromotion = editInputPromotion;
        vm.closeModal = closeModal;
        vm.deleteData = deleteData;
        vm.loadData = viewData;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;
        vm.loadSalesArea = loadSalesArea;
        vm.changeArea = changeArea;
        vm.country = $localStorage.country;

        switch (vm.groupLogin) {
            case '1':
            case '104':
            case '130':
            case '10':
            case '132':
                vm.budisabled = false;
                break;
            case '11':
            case '127':
                vm.budisabled = true;
                vm.divdeptdisabled = true;
                vm.upload = false;
                vm.download = false;
                break;
            case '130':
                vm.budisabled = false;
                vm.divdeptdisabled = true;
                vm.upload = false;
                vm.eCheckin = true;
                vm.download = true;
                break;
            case '131':
                vm.budisabled = true;
                vm.divdeptdisabled = true;
                vm.upload = true;
                vm.typedisabled = true;
                vm.employeeType = 'HRIS';
                vm.eCheckin = false;
                vm.download = true;
                break;
            case '164':
            case '165':
            case '167':
            case '169':
                vm.dataSales = true;
                break;
        }

        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();
        // vm.loadData = loadData;
        // loadData(1);
        LoadCountry();

        function changeArea() {
            vm.wilayah = null;
            vm.region = null;
            vm.cabang = null;
            vm.area = null;
            loadSalesArea();
        }

        function loadSubArea() {
            var response = Attendancereport.query({
                action: 'viewSubArea',
                company: vm.company,
                cabangcode: vm.cabang
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }


        function loadDataBU() {
            var response = Attendancereport.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadDataDivision(idbu) {
            if (idbu == 'PM') {
                vm.dataSales = true;
                loadSalesArea();
            }
            var response = Attendancereport.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;

            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadSalesArea() {
            var response = Subarea.query({
                action: 'getAreaSales',
                subarea: vm.subarea,
                wilayah: vm.wilayah,
                region: vm.region,
                cabang: vm.cabang
            });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorfetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.areaSales = data[0].area;
            vm.cabangSales = data[0].cabang;
            vm.regionSales = data[0].region;
            vm.wilayahSales = data[0].wilayah;
        }

        function errorfetchAreaSales(data) {
            vm.areaSales = [];
            vm.cabangSales = [];
            vm.regionSales = [];
            vm.wilayahSales = [];
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            // vm.listDivision.push(data);
            // loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        viewData(1);

        function viewData(pageno) {
            angular.element.blockUI();
            var dataPromise = vm.DataTable.loadData(Promotion, pageno, {
                action: 'viewData',
                company: vm.company,
                country: vm.country,
                divisi: vm.divisi,
                department: vm.department,
                subarea: vm.subarea,
                wilayah: vm.wilayah,
                region: vm.region,
                cabang: vm.cabang,
                area: vm.area
            });

            dataPromise.then(function (data) {
                vm.selected = [];
                vm.items = data.list;
            });

        }

        function UploadPromotion(ev) {
            $mdDialog.show({
                controller: 'UploadPromotionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/promotion/upload-promotion.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData(1);
                    // employe();
                },
                locals: {
                    data: vm.data
                }
            });
        }

        function openInputPromotion(ev) {
            $mdDialog.show({
                controller: 'PromotionCreateController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/promotion/create.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData(1);
                    // employe();
                },
                locals: {
                    data: vm.data
                }
            });
        }

        function editInputPromotion(ev, data) {
            $mdDialog.show({
                controller: 'PromotionEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/promotion/create.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData(1);
                    // employe();
                },
                locals: {
                    data: data
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function deleteData(ev) {

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Promotion.delete({ action: 'deletepromotion', data: angular.toJson(vm.selected) });
                    response.$promise.then(function (resData) {
                        angular.element.unblockUI();
                        var title = 'Success Delete Data';
                        var textContent = 'Process Delete data was Success';
                        var ariaLabel = 'Success Delete Data';
                        showDialogMessage(title, textContent, ariaLabel);
                        viewData(1);
                    });
                    response.$promise.catch(function () {
                        angular.element.unblockUI();
                        var title = 'Delete Data Failed';
                        var textContent = 'Process delete data promotion has been failed.';
                        var ariaLabel = 'Delete Data Failed';
                        showDialogMessage(title, textContent, ariaLabel, ev);
                    })
                }, function () {

                });
            });
        }

        function showDialogMessage(title, textContent, ariaLabel, ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(textContent)
                    .ariaLabel(ariaLabel)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function isIndeterminate() {
            return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
        }

        function isChecked() {
            return vm.selected.length === vm.items.length;
        }

        function toggleAll() {
            if (vm.selected.length === vm.items.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.items.slice(0);
            }
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }
    }
})();  

(function () {
  'use strict';

  angular
    .module('app.employee.promotion')
    .controller('PromotionEditController', PromotionEditController);

  /** @ngInject */
  PromotionEditController.$inject = ['$mdDialog', '$localStorage', 'data', 'AppAPI', 'Auth', 'Form', '$q', 'filterFilter', '$stateParams', '$scope', '$filter', '$http', 'config', '$element'];
  /** @ngInject */
  function PromotionEditController($mdDialog, $localStorage, data, AppAPI, Auth, Form, $q, filterFilter, $stateParams, $scope, $filter, $http, config, $element) {
    var vm = this;

    var translate = $filter('translate');
    // $scope.my = {}
    // initial form
    Form.initialForm();

    // get constructor form
    var Promotion = AppAPI.Promotion();
    var Employements = AppAPI.Employements();
    var Attendancereport = AppAPI.Attendancereport();

    // set constructor form
    Form.setObject(Promotion);

    // set form to controller
    vm.Form = Form;

    vm.closeModal = closeModal;
    // vm.id=id;
    vm.saveData = updateData;
    vm.setToken = Auth.setToken;

    vm.oldAllowance = [];
    vm.proAllowance = [];

    // vm.company=$localStorage.empsite;
    vm.Form.objForm.nik = null;

    vm.nik = true;
    vm.divisi = null;
    vm.department = null;
    vm.getJobTitle = getJobTitle;
    vm.getLevelCategory = getLevelCategory;
    vm.saveProcess = false;
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.loadJfmSub = loadJfmSub;
    vm.loadGedung = loadGedung;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.querySearchDeferred = querySearchDeferred;
    vm.getJfm = getJfm;
    vm.addAllowance = addAllowance;
    vm.delListAllowance = delListAllowance;
    vm.selectedItemChanged = selectedItemChanged;
    vm.selectedItemChangedAtasan = selectedItemChangedAtasan;
    vm.getEmployeeAtasan = getEmployee;
    vm.getEmployee = getEmployee;
    vm.isRequiredGedung = vm.company == 'KS' ? true : false;
    vm.checkActing = checkActing
    vm.setDisabled = setDisabled
    vm.disabledAfterChangeJob = false;
    vm.isDisabled = false;
    vm.isDisabledMpnNumber = true;
    vm.setActing = setActing();

    function setActing() {
      vm.Form.objForm.act_result = typeof vm.Form.objForm.act_result == 'undefined' ? 3 : vm.Form.objForm.act_result;
    }
    function setDisabled(param) {
      vm.listMpnNumberDetail = [];

      var res = param.split("-");
      getMpnNumber('detail', res[0], res[1]);
    }

    function getRefCostCentreCnb() {
      vm.saveProcess = true;
      var response = Promotion.query({ action: 'getRefCostCentre', company: vm.company, type: 'cnb' });
      response.$promise.then(fetchRefCostCentre);
      response.$promise.catch(errorRefCostCentre);
    }

    function fetchRefCostCentre(data) {
      vm.listRefCostCentreCnb = data;
      vm.saveProcess = false;
    }

    function errorRefCostCentre(data) {
      vm.listRefCostCentreCnb = [];
      vm.saveProcess = false;
    }

    function getRefCostCentreNonCnb() {
      vm.saveProcess = true;
      var response = Promotion.query({ action: 'getRefCostCentre', company: vm.company, type: 'noncnb' });
      response.$promise.then(fetchRefCostCentreNon);
      response.$promise.catch(errorRefCostCentreNon);
    }

    function fetchRefCostCentreNon(data) {
      vm.listRefCostCentreNonCnb = data;
      vm.saveProcess = false;
    }

    function errorRefCostCentreNon(data) {
      vm.listRefCostCentreNonCnb = [];
      vm.saveProcess = false;
    }

    function checkActing() {
      if (vm.Form.objForm.acting == false || typeof vm.Form.objForm.acting == 'undefined') {
        vm.Form.objForm.acting = 1;
        vm.isChecked = true
      } else {
        vm.isChecked = false
        vm.Form.objForm.acting = 0;
      }
    }

    vm.setEmp = setEmp
    vm.changeEffectiveData = changeEffectiveData
    vm.emp = {
      selectedItem: null,
      searchText: null
    }

    function getMpnNumber(actionType, id, mpnNumber) {
      vm.saveProcess = true;
      var response = Promotion.query({
        action: 'getMpnNumber',
        action_type: actionType,
        id: id,
        mpn_number: mpnNumber,
        company: data.to_company
      });
      if (actionType == 'detail') {
        response.$promise.then(fetchMpnNumberDetail);
        response.$promise.catch(errorMpnNumberDetail);
      } else {
        response.$promise.then(fetchMpnNumber);
        response.$promise.catch(errorMpnNumber);
      }
    }

    function fetchMpnNumber(data) {
      vm.listMpnNumber = data;
      vm.saveProcess = false;
    }

    function errorMpnNumber(data) {
      vm.listMpnNumber = [];
      vm.saveProcess = false;
    }

    function fetchMpnNumberDetail(data) {
      vm.listMpnNumberDetail = data;
      vm.saveProcess = false;

      var obj = vm.listMpnNumberDetail[0];
      vm.Form.objForm.businessTitle = obj.businessTitle;
      vm.isDisabled = true;
      vm.Form.objForm.mpn_replacement_id = obj.id + '-' + obj.mpn_number
      vm.company = obj.company_id
      vm.divisi = obj.division_id;
      vm.Form.objForm.jobGrade = obj.emp_grade
      vm.Form.objForm.empGrade = obj.emp_grade
      vm.Form.objForm.subArea = obj.sub_area
      vm.department = obj.department_id;
      vm.Form.objForm.flag_mpn = obj.flag;

      getLevelCategory(obj.emp_grade);
      loadDataDepartment(vm.divisi);
      getRefCostCentreCnb(vm.company);
      getRefCostCentreNonCnb(vm.company);
    }

    function errorMpnNumberDetail(data) {
      vm.listMpnNumberDetail = [];
      vm.saveProcess = false;
    }
    vm.messageTheme = 'pink';
    vm.listAllowance = [];
    vm.gradeMaster = ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A', '6B', '6C', '7'];
    vm.gradeJob = vm.gradeMaster;
    vm.gradeEmp = vm.gradeMaster;

    vm.level = ['001', '002', '003', '004', '005', '006', '007', '008'];
    vm.category = ['Non-Staff', 'Staff', 'Supervisory', 'Managerial'];
    vm.actResult = [
      { id: 1, description: 'pass' },
      { id: 2, description: 'failed' },
      { id: 3, description: 'progress' }
    ];

    ////////////////////////////////////
    empList();
    getMpnNumber('update', data.mpn_replacement_id, '');
    setEmp(data)
    function selectedItemChanged(employee) {
      vm.Form.objForm.nik = '';
      vm.Form.objForm.name = '';
      vm.Form.objForm.date_of_birth = '';
      if (typeof employee !== 'undefined' && employee) {
        vm.isDisabledMpnNumber = false;
        vm.Form.objForm.nik = employee.empno;
        vm.Form.objForm.name = employee.name
        vm.Form.objForm.date_of_birth = employee.date_of_birth
        setEmp(employee)
      }
    }

    function selectedItemChangedAtasan(employee) {
      vm.Form.objForm.nikAtasan = '';
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.nikAtasan = employee.empno;
      }
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/promotion?action=viewListEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function setEmp(data) {
      vm.isDisabledMpnNumber = false;
      vm.Form.objForm.nikParam = data.nik + ' - ' + data.name;
      vm.Form.objForm.nik = data.nik;
      vm.Form.objForm.name = data.name;
      vm.Form.objForm.date_of_birth = data.date_of_birth;
      vm.Form.objForm.nikAtasanParam = data.directReport + ' - ' + data.directReportname;
      vm.Form.objForm.nikAtasan = data.directReport;
      vm.emp.selectedItem = vm.Form.objForm.nik
      vm.Form.objForm.skNo = data.skNo;
      vm.Form.objForm.jobTitle = data.job_title;
      vm.company = data.to_company;
      vm.divisi = data.to_division;
      vm.department = data.to_department;
      vm.Form.objForm.effectiveDate = new Date(data.effectiveDate);
      vm.Form.objForm.jobGrade = data.jobGrade;
      vm.Form.objForm.empGrade = data.empGrade;
      vm.Form.objForm.emp_job_id = data.emp_job_id;
      vm.Form.objForm.subArea = data.to_sub_area;
      vm.Form.objForm.gedung = data.to_gedung;
      vm.Form.objForm.empCategory = data.emp_category;
      vm.Form.objForm.jobLevel = data.job_level;
      vm.Form.objForm.jfm = data.jfm;
      vm.Form.objForm.jfmSub = data.jfmSub;
      vm.Form.objForm.acting = data.acting;
      vm.isChecked = vm.Form.objForm.acting == '1' ? true : false;
      vm.selectedItem = data.directReport;
      vm.Form.objForm.mpn_replacement_id_old = data.mpn_replacement_id + '-' + data.mpn_number;
      vm.Form.objForm.flag_mpn_old = data.flag_mpn;
      vm.isDisabled = false;
      if (data.mpn_replacement_id != null) {
        vm.isDisabled = true;
      }
      vm.Form.objForm.mpn_replacement_id = data.mpn_replacement_id + '-' + data.mpn_number;

      vm.Form.objForm.emp_sub_area_id = data.emp_sub_area_id;
      vm.Form.objForm.emp_cost_center_id = data.emp_cost_center_id;
      vm.Form.objForm.businessTitle = data.businessTitle;
      vm.Form.objForm.description = data.description;
      vm.Form.objForm.old_cost_centre_cnb = data.old_cost_center_cnb;
      vm.Form.objForm.old_cost_centre_noncnb = data.old_cost_center_noncnb;
      vm.Form.objForm.costcnb = data.to_cost_center_cnb;
      vm.Form.objForm.costnoncnb = data.to_cost_center_noncnb;
      vm.Form.objForm.act_startDate = data.start_date ? new Date(data.start_date) : new Date(data.effectiveDate);
      vm.Form.objForm.act_endDate = new Date(data.end_date);

      loadDataDivision(vm.company);
      loadDataDepartment(vm.divisi);
      getRefCostCentreCnb(vm.company);
      getRefCostCentreNonCnb(vm.company);

      if (data.acting_result == 'pass') {
        vm.Form.objForm.act_result = 1
      } else if (data.acting_result == 'failed') {
        vm.Form.objForm.act_result = 2
      } else {
        vm.Form.objForm.act_result = 3;
      }

      loadJfm();
      loadDataBU();
      loadSubArea();
      loadDataOldJob();
      loadDetailPromotion();
      loadDataSalaryComponent();
      getJobTitle();
      getJfm();
      loadDataOldAllowance();
      loadGedung(vm.Form.objForm.subArea);
    }

    //  $scope.$watch('my.promotionForm', function(newVal) {
    //   // console.info('myForm watch');
    //   console.log(newVal);
    //   my.promotionForm.setPristine();
    //   // newVal.$setPrestine()

    //   // console.log($scope.formValid);

    // });

    // console.log($scope.my);


    // changeDate();

    // function changeDate() {
    //   loadJfm();
    //   loadDataBU();
    //   loadSubArea();
    //   // vm.Form.objForm.acting = false;
    //   // vm.Form.objForm.nik = data.nik;

    //   var posID=data.abreviation;
    //   // vm.company=posID.substring(0,2)
    //   // vm.divisi=posID.substring(2,4);
    //   // vm.department=posID.substring(4,6);
    //   loadDetailPromotion(); 
    //   loadDataOldJob();
    //   loadDataSalaryComponent();
    //   loadDataDivision(vm.company);
    //   loadDataDepartment(vm.divisi); 
    //   getJobTitle();
    //   loadGedung(vm.Form.objForm.subArea); 
    // }

    function loadDetailPromotion() {
      var response = Promotion.query({ action: 'viewDetail', id: data.id });
      response.$promise.then(fetchDetail);
      response.$promise.catch(errorDetail);
    }

    function fetchDetail(data) {
      vm.listAllowance = [];
      angular.forEach(data, function (value, key) {
        var obj = {};
        obj["Amount"] = value.amount;
        obj["ID_SalaryComponent"] = value.id_salary_component;
        obj["ID_employee"] = value.id_employee;
        obj["effective_date"] = new Date(value.effective_date);
        vm.listAllowance.push(obj);
      });
      vm.saveProcess = false;

    }

    function errorDetail(data) {
      vm.proAllowance = [];
      vm.saveProcess = false;
    }

    function addAllowance() {
      var obj = {};
      obj["Amount"] = vm.Amount;
      obj["ID_SalaryComponent"] = vm.ID_SalaryComponent;
      obj["ID_employee"] = vm.Form.objForm.nik;
      obj["effective_date"] = vm.Form.objForm.effectiveDate;
      vm.listAllowance.push(obj);
    }

    function delListAllowance(idx) {
      vm.listAllowance.splice(idx, 1);
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function getJfm() {
      vm.disabledAfterChangeJob = false;
      if (vm.company == 'PM') {
        vm.disabledAfterChangeJob = true;
      }
      var jt = vm.Form.objForm.jobTitle;
      vm.Form.objForm.jfm = jt.substring(7, 9);
      vm.Form.objForm.jfmSub = jt.substring(9, 12);
    }

    function updateData(ev, formController) {
      var str = vm.Form.objForm.jobTitle;
      var words = str.split("-");

      vm.Form.objForm.mpn_replacement_id = null;
      vm.Form.objForm.mpn_replacement_id_old = null;

      if(vm.Form.objForm.mpn_replacement_id) {  
        var res = vm.Form.objForm.mpn_replacement_id.split("-");
        vm.Form.objForm.mpn_replacement_id = res[0];
      }

      if(vm.Form.objForm.mpn_replacement_id_old) {
        var resOld = vm.Form.objForm.mpn_replacement_id_old.split("-");
        vm.Form.objForm.mpn_replacement_id_old = resOld[0];
      }

      vm.Form.objForm.jobTitle = words[1];
      vm.Form.objForm.abreviation = words[0];
      vm.Form.objForm.company = vm.company;
      vm.Form.objForm.department = vm.department;
      vm.Form.objForm.division = vm.divisi;
      var nikatasan = typeof vm.Form.objForm.nikAtasan == 'undefined' ? vm.nikAtasan : vm.Form.objForm.nikAtasan;
      vm.Form.objForm.directReport = nikatasan;
      vm.Form.objForm.allowance = vm.listAllowance;
      vm.Form.objForm.old_emp_grade = vm.listOldJob.emp_grade;
      vm.Form.objForm.old_abreviation = data.old_abbreviattion;
      vm.Form.objForm.id = data.id;

      if (vm.Form.objForm.acting == false || typeof vm.Form.objForm.acting == 'undefined') {
        vm.Form.objForm.acting = 0;
      } else {
        vm.Form.objForm.acting = 1;
      }

      var promise = Form.saveData('updateData', formController, Promotion);
      promise.then(function (data) {
        showDialogInfo(ev, data);
      });
    }

    function showDialog(ev) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Save Data')
          .textContent('Process Data was Success.')
          .ariaLabel('Success Save Data')
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }

    function loadDataOldJob() {
      vm.saveProcess = true;
      var response = Promotion.query({ action: 'viewOldJob', id: vm.Form.objForm.nik });
      response.$promise.then(fetchOldJob);
      response.$promise.catch(errorOldJob);
    }

    function fetchOldJob(data) {
      vm.listOldJob = data[0];

      var posID = vm.listOldJob.positionID;

      vm.Form.objForm.old_emp_job_id = vm.listOldJob.id;
      vm.Form.objForm.old_direct_report = vm.listOldJob.direct_report;
      vm.Form.objForm.jobTitle = vm.listOldJob.abreviation + '-' + vm.listOldJob.job_title;
      vm.Form.objForm.nikAtasanParam = vm.listOldJob.direct_report + ' - ' + vm.listOldJob.directReportname;
      vm.nikAtasan = vm.listOldJob.direct_report;
      vm.Form.objForm.old_company = vm.listOldJob.company_id;
      vm.Form.objForm.old_country = vm.listOldJob.country_id;
      vm.Form.objForm.old_division = posID.substring(2, 4);
      vm.Form.objForm.old_department = posID.substring(4, 6);
      vm.Form.objForm.old_sub_area = vm.listOldJob.sub_area_id;
      vm.Form.objForm.old_cost_centre = vm.listOldJob.cost_center_id;

      vm.Form.objForm.jobGrade = vm.listOldJob.job_grade
      vm.Form.objForm.empGrade = vm.listOldJob.emp_grade
      vm.Form.objForm.empCategory = vm.listOldJob.emp_category
      vm.Form.objForm.jobLevel = vm.listOldJob.job_level
      vm.Form.objForm.costcnb = vm.listOldJob.old_cnb
      vm.Form.objForm.subArea = vm.listOldJob.sub_area_id
      vm.Form.objForm.costnoncnb = vm.listOldJob.old_noncnb

      vm.saveProcess = false;
    }

    function errorOldJob(data) {
      vm.listOldJob = [];
      vm.saveProcess = false;
    }

    function loadDataSalaryComponent() {
      vm.saveProcess = true;
      var response = Promotion.query({ action: 'viewSalaryComponent' });
      response.$promise.then(fetchSalaryComponent);
      response.$promise.catch(errorSalaryComponent);
    }

    function fetchSalaryComponent(data) {
      vm.listSalaryComponent = data;
      vm.saveProcess = false;
    }

    function errorSalaryComponent(data) {
      vm.listSalaryComponent = [];
      vm.saveProcess = false;
    }

    function loadDataDepartment(iddivisi) {
      vm.saveProcess = true;
      var response = Attendancereport.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
      vm.saveProcess = false;
    }

    function errorDepartment() {
      vm.listDepartment = [];
      vm.saveProcess = false;
    }

    function loadDataDivision(idbu) {
      vm.saveProcess = true;
      var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
      empList();
    }

    function fetchDivisiBU(data) {
      vm.listDivision = data;
      vm.saveProcess = false;
    }

    function errorDivisiBU() {
      vm.listDivision = [];
      vm.saveProcess = false;
    }

    function loadDataBU() {
      vm.saveProcess = true;
      var response = Attendancereport.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
      vm.saveProcess = false;
    }

    function errorFetchBU() {
      vm.listBU = [];
      vm.saveProcess = false;
    }

    function getJobTitle() {
      vm.saveProcess = true;
      var response = Employements.query({ action: 'getJobTitle', company: vm.company, divisi: vm.divisi, department: vm.department });
      response.$promise.then(fetchJobTitle);
      response.$promise.catch(errorJobTitle);
    }

    function fetchJobTitle(data) {
      vm.listJobTitle = data;
      vm.saveProcess = false;
    }

    function errorJobTitle() {
      vm.listJobTitle = [];
      vm.saveProcess = false;
    }

    function getLevelCategory(grade) {
      vm.saveProcess = true;
      vm.Form.objForm.empCategory = null;
      vm.Form.objForm.jobLevel = null;
      var response = Employements.query({ action: 'getLevelCategory', grade: grade });
      response.$promise.then(fetchLevel);
      response.$promise.catch(errorFtechLevel);

    }

    function fetchLevel(data) {
      vm.Form.objForm.empCategory = data[0].description;
      vm.Form.objForm.jobLevel = data[0].level;
      vm.saveProcess = false;
    }

    function errorFtechLevel() {
      vm.Form.objForm.empCategory = null;
      vm.saveProcess = false;
    }

    function loadSubArea() {
      var response = Promotion.query({ action: 'viewSubArea', company: vm.company });
      response.$promise.then(fetchSubArea);
      response.$promise.catch(errorFetchSubArea);
    }

    function fetchSubArea(data) {
      vm.listSubArea = data;
    }

    function errorFetchSubArea() {
      vm.listSubArea = [];
    }

    function loadGedung(id_sub) {
      var response = Promotion.query({ action: 'viewGedung', id: id_sub });
      response.$promise.then(fetchGedung);
      response.$promise.catch(errorFetchGedung);
    }

    function fetchGedung(data) {
      vm.listGedung = data;
    }

    function errorFetchGedung() {
      vm.listGedung = [];
    }

    function loadJfm() {
      var response = Promotion.query({ action: 'viewJfm' });
      response.$promise.then(fetchJfm);
      response.$promise.catch(errorFetchJfm);
    }

    function fetchJfm(data) {
      vm.listJfm = data;
    }

    function errorFetchJfm() {
      vm.listJfm = [];
    }

    function loadJfmSub(id_jfm) {
      var response = Promotion.query({ action: 'viewJfmSub', id: id_jfm });
      response.$promise.then(fetchJfmSub);
      response.$promise.catch(errorFetchJfmSub);
    }

    function fetchJfmSub(data) {
      vm.listJfmSub = data;
    }

    function errorFetchJfmSub() {
      vm.listJfmSub = [];
    }

    function empList() {
      var response = Promotion.query({
        action: 'viewListEmployee',
        company: vm.company
      });
      response.$promise.then(fetchDataEmpList);
    }

    function fetchDataEmpList(data) {
      vm.empListData = data;
    }

    function empList() {
      var response = Promotion.query({
        action: 'viewListEmployee',
        company: vm.company
      });
      response.$promise.then(fetchDataEmpList);
    }

    function fetchDataEmpList(data) {
      vm.empListData = data;
    }

    function querySearchDeferred(query) {
      var deferred = $q.defer();
      setTimeout(function () {
        var data = vm.empListData;
        if (query) {
          deferred.resolve(filterFilter(data, query));
        } else {
          deferred.reject([{ nik: 'none', name: 'none' }]);
        }
      }, 200);
      return deferred.promise;
    }

    function loadDataOldAllowance() {
      var response = Promotion.query({ action: 'viewOldAllowance', id: vm.Form.objForm.nik });
      response.$promise.then(fetchDataOldAllowance);
      response.$promise.catch(errorFetchDataOldAllowance);
    }

    function fetchDataOldAllowance(data) {
      vm.oldAllowance = data;
    }

    function errorFetchDataOldAllowance() {
      vm.oldAllowance = [];
    }

    function checkGrade(type, value) {
      if (type == 'gradeJob') {

        var arrJobGrade = [];

        angular.forEach(vm.gradeJob, function (val) {

          if (val > value) {
            arrJobGrade.push(val);
          }

        });

        if (arrJobGrade.length > 0) {
          vm.gradeJob = arrJobGrade
        }

      } else if (type == 'gradeEmp') {

        var arrEmpGrade = [];

        angular.forEach(vm.gradeEmp, function (v) {
          if (v > value) {
            arrEmpGrade.push(v);
          }

        });

        if (arrEmpGrade.length > 0) {
          vm.gradeEmp = arrEmpGrade;
        }
      }
    }

    function changeEffectiveData() {
      vm.Form.objForm.act_startDate = vm.Form.objForm.effectiveDate;
    }

    function loadDetailPromotion() {
      var response = Promotion.query({ action: 'viewDetail', id: data.id });
      response.$promise.then(fetchDetail);
      response.$promise.catch(errorDetail);
    }

    function fetchDetail(data) {
      vm.listAllowance = [];
      angular.forEach(data, function (value, key) {
        var obj = {};
        obj["Amount"] = value.amount;
        obj["ID_SalaryComponent"] = value.id_salary_component;
        obj["ID_employee"] = value.id_employee;
        obj["effective_date"] = new Date(value.effective_date);
        vm.listAllowance.push(obj);
      });
      vm.saveProcess = false;

    }

    function errorDetail(data) {
      vm.proAllowance = [];
      vm.saveProcess = false;
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var message = translate(data.pesan);
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }

})();  

(function () {
  'use strict';

  angular
    .module('app.employee.promotion')
    .controller('PromotionCreateController', PromotionCreateController);

  /** @ngInject */
  PromotionCreateController.$inject = ['$stateParams', '$mdDialog', '$localStorage', 'AppAPI', 'Auth', 'Form', '$q', 'filterFilter', '$filter', '$http', 'config', '$element'];
  /** @ngInject */
  function PromotionCreateController($stateParams, $mdDialog, $localStorage, AppAPI, Auth, Form, $q, filterFilter, $filter, $http, config, $element) {
    var vm = this;

    var translate = $filter('translate');

    // initial form
    Form.initialForm();

    // get constructor form
    var Promotion = AppAPI.Promotion();
    var Employements = AppAPI.Employements();
    var Attendancereport = AppAPI.Attendancereport();

    // set constructor form
    Form.setObject(Promotion);

    // set form to controller
    vm.Form = Form;

    vm.closeModal = closeModal;
    // vm.id=id;
    vm.saveData = saveData;
    vm.setToken = Auth.setToken;
    vm.company = $localStorage.empsite;

    vm.nik = true;
    vm.divisi = null;
    vm.department = null;
    vm.getJobTitle = getJobTitle;
    vm.getLevelCategory = getLevelCategory;
    vm.saveProcess = false;
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.loadJfmSub = loadJfmSub;
    vm.loadGedung = loadGedung;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.querySearchDeferred = querySearchDeferred;
    vm.getJfm = getJfm;
    vm.addAllowance = addAllowance;
    vm.delListAllowance = delListAllowance;
    vm.selectedItemChanged = selectedItemChanged;
    vm.selectedItemChangedAtasan = selectedItemChangedAtasan;
    vm.getEmployeeAtasan = getEmployee;
    vm.getEmployee = getEmployee;
    vm.Form.objForm.acting = 0;
    vm.isRequiredGedung = vm.company == 'KS' ? true : false;
    vm.checkActing = checkActing
    vm.setDisabled = setDisabled
    vm.disabledAfterChangeJob = vm.company == 'KS' ? true : false;
    vm.isDisabledMpnNumber = true;

    vm.isDisabled = false;
    function setDisabled(param) {
      vm.listMpnNumberDetail = [];
      var res = param.split("-");
      getMpnNumber('detail', res[0], res[1]);
    }

    vm.setEmp = setEmp
    vm.changeEffectiveData = changeEffectiveData
    vm.emp = {
      selectedItem: null,
      searchText: null
    }
    vm.Form.objForm.act_result = 3;

    function selectedItemChanged(employee) {
      vm.Form.objForm.nik = '';
      vm.Form.objForm.name = '';
      vm.Form.objForm.date_of_birth = '';
      if (typeof employee !== 'undefined' && employee) {
        vm.isDisabledMpnNumber = false;
        vm.Form.objForm.nik = employee.empno;
        vm.Form.objForm.name = employee.name
        vm.Form.objForm.date_of_birth = employee.date_of_birth
        setEmp(employee)
      }
    }

    function selectedItemChangedAtasan(employee) {
      vm.Form.objForm.nikAtasan = '';
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.nikAtasan = employee.empno;
      }
    }

    getMpnNumber('insert', 0, '');

    var date = new Date();
    var nowM = date.getMonth() + 1;
    var nowYear = date.getFullYear();
    var nowD = date.getDate()
    var newDate = nowYear + '-' + nowM + '-' + nowD
    vm.nowDate = new Date(newDate);

    vm.oldAllowance = [];

    vm.messageTheme = 'pink';
    vm.listAllowance = [];
    vm.gradeMaster = ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A', '6B', '6C', '7'];
    vm.gradeJob = vm.gradeMaster;
    vm.gradeEmp = vm.gradeMaster;
    vm.level = ['001', '002', '003', '004', '005', '006', '007', '008'];
    vm.category = ['Non-Staff', 'Staff', 'Supervisory', 'Managerial'];
    vm.actResult = [
      { id: 1, description: 'pass' },
      { id: 2, description: 'failed' },
      { id: 3, description: 'progress' }
    ];

    ////////////////////////////////////

    function setEmp(data) {

      // vm.Form.objForm.nik = data.empno;
      vm.Form.objForm.old_abreviation = data.positionID;

      loadDataDivision(vm.company);

      loadJfm();
      loadDataBU();
      loadSubArea();
      loadDataOldJob();
      loadDataSalaryComponent();
      getJobTitle();
      setTimeout(function () { getJfm(); }, 7000);
      loadDataOldAllowance();
      vm.disabledAfterChangeJob = false;
      if (vm.company == 'PM') {
        vm.disabledAfterChangeJob = true;
      }
    }

    function changeEffectiveData() {
      vm.Form.objForm.act_startDate = vm.Form.objForm.effectiveDate;
      getDefaultAllowance();
    }

    function addAllowance() {
      var obj = {};
      obj["Amount"] = vm.Amount;
      obj["ID_SalaryComponent"] = vm.ID_SalaryComponent.ID;
      obj["desc_SalaryComponent"] = vm.ID_SalaryComponent.description;
      obj["ID_employee"] = vm.Form.objForm.nik;
      obj["effective_date"] = vm.Form.objForm.effectiveDate;
      vm.listAllowance.push(obj);
    }

    function delListAllowance(idx) {
      vm.listAllowance.splice(idx, 1);
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function getJfm() {
      vm.disabledAfterChangeJob = false;
      if (vm.company == 'PM') {
        vm.disabledAfterChangeJob = true;
      }
      var jt = vm.Form.objForm.jobTitle;
      console.log(jt)
      vm.Form.objForm.jfm = jt.substring(7, 9);
      vm.Form.objForm.jfmSub = jt.substring(9, 12);
    }

    function checkActing() {
      if (vm.Form.objForm.acting == false || typeof vm.Form.objForm.acting == 'undefined') {
        vm.Form.objForm.acting = 1;
        vm.isChecked = true
      } else {
        vm.isChecked = false
        vm.Form.objForm.acting = 0;
      }
    }

    function saveData(ev, formController) {
      var str = vm.Form.objForm.jobTitle;
      var words = str.split("-");

      vm.Form.objForm.mpn_replacement_id = null;
      if(vm.Form.objForm.mpn_replacement_id) {
        var res = vm.Form.objForm.mpn_replacement_id.split("-");
        vm.Form.objForm.mpn_replacement_id = res[0];
      }

      var nikatasan = typeof vm.Form.objForm.nikAtasan == 'undefined' ? vm.nikAtasan : vm.Form.objForm.nikAtasan;
      vm.Form.objForm.jobTitle = words[1];
      vm.Form.objForm.abreviation = words[0];
      vm.Form.objForm.company = vm.company;
      vm.Form.objForm.department = vm.department;
      vm.Form.objForm.division = vm.divisi;
      vm.Form.objForm.directReport = nikatasan;
      vm.Form.objForm.allowance = vm.listAllowance;
      vm.Form.objForm.old_emp_grade = vm.listOldJob.emp_grade;

      var promise = Form.saveData('save', formController, Promotion);
      promise.then(function (data) {
        showDialogInfo(ev, data);
      });
    }

    function showDialog(ev) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Save Data')
          .textContent('Process Data was Success.')
          .ariaLabel('Success Save Data')
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }

    function loadDataOldJob() {
      vm.saveProcess = true;
      var response = Promotion.query({ action: 'viewOldJob', id: vm.Form.objForm.nik });
      response.$promise.then(fetchOldJob);
      response.$promise.catch(errorOldJob);
    }

    function fetchOldJob(data) {
      vm.listOldJob = data[0];
      var posID = vm.listOldJob.positionID;

      vm.Form.objForm.old_emp_job_id = vm.listOldJob.id;
      vm.Form.objForm.old_direct_report = vm.listOldJob.direct_report;
      vm.Form.objForm.jobTitle = vm.listOldJob.abreviation + '-' + vm.listOldJob.job_title;
      vm.Form.objForm.nikAtasanParam = vm.listOldJob.direct_report + ' - ' + vm.listOldJob.directReportname;
      vm.nikAtasan = vm.listOldJob.direct_report;
      vm.Form.objForm.old_company = vm.listOldJob.company_id;
      vm.Form.objForm.old_country = vm.listOldJob.country_id;
      vm.Form.objForm.old_division = posID.substring(2, 4);
      vm.Form.objForm.old_department = posID.substring(4, 6);
      vm.Form.objForm.old_sub_area = vm.listOldJob.sub_area_id;
      vm.Form.objForm.old_cost_centre = vm.listOldJob.cost_center_id;
      vm.Form.objForm.old_cost_centre_cnb = vm.listOldJob.old_cnb;
      vm.Form.objForm.old_cost_centre_noncnb = vm.listOldJob.old_noncnb;


      vm.Form.objForm.jobGrade = vm.listOldJob.job_grade
      vm.Form.objForm.empGrade = vm.listOldJob.emp_grade
      vm.Form.objForm.empCategory = vm.listOldJob.emp_category
      vm.Form.objForm.jobLevel = vm.listOldJob.job_level
      vm.Form.objForm.costcnb = vm.listOldJob.old_cnb
      vm.Form.objForm.subArea = vm.listOldJob.sub_area_id
      vm.Form.objForm.costnoncnb = vm.listOldJob.old_noncnb
      vm.department = posID.substring(4, 6);
      vm.divisi = posID.substring(2, 4);

      loadDataDepartment(vm.divisi);
      getRefCostCentreCnb(vm.listOldJob.company_id);
      getRefCostCentreNonCnb(vm.listOldJob.company_id);

      // checkGrade('gradeJob', vm.listOldJob.job_grade);
      // checkGrade('gradeEmp', vm.listOldJob.emp_grade);

    }

    function errorOldJob(data) {
      vm.listOldJob = [];
      vm.saveProcess = false;
    }

    function loadDataSalaryComponent() {
      vm.saveProcess = true;
      var response = Promotion.query({ action: 'viewSalaryComponent' });
      response.$promise.then(fetchSalaryComponent);
      response.$promise.catch(errorSalaryComponent);
    }

    function fetchSalaryComponent(data) {
      vm.listSalaryComponent = data;
      vm.saveProcess = false;
    }

    function errorSalaryComponent(data) {
      vm.listSalaryComponent = [];
      vm.saveProcess = false;
    }

    function getRefCostCentreCnb() {
      vm.saveProcess = true;
      var response = Promotion.query({ action: 'getRefCostCentre', company: vm.company, type: 'cnb' });
      response.$promise.then(fetchRefCostCentre);
      response.$promise.catch(errorRefCostCentre);
    }

    function fetchRefCostCentre(data) {
      vm.listRefCostCentreCnb = data;
      vm.saveProcess = false;
    }

    function errorRefCostCentre(data) {
      vm.listRefCostCentreCnb = [];
      vm.saveProcess = false;
    }

    function getRefCostCentreNonCnb() {
      vm.saveProcess = true;
      var response = Promotion.query({ action: 'getRefCostCentre', company: vm.company, type: 'noncnb' });
      response.$promise.then(fetchRefCostCentreNon);
      response.$promise.catch(errorRefCostCentreNon);
    }

    function fetchRefCostCentreNon(data) {
      vm.listRefCostCentreNonCnb = data;
      vm.saveProcess = false;
    }

    function errorRefCostCentreNon(data) {
      vm.listRefCostCentreNonCnb = [];
      vm.saveProcess = false;
    }

    function getMpnNumber(actionType, id, mpnNumber) {
      vm.saveProcess = true;
      var response = Promotion.query({
        action: 'getMpnNumber',
        action_type: actionType,
        id: id,
        mpn_number: mpnNumber,
        company: vm.company
      });
      if (actionType == 'detail') {
        response.$promise.then(fetchMpnNumberDetail);
        response.$promise.catch(errorMpnNumberDetail);
      } else {
        response.$promise.then(fetchMpnNumber);
        response.$promise.catch(errorMpnNumber);
      }
    }

    function fetchMpnNumber(data) {
      vm.listMpnNumber = data;
      vm.saveProcess = false;
    }

    function errorMpnNumber(data) {
      vm.listMpnNumber = [];
      vm.saveProcess = false;
    }

    function fetchMpnNumberDetail(data) {
      vm.listMpnNumberDetail = data;
      vm.saveProcess = false;

      var obj = vm.listMpnNumberDetail[0];
      vm.Form.objForm.businessTitle = obj.businessTitle;
      vm.isDisabled = true;
      vm.Form.objForm.mpn_replacement_id = obj.id + '-' + obj.mpn_number
      vm.company = obj.company_id
      vm.divisi = obj.division_id;
      vm.Form.objForm.jobGrade = obj.emp_grade
      vm.Form.objForm.empGrade = obj.emp_grade
      vm.Form.objForm.subArea = obj.sub_area
      vm.Form.objForm.flag_mpn = obj.flag
      vm.department = obj.department_id;

      getLevelCategory(obj.emp_grade);
      loadDataDepartment(vm.divisi);
      getRefCostCentreCnb(vm.company);
      getRefCostCentreNonCnb(vm.company);

    }

    function errorMpnNumberDetail(data) {
      vm.listMpnNumberDetail = [];
      vm.saveProcess = false;
    }

    function loadDataDepartment(iddivisi) {
      vm.saveProcess = true;
      var response = Attendancereport.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
      vm.saveProcess = false;
    }

    function errorDepartment() {
      vm.listDepartment = [];
      vm.saveProcess = false;
    }

    function loadDataDivision(idbu) {
      vm.saveProcess = true;
      var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
      vm.listDivision = data;
      vm.saveProcess = false;
    }

    function errorDivisiBU() {
      vm.listDivision = [];
      vm.saveProcess = false;
    }

    function loadDataBU() {
      vm.saveProcess = true;
      var response = Attendancereport.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
      vm.saveProcess = false;
    }

    function errorFetchBU() {
      vm.listBU = [];
      vm.saveProcess = false;
    }

    function getJobTitle() {
      vm.saveProcess = true;
      var response = Employements.query({ action: 'getJobTitle', company: vm.company, divisi: vm.divisi, department: vm.department });
      response.$promise.then(fetchJobTitle);
      response.$promise.catch(errorJobTitle);
    }

    function fetchJobTitle(data) {
      vm.listJobTitle = data;
      vm.saveProcess = false;
    }

    function errorJobTitle() {
      vm.listJobTitle = [];
      vm.saveProcess = false;
    }

    function getLevelCategory(grade) {
      vm.saveProcess = true;
      vm.Form.objForm.empCategory = null;
      vm.Form.objForm.jobLevel = null;
      var response = Employements.query({ action: 'getLevelCategory', grade: grade });
      response.$promise.then(fetchLevel);
      response.$promise.catch(errorFtechLevel);

      getDefaultAllowance();

    }

    function fetchLevel(data) {
      vm.Form.objForm.empCategory = data[0].description;
      vm.Form.objForm.jobLevel = data[0].level;
      vm.saveProcess = false;
    }

    function errorFtechLevel() {
      vm.Form.objForm.empCategory = null;
      vm.saveProcess = false;
    }

    function getDefaultAllowance() {
      var response = Promotion.query({ action: 'getallowancegrade', grade: vm.Form.objForm.empGrade });
      response.$promise.then(fetchAllowList);
      response.$promise.catch(errorFtechAllowList);
    }

    function fetchAllowList(data) {
      vm.listAllowance = [];
      angular.forEach(data, function (value, key) {
        var obj = {};
        obj["Amount"] = value.amount;
        obj["ID_SalaryComponent"] = value.id_payrollcode;
        obj["desc_SalaryComponent"] = value.description;
        obj["ID_employee"] = vm.Form.objForm.nik;
        obj["effective_date"] = vm.Form.objForm.effectiveDate;
        vm.listAllowance.push(obj);
      });
    }

    function errorFtechAllowList(data) {
      vm.listAllowance = [];
    }


    function loadSubArea() {
      var response = Promotion.query({ action: 'viewSubArea', company: vm.company });
      response.$promise.then(fetchSubArea);
      response.$promise.catch(errorFetchSubArea);
    }

    function fetchSubArea(data) {
      vm.listSubArea = data;
    }

    function errorFetchSubArea() {
      vm.listSubArea = [];
    }

    function loadGedung(id_sub) {
      var response = Promotion.query({ action: 'viewGedung', id: id_sub });
      response.$promise.then(fetchGedung);
      response.$promise.catch(errorFetchGedung);
    }

    function fetchGedung(data) {
      vm.listGedung = data;
    }

    function errorFetchGedung() {
      vm.listGedung = [];
    }

    function loadJfm() {
      var response = Promotion.query({ action: 'viewJfm' });
      response.$promise.then(fetchJfm);
      response.$promise.catch(errorFetchJfm);
    }

    function fetchJfm(data) {
      vm.listJfm = data;
    }

    function errorFetchJfm() {
      vm.listJfm = [];
    }

    function loadJfmSub(id_jfm) {
      var response = Promotion.query({ action: 'viewJfmSub', id: id_jfm });
      response.$promise.then(fetchJfmSub);
      response.$promise.catch(errorFetchJfmSub);
    }

    function fetchJfmSub(data) {
      vm.listJfmSub = data;
    }

    function errorFetchJfmSub() {
      vm.listJfmSub = [];
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/promotion?action=viewListEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function querySearchDeferred(query) {
      var deferred = $q.defer();
      setTimeout(function () {
        var data = vm.empListData;
        if (query) {
          deferred.resolve(filterFilter(data, query));
        } else {
          deferred.reject([{ nik: 'none', name: 'none' }]);
        }
      }, 200);
      return deferred.promise;
    }

    function loadDataOldAllowance() {
      var response = Promotion.query({ action: 'viewOldAllowance', id: vm.Form.objForm.nik });
      response.$promise.then(fetchDataOldAllowance);
      response.$promise.catch(errorFetchDataOldAllowance);
    }

    function fetchDataOldAllowance(data) {
      vm.oldAllowance = data;
    }

    function errorFetchDataOldAllowance() {
      vm.oldAllowance = [];
    }

    function checkGrade(type, value) {
      if (type == 'gradeJob') {

        var arrJobGrade = [];

        angular.forEach(vm.gradeJob, function (val) {

          if (val > value) {
            arrJobGrade.push(val);
          }

        });

        if (arrJobGrade.length > 0) {
          vm.gradeJob = arrJobGrade
        }

      } else if (type == 'gradeEmp') {

        var arrEmpGrade = [];

        angular.forEach(vm.gradeEmp, function (v) {
          if (v > value) {
            arrEmpGrade.push(v);
          }

        });

        if (arrEmpGrade.length > 0) {
          vm.gradeEmp = arrEmpGrade;
        }
      }
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var message = translate(data.pesan);
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.employee.profiles', ['app.employee.profiles.input-profiles'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.employee_profiles', {
                url    : '/employee/profiles',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/profiles/profiles.html',
                        controller : 'ProfilesController as vm'
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employee.profiles')
        .controller('ProfilesController', ProfilesController);


    ProfilesController.$inject = ['$state', '$mdDialog', 'DTColumnDefBuilder', 'AppAPI', 'Auth', 'DataService'];
    /** @ngInject */
    function ProfilesController($state, $mdDialog, DTColumnDefBuilder, AppAPI, Auth, DataService) {

        var vm = this;
        vm.listProfiles = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listProfilesSelected = [];
        vm.editData = editData;
        vm.deleteProfiles = deleteProfiles;
        // vm.checkone=checkone;

        // Data
        /*  vm.employees = Employees.data;*/
        /*       var Profiles=AppAPI.Profiles();
                viewDataProfiles();
                vm.dtOptions = {
                   dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
                    autoWidth : false,
                    responsive: true,
                    pagingType: 'full_numbers'
                };
        
                 vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(1).notSortable()
            ];
        */
        var Profiles = AppAPI.Profiles();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;

        loadData(1);

        function loadData(pageno) {
            vm.DataTable.loadData(Profiles, pageno, { action: 'viewdata' });
        }

        // Data

        // Methods

        //////////
        /*
                function viewDataProfiles() {
                  angular.element.blockUI();
                   var profilesPromise=Profiles.query({action:'viewdata'});
                profilesPromise.$promise.then(fetchDataProfiles);
                profilesPromise.$promise.catch(errorFetchProfiles); 
                }
        
                function fetchDataProfiles(data) {
                    vm.listProfiles=data;
                    angular.element.unblockUI();
                }
        
                function errorFetchProfiles() {
                    vm.listProfiles=[];
                    angular.element.unblockUI();
                }
        */


        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listProfilesSelected = angular.copy(vm.listProfiles);
        }

        function unCheckAll() {
            vm.listProfilesSelected = [];
        }

        function editData(id) {
            $state.go('app.employee_profiles_edit', { id: encodeURIComponent(window.btoa(id)) });
        }

        function checkone(div) {
            div.isChecked = !div.isChecked;
        }

        function deleteProfiles(ev) {

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Profiles.delete({ action: 'delete', data: angular.toJson(vm.listProfilesSelected) });

                    response.$promise.then(loadData(1));
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.hr_completion')
        .controller('HrCompletionController', HrCompletionController);


    HrCompletionController.$inject = ['$state', '$mdDialog', 'DTColumnDefBuilder', 'AppAPI', 'Auth', 'DataService', '$filter'];
    /** @ngInject */
    function HrCompletionController($state, $mdDialog, DTColumnDefBuilder, AppAPI, Auth, DataService, $filter) {

        var vm = this;

        var translate = $filter('translate')
        vm.hrCompletion = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.hrCompletionSelected = [];
        vm.editData = editData;
        vm.deleteHrCompletion = deleteHrCompletion;
        vm.viewCompletionForm = viewCompletionForm;
        vm.submitToProfile = submitToProfile;
        vm.checkone = checkone;
        vm.loadData = loadData;

        // Data
        /*  vm.employees = Employees.data;*/
        /*       var HrCompletion=AppAPI.HrCompletion();
                viewDataHrCompletion();
                vm.dtOptions = {
                   dom       : '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
                    autoWidth : false,
                    responsive: true,
                    pagingType: 'full_numbers'
                };

                 vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(1).notSortable()
            ];
        */
        var HrCompletion = AppAPI.HrCompletion();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.UploadHrCompletion = UploadHrCompletion;
        vm.showDialogInfo = showDialogInfo;

        loadData(1);

        function loadData(pageno) {
            vm.DataTable.loadData(HrCompletion, pageno, { action: 'viewdata' });
            vm.hrCompletionSelected = [];
        }

        // Data

        // Methods

        //////////
        /*
                function viewDataHrCompletion() {
                  angular.element.blockUI();
                   var profilesPromise=HrCompletion.query({action:'viewdata'});
                profilesPromise.$promise.then(fetchDataHrCompletion);
                profilesPromise.$promise.catch(errorFetchHrCompletion);
                }

                function fetchDataHrCompletion(data) {
                    vm.hrCompletion=data;
                    angular.element.unblockUI();
                }

                function errorFetchHrCompletion() {
                    vm.hrCompletion=[];
                    angular.element.unblockUI();
                }
        */


        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.hrCompletionSelected = angular.copy(vm.DataTable.list);
            vm.DataTable.list.find(function (val) {
                val.checked = true;
            });
        }

        function unCheckAll() {
            vm.hrCompletionSelected = [];
            vm.DataTable.list.find(function (val) {
                val.checked = false;
            });
        }

        function editData(id) {
            $state.go('app.employee_profiles_edit', { id: id });
        }

        function checkone(idx, item) {
            if (item.checked === true) {
                vm.hrCompletionSelected.push(item);
            } else {
                vm.hrCompletionSelected.splice(idx, 1);
            }
        }

        function viewCompletionForm(ev, item) {
            $mdDialog.show({
                controller: 'HrCompletionFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/hr-completion/completion-form/completion-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals: {
                    _data: item,
                    loadData: loadData
                },
                clickOutsideToClose: true,
                fullscreen: true, // Only for -xs, -sm breakpoints.
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
            });
        }


        function submitToProfile(ev) {
            if (vm.hrCompletionSelected.length > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to submit into profile?')
                        .textContent('All data your selected will be process and can not recovered.')
                        .ariaLabel('Comfirmation')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');

                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();

                        // Form.initialForm();
                        // Form.setObject(ApiHrCompletion);
                        // var response = Form.saveData('saveToProfile', formController, ApiHrCompletion);
                        // response.then(function (data) {
                        //     loadData(1)
                        // });

                        // response.catch(function (data) {
                        //     angular.element.unblockUI();
                        //     formController.$setPristine();
                        //     dialogClose();
                        // });


                        var response = HrCompletion.save({ action: 'saveToProfile', data: vm.hrCompletionSelected });
                        response.$promise.then(function (resData) {

                            angular.element.unblockUI();
                            if ('moreInfo' in resData && resData.moreInfo.length > 0) {
                                $mdDialog.show({
                                    controller: 'logFailGwController',
                                    controllerAs: 'vm',
                                    templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                                    parent: angular.element(document.body),
                                    clickOutsideToClose: true,
                                    fullscreen: true,
                                    onRemoving: function (element, removePromise) {
                                        // loadData(1);
                                    },
                                    locals: {
                                        data: resData.moreInfo
                                    }
                                });
                            } else {
                                showDialogInfo(ev, resData)
                                loadData(1)
                            }

                        });
                        response.$promise.catch(function (resData) {
                            angular.element.unblockUI();
                            showDialogInfo(ev, resData.data)
                        });

                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(angular.element(document.querySelector('#contentDialog')))
                            .clickOutsideToClose(true)
                            .title('Attention !')
                            .textContent('No data selected !')
                            .ariaLabel('')
                            .ok('OK')
                            .targetEvent(ev)
                    )
                    .then(function () {
                        dialogClose();
                    });
            }


        }

        function deleteHrCompletion(ev) {

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = HrCompletion.delete({ action: 'delete', data: angular.toJson(vm.hrCompletionSelected) });

                    response.$promise.then(loadData(1));
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function UploadHrCompletion(ev) {
            $mdDialog.show({
                controller: 'UploadHrCompletionController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/employee/hr-completion/completion-upload/completion-upload.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals: {
                    dialogClose: dialogClose,
                    infoDialog: vm.showDialogInfo
                },
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.employement', ['app.employee.employement.input-employement'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.employee_employement', {
                url    : '/employee/employement',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/employement/employement.html',
                        controller : 'EmployementController as vm'
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employee.employement')
        .controller('EmployementController', EmployementController);


    EmployementController.$inject = ['$state', '$mdDialog', 'DTColumnDefBuilder', 'AppAPI', 'Auth', 'DataService', '$filter'];
    /** @ngInject */
    function EmployementController($state, $mdDialog, DTColumnDefBuilder, AppAPI, Auth, DataService, $filter) {

        var vm = this;
        var translate = $filter('translate');
        vm.listEmployement = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listEmployementSelected = [];
        vm.editData = editData;
        vm.deleteEmployement = deleteEmployement;
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        // Data
        /*  vm.employees = Employees.data;*/
        var Employement = AppAPI.Employement();
        viewDataEmployement();
        vm.dtOptions = {
            dom: '<"top"<"length"l>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>',
            autoWidth: false,
            responsive: true,
            pagingType: 'full_numbers'
        };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1).notSortable()
        ];

        // Data

        // Methods

        //////////

        function viewDataEmployement(pageno) {
            angular.element.blockUI();
            var resp = vm.DataTables.loadData(Employement, pageno, {
                action: 'viewdata'
            });

            resp.then(function (data) {
                angular.element.unblockUI();
                vm.selected = [];
                vm.listEmployement = data.list;
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listEmployementSelected = angular.copy(vm.listEmployement);
        }

        function unCheckAll() {
            vm.listEmployementSelected = [];
        }
        function editData(nik) {
            $state.go('app.employee_employement_edit', { nik: nik });
        }

        function deleteEmployement(ev) {

            var confirmdel = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(confirmdel)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Employement.delete({ action: 'delete', data: angular.toJson(vm.listEmployementSelected) });

                    response.$promise.then(viewDataEmployement);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.employe-update-approval', [
        ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
      // Translation
        // $translatePartialLoaderProvider.addPart('app/main/employee/employe');

        // State
        $stateProvider
            .state('app.employee_employee_update_approval', {
                url    : '/employee/employee-update-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/employee-update-approval/employee-update-approval.html',
                        controller : 'EmployeUpdateApprovalController as vm'
                    }
                }
            });
    }
})();
(function() {
    "use strict";

    angular
        .module("app.employee.employe-update-approval")
        .controller("viewDetailUpdateController", viewDetailUpdateController);

    viewDetailUpdateController.$inject = [
        "$localStorage",
        "reffData",
        "$mdDialog",
        "$http",
        "config"
    ];

    /* @ngInject */
    function viewDetailUpdateController(
        $localStorage,
        reffData,
        $mdDialog,
        $http,
        config
    ) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.oldData = reffData.old_data;
        vm.newData = reffData.new_data;
        vm.downLoadID = downLoadID;
        vm.showDocuments = showDocuments;
        vm.isDocumentNotExists = false;
        vm.attributeComplete = {
            ktp: false,
            marital: false,
            maritalCerai: false
        };

        activate();

        function activate() {
            console.log(reffData);
            if (typeof reffData.fileExist !== "undefined") {
                if (!reffData.fileExist.ktp) {
                    vm.attributeComplete.ktp = true;
                    vm.isDocumentNotExists = true;
                }
                if (
                    (vm.oldData.maritalStatus.toUpperCase() === "MENIKAH" &&
                        vm.newData.maritalStatus.toUpperCase() === "JANDA") ||
                    (vm.oldData.maritalStatus.toUpperCase() === "MENIKAH" &&
                        vm.newData.maritalStatus.toUpperCase() === "DUDA")
                ) {
                    if (
                        !reffData.fileExist.maritalCerai &&
                        reffData.changeAttributes.maritalStatus
                    ) {
                        vm.attributeComplete.maritalCerai = true;
                        vm.isDocumentNotExists = true;
                    }
                }
                if (
                    vm.oldData.maritalStatus.toUpperCase() === "LAJANG" &&
                    vm.newData.maritalStatus.toUpperCase() === "MENIKAH"
                ) {
                    if (
                        !reffData.fileExist.marital &&
                        reffData.changeAttributes.maritalStatus
                    ) {
                        vm.attributeComplete.marital = true;
                        vm.isDocumentNotExists = true;
                    }
                }
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function showDocuments(ev) {
            $mdDialog.show({
                multiple: true,
                controller: "ApprovalShowDocumentsController",
                controllerAs: "vm",
                templateUrl:
                    "app/main/employee/employee-update-approval/approval-show-documents.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    reffData: reffData
                }
            });
        }

        function downLoadID(ev) {
            var name = reffData.linkDocumentKtp;
            if (name !== null && name !== "-") {
                $http({
                    method: "GET",
                    url: config.api + "api/empdocument/" + name,
                    responseType: "arraybuffer"
                })
                    .success(function(data, status, headers) {
                        headers = headers();
                        // console.log(data);
                        var filename = name;
                        var contentType = headers["content-type"];

                        var linkElement = document.createElement("a");
                        try {
                            var blob = new Blob([data], {
                                type: contentType
                            });
                            var url = window.URL.createObjectURL(blob);

                            linkElement.setAttribute("href", url);
                            linkElement.setAttribute("download", filename);

                            var clickEvent = new MouseEvent("click", {
                                view: window,
                                bubbles: true,
                                cancelable: false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                    })
                    .error(function(data) {
                        $mdDialog
                            .show(
                                $mdDialog
                                    .alert()
                                    .parent(
                                        angular.element(
                                            document.querySelector(
                                                "#contentDialog"
                                            )
                                        )
                                    )
                                    .clickOutsideToClose(true)
                                    .title("Document Not Found")
                                    .textContent("Document not Found")
                                    .ariaLabel("Failed Save Data")
                                    .ok("OK")
                                    .targetEvent(ev)
                            )
                            .then(function() {
                                closeModal();
                            });
                    });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector("#contentDialog")
                                )
                            )
                            .clickOutsideToClose(true)
                            .title("Document Not Found")
                            .textContent("Document not Found")
                            .ariaLabel("Failed Save Data")
                            .ok("OK")
                            .targetEvent(ev)
                    )
                    .then(function() {
                        closeModal();
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe-update-approval')
        .controller('EmployeUpdateApprovalController', EmployeUpdateApprovalController);


    EmployeUpdateApprovalController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$window', '$location', '$http', 'config', '$filter'];
    /** @ngInject */
    function EmployeUpdateApprovalController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $window, $location, $http, config, $filter) {

        var translate = $filter('translate');

        var vm = this;
        vm.loadData = loadData
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Employeupdateapproval = AppAPI.Employeupdateapproval();
        var Attendancereport = AppAPI.Attendancereport();
        var nik = $localStorage.user;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected = [];
        vm.Approve = Approve;
        vm.setViewTeam = setViewTeam;
        vm.download = download;
        vm.company = $localStorage.empsite;
        vm.deleteData = deleteData;
        vm.Reject = Reject;
        vm.viewComment = viewComment;
        vm.group = $localStorage.group;
        vm.employeeType = 'SAP';

        vm.icon = "icon-plus";
        vm.result = false;
        vm.toogleSubChild = toogleSubChild;
        vm.visibleSubChild = [];
        vm.listType = ['All', 'Profiles', 'Dependents', 'Education', 'Tax'];

        vm.tglmulai = null;
        vm.tglakhir = null;

        vm.type = 'All';

        vm.typeEmp = [{
            "view": "All",
            "value": "all"
        },
        {
            "view": "Staff",
            "value": "SAP"
        },
        {
            "view": "General Worker",
            "value": "HRIS"
        }];

        vm.employeeType = 'all';
        if (vm.group == 131) {
            vm.employeeType = 'HRIS';
        }

        angular.element.blockUI();
        loadDataBU();

        //////////

        function loadData() {
            angular.element.blockUI();

            var response = Employeupdateapproval.query({
                action: 'viewdata',
                type: vm.type,
                company: vm.company,
                start_date: vm.tglmulai ? changeDateFormat(vm.tglmulai) : "",
                end_date: vm.tglakhir ? changeDateFormat(vm.tglakhir) : "",
                emp_type: vm.employeeType,
                search: vm.searchParam
            });
            response.$promise.then(fetchdwsdetail1);
            response.$promise.catch(errorFetchdwsdetail1);
        }

        function fetchdwsdetail1(data) {
            vm.listData = data;
            vm.listOtselected = [];
            angular.element.unblockUI();
        }

        function errorFetchdwsdetail1() {
            vm.listData = [];
            vm.listOtselected = [];
            angular.element.unblockUI();
        }

        function isChecked(ls) {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if (idx > -1) {
                vm.listOtselected.splice(idx, 1);
            } else {
                vm.listOtselected.push(ls);
            }
        }

        function setViewTeam(ev, id) {
            // console.log(id);
            vm.transType = id.transactionType;
            var template = "";
            switch (vm.transType) {
                case 'profiles':
                    template = 'app/main/employee/employee-update-approval/view-detail-update.html';
                    break;
                case 'dependents':
                    template = 'app/main/employee/employee-update-approval/view-dependents-update.html';
                    break;
                case 'education':
                    template = 'app/main/employee/employee-update-approval/view-education-update.html';
                    break;
                case 'tax':
                    template = 'app/main/employee/employee-update-approval/view-tax-update.html';
                    break;
            }

            var multiple = vm.transType == 'profiles';

            $mdDialog.show({
                multiple: multiple,
                controller: 'viewDetailUpdateController',
                controllerAs: 'vm',
                templateUrl: template,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    reffData: id
                }
            });
        }

        function toogleSubChild(idx) {
            switch (vm.visibleSubChild[idx]) {
                case true:
                    vm.visibleSubChild[idx] = false;
                    vm.icon = 'icon-minus';
                    break;
                case false:
                    vm.visibleSubChild[idx] = true;
                    vm.icon = 'icon-plus';
                    break;
                default:
                    vm.visibleSubChild[idx] = true;
                    vm.icon = 'icon-minus';
                    break;
            }

        }

        function Approve(ev) {
            var jum = vm.listOtselected.length,
                i, ids = [];
            // console.log(vm.listOtselected);
            if (jum > 0) {
                var conf = translate('KPI.MESSAGE.CONFAPP');
                var note = translate('KPI.MESSAGE.APPNOTE');
                var yes = translate('PAYROLL.MESSAGE.YES');
                var no = translate('PAYROLL.MESSAGE.NO');

                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title(conf)
                        .textContent(note)
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok(yes)
                        .cancel(no);
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        // angular.element.blockUI();
                        // console.log(vm.listOtselected);
                        var ot = new Employeupdateapproval();
                        ot.data = [];
                        ot.action = 'approve';
                        ot.transType = vm.transType;
                        for (i = 0; i < jum; i++) {
                            ot.data.push({
                                id: vm.listOtselected[i]
                            });
                        }
                        var idtx = encodeURIComponent(angular.toJson(ids));
                        var response = ot.$save();
                        //var response=tm.$delete({action:'approve'});
                        response.then(function (data) {
                            showDialogInfo(ev, data);
                            // angular.element.unblockUI();
                        });
                        response.catch(function (data) {
                            showDialogInfo(ev, data);
                            // angular.element.unblockUI();
                        });
                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                        // angular.element.unblockUI();
                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention!')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Approve Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Approve Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                // closeModal();
                loadData();
                // angular.element.unblockUI();
            });
        }

        function ShowFailed(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Approve Data')
                    .textContent('Please Recheck Your Data.')
                    .ariaLabel('Failed Approve Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                // closeModal();
                loadData();
                angular.element.unblockUI();
            });
        }


        function download() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                var tipe = vm.tipe;
                var ds = new Date(vm.tglmulai);
                var de = new Date(vm.tglakhir);
                var tglAwal = ds.getFullYear() + '-' + (ds.getMonth() + 1) + '-' + ds.getDate();
                var tglAkhir = de.getFullYear() + '-' + (de.getMonth() + 1) + '-' + de.getDate();


                $window.open(protocol + '://' + host + config.port + config.api + 'api/employeupdateapproval/downloadapproved/' + tglAwal + '/' + tglAkhir + '/' + vm.company + '/' + vm.employeeType + '/' + vm.type, '_blank');
            }, function () {
                $window.alert('gagal load token');
            });
        }

        function deleteData(ev) {
            var jum = vm.listOtselected.length,
                i, ids = [];
            // console.log(vm.listOtselected);
            // console.log(jum);
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to delete this list?')
                        .textContent('All data your selected will be deleted and can not recovered.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');

                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var response = Employeupdateapproval.delete({
                            action: 'delete',
                            data: angular.toJson(vm.listOtselected)
                        });

                        response.$promise.then(function () {
                            loadData();
                            angular.element.unblockUI();
                        });
                        response.$promise.catch(function () {
                            loadData();
                            angular.element.unblockUI();
                        });
                    }, function () {

                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention!')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function loadDataBU() {
            var response = Attendancereport.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;

            loadData(1);

        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function Reject(ev) {
            var jum = vm.listOtselected.length,
                i, ids = [];
            if (jum > 0) {
                $mdDialog.show({
                    controller: 'UpdateApprovalViewRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/employee/employee-update-approval/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        loadData();
                        vm.listOtselected = [];
                    },
                    locals: {
                        id: vm.listOtselected,
                        statusView: false
                    }
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention!')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    //
                });
            }
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'UpdateApprovalViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employee-update-approval/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listOtselected = [];
                },
                locals: {
                    id: id,
                    statusView: true
                }
            });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function changeDateFormat(date) {
            var date = new Date(date);
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var year = date.getFullYear();
            return year + "-" + month + "-" + day;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe-update-approval')
        .controller('UpdateApprovalViewRejectCommentController', UpdateApprovalViewRejectCommentController);

    UpdateApprovalViewRejectCommentController.$inject = ['$localStorage', 'id', 'statusView', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function UpdateApprovalViewRejectCommentController($localStorage, id, statusView, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');
        // initial form
        Form.initialForm();

        var Employeupdateapproval = AppAPI.Employeupdateapproval();

        // set constructor form
        Form.setObject(Employeupdateapproval);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = !statusView ? false : true;

        function saveData(ev, formController) {
            var promise = Form.saveData('reject', formController, Employeupdateapproval);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employee.employe-update-approval')
        .controller('ApprovalShowDocumentsController', ApprovalShowDocumentsController);

    ApprovalShowDocumentsController.$inject = [
        '$localStorage',
        'reffData',
        '$mdDialog',
        '$http',
        'config',
        '$sce'
    ];

    /* @ngInject */
    function ApprovalShowDocumentsController(
        $localStorage,
        reffData,
        $mdDialog,
        $http,
        config,
        $sce
    ) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.oldData = reffData.old_data;
        vm.newData = reffData.new_data;

        activate();

        vm.iframeStyle = "height:500px; width:100%";

        function activate() {
            getDocuments(reffData.linkDocumentKtp, 'ktp');
            getDocuments(reffData.linkDocumentMarital, 'marital');
        }

        function getDocuments(filename, type) {
            if (filename) {
                var defaultType = 'application';
                var poolMime = ['jpeg', 'jpg', 'png', 'gif'];
                var splitter = filename.split('.');
                var mime = splitter[1];
                
                if (poolMime.indexOf(mime) !== -1) {
                    defaultType = 'image';
                }

                var apiCall = $http.get(config.api + 'api/empdocument/' + filename, {
                    responseType: "arraybuffer"
                });

                apiCall
                    .success(function (response) {
                        var blobType = defaultType + '/' + mime;
                        var blobFile = new Blob([response], {
                            type: blobType
                        });
                        console.log(blobType);
                        var fileURL = URL.createObjectURL(blobFile);
                        if (type == 'ktp') {
                            vm.fileUrlKtp = $sce.trustAsResourceUrl(fileURL);
                            vm.templateKtp = $sce.trustAsHtml(
                                "<iframe src='" + vm.fileUrlKtp + "' style='" + vm.iframeStyle + "'></iframe>"
                            );
                        } else {
                            vm.fileUrlMarital = $sce.trustAsResourceUrl(fileURL);
                            vm.templateMarital = $sce.trustAsHtml(
                                "<iframe src='" + vm.fileUrlMarital + "' style='" + vm.iframeStyle + "'></iframe>"
                            );
                        }
                    }).error(function (error) {
                        vm.fileUrlKtp = '/assets/images/avatars/profile.jpg';
                        vm.fileUrlMarital = '/assets/images/avatars/profile.jpg';
                    })
            } else {
                vm.fileUrlKtp = '/assets/images/avatars/profile.jpg';
                vm.fileUrlMarital = '/assets/images/avatars/profile.jpg';
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.employe-uniform', [])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.employee_employe-uniform', {
                url    : '/employee/employe-uniform',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/employee-uniform/employe-uniform.html',
                        controller : 'EmployeUniformController as vm',
                        css: ['app/main/employee/employee-uniform/employe-uniform.scss']
                    }
                }
            });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.employee.employe-uniform')
    .controller('EmployeUniformController', EmployeUniformController);

  EmployeUniformController.$inject = [
    '$state',
    '$window',
    '$localStorage',
    '$location',
    '$document',
    '$mdDialog',
    'AppAPI',
    'DataService',
    'config',
    'Auth',
    'Form',
    '$filter',
    '$element'
  ];
  /** @ngInject */
  function EmployeUniformController(
    $state,
    $window,
    $localStorage,
    $location,
    $document,
    $mdDialog,
    AppAPI,
    DataService,
    config,
    Auth,
    Form,
    $filter,
    $element
  ) {

    var vm = this;
    var translate = $filter('translate');
    var EMP = AppAPI.Employe();
    var Attendancereport = AppAPI.Attendancereport();
    var Subarea = AppAPI.Subarea();

    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();

    vm.detailEmployee = detailEmployee;
    vm.loadData = loadData;
    vm.cekStatus = cekStatus;

    vm.exportToExcel = exportToExcel;

    vm.company = $localStorage.empsite;

    vm.isCheckAction = false;
    vm.isCheckActionAdd = false;
    vm.isCheckActionDelete = false;

    vm.searchTerm = '';

    vm.typeEmp = [
      {
        view: 'Parttime',
        value: 'parttime'
      },
      {
        view: 'Staff',
        value: 'SAP'
      },
      {
        view: 'General Worker',
        value: 'HRIS'
      }
    ];

    vm.employeeType = vm.typeEmp[0].value;

    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.applyData = applyData;
    vm.selectedItems = [];
    vm.cancel = cancel;
    vm.parseIntAdd = parseIntAdd;

    loadData(1);
    loadDataBU();
    loadSubArea();

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function loadData(pageno) {
      cancel();
      vm.DataTable.loadData(EMP, pageno, {
        action: 'viewdatauniform',
        company: vm.company,
        subarea: vm.subarea,
        emptype: vm.employeeType
      });
    }

    function exportToExcel(ev) {
      $mdDialog.show({
        controller: 'DownloadEmployeController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/employe/employe-download.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
        }
      });
    }

    function detailEmployee(id, nik) {
      $localStorage.currentNik = encodeURIComponent(window.btoa(nik));
      $state.go('app.employee_employe_edit.profile', {
        id: encodeURIComponent(window.btoa(id)),
        nik: encodeURIComponent(window.btoa(nik))
      });
    }

    function loadDataBU() {
      var response = Attendancereport.query({
        action: 'viewBu'
      });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    function loadSubArea() {
      var response = Attendancereport.query({
        action: 'viewSubArea'
      });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorfetchArea);
    }

    function fetchArea(data) {
      vm.subArea = data;
    }

    function errorfetchArea(data) {
      vm.subArea = [];
    }

    function cekStatus(status) {
      return ((status.trim()).toLowerCase()).substr(0, 8) == 'parttime';
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return (
        vm.selectedItems.length !== 0 &&
        vm.selectedItems.length !== vm.DataTable.list.length
      );
    }

    function isChecked() {
      return vm.selectedItems.length === vm.DataTable.list.length;
    }

    function toggleAll() {
      if (vm.selectedItems.length === vm.DataTable.list.length) {
        vm.selectedItems = [];
      } else if (vm.selectedItems.length === 0 || vm.selectedItems.length > 0) {
        for (var i = 0; i < vm.DataTable.list.length; i++) {
          if (parseInt(vm.DataTable.list[i].remaining_days) <= 0) {
            vm.selectedItems.push(vm.DataTable.list[i]);
          }
        }
      }
    }

    function applyData(ev, data) {
      if (vm.isCheckActionAdd) {
        $mdDialog.show({
          controller: 'UpdateEEUController',
          controllerAs: 'vm',
          templateUrl: 'app/main/employee/employee-uniform/edit-employe-uniform.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          locals: {
            data: data
          },
        })
          .then(function (answer) {
            if (answer) {
              loadData(1);
            }
          }, function () {

          });
      } else {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog
            .confirm()
            .title('Would you like to reset this sent status?')
            .textContent(
              'All data your selected will be reset as not sent yet.'
            )
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

          $mdDialog.show(confirm).then(
            function () {
              angular.element.blockUI();
              var response = EMP.delete({
                action: 'deleteuniform',
                data: angular.toJson(vm.selectedItems)
              });

              response.$promise.then(function (resp) {
                angular.element.unblockUI();
                showDialogInfo(ev, resp);
              });
            },
            function () { }
          );
        });
      }
    }

    function cancel() {
      vm.isCheckAction = false;
      vm.selectedItems = [];
      vm.isCheckActionAdd = false;
      vm.isCheckActionDelete = false;
    }

    function parseIntAdd(number) {
      return parseInt(number);
    }

    function showDialogInfo(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe-uniform')
        .controller('UpdateEEUController', UpdateEEUController);

    UpdateEEUController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', 'config', 'data', '$filter'];

    /* @ngInject */
    function UpdateEEUController($localStorage, $mdDialog, Form, AppAPI, config, data, $filter) {
        var vm = this;

        var translate = $filter('translate');

        Form.initialForm();

        var EMP = AppAPI.Employe();

        // set constructor form
        Form.setObject(EMP);

        // set form to controller
        vm.Form = Form;
        vm.Form.objForm.effectivedate = new Date();
        vm.data = data;
        vm.saveData = saveData;
        vm.messageTheme = '';


        vm.hide = function () {
            $mdDialog.hide();
        }

        vm.cancel = function () {
            $mdDialog.cancel();
        }

        vm.answer = function (answer) {
            $mdDialog.hide(answer);
        }

        function showDialog() {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent()
            );
        }

        function changeDateFormat(date) {
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var year = date.getFullYear();
            return year + "-" + month + "-" + day;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.ids = angular.toJson(vm.data);
            vm.Form.objForm.effectivedate_parsed = changeDateFormat(vm.Form.objForm.effectivedate);

            var promise = Form.saveData('saveuniform', formController, EMP);
            promise.then(function (data) {
                vm.messageTheme = 'green';
                vm.answer(true);
                showDialogInfo(ev, data);
            });
            promise.catch(function (data) {
                vm.messageTheme = 'red';
                showDialogInfo(ev, data.data);
            })
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.employee.employee-reports', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.employee_employee-reports', {
                url    : '/employee/employee-reports',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/employee-reports/employee-reports.html',
                        controller : 'EmployeereportsController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.employee.employee-reports')
        .controller('EmployeereportsController', EmployeereportsController);

    EmployeereportsController.$inject = [
        '$state',
        '$window',
        '$location',
        '$localStorage',
        '$document',
        '$element',
        '$http',
        '$scope',
        'config',
        '$log',
        '$mdDialog',
        'AppAPI',
        'Auth',
        'DataService'
    ];

    /* @ngInject */
    function EmployeereportsController(
        $state,
        $window,
        $location,
        $localStorage,
        $document,
        $element,
        $http,
        $scope,
        config,
        $log,
        $mdDialog,
        AppAPI,
        Auth,
        DataService
    ) {
        var vm = this; 
        var Employee=AppAPI.Employe();

        vm.empFinishContract = empFinishContract; 
        vm.Download = Download;

        loadReportList();
        
        function loadReportList() 
        {
            var response=Employee.query({action:'getReportList'});
           response.$promise.then(fetchReportList);
           response.$promise.catch(errorFetchReportList);
        }
 
        function fetchReportList(data) 
        {
            vm.listReport = data;
        }
 
        function errorFetchReportList() 
        {
           vm.listReport=[];
        }

        ///////////////////////////////
        function Download(ev, data) {
            switch (data) {
                case 'empFinishContract':
                    empFinishContract(ev,data);
                    break; 
            }
        }

        function empFinishContract(ev,data) {
            // console.log(data);
            $mdDialog.show({
                controller: 'EmpFinishContractController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employee-reports/emp-finish-contract.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true, 
                onRemoving: function(element, removePromise) 
                {
                   
                },locals :{
                    data :data
                }
            });
        } 
         
    }
})();

(function() {
    'use strict';

    angular
        .module('app.employee.employee-reports')
        .controller('EmpFinishContractController', EmpFinishContractController);

    EmpFinishContractController.$inject = ['$localStorage','$mdDialog','$window','$location','Form','AppAPI','$log','FileUploader','config','Auth','data'];

    /* @ngInject */
    function EmpFinishContractController($localStorage,$mdDialog,$window,$location,Form,AppAPI,$log,FileUploader,config,Auth,data) {
      var vm = this;
      Form.initialForm(); 
      var Attendancereport = AppAPI.Attendancereport(); 
      

      vm.loadDataDivision = loadDataDivision;
      vm.loadDataDepartment = loadDataDepartment;

      vm.company = $localStorage.empsite;
      vm.groupLogin = $localStorage.group;
      vm.download = download;
      vm.closeModal = closeModal;
      vm.flagApp = ['SAP','HRIS'];
      vm.flag_app = 'SAP';
      vm.selectedSubarea = '';
      vm.loadSubArea=loadSubArea;
      vm.data=data;

      vm.start_date = vm.end_date = null;

      var date = new Date();
      vm.tahun = date.getFullYear();
      vm.bulan = date.getMonth() + 1;
      vm.tgl = date.getDate();
        
      vm.selectedBuilding = vm.selectedSector = 'all'; 

      vm.divisi='all';
      vm.department='all';
      vm.typeEmp = [
        {
          "view"  : "All",
          "value" : "all"
        },
        {
          "view"  : "Staff",
          "value" : "SAP"
        },
        {
          "view"  : "General Worker",
          "value" : "HRIS"
        }
      ];

     

      loadDataBU(); 
      //////////////////////////
      function changeDateFormat(date){
        var monthTmp = "" + (date.getMonth()+1);
        var monthPad = "00";
        var month = monthPad.substring(0, monthPad.length - monthTmp.length) + monthTmp;

        var dayTmp = "" + date.getDate();
        var dayPad = "00";
        var day = dayPad.substring(0, dayPad.length - dayTmp.length) + dayTmp;

        var year = date.getFullYear();
        return year+"-"+month+"-"+day;
      }

      function closeModal() 
      {
        $mdDialog.hide();
      }

      function getPeriode() 
      {
        var res=Attendancereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.start_date=new Date(data[0]['periode_start']);
        vm.end_date=new Date(data[0]['periode_end']);
        // console.log(vm.periode);
        // loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }

      function loadDataDepartment(iddivisi) {
        var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listDepartment=data;
        // loadData(1);
      }

      function errorDepartment() {
        vm.listDepartment=[];
      }

      function loadDataDivision(idbu) {
        var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
      }

      function fetchDivisiBU(data) {
        vm.listDivision=data;
        loadDataDepartment(vm.divisi);
        // vm.listDivision.push(data);
        // loadData(1);
      }

      function errorDivisiBU() {
        vm.listDivision=[];
        errorDepartment();
      }

      function loadDataBU() {
        var response=Attendancereport.query({action:'viewBu'});
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
        vm.listBU=data;
        loadSubArea();
        loadDataDivision(vm.company);
      }

      function errorFetchBU() {
        vm.listBU=[];
        errorfetchArea();
        errorDivisiBU();
      }

      function download()
      {
        var company=vm.company;
        var divisi=vm.divisi;
        var department=vm.department;
        var start_date= changeDateFormat(vm.start_date);
        var end_date= changeDateFormat(vm.end_date);
        var token=Auth.setTokenPromise();
        var subarea=vm.selectedSubarea;  
        var empType=vm.flag_app;

        token.then(function(data){
          var protocol=$location.protocol();
          var host=$location.host();
          $window.open(protocol+'://'+host+config.api+'api/employe/'+vm.data+'/'+company+'/'+divisi+'/'+department+'/'+start_date+'/'+end_date+'/'+subarea+'/'+empType,'_blank');
        },function(){
          $window.alert('gagal load token');
        });
      }

      function loadSubArea()
      {
        var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
        response.$promise.then(fetchArea);
        response.$promise.catch(errorfetchArea);
      }

      function fetchArea(data)
      {
        vm.subArea=data; 
      }

      function errorfetchArea(data)
      {
        vm.subArea=[];
        if(isAdminPlant) {
          errorGedung();
        }
      } 

      function closeModal()
      {
        $mdDialog.hide();
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.employee-cost-center', [])
        .config(config);

      config.$inject=['$stateProvider'];
      /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.employee_employee_costcenter', {
                url    : '/employee/employee-cost-center',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/employee-cost-center/employee-cost-center.html',
                        controller : 'EmployeeCostCenterController as vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.employee.employee-cost-center')
        .controller('UploadEmployeecostcenterController', UploadEmployeecostcenterController);

    UploadEmployeecostcenterController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadEmployeecostcenterController($mdDialog,$localStorage,FileUploader,config) {
        var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;
        vm.message = '';       

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
            url:config.api+'api/employeecostcenter/UploadEmployeecostcenter', 
            removeAfterUpload:true,
            alias:'FileEmployeecostcenter',
            formData:[
                {
                    action:'UploadEmployeecostcenter'
                }
            ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
            },
            headers:{
                tokenAuth:$localStorage.tokenAuth
            }
        }); 
            
        uploaderPhoto.onSuccessItem = function(item, response) {
            if (response.status == 0) {
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=true;
            } else {
                vm.UploadPhotoStateSucces=true;
                vm.UploadPhotoStateError=false;
            }

            vm.message = response.pesan
            
            // setTimeout(function() {
                angular.element('#uploaderPhoto').val('');
                // closeModal();
            // }, 1000); 
        };

        uploaderPhoto.onErrorItem=function()
        {
            vm.UploadPhotoStateSucces=false;
            vm.UploadPhotoStateError=true;
            vm.message = 'Upload file has been failed'
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }
    }
})();
(function() {
  'use strict';

  angular
    .module('app.employee.employee-cost-center')
    .controller('EmployeeCostCenterController', EmployeeCostCenterController);

  EmployeeCostCenterController.$inject = [
    '$state',
    '$log',
    '$mdDialog',
    'AppAPI',
    'Auth',
    'DataService',
    '$localStorage',
    '$document'
  ];
  //AppAPI untuk koneksi ambil data ke api
  //Auth untuk mendapatkan authentikasi mendapatkan token, setiap hubungan ke API wajib token
  //DataService untuk pagination dan datatable

  /** @ngInject */
  function EmployeeCostCenterController(
    $state,
    $log,
    $mdDialog,
    AppAPI,
    Auth,
    DataService,
    $localStorage,
    $document
  ) {
    var vm = this;
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService(); //inisialisasi class DataService
    var Employeecostcenter = AppAPI.Employeecostcenter(); //memanggil api modules dari api
    var Employeshiftt = AppAPI.Overtime();
    vm.uploadOvertimeConfig = uploadOvertimeConfig;
    vm.loadDataDepartment = loadDataDepartment;
    vm.loadDataDivision = loadDataDivision;
    vm.company = $localStorage.empsite;
    vm.closeModal = closeModal;
    vm.loadData = loadData;
    vm.editData = editData;
    vm.toglefilter = false;
    vm.toggle = toggle;
    vm.downloadEmployeeCostCenter = downloadEmployeeCostCenter;

    vm.Breadhome = 'app.pms_dashboard';
    vm.Breadlist = [{ link: '#', name: 'Employee Cost Center', active: '0' }];
    vm.edit1 = false;

    loadData(1);
    loadDataBU();
    loadDataDivision(vm.company);

    function loadData(pageno) {
      vm.DataTable.loadData(Employeecostcenter, pageno, {
        action: 'viewData',
        company: vm.company,
        divisi: vm.divisi,
        departement: vm.department
      });
    }

    function loadDataDepartment(iddivisi) {
      var response = Employeecostcenter.query({
        action: 'viewDivisiDept',
        idbu: vm.company,
        iddivisi: iddivisi
      });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
      // loadData(1);
    }

    function errorDepartment() {
      vm.listDepartment = [];
    }

    function loadDataDivision(idbu) {
      var response = Employeecostcenter.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
      vm.listDivision = data;
      // loadData(1);
    }

    function errorDivisiBU() {
      vm.listDivision = [];
    }

    function loadDataBU() {
      var response = Employeecostcenter.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    function checkAll() {
      vm.listModulSelected = angular.copy(vm.list);
    }

    function unCheckAll() {
      vm.listModulSelected = [];
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function toggle() {
      if (vm.toglefilter) {
        vm.toglefilter = false;
      } else {
        vm.toglefilter = true;
      }
    }

    function uploadOvertimeConfig(ev) {
      $mdDialog.show({
        controller: 'UploadEmployeecostcenterController as vm',
        templateUrl: 'app/main/employee/employee-cost-center/upload-employee-cost-center.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        onRemoving: function(element, removePromise) {
          loadData(1);
        }
      });
    }

    function downloadEmployeeCostCenter(ev) {
      $mdDialog.show({
        controller: 'DownloadEmployeeCostCenterController as vm',
        templateUrl: 'app/main/employee/employee-cost-center/download-employee-cost-center.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        onRemoving: function(element, removePromise) {
          loadData(1);
        }
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'UpdateECCController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/employee-cost-center/edit-employee-cost-center.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        locals: {
          edt: data
        }
      });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.employee.employee-cost-center')
        .controller('UpdateECCController', UpdateECCController);

    UpdateECCController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','config','edt'];

    /* @ngInject */
    function UpdateECCController($localStorage,$mdDialog,Form,AppAPI,config,edt) {
        var vm = this;
            vm.saveData=saveData;

        Form.initialForm();

        var Employeecostcenter = AppAPI.Employeecostcenter();

        // set constructor form
        Form.setObject(Employeecostcenter);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.listType = [
            {id:1, type:'Hanya OT KHL'},
            {id:2, type:'Hanya OT Normal'},
            {id:3, type:'Semua Bisa'},
            {id:4, type:'Tidak Bisa OT'},
        ];
        
        var response=vm.Form.objForm.$get({action:'viewDetail',id:edt.id});
        response.then(setData);

        loadDescription();
        
        function setData(data)
        {
            vm.Form.objForm.id=edt.id;
            vm.name = edt.empName;
            if(!data.effectivedate) {
                vm.Form.objForm.effectivedate = new Date();
            }
            vm.Form.objForm.effectivedate = new Date(data.effectivedate);
            vm.Form.objForm.ottype = Number(data.ottype);
        }

        function loadDescription()
        {
            angular.element.blockUI();
            var response=Employeecostcenter.query({action:'viewDescriptionCostCenter'});
            response.$promise.then(fetchDescription);
            response.$promise.catch(errorDescription);
        }
    
        function fetchDescription(data) {
            angular.element.unblockUI();
            vm.listcnb=data[0].cnb;
            vm.listnoncnb=data[0].noncnb;
        }
    
        function errorDescription() {
            angular.element.unblockUI();
            vm.listcnb=[];
            vm.listnoncnb=[];
        }

        function closeModal()
        {
            $mdDialog.hide();
        }
         
        function saveData(ev,formController) {
            var promise= Form.updateData('updateData', formController, Employeecostcenter, edt.id, 'viewDetail');
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog() {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent()
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.employee.employee-cost-center')
    .controller('DownloadEmployeeCostCenterController', DownloadEmployeeCostCenterController);

  DownloadEmployeeCostCenterController.$inject = [
    '$state',
    '$log',
    '$mdDialog',
    'AppAPI',
    'Auth',
    '$localStorage',
    'Form',
    '$window',
    '$location',
    'config'
  ];
  //AppAPI untuk koneksi ambil data ke api
  //Auth untuk mendapatkan authentikasi mendapatkan token, setiap hubungan ke API wajib token
  //DataService untuk pagination dan datatable

  /** @ngInject */
  function DownloadEmployeeCostCenterController(
    $state,
    $log,
    $mdDialog,
    AppAPI,
    Auth,
    $localStorage,
    Form,
    $window,
    $location,
    config
  ) {
    var vm = this;
    var Employeecostcenter = AppAPI.Employeecostcenter();
    var Employeshiftt = AppAPI.Overtime();
    var ApiHoliday = AppAPI.NationalHoliday();
    vm.loadDataDepartment = loadDataDepartment;
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDivisiSub = loadDataDivisiAndSubArea;
    vm.loadSubArea = loadSubArea;
    vm.company = $localStorage.empsite;
    vm.closeModal = closeModal;
    vm.download = download;
    vm.empType = [
      {
        'view': 'General Working',
        'value': 'HRIS'
      },
      {
        'view': 'Staff',
        'value': 'SAP'
      },
    ];
    vm.Form = Form;

    Form.initialForm();

    Form.setObject(Employeecostcenter);

    loadDataBU();
    loadSubArea(vm.company);
    loadDataDivision(vm.company);

    function loadDataDepartment(iddivisi) {
      var response = Employeecostcenter.query({
        action: 'viewDivisiDept',
        idbu: vm.company,
        iddivisi: iddivisi
      });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function loadSubArea(company) {
      var response = Employeecostcenter.query({
        action: 'loadDataSubArea',
        idbu: company
      });
      response.$promise.then(function (data) {
        vm.subArea = data;
      });
      response.$promise.catch(function (data) {
        vm.subArea = [];
      });
    }

    function loadDataDivisiAndSubArea(idbu) {
      loadSubArea(idbu);
      loadDataDivision(idbu);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
      // loadData(1);
    }

    function errorDepartment() {
      vm.listDepartment = [];
    }

    function loadDataDivision(idbu) {
      var response = Employeecostcenter.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
      vm.listDivision = data;
      // loadData(1);
    }

    function errorDivisiBU() {
      vm.listDivision = [];
    }

    function loadDataBU() {
      var response = Employeecostcenter.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    function download(ev, formController) {
      // angular.element.blockUI();
      var company = formController.company.$viewValue;
      var empType = formController.emptype.$viewValue;
      var department = formController.department.$viewValue;
      var divisi = formController.divisi.$viewValue;
      var subarea = formController.subarea.$viewValue;

      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/employeecostcenter/exportData/' + company + '/' + divisi + '/' + department + '/' + subarea + '/' + empType + '/' + $localStorage.lang + '/' + data.token, '_blank');
      }, function () {
        $window.alert('gagal load token');
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
      .module('app.employee.emplabortype', [
        'app.employee.emplabortype.input-employee-labor-type',
        'app.employee.emplabortype.update-employee-labor-type',
        'app.employee.emplabortype.upload-employee-labor-type'
      ])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_employee_labor_type', {
              url: '/employee/emplabortype',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/employee-labor-type/employee-labor-type.html',
                      controller: 'EmpLaborTypeController as vm'
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.employee.emplabortype')
    .controller('EmpLaborTypeController', EmpLaborTypeController);

  EmpLaborTypeController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form'
  ];
  /** @ngInject */
  function EmpLaborTypeController(
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form
  ) {
    var vm = this;
    var Attendancereport = AppAPI.Attendancereport();
    var ApiHoliday = AppAPI.NationalHoliday();
    var ApiLaborType = AppAPI.EmpLaborType();
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.company = $localStorage.empsite ? $localStorage.empsite : 'KS';
    vm.selectedSubarea = '0';
    vm.divisi = 'all';
    vm.department = 'all';
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.loadDataDivisiAndSubArea = loadDataDivisiAndSubArea;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addEmpLabor = addEmpLabor;
    vm.showDialogInfo = showDialogInfo;
    vm.deleteEmpLabor = deleteEmpLabor;
    vm.editEmpLabor = editEmpLabor;
    vm.UploadEmpLabor = UploadEmpLabor;

    activate();

    function activate() {
      vm.selected = [];
      // loadData(1);
      loadDataDivision(vm.company);
      loadSubArea();
      loadDataBU();
    }

    function addEmpLabor(ev) {
      $mdDialog.show({
        controller: 'InputEmpLaborTypeController',
        controllerAs: 'vm',
        templateUrl:
          'app/main/employee/employee-labor-type/input-employee-labor-type/input-employee-labor-type.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          loadData: vm.loadData,
          infoDialog: vm.showDialogInfo
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteEmpLabor(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = ApiLaborType.delete({
              action: 'deleteDataEmpLaborType',
              data: angular.toJson(data)
            });
            response.$promise.then(function(data) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function editEmpLabor(ev, data) {
      $mdDialog.show({
        controller: 'UpdateEmpLaborTypeController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/employee-labor-type/update-employee-labor-type/update-employee-labor-type.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          dataUpdate: data,
          infoDialog : vm.showDialogInfo
        },
        clickOutsideToClose: true,
        fullscreen: true
      });
    }

    function loadData(pageno) {
      var subarea = vm.selectedSubarea == '0' ? 'all' : vm.selectedSubarea;
      var resp = vm.DataTables.loadData(ApiLaborType, pageno, {
        action: 'viewDataEmpLaborType',
        company: vm.company,
        subarea: subarea,
        divisi: vm.divisi,
        department: vm.department
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function UploadEmpLabor(ev) {
      $mdDialog.show({
        controller: 'UploadEmpLaborTypeController',
        controllerAs: 'vm',
        templateUrl:
          'app/main/employee/employee-labor-type/upload-employee-labor-type/upload-employee-labor-type.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          dialogClose: dialogClose,
          infoDialog: vm.showDialogInfo
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function loadDataDivisiAndSubArea(idbu) {
      loadSubArea();
      loadDataDivision(idbu);
    }

    function loadDataBU() {
      var response = Attendancereport.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    function loadSubArea() {
      var response = ApiHoliday.query({
        action: 'loadDataSubArea',
        idbu: vm.company
      });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorfetchArea);
    }

    function fetchArea(data) {
      vm.subArea = data;
    }

    function errorfetchArea(data) {
      vm.subArea = [];
    }

    function loadDataDepartment(iddivisi) {
      var response = Attendancereport.query({
        action: 'viewDivisiDept',
        idbu: vm.company,
        iddivisi: iddivisi
      });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
    }

    function errorDepartment() {
      vm.listDepartment = [];
    }

    function loadDataDivision(idbu) {
      var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
      vm.listDivision = data;
    }

    function errorDivisiBU() {
      vm.listDivision = [];
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe_admin')
        .controller('EmployeAdminController', EmployeAdminController);

    EmployeAdminController.$inject = [
        '$state',
        '$window',
        '$localStorage',
        '$location',
        '$document',
        '$mdDialog',
        'AppAPI',
        'DataService',
        'config',
        'Auth',
        'Form',
        '$element'
    ];
    /** @ngInject */
    function EmployeAdminController(
        $state,
        $window,
        $localStorage,
        $location,
        $document,
        $mdDialog,
        AppAPI,
        DataService,
        config,
        Auth,
        Form,
        $element
    ) {
        var vm = this;
        // initial form
        Form.initialForm();

        var EMP = AppAPI.Employeeadmin();
        var Attendancereport = AppAPI.Attendancereport();
        var Subarea = AppAPI.Subarea();

        Form.setObject(EMP);

        // set form to controller
        vm.Form = Form;

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.detailEmployee = detailEmployee;
        vm.loadData = loadData;

        vm.openInputEmployee = openInputEmployee;
        vm.closeModal = closeModal;
        vm.title = ['Mr', 'Mrs', 'Miss', 'Ms'];
        vm.jenkel = ['L', 'P'];
        vm.maritalStatuses = ['Lajang', 'Menikah', 'Duda', 'Janda'];
        vm.saveData = saveData;
        vm.deleteData = deleteData;

        vm.listData = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];
        vm.checkone = checkone;
        vm.uploadEmployee = uploadEmployee;
        vm.uploadContract = uploadContract;
        vm.downloadEmployee = downloadEmployee;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;
        vm.downloadEcheckIn = downloadEcheckIn;

        vm.exportToExcel = exportToExcel;

        vm.company = $localStorage.empsite;
        vm.groupLogin = $localStorage.group;
        vm.user = $localStorage.user;
        vm.eCheckin = false;
        vm.viewEcheckin = false;
        vm.divisi = 'all';
        vm.department = 'all';
        vm.divdeptdisabled = false;
        vm.upload = true;
        vm.download = true;
        vm.typedisabled = false;
        vm.budisabled = true;
        vm.dataSales = false; 
        vm.ClearFilter = ClearFilter;
        vm.country = $localStorage.country;
        vm.enableSpouseWork = enableSpouseWork;
        vm.isSpouseWork = isSpouseWork;
        vm.loadSubArea = loadSubArea;
        vm.loadGedung = loadGedung;
        vm.loadSector = loadSector;
        vm.loadShiftGroup  = loadShiftGroup;
        vm.empstatus='active';

        vm.gedung = null;
        vm.sector = null;
        vm.line = null;
        vm.area = null;

        vm.searchTerm = '';

        vm.empStatus = [{
                view: 'Active',
                value: 'active'
            },
            {
                view: 'Non Active',
                value: 'non active'
            }
        ];

        vm.uploadBuilding = uploadBuilding;
        vm.uploadEditAtasan = uploadEditAtasan;
        vm.uploadEditGroupShift = uploadEditGroupShift;
        vm.searchEmploye = searchEmploye;
        switch (vm.groupLogin) {
            case '1':
            case '104':
            case '130':
            case '10':
            case '132':
                vm.budisabled = false;
                break;
            case '11':
            case '127':
                vm.budisabled = true;
                vm.divdeptdisabled = true;
                vm.upload = false;
                vm.download = false;
                break;
            case '130':
                vm.budisabled = false;
                vm.divdeptdisabled = true;
                vm.upload = false;
                vm.eCheckin = true;
                vm.download = true;
                break;
            case '131':
                vm.budisabled = true;
                vm.divdeptdisabled = true;
                vm.upload = true;
                vm.typedisabled = true;
                vm.employeeType = 'HRIS';
                vm.eCheckin = false;
                vm.download = true;
                break;
            case '164':
            case '165':
            case '167':
            case '169':
                vm.dataSales = true;
                break;
        }
        vm.upload = true;

        if (
            vm.user == '04130027' ||
            vm.user == '16000396' ||
            vm.user == '18000105' ||
            vm.user == '17000375' ||
            vm.user == '16000516' ||
            vm.user == '17000474' ||
            vm.user == '15000062'
        ) {
            vm.eCheckin = true;
        }

        // loadDataBU();
        // loadDataDivision(vm.company);
        loadSubArea();
        // vm.loadData = loadData;
        // loadData(1);

        ////////////////////////////
        function isSpouseWork() {
            return vm.spousework
        }

        function loadData(pageno) {
            var response = vm.DataTable.loadData(EMP, pageno, {
                action: 'viewDataAdmin',
                company: vm.company,
                divisi: vm.divisi,
                department: vm.department,
                echeckin: vm.viewEcheckin,
                subarea: vm.subarea,
                emptype: vm.employeeType,
                gedung: vm.gedung,
                sector: vm.sector, 
                empstatus: vm.empstatus,
                area: vm.area,
                shiftgroup : vm.shiftgroup
            });
            response.then(function (data) {
                if (vm.country == 'MYS') {
                    // spousework
                    // var lng = vm.DataTable.list.length
                    // console.log(lng)
                    console.log(data.list)
                    // for(var i=0;i<lng;i++)
                    // {
                    // }
                }
            })
        }

        function exportToExcel(ev) {
            $mdDialog.show({
                controller: 'DownloadEmployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe-admin/employe-admin-download.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                }
            });
            // var token=Auth.setTokenPromise();
            //     token.then(function(data){
            //           var protocol=$location.protocol();
            //           var host=$location.host();
            //           var lokasi = vm.company;
            //     console.log('api/employe/exportexcel/'+data.token+'/'+lokasi, '_blank');

            //     $window.open(protocol+'://'+host+config.api+'api/employe/exportexcel/'+data.token+'/'+lokasi, '_blank');
            //     },function(){
            //       $window.alert('gagal load token');
            //     });
        }

        function detailEmployee(id, eCheckin, nik) {
            console.log('NIK : ' + nik);
            $localStorage.currentNik = encodeURIComponent(window.btoa(nik));
            switch (eCheckin) {
                case '0':
                    $state.go('app.employee_employe_edit.profile', {
                        id: encodeURIComponent(window.btoa(id)),
                        nik: encodeURIComponent(window.btoa(nik))
                    });
                    break;
                case '1':
                    // console.log('id '+id);
                    // console.log('eCheckin '+eCheckin);
                    // $state.go('app.employee_employee_join',{id:id});
                    break;
            }
        }

        function openInputEmployee(ev) {
            $mdDialog.show({
                controller: 'EmployeAdminController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/input-employe/input-employe-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true
            });
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, EMP);
            promise.then(function () {
                showDialog(ev);
            });
        }

        function enableSpouseWork(frm, id, spouseWork) {
            vm.Form.objForm.emp_id = id;
            vm.Form.objForm.is_spouse_work = spouseWork;
            // vm.spousework = spouseWork;
            // vm.spousework
            var promise = Form.saveData('changeIsSpouseWork', frm, EMP);
            promise.then(function () {
                // showDialog('x');
                // loadData(1)
            });
        }

        function showDialog(ev) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(document.querySelector('#contentDialog'))
                    )
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    closeModal();
                });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            console.log(div);

            // div.isChecked = !div.isChecked;
        }

        function deleteData(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this list?')
                    .textContent(
                        'All data your selected will be deleted and can not recovered.'
                    )
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = EMP.delete({
                            action: 'delete',
                            data: angular.toJson(vm.listDataSelected)
                        });

                        response.$promise.then(loadData(1));
                    },
                    function () {}
                );
            });
        }

        function uploadEmployee(ev) {
            $mdDialog.show({
                controller: 'UploadfileController as vm',
                templateUrl: 'app/main/employee/employe/uploadfile/uploadfile.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function uploadContract(ev) {
            $mdDialog.show({
                controller: 'UploadEditKaryawanController as vm',
                templateUrl: 'app/main/employee/employe/uploadeditkaryawan/uploadeditkaryawan.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function downloadEmployee() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/employe/downloadecheckin/' +
                        data.token,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;

            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            if (idbu == 'PM') {
                vm.dataSales = true;
                loadSalesArea();
            }
            var response = Attendancereport.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            // vm.listDivision.push(data);
            // loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = Attendancereport.query({
                action: 'viewSubArea',
                company: vm.company
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
             
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        function downloadEcheckIn(ev) {
            $mdDialog.show({
                controller: 'DownloadEcheckInController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/echeckin-download.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    listBU: vm.listBU
                }
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

         

        function ClearFilter() {
            vm.subarea = null;
            vm.gedung = null;
            vm.sector = null;
            vm.area = null; 
            vm.groupLogin = $localStorage.group;
            vm.divisi = 'all';
            vm.department = 'all';
            vm.empstatus='active';
            vm.shiftgroup=null;
            // loadDataBU();
            // loadDataDivision(vm.company);
            loadSubArea();
        }

        function uploadBuilding(ev) {
            $mdDialog.show({
                controller: 'UploadBuildingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe-admin/upload-building/upload-building.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                }
            });

        }

        function uploadEditAtasan(ev) {
            $mdDialog.show({
                controller: 'UploadEditAtasanController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe-admin/upload-edit-atasan/upload-edit-atasan.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                }
            });

        }

        function uploadEditGroupShift(ev) {
            $mdDialog.show({
                controller: 'UploadEditGroupShiftController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe-admin/upload-edit-group-shift/upload-edit-group-shift.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                }
            });

        }

        function searchEmploye(ev) {
            $mdDialog.show({
                controller: 'SearchEmployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe-admin/search-employe/search-employe.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                }
            });

        }

        function  loadGedung(id)
        {
            var response = EMP.query({
                action: 'getSelectListGedungByAdmin',
                sub_area_id: id
            });
            response.$promise.then(fetchGedung);
            response.$promise.catch(errorfetchGedung);
        }

        function fetchGedung(data)
        {
            vm.listGedung=data;
        }

        function errorfetchGedung()
        {
            vm.listGedung=[];
        }

        function  loadSector(id)
        {
            var response = EMP.query({
                action: 'getSelectListSectorByAdmin',
                gedung_id: id
            });
            response.$promise.then(fetchSector);
            response.$promise.catch(errorfetchSector);
        }

        function fetchSector(data)
        {
            vm.listSector=data;
        }

        function errorfetchSector()
        {
            vm.listSector=[];
        }

        function  loadShiftGroup(id)
        { 
            var response = EMP.query({
                action: 'getShiftGroupByArea',
                sub_area: id
            });
            response.$promise.then(fetchShift);
            response.$promise.catch(errorfetchShift);
        }

        function fetchShift(data)
        {
            vm.listShift=data;
        }

        function errorfetchShift()
        {
            vm.listShift=[];
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe')
        .controller('EmployeController', EmployeController);

    EmployeController.$inject = [
        '$state',
        '$window',
        '$localStorage',
        '$location',
        '$document',
        '$mdDialog',
        'AppAPI',
        'DataService',
        'config',
        'Auth',
        'Form',
        '$element'
    ];
    /** @ngInject */
    function EmployeController(
        $state,
        $window,
        $localStorage,
        $location,
        $document,
        $mdDialog,
        AppAPI,
        DataService,
        config,
        Auth,
        Form,
        $element
    ) {
        var vm = this;
        // initial form
        Form.initialForm();

        var EMP = AppAPI.Employe();
        var Attendancereport = AppAPI.Attendancereport();
        var PayrollProcess = AppAPI.NewPayrollProcess();
        var Subarea = AppAPI.Subarea();

        Form.setObject(EMP);

        // set form to controller
        vm.Form = Form;

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.detailEmployee = detailEmployee;
        vm.loadData = loadData;

        vm.openInputEmployee = openInputEmployee;
        vm.closeModal = closeModal;
        vm.title = ['Mr', 'Mrs', 'Miss', 'Ms'];
        vm.jenkel = ['L', 'P'];
        vm.maritalStatuses = ['Lajang', 'Menikah', 'Duda', 'Janda'];
        vm.saveData = saveData;
        vm.deleteData = deleteData;

        vm.listData = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];
        vm.checkone = checkone;
        vm.uploadEmployee = uploadEmployee;
        vm.uploadContract = uploadContract;
        vm.downloadEmployee = downloadEmployee;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;
        vm.downloadEcheckIn = downloadEcheckIn;

        vm.exportToExcel = exportToExcel;
        console.log('sitestttt '+ $localStorage.empsite);
        vm.company = $localStorage.empsite;
        vm.groupLogin = $localStorage.group;
        vm.user = $localStorage.user;
        vm.eCheckin = false;
        vm.viewEcheckin = false;
        vm.divisi = 'all';
        vm.department = 'all';
        vm.divdeptdisabled = false;
        vm.upload = true;
        vm.download = true;
        vm.typedisabled = false;
        vm.budisabled = true;
        vm.dataSales = false;
        vm.loadSalesArea = loadSalesArea;
        vm.changeArea = changeArea;
        vm.ClearFilter = ClearFilter;
        vm.country = $localStorage.country;
        vm.enableSpouseWork = enableSpouseWork;
        vm.isSpouseWork = isSpouseWork;
        vm.loadSubArea = loadSubArea;


        vm.wilayah = null;
        vm.region = null;
        vm.cabang = null;
        vm.area = null;

        vm.searchTerm = '';

        vm.typeEmp = [
            {
                view: 'Staff',
                value: 'SAP'
            },
            {
                view: 'General Worker',
                value: 'HRIS'
            }
        ];

        switch (vm.groupLogin) {
            case '1':
            case '104':
            case '130':
            case '10':
            case '132':
                vm.budisabled = false;
                break;
            case '11':
            case '127':
                vm.budisabled = true;
                vm.divdeptdisabled = true;
                vm.upload = false;
                vm.download = false;
                break;
            case '130':
                vm.budisabled = false;
                vm.divdeptdisabled = true;
                vm.upload = false;
                vm.eCheckin = true;
                vm.download = true;
                break;
            case '131':
                vm.budisabled = true;
                vm.divdeptdisabled = true;
                vm.upload = true;
                vm.typedisabled = true;
                vm.employeeType = 'HRIS';
                vm.eCheckin = false;
                vm.download = true;
                break;
            case '164':
            case '165':
            case '167':
            case '169':
                vm.dataSales = true;
                break;
        }
        if (
            vm.user == '04130027' ||
            vm.user == '16000396' ||
            vm.user == '18000105' ||
            vm.user == '17000375' ||
            vm.user == '16000516' ||
            vm.user == '17000474' ||
            vm.user == '15000062'
        ) {
            vm.eCheckin = true;
        }

        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();
        // vm.loadData = loadData;
        // loadData(1);
        LoadCountry();

        function LoadCountry() {
            var response = PayrollProcess.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        ////////////////////////////
        function isSpouseWork() {
            return vm.spousework
        }

        function loadData(pageno) {
            var response = vm.DataTable.loadData(EMP, pageno, {
                action: 'viewdata',
                company: vm.company,
                country: vm.country,
                divisi: vm.divisi,
                department: vm.department,
                echeckin: vm.viewEcheckin,
                subarea: vm.subarea,
                emptype: vm.employeeType,
                wilayah: vm.wilayah,
                region: vm.region,
                cabang: vm.cabang,
                area: vm.area
            });
            response.then(function (data) {
                if (vm.country == 'MYS') {
                    // spousework
                    // var lng = vm.DataTable.list.length
                    // console.log(lng)
                    console.log(data.list)
                    // for(var i=0;i<lng;i++)
                    // {
                    // }
                }
            })
        }

        function exportToExcel(ev) {
            $mdDialog.show({
                controller: 'DownloadEmployeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/employe-download.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                }
            });
            // var token=Auth.setTokenPromise();
            //     token.then(function(data){
            //           var protocol=$location.protocol();
            //           var host=$location.host();
            //           var lokasi = vm.company;
            //     console.log('api/employe/exportexcel/'+data.token+'/'+lokasi, '_blank');

            //     $window.open(protocol+'://'+host+config.api+'api/employe/exportexcel/'+data.token+'/'+lokasi, '_blank');
            //     },function(){
            //       $window.alert('gagal load token');
            //     });
        }

        function detailEmployee(id, eCheckin, nik) {
            console.log('NIK : ' + nik);
            $localStorage.currentNik = encodeURIComponent(window.btoa(nik));
            switch (eCheckin) {
                case '0':
                    $state.go('app.employee_employe_edit.profile', {
                        id: encodeURIComponent(window.btoa(id)),
                        nik: encodeURIComponent(window.btoa(nik))
                    });
                    break;
                case '1':
                    // console.log('id '+id);
                    // console.log('eCheckin '+eCheckin);
                    // $state.go('app.employee_employee_join',{id:id});
                    break;
            }
        }

        function openInputEmployee(ev) {
            $mdDialog.show({
                controller: 'EmployeController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/employee/employe/input-employe/input-employe-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true
            });
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('save', formController, EMP);
            promise.then(function () {
                showDialog(ev);
            });
        }

        function enableSpouseWork(frm, id, spouseWork) {
            angular.element.blockUI();

            vm.Form.objForm.emp_id = id;
            vm.Form.objForm.is_spouse_work = spouseWork;
            // vm.spousework = spouseWork;
            // vm.spousework
            var promise = Form.saveData('changeIsSpouseWork', frm, EMP);
            promise.then(function () {
                angular.element.unblockUI();
                // showDialog('x');
                // loadData(1)
            });
        }

        function showDialog(ev) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Success Save Data')
                        .textContent('Process Data was Success.')
                        .ariaLabel('Success Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    closeModal();
                });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            console.log(div);

            // div.isChecked = !div.isChecked;
        }

        function deleteData(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this list?')
                    .textContent(
                        'All data your selected will be deleted and can not recovered.'
                    )
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = EMP.delete({
                            action: 'delete',
                            data: angular.toJson(vm.listDataSelected)
                        });

                        response.$promise.then(loadData(1));
                    },
                    function () { }
                );
            });
        }

        function uploadEmployee(ev) {
            $mdDialog.show({
                controller: 'UploadfileController as vm',
                templateUrl: 'app/main/employee/employe/uploadfile/uploadfile.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        function uploadContract(ev) {
            $mdDialog.show({
                controller: 'UploadEditKaryawanController as vm',
                templateUrl:
                    'app/main/employee/employe/uploadeditkaryawan/uploadeditkaryawan.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        function downloadEmployee() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                        '://' +
                        host +
                        config.api +
                        'api/employe/downloadecheckin/' +
                        data.token,
                        '_blank'
                    );
                },
                function () {
                    $window.alert('gagal load token');
                }
            );
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;

            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            if (idbu == 'PM') {
                vm.dataSales = true;
                loadSalesArea();
            }
            var response = Attendancereport.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            // vm.listDivision.push(data);
            // loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = Attendancereport.query({
                action: 'viewSubArea',
                company: vm.company
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
            if (vm.company == 'PM') {
                vm.wilayah = null;
                vm.region = null;
                vm.cabang = null;
                vm.area = null;
                loadSalesArea();
            }
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        function downloadEcheckIn(ev) {
            $mdDialog.show({
                controller: 'DownloadEcheckInController',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee/employe/echeckin-download.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    listBU: vm.listBU
                }
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function loadSalesArea() {
            // vm.wilayah=null;
            // vm.region=null;
            // vm.cabang=null;
            // vm.area=null;
            var response = Subarea.query({
                action: 'getAreaSales',
                subarea: vm.subarea,
                wilayah: vm.wilayah,
                region: vm.region,
                cabang: vm.cabang
            });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorfetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.areaSales = data[0].area;
            vm.cabangSales = data[0].cabang;
            vm.regionSales = data[0].region;
            vm.wilayahSales = data[0].wilayah;
            // vm.wilayah=null;
            // vm.region=null;
            // vm.cabang=null;
            // vm.area=null;
        }

        function errorfetchAreaSales(data) {
            vm.areaSales = [];
            vm.cabangSales = [];
            vm.regionSales = [];
            vm.wilayahSales = [];
            // vm.wilayah=null;
            // vm.region=null;
            // vm.cabang=null;
            // vm.area=null;
        }

        function changeArea() {
            vm.wilayah = null;
            vm.region = null;
            vm.cabang = null;
            vm.area = null;
            loadSalesArea();
        }

        function ClearFilter() {
            vm.wilayah = null;
            vm.region = null;
            vm.cabang = null;
            vm.area = null;
            vm.company = [$localStorage.empsite];
            vm.groupLogin = $localStorage.group;
            vm.divisi = 'all';
            vm.department = 'all';
            loadDataBU();
            loadDataDivision(vm.company);
            loadSubArea();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee.employe')
        .controller('DownloadEmployeController', DownloadEmployeController)
        .directive( 'emHeightTarget', function() {
            return {
                link: function( scope, elem, attrs ) {
                    scope.$watch( '__height', function( newHeight, oldHeight ) {
                        elem.attr( 'style', 'height: ' + Math.ceil(newHeight + (27/2)) + 'px' );
                    } );
                }
            }
        } )
        .directive( 'emHeightSource', function() {
            return {
                link: function( scope, elem, attrs ) {
                    scope.$watch( function() {
                        scope.__height = elem.height();
                    } );
                }
            }
        } );

    DownloadEmployeController.$inject = [
        '$localStorage',
        '$mdDialog',
        'Form',
        'AppAPI',
        '$log',
        'FileUploader',
        'config',
        'Auth',
        '$window', '$location',
        '$element'
    ];

    /* @ngInject */
    function DownloadEmployeController(
        $localStorage,
        $mdDialog,
        Form,
        AppAPI,
        $log,
        FileUploader,
        config,
        Auth,
        $window,
        $location,
        $element
    ) {
        var vm = this;
        Form.initialForm();

        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        var Attendancereport = AppAPI.Attendancereport();
        var Subarea = AppAPI.Subarea();

        vm.company = $localStorage.empsite;
        vm.groupLogin = $localStorage.group;
        vm.download = download;
        vm.closeModal = closeModal;
        vm.loadSubArea = loadSubArea;
        vm.divisi = 'all';
        vm.department = 'all';
        vm.divdeptdisabled = false;
        vm.typedisabled = false;
        vm.budisabled = true;

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.toggleCheck = toggleCheck;
        vm.isChecked = isChecked;
        vm.AddFieldList = AddFieldList;
        vm.removeField = removeField;
        vm.isCheckedAll = false;
        vm.disable = false;
        vm.listSelected = [];
        vm.fieldCodeSelected = [];
        vm.fieldSelected = [];

        vm.dataSales = false;
        vm.loadSalesArea = loadSalesArea;
        vm.changeArea = changeArea;
        vm.ClearFilter = ClearFilter;

        vm.wilayah = null;
        vm.region = null;
        vm.cabang = null;
        vm.area = null;
        vm.loadSubArea = loadSubArea;
        vm.searchTerm = '';
        vm.clearSearchTerm = clearSearchTerm;

        vm.typeEmp = [{
            "view": "Staff/Manager",
            "value": "SAP"
        },
        {
            "view": "GW/Crew/Sales",
            "value": "HRIS"
        },
        {
            "view": "All",
            "value": "All"
        }
        ];

        loadDataBU();
        loadCustomField();
        loadDataDivision(vm.company);
        loadSubArea();

        vm.divisi = 'all';
        vm.department = 'all';
        vm.listStatus = ['active', 'non active'];
        vm.typeContract = [
                            'permanent',
                            'contract',
                            'probation',
                            'parttime',
                            'pelatihan',
                            'borongan'
                        ];

        switch (vm.groupLogin) {
            case '1':
            case '104':
            case '130':
            case '10':
            case '132':
            case '138':
                vm.budisabled = false;
                break;
            case '11':
            case '127':
            case '130':
                vm.budisabled = true;
                vm.divdeptdisabled = true;
                vm.upload = false;
                vm.download = false;
                break;
            case '131':
                vm.budisabled = true;
                vm.divdeptdisabled = true;
                vm.upload = true;
                vm.typedisabled = true;
                vm.employeeType = 'HRIS';
                vm.eCheckin = false;
                break;
            case '164':
            case '165':
            case '167':
            case '169':
                vm.dataSales = true;
                break;
        }

        //////////////////////////

        function closeModal() {
            $mdDialog.hide();
        }


        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;

            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            // console.log(idbu);
            if (idbu) {
                if (idbu.length == 1) {
                    vm.divdeptdisabled = false;
                    var response = Attendancereport.query({
                        action: 'viewDivisiBu',
                        idbu: idbu
                    });
                    response.$promise.then(fetchDivisiBU);
                    response.$promise.catch(errorDivisiBU);
                } else {
                    vm.divdeptdisabled = true;
                }
                if (idbu == 'PM') {
                    console.log('test');
                    vm.dataSales = true;
                    loadSalesArea();
                }
            }
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            // vm.listDivision.push(data);
            // loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadCustomField() {
            var response = Attendancereport.query({
                action: 'viewBu',
                type: 'customField'
            });
            response.$promise.then(fetchCustomField);
            response.$promise.catch(errorFetchCustomField);
        }

        function fetchCustomField(data) {
            vm.listCustomField = data;
        }

        function errorFetchCustomField() {
            vm.listCustomField = [];
        }

        function download() {

            var company = angular.copy(vm.company);
            var divisi = vm.divisi;
            var department = vm.department;
            var startrange = vm.startrange;
            var endrange = vm.endrange;
            var status = null;
            var startRangeJoin = null;
            var endRangeJoin = null;
            var contract = null;
            var empType = null;

            if (company.length == 1) {
                if (divisi !== 'all') {
                    company = company + divisi;
                }

                if (department !== 'all') {
                    company = company + department;
                }
            }

            if (typeof (startrange) !== 'undefined' && typeof (endrange) !== 'undefined') {
                var d1 = new Date(startrange);
                var d2 = new Date(endrange);
                var d1M = (d1.getMonth() + 1);
                var d2M = (d2.getMonth() + 1);
                var d1D = d1.getDate();
                var d2D = d2.getDate();
                if (d1M < 10) {
                    d1M = '0' + d1M;
                }
                if (d2M < 10) {
                    d2M = '0' + d2M;
                }

                if (d1D < 10) {
                    d1D = '0' + d1D;
                }

                if (d2D < 10) {
                    d2D = '0' + d2D;
                }
                var startRangeJoin = d1.getFullYear() + '-' + d1M + '-' + d1D;
                var endRangeJoin = d2.getFullYear() + '-' + d2M + '-' + d2D;
            }

            if (typeof (vm.status) !== 'undefined') {
                status = vm.status;
            }

            if (typeof (vm.contract) !== 'undefined') {
                contract = vm.contract;
            }

            if (typeof vm.employeeType !== "undefined") {
                empType = vm.employeeType;
            }

            // console.log(company+' / '+startRangeJoin+' / '+endRangeJoin+' / '+status+' / '+contract);


            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                // var host='localhost:3000/';
                var custom = vm.fieldCodeSelected.toString();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/employe/exportexcel/' + encodeURIComponent(JSON.stringify(company)) + '/' + startRangeJoin + '/' + endRangeJoin + '/' + status + '/' + contract + '/' + empType + '/' + vm.subarea + '/' + vm.wilayah + '/' + vm.region + '/' + vm.cabang + '/' + vm.area + '/' + data.token + '?custom=' + custom, '_blank');
            },
                function () {
                    $window.alert('gagal load token');
                });
        }

        function loadSubArea() {
            var response = Attendancereport.query({
                action: 'viewSubArea',
                company: vm.company
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
            if (vm.company == 'PM') {
                vm.wilayah = null;
                vm.region = null;
                vm.cabang = null;
                vm.area = null;
                loadSalesArea();
            }
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }



        function closeModal() {
            $mdDialog.hide();
        }

        function toggleSelectedAll(state) {
            if (vm.isCheckedAll) {
                vm.isCheckedAll = false;
            } else {
                vm.isCheckedAll = true;
            }
            if (vm.listSelected.length === vm.listCustomField.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.listCustomField.slice(0);
            }
        }

        function isChecked(ls) {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if (idx > -1) {
                vm.listSelected.splice(idx, 1);
            } else {
                vm.listSelected.push(ls);
            }
        }

        function AddFieldList() {
            vm.isCheckedAll = false;
            var obj = vm.listSelected;
            angular.forEach(obj, function (value, key) {
                var ifSelected = checkIfExistInselected(value.name, vm.fieldSelected);
                if (!ifSelected) {
                    var datas = {
                        code: value.code,
                        name: value.name
                    }
                    vm.fieldSelected.push(datas);
                    vm.fieldCodeSelected.push(value.code);
                    vm.listSelected = [];
                }
            });
        }

        function checkIfExistInselected(value, arrSelected) {
            var ifSelected = false;
            var len = arrSelected.length;
            for (var i = 0; i < len; i++) {
                if (arrSelected[i].name == value) {
                    ifSelected = true;
                }
            }

            return ifSelected;
        }

        function removeField(ls) {
            var idx = vm.fieldSelected.indexOf(ls);
            var codeX = vm.fieldCodeSelected.indexOf(ls.code);
            if (idx > -1) {
                vm.fieldSelected.splice(idx, 1);
            }
            if (codeX > -1) {
                vm.fieldCodeSelected.splice(codeX, 1);
            }
        }

        function loadSalesArea() {
            // vm.wilayah=null;
            // vm.region=null;
            // vm.cabang=null;
            // vm.area=null;
            var response = Subarea.query({
                action: 'getAreaSales',
                subarea: vm.subarea,
                wilayah: vm.wilayah,
                region: vm.region,
                cabang: vm.cabang

            });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorfetchAreaSales)
        }

        function fetchAreaSales(data) {
            vm.areaSales = data[0].area;
            vm.cabangSales = data[0].cabang;
            vm.regionSales = data[0].region;
            vm.wilayahSales = data[0].wilayah;
            // vm.wilayah=null;
            // vm.region=null;
            // vm.cabang=null;
            // vm.area=null;

        }

        function errorfetchAreaSales(data) {
            vm.areaSales = [];
            vm.cabangSales = [];
            vm.regionSales = [];
            vm.wilayahSales = [];
            // vm.wilayah=null;
            // vm.region=null;
            // vm.cabang=null;
            // vm.area=null;
        }

        function changeArea() {
            vm.wilayah = null;
            vm.region = null;
            vm.cabang = null;
            vm.area = null;
            loadSalesArea();
        }

        function ClearFilter() {
            vm.wilayah = null;
            vm.region = null;
            vm.cabang = null;
            vm.area = null;
            vm.company = [$localStorage.empsite];
            vm.groupLogin = $localStorage.group;
            vm.divisi = 'all';
            vm.department = 'all';
            loadDataBU();
            loadDataDivision(vm.company);
            loadSubArea();
        }

        function clearSearchTerm() {
            vm.searchTerm = '';
        };

        // $element.find('input').on('keydown', function (ev) {
        //     ev.stopPropagation();
        // });

    }
})();

(function() {
    'use strict';

    angular
        .module('app.employee.employe')
        .controller('DownloadEcheckInController', DownloadEcheckInController);

    DownloadEcheckInController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','FileUploader','config','Auth','$window','$location','listBU'];

    /* @ngInject */
    function DownloadEcheckInController($localStorage,$mdDialog,Form,AppAPI,$log,FileUploader,config,Auth,$window,$location,listBU)
    {
        var vm = this;
        Form.initialForm();
        
        vm.company=$localStorage.empsite;
        vm.groupLogin=$localStorage.group;
        vm.download=download;
        vm.closeModal=closeModal;
        vm.listBU=listBU;
        vm.listBU.push({'id':'all','description':'All'});
        
        function closeModal() {
            $mdDialog.hide();
        }

        function download()
        {

            var company=vm.company;
            var startrange=vm.startrange;
            var endrange=vm.endrange;
            var startRange=null;
            var endRange=null;
            var contract=null;
            var empType = null;

            if(typeof(startrange) !=='undefined' && typeof(endrange) !=='undefined'){
                var d1=new Date(startrange);
                var d2=new Date(endrange);
                
                var d1M=(d1.getMonth()+1);
                var d2M=(d2.getMonth()+1);
                
                var d1D=d1.getDate();
                var d2D=d2.getDate();
                
                if(d1M <10){
                    d1M='0'+d1M;
                }
                if(d2M < 10){
                    d2M='0'+d2M;
                }
                if(d1D < 10){
                    d1D='0'+d1D;
                }
                if(d2D < 10){
                    d2D='0'+d2D;
                }

                var startRange=d1.getFullYear()+'-'+d1M+'-'+d1D;
                var endRange=d2.getFullYear()+'-'+d2M+'-'+d2D;
            }

            var token=Auth.setTokenPromise();
            token.then(function(data){
                var protocol=$location.protocol();
                var host=$location.host();
                $window.open(protocol+'://'+host+config.api+'api/employe/downloadecheckin/'+data.token+'/'+startRange+'/'+endRange+'/'+vm.company, '_blank');

            },function(){
                $window.alert('gagal load token');
            });
        }

        function closeModal(){
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employee.download-employee', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.employee_download-employee', {
                url    : '/cd/download-employee',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/employee/download-employee/download-employee.html',
                        controller : 'DownloadEmployeeController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.employee.download-employee')
        .controller('DownloadEmployeeController', DownloadEmployeeController);

    DownloadEmployeeController.$inject = ['$state','$window','$location','$localStorage','$document','$element','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService'];

    /* @ngInject */
  function DownloadEmployeeController($state,$window,$location,$localStorage,$document,$element,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService ) {
      var vm = this;
      vm.downloadEmployees=downloadEmployees; 


       /////////////////////////////// 
    function downloadEmployees(ev)
        {
            $mdDialog.show({
                controller         : 'EmployeesDownloadController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/employee/download-employee/employee-download.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {

                } 
            }); 

        }

     

    }
})();
(function () {
  'use strict';

  angular
      .module('app.employee.borongan-transaction', [])
       .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.employee_borongan_transaction', {
              url: '/employee/borongan-transaction',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/employee/borongan-transaction/borongan-transaction.html',
                      controller: 'BoronganTransactionController as vm'
                  }
              }
          });
  }
 })();

(function() {
  'use strict';
  angular
    .module('app.employee.borongan-transaction')
    .controller('BoronganTransactionController', BoronganTransactionController);

  BoronganTransactionController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    '$q',
    'filterFilter'
  ];
  /** @ngInject */
  function BoronganTransactionController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    $q,
    filterFilter
  ) {
    var vm = this;
    var Attendancereport = AppAPI.Attendancereport();
    var borongan = AppAPI.BoronganTransaction();
    var ApiLaborType = AppAPI.EmpLaborType();
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.company = $localStorage.empsite ? $localStorage.empsite : 'KS';
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addDataBoronganTransaction = addDataBoronganTransaction;
    vm.saveData = saveData;
    vm.boronganType = [];
    vm.years = [];
    vm.empList = empList;
    vm.empListData = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.selectedEmp = [];
    vm.querySearchDeferred = querySearchDeferred;
    vm.Form = Form;
    vm.editDataBoronganTransaction = editDataBoronganTransaction;
    vm.deleteDataBoronganTransaction = deleteDataBoronganTransaction;
    vm.UploadBoronganTransaction = UploadBoronganTransaction;

    vm.monthName = [
      {view : "Januari", value: "01"},
      {view : "Februari", value: "02"},
      {view : "Maret", value: "03"},
      {view : "April", value: "04"},
      {view : "Mei", value: "05"},
      {view : "Juni", value: "06"},
      {view : "Juli", value: "07"},
      {view : "Agustus", value: "08"},
      {view : "September", value: "09"},
      {view : "Oktober", value: "10"},
      {view : "November", value: "11"},
      {view : "Desember", value: "12"}
    ];

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      Form.initialForm();
      Form.setObject(borongan);
      loadDataBoronganType();
      generateYears();
      empList()
      loadDataBU();
    }

    function generateYears() {
      var yearsTmp  = new Date();
      var i=0;
      var yearsOnly = yearsTmp.getFullYear();
      for ( i = 0; i < 5; i++) {
        vm.years.push(
          yearsOnly + i
        );
      }

    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(borongan, pageno, {
        action: 'viewData',
        company: vm.company,
        type: vm.selectedBoronganType,
        month: vm.selectedMonth,
        year: vm.selectedYears
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addDataBoronganTransaction(ev) {
      $mdDialog.show({
        controller: 'BoronganTransactionController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/borongan-transaction/borongan-transaction-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editDataBoronganTransaction(ev, data) {
      $mdDialog.show({
        controller: 'EditBoronganTransactionController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee/borongan-transaction/borongan-transaction-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data  : data,
          years : vm.years,
          boronganType : vm.boronganType
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteDataBoronganTransaction(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = borongan.delete({
              action: 'deleteData',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.type_borongan_id = frm.boronganType.$viewValue;
      vm.Form.objForm.jumlahPengerjaan = frm.jumlahPengerjaan.$viewValue;
      vm.Form.objForm.year = frm.years.$viewValue;
      vm.Form.objForm.month = frm.month.$viewValue;
      vm.Form.objForm.nik = frm.nik.$viewValue;
      var response = Form.saveData('saveData', frm, borongan);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function UploadBoronganTransaction(ev) {
      $mdDialog.show({
        controller: 'UploadBoronganTransactionController',
        controllerAs: 'vm',
        templateUrl:
          'app/main/employee/borongan-transaction/borongan-transaction-upload.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function loadDataBU() {
      var response = Attendancereport.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }


    function loadDataBoronganType() {
      var response = borongan.query({
        action: 'getBoronganType'
      });

      response.$promise.then(function(data){
        vm.boronganType = data;
      });

      response.$promise.catch(function(){
        vm.boronganType = [];
      });
    }

    function empList() {
      var response = ApiLaborType.query({
          action: 'viewListEmployee',
          company: vm.company
      });
      response.$promise.then(fetchDataEmpList);
    }

    function fetchDataEmpList(data) {
      vm.empListData = [];
      vm.empListData = data;
    }

    function querySearchDeferred(query) {
        var deferred = $q.defer();
        setTimeout(function() {
            var data = vm.empListData;
            if (query) {
                deferred.resolve(filterFilter(data, query));
            } else {
                deferred.reject([{ nik: 'none', name: 'none' }]);
            }
        }, 200);
        return deferred.promise;
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('app.employee.borongan-transaction')
    .controller('UploadBoronganTransactionController', UploadBoronganTransactionController);

  UploadBoronganTransactionController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'FileUploader',
    'config'
  ];
  /** @ngInject */
  function UploadBoronganTransactionController(
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    FileUploader,
    config
  ) {
    var vm = this;
    var borongan = AppAPI.BoronganTransaction();
    vm.Form = Form;
    vm.dialogClose = dialogClose;

    vm.uploadBoronganTransactionSuccess = false;
    vm.uploadBoronganTransactionError = false;

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.FileUploaderBoronganTransaction = new FileUploader({
      url: config.api + 'api/borongantransaction/uploadData',
      removeAfterUpload: true,
      alias: 'fileBoronganTransaction',
      formData: [{
          action: 'uploadData'
      }],
      onAfterAddingAll: function() {
        vm.uploadBoronganTransactionSuccess = false;
        vm.uploadBoronganTransactionError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUploaderBoronganTransaction.onSuccessItem = function(item) {
      vm.uploadBoronganTransactionSuccess = true;
      vm.uploadBoronganTransactionError   = false;
      angular.element('#uploadBoronganTransaction').val('');
      setTimeout(function(item){
        dialogClose();
      }, 1000);
    };

    vm.FileUploaderBoronganTransaction.onErrorItem = function() {
      vm.uploadBoronganTransactionSuccess = false;
      vm.uploadBoronganTransactionError = true;
      setTimeout(function(item){
        dialogClose();
      }, 2000);
    };

    function dialogClose() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('app.employee.borongan-transaction')
    .controller('EditBoronganTransactionController', EditBoronganTransactionController);

  EditBoronganTransactionController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'data',
    'boronganType',
    'years'
  ];
  /** @ngInject */
  function EditBoronganTransactionController(
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    data,
    boronganType,
    years
  ) {
    var vm = this;
    var borongan = AppAPI.BoronganTransaction();
    vm.Form = Form;
    vm.boronganType = boronganType;
    vm.years = years;
    vm.info = data;
    vm.updateData = updateData;
    vm.dialogClose = dialogClose;

    vm.monthName = [
      {view : "Januari", value: 1},
      {view : "Februari", value: 2},
      {view : "Maret", value: 3},
      {view : "April", value: 4},
      {view : "Mei", value: 5},
      {view : "Juni", value: 6},
      {view : "Juli", value: 7},
      {view : "Agustus", value: 8},
      {view : "September", value: 9},
      {view : "Oktober", value: 10},
      {view : "November", value: 11},
      {view : "Desember", value: 12}
    ];

    activate();

    function activate() {
      console.log(data);
      vm.selectedMonth = data.monthNumber;
      vm.selectedYears = data.year;
      vm.jumlahPengerjaan = data.jumlah_pengerjaan
      vm.selectedBoronganType = data.borongan_type_id;
      Form.initialForm();
      Form.setObject(borongan);
    }


    function updateData(ev, frm) {
      angular.element.blockUI();
      console.log(frm);
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.type_borongan_id = frm.boronganType.$viewValue;
      vm.Form.objForm.jumlahPengerjaan = frm.jumlahPengerjaan.$viewValue;
      vm.Form.objForm.year = frm.years.$viewValue;
      vm.Form.objForm.month = frm.month.$viewValue;
      var response = Form.saveData('updateData', frm, borongan);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.emp_surveys.emp-surveys-detail', [])
        .config(config);

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
        // State 
        $stateProvider
        .state('app.emp_surveys_detail', {
            url    : '/emp-surveys/emp-surveys-detail/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/emp-surveys/emp-surveys-detail/emp-surveys-detail.html',
                    controller : 'SetEmpSurveysDetailController as vm'
                }
            }
        });   
                
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.emp_surveys.emp-surveys-detail')
        .controller('SetEmpSurveysDetailController', SetEmpSurveysDetailController)
        .directive('mdButtonsToggleSurveys', SetEmpSurveysDirective);


    SetEmpSurveysDetailController.$inject=['DataService','$state','$mdDialog','$mdToast','$localStorage','$window','AppAPI','Auth','Form','DTColumnDefBuilder','$timeout','$stateParams'];
    /** @ngInject */
    function SetEmpSurveysDetailController(DataService,$state,$mdDialog,$mdToast,$localStorage,$window,AppAPI,Auth,Form,DTColumnDefBuilder,$timeout,$stateParams)
    {

        var vm             = this;
        var EmpSurveys      = AppAPI.EmpSurveys();
        vm.username        = $localStorage.user;
        vm.nik             = $stateParams.id;
        vm.profile         = {};

        vm.islastStep      = false;

        vm.ratingLists     = [];       
        vm.languageList    = [
            {value: 'ID', label: 'Indonesia'},
            {value: 'EN', label: 'English'}
        ];
        vm.isDisabled      = true;
        vm.selected        = 'ID';
        vm.language        = 'ID';
        vm.changeLanguage  = changeLanguage;


        Form.initialForm();

        Form.setObject(EmpSurveys);
        vm.Form = Form;

        vm.setToken=Auth.setToken;

        loadData();

        function changeLanguage(lang) {
            vm.language = lang;
        }
        
        function loadData() {
           angular.element.blockUI();
           var promises = EmpSurveys.query({action:'get_profile', nik: vm.nik});
           promises.$promise.then(fetchData);
           promises.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            if(typeof(data[0]) !== 'undefined') {
                vm.profile = data;

                loadSurveyData();

            }
        }

        function errorFetch() {
            vm.profile = {};
            angular.element.unblockUI();
        }

        function loadSurveyData() {
           angular.element.blockUI();
           var promises = EmpSurveys.query({action:'get_employee_surveys',nik:vm.nik});
           promises.$promise.then(fetchSurveyData);
           promises.$promise.catch(errorSurveyFetch); 
        }

        function fetchSurveyData(data) {

            vm.surveys = data; 
            
            console.log('data', data);

            angular.element.unblockUI();                
        }

        function errorSurveyFetch() {

            angular.element.unblockUI();
        }

        function successSaveData() {
            vm.Form.tampilPesan = false;
            vm.messageTheme='green';

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.Form.pesan)
                .position('top right')
                .hideDelay(3000)
                .theme("success-toast")
            );

            loadCalculatedScoreData();

            // $timeout(function() {
            //     vm.Form.tampilPesan = false;
            // }, 2000);

            vm.setToken();
            
        }

        function failedSaveData() {
            vm.messageTheme='red';

            vm.setToken();
        }

    };

    function SetEmpSurveysDirective() {

        return {
            template: '<div layout="row" layout-align="center center">' +
            '<md-button ng-repeat="option in items" class="md-group md-raised" ng-class="{\'{{selectedClass}}\': option.value == ngModel,left: $index == 0, right: $last}" ng-click="change(option.value)" ng-bind="option.label" ng-disabled="ngDisabled"></md-button></div>',
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                ngModel: '=',
                items: '=',
                ngDisabled: '=',
                selectedClass: '@?'
            },
            link: function(scope, elem, attrs){
                if(angular.isUndefined(scope.selectedClass)){
                    scope.selectedClass = 'md-primary';
                }

                angular.forEach(scope.items, function(value, key){
                    if(!angular.isObject(value)){
                        scope.items[key] = {value: value, label: value};
                    }
                });

                scope.change = function(key){
                    scope.ngModel = key;
                };
            }
        };
   
    }

})();
(function () {
    'use strict';

    angular
        .module('app.emp-sales-code', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.emp-sales-code', {
                url: '/emp-sales-code',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/emp-sales-code/emp-sales-code.html',
                        controller: 'EmpSalesCodeController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.emp-sales-code')
        .controller('viewEmpSalesCodeDetailController', viewEmpSalesCodeDetailController);

    viewEmpSalesCodeDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewEmpSalesCodeDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var Tiket = AppAPI.HcTicket();
        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.saveData = saveData;
        vm.closeTicket = closeTicket;
        vm.viewFile = viewFile
        vm.upload = upload
        vm.checkIsNeddFile = checkIsNeddFile
        vm.downloadDoc = downloadDoc
        vm.isSysdev = data.is_sysdev
        vm.status = data.status
        vm.refData = data
        vm.delegateToSysdev = delegateToSysdev

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(Tiket);

        vm.tinymceOptions = {
            height: 250,
            theme: 'modern',
            plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
            toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
            templates: [
                { title: 'template 1', content: 'Template 1' },
                { title: 'template 2', content: 'Template 2' }
            ],
        };

        loadTiketDetail();

        function loadTiketDetail() {
            var response = Tiket.query({ action: 'viewDetail', detail_id: data.id });
            response.$promise.then(fetchTiketDetail);
            response.$promise.catch(errorFetchTiketDetail);
        }

        function downloadDoc(ev, filename) {
            var name = filename;
            if (name !== null && name !== '') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                var message = translate('HCTICKET.MESSAGE.FILENOTFOUND');
                var status = translate('PAYROLL.MESSAGE.FAILED');

                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(message)
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }

        function fetchTiketDetail(data) {
            vm.id = data[0].id
            vm.errorType = data[0].errorType
            vm.type = data[0].type
            vm.isAdmin = data[0].isAdmin
            vm.title = data[0].title
            vm.description = (data[0].description == null || data[0].description === "") ? '<p>-</p>' : data[0].description
            vm.solutions = (data[0].note == null || data[0].note === "") ? '<p>-</p>' : data[0].note
            vm.requestedBy = data[0].requested_by + '-' + data[0].name
            vm.ticketStatus = data[0].statuss
            vm.company = data[0].company
            vm.area = data[0].area
            vm.estimation = (data[0].estimation != '0.0' && data[0].estimation != '0.00') ? data[0].estimation + ' ' + translate('MENU.MAIN.CB.HOUR') : '';
            vm.workDuration = (data[0].workDuration != '0.0' && data[0].workDuration != '0.00') ? data[0].workDuration + ' ' + translate('MENU.MAIN.CB.HOUR') : '';
            vm.phone = data[0].pic_phone
            vm.priority = data[0].priority
            vm.isRequested = data[0].is_requested
            vm.ticketRespons = data[0].respons
            vm.needSendMail = data[0].needSendMail
            vm.mailTo = data[0].mailTo

            vm.isClosed = data[0].status == '4' ? true : false;
            vm.message = translate('PAYROLL.MESSAGE.CLOSETICKETNOTIF');

            var tmpdate = new Date(data[0].created_at);
            var dd = tmpdate.getDate();
            var mm = tmpdate.getMonth() + 1; //January is 0!

            var yyyy = tmpdate.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            var tmpdate = dd + '/' + mm + '/' + yyyy;
            vm.requestedAt = tmpdate
        }

        function errorFetchTiketDetail() {
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();
            //set value
            vm.Form.objForm.ticket_id = data.id;
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.answer = vm.answer;
            var response = Form.saveData('reply', frm, Tiket);
            response.then(function (dataRespons) {
                loadTiketDetail()
                angular.element.unblockUI();
                frm.$setPristine();
                vm.answer = '';

                //sendEmail
                if (vm.needSendMail) {
                    vm.Form.objForm.title = data.title;
                    vm.Form.objForm.mailTo = vm.mailTo;
                    Form.saveData('sendMail', frm, Tiket);
                    // setTimeout(function () {
                    //     var promise = Auth.setToken();
                    //     promise.then(function () {
                    //         vm.objForm = new Tiket();
                    //         vm.objForm.action = 'sendMail';
                    //         //set value
                    //         vm.objForm.ticket_id = data.id;
                    //         vm.objForm.ticket_id = data.id;
                    //         vm.objForm.mailTo = vm.mailTo;
                    //         vm.objForm.$save();
                    //         var response = vm.objForm.$save();
                    //         response.then(function (data) {
                    //             Auth.setToken()
                    //         });
                    //         response.catch(function (data) {
                    //             Auth.setToken()
                    //         });
                    //     });
                    // }, 2000);
                    vm.showMessage = false;
                }
            });

            response.catch(function (data) {
                vm.showMessage = false;
                angular.element.unblockUI();
                frm.$setPristine();
            });
        }

        function closeTicket(ev, frm) {
            var message = translate('PAYROLL.MESSAGE.CONFIRMCLOSETICKET');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .ariaLabel('dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                // $mdDialog.show(confirm).then(function () {
                angular.element('#attView').block({
                    message: ' <span>Loading...</span>'
                });
                angular.element.blockUI();
                vm.objForm = new Tiket();
                vm.objForm.action = 'closeTicket';
                //set value
                vm.objForm.ticket_id = data.id;
                vm.objForm.is_closed = '4';
                var response = vm.objForm.$save();

                response.then(function (data) {
                    angular.element.unblockUI();
                    showDialogInfo(ev, data);
                });
                response.catch(function (data) {
                    angular.element.unblockUI();
                    showDialogInfo(ev, data);
                });

                // }, function () {
                //     angular.element('#attView').unblock();

                // });
            });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function viewFile(ev, img) {
            $mdDialog.show({
                controller: 'viewDocHcTicket',
                controllerAs: 'vm',
                templateUrl: 'app/main/hcticket/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    img: img
                }
            });
        }

        function checkIsNeddFile() {
            if (vm.isNeddUploadFile == false || typeof vm.isNeddUploadFile === 'undefined') {
                vm.isChecked = true
            } else {
                vm.isChecked = false
            }
        }

        function upload(form) {
            var vidFileLength = $("#uploadData")[0].files.length;
            if (vidFileLength === 0) {
                vm.showMessage = true;
                vm.alertMessage = translate('MENU.MAIN.PLEASECHOOSEAFILE');
            } else {
                vm.showMessage = false;
                angular.element.blockUI();
                var resp = vm.FileUploader.uploadAll();
            }
        }

        vm.FileUploader = new FileUploader({
            url: config.api + 'api/emphcticket/uploadReply',
            removeAfterUpload: true,
            alias: 'fileName',
            onSuccessItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                vm.answer = '';
                vm.isChecked = false;
                loadTiketDetail();//sendEmail
                if (vm.needSendMail) {
                    // vm.Form.objForm.title = data.title;
                    // vm.Form.objForm.mailTo = vm.mailTo;
                    // Form.saveData('sendMail', frm, Tiket);
                    // setTimeout(function () {
                    var promise = Auth.setToken();
                    promise.then(function () {
                        vm.objForm = new Tiket();
                        vm.objForm.action = 'sendMail';
                        //set value
                        vm.objForm.title = data.title;
                        vm.objForm.mailTo = vm.mailTo;
                        vm.objForm.$save();
                        var response = vm.objForm.$save();
                        response.then(function (data) {
                            Auth.setToken()
                        });
                        response.catch(function (data) {
                            Auth.setToken()
                        });
                    });
                    // }, 2000);
                }

            }, onErrorItem: function (item, response, status, headers) {
                angular.element.unblockUI();
            }
        });

        function delegateToSysdev(item, status) {
            angular.element.blockUI();
            var ev = "";
            var objForm = new Tiket();
            objForm.action = 'delegateToSysdev';
            objForm.id = item.id;
            objForm.status = status;
            var response = objForm.$save();
            response.then(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data);
            });
            response.catch(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data.data);
            });
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.emp-sales-code')
    .controller('EmpSalesCodeController', EmpSalesCodeController);

  EmpSalesCodeController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function EmpSalesCodeController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpSalesCode();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.viewDetail = viewDetail;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.getArea = loadArea;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      loadArea();
    }

    function loadArea() {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listArea = data;
    }

    function errorFetchArea() {
      vm.listArea = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        startDate: vm.start_date,
        endDate: vm.end_date,
        area: vm.area,
        sales_code: vm.Form.objForm.ref_sales_code_id,
        nik: vm.Form.objForm.empno
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'EmpSalesCodeInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-sales-code/emp-sales-code-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewEmpSalesCodetDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-sales-code/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'EmpSalesCodeEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-sales-code/emp-sales-code-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    getSalesCode();
    function getSalesCode() {
      var response = endPoint.query({ action: 'getSalesCode' });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-sales-code')
    .controller('EmpSalesCodeInputController', EmpSalesCodeInputController);

  EmpSalesCodeInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$filter',
    '$http',
    '$element',
    'config'
  ];
  /** @ngInject */
  function EmpSalesCodeInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $filter,
    $http,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpSalesCode();
    var salesCode = AppAPI.RefSalesCode();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.selectedItemChangedAss = selectedItemChangedAss;
    vm.getEmployee = getEmployee;

    vm.Form.objForm.sales_behaviour = 'REAL';

    activate();
    getSalesCode();
    getSalesBehaviour();

    function getSalesCode() {
      var response = endPoint.query({ action: 'getSalesCode' });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    function getSalesBehaviour() {
      var response = salesCode.query({ action: 'getSalesBehaviour' });
      response.$promise.then(fetchSalesBehaviour);
      response.$promise.catch(errorFetchSalesBehaviour);
    }

    function fetchSalesBehaviour(data) {
      vm.listSalesBehaviour = data;
    }

    function errorFetchSalesBehaviour() {
      vm.listSalesBehaviour = [];
    }

    function getAreaSales() {
      var response = endPoint.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function selectedItemChangedAss(employee) {
      vm.Form.objForm.nik_ass = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchStringAss;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.nik_ass = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      vm.selected = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-sales-code')
    .controller('EmpSalesCodeEditController', EmpSalesCodeEditController);

  EmpSalesCodeEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function EmpSalesCodeEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpSalesCode();
    var salesCode = AppAPI.RefSalesCode();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.selectedItemChangedAss = selectedItemChangedAss;
    vm.getEmployee = getEmployee;

    activate();
    getSalesCode();
    getSalesBehaviour();

    function getSalesBehaviour() {
      var response = salesCode.query({ action: 'getSalesBehaviour' });
      response.$promise.then(fetchSalesBehaviour);
      response.$promise.catch(errorFetchSalesBehaviour);
    }

    function fetchSalesBehaviour(data) {
      vm.listSalesBehaviour = data;
    }

    function errorFetchSalesBehaviour() {
      vm.listSalesBehaviour = [];
    }
    function getSalesCode() {
      var response = endPoint.query({ action: 'getSalesCode' });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }


    function selectedItemChangedAss(employee) {
      vm.Form.objForm.nik_ass = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchStringAss;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.nik_ass = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.nik = data.nik + ' - ' + data.name;
      vm.Form.objForm.sales_behaviour = data.sales_behaviour;
      vm.Form.objForm.empno = data.nik;
      vm.Form.objForm.nik_ass = data.nik_ass;
      vm.Form.objForm.nikass = data.nik_ass + ' - ' + data.ass_name;
      vm.Form.objForm.nik_upd = data.nik;
      vm.Form.objForm.nik_ass_upd = data.nik_ass;
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.start_date = new Date(data.start_date);
      vm.Form.objForm.end_date = new Date(data.end_date);
      vm.Form.objForm.ref_sales_code_id = data.ref_sales_code_id;
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();
(function () {
    'use strict';

    angular
        .module('app.emp-subdis', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.emp-subdis', {
                url: '/emp-subdis',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/emp-subdis/emp-subdis.html',
                        controller: 'EmpSubdisController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-subdis')
    .controller('EmpSubdisController', EmpSubdisController);

  EmpSubdisController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function EmpSubdisController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpSubdis();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.viewDetail = viewDetail;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.getArea = loadArea;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      loadArea();
    }

    function loadArea() {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listAreaSales = data;
    }

    function errorFetchArea() {
      vm.listAreaSales = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        startDate: vm.start_date,
        endDate: vm.end_date,
        area: vm.area,
        sales_code: vm.Form.objForm.ref_sales_code_id,
        nik: vm.Form.objForm.empno
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'EmpSubdisInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-subdis/emp-subdis-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewEmpSubdistDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-subdis/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'EmpSubdisEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-subdis/emp-subdis-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsubdis?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    getSubdis();
    function getSubdis() {
      var response = endPoint.query({ action: 'getSubdis' });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSubdis = data;
    }

    function errorFetchSalesCode() {
      vm.listSubdis = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-subdis')
    .controller('EmpSubdisInputController', EmpSubdisInputController);

  EmpSubdisInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$filter',
    '$http',
    '$element',
    'config'
  ];
  /** @ngInject */
  function EmpSubdisInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $filter,
    $http,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpSubdis();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;

    vm.Form.objForm.sales_behaviour = 'VIRTUAL';

    activate();
    getSubdis();
    loadArea();

    function loadArea() {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listAreaSales = data;
    }

    function errorFetchArea() {
      vm.listAreaSales = [];
    }

    function getSubdis() {
      var response = endPoint.query({ action: 'getSubdis' });
      response.$promise.then(fetchSubdis);
      response.$promise.catch(errorFetchSubdis);
    }

    function fetchSubdis(data) {
      vm.listSubdis = data;
    }

    function errorFetchSubdis() {
      vm.listSubdis = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      vm.selected = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsubdis?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-subdis')
    .controller('EmpSubdisEditController', EmpSubdisEditController);

  EmpSubdisEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function EmpSubdisEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpSubdis();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;

    activate();
    getSubdis();
    loadArea();

    function loadArea() {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listAreaSales = data;
    }

    function errorFetchArea() {
      vm.listAreaSales = [];
    }

    function getSubdis() {
      var response = endPoint.query({ action: 'getSubdis' });
      response.$promise.then(fetchSubdis);
      response.$promise.catch(errorFetchSubdis);
    }

    function fetchSubdis(data) {
      vm.listSubdis = data;
    }

    function errorFetchSubdis() {
      vm.listSubdis = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.nik = data.nik + ' - ' + data.name;
      vm.Form.objForm.empno = data.nik;
      vm.Form.objForm.nik_upd = data.nik;
      vm.Form.objForm.nik_ass_upd = data.nik_ass;
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.ref_subdis_id = data.ref_subdis_id;
      vm.Form.objForm.area_sales_id = data.area_sales_id;
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsubdis?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();
(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.emp-appraisal', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.emp-appraisal', {
        url: '/emp-appraisal',
        views: {
          'content@app': {
            templateUrl: 'app/main/emp-appraisal/emp-appraisal.html',
            controller: 'EmpAppraisalController as vm'
          }
        }
      });
  }
}());
(function () {
  'use strict';
  angular
    .module('app.emp-appraisal')
    .controller('UploadEmpAppraisalController', UploadEmpAppraisalController);

  UploadEmpAppraisalController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadEmpAppraisalController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/empappraisal/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/empappraisal/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';

  angular
    .module('app.emp-appraisal')
    .controller('InputEmpAppraisalController', InputEmpAppraisalController);

  InputEmpAppraisalController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter'];

  /* @ngInject */
  function InputEmpAppraisalController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;

    Form.initialForm();

    var EmpAppraisal = AppAPI.EmpAppraisal();

    // set constructor form
    Form.setObject(EmpAppraisal);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.saveData = saveData;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;

    vm.Form.objForm.empno = '';
    vm.Form.objForm.effective_date = new Date();

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;
      }
    }

    vm.LoadCompany = LoadCompany;
    vm.Form.objForm.country = $localStorage.country;
    vm.Form.objForm.company = $localStorage.empsite

    LoadCompany();
    getType();

    function LoadCompany() {
      var KPI = AppAPI.teamMember();
      var response = KPI.query({
        action: 'viewBu'
      });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listcompany = data;
    }

    function errorFetchBU() {
      vm.listcompany = [];
    }

    function getType() {
      var response = EmpAppraisal.query({
        action: 'getTypes'
      });
      response.$promise.then(fetchType);
      response.$promise.catch(errorFetchType);
    }

    function fetchType(data) {
      vm.listType = data;
    }

    function errorFetchType() {
      vm.listType = [];
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empappraisal?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            Form.objForm.empno = '';
          }
          return item.data;
        });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, EmpAppraisal);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    $scope.isDisabled = true;
  }
})();
(function () {
    'use strict';

    angular
        .module('app.emp-appraisal')
        .controller('EmpAppraisalController', EmpAppraisalController);

    EmpAppraisalController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function EmpAppraisalController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var EmpAppraisal = AppAPI.EmpAppraisal();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();


        Form.setObject(EmpAppraisal);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputEmpAppraisal = inputEmpAppraisal;
        vm.lisEmpAppraisalSelected = [];
        vm.arr_area = [];
        vm.DeleteEmpAppraisal = DeleteEmpAppraisal;
        vm.editEmpAppraisal = editEmpAppraisal;
        vm.openUpload = openUpload;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.company = $localStorage.empsite
        vm.country = $localStorage.country;
        vm.type = 'all';

        LoadCompany();
        getType();

        function loadData(pageno) {
            var nik = '';
            var company = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;

            vm.DataTable.loadData(EmpAppraisal, pageno, {
                action: 'viewdata',
                nik: nik,
                country: vm.country,
                company: vm.company,
                effective_date: vm.Form.objForm.effective_date,
                type: vm.type,
            });
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empappraisal?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var KPI = AppAPI.teamMember();
            var response = KPI.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listcompany = data;
        }

        function errorFetchBU() {
            vm.listcompany = [];
        }

        function getType() {
            var response = EmpAppraisal.query({
                action: 'getTypes'
            });
            response.$promise.then(fetchType);
            response.$promise.catch(errorFetchType);
        }

        function fetchType(data) {
            vm.listType = data;
        }

        function errorFetchType() {
            vm.listType = [];
        }

        function inputEmpAppraisal(ev) {
            $mdDialog.show({
                controller: 'InputEmpAppraisalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/emp-appraisal/input-emp-appraisal.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editEmpAppraisal(ev, id) {
            $mdDialog.show({
                controller: 'EditEmpAppraisalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/emp-appraisal/input-emp-appraisal.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisEmpAppraisalSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisEmpAppraisalSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteEmpAppraisal(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = EmpAppraisal.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisEmpAppraisalSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadEmpAppraisalController as vm',
                templateUrl: 'app/main/emp-appraisal/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.emp-appraisal')
        .controller('EditEmpAppraisalController', EditEmpAppraisalController);

    EditEmpAppraisalController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', 'config', '$http', '$filter'];

    /* @ngInject */
    function EditEmpAppraisalController($localStorage, id, $mdDialog, Form, AppAPI, config, $http, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var EmpAppraisal = AppAPI.EmpAppraisal();

        // set constructor form
        Form.setObject(EmpAppraisal);
        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.saveData = saveData;
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        function selectedItemChanged(employee) {
            console.log("masuk")
            vm.Form.objForm.nikemp = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined' && employee !== null) {
                vm.Form.objForm.nikemp = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        vm.Form.objForm.id = id.id;
        vm.Form.objForm.country = $localStorage.country;
        vm.Form.objForm.company = id.company;
        vm.Form.objForm.type = id.type;
        vm.Form.objForm.effective_date = new Date(id.effective_date);
        vm.Form.objForm.nik = id.nik + ' - ' + id.emp_name;
        vm.Form.objForm.nikemp = id.nik;
        vm.Form.objForm.ganteng = id.nik;
        console.log(vm.Form.objForm);

        LoadCompany();
        getType();

        function LoadCompany() {
            var KPI = AppAPI.teamMember();
            var response = KPI.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listcompany = data;
        }

        function errorFetchBU() {
            vm.listcompany = [];
        }

        function getType() {
            var response = EmpAppraisal.query({
                action: 'getTypes'
            });
            response.$promise.then(fetchType);
            response.$promise.catch(errorFetchType);
        }

        function fetchType(data) {
            vm.listType = data;
        }

        function errorFetchType() {
            vm.listType = [];
        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empappraisal?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.nikemp = '';
                    }
                    return item.data;
                });
        }

        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, EmpAppraisal);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                errorDialog(data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
  angular.module('app.elearning.practicalearning', ['ngMaterial', 'ngMessages']).config(config);
  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      .state('app.practicalearning', {
        url: '/elearning/practicalearning',
        views: {
          'content@app': {
            templateUrl: 'app/main/elearning/practicalearning/practicalearning.html',
            controller: 'PracticalearningController as vm'
          }
        }
      })
      .state('app.practicalearning_detail', {
        url: '/elearning/practicalearning/detail/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/elearning/practicalearning/practicalearning-detail.html',
            controller: 'PracticalearningdetailController as vm'
          }
        }
      });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.elearning.practicalearning')
    .controller('PracticalearningController', PracticalearningController);

  PracticalearningController.$inject = [
    "AppAPI",
    "DataService",
    "config",
    "$localStorage",
    "$state",
    "$location",
    "$window"
  ];

  function PracticalearningController(
    AppAPI,
    DataService,
    config,
    $localStorage,
    $state,
    $location,
    $window
  ) {
    var vm = this;
    var endpoint = AppAPI.Elearning();
    vm.listSelected = [];
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = viewData;
    vm.viewDetail = viewDetail;
    vm.DataTable = new DataService();

    viewData();

    function viewData(pageno) {
      angular.element.blockUI();
      vm.DataTable.loadData(endpoint, pageno, {
        action: 'viewdata',
      });
      angular.element.unblockUI();

    }

    function viewDetail(id) {
      $state.go("app.practicalearning_detail", {
        id: id,
      });
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.elearning.practicalearning')
    .controller('PracticalearningdetailController', PracticalearningdetailController);

  PracticalearningdetailController.$inject = [
    "$stateParams",
    "$state",
    "$mdDialog",
    "Auth",
    "AppAPI"
  ];

  function PracticalearningdetailController(
    $stateParams,
    $state,
    $mdDialog,
    Auth,
    AppAPI
  ) {
    var vm = this;
    var endpoint = AppAPI.Elearning();
    vm.back = back;
    vm.approve = approve;

    viewData();

    function viewData() {
      angular.element.blockUI();
      var RequestPromise = endpoint.get({
        action: "getDetail",
        id: $stateParams.id
      });
      RequestPromise.$promise.then(fetchDataRequest);
      RequestPromise.$promise.catch(errorFetchRequest);
    }

    function fetchDataRequest(data) {
      vm.personalInformation = data.empModulePool;
      vm.competenciesList = data.competenciesList;
      vm.modulePoolList = data.modulePoolList;
      vm.skillIndicatorList = data.skillIndicatorList;
      angular.element.unblockUI();
    }

    function errorFetchRequest() {
      vm.request = [];
      angular.element.unblockUI();
    }

    function back() {
      $state.go("app.practicalearning", {});
    }

    function approve(data, job_code, nik, el_module_pool_id) {
      angular.element.blockUI();
      var promiseAuth = Auth.setToken();

      promiseAuth.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Give an assessment')
          .textContent('This practice will be pass.')
          .ariaLabel('eccept dialog')
          .ok('Yes')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = endpoint.save({
            action: 'approve',
            competency: data,
            job_code: job_code,
            nik: nik,
            el_module_pool_id: el_module_pool_id
          });

          response.$promise.then(function (data) {
            angular.element.unblockUI();
            var confirm = $mdDialog.confirm()
              .title('Success.!')
              .textContent(data.pesan)
              .ariaLabel('Lucky day')
              .ok('Close');

            $mdDialog.show(confirm).then(function () {
              $mdDialog.cancel();
              viewData();
            }, function () {
              alert("cancel");
              viewData();
            });
          });
          angular.element.unblockUI();

        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.echeckin', [])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider'];
   /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
        .state('app.echeckin', {
            url    : '/echeckin',
            abstract:true,
            views  : {
                'main@' : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.echeckin': {
                    templateUrl: 'app/main/echeckin/echeckin.html',
                    controller:'EcheckinController as vm'
                }
            }
        })
        .state('app.echeckin.dashboard',{
            url :'/dashboard',
            templateUrl:'app/main/echeckin/dashboard/dashboard.html',
            controller:'DashboardController',
            controllerAs:'vm'
        })
        .state('app.echeckin.profile',{
            url :'/profile',
            templateUrl:'app/main/echeckin/profile/profile.html',
            controller:'ProfileController',
            controllerAs:'vm'
        })
        .state('app.echeckin.pendidikan',{
            url :'/pendidikan',
            templateUrl:'app/main/echeckin/pendidikan/pendidikan.html',
            controller:'PendidikanController',
            controllerAs:'vm'
        })
        .state('app.echeckin.bahasa',{
            url :'/bahasa',
            templateUrl:'app/main/echeckin/bahasa/bahasa.html',
            controller:'BahasaController',
            controllerAs:'vm'
        })
        .state('app.echeckin.training',{
            url :'/training',
            templateUrl:'app/main/echeckin/training/training.html',
            controller:'TrainingController',
            controllerAs:'vm'
        })
        .state('app.echeckin.alamat',{
            url :'/alamat',
            templateUrl:'app/main/echeckin/alamat/alamat.html',
            controller:'AlamatController',
            controllerAs:'vm'
        })
        .state('app.echeckin.pengalaman-kerja',{
            url :'/pengalaman-kerja',
            templateUrl:'app/main/echeckin/pengalamankerja/pengalaman-kerja.html',
            controller:'PengalamankerjaController',
            controllerAs:'vm'
        })
        .state('app.echeckin.keluarga',{
            url :'/keluarga',
            templateUrl:'app/main/echeckin/keluarga/keluarga.html',
            controller:'KeluargaController',
            controllerAs:'vm'
        })
        .state('app.echeckin.bank',{
            url :'/bank',
            templateUrl:'app/main/echeckin/bank/bank.html',
            controller:'EbankController',
            controllerAs:'vm'
        })
        .state('app.echeckin.pajak',{
            url :'/pajak',
            templateUrl:'app/main/echeckin/pajak/pajak.html',
            controller:'PajakController',
            controllerAs:'vm'
        })
        .state('app.echeckin.info-gawat',{
            url :'/info-gawat',
            templateUrl:'app/main/echeckin/info-gawat/info-gawat.html',
            controller:'InfogawatController',
            controllerAs:'vm'
        })
        .state('app.echeckin.ijazah',{
            url :'/ijazah-transkrip',
            templateUrl:'app/main/echeckin/ijazah/ijazah.html',
            controller:'IjazahController',
            controllerAs:'vm'
        })
        .state('app.echeckin.dokumen',{
            url :'/dokumen',
            templateUrl:'app/main/echeckin/dokumen/dokumen.html',
            controller:'DokumenController',
            controllerAs:'vm'
        })
        .state('app.echeckin.helpdesk',{
            url :'/helpdesk',
            templateUrl:'app/main/echeckin/helpdesk/form.html',
            controller:'HelpdeskController',
            controllerAs:'vm'
        }); 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('TrainingController', TrainingController);


    TrainingController.$inject = ['$state', '$stateParams', '$document', '$localStorage', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'Echeckin', '$filter'];
    /** @ngInject */
    function TrainingController($state, $stateParams, $document, $localStorage, $mdDialog, Auth, Form, AppAPI, Echeckin, $filter) {

        var vm = this;

        var translate = $filter('translate');
        // vm.activeItem = [{
        //     label: 'Training',
        //     link: 'app.employee_employe_edit.training'
        // }];



        var Training = AppAPI.Training();



        Echeckin.breadcrumb = [
            {
                state: 'app.echeckin.dashboard',
                name: 'Halaman Depan',
                active: 0

            },
            {
                state: '',
                name: 'Training',
                active: 1

            }
        ];



        vm.openInputTraining = openInputTraining;
        vm.editInputTraining = editInputTraining;


        vm.listData = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.deleteData = deleteData;

        var empID = $localStorage.username;
        vm.goBack = goBack;


        viewData();

        function goBack() {
            $state.go('app.echeckin.dashboard');
        }

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Training.query({ action: 'viewData', emp_id: empID });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            console.log(div);

            div.isChecked = !div.isChecked;
        }


        function openInputTraining(ev) {
            $mdDialog.show({
                controller: 'InputtrainingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/training/inputtraining.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });
        }

        function editInputTraining(ev, id) {
            $mdDialog.show({
                controller: 'EdittrainingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/training/inputtraining.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    id: id
                },
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Training.delete({ action: 'deletetraining', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                }, function () {

                });
            });


        }

    }
})();  

(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('InputtrainingController', InputtrainingController);


    InputtrainingController.$inject = ['$stateParams', '$document', '$localStorage', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'Echeckin', 'FileUploader', 'config', '$filter'];
    /** @ngInject */
    function InputtrainingController($stateParams, $document, $localStorage, $mdDialog, Auth, Form, AppAPI, Echeckin, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        // vm.activeItem = [{
        //     label: 'Training',
        //     link: 'app.employee_employe_edit.training'
        // }];

        // initial form
        Form.initialForm();


        var Training = AppAPI.Training();

        // set constructor form
        Form.setObject(Training);

        // set form to controller
        vm.Form = Form;



        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.upload = upload;
        vm.sizefile = 0;

        var empID = $localStorage.username;
        vm.chnageStartDate = chnageStartDate;
        vm.changeCertificate = changeCertificate;
        vm.Form.objForm.empId = $localStorage.username;
        vm.cert = false;

        /////////////////////////////

        function changeCertificate() {

            if (vm.Form.objForm.isCertificate == 1) {
                vm.cert = true;
            } else {
                vm.cert = false;
            }

        }

        function chnageStartDate() {
            var sS = new Date(vm.Form.objForm.startDate);
            var year = sS.getFullYear();
            var month = sS.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }

            var date = sS.getDate();
            var sD = year + '-' + month + '-' + date;
            vm.minDate = new Date(sD);
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.empId = window.atob(decodeURIComponent(empID));
            vm.Form.objForm.isCertificate = 0;
            var promise = Form.saveData('save', formController, Training);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            }).catch(function (data) {
                showDialogInfo(ev, data.data);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function upload() {
            var resp = vm.FileUploaderPhoto.uploadAll();
            console.log(resp);
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/training/uploadsertifikat',
            removeAfterUpload: true,
            alias: 'image',
            onBeforeUploadItem: function (item) {
                var dt = new Date(item.formData[0].startDate);
                var et = new Date(item.formData[0].finishDate);
                // console.log(item);

                var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                var newdate1 = dt.getFullYear() + '-' + (et.getMonth() + 1) + '-' + et.getDate();
                item.formData[0].start_date = newdate;
                item.formData[0].end_date = newdate1;
                vm.Form.objForm.startDate = newdate;
                vm.Form.objForm.finishDate = newdate1;
                angular.element.blockUI();

            },
            formData: [
                vm.Form.objForm
            ],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
                angular.element.unblockUI();
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            },
            onSuccessItem: function (item, response, status, headers) {
                if (response.error) {
                    vm.message = {
                        ariaLabel: 'Upload file has been failed',
                        textContent: response.pesan
                    }
                } else {
                    vm.message = {
                        ariaLabel: 'Upload file has been successfully',
                        textContent: response.pesan
                    }
                }
                showDialog();
                $timeout(function () {
                    vm.notif.error = false;
                    vm.notif.success = false;
                    vm.Form.objForm = {};
                }, 3000);
                angular.element.unblockUI();
            },
            onError: function () {
                vm.notif.error = 'Internal server error'
                vm.notif.success = false;
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            }
        });

        uploaderPhoto.filters.push({
            name: 'syncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                vm.sizefile = item.size;
                // console.log(vm.sizefile); 
                return true;
            }
        });

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();  

(function () {
	'use strict';

	angular
		.module('app.echeckin')
		.controller('EdittrainingController', EdittrainingController);

	/** @ngInject */
	EdittrainingController.$inject = ['$mdDialog', 'id', 'AppAPI', 'Auth', 'Form', '$filter'];
	/** @ngInject */
	function EdittrainingController($mdDialog, id, AppAPI, Auth, Form, $filter) {
		var vm = this;

		var translate = $filter('translate');

		// initial form
		Form.initialForm();

		// get constructor form
		var Training = AppAPI.Training();

		// set constructor form
		Form.setObject(Training);

		// set form to controller
		vm.Form = Form;

		var response = vm.Form.objForm.$get({ action: 'viewDetail', id: id.id });
		response.then(changeDate);

		vm.closeModal = closeModal;
		vm.id = id;
		vm.saveData = saveData;
		vm.setToken = Auth.setToken;

		vm.messageTheme = 'pink';


		function changeDate(data) {
			vm.Form.objForm.startDate = new Date(data.start_date);
			vm.Form.objForm.finishDate = new Date(data.finish_date);
			vm.Form.objForm.specificationOfTraining = data.specification_of_training;
			vm.Form.objForm.isCertificate = data.is_certificate;
			vm.Form.objForm.typeOfTraining = data.type_of_training;
		}

		function closeModal() {
			$mdDialog.hide();
		}

		/*	    function saveData(ev,formController) {
					Form.objForm.id=id.id;
					var promise= Form.saveData('updatetraining', formController, Employe);
					promise.then(function(){
						showDialog(ev);
					});
				}
		*/
		function saveData(ev, formController) {
			var promise = Form.saveData('update', formController, Training);
			promise.then(function (data) {
				showDialogInfo(ev, data);
			}).catch(function (data) {
				showDialogInfo(ev, data.data);
			});
		}

		function showDialog(ev) {
			$mdDialog.show(
				$mdDialog.alert()
					.parent(angular.element(document.querySelector('#contentDialog')))
					.clickOutsideToClose(true)
					.title('Success Save Data')
					.textContent('Process Data was Success.')
					.ariaLabel('Success Save Data')
					.ok('OK')
					.targetEvent(ev)
			).then(function () {
				closeModal();
			});
		}

		function showDialogInfo(ev, data) {
			var message = translate(data.pesan);
			var status = translate(data.status);
			$mdDialog
				.show(
					$mdDialog
						.alert()
						.parent(angular.element(document.querySelector('#contentDialog')))
						.clickOutsideToClose(true)
						.title(status)
						.textContent(message)
						.ariaLabel(status)
						.ok('OK')
						.targetEvent(ev)
				)
				.then(function () {
					dialogClose();
				});
		}

		function dialogClose() {
			$mdDialog.hide();
		}
	}

})();  

(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('ProfileController', ProfileController);

   ProfileController.$inject = ['$localStorage','$window','$timeout','$document','$mdDialog','Echeckin','Form','AppAPI','Auth','config','FileUploader'];

    /* @ngInject */
    function ProfileController($localStorage,$window,$timeout,$document,$mdDialog,Echeckin,Form,AppAPI,Auth,config,FileUploader) {
        var vm = this;
        Echeckin.breadcrumb=[
          {
          	state:'app.echeckin.dashboard',
        	name:'Halaman Depan',
        	active:0
          },
          {
          	state:'',
        	name:'Profil',
        	active:1
          }
        ];

        Form.initialForm();

        vm.stateEdit=false;

        vm.closeModal=closeModal;
        vm.goNav=goNav;
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;
        vm.upload = upload;

        vm.ChangeState=ChangeState;
        vm.saveData=saveData;
        vm.openUploadPhoto=openUploadPhoto;
        vm.fullname = '';
        vm.listCountry = [];
        vm.changeTitle=changeTitle;

         // get constructor form
        var profiles=AppAPI.Profiles();

         // set constructor form
        Form.setObject(profiles);

        // set form to controller
        vm.Form = Form; 
        
        // set token
        vm.setToken=Auth.setToken;

        vm.Form.objForm.photo_address = '';

        var empID=$localStorage.username;

        // vm.title = ['Mr','Mrs','Miss','Ms'];
        vm.bloods = ['A', 'AB', 'B', 'O'];
        vm.maritalStatuses = [{id:'Lajang',value:'Belum Menikah'},
                              {id:'Menikah',value:'Menikah'},
                              {id:'Duda',value:'Duda'},
                              {id:'Janda',value:'Janda'}];
        vm.messageTheme='green'; 
        loadData();
        LoadCountry();

        function loadData()
        {
            var response=vm.Form.objForm.$get({action:'viewdetail',id:empID});
            response.then(changeDate);
        }

        function LoadCountry() 
        {
            var response=profiles.query({action:'getCountry'});
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
        vm.listCountry=data;
        }

        function errorFetchCountry() {
        vm.listCountry=[];
        } 

        function ChangeState()
        {
          switch(vm.stateEdit){
            case true:
              vm.stateEdit=false;
              break;
            case false:
              vm.stateEdit=true;
              break;
          }
        }

        function changeDate(data) {
           vm.Form.objForm.dateOfBirth=new Date(data.dateOfBirth);
           vm.Form.objForm.dateJoin=new Date(data.dateJoin);
           if (data.lastName == null && data.middleName == null) {
                vm.fullname = data.firstName;
            } else if (data.middleName == null) {
                vm.fullname = data.firstName+' '+data.lastName;
            } else {
                vm.fullname = data.firstName+' '+data.middleName+' '+data.lastName;
            }
            if(data.nationality == null) {
                data.nationality = '';
            }
            if (data.countrycode_of_birth == null) {
              data.countrycode_of_birth = '';
            }

            vm.Form.objForm.countrycode_of_birth = data.countrycode_of_birth
            // console.log(vm.Form.objForm.empExp);
            vm.Form.objForm.empExp=(data.empExp=='1')?true:false;
            vm.Form.objForm.acc_mandiri=(data.acc_mandiri=='1')?true:false;
            vm.Form.objForm.empSim=(data.empSim=='1')?true:false;
            vm.Form.objForm.jamsostek=(data.jamsostek=='1')?true:false;
            vm.Form.objForm.npwp=(data.npwp=='1')?true:false;
            vm.Form.objForm.bpjs=(data.bpjs=='1')?true:false;
        }

        function saveData(formController)
        {
            angular.element.blockUI();

            var str = vm.fullname;
            var words = str.split(" ");
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            if (words.length >= 3) {
                vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                vm.Form.objForm.middleName = words[1].replace(/\s/g, '');
                vm.Form.objForm.lastName = str.substring(words[0].length+words[1].length);
            } else if (words.length == 2) {
                vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                vm.Form.objForm.middleName = null;
                vm.Form.objForm.lastName = words[1].replace(/\s/g, '');
            } else {
                vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
                vm.Form.objForm.middleName = null;
                vm.Form.objForm.lastName = null;
            }
  
            var resp=Form.updateData('updatedata',formController,profiles,empID,'viewdetail');
             resp.then(function(){
                 vm.messageTheme='blue';
                 angular.element.unblockUI();
                 formController.$setPristine();
                 vm.Form.objForm.dateOfBirth=new Date(vm.Form.objForm.dateOfBirth);
                 $timeout(function() {
                     vm.Form.tampilPesan=false; 
                     vm.stateEdit=false; 
                     loadData();
                 }, 3000);

             });

            resp.catch(function(){
               vm.messageTheme='pink';
                angular.element.unblockUI();

           });
        }
        loadCountry();
        function loadCountry()
        {
          var respose=profiles.query({action:'getCountry'});
        }

        function openUploadPhoto(ev)
        {
            $mdDialog.show({
                controller         : 'ProfileController as vm',
                templateUrl        : 'app/main/echeckin/profile/upload-photo.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                onRemoving:function(element, removePromise)
                {
                   loadData();
                   LoadCountry();
                }
            });
        }

        function upload()
        {
          var resp=vm.FileUploaderPhoto.uploadAll();
        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/employe/uploadPhoto', 
           removeAfterUpload:true,
           alias:'profilephoto',
           formData:[
              {
               action:'uploadPhoto'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
            closeModal();
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        };

        function goNav(state) {
            $state.go(state);
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function changeTitle()
        {
          var title=vm.Form.objForm.title;
          switch(title)
          {
            case 'Mr':
              vm.Form.objForm.jenkel='L';
            break;
            default:
              vm.Form.objForm.jenkel='P';
            break;
          }
          // console.log(title);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('PengalamankerjaController', PengalamankerjaController);


    PengalamankerjaController.$inject = ['$state', '$localStorage', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'Echeckin', '$filter'];
    /** @ngInject */
    function PengalamankerjaController($state, $localStorage, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, Echeckin, $filter) {

        var vm = this;

        var translate = $filter('translate');

        var Experience = AppAPI.Experience();

        var empID = $localStorage.username;



        Echeckin.breadcrumb = [
            {
                state: 'app.echeckin.dashboard',
                name: 'Halaman Depan',
                active: 0

            },
            {
                state: '',
                name: 'Pengalaman Kerja',
                active: 1

            }
        ];

        vm.goBack = goBack;





        vm.openInputEducation = openInputEducation;
        vm.editInputEducation = editInputEducation;


        vm.listData = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];


        vm.deleteData = deleteData;

        viewData();


        function viewData() {
            angular.element.blockUI();
            var dataPromise = Experience.query({ action: 'viewData', emp_id: empID });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function goBack() {
            $state.go('app.echeckin.dashboard');
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            console.log(div);

            div.isChecked = !div.isChecked;
        }


        function openInputEducation(ev) {
            $mdDialog.show({
                controller: 'InputpengalamanController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/pengalamankerja/inputpengalamankerja.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });


        }

        function editInputEducation(ev, id) {
            $mdDialog.show({
                controller: 'EditpengalamanController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/pengalamankerja/inputpengalamankerja.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    id: id
                }
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Experience.delete({ action: 'deleteexperience', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                    // response.$promise.then(function (resp) {
                    //     angular.element.unblockUI();
                    //     showDialogInfo(ev, resp);
                    // });
                }, function () {

                });
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();  

(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('InputpengalamanController', InputpengalamanController);

    InputpengalamanController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$filter'];

    /* @ngInject */
    function InputpengalamanController($localStorage, $mdDialog, Form, AppAPI, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Experience = AppAPI.Experience();

        // set constructor form
        Form.setObject(Experience);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;


        var empID = $localStorage.username;
        vm.chnageStartDate = chnageStartDate;


        ////////////////

        function chnageStartDate() {
            var sS = new Date(vm.Form.objForm.startDate);
            var year = sS.getFullYear();
            var month = sS.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }

            var date = sS.getDate();
            var sD = year + '-' + month + '-' + date;
            vm.minDate = new Date(sD);
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.empId = window.atob(decodeURIComponent(empID));
            var promise = Form.saveData('save', formController, Experience);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });
            promise.catch(function (data) {
                showDialogInfo(ev, data.data);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('EditpengalamanController', EditpengalamanController);

    EditpengalamanController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$filter'];

    /* @ngInject */
    function EditpengalamanController($localStorage, id, $mdDialog, Form, AppAPI, $filter) {
        var vm = this;

        var translate = $filter('translate');
        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Experience = AppAPI.Experience();

        // set constructor form
        Form.setObject(Experience);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.chnageStartDate = chnageStartDate;


        var empID = $localStorage.username;

        var response = vm.Form.objForm.$get({ action: 'viewDetail', id: id.id });
        response.then(changeDate);


        ////////////////

        function chnageStartDate() {
            var sS = new Date(vm.Form.objForm.startDate);
            var year = sS.getFullYear();
            var month = sS.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }

            var date = sS.getDate();
            var sD = year + '-' + month + '-' + date;
            vm.minDate = new Date(sD);
        }


        function changeDate(data) {
            vm.Form.objForm.startDate = new Date(data.start_date);
            vm.Form.objForm.finishDate = new Date(data.finish_date);
            vm.Form.objForm.companyName = data.company_name;
            vm.Form.objForm.departmentName = data.department_name;
            vm.Form.objForm.sectionName = data.section_name;
            vm.Form.objForm.jobDescription = data.job_description;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, Experience);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });
            promise.catch(function (data) {
                showDialogInfo(ev, data.data);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('PendidikanController', PendidikanController);


    PendidikanController.$inject = ['$state', '$localStorage', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'Echeckin', '$http', 'config', '$filter'];
    /** @ngInject */
    function PendidikanController($state, $localStorage, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, Echeckin, $http, config, $filter) {

        var vm = this;

        var translate = $filter('translate');

        var Education = AppAPI.Education();

        var empID = $localStorage.username;

        Echeckin.breadcrumb = [
            {
                state: 'app.echeckin.dashboard',
                name: 'Halaman Depan',
                active: 0

            },
            {
                state: '',
                name: 'Pendidikan',
                active: 1

            }
        ];


        vm.openInputEducation = openInputEducation;
        vm.editInputEducation = editInputEducation;
        vm.openInputIjazah = openInputIjazah;
        vm.editInputIjazah = editInputIjazah;
        vm.viewIjazahDoc = viewIjazahDoc;
        vm.downloadDoc = downloadDoc;
        vm.closeModal = closeModal;
        vm.goBack = goBack;


        vm.listData = [];
        vm.listIjazah = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];


        vm.deleteData = deleteData;

        viewData();
        // viewIjazah();

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Education.query({ action: 'viewData', emp_id: empID });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            angular.element.unblockUI();
            vm.listData = data[0].data;
            // console.log(data);
            vm.id_ijazah = data[0].id_ijazah;
            vm.id_transkrip = data[0].id_transkrip;
            if (data[0].ijazah.slice(-3) === 'pdf') {
                vm.doc_type = true;
                vm.url = 'api/empdocument/' + data[0].ijazah + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
                vm.ijazah = data[0].ijazah;
            } else {
                vm.ijazah = data[0].ijazah;
                vm.doc_type = false;
            }

            if (data[0].transkrip.slice(-3) === 'pdf') {
                vm.doc_type = true;
                vm.urll = 'api/empdocument/' + data[0].transkrip + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
                vm.transkrip = data[0].transkrip;
            } else {
                vm.transkrip = data[0].transkrip;
                vm.doc_type = false;
            }
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        // function viewIjazah() {
        //     angular.element.blockUI();
        //     var dataPromise = Document.query({action:'viewData',emp_id:empID,type:'ijazah'});
        //     dataPromise.$promise.then(fetchIjazah);
        //     dataPromise.$promise.catch(errorFetchIjazah); 
        //  }

        //  function fetchIjazah(data) {
        //      vm.listIjazah = data;
        //      angular.element.unblockUI();
        //      console.log(vm.listIjazah);
        //  }

        //  function errorFetchIjazah() {
        //      vm.listIjazah = [];
        //      angular.element.unblockUI();
        //  }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            console.log(div);
            div.isChecked = !div.isChecked;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function goBack() {
            $state.go('app.echeckin.dashboard');
        }

        function openInputEducation(ev) {
            $mdDialog.show({
                controller: 'InputpendidikanController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/pendidikan/inputpendidikan.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });
        }

        function editInputEducation(ev, id) {
            $mdDialog.show({
                controller: 'EditpendidikanController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/pendidikan/inputpendidikan.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    id: id
                }
            });
        }

        function openInputIjazah(ev, id) {
            // console.log(type);
            $mdDialog.show({
                controller: 'InputIjazahController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/pendidikan/input-ijazah.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    id: id
                }
            });
        }

        function editInputIjazah(ev, id) {
            $mdDialog.show({
                controller: 'UpdateIjazahController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/pendidikan/edit-ijazah.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    id: id
                }
            });
        }

        function viewIjazahDoc(ev, id) {
            var uri = "";
            switch (id) {
                case 'transkrip':
                    uri = "app/main/echeckin/pendidikan/view-transkrip.html";
                    break;
                case 'ijazah':
                    uri = "app/main/echeckin/pendidikan/view-ijazah.html";
                    break;
            }
            $mdDialog.show({
                controller: 'PendidikanController',
                controllerAs: 'vm',
                templateUrl: uri,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });
        }

        function deleteData(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Education.delete({ action: 'deleteeducation', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(function (resp) {
                        dialogClose();
                        angular.element.unblockUI();
                        showDialogInfo(ev, resp);
                    });
                }, function () {

                });
            });
        }

        function downloadDoc(ev) {
            var name = vm.ijazah;
            // console.log(link);
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/empdocument/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Document Not Found')
                        .textContent('Document not Found')
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }

        function showDialogInfo(ev, data) {
            var expmess = data.pesan.split("_");
            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    viewData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();  

(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('InputpendidikanController', InputpendidikanController);

    InputpendidikanController.$inject = ['$state', '$localStorage', '$http', '$mdDialog', 'Form', 'AppAPI', 'config', '$filter'];

    /* @ngInject */
    function InputpendidikanController($state, $localStorage, $http, $mdDialog, Form, AppAPI, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Education = AppAPI.Education();

        // set constructor form
        Form.setObject(Education);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.getUniversity = getUniversity;
        vm.getJurusan = getJurusan;
        vm.selectedItemChanged = selectedItemChanged;
        vm.jurusan = [];
        vm.helpdesk = helpdesk;
        // vm.minDate=new Date('1990-01-01');
        vm.ChangeStartStudy = ChangeStartStudy;
        vm.Form.objForm.certificate = '1';
        vm.Form.objForm.title = '';

        var empID = $localStorage.username;

        vm.pendidikan = ['SMP', 'SMA Sederajat', 'SMK', 'D1', 'D2', 'D3', 'D4', 'S1', 'S2', 'S3'];

        // vm.universitas=[
        //     'Institut Teknologi Bandung',
        //     'Universitas Indonesia',
        //     'Universitas Gajah Mada',
        //     'Universitas Telkom',
        //     'Universitas Pasundan',
        //     'Universitas Widyatama'
        // ];

        vm.changeRequired = changeRequired;

        vm.required = false;

        // getUniversity();
        getJurusan();

        ////////////////

        function ChangeStartStudy() {
            var sS = new Date(vm.Form.objForm.startStudy);
            var year = sS.getFullYear();
            var month = sS.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }

            var date = sS.getDate();
            var sD = year + '-' + month + '-' + date;
            vm.minDate = new Date(sD);
            // console.log(vm.minDate);
        }

        function getUniversity(searchText) {
            // var response=Education.query({action:'getUniversity'});
            // response.$promise.then(fetChDataUniversity);
            vm.Form.objForm.schoolID = 0;
            return $http
                .get(config.api + 'api/education?action=getUniversity&id=' + searchText)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        vm.Form.objForm.schoolID = '0';
                    }
                    return item.data;
                });
        }

        function selectedItemChanged(sc) {

            vm.Form.objForm.schoolID = 0;
            vm.Form.objForm.schoolName = vm.searchString;
            if (typeof sc !== 'undefined') {
                vm.Form.objForm.schoolName = sc.schoolName;
                vm.Form.objForm.schoolID = sc.schoolID;
            }
        }

        function getJurusan() {
            $http.get(config.api + 'api/education?action=getJurusan')
                .then(function (item) {
                    vm.jurusan = item.data;
                });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.department = '-';
            vm.Form.objForm.empId = window.atob(decodeURIComponent(empID));
            var promise = Form.saveData('save', formController, Education);
            promise.then(function (data) {
                formController.$setPristine();

                showDialogInfo(ev, data);
            });

            promise.catch(function (data) {
                formController.$setPristine();
                showDialogInfo(ev, data.data);
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function changeRequired(val) {
            // console.log(val);
            if (val == 'SMP' || val == 'SMA Sederajat' || val == 'SMK') {
                vm.required = false;
            } else {
                vm.required = true;
            }

            // console.log(vm.required);

        }

        function helpdesk() {
            $state.go('app.echeckin.helpdesk');
            closeModal();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('InputIjazahController', InputIjazahController);

    InputIjazahController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','config','FileUploader','id'];

    /* @ngInject */
    function InputIjazahController($localStorage,$mdDialog,Form,AppAPI,config,FileUploader,id) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Document = AppAPI.Document();

        // set constructor form
        Form.setObject(Document);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.goNav=goNav; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;
        vm.upload=upload;
        vm.Form.objForm.typeOfDocument=id;
        vm.Form.objForm.description='ijazah';

        var empID=$localStorage.username;



        ////////////////
        vm.documentNo=vm.Form.objForm.documentNo;
        vm.typeOfDocument=vm.Form.objForm.typeOfDocument;
        vm.description=vm.Form.objForm.description;
        vm.Form.objForm.empID=empID;
        vm.Form.objForm.expiredDate='9999-12-31';

     

        function upload()
        {
            
             var resp=vm.FileUploaderPhoto.uploadAll();
             // console.log('test');

        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({ 
           url:config.api+'api/documents/upload', 
           removeAfterUpload:true,
           alias:'ijazah',
           onBeforeUploadItem :function(item){
              var dt= new Date(item.formData[0].issuedDate);
              var et= new Date(item.formData[0].expiredDate);
              
              var dtM=(dt.getMonth()+1);
              var dtD=dt.getDate();
              var etM=(et.getMonth()+1);
              var etD=et.getDate();
              if(dtM < 10){
                dtM='0'+dtM
              }
              if(dtD<10)
              {
                dtD='0'+dtD;
              }

              if(etM < 10){
                etM='0'+etM
              }
              if(etD<10)
              {
                etD='0'+etD;
              } 

              var newdate=dt.getFullYear()+'-'+dtM+'-'+dtD;
              var newdate1=et.getFullYear()+'-'+etM+'-'+etD;
              item.formData[0].issuedDate= newdate;
              item.formData[0].expiredDate=newdate1;

              angular.element.blockUI();
           }, 
           formData:[
              {
               action:'uploadijazah',
               documentNo:vm.documentNo,
               typeOfDocument:vm.typeOfDocument,
               description:vm.description
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
                angular.element.unblockUI();
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth 
              },
            onSuccessItem:function(item, response, status, headers){
              // console.log(item);
              // console.log(response);
              showDialog();
              // console.log(status);
              // console.log(headers);
              angular.element.unblockUI();
            }
        });

        uploaderPhoto.filters.push({
            name: 'syncFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                vm.sizefile=item.size; 
                // console.log(vm.sizefile); 
                return true;
            }
        });

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function goNav(state) {
            $state.go(state);
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }

        function saveData(ev,formController) {
             vm.Form.objForm.title=vm.Form.objForm.eduTitle;
             vm.Form.objForm.empId=empID;
            var promise= Form.saveData('save', formController, Education);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog() {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent()
            ).then(function(){
                closeModal();
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('EditpendidikanController', EditpendidikanController);

    EditpendidikanController.$inject = ['$localStorage', '$http', 'id', '$mdDialog', 'Form', 'AppAPI', 'config', '$filter'];

    /* @ngInject */
    function EditpendidikanController($localStorage, $http, id, $mdDialog, Form, AppAPI, config, $filter) {
        var vm = this;

        var translate = $filter('translate');
        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Education = AppAPI.Education();

        // set constructor form
        Form.setObject(Education);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;

        var empID = $localStorage.username;
        vm.getUniversity = getUniversity;
        vm.selectedItemChanged = selectedItemChanged;
        vm.helpdesk = helpdesk;

        vm.jurusan = [];
        vm.getJurusan = getJurusan;
        vm.ChangeStartStudy = ChangeStartStudy;
        vm.Form.objForm.certificate = '1';
        vm.Form.objForm.title = '';

        var response = vm.Form.objForm.$get({ action: 'viewDetail', id: id.id });
        response.then(changeDate);
        getJurusan();


        ////////////////

        vm.pendidikan = ['SMP', 'SMA Sederajat', 'SMK', 'D1', 'D2', 'D3', 'D4', 'S1', 'S2', 'S3'];

        /* vm.universitas=[
            'Institut Teknologi Bandung',
            'Universitas Indonesia',
            'Universitas Gajah Mada',
            'Universitas Telkom',
            'Universitas Pasundan',
            'Universitas Widyatama'
        ]; */

        vm.changeRequired = changeRequired;

        function getUniversity(searchText) {
            // var response=Education.query({action:'getUniversity'});
            // response.$promise.then(fetChDataUniversity);
            vm.Form.objForm.schoolID = 0;
            return $http
                .get(config.api + 'api/education?action=getUniversity&id=' + searchText)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        vm.Form.objForm.schoolID = '0';
                    }
                    return item.data;
                });
        }

        function selectedItemChanged(sc) {

            vm.Form.objForm.schoolID = 0;
            vm.Form.objForm.schoolName = vm.searchString;
            if (typeof sc !== 'undefined') {
                vm.Form.objForm.schoolName = sc.schoolName;
                vm.Form.objForm.schoolID = sc.schoolID;
            }
        }

        function changeDate(data) {
            vm.Form.objForm.startStudy = new Date(data.start_study);
            vm.Form.objForm.finishStudy = new Date(data.finish_study);
            vm.Form.objForm.oldId = data.id;
            vm.Form.objForm.schoolName = data.school_name;
            vm.Form.objForm.finalGrade = data.final_grade;
            vm.Form.objForm.eduTitle = data.title;
            vm.Form.objForm.pendidikan = data.tingkat_pendidikan;
            vm.minDate = new Date(data.start_study);
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.title = vm.Form.objForm.title;
            var promise = Form.saveData('update', formController, Education);
            promise.then(function (data) {
                formController.$setPristine();

                showDialogInfo(ev, data);
            });

            promise.catch(function (data) {
                formController.$setPristine();
                showDialogInfo(ev, data.data);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function changeRequired(val) {
            if (val == 'SMP' || val == 'SMA Sederajat' || val == 'SMK') {
                vm.required = false;
            } else {
                vm.required = true;
            }

        }

        function getJurusan() {
            $http.get(config.api + 'api/education?action=getJurusan')
                .then(function (item) {
                    vm.jurusan = item.data;
                });
        }

        function ChangeStartStudy() {
            var sS = new Date(vm.Form.objForm.startStudy);
            var year = sS.getFullYear();
            var month = sS.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }

            var date = sS.getDate();
            var sD = year + '-' + month + '-' + date;
            vm.minDate = new Date(sD);
            // console.log(vm.minDate);
        }


        function helpdesk() {
            $state.go('app.echeckin.helpdesk');
            closeModal();
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('UpdateIjazahController', UpdateIjazahController);

    UpdateIjazahController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', 'config', 'FileUploader', 'id'];

    /* @ngInject */
    function UpdateIjazahController($localStorage, $mdDialog, Form, AppAPI, config, FileUploader, id) {
        var vm = this;
        vm.saveData = saveData;
        // initial form
        Form.initialForm();
        // console.log("test");

        var Document = AppAPI.Document();

        // set constructor form
        Form.setObject(Document);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.goNav = goNav;
        vm.uploadFile = uploadFile;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        vm.upload = upload;

        var empID = $localStorage.username;

        var response = vm.Form.objForm.$get({ action: 'viewDetail', id: id });
        response.then(changeDate);


        ////////////////
        vm.documentNo = vm.Form.objForm.documentNo;
        vm.typeOfDocument = vm.Form.objForm.typeOfDocument;
        vm.description = vm.Form.objForm.description;
        // vm.Form.objForm.empID=empID;
        // vm.Form.objForm.expiredDate='2222-22-22';


        function changeDate(data) {
            vm.Form.objForm.empID = empID;
            if (data.type_document == '3') {
                vm.Form.objForm.typeOfDocument = 3;
            } else {
                vm.Form.objForm.typeOfDocument = 4;
            }
            vm.Form.objForm.expiredDate = '2222-22-22';
            // console.log(data);
        }

        function closeModal() {
            $mdDialog.hide();
        }


        function upload() {

            var resp = vm.FileUploaderPhoto.uploadAll();

        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/documents/uploads',
            removeAfterUpload: true,
            alias: 'ijazah',
            onBeforeUploadItem: function () {
                angular.element.blockUI();
            },
            formData: [
                {
                    action: 'uploadijazah',
                    documentNo: vm.documentNo,
                    typeOfDocument: vm.typeOfDocument,
                    description: vm.description
                }
            ],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
                angular.element.unblockUI();
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            },
            onSuccessItem: function (item, response, status, headers) {
                // console.log(item);
                // console.log(response);
                showDialog();
                // console.log(status);
                // console.log(headers);
                angular.element.unblockUI();
            }
        });

        uploaderPhoto.filters.push({
            name: 'syncFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                vm.sizefile = item.size;
                // console.log(vm.sizefile); 
                return true;
            }
        });

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function goNav(state) {
            $state.go(state);
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.title = vm.Form.objForm.eduTitle;
            vm.Form.objForm.empId = empID;
            var promise = Form.saveData('save', formController, Education);
            promise.then(function () {
                showDialog(ev);
            });
        }

        function showDialog() {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent()
            ).then(function () {
                closeModal();
            });
        }

    }
})();
(function() {
  'use strict';

  angular.module('app.echeckin').controller('PajakController', PajakController);

  PajakController.$inject = [
    '$localStorage',
    '$timeout',
    'Echeckin',
    'Form',
    'AppAPI',
    'Auth',
    '$mdDialog',
    '$document',
    'config',
    'FileUploader',
    '$scope'
  ];

  /* @ngInject */
  function PajakController(
    $localStorage,
    $timeout,
    Echeckin,
    Form,
    AppAPI,
    Auth,
    $mdDialog,
    $document,
    config,
    FileUploader,
    $scope
  ) {
    var vm = this;
    Echeckin.breadcrumb = [
      {
        state: 'app.echeckin.dashboard',
        name: 'Halaman Depan',
        active: 0
      },
      {
        state: '',
        name: 'Pajak',
        active: 1
      }
    ];

    Form.initialForm();

    $scope.hasUpload = false;

    vm.stateEdit = false;

    vm.ChangeState = ChangeState;
    vm.saveData = saveData;
    vm.optionNpwp = null;
    vm.changeNpwp = changeNpwp;
    vm.uploadNpwp = uploadNpwp;
    vm.UploadNpwpStateSucces = false;
    vm.UploadNpwpStateError = false;
    vm.upload = upload;
    vm.checkNpwp = false;
    vm.stateView = false;
    vm.closeModal = closeModal;
    vm.viewNpwp = viewNpwp;
    vm.Echeckin = Echeckin

    // get constructor form
    var Tax = AppAPI.Tax();
    var Document = AppAPI.Document();
    var Profiles = AppAPI.Profiles();

    // set constructor form
    Form.setObject(Tax);

    // set form to controller
    vm.Form = Form;

    // set token
    vm.setToken = Auth.setToken;

    var empID = $localStorage.username;

    vm.empID = empID;
    vm.check = {};

    var response = vm.Form.objForm.$get({ action: 'viewTax', id: empID });
    response.then(changeDate);

    // vm.title = ['Mr','Mrs','Miss','Ms'];
    vm.jenkel = ['L', 'P'];
    vm.maritalStatuses = ['Lajang', 'Menikah', 'Duda', 'Janda'];

    vm.messageTheme = 'green';

    loadDataCheck();
        
    function loadDataCheck() {
    //    angular.element.blockUI();
        var promises = Profiles.query({action:'checkCompletionData', id:empID});
        promises.$promise.then( function (res) {
            vm.check = res[0];
        } );
        promises.$promise.catch( function (res) {
            vm.check = {};
        } ); 
    }

    function ChangeState() {
      loadDataNpwp();
      changeNpwp();
      switch (vm.stateEdit) {
        case true:
          vm.stateEdit = false;
          break;
        case false:
          vm.stateEdit = true;
          break;
      }
    }

    function changeDate(data) {
      vm.optionNpwp = data.npwp
    }

    function uploadNpwp(ev) {
      $mdDialog.show({
        controller: 'PajakController',
        controllerAs: 'vm',
        templateUrl: 'app/main/echeckin/pajak/pajak-upload.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function(element, removePromise) {
          loadDataCheck();
          viewData();
        }
      });
    }

    function upload() {
      var resp = vm.FileUploaderNpwp.uploadAll();
    }

    var uploaderNpwp = (vm.FileUploaderNpwp = new FileUploader({
      url: config.api + 'api/documents/uploadnpwp',
      removeAfterUpload: true,
      alias: 'npwp',
      onBeforeUploadItem: function() {
        angular.element.blockUI();
      },
      formData: [
        {
          action: 'uploadnpwp',
          documentNo: vm.documentNo,
          typeOfDocument: 'npwp',
          expiredDate: '9999-12-31',
          issuedDate: vm.issuedDate,
          description: vm.description
        }
      ],
      onAfterAddingAll: function() {
        vm.UploadNpwpStateSucces = false;
        vm.UploadNpwpStateError = false;
        angular.element.unblockUI();
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      },
      onSuccessItem: function(item, response, status, headers) {
        angular.element.unblockUI();
        vm.UploadNpwpStateSucces = true;
        vm.UploadNpwpStateError = false;
        $timeout(function() {
          $mdDialog.hide();
          $scope.hasUpload = true;
          vm.Echeckin.checkComplete.doc_npwp = true;
        }, 1000);
      },
      onErrorItem: function(item, response, status, headers) {
        angular.element.unblockUI();
        vm.UploadNpwpStateSucces = false;
        vm.UploadNpwpStateError = true;
        $scope.hasUpload = false;
      }
    }));

    function closeModal() {
      $mdDialog.hide();
    }

    function changeNpwp() {
      if (vm.optionNpwp == '0') {
        vm.Form.objForm.taxNumber = '-';
        vm.checkNpwp = false;
      } else {
        vm.checkNpwp = true;
      }
    }

    function loadDataNpwp() {
      var npwp = Document.query({
        action: 'viewData',
        emp_id: empID,
        type: 'npwp'
      });

      npwp.$promise.then(function(data) {
        if (data.length > 0) {
          vm.stateview = true;
          vm.doc = data[0].link;
        } else {
          vm.stateview = false;
        }
      });
    }

    function viewNpwp(ev) {
      $mdDialog.show({
        controller: 'PajakDocController',
        controllerAs: 'vm',
        templateUrl: 'app/main/echeckin/pajak/pajak-view.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function(element, removePromise) {
          loadDataNpwp();
        },
        locals: {
          img : vm.doc
        }
      });
    }

    function saveData(formController) {
      angular.element.blockUI();
      var resp = Form.updateData('updatetax', formController, Tax, empID, 'viewTax');

      resp.then(function() {
        vm.messageTheme = 'blue';
        angular.element.unblockUI();
        formController.$setPristine();
        $timeout(function() {
          vm.Form.tampilPesan = false;
          vm.stateEdit = false;
        }, 3000);
      });

      resp.catch(function() {
        vm.messageTheme = 'pink';
        angular.element.unblockUI();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
      .module('app.echeckin')
      .controller('PajakDocController', PajakDocController);

  PajakDocController.$inject = ['$localStorage','$http','$location','$window','$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','Echeckin','config','img'];

  /* @ngInject */
  function PajakDocController($localStorage,$http,$location,$window,$stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,Echeckin,config,img) {
    var vm = this;

    vm.closeModal = closeModal;
    vm.downloadDoc = downloadDoc;

    function closeModal()
    {
        $mdDialog.hide();
    }

    loadImage();

    function loadImage()
    {
        vm.doc = img;
        if (vm.doc.slice(-3) === 'pdf') {
            vm.doc_type = true;
        } else {
            vm.doc_type = false;
        }
        vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
    }

    function downloadDoc(ev)
    {
        var img=vm.doc;
        // console.log(link);
        if(name !==null && name !=='-')
        {
            $http({
                method: 'GET',
                url: config.api+'api/empdocument/'+name,
                params: { name: name },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();
                // console.log(data);
                var filename = name;
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);

                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).error(function (data) {
                console.log(data);
            });
        } else {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Document Not Found')
            .textContent('Document not Found')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
        }
    }

  }
})();

(function () 
{
    'use strict';

    angular
        .module('app.echeckin')
        .controller('UploadKKController', UploadKKController);

    /** @ngInject */
    UploadKKController.$inject=['$localStorage','$mdDialog','AppAPI','Auth','Form','config','FileUploader'];
    /** @ngInject */
    function UploadKKController($localStorage,$mdDialog,AppAPI,Auth,Form,config,FileUploader)
    {
        
      var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Document=AppAPI.Document();

	    // set constructor form
	    Form.setObject(Document);

	    // set form to controller
	    vm.Form = Form;
 

	    vm.closeModal=closeModal; 
	    vm.setToken=Auth.setToken;
      vm.goNav=goNav; 
      vm.uploadFile=uploadFile;
      vm.UploadPhotoStateSucces=false;
      vm.UploadPhotoStateError=false;
      vm.upload=upload;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck; 
      vm.Form.objForm.typeOfDocument='kk';
      vm.Form.objForm.empID=$localStorage.username;
      vm.ChangeDate=ChangeDate;
      vm.ChangeDateExp=ChangeDateExp;
      vm.Form.objForm.expiredDate="9999-12-31";
      // vm.Form.objForm.dataEdu=id;

	    vm.messageTheme='pink';

      vm.message = {
        title: 'Process Upload File',
        ariaLabel: '',
        textContent: ''
      }
      // console.log(id);

      function ChangeDate()
      {
        var d=new Date(vm.Form.objForm.issuedDate);
        // console.log(d);
        // console.log(d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate());
        vm.issuedDate=d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate();
        // console.log(vm.issuedDate);
      }

      function ChangeDateExp()
      {
        var d=new Date(vm.Form.objForm.expiredDate);
        // console.log(d);
        // console.log(d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate());
        vm.expiredDate=d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate();
      }
 
 
	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

/*	    function saveData(ev,formController) {
	        Form.objForm.id=id.id;
	        var promise= Form.saveData('updateeducation', formController, Employe);
	        promise.then(function(){
	            showDialog(ev);
	        });
	    }
*/

        function upload()
        {
            
             var resp=vm.FileUploaderPhoto.uploadAll();

        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({ 
           url:config.api+'api/dependents/uploadkk', 
           removeAfterUpload:true,
           alias:'kk',
           onBeforeUploadItem :function(){
            
            angular.element.blockUI();

           }, 
           formData:[
              {
               action:'uploadkk',
               documentNo:vm.documentNo,
               typeOfDocument:vm.typeOfDocument,
               description:vm.description
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
                angular.element.unblockUI();
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth 
              },
            onSuccessItem:function(item, response, status, headers){
              if (response.error) {
                vm.message = {
                  ariaLabel: 'Upload file has been failed',
                  textContent: response.pesan
                }
              } else {
                vm.message = {
                  ariaLabel: 'Upload file has been successfully',
                  textContent: response.pesan
                }
              }

              showDialog();
              // console.log(status);
              // console.log(headers);
              angular.element.unblockUI();
            }
        });

        uploaderPhoto.filters.push({
            name: 'syncFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                vm.sizefile=item.size; 
                // console.log(vm.sizefile); 
                return true;
            }
        });

        function goNav(state) {
            $state.go(state);
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }

       

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title(vm.message.title)
          .textContent(vm.message.textContent)
          .ariaLabel(vm.message.ariaLabel)
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
		        closeModal();
		    });
	    }

    function isChecked()
        {
            // console.log(vm.seumurhidupChecked);
            vm.Form.objForm.ktpSeumurHidup=false;
            if(!vm.seumurhidupChecked){
              vm.Form.objForm.ktpSeumurHidup=true;
            }

            // console.log(vm.Form.objForm.ktpSeumurHidup);
        }

    function toggleCheck(event)
      {
          if ( event )
          {
              event.stopPropagation();
          }  
      }

    }
})();  

(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('KeluargaController', KeluargaController);


    KeluargaController.$inject = ['$state', '$localStorage', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'Echeckin', '$http', 'config', '$filter'];
    /** @ngInject */
    function KeluargaController($state, $localStorage, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, Echeckin, $http, config, $filter) {
        var vm = this;

        var translate = $filter('translate');
        var Dependents = AppAPI.Dependents();

        var empID = $localStorage.username;

        Echeckin.breadcrumb = [
            {
                state: 'app.echeckin.dashboard',
                name: 'Halaman Depan',
                active: 0

            },
            {
                state: '',
                name: 'Keluarga',
                active: 1

            }
        ];

        vm.openInputEducation = openInputEducation;
        vm.editInputEducation = editInputEducation;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.downloadDoc = downloadDoc;
        vm.deleteData = deleteData;
        vm.closeModal = closeModal;
        vm.uploadKK = uploadKK;
        vm.viewKK = viewKK;
        vm.goBack = goBack;

        vm.listDataSelected = [];
        vm.listData = [];

        viewData();

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Dependents.query({ action: 'viewData', emp_id: empID });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            vm.doc = data[0].kk;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
                vm.url = 'api/empdocument/' + vm.doc + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
            } else {
                vm.doc_type = false;
            }
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function goBack() {
            $state.go('app.echeckin.dashboard');
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            console.log(div);

            div.isChecked = !div.isChecked;
        }


        function openInputEducation(ev) {
            $mdDialog.show({
                controller: 'InputkeluargaController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/keluarga/inputkeluarga.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });
        }

        function editInputEducation(ev, id) {
            $mdDialog.show({
                controller: 'EditkeluargaController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/keluarga/inputkeluarga.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    id: id
                }
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Dependents.delete({ action: 'deletedependents', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                }, function () {

                });
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function uploadKK(ev) {
            $mdDialog.show({
                controller: 'UploadKKController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/keluarga/upload-kk.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });
        }

        function viewKK(ev) {
            console.log(vm.doc);
            $mdDialog.show({
                controller: 'KeluargaController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/keluarga/view-kk.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            // console.log(link);
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/empdocument/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Document Not Found')
                        .textContent('Document not Found')
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }

    }
})();  

(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('InputkeluargaController', InputkeluargaController);

    InputkeluargaController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$filter'];

    /* @ngInject */
    function InputkeluargaController($localStorage, $mdDialog, Form, AppAPI, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Dependents = AppAPI.Dependents();

        // set constructor form
        Form.setObject(Dependents);

        // set form to controller
        vm.Form = Form;

        vm.listData = [];

        vm.closeModal = closeModal;

        vm.fullname = '';

        var empID = $localStorage.username;
        vm.gender = ['L', 'P'];
        vm.genderDisabled = false;
        vm.keluarga = [];
        vm.changeTypeOfFamily = changeTypeOfFamily;

        viewData();

        ////////////////

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Dependents.query({ action: 'viewData', emp_id: empID });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            angular.element.unblockUI();
            if (data[0].status == 'Lajang') {
                vm.keluarga = [
                    { id: "ayah", value: "Father" },
                    { id: "ibu", value: "Mother" }
                ];
            } else {
                if (data[0].gender == 'L') {
                    vm.keluarga = [
                        { id: "anak", value: "Child" },
                        { id: "istri", value: "Wife" },
                        { id: "ayah", value: "Father" },
                        { id: "ibu", value: "Mother" },
                        { id: "ayah mertua", value: "Father in-laws" },
                        { id: "ibu mertua", value: "Mother in-laws" }
                    ];
                } else {
                    vm.keluarga = [
                        { id: "anak", value: "Child" },
                        { id: "suami", value: "Husband" },
                        { id: "ayah", value: "Father" },
                        { id: "ibu", value: "Mother" },
                        { id: "ayah mertua", value: "Father in-laws" },
                        { id: "ibu mertua", value: "Mother in-laws" }
                    ];
                }
            }
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var str = vm.fullname;
            var words = str.split(" ");
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            vm.Form.objForm.empId = window.atob(decodeURIComponent(empID));
            vm.Form.objForm.photoAddress = '';
            vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
            vm.Form.objForm.lastName = str.substring(words[0].length);
            var promise = Form.saveData('save', formController, Dependents);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });
            promise.catch(function (data) {
                showDialogInfo(ev, data.data);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function changeTypeOfFamily() {
            var type = vm.Form.objForm.typeOfFamily;
            switch (type) {
                case 'istri':
                    vm.Form.objForm.gender = 'P';
                    vm.genderDisabled = true;
                    break;
                case 'suami':
                    vm.Form.objForm.gender = 'L';
                    vm.genderDisabled = true;
                    break;
                case 'ibu mertua':
                    vm.Form.objForm.gender = 'P';
                    vm.genderDisabled = true;
                    break;
                case 'ayah mertua':
                    vm.Form.objForm.gender = 'L';
                    vm.genderDisabled = true;
                    break;
                case 'ibu':
                    vm.Form.objForm.gender = 'P';
                    vm.genderDisabled = true;
                    break;
                case 'ayah':
                    vm.Form.objForm.gender = 'L';
                    vm.genderDisabled = true;
                    break;
                default:
                    vm.Form.objForm.gender = null;
                    vm.genderDisabled = false;
                    break;
            }
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('EditkeluargaController', EditkeluargaController);

    EditkeluargaController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$filter'];

    /* @ngInject */
    function EditkeluargaController($localStorage, id, $mdDialog, Form, AppAPI, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Dependents = AppAPI.Dependents();

        // set constructor form
        Form.setObject(Dependents);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.gender = ['L', 'P'];

        vm.fullname = '';

        var empID = $localStorage.username;

        var response = vm.Form.objForm.$get({ action: 'viewDetail', id: id.id });
        response.then(changeDate);

        vm.keluarga = [];

        viewData();

        ////////////////

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Dependents.query({ action: 'viewData', emp_id: empID });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            angular.element.unblockUI();
            if (data[0].status == 'Lajang') {
                vm.keluarga = [
                    { id: "ayah", value: "Father" },
                    { id: "ibu", value: "Mother" }
                ];
            } else {
                vm.keluarga = [
                    { id: "anak", value: "Child" },
                    { id: "istri", value: "Wife" },
                    { id: "suami", value: "Husband" },
                    { id: "ayah", value: "Father" },
                    { id: "ibu", value: "Mother" },
                    { id: "ayah mertua", value: "Father in-laws" },
                    { id: "ibu mertua", value: "Mother in-laws" }
                ];
            }
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }


        ////////////////

        function changeDate(data) {
            vm.Form.objForm.dateOfBirth = new Date(data.date_of_birth);
            vm.Form.objForm.typeOfFamily = data.type_of_family;
            vm.Form.objForm.birthPlace = data.birth_place;
            vm.Form.objForm.photoAddress = '';

            if (data.last_name == null) {
                data.last_name = '';
            }

            vm.fullname = data.first_name + ' ' + data.last_name;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            var str = vm.fullname;
            var words = str.split(" ");
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            vm.Form.objForm.firstName = words[0].replace(/\s/g, '');
            vm.Form.objForm.lastName = str.substring(words[0].length);
            var promise = Form.saveData('update', formController, Dependents);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });
            promise.catch(function (data) {
                showDialogInfo(ev, data.data);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('ViewIjazahController', ViewDocController);

    ViewDocController.$inject = ['$localStorage','$http','$location','$window','$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','Echeckin','config','img'];

    /* @ngInject */
    function ViewDocController($localStorage,$http,$location,$window,$stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,Echeckin,config,img) {
        var vm = this;
        
        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal()
        {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage()
        {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev)
        {
            var img=vm.doc;
            // console.log(link);
            if(name !==null && name !=='-')
            {
                $http({
                    method: 'GET',
                    url: config.api+'api/empdocument/'+name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];
             
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);
             
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
             
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Document Not Found')
                .textContent('Document not Found')
                .ariaLabel('Failed Save Data')
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    // closeModal();
                });
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('InputijazahController', InputijazahController);

    InputijazahController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','config','FileUploader'];

    /* @ngInject */
    function InputijazahController($localStorage,$mdDialog,Form,AppAPI,config,FileUploader) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Document = AppAPI.Document();

        // set constructor form
        Form.setObject(Document);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.goNav=goNav; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;
        vm.upload=upload;


        var empID=$localStorage.username;



        ////////////////
        vm.documentNo=vm.Form.objForm.documentNo;
        vm.typeOfDocument=vm.Form.objForm.typeOfDocument;
        vm.description=vm.Form.objForm.description;
        vm.Form.objForm.empID=empID;
        vm.Form.objForm.expiredDate='9999-12-31';

        vm.message = {
          title: 'Process Upload File',
          ariaLabel: '',
          textContent: ''
        }

       

        function upload()
        {
            
             var resp=vm.FileUploaderPhoto.uploadAll();

        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({ 
           url:config.api+'api/documents/upload', 
           removeAfterUpload:true,
           alias:'ijazah',
           onBeforeUploadItem :function(){
              angular.element.blockUI();
           }, 
           formData:[
               vm.Form.objForm
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
                angular.element.unblockUI();
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth 
              },
            onSuccessItem:function(item, response, status, headers){
              if (response.error) {
                vm.message = {
                  ariaLabel: 'Upload file has been failed',
                  textContent: response.pesan
                }
              } else {
                vm.message = {
                  ariaLabel: 'Upload file has been successfully',
                  textContent: response.pesan
                }
              }
              showDialog();
              angular.element.unblockUI();
            }
        });

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function goNav(state) {
            $state.go(state);
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }

        function saveData(ev,formController) {
             vm.Form.objForm.title=vm.Form.objForm.eduTitle;
             vm.Form.objForm.empId=empID;
            var promise= Form.saveData('save', formController, Education);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog() {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(vm.message.title)
            .textContent(vm.message.textContent)
            .ariaLabel(vm.message.ariaLabel)
            .ok('OK')
            .targetEvent()
            ).then(function(){
                closeModal();
            });
        }

    }
})();
(function () 
{
    'use strict';

    angular
        .module('app.echeckin')
        .controller('IjazahController', IjazahController);


    IjazahController.$inject=['$state','$localStorage','$http','$location','$window','$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','Echeckin','config'];
    /** @ngInject */
    function IjazahController($state,$localStorage,$http,$location,$window,$stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,Echeckin,config )
    {
        
        var vm = this;
         
        var Document = AppAPI.Document(); 

        var empID=$localStorage.username;
        vm.viewDokumen=viewDokumen; 

        Echeckin.breadcrumb=[
          {
            state:'app.echeckin.dashboard',
            name:'Halaman Depan',
            active:0

          },
          {
            state:'',
            name:'Ijazah/Transkrip',
            active:1

          }
        ];
      
        
        

       

        vm.openInputEducation = openInputEducation;
        vm.editInputEducation = editInputEducation;
        

        vm.listData=[];
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listDataSelected=[];
        vm.goBack=goBack;
    
        vm.deleteData=deleteData; 
        
        viewData();

        function goBack()
        {
            $state.go('app.echeckin.dashboard');
        }

        function viewData() {
           angular.element.blockUI();
           var dataPromise = Document.query({action:'viewData',emp_id:empID,type:'ijazah1'});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
           vm.listDataSelected=angular.copy(vm.listData);
        }

        function unCheckAll() {
           vm.listDataSelected=[];
        }

        function checkone(div) {
            console.log(div);

            div.isChecked = !div.isChecked;
        }
       

        function openInputEducation(ev)
        {
            $mdDialog.show({
                controller         : 'InputijazahController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/echeckin/ijazah/input-ijazah.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                }
            });


        }

        function editInputEducation(ev, id)
        {
            $mdDialog.show({
                controller         : 'EditijazahController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/echeckin/ijazah/edit-ijazah.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                },
                locals:{
                  id:id
                }
            });
        } 
        
        function deleteData(ev) {
       
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=Document.delete({action:'deletedocument',data:angular.toJson(vm.listDataSelected)});
                    response.$promise.then(viewData);
                }, function() {

                });
            });
      
       
        }

        function viewDokumen(ev, img)
        {
            $mdDialog.show({    
                controller         : 'ViewIjazahController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/echeckin/ijazah/view-ijazah.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                },
                locals:{
                  img:img
                }
            });
        }

    }
})();  

(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('EditijazahController', EditijazahController);

    EditijazahController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','config','FileUploader'];

    /* @ngInject */
    function EditijazahController($localStorage,id,$mdDialog,Form,AppAPI,config,FileUploader) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Document = AppAPI.Document();

        // set constructor form
        Form.setObject(Document);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.goNav=goNav; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;
        vm.upload=upload;


        var empID=$localStorage.username; 

        var response=vm.Form.objForm.$get({action:'viewDetail',id:id.id});
        response.then(changeDate);


        ////////////////
        vm.documentNo=vm.Form.objForm.documentNo;
        vm.typeOfDocument=vm.Form.objForm.typeOfDocument;
        vm.description=vm.Form.objForm.description;
        // vm.Form.objForm.empID=empID;
        // vm.Form.objForm.expiredDate='2222-22-22';

        vm.message = {
          title: 'Process Upload File',
          ariaLabel: '',
          textContent: ''
        }


        function changeDate(data) {
           vm.Form.objForm.empID=data.emp_id;
           vm.Form.objForm.expiredDate='2222-22-22';
           vm.Form.objForm.typeOfDocument = data.type_document;
        }

       function closeModal()
        {
            $mdDialog.hide();
        }

         
        function upload()
        {
            
             var resp=vm.FileUploaderPhoto.uploadAll();

        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({ 
           url:config.api+'api/documents/uploads', 
           removeAfterUpload:true,
           alias:'ijazah',
           onBeforeUploadItem :function(){
              angular.element.blockUI();
           }, 
           formData:[
              {
                action:'uploadijazah',
                documentNo:vm.Form.objForm.documentNo,
                typeOfDocument:vm.Form.objForm.typeOfDocument,
                description:vm.Form.objForm.description
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
                angular.element.unblockUI();
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth 
              },
            onSuccessItem:function(item, response, status, headers){
              if (response.error) {
                vm.message = {
                  ariaLabel: 'Upload file has been failed',
                  textContent: response.pesan
                }
              } else {
                vm.message = {
                  ariaLabel: 'Upload file has been successfully',
                  textContent: response.pesan
                }
              }
              showDialog();
              angular.element.unblockUI();
            }
        });

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function goNav(state) {
            $state.go(state);
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }

        function saveData(ev,formController) {
             vm.Form.objForm.title=vm.Form.objForm.eduTitle;
             vm.Form.objForm.empId=empID;
            var promise= Form.saveData('save', formController, Education);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog() {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(vm.message.title)
            .textContent(vm.message.textContent)
            .ariaLabel(vm.message.ariaLabel)
            .ok('OK')
            .targetEvent()
            ).then(function(){
                closeModal();
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('InputinfoController', InputinfoController);

    InputinfoController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputinfoController($localStorage,$mdDialog,Form,AppAPI) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Emergency = AppAPI.Emergency();

        // set constructor form
        Form.setObject(Emergency);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;

        var empID=$localStorage.username;

        ////////////////

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {
            var str = vm.fullname;
            var words = str.split(" ");
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            vm.Form.objForm.firstName=words[0].replace(/\s/g, '');
            vm.Form.objForm.lastName=str.substring(words[0].length); 
            vm.Form.objForm.empId=window.atob(decodeURIComponent(empID));
            var promise= Form.saveData('save', formController, Emergency);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('InfogawatController', InfogawatController);


    InfogawatController.$inject = ['$state', '$localStorage', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'Echeckin', '$filter'];
    /** @ngInject */
    function InfogawatController($state, $localStorage, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, Echeckin, $filter) {

        var vm = this;

        var translate = $filter('translate');

        var Emergency = AppAPI.Emergency();

        var empID = $localStorage.username;

        Echeckin.breadcrumb = [
            {
                state: 'app.echeckin.dashboard',
                name: 'Halaman Depan',
                active: 0

            },
            {
                state: '',
                name: 'Info Gawat Darurat',
                active: 1

            }
        ];

        vm.openInputEducation = openInputEducation;
        vm.editInputEducation = editInputEducation;


        vm.listData = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];
        vm.goBack = goBack;

        vm.deleteData = deleteData;

        viewData();


        function viewData() {
            angular.element.blockUI();
            var dataPromise = Emergency.query({ action: 'viewData', emp_id: empID });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function goBack() {
            $state.go('app.echeckin.dashboard');
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {
            console.log(div);

            div.isChecked = !div.isChecked;
        }


        function openInputEducation(ev) {
            $mdDialog.show({
                controller: 'InputinfoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/info-gawat/input-info-gawat.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });


        }

        function editInputEducation(ev, id) {
            $mdDialog.show({
                controller: 'EditinfoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/info-gawat/input-info-gawat.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    id: id
                }
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Emergency.delete({ action: 'deleteemergency', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                }, function () {

                });
            });


        }

    }
})();  

(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('EditinfoController', EditinfoController);

    EditinfoController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function EditinfoController($localStorage,id,$mdDialog,Form,AppAPI) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Emergency = AppAPI.Emergency();

        // set constructor form
        Form.setObject(Emergency);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;


        var empID=$localStorage.username;

        var response=vm.Form.objForm.$get({action:'viewDetail',id:id.id});
        response.then(changeDate);


        ////////////////

        function changeDate(data)
        {
            if(data.last_name == null) {
                data.last_name = '';
            }
            vm.fullname = data.first_name+' '+data.last_name;
            vm.Form.objForm.phoneNumber=data.phone_number;
            vm.Form.objForm.typeOfFamily=data.type_of_family;
        }

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {
            var str = vm.fullname;
            var words = str.split(" ");
            for (var i = 0; i < words.length - 1; i++) {
                words[i] += " ";
            }

            vm.Form.objForm.firstName=words[0].replace(/\s/g, '');
            vm.Form.objForm.lastName=str.substring(words[0].length);
            var promise= Form.updateData('update',formController,Emergency, Form.objForm.id,'viewDetail');
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('HelpdeskController', HelpdeskController);

    HelpdeskController.$inject = ['$localStorage','$window','$timeout','$document','$mdDialog','Echeckin','Form','AppAPI','Auth','config','$scope', 'FileUploader'];

    /* @ngInject */
    function HelpdeskController($localStorage,$window,$timeout,$document,$mdDialog,Echeckin,Form,AppAPI,Auth,config,$scope, FileUploader) {
        var vm = this;
        $scope.imageSrc = "";

        Echeckin.breadcrumb=[
          {
          	state:'app.echeckin.dashboard',
        	  name:'Halaman Depan',
        	  active:0
          },
          {
          	state:'',
        	name:'Helpdesk',
        	active:1
          }
        ];

        var Helpdesk=AppAPI.Helpdesk();

        // set constructor form
        Form.initialForm();
        Form.setObject(Helpdesk);
        vm.Form = Form;
        var empID=$localStorage.username;
        vm.notif = {
          success: false,
          error: false
        }
        
        vm.attach = false
        vm.saveData = saveData;
        vm.upload = upload;
        vm.setUpload = setUpload
        vm.messageTheme='green';

        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        vm.Form.objForm.empId=empID;

        function saveData(data) {
          angular.element.blockUI();
          vm.Form.objForm.empId=empID;
          var promise= Form.saveData('saveData',data, Helpdesk);
            promise.then(function(response){
                if ( response.error ) {
                  vm.notif.error = response.pesan;
                  vm.notif.success = false;
                  vm.messageTheme='pink';
                } else {
                  vm.notif.error = false;
                  vm.notif.success = response.pesan;
                  vm.messageTheme='green';
                }
              data.$setPristine();
              $timeout(function() {
                vm.notif.error=false; 
                vm.notif.success=false; 
              }, 3000);
              angular.element.unblockUI();
            })
            .catch(function (response) {
              vm.notif.error = 'Internal server error'
              vm.notif.success = false;
              vm.messageTheme='pink';
              angular.element.unblockUI();
            });
        }

        function setUpload($event) 
        {
          console.log($event)
        }

        function upload()
        {
          var resp=vm.FileUploaderPhoto.uploadAll();
        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({ 
           url:config.api+'api/helpdesk/saveData', 
           removeAfterUpload:true,
           alias:'image',
           onBeforeUploadItem :function(){
              angular.element.blockUI();
           }, 
           formData:[
            vm.Form.objForm
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
                angular.element.unblockUI();
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth 
              },
            onSuccessItem:function(item, response, status, headers){
              if ( response.error ) {
                vm.notif.error = response.pesan;
                vm.notif.success = false;
                vm.messageTheme='pink';
              } else {
                vm.notif.error = false;
                vm.notif.success = response.pesan;
                vm.messageTheme='green';
              }

              $timeout(function() {
                vm.notif.error=false; 
                vm.notif.success=false; 
                vm.Form.objForm = {};
              }, 3000);
              angular.element.unblockUI();
            },
            onError: function() {
              vm.notif.error = 'Internal server error'
              vm.notif.success = false;
              vm.messageTheme='pink';
              angular.element.unblockUI();
            }
        });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('ViewDocController', ViewDocController);

    ViewDocController.$inject = ['$localStorage','$http','$location','$window','$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','Echeckin','config','img'];

    /* @ngInject */
    function ViewDocController($localStorage,$http,$location,$window,$stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,Echeckin,config,img) {
        var vm = this;
        
        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal()
        {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage()
        {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = 'api/empdocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev)
        {
            var name=vm.doc;
            // console.log(link);
            if(name !==null && name !=='-')
            {
                $http({
                    method: 'GET',
                    url: config.api+'api/empdocument/'+name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];
             
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);
             
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
             
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Document Not Found')
                .textContent('Document not Found')
                .ariaLabel('Failed Save Data')
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    // closeModal();
                });
            }
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.echeckin')
    .controller('InputDokumenController', InputDokumenController);

  InputDokumenController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', 'config', 'FileUploader', '$filter'];

  /* @ngInject */
  function InputDokumenController($localStorage, $mdDialog, Form, AppAPI, config, FileUploader, $filter) {
    var vm = this;

    var translate = $filter('translate');

    vm.saveData = saveData;
    // initial form
    Form.initialForm();

    var Document = AppAPI.Document();

    // set constructor form
    Form.setObject(Document);

    // set form to controller
    vm.Form = Form;

    vm.closeModal = closeModal;
    vm.goNav = goNav;
    vm.uploadFile = uploadFile;
    vm.UploadPhotoStateSucces = false;
    vm.UploadPhotoStateError = false;
    vm.upload = upload;
    vm.reqno = true;
    vm.changeTypeDoc = changeTypeDoc;
    vm.changeStarDate = changeStarDate;


    var empID = $localStorage.username;



    ////////////////
    vm.documentNo = vm.Form.objForm.documentNo;
    vm.typeOfDocument = vm.Form.objForm.typeOfDocument;
    vm.description = vm.Form.objForm.description;
    vm.Form.objForm.empID = empID;
    // vm.Form.objForm.expiredDate='2222-22-22';
    vm.listDoc = [];

    vm.message = {
      title: 'Process Upload File',
      ariaLabel: '',
      textContent: ''
    }

    viewDoc();
    function viewDoc() {
      angular.element.blockUI();
      var dataPromise = Document.query({ action: 'listTypedoc' });
      dataPromise.$promise.then(fetchDoc);
      dataPromise.$promise.catch(errorFetchdoc);
    }

    function fetchDoc(data) {
      vm.listDoc = data;
      // console.log(vm.listDoc);
      angular.element.unblockUI();
    }

    function errorFetchdoc() {
      vm.listDoc = [];
      angular.element.unblockUI();
    }

    function changeTypeDoc() {

      var typeDoc = vm.Form.objForm.typeOfDocument;
      // console.log(typeDoc); 
      switch (typeDoc) {
        case '2':
          vm.reqno = true;
          vm.docSeumurhidup = false;
          vm.Form.objForm.documentNo = null;
          vm.Form.objForm.expiredDate = null;
          break;
        case '5':
          vm.reqno = true;
          vm.docSeumurhidup = true;
          vm.Form.objForm.documentNo = null;
          vm.Form.objForm.expiredDate = new Date('9999-12-31');
          vm.minDate = vm.Form.objForm.expiredDate;
          break;
        case '10':
          vm.reqno = true;
          vm.docSeumurhidup = true;
          vm.Form.objForm.documentNo = null;
          vm.Form.objForm.expiredDate = new Date('9999-12-31');
          vm.minDate = vm.Form.objForm.expiredDate;
          break;
        case '8':
          vm.reqno = false;
          vm.Form.objForm.documentNo = '00';
          vm.docSeumurhidup = true;
          vm.Form.objForm.expiredDate = new Date('9999-12-31');
          vm.minDate = vm.Form.objForm.expiredDate;
          break;
        default:
          vm.reqno = true;
          vm.Form.objForm.documentNo = null;
          vm.docSeumurhidup = false;
          vm.Form.objForm.expiredDate = null;
          break;
      }
    }


    function changeStarDate() {
      var sS = new Date(vm.Form.objForm.issuedDate);
      var year = sS.getFullYear();
      var month = sS.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }

      var date = sS.getDate();
      var sD = year + '-' + month + '-' + date;
      vm.minDate = new Date(sD);
      vm.Form.objForm.issuedDate = new Date(sD);
      // console.log(vm.minDate);
    }

    function upload() {

      var resp = vm.FileUploaderPhoto.uploadAll();

    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/documents/upload',
      removeAfterUpload: true,
      alias: 'ijazah',
      onBeforeUploadItem: function (item) {
        var dt = new Date(item.formData[0].issuedDate);
        var et = new Date(item.formData[0].expiredDate);

        var dtM = (dt.getMonth() + 1);
        var dtD = dt.getDate();
        var etM = (et.getMonth() + 1);
        var etD = et.getDate();
        if (dtM < 10) {
          dtM = '0' + dtM
        }
        if (dtD < 10) {
          dtD = '0' + dtD;
        }

        if (etM < 10) {
          etM = '0' + etM
        }
        if (etD < 10) {
          etD = '0' + etD;
        }

        var newdate = dt.getFullYear() + '-' + dtM + '-' + dtD;
        var newdate1 = et.getFullYear() + '-' + etM + '-' + etD;
        item.formData[0].issuedDate = newdate;
        item.formData[0].expiredDate = newdate1;

        angular.element.blockUI();
      },
      formData: [
        vm.Form.objForm
      ],
      onAfterAddingAll: function () {
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        angular.element.unblockUI();
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      },
      onSuccessItem: function (item, response, status, headers) {

        if (response.error) {
          vm.message = {
            ariaLabel: 'Upload file has been failed',
            textContent: response.pesan
          }
        } else {
          vm.message = {
            ariaLabel: 'Upload file has been successfully',
            textContent: response.pesan
          }
        }

        showDialog();

        angular.element.unblockUI();
      }
    });

    uploaderPhoto.filters.push({
      name: 'syncFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        vm.sizefile = item.size;
        // console.log(vm.sizefile); 
        return true;
      }
    });

    function closeModal() {
      $mdDialog.hide();
    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }

    function goNav(state) {
      $state.go(state);
      vm.activeItem = state;
    }

    function uploadFile() {
      return false;
    }

    function saveData(ev, formController) {
      vm.Form.objForm.title = vm.Form.objForm.eduTitle;
      vm.Form.objForm.empId = empID;
      var promise = Form.saveData('save', formController, Education);
      promise.then(function (data) {
        showDialogInfo(ev, data);
      }).catch(function (data) {
        showDialogInfo(ev, data.data);
      });
    }

    function showDialog() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(vm.message.title)
          .textContent(vm.message.textContent)
          .ariaLabel(vm.message.ariaLabel)
          .ok('OK')
          .targetEvent()
      ).then(function () {
        closeModal();
      });
    }

    function showDialogInfo(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.echeckin')
    .controller('EditDokumenController', EditDokumenController);

  EditDokumenController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', 'config', 'FileUploader', '$filter'];

  /* @ngInject */
  function EditDokumenController($localStorage, id, $mdDialog, Form, AppAPI, config, FileUploader, $filter) {
    var vm = this;

    var translate = $filter('translate');
    vm.saveData = saveData;
    // initial form
    Form.initialForm();

    var Document = AppAPI.Document();

    // set constructor form
    Form.setObject(Document);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    vm.goNav = goNav;
    vm.uploadFile = uploadFile;
    vm.UploadPhotoStateSucces = false;
    vm.UploadPhotoStateError = false;
    vm.upload = upload;
    vm.showExipred = false;


    var empID = $localStorage.username;

    var response = vm.Form.objForm.$get({ action: 'viewDetail', id: id.id });
    response.then(changeDate);


    ////////////////
    vm.documentNo = vm.Form.objForm.documentNo;
    vm.typeOfDocument = vm.Form.objForm.typeOfDocument;
    vm.description = vm.Form.objForm.description;

    vm.listDoc = [];

    vm.message = {
      title: 'Process Upload File',
      ariaLabel: '',
      textContent: ''
    }

    viewDoc();
    function viewDoc() {
      angular.element.blockUI();
      var dataPromise = Document.query({ action: 'listTypedoc' });
      dataPromise.$promise.then(fetchDoc);
      dataPromise.$promise.catch(errorFetchdoc);
    }

    function fetchDoc(data) {
      vm.listDoc = data;
      angular.element.unblockUI();
    }

    function errorFetchdoc() {
      vm.listDoc = [];
      angular.element.unblockUI();
    }


    function changeDate(data) {
      vm.Form.objForm.empID = data.emp_id;
      vm.Form.objForm.expiredDate = new Date(data.expired_date);
      vm.Form.objForm.typeOfDocument = data.type_document;
      // console.log(data.typeOfDocument);
      switch (data.type_document) {
        case 'KTP':
          vm.showExipred = true;
          break;
      }
    }

    function closeModal() {
      $mdDialog.hide();
    }


    function upload() {

      var resp = vm.FileUploaderPhoto.uploadAll();

    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/documents/uploads',
      removeAfterUpload: true,
      alias: 'ijazah',
      onBeforeUploadItem: function () {
        angular.element.blockUI();
      },
      formData: [
        {
          action: 'uploadijazah',
          documentNo: vm.Form.objForm.documentNo,
          typeOfDocument: vm.Form.objForm.typeOfDocument,
          description: vm.Form.objForm.description
        }
      ],
      onAfterAddingAll: function () {
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        angular.element.unblockUI();
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      },
      onSuccessItem: function (item, response, status, headers) {
        if (response.error) {
          vm.message = {
            ariaLabel: 'Upload file has been failed',
            textContent: response.pesan
          }
        } else {
          vm.message = {
            ariaLabel: 'Upload file has been successfully',
            textContent: response.pesan
          }
        }
        showDialog();
        angular.element.unblockUI();
      }
    });

    function closeModal() {
      $mdDialog.hide();
    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }

    function goNav(state) {
      $state.go(state);
      vm.activeItem = state;
    }

    function uploadFile() {
      return false;
    }

    function saveData(ev, formController) {
      vm.Form.objForm.title = vm.Form.objForm.eduTitle;
      vm.Form.objForm.empId = empID;
      var promise = Form.saveData('save', formController, Education);
      promise.then(function (data) {
        showDialogInfo(ev, data);
      }).catch(function (data) {
        showDialogInfo(ev, data.data);
      });
    }

    function showDialog() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(vm.message.title)
          .textContent(vm.message.textContent)
          .ariaLabel(vm.message.ariaLabel)
          .ok('OK')
          .targetEvent()
      ).then(function () {
        closeModal();
      });
    }

    function showDialogInfo(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('DokumenController', DokumenController);


    DokumenController.$inject = ['$state', '$localStorage', '$http', '$location', '$window', '$stateParams', '$document', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'DTColumnDefBuilder', 'Echeckin', 'config', '$filter'];
    /** @ngInject */
    function DokumenController($state, $localStorage, $http, $location, $window, $stateParams, $document, $mdDialog, Auth, Form, AppAPI, DTColumnDefBuilder, Echeckin, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        var Document = AppAPI.Document();
        var Profiles = AppAPI.Profiles();

        var empID = $localStorage.username;
        vm.viewDokumen = viewDokumen;

        Echeckin.breadcrumb = [
            {
                state: 'app.echeckin.dashboard',
                name: 'Halaman Depan',
                active: 0

            },
            {
                state: '',
                name: 'Dokumen',
                active: 1

            }
        ];

        vm.Echeckin = Echeckin;
        vm.check = {};

        vm.openInputEducation = openInputEducation;
        vm.editInputEducation = editInputEducation;
        vm.closeModal = closeModal;

        vm.listData = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.deleteData = deleteData;
        vm.goBack = goBack;

        viewData();
        loadDataCheck();

        function loadDataCheck() {
            //    angular.element.blockUI();
            var promises = Profiles.query({ action: 'checkCompletionData', id: empID });
            promises.$promise.then(function (res) {
                vm.check = res[0];
            });
            promises.$promise.catch(function (res) {
                vm.check = {};
            });
        }


        function viewData() {
            angular.element.blockUI();
            var dataPromise = Document.query({ action: 'viewData', emp_id: empID, type: 'other' });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function goBack() {
            $state.go('app.echeckin.dashboard');
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
        }

        function unCheckAll() {
            vm.listDataSelected = [];
        }

        function checkone(div) {

            console.log(div);

            div.isChecked = !div.isChecked;
        }


        function openInputEducation(ev) {
            $mdDialog.show({
                controller: 'InputDokumenController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/dokumen/input-dokumen.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                    loadDataCheck();
                }
            });


        }

        function editInputEducation(ev, id) {
            var type = id.typename;
            switch (type) {
                case "KTP":
                    $mdDialog.show({
                        controller: 'EditKtpController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/echeckin/alamat/upload-ktp.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            viewData();
                            loadDataCheck();
                        },
                        locals: {
                            id: id.id
                        }
                    });
                    break;
                default:
                    $mdDialog.show({
                        controller: 'EditDokumenController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/echeckin/dokumen/edit-dokumen.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            viewData();
                            loadDataCheck();
                        },
                        locals: {
                            id: id
                        }
                    });
                    break;
            }
        }

        function deleteData(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Document.delete({ action: 'deletedocument', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                }, function () {

                });
            });


        }

        function closeModal() {
            $mdDialog.hide();
        }

        function viewDokumen(ev, img) {
            $mdDialog.show({
                controller: 'ViewDocController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/dokumen/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    img: img
                }
            });
        }
    }
})();  

(function() {
    'use strict';
    
    angular
        .module('app.echeckin')
        .controller('DashboardController', DashboardController);
        
    DashboardController.$inject = ['$localStorage','$state','$location','config','$window','Echeckin','Form','AppAPI','Auth','$mdDialog','$timeout'];

    /* @ngInject */
    function DashboardController($localStorage,$state,$location,config,$window,Echeckin,Form,AppAPI,Auth,$mdDialog,$timeout) {
        var vm              = this;
        vm.check            = {};
        vm.profile          = profile;
        vm.pendidikan       = pendidikan;
        vm.bahasa           = bahasa;
        vm.training         = training;
        vm.alamat           = alamat;
        vm.pengalamankerja  = pengalamankerja;
        vm.keluarga         = keluarga;
        vm.bank             = bank;
        vm.pajak            = pajak;
        vm.infogawat        = infogawat;
        vm.ijazah           = ijazah;
        vm.dokumen          = dokumen;
        vm.helpdesk          = helpdesk;
        vm.ExportToExcel    = ExportToExcel;
        vm.saveData         = saveData;
        vm.cek_profiles	    = true;
        vm.cek_address	    = true;
        vm.cek_dependents	= true;
		vm.cek_doc_ktp	    = true;
		vm.cek_doc_ijazah	= true;
		vm.cek_doc_sim	    = true;
        vm.cek_doc_bpjs     = true;
        vm.cek_doc_buku_nikah = true;
		vm.cek_education	= true;
		vm.cek_experience	= true;
		vm.cek_certification= true;
		vm.cek_bank	        = true;
		vm.cek_tax      	= true;
		vm.cek_emergency	= true;
		vm.cek_language	    = true;
        vm.cek_training	    = true;

        Echeckin.breadcrumb = [
            {
                state:'',
                name:'Halaman Depan',
                active:1
            }
       ];
       
       var Profiles=AppAPI.Profiles();
       Form.initialForm();
       Form.setObject(Profiles);
       vm.Form = Form;
       var empID=$localStorage.username;
       vm.Form.objForm.id = empID;
       vm.Form.objForm.submit = 1;
       loadData();

        
        function loadData() {
        //    angular.element.blockUI();
           var promises = Profiles.query({action:'checkCompletionData', id:empID});
           promises.$promise.then(fetchData);
           promises.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            if(typeof(data[0]) !== 'undefined') {
                vm.check = data[0];
                vm.cek_profiles	    =	vm.check.profiles;
                vm.cek_address	    =	vm.check.address;
                vm.cek_dependents	=	vm.check.dependents;
                vm.cek_doc_ktp	    =	vm.check.doc_ktp;
                vm.cek_doc_ijazah	=	vm.check.doc_ijazah;
                vm.cek_doc_sim	    =	vm.check.doc_sim;
                vm.cek_education	=	vm.check.education;
                vm.cek_experience	=	vm.check.experience;
                vm.cek_certification=	vm.check.certification;
                vm.cek_bank	        =	vm.check.bank;
                vm.cek_tax      	=	vm.check.tax;
                vm.cek_emergency	=	vm.check.emergency;
                vm.cek_language	    =	vm.check.language;
                vm.cek_training	    =	vm.check.training;
                vm.cek_jamsostek    =   vm.check.jamsostek;
                vm.doc_mandiri	    =	vm.check.doc_mandiri;
                vm.cek_doc_buku_nikah = vm.check.doc_buku_nikah;
                vm.cek_doc_bpjs     =   vm.check.doc_bpjs;
            }
        }

        function saveData(ev,formController)
        {
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Apakah anda yakin akan mengirim data ini ?')
                .textContent('Data yang terkirim tidak bisa diubah kembali.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('Ya, Kirim')
                .cancel('Tidak');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var resp=Form.updateData('updatesubmit',formController,Profiles,empID,'viewdetail');
                    resp.then(function(){
                        vm.messageTheme='blue';
                        angular.element.unblockUI();
                        formController.$setPristine();
                        $timeout(function() {
                            vm.Form.tampilPesan=false; 
                            vm.stateEdit=false; 
                        }, 3000);
                        loadData();
                    });
                    resp.catch(function(){
                        vm.messageTheme='pink';
                        angular.element.unblockUI();
         
                    });
                }, function() {
                });
            });
        }

        function errorFetch() {
            vm.check = {};
            angular.element.unblockUI();
        }
    
        function profile() {
            $state.go('app.echeckin.profile');
        }

        function pendidikan() {
        	$state.go('app.echeckin.pendidikan');
        }

        function bahasa() {
        	$state.go('app.echeckin.bahasa');
        }
        function training() {
            $state.go('app.echeckin.training');
        }

        function alamat() {
            $state.go('app.echeckin.alamat');
        }

        function pengalamankerja() {
            $state.go('app.echeckin.pengalaman-kerja');
        }

        function keluarga() {
            $state.go('app.echeckin.keluarga');
        }

        function bank(){
             $state.go('app.echeckin.bank');
        }

        function pajak()
        {
            $state.go('app.echeckin.pajak');
        }

        function infogawat()
        {
             $state.go('app.echeckin.info-gawat');
        }

        function ijazah()
        {
             $state.go('app.echeckin.ijazah');
        }

        function dokumen()
        {
            $state.go('app.echeckin.dokumen');
        }

        function helpdesk() {
            $state.go('app.echeckin.helpdesk');
        }

        function ExportToExcel()
        {
		  
          var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                   $window.open(protocol+'://'+host+config.api+'api/documents/downloadtutorial/', '_blank');
            },function(){
        
                $window.alert('gagal load token');
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('EbankController', EbankController);

   EbankController.$inject = ['$localStorage','$timeout','Echeckin','Form','AppAPI','Auth','FileUploader','config','$mdDialog','$document','$scope'];

    /* @ngInject */
    function EbankController($localStorage,$timeout,Echeckin,Form,AppAPI,Auth,FileUploader,config,$mdDialog,$document,$scope) {
        var vm = this;
        Echeckin.breadcrumb=[
          {
          	state:'app.echeckin.dashboard',
        	name:'Halaman Depan',
        	active:0

          },
          {
          	state:'',
        	name:'Bank',
        	active:1

          }
        ];

        Form.initialForm();

        $scope.hasUpload = false;

        vm.Echeckin = Echeckin
        
        vm.stateEdit=false;

        vm.ChangeState=ChangeState;
        vm.saveData=saveData;
        vm.viewDokumen = viewDokumen

        vm.uploadAccMandiri = uploadAccMandiri;
        vm.uploadAccMandiriStateSucces = false;
        vm.uploadAccMandiriStateError = false;
        vm.upload = upload;
        vm.closeModal = closeModal;
        vm.hasUpload = false;
        vm.Echeckin = Echeckin;

        vm.message = {
          uplodFailed: 'Failed Upload data',
          uploadSuccess: 'Success Upload data'
        }

         // get constructor form
        var Bank=AppAPI.Bank();
        var Profiles = AppAPI.Profiles();

         // set constructor form
        Form.setObject(Bank);

        // set form to controller
        vm.Form = Form; 
        
        // set token
        vm.setToken=Auth.setToken;

        var empID=$localStorage.username;
        vm.empID = empID;
        vm.documentNo='00';

        // vm.title = ['Mr','Mrs','Miss','Ms'];
        vm.jenkel = ['L','P'];
        vm.maritalStatuses = ['Lajang','Menikah','Duda','Janda'];

        vm.listCurrency = [
          { currency: 'IDR' },
          { currency: 'USD' }
        ]

        vm.messageTheme='green';
        vm.Form.objForm.currency = 'IDR';
        vm.check = {};

        loadData();
        loadListCurrency();

        loadDataCheck();
        
        function loadDataCheck() {
        //    angular.element.blockUI();
            var promises = Profiles.query({action:'checkCompletionData', id:empID});
            promises.$promise.then( function (res) {
                vm.check = res[0];
            } );
            promises.$promise.catch( function (res) {
                vm.check = {};
            } ); 
        }

        function ChangeState()
        {
          switch(vm.stateEdit){
            case true:
              vm.stateEdit=false;
              break;
            case false:
              vm.stateEdit=true;
              break;
          }
        }

        function loadData() {
          var response=vm.Form.objForm.$get({action:'viewBank',id:empID});
          response.then(changeDate);
        }

        function loadListCurrency()
        {
            var response=Bank.query({action:'getCurrency'});
            response.$promise.then(fetchCurrency);
        }

        function fetchCurrency(data) {
          vm.listCurrency=data;
        }

        function changeDate(data) {
            vm.Form.objForm.dateOfBirth=new Date(data.dateOfBirth);
            vm.Form.objForm.dateJoin=new Date(data.dateJoin);
            vm.Form.objForm.bankName = 'MANDIRI';
            vm.Form.objForm.currency = data.currency;
            vm.Form.objForm.link = data.link;
            if(vm.Form.objForm.accountNumber !==null)
            {
              vm.documentNo=vm.Form.objForm.accountNumber;
            } 
            vm.description='Account Mandiri';
            
        }

        function saveData(formController)
        {
            angular.element.blockUI();
            var resp=Form.updateData('updatebank',formController,Bank,empID,'viewBank');
 
             resp.then(function(){
                 vm.messageTheme='blue';
                 angular.element.unblockUI();
                 formController.$setPristine();
                 vm.Form.objForm.dateOfBirth=new Date(vm.Form.objForm.dateOfBirth);
                 $timeout(function() {
                     vm.Form.tampilPesan=false; 
                     vm.stateEdit=false; 
                 }, 3000);

             });

            resp.catch(function(){
               vm.messageTheme='pink';
                angular.element.unblockUI();

           });
        }

        function uploadAccMandiri(ev) {
          $mdDialog.show({
            controller: 'EbankController',
            controllerAs: 'vm',
            templateUrl: 'app/main/echeckin/bank/upload.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function(element, removePromise) {
              loadData();
              loadDataCheck();
            }
          });
        }

        function upload() {
          var resp = vm.FileUploaderAccMandiri.uploadAll();
        }

        var uploaderNpwp = (vm.FileUploaderAccMandiri = new FileUploader({
          url: config.api + 'api/documents/upload',
          removeAfterUpload: true,
          alias: 'ijazah',
          onBeforeUploadItem: function() {
            angular.element.blockUI();
          },
          formData: [
            {
              action: 'uploadijazah',
              documentNo: vm.documentNo,
              typeOfDocument: '10',
              expiredDate: '9999-12-31',
              description: vm.description
            }
          ],
          onAfterAddingAll: function() {
            vm.UploadNpwpStateSucces = false;
            vm.UploadNpwpStateError = false;
            angular.element.unblockUI();
          },
          headers: {
            tokenAuth: $localStorage.tokenAuth
          },
          onSuccessItem: function(item, response, status, headers) {
            angular.element.unblockUI();
            if ( response.error ) {
              vm.message.uplodFailed = response.pesan;
              vm.uploadAccMandiriStateSucces = false;
              vm.uploadAccMandiriStateError = true;
              $scope.hasUpload = false;
            } else {
              vm.message.uploadSuccess = response.pesan;
              vm.uploadAccMandiriStateSucces = true;
              vm.uploadAccMandiriStateError = false;
              
              $timeout(function() {
                $mdDialog.hide();
                vm.hasUpload = true;
                $scope.hasUpload = true;
              }, 1000);
            }
            
          },
          onErrorItem: function(item, response, status, headers) {
            angular.element.unblockUI();
            vm.message.uplodFailed = 'Upload failed';
            vm.uploadAccMandiriStateSucces = false;
            vm.uploadAccMandiriStateError = true;
            $scope.hasUpload = false;
          }
        }));

        function closeModal() {
          $mdDialog.hide();
        }

        function viewDokumen(ev, img)
        {
            $mdDialog.show({    
                controller         : 'ViewDocController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/echeckin/dokumen/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                },
                locals:{
                  img:img
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('InputbahasaController', InputbahasaController);


    InputbahasaController.$inject = ['$stateParams', '$document', '$localStorage', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'Echeckin', '$filter'];
    /** @ngInject */
    function InputbahasaController($stateParams, $document, $localStorage, $mdDialog, Auth, Form, AppAPI, Echeckin, $filter) {
        var vm = this;

        var translate = $filter('translate');
        // initial form
        Form.initialForm();

        var Language = AppAPI.Language();

        // set constructor form
        Form.setObject(Language);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;

        vm.saveData = saveData;
        // vm.listLang=[];

        var empID = $localStorage.username;

        viewLang();

        function viewLang() {
            angular.element.blockUI();
            var dataPromise = Language.query({ action: 'viewLang' });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listLang = data;
            console.log(vm.listLang);
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.empId = window.atob(decodeURIComponent(empID));
            vm.Form.objForm.typeOfLanguage = '-';
            var promise = Form.saveData('save', formController, Language);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            }).catch(function (data) {
                vm.messageTheme = 'red';
                showDialogInfo(ev, data.data);
            });
        }

        function showDialog(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();  
(function () {
	'use strict';

	angular
		.module('app.echeckin')
		.controller('EditbahasaController', EditbahasaController);

	/** @ngInject */
	EditbahasaController.$inject = ['$mdDialog', 'id', 'AppAPI', 'Auth', 'Form', '$filter'];
	/** @ngInject */
	function EditbahasaController($mdDialog, id, AppAPI, Auth, Form, $filter) {
		var vm = this;

		var translate = $filter('translate');
		// initial form
		Form.initialForm();

		// get constructor form
		var Language = AppAPI.Language();

		// set constructor form
		Form.setObject(Language);

		// set form to controller
		vm.Form = Form;

		var response = vm.Form.objForm.$get({ action: 'viewDetail', id: id.id });
		response.then(SetData);
		vm.closeModal = closeModal;
		vm.id = id;
		vm.saveData = saveData;
		vm.setToken = Auth.setToken;

		vm.messageTheme = 'pink';

		viewLang();

		function viewLang() {
			angular.element.blockUI();
			var dataPromise = Language.query({ action: 'viewLang' });
			dataPromise.$promise.then(fetchData);
			dataPromise.$promise.catch(errorFetch);
		}

		function fetchData(data) {
			vm.listLang = data;
			angular.element.unblockUI();
		}

		function errorFetch() {
			vm.listData = [];
			angular.element.unblockUI();
		}

		function closeModal() {
			$mdDialog.hide();
		}

		function SetData(data) {
			vm.Form.objForm.languageCode = data.language_code;
			vm.Form.objForm.typeOfLanguage = data.type_of_language;
		}


		/*	    function saveData(ev,formController) {
					Form.objForm.id=id.id;
					var promise= Form.saveData('updatelanguage', formController, Employe);
					promise.then(function(){
						showDialog(ev);
					});
				}
		*/
		function saveData(ev, formController) {
			vm.Form.objForm.typeOfLanguage = '-';
			var promise = Form.saveData('update', formController, Language);
			promise.then(function (data) {
				showDialogInfo(ev, data);
			});
			promise.catch(function (data) {
				showDialogInfo(ev, data.data);
			})
		}

		function showDialog(ev) {
			$mdDialog.show(
				$mdDialog.alert()
					.parent(angular.element(document.querySelector('#contentDialog')))
					.clickOutsideToClose(true)
					.title('Success Save Data')
					.textContent('Process Data was Success.')
					.ariaLabel('Success Save Data')
					.ok('OK')
					.targetEvent(ev)
			).then(function () {
				closeModal();
			});
		}

		function showDialogInfo(ev, data) {
			var message = translate(data.pesan);
			var status = translate(data.status);
			$mdDialog
				.show(
					$mdDialog
						.alert()
						.parent(angular.element(document.querySelector('#contentDialog')))
						.clickOutsideToClose(true)
						.title(status)
						.textContent(message)
						.ariaLabel(status)
						.ok('OK')
						.targetEvent(ev)
				)
				.then(function () {
					dialogClose();
				});
		}

		function dialogClose() {
			$mdDialog.hide();
		}
	}

})();  

(function () {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('BahasaController', BahasaController);


    BahasaController.$inject = ['$state', '$stateParams', '$document', '$localStorage', '$mdDialog', 'Auth', 'Form', 'AppAPI', 'Echeckin', '$filter'];
    /** @ngInject */
    function BahasaController($state, $stateParams, $document, $localStorage, $mdDialog, Auth, Form, AppAPI, Echeckin, $filter) {
        var vm = this;

        var translate = $filter('translate');
        // initial form
        Form.initialForm();

        var Employe = AppAPI.Employe();
        var Language = AppAPI.Language();

        // set constructor form
        Form.setObject(Language);

        // set form to controller
        vm.Form = Form;

        Echeckin.breadcrumb = [
            {
                state: 'app.echeckin.dashboard',
                name: 'Halaman Depan',
                active: 0

            },
            {
                state: '',
                name: 'Bahasa',
                active: 1

            }
        ];

        vm.openInputLanguage = openInputLanguage;
        vm.editInputLanguage = editInputLanguage;


        vm.listData = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listDataSelected = [];

        vm.deleteData = deleteData;
        var empID = $localStorage.username;
        vm.goBack = goBack;



        viewData();




        function viewData() {
            angular.element.blockUI();
            var dataPromise = Language.query({ action: 'viewData', emp_id: empID });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listData = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listData = [];
            angular.element.unblockUI();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function goBack() {
            $state.go('app.echeckin.dashboard');
        }

        function checkAll() {
            vm.listDataSelected = angular.copy(vm.listData);
            console.log(vm.listDataSelected);

        }

        function unCheckAll() {
            vm.listDataSelected = [];
            console.log(vm.listDataSelected);
        }

        function checkone(div) {
            console.log(div);
            div.isChecked = !div.isChecked;
        }


        function openInputLanguage(ev) {
            $mdDialog.show({
                controller: 'InputbahasaController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/bahasa/inputbahasa.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });
        }

        function editInputLanguage(ev, id) {
            $mdDialog.show({
                controller: 'EditbahasaController',
                controllerAs: 'vm',
                templateUrl: 'app/main/echeckin/bahasa/inputbahasa.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    id: id
                },
                onRemoving: function (element, removePromise) {
                    viewData();
                }
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Language.delete({ action: 'deletelanguage', data: angular.toJson(vm.listDataSelected) });

                    response.$promise.then(viewData);
                }, function () {

                });
            });


        }

    }
})();  
(function () 
{
    'use strict';

    angular
        .module('app.echeckin')
        .controller('UploadKtpController', UploadKtpController);

    /** @ngInject */
    UploadKtpController.$inject=['$localStorage','$mdDialog','$stateParams','AppAPI','Auth','Form','config','FileUploader'];
    /** @ngInject */
    function UploadKtpController($localStorage,$mdDialog,$stateParams,AppAPI,Auth,Form,config,FileUploader)
    {
        
      var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Document=AppAPI.Address();
        var Doc=AppAPI.Document();

	    // set constructor form
	    Form.setObject(Document);

	    // set form to controller
	    vm.Form = Form;
 

	    vm.closeModal=closeModal; 
	    vm.setToken=Auth.setToken;
        vm.goNav=goNav; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;
        vm.upload=upload;
        vm.isChecked=isChecked;
        vm.forever = false;
        vm.toggleCheck = toggleCheck;
        vm.seumurhidupChecked=false;
        vm.typeOfDocument='ktp';
        vm.empID=$localStorage.username;
  
	    vm.messageTheme='pink';
  
        vm.message = {
        title: 'Process Upload File',
        ariaLabel: '',
        textContent: ''
      }
 
        
        loadNoKTP();

        function loadNoKTP()
        {
            var docs=new Doc();
            var response=docs.$get({action:'viewidktp',id:vm.empID});
            response.then(fetchNoKTP);
            response.catch(errorfetchNoKTP);
        }

        function fetchNoKTP(data)
        {
            console.log(data);
            vm.documentNo=data.noktp;
        }

        function errorfetchNoKTP(data)
        {
            vm.documentNo=[];
        }

	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

        function upload()
        {
            
             var resp=vm.FileUploaderPhoto.uploadAll();

        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({ 
           url:config.api+'api/documents/uploadktp', 
           removeAfterUpload:true,
           alias:'ktp',
           onBeforeUploadItem :function(){
              angular.element.blockUI();
           }, 
           formData:[
              {
               action:'uploadktp',
               documentNo:vm.documentNo,
               typeOfDocument:vm.typeOfDocument,
               description:vm.description
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
                angular.element.unblockUI();
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth 
              },
            onSuccessItem:function(item, response, status, headers){
              if (response.error) {
                vm.message = {
                  ariaLabel: 'Upload file has been failed',
                  textContent: response.pesan
                }
              } else {
                vm.message = {
                  ariaLabel: 'Upload file has been successfully',
                  textContent: response.pesan
                }
              }
              showDialog();
              angular.element.unblockUI();
            }
        });

        uploaderPhoto.filters.push({
            name: 'syncFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                vm.sizefile=item.size; 
                // console.log(vm.sizefile); 
                return true;
            }
        });

        function goNav(state) {
            $state.go(state);
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title(vm.message.title)
          .textContent(vm.message.textContent)
          .ariaLabel(vm.message.ariaLabel)
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
                vm.checkKTP = true;
		        closeModal();
		    });
	    }

    function isChecked()
        {
            // console.log(vm.seumurhidupChecked);
            vm.ktpSeumurHidup=false;
            if(vm.seumurhidupChecked){
              vm.ktpSeumurHidup=true;
              vm.forever = true;
              vm.expiredDate = '9999-12-31';
            }

            console.log(vm.ktpSeumurHidup);
        }

    function toggleCheck(event)
      {
          if ( event )
          {
              event.stopPropagation();
          }  
      }

    }
})();  

(function () 
{
    'use strict';

    angular
        .module('app.echeckin')
        .controller('EditKtpController', EditKtpController);

    /** @ngInject */
    EditKtpController.$inject=['$localStorage','$mdDialog','$stateParams','id','AppAPI','Auth','Form','config','FileUploader'];
    /** @ngInject */
    function EditKtpController($localStorage,$mdDialog,$stateParams,id,AppAPI,Auth,Form,config,FileUploader)
    {
        
      var vm = this;
	    // initial form
	    Form.initialForm();

	    // get constructor form
	    var Document=AppAPI.Address();
      var Doc=AppAPI.Document();

	    // set constructor form
	    Form.setObject(Document);

	    // set form to controller
	    vm.Form = Form;
 

	    vm.closeModal=closeModal; 
	    vm.setToken=Auth.setToken;
      vm.goNav=goNav; 
      vm.uploadFile=uploadFile;
      vm.UploadPhotoStateSucces=false;
      vm.UploadPhotoStateError=false;
      vm.upload=upload;
      vm.isChecked=isChecked;
      vm.forever = false;
      vm.toggleCheck = toggleCheck;
      vm.seumurhidupChecked=false;
      vm.typeOfDocument='ktp';
      vm.empID=$localStorage.username;

	    vm.messageTheme='pink';

      vm.message = {
        title: 'Process Upload File',
        ariaLabel: '',
        textContent: ''
      }

      loadData();

      //////////////////////// 

      function loadData() {
        var docs=new Doc();
            var response=docs.$get({action:'viewDetail',id:id});
            // console.log(response);
            response.then(SetData);
        }

      function SetData(data)
      {
        if(data.expired_date=='9999-12-31'){
          vm.seumurhidupChecked=true;
          vm.ktpSeumurHidup=true; 
        }
        vm.documentNo=data.documentNo;
        vm.description=data.description;
        vm.issuedDate=new Date(data.issued_date);
        vm.Form.objForm.expiredDate=new Date(data.expired_date);
        vm.expiredDate=new Date(data.expired_date);
        // console.log(data);
      }
 
 
	    function closeModal()
	    {
	        $mdDialog.hide();
	    }

        function upload()
        {
            
             var resp=vm.FileUploaderPhoto.uploadAll();

        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({ 
           url:config.api+'api/documents/uploadktp', 
           removeAfterUpload:true,
           alias:'ktp',
           onBeforeUploadItem :function(item){
              var dt= new Date(item.formData[0].issuedDate);
              var et= new Date(item.formData[0].expiredDate);
              // console.log(item);

              var newdate=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
              var newdate1=et.getFullYear()+'-'+(et.getMonth()+1)+'-'+et.getDate();
              item.formData[0].issuedDate= newdate;
              item.formData[0].expiredDate=newdate1; 

              angular.element.blockUI(); 
           }, 
           formData:[
              {
               action:'uploadktp',
               documentNo:vm.documentNo,
               typeOfDocument:vm.typeOfDocument,
               description:vm.description
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
                angular.element.unblockUI();
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth 
              },
            onSuccessItem:function(item, response, status, headers){
              if (response.error) {
                vm.message = {
                  ariaLabel: 'Upload file has been failed',
                  textContent: response.pesan
                }
              } else {
                vm.message = {
                  ariaLabel: 'Upload file has been successfully',
                  textContent: response.pesan
                }
              }
              showDialog();
              angular.element.unblockUI();
            }
        });

        function goNav(state) {
            $state.go(state);
            vm.activeItem = state;
        }

        function uploadFile() {
            return false;
        }

	    function showDialog(ev) {
	        $mdDialog.show(
	        $mdDialog.alert()
	        .parent(angular.element(document.querySelector('#contentDialog')))
	        .clickOutsideToClose(true)
	        .title(vm.message.title)
          .textContent(vm.message.textContent)
          .ariaLabel(vm.message.ariaLabel)
	        .ok('OK')
	        .targetEvent(ev)
		    ).then(function(){
                vm.checkKTP = true;
		        closeModal();
		    });
	    }

    function isChecked()
        {
            // console.log(vm.seumurhidupChecked);
            vm.ktpSeumurHidup=false;
            if(vm.seumurhidupChecked){
              vm.ktpSeumurHidup=true;
              vm.forever = true;
              vm.expiredDate = '9999-12-31';
            } 
            // console.log(vm.ktpSeumurHidup);
        }

    function toggleCheck(event)
      {
          if ( event )
          {
              event.stopPropagation();
          }  
      }

    }
})();  

(function() {
    "use strict";

    angular
        .module("app.echeckin")
        .controller("AlamatController", AlamatController);

    AlamatController.$inject = [
        "$scope",
        "$localStorage",
        "$timeout",
        "Echeckin",
        "Form",
        "AppAPI",
        "Auth",
        "$mdDialog",
        "$http",
        "config"
    ];

    /* @ngInject */
    function AlamatController(
        $scope,
        $localStorage,
        $timeout,
        Echeckin,
        Form,
        AppAPI,
        Auth,
        $mdDialog,
        $http,
        config
    ) {
        var vm = this;
        Echeckin.breadcrumb = [
            {
                state: "app.echeckin.dashboard",
                name: "Halaman Depan",
                active: 0
            },
            {
                state: "",
                name: "Alamat",
                active: 1
            }
        ];

        // initial form
        Form.initialForm();

        var Address = AppAPI.Address();
        var Lokasi = AppAPI.Infolokasi();
        var Document = AppAPI.Document();
        var Profiles = AppAPI.Profiles();

        var empID = $localStorage.username;

        // set constructor form
        Form.setObject(Address);

        // set form to controller
        vm.Form = Form;
        vm.loadKab = loadKab;
        vm.loadKec = loadKec;
        vm.loadKabKtp = loadKabKtp;
        vm.loadKecKtpe = loadKecKtp;
        vm.Uploadktp = Uploadktp;
        vm.viewDoc = viewDoc;
        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        vm.listProvince = [];
        vm.listKab = [];
        vm.listKec = [];
        vm.listKtp = [];
        vm.checkKTP = false;
        vm.saveAddress = saveAddress;
        vm.clearMeesage = clearMeesage;
        vm.stateEdit = false;
        vm.ChangeState = ChangeState;
        vm.alamatsekarang = alamatsekarang;
        var addressdata = null;
        vm.editKTP = editKTP;

        loadData();
        checkStatusKtp();
        viewData();
        loadKtp();

        function loadData() {
            var response = vm.Form.objForm.$get({
                action: "viewAddress",
                id: empID
            });
            // console.log(response);
            response.then(SetData);
        }

        function checkStatusKtp() {
            var promises = Profiles.query({
                action: "checkCompletionData",
                id: empID
            });
            promises.$promise.then(fetchDataCheck);
        }

        function fetchDataCheck(data) {
            vm.checkKTP = data[0].doc_ktp;
        }

        function ChangeState() {
            // console.log(addressdata);
            switch (vm.stateEdit) {
                case true:
                    vm.stateEdit = false;
                    loadData();
                    checkStatusKtp();
                    break;
                case false:
                    vm.stateEdit = true;
                    vm.Form.objForm.alamatsekarangdigunakan = addressdata.alamatsekarangdigunakan;
                    vm.Form.objForm.addressCurrent = addressdata.addressCurrent;
                    vm.Form.objForm.phoneCurrent = addressdata.phoneCurrent;
                    // vm.Form.objForm.rtCurrent=addressdata.rtCurrent;
                    // vm.Form.objForm.rwCurrent=addressdata.rwCurrent;
                    vm.Form.objForm.provinsiCurrent = addressdata.provinsiCurrent;
                    vm.Form.objForm.kabKotaCurrent = addressdata.kabKotaCurrent;
                    vm.Form.objForm.kecCurrent = addressdata.kecCurrent;
                    vm.Form.objForm.kodePosCurrent = addressdata.kodePosCurrent;
                    vm.Form.objForm.kelurahanCurrent =
                        addressdata.kelurahanCurrent;
                    break;
            }
        }

        function SetData(data) {
            // console.log(data);
            addressdata = data;
            if (data.addressKtp == null) {
                vm.Form.objForm.alamatsekarangdigunakan = "noktp";
            } else if (
                data.addressKtp == data.addressCurrent &&
                data.provinsiKtp == data.provinsiCurrent
            ) {
                vm.Form.objForm.alamatsekarangdigunakan = "ktp";
            } else {
                vm.Form.objForm.alamatsekarangdigunakan = "noktp";
            }
        }

        // ===== watch =======

        $scope.$watch("vm.Form.objForm.provinsiCurrent", watchProv);
        $scope.$watch("vm.Form.objForm.kabKotaCurrent", watchKab);

        $scope.$watch("vm.Form.objForm.provinsiKtp", watchProvKtp);
        $scope.$watch("vm.Form.objForm.kabKotaKtp", watchKabKtp);

        function watchProv() {
            var prov = vm.Form.objForm.provinsiCurrent;
            if (prov != null || prov != undefined) {
                loadKab(prov);
            }

            // console.log(prov);
        }

        function watchKab() {
            var kab = vm.Form.objForm.kabKotaCurrent;
            if (kab != null || kab != undefined) {
                loadKec(kab);
            }
        }

        function watchProvKtp() {
            var prov = vm.Form.objForm.provinsiKtp;
            if (prov != null || prov != undefined) {
                loadKabKtp(prov);
            }

            // console.log(prov);
        }

        function watchKabKtp() {
            var kab = vm.Form.objForm.kabKotaKtp;
            if (kab != null || kab != undefined) {
                loadKecKtp(kab);
            }
        }

        // =====end watch===

        function viewData() {
            angular.element.blockUI();
            var dataPromise = Lokasi.query({ action: "infoPropinsi" });
            dataPromise.$promise.then(fetchData);
            dataPromise.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            vm.listProvince = data;
            // console.log(vm.listProvince);
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listProvince = [];
            angular.element.unblockUI();
        }

        function loadKab(prov) {
            // console.log(prov);
            angular.element.blockUI();
            var dataPromise = Lokasi.query({
                action: "infoKabupaten",
                kode: prov
            });
            dataPromise.$promise.then(fetchKab);
            dataPromise.$promise.catch(errorFetchKab);
        }

        function fetchKab(data) {
            vm.listKab = data;
            // console.log(vm.listProvince);
            angular.element.unblockUI();
        }

        function errorFetchKab() {
            vm.listKab = [];
            angular.element.unblockUI();
        }

        function loadKec(kab) {
            var dataPromise = Lokasi.query({
                action: "viewKecamatan",
                kode: kab
            });
            dataPromise.$promise.then(fetchKec);
            dataPromise.$promise.catch(errorFetchKec);
        }

        function fetchKec(data) {
            vm.listKec = data;
            // console.log(vm.listProvince);
            angular.element.unblockUI();
        }

        function errorFetchKec() {
            vm.listKec = [];
            angular.element.unblockUI();
        }

        //KTP
        function loadKabKtp(prov) {
            angular.element.blockUI();
            var dataPromise = Lokasi.query({
                action: "infoKabupaten",
                kode: prov
            });
            dataPromise.$promise.then(fetchKabKtp);
            dataPromise.$promise.catch(errorFetchKabKtp);
        }

        function fetchKabKtp(data) {
            vm.listKabKtp = data;
            // console.log(vm.listProvince);
            angular.element.unblockUI();
        }

        function errorFetchKabKtp() {
            vm.listKabKtp = [];
            angular.element.unblockUI();
        }

        function loadKecKtp(kab) {
            var dataPromise = Lokasi.query({
                action: "viewKecamatan",
                kode: kab
            });
            dataPromise.$promise.then(fetchKecKtp);
            dataPromise.$promise.catch(errorFetchKecKtp);
        }

        function fetchKecKtp(data) {
            vm.listKecKtp = data;
            // console.log(vm.listProvince);
            angular.element.unblockUI();
        }

        function errorFetchKecKtp() {
            vm.listKecKtp = [];
            angular.element.unblockUI();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveAddress(formController) {
            angular.element.blockUI();
            // console.log(formController);
            var response = Form.updateData(
                "updateaddress",
                formController,
                Address,
                empID,
                "viewAddress"
            );
            response.then(function() {
                vm.messageTheme = "blue";
                angular.element.unblockUI();
                formController.$setPristine();

                $timeout(function() {
                    vm.Form.tampilPesan = false;
                    vm.stateEdit = false;
                }, 3000);
            });

            response.catch(function() {
                vm.messageTheme = "pink";
                angular.element.unblockUI();
            });
        }

        function alamatsekarang() {
            // console.log(addressdata);
            switch (vm.Form.objForm.alamatsekarangdigunakan) {
                case "ktp":
                    vm.Form.objForm.addressCurrent = vm.Form.objForm.addressKtp;
                    vm.Form.objForm.phoneCurrent = vm.Form.objForm.phoneKtp;
                    // vm.Form.objForm.rtCurrent = vm.Form.objForm.rtKtp;
                    // vm.Form.objForm.rwCurrent = vm.Form.objForm.rwKtp;
                    vm.Form.objForm.provinsiCurrent = vm.Form.objForm.provinsiKtp;
                    vm.Form.objForm.kabKotaCurrent = vm.Form.objForm.kabKotaKtp;
                    vm.Form.objForm.kecCurrent = vm.Form.objForm.kecKtp;
                    vm.Form.objForm.kelurahanCurrent =
                        vm.Form.objForm.kelurahanKtp;
                    vm.Form.objForm.kodePosCurrent = vm.Form.objForm.kodePosKtp;
                    break;
                case "noktp":
                    vm.Form.objForm.addressCurrent = addressdata.addressCurrent;
                    vm.Form.objForm.phoneCurrent = addressdata.phoneCurrent;
                    vm.Form.objForm.rtCurrent = addressdata.rtCurrent;
                    vm.Form.objForm.rwCurrent = addressdata.rwCurrent;
                    vm.Form.objForm.provinsiCurrent = addressdata.provinsiCurrent;
                    vm.Form.objForm.kabKotaCurrent = addressdata.kabKotaCurrent;
                    vm.Form.objForm.kecCurrent = addressdata.kecCurrent;
                    vm.Form.objForm.kodePosCurrent = addressdata.kodePosCurrent;
                    vm.Form.objForm.kelurahanCurrent =
                        addressdata.kelurahanCurrent;
                    break;
            }
        }

        function loadKtp() {
            var resp = Document.query({
                action: "viewData",
                emp_id: empID,
                type: "ktp"
            });
            // console.log(resp);
            resp.$promise.then(fetchKtp);
            resp.$promise.catch(errorFetchKtp);
        }

        function fetchKtp(data) {
            vm.listKtp = data[0];
            vm.idKtp = data[0].id;
            if (vm.listKtp) {
                vm.doc = vm.listKtp.link;
            }

            if (vm.doc.slice(-3) === "pdf") {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = "api/empdocument/" + vm.doc +
                "?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;";
        }

        function errorFetchKtp() {
            vm.listKtp = [];
        }

        function Uploadktp(ev) {
            $mdDialog.show({
                controller: "UploadKtpController",
                controllerAs: "vm",
                templateUrl: "app/main/echeckin/alamat/upload-ktp.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData();
                    checkStatusKtp();
                    loadKtp();
                    vm.stateEdit = true;
                }
            });
        }

        function viewDoc(ev) {
            // console.log(vm.doc);

            $mdDialog.show({
                controller: "AlamatController",
                controllerAs: "vm",
                templateUrl: "app/main/echeckin/alamat/view-doc.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    viewData();
                }
            });
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            // console.log(link);
            if (name !== null && name !== "-") {
                $http({
                    method: "GET",
                    url: config.api + "api/empdocument/" + name,
                    params: { name: name },
                    responseType: "arraybuffer"
                })
                    .success(function(data, status, headers) {
                        headers = headers();
                        // console.log(data);
                        var filename = name;
                        var contentType = headers["content-type"];

                        var linkElement = document.createElement("a");
                        try {
                            var blob = new Blob([data], { type: contentType });
                            var url = window.URL.createObjectURL(blob);

                            linkElement.setAttribute("href", url);
                            linkElement.setAttribute("download", filename);

                            var clickEvent = new MouseEvent("click", {
                                view: window,
                                bubbles: true,
                                cancelable: false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                    })
                    .error(function(data) {
                        console.log(data);
                    });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector("#contentDialog")
                                )
                            )
                            .clickOutsideToClose(true)
                            .title("Document Not Found")
                            .textContent("Document not Found")
                            .ariaLabel("Failed Save Data")
                            .ok("OK")
                            .targetEvent(ev)
                    )
                    .then(function() {
                        // closeModal();
                    });
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function editKTP(ev) {
            $mdDialog.show({
                controller: "EditKtpController",
                controllerAs: "vm",
                templateUrl: "app/main/echeckin/alamat/upload-ktp.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData();
                    checkStatusKtp();
                    loadKtp();
                    vm.stateEdit = true;
                },
                locals: {
                    id: vm.idKtp
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.development.download', [
        ])
        .config(config);

    config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {       

        $stateProvider
        .state('app.development_download', {
            url    : '/development/download',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/development/download/download.html',
                    controller : 'DevelopmentDownloadController as vm'
                }
            }
        });

        // $translatePartialLoaderProvider.addPart('app/main/pms/competency');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.development.download')
        .controller('DevelopmentDownloadController', DevelopmentDownloadController);

    DevelopmentDownloadController.$inject = ['$state', '$stateParams', '$log', '$mdDialog', 'config', 'AppAPI', 'Auth', 'DataService', '$document', '$location', '$window'];
    /** @ngInject */
    function DevelopmentDownloadController($state, $stateParams, $log, $mdDialog, config, AppAPI, Auth, DataService, $document, $location, $window) {

        var vm = this;
        vm.ExportAllEmployeetoExcel = ExportAllEmployeetoExcel;
        vm.ExportRcPrToExcel = ExportRcPrToExcel;

        function ExportAllEmployeetoExcel() {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var bu = "-";
            var divisi = "-";
            var department = "-";
            if (vm.bu !== "") {
                bu = vm.bu;
            }
            if (vm.divisi !== "") {
                divisi = vm.divisi;
            }
            if (vm.department !== "") {
                department = vm.department;
            }
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/developmentdownload/trexportexcel/' + bu + '/' + divisi + '/' + department + '/' + data.token, '_blank');
                console.log(config.api);
            }, function () {
                $window.alert('gagal load token')
            });
        }

        function ExportRcPrToExcel() {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var bu = "-";
            var divisi = "-";
            var department = "-";
            if (vm.bu !== "") {
                bu = vm.bu;
            }
            if (vm.divisi !== "") {
                divisi = vm.divisi;
            }
            if (vm.department !== "") {
                department = vm.department;
            }
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/developmentdownload/crprexportexcel/' + bu + '/' + divisi + '/' + department + '/' + data.token, '_blank');
                console.log(config.api);
            }, function () {
                $window.alert('gagal load token')
            });
        }

    }


})();
(function () {
    'use strict';

    angular
        .module('app.correspondence.requirement')
        .controller('CorrespondenceRequirementController', Controller);

    Controller.$inject = [
        'AppAPI',
        '$state',
        '$localStorage',
        'Auth',
        '$mdDialog',
        'DataService'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $state,
        $localStorage,
        Auth,
        $mdDialog,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.Correspondence().administrator;
        vm.DataTable = new DataService();
        vm.status = 'all';
        vm.loadData = loadData;
        vm.listJum = [5, 10, 20, 25, 50];
        vm.DataTable.jumDataPerPage = 20;
        vm.showRequestDialog = showRequestDialog;
        vm.isCheckAction = false;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isChecked = isChecked;
        vm.checked = [];
        vm.checkedAll = false;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.deleteRequest = deleteRequest;
        vm.showFilter = true;
        vm.disabledSelectAll = disabledSelectAll;
        vm.setStatus = setStatus;

        activate();

        function activate() {
            loadData(1);
        }

        loadData(1);

        function loadData(pageno) {
            vm.DataTable.loadData(endpoint, pageno, {
                action: "getDataRequestRequirement",
                status: vm.status
            });
        }

        function setStatus(item) {
            vm.updateProcess = true;
            angular.element.blockUI()
            var promise = Auth.setToken();
            promise.then(function () {
                var request = endpoint.save({
                    action: 'updateDataRequestRequirement',
                    id: item.id,
                    name: item.name,
                    status: item.status
                });
                request.$promise.then(function (data) {
                    angular.element.unblockUI();
                    loadData(1);
                });
                request.$promise.catch(function (error) {
                    angular.element.unblockUI();
                    loadData(1);
                });
            });
        }

        function showRequestDialog(ev, type, item) {
            $mdDialog.show({
                controller: 'CorrespondenceRequirementFormController as vm',
                templateUrl: 'app/main/correspondence/requirement/form/form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dialogType: type,
                    reffData: item
                }
            }).then(function () {
                loadData(1);
            });
        }

        function disabledSelectAll() {
            var response = false;
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].status == 'progress') {
                    response = true;
                    break;
                }
            }
            return response;

        }

        function toggle(item) {
            var idx = vm.checked.indexOf(item);
            if (idx > -1) {
                vm.checked.splice(idx, 1);
            } else {
                vm.checked.push(item);
            }
            console.log(vm.checked);
        }

        function exists(item) {
            return vm.checked.indexOf(item) > -1;
        }

        function isChecked() {
            return vm.checked.length === vm.DataTable.list.length;
        }

        function isIndeterminate() {
            return (vm.checked.length !== 0 && vm.checked.length !== vm.DataTable.list.length);
        }

        function toggleAll() {
            if (vm.checked.length === vm.DataTable.list.length) {
                vm.checked = [];
            } else if (vm.checked.length === 0 || vm.checked.length > 0) {
                angular.forEach(vm.DataTable.list, function (v, k) {
                    if (!exists(v.id)) {
                        vm.checked.push(v.id);
                    }
                })
            }
        };

        function deleteRequest(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent('Data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = endpoint.delete({
                            action: 'deleteDataRequestRequirement',
                            data: angular.toJson(vm.checked)
                        });
                        response.$promise.then(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }


        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.message)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.correspondence.requestor')
        .controller('CorrespondenceRequestorController', Controller);

    Controller.$inject = [
        'AppAPI',
        '$state',
        '$localStorage',
        '$scope',
        '$mdToast',
        'Auth',
        '$mdDialog',
        'DataService'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $state,
        $localStorage,
        $scope,
        $mdToast,
        Auth,
        $mdDialog,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.Correspondence().requestor;
        vm.DataTable = new DataService();
        vm.type = 0;
        vm.status = 'all';
        vm.loadData = loadData;
        vm.isAlreadyApproved = isAlreadyApproved;
        vm.listJum = [5, 10, 20, 25, 50];
        vm.DataTable.jumDataPerPage = 20;
        vm.showRequestDialog = showRequestDialog;
        vm.requestType = [];
        vm.countryCodes = [];
        vm.isCheckAction = false;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isChecked = isChecked;
        vm.checked = [];
        vm.checkedAll = false;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.deleteRequest = deleteRequest;
        vm.showFilter = true;
        vm.requestTypeFilter = [];
        vm.disabledSelectAll = disabledSelectAll;
        vm.requirements = [];


        activate();

        function activate() {
            loadData(1);
            getRequestType();
            getCountryCodes();
            getRequirement();
        }


        function loadData(pageno) {
            vm.DataTable.loadData(endpoint, pageno, {
                action: "getDataRequest",
                type: vm.type,
                status: vm.status
            });
        }

        function showRequestDialog(ev, type, item) {
            var group = 'user';
            $mdDialog.show({
                controller: 'CorrespondenceRequestorFormController as vm',
                templateUrl: 'app/main/correspondence/requestor/form/form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    groupUser: group,
                    dialogType: type,
                    reffData: item,
                    requestType: vm.requestType,
                    countryCodes: vm.countryCodes,
                    requirements: vm.requirements,
                    isAdmin: false
                }
            }).then(function () {
                loadData(1);
            });
        }

        function getRequirement() {
            var response = endpoint.query({
                action: 'getRequirement'
            });
            response.$promise.then(function (data) {
                vm.requirements = data;
            });
            response.$promise.catch(function (err) {
                vm.requirements = [];
            });
        }

        function getRequestType() {
            var response = endpoint.query({
                action: 'getRequestType'
            });
            response.$promise.then(function (data) {
                vm.requestType = data;
                vm.requestTypeFilter = angular.copy(data);
                vm.requestTypeFilter.unshift({
                    'id': 0,
                    'name': 'ALL',
                    'description': 'ALL'
                });
            });
            response.$promise.catch(function (err) {
                vm.requestType = [];
                vm.requestTypeFilter = [];
            });
        }


        function getCountryCodes() {
            var response = endpoint.query({
                action: 'getCountryCodes'
            });
            response.$promise.then(function (data) {
                vm.countryCodes = data;
            });
            response.$promise.catch(function (err) {
                vm.countryCodes = [];
            });
        }

        function isAlreadyApproved(status) {
            return status != 'register';
        }

        function toggle(item) {
            var idx = vm.checked.indexOf(item);
            if (idx > -1) {
                vm.checked.splice(idx, 1);
            } else {
                vm.checked.push(item);
            }
            console.log(vm.checked);
        }

        function exists(item) {
            return vm.checked.indexOf(item) > -1;
        }

        function isChecked() {
            return vm.checked.length === vm.DataTable.list.length;
        }

        function isIndeterminate() {
            return (vm.checked.length !== 0 && vm.checked.length !== vm.DataTable.list.length);
        }

        function toggleAll() {
            if (vm.checked.length === vm.DataTable.list.length) {
                vm.checked = [];
            } else if (vm.checked.length === 0 || vm.checked.length > 0) {
                angular.forEach(vm.DataTable.list, function (v, k) {
                    if (!exists(v.id)) {
                        vm.checked.push(v.id);
                    }
                })
            }
        };

        function deleteRequest(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent('Data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = endpoint.delete({
                            action: 'deleteRequest',
                            data: angular.toJson(vm.checked)
                        });
                        response.$promise.then(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.message)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function disabledSelectAll() {
            var response = false;
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].status == 'progress') {
                    response = true;
                    break;
                }
            }
            return response;

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.correspondence.decision_letter')
        .controller('CorrespondenceDecisionLetterController', Controller);

    Controller.$inject = [
        'AppAPI',
        '$state',
        '$localStorage',
        'Auth',
        '$mdDialog',
        'DataService'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $state,
        $localStorage,
        Auth,
        $mdDialog,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.Correspondence().administrator;
        vm.DataTable = new DataService();
        vm.status = 'all';
        vm.loadData = loadData;
        vm.listJum = [5, 10, 20, 25, 50];
        vm.DataTable.jumDataPerPage = 20;
        vm.showRequestDialog = showRequestDialog;
        vm.isCheckAction = false;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isChecked = isChecked;
        vm.checked = [];
        vm.checkedAll = false;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.deleteRequest = deleteRequest;
        vm.showFilter = true;
        vm.disabledSelectAll = disabledSelectAll;
        vm.printPDF = printPDF;
        vm.decisionTypeList = [];
        vm.code = 'all';
        vm.getFinishedAt = getFinishedAt;
        vm.getLeadTime = getLeadTime;
        vm.updateStatusRequest = updateStatusRequest;


        activate();

        function activate() {
            getDecisionType();
            loadData(1);
        }

        function loadData(pageno) {
            vm.DataTable.loadData(endpoint, pageno, {
                action: "getDataDecision",
                status: vm.status,
                code: vm.code,
                type: 'promosi'
            });
        }

        function getDecisionType() {
            var response = endpoint.query({
                action: 'getDataDecisionType',
                type: 'promosi'
            });
            response.$promise.then(function (data) {
                vm.decisionTypeList = data;
            });
            response.$promise.catch(function (err) {
                vm.decisionTypeList = [];
            });
        }

        function updateStatusRequest(ev, item, status) {

            var title = 'Would you like to set this to ' + status.toUpperCase() + ' ?';
            var tContent = 'Request will be set from ' + item.status.toUpperCase() + ' to ' + status.toUpperCase();

            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(tContent)
                .ariaLabel('dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog
                .show(confirm)
                .then(function () {
                    setStatusRequest(ev, item, status);
                });

        }

        function setStatusRequest(ev, item, status) {
            var promise = Auth.setToken();
            promise.then(function () {
                angular.element.blockUI();
                var response = endpoint.save({
                    action: 'updateDataDecision',
                    id: item.id,
                    status: status
                });
                response.$promise.then(function (data) {
                    angular.element.unblockUI();
                    showDialog(ev, data);
                });

                response.$promise.catch(function (data) {
                    angular.element.unblockUI();
                    showDialog(ev, data);
                });
            })
        }

        function showRequestDialog(ev, type, item) {
            $mdDialog.show({
                controller: 'CorrespondenceDecisionFormController as vm',
                templateUrl: 'app/main/correspondence/decision-letter/form/form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dialogType: type,
                    reffData: item
                }
            }).then(function () {
                loadData(1);
            });
        }

        function getFinishedAt(iDate) {
            var d = new Date(iDate);
            var year = d.getFullYear();
            return year != '1970' ? iDate : 'NOT FINISHED';
        }

        function getLeadTime(cDate, fDate) {
            var tmpcDate = new Date(cDate);
            var tmpfDate = new Date(fDate);
            var leadTime = '-';
            if (tmpfDate.getFullYear() != '1970') {
                var temp = moment.duration(moment(tmpcDate).diff(moment(tmpfDate)));
                var day = Math.abs(temp.days()) + ' Days ' + +' Hours ' + Math.abs(temp.minutes()) + ' Minutes ';
                var hour = Math.abs(temp.hours());
                var minutes = Math.abs(temp.minutes());
                var seconds = Math.abs(temp.seconds());
                leadTime = day > 0 ? day + ' Days ' : '';
                leadTime += hour > 0 ? hour + ' Hours ' : '';
                leadTime += minutes > 0 ? minutes + ' Min ' : '';
                leadTime += seconds + ' Sec'
            }
            return leadTime;
        }

        function disabledSelectAll() {
            var response = false;
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].status == 'progress') {
                    response = true;
                    break;
                }
            }
            return response;

        }

        function toggle(item) {
            var idx = vm.checked.indexOf(item);
            if (idx > -1) {
                vm.checked.splice(idx, 1);
            } else {
                vm.checked.push(item);
            }
        }

        function exists(item) {
            return vm.checked.indexOf(item) > -1;
        }

        function isChecked() {
            return vm.checked.length === vm.DataTable.list.length;
        }

        function isIndeterminate() {
            return (vm.checked.length !== 0 && vm.checked.length !== vm.DataTable.list.length);
        }

        function toggleAll() {
            if (vm.checked.length === vm.DataTable.list.length) {
                vm.checked = [];
            } else if (vm.checked.length === 0 || vm.checked.length > 0) {
                angular.forEach(vm.DataTable.list, function (v, k) {
                    if (!exists(v.id)) {
                        vm.checked.push(v.id);
                    }
                })
            }
        };

        function deleteRequest(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent('Data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = endpoint.delete({
                            action: 'deleteDataDecision',
                            data: angular.toJson(vm.checked)
                        });
                        response.$promise.then(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }


        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.message)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function printPDF(item) {
            console.log(item);
            item.end_date = new Date(item.end_date);
            switch (item.code) {
                case 'promosi-extend':
                    $state.goNewTab('app.report.correspondence.sk_promosi_extend', {
                        data: encodeURIComponent(JSON.stringify(item))
                    });
                    break;
                case 'promosi-lanjutan':
                    $state.goNewTab('app.report.correspondence.sk_promosi_lanjutan', {
                        data: encodeURIComponent(JSON.stringify(item))
                    });
                    break;
                case 'promosi-lulus':
                    $state.goNewTab('app.report.correspondence.sk_promosi_lulus', {
                        data: encodeURIComponent(JSON.stringify(item))
                    });
                    break;
                case 'promosi-tetap':
                    $state.goNewTab('app.report.correspondence.sk_promosi_tetap', {
                        data: encodeURIComponent(JSON.stringify(item))
                    });
                    break;
            }
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.correspondence.assignment_letter')
        .controller('CorrespondenceAssignmentLetterController', Controller);

    Controller.$inject = [
        'AppAPI',
        '$state',
        '$localStorage',
        'Auth',
        '$mdDialog',
        'DataService'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $state,
        $localStorage,
        Auth,
        $mdDialog,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.Correspondence().administrator;
        vm.DataTable = new DataService();
        vm.status = 'all';
        vm.loadData = loadData;
        vm.listJum = [5, 10, 20, 25, 50];
        vm.DataTable.jumDataPerPage = 20;
        vm.showRequestDialog = showRequestDialog;
        vm.isCheckAction = false;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isChecked = isChecked;
        vm.checked = [];
        vm.checkedAll = false;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.deleteRequest = deleteRequest;
        vm.showFilter = true;
        vm.disabledSelectAll = disabledSelectAll;
        vm.printPDF = printPDF;
        vm.decisionTypeList = [];
        vm.code = 'all';
        vm.getFinishedAt = getFinishedAt;
        vm.getLeadTime = getLeadTime;
        vm.updateStatusRequest = updateStatusRequest;


        activate();

        function activate() {
            getDecisionType();
            loadData(1);
        }

        function loadData(pageno) {
            vm.DataTable.loadData(endpoint, pageno, {
                action: "getDataDecision",
                status: vm.status,
                code: vm.code,
                type: 'penugasan'
            });
        }

        function getDecisionType() {
            var response = endpoint.query({
                action: 'getDataDecisionType',
                type: 'penugasan'
            });
            response.$promise.then(function (data) {
                vm.decisionTypeList = data;
            });
            response.$promise.catch(function (err) {
                vm.decisionTypeList = [];
            });
        }

        function updateStatusRequest(ev, item, status) {

            var title = 'Would you like to set this to ' + status.toUpperCase() + ' ?';
            var tContent = 'Request will be set from ' + item.status.toUpperCase() + ' to ' + status.toUpperCase();

            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(tContent)
                .ariaLabel('dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog
                .show(confirm)
                .then(function () {
                    setStatusRequest(ev, item, status);
                });

        }

        function setStatusRequest(ev, item, status) {
            var promise = Auth.setToken();
            promise.then(function () {
                angular.element.blockUI();
                var response = endpoint.save({
                    action: 'updateDataDecision',
                    id: item.id,
                    status: status
                });
                response.$promise.then(function (data) {
                    angular.element.unblockUI();
                    showDialog(ev, data);
                });

                response.$promise.catch(function (data) {
                    angular.element.unblockUI();
                    showDialog(ev, data);
                });
            })
        }

        function showRequestDialog(ev, type, item) {
            $mdDialog.show({
                controller: 'CorrespondenceAssignmentFormController as vm',
                templateUrl: 'app/main/correspondence/assignment-letter/form/form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dialogType: type,
                    reffData: item
                }
            }).then(function () {
                loadData(1);
            });
        }

        function getFinishedAt(iDate) {
            var d = new Date(iDate);
            var year = d.getFullYear();
            return year != '1970' ? iDate : 'NOT FINISHED';
        }

        function getLeadTime(cDate, fDate) {
            var tmpcDate = new Date(cDate);
            var tmpfDate = new Date(fDate);
            var leadTime = '-';
            if (tmpfDate.getFullYear() != '1970') {
                var temp = moment.duration(moment(tmpcDate).diff(moment(tmpfDate)));
                var day = Math.abs(temp.days()) + ' Days ' + +' Hours ' + Math.abs(temp.minutes()) + ' Minutes ';
                var hour = Math.abs(temp.hours());
                var minutes = Math.abs(temp.minutes());
                var seconds = Math.abs(temp.seconds());
                leadTime = day > 0 ? day + ' Days ' : '';
                leadTime += hour > 0 ? hour + ' Hours ' : '';
                leadTime += minutes > 0 ? minutes + ' Min ' : '';
                leadTime += seconds + ' Sec'
            }
            return leadTime;
        }

        function disabledSelectAll() {
            var response = false;
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].status == 'progress') {
                    response = true;
                    break;
                }
            }
            return response;

        }

        function toggle(item) {
            var idx = vm.checked.indexOf(item);
            if (idx > -1) {
                vm.checked.splice(idx, 1);
            } else {
                vm.checked.push(item);
            }
        }

        function exists(item) {
            return vm.checked.indexOf(item) > -1;
        }

        function isChecked() {
            return vm.checked.length === vm.DataTable.list.length;
        }

        function isIndeterminate() {
            return (vm.checked.length !== 0 && vm.checked.length !== vm.DataTable.list.length);
        }

        function toggleAll() {
            if (vm.checked.length === vm.DataTable.list.length) {
                vm.checked = [];
            } else if (vm.checked.length === 0 || vm.checked.length > 0) {
                angular.forEach(vm.DataTable.list, function (v, k) {
                    if (!exists(v.id)) {
                        vm.checked.push(v.id);
                    }
                })
            }
        };

        function deleteRequest(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent('Data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = endpoint.delete({
                            action: 'deleteDataDecision',
                            data: angular.toJson(vm.checked)
                        });
                        response.$promise.then(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }


        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.message)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function printPDF(item) {
            console.log(item);
            item.end_date = new Date(item.end_date);
            item.start_date = new Date(item.start_date);

            if (item.code == 'penugasan-single') {
                $state.goNewTab('app.report.correspondence.sk_penugasan_single', {
                    data: encodeURIComponent(JSON.stringify(item))
                });
            } else {
                $state.goNewTab('app.report.correspondence.sk_penugasan_multiple', {
                    data: encodeURIComponent(JSON.stringify(item))
                });
            }
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("app.correspondence.administrator", [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.correspondence.administrator", {
            url: "/administrator",
            views: {
                "content@app": {
                    templateUrl: "app/main/correspondence/administrator/administrator.html",
                    controller: "CorrespondenceAdminController as vm"
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.correspondence.administrator')
        .controller('CorrespondenceAdminController', Controller);

    Controller.$inject = [
        'AppAPI',
        '$state',
        '$localStorage',
        '$scope',
        '$mdToast',
        'Auth',
        '$mdDialog',
        'DataService'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $state,
        $localStorage,
        $scope,
        $mdToast,
        Auth,
        $mdDialog,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.Correspondence().administrator;
        vm.DataTable = new DataService();
        vm.type = 0;
        vm.status = 'all';
        vm.loadData = loadData;
        vm.isAlreadyApproved = isAlreadyApproved;
        vm.listJum = [5, 10, 20, 25, 50];
        vm.DataTable.jumDataPerPage = 20;
        vm.showRequestDialog = showRequestDialog;
        vm.requestType = [];
        vm.countryCodes = [];
        vm.isCheckAction = false;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isChecked = isChecked;
        vm.checked = [];
        vm.checkedAll = false;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.deleteRequest = deleteRequest;
        vm.updateStatusRequest = updateStatusRequest;
        vm.printPDF = printPDF;
        vm.getFinishedAt = getFinishedAt;
        vm.getLeadTime = getLeadTime;
        vm.showFilter = true;
        vm.requestTypeFilter = [];
        vm.disabledSelectAll = disabledSelectAll;
        vm.requirements = [];
        vm.goToRequirement = goToRequirement;
        vm.goToDecisionLetter = goToDecisionLetter;
        vm.goToAssignmentLetter = goToAssignmentLetter;


        activate();

        function activate() {
            getCountryCodes();
            getRequestType();
            getRequirement();
            loadData(1);
        }

        loadData(1);

        function loadData(pageno) {
            vm.DataTable.loadData(endpoint, pageno, {
                action: "getDataRequestor",
                type: vm.type,
                status: vm.status
            });
        }

        function showRequestDialog(ev, type, item) {
            var group = 'admin';
            $mdDialog.show({
                controller: 'CorrespondenceRequestorFormController as vm',
                templateUrl: 'app/main/correspondence/requestor/form/form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    groupUser: group,
                    dialogType: type,
                    reffData: item,
                    requestType: vm.requestType,
                    countryCodes: vm.countryCodes,
                    requirements: vm.requirements,
                    isAdmin: true
                }
            }).then(function () {
                loadData(1);
            });
        }

        function getRequestType() {
            var response = endpoint.query({
                action: 'getRequestType'
            });
            response.$promise.then(function (data) {
                vm.requestType = data;
                vm.requestTypeFilter = data;
                vm.requestTypeFilter.unshift({
                    'id': 0,
                    'name': 'ALL',
                    'description': 'ALL'
                });
            });
            response.$promise.catch(function (err) {
                vm.requestType = [];
                vm.requestTypeFilter = [];
            });
        }

        function disabledSelectAll() {
            var response = false;
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].status == 'progress') {
                    response = true;
                    break;
                }
            }
            return response;

        }

        function goToRequirement() {
            $state.go('app.correspondence.requirement');
        }

        function getRequirement() {
            var response = endpoint.query({
                action: 'getRequirement'
            });
            response.$promise.then(function (data) {
                vm.requirements = data;
            });
            response.$promise.catch(function (err) {
                vm.requirements = [];
            });
        }


        function getCountryCodes() {
            var response = endpoint.query({
                action: 'getCountryCodes'
            });
            response.$promise.then(function (data) {
                vm.countryCodes = data;
            });
            response.$promise.catch(function (err) {
                vm.countryCodes = [];
            });
        }

        function isAlreadyApproved(status) {
            return status != 'register';
        }

        function toggle(item) {
            var idx = vm.checked.indexOf(item);
            if (idx > -1) {
                vm.checked.splice(idx, 1);
            } else {
                vm.checked.push(item);
            }
            console.log(vm.checked);
        }

        function exists(item) {
            return vm.checked.indexOf(item) > -1;
        }

        function isChecked() {
            return vm.checked.length === vm.DataTable.list.length;
        }

        function isIndeterminate() {
            return (vm.checked.length !== 0 && vm.checked.length !== vm.DataTable.list.length);
        }

        function toggleAll() {
            if (vm.checked.length === vm.DataTable.list.length) {
                vm.checked = [];
            } else if (vm.checked.length === 0 || vm.checked.length > 0) {
                angular.forEach(vm.DataTable.list, function (v, k) {
                    if (!exists(v.id)) {
                        vm.checked.push(v.id);
                    }
                })
            }
        };

        function deleteRequest(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent('Data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = endpoint.delete({
                            action: 'deleteRequest',
                            data: angular.toJson(vm.checked)
                        });
                        response.$promise.then(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function updateStatusRequest(ev, item, status) {

            var title = 'Would you like to set this request to ' + status.toUpperCase() + ' ?';
            var tContent = 'Request will be set from ' + item.status.toUpperCase() + ' to ' + status.toUpperCase();

            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(tContent)
                .ariaLabel('dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog
                .show(confirm)
                .then(function () {
                    if (status == 'rejected') {
                        showReasonForm(ev, item, status);
                    } else {

                        setStatusRequest(ev, item, status, 'none');
                    }
                });

        }

        function showReasonForm(ev, item, status) {
            var confirm = $mdDialog.prompt()
                .title('Would you give requestor a note (optional) ?')
                .textContent('Note')
                .placeholder('Please write the note here')
                .ariaLabel('note')
                .initialValue('none')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            $mdDialog.show(confirm).then(function (response) {
                var reason = response ? response : 'none';
                setStatusRequest(ev, item, status, reason);
            }, function () {
                setStatusRequest(ev, item, status, 'none');
            });
        }

        function setStatusRequest(ev, item, status, reason) {
            var promise = Auth.setToken();
            promise.then(function () {
                angular.element.blockUI();
                var response = endpoint.save({
                    action: 'updateStatusRequest',
                    id: item.id,
                    status: status,
                    reason: reason
                });
                response.$promise.then(function (data) {
                    angular.element.unblockUI();
                    showDialog(ev, data);
                });

                response.$promise.catch(function (data) {
                    angular.element.unblockUI();
                    showDialog(ev, data);
                });
            })
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(data.title)
                    .textContent(data.message)
                    .ariaLabel(data.title)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function getFinishedAt(iDate) {
            var d = new Date(iDate);
            var year = d.getFullYear();
            return year != '1970' ? iDate : 'NOT FINISHED';
        }

        function getLeadTime(cDate, fDate) {
            var tmpcDate = new Date(cDate);
            var tmpfDate = new Date(fDate);
            var leadTime = '-';
            if (tmpfDate.getFullYear() != '1970') {
                var temp = moment.duration(moment(tmpcDate).diff(moment(tmpfDate)));
                var day = Math.abs(temp.days()) + ' Days ' + +' Hours ' + Math.abs(temp.minutes()) + ' Minutes ';
                var hour = Math.abs(temp.hours());
                var minutes = Math.abs(temp.minutes());
                leadTime = day > 0 ? day + ' Days ' : '';
                leadTime += hour > 0 ? hour + ' Hours ' : '';
                leadTime += minutes > 0 ? minutes + ' Minutes ' : '';
            }
            return leadTime;
        }

        function printPDF(item) {
            console.log(item);
            if (item.request_type == 1) {
                $state.goNewTab('app.report.correspondence.company_certificate', {
                    data: encodeURIComponent(JSON.stringify(item))
                });
            } else {
                $state.goNewTab('app.report.correspondence.visa', {
                    data: encodeURIComponent(JSON.stringify(item))
                });
            }
        }

        function goToDecisionLetter() {
            $state.go('app.correspondence.decision_letter');
        }

        function goToAssignmentLetter() {
            $state.go('app.correspondence.assignment_letter');
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.warning-letter', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
     // State
        $stateProvider
            .state('app.cb_warning_letter', {
                url    : '/cb/warning-letter',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/warning-letter/index.html',
                        controller : 'WarningLetterController as vm'
                    }
                }
            }); 
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.warning-letter')
        .controller('WarningLetterController', WarningLetterController);


    WarningLetterController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$element'];
    /** @ngInject */
    function WarningLetterController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$element)
    {
      var vm = this; 
      var WarningLetter=AppAPI.WarningLetter();
      
      var nik= $localStorage.user;
      
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.listselected=[];
      vm.items = [];
      
      vm.deleteData       = deleteData;
      vm.loadData         = loadData; 
      vm.isChecked        = isChecked;
      vm.toggleCheck      = toggleCheck;
      vm.Input            = Input;
      vm.Edit             = Edit;
      vm.exists           = exists;
      vm.isIndeterminate  = isIndeterminate;
      vm.toggleAll        = toggleAll;
      vm.ViewDocument     = ViewDocument;

      loadData(1);

      function closeModal()
      {
          $mdDialog.hide();
      }

      function loadData(pageno)
      {
        var resp=vm.DataTable.loadData(WarningLetter,pageno,{action:'viewData',working_date:vm.workingDate});
        resp.then(function(data) {
            vm.listselected = [];
            vm.items = data.list;
        });
      }
    
      function deleteData(ev) {
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Apakah anda yakin akan menghapus transaksi ini?')
            .textContent('Seluruh data pada transaksi ini akan di hapus dari system.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('Ya')
            .cancel('Tidak');

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=WarningLetter.delete({action:'deleteData',data:angular.toJson(vm.listselected)});
                response.$promise.then( function(resData) {
                    angular.element.unblockUI();
                    if ( resData.status == 1 ) {
                      var title = 'Success Delete Data';
                      var textContent = resData.pesan;
                      var ariaLabel = 'Success Delete Data';
                    } else {
                      var title = 'Delete Data Failed';
                      var textContent = resData.message;
                      var ariaLabel = 'Delete Data Failed';
                    }
                    
                    showDialogMessage(title,textContent,ariaLabel);
                    loadData(1);
                });
                response.$promise.catch( function(resData) {
                    angular.element.unblockUI();
                    var title = 'Delete Data Failed';
                    var textContent = resData.pesan;
                    var ariaLabel = 'Delete Data Failed';
                    showDialogMessage(title,textContent,ariaLabel,ev);
                })
            }, function() {

            });
        });
      }

      function isChecked(ls)
      {
            return vm.listselected.length === vm.items.length;
      }

      function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listselected.splice(idx, 1);
          }
          else
          {
              vm.listselected.push(ls);
          }
      }

      function toggleAll() {
        if (vm.listselected.length === vm.items.length) {
          vm.listselected = [];
        } else if (vm.listselected.length === 0 || vm.listselected.length > 0) {
          vm.listselected = vm.items.slice(0);
        }
      }

      function isIndeterminate() {
        return vm.listselected.length !== 0 && vm.listselected.length !== vm.items.length;
      }

      function Input(ev,id)
      {
            $mdDialog.show({
                controller         : 'CreateWarningLetterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/warning-letter/create.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            }); 

      }
      
      function Edit(ev,data)
      {
            $mdDialog.show({
                controller         : 'EditWarningLetterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/warning-letter/edit.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  data:data
                }
            });
      }

      function exists(item, list) {
        return list.indexOf(item) > -1;
      }

        function ViewDocument(ev, img)
        {
            $mdDialog.show({    
                controller         : 'ViewDocWarningLetterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/warning-letter/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                },
                locals:{
                  img:img
                }
            });
        }

      function showDialogMessage(title,textContent,ariaLabel,ev) {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              closeModal();
          });
      }

      vm.clearSearchTerm = function() {
        vm.searchTerm = '';
      };
      
      $element.find('input').on('keydown', function(ev) {
          ev.stopPropagation();
      });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.warning-letter')
        .controller('ViewDocWarningLetterController', ViewDocWarningLetterController);

    ViewDocWarningLetterController.$inject = ['$localStorage','$http','$location','$window','$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','Echeckin','config','img'];

    /* @ngInject */
    function ViewDocWarningLetterController($localStorage,$http,$location,$window,$stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,Echeckin,config,img) {
        var vm = this;
        
        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal()
        {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage()
        {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = 'api/src/modules/warningletter/document/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev)
        {
            var name=vm.doc;
            // console.log(link);
            if(name !==null && name !=='-')
            {
                $http({
                    method: 'GET',
                    url: config.api+'api/src/modules/warningletter/document/'+name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];
             
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);
             
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
             
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Document Not Found')
                .textContent('Document not Found')
                .ariaLabel('Failed Save Data')
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    // closeModal();
                });
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.warning-letter')
        .controller('EditWarningLetterController', EditWarningLetterController);

    EditWarningLetterController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','$element','data','FileUploader'];

    /* @ngInject */
    function EditWarningLetterController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,$element,data,FileUploader) {
        var vm = this;
        // initial form
        Form.initialForm();
        
        var WarningLetter = AppAPI.WarningLetter();

        // set constructor form
        Form.setObject(WarningLetter);
        
        // set form to controller
        vm.Form = Form;
        vm.isUpdate = true;
        
        vm.Form.objForm.nik = data.nik
        vm.Form.objForm.working_date = new Date(data.working_date);
        vm.Form.objForm.reason = data.reason
        vm.Form.objForm.id = data.id
        
        vm.listSelected=[];
        
        vm.saveData             = saveData;
        vm.closeModal           = closeModal; 
        
        var uploader = vm.uploader = new FileUploader({
            url:config.api+'api/warningletter/uploadFile', 
            removeAfterUpload:true,
            alias:'fileupload',
            onBeforeUploadItem :function(item){
                angular.element.blockUI();
                var dt= new Date(item.formData[0].working_date);
                
                var dtM=(dt.getMonth()+1);
                var dtD=dt.getDate();
                if(dtM < 10){
                  dtM='0'+dtM
                }
                if(dtD<10)
                {
                  dtD='0'+dtD;
                }
  
                var newdate=dt.getFullYear()+'-'+dtM+'-'+dtD;
                item.formData[0].working_date= newdate;
             },
        });
    
          // a sync filter
        uploader.filters.push({
          name: 'syncFilter',
          fn: function(item /*{File|FileLikeObject}*/, options) {
              return this.queue.length < 10;
          }
        });
    
        // an async filter
        uploader.filters.push({
          name: 'asyncFilter',
          fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
              setTimeout(deferred.resolve, 1e3);
          }
        });

        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            angular.element.blockUI();

            var promise= Form.saveData('updateData', formController, WarningLetter);
            promise.then(function(data){
                angular.element.unblockUI();
                formController.$setPristine();
                
                if (data.status == 1) {
                    vm.uploader.uploadAll();
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.warning-letter')
        .controller('CreateWarningLetterController', CreateWarningLetterController);

    CreateWarningLetterController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','$element','$http','FileUploader'];

    /* @ngInject */
    function CreateWarningLetterController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,$element,$http,FileUploader) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var WarningLetter = AppAPI.WarningLetter();

        // set constructor form
        Form.setObject(WarningLetter);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;

        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        
        vm.closeModal           = closeModal;  
        vm.getEmployee          = getEmployee;
        vm.selectedItemChanged  = selectedItemChanged;
        vm.upload               = upload;
        
        var uploader = vm.uploader = new FileUploader({
            url:config.api+'api/warningletter/uploadFile', 
            removeAfterUpload:true,
            alias:'fileupload',
            onBeforeUploadItem :function(item){
                angular.element.blockUI();
                var dt= new Date(item.formData[0].working_date);
                
                var dtM=(dt.getMonth()+1);
                var dtD=dt.getDate();
                if(dtM < 10){
                  dtM='0'+dtM
                }
                if(dtD<10)
                {
                  dtD='0'+dtD;
                }
  
                var newdate=dt.getFullYear()+'-'+dtM+'-'+dtD;
                item.formData[0].working_date= newdate;
             },
             onSuccessItem:function(item, response, status, headers){
                angular.element.unblockUI();
                
                if (response.status == 1) {
                    showDialog(response);
                } else {
                    showFailed(response);
                }
              },onErrorItem:function(item, response, status, headers)
              {

              }
        });
    
        // a sync filter
        uploader.filters.push({
          name: 'syncFilter',
          fn: function(item /*{File|FileLikeObject}*/, options) {
              return this.queue.length < 10;
          }
        });
    
        // an async filter
        uploader.filters.push({
          name: 'asyncFilter',
          fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
              setTimeout(deferred.resolve, 1e3);
          }
        });

        function closeModal()
        {
            $mdDialog.hide();
        }

        function upload(frmBT)
        {
            vm.uploader.uploadAll();
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;

            angular.element.blockUI();
            var response = Form.saveData('saveData', formController, WarningLetter);
            response.then(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                
                if (data.status == 1) {
                    vm.uploader.uploadAll();
                    showDialog(data);
                } else {
                    showFailed(data);
                }
            });
        
            response.catch(function(data) {
                angular.element.unblockUI();
                formController.$setPristine();
                showFailed(data.data);
            });
        }

        function showDialog(data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            ).then(function(){
                // closeModal();
            });
        }

        function getEmployee(searchText)
        {
            return $http
                .get(config.api + 'api/warningletter?action=searchEmployee&param=' + searchText)
                .then(function(item) {
                    // Map the response object to the data object.
                    if(item.data.length===''){
                        Form.objForm.empno='';
                    }
                    return item.data;
                });
        }

        function selectedItemChanged(employee)
        {
            vm.Form.objForm.nik='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.nik=employee.empno;
                vm.Form.objForm.fullname=employee.fullname
                vm.isDisabled=true;
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.view-outlet-team', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_view-outlet-team', {
                url    : '/cb/view-outlet-team',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/view-outlet-team/view-outlet-team.html',
                        controller : 'viewOutletTeamController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.view-outlet-team')
        .controller('viewOutletTeamController', viewOutletTeamController);


    /* @ngInject */
    viewOutletTeamController.$inject = ['$state', '$mdDialog', '$window', '$location', 'config', '$log', 'AppAPI', 'Auth', 'DataService', '$localStorage'];
    function viewOutletTeamController($state, $mdDialog, $window, $location, config, $log, AppAPI, Auth, DataService, $localStorage) {
        var vm = this;

        var ViewOutletTeam = AppAPI.ViewOutletTeam();

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        vm.ExportToExcel = ExportToExcel;

        loadData(1);
        //////////////////

        function loadData(pageno) {
            /* menggunakan DataTable */
            vm.DataTable.loadData(ViewOutletTeam, pageno, { action: 'viewData', sub_area: vm.selectedSubarea });
        }

        function ExportToExcel() {
            var search = vm.DataTable.searchParam;
            if (!search)
                search = 0;

            var sub_area = vm.selectedSubarea;
            if (!sub_area)
                sub_area = 0;

            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/viewoutletteam/exportexcel/' + '/' + search + '/' + sub_area + '/' + $localStorage.lang, '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.uploadslip',[])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider'];
   /** @ngInject */
    function config($stateProvider)
    {
       // State
        $stateProvider
            .state('app.cb_upload_payslip', {
                url    : '/cb/uploadslip',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/uploadslip/uploadslip.html',
                        controller : 'UploadslipController as vm'
                    }
                }
            });
     

         
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.uploadslip')
        .controller('UploadslipController', Controller);

   // Controller.$inject = ['dependencies'];

    /* @ngInject */
    function Controller() {
        var vm = this;
        vm.title = 'Controller';

        activate();

        ////////////////

        function activate() {
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.upload-ghk-abnormal', [ ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    { 
        // State
        $stateProvider
            .state('app.cb_upload_ghk_abnormal', {
                url    : '/cb/upload-ghk',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/upload-ghk-abnormal/upload-ghk-abnormal-list.html',
                        controller : 'UploadGhkAbnormalController as vm'
                    }
                }
            });  
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.upload-ghk-abnormal')
        .controller('ViewErrorUploadGhkController', ViewErrorUploadGhkController);

    ViewErrorUploadGhkController.$inject = ['$mdDialog','id','$localStorage','FileUploader','config','AppAPI'];

    /* @ngInject */
    function ViewErrorUploadGhkController($mdDialog,id,$localStorage,FileUploader,config,AppAPI) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal;
        vm.loadData=loadData;
        var Leaveupload=AppAPI.Leaveupload(); 
        loadData(); 
        vm.ls = id.json_text;
        console.log(vm.ls);
        //////////////// 
        
        function loadData(){
           angular.element('#contentDialog').block({message:'please wait..'}); 
            var response=Leaveupload.query({action:'viewUploadError',id:id.id});
              response.$promise.then(function(data){
                vm.listData=data;
                console.log(vm.listData);
                 angular.element('#contentDialog').unblock();
              });
              response.$promise.catch(function(data){
                // $log.info(data);
                vm.listData=[];
                 angular.element('#contentDialog').unblock();
              });
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.upload-ghk-abnormal')
        .controller('UploadGhkAbnormalController', UploadGhkAbnormalController);


    UploadGhkAbnormalController.$inject = ['$state', '$window', '$location', '$localStorage', '$document', '$http', '$scope', 'config', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService','FileUploader'];
    /** @ngInject */
    function UploadGhkAbnormalController($state, $window, $location, $localStorage, $document, $http, $scope, config, $log, $mdDialog, AppAPI, Auth, DataService,FileUploader) 
    {
        var vm = this;
        var Replacement=AppAPI.Replacement(); 
        vm.Upload = Upload;

        vm.listUpload=[{'reportname':'Upload GHK Holiday','target':'uploadghkholiday'},
                        {'reportname':'Upload GHK Halfday','target':'uploadghkhalfday'}
                      ];
 
        

        ///////////////////////////////
        function Upload(ev, data) 
        {
             $mdDialog.show({
                controller: 'DouploadGhkAbnormalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/upload-ghk-abnormal/upload-ghk-abnormal.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) 
                {
                    
                },
                locals:{
                    data:data
                }
            });
        } 
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.upload-ghk-abnormal')
        .controller('DouploadGhkAbnormalController', DouploadGhkAbnormalController);

    DouploadGhkAbnormalController.$inject = ['$mdDialog','$localStorage','$location','$window','FileUploader','config','data','Auth'];

    /* @ngInject */
    function DouploadGhkAbnormalController($mdDialog,$localStorage,$location,$window,FileUploader,config,data,Auth) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.isMoreInfo = false;
        vm.viewMoreInfo = viewMoreInfo;
        vm.detailInfo = [];
        vm.DownloadTemplate=DownloadTemplate;
        var act=data;
        
        // console.log('data '+ data);

        var uploader = vm.FileUpload = new FileUploader({
        url: config.api + 'api/replacement/'+act,
        removeAfterUpload: true,
        alias:'fileghk',
        formData:[
            {
            action:act
            }
        ],
        onAfterAddingAll: function() {
            vm.uploadSuccess = false;
            vm.uploadError = false;
        },
        headers: {
            tokenAuth: $localStorage.tokenAuth
        }
        });

        uploader.onSuccessItem = function(item,status) {
            if ( status.status == 0 ) {
                vm.uploadSuccess = false;
                vm.uploadError   = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError   = false;
            }

            vm.uploadNotif = status.message
            if ('moreInfo' in status && status.moreInfo.length>0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }
            angular.element('#uploaderPhoto').val('');
        };

        uploader.onErrorItem=function()
        {
            vm.uploadSuccess = false;
            vm.uploadError = true;
        };

        function closeModal()
        {
            $mdDialog.hide();
        }

        function viewMoreInfo()
        {
            $mdDialog.show({
                controller         : 'logFailGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                data:vm.detailInfo
                }
            });
        }

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/replacement/downloadtemplate'+act, '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.uploadholiday', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.cb_upload_holiday', {
                url    : '/cb/upload-holiday',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/upload-holiday/upload-holiday.html',
                        controller : 'UploadHolidayController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';
    angular
      .module('app.uploadholiday')
      .controller('UploadHolidayController', UploadHolidayController);
  
    UploadHolidayController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter','AppAPI','DataService','$document'];
    /** @ngInject */
    function UploadHolidayController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter,AppAPI,DataService,$document) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
      
      var endPoint = AppAPI.UploadHoliday();
      
      vm.DataTables = new DataService();
      vm.listJum = [2, 5, 25, 50, 75, 100, 200];
      vm.loadData = loadData;
      vm.selected = [];
      vm.toggle = toggle;
      vm.exists = exists;
      vm.isIndeterminate = isIndeterminate;
      vm.isChecked = isChecked;
      vm.toggleAll = toggleAll;
      vm.items = [];
      vm.upload = upload; 
      vm.uploadWorkingDate = uploadWorkingDate; 
      vm.selectedItem = null;
      vm.searchText = null;
      vm.listNC = []; 
      vm.deleteData = deleteData;
      vm.dialogClose = dialogClose;
      vm.company=$localStorage.empsite;
      
      vm.uploadSuccess = vm.uploadError = vm.isMoreInfo =  false;
      vm.uploadWorkingSuccess = vm.uploadWorkingError = vm.isMoreInfoWorking =  false;
      vm.uploadNotifWorking = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.viewMoreInfo = viewMoreInfo
      vm.downloadTemplateWorking = downloadTemplateWorking
      vm.changeSector = getSector
      vm.detailInfoWorking = []
      
      loadData(1);
      getListGedung();
      getListShiftGroup();

      vm.FileUploader = new FileUploader({
        url: config.api + 'api/uploadholiday/uploadfile',
        removeAfterUpload: true,
        alias: 'fileupload',
        formData: [{
            action: 'uploadfile'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUploader.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
          var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUploader.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };
      
      vm.FileUploaderWorking = new FileUploader({
        url: config.api + 'api/uploadholiday/uploadworkingdate',
        removeAfterUpload: true,
        alias: 'fileupload',
        formData: [{
            action: 'uploadfile'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUploaderWorking.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadWorkingSuccess = false;
          vm.uploadWorkingError   = true;
        } else {
          vm.uploadWorkingSuccess = true;
          vm.uploadWorkingError   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
          var message = translate(status.pesan);
        }
        vm.uploadNotifWorking = message
        
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfoWorking = true;
            vm.detailInfoWorking = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUploaderWorking.onErrorItem = function() {
        vm.uploadWorkingSuccess = false;
        vm.uploadWorkingError = true;
        
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/uploadholiday/downloadtemplate', '_blank');
          },function(){
              $window.alert('gagal load token');
          });
      }
      
      function downloadTemplateWorking()
      {
        var data = [];
        for (var index = 0; index < vm.selected.length; index++) {
          data.push(vm.selected[index].id);
        }

        var param = encodeURIComponent(window.btoa(angular.toJson(data)));

        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/uploadholiday/downloadtemplateworking/'+param, '_blank');
          },function(){
              $window.alert('gagal load token');
          });
      }

      function viewMoreInfo(detail)
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:detail
          }
        });
      }

      function upload(ev) {
        $mdDialog.show({
          controller: 'UploadHolidayController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/upload-holiday/upload-form.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          onRemoving: function(element, removePromise) {
            loadData(1);
          },
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        });
      }

      function uploadWorkingDate(ev) {
        $mdDialog.show({
          controller: 'UploadHolidayController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/upload-holiday/upload-working-date-form.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          onRemoving: function(element, removePromise) {
            loadData(1);
          },
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        });
      }

      function loadData(pageno) {
        var resp = vm.DataTables.loadData(endPoint, pageno, {
          action: 'viewData',
          gedung: vm.gedung,
          sector: vm.sector,
          shiftGroup: vm.shiftGroup
        });
  
        resp.then(function(data) {
          angular.element.unblockUI();
          vm.selected = [];
          vm.items = data.list;
        });
        resp.catch( function(){
          angular.element.unblockUI();
        });
      }
      
      function dialogClose() {
        $mdDialog.hide();
      }
  
      function toggle(item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        } else {
          list.push(item);
        }
      }
  
      function exists(item, list) {
        return list.indexOf(item) > -1;
      }
  
      function isIndeterminate() {
        return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
      }
  
      function isChecked() {
        return vm.selected.length === vm.items.length;
      }
  
      function toggleAll() {
        if (vm.selected.length === vm.items.length) {
          vm.selected = [];
        } else if (vm.selected.length === 0 || vm.selected.length > 0) {
          vm.selected = vm.items.slice(0);
        }
      }

      function deleteData(ev) {
        var message = translate('PAYROLL.MESSAGE.CONFDEL');
        var note    = translate('PAYROLL.MESSAGE.DELNOTE');
        var yes     = translate('PAYROLL.MESSAGE.YES');
        var no      = translate('PAYROLL.MESSAGE.NO');
  
        var promise = Auth.setToken();
        promise.then(function() {
          var confirm = $mdDialog
            .confirm()
            .title(message)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
  
          $mdDialog.show(confirm).then(
            function() {
              var data = [];
              for (var index = 0; index < vm.selected.length; index++) {
                data.push(vm.selected[index].id);
              }
              angular.element.blockUI();
              var response = endPoint.delete({
                action: 'delete',
                data: angular.toJson(data)
              });
              response.$promise.then(function(resp) {
                dialogClose();
                angular.element.unblockUI();
                showDialogInfo(ev, resp);
              });
              response.$promise.catch( function(){
                angular.element.unblockUI();
              });
            },
            function() {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        });
      }

      function showDialogInfo(ev, data) {
        var message = translate(data.pesan);
        var status = translate(data.status);
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel(status)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
            loadData(1);
          });
      }

      function getListGedung() 
      {
        var response = endPoint.query({
              action: "getGedung"
          });
          response.$promise.then(fetchGedung);
          response.$promise.catch(errorFetchGedung);
      }

      function fetchGedung(data) 
      {
          vm.listGedung = data;
      }
      function errorFetchGedung() 
      {
          vm.listGedung = [];
      }
      
      function getListShiftGroup() 
      {
        var response = endPoint.query({
              action: "getShiftGroup"
          });
          response.$promise.then(fetchShiftGroup);
          response.$promise.catch(errorFetchShiftGroup);
      }

      function fetchShiftGroup(data) 
      {
          vm.listShiftGroup = data;
      }
      function errorFetchShiftGroup() 
      {
          vm.listShiftGroup = [];
      }

      function getSector(gedungId) 
      {
          var response = endPoint.query({
              action: "getSector",
              id: gedungId
          });
          response.$promise.then(fetchSector);
          response.$promise.catch(errorFetchSector);
      }

      function fetchSector(data) {
          vm.listSector = data;
      }

      function errorFetchSector() {
        vm.listSector = [];
      }
    }
  })();
(function ()
{
    'use strict';

    angular
        .module('app.cb.upload-finger', [])
        .config(config);

      config.$inject=['$stateProvider'];
      /** @ngInject */
    function config($stateProvider)
    {

        // State
        $stateProvider
            .state('app.cb_upload_finger', {
                url    : '/cb/upload-finger',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/upload-finger/upload-finger.html',
                        controller : 'UploadFingerController as vm'
                    }
                }
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.upload-finger')
        .controller('UploadattendanceController', UploadattendanceController);


    UploadattendanceController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader','$filter'];
    /** @ngInject */
    function UploadattendanceController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader,$filter)
    {
        
        var vm = this;  
        var UploadFinger=AppAPI.Updatefinger(); 
        
        var translate = $filter('translate');
        vm.closeModal = closeModal
    
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        vm.detailInfo = []
        
        vm.FileUpload = new FileUploader({
            url: config.api + 'api/uploadfinger/uploadfile',
            removeAfterUpload: true,
            alias: 'fileatt',
            formData: [{
                action: 'uploadfile'
            }],
            onAfterAddingAll: function() {
            vm.uploadSuccess = false;
            vm.uploadError = false;
            },
            headers: {
            tokenAuth: $localStorage.tokenAuth
            }
        });
    
        vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
            if ( status.status == 0 ) {
            vm.uploadSuccess = false;
            vm.uploadError   = true;
            } else {
            vm.uploadSuccess = true;
            vm.uploadError   = false;
            }
    
            var expmess = status.pesan.split("_");
            if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
            }else{
                var message = translate(status.pesan);
            }
            vm.uploadNotif = message
            if ('moreInfo' in status && status.moreInfo.length>0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }
            
            angular.element('#uploadCutOff').val('');
            
        };
    
        vm.FileUpload.onErrorItem = function() {
            vm.uploadSuccess = false;
            vm.uploadError = true;
            
        };
    
        function closeModal()
        {
            $mdDialog.hide();
        }
    
        function viewMoreInfo()
        {
            $mdDialog.show({
            controller         : 'logFailGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{
                data:vm.detailInfo
            }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.upload-finger')
        .controller('UploadFingerController', UploadFingerController);


    UploadFingerController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService','$localStorage','$document','Form','$timeout'];
    
    /** @ngInject */
    function UploadFingerController($state,$log,$mdDialog,AppAPI,Auth,DataService,$localStorage,$document,Form,$timeout)
    {
        var vm = this; 
        var UploadFinger = AppAPI.Uploadfinger();//memanggil api modules dari api
        vm.listJum = [2,5,25,50,75,100,200];
        vm.DataTable = new DataService(); //inisialisasi class DataService
        vm.Form = Form;
        Form.initialForm();
        Form.setObject(UploadFinger);
        vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal = closeModal;
        vm.deleteData=deleteData; 
        vm.loadData=loadData;
        vm.viewDetails = viewDetails;

        vm.listData=[];
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listDataSelected=[];

        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [
            {link:'#',name:'Upload Finger',active:'0'}    
        ];

        loadData(1);
 
        function loadData(pageno)
        {
           var resp=vm.DataTable.loadData(UploadFinger,pageno,{action:'viewData'});
        //    var dataPromise = UploadFinger.query({action:'viewData',jumPage:25,offset:0});
        //    dataPromise.$promise.then(fetchDataUFinger);
        //    dataPromise.$promise.catch(errorFetchUFinger); 
        }

        // function fetchDataUFinger(data) {
        //     vm.listData=data[0].aData;
        //     angular.element.unblockUI();
        // }

        // function errorFetchUFinger() {
        //     vm.listData=[];
        //     angular.element.unblockUI();
        // }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
           vm.listDataSelected=angular.copy(vm.DataTable.list);
        //    vm.listDataSelected=angular.copy(vm.listData);
           console.log(vm.listDataSelected);
           
        }
        
        function unCheckAll() {
            vm.listDataSelected=[];
            console.log(vm.listDataSelected);
        }

        function checkone(div) {
            console.log(div);

            div.isChecked = !div.isChecked;
        }

        function deleteData(ev) {
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=UploadFinger.delete({action:'deleteupdatefinger',data:angular.toJson(vm.listDataSelected)});

                    response.$promise.then(loadData(1));
                }, function() {

                });
            });
        }

        function openUploadPhoto(ev)
        {
            $mdDialog.show({
                controller         : 'UploadattendanceController as vm',
                templateUrl        : 'app/main/cb/upload-finger/upload-file.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            });
        }

        function viewDetails(ev,data)
        {
            $mdDialog.show({
                controller         : 'InfoDetailController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/upload-finger/info-detail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                locals:{
                  data:data
                }
            });
        }
    }
})();

(function () 
{
    'use strict';

    angular
        .module('app.cb.upload-finger')
        .controller('InfoDetailController', InfoDetailController);

    InfoDetailController.$inject=['$mdDialog','Auth','Form','AppAPI','Echeckin','$http','config','data'];
    /** @ngInject */
    function InfoDetailController($mdDialog,Auth,Form,AppAPI,Echeckin,$http,config,data)
    {
        var vm = this;
        var Emergency = AppAPI.Emergency(); 

        vm.closeModal = closeModal;
        vm.name = data.file_name;

        vm.listData=data;
        vm.listError = JSON.parse(data.json_failed);      
        
        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();  

(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('UploadFormAttendancesController', UploadFormAttendancesController);

    UploadFormAttendancesController.$inject = ['$state','$mdDialog','config','$localStorage','$timeout','AppAPI','Auth','FileUploader','$location','$window'];

    /* @ngInject */
    function UploadFormAttendancesController($state,$mdDialog,config,$localStorage,$timeout,AppAPI,Auth,FileUploader,$location,$window) 
    {
      var vm = this;

      vm.closeModal = closeModal
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';
      vm.FileUpload = new FileUploader({
        url: config.api + 'api/finalattendance/uploadfileattendance',
        removeAfterUpload: true,
        alias: 'file',
        formData: [{
            type: '31'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError   = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });

      vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 'Failed' ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }

        vm.uploadNotif = status.message

        
        angular.element('#uploadCutOff').val('');
        
      };

      vm.FileUpload.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };

      function closeModal()
      {
        $mdDialog.hide();
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.upload-attendance', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.cb_upload-attendance', {
                url    : '/cd/upload-attendance',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/upload-attendance/upload-attendance.html',
                        controller : 'UploadAttendanceController as vm'
                    }
                }
            });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.upload-attendance')
        .controller('UploadAttendanceController', UploadAttendanceController);

    UploadAttendanceController.$inject = ['$state','$window','$location','$localStorage','$document','$element','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService'];

    /* @ngInject */
  function UploadAttendanceController($state,$window,$location,$localStorage,$document,$element,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService ) {
      var vm = this;
      vm.uploadAttenddance=uploadAttenddance;
      vm.downloadSummaryAttenddance=downloadSummaryAttenddance;
      vm.leaveWaitingApproval=leaveWaitingApproval;
      vm.payleaveDownload=payleaveDownload;
      vm.transactionWaitingApproval=transactionWaitingApproval;



       /////////////////////////////// 
    function uploadAttenddance(ev)
        {
            $mdDialog.show({
                controller         : 'UploadFormAttendancesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/upload-attendance/upload-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                } 
            }); 

        }
    
    function downloadSummaryAttenddance(ev)
    {
        $mdDialog.show({
            controller         : 'AttendanceSummaryController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/download-attendance/attendance-summary.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData();
            } 
        }); 

    }

    function leaveWaitingApproval(ev)
        {
            $mdDialog.show({
                controller         : 'LeaveWaitingApprovalController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/download-attendance/leave-waiting-approval.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                } 
            }); 

        }

    function payleaveDownload(ev)
    {
        $mdDialog.show({
            controller         : 'PayleaveDownloadController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/download-attendance/payleave-download.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData();
            } 
        }); 
    }

    function transactionWaitingApproval(ev)
    {
        $mdDialog.show({
            controller         : 'TransactionDownloadController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/download-attendance/transaction-download.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData();
            } 
        });
    }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.upload-annual-leave', [ ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    { 
        // State
        $stateProvider
            .state('app.cb_upload_annual_leave', {
                url    : '/cb/upload-annual-leave',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/upload-annual-leave/upload-annual-leave.html',
                        controller : 'UploadAnnualLeaveController as vm'
                    }
                }
            });  
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.upload-annual-leave')
        .controller('ViewErrorLeaveUploadController', ViewErrorLeaveUploadController);

    ViewErrorLeaveUploadController.$inject = ['$mdDialog','id','$localStorage','FileUploader','config','AppAPI'];

    /* @ngInject */
    function ViewErrorLeaveUploadController($mdDialog,id,$localStorage,FileUploader,config,AppAPI) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal;
        vm.loadData=loadData;
        var Leaveupload=AppAPI.Leaveupload(); 
        loadData(); 
        vm.ls = id.json_text;
        console.log(vm.ls);
        //////////////// 
        
        function loadData(){
           angular.element('#contentDialog').block({message:'please wait..'}); 
            var response=Leaveupload.query({action:'viewUploadError',id:id.id});
              response.$promise.then(function(data){
                vm.listData=data;
                console.log(vm.listData);
                 angular.element('#contentDialog').unblock();
              });
              response.$promise.catch(function(data){
                // $log.info(data);
                vm.listData=[];
                 angular.element('#contentDialog').unblock();
              });
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.upload-annual-leave')
        .controller('UploadAnnualLeaveController', UploadAnnualLeaveController);


    UploadAnnualLeaveController.$inject = ['$state', '$window', '$location', '$localStorage', '$document', '$http', '$scope', 'config', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService'];
    /** @ngInject */
    function UploadAnnualLeaveController($state, $window, $location, $localStorage, $document, $http, $scope, config, $log, $mdDialog, AppAPI, Auth, DataService) {

        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;  
        var Leaveupload = AppAPI.Leaveupload();
        vm.uploadLeave = uploadLeave;
        vm.viewError = viewError; 
        vm.company = $localStorage.empsite;
        vm.showFilter = true; 
        vm.deleteData=deleteData;

        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist = [
            { link: '#', name: 'C&B / ', active: '0' }
        ];
        vm.listtahun = [ '2017','2018','2019', '2020','2021'];
        vm.listbulan = [{ name: 'January', value: '01' },
        { name: 'February', value: '02' },
        { name: 'Maret', value: '03' },
        { name: 'April', value: '04' },
        { name: 'Mei', value: '05' },
        { name: 'June', value: '06' },
        { name: 'July', value: '07' },
        { name: 'August', value: '08' },
        { name: 'September', value: '09' },
        { name: 'October', value: '10' },
        { name: 'November', value: '11' },
        { name: 'Desember', value: '12' }];

        vm.simulateQuery = false;
        vm.isDisabled = false;
        vm.closeModal = closeModal;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.selectedItems = [];
 

        //////////   


        function loadData(pageno) {
            angular.element('#attView').block({ message: 'please wait..' }); 
            var resp = vm.DataTable.loadData(Leaveupload, pageno,{
                action: 'viewdata',
                upload_date:vm.upload_date,
                start_date:vm.start_date,
                end_date:vm.end_date,
                empnik_name:vm.empnik_name
            });
        }

       

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listModulSelected = angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listModulSelected = [];
        }




        function closeModal() {
            $mdDialog.hide();
        }
 

        function uploadLeave(ev) {
            $mdDialog.show({
                controller: 'LeaveUploadDataController as vm',
                templateUrl: 'app/main/cb/upload-annual-leave/leave-upload.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        function viewError(ls, ev) {
            $mdDialog.show({
                controller: 'ViewErrorLeaveUploadController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/upload-annual-leave/view-error-leave-upload.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    id: ls
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return (
                vm.selectedItems.length !== 0 &&
                vm.selectedItems.length !== vm.DataTable.list.length
            );
        }

        function isChecked() {
            return vm.selectedItems.length === vm.DataTable.list.length;
        }

        function toggleAll() {
            if (vm.selectedItems.length === vm.DataTable.list.length) {
                vm.selectedItems = [];
            } else if (
                vm.selectedItems.length === 0 ||
                vm.selectedItems.length > 0
            ) {
                vm.selectedItems = vm.DataTable.list.slice(0);
            }
        }

        function deleteData(ev) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this list?')
                    .textContent(
                        'All data your selected will be deleted and can not recovered.'
                    )
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(
                    function() {
                        var payload = [];
                        console.log(vm.selectedItems);
                        vm.selectedItems.map(function(val) {
                            payload.push({
                                id: val.id, 
                                absence_date: val.absence_date,
                                nik:val.nik,
                                absence_type:val.absence_type
                            });
                        });

                        // console.log(payload);
                        angular.element.blockUI();
                        
                        var response = Leaveupload.save({
                            action: 'delete',
                            data: payload
                        });

                        response.$promise.then(showDialog);
                        response.$promise.catch(ShowFailed);
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialog(ev, data) {
            angular.element.unblockUI();
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Success Delete Data')
                        .textContent('Success Delete Data')
                        .ariaLabel('Success Delete Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    vm.selectedItems = [];
                    loadData(1);
                });
        }

        function ShowFailed(ev, data) {
            angular.element.unblockUI();
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Delete Data')
                        .textContent('Failed Delete Data')
                        .ariaLabel('Failed Delete Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    vm.selectedItems = [];
                    loadData(1);
                });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.upload-annual-leave')
        .controller('LeaveUploadDataController', LeaveUploadDataController);

    LeaveUploadDataController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function LeaveUploadDataController($mdDialog,$localStorage,FileUploader,config) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        vm.detailInfo = [];
        vm.loading = 0;
        vm.uploadData = uploadData;
        
        vm.FileUpload = new FileUploader({
        url: config.api + 'api/leaveupload/uploadleave',
        removeAfterUpload: true,
        alias:'fileleave',
        formData:[
            {
            action:'uploadleave'
            }
        ],
        onAfterAddingAll: function() {
            vm.loading=0;
            vm.uploadSuccess = false;
            vm.uploadError = false;
        },
        headers: {
            tokenAuth: $localStorage.tokenAuth
        }
        });

        vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
            vm.uploadSuccess = false;
            vm.uploadError   = true;
             vm.loading = 0;
        } else {
            vm.uploadSuccess = true;
            vm.uploadError   = false;
        }

        vm.uploadNotif = status.pesan
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
        };

        vm.FileUpload.onErrorItem = function() {
            vm.uploadSuccess = false;
            vm.uploadError = true;
             vm.loading = 0;
        };

        function closeModal()
        {
            $mdDialog.hide();
        }

        function viewMoreInfo()
        {
            $mdDialog.show({
                controller         : 'logFailGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                data:vm.detailInfo
                }
            });
        }

        function uploadData() {
            vm.loading = 1;
            vm.FileUpload.uploadAll().then(function(){
                vm.loading = 0;
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.update-finger-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_update_finger_approval', {
                url    : '/cb/update-finger-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/update-finger-approval/update-finger-approval.html',
                        controller : 'UpdateFingerAppController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.update-finger-approval')
        .controller('UpfingerViewRejectCommentController', UpfingerViewRejectCommentController);

    UpfingerViewRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function UpfingerViewRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = true;
        // console.log(id);
        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }
        function saveData(ev, formController) {

            var promise = Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.update-finger-approval')
        .controller('UpFingerAppRejectCommentController', UpFingerAppRejectCommentController);

    UpFingerAppRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function UpFingerAppRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;
        var translate = $filter('translate');
        // initial form
        Form.initialForm();

        var Approvalfinger = AppAPI.Approvalfinger();

        // set constructor form
        Form.setObject(Approvalfinger);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;
        // console.log(id);

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function saveData(ev, formController) {

            var promise = Form.saveData('reject', formController, Approvalfinger);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.update-finger-approval')
        .controller('UpdateFingerAppController', UpdateFingerAppController);

    UpdateFingerAppController.$inject = [
        '$state',
        '$mdDialog',
        'DataService',
        'AppAPI',
        'Auth',
        'GeneralService',
        '$localStorage',
        '$filter'
    ];
    /** @ngInject */
    function UpdateFingerAppController(
        $state,
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        GeneralService,
        $localStorage,
        $filter
    ) {
        var vm = this;
        var translate = $filter('translate');

        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Approvalfinger = AppAPI.Approvalfinger();
        var Attendanceemploye = AppAPI.Attendanceemploye();
        var nik = $localStorage.user;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected = [];
        vm.approveData = approveData;
        vm.Reject = Reject;
        vm.UnApproved = UnApproved;
        vm.UnReject = UnReject;
        vm.viewComment = viewComment;
        vm.type = 'waiting approval';
        vm.listType = ['waiting approval', 'approved', 'rejected'];
        vm.toggleSelectedAll = toggleSelectedAll;

        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.getPeriode = getPeriode;
        vm.tgl = date.getDate();
        if (vm.tgl >= 25 && vm.tgl <= 31) {
            if (vm.bulan == 12) {
                vm.bulan = '01';
            } else {
                vm.bulan = vm.bulan + 1;
            }
        }
        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }

        vm.listtahun = [2017, 2018, 2019, 2020, 2021];
        vm.listbulan = [
            { name: 'January', value: '01' },
            { name: 'February', value: '02' },
            { name: 'Maret', value: '03' },
            { name: 'April', value: '04' },
            { name: 'Mei', value: '05' },
            { name: 'June', value: '06' },
            { name: 'July', value: '07' },
            { name: 'August', value: '08' },
            { name: 'September', value: '09' },
            { name: 'October', value: '10' },
            { name: 'November', value: '11' },
            { name: 'Desember', value: '12' }
        ];

        getPeriode();
        // loadData();

        //////////

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(Approvalfinger, pageno, {
                action: 'viewdata',
                tglmulai: vm.tglmulai,
                tglakhir: vm.tglakhir,
                type: vm.type
            });
            vm.listOtselected = [];
        }

        // function loadData() {
        //     angular.element.blockUI();
        //      var response=Approvalfinger.query({action:'viewdata'});
        //     response.$promise.then(fetchDepartment);
        //     response.$promise.catch(errorDepartment);
        //   }

        //   function fetchDepartment(data) {
        //     vm.listApp=data;
        //     // loadData(1);
        //     // console.log(vm.listApp);
        //     angular.element.unblockUI();
        //   }

        //   function errorDepartment() {
        //     vm.listApp=[];
        //     angular.element.unblockUI();
        //   }

        function getPeriode() {
            var res = Attendanceemploye.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan
            });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            vm.periode = data[0]['periode'];
            // console.log(vm.periode);
            // loadData(1);
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }

        function isChecked(ls) {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if (idx > -1) {
                vm.listOtselected.splice(idx, 1);
            } else {
                vm.listOtselected.push(ls);
            }
        }

        function toggleSelectedAll(state) {
            // console.log(state);
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listOtselected = angular.copy(vm.DataTable.list);
            // console.log(vm.listOtselected);
        }

        function unCheckAll() {
            vm.listOtselected = [];
        }

        function approveData(ev) {
            var conf = translate('KPI.MESSAGE.CONFAPP');
            var note = translate('KPI.MESSAGE.APPNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            // console.log(vm.listOtselected);
            var jum = vm.listOtselected.length,
                i,
                ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog
                        .confirm()
                        .title(conf)
                        .textContent(note)
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok(yes)
                        .cancel(no);
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(
                        function () {
                            angular.element.blockUI();
                            // console.log(vm.listOtselected);
                            var ot = new Approvalfinger();
                            ot.data = [];
                            ot.action = 'approve';
                            ot.nik = nik;
                            for (i = 0; i < jum; i++) {
                                ot.data.push({ id: vm.listOtselected[i].id });
                            }
                            var idtx = encodeURIComponent(angular.toJson(ids));
                            var response = ot.$save();
                            response.then(function (data) {
                                // console.log(data.pesan);
                                angular.element.unblockUI();
                                showDialogInfo(ev, data);
                            });
                            response.catch(function (data) {
                                // console.log(data.data);
                                angular.element.unblockUI();
                                showDialogInfo(ev, data.data);
                            });
                        },
                        function () {
                            // $scope.status = 'You decided to keep your debt.';
                        }
                    );
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector('#contentDialog')
                                )
                            )
                            .clickOutsideToClose(true)
                            .title('Attention!')
                            .textContent('No data selected')
                            .ariaLabel('Attention')
                            .ok('close')
                            .targetEvent(ev)
                    )
                    .then(function () {
                        loadData();
                    });
            }
        }

        function successApproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Thanks for Approval')
                        .textContent(data.pesan)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                )
                .then(function () {
                    angular.element.unblockUI();
                    vm.listOtselected = [];
                    loadData();
                });
        }

        function failedApproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Approval')
                        .textContent(data.pesan)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                )
                .then(function () {
                    // loadData();
                    angular.element.unblockUI();
                });
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'UpfingerViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/update-finger-approval/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listOtselected = [];
                },
                locals: {
                    id: id
                }
            });
        }

        function Reject(ev) {
            var jum = vm.listOtselected.length,
                i,
                ids = [];
            if (jum > 0) {
                // var promise=Auth.setToken();
                //  promise.then(function(){
                //       var confirm = $mdDialog.confirm()
                //       .title('Would you like to Reject this list?')
                //       .textContent('All data your selected will be Reject.')
                //       .ariaLabel('delete dialog')
                //       .targetEvent(ev)
                //       .ok('YES')
                //       .cancel('no');
                //   $mdDialog.show({
                //         multiple: true
                //    });
                //   $mdDialog.show(confirm).then(function() {
                //         angular.element.blockUI();
                //         // console.log(vm.listOtselected);
                //         var ot= new Approvalfinger();
                //         ot.data=[];
                //         ot.action='reject';
                //         ot.nik=nik;
                //         ot.approval_type='n1';
                //         var jum=vm.listOtselected.length,i,ids=[];
                //         for (i=0;i<jum;i++) {
                //           ot.data.push({id:vm.listOtselected[i].id});
                //         }
                //         var idtx=encodeURIComponent(angular.toJson(ids));
                //         var response=ot.$save();
                //         //var response=tm.$delete({action:'approve'});
                //         response.then(loadData);
                //     }, function() {
                //    // $scope.status = 'You decided to keep your debt.';
                //   });
                // });
                $mdDialog.show({
                    controller: 'UpFingerAppRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl:
                        'app/main/cb/update-finger-approval/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        loadData();
                        vm.listOtselected = [];
                    },
                    locals: {
                        id: vm.listOtselected
                    }
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector('#contentDialog')
                                )
                            )
                            .clickOutsideToClose(true)
                            .title('Attention!')
                            .textContent('No data selected')
                            .ariaLabel('Attention')
                            .ok('close')
                            .targetEvent(ev)
                    )
                    .then(function () {
                        loadData();
                    });
            }
        }

        function UnApproved(ev, id) {
            var conf = translate('KPI.MESSAGE.CONFUNAPP');
            var note = translate('KPI.MESSAGE.UNAPPNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title(conf)
                    .textContent(note)
                    .ariaLabel('unapprove dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = Approvalfinger.delete({
                            action: 'unapproved',
                            data: angular.toJson(id)
                        });
                        response.$promise.then(function (data) {
                            angular.element.unblockUI();
                            showDialogInfo(ev, data);
                        });
                        response.$promise.catch(function (data) {
                            angular.element.unblockUI();
                            showDialogInfo(ev, data);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function UnReject(ev, id) {
            var conf = translate('KPI.MESSAGE.CONFUNREJ');
            var note = translate('KPI.MESSAGE.UNREJNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title(conf)
                    .textContent(note)
                    .ariaLabel('unreject dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = Approvalfinger.delete({
                            action: 'unreject',
                            data: angular.toJson(id)
                        });
                        response.$promise.then(function (data) {
                            angular.element.unblockUI();
                            showDialogInfo(ev, data);
                        });
                        response.$promise.catch(function () {
                            angular.element.unblockUI();
                            showDialogInfo(ev, data);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function succesUnapproved(ev, data) {
            if (data.hasil == 'expired') {
                showFailedUnapproved();
            } else {
                showDialog();
            }
            vm.listOtselected = [];
            loadData();
        }

        function succesUnreject(ev, data) {
            if (data.hasil == 'expired') {
                showFailedUnreject();
            } else {
                showDialogUnreject();
            }
            loadData();
        }

        function failedUnapproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Approval')
                        .textContent(data.data)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                )
                .then(function () {
                    loadData();
                });
        }

        function showFailedUnapproved() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Unapproved Data')
                        .textContent('Transaction Locked By System.')
                        .ariaLabel('Transaction Locked By System')
                        .ok('OK')
                )
                .then(function () {
                    $mdDialog.hide();
                });
        }

        function showFailedUnreject() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Unreject Data')
                        .textContent('Transaction Locked By System.')
                        .ariaLabel('Transaction Locked By System')
                        .ok('OK')
                )
                .then(function () {
                    $mdDialog.hide();
                });
        }

        function showDialog() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Thanks for Approval')
                        .textContent('Process Data was Success.')
                        .ariaLabel('Attention')
                        .ok('close')
                )
                .then(function () {
                    $mdDialog.hide();
                    vm.listOtselected = [];
                });
        }

        function showDialogUnreject() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Success Process Data')
                        .textContent('Process Data was Success.')
                        .ariaLabel('Attention')
                        .ok('close')
                )
                .then(function () {
                    $mdDialog.hide();
                    vm.listOtselected = [];
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.update-finger', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_update_finger', {
                url    : '/cb/update-finger',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/update-finger/update-finger.html',
                        controller : 'UpdateFingerController as vm'
                    }
                }
            });

      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.update-finger')
        .controller('UpdateFingerController', UpdateFingerController);


    UpdateFingerController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function UpdateFingerController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Updatefinger=AppAPI.Updatefinger();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveAbnormal=approveAbnormal;
      vm.Reject=Reject;
      vm.deleteUpdate=deleteUpdate;
      vm.viewComment=viewComment;
      vm.stateView=true;
      vm.appstatus=[{name:'Waiting Approval',value:'0'},{name:'Approved',value:'1'},{name:'Rejected',value:'2'}];
      vm.status='';
         
      loadData(1);
 
        ////////// 
    
    // function loadData(pageno)
    // {
    //   var resp=vm.DataTable.loadData(Abnormalapproval,pageno,{action:'viewdata',nik:nik});
    //   vm.listOtselected=[];
    // }

    function loadData(pageno) {
        angular.element.blockUI();
        var response=vm.DataTable.loadData(Updatefinger,pageno,{action:'viewdata',status:vm.status,start_date:vm.start_date,end_date:vm.end_date});
    }

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function approveAbnormal(ev)
      {
        console.log(vm.listOtselected);
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                console.log(vm.listOtselected);
                var ot= new Updatefinger();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id
                                });
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function Reject(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Reject this list?')
              .textContent('All data your selected will be Reject.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Updatefinger();
                ot.data=[];
                ot.action='reject';
                ot.nik=nik;
                ot.approval_type='n1';
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function deleteUpdate(ev, id) {
       
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this data?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.unblockUI();
           var response=Updatefinger.delete({action:'delete',data:id});

           response.$promise.then(loadData);
        }, function() {

        });
           });
      
       
        }

     function viewComment(ev,id)
      {
        console.log(id);
        $mdDialog.show({
            controller         : 'UpfingerViewRejectCommentController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/update-finger-approval/comment-reject.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            { 
                loadData(1);
            },
            locals:{
              id:id
            }
        });
      }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.type-shift-matrix')
        .controller('TypeShiftMatrixController', TypeShiftMatrixController);


    TypeShiftMatrixController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$log','$localStorage'];
    /** @ngInject */
    function TypeShiftMatrixController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$log,$localStorage)
    {

      var vm = this;
      vm.editData=editData;
      vm.deleteData=deleteData;
      vm.loadData=loadData;
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      var TypeShiftMatrix=AppAPI.TypeShiftMatrix();
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listselected=[];
      vm.create = create;
      vm.uploadData = uploadData;
      
      loadData(1);

        //////////
      function loadData(pageno)
      {
        var resp=vm.DataTable.loadData(TypeShiftMatrix,pageno,{action:'viewdata'});
         vm.listselected=[];
        resp.then(function(){
           // vm.abs_code='';
         });
      }

      function create(ev) {
          $mdDialog.show({
              controller         : 'CreateTypeShiftMatrixController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/cb/type-shift-matrix/create/create.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData(1);
              }
          });
      }

      function editData (event, ls)
      {
        $mdDialog.show({
              controller         : 'EditTypeShiftMatrixController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/cb/type-shift-matrix/edit/edit.html',
              parent: angular.element(document.body),
              targetEvent: event,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData(1);
              },
              locals:{
                data:ls
              }
          }); 
      }

      function isChecked(ls)
      {
          return vm.listselected.indexOf(ls) > -1;
      }

      function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listselected.splice(idx, 1);
          }
          else
          {
              vm.listselected.push(ls);
          }
      }

      function deleteData(ev) {

        if ( vm.listselected.length > 0) {
          var promise=Auth.setToken();
          promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data your selected will be deleted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=TypeShiftMatrix.delete({action:'delete',data:angular.toJson(vm.selected)});
                response.$promise.then( function(resData) {
                    angular.element.unblockUI();
                    var title = 'Success Delete Data';
                    var textContent = 'Process Delete data was Success';
                    var ariaLabel = 'Success Delete Data';
                    showDialogMessage(title,textContent,ariaLabel);
                    viewData(1);
                });
                response.$promise.catch( function() {
                    angular.element.unblockUI();
                    var title = 'Delete Data Failed';
                    var textContent = 'Process delete data promotion has been failed.';
                    var ariaLabel = 'Delete Data Failed';
                    showDialogMessage(title,textContent,ariaLabel,ev);
                })
            }, function() {

            });
          });
        } else {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            }); 
        }
      }

      function showDialogMessage(title,textContent,ariaLabel,ev) {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              closeModal();
          });
      }

      function uploadData(ev)
      {
        $mdDialog.show({
          controller: 'UploadTypeShiftMatrixController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/type-shift-matrix/upload/upload.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true, // Only for -xs, -sm breakpoints.
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          }
          
        });
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.truant', [ ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    { 
        // State
        $stateProvider
            .state('app.cb_truant', {
                url    : '/cb/truant',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/truant/truant.html',
                        controller : 'TruantController as vm'
                    }
                }
            });  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.truant')
        .controller('TruantController', TruantController);


    TruantController.$inject=['$state','$window','$location','$localStorage','$document','$element','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService' ];
    /** @ngInject */
    function TruantController($state,$window,$location,$localStorage,$document,$element,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService )
    {

        var vm = this;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.ExportToExcel=ExportToExcel;
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;
        var Truant=AppAPI.Truant();
        var Attendancereport=AppAPI.Attendancereport();
        var date=new Date();
        vm.tahun=date.getFullYear();
        vm.bulan=date.getMonth()+1;
        vm.getPeriode=getPeriode;
        vm.tgl=date.getDate();
        vm.flag_app='SAP';
        vm.flagApp=['SAP','HRIS'];
        vm.loadSubArea=loadSubArea;
        if(vm.tgl >=25 && vm.tgl <=31)
        {
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }
        vm.company=$localStorage.empsite;
        vm.groupLogin=$localStorage.group;
        // console.log('employesite > '+$localStorage.empsite);

        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();

        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
                    {link:'#',name:'C&B / ',active:'0'}
                    ];
        vm.listtahun=[2017,2018,2019,2020,2021];
        vm.listbulan=[{name:'January',value:'01'},
                      {name:'February',value:'02'},
                      {name:'Maret',value:'03'},
                      {name:'April',value:'04'},
                      {name:'Mei',value:'05'},
                      {name:'June',value:'06'},
                      {name:'July',value:'07'},
                      {name:'August',value:'08'},
                      {name:'September',value:'09'},
                      {name:'October',value:'10'},
                      {name:'November',value:'11'},
                      {name:'Desember',value:'12'}];

        vm.simulateQuery = false;
        vm.isDisabled    = false;
        vm.typeEmp = [
          {
            "view"  : "Staff",
            "value" : "SAP"
          },
          {
            "view"  : "General Worker",
            "value" : "HRIS"
          }
        ];

        vm.closeModal=closeModal;
       getPeriode();


        //////////
        vm.searchTerm;
        vm.clearSearchTerm = function() {
          vm.searchTerm = '';
        };
        // The md-select directive eats keydown events for some quick select
        // logic. Since we have a search input here, we don't need that logic.
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

         function getPeriode(){
          var res=Truant.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
          res.$promise.then(fetchPeriode);
          res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data)
        {
          vm.periode=data[0]['periode'];
          // console.log(vm.periode);
          // loadData(1);
        }

        function errorfetchPeriode(data)
        {
          console.log('error');
        }

         function loadDataDepartment(iddivisi) {
             var response=Truant.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }

          function loadDataDivision(idbu) {
             var response=Truant.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          }

          function loadDataBU() {
            var response=Truant.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }



        function loadData(){
           angular.element('#attView').block({message:'please wait..'});
           var company=vm.company;
           var divisi=vm.divisi;
           var department=vm.department;
           var tahun=vm.tahun;
           var bulan=vm.bulan;
           var subarea=vm.selectedSubarea;
           var empType=vm.flag_app;
           if(typeof(vm.divisi)==='undefined')
           {
              divisi='all';
           }
           if(typeof(vm.department)==='undefined')
           {
              department='all';
           }
           if (typeof(vm.flag_app) !== "undefined")
           {
             empType = vm.flag_app;
           }

           // console.log(company+' / '+divisi+' / '+department+' / '+tahun+' / '+bulan);
           var response=Truant.query({action:'viewdata',company:company,divisi:divisi,department:department,tahun:tahun,bulan:bulan,subarea:subarea,emptype:flag_app});
              response.$promise.then(function(data){
                vm.listData=data;
                console.log(vm.listData);
                 angular.element('#attView').unblock();
              });
              response.$promise.catch(function(data){
                $log.info(data);
                vm.listData=[];
                 angular.element('#attView').unblock();
              });
        }

        // function loadData(pageno)
        // {
        //   var company=vm.company;
        //   var divisi=vm.divisi;
        //   var department=vm.department;
        //   var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
        //   var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');

        //   var resp=vm.DataTable.loadData(Overtime,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
        //  // console.log(resp);
        //   // angular.element.unblockUI();
        // }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          }




        function closeModal()
        {
            $mdDialog.hide();
        }

        function ExportToExcel()
        {
         var company=vm.company;
         var divisi=vm.divisi;
         var department=vm.department;
         var tahun=vm.tahun;
         var bulan=vm.bulan;
         var subarea=vm.selectedSubarea;
         var empType=vm.flag_app;
         if(typeof(vm.divisi)==='undefined')
         {
            divisi='all';
         }
         if(typeof(vm.department)==='undefined')
         {
            department='all';
         }
         if (typeof(vm.flag_app) !== "undefined")
         {
           empType = vm.flag_app;
         }
          var token=Auth.setTokenPromise();
            token.then(function(data){
              var protocol=$location.protocol();
              var host=$location.host();
              $window.open(protocol+'://'+host+config.api+'api/truant/exportexcel/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan+'/'+subarea+'/'+empType, '_blank');
            },function(){

                $window.alert('gagal load token');
            });
        }

        function  loadSubArea()
        {
          var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.team-assignment-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_team_assignment_approval', {
                url    : '/cb/team-assignment-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/team-assignment-approval/team-assignment-approval.html',
                        controller : 'TeamAssignmentAppController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.team-assignment-approval')
        .controller('TeamAssignmentAppController', TeamAssignmentAppController);

    TeamAssignmentAppController.$inject = [
        '$state',
        '$mdDialog',
        'DataService',
        'AppAPI',
        'Auth',
        'GeneralService',
        '$localStorage'
    ];
    /** @ngInject */
    function TeamAssignmentAppController(
        $state,
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        GeneralService,
        $localStorage
    ) {
        var vm = this;
        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Approvalassignment = AppAPI.Approvalassignment();
        var Attendanceemploye = AppAPI.Attendanceemploye();
        var nik = $localStorage.user;
        vm.nik = nik;
        vm.isChecked = isChecked;
        vm.isCheckedAll = isCheckedAll;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected = [];
        vm.approveData = approveData;
        vm.Reject = Reject;
        vm.UnApproved = UnApproved;
        vm.UnReject = UnReject;
        vm.viewComment = viewComment;
        vm.type = 'waiting approval';
        vm.listType = ['waiting approval', 'approved', 'rejected'];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.viewDetail = viewDetail;
        vm.isIndeterminate = isIndeterminate;
        vm.selectAll = false;
        vm.reinitCheckbox = reinitCheckbox;
        vm.checkApprovalData = checkApprovalData;

        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.getPeriode = getPeriode;
        vm.tgl = date.getDate();
        if (vm.tgl >= 25 && vm.tgl <= 31) {
            if (vm.bulan == 12) {
                vm.bulan = '01';
            } else {
                vm.bulan = vm.bulan + 1;
            }
        }
        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }

        vm.listtahun = [2017, 2018, 2019, 2020, 2021];
        vm.listbulan = [{
                name: 'January',
                value: '01'
            },
            {
                name: 'February',
                value: '02'
            },
            {
                name: 'Maret',
                value: '03'
            },
            {
                name: 'April',
                value: '04'
            },
            {
                name: 'Mei',
                value: '05'
            },
            {
                name: 'June',
                value: '06'
            },
            {
                name: 'July',
                value: '07'
            },
            {
                name: 'August',
                value: '08'
            },
            {
                name: 'September',
                value: '09'
            },
            {
                name: 'October',
                value: '10'
            },
            {
                name: 'November',
                value: '11'
            },
            {
                name: 'Desember',
                value: '12'
            }
        ];

        getPeriode();
        loadData();

        //////////

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(Approvalassignment, pageno, {
                action: 'viewdata',
                tglmulai: vm.tglmulai,
                tglakhir: vm.tglakhir,
                type: vm.type
            });
            vm.listOtselected = [];
        }

        function viewDetail(ev, data, detail) {
            $mdDialog.show({
                controller: 'AmdetailTeamAssignmentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/am-team-assignment/am-detail-team-assignment.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    data: data,
                    detail: detail,
                    state: false,
                    approveFunction: approveFunction
                }
            });
        }

        function approveFunction(ev, data) {
            vm.listOtselected.push(data);
            approveData(ev);
        }

        // function loadData() {
        //     angular.element.blockUI();
        //      var response=Approvalassignment.query({action:'viewdata'});
        //     response.$promise.then(fetchDepartment);
        //     response.$promise.catch(errorDepartment);
        //   }

        //   function fetchDepartment(data) {
        //     vm.listApp=data;
        //     // loadData(1);
        //     // console.log(vm.listApp);
        //     angular.element.unblockUI();
        //   }

        //   function errorDepartment() {
        //     vm.listApp=[];
        //     angular.element.unblockUI();
        //   }

        function getPeriode() {
            var res = Attendanceemploye.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan
            });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            vm.periode = data[0]['periode'];
            // console.log(vm.periode);
            // loadData(1);
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }

        function isChecked(ls) {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function isCheckedAll() {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    if (vm.DataTable.list[i].approval == 0) {
                        countCheckAvail++;
                    }
                }

                return vm.listOtselected.length === countCheckAvail && vm.listOtselected.length > 0;
            } else {
                return false;
            }
        }

        function isIndeterminate() {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    if (vm.DataTable.list[i].approval == 0) {
                        countCheckAvail++;
                    }
                }
                return (
                    vm.listOtselected.length > 0 &&
                    vm.listOtselected.length !== countCheckAvail
                );
            } else {
                return false;
            }
        }


        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if (idx > -1) {
                vm.listOtselected.splice(idx, 1);
            } else {
                vm.listOtselected.push(ls);
            }
        }

        function toggleSelectedAll() {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    if (vm.DataTable.list[i].approval == 0) {
                        countCheckAvail++;
                    }
                }
                if (vm.listOtselected.length === countCheckAvail) {
                    unCheckAll();
                } else if (
                    vm.listOtselected.length === 0 ||
                    vm.listOtselected.length > 0
                ) {
                    checkAll();
                }
            } else {
                return false;
            }
        }

        function checkAll() {
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].approval == 0) {
                    if (vm.listOtselected.indexOf(vm.DataTable.list[i]) < 0) {
                        vm.listOtselected.push(vm.DataTable.list[i]);
                    }
                }
            }
        }

        function unCheckAll() {
            vm.listOtselected = [];
        }

        function approveData(ev) {
            // console.log(vm.listOtselected);
            var jum = vm.listOtselected.length,
                i,
                ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog
                        .confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(
                        function () {
                            angular.element.blockUI();
                            // console.log(vm.listOtselected);
                            var ot = new Approvalassignment();
                            ot.data = [];
                            ot.action = 'approve';
                            ot.nik = nik;
                            for (i = 0; i < jum; i++) {
                                ot.data.push({
                                    id: vm.listOtselected[i].id
                                });
                            }
                            var idtx = encodeURIComponent(angular.toJson(ids));
                            var response = ot.$save();
                            response.then(function (data) {
                                // console.log(data.pesan);
                                successApproved(ev, data);
                                angular.element.unblockUI();
                            });
                            response.catch(function (data) {
                                // console.log(data.data);
                                failedApproved(ev, data.data);
                                angular.element.unblockUI();
                            });
                        },
                        function () {
                            // $scope.status = 'You decided to keep your debt.';
                        }
                    );
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector('#contentDialog')
                            )
                        )
                        .clickOutsideToClose(true)
                        .title('Attention!')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                    )
                    .then(function () {
                        loadData();
                    });
            }
        }

        function successApproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(document.querySelector('#contentDialog'))
                    )
                    .clickOutsideToClose(true)
                    .title('Thanks for Approval')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                )
                .then(function () {
                    angular.element.unblockUI();
                    vm.listOtselected = [];
                    if ('moreInfo' in data && data.moreInfo.length > 0) {
                        $mdDialog.show({
                            controller: 'logFailGwController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: true,
                            onRemoving: function (element, removePromise) {
                                loadData(1);
                            },
                            locals: {
                                data: data.moreInfo
                            }
                        });
                    } else {
                        loadData(1);
                    }
                });
        }

        function failedApproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(document.querySelector('#contentDialog'))
                    )
                    .clickOutsideToClose(true)
                    .title('Failed Approval')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                )
                .then(function () {
                    // loadData();
                    angular.element.unblockUI();
                });
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'UpfingerViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/update-finger-approval/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listOtselected = [];
                },
                locals: {
                    id: id
                }
            });
        }

        function Reject(ev) {
            var jum = vm.listOtselected.length,
                i,
                ids = [];
            if (jum > 0) {
                // var promise=Auth.setToken();
                //  promise.then(function(){
                //       var confirm = $mdDialog.confirm()
                //       .title('Would you like to Reject this list?')
                //       .textContent('All data your selected will be Reject.')
                //       .ariaLabel('delete dialog')
                //       .targetEvent(ev)
                //       .ok('YES')
                //       .cancel('no');
                //   $mdDialog.show({
                //         multiple: true
                //    });
                //   $mdDialog.show(confirm).then(function() {
                //         angular.element.blockUI();
                //         // console.log(vm.listOtselected);
                //         var ot= new Approvalassignment();
                //         ot.data=[];
                //         ot.action='reject';
                //         ot.nik=nik;
                //         ot.approval_type='n1';
                //         var jum=vm.listOtselected.length,i,ids=[];
                //         for (i=0;i<jum;i++) {
                //           ot.data.push({id:vm.listOtselected[i].id});
                //         }
                //         var idtx=encodeURIComponent(angular.toJson(ids));
                //         var response=ot.$save();
                //         //var response=tm.$delete({action:'approve'});
                //         response.then(loadData);
                //     }, function() {
                //    // $scope.status = 'You decided to keep your debt.';
                //   });
                // });
                $mdDialog.show({
                    controller: 'UpFingerRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/cb/update-finger-approval/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        loadData();
                        vm.listOtselected = [];
                    },
                    locals: {
                        id: vm.listOtselected
                    }
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector('#contentDialog')
                            )
                        )
                        .clickOutsideToClose(true)
                        .title('Attention!')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                    )
                    .then(function () {
                        loadData();
                    });
            }
        }

        function UnApproved(ev, id) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to unapprove this list?')
                    .textContent('All data you selected will be set to unapproved.')
                    .ariaLabel('unapprove dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = Approvalassignment.delete({
                            action: 'unapproved',
                            data: angular.toJson(id)
                        });
                        response.$promise.then(function (data) {
                            succesUnapproved(ev, data);
                        });
                        response.$promise.catch(function (data) {
                            failedUnapproved(ev, data);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function UnReject(ev, id) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to unreject this list?')
                    .textContent('All data you selected will be set to unreject.')
                    .ariaLabel('unreject dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = Approvalassignment.delete({
                            action: 'unreject',
                            data: angular.toJson(id)
                        });
                        response.$promise.then(function (data) {
                            succesUnreject(ev, data);
                        });
                        response.$promise.catch(function () {
                            angular.element.unblockUI();
                            failedUnapproved(ev, data);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function succesUnapproved(ev, data) {
            if (data.hasil == 'expired') {
                showFailedUnapproved();
            } else {
                showDialog();
            }
            vm.listOtselected = [];
            loadData();
        }

        function succesUnreject(ev, data) {
            if (data.hasil == 'expired') {
                showFailedUnreject();
            } else {
                showDialogUnreject();
            }
            loadData();
        }

        function failedUnapproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(document.querySelector('#contentDialog'))
                    )
                    .clickOutsideToClose(true)
                    .title('Failed Approval')
                    .textContent(data.data)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                )
                .then(function () {
                    loadData();
                });
        }

        function showFailedUnapproved() {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(document.querySelector('#contentDialog'))
                    )
                    .clickOutsideToClose(true)
                    .title('Failed Unapproved Data')
                    .textContent('Transaction Locked By System.')
                    .ariaLabel('Transaction Locked By System')
                    .ok('OK')
                )
                .then(function () {
                    $mdDialog.hide();
                });
        }

        function showFailedUnreject() {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(document.querySelector('#contentDialog'))
                    )
                    .clickOutsideToClose(true)
                    .title('Failed Unreject Data')
                    .textContent('Transaction Locked By System.')
                    .ariaLabel('Transaction Locked By System')
                    .ok('OK')
                )
                .then(function () {
                    $mdDialog.hide();
                });
        }

        function showDialog() {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(document.querySelector('#contentDialog'))
                    )
                    .clickOutsideToClose(true)
                    .title('Thanks for Approval')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Attention')
                    .ok('close')
                )
                .then(function () {
                    $mdDialog.hide();
                    vm.listOtselected = [];
                });
        }

        function showDialogUnreject() {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(document.querySelector('#contentDialog'))
                    )
                    .clickOutsideToClose(true)
                    .title('Success Process Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Attention')
                    .ok('close')
                )
                .then(function () {
                    $mdDialog.hide();
                    vm.listOtselected = [];
                });
        }

        function reinitCheckbox() {
            unCheckAll();
        }

        function checkApprovalData(inls, approvalData, i) {
            // console.log(inls, approvalData, i);

            if (inls.approved_by == vm.nik) {
                if (inls.approval_status == '2') {
                    if (typeof approvalData[i + 1] != 'undefined' && approvalData[i + 1].approval_status == '1') {
                        return false;
                    }
                }
            }
            return true;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.substitution-leave-ot', [
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.cb_substitution_leave_ot', {
                url    : '/cb/substitution-leave-ot',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/substitution-leave-ot/index.html',
                        controller : 'SubstitutionLeaveOTController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.substitution-leave-ot')
        .controller('SubstitutionLeaveOTController', SubstitutionLeaveOTController);


    SubstitutionLeaveOTController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','Form'];
    /** @ngInject */
    function SubstitutionLeaveOTController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,Form)
    {
        
        var vm = this; 
        Form.initialForm();
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;  
        
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment; 
        var SubstitutionLeaveOT=AppAPI.SubstitutionLeaveOT();
        var Attendancereport=AppAPI.Attendancereport();
        vm.company=$localStorage.empsite;

        Form.setObject(SubstitutionLeaveOT);
        vm.Form = Form;
        
        
        vm.changeToOT = changeToOT;
        vm.loadSubArea=loadSubArea;
        
        loadCompany();
        loadDataDivision(vm.company)
        loadSubArea()
        loadData(1)

        vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[ 
                    {link:'#',name:'C&B / ',active:'0'}
                    ]; 

        
        vm.closeModal=closeModal; 
        
        function loadDataDepartment(iddivisi) {
          var response=SubstitutionLeaveOT.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
          vm.listDepartment=data; 
        }

        function errorDepartment() {
          vm.listDepartment=[];
        }
         

        function loadDataDivision(idbu) {
           var response=SubstitutionLeaveOT.query({action:'viewDivisiBu',idbu:idbu});
          response.$promise.then(fetchDivisiBU);
          response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
         vm.listDivision=data; 
        }

        function errorDivisiBU() {
          vm.listDivision=[];
        }
        
        function loadCompany() {
          var response=SubstitutionLeaveOT.query({action:'viewBu'});
          response.$promise.then(fetchBU);
          response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
          vm.listBU=data;
        }

        function errorFetchBU() {
          vm.listBU=[];
        } 

        function loadSubArea()
        {
          var response=Attendancereport.query({action:'viewSubArea'});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }


        ////////// 

        function loadData(pageno)
        {
          var company=vm.company; 
          var divisi=vm.divisi;
          var department=vm.department;
          var resp=vm.DataTable.loadData(SubstitutionLeaveOT,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:vm.tglmulai,tglakhir:vm.tglakhir,subarea:vm.subarea});
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function changeToOT(event,data)
        {
            vm.Form.objForm = data
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to change data from substitution leave to overtime ?')
                .textContent('All data your selected will be updated and can not recovered.')
                .ariaLabel('Change Substitution')
                .targetEvent(event)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response = SubstitutionLeaveOT.delete({
                      action: 'update',
                      data: angular.toJson(data)
                    });
                    response.$promise.then(function(response) {
                      // dialogClose();
                      angular.element.unblockUI();
                      // showDialogInfo(ev, data);
                      if ( response.status == 0 ) {
                        var res = {
                          pesan: response.pesan,
                          title : 'Error Info'
                        }
                      } else {
                        var res = {
                          pesan: response.pesan,
                          title : 'Success Info'
                        }
                      }
                      console.log(response)
                      showDialogInfo(event,res)
                    });
                }, function() {
                });
            });
        }

        function showDialogInfo(ev,data)
        {
          $mdDialog
            .show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(data.title)
                .textContent(data.pesan)
                .ariaLabel(data.title)
                .ok('OK')
                .targetEvent(ev)
            )
            .then(function() {
              loadData(1);
            });
        
        }
        
 
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.store-incharge', ['app.cb.sic.input-sic'])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_store-incharge', {
                url    : '/cb/store-incharge',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/store-incharge/store-incharge.html',
                        controller : 'storeInchargeController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.store-incharge')
        .controller('storeInchargeController', storeInchargeController);

    
    /* @ngInject */
    storeInchargeController.$inject=['$state','$mdDialog','$window','$location','config','$log','AppAPI','Auth','DataService'];
    function storeInchargeController($state,$mdDialog,$window,$location,config,$log,AppAPI,Auth,DataService) {
        var vm = this;

        var StoreIncharge=AppAPI.StoreIncharge();
		
        vm.DataTable= new DataService();
        vm.loadData=loadData;
    		vm.listJum=[2,5,25,50,75,100,200];
    		vm.listSicSelected = [];
    		vm.editData = editData;
    		vm.deleteSIC = deleteSIC;
    		vm.loadSubArea = loadSubArea;
    		vm.selectedSubarea = '0';
    		vm.ExportToExcel = ExportToExcel;
        vm.toggle = toggle;
        vm.onCollapse = onCollapse;

        vm.searchTermSA = '';
        vm.clearSearchTermSA = clearSearchTermSA;
    		
    		loadSubArea();
        //////////////////

        function loadData(pageno)
        {
            /* menggunakan DataTable */
          vm.DataTable.loadData(StoreIncharge,pageno,{action:'viewData', sub_area:vm.selectedSubarea});

          /* tanpa menggunakan DataTable */
          /* var response=StoreIncharge.query({action:'viewData'}); 
          response.$promise.then(fetchData);
          response.$promise.catch(errorFetchData); */
        }

        /* function fetchData(data)
        {
           vm.listData=data; 
        }

        function errorFetchData()
        {
            vm.listData=[];
        } */
		
		function editData(id) {
		  $state.go('app.cb_sic_edit-sic', {id:encodeURIComponent(window.btoa(id))});	
		}
		
		function deleteSIC(ev) {
			var promise = Auth.setToken();
			promise.then(function() {
				var confirm = $mdDialog.confirm()
				.title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
				
				$mdDialog.show(confirm).then(function() {
					angular.element.blockUI();
					var response = StoreIncharge.delete({action:'delete', data:angular.toJson(vm.listSicSelected)});
					
					response.$promise.then(function(){
            loadData(1);
          });
				}, function() {
					
				});
			});
		} 

		function  loadSubArea()
        {
          var response=StoreIncharge.query({
			  action: 'viewSubArea'
		  });
		  
          response.$promise.then(fetchArea);
          response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        { 
          data.unshift({ id: "0", description: "All" });
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }
		
		function ExportToExcel()
        {
          /* var tahun=vm.tahun;
          var bulan=vm.bulan; */
		  
		  var search = vm.DataTable.searchParam;
		  if(!search) 
			  search = 0;
		  
		  var sub_area = vm.selectedSubarea;
		  if(!sub_area) 
			  sub_area = 0;
		  
          var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                   $window.open(protocol+'://'+host+'/'+config.api+'api/storeincharge/exportexcel/' + search + '/' + sub_area, '_blank');
            },function(){
        
                $window.alert('gagal load token');
            });
        }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
    }

    function onCollapse() {
      if(vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
        vm.DataTable.searchParam = '';
        vm.loadData(1);
      }
    }

    function clearSearchTermSA() {
      vm.searchTermSA = '';
    }
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-update-finger-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_sic_update_finger_approval', {
                url    : '/cb/sic-update-finger-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/sic-update-finger-approval/sic-update-finger-approval.html',
                        controller : 'SicupdateFingerAppController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.sic-update-finger-approval')
        .controller('SicUpfingerViewRejectCommentController', SicUpfingerViewRejectCommentController);

    SicUpfingerViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function SicUpfingerViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.sic-update-finger-approval')
        .controller('SicUpFingerRejectCommentController', SicUpFingerRejectCommentController);

    SicUpFingerRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function SicUpFingerRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Approvalfinger = AppAPI.Sicapprovalfinger();

        // set constructor form
        Form.setObject(Approvalfinger);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Approvalfinger);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-update-finger-approval')
        .controller('SicupdateFingerAppController', SicupdateFingerAppController);


    SicupdateFingerAppController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function SicupdateFingerAppController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
       var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Approvalfinger=AppAPI.Sicapprovalfinger();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveAbnormal=approveAbnormal;
      vm.Reject=Reject;
      vm.UnApproved=UnApproved;
      vm.UnReject=UnReject;
      vm.viewComment=viewComment;
      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected'];
      vm.toggleSelectedAll=toggleSelectedAll;

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();
      if(vm.tgl >=25 && vm.tgl <=31)
        { 
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }

      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
      
      // getPeriode();  
      // loadData();
 
        ////////// 
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Approvalfinger,pageno,{action:'viewdata',tglmulai:vm.tglmulai,tglakhir:vm.tglakhir,type:vm.type});
      vm.listOtselected=[];
    }

    // function loadData() {
    //     angular.element.blockUI();
    //      var response=Approvalfinger.query({action:'viewdata'});
    //     response.$promise.then(fetchDepartment);
    //     response.$promise.catch(errorDepartment);
    //   }

    //   function fetchDepartment(data) {
    //     vm.listApp=data;
    //     // loadData(1);
    //     // console.log(vm.listApp);
    //     angular.element.unblockUI();
    //   }

    //   function errorDepartment() {
    //     vm.listApp=[];
    //     angular.element.unblockUI();
    //   }
     
     function getPeriode(){
        var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.periode=data[0]['periode'];
        // console.log(vm.periode);
        loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }

    

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function toggleSelectedAll(state)
      {
        // console.log(state);
          switch(state)
          {
              case true:
              checkAll();
              break;
              case false:
              unCheckAll();
              break;
          }
      }

      function checkAll() {
         vm.listOtselected=angular.copy(vm.DataTable.list);
         // console.log(vm.listOtselected);
      }

      function unCheckAll() {
         vm.listOtselected=[];
      }

      function approveAbnormal(ev)
      {
        // console.log(vm.listOtselected);
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Approve this list?')
                .textContent('All data your selected will be approve.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  // console.log(vm.listOtselected);
                  var ot= new Approvalfinger();
                  ot.data=[];
                  ot.action='approve';
                  ot.nik=nik;  
                  for (i=0;i<jum;i++) {
                    ot.data.push({id:vm.listOtselected[i].id
                                  });
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save(); 
                  response.then(function(data){
                      // console.log(data.pesan);
                      successApproved(ev,data);
                      angular.element.unblockUI();
                  });
                  response.catch(function(data){
                    // console.log(data.data);
                    failedApproved(ev,data.data);
                    angular.element.unblockUI();
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 

      }

      function successApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

      function failedApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

      function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'SicUpfingerViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/update-finger-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              vm.listOtselected=[];
          },
          locals:{
            id:id
          }
      });
    }

      function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          // var promise=Auth.setToken();
          //  promise.then(function(){
          //       var confirm = $mdDialog.confirm()
          //       .title('Would you like to Reject this list?')
          //       .textContent('All data your selected will be Reject.')
          //       .ariaLabel('delete dialog')
          //       .targetEvent(ev)
          //       .ok('YES')
          //       .cancel('no');
          //   $mdDialog.show({
          //         multiple: true
          //    });      
          //   $mdDialog.show(confirm).then(function() {
          //         angular.element.blockUI();
          //         // console.log(vm.listOtselected);
          //         var ot= new Approvalfinger();
          //         ot.data=[];
          //         ot.action='reject';
          //         ot.nik=nik;
          //         ot.approval_type='n1';
          //         var jum=vm.listOtselected.length,i,ids=[]; 
          //         for (i=0;i<jum;i++) {
          //           ot.data.push({id:vm.listOtselected[i].id});
          //         }
          //         var idtx=encodeURIComponent(angular.toJson(ids));
          //         var response=ot.$save(); 
          //         //var response=tm.$delete({action:'approve'});
          //         response.then(loadData);
          //     }, function() {
          //    // $scope.status = 'You decided to keep your debt.';
          //   });
          // });
          $mdDialog.show({
                controller         : 'SicUpFingerRejectCommentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/update-finger-approval/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                    vm.listOtselected=[];
                },
                locals:{
                  id:vm.listOtselected
                }
            });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        }
         
      }

  function UnApproved(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to unapprove this list?')
          .textContent('All data you selected will be set to unapproved.')
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
      angular.element.blockUI();
      var response=Approvalfinger.delete({action:'unapproved',data:angular.toJson(id)});
      response.$promise.then(loadData);
      response.$promise.catch(function(){
        angular.element.unblockUI();
      });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

    function UnReject(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
      angular.element.blockUI();
      var response=Approvalfinger.delete({action:'unreject',data:angular.toJson(id)});
      response.$promise.then(loadData);
      response.$promise.catch(function(){
        angular.element.unblockUI();
      });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-team-mapping', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_sic-team-mapping', {
                url    : '/cb/sic-team-mapping',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/sic-team-mapping/sic-team-mapping.html',
                        controller : 'sicTeamMappingController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.sic-team-mapping')
        .controller('sicTeamMappingController', sicTeamMappingController);

    
    /* @ngInject */
    sicTeamMappingController.$inject=['$state','$mdDialog','$window','$location','config','$log','AppAPI','Auth','DataService'];
    function sicTeamMappingController($state,$mdDialog,$window,$location,config,$log,AppAPI,Auth,DataService) {
        var vm = this;

        var SicTeamMapping=AppAPI.SicTeamMapping();
		
        vm.DataTable= new DataService();
        vm.loadData=loadData;
		vm.listJum=[2,5,25,50,75,100,200];
		
		vm.loadSubArea = loadSubArea;
		vm.selectedSubarea = '0';
		
		vm.ExportToExcel = ExportToExcel;
	    vm.getPeriode = getPeriode;
	    var date=new Date();
        vm.tahun=date.getFullYear();
        vm.bulan=date.getMonth()+1;
	    
	    vm.tgl=date.getDate();
        if(vm.tgl >=25 && vm.tgl <=31)
        {
          if(vm.bulan==12){
            vm.bulan='01';
          }
	    else{
            vm.bulan=vm.bulan+1;
          }
        }
        
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }
		  
	    vm.listtahun=[2017,2018,2019,2020,2021];
        vm.listbulan=[{name:'January',value:'01'},
				  {name:'February',value:'02'},
				  {name:'Maret',value:'03'},
				  {name:'April',value:'04'},
				  {name:'Mei',value:'05'},
				  {name:'June',value:'06'},
				  {name:'July',value:'07'},
				  {name:'August',value:'08'},
				  {name:'September',value:'09'},
				  {name:'October',value:'10'},
				  {name:'November',value:'11'},
				  {name:'Desember',value:'12'}];
				  
        loadData(1);
		loadSubArea();
		getPeriode();
        //////////////////

        function loadData(pageno)
        {
            /* menggunakan DataTable */
          vm.DataTable.loadData(SicTeamMapping,pageno,{action:'viewData', sub_area:vm.selectedSubarea, bulan:vm.bulan, tahun:vm.tahun});
        }

        function getPeriode(){
			var res=SicTeamMapping.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
			res.$promise.then(fetchPeriode);
			res.$promise.catch(errorfetchPeriode);
		}
		
		function fetchPeriode(data)
		{
			vm.periode=data[0]['periode'];
		}
	
		function errorfetchPeriode(data)
		{
			vm.periode= [];
		}
		
		function ExportToExcel()
        {
          var tahun=vm.tahun;
          var bulan=vm.bulan;
		  
		  var search = vm.DataTable.searchParam;
		  if(!search) 
			  search = 0;
		  
		  var sub_area = vm.selectedSubarea;
		  if(!sub_area) 
			  sub_area = 0;
		  
          var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                   $window.open(protocol+'://'+host+'/'+config.api+'api/sicteammapping/exportexcel/'+ tahun + '/' + bulan + '/' + search + '/' + sub_area, '_blank');
            },function(){
        
                $window.alert('gagal load token');
            });
        }
	  
		function loadSubArea()
        {
          var response=SicTeamMapping.query({
			  action: 'viewSubArea'
		  });
		  
          response.$promise.then(fetchArea);
          response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-outlet-team', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_sic_outlet_team', {
                url    : '/cb/sic-outlet-team',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/sic-outlet-team/sic-outlet-team.html',
                        controller : 'SicOutletteamController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-outlet-team')
        .controller('SicOutletteamController', SicOutletteamController);


    SicOutletteamController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function SicOutletteamController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Employeoutletteam=AppAPI.Employeoutletteam();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];  
      vm.newMapping=newMapping;
      vm.loadFinish=false;
      // vm.Reject=Reject;

      vm.icon = "icon-plus";
      vm.result = false;
      vm.toogleSubChild=toogleSubChild;
      vm.visibleSubChild=[];
         
      loadData();
 
        //////////
    
    
    function loadData()
    {
      var response=Employeoutletteam.query({action:'viewdata'});
      response.$promise.then(fetchEmpOutlet);
      response.$promise.catch(errorFetchEmpOutlet);
    }

    function fetchEmpOutlet(data)
    {
       vm.listEmpOutlet=data;
       vm.loadFinish=true;
    }

    function errorFetchEmpOutlet()
    {
       vm.loadFinish=true;
    }
  

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

     

    function toogleSubChild(idx) {
      switch(vm.visibleSubChild[idx])
        {
            case true :
            vm.visibleSubChild[idx]=false;
            vm.icon='icon-minus';
            break;
            case false :
            vm.visibleSubChild[idx]=true;
             vm.icon='icon-plus';
            break;
            default:
               vm.visibleSubChild[idx]=true;
                vm.icon='icon-minus';
            break;
        }

    }

    function newMapping(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          // console.log(vm.listOtselected);
          $mdDialog.show({
              controller         : 'sicOutletTeamMappingController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/cb/sic-outlet-team/outlet-team-mapping.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:false,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                vm.listOtselected=[];
                  loadData();
              },
              locals:{
                id:vm.listOtselected
              }
          }); 
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
            vm.listOtselected=[];
              loadData();
          });
        } 
      }

      

    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.sic-outlet-team')
        .controller('sicOutletTeamMappingController', sicOutletTeamMappingController);


    /* @ngInject */
    sicOutletTeamMappingController.$inject = ['$mdDialog', '$http', 'id', 'config', 'Form', 'AppAPI', 'Auth', '$localStorage'];

    function sicOutletTeamMappingController($mdDialog, $http, id, config, Form, AppAPI, Auth, $localStorage) {
        var vm = this;

        vm.cancel = cancel;
        vm.isDisabled = false;
        vm.saveMapping = saveMapping;
        vm.messageTheme = '';
        // initial form
        Form.initialForm(false);

        // get constructor form
        var Employeoutletteam = AppAPI.Employeoutletteam();

        // set constructor form
        Form.setObject(Employeoutletteam);

        // set form to controller
        vm.Form = Form;
        vm.Form.objForm.listteam = id;
        // loadData(); 
        vm.setToken = Auth.setToken;
        vm.lookupJobTitle = lookupJobTitle;
        vm.clearSearchTermSA = clearSearchTermSA;
        vm.searchTermSA = [];
        vm.disabledBtn = false;

        angular.element.blockUI();
        loadOutletList();

        ////////////////
        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }



        // function loadData()
        // {
        //   var response=Employeoutletteam.query({action:'loadSic'});
        //   response.$promise.then(fetchSic);
        //   response.$promise.catch(errorFetchSic);
        // }

        // function fetchSic(data)
        // {
        //    vm.Form.objForm.listSic=data;
        // }

        // function errorFetchSic()
        // {

        // }

        function loadOutletList() {
            var response = Employeoutletteam.query({
                action: 'getOutletList'
            });
            response.$promise.then(fetchOutlet);
            response.$promise.catch(errorFetchOutlet);
        }

        function fetchOutlet(data) {
            vm.listOutlet = data;
            angular.element.unblockUI();
        }

        function errorFetchOutlet() {
            angular.element.unblockUI();
        }

        function cancel() {
            $mdDialog.cancel();
        }


        function saveMapping(ev, formController) {
            angular.element.blockUI();
            for (var i = 0; i < vm.Form.objForm.listteam.length; i++) {
                vm.Form.objForm.listteam[i].effective_date = formController['effective_date_raw' + i].$viewValue;
                formController['effective_date' + i] = formController['effective_date_raw' + i].$viewValue;
            }

            var promise = Form.saveData('save', formController, Employeoutletteam);

            if (promise) {
                promise.then(succesSaveMapping);
                promise.catch(faileSaveMapping);
            } else {
                if (!formController.$valid) {
                    faileSaveMapping();
                }
            }
        }

        function succesSaveMapping() {
            vm.disabledBtn = true;
            vm.messageTheme = 'green';
            angular.element.unblockUI();
        }

        function faileSaveMapping() {
            vm.messageTheme = 'red';
            angular.element.unblockUI();
        }

        function lookupJobTitle(ev, idx) {
            vm.isLayerOverlap = false;
            $localStorage.seleEctedJob = null;
            $mdDialog.show({
                controller: 'OutletTeamMappingLookUpLayerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/sic-outlet-team/outlet-team-mapping-lookupLayer.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {
                    var layerSelected = $localStorage.seleEctedJob;
                    if (layerSelected) {
                        vm.Form.objForm.listteam[idx].jobTitleName = layerSelected.jobTitleName;
                        vm.Form.objForm.listteam[idx].jobTitle = layerSelected.mpp_detail_id;
                        if (layerSelected.fullfilmentType == 'Fullfilement') {
                            vm.isLayerOverlap = true;
                        }
                        vm.Form.objForm.listteam[idx].abreviation = layerSelected.abreviation;
                        vm.Form.objForm.listteam[idx].mppDetailId = layerSelected.mpp_detail_id;
                        vm.Form.objForm.listteam[idx].job_title = layerSelected.description;
                        vm.Form.objForm.listteam[idx].orgLayerId = layerSelected.org_layer_id;
                    }
                },
                locals: {
                    id: {
                        company: vm.Form.objForm.listteam[idx].company,
                        divisi: vm.Form.objForm.listteam[idx].divisi,
                        department: vm.Form.objForm.listteam[idx].department,
                        nextArea: vm.Form.objForm.listteam[idx].nextArea,
                        effectiveDate: vm.Form.objForm.listteam[idx].effective_date,
                        empGrade: vm.Form.objForm.listteam[idx].empGrade
                    }
                }
            });
        }

        function clearSearchTermSA(idx) {
            if (typeof vm.searchTermSA[idx] != 'undefined') {
                vm.searchTermSA[idx] = '';
            }
        }
    }
})();

(function () 
{
    'use strict';

    angular
        .module('app.employee.employe.input-employe')
        .controller('OutletTeamMappingLookUpLayerController', OutletTeamMappingLookUpLayerController);

    /** @ngInject */
    OutletTeamMappingLookUpLayerController.$inject=['$stateParams','$mdDialog','$localStorage','AppAPI','Auth','id'];
    /** @ngInject */
    function OutletTeamMappingLookUpLayerController($stateParams,$mdDialog,$localStorage,AppAPI,Aut,id)
    {
        
      var vm = this;
	    vm.cancel=cancel;
      var Employements=AppAPI.Employements(); 
      var Attendancereport=AppAPI.Attendancereport();
 
      vm.company=id.company;
      vm.divisi=id.divisi;
      vm.department=id.department;
      vm.loadLayerData=loadLayerData;
      vm.chooseEmployee=chooseEmployee;
      vm.isLoadingLoadEmployee=true;
      vm.nextArea=id.nextArea;
      vm.effectiveDate=id.effective_date;
      vm.empGrade=id.empGrade;

      vm.AM = null;

      angular.element.blockUI();
      // activate(); 

      ////////////////////////////////////

      function cancel()
      {
        $mdDialog.hide();
      }

      var response=Attendancereport.query({action:'getAMByArea',subAreaID:vm.nextArea});
      response.$promise.then(fetchAM);
      response.$promise.catch(errorAm);

      function fetchAM(data) 
      {
        if(data.length > 0) {
          vm.directReport=data[0].nik;
          vm.AM = data[0];
          loadLayerData();
        } else {
          errorAm();
        }
      }

      function errorAm() {
        vm.listDepartment=[];
        angular.element.blockUI();
      }

      function loadLayerData()
      {
          vm.saveProcess=true;
          vm.isLoadingLoadEmployee=true;
          var response=Employements.query({
                action: "getLayerDataAM",
                company:vm.company,
                divisi:vm.divisi,
                department:vm.department,
                search:vm.searchParam,
                nextArea:vm.nextArea,
                effectiveDate:vm.effectiveDate,
                empGrade:vm.empGrade
              }
            );
          response.$promise.then(fetchEmp);
          response.$promise.catch(errorFetchEmp);

      }

      function fetchEmp(data) {
        vm.empList=data;
        vm.isLoadingLoadEmployee=false;
        angular.element.unblockUI();
      }

      function errorFetchEmp() {
        vm.isLoadingLoadEmployee=false;
        angular.element.unblockUI();
      }

      function chooseEmployee(item)
      {
        $localStorage.seleEctedJob = item;
        $mdDialog.hide($localStorage.seleEctedJob);
      }

    } 
})();  

(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-outlet-mapping', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_sic_outlet_mapping', {
                url    : '/cb/outlet-mapping',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/sic-outlet-mapping/sic-outlet-mapping.html',
                        controller : 'SicOutletMappingController as vm',
                        css: ['app/main/cb/sic-outlet-mapping/sic-outlet-mapping.scss']
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-outlet-mapping')
        .controller('SicOutletMappingController', SicOutletMappingController);


    SicOutletMappingController.$inject=['$state','$mdDialog', 'DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function SicOutletMappingController($state,$mdDialog, DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Outletmapping=AppAPI.Outletmapping();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[]; 
      vm.NewMapping=NewMapping;
      vm.setViewTeam=setViewTeam;
      vm.Delete=Delete;
	  		
      vm.icon = "icon-plus";
      vm.result = false;
      vm.toogleSubChild=toogleSubChild;
      vm.visibleSubChild=[];

      vm.oddEven = function(idx) {
        return idx % 1 == 0 ? 'odd' : 'even';
      }
      
      angular.element.blockUI();
      loadData(1);
 
        //////////
    
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Outletmapping,pageno,{action:'viewdata'});

      resp.then(function(){
        angular.element.unblockUI();
      });

      resp.catch(function(){
        angular.element.unblockUI();
      });

      vm.listOtselected=[];
    }
     	
    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

    function NewMapping(ev)
    {
      $mdDialog.show({
        controller: 'sicnewMappingController',
        controllerAs:'vm',
        templateUrl: 'app/main/cb/am-sic-mapping/new-mapping.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        locals:{ 
        },
        onRemoving:function(element, removePromise)
        {
          loadData();
        },
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function toogleSubChild(idx) {
      switch(vm.visibleSubChild[idx])
        {
            case true :
            vm.visibleSubChild[idx]=false;
            vm.icon='icon-minus';
            break;
            case false :
            vm.visibleSubChild[idx]=true;
             vm.icon='icon-plus';
            break;
            default:
               vm.visibleSubChild[idx]=true;
                vm.icon='icon-minus';
            break;
        }

    }

    function setViewTeam(ev,id)
      {
        $mdDialog.show({
                controller         : 'viewTeamMappingtController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/hr-crew-mapping-approval/view-team-mapping.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            });
      }

      function Delete(ev,id)
      {
         var promise=Auth.setToken();
        promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data you selected will be delete.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

        $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
        var response=Outletmapping.delete({action:'delete',data:angular.toJson(id)});
        response.$promise.then(loadData);
            }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
        });
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-leave-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_sic_leave_approval', {
                url    : '/cb/store-incharge-leave-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/sic-leave-approval/sic-leave-approval.html',
                        controller : 'SicLeaveApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.sic-leave-approval')
        .controller('sicLeaveRejectCommentController', sicLeaveRejectCommentController);

    sicLeaveRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function sicLeaveRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Approvalabsence = AppAPI.Sicleaveapproval();

        // set constructor form
        Form.setObject(Approvalabsence);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;
        // console.log(id);

    function saveData(ev,formController)
        { 
            var promise= Form.saveData('reject', formController, Approvalabsence);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-leave-approval')
        .controller('SicLeaveApprovalController', SicLeaveApprovalController);


    SicLeaveApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$location','$http','config','$filter'];
    /** @ngInject */
    function SicLeaveApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$location,$http,config,$filter)
    {
        
      var vm = this; 
      var translate = $filter('translate');
      vm.editData=editData;
      vm.deleteData=deleteData;
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Approvalabsence=AppAPI.Sicleaveapproval();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveOT=approveOT;
      vm.ViewDocument=ViewDocument;
      vm.UnApproved=UnApproved;
      vm.Reject=Reject;
      vm.UnReject=UnReject;
      vm.viewComment=viewComment; 
      var Employeshiftt=AppAPI.Overtime();
      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected'];
      vm.toggleSelectedAll=toggleSelectedAll;  
      vm.onCollapse = onCollapse;

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();
      if(vm.tgl >=25 && vm.tgl <=31)
        { 
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }

      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
    
    // getPeriode();  
    

    //////////
    // loadData(1);
    
    function loadData(pageno)
    {
      var company='all';
      var divisi='all';
      var department='all';
      var resp=vm.DataTable.loadData(Approvalabsence,pageno,{action:'viewdata',company:company,divisi:divisi,departement:department,tglmulai:vm.tglmulai,tglakhir:vm.tglakhir,type:vm.type});
      vm.listOtselected=[];
    }

    function getPeriode(){
        var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.periode=data[0]['periode'];
        // console.log(vm.periode);
        loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }
     

    function editData(id) {
        $state.go('app.cb_employe_overtime_edit_employe_ot',{id:id});
    }

    function deleteData(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=BU.delete({action:'delete',data:angular.toJson(vm.listBuSelected)});

       response.$promise.then(viewDataBu);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

   function toggleSelectedAll(state)
    {
      // console.log(state);
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listOtselected=angular.copy(vm.DataTable.list);
       // console.log(vm.listOtselected);
    }

    function unCheckAll() {
       vm.listOtselected=[];
    }

       
      function approveOT(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Approve this list?')
                .textContent('All data your selected will be approve.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  // console.log(vm.listOtselected);
                  var ot= new Approvalabsence();
                  ot.data=[];
                  ot.action='approve';
                  ot.nik=nik;
                  ot.approval_type='n1';  
                  for (i=0;i<jum;i++) {
                    ot.data.push({id:vm.listOtselected[i].id});
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save();  

                  response.then(function (data) {
                    angular.element.unblockUI();
                    showDialogInfo(ev, data);
                  });
                  response.catch(function(data){
                    angular.element.unblockUI();
                    showDialogInfo(ev, data.data);
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 

      }

      function successApproved(ev,data)
      {
          if (data.status == 1) {
              data.status = 'PAYROLL.MESSAGE.SUCCESS';
          } else if (data.status == 0) {
              data.status = 'PAYROLL.MESSAGE.FAILED';
          }

          var expmess = data.pesan.split("_");

          if (expmess.length > 1) {
              var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
          } else {
              var message = translate(data.pesan);
          }

          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

      function failedApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

      // function  showSuccess(ev,data) { 
      //   angular.element.unblockUI();
      //   $mdDialog.show(
      //   $mdDialog.alert()
      //   .parent(angular.element(document.querySelector('#contentDialog')))
      //   .clickOutsideToClose(true)
      //   .title('Approval Success!')
      //   .textContent(data.pesan)
      //   .ariaLabel('Approval Success')
      //   .ok('close')
      //   .targetEvent(ev)
      //   ).then(function(){
      //       loadData();
      //   });
      // }

      // function  showFailed(ev,data) {
      //   // console.log(data);
      //   angular.element.unblockUI();
      //   $mdDialog.show(
      //   $mdDialog.alert()
      //   .parent(angular.element(document.querySelector('#contentDialog')))
      //   .clickOutsideToClose(true)
      //   .title('Approval Failed!')
      //   .textContent(data.pesan)
      //   .ariaLabel('Approval Failed')
      //   .ok('close')
      //   .targetEvent(ev)
      //   ).then(function(){
      //       loadData();
      //   });
      // }

     // function Reject(ev)
     //  {
     //    var promise=Auth.setToken();
     //     promise.then(function(){
     //          var confirm = $mdDialog.confirm()
     //          .title('Would you like to Reject this list?')
     //          .textContent('All data your selected will be Reject.')
     //          .ariaLabel('delete dialog')
     //          .targetEvent(ev)
     //          .ok('YES')
     //          .cancel('no');
     //      $mdDialog.show({
     //            multiple: true
     //       });      
     //      $mdDialog.show(confirm).then(function() {
     //            angular.element.blockUI();
     //            // console.log(vm.listOtselected);
     //            var ot= new Approvalabsence();
     //            ot.data=[];
     //            ot.action='reject';
     //            ot.nik=nik;
     //            ot.approval_type='n1';
     //            var jum=vm.listOtselected.length,i,ids=[]; 
     //            for (i=0;i<jum;i++) {
     //              ot.data.push({id:vm.listOtselected[i].id});
     //            }
     //            var idtx=encodeURIComponent(angular.toJson(ids));
     //            var response=ot.$save(); 
     //            //var response=tm.$delete({action:'approve'});
     //            response.then(loadData);
     //        }, function() {
     //       // $scope.status = 'You decided to keep your debt.';
     //      });
     //    });

     //  }
     function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
        //  var promise=Auth.setToken();
        //  promise.then(function(){
        //       var confirm = $mdDialog.confirm()
        //       .title('Would you like to Reject this list?')
        //       .textContent('All data your selected will be Reject.')
        //       .ariaLabel('delete dialog')
        //       .targetEvent(ev)
        //       .ok('YES')
        //       .cancel('no');
        //   $mdDialog.show({
        //         multiple: true
        //    });      
        //   $mdDialog.show(confirm).then(function() {
        //         angular.element.blockUI();
        //         // console.log(vm.listOtselected);
        //         var ot= new Approvalabsence();
        //         ot.data=[];
        //         ot.action='reject';
        //         ot.nik=nik;
        //         ot.approval_type='n1';  
        //         for (i=0;i<jum;i++) {
        //           ot.data.push({id:vm.listOtselected[i].id});
        //         }
        //         var idtx=encodeURIComponent(angular.toJson(ids));
        //         var response=ot.$save(); 
        //         //var response=tm.$delete({action:'approve'});
        //         response.then(loadData);
        //         response.catch( function(){
        //             angular.element.unblockUI();
        //           });
        //     }, function() {
        //    // $scope.status = 'You decided to keep your debt.';
        //   });
        // });

          $mdDialog.show({
                controller         : 'sicLeaveRejectCommentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/approval-absence/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                    vm.listOtselected=[];
                },
                locals:{
                  id:vm.listOtselected
                }
            });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              vm.listOtselected=[];
          });
        } 
      }

      function ViewDocument(name)
        {
            // var protocol=$location.protocol();
            // var host=$location.host();
            // $window.open(protocol+'://'+host+'/'+config.api+'api/empdocument/'+link, '_blank'); 

            // console.log(protocol+'  /  '+host+'  /   '+config.api);
            // var url=config.api+'api/empdocument/'+link;
            $http({
                    method: 'GET',
                    url: config.api+'api/leavedocument/'+name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];
             
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);
             
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
             
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
        }

      function UnApproved(ev,id)
      {
        var promise=Auth.setToken();
         promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

        $mdDialog.show(confirm).then(function() {
         angular.element.blockUI();
            var response=Approvalabsence.delete({action:'unapproved',data:angular.toJson(id)});
            response.$promise.then(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
            response.$promise.catch(function(data){
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
            }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
         });
      }

      function viewComment(ev,id)
      {
        $mdDialog.show({
            controller         : 'AbsenceViewRejectCommentController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-absence/comment-reject.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            { 
                vm.listOtselected=[];
            },
            locals:{
              id:id
            }
        });
      }

      function UnReject(ev,id)
      {
        var promise=Auth.setToken();
        promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to unreject this list?')
            .textContent('All data you selected will be set to unreject.')
            .ariaLabel('unreject dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

          $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
            var response=Approvalabsence.delete({action:'unreject',data:angular.toJson(id)});
            response.$promise.then(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
            response.$promise.catch(function(data){
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });
      }

      function onCollapse() {
        loadData(1);
      }

      function showDialogInfo(ev, data) {
          if (data.status == 1) {
              data.status = 'PAYROLL.MESSAGE.SUCCESS';
          } else if (data.status == 0) {
              data.status = 'PAYROLL.MESSAGE.FAILED';
          }

          var expmess = data.pesan.split("_");

          if (expmess.length > 1) {
              var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
          } else {
              var message = translate(data.pesan);
          }

          var status = translate(data.status);
          $mdDialog
              .show(
                  $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('#contentDialog')))
                      .clickOutsideToClose(true)
                      .title(status)
                      .textContent(message)
                      .ariaLabel(status)
                      .ok('OK')
                      .targetEvent(ev)
              )
              .then(function () {
                  dialogClose();
                  if ('moreInfo' in data && data.moreInfo.length > 0) {
                      $mdDialog.show({
                          controller: 'logFailGwController',
                          controllerAs: 'vm',
                          templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                          parent: angular.element(document.body),
                          clickOutsideToClose: true,
                          fullscreen: true,
                          onRemoving: function (element, removePromise) {
                              loadData(1);
                          },
                          locals: {
                              data: data.moreInfo
                          }
                      });
                  } else {
                      loadData(1);
                  }
              });
      } 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-changeshift-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_sic_changeshift_approval', {
                url    : '/cb/sic-changeshift-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/sic-changeshift-approval/sic-changeshift-approval.html',
                        controller : 'SicchangeshiftApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.sic-changeshift-approval')
        .controller('sicChangeshiftRejectController', sicChangeshiftRejectController);

    sicChangeshiftRejectController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function sicChangeshiftRejectController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Attendanceemploye = AppAPI.Sicchangeshiftapproval();

        // set constructor form
        Form.setObject(Attendanceemploye);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Attendanceemploye);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-changeshift-approval')
        .controller('SicchangeshiftApprovalController', SicchangeshiftApprovalController);


    SicchangeshiftApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function SicchangeshiftApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
       var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Changeshiftapproval=AppAPI.Sicchangeshiftapproval();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveChangeshift=approveChangeshift;
      vm.Reject=Reject;
      vm.UnReject=UnReject;
      vm.UnApproved=UnApproved;
      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();
      vm.viewComment=viewComment;
      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected']; 
      vm.toggleSelectedAll=toggleSelectedAll;

      if(vm.tgl >=25 && vm.tgl <=31)
        { 
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }

      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}]; 
      
      getPeriode();
      loadData(1); 
        //////////
   

    function getPeriode(){
        var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.periode=data[0]['periode'];
        // console.log(vm.periode);
        loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Changeshiftapproval,pageno,{action:'viewdata',nik:nik,tahun:vm.tahun,bulan:vm.bulan});
      vm.listOtselected=[];
    }
     
  

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

    function toggleSelectedAll(state)
      {
        // console.log(state);
          switch(state)
          {
              case true:
              checkAll();
              break;
              case false:
              unCheckAll();
              break;
          }
      }

      function checkAll() {
         vm.listOtselected=angular.copy(vm.DataTable.list);
         // console.log(vm.listOtselected);
      }

      function unCheckAll() {
         vm.listOtselected=[];
      }

      function approveChangeshift(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    // console.log(vm.listOtselected);
                    var ot= new Changeshiftapproval();
                    ot.data=[];
                    ot.action='approve';
                    ot.nik=nik;  
                    for (i=0;i<jum;i++) {
                      ot.data.push({id:vm.listOtselected[i].id,
                                    idshift:vm.listOtselected[i].idshift,
                                    nik:vm.listOtselected[i].nik,
                                    tgl:vm.listOtselected[i].tgl});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    //var response=tm.$delete({action:'approve'});
                    response.then(loadData);
                    response.catch( function(){
                      angular.element.unblockUI();
                    });
                }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
            }); 
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

      function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          var data=[];
          for (i=0;i<jum;i++) {
            data.push({id:vm.listOtselected[i].id,
                      idshift:vm.listOtselected[i].idshift,
                      nik:vm.listOtselected[i].nik,
                      tgl:vm.listOtselected[i].tgl});
          }

          $mdDialog.show({
                controller         : 'sicChangeshiftRejectController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/changeshift-approval/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:data
                }
            });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        }
      }

  function UnReject(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
      angular.element.blockUI();
      var response=Changeshiftapproval.delete({action:'unreject',data:angular.toJson(id)});
      response.$promise.then(loadData);
      response.$promise.catch(function(){
        angular.element.unblockUI();
      });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

  function UnApproved(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to unapprove this list?')
          .textContent('All data you selected will be set to unapproved.')
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
      angular.element.blockUI();
      var response=Changeshiftapproval.delete({action:'unapproved',data:angular.toJson(id)});
      response.$promise.then(loadData);
      response.$promise.catch(function(){
        angular.element.unblockUI();
      });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

  function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'changeShiftViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/abnormal-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              vm.listOtselected=[];
          },
          locals:{
            id:id
          }
      });
    } 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-approval-ghk', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_sic_approval_ghk', {
                url    : '/cb/sic-approval-ghk',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/sic-approval-ghk/sic-approval-ghk.html',
                        controller : 'SicapprovalghkController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-approval-ghk')
        .controller('SicapprovalghkController', SicapprovalghkController);


    SicapprovalghkController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function SicapprovalghkController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this; 
      vm.editData=editData;
      vm.deleteData=deleteData;
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Approvalghk=AppAPI.Approvalghk();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveOT=approveOT;
      vm.Reject=Reject;
      loadData();
      
 
    /////////////////////

    function loadData() {
        angular.element.blockUI();
         var response=Approvalghk.query({action:'viewdata'});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listGhk=data;
        angular.element.unblockUI();
      }

      function errorDepartment() {
        vm.listGhk=[];
        angular.element.unblockUI();
      }



    function editData(id) {
        $state.go('app.cb_employe_overtime_edit_employe_ot',{id:id});
    }

    function deleteData(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=BU.delete({action:'delete',data:angular.toJson(vm.listBuSelected)});

       response.$promise.then(viewDataBu);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function approveOT(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Approvalghk();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik; 
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

    function Reject(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Reject this list?')
              .textContent('All data your selected will be Reject.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Approvalghk();
                ot.data=[];
                ot.action='reject'; 
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      } 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-abnormal-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_sic_abnormal_approval', {
                url    : '/cb/sic-abnormal-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/sic-abnormal-approval/sic-abnormal-approval.html',
                        controller : 'SicabnormalApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.sic-abnormal-approval')
        .controller('SicAbnormalViewRejectCommentController', SicAbnormalViewRejectCommentController);

    SicAbnormalViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function SicAbnormalViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.sic-abnormal-approval')
        .controller('SicAbnormaltRejectCommentController', SicAbnormaltRejectCommentController);

    SicAbnormaltRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function SicAbnormaltRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Sicabnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.sic-abnormal-approval')
        .controller('SicabnormalApprovalController', SicabnormalApprovalController);


    SicabnormalApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function SicabnormalApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Abnormalapproval=AppAPI.Sicabnormalapproval();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveAbnormal=approveAbnormal;
      vm.Reject=Reject;
      vm.UnApproved=UnApproved;
      vm.getPeriode=getPeriode;
      vm.UnReject=UnReject;
      vm.viewComment=viewComment;

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();
      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected']; 
      vm.toggleSelectedAll=toggleSelectedAll; 

      if(vm.tgl >=25 && vm.tgl <=31)
        { 
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }

      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
      
      // getPeriode();  
 
        ////////// 
    
     function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Abnormalapproval,pageno,{action:'viewdata',tglmulai:vm.tglmulai,tglakhir:vm.tglakhir,type:vm.type});
      // vm.listOtselected=[];
    }

    // function loadData() {
    //     angular.element.blockUI();
    //      var response=Abnormalapproval.query({action:'viewdata'});
    //     response.$promise.then(fetchDepartment);
    //     response.$promise.catch(errorDepartment);
    //   }

    //   function fetchDepartment(data) {
    //     vm.listApp=data;
    //     // loadData(1);
    //     // console.log(vm.listApp);
    //     angular.element.unblockUI();
    //   }

    //   function errorDepartment() {
    //     vm.listApp=[];
    //     angular.element.unblockUI();
    //   }
     
    function getPeriode(){
        var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.periode=data[0]['periode'];
        // console.log(vm.periode);
        loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }
    

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function toggleSelectedAll(state)
    {
      // console.log(state);
        switch(state)
        {
            case true:
            checkAll();
            break;
            case false:
            unCheckAll();
            break;
        }
    }

    function checkAll() {
       vm.listOtselected=angular.copy(vm.DataTable.list);
       // console.log(vm.listOtselected);
    }

    function unCheckAll() {
       vm.listOtselected=[];
    }

     function approveAbnormal(ev)
      {
        // console.log(vm.listOtselected);
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Approve this list?')
                .textContent('All data your selected will be approve.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  console.log(vm.listOtselected);
                  var ot= new Abnormalapproval();
                  ot.data=[];
                  ot.action='approve';
                  ot.nik=nik;  
                  for (i=0;i<jum;i++) {
                    ot.data.push({id:vm.listOtselected[i].id
                                  });
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save(); 
                  //var response=tm.$delete({action:'approve'});
                  response.then(loadData);
                  response.catch( function(){
                    angular.element.unblockUI();
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

  function UnApproved(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to unapprove this list?')
          .textContent('All data you selected will be set to unapproved.')
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
      angular.element.blockUI();
      var response=Abnormalapproval.delete({action:'unapproved',data:angular.toJson(id)});
      response.$promise.then(loadData);
      response.$promise.catch(function(){
        angular.element.unblockUI();
      });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

    function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[]; 
        if(jum>0)
        {
          //  var promise=Auth.setToken();
          //  promise.then(function(){
          //       var confirm = $mdDialog.confirm()
          //       .title('Would you like to Reject this list?')
          //       .textContent('All data your selected will be Reject.')
          //       .ariaLabel('delete dialog')
          //       .targetEvent(ev)
          //       .ok('YES')
          //       .cancel('no');
          //   $mdDialog.show({
          //         multiple: true
          //    });      
          //   $mdDialog.show(confirm).then(function() {
          //         angular.element.blockUI();
          //         // console.log(vm.listOtselected);
          //         var ot= new Abnormalapproval();
          //         ot.data=[];
          //         ot.action='reject'; 
          //         for (i=0;i<jum;i++) {
          //           ot.data.push({id:vm.listOtselected[i].id});
          //         }
          //         var idtx=encodeURIComponent(angular.toJson(ids));
          //         var response=ot.$save(); 
          //         //var response=tm.$delete({action:'approve'});
          //         response.then(loadData);
          //         response.catch( function(){
          //           angular.element.unblockUI();
          //         });
          //     }, function() {
          //    // $scope.status = 'You decided to keep your debt.';
          //   });
          // });
          $mdDialog.show({
                controller         : 'SicAbnormaltRejectCommentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/abnormal-approval/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                    vm.listOtselected=[];
                },
                locals:{
                  id:vm.listOtselected
                }
            });
        }else{
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            });
        } 

      }

      // function Reject(ev)
      // {
      //   var promise=Auth.setToken();
      //    promise.then(function(){
      //         var confirm = $mdDialog.confirm()
      //         .title('Would you like to Reject this list?')
      //         .textContent('All data your selected will be Reject.')
      //         .ariaLabel('delete dialog')
      //         .targetEvent(ev)
      //         .ok('YES')
      //         .cancel('no');
      //     $mdDialog.show({
      //           multiple: true
      //      });      
      //     $mdDialog.show(confirm).then(function() {
      //           angular.element.blockUI();
      //           // console.log(vm.listOtselected);
      //           var ot= new Abnormalapproval();
      //           ot.data=[];
      //           ot.action='reject';
      //           var jum=vm.listOtselected.length,i,ids=[]; 
      //           for (i=0;i<jum;i++) {
      //             ot.data.push({id:vm.listOtselected[i].id});
      //           }
      //           var idtx=encodeURIComponent(angular.toJson(ids));
      //           var response=ot.$save(); 
      //           //var response=tm.$delete({action:'approve'});
      //           response.then(loadData);
      //       }, function() {
      //      // $scope.status = 'You decided to keep your debt.';
      //     });
      //   });

      // }

  function UnReject(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
      angular.element.blockUI();
      var response=Abnormalapproval.delete({action:'unreject',data:angular.toJson(id)});
      response.$promise.then(loadData);
      response.$promise.catch(function(){
        angular.element.unblockUI();
      });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

    function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'SicAbnormalViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/abnormal-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              vm.listOtselected=[];
          },
          locals:{
            id:id
          }
      });
    } 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.shiftlocation', [
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.cb_shiftlocation', {
                url    : '/cb/shiftlocation',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/shiftlocation/shiftlocation.html',
                        controller : 'shiftlocationController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.shiftlocation')
        .controller('shiftlocationController', shiftlocationController);


    shiftlocationController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function shiftlocationController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {

        var vm = this;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.editData=editData;
        vm.toggleSelectedAll=toggleSelectedAll;
        var Shiftlocation=AppAPI.Shiftlocation();
        vm.inputShiftLocation= inputShiftLocation;
        vm.lisShiftSelected=[];
        vm.company = ($localStorage.empsite) ? $localStorage.empsite : "all";
        vm.DeleteShiftlocation=DeleteData;

        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
                    {link:'#',name:'C&B / ',active:'0'}
                    ];
         loadData(1);


        function inputShiftLocation(ev,id)
        {
            $mdDialog.show({
                controller         : 'InputshiftlocationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/shiftlocation/input-shiftlocation.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  id:id
                }
            });
        }

        //////////

        function loadData(pageno)
        {
          var resp=vm.DataTable.loadData(Shiftlocation,pageno,{action:'viewdata', company: vm.company});
         // console.log(resp);
          // angular.element.unblockUI();
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisShiftSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.lisShiftSelected=[];
          }
        function editData(id){
          $state.go('app.utility_modul_edit-modul',{id:id});
        }


        function closeModal()
        {
            $mdDialog.hide();
        }

    function DeleteData(ev) {
          var promise=Auth.setToken();
         promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data your selected will be deleted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

      $mdDialog.show(confirm).then(function() {
          angular.element.blockUI();
         var response=Shiftlocation.delete({action:'delete',data:angular.toJson(vm.lisShiftSelected)});

         response.$promise.then(loadData);
      }, function() {
       // $scope.status = 'You decided to keep your debt.';
      });
         });


      }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.shiftlocation')
        .controller('InputshiftlocationController', InputshiftlocationController);

    InputshiftlocationController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function InputshiftlocationController($localStorage,$mdDialog,Form,AppAPI) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Shiftlocation = AppAPI.Shiftlocation();

        // set constructor form
        Form.setObject(Shiftlocation);

        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal; 
        var empID=$localStorage.username;
        vm.gender = ['L','P'];
        vm.LoadLocation=LoadLocation;
        vm.changeRefshift=changeRefshift;
        vm.changedws1=changedws1; 
        vm.changedws2=changedws2;
        vm.changedws3=changedws3;
        vm.shift1=false;
        vm.shift2=false;
        vm.shift3=false;
        LoadLocation();
        Loadshiftref();
        Loaddws();
        // console.log(id); 
        ////////////////

        function changeRefshift(c)
        {
          var obj=JSON.parse(c);
          vm.listdwsdetail1=[];
          vm.listdwsdetail2=[];
          vm.listdwsdetail3=[];
          vm.Form.objForm.dwscode1='';
          vm.Form.objForm.dwscode2='';
          vm.Form.objForm.dwscode3='';
          if(obj.cycling ==3)
          {
            vm.shift1=true;
            vm.shift2=true;
            vm.shift3=true;
          }else if(obj.cycling ==2)
          {
            vm.shift1=true;
            vm.shift2=true;
            vm.shift3=false;
          }else if(obj.cycling ==1)
          {
            vm.shift1=true;
            vm.shift2=false;
            vm.shift3=false;
          } 
          
        }

        function changedws1(dws)
        {
          // console.log(dws);
          var response=Shiftlocation.query({action:'getdwsDetail',dwscode:dws});
          response.$promise.then(fetchdwsdetail1);
          response.$promise.catch(errorFetchdwsdetail1);
        }

        function fetchdwsdetail1(data) {
            vm.listdwsdetail1=data;
          }

          function errorFetchdwsdetail1() {
            vm.listdwsdetail1=[];
          }

        function changedws2(dws)
        {
          var response=Shiftlocation.query({action:'getdwsDetail',dwscode:dws});
          response.$promise.then(fetchdwsdetail2);
          response.$promise.catch(errorFetchdwsdetail2);
        }

        function fetchdwsdetail2(data) {
            vm.listdwsdetail2=data;
        }

        function errorFetchdwsdetail2() {
          vm.listdwsdetail2=[];
        }

        function changedws3(dws)
        {
          var response=Shiftlocation.query({action:'getdwsDetail',dwscode:dws});
          response.$promise.then(fetchdwsdetail3);
          response.$promise.catch(errorFetchdwsdetail3);;
        }

        function fetchdwsdetail3(data) {
            vm.listdwsdetail3=data;
        }

        function errorFetchdwsdetail3() {
          vm.listdwsdetail3=[];
        }

        function Loaddws() {
            var response=Shiftlocation.query({action:'getdws'});
            response.$promise.then(fetchdws);
            response.$promise.catch(errorFetchdws);
          }

          function fetchdws(data) {
            vm.listdws=data;
          }

          function errorFetchdws() {
            vm.listdws=[];
          }

        function LoadLocation() {
            var response=Shiftlocation.query({action:'getLocation'});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

          function fetchLocation(data) {
            vm.listLocation=data;
          }

          function errorFetchLocation() {
            vm.listLocation=[];
          } 

        function Loadshiftref() {
            var response=Shiftlocation.query({action:'getshiftref'});
            response.$promise.then(fetchshiftref);
            response.$promise.catch(errorFetchshiftref);
          }

          function fetchshiftref(data) {
            vm.listshiftref=data;
          }

          function errorFetchshiftref() {
            vm.listshiftref=[];
          } 


       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {  
            var promise= Form.saveData('save', formController, Shiftlocation);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.shift-ghk-report', [ ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    { 
        // State
        $stateProvider
            .state('app.cb_shift_ghk_report', {
                url    : '/cb/shift-ghk-report',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/shift-ghk-report/shift-ghk-report.html',
                        controller : 'ShiftGhkReportController as vm'
                    }
                }
            });  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.shift-ghk-report')
        .controller('ShiftGhkReportController', ShiftGhkReportController);


    ShiftGhkReportController.$inject=['$state','$window','$location','$localStorage','$document','$element','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService' ];
    /** @ngInject */
    function ShiftGhkReportController($state,$window,$location,$localStorage,$document,$element,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService )
    {

        var vm = this;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.ExportToExcel=ExportToExcel;
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;
        var Shiftghkreport=AppAPI.Shiftghkreport();
        var Attendancereport=AppAPI.Attendancereport();
        var date=new Date();
        vm.tahun=date.getFullYear();
        vm.bulan=date.getMonth()+1;
        vm.getPeriode=getPeriode;
        vm.tgl=date.getDate();
        vm.flag_app='SAP';
        vm.flagApp=['SAP','HRIS'];
        vm.loadSubArea=loadSubArea;
        if(vm.tgl >=25 && vm.tgl <=31)
        {
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }
        vm.company=$localStorage.empsite;
        vm.groupLogin=$localStorage.group;

        vm.typeEmp = [
          {
            "view"  : "Staff",
            "value" : "SAP"
          },
          {
            "view"  : "General Worker",
            "value" : "HRIS"
          }
        ];

        loadDataBU();
        loadDataDivision(vm.company);
        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
                    {link:'#',name:'C&B / ',active:'0'}
                    ];
        vm.listtahun=[2017,2018,2019,2020,2021];
        vm.listbulan=[{name:'January',value:'01'},
                      {name:'February',value:'02'},
                      {name:'Maret',value:'03'},
                      {name:'April',value:'04'},
                      {name:'Mei',value:'05'},
                      {name:'June',value:'06'},
                      {name:'July',value:'07'},
                      {name:'August',value:'08'},
                      {name:'September',value:'09'},
                      {name:'October',value:'10'},
                      {name:'November',value:'11'},
                      {name:'Desember',value:'12'}];

        vm.simulateQuery = false;
        vm.isDisabled    = false;
        vm.closeModal=closeModal;
        getPeriode();
        loadSubArea();

        //////////

        vm.searchTerm;
        vm.clearSearchTerm = function() {
          vm.searchTerm = '';
        };
        // The md-select directive eats keydown events for some quick select
        // logic. Since we have a search input here, we don't need that logic.
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

         function getPeriode(){
          var res=Shiftghkreport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
          res.$promise.then(fetchPeriode);
          res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data)
        {
          vm.periode=data[0]['periode'];
          // console.log(vm.periode);
          // loadData(1);
        }

        function errorfetchPeriode(data)
        {
          console.log('error');
        }

         function loadDataDepartment(iddivisi) {
             var response=Shiftghkreport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }

          function loadDataDivision(idbu) {
             var response=Shiftghkreport.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          }

          function loadDataBU() {
            var response=Shiftghkreport.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }



        function loadData(){
           // angular.element.blockUI();
           angular.element('#attView').block({message:'please wait..'});
           var company=vm.company;
           var divisi=vm.divisi;
           var department=vm.department;
           var tahun=vm.tahun;
           var bulan=vm.bulan;
           var subarea=vm.selectedSubarea;
           if(typeof(vm.divisi)==='undefined')
           {
              divisi='all';
           }
           if(typeof(vm.department)==='undefined')
           {
              department='all';
           }

           // console.log(company+' / '+divisi+' / '+department+' / '+tahun+' / '+bulan);
           var response=Shiftghkreport.query({action:'viewdata',company:company,divisi:divisi,department:department,tahun:tahun,bulan:bulan,subarea:subarea,type:vm.flag_app});
              response.$promise.then(function(data){
                vm.listData=data;
                angular.element('#attView').unblock();
              });
              response.$promise.catch(function(data){
                $log.info(data);
                vm.listData=[];
                angular.element('#attView').unblock();
              });
        }

        // function loadData(pageno)
        // {
        //   var company=vm.company;
        //   var divisi=vm.divisi;
        //   var department=vm.department;
        //   var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
        //   var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');

        //   var resp=vm.DataTable.loadData(Overtime,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
        //  // console.log(resp);
        //   // angular.element.unblockUI();
        // }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          }




        function closeModal()
        {
            $mdDialog.hide();
        }

        function ExportToExcel()
        {
          var company=vm.company;
          var divisi=vm.divisi;
          var department=vm.department;
          var tahun=vm.tahun;
          var bulan=vm.bulan;
          var subarea=vm.selectedSubarea;
          var empType=vm.flag_app;
          if(typeof(vm.divisi)==='undefined')
          {
            divisi='all';
          }
          if(typeof(vm.department)==='undefined')
          {
            department='all';
          }
          if (typeof(vm.flag_app) !== "undefined")
          {
            empType = vm.flag_app;
          }
          var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                   $window.open(protocol+'://'+host+config.api+'api/shiftghkreport/exportexcel/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan+'/'+subarea+'/'+empType, '_blank');
            },function(){

                $window.alert('gagal load token');
            });
        }

        function  loadSubArea()
        {
          var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.saldo-ghk-gw', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        $stateProvider
            .state('app.cb_saldo_ghk_gw', {
                url    : '/cb/saldo-ghk-gw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/saldo-ghk-gw/saldo-ghk-gw.html',
                        controller : 'SaldoghkgwController as vm'
                    }
                }
            });
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.saldo-ghk-gw')
        .controller('SaldoghkgwController', SaldoghkgwController);


    SaldoghkgwController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function SaldoghkgwController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
        var vm = this; 
        vm.editData=editData;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData; 
        var SaldoghkGw=AppAPI.SaldoghkGw();
        var nik= $localStorage.user;
        vm.SubtitutionRequest=SubtitutionRequest;
        vm.listGedung = [];
        vm.getListGedung = getListGedung;
        vm.gedung = '';
        
        loadData(1);
        getListGedung();

        function loadData(pageno) {
            var resp=vm.DataTable.loadData(SaldoghkGw,pageno,{action:'viewdata',gedung:vm.gedung});
        }
     
        function editData(id) {
            $state.go('app.cb_emp_ghk_edit_ghk',{id:id});
        }

        function SubtitutionRequest(ev,id)
        {
            $mdDialog.show({
                controller         : 'ApplysubtitutiongwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/saldo-ghk-gw/apply-subtitution-gw.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  id:id
                }
            }); 
        } 

        function getListGedung()
        {
          var response= SaldoghkGw.query({action:'getSelectListGedung'});
          response.$promise.then(fetchGedung);
          response.$promise.catch(errorFetchGedung);
        }

        function fetchGedung(data) {
            vm.listGedung=data;
        }

        function errorFetchGedung() {
            vm.listGedung=[];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.saldo-ghk-gw')
        .controller('ApplysubtitutiongwController', ApplysubtitutiongwController);

    ApplysubtitutiongwController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function ApplysubtitutiongwController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) 
    {
        var vm = this;
        var Saldoghk = AppAPI.SaldoghkGw();
        
        Form.initialForm();
        Form.setObject(Saldoghk);
        
        vm.saveData=saveData;
        vm.Form = Form;
        vm.closeModal = closeModal; 
        vm.Form.objForm.working_date= new Date(id.working_date);
        vm.Form.objForm.id_ghk=id.id; 
        vm.Form.objForm.nik=id.nik; 
        vm.ChangeDayType=ChangeDayType;
        vm.ChangeAbsenceType=ChangeAbsenceType; 
 
        vm.closeModal = closeModal;
        vm.saveProcess=true;

        var response=Saldoghk.query(
            {
                action:'getworkHoliday',
                working_date:vm.Form.objForm.working_date,
                variant:id.variant
            }
        );

        response.$promise.then(fetchHoliday);
        response.$promise.catch(errorfetchHoliday);

        function fetchHoliday(data) {
            vm.listHoliday=data;
            vm.saveProcess=false;
        }

        function errorfetchHoliday() {
            vm.listHoliday=[];
            vm.saveProcess=false;
        }
 
        function ChangeAbsenceType(abs){
            var abs=Attendanceemploye.query({action:'getDocumentRequest',abs_code:abs});
            abs.$promise.then(function(data){ 
                vm.requestdocument=data[0].request
            });

            abs.$promise.catch(function(data){
                $log.info(data);
            });
        }
 
        function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) 
        {  
            vm.saveProcess=true;
            var promise= Form.saveData('savesubtitution', formController, Saldoghk);
            
            promise.then(function(data){
                successSaveData(ev,data);
            });

            promise.catch(function(data){
               failedSaveData(ev,data.data)  
            });
        }

        function successSaveData(ev,data)
        {
            vm.Form.tampilPesan=true;
            vm.messageTheme='green';
            vm.saveProcess=false;
            vm.Form.pesan=data.pesan;
        }

        function failedSaveData(ev,data)
        {
            vm.Form.tampilPesan=true;
            vm.messageTheme='red';
            vm.saveProcess=false;
            vm.Form.pesan=data.pesan;
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
                vm.timedisabled=false;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
                vm.timedisabled=true;
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.saldo-ghk', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_saldo_ghk', {
                url    : '/cb/saldo-ghk',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/saldo-ghk/saldo-ghk.html',
                        controller : 'SaldoghkController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.saldo-ghk')
        .controller('SaldoghkController', SaldoghkController);


    SaldoghkController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage'];
    /** @ngInject */
    function SaldoghkController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage) {

        var vm = this;
        vm.editData = editData;
        vm.deleteData = deleteData;
        vm.loadData = loadData
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Saldoghk = AppAPI.Saldoghk();
        var nik = $localStorage.user;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected = [];
        vm.approveOT = approveOT;
        vm.SubtitutionRequest = SubtitutionRequest;

        loadData(1);




        ////////// 

        function loadData(pageno) {
            angular.element.blockUI();
            var response = Saldoghk.query({
                action: 'viewdata'
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
            //  var resp=vm.DataTable.loadData(Saldoghk,pageno,{action:'viewdata'});
        }

        function fetchDepartment(data) {
            vm.listsaldoGhk = data;
            angular.element.unblockUI();
            // loadData(1);
        }

        function errorDepartment() {
            angular.element.unblockUI();
            vm.listsaldoGhk = [];
        }


        function editData(id) {
            $state.go('app.cb_emp_ghk_edit_ghk', {
                id: id
            });
        }

        function deleteData(ev) {

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = BU.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listBuSelected)
                    });

                    response.$promise.then(viewDataBu);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function isChecked(ls) {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if (idx > -1) {
                vm.listOtselected.splice(idx, 1);
            } else {
                vm.listOtselected.push(ls);
            }
        }

        function approveOT(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to Approve this list?')
                    .textContent('All data your selected will be approve.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });
                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    // console.log(vm.listOtselected);
                    var ot = new Employeghk();
                    ot.data = [];
                    ot.action = 'approve';
                    ot.nik = nik;
                    ot.approval_type = 'n1';
                    var jum = vm.listOtselected.length,
                        i, ids = [];
                    for (i = 0; i < jum; i++) {
                        ot.data.push({
                            id: vm.listOtselected[i].id
                        });
                    }
                    var idtx = encodeURIComponent(angular.toJson(ids));
                    var response = ot.$save();
                    //var response=tm.$delete({action:'approve'});
                    response.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });

        }

        function SubtitutionRequest(ev, id) {
            $mdDialog.show({
                controller: 'ApplysubtitutionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/saldo-ghk/apply-subtitution.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData(1);
                },
                locals: {
                    id: id,
                    loadData: loadData
                }
            });

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.saldo-ghk')
        .controller('ApplysubtitutionController', ApplysubtitutionController);

    ApplysubtitutionController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter', 'loadData'];

    /* @ngInject */
    function ApplysubtitutionController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter, loadData) {
        var vm = this;

        var translate = $filter('translate');
        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Saldoghk = AppAPI.Saldoghk();
        var Employeabsence = AppAPI.Employeabsence();

        // set constructor form
        Form.setObject(Saldoghk);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.Form.objForm.working_date = new Date(id.working_date);
        vm.Form.objForm.id_ghk = id.id;
        vm.Form.objForm.detail_id = id.detail_id;
        vm.ChangeDayType = ChangeDayType;
        vm.ChangeAbsenceType = ChangeAbsenceType;

        vm.closeModal = closeModal;
        vm.saveProcess = true;

        // console.log(id);


        ////////////////

        var response = Saldoghk.query({
            action: 'getworkHoliday',
            working_date: vm.Form.objForm.working_date,
            variant: id.variant
        });

        response.$promise.then(fetchHoliday);
        response.$promise.catch(errorfetchHoliday);

        function fetchHoliday(data) {
            vm.listHoliday = data;
            // console.log(vm.listHoliday);
            vm.saveProcess = false;
        }

        function errorfetchHoliday() {
            vm.listHoliday = [];
            vm.saveProcess = false;
        }

        function ChangeAbsenceType(abs) {
            var abs = Attendanceemploye.query({
                action: 'getDocumentRequest',
                abs_code: abs
            });
            abs.$promise.then(function (data) {
                vm.requestdocument = data[0].request
                console.log(vm.requestdocument);
            });

            abs.$promise.catch(function (data) {
                $log.info(data);
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.Form.objForm.start_date = vm.Form.objForm.holiday_date;
            vm.Form.objForm.end_date = vm.Form.objForm.holiday_date;
            var check = Employeabsence.query({
                action: 'checkFinger',
                startDate: vm.Form.objForm.start_date,
                endDate: vm.Form.objForm.end_date
            });
            check.$promise.then(function (response) {
                angular.element.unblockUI();
                if (response[0].is_working == 1) {
                    var note = translate('PAYROLL.MESSAGE.CHECKFINGER');
                    var yes = translate('PAYROLL.MESSAGE.YES');
                    var no = translate('PAYROLL.MESSAGE.NO');

                    angular.element.unblockUI();
                    var confirm = $mdDialog
                        .confirm()
                        .title('Attention !')
                        .textContent(note)
                        .ariaLabel('dialog')
                        .ok(yes)
                        .cancel(no);

                    $mdDialog.show(confirm).then(
                        function () {
                            angular.element.blockUI();
                            vm.saveProcess = true;
                            var promise = Form.saveData('savesubtitution', formController, Saldoghk);
                            // promise.then(function(){
                            //     showDialog(ev);
                            // });
                            // console.log(promise);
                            // resp.then(successSaveData(data));
                            // resp.catch(failedSaveData(data)); 
                            promise.then(function (data) {
                                successSaveData(ev, data);
                            });

                            promise.catch(function (data) {
                                failedSaveData(ev, data.data)
                            });
                        },
                        function () {
                            // $scope.status = 'You decided to keep your debt.';
                        }
                    );
                } else {
                    vm.saveProcess = true;
                    angular.element.blockUI();
                    var promise = Form.saveData('savesubtitution', formController, Saldoghk);
                    // promise.then(function(){
                    //     showDialog(ev);
                    // });
                    // console.log(promise);
                    // resp.then(successSaveData(data));
                    // resp.catch(failedSaveData(data)); 
                    promise.then(function (data) {
                        successSaveData(ev, data);
                    });

                    promise.catch(function (data) {
                        failedSaveData(ev, data.data)
                    });
                }
            });
            check.$promise.catch(function () {
                angular.element.unblockUI();
            });
        }

        function successSaveData(ev, data) {

            vm.Form.tampilPesan = true;
            vm.messageTheme = 'green';
            vm.saveProcess = false;
            vm.Form.pesan = data.pesan;

            angular.element.unblockUI();

            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success')
                    .textContent(data.pesan)
                    .ariaLabel('')
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function failedSaveData(ev, data) {
            // console.log(data);
            vm.Form.tampilPesan = true;
            vm.messageTheme = 'red';
            vm.saveProcess = false;
            vm.Form.pesan = data.pesan;
        }

        // function showDialog(ev) {
        //     vm.saveProcess=false;
        //    $mdDialog.show(
        //     $mdDialog.alert()
        //     .parent(angular.element(document.querySelector('#contentDialog')))
        //     .clickOutsideToClose(true)
        //     .title('Success Save Data')
        //     .textContent('Process Data was Success.')
        //     .ariaLabel('Success Save Data')
        //     .ok('OK')
        //     .targetEvent(ev)
        //     ).then(function(){
        //         closeModal();
        //     });
        // }

        function ChangeDayType() {
            if (vm.Form.objForm.daytype == 'halfday') {
                vm.Form.objForm.end_date = vm.Form.objForm.start_date;
                vm.enddaterequire = false;
                vm.timerequire = true;
                vm.timedisabled = false;
            } else {
                vm.enddaterequire = true;
                vm.timerequire = false;
                vm.timedisabled = true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.replacement-holiday')
        .controller('ReplacementHolidayController', Controller);

    Controller.$inject = [
        '$state',
        '$log',
        '$mdDialog',
        'DataService',
        'AppAPI',
        'Auth',
        '$localStorage'
    ];
    /** @ngInject */
    function Controller(
        $state,
        $log,
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        $localStorage
    ) {
        var vm = this;
        var Replacement = AppAPI.Replacement();
        var Attendancereport = AppAPI.Attendancereport();
        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.listBU = [];
        vm.selected = [];
        vm.items = [];;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.loadBU = loadBU;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;
        vm.company = $localStorage.empsite;
        vm.showFilter = true;
        vm.openUpload = openUpload;
        vm.isChecked = isChecked;;
        vm.checked = checked;;
        vm.toggleCheck = toggleCheck;;
        vm.toggleAll = toggleAll;;
        vm.isIndeterminate = isIndeterminate;;
        vm.deleteData = deleteData;;
        vm.dialogClose = dialogClose;;

        //////////
        activate();

        function activate() {
            loadBU();
            loadDataDivision(vm.company);
            loadSubArea();
            loadData(1);
        }

        function loadData(pageno) {
            var request = vm.DataTable.loadData(Replacement, pageno, {
                action: 'viewData',
                company: vm.company,
                division: vm.divisi,
                department: vm.department,
                sub_area_id: vm.selectedSubarea
            });
            request.then(function (data) {
                vm.items = data.list;
            });
            vm.selected = [];
        }

        function loadBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendancereport.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadSubArea() {
            var response = Replacement.query({
                action: 'getSubAreaByBu',
                company: vm.company
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'ReplacementHolidayUploadController as vm',
                templateUrl:
                    'app/main/cb/replacement-holiday/upload/replacement-holiday-upload.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function isChecked(ls) {
            return vm.selected.indexOf(ls) > -1;
        }

        function checked() {
            return vm.selected.length === vm.items.length;
        }

        function isIndeterminate() {
            return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.selected.indexOf(ls);

            if (idx > -1) {
                vm.selected.splice(idx, 1);
            }
            else {
                vm.selected.push(ls);
            }
        }

        function toggleAll() {
            if (vm.selected.length === vm.items.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.items.slice(0);
            }
        }

        function deleteData(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent('Data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = Replacement.delete({
                            action: 'delete',
                            data: angular.toJson(vm.selected)
                        });
                        response.$promise.then(function (resp) {
                            dialogClose();
                            angular.element.unblockUI();
                            showDialogInfo(ev, resp);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialogInfo(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.pesan)
                        .ariaLabel(data.title)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        vm.newReplacement = newReplacement;

        function newReplacement() {
            $state.go('app.cb_new_replacement_holiday');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.passwordecheckingw')
        .controller('PasswordecheckingwController', PasswordecheckingwController);


    PasswordecheckingwController.$inject=['$state','$localStorage','$http','$scope','$document','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function PasswordecheckingwController($state,$localStorage,$http,$scope,$document,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.editData=editData; 
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listModulSelected=[];   
        var EcheckinPassGw=AppAPI.EcheckinPassGw();  

         vm.uploadEmployee=uploadEmployee;

        vm.Breadhome="app.cb";
        vm.Breadlist=[ 
                    {link:'#',name:'CB / ',active:'0'}
                    ]; 
         


        

        loadData(1);
        ////////// 

        function loadData(pageno){
           vm.DataTable.loadData(EcheckinPassGw,pageno,{action:'viewdata'});
           // console.log('test');
        }

         

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 

        function editData(id){ 
          $state.go('app.cb_passwordecheckingw_edit-password-echeckingw',{id:id});
        }
  
         function uploadEmployee(ev) {
            $mdDialog.show({
                controller         : 'UploadfilegwController as vm',
                templateUrl        : 'app/main/cb/passwordecheckingw/uploadfile/uploadfile.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-shift', [
        ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
      // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-shift');

        // State
        $stateProvider
        .state('app.cb_employe_shift', {
            url    : '/cb/employe-shift',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/cb/employe-shift/employe-shift.html',
                    controller : 'EmployeshiftController as vm'
                }
            }
        });

        
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.employe-shift')
        .controller('UploadOTConfigController', UploadOTConfigController);

    UploadOTConfigController.$inject = ['$mdDialog','$localStorage','FileUploader','config'];

    /* @ngInject */
    function UploadOTConfigController($mdDialog,$localStorage,FileUploader,config) {
        var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;       

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
            url:config.api+'api/overtimeconfiguration/uploadOTConfig', 
            removeAfterUpload:true,
            alias:'fileOTConfig',
            formData:[
                {
                    action:'uploadOTConfig'
                }
            ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
            },
            headers:{
                tokenAuth:$localStorage.tokenAuth
            }    
        }); 
            
        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
            closeModal();
        };

        uploaderPhoto.onErrorItem=function()
        {
            vm.UploadPhotoStateSucces=false;
            vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.overtime-configuration', [])
        .config(config);

      config.$inject=['$stateProvider'];
      /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.cb_overtime_coonfiguration', {
                url    : '/cb/overtime-configuration',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/overtime-configuration/overtime-configuration.html',
                        controller : 'OvertimeConfigurationController as vm'
                    }
                }
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.overtime-configuration')
        .controller('OvertimeConfigurationController', OvertimeConfigurationController);


    OvertimeConfigurationController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService','$localStorage','$document'];
    //AppAPI untuk koneksi ambil data ke api
    //Auth untuk mendapatkan authentikasi mendapatkan token, setiap hubungan ke API wajib token
    //DataService untuk pagination dan datatable
    
    /** @ngInject */
    function OvertimeConfigurationController($state,$log,$mdDialog,AppAPI,Auth,DataService,$localStorage,$document)
    {
        var vm = this; 
        vm.listJum = [2,5,25,50,75,100,200];
        vm.DataTable = new DataService(); //inisialisasi class DataService
        var OTConfig = AppAPI.Overtimeconfiguration();//memanggil api modules dari api
        var Employeshiftt = AppAPI.Overtime();
        vm.uploadOvertimeConfig = uploadOvertimeConfig;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadDataDivision = loadDataDivision;
        vm.company = $localStorage.empsite; 
        vm.closeModal = closeModal;
        vm.loadData = loadData;
        vm.editData = editData;
        vm.toglefilter = false;
        vm.toggle = toggle;
        
        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [
            {link:'#',name:'Overtime Configuration',active:'0'}    
        ];
        vm.edit1 = false;

        loadData(1);
        loadDataBU();
        loadDataDivision(vm.company);

        function loadData(pageno)
        {
           var resp=vm.DataTable.loadData(OTConfig,pageno,{action:'viewData',company:vm.company,divisi:vm.divisi,departement:vm.department});
        }

        function loadDataDepartment(iddivisi)
        {
            var response=Employeshiftt.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }
    
        function fetchDepartment(data) {
        vm.listDepartment=data;
        // loadData(1);
        }
    
        function errorDepartment() {
        vm.listDepartment=[];
        }
    
        function loadDataDivision(idbu) {
            var response=Employeshiftt.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }
    
        function fetchDivisiBU(data) {
            vm.listDivision=data;
            // loadData(1);
        }
    
        function errorDivisiBU() {
            vm.listDivision=[];
        }
    
        function loadDataBU() {
            var response=Employeshiftt.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }
    
        function fetchBU(data) {
            vm.listBU=data;
        }
    
        function errorFetchBU() {
            vm.listBU=[];
        }

        function checkAll()
        {
            vm.listModulSelected=angular.copy(vm.list);
        }

        function unCheckAll()
        {
            vm.listModulSelected=[];
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function toggle() {
            if(vm.toglefilter) {
                vm.toglefilter = false;
            } else {
                vm.toglefilter = true;
            }
        }

        function uploadOvertimeConfig(ev)
        {
            $mdDialog.show({
                controller         : 'UploadOTConfigController as vm',
                templateUrl        : 'app/main/cb/overtime-configuration/upload-overtime-config.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                }
            });
          }

        function editData(ev,data)
        {
            $mdDialog.show({
                controller         : 'UpdateOTController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/overtime-configuration/edit-overtime-config.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  edt:data
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.overtime-configuration')
        .controller('UpdateOTController', UpdateOTController);

    UpdateOTController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','config','edt'];

    /* @ngInject */
    function UpdateOTController($localStorage,$mdDialog,Form,AppAPI,config,edt) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var OTConfig = AppAPI.Overtimeconfiguration();

        // set constructor form
        Form.setObject(OTConfig);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        vm.listType = [
            {id:1, type:'Hanya OT KHL'},
            {id:2, type:'Hanya OT Normal'},
            {id:3, type:'Semua Bisa'},
            {id:4, type:'Tidak Bisa OT'},
        ];
        
        var response=vm.Form.objForm.$get({action:'viewDetail',id:edt.id});
        response.then(setData);
        
        function setData(data)
        {
            vm.Form.objForm.id=edt.id;
            vm.name = edt.empName;
            if(!data.effectivedate) {
                vm.Form.objForm.effectivedate = new Date();
            }
            vm.Form.objForm.ottype = Number(data.ottype);
            vm.Form.objForm.effectivedate = new Date(data.effectivedate);
        }

        function closeModal()
        {
            $mdDialog.hide();
        }
         
        function saveData(ev,formController) {
            var promise= Form.updateData('updateData', formController, OTConfig, edt.id, 'viewDetail');
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog() {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent()
            ).then(function(){
                closeModal();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.overtime', ['app.cb.overtime.input-overtime'
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
           
        // State
        $stateProvider
            .state('app.cb_overtime', {
                url    : '/cb/overtime',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/overtime/overtime.html',
                        controller : 'OvertimeController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.overtime')
        .controller('OvertimeController', OvertimeController);


    OvertimeController.$inject=['$state','$window','$location','$localStorage','$document','$element','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService' ];
    /** @ngInject */
    function OvertimeController($state,$window,$location,$localStorage,$document,$element,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService )
    {

        var vm = this;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.ExportToExcel=ExportToExcel;
        vm.ExportToExcelUnapproved=ExportToExcelUnapproved;
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;
        var Attendance=AppAPI.Attendance();
        var Department=AppAPI.Department();
        var Division=AppAPI.Division();
        var Attendancereport=AppAPI.Attendancereport();
        var BU=AppAPI.BU();
        var Overtime=AppAPI.Overtime();
        var date=new Date();
        vm.tahun=date.getFullYear();
        vm.bulan=date.getMonth()+1;
        vm.getPeriode=getPeriode;
        vm.tgl=date.getDate();
        vm.flag_app='SAP';
        vm.flagApp=['SAP','HRIS'];
        vm.loadSubArea=loadSubArea;

        if(vm.tgl >=25 && vm.tgl <=31)
        {
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }
        vm.company=$localStorage.empsite;
        vm.groupLogin=$localStorage.group;

        vm.typeEmp = [
          {
            "view"  : "Staff",
            "value" : "SAP"
          },
          {
            "view"  : "General Worker",
            "value" : "HRIS"
          }
        ];

        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();

        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
                    {link:'#',name:'C&B / ',active:'0'}
                    ];
        vm.listtahun=[2017,2018,2019,2020,2021];
        vm.listbulan=[{name:'January',value:'01'},
                      {name:'February',value:'02'},
                      {name:'Maret',value:'03'},
                      {name:'April',value:'04'},
                      {name:'Mei',value:'05'},
                      {name:'June',value:'06'},
                      {name:'July',value:'07'},
                      {name:'August',value:'08'},
                      {name:'September',value:'09'},
                      {name:'October',value:'10'},
                      {name:'November',value:'11'},
                      {name:'Desember',value:'12'}];

        vm.simulateQuery = false;
        vm.isDisabled    = false;
        vm.closeModal=closeModal;
        getPeriode();


        //////////

        vm.searchTerm;
        vm.clearSearchTerm = function() {
          vm.searchTerm = '';
        };
        // The md-select directive eats keydown events for some quick select
        // logic. Since we have a search input here, we don't need that logic.
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

         function getPeriode(){
          var res=Overtime.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
          res.$promise.then(fetchPeriode);
          res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data)
        {
          vm.periode=data[0]['periode'];
          // console.log(vm.periode);
          // loadData(1);
        }

        function errorfetchPeriode(data)
        {
          console.log('error');
        }

         function loadDataDepartment(iddivisi) {
             var response=Overtime.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }

          function loadDataDivision(idbu) {
             var response=Overtime.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          }

          function loadDataBU() {
            var response=Overtime.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }



        function loadData(){
           angular.element.blockUI();
           var company=vm.company;
           var divisi=vm.divisi;
           var department=vm.department;
           var tahun=vm.tahun;
           var bulan=vm.bulan;
           var subarea=vm.selectedSubarea;
           var empType=vm.flag_app;
           // console.log(vm.selectedSubarea);
           if(typeof(vm.divisi)==='undefined')
           {
              divisi='all';
           }
           if(typeof(vm.department)==='undefined')
           {
              department='all';
           }

            if (typeof(vm.flag_app) !== "undefined")
           {
             empType = vm.flag_app;
           }

           if(typeof(vm.selectedSubarea)=='undefined')
           {
              subarea='all';
           }

           // console.log(company+' / '+divisi+' / '+department+' / '+tahun+' / '+bulan);
           var response=Overtime.query({action:'viewdata',company:company,divisi:divisi,department:department,tahun:tahun,bulan:bulan,subarea:subarea,empType:empType, search:vm.searchParam});
              response.$promise.then(function(data){
                vm.listData=data;
                // console.log(vm.listData);
                angular.element.unblockUI();
              });
              response.$promise.catch(function(data){
                $log.info(data);
                vm.listData=[];
                angular.element.unblockUI();
              });
        }

        // function loadData(pageno)
        // {
        //   var company=vm.company;
        //   var divisi=vm.divisi;
        //   var department=vm.department;
        //   var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
        //   var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');

        //   var resp=vm.DataTable.loadData(Overtime,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
        //  // console.log(resp);
        //   // angular.element.unblockUI();
        // }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          }




        function closeModal()
        {
            $mdDialog.hide();
        }

        function ExportToExcel()
        {
         var company=vm.company;
         var divisi=vm.divisi;
         var department=vm.department;
         var tahun=vm.tahun;
         var bulan=vm.bulan;
         var subarea=vm.selectedSubarea;
         var search = vm.searchParam;
         var empType=vm.flag_app;
         if(typeof(vm.divisi)==='undefined')
         {
            divisi='all';
         }
         if(typeof(vm.department)==='undefined')
         {
            department='all';
         }
         if (typeof(vm.flag_app) !== "undefined")
         {
           empType = vm.flag_app;
         }

         if (typeof(vm.searchParam) === "undefined")
         {
           search = '';
         }

          var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                    // var host='localhost:3000/';
                    
                    $window.open(protocol+'://'+host+config.api+'api/overtime/exportexcel/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan+'/'+subarea+'/'+empType+'/'+search, '_blank');
            },function(){

                $window.alert('gagal load token');
            });
        }
        
        function ExportToExcelUnapproved()
        {
         var company=vm.company;
         var divisi=vm.divisi;
         var department=vm.department;
         var tahun=vm.tahun;
         var bulan=vm.bulan;
         var subarea=vm.selectedSubarea;
         var search = vm.searchParam;
         var empType=null;
         if(typeof(vm.divisi)==='undefined')
         {
            divisi='all';
         }
         if(typeof(vm.department)==='undefined')
         {
            department='all';
         }
         if (typeof(vm.employeeType) !== "undefined")
         {
           empType = vm.employeeType;
         }

         if (typeof(vm.searchParam) === "undefined")
         {
           search = '';
         }

          var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                    // var host='localhost:3000/';
                    
                    $window.open(protocol+'://'+host+config.api+'api/overtime/exportexcelunapproved/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan+'/'+subarea+'/'+empType+'/'+search, '_blank');
            },function(){

                $window.alert('gagal load token');
            });
        }
        
        function  loadSubArea()
        {
          var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.outlet-team-list', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_outlet-team-list', {
                url    : '/cb/outlet-team-list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/outlet-team-list/outlet-team-list.html',
                        controller : 'outletTeamListController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.outlet-team-list')
        .controller('outletTeamListController', outletTeamListController);

    
    /* @ngInject */
    outletTeamListController.$inject=['$state','$mdDialog','$window','$location','config','$log','AppAPI','Auth','DataService'];
    function outletTeamListController($state,$mdDialog,$window,$location,config,$log,AppAPI,Auth,DataService) {
        var vm = this;

        var OutletTeamList=AppAPI.OutletTeamList();
		
        vm.DataTable= new DataService();
        vm.loadData=loadData;
		vm.listJum=[2,5,25,50,75,100,200];
		vm.listSicSelected = [];
		
		vm.loadSubArea = loadSubArea;
		vm.selectedSubarea = '0';
		
		vm.ExportToExcel = ExportToExcel;
	    vm.getPeriode = getPeriode;
	    var date=new Date();
        vm.tahun=date.getFullYear();
        vm.bulan=date.getMonth()+1;
	    
	    vm.tgl=date.getDate();
        if(vm.tgl >=25 && vm.tgl <=31)
        {
          if(vm.bulan==12){
            vm.bulan='01';
          }
	    else{
            vm.bulan=vm.bulan+1;
          }
        }
        
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }
		  
	    vm.listtahun=[2017,2018,2019,2020,2021];
        vm.listbulan=[{name:'January',value:'01'},
				  {name:'February',value:'02'},
				  {name:'Maret',value:'03'},
				  {name:'April',value:'04'},
				  {name:'Mei',value:'05'},
				  {name:'June',value:'06'},
				  {name:'July',value:'07'},
				  {name:'August',value:'08'},
				  {name:'September',value:'09'},
				  {name:'October',value:'10'},
				  {name:'November',value:'11'},
				  {name:'Desember',value:'12'}];
				  
        loadData(1);
		loadSubArea();
		getPeriode();
        //////////////////

        function loadData(pageno)
        {
            /* menggunakan DataTable */
          vm.DataTable.loadData(OutletTeamList,pageno,{action:'viewData', sub_area:vm.selectedSubarea, bulan:vm.bulan, tahun:vm.tahun});
        }

        function getPeriode(){
			var res=OutletTeamList.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
			res.$promise.then(fetchPeriode);
			res.$promise.catch(errorfetchPeriode);
		}
		
		function fetchPeriode(data)
		{
			vm.periode=data[0]['periode'];
			// console.log(vm.periode);
			// loadData(1);
		}
	
		function errorfetchPeriode(data)
		{
			vm.periode= [];
		}
		
		function ExportToExcel()
        {
          var tahun=vm.tahun;
          var bulan=vm.bulan;
		  
		  var search = vm.DataTable.searchParam;
		  if(!search) 
			  search = 0;
		  
		  var sub_area = vm.selectedSubarea;
		  if(!sub_area) 
        sub_area = 0;
        
          var token=Auth.setTokenPromise();
          token.then(function(data){
          var protocol=$location.protocol();
          var host=$location.host();

          $window.open(protocol+'://'+host+'/'+config.api+'api/outletteamlist/exportexcel/'+ tahun + '/' + bulan + '/' + search + '/' + sub_area, '_blank');
            },function(){
        
                $window.alert('gagal load token');
            });
        }
	  
		function loadSubArea()
        {
          var response=OutletTeamList.query({
			  action: 'viewSubArea'
		  });
		  
          response.$promise.then(fetchArea);
          response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }
	}
})();
(function () {
    'use strict';

    angular
        .module('app.cb.new-replacement-holiday', [])
        .config(config)
        .filter('slice', function () {
            return function (arr, start, end) {
                return arr.slice(start, end);
            };
        });

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.cb_new_replacement_holiday', {
                url: '/cb/new-replacement-holiday',
                views: {
                    'content@app': {
                        templateUrl:
                            'app/main/cb/new-replacement-holiday/new-replacement-holiday.html',
                        controller: 'newReplacementHolidayController as vm'
                    }
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.new-replacement-holiday')
        .controller('newReplacementHolidayController', newReplacementHolidayController);

    newReplacementHolidayController.$inject = [
        '$localStorage',
        '$mdDialog',
        '$log',
        '$window',
        '$location',
        'Form',
        'AppAPI',
        'FileUploader',
        'config',
        'Auth',
        '$http'
    ];
    /* @ngInject */
    function newReplacementHolidayController(
        $localStorage,
        $mdDialog,
        $log,
        $window,
        $location,
        Form,
        AppAPI,
        FileUploader,
        config,
        Auth,
        $http
    ) {
        var vm = this;
        Form.initialForm();
        vm.saveData = saveData;
        var Attendancereport = AppAPI.Attendancereport();
        var SubArea = AppAPI.Locktransaction();
        var Replacement = AppAPI.Replacement();
        Form.setObject(Replacement);
        vm.saveProcess = false;

        vm.Form = Form;
        vm.company = $localStorage.empsite;
        vm.groupLogin = $localStorage.group;
        vm.closeModal = closeModal;
        vm.loadSubArea = loadSubArea;
        vm.reloadToken = reloadToken;

        loadDataBU();
        loadSubArea();

        vm.start_date = new Date();
        vm.end_date = new Date();
        vm.block = [];

        vm.subArea = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.selectedSubarea = [];

        //////////////////////////
        vm.blockJobTitle = [];
        vm.jobTitle = [];
        vm.selectedJobTitle = [];

        vm.blockGrade = [];
        vm.Grade = ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C', '4A', '4B', '4C', '5A', '5B', '5C', '6A', '6B', '6C',];
        vm.selectedGrade = [];


        vm.toggleJobTitle = toggleJobTitle;
        vm.existsJobTitle = existsJobTitle;
        vm.isCheckedJobTitle = isCheckedJobTitle;
        vm.toggleAllJobTitle = toggleAllJobTitle;
        vm.isIndeterminateJobTitle = isIndeterminateJobTitle;

        vm.toggleGrade = toggleGrade;
        vm.existsGrade = existsGrade;
        vm.isCheckedGrade = isCheckedGrade;
        vm.toggleAllGrade = toggleAllGrade;
        vm.isIndeterminateGrade = isIndeterminateGrade;

        function closeModal() {
            $mdDialog.hide();
        }

        function loadDataBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.saveProcess = true;
            vm.Form.objForm.company = vm.company;
            vm.Form.objForm.start_date = vm.start_date;
            vm.Form.objForm.end_date = vm.end_date;
            vm.Form.objForm.subarea = [];
            vm.selectedSubarea.forEach(function (val) {
                vm.Form.objForm.subarea.push(val.id);
            });
            vm.Form.objForm.jobTitle = [];
            vm.selectedJobTitle.forEach(function (val) {
                vm.Form.objForm.jobTitle.push(val.abreviation);
            });
            vm.Form.objForm.grade = [];
            vm.selectedGrade.forEach(function (val) {
                vm.Form.objForm.grade.push(val);
            });
            vm.Form.objForm.listDate = vm.listDate;
            vm.Form.objForm.action = 'getTemplateShiftReplacement';

            $http({
                method: 'POST',
                url: config.api + 'api/replacement',
                data: vm.Form.objForm,
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();
                var filename = name;
                var contentType = headers['content-type'];
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
                    angular.element.unblockUI();
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    angular.element.unblockUI();
                    console.log(ex);
                }
            }).error(function (data) {
                angular.element.unblockUI();
                console.log(data);
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Success Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Success Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    closeModal();
                });
        }

        function ShowFailed(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    closeModal();
                });
        }

        function loadSubArea() {
            var response = Replacement.query({
                action: 'getSubAreaByBu',
                company: vm.company
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.block = [];
            vm.selectedSubarea = [];
            var itemsPerColumn = Math.ceil(data.length / 4);
            for (var i = 0; i < data.length; i += itemsPerColumn) {
                var col = {
                    start: i,
                    end: Math.min(i + itemsPerColumn, data.length)
                };
                vm.block.push(col);
            }
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return (
                vm.selectedSubarea.length !== 0 &&
                vm.selectedSubarea.length !== vm.subArea.length
            );
        }

        function isChecked() {
            return vm.selectedSubarea.length === vm.subArea.length;
        }

        function toggleAll() {
            if (vm.selectedSubarea.length === vm.subArea.length) {
                vm.selectedSubarea = [];
            } else if (
                vm.selectedSubarea.length === 0 ||
                vm.selectedSubarea.length > 0
            ) {
                vm.selectedSubarea = vm.subArea.slice(0);
            }
        }

        function getPeriodeList() {
            var response = SubArea.query({
                action: 'listPeriode'
            });
            response.$promise.then(function (success) {
                vm.listPeriode = success;
            });
            response.$promise.catch(function (success) {
                vm.listPeriode = [];
            });
        }

        function reloadToken() {
            Auth.setToken();
        }


        function toggleJobTitle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function existsJobTitle(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminateJobTitle() {
            return (
                vm.selectedJobTitle.length !== 0 &&
                vm.selectedJobTitle.length !== vm.jobTitle.length
            );
        }

        function isCheckedJobTitle() {
            return vm.selectedJobTitle.length === vm.jobTitle.length;
        }

        function toggleAllJobTitle() {
            if (vm.selectedJobTitle.length === vm.jobTitle.length) {
                vm.selectedJobTitle = [];
            } else if (
                vm.selectedJobTitle.length === 0 ||
                vm.selectedJobTitle.length > 0
            ) {
                vm.selectedJobTitle = vm.jobTitle.slice(0);
            }
        }

        vm.loadJobTitle = loadJobTitle;

        function loadJobTitle() {
            var area = [];

            for (var i = 0; i < vm.selectedSubarea.length; i++) {
                area.push(vm.selectedSubarea[i].id);
            }

            var response = Replacement.query({
                action: 'getJobTitleByAreaEmpActive',
                company: vm.company,
                startDate: '2020-07-19',
                endDate: '2020-08-18',
                area: area.toString()
            });
            response.$promise.then(fetchJobTitle);
            response.$promise.catch(errorfetchJobTitle);
        }

        function fetchJobTitle(data) {
            vm.blockJobTitle = [];
            vm.selectedJobTitle = [];
            var itemsPerColumn = Math.ceil(data.length / 4);
            for (var i = 0; i < data.length; i += itemsPerColumn) {
                var col = {
                    start: i,
                    end: Math.min(i + itemsPerColumn, data.length)
                };
                vm.blockJobTitle.push(col);
            }
            vm.jobTitle = data;
        }

        function errorfetchJobTitle(data) {
            vm.jobTitle = [];
        }

        function toggleGrade(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function existsGrade(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminateGrade() {
            return (
                vm.selectedGrade.length !== 0 &&
                vm.selectedGrade.length !== vm.Grade.length
            );
        }

        function isCheckedGrade() {
            return vm.selectedGrade.length === vm.Grade.length;
        }

        function toggleAllGrade() {
            if (vm.selectedGrade.length === vm.Grade.length) {
                vm.selectedGrade = [];
            } else if (
                vm.selectedGrade.length === 0 ||
                vm.selectedGrade.length > 0
            ) {
                vm.selectedGrade = vm.Grade.slice(0);
            }
        }

        getListGrade();

        function getListGrade() {
            vm.blockGrade = [];
            vm.selectedGrade = [];
            var itemsPerColumn = Math.ceil(vm.Grade.length / 4);
            for (var i = 0; i < vm.Grade.length; i += itemsPerColumn) {
                var col = {
                    start: i,
                    end: Math.min(i + itemsPerColumn, vm.Grade.length)
                };
                vm.blockGrade.push(col);
            }
        }

        vm.listDate = [];
        vm.addDate = addDate;
        vm.deleteListDate = deleteListDate;

        function addDate() {
            vm.listDate.push({
                start_date: null,
                end_date: null,
                start_time: null,
                end_time: null
            })
        }

        function deleteListDate(index) {
            vm.listDate.splice(index, 1);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.nationalholiday', [
           'app.cb.nationalholiday.input-national-holiday'
        ])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.cb_nationalholiday', {
                url: '/cb/nationalholiday',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cb/national-holiday/national-holiday.html',
                        controller: 'NationalHolidayController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.cb.nationalholiday')
    .controller('NationalHolidayController', NationalHolidayController);

  NationalHolidayController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$mdToast',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form'
  ];
  /** @ngInject */
  function NationalHolidayController(
    DataService,
    $state,
    $mdDialog,
    $mdToast,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form
  ) {
    var vm = this;
    var ApiHoliday = AppAPI.NationalHoliday();
    var Attendancereport = AppAPI.Attendancereport();
    vm.Breadhome = 'app.cb';
    vm.Breadlist = [{ link: '#', name: 'C&B', active: '0' }];
    vm.DataTables = new DataService();
    vm.showDialogInput = showDialogInput;
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.years = [];
    vm.showHoliday = showHoliday;
    vm.dialogClose = dialogClose;
    vm.loadData = loadData;
    vm.selectedSubarea = '0';
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.selected = [];
    vm.styleTableTop = {
      'padding-bottom': '0',
      'margin-bottom': '0',
      'margin-top': '0'
    };
    vm.styleNoPaddingLeft = {
      'margin': '0px 5px 10px 0px',
      'padding': '2px'
    };

    vm.Form = Form;
    vm.company = $localStorage.empsite;
    vm.user = $localStorage.user;
    vm.deleteData = deleteData;
    vm.showDialogEdit = showDialogEdit;

    vm.saveUpdate = {};

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(ApiHoliday);
      getYearsHoliday();
      vm.selected = [];
      loadSubArea();
      loadDataBU();
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(ApiHoliday, pageno, {
        action: 'viewDataHoliday',
        company: vm.company,
        year: vm.yearSelected
      });
    }

    function getUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

    function getYearsHoliday() {
      var response = ApiHoliday.query({
        action: 'getYearsHoliday'
      });
      response.$promise.then(fetchDataYears);
    }

    function fetchDataYears(data) {
      vm.years = data;
      vm.yearSelected = vm.years[0];
      loadData(1);
    }

    function showHoliday(years) {
      vm.yearSelected = years;
      loadData(1);
    }
    function reloadToken() {
      Auth.setToken();
    }

    function showDialogInput(ev) {
      $mdDialog.show({
        controller: 'InputNationalHolidayController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/national-holiday/input-national-holiday/input-national-holiday.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          items: vm.items,
          loadData: vm.loadData
        },
        clickOutsideToClose: true,
        fullscreen: true
      });
    }

    function showDialogEdit(ev, item) {
      $mdDialog.show({
        controller: 'EditNationalHolidayController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/national-holiday/edit-national-holiday.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals : {
          items : item
        },
        clickOutsideToClose: true,
        fullscreen: true
      });
    }

    function deleteData(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();
            var response = ApiHoliday.delete({
              action: 'deleteDataHoliday',
              data: angular.toJson(vm.selected)
            });
            response.$promise.then(function (data) {
              dialogClose();
              showDialogInfo(ev, data);
              angular.element.unblockUI();
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
        $mdDialog
          .alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title("test")
          .textContent(data.pesan)
          .ariaLabel(data.title)
          .ok('OK')
          .targetEvent(ev)
        )
        .then(function () {
          loadData(1);
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
      console.log(list);
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
        console.log(vm.selected);
      }
    }

    function loadDataBU() {
      var response = Attendancereport.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    function loadSubArea() {
      var response = ApiHoliday.query({
        action: 'loadDataSubArea',
        idbu: vm.company,
      });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorfetchArea);
    }

    function fetchArea(data) {
      vm.subArea = data;
      vm.items = data;
    }

    function errorfetchArea(data) {
      vm.subArea = [];
      vm.items = [];
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('app.cb.nationalholiday.input-national-holiday')
    .controller('EditNationalHolidayController', EditNationalHolidayController);

  EditNationalHolidayController.$inject = [
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'items'
  ];
  /** @ngInject */
  function EditNationalHolidayController(
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    items
  ) {
    var vm = this;
    var ApiHoliday = AppAPI.NationalHoliday();
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.selected = items;
    vm.dialogClose = dialogClose;
    vm.Form = Form;

    activate();

    function activate() {
      vm.selected = [];
      vm.items = items;
      Form.initialForm();
      Form.setObject(ApiHoliday);
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
      console.log(list);
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
        console.log(vm.selected);
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.mapping-mpp-setting', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {        
        $stateProvider.state('app.cb_mapping_mpp_setting', {
            url : '/cb/mapping-mpp-setting',
            views : {
                'content@app' : {
                    templateUrl: 'app/main/cb/mapping-mpp-setting/mapping-mpp-setting.html',
                    controller : 'MappingMPPSetting as vm',
                    css: ['app/main/cb/mapping-mpp-setting/mapping-mpp-setting.scss']
                }
            }
        });
    }

})();
(function ()
{
  'use strict';

  angular
  .module('app.cb.mapping-mpp-setting')
  .controller('MappingMPPSetting', MappingMPPSetting);

  MappingMPPSetting.$inject = ['$scope', '$timeout', '$mdDialog', '$mdMedia', 'AppAPI'];

  /** @ngInject */
  function MappingMPPSetting($scope, $timeout, $mdDialog, $mdMedia, AppAPI)
  {
    var vm = this;
    
    vm.dynamicHeight = false;
  }

})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.lock-transaction', [])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.cb_lock_transaction', {
                url    : '/cb/lock-transaction',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/lock-transaction/lock-transaction.html',
                        controller : 'lockTransactionController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.lock-transaction')
        .controller('lockTransactionController', lockTransactionController) 


    lockTransactionController.$inject=['DataService','$state','$mdDialog','$mdToast','$localStorage','$window','AppAPI','Auth','Form','$timeout','$stateParams'];
    /** @ngInject */
    function lockTransactionController(DataService,$state,$mdDialog,$mdToast,$localStorage,$window,AppAPI,Auth,Form,$timeout,$stateParams)
    {

        var vm= this;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.inputLockTransaction= inputLockTransaction;
        vm.viewDetail= viewDetail;
        var Locktransaction= AppAPI.Locktransaction();
        
        loadData(1);
        ////////////////

        function viewDetail(id)
        {
            $mdDialog.show({
                controller         : 'lockTransactionDetailController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/lock-transaction/lock-transaction-detail.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  id:id
                }
            }); 
        }
        function loadData(pageno)
        { 
          var resp=vm.DataTable.loadData(Locktransaction,pageno,{action:'viewData'});
         // console.log(resp);
          // angular.element.unblockUI();
        }

        function inputLockTransaction(ev,id)
        {
            $mdDialog.show({
                controller         : 'inputLockTransactionController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/lock-transaction/input-lock-transaction.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  id:id
                }
            }); 

        } 

        // function loadData() {
        //    angular.element.blockUI();
        //    var promises = Locktransaction.query({action:'viewData'});
        //    promises.$promise.then(fetchData);
        //    promises.$promise.catch(errorFetchData); 
        // }

        function fetchData(data) {
            vm.listData=data;
            angular.element.unblockUI();
        }

        function errorFetchData() { 
            vm.listData=[];    
            angular.element.unblockUI();
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.cb.lock-transaction')
        .controller('lockTransactionDetailController', lockTransactionDetailController);

    lockTransactionDetailController.$inject = ['$mdDialog','id','$localStorage','config','AppAPI','DataService','Auth'];

    /* @ngInject */
    function lockTransactionDetailController($mdDialog,id,$localStorage,config,AppAPI,DataService,Auth) {
        var vm = this; 

        var Locktransaction= AppAPI.Locktransaction();
        vm.closeModal=closeModal;

        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.items = [];

        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listSelected=[];
        vm.deleteArea=deleteArea;
        vm.toggleSelectedAll=toggleSelectedAll;

        function isChecked(ls)
        {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if ( idx > -1 )
            {
                vm.listSelected.splice(idx, 1);
            }
            else
            {
                vm.listSelected.push(ls);
            }
        }
        
        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() 
        {
            vm.listSelected=angular.copy(vm.DataTables.list);
        }

        function unCheckAll() 
        {
            vm.listSelected=[];
        }

        loadData(1);

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadData(pageno) {
            var resp = vm.DataTables.loadData(Locktransaction, pageno, {
                action: 'viewDetail',id:id
            });
        
            resp.then(function(data) {
                console.log(data.list);
                vm.selected = [];
                vm.items = data.list;
            });
        }

        function deleteArea(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0)
            {
                var promise=Auth.setToken();
                promise.then(function()
                {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Delete this list?')
                        .textContent('All data your selected will be deleted.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });      

                    $mdDialog.show(confirm).then(function() {
                        angular.element.blockUI();
                        // console.log(vm.listOtselected);
                        var attributes= new Locktransaction();
                        attributes.area=[];
                        attributes.action='deleteArea';
                        attributes.id=id;   
                        for (i=0;i<jum;i++) {
                            attributes.area.push(vm.listSelected[i]);
                        }
                        var idtx=encodeURIComponent(angular.toJson(ids));
                        var response=attributes.$save(); 
                        response.then(function(data){
                            angular.element.unblockUI();
                            successApproved(ev,data);
                        });
                        response.catch(function(data){
                            // console.log(data.data);
                            failedApproved(ev,data.data);
                            angular.element.unblockUI();
                        });
                    }, function() {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            }else{
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            });
            } 
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Delete')
            .textContent(data.pesan)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData(1);
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Delete Data')
            .textContent(data.pesan)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            });
            
        }
    }
})();
(function() {
  'use strict';

  angular
    .module('app.cb.lock-transaction')
    .controller('inputLockTransactionController', inputLockTransactionController);

  inputLockTransactionController.$inject = ['$localStorage','$mdDialog','Form','AppAPI'];

  /* @ngInject */
  function inputLockTransactionController($localStorage,$mdDialog,Form,AppAPI) {
    var vm = this;
        vm.saveData=saveData;
        // initial form
    Form.initialForm();

    var Locktransaction = AppAPI.Locktransaction();
    var Attendancereport = AppAPI.Attendancereport(); 
    var CommitAttendance = AppAPI.CommitAttendance();

    // set constructor form
    Form.setObject(Locktransaction);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal; 
    // vm.LoadLocation=LoadLocation;
    var empID=$localStorage.username;
    vm.searchTerm = '';
    vm.clearSearchTerm = clearSearchTerm;
    vm.flagList = [
      {'id' : 'ALL','name' : 'ALL'},
      {'id' : 'SAP','name' : 'SAP'},
      {'id' : 'HRIS','name' : 'HRIS'}
    ];
     vm.subArea = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.selectedSubarea=[];
    vm.loadSubArea = loadSubArea;
    vm.company     = $localStorage.empsite;
    vm.groupLogin  = $localStorage.group;

    loadDataBU(); 
    // console.log(id); 
    ////////////////

    function clearSearchTerm() {
      vm.searchTerm = '';
    }

    // function LoadLocation() {
    //   var response=Locktransaction.query({action:'viewSubArea'});
    //   response.$promise.then(fetchLocation);
    //   response.$promise.catch(errorFetchLocation);
    // }

    // function fetchLocation(data) {
    //   // vm.listLocation=data;
    //   vm.block = [];
    //   vm.selectedSubarea = [];
    //   var itemsPerColumn = Math.ceil(data.length / 4);
    //   for (var i = 0; i < data.length; i += itemsPerColumn) {
    //       var col = {
    //           start: i,
    //           end: Math.min(i + itemsPerColumn, data.length)
    //       };
    //       vm.block.push(col);
    //   }
    //   vm.subArea = data;
    // }

    // function errorFetchLocation() {
    //   vm.listLocation=[];
    // } 

    function loadSubArea() {
          var response = Locktransaction.query({
              action: 'getLocation',
              company: vm.company
          });
          response.$promise.then(fetchArea);
          response.$promise.catch(errorfetchArea);
      }

      function fetchArea(data) {
          vm.block = [];
          vm.selectedSubarea = [];
          var itemsPerColumn = Math.ceil(data.length / 4);
          for (var i = 0; i < data.length; i += itemsPerColumn) {
              var col = {
                  start: i,
                  end: Math.min(i + itemsPerColumn, data.length)
              };
              vm.block.push(col);
          }
          vm.subArea = data;
      }

      function errorfetchArea(data) {
          vm.subArea = [];
      }

    function closeModal() {
      $mdDialog.hide();
    }

    function clearMeesage() {
      vm.Form.tampilPesan=false;
    }

    function saveData(ev,formController) {
      vm.Form.objForm.location = vm.selectedSubarea; 
      var promise= Form.saveData('save', formController, Locktransaction);
      promise.then(function(){
          showDialog(ev);
      });
      // console.log(vm.selectedSubarea);
      
    }

     function toggle(item, list) {
          var idx = list.indexOf(item);
          if (idx > -1) {
              list.splice(idx, 1);
          } else {
              list.push(item);
          }
      }

      function exists(item, list) {
          return list.indexOf(item) > -1;
      }

    function isIndeterminate() {
        return (
            vm.selectedSubarea.length !== 0 &&
            vm.selectedSubarea.length !== vm.subArea.length
        );
    }

    function isChecked() {
        return vm.selectedSubarea.length === vm.subArea.length;
    }

    function toggleAll() {
        if (vm.selectedSubarea.length === vm.subArea.length) {
            vm.selectedSubarea = [];
        } else if (
            vm.selectedSubarea.length === 0 ||
            vm.selectedSubarea.length > 0
        ) {
            vm.selectedSubarea = vm.subArea.slice(0);
        }
    }

    function showDialog(ev) {
      $mdDialog.show(
      $mdDialog.alert()
      .parent(angular.element(document.querySelector('#contentDialog')))
      .clickOutsideToClose(true)
      .title('Success Save Data')
      .textContent('Process Data was Success.')
      .ariaLabel('Success Save Data')
      .ok('OK')
      .targetEvent(ev)
      ).then(function(){
          closeModal();
      });
    }

     function loadDataBU() {
          var response = Attendancereport.query({ action: 'viewBu' });
          response.$promise.then(fetchBU);
          response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
          vm.listBU = data;
          loadSubArea();
      }

      function errorFetchBU() {
          vm.listBU = [];
      }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-overtime', ['app.cb.employe-overtime.input-employe-ot'])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_employe_overtime', {
                url    : '/cb/employe-overtime',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employe-overtime/employe-overtime.html',
                        controller : 'EmployeotController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-overtime')
        .controller('ListOtController', ListOtController);


    ListOtController.$inject=['$state','$log','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function ListOtController($state,$log,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this; 
      // vm.editData=editData;
      vm.deleteData=deleteData;
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Listovertime=AppAPI.Listovertime(); 
      vm.viewComment=viewComment;
      vm.appstatus=[{name:'Waiting Approval',value:'0'},{name:'Approved',value:'1'},{name:'Rejected',value:'2'}];
      vm.status='0';
         
      
 
        //////////
    loadData(1);
    vm.currentot=0;
    vm.periode="";
    // var res= Listovertime.query({action:'getCurrentOt'});
    //       res.$promise.then(function(data){
    //        vm.currentot=vm.currentot + data[0].overtime;
    //        vm.periode=data[0].periode;
    //       console.log(data);
    //     });

    //     res.$promise.catch(function(data){
    //       $log.info(data);
    //     });
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Listovertime,pageno,{action:'viewdata',status:vm.status,start_date:vm.start_date,end_date:vm.end_date});
    }
     

    // function editData(id) {
    //     $state.go('app.cb_employe_overtime_edit_employe_ot',{id:id});
    // }

    function deleteData(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=BU.delete({action:'delete',data:angular.toJson(vm.listBuSelected)});

       response.$promise.then(viewDataBu);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'ApprovalotViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/approval-ot/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              loadData();
          },
          locals:{
            id:id
          }
      });
    }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.leave-report', [ ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    { 
        // State
        $stateProvider
            .state('app.cb_leave_report', {
                url    : '/cb/leave-report',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/leave-report/leave-report.html',
                        controller : 'LeavereportController as vm'
                    }
                }
            });  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.leave-report')
        .controller('LeavereportController', LeavereportController);


    LeavereportController.$inject=['$state','$window','$location','$localStorage','$document','$element','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService' ];
    /** @ngInject */
    function LeavereportController($state,$window,$location,$localStorage,$document,$element,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService )
    {

        var vm = this;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.ExportToExcel=ExportToExcel;
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;
        var Leavereport=AppAPI.Leavereport();
        var Attendancereport=AppAPI.Attendancereport();
        var date=new Date();
        vm.tahun=date.getFullYear();
        vm.bulan=date.getMonth()+1;
        vm.getPeriode=getPeriode;
        vm.tgl=date.getDate();
        vm.flag_app='SAP';
        vm.flagApp=['SAP','HRIS'];
        vm.loadSubArea=loadSubArea;
        if(vm.tgl >=25 && vm.tgl <=31)
        {
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }
        vm.company=$localStorage.empsite;
        vm.groupLogin=$localStorage.group;
        vm.typeEmp = [
          {
            "view"  : "Staff",
            "value" : "SAP"
          },
          {
            "view"  : "General Worker",
            "value" : "HRIS"
          }
        ];
        // console.log('employesite > '+$localStorage.empsite);

        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();

        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
                    {link:'#',name:'C&B / ',active:'0'}
                    ];
        vm.listtahun=[2017,2018,2019,2020,2021];
        vm.listbulan=[{name:'January',value:'01'},
                      {name:'February',value:'02'},
                      {name:'Maret',value:'03'},
                      {name:'April',value:'04'},
                      {name:'Mei',value:'05'},
                      {name:'June',value:'06'},
                      {name:'July',value:'07'},
                      {name:'August',value:'08'},
                      {name:'September',value:'09'},
                      {name:'October',value:'10'},
                      {name:'November',value:'11'},
                      {name:'Desember',value:'12'}];

        vm.simulateQuery = false;
        vm.isDisabled    = false;
        vm.closeModal=closeModal;
        getPeriode();


        //////////
        vm.searchTerm;
        vm.clearSearchTerm = function() {
          vm.searchTerm = '';
        };
        // The md-select directive eats keydown events for some quick select
        // logic. Since we have a search input here, we don't need that logic.
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function getPeriode(){
          var res=Leavereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
          res.$promise.then(fetchPeriode);
          res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data)
        {
          vm.periode=data[0]['periode'];
          // console.log(vm.periode);
          // loadData(1);
        }

        function errorfetchPeriode(data)
        {
          console.log('error');
        }

         function loadDataDepartment(iddivisi) {
             var response=Leavereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }

          function loadDataDivision(idbu) {
             var response=Leavereport.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          }

          function loadDataBU() {
            var response=Leavereport.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }



        function loadData(){
           angular.element('#attView').block({message:'please wait..'});
           var company=vm.company;
           var divisi=vm.divisi;
           var department=vm.department;
           var tahun=vm.tahun;
           var bulan=vm.bulan;
           var subarea=vm.selectedSubarea;
           var empType=vm.flag_app;
           if(typeof(vm.divisi)==='undefined')
           {
              divisi='all';
           }
           if(typeof(vm.department)==='undefined')
           {
              department='all';
           }
          if (typeof vm.employeeType !== "undefined")
           {
             empType = vm.employeeType;
           }

           // console.log(company+' / '+divisi+' / '+department+' / '+tahun+' / '+bulan);
           var response=Leavereport.query({action:'viewdata',company:company,divisi:divisi,department:department,tahun:tahun,bulan:bulan,subarea:subarea,empType:vm.flag_app});
              response.$promise.then(function(data){
                vm.listData=data;
                // console.log(vm.listData);
                 angular.element('#attView').unblock();
              });
              response.$promise.catch(function(data){
                $log.info(data);
                vm.listData=[];
                 angular.element('#attView').unblock();
              });
        }

        // function loadData(pageno)
        // {
        //   var company=vm.company;
        //   var divisi=vm.divisi;
        //   var department=vm.department;
        //   var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
        //   var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');

        //   var resp=vm.DataTable.loadData(Overtime,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
        //  // console.log(resp);
        //   // angular.element.unblockUI();
        // }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          }




        function closeModal()
        {
            $mdDialog.hide();
        }

        function ExportToExcel()
        {
         var company=vm.company;
         var divisi=vm.divisi;
         var department=vm.department;
         var tahun=vm.tahun;
         var bulan=vm.bulan;
         var subarea=vm.selectedSubarea;
         var empType=vm.flag_app;

         if(typeof(vm.divisi)==='undefined')
         {
            divisi='all';
         }
         if(typeof(vm.department)==='undefined')
         {
            department='all';
         }
         if (typeof vm.flag_app !== "undefined")
         {
           empType = vm.flag_app;
         }

          var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                   $window.open(protocol+'://'+host+config.api+'api/leavereport/exportexcel/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan+'/'+subarea+'/'+empType, '_blank');
            },function(){

                $window.alert('gagal load token');
            });
        }

      function  loadSubArea()
      {
        var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorfetchArea);
      }

      function fetchArea(data)
      {
        vm.subArea=data;
      }

      function errorfetchArea(data)
      {
        vm.subArea=[];
      }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.leavehold', [
            'app.cb.leavehold.input-leave-hold',
            'app.cb.leavehold.detail-leave-hold',
            'app.cb.leavehold.update-leave-hold',
        ]).config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.cb_leavehold', {
                url: '/cb/leavehold',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cb/leave-hold/leave-hold.html',
                        controller: 'LeaveHoldController as vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.cb.leavehold')
        .controller('LeaveHoldController', LeaveHoldController);

    LeaveHoldController.$inject = [
        'DataService',
        '$state',
        '$mdDialog',
        '$mdToast',
        '$localStorage',
        '$window',
        '$timeout',
        'AppAPI',
        'Auth',
        'Form'
    ];
    /** @ngInject */
    function LeaveHoldController(
        DataService,
        $state,
        $mdDialog,
        $mdToast,
        $localStorage,
        $window,
        $timeout,
        AppAPI,
        Auth,
        Form
    ) {
        var vm = this;
        var EMP = AppAPI.Employe();
        var Attendancereport = AppAPI.Attendancereport();
        var LeaveHold = AppAPI.LeaveHold();
        vm.addLeaveHold = addLeaveHold;
        vm.deleteDataGroup = deleteDataGroup;
        vm.editLeaveHold = editLeaveHold;
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.items = [];
        vm.detailLeaveHold = detailLeaveHold;
        vm.divisi = 'all';
        vm.department = 'all';
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;
        vm.company = $localStorage.empsite;
        vm.user = $localStorage.user;
        vm.selected = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.showDialogFailed = showDialogFailed;
        vm.showDialogSuccess = showDialogSuccess;
        vm.convertTime = convertTime;
        vm.currentDate = new Date();
        // vm.toggleAll = toggleAll;

        activate();

        function activate() {
            loadDataBU();
            loadDataDivision(vm.company);
            loadSubArea();
            minDate();
            loadData(1);
        }

        function addLeaveHold(ev) {
            $mdDialog.show({
                controller: 'InputLeaveHoldController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/leave-hold/input-leave-hold/input-leave-hold.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals : {
                    loadData: vm.loadData
                },
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function editLeaveHold(ev, data) {
            $mdDialog.show({
                controller: 'UpdateLeaveHoldController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/leave-hold/update-leave-hold/update-leave-hold.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals : {
                    dataUpdate: data,
                },
                clickOutsideToClose: true,
                fullscreen: true
            });
        }

        function detailLeaveHold(ev, data) {
            $mdDialog.show({
                controller: 'DetailLeaveHoldController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/leave-hold/detail-leave-hold/detail-leave-hold.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals : {
                    groupInfo: data,
                    dialogSuccess: vm.showDialogSuccess,
                    dialogFailed: vm.showDialogFailed,
                    toogle: vm.toggle,
                    exists: vm.exists,
                    isIndeterminate: vm.isIndeterminate,
                    iChecked: vm.isChecked
                },
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function loadData(pageno) {
            var resp = vm.DataTables.loadData(LeaveHold, pageno, {
                action: 'viewDataGroupLeaveHold',
                company: vm.company,
                department: vm.department,
                divisi: vm.divisi
            });

            resp.then(function(data) {
                vm.items = data.list;
                vm.selected = [];
            });
        }

        function reloadToken() {
            Auth.setToken();
        }

        function showDialogSuccess(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Success Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Success Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function(ev) {
                    vm.loadData(1);
                });
        }

        function deleteDataGroup(ev) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent('Data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function() {
                        var data = [];
                        for (var index = 0; index < vm.selected.length; index++) {
                            data.push(vm.selected[index].id);
                        }
                        angular.element.blockUI();
                        var response = LeaveHold.delete({
                            action: 'deleteDataGroup',
                            data: angular.toJson(data)
                        });
                        response.$promise.then(loadData());
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialogFailed(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Failed Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function minDate() {
            var response = LeaveHold.query({
                action: 'viewTimeServer'
            });
            response.$promise.then(fetchDataMinDate);
        }

        function fetchDataMinDate(data) {
            var time = new Date(data[0].date);
            vm.HoldMinDate = time;
        }

        function convertTime(time) {
            return new Date(time);
        }

        function fetcDataNikEmployee(data) {
            vm.empSubareaList = data;
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = Attendancereport.query({ action: 'viewSubArea' });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        // Toggle checkbox
        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
        }

        function isChecked() {
            return vm.selected.length === vm.items.length;
        }

        // function toggleAll() {
        //     if (vm.selected.length === vm.items.length) {
        //         vm.selected = [];
        //     } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        //         vm.selected = vm.items.slice(0);
        //         console.log(vm.selected);
        //     }
        // }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.leave-balance', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_leave_balance', {
                url    : '/cb/leave-balance',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/leave-balance/leave-balance.html',
                        controller : 'LeaveBalanceController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.leave-balance')
        .controller('viewSubsLeaveLogController', viewSubsLeaveLogController);

    viewSubsLeaveLogController.$inject = ['$mdDialog','id','$localStorage','FileUploader','config','AppAPI'];

    /* @ngInject */
    function viewSubsLeaveLogController($mdDialog,id,$localStorage,FileUploader,config,AppAPI) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto; 
      vm.closeModal=closeModal;
      vm.listData=id.logSubtitutionLeave;
        // console.log(id);
        //////////////// 
        
         
        function closeModal()
        {
            $mdDialog.hide();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.leave-balance')
        .controller('viewHoldLeaveLogController', viewHoldLeaveLogController);

    viewHoldLeaveLogController.$inject = ['$mdDialog','id','$localStorage','FileUploader','config','AppAPI'];

    /* @ngInject */
    function viewHoldLeaveLogController($mdDialog,id,$localStorage,FileUploader,config,AppAPI) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto; 
      vm.closeModal=closeModal;
      vm.listData=id.logHoldLeave;
        // console.log(id);
        ////////////////  
        function closeModal()
        {
            $mdDialog.hide();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.leave-balance')
        .controller('viewAnnualLeaveLogController', viewAnnualLeaveLogController);

    viewAnnualLeaveLogController.$inject = ['$mdDialog','id','$localStorage','FileUploader','config','AppAPI'];

    /* @ngInject */
    function viewAnnualLeaveLogController($mdDialog,id,$localStorage,FileUploader,config,AppAPI) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto; 
      vm.closeModal=closeModal;
      vm.listData=id.logAnnualLeave;
        // console.log(id);
        //////////////// 
        
         
        function closeModal()
        {
            $mdDialog.hide();
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.leave-balance')
    .controller('newLeaveRequestController', newLeaveRequestController);

  newLeaveRequestController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'Form', 'config', 'AppAPI', '$filter'];

  /* @ngInject */
  function newLeaveRequestController($mdDialog, $localStorage, FileUploader, Form, config, AppAPI, $filter) {
    var vm = this;

    var translate = $filter('translate');
    Form.initialForm();
    vm.closeModal = closeModal;
    vm.saveData = saveData;
    var Leavebalance = AppAPI.Leavebalance();
    var Employeabsence = AppAPI.Employeabsence();


    Form.setObject(Leavebalance);
    vm.Form = Form;
    // console.log(id);

    //////////////// 

    function saveData(ev, formController) {
      angular.element.blockUI();
      var check = Employeabsence.query({
        action: 'checkFinger',
        startDate: vm.Form.objForm.start_date,
        endDate: vm.Form.objForm.end_date
      });
      check.$promise.then(function (response) {
        angular.element.unblockUI();
        if (response[0].is_working == 1) {
          var note = translate('PAYROLL.MESSAGE.CHECKFINGER');
          var yes = translate('PAYROLL.MESSAGE.YES');
          var no = translate('PAYROLL.MESSAGE.NO');

          angular.element.unblockUI();
          var confirm = $mdDialog
            .confirm()
            .title('Attention !')
            .textContent(note)
            .ariaLabel('dialog')
            .ok(yes)
            .cancel(no);

          $mdDialog.show(confirm).then(
            function () {
              vm.Form.objForm.abs_code = 'Z101';
              vm.Form.objForm.start_time = '00:00:00';
              vm.Form.objForm.end_time = '00:00:00';
              vm.Form.objForm.start_date = new Date(formController.start_date.$viewValue);
              vm.Form.objForm.end_date = new Date(formController.end_date.$viewValue);

              angular.element.blockUI();
              var promise = Form.saveData('saveabsence', formController, Leavebalance);
              promise.then(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data);
              });
              promise.catch(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data)
              });
            },
            function () {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        } else {
          vm.Form.objForm.abs_code = 'Z101';
          vm.Form.objForm.start_time = '00:00:00';
          vm.Form.objForm.end_time = '00:00:00';
          vm.Form.objForm.start_date = new Date(formController.start_date.$viewValue);
          vm.Form.objForm.end_date = new Date(formController.end_date.$viewValue);

          angular.element.blockUI();
          var promise = Form.saveData('saveabsence', formController, Leavebalance);
          promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
          promise.catch(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data)
          });
        }
      });
      check.$promise.catch(function () {
        angular.element.unblockUI();
      });
    }
    function closeModal() {
      $mdDialog.hide();
    }

    function showDialog(ev, data) {
      // console.log(data);
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Save Data')
          // .textContent('Process Data was Success.')
          .textContent(data.pesan)
          .ariaLabel('Success Save Data')
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    function ShowFailed(ev, data) {
      // console.log(data.data);
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Save Data')
          .textContent(data.data.pesan)
          .ariaLabel('Failed Save Data')
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
      // console.log(data.data.pesan);
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var message = translate(data.pesan);
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.leave-balance')
        .controller('LeaveBalanceController', LeaveBalanceController);


    LeaveBalanceController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function LeaveBalanceController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService(); 
      vm.loadData=loadData; 
      var Leavebalance=AppAPI.Leavebalance(); 
      vm.SubtitutionRequest=SubtitutionRequest;
      vm.viewAnnuaLeaveLog=viewAnnuaLeaveLog;
      vm.viewSubsLeaveLog=viewSubsLeaveLog;
      vm.NewLeaveRequest=NewLeaveRequest;
      vm.viewHoldLeaveLog=viewHoldLeaveLog;
      vm.appstatus=[{name:'Waiting Approval',value:'0'},{name:'Approved',value:'1'},{name:'Rejected',value:'2'}];
      vm.status='';
      loadData();
      
 
        ////////// 

      function loadData() {
        angular.element.blockUI();
        var response=Leavebalance.query({action:'viewdata'});
        response.$promise.then(fetchDataLeave);
        response.$promise.catch(errorDataLeave);
      }

      function fetchDataLeave(data) {
        vm.listDataLeave=data;
        angular.element.unblockUI();
        // loadData(1);
      }

      function errorDataLeave() {
        vm.listDataLeave=[];
        angular.element.unblockUI();
      }

     // function loadData(pageno) {
     //    var resp=vm.DataTable.loadData(Leavebalance,pageno,{action:'viewdata',status:vm.status,start_date:vm.start_date,end_date:vm.end_date});
     //  }

      function fetchDepartment(data) {
        vm.listData=data;
        angular.element('#attView').unblock();
      }

      function errorDepartment(data)
      {
        console.log('error')
        angular.element('#attView').unblock();
      }

      function SubtitutionRequest(ev,id)
        {
            $mdDialog.show({
                controller         : 'ApplysubtitutionController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/saldo-ghk/apply-subtitution.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  id:id
                }
            }); 

        } 
      function viewAnnuaLeaveLog(ls,ev)
      {
        $mdDialog.show({
                controller         : 'viewAnnualLeaveLogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/leave-balance/view-annualleave-log.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:ls
                }
            }); 
      }

      function viewSubsLeaveLog(ls,ev)
      {
        $mdDialog.show({
            controller         : 'viewSubsLeaveLogController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/leave-balance/view-subsleave-log.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData();
            },
            locals:{
              id:ls
            }
        });
      }

      function NewLeaveRequest(ev)
      {
        $mdDialog.show({
          controller         : 'newLeaveRequestController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/leave-balance/new-leave-request.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData();
          }
        }); 
      }

      function viewHoldLeaveLog(ls,ev)
      {
        $mdDialog.show({
            controller         : 'viewHoldLeaveLogController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/leave-balance/view-holdleave-log.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData();
            },
            locals:{
              id:ls
            }
        });
      }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.joinholiday', [
            'app.cb.joinholiday.input-join-holiday'
        ]).config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.cb_joinholiday', {
                url: '/cb/joinholiday',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cb/join-holiday/join-holiday.html',
                        controller: 'JoinHolidayController as vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.cb.joinholiday')
        .controller('JoinHolidayController', JoinHolidayController);

    JoinHolidayController.$inject = [
        'DataService',
        '$state',
        '$mdDialog',
        '$mdToast',
        '$localStorage',
        '$window',
        '$timeout',
        'AppAPI',
        'Auth',
        'Form'
    ];
    /** @ngInject */
    function JoinHolidayController(
        DataService,
        $state,
        $mdDialog,
        $mdToast,
        $localStorage,
        $window,
        $timeout,
        AppAPI,
        Auth,
        Form
    ) {
        var vm = this;
        var EMP = AppAPI.Employe();
        var Attendancereport = AppAPI.Attendancereport();
        var LeaveHold = AppAPI.LeaveHold();
        var JoinHoliday = AppAPI.JoinHoliday();

        vm.divisi = 'all';
        vm.department = 'all';
        vm.selectedSubarea = 'all';
        vm.addJoinHoliday = addJoinHoliday;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;
        vm.deleteData = deleteData;
        vm.company = $localStorage.empsite;
        vm.user = $localStorage.user;
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;

        activate();

        function activate(){
            loadDataBU();
            loadData(1);
            loadDataDivision(vm.company);
            loadSubArea();
        }

        function addJoinHoliday(ev) {
            $mdDialog.show({
                controller: 'InputJoinHolidayController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/join-holiday/input-join-holiday/input-join-holiday.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals : {
                    loadData: vm.loadData
                },
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function reloadToken() {
            Auth.setToken();
        }

        function loadData(pageno) {
            var department = 'all';
            if(vm.department != ''){
                department = vm.department;
            }
            var resp = vm.DataTables.loadData(JoinHoliday, pageno, {
                action: 'viewDataJoinHoliday',
                company: vm.company,
                department: department,
                divisi: vm.divisi,
                subarea: vm.selectedSubarea
            });

            resp.then(function(data) {
                vm.items = data.list;
                vm.selected = [];
            });
        }

        function deleteData(ev) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent('Data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function() {
                        var data = [];
                        for (var index = 0; index < vm.selected.length; index++) {
                            data.push(vm.selected[index].id);
                        }
                        angular.element.blockUI();
                        var response = JoinHoliday.delete({
                            action: 'deleteDataJoinHoliday',
                            data: angular.toJson(data)
                        });
                        response.$promise.then(loadData());
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }


        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function minDate() {
            var response = LeaveHold.query({
                action: 'viewTimeServer'
            });
            response.$promise.then(fetchDataMinDate);
        }

        function fetchDataMinDate(data) {
            var time = new Date(data[0].date);
            vm.HoldMinDate = time;
        }

        function convertTime(time) {
            return new Date(time);
        }

        function fetcDataNikEmployee(data) {
            vm.empSubareaList = data;
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = Attendancereport.query({ action: 'viewSubArea' });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        // Toggle checkbox
        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
        }

        function isChecked() {
            return vm.selected.length === vm.items.length;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.itinerary', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.cb_itinerary', {
                url    : '/cd/itinerary',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/itinerary/itinerary.html',
                        controller : 'ItineraryController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.itinerary')
        .controller('ItineraryController', ItineraryController);

    ItineraryController.$inject = ['$localStorage','FileUploader','config','Auth'];

    /* @ngInject */
  function ItineraryController($localStorage,FileUploader,config,Auth) {
      var vm = this;
      vm.UploadIteneraryStateSucces=false;
      vm.UploadIteneraryStateError=false;

      var uploaderPeople= vm.FileuploaderItenerary= new FileUploader({
        url:config.api+'api/attendanceemploye/uploaditenerary',
        removeAfterUpload:true,
        alias:'itenerary',
        formData:[
           {
            action:'uploadDataItenerary'
           }
        ],
        onAfterAddingAll:function(){
            vm.UploadIteneraryStateSucces=false;
            vm.UploadIteneraryStateError=false;
         },
         headers:{
            tokenAuth:$localStorage.tokenAuth
          }
    });
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.update-finger-approval')
        .controller('UpfingerViewRejectCommentController', UpfingerViewRejectCommentController);

    UpfingerViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function UpfingerViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.update-finger-approval')
        .controller('UpFingerRejectCommentController', UpFingerRejectCommentController);

    UpFingerRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function UpFingerRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        // initial form
        Form.initialForm();

        var Approvalfinger = AppAPI.Approvalfinger();

        // set constructor form
        Form.setObject(Approvalfinger);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {

            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");
            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function saveData(ev, formController) {

            var promise = Form.saveData('reject', formController, Approvalfinger);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.hr-update-finger-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_hr_update_finger_approval', {
                url    : '/cb/hr-update-finger-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/hr-update-finger-approval/hr-update-finger-approval.html',
                        controller : 'HRUpdateFingerAppController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.hr-update-finger-approval')
        .controller('HRUpdateFingerAppController', HRUpdateFingerAppController);

    HRUpdateFingerAppController.$inject = [
        '$state',
        '$mdDialog',
        'DataService',
        'AppAPI',
        'Auth',
        'GeneralService',
        '$localStorage'
    ];
    /** @ngInject */
    function HRUpdateFingerAppController(
        $state,
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        GeneralService,
        $localStorage
    ) {
        var vm = this;
        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Approvalfinger = AppAPI.Approvalfinger();
        var Approvalabsence = AppAPI.Approvalabsence();
        var Attendanceemploye = AppAPI.Attendanceemploye();
        var Employeshiftt = AppAPI.Overtime();
        var nik = $localStorage.user;
        vm.company = $localStorage.empsite;
        vm.approveData = approveData;
        vm.Reject = Reject;
        vm.UnApproved = UnApproved;
        vm.UnReject = UnReject;
        vm.viewComment = viewComment;
        vm.type = 'waiting approval';
        vm.listType = ['waiting approval', 'approved', 'rejected'];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.flag_app = 'SAP';
        vm.flagApp = ['SAP', 'HRIS'];
        vm.group = $localStorage.group;
        vm.flagAppDisabled = false;
        vm.budisabled = true;

        vm.exists = exists
        vm.items = [];
        vm.isIndeterminate = isIndeterminate
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected = [];

        function isIndeterminate() {
            return vm.listOtselected.length !== 0 && vm.listOtselected.length !== vm.items.length;
        }

        if (vm.group == 145) {
            vm.flag_app = 'HRIS';
            vm.flagAppDisabled = true;
        }

        if (vm.group == '1' || vm.group == '128') {
            vm.budisabled = false;
        }

        // var date = new Date();
        // vm.tahun = date.getFullYear();
        // vm.bulan = date.getMonth() + 1;
        // vm.getPeriode = getPeriode;
        // vm.tgl = date.getDate();
        // if (vm.tgl >= 25 && vm.tgl <= 31) {
        //     if (vm.bulan == 12) {
        //         vm.bulan = '01';
        //     } else {
        //         vm.bulan = vm.bulan + 1;
        //     }
        // }
        // if (vm.bulan < 10) {
        //     vm.bulan = '0' + vm.bulan;
        // }

        // vm.listtahun = [2014, 2015, 2016, 2017, 2018, 2019];
        // vm.listbulan = [
        //     { name: 'January', value: '01' },
        //     { name: 'February', value: '02' },
        //     { name: 'Maret', value: '03' },
        //     { name: 'April', value: '04' },
        //     { name: 'Mei', value: '05' },
        //     { name: 'June', value: '06' },
        //     { name: 'July', value: '07' },
        //     { name: 'August', value: '08' },
        //     { name: 'September', value: '09' },
        //     { name: 'October', value: '10' },
        //     { name: 'November', value: '11' },
        //     { name: 'Desember', value: '12' }
        // ];
        vm.gedung = 'all';

        // getPeriode();
        loadDataBU();
        loadDataDivision(vm.company);
        getListGedung(); 

        //////////

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(Approvalfinger, pageno, {
                action: 'viewdata',
                tglmulai: vm.tglmulai,
                tglakhir: vm.tglakhir,
                type: vm.type,
                flag_app: vm.flag_app,
                company: vm.company,
                gedung: vm.gedung
            });
            resp.then(function(data) {
                vm.listOtselected = [];
                vm.items = data.list;
            });
        }

        // function loadData() {
        //     angular.element.blockUI();
        //      var response=Approvalfinger.query({action:'viewdata'});
        //     response.$promise.then(fetchDepartment);
        //     response.$promise.catch(errorDepartment);
        //   }

        //   function fetchDepartment(data) {
        //     vm.listApp=data;
        //     // loadData(1);
        //     // console.log(vm.listApp);
        //     angular.element.unblockUI();
        //   }

        //   function errorDepartment() {
        //     vm.listApp=[];
        //     angular.element.unblockUI();
        //   }

        function getPeriode() {
            var res = Attendanceemploye.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan,
                flag_app: vm.flag_app
            });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            vm.periode = data[0]['periode'];
            // console.log(vm.periode);
            // loadData(1);
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }

        function isChecked(ls)
        {
            return vm.listOtselected.length === vm.items.length && (vm.items.length > 0 || vm.listOtselected.length > 0);
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if (idx > -1) {
                vm.listOtselected.splice(idx, 1);
            } else {
                vm.listOtselected.push(ls);
            }
        }

        function toggleSelectedAll(state) {
            if (vm.listOtselected.length === vm.items.length) {
                vm.listOtselected = [];
            } else if (vm.listOtselected.length === 0 || vm.listOtselected.length > 0) {
                vm.listOtselected = vm.items.slice(0);
            } 
        }

        function checkAll() {
            vm.listOtselected = angular.copy(vm.DataTable.list);
            // console.log(vm.listOtselected);
        }

        function unCheckAll() {
            vm.listOtselected = [];
        }

        function approveData(ev) {
            // console.log(vm.listOtselected);
            var jum = vm.listOtselected.length,i,ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function() {
                    var confirm = $mdDialog
                        .confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(
                        function() {
                            angular.element.blockUI();
                            // console.log(vm.listOtselected);
                            var ot = new Approvalfinger();
                            ot.data = [];
                            ot.action = 'approve';
                            ot.nik = nik;
                            for (i = 0; i < jum; i++) {
                                ot.data.push({ id: vm.listOtselected[i].id });
                            }
                            var idtx = encodeURIComponent(angular.toJson(ids));
                            var response = ot.$save();
                            //var response=tm.$delete({action:'approve'});
                            // response.then(loadData);
                            response.then(function(data) {
                                angular.element.unblockUI();
                                succesApproved(ev, data);
                                vm.listOtselected = [];
                                loadData();
                            });

                            response.catch(function() {
                                angular.element.unblockUI();
                                failedApproved(ev, data);
                                vm.listOtselected = [];
                                loadData();
                            });
                        },
                        function() {
                            // $scope.status = 'You decided to keep your debt.';
                        }
                    );
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector('#contentDialog')
                                )
                            )
                            .clickOutsideToClose(true)
                            .title('Attention!')
                            .textContent('No data selected')
                            .ariaLabel('Attention')
                            .ok('close')
                            .targetEvent(ev)
                    )
                    .then(function() {
                        loadData();
                    });
            }
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'UpfingerViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/update-finger-approval/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    vm.listOtselected = [];
                },
                locals: {
                    id: id
                }
            });
        }

        function Reject(ev) {
            var jum = vm.listOtselected.length,
                i,
                ids = [];
            if (jum > 0) {
                // var promise=Auth.setToken();
                //  promise.then(function(){
                //       var confirm = $mdDialog.confirm()
                //       .title('Would you like to Reject this list?')
                //       .textContent('All data your selected will be Reject.')
                //       .ariaLabel('delete dialog')
                //       .targetEvent(ev)
                //       .ok('YES')
                //       .cancel('no');
                //   $mdDialog.show({
                //         multiple: true
                //    });
                //   $mdDialog.show(confirm).then(function() {
                //         angular.element.blockUI();
                //         // console.log(vm.listOtselected);
                //         var ot= new Approvalfinger();
                //         ot.data=[];
                //         ot.action='reject';
                //         ot.nik=nik;
                //         ot.approval_type='n1';
                //         var jum=vm.listOtselected.length,i,ids=[];
                //         for (i=0;i<jum;i++) {
                //           ot.data.push({id:vm.listOtselected[i].id});
                //         }
                //         var idtx=encodeURIComponent(angular.toJson(ids));
                //         var response=ot.$save();
                //         //var response=tm.$delete({action:'approve'});
                //         response.then(loadData);
                //     }, function() {
                //    // $scope.status = 'You decided to keep your debt.';
                //   });
                // });
                $mdDialog.show({
                    controller: 'UpFingerRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl:
                        'app/main/cb/update-finger-approval/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function(element, removePromise) {
                        vm.listOtselected = [];
                        loadData();
                    },
                    locals: {
                        id: vm.listOtselected
                    }
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector('#contentDialog')
                                )
                            )
                            .clickOutsideToClose(true)
                            .title('Attention!')
                            .textContent('No data selected')
                            .ariaLabel('Attention')
                            .ok('close')
                            .targetEvent(ev)
                    )
                    .then(function() {
                        loadData();
                    });
            }
        }

        function UnApproved(ev, id) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to unapprove this list?')
                    .textContent('All data you selected will be set to unapproved.')
                    .ariaLabel('unapprove dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        var response = Approvalfinger.delete({
                            action: 'unapproved',
                            data: angular.toJson(id)
                        });
                        response.$promise.then(function(data) {
                            succesUnapproved(ev, data);
                            vm.listOtselected = [];
                        });
                        response.$promise.catch(function(data) {
                            failedUnapproved(ev, data);
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function UnReject(ev, id) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to unreject this list?')
                    .textContent('All data you selected will be set to unreject.')
                    .ariaLabel('unreject dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        var response = Approvalfinger.delete({
                            action: 'unreject',
                            data: angular.toJson(id)
                        });
                        response.$promise.then(function(data) {
                            succesUnreject(ev, data);
                            vm.listOtselected = [];
                        });
                        response.$promise.catch(function() {
                            angular.element.unblockUI();
                            failedUnapproved(ev, data);
                            vm.listOtselected = [];
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function succesUnapproved(ev, data) {
            if (data.hasil == 'expired') {
                showFailedUnapproved();
            } else {
                showDialog();
            }
            loadData();
        }

        function succesUnreject(ev, data) {
            if (data.hasil == 'expired') {
                showFailedUnreject();
            } else {
                showDialogUnreject();
            }
            loadData();
        }

        function failedUnapproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Approval')
                        .textContent(data.data)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                )
                .then(function() {
                    loadData();
                });
        }

        function showFailedUnapproved() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Unapproved Data')
                        .textContent('Transaction Locked By System.')
                        .ariaLabel('Transaction Locked By System')
                        .ok('OK')
                )
                .then(function() {
                    $mdDialog.hide();
                    angular.element.unblockUI();
                });
        }

        function showFailedUnreject() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Unreject Data')
                        .textContent('Transaction Locked By System.')
                        .ariaLabel('Transaction Locked By System')
                        .ok('OK')
                )
                .then(function() {
                    $mdDialog.hide();
                    angular.element.unblockUI();
                });
        }

        function showDialog() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Thanks for Approval')
                        .textContent('Process Data was Success.')
                        .ariaLabel('Attention')
                        .ok('close')
                )
                .then(function() {
                    $mdDialog.hide();
                    angular.element.unblockUI();
                });
        }

        function showDialogUnreject() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Success Process Data')
                        .textContent('Process Data was Success.')
                        .ariaLabel('Attention')
                        .ok('close')
                )
                .then(function() {
                    $mdDialog.hide();
                });
        }

        function loadDataDepartment(iddivisi) {
            var response = Employeshiftt.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Employeshiftt.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            // loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Employeshiftt.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function succesApproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Success Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Success Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    closeModal();
                });
        }

        function failedApproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    closeModal();
                });
        }

        function getListGedung() {
            angular.element.blockUI();
            var resp = Approvalabsence.query({ action: 'getListGedung' });
            resp.$promise.then(function(data) {
                vm.listGedung = data;
                angular.element.unblockUI();
            });
            resp.$promise.catch(function(data) {
                vm.listGedung = [];
                angular.element.unblockUI();
            });
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
          }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.hr-team-assignment-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_hr_team_assignment_approval', {
                url    : '/cb/hr-team-assignment-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/hr-team-assignment-approval/hr-team-assignment-approval.html',
                        controller : 'HRTeamAssignmentAppController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.hr-team-assignment-approval')
        .controller('HRTeamAssignmentAppController', HRTeamAssignmentAppController);

    HRTeamAssignmentAppController.$inject = [
        '$state',
        '$mdDialog',
        'DataService',
        'AppAPI',
        'Auth',
        'GeneralService',
        '$filter',
        '$localStorage'
    ];
    /** @ngInject */
    function HRTeamAssignmentAppController(
        $state,
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        GeneralService,
        $filter,
        $localStorage
    ) {
        var vm = this;

        var translate = $filter('translate');

        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Approvalassignment = AppAPI.Approvalassignment();
        var Attendanceemploye = AppAPI.Attendanceemploye();
        var nik = $localStorage.user;
        vm.isChecked = isChecked;
        vm.isCheckedAll = isCheckedAll;
        vm.toggleCheck = toggleCheck;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.isIndeterminate = isIndeterminate;
        vm.listOtselected = [];
        vm.approveData = approveData;
        vm.Reject = Reject;
        vm.UnApproved = UnApproved;
        vm.UnReject = UnReject;
        vm.viewComment = viewComment;
        vm.type = 'all';
        vm.listType = ['all', 'waiting approval', 'approved', 'rejected'];
        vm.viewDetail = viewDetail;
        vm.printLetter = printLetter;
        vm.selectAll = false;
        vm.resolveDate = resolveDate;

        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.getPeriode = getPeriode;
        vm.tgl = date.getDate();
        if (vm.tgl >= 25 && vm.tgl <= 31) {
            if (vm.bulan == 12) {
                vm.bulan = '01';
            } else {
                vm.bulan = vm.bulan + 1;
            }
        }
        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }

        vm.listtahun = [2017, 2018, 2019, 2020, 2021];
        vm.listbulan = [
            { name: 'January', value: '01' },
            { name: 'February', value: '02' },
            { name: 'Maret', value: '03' },
            { name: 'April', value: '04' },
            { name: 'Mei', value: '05' },
            { name: 'June', value: '06' },
            { name: 'July', value: '07' },
            { name: 'August', value: '08' },
            { name: 'September', value: '09' },
            { name: 'October', value: '10' },
            { name: 'November', value: '11' },
            { name: 'Desember', value: '12' }
        ];

        getPeriode();
        loadData(1);

        //////////

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(Approvalassignment, pageno, {
                action: 'viewdata',
                tglmulai: vm.tglmulai,
                tglakhir: vm.tglakhir,
                type: vm.type,
                is_admin: 1
            });
            vm.listOtselected = [];
        }

        function viewDetail(ev, data, detail) {
            $mdDialog.show({
                controller: 'AmdetailTeamAssignmentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/am-team-assignment/am-detail-team-assignment.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    data: data,
                    detail: detail
                }
            });
        }

        function getPeriode() {
            var res = Attendanceemploye.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan
            });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            vm.periode = data[0]['periode'];
            // console.log(vm.periode);
            // loadData(1);
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }

        function isChecked(ls) {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function isCheckedAll() {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    if (vm.DataTable.list[i].approval == 0) {
                        countCheckAvail++;
                    }
                }

                return vm.listOtselected.length === countCheckAvail && vm.listOtselected.length > 0;
            } else {
                return false;
            }
        }

        function isIndeterminate() {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    if (vm.DataTable.list[i].approval == 0) {
                        countCheckAvail++;
                    }
                }
                return (
                    vm.listOtselected.length > 0 &&
                    vm.listOtselected.length !== countCheckAvail
                );
            } else {
                return false;
            }
        }


        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if (idx > -1) {
                vm.listOtselected.splice(idx, 1);
            } else {
                vm.listOtselected.push(ls);
            }
        }

        function toggleSelectedAll() {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    if (vm.DataTable.list[i].approval == 0) {
                        countCheckAvail++;
                    }
                }
                if (vm.listOtselected.length === countCheckAvail) {
                    unCheckAll();
                } else if (
                    vm.listOtselected.length === 0 ||
                    vm.listOtselected.length > 0
                ) {
                    checkAll();
                }
            } else {
                return false;
            }
        }

        function checkAll() {
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].approval == 0) {
                    if (vm.listOtselected.indexOf(vm.DataTable.list[i]) < 0) {
                        vm.listOtselected.push(vm.DataTable.list[i]);
                    }
                }
            }
        }

        function unCheckAll() {
            vm.listOtselected = [];
        }

        function approveData(ev) {
            var nodataselected = translate('KPI.LABEL.NODATASELECTED');
            var conf = translate('KPI.MESSAGE.CONFAPP');
            var note = translate('KPI.MESSAGE.APPNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var jum = vm.listOtselected.length,
                i,
                ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog
                        .confirm()
                        .title(conf)
                        .textContent(note)
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok(yes)
                        .cancel(no);
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(
                        function () {
                            angular.element.blockUI();

                            var ot = new Approvalassignment();
                            ot.data = [];
                            ot.action = 'approve';
                            ot.nik = nik;
                            for (i = 0; i < jum; i++) {
                                ot.data.push({ id: vm.listOtselected[i].id });
                            }
                            var idtx = encodeURIComponent(angular.toJson(ids));
                            var response = ot.$save();
                            response.then(function (data) {
                                angular.element.unblockUI();
                                showDialogInfo(ev, data);
                            });
                            response.catch(function (data) {
                                angular.element.unblockUI();
                                showDialogInfo(ev, data);
                            });
                        },
                        function () {
                            // $scope.status = 'You decided to keep your debt.';
                        }
                    );
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector('#contentDialog')
                                )
                            )
                            .clickOutsideToClose(true)
                            .title('Attention!')
                            .textContent(nodataselected)
                            .ariaLabel('Attention')
                            .ok('close')
                            .targetEvent(ev)
                    )
                    .then(function () {
                        loadData();
                    });
            }
        }

        function successApproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Thanks for Approval')
                        .textContent(data.pesan)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                )
                .then(function () {
                    angular.element.unblockUI();
                    vm.listOtselected = [];

                    if ('moreInfo' in data && data.moreInfo.length > 0) {
                        $mdDialog.show({
                            controller: 'logFailGwController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: true,
                            onRemoving: function (element, removePromise) {
                                loadData(1);
                            },
                            locals: {
                                data: data.moreInfo
                            }
                        });
                    } else {
                        loadData(1);
                    }
                });
        }

        function failedApproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Approval')
                        .textContent(data.pesan)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                )
                .then(function () {
                    // loadData();
                    angular.element.unblockUI();
                });
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'UpfingerViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/update-finger-approval/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listOtselected = [];
                },
                locals: {
                    id: id
                }
            });
        }

        function Reject(ev) {
            var nodataselected = translate('KPI.LABEL.NODATASELECTED');
            var jum = vm.listOtselected.length,
                i,
                ids = [];
            if (jum > 0) {
                // var promise=Auth.setToken();
                //  promise.then(function(){
                //       var confirm = $mdDialog.confirm()
                //       .title('Would you like to Reject this list?')
                //       .textContent('All data your selected will be Reject.')
                //       .ariaLabel('delete dialog')
                //       .targetEvent(ev)
                //       .ok('YES')
                //       .cancel('no');
                //   $mdDialog.show({
                //         multiple: true
                //    });
                //   $mdDialog.show(confirm).then(function() {
                //         angular.element.blockUI();
                //         // console.log(vm.listOtselected);
                //         var ot= new Approvalassignment();
                //         ot.data=[];
                //         ot.action='reject';
                //         ot.nik=nik;
                //         ot.approval_type='n1';
                //         var jum=vm.listOtselected.length,i,ids=[];
                //         for (i=0;i<jum;i++) {
                //           ot.data.push({id:vm.listOtselected[i].id});
                //         }
                //         var idtx=encodeURIComponent(angular.toJson(ids));
                //         var response=ot.$save();
                //         //var response=tm.$delete({action:'approve'});
                //         response.then(loadData);
                //     }, function() {
                //    // $scope.status = 'You decided to keep your debt.';
                //   });
                // });
                $mdDialog.show({
                    controller: 'UpFingerRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl:
                        'app/main/cb/update-finger-approval/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        loadData();
                        vm.listOtselected = [];
                    },
                    locals: {
                        id: vm.listOtselected
                    }
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(
                                angular.element(
                                    document.querySelector('#contentDialog')
                                )
                            )
                            .clickOutsideToClose(true)
                            .title('Attention!')
                            .textContent(nodataselected)
                            .ariaLabel('Attention')
                            .ok('close')
                            .targetEvent(ev)
                    )
                    .then(function () {
                        loadData();
                    });
            }
        }

        function UnApproved(ev, id) {
            var conf = translate('KPI.MESSAGE.CONFUNAPP');
            var note = translate('KPI.MESSAGE.UNAPPNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title(conf)
                    .textContent(note)
                    .ariaLabel('unapprove dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = Approvalassignment.delete({
                            action: 'unapproved',
                            data: angular.toJson(id)
                        });
                        response.$promise.then(function (data) {
                            succesUnapproved(ev, data);
                        });
                        response.$promise.catch(function (data) {
                            failedUnapproved(ev, data);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function UnReject(ev, id) {
            var conf = translate('KPI.MESSAGE.CONFUNREJ');
            var note = translate('KPI.MESSAGE.UNREJNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title(conf)
                    .textContent(note)
                    .ariaLabel('unreject dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = Approvalassignment.delete({
                            action: 'unreject',
                            data: angular.toJson(id)
                        });
                        response.$promise.then(function (data) {
                            succesUnreject(ev, data);
                        });
                        response.$promise.catch(function () {
                            angular.element.unblockUI();
                            failedUnapproved(ev, data);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function succesUnapproved(ev, data) {
            if (data.hasil == 'expired') {
                showFailedUnapproved();
            } else {
                showDialog();
            }
            vm.listOtselected = [];
            loadData();
        }

        function succesUnreject(ev, data) {
            if (data.hasil == 'expired') {
                showFailedUnreject();
            } else {
                showDialogUnreject();
            }
            loadData();
        }

        function failedUnapproved(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Approval')
                        .textContent(data.data)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                )
                .then(function () {
                    loadData();
                });
        }

        function showFailedUnapproved() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Unapproved Data')
                        .textContent('Transaction Locked By System.')
                        .ariaLabel('Transaction Locked By System')
                        .ok('OK')
                )
                .then(function () {
                    $mdDialog.hide();
                });
        }

        function showFailedUnreject() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Unreject Data')
                        .textContent('Transaction Locked By System.')
                        .ariaLabel('Transaction Locked By System')
                        .ok('OK')
                )
                .then(function () {
                    $mdDialog.hide();
                });
        }

        function showDialog() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Thanks for Approval')
                        .textContent('Process Data was Success.')
                        .ariaLabel('Attention')
                        .ok('close')
                )
                .then(function () {
                    $mdDialog.hide();
                    vm.listOtselected = [];
                });
        }

        function showDialogUnreject() {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Success Process Data')
                        .textContent('Process Data was Success.')
                        .ariaLabel('Attention')
                        .ok('close')
                )
                .then(function () {
                    $mdDialog.hide();
                    vm.listOtselected = [];
                });
        }

        function printLetter(ev, data, detail) {
            $mdDialog.show({
                controller: 'HrTeamAssignmentApprovalPrintController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/hr-team-assignment-approval/hr-team-assignment-approval-print.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    data: data,
                    detail: detail
                }
            });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function resolveDate(dateInput) {
            var vDate = new Date(dateInput);
            
            return vDate.getDate() + '/' + (vDate.getMonth() + 1) + '/' + vDate.getFullYear() + ' ' + vDate.getHours() + ':' + vDate.getMinutes() + ':' + vDate.getSeconds();    
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.hr-team-assignment-approval')
        .controller('HrTeamAssignmentApprovalPrintController', HrTeamAssignmentApprovalPrintController);
    /* @ngInject */
    HrTeamAssignmentApprovalPrintController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','config','data','detail','Auth','$location','$window'];

    /* @ngInject */
    function HrTeamAssignmentApprovalPrintController($localStorage,$mdDialog,Form,AppAPI,config,data,detail,Auth,$location,$window) {
        var vm = this;
    
        vm.close = close;
        vm.data = data;
        vm.detail = detail;
        vm.indexOfFunction = indexOfFunction;
        vm.download = download;
        var Approvalassignment = AppAPI.Approvalassignment();

        Form.initialForm();
        Form.setObject(Approvalassignment);

        vm.Form = Form;


        vm.Form.objForm['print_assignment'] = {};
        vm.Form.objForm.print_assignment.sk = true;
        vm.Form.objForm.print_assignment.surkom = true;
        vm.Form.objForm.print_assignment.ba = false;
        vm.Form.objForm.print_assignment.kop = true;
        
        var nik = $localStorage.user;
        vm.nik = nik;

        vm.masterBenefits = vm.data.master_benefit;
        vm.penyesuaian = [];
        for(var i = 0; i < vm.detail.length; i++) {
            if(typeof vm.detail[i].penyesuaian == 'undefined') {
                vm.detail[i]['penyesuaian'] = [];
            }
            
            for(var j = 0; j < vm.detail[i].benefits.length; j++) {
                if(vm.detail[i].grade != vm.detail[i].benefits[j].grade) {
                    vm.detail[i].penyesuaian.push(vm.detail[i].benefits[j].id);
                    vm.penyesuaian.push(vm.detail[i]);
                }
            }
        }

        if(vm.penyesuaian.length > 0) {
            vm.Form.objForm.print_assignment.ba = true;
        }

        function close() {
          $mdDialog.cancel();
        }

        function indexOfFunction(array, q) {
            return array.indexOf(q);
        }

        function download() {
            var token = Auth.setTokenPromise();
        
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    var fileShow = ['RKI Penugasan ', vm.data.assign_by, ' ', vm.data.startDate.replace(/-/g, ''), ' ', vm.data.endDate.replace(/-/g, ''), '   ', vm.detail.length, ' Emp'].join('');
                    $window.open(
                        protocol +
                            '://' +
                            host +
                            config.port +
                            config.api +
                            'api/approvalassignment/downloaddocs/' +
                            vm.data.company_id +
                            '/' +
                            vm.data.id +
                            '/' +
                            vm.Form.objForm.print_assignment.sk +
                            '/' +
                            vm.Form.objForm.print_assignment.surkom +
                            '/' +
                            vm.Form.objForm.print_assignment.ba + 
                            '/' +
                            vm.Form.objForm.print_assignment.kop + 
                            '/' +
                            encodeURI(fileShow),
                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.hr-sic-mapping-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_hr_sic_mapping_approval', {
                url    : '/cb/store-incharge-mapping-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/hr-sic-mapping-approval/hr-sic-mapping-approval.html',
                        controller : 'HrSicMappingApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.hr-sic-mapping-approval')
        .controller('HrSicMappingApprovalController', HrSicMappingApprovalController);


    HrSicMappingApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function HrSicMappingApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Sicmappingapproval=AppAPI.Sicmappingapproval();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];  
      vm.Approve=Approve;
      vm.unApprove=unApprove;
      // vm.Reject=Reject;

      vm.icon = "icon-plus";
      vm.result = false;
      vm.toogleSubChild=toogleSubChild;
      vm.visibleSubChild=[];
      vm.setViewTeam=setViewTeam;
         
      loadData(1);
 
        //////////
    
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Sicmappingapproval,pageno,{action:'viewdata'});
      vm.listOtselected=[];
    }
     
  

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

     

    function toogleSubChild(idx) {
      switch(vm.visibleSubChild[idx])
        {
            case true :
            vm.visibleSubChild[idx]=false;
            vm.icon='icon-minus';
            break;
            case false :
            vm.visibleSubChild[idx]=true;
             vm.icon='icon-plus';
            break;
            default:
               vm.visibleSubChild[idx]=true;
                vm.icon='icon-minus';
            break;
        }

    }

    function Approve(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    // console.log(vm.listOtselected);
                    var ot= new Sicmappingapproval();
                    ot.data=[];
                    ot.action='approve';
                    ot.nik=nik;  
                    for (i=0;i<jum;i++) {
                      ot.data.push({id:vm.listOtselected[i].id});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    //var response=tm.$delete({action:'approve'});
                    response.then(loadData);
                    response.catch( function(){
                      angular.element.unblockUI();
                    });
                }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
            }); 
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

      function setViewTeam(ev,id)
      {
        $mdDialog.show({
                controller         : 'viewTeamMappingtController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/hr-crew-mapping-approval/view-team-mapping.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            });
      }

      function unApprove(ev,id)
      {
         var promise=Auth.setToken();
        promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

            $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
            var response=Sicmappingapproval.delete({action:'unapprove',data:angular.toJson(id)});
            response.$promise.then(loadData);
            angular.element.unblockUI();
            }, function() {
             // $scope.status = 'You decided to keep your debt.';
             angular.element.unblockUI();
            });
        });
      }
      

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.hr-crew-mapping-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_hr_crew_mapping_approval', {
                url    : '/cb/crew-mapping-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/hr-crew-mapping-approval/hr-crew-mapping-approval.html',
                        controller : 'HrCrewMappingApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.hr-crew-mapping-approval')
        .controller('viewTeamMappingtController', viewTeamMappingtController);

    viewTeamMappingtController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function viewTeamMappingtController($localStorage,id,$mdDialog,Form,AppAPI) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Attendanceemploye = AppAPI.Attendanceemploye();

        // set constructor form
        Form.setObject(Attendanceemploye);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal; 
        vm.gender = ['L','P'];

        
 
        vm.request=false;
        vm.Form.tampilPesan=false;
        vm.listSic=id.listSic;
        
        ////////////////

         
       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) { 

            var promise= Form.saveData('updatefinger', formController, Attendanceemploye);
            promise.then(function(){
                showDialog(ev);
            });

            promise.catch(function(){
               ShowFailed(ev)  
            });

        }

        function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent('Please Recheck Your Data.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.hr-crew-mapping-approval')
        .controller('HrCrewMappingApprovalController', HrCrewMappingApprovalController);


    HrCrewMappingApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function HrCrewMappingApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Sicmappingapproval=AppAPI.Amoutletmappingapproval();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];  
      vm.Approve=Approve;
      vm.setViewTeam=setViewTeam;
      vm.unApprove=unApprove;
      // vm.Reject=Reject;

      vm.icon = "icon-plus";
      vm.result = false;
      vm.toogleSubChild=toogleSubChild;
      vm.visibleSubChild=[];
         
      loadData(1);
 
        //////////
    
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Sicmappingapproval,pageno,{action:'viewdata'});
      vm.listOtselected=[];
    }
     
  

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function setViewTeam(ev,id)
      {
        $mdDialog.show({
                controller         : 'viewTeamMappingtController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/hr-crew-mapping-approval/view-team-mapping.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            });
      }
     

    function toogleSubChild(idx) {
      switch(vm.visibleSubChild[idx])
        {
            case true :
            vm.visibleSubChild[idx]=false;
            vm.icon='icon-minus';
            break;
            case false :
            vm.visibleSubChild[idx]=true;
             vm.icon='icon-plus';
            break;
            default:
               vm.visibleSubChild[idx]=true;
                vm.icon='icon-minus';
            break;
        }

    }

    function Approve(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    // console.log(vm.listOtselected);
                    var ot= new Sicmappingapproval();
                    ot.data=[];
                    ot.action='approve';
                    ot.nik=nik;  
                    for (i=0;i<jum;i++) {
                      ot.data.push({id:vm.listOtselected[i].id});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    //var response=tm.$delete({action:'approve'});
                    response.then(loadData);
                    response.catch( function(){
                      angular.element.unblockUI();
                    });
                }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
            }); 
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

      function unApprove(ev,id)
      {
         var promise=Auth.setToken();
        promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

        $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
        var response=Sicmappingapproval.delete({action:'unapprove',data:angular.toJson(id)});
        response.$promise.then(loadData);
            }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
        });
      }

      

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.halfday-report', [ ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    { 
        // State
        $stateProvider
            .state('app.cb_halfday_report', {
                url    : '/cb/halfday-report',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/halfday-report/halfday-report.html',
                        controller : 'HalfdayreportController as vm'
                    }
                }
            });  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.halfday-report')
        .controller('HalfdayreportController', HalfdayreportController);


    HalfdayreportController.$inject=['$state','$window','$location','$localStorage','$document','$element','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService' ];
    /** @ngInject */
    function HalfdayreportController($state,$window,$location,$localStorage,$document,$element,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService )
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData; 
        vm.toggleSelectedAll=toggleSelectedAll; 
        vm.ExportToExcel=ExportToExcel; 
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;  
        var Halfdayreport=AppAPI.Halfdayreport();
        var Attendancereport=AppAPI.Attendancereport();
        var date=new Date();
        vm.tahun=date.getFullYear();
        vm.bulan=date.getMonth()+1;
        vm.getPeriode=getPeriode;
        vm.tgl=date.getDate();
        vm.loadSubArea=loadSubArea;
        if(vm.tgl >=20 && vm.tgl <=31)
        {
          vm.bulan=vm.bulan+1;
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }
        vm.company=$localStorage.empsite;
        // console.log('employesite > '+$localStorage.empsite);

        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();

        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[ 
                    {link:'#',name:'C&B / ',active:'0'}
                    ]; 
        vm.listtahun=['2017','2018','2019', '2020', '2021'];
        vm.listbulan=[{name:'January',value:'01'},
                      {name:'February',value:'02'},
                      {name:'Maret',value:'03'},
                      {name:'April',value:'04'},
                      {name:'Mei',value:'05'},
                      {name:'June',value:'06'},
                      {name:'July',value:'07'},
                      {name:'August',value:'08'},
                      {name:'September',value:'09'},
                      {name:'October',value:'10'},
                      {name:'November',value:'11'},
                      {name:'Desember',value:'12'}];

        vm.simulateQuery = false;
        vm.isDisabled    = false;  
        vm.closeModal=closeModal; 
       getPeriode();
 

        //////////
        vm.searchTerm;
        vm.clearSearchTerm = function() {
          vm.searchTerm = '';
        };
        // The md-select directive eats keydown events for some quick select
        // logic. Since we have a search input here, we don't need that logic.
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        }); 

         function getPeriode(){
          var res=Halfdayreport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
          res.$promise.then(fetchPeriode);
          res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data)
        {
          vm.periode=data[0]['periode'];
          // console.log(vm.periode);
          // loadData(1);
        }

        function errorfetchPeriode(data)
        {
          console.log('error');
        }

         function loadDataDepartment(iddivisi) {
             var response=Halfdayreport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }
          
          function loadDataDivision(idbu) {
             var response=Halfdayreport.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          } 

          function loadDataBU() {
            var response=Halfdayreport.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }

         

        function loadData(){
           angular.element('#attView').block({message:'please wait..'});
           var company=vm.company; 
           var divisi=vm.divisi;
           var department=vm.department;
           var tahun=vm.tahun;
           var bulan=vm.bulan; 
           if(typeof(vm.divisi)==='undefined')
           {
              divisi='all';
           }
           if(typeof(vm.department)==='undefined')
           {
              department='all';
           }

           // console.log(company+' / '+divisi+' / '+department+' / '+tahun+' / '+bulan);
           var response=Halfdayreport.query({action:'viewdata',company:company,divisi:divisi,department:department,tahun:tahun,bulan:bulan});
              response.$promise.then(function(data){
                vm.listData=data;
                console.log(vm.listData);
                 angular.element('#attView').unblock();
              });
              response.$promise.catch(function(data){
                $log.info(data);
                vm.listData=[];
                 angular.element('#attView').unblock();
              });
        }

        // function loadData(pageno)
        // {
        //   var company=vm.company; 
        //   var divisi=vm.divisi;
        //   var department=vm.department;
        //   var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
        //   var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');
        
        //   var resp=vm.DataTable.loadData(Overtime,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
        //  // console.log(resp);
        //   // angular.element.unblockUI();
        // }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 
        
        
         

        function closeModal()
        {
            $mdDialog.hide();
        }

        function ExportToExcel()
        {
         var company=vm.company; 
         var divisi=vm.divisi;
         var department=vm.department;
         var tahun=vm.tahun;
         var bulan=vm.bulan;
         if(typeof(vm.divisi)==='undefined')
         {
            divisi='all';
         }
         if(typeof(vm.department)==='undefined')
         {
            department='all';
         }
          var token=Auth.setTokenPromise();
            token.then(function(data){
              var protocol=$location.protocol();
              var host=$location.host();
              $window.open(protocol+'://'+host+config.api+'api/halfdayreport/exportexcel/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan, '_blank');
            },function(){
              
                $window.alert('gagal load token');
            });
        }

        function  loadSubArea()
        {
          var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.ghk-holiday-gw', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_ghk_holiday_gw', {
                url    : '/cb/ghk-holiday-gw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/ghk-holiday-gw/index.html',
                        controller : 'GhkHolidayGwController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
  'use strict';
  angular
    .module('app.cb.ghk-holiday-gw')
    .controller('UploadGhkHolidayGwController', UploadGhkHolidayGwController);

  UploadGhkHolidayGwController.$inject = [
    '$state',
    '$mdDialog',
    'config',
    '$localStorage',
    '$timeout',
    'AppAPI',
    'Auth',
    'FileUploader',
    '$location',
    '$window'
    
    
  ];
  /** @ngInject */
  function UploadGhkHolidayGwController(
    $state,
    $mdDialog,
    config,
    $localStorage,
    $timeout,
    AppAPI,
    Auth,
    FileUploader,
    $location,
    $window
    
  ) {
    var vm = this;

    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    // vm.detailInfo = []
    
    vm.FileUpload = new FileUploader({
      url: config.api + 'api/ghkholidaygw/upload',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
          action: 'upload'
      }],
      onAfterAddingAll: function() {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
      if ( status.status == 0 ) {
        vm.uploadSuccess = false;
        vm.uploadError   = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError   = false;
      }

      vm.uploadNotif = status.pesan
      if ('moreInfo' in status && status.moreInfo.length>0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }
      angular.element('#uploadCutOff').val('');
      
    };

    vm.FileUpload.onErrorItem = function() {
      vm.uploadSuccess = false;
      vm.uploadError = true;
      
    };

    function closeModal()
    {
      $mdDialog.hide();
    }

    function DownloadTemplate()
    {
      var token=Auth.setTokenPromise();
        token.then(function(data){
                var protocol=$location.protocol();
                var host=$location.host();
               $window.open(protocol+'://'+host+config.api+'api/ghkholidaygw/downloadtemplate', '_blank');
        },function(){
          
            $window.alert('gagal load token');
        });
    }

    function viewMoreInfo()
    {
      $mdDialog.show({
        controller         : 'logFailGwController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose:true,
        fullscreen: true,
        onRemoving:function(element, removePromise)
        {
            loadData(1);
        },
        locals:{
          data:vm.detailInfo
        }
      });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.ghk-holiday-gw')
        .controller('searchEmpGhkHolidayGwController', searchEmpGhkHolidayGwController);

    searchEmpGhkHolidayGwController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','replacementType','DataService'];

    /* @ngInject */
    function searchEmpGhkHolidayGwController($localStorage,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,replacementType,DataService) {
        var vm = this; 
        // initial form
        Form.initialForm(); 
        var Employeghk = AppAPI.GhkHolidayGw();
        // set constructor form
        Form.setObject(Employeghk); 
        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal;
        vm.DataTable= new DataService();
        vm.detail=detail; 

   
        vm.loadData = loadData
        var nik= $localStorage.user;

 
        // function loadData(pageno) {
        //     var resp=vm.DataTable.loadData(Employeghk,pageno,{action:'searchEmployeeGhk',working_date:vm.working_date,replacementType:replacementType});
        //     resp.then(function(data) {
        //         vm.listSelected = [];
        //         vm.items = data.list;
        //     });
        // }

        function loadData(id)
        {
            var response= Employeghk.query({action:'searchEmployeeGhk',working_date:vm.working_date,replacementType:replacementType,nik:vm.nik});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {
            vm.items = data;
        }

        function errorFetchDetail() {
            vm.items = [];
        } 


        function closeModal()
        {
            $mdDialog.hide();
        }

        
        function reloadToken(){
            Auth.setToken();
        }

    function detail(ev, data)
      {
        // console.log(data);
        switch(replacementType)
        {
            case '1':
                $mdDialog.show({
                controller         : 'DetailGhkHolidayGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-holiday-gw/create.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  data:data
                }
            });
            break;
            case '0':
                $mdDialog.show({
                controller         : 'DetailGhkGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-gw/create.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                  data:data
                }
            });
            break;
            case '2': 
                $mdDialog.show({
                    controller         : 'DetailGhkHalfdayGwController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/cb/ghk-halfday-gw/create.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    },
                    locals:{
                      data:data
                    }
                }); 
            break;
        } 
      }
  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.ghk-holiday-gw')
        .controller('GhkHolidayGwController', GhkHolidayGwController);


    GhkHolidayGwController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function GhkHolidayGwController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this; 
      vm.deleteData=deleteData;
      vm.detail = detail
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Employeghk=AppAPI.GhkHolidayGw();
      var Attendanceemploye=AppAPI.Attendanceemploye(); 
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listselected=[];
      vm.approveOT=approveOT;
      vm.InputGhk=InputGhk;
      vm.viewComment=viewComment;
      vm.searchEmployee=searchEmployee;

      vm.exists = exists;
      vm.isIndeterminate = isIndeterminate;
      vm.toggleAll = toggleAll;
      vm.items = [];
      vm.Upload = Upload;
      vm.detailApproval=detailApproval;
      vm.getPeriode=getPeriode;

      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected'];

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1; 
      vm.tgl=date.getDate();
      if(vm.tgl >=25 && vm.tgl <=31)
      { 
        if(vm.bulan==12){
          vm.bulan='01';
        }else{
          vm.bulan=vm.bulan+1;
        }
      }
      if(vm.bulan < 10){
        vm.bulan='0'+vm.bulan;
      }

      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
         
      
      // loadData(1);
      getPeriode();
      ////////// 
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Employeghk,pageno,{action:'viewdata',nik:nik,periode:vm.datePeriode,workingDate:vm.workingDate});
      resp.then(function(data) {
          vm.listselected = [];
          vm.items = data.list;
      });
    }

    function getPeriode(){
      var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:'HRIS'});
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data)
    {
      vm.periode=data[0]['periode'];
      vm.datePeriode=data[0]['datePeriode'];
    }

    function errorfetchPeriode(data)
    {
      console.log('error');
      // vm.searchComplete=true;
    }
    
    function deleteData(ev) {
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data your selected will be deleted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=Employeghk.delete({action:'delete',data:angular.toJson(vm.listselected)});
                response.$promise.then( function(resData) {
                    angular.element.unblockUI();
                    if ( resData.status == 1 ) {
                      var title = 'Success Delete Data';
                      var textContent = resData.message;
                      var ariaLabel = 'Success Delete Data';
                    } else {
                      var title = 'Delete Data Failed';
                      var textContent = resData.message;
                      var ariaLabel = 'Delete Data Failed';
                    }
                    
                    showDialogMessage(title,textContent,ariaLabel);
                    loadData(1);
                });
                response.$promise.catch( function(resData) {
                    angular.element.unblockUI();
                    var title = 'Delete Data Failed';
                    var textContent = resData.message;
                    var ariaLabel = 'Delete Data Failed';
                    showDialogMessage(title,textContent,ariaLabel,ev);
                })
            }, function() {

            });
        });
    }

    function isChecked(ls)
        {
            // return vm.listselected.indexOf(ls) > -1;
            return vm.listselected.length === vm.items.length;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listselected.splice(idx, 1);
          }
          else
          {
              vm.listselected.push(ls);
          }
      }

      function toggleAll() {
        if (vm.listselected.length === vm.items.length) {
          vm.listselected = [];
        } else if (vm.listselected.length === 0 || vm.listselected.length > 0) {
          vm.listselected = vm.items.slice(0);
        }
      }

      function isIndeterminate() {
        return vm.listselected.length !== 0 && vm.listselected.length !== vm.items.length;
      }

      function approveOT(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listselected);
                var ot= new Employeghk();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;
                ot.approval_type='n1';
                var jum=vm.listselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function InputGhk(ev,id)
        {
            $mdDialog.show({
                controller         : 'CreateGhkHolidayGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-holiday-gw/create.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            }); 

        }

      function viewComment(ev,id)
      {
        $mdDialog.show({
            controller         : 'GhkholidayGwViewRejectCommentController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-ghk-holiday-gw/comment-reject.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            { 
                // vm.listOtselected=[];
                loadData();
            },
            locals:{
              data:id
            }
        });
      }

      function exists(item, list) {
        return list.indexOf(item) > -1;
      }

      function showDialogMessage(title,textContent,ariaLabel,ev) {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              // closeModal();
          });
      }

      function detail(ev, data)
      {
        // console.log(data);
        $mdDialog.show({
            controller         : 'DetailGhkHolidayGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-holiday-gw/create.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{
              data:data
            }
        });
      }

      function Upload(ev) {
        $mdDialog.show({
          controller: 'UploadGhkHolidayGwController',
          controllerAs: 'vm',
          templateUrl:'app/main/cb/ghk-holiday-gw/upload.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true, // Only for -xs, -sm breakpoints.
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
        });
      }

      function detailApproval(ev, data)
      {
        $mdDialog.show({
            controller         : 'DetailApprovalGhkHolidayGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-holiday-gw/detail-approval.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                // loadData(1);
            },
            locals:{
              data:data
            }
        });
      }

      function searchEmployee(ev)
      {
        $mdDialog.show({
            controller         : 'searchEmpGhkHolidayGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-holiday-gw/search-employee.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{  
              replacementType:'1' 
            }
        });
      }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.ghk-holiday-gw')
        .controller('DetailGhkHolidayGwController', DetailGhkHolidayGwController);

    DetailGhkHolidayGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data'];

    /* @ngInject */
    function DetailGhkHolidayGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.GhkHolidayGw();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;
        vm.disable=true;
        vm.edit = true;
        vm.setEdit = setEdit;
        vm.disableDate=false;
 

        vm.closeModal = closeModal;  
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();

        vm.reloadToken=reloadToken; 
        vm.changeRefshift=changeRefshift; 
        vm.unscheduleshift=false; 
        vm.Form.objForm.shifttype='group';
        vm.changeShiftType=changeShiftType;
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.exist=exist;
        vm.toggleCheck = toggleCheck;
        vm.listSelected=[];
        vm.Form.objForm.approval = data.approval
        vm.isStatus = isStatus
        vm.canModify = data.can_modify
        vm.canDelete = data.can_delete
        vm.getDataListEmploye = getDataListEmploye

        vm.listDepartment = [];
        vm.selectedDepartment = [];
        vm.toggleDeparment = toggleDeparment
        vm.existsDept = existsDept
        vm.AddEmployeeList=AddEmployeeList;
        vm.removeEmployee=removeEmployee;
        vm.empSelected=[];

        vm.toggleSector = toggleSector
        vm.selectedSector = [];
        vm.sectorList = [];
        vm.existsSector = existsSector
        vm.disableSector = true;

        // console.log(data); 
       
        LoadLocationshift();
        getListGedung();
        loadDetail(data.id);
        setData(); 

        vm.setSameDate = setSameDate;
        vm.isStartSameDate = "1";

        function setSameDate(param)
        {
            if (param != '1'){
                vm.isStartSameDate = "1";
            }else{
                vm.isStartSameDate = "0";
            }
        }

        function setData()
        {
            vm.Form.objForm.holiday_date = new Date(data.holiday_date);
            vm.Form.objForm.working_date = new Date(data.working_date);
            vm.Form.objForm.reason = data.reason
            // console.log(data);
            if ( data.dws_code == 'NG00' ) {
                vm.Form.objForm.shifttype = 'nongroup'
                vm.Form.objForm.start_time = data.start_time
                vm.Form.objForm.end_time = data.end_time
                changeShiftType();
            } else {
                vm.Form.objForm.shifttype = 'group'
                vm.Form.objForm.locationid = data.location_id
                changeRefshift(data.location_id)
                var code = data.dws_code+'-'+data.variant    
                changeShiftType(code);
            }
        }

        function changeRefshift(id)
        { 
            if(id==0){
                vm.unscheduleshift=true;
                vm.Form.objForm.start_template='NG00-Full';
            }else{
                vm.listLocationdetail=[];
                var resp=Employeghk.query({action:'getDetailshift',id:id})
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            } 
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function LoadLocationshift() {
            var response=Employeghk.query({action:'getLocationshift',nik:$localStorage.user});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

        function fetchLocation(data) {
            vm.listLocation=data;
        }

        function errorFetchLocation() {
            vm.listLocation=[];
        } 
 
      

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            vm.Form.objForm.listEmploye = vm.empSelected;
            vm.Form.objForm.id = data.id;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;

            var promise= Form.saveData('update', formController, Employeghk);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
          // console.log(data);
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
                vm.timedisabled=false;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
                vm.timedisabled=true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function changeShiftType(code)
        {
            if(vm.Form.objForm.shifttype==='nongroup')
            {
                vm.Form.objForm.start_template='NG00-Full';
                vm.unscheduleshift=true;
            }else{
                vm.Form.objForm.start_template=code;
                vm.unscheduleshift=false;
            }
        }

        function toggleSelectedAll(state)
        {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }

        }

        function isChecked(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = true;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function isStatus(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.empSelected.length > 0 ) {
                angular.forEach(vm.empSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = value.status1;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event)
        {

            if ( event )
            {
                event.stopPropagation();
            }

            var arrTemp = []
            var exist = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    
                        if ( value.nik != ls.nik ) {
                            
                            // arrTemp.push(ls)
                            arrTemp.push(value)
                        } else {
                            exist = true
                        }    
                    
                    
                });
                if ( !exist ) {
                    arrTemp.push(ls)
                }
            } else {
                arrTemp.push(ls)
            }


            vm.listSelected = arrTemp
            // var idx = vm.listSelected.indexOf(ls);

            // if ( idx > -1 )
            // { 
            //     vm.listSelected.splice(idx, 1);
            // }
            // else
            // {
            //     vm.listSelected.push(ls);
            // }
        }

        // function getDataListEmploye(pageno)
        // {

        //     var resp=vm.DataTable.loadData(Employeghk,pageno,{action:'getEmployelist',nik:$localStorage.user});
        //       resp.then(function(data) {
        //           vm.listselected = [];
        //           vm.items = data.list;
        //       });

        // }

        function loadDetail(id)
        {
            var response= Employeghk.query({action:'getDetailGhk',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {
            var idToDelete=[];
            // console.log(data);
            angular.forEach(data, function(value, key) 
            {
                var emp = {
                    nik : value.nik,
                    nik_atasan : value.nik_atasan,
                    nama : value.nama,
                    status1 : value.status1,
                    approvalStatus1:null,
                    approvalStatus2:null
                }
                vm.empSelected.push(emp)
                if(value.deleteStatus==1)
                {
                    idToDelete.push(value.id); 
                }
                if(value.approvalStatus1!='Waiting Approval')
                {
                    vm.disableDate=true;
                }               
            }); 
            vm.Form.objForm.idToDelete=idToDelete;

            // console.log(vm.Form.objForm);
            // getDataListEmploye(1);
        }

        function errorFetchDetail() {
            vm.empSelected = [];
            // getDataListEmploye(1);
        }

        function setEdit (status)
        {
            vm.disable = status;
        }

        function getDataListEmploye()
        {
            // if ( vm.canModify == '0' ) {
            //     vm.items = vm.listSelected
            // } else {
                angular.element.blockUI();
                var workingDate = vm.Form.objForm.working_date;
                var holidayDate = vm.Form.objForm.holiday_date; 
                var gedung_id = angular.toJson(vm.selectedDepartment);
                var sector_id = angular.toJson(vm.selectedSector);
                var resp=Employeghk.query({action:'getEmployelist',nik:$localStorage.user, working_date: workingDate, holiday_date: holidayDate, gedung_id: gedung_id, sector_id: sector_id });
                  resp.$promise.then(function(data) {
                      vm.listselected = [];
                      vm.items = data;
                      angular.element.unblockUI();
                  });
                  resp.$promise.catch(function(data){
                    vm.items = [];
                    angular.element.unblockUI();
                  });    
            // }
            
        }

        function getListGedung()
        {
            var resp=Employeghk.query({action:'getListGedungDepartment'});
            resp.$promise.then(function(data) {
                vm.listDepartment = data
                vm.sectorList = data

                angular.forEach(data, function(value, key) {
                    vm.selectedDepartment.push(value);
                    angular.forEach(value.sectors, function(val, k) {
                        vm.selectedSector.push(val);
                    });
                });
                getDataListEmploye(1);
        
            });
            resp.$promise.catch(function(data){
                vm.listDepartment = []
            });    
        }

        function toggleDeparment (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                angular.forEach(item.sectors, function (obj,index){
                    angular.forEach(vm.selectedSector, function (objSector,idxSector){
                        if(objSector.id==obj.id){
                            vm.selectedSector.splice(idxSector, 1);
                        }
                    })
                })
                list.splice(idx, 1);
            }
            else {
                angular.forEach(item.sectors, function (obj,index){
                    vm.selectedSector.push(obj);
                })
                list.push(item);
            }

            getDataListEmploye(1);
        };

        function existsDept (item, list) {
            return list.indexOf(item) > -1;
        };

        function AddEmployeeList()
        {
            var obj=vm.listSelected;  
            angular.forEach(obj, function (value,key) 
            {
                // console.log(value);
               var ifSelected=checkIfExistInselected(value.nik,vm.empSelected);
               if(!ifSelected){
                    var emp = {
                            nik : value.nik,
                            nik_atasan : value.nik_atasan,
                            nama : value.name,
                            status1 : 'Waiting Approval', 
                            approvalStatus1:null,
                            approvalStatus2:null
                        }
                 vm.empSelected.push(emp);
                 vm.listSelected=[];
               }
            });
            
        }

        function checkIfExistInselected(value,arrSelected)
        {
             var ifSelected=false;
             var len=arrSelected.length;
             for (var i=0;i<len;i++)
             {
                if(arrSelected[i].nik==value){
                    ifSelected=true;
                }
                // console.log(value);
                // console.log(arrSelected[i]);
             }

             return ifSelected;
        }

        function removeEmployee(ls)
        {
             var idx = vm.empSelected.indexOf(ls);
             if ( idx > -1 )
              {
                  vm.empSelected.splice(idx, 1);
              }
              // console.log(vm.empSelected);
             
             
        }
        
        function toggleSector (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
              list.splice(idx, 1);
            }
            else {
              list.push(item);
            }
            getDataListEmploye();
        };

        function existsSector (item, list) {
            return list.indexOf(item) > -1;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.ghk-holiday-gw')
        .controller('DetailApprovalGhkHolidayGwController', DetailApprovalGhkHolidayGwController);

    DetailApprovalGhkHolidayGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data'];

    /* @ngInject */
    function DetailApprovalGhkHolidayGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data) {
        var vm = this; 

        var Employeghk = AppAPI.GhkHolidayGw(); 
        vm.closeModal=closeModal;
          
        loadDetail(data.id); 
        
        ////////////////f 

        function closeModal()
        {
            $mdDialog.hide();
        }   

        function loadDetail(id)
        {
            var response= Employeghk.query({action:'getDetailGhk',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {
            vm.items = data;
        }

        function errorFetchDetail() {
            vm.items = [];
        }   
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.ghk-holiday-gw')
        .controller('CreateGhkHolidayGwController', CreateGhkHolidayGwController);

    CreateGhkHolidayGwController.$inject = ['$localStorage', 'DataService', '$mdDialog', 'Form', 'AppAPI', '$log', 'config', 'Auth', '$mdToast'];

    /* @ngInject */
    function CreateGhkHolidayGwController($localStorage, DataService, $mdDialog, Form, AppAPI, $log, config, Auth, $mdToast) {
        var vm = this;
        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.GhkHolidayGw();
        var EmployeghkHoliday = AppAPI.Employeghkholiday();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess = false;
        vm.disable = false;
        vm.edit = false;


        vm.closeModal = closeModal;

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();

        vm.reloadToken = reloadToken;
        vm.changeRefshift = changeRefshift;
        vm.unscheduleshift = false;
        vm.Form.objForm.shifttype = 'group';
        vm.changeShiftType = changeShiftType;
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listSelected = [];
        vm.canModify = vm.canDelete = 1
        vm.getDataListEmploye = getDataListEmploye;

        vm.listDepartment = [];
        vm.selectedDepartment = [];
        vm.toggleDeparment = toggleDeparment
        vm.existsDept = existsDept

        vm.AddEmployeeList = AddEmployeeList;
        vm.removeEmployee = removeEmployee;
        vm.checkIfExistInselected = checkIfExistInselected;
        vm.empSelected = [];
        vm.isStatus = isStatus;
        vm.toggleSector = toggleSector
        vm.selectedSector = [];
        vm.sectorList = [];
        vm.existsSector = existsSector
        vm.disableSector = false;
        vm.changeWorkingDay = changeWorkingDay;

        LoadLocationshift();
        getListGedung();
        getWorkingDay();

        vm.setSameDate = setSameDate;
        vm.isStartSameDate = "1";

        function setSameDate(param) {
            if (param != '1') {
                vm.isStartSameDate = "1";
            } else {
                vm.isStartSameDate = "0";
            }
        }

        function changeRefshift(id) {
            if (id == 0) {
                vm.unscheduleshift = true;
                vm.Form.objForm.start_template = 'NG00-Full';
            } else {
                vm.listLocationdetail = [];
                var resp = Employeghk.query({ action: 'getDetailshift', id: id })
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            }
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data) {
            vm.listLocationdetail = data;
        }

        function errorfetchdetailshift() {
            vm.listLocationdetail = [];
        }

        function LoadLocationshift() {
            var response = Employeghk.query({ action: 'getLocationshift', nik: $localStorage.user });
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
        }

        function fetchLocation(data) {
            vm.listLocation = data;
        }

        function errorFetchLocation() {
            vm.listLocation = [];
        }



        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.saveProcess = true;
            vm.Form.objForm.listEmploye = vm.empSelected;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;

            var promise = Form.saveData('save', formController, Employeghk);
            promise.then(function (data) {
                if (data.status == 1) {
                    showDialog(ev, data);
                } else {
                    showFailed(ev, data);
                }
            });

            promise.catch(function (data) {
                showFailed(ev, data.data);
            });

        }

        function showDialog(ev, data) {
            vm.saveProcess = false;
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                if ('moreInfo' in data && data.moreInfo.length > 0) {
                    $mdDialog.show({
                        controller: 'logFailGwController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            loadData(1);
                        },
                        locals: {
                            data: data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(ev, data) {
            vm.saveProcess = false;
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                // closeModal();
            });
            console.log(data);
        }

        function ChangeDayType() {
            if (vm.Form.objForm.daytype == 'halfday') {
                vm.Form.objForm.end_date = vm.Form.objForm.start_date;
                vm.enddaterequire = false;
                vm.timerequire = true;
                vm.timedisabled = false;
            } else {
                vm.enddaterequire = true;
                vm.timerequire = false;
                vm.timedisabled = true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken() {
            Auth.setToken();
        }

        function changeShiftType() {
            if (vm.Form.objForm.shifttype === 'nongroup') {
                vm.Form.objForm.start_template = 'NG00-Full';
                vm.unscheduleshift = true;
            } else {
                vm.Form.objForm.start_template = null;
                vm.unscheduleshift = false;
            }
        }

        function toggleSelectedAll(state) {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }

            // switch(state)
            // {
            //     case false:
            //     checkAll();
            //     break;
            //     case true:
            //     unCheckAll();
            //     break;
            // }

            // console.log(state);
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.items);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function isChecked(ls) {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if (idx > -1) {
                vm.listSelected.splice(idx, 1);
            }
            else {
                vm.listSelected.push(ls);
            }
        }

        function getDataListEmploye() {
            var workingDate = vm.Form.objForm.working_date;
            var holidayDate = vm.Form.objForm.holiday_date;


            if (workingDate !== undefined) {
                angular.element.blockUI();
                var gedung_id = angular.toJson(vm.selectedDepartment);
                var sector_id = angular.toJson(vm.selectedSector);
                var resp = Employeghk.query({ action: 'getEmployelist', nik: $localStorage.user, working_date: workingDate, holiday_date: holidayDate, gedung_id: gedung_id, sector_id: sector_id });
                resp.$promise.then(function (data) {
                    vm.listselected = [];
                    vm.selectAll = false;
                    vm.items = data;
                    angular.element.unblockUI();
                });
                resp.$promise.catch(function (data) {
                    vm.items = [];
                    angular.element.unblockUI();
                });
            }

        }

        function getListGedung() {
            angular.element.blockUI();
            var resp = Employeghk.query({ action: 'getListGedungDepartment' });
            resp.$promise.then(function (data) {
                vm.listDepartment = data
                vm.sectorList = data

                angular.forEach(data, function (value, key) {
                    vm.selectedDepartment.push(value);
                    angular.forEach(value.sectors, function (val, k) {
                        vm.selectedSector.push(val);
                    });
                });

                angular.element.unblockUI();
            });
            resp.$promise.catch(function (data) {
                vm.listDepartment = []
                angular.element.unblockUI();
            });
        }

        function toggleDeparment(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                angular.forEach(item.sectors, function (obj, index) {
                    angular.forEach(vm.selectedSector, function (objSector, idxSector) {
                        if (objSector.id == obj.id) {
                            vm.selectedSector.splice(idxSector, 1);
                        }
                    })
                })
                list.splice(idx, 1);
            }
            else {
                angular.forEach(item.sectors, function (obj, index) {
                    vm.selectedSector.push(obj);
                })
                list.push(item);
            }

            getDataListEmploye();
        };

        function existsDept(item, list) {
            vm.disableSector = !(list.indexOf(item) > -1);
            return list.indexOf(item) > -1;
        };


        function AddEmployeeList() {
            var obj = vm.listSelected;
            angular.forEach(obj, function (value, key) {
                var ifSelected = checkIfExistInselected(value.nik, vm.empSelected);
                if (!ifSelected) {
                    var emp = {
                        nik: value.nik,
                        nik_atasan: value.nik_atasan,
                        nama: value.name,
                        status: 'Waiting Approval'
                    }
                    vm.empSelected.push(emp);
                    vm.listSelected = [];
                }
            });

        }

        function checkIfExistInselected(value, arrSelected) {
            var ifSelected = false;
            var len = arrSelected.length;
            for (var i = 0; i < len; i++) {
                if (arrSelected[i].nik == value) {
                    ifSelected = true;
                }
                // console.log(value);
                // console.log(arrSelected[i]);
            }

            return ifSelected;
        }

        function removeEmployee(ls) {
            var idx = vm.empSelected.indexOf(ls);
            if (idx > -1) {
                vm.empSelected.splice(idx, 1);
            }
            // console.log(vm.empSelected);


        }

        function isStatus(ls) {
            var val = false
            var breakEach = false
            if (vm.empSelected.length > 0) {
                angular.forEach(vm.empSelected, function (value, key) {
                    if (!breakEach) {
                        if (value.nik == ls.nik) {
                            val = value.status;
                            breakEach = true
                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleSector(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            }
            else {
                list.push(item);
            }
            getDataListEmploye();
        };

        function existsSector(item, list) {
            return list.indexOf(item) > -1;
        };

        function getWorkingDay() {
            vm.listworkingday = [];
            var resp = EmployeghkHoliday.query({ action: 'getWorkingDay' });
            resp.$promise.then(function (data) {
                vm.listworkingday = data;
                if (vm.listworkingday.length > 0) {
                    vm.required = true;
                } else {
                    vm.required = false;
                }
            });
            resp.$promise.catch(function () {
                vm.listworkingday = [];
            });
        }

        function changeWorkingDay() {
            getDataListEmploye();
            vm.listholiday = [];
            var resp = EmployeghkHoliday.query({ action: 'getWorkingDay', workingDay: vm.Form.objForm.working_date });
            resp.$promise.then(function (data) {
                vm.listholiday = data;
                if (vm.listholiday.length > 0) {
                    vm.required = true;
                } else {
                    vm.required = false;
                }
            });
            resp.$promise.catch(function () {
                vm.listholiday = [];
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.ghk-gw', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_ghk_gw', {
                url    : '/cb/ghk-gw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/ghk-gw/index.html',
                        controller : 'GhkGwController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
  'use strict';
  angular
    .module('app.cb.ghk-gw')
    .controller('UploadGhkHalfdayGwController', UploadGhkHalfdayGwController);

  UploadGhkHalfdayGwController.$inject = [
    '$state',
    '$mdDialog',
    'config',
    '$localStorage',
    '$timeout',
    'AppAPI',
    'Auth',
    'FileUploader',
    '$location',
    '$window'
    
    
  ];
  /** @ngInject */
  function UploadGhkHalfdayGwController(
    $state,
    $mdDialog,
    config,
    $localStorage,
    $timeout,
    AppAPI,
    Auth,
    FileUploader,
    $location,
    $window
    
  ) {
    var vm = this;

    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []
    
    vm.FileUpload = new FileUploader({
      url: config.api + 'api/ghkhalfdaygw/upload',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
          action: 'upload'
      }],
      onAfterAddingAll: function() {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
      
      if ( status.status == 0 ) {
        vm.uploadSuccess = false;
        vm.uploadError   = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError   = false;
      }

      vm.uploadNotif = status.pesan
      if ('moreInfo' in status && status.moreInfo.length>0) {
          vm.isMoreInfo = true;
          vm.detailInfo = status.moreInfo;
      }

      
      angular.element('#uploadCutOff').val('');
      
    };

    vm.FileUpload.onErrorItem = function() {
      vm.uploadSuccess = false;
      vm.uploadError = true;
      
    };

    function closeModal()
    {
      $mdDialog.hide();
    }

    function DownloadTemplate()
    {
      var token=Auth.setTokenPromise();
        token.then(function(data){
                var protocol=$location.protocol();
                var host=$location.host();
               $window.open(protocol+'://'+host+config.api+'api/ghkhalfdaygw/downloadtemplate', '_blank');
        },function(){
          
            $window.alert('gagal load token');
        });
    }

    function viewMoreInfo()
    {
      $mdDialog.show({
        controller         : 'logFailGwController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose:true,
        fullscreen: true,
        onRemoving:function(element, removePromise)
        {
            loadData(1);
        },
        locals:{
          data:vm.detailInfo
        }
      });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.ghk-halfday-gw', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_ghk_halfday_gw', {
                url    : '/cb/ghk-halfday-gw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/ghk-halfday-gw/index.html',
                        controller : 'GhkHalfdayGwController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.ghk-halfday-gw')
        .controller('GhkHalfdayGwController', GhkHalfdayGwController);


    GhkHalfdayGwController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function GhkHalfdayGwController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this; 
      vm.deleteData=deleteData;
      vm.detail = detail
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Employeghk=AppAPI.GhkHalfdayGw();
      var Attendanceemploye=AppAPI.Attendanceemploye(); 
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listselected=[];
      vm.approveOT=approveOT;
      vm.InputGhk=InputGhk;
      vm.viewComment=viewComment;

      vm.exists = exists;
      vm.isIndeterminate = isIndeterminate;
      vm.toggleAll = toggleAll;
      vm.items = [];
      vm.Upload = Upload
      vm.detailApproval=detailApproval;
      vm.getPeriode=getPeriode;
      vm.searchEmployee=searchEmployee;

      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected'];

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();
      if(vm.tgl >=25 && vm.tgl <=31)
        { 
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }

      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
         
      
      // loadData(1);
      getPeriode();

        //////////
    
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Employeghk,pageno,{action:'viewdata',nik:nik,periode:vm.datePeriode,workingDate:vm.workingDate});
      resp.then(function(data) {
          vm.listselected = [];
          vm.items = data.list;
      });
    }
    
    function deleteData(ev) {
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data your selected will be deleted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=Employeghk.delete({action:'delete',data:angular.toJson(vm.listselected)});
                response.$promise.then( function(resData) {
                    angular.element.unblockUI();
                    if ( resData.status == 1 ) {
                      var title = 'Success Delete Data';
                      var textContent = resData.message;
                      var ariaLabel = 'Success Delete Data';
                    } else {
                      var title = 'Delete Data Failed';
                      var textContent = resData.message;
                      var ariaLabel = 'Delete Data Failed';
                    }
                    
                    showDialogMessage(title,textContent,ariaLabel);
                    loadData(1);
                });
                response.$promise.catch( function(resData) {
                    angular.element.unblockUI();
                    var title = 'Delete Data Failed';
                    var textContent = resData.message;
                    var ariaLabel = 'Delete Data Failed';
                    showDialogMessage(title,textContent,ariaLabel,ev);
                })
            }, function() {

            });
        });
    }

    function getPeriode(){
      var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:'HRIS'});
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data)
    {
      vm.periode=data[0]['periode'];
      vm.datePeriode=data[0]['datePeriode'];
    }

    function errorfetchPeriode(data)
    {
      console.log('error');
      // vm.searchComplete=true;
    }

    function isChecked(ls)
        {
            // return vm.listselected.indexOf(ls) > -1;
            return vm.listselected.length === vm.items.length;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listselected.splice(idx, 1);
          }
          else
          {
              vm.listselected.push(ls);
          }
      }

      function toggleAll() {
        if (vm.listselected.length === vm.items.length) {
          vm.listselected = [];
        } else if (vm.listselected.length === 0 || vm.listselected.length > 0) {
          vm.listselected = vm.items.slice(0);
        }
      }

      function isIndeterminate() {
        return vm.listselected.length !== 0 && vm.listselected.length !== vm.items.length;
      }

      function approveOT(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listselected);
                var ot= new Employeghk();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;
                ot.approval_type='n1';
                var jum=vm.listselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function InputGhk(ev,id)
        {
            $mdDialog.show({
                controller         : 'CreateGhkHalfdayGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-halfday-gw/create.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            }); 

        }

      function viewComment(ev,id)
      {
        $mdDialog.show({
            controller         : 'GhkHalfdayGwViewRejectCommentController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-ghk-halfday-gw/comment-reject.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            { 
                // vm.listOtselected=[];
                loadData();
            },
            locals:{
              data:id
            }
        });
      }

      function exists(item, list) {
        return list.indexOf(item) > -1;
      }

      function showDialogMessage(title,textContent,ariaLabel,ev) {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              closeModal();
          });
      }

      function detail(ev, data)
      {
        $mdDialog.show({
            controller         : 'DetailGhkHalfdayGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-halfday-gw/create.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{
              data:data
            }
        });
      }

      function Upload(ev) {
        $mdDialog.show({
          controller: 'UploadGhkHalfdayGwController',
          controllerAs: 'vm',
          templateUrl:'app/main/cb/ghk-gw/upload.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true, // Only for -xs, -sm breakpoints.
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
        });
      }

      function detailApproval(ev, data)
      {
        $mdDialog.show({
            controller         : 'DetailApprovalListGhkHalfdayGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-holiday-gw/detail-approval.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                // loadData(1);
            },
            locals:{
              data:data
            }
        });
      }

      function searchEmployee(ev)
      {
        $mdDialog.show({
            controller         : 'searchEmpGhkHolidayGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-holiday-gw/search-employee.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{  
              replacementType:'2' 
            }
        });
      }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.ghk-halfday-gw')
        .controller('DetailGhkHalfdayGwController', DetailGhkHalfdayGwController);

    DetailGhkHalfdayGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data'];

    /* @ngInject */
    function DetailGhkHalfdayGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.GhkHalfdayGw();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;
        vm.disable=true;
        vm.edit = true;
        vm.setEdit = setEdit;
        vm.disableDate=false;
 

        vm.closeModal = closeModal;  
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();

        vm.reloadToken=reloadToken; 
        vm.changeRefshift=changeRefshift; 
        vm.unscheduleshift=false; 
        vm.Form.objForm.shifttype='group';
        vm.changeShiftType=changeShiftType;
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.exist=exist;
        vm.toggleCheck = toggleCheck;
        vm.listSelected=[];
        vm.Form.objForm.approval = data.approval
        vm.isStatus = isStatus
        vm.canModify = data.can_modify
        vm.getDataListEmploye = getDataListEmploye
        
        vm.listDepartment = [];
        vm.selectedDepartment = [];
        vm.toggleDeparment = toggleDeparment
        vm.existsDept = existsDept;

        vm.AddEmployeeList=AddEmployeeList;
        vm.removeEmployee=removeEmployee;
        vm.empSelected=[];

        vm.toggleSector = toggleSector
        vm.selectedSector = [];
        vm.sectorList = [];
        vm.existsSector = existsSector
        vm.disableSector = true;
        
        loadDetail(data.id);
        setData();
        LoadLocationshift();
        getListGedung()

        vm.setSameDate = setSameDate;
        vm.isStartSameDate = "1";

        function setSameDate(param)
        {
            if (param != '1'){
                vm.isStartSameDate = "1";
            }else{
                vm.isStartSameDate = "0";
            }
        }

        function setData()
        {
            vm.Form.objForm.working_date = new Date(data.working_date);
            vm.Form.objForm.reason = data.reason
            if ( data.dws_code == 'NG00' ) {
                vm.Form.objForm.shifttype = 'nongroup'
                vm.Form.objForm.start_time = data.start_time
                vm.Form.objForm.end_time = data.end_time
                changeShiftType();
            } else {
                vm.Form.objForm.shifttype = 'group'
                vm.Form.objForm.locationid = data.location_id
                changeRefshift(data.location_id)
                var code = data.idshift+'-Half'    
                changeShiftType(code);
            }
        }

        function changeRefshift(id)
        { 
            if(id==0){
                vm.unscheduleshift=true;
                vm.Form.objForm.start_template='NG00-Full';
            }else{
                vm.listLocationdetail=[];
                var resp=Employeghk.query({action:'getDetailshift',id:id})
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            } 
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function LoadLocationshift() {
            var response=Employeghk.query({action:'getLocationshift',nik:$localStorage.user});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

        function fetchLocation(data) {
            vm.listLocation=data;
        }

        function errorFetchLocation() {
            vm.listLocation=[];
        } 
 
      

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            vm.Form.objForm.listEmploye = vm.empSelected;
            vm.Form.objForm.id = data.id;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;

            var promise= Form.saveData('update', formController, Employeghk);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
          console.log(data);
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
                vm.timedisabled=false;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
                vm.timedisabled=true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function changeShiftType(code)
        {
            if(vm.Form.objForm.shifttype==='nongroup')
            {
                vm.Form.objForm.start_template='NG00-Full';
                vm.unscheduleshift=true;
            }else{
                vm.Form.objForm.start_template=code;
                vm.unscheduleshift=false;
            }
        }

        function toggleSelectedAll(state)
        {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }

        }

        function isChecked(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = true;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function isStatus(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.empSelected.length > 0 ) {
                angular.forEach(vm.empSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = value.status1;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event)
        {

            if ( event )
            {
                event.stopPropagation();
            }

            var arrTemp = []
            var exist = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    
                        if ( value.nik != ls.nik ) {
                            
                            // arrTemp.push(ls)
                            arrTemp.push(value)
                        } else {
                            exist = true
                        }    
                    
                    
                });
                if ( !exist ) {
                    arrTemp.push(ls)
                }
            } else {
                arrTemp.push(ls)
            }


            vm.listSelected = arrTemp
            // var idx = vm.listSelected.indexOf(ls);

            // if ( idx > -1 )
            // { 
            //     vm.listSelected.splice(idx, 1);
            // }
            // else
            // {
            //     vm.listSelected.push(ls);
            // }
        }

        function loadDetail(id)
        {
            var response= Employeghk.query({action:'getDetail',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) 
        {
            var idToDelete=[];

            angular.forEach(data, function(value, key) 
            {
                var emp = {
                    nik : value.nik,
                    nik_atasan : value.nik_atasan,
                    nama : value.nama,
                    status : value.status
                }
                vm.empSelected.push(value)
                if(value.deleteStatus==1)
                {
                    idToDelete.push(value.id); 
                }
                if(value.approvalStatus1=='1')
                {
                    vm.disableDate=true;
                }                  
            });
            vm.Form.objForm.idToDelete=idToDelete;
        }

        function errorFetchDetail() {
            vm.listSelected = [];
        }

        function setEdit (status)
        {
            vm.disable = status;
        }

        function getDataListEmploye()
        {
            if ( vm.canModify == '0' ) {
                vm.items = vm.listSelected
            } else {
                angular.element.blockUI();
                var workingDate = vm.Form.objForm.working_date;
                var holidayDate = ''; 
                var gedung_id = angular.toJson(vm.selectedDepartment);
                var sector_id = angular.toJson(vm.selectedSector);
                var resp=Employeghk.query({action:'getEmployelist',nik:$localStorage.user, working_date: workingDate, holiday_date: holidayDate, gedung_id: gedung_id, sector_id: sector_id });
                  resp.$promise.then(function(data) {
                      vm.listselected = [];
                      vm.items = data;
                      angular.element.unblockUI();
                  });
                  resp.$promise.catch(function(data){
                    vm.items = [];
                    angular.element.unblockUI();
                  });    
            }
            
        }

        function getListGedung()
        {
            var resp=Employeghk.query({action:'getListGedungDepartment'});
            resp.$promise.then(function(data) {
                vm.listDepartment = data
                vm.sectorList = data

                angular.forEach(data, function(value, key) {
                    vm.selectedDepartment.push(value);
                    angular.forEach(value.sectors, function(val, k) {
                        vm.selectedSector.push(val);
                    });
                });
                getDataListEmploye()
        
            });
            resp.$promise.catch(function(data){
                vm.listDepartment = []
            });    
        }

        function toggleDeparment (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                angular.forEach(item.sectors, function (obj,index){
                    angular.forEach(vm.selectedSector, function (objSector,idxSector){
                        if(objSector.id==obj.id){
                            vm.selectedSector.splice(idxSector, 1);
                        }
                    })
                })
                list.splice(idx, 1);
            }
            else {
                angular.forEach(item.sectors, function (obj,index){
                    vm.selectedSector.push(obj);
                })
                list.push(item);
            }

            getDataListEmploye();
        };

        function existsDept (item, list) {
            return list.indexOf(item) > -1;
        };

        function AddEmployeeList()
        {
            var obj=vm.listSelected;  
            angular.forEach(obj, function (value,key) 
            {
                console.log(value);
               var ifSelected=checkIfExistInselected(value.nik,vm.empSelected);
               if(!ifSelected){
                    var emp = {
                            nik : value.nik,
                            nik_atasan : value.nik_atasan,
                            nama : value.name,
                            status : 'Waiting Approval'
                        }
                 vm.empSelected.push(emp);
               }
            });
            vm.listSelected=[];
        }

        function checkIfExistInselected(value,arrSelected)
        {
             var ifSelected=false;
             var len=arrSelected.length;
             for (var i=0;i<len;i++)
             {
                if(arrSelected[i].nik==value){
                    ifSelected=true;
                }
                // console.log(value);
                // console.log(arrSelected[i]);
             }

             return ifSelected;
        }

        function removeEmployee(ls)
        {
             var idx = vm.empSelected.indexOf(ls);
             if ( idx > -1 )
              {
                  vm.empSelected.splice(idx, 1);
              }
              // console.log(vm.empSelected);
             
             
        }
        
        function toggleSector (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
              list.splice(idx, 1);
            }
            else {
              list.push(item);
            }
            getDataListEmploye();
        };

        function existsSector (item, list) {
            return list.indexOf(item) > -1;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.ghk-halfday-gw')
        .controller('DetailApprovalListGhkHalfdayGwController', DetailApprovalListGhkHalfdayGwController);

    DetailApprovalListGhkHalfdayGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data'];

    /* @ngInject */
    function DetailApprovalListGhkHalfdayGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data) {
        var vm = this; 

        var EmployeghkHalfday = AppAPI.GhkHalfdayGw(); 
        vm.closeModal=closeModal;
          
        loadDetail(data.id); 

        function closeModal()
        {
            $mdDialog.hide();
        }   

        function loadDetail(id)
        {
            var response= EmployeghkHalfday.query({action:'getDetail',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {
            vm.items = data;
        }

        function errorFetchDetail() {
            vm.items = [];
        }   
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.ghk-halfday-gw')
        .controller('CreateGhkHalfdayGwController', CreateGhkHalfdayGwController);

    CreateGhkHalfdayGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast'];

    /* @ngInject */
    function CreateGhkHalfdayGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.GhkHalfdayGw();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;
        vm.disable = false;
        vm.edit = false;
 

        vm.closeModal = closeModal;  

        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();

        vm.reloadToken=reloadToken; 
        vm.changeRefshift=changeRefshift; 
        
        vm.unscheduleshift=false; 
        vm.Form.objForm.shifttype='group';
        vm.changeShiftType=changeShiftType;
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listSelected=[];
        vm.canModify = 1
        vm.getDataListEmploye = getDataListEmploye

        vm.listDepartment = [];
        vm.selectedDepartment = [];
        vm.toggleDeparment = toggleDeparment
        vm.existsDept = existsDept

        vm.AddEmployeeList=AddEmployeeList;
        vm.removeEmployee=removeEmployee;
        vm.checkIfExistInselected=checkIfExistInselected;
        vm.empSelected=[];
        vm.isStatus=isStatus;

        vm.toggleSector = toggleSector
        vm.selectedSector = [];
        vm.sectorList = [];
        vm.existsSector = existsSector
        vm.disableSector = false

        LoadLocationshift();
        getListGedung();

        vm.setSameDate = setSameDate;
        vm.isStartSameDate = "1";

        function setSameDate(param)
        {
            if (param != '1'){
                vm.isStartSameDate = "1";
            }else{
                vm.isStartSameDate = "0";
            }
        }
        
        function changeRefshift(id)
        { 
            if(id==0){
                vm.unscheduleshift=true;
                vm.Form.objForm.start_template='NG00-Full';
            }else{
                vm.listLocationdetail=[];
                var resp=Employeghk.query({action:'getDetailshift',id:id})
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            } 
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function LoadLocationshift() {
            var response=Employeghk.query({action:'getLocationshift',nik:$localStorage.user});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

          function fetchLocation(data) {
            vm.listLocation=data;
          }

        function errorFetchLocation() {
            vm.listLocation=[];
          } 
 
      

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            vm.Form.objForm.listEmploye = vm.empSelected;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;
            var promise= Form.saveData('save', formController, Employeghk);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
          console.log(data);
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
                vm.timedisabled=false;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
                vm.timedisabled=true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function changeShiftType()
        {
            if(vm.Form.objForm.shifttype==='nongroup')
            {
                vm.Form.objForm.start_template='NG00-Full';
                vm.unscheduleshift=true;
            }else{
                vm.Form.objForm.start_template=null;
                vm.unscheduleshift=false;
            }
        }

        function toggleSelectedAll(state)
        {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }

            // console.log(state);
        }

        function isChecked(ls)
        {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if ( idx > -1 )
            { 
                vm.listSelected.splice(idx, 1);
            }
            else
            {
                vm.listSelected.push(ls);
            }
        }

        function getDataListEmploye()
        {
            var halfdayDate = vm.Form.objForm.halfday_date;
            
            angular.element.blockUI();
            var gedung_id = angular.toJson(vm.selectedDepartment);
            var sector_id = angular.toJson(vm.selectedSector);
            var resp=Employeghk.query({action:'getEmployelist',nik:$localStorage.user, halfday_date: halfdayDate, gedung_id: gedung_id, sector_id: sector_id });
              resp.$promise.then(function(data) {
                  vm.listselected = [];
                  vm.items = data;
                  angular.element.unblockUI();
              });
              resp.$promise.catch(function(data){
                vm.items = [];
                angular.element.unblockUI();
              });    
        }

        function getListGedung()
        {
            angular.element.blockUI();
            var resp=Employeghk.query({action:'getListGedungDepartment'});
            resp.$promise.then(function(data) {
                vm.listDepartment = data
                vm.sectorList = data

                angular.forEach(data, function(value, key) {
                    vm.selectedDepartment.push(value);
                    angular.forEach(value.sectors, function(val, k) {
                        vm.selectedSector.push(val);
                    });
                });

                angular.element.unblockUI();
            });
            resp.$promise.catch(function(data){
                vm.listDepartment = []
                angular.element.unblockUI();
            });    
        }

        function toggleDeparment (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                angular.forEach(item.sectors, function (obj,index){
                    angular.forEach(vm.selectedSector, function (objSector,idxSector){
                        if(objSector.id==obj.id){
                            vm.selectedSector.splice(idxSector, 1);
                        }
                    })
                })
                list.splice(idx, 1);
            }
            else {
                angular.forEach(item.sectors, function (obj,index){
                    vm.selectedSector.push(obj);
                })
                list.push(item);
            }
            
            getDataListEmploye();
        };

        function existsDept (item, list) {
            vm.disableSector = !(list.indexOf(item) > -1);
            return list.indexOf(item) > -1;
        };

        function AddEmployeeList()
        {
            var obj=vm.listSelected;  
            angular.forEach(obj, function (value,key) 
            { 
               var ifSelected=checkIfExistInselected(value.nik,vm.empSelected);
               if(!ifSelected){
                    var emp = {
                            nik : value.nik,
                            nik_atasan : value.nik_atasan,
                            nama : value.name,
                            status : 'Waiting Approval'
                        }
                 vm.empSelected.push(emp);
                 vm.listSelected=[];
               }
            });
            
        }

        function checkIfExistInselected(value,arrSelected)
        {
             var ifSelected=false;
             var len=arrSelected.length;
             for (var i=0;i<len;i++)
             {
                if(arrSelected[i].nik==value){
                    ifSelected=true;
                }
                // console.log(value);
                // console.log(arrSelected[i]);
             }

             return ifSelected;
        }

        function removeEmployee(ls)
        {
             var idx = vm.empSelected.indexOf(ls);
             if ( idx > -1 )
              {
                  vm.empSelected.splice(idx, 1);
              }
              // console.log(vm.empSelected);
             
             
        }

        function isStatus(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.empSelected.length > 0 ) {
                angular.forEach(vm.empSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = value.status;
                            breakEach = true
                        }
                    }
                });
            }

            return val;
 
        }
        
        function toggleSector (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
              list.splice(idx, 1);
            }
            else {
              list.push(item);
            }
            getDataListEmploye();
        };

        function existsSector (item, list) {
            return list.indexOf(item) > -1;
        };
    }
})();
(function() {
  'use strict';
  angular
    .module('app.cb.ghk-gw')
    .controller('UploadGhkGwController', UploadGhkGwController);

  UploadGhkGwController.$inject = [
    '$state',
    '$mdDialog',
    'config',
    '$localStorage',
    '$timeout',
    'AppAPI',
    'Auth',
    'FileUploader',
    '$location',
    '$window'
    
    
  ];
  /** @ngInject */
  function UploadGhkGwController(
    $state,
    $mdDialog,
    config,
    $localStorage,
    $timeout,
    AppAPI,
    Auth,
    FileUploader,
    $location,
    $window
    
  ) {
    var vm = this;

    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []
    
    vm.FileUpload = new FileUploader({
      url: config.api + 'api/ghkgw/upload',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
          action: 'upload'
      }],
      onAfterAddingAll: function() {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
      if ( status.status == 0 ) {
        vm.uploadSuccess = false;
        vm.uploadError   = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError   = false;
      }

      vm.uploadNotif = status.pesan
      if ('moreInfo' in status && status.moreInfo.length>0) {
          vm.isMoreInfo = true;
          vm.detailInfo = status.moreInfo;
      }
      
      angular.element('#uploadCutOff').val('');
      
    };

    vm.FileUpload.onErrorItem = function() {
      vm.uploadSuccess = false;
      vm.uploadError = true;
      
    };

    function closeModal()
    {
      $mdDialog.hide();
    }

    function DownloadTemplate()
    {
      var token=Auth.setTokenPromise();
        token.then(function(data){
                var protocol=$location.protocol();
                var host=$location.host();
               $window.open(protocol+'://'+host+config.api+'api/ghkgw/downloadtemplate', '_blank');
        },function(){
          
            $window.alert('gagal load token');
        });
    }

    function viewMoreInfo()
    {
      $mdDialog.show({
        controller         : 'logFailGwController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose:true,
        fullscreen: true,
        onRemoving:function(element, removePromise)
        {
            loadData(1);
        },
        locals:{
          data:vm.detailInfo
        }
      });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.ghk-gw')
        .controller('logFailGwController', logFailGwController);

    logFailGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data'];

    /* @ngInject */
    function logFailGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data) {
        var vm = this;
        
        vm.closeModal = closeModal
        vm.logFail =data;
        console.log(data);
        function closeModal()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.ghk-gw')
        .controller('GhkGwController', GhkGwController);


    GhkGwController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function GhkGwController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this; 
      vm.deleteData=deleteData;
      vm.detail = detail
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Employeghk=AppAPI.GhkGw();
      var Attendanceemploye=AppAPI.Attendanceemploye(); 
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listselected=[];
      vm.approveOT=approveOT;
      vm.InputGhk=InputGhk;
      vm.viewComment=viewComment;

      vm.exists = exists;
      vm.isIndeterminate = isIndeterminate;
      vm.toggleAll = toggleAll;
      vm.items = [];
      vm.Upload = Upload
      vm.detailApproval=detailApproval;
      vm.getPeriode=getPeriode;
      vm.searchEmployee=searchEmployee;

      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected'];

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1; 
      vm.tgl=date.getDate();
      if(vm.tgl >=25 && vm.tgl <=31)
        { 
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }
      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
         
      
      getPeriode();
        //////////
    // loadData(1);
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Employeghk,pageno,{action:'viewdata',nik:nik,periode:vm.datePeriode,workingDate:vm.workingDate});
      resp.then(function(data) {
          vm.listselected = [];
          vm.items = data.list;
      });
    }

    function getPeriode(){
      var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:'HRIS'});
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data)
    {
      vm.periode=data[0]['periode'];
      vm.datePeriode=data[0]['datePeriode'];
    }

    function errorfetchPeriode(data)
    {
      console.log('error');
      // vm.searchComplete=true;
    }
    
    function deleteData(ev) {
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Apakah anda yakin akan menghapus transaksi ini?')
            .textContent('Seluruh data pada transaksi ini akan di hapus dari system.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('Ya')
            .cancel('Tidak');

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=Employeghk.delete({action:'delete',data:angular.toJson(vm.listselected)});
                response.$promise.then( function(resData) {
                    angular.element.unblockUI();
                    if ( resData.status == 1 ) {
                      var title = 'Success Delete Data';
                      var textContent = resData.message;
                      var ariaLabel = 'Success Delete Data';
                    } else {
                      var title = 'Delete Data Failed';
                      var textContent = resData.message;
                      var ariaLabel = 'Delete Data Failed';
                    }
                    
                    showDialogMessage(title,textContent,ariaLabel);
                    loadData(1);
                });
                response.$promise.catch( function(resData) {
                    angular.element.unblockUI();
                    var title = 'Delete Data Failed';
                    var textContent = resData.message;
                    var ariaLabel = 'Delete Data Failed';
                    showDialogMessage(title,textContent,ariaLabel,ev);
                })
            }, function() {

            });
        });
    }

    function isChecked(ls)
        {
            // return vm.listselected.indexOf(ls) > -1;
            return vm.listselected.length === vm.items.length;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listselected.splice(idx, 1);
          }
          else
          {
              vm.listselected.push(ls);
          }
      }

      function toggleAll() {
        if (vm.listselected.length === vm.items.length) {
          vm.listselected = [];
        } else if (vm.listselected.length === 0 || vm.listselected.length > 0) {
          vm.listselected = vm.items.slice(0);
        }
      }

      function isIndeterminate() {
        return vm.listselected.length !== 0 && vm.listselected.length !== vm.items.length;
      }

      function approveOT(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listselected);
                var ot= new Employeghk();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;
                ot.approval_type='n1';
                var jum=vm.listselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function InputGhk(ev,id)
        {
            $mdDialog.show({
                controller         : 'CreateGhkGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-gw/create.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            }); 

        }

      function viewComment(ev,id)
      {
        $mdDialog.show({
            controller         : 'GhkGwViewRejectCommentController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-ghk-gw/comment-reject.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            { 
                // vm.listOtselected=[];
                loadData();
            },
            locals:{
              data:id
            }
        });
      }

      function exists(item, list) {
        return list.indexOf(item) > -1;
      }

      function showDialogMessage(title,textContent,ariaLabel,ev) {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              closeModal();
          });
      }

      function detail(ev, data)
      {
        $mdDialog.show({
            controller         : 'DetailGhkGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-gw/create.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{
              data:data
            }
        });
      }

      function Upload(ev) {
        $mdDialog.show({
          controller: 'UploadGhkGwController',
          controllerAs: 'vm',
          templateUrl:'app/main/cb/ghk-gw/upload.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true, // Only for -xs, -sm breakpoints.
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
        });
      }

      function detailApproval(ev, data)
      {
        $mdDialog.show({
            controller         : 'DetailApprovalListGhkGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-holiday-gw/detail-approval.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                // loadData(1);
            },
            locals:{
              data:data
            }
        });
      }

      function searchEmployee(ev)
      {
        $mdDialog.show({
            controller         : 'searchEmpGhkHolidayGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/ghk-holiday-gw/search-employee.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{  
              replacementType:'0' 
            }
        });
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.ghk-gw')
        .controller('DetailGhkGwController', DetailGhkGwController);

    DetailGhkGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data'];

    /* @ngInject */
    function DetailGhkGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.GhkGw();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;
        vm.disable=true;
        vm.edit = true;
        vm.setEdit = setEdit;
        vm.disableDate=false;
 

        vm.closeModal = closeModal;  
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();

        vm.reloadToken=reloadToken; 
        vm.changeRefshift=changeRefshift; 
        vm.unscheduleshift=false; 
        vm.Form.objForm.shifttype='group';
        vm.changeShiftType=changeShiftType;
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.exist=exist;
        vm.toggleCheck = toggleCheck;
        vm.listSelected=[];
        vm.Form.objForm.approval = data.approval;
        vm.isStatus = isStatus;
        vm.canModify = data.can_modify;
        vm.canDelete = data.can_delete;
        vm.getDataListEmploye = getDataListEmploye;
        vm.AddEmployeeList=AddEmployeeList;
        vm.removeEmployee=removeEmployee;

        vm.listDepartment = [];
        vm.selectedDepartment = [];
        vm.toggleDeparment = toggleDeparment
        vm.existsDept = existsDept
        vm.empSelected=[];

        vm.toggleSector = toggleSector
        vm.selectedSector = [];
        vm.sectorList = [];
        vm.existsSector = existsSector
        vm.disableSector = true;
        
        loadDetail(data.id);    
        setData();
        LoadLocationshift();
        getListGedung(); 



        ////////////////f

        function setSameDate(param)
        {
            if (param != '1'){
                vm.isStartSameDate = "1";
            }else{
                vm.isStartSameDate = "0";
            }
        }

        function setData()
        {
            vm.Form.objForm.working_date = new Date(data.working_date);
            vm.Form.objForm.reason = data.reason
            if ( data.dws_code == 'NG00' ) {
                vm.Form.objForm.shifttype = 'nongroup'
                vm.Form.objForm.start_time = data.start_time
                vm.Form.objForm.end_time = data.end_time
                changeShiftType();
            } else {
                vm.Form.objForm.shifttype = 'group'
                vm.Form.objForm.locationid = data.location_id
                changeRefshift(data.location_id)
                var code = data.dws_code+'-'+data.variant    
                changeShiftType(code);
            }
        }

        function changeRefshift(id)
        { 
            if(id==0){
                vm.unscheduleshift=true;
                vm.Form.objForm.start_template='NG00-Full';
            }else{
                vm.listLocationdetail=[];
                var resp=Employeghk.query({action:'getDetailshift',id:id})
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            } 
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function LoadLocationshift() {
            var response=Employeghk.query({action:'getLocationshift',nik:$localStorage.user});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

        function fetchLocation(data) {
            vm.listLocation=data;
        }

        function errorFetchLocation() {
            vm.listLocation=[];
        } 
 
      

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            vm.disable=true;
            vm.Form.objForm.listEmploye = vm.empSelected;
            vm.Form.objForm.id = data.id;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;

            var promise= Form.saveData('update', formController, Employeghk);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
          // console.log(data);
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
                vm.timedisabled=false;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
                vm.timedisabled=true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function changeShiftType(code)
        {
            if(vm.Form.objForm.shifttype==='nongroup')
            {
                vm.Form.objForm.start_template='NG00-Full';
                vm.unscheduleshift=true;
            }else{
                vm.Form.objForm.start_template=code;
                vm.unscheduleshift=false;
            }
        }

        function toggleSelectedAll(state)
        {
            // switch(state)
            // {
            //     case true:
            //     checkAll();
            //     break;
            //     case false:
            //     unCheckAll();
            //     break;
            // }

            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }

            // console.log(state);
        }

        function checkAll() {
           vm.listSelected=angular.copy(vm.listemploye);
        }

        function unCheckAll() {
           vm.listSelected=[];
        }

        function isChecked(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = true;
                            breakEach = true

                        }
                    }
                });
            }

            return val;
        }

        function isStatus(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.empSelected.length > 0 ) {
                angular.forEach(vm.empSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = value.status1;
                            breakEach = true
                        }
                    }
                });
            }
            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event)
        {

            if ( event )
            {
                event.stopPropagation();
            }

            var arrTemp = []
            var exist = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    
                        if ( value.nik != ls.nik ) {
                            
                            // arrTemp.push(ls)
                            arrTemp.push(value)
                        } else {
                            exist = true
                        }    
                    
                    
                });
                if ( !exist ) {
                    arrTemp.push(ls)
                }
            } else {
                arrTemp.push(ls)
            }


            vm.listSelected = arrTemp
            // console.log(vm.listSelected);
            // var idx = vm.listSelected.indexOf(ls);

            // if ( idx > -1 )
            // { 
            //     vm.listSelected.splice(idx, 1);
            // }
            // else
            // {
            //     vm.listSelected.push(ls);
            // }
        }

        // function getDataListEmploye(pageno)
        // {

        //     var resp=vm.DataTable.loadData(Employeghk,pageno,{action:'getEmployelist',nik:$localStorage.user});
        //       resp.then(function(data) {
        //           vm.listselected = [];
        //           vm.items = data.list;
        //       });

        // }

        function loadDetail(id)
        { 
            var response= Employeghk.query({action:'getDetailGhk',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) 
        {
            var idToDelete=[]; 
            angular.forEach(data, function(value, key) {
                var emp = {
                    nik : value.nik,
                    nik_atasan : value.nik_atasan,
                    nama : value.nama,
                    status : value.status
                }
                // vm.listSelected.push(value);
                vm.empSelected.push(value); 
                if(value.deleteStatus==1){
                    idToDelete.push(value.id); 
                }
                if(value.approvalStatus1=='1')
                {
                    vm.disableDate=true;
                }
                              
            });
            vm.Form.objForm.idToDelete=idToDelete;

            // console.log(vm.empSelected);
        }

        function errorFetchDetail() {
            vm.listSelected = [];
            getDataListEmploye(1);
        }

        function setEdit (status)
        {
            // console.log(status);
            vm.disable = status;
        }

        function getDataListEmploye()
        {
            // if ( vm.canModify == '0' ) {
            //     vm.items = vm.listSelected
            // } else {
                angular.element.blockUI();
                var workingDate = vm.Form.objForm.working_date;
                var holidayDate = ''; 
                var gedung_id = angular.toJson(vm.selectedDepartment);
                var sector_id = angular.toJson(vm.selectedSector);
                var resp=Employeghk.query({action:'getEmployelist',nik:$localStorage.user, working_date: workingDate, holiday_date: holidayDate, gedung_id: gedung_id, sector_id: sector_id });
                  resp.$promise.then(function(data) {
                      vm.listselected = [];
                      vm.items = data;
                      angular.element.unblockUI();
                  });
                  resp.$promise.catch(function(data){
                    vm.items = [];
                    angular.element.unblockUI();
                  });    
            // }
            
        }

        function getListGedung()
        {
            var resp=Employeghk.query({action:'getListGedungDepartment'});
            resp.$promise.then(function(data) {
                vm.listDepartment = data
                vm.sectorList = data

                angular.forEach(data, function(value, key) {
                    vm.selectedDepartment.push(value);
                    angular.forEach(value.sectors, function(val, k) {
                        vm.selectedSector.push(val);
                    });
                  // toggleDeparment (value, vm.selectedDepartment);
                });
                getDataListEmploye();
        
            });
            resp.$promise.catch(function(data){
                vm.listDepartment = []
            });    
        }

        function toggleDeparment (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                angular.forEach(item.sectors, function (obj,index){
                    angular.forEach(vm.selectedSector, function (objSector,idxSector){
                        if(objSector.id==obj.id){
                            vm.selectedSector.splice(idxSector, 1);
                        }
                    })
                })
                list.splice(idx, 1);
            }
            else {
                angular.forEach(item.sectors, function (obj,index){
                    vm.selectedSector.push(obj);
                })
                list.push(item);
            }

            getDataListEmploye();
        };

        function existsDept (item, list) {
            return list.indexOf(item) > -1;
        };
        

        function AddEmployeeList()
        {
            var obj=vm.listSelected;
            angular.forEach(obj, function (value,key) 
            {
                // console.log(value);
               var ifSelected=checkIfExistInselected(value.nik,vm.empSelected);
               if(!ifSelected){
                    var emp = {
                            nik : value.nik,
                            nik_atasan : value.nik_atasan,
                            nama : value.name,
                            status1 : 'Waiting Approval',
                            approvalStatus1:null,
                            approvalStatus2:null
                        }
                 vm.empSelected.push(emp);
                 vm.listSelected=[];
               }
            }); 
            
        }

        function checkIfExistInselected(value,arrSelected)
        {
             var ifSelected=false;
             var len=arrSelected.length;
             for (var i=0;i<len;i++)
             {
                if(arrSelected[i].nik==value){
                    ifSelected=true;
                }
                // console.log(value);
                // console.log(arrSelected[i]);
             }

             return ifSelected;
        }

        function removeEmployee(ls)
        {
             var idx = vm.empSelected.indexOf(ls);
             if ( idx > -1 )
              {
                  vm.empSelected.splice(idx, 1);
              }
              // console.log(vm.empSelected);
             
             
        }

        function toggleSector (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
              list.splice(idx, 1);
            }
            else {
              list.push(item);
            }
            getDataListEmploye();
        };
        
        function existsSector (item, list) {
            return list.indexOf(item) > -1;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.ghk-gw')
        .controller('DetailApprovalListGhkGwController', DetailApprovalListGhkGwController);

    DetailApprovalListGhkGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data'];

    /* @ngInject */
    function DetailApprovalListGhkGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data) {
        var vm = this; 

        var Employeghk = AppAPI.GhkGw(); 
        vm.closeModal=closeModal;
          
        loadDetail(data.id); 

        function closeModal()
        {
            $mdDialog.hide();
        }   

        function loadDetail(id)
        {
            var response= Employeghk.query({action:'getDetailGhk',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {
            vm.items = data;
        }

        function errorFetchDetail() {
            vm.items = [];
        }   
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.ghk-gw')
        .controller('CreateGhkGwController', CreateGhkGwController);

    CreateGhkGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast'];

    /* @ngInject */
    function CreateGhkGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.GhkGw();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;
        vm.disable = false;
        vm.edit = false;
 

        vm.closeModal = closeModal;  

        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();

        vm.reloadToken=reloadToken; 
        vm.changeRefshift=changeRefshift; 
        
        vm.unscheduleshift=false; 
        vm.Form.objForm.shifttype='group';
        vm.changeShiftType=changeShiftType;
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listSelected=[];
        vm.canModify = vm.canDelete = 1;
        vm.getDataListEmploye = getDataListEmploye;
        vm.AddEmployeeList=AddEmployeeList;
        vm.removeEmployee=removeEmployee;
        
        vm.listDepartment = [];
        vm.selectedDepartment = [];
        vm.toggleDeparment = toggleDeparment
        vm.existsDept = existsDept
        vm.toggleSector = toggleSector
        vm.selectedSector = [];
        vm.sectorList = [];
        vm.existsSector = existsSector
        vm.checkIfExistInselected=checkIfExistInselected;
        vm.empSelected=[];
        vm.isStatus=isStatus;
        vm.disableSector = false;
        
        LoadLocationshift();
        getListGedung();
        // getDataListEmploye(1);

        vm.setSameDate = setSameDate;
        vm.isStartSameDate = "1";

        function setSameDate(param)
        {
            if (param != '1'){
                vm.isStartSameDate = "1";
            }else{
                vm.isStartSameDate = "0";
            }
        }

        function changeRefshift(id)
        { 
            if(id==0){
                vm.unscheduleshift=true;
                vm.Form.objForm.start_template='NG00-Full';
            }else{
                vm.listLocationdetail=[];
                var resp=Employeghk.query({action:'getDetailshift',id:id})
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            } 
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function LoadLocationshift() {
            var response=Employeghk.query({action:'getLocationshift',nik:$localStorage.user});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
        }

        function fetchLocation(data) {
            vm.listLocation=data;
        }

        function errorFetchLocation() {
            vm.listLocation=[];
        } 
 
      

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            vm.Form.objForm.listEmploye = vm.empSelected;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;

            var promise= Form.saveData('save', formController, Employeghk);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
          console.log(data);
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
                vm.timedisabled=false;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
                vm.timedisabled=true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function changeShiftType()
        {
            if(vm.Form.objForm.shifttype==='nongroup')
            {
                vm.Form.objForm.start_template='NG00-Full';
                vm.unscheduleshift=true;
            }else{
                vm.Form.objForm.start_template=null;
                vm.unscheduleshift=false;
            }
        }

        function toggleSelectedAll(state)
        {

            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }

            // switch(state)
            // {
            //     case true:
            //     checkAll();
            //     break;
            //     case false:
            //     unCheckAll();
            //     break;
            // }

            // console.log(state);
        }

        // function checkAll() {
        //    vm.listSelected=angular.copy(vm.items);
        // }

        // function unCheckAll() {
        //    vm.listSelected=[];
        // }

        function isChecked(ls)
        {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if ( idx > -1 )
            { 
                vm.listSelected.splice(idx, 1);
            }
            else
            {
                vm.listSelected.push(ls);
            }
        }

        function getDataListEmploye()
        {
            angular.element.blockUI();
            var workingDate = vm.Form.objForm.working_date;
            var holidayDate = ''; 
            var gedung_id = angular.toJson(vm.selectedDepartment);
            var sector_id = angular.toJson(vm.selectedSector);
            var resp=Employeghk.query({action:'getEmployelist',nik:$localStorage.user, working_date: workingDate, holiday_date: holidayDate, gedung_id: gedung_id, sector_id: sector_id });
              resp.$promise.then(function(data) {
                  vm.listselected = [];
                  vm.items = data;
                  var jum=vm.items.length;
                  for(var i=0;i<jum;i++)
                  {
                    vm.items[i].status='Waiting Approval';
                  }
                  angular.element.unblockUI();
              });
              resp.$promise.catch(function(data){
                vm.items = [];
                angular.element.unblockUI();
              });    
        }

        function getListGedung()
        {
            angular.element.blockUI();
            var resp=Employeghk.query({action:'getListGedungDepartment'});
            resp.$promise.then(function(data) {
                vm.listDepartment = data
                vm.sectorList = data

                angular.forEach(data, function(value, key) {
                    vm.selectedDepartment.push(value);
                    angular.forEach(value.sectors, function(val, k) {
                        vm.selectedSector.push(val);
                    }); 
                });

                angular.element.unblockUI();
            });
            resp.$promise.catch(function(data){
                vm.listDepartment = []
                angular.element.unblockUI();
            });    
        }

        function toggleDeparment (item, list) {
            var idx = list.indexOf(item);
            
            if (idx > -1) {
                angular.forEach(item.sectors, function (obj,index){
                    angular.forEach(vm.selectedSector, function (objSector,idxSector){
                        if(objSector.id==obj.id){
                            vm.selectedSector.splice(idxSector, 1);
                        }
                    })
                })
                list.splice(idx, 1);
            }
            else {
                angular.forEach(item.sectors, function (obj,index){
                    vm.selectedSector.push(obj);
                })
                list.push(item);
            }
            getDataListEmploye();
        };
        
        function toggleSector (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
              list.splice(idx, 1);
            }
            else {
              list.push(item);
            }
            getDataListEmploye();
        };

        function existsDept (item, list) {
            vm.disableSector = !(list.indexOf(item) > -1);
            return list.indexOf(item) > -1;
        };
        
        function existsSector (item, list) {
            return list.indexOf(item) > -1;
        };


        function AddEmployeeList()
        {
            var obj=vm.listSelected;  
            angular.forEach(obj, function (value,key) 
            { 
               var ifSelected=checkIfExistInselected(value.nik,vm.empSelected);
               if(!ifSelected){
                    var emp = {
                            nik : value.nik,
                            nik_atasan : value.nik_atasan,
                            nama : value.name,
                            status : 'Waiting Approval'
                        }
                 vm.empSelected.push(emp);
                 vm.listSelected=[];
               }
            });
            
        }

        function checkIfExistInselected(value,arrSelected)
        {
             var ifSelected=false;
             var len=arrSelected.length;
             for (var i=0;i<len;i++)
             {
                if(arrSelected[i].nik==value){
                    ifSelected=true;
                }
                // console.log(value);
                // console.log(arrSelected[i]);
             }

             return ifSelected;
        }

        function removeEmployee(ls)
        {
             var idx = vm.empSelected.indexOf(ls);
             if ( idx > -1 )
              {
                  vm.empSelected.splice(idx, 1);
              }
              // console.log(vm.empSelected);
             
             
        }

        function isStatus(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.empSelected.length > 0 ) {
                angular.forEach(vm.empSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = value.status;
                            breakEach = true
                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-shift-template', [
        ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
      // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-shift');

        // State
        $stateProvider
        .state('app.cb_employee_shift_template', {
            url    : '/cb/employee-shift-template',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/cb/employee-shift-template/employee-shift-template.html',
                    controller : 'EmployeshiftTemplateController as vm'
                }
            }
        });

        
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.employe-shift-template')
        .controller('UploadshiftTemplateController', UploadshiftTemplateController);

    UploadshiftTemplateController.$inject = ['$mdDialog','$localStorage','FileUploader','config','AppAPI','Auth','$location','$window'];

    /* @ngInject */
    function UploadshiftTemplateController($mdDialog,$localStorage,FileUploader,config,AppAPI,Auth,$location,$window) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        var Employeshifttemplate = AppAPI.Employeshifttemplate();
        vm.getDetailShift=getDetailShift;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.DownloadTemplate = DownloadTemplate;
        LoadLocation();
        ////////////////

       function LoadLocation() {
            var response=Employeshifttemplate.query({action:'getLocation'});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

          function fetchLocation(data) {
            vm.listLocation=data;
          }

        function errorFetchLocation() {
            vm.listLocation=[];
          }

        var uploaderPhoto= vm.FileUpload= new FileUploader({
           url:config.api+'api/employeshifttemplate/uploadshifttemplate', 
           removeAfterUpload:true,
           alias:'fileshift',
           formData:[
              {
               action:'uploadshifttemplate'
              }
           ],
            onAfterAddingAll:function(){
                vm.uploadSuccess = false;
                vm.uploadError = false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item, status) {
            if ( status.status == 0 ) {
                vm.uploadSuccess = false;
                vm.uploadError   = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError   = false;
            }

            vm.uploadNotif = status.message
            if ('moreInfo' in status && status.moreInfo.length>0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
            vm.uploadSuccess = false;
            vm.uploadError = true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        } 

        function getDetailShift(id)
        { 
            // console.log(id);
            vm.listLocationdetail=[];
            var resp=Employeshifttemplate.query({action:'getDetailshift',id:id})
            resp.$promise.then(fetchdetailshift);
            resp.$promise.catch(errorfetchdetailshift);
           
          
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function viewMoreInfo()
        {
            $mdDialog.show({
                controller         : 'logFailGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                data:vm.detailInfo
                }
            });
        }

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/employeshifttemplate/downloadshifttemplate', '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-shift-template')
        .controller('EmployeshiftTemplateController', EmployeshiftTemplateController);


    EmployeshiftTemplateController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function EmployeshiftTemplateController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {

        var vm = this;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.editData=editData;
        vm.toggleSelectedAll=toggleSelectedAll;
        var Employeshifttemplate=AppAPI.Employeshifttemplate();
        vm.inputShiftLocation= inputShiftLocation;
        vm.lisShiftSelected=[];
        vm.DeleteShiftlocation=DeleteData;
        vm.uploadShift=uploadShift;
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;
        var Employeshiftt=AppAPI.Overtime();
        vm.company=$localStorage.empsite;
        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
                    {link:'#',name:'C&B / ',active:'0'}
                    ];
         loadData(1);
        
         vm.listselected = [];
         vm.items = [];
         vm.isChecked=isChecked;
         vm.isIndeterminate = isIndeterminate
         vm.exists = exists
         vm.toggleCheck = toggleCheck;
         vm.Delete = Delete;
        
        function isChecked(ls)
        {
            return vm.listselected.length === vm.items.length;
        }
        function isIndeterminate() {
          return vm.listselected.length !== 0 && vm.listselected.length !== vm.items.length;
        }
        function exists(item, list) {
          return list.indexOf(item) > -1;
        }
        function toggleCheck(ls, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listselected.indexOf(ls);

            if ( idx > -1 )
            {
                vm.listselected.splice(idx, 1);
            }
            else
            {
                vm.listselected.push(ls);
            }
        }

        function Reject(ev)
      {
        var jum=vm.listselected.length,i,ids=[];
        if(jum>0){
          $mdDialog.show({
              controller         : 'GhkHolidayGwRejectCommentController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/cb/approval-ghk-holiday-gw/comment-reject.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData();
                  vm.listselected=[];
              },
              locals:{
                id:vm.listselected
              }
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }
      
      function Delete(ev)
      {
        var jum=vm.listselected.length,i,ids=[];
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to Delete this list?')
            .textContent('All data your selected will be delete.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
            $mdDialog.show({
              multiple: true
            });      
            $mdDialog.show(confirm).then(function() {
              angular.element.blockUI();
              var Attributes= new Employeshifttemplate();
              Attributes.data=[];
              Attributes.action='delete'; 
              for (i=0;i<jum;i++) {
                Attributes.data.push({id:vm.listselected[i].id});
              }
              console.log(Attributes.data);
              var idtx=encodeURIComponent(angular.toJson(ids));
              var response=Attributes.$save(); 
              response.then(function(data){
                  successApproved(ev,data);
                  angular.element.unblockUI();
                  vm.listselected=[];
              });
              response.catch(function(data){
                failedApproved(ev,data.data);
                angular.element.unblockUI();
                vm.listselected=[];
              });
            }, function() {
            
            });
        }); 
      }
      function successApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success')
          .textContent(data.message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }
      function failedApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }
        function inputShiftLocation(ev,id)
        {
            $mdDialog.show({
                controller         : 'InputempshiftController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/employe-shift/input-employe-shift.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            });

        }
        loadDataBU();
        loadDataDivision(vm.company);
        //////////

        // function loadData()
        // {
        //   var resp=Employeshifttemplate.query({action:'viewdata'});
        //       resp.$promise.then(function(data){
        //         vm.listData=data[0];
        //         console.log(vm.listData);
        //         angular.element.unblockUI();
        //       });
        //       resp.$promise.catch(function(data){
        //         $log.info(data);
        //         angular.element.unblockUI();
        //       });
        // }

        function loadData(pageno)
          {
            var resp=vm.DataTable.loadData(Employeshifttemplate,pageno,{action:'viewdata',company:vm.company,divisi:vm.divisi,departement:vm.department,start_date:vm.start_date,end_date:vm.end_date});
            resp.then(function(data){
              vm.items = data.list;
              vm.listselected=[];
             });
          }

        function toggleSelectedAll(state)
        {
          if (vm.listselected.length === vm.items.length) {
            vm.listselected = [];
          } else if (vm.listselected.length === 0 || vm.listselected.length > 0) {
            vm.listselected = vm.items.slice(0);
          }
        }

         function checkAll() {
             vm.lisShiftSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.lisShiftSelected=[];
          }
        function editData(id){
          $state.go('app.utility_modul_edit-modul',{id:id});
        }


        function closeModal()
        {
            $mdDialog.hide();
        }

    function DeleteData(ev) {
          var promise=Auth.setToken();
         promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data your selected will be deleted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

      $mdDialog.show(confirm).then(function() {
          angular.element.blockUI();
         var response=Employeshift.delete({action:'delete',data:angular.toJson(vm.lisShiftSelected)});

         response.$promise.then(loadData);
      }, function() {
       // $scope.status = 'You decided to keep your debt.';
      });
         });


      }

    function uploadShift(ev) {
      $mdDialog.show({
          controller         : 'UploadshiftTemplateController as vm',
          templateUrl        : 'app/main/cb/employee-shift-template/upload-shift-template.html',
          parent             : angular.element($document.body),
          targetEvent        : ev,
          clickOutsideToClose: true
      });
    }

    function loadDataDepartment(iddivisi) {
       var response=Employeshiftt.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment=data;
      // loadData(1);
    }

    function errorDepartment() {
      vm.listDepartment=[];
    }

    function loadDataDivision(idbu) {
       var response=Employeshiftt.query({action:'viewDivisiBu',idbu:idbu});
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
     vm.listDivision=data;
     // loadData(1);
    }

    function errorDivisiBU() {
      vm.listDivision=[];
    }

    function loadDataBU() {
      var response=Employeshiftt.query({action:'viewBu'});
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU=data;
    }

    function errorFetchBU() {
      vm.listBU=[];
    }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.leave-balance')
        .controller('EmployeeLeaveBalanceController', EmployeeLeaveBalanceController);


    EmployeeLeaveBalanceController.$inject = ['$state', '$window', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', 'config', '$location'];
    /** @ngInject */
    function EmployeeLeaveBalanceController($state, $window, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, config, $location) {

        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        var Leavebalanceemp = AppAPI.Leavebalanceemp();
        var Leavereport = AppAPI.Leavereport();
        var nik = $localStorage.user;
        vm.viewAnnuaLeaveLog = viewAnnuaLeaveLog;
        vm.viewSubsLeaveLog = viewSubsLeaveLog;
        vm.viewHoldLeaveLog = viewHoldLeaveLog;
        vm.ExportToExcel = ExportToExcel;

        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.company = $localStorage.empsite;
        vm.listtahun = [2017, 2018, 2019, 2020, 2021];
        vm.emp_nik = null;

        vm.divisiProses = false;
        vm.departmentProses = false;

        vm.onCollapse = onCollapse;

        loadDataBU();
        // getPeriode();
        ////////// 
        // function getPeriode(){
        //     var res=Leavereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
        //     res.$promise.then(fetchPeriode);
        //     res.$promise.catch(errorfetchPeriode);
        //   }
        // function fetchPeriode(data)
        //   {
        //     vm.periode=data[0]['periode']; 
        //   }

        //   function errorfetchPeriode(data)
        //   {
        //     console.log('error');
        //   }

        function loadData() {
            // console.log(vm.emp_nik);
            //angular.element('#attView').block({message:'please wait..'});
            angular.element.blockUI();
            var company = vm.company;
            var divisi = vm.divisi;
            var department = vm.department;
            var nik = vm.DataTable.searchParam;
            // console.log(company+' / '+divisi+' / '+department+' / '+tahun);s
            // if(nik) {
            var response = Leavebalanceemp.query({
                action: 'viewData',
                company: company,
                divisi: divisi,
                department: department,
                nik: nik
            });
            response.$promise.then(fetchData);
            response.$promise.catch(errorData);
            // } else {
            // errorData();
            // }
        }

        function fetchData(data) {
            vm.listData = data;
            // loadData(1);
            //angular.element('#attView').unblock();
            angular.element.unblockUI();
        }

        function errorData() {
            vm.listData = [];
            //angular.element('#attView').unblock();
            angular.element.unblockUI();
        }

        function loadDataDepartment(iddivisi) {
            angular.element.blockUI();
            vm.departmentProses = true;
            var response = Leavereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            vm.departmentProses = false;
            // loadData(1);
            angular.element.unblockUI();
        }

        function errorDepartment() {
            vm.listDepartment = [];
            angular.element.unblockUI();
        }

        function loadDataDivision(idbu) {
            angular.element.blockUI();
            vm.divisiProses = true;
            var response = Leavereport.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            vm.divisiProses = false;
            // loadData(1);
            vm.divisi = data[0].id;
            vm.loadDataDepartment(vm.divisi);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
            vm.divisiProses = false;
            angular.element.unblockUI();
        }

        function loadDataBU() {
            angular.element.blockUI();
            var response = Leavereport.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
            loadDataDivision(vm.company);
        }

        function errorFetchBU() {
            vm.listBU = [];
            angular.element.unblockUI();
        }

        function viewAnnuaLeaveLog(ls, ev) {
            $mdDialog.show({
                controller: 'viewAnnualLeaveLogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/leave-balance/view-annualleave-log.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: ls
                }
            });
        }

        function viewSubsLeaveLog(ls, ev) {
            $mdDialog.show({
                controller: 'viewSubsLeaveLogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/leave-balance/view-subsleave-log.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: ls
                }
            });
        }

        function viewHoldLeaveLog(ls, ev) {
            $mdDialog.show({
                controller: 'viewHoldLeaveLogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/leave-balance/view-holdleave-log.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: ls
                }
            });
        }

        function ExportToExcel() {
            var company = vm.company;
            var divisi = vm.divisi;
            var department = vm.department;
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/leavebalanceemp/exportexcel/' + company + '/' + divisi + '/' + department, '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }

        function onCollapse() {
            if (vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
                vm.DataTable.searchParam = '';
                vm.loadData(1);
            }
        }

        vm.classChanger = function (data) {
            return data % 2 == 0 ? 'odd-class' : 'even-class';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.employee-certificates')
        .controller('EmployeeCertificatesController', EmployeeCertificatesController);


    EmployeeCertificatesController.$inject = ['$state', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', '$filter', 'FileUploader', 'config', '$localStorage', '$location', '$window'];
    /** @ngInject */
    function EmployeeCertificatesController($state, $log, $mdDialog, AppAPI, Auth, DataService, $filter, FileUploader, config, $localStorage, $location, $window) {
        var vm = this;
        var Certificate = AppAPI.Certificate(); //memanggil api modules dari api
        var Certificateprograms = AppAPI.Certificateprograms(); //memanggil api modules dari api
        var Certificateclassrooms = AppAPI.Certificateclassrooms(); //memanggil api modules dari api

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.checkAll = checkAll;
        vm.unCheckAll = unCheckAll;
        vm.deleteData = deleteData;

        vm.isChecked = isChecked;
        vm.isCheckedAll = isCheckedAll;
        vm.toggleCheck = toggleCheck;
        vm.isIndeterminate = isIndeterminate;

        vm.listCertificateSelected = [];

        vm.type = 'All';
        vm.listType = ['Waiting Approval', 'Approved', 'Rejected', 'All'];

        vm.openInput = openInput;
        vm.editInput = editInput;

        vm.country = 'all';
        vm.program = '';
        vm.closeModal = closeModal;

        vm.clearSearchTermCountry = clearSearchTermCountry;
        vm.clearSearchTermPrograms = clearSearchTermPrograms;
        vm.clearSearchTermConfiguration = clearSearchTermConfiguration;

        vm.searchTermCountry = '';
        vm.searchTermPrograms = '';
        vm.searchTermConfiguration = '';

        vm.listcountry = [];
        vm.listPrograms = [];

        vm.Upload = Upload;
        vm.uploadDialog = uploadDialog;
        vm.DownloadTemplate = DownloadTemplate;
        vm.DownloadReportForm = DownloadReportForm;
        vm.DownloadReport = DownloadReport;
        vm.tglmulai = null;
        vm.tglakhir = null;
        vm.listClassrooms = [];

        vm.viewDetail = viewDetail;
        vm.viewDetailComponents = viewDetailComponents;

        vm.LoadClassrooms = LoadClassrooms;

        vm.onCollapse = onCollapse;
        vm.viewComment = viewComment;

        var translate = $filter('translate');

        // Data
        loadData(1);
        LoadCountry();
        LoadPrograms();
        // Methods

        ////////// 

        function loadData(pageno) {
            angular.element.blockUI();

            var tglmulai = '';
            var tglakhir = '';
            if (vm.tglmulai) {
                tglmulai = changeDateFormat(vm.tglmulai);
            }

            if (vm.tglakhir) {
                tglakhir = changeDateFormat(vm.tglakhir);
            }

            var resp = vm.DataTable.loadData(Certificate, pageno, {
                action: 'viewData',
                type: vm.type,
                country: vm.country,
                idProgram: vm.program,
                startDate: tglmulai,
                endDate: tglakhir
            });

            resp.then(function () {
                vm.listCertificateSelected = [];
                angular.element.unblockUI();
            });
        }

        function changeDateFormat(date) {
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var year = date.getFullYear();
            return year + "-" + month + "-" + day;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listCertificateSelected.indexOf(ls);

            if (idx > -1) {
                vm.listCertificateSelected.splice(idx, 1);
            } else {
                if (ls.approval_status <= '1') {
                    vm.listCertificateSelected.push(ls);
                }
            }
        }

        function toggleSelectedAll(state) {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    if (vm.DataTable.list[i].approval_status <= '1') {
                        countCheckAvail++;
                    }
                }
                if (vm.listCertificateSelected.length === countCheckAvail) {
                    unCheckAll();
                } else if (
                    vm.listCertificateSelected.length === 0 ||
                    vm.listCertificateSelected.length > 0
                ) {
                    checkAll();
                }
            } else {
                return false;
            }
        }

        function checkAll() {
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.listCertificateSelected.indexOf(vm.DataTable.list[i]) < 0) {
                    if (vm.DataTable.list[i].approval_status <= '1') {
                        vm.listCertificateSelected.push(vm.DataTable.list[i]);
                    }
                }
            }
        }

        function unCheckAll() {
            vm.listCertificateSelected = [];
        }

        function isChecked(ls) {
            return vm.listCertificateSelected.indexOf(ls) > -1;
        }

        function isCheckedAll() {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    if (vm.DataTable.list[i].approval_status <= '1') {
                        countCheckAvail++;
                    }
                }
                return vm.listCertificateSelected.length === countCheckAvail && vm.listCertificateSelected.length > 0;
            } else {
                return false;
            }
        }

        function isIndeterminate() {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    if (vm.DataTable.list[i].approval_status <= '1') {
                        countCheckAvail++;
                    }
                }
                return (
                    vm.listCertificateSelected.length > 0 &&
                    vm.listCertificateSelected.length !== countCheckAvail
                );
            } else {
                return false;
            }
        }

        function openInput(ev) {
            $mdDialog.show({
                controller: 'InputEmployeeCertificatesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/employee-certificates/input-employee-certificates/input-employee-certificates.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: false
                }
            });
        }

        function editInput(ev, id) {
            $mdDialog.show({
                controller: 'InputEmployeeCertificatesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/employee-certificates/input-employee-certificates/input-employee-certificates.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function deleteData(ev) {

            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Certificate.delete({
                        action: 'deleteData',
                        data: angular.toJson(vm.listCertificateSelected)
                    });

                    response.$promise.then(function (resp) {
                        loadData(1);
                        angular.element.unblockUI();

                        var Message = translate(resp.pesan);
                        var Status = translate(resp.status);

                        $mdDialog
                            .show(
                                $mdDialog
                                .alert()
                                .parent(angular.element(document.querySelector('#contentDialog')))
                                .clickOutsideToClose(true)
                                .title(Status)
                                .textContent(Message)
                                .ariaLabel(Status)
                                .ok('OK')
                                .targetEvent(ev)
                            )
                            .then(function () {
                                angular.element.unblockUI();
                            });

                    });
                }, function () {

                });
            });
        }

        function LoadCountry() {
            var response = Certificateprograms.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function clearSearchTermCountry() {
            vm.searchTermCountry = '';
        };

        function LoadPrograms() {
            var response = Certificateprograms.query({
                action: 'getPrograms',
                country: vm.country
            });
            response.$promise.then(fetchPrograms);
            response.$promise.catch(errorFetchPrograms);
        }

        function fetchPrograms(data) {
            vm.listPrograms = data;
        }

        function errorFetchPrograms() {
            vm.listPrograms = [];
        }

        function clearSearchTermPrograms() {
            vm.searchTermPrograms = '';
        };

        function clearSearchTermConfiguration() {
            vm.searchTermConfiguration = '';
        };

        var uploaderPhoto = vm.FileUpload = new FileUploader({
            url: config.api + 'api/certificate/uploadData',
            removeAfterUpload: true,
            alias: 'filenikkepesertaan',
            formData: [{
                action: 'uploadData'
            }],
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        function uploadDialog(ev) {
            $mdDialog.show({
                controller: 'EmployeeCertificatesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/employee-certificates/employee-certificates-upload.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: false
                }
            });
        }

        vm.FileUpload.onSuccessItem = function (item, status) {
            if (status.status == 0) {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }

            vm.uploadNotif = translate(status.message);
            if ('moreInfo' in status && status.moreInfo.length > 0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }
            angular.element('#uploaderPhoto').val('');

            angular.element.unblockUI();
        };

        function Upload() {
            angular.element.blockUI();

            vm.FileUpload.uploadAll();
        }

        uploaderPhoto.onErrorItem = function () {
            vm.uploadSuccess = false;
            vm.uploadError = true;
            angular.element.unblockUI();
        };

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/certificate/downloadtemplate', '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }

        function viewDetailComponents(ev, ls) {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/certificate/viewpdf/' + ls.nik + '/' + ls.code_class + '/' + $localStorage.tokenAuth + '/' + ls.nik + '-' + ls.code_class, '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function viewDetail(ev, data) {
            angular.element.blockUI();
            var response = Certificate.query({
                action: 'viewDetail',
                id: data.id
            });
            response.$promise.then(function (detail) {
                $mdDialog.show({
                    controller: ['data', 'closeModal', function (data, closeModal) {
                        var vm1 = this;
                        vm1.data = data;
                        console.log(data);
                        vm1.closeModal = closeModal;
                        vm1.certificateResolve = function (data) {
                            return data ? data : 'Not Available';
                        };
                    }],
                    controllerAs: 'vm1',
                    templateUrl: 'app/main/cb/employee-certificates/employee-certificates-detail.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        // loadData(1);
                    },
                    locals: {
                        data: detail[0],
                        closeModal: closeModal
                    }
                });

                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                $mdDialog
                    .show(
                        $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Failed')
                        .textContent('Failed Get Detail')
                        .ariaLabel('Failed')
                        .ok('OK')
                        .targetEvent(ev)
                    );

                angular.element.unblockUI();
            });
        }

        function onCollapse() {
            if (vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
                vm.DataTable.searchParam = '';
                vm.loadData(1);
            }
        }

        function DownloadReportForm(ev) {
            $mdDialog.show({
                controller: 'EmployeeCertificatesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/employee-certificates/employee-certificates-report.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function DownloadReport(ev, formController) {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/certificate/downloadreport/' + formController.tglmulai.$viewValue + '/' + formController.tglakhir.$viewValue + '/' + formController.configuration.$viewValue, '_blank');
            }, function () {
                $window.alert('gagal load token');
            });
        }

        function LoadClassrooms(idProgram) {
            angular.element.blockUI();
            vm.listClassrooms = [];

            var response = Certificateclassrooms.query({
                action: 'getClassrooms',
                id_program: idProgram
            });
            response.$promise.then(fetchClassrooms);
            response.$promise.catch(errorFetchClassrooms);
        }

        function fetchClassrooms(data) {
            vm.listClassrooms = data;
            angular.element.unblockUI();
        }

        function errorFetchClassrooms() {
            vm.listClassrooms = [];
            angular.element.unblockUI();
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'CertificateViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/approval-absence/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listOtselected = [];
                },
                locals: {
                    id: id
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employee-certificates')
        .controller('EmployeeCertificatesProgramsController', EmployeeCertificatesProgramsController);


    EmployeeCertificatesProgramsController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService','$filter'];
    /** @ngInject */
    function EmployeeCertificatesProgramsController($state,$log,$mdDialog,AppAPI,Auth,DataService,$filter)
    {
      var vm = this;
      var Certificateprograms = AppAPI.Certificateprograms(); //memanggil api modules dari api

      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData;
      vm.toggleSelectedAll=toggleSelectedAll;
      vm.checkAll=checkAll;
      vm.unCheckAll=unCheckAll;
      vm.deleteData=deleteData;

      vm.isChecked = isChecked;
      vm.isCheckedAll = isCheckedAll;
      vm.toggleCheck = toggleCheck;
      vm.isIndeterminate = isIndeterminate;

      vm.listProgramsSelected=[];

      vm.openInputPrograms = openInputPrograms;
      vm.editInputPrograms = editInputPrograms;
      
      vm.country = 'all';

      vm.clearSearchTermCountry = clearSearchTermCountry;

      vm.searchTermCountry = '';

      vm.listcountry = [];

      vm.onCollapse=onCollapse;

      var translate = $filter('translate');

      loadData(1);
      LoadCountry();

      function loadData(pageno) {
        angular.element.blockUI();
        var resp=vm.DataTable.loadData(Certificateprograms,pageno,{action:'viewData', country: vm.country});

        resp.then(function(){
          vm.listProgramsSelected=[];          
          angular.element.unblockUI();
        });
      }

      function toggleCheck(ls, event) {
        if (event) {
            event.stopPropagation();
        }

        var idx = vm.listProgramsSelected.indexOf(ls);

        if (idx > -1) {
            vm.listProgramsSelected.splice(idx, 1);
        } else {
            vm.listProgramsSelected.push(ls);
        }
      }

      function toggleSelectedAll(state)
      { 
        if(typeof vm.DataTable.list!= 'undefined') {
          var countCheckAvail = 0;
          for(var i=0; i<vm.DataTable.list.length;i++) {
              countCheckAvail++;
          }
          if (vm.listProgramsSelected.length === countCheckAvail) {
              unCheckAll();
          } else if (
              vm.listProgramsSelected.length === 0 ||
              vm.listProgramsSelected.length > 0
          ) {
              checkAll();
          }
        } else {
          return false;
        }
      }

      function checkAll() {
          for(var i=0; i<vm.DataTable.list.length;i++) {
              if(vm.listProgramsSelected.indexOf(vm.DataTable.list[i]) < 0) {
                vm.listProgramsSelected.push(vm.DataTable.list[i]);
              }
          }
      }

      function unCheckAll() {
        vm.listProgramsSelected = [];
      }

      function isChecked(ls) {
        return vm.listProgramsSelected.indexOf(ls) > -1;
      }        

      function isCheckedAll() {
        if(typeof vm.DataTable.list!= 'undefined') {
          var countCheckAvail = 0;
          for(var i=0; i<vm.DataTable.list.length;i++) {
            countCheckAvail++;
          }
          return vm.listProgramsSelected.length === countCheckAvail && vm.listProgramsSelected.length > 0;
        } else {
          return false;
        }
      }

      function isIndeterminate() {
        if(typeof vm.DataTable.list!= 'undefined') {
          var countCheckAvail = 0;
          for(var i=0; i<vm.DataTable.list.length;i++) {
            countCheckAvail++;
          }
          return (
            vm.listProgramsSelected.length > 0 &&
            vm.listProgramsSelected.length !== countCheckAvail
            );
        } else {
          return false;
        }
      }

      function openInputPrograms(ev) {
        $mdDialog.show({
          controller: 'InputEmployeeCertificatesProgramsController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/employee-certificates/input-employee-certificates/input-employee-certificates-programs.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData(1);
          },
          locals: {
              id: false
          }
        });
      }

      function editInputPrograms(ev, id) {
        $mdDialog.show({
          controller: 'InputEmployeeCertificatesProgramsController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/employee-certificates/input-employee-certificates/input-employee-certificates-programs.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData(1);
          },
          locals: {
              id: id
          }
        });
      }

      function deleteData(ev) {

        var message = translate('PAYROLL.MESSAGE.CONFDEL');
        var note = translate('PAYROLL.MESSAGE.DELNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var response = Certificateprograms.delete({ action: 'deleteData', data: angular.toJson(vm.listProgramsSelected) });

            response.$promise.then(function (resp) {
              loadData(1);
              angular.element.unblockUI();

              var Message = translate(resp.pesan);
              var Status = translate(resp.status);

              $mdDialog
                .show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(Status)
                    .textContent(Message)
                    .ariaLabel(Status)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                  angular.element.unblockUI();
                });

            });
          }, function () {

          });
        });
      }

      function LoadCountry() {
          var response = Certificateprograms.query({
              action: 'getCountry'
          });
          response.$promise.then(fetchCountry);
          response.$promise.catch(errorFetchCountry);
      }

      function fetchCountry(data) {
          vm.listcountry = data;
      }

      function errorFetchCountry() {
          vm.listcountry = [];
      }

      function clearSearchTermCountry() {
          vm.searchTermCountry = '';
      };

      function onCollapse() {
        if(vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
          vm.DataTable.searchParam = '';
          vm.loadData(1);
        }
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employee-certificates')
        .controller('EmployeeCertificatesConfigurationsController', EmployeeCertificatesConfigurationsController);


    EmployeeCertificatesConfigurationsController.$inject=['$state','$log','$mdDialog','AppAPI','Auth','DataService','$filter','$localStorage'];
    /** @ngInject */
    function EmployeeCertificatesConfigurationsController($state,$log,$mdDialog,AppAPI,Auth,DataService,$filter,$localStorage)
    {
      var vm = this;
      var Certificateclassrooms = AppAPI.Certificateclassrooms(); //memanggil api modules dari api
      var Certificateprograms = AppAPI.Certificateprograms(); //memanggil api modules dari api

      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData;
      vm.toggleSelectedAll=toggleSelectedAll;
      vm.checkAll=checkAll;
      vm.unCheckAll=unCheckAll;
      vm.deleteData=deleteData;

      vm.isChecked = isChecked;
      vm.isCheckedAll = isCheckedAll;
      vm.toggleCheck = toggleCheck;
      vm.isIndeterminate = isIndeterminate;

      vm.listConfigurationsSelected=[];

      vm.openInputConfigurations = openInputConfigurations;
      vm.editInputConfigurations = editInputConfigurations;
      
      vm.closeModal=closeModal;
      vm.viewDetailComponents = viewDetailComponents;
      
      vm.country = 'all';
      vm.program = '';

      vm.clearSearchTermCountry = clearSearchTermCountry;
      vm.clearSearchTermPrograms = clearSearchTermPrograms;

      vm.searchTermCountry = '';
      vm.searchTermPrograms = '';

      vm.listcountry = [];
      vm.listPrograms = [];

      vm.data = [];

      vm.onCollapse=onCollapse;

      var translate = $filter('translate');

      loadData(1);
      LoadCountry();
      LoadPrograms();

      function loadData(pageno) {
        angular.element.blockUI();
        var resp=vm.DataTable.loadData(Certificateclassrooms,pageno,{action:'viewData', country: vm.country, program: vm.program});

        resp.then(function(){
          vm.listConfigurationsSelected=[];          
          angular.element.unblockUI();
        });
      }

      function toggleCheck(ls, event) {
        if (event) {
            event.stopPropagation();
        }

        var idx = vm.listConfigurationsSelected.indexOf(ls);

        if (idx > -1) {
            vm.listConfigurationsSelected.splice(idx, 1);
        } else {
            vm.listConfigurationsSelected.push(ls);
        }
      }

      function toggleSelectedAll(state)
      { 
        if(typeof vm.DataTable.list!= 'undefined') {
          var countCheckAvail = 0;
          for(var i=0; i<vm.DataTable.list.length;i++) {
              countCheckAvail++;
          }
          if (vm.listConfigurationsSelected.length === countCheckAvail) {
              unCheckAll();
          } else if (
              vm.listConfigurationsSelected.length === 0 ||
              vm.listConfigurationsSelected.length > 0
          ) {
              checkAll();
          }
        } else {
          return false;
        }
      }

      function checkAll() {
          for(var i=0; i<vm.DataTable.list.length;i++) {
              if(vm.listConfigurationsSelected.indexOf(vm.DataTable.list[i]) < 0) {
                vm.listConfigurationsSelected.push(vm.DataTable.list[i]);
              }
          }
      }

      function unCheckAll() {
        vm.listConfigurationsSelected = [];
      }

      function isChecked(ls) {
        return vm.listConfigurationsSelected.indexOf(ls) > -1;
      }        

      function isCheckedAll() {
        if(typeof vm.DataTable.list!= 'undefined') {
          var countCheckAvail = 0;
          for(var i=0; i<vm.DataTable.list.length;i++) {
            countCheckAvail++;
          }
          return vm.listConfigurationsSelected.length === countCheckAvail && vm.listConfigurationsSelected.length > 0;
        } else {
          return false;
        }
      }

      function isIndeterminate() {
        if(typeof vm.DataTable.list!= 'undefined') {
          var countCheckAvail = 0;
          for(var i=0; i<vm.DataTable.list.length;i++) {
            countCheckAvail++;
          }
          return (
            vm.listConfigurationsSelected.length > 0 &&
            vm.listConfigurationsSelected.length !== countCheckAvail
            );
        } else {
          return false;
        }
      }

      function openInputConfigurations(ev) {
        $mdDialog.show({
          controller: 'InputEmployeeCertificatesConfigurationsController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/employee-certificates/input-employee-certificates/input-employee-certificates-configurations.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData(1);
          },
          locals: {
              id: false
          }
        });
      }

      function editInputConfigurations(ev, id) {
        $mdDialog.show({
          controller: 'InputEmployeeCertificatesConfigurationsController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/employee-certificates/input-employee-certificates/input-employee-certificates-configurations.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData(1);
          },
          locals: {
              id: id
          }
        });
      }

      function viewDetailComponents(ev, data) {
        $mdDialog.show({
          controller: ['data', 'closeModal', function(data, closeModal) { 
            var vm1 = this;
            vm1.data = data;
            vm1.closeModal = closeModal;
          }],
          controllerAs: 'vm1',
          templateUrl: 'app/main/cb/employee-certificates/employee-certificates-configurations-components.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            // loadData(1);
          },
          locals: {
              data: data,
              closeModal: closeModal
          }
        });
      }

      function deleteData(ev) {

        var message = translate('PAYROLL.MESSAGE.CONFDEL');
        var note = translate('PAYROLL.MESSAGE.DELNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var response = Certificateclassrooms.delete({ action: 'deleteData', data: angular.toJson(vm.listConfigurationsSelected) });

            response.$promise.then(function (resp) {
              loadData(1);
              angular.element.unblockUI();

              var Message = translate(resp.pesan);
              var Status = translate(resp.status);

              $mdDialog
                .show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(Status)
                    .textContent(Message)
                    .ariaLabel(Status)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                  angular.element.unblockUI();
                });

            });
          }, function () {

          });
        });
      }

      function LoadCountry() {
          var response = Certificateprograms.query({
              action: 'getCountry'
          });
          response.$promise.then(fetchCountry);
          response.$promise.catch(errorFetchCountry);
      }

      function fetchCountry(data) {
          vm.listcountry = data;
      }

      function errorFetchCountry() {
          vm.listcountry = [];
      }

      function clearSearchTermCountry() {
          vm.searchTermCountry = '';
      };

      function LoadPrograms() {
          var response = Certificateprograms.query({
              action: 'getPrograms',
              country: vm.country
          });
          response.$promise.then(fetchPrograms);
          response.$promise.catch(errorFetchPrograms);
      }

      function fetchPrograms(data) {
          vm.listPrograms = data;
      }

      function errorFetchPrograms() {
          vm.listPrograms = [];
      }

      function clearSearchTermPrograms() {
          vm.searchTermPrograms = '';
      };

      function closeModal() {
          $mdDialog.hide();
      }

      function onCollapse() {
        if(vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
          vm.DataTable.searchParam = '';
          vm.loadData(1);
        }
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employee-alert', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
     // State
        $stateProvider
            .state('app.cb_employee_alert', {
                url    : '/cb/employee-alert',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employee-alert/index.html',
                        controller : 'EmployeeAlertController as vm'
                    }
                }
            }); 
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.employee-alert')
        .controller('viewDetailAlertController', viewDetailAlertController);

    viewDetailAlertController.$inject = ['$mdDialog','data','$localStorage','config','AppAPI','DataService'];

    /* @ngInject */
    function viewDetailAlertController($mdDialog,data,$localStorage,config,AppAPI,DataService) 
    {
        var vm = this; 

        var endPoint=AppAPI.EmployeeAlert();
        vm.closeModal=closeModal;
        vm.listData=data.logReader;

        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.items = [];

        loadData();

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadData() 
        {
            angular.element.blockUI();
            var response=endPoint.query({action:'viewDetail',id:data.id});
            response.$promise.then(fetchData);
            response.$promise.catch(errorFetchData);
        }

        function fetchData(data) 
        {
            angular.element.unblockUI();
            vm.items=data;
        }

        function errorFetchData() {
            vm.items=[];
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.employee-alert')
        .controller('InputWarningAlertController', InputWarningAlertController);


    InputWarningAlertController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$element','data'];
    /** @ngInject */
    function InputWarningAlertController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$element,data)
    {
        var vm = this; 
        var EmployeeAlert=AppAPI.EmployeeAlert();
        
        var nik= $localStorage.user;
        
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.listselected=[];
        vm.items = [];
        
        vm.deleteData       = deleteData;
        vm.loadData         = loadData; 
        vm.closeModal       = closeModal; 
        vm.Input            = Input;
        vm.Edit             = Edit;
        vm.listFlagApp      = ['SAP','HRIS'];
        vm.listLaborType    = [
                                    {'id':'direct','name':'DIRECT'},
                                    {'id':'indirect','name':'INDIRECT'},
                                ];

        loadData(1);
        getType();
        getRefWarningLetter();
        
        function closeModal()
        {
            $mdDialog.hide();
        }

        function getType()
        { 
            var resp=EmployeeAlert.query({action:'getType'})
            resp.$promise.then(fetchType);
            resp.$promise.catch(errorType); 
        }

        function fetchType(data)
        {
                vm.listType=data;
        }

        function errorType()
        {
                vm.listType=[];
        }
        
        function Edit(ev,data)
        {
            $mdDialog.show({
                controller         : 'EditEmployeeAlertController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/area-incharge/create.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                data:data
                }
            });
        }

        function getRefWarningLetter()
        { 
            var resp=EmployeeAlert.query({action:'getRefWarningLetter'})
            resp.$promise.then(fetchRefWarningLetter);
            resp.$promise.catch(errorRefWarningLetter); 
        }

        function fetchRefWarningLetter(data)
        {
                vm.listRefWarningLetter=data;
        }

        function errorRefWarningLetter()
        {
                vm.listRefWarningLetter=[];
        }

        function loadData(pageno)
        {
            var resp=vm.DataTable.loadData(EmployeeAlert,pageno,{action:'viewData',flagApp:vm.flagApp,type:vm.type,laborType:vm.laborType});
            resp.then(function(data) {
                vm.listselected = [];
                vm.items = data.list;
            });
        }
        
        function deleteData(ev) {
            var promise=Auth.setToken();
            promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Apakah anda yakin akan menghapus transaksi ini?')
                .textContent('Seluruh data pada transaksi ini akan di hapus dari system.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('Ya')
                .cancel('Tidak');

                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var response=EmployeeAlert.delete({action:'deleteData',data:angular.toJson(vm.listselected)});
                    response.$promise.then( function(resData) {
                        angular.element.unblockUI();
                        if ( resData.status == 1 ) {
                        var title = 'Success Delete Data';
                        var textContent = resData.pesan;
                        var ariaLabel = 'Success Delete Data';
                        } else {
                        var title = 'Delete Data Failed';
                        var textContent = resData.message;
                        var ariaLabel = 'Delete Data Failed';
                        }
                        
                        showDialogMessage(title,textContent,ariaLabel);
                        loadData(1);
                    });
                    response.$promise.catch( function(resData) {
                        angular.element.unblockUI();
                        var title = 'Delete Data Failed';
                        var textContent = resData.pesan;
                        var ariaLabel = 'Delete Data Failed';
                        showDialogMessage(title,textContent,ariaLabel,ev);
                    })
                }, function() {

                });
            });
        }

        function Input(ev,id)
        {
                $mdDialog.show({
                    controller         : 'CreateCreateEmployeeAlertController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/cb/area-incharge/create.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData();
                    },
                    locals:{
                    id:id
                    }
                }); 

        }

        function showDialogMessage(title,textContent,ariaLabel,ev) {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(title)
            .textContent(textContent)
            .ariaLabel(ariaLabel)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.employee-alert')
        .controller('EmployeeAlertController', EmployeeAlertController);


    EmployeeAlertController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$element','$filter','Form'];
    /** @ngInject */
    function EmployeeAlertController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$element,$filter,Form)
    {
      var vm = this;
      var translate = $filter('translate'); 
      var EmployeeAlert=AppAPI.EmployeeAlert();
      
      var nik= $localStorage.user;
      
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.listselected=[];
      vm.items = [];
      
      Form.initialForm();
      Form.setObject(EmployeeAlert);
      vm.Form = Form; 

      vm.country          = $localStorage.country;
      vm.bu               = $localStorage.empsite;
      vm.processData      = processData;
      vm.loadData         = loadData; 
      vm.isChecked        = isChecked;
      vm.toggleCheck      = toggleCheck;
      vm.exists           = exists;
      vm.isIndeterminate  = isIndeterminate;
      vm.toggleAll        = toggleAll;
      vm.createAlert      = createAlert;
      vm.detail           = detail;
      vm.processAlert     = processAlert;
      vm.showFormDialog   = showFormDialog;
      vm.listFlagApp      = [
                                {'id':'all','name':'All'},
                                {'id':'SAP','name':'STAFF'},
                                {'id':'HRIS','name':'GW'},
                            ];
      vm.listLaborType    = [
                                {'id':'all','name':'All'},
                                {'id':'direct','name':'DIRECT'},
                                {'id':'indirect','name':'INDIRECT'},
                            ];
      vm.listAlertType    = [
                                {'id':'all','name':'All'},
                                {'id':'4','name':'Hijau'},
                                {'id':'1','name':'Kuning'},
                                {'id':'2','name':'Merah'},
                                {'id':'3','name':'Hitam'},
                            ];
      vm.listAlertStatus    = [
                                {'id':'all','name':'All'},
                                {'id':'SP1','name':'SP 1'},
                                {'id':'SP2','name':'SP 2'},
                                {'id':'SP3','name':'SP 3'},
                                {'id':'PHK','name':'PHK'},
                                // {'id':'none','name':'LOW PERFORMANCE'},
                            ];

      getType();
      LoadPeriod();
      LoadCostCenterGroup();
    
      function createAlert(ev,data)
      {
        $mdDialog.show({
            controller         : 'InputWarningAlertController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/employee-alert/input-alert.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData();
            },
            locals:{
              data:data
            }
        });
      }
      
      function detail(ev,data)
      {
        $mdDialog.show({
            controller         : 'viewDetailAlertController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/employee-alert/view-detail.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData();
            },
            locals:{
              data:data
            }
        });
      }
      
      function processData(ev)
      {
        $mdDialog.show({
            controller         : 'EmployeeAlertProcessController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/employee-alert/process-form.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData();
            },
            locals:{
              flagApp:vm.flagApp,
              period:vm.period,
              type:vm.type,
              laborType:vm.laborType,
              alertType:vm.alertType,
            }
        });
      }

      function closeModal()
      {
          $mdDialog.hide();
      }

      function getType()
      { 
          var resp=EmployeeAlert.query({action:'getType'})
          resp.$promise.then(fetchType);
          resp.$promise.catch(errorType); 
      }

      function fetchType(data)
      {
            vm.listType=data;
      }

      function errorType()
      {
            vm.listType=[];
      }

      function loadData(pageno)
      {
        var resp=vm.DataTable.loadData(EmployeeAlert,pageno,{action:'viewData',period:vm.period,flagApp:vm.flagApp,type:vm.type,laborType:vm.laborType,alertType:vm.alertType,alertStatus:vm.alertStatus,costCenterGroup:vm.costCenterGroup});
        resp.then(function(data) {
            vm.listselected = [];
            vm.items = data.list;
            vm.headcount = data.headcount;
            console.log(vm.headcount);
        });
      }

      function isChecked(ls)
      {
            return vm.listselected.length === vm.items.length;
      }

      function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listselected.splice(idx, 1);
          }
          else
          {
              vm.listselected.push(ls);
          }
      }

      function toggleAll() {
        if (vm.listselected.length === vm.items.length) {
          vm.listselected = [];
        } else if (vm.listselected.length === 0 || vm.listselected.length > 0) {
          vm.listselected = vm.items.slice(0);
        }
      }

      function isIndeterminate() {
        return vm.listselected.length !== 0 && vm.listselected.length !== vm.items.length;
      }

      function exists(item, list) {
        return list.indexOf(item) > -1;
      }

      function LoadPeriod() 
      {
          angular.element.blockUI();
          var response=EmployeeAlert.query({action:'getPeriodList'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
      }

      function fetchPeriod(data) 
      {
          vm.listPeriod=data;
          angular.element.unblockUI();
          vm.disabledPeriod = false;
      }

      function errorFetchPeriod() {
          vm.listPeriod=[];
      }
      
      function LoadCostCenterGroup() 
      {
          angular.element.blockUI();
          var response=EmployeeAlert.query({action:'getCostCenterGroup',country:vm.country,bu:vm.bu});
          response.$promise.then(fetchCostCenterGroup);
          response.$promise.catch(errorFetchCostCenterGroup);
      }

      function fetchCostCenterGroup(data) 
      {
          vm.listCostCenterGroup=data;
          angular.element.unblockUI();
          vm.disabledPeriod = false;
      }

      function errorFetchCostCenterGroup() {
          vm.listCostCenterGroup=[];
      }


      function showDialogMessage(title,textContent,ariaLabel,ev) {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              closeModal();
          });
      }

      function showFormDialog(ev, type, item, isAdmin) {
        $mdDialog
            .show({
                controller: 'IndisciplinaryAlertFormController as vm',
                templateUrl: 'app/main/indisciplinary-alert/form/form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    dialogType: type,
                    reffData: item,
                    isAdmin: isAdmin
                }
            })
            .then(function() {
                loadData(1);
            });
    }

    function processAlert(ev,formController,ls) 
    {
        var message = translate('PAYROLL.MESSAGE.CONFPROC');
        var note    = translate('PAYROLL.MESSAGE.PROCNOTE');
        var yes     = translate('PAYROLL.MESSAGE.YES');
        var no      = translate('PAYROLL.MESSAGE.NO');
  
        var promise = Auth.setToken();
        promise.then(function() {
          var confirm = $mdDialog
            .confirm()
            .title(message)
            .textContent(note)
            .ariaLabel('confirm dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
  
          $mdDialog.show(confirm).then(
            function() {
                var dt= ls.alertperiod;
                var year = dt.substring(0, 4);
                var month = dt.substring(4, 6);
    
                var newdate=year+'-'+month+'-28';
                
                var d1 = new Date(newdate);
                var d2 = new Date();

                var tanggal = newdate
                if(d2<d1)
                {
                    var dtM=(d2.getMonth()+1);
                    var dtD=d2.getDate();
                    if(dtM < 10){
                        dtM='0'+dtM
                    }
                    if(dtD<10)
                    {
                        dtD='0'+dtD;
                    }
        
                    var tanggal = d2.getFullYear()+'-'+dtM+'-'+dtD;
                }

                vm.Form.objForm.effective_date = tanggal;
    
                var promise=Auth.setToken();
                promise.then(function()
                {
                    angular.element('#attView').block({message:' <span>Loading...</span>'});
                
                    angular.element.blockUI();
                    vm.Form.objForm.companyid=ls.bu;
                    vm.Form.objForm.empno=ls.nik;
                    vm.Form.objForm.area=ls.group_area_id;
                    vm.Form.objForm.countryid=ls.country_id;
                    vm.Form.objForm.period=ls.alertperiod;
                    var response=Form.saveData('alertProcess', formController, EmployeeAlert);
                    
                    response.then(fetchProcess);
                    response.catch(errorFetchProcess);
                });
            },
            function() {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        });
    }

        function fetchProcess(data)
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(data.status)
                .textContent(data.pesan)
                .ariaLabel('Process data has been successully')
                .ok('OK')
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                  }else{
                    loadData(1);
                  }
            });
        }

        function errorFetchProcess()
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Process Data')
                .textContent('Process Data was Fail.')
                .ariaLabel('Failed Process Data')
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }      
 
        function showDialog(ev) 
        {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Process data has been successully')
            .textContent('Process data has been successully.')
            .ariaLabel('Process data has been successully')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

    vm.clearSearchTerm = function() {
    vm.searchTerm = '';
    };
    
    $element.find('input').on('keydown', function(ev) {
        ev.stopPropagation();
    });
    
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employee-alert')
        .controller('EmployeeAlertProcessController', EmployeeAlertProcessController);


    EmployeeAlertProcessController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$element','Form','$http','config','flagApp','period','type','laborType','alertType'];
    /** @ngInject */
    function EmployeeAlertProcessController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$element,Form,$http,config,flagApp,period,type,laborType,alertType)
    {
        var vm = this; 
        var endPoint=AppAPI.EmployeeAlert();
      
        vm.today = new Date();
        
        Form.initialForm();
        Form.setObject(endPoint);
        vm.Form = Form; 

        var dt = new Date();
        dt.setMonth(dt.getMonth()-1);
        
        var dtM=(dt.getMonth()+1);
        var dtD=dt.getDate();
        if(dtM < 10){
            dtM='0'+dtM
        }

        vm.prevMonth =new Date(dt.getFullYear()+'-'+dtM+'-28');
        
        vm.country = $localStorage.country;   
        vm.company = $localStorage.empsite;
        vm.disabledPeriod = true;
        vm.getEmployee=getEmployee;
        vm.closeModal=closeModal;
        vm.saveData=saveData;
        vm.LoadCompany=LoadCompany;
        vm.stateEdit=false;
        vm.selectedItemChanged=selectedItemChanged;  

        vm.Form.objForm.area = '';
        vm.Form.objForm.empno = '';
        
        vm.LoadArea = LoadArea
       
        LoadCountry();
        LoadCompany(vm.country);
        LoadArea(vm.country,vm.company);
        LoadPeriod()

        function loadData(pageno)
        {
            var resp=vm.DataTable.loadData(endPoint,pageno,{action:'viewData',flagApp:flagApp,period:period,type:type,laborType:laborType});
            resp.then(function(data) {
                vm.listselected = [];
                vm.items = data.list;
            });
        }

        function LoadCountry() {
            var response=endPoint.query({action:'getCountry'});
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listCountry=data;
        }

        function errorFetchCountry() {
            vm.listCountry=[];
        } 
        
        function LoadCompany(countryId) {
            var response=endPoint.query({action:'getCompany',country:countryId});
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany=data;
        }

        function errorFetchCompany() {
            vm.listcompany=[];
        } 

       function LoadArea(countryid,companyid) {
            var response=endPoint.query({action:'getArea',country:countryid, bu:companyid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       } 

        function selectedItemChanged(employee)
        {
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;
            }
        }

        function getEmployee(searchText)
        {
            return $http
            .get(config.api + 'api/employeealert?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
            .then(function(item) {
                // Map the response object to the data object.
                if(item.data.length===''){
                    Form.objForm.empno='';
                } 
                return item.data;
            });
        }

        function LoadPeriod() 
        {
            angular.element.blockUI();
            var response=endPoint.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) 
        {
            vm.listperiod=data;
            angular.element.unblockUI();
            vm.disabledPeriod = false;
        }

        function errorFetchPeriod() {
            vm.listperiod=[];
        }

        function saveData(ev,formController) 
        {      
            var dt= new Date(vm.Form.objForm.effective_date);
            var dtM=(dt.getMonth()+1);
            var dtD=dt.getDate();
            if(dtM < 10){
                dtM='0'+dtM
            }
            if(dtD<10)
            {
                dtD='0'+dtD;
            }

            var newdate=dt.getFullYear()+'-'+dtM+'-'+dtD;
            vm.Form.objForm.effective_date= newdate;

            var promise=Auth.setToken();
            promise.then(function()
            {
                // var confirm = $mdDialog.confirm()
                //     .title('Would you like to process?')
                //     .ariaLabel('delete dialog')
                //     .targetEvent(ev)
                //     .ok('YES')
                //     .cancel('no');
            
                // $mdDialog.show(confirm).then(function() {
                    angular.element('#attView').block({message:' <span>Loading...</span>'});
                
                    angular.element.blockUI();
                    vm.Form.objForm.companyid=vm.company;
                    vm.Form.objForm.countryid=vm.country;
                    var response=Form.saveData('alertProcess', formController, endPoint);
                    
                    response.then(fetchProcess);
                    response.catch(errorFetchProcess);
                // }, function() {
                //     angular.element('#attView').unblock();
                    
                // });
            });
        }

        function fetchProcess(data)
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(data.status)
                .textContent(data.pesan)
                .ariaLabel('Process data has been successully')
                .ok('OK')
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                  }else{
                    loadData(1);
                  }
            });
        }

        function errorFetchProcess()
        {
            angular.element.unblockUI();
            angular.element('#attView').unblock();
            vm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.Form.objForm.period ='';
            vm.company = '';
            vm.Form.objForm.area='';
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Process Data')
                .textContent('Process Data was Fail.')
                .ariaLabel('Failed Process Data')
                .ok('OK')
            ).then(function(){
                closeModal();
            });
        }      
 
        function showDialog(ev) 
        {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Process data has been successully')
            .textContent('Process data has been successully.')
            .ariaLabel('Process data has been successully')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
       
        function closeModal()
        {
            $mdDialog.hide();
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-acting', [
        ])
        .config(config);

    config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
        $stateProvider
            .state('app.cb_employee_acting', {
                url    : '/cb/employee-acting',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employee-acting/employee-acting.html',
                        controller : 'EmployeActingController as vm'
                    }
                }
            });
    }
})();
(function() {
    'use strict';
    angular
      .module('app.cb.employe-acting')
      .controller('EmployeActingController', EmployeActingController);
  
    EmployeActingController.$inject = [
        '$document',
        'DataService',
        '$state',
        '$mdDialog',
        '$localStorage',
        '$window',
        '$timeout',
        'AppAPI',
        'Auth',
        'Form',
        '$q',
        'filterFilter',
        'config'
    ];

    /** @ngInject */
    function EmployeActingController(
        $document,
        DataService,
        $state,
        $mdDialog,
        $localStorage,
        $window,
        $timeout,
        AppAPI,
        Auth,
        Form,
        $q,
        filterFilter,
        config
    ) {
        var vm = this;
        var EmployeActing = AppAPI.EmployeActing();
        var news = AppAPI.News();
        var Attendancereport=AppAPI.Attendancereport();

        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.items = [];
        vm.selectedItem = null;
        vm.searchText = null;
        vm.listNC = [];
        vm.Form = Form;
        vm.processData = processData;
        vm.dialogClose = dialogClose;
        vm.company=$localStorage.empsite;
        vm.listType = ['progress','pass','failed'];
        vm.type = 'progress';
        vm.company='all';
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;
        vm.divisi='all';
        vm.department='all';
        vm.start_date=null;
        vm.end_date=null;
        vm.extendActing=extendActing;

        loadData(1);
        loadDataBU();
        loadDataDivision(vm.company);
        function loadData(pageno) {
            var resp = vm.DataTables.loadData(EmployeActing, pageno, { action: 'viewData',type: vm.type,company: vm.company,divisi:vm.divisi,department:vm.department,startdate: vm.start_date,enddate: vm.end_date});
    
            resp.then(function(data) {
                vm.selected = [];
                vm.items = data.list;
            });
        }

        function loadDataDepartment(iddivisi) {
            var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment=data;
        }

        function errorDepartment() {
            vm.listDepartment=[];
        }
        function loadDataDivision(idbu) {
            var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision=data;
        }

        function errorDivisiBU() {
            vm.listDivision=[];
        }

        function loadDataBU() {
            var response=news.query({action:'viewBU'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }
    
        function fetchBU(data) {
            vm.listBU=data;
            vm.listBU.push({id:'all', description:'All'});
        }
    
        function errorFetchBU() {
            vm.listBU=[];
        }

        function processData(ev,type) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to process this ?')
                    .textContent('Data your selected will be process and can not recovered.')
                    .ariaLabel('process dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(function() {
                    var ea= new EmployeActing();
                    ea.data=[];
                    ea.action='save';
                    ea.type=type;
                    
                    for (var index = 0; index < vm.selected.length; index++) {
                        ea.data.push(vm.selected[index]);
                    }
                    var response=ea.$save();
                    response.then(function(){
                        loadData(1);
                        dialogClose();
                        angular.element.unblockUI();
                        showDialogInfo(ev, response);
                    });
                    response.catch( function(){
                        
                    });
                }, function() {
                
                });
            });
        }
  
        function showDialogInfo(ev, data) {
            $mdDialog
            .show(
                $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success')
                .textContent('Success Save Data')
                .ariaLabel('Process Save Data')
                .ok('OK')
                .targetEvent(ev)
            )
            .then(function() {
                dialogClose();
                loadData(1);
            });
        }
  
        function dialogClose() {
            $mdDialog.hide();
        }
  
        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
            list.splice(idx, 1);
            } else {
            list.push(item);
            }
        }
  
        function exists(item, list) {
            return list.indexOf(item) > -1;
        }
  
        function isChecked() {
            return vm.selected.length === vm.items.length;
        }
  
        function toggleAll() {
            if (vm.selected.length === vm.items.length) {
            vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
            vm.selected = vm.items.slice(0);
            }
        }
  
        function inArray(param, array) {
            var length = array.length;
            for (var i = 0; i < length; i++) {
            if (array[i] == param)
                return true;
            }
            return false;
        }

        function extendActing(ev)
        { 
            var data=[]; 
            for (var index = 0; index < vm.selected.length; index++) {
                data.push(vm.selected[index]);
            }
            $mdDialog.show({
                controller: 'ActingExtendController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/employee-acting/employe-acting-extend.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple:true,
                onRemoving: function (element, removePromise) 
                { 
                   loadData(1); 
                },
                locals:{
                  data:data
                }
            });
        }
    }
  })();  
(function () 
{
    'use strict';

    angular
        .module('app.cb.employe-acting')
        .controller('ActingExtendController', ActingExtendController);

    /** @ngInject */
    ActingExtendController.$inject=['$stateParams','$mdDialog','$localStorage','AppAPI','Auth','data','Form'];
    /** @ngInject */
    function ActingExtendController($stateParams,$mdDialog,$localStorage,AppAPI,Auth,data,Form)
    {
        
      var vm = this;  
      var EmployeActing = AppAPI.EmployeActing();
      vm.empList=[];
      vm.cancel=cancel; 
      vm.submitActingExtend=submitActingExtend;

      console.log('extend');
      console.log(vm.empList);
      setupData();
      // ======================

      function setupData() 
      {
        vm.empList=[]; 
        for (var index = 0; index < data.length; index++) 
        {
            data[index].effectiveDate=new Date(data[index].end_date);
            vm.empList.push(data[index]);
        }
      }

      function submitActingExtend(ev)
      {
        var promise = Auth.setToken();
        promise.then(function() {
          var ea= new EmployeActing();
          ea.data=vm.empList;
          ea.action='extend';
          var response=ea.$save();
          response.then(function()
          { 
              cancel(); 
              showDialogInfo(ev, response);
          });
          response.catch( function(){
              
          });
        }); 
      }

       function showDialogInfo(ev, data) {
            $mdDialog
            .show(
                $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success')
                .textContent('Success Save Data')
                .ariaLabel('Process Save Data')
                .ok('OK')
                .targetEvent(ev)
            )
            .then(function() {
                cancel(); 
            });
        }

      function cancel()
      {
        $mdDialog.hide();
      }
    } 
})();  

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-shift-unschedule', [
        ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
      // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-shift');

        // State
        $stateProvider
        .state('app.cb_employe_shift_unschedule', {
            url    : '/cb/employe-shift-unschedule',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/cb/employe-shift-unschedule/employe-shift-unschedule.html',
                    controller : 'EmployeshiftunscheduleController as vm',
                    css: ['app/main/cb/employe-shift-unschedule/employe-shift-unschedule.scss']
                }
            }
        });

        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.employe-shift-unschedule')
        .controller('viewDetailShiftUnscheduledController', viewDetailShiftUnscheduledController);

    viewDetailShiftUnscheduledController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService'];

    /* @ngInject */
    function viewDetailShiftUnscheduledController($mdDialog, data, $localStorage, config, AppAPI, DataService) {
        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        var date = new Date();
        vm.tahun = data.tahun;
        vm.bulan = data.bulan;
        vm.nik = data.nik;
        vm.name = data.name;
        vm.status = data.status;
        vm.closeModal = closeModal
        var Employeshift = AppAPI.Employeshiftunschedule();
        var Employeshiftt = AppAPI.Overtime();
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listselected = [];
        vm.cekStatus = cekStatus;

        loadData(1);

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(Employeshift, pageno, {
                action: 'viewData',
                tahun: vm.tahun,
                bulan: vm.bulan,
                nik: vm.nik,
                isDetail: true
            });
            vm.listselected = [];
            resp.then(function () {
                // vm.abs_code='';
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listselected.indexOf(ls);

            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listselected = angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listselected = [];
        }

        function editData(id) {
            $state.go('app.utility_modul_edit-modul', {
                id: id
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function cekStatus(status) {
            return ((status.trim()).toLowerCase()).substr(0, 8) == 'parttime';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.employe-shift-unschedule')
        .controller('UploadshiftunscheduleController', UploadshiftunscheduleController);

    UploadshiftunscheduleController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$sce'];

    /* @ngInject */
    function UploadshiftunscheduleController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $sce) {
        var vm = this;
        // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal = closeModal;
        vm.uploadFile = uploadFile;
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        vm.detailInfo = []
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.uploadProcess = uploadProcess;
        vm.DownloadTemplate = DownloadTemplate;
        vm.width = 40;
        vm.splitNotif = splitNotif;

        ////////////////
        function uploadProcess() {
            angular.element.blockUI();
            vm.FileUpload.uploadAll()
        }

        var uploaderPhoto = vm.FileUpload = new FileUploader({
            url: config.api + 'api/employeshiftunschedule/uploadshift',
            removeAfterUpload: true,
            alias: 'fileshift',
            formData: [{
                action: 'uploadshift'
            }],
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;
                vm.isMoreInfo = false;
                vm.detailInfo = [];
                vm.width = 40;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        uploaderPhoto.onSuccessItem = function (item, status) {
            angular.element.unblockUI();
            if (status.status == 0) {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }

            vm.uploadNotif = status.message;
            if ('moreInfo' in status && status.moreInfo.length > 0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
                vm.width = 60;
            }
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem = function (item) {
            angular.element.unblockUI();
            vm.uploadSuccess = false;
            vm.uploadError = true;
        };

        function uploadFile() {
            return false;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function viewMoreInfo() {
            $mdDialog.show({
                controller: 'logFailGwController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: vm.detailInfo
                }
            });
        }

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/employeshiftunschedule/downloadtemplate', '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }

        function splitNotif(txt) {
            if (txt) {
                var splitTxt = txt.split(',');
                var splitSpace = splitTxt[1].trim().split(' ');

                var txtSuccess = '';
                if (parseInt(splitSpace[0]) > 0) {
                    txtSuccess = '<span style="color:green;"> ' + splitSpace[0] + ' ' + splitSpace[1] + '</span>';
                } else {
                    txtSuccess = splitSpace[0] + ' ' + splitSpace[1];
                }

                var txtFailed = '';
                if (parseInt(splitSpace[2]) > 0) {
                    txtFailed = '<span style="color:red;"> ' + splitSpace[2] + ' ' + splitSpace[3] + '</span>';
                } else {
                    txtFailed = splitSpace[2] + ' ' + splitSpace[3];
                }

                return $sce.trustAsHtml(splitTxt[0] + ', ' + txtSuccess + ' ' + txtFailed + '.');
            } else {
                return '';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.employe-shift-unschedule')
        .controller('EmployeshiftunscheduleController', EmployeshiftunscheduleController);


    EmployeshiftunscheduleController.$inject = ['$state', '$localStorage', '$document', '$http', '$scope', 'config', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', 'FileUploader'];
    /** @ngInject */
    function EmployeshiftunscheduleController($state, $localStorage, $document, $http, $scope, config, $log, $mdDialog, AppAPI, Auth, DataService, FileUploader) {

        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.editData = editData;
        vm.toggleSelectedAll = toggleSelectedAll;
        var Attendanceemploye = AppAPI.Attendanceemploye();
        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.tgl = date.getDate();

        if (vm.tgl >= 25 && vm.tgl <= 31) {
            if (vm.bulan == 12) {
                vm.bulan = 1;
                vm.tahun += 1;
            } else {
                vm.bulan = vm.bulan + 1;
            }
        }

        var Employeshift = AppAPI.Employeshiftunschedule();
        vm.uploadShiftUnschedule = uploadShiftUnschedule;
        vm.uploadShiftNonGroup = uploadShiftNonGroup;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        var Employeshiftt = AppAPI.Overtime();
        vm.company = $localStorage.empsite;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listselected = [];
        vm.DeleteShift = DeleteShift;
        vm.viewDetail = viewDetail;
        vm.cekStatus = cekStatus;
        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist = [{
            link: '#',
            name: 'C&B / ',
            active: '0'
        }];

        vm.getPeriode = getPeriode;

        vm.listtahun = [2017, 2018, 2019, 2020, 2021];
        vm.listbulan = [{
                name: 'January',
                value: '1'
            },
            {
                name: 'February',
                value: '2'
            },
            {
                name: 'Maret',
                value: '3'
            },
            {
                name: 'April',
                value: '4'
            },
            {
                name: 'Mei',
                value: '5'
            },
            {
                name: 'June',
                value: '6'
            },
            {
                name: 'July',
                value: '7'
            },
            {
                name: 'August',
                value: '8'
            },
            {
                name: 'September',
                value: '9'
            },
            {
                name: 'October',
                value: '10'
            },
            {
                name: 'November',
                value: '11'
            },
            {
                name: 'Desember',
                value: '12'
            }
        ];
        getPeriode(1);

        function getPeriode(init) {
            angular.element.blockUI();
            var res = Attendanceemploye.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan
            });
            res.$promise.then(
                function fetchPeriode(data, init) {
                    vm.periode = data[0]['periode'];
                    loadData(1);
                }
            );
            res.$promise.catch(
                function errorfetchPeriode(data) {
                    console.log('error');
                    angular.element.unblockUI();
                }
            );
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }

        function loadData(pageno) {
            angular.element.blockUI();
            var resp = vm.DataTable.loadData(Employeshift, pageno, {
                action: 'viewData',
                tahun: vm.tahun,
                bulan: vm.bulan
            });
            vm.listselected = [];
            resp.then(function () {
                angular.element.unblockUI();
            });
            resp.catch(function () {
                angular.element.unblockUI();
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listselected.indexOf(ls);

            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
            //console.log(vm.listModulSelected);
        }

        function checkAll() {
            vm.listselected = angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listselected = [];
        }

        function editData(id) {
            $state.go('app.utility_modul_edit-modul', {
                id: id
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteShift(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Employeshift.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listselected)
                    });

                    response.$promise.then(loadData);
                    response.$promise.catch(function () {
                        angular.element.unblockUI();
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function uploadShiftUnschedule(ev) {
            $mdDialog.show({
                controller: 'UploadshiftunscheduleController as vm',
                templateUrl: 'app/main/cb/employe-shift-unschedule/upload-shift-unschedule.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
            });
        }

        function uploadShiftNonGroup(ev) {
            $mdDialog.show({
                controller: 'UploadshiftngController as vm',
                templateUrl: 'app/main/cb/employe-shift/upload-shift-ng.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
            });
        }

        function loadDataDepartment(iddivisi) {
            var response = Employeshiftt.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Employeshiftt.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            // loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Employeshiftt.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function viewDetail(nik, name, bulan, tahun, status, ev) {
            var item = {
                nik: nik,
                name: name,
                bulan: bulan,
                tahun: tahun,
                status: status
            }
            $mdDialog.show({
                controller: 'viewDetailShiftUnscheduledController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/employe-shift-unschedule/view-detail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: item
                }
            });
        }

        function cekStatus(status) {
            return ((status.trim()).toLowerCase()).substr(0, 8) == 'parttime';
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-shift-migrate', [
        ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
      // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-shift');

        // State
        $stateProvider
        .state('app.cb_employe_shift_migrate', {
            url    : '/cb/employe-shift-migrate',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/cb/employe-shift-migrate/employe-shift-migrate.html',
                    controller : 'EmployeShiftMigrateController as vm'
                }
            }
        });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-shift-migrate')
        .controller('EmployeShiftMigrateController', EmployeShiftMigrateController);

    EmployeShiftMigrateController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader','$sce'];
    /** @ngInject */
    function EmployeShiftMigrateController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader,$sce)
    {
        var vm = this;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.editData=editData;
        vm.toggleSelectedAll=toggleSelectedAll;
        var Employeshift=AppAPI.EmployeShiftMigrate();
        var ChecklistAttendanceGw = AppAPI.ChecklistAttendanceGw();
        var Employeshiftt=AppAPI.Overtime();
        var Employe = AppAPI.Employe();
        vm.lisShiftSelected=[];
        vm.company=$localStorage.empsite; 
        vm.getListGedung = getListGedung;
        vm.getSector = getSector;
        vm.gedung = "";
        vm.objGedung = "";
        vm.isObject = isObject;
        vm.viewDetail = viewDetail;
        
        function isObject (data)
        {
          return typeof data==='object'
        }

        function viewDetail(item,ev)
        {
          $mdDialog.show({
                  controller         : 'viewDetailShiftMigrateController',
                  controllerAs       : 'vm',
                  templateUrl        : 'app/main/cb/employe-shift-migrate/view-detail.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: true,
                  onRemoving:function(element, removePromise)
                  {
                    setTimeout(function(){ loadData(1) }, 3000);
                  },
                  locals:{
                    data:item
                  }
              }); 
        }
        
        getListGedung();
        
        function getListGedung() {
          var response = ChecklistAttendanceGw.query({
              action: "getSelectListGedung"
          });
          response.$promise.then(fetchGedung);
          response.$promise.catch(errorFetchGedung);
        }
        function fetchGedung(data) {
            vm.listGedung = data;
        }
        function errorFetchGedung() {
            vm.listGedung = [];
        }

        function getSector(objGedung) {
            var obj = JSON.parse(objGedung);
            vm.gedung = obj.gedung_id;
            var response = ChecklistAttendanceGw.query({
                action: "getSelectListSector",
                id: obj.id
            });
            response.$promise.then(fetchSector);
            response.$promise.catch(errorFetchSector);
        }
        function fetchSector(data) {
            vm.listSector = data;
        }
        function errorFetchSector() {
            vm.listSector = [];
        }

        function loadData(pageno)
        {
          var resp=vm.DataTable.loadData(Employeshift,pageno,{action:'viewdata',gedung_id:vm.gedung,sector_id:vm.sector,start_date:vm.start_date,end_date:vm.end_date});
          vm.listselected=[];
          
          resp.then(function(){
            if(vm.DataTable.list.length>0){
              vm.header = Object.keys(vm.DataTable.list[0])
            }
          });
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisShiftSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.lisShiftSelected=[];
          }
        function editData(id){
          $state.go('app.utility_modul_edit-modul',{id:id});
        }


        function closeModal()
        {
            $mdDialog.hide();
        }    
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.employe-shift-migrate')
        .controller('viewDetailShiftMigrateController', viewDetailShiftMigrateController);

    viewDetailShiftMigrateController.$inject = ['$mdDialog','data','$localStorage','config','AppAPI','DataService','Form'];

    /* @ngInject */
    function viewDetailShiftMigrateController($mdDialog,data,$localStorage,config,AppAPI,DataService,Form) {
        var vm = this; 

        var Employeshift = AppAPI.EmployeShiftMigrate();
        vm.Form = Form;
        Form.initialForm();
        Form.setObject(Employeshift);
        vm.closeModal=closeModal;
        vm.items = data;
        vm.update = update;
        
        function closeModal()
        {
            $mdDialog.hide();
        }

        function update(ev,frm) 
        {
            angular.element.blockUI();
            vm.Form.objForm.date        = data.date;
            vm.Form.objForm.nik         = data.nik;
            vm.Form.objForm.old_value   = data.old_value;
            vm.Form.objForm.new_value   = data.new_value;

            var response = Form.saveData('saveData', frm, Employeshift);
            response.then(function(data) {
                angular.element.unblockUI();
                frm.$setPristine(); 
                data.title = "Success";
                showDialogInfo(ev, data);
            });
      
            response.catch(function(data) {
                angular.element.unblockUI();
                data.title = "Failed";
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) 
        {
            $mdDialog
            .show(
                $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(data.title)
                .textContent(data.message)
                .ariaLabel(data.title)
                .ok('OK')
                .targetEvent(ev)
            )
            .then(function() {
                closeModal();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.employe-shift')
        .controller('UploadshiftController', UploadshiftController);

    UploadshiftController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window'];

    /* @ngInject */
    function UploadshiftController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window) {
         var vm = this;
         // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        vm.detailInfo = []
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';  
        vm.DownloadTemplate = DownloadTemplate;

        var uploaderPhoto= vm.FileUpload= new FileUploader({
           url:config.api+'api/employeshift/uploadshift', 
           removeAfterUpload:true,
           alias:'fileshift',
           formData:[
              {
               action:'uploadshift'
              }
           ],
            onAfterAddingAll:function(){
                vm.uploadSuccess = false;
                vm.uploadError = false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item,status) {
            if ( status.status == 0 ) {
                vm.uploadSuccess = false;
                vm.uploadError   = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError   = false;
            }

            vm.uploadNotif = status.message
            if ('moreInfo' in status && status.moreInfo.length>0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
            vm.uploadSuccess = false;
            vm.uploadError = true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function viewMoreInfo()
        {
            $mdDialog.show({
                controller         : 'logFailGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                data:vm.detailInfo
                }
            });
        }

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/employeshift/downloadshifttemplate', '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.employe-shift')
        .controller('UploadshiftngController', UploadshiftngController);

    UploadshiftngController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window'];

    /* @ngInject */
    function UploadshiftngController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window) {
        var vm = this;
        // vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        vm.detailInfo = []
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.DownloadTemplate = DownloadTemplate;

        ////////////////
        var uploaderPhoto= vm.FileUpload= new FileUploader({
           url:config.api+'api/employeshift/uploadshiftnongroup', 
           removeAfterUpload:true,
           alias:'fileshift',
           formData:[
              {
               action:'uploadshift'
              }
           ],
            onAfterAddingAll:function(){
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers:{
                tokenAuth:$localStorage.tokenAuth
            }
        }); 

        uploaderPhoto.onSuccessItem = function(item, status) {
            if ( status.status == 0 ) {
                vm.uploadSuccess = false;
                vm.uploadError   = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError   = false;
            }
    
            vm.uploadNotif = status.message
            if ('moreInfo' in status && status.moreInfo.length>0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
            vm.uploadSuccess = false;
            vm.uploadError = true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function viewMoreInfo()
        {
            $mdDialog.show({
                controller         : 'logFailGwController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                locals:{
                data:vm.detailInfo
                }
            });
        }

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/employeshift/downloadshiftngtemplate', '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }
    }
})();
(function(){
  'use strict';

  angular
    .module('app.cb.employe-shift')
    .controller('UnsetShiftController', UnsetShiftController);

    UnsetShiftController.$inject =  ['$mdDialog', 'data'];

    function UnsetShiftController($mdDialog, data) {
      console.log(data);
      var vm = this;
      vm.data = data;
      vm.closeModal = closeModal;
	    
	    function closeModal(){
	      $mdDialog.cancel();
	    }

    }


})();
(function() {
    'use strict';

    angular
        .module('app.cb.employe-shift')
        .controller('InputempshiftController', InputempshiftController);

    InputempshiftController.$inject = ['$localStorage','$http','$mdDialog','Form','AppAPI','config'];

    /* @ngInject */
    function InputempshiftController($localStorage,$http,$mdDialog,Form,AppAPI,config) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Employeshift = AppAPI.Employeshift();

        // set constructor form
        Form.setObject(Employeshift);

        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal; 
        var empID=$localStorage.username; 
        vm.LoadLocation=LoadLocation;
        vm.querySearch   = querySearch;
        vm.selectedItemChanged = selectedItemChanged;  
        LoadLocation(); 
        // console.log(id); 
        ////////////////
 

        function LoadLocation() {
            var response=Employeshift.query({action:'getLocation'});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

          function fetchLocation(data) {
            vm.listLocation=data;
          }

        function errorFetchLocation() {
            vm.listLocation=[];
          }  


       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) {
            vm.Form.objForm.nik=vm.emp_no;  
            var promise= Form.saveData('save', formController, Employeshift);
            promise.then(function(){
                showDialog(ev);
            });
        }

        function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

       function querySearch (query) { 
           return $http
          .get(config.api + 'api/employeshift?action=searchEmp&id=' + query)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){

            }   
              return item.data;
          });
        }
         

        function selectedItemChanged(item) { 
          if(typeof item!=='undefined')
          { 
            vm.emp_no=item.emp_no;
            vm.empId=item.empId;
            vm.emp_name=item.nama;
            vm.position=item.position;
            vm.isDisabled=true; 
          } 
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-shift')
        .controller('EmployeshiftController', EmployeshiftController);


    EmployeshiftController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function EmployeshiftController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {

        var vm = this;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.editData=editData;
        vm.toggleSelectedAll=toggleSelectedAll;
        var Employeshift=AppAPI.Employeshift();
        vm.inputShiftLocation= inputShiftLocation;
        vm.lisShiftSelected=[];
        vm.DeleteData=DeleteData;
        vm.uploadShift=uploadShift;
        vm.uploadShiftNonGroup=uploadShiftNonGroup;
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;
        var Employeshiftt=AppAPI.Overtime();
        vm.company=$localStorage.empsite; 
        var Employe = AppAPI.Employe();
        vm.unsetShiftDetail = unsetShiftDetail;


        vm.Breadlist=[
                    {link:'#',name:'C&B / ',active:'0'}
                    ];
         totUnset();


        function inputShiftLocation(ev,id)
        {
            $mdDialog.show({
                controller         : 'InputempshiftController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/employe-shift/input-employe-shift.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            });

        }
        loadDataBU();
        loadDataDivision(vm.company);
        //////////

        // function loadData()
        // {
        //   var resp=Employeshift.query({action:'viewdata'});
        //       resp.$promise.then(function(data){
        //         vm.listData=data[0];
        //         console.log(vm.listData);
        //         angular.element.unblockUI();
        //       });
        //       resp.$promise.catch(function(data){
        //         $log.info(data);
        //         angular.element.unblockUI();
        //       });
        // }

        function loadData(pageno)
          {
            var resp=vm.DataTable.loadData(Employeshift,pageno,{action:'viewdata',company:vm.company,divisi:vm.divisi,departement:vm.department,start_date:vm.start_date,end_date:vm.end_date});
             vm.listselected=[];
            resp.then(function(){
               // vm.abs_code='';
             });
          }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.lisShiftSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.lisShiftSelected=[];
          }
        function editData(id){
          $state.go('app.utility_modul_edit-modul',{id:id});
        }


        function closeModal()
        {
            $mdDialog.hide();
        }

    function DeleteData(ev,ls) {
          var promise=Auth.setToken();
         promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data your selected will be deleted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

      $mdDialog.show(confirm).then(function() {
          angular.element.blockUI();
         var response=Employeshift.delete({action:'delete',data:angular.toJson(ls)});

         response.$promise.then(loadData);
      }, function() {
       // $scope.status = 'You decided to keep your debt.';
      });
         });


      }

    function uploadShift(ev) {
      $mdDialog.show({
          controller         : 'UploadshiftController as vm',
          templateUrl        : 'app/main/cb/employe-shift/upload-shift.html',
          parent             : angular.element($document.body),
          targetEvent        : ev,
          clickOutsideToClose: true
      });
    }

    function uploadShiftNonGroup(ev) {
      $mdDialog.show({
          controller         : 'UploadshiftngController as vm',
          templateUrl        : 'app/main/cb/employe-shift/upload-shift-ng.html',
          parent             : angular.element($document.body),
          targetEvent        : ev,
          clickOutsideToClose: true
      });
    }

    function loadDataDepartment(iddivisi) {
       var response=Employeshiftt.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment=data;
      // loadData(1);
    }

    function errorDepartment() {
      vm.listDepartment=[];
    }

    function loadDataDivision(idbu) {
       var response=Employeshiftt.query({action:'viewDivisiBu',idbu:idbu});
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
     vm.listDivision=data;
     // loadData(1);
    }

    function errorDivisiBU() {
      vm.listDivision=[];
    }

    function loadDataBU() {
      var response=Employeshiftt.query({action:'viewBu'});
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU=data;
    }

    function errorFetchBU() {
      vm.listBU=[];
    }

    function unsetShiftDetail(data, ev){
      $mdDialog.show({
        controller         : 'UnsetShiftController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/cb/employe-shift/unset-shift.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: true,
        onRemoving:function(element, removePromise){

        },
        locals:{
          data:data
        }
      }); 
    }

    function totUnset(){
      var response = Employe.query({action:'shiftInfo'});
      response.$promise.then(function(data){
        vm.totUnsetShift = data.length;
        vm.unsetShift = data;
      });
    }
    
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-overtime-gw', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_employe_overtime_gw', {
                url    : '/cb/employe-overtime-gw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employe-overtime-gw/index.html',
                        controller : 'EmployeOvertimeGwController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';
    angular
        .module('app.cb.employe-overtime-gw')
        .controller('UploadEmployeOvertimeGwController', UploadEmployeOvertimeGwController);

    UploadEmployeOvertimeGwController.$inject = [
        '$state',
        '$mdDialog',
        'config',
        '$localStorage',
        '$timeout',
        'AppAPI',
        'Auth',
        'FileUploader',
        '$location',
        '$window'


    ];
    /** @ngInject */
    function UploadEmployeOvertimeGwController(
        $state,
        $mdDialog,
        config,
        $localStorage,
        $timeout,
        AppAPI,
        Auth,
        FileUploader,
        $location,
        $window

    ) {
        var vm = this;

        vm.closeModal = closeModal

        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.DownloadTemplate = DownloadTemplate;
        vm.isMoreInfo = false
        vm.viewMoreInfo = viewMoreInfo
        vm.detailInfo = []

        vm.FileUpload = new FileUploader({
            url: config.api + 'api/employeovertimegw/upload',
            removeAfterUpload: true,
            alias: 'file',
            formData: [{
                action: 'upload'
            }],
            onAfterAddingAll: function () {
                vm.uploadSuccess = false;
                vm.uploadError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
            if (status.status == 0) {
                vm.uploadSuccess = false;
                vm.uploadError = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError = false;
            }

            vm.uploadNotif = status.pesan
            if ('moreInfo' in status && status.moreInfo.length > 0) {
                vm.isMoreInfo = true;
                vm.detailInfo = status.moreInfo;
            }

            angular.element('#uploadCutOff').val('');

        };

        vm.FileUpload.onErrorItem = function () {
            vm.uploadSuccess = false;
            vm.uploadError = true;

        };

        function closeModal() {
            $mdDialog.hide();
        }

        function DownloadTemplate() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                // var host='localhost:3000/';
                $window.open(protocol + '://' + host + config.api + 'api/employeovertimegw/downloadtemplate', '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }

        function viewMoreInfo() {
            $mdDialog.show({
                controller: 'logFailGwController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: vm.detailInfo
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.employe-overtime-gw')
        .controller('searchEmpOtGwController', searchEmpOtGwController);

    searchEmpOtGwController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','DataService'];

    /* @ngInject */
    function searchEmpOtGwController($localStorage,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,DataService) {
        var vm = this; 
        // initial form
        Form.initialForm(); 
        var Employeghk = AppAPI.EmployeOvertimeGw();
        // set constructor form
        Form.setObject(Employeghk); 
        // set form to controller
        vm.Form = Form; 
        vm.closeModal = closeModal;
        vm.DataTable= new DataService();
        vm.detail=detail; 

   
        vm.loadData = loadData
        var nik= $localStorage.user;

 
        // function loadData(pageno) {
        //     var resp=vm.DataTable.loadData(Employeghk,pageno,{action:'searchEmployeeGhk',working_date:vm.working_date,replacementType:replacementType});
        //     resp.then(function(data) {
        //         vm.listSelected = [];
        //         vm.items = data.list;
        //     });
        // }

        function loadData(id)
        {

            var response= Employeghk.query({action:'searchEmployeeOt',ot_date:vm.ot_date,nik:vm.nik});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {
            vm.items = data;
        }

        function errorFetchDetail() {
            vm.items = [];
        } 


        function closeModal()
        {
            $mdDialog.hide();
        }

        
        function reloadToken(){
            Auth.setToken();
        }

    function detail(ev, data)
      {
         $mdDialog.show({
            controller: 'DetailEmployeOvertimeGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/employe-overtime-gw/create.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data
            }
          }); 
      }
  
    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.employe-overtime-gw')
    .controller('EmployeOvertimeGwController', EmployeOvertimeGwController);


  EmployeOvertimeGwController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage'];
  /** @ngInject */
  function EmployeOvertimeGwController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage) {

    var vm = this;
    vm.deleteData = deleteData;
    vm.detail = detail
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var EmployeOtGw = AppAPI.EmployeOvertimeGw();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listselected = [];
    vm.approveOT = approveOT;
    vm.InputGhk = InputGhk;
    vm.viewComment = viewComment;

    vm.closeModal = closeModal

    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.Upload = Upload
    vm.detailApproval = detailApproval;
    vm.searchEmployee=searchEmployee;

    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];

    var date = new Date();
    vm.tahun = date.getFullYear();
    vm.bulan = date.getMonth() + 1;
    vm.getPeriode = getPeriode;
    vm.tgl = date.getDate();
    if (vm.tgl >= 25 && vm.tgl <= 31) {
      if (vm.bulan == 12) {
        vm.bulan = '01';
      } else {
        vm.bulan = vm.bulan + 1;
      }
    }
    if (vm.bulan < 10) {
      vm.bulan = '0' + vm.bulan;
    }

    vm.listtahun = [2017, 2018, 2019,2020,2021];
    vm.listbulan = [{ name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'Maret', value: '03' },
    { name: 'April', value: '04' },
    { name: 'Mei', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'Desember', value: '12' }];



    //////////
    // loadData(1);
    getPeriode();

    vm.currentot = 0;
    vm.periode = "";
    // var res= EmployeOtGw.query({action:'getCurrentOt'});
    //       res.$promise.then(function(data){
    //        vm.currentot=vm.currentot + data[0].overtime;
    //        vm.periode=data[0].periode;
    //       console.log(data);
    //     });

    //     res.$promise.catch(function(data){
    //       // $log.info(data);
    //     });

    // function loadData(pageno)
    // {
    //   var resp=vm.DataTable.loadData(EmployeOtGw,pageno,{action:'viewdata',nik:nik,tahun:vm.tahun,bulan:vm.bulan,type:vm.type});
    //   resp.then(function(data) {
    //       vm.listselected = [];
    //       vm.items = data.list;
    //   });
    // }
    function loadData(pageno) {
      var workingDate = angular.copy(vm.workingDate);
      if (typeof (workingDate) != 'undefined') {
        workingDate = moment(workingDate).format("YYYY-MM-DD");
      }
      var resp = vm.DataTable.loadData(EmployeOtGw, pageno, { action: 'viewdata', nik: nik, periode: vm.datePeriode, type: vm.type, workingDate: workingDate });
      resp.then(function (data) {
        vm.listselected = [];
        vm.items = data.list;
      });
    }

    function getPeriode() {
      var res = Attendanceemploye.query({ action: 'getPeriode', tahun: vm.tahun, bulan: vm.bulan, flag_app: 'HRIS' });
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data) {
      vm.periode = data[0]['periode'];
      vm.datePeriode = data[0]['datePeriode'];
    }

    function errorfetchPeriode(data) {
      console.log('error');
      // vm.searchComplete=true;
    }

    function deleteData(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = EmployeOtGw.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
          response.$promise.then(function (resData) {
            angular.element.unblockUI();
            if (resData.status == 1) {
              var title = 'Success Delete Data';
              var textContent = resData.message;
              var ariaLabel = 'Success Delete Data';
            } else {
              var title = 'Delete Data Failed';
              var textContent = resData.message;
              var ariaLabel = 'Delete Data Failed';
            }

            showDialogMessage(title, textContent, ariaLabel);
            loadData(1);
          });
          response.$promise.catch(function (resData) {
            angular.element.unblockUI();
            var title = 'Delete Data Failed';
            var textContent = resData.message;
            var ariaLabel = 'Delete Data Failed';
            showDialogMessage(title, textContent, ariaLabel, ev);
          })
        }, function () {

        });
      });
    }

    function isChecked(ls) {
      // return vm.listselected.indexOf(ls) > -1;
      return vm.listselected.length === vm.items.length;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listselected.indexOf(ls);

      if (idx > -1) {
        vm.listselected.splice(idx, 1);
      }
      else {
        vm.listselected.push(ls);
      }
    }

    function toggleAll() {
      if (vm.listselected.length === vm.items.length) {
        vm.listselected = [];
      } else if (vm.listselected.length === 0 || vm.listselected.length > 0) {
        vm.listselected = vm.items.slice(0);
      }
    }

    function isIndeterminate() {
      return vm.listselected.length !== 0 && vm.listselected.length !== vm.items.length;
    }

    function approveOT(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to Approve this list?')
          .textContent('All data your selected will be approve.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');
        $mdDialog.show({
          multiple: true
        });
        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          // console.log(vm.listselected);
          var ot = new EmployeOtGw();
          ot.data = [];
          ot.action = 'approve';
          ot.nik = nik;
          ot.approval_type = 'n1';
          var jum = vm.listselected.length, i, ids = [];
          for (i = 0; i < jum; i++) {
            ot.data.push({ id: vm.listselected[i].id });
          }
          var idtx = encodeURIComponent(angular.toJson(ids));
          var response = ot.$save();
          //var response=tm.$delete({action:'approve'});
          response.then(loadData);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });

    }

    function InputGhk(ev, id) {
      $mdDialog.show({
        controller: 'CreateEmployeOvertimeGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/employe-overtime-gw/create.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id
        }
      });

    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'GhkGwViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-gw/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          // vm.listOtselected=[];
          loadData();
        },
        locals: {
          data: id
        }
      });
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function showDialogMessage(title, textContent, ariaLabel, ev) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }

    function detail(ev, data) {
      $mdDialog.show({
        controller: 'DetailEmployeOvertimeGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/employe-overtime-gw/create.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function Upload(ev) {
      $mdDialog.show({
        controller: 'UploadEmployeOvertimeGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/employe-overtime-gw/upload.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true, // Only for -xs, -sm breakpoints.
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function detailApproval(ev, data) {
      $mdDialog.show({
        controller: 'DetailApprovalListGhkOvertimeGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-holiday-gw/detail-approval.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          // loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function searchEmployee(ev)
      {
        $mdDialog.show({
            controller         : 'searchEmpOtGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/employe-overtime-gw/search-employee.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{  
              
            }
        });
      }

  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.employe-overtime-gw')
        .controller('DetailEmployeOvertimeGwController', DetailEmployeOvertimeGwController)
        .config(function($mdDateLocaleProvider) {
            $mdDateLocaleProvider.formatDate = function(date) {
          
              var day = date.getDate();
              var monthIndex = date.getMonth();
              var year = date.getFullYear();
          
              return day + '/' + (monthIndex + 1) + '/' + year;
          
            };
          });

    DetailEmployeOvertimeGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data'];

    /* @ngInject */
    function DetailEmployeOvertimeGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var EmployeOvertimeGw = AppAPI.EmployeOvertimeGw();

        // set constructor form
        Form.setObject(EmployeOvertimeGw);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;
        vm.disable = vm.isEdit =true;
        vm.edit = true;
        vm.Form.objForm.isHasApproved = vm.hasApprove = data.can_modify==0 ? true : false;
        vm.setEdit = setEdit;

        vm.closeModal = closeModal;  
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();

        vm.reloadToken=reloadToken; 
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.exist=exist;
        vm.toggleCheck = toggleCheck;
        vm.listSelected=[];
        vm.Form.objForm.approval = data.approval;
        vm.isStatus = isStatus;
        vm.canModify = data.can_modify;
        vm.canDelete = data.can_delete;
        vm.getDataListEmploye = getDataListEmploye;
        vm.AddEmployeeList=AddEmployeeList;
        vm.removeEmployee=removeEmployee;
        vm.empSelected=[];
        vm.isStartSameDate= data.isStartSameDate;
        vm.setSameDate = setSameDate;

        loadDetail(data.id);
        setData();
        

        ////////////////f
        function setSameDate(param)
        {
            if (param != '1'){
                vm.isStartSameDate = "1";
            }else{
                vm.isStartSameDate = "0";
            }
        }
        
        function setData()
        {
            console.log(data)
            vm.Form.objForm.ot_date = new Date(data.ot_date);
            vm.Form.objForm.end_time = data.iEnd_time
            vm.Form.objForm.ot_type = data.ot_type
            vm.Form.objForm.resthour = parseInt(data.rest_hour)
            vm.Form.objForm.start_time = data.iStart_time
            vm.Form.objForm.reason = data.reason
            vm.Form.objForm.isafter = data.is_after
            getDataListEmploye();
        }

        
       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            vm.Form.objForm.listEmploye = vm.empSelected;
            vm.Form.objForm.id = data.id;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;

            var promise= Form.saveData('update', formController, EmployeOvertimeGw);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
          console.log(data);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }

            // console.log(state);
        }

        function checkAll() {
           vm.listSelected=angular.copy(vm.listemploye);
        }

        function unCheckAll() {
           vm.listSelected=[];
        }

        function isChecked(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = true;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function isStatus(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.empSelected.length > 0 ) {
                angular.forEach(vm.empSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = value.status1;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event)
        {

            if ( event )
            {
                event.stopPropagation();
            }

            var arrTemp = []
            var exist = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    
                        if ( value.nik != ls.nik ) {
                            
                            // arrTemp.push(ls)
                            arrTemp.push(value)
                        } else {
                            exist = true
                        }    
                    
                    
                });
                if ( !exist ) {
                    arrTemp.push(ls)
                }
            } else {
                arrTemp.push(ls)
            }


            vm.listSelected = arrTemp
            // var idx = vm.listSelected.indexOf(ls);

            // if ( idx > -1 )
            // { 
            //     vm.listSelected.splice(idx, 1);
            // }
            // else
            // {
            //     vm.listSelected.push(ls);
            // }
        }

        function getDataListEmploye(pageno)
        {
            if(typeof(vm.Form.objForm.ot_type)!=="undefined" && typeof(vm.Form.objForm.ot_date)!=="undefined"){
                var resp=EmployeOvertimeGw.query({action:'getEmployelist',nik:$localStorage.user,type:vm.Form.objForm.ot_type,start:vm.Form.objForm.ot_date,end:vm.Form.objForm.ot_date});
                resp.$promise.then(function(data) {
                    vm.listselected = [];
                    vm.items = data;
                    var jum=vm.items.length;
                    angular.element.unblockUI();
                });
            }
        }

        function loadDetail(id)
        {
            var response= EmployeOvertimeGw.query({action:'getDetail',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {

            angular.forEach(data, function(value, key) {
                var emp = {
                    nik : value.nik,
                    nik_atasan : value.nik_atasan,
                    nama : value.nama,
                    status : value.status
                }
                vm.empSelected.push(value);              
            });
            angular.element.blockUI();
            getDataListEmploye(1);
        }

        function errorFetchDetail() {
            vm.empSelected = [];
            angular.element.blockUI();
            getDataListEmploye(1);
        }

        function setEdit (status)
        {
            vm.disable = status;
        }

        function AddEmployeeList()
        {
            var obj=vm.listSelected;  
            angular.forEach(obj, function (value,key) 
            {
               var ifSelected=checkIfExistInselected(value.nik,vm.empSelected);
               if(!ifSelected){
                    var emp = {
                            nik : value.nik,
                            nik_atasan : value.nik_atasan,
                            nama : value.name,
                            status1 : 'Waiting Approval'
                        }
                 vm.empSelected.push(emp);
                 vm.listSelected=[];
               }
            });
            
        }

        function checkIfExistInselected(value,arrSelected)
        {
             var ifSelected=false;
             var len=arrSelected.length;
             for (var i=0;i<len;i++)
             {
                if(arrSelected[i].nik==value){
                    ifSelected=true;
                }
                // console.log(value);
                // console.log(arrSelected[i]);
             }

             return ifSelected;
        }

        function removeEmployee(ls)
        {
             var idx = vm.empSelected.indexOf(ls);
             if ( idx > -1 )
              {
                  vm.empSelected.splice(idx, 1);
              }
              // console.log(vm.empSelected);
             
             
        }
        

    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.employe-overtime-gw')
        .controller('DetailApprovalListGhkOvertimeGwController', DetailApprovalListGhkOvertimeGwController);

    DetailApprovalListGhkOvertimeGwController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data'];

    /* @ngInject */
    function DetailApprovalListGhkOvertimeGwController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data) {
        var vm = this; 

        var EmployeOt = AppAPI.EmployeOvertimeGw(); 
        vm.closeModal=closeModal;
          
        loadDetail(data.id); 

        function closeModal()
        {
            $mdDialog.hide();
        }   

        function loadDetail(id)
        {
            var response= EmployeOt.query({action:'getDetail',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {
            vm.items = data;
        }

        function errorFetchDetail() {
            vm.items = [];
        }   
    }
})();
(function() {
    "use strict";

    angular
        .module("app.cb.employe-overtime-gw")
        .controller(
            "CreateEmployeOvertimeGwController",
            CreateEmployeOvertimeGwController
        );
    // .config(function($mdDateLocaleProvider) {
    //     $mdDateLocaleProvider.formatDate = function(date) {

    //       var day = date.getDate();
    //       var monthIndex = date.getMonth();
    //       var year = date.getFullYear();

    //       return day + '/' + (monthIndex + 1) + '/' + year;

    //     };
    //   });

    CreateEmployeOvertimeGwController.$inject = [
        "$localStorage",
        "DataService",
        "$mdDialog",
        "Form",
        "AppAPI",
        "$log",
        "config",
        "Auth",
        "$mdToast",
        "$scope"
    ];

    /* @ngInject */
    function CreateEmployeOvertimeGwController(
        $localStorage,
        DataService,
        $mdDialog,
        Form,
        AppAPI,
        $log,
        config,
        Auth,
        $mdToast,
        $scope
    ) {
        var vm = this;
        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var EmployeOvertimeGw = AppAPI.EmployeOvertimeGw();

        // set constructor form
        Form.setObject(EmployeOvertimeGw);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess = false;
        vm.disable = false;
        vm.edit = false;

        vm.closeModal = closeModal;

        vm.listJum = [5, 10, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.DataTable.jumDataPerPage = 10;

        vm.reloadToken = reloadToken;

        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listSelected = [];
        vm.canModify = vm.canDelete = 1;

        vm.AddEmployeeList = AddEmployeeList;
        vm.removeEmployee = removeEmployee;
        vm.checkIfExistInselected = checkIfExistInselected;
        vm.empSelected = [];
        vm.isStatus = isStatus;
        vm.minHour = 0;

        vm.getEmployelist = getEmployeList;
        /*=====================*/

        function getEmployeList(pageno) {
            if (
                typeof vm.Form.objForm.ot_type !== "undefined" &&
                typeof vm.Form.objForm.ot_date !== "undefined" &&
                typeof vm.Form.objForm.ot_date !== "undefined"
            ) {
                angular.element.blockUI();
                var resp = EmployeOvertimeGw.query({
                    action: "getEmployelist",
                    nik: $localStorage.user,
                    type: vm.Form.objForm.ot_type,
                    start: vm.Form.objForm.ot_date,
                    end: vm.Form.objForm.ot_date
                });
                resp.$promise.then(function(data) {
                    vm.listselected = [];
                    vm.items = data;
                    var jum = vm.items.length;
                    angular.element.unblockUI();
                });
                resp.$promise.catch(function(data) {
                    vm.items = [];
                    angular.element.unblockUI();
                });
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.saveProcess = true;
            vm.Form.objForm.listEmploye = vm.empSelected;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;

            var promise = Form.saveData(
                "save",
                formController,
                EmployeOvertimeGw
            );
            promise.then(function(data) {
                if (data.status == 1) {
                    showDialog(ev, data);
                } else {
                    showFailed(ev, data);
                }
            });

            promise.catch(function(data) {
                showFailed(ev, data.data);
            });
        }

        function showDialog(ev, data) {
            vm.saveProcess = false;
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title("Success Save Data")
                        .textContent(data.pesan)
                        .ariaLabel("Success Save Data")
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function() {
                    if ("moreInfo" in data && data.moreInfo.length > 0) {
                        $mdDialog.show({
                            controller: "logFailGwController",
                            controllerAs: "vm",
                            templateUrl: "app/main/cb/ghk-gw/log-fail.html",
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: true,
                            onRemoving: function(element, removePromise) {
                                loadData(1);
                            },
                            locals: {
                                data: data.moreInfo
                            }
                        });
                    }
                });
        }

        function showFailed(ev, data) {
            vm.saveProcess = false;
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title("Failed Save Data")
                        .textContent(data.pesan)
                        .ariaLabel("Failed Save Data")
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function() {
                    // closeModal();
                });
            console.log(data);
        }

        function ChangeDayType() {
            if (vm.Form.objForm.daytype == "halfday") {
                vm.Form.objForm.end_date = vm.Form.objForm.start_date;
                vm.enddaterequire = false;
                vm.timerequire = true;
                vm.timedisabled = false;
            } else {
                vm.enddaterequire = true;
                vm.timerequire = false;
                vm.timedisabled = true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken() {
            Auth.setToken();
        }

        function changeShiftType() {
            if (vm.Form.objForm.shifttype === "nongroup") {
                vm.Form.objForm.start_template = "NG00-Full";
                vm.unscheduleshift = true;
            } else {
                vm.Form.objForm.start_template = null;
                vm.unscheduleshift = false;
            }
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }

            // console.log(state);
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.listemploye);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function isChecked(ls) {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if (idx > -1) {
                vm.listSelected.splice(idx, 1);
            } else {
                vm.listSelected.push(ls);
            }
        }

        function getDataListEmploye(pageno) {
            var resp = vm.DataTable.loadData(EmployeOvertimeGw, pageno, {
                action: "getEmployelist",
                nik: $localStorage.user
            });
            resp.then(function(data) {
                vm.listselected = [];
                vm.items = data.list;
            });

            // var response= EmployeOvertimeGw.query({action:'getEmployelist',nik:$localStorage.user});
            //         response.$promise.then(function(data){
            //         vm.listemploye=data;
            //     // console.log(vm.listemploye);
            //     });

            //     response.$promise.catch(function(data){
            //         $log.info(data);
            //     });
        }

        function AddEmployeeList() {
            var obj = vm.listSelected;
            angular.forEach(obj, function(value, key) {
                var ifSelected = checkIfExistInselected(
                    value.nik,
                    vm.empSelected
                );
                if (!ifSelected) {
                    var emp = {
                        nik: value.nik,
                        nik_atasan: value.nik_atasan,
                        nama: value.name,
                        status: "Waiting Approval"
                    };
                    vm.empSelected.push(emp);
                    vm.listSelected = [];
                }
            });
        }

        function checkIfExistInselected(value, arrSelected) {
            var ifSelected = false;
            var len = arrSelected.length;
            for (var i = 0; i < len; i++) {
                if (arrSelected[i].nik == value) {
                    ifSelected = true;
                }
                // console.log(value);
                // console.log(arrSelected[i]);
            }

            return ifSelected;
        }

        function removeEmployee(ls) {
            var idx = vm.empSelected.indexOf(ls);
            if (idx > -1) {
                vm.empSelected.splice(idx, 1);
            }
            // console.log(vm.empSelected);
        }

        function isStatus(ls) {
            var val = false;
            var breakEach = false;
            if (vm.empSelected.length > 0) {
                angular.forEach(vm.empSelected, function(value, key) {
                    if (!breakEach) {
                        if (value.nik == ls.nik) {
                            val = value.status;
                            breakEach = true;
                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        $scope.$watch("vm.Form.objForm.start_time", function(nVal, oVal) {
            if (nVal) {
                if (!vm.Form.objForm.end_time) {
                    return;
                }
                var diff = getDiffHours(
                    parseDate(nVal),
                    parseDate(vm.Form.objForm.end_time)
                );
                setMinHour(diff);
            }
        });

        $scope.$watch("vm.Form.objForm.end_time", function(nVal, oVal) {
            if (nVal) {
                if (!vm.Form.objForm.start_time) {
                    return;
                }
                var diff = getDiffHours(
                    parseDate(vm.Form.objForm.start_time),
                    parseDate(nVal)
                );
                setMinHour(diff);
            }
        });

        function getDiffHours(start, end) {
            // console.log("start", start);
            // console.log("end", end);

            var t1 = moment(start);
            var t2 = moment(end);
            var diff = moment.duration(t2.diff(t1));
            return diff.asHours();
        }

        function setMinHour(diff) {
            var company = $localStorage.empSite;
            if (company === "RK") {
                if (diff < 5) {
                    vm.minHour = 0;
                } else if (diff >= 5) {
                    vm.minHour = 1;
                } else if (diff >= 12) {
                    vm.minHour = 2;
                }
            } else {
              if(vm.Form.objForm.ot_type=='NORMAL'){
                    if (diff <= 4) 
                    {
                        vm.minHour = 0;
                    } else if (diff > 4) {
                        vm.minHour = 1;
                    }
                }else{
                    if (diff <=5) 
                    {
                        vm.minHour = 0;
                    } else if (diff > 5) {
                        vm.minHour = 1;
                    }
                }
            }
        }

        function parseDate(dt) {
            var splitted = dt.split(" ");
            var dateSplit = splitted[0].split("/");
            var dtGlue =
                dateSplit[2] +
                "-" +
                dateSplit[1] +
                "-" +
                dateSplit[0] +
                " " +
                splitted[1] +
                ":00";
            return dtGlue;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.list-overtime', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_list_overtime', {
                url    : '/cb/list-overtime',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/list-overtime/list-overtime.html',
                        controller : 'ListOtController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.list-overtime')
        .controller('EmployeeOtteamController', EmployeeOtteamController);

    EmployeeOtteamController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI'];

    /* @ngInject */
    function EmployeeOtteamController($localStorage,id,$mdDialog,Form,AppAPI) {
        var vm = this;
            vm.saveData=saveData;
            // initial form
        Form.initialForm();

        var Attendanceemploye = AppAPI.Attendanceemploye();

        // set constructor form
        Form.setObject(Attendanceemploye);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal; 
        vm.gender = ['L','P'];

        
 
        vm.request=false;
        vm.Form.tampilPesan=false;
        vm.listtime=id.team;
        console.log(vm.listtime);

        
        ////////////////

         
       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController) { 

            var promise= Form.saveData('updatefinger', formController, Attendanceemploye);
            promise.then(function(){
                showDialog(ev);
            });

            promise.catch(function(){
               ShowFailed(ev)  
            });

        }

        function showDialog(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent('Process Data was Success.')
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent('Please Recheck Your Data.')
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.list-overtime')
    .controller('EmployeotController', EmployeotController);


  EmployeotController.$inject = ['$state', '$log', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function EmployeotController($state, $log, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {
    var vm = this;
    var translate = $filter('translate');

    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var EmployeOT = AppAPI.Employeot();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listselected = [];
    vm.setViewTeam = setViewTeam;
    vm.viewComment = viewComment;
    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];

    var date = new Date();
    vm.tahun = date.getFullYear();
    vm.bulan = date.getMonth() + 1;
    vm.getPeriode = getPeriode;
    vm.tgl = date.getDate();
    if (vm.tgl >= 25 && vm.tgl <= 31) {
      if (vm.bulan == 12) {
        vm.bulan = '01';
      } else {
        vm.bulan = vm.bulan + 1;
      }
    }
    if (vm.bulan < 10) {
      vm.bulan = '0' + vm.bulan;
    }

    vm.listtahun = [2017, 2018, 2019, 2020, 2021];
    vm.listbulan = [{ name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'Maret', value: '03' },
    { name: 'April', value: '04' },
    { name: 'Mei', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'Desember', value: '12' }];


    getPeriode();
    loadData(1);
    ////////// 
    function getPeriode() {
      var res = Attendanceemploye.query({ action: 'getPeriode', tahun: vm.tahun, bulan: vm.bulan });
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data) {
      vm.periode = data[0]['periode'];
      // console.log(vm.periode);
      // loadData(1);
      // vm.searchComplete=false;
    }

    function errorfetchPeriode(data) {
      console.log('error');
      // vm.searchComplete=true;
    }

    vm.currentot = 0;
    vm.periode = "";
    var res = EmployeOT.query({ action: 'getCurrentOt' });
    res.$promise.then(function (data) {
      vm.currentot = vm.currentot + data[0].overtime;
      vm.periode = data[0].periode;
      console.log(data);
    });

    res.$promise.catch(function (data) {
      $log.info(data);
    });

    function loadData(pageno) {
      var resp = vm.DataTable.loadData(EmployeOT, pageno, { action: 'viewdata', tglmulai: vm.tglmulai, tglakhir: vm.tglakhir, type: vm.type });
    }


    function editData(id) {
      $state.go('app.cb_employe_overtime_edit_employe_ot', { id: id });
    }


    function isChecked(ls) {
      return vm.listselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listselected.indexOf(ls);

      if (idx > -1) {
        vm.listselected.splice(idx, 1);
      }
      else {
        vm.listselected.push(ls);
      }
    }

    function deleteData(ev) {

      var confirmdel = translate('PAYROLL.MESSAGE.CONFDEL');
      var note = translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(confirmdel)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () 
        {
          angular.element.blockUI();
          var response = EmployeOT.delete({ action: 'delete', data: angular.toJson(vm.listselected) }); 
          // response.$promise.then(loadData);
          // angular.element.unblockUI();
          response.$promise.then(function (resData) { 
            angular.element.unblockUI();
            var title = 'Success Delete Data';
            var textContent = resData.message;
            var ariaLabel = 'Success Delete Data';
            showDialogMessage(title, textContent, ariaLabel);
             
          });
          response.$promise.catch(function (resData) {
            angular.element.unblockUI();
            console.log(resData.data);
            var title = 'Delete Data Failed';
            var textContent = resData.data;
            var ariaLabel = 'Delete Data Failed';
            showDialogMessage(title, textContent, ariaLabel); 
          })
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });


    }

    // function setViewTeam(ls)
    // {
    //   console.log(ls);
    // }

    function setViewTeam(ev, id) {
      $mdDialog.show({
        controller: 'EmployeeOtteamController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/employe-overtime/employeeot-team.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id
        }
      });
    }

    
    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'ApprovalotViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ot/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id
        }
      });
    }

    function showDialogMessage(title, textContent, ariaLabel, ev) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }
   

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-outlet-ot', ['app.cb.employe-outlet-ot.input-emp-outlet-ot'])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_emp_outlet_ot', {
                url    : '/cb/employe-outlet-overtime',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employe-outlet-ot/employe-outlet-ot.html',
                        controller : 'EmployeOutletotController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.employe-outlet-ot')
        .controller('EmployeOutletotController', EmployeOutletotController);


    EmployeOutletotController.$inject = ['$state', '$log', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage'];
    /** @ngInject */
    function EmployeOutletotController($state, $log, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage) {

        var vm = this;
        vm.editData = editData;
        vm.deleteData = deleteData;
        vm.loadData = loadData
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var EmployeOT = AppAPI.Employeotoutlet();
        var Attendanceemploye = AppAPI.Attendanceemploye();
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listselected = [];
        vm.setViewTeam = setViewTeam;
        vm.type = 'waiting approval';
        vm.listType = ['waiting approval', 'approved', 'rejected'];

        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.getPeriode = getPeriode;
        vm.tgl = date.getDate();

        if (vm.tgl >= 25 && vm.tgl <= 31) {
            if (vm.bulan == 12) {
                vm.bulan = 1;
                vm.tahun += 1;
            } else {
                vm.bulan = vm.bulan + 1;
            }
        }

        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }

        vm.listtahun = [2017, 2018, 2019, 2020, 2021];
        vm.listbulan = [{
                name: 'January',
                value: '01'
            },
            {
                name: 'February',
                value: '02'
            },
            {
                name: 'Maret',
                value: '03'
            },
            {
                name: 'April',
                value: '04'
            },
            {
                name: 'Mei',
                value: '05'
            },
            {
                name: 'June',
                value: '06'
            },
            {
                name: 'July',
                value: '07'
            },
            {
                name: 'August',
                value: '08'
            },
            {
                name: 'September',
                value: '09'
            },
            {
                name: 'October',
                value: '10'
            },
            {
                name: 'November',
                value: '11'
            },
            {
                name: 'Desember',
                value: '12'
            }
        ];



        loadData(1);
        getPeriode();
        //////////

        vm.currentot = 0;
        vm.periode = "";

        function getPeriode() {
            var res = Attendanceemploye.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan
            });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            vm.periode = data[0]['periode'];
        }

        function errorfetchPeriode(data) {
            console.log('error');
            // vm.searchComplete=true;
        }
        // var res= EmployeOT.query({action:'getCurrentOt'});
        //       res.$promise.then(function(data){
        //        vm.currentot=vm.currentot + data[0].overtime;
        //        vm.periode=data[0].periode;
        //       console.log(data);
        //     });

        //     res.$promise.catch(function(data){
        //       $log.info(data);
        //     });

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(EmployeOT, pageno, {
                action: 'viewdata',
                tglmulai: vm.tglmulai, 
                tglakhir: vm.tglakhir,
                type: vm.type
            });
        }


        function editData(id) {
            $state.go('app.cb_employe_overtime_edit_employe_ot', {
                id: id
            });
        }


        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listselected.indexOf(ls);

            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }

        function deleteData(ev) {

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this list?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = EmployeOT.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listselected)
                    });

                    response.$promise.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        // function setViewTeam(ls)
        // {
        //   console.log(ls);
        // }

        function setViewTeam(ev, id) {
            $mdDialog.show({
                controller: 'EmployeeOtteamController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/employe-overtime/employeeot-team.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-break-finger', [
        ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
      // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-shift');

        // State
        $stateProvider
        .state('app.cb_employe_break_finger', {
            url    : '/cb/employe-break-finger',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/cb/employe-break-finger/employe-break-finger.html',
                    controller : 'EmployebreakfingerController as vm'
                }
            }
        });

        
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.employe-break-finger')
        .controller('UploadBreakFingerDataController', UploadBreakFingerDataController);

    UploadBreakFingerDataController.$inject = ['$state','$mdDialog','config','$localStorage','$timeout','AppAPI','Auth','FileUploader','$location','$window'];

    /* @ngInject */
    function UploadBreakFingerDataController($state,$mdDialog,config,$localStorage,$timeout,AppAPI,Auth,FileUploader,$location,$window) 
    {
        var vm = this;

        vm.closeModal = closeModal
        vm.uploadSuccess = false;
        vm.uploadError = false;
        vm.uploadNotif = '';
        vm.FileUpload = new FileUploader({
            url: config.api + 'api/empbreakfinger/uploadfile',
            removeAfterUpload: true,
            alias: 'fileupload',
            formData: [{
                action: 'uploadbreakfinger'
            }],
            onAfterAddingAll: function() {
                vm.uploadSuccess = false;
                vm.uploadError   = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        vm.FileUpload.onSuccessItem = function(data, status, headers, config) {
            if ( status.status == 'Failed' ) {
                vm.uploadSuccess = false;
                vm.uploadError   = true;
            } else {
                vm.uploadSuccess = true;
                vm.uploadError   = false;
            }
            vm.uploadNotif = status.message
            angular.element('#uploadCutOff').val('');    
        };

        vm.FileUpload.onErrorItem = function() {
            vm.uploadSuccess = false;
            vm.uploadError = true;
            
        };

        function closeModal()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-break-finger')
        .controller('EmployebreakfingerController', EmployebreakfingerController);


    EmployebreakfingerController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function EmployebreakfingerController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.loadBuilding=loadDataBuilding;
        vm.company=$localStorage.empsite;
        vm.uploadData=uploadData;
        vm.building = 'all';
        vm.typeEmp = [
            {
              "view"  : "Staff",
              "value" : "SAP"
            },
            {
              "view"  : "General Worker",
              "value" : "HRIS"
            }
        ];
        var Empbreakfinger   = AppAPI.Empbreakfinger();
        var Attendancereport = AppAPI.Attendancereport();
        var Completeness     = AppAPI.Completeness();

        loadDataBU();
        loadSubArea(); 

        /** -load data- */
        function loadData(pageno)
        { 
          var resp=vm.DataTable.loadData(Empbreakfinger,pageno,{action:'viewdata',company:vm.company,subarea:vm.subarea,emptype:vm.employeeType,building:vm.building});
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        /** -load business unit- */
        function loadDataBU() {
            var response=Attendancereport.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }
        function fetchBU(data) {
            vm.listBU=data;

        }
        function errorFetchBU() {
            vm.listBU=[];
        }

        /** -load sub area- */
        function  loadSubArea()
        {
            var response=Attendancereport.query({action:'viewSubArea'});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }
        function fetchArea(data)
        {
            vm.subArea=data;
        }
        function errorfetchArea(data)
        {
            vm.subArea=[];
        }

        /** -load building- */
        function loadDataBuilding(subAreaId) {
            var response=Completeness.query({action:'viewBuilding',subAreaId:subAreaId});
            response.$promise.then(fetchBuilding);
            response.$promise.catch(errorFetchBuilding);
        }
        function fetchBuilding(data) {
            vm.listBuilding=data;
        }
        function errorFetchBuilding() {
            vm.listBuilding=[];
        }

        /** -upload break finger- */
        function uploadData(ev)
        {
            $mdDialog.show({
                controller         : 'UploadBreakFingerDataController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/employe-break-finger/upload-form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                } 
            }); 

        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employe-absence', ['app.cb.employe-absence.input-employe-absence'])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_employe_absence', {
                url    : '/cb/employe-absence',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employe-absence/employe-absence.html',
                        controller : 'EmployeabsenceController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.employe-absence')
        .controller('EmployeabsenceController', EmployeabsenceController);


    EmployeabsenceController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$log', '$localStorage', '$filter'];
    /** @ngInject */
    function EmployeabsenceController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $log, $localStorage, $filter) {

        var vm = this;
        var translate = $filter('translate');

        vm.editData = editData;
        vm.deleteData = deleteData;
        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Employeabsence = AppAPI.Employeabsence();
        var nik = $localStorage.user;
        vm.group = $localStorage.group;
        vm.typeEmp = $localStorage.typeEmp;
        vm.addDisabled = vm.typeEmp == 'Parttime';
        vm.clearFilter = clearFilter;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listselected = [];
        vm.ViewDocument = ViewDocument;
        vm.appstatus = [{
            name: 'Waiting Approval',
            value: '0'
        }, {
            name: 'Approved',
            value: '1'
        }, {
            name: 'Rejected',
            value: '2'
        }];
        vm.abs_code = '';
        vm.status = '0';
        vm.resendMail = resendMail;
        vm.viewComment = viewComment;

        angular.element.blockUI();
        loadAbsenceType();
        
        //////////
        function clearFilter() {
            console.log('test');
            vm.abs_code = null;
            vm.status = null;
            vm.start_date = null;
            vm.end_date = null;
        }

        function loadAbsenceType() {
            var response = Employeabsence.query({
                action: 'getAbsenceType',
                leaveType: 'all'
            });
            response.$promise.then(function (data) {
                vm.listAbsenceType = data;
                loadData(1);
                // console.log(vm.listParent);
            });

            response.$promise.catch(function (data) {
                angular.element.unblockUI();
                $log.info(data);
            });
        }

        function loadData(pageno) {
            angular.element.blockUI();
            var resp = vm.DataTable.loadData(Employeabsence, pageno, {
                action: 'viewdata',
                abs_code: vm.abs_code,
                status: vm.status,
                start_date: vm.start_date,
                end_date: vm.end_date
            });
            vm.listselected = [];
            resp.then(function () {
                // vm.abs_code='';
                angular.element.unblockUI();
            });

            resp.catch(function () {
                angular.element.unblockUI();
            })
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listselected.indexOf(ls);

            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            } else {
                vm.listselected.push(ls);
            }
        }


        function editData(id) {
            $state.go('app.cb_employe_absence_edit_employe_absence', {
                id: id
            });
        }

        function deleteData(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirmdel = translate('PAYROLL.MESSAGE.CONFDEL');
                var note = translate('PAYROLL.MESSAGE.DELNOTE');
                var yes = translate('PAYROLL.MESSAGE.YES');
                var no = translate('PAYROLL.MESSAGE.NO');

                var confirm = $mdDialog.confirm()
                    .title(confirmdel)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Employeabsence.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listselected)
                    });

                    response.$promise.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function resendMail(ev, data) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirmProcess = translate('ATTENDANCE.MESSAGE.CONFRESENDMAIL');
                var yes = translate('PAYROLL.MESSAGE.YES');
                var no = translate('PAYROLL.MESSAGE.NO');

                var confirm = $mdDialog.confirm()
                    .title(confirmProcess)
                    .ariaLabel('sendmail dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);
                $mdDialog.show(confirm).then(function () {
                    // angular.element.blockUI();
                    // console.log(vm.listOtselected);
                    var absence = new Employeabsence();
                    absence.data = data;
                    absence.action = 'resendEmail';
                    var response = absence.$save();
                    //var response=tm.$delete({action:'approve'});
                    response.then(loadData);

                }, function () {

                });
            });
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'AbsenceViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/approval-absence/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }

        function ViewDocument(ev, img) {
            $mdDialog.show({
                controller: 'ViewDocAbsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/approval-absence-hr/view-doc-abs.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    img: img
                }
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.emp-join-holiday', ['app.cb.emp-join-holiday.input-join-holiday'])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_employe_join_holiday', {
                url    : '/cb/employee-join-holiday',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/emp-join-holiday/emp-join-holiday.html',
                        controller : 'EmpJoinholidayController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.emp-join-holiday')
        .controller('EmpJoinholidayController', EmpJoinholidayController);


    EmpJoinholidayController.$inject=['$state','$log','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function EmpJoinholidayController($state,$log,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService(); 
      var EmployeOT=AppAPI.Employeot();  
      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      var Empjoinholiday=AppAPI.Empjoinholiday();
      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1; 
      vm.tgl=date.getDate();
      if(vm.tgl >=20 && vm.tgl <=31)
      {
        vm.bulan=vm.bulan+1;
      }
      if(vm.bulan < 10){
        vm.bulan='0'+vm.bulan;
      }
      vm.listtahun=[2017,2018,2019, 2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];

      loadDataBU();
          
    //////////
    function loadDataDepartment(iddivisi) {
             var response=Empjoinholiday.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }
          
          function loadDataDivision(idbu) {
             var response=Empjoinholiday.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          } 

          function loadDataBU() {
            var response=Empjoinholiday.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }

    // loadData(1);
     
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Empjoinholiday,pageno,{action:'viewdata'});
    }
     

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.emp-ghk-holiday', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_emp_ghk_holiday', {
                url    : '/cb/employe-ghk-holiday',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/emp-ghk-holiday/emp-ghk-holiday.html',
                        controller : 'EmpghkHolidayController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.emp-ghk-holiday')
        .controller('InputGhkHolidayController', InputGhkHolidayController);

    InputGhkHolidayController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$log', 'config', 'Auth', '$filter'];

    /* @ngInject */
    function InputGhkHolidayController($localStorage, $mdDialog, Form, AppAPI, $log, config, Auth, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm(false);

        var Employeghk = AppAPI.Employeghkholiday();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess = false;


        vm.closeModal = closeModal;

        vm.reloadToken = reloadToken;
        vm.changeRefshift = changeRefshift;
        vm.changeWorkingDay = changeWorkingDay;
        vm.unscheduleshift = false;
        vm.Form.objForm.shifttype = 'group';
        vm.changeShiftType = changeShiftType;

        angular.element.blockUI();
        LoadLocationshift();


        function getWorkingDay() {
            vm.listworkingday = [];
            var resp = Employeghk.query({ action: 'getWorkingDay' });
            resp.$promise.then(fetchWorkingDay);
            resp.$promise.catch(errorfetchWorkingDay);

        }
        function fetchWorkingDay(data) {
            vm.listworkingday = data;
            if (vm.listworkingday.length > 0) {
                vm.required = true;
            } else {
                vm.required = false;
            }
            angular.element.unblockUI();
        }
        function errorfetchWorkingDay() {
            vm.listworkingday = [];
        }

        function changeWorkingDay() {
            angular.element.blockUI();
            vm.listholiday = [];
            var resp = Employeghk.query({ action: 'getWorkingDay', workingDay: vm.Form.objForm.kerjadate });
            resp.$promise.then(fetchHoliDay);
            resp.$promise.catch(errorfetchHoliDay);

        }
        function fetchHoliDay(data) {
            vm.listholiday = data;
            if (vm.listholiday.length > 0) {
                vm.required = true;
            } else {
                vm.required = false;
            }
            angular.element.unblockUI();
        }
        function errorfetchHoliDay() {
            vm.listholiday = [];
            angular.element.unblockUI();
        }

        function changeRefshift(id, holidayDate) {
            if (id == 0) {
                vm.unscheduleshift = true;
                vm.Form.objForm.start_template = 'NG00-Full';
            } else {
                vm.listLocationdetail = [];
                var resp = Employeghk.query({ action: 'getDetailshift', id: id, holiday_date: holidayDate })
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            }
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data) {
            vm.listLocationdetail = data;
        }

        function errorfetchdetailshift() {
            vm.listLocationdetail = [];
        }

        function LoadLocationshift() {
            var response = Employeghk.query({ action: 'getLocationshift', nik: $localStorage.user });
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
        }

        function fetchLocation(data) {
            vm.listLocation = data;
            getWorkingDay();
        }

        function errorFetchLocation() {
            vm.listLocation = [];
            angular.element.unblockUI();
        }



        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.saveProcess = true;
            var promise = Form.saveData('save', formController, Employeghk);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function (data) {
                showDialogInfo(ev, data.data);
            });

        }

        function showDialog(ev, data) {
            vm.saveProcess = false;
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function showFailed(ev, data) {
            vm.saveProcess = false;
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            console.log(data);
        }

        function ChangeDayType() {
            if (vm.Form.objForm.daytype == 'halfday') {
                vm.Form.objForm.end_date = vm.Form.objForm.start_date;
                vm.enddaterequire = false;
                vm.timerequire = true;
                vm.timedisabled = false;
            } else {
                vm.enddaterequire = true;
                vm.timerequire = false;
                vm.timedisabled = true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken() {
            Auth.setToken();
        }

        function changeShiftType() {
            if (vm.Form.objForm.shifttype === 'nongroup') {
                vm.Form.objForm.start_template = 'NG00-Full';
                vm.unscheduleshift = true;
            } else {
                vm.Form.objForm.start_template = null;
                vm.unscheduleshift = false;
            }
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.cb.emp-ghk-holiday')
    .controller('EmpghkHolidayController', EmpghkHolidayController);


  EmpghkHolidayController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function EmpghkHolidayController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {
    var vm = this;
    var translate = $filter('translate');

    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Employeghk = AppAPI.Employeghkholiday();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listselected = [];
    vm.approveOT = approveOT;
    vm.InputGhk = InputGhk;
    vm.viewComment = viewComment;
    vm.appstatus = [{ name: 'Waiting Approval', value: '0' }, { name: 'Approved', value: '1' }, { name: 'Rejected', value: '2' }];
    vm.status = '0';
    vm.clearFilter = clearFilter;

    function clearFilter() {
      vm.status = null;
      vm.start_date = null;
      vm.end_date = null;
    }


    //////////
    loadData(1);

    function loadData(pageno) {
      var resp = vm.DataTable.loadData(Employeghk, pageno, { action: 'viewdata', nik: nik, status: vm.status, start_date: vm.start_date, end_date: vm.end_date });
      vm.listselected = [];
    }


    // function editData(id) {
    //     $state.go('app.cb_emp_ghk_edit_ghk',{id:id});
    // }

    function deleteData(ev) {

      var confirmdel = translate('PAYROLL.MESSAGE.CONFDEL');
      var note = translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(confirmdel)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Employeghk.delete({ action: 'delete', data: angular.toJson(vm.listselected) });

          response.$promise.then(loadData);
          response.$promise.catch(loadData);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });


    }

    function isChecked(ls) {
      return vm.listselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listselected.indexOf(ls);

      if (idx > -1) {
        vm.listselected.splice(idx, 1);
      }
      else {
        vm.listselected.push(ls);
      }
    }

    function approveOT(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to Approve this list?')
          .textContent('All data your selected will be approve.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');
        $mdDialog.show({
          multiple: true
        });
        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          // console.log(vm.listselected);
          var ot = new Employeghk();
          ot.data = [];
          ot.action = 'approve';
          ot.nik = nik;
          ot.approval_type = 'n1';
          var jum = vm.listselected.length, i, ids = [];
          for (i = 0; i < jum; i++) {
            ot.data.push({ id: vm.listselected[i].id });
          }
          var idtx = encodeURIComponent(angular.toJson(ids));
          var response = ot.$save();
          //var response=tm.$delete({action:'approve'});
          response.then(loadData);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });

    }

    function InputGhk(ev, id) {
      $mdDialog.show({
        controller: 'InputGhkHolidayController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/emp-ghk-holiday/inputghkholiday.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id
        }
      });

    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'GhkHolidayCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-holiday/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          // vm.listOtselected=[];
          loadData();
        },
        locals: {
          id: id
        }
      });
    }

    function editData(ev, detailId, approval) {
      $mdDialog.show({
        controller: 'EditGhkHolidayController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/emp-ghk-holiday/inputghkholiday.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          detailId: detailId,
          approval: approval[0].approval_status
        }
      });
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.emp-ghk-holiday')
        .controller('GhkHolidayCommentController', GhkHolidayCommentController);

    GhkHolidayCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function GhkHolidayCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Approvalghk = AppAPI.Approvalghkholiday();

        // set constructor form
        Form.setObject(Approvalghk);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id[0];
        vm.stateView=true;
        // console.log(id[0]);

    function saveData(ev,formController)
        { 
            var promise= Form.saveData('reject', formController, Approvalghk);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.emp-ghk-holiday')
        .controller('EditGhkHolidayController', EditGhkHolidayController);

    EditGhkHolidayController.$inject = ['$localStorage', 'detailId', 'approval', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function EditGhkHolidayController($localStorage, detailId, approval, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.Employeghkholiday();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.Form.objForm.start_time = '00:00:00';
        vm.Form.objForm.end_time = '00:00:00';
        vm.closeModal = closeModal;
        vm.changeRefshift = changeRefshift;
        vm.Form.objForm.shifttype = 'group';
        vm.changeShiftType = changeShiftType;
        vm.approval = approval;
        vm.changeHoliday = changeHoliday;

        LoadLocationshift();

        vm.setSameDate = setSameDate;
        vm.isStartSameDate = "1";

        function setSameDate(param) {
            if (param != '1') {
                vm.isStartSameDate = "1";
            } else {
                vm.isStartSameDate = "0";
            }
        }

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', detail_id: detailId });
        res.then(changeDate);

        function changeWorkingDay() {
            vm.listholiday = [];
            var resp = Employeghk.query({ action: 'getWorkingDay', workingDay: vm.Form.objForm.kerjadate });
            resp.$promise.then(fetchHoliDay);
            resp.$promise.catch(errorfetchHoliDay);

        }
        function fetchHoliDay(data) {
            vm.listholiday = data;
            if (vm.listholiday.length > 0) {
                vm.required = true;
            } else {
                vm.required = false;
            }
        }
        function errorfetchHoliDay() {
            vm.listholiday = [];
        }

        function changeDate(data) {
            vm.id = data.id
            changeHoliday();
            vm.Form.objForm.working_date = data.working_date;

            if (data.dws_code == 'NG00') {
                vm.unscheduleshift = true;
                vm.Form.objForm.shifttype = 'nongroup';
                vm.Form.objForm.start_template = 'NG00-Full';
            } else {
                vm.listLocationdetail = [];
                vm.unscheduleshift = false;
                vm.Form.objForm.shifttype = 'group';
                var resp = Employeghk.query({ action: 'getDetailshift', id: data.locationid })
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
                vm.Form.objForm.start_template = data.dws_code + '-' + data.variant;
                vm.Form.objForm.locationid = data.locationid;
            }

            changeWorkingDay()
        }

        function fetchdetailshift(data) {
            vm.listLocationdetail = data;
        }

        function errorfetchdetailshift() {
            vm.listLocationdetail = [];
        }

        function changeRefshift(id) {
            if (id == 0) {
                vm.unscheduleshift = true;
                vm.Form.objForm.start_template = 'NG00-Full';
            } else {
                vm.listLocationdetail = [];
                var resp = Employeghk.query({ action: 'getDetailshift', id: id })
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            }
            // console.log(vm.unscheduleshift);
        }

        function LoadLocationshift() {
            var response = Employeghk.query({ action: 'getLocationshift', nik: $localStorage.user });
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
        }

        function fetchLocation(data) {
            vm.listLocation = data;
        }

        function errorFetchLocation() {
            vm.listLocation = [];
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.id = vm.id;
            vm.Form.objForm.detail_id = detailId;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;

            var promise = Form.saveData('update', formController, Employeghk);
            promise.then(function (data) {
                showDialogInfo(ev, data);

            });
            promise.catch(function (data) {
                showDialogInfo(ev, data)

            });


        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }


        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

        function changeShiftType() {
            if (vm.Form.objForm.shifttype === 'nongroup') {
                vm.Form.objForm.start_template = 'NG00-Full';
                vm.unscheduleshift = true;
            } else {
                vm.Form.objForm.start_template = null;
                vm.unscheduleshift = false;
            }
        }

        function changeHoliday() {
            vm.listworkingday = [];
            var resp = Employeghk.query({ action: 'getWorkingDay', holiday: vm.Form.objForm.holiday_date });
            resp.$promise.then(fetchWorkingDay);
            resp.$promise.catch(errorfetchWorkingDay);

        }

        function fetchWorkingDay(data) {
            vm.listworkingday = data;
            if (vm.listworkingday.length > 0) {
                vm.required = true;
                if (approval == 1) {
                    vm.required = false;
                }
            } else {
                vm.required = false;
            }
        }

        function errorfetchWorkingDay() {
            vm.listworkingday = [];
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.emp-ghk-halfday', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_emp_ghk_halfday', {
                url    : '/cb/employe-ghk-halfday',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/emp-ghk-halfday/index.html',
                        controller : 'EmpGhkHalfdayController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.emp-ghk-halfday')
        .controller('InputGhkHalfdayController', InputGhkHalfdayController);

    InputGhkHalfdayController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$log', 'config', 'Auth', '$filter'];

    /* @ngInject */
    function InputGhkHalfdayController($localStorage, $mdDialog, Form, AppAPI, $log, config, Auth, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.EmployeGhkHalfday();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess = false;
        vm.disable = false;
        vm.edit = false;


        vm.closeModal = closeModal;

        vm.reloadToken = reloadToken;
        vm.changeRefshift = changeRefshift;
        vm.changeHoliday = changeHoliday;
        vm.unscheduleshift = false;
        vm.Form.objForm.shifttype = 'group';
        vm.changeShiftType = changeShiftType;

        LoadLocationshift();

        vm.setSameDate = setSameDate;
        vm.isStartSameDate = "1";

        function setSameDate(param) {
            if (param != '1') {
                vm.isStartSameDate = "1";
            } else {
                vm.isStartSameDate = "0";
            }
        }

        function changeHoliday() {
            // console.log(vm.Form.objForm.holiday_date);
            vm.listworkingday = [];
            var resp = Employeghk.query({ action: 'getWorkingDay', holiday: vm.Form.objForm.holiday_date });
            resp.$promise.then(fetchWorkingDay);
            resp.$promise.catch(errorfetchWorkingDay);

        }

        function fetchWorkingDay(data) {
            vm.listworkingday = data;
            if (vm.listworkingday.length > 0) {
                vm.required = true;
            } else {
                vm.required = false;
            }
            console.log(vm.required);
        }

        function errorfetchWorkingDay() {
            vm.listworkingday = [];
        }

        function changeRefshift(id, holidayDate) {
            if (id == 0) {
                vm.unscheduleshift = true;
                vm.Form.objForm.start_template = 'NG00-Full';
            } else {
                vm.listLocationdetail = [];
                var resp = Employeghk.query({ action: 'getDetailshift', id: id, holiday_date: holidayDate })
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            }
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data) {
            vm.listLocationdetail = data;
        }

        function errorfetchdetailshift() {
            vm.listLocationdetail = [];
        }

        function LoadLocationshift() {
            var response = Employeghk.query({ action: 'getLocationshift', nik: $localStorage.user });
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
        }

        function fetchLocation(data) {
            vm.listLocation = data;
        }

        function errorFetchLocation() {
            vm.listLocation = [];
        }



        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.saveProcess = true;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;
            var promise = Form.saveData('save', formController, Employeghk);
            promise.then(function (data) {
                angular.element.unblockUI();

                showDialogInfo(ev, data);
            });

            promise.catch(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data);
            });

        }

        function showDialog(ev, message, title) {
            vm.saveProcess = false;
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(message)
                    .ariaLabel(title)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function showFailed(ev, data) {
            vm.saveProcess = false;
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            console.log(data);
        }

        function ChangeDayType() {
            if (vm.Form.objForm.daytype == 'halfday') {
                vm.Form.objForm.end_date = vm.Form.objForm.start_date;
                vm.enddaterequire = false;
                vm.timerequire = true;
                vm.timedisabled = false;
            } else {
                vm.enddaterequire = true;
                vm.timerequire = false;
                vm.timedisabled = true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken() {
            Auth.setToken();
        }

        function changeShiftType() {
            if (vm.Form.objForm.shifttype === 'nongroup') {
                vm.Form.objForm.start_template = 'NG00-Full';
                vm.unscheduleshift = true;
            } else {
                vm.Form.objForm.start_template = null;
                vm.unscheduleshift = false;
            }
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.emp-ghk-halfday')
    .controller('EmpGhkHalfdayController', EmpGhkHalfdayController);


  EmpGhkHalfdayController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function EmpGhkHalfdayController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {

    var vm = this;

    var translate = $filter('translate');
    // vm.editData=editData;
    vm.deleteData = deleteData;
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Employeghk = AppAPI.EmployeGhkHalfday();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listselected = [];
    vm.approveOT = approveOT;
    vm.InputGhk = InputGhk;
    vm.viewComment = viewComment;
    vm.appstatus = [{ name: 'Waiting Approval', value: '0' }, { name: 'Approved', value: '1' }, { name: 'Rejected', value: '2' }];
    vm.status = '';
    vm.clearFilter = clearFilter;
    vm.detail = detail;

    function clearFilter() {
      vm.status = null;
      vm.start_date = null;
      vm.end_date = null;
    }


    //////////
    loadData(1);

    function loadData(pageno) {
      var resp = vm.DataTable.loadData(Employeghk, pageno, { action: 'viewdata', nik: nik, status: vm.status, start_date: vm.start_date, end_date: vm.end_date });
      vm.listselected = [];
    }


    function deleteData(ev) {
      var confirmdel = translate('PAYROLL.MESSAGE.CONFDEL');
      var note = translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(confirmdel)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Employeghk.delete({ action: 'delete', data: angular.toJson(vm.listselected) });
          response.$promise.then(function (resData) {
            angular.element.unblockUI();
            if (resData.status == 1) {
              var title = 'PAYROLL.MESSAGE.SUCCESS';
              var textContent = 'PAYROLL.MESSAGE.SUCCMESDEL';
              var ariaLabel = 'Success Delete Data';
            } else {
              var title = 'PAYROLL.MESSAGE.FAILED';
              var textContent = 'PAYROLL.MESSAGE.FAILED';
              var ariaLabel = 'Delete Data Failed';
            }

            showDialogMessage(title, textContent, ariaLabel);
            loadData(1);
          });
          response.$promise.catch(function (resData) {
            angular.element.unblockUI();
            var title = 'Delete Data Failed';
            var textContent = resData.message;
            var ariaLabel = 'Delete Data Failed';
            showDialogMessage(title, textContent, ariaLabel, ev);
          })
        }, function () {

        });
      });
    }

    function isChecked(ls) {
      return vm.listselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listselected.indexOf(ls);

      if (idx > -1) {
        vm.listselected.splice(idx, 1);
      }
      else {
        vm.listselected.push(ls);
      }
    }

    function approveOT(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to Approve this list?')
          .textContent('All data your selected will be approve.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');
        $mdDialog.show({
          multiple: true
        });
        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          // console.log(vm.listselected);
          var ot = new Employeghk();
          ot.data = [];
          ot.action = 'approve';
          ot.nik = nik;
          ot.approval_type = 'n1';
          var jum = vm.listselected.length, i, ids = [];
          for (i = 0; i < jum; i++) {
            ot.data.push({ id: vm.listselected[i].id });
          }
          var idtx = encodeURIComponent(angular.toJson(ids));
          var response = ot.$save();
          //var response=tm.$delete({action:'approve'});
          response.then(loadData);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });

    }

    function InputGhk(ev, id) {
      $mdDialog.show({
        controller: 'InputGhkHalfdayController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/emp-ghk-halfday/input.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id
        }
      });

    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'GhkHalfdayViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-halfday/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          // vm.listOtselected=[];
          loadData();
        },
        locals: {
          id: id
        }
      });
    }

    function showDialogMessage(title, textContent, ariaLabel, ev) {
      var textTitle = translate(title);
      var txtContent = translate(textContent);
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(textTitle)
          .textContent(txtContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }

    function detail(ev, data) {
      $mdDialog.show({
        controller: 'DetailGhkHalfdayController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/emp-ghk-halfday/input.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.emp-ghk-halfday')
        .controller('DetailGhkHalfdayController', DetailGhkHalfdayController);

    DetailGhkHalfdayController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','config','Auth','data'];

    /* @ngInject */
    function DetailGhkHalfdayController($localStorage,$mdDialog,Form,AppAPI,$log,config,Auth,data) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.EmployeGhkHalfday();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;
        vm.disable = true;
        vm.edit = true;
        vm.setEdit = setEdit;
        vm.canModify = 0;
 

        vm.closeModal = closeModal;  

        vm.reloadToken=reloadToken; 
        vm.changeRefshift=changeRefshift; 
        vm.unscheduleshift=false; 
        
        vm.changeShiftType=changeShiftType;

        setData();
        LoadLocationshift();


        ////////////////

        function setData()
        {
            vm.Form.objForm.halfday_date = new Date(data.date);
            vm.Form.objForm.description = data.description
            if ( data.approval == 0 ) {
                vm.canModify = 1;
            }
            if ( data.idshift == 'NG00' ) {
                vm.Form.objForm.shifttype = 'nongroup'
                vm.Form.objForm.start_time = data.istart_time
                vm.Form.objForm.end_time = data.iend_time
                changeShiftType();
            } else {
                vm.Form.objForm.shifttype = 'group'
                vm.Form.objForm.locationid = data.location_id
                changeRefshift(data.location_id)
                var code = data.idshift+'-'+'Half'    
                changeShiftType(code);
            }
        }

        function changeRefshift(id, holidayDate)
        { 
            if(id==0){
                vm.unscheduleshift=true;
                vm.Form.objForm.start_template='NG00-Full';
            }else{
                vm.listLocationdetail=[];
                var resp=Employeghk.query({action:'getDetailshift',id:id,holiday_date:holidayDate})
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            } 
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function LoadLocationshift() {
            var response=Employeghk.query({action:'getLocationshift',nik:$localStorage.user});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

          function fetchLocation(data) {
            vm.listLocation=data;
          }

        function errorFetchLocation() {
            vm.listLocation=[];
          } 
 
      

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            vm.Form.objForm.id = data.id;

            var promise= Form.saveData('update', formController, Employeghk);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data.pesan,'Success Save Data');
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,message,title)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(title)
            .textContent(message)
            .ariaLabel(title)
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
          console.log(data);
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
                vm.timedisabled=false;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
                vm.timedisabled=true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function changeShiftType(code)
        {
            if(vm.Form.objForm.shifttype==='nongroup')
            {
                vm.Form.objForm.start_template='NG00-Full';
                vm.unscheduleshift=true;
            }else{
                vm.Form.objForm.start_template=code;
                vm.unscheduleshift=false;
            }
        }

        function setEdit (status)
        {
            vm.disable = status;
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.emp-ghk', ['app.cb.emp-ghk.input-ghk'])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_emp-ghk', {
                url    : '/cb/employe-ghk',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/emp-ghk/emp-ghk.html',
                        controller : 'EmpghkController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.emp-ghk')
        .controller('InputGhkController', InputGhkController);

    InputGhkController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$log', 'config', 'Auth', '$filter'];

    /* @ngInject */
    function InputGhkController($localStorage, $mdDialog, Form, AppAPI, $log, config, Auth, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.Employeghk();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;


        vm.closeModal = closeModal;

        vm.reloadToken = reloadToken;
        vm.changeRefshift = changeRefshift;
        vm.saveProcess = false;
        vm.unscheduleshift = false;
        vm.Form.objForm.shifttype = 'group';
        vm.changeShiftType = changeShiftType;
        LoadLocationshift();

        function changeRefshift(id) {
            if (id == 0) {
                vm.unscheduleshift = true;
                vm.Form.objForm.start_template = 'NG00-Full';
            } else {
                vm.listLocationdetail = [];
                var resp = Employeghk.query({ action: 'getDetailshift', id: id })
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            }
        }

        function fetchdetailshift(data) {
            vm.listLocationdetail = data;
        }

        function errorfetchdetailshift() {
            vm.listLocationdetail = [];
        }

        function LoadLocationshift() {
            var response = Employeghk.query({ action: 'getLocationshift', nik: $localStorage.user });
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
        }

        function fetchLocation(data) {
            vm.listLocation = data;
        }

        function errorFetchLocation() {
            vm.listLocation = [];
        }



        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.saveProcess = true;
            var promise = Form.saveData('save', formController, Employeghk);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function (data) {
                showDialogInfo(ev, data.data);
            });

        }

        function showDialog(ev, data) {
            vm.saveProcess = false;
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function showFailed(ev, data) {
            vm.saveProcess = false;
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            console.log(data);
        }

        function ChangeDayType() {
            if (vm.Form.objForm.daytype == 'halfday') {
                vm.Form.objForm.end_date = vm.Form.objForm.start_date;
                vm.enddaterequire = false;
                vm.timerequire = true;
                vm.timedisabled = false;
            } else {
                vm.enddaterequire = true;
                vm.timerequire = false;
                vm.timedisabled = true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken() {
            Auth.setToken();
        }

        function changeShiftType() {
            if (vm.Form.objForm.shifttype === 'nongroup') {
                vm.Form.objForm.start_template = 'NG00-Full';
                vm.unscheduleshift = true;
            } else {
                vm.Form.objForm.start_template = null;
                vm.unscheduleshift = false;
            }
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.emp-ghk')
    .controller('EmpghkController', EmpghkController);


  EmpghkController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function EmpghkController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {
    var vm = this;

    var translate = $filter('translate');

    // vm.editData=editData;
    vm.deleteData = deleteData;
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Employeghk = AppAPI.Employeghk();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listselected = [];
    vm.approveOT = approveOT;
    vm.InputGhk = InputGhk;
    vm.viewComment = viewComment;
    vm.editData = editData;
    vm.appstatus = [{ name: 'Waiting Approval', value: '0' }, { name: 'Approved', value: '1' }, { name: 'Rejected', value: '2' }];
    vm.status = '0';
    vm.clearFilter = clearFilter;

    function clearFilter() {
      console.log('test');
      vm.abs_code = null;
      vm.status = null;
      vm.start_date = null;
      vm.end_date = null;
    }
    //////////
    loadData(1);

    function loadData(pageno) {
      var resp = vm.DataTable.loadData(Employeghk, pageno, { action: 'viewdata', nik: nik, status: vm.status, start_date: vm.start_date, end_date: vm.end_date });
      vm.listselected = [];
    }


    // function editData(id) {
    //     $state.go('app.cb_emp_ghk_edit_ghk',{id:id});
    // }

    function deleteData(ev) {
      var confirmdel = translate('PAYROLL.MESSAGE.CONFDEL');
      var note = translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(confirmdel)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Employeghk.delete({ action: 'delete', data: angular.toJson(vm.listselected) });

          response.$promise.then(loadData);
          response.$promise.catch(loadData);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });


    }

    function isChecked(ls) {
      return vm.listselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listselected.indexOf(ls);

      if (idx > -1) {
        vm.listselected.splice(idx, 1);
      }
      else {
        vm.listselected.push(ls);
      }
    }

    function approveOT(ev) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to Approve this list?')
          .textContent('All data your selected will be approve.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');
        $mdDialog.show({
          multiple: true
        });
        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          // console.log(vm.listselected);
          var ot = new Employeghk();
          ot.data = [];
          ot.action = 'approve';
          ot.nik = nik;
          ot.approval_type = 'n1';
          var jum = vm.listselected.length, i, ids = [];
          for (i = 0; i < jum; i++) {
            ot.data.push({ id: vm.listselected[i].id });
          }
          var idtx = encodeURIComponent(angular.toJson(ids));
          var response = ot.$save();
          //var response=tm.$delete({action:'approve'});
          response.then(loadData);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });

    }

    function InputGhk(ev, id) {
      $mdDialog.show({
        controller: 'InputGhkController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/emp-ghk/inputghk.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id
        }
      });

    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'GhkViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          vm.listOtselected = [];
        },
        locals: {
          id: id
        }
      });
    }

    function editData(ev, detailId, approval) {
      $mdDialog.show({
        controller: 'EditGhkController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/emp-ghk/inputghk.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          detailId: detailId,
          approval: approval.approval_status
        }
      });
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.emp-ghk')
        .controller('EditGhkController', EditGhkController);

    EditGhkController.$inject = ['$localStorage', 'detailId', 'approval', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function EditGhkController($localStorage, detailId, approval, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.Employeghk();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;

        vm.Form.objForm.start_time = '00:00:00';
        vm.Form.objForm.end_time = '00:00:00';
        vm.closeModal = closeModal;
        vm.changeRefshift = changeRefshift;
        vm.Form.objForm.shifttype = 'group';
        vm.changeShiftType = changeShiftType;
        vm.approval = approval

        vm.setSameDate = setSameDate;
        LoadLocationshift();

        vm.isStartSameDate = "1";

        ////////////////
        function setSameDate(param) {
            if (param != '1') {
                vm.isStartSameDate = "1";
            } else {
                vm.isStartSameDate = "0";
            }
        }

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', detail_id: detailId });
        res.then(changeDate);

        function changeDate(data) {
            vm.id = data.id
            vm.Form.objForm.kerjadate = new Date(data.kerjadate);
            if (data.dws_code == 'NG00') {
                vm.unscheduleshift = true;
                vm.Form.objForm.shifttype = 'nongroup';
                vm.Form.objForm.start_template = 'NG00-Full';
            } else {
                vm.listLocationdetail = [];
                vm.unscheduleshift = false;
                vm.Form.objForm.shifttype = 'group';
                var resp = Employeghk.query({ action: 'getDetailshift', id: data.locationid })
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
                vm.Form.objForm.start_template = data.dws_code + '-' + data.variant;
                vm.Form.objForm.locationid = data.locationid;
            }

        }

        function fetchdetailshift(data) {
            vm.listLocationdetail = data;
        }

        function errorfetchdetailshift() {
            vm.listLocationdetail = [];
        }

        function changeRefshift(id) {
            if (id == 0) {
                vm.unscheduleshift = true;
                vm.Form.objForm.start_template = 'NG00-Full';
            } else {
                vm.listLocationdetail = [];
                var resp = Employeghk.query({ action: 'getDetailshift', id: id })
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            }
            // console.log(vm.unscheduleshift);
        }

        function LoadLocationshift() {
            var response = Employeghk.query({ action: 'getLocationshift', nik: $localStorage.user });
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
        }

        function fetchLocation(data) {
            vm.listLocation = data;
        }

        function errorFetchLocation() {
            vm.listLocation = [];
        }


        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.Form.objForm.id = vm.id;
            vm.Form.objForm.detail_id = detailId;
            vm.Form.objForm.isStartSameDate = vm.isStartSameDate;

            var promise = Form.saveData('update', formController, Employeghk);
            promise.then(function (data) {
                showDialogInfo(ev, data);

            });
            promise.catch(function (data) {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }


        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

        function changeShiftType() {
            if (vm.Form.objForm.shifttype === 'nongroup') {
                vm.Form.objForm.start_template = 'NG00-Full';
                vm.unscheduleshift = true;
            } else {
                vm.Form.objForm.start_template = null;
                vm.unscheduleshift = false;
            }
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.download-attendance-pma', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.cb_download-attendance-pma', {
                url    : '/cd/download-report-attendance',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/download-attendance-pma/download-attendance.html',
                        controller : 'DownloadReportAttendanceController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance-pma')
        .controller('DownloadReportAttendanceController', DownloadReportAttendanceController);

    DownloadReportAttendanceController.$inject = [
        '$state',
        '$window',
        '$location',
        '$localStorage',
        '$document',
        '$element',
        '$http',
        '$scope',
        'config',
        '$log',
        '$mdDialog',
        'AppAPI',
        'Auth',
        'DataService'
    ];

    /* @ngInject */
    function DownloadReportAttendanceController(
        $state,
        $window,
        $location,
        $localStorage,
        $document,
        $element,
        $http,
        $scope,
        config,
        $log,
        $mdDialog,
        AppAPI,
        Auth,
        DataService
    ) {
        var vm = this;
        var Attendancereport=AppAPI.DownloadReportAttendance();

        vm.Download = Download;

        loadReportList();
        
        function loadReportList() 
        {
            var response=Attendancereport.query({action:'getReportList'});
           response.$promise.then(fetchReportList);
           response.$promise.catch(errorFetchReportList);
        }
 
        function fetchReportList(data) 
        {
            vm.listReport = data;
        }
 
        function errorFetchReportList() 
        {
           vm.listReport=[];
        }

        ///////////////////////////////
        function Download(ev, data) {
            switch (data) {
                case 'downloadAttendancePMA':
                    downloadAttendancePMA(ev);
                    break;
            }
        }

        function downloadAttendancePMA(ev) {
            $mdDialog.show({
                controller: 'DownloadAttendancePMAController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/download-attendance/download-attendance-pma.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    // loadData();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('TransactionDownloadController', TransactionDownloadController);

    TransactionDownloadController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', 'Auth', '$window', '$location'];

    /* @ngInject */
    function TransactionDownloadController($localStorage, $mdDialog, Form, AppAPI, $log, FileUploader, config, Auth, $window, $location) {
        var vm = this;
        Form.initialForm();

        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        var Attendancereport = AppAPI.Attendancereport();
        vm.company = $localStorage.empsite;
        vm.groupLogin = $localStorage.group;
        vm.download = download;
        vm.closeModal = closeModal;
        vm.flag_app = 'SAP';
        vm.selectedSubarea = '';
        vm.type = null;
        vm.loadSubArea=loadSubArea;

        vm.start_date = vm.end_date = null;

        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.getPeriode = getPeriode;
        vm.tgl = date.getDate();

        var isAdminPlant = false;
        if (vm.groupLogin == 11) {
            isAdminPlant = true;
        }

        if (vm.tgl >= 20 && vm.tgl <= 31) {
            vm.bulan = vm.bulan + 1;
        }
        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }

        vm.divisi = 'all';
        vm.department = 'all';
        vm.typeEmp = [{
                "view": "All",
                "value": "all"
            },
            {
                "view": "Staff",
                "value": "SAP"
            },
            {
                "view": "General Worker",
                "value": "HRIS"
            }
        ];

        vm.transactionType = [{
                "view": "All",
                "value": "all"
            },
            {
                "view": "Leave",
                "value": "leave"
            },
            {
                "view": "Abnormal",
                "value": "abnormal"
            },
            {
                "view": "Update Finger",
                "value": "updatefinger"
            },
            {
                "view": "Overtime",
                "value": "overtime"
            },
            {
                "view": "GHK",
                "value": "ghk"
            },
            {
                "view": "GHK Holiday",
                "value": "ghk holiday"
            },
            {
                "view": "Change Shift",
                "value": "change shift"
            }
        ];

        vm.listtahun = [2017, 2018, 2019,2020,2021];
        vm.listbulan = [{
                name: 'January',
                value: '01'
            },
            {
                name: 'February',
                value: '02'
            },
            {
                name: 'Maret',
                value: '03'
            },
            {
                name: 'April',
                value: '04'
            },
            {
                name: 'Mei',
                value: '05'
            },
            {
                name: 'June',
                value: '06'
            },
            {
                name: 'July',
                value: '07'
            },
            {
                name: 'August',
                value: '08'
            },
            {
                name: 'September',
                value: '09'
            },
            {
                name: 'October',
                value: '10'
            },
            {
                name: 'November',
                value: '11'
            },
            {
                name: 'Desember',
                value: '12'
            }
        ];

        getPeriode();
        loadDataBU();
        //////////////////////////
        function changeDateFormat(date) {
            var monthTmp = "" + (date.getMonth() + 1);
            var monthPad = "00";
            var month = monthPad.substring(0, monthPad.length - monthTmp.length) + monthTmp;

            var dayTmp = "" + date.getDate();
            var dayPad = "00";
            var day = dayPad.substring(0, dayPad.length - dayTmp.length) + dayTmp;

            var year = date.getFullYear();
            return year + "-" + month + "-" + day;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function getPeriode() {
            var res = Attendancereport.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan
            });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            vm.start_date = new Date(data[0]['periode_start']);
            vm.end_date = new Date(data[0]['periode_end']);
            // vm.periode=data[0]['periode'];
            // console.log(vm.periode);
            // loadData(1);
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;

            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendancereport.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            // vm.listDivision.push(data);
            // loadData(1);
            loadDataDepartment(vm.divisi);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
            errorDepartment();
        }

        function loadDataBU() {
            var response = Attendancereport.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
            loadSubArea();
            loadDataDivision(vm.company);
        }

        function errorFetchBU() {
            vm.listBU = [];
            errorfetchArea();
            errorDivisiBU();
        }

        function download() {
            var company = vm.company;
            var divisi = vm.divisi;
            var department = vm.department;
            var start_date = changeDateFormat(vm.start_date);
            var end_date = changeDateFormat(vm.end_date);
            var token = Auth.setTokenPromise();
            var subarea = vm.selectedSubarea;
            var type = vm.type;
            var empType = vm.flag_app;

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/attendancereport/downloadwaitingapprovalrange/' + company + '/' + divisi + '/' + department + '/' + start_date + '/' + end_date + '/' + subarea + '/' + type + '/' + empType, '_blank');
            }, function () {
                $window.alert('gagal load token');
            });
        }

        function loadSubArea() {
            var response = Attendancereport.query({
                action: 'viewSubArea',
                company:vm.company
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
            if (isAdminPlant) {
                if (vm.subArea.length > 0) {
                    vm.selectedSubarea = vm.subArea[0].subarea_id;
                }
            }
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('DownloadSvaController', DownloadSvaController);

    DownloadSvaController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','FileUploader','config','Auth','$window','$location'];

    /* @ngInject */
    function DownloadSvaController($localStorage,$mdDialog,Form,AppAPI,$log,FileUploader,config,Auth,$window,$location) {
      var vm = this;
      Form.initialForm();

      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      var Attendancereport=AppAPI.Attendancereport();
      var Approvalabsence=AppAPI.Approvalabsence();
      var Completeness=AppAPI.Completeness();
      vm.company=$localStorage.empsite;
      vm.groupLogin=$localStorage.group;
      vm.download=download;
      vm.closeModal=closeModal;
      vm.flagApp = ['SAP','HRIS'];
      vm.flag_app = 'SAP';
      vm.selectedSubarea = '';
      vm.loadSubArea=loadSubArea;

      vm.start_date = vm.end_date = null;

      var date = new Date();
      vm.tahun = date.getFullYear();
      vm.bulan = date.getMonth() + 1;
      vm.tgl = date.getDate();
      
      vm.getPeriode = getPeriode;
      vm.selectSubarea = selectSubarea;
      vm.getListGedung = getListGedung;
      vm.getListSector = getListSector;
      
      vm.selectedBuilding = vm.selectedSector = 'all';

      vm.page = '0';

      vm.isRkPma = false;
      if(vm.company == "RK" || vm.company == "PM")
      {
        vm.isRkPma = true;
      }

      var isAdminPlant = false;
      if(vm.groupLogin == 11) {
        isAdminPlant = true;
      }

      if(vm.tgl >=25 && vm.tgl <=31)
      {
        vm.bulan=vm.bulan+1;
      }

      if(vm.bulan < 10) {
        vm.bulan='0'+vm.bulan;
      }

      vm.divisi='all';
      vm.department='all';
      vm.typeEmp = [
        {
          "view"  : "All",
          "value" : "all"
        },
        {
          "view"  : "Staff",
          "value" : "SAP"
        },
        {
          "view"  : "General Worker",
          "value" : "HRIS"
        }
      ];

      vm.listtahun=[2017,2018,2019, 2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
      vm.listPage=[
                   {name:'All',value:'all'},
                   {name:'0-1000',value:'0'},
                   {name:'1001-2000',value:'1'},
                   {name:'2001-3000',value:'2'},
                   {name:'3001-4000',value:'3'},
                   {name:'4001-5000',value:'4'},
                   {name:'5001-6000',value:'5'},
                   {name:'6001-7000',value:'6'},
                   {name:'7001-8000',value:'7'},
                   {name:'8001-9000',value:'8'},
                   {name:'9001-10000',value:'9'},
                   {name:'10001-11000',value:'10'},
                   {name:'11001-12000',value:'11'},
                   {name:'12001-13000',value:'12'},
                   {name:'13001-14000',value:'13'},
                   {name:'14001-15000',value:'14'}  
                  ];

      loadDataBU();
      getPeriode();
      //////////////////////////
      function changeDateFormat(date){
        var monthTmp = "" + (date.getMonth()+1);
        var monthPad = "00";
        var month = monthPad.substring(0, monthPad.length - monthTmp.length) + monthTmp;

        var dayTmp = "" + date.getDate();
        var dayPad = "00";
        var day = dayPad.substring(0, dayPad.length - dayTmp.length) + dayTmp;

        var year = date.getFullYear();
        return year+"-"+month+"-"+day;
      }

      function closeModal() {
        $mdDialog.hide();
      }
      function getPeriode(){
        var res=Attendancereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.start_date=new Date(data[0]['periode_start']);
        vm.end_date=new Date(data[0]['periode_end']);
        // console.log(vm.periode);
        // loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }

      function loadDataDepartment(iddivisi) {
           var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listDepartment=data;

        // loadData(1);
      }

      function errorDepartment() {
        vm.listDepartment=[];
      }

      function loadDataDivision(idbu) {
         var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
      }

      function fetchDivisiBU(data) {
       vm.listDivision=data;
        loadDataDepartment(vm.divisi);
       // vm.listDivision.push(data);
       // loadData(1);
      }

      function errorDivisiBU() {
        vm.listDivision=[];
        errorDepartment();
      }

      function loadDataBU() {
        var response=Attendancereport.query({action:'viewBu'});
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
        vm.listBU=data;
        loadSubArea();
        loadDataDivision(vm.company);
      }

      function errorFetchBU() {
        vm.listBU=[];
        errorfetchArea();
        errorDivisiBU();
      }

      function download()
      {
        var company=vm.company;
        var divisi=vm.divisi;
        var department=vm.department;
        var start_date= changeDateFormat(vm.start_date);
        var end_date= changeDateFormat(vm.end_date);
        var token=Auth.setTokenPromise();
        var subarea=vm.selectedSubarea;
        var building=vm.selectedBuilding;
        var sector=vm.selectedSector;
        var reqPage = vm.page != 'all' ? vm.page : '-1';
        var empType=vm.flag_app;

        token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.api+'api/attendancereport/downloadsvarange/'+company+'/'+divisi+'/'+department+'/'+start_date+'/'+end_date+'/'+subarea+'/'+empType+'/'+reqPage+'/'+building+'/'+sector,'_blank');
          },function(){

              $window.alert('gagal load token');
          });
      }

      function  loadSubArea()
      {
        var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorfetchArea);
      }

      function fetchArea(data)
      {
        vm.subArea=data;
        if(isAdminPlant) {
          if(vm.subArea.length > 0) {
            vm.selectedSubarea = vm.subArea[0].subarea_id;
            vm.getListGedung(vm.selectedSubarea);
          } else {
            vm.listGedung = vm.listSector = [];
          }
        }
      }

      function errorfetchArea(data)
      {
        vm.subArea=[];
        if(isAdminPlant) {
          errorGedung();
        }
      }

      function closeModal()
      {
          $mdDialog.hide();
      }

      function selectSubarea() {
        if(isAdminPlant) {
          vm.getListGedung(vm.selectedSubarea);
        } 

        if(vm.selectedSubarea == 'all') {
          vm.page = '0';
        } else {
          vm.page = 'all';
        }
      }

      function getListGedung(subArea)
      {
          angular.element.blockUI();
          var resp=Approvalabsence.query({action:'getListGedung',subArea:subArea});
          resp.$promise.then(function(data) {
              vm.listGedung = data
              vm.selectedBuilding = 'all';
              vm.getListSector(vm.selectedBuilding);
              // angular.element.unblockUI();
          });
          resp.$promise.catch(function(data){
              vm.listGedung = []
              errorSector();
              // angular.element.unblockUI();
          });    
      }
      
      function getListSector(buildingId)
      {
          angular.element.blockUI();
          var resp=Completeness.query({action:'viewSector',buildingId:buildingId});
          resp.$promise.then(function(data) {
              vm.listSector = data
              vm.selectedSector = 'all';
              angular.element.unblockUI();
          });
          resp.$promise.catch(function(data){
              vm.listSector = []
              // angular.element.unblockUI();
          });    
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('ResignationPayleaveDownloadController', ResignationPayleaveDownloadController);

    ResignationPayleaveDownloadController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','FileUploader','config','Auth','$window','$location'];

    /* @ngInject */
    function ResignationPayleaveDownloadController($localStorage,$mdDialog,Form,AppAPI,$log,FileUploader,config,Auth,$window,$location) {
      var vm = this;
      Form.initialForm();

      var Attendancereport=AppAPI.Attendancereport();
      vm.closeModal=closeModal;
      vm.DownloadTemplate = DownloadTemplate;
      vm.Download=Download;
 
      vm.uploadFile=uploadFile;
      vm.uploadSuccess = false;
      vm.uploadError = false;
      vm.uploadNotif = '';

      vm.start_date = vm.end_date = null;

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();

      if(vm.tgl >=25 && vm.tgl <=31) {
        vm.bulan=vm.bulan+1;
      }

      if(vm.bulan < 10) {
        vm.bulan='0'+vm.bulan;
      }

      getPeriode();
      //////////////////////////
      var uploaderPhoto= vm.FileUpload= new FileUploader({
         url:config.api+'api/attendancereport/payleavereportresignupload', 
         removeAfterUpload:true,
         alias:'filenikresign',
         formData:[],
          onAfterAddingAll:function(){
              vm.uploadSuccess = false;
              vm.uploadError = false;
          },
          headers:{
              tokenAuth:$localStorage.tokenAuth
          }
      }); 

      uploaderPhoto.onSuccessItem = function(item, status) {
          if ( status.status == 0 ) {
              vm.uploadSuccess = false;
              vm.uploadError   = true;
          } else {
              vm.uploadSuccess = true;
              vm.uploadError   = false;
          }

          var tempNotif = status.message.split("||");

          vm.uploadNotif = tempNotif[0];
          if ('moreInfo' in status && status.moreInfo.length>0) {
              vm.isMoreInfo = true;
              vm.detailInfo = status.moreInfo;
          }
          angular.element('#uploaderPhoto').val('');

          if(status.status == 1) {
            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.api + 'api/attendancereport/payleavereportresignrange/' + tempNotif[2] + '/' + tempNotif[3] + '/' + tempNotif[1], '_blank');
          }

          angular.element.unblockUI();
      };

      function Download() {
        angular.element.blockUI();

        vm.FileUpload.onBeforeUploadItem = function(item) {
          var startDate= changeDateFormat(vm.start_date);
          var endDate= changeDateFormat(vm.end_date);
          
          item.formData.push({'start_date': startDate});
          item.formData.push({'end_date': endDate});
        };

        vm.FileUpload.uploadAll();
      }

      uploaderPhoto.onErrorItem=function()
      {
          vm.uploadSuccess = false;
          vm.uploadError = true;
          angular.element.unblockUI();
      }; 

      function uploadFile() {
          return false;
      }

      function changeDateFormat(date){
        var monthTmp = "" + (date.getMonth()+1);
        var monthPad = "00";
        var month = monthPad.substring(0, monthPad.length - monthTmp.length) + monthTmp;

        var dayTmp = "" + date.getDate();
        var dayPad = "00";
        var day = dayPad.substring(0, dayPad.length - dayTmp.length) + dayTmp;

        var year = date.getFullYear();
        return year+"-"+month+"-"+day;
      }

      function closeModal() {
        $mdDialog.hide();
      }

      function getPeriode() {
        var res=Attendancereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.start_date=new Date(data[0]['periode_start']);
        vm.end_date=new Date(data[0]['periode_end']);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }

      function DownloadTemplate() {
          var token = Auth.setTokenPromise();
          token.then(function (data) {
              var protocol = $location.protocol();
              var host = $location.host();
              $window.open(protocol + '://' + host + config.api + 'api/attendancereport/downloadshiftresigntemplate', '_blank');
          }, function () {

              $window.alert('gagal load token');
          });
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('PayleaveDownloadController', PayleaveDownloadController);

    PayleaveDownloadController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','FileUploader','config','Auth','$window','$location'];

    /* @ngInject */
    function PayleaveDownloadController($localStorage,$mdDialog,Form,AppAPI,$log,FileUploader,config,Auth,$window,$location) {
      var vm = this;
      Form.initialForm();

      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      var Attendancereport=AppAPI.Attendancereport();
      vm.company=$localStorage.empsite;
      vm.groupLogin=$localStorage.group;
      vm.download=download;
      vm.closeModal=closeModal;
      vm.flag_app = 'SAP';
      vm.selectedSubarea = '';
      vm.loadSubArea=loadSubArea;

      vm.start_date = vm.end_date = null;

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();

      var isAdminPlant = false;
      if(vm.groupLogin == 11) {
        isAdminPlant = true;
      }

      if(vm.tgl >=25 && vm.tgl <=31)
      {
        vm.bulan=vm.bulan+1;
      }

      if(vm.bulan < 10) {
        vm.bulan='0'+vm.bulan;
      }

      vm.divisi='all';
      vm.department='all';
      vm.typeEmp = [
        {
          "view"  : "All",
          "value" : "all"
        },
        {
          "view"  : "Staff",
          "value" : "SAP"
        },
        {
          "view"  : "General Worker",
          "value" : "HRIS"
        }
      ];

      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];

      getPeriode();
      loadDataBU();
      //////////////////////////
      function changeDateFormat(date){
        var monthTmp = "" + (date.getMonth()+1);
        var monthPad = "00";
        var month = monthPad.substring(0, monthPad.length - monthTmp.length) + monthTmp;

        var dayTmp = "" + date.getDate();
        var dayPad = "00";
        var day = dayPad.substring(0, dayPad.length - dayTmp.length) + dayTmp;

        var year = date.getFullYear();
        return year+"-"+month+"-"+day;
      }

      function closeModal() {
        $mdDialog.hide();
      }

      function getPeriode(){
        // var res=Attendancereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
        // res.$promise.then(fetchPeriode);
        // res.$promise.catch(errorfetchPeriode);
        var res=Attendancereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.start_date=new Date(data[0]['periode_start']);
        vm.end_date=new Date(data[0]['periode_end']);
        // vm.periode=data[0]['periode'];
        // console.log(vm.periode);
        // loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }

      function loadDataDepartment(iddivisi) {
           var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
          vm.listDepartment=data;

          // loadData(1);
        }

        function errorDepartment() {
          vm.listDepartment=[];
        }

        function loadDataDivision(idbu) {
           var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
          response.$promise.then(fetchDivisiBU);
          response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
         vm.listDivision=data;
         loadDataDepartment(vm.divisi);
         // vm.listDivision.push(data);
         // loadData(1);
        }

        function errorDivisiBU() {
          vm.listDivision=[];
          errorDepartment();
        }

        function loadDataBU() {
          var response=Attendancereport.query({action:'viewBu'});
          response.$promise.then(fetchBU);
          response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
          vm.listBU=data;
          loadSubArea();
          loadDataDivision(vm.company); 
        }

        function errorFetchBU() {
          vm.listBU=[];
          errorfetchArea();
          errorDivisiBU();
        }

        function download()
        {
          var company=vm.company;
          var divisi=vm.divisi;
          var department=vm.department;
          var start_date= changeDateFormat(vm.start_date);
          var end_date= changeDateFormat(vm.end_date);
          var token=Auth.setTokenPromise();
          var subarea=vm.selectedSubarea;
          var empType=vm.flag_app;

          token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                  // $window.open(protocol+'://'+host+config.api+'api/attendancereport/payleavereport/'+company+'/'+divisi+'/'+department+'/'+start_date+'/'+end_date+'/'+subarea+'/'+empType+'/'+reqPage+'/'+building+'/'+sector,'_blank');
                  $window.open(protocol+'://'+host+config.api+'api/attendancereport/payleavereportrange/'+company+'/'+divisi+'/'+department+'/'+start_date+'/'+end_date+'/'+subarea+'/'+empType, '_blank');
            },function(){

                $window.alert('gagal load token');
            });
        }

        function  loadSubArea()
        {
          var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
          if(isAdminPlant) {
            if(vm.subArea.length > 0) {
              vm.selectedSubarea = vm.subArea[0].subarea_id;
            }
          }
        }

      function errorfetchArea(data)
      {
        vm.subArea=[];
      }

      function closeModal()
      {
          $mdDialog.hide();
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('LeaveWaitingApprovalController', LeaveWaitingApprovalController);

    LeaveWaitingApprovalController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','FileUploader','config','Auth','$window','$location'];

    /* @ngInject */
    function LeaveWaitingApprovalController($localStorage,$mdDialog,Form,AppAPI,$log,FileUploader,config,Auth,$window,$location) {
      var vm = this;
      Form.initialForm();

      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      var Attendancereport=AppAPI.Attendancereport();
      vm.company=$localStorage.empsite;
      vm.groupLogin=$localStorage.group;
      vm.download=download;
      vm.closeModal=closeModal;
      vm.loadSubArea=loadSubArea;

      loadDataBU();
      loadDataDivision(vm.company);
      getPeriode();
      loadSubArea();

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();
      if(vm.tgl >=20 && vm.tgl <=31)
      {
        vm.bulan=vm.bulan+1;
      }
      if(vm.bulan < 10){
        vm.bulan='0'+vm.bulan;
      }
      vm.divisi='all';
      vm.department='all';
      vm.typeEmp = [
        {
          "view"  : "Staff",
          "value" : "SAP"
        },
        {
          "view"  : "General Worker",
          "value" : "HRIS"
        }
      ];
      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];

      //////////////////////////


      function closeModal() {
        $mdDialog.hide();
      }
      function getPeriode(){
          var res=Attendancereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
          res.$promise.then(fetchPeriode);
          res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data)
        {
          vm.periode=data[0]['periode'];
          // console.log(vm.periode);
          // loadData(1);
        }

        function errorfetchPeriode(data)
        {
          console.log('error');
        }

      function loadDataDepartment(iddivisi) {
           var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
          vm.listDepartment=data;

          // loadData(1);
        }

        function errorDepartment() {
          vm.listDepartment=[];
        }

        function loadDataDivision(idbu) {
           var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
          response.$promise.then(fetchDivisiBU);
          response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
         vm.listDivision=data;
         // vm.listDivision.push(data);
         // loadData(1);
        }

        function errorDivisiBU() {
          vm.listDivision=[];
        }

        function loadDataBU() {
          var response=Attendancereport.query({action:'viewBu'});
          response.$promise.then(fetchBU);
          response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
          vm.listBU=data;
        }

        function errorFetchBU() {
          vm.listBU=[];
        }

        function download()
        {
          var company=vm.company;
          var divisi=vm.divisi;
          var department=vm.department;
          var tahun=vm.tahun;
          var bulan=vm.bulan;
          var token=Auth.setTokenPromise();
          var subarea=vm.selectedSubarea;
          var empType=null;
          if(typeof(vm.employeeType) !== "undefined")
          {
            empType = vm.employeeType;
          }
          token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                   $window.open(protocol+'://'+host+config.api+'api/attendancereport/downloadattendances/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan+'/'+subarea+'/'+empType, '_blank');
            },function(){

                $window.alert('gagal load token');
            });
        }

        function  loadSubArea()
        {
          var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }

      function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('DownloadAttendanceController', DownloadAttendanceController);

    DownloadAttendanceController.$inject = [
        '$state',
        '$window',
        '$location',
        '$localStorage',
        '$document',
        '$element',
        '$http',
        '$scope',
        'config',
        '$log',
        '$mdDialog',
        'AppAPI',
        'Auth',
        'DataService'
    ];

    /* @ngInject */
    function DownloadAttendanceController(
        $state,
        $window,
        $location,
        $localStorage,
        $document,
        $element,
        $http,
        $scope,
        config,
        $log,
        $mdDialog,
        AppAPI,
        Auth,
        DataService
    ) {
        var vm = this;
        var Attendancereport=AppAPI.Attendancereport();

        vm.downloadAttenddance = downloadAttenddance;
        vm.downloadSummaryAttenddance = downloadSummaryAttenddance;
        vm.leaveWaitingApproval = leaveWaitingApproval;
        vm.payleaveDownload = payleaveDownload;
        vm.transactionWaitingApproval = transactionWaitingApproval;
        vm.downloadSva = downloadSva;
        vm.Download = Download;

        loadReportList();
        
        function loadReportList() 
        {
            angular.element.blockUI();
            var response=Attendancereport.query({action:'getReportList'});
           response.$promise.then(fetchReportList);
           response.$promise.catch(errorFetchReportList);
        }
 
        function fetchReportList(data) 
        {
            vm.listReport = data;
            angular.element.unblockUI();
        }
 
        function errorFetchReportList() 
        {
           vm.listReport=[];
            angular.element.unblockUI();
        }

        ///////////////////////////////
        function Download(ev, data) {
            switch (data) {
                case 'downloadAttenddance':
                    downloadAttenddance(ev);
                    break;
                case 'downloadSummaryAttenddance':
                    downloadSummaryAttenddance(ev);
                    break;
                case 'leaveWaitingApproval':
                    leaveWaitingApproval(ev);
                    break;
                case 'payleaveDownload':
                    payleaveDownload(ev);
                    break;
                case 'transactionWaitingApproval':
                    transactionWaitingApproval(ev);
                    break;
                case 'downloadSva':
                    downloadSva(ev);
                    break;
                case 'downloadAttendancePMA':
                    downloadAttendancePMA(ev);
                    break;
                case 'reportCico':
                    reportCico(ev);
                    break;
                case 'resignationPayleaveDownload':
                    resignationPayleaveDownload(ev);
                    break;
            }
        }

        function downloadAttenddance(ev) {
            $mdDialog.show({
                controller: 'AttendancesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/download-attendance/attendances.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData();
                }
            });
        }

        function downloadSummaryAttenddance(ev) {
            $mdDialog.show({
                controller: 'AttendanceSummaryController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/download-attendance/attendance-summary.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData();
                }
            });
        }

        function leaveWaitingApproval(ev) {
            $mdDialog.show({
                controller: 'LeaveWaitingApprovalController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/download-attendance/leave-waiting-approval.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData();
                }
            });
        }

        function payleaveDownload(ev) {
            $mdDialog.show({
                controller: 'PayleaveDownloadController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/download-attendance/payleave-download.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData();
                }
            });
        }

        function transactionWaitingApproval(ev) {
            $mdDialog.show({
                controller: 'TransactionDownloadController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/download-attendance/transaction-download.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData();
                }
            });
        }

        function downloadSva(ev) {
            $mdDialog.show({
                controller: 'DownloadSvaController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/download-attendance/sva-download.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    // loadData();
                }
            });
        }

        function downloadAttendancePMA(ev) {
            $mdDialog.show({
                controller: 'DownloadAttendancePMAController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/download-attendance/download-attendance-pma.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    // loadData();
                }
            });
        }

        function reportCico(ev)
        {
            $mdDialog.show({
                controller: 'reportCicoController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/download-attendance/report-sap/cico.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    // loadData();
                }
            });
        }

        function resignationPayleaveDownload(ev) {
            $mdDialog.show({
                controller: 'ResignationPayleaveDownloadController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/cb/download-attendance/resignation-payleave-download.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function(element, removePromise) {
                    loadData();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('DownloadAttendancePMAController', Controller);

    Controller.$inject = [
        '$localStorage',
        '$mdDialog',
        'Form',
        'AppAPI',
        '$log',
        'FileUploader',
        'config',
        'Auth',
        '$window',
        '$element',
        '$location'
    ];

    /* @ngInject */
    function Controller(
        $localStorage,
        $mdDialog,
        Form,
        AppAPI,
        $log,
        FileUploader,
        config,
        Auth,
        $window,
        $element,
        $location
    ) {
        var vm = this;
        Form.initialForm();

        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        var Attendancereport = AppAPI.Attendancereport();
        var Approvalabsence = AppAPI.Approvalabsence();
        var Completeness = AppAPI.Completeness();
        vm.company = 'PM';
        vm.groupLogin = $localStorage.group;
        vm.download = download;
        vm.closeModal = closeModal;
        vm.flag_app = 'SAP';
        vm.flagApp = ['SAP', 'HRIS'];
        vm.loadSubArea=loadSubArea;

        loadDataBU();
        loadDataDivision(vm.company);
        getPeriode();
        loadSubArea();

        vm.changeDate = changeDate
        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.getPeriode = getPeriode;
        vm.tgl = date.getDate();
        vm.page = '0,1000';

        vm.endDt = date;

        Date.prototype.addDays = function(days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }
        
        function changeDate(date)
        {
            var dates = date;
            vm.endDt = date.addDays(31);
        }
        
        if (vm.tgl >= 25 && vm.tgl <= 31) {
            vm.bulan = vm.bulan + 1;
        }

        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }

        vm.divisi = 'all';
        vm.department = 'all';
        vm.typeEmp = [
            {
                view: 'Staff',
                value: 'SAP'
            },
            {
                view: 'General Worker',
                value: 'HRIS'
            }
        ];

        vm.listtahun = [2017, 2018, 2019,2020,2021];
        vm.listbulan = [
            { name: 'January', value: '01' },
            { name: 'February', value: '02' },
            { name: 'Maret', value: '03' },
            { name: 'April', value: '04' },
            { name: 'Mei', value: '05' },
            { name: 'June', value: '06' },
            { name: 'July', value: '07' },
            { name: 'August', value: '08' },
            { name: 'September', value: '09' },
            { name: 'October', value: '10' },
            { name: 'November', value: '11' },
            { name: 'Desember', value: '12' }
        ];

        vm.listPage = [
            { name: '0-500', value: '0' },
            { name: '501-1000', value: '1' },
            { name: '1001-1500', value: '2' },
            { name: '1501-2000', value: '3' },
            { name: '2001-2500', value: '4' },
            { name: '2501-3000', value: '5' },
            { name: '3001-3500', value: '6' },
            { name: '3501-4000', value: '7' },
            { name: '4001-4500', value: '8' },
            { name: '4501-5000', value: '9' },
            { name: '5001-5500', value: '10' },
            { name: '5501-6000', value: '11' },
            { name: '6001-6500', value: '12' },
            { name: '6501-7000', value: '13' },
            { name: '7001-7500', value: '14' },
            { name: '7501-8000', value: '15' },
            { name: '8001-8500', value: '16' },
            { name: '8501-9000', value: '17' },
            { name: '9001-9500', value: '18' },
            { name: '9501-10000', value: '19' }
        ];

        //////////////////////////

        function closeModal() {
            $mdDialog.hide();
        }

        function getPeriode() {
            var res = Attendancereport.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan,
                flag_app: vm.flag_app
            });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            vm.periode = data[0]['periode'];
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendancereport.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function download() {
            var company = vm.company;
            var divisi = vm.divisi;
            var department = vm.department;
            var startDate = angular.copy(vm.startDate);
            var endDate = angular.copy(vm.endDate);
            var token = Auth.setTokenPromise();
            var subarea = vm.selectedSubarea;
            var empType = null;

            if (typeof vm.flag_app !== 'undefined') {
                empType = vm.flag_app;
            }

            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            '://' +
                            host +
                            config.port +
                            config.api +
                            'api/attendancereport/downloadattendancepma/' +
                            company +
                            '/' +
                            divisi +
                            '/' +
                            department +
                            '/' +
                            moment(startDate).format('YYYY-MM-DD') +
                            '/' +
                            moment(endDate).format('YYYY-MM-DD') +
                            '/' +
                            subarea +
                            '/' +
                            empType +
                            '/' +
                            vm.page,
                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }

        function loadSubArea() {
            var response = Attendancereport.query({ action: 'viewSubArea',company:vm.company});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('AttendancesController', AttendancesController);

    AttendancesController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','FileUploader','config','Auth','$window','$location'];

    /* @ngInject */
    function AttendancesController($localStorage,$mdDialog,Form,AppAPI,$log,FileUploader,config,Auth,$window,$location) {
      var vm = this;
      Form.initialForm();

      var Attendancereport = AppAPI.Attendancereport();
      var Approvalabsence = AppAPI.Approvalabsence();
      var Completeness = AppAPI.Completeness();

      vm.loadDataDivision = loadDataDivision;
      vm.loadDataDepartment = loadDataDepartment;

      vm.company = $localStorage.empsite;
      vm.groupLogin = $localStorage.group;
      vm.download = download;
      vm.closeModal = closeModal;
      vm.flagApp = ['SAP','HRIS'];
      vm.flag_app = 'SAP';
      vm.selectedSubarea = '';
      vm.loadSubArea=loadSubArea;

      vm.start_date = vm.end_date = null;

      var date = new Date();
      vm.tahun = date.getFullYear();
      vm.bulan = date.getMonth() + 1;
      vm.tgl = date.getDate();
      
      vm.getPeriode = getPeriode;
      vm.selectSubarea = selectSubarea;
      vm.getListGedung = getListGedung;
      vm.getListSector = getListSector;
      
      vm.selectedBuilding = vm.selectedSector = 'all';

      vm.page = '0';

      vm.isRkPma = false;
      if(vm.company == "RK" || vm.company == "PM")
      {
        vm.isRkPma = true;
      }

      var isAdminPlant = false;
      if(vm.groupLogin == 11) {
        isAdminPlant = true;
      }

      if(vm.tgl >=25 && vm.tgl <=31)
      {
        vm.bulan=vm.bulan+1;
      }

      if(vm.bulan < 10) {
        vm.bulan='0'+vm.bulan;
      }

      vm.divisi='all';
      vm.department='all';
      vm.typeEmp = [
        {
          "view"  : "All",
          "value" : "all"
        },
        {
          "view"  : "Staff",
          "value" : "SAP"
        },
        {
          "view"  : "General Worker",
          "value" : "HRIS"
        }
      ];

      vm.listtahun=[2014,2015,2016,2017,2018,2019];

      vm.listbulan=[
                    {name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}
                  ];

      vm.listPage=[
                    {name:'All',value:'all'},
                    {name:'0-500',value:'0'},
                    {name:'501-1000',value:'1'},
                    {name:'1001-1500',value:'2'},
                    {name:'1501-2000',value:'3'},
                    {name:'2001-2500',value:'4'},
                    {name:'2501-3000',value:'5'},
                    {name:'3001-3500',value:'6'},
                    {name:'3501-4000',value:'7'},
                    {name:'4001-4500',value:'8'},
                    {name:'4501-5000',value:'9'},
                    {name:'5001-5500',value:'10'},
                    {name:'5501-6000',value:'11'},
                    {name:'6001-6500',value:'12'},
                    {name:'6501-7000',value:'13'},
                    {name:'7001-7500',value:'14'},
                    {name:'7501-8000',value:'15'}, 
                    {name:'8001-8500',value:'16'}, 
                    {name:'8501-9000',value:'17'},
                    {name:'9001-9500',value:'18'},
                    {name:'9501-10000',value:'19'} 
                  ];

      loadDataBU();
      getPeriode();
      //////////////////////////
      function changeDateFormat(date){
        var monthTmp = "" + (date.getMonth()+1);
        var monthPad = "00";
        var month = monthPad.substring(0, monthPad.length - monthTmp.length) + monthTmp;

        var dayTmp = "" + date.getDate();
        var dayPad = "00";
        var day = dayPad.substring(0, dayPad.length - dayTmp.length) + dayTmp;

        var year = date.getFullYear();
        return year+"-"+month+"-"+day;
      }

      function closeModal() 
      {
        $mdDialog.hide();
      }

      function getPeriode() 
      {
        var res=Attendancereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.start_date=new Date(data[0]['periode_start']);
        vm.end_date=new Date(data[0]['periode_end']);
        // console.log(vm.periode);
        // loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }

      function loadDataDepartment(iddivisi) {
        var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listDepartment=data;
        // loadData(1);
      }

      function errorDepartment() {
        vm.listDepartment=[];
      }

      function loadDataDivision(idbu) {
        var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
      }

      function fetchDivisiBU(data) {
        vm.listDivision=data;
        loadDataDepartment(vm.divisi);
        // vm.listDivision.push(data);
        // loadData(1);
      }

      function errorDivisiBU() {
        vm.listDivision=[];
        errorDepartment();
      }

      function loadDataBU() {
        var response=Attendancereport.query({action:'viewBu'});
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }

      function fetchBU(data) {
        vm.listBU=data;
        loadSubArea();
        loadDataDivision(vm.company);
      }

      function errorFetchBU() {
        vm.listBU=[];
        errorfetchArea();
        errorDivisiBU();
      }

      function download()
      {
        var company=vm.company;
        var divisi=vm.divisi;
        var department=vm.department;
        var start_date= changeDateFormat(vm.start_date);
        var end_date= changeDateFormat(vm.end_date);
        var token=Auth.setTokenPromise();
        var subarea=vm.selectedSubarea;
        var building=vm.selectedBuilding;
        var sector=vm.selectedSector;
        var reqPage = vm.page != 'all' ? vm.page : '-1';
        var empType=vm.flag_app;

        token.then(function(data){
          var protocol=$location.protocol();
          var host=$location.host();
          $window.open(protocol+'://'+host+config.api+'api/attendancereport/downloadattendancesrange/'+company+'/'+divisi+'/'+department+'/'+start_date+'/'+end_date+'/'+subarea+'/'+empType+'/'+reqPage+'/'+building+'/'+sector+'/'+vm.nik,'_blank');
        },function(){
          $window.alert('gagal load token');
        });
      }

      function loadSubArea()
      {
        var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
        response.$promise.then(fetchArea);
        response.$promise.catch(errorfetchArea);
      }

      function fetchArea(data)
      {
        vm.subArea=data;
        if(isAdminPlant) {
          if(vm.subArea.length > 0) {
            vm.selectedSubarea = vm.subArea[0].subarea_id;
            vm.getListGedung(vm.selectedSubarea);
          } else {
            vm.listGedung = vm.listSector = [];
          }
        }
      }

      function errorfetchArea(data)
      {
        vm.subArea=[];
        if(isAdminPlant) {
          errorGedung();
        }
      }

      function selectSubarea() {
        if(isAdminPlant) {
          vm.getListGedung(vm.selectedSubarea);
        } 

        if(vm.selectedSubarea == 'all') {
          vm.page = '0';
        } else {
          vm.page = 'all';
        }
      }

      function getListGedung(subArea)
      {
        // angular.element.blockUI();
        var resp=Approvalabsence.query({action:'getListGedung',subArea:subArea});
        resp.$promise.then(function(data) {
          vm.listGedung = data;
          vm.selectedBuilding = 'all';
          vm.getListSector(vm.selectedBuilding);
          // angular.element.unblockUI();
        });
        resp.$promise.catch(errorGedung);   
      }

      function errorGedung(){
        vm.listGedung = [];
        errorSector();
        // angular.element.unblockUI();
      } 
      
      function getListSector(buildingId)
      {
        // angular.element.blockUI();
        var resp=Completeness.query({action:'viewSector',buildingId:buildingId});
        resp.$promise.then(function(data) {
          vm.listSector = data;
          vm.selectedSector = 'all';
          // angular.element.unblockUI();
        });
        resp.$promise.catch(errorSector);    
      }

      function errorSector(){
        vm.listSector = [];
        // angular.element.unblockUI();
      }

      function closeModal()
      {
        $mdDialog.hide();
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.download-attendance')
        .controller('AttendanceSummaryController', AttendanceSummaryController);

    AttendanceSummaryController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','FileUploader','config','Auth','$window','$location'];

    /* @ngInject */
    function AttendanceSummaryController($localStorage,$mdDialog,Form,AppAPI,$log,FileUploader,config,Auth,$window,$location) {
      var vm = this;
      Form.initialForm();

      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      var Attendancereport=AppAPI.Attendancereport();
      vm.company=$localStorage.empsite;
      vm.groupLogin=$localStorage.group;
      vm.download=download;
      vm.closeModal=closeModal;
      vm.flag_app = 'SAP';
      vm.selectedSubarea = '';
      vm.type = null;

      vm.start_date = vm.end_date = null;

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();

      var isAdminPlant = false;
      if(vm.groupLogin == 11) {
        isAdminPlant = true;
      }

      if(vm.tgl >=20 && vm.tgl <=31)
      {
        vm.bulan=vm.bulan+1;
      }

      if(vm.bulan < 10){
        vm.bulan='0'+vm.bulan;
      }

      vm.divisi='all';
      vm.department='all';
      vm.typeEmp = [
        {
          "view"  : "All",
          "value" : "all"
        },
        {
          "view"  : "Staff",
          "value" : "SAP"
        },
        {
          "view"  : "General Worker",
          "value" : "HRIS"
        }
      ];

      vm.listtahun=[2017,2018,2019, 2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];

      loadDataBU();
      getPeriode();
      //////////////////////////
      function changeDateFormat(date){
        var monthTmp = "" + (date.getMonth()+1);
        var monthPad = "00";
        var month = monthPad.substring(0, monthPad.length - monthTmp.length) + monthTmp;

        var dayTmp = "" + date.getDate();
        var dayPad = "00";
        var day = dayPad.substring(0, dayPad.length - dayTmp.length) + dayTmp;

        var year = date.getFullYear();
        return year+"-"+month+"-"+day;
      }

      function closeModal() {
        $mdDialog.hide();
      }

      function getPeriode(){
          var res=Attendancereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
          res.$promise.then(fetchPeriode);
          res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data)
        {
          vm.start_date=new Date(data[0]['periode_start']);
          vm.end_date=new Date(data[0]['periode_end']);
          // vm.periode=data[0]['periode'];
          // console.log(vm.periode);
          // loadData(1);
        }

        function errorfetchPeriode(data)
        {
          console.log('error');
        }

      function loadDataDepartment(iddivisi) {
           var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
          response.$promise.then(fetchDepartment);
          response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
          vm.listDepartment=data;

          // loadData(1);
        }

        function errorDepartment() {
          vm.listDepartment=[];
        }

        function loadDataDivision(idbu) {
           var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
          response.$promise.then(fetchDivisiBU);
          response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
         vm.listDivision=data;
         // vm.listDivision.push(data);
         // loadData(1);
          loadDataDepartment(vm.divisi);
        }

        function errorDivisiBU() {
          vm.listDivision=[];
          errorDepartment();
        }

        function loadDataBU() {
          var response=Attendancereport.query({action:'viewBu'});
          response.$promise.then(fetchBU);
          response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
          vm.listBU=data;
          loadSubArea();
          loadDataDivision(vm.company);
        }

        function errorFetchBU() {
          vm.listBU=[];
          errorfetchArea();
          errorDivisiBU();
        }

        function download()
        {
          var company=vm.company;
          var divisi=vm.divisi;
          var department=vm.department;
          var startDate= changeDateFormat(vm.start_date);
          var endDate= changeDateFormat(vm.end_date);
          var token=Auth.setTokenPromise();
          var subarea=vm.selectedSubarea;
          var empType=vm.flag_app;
          token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                   $window.open(protocol+'://'+host+config.api+'api/attendancereport/downloadattendancesummaryrange/'+company+'/'+divisi+'/'+department+'/'+startDate+'/'+endDate+'/'+subarea+'/'+empType, '_blank');
            },function(){

                $window.alert('gagal load token');
            });
        }

        function loadSubArea()
        {
          var response=Attendancereport.query({action:'viewSubArea'});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
          if(isAdminPlant) {
            if(vm.subArea.length > 0) {
              vm.selectedSubarea = vm.subArea[0].subarea_id;
            }
          }
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }

      function closeModal()
        {
            $mdDialog.hide();
        }

    }
})();

(function () {
  'use strict';

  angular
      .module('app.cb.cutoffperiode', [
        'app.cb.cutoffperiode.input-cut-off-periode',
        'app.cb.cutoffperiode.upload-cut-off-periode',
        'app.cb.cutoffperiode.edit-cut-off-periode'
      ])
      .config(config);

  config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
      $stateProvider
          .state('app.cb_cutoffperiode', {
              url: '/cb/cutoffperiode',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/cb/cut-off-periode/cut-off-periode.html',
                      controller: 'CutOffPeriodeController as vm'
                  }
              }
          });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.cb.cutoffperiode')
    .controller('CutOffPeriodeController', CutOffPeriodeController);

  CutOffPeriodeController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form'
  ];
  /** @ngInject */
  function CutOffPeriodeController(
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form
  ) {
    var vm = this;
    var apiCutOff = AppAPI.CutOffPeriode();
    var Attendancereport = AppAPI.Attendancereport();
    var ApiHoliday = AppAPI.NationalHoliday();
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.company = $localStorage.empsite;
    vm.selectedSubarea = '0';
    vm.divisi = 'all';
    vm.department = 'all';
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    vm.addCutOffPeriode = addCutOffPeriode;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.deleteDataCutOff = deleteDataCutOff;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.EditCutOffPeriode = EditCutOffPeriode;
    vm.UploadCutOffPeriode = UploadCutOffPeriode;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      loadDataDivision(vm.company);
      loadSubArea();
      loadDataBU();
    }

    function loadData(pageno) {
      var subarea = vm.selectedSubarea == '0' ? 'all' : vm.selectedSubarea;
      var resp = vm.DataTables.loadData(apiCutOff, pageno, {
        action: 'viewDataCutOffPeriode',
        company: vm.company,
        subarea: subarea,
        divisi : vm.divisi,
        department : vm.department
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function deleteDataCutOff(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = apiCutOff.delete({
              action: 'deleteDataCutOffPeriode',
              data: angular.toJson(data)
            });
            response.$promise.then(function(data) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function addCutOffPeriode(ev) {
      $mdDialog.show({
        controller: 'InputCutOffPeriodeController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/cut-off-periode/input-cut-off-periode/input-cut-off-periode.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          loadData: vm.loadData,
          listBU: vm.listBU,
          company: vm.company,
          subArea: vm.subArea,
          dialogClose: dialogClose
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function UploadCutOffPeriode(ev) {
      $mdDialog.show({
        controller: 'UploadCutOffPeriodeController',
        controllerAs: 'vm',
        templateUrl:
          'app/main/cb/cut-off-periode/upload-cut-off-periode/upload-cut-off-periode.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          dialogClose: dialogClose,
          loadData: loadData
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function EditCutOffPeriode(ev, data) {
      $mdDialog.show({
        controller: 'EditCutOffPeriodeController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/cut-off-periode/edit-cut-off-periode/edit-cut-off-periode.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          updateData: data,
          loadData: vm.loadData,
          listBU: vm.listBU,
          company: vm.company,
          subArea: vm.subArea,
          dialogClose: dialogClose
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          loadData(1);
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function loadDataBU() {
      var response = Attendancereport.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }

    function loadSubArea() {
      var response = ApiHoliday.query({
        action: 'loadDataSubArea',
        idbu: vm.company
      });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorfetchArea);
    }

    function fetchArea(data) {
      vm.subArea = data;
    }

    function errorfetchArea(data) {
      vm.subArea = [];
    }

    function loadDataDepartment(iddivisi) {
      var response = Attendancereport.query({
        action: 'viewDivisiDept',
        idbu: vm.company,
        iddivisi: iddivisi
      });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
    }

    function errorDepartment() {
      vm.listDepartment = [];
    }

    function loadDataDivision(idbu) {
      var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
      vm.listDivision = data;
    }

    function errorDivisiBU() {
      vm.listDivision = [];
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.commit-attendance', [])
        .config(config)
        .filter('slice', function() {
            return function(arr, start, end) {
                return arr.slice(start, end);
            };
        });

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.cb_commit_attendance', {
                url: '/cb/commit-attendance',
                views: {
                    'content@app': {
                        templateUrl:
                            'app/main/cb/commit-attendance/commit-attendance.html',
                        controller: 'CommitAttendanceController as vm'
                    }
                }
            })
            .state('app.cb_new_commit_attendance', {
                url: '/cb/commit-attendance/new',
                views: {
                    'content@app': {
                        templateUrl:
                            'app/main/cb/commit-attendance/new-commit-attendance.html',
                        controller: 'newCommitAttendncController as vm'
                    }
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.commit-attendance')
        .controller('newCommitAttendncController', newCommitAttendncController);

    newCommitAttendncController.$inject = [
        '$localStorage',
        '$mdDialog',
        '$log',
        '$window',
        '$location',
        'Form',
        'AppAPI',
        'FileUploader',
        'config',
        'Auth'
    ];
    /* @ngInject */
    function newCommitAttendncController(
        $localStorage,
        $mdDialog,
        $log,
        $window,
        $location,
        Form,
        AppAPI,
        FileUploader,
        config,
        Auth
    ) {
        var vm = this;
        Form.initialForm();
        vm.saveData = saveData;
        var Attendancereport = AppAPI.Attendancereport();
        var SubArea = AppAPI.Locktransaction();
        var CommitAttendance = AppAPI.CommitAttendance();
        Form.setObject(CommitAttendance);
        vm.saveProcess = false;

        vm.Form = Form;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.company     = $localStorage.empsite;
        vm.groupLogin  = $localStorage.group;
        vm.closeModal  = closeModal;
        vm.loadSubArea = loadSubArea;
        vm.reloadToken = reloadToken;

        vm.typeEmp = [
            {
                name: 'Staff',
                value: 'SAP'
            },
            {
                name: 'General Worker',
                value: 'HRIS'
            }
        ];
        vm.employeeType = 'SAP';

        loadDataBU();
        loadDataDivision(vm.company);
        getPeriode();
        loadSubArea();

        var date = new Date();
        vm.block = [];
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.getPeriode = getPeriode;
        vm.tgl = date.getDate();
        if (vm.tgl >= 20 && vm.tgl <= 31) {
            vm.bulan = vm.bulan + 1;
        }
        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }
        vm.divisi = 'all';
        vm.department = 'all';
        vm.listtahun = [2017, 2018, 2019, 2020, 2021];
        vm.listbulan = [
            { name: 'January', value: '01' },
            { name: 'February', value: '02' },
            { name: 'Maret', value: '03' },
            { name: 'April', value: '04' },
            { name: 'Mei', value: '05' },
            { name: 'June', value: '06' },
            { name: 'July', value: '07' },
            { name: 'August', value: '08' },
            { name: 'September', value: '09' },
            { name: 'October', value: '10' },
            { name: 'November', value: '11' },
            { name: 'Desember', value: '12' }
        ];

        vm.subArea = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.selectedSubarea = [];
        vm.listPeriode = [];
        vm.rangePeriode = '';

        //////////////////////////

        function closeModal() {
            $mdDialog.hide();
        }
        function getPeriode() {
            var res = Attendancereport.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan
            });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            getPeriodeList();
            vm.periode = data[0]['periode'];
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;

            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Attendancereport.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            vm.saveProcess = true;
            vm.Form.objForm.company = vm.company;
            vm.Form.objForm.divisi = vm.divisi;
            vm.Form.objForm.department = vm.department;
            vm.Form.objForm.tahun = vm.tahun;
            vm.Form.objForm.bulan = vm.bulan;
            vm.Form.objForm.subarea = [];
            vm.Form.objForm.empType = vm.employeeType;
            vm.selectedSubarea.forEach(function(val) {
                vm.Form.objForm.subarea.push(val.id);
            });
            vm.Form.objForm.rangePeriode = vm.rangePeriode;
            
            var promise = Form.saveData(
                'commitattendance',
                formController,
                CommitAttendance
            );
            promise.then(function(data) {
                showDialog(ev, data);
                angular.element.unblockUI();
                vm.saveProcess = false;
            });
            promise.catch(function(data) {
                ShowFailed(ev, data.data);
                angular.element.unblockUI();
                vm.saveProcess = false;
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Success Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Success Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    closeModal();
                });
        }

        function ShowFailed(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Save Data')
                        .textContent(data.pesan)
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    closeModal();
                });
        }

        function loadSubArea() {
            var response = CommitAttendance.query({
                action: 'getLocation',
                company: vm.company
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.block = [];
            vm.selectedSubarea = [];
            var itemsPerColumn = Math.ceil(data.length / 4);
            for (var i = 0; i < data.length; i += itemsPerColumn) {
                var col = {
                    start: i,
                    end: Math.min(i + itemsPerColumn, data.length)
                };
                vm.block.push(col);
            }
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return (
                vm.selectedSubarea.length !== 0 &&
                vm.selectedSubarea.length !== vm.subArea.length
            );
        }

        function isChecked() {
            return vm.selectedSubarea.length === vm.subArea.length;
        }

        function toggleAll() {
            if (vm.selectedSubarea.length === vm.subArea.length) {
                vm.selectedSubarea = [];
            } else if (
                vm.selectedSubarea.length === 0 ||
                vm.selectedSubarea.length > 0
            ) {
                vm.selectedSubarea = vm.subArea.slice(0);
            }
        }

        function getPeriodeList() {
            var response = SubArea.query({
                action: 'listPeriode'
            });
            response.$promise.then(function(success) {
                vm.listPeriode = success;
            });
            response.$promise.catch(function(success) {
                vm.listPeriode = [];
            });
        }

         function reloadToken(){
            Auth.setToken();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.commit-attendance')
        .controller('CommitAttendanceController', CommitAttendanceController);

    CommitAttendanceController.$inject = [
        '$state',
        '$mdDialog',
        'DataService',
        'AppAPI',
        'Auth',
        'GeneralService',
        '$localStorage'
    ];
    /** @ngInject */
    function CommitAttendanceController(
        $state,
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        GeneralService,
        $localStorage
    ) {
        var vm = this;
        vm.loadData = loadData;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var CommitAttendance = AppAPI.CommitAttendance();
        var Attendancereport = AppAPI.Attendancereport();
        var SubArea = AppAPI.Locktransaction();
        var nik = $localStorage.user;
        var date = new Date();
        vm.newCommit = newCommit;
        vm.deleteData = deleteData;
        vm.icon = 'icon-plus';
        vm.result = false;
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.getPeriode = getPeriode;
        vm.tgl = date.getDate();
        if (vm.tgl >= 20 && vm.tgl <= 31) {
            vm.bulan = vm.bulan + 1;
        }
        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }
        vm.listtahun = [2017, 2018, 2019,2020,2021];
        vm.listbulan = [
            { name: 'January', value: '01' },
            { name: 'February', value: '02' },
            { name: 'Maret', value: '03' },
            { name: 'April', value: '04' },
            { name: 'Mei', value: '05' },
            { name: 'June', value: '06' },
            { name: 'July', value: '07' },
            { name: 'August', value: '08' },
            { name: 'September', value: '09' },
            { name: 'October', value: '10' },
            { name: 'November', value: '11' },
            { name: 'Desember', value: '12' }
        ];
        vm.showFilter = true;
        vm.typeEmp = [
            {
                name: 'Staff',
                value: 'SAP'
            },
            {
                name: 'General Worker',
                value: 'HRIS'
            }
        ];
        vm.employeeType = 'SAP';
        vm.company = $localStorage.empsite;

        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.selectedItems = [];

        vm.flagTranslate = flagTranslate;

        // loadData(1);
        loadDataBU();
        getPeriodeList();

        //////////

        function loadData(pageno) {
            vm.DataTable.loadData(CommitAttendance, pageno, {
                action: 'viewdata',
                company: vm.company,
                year: vm.tahun,
                month: vm.bulan,
                rangePeriode: vm.rangePeriode,
                empType: vm.employeeType
            });
        }

        function newCommit(ev) {
            // $mdDialog.show({
            //     controller: 'newCommitAttendncController',
            //     controllerAs: 'vm',
            //     templateUrl:
            //         'app/main/cb/commit-attendance/new-commit-attendance.html',
            //     parent: angular.element(document.body),
            //     targetEvent: ev,
            //     clickOutsideToClose: true,
            //     fullscreen: true,
            //     onRemoving: function(element, removePromise) {
            //         loadData();
            //     },
            //     locals: {}
            // });
            $state.go('app.cb_new_commit_attendance');
        }

        function deleteData(ev) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this list?')
                    .textContent(
                        'All data your selected will be deleted and can not recovered.'
                    )
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(
                    function() {
                        var payload = [];

                        vm.selectedItems.map(function(val) {
                            payload.push({
                                id: val.id,
                                sub_area_id: val.sub_area_id,
                                end_date: val.end_date, 
                                flag_app: val.flag_app
                            });
                        });

                        angular.element.blockUI();

                        var response = CommitAttendance.save({
                            action: 'delete',
                            data: payload,
                            flag_app: vm.employeeType
                        });

                        response.$promise.then(showDialog);
                        response.$promise.catch(ShowFailed);
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialog(ev, data) {
            angular.element.unblockUI();
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Success Delete Data')
                        .textContent('Success Delete Data')
                        .ariaLabel('Success Delete Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    vm.selectedItems = [];
                    loadData(1);
                });
        }

        function ShowFailed(ev, data) {
            angular.element.unblockUI();
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title('Failed Delete Data')
                        .textContent('Failed Delete Data')
                        .ariaLabel('Failed Delete Data')
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    vm.selectedItems = [];
                    loadData(1);
                });
        }

        function loadDataBU() {
            var response = Attendancereport.query({ action: 'viewBu' });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function getPeriode() {
            var res = Attendancereport.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan
            });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            getPeriodeList();
            vm.periode = data[0]['periode'];
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }

        function getPeriodeList() {
            var response = SubArea.query({
                action: 'listPeriode'
            });
            response.$promise.then(function(success) {
                vm.listPeriode = success;
            });
            response.$promise.catch(function(success) {
                vm.listPeriode = [];
            });
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return (
                vm.selectedItems.length !== 0 &&
                vm.selectedItems.length !== vm.DataTable.list.length
            );
        }

        function isChecked() {
            return vm.selectedItems.length === vm.DataTable.list.length;
        }

        function toggleAll() {
            if (vm.selectedItems.length === vm.DataTable.list.length) {
                vm.selectedItems = [];
            } else if (
                vm.selectedItems.length === 0 ||
                vm.selectedItems.length > 0
            ) {
                vm.selectedItems = vm.DataTable.list.slice(0);
            }
        }

        function flagTranslate(flag) {
            return flag == 'HRIS' ? 'General Worker' : 'Staff';
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.checklist-attendance-gw-admin', [])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
        // State
        $stateProvider
            .state('app.cb_checklist_attendance_gw_admin', {
                url    : '/cb/checklist-attendance-gw-hr',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/checklist-attendance-gw-admin/checklist-attendance-gw-admin.html',
                        controller : 'ChecklistAttendanceAdminController as vm'
                    }
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("app.cb.checklist-attendance-gw-admin")
        .controller(
            "ChecklistAttendanceAdminController",
            ChecklistAttendanceAdminController
        );

    ChecklistAttendanceAdminController.$inject = [
        "$state",
        "$mdDialog",
        "DataService",
        "AppAPI",
        "Auth",
        "GeneralService",
        "$localStorage",
        "$window",
        "$location",
        "$http",
        "config",
        "$document"
    ];
    /** @ngInject */
    function ChecklistAttendanceAdminController(
        $state,
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        GeneralService,
        $localStorage,
        $window,
        $location,
        $http,
        config,
        $document
    ) {
        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var ChecklistAttendanceGw = AppAPI.ChecklistAttendanceGwAdmin();
        var ChecklistAttendanceGwNonAdmin = AppAPI.ChecklistAttendanceGw();
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listSelected = [];
        vm.listGedung = [];
        vm.getListGedung = getListGedung;
        vm.getShiftLocation = getShiftLocation;
        vm.getSector = getSector;
        vm.getline = getLine;
        vm.recordFilterData = recordFilterData;
        vm.working_date = new Date(moment().format('YYYY/MM/DD'));

        getShiftLocation();
        getListShiftGroup();
        getListGedung();
        getFilterData();


        function loadData(pageno) {
            angular.element.blockUI(pageno);
            var response = vm.DataTable.loadData(
                ChecklistAttendanceGwNonAdmin,
                pageno, {
                    action: "viewdata",
                    search: vm.searchParam,
                    gedung: vm.gedung,
                    sector: vm.sector,
                    working_date: vm.working_date,
                    shift: vm.shift,
                    shiftGroup: vm.shiftGroup,
                    line: vm.line
                }
            );
        }

        function getFilterData() {
            vm.filterData = $localStorage.checklistAttGw_filter;
            if (typeof (vm.filterData) != 'undefined') {
                if (typeof (vm.filterData.working_date) != 'undefined') {
                    vm.working_date = new Date(vm.filterData.working_date);
                }
            }
        }

        function recordFilterData() {
            var filterData = {
                working_date: vm.working_date,
                gedung: vm.gedung,
                sector: vm.sector,
                shift: vm.shift,
                shiftGroup: vm.shiftGroup,
                line: vm.line
            }
            getLine(vm.gedung, vm.sector);
            $localStorage.checklistAttGw_filter = filterData;
        }

        function isChecked(ls) {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if (idx > -1) {
                vm.listSelected.splice(idx, 1);
            } else {
                vm.listSelected.push(ls);
            }
        }

        function showDialogMessage(ev, title, textContent, ok) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(textContent)
                    .ok(ok)
                    .targetEvent(ev)
                )
                .then(function () {
                    loadData(1);
                });
        }

        function showDialog(ev) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title("Success Approve Data")
                    .textContent("Process Data was Success.")
                    .ariaLabel("Success Approve Data")
                    .ok("OK")
                    .targetEvent(ev)
                )
                .then(function () {
                    loadData(1);
                    angular.element.unblockUI();
                });
        }

        function ShowFailed(ev) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title("Failed Check Data")
                    .textContent("Please Recheck Your Data.")
                    .ariaLabel("Failed Check Data")
                    .ok("OK")
                    .targetEvent(ev)
                )
                .then(function () {
                    loadData(1);
                    angular.element.unblockUI();
                });
        }

        function getListGedung() {
            var response = ChecklistAttendanceGw.query({
                action: "getSelectListGedung"
            });
            response.$promise.then(fetchGedung);
            response.$promise.catch(errorFetchGedung);
        }

        function fetchGedung(data) {
            vm.listGedung = data;
        }

        function errorFetchGedung() {
            vm.listGedung = [];
        }

        function getShiftLocation() {
            var response = ChecklistAttendanceGw.query({
                action: "getShiftBylocation"
            });
            response.$promise.then(fetchShift);
            response.$promise.catch(errorFetchShift);
        }

        function fetchShift(data) {
            vm.listShift = data;
        }

        function errorFetchShift() {
            vm.listShift = [];
        }

        function getListShiftGroup() {
            var response = ChecklistAttendanceGw.query({
                action: "getShiftGroup"
            });
            response.$promise.then(fetchShiftGroup);
            response.$promise.catch(errorFetchShiftGroup);
        }

        function fetchShiftGroup(data) {
            vm.listShiftGroup = data;
        }

        function errorFetchShiftGroup() {
            vm.listShiftGroup = [];
        }

        function getSector(objGedung) {
            var obj = JSON.parse(objGedung);
            vm.gedung = obj.gedung_id;
            var response = ChecklistAttendanceGw.query({
                action: "getSelectListSector",
                id: vm.gedung
            });
            response.$promise.then(fetchSector);
            response.$promise.catch(errorFetchSector);
            vm.recordFilterData();
        }

        function fetchSector(data) {
            vm.listSector = data;
        }

        function errorFetchSector() {
            vm.listSector = [];
        }

        function getLine(gedungId, id) {
            var response = ChecklistAttendanceGw.query({
                action: "getLines",
                gedung_id: gedungId,
                id: id
            });
            response.$promise.then(fetchLine);
            response.$promise.catch(errorFetchLine);
        }

        function fetchLine(data) {
            vm.listLines = data;
        }

        function errorFetchLine() {
            vm.listLines = [];
        }
    }
})();

(function () {
    "use strict"
    angular
        .module("app.cb.checklist-attendance-gw")
        .controller(
            "ViewcommentController",
            ViewcommentController
        );

    ViewcommentController.$inject = [
        "$mdDialog",
        "AppAPI",
        "data"
    ];

    function ViewcommentController(
        $mdDialog,
        AppAPI,
        data
    ) {

        var vm = this;
        var endpoint = AppAPI.ChecklistAttendanceGw();
        vm.data = data;
        vm.closeModal = closeModal;

        loadData();

        function closeModal() {
            $mdDialog.hide();
        }

        function loadData() {
            vm.listData = [];
            var response = endpoint.query({
                action: "checkcomment",
                data: data,
            });
            response.$promise.then(function (res) {
                vm.listData = res;
            });
            response.$promise.catch(function (err) {
                vm.listData = [];
                console.log('err', err);
            });
        }

    }
})();

(function () {
    "use strict";

    angular
        .module("app.cb.checklist-attendance-gw")
        .controller(
            "ChecklistAttendanceController",
            ChecklistAttendanceController
        );

    ChecklistAttendanceController.$inject = [
        "$state",
        "$mdDialog",
        "DataService",
        "AppAPI",
        "Auth",
        "GeneralService",
        "$localStorage",
        "$window",
        "$location",
        "$http",
        "config",
        "$document"
    ];
    /** @ngInject */
    function ChecklistAttendanceController(
        $state,
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        GeneralService,
        $localStorage,
        $window,
        $location,
        $http,
        config,
        $document
    ) {
        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var ChecklistAttendanceGw = AppAPI.ChecklistAttendanceGw();
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listSelected = [];
        vm.Checklist = Checklist;
        vm.uploadData = uploadData;
        vm.listGedung = [];
        vm.getListGedung = getListGedung;
        vm.getShiftLocation = getShiftLocation;
        vm.getSector = getSector;
        vm.getline = getLine;
        //vm.gedung = "";
        //vm.objGedung = "";
        vm.deleteData = deleteData;
        vm.recordFilterData = recordFilterData;
        vm.inputComment = inputComment;
        vm.viewComment = viewComment;
        vm.working_date = new Date(moment().format('YYYY/MM/DD'));
        vm.replaceShift = replaceShift;
        getShiftLocation();
        getListShiftGroup();
        getListGedung();
        getFilterData();


        function loadData(pageno) {
            angular.element.blockUI(pageno);
            var response = vm.DataTable.loadData(
                ChecklistAttendanceGw,
                pageno, {
                    action: "viewdata",
                    search: vm.searchParam,
                    gedung: vm.gedung,
                    sector: vm.sector,
                    working_date: vm.working_date,
                    shift: vm.shift,
                    shiftGroup: vm.shiftGroup,
                    line: vm.line
                }
            );
        }

        function getFilterData() {
            vm.filterData = $localStorage.checklistAttGw_filter;
            if (typeof (vm.filterData) != 'undefined') {
                if (typeof (vm.filterData.working_date) != 'undefined') {
                    vm.working_date = new Date(vm.filterData.working_date);
                }
            }
        }

        function recordFilterData() {
            //console.log('vm.gedung', vm.gedung);
            // var objGedung = '';
            // if (vm.objGedung == {}.constructor) {
            //     objGedung = JSON.parse(vm.objGedung);
            // }
            // console.log('objGedung', objGedung);
            var filterData = {
                working_date: vm.working_date,
                gedung: vm.gedung,
                sector: vm.sector,
                shift: vm.shift,
                shiftGroup: vm.shiftGroup,
                line: vm.line
            }
            getLine(vm.gedung, vm.sector);
            $localStorage.checklistAttGw_filter = filterData;
        }

        function isChecked(ls) {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if (idx > -1) {
                vm.listSelected.splice(idx, 1);
            } else {
                vm.listSelected.push(ls);
            }
        }

        function deleteData(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title("Would you like to delete this selected list?")
                    .textContent(
                        "All data your selected will be deleted and can not recovered."
                    )
                    .ariaLabel("Delete Dialog")
                    .targetEvent(ev)
                    .ok("YES")
                    .cancel("no");

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = ChecklistAttendanceGw.save({
                            action: "delete",
                            datas: vm.listSelected
                        });
                        response.$promise.then(function () {
                            showDialogMessage(
                                ev,
                                "Success Delete Data",
                                "Successfully, selected data has been deleted.",
                                "OK"
                            );
                            angular.element.unblockUI();
                        });

                        response.$promise.catch(function (rdata) {
                            showDialogMessage(
                                ev,
                                "Failed Delete Data",
                                "Please check your internet connection, or contact administrator.",
                                "OK"
                            );
                            angular.element.unblockUI();
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialogMessage(ev, title, textContent, ok) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(textContent)
                    .ok(ok)
                    .targetEvent(ev)
                )
                .then(function () {
                    loadData(1);
                });
        }

        function Checklist(ev) {
            var jum = vm.listSelected.length,
                i,
                ids = [];

            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog
                        .confirm()
                        .title("Would you like to Check this list?")
                        .textContent("All data your selected will be check.")
                        .ariaLabel("delete dialog")
                        .targetEvent(ev)
                        .ok("YES")
                        .cancel("no");
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(
                        function () {
                            var checkAttendance = new ChecklistAttendanceGw();
                            checkAttendance.data = [];
                            checkAttendance.action = "checklist";

                            for (i = 0; i < jum; i++) {
                                checkAttendance.data.push({
                                    listData: vm.listSelected[i]
                                });
                            }
                            var response = checkAttendance.$save();
                            response.then(function () {
                                showDialog(ev);
                                vm.listSelected.length = 0;
                            });
                            response.catch(function () {
                                ShowFailed(ev);
                            });
                        },
                        function () {
                            //
                        }
                    );
                });
            } else {
                $mdDialog
                    .show(
                        $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title("Attention!")
                        .textContent("No data selected")
                        .ariaLabel("Attention")
                        .ok("close")
                        .targetEvent(ev)
                    )
                    .then(function () {
                        loadData();
                    });
            }
        }

        function showDialog(ev) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title("Success Approve Data")
                    .textContent("Process Data was Success.")
                    .ariaLabel("Success Approve Data")
                    .ok("OK")
                    .targetEvent(ev)
                )
                .then(function () {
                    loadData(1);
                    angular.element.unblockUI();
                });
        }

        function ShowFailed(ev) {
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector("#contentDialog")
                        )
                    )
                    .clickOutsideToClose(true)
                    .title("Failed Check Data")
                    .textContent("Please Recheck Your Data.")
                    .ariaLabel("Failed Check Data")
                    .ok("OK")
                    .targetEvent(ev)
                )
                .then(function () {
                    loadData(1);
                    angular.element.unblockUI();
                });
        }

        function uploadData(ev) {
            $mdDialog.show({
                controller: "UploadfileChecklistAttendanceController as vm",
                templateUrl: "app/main/cb/checklist-attendance-gw/uploadfile/uploadfile.html",
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function getListGedung() {
            var response = ChecklistAttendanceGw.query({
                action: "getSelectListGedung"
            });
            response.$promise.then(fetchGedung);
            response.$promise.catch(errorFetchGedung);
        }

        function fetchGedung(data) {
            vm.listGedung = data;
        }

        function errorFetchGedung() {
            vm.listGedung = [];
        }

        function getShiftLocation() {
            var response = ChecklistAttendanceGw.query({
                action: "getShiftBylocation"
            });
            response.$promise.then(fetchShift);
            response.$promise.catch(errorFetchShift);
        }

        function fetchShift(data) {
            vm.listShift = data;
        }

        function errorFetchShift() {
            vm.listShift = [];
        }

        function getListShiftGroup() {
            var response = ChecklistAttendanceGw.query({
                action: "getShiftGroup"
            });
            response.$promise.then(fetchShiftGroup);
            response.$promise.catch(errorFetchShiftGroup);
        }

        function fetchShiftGroup(data) {
            vm.listShiftGroup = data;
        }

        function errorFetchShiftGroup() {
            vm.listShiftGroup = [];
        }

        function getSector(objGedung) {
            var obj = JSON.parse(objGedung);
            vm.gedung = obj.gedung_id;
            var response = ChecklistAttendanceGw.query({
                action: "getSelectListSector",
                id: vm.gedung
            });
            response.$promise.then(fetchSector);
            response.$promise.catch(errorFetchSector);
            vm.recordFilterData();
        }

        function fetchSector(data) {
            vm.listSector = data;
        }

        function errorFetchSector() {
            vm.listSector = [];
        }

        function getLine(gedungId, id) {
            var response = ChecklistAttendanceGw.query({
                action: "getLines",
                gedung_id: gedungId,
                id: id
            });
            response.$promise.then(fetchLine);
            response.$promise.catch(errorFetchLine);
        }

        function fetchLine(data) {
            vm.listLines = data;
        }

        function errorFetchLine() {
            vm.listLines = [];
        }

        function inputComment(ev, data) {
            $mdDialog.show({
                controller: "UpdatechecklistController as vm",
                templateUrl: "app/main/cb/checklist-attendance-gw/input-checklist/update-checklist.html",
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
        }

        function viewComment(ev, data) {
            $mdDialog.show({
                controller: "ViewcommentController as vm",
                templateUrl: "app/main/cb/checklist-attendance-gw/view-comment.html",
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
        }

        function replaceShift(data, ev) {
            $mdDialog.show({
                controller: "ChangeshiftController as vm",
                templateUrl: "app/main/cb/checklist-attendance-gw/input-checklist/change-shift.html",
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
            // var confirm = $mdDialog
            //     .prompt()
            //     .title("Would you like to Replace Shift this list?")
            //     .textContent("All data your selected will be Replace.")
            //     .placeholder("Comment")
            //     .ariaLabel("Comment")
            //     .initialValue("Replace Shift")
            //     .targetEvent(ev)
            //     .parent(angular.element(document.body))
            //     .ok("YES")
            //     .cancel("no");
            // $mdDialog.show(confirm).then(
            //     function (comment) {
            //         changeShit(comment, data);
            //     },
            //     function () {
            //         $scope.status = "You didn't name your dog.";
            //     }
            // );
        }

        function changeShit(comment, data, ev) {
            console.log(comment, data);
            var checkAttendance = new ChecklistAttendanceGw();
            checkAttendance.comment = comment;
            checkAttendance.data = data;
            checkAttendance.action = "changeShift";
            var response = checkAttendance.$save();
            response.then(function () {
                showDialog(ev);
            });
            response.catch(function () {
                ShowFailed(ev);
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.changeshift', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_changeshift', {
                url    : '/cb/changeshift',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/changeshift/changeshift.html',
                        controller : 'ChangeshiftOriController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.changeshift')
        .controller('ViewChangShiftRejectCommentController', ViewChangShiftRejectCommentController);

    ViewChangShiftRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function ViewChangShiftRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.changeshift')
        .controller('ChangeshiftOriController', ChangeshiftOriController);


    ChangeshiftOriController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage'];
    /** @ngInject */
    function ChangeshiftOriController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage) {

        var vm = this;
        vm.loadData = loadData
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Changeshift = AppAPI.Changeshift();
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected = [];
        vm.approveChangeshift = approveChangeshift;
        vm.deleteChangeshift = deleteChangeshift;
        vm.viewComment = viewComment;
        vm.appstatus = [{
            name: 'Waiting Approval',
            value: '1'
        }, {
            name: 'Approved',
            value: '2'
        }, {
            name: 'Rejected',
            value: '4'
        }];
        vm.status = '1';


        //////////
        loadData(1);

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(Changeshift, pageno, {
                action: 'viewdata',
                status: vm.status,
                start_date: vm.start_date,
                end_date: vm.end_date
            });
            vm.listOtselected = [];
        }



        function isChecked(ls) {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if (idx > -1) {
                vm.listOtselected.splice(idx, 1);
            } else {
                vm.listOtselected.push(ls);
            }
        }

        function approveChangeshift(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to Approve this list?')
                    .textContent('All data your selected will be approve.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });
                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    // console.log(vm.listOtselected);
                    var ot = new Changeshiftapproval();
                    ot.data = [];
                    ot.action = 'approve';
                    ot.nik = nik;
                    var jum = vm.listOtselected.length,
                        i, ids = [];
                    for (i = 0; i < jum; i++) {
                        ot.data.push({
                            id: vm.listOtselected[i].id,
                            idshift: vm.listOtselected[i].idshift,
                            nik: vm.listOtselected[i].nik,
                            tgl: vm.listOtselected[i].tgl
                        });
                    }
                    var idtx = encodeURIComponent(angular.toJson(ids));
                    var response = ot.$save();
                    //var response=tm.$delete({action:'approve'});
                    response.then(loadData);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });

        }

        function deleteChangeshift(ev, id) {

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to delete this data?')
                    .textContent('All data your selected will be deleted and can not recovered.')
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');

                $mdDialog.show(confirm).then(function () {
                    angular.element.unblockUI();
                    var response = Changeshift.delete({
                        action: 'delete',
                        data: id
                    });

                    response.$promise.then(loadData);
                }, function () {

                });
            });


        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'ViewChangShiftRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/abnormal-approval/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listOtselected = [];
                },
                locals: {
                    id: id
                }
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.changeshift-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_changeshift_approval', {
                url    : '/cb/changeshift-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/changeshift-approval/changeshift-approval.html',
                        controller : 'ChangeshiftApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.changeshift-approval')
        .controller('changeShiftViewRejectCommentController', changeShiftViewRejectCommentController);

    changeShiftViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function changeShiftViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.changeshift-approval')
        .controller('ChangeshiftRejectCommentController', ChangeshiftRejectCommentController);

    ChangeshiftRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function ChangeshiftRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;
        var translate = $filter('translate');
        // initial form
        Form.initialForm();

        var Attendanceemploye = AppAPI.Changeshiftapproval();

        // set constructor form
        Form.setObject(Attendanceemploye);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        // console.log(id);
        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }
        function saveData(ev, formController) {

            var promise = Form.saveData('reject', formController, Attendanceemploye);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.changeshift-approval')
    .controller('ChangeshiftApprovalController', ChangeshiftApprovalController);


  ChangeshiftApprovalController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function ChangeshiftApprovalController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {

    var vm = this;
    var translate = $filter('translate');
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Changeshiftapproval = AppAPI.Changeshiftapproval();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveChangeshift = approveChangeshift;
    vm.Reject = Reject;
    vm.UnReject = UnReject;
    vm.UnApproved = UnApproved;
    var date = new Date();
    vm.tahun = date.getFullYear();
    vm.bulan = date.getMonth() + 1;
    vm.getPeriode = getPeriode;
    vm.tgl = date.getDate();
    vm.viewComment = viewComment;
    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.changeChecked = changeChecked;

    if (vm.tgl >= 25 && vm.tgl <= 31) {
      if (vm.bulan == 12) {
        vm.bulan = '01';
      } else {
        vm.bulan = vm.bulan + 1;
      }
    }
    if (vm.bulan < 10) {
      vm.bulan = '0' + vm.bulan;
    }

    vm.listtahun = [2017, 2018, 2019, 2020, 2021];
    vm.listbulan = [{ name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'Maret', value: '03' },
    { name: 'April', value: '04' },
    { name: 'Mei', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'Desember', value: '12' }];

    getPeriode();
    // loadData(1); 
    //////////


    function getPeriode() {
      var res = Attendanceemploye.query({ action: 'getPeriode', tahun: vm.tahun, bulan: vm.bulan });
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data) {
      vm.periode = data[0]['periode'];
      vm.tglmulai = new Date(data[0]['datePeriode']['start'] * 1000);
      vm.tglakhir = new Date(data[0]['datePeriode']['end'] * 1000);
      loadData(1); 
    }

    function errorfetchPeriode(data) {
      console.log('error');
    }

    function loadData(pageno) {
      var resp = vm.DataTable.loadData(Changeshiftapproval, pageno, { action: 'viewdata', nik: nik, tglmulai: vm.tglmulai, tglakhir: vm.tglakhir, type: vm.type });
      vm.listOtselected = [];
      vm.changeChecked();
    }


    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.DataTable.list);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveChangeshift(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            // console.log(vm.listOtselected);
            var ot = new Changeshiftapproval();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push({
                id: vm.listOtselected[i].id,
                idshift: vm.listOtselected[i].idshift,
                nik: vm.listOtselected[i].nik,
                iStartShift: vm.listOtselected[i].iStartShift,
                iEndShift: vm.listOtselected[i].iEndShift,
                tgl: vm.listOtselected[i].tgl,
                level: vm.listOtselected[i].level,
                lastApproval: vm.listOtselected[i].is_last_approval,
                days_limit_approval: vm.listOtselected[i].days_limit_approval,
                approvalId: vm.listOtselected[i].approvalId
              });
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              // console.log(data.pesan);
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
            response.catch(function (data) {
              // console.log(data.data);
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
            // angular.element.unblockUI();
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData(1);
        angular.element.unblockUI();
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        // loadData();
        angular.element.unblockUI();
      });
    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var data = [];
        for (i = 0; i < jum; i++) {
          data.push({
            id: vm.listOtselected[i].id,
            idshift: vm.listOtselected[i].idshift,
            nik: vm.listOtselected[i].nik,
            tgl: vm.listOtselected[i].tgl,
            level: vm.listOtselected[i].level,
            lastApproval: vm.listOtselected[i].is_last_approval,
            approvalId: vm.listOtselected[i].approvalId
          });
        }

        $mdDialog.show({
          controller: 'ChangeshiftRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/changeshift-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
          },
          locals: {
            id: data
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function UnReject(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNREJ');
      var note = translate('KPI.MESSAGE.UNREJNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Changeshiftapproval.delete({ action: 'unreject', data: angular.toJson(id) });
          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
          response.$promise.catch(function () {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function UnApproved(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNAPP');
      var note = translate('KPI.MESSAGE.UNAPPNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Changeshiftapproval.delete({ action: 'unapproved', data: angular.toJson(id) });
          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'changeShiftViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/abnormal-approval/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          vm.listOtselected = [];
        },
        locals: {
          id: id
        }
      });
    }

    function succesUnapproved(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnapproved();
      } else {
        showDialog();
      }
      loadData();
    }

    function succesUnreject(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnreject();
      } else {
        showDialogUnreject();
      }
      loadData();
    }

    function failedUnapproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.data)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }

    function showFailedUnapproved() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unapproved Data')
          .textContent('Transaction time expired.')
          .ariaLabel('Transaction time expired')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showFailedUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unreject Data')
          .textContent('Transaction time expired.')
          .ariaLabel('Transaction time expired')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialog() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialogUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Process Data')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function changeChecked() {
      vm.selectAll =  typeof vm.DataTable.list != 'undefined' && vm.listOtselected.length == vm.DataTable.list.length;
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.business-trip', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_business_trip', {
                url    : '/cb/business-trip',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/business-trip/business-trip.html',
                        controller : 'BusinesstripController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.business-trip')
        .controller('InputBusinesstripController', InputBusinesstripController);

    InputBusinesstripController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function InputBusinesstripController($localStorage, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;
        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Businesstrip = AppAPI.Businesstrip();

        // set constructor form
        Form.setObject(Businesstrip);

        // set form to controller
        vm.Form = Form;


        vm.closeModal = closeModal;
        vm.Form.objForm.start_time = '00:00:00';
        vm.Form.objForm.end_time = '00:00:00';
        vm.closeModal = closeModal;


        ////////////////  
        var response = Businesstrip.query({ action: 'getAbsenceType' });
        response.$promise.then(function (data) {
            vm.listAbsenceType = data;
        });

        response.$promise.catch(function (data) {
            $log.info(data);
        });

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            // var dt=new Date(formController.start_date.$viewValue);
            // var et=new Date(formController.end_date.$viewValue); 
            // var newdate=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
            // var newdate1=dt.getFullYear()+'-'+(et.getMonth()+1)+'-'+et.getDate();
            // vm.Form.objForm.start_date=newdate;
            // vm.Form.objForm.end_date=newdate1; 
            vm.Form.objForm.start_date = new Date(formController.start_date.$viewValue);
            vm.Form.objForm.end_date = new Date(formController.end_date.$viewValue);
            var promise = Form.saveData('save', formController, Businesstrip);
            promise.then(function (data) {
                showDialogInfo(ev, data);

            });
            promise.catch(function (data) {
                showDialogInfo(ev, data)

            });
        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }


        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.business-trip')
        .controller('EditBusinesstripController', EditBusinesstripController);

    EditBusinesstripController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function EditBusinesstripController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');
        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Businesstrip = AppAPI.Businesstrip();

        // set constructor form
        Form.setObject(Businesstrip);

        // set form to controller
        vm.Form = Form;

        // console.log(id.listFingerLength);

        vm.closeModal = closeModal;
        vm.Form.objForm.start_time = '00:00:00';
        vm.Form.objForm.end_time = '00:00:00';
        vm.closeModal = closeModal;

        ////////////////  
        var res = vm.Form.objForm.$get({ action: 'viewdetail', id: id });
        res.then(changeDate);

        function changeDate(data) {
            vm.Form.objForm.start_date = new Date(data.start_date);
            vm.Form.objForm.end_date = new Date(data.end_date);
            vm.Form.objForm.abs_code = data.absence_type;

        }

        var response = Businesstrip.query({ action: 'getAbsenceType' });
        response.$promise.then(function (data) {
            vm.listAbsenceType = data;
            // console.log(vm.listParent);
        });

        response.$promise.catch(function (data) {
            $log.info(data);
        });

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {

            var promise = Form.saveData('update', formController, Businesstrip);
            promise.then(function (data) {
                showDialogInfo(ev, data);

            });
            promise.catch(function (data) {
                showDialogInfo(ev, data)

            });


        }

        function showDialog(ev, data) {
            // console.log(ev);
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }


        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
            // console.log(data.data.pesan);
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.business-trip')
        .controller('BusinesstripController', BusinesstripController);


    BusinesstripController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
    /** @ngInject */
    function BusinesstripController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {
        var vm = this;
        var translate = $filter('translate');

        // vm.editData=editData;
        vm.deleteData = deleteData;
        vm.loadData = loadData
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Businesstrip = AppAPI.Businesstrip();
        var nik = $localStorage.user;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listselected = [];
        vm.InputBusinesstrip = InputBusinesstrip;
        vm.editData = editData;
        vm.appstatus = [{ name: 'Waiting Approval', value: '0' }, { name: 'Approved', value: '1' }, { name: 'Rejected', value: '2' }];
        vm.status = '0';

        loadData(1);

        //////////

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(Businesstrip, pageno, { action: 'viewdata', nik: nik, abs_code: vm.abs_code, status: vm.status, start_date: vm.start_date, end_date: vm.end_date });
            vm.listselected = [];
            resp.then(function () {
                vm.abs_code = '';
            });
        }

        function isChecked(ls) {
            return vm.listselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listselected.indexOf(ls);

            if (idx > -1) {
                vm.listselected.splice(idx, 1);
            }
            else {
                vm.listselected.push(ls);
            }
        }

        function InputBusinesstrip(ev) {
            $mdDialog.show({
                controller: 'InputBusinesstripController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/business-trip/input-business-trip.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                }
            });
        }

        function editData(ev, id) {
            $mdDialog.show({
                controller: 'EditBusinesstripController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/business-trip/input-business-trip.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }

        function deleteData(ev) {
            var confirmdel = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(confirmdel)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Businesstrip.delete({ action: 'delete', data: angular.toJson(vm.listselected) });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        if (data.status == 1) {
                            showDialogInfo(ev, data);
                        } else {
                            showDialogInfo(ev, data);
                        }
                    });
                    response.catch(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data.data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.attendance-team', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.cb_attendance_team', {
                url    : '/cb/attendance-team',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/attendance-team/attendance-team.html',
                        controller : 'AttendanceteamController as vm'
                    }
                }
            });

   

    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.attendance-team')
        .controller('AttendanceteamController', AttendanceteamController);


    AttendanceteamController.$inject = ['$state', '$localStorage', '$document', '$http', '$scope', 'config', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', 'FileUploader'];
    /** @ngInject */
    function AttendanceteamController($state, $localStorage, $document, $http, $scope, config, $log, $mdDialog, AppAPI, Auth, DataService, FileUploader) {

        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Attendanceteam = AppAPI.Attendanceteam();
        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.tgl = date.getDate();
        vm.fingerLog = fingerLog;
        vm.OtInfo = OtInfo;
        vm.infoTransaction = infoTransaction;
        vm.ChangeNik = ChangeNik;

        if (vm.tgl >= 25 && vm.tgl <= 31) {
            if (vm.bulan == 12) {
                vm.bulan = 1;
                vm.tahun += 1;
            } else {
                vm.bulan = vm.bulan + 1;
            }
        }

        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }

        vm.listtahun = [2017, 2018, 2019, 2020, 2021, 2022];
        vm.listbulan = [{
                name: 'January',
                value: '01'
            },
            {
                name: 'February',
                value: '02'
            },
            {
                name: 'Maret',
                value: '03'
            },
            {
                name: 'April',
                value: '04'
            },
            {
                name: 'Mei',
                value: '05'
            },
            {
                name: 'June',
                value: '06'
            },
            {
                name: 'July',
                value: '07'
            },
            {
                name: 'August',
                value: '08'
            },
            {
                name: 'September',
                value: '09'
            },
            {
                name: 'October',
                value: '10'
            },
            {
                name: 'November',
                value: '11'
            },
            {
                name: 'Desember',
                value: '12'
            }
        ];

        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [{
            link: '#',
            name: 'C&B / ',
            active: '0'
        }];


        // console.log(vm.nik);


        ////////// 

        function ChangeNik() {
            loadData(1);
        }

        function loadData(pageno) {
            angular.element.blockUI();
            var tahun = vm.tahun;
            var bulan = vm.bulan;
            var resp = Attendanceteam.query({
                action: 'viewdata',
                tahun: tahun,
                bulan: bulan,
                nik: vm.nik
            });
            resp.$promise.then(fetchDataAttendance);
            resp.$promise.catch(errFetchDataAttendance);
        }

        function errFetchDataAttendance(data) {
            vm.listAttendance = [];
            angular.element.unblockUI();
        }

        function fetchDataAttendance(data) {
            vm.listAttendance = data;
            angular.element.unblockUI();
        }

        var response = Attendanceteam.query({
            action: 'getListteam'
        });
        response.$promise.then(function (data) {
            vm.listteam = data;
            // console.log(vm.listParent);
        });

        response.$promise.catch(function (data) {
            $log.info(data);
        });


        function fingerLog(ev, id, nik) {
            var nik1 = nik.substr(1, 8);
            $mdDialog.show({
                controller: 'FingerLogAttController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance/finger-log.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id,
                    nik: nik1
                }
            });
        }

        function OtInfo(ev, ls) {
            $mdDialog.show({
                controller: 'OvertimeInfoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance-employe/ot-info.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {

                },
                locals: {
                    id: ls
                }
            });
        }

        function infoTransaction(ev, id, nik) {
            var nik1 = nik.substr(1, 8);
            // console.log(nik1);
            $mdDialog.show({
                controller: 'infoTransactionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance/info-transaction.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id,
                    nik: nik1
                }
            });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.attendancelist', [
        ])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.cb_attendancelist', {
                url    : '/cb/attendancelist',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/attendancelist/attendancelist.html',
                        controller : 'AttendancelistController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.attendancelist')
        .controller('AttendancelistController', AttendancelistController);


    AttendancelistController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function AttendancelistController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.editData=editData; 
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listModulSelected=[];
        vm.IMportFile=IMportFile;
        vm.Reloadatt=Reloadatt;
        vm.EmpKeyUp=EmpKeyUp;
        var Group=AppAPI.Group();
        var Module=AppAPI.Module();
         vm.loadDataDivision=loadDataDivision;
         vm.loadDataDepartment=loadDataDepartment; 
        var Attendance=AppAPI.Attendance();
        var Department=AppAPI.Department();
        var Division=AppAPI.Division();
        var BU=AppAPI.BU();
        loadDataBU();

        vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[ 
                    {link:'#',name:'C&B / ',active:'0'}
                    ]; 
        vm.listperiode=[{name:"January to February",value:1},
                        {name:"February to March",value:2},
                        {name:"March to April",value:3},
                        {name:"April to May",value:4},
                        {name:"May to June",value:5},
                        {name:"June to July",value:6},
                        {name:"July to August",value:7},
                        {name:"August to September",value:8},
                        {name:"September to October",value:9},
                        {name:"October to November", value:10},
                        {name:"November to December",value:11},
                        {name:"December to January",value:12}
                      ];
        vm.listyears=[{name:"2016",value:"2016"},{name:"2017",value:"2017"}];
        vm.simulateQuery = false;
        vm.isDisabled    = false; 
        vm.querySearch   = querySearch;
        vm.selectedItemChanged = selectedItemChanged;
        // vm.searchTextChange   = searchTextChange;

        vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;


        // var response= Group.query({action:'listGroupSelect'});
        //     response.$promise.then(function(data){
        //      vm.listGroupSelect=data;
        //      // console.log(vm.listGroupSelect);
        //   });

        //   response.$promise.catch(function(data){
        //     $log.info(data);
        //   });

          function loadDataDepartment(iddivisi) {
             var response=Attendance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }
          // var dep= Department.query({action:'viewdata'});
          //   dep.$promise.then(function(data){
          //   vm.listDepartment=data;
          //    // console.log(vm.listGroupSelect);
          // });

          // dep.$promise.catch(function(data){
          //   $log.info(data);
          // });

          function loadDataDivision(idbu) {
             var response=Attendance.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          }
          // var div= Division.query({action:'viewdata'});
          //   div.$promise.then(function(data){
          //   vm.listDivision=data;
          //    // console.log(vm.listGroupSelect);
          // });

          // div.$promise.catch(function(data){
          //   $log.info(data);
          // });

          function loadDataBU() {
            var response=Attendance.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }

          // var beu= BU.query({action:'viewdata'});
          //   beu.$promise.then(function(data){
          //   vm.listBU=data;
          //    // console.log(vm.listGroupSelect);
          // });

          // beu.$promise.catch(function(data){
          //   $log.info(data);
          // });


        $scope.$watch('vm.emp_no',function(){
          if(typeof vm.emp_no != 'undefined'){
            var Lempno=vm.emp_no.length;
            console.log('empno > '+Lempno);
          } 
        });




        ////////// 

        // function loadData(pageno){
        //    // angular.element.blockUI();
        //    var company=vm.company; 
        //    var divisi=vm.divisi;
        //    var department=vm.department;
        //    var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
        //    var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');

        //    // console.log(company+' / '+bu+' / '+divisi+' / '+department+' / '+tglmulai+' / '+tglakhir);
        //    var response=Attendance.query({action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
        //       response.$promise.then(function(data){
        //         vm.listData=data[0];
        //         console.log(vm.listData);
        //         angular.element.unblockUI();
        //       });
        //       response.$promise.catch(function(data){
        //         $log.info(data);
        //         angular.element.unblockUI();
        //       });
        // }

        function loadData(pageno)
        {
          var company=vm.company; 
          var divisi=vm.divisi;
          var department=vm.department;
          var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
          var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');
        
          var resp=vm.DataTable.loadData(Attendance,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
         // console.log(resp);
          // angular.element.unblockUI();
        }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 
        function editData(id){ 
          $state.go('app.utility_modul_edit-modul',{id:id});
        }

      function Reloadatt(ev) {
        // angular.element.blockUI();
        var response= Attendance.query({action:'getDataAttendance'});
        response.$promise.then(function(data){
          console.log(data[0].message);
           $mdDialog.show(
                $mdDialog.alert()
                  .parent(angular.element(document.querySelector('#popupContainer')))
                  .clickOutsideToClose(true)
                  .parent(angular.element(document.body))
                  .title('Attendance Update Message')
                  .textContent(data[0].message)
                  .ariaLabel('Alert Dialog Demo')
                  .ok('Got it!')
                  .targetEvent(ev)
              );
          // angular.element.unblockUI();
        });
        response.$promise.catch(function(data){

          // console.log(data.message);
          angular.element.unblockUI();
        }); 
      }

      function EmpKeyUp(){
        if(vm.emp_no.length >=8){
          var resp=Attendance.query({action:'getDataEmp',empNo:vm.emp_no});
          resp.$promise.then(function(data){
            // console.log(data);
          });
          resp.$promise.catch(function(){

          });
        }
      }

      function querySearch (query) { 
           return $http
          .get(config.api + 'api/attendance?action=searchEmp&id=' + query)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){

            }   
              return item.data;
          });
        }
        // function searchTextChange(text) {
        //   $log.info('Text changed to ' + text);
        // }

        function selectedItemChanged(item) {
          // vm.emp_no='';
          // vm.emp_name=vm.searchString;
          if(typeof item!=='undefined')
          { 
            vm.emp_no=item.emp_no;
            vm.empId=item.empId;
            vm.emp_name=item.nama;
            vm.position=item.position;
            vm.isDisabled=true; 
          }
          // console.log('test');
        }


        function IMportFile()
        {
          

        }

        function openUploadPhoto(ev)
        {
            $mdDialog.show({
                controller         : 'AttendancelistController as vm',
                templateUrl        : 'app/main/cb/attendancelist/upload-file.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/attendance/uploadfile', 
           removeAfterUpload:true,
           alias:'fileatt',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.attendance-report', [ ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    { 
        // State
        $stateProvider
            .state('app.cb_attendance_report', {
                url    : '/cb/attendance-report',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/attendance-report/attendance-report.html',
                        controller : 'AttendanceReportController as vm'
                    }
                }
            });  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.attendance-report')
        .controller('AttendanceReportController', AttendanceReportController);


    AttendanceReportController.$inject=['$state','$window','$location','$localStorage','$document','$element','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService' ];
    /** @ngInject */
    function AttendanceReportController($state,$window,$location,$localStorage,$document,$element,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService )
    {

        var vm = this;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.ExportToExcel=ExportToExcel;
        vm.ExportTotxt=ExportTotxt;
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;
        var Attendancereport=AppAPI.Attendancereport();
        var date=new Date();
        vm.tahun=date.getFullYear();
        vm.bulan=date.getMonth()+1;
        vm.getPeriode=getPeriode;
        vm.flag_app='SAP';
        vm.flagApp=['SAP','HRIS'];
        vm.tgl=date.getDate();
        vm.loadSubArea=loadSubArea;
        // console.log(vm.bulan)
        if(vm.tgl >=25 && vm.tgl <=31)
        {
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }
        vm.company=$localStorage.empsite;
        vm.groupLogin=$localStorage.group;

        vm.typeEmp = [
          {
            "view"  : "Staff",
            "value" : "SAP"
          },
          {
            "view"  : "General Worker",
            "value" : "HRIS"
          }
        ];

        // console.log(vm.groupLogin);

        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();
        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[
                    {link:'#',name:'C&B / ',active:'0'}
                    ];
        vm.listtahun=[2017,2018,2019,2020,2021];
        vm.listbulan=[{name:'January',value:'01'},
                      {name:'February',value:'02'},
                      {name:'Maret',value:'03'},
                      {name:'April',value:'04'},
                      {name:'Mei',value:'05'},
                      {name:'June',value:'06'},
                      {name:'July',value:'07'},
                      {name:'August',value:'08'},
                      {name:'September',value:'09'},
                      {name:'October',value:'10'},
                      {name:'November',value:'11'},
                      {name:'Desember',value:'12'}];

        vm.simulateQuery = false;
        vm.isDisabled    = false;
        vm.closeModal=closeModal;
       getPeriode();


        //////////

        // vm.searchTerm;
        // vm.clearSearchTerm = function() {
        //   vm.searchTerm = '';
        // };
        // // The md-select directive eats keydown events for some quick select
        // // logic. Since we have a search input here, we don't need that logic.
        // $element.find('input').on('keydown', function(ev) {
        //     ev.stopPropagation();
        // });

         function getPeriode(){
          var res=Attendancereport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
          res.$promise.then(fetchPeriode);
          res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data)
        {
          vm.periode=data[0]['periode'];
          // console.log(vm.periode);
          // loadData(1);
        }

        function errorfetchPeriode(data)
        {
          console.log('error');
        }

         function loadDataDepartment(iddivisi) {
             var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;

            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }

          function loadDataDivision(idbu) {
             var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // vm.listDivision.push(data);
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          }

          function loadDataBU() {
            var response=Attendancereport.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }



        function loadData(){
           // angular.element.blockUI();
           angular.element('#attView').block({message:'please wait..'});
           var company=vm.company;
           var divisi=vm.divisi;
           var department=vm.department;
           var tahun=vm.tahun;
           var bulan=vm.bulan;
           var subArea=vm.selectedSubarea;
           if(typeof(vm.divisi)==='undefined')
           {
              divisi='all';
           }
           if(typeof(vm.department)==='undefined')
           {
              department='all';
           }

           // console.log(company+' / '+divisi+' / '+department+' / '+tahun+' / '+bulan);
           var response=Attendancereport.query({action:'viewdata',company:company,divisi:divisi,department:department,tahun:tahun,bulan:bulan,subarea:subArea,type:vm.flag_app});
           // var response=Attendancereport.query({action:'viewdata',company:company,divisi:divisi,department:department,tahun:tahun,bulan:bulan});
              response.$promise.then(function(data){
                vm.listData=data;
                console.log(vm.listData);
                angular.element('#attView').unblock();
              });
              response.$promise.catch(function(data){
                $log.info(data);
                vm.listData=[];
                angular.element('#attView').unblock();
              });
        }

        // function loadData(pageno)
        // {
        //   var company=vm.company;
        //   var divisi=vm.divisi;
        //   var department=vm.department;
        //   var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
        //   var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');

        //   var resp=vm.DataTable.loadData(Overtime,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
        //  // console.log(resp);
        //   // angular.element.unblockUI();
        // }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          }




        function closeModal()
        {
            $mdDialog.hide();
        }

        function ExportToExcel()
        {
          var company=vm.company;
          var divisi=vm.divisi;
          var department=vm.department;
          var tahun=vm.tahun;
          var bulan=vm.bulan;
          var token=Auth.setTokenPromise();
          token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                   $window.open(protocol+'://'+host+config.api+'api/attendancereport/exportexcel/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan, '_blank');
            },function(){

                $window.alert('gagal load token');
            });
        }

        function ExportTotxt()
        {
           var company=vm.company;
           var divisi=vm.divisi;
           var department=vm.department;
           var tahun=vm.tahun;
           var bulan=vm.bulan;
           var subarea=vm.selectedSubarea;
           var empType=vm.flag_app;
           if(typeof(vm.divisi)==='undefined')
           {
              divisi='all';
           }
           if(typeof(vm.department)==='undefined')
           {
              department='all';
           }
           if(typeof vm.employeeType !== "undefined")
           {
             empType = vm.employeeType;
           }

            var token=Auth.setTokenPromise();
              token.then(function(data){
                      var protocol=$location.protocol();
                      var host=$location.host();
                     $window.open(protocol+'://'+host+config.api+'api/attendancereport/exporttxt/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan+'/'+subarea+'/'+empType, '_blank');
              },function(){

                  $window.alert('gagal load token');
              });
        }


        function  loadSubArea()
        {
          var response=Attendancereport.query({action:'viewSubArea',company:vm.company});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data)
        {
          vm.subArea=data;
        }

        function errorfetchArea(data)
        {
          vm.subArea=[];
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.attendance-outlet-team', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.cb_attendance_outlet_team', {
                url    : '/cb/attendance-outlet-team',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/attendance-outlet-team/attendance-outlet-team.html',
                        controller : 'AttendanceoutletteamController as vm'
                    }
                }
            });

   

    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.attendance-outlet-team')
        .controller('AttendanceoutletteamController', AttendanceoutletteamController);


    AttendanceoutletteamController.$inject = ['$state', '$localStorage', '$document', '$http', '$scope', 'config', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', 'FileUploader'];
    /** @ngInject */
    function AttendanceoutletteamController($state, $localStorage, $document, $http, $scope, config, $log, $mdDialog, AppAPI, Auth, DataService, FileUploader) {

        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Attendanceteam = AppAPI.Attendanceteam();
        var PayrollProcess = AppAPI.NewPayrollProcess();
        var Attendancereport = AppAPI.Attendancereport();
        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.tgl = date.getDate();
        vm.fingerLog = fingerLog;
        vm.OtInfo = OtInfo;
        vm.infoTransaction = infoTransaction;
        vm.ChangeNik = ChangeNik;

        if (vm.tgl >= 25 && vm.tgl <= 31) {
            if (vm.bulan == 12) {
                vm.bulan = 1;
                vm.tahun += 1;
            } else {
                vm.bulan = vm.bulan + 1;
            }
        }

        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }

        vm.listtahun = [2017, 2018, 2019, 2020, 2021, 2022];
        vm.listbulan = [{
                name: 'January',
                value: '01'
            },
            {
                name: 'February',
                value: '02'
            },
            {
                name: 'Maret',
                value: '03'
            },
            {
                name: 'April',
                value: '04'
            },
            {
                name: 'Mei',
                value: '05'
            },
            {
                name: 'June',
                value: '06'
            },
            {
                name: 'July',
                value: '07'
            },
            {
                name: 'August',
                value: '08'
            },
            {
                name: 'September',
                value: '09'
            },
            {
                name: 'October',
                value: '10'
            },
            {
                name: 'November',
                value: '11'
            },
            {
                name: 'Desember',
                value: '12'
            }
        ];

        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [{
            link: '#',
            name: 'C&B / ',
            active: '0'
        }];


        // console.log(vm.nik);
        vm.company = $localStorage.empsite;
        vm.loadSubArea = loadSubArea;
        vm.searchTerm = '';

        vm.subarea = '';

        vm.listteam = [];

        vm.changeArea = changeArea;

        loadSubArea();


        ////////// 
        function changeArea(sa_id) {
            vm.listteam = [];
            vm.listAttendance = [];
            vm.nik = '';
            listTeam(sa_id);
        }

        function ChangeNik() {
            vm.listAttendance = [];
            loadData(1);
        }

        function loadData(pageno) {
            angular.element.blockUI();
            var tahun = vm.tahun;
            var bulan = vm.bulan;
            var resp = Attendanceteam.query({
                action: 'viewdata',
                tahun: tahun,
                bulan: bulan,
                nik: vm.nik
            });
            resp.$promise.then(fetchDataAttendance);
            resp.$promise.catch(errFetchDataAttendance);
        }

        function errFetchDataAttendance(data) {
            vm.listAttendance = [];
            angular.element.unblockUI();
        }

        function fetchDataAttendance(data) {
            vm.listAttendance = data;
            angular.element.unblockUI();
        }

        function listTeam(sa_id) {
            var response = Attendanceteam.query({
                action: 'getListteam',
                sa_id: sa_id
            });
            response.$promise.then(function (data) {
                vm.listteam = data;
                // console.log(vm.listParent);
            });

            response.$promise.catch(function (data) {
                $log.info(data);
            });
        }


        function fingerLog(ev, id, nik) {
            var nik1 = nik.substr(1, 8);
            $mdDialog.show({
                controller: 'FingerLogAttController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance/finger-log.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id,
                    nik: nik1
                }
            });
        }

        function OtInfo(ev, ls) {
            $mdDialog.show({
                controller: 'OvertimeInfoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance-employe/ot-info.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {

                },
                locals: {
                    id: ls
                }
            });
        }

        function infoTransaction(ev, id, nik) {
            var nik1 = nik.substr(1, 8);
            // console.log(nik1);
            $mdDialog.show({
                controller: 'infoTransactionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance/info-transaction.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id,
                    nik: nik1
                }
            });
        }

        function loadSubArea() {
            var response = Attendancereport.query({
                action: 'viewSubArea',
                company: vm.company
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }


        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        vm.clearSingleQuote = function (txt) {
            return txt ? txt.replace(/'/g, "") : txt;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.attendance_employe', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.cb_attendance_employe', {
                url    : '/cb/employee-attendances',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/attendance-employe/attendance-employe.html',
                        controller : 'AttendanceemployeController as vm'
                    }
                }
            });

   

    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.attendance_employe')
        .controller('UpdateFinegerController', UpdateFinegerController);

    UpdateFinegerController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$filter'];

    /* @ngInject */
    function UpdateFinegerController($localStorage, id, $mdDialog, Form, AppAPI, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Attendanceemploye = AppAPI.Attendanceemploye();

        // set constructor form
        Form.setObject(Attendanceemploye);

        // set form to controller
        vm.Form = Form;
        vm.otherReason = false;
        vm.company=$localStorage.empsite;
        vm.country=$localStorage.country;
        // console.log('country '+vm.country+' / company '+vm.company);
        vm.closeModal = closeModal;
        vm.changeReasonUpdatefinger = changeReasonUpdatefinger;

        var empID = $localStorage.username;
        vm.gender = ['L', 'P'];
        vm.saveProcess = false;

        if(vm.company=='EN' && vm.country !='IDN')
        {
            vm.Form.objForm.description='other';
            vm.otherReason = true;
        }
        // vm.reasonUpdateFinger=[
        //             'Karyawan baru belum daftar scan finger',
        //             'Sudah scan namun jam in/out tidak terecord mesin',
        //             'Salah kode absen in/out',
        //             'Kulit jari bermasalah (ada surat dokter)',
        //             'Ganti No NIK',
        //             'Other']

        // vm.timein=id.listFinger.in;
        // vm.breakout=id.listFinger.breakOut;
        // vm.breakin=id.listFinger.breakIn;
        // vm.timeout=id.listFinger.out;
        vm.requiredBreakFinger = id.requiredBreakFinger;
        vm.Form.objForm.timein = (id.listFinger.in != 'empty') ? id.listFinger.in : '';
        vm.Form.objForm.breakout = (id.listFinger.breakOut != 'empty') ? id.listFinger.breakOut : '';
        vm.Form.objForm.breakin = (id.listFinger.breakIn != 'empty') ? id.listFinger.breakIn : '';
        vm.Form.objForm.timeout = (id.listFinger.out != 'empty') ? id.listFinger.out : '';
        vm.Form.objForm.tanggal = id.date;
        vm.Form.objForm.nik = $localStorage.user;
        vm.Form.objForm.listFinger = id.listFinger;
        vm.Form.objForm.requiredBreakFinger = id.requiredBreakFinger;
        vm.Form.objForm.shift = id.shift;
        vm.Form.objForm.startRange = id.startRange;
        vm.Form.objForm.endRange = id.endRange;

        vm.in = (id.listFinger.in != 'empty') ? id.listFinger.in : '';
        vm.out = (id.listFinger.out != 'empty') ? id.listFinger.out : '';
        vm.breakOut = (id.listFinger.breakOut != 'empty') ? id.listFinger.breakOut : '';
        vm.breakIn = (id.listFinger.breakIn != 'empty') ? id.listFinger.breakIn : '';
        vm.request = false;
        vm.Form.tampilPesan = false;

        // console.log(vm.Form.objForm.timeout);

        vm.startRange = formatDate(new Date(id.startRange));
        vm.endRange = formatDate(new Date(id.endRange));
        vm.startShift = formatDate(new Date(id.shift.iStartShiftDT));
        vm.endShift = formatDate(new Date(id.shift.iEndShiftDT));
        // vm.Form.objForm.timeout=new Date(vm.Form.objForm.timeout);
        getReasonFinger();

        ////////////////

        var resp = Attendanceemploye.query({ action: 'GetUpdateFingerExist', tgl: id.date });
        resp.$promise.then(function (data) {
            var dt = data[0];
            if (dt.app == 1) {
                vm.request = true;
            }
            vm.Form.tampilPesan = true;
            vm.messageTheme = 'pink';
            vm.Form.pesan = dt.msg;
        });

        function formatDate(date) {
            var year = date.getFullYear()
            var month = date.getMonth() + 1;
            var tgl = date.getDate();
            var hours = date.getHours();
            var minutes = date.getMinutes();
            minutes = minutes < 10 ? '0' + minutes : minutes;
            return tgl + "/" + month + "/" + year + "  " + hours + ':' + minutes;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            angular.element.blockUI();
            var promise = Form.saveData('updatefinger', formController, Attendanceemploye);
            promise.then(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                angular.element.unblockUI();
                showDialogInfo(ev, data)
            });

        }

        function changeReasonUpdatefinger() {
            var reason = vm.Form.objForm.description;
            vm.Form.objForm.description1 = '-';
            vm.otherReason = false;
            if (reason === 'Other') {
                vm.otherReason = true;
                vm.Form.objForm.description1 = null;
            }
        }

        function getReasonFinger() {
            var response = Attendanceemploye.query({ action: 'getReasonFinger' });
            response.$promise.then(function (data) {
                vm.reasonUpdateFinger = data;
            });
            response.$promise.catch(function () {
                vm.reasonUpdateFinger = [];
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    // loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.attendance_employe')
        .controller('OtInfoController', OtInfoController);

    OtInfoController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function OtInfoController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();
 
        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal; 
        vm.data=id;
        vm.stateView=true;

        // console.log(vm.data.date);
        // console.log(id);

    

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.attendance_employe')
        .controller('InputchangeShiftController', InputchangeShiftController);

    InputchangeShiftController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$filter'];

    /* @ngInject */
    function InputchangeShiftController($localStorage, id, $mdDialog, Form, AppAPI, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Attendanceemploye = AppAPI.Attendanceemploye();

        // set constructor form
        Form.setObject(Attendanceemploye);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;
        var empID = $localStorage.username;
        vm.Form.objForm.nik = $localStorage.user;
        vm.changeRefshift = changeRefshift;
        // console.log(id);
        vm.Form.objForm.tanggal = id.date;
        vm.Form.objForm.currentshift = id.shift;
        vm.getChangeshiftExist = getChangeshiftExist;
        vm.Form.objForm.shifttype = 'group';
        vm.Form.objForm.isStartSameDate = true;
        vm.changeShiftType = changeShiftType;
        vm.company = $localStorage.empsite;
        // vm.isStartSameDate=1;

        // console.log(vm.company);

        LoadLocation();

        ////////////////

        function changeRefshift(id) {
            vm.listLocationdetail = [];
            var resp = Attendanceemploye.query({ action: 'getDetailshift', id: id })
            resp.$promise.then(fetchdetailshift);
            resp.$promise.catch(errorfetchdetailshift);
        }

        function changeShiftType() {
            if (vm.Form.objForm.shifttype === 'nongroup') {
                vm.Form.objForm.start_template = "NG00";
            } else {
                vm.Form.objForm.start_template = null;
            }
        }

        function fetchdetailshift(data) {
            vm.listLocationdetail = data;
        }

        function errorfetchdetailshift() {
            vm.listLocationdetail = [];
        }

        function LoadLocation() {
            var response = Attendanceemploye.query({ action: 'getLocationshift', nik: $localStorage.user });
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
        }

        function fetchLocation(data) {
            vm.listLocation = data;
        }

        function errorFetchLocation() {
            vm.listLocation = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function getChangeshiftExist() {
            vm.Form.pesan = null;
            vm.request = false;
            vm.Form.tampilPesan = false;
            var dws_code = vm.Form.objForm.start_template;
            var resp = Attendanceemploye.query({ action: 'getChangeshiftExist', tgl: id.date, dws_code: dws_code });
            resp.$promise.then(function (data) {
                var dt = data[0];
                if (dt.app == 1) {
                    if (dt.msg == 'Request already exist and Approved') {
                        vm.request = true;
                    }
                    vm.Form.tampilPesan = true;
                    vm.messageTheme = 'pink';
                    vm.Form.pesan = dt.msg;
                }
            });
        }

        function saveData(ev, formController) {
            angular.element.blockUI();

            var promise = Form.saveData('savechangeshift', formController, Attendanceemploye);
            promise.then(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                angular.element.unblockUI();
                showDialogInfo(ev, data)
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.attendance_employe')
    .controller('InputAbsenceController', InputAbsenceController);

  InputAbsenceController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$state', '$filter'];

  /* @ngInject */
  function InputAbsenceController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $state, $filter) {
    var vm = this;

    var translate = $filter('translate');
    vm.saveData = saveData;
    // initial form
    Form.initialForm();

    var Attendanceemploye = AppAPI.Attendanceemploye();
    var Employeabsence = AppAPI.Employeabsence();

    // set constructor form
    Form.setObject(Attendanceemploye);

    // set form to controller
    vm.Form = Form;
    vm.statEdit = false;
    // console.log(id.infoAbsence);
    // console.log(id.listFingerLength);

    vm.closeModal = closeModal;
    var d = id.date.split('-');
    var d1 = d[2] + '-' + d[1] + '-' + d[0];
    // console.log(id.date);
    // console.log('Tanngal : '+d1);

    var empID = $localStorage.username;

    vm.Form.objForm.start_date = new Date(d1);
    vm.Form.objForm.end_date = new Date(d1);
    vm.Form.objForm.nik = $localStorage.user;
    vm.ChangeDayType = ChangeDayType;
    vm.ChangeAbsenceType = ChangeAbsenceType;
    vm.Form.objForm.start_time = '00:00:00';
    vm.Form.objForm.end_time = '00:00:00';
    vm.uploadFile = uploadFile;
    vm.UploadPhotoStateSucces = false;
    vm.UploadPhotoStateError = false;
    vm.upload = upload;
    vm.closeModal = closeModal;
    vm.ChangeTime = ChangeTime;
    vm.absence_id = '0';

    vm.infoAbsence = id.infoAbsence;
    var jumInfo = vm.infoAbsence.length, i;
    vm.iftruant = false;
    vm.isdisabled = false;
    vm.latein = id.lateIn;
    vm.earlyOut = id.earlyOut;
    vm.halfday = false;
    vm.latestart = id.shift.tampilStart;
    vm.lateend = id.listFinger.in;
    vm.earlystart = id.listFinger.out;
    vm.earlyend = id.shift.tampilEnd;
    vm.requestdocument = '0';
    vm.GetAbsenceExist = GetAbsenceExist;
    vm.allowsave = true;
    var latein = vm.latestart + '-' + vm.lateend;
    var earlyout = vm.earlystart + '-' + vm.earlyend;
    vm.allowedit = allowedit;
    vm.isdisabledRadio = true;
    vm.leavBalance = 0;
    vm.viewLeaveBalance = viewLeaveBalance;
    vm.saveProcess = true;
    vm.personalleaveonly = personalleaveonly;
    vm.limitTruant = id.limitTruant;
    GetAbsenceExist();

    var totalAbsen = id.lateIn + id.earlyOut + id.lateBreakIn;
    if ((totalAbsen <= vm.limitTruant && totalAbsen > 0)) {
      vm.halfday = true;
      vm.isdisabled = false;
      vm.Form.objForm.daytype = 'halfday';
      vm.Form.objForm.abs_code = 'Z304';
    }

    // console.log('start_date :'+vm.Form.objForm.start_date);
    // console.log('Earlyout :'+earlyout);

    ////////////////
    function GetAbsenceExist() {
      var resp = Attendanceemploye.query({ action: 'GetAbsenceExist', tgl: id.date });
      resp.$promise.then(function (data) {
        var dt = data[0];
        if (dt.req == 1) {
          // console.log(dt.lastrequest[0].start_time); 
          vm.request = true;
          vm.isdisabled = true;
          vm.allowsave = false;
          vm.stateEdit = false;
          if (dt.app == 1) {
            vm.allowsave = true;
          }
          vm.requestdocument = dt.lastrequest[0].document_request;
          vm.absence_id = dt.lastrequest[0].id;
          vm.Form.objForm.abs_code = dt.lastrequest[0].absence_type;
          vm.Form.objForm.description = dt.lastrequest[0].description;
          vm.Form.tampilPesan = true;
          vm.messageTheme = 'pink';
          vm.Form.pesan = dt.msg;
          var reqtime = dt.lastrequest[0].start_time + '-' + dt.lastrequest[0].end_time;
          if (latein == reqtime) {
            vm.Form.objForm.timetype = 'latein';
          }

          if (earlyout == reqtime) {
            vm.Form.objForm.timetype = 'earlyout';
          }
        }
        vm.saveProcess = false;
      });
    }

    function ChangeTime() {
      if (vm.Form.objForm.timetype == 'latein') {
        vm.Form.objForm.start_time = id.shift.start_time;
        vm.Form.objForm.end_time = vm.lateend + ':00';
      }
      if (vm.Form.objForm.timetype == 'earlyout') {
        vm.Form.objForm.start_time = id.listFinger.out;
        vm.Form.objForm.end_time = vm.earlyend + ':00';
      }
    }

    function ChangeAbsenceType(abs) {
      vm.saveProcess = true;
      var absence = Attendanceemploye.query({ action: 'getDocumentRequest', abs_code: abs });
      absence.$promise.then(function (data) {
        vm.requestdocument = data[0].request;
        GetAbsenceExist();
      });

      absence.$promise.catch(function (data) {
        $log.info(data);
      });

      if (abs == 'Z303') {
        vm.saveProcess = true;
        var leave = Attendanceemploye.query({ action: 'getLeaveBalance' });
        leave.$promise.then(function (data) {
          vm.leavBalance = data[0].leavebalance;
          vm.saveProcess = false;
        });
        leave.$promise.catch(function (data) {
          vm.leavBalance = 0;
          vm.saveProcess = false;
        });
        if (vm.leavBalance > 0) {
          vm.isdisabled = true;
        }

      }
    }

    function uploadFile() {
      return false;
    }

    function upload() {
      angular.element.blockUI();
      var check = Employeabsence.query({
        action: 'checkFinger',
        startDate: vm.Form.objForm.start_date,
        endDate: vm.Form.objForm.end_date
      });
      check.$promise.then(function (response) {
        angular.element.unblockUI();
        if (response[0].is_working == 1) {
          var note = translate('PAYROLL.MESSAGE.CHECKFINGER');
          var yes = translate('PAYROLL.MESSAGE.YES');
          var no = translate('PAYROLL.MESSAGE.NO');

          angular.element.unblockUI();
          var confirm = $mdDialog
            .confirm()
            .title('Attention !')
            .textContent(note)
            .ariaLabel('dialog')
            .ok(yes)
            .cancel(no);

          $mdDialog.show(confirm).then(
            function () {
              vm.saveProcess = true;
              var resp = vm.FileUploaderPhoto.uploadAll();
            },
            function () {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        } else {
          vm.saveProcess = true;
          var resp = vm.FileUploaderPhoto.uploadAll();
        }
      });
      check.$promise.catch(function () {
        angular.element.unblockUI();
      });

    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/employeabsence/upload',
      removeAfterUpload: true,
      alias: 'ijazah',
      onBeforeUploadItem: function (item) {

        var dt = new Date(item.formData[0].start_date);
        var et = new Date(item.formData[0].end_date);

        var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
        var newdate1 = dt.getFullYear() + '-' + (et.getMonth() + 1) + '-' + et.getDate();
        item.formData[0].start_date = newdate;
        item.formData[0].end_date = newdate1;
        angular.element.blockUI();
      },
      formData: [
        {
          action: 'uploadijazah',
          documentNo: vm.documentNo,
          typeOfDocument: vm.typeOfDocument,
          description: vm.description
        }
      ],
      onAfterAddingAll: function () {
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        vm.saveProcess = false;
        angular.element.unblockUI();
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      },
      onSuccessItem: function (item, response, status, headers) {
        showUploadDialog(response);
        angular.element.unblockUI();
        vm.saveProcess = false;
      }, onErrorItem: function (item, response, status, headers) {
        showUploadDialog(response);
        angular.element.unblockUI();
        vm.saveProcess = false;
      }
    });

    var response = Attendanceemploye.query({ action: 'getAbsenceType' });
    response.$promise.then(function (data) {
      vm.listAbsenceType = data;
      // console.log(vm.listParent);
      vm.saveProcess = false;
    });

    response.$promise.catch(function (data) {
      $log.info(data);
      vm.saveProcess = false;
    });

    function closeModal() {
      $mdDialog.hide();
    }

    function clearMeesage() {
      vm.Form.tampilPesan = false;
    }

    function saveData(ev, formController) {
      angular.element.blockUI();
      var check = Employeabsence.query({
        action: 'checkFinger',
        startDate: vm.Form.objForm.start_date,
        endDate: vm.Form.objForm.end_date
      });
      check.$promise.then(function (response) {
        angular.element.unblockUI();
        if (response[0].is_working == 1) {
          var note = translate('PAYROLL.MESSAGE.CHECKFINGER');
          var yes = translate('PAYROLL.MESSAGE.YES');
          var no = translate('PAYROLL.MESSAGE.NO');

          angular.element.unblockUI();
          var confirm = $mdDialog
            .confirm()
            .title('Attention !')
            .textContent(note)
            .ariaLabel('dialog')
            .ok(yes)
            .cancel(no);

          $mdDialog.show(confirm).then(
            function () {
              vm.saveProcess = true;
              if (!vm.stateEdit) {
                // angular.element.blockUI();
                var promise = Form.saveData('saveabsence', formController, Attendanceemploye);
                promise.then(function (data) {
                  showDialog(ev, data);
                  // angular.element.unblockUI();
                  vm.saveProcess = false;
                });
                promise.catch(function (data) {
                  ShowFailed(ev, data.data)
                  // angular.element.unblockUI();
                  vm.saveProcess = false;
                });
              } else {
                // console.log(vm.stateEdit);
                angular.element.blockUI();
                var promise = Form.saveData('updateabsence', formController, Attendanceemploye);
                promise.then(function (data) {
                  showDialog(ev, data.data);
                  // angular.element.unblockUI();
                  vm.saveProcess = false;
                });
                promise.catch(function (data) {
                  ShowFailed(ev, data)
                  // angular.element.unblockUI();
                  vm.saveProcess = false;
                });
              }
            },
            function () {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        } else {
          vm.saveProcess = true;
          if (!vm.stateEdit) {
            // angular.element.blockUI();
            var promise = Form.saveData('saveabsence', formController, Attendanceemploye);
            promise.then(function (data) {
              showDialog(ev, data);
              // angular.element.unblockUI();
              vm.saveProcess = false;
            });
            promise.catch(function (data) {
              ShowFailed(ev, data.data)
              // angular.element.unblockUI();
              vm.saveProcess = false;
            });
          } else {
            // console.log(vm.stateEdit);
            angular.element.blockUI();
            var promise = Form.saveData('updateabsence', formController, Attendanceemploye);
            promise.then(function (data) {
              showDialog(ev, data.data);
              // angular.element.unblockUI();
              vm.saveProcess = false;
            });
            promise.catch(function (data) {
              ShowFailed(ev, data)
              // angular.element.unblockUI();
              vm.saveProcess = false;
            });
          }
        }
      });
      check.$promise.catch(function () {
        angular.element.unblockUI();
      });
    }

    function showDialog(ev, data) {
      console.log(ev);
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Save Data')
          // .textContent('Process Data was Success.')
          .textContent(data.pesan)
          .ariaLabel('Success Save Data')
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }

    function showUploadDialog(data) {
      // console.log(ev);
      var title = 'Success Save Data';
      if (!data.status) {
        title = 'Failed Save Data';
      }
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          // .textContent('Process Data was Success.')
          .textContent(data.pesan)
          .ariaLabel(title)
          .ok('OK')
          .targetEvent()
      ).then(function () {
        closeModal();
      });
    }

    function ChangeDayType() {
      if (vm.Form.objForm.daytype == 'halfday') {
        vm.Form.objForm.end_date = vm.Form.objForm.start_date;
        vm.enddaterequire = false;
        vm.timerequire = true;
        vm.timedisabled = false;
      } else {
        vm.enddaterequire = true;
        vm.timerequire = false;
        vm.timedisabled = true;
      }
      // console.log(vm.Form.objForm.daytype);
    }

    function ShowFailed(ev, data) {
      // console.log(data.data);
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Save Data')
          .textContent(data.pesan)
          .ariaLabel('Failed Save Data')
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
      // console.log(data.data.pesan);
    }

    function allowedit() {
      vm.isdisabled = false;
      vm.allowsave = true;
      vm.stateEdit = true;
      vm.Form.tampilPesan = false;
    }

    function viewLeaveBalance() {

      closeModal();
      $state.go('app.cb_leave_balance');
    }

    function personalleaveonly() {
      vm.isdisabled = false;
      vm.leavBalance = 0;
    }

  }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.attendance_employe')
        .controller('InputabnormalController', InputabnormalController);

    InputabnormalController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$filter'];

    /* @ngInject */
    function InputabnormalController($localStorage, id, $mdDialog, Form, AppAPI, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Attendanceemploye = AppAPI.Attendanceemploye();

        // set constructor form
        Form.setObject(Attendanceemploye);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;


        var empID = $localStorage.username;
        // vm.gender = ['L','P'];

        // vm.timein=id.listFinger.in;
        // vm.breakout=id.listFinger.breakOut;
        // vm.breakin=id.listFinger.breakIn;
        // vm.timeout=id.listFinger.out;
        vm.requiredBreakFinger = id.requiredBreakFinger;
        vm.Form.objForm.timein = (id.listFinger.in != 'empty') ? id.listFinger.in : '';
        vm.Form.objForm.breakout = (id.listFinger.breakOut != 'empty') ? id.listFinger.breakOut : '';
        vm.Form.objForm.breakin = (id.listFinger.breakIn != 'empty') ? id.listFinger.breakIn : '';
        vm.Form.objForm.timeout = (id.listFinger.out != 'empty') ? id.listFinger.out : '';
        vm.Form.objForm.tanggal = id.date;
        vm.Form.objForm.nik = $localStorage.user;
        vm.Form.objForm.listFinger = id.listFinger;
        vm.Form.objForm.requiredBreakFinger = id.requiredBreakFinger;
        vm.Form.objForm.shift = id.shift;
        vm.Form.objForm.startRange = id.startRange;
        vm.Form.objForm.endRange = id.endRange;

        vm.in = (id.listFinger.in != 'empty') ? id.listFinger.in : '';
        vm.out = (id.listFinger.out != 'empty') ? id.listFinger.out : '';
        vm.breakOut = (id.listFinger.breakOut != 'empty') ? id.listFinger.breakOut : '';
        vm.breakIn = (id.listFinger.breakIn != 'empty') ? id.listFinger.breakIn : '';
        vm.request = false;
        vm.Form.tampilPesan = false;

        vm.startRange = formatDate(new Date(id.startRange));
        vm.endRange = formatDate(new Date(id.endRange));
        vm.startShift = formatDate(new Date(id.shift.iStartShiftDT));
        vm.endShift = formatDate(new Date(id.shift.iEndShiftDT));
        vm.saveProcess = false;

        // console.log(vm.startRange); 

        ////////////////

        var resp = Attendanceemploye.query({ action: 'GetAbnormalExist', tgl: id.date });
        resp.$promise.then(function (data) {
            var dt = data[0];
            if (dt.app == 1) {
                vm.request = true;
            }
            vm.Form.tampilPesan = true;
            vm.messageTheme = 'pink';
            vm.Form.pesan = dt.msg;
        });

        function formatDate(date) {
            var year = date.getFullYear()
            var month = date.getMonth() + 1;
            var tgl = date.getDate();
            var hours = date.getHours();
            var minutes = date.getMinutes();
            minutes = minutes < 10 ? '0' + minutes : minutes;
            return tgl + "/" + month + "/" + year + "  " + hours + ':' + minutes;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.saveProcess = true;
            var promise = Form.saveData('saveabnormal', formController, Attendanceemploye);
            promise.then(function (data) {
                showDialogInfo(ev, data);
                vm.saveProcess = false;
            });

            promise.catch(function (data) {
                showDialogInfo(ev, data)
                vm.saveProcess = false;
            });

        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.attendance_employe')
        .controller('FingerLogController', FingerLogController);

    FingerLogController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function FingerLogController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Attendanceemploye = AppAPI.Attendanceemploye();

        // set constructor form
        Form.setObject(Attendanceemploye);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal; 
        vm.Form.objForm.tanggal =id.date;
        vm.Form.objForm.shift=id.shift; 
        vm.Form.objForm.requiredBreakFinger=id.requiredBreakFinger;
        vm.Form.objForm.startRange=id.startRange;
        vm.Form.objForm.endRange=id.endRange; 
        vm.startRange=formatDate(new Date(id.startRange));
        vm.endRange=formatDate(new Date(id.endRange));
        vm.startShift=formatDate(new Date(id.shift.iStartShiftDT));
        vm.endShift=formatDate(new Date(id.shift.iEndShiftDT)); 
        // vm.nik=$localStorage.username;
         // console.log($localStorage.user);
         LoadFinger();

        //////////////// 
 
      function LoadFinger(){
        var abs=Attendanceemploye.query({action:'fingerlog',tgl:id.date,nik:$localStorage.user});
        abs.$promise.then(function(data){ 
            vm.logfinger=data;
            // console.log(vm.logfinger);
        });

        abs.$promise.catch(function(data){
            $log.info(data);
        });
      }

      function closeModal()
        {
            $mdDialog.hide();
        }

    function formatDate(date) {
              var year=date.getFullYear()
              var month=date.getMonth()+1;
              var tgl=date.getDate();
              var hours = date.getHours();
              var minutes = date.getMinutes();  
              minutes = minutes < 10 ? '0'+minutes : minutes; 
              return tgl+ "/" + month + "/" + year + "  " + hours+':'+minutes;
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.attendance_employe')
        .controller('AttendanceemployeController', AttendanceemployeController);

    AttendanceemployeController.$inject = [
        '$state',
        '$localStorage',
        '$document',
        '$http',
        '$scope',
        'config',
        '$log',
        '$mdDialog',
        'AppAPI',
        'Auth',
        'DataService',
        'FileUploader',
        'msNavigationService'
    ];
    /** @ngInject */
    function AttendanceemployeController(
        $state,
        $localStorage,
        $document,
        $http,
        $scope,
        config,
        $log,
        $mdDialog,
        AppAPI,
        Auth,
        DataService,
        FileUploader,
        msNavigationService
    ) {
        var vm = this;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.Reloadatt = Reloadatt;
        var Attendanceemploye = AppAPI.Attendanceemploye();
        var date = new Date();
        vm.tahun = date.getFullYear();
        vm.bulan = date.getMonth() + 1;
        vm.getPeriode = getPeriode;
        vm.tgl = date.getDate();
        vm.infoTransaction = infoTransaction;
        vm.OtInfo = OtInfo;
        vm.isLoading = true;
        if (vm.tgl >= 25 && vm.tgl <= 31) {
            if (vm.bulan == 12) {
                vm.bulan = 1;
                vm.tahun += 1;
            } else {
                vm.bulan = vm.bulan + 1;
            }
        }

        if (vm.bulan < 10) {
            vm.bulan = '0' + vm.bulan;
        }

        // console.log(vm.tgl + '/' + vm.bulan + '/' + vm.tahun);

        vm.listtahun = [2017, 2018, 2019, 2020];
        vm.listbulan = [{
                name: 'January',
                value: '01'
            },
            {
                name: 'February',
                value: '02'
            },
            {
                name: 'Maret',
                value: '03'
            },
            {
                name: 'April',
                value: '04'
            },
            {
                name: 'Mei',
                value: '05'
            },
            {
                name: 'June',
                value: '06'
            },
            {
                name: 'July',
                value: '07'
            },
            {
                name: 'August',
                value: '08'
            },
            {
                name: 'September',
                value: '09'
            },
            {
                name: 'October',
                value: '10'
            },
            {
                name: 'November',
                value: '11'
            },
            {
                name: 'Desember',
                value: '12'
            }
        ];

        vm.Breadhome = 'app.pms_dashboard';
        vm.Breadlist = [{
            link: '#',
            name: 'C&B / ',
            active: '0'
        }];

        vm.openUploadPhoto = openUploadPhoto;
        vm.closeModal = closeModal;
        vm.uploadFile = uploadFile;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        vm.nik = $localStorage.user;
        vm.inputUpnormal = inputAbnormal;
        vm.changeShift = changeShift;
        vm.InputAbsence = InputAbsence;
        vm.fingerLog = fingerLog;
        vm.UpdateFingertime = updateFinger;

        // console.log(vm.nik);
        getPeriode();

        //////////

        function getPeriode() {
            var res = Attendanceemploye.query({
                action: 'getPeriode',
                tahun: vm.tahun,
                bulan: vm.bulan
            });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            vm.periode = data[0]['periode'];
            // console.log(vm.periode);
            loadData(1);
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }

        function updateFinger(ev, id) {
            $mdDialog.show({
                controller: 'UpdateFinegerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance-employe/update-finger.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }


        function loadData(pageno) {
            // angular
            //     .element('#attendance-content')
            //     .block({ message: 'please wait..' });
            vm.isLoading = true;
            var tahun = vm.tahun;
            var bulan = vm.bulan;
            var resp = Attendanceemploye.query({
                action: 'viewdata',
                tahun: tahun,
                bulan: bulan
            });
            resp.$promise.then(fetchDataAttendance);
            resp.$promise.catch(errFetchDataAttendance);
        }

        function errFetchDataAttendance(data) {
            vm.listAttendance = [];
            vm.isLoading = false;
            // angular.element('#attendance-content').unblock();
        }

        function fetchDataAttendance(data) {
            vm.listAttendance = [];
            vm.isLoading = false;
            vm.listAttendance = data;
            // angular.element('#attendance-content').unblock();

        }

        function Reloadatt(ev) {
            // angular.element.blockUI();
            var response = Attendance.query({
                action: 'getDataAttendance'
            });
            response.$promise.then(function (data) {
                console.log(data[0].message);
                $mdDialog.show(
                    $mdDialog
                    .alert()
                    .parent(
                        angular.element(
                            document.querySelector('#popupContainer')
                        )
                    )
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title('Attendance Update Message')
                    .textContent(data[0].message)
                    .ariaLabel('Alert Dialog Demo')
                    .ok('Got it!')
                    .targetEvent(ev)
                );
                // angular.element.unblockUI();
            });
            response.$promise.catch(function (data) {
                // console.log(data.message);
                angular.element.unblockUI();
            });
        }

        function inputAbnormal(ev, id) {
            $mdDialog.show({
                controller: 'InputabnormalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance-employe/input-abnormal.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }

        function changeShift(ev, id) {
            $mdDialog.show({
                controller: 'InputchangeShiftController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance-employe/input-changeshift.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }

        function InputAbsence(ev, id) {
            $mdDialog.show({
                controller: 'InputAbsenceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance-employe/input-absence.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }

        function fingerLog(ev, id) {
            $mdDialog.show({
                controller: 'FingerLogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance-employe/finger-log.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id
                }
            });
        }

        function openUploadPhoto(ev) {
            $mdDialog.show({
                controller: 'UploadattendanceController as vm',
                templateUrl: 'app/main/cb/attendance/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        var uploaderPhoto = (vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/attendance/uploadfile',
            removeAfterUpload: true,
            alias: 'fileatt',
            formData: [{
                action: 'uploadfile'
            }],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        }));

        uploaderPhoto.onSuccessItem = function (item) {
            vm.UploadPhotoStateSucces = true;
            vm.UploadPhotoStateError = false;
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem = function () {
            vm.UploadPhotoStateSucces = false;
            vm.UploadPhotoStateError = true;
        };

        function uploadFile() {
            return false;
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function OtInfo(ev, ls) {
            $mdDialog.show({
                controller: 'OtInfoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance-employe/ot-info.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {},
                locals: {
                    id: ls
                }
            });
        }

        function infoTransaction(ev, id, nik) {
            $mdDialog.show({
                controller: 'infoTransactionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/attendance/info-transaction.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    id: id,
                    nik: nik
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.attendance', [
        ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {
       
      // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/attendance');

        // State
        $stateProvider
            .state('app.cb_attendance', {
                url    : '/cb/attendance',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/attendance/attendance.html',
                        controller : 'AttendanceController as vm'
                    }
                }
            });

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.attendance')
        .controller('UploadExcelAttendanceController', UploadExcelAttendanceController);


    UploadExcelAttendanceController.$inject=['$state','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','FileUploader','$location', '$window', '$element', '$filter'];
    /** @ngInject */
    function UploadExcelAttendanceController($state,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,FileUploader,$location, $window, $element, $filter)
    {
        
        var vm = this;  
        var Attendance=AppAPI.Attendance(); 
        vm.closeModal=closeModal;  
        vm.DownloadTemplate=DownloadTemplate;
        vm.uploadSuccess = vm.uploadError = vm.isMoreInfo = false;
        vm.uploadNotif = '';
        vm.closeModal=closeModal;
        vm.dialogClose=dialogClose;
        vm.viewMoreInfo = viewMoreInfo;


        //////////  

        function closeModal()
        {
            $mdDialog.hide();
        }

        function DownloadTemplate() {
          var token = Auth.setTokenPromise();
          token.then(function (data) {
            var protocol = $location.protocol();
            var host = $location.host();
            $window.open(protocol + '://' + host + config.port + config.api + 'api/attendance/downloadtemplate', '_blank');
          }, function () {
            $window.alert('gagal load token');
          });
        }

        vm.FileUploader = new FileUploader({
          url: config.api + 'api/attendance/uploadfilechina',
          removeAfterUpload: true,
          alias: 'fileupload',
          formData: [{
            action: 'uploadfilechina'
          }],
          onAfterAddingAll: function () {
            vm.uploadSuccess = false;
            vm.uploadError = false;
          },
          headers: {
            tokenAuth: $localStorage.tokenAuth
          }
        });

        vm.FileUploader.onSuccessItem = function (data, status, headers, config) {
          if (status.status == 0) {
            vm.uploadSuccess = false;
            vm.uploadError = true;
          } else {
            vm.uploadSuccess = true;
            vm.uploadError = false;
          }

          var expmess = status.pesan.split("_");
          if (expmess.length > 1) {
            var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
          } else {
            var message = translate(status.pesan);
          }
          vm.uploadNotif = message

          if ('moreInfo' in status && status.moreInfo.length > 0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
          }

          angular.element('#uploadCutOff').val('');

        };

        vm.FileUploader.onErrorItem = function () {
          vm.uploadSuccess = false;
          vm.uploadError = true;

        };

       function viewMoreInfo(detail) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: detail
              }
            });
          }

      function dialogClose() {
          $mdDialog.hide();
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.attendance')
        .controller('OvertimeInfoController', OvertimeInfoController);

    OvertimeInfoController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function OvertimeInfoController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();
 
        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal; 
        vm.data=id;
        vm.stateView=true;

        // console.log(vm.data.date);
        // console.log(id);

    

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.attendance')
        .controller('infoTransactionController', infoTransactionController);

    infoTransactionController.$inject = ['$localStorage', 'id', 'nik', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$translate', '$scope', '$filter'];

    /* @ngInject */
    function infoTransactionController($localStorage, id, nik, $mdDialog, Form, AppAPI, $log, FileUploader, config, $translate, $scope, $filter) {
        var vm = this;
        // initial form
        Form.initialForm();

        var Attendanceemploye = AppAPI.Attendanceemploye();

        // set constructor form
        Form.setObject(Attendanceemploye);

        // set form to controller
        vm.Form = Form;

        vm.showDetail = showDetail

        vm.closeModal = closeModal;
        vm.Form.objForm.tanggal = id.date;
        vm.Form.objForm.shift = id.shift;
        vm.startRange = formatDate(new Date(id.startRange));
        vm.endRange = formatDate(new Date(id.endRange));
        vm.startShift = formatDate(new Date(id.shift.iStartShiftDT));
        vm.endShift = formatDate(new Date(id.shift.iEndShiftDT));
        vm.toogleSubChild = toogleSubChild;
        vm.saveProcess = true;

        vm.active = '';

        loadTransaction();

        // $scope.$watch(
        //   function() { return $filter('translate')('HELLO_WORLD'); },
        //   function(newval) { $scope.pageTitle = newval; }
        // );

        //////////////// 

        function loadTransaction() {
            var abs = Attendanceemploye.query({
                action: 'viewTransaction',
                tgl: id.date,
                nik: nik
            });
            abs.$promise.then(function (data) {
                vm.listTransaction = data;
                vm.saveProcess = false;
                // console.log(vm.listTransaction[0]);
            });

            abs.$promise.catch(function (data) {
                $log.info(data);
                vm.saveProcess = false;
            });
        }

        function toogleSubChild(idx) {
            switch (vm.visibleSubChild[idx]) {
                case true:
                    vm.visibleSubChild[idx] = false;
                    vm.icon = 'icon-minus';
                    break;
                case false:
                    vm.visibleSubChild[idx] = true;
                    vm.icon = 'icon-plus';
                    break;
                default:
                    vm.visibleSubChild[idx] = true;
                    vm.icon = 'icon-minus';
                    break;
            }

        }

        function closeModal() {
            $mdDialog.hide();
        }

        function formatDate(date) {
            var year = date.getFullYear()
            var month = date.getMonth() + 1;
            var tgl = date.getDate();
            var hours = date.getHours();
            var minutes = date.getMinutes();
            minutes = minutes < 10 ? '0' + minutes : minutes;
            return tgl + "/" + month + "/" + year + "  " + hours + ':' + minutes;
        }

        function showDetail(event, row) {

            var tHeader = ''
            var tColumn = ''
            var tColumnOld = ''
            var tColumnNew = ''
            var dataNew = {}
            var titleBefore = '<h5>Data Finger Before :</h5>'
            var titleAfter = '<h5>Data Finger After :</h5>'
            var shiftBefore = '<h5>Data Shift Before :</h5>'
            var shifteAfter = '<h5>Data Shift After :</h5>'

            var divElement = angular.element(document.querySelector('#row-child-' + vm.active));
            divElement.remove();
            // vm.active = ''

            if (vm.active !== row.id) {
                vm.active = row.id
                if (row.transactionType == 'leave') {

                    tHeader += '<th>NIK</th>'
                    tHeader += '<th>Transaction Type</th>'
                    tHeader += '<th>Transaction Name</th>'
                    tHeader += '<th>Absence Type</th>'
                    tHeader += '<th>Start Date</th>'
                    tHeader += '<th>End Date</th>'
                    tHeader += '<th>Start Time</th>'
                    tHeader += '<th>End Time</th>'
                    tHeader += '<th>Description</th>'
                    tHeader += '<th>Request Date</th>'
                    tHeader += '<th>Approval</th>'
                    tHeader += '<th>Approval Date</th>'

                    tColumn += '<td>' + row.nik + '</td>'
                    tColumn += '<td>' + row.transactionType + '</td>'
                    tColumn += '<td>' + row.typeName + '</td>'
                    tColumn += '<td>' + row.absence_type + '</td>'
                    tColumn += '<td>' + row.start_date + '</td>'
                    tColumn += '<td>' + row.end_date + '</td>'
                    tColumn += '<td>' + row.start_time + '</td>'
                    tColumn += '<td>' + row.end_time + '</td>'
                    tColumn += '<td>' + row.description + '</td>'
                    tColumn += '<td>' + row.requestDate + '</td>'
                    tColumn += '<td>' + row.approvalInfo + '</td>'
                    tColumn += '<td>' + row.approvalDate + '</td>'

                    var childRow = '<tr id="row-child-' + row.id + '"><td colspan="5"><table class="table"><tr>' + tHeader + '</tr><tr>' + tColumn + '</tr></table></td></tr>'

                } else if (row.transactionType == 'overtime') {

                    if (row.is_after == 1) {
                        row.is_after = 'Yes'
                    } else {
                        row.is_after = 'No'
                    }

                    tHeader += '<th>NIK</th>'
                    tHeader += '<th>Transaction Type</th>'
                    tHeader += '<th>Overtime Type</th>'
                    tHeader += '<th>Overtime Date</th>'
                    tHeader += '<th>Start Time</th>'
                    tHeader += '<th>End Time</th>'
                    tHeader += '<th>Is After</th>'
                    tHeader += '<th>Rest Hour</th>'
                    tHeader += '<th>Reason</th>'
                    tHeader += '<th>Request Date</th>'
                    tHeader += '<th>Request By</th>'
                    tHeader += '<th>Approval</th>'
                    tHeader += '<th>Approval Date</th>'

                    tColumn += '<td>' + row.nik + '</td>'
                    tColumn += '<td>' + row.transactionType + '</td>'
                    tColumn += '<td>' + row.ot_type + '</td>'
                    tColumn += '<td>' + row.ot_date + '</td>'
                    tColumn += '<td>' + row.start_time + '</td>'
                    tColumn += '<td>' + row.end_time + '</td>'
                    tColumn += '<td>' + row.is_after + '</td>'
                    tColumn += '<td>' + row.rest_hour + '</td>'
                    tColumn += '<td>' + row.reason + '</td>'
                    tColumn += '<td>' + row.requestDate + '</td>'
                    tColumn += '<td>' + row.requestby + '</td>'
                    tColumn += '<td>' + row.approvalInfo + '<br>' + row.approvalInfo2 + '</td>'
                    tColumn += '<td>' + row.approvalDate + '<br>' + row.approvalDate2 + '</td>'

                    var childRow = '<tr id="row-child-' + row.id + '"><td colspan="5"><table class="table"><tr>' + tHeader + '</tr><tr>' + tColumn + '</tr></table></td></tr>'

                } else if (row.transactionType == 'abnormal') {

                    var dataOld = JSON.parse(row.absen_list)
                    var detail = row.detail

                    tHeader += '<th>IN</th>'
                    tHeader += '<th>Break Out</th>'
                    tHeader += '<th>Break In</th>'
                    tHeader += '<th>Out</th>'

                    tColumnOld += '<td>' + dataOld.in + '</td>'
                    tColumnOld += '<td>' + dataOld.breakOut + '</td>'
                    tColumnOld += '<td>' + dataOld.breakIn + '</td>'
                    tColumnOld += '<td>' + dataOld.out + '</td>'

                    dataNew.in = dataOld.in
                    dataNew.out = detail.out

                    angular.forEach(detail, function (value, key) {
                        if (value.type == 'I0') {
                            dataNew.in = value.transaction_time
                        } else if (value.type == 'O0') {
                            dataNew.out = value.transaction_time
                        }
                    });

                    tColumnNew += '<td>' + dataNew.in + '</td>'
                    tColumnNew += '<td>' + dataOld.breakOut + '</td>'
                    tColumnNew += '<td>' + dataOld.breakIn + '</td>'
                    tColumnNew += '<td>' + dataNew.out + '</td>'

                    var childRow = '<tr id="row-child-' + row.id + '">' +
                        '<td colspan="5">' +
                        '<h5>Description : </h5>' +
                        '<p>' + row.description + '</p>' +
                        titleBefore +
                        '<table class="table">' +
                        '<tr>' + tHeader + '</tr>' +
                        '<tr>' + tColumnOld + '</tr>' +
                        '</table>' +
                        titleAfter +
                        '<table class="table">' +
                        '<tr>' + tHeader + '</tr>' +
                        '<tr>' + tColumnNew + '</tr>' +
                        '</table>' +
                        '</td>' +
                        '</tr>'

                } else if (row.transactionType == 'updatefinger') {

                    var detail = row.detail
                    var dataOld = JSON.parse(row.finger_actual)

                    tHeader += '<th>IN</th>'
                    tHeader += '<th>Break Out</th>'
                    tHeader += '<th>Break In</th>'
                    tHeader += '<th>Out</th>'

                    tColumnOld += '<td>' + ((dataOld.in !== undefined) ? dataOld.in : '-') + '</td>'
                    tColumnOld += '<td>' + ((dataOld.breakOut !== undefined) ? dataOld.breakOut : '-') + '</td>'
                    tColumnOld += '<td>' + ((dataOld.breakIn !== undefined) ? dataOld.breakIn : '-') + '</td>'
                    tColumnOld += '<td>' + ((dataOld.out !== undefined) ? dataOld.out : '-') + '</td>'

                    dataNew.in = dataOld.in
                    dataNew.out = dataOld.out

                    angular.forEach(detail, function (value, key) {
                        if (value.type == 'I0') {
                            dataNew.in = value.transaction_time
                        } else if (value.type == 'O0') {
                            dataNew.out = value.transaction_time
                        }
                    });

                    tColumnNew += '<td>' + ((dataNew.in !== undefined) ? dataNew.in : '-') + '</td>'
                    tColumnNew += '<td>' + ((dataOld.breakOut !== undefined) ? dataOld.breakOut : '-') + '</td>'
                    tColumnNew += '<td>' + ((dataOld.breakIn !== undefined) ? dataOld.breakIn : '-') + '</td>'
                    tColumnNew += '<td>' + ((dataNew.out !== undefined) ? dataNew.out : '-') + '</td>'

                    var childRow = '<tr id="row-child-' + row.id + '">' +
                        '<td colspan="5">' +
                        '<h5>Description : </h5>' +
                        '<p>' + row.description + '</p>' +
                        titleBefore +
                        '<table class="table">' +
                        '<tr>' + tHeader + '</tr>' +
                        '<tr>' + tColumnOld + '</tr>' +
                        '</table>' +
                        titleAfter +
                        '<table class="table">' +
                        '<tr>' + tHeader + '</tr>' +
                        '<tr>' + tColumnNew + '</tr>' +
                        '</table>' +
                        '</td>' +
                        '</tr>'

                } else if (row.transactionType == 'ghk' || row.transactionType == 'ghk holiday') {

                    tHeader += '<th>DWS Code</th>'
                    tHeader += '<th>Start Shift</th>'
                    tHeader += '<th>End Shift</th>'
                    tHeader += '<th>Variant</th>'
                    tHeader += '<th>Holiday Date</th>'
                    tHeader += '<th>Reason</th>'

                    tColumn += '<td>' + row.dws_code + '</td>'
                    tColumn += '<td>' + row.startShift + '</td>'
                    tColumn += '<td>' + row.endShift + '</td>'
                    tColumn += '<td>' + row.variant + '</td>'
                    tColumn += '<td>' + ((row.holiday_date !== undefined) ? row.holiday_date : '-') + '</td>'
                    tColumn += '<td>' + row.reason + '</td>'

                    var childRow = '<tr id="row-child-' + row.id + '"><td colspan="5"><table class="table"><tr>' + tHeader + '</tr><tr>' + tColumn + '</tr></table></td></tr>'

                } else if (row.transactionType == 'change shift') {
                    var currentShift = JSON.parse(row.cuurentshift)

                    tHeader += '<th>ID Shift</th>'
                    tHeader += '<th>Start Shift</th>'
                    tHeader += '<th>End Shift</th>'
                    tHeader += '<th>Variant</th>'


                    tColumn += '<td>' + currentShift.dwsCode + '</td>'
                    tColumn += '<td>' + currentShift.start_time + '</td>'
                    tColumn += '<td>' + currentShift.end_time + '</td>'
                    tColumn += '<td>' + currentShift.variant + '</td>'

                    if (row.variant == 'Half') {
                        var startShift = row.startShiftHalf
                        var endShift = row.endShiftHalf
                    } else {
                        var startShift = row.startShiftFull
                        var endShift = row.endShiftFull
                    }

                    tColumnNew += '<td>' + row.idshift + '</td>'
                    tColumnNew += '<td>' + startShift + '</td>'
                    tColumnNew += '<td>' + endShift + '</td>'
                    tColumnNew += '<td>' + ((row.variant !== undefined) ? row.variant : '-') + '</td>'

                    var childRow = '<tr id="row-child-' + row.id + '">' +
                        '<td colspan="5">' +
                        shiftBefore +
                        '<table class="table">' +
                        '<tr>' + tHeader + '</tr>' +
                        '<tr>' + tColumn + '</tr>' +
                        '</table>' +
                        shifteAfter +
                        '<table class="table">' +
                        '<tr>' + tHeader + '</tr>' +
                        '<tr>' + tColumnNew + '</tr>' +
                        '</table>' +
                        '</td>' +
                        '</tr>'
                } else if (row.transactionType == 'ghk halfday') {
                    tHeader += '<th>Start Shift</th>'
                    tHeader += '<th>End Shift</th>'
                    tHeader += '<th>Holiday Date</th>'
                    tHeader += '<th>Reason</th>'

                    tColumn += '<td>' + row.startShift + '</td>'
                    tColumn += '<td>' + row.endShift + '</td>'
                    tColumn += '<td>' + ((row.working_date !== undefined) ? row.working_date : '-') + '</td>'
                    tColumn += '<td>' + row.reason + '</td>'

                    var childRow = '<tr id="row-child-' + row.id + '"><td colspan="5"><table class="table"><tr>' + tHeader + '</tr><tr>' + tColumn + '</tr></table></td></tr>'

                }

                var divElement = angular.element(document.querySelector('#row-' + row.id));
                var htmlElement = angular.element(childRow);
                htmlElement.insertAfter(divElement);

            } else {

                var divElement = angular.element(document.querySelector('#row-child-' + vm.active));
                divElement.remove();
                vm.active = ''

            }


            // $compile(divElement)($scope);

            // console.log(row)
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.attendance')
        .controller('FingerLogAttController', FingerLogAttController);

    FingerLogAttController.$inject = ['$localStorage','id','nik','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function FingerLogAttController($localStorage,id,nik,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Attendanceemploye = AppAPI.Attendanceemploye();

        // set constructor form
        Form.setObject(Attendanceemploye);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal; 
        vm.Form.objForm.tanggal =id.date;
        vm.Form.objForm.shift=id.shift;  
        vm.startRange=formatDate(new Date(id.startRange));
        vm.endRange=formatDate(new Date(id.endRange));
        vm.startShift=formatDate(new Date(id.shift.iStartShiftDT));
        vm.endShift=formatDate(new Date(id.shift.iEndShiftDT)); 
        // vm.nik=$localStorage.username;
         // console.log(id);
         LoadFinger();

        //////////////// 
 
      function LoadFinger(){
        var abs=Attendanceemploye.query({action:'fingerlog',tgl:id.date,nik:nik});
        abs.$promise.then(function(data){ 
            vm.logfinger=data;
            // console.log(vm.logfinger);
        });

        abs.$promise.catch(function(data){
            $log.info(data);
        });
      }

      function closeModal()
        {
            $mdDialog.hide();
        }

        function formatDate(date) {
              var year=date.getFullYear()
              var month=date.getMonth()+1;
              var tgl=date.getDate();
              var hours = date.getHours();
              var minutes = date.getMinutes();  
              minutes = minutes < 10 ? '0'+minutes : minutes; 
              return tgl+ "/" + month + "/" + year + "  " + hours+':'+minutes;
        }
 
    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.attendance')
    .controller('AttendanceController', AttendanceController);


  AttendanceController.$inject = ['$state', '$localStorage', '$document', '$http', '$scope', 'config', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', 'FileUploader', '$location', '$window'];
  /** @ngInject */
  function AttendanceController($state, $localStorage, $document, $http, $scope, config, $log, $mdDialog, AppAPI, Auth, DataService, FileUploader, $location, $window) {

    var vm = this;
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    vm.Reloadatt = Reloadatt;
    vm.loadDataDivision = loadDataDivision;
    vm.loadDataDepartment = loadDataDepartment;
    var Attendance = AppAPI.Attendance();
    vm.company = $localStorage.empsite;
    vm.fingerLog = fingerLog;
    vm.OtInfo = OtInfo;
    vm.infoTransaction = infoTransaction;
    vm.search = search;
    vm.downloadAttendance = downloadAttendance;
    vm.company = $localStorage.empsite;
    vm.country = $localStorage.country;
    vm.group = $localStorage.group;

    console.log(typeof vm.DataTable.searchParam)
    function downloadAttendance() {
      var token = Auth.setTokenPromise();
      var company = vm.company;
      var divisi = vm.divisi;
      var department = vm.department;

      var dt = new Date(vm.tglmulai);
      var et = new Date(vm.tglakhir);
      var startDate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
      var endDate = et.getFullYear() + '-' + (et.getMonth() + 1) + '-' + et.getDate();

      var nik = '';
      nik = vm.DataTable.searchParam;

      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/attendance/downloadPDF/' + company + '/' + divisi + '/' + department + '/' + startDate + '/' + endDate + '/' + nik + '/' + data.token, '_blank');
      }, function () {
        $window.alert('gagal load token')
      });
    }

    // vm.DataTable.searchParam='16000390';
    function search() {
      // vm.DataTable.searchParam='16000390';
      // loadData(1);

      console.log(vm.query);
    }

    loadCompany();
    loadDataDivision(vm.company)
    vm.Breadhome = "app.pms_dashboard";
    vm.Breadlist = [
      { link: '#', name: 'C&B / ', active: '0' }
    ];



    vm.uploadAttendance = uploadAttendance;
    vm.closeModal = closeModal;
    vm.uploadFile = uploadFile;
    vm.UploadPhotoStateSucces = false;
    vm.UploadPhotoStateError = false;




    function loadDataDepartment(iddivisi) {
      var response = Attendance.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
    }

    function errorDepartment() {
      vm.listDepartment = [];
    }


    function loadDataDivision(idbu) {
      var response = Attendance.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
      vm.listDivision = data;
    }

    function errorDivisiBU() {
      vm.listDivision = [];
    }


    function loadCompany() {
      var response = Attendance.query({ action: 'viewBu' });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU = data;
    }

    function errorFetchBU() {
      vm.listBU = [];
    }


    ////////// 



    function loadData(pageno) {
      var company = vm.company;
      var divisi = vm.divisi;
      var department = vm.department;
      // var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
      // var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');
      var resp = vm.DataTable.loadData(Attendance, pageno, { action: 'viewdata', company: company, divisi: divisi, department: department, tglmulai: vm.tglmulai, tglakhir: vm.tglakhir });
      // console.log(resp);
      // angular.element.unblockUI();
    }



    function Reloadatt(ev) {
      // angular.element.blockUI();
      var response = Attendance.query({ action: 'getDataAttendance' });
      response.$promise.then(function (data) {
        console.log(data[0].message);
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#popupContainer')))
            .clickOutsideToClose(true)
            .parent(angular.element(document.body))
            .title('Attendance Update Message')
            .textContent(data[0].message)
            .ariaLabel('Alert Dialog Demo')
            .ok('Got it!')
            .targetEvent(ev)
        );
        // angular.element.unblockUI();
      });
      response.$promise.catch(function (data) {

        // console.log(data.message);
        angular.element.unblockUI();
      });
    }


    function uploadAttendance(ev) {
      $mdDialog.show({
        controller: 'UploadExcelAttendanceController as vm',
        templateUrl: 'app/main/cb/attendance/upload-file.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      });
    }


    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/attendance/uploadfile',
      removeAfterUpload: true,
      alias: 'fileatt',
      formData: [
        {
          action: 'uploadfile'
        }
      ],
      onAfterAddingAll: function () {
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });


    uploaderPhoto.onSuccessItem = function (item) {
      vm.UploadPhotoStateSucces = true;
      vm.UploadPhotoStateError = false;
      angular.element('#uploaderPhoto').val('');
    };

    uploaderPhoto.onErrorItem = function () {
      vm.UploadPhotoStateSucces = false;
      vm.UploadPhotoStateError = true;
    };

    function uploadFile() {
      return false;
    }

    function closeModal() {
      $mdDialog.hide();
    }


    function fingerLog(ev, id, nik) {
      // console.log(nik);
      $mdDialog.show({
        controller: 'FingerLogAttController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/attendance/finger-log.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id,
          nik: nik
        }
      });
    }

    function OtInfo(ev, ls) {
      $mdDialog.show({
        controller: 'OvertimeInfoController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/attendance-employe/ot-info.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {

        },
        locals: {
          id: ls
        }
      });
    }

    function infoTransaction(ev, id, nik) {
      $mdDialog.show({
        controller: 'infoTransactionController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/attendance/info-transaction.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id,
          nik: nik
        }
      });
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.admin-area-incharge', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
     // State
        $stateProvider
            .state('app.cb_admin_area_incharge_management', {
                url    : '/cb/admin-area-incharge',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/area-incharge/index.html',
                        controller : 'AdminAreaInchargeController as vm'
                    }
                }
            }); 
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.admin-area-incharge')
        .controller('EditAdminAreaInchargeController', EditAdminAreaInchargeController);

    EditAdminAreaInchargeController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','$element','data'];

    /* @ngInject */
    function EditAdminAreaInchargeController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,$element,data) {
        var vm = this;
        // initial form
        Form.initialForm();
        
        var AdminAreaIncharge = AppAPI.AdminAreaIncharge();

        // set constructor form
        Form.setObject(AdminAreaIncharge);
        
        // set form to controller
        vm.Form = Form;
        vm.isUpdate = true;
        
        getArea();
        getType();
        
        ////////////////  
        var res=vm.Form.objForm.$get({action:'viewDetail',id:data.id});
        res.then(getDetail);
        
        function getDetail(data)
        {
            vm.Form.objForm.nik = data.nik
            vm.Form.objForm.sub_area_ids = data.sub_area_ids
            vm.Form.objForm.type = data.type
        }
        
        vm.listSelected=[];
        
        vm.saveData             = saveData;
        vm.closeModal           = closeModal; 
        vm.toggleSelectedAll    =toggleSelectedAll;
        vm.isChecked            = isChecked;
        vm.toggleCheck          = toggleCheck;
        vm.getArea              = getArea
        

        function getType()
        { 
            var resp=AdminAreaIncharge.query({action:'getType'})
            resp.$promise.then(fetchType);
            resp.$promise.catch(errorType); 
        }
        
        function fetchType(data)
        {
             vm.listType=data;
        }

        function errorType()
        {
             vm.listType=[];
        }

        function getArea()
        {
            var resp=AdminAreaIncharge.query({action:'getArea',company:"PM"})
            resp.$promise.then(fetchArea);
            resp.$promise.catch(errorArea); 
        }

        function fetchArea(data)
        {
             vm.listArea=data;
        }

        function errorArea()
        {
             vm.listArea=[];
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;

            var promise= Form.saveData('updateData', formController, AdminAreaIncharge);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
        }

        function toggleSelectedAll(state)
        {

            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }
        }

        function isChecked(ls)
        {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if ( idx > -1 )
            { 
                vm.listSelected.splice(idx, 1);
            }
            else
            {
                vm.listSelected.push(ls);
            }
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.admin-area-incharge')
        .controller('CreateAdminAreaInchargeController', CreateAdminAreaInchargeController);

    CreateAdminAreaInchargeController.$inject = ['$localStorage','DataService','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','$element'];

    /* @ngInject */
    function CreateAdminAreaInchargeController($localStorage,DataService,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,$element) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var AdminAreaIncharge = AppAPI.AdminAreaIncharge();

        // set constructor form
        Form.setObject(AdminAreaIncharge);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;

        
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        
        vm.closeModal        = closeModal;  
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.isChecked         = isChecked;
        vm.toggleCheck       = toggleCheck;
        vm.getArea           = getArea
        
        vm.listSelected = [];
        vm.empSelected  = [];
        
        getType();

        function getType()
        { 
            var resp=AdminAreaIncharge.query({action:'getType'})
            resp.$promise.then(fetchType);
            resp.$promise.catch(errorType); 
        }
        
        function fetchType(data)
        {
             vm.listType=data;
        }

        function errorType()
        {
             vm.listType=[];
        }

        function getArea(nik)
        { 
            if(nik.length==8){
                var resp=AdminAreaIncharge.query({action:'getArea',company:"PM",nik:nik})
                resp.$promise.then(fetchArea);
                resp.$promise.catch(errorArea); 
            }
        }

        function fetchArea(data)
        {
             vm.listArea=data;
        }

        function errorArea()
        {
             vm.listArea=[];
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;

            var promise= Form.saveData('saveData', formController, AdminAreaIncharge);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
        }

        function toggleSelectedAll(state)
        {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }
        }

        function isChecked(ls)
        {
            return vm.listSelected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if ( idx > -1 )
            { 
                vm.listSelected.splice(idx, 1);
            }
            else
            {
                vm.listSelected.push(ls);
            }
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.admin-area-incharge')
        .controller('AdminAreaInchargeController', AdminAreaInchargeController);


    AdminAreaInchargeController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$element'];
    /** @ngInject */
    function AdminAreaInchargeController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$element)
    {
      var vm = this; 
      var AdminAreaIncharge=AppAPI.AdminAreaIncharge();
      
      var nik= $localStorage.user;
      
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.listselected=[];
      vm.items = [];
      
      vm.deleteData       = deleteData;
      vm.loadData         = loadData; 
      vm.isChecked        = isChecked;
      vm.toggleCheck      = toggleCheck;
      vm.Input            = Input;
      vm.Edit             = Edit;
      vm.exists           = exists;
      vm.isIndeterminate  = isIndeterminate;
      vm.toggleAll        = toggleAll;

      loadData(1);
      getType();
      getArea();

      function closeModal()
      {
          $mdDialog.hide();
      }

      function getArea()
      {
          var resp=AdminAreaIncharge.query({action:'getArea',company:"PM"})
          resp.$promise.then(fetchArea);
          resp.$promise.catch(errorArea); 
      }

      function fetchArea(data)
      {
            vm.listArea=data;
      }

      function errorArea()
      {
            vm.listArea=[];
      }

      function getType()
      { 
          var resp=AdminAreaIncharge.query({action:'getType'})
          resp.$promise.then(fetchType);
          resp.$promise.catch(errorType); 
      }

      function fetchType(data)
      {
            vm.listType=data;
      }

      function errorType()
      {
            vm.listType=[];
      }

      function loadData(pageno)
      {
        var resp=vm.DataTable.loadData(AdminAreaIncharge,pageno,{action:'viewData',area:vm.area,type:vm.type});
        resp.then(function(data) {
            vm.listselected = [];
            vm.items = data.list;
        });
      }
    
      function deleteData(ev) {
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Apakah anda yakin akan menghapus transaksi ini?')
            .textContent('Seluruh data pada transaksi ini akan di hapus dari system.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('Ya')
            .cancel('Tidak');

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=AdminAreaIncharge.delete({action:'deleteData',data:angular.toJson(vm.listselected)});
                response.$promise.then( function(resData) {
                    angular.element.unblockUI();
                    if ( resData.status == 1 ) {
                      var title = 'Success Delete Data';
                      var textContent = resData.pesan;
                      var ariaLabel = 'Success Delete Data';
                    } else {
                      var title = 'Delete Data Failed';
                      var textContent = resData.message;
                      var ariaLabel = 'Delete Data Failed';
                    }
                    
                    showDialogMessage(title,textContent,ariaLabel);
                    loadData(1);
                });
                response.$promise.catch( function(resData) {
                    angular.element.unblockUI();
                    var title = 'Delete Data Failed';
                    var textContent = resData.pesan;
                    var ariaLabel = 'Delete Data Failed';
                    showDialogMessage(title,textContent,ariaLabel,ev);
                })
            }, function() {

            });
        });
      }

      function isChecked(ls)
      {
            return vm.listselected.length === vm.items.length;
      }

      function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listselected.splice(idx, 1);
          }
          else
          {
              vm.listselected.push(ls);
          }
      }

      function toggleAll() {
        if (vm.listselected.length === vm.items.length) {
          vm.listselected = [];
        } else if (vm.listselected.length === 0 || vm.listselected.length > 0) {
          vm.listselected = vm.items.slice(0);
        }
      }

      function isIndeterminate() {
        return vm.listselected.length !== 0 && vm.listselected.length !== vm.items.length;
      }

      function Input(ev,id)
      {
            $mdDialog.show({
                controller         : 'CreateAdminAreaInchargeController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/area-incharge/create.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            }); 

      }
      
      function Edit(ev,data)
      {
            $mdDialog.show({
                controller         : 'EditAdminAreaInchargeController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/area-incharge/create.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  data:data
                }
            });
      }

      function exists(item, list) {
        return list.indexOf(item) > -1;
      }

      function showDialogMessage(title,textContent,ariaLabel,ev) {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              closeModal();
          });
      }

      vm.clearSearchTerm = function() {
        vm.searchTerm = '';
      };
      
      $element.find('input').on('keydown', function(ev) {
          ev.stopPropagation();
      });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.area-manager')
        .controller('areaManagerController', areaManagerController);

    
    /* @ngInject */
    areaManagerController.$inject=['$state','$mdDialog','$log','AppAPI','Auth','DataService','$scope'];
    function areaManagerController($state,$mdDialog,$log,AppAPI,Auth,DataService,$scope) {
        var vm = this;

        var AreaManager=AppAPI.AreaManager();
		
        vm.DataTable= new DataService();
        vm.loadData=loadData;
		vm.listJum=[2,5,25,50,75,100,200];
		vm.editData = editData;
		vm.listAMSelected = [];
		vm.deleteAM = deleteAM;
		vm.detailAction = detailAction;
    	vm.toggle = toggle;
    	vm.onCollapse = onCollapse;
		
        loadData(1);
        //////////////////

        function loadData(pageno)
        {
            /* menggunakan DataTable */
          vm.DataTable.loadData(AreaManager,pageno,{action:'viewData'});
        }
		
		function detailAction(id) {
		  $state.go('app.cb_area-manager-detail', {id:id});	
		}
		
		function editData(id) {
		  $state.go('app.cb_am_edit-am', {id:id});	
		}
		
		function deleteAM(ev) {
			var promise = Auth.setToken();
			promise.then(function() {
				var confirm = $mdDialog.confirm()
				.title('Would you like to delete this list?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
				
				$mdDialog.show(confirm).then(function() {
					angular.element.blockUI();
					var response = AreaManager.delete({action:'delete', data:angular.toJson(vm.listAMSelected)});
					
					response.$promise.then(function(){
						angular.element.unblockUI();
						loadData(1);
					}); 
				}, function() {
					
				});
			});
		}

	    function toggle(item, list) {
	      var idx = list.indexOf(item);
	      if (idx > -1) {
	        list.splice(idx, 1);
	      }
	      else {
	        list.push(item);
	      }
	    }

	    function onCollapse() {
	    	if(vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
	    		vm.DataTable.searchParam = '';
	    		vm.loadData(1);
	    	}
	    }
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-overtime-gw', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_approval_overtime_gw', {
                url    : '/cb/approval-overtime-gw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-overtime-gw/index.html',
                        controller : 'ApprovalOvertimeGwController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.approval-overtime-gw')
        .controller('OvertimeGwViewRejectCommentController', OvertimeGwViewRejectCommentController);

    OvertimeGwViewRejectCommentController.$inject = ['$localStorage','data','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function OvertimeGwViewRejectCommentController($localStorage,data,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.data=data;
        vm.stateView=true;
   
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.approval-overtime-gw')
        .controller('searchEmployeeOvertimeGwController', searchEmployeeOvertimeGwController);

    searchEmployeeOvertimeGwController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','type','DataService','$http'];

    /* @ngInject */
    function searchEmployeeOvertimeGwController($localStorage,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,type,DataService,$http) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Employegw = AppAPI.ApprovalOvertimeGw(); 
        // set constructor form
        Form.setObject(Employegw); 
        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.exist=exist; 
        vm.listSelected=[];
        vm.disable = true; 
        vm.listJum=[2,5,25,50,75,100,200,500,1000];
        vm.closeModal = closeModal;
        vm.DataTable= new DataService();
        vm.isChecked=isChecked;

        vm.items = [];
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.isIndeterminate = isIndeterminate;
        vm.exists = exists;
        vm.listSelected=[];
        vm.approveData=approveData;
        vm.Reject=Reject;
        vm.viewComment=viewComment;
        vm.unrejected=unrejected;
        vm.unapprove=unapprove;
        vm.loadData = loadData
        var nik= $localStorage.user;
        vm.stateEdit=false;
        vm.getEmployee=getEmployee;
        vm.selectedItemChanged=selectedItemChanged;

        vm.isWaiting = vm.isApproved = vm.isReject = false
        switch (type) {
            case 'waiting approval':
                vm.isWaiting = true
                break;
            case 'approved':
                vm.isApproved = true
                break;
            case 'rejected':
                vm.isReject = true
                break;
        }


        function loadData(pageno) {
            var resp=vm.DataTable.loadData(Employegw,pageno,{action:'searchApprovalOvertimeByNik',type:type,ot_date:vm.ot_date,source:'ot-gw',atasan:vm.Form.objForm.atasan});
            resp.then(function(data) {
                vm.listSelected = [];
                vm.items = data.list;
            });
        }


        function closeModal()
        {
            $mdDialog.hide();
        }

        
        function reloadToken(){
            Auth.setToken();
        }

        
        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }

            // console.log(state);
        }

        function isChecked(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = true;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }


        function isIndeterminate() {
            return vm.listSelected.length !== 0 && vm.listSelected.length !== vm.items.length;
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function toggleSelectedAll(state)
        {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }
        }

        function checkAll() {
           vm.listSelected=angular.copy(vm.items);
        }

        function unCheckAll() {
           vm.listSelected=[];
        }

        function isChecked(ls)
        {
            return vm.listSelected.length === vm.items.length;
        }
        
        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event)
        {

            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if ( idx > -1 )
            {
                vm.listSelected.splice(idx, 1);
            }
            else
            {
                vm.listSelected.push(ls);
            }
        }

        function approveData(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
                var promise=Auth.setToken();
                promise.then(function(){
                        var confirm = $mdDialog.confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });      
                    $mdDialog.show(confirm).then(function() {
                        angular.element.blockUI();
                        var ot= new Employegw();
                        ot.data=[];
                        ot.action='approve';
                        ot.nik=nik;   
                        for (i=0;i<jum;i++) {
                            ot.data.push(vm.listSelected[i]);
                        }
                        var idtx=encodeURIComponent(angular.toJson(ids));
                        var response=ot.$save(); 
                        response.then(function(data){
                            successApproved(ev,data);
                            angular.element.unblockUI();
                            vm.listSelected=[];
                        });
                        response.catch(function(data){
                            failedApproved(ev,data.data);
                            angular.element.unblockUI();
                            vm.listSelected=[];
                        });
                    }, function() {
                    });
                });
            }else{
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                    ).then(function(){
                        loadData();
                    }); 
            } 
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Thanks for Approval')
                .textContent(data.message)
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }else{
                    loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Approval')
                .textContent(data.message)
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
            ).then(function(){
                loadData();
            });   
        }

        function Reject(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
                $mdDialog.show({
                    controller         : 'OvertimeGwRejectCommentController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/cb/approval-overtime-gw/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData();
                        vm.listSelected=[];
                    },
                    locals:{
                      id:vm.listSelected
                    }
                });
            }else{
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                ).then(function(){
                    loadData();
                });
            } 
        }

        function viewComment(ev,data)
        {
            $mdDialog.show({
                controller         : 'GhkGwViewRejectCommentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/approval-ghk-gw/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                { 
                    // vm.listOtselected=[];
                    loadData();
                },
                locals:{
                  data:data
                }
            });
        }

        function unapprove(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                    .title('Would you like to Un-Approve this list?')
                    .textContent('All data your selected will be un-approve.')
                    .ariaLabel('un-approve dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });      
                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var ot= new Employegw();
                    ot.data=[];
                    ot.action='unapproved';
                    ot.nik=nik;   
                    for (i=0;i<jum;i++) {
                        ot.data.push({id:vm.listSelected[i].id,
                                    nik:vm.listSelected[i].nik,
                                    is_last_approval:vm.listSelected[i].is_last_approval
                                });
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    response.then(function(data){
                        successApproved(ev,data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                    response.catch(function(data){
                        failedApproved(ev,data.data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                }, function() {
                // $scope.status = 'You decided to keep your debt.';
                });
            });
            }else{
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Attention')
                .textContent('No data selected')
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
                ).then(function(){
                    loadData();
                }); 
            } 
        }

        function unrejected(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                    .title('Would you like to Un-Reject this list?')
                    .textContent('All data your selected will be un-reject.')
                    .ariaLabel('un-reject dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });      
                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var ot= new Employegw();
                    ot.data=[];
                    ot.action='unreject';
                    ot.nik=nik;   
                    for (i=0;i<jum;i++) {
                        ot.data.push({id:vm.listSelected[i].id});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    response.then(function(data){
                        successApproved(ev,data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                    response.catch(function(data){
                        failedApproved(ev,data.data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                }, function() {
                // $scope.status = 'You decided to keep your debt.';
                });
            });
            }else{
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Attention')
                .textContent('No data selected')
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
                ).then(function(){
                    loadData();
                }); 
            } 
        }

        function getEmployee(searchText){

            return $http
           .get(config.api + 'api/approvalovertimegw?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
           .then(function(item) {
             // Map the response object to the data object.
             if(item.data.length===''){
               Form.objForm.empno='';
             } 
               return item.data;
           });
        }

        function selectedItemChanged(employee)
         {
               
              vm.Form.objForm.atasan='';
               vm.Form.objForm.fullname='';
               vm.isDisabled=false;
               vm.Form.objForm.fullname=vm.searchString; 
              if(typeof employee!=='undefined')
              {
                vm.Form.objForm.atasan=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;

              }
         }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.approval-overtime-gw')
        .controller('OvertimeGwRejectCommentController', OvertimeGwRejectCommentController);

    OvertimeGwRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function OvertimeGwRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var ApprovalGw = AppAPI.ApprovalOvertimeGw();

        // set constructor form
        Form.setObject(ApprovalGw);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;
        // console.log(id);

        function saveData(ev,formController)
        { 
            var promise= Form.saveData('reject', formController, ApprovalGw);
            promise.then(function(data){
                if (data.status == 1) {
                    successApproved(ev,data);
                } else {
                    failedApproved(ev,data);
                }
            });

            promise.catch(function(){
                failedApproved(ev,data);
            });
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success save data')
            .textContent(data.message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    // loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed save data')
            .textContent(data.message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                // loadData();
            });
            
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.approval-overtime-gw')
        .controller('DetailApprovalOvertimeGwController', DetailApprovalOvertimeGwController);

    DetailApprovalOvertimeGwController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data','type','DataService'];

    /* @ngInject */
    function DetailApprovalOvertimeGwController($localStorage,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data,type,DataService) {
        var vm = this;
        
        // initial form
        Form.initialForm();

        var Employegw = AppAPI.ApprovalOvertimeGw();

        // set constructor form
        Form.setObject(Employegw);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.closeModal = closeModal;  
        vm.reloadToken=reloadToken; 
        vm.Form.objForm.listEmploye = [];
        vm.isChecked=isChecked;
        vm.exist=exist;
        vm.listSelected=[];
        vm.disable = true;
        
        vm.listJum=[2,5,25,50,75,100,200,500,1000];
        vm.DataTable= new DataService();
        vm.items = [];
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.isIndeterminate = isIndeterminate
        vm.exists = exists
        vm.listSelected=[];
        vm.approveData=approveData;
        vm.Reject=Reject;
        vm.viewComment=viewComment;
        vm.unrejected=unrejected;
        vm.unapprove=unapprove;
        vm.loadData = loadData
        var nik= $localStorage.user;

        
        loadData(1);
        setData();
        
        vm.isWaiting = vm.isApproved = vm.isReject = false
        switch (type) {
            case 'waiting approval':
                vm.isWaiting = true
                break;
            case 'approved':
                vm.isApproved = true
                break;
            case 'rejected':
                vm.isReject = true
                break;
        }

        function loadData(pageno) {
            var resp=vm.DataTable.loadData(Employegw,pageno,{action:'getDetail',id:data.id,isApproval:true,type:type});
            resp.then(function(data) {
                vm.listSelected = [];
                vm.items = data.list;
            });
        }

        function setData()
        {
            vm.Form.objForm.ot_date = new Date(data.ot_date);
            vm.Form.objForm.end_time = data.end_time
            vm.Form.objForm.ot_type = data.ot_type
            vm.Form.objForm.resthour = data.resthour
            vm.Form.objForm.start_time = data.start_time
            vm.Form.objForm.reason = data.reason
            vm.Form.objForm.isafter = data.is_after   
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        
        function reloadToken(){
            Auth.setToken();
        }

        
        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }

            // console.log(state);
        }

        function isChecked(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = true;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function loadDetail(id)
        {
            var response= Employegw.query({action:'getDetail',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {

            angular.forEach(data, function(value, key) {
                var emp = {
                    nik : value.nik,
                    nik_atasan : value.nik_atasan,
                    nama : value.nama
                }
                vm.listSelected.push(value)                
            });
            
        }

        function errorFetchDetail() {
            vm.listSelected = [];
            getDataListEmploye();
        }

        function setEdit (status)
        {
            vm.disable = status;
        }
        
        function isIndeterminate() {
            return vm.listSelected.length !== 0 && vm.listSelected.length !== vm.items.length;
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function toggleSelectedAll(state)
        {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }
        }

        function checkAll() {
           vm.listSelected=angular.copy(vm.items);
        }

        function unCheckAll() {
           vm.listSelected=[];
        }

        function isChecked(ls)
        {
            return vm.listSelected.length === vm.items.length;
        }
        
        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event)
        {

            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if ( idx > -1 )
            {
                vm.listSelected.splice(idx, 1);
            }
            else
            {
                vm.listSelected.push(ls);
            }
        }

        function approveData(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
                var promise=Auth.setToken();
                promise.then(function(){
                        var confirm = $mdDialog.confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });      
                    $mdDialog.show(confirm).then(function() {
                        angular.element.blockUI();
                        var ot= new Employegw();
                        ot.data=[];
                        ot.action='approve';
                        ot.nik=nik;   
                        for (i=0;i<jum;i++) {
                            ot.data.push(vm.listSelected[i]);
                        }
                        var idtx=encodeURIComponent(angular.toJson(ids));
                        var response=ot.$save(); 
                        response.then(function(data){
                            successApproved(ev,data);
                            angular.element.unblockUI();
                            vm.listSelected=[];
                        });
                        response.catch(function(data){
                            failedApproved(ev,data.data);
                            angular.element.unblockUI();
                            vm.listSelected=[];
                        });
                    }, function() {
                    });
                });
            }else{
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                    ).then(function(){
                        loadData();
                    }); 
            } 
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Thanks for Approval')
                .textContent(data.message)
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }else{
                    loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Approval')
                .textContent(data.message)
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
            ).then(function(){
                loadData();
            });   
        }

        function Reject(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
                $mdDialog.show({
                    controller         : 'OvertimeGwRejectCommentController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/cb/approval-overtime-gw/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData();
                        vm.listSelected=[];
                    },
                    locals:{
                      id:vm.listSelected
                    }
                });
            }else{
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                ).then(function(){
                    loadData();
                });
            } 
        }

        function viewComment(ev,data)
        {
            $mdDialog.show({
                controller         : 'GhkGwViewRejectCommentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/approval-ghk-gw/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                { 
                    // vm.listOtselected=[];
                    loadData();
                },
                locals:{
                  data:data
                }
            });
        }

        function unapprove(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                    .title('Would you like to Un-Approve this list?')
                    .textContent('All data your selected will be un-approve.')
                    .ariaLabel('un-approve dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });      
                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var ot= new Employegw();
                    ot.data=[];
                    ot.action='unapproved';
                    ot.nik=nik;   
                    for (i=0;i<jum;i++) {
                        ot.data.push({id:vm.listSelected[i].id,
                                    nik:vm.listSelected[i].nik,
                                    is_last_approval:vm.listSelected[i].is_last_approval
                                });
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    response.then(function(data){
                        successApproved(ev,data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                    response.catch(function(data){
                        failedApproved(ev,data.data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                }, function() {
                // $scope.status = 'You decided to keep your debt.';
                });
            });
            }else{
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Attention')
                .textContent('No data selected')
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
                ).then(function(){
                    loadData();
                }); 
            } 
        }

        function unrejected(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                    .title('Would you like to Un-Reject this list?')
                    .textContent('All data your selected will be un-reject.')
                    .ariaLabel('un-reject dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });      
                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var ot= new Employegw();
                    ot.data=[];
                    ot.action='unreject';
                    ot.nik=nik;   
                    for (i=0;i<jum;i++) {
                        ot.data.push({id:vm.listSelected[i].id});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    response.then(function(data){
                        successApproved(ev,data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                    response.catch(function(data){
                        failedApproved(ev,data.data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                }, function() {
                // $scope.status = 'You decided to keep your debt.';
                });
            });
            }else{
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Attention')
                .textContent('No data selected')
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
                ).then(function(){
                    loadData();
                }); 
            } 
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-overtime-gw')
        .controller('ApprovalOvertimeGwController', ApprovalOvertimeGwController);


    ApprovalOvertimeGwController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function ApprovalOvertimeGwController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.deleteData=deleteData;
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200,500,1000];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Approvalghk=AppAPI.ApprovalOvertimeGw();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var Attendancereport=AppAPI.Attendancereport();
      var Approvalabsence=AppAPI.Approvalabsence();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveOT=approveOT;
      vm.Reject=Reject;
      vm.viewComment=viewComment;
      vm.UnReject=UnReject;
      vm.UnApproved=UnApproved;
      vm.listOtselected=[];
      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();
      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected']; 
      vm.toggleSelectedAll=toggleSelectedAll; 
      vm.exists = exists
      vm.items = [];
      vm.isIndeterminate = isIndeterminate
      vm.detail = detail
      vm.searchEmployee=searchEmployee;
      vm.company=$localStorage.empsite;
      vm.loadDataDepartment = loadDataDepartment
      vm.divisi = vm.department = vm.gedung = 'all';
      vm.unapprove=unapprove;
      vm.unrejected=unrejected;
      vm.isWaiting = true;
      vm.setButton = setButton

      if(vm.tgl >=25 && vm.tgl <=31)
        { 
          if(vm.bulan==12){
            vm.bulan='01';
          }else{
            vm.bulan=vm.bulan+1;
          }
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }

      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
 
      getPeriode();
      loadDataDivision(vm.company);
      loadDataGedung();
        
  function setButton(param)
    {
      // console.log(param);
      if(param=="approved"){
        vm.isWaiting  = false;
        vm.isApproved = true;
        vm.isReject   = false;
      }else if(param=="rejected"){
        vm.isWaiting  = false;
        vm.isApproved = false;
        vm.isReject   = true;
      }else{
        vm.isWaiting  = true;
        vm.isApproved = false;
        vm.isReject   = false;
      }

      loadData(1);
    }

    function getPeriode(){
      var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:'HRIS'});
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data)
    {
      vm.periode=data[0]['periode'];
    }

    function errorfetchPeriode(data)
    {
      console.log('error');
    }

    function loadData(pageno) {
      // angular.element.blockUI();
      //  var response=Approvalghk.query({action:'viewdata'});
      // response.$promise.then(fetchDepartment);
      // response.$promise.catch(errorDepartment);
      var resp=vm.DataTable.loadData(Approvalghk,pageno,{action:'viewdata',bulan:vm.bulan,tahun:vm.tahun,type:vm.type,divisi:vm.divisi,department:vm.department,gedung:vm.gedung});
      resp.then(function(data) {
        vm.listOtselected = [];
        vm.items = data.list;
      });

    }


    function deleteData(ev) {
   
      var promise=Auth.setToken();
      promise.then(function(){
          var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=BU.delete({action:'delete',data:angular.toJson(vm.listBuSelected)});

       response.$promise.then(viewDataBu);
      }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
    });
  
   
    }

    function isChecked(ls)
        {
            // return vm.listOtselected.indexOf(ls) > -1;
            return vm.listOtselected.length === vm.items.length;
        }

    function toggleCheck(ls, event)
    {
        if ( event )
        {
            event.stopPropagation();
        }

        var idx = vm.listOtselected.indexOf(ls);

        if ( idx > -1 )
        {
            vm.listOtselected.splice(idx, 1);
        }
        else
        {
            vm.listOtselected.push(ls);
        }
    }
    function toggleSelectedAll(state)
    {
      if (vm.listOtselected.length === vm.items.length) {
        vm.listOtselected = [];
      } else if (vm.listOtselected.length === 0 || vm.listOtselected.length > 0) {
        vm.listOtselected = vm.items.slice(0);
      } 
    }

      function approveOT(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0){
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Approve this list?')
                .textContent('All data your selected will be approve.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  var ot= new Approvalghk();
                  ot.data=[];
                  ot.action='approve';
                  ot.nik=nik;   
                  for (i=0;i<jum;i++) {
                    ot.data.push(vm.listOtselected[i]);
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save(); 
                  response.then(function(data){
                    if (data.status == 1) {
                      successApproved(ev,data);
                    } else {
                      failedApproved(ev,data);
                    }
                    angular.element.unblockUI();
                    vm.listOtselected=[];
                  });
                  response.catch(function(data){
                    // console.log(data.data);
                    failedApproved(ev,data.data);
                    angular.element.unblockUI();
                    vm.listOtselected=[];
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            }); 
        } 
      }


      function successApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
            if ('moreInfo' in data && data.moreInfo.length>0) {
              $mdDialog.show({
                  controller         : 'logFailGwController',
                  controllerAs       : 'vm',
                  templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                  parent: angular.element(document.body),
                  clickOutsideToClose:true,
                  fullscreen: true,
                  onRemoving:function(element, removePromise)
                  {
                      loadData(1);
                  },
                  locals:{
                    data:data.moreInfo
                  }
              });
            }else{
              loadData(1);
            }
          });
        
      }

      function failedApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

    function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0){
          $mdDialog.show({
              controller         : 'OvertimeGwRejectCommentController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/cb/approval-overtime-gw/comment-reject.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData();
                  vm.listOtselected=[];
              },
              locals:{
                id:vm.listOtselected
              }
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

      function viewComment(ev,data)
      {
        $mdDialog.show({
            controller         : 'GhkGwViewRejectCommentController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-ghk-gw/comment-reject.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            { 
                // vm.listOtselected=[];
                loadData();
            },
            locals:{
              data:data
            }
        });
      }

      function UnReject(ev,id)
      {
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to unreject this list?')
            .textContent('All data you selected will be set to unreject.')
            .ariaLabel('unreject dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

          $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
            var response=Approvalghk.delete({action:'unreject',data:angular.toJson(id)});

            response.$promise.then(function(data){
                angular.element.unblockUI();
                var title = "Information"
                var content = data.message
                var lable = "Information"
                showAlert(title,content,lable)
            });
            response.$promise.catch(function(data){
              angular.element.unblockUI();
              var title = "Warning"
              var content = "Somethin went wrong"
              var lable = "Warning"
              showAlert(title,content,lable)
            });
          });
        });
      }

      function UnApproved(ev,id)
      {
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

          $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
            var response=Approvalghk.delete({action:'unapproved',data:angular.toJson(id)});

            response.$promise.then(function(data){
                angular.element.unblockUI();
                var title = "Information"
                var content = data.message
                var lable = "Information"
                showAlert(title,content,lable)
            });
            response.$promise.catch(function(data){
              angular.element.unblockUI();
              var title = "Warning"
              var content = "Somethin went wrong"
              var lable = "Warning"
              showAlert(title,content,lable)
            });
          });
        });
      } 

      function exists(item, list) {
        return list.indexOf(item) > -1;
      }

      function isIndeterminate() {
        return vm.listOtselected.length !== 0 && vm.listOtselected.length !== vm.items.length;
      }

      function detail(ev, data)
      {
        $mdDialog.show({
            controller         : 'DetailApprovalOvertimeGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-overtime-gw/approval-form.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{
              data:data,
              type:vm.type
            }
        });
      }

      function searchEmployee(ev)
      {
        $mdDialog.show({
            controller         : 'searchEmployeeOvertimeGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-overtime-gw/search-employee-ot.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{ 
              type:vm.type,
              source:'ot-gw'
            }
        });
      }

      function showAlert(title,content,lable)
      {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(content)
          .ariaLabel(lable)
          .ok('close')
          ).then(function(){
            loadData();
        });
      }

      function loadDataDepartment(iddivisi) {
        var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
       response.$promise.then(fetchDepartment);
       response.$promise.catch(errorDepartment);
      }
      function fetchDepartment(data) {
        vm.listDepartment=data;
      }
      function errorDepartment() {
        vm.listDepartment=[];
      }

      function loadDataDivision(idbu) {
          var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
      }
      function fetchDivisiBU(data) {
        vm.listDivision=data;
      }
      function errorDivisiBU() {
        vm.listDivision=[];
      }
      
      function loadDataGedung() {
          var response=Approvalabsence.query({action:'getListGedung'});
        response.$promise.then(fetchGedung);
        response.$promise.catch(errorGedung);
      }
      function fetchGedung(data) {
        vm.listGedung=data;
      }
      function errorGedung() {
        vm.listGedung=[];
      }

      function unapprove(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0){
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Un-Approve this list?')
                .textContent('All data your selected will be un-approve.')
                .ariaLabel('un-approve dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  var ot= new Approvalghk();
                  ot.data=[];
                  ot.action='unapproved';
                  ot.nik=nik;   
                  for (i=0;i<jum;i++) {
                    ot.data.push({id:vm.listOtselected[i].id,
                                  nik:vm.listOtselected[i].nik,
                                  is_last_approval:vm.listOtselected[i].is_last_approval});
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save(); 
                  response.then(function(data){
                      successApproved(ev,data);
                      angular.element.unblockUI();
                      vm.listOtselected=[];
                  });
                  response.catch(function(data){
                    failedApproved(ev,data.data);
                    angular.element.unblockUI();
                    vm.listOtselected=[];
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            }); 
        } 
      }

      function unrejected(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0){
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Un-Reject this list?')
                .textContent('All data your selected will be un-reject.')
                .ariaLabel('un-reject dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  var ot= new Approvalghk();
                  ot.data=[];
                  ot.action='unreject';
                  ot.nik=nik;   
                  for (i=0;i<jum;i++) {
                    ot.data.push({id:vm.listOtselected[i].id});
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save(); 
                  response.then(function(data){
                      successApproved(ev,data);
                      angular.element.unblockUI();
                      vm.listOtselected=[];
                  });
                  response.catch(function(data){
                    failedApproved(ev,data.data);
                    angular.element.unblockUI();
                    vm.listOtselected=[];
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            }); 
        } 
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-ot', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_approval_ot', {
                url    : '/cb/approval-ot',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-ot/approval-ot.html',
                        controller : 'ApprovalotController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
  'use strict';

  angular
    .module('app.cb.approval-ot')
    .controller('ApprovalotController', ApprovalotController);


  ApprovalotController.$inject = ['$timeout', '$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$log', '$filter'];
  /** @ngInject */
  function ApprovalotController($timeout, $state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $log, $filter) {
    var vm = this;

    var translate = $filter('translate');

    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Approvalot = AppAPI.Approvalot();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.setViewTeam = setViewTeam;
    vm.UnApproved = UnApproved;
    vm.Reject = Reject;
    vm.UnReject = UnReject;
    vm.viewComment = viewComment;
    vm.searchComplete = false;
    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];
    vm.toggleSelectedAll = toggleSelectedAll;

    vm.currentot = 0;
    vm.periode = "";


    function loadData(pageno) {
      var resp = vm.DataTable.loadData(Approvalot, pageno, { action: 'viewdata', nik: nik, tglmulai: vm.tglmulai, tglakhir: vm.tglakhir, type: vm.type });
      vm.listOtselected = [];
    }


    function editData(id) {
      $state.go('app.cb_employe_overtime_edit_employe_ot', { id: id });
    }

    function deleteData(ev) {

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = BU.delete({ action: 'delete', data: angular.toJson(vm.listBuSelected) });

          response.$promise.then(viewDataBu);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });


    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.DataTable.list);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];

      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            // console.log(vm.listOtselected);
            var ot = new Approvalot();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            // var jum=vm.listOtselected.length,i,ids=[]; 
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              showDialogInfo(ev, data);
              angular.element.unblockUI();
            });
            response.catch(function (data) {
              // console.log(data.data);
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          loadData(1);
        }
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          loadData(1);
        }
      });

    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        $mdDialog.show({
          controller: 'ApproveOtRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/approval-ot/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function setViewTeam(ev, id) {
      $mdDialog.show({
        controller: 'EmployeeOtteamController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/employe-overtime/employeeot-team.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id
        }
      });
    }

    function UnApproved(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNAPP');
      var note = translate('KPI.MESSAGE.UNAPPNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalot.delete({ action: 'unapproved', data: angular.toJson(id) });

          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function getPeriode() {
      var res = Attendanceemploye.query({ action: 'getPeriode', tahun: vm.tahun, bulan: vm.bulan });
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data) {
      vm.periode = data[0]['periode'];
      // console.log(vm.periode);
      // loadData(1);
      // vm.searchComplete=false;
    }

    function errorfetchPeriode(data) {
      console.log('error');
      // vm.searchComplete=true;
    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'ApprovalotViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ot/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData();
        },
        locals: {
          id: id
        }
      });
    }

    function UnReject(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNREJ');
      var note = translate('KPI.MESSAGE.UNREJNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalot.delete({ action: 'unreject', data: angular.toJson(id) });
          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
          response.$promise.catch(function () {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function succesUnapproved(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnapproved();
      } else {
        showDialog();
      }
      loadData();
    }

    function succesUnreject(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnreject();
      } else {
        showDialogUnreject();
      }
      loadData();
    }

    function failedUnapproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.data)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }
    function showFailedUnapproved() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unapproved Data')
          .textContent('Transaction time expired.')
          .ariaLabel('Transaction time expired')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showFailedUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unreject Data')
          .textContent('Transaction time expired.')
          .ariaLabel('Transaction time expired')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialog() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialogUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Process Data')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.approval-ot')
        .controller('ApprovalotViewRejectCommentController', ApprovalotViewRejectCommentController);

    ApprovalotViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function ApprovalotViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }

    
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.approval-ot')
        .controller('ApproveOtRejectCommentController', ApproveOtRejectCommentController);

    ApproveOtRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function ApproveOtRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        // initial form
        Form.initialForm();

        var Approvalot = AppAPI.Approvalot();

        // set constructor form
        Form.setObject(Approvalot);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;
        // console.log(id);
        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('reject', formController, Approvalot);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-ghk-holiday-gw', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_approval_ghk_holiday_gw', {
                url    : '/cb/approval-ghk-holiday-gw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-ghk-holiday-gw/index.html',
                        controller : 'ApprovalGhkHolidayGwController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-holiday-gw')
        .controller('GhkholidayGwViewRejectCommentController', GhkholidayGwViewRejectCommentController);

    GhkholidayGwViewRejectCommentController.$inject = ['$localStorage','data','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function GhkholidayGwViewRejectCommentController($localStorage,data,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.ApprovalghkholidayGw();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.data=data;
        vm.stateView=true;
   
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-holiday-gw')
        .controller('GhkHolidayGwRejectCommentController', GhkHolidayGwRejectCommentController);

    GhkHolidayGwRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function GhkHolidayGwRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Approvalghk = AppAPI.ApprovalghkholidayGw();

        // set constructor form
        Form.setObject(Approvalghk);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;
        // console.log(id);

        function saveData(ev,formController)
        { 
            var promise= Form.saveData('reject', formController, Approvalghk);
            promise.then(function(data){
                if (data.status == 1) {
                    successApproved(ev,data);
                } else {
                    failedApproved(ev,data);
                }  
            });

            promise.catch(function(){
                failedApproved(ev,data.data);
            });
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success save data')
            .textContent(data.message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    // loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed save data')
            .textContent(data.message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                // loadData();
            });
            
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-ghk-holiday', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_approval_ghk_holiday', {
                url    : '/cb/approval-ghk-holiday',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-ghk-holiday/approval-ghk-holiday.html',
                        controller : 'ApprovalghkholidayController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.approval-ghk-holiday')
        .controller('DetailAppGhkHolidayGwController', DetailAppGhkHolidayGwController);

    DetailAppGhkHolidayGwController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$log', 'config', 'Auth', '$mdToast', 'data', 'type', 'DataService', '$filter'];

    /* @ngInject */
    function DetailAppGhkHolidayGwController($localStorage, $mdDialog, Form, AppAPI, $log, config, Auth, $mdToast, data, type, DataService, $filter) {
        var vm = this;
        var translate = $filter('translate');
        vm.saveData = saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.ApprovalghkholidayGw();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess = false;
        vm.disable = true;
        vm.edit = true;
        vm.setEdit = setEdit;


        vm.closeModal = closeModal;

        vm.reloadToken = reloadToken;
        vm.changeRefshift = changeRefshift;
        vm.changeHoliday = changeHoliday;
        vm.unscheduleshift = false;
        vm.Form.objForm.shifttype = 'group';
        vm.changeShiftType = changeShiftType;
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll = toggleSelectedAll;
        vm.isChecked = isChecked;
        vm.exist = exist;
        vm.toggleCheck = toggleCheck;
        vm.listSelected = [];
        vm.Form.objForm.approval = data.approval

        vm.listJum = [2, 5, 25, 50, 75, 100, 200, 500, 1000];
        vm.DataTable = new DataService();
        vm.items = [];
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.isIndeterminate = isIndeterminate
        vm.exists = exists
        vm.listSelected = [];
        vm.approveData = approveData;
        vm.Reject = Reject;
        vm.viewComment = viewComment;
        vm.unrejected = unrejected;
        vm.unapprove = unapprove;
        vm.loadData = loadData
        var nik = $localStorage.user;


        loadData(1);
        setData();
        LoadLocationshift();

        vm.isWaiting = vm.isApproved = vm.isReject = false
        switch (type) {
            case 'waiting approval':
                vm.isWaiting = true
                break;
            case 'approved':
                vm.isApproved = true
                break;
            case 'rejected':
                vm.isReject = true
                break;
        }

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(Employeghk, pageno, { action: 'getDetailGhk', id: data.id, isApproval: true, type: type });
            resp.then(function (data) {
                vm.listSelected = [];
                vm.items = data.list;
            });
        }

        function setData() {
            vm.Form.objForm.holiday_date = new Date(data.holiday_date);
            changeHoliday();
            vm.Form.objForm.working_date = data.working_date
            vm.Form.objForm.reason = data.reason
            if (data.dws_code == 'NG00') {
                vm.Form.objForm.shifttype = 'nongroup'
                vm.Form.objForm.start_time = data.start_time
                vm.Form.objForm.end_time = data.end_time
                changeShiftType();
            } else {
                vm.Form.objForm.shifttype = 'group'
                vm.Form.objForm.locationid = data.location_id
                changeRefshift(data.location_id)
                var code = data.dws_code + '-' + data.variant
                changeShiftType(code);
            }
        }

        function changeHoliday() {
            // console.log(vm.Form.objForm.holiday_date);
            vm.listworkingday = [];
            var resp = Employeghk.query({ action: 'getWorkingDay', holiday: vm.Form.objForm.holiday_date });
            resp.$promise.then(fetchWorkingDay);
            resp.$promise.catch(errorfetchWorkingDay);

        }

        function fetchWorkingDay(data) {
            vm.listworkingday = data;
            if (vm.listworkingday.length > 0) {
                vm.required = true;
            } else {
                vm.required = false;
            }
            console.log(vm.required);
        }

        function errorfetchWorkingDay() {
            vm.listworkingday = [];
        }

        function changeRefshift(id) {
            if (id == 0) {
                vm.unscheduleshift = true;
                vm.Form.objForm.start_template = 'NG00-Full';
            } else {
                vm.listLocationdetail = [];
                var resp = Employeghk.query({ action: 'getDetailshift', id: id })
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            }
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data) {
            vm.listLocationdetail = data;
        }

        function errorfetchdetailshift() {
            vm.listLocationdetail = [];
        }

        function LoadLocationshift() {
            var response = Employeghk.query({ action: 'getLocationshift', nik: data.request_by });
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
        }

        function fetchLocation(data) {
            vm.listLocation = data;
        }

        function errorFetchLocation() {
            vm.listLocation = [];
        }



        function closeModal() {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan = false;
        }

        function saveData(ev, formController) {
            vm.saveProcess = true;
            vm.Form.objForm.listEmploye = vm.listSelected;
            vm.Form.objForm.id = data.id;

            var promise = Form.saveData('update', formController, Employeghk);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function (data) {
                showDialogInfo(ev, data.data);
            });

        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.message.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    if ('moreInfo' in data && data.moreInfo.length > 0) {
                        $mdDialog.show({
                            controller: 'logFailGwController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: true,
                            onRemoving: function (element, removePromise) {
                                loadData(1);
                            },
                            locals: {
                                data: data.moreInfo
                            }
                        });
                    } else {
                        loadData(1);
                    }
                });
        }
        function showDialog(ev, data) {
            vm.saveProcess = false;
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                // closeModal();
            });
        }

        function showFailed(ev, data) {
            vm.saveProcess = false;
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                // closeModal();
            });
            console.log(data);
        }

        function ChangeDayType() {
            if (vm.Form.objForm.daytype == 'halfday') {
                vm.Form.objForm.end_date = vm.Form.objForm.start_date;
                vm.enddaterequire = false;
                vm.timerequire = true;
                vm.timedisabled = false;
            } else {
                vm.enddaterequire = true;
                vm.timerequire = false;
                vm.timedisabled = true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken() {
            Auth.setToken();
        }

        function changeShiftType(code) {
            if (vm.Form.objForm.shifttype === 'nongroup') {
                vm.Form.objForm.start_template = 'NG00-Full';
                vm.unscheduleshift = true;
            } else {
                vm.Form.objForm.start_template = code;
                vm.unscheduleshift = false;
            }
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }

            // console.log(state);
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.listemploye);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function isChecked(ls) {
            var val = false
            var breakEach = false
            if (vm.listSelected.length > 0) {
                angular.forEach(vm.listSelected, function (value, key) {
                    if (!breakEach) {
                        if (value.nik == ls.nik) {
                            val = true;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function exist(item, list) {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event) {

            if (event) {
                event.stopPropagation();
            }

            var arrTemp = []
            var exist = false
            if (vm.listSelected.length > 0) {
                angular.forEach(vm.listSelected, function (value, key) {

                    if (value.nik != ls.nik) {

                        // arrTemp.push(ls)
                        arrTemp.push(value)
                    } else {
                        exist = true
                    }


                });
                if (!exist) {
                    arrTemp.push(ls)
                }
            } else {
                arrTemp.push(ls)
            }


            vm.listSelected = arrTemp
            // var idx = vm.listSelected.indexOf(ls);

            // if ( idx > -1 )
            // { 
            //     vm.listSelected.splice(idx, 1);
            // }
            // else
            // {
            //     vm.listSelected.push(ls);
            // }
            // console.log('tes');
        }

        function getDataListEmploye() {
            var response = Employeghk.query({ action: 'getEmployelist', nik: data.request_by });
            response.$promise.then(function (data) {
                vm.listemploye = data;
            });

            response.$promise.catch(function (data) {
                $log.info(data);
            });
        }

        function loadDetail(id) {
            var response = Employeghk.query({ action: 'getDetailGhk', id: id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {

            angular.forEach(data, function (value, key) {
                var emp = {
                    nik: value.nik,
                    nik_atasan: value.nik_atasan,
                    nama: value.nama
                }
                vm.listSelected.push(value)
            });
            getDataListEmploye();
        }

        function errorFetchDetail() {
            vm.listSelected = [];
            getDataListEmploye();
        }

        function setEdit(status) {
            vm.disable = status;
        }

        function isIndeterminate() {
            return vm.listSelected.length !== 0 && vm.listSelected.length !== vm.items.length;
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function toggleSelectedAll(state) {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.items);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function isChecked(ls) {
            return vm.listSelected.length === vm.items.length;
        }

        function exist(item, list) {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event) {

            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if (idx > -1) {
                vm.listSelected.splice(idx, 1);
            }
            else {
                vm.listSelected.push(ls);
            }
        }

        function approveData(ev) {
            var jum = vm.listSelected.length, i, ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var ot = new Employeghk();
                        ot.data = [];
                        ot.action = 'approve';
                        ot.nik = nik;
                        for (i = 0; i < jum; i++) {
                            ot.data.push(vm.listSelected[i]);
                        }
                        var idtx = encodeURIComponent(angular.toJson(ids));
                        var response = ot.$save();
                        response.then(function (data) {
                            angular.element.unblockUI();
                            showDialogInfo(ev, data);
                            vm.listSelected = [];
                        });
                        response.catch(function (data) {
                            angular.element.unblockUI();
                            showDialogInfo(ev, data.data);
                            vm.listSelected = [];
                        });
                    }, function () {
                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function successApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Thanks for Approval')
                    .textContent(data.message)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                if ('moreInfo' in data && data.moreInfo.length > 0) {
                    $mdDialog.show({
                        controller: 'logFailGwController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            loadData(1);
                        },
                        locals: {
                            data: data.moreInfo
                        }
                    });
                } else {
                    loadData(1);
                }
            });

        }

        function failedApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Approval')
                    .textContent(data.message)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                loadData();
            });
        }

        function Reject(ev) {
            var jum = vm.listSelected.length, i, ids = [];
            if (jum > 0) {
                $mdDialog.show({
                    controller: 'GhkHalfdayGwRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/cb/approval-ghk-halfday-gw/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        loadData();
                        vm.listSelected = [];
                    },
                    locals: {
                        id: vm.listSelected
                    }
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function viewComment(ev, data) {
            $mdDialog.show({
                controller: 'GhkGwViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/approval-ghk-gw/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    data: data
                }
            });
        }

        function unapprove(ev) {
            var jum = vm.listSelected.length, i, ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Un-Approve this list?')
                        .textContent('All data your selected will be un-approve.')
                        .ariaLabel('un-approve dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var ot = new Employeghk();
                        ot.data = [];
                        ot.action = 'unapproved';
                        ot.nik = nik;
                        for (i = 0; i < jum; i++) {
                            ot.data.push({
                                id: vm.listSelected[i].id,
                                nik: vm.listSelected[i].nik,
                                is_last_approval: vm.listSelected[i].is_last_approval,
                                dws_code: vm.listSelected[i].dws_code
                            });
                        }
                        var idtx = encodeURIComponent(angular.toJson(ids));
                        var response = ot.$save();
                        response.then(function (data) {
                            showDialogInfo(ev, data);
                            angular.element.unblockUI();
                            vm.listSelected = [];
                        });
                        response.catch(function (data) {
                            showDialogInfo(ev, data.data);
                            angular.element.unblockUI();
                            vm.listSelected = [];
                        });
                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function unrejected(ev) {
            var jum = vm.listSelected.length, i, ids = [];
            // console.log(vm.listSelected);
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Un-Reject this list?')
                        .textContent('All data your selected will be un-reject.')
                        .ariaLabel('un-reject dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var ot = new Employeghk();
                        ot.data = [];
                        ot.action = 'unreject';
                        ot.nik = nik;
                        for (i = 0; i < jum; i++) {
                            ot.data.push({
                                id: vm.listSelected[i].id,
                                working_date: vm.listSelected[i].working_date,
                                holiday_date: vm.listSelected[i].holiday_date,
                                nik: vm.listSelected[i].nik
                            });
                        }
                        var idtx = encodeURIComponent(angular.toJson(ids));
                        var response = ot.$save();
                        response.then(function (data) {
                            showDialogInfo(ev, data);
                            angular.element.unblockUI();
                            vm.listSelected = [];
                        });
                        response.catch(function (data) {
                            showDialogInfo(ev, data.data);
                            angular.element.unblockUI();
                            vm.listSelected = [];
                        });
                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.approval-ghk-holiday-gw')
    .controller('ApprovalGhkHolidayGwController', ApprovalGhkHolidayGwController);


  ApprovalGhkHolidayGwController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage'];
  /** @ngInject */
  function ApprovalGhkHolidayGwController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage) {
    var vm = this;
    vm.deleteData = deleteData;
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200, 1000];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Approvalghk = AppAPI.ApprovalghkholidayGw();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var Attendancereport = AppAPI.Attendancereport();
    var Approvalabsence = AppAPI.Approvalabsence();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.Reject = Reject;
    vm.viewComment = viewComment;
    vm.UnReject = UnReject;
    vm.UnApproved = UnApproved;
    vm.listOtselected = [];
    // var date=new Date();
    // vm.tahun=date.getFullYear();
    // vm.bulan=date.getMonth()+1;
    // vm.getPeriode=getPeriode;
    // vm.tgl=date.getDate();
    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.exists = exists
    vm.items = [];
    vm.isIndeterminate = isIndeterminate
    vm.detail = detail
    vm.company = $localStorage.empsite;
    vm.loadDataDepartment = loadDataDepartment
    vm.divisi = vm.department = vm.gedung = 'all';
    vm.unapprove = unapprove;
    vm.unrejected = unrejected;
    vm.isWaiting = true;
    vm.setButton = setButton
    vm.searchEmployee = searchEmployee;

    // if(vm.tgl >=25 && vm.tgl <=31)
    //   { 
    //     if(vm.bulan==12){
    //       vm.bulan='01';
    //     }else{
    //       vm.bulan=vm.bulan+1;
    //     }
    //   }
    //   if(vm.bulan < 10){
    //     vm.bulan='0'+vm.bulan;
    //   }

    // vm.listtahun=[2014,2015,2016,2017,2018,2019];
    // vm.listbulan=[{name:'January',value:'01'},
    //               {name:'February',value:'02'},
    //               {name:'Maret',value:'03'},
    //               {name:'April',value:'04'},
    //               {name:'Mei',value:'05'},
    //               {name:'June',value:'06'},
    //               {name:'July',value:'07'},
    //               {name:'August',value:'08'},
    //               {name:'September',value:'09'},
    //               {name:'October',value:'10'},
    //               {name:'November',value:'11'},
    //               {name:'Desember',value:'12'}];

    // getPeriode();
    loadDataDivision(vm.company);
    loadDataGedung();

    /////////////////////
    function setButton(param) {
      if (param == "approved") {
        vm.isWaiting = false;
        vm.isApproved = true;
        vm.isReject = false;
      } else if (param == "rejected") {
        vm.isWaiting = false;
        vm.isApproved = false;
        vm.isReject = true;
      } else {
        vm.isWaiting = true;
        vm.isApproved = false;
        vm.isReject = false;
      }
      loadData(1);
    }

    // function getPeriode(){
    //   var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:'HRIS'});
    //   res.$promise.then(fetchPeriode);
    //   res.$promise.catch(errorfetchPeriode);
    // }

    // function fetchPeriode(data)
    // {
    //   vm.periode=data[0]['periode'];
    //   vm.datePeriod=data[0]['datePeriode'];
    // }

    // function errorfetchPeriode(data)
    // {
    //   console.log('error');
    // }

    function loadData(pageno) {
      // angular.element.blockUI();
      //  var response=Approvalghk.query({action:'viewdata'});
      // response.$promise.then(fetchDepartment);
      // response.$promise.catch(errorDepartment);
      vm.listOtselected = [];
      var resp = vm.DataTable.loadData(Approvalghk, pageno, { action: 'viewdata', tglmulai: vm.tglmulai, tglakhir: vm.tglakhir, type: vm.type, divisi: vm.divisi, department: vm.department, gedung: vm.gedung });
      resp.then(function (data) {
        vm.items = data.list;

      });

    }


    function deleteData(ev) {

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = BU.delete({ action: 'delete', data: angular.toJson(vm.listBuSelected) });

          response.$promise.then(viewDataBu);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });


    }

    function isChecked(ls) {
      // return vm.listOtselected.indexOf(ls) > -1;
      return vm.listOtselected.length === vm.items.length;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }
    function toggleSelectedAll(state) {
      if (vm.listOtselected.length === vm.items.length) {
        vm.listOtselected = [];
      } else if (vm.listOtselected.length === 0 || vm.listOtselected.length > 0) {
        vm.listOtselected = vm.items.slice(0);
      }
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      // console.log(vm.listOtselected);
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Approve this list?')
            .textContent('All data your selected will be approve.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            // console.log(vm.listOtselected);
            var ot = new Approvalghk();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              showDialogInfo(ev, data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
            response.catch(function (data) {
              // console.log(data.data);
              showDialogInfo(ev, data.data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }


    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });

    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        $mdDialog.show({
          controller: 'GhkHolidayGwRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/approval-ghk-holiday-gw/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function viewComment(ev, data) {
      $mdDialog.show({
        controller: 'GhkholidayGwViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-holiday-gw/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          // vm.listOtselected=[];
          loadData();
        },
        locals: {
          data: data
        }
      });
    }

    function UnReject(ev, id) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalghk.delete({ action: 'unreject', data: angular.toJson(id) });

          response.$promise.then(function (data) {
            angular.element.unblockUI();
            var title = "Information"
            var content = data.message
            var lable = "Information"
            showAlert(title, content, lable)
          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            var title = "Warning"
            var content = "Somethin went wrong"
            var lable = "Warning"
            showAlert(title, content, lable)
          });
        });
      });
    }

    function UnApproved(ev, id) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to unapprove this list?')
          .textContent('All data you selected will be set to unapproved.')
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalghk.delete({ action: 'unapproved', data: angular.toJson(id) });

          response.$promise.then(function (data) {
            angular.element.unblockUI();
            var title = "Information"
            var content = data.message
            var lable = "Information"
            showAlert(title, content, lable)
          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            var title = "Warning"
            var content = "Somethin went wrong"
            var lable = "Warning"
            showAlert(title, content, lable)
          });
        });
      });
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.listOtselected.length !== 0 && vm.listOtselected.length !== vm.items.length;
    }

    function detail(ev, data) {
      $mdDialog.show({
        controller: 'DetailAppGhkHolidayGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-holiday-gw/approval-form.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data,
          type: vm.type
        }
      });
    }

    function showAlert(title, content, lable) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(content)
          .ariaLabel(lable)
          .ok('close')
      ).then(function () {
        loadData();
      });
    }

    function loadDataDepartment(iddivisi) {
      var response = Attendancereport.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }
    function fetchDepartment(data) {
      vm.listDepartment = data;
    }
    function errorDepartment() {
      vm.listDepartment = [];
    }

    function loadDataDivision(idbu) {
      var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }
    function fetchDivisiBU(data) {
      vm.listDivision = data;
    }
    function errorDivisiBU() {
      vm.listDivision = [];
    }

    function loadDataGedung() {
      var response = Approvalabsence.query({ action: 'getListGedung' });
      response.$promise.then(fetchGedung);
      response.$promise.catch(errorGedung);
    }
    function fetchGedung(data) {
      vm.listGedung = data;
    }
    function errorGedung() {
      vm.listGedung = [];
    }

    function unapprove(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Un-Approve this list?')
            .textContent('All data your selected will be un-approve.')
            .ariaLabel('un-approve dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new Approvalghk();
            ot.data = [];
            ot.action = 'unapproved';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push({
                id: vm.listOtselected[i].id,
                nik: vm.listOtselected[i].nik,
                is_last_approval: vm.listOtselected[i].is_last_approval,
                shift_id: vm.listOtselected[i].emp_shift_id,
                abs_id: vm.listOtselected[i].emp_absence_id,
                dws_code: vm.listOtselected[i].dws_code
              });
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              successApproved(ev, data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function unrejected(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Un-Reject this list?')
            .textContent('All data your selected will be un-reject.')
            .ariaLabel('un-reject dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new Approvalghk();
            ot.data = [];
            ot.action = 'unreject';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push({ id: vm.listOtselected[i].id });
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              successApproved(ev, data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function searchEmployee(ev) {
      $mdDialog.show({
        controller: 'searchEmployeeGhkGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-gw/search-employee.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          type: vm.type,
          replacementType: '1',
          source: 'ghk-gw'
        }
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.message.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-holiday')
        .controller('GhkholidayViewRejectCommentController', GhkholidayViewRejectCommentController);

    GhkholidayViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function GhkholidayViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.approval-ghk-holiday')
        .controller('GhkHolidayRejectCommentController', GhkHolidayRejectCommentController);

    GhkHolidayRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function GhkHolidayRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;
        var translate = $filter('translate');
        // initial form
        Form.initialForm();

        var Approvalghk = AppAPI.Approvalghkholiday();

        // set constructor form
        Form.setObject(Approvalghk);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('reject', formController, Approvalghk);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.approval-ghk-holiday')
    .controller('ApprovalghkholidayController', ApprovalghkholidayController);


  ApprovalghkholidayController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function ApprovalghkholidayController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {
    var vm = this;

    var translate = $filter('translate');

    vm.deleteData = deleteData;
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Approvalghk = AppAPI.Approvalghkholiday();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.Reject = Reject;
    vm.viewComment = viewComment;
    vm.UnReject = UnReject;
    vm.UnApproved = UnApproved;
    vm.listOtselected = [];
    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];
    vm.toggleSelectedAll = toggleSelectedAll;


    // loadData(1);
    // getPeriode();

    /////////////////////


    function loadData(pageno) {
      vm.listOtselected = [];
      var resp = vm.DataTable.loadData(Approvalghk, pageno, { action: 'viewdata', tglmulai: vm.tglmulai, tglakhir: vm.tglakhir, type: vm.type });
    }


    function deleteData(ev) {

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = BU.delete({ action: 'delete', data: angular.toJson(vm.listBuSelected) });

          response.$promise.then(viewDataBu);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });


    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }
    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.DataTable.list);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      // console.log(vm.listOtselected);
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            // console.log(vm.listOtselected);
            var ot = new Approvalghk();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
            response.catch(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }


    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          loadData(1);
        }
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });

    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        //   var promise=Auth.setToken();
        //   promise.then(function(){
        //       var confirm = $mdDialog.confirm()
        //       .title('Would you like to Reject this list?')
        //       .textContent('All data your selected will be Reject.')
        //       .ariaLabel('delete dialog')
        //       .targetEvent(ev)
        //       .ok('YES')
        //       .cancel('no');
        //   $mdDialog.show({
        //         multiple: true
        //    });      
        //   $mdDialog.show(confirm).then(function() {
        //         angular.element.blockUI();
        //         // console.log(vm.listOtselected);
        //         var ot= new Approvalghk();
        //         ot.data=[];
        //         ot.action='reject';   
        //         for (i=0;i<jum;i++) {
        //           ot.data.push({id:vm.listOtselected[i].id});
        //         }
        //         var idtx=encodeURIComponent(angular.toJson(ids));
        //         var response=ot.$save(); 
        //         //var response=tm.$delete({action:'approve'});
        //         response.then(loadData);
        //     }, function() {
        //    // $scope.status = 'You decided to keep your debt.';
        //   });
        // });
        $mdDialog.show({
          controller: 'GhkHolidayRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/approval-ghk-holiday/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'GhkholidayViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-holiday/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          // vm.listOtselected=[];
          loadData();
        },
        locals: {
          id: id
        }
      });
    }

    function UnReject(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNREJ');
      var note = translate('KPI.MESSAGE.UNREJNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalghk.delete({ action: 'unreject', data: angular.toJson(id) });
          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
          response.$promise.catch(function () {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function UnApproved(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNAPP');
      var note = translate('KPI.MESSAGE.UNAPPNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalghk.delete({ action: 'unapproved', data: angular.toJson(id) });

          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function succesUnapproved(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnapproved();
      } else {
        showDialog();
      }
      loadData();
    }

    function succesUnreject(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnreject();
      } else {
        showDialogUnreject();
      }
      loadData();
    }

    function failedUnapproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.data)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }

    function showFailedUnapproved() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unapproved Data')
          .textContent('Transaction Locked By System.')
          .ariaLabel('Transaction Locked By System')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showFailedUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unreject Data')
          .textContent('Transaction Locked By System.')
          .ariaLabel('Transaction Locked By System')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialog() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialogUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Process Data')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-ghk-gw', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_approval_ghk_gw', {
                url    : '/cb/approval-ghk-gw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-ghk-gw/index.html',
                        controller : 'ApprovalGhkGwController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-gw')
        .controller('GhkGwViewRejectCommentController', GhkGwViewRejectCommentController);

    GhkGwViewRejectCommentController.$inject = ['$localStorage','data','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function GhkGwViewRejectCommentController($localStorage,data,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.data=data;
        vm.stateView=true;
   
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-ghk-halfday-gw', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_approval_ghk_halfday_gw', {
                url    : '/cb/approval-ghk-halfday-gw',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-ghk-halfday-gw/index.html',
                        controller : 'ApprovalGhkHalfdayGwController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-halfday-gw')
        .controller('GhkHalfdayGwRejectCommentController', GhkHalfdayGwRejectCommentController);

    GhkHalfdayGwRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function GhkHalfdayGwRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Approvalghk = AppAPI.ApprovalGhkHalfdayGw();

        // set constructor form
        Form.setObject(Approvalghk);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;
        
        function saveData(ev,formController)
        { 
            var promise= Form.saveData('reject', formController, Approvalghk);
            promise.then(function(data){
                if (data.status == 1) {
                    successApproved(ev,data);
                } else {
                    failedApproved(ev,data);
                }
            });

            promise.catch(function(){
                failedApproved(ev,data)  
            });
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success save data')
            .textContent(data.message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    // loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed save data')
            .textContent(data.message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                // loadData();
            });
            
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-halfday-gw')
        .controller('DetailApprovalGhkHalfdayGwController', DetailApprovalGhkHalfdayGwController);

    DetailApprovalGhkHalfdayGwController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data','type','DataService'];

    /* @ngInject */
    function DetailApprovalGhkHalfdayGwController($localStorage,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data,type,DataService) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.ApprovalGhkHalfdayGw();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;
        vm.disable=true;
        vm.edit = true;
        vm.setEdit = setEdit;
 

        vm.closeModal = closeModal;  

        vm.reloadToken=reloadToken; 
        vm.changeRefshift=changeRefshift; 
        vm.unscheduleshift=false; 
        vm.Form.objForm.shifttype='group';
        vm.changeShiftType=changeShiftType;
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll=toggleSelectedAll;
        vm.exist=exist;
        vm.listSelected=[];
        vm.Form.objForm.approval = data.approval
        
        vm.listJum=[2,5,25,50,75,100,200,500,1000];
        vm.DataTable= new DataService();
        vm.items = [];
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.isIndeterminate = isIndeterminate
        vm.exists = exists
        vm.listSelected=[];
        vm.approveData=approveData;
        vm.Reject=Reject;
        vm.viewComment=viewComment;
        vm.unrejected=unrejected;
        vm.unapprove=unapprove;
        vm.loadData = loadData
        var nik= $localStorage.user;

        
        loadData(1);
        setData();
        LoadLocationshift();

        vm.isWaiting = vm.isApproved = vm.isReject = false
        switch (type) {
            case 'waiting approval':
                vm.isWaiting = true
                break;
            case 'approved':
                vm.isApproved = true
                break;
            case 'rejected':
                vm.isReject = true
                break;
        }

        function loadData(pageno) {
            var resp=vm.DataTable.loadData(Employeghk,pageno,{action:'getDetail',id:data.id,isApproval:true,type:type});
            resp.then(function(data) {
                vm.listSelected = [];
                vm.items = data.list;
            });
        }

        function setData()
        {
            vm.Form.objForm.working_date = new Date(data.working_date);
            vm.Form.objForm.reason = data.reason
            if ( data.dws_code == 'NG00' ) {
                vm.Form.objForm.shifttype = 'nongroup'
                vm.Form.objForm.start_time = data.start_time
                vm.Form.objForm.end_time = data.end_time
                changeShiftType();
            } else {
                vm.Form.objForm.shifttype = 'group'
                vm.Form.objForm.locationid = data.location_id
                changeRefshift(data.location_id)
                var code = data.idshift+'-Half'    
                changeShiftType(code);
            }
        }

        function changeRefshift(id)
        { 
            if(id==0){
                vm.unscheduleshift=true;
                vm.Form.objForm.start_template='NG00-Full';
            }else{
                vm.listLocationdetail=[];
                var resp=Employeghk.query({action:'getDetailshift',id:id})
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            } 
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function LoadLocationshift() {
            var response=Employeghk.query({action:'getLocationshift',nik:data.request_by});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

        function fetchLocation(data) {
            vm.listLocation=data;
        }

        function errorFetchLocation() {
            vm.listLocation=[];
        } 
 
      

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            vm.Form.objForm.listEmploye = vm.listSelected;
            vm.Form.objForm.id = data.id;

            var promise= Form.saveData('update', formController, Employeghk);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
          console.log(data);
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
                vm.timedisabled=false;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
                vm.timedisabled=true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function changeShiftType(code)
        {
            if(vm.Form.objForm.shifttype==='nongroup')
            {
                vm.Form.objForm.start_template='NG00-Full';
                vm.unscheduleshift=true;
            }else{
                vm.Form.objForm.start_template=code;
                vm.unscheduleshift=false;
            }
        }

        function getDataListEmploye()
        {
            var response= Employeghk.query({action:'getEmployelist',nik:data.request_by});
                    response.$promise.then(function(data){
                    vm.listemploye=data;
                });

                response.$promise.catch(function(data){
                    $log.info(data);
                });    
        }

        function loadDetail(id)
        {
            var response= Employeghk.query({action:'getDetailGhk',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {

            angular.forEach(data, function(value, key) {
                var emp = {
                    nik : value.nik,
                    nik_atasan : value.nik_atasan,
                    nama : value.nama
                }
                vm.listSelected.push(value)                
            });
            getDataListEmploye();
        }

        function errorFetchDetail() {
            vm.listSelected = [];
            getDataListEmploye();
        }

        function setEdit (status)
        {
            vm.disable = status;
        }
        
        function isIndeterminate() {
            return vm.listSelected.length !== 0 && vm.listSelected.length !== vm.items.length;
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function toggleSelectedAll(state)
        {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }
        }

        function checkAll() {
           vm.listSelected=angular.copy(vm.items);
        }

        function unCheckAll() {
           vm.listSelected=[];
        }

        function isChecked(ls)
        {
            return vm.listSelected.length === vm.items.length;
        }
        
        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event)
        {

            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if ( idx > -1 )
            {
                vm.listSelected.splice(idx, 1);
            }
            else
            {
                vm.listSelected.push(ls);
            }
        }

        function approveData(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
                var promise=Auth.setToken();
                promise.then(function(){
                        var confirm = $mdDialog.confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });      
                    $mdDialog.show(confirm).then(function() {
                        angular.element.blockUI();
                        var ot= new Employeghk();
                        ot.data=[];
                        ot.action='approve';
                        ot.nik=nik;   
                        for (i=0;i<jum;i++) {
                            ot.data.push(vm.listSelected[i]);
                        }
                        var idtx=encodeURIComponent(angular.toJson(ids));
                        var response=ot.$save(); 
                        response.then(function(data){
                            successApproved(ev,data);
                            angular.element.unblockUI();
                            vm.listSelected=[];
                        });
                        response.catch(function(data){
                            failedApproved(ev,data.data);
                            angular.element.unblockUI();
                            vm.listSelected=[];
                        });
                    }, function() {
                    });
                });
            }else{
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                    ).then(function(){
                        loadData();
                    }); 
            } 
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Thanks for Approval')
                .textContent(data.message)
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }else{
                    loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Approval')
                .textContent(data.message)
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
            ).then(function(){
                loadData();
            });   
        }

        function Reject(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
                $mdDialog.show({
                    controller         : 'GhkHalfdayGwRejectCommentController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/cb/approval-ghk-halfday-gw/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData();
                        vm.listSelected=[];
                    },
                    locals:{
                        id:vm.listSelected
                    }
                });
            }else{
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                ).then(function(){
                    loadData();
                });
            } 
        }

        function viewComment(ev,data)
        {
            $mdDialog.show({
                controller         : 'GhkGwViewRejectCommentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/approval-ghk-gw/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                { 
                    loadData();
                },
                locals:{
                    data:data
                }
            });
        }

        function unapprove(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                    .title('Would you like to Un-Approve this list?')
                    .textContent('All data your selected will be un-approve.')
                    .ariaLabel('un-approve dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });      
                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var ot= new Employeghk();
                    ot.data=[];
                    ot.action='unapproved';
                    ot.nik=nik;   
                    for (i=0;i<jum;i++) {
                        ot.data.push({id:vm.listSelected[i].id,
                                    nik:vm.listSelected[i].nik,
                                    is_last_approval:vm.listSelected[i].is_last_approval,
                                    dws_code:vm.listSelected[i].dws_code
                                });
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    response.then(function(data){
                        successApproved(ev,data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                    response.catch(function(data){
                        failedApproved(ev,data.data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                }, function() {
                // $scope.status = 'You decided to keep your debt.';
                });
            });
            }else{
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Attention')
                .textContent('No data selected')
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
                ).then(function(){
                    loadData();
                }); 
            } 
        }

        function unrejected(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                    .title('Would you like to Un-Reject this list?')
                    .textContent('All data your selected will be un-reject.')
                    .ariaLabel('un-reject dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });      
                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var ot= new Employeghk();
                    ot.data=[];
                    ot.action='unreject';
                    ot.nik=nik;   
                    for (i=0;i<jum;i++) {
                        ot.data.push({id:vm.listSelected[i].id,
                                    working_date:vm.listSelected[i].working_date,
                                    holiday_date:vm.listSelected[i].holiday_date,
                                    nik:vm.listSelected[i].nik});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    response.then(function(data){
                        successApproved(ev,data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                    response.catch(function(data){
                        failedApproved(ev,data.data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                }, function() {
                // $scope.status = 'You decided to keep your debt.';
                });
            });
            }else{
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Attention')
                .textContent('No data selected')
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
                ).then(function(){
                    loadData();
                }); 
            } 
        }

        function showAlert(title,content,lable)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(title)
            .textContent(content)
            .ariaLabel(lable)
            .ok('close')
            ).then(function(){
                loadData();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-halfday-gw')
        .controller('DetailApprovalGhkHalfdayGwControllerbak', DetailApprovalGhkHalfdayGwControllerbak);

    DetailApprovalGhkHalfdayGwControllerbak.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data'];

    /* @ngInject */
    function DetailApprovalGhkHalfdayGwControllerbak($localStorage,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.ApprovalGhkHalfdayGw();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;
        vm.disable=true;
        vm.edit = true;
        vm.setEdit = setEdit;
 

        vm.closeModal = closeModal;  

        vm.reloadToken=reloadToken; 
        vm.changeRefshift=changeRefshift; 
        vm.unscheduleshift=false; 
        vm.Form.objForm.shifttype='group';
        vm.changeShiftType=changeShiftType;
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.exist=exist;
        vm.toggleCheck = toggleCheck;
        vm.listSelected=[];
        vm.Form.objForm.approval = data.approval
        
        
        loadDetail(data.id);
        setData();
        LoadLocationshift();

        ////////////////f

        function setData()
        {
            vm.Form.objForm.halfday_date = new Date(data.date);
            vm.Form.objForm.description = data.description
            if ( data.dws_code == 'NG00' ) {
                vm.Form.objForm.shifttype = 'nongroup'
                vm.Form.objForm.start_time = data.start_time
                vm.Form.objForm.end_time = data.end_time
                changeShiftType();
            } else {
                vm.Form.objForm.shifttype = 'group'
                vm.Form.objForm.locationid = data.location_id
                changeRefshift(data.location_id)
                var code = data.idshift+'-Half'    
                changeShiftType(code);
            }
        }

        function changeRefshift(id)
        { 
            if(id==0){
                vm.unscheduleshift=true;
                vm.Form.objForm.start_template='NG00-Full';
            }else{
                vm.listLocationdetail=[];
                var resp=Employeghk.query({action:'getDetailshift',id:id})
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            } 
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function LoadLocationshift() {
            var response=Employeghk.query({action:'getLocationshift',nik:data.request_by});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

        function fetchLocation(data) {
            vm.listLocation=data;
        }

        function errorFetchLocation() {
            vm.listLocation=[];
        } 
 
      

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            vm.Form.objForm.listEmploye = vm.listSelected;
            vm.Form.objForm.id = data.id;

            var promise= Form.saveData('update', formController, Employeghk);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
          console.log(data);
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
                vm.timedisabled=false;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
                vm.timedisabled=true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function changeShiftType(code)
        {
            if(vm.Form.objForm.shifttype==='nongroup')
            {
                vm.Form.objForm.start_template='NG00-Full';
                vm.unscheduleshift=true;
            }else{
                vm.Form.objForm.start_template=code;
                vm.unscheduleshift=false;
            }
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }

            // console.log(state);
        }

        function checkAll() {
           vm.listSelected=angular.copy(vm.listemploye);
        }

        function unCheckAll() {
           vm.listSelected=[];
        }

        function isChecked(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = true;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event)
        {

            if ( event )
            {
                event.stopPropagation();
            }

            var arrTemp = []
            var exist = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    
                        if ( value.nik != ls.nik ) {
                            
                            // arrTemp.push(ls)
                            arrTemp.push(value)
                        } else {
                            exist = true
                        }    
                    
                    
                });
                if ( !exist ) {
                    arrTemp.push(ls)
                }
            } else {
                arrTemp.push(ls)
            }


            vm.listSelected = arrTemp
            // var idx = vm.listSelected.indexOf(ls);

            // if ( idx > -1 )
            // { 
            //     vm.listSelected.splice(idx, 1);
            // }
            // else
            // {
            //     vm.listSelected.push(ls);
            // }
          // console.log('tes');
        }

        function getDataListEmploye()
        {
            var response= Employeghk.query({action:'getEmployelist',nik:data.request_by});
                    response.$promise.then(function(data){
                    vm.listemploye=data;
                });

                response.$promise.catch(function(data){
                    $log.info(data);
                });    
        }

        function loadDetail(id)
        {
            var response= Employeghk.query({action:'getDetail',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {

            angular.forEach(data, function(value, key) {
                var emp = {
                    nik : value.nik,
                    nik_atasan : value.nik_atasan,
                    nama : value.nama
                }
                vm.listSelected.push(value)                
            });
            getDataListEmploye();
        }

        function errorFetchDetail() {
            vm.listSelected = [];
            getDataListEmploye();
        }

        function setEdit (status)
        {
            vm.disable = status;
        }
        

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-ghk-halfday-gw')
        .controller('ApprovalGhkHalfdayGwController', ApprovalGhkHalfdayGwController);


    ApprovalGhkHalfdayGwController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function ApprovalGhkHalfdayGwController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.deleteData=deleteData;
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200,500,1000];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Approvalghk=AppAPI.ApprovalGhkHalfdayGw();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var Attendancereport=AppAPI.Attendancereport();
      var Approvalabsence=AppAPI.Approvalabsence();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveOT=approveOT;
      vm.Reject=Reject;
      vm.viewComment=viewComment;
      vm.UnReject=UnReject;
      vm.UnApproved=UnApproved;
      vm.listOtselected=[];
       
      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected']; 
      vm.toggleSelectedAll=toggleSelectedAll; 
      vm.exists = exists
      vm.items = [];
      vm.isIndeterminate = isIndeterminate
      vm.detail = detail
      vm.company=$localStorage.empsite;
      vm.loadDataDepartment = loadDataDepartment
      vm.divisi = vm.department = vm.gedung = 'all';
      vm.unapprove=unapprove;
      vm.unrejected=unrejected;
      vm.isWaiting = true;
      vm.setButton = setButton
      vm.searchEmployee=searchEmployee;
 
      // loadDataDivision(vm.company);
      // loadDataGedung();
    
    function setButton(param)
    {
      if(param=="approved"){
        vm.isWaiting  = false;
        vm.isApproved = true;
        vm.isReject   = false;
      }else if(param=="rejected"){
        vm.isWaiting  = false;
        vm.isApproved = false;
        vm.isReject   = true;
      }else{
        vm.isWaiting  = true;
        vm.isApproved = false;
        vm.isReject   = false;
      }
      loadData(1);
    }
    // function getPeriode(){
    //   var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:'HRIS'});
    //   res.$promise.then(fetchPeriode);
    //   res.$promise.catch(errorfetchPeriode);
    // }

    // function fetchPeriode(data)
    // {
    //   vm.periode=data[0]['periode'];
    //   vm.datePeriod=data[0]['datePeriode'];
    // }

    // function errorfetchPeriode(data)
    // {
    //   console.log('error');
    // }
    
    function loadData(pageno) {
       vm.listOtselected = [];
      var resp=vm.DataTable.loadData(Approvalghk,pageno,{action:'viewdata',tglmulai:vm.tglmulai,tglakhir:vm.tglakhir,type:vm.type,divisi:vm.divisi,department:vm.department,gedung:vm.gedung});
      resp.then(function(data) {
        
        vm.items = data.list;
      });

    }


    function deleteData(ev) {
   
      var promise=Auth.setToken();
      promise.then(function(){
          var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=BU.delete({action:'delete',data:angular.toJson(vm.listBuSelected)});

       response.$promise.then(viewDataBu);
      }, function() {
         // $scope.status = 'You decided to keep your debt.';
      });
    });
  
   
    }

    function isChecked(ls)
        {
            // return vm.listOtselected.indexOf(ls) > -1;
            return vm.listOtselected.length === vm.items.length;
        }

    function toggleCheck(ls, event)
    {
        if ( event )
        {
            event.stopPropagation();
        }

        var idx = vm.listOtselected.indexOf(ls);

        if ( idx > -1 )
        {
            vm.listOtselected.splice(idx, 1);
        }
        else
        {
            vm.listOtselected.push(ls);
        }
    }
    function toggleSelectedAll(state)
    {
      if (vm.listOtselected.length === vm.items.length) {
        vm.listOtselected = [];
      } else if (vm.listOtselected.length === 0 || vm.listOtselected.length > 0) {
        vm.listOtselected = vm.items.slice(0);
      } 
    }

      function approveOT(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        // console.log(vm.listOtselected);
        if(jum>0){
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Approve this list?')
                .textContent('All data your selected will be approve.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  // console.log(vm.listOtselected);
                  var ot= new Approvalghk();
                  ot.data=[];
                  ot.action='approve';
                  ot.nik=nik;   
                  for (i=0;i<jum;i++) {
                    ot.data.push(vm.listOtselected[i]);
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save(); 
                  response.then(function(data){
                      successApproved(ev,data);
                      angular.element.unblockUI();
                      vm.listOtselected=[];
                  });
                  response.catch(function(data){
                    // console.log(data.data);
                    failedApproved(ev,data.data);
                    angular.element.unblockUI();
                    vm.listOtselected=[];
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            }); 
        } 
      }


      function successApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

      function failedApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

      function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0){
          $mdDialog.show({
              controller         : 'GhkHalfdayGwRejectCommentController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/cb/approval-ghk-halfday-gw/comment-reject.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData();
                  vm.listOtselected=[];
              },
              locals:{
                id:vm.listOtselected
              }
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

      function viewComment(ev,data)
      {
        $mdDialog.show({
            controller         : 'GhkGwViewRejectCommentController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-ghk-gw/comment-reject.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            { 
                // vm.listOtselected=[];
                loadData();
            },
            locals:{
              data:data
            }
        });
      }

      function UnReject(ev,id)
      {
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to unreject this list?')
            .textContent('All data you selected will be set to unreject.')
            .ariaLabel('unreject dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

          $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
            var response=Approvalghk.delete({action:'unreject',data:angular.toJson(id)});

            response.$promise.then(function(data){
                angular.element.unblockUI();
                var title = "Information"
                var content = data.message
                var lable = "Information"
                showAlert(title,content,lable)
            });
            response.$promise.catch(function(data){
              angular.element.unblockUI();
              var title = "Warning"
              var content = "Somethin went wrong"
              var lable = "Warning"
              showAlert(title,content,lable)
            });
          });
        });
      }

      function UnApproved(ev,id)
      {
        var promise=Auth.setToken();
        promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

          $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
            var response=Approvalghk.delete({action:'unapproved',data:angular.toJson(id)});

            response.$promise.then(function(data){
                angular.element.unblockUI();
                var title = "Information"
                var content = data.message
                var lable = "Information"
                showAlert(title,content,lable)
            });
            response.$promise.catch(function(data){
              angular.element.unblockUI();
              var title = "Warning"
              var content = "Somethin went wrong"
              var lable = "Warning"
              showAlert(title,content,lable)
            });
          });
        });
      } 

      function exists(item, list) {
        return list.indexOf(item) > -1;
      }

      function isIndeterminate() {
        return vm.listOtselected.length !== 0 && vm.listOtselected.length !== vm.items.length;
      }

      function detail(ev, data)
      {
        $mdDialog.show({
            controller         : 'DetailApprovalGhkHalfdayGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-ghk-halfday-gw/approval-form.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{
              data:data,
              type:vm.type
            }
        });
      }

      function showAlert(title,content,lable)
      {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(content)
          .ariaLabel(lable)
          .ok('close')
          ).then(function(){
            loadData();
        });
      }

      function loadDataDepartment(iddivisi) {
        var response=Attendancereport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
       response.$promise.then(fetchDepartment);
       response.$promise.catch(errorDepartment);
      }
      function fetchDepartment(data) {
        vm.listDepartment=data;
      }
      function errorDepartment() {
        vm.listDepartment=[];
      }

      function loadDataDivision(idbu) {
          var response=Attendancereport.query({action:'viewDivisiBu',idbu:idbu});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
      }
      function fetchDivisiBU(data) {
        vm.listDivision=data;
      }
      function errorDivisiBU() {
        vm.listDivision=[];
      }
      
      function loadDataGedung() {
          var response=Approvalabsence.query({action:'getListGedung'});
        response.$promise.then(fetchGedung);
        response.$promise.catch(errorGedung);
      }
      function fetchGedung(data) {
        vm.listGedung=data;
      }
      function errorGedung() {
        vm.listGedung=[];
      }

      function unapprove(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0){
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Un-Approve this list?')
                .textContent('All data your selected will be un-approve.')
                .ariaLabel('un-approve dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  var ot= new Approvalghk();
                  ot.data=[];
                  ot.action='unapproved';
                  ot.nik=nik;   
                  for (i=0;i<jum;i++) {
                    ot.data.push({id:vm.listOtselected[i].id});
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save(); 
                  response.then(function(data){
                      successApproved(ev,data);
                      angular.element.unblockUI();
                      vm.listOtselected=[];
                  });
                  response.catch(function(data){
                    failedApproved(ev,data.data);
                    angular.element.unblockUI();
                    vm.listOtselected=[];
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            }); 
        } 
      }

      function unrejected(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0){
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Un-Reject this list?')
                .textContent('All data your selected will be un-reject.')
                .ariaLabel('un-reject dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  var ot= new Approvalghk();
                  ot.data=[];
                  ot.action='unreject';
                  ot.nik=nik;   
                  for (i=0;i<jum;i++) {
                    ot.data.push({id:vm.listOtselected[i].id});
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save(); 
                  response.then(function(data){
                      successApproved(ev,data);
                      angular.element.unblockUI();
                      vm.listOtselected=[];
                  });
                  response.catch(function(data){
                    failedApproved(ev,data.data);
                    angular.element.unblockUI();
                    vm.listOtselected=[];
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            }); 
        } 
      }

      function searchEmployee(ev)
      {
        $mdDialog.show({
            controller         : 'searchEmployeeGhkGwController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-ghk-gw/search-employee.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            {
                loadData(1);
            },
            locals:{ 
              type:vm.type,
              replacementType:'2',
              source:'ghk-gw'
            }
        });
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-ghk-halfday', [])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_approval_ghk_halfday', {
                url    : '/cb/approval-ghk-halfday',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-ghk-halfday/index.html',
                        controller : 'ApprovalGhkHalfdayController as vm'
                    }
                }
            });
    }
})(); 
(function () {
  'use strict';

  angular
    .module('app.cb.approval-ghk-halfday')
    .controller('ApprovalGhkHalfdayController', ApprovalGhkHalfdayController);


  ApprovalGhkHalfdayController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function ApprovalGhkHalfdayController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Approvalghk = AppAPI.ApprovalGhkHalfday();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.Reject = Reject;
    vm.viewComment = viewComment;
    vm.UnReject = UnReject;
    vm.UnApproved = UnApproved;
    var title = ''
    var message = ''

    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];
    vm.toggleSelectedAll = toggleSelectedAll;



    /////////////////////

    function loadData(pageno) {
      vm.listOtselected = [];
      var resp = vm.DataTable.loadData(Approvalghk, pageno, { action: 'viewdata', tglmulai: vm.tglmulai, tglakhir: vm.tglakhir, type: vm.type });
      vm.listGhk = [];
    }


    function editData(id) {
      $state.go('app.cb_employe_overtime_edit_employe_ot', { id: id });
    }

    function deleteData(ev) {

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = BU.delete({ action: 'delete', data: angular.toJson(vm.listBuSelected) });

          response.$promise.then(viewDataBu);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });


    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.DataTable.list);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            // console.log(vm.listOtselected);
            var ot = new Approvalghk();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data);

            });
            response.catch(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);

            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          loadData(1);
        }
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });

    }

    function showDialogMessage(ev, title, message) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(message)
          .ariaLabel(title)
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        $mdDialog.show({
          controller: 'GhkHalfdayRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/approval-ghk-halfday/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'GhkHalfdayViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-halfday/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          vm.listOtselected = [];
        },
        locals: {
          id: id
        }
      });
    }

    function UnReject(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNREJ');
      var note = translate('KPI.MESSAGE.UNREJNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalghk.delete({ action: 'unreject', data: angular.toJson(id) });
          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data)

          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function UnApproved(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNAPP');
      var note = translate('KPI.MESSAGE.UNAPPNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalghk.delete({ action: 'unapproved', data: angular.toJson(id) });
          // console.log(response);
          response.$promise.then(function (data) {

            angular.element.unblockUI();
            showDialogInfo(ev, data);

          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);

          });

        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }
    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-halfday')
        .controller('GhkHalfdayViewRejectCommentController', GhkHalfdayViewRejectCommentController);

    GhkHalfdayViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function GhkHalfdayViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.Form.objForm.note_approval = id.rejected_comment
        vm.stateView=true;
    

        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.approval-ghk-halfday')
        .controller('GhkHalfdayRejectCommentController', GhkHalfdayRejectCommentController);

    GhkHalfdayRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function GhkHalfdayRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;
        var translate = $filter('translate');
        // initial form
        Form.initialForm();

        var Approvalghk = AppAPI.ApprovalGhkHalfday();

        // set constructor form
        Form.setObject(Approvalghk);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;
        // console.log(id);
        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }
        function saveData(ev, formController) {
            var promise = Form.saveData('reject', formController, Approvalghk);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-gw')
        .controller('GhkGwViewRejectCommentController', GhkGwViewRejectCommentController);

    GhkGwViewRejectCommentController.$inject = ['$localStorage','data','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function GhkGwViewRejectCommentController($localStorage,data,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.data=data;
        vm.stateView=true;
   
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.approval-ghk-gw')
        .controller('searchEmployeeGhkGwController', searchEmployeeGhkGwController);

    searchEmployeeGhkGwController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$log', 'config', 'Auth', '$mdToast', 'type', 'source', 'replacementType', 'DataService', '$http', '$filter'];

    /* @ngInject */
    function searchEmployeeGhkGwController($localStorage, $mdDialog, Form, AppAPI, $log, config, Auth, $mdToast, type, source, replacementType, DataService, $http, $filter) {
        var vm = this;
        // initial form
        Form.initialForm();
        var translate = $filter('translate');
        var Employegw = AppAPI.ApprovalOvertimeGw();
        var Employeghk = AppAPI.ApprovalGhkGw();
        // set constructor form
        Form.setObject(Employeghk);
        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.exist = exist;
        vm.listSelected = [];
        vm.disable = true;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200, 500, 1000];
        vm.closeModal = closeModal;
        vm.DataTable = new DataService();
        vm.isChecked = isChecked;

        vm.items = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.isIndeterminate = isIndeterminate;
        vm.exists = exists;
        vm.listSelected = [];
        vm.approveData = approveData;
        vm.Reject = Reject;
        vm.viewComment = viewComment;
        vm.unrejected = unrejected;
        vm.unapprove = unapprove;
        vm.loadData = loadData
        var nik = $localStorage.user;
        vm.stateEdit = false;
        vm.getEmployee = getEmployee;
        vm.selectedItemChanged = selectedItemChanged;

        vm.isWaiting = vm.isApproved = vm.isReject = false
        switch (type) {
            case 'waiting approval':
                vm.isWaiting = true
                break;
            case 'approved':
                vm.isApproved = true
                break;
            case 'rejected':
                vm.isReject = true
                break;
        }

        function loadData(pageno) {
            var resp = vm.DataTable.loadData(Employegw, pageno, { action: 'searchApprovalOvertimeByNik', type: type, ot_date: vm.ot_date, source: source, replacementType: replacementType, atasan: vm.Form.objForm.atasan });
            resp.then(function (data) {
                vm.listSelected = [];
                vm.items = data.list;
            });
        }


        function closeModal() {
            $mdDialog.hide();
        }


        function reloadToken() {
            Auth.setToken();
        }


        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }

            // console.log(state);
        }

        function isChecked(ls) {
            var val = false
            var breakEach = false
            if (vm.listSelected.length > 0) {
                angular.forEach(vm.listSelected, function (value, key) {
                    if (!breakEach) {
                        if (value.nik == ls.nik) {
                            val = true;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function exist(item, list) {
            return list.indexOf(item) > -1;
        }


        function isIndeterminate() {
            return vm.listSelected.length !== 0 && vm.listSelected.length !== vm.items.length;
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function toggleSelectedAll(state) {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.items);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function isChecked(ls) {
            return vm.listSelected.length === vm.items.length;
        }

        function exist(item, list) {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event) {

            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if (idx > -1) {
                vm.listSelected.splice(idx, 1);
            }
            else {
                vm.listSelected.push(ls);
            }
        }

        function approveData(ev) {
            var jum = vm.listSelected.length, i, ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var ot = new Employeghk();
                        ot.data = [];
                        ot.action = 'approve';
                        ot.nik = nik;
                        for (i = 0; i < jum; i++) {
                            ot.data.push(vm.listSelected[i]);
                        }
                        var idtx = encodeURIComponent(angular.toJson(ids));
                        var response = ot.$save();
                        response.then(function (data) {
                            showDialogInfo(ev, data);
                            angular.element.unblockUI();
                            vm.listSelected = [];
                        });
                        response.catch(function (data) {
                            showDialogInfo(ev, data.data);
                            angular.element.unblockUI();
                            vm.listSelected = [];
                        });
                    }, function () {
                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function successApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Thanks for Approval')
                    .textContent(data.message)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                if ('moreInfo' in data && data.moreInfo.length > 0) {
                    $mdDialog.show({
                        controller: 'logFailGwController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            loadData(1);
                        },
                        locals: {
                            data: data.moreInfo
                        }
                    });
                } else {
                    loadData(1);
                }
            });

        }

        function failedApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Approval')
                    .textContent(data.message)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                loadData();
            });
        }
        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.message.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    if ('moreInfo' in data && data.moreInfo.length > 0) {
                        $mdDialog.show({
                            controller: 'logFailGwController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: true,
                            onRemoving: function (element, removePromise) {
                                loadData(1);
                            },
                            locals: {
                                data: data.moreInfo
                            }
                        });
                    } else {
                        loadData(1);
                    }
                });
        }

        function Reject(ev) {
            var jum = vm.listSelected.length, i, ids = [];
            if (jum > 0) {
                $mdDialog.show({
                    controller: 'GhkHalfdayGwRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/cb/approval-ghk-halfday-gw/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        loadData(1);
                        vm.listSelected = [];
                    },
                    locals: {
                        id: vm.listSelected
                    }
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function viewComment(ev, data) {
            $mdDialog.show({
                controller: 'GhkGwViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/approval-ghk-gw/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    data: data
                }
            });
        }

        function unapprove(ev) {
            var jum = vm.listSelected.length, i, ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Un-Approve this list?')
                        .textContent('All data your selected will be un-approve.')
                        .ariaLabel('un-approve dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var ot = new Employeghk();
                        ot.data = [];
                        ot.action = 'unapproved';
                        ot.nik = nik;
                        for (i = 0; i < jum; i++) {
                            ot.data.push({
                                id: vm.listSelected[i].id,
                                nik: vm.listSelected[i].nik,
                                is_last_approval: vm.listSelected[i].is_last_approval,
                                shift_id: vm.listSelected[i].emp_shift_id,
                                abs_id: vm.listSelected[i].emp_absence_id,
                                dws_code: vm.listSelected[i].dws_code,
                                requested_at: vm.listSelected[i].requested_at,
                                days_limit_approval: vm.listSelected[i].days_limit_approval
                            });
                        }
                        var idtx = encodeURIComponent(angular.toJson(ids));
                        var response = ot.$save();
                        response.then(function (data) {
                            successApproved(ev, data);
                            angular.element.unblockUI();
                            vm.listSelected = [];
                        });
                        response.catch(function (data) {
                            failedApproved(ev, data.data);
                            angular.element.unblockUI();
                            vm.listSelected = [];
                        });
                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function unrejected(ev) {
            var jum = vm.listSelected.length, i, ids = [];
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Un-Reject this list?')
                        .textContent('All data your selected will be un-reject.')
                        .ariaLabel('un-reject dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var ot = new Employeghk();
                        ot.data = [];
                        ot.action = 'unreject';
                        ot.nik = nik;
                        for (i = 0; i < jum; i++) {
                            ot.data.push({
                                id: vm.listSelected[i].id,
                                working_date: vm.listSelected[i].working_date,
                                holiday_date: vm.listSelected[i].holiday_date,
                                nik: vm.listSelected[i].nik
                            });
                        }
                        var idtx = encodeURIComponent(angular.toJson(ids));
                        var response = ot.$save();
                        response.then(function (data) {
                            successApproved(ev, data);
                            angular.element.unblockUI();
                            vm.listSelected = [];
                        });
                        response.catch(function (data) {
                            failedApproved(ev, data.data);
                            angular.element.unblockUI();
                            vm.listSelected = [];
                        });
                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function fetchdetailshift(data) {
            vm.listLocationdetail = data;
        }

        function errorfetchdetailshift() {
            vm.listLocationdetail = [];
        }

        function getEmployee(searchText) {

            return $http
                .get(config.api + 'api/approvalovertimegw?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.atasan = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.atasan = employee.empno;
                vm.Form.objForm.fullname = employee.fullname;
                vm.isDisabled = true;

            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-gw')
        .controller('GhkGwRejectCommentController', GhkGwRejectCommentController);

    GhkGwRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function GhkGwRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Approvalghk = AppAPI.ApprovalGhkGw();

        // set constructor form
        Form.setObject(Approvalghk);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;
        // console.log(id);

        function saveData(ev,formController)
        { 
            var promise= Form.saveData('reject', formController, Approvalghk);
            promise.then(function(data){
                if (data.status == 1) {
                    successApproved(ev,data);
                } else {
                    failedApproved(ev,data);
                }  
            });

            promise.catch(function(){
                failedApproved(ev,data.data);
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
        
        function successApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success save data')
            .textContent(data.message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    // loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed save data')
            .textContent(data.message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                // loadData();
            });
            
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk-gw')
        .controller('DetailApprovalGhkGwController', DetailApprovalGhkGwController);

    DetailApprovalGhkGwController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','$log','config','Auth','$mdToast','data','type','DataService'];

    /* @ngInject */
    function DetailApprovalGhkGwController($localStorage,$mdDialog,Form,AppAPI,$log,config,Auth,$mdToast,data,type,DataService) {
        var vm = this;
        vm.saveData=saveData;
        // initial form
        Form.initialForm();

        var Employeghk = AppAPI.ApprovalGhkGw();

        // set constructor form
        Form.setObject(Employeghk);

        // set form to controller
        vm.Form = Form;
        vm.required = false;
        vm.saveProcess=false;
        vm.disable=true;
        vm.edit = true;
        vm.setEdit = setEdit;
 

        vm.closeModal = closeModal;  

        vm.reloadToken=reloadToken; 
        vm.changeRefshift=changeRefshift; 
        vm.changeHoliday=changeHoliday;
        vm.unscheduleshift=false; 
        vm.Form.objForm.shifttype='group';
        vm.changeShiftType=changeShiftType;
        vm.Form.objForm.listEmploye = [];

        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.exist=exist;
        vm.toggleCheck = toggleCheck;
        vm.listSelected=[];
        vm.Form.objForm.approval = data.approval
        
        vm.listJum=[2,5,25,50,75,100,200,500,1000];
        vm.DataTable= new DataService();
        vm.items = [];
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.isIndeterminate = isIndeterminate
        vm.exists = exists
        vm.listSelected=[];
        vm.approveData=approveData;
        vm.Reject=Reject;
        vm.viewComment=viewComment;
        vm.unrejected=unrejected;
        vm.unapprove=unapprove;
        vm.loadData = loadData
        var nik= $localStorage.user;

        
        loadData(1);
        setData();
        LoadLocationshift();

        vm.isWaiting = vm.isApproved = vm.isReject = false
        switch (type) {
            case 'waiting approval':
                vm.isWaiting = true
                break;
            case 'approved':
                vm.isApproved = true
                break;
            case 'rejected':
                vm.isReject = true
                break;
        }

        function loadData(pageno) {
            var resp=vm.DataTable.loadData(Employeghk,pageno,{action:'getDetailGhk',id:data.id,isApproval:true,type:type});
            resp.then(function(data) {
                vm.listSelected = [];
                vm.items = data.list;
            });
        }

        function setData()
        {
            vm.Form.objForm.working_date = new Date(data.working_date);
            vm.Form.objForm.reason = data.reason
            if ( data.dws_code == 'NG00' ) {
                vm.Form.objForm.shifttype = 'nongroup'
                vm.Form.objForm.start_time = data.start_time
                vm.Form.objForm.end_time = data.end_time
                changeShiftType();
            } else {
                vm.Form.objForm.shifttype = 'group'
                vm.Form.objForm.locationid = data.location_id
                changeRefshift(data.location_id)
                var code = data.dws_code+'-'+data.variant    
                changeShiftType(code);
            }
        }

        function changeHoliday()
        {
            // console.log(vm.Form.objForm.holiday_date);
            vm.listworkingday=[];
            var resp=Employeghk.query({action:'getWorkingDay',holiday:vm.Form.objForm.holiday_date});
            resp.$promise.then(fetchWorkingDay);
            resp.$promise.catch(errorfetchWorkingDay);

        }

        function fetchWorkingDay(data)
        {
            vm.listworkingday=data;
            if(vm.listworkingday.length > 0) {
                vm.required = true;
            } else {
                vm.required = false;
            }
            console.log(vm.required);
        }

        function errorfetchWorkingDay()
        {
             vm.listworkingday=[];
        } 

        function changeRefshift(id)
        { 
            if(id==0){
                vm.unscheduleshift=true;
                vm.Form.objForm.start_template='NG00-Full';
            }else{
                vm.listLocationdetail=[];
                var resp=Employeghk.query({action:'getDetailshift',id:id})
                resp.$promise.then(fetchdetailshift);
                resp.$promise.catch(errorfetchdetailshift);
            } 
            // console.log(vm.unscheduleshift);
        }

        function fetchdetailshift(data)
        {
             vm.listLocationdetail=data;
        }

        function errorfetchdetailshift()
        {
             vm.listLocationdetail=[];
        }

        function LoadLocationshift() {
            var response=Employeghk.query({action:'getLocationshift',nik:data.request_by});
            response.$promise.then(fetchLocation);
            response.$promise.catch(errorFetchLocation);
          }

        function fetchLocation(data) {
            vm.listLocation=data;
        }

        function errorFetchLocation() {
            vm.listLocation=[];
        } 
 
      

       function closeModal()
        {
            $mdDialog.hide();
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function saveData(ev,formController)
        {
            vm.saveProcess=true;
            vm.Form.objForm.listEmploye = vm.listSelected;
            vm.Form.objForm.id = data.id;

            var promise= Form.saveData('update', formController, Employeghk);
            promise.then(function(data){
                if (data.status == 1) {
                    showDialog(ev,data);
                } else {
                    showFailed(ev,data);
                }
            });

            promise.catch(function(data){
                showFailed(ev,data.data);
            });

        }

        function showDialog(ev,data)
        {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
        }

        function showFailed(ev,data) {
            vm.saveProcess=false;
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                // closeModal();
            });
          console.log(data);
        }

        function ChangeDayType()
        {
            if(vm.Form.objForm.daytype=='halfday'){
                vm.Form.objForm.end_date=vm.Form.objForm.start_date;
                vm.enddaterequire=false;
                vm.timerequire=true;
                vm.timedisabled=false;
            }else{
                vm.enddaterequire=true;
                vm.timerequire=false;
                vm.timedisabled=true;
            }
            // console.log(vm.Form.objForm.daytype);
        }

        function reloadToken(){
            Auth.setToken();
        }

        function changeShiftType(code)
        {
            if(vm.Form.objForm.shifttype==='nongroup')
            {
                vm.Form.objForm.start_template='NG00-Full';
                vm.unscheduleshift=true;
            }else{
                vm.Form.objForm.start_template=code;
                vm.unscheduleshift=false;
            }
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }

            // console.log(state);
        }

        function checkAll() {
           vm.listSelected=angular.copy(vm.listemploye);
        }

        function unCheckAll() {
           vm.listSelected=[];
        }

        function isChecked(ls)
        {
            var val = false
            var breakEach = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    if ( !breakEach ) {
                        if ( value.nik == ls.nik ) {
                            val = true;
                            breakEach = true

                        }
                    }
                });
            }

            return val;

            // return vm.listSelected.indexOf(ls) > -1;
        }

        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event)
        {

            if ( event )
            {
                event.stopPropagation();
            }

            var arrTemp = []
            var exist = false
            if ( vm.listSelected.length > 0 ) {
                angular.forEach(vm.listSelected, function(value, key) {
                    
                        if ( value.nik != ls.nik ) {
                            
                            // arrTemp.push(ls)
                            arrTemp.push(value)
                        } else {
                            exist = true
                        }    
                    
                    
                });
                if ( !exist ) {
                    arrTemp.push(ls)
                }
            } else {
                arrTemp.push(ls)
            }


            vm.listSelected = arrTemp
            // var idx = vm.listSelected.indexOf(ls);

            // if ( idx > -1 )
            // { 
            //     vm.listSelected.splice(idx, 1);
            // }
            // else
            // {
            //     vm.listSelected.push(ls);
            // }
          // console.log('tes');
        }

        function getDataListEmploye()
        {
            var response= Employeghk.query({action:'getEmployelist',nik:data.request_by});
                    response.$promise.then(function(data){
                    vm.listemploye=data;
                });

                response.$promise.catch(function(data){
                    $log.info(data);
                });    
        }

        function loadDetail(id)
        {
            var response= Employeghk.query({action:'getDetailGhk',id:id});
                response.$promise.then(fetchDetail);
                response.$promise.catch(errorFetchDetail);    
        }

        function fetchDetail(data) {

            angular.forEach(data, function(value, key) {
                var emp = {
                    nik : value.nik,
                    nik_atasan : value.nik_atasan,
                    nama : value.nama
                }
                vm.listSelected.push(value)                
            });
            getDataListEmploye();
        }

        function errorFetchDetail() {
            vm.listSelected = [];
            getDataListEmploye();
        }

        function setEdit (status)
        {
            vm.disable = status;
        }
        
        function isIndeterminate() {
            return vm.listSelected.length !== 0 && vm.listSelected.length !== vm.items.length;
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function toggleSelectedAll(state)
        {
            if (vm.listSelected.length === vm.items.length) {
                vm.listSelected = [];
            } else if (vm.listSelected.length === 0 || vm.listSelected.length > 0) {
                vm.listSelected = vm.items.slice(0);
            }
        }

        function checkAll() {
           vm.listSelected=angular.copy(vm.items);
        }

        function unCheckAll() {
           vm.listSelected=[];
        }

        function isChecked(ls)
        {
            return vm.listSelected.length === vm.items.length;
        }
        
        function exist(item,list)
        {
            return list.indexOf(item) > -1;
        }

        function toggleCheck(ls, event)
        {

            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listSelected.indexOf(ls);

            if ( idx > -1 )
            {
                vm.listSelected.splice(idx, 1);
            }
            else
            {
                vm.listSelected.push(ls);
            }
        }

        function approveData(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
                var promise=Auth.setToken();
                promise.then(function(){
                        var confirm = $mdDialog.confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });      
                    $mdDialog.show(confirm).then(function() {
                        angular.element.blockUI();
                        var ot= new Employeghk();
                        ot.data=[];
                        ot.action='approve';
                        ot.nik=nik;   
                        for (i=0;i<jum;i++) {
                            ot.data.push(vm.listSelected[i]);
                        }
                        var idtx=encodeURIComponent(angular.toJson(ids));
                        var response=ot.$save(); 
                        response.then(function(data){
                            successApproved(ev,data);
                            angular.element.unblockUI();
                            vm.listSelected=[];
                        });
                        response.catch(function(data){
                            failedApproved(ev,data.data);
                            angular.element.unblockUI();
                            vm.listSelected=[];
                        });
                    }, function() {
                    });
                });
            }else{
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                    ).then(function(){
                        loadData();
                    }); 
            } 
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Thanks for Approval')
                .textContent(data.message)
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            loadData(1);
                        },
                        locals:{
                          data:data.moreInfo
                        }
                    });
                }else{
                    loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Approval')
                .textContent(data.message)
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
            ).then(function(){
                loadData();
            });   
        }

        function Reject(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
                $mdDialog.show({
                    controller         : 'GhkHalfdayGwRejectCommentController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/cb/approval-ghk-halfday-gw/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                        vm.listSelected=[];
                    },
                    locals:{
                        id:vm.listSelected
                    }
                });
            }else{
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                ).then(function(){
                    loadData();
                });
            } 
        }

        function viewComment(ev,data)
        {
            $mdDialog.show({
                controller         : 'GhkGwViewRejectCommentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/approval-ghk-gw/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                { 
                    loadData();
                },
                locals:{
                    data:data
                }
            });
        }

        function unapprove(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                    .title('Would you like to Un-Approve this list?')
                    .textContent('All data your selected will be un-approve.')
                    .ariaLabel('un-approve dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });      
                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var ot= new Employeghk();
                    ot.data=[];
                    ot.action='unapproved';
                    ot.nik=nik;   
                    for (i=0;i<jum;i++) {
                        ot.data.push({id:vm.listSelected[i].id,
                                        nik:vm.listSelected[i].nik,
                                        is_last_approval:vm.listSelected[i].is_last_approval,
                                        shift_id:vm.listSelected[i].emp_shift_id,
                                        abs_id:vm.listSelected[i].emp_absence_id,
                                        dws_code:vm.listSelected[i].dws_code,
                                        requested_at:vm.listSelected[i].requested_at,
                                        days_limit_approval:vm.listSelected[i].days_limit_approval
                                    });
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    response.then(function(data){
                        successApproved(ev,data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                    response.catch(function(data){
                        failedApproved(ev,data.data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                }, function() {
                // $scope.status = 'You decided to keep your debt.';
                });
            });
            }else{
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Attention')
                .textContent('No data selected')
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
                ).then(function(){
                    loadData();
                }); 
            } 
        }

        function unrejected(ev)
        {
            var jum=vm.listSelected.length,i,ids=[];
            if(jum>0){
            var promise=Auth.setToken();
            promise.then(function(){
                    var confirm = $mdDialog.confirm()
                    .title('Would you like to Un-Reject this list?')
                    .textContent('All data your selected will be un-reject.')
                    .ariaLabel('un-reject dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('no');
                $mdDialog.show({
                    multiple: true
                });      
                $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    var ot= new Employeghk();
                    ot.data=[];
                    ot.action='unreject';
                    ot.nik=nik;   
                    for (i=0;i<jum;i++) {
                        ot.data.push({id:vm.listSelected[i].id,
                                    working_date:vm.listSelected[i].working_date,
                                    holiday_date:vm.listSelected[i].holiday_date,
                                    nik:vm.listSelected[i].nik});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    response.then(function(data){
                        successApproved(ev,data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                    response.catch(function(data){
                        failedApproved(ev,data.data);
                        angular.element.unblockUI();
                        vm.listSelected=[];
                    });
                }, function() {
                // $scope.status = 'You decided to keep your debt.';
                });
            });
            }else{
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Attention')
                .textContent('No data selected')
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
                ).then(function(){
                    loadData();
                }); 
            } 
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.approval-ghk-gw')
    .controller('ApprovalGhkGwController', ApprovalGhkGwController);


  ApprovalGhkGwController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage'];
  /** @ngInject */
  function ApprovalGhkGwController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage) {

    var vm = this;
    vm.deleteData = deleteData;
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200, 500, 1000];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Approvalghk = AppAPI.ApprovalGhkGw();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var Attendancereport = AppAPI.Attendancereport();
    var Approvalabsence = AppAPI.Approvalabsence();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.unapprove = unapprove;
    vm.unrejected = unrejected;
    vm.Reject = Reject;
    vm.viewComment = viewComment;
    vm.UnReject = UnReject;
    vm.UnApproved = UnApproved;
    vm.listOtselected = [];

    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.exists = exists
    vm.items = [];
    vm.isIndeterminate = isIndeterminate
    vm.setButton = setButton
    vm.detail = detail
    vm.company = $localStorage.empsite;
    vm.loadDataDepartment = loadDataDepartment
    vm.divisi = vm.department = vm.gedung = 'all';
    vm.isWaiting = true;
    vm.searchEmployee = searchEmployee;

    loadDataDivision(vm.company);
    loadDataGedung();

    function setButton(param) {
      if (param == "approved") {
        vm.isWaiting = false;
        vm.isApproved = true;
        vm.isReject = false;
      } else if (param == "rejected") {
        vm.isWaiting = false;
        vm.isApproved = false;
        vm.isReject = true;
      } else {
        vm.isWaiting = true;
        vm.isApproved = false;
        vm.isReject = false;
      }

      loadData(1);
    }



    function loadData(pageno) {
      vm.listOtselected = [];
      var resp = vm.DataTable.loadData(Approvalghk, pageno, { action: 'viewdata', tglmulai: vm.tglmulai, tglakhir: vm.tglakhir, type: vm.type, divisi: vm.divisi, department: vm.department, gedung: vm.gedung });
      resp.then(function (data) {
        vm.items = data.list;
      });

    }


    function deleteData(ev) {

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = BU.delete({ action: 'delete', data: angular.toJson(vm.listBuSelected) });

          response.$promise.then(viewDataBu);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });


    }

    function isChecked(ls) {
      // return vm.listOtselected.indexOf(ls) > -1;
      return vm.listOtselected.length === vm.items.length;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }
    function toggleSelectedAll(state) {
      if (vm.listOtselected.length === vm.items.length) {
        vm.listOtselected = [];
      } else if (vm.listOtselected.length === 0 || vm.listOtselected.length > 0) {
        vm.listOtselected = vm.items.slice(0);
      }
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Approve this list?')
            .textContent('All data your selected will be approve.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new Approvalghk();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              if (data.status == 1) {
                successApproved(ev, data);
              } else {
                failedApproved(ev, data);
              }
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
            response.catch(function (data) {
              // console.log(data.data);
              failedApproved(ev, data.data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }


    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          loadData(1);
        }
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });

    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        $mdDialog.show({
          controller: 'GhkGwRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/approval-ghk-gw/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function viewComment(ev, data) {
      $mdDialog.show({
        controller: 'GhkGwViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-gw/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          // vm.listOtselected=[];
          loadData();
        },
        locals: {
          data: data
        }
      });
    }

    function UnReject(ev, id) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalghk.delete({ action: 'unreject', data: angular.toJson(id) });

          response.$promise.then(function (data) {
            angular.element.unblockUI();
            var title = "Information"
            var content = data.message
            var lable = "Information"
            showAlert(title, content, lable)
          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            var title = "Warning"
            var content = "Somethin went wrong"
            var lable = "Warning"
            showAlert(title, content, lable)
          });
        });
      });
    }

    function UnApproved(ev, id) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to unapprove this list?')
          .textContent('All data you selected will be set to unapproved.')
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalghk.delete({ action: 'unapproved', data: angular.toJson(id) });

          response.$promise.then(function (data) {
            angular.element.unblockUI();
            var title = "Information"
            var content = data.message
            var lable = "Information"
            showAlert(title, content, lable)
          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            var title = "Warning"
            var content = "Somethin went wrong"
            var lable = "Warning"
            showAlert(title, content, lable)
          });
        });
      });
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.listOtselected.length !== 0 && vm.listOtselected.length !== vm.items.length;
    }

    function detail(ev, data) {
      $mdDialog.show({
        controller: 'DetailApprovalGhkGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-gw/approval-form.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data,
          type: vm.type
        }
      });
    }

    function showAlert(title, content, lable) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(content)
          .ariaLabel(lable)
          .ok('close')
      ).then(function () {
        loadData();
      });
    }

    function loadDataDepartment(iddivisi) {
      var response = Attendancereport.query({ action: 'viewDivisiDept', idbu: vm.company, iddivisi: iddivisi });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }
    function fetchDepartment(data) {
      vm.listDepartment = data;
    }
    function errorDepartment() {
      vm.listDepartment = [];
    }

    function loadDataDivision(idbu) {
      var response = Attendancereport.query({ action: 'viewDivisiBu', idbu: idbu });
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }
    function fetchDivisiBU(data) {
      vm.listDivision = data;
    }
    function errorDivisiBU() {
      vm.listDivision = [];
    }

    function loadDataGedung() {
      var response = Approvalabsence.query({ action: 'getListGedung' });
      response.$promise.then(fetchGedung);
      response.$promise.catch(errorGedung);
    }
    function fetchGedung(data) {
      vm.listGedung = data;
    }
    function errorGedung() {
      vm.listGedung = [];
    }

    function unapprove(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Un-Approve this list?')
            .textContent('All data your selected will be un-approve.')
            .ariaLabel('un-approve dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new Approvalghk();
            ot.data = [];
            ot.action = 'unapproved';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push({
                id: vm.listOtselected[i].id,
                nik: vm.listOtselected[i].nik,
                is_last_approval: vm.listOtselected[i].is_last_approval,
                shift_id: vm.listOtselected[i].emp_shift_id,
                abs_id: vm.listOtselected[i].emp_absence_id,
                dws_code: vm.listOtselected[i].dws_code
              });
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              successApproved(ev, data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function unrejected(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Un-Reject this list?')
            .textContent('All data your selected will be un-reject.')
            .ariaLabel('un-reject dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new Approvalghk();
            ot.data = [];
            ot.action = 'unreject';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push({ id: vm.listOtselected[i].id });
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              successApproved(ev, data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function searchEmployee(ev) {
      $mdDialog.show({
        controller: 'searchEmployeeGhkGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk-gw/search-employee.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          type: vm.type,
          replacementType: '0',
          source: 'ghk-gw'
        }
      });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-ghk', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_approval_ghk', {
                url    : '/cb/approval-ghk',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-ghk/approval-ghk.html',
                        controller : 'ApprovalghkController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
  'use strict';

  angular
    .module('app.cb.approval-ghk')
    .controller('ApprovalghkController', ApprovalghkController);


  ApprovalghkController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function ApprovalghkController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {
    var vm = this;

    var translate = $filter('translate');

    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Approvalghk = AppAPI.Approvalghk();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.Reject = Reject;
    vm.viewComment = viewComment;
    vm.UnReject = UnReject;
    vm.UnApproved = UnApproved;

    var date = new Date();
    vm.tahun = date.getFullYear();
    vm.bulan = date.getMonth() + 1;
    vm.getPeriode = getPeriode;
    vm.tgl = date.getDate();
    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];
    vm.toggleSelectedAll = toggleSelectedAll;

    if (vm.tgl >= 25 && vm.tgl <= 31) {
      if (vm.bulan == 12) {
        vm.bulan = '01';
      } else {
        vm.bulan = vm.bulan + 1;
      }
    }
    if (vm.bulan < 10) {
      vm.bulan = '0' + vm.bulan;
    }

    vm.listtahun = [2017, 2018, 2019, 2020, 2021];
    vm.listbulan = [{ name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'Maret', value: '03' },
    { name: 'April', value: '04' },
    { name: 'Mei', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'Desember', value: '12' }];

    getPeriode();
    // loadData(1);     

    /////////////////////

    function getPeriode() {
      var res = Attendanceemploye.query({ action: 'getPeriode', tahun: vm.tahun, bulan: vm.bulan });
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data) {
      vm.periode = data[0]['periode'];
      vm.tglmulai = new Date(data[0]['datePeriode']['start'] * 1000);
      vm.tglakhir = new Date(data[0]['datePeriode']['end'] * 1000);
      loadData(1);
    }

    function errorfetchPeriode(data) {
      console.log('error');
    }

    function loadData(pageno) {
      vm.listOtselected = [];
      var resp = vm.DataTable.loadData(Approvalghk, pageno, { action: 'viewdata', tglmulai: vm.tglmulai, tglakhir: vm.tglakhir, type: vm.type });
      vm.listGhk = [];
    }


    function editData(id) {
      $state.go('app.cb_employe_overtime_edit_employe_ot', { id: id });
    }

    function deleteData(ev) {

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = BU.delete({ action: 'delete', data: angular.toJson(vm.listBuSelected) });

          response.$promise.then(viewDataBu);
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });


    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.DataTable.list);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            // console.log(vm.listOtselected);
            var ot = new Approvalghk();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
            response.catch(function (data) {
              // console.log(data.data);
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          loadData(1);
        }
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });

    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        //  var promise=Auth.setToken();
        //  promise.then(function(){
        //       var confirm = $mdDialog.confirm()
        //       .title('Would you like to Reject this list?')
        //       .textContent('All data your selected will be Reject.')
        //       .ariaLabel('delete dialog')
        //       .targetEvent(ev)
        //       .ok('YES')
        //       .cancel('no');
        //   $mdDialog.show({
        //         multiple: true
        //    });      
        //   $mdDialog.show(confirm).then(function() {
        //         angular.element.blockUI();
        //         // console.log(vm.listOtselected);
        //         var ot= new Approvalghk();
        //         ot.data=[];
        //         ot.action='reject';  
        //         for (i=0;i<jum;i++) {
        //           ot.data.push({id:vm.listOtselected[i].id});
        //         }
        //         var idtx=encodeURIComponent(angular.toJson(ids));
        //         var response=ot.$save(); 
        //         //var response=tm.$delete({action:'approve'});
        //         response.then(loadData);
        //     }, function() {
        //    // $scope.status = 'You decided to keep your debt.';
        //   });
        // });
        $mdDialog.show({
          controller: 'GhkRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/approval-ghk/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'GhkViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          vm.listOtselected = [];
        },
        locals: {
          id: id
        }
      });
    }

    function UnReject(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNREJ');
      var note = translate('KPI.MESSAGE.UNREJNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalghk.delete({ action: 'unreject', data: angular.toJson(id) });
          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
          response.$promise.catch(function () {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function UnApproved(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNAPP');
      var note = translate('KPI.MESSAGE.UNAPPNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Approvalghk.delete({ action: 'unapproved', data: angular.toJson(id) });
          // console.log(response);
          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);

          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });

        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function succesUnapproved(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnapproved();
      } else {
        showDialog();
      }
      loadData();
    }

    function succesUnreject(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnreject();
      } else {
        showDialogUnreject();
      }
      loadData();
    }

    function failedUnapproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.data)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }

    function showFailedUnapproved() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unapproved Data')
          .textContent('Transaction Locked By System.')
          .ariaLabel('Transaction Locked By System')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showFailedUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unreject Data')
          .textContent('Transaction Locked By System.')
          .ariaLabel('Transaction Locked By System')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialog() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialogUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Process Data')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }
    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.approval-ghk')
        .controller('GhkViewRejectCommentController', GhkViewRejectCommentController);

    GhkViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function GhkViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.approval-ghk')
        .controller('GhkRejectCommentController', GhkRejectCommentController);

    GhkRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function GhkRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        // initial form
        Form.initialForm();

        var Approvalghk = AppAPI.Approvalghk();

        // set constructor form
        Form.setObject(Approvalghk);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;
        // console.log(id);

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    if ('moreInfo' in data && data.moreInfo.length > 0) {
                        $mdDialog.show({
                            controller: 'logFailGwController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: true,
                            onRemoving: function (element, removePromise) {
                                loadData(1);
                            },
                            locals: {
                                data: data.moreInfo
                            }
                        });
                    } else {
                        loadData(1);
                    }
                });
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('reject', formController, Approvalghk);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function successApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save data')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                if ('moreInfo' in data && data.moreInfo.length > 0) {
                    $mdDialog.show({
                        controller: 'logFailGwController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            // loadData(1);
                        },
                        locals: {
                            data: data.moreInfo
                        }
                    });
                } else {
                    // loadData(1);
                }
            });

        }

        function failedApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save data')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                // loadData();
            });

        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-employee-certificates', [])
        .config(config);

      config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.cb_approval_employee_certificates', {
                url    : '/cb/approval_employee_certificates',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-employee-certificates/approval-employee-certificates.html',
                        controller : 'ApprovalEmployeeCertificatesController as vm'
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.approval-employee-certificates')
        .controller('ApprovalEmployeeCertificatesController', ApprovalEmployeeCertificatesController);


    ApprovalEmployeeCertificatesController.$inject = ['$state', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', '$filter', 'FileUploader', 'config', '$localStorage', '$location', '$window'];
    /** @ngInject */
    function ApprovalEmployeeCertificatesController($state, $log, $mdDialog, AppAPI, Auth, DataService, $filter, FileUploader, config, $localStorage, $location, $window) {
        var vm = this;
        var Approvalcertificate = AppAPI.Approvalcertificate(); //memanggil api modules dari api

        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.checkAll = checkAll;
        vm.unCheckAll = unCheckAll;

        vm.isChecked = isChecked;
        vm.isCheckedAll = isCheckedAll;
        vm.toggleCheck = toggleCheck;
        vm.isIndeterminate = isIndeterminate;

        vm.listCertificateSelected = [];

        vm.type = 'Waiting Approval';
        vm.listType = ['Waiting Approval', 'Approved', 'Rejected', 'All'];

        vm.country = 'all';
        vm.program = '';
        vm.closeModal = closeModal;

        vm.clearSearchTermCountry = clearSearchTermCountry;
        vm.clearSearchTermPrograms = clearSearchTermPrograms;

        vm.searchTermCountry = '';
        vm.searchTermPrograms = '';

        vm.listcountry = [];
        vm.listPrograms = [];

        vm.viewDetail = viewDetail;

        vm.onCollapse = onCollapse;
        vm.viewComment = viewComment;

        vm.approveOT = approveOT;
        vm.UnApproved = UnApproved;
        vm.Reject = Reject;
        vm.UnReject = UnReject;

        var nik = $localStorage.user;

        var translate = $filter('translate');

        // Data
        loadData(1);
        LoadCountry();
        LoadPrograms();
        // Methods

        ////////// 

        function loadData(pageno) {
            angular.element.blockUI();

            var tglmulai = '';
            var tglakhir = '';
            if (vm.tglmulai) {
                tglmulai = changeDateFormat(vm.tglmulai);
            }

            if (vm.tglakhir) {
                tglakhir = changeDateFormat(vm.tglakhir);
            }

            var resp = vm.DataTable.loadData(Approvalcertificate, pageno, {
                action: 'viewData',
                type: vm.type,
                country: vm.country,
                idProgram: vm.program,
                startDate: tglmulai,
                endDate: tglakhir
            });

            resp.then(function () {
                vm.listCertificateSelected = [];
                angular.element.unblockUI();
            });
        }

        function changeDateFormat(date) {
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var year = date.getFullYear();
            return year + "-" + month + "-" + day;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listCertificateSelected.indexOf(ls);

            if (idx > -1) {
                vm.listCertificateSelected.splice(idx, 1);
            } else {
                vm.listCertificateSelected.push(ls);
            }
        }

        function toggleSelectedAll(state) {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    countCheckAvail++;
                }
                if (vm.listCertificateSelected.length === countCheckAvail) {
                    unCheckAll();
                } else if (
                    vm.listCertificateSelected.length === 0 ||
                    vm.listCertificateSelected.length > 0
                ) {
                    checkAll();
                }
            } else {
                return false;
            }
        }

        function checkAll() {
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.listCertificateSelected.indexOf(vm.DataTable.list[i]) < 0) {
                    vm.listCertificateSelected.push(vm.DataTable.list[i]);
                }
            }
        }

        function unCheckAll() {
            vm.listCertificateSelected = [];
        }

        function isChecked(ls) {
            return vm.listCertificateSelected.indexOf(ls) > -1;
        }

        function isCheckedAll() {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    countCheckAvail++;
                }
                return vm.listCertificateSelected.length === countCheckAvail && vm.listCertificateSelected.length > 0;
            } else {
                return false;
            }
        }

        function isIndeterminate() {
            if (typeof vm.DataTable.list != 'undefined') {
                var countCheckAvail = 0;
                for (var i = 0; i < vm.DataTable.list.length; i++) {
                    countCheckAvail++;
                }
                return (
                    vm.listCertificateSelected.length > 0 &&
                    vm.listCertificateSelected.length !== countCheckAvail
                );
            } else {
                return false;
            }
        }

        function LoadCountry() {
            var response = Approvalcertificate.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function clearSearchTermCountry() {
            vm.searchTermCountry = '';
        };

        function LoadPrograms() {
            var response = Approvalcertificate.query({
                action: 'getPrograms',
                country: vm.country
            });
            response.$promise.then(fetchPrograms);
            response.$promise.catch(errorFetchPrograms);
        }

        function fetchPrograms(data) {
            vm.listPrograms = data;
        }

        function errorFetchPrograms() {
            vm.listPrograms = [];
        }

        function clearSearchTermPrograms() {
            vm.searchTermPrograms = '';
        };

        function closeModal() {
            $mdDialog.hide();
        }

        function viewDetail(ev, data) {
            angular.element.blockUI();
            var response = Approvalcertificate.query({
                action: 'viewDetail',
                id: data.id
            });
            response.$promise.then(function (detail) {
                $mdDialog.show({
                    controller: ['data', 'closeModal', function (data, closeModal) {
                        var vm1 = this;
                        vm1.data = data;
                        vm1.closeModal = closeModal;
                        vm1.certificateResolve = function (data) {
                            return data ? data : 'Not Available';
                        };
                    }],
                    controllerAs: 'vm1',
                    templateUrl: 'app/main/cb/employee-certificates/employee-certificates-detail.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        // loadData(1);
                    },
                    locals: {
                        data: detail[0],
                        closeModal: closeModal
                    }
                });

                angular.element.unblockUI();
            });
            response.$promise.catch(function () {
                $mdDialog
                    .show(
                        $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Failed')
                        .textContent('Failed Get Detail')
                        .ariaLabel('Failed')
                        .ok('OK')
                        .targetEvent(ev)
                    );

                angular.element.unblockUI();
            });
        }

        function onCollapse() {
            if (vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
                vm.DataTable.searchParam = '';
                vm.loadData(1);
            }
        }

        function approveOT(ev) {
            var jum = vm.listCertificateSelected.length,
                i, ids = [];
            if (jum > 0) {
                var conf = translate('KPI.MESSAGE.CONFAPP');
                var note = translate('KPI.MESSAGE.APPNOTE');
                var yes = translate('PAYROLL.MESSAGE.YES');
                var no = translate('PAYROLL.MESSAGE.NO');
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title(conf)
                        .textContent(note)
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok(yes)
                        .cancel(no);
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var ot = new Approvalcertificate();
                        ot.data = [];
                        ot.action = 'approve';
                        for (i = 0; i < jum; i++) {
                            ot.data.push({
                                id: vm.listCertificateSelected[i].id
                            });
                        }
                        var idtx = encodeURIComponent(angular.toJson(ids));
                        var response = ot.$save();
                        response.then(function (data) {
                            angular.element.unblockUI();
                            showDialogInfo(ev, data)
                        });
                        response.catch(function (data) {
                            angular.element.unblockUI();
                            showDialogInfo(ev, data.data);
                        });
                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            } else {
                var msg = translate('ATTENDANCE.MESSAGE.NOTSELECTED');
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention!')
                    .textContent(msg)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }

        }

        function failedApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Approval')
                .textContent(data.pesan)
                .ariaLabel('Attention')
                .ok('close')
                .targetEvent(ev)
            ).then(function () {
                loadData();
            });

        }


        function Reject(ev) {
            var jum = vm.listCertificateSelected.length,
                i, ids = [];
            if (jum > 0) {
                $mdDialog.show({
                    controller: 'CertificateRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/cb/approval-absence/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        loadData();
                        vm.listCertificateSelected = [];
                    },
                    locals: {
                        id: vm.listCertificateSelected
                    }
                });
            } else {
                var msg = translate('ATTENDANCE.MESSAGE.NOTSELECTED');
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention!')
                    .textContent(msg)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function UnApproved(ev, id) {
            var conf = translate('KPI.MESSAGE.CONFUNAPP');
            var note = translate('KPI.MESSAGE.UNAPPNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(conf)
                    .textContent(note)
                    .ariaLabel('unapprove dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Approvalcertificate.delete({
                        action: 'unapproved',
                        data: angular.toJson(id)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data)
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data.data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'CertificateViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/approval-absence/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listCertificateSelected = [];
                },
                locals: {
                    id: id
                }
            });
        }

        function UnReject(ev, id) {
            var conf = translate('KPI.MESSAGE.CONFUNREJ');
            var note = translate('KPI.MESSAGE.UNREJNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(conf)
                    .textContent(note)
                    .ariaLabel('unreject dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Approvalcertificate.delete({
                        action: 'unreject',
                        data: angular.toJson(id)
                    });
                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data)
                    });
                    response.catch(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data.data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function successUnapprove(data) {
            if (data.hasil == 'expired') {
                showFailedUnapproved();
            } else {
                showDialog();
            }
            loadData(1);
        }

        function errorUnapprove(data) {
            angular.element.unblockUI();
        }

        function showFailedUnapproved() {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Failed Unapproved Data')
                .textContent('Transaction Locked By System.')
                .ariaLabel('Transaction Locked By System')
                .ok('OK')
            ).then(function () {
                $mdDialog.hide();
            });
        }

        function showDialog() {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success Save Data')
                .textContent('Process Data was Success.')
                .ariaLabel('Success Save Data')
                .ok('OK')
            ).then(function () {
                $mdDialog.hide();
            });
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
                )
                .then(function () {
                    closeModal();
                    if ('moreInfo' in data && data.moreInfo.length > 0) {
                        $mdDialog.show({
                            controller: 'logFailGwController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: true,
                            onRemoving: function (element, removePromise) {
                                loadData(1);
                            },
                            locals: {
                                data: data.moreInfo
                            }
                        });
                    } else {
                        loadData(1);
                    }
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.approval-employee-certificates')
        .controller('CertificateViewRejectCommentController', CertificateViewRejectCommentController);

    CertificateViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$filter'];

    /* @ngInject */
    function CertificateViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Approvalcertificate = AppAPI.Approvalcertificate(); 

        // set constructor form
        Form.setObject(Approvalcertificate);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Approvalcertificate);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.approval-employee-certificates')
        .controller('CertificateRejectCommentController', CertificateRejectCommentController);

    CertificateRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function CertificateRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;
        // initial form
        Form.initialForm();

        var Approvalcertificate = AppAPI.Approvalcertificate(); 

        // set constructor form
        Form.setObject(Approvalcertificate);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;
        // console.log(id);

        var translate = $filter('translate');

        function saveData(ev, formController) {
            var promise = Form.saveData('reject', formController, Approvalcertificate);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    // loadData(1);
                });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-absence-hr', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_hr_approval_absence', {
                url    : '/cb/hr-approval-absence',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-absence-hr/approval-absence-hr.html',
                        controller : 'ApprovalabsenceHrController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.approval-absence-hr')
        .controller('ViewDocAbsController', ViewDocAbsController);

    ViewDocAbsController.$inject = ['$localStorage','$http','$location','$window','$stateParams','$document','$mdDialog','Auth','Form','AppAPI','DTColumnDefBuilder','Echeckin','config','img'];

    /* @ngInject */
    function ViewDocAbsController($localStorage,$http,$location,$window,$stateParams,$document,$mdDialog,Auth,Form,AppAPI,DTColumnDefBuilder,Echeckin,config,img) {
        var vm = this;
        
        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal()
        {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage()
        {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = 'api/leavedocument/'+vm.doc+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev)
        {
            var name=vm.doc;
            // console.log(link);
            if(name !==null && name !=='-')
            {
                $http({
                    method: 'GET',
                    url: config.api+'api/leavedocument/'+name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];
             
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);
             
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
             
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Document Not Found')
                .textContent('Document not Found')
                .ariaLabel('Failed Save Data')
                .ok('OK')
                .targetEvent(ev)
                ).then(function(){
                    // closeModal();
                });
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-absence-hr')
        .controller('ApproveOtherTypeController', ApproveOtherTypeController);


    ApproveOtherTypeController.$inject=['$state','$mdDialog','$localStorage','AppAPI','Form','$http','config','id'];
    /** @ngInject */
    function ApproveOtherTypeController($state,$mdDialog,$localStorage,AppAPI,Form,$http,config,id)
    {
        
      var vm = this;
      vm.Form = Form;
      var Approvalabsence=AppAPI.Approvalabsence();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var nik= $localStorage.user;
      vm.saveData=saveData;

      // initial form
      Form.initialForm();
      Form.setObject(Approvalabsence); 
      vm.Form.objForm.data=id; 
      vm.Form.objForm.abs_codeN='Z306';
      vm.closeModal = closeModal; 
      
      vm.isShowCustomDate = false;
      if(id.absence_type=='Z305'){
        vm.isShowCustomDate = true;
      }
      vm.getDateArray = [];
      var start = id.start_date;
      var end   = id.end_date;
      // date array
      getDateArray(start,end);

      console.log(vm.Form.objForm.abs_codeN);
      
      vm.listAbsenceTypeCustom = [
        {
          "name"  : "Z305-Sick Leave with Certificate/Sakit Dengan Surat Dokter (Premi Attendance Deduction for staff up)",
          "code" : "Z305"
        },
        {
          "name"  : "Z306-Sick Leave without Certificate/Sakit Tanpa Surat Dokter (Salary Deduction)",
          "code" : "Z306"
        }
      ];

      var response= Attendanceemploye.query({action:'getAbsenceType'});
          response.$promise.then(function(data){
          vm.listAbsenceType=data;
          // console.log(vm.listParent);
          vm.saveProcess=false;
        });

        response.$promise.catch(function(data){
          $log.info(data);
          vm.saveProcess=false;
        });

        function closeModal()
        {
            $mdDialog.hide();
        }

      function saveData(ev,formController) 
      {   
           angular.element.blockUI();
           vm.Form.objForm.daysNumber = vm.days;
          var promise= Form.saveData('approveOther', formController, Approvalabsence);
            promise.then(function(data){
                angular.element.unblockUI();
                successApproved(ev,data)
            vm.saveProcess=false;
            });
          promise.catch(function(data){
              angular.element.unblockUI();
               ShowFailed(ev,data.data)  
            vm.saveProcess=false;
            });
          

      }

      function showDialog(ev,data) 
      {
         $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Save Data') 
          .textContent(data.pesan)
          .ariaLabel('Success Save Data')
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              closeModal();
          });
      }

      function ShowFailed(ev,data) 
      {
         $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Save Data')
          .textContent(data.pesan)
          .ariaLabel('Failed Save Data')
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              closeModal();
          }); 
      }

      function getDateArray(start, end)
      {
        var dtStart = new Date(start);
        var dtEnd = new Date(end);
        vm.start_date = dtStart;
        vm.end_date   = dtEnd;
        var timeStart = dtStart.getTime();
        var timeEnd   = dtEnd.getTime();
        vm.dayNumber = [{'value':0,'name':0}];
        var number = 1;
        while (timeStart <= timeEnd) {
            vm.dayNumber.push({'value':number,'name':number});
            number+=1;
            timeStart += 86400000;
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Thanks for Approval')
            .textContent(data.pesan)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                $mdDialog.show({
                    controller         : 'logFailGwController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    },
                    locals:{
                        data:data.moreInfo
                    }
                });
                }else{
                loadData(1);
                }
            });
            
        }
        // while (timeStart <= timeEnd) {
        //     var dd = dtStart.getDate();
        //     var mm = dtStart.getMonth()+1;
        //     var yyyy = dtStart.getFullYear();
        //     if(dd<10){
        //         dd='0'+dd;
        //     } 
        //     if(mm<10){
        //         mm='0'+mm;
        //     } 
        //     var today = yyyy+'-'+mm+'-'+dd;
        //     vm.getDateArray.push(today);
        //     dtStart.setDate(dtStart.getDate() + 1);
        //     var currentTime = dtStart.getTime();
        //     timeStart += 86400000;
        // }
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-absence-hr')
        .controller('ApprovalabsenceHrController', ApprovalabsenceHrController);


    ApprovalabsenceHrController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$location','$http','config'];
    /** @ngInject */
    function ApprovalabsenceHrController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$location,$http,config)
    {
        
      var vm = this; 
      vm.editData=editData;
      vm.deleteData=deleteData;
      vm.loadData=loadData;
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Approvalabsence=AppAPI.Approvalabsence();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveOT=approveOT;
      vm.ViewDocument=ViewDocument;
      vm.UnApproved=UnApproved;
      vm.Reject=Reject;
      vm.UnReject=UnReject;
      vm.viewComment=viewComment; 
      vm.group=$localStorage.group;
      vm.approveOtherType=approveOtherType;
      vm.budisabled=true;


      vm.loadDataDivision=loadDataDivision;
      vm.loadDataDepartment=loadDataDepartment;
      var Employeshiftt=AppAPI.Overtime(); 
      vm.company=$localStorage.empsite;
      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected'];
      vm.flag_app='SAP';
      vm.flagApp=['SAP','HRIS'];
      vm.gedung='all';
      vm.flagAppDisabled=false;
      if(vm.group=='145')
      {
        vm.flag_app='HRIS';
        vm.flagAppDisabled=true;
      }

      if(vm.group== '1' || vm.group == '128' || vm.group == '132')
      {
        vm.budisabled=false;
      }

      // console.log(vm.flagAppDisabled);
      // var date=new Date();
      // vm.tahun=date.getFullYear();
      // vm.bulan=date.getMonth()+1;
      // vm.getPeriode=getPeriode;
      // vm.tgl=date.getDate();
      // if(vm.tgl >=25 && vm.tgl <=31)
      //   { 
      //     if(vm.bulan==12){
      //       vm.bulan='01';
      //     }else{
      //       vm.bulan=vm.bulan+1;
      //     }
      //   }
      //   if(vm.bulan < 10){
      //     vm.bulan='0'+vm.bulan;
      //   }

      // vm.listtahun=[2014,2015,2016,2017,2018,2019];
      // vm.listbulan=[{name:'January',value:'01'},
      //               {name:'February',value:'02'},
      //               {name:'Maret',value:'03'},
      //               {name:'April',value:'04'},
      //               {name:'Mei',value:'05'},
      //               {name:'June',value:'06'},
      //               {name:'July',value:'07'},
      //               {name:'August',value:'08'},
      //               {name:'September',value:'09'},
      //               {name:'October',value:'10'},
      //               {name:'November',value:'11'},
      //               {name:'Desember',value:'12'}];
    
      // getPeriode();   
      loadDataBU(); 
      loadDataDivision(vm.company); 
      getListGedung();
      // loadData(1);
    //////////
    
    
    function getPeriode(){
        var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan,flag_app:vm.flag_app});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.periode=data[0]['periode'];
        // console.log(vm.periode);
        // loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }

    function loadData(pageno)
    {
      var divisi=vm.divisi;
      var department=vm.department; 
      var resp=vm.DataTable.loadData(Approvalabsence,pageno,{action:'viewdata',company:vm.company,divisi:vm.divisi,departement:vm.department,tglmulai:vm.tglmulai,tglakhir:vm.tglakhir,type:vm.type,flag_app:vm.flag_app,gedung:vm.gedung});
      vm.listOtselected=[];
    }
    
    function getListGedung()
    {
        angular.element.blockUI();
        var resp=Approvalabsence.query({action:'getListGedung'});
        resp.$promise.then(function(data) {
            vm.listGedung = data
            angular.element.unblockUI();
        });
        resp.$promise.catch(function(data){
            vm.listGedung = []
            angular.element.unblockUI();
        });    
    }

    function editData(id) {
        $state.go('app.cb_employe_overtime_edit_employe_ot',{id:id});
    }

    function deleteData(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=BU.delete({action:'delete',data:angular.toJson(vm.listBuSelected)});

       response.$promise.then(viewDataBu);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

     //  function approveOT(ev)
     //  {
     //    var promise=Auth.setToken();
     //     promise.then(function(){
     //          var confirm = $mdDialog.confirm()
     //          .title('Would you like to Approve this list?')
     //          .textContent('All data your selected will be approve.')
     //          .ariaLabel('delete dialog')
     //          .targetEvent(ev)
     //          .ok('YES')
     //          .cancel('no');
     //      $mdDialog.show({
     //            multiple: true
     //       });      
     //      $mdDialog.show(confirm).then(function() {
     //            angular.element.blockUI();
     //            // console.log(vm.listOtselected);
     //            var ot= new Approvalabsence();
     //            ot.data=[];
     //            ot.action='approve';
     //            ot.nik=nik;
     //            ot.approval_type='n1';
     //            var jum=vm.listOtselected.length,i,ids=[]; 
     //            for (i=0;i<jum;i++) {
     //              ot.data.push({id:vm.listOtselected[i].id});
     //            }
     //            var idtx=encodeURIComponent(angular.toJson(ids));
     //            var response=ot.$save(); 
     //            //var response=tm.$delete({action:'approve'});
     //            response.then(loadData);
     //        }, function() {
     //       // $scope.status = 'You decided to keep your debt.';
     //      });
     //    });

     //  }

     // function Reject(ev)
     //  {
     //    var promise=Auth.setToken();
     //     promise.then(function(){
     //          var confirm = $mdDialog.confirm()
     //          .title('Would you like to Reject this list?')
     //          .textContent('All data your selected will be Reject.')
     //          .ariaLabel('delete dialog')
     //          .targetEvent(ev)
     //          .ok('YES')
     //          .cancel('no');
     //      $mdDialog.show({
     //            multiple: true
     //       });      
     //      $mdDialog.show(confirm).then(function() {
     //            angular.element.blockUI();
     //            // console.log(vm.listOtselected);
     //            var ot= new Approvalabsence();
     //            ot.data=[];
     //            ot.action='reject';
     //            ot.nik=nik;
     //            ot.approval_type='n1';
     //            var jum=vm.listOtselected.length,i,ids=[]; 
     //            for (i=0;i<jum;i++) {
     //              ot.data.push({id:vm.listOtselected[i].id});
     //            }
     //            var idtx=encodeURIComponent(angular.toJson(ids));
     //            var response=ot.$save(); 
     //            //var response=tm.$delete({action:'approve'});
     //            response.then(loadData);
     //        }, function() {
     //       // $scope.status = 'You decided to keep your debt.';
     //      });
     //    });

     //  }

     function approveOT(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Approve this list?')
                .textContent('All data your selected will be approve.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  // console.log(vm.listOtselected);
                  var ot= new Approvalabsence();
                  ot.data=[];
                  ot.action='approve';
                  ot.nik=nik;
                  ot.approval_type='n1';  
                  for (i=0;i<jum;i++) {
                    ot.data.push({id:vm.listOtselected[i].id});
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save();  
                  response.then(function(data){
                      // console.log(data.pesan);
                    successApproved(ev,data);
                    angular.element.unblockUI();
                  });
                  response.catch(function(data){
                    // console.log(data.data);
                    failedApproved(ev,data.data);
                    angular.element.unblockUI();
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 

      }

     function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {  
          $mdDialog.show({
                controller         : 'LeaveRejectCommentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/approval-absence/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                    vm.listOtselected=[];
                },
                locals:{
                  id:vm.listOtselected
                }
            });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

      // function ViewDocument(name)
      //   {
      //       // var protocol=$location.protocol();
      //       // var host=$location.host();
      //       // $window.open(protocol+'://'+host+'/'+config.api+'api/empdocument/'+link, '_blank'); 

      //       // console.log(protocol+'  /  '+host+'  /   '+config.api);
      //       // var url=config.api+'api/empdocument/'+link;
      //       $http({
      //               method: 'GET',
      //               url: config.api+'api/leavedocument/'+name,
      //               params: { name: name },
      //               responseType: 'arraybuffer'
      //           }).success(function (data, status, headers) {
      //               headers = headers();
      //               // console.log(data);
      //               var filename = name;
      //               var contentType = headers['content-type'];
             
      //               var linkElement = document.createElement('a');
      //               try {
      //                   var blob = new Blob([data], { type: contentType });
      //                   var url = window.URL.createObjectURL(blob);
             
      //                   linkElement.setAttribute('href', url);
      //                   linkElement.setAttribute("download", filename);
             
      //                   var clickEvent = new MouseEvent("click", {
      //                       "view": window,
      //                       "bubbles": true,
      //                       "cancelable": false
      //                   });
      //                   linkElement.dispatchEvent(clickEvent);
      //               } catch (ex) {
      //                   console.log(ex);
      //               }
      //           }).error(function (data) {
      //               console.log(data);
      //           });
      //   }

      function UnApproved(ev,id)
      {
        var promise=Auth.setToken();
         promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

        $mdDialog.show(confirm).then(function() {
         angular.element.blockUI();
         var response=Approvalabsence.delete({action:'unapproved',data:angular.toJson(id)});

         response.$promise.then(loadData);
            }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
         });
      }

      function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'AbsenceViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/approval-absence/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              vm.listOtselected=[];
          },
          locals:{
            id:id
          }
      });
    }

  function UnReject(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
      angular.element.blockUI();
      var response=Approvalabsence.delete({action:'unreject',data:angular.toJson(id)});
      response.$promise.then(loadData);
      response.$promise.catch(function(){
        angular.element.unblockUI();
      });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

      function loadDataDepartment(iddivisi) {
       var response=Employeshiftt.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment=data;
      // loadData(1);
    }

    function errorDepartment() {
      vm.listDepartment=[];
    }
    
    function loadDataDivision(idbu) {
       var response=Employeshiftt.query({action:'viewDivisiBu',idbu:idbu});
      response.$promise.then(fetchDivisiBU);
      response.$promise.catch(errorDivisiBU);
    }

    function fetchDivisiBU(data) {
     vm.listDivision=data;
     // loadData(1);
    }

    function errorDivisiBU() {
      vm.listDivision=[];
    } 

    function loadDataBU() {
      var response=Employeshiftt.query({action:'viewBu'});
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listBU=data;
    }

    function errorFetchBU() {
      vm.listBU=[];
    } 

    function approveOtherType(ev,ls)
    {
      $mdDialog.show({
          controller         : 'ApproveOtherTypeController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/approval-absence-hr/approve-other-type.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              vm.listOtselected=[];
              loadData();
          },
          locals:{
            id:ls
          }
      });
    }

    function ViewDocument(ev, img)
        {
            $mdDialog.show({    
                controller         : 'ViewDocAbsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/approval-absence-hr/view-doc-abs.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    viewData();
                },
                locals:{
                  img:img
                }
            });
        }

        function successApproved(ev,data)
        {
            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Thanks for Approval')
            .textContent(data.pesan)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                $mdDialog.show({
                    controller         : 'logFailGwController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        loadData(1);
                    },
                    locals:{
                        data:data.moreInfo
                    }
                });
                }else{
                loadData(1);
                }
            });
            
        }

      function failedApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.approval-absence', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_approval_absence', {
                url    : '/cb/approval-absence',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/approval-absence/approval-absence.html',
                        controller : 'ApprovalabsenceController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.cb.approval-absence')
        .controller('ApprovalabsenceController', ApprovalabsenceController);


    ApprovalabsenceController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$location', '$http', 'config', '$filter'];
    /** @ngInject */
    function ApprovalabsenceController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $location, $http, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        vm.editData = editData;
        vm.deleteData = deleteData;
        vm.loadData = loadData
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        var Approvalabsence = AppAPI.Approvalabsence();
        var Attendanceemploye = AppAPI.Attendanceemploye();
        var nik = $localStorage.user;
        vm.isChecked = isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected = [];
        vm.approveOT = approveOT;
        vm.ViewDocument = ViewDocument;
        vm.UnApproved = UnApproved;
        vm.Reject = Reject;
        vm.UnReject = UnReject;
        vm.viewComment = viewComment;
        var Employeshiftt = AppAPI.Overtime();
        vm.successApproved = successApproved;
        vm.type = 'waiting approval';
        vm.listType = ['waiting approval', 'approved', 'rejected'];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.approveOtherType = approveOtherType;

        //   var date=new Date();
        //   vm.tahun=date.getFullYear();
        //   vm.bulan=date.getMonth()+1;
        //   vm.getPeriode=getPeriode;
        //   vm.tgl=date.getDate();
        //   if(vm.tgl >=25 && vm.tgl <=31)
        //     { 
        //       if(vm.bulan==12){
        //         vm.bulan='01';
        //       }else{
        //         vm.bulan=vm.bulan+1;
        //       }
        //     }
        //     if(vm.bulan < 10){
        //       vm.bulan='0'+vm.bulan;
        //     }

        //   vm.listtahun=[2014,2015,2016,2017,2018,2019];
        //   vm.listbulan=[{name:'January',value:'01'},
        //                 {name:'February',value:'02'},
        //                 {name:'Maret',value:'03'},
        //                 {name:'April',value:'04'},
        //                 {name:'Mei',value:'05'},
        //                 {name:'June',value:'06'},
        //                 {name:'July',value:'07'},
        //                 {name:'August',value:'08'},
        //                 {name:'September',value:'09'},
        //                 {name:'October',value:'10'},
        //                 {name:'November',value:'11'},
        //                 {name:'Desember',value:'12'}];

        // getPeriode();  
        //////////
        // loadData(1);

        function loadData(pageno) {
            var company = 'all';
            var divisi = 'all';
            var department = 'all';
            var resp = vm.DataTable.loadData(Approvalabsence, pageno, { action: 'viewdata', company: company, divisi: divisi, departement: department, tglmulai: vm.tglmulai, tglakhir: vm.tglakhir, type: vm.type });
            vm.listOtselected = [];
        }

        function getPeriode() {
            var res = Attendanceemploye.query({ action: 'getPeriode', tahun: vm.tahun, bulan: vm.bulan });
            res.$promise.then(fetchPeriode);
            res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data) {
            vm.periode = data[0]['periode'];
            // console.log(vm.periode);
            loadData(1);
        }

        function errorfetchPeriode(data) {
            console.log('error');
        }


        function editData(id) {
            $state.go('app.cb_employe_overtime_edit_employe_ot', { id: id });
        }

        function deleteData(ev) {
            var conf = translate('KPI.MESSAGE.CONFAPP');
            var note = translate('KPI.MESSAGE.APPNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(conf)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = BU.delete({ action: 'delete', data: angular.toJson(vm.listBuSelected) });

                    response.$promise.then(viewDataBu);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function isChecked(ls) {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event) {
            if (event) {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if (idx > -1) {
                vm.listOtselected.splice(idx, 1);
            }
            else {
                vm.listOtselected.push(ls);
            }
        }

        function toggleSelectedAll(state) {
            // console.log(state);
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listOtselected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listOtselected = [];
        }

        function approveOT(ev) {
            var jum = vm.listOtselected.length, i, ids = [];
            if (jum > 0) {
                var conf = translate('KPI.MESSAGE.CONFAPP');
                var note = translate('KPI.MESSAGE.APPNOTE');
                var yes = translate('PAYROLL.MESSAGE.YES');
                var no = translate('PAYROLL.MESSAGE.NO');
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title(conf)
                        .textContent(note)
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok(yes)
                        .cancel(no);
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var ot = new Approvalabsence();
                        ot.data = [];
                        ot.action = 'approve';
                        ot.nik = nik;
                        ot.approval_type = 'n1';
                        for (i = 0; i < jum; i++) {
                            ot.data.push({ id: vm.listOtselected[i].id });
                        }
                        var idtx = encodeURIComponent(angular.toJson(ids));
                        var response = ot.$save();
                        response.then(function (data) {
                            angular.element.unblockUI();
                            showDialogInfo(ev, data)
                        });
                        response.catch(function (data) {
                            angular.element.unblockUI();
                            showDialogInfo(ev, data.data);
                        });
                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            } else {
                var msg = translate('ATTENDANCE.MESSAGE.NOTSELECTED');
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention!')
                        .textContent(msg)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }

        }

        function failedApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Approval')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                loadData();
            });

        }


        function Reject(ev) {
            var jum = vm.listOtselected.length, i, ids = [];
            if (jum > 0) {
                $mdDialog.show({
                    controller: 'LeaveRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/cb/approval-absence/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        loadData();
                        vm.listOtselected = [];
                    },
                    locals: {
                        id: vm.listOtselected
                    }
                });
            } else {
                var msg = translate('ATTENDANCE.MESSAGE.NOTSELECTED');
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention!')
                        .textContent(msg)
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        // function ViewDocument(name)
        //   {
        //       // var protocol=$location.protocol();
        //       // var host=$location.host();
        //       // $window.open(protocol+'://'+host+'/'+config.api+'api/empdocument/'+link, '_blank'); 

        //       // console.log(protocol+'  /  '+host+'  /   '+config.api);
        //       // var url=config.api+'api/empdocument/'+link;
        //       $http({
        //               method: 'GET',
        //               url: config.api+'api/leavedocument/'+name,
        //               params: { name: name },
        //               responseType: 'arraybuffer'
        //           }).success(function (data, status, headers) {
        //               headers = headers();
        //               // console.log(data);
        //               var filename = name;
        //               var contentType = headers['content-type'];

        //               var linkElement = document.createElement('a');
        //               try {
        //                   var blob = new Blob([data], { type: contentType });
        //                   var url = window.URL.createObjectURL(blob);

        //                   linkElement.setAttribute('href', url);
        //                   linkElement.setAttribute("download", filename);

        //                   var clickEvent = new MouseEvent("click", {
        //                       "view": window,
        //                       "bubbles": true,
        //                       "cancelable": false
        //                   });
        //                   linkElement.dispatchEvent(clickEvent);
        //               } catch (ex) {
        //                   console.log(ex);
        //               }
        //           }).error(function (data) {
        //               console.log(data);
        //           });
        //   }

        function UnApproved(ev, id) {
            var conf = translate('KPI.MESSAGE.CONFUNAPP');
            var note = translate('KPI.MESSAGE.UNAPPNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(conf)
                    .textContent(note)
                    .ariaLabel('unapprove dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Approvalabsence.delete({ action: 'unapproved', data: angular.toJson(id) });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data)
                    });
                    response.catch(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data.data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function viewComment(ev, id) {
            $mdDialog.show({
                controller: 'AbsenceViewRejectCommentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/approval-absence/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listOtselected = [];
                },
                locals: {
                    id: id
                }
            });
        }

        function UnReject(ev, id) {
            var conf = translate('KPI.MESSAGE.CONFUNREJ');
            var note = translate('KPI.MESSAGE.UNREJNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(conf)
                    .textContent(note)
                    .ariaLabel('unreject dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = Approvalabsence.delete({ action: 'unreject', data: angular.toJson(id) });
                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data)
                    });
                    response.catch(function (data) {
                        angular.element.unblockUI();
                        showDialogInfo(ev, data.data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function successUnapprove(data) {
            if (data.hasil == 'expired') {
                showFailedUnapproved();
            } else {
                showDialog();
            }
            loadData(1);
        }

        function errorUnapprove(data) {
            angular.element.unblockUI();
        }

        function showFailedUnapproved() {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Unapproved Data')
                    .textContent('Transaction Locked By System.')
                    .ariaLabel('Transaction Locked By System')
                    .ok('OK')
            ).then(function () {
                $mdDialog.hide();
            });
        }

        function showDialog() {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent('Process Data was Success.')
                    .ariaLabel('Success Save Data')
                    .ok('OK')
            ).then(function () {
                $mdDialog.hide();
            });
        }

        function ViewDocument(ev, img) {
            $mdDialog.show({
                controller: 'ViewDocAbsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/approval-absence-hr/view-doc-abs.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    img: img
                }
            });
        }

        function approveOtherType(ev, ls) {
            $mdDialog.show({
                controller: 'ApproveOtherTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/cb/approval-absence-hr/approve-other-type.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    vm.listOtselected = [];
                    loadData();
                },
                locals: {
                    id: ls
                }
            });
        }

        function successApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Thanks for Approval')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                if ('moreInfo' in data && data.moreInfo.length > 0) {
                    $mdDialog.show({
                        controller: 'logFailGwController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            loadData(1);
                        },
                        locals: {
                            data: data.moreInfo
                        }
                    });
                } else {
                    loadData(1);
                }
            });

        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    if ('moreInfo' in data && data.moreInfo.length > 0) {
                        $mdDialog.show({
                            controller: 'logFailGwController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: true,
                            onRemoving: function (element, removePromise) {
                                loadData(1);
                            },
                            locals: {
                                data: data.moreInfo
                            }
                        });
                    } else {
                        loadData(1);
                    }
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.approval-absence')
        .controller('AbsenceViewRejectCommentController', AbsenceViewRejectCommentController);

    AbsenceViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$filter'];

    /* @ngInject */
    function AbsenceViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

        var translate = $filter('translate');

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.approval-absence')
        .controller('LeaveRejectCommentController', LeaveRejectCommentController);

    LeaveRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function LeaveRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;
        // initial form
        Form.initialForm();

        var Approvalabsence = AppAPI.Approvalabsence();

        // set constructor form
        Form.setObject(Approvalabsence);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;
        // console.log(id);

        var translate = $filter('translate');

        function saveData(ev, formController) {
            var promise = Form.saveData('reject', formController, Approvalabsence);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function () {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    // loadData(1);
                });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.annual-leave-rules')
        .controller('AnnualLeaveRulesController', AnnualLeaveRulesController);


    AnnualLeaveRulesController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$log','$localStorage'];
    /** @ngInject */
    function AnnualLeaveRulesController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$log,$localStorage)
    {

      var vm = this;
      vm.editData=editData;
      vm.deleteData=deleteData;
      vm.loadData=loadData;
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      var AnnualLeaveRules=AppAPI.AnnualLeaveRules();
      vm.clearFilter=clearFilter;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listselected=[];
      vm.create = create;
      
      loadData(1);

        //////////
      function clearFilter()
      {
        console.log('test');
        vm.abs_code=null;
        vm.status=null;
        vm.start_date=null;
        vm.end_date=null;
      }
    
      function loadData(pageno)
      {
        var resp=vm.DataTable.loadData(AnnualLeaveRules,pageno,{action:'viewdata'});
         vm.listselected=[];
        resp.then(function(){
           // vm.abs_code='';
         });
      }

      function create(ev) {
          $mdDialog.show({
              controller         : 'CreateAnnualLeaveRulesController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/cb/annual-leave-rules/create/create.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData(1);
              }
          });
      }

      function editData (event, ls)
      {
        $mdDialog.show({
              controller         : 'EditAnnualLeaveRulesController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/cb/annual-leave-rules/edit/edit.html',
              parent: angular.element(document.body),
              targetEvent: event,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData(1);
              },
              locals:{
                data:ls
              }
          }); 
      }

      function isChecked(ls)
      {
          return vm.listselected.indexOf(ls) > -1;
      }

      function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listselected.splice(idx, 1);
          }
          else
          {
              vm.listselected.push(ls);
          }
      }

      function deleteData(ev) {

        if ( vm.listselected.length > 0) {
          var promise=Auth.setToken();
          promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data your selected will be deleted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=AnnualLeaveRules.delete({action:'delete',data:angular.toJson(vm.selected)});
                response.$promise.then( function(resData) {
                    angular.element.unblockUI();
                    var title = 'Success Delete Data';
                    var textContent = 'Process Delete data was Success';
                    var ariaLabel = 'Success Delete Data';
                    showDialogMessage(title,textContent,ariaLabel);
                    viewData(1);
                });
                response.$promise.catch( function() {
                    angular.element.unblockUI();
                    var title = 'Delete Data Failed';
                    var textContent = 'Process delete data promotion has been failed.';
                    var ariaLabel = 'Delete Data Failed';
                    showDialogMessage(title,textContent,ariaLabel,ev);
                })
            }, function() {

            });
          });
        } else {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            }); 
        }
      }

      function showDialogMessage(title,textContent,ariaLabel,ev) {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel(ariaLabel)
          .ok('OK')
          .targetEvent(ev)
          ).then(function(){
              closeModal();
          });
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.am-update-finger-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_am_update_finger_approval', {
                url    : '/cb/area-manager-update-finger-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-update-finger-approval/am-update-finger-approval.html',
                        controller : 'AmupdateFingerAppController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-update-finger-approval')
        .controller('AmupdateFingerAppController', AmupdateFingerAppController);


    AmupdateFingerAppController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function AmupdateFingerAppController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Approvalfinger=AppAPI.Amapprovalfinger();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveAbnormal=approveAbnormal;
      vm.Reject=Reject;
         
      loadData();
 
        ////////// 
    
    // function loadData(pageno)
    // {
    //   var resp=vm.DataTable.loadData(Abnormalapproval,pageno,{action:'viewdata',nik:nik});
    //   vm.listOtselected=[];
    // }

    function loadData() {
        angular.element.blockUI();
         var response=Approvalfinger.query({action:'viewdata'});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listApp=data;
        // loadData(1);
        console.log(vm.listApp);
        angular.element.unblockUI();
      }

      function errorDepartment() {
        vm.listApp=[];
        angular.element.unblockUI();
      }
     

    

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function approveAbnormal(ev)
      {
        console.log(vm.listOtselected);
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                console.log(vm.listOtselected);
                var ot= new Approvalfinger();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id
                                });
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function Reject(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Reject this list?')
              .textContent('All data your selected will be Reject.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Approvalfinger();
                ot.data=[];
                ot.action='reject';
                ot.nik=nik;
                ot.approval_type='n1';
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

    }
})();

(function ()
{
  'use strict';

  angular
  .module('app.cb.am-team-assignment')
  .controller('AmteamassignmentController', AmteamassignmentController);


  AmteamassignmentController.$inject=['$state','$mdDialog','$document','$localStorage','DataService','AppAPI','Auth','GeneralService','Form','$timeout','$log','$scope'];
  /** @ngInject */
  function AmteamassignmentController($state,$mdDialog,$document,$localStorage,DataService,AppAPI,Auth,GeneralService,Form,$timeout,$log,$scope)
  {
    var vm = this;
    var Teamassignment = AppAPI.Teamassignment(); //memanggil api modules dari api

    vm.listJum = [2,5,25,50,75,100,200];
    vm.DataTable = new DataService(); //inisialisasi class DataService
    vm.loadData = loadData;
    vm.editData = editData;
    vm.insertData = insertData;
    vm.uploadAssignment = uploadAssignment;
    vm.viewDetail = viewDetail;
    vm.isChecked = isChecked;
    vm.isCheckedAll = isCheckedAll;
    vm.toggleCheck = toggleCheck;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.isIndeterminate = isIndeterminate;
    vm.deleteData=deleteData;
    vm.onCollapse=onCollapse;

    vm.listOtselected = [];

    var currentPage = 1;
    
    loadData(currentPage);

    function loadData(pageno) {
      angular.element.blockUI();
      currentPage = pageno;
      var resp=vm.DataTable.loadData(Teamassignment,pageno,{action:'viewData'});

      resp.then(function(){
        angular.element.unblockUI();
      });
    }

    function viewDetail(ev,data,detail)
    {
      $mdDialog.show({
        controller         : 'AmdetailTeamAssignmentController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/cb/am-team-assignment/am-detail-team-assignment.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:false,
        fullscreen: true,
        locals:{
          data:data,
          detail:detail,
          state: false,
          approveFunction: (function() {})
        },
        onRemoving:function(element, removePromise)
        {
          loadData(currentPage);
        }
      });
    }

    function insertData(ev)
    {
      $mdDialog.show({
        controller         : 'AmeditTeamAssignmentController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/cb/am-team-assignment/am-insert-team-assignment.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:false,
        fullscreen: true,
        onRemoving:function(element, removePromise)
        {
          loadData(1);
        },
        locals:{
          edt:{id: null}
        }
      });
    }

    function editData(ev,data)
    {
      $mdDialog.show({
        controller         : 'AmeditTeamAssignmentController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/cb/am-team-assignment/am-insert-team-assignment.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:false,
        fullscreen: true,
        onRemoving:function(element, removePromise)
        {
          loadData(1);
        },
        locals:{
          edt:data
        }
      });
    }

    function uploadAssignment(ev) {
      $mdDialog.show({
        controller         : 'UploadfileAssignmentController as vm',
        templateUrl        : 'app/main/cb/am-team-assignment/am-uploadfile/am-uploadfile.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true
      });
    }


    function isChecked(ls) {
        return vm.listOtselected.indexOf(ls) > -1;
    }        

    function isCheckedAll() {
        if(typeof vm.DataTable.list != 'undefined') {
            var countCheckAvail = 0;
            for(var i=0; i<vm.DataTable.list.length;i++) {
                if(vm.DataTable.list[i].approval == 0) {
                    countCheckAvail++;
                }
            }
          return vm.listOtselected.length === countCheckAvail && vm.listOtselected.length > 0;
        } else {
          return false;
        }
    }

    function isIndeterminate() {
        if(typeof vm.DataTable.list != 'undefined') {
          var countCheckAvail = 0;
          for(var i=0; i<vm.DataTable.list.length;i++) {
              if(vm.DataTable.list[i].approval == 0) {
                  countCheckAvail++;
              }
          }
          return (
              vm.listOtselected.length > 0 &&
              vm.listOtselected.length !== countCheckAvail
          );
        } else {
          return false;
        }
    }


    function toggleCheck(ls, event) {
        if (event) {
            event.stopPropagation();
        }

        var idx = vm.listOtselected.indexOf(ls);

        if (idx > -1) {
            vm.listOtselected.splice(idx, 1);
        } else {
            vm.listOtselected.push(ls);
        }
    }

    function toggleSelectedAll() {
        if(typeof vm.DataTable.list != 'undefined') {
            var countCheckAvail = 0;
            for(var i=0; i<vm.DataTable.list.length;i++) {
                if(vm.DataTable.list[i].approval == 0) {
                    countCheckAvail++;
                }
            }
            if (vm.listOtselected.length === countCheckAvail) {
                unCheckAll();
            } else if (
                vm.listOtselected.length === 0 ||
                vm.listOtselected.length > 0
            ) {
                checkAll();
            }
        } else {
          return false;
        }
    }

    function checkAll() {
        for(var i=0; i<vm.DataTable.list.length;i++) {
            if(vm.DataTable.list[i].approval == 0) {
              if(vm.listOtselected.indexOf(vm.DataTable.list[i]) < 0) {
                vm.listOtselected.push(vm.DataTable.list[i]);
              }
            }
        }
    }

    function unCheckAll() {
        vm.listOtselected = [];
    }

    function deleteData(ev) {
      if(vm.listOtselected.length > 0) {
        var list = [];
        for(var i = 0; i < vm.listOtselected.length; i++) {
          list.push({id: vm.listOtselected[i].id});
        }

        var promise=Auth.setToken();
        promise.then(function(){
          var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

          $mdDialog.show(confirm).then(function() {
              angular.element.blockUI();
              var response=Teamassignment.delete({action:'delete',data:angular.toJson(list)});
              response.$promise.then( function(resData) {
                  angular.element.unblockUI();
                  var title = 'Success Delete Data';
                  var textContent = 'Process Delete data was Success';
                  var ariaLabel = 'Success Delete Data';
                  showDialogMessage(title,textContent,ariaLabel);
                  loadData(1);
              });
              response.$promise.catch( function() {
                  angular.element.unblockUI();
                  var title = 'Delete Data Failed';
                  var textContent = 'Process delete data has been failed.';
                  var ariaLabel = 'Delete Data Failed';
                  showDialogMessage(title,textContent,ariaLabel,ev);
              })
          }, function() {

          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          }); 
      }
    }

    function showDialogMessage(title,textContent,ariaLabel,ev) {
      $mdDialog.show(
      $mdDialog.alert()
      .parent(angular.element(document.querySelector('#contentDialog')))
      .clickOutsideToClose(true)
      .title(title)
      .textContent(textContent)
      .ariaLabel(ariaLabel)
      .ok('OK')
      .targetEvent(ev)
      ).then(function(){
          closeModal();
      });
    }

    function onCollapse() {
      if(vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
        vm.DataTable.searchParam = '';
        vm.loadData(1);
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.cb.am-team-assignment')
        .controller('AmeditTeamAssignmentController', AmeditTeamAssignmentController)
        .directive('customRepeatDirective', function () {
            return function (scope, element, attrs) {
                if (scope.$last) {
                    angular.element.unblockUI();
                }
            };
        });
    /* @ngInject */
    AmeditTeamAssignmentController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', 'config', 'edt', 'Auth', '$timeout'];

    /* @ngInject */
    function AmeditTeamAssignmentController($localStorage, $mdDialog, Form, AppAPI, config, edt, Auth, $timeout) {
        var vm = this;

        angular.element.blockUI();

        var Teamassignment = AppAPI.Teamassignment(); //memanggil api modules dari api
        Form.initialForm(false);
        Form.setObject(Teamassignment);
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.listType = [{
                id: 1,
                type: 'Hanya OT KHL'
            },
            {
                id: 2,
                type: 'Hanya OT Normal'
            },
            {
                id: 3,
                type: 'Semua Bisa'
            },
            {
                id: 4,
                type: 'Tidak Bisa OT'
            },
        ];

        vm.saveData = saveData;
        vm.closeModal = closeModal;
        vm.company = $localStorage.empsite;
        vm.loadDirectName = loadDirectName;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.getEmptyDataNIK = getEmptyDataNIK;
        vm.Breadhome = "app.pms_dashboard";
        vm.Breadlist = [{
            link: '#',
            name: 'Team Assignment',
            active: '0'
        }];

        vm.listType = ["employee", "sic", "department"];

        vm.new_employee = false;

        vm.noCache = true;
        vm.simulateQuery = false;

        vm.grade = null;

        // list of `state` value/display objects
        vm.selectedItem = [];
        vm.searchText = [];
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        vm.addEmployee = addEmployee;
        vm.cancelEmployee = cancelEmployee;
        vm.reinitEndDate = reinitEndDate;
        vm.directReportNamChanged = directReportNamChanged;

        vm.textLength = 0;
        vm.getStrLength = getStrLength;
        vm.getMinLength = getMinLength;
        vm.getDetailDirectReport = getDetailDirectReport;

        function getStrLength(textLength) {
            vm.textLength = typeof vm.Form.objForm.description != 'undefined' ? vm.Form.objForm.description.length : 0;
        }

        function getMinLength(textLength) {
            return typeof textLength != 'undefined' ? (textLength.length < 50 ? 'Masih dibawah 50 karakter' : textLength.length) : 'Masih dibawah 50 karakter';
        }

        var init_date = new Date();
        vm.initDate = new Date(init_date.setDate(init_date.getDate() + 14));

        var initemployee = {
            nik: null,
            new_employee: false,
            benefits: [],
            benefit: []
        };

        vm.Form.objForm.employee = [angular.copy(initemployee)];

        var nowDate = new Date();
        var minDate = angular.copy(nowDate);

        vm.Form.objForm.startDate = nowDate;
        vm.Form.objForm.endDate = new Date(minDate.setDate(minDate.getDate() + 14));

        vm.searchTermCCC = '';
        vm.clearSearchTermCCC = clearSearchTermCCC;
        vm.searchTermCCCNC = '';
        vm.clearSearchTermCCNC = clearSearchTermCCNC;
        vm.searchTermSA = '';
        vm.clearSearchTermSA = clearSearchTermSA;

        vm.reloadToken = reloadToken;

        function closeModal() {
            $mdDialog.hide();
        }

        loadEmp();
        loadDescription();
        loadDataBU();
        loadSubArea();
        loadBenefits();

        function loadDirectName() {
            var codeCDD = vm.Form.objForm.company_id + vm.Form.objForm.dvision_id + vm.Form.objForm.department_id;
            var subAreaID = vm.Form.objForm.sub_area_id;
            var response = Teamassignment.query({
                action: 'viewDirectReportName',
                cddcode: vm.codeCDD,
                sub_area_id: subAreaID
            });
            response.$promise.then(fetchDirectName);
            response.$promise.catch(errorDirectName);
        }

        function fetchDirectName(data) {
            vm.listDirectName = data;
            initCostCenter(vm.Form.objForm.sub_area_id);
        }

        function errorDirectName() {
            vm.listDirectName = [];
        }

        function loadEmp() {
            var response = Teamassignment.query({
                action: 'getEmployeTeam'
            });
            response.$promise.then(fetchEmp);
            response.$promise.catch(errorFetchEmp);
        }

        function fetchEmp(data) {
            vm.listEmp = data;
        }

        function errorFetchEmp() {
            vm.listBU = [];
        }

        function loadDescription() {
            var response = Teamassignment.query({
                action: 'viewDescriptionCostCenter'
            });
            response.$promise.then(fetchDescription);
            response.$promise.catch(errorDescription);
        }

        function fetchDescription(data) {
            vm.listcnb = data[0].cnb;
            vm.listnoncnb = data[0].noncnb;
        }

        function errorDescription() {
            vm.listcnb = [];
            vm.listnoncnb = [];
        }

        function loadDataDepartment(iddivisi) {
            var response = Teamassignment.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            var response = Teamassignment.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            // loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Teamassignment.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            var response = Teamassignment.query({
                action: 'viewSubArea'
            });
            response.$promise.then(fetchSubArea);
            response.$promise.catch(errorFetchSubArea);
        }

        function fetchSubArea(data) {
            vm.listSubArea = data;
        }

        function errorFetchSubArea() {
            vm.listSubArea = [];
        }

        function loadBenefits() {
            var response = Teamassignment.query({
                action: 'getBenefits'
            });
            response.$promise.then(fetchBenefits);
            response.$promise.catch(errorBenefits);
        }

        function fetchBenefits(data) {
            vm.listBenefits = data;
            for (var i = 0; i < data.length; i++) {
                vm.Form.objForm.employee[0].benefits[i] = null;
            }
        }

        function errorBenefits() {
            vm.listBenefits = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            angular.element.blockUI();

            vm.Form.objForm.startDate_resolved = changeDateFormat(vm.Form.objForm.startDate);
            vm.Form.objForm.endDate_resolved = changeDateFormat(vm.Form.objForm.endDate);

            var response = Form.saveData('saveData', formController, Teamassignment);
            response.then(function () {
                vm.messageTheme = 'blue';
                formController.$setPristine();
                showDialog();
                $timeout(function () {
                    vm.Form.tampilPesan = false;
                }, 3000);
            });
            response.catch(function () {
                vm.messageTheme = 'pink';
                angular.element.unblockUI();
            });
        }

        function showDialog() {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title('Success Save Data')
                .textContent('Process Data was Success.')
                .ariaLabel('Success Save Data')
                .ok('OK')
                .targetEvent()
            ).then(function () {
                closeModal();
            });
        }

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            var results = query ? vm.listEmp.filter(createFilterFor(query)) : vm.listEmp,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        function searchTextChange(idx) {
            var keys = Object.keys(vm.Form.objForm.employee[idx]);
            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != 'new_employee') {
                    vm.Form.objForm.employee[idx][keys[i]] = null;
                } else {
                    vm.Form.objForm.employee[idx]['new_employee'] = false;
                }
            }
        }

        function selectedItemChange(item, idx) {
            if (item) {
                var keys = Object.keys(item);
                for (var i = 0; i < keys.length; i++) {
                    if (keys[i] != 'new_employee') {
                        vm.Form.objForm.employee[idx][keys[i]] = item[keys[i]];
                    }

                    if (idx == 0) {
                        if (keys[i] == 'company_id') {
                            vm.Form.objForm.company_id = item[keys[i]];
                            vm.loadDataDivision(item[keys[i]]);
                        }

                        if (keys[i] == 'dvision_id') {
                            vm.Form.objForm.dvision_id = item[keys[i]];
                            vm.loadDataDepartment(item[keys[i]]);
                        }

                        if (keys[i] == 'department_id') {
                            vm.Form.objForm.department_id = item[keys[i]];
                        }
                    }
                }

                vm.Form.objForm.employee[idx].nik = item.nik;
                if (typeof vm.Form.objForm.employee[idx].benefit == 'undefined' || vm.Form.objForm.employee[idx].benefit == null) {
                    vm.Form.objForm.employee[idx].benefit = [];
                }
                console.log(vm.Form.objForm.employee[idx].benefit);
                for (var i = 0; i < vm.listBenefits.length; i++) {
                    if (item.nik) {
                        vm.Form.objForm.employee[idx].benefit[i] = item.emp_grade;
                    } else {
                        vm.Form.objForm.employee[idx].benefit[i] = null;
                    }
                }
            }
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(data) {
                return (data.display.toLowerCase().indexOf(lowercaseQuery) > -1);
            };

        }

        function addEmployee(e) {
            vm.Form.objForm.employee.push(angular.copy(initemployee));
        }

        function cancelEmployee(e, idx) {
            if (vm.Form.objForm.employee[idx]) {
                vm.Form.objForm.employee.splice(idx, 1);
            }
        }

        function reinitEndDate(date) {
            var var_date = angular.copy(date);
            vm.initDate = new Date(var_date.setDate(var_date.getDate() + 14));
            vm.Form.objForm.endDate = new Date(angular.copy(vm.initDate));
        }

        function clearSearchTermCCC() {
            vm.searchTermCCC = '';
        }

        function clearSearchTermCCNC() {
            vm.searchTermCCNC = '';
        }

        function clearSearchTermSA() {
            vm.searchTermSA = '';
        }

        function directReportNamChanged() {
            for (var i = 0; i < vm.listDirectName.length; i++) {
                if (vm.Form.objForm.directReport == vm.listDirectName[i].nik) {
                    vm.Form.objForm.directReport_type = 'employee';
                    if (vm.listDirectName[i].sic_id) {
                        vm.Form.objForm.directReport_type = 'sic';
                    }
                    if (vm.listDirectName[i].am_id) {
                        vm.Form.objForm.directReport_type = 'area manager';
                    }
                }
            }
        }

        function initCostCenter(sub_area_id) {
            for (var i = 0; i < vm.listSubArea.length; i++) {
                if (vm.listSubArea[i].id == sub_area_id) {
                    for (var j = 0; j < vm.listcnb.length; j++) {
                        if (vm.listSubArea[i].description.trim() == vm.listcnb[j].description.trim()) {
                            vm.Form.objForm.cost_center_cnb = vm.listcnb[j].id;
                        }
                    }

                    for (var j = 0; j < vm.listnoncnb.length; j++) {
                        if (vm.listSubArea[i].description.trim() == vm.listnoncnb[j].description.trim()) {
                            vm.Form.objForm.cost_center_noncnb = vm.listnoncnb[j].id;
                        }
                    }
                }
            }
        }

        function changeDateFormat(date) {
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var year = date.getFullYear();
            return year + "-" + month + "-" + day;
        }

        function reloadToken() {
            Auth.setToken();
        }

        function getEmptyDataNIK(value) {
            console.log(value);
            return typeof value != 'undefined' && value != null && value != '' ? false : true;
        }

        function getDetailDirectReport(data) {
            if(typeof data != 'undefined') {
                if(data.am_state == '1') {
                    return '(AREA MANAGER)';
                }

                if(data.sic_state == '1') {
                    return '(' + 'STORE MANAGER - ' + data.area_name + ')';
                }

                return '(' + data.job_description + ' - ' + data.area_name + ')';
            }

            return '';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.am-team-assignment')
        .controller('AmdetailTeamAssignmentController', AmdetailTeamAssignmentController);
    /* @ngInject */
    AmdetailTeamAssignmentController.$inject = ['$localStorage','$mdDialog','Form','AppAPI','config','data','detail','Auth'];

    /* @ngInject */
    function AmdetailTeamAssignmentController($localStorage,$mdDialog,Form,AppAPI,config,data,detail,state,approveFunction,Auth) {
        var vm = this;
    
        vm.close = close;
        vm.data = data;
        vm.detail = detail;
        vm.approveState = state;
        vm.approveSingle = approveFunction;
        
        vm.isNewEmployee = false;

        for(var i = 0; i < vm.detail.length; i++) {
            if(vm.detail[i].new_employee == '1') {
                vm.isNewEmployee = true;
            }
        }

        vm.listOfBenefits = [];
        if(vm.data.master_benefit.length > 0) {
            vm.listOfBenefits = vm.data.master_benefit[0].benefits;
        }

        var nik = $localStorage.user;
        vm.nik = nik;

        function close() {
          $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-store-incharge', ['app.cb.sic.am-input-sic'])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_am-store-incharge', {
                url    : '/cb/am-store-incharge',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-store-incharge/am-store-incharge.html',
                        controller : 'amStoreInchargeController as vm',
                        css: ['app/main/cb/am-store-incharge/am-store-incharge.scss']
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
  'use strict';

  angular
      .module('app.cb.am-store-incharge')
      .controller('amStoreInchargeController', amStoreInchargeController);
  
  /* @ngInject */
  amStoreInchargeController.$inject=['$state','$mdDialog','$window','$location','config','$log','AppAPI','Auth','DataService'];
  function amStoreInchargeController($state,$mdDialog,$window,$location,config,$log,AppAPI,Auth,DataService) {
    var vm = this;

    var StoreIncharge=AppAPI.AMStoreIncharge();

    vm.DataTable = new DataService();
    vm.loadData = loadData;
		vm.listJum = [2,5,25,50,75,100,200];
		vm.listSicSelected = [];
		vm.editData = editData;
		vm.deleteSIC = deleteSIC;
		vm.ExportToExcel = ExportToExcel;
    vm.toggle = toggle;
    vm.onCollapse = onCollapse;
    vm.newMapping = newMapping;

    loadData(1);		
    //////////////////

    function loadData(pageno) {
      vm.DataTable.loadData(StoreIncharge, pageno, {action:'viewData'});
    }
		
		function editData(id) {
		  $state.go('app.cb_sic_am-edit-sic', {id:encodeURIComponent(window.btoa(id))});	
		}
		
		function deleteSIC(ev) {
      var jum=vm.listSicSelected.length,i,ids=[];
      if(jum>0)
      {
        var promise = Auth.setToken();
        promise.then(function() {
          var confirm = $mdDialog.confirm().title('Would you like to delete this list?')
                                  .textContent('All data your selected will be deleted and can not recovered.')
                                  .ariaLabel('delete dialog')
                                  .targetEvent(ev)
                                  .ok('YES')
                                  .cancel('no');
          
          $mdDialog.show(confirm).then(function() {
            angular.element.blockUI();
            var response = StoreIncharge.delete({action:'delete', data:angular.toJson(vm.listSicSelected)});
            
            response.$promise.then(function(){
              loadData(1);
            });
          }, function() {
            
          });
        });
      }else{
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Attention!')
        .textContent('No data selected')
        .ariaLabel('Attention')
        .ok('close')
        .targetEvent(ev)
        ).then(function(){
          vm.listSicSelected=[];
            loadData(1);
        });
      } 
		} 

		function ExportToExcel() {
		  var search = vm.DataTable.searchParam;
  	  if(!search) 
  		  search = 0;

      var token=Auth.setTokenPromise();
      token.then(function(data){
        var protocol=$location.protocol();
        var host=$location.host();
        $window.open(protocol+'://'+host+'/'+config.api+'api/amstoreincharge/exportexcel/' + search, '_blank');
      },function(){
        $window.alert('gagal load token');
      });
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
    }

    function onCollapse() {
      if(vm.DataTable.searchParam && typeof vm.DataTable.searchParam !== 'undefined') {
        vm.DataTable.searchParam = '';
        vm.loadData(1);
      }
    }

    function newMapping(ev)
    {
      var jum=vm.listSicSelected.length,i,ids=[];
      if(jum>0)
      {
        $mdDialog.show({
          controller: 'amTeamMappingController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/am-sic-team/am-sic-team-mapping.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
            vm.listSicSelected=[];
            loadData(1);
          },
          locals:{
            id:vm.listSicSelected
          }
        }); 
      }else{
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
            vm.listSicSelected=[];
            loadData(1);
          });
        } 
      }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-sic-team', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_am_sic_team', {
                url    : '/cb/sic-team',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-sic-team/am-sic-team.html',
                        controller : 'SicteamController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-sic-team')
        .controller('SicteamController', SicteamController);


    SicteamController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function SicteamController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Sicteam=AppAPI.Sicteam();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];  
      vm.newMapping=newMapping;
      vm.loadFinish=false;
      // vm.Reject=Reject;

      vm.icon = "icon-plus";
      vm.result = false;
      vm.toogleSubChild=toogleSubChild;
      vm.visibleSubChild=[];
         
      loadData();
 
        //////////
    
    
    function loadData()
    {
      var response=Sicteam.query({action:'viewdata'});
      response.$promise.then(fetchEmpOutlet);
      response.$promise.catch(errorFetchEmpOutlet);
    }

    function fetchEmpOutlet(data)
    {
       vm.listEmpOutlet=data;
       console.log(vm.listEmpOutlet);
       vm.loadFinish=true;
    }

    function errorFetchEmpOutlet()
    {
       vm.loadFinish=true;
    }
  

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

     

    function toogleSubChild(idx) {
      switch(vm.visibleSubChild[idx])
        {
            case true :
            vm.visibleSubChild[idx]=false;
            vm.icon='icon-minus';
            break;
            case false :
            vm.visibleSubChild[idx]=true;
             vm.icon='icon-plus';
            break;
            default:
               vm.visibleSubChild[idx]=true;
                vm.icon='icon-minus';
            break;
        }

    }

    function newMapping(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          $mdDialog.show({
              controller: 'amTeamMappingController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/am-sic-team/am-sic-team-mapping.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                vm.listOtselected=[];
                  loadData();
              },
              locals:{
                id:vm.listOtselected
              }
          }); 
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
            vm.listOtselected=[];
              loadData();
          });
        } 
      }

      

    }
})();

(function() {
    'use strict';

    angular
        .module('app.cb.am-sic-team')
        .controller('amTeamMappingController', amTeamMappingController);

    
    /* @ngInject */
    amTeamMappingController.$inject=['$mdDialog','$http','id','config','Form','AppAPI','Auth'];
    function amTeamMappingController($mdDialog,$http,id,config,Form,AppAPI,Auth) {
        var vm = this;
       
        vm.cancel=cancel;
        vm.isDisabled=false;
        vm.saveMapping=saveMapping;
        vm.messageTheme='';
         // initial form
        Form.initialForm();

         // get constructor form
        var Employeoutletteam=AppAPI.Employeoutletteam();
        var Sicmapping=AppAPI.Sicmapping();

         // set constructor form
        Form.setObject(Sicmapping);

        // set form to controller
        vm.Form = Form; 

        var i;
        for (i = 0; i < id.length; i++) {
          id[i].effective_date = new Date();
        }

        vm.searchTermSA = [];
        vm.clearSearchTermSA = clearSearchTermSA;

        vm.Form.objForm.listSic=id;
        // loadData(); 
        loadOutletList();
        vm.setToken=Auth.setToken;

        ////////////////
        function hide()
        {
        	  $mdDialog.hide();
        }
       
       function cancel()
       {
       	  $mdDialog.cancel();
       }


     
        // function loadData()
        // {
        //   var response=Employeoutletteam.query({action:'loadSic'});
        //   response.$promise.then(fetchSic);
        //   response.$promise.catch(errorFetchSic);
        // }

        // function fetchSic(data)
        // {
        //    vm.Form.objForm.listSic=data;
        // }

        // function errorFetchSic()
        // {
           
        // }

        function loadOutletList()
        {
          var response=Employeoutletteam.query({action:'getOutletList'});
          response.$promise.then(fetchOutlet);
          response.$promise.catch(errorFetchOutlet);
        }

        function fetchOutlet(data)
        {
           vm.listOutlet=data;
        }

        function errorFetchOutlet()
        {
           
        }

      function cancel()
       {
          $mdDialog.cancel();
       }
    

     function saveMapping(ev,formController)
     {

        // console.log(vm.Form.objForm);
         var promise= Form.saveData('save', formController, Sicmapping);

         promise.then(succesSaveMapping);
         promise.catch(faileSaveMapping);
     }

    function succesSaveMapping()
    {
       vm.messageTheme='green';
    }

    function faileSaveMapping()
    {
       vm.messageTheme='red';

    }

      function clearSearchTermSA(idx) {
        vm.searchTermSA.splice(idx, 1);
      }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-sic-mapping-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_am_sic_mapping_approval', {
                url    : '/cb/sic-mapping-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-sic-mapping-approval/am-sic-mapping-approval.html',
                        controller : 'AmSicMappingApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-sic-mapping-approval')
        .controller('AmSicMappingApprovalController', AmSicMappingApprovalController);


    AmSicMappingApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function AmSicMappingApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Sicmappingapproval=AppAPI.Sicmappingapproval();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];  
      vm.Approve=Approve;
      vm.setViewTeam=setViewTeam;

      vm.icon = "icon-plus";
      vm.result = false;
      vm.toogleSubChild=toogleSubChild;
      vm.visibleSubChild=[];
         
      loadData(1);
 
        //////////
    
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Sicmappingapproval,pageno,{action:'viewdata'});
      vm.listOtselected=[];
    }
     
  

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

     

    function toogleSubChild(idx) {
      switch(vm.visibleSubChild[idx])
        {
            case true :
            vm.visibleSubChild[idx]=false;
            vm.icon='icon-minus';
            break;
            case false :
            vm.visibleSubChild[idx]=true;
             vm.icon='icon-plus';
            break;
            default:
               vm.visibleSubChild[idx]=true;
                vm.icon='icon-minus';
            break;
        }

    }

    function Approve(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    // console.log(vm.listOtselected);
                    var ot= new Sicmappingapproval();
                    ot.data=[];
                    ot.action='approve';
                    ot.nik=nik;  
                    for (i=0;i<jum;i++) {
                      ot.data.push({id:vm.listOtselected[i].id});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    //var response=tm.$delete({action:'approve'});
                    response.then(loadData);
                    response.catch( function(data){
                        $mdDialog.show(
                            $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#contentDialog')))
                            .clickOutsideToClose(true)
                            .title('Attention!')
                            .textContent(data.data.pesan)
                            .ariaLabel('Attention')
                            .ok('close')
                            .targetEvent(ev)
                            ).then(function(){
                                loadData();
                            });
                      angular.element.unblockUI();
                    });
                }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
            }); 
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

      function setViewTeam(ev,id)
      {
        $mdDialog.show({
                controller         : 'viewTeamMappingtController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/hr-crew-mapping-approval/view-team-mapping.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            });
      }
      

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.am-sic-mapping', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_am_sic_mapping', {
                url    : '/cb/sic-mapping',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-sic-mapping/am-sic-mapping.html',
                        controller : 'AmSicMappingController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.am-sic-mapping')
        .controller('sicnewMappingController', sicnewMappingController);

    
    /* @ngInject */
    sicnewMappingController.$inject=['$mdDialog','$http','config','Form','AppAPI','Auth'];
    function sicnewMappingController($mdDialog,$http,config,Form,AppAPI,Auth) {
        var vm = this;
       
        vm.cancel=cancel;
        vm.isDisabled=false;
        vm.saveMapping=saveMapping;
        vm.messageTheme='';
         // initial form
        Form.initialForm();

         // get constructor form
        var Sicmapping=AppAPI.Sicmapping();

         // set constructor form
        Form.setObject(Sicmapping);

        // set form to controller
        vm.Form = Form; 

        loadData(); 
        loadOutletList();
        vm.setToken=Auth.setToken;

        ////////////////
        function hide()
        {
        	  $mdDialog.hide();
        }
       
       function cancel()
       {
       	  $mdDialog.cancel();
       }

     
        function loadData()
        {
          var response=Sicmapping.query({action:'loadSic'});
          response.$promise.then(fetchSic);
          response.$promise.catch(errorFetchSic);
        }

        function fetchSic(data)
        {
           vm.Form.objForm.listSic=data;
        }

        function errorFetchSic()
        {
           
        }

        function loadOutletList()
        {
          var response=Sicmapping.query({action:'getOutletList'});
          response.$promise.then(fetchOutlet);
          response.$promise.catch(errorFetchOutlet);
        }

        function fetchOutlet(data)
        {
           vm.listOutlet=data;
        }

        function errorFetchOutlet()
        {
           
        }

      function cancel()
       {
          $mdDialog.cancel();
       }
    

     function saveMapping(ev,formController)
     {

        // console.log(vm.Form.objForm);
         var promise= Form.saveData('save', formController, Sicmapping);

         promise.then(succesSaveMapping);
         promise.catch(faileSaveMapping);
     }

    function succesSaveMapping()
    {
       vm.messageTheme='green';
    }

    function faileSaveMapping()
    {
       vm.messageTheme='red';

    }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-sic-mapping')
        .controller('AmSicMappingController', AmSicMappingController);


    AmSicMappingController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function AmSicMappingController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Sicmapping=AppAPI.Sicmapping();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[]; 
      vm.NewMapping=NewMapping;
      vm.setViewTeam=setViewTeam;

      vm.icon = "icon-plus";
      vm.result = false;
      vm.toogleSubChild=toogleSubChild;
      vm.visibleSubChild=[];
         
      loadData(1);
 
        //////////
    
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Sicmapping,pageno,{action:'viewdata'});
      vm.listOtselected=[];
    }
     
  

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

    function NewMapping(ev)
    {
      $mdDialog.show({
        controller: 'sicnewMappingController',
        controllerAs:'vm',
        templateUrl: 'app/main/cb/am-sic-mapping/new-mapping.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        locals:{ 
        },
        onRemoving:function(element, removePromise)
        {
          loadData();
        },
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function toogleSubChild(idx) {
      switch(vm.visibleSubChild[idx])
        {
            case true :
            vm.visibleSubChild[idx]=false;
            vm.icon='icon-minus';
            break;
            case false :
            vm.visibleSubChild[idx]=true;
             vm.icon='icon-plus';
            break;
            default:
               vm.visibleSubChild[idx]=true;
                vm.icon='icon-minus';
            break;
        }

    }

    function setViewTeam(ev,id)
      {
        $mdDialog.show({
                controller         : 'viewTeamMappingtController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/hr-crew-mapping-approval/view-team-mapping.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            });
      }
        

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.am-outlet-mapping-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_outlet_mapping_approval', {
                url    : '/cb/outlet-mapping-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-outlet-mapping-approval/am-outlet-mapping-approval.html',
                        controller : 'AmOutletMappingApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-outlet-mapping-approval')
        .controller('AmOutletMappingApprovalController', AmOutletMappingApprovalController);


    AmOutletMappingApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function AmOutletMappingApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Amoutletmappingapproval=AppAPI.Amoutletmappingapproval();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];  
      vm.Approve=Approve;
      // vm.Reject=Reject;

      vm.icon = "icon-plus";
      vm.result = false;
      vm.toogleSubChild=toogleSubChild;
      vm.visibleSubChild=[];
      vm.setViewTeam=setViewTeam;
         
      loadData(1);
 
        //////////
    
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Amoutletmappingapproval,pageno,{action:'viewdata'});
      vm.listOtselected=[];
    }
     
  

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

     

    function toogleSubChild(idx) {
      switch(vm.visibleSubChild[idx])
        {
            case true :
            vm.visibleSubChild[idx]=false;
            vm.icon='icon-minus';
            break;
            case false :
            vm.visibleSubChild[idx]=true;
             vm.icon='icon-plus';
            break;
            default:
               vm.visibleSubChild[idx]=true;
                vm.icon='icon-minus';
            break;
        }

    }

    function Approve(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    // console.log(vm.listOtselected);
                    var ot= new Amoutletmappingapproval();
                    ot.data=[];
                    ot.action='approve';
                    ot.nik=nik;  
                    for (i=0;i<jum;i++) {
                      ot.data.push({id:vm.listOtselected[i].id});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    //var response=tm.$delete({action:'approve'});
                    response.then(function(data){
                        $mdDialog.show(
                            $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#contentDialog')))
                            .clickOutsideToClose(true)
                            .title('Success')
                            .textContent(data.pesan)
                            .ariaLabel('Success')
                            .ok('close')
                            .targetEvent(ev)
                            ).then(function(){
                                loadData();
                            });
                      angular.element.unblockUI();
                    });
                    response.catch( function(data){
                        $mdDialog.show(
                            $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#contentDialog')))
                            .clickOutsideToClose(true)
                            .title('Attention!')
                            .textContent(data.data.pesan)
                            .ariaLabel('Attention')
                            .ok('close')
                            .targetEvent(ev)
                            ).then(function(){
                                loadData();
                            });
                      angular.element.unblockUI();
                    });
                }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
            }); 
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

      function setViewTeam(ev,id)
      {
        $mdDialog.show({
                controller         : 'viewTeamMappingtController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/hr-crew-mapping-approval/view-team-mapping.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            });
      }
      

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.am-leave-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_am_leave_approval', {
                url    : '/cb/area-manager-leave-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-leave-approval/am-leave-approval.html',
                        controller : 'AmLeaveApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.am-leave-approval')
        .controller('AmLeaveRejectCommentController', AmLeaveRejectCommentController);

    AmLeaveRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function AmLeaveRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Approvalabsence = AppAPI.Approvalabsence();

        // set constructor form
        Form.setObject(Approvalabsence);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;
        // console.log(id);

    function saveData(ev,formController)
        { 
            var promise= Form.saveData('reject', formController, Approvalabsence);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-leave-approval')
        .controller('AmLeaveApprovalController', AmLeaveApprovalController);


    AmLeaveApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$location','$http','config'];
    /** @ngInject */
    function AmLeaveApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$location,$http,config)
    {
        
      var vm = this; 
      vm.editData=editData;
      vm.deleteData=deleteData;
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Approvalabsence=AppAPI.Amleaveapproval();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveOT=approveOT;
      vm.ViewDocument=ViewDocument;
      vm.UnApproved=UnApproved;
      vm.Reject=Reject;
      vm.UnReject=UnReject;
      vm.viewComment=viewComment;  
      var Employeshiftt=AppAPI.Overtime(); 

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      vm.tgl=date.getDate();
      if(vm.tgl >=20 && vm.tgl <=31)
      {
        vm.bulan=vm.bulan+1;
      }
      if(vm.bulan < 10){
        vm.bulan='0'+vm.bulan;
      }

      vm.listtahun=[2017,2018,2019,2020,2021];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
    
    getPeriode();  
    

    //////////
    loadData(1);
    
    function loadData(pageno)
    {
      var company='all';
      var divisi='all';
      var department='all';
      var resp=vm.DataTable.loadData(Approvalabsence,pageno,{action:'viewdata',company:company,divisi:divisi,departement:department,bulan:vm.bulan,tahun:vm.tahun});
      vm.listOtselected=[];
    }

    function getPeriode(){
        var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
      }

      function fetchPeriode(data)
      {
        vm.periode=data[0]['periode'];
        // console.log(vm.periode);
        loadData(1);
      }

      function errorfetchPeriode(data)
      {
        console.log('error');
      }
     

    function editData(id) {
        $state.go('app.cb_employe_overtime_edit_employe_ot',{id:id});
    }

    function deleteData(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=BU.delete({action:'delete',data:angular.toJson(vm.listBuSelected)});

       response.$promise.then(viewDataBu);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function approveOT(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
           var promise=Auth.setToken();
           promise.then(function(){
                var confirm = $mdDialog.confirm()
                .title('Would you like to Approve this list?')
                .textContent('All data your selected will be approve.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');
            $mdDialog.show({
                  multiple: true
             });      
            $mdDialog.show(confirm).then(function() {
                  angular.element.blockUI();
                  // console.log(vm.listOtselected);
                  var ot= new Approvalabsence();
                  ot.data=[];
                  ot.action='approve';
                  ot.nik=nik;
                  ot.approval_type='n1';  
                  for (i=0;i<jum;i++) {
                    ot.data.push({id:vm.listOtselected[i].id});
                  }
                  var idtx=encodeURIComponent(angular.toJson(ids));
                  var response=ot.$save();  
                  response.then(loadData);
                  response.catch(function(){
                    angular.element.unblockUI();
                  });
              }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 

      }

     function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
        //  var promise=Auth.setToken();
        //  promise.then(function(){
        //       var confirm = $mdDialog.confirm()
        //       .title('Would you like to Reject this list?')
        //       .textContent('All data your selected will be Reject.')
        //       .ariaLabel('delete dialog')
        //       .targetEvent(ev)
        //       .ok('YES')
        //       .cancel('no');
        //   $mdDialog.show({
        //         multiple: true
        //    });      
        //   $mdDialog.show(confirm).then(function() {
        //         angular.element.blockUI();
        //         // console.log(vm.listOtselected);
        //         var ot= new Approvalabsence();
        //         ot.data=[];
        //         ot.action='reject';
        //         ot.nik=nik;
        //         ot.approval_type='n1';  
        //         for (i=0;i<jum;i++) {
        //           ot.data.push({id:vm.listOtselected[i].id});
        //         }
        //         var idtx=encodeURIComponent(angular.toJson(ids));
        //         var response=ot.$save(); 
        //         //var response=tm.$delete({action:'approve'});
        //         response.then(loadData);
        //         response.catch( function(){
        //             angular.element.unblockUI();
        //           });
        //     }, function() {
        //    // $scope.status = 'You decided to keep your debt.';
        //   });
        // });

          $mdDialog.show({
                controller         : 'AmLeaveRejectCommentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/approval-absence/comment-reject.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                    vm.listOtselected=[];
                },
                locals:{
                  id:vm.listOtselected
                }
            });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

      function ViewDocument(name)
        {
            // var protocol=$location.protocol();
            // var host=$location.host();
            // $window.open(protocol+'://'+host+'/'+config.api+'api/empdocument/'+link, '_blank'); 

            // console.log(protocol+'  /  '+host+'  /   '+config.api);
            // var url=config.api+'api/empdocument/'+link;
            $http({
                    method: 'GET',
                    url: config.api+'api/leavedocument/'+name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];
             
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);
             
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
             
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
        }

      function UnApproved(ev,id)
      {
        var promise=Auth.setToken();
         promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

        $mdDialog.show(confirm).then(function() {
         angular.element.blockUI();
         var response=Approvalabsence.delete({action:'unapproved',data:angular.toJson(id)});

         response.$promise.then(loadData);
            }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
         });
      }
  
    function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'AbsenceViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/approval-absence/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              vm.listOtselected=[];
          },
          locals:{
            id:id
          }
      });
    }

  function UnReject(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
      angular.element.blockUI();
      var response=Approvalabsence.delete({action:'unreject',data:angular.toJson(id)});
      response.$promise.then(loadData);
      response.$promise.catch(function(){
        angular.element.unblockUI();
      });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.am-changeshift-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_am_changeshift_approval', {
                url    : '/cb/area-manager-changeshift-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-changeshift-approval/am-changeshift-approval.html',
                        controller : 'AmchangeshiftApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-changeshift-approval')
        .controller('AmchangeshiftApprovalController', AmchangeshiftApprovalController);


    AmchangeshiftApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function AmchangeshiftApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Changeshiftapproval=AppAPI.Changeshiftapproval();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveChangeshift=approveChangeshift;
         
      
 
        //////////
    loadData(1);
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Changeshiftapproval,pageno,{action:'viewdata',nik:nik});
      vm.listOtselected=[];
    }
     
  

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function approveChangeshift(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Changeshiftapproval();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id,
                                idshift:vm.listOtselected[i].idshift,
                                nik:vm.listOtselected[i].nik,
                                tgl:vm.listOtselected[i].tgl});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
                response.catch( function(){
                  angular.element.unblockUI();
                });
            }, function() {
              // $scope.status = 'You decided to keep your debt.';
              // angular.element.unblockUI();
          });
        });

      } 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.am-approval-ot', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_am_approval_ot', {
                url    : '/cb/area-manager-approval-ot',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-approval-ot/am-approval-ot.html',
                        controller : 'AmapprovalotController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-approval-ot')
        .controller('AmapprovalotController', AmapprovalotController);


    AmapprovalotController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$log'];
    /** @ngInject */
    function AmapprovalotController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$log)
    {
        
      var vm = this; 
      vm.editData=editData;
      vm.deleteData=deleteData;
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Approvalot=AppAPI.Amapprovalot();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveOT=approveOT;
      vm.setViewTeam=setViewTeam;
      vm.UnApproved=UnApproved;
      vm.Reject=Reject;
         
      
 
        //////////
    loadData(1);

    vm.currentot=0;
    vm.periode="";
    var res= Approvalot.query({action:'getCurrentOt'});
          res.$promise.then(function(data){
           vm.currentot=vm.currentot + data[0].overtime;
           vm.periode=data[0].periode;
          console.log(data);
        });

        res.$promise.catch(function(data){
          $log.info(data);
        });
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(Approvalot,pageno,{action:'viewdata',nik:nik});
      vm.listOtselected=[];
    }
     

    function editData(id) {
        $state.go('app.cb_employe_overtime_edit_employe_ot',{id:id});
    }

    function deleteData(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=BU.delete({action:'delete',data:angular.toJson(vm.listBuSelected)});

       response.$promise.then(viewDataBu);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function approveOT(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Approvalot();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function Reject(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Reject this list?')
              .textContent('All data your selected will be Reject.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Approvalot();
                ot.data=[];
                ot.action='reject';
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function setViewTeam(ev,id)
      {
        $mdDialog.show({
                controller         : 'EmployeeOtteamController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/cb/employe-overtime/employeeot-team.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true,
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                locals:{
                  id:id
                }
            });
      }

      function UnApproved(ev,id)
      {
        var promise=Auth.setToken();
         promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

        $mdDialog.show(confirm).then(function() {
         angular.element.blockUI();
         var response=Approvalot.delete({action:'unapproved',data:angular.toJson(id)});

         response.$promise.then(loadData);
            }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
         });
      } 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.am-approval-ghk', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_am_approval_ghk', {
                url    : '/cb/area-manager-approval-ghk',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-approval-ghk/am-approval-ghk.html',
                        controller : 'AmapprovalghkController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-approval-ghk')
        .controller('AmapprovalghkController', AmapprovalghkController);


    AmapprovalghkController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function AmapprovalghkController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this; 
      vm.editData=editData;
      vm.deleteData=deleteData;
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Approvalghk=AppAPI.Approvalghk();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveOT=approveOT;
      vm.Reject=Reject;
      loadData();
      
 
    /////////////////////

    function loadData() {
        angular.element.blockUI();
         var response=Approvalghk.query({action:'viewdata'});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listGhk=data;
        angular.element.unblockUI();
      }

      function errorDepartment() {
        vm.listGhk=[];
        angular.element.unblockUI();
      }



    function editData(id) {
        $state.go('app.cb_employe_overtime_edit_employe_ot',{id:id});
    }

    function deleteData(ev) {
   
      var promise=Auth.setToken();
       promise.then(function(){
              var confirm = $mdDialog.confirm()
          .title('Would you like to delete this list?')
          .textContent('All data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

    $mdDialog.show(confirm).then(function() {
        angular.element.blockUI();
       var response=BU.delete({action:'delete',data:angular.toJson(vm.listBuSelected)});

       response.$promise.then(viewDataBu);
    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
       });
  
   
    }

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function approveOT(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Approvalghk();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik; 
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

    function Reject(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Reject this list?')
              .textContent('All data your selected will be Reject.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Approvalghk();
                ot.data=[];
                ot.action='reject'; 
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      } 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.am-abnormal-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_am_abnormal_approval', {
                url    : '/cb/am-abnormal-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/am-abnormal-approval/am-abnormal-approval.html',
                        controller : 'AmabnormalApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.am-abnormal-approval')
        .controller('AmabnormalApprovalController', AmabnormalApprovalController);


    AmabnormalApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function AmabnormalApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Abnormalapproval=AppAPI.Amabnormalapproval();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveAbnormal=approveAbnormal;
      vm.Reject=Reject;
         
      loadData();
 
        ////////// 
    
    // function loadData(pageno)
    // {
    //   var resp=vm.DataTable.loadData(Abnormalapproval,pageno,{action:'viewdata',nik:nik});
    //   vm.listOtselected=[];
    // }

    function loadData() {
        angular.element.blockUI();
         var response=Abnormalapproval.query({action:'viewdata'});
        response.$promise.then(fetchDepartment);
        response.$promise.catch(errorDepartment);
      }

      function fetchDepartment(data) {
        vm.listApp=data;
        // loadData(1);
        // console.log(vm.listApp);
        angular.element.unblockUI();
      }

      function errorDepartment() {
        vm.listApp=[];
        angular.element.unblockUI();
      }
     

    

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function approveAbnormal(ev)
      {
        console.log(vm.listOtselected);
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                console.log(vm.listOtselected);
                var ot= new Abnormalapproval();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id
                                });
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function Reject(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Reject this list?')
              .textContent('All data your selected will be Reject.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Abnormalapproval();
                ot.data=[];
                ot.action='reject';
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      } 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.administrator', [])
        .config(config);

         config.$inject=['$stateProvider'];

    /** @ngInject */
   /** @ngInject */
   function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.cb_administrator', {
                url    : '/cb/administration',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/administrator/administrator.html',
                        controller : 'AdministratorController as vm'
                    }
                }
            });

       
        

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.administrator')
        .controller('AdministratorController', AdministratorController);


    AdministratorController.$inject=['$state','$localStorage','$http','$scope','$document','config','$log','$mdDialog','AppAPI','Auth','DataService','FileUploader'];
    /** @ngInject */
    function AdministratorController($state,$localStorage,$http,$scope,$document,config,$log,$mdDialog,AppAPI,Auth,DataService,FileUploader)
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData;
        vm.editData=editData; 
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.listModulSelected=[];
        vm.IMportFile=IMportFile;
        vm.EmpKeyUp=EmpKeyUp;
        var Group=AppAPI.Group();
        var Administration=AppAPI.Administration(); 
        var Attendance=AppAPI.Attendance();

        vm.openUploadPhoto=openUploadPhoto;
        vm.closeModal=closeModal; 
        vm.uploadFile=uploadFile;
        vm.UploadPhotoStateSucces=false;
        vm.UploadPhotoStateError=false;

        vm.Breadhome="app.cb";
        vm.Breadlist=[ 
                    {link:'#',name:'C&B',active:'0'}
                    ]; 
        vm.listperiode=[{name:"Pembayaran Gaji",value:'Pembayaran Gaji'},
                        {name:"Buku Tabungan",value:'Buku Tabungan'} 

                      ];
        vm.listyears=[{name:"2016",value:"2016"},{name:"2017",value:"2017"}];
        vm.simulateQuery = false;
        vm.isDisabled    = false; 
        vm.querySearch   = querySearch;
        vm.selectedItemChanged = selectedItemChanged;
        // vm.searchTextChange   = searchTextChange;


        var response= Group.query({action:'listGroupSelect'});
            response.$promise.then(function(data){
             vm.listGroupSelect=data;
             // console.log(vm.listGroupSelect);
          });

          response.$promise.catch(function(data){
            $log.info(data);
          });

        $scope.$watch('vm.emp_no',function(){
          if(typeof vm.emp_no != 'undefined'){
            var Lempno=vm.emp_no.length;
            console.log('empno > '+Lempno);
          } 
        });

        // loadData(1);
        ////////// 

        function loadData(pageno){
           vm.DataTable.loadData(Administration,pageno,{action:'viewdata',activity:vm.activity,fromdate:vm.fromdate,untildate:vm.untildate});
           // console.log('test');
        }

        // function loadData(pageno)
        // {
        //   angular.element.blockUI();
        //   var emp_no=vm.emp_no;
        //   var periode=vm.periode;
        //   var years= vm.years;
        //   // console.log(emp_no+'/'+periode+'/'+years);
        //   var response=Attendance.query({action:'viewdata',emp_no:emp_no,periode:periode,years:years});
        //       response.$promise.then(function(data){
        //         vm.listData=data[0];
        //         console.log(vm.listData.list);
        //         angular.element.unblockUI();
        //       });
        //       response.$promise.catch(function(data){
        //         $log.info(data);
        //         angular.element.unblockUI();
        //       });

        //     vm.DataTable.loadData(Attendance,pageno,{action:'viewdata',emp_no:emp_no,periode:periode,years:years});
        // }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 
        function editData(id){ 
          $state.go('app.utility_modul_edit-modul',{id:id});
        }

      function IMportFile(ev) {
        angular.element.blockUI();
        var response= Attendance.query({action:'getDataAttendance'});
        response.$promise.then(function(data){
          console.log(data[0].message);
           $mdDialog.show(
                $mdDialog.alert()
                  .parent(angular.element(document.querySelector('#popupContainer')))
                  .clickOutsideToClose(true)
                  .parent(angular.element(document.body))
                  .title('Attendance Update Message')
                  .textContent(data[0].message)
                  .ariaLabel('Alert Dialog Demo')
                  .ok('Got it!')
                  .targetEvent(ev)
              );
          angular.element.unblockUI();
        });
        response.$promise.catch(function(data){

          console.log(data.message);
          angular.element.unblockUI();
        }); 
      }

      function EmpKeyUp(){
        if(vm.emp_no.length >=8){
          var resp=Attendance.query({action:'getDataEmp',empNo:vm.emp_no});
          resp.$promise.then(function(data){
            // console.log(data);
          });
          resp.$promise.catch(function(){

          });
        }
      }

      function querySearch (query) { 
           return $http
          .get(config.api + 'api/attendance?action=searchEmp&id=' + query)
          .then(function(item) {
            // Map the response object to the data object.
            if(item.data.length===''){

            }   
              return item.data;
          });
        }
        // function searchTextChange(text) {
        //   $log.info('Text changed to ' + text);
        // }

        function selectedItemChanged(item) {
          // vm.emp_no='';
          // vm.emp_name=vm.searchString;
          if(typeof item!=='undefined')
          { 
            vm.emp_no=item.emp_no;
            vm.empId=item.empId;
            vm.emp_name=item.nama;
            vm.position=item.position;
            vm.isDisabled=true; 
          }
          // console.log('test');
        }

        function openUploadPhoto(ev)
        {
            $mdDialog.show({
                controller         : 'AdministratorController as vm',
                templateUrl        : 'app/main/cb/administrator/upload-file.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        var uploaderPhoto= vm.FileUploaderPhoto= new FileUploader({
           url:config.api+'api/administration/uploadfile', 
           removeAfterUpload:true,
           alias:'fileadm',
           formData:[
              {
               action:'uploadfile'
              }
           ],
            onAfterAddingAll:function(){
                vm.UploadPhotoStateSucces=false;
                vm.UploadPhotoStateError=false;
             },
             headers:{
                tokenAuth:$localStorage.tokenAuth
              }
        }); 

        uploaderPhoto.onSuccessItem = function(item) {
            vm.UploadPhotoStateSucces=true;
            vm.UploadPhotoStateError=false; 
            angular.element('#uploaderPhoto').val('');
        };

        uploaderPhoto.onErrorItem=function()
        {
             vm.UploadPhotoStateSucces=false;
             vm.UploadPhotoStateError=true;
        }; 

        function uploadFile() {
            return false;
        }

        function closeModal()
        {
            $mdDialog.hide();
        }
         
        

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.admin-department', ['app.cb.admin-department.input'])
        .config(config);  

    config.$inject=['$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_admin_department', {
                url    : '/cb/admin-department',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/admin-department/index.html',
                        controller : 'AdminDepartmentController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.admin-department')
        .controller('AdminDepartmentController', AdminDepartmentController);


    AdminDepartmentController.$inject=['$state','$log','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$document'];
    /** @ngInject */
    function AdminDepartmentController($state,$log,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$document)
    {
        
      var vm = this; 
      vm.deleteData=deleteData;
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var AdminDepartment=AppAPI.AdminDepartment();
      // var Attendanceemploye=AppAPI.Attendanceemploye(); 
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listselected=[];
      vm.editData = editData;


      vm.create = create;


      loadData(1);
    ////////// 
     
    
    function loadData(pageno)
    {
      var resp=vm.DataTable.loadData(AdminDepartment,pageno,{action:'viewdata'});
    }
     

    function isChecked(ls)
        {
            return vm.listselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listselected.splice(idx, 1);
          }
          else
          {
              vm.listselected.push(ls);
          }
      }

    function deleteData(ev) {

        if ( vm.listselected.length > 0) {
          var promise=Auth.setToken();
          promise.then(function(){
            var confirm = $mdDialog.confirm()
            .title('Would you like to delete this list?')
            .textContent('All data your selected will be deleted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

            $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var response=AdminDepartment.delete({action:'delete',data:angular.toJson(vm.listselected)});
                response.$promise.then( function(resData) {
                    angular.element.unblockUI();
                    var title = 'Success Delete Data';
                    var textContent = 'Process Delete data was Success';
                    var ariaLabel = 'Success Delete Data';
                    showDialogMessage(title,textContent,ariaLabel);
                    loadData(1);
                });
                response.$promise.catch( function() {
                    angular.element.unblockUI();
                    var title = 'Delete Data Failed';
                    var textContent = 'Process delete data has been failed.';
                    var ariaLabel = 'Delete Data Failed';
                    showDialogMessage(title,textContent,ariaLabel,ev);
                })
            }, function() {

            });
          });
        } else {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                loadData();
            }); 
        }
      }

    
    function create(ev) {
      $mdDialog.show({
          controller         : 'AdminDepartmentInputController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/admin-department/input/input.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          }
      });
    }

    function showDialogMessage(title,textContent,ariaLabel,ev) {
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title(title)
        .textContent(textContent)
        .ariaLabel(ariaLabel)
        .ok('OK')
        .targetEvent(ev)
        ).then(function(){
            closeModal();
        });
    }

    function editData(data) {
        $mdDialog.show({
            controller: 'AdminDepartmentEditController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/admin-department/input/input.html',
            parent: angular.element($document.body),
            onRemoving: function() {
                loadData(1);
            },
            locals: {
                data  : data
            },
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
        });
    }
  }


})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.admin-department')
        .controller('AdminDepartmentEditController', AdminDepartmentEditController);


    AdminDepartmentEditController.$inject=['$state','$mdDialog','$localStorage','$timeout','Form','AppAPI','Auth','$log','DataService','data'];
    /** @ngInject */
    function AdminDepartmentEditController($state,$mdDialog,$localStorage,$timeout,Form,AppAPI,Auth,$log,DataService,data)
    {
        var vm = this;
        
        // initial form
        Form.initialForm();

        var AdminDepartment = AppAPI.AdminDepartment();
        var Completeness=AppAPI.Completeness();

        // set constructor form
        Form.setObject(AdminDepartment);

        // set form to controller
        vm.Form = Form;

        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.closeModal=closeModal;

        vm.listSubArea = [];
        vm.listGedung = [];
        vm.getListGedung = getListGedung
        vm.getListSector = getListSector
        vm.save = save
        vm.notif = {
            success: false,
            error: false
        }
        vm.messageTheme=''

        vm.Form.objForm.department_id = ''
        vm.isSector = false;
        vm.isSectorStatus = isSectorStatus;
        vm.reloadToken=reloadToken;
        vm.back=back;
        vm.stateEdit=false;
        vm.clearMeesage=clearMeesage;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected=[];
        vm.changeOTType=changeOTType;
        vm.getListGroupShift = getListGroupShift;

        // console.log(data);

        getListSubArea();
        getListGedung(data.sub_area);
        getListSector(data.gedung_id);
        getListGroupShift();
        vm.Form.objForm.sub_area_id      = data.sub_area
        vm.Form.objForm.nik              = data.nik
        vm.Form.objForm.gedung_id        = data.gedung_id
        vm.Form.objForm.id               = data.id
        vm.Form.objForm.gedung_sector_id = data.gedung_sector_id 
        vm.Form.objForm.group_shift_id   = data.group_shift_id
        if(data.sector_id!=null){
            vm.isSector = true;
            vm.Form.objForm.sector_id        = data.sector_id
            vm.Form.objForm.effective_date   = new Date(data.effective_date)
        }else{
            vm.Form.objForm.sector_id = 'all';
        }
        function getListSubArea() {
            var response= AdminDepartment.query({action:'getSelectListArea'});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listSubArea=data;
        }

        function errorFetchArea() {
            vm.listSubArea=[];
        } 

        function getListGedung(subareaId)
        {
            var response= AdminDepartment.query({action:'getSelectListGedung',sub_area_id:subareaId});
            response.$promise.then(fetchGedung);
            response.$promise.catch(errorFetchGedung);
        }

        function fetchGedung(data) {
            vm.listGedung=data;
        }

        function errorFetchGedung() {
            vm.listGedung=[];
        } 

        function save(ev,formController) {
            angular.element.blockUI();
            var promise=Form.saveData('save', formController, AdminDepartment);
            promise.then(function(response){
                if ( response.status == 0 ) {
                    vm.notif.error = response.pesan;
                    vm.notif.success = false;
                    vm.messageTheme='pink';
                } else {
                    vm.notif.error = false;
                    vm.notif.success = response.pesan;
                    vm.messageTheme='green';
                    formController.$setPristine();
                }
              
              $timeout(function() {
                    vm.notif.error=false; 
                    vm.notif.success=false; 
              }, 6000);
              angular.element.unblockUI();
            })
            .catch(function (response) {
                vm.notif.error = 'Internal server error'
                vm.notif.success = false;
                vm.messageTheme='pink';
                angular.element.unblockUI();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function toggleSelectedAll(state)
        {
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
        }

        function checkAll() {
           vm.listOtselected=angular.copy(vm.listemploye);
        }

        function unCheckAll() {
            vm.listOtselected=[];
        }

        function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.listOtselected.indexOf(ls);

            if ( idx > -1 )
            {
                vm.listOtselected.splice(idx, 1);
            }
            else
            {
                vm.listOtselected.push(ls);
            }
        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }

        function reloadToken(){
            Auth.setToken();
        }

        function back(){
            $state.transitionTo('app.cb_employe_overtime');
        }

        function changeOTType()
        {
          // vm.Form.objForm.isafter=null;
        }
        
        function isSectorStatus(param)
        {
            if(param=="all"){
                vm.isSector = false;
            }else{
                vm.isSector = true;
            }
        }

        function getListSector(buildingId)
        {
            angular.element.blockUI();
            var resp=Completeness.query({action:'viewSector',buildingId:buildingId});
            resp.$promise.then(function(data) {
                vm.listSector = data
                angular.element.unblockUI();
            });
            resp.$promise.catch(function(data){
                vm.listSector = []
                angular.element.unblockUI();
            });    
        }

        function getListGroupShift()
        {
          var response= AdminDepartment.query({action:'getListGroupShift'});
          response.$promise.then(fetchGroupShift);
          response.$promise.catch(errorFetchGroupShift);
        }

        function fetchGroupShift(data) {
          vm.listGroupShift=data;
        }

        function errorFetchGroupShift() {
          vm.listGroupShift=[];
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.abnormal-report', [ ])
        .config(config);

      config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    { 
        // State
        $stateProvider
            .state('app.cb_abnormal_report', {
                url    : '/cb/abnormal-report',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/abnormal-report/abnormal-report.html',
                        controller : 'AbnormalReportController as vm'
                    }
                }
            });  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cb.abnormal-report')
        .controller('AbnormalReportController', AbnormalReportController);


    AbnormalReportController.$inject=['$state','$window','$location','$localStorage','$document','$http','$scope','config','$log','$mdDialog','AppAPI','Auth','DataService' ];
    /** @ngInject */
    function AbnormalReportController($state,$window,$location,$localStorage,$document,$http,$scope,config,$log,$mdDialog,AppAPI,Auth,DataService )
    {
        
        var vm = this; 
        vm.listJum=[2,5,25,50,75,100,200];
        vm.DataTable= new DataService();
        vm.loadData=loadData; 
        vm.toggleSelectedAll=toggleSelectedAll; 
        vm.ExportToExcel=ExportToExcel; 
        vm.loadDataDivision=loadDataDivision;
        vm.loadDataDepartment=loadDataDepartment;  
        var Abnormalreport=AppAPI.Abnormalreport();
        var date=new Date();
        vm.tahun=date.getFullYear();
        vm.bulan=date.getMonth()+1;
        vm.getPeriode=getPeriode;
        vm.tgl=date.getDate();
        if(vm.tgl >=20 && vm.tgl <=31)
        {
          vm.bulan=vm.bulan+1;
        }
        if(vm.bulan < 10){
          vm.bulan='0'+vm.bulan;
        }

        vm.company=$localStorage.empsite;  
        loadDataBU();
        loadDataDivision(vm.company);

        // vm.Breadhome="app.pms_dashboard";
        vm.Breadlist=[ 
                    {link:'#',name:'C&B / ',active:'0'}
                    ]; 
        vm.listtahun=[2017,2018,2019,2020,2021];
        vm.listbulan=[{name:'January',value:'01'},
                      {name:'February',value:'02'},
                      {name:'Maret',value:'03'},
                      {name:'April',value:'04'},
                      {name:'Mei',value:'05'},
                      {name:'June',value:'06'},
                      {name:'July',value:'07'},
                      {name:'August',value:'08'},
                      {name:'September',value:'09'},
                      {name:'October',value:'10'},
                      {name:'November',value:'11'},
                      {name:'Desember',value:'12'}];

        vm.simulateQuery = false;
        vm.isDisabled    = false;  
        vm.closeModal=closeModal; 
       getPeriode();
 

        ////////// 

         function getPeriode(){
          var res=Abnormalreport.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
          res.$promise.then(fetchPeriode);
          res.$promise.catch(errorfetchPeriode);
        }

        function fetchPeriode(data)
        {
          vm.periode=data[0]['periode'];
          // console.log(vm.periode);
          // loadData(1);
        }

        function errorfetchPeriode(data)
        {
          console.log('error');
        }

         function loadDataDepartment(iddivisi) {
             var response=Abnormalreport.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
          }

          function fetchDepartment(data) {
            vm.listDepartment=data;
            // loadData(1);
          }

          function errorDepartment() {
            vm.listDepartment=[];
          }
          
          function loadDataDivision(idbu) {
             var response=Abnormalreport.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
          }

          function fetchDivisiBU(data) {
           vm.listDivision=data;
           // loadData(1);
          }

          function errorDivisiBU() {
            vm.listDivision=[];
          } 

          function loadDataBU() {
            var response=Abnormalreport.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
          }

          function fetchBU(data) {
            vm.listBU=data;
          }

          function errorFetchBU() {
            vm.listBU=[];
          }

         

        function loadData(){
           // angular.element.blockUI();
           var company=vm.company; 
           var divisi=vm.divisi;
           var department=vm.department;
           var tahun=vm.tahun;
           var bulan=vm.bulan;

           // console.log(company+' / '+divisi+' / '+department+' / '+tahun+' / '+bulan);
           var response=Abnormalreport.query({action:'viewdata',company:company,divisi:divisi,department:department,tahun:tahun,bulan:bulan});
              response.$promise.then(function(data){
                vm.listData=data;
                console.log(vm.listData);
                angular.element.unblockUI();
              });
              response.$promise.catch(function(data){
                $log.info(data);
                vm.listData=[];
                angular.element.unblockUI();
              });
        }

        // function loadData(pageno)
        // {
        //   var company=vm.company; 
        //   var divisi=vm.divisi;
        //   var department=vm.department;
        //   var tglmulai=new Date(vm.tglmulai).toString('yyyy-MM-dd');
        //   var tglakhir=new Date(vm.tglakhir).toString('yyyy-MM-dd');
        
        //   var resp=vm.DataTable.loadData(Overtime,pageno,{action:'viewdata',company:company,divisi:divisi,department:department,tglmulai:tglmulai,tglakhir:tglakhir});
        //  // console.log(resp);
        //   // angular.element.unblockUI();
        // }

        function toggleSelectedAll(state)
        { 
            switch(state)
            {
                case true:
                checkAll();
                break;
                case false:
                unCheckAll();
                break;
            }
            //console.log(vm.listModulSelected);
        }

         function checkAll() {
             vm.listModulSelected=angular.copy(vm.list);
          }

          function unCheckAll() {
             vm.listModulSelected=[];
          } 
        
        
         

        function closeModal()
        {
            $mdDialog.hide();
        }

        function ExportToExcel()
        {
          var company=vm.company; 
         var divisi=vm.divisi;
         var department=vm.department;
         var tahun=vm.tahun;
         var bulan=vm.bulan;
          var token=Auth.setTokenPromise();
            token.then(function(data){
                    var protocol=$location.protocol();
                    var host=$location.host();
                   $window.open(protocol+'://'+host+config.api+'api/abnormalreport/exportexcel/'+company+'/'+divisi+'/'+department+'/'+tahun+'/'+bulan, '_blank');
            },function(){
              
                $window.alert('gagal load token');
            });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.abnormal-approval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_abnormal_approval', {
                url    : '/cb/abnormal-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/abnormal-approval/abnormal-approval.html',
                        controller : 'AbnormalApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function() {
    'use strict';

    angular
        .module('app.cb.abnormal-approval')
        .controller('AbnormalViewRejectCommentController', AbnormalViewRejectCommentController);

    AbnormalViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function AbnormalViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);

    function saveData(ev,formController)
        {

            var promise= Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function(data){
                showDialog(ev,data);
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function showDialog(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success Save Data')
            .textContent(data.pesan)
            .ariaLabel('Success Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }

        function ShowFailed(ev,data) {
           $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed Save Data')
            .textContent(data.pesan)
            .ariaLabel('Failed Save Data')
            .ok('OK')
            .targetEvent(ev)
            ).then(function(){
                closeModal();
            });
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cb.abnormal-approval')
        .controller('AbnormaltRejectCommentController', AbnormaltRejectCommentController);

    AbnormaltRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function AbnormaltRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;
        // console.log(id);

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function saveData(ev, formController) {

            var promise = Form.saveData('reject', formController, Abnormalapproval);
            promise.then(function (data) {
                showDialogInfo(ev, data);
            });

            promise.catch(function (data) {
                showDialogInfo(ev, data)
            });
        }

        function showDialog(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Success Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function ShowFailed(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Save Data')
                    .textContent(data.pesan)
                    .ariaLabel('Failed Save Data')
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.cb.abnormal-approval')
    .controller('AbnormalApprovalController', AbnormalApprovalController);


  AbnormalApprovalController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function AbnormalApprovalController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {
    var vm = this;

    var translate = $filter('translate');

    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    var Abnormalapproval = AppAPI.Abnormalapproval();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var nik = $localStorage.user;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveAbnormal = approveAbnormal;
    vm.Reject = Reject;
    vm.UnApproved = UnApproved;
    vm.UnReject = UnReject;
    vm.viewComment = viewComment;
    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];
    vm.toggleSelectedAll = toggleSelectedAll;




    function loadData(pageno) {
      var resp = vm.DataTable.loadData(Abnormalapproval, pageno, { action: 'viewdata', tglmulai: vm.tglmulai, tglakhir: vm.tglakhir, type: vm.type });
      // vm.listOtselected=[];
    }


    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.DataTable.list);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveAbnormal(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new Abnormalapproval();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push({
                id: vm.listOtselected[i].id
              });
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();

            response.then(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data)
              loadData();
              vm.listOtselected = [];
            });
            response.catch(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data)
              vm.listOtselected = [];
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        //  var promise=Auth.setToken();
        //  promise.then(function(){
        //       var confirm = $mdDialog.confirm()
        //       .title('Would you like to Reject this list?')
        //       .textContent('All data your selected will be Reject.')
        //       .ariaLabel('delete dialog')
        //       .targetEvent(ev)
        //       .ok('YES')
        //       .cancel('no');
        //   $mdDialog.show({
        //         multiple: true
        //    });      
        //   $mdDialog.show(confirm).then(function() {
        //         angular.element.blockUI();
        //         // console.log(vm.listOtselected);
        //         var ot= new Abnormalapproval();
        //         ot.data=[];
        //         ot.action='reject'; 
        //         for (i=0;i<jum;i++) {
        //           ot.data.push({id:vm.listOtselected[i].id});
        //         }
        //         var idtx=encodeURIComponent(angular.toJson(ids));
        //         var response=ot.$save(); 
        //         
        //         response.then(loadData);
        //         response.catch( function(){
        //           angular.element.unblockUI();
        //         });
        //     }, function() {
        //    // $scope.status = 'You decided to keep your debt.';
        //   });
        // });
        $mdDialog.show({
          controller: 'AbnormaltRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/abnormal-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }

    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'AbnormalViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/abnormal-approval/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          vm.listOtselected = [];
        },
        locals: {
          id: id
        }
      });
    }

    function UnApproved(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNAPP');
      var note = translate('KPI.MESSAGE.UNAPPNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Abnormalapproval.delete({ action: 'unapproved', data: angular.toJson(id) });
          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data)
          });
          response.$promise.catch(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data)
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function UnReject(ev, id) {
      var conf = translate('KPI.MESSAGE.CONFUNREJ');
      var note = translate('KPI.MESSAGE.UNREJNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = Abnormalapproval.delete({ action: 'unreject', data: angular.toJson(id) });
          response.$promise.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data)
          });
          response.$promise.catch(function () {
            angular.element.unblockUI();
            showDialogInfo(ev, data)
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function succesUnapproved(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnapproved();
      } else {
        showDialog();
      }
      loadData();
    }

    function succesUnreject(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnreject();
      } else {
        showDialogUnreject();
      }
      loadData();
    }

    function failedUnapproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.data)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }

    function showFailedUnapproved() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unapproved Data')
          .textContent('Transaction Locked By System.')
          .ariaLabel('Transaction Locked By System')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showFailedUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unreject Data')
          .textContent('Transaction Locked By System.')
          .ariaLabel('Transaction Locked By System')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialog() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialogUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Success Process Data')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.abnormal-approval')
        .controller('AbnormalController', AbnormalController);


    AbnormalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage'];
    /** @ngInject */
    function AbnormalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage)
    {
        
      var vm = this;  
      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      var Abnormal=AppAPI.Abnormal();
      var nik= $localStorage.user;
      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveAbnormal=approveAbnormal;
      vm.Reject=Reject;
      vm.deleteAbnormal=deleteAbnormal;
      vm.viewComment=viewComment;
      vm.appstatus=[{name:'Waiting Approval',value:'0'},{name:'Approved',value:'1'},{name:'Rejected',value:'2'}];
      vm.status='0'
      loadData();


      var columnDefs = [
        {headerName: "Make", field: "make"},
        {headerName: "Model", field: "model"},
        {headerName: "Price", field: "price"}
    ];

    var rowData = [
        {make: "Toyota", model: "Celica", price: 35000},
        {make: "Ford", model: "Mondeo", price: 32000},
        {make: "Porsche", model: "Boxter", price: 72000}
    ];

    vm.gridOptions = {
        columnDefs: columnDefs,
        rowData: rowData
    };

 
        ////////// 
    
    // function loadData(pageno)
    // {
    //   var resp=vm.DataTable.loadData(Abnormal,pageno,{action:'viewdata',nik:nik});
    //   vm.listOtselected=[];
    // }

    function loadData(pageno) {
        angular.element.blockUI();
         var response=vm.DataTable.loadData(Abnormal,pageno,{action:'viewdata',status:vm.status,start_date:vm.start_date,end_date:vm.end_date});
         vm.listselected=[];
    }

      function fetchDepartment(data) {
          console.log(data);

        vm.listApp=data;
        // loadData(1);
        angular.element.unblockUI();
      }

      function errorDepartment() {
        vm.listApp=[];
        angular.element.unblockUI();
      }
     

    

    function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

    function toggleCheck(ls, event)
      {
          if ( event )
          {
              event.stopPropagation();
          }

          var idx = vm.listOtselected.indexOf(ls);

          if ( idx > -1 )
          {
              vm.listOtselected.splice(idx, 1);
          }
          else
          {
              vm.listOtselected.push(ls);
          }
      }

      function approveAbnormal(ev)
      {
        console.log(vm.listOtselected);
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                console.log(vm.listOtselected);
                var ot= new Abnormal();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id
                                });
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function Reject(ev)
      {
        var promise=Auth.setToken();
         promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Reject this list?')
              .textContent('All data your selected will be Reject.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                // console.log(vm.listOtselected);
                var ot= new Abnormal();
                ot.data=[];
                ot.action='reject';
                var jum=vm.listOtselected.length,i,ids=[]; 
                for (i=0;i<jum;i++) {
                  ot.data.push({id:vm.listOtselected[i].id});
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                //var response=tm.$delete({action:'approve'});
                response.then(loadData);
            }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
        });

      }

      function deleteAbnormal(ev, id) {
       
          var promise=Auth.setToken();
           promise.then(function(){
                  var confirm = $mdDialog.confirm()
              .title('Would you like to delete this data?')
              .textContent('All data your selected will be deleted and can not recovered.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');

        $mdDialog.show(confirm).then(function() {
            angular.element.unblockUI();
           var response=Abnormal.delete({action:'delete',data:id});

           response.$promise.then(loadData);
        }, function() {

        });
           });
      
       
        }

    function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'AbnormalViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/abnormal-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              loadData(1);
          },
          locals:{
            id:id
          }
      });
    } 

    }
})();
 
(function ()
{
    'use strict';

    angular
        .module('app.behivor.ref')
        .controller('RefController', RefController);


    RefController.$inject=['$state','$mdDialog','AppAPI','Auth'];
    /** @ngInject */
    function RefController($state,$mdDialog,AppAPI,Auth)
    {
        
        var vm = this;

        vm.addData = addData;
        vm.editData = editData;
        vm.deleteData = deleteData;  

        var Behivor = AppAPI.Behivor();
        vm.loadData = loadData;

        loadData();

        function loadData() {
           angular.element.blockUI();
           var dataPromise = Behivor.query({action:'viewrefdata'});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listRef = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listRef = [];
            angular.element.unblockUI();
        }

        function addData(ev)
        {
            $mdDialog.show({
                controller: 'inputrefController',
                controllerAs:'vm',
                templateUrl: 'app/main/behivor/ref/input-ref/input-ref.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                },
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }
     
        function editData(ev, ref)
        {
            $mdDialog.show({
                controller   : 'editrefController',
                controllerAs : 'vm',
                templateUrl  : 'app/main/behivor/ref/input-ref/input-ref.html',
                parent       : angular.element(document.body),
                targetEvent  : ev,
                clickOutsideToClose:true,
                locals : {
                    ref:ref
                },
                onRemoving : function(element, removePromise)
                {
                    loadData();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }
     
        function deleteData(ev, ref) 
        {       
            var promise=Auth.setToken();
            promise.then(function(){
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this data?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.unblockUI();
                    var response=Behivor.delete({action:'deleteref',data:ref});

                    response.$promise.then(loadData());
                    }, function() {

                });
            });
       
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.behivor.input')
        .controller('InputController', InputController);


    InputController.$inject=['$state','$mdDialog','$localStorage','AppAPI','Auth'];
    /** @ngInject */
    function InputController($state,$mdDialog,$localStorage,AppAPI,Auth)
    {
        
        var vm = this;
        vm.username=$localStorage.nama;
        vm.addData = addData;
        vm.editData = editData;

        var Behivor = AppAPI.Behivor();
        vm.loadData = loadData;
        vm.checkSelectedPeriod=checkSelectedPeriod;
        vm.showBehivor=showBehivor;

        loadConfig();
        checkSelectedPeriod();

        function checkSelectedPeriod()
        {
            angular.forEach(vm.listPeriod,function(obj){
               if(obj.effectiveDate===vm.currentDate)
               {
                obj.selected=true;
               }else
               {
                obj.selected=false;
               }
            });
        }

        function showBehivor(rDate)
        {
           vm.currentDate=rDate;
           checkSelectedPeriod();
           loadData();
        }

        function loadData() {
           angular.element.blockUI();
           var dataPromise = Behivor.query({action:'viewinputdata',rDate:vm.currentDate});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listInput = data;
            vm.totalResult = 0;
            angular.forEach(vm.listInput,function(obj){
               vm.totalResult += obj.result;
            });
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadConfig() {
           angular.element.blockUI();
           var dataPromise = Behivor.query({action:'viewconfigdata'});
           dataPromise.$promise.then(fetchConfig);
           dataPromise.$promise.catch(errorConfig); 
        }

        function fetchConfig(data) {
            vm.listPeriod = data;
            angular.forEach(vm.listPeriod,function(obj){
               vm.currentDate = obj.effectiveDate;
            });
            loadData(vm.currentDate);

            angular.element.unblockUI();
        }

        function errorConfig() {
            vm.listPeriod = [];
            angular.element.unblockUI();
        }

        function addData(ev)
        {
            $mdDialog.show({
                controller: 'inputinputController',
                controllerAs:'vm',
                templateUrl: 'app/main/behivor/input/input-input/input-input.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    listInput:vm.listInput
                },
                onRemoving:function(element, removePromise)
                {
                    loadData(vm.currentDate);
                    checkSelectedPeriod();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }
     
        function editData(ev, input)
        {
            $mdDialog.show({
                controller   : 'editinputController',
                controllerAs : 'vm',
                templateUrl  : 'app/main/behivor/input/input-input/input-input.html',
                parent       : angular.element(document.body),
                targetEvent  : ev,
                clickOutsideToClose:true,
                locals : {
                    listInput:vm.listInput
                },
                onRemoving : function(element, removePromise)
                {
                    loadData(vm.currentDate);
                    checkSelectedPeriod();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }
     
/*        function deleteData(ev, input) 
        {       
            var promise=Auth.setToken();
            promise.then(function(){
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this data?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.unblockUI();
                    var response=Behivor.delete({action:'deleteinput',data:input});

                    response.$promise.then(loadData());
                    }, function() {

                });
            });
       
        }

*/    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.behivor.config')
        .controller('ConfigController', ConfigController);


    ConfigController.$inject=['$state','$mdDialog','AppAPI','Auth','DataService'];
    /** @ngInject */
    function ConfigController($state,$mdDialog,AppAPI,Auth,DataService)
    {
        
        var vm = this;

        vm.addData = addData;
        vm.editData = editData;
        vm.deleteData = deleteData;  

        var Behivor = AppAPI.Behivor();
        vm.loadData = loadData;
        vm.loadRef = loadRef;

        loadData();
        loadRef();

        function loadRef()
        {
          var response=Behivor.query({action:'viewrefdata'});
          response.$promise.then(fetchRef);
          response.$promise.catch(errorFetchRef);
        }

        function fetchRef(data)
        {
           vm.listRef=data;
        }

        function errorFetchRef()
        {
           vm.listRef=[];
        }

        function loadData() {
           angular.element.blockUI();
           var dataPromise = Behivor.query({action:'viewconfigdata'});
           dataPromise.$promise.then(fetchData);
           dataPromise.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            vm.listConfig = data;
            angular.element.unblockUI();
        }

        function errorFetch() {
            vm.listConfig = [];
            angular.element.unblockUI();
        }

        function addData(ev)
        {
            $mdDialog.show({
                controller   : 'inputconfigController',
                controllerAs : 'vm',
                templateUrl  : 'app/main/behivor/config/input-config/input-config.html',
                parent       : angular.element(document.body),
                targetEvent  : ev,
                clickOutsideToClose:true,
                locals : {
                    listRef:vm.listRef
                },
                onRemoving:function(element, removePromise)
                {
                    loadData();
                    loadRef();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }
     
        function editData(ev, cfg)
        {
            $mdDialog.show({
                controller   : 'editconfigController',
                controllerAs : 'vm',
                templateUrl  : 'app/main/behivor/config/input-config/input-config.html',
                parent       : angular.element(document.body),
                targetEvent  : ev,
                clickOutsideToClose:true,
                locals : {
                    cfg:cfg,
                    listRef:vm.listRef
                },
                onRemoving : function(element, removePromise)
                {
                    loadData();
                    loadRef();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }
     
        function deleteData(ev, cfg) 
        {       
            var promise=Auth.setToken();
            promise.then(function(){
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this data?')
                .textContent('All data your selected will be deleted and can not recovered.')
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('no');

                $mdDialog.show(confirm).then(function() {
                    angular.element.unblockUI();
                    var response=Behivor.delete({action:'deleteconfig',data:cfg});

                    response.$promise.then(loadData());
                    }, function() {

                });
            });
       
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.assessment.assessment-detail', [])
        .config(config);

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
        // State 
        $stateProvider
        .state('app.assessment_detail', {
            url    : '/assessment/assessment-detail/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/assessment/assessment-detail/assessment-detail.html',
                    controller : 'AssessmentDetailController as vm'
                }
            }
        });   
                
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.assessment.assessment-detail')
        .controller('AssessmentDetailController', AssessmentDetailController)
        .directive('mdButtonsToggleSurveys', SetAssessmentDetailDirective);


    AssessmentDetailController.$inject=['DataService','$state','$mdDialog','$mdToast','$localStorage','$window','AppAPI','Auth','Form','DTColumnDefBuilder','$timeout','$stateParams', '$location', 'config'];
    /** @ngInject */
    function AssessmentDetailController(DataService,$state,$mdDialog,$mdToast,$localStorage,$window,AppAPI,Auth,Form,DTColumnDefBuilder,$timeout,$stateParams, $location, config)
    {

        var vm             = this;
        var Assessment      = AppAPI.Assessment();
        vm.username        = $localStorage.user;
        vm.nik             = $stateParams.id;
        vm.profile         = {};

        vm.islastStep      = false;

        vm.ratingLists     = [];       
        vm.languageList    = [
            {value: 'ID', label: 'Indonesia'},
            {value: 'EN', label: 'English'}
        ];
        vm.isDisabled      = true;
        vm.selected        = 'ID';
        vm.language        = 'ID';
        vm.changeLanguage  = changeLanguage;
        vm.answers         = [];
        vm.downloadAnswer = downloadAnswer;
        vm.dowloadPapikostik = dowloadPapikostik;


        Form.initialForm();

        Form.setObject(Assessment);
        vm.Form = Form;

        vm.setToken=Auth.setToken;

        loadData();

        function changeLanguage(lang) {
            vm.language = lang;
        }
        
        function loadData() {
           angular.element.blockUI();
           var promises = Assessment.query({action:'get_profile', nik: vm.nik});
           promises.$promise.then(fetchData);
           promises.$promise.catch(errorFetch); 
        }

        function fetchData(data) {
            if(typeof(data[0]) !== 'undefined') {
                vm.profile = data;

                loadEmployeeAssessmentData();

            }
        }

        function errorFetch() {
            vm.profile = {};
            angular.element.unblockUI();
        }

        function loadEmployeeAssessmentData() {
           angular.element.blockUI();
           var promises = Assessment.query({action:'get_answers',nik:vm.nik});
           promises.$promise.then(fetchEmployeeAssessmentData);
           promises.$promise.catch(errorEmployeeAssessmentFetch); 
        }

        function fetchEmployeeAssessmentData(data) {

            if(typeof(data[0]) !== 'undefined') {
                vm.answers = data;
            }
            
            angular.element.unblockUI();                
        }

        function errorEmployeeAssessmentFetch() {
            vm.answers = [];
            angular.element.unblockUI();
        }

        function successSaveData() {
            vm.Form.tampilPesan = false;
            vm.messageTheme='green';

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.Form.pesan)
                .position('top right')
                .hideDelay(3000)
                .theme("success-toast")
            );

            loadCalculatedScoreData();

            // $timeout(function() {
            //     vm.Form.tampilPesan = false;
            // }, 2000);

            vm.setToken();
            
        }

        function failedSaveData() {
            vm.messageTheme='red';

            vm.setToken();
        }

        function downloadAnswer(ev) {
            var token = Auth.setTokenPromise();            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/assessment/exportempanswers/' + vm.nik + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }
        
        function dowloadPapikostik(ev) {
            var token = Auth.setTokenPromise();            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/assessment/exportempanswerspapikostik/' + vm.nik + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }



    };

    function SetAssessmentDetailDirective() {

        return {
            template: '<div layout="row" layout-align="center center">' +
            '<md-button ng-repeat="option in items" class="md-group md-raised" ng-class="{\'{{selectedClass}}\': option.value == ngModel,left: $index == 0, right: $last}" ng-click="change(option.value)" ng-bind="option.label" ng-disabled="ngDisabled"></md-button></div>',
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                ngModel: '=',
                items: '=',
                ngDisabled: '=',
                selectedClass: '@?'
            },
            link: function(scope, elem, attrs){
                if(angular.isUndefined(scope.selectedClass)){
                    scope.selectedClass = 'md-primary';
                }

                angular.forEach(scope.items, function(value, key){
                    if(!angular.isObject(value)){
                        scope.items[key] = {value: value, label: value};
                    }
                });

                scope.change = function(key){
                    scope.ngModel = key;
                };
            }
        };
   
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function () {
    "use strict";
    angular
        .module("app.quick-panel")
        .controller("NewsTabController", NewsTabController);

    NewsTabController.$inject = [
        "DataService",
        "$state",
        "$mdDialog",
        "$localStorage",
        "$window",
        "$timeout",
        "$sce",
        "AppAPI",
        "Auth",
        "Form",
        "data"
    ];
    /** @ngInject */
    function NewsTabController(
        DataService,
        $state,
        $mdDialog,
        $localStorage,
        $window,
        $timeout,
        $sce,
        AppAPI,
        Auth,
        Form,
        data
    ) {
        var vm = this;
        var news = AppAPI.News();
        vm.Form = Form;
        vm.info = data;
        vm.dialogClose = dialogClose;
        vm.doc_type = false;

        // console.log(data);

        activate();

        function activate() {
            vm.title = data.title;
            vm.content = $sce.trustAsHtml(data.content);
            vm.category = data.category;
            vm.date = data.created_at;
            vm.publishBy = data.updated_by;

            if (data.doc_path != null) {
                // console.log(data.doc_path.slice(-3));
                if (data.doc_path.slice(-3) === "mp4") {
                    vm.video_type = true;
                    vm.doc_type = false;
                    vm.images = false;
                } else if (data.doc_path.slice(-3) === "pdf") {
                    vm.doc_type = true;
                    vm.video_type = false;
                    vm.images = false;
                } else {
                    vm.video_type = false;
                    vm.doc_type = false;
                    vm.images = true;
                    vm.doc = data.doc_path;
                }
                // console.log(vm.doc);
                vm.url =
                    "api/newsdocument/" +
                    data.doc_path +
                    "?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;";
            }

            Form.initialForm();
            Form.setObject(news);

            var promise = Auth.setToken();
            var tempContent = data.content;
            data.content = null;
            promise.then(function () {
                angular.element.blockUI();
                var response = news.delete({
                    action: "saveDataUser",
                    data: data
                });
                response.$promise.then(function (resp) {
                    angular.element.unblockUI();
                    data.content = tempContent;
                });
            });
        }

        function dialogClose() {
            $mdDialog.hide();
            // $window.location.reload();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    // {
                    //     'title'      : 'Sample',
                    //     'icon'       : 'icon-tile-four',
                    //     'state'      : 'app.sample',
                    //     'weight'     : 1,
                    //     'children'   : [],
                    //     '_id'        : 'sample',
                    //     '_path'      : 'apps.sample',
                    //     'uisref'     : 'app.sample',
                    //     'hasShortcut': true
                    // }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        vm.blurred = blurred;

        //////////

       // init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                   // vm.handleResultClick(vm.results[vm.selectedResultIndex]);
                       $scope.$parent.$eval(vm.onSearch);
                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            // vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }


        /**
         * Ensure the query field
         * if not empty
         * cannot collapse
         */
        function blurred() 
        {
            if(!vm.query) {
                vm.collapse();
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?',
                query:'=?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function () {
    "use strict";

    angular
        .module("app.core")
        .provider("msNavigationService", msNavigationServiceProvider)
        .controller("MsNavigationController", MsNavigationController)
        // Vertical
        .directive("msNavigation", msNavigationDirective)
        .controller("MsNavigationNodeController", MsNavigationNodeController)
        .directive("msNavigationNode", msNavigationNodeDirective)
        .directive("msNavigationItem", msNavigationItemDirective)
        //Horizontal
        .directive("msNavigationHorizontal", msNavigationHorizontalDirective)
        .controller(
            "MsNavigationHorizontalNodeController",
            MsNavigationHorizontalNodeController
        )
        .directive(
            "msNavigationHorizontalNode",
            msNavigationHorizontalNodeDirective
        )
        .directive(
            "msNavigationHorizontalItem",
            msNavigationHorizontalItemDirective
        );

    /** @ngInject */
    function msNavigationServiceProvider() {
        // Inject $log service
        var $log = angular.injector(["ng"]).get("$log");

        // Navigation array
        var navigation = [];

        var service = this;

        var isSurvey = 33;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item) {
            if (!angular.isString(path)) {
                $log.error("path must be a string (eg. `dashboard.project`)");
                return;
            }

            var parts = path.split(".");

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for (var i = 0; i < parent.length; i++) {
                if (parent[i]._id === id) {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if (updateItem) {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if (
                    angular.isUndefined(item.weight) ||
                    !angular.isNumber(item.weight)
                ) {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path) {
            if (!angular.isString(path)) {
                $log.error("path must be a string (eg. `dashboard.project`)");
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split(".");

            for (var p = 0; p < parts.length; p++) {
                var id = parts[p];

                for (var i = 0; i < item.length; i++) {
                    if (item[i]._id === id) {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if (item[i]._path === path) {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;

                if (children.length > 1) {
                    children.sort(_byWeight);
                }

                if (children.length > 0) {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts) {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1) {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++) {
                var _id = parts[i],
                    createParent = true;

                for (var p = 0; p < parent.length; p++) {
                    if (parent[p]._id === _id) {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent) {
                    var item = {
                        _id: _id,
                        _path: parts.join("."),
                        title: _id,
                        weight: 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y) {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item) {
            var uisref = "";

            if (angular.isDefined(item.state)) {
                uisref = item.state;

                if (
                    angular.isDefined(item.stateParams) &&
                    angular.isObject(item.stateParams)
                ) {
                    uisref =
                        uisref + "(" + angular.toJson(item.stateParams) + ")";
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function () {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem: saveItem,
                deleteItem: deleteItem,
                sort: sortByWeight,
                clearNavigation: clearNavigation,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigation: getNavigation,
                getNavigationByID: getNavigationByID,
                getFlatNavigation: getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation() {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if (navigationScope) {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope) {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem() {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root) {
                if (root) {
                    for (var i = 0; i < navigation.length; i++) {
                        if (navigation[i]._id === root) {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            function getNavigationByID(id) {
                for (var i = 0; i < navigation.length; i++) {
                    if (navigation[i]._id === id) {
                        return navigation[i];
                    }
                }

                return null;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root) {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope) {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status) {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded() {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status) {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen() {
                return foldedOpen;
            }

            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded() {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation) {
                var flatNav = [];

                for (var x = 0; x < navigation.length; x++) {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if (navigation[x].children.length > 0) {
                        flatNav = flatNav.concat(
                            _flattenNavigation(navigation[x].children)
                        );
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController(
        $scope,
        msNavigationService,
        $localStorage
    ) {
        var vm = this;
        vm.isSurvey = $localStorage.isSurvey;

        // Data
        if ($scope.root) {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        } else {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular
                .element("body")
                .toggleClass("ms-navigation-horizontal-mobile-menu-active");
        }
    }

    /** @ngInject */
    function msNavigationDirective(
        $rootScope,
        $timeout,
        $mdSidenav,
        msNavigationService
    ) {
        return {
            restrict: "E",
            scope: {
                folded: "=",
                root: "@"
            },
            controller: "MsNavigationController as vm",
            templateUrl:
                "app/core/directives/ms-navigation/templates/vertical.html",
            transclude: true,
            compile: function (tElement) {
                tElement.addClass("ms-navigation");

                return function postLink(scope, iElement) {
                    var bodyEl = angular.element("body"),
                        foldExpanderEl = angular.element(
                            '<div id="ms-navigation-fold-expander"></div>'
                        ),
                        foldCollapserEl = angular.element(
                            '<div id="ms-navigation-fold-collapser"></div>'
                        ),
                        sidenav = $mdSidenav("navigation");

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if (msNavigationService.getFolded() === null) {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if (msNavigationService.getFolded()) {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function () {
                                $rootScope.$broadcast("msNavigation::collapse");
                            });

                            // Add class to the body
                            bodyEl.addClass("ms-navigation-folded");

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(
                        function () {
                            return sidenav.isLockedOpen();
                        },
                        function (current, old) {
                            if (
                                angular.isUndefined(current) ||
                                angular.equals(current, old)
                            ) {
                                return;
                            }

                            var folded = msNavigationService.getFolded();

                            if (folded) {
                                if (current) {
                                    // Collapse everything
                                    $rootScope.$broadcast(
                                        "msNavigation::collapse"
                                    );
                                } else {
                                    // Expand the active one and its parents
                                    var activeItem = msNavigationService.getActiveItem();
                                    if (activeItem) {
                                        activeItem.scope.$emit(
                                            "msNavigation::stateMatched"
                                        );
                                    }
                                }
                            }
                        }
                    );

                    // Folded status watcher
                    scope.$watch("folded", function (current, old) {
                        if (
                            angular.isUndefined(current) ||
                            angular.equals(current, old)
                        ) {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded) {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if (folded) {
                            // Collapse everything
                            $rootScope.$broadcast("msNavigation::collapse");

                            // Add class to the body
                            bodyEl.addClass("ms-navigation-folded");

                            // Set fold expander
                            setFoldExpander();
                        } else {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if (activeItem) {
                                activeItem.scope.$emit(
                                    "msNavigation::stateMatched"
                                );
                            }

                            // Remove body class
                            bodyEl.removeClass(
                                "ms-navigation-folded ms-navigation-folded-open"
                            );

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander() {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function () {
                            foldExpanderEl.on(
                                "mouseenter touchstart",
                                onFoldExpanderHover
                            );
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser() {
                        bodyEl.find("#main").append(foldCollapserEl);
                        foldCollapserEl.on(
                            "mouseenter touchstart",
                            onFoldCollapserHover
                        );
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser() {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem) {
                            activeItem.scope.$emit(
                                "msNavigation::stateMatched"
                            );
                        }

                        // Add class to the body
                        bodyEl.addClass("ms-navigation-folded-open");

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast("msNavigation::collapse");

                        // Remove body class
                        bodyEl.removeClass("ms-navigation-folded-open");

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function () {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on("$stateChangeStart", function () {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on("$destroy", function () {
                        foldCollapserEl.off("mouseenter touchstart");
                        foldExpanderEl.off("mouseenter touchstart");
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController(
        $scope,
        $element,
        $rootScope,
        $animate,
        $state,
        $localStorage,
        msNavigationService,
        jwtHelper,
        config,
        $http,
        $q
    ) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = "animate-height";
        vm.token = $localStorage.tokenJWT;
        vm.country = $localStorage.country;

        // console.log(vm.node);

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;
        vm.getExternalUrl = getExternalUrl;
        vm.goToExternal = goToExternal;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(
                angular.isDefined(vm.node.group) && vm.node.group === true
            );

            // Is collapsable?
            if (!vm.hasChildren || vm.group) {
                vm.collapsable = false;
            } else {
                vm.collapsable = !!(
                    angular.isUndefined(vm.node.collapsable) ||
                    typeof vm.node.collapsable !== "boolean" ||
                    vm.node.collapsable === true
                );
            }

            // Is collapsed?
            if (!vm.collapsable) {
                vm.collapsed = false;
            } else {
                vm.collapsed = !!(
                    angular.isUndefined(vm.node.collapsed) ||
                    typeof vm.node.collapsed !== "boolean" ||
                    vm.node.collapsed === true
                );
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (
                vm.node.state === $state.current.name ||
                $state.includes(vm.node.state)
            ) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (
                    angular.isDefined(vm.node.stateParams) &&
                    angular.isDefined($state.params) &&
                    !angular.equals(vm.node.stateParams, $state.params)
                ) {
                    return;
                }

                $scope.$emit("msNavigation::stateMatched");

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on("msNavigation::stateMatched", function () {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed) {
                    $scope.$evalAsync(function () {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on("msNavigation::collapse", function (event, path) {
                if (vm.collapsed || !vm.collapsable) {
                    return;
                }

                // If there is no path defined, collapse
                if (angular.isUndefined(path)) {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else {
                    var givenPathParts = path.split("."),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if (activeItem) {
                        activePathParts = activeItem.node._path.split(".");
                    }

                    // Test for given path
                    if (givenPathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    // Test for active path
                    if (activePathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on("$stateChangeSuccess", function () {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (
                        angular.isDefined(vm.node.stateParams) &&
                        angular.isDefined($state.params) &&
                        !angular.equals(vm.node.stateParams, $state.params)
                    ) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast(
                        "msNavigation::collapse",
                        vm.node._path
                    );
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ($state.includes(vm.node.state)) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (
                        angular.isDefined(vm.node.stateParams) &&
                        angular.isDefined($state.params) &&
                        !angular.equals(vm.node.stateParams, $state.params)
                    ) {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit("msNavigation::stateMatched");
                }
            });
        }

        function getExternalUrl(state) {
            if (state.indexOf("?") !== -1) {
                return state + "&token=" + vm.token;
            }
            return state + "?token=" + vm.token;
        }

        function goToExternal(ev, itemNode) {
            angular.element.blockUI();
            ev.preventDefault();

            var decode = jwtHelper.decodeToken(vm.token);
            var params = {
                tokenID: decode.jti,
                appID: "hcportal"
            };
            var refresh = refreshToken(params);
            refresh.then(function (data) {
                angular.element.unblockUI();
                var url = itemNode;
                if (itemNode.indexOf("?") !== -1) {
                    url = itemNode + "&token=" + data;
                } else {
                    url = itemNode + "?token=" + data;
                }
                window.open(url, "_blank");
            });
            refresh.catch(function (err) {
                alert("failed refresh token");
            });
        }

        function refreshToken(params) {
            var defer = $q.defer();
            var httpOption = {
                url: config.api + "api/token/refreshJWT",
                skipAuthorization: true,
                method: "POST",
                data: params
            };

            var request = $http(httpOption);
            request.then(
                function (res) {
                    $localStorage.tokenJWT = res.data.data;
                    defer.resolve(res.data.data);
                },
                function (err) {
                    console.log(err);
                    defer.reject();
                }
            );
            return defer.promise;
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed() {
            if (vm.collapsed) {
                vm.expand();
            } else {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children("ul");

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass("collapsing");

                // Animate the height
                $animate
                    .animate(
                        collapseEl,
                        {
                            display: "block",
                            height: height + "px"
                        },
                        {
                            height: "0px"
                        },
                        vm.animateHeightClass
                    )
                    .then(function () {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            display: "",
                            height: ""
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass("collapsing");
                    });

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast("msNavigation::collapse");
            });
        }

        /**
         * Expand
         */
        function expand() {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children("ul");

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                position: "absolute",
                visibility: "hidden",
                display: "block",
                height: "auto"
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                position: "",
                visibility: "",
                display: "",
                height: ""
            });

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass("expanding");

                // Animate the height
                $animate
                    .animate(
                        expandEl,
                        {
                            display: "block",
                            height: "0px"
                        },
                        {
                            height: height + "px"
                        },
                        vm.animateHeightClass
                    )
                    .then(function () {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            height: ""
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass("expanding");
                    });

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast("msNavigation::collapse", vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden() {
            if (
                angular.isDefined(vm.node.hidden) &&
                angular.isFunction(vm.node.hidden)
            ) {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict: "A",
            bindToController: {
                node: "=msNavigationNode"
            },
            controller: "MsNavigationNodeController as vm",
            compile: function (tElement) {
                tElement.addClass("ms-navigation-node");

                return function postLink(
                    scope,
                    iElement,
                    iAttrs,
                    MsNavigationNodeCtrl
                ) {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group) {
                        iElement.addClass("group");
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: "A",
            require: "^msNavigationNode",
            compile: function (tElement) {
                tElement.addClass("ms-navigation-item");

                return function postLink(
                    scope,
                    iElement,
                    iAttrs,
                    MsNavigationNodeCtrl
                ) {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable) {
                        iElement.on(
                            "click",
                            MsNavigationNodeCtrl.toggleCollapsed
                        );
                    }

                    // Cleanup
                    scope.$on("$destroy", function () {
                        iElement.off("click");
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: "E",
            scope: {
                root: "@"
            },
            controller: "MsNavigationController as vm",
            templateUrl:
                "app/core/directives/ms-navigation/templates/horizontal.html",
            transclude: true,
            compile: function (tElement) {
                tElement.addClass("ms-navigation-horizontal");

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController(
        $scope,
        $element,
        $rootScope,
        $state,
        msNavigationService
    ) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(
                angular.isDefined(vm.node.group) && vm.node.group === true
            );

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (
                vm.node.state === $state.current.name ||
                $state.includes(vm.node.state)
            ) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (
                    angular.isDefined(vm.node.stateParams) &&
                    angular.isDefined($state.params) &&
                    !angular.equals(vm.node.stateParams, $state.params)
                ) {
                    return;
                }

                $scope.$emit("msNavigation::stateMatched");

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on("msNavigation::stateMatched", function () {
                // Mark as active if has children
                if (vm.hasChildren) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on("msNavigation::clearActive", function () {
                if (!vm.hasChildren) {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                    activePathParts = activeItem.node._path.split(".");
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                } else {
                    $scope.$evalAsync(function () {
                        vm.isActive = false;
                    });
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on("$stateChangeSuccess", function () {
                if (
                    vm.node.state === $state.current.name ||
                    $state.includes(vm.node.state)
                ) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (
                        angular.isDefined(vm.node.stateParams) &&
                        angular.isDefined($state.params) &&
                        !angular.equals(vm.node.stateParams, $state.params)
                    ) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast("msNavigation::clearActive");
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective() {
        return {
            restrict: "A",
            bindToController: {
                node: "=msNavigationHorizontalNode"
            },
            controller: "MsNavigationHorizontalNodeController as vm",
            compile: function (tElement) {
                tElement.addClass("ms-navigation-horizontal-node");

                return function postLink(
                    scope,
                    iElement,
                    iAttrs,
                    MsNavigationHorizontalNodeCtrl
                ) {
                    // Add custom classes
                    iElement.addClass(
                        MsNavigationHorizontalNodeCtrl.getClass()
                    );

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group) {
                        iElement.addClass("group");
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia) {
        return {
            restrict: "A",
            require: "^msNavigationHorizontalNode",
            compile: function (tElement) {
                tElement.addClass("ms-navigation-horizontal-item");

                return function postLink(
                    scope,
                    iElement,
                    iAttrs,
                    MsNavigationHorizontalNodeCtrl
                ) {
                    iElement.on("click", onClick);

                    function onClick() {
                        if (
                            !MsNavigationHorizontalNodeCtrl.hasChildren ||
                            $mdMedia("gt-md")
                        ) {
                            return;
                        }

                        iElement.toggleClass("expanded");
                    }

                    // Cleanup
                    scope.$on("$destroy", function () {
                        iElement.off("click");
                    });
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    "use strict";
    /**
     *  Module
     *
     * Description
     */
    angular.module('app.wfh-report-health', []).config(config);

    config.$inject = ['$stateProvider'];
    function config($stateProvider) {
        $stateProvider
            .state('app.wfh-report-health', {
                url: '/report-health',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/wfh-report-health/wfh-report-health.html',
                        controller: 'WfhReportHealthController as vm'
                    }
                }

            });
    }
}());
(function () {
    'use strict';

    angular
        .module('app.wfh-report-health')
        .controller('WfhReportHealthController', WfhReportHealthController);

    WfhReportHealthController.$inject = ['AppAPI', 'DataService', '$mdDialog', 'Form', 'Auth', 'FileUploader', 'config', '$localStorage', '$document', '$http', '$location', '$window', '$element', '$filter'];

    function WfhReportHealthController(AppAPI, DataService, $mdDialog, Form, Auth, FileUploader, config, $localStorage, $document, $http, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');
        var basePath = 'app/main/wfh-report-health';
        Form.initialForm();

        var endPoint = AppAPI.WfhReport();

        Form.setObject(endPoint);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.lisPayrollEmployeeSelected = [];
        vm.DeletePayrollEmployee = DeletePayrollEmployee;
        vm.openUploadEmployee = openUploadEmployee;
        vm.closeModal = closeModal;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;
        vm.LoadCompany = LoadCompany;
        vm.LoadDepartment = LoadDepartment;
        vm.LoadArea = LoadArea;
        vm.changeCompany = changeCompany;
        vm.LoadDivisi = LoadDivisi;
        vm.DownloadEmployee = DownloadEmployee;
        vm.company = $localStorage.empsite;
        vm.country = $localStorage.country;
        vm.start_date = new Date();
        vm.end_date = new Date();
        vm.divisi = vm.department = vm.area = 'all';
        vm.status = ["all"];
        vm.isAll = false;

        vm.selectedDatas = [];
        vm.autocompleteDemoRequireMatch = true;
        vm.transformChip = transformChip;
        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }

            // Otherwise, create a new one
            return { name: chip, type: 'new' };
        }

        vm.Form.objForm.empno = '';
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.arr_area = [];
        vm.listStatus = [
            {
                'id': 'all',
                'name': 'All',
            },
            {
                'id': 'fix',
                'name': 'Fit',
            },
            {
                'id': 'unfix',
                'name': 'Unfit',
            },
            {
                'id': 'sick',
                'name': 'Sick',
            },
        ];

        //loadData(1);
        LoadCompany();
        LoadDivisi(vm.company);
        LoadDefaultArea(vm.company);

        vm.items = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;

        LoadCountry();

        function LoadCountry() {
            var response = endPoint.query({
                action: 'getCountry'
            });
            response.$promise.then(fetchCountry);
            response.$promise.catch(errorFetchCountry);
        }

        function fetchCountry(data) {
            vm.listcountry = data;
        }

        function errorFetchCountry() {
            vm.listcountry = [];
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return vm.lisPayrollEmployeeSelected.length !== 0 && vm.lisPayrollEmployeeSelected.length !== vm.items.length;
        }

        function isChecked() {
            return vm.lisPayrollEmployeeSelected.length === vm.items.length && vm.items.length != 0;
        }

        function toggleAll() {
            if (vm.lisPayrollEmployeeSelected.length === vm.items.length) {
                vm.lisPayrollEmployeeSelected = [];
            } else if (vm.lisPayrollEmployeeSelected.length === 0 || vm.lisPayrollEmployeeSelected.length > 0) {
                vm.lisPayrollEmployeeSelected = vm.items.slice(0);
            }
        }

        function LoadArea(company, cabangid, regionalid) {
            LoadDivisi(company);
            loadWilayah();
            var response = PayrollEmployee.query({
                action: 'getArea',
                companyid: company,
                cabangid: (cabangid) ? cabangid.toString() : '',
                regionalid: (regionalid) ? regionalid.toString() : ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea = data;
            vm.arr_area = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].id != 'all') {
                    vm.arr_area.push('"' + data[i].id + '"');
                }
            }
        }

        function errorFetchArea() {
            vm.listarea = [];
        }

        function loadWilayah() {
            var response = PayrollEmployee.query({
                action: 'getWilayah',
                companyid: vm.company
            });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadData(pageno) {
            vm.arrNik = [];
            if (vm.selectedDatas.length > 0) {
                for (var i = 0; i < vm.selectedDatas.length; i++) {
                    vm.arrNik.push('"' + vm.selectedDatas[i].empno + '"');
                }
            }

            vm.arrStatus = [];
            if (vm.status.length > 0) {
                for (var i = 0; i < vm.status.length; i++) {
                    vm.arrStatus.push('"' + vm.status[i] + '"');
                }
            }

            var resp = vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewData',
                company: vm.company,
                country: vm.country,
                department: vm.department,
                area: vm.area,
                startDate: vm.start_date,
                endDate: vm.end_date,
                divisi: vm.divisi,
                status: vm.arrStatus.toString(),
                nik: vm.arrNik.toString()
            });

            resp.then(function (data) {
                console.log(vm.selectedDatas);
                angular.element.unblockUI();
                vm.lisPayrollEmployeeSelected = [];
                vm.items = data.list;
            });
        }

        function selectedItemChanged(employee) {

            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined' && employee != null) {
                console.log('pertama: ', employee)
                console.log('kedua: ', employee.empno)
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/wfhreport?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var response = endPoint.query({
                action: 'getCompany'
            });
            response.$promise.then(fetchCompany);
            response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany = data;
        }

        function errorFetchCompany() {
            vm.listcompany = [];
        }

        function changeCompany(id) {
            vm.listarea = [];
            var resp = PayrollEmployee.query({
                action: 'getSpecificArea',
                companyid: id
            })
            resp.$promise.then(fetchspecificarea);
            resp.$promise.catch(errorfetchspecificarea);
        }

        function fetchspecificarea(data) {
            vm.listarea = data;
        }

        function errorfetchspecificarea() {
            vm.listarea = [];
        }

        function LoadDepartment(company, divisi) {
            var response = endPoint.query({
                action: 'getDepartment',
                idbu: company,
                iddivisi: divisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorFetchDepartment);
        }

        function fetchDepartment(data) {
            vm.listdepartment = data;
        }

        function errorFetchDepartment() {
            vm.listdepartment = [];
        }

        function LoadDefaultArea(companyid) {
            var response = endPoint.query({
                action: 'getArea',
                companyid: companyid,
                regionalid: ''
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
            LoadDivisi(companyid)

        }

        function LoadDivisi(company) {
            var response = endPoint.query({
                action: 'getDivision',
                idbu: company
            });
            response.$promise.then(fetchDivisi);
            response.$promise.catch(errorFetchDivisi);
            LoadDepartment(company, vm.divisi);
        }

        function fetchDivisi(data) {
            vm.listdivisi = data;
        }

        function errorFetchDivisi() {
            vm.listdivisi = [];
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisPayrollEmployeeSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisPayrollEmployeeSelected = [];
        }


        function openUploadEmployee(ev) {
            $mdDialog.show({
                controller: 'NewUploademployeeController as vm',
                templateUrl: basePath + '/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }


        function DeletePayrollEmployee(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = PayrollEmployee.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisPayrollEmployeeSelected)
                    });

                    response.$promise.then(loadData);
                    response.$promise.catch(ErrDel);

                    loadData(1);
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function DownloadEmployee(companyid, divisiid, departmentid, areaid, idemployee, wilayah, regional, cabang) {
            var token = Auth.setTokenPromise();

            vm.arrNik = [];
            if (vm.selectedDatas.length > 0) {
                for (var i = 0; i < vm.selectedDatas.length; i++) {
                    vm.arrNik.push('"' + vm.selectedDatas[i].empno + '"');
                }
            } else {
                vm.arrNik = 'undefined';
            }
            vm.arrStatus = [];
            if (vm.status.length > 0) {
                for (var i = 0; i < vm.status.length; i++) {
                    vm.arrStatus.push('"' + vm.status[i] + '"');
                }
            } else {
                vm.arrStatus = 'undefined';
            }
            var startDate = vm.start_date.getFullYear() + '-' + (vm.start_date.getMonth() + 1) + '-' + vm.start_date.getDate();
            var endDate = vm.end_date.getFullYear() + '-' + (vm.end_date.getMonth() + 1) + '-' + vm.end_date.getDate();

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/wfhreport/wfhStatusDependentTeamExportExcel/' + vm.country + '/' + vm.company + '/' + vm.department + '/' + vm.area + '/' + vm.divisi + '/' + startDate + '/' + endDate + '/' + vm.arrNik.toString() + '/' + vm.arrStatus.toString() + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }


        function ErrDel() {
            alert("Sorry, Data can't delete. other transactions using this data");

        }

        function closeModal() {
            $mdDialog.hide();
        }

        vm.selectStatus = selectStatus;
        function selectStatus(status) {
            if (typeof status != "undefined" && status.indexOf('all') != -1) {
                if ((vm.listStatus.length - 1) == status.length) {
                    var index = status.indexOf('all');
                    if (index > -1) {
                        vm.status.splice(index, 1);
                    }
                    vm.isAll = false;
                } else {
                    vm.isAll = true;
                    vm.status = [];
                    for (var i = 0; i <= (vm.listStatus.length - 1); i++) {
                        vm.status.push(vm.listStatus[i].id);
                    }
                }
            } else {
                if (vm.isAll) {
                    vm.status = [];
                    vm.isAll = false;
                } else if (typeof status != "undefined" && (vm.listStatus.length - 1) == status.length) {
                    vm.status.push('all');
                    vm.isAll = true;
                }
            }
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
//
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.umut-report', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.umut_report', {
                url    : '/um-ut-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/umut-report/umutreport.html',
                    controller : 'UmutreportController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.umut-report')
        .controller('UmutreportController', UmutreportController);

    UmutreportController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function UmutreportController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window, $element) {
       
       var vm = this;
       var endPoint=AppAPI.Umutreport();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExporttoExcel = ExporttoExcel;

       vm.company       = $localStorage.empsite;
       vm.loadDivision  = loadDivision;
       vm.LoadRegional  = loadRegional;
       vm.LoadCabang    = loadCabang;
       vm.LoadWilayah   = loadWilayah;

       vm.reqWil    = false;
       vm.reqArea   = true;

       LoadPeriod();
       LoadSubPeriod();
       LoadCompany()
       loadWilayah();
       LoadAreaDefault(vm.company);

       function LoadAreaDefault(company) 
        {
            var response=endPoint.query({action:'getArea', companyid:company});
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

       function fetchAreaDefault(data) {
            vm.listarea=data;
       }

       function errorFetchAreaDefault() {
            vm.listarea=[];
       }

      function LoadPeriod() 
      {
          var response=endPoint.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 
      
       function LoadSubPeriod() 
      {
          var response=endPoint.query({action:'getSubPeriod'});
          response.$promise.then(fetchSubPeriod);
          response.$promise.catch(errorFetchSubPeriod);
       }

       function fetchSubPeriod(data) {
            vm.listsubperiod=data;
       }

       function errorFetchSubPeriod() {
            vm.listsubperiod=[];
       } 

       function LoadCompany() {
          var response=endPoint.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

        function LoadArea(company,cabangid) 
        {
            loadDivision(company);
            loadWilayah();
            var response=endPoint.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadDivision(company) {
          var response=endPoint.query({action:'getDivision', companyid:company});
          response.$promise.then(fetchDivision);
          response.$promise.catch(errorFetchDivision);
       }

       function fetchDivision(data) {
            vm.listDivision=data;
       }

       function errorFetchDivision() {
            vm.listDivision=[];
       }  
       
       function loadWilayah() {
          var response=endPoint.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=endPoint.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=endPoint.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  
       
       function ExporttoExcel(form) 
       {    
            var subPeriod   = encodeURIComponent(window.btoa(vm.subperiod));
            var token       = Auth.setTokenPromise();
            var period      = encodeURIComponent(window.btoa(vm.period));
            var company     = encodeURIComponent(window.btoa(vm.company));
            var area        = encodeURIComponent(window.btoa(vm.area));
            var division    = encodeURIComponent(window.btoa(vm.division));
            var wilayah     = encodeURIComponent(window.btoa(vm.wilayah));
            var regional    = encodeURIComponent(window.btoa(vm.regional));
            var cabang      = encodeURIComponent(window.btoa(vm.cabang));
            var action      = encodeURIComponent(window.btoa('downloadReport'));
            
            token.then(function(data) 
            {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/umutreport/lgexportexcel/' + period + '/' + company  + '/' + area + '/' + division + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + subPeriod + '/' +  data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.uploadwfhumut', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject = ['$stateProvider', 'msNavigationServiceProvider'];
    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {


        // State
        $stateProvider
            .state('app.uploadwfhumut', {
                url: '/upload-whf-umut',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/uploadwfhumut/uploadwfhumut.html',
                        controller: 'UploadWfhUmutController as vm'
                    }
                }
            });
    }
})();
(function () {
  'use strict';
  angular
    .module('app.uploadwfhumut')
    .controller('UploadWfhUmutController', UploadWfhUmutController);

  UploadWfhUmutController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter', 'AppAPI', 'DataService', '$document', '$element'];
  /** @ngInject */
  function UploadWfhUmutController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter, AppAPI, DataService, $document, $element) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    var endPoint = AppAPI.UploadWfhUmut();
    var endPointUmut = AppAPI.Umutreport();

    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.upload = upload;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = [];
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;

    vm.uploadSuccess = vm.uploadError = vm.isMoreInfo = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.viewMoreInfo = viewMoreInfo
    vm.LoadRegional = loadRegional
    vm.LoadArea = LoadArea
    vm.LoadCabang = loadCabang
    vm.detailInfo = []

    vm.reqWil = false;
    vm.reqArea = true;

    LoadPeriod();
    LoadSubPeriod();
    LoadCompany()
    loadWilayah();
    LoadAreaDefault(vm.company);

    vm.FileUploader = new FileUploader({
      url: config.api + 'api/wfhumut/uploadfile',
      removeAfterUpload: true,
      alias: 'fileupload',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUploader.onSuccessItem = function (data, status, headers, config) {
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message

      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUploader.onErrorItem = function () {
      vm.uploadSuccess = false;
      vm.uploadError = true;

    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/wfhumut/downloadtemplate', '_blank');
      }, function () {
        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo(detail) {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: detail
        }
      });
    }

    function upload(ev) {
      $mdDialog.show({
        controller: 'UploadWfhUmutController',
        controllerAs: 'vm',
        templateUrl: 'app/main/uploadwfhumut/upload-form.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        start_date: vm.startDate,
        end_date: vm.endDate,
        company: vm.company,
        area: vm.area,
        division: vm.division,
        wilayah: vm.wilayah,
        regional: vm.regional,
        cabang: vm.cabang
      });

      resp.then(function (data) {
        angular.element.unblockUI();
        vm.selected = [];
        vm.items = data.list;
      });
      resp.catch(function (data) {
        angular.element.unblockUI();
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function deleteData(ev) {
      var message = translate('PAYROLL.MESSAGE.CONFDEL');
      var note = translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function LoadAreaDefault(company) {
      var response = endPointUmut.query({ action: 'getArea', companyid: company });
      response.$promise.then(fetchAreaDefault);
      response.$promise.catch(errorFetchAreaDefault);
    }

    function fetchAreaDefault(data) {
      vm.listarea = data;
    }

    function errorFetchAreaDefault() {
      vm.listarea = [];
    }

    function LoadPeriod() {
      var response = endPointUmut.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listperiod = data;
    }

    function errorFetchPeriod() {
      vm.listperiod = [];
    }

    function LoadSubPeriod() {
      var response = endPointUmut.query({ action: 'getSubPeriod' });
      response.$promise.then(fetchSubPeriod);
      response.$promise.catch(errorFetchSubPeriod);
    }

    function fetchSubPeriod(data) {
      vm.listsubperiod = data;
    }

    function errorFetchSubPeriod() {
      vm.listsubperiod = [];
    }

    function LoadCompany() {
      var response = endPointUmut.query({ action: 'getCompany' });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listcompany = data;
    }

    function errorFetchCompany() {
      vm.listcompany = [];
    }

    function LoadArea(company, cabangid) {
      loadDivision(company);
      loadWilayah();
      var response = endPointUmut.query({ action: 'getArea', companyid: company, cabangid: cabangid });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listarea = data;
    }

    function errorFetchArea() {
      vm.listarea = [];
    }

    function loadWilayah() {
      var response = endPointUmut.query({ action: 'getWilayah', companyid: vm.company });
      response.$promise.then(fetchWilayah);
      response.$promise.catch(errorFetchWilayah);
    }

    function fetchWilayah(data) {
      vm.listWilayah = data;
    }

    function errorFetchWilayah() {
      vm.listWilayah = [];
    }

    function loadRegional(id) {
      vm.listarea = [];
      vm.reqWil = true;
      vm.reqArea = false;
      var response = endPointUmut.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
      response.$promise.then(fetchRegional);
      response.$promise.catch(errorFetchRegional);
    }

    function fetchRegional(data) {
      vm.listRegional = data;
    }

    function errorFetchRegional() {
      vm.listRegional = [];
    }

    function loadCabang(id) {
      var response = endPointUmut.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
      response.$promise.then(fetchCabang);
      response.$promise.catch(errorFetchCabang);
    }

    function fetchCabang(data) {
      vm.listCabang = data;
    }

    function errorFetchCabang() {
      vm.listCabang = [];
    }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.uploadadditionalumut', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.uploadadditionalumut', {
                url    : '/upload-additional-umut',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/uploadadditionalumut/upload-data.html',
                        controller : 'UploadAdditionalUmutController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function () {
  'use strict';
  angular
    .module('app.uploadadditionalumut')
    .controller('UploadAdditionalUmutController', UploadAdditionalUmutController);

  UploadAdditionalUmutController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter', 'AppAPI', 'DataService', '$document', '$element'];
  /** @ngInject */
  function UploadAdditionalUmutController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter, AppAPI, DataService, $document, $element) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    var endPoint = AppAPI.AdditionalUMUT();
    var endPointUmut = AppAPI.Umutreport();

    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.upload = upload;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = [];
    vm.deleteData = deleteData;
    vm.changeArea = changeArea;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;

    vm.uploadSuccess = vm.uploadError = vm.isMoreInfo = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.viewMoreInfo = viewMoreInfo
    vm.LoadRegional = loadRegional
    vm.LoadArea = LoadArea
    vm.LoadCabang = loadCabang
    vm.viewComment = viewComment
    vm.detailInfo = []

    vm.reqWil = false;
    vm.reqArea = true;

    LoadPeriod();
    LoadSubPeriod();
    LoadCompany()
    loadWilayah();
    LoadAreaDefault(vm.company);

    vm.FileUploader = new FileUploader({
      url: config.api + 'api/additionalumut/uploadfile',
      removeAfterUpload: true,
      alias: 'fileupload',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUploader.onSuccessItem = function (data, status, headers, config) {
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message

      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUploader.onErrorItem = function () {
      vm.uploadSuccess = false;
      vm.uploadError = true;

    };

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'AdditionalUmutViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          vm.listOtselected = [];
        },
        locals: {
          id: id
        }
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/additionalumut/downloadtemplate', '_blank');
      }, function () {
        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo(detail) {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: detail
        }
      });
    }

    function upload(ev) {
      $mdDialog.show({
        controller: 'UploadAdditionalUmutController',
        controllerAs: 'vm',
        templateUrl: 'app/main/uploadadditionalumut/upload-form.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function changeArea(ev, data) {
      $mdDialog.show({
        controller: 'ChangeAreaUmutController',
        controllerAs: 'vm',
        templateUrl: 'app/main/uploadadditionalumut/change-area.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        subPeriod: vm.subperiod,
        period: vm.period,
        company: vm.company,
        area: vm.area,
        division: vm.division,
        wilayah: vm.wilayah,
        regional: vm.regional,
        tgl: vm.tgl,
        cabang: vm.cabang
      });

      resp.then(function (data) {
        angular.element.unblockUI();
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function deleteData(ev) {
      var message = translate('PAYROLL.MESSAGE.CONFDEL');
      var note = translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function LoadAreaDefault(company) {
      var response = endPointUmut.query({ action: 'getArea', companyid: company });
      response.$promise.then(fetchAreaDefault);
      response.$promise.catch(errorFetchAreaDefault);
    }

    function fetchAreaDefault(data) {
      vm.listarea = data;
    }

    function errorFetchAreaDefault() {
      vm.listarea = [];
    }

    function LoadPeriod() {
      var response = endPointUmut.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listperiod = data;
    }

    function errorFetchPeriod() {
      vm.listperiod = [];
    }

    function LoadSubPeriod() {
      var response = endPointUmut.query({ action: 'getSubPeriod' });
      response.$promise.then(fetchSubPeriod);
      response.$promise.catch(errorFetchSubPeriod);
    }

    function fetchSubPeriod(data) {
      vm.listsubperiod = data;
    }

    function errorFetchSubPeriod() {
      vm.listsubperiod = [];
    }

    function LoadCompany() {
      var response = endPointUmut.query({ action: 'getCompany' });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listcompany = data;
    }

    function errorFetchCompany() {
      vm.listcompany = [];
    }

    function LoadArea(company, cabangid) {
      loadDivision(company);
      loadWilayah();
      var response = endPointUmut.query({ action: 'getArea', companyid: company, cabangid: cabangid });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listarea = data;
    }

    function errorFetchArea() {
      vm.listarea = [];
    }

    function loadDivision(company) {
      var response = endPointUmut.query({ action: 'getDivision', companyid: company });
      response.$promise.then(fetchDivision);
      response.$promise.catch(errorFetchDivision);
    }

    function fetchDivision(data) {
      vm.listDivision = data;
    }

    function errorFetchDivision() {
      vm.listDivision = [];
    }

    function loadWilayah() {
      var response = endPointUmut.query({ action: 'getWilayah', companyid: vm.company });
      response.$promise.then(fetchWilayah);
      response.$promise.catch(errorFetchWilayah);
    }

    function fetchWilayah(data) {
      vm.listWilayah = data;
    }

    function errorFetchWilayah() {
      vm.listWilayah = [];
    }

    function loadRegional(id) {
      vm.listarea = [];
      vm.reqWil = true;
      vm.reqArea = false;
      var response = endPointUmut.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
      response.$promise.then(fetchRegional);
      response.$promise.catch(errorFetchRegional);
    }

    function fetchRegional(data) {
      vm.listRegional = data;
    }

    function errorFetchRegional() {
      vm.listRegional = [];
    }

    function loadCabang(id) {
      var response = endPointUmut.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
      response.$promise.then(fetchCabang);
      response.$promise.catch(errorFetchCabang);
    }

    function fetchCabang(data) {
      vm.listCabang = data;
    }

    function errorFetchCabang() {
      vm.listCabang = [];
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.uploadadditionalumut')
    .controller('ChangeAreaUmutController', ChangeAreaUmutController);


  ChangeAreaUmutController.$inject = ['$state', '$mdDialog', 'AppAPI', '$localStorage', '$filter', '$element', 'Form', 'data'];
  /** @ngInject */
  function ChangeAreaUmutController($state, $mdDialog, AppAPI, $localStorage, $filter, $element, Form, data) {
    var vm = this;
    var translate = $filter('translate');
    var attributes = data
    var endPoint = AppAPI.AdditionalUMUT();
    vm.changeArea = changeArea;
    vm.dialogClose = dialogClose;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.company = $localStorage.empsite;

    LoadAreaDefault(vm.company);

    function dialogClose() {
      $mdDialog.hide();
    }
    function LoadAreaDefault(company) {
      var response = endPoint.query({ action: 'getArea', companyid: company });
      response.$promise.then(fetchAreaDefault);
      response.$promise.catch(errorFetchAreaDefault);
    }

    function fetchAreaDefault(data) {
      vm.listarea = data;
    }

    function errorFetchAreaDefault() {
      vm.listarea = [];
    }

    function changeArea(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.id = attributes.id;
      vm.Form.objForm.area = vm.area;

      var response = Form.saveData('changeArea', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        if (data.status == 1) {
          successApproved(ev, data);
        } else {
          failedApproved(ev, data);
        }
      });
      response.catch(function (data) {
        failedApproved(ev, data.data);
        angular.element.unblockUI();
      });
    }

    function successApproved(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          loadData(1);
        }
      });
    }

    function failedApproved(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.uploadadditionalinsentif', [
        ])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider','msNavigationServiceProvider'];
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {


        // State
        $stateProvider
            .state('app.uploadadditionalinsentif', {
                url    : '/upload-additional-insentif',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/uploadadditionalinsentif/upload-data.html',
                        controller : 'UploadAdditionalInsentifController as vm'
                    }
                }
            });
         

       

      
    }
})();
(function() {
    'use strict';
    angular
      .module('app.uploadadditionalinsentif')
      .controller('UploadAdditionalInsentifController', UploadAdditionalInsentifController);
  
    UploadAdditionalInsentifController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter','AppAPI','DataService','$document','$element'];
    /** @ngInject */
    function UploadAdditionalInsentifController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter,AppAPI,DataService,$document,$element) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
      
      var endPoint = AppAPI.AdditionalInsentif();
      var endPointUmut=AppAPI.Umutreport();
      var endPointInsentif=AppAPI.Insentifreport();
      
      vm.DataTables = new DataService();
      vm.listJum = [2, 5, 25, 50, 75, 100, 200];
      vm.loadData = loadData;
      vm.selected = [];
      vm.toggle = toggle;
      vm.exists = exists;
      vm.isIndeterminate = isIndeterminate;
      vm.isChecked = isChecked;
      vm.toggleAll = toggleAll;
      vm.items = [];
      vm.upload = upload; 
      vm.selectedItem = null;
      vm.searchText = null;
      vm.listNC = []; 
      vm.deleteData = deleteData;
      vm.dialogClose = dialogClose;
      vm.company=$localStorage.empsite;
      
      vm.uploadSuccess = vm.uploadError = vm.isMoreInfo =  false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.viewMoreInfo = viewMoreInfo
      vm.LoadRegional = loadRegional
      vm.LoadCabang = loadCabang
      vm.LoadArea = LoadArea
      vm.viewComment = viewComment
      vm.detailInfo = []
      
      vm.reqWil    = false;
      vm.reqArea   = true;

      LoadPeriod();
      LoadSubPeriod();
      LoadCompany()
      loadWilayah();
      LoadAreaDefault(vm.company);

      vm.FileUploader = new FileUploader({
        url: config.api + 'api/additionalinsentif/uploadfile',
        removeAfterUpload: true,
        alias: 'fileupload',
        formData: [{
            action: 'uploadfile'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUploader.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
          var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUploader.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };
  
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/additionalinsentif/downloadtemplate', '_blank');
          },function(){
              $window.alert('gagal load token');
          });
      }

      function viewMoreInfo(detail)
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              loadData(1);
          },
          locals:{
            data:detail
          }
        });
      }

      function upload(ev) {
        $mdDialog.show({
          controller: 'UploadAdditionalInsentifController',
          controllerAs: 'vm',
          templateUrl: 'app/main/uploadadditionalinsentif/upload-form.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          onRemoving: function(element, removePromise) {
            loadData(1);
          },
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        });
      }

      function loadData(pageno) {
        var resp = vm.DataTables.loadData(endPoint, pageno, {
          action: 'viewData',
          subPeriod   : vm.subperiod,
          period      : vm.period,
          company     : vm.company,
          area        : vm.area,
          division    : vm.division,
          wilayah     : vm.wilayah,
          regional    : vm.regional,
          cabang      : vm.cabang
        });
  
        resp.then(function(data) {
          angular.element.unblockUI();
          vm.selected = [];
          vm.items = data.list;
        });
      }
      
      function dialogClose() {
        $mdDialog.hide();
      }
  
      function toggle(item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        } else {
          list.push(item);
        }
      }
  
      function exists(item, list) {
        return list.indexOf(item) > -1;
      }
  
      function isIndeterminate() {
        return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
      }
  
      function isChecked() {
        return vm.selected.length === vm.items.length;
      }
  
      function toggleAll() {
        if (vm.selected.length === vm.items.length) {
          vm.selected = [];
        } else if (vm.selected.length === 0 || vm.selected.length > 0) {
          vm.selected = vm.items.slice(0);
        }
      }

      function deleteData(ev) {
        var message = translate('PAYROLL.MESSAGE.CONFDEL');
        var note    = translate('PAYROLL.MESSAGE.DELNOTE');
        var yes     = translate('PAYROLL.MESSAGE.YES');
        var no      = translate('PAYROLL.MESSAGE.NO');
  
        var promise = Auth.setToken();
        promise.then(function() {
          var confirm = $mdDialog
            .confirm()
            .title(message)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
  
          $mdDialog.show(confirm).then(
            function() {
              var data = [];
              for (var index = 0; index < vm.selected.length; index++) {
                data.push(vm.selected[index].id);
              }
              angular.element.blockUI();
              var response = endPoint.delete({
                action: 'delete',
                data: angular.toJson(data)
              });
              response.$promise.then(function(resp) {
                dialogClose();
                angular.element.unblockUI();
                showDialogInfo(ev, resp);
              });
            },
            function() {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        });
      }

      function showDialogInfo(ev, data) {
        var message = translate(data.pesan);
        var status = translate(data.status);
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel(status)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
            loadData(1);
          });
      }

      vm.clearSearchTerm = function() {
        vm.searchTerm = '';
      };
      
      $element.find('input').on('keydown', function(ev) {
          ev.stopPropagation();
      });
      
      function LoadAreaDefault(company) 
        {
            var response=endPointUmut.query({action:'getArea', companyid:company});
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

       function fetchAreaDefault(data) {
            vm.listarea=data;
       }

       function errorFetchAreaDefault() {
            vm.listarea=[];
       }

      function LoadPeriod() 
      {
          var response=endPointUmut.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 
      
       function LoadSubPeriod() 
      {
          var response=endPointInsentif.query({action:'getSubPeriod'});
          response.$promise.then(fetchSubPeriod);
          response.$promise.catch(errorFetchSubPeriod);
       }

       function fetchSubPeriod(data) {
            vm.listsubperiod=data;
       }

       function errorFetchSubPeriod() {
            vm.listsubperiod=[];
       } 

       function LoadCompany() {
          var response=endPointUmut.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

        function LoadArea(company,cabangid) 
        {
            loadDivision(company);
            loadWilayah();
            var response=endPointUmut.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadDivision(company) {
          var response=endPointUmut.query({action:'getDivision', companyid:company});
          response.$promise.then(fetchDivision);
          response.$promise.catch(errorFetchDivision);
       }

       function fetchDivision(data) {
            vm.listDivision=data;
       }

       function errorFetchDivision() {
            vm.listDivision=[];
       }  
       
       function loadWilayah() {
          var response=endPointUmut.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=endPointUmut.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=endPointUmut.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }

      function viewComment(ev,id)
      {
        $mdDialog.show({
            controller         : 'AdditionalUmutViewRejectCommentController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/cb/approval-ghk/comment-reject.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: true,
            onRemoving:function(element, removePromise)
            { 
                vm.listOtselected=[];
            },
            locals:{
              id:id
            }
        });
      }
    }
  })();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.umut-transfer', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.umut_transfer', {
                url    : '/um-ut-transfer',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/umut-transfer/umuttransfer.html',
                    controller : 'UmuttransferController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.umut-transfer')
        .controller('UmuttransferController', UmuttransferController);

    UmuttransferController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function UmuttransferController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window, $element) {
       
       var vm = this;
       var endPoint=AppAPI.Umuttransfer();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExporttoExcel = ExporttoExcel;

       vm.company       = $localStorage.empsite;
       vm.loadDivision  = loadDivision;
       vm.LoadRegional  = loadRegional;
       vm.LoadCabang    = loadCabang;
       vm.LoadWilayah   = loadWilayah;

       vm.reqWil    = false;
       vm.reqArea   = true;

       LoadPeriod();
       LoadSubPeriod();
       LoadCompany()
       loadWilayah();
       LoadAreaDefault(vm.company);

       function LoadAreaDefault(company) 
        {
            var response=endPoint.query({action:'getArea', companyid:company});
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

       function fetchAreaDefault(data) {
            vm.listarea=data;
       }

       function errorFetchAreaDefault() {
            vm.listarea=[];
       }

      function LoadPeriod() 
      {
          var response=endPoint.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 
      
       function LoadSubPeriod() 
      {
          var response=endPoint.query({action:'getSubPeriod'});
          response.$promise.then(fetchSubPeriod);
          response.$promise.catch(errorFetchSubPeriod);
       }

       function fetchSubPeriod(data) {
            vm.listsubperiod=data;
       }

       function errorFetchSubPeriod() {
            vm.listsubperiod=[];
       } 

       function LoadCompany() {
          var response=endPoint.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

        function LoadArea(company,cabangid) 
        {
            loadDivision(company);
            loadWilayah();
            var response=endPoint.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadDivision(company) {
          var response=endPoint.query({action:'getDivision', companyid:company});
          response.$promise.then(fetchDivision);
          response.$promise.catch(errorFetchDivision);
       }

       function fetchDivision(data) {
            vm.listDivision=data;
       }

       function errorFetchDivision() {
            vm.listDivision=[];
       }  
       
       function loadWilayah() {
          var response=endPoint.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=endPoint.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=endPoint.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  
       
       function ExporttoExcel(form) 
       {    
            var subPeriod   = encodeURIComponent(window.btoa(vm.subperiod));
            var token       = Auth.setTokenPromise();
            var period      = encodeURIComponent(window.btoa(vm.period));
            var company     = encodeURIComponent(window.btoa(vm.company));
            var area        = encodeURIComponent(window.btoa(vm.area));
            var division    = encodeURIComponent(window.btoa(vm.division));
            var wilayah     = encodeURIComponent(window.btoa(vm.wilayah));
            var regional    = encodeURIComponent(window.btoa(vm.regional));
            var cabang      = encodeURIComponent(window.btoa(vm.cabang));
            var action      = encodeURIComponent(window.btoa('downloadReport'));
            
            token.then(function(data) 
            {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/umuttransfer/lgexportexcel/' + period + '/' + company  + '/' + area + '/' + division + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + subPeriod + '/' +  data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.umut-process', [])
        .config(config)
        .filter('slice', function() {
            return function(arr, start, end) {
                return arr.slice(start, end);
            };
        });

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.umut_process', {
                url: '/umut-process',
                views: {
                    'content@app': {
                        templateUrl:
                            'app/main/umut-process/umut-process.html',
                        controller: 'UmutProcessController as vm'
                    }
                }
            })
            .state('app.new_umut_process', {
                url: '/umut-process/new',
                views: {
                    'content@app': {
                        templateUrl:
                            'app/main/umut-process/new-umut-process.html',
                        controller: 'newUmutProcessController as vm'
                    }
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
    }
})();

(function () {
  'use strict';

  angular
    .module('app.umut-process')
    .controller('UmutProcessController', UmutProcessController);

  UmutProcessController.$inject = [
    '$state',
    '$mdDialog',
    'DataService',
    'AppAPI',
    'Auth',
    '$document',
    '$element',
    '$filter',
    '$localStorage'
  ];
  /** @ngInject */
  function UmutProcessController(
    $state,
    $mdDialog,
    DataService,
    AppAPI,
    Auth,
    $document,
    $element,
    $filter,
    $localStorage
  ) {
    var vm = this;
    var translate = $filter('translate');
    var umutReport = AppAPI.Umutreport();
    var endPoint = AppAPI.UmutProcess();
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.newProcess = newProcess;
    vm.detail = detail;
    vm.deleteData = deleteData;
    vm.items = [];

    vm.company = $localStorage.empsite;
    vm.loadDivision = loadDivision;
    vm.LoadRegional = loadRegional;
    vm.LoadCabang = loadCabang;
    vm.LoadWilayah = loadWilayah;

    vm.toggleSelectedAll = toggleSelectedAll;

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.selected = angular.copy(vm.DataTables.list);
      console.log(vm.selected)
    }

    function unCheckAll() {
      vm.selected = [];
    }

    vm.reqWil = false;
    vm.reqArea = true;

    LoadPeriod();
    LoadSubPeriod();
    LoadCompany()
    loadWilayah();
    LoadAreaDefault(vm.company);

    function newProcess(ev) {
      $mdDialog.show({
        controller: 'newUmutProcessController',
        controllerAs: 'vm',
        templateUrl: 'app/main/umut-process/new-umut-process.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function detail(ev, data) {
      data.period = vm.period;
      data.subPeriod = vm.subperiod;
      $mdDialog.show({
        controller: 'UmutProcessDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/umut-process/umut-process-detail.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          _data: data
        }
      });
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        subPeriod: vm.subperiod,
        period: vm.period,
        company: vm.company,
        area: vm.area,
        division: vm.division,
        wilayah: vm.wilayah,
        regional: vm.regional,
        cabang: vm.cabang
      });

      resp.then(function (data) {
        angular.element.unblockUI();
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length && vm.items.length != 0;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function LoadAreaDefault(company) {
      var response = umutReport.query({ action: 'getArea', companyid: company });
      response.$promise.then(fetchAreaDefault);
      response.$promise.catch(errorFetchAreaDefault);
    }

    function fetchAreaDefault(data) {
      vm.listarea = data;
    }

    function errorFetchAreaDefault() {
      vm.listarea = [];
    }

    function LoadPeriod() {
      var response = umutReport.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listperiod = data;
    }

    function errorFetchPeriod() {
      vm.listperiod = [];
    }

    function LoadSubPeriod() {
      var response = umutReport.query({ action: 'getSubPeriod' });
      response.$promise.then(fetchSubPeriod);
      response.$promise.catch(errorFetchSubPeriod);
    }

    function fetchSubPeriod(data) {
      delete data[0];
      vm.listsubperiod = reindex_array_keys(data);
      vm.listsubperiod.length = 2;
    }

    function errorFetchSubPeriod() {
      vm.listsubperiod = [];
    }

    function LoadCompany() {
      var response = umutReport.query({ action: 'getCompany' });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listcompany = data;
    }

    function errorFetchCompany() {
      vm.listcompany = [];
    }

    function LoadArea(company, cabangid) {
      loadDivision(company);
      loadWilayah();
      var response = umutReport.query({ action: 'getArea', companyid: company, cabangid: cabangid });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listarea = data;
    }

    function errorFetchArea() {
      vm.listarea = [];
    }

    function loadDivision(company) {
      var response = umutReport.query({ action: 'getDivision', companyid: company });
      response.$promise.then(fetchDivision);
      response.$promise.catch(errorFetchDivision);
    }

    function fetchDivision(data) {
      vm.listDivision = data;
    }

    function errorFetchDivision() {
      vm.listDivision = [];
    }

    function loadWilayah() {
      var response = umutReport.query({ action: 'getWilayah', companyid: vm.company });
      response.$promise.then(fetchWilayah);
      response.$promise.catch(errorFetchWilayah);
    }

    function fetchWilayah(data) {
      vm.listWilayah = data;
    }

    function errorFetchWilayah() {
      vm.listWilayah = [];
    }

    function loadRegional(id) {
      vm.listarea = [];
      vm.reqWil = true;
      vm.reqArea = false;
      var response = umutReport.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
      response.$promise.then(fetchRegional);
      response.$promise.catch(errorFetchRegional);
    }

    function fetchRegional(data) {
      vm.listRegional = data;
    }

    function errorFetchRegional() {
      vm.listRegional = [];
    }

    function loadCabang(id) {
      var response = umutReport.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
      response.$promise.then(fetchCabang);
      response.$promise.catch(errorFetchCabang);
    }

    function fetchCabang(data) {
      vm.listCabang = data;
    }

    function errorFetchCabang() {
      vm.listCabang = [];
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function reindex_array_keys(array, start) {
      var temp = [];
      start = typeof start == 'undefined' ? 0 : start;
      start = typeof start != 'number' ? 0 : start;
      for (var i in array) {
        temp[start++] = array[i];
      }
      return temp;
    }

    function deleteData(ev) {
      var message = translate('PAYROLL.MESSAGE.CONFDEL');
      var note = translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = translate('PAYROLL.MESSAGE.YES');
      var no = translate('PAYROLL.MESSAGE.NO');

      var jum = vm.selected.length, i = [];

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();
            var attributes = new endPoint();
            attributes.data = [];
            attributes.action = 'delete';
            for (i = 0; i < jum; i++) {
              attributes.data.push(vm.selected[i]);
            }
            var response = attributes.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              if (data.status == 1) {
                showDialogInfo(ev, data);
              } else {
                showDialogInfo(ev, data);
              }
            });
            response.catch(function (data) {
              showDialogInfo(ev, data.data);
              angular.element.unblockUI();
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.umut-process')
        .controller('UmutProcessDetailController', UmutProcessDetailController);

    UmutProcessDetailController.$inject = [
        '$state',
        '$mdDialog',
        'DataService',
        'AppAPI',
        'Auth',
        '$document',
        '$element',
        '_data',
        '$filter',
        '$localStorage'
    ];
    /** @ngInject */
    function UmutProcessDetailController(
        $state,
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        $document,
        $element,
        _data,
        $filter,
        $localStorage
    ) {
        var vm = this;
        var translate = $filter('translate');
        var endPoint=AppAPI.UmutProcess();
        vm.loadData = loadData;
        vm.detail = detail;
        vm.reProcess = reProcess;
        vm.dialogClose = dialogClose;
        vm.items = [];
        vm.company       = $localStorage.empsite;
       
       loadData();

       function detail(ev,data) {
          data.period = _data.period;
          data.subPeriod = _data.subPeriod;
        $mdDialog.show({
          controller: 'UmutProcessDetailDateController',
          controllerAs: 'vm',
          templateUrl: 'app/main/umut-process/umut-process-detail-date.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          onRemoving: function(element, removePromise) {
            loadData(1);
          },
          clickOutsideToClose: true,
          multiple: true,
          fullscreen: true,
          locals : { 
              _data : data
          }
        });
      }
       
      function reProcess(ev,data) {
        angular.element.blockUI();

        var promise = Auth.setToken();
        promise.then(function() {
            var confirm = $mdDialog
            .confirm()
            .title('Are you sure want to process ?')
            .textContent('All data will be processed and can not recovered.')
            .ariaLabel('process dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('NO');

            $mdDialog.show(confirm).then(
            function() {
                angular.element.blockUI();

                var Form= new endPoint();
                Form.action='processByNik';
                Form.nik=data.nik;   
                Form.id=data.id;   
                Form.period=data.period;   
                Form.sub_area_id=data.sub_area_id;   
                Form.sub_period=data.sub_period;   
                
                var response=Form.$save();

                response.then(function(data) {
                    angular.element.unblockUI();
                    showDialogInfo(ev, data);
                });

                response.catch(function(data) {
                    angular.element.unblockUI();
                    form.$setPristine();
                    showDialogInfo(ev, data);
                });
            },
            function() {}
        );
        });
      }

       function loadData() {
          var response = endPoint.query({
               action:'getDetail', 
               subPeriod      : _data.subPeriod,
               period         : _data.period,
               sub_area_id    : _data.sub_area_id
          });
          response.$promise.then(fetchListData);
          response.$promise.catch(errorFetchListData);
      }

       function fetchListData(data) {
            vm.listData=data;
       }

       function errorFetchListData() {
            vm.listData=[];
       }

       function dialogClose() {
          $mdDialog.hide();
      }

      function showDialogInfo(ev, data) {
        var title = 'Success';
        if(data.status==0){
            var title = 'Failed';
        }
        var expmess = data.pesan.split("_");
        if(expmess.length>1){
            var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(data.pesan);
        }
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(title)
              .textContent(message)
              .ariaLabel(title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            if ('moreInfo' in data && data.moreInfo.length>0) {
                $mdDialog.show({
                    controller         : 'logFailGwController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose:true,
                    fullscreen: true,
                    onRemoving:function(element, removePromise)
                    {
                        // loadData(1);
                    },
                    locals:{
                        data:data.moreInfo
                    }
                });
            }else{
                dialogClose();
            }
          });
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.umut-process')
        .controller('UmutProcessDetailDateController', UmutProcessDetailDateController);

    UmutProcessDetailDateController.$inject = [
        '$mdDialog',
        'AppAPI',
        '_data'
    ];
    /** @ngInject */
    function UmutProcessDetailDateController(
        $mdDialog,
        AppAPI,
        _data
    ) {
        var vm = this;
        var endPoint=AppAPI.UmutProcess();
        vm.loadData = loadData;
        vm.dialogClose = dialogClose;
        vm.nik = _data.nik
        vm.name = _data.name

       loadData();

       function loadData() {
          var response = endPoint.query({
               action:'getDetailDate', 
               id           : _data.id,
               period       : _data.period,
               subPeriod    : _data.subPeriod
          });
          response.$promise.then(fetchListData);
          response.$promise.catch(errorFetchListData);
      }

       function fetchListData(data) {
            vm.listData=data;
       }

       function errorFetchListData() {
            vm.listData=[];
       }

       function dialogClose() {
          $mdDialog.hide();
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.umut-process')
        .controller('newUmutProcessController', newUmutProcessController);

    newUmutProcessController.$inject = [
        '$localStorage',
        '$mdDialog',
        '$log',
        '$window',
        '$location',
        'Form',
        'AppAPI',
        '$element',
        '$filter',
        'Auth'
    ];
    /* @ngInject */
    function newUmutProcessController(
        $localStorage,
        $mdDialog,
        $log,
        $window,
        $location,
        Form,
        AppAPI,
        $element,
        $filter,
        Auth
    ) {
        var vm = this;
        var translate = $filter('translate');
        var umutReport=AppAPI.Umutreport();
        var endPoint=AppAPI.UmutProcess();

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        
        vm.company       = $localStorage.empsite;
        vm.loadDivision  = loadDivision;
        vm.LoadRegional  = loadRegional;
        vm.LoadCabang    = loadCabang;
        vm.LoadWilayah   = loadWilayah;
        vm.dialogClose   = dialogClose;
        vm.saveData      = saveData;

        vm.reqWil    = false;
        vm.reqArea   = true;

        function dialogClose() {
            $mdDialog.hide();
        }

       LoadPeriod();
       LoadSubPeriod();
       LoadCompany()
       loadWilayah();
       LoadAreaDefault(vm.company);

       function LoadAreaDefault(company) 
        {
            var response=umutReport.query({action:'getArea', companyid:company});
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

       function fetchAreaDefault(data) {
            vm.listarea=data;
       }

       function errorFetchAreaDefault() {
            vm.listarea=[];
       }

      function LoadPeriod() 
      {
          var response=umutReport.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            var tempPeriod = [];
            tempPeriod.push(data[data.length-2])
            tempPeriod.push(data[data.length-1])
            vm.listperiod=tempPeriod;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 
      
       function LoadSubPeriod() 
      {
          var response=umutReport.query({action:'getSubPeriod'});
          response.$promise.then(fetchSubPeriod);
          response.$promise.catch(errorFetchSubPeriod);
       }

       function fetchSubPeriod(data) {
            delete data[0];
            vm.listsubperiod=reindex_array_keys(data);
            vm.listsubperiod.length=2;
       }

       function errorFetchSubPeriod() {
            vm.listsubperiod=[];
       } 

       function LoadCompany() {
          var response=umutReport.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

        function LoadArea(company,cabangid) 
        {
            loadDivision(company);
            loadWilayah();
            var response=umutReport.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadDivision(company) {
          var response=umutReport.query({action:'getDivision', companyid:company});
          response.$promise.then(fetchDivision);
          response.$promise.catch(errorFetchDivision);
       }

       function fetchDivision(data) {
            vm.listDivision=data;
       }

       function errorFetchDivision() {
            vm.listDivision=[];
       }  
       
       function loadWilayah() {
          var response=umutReport.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=umutReport.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=umutReport.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function reindex_array_keys(array, start){
            var temp = [];
            start = typeof start == 'undefined' ? 0 : start;
            start = typeof start != 'number' ? 0 : start;
            for(var i in array){
                temp[start++] = array[i];
            }
            return temp;
        }

        function saveData(ev,form) 
        {
            angular.element.blockUI();

            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                .confirm()
                .title('Are you sure want to process ?')
                .textContent('All data will be processed and can not recovered.')
                .ariaLabel('process dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

                $mdDialog.show(confirm).then(
                function() {
                    angular.element.blockUI();
                    vm.Form.objForm.subPeriod = vm.subperiod,
                    vm.Form.objForm.period = vm.period,
                    vm.Form.objForm.company = vm.company,
                    vm.Form.objForm.area = vm.area,
                    vm.Form.objForm.division = vm.division,
                    vm.Form.objForm.wilayah = vm.wilayah,
                    vm.Form.objForm.regional = vm.regional,
                    vm.Form.objForm.cabang = vm.cabang

                    var response = Form.saveData('processumut', form, endPoint);
                    response.then(function(data) {
                        angular.element.unblockUI();
                        form.$setPristine(); 
                        showDialogInfo(ev, data);
                    });

                    response.catch(function(data) {
                        angular.element.unblockUI();
                        form.$setPristine();
                        showDialogInfo(ev, data);
                    });
                },
                function() {}
            );
            });
        }

        function showDialogInfo(ev, data) {
            var title = 'Success';
            if(data.status==0){
                var title = 'Failed';
            }
            var expmess = data.pesan.split("_");
            if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
            }else{
                var message = translate(data.pesan);
            }
            $mdDialog
              .show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('#contentDialog')))
                  .clickOutsideToClose(true)
                  .title(title)
                  .textContent(message)
                  .ariaLabel(title)
                  .ok('OK')
                  .targetEvent(ev)
              )
              .then(function() {
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    dialogClose();
                }
              });
          }

        function reindex_array_keys(array, start){
            var temp = [];
            start = typeof start == 'undefined' ? 0 : start;
            start = typeof start != 'number' ? 0 : start;
            for(var i in array){
                temp[start++] = array[i];
            }
            return temp;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.umut-history', [])
        .config(config);

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.payroll_new_umut_history', {
                url: '/umut-history',
                views: {
                    'content@app': {
                        templateUrl:
                            'app/main/umut-history/umut-history.html',
                        controller: 'UmutHistoryController as vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.umut-history')
        .controller('UmutHistoryController', UmutHistoryController);

    UmutHistoryController.$inject = [
        '$mdDialog',
        'DataService',
        'AppAPI',
        '$document'
    ];
    /** @ngInject */
    function UmutHistoryController(
        $mdDialog,
        DataService,
        AppAPI,
        $document
    ) {
        var vm = this;

        var endPoint=AppAPI.UmutHistory();
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.detail = detail;
        vm.items = [];

       LoadPeriod();
       LoadSubPeriod();
       loadData(1);
              
      function detail(ev,data) {
        $mdDialog.show({
            controller: 'UmutHistoryDetailController',
            controllerAs: 'vm',
            templateUrl: 'app/main/umut-history/umut-history-detail-date.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            onRemoving: function(element, removePromise) {
              loadData(1);
            },
            clickOutsideToClose: true,
            fullscreen: true,
            locals : { 
                _data : data
            }
          });
      }

       function loadData(pageno) {
        var resp = vm.DataTables.loadData(endPoint, pageno, {
          action: 'viewData',
          subPeriod   : vm.subperiod,
          period      : vm.period,
        });
  
        resp.then(function(data) {
          angular.element.unblockUI();
          vm.selected = [];
          vm.items = data.list;
        });
      }

      function toggle(item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        } else {
          list.push(item);
        }
      }
  
      function exists(item, list) {
        return list.indexOf(item) > -1;
      }
  
      function isIndeterminate() {
        return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
      }
  
      function isChecked() {
        return vm.selected.length === vm.items.length;
      }
  
      function toggleAll() {
        if (vm.selected.length === vm.items.length) {
          vm.selected = [];
        } else if (vm.selected.length === 0 || vm.selected.length > 0) {
          vm.selected = vm.items.slice(0);
        }
      }

      function LoadPeriod() 
      {
          var response=endPoint.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

        function fetchPeriod(data) {
            vm.listperiod=data;
        }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 
      
       function LoadSubPeriod() 
      {
          var response=endPoint.query({action:'getSubPeriod'});
          response.$promise.then(fetchSubPeriod);
          response.$promise.catch(errorFetchSubPeriod);
       }

       function fetchSubPeriod(data) {
            delete data[0];
            vm.listsubperiod=reindex_array_keys(data);
            vm.listsubperiod.length=2;
       }

       function errorFetchSubPeriod() {
            vm.listsubperiod=[];
       } 

        function reindex_array_keys(array, start){
            var temp = [];
            start = typeof start == 'undefined' ? 0 : start;
            start = typeof start != 'number' ? 0 : start;
            for(var i in array){
                temp[start++] = array[i];
            }
            return temp;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.umut-process')
        .controller('UmutHistoryDetailController', UmutHistoryDetailController);

    UmutHistoryDetailController.$inject = [
        '$mdDialog',
        'AppAPI',
        '_data'
    ];
    /** @ngInject */
    function UmutHistoryDetailController(
        $mdDialog,
        AppAPI,
        _data
    ) {
        var vm = this;
        var endPoint=AppAPI.UmutHistory();
        vm.loadData = loadData;
        vm.dialogClose = dialogClose;
        vm.items = [];
        
        loadData();

        function loadData() {
          var response = endPoint.query({
               action:'viewDetail', 
               subPeriod    : _data.sub_period=='P1' ? '1' : '2',
               period       : _data.period,
               id           : _data.id
          });
          response.$promise.then(fetchListData);
          response.$promise.catch(errorFetchListData);
        }

        function fetchListData(data) {
            vm.listData=data;
        }

        function errorFetchListData() {
            vm.listData=[];
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();

(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.umut-log', []).config(config);

   config.$inject=['$stateProvider'];

   function config($stateProvider) 
   {
   	    $stateProvider
            .state('app.umut_log', {
                url    : '/log-um-ut',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/umut-log/umutlog.html',
                    controller : 'UmutlogController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.umut-log')
        .controller('UmutlogController', UmutlogController);

    UmutlogController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window', '$element','$http'];

    /* @ngInject */
    function UmutlogController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window, $element, $http) {
       
       var vm = this;
       var endPoint=AppAPI.Umutreport();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExporttoExcel = ExporttoExcel;

       vm.company               = $localStorage.empsite;
       vm.loadDivision          = loadDivision;
       vm.LoadRegional          = loadRegional;
       vm.LoadCabang            = loadCabang;
       vm.LoadWilayah           = loadWilayah;
       vm.getEmployee           = getEmployee;
       vm.selectedItemChanged   = selectedItemChanged;

       vm.reqWil    = false;
       vm.reqArea   = true;

       LoadPeriod();
       LoadSubPeriod();
       LoadCompany()
       loadWilayah();
       LoadAreaDefault(vm.company);

       function selectedItemChanged(employee)
        {        
            vm.Form.objForm.empno='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.empno=employee.empno;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;
            }
        }

       function LoadAreaDefault(company) 
        {
            var response=endPoint.query({action:'getArea', companyid:company});
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

       function fetchAreaDefault(data) {
            vm.listarea=data;
       }

       function errorFetchAreaDefault() {
            vm.listarea=[];
       }

      function LoadPeriod() 
      {
          var response=endPoint.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 
      
       function LoadSubPeriod() 
      {
          var response=endPoint.query({action:'getSubPeriod'});
          response.$promise.then(fetchSubPeriod);
          response.$promise.catch(errorFetchSubPeriod);
       }

       function fetchSubPeriod(data) {
            vm.listsubperiod=data;
       }

       function errorFetchSubPeriod() {
            vm.listsubperiod=[];
       } 

       function LoadCompany() {
          var response=endPoint.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

        function LoadArea(company,cabangid) 
        {
            loadDivision(company);
            loadWilayah();
            var response=endPoint.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadDivision(company) {
          var response=endPoint.query({action:'getDivision', companyid:company});
          response.$promise.then(fetchDivision);
          response.$promise.catch(errorFetchDivision);
       }

       function fetchDivision(data) {
            vm.listDivision=data;
       }

       function errorFetchDivision() {
            vm.listDivision=[];
       }  
       
       function loadWilayah() {
          var response=endPoint.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=endPoint.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=endPoint.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  
       
       function ExporttoExcel(form) 
       {    
            var subPeriod   = encodeURIComponent(window.btoa(vm.subperiod));
            var token       = Auth.setTokenPromise();
            var period      = encodeURIComponent(window.btoa(vm.period));
            var company     = encodeURIComponent(window.btoa(vm.company));
            var area        = encodeURIComponent(window.btoa(vm.area));
            var division    = encodeURIComponent(window.btoa(vm.division));
            var wilayah     = encodeURIComponent(window.btoa(vm.wilayah));
            var regional    = encodeURIComponent(window.btoa(vm.regional));
            var cabang      = encodeURIComponent(window.btoa(vm.cabang));
            var nik         = encodeURIComponent(window.btoa(vm.Form.objForm.empno));
            var action      = encodeURIComponent(window.btoa('downloadReport'));
            
            token.then(function(data) 
            {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/umutlog/lgexportexcel/' + period + '/' + company  + '/' + area + '/' + division + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + subPeriod + '/' + nik + '/' +  data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function getEmployee(searchText)
        {
            return $http
                .get(config.api + 'api/umutlog?action=searchEmployee&id=' + searchText)
                .then(function(item) {
                    // Map the response object to the data object.
                    if(item.data.length===''){
                        vm.Form.objForm.empno='';
                    }   
                    return item.data;
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.training-gw', [])
        .config(config);

    config.$inject = ['$stateProvider'];

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider
            .state('app.training_gw_list', {
                url: '/traning-gw/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/training-gw/traininggwlist.html',
                        controller: 'TraininggwlistController as vm'
                    }
                }
            });

    }
}());

(function () {
    'use strict';

    angular
        .module('app.training-gw')
        .controller('TraininggwlistController', TraininggwlistController);

    TraininggwlistController.$inject = [
        "$scope",
        "$localStorage",
        "$http",
        "$location",
        "$window",
        "AppAPI",
        "Auth",
        "config",
        "DataService",
        "FileUploader"
    ];

    function TraininggwlistController(
        $scope,
        $localStorage,
        $http,
        $location,
        $window,
        AppAPI,
        Auth,
        config,
        DataService,
        FileUploader
    ) {
        var vm = this;
        var endpoint = new AppAPI.TrainingGw();
        vm.listDepartment = [];
        vm.listDivision = [];
        vm.listBt = [];
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.company = $localStorage.empsite;
        vm.divisi = 0;
        vm.department = 0;
        vm.btcode = 0;
        vm.status = 0;
        vm.listStatus = [{
            id: 0,
            description: "Semua"
        }, {
            id: 1,
            description: "Hadir"
        }, {
            id: 2,
            description: "Tidak Hadir"
        }];
        vm.loadBt = loadBt;
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.loadDataDepartment = loadDataDepartment;
        vm.exportToExcel = exportToExcel;
        vm.uploadFile = uploadFile;
        vm.UploadPhotoStateSucces = false;
        vm.UploadPhotoStateError = false;

        loadDataDivision();
        loadData();

        function loadData(pageno) {
            angular.element.blockUI();
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'viewData',
                company: vm.company,
                divisi: vm.divisi,
                btcode: vm.btcode,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                status: vm.status,
            });
        }

        function loadDataDivision() {
            vm.listDivision = [];
            var response = endpoint.query({
                action: "getDivision",
                bu: vm.company
            });
            response.$promise.then(function (data) {
                vm.listDivision = data;
            });
            response.$promise.catch(function (data) {
                vm.listDivision = [];
            });
        }

        function loadDataDepartment(iddivisi) {
            vm.listDepartment = [];
            var response = endpoint.query({
                action: "getDepartment",
                idDivisi: vm.company + iddivisi
            });
            response.$promise.then(function (data) {
                vm.listDepartment = data;
            });
            response.$promise.catch(function (data) {
                vm.listDepartment = [];
            });
        }

        function loadBt(department) {
            vm.listBt = [];
            var promise = endpoint.get({
                action: "getBusinessTitle",
                company: vm.company,
                divisi: vm.division,
                department: department,
                bu_only: true
            });

            promise.$promise.then(function (data) {
                vm.listBt = [];
                vm.listBt = data.business_title;
            });

            promise.$promise.catch(function (err) {
                vm.listBt = [];
            });
        }

        function exportToExcel() {
            var protocol = $location.protocol();
            var host = $location.host();
            var data = JSON.stringify({
                company: vm.company,
                divisi: vm.divisi,
                btcode: vm.btcode,
                department: vm.department,
                startDate: vm.tglmulai,
                endDate: vm.tglakhir,
                status: vm.status,
            });
            $window.open(protocol +':'+'//'+host+config.port+ config.api + 'api/traininggw/exportExcel/' + data, '_blank');
        }

        function uploadFile() {
            return false;
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/traininggw/uploadScore',
            removeAfterUpload: true,
            alias: 'fileupload',
            formData: [{
                action: 'uploadScore'
            }],
            onAfterAddingAll: function () {
                vm.UploadPhotoStateSucces = false;
                vm.UploadPhotoStateError = false;
            },
            headers: {
                tokenAuth: $localStorage.tokenAuth
            }
        });

        uploaderPhoto.onSuccessItem = function () {
            vm.UploadPhotoStateSucces = true;
            vm.UploadPhotoStateError = false;
            loadData();
        };

        uploaderPhoto.onErrorItem = function () {
            vm.UploadPhotoStateSucces = false;
            vm.UploadPhotoStateError = true;
            loadData();
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('ReportController', ReportController);

    ReportController.$inject = ['$rootScope'];

    /** @ngInject */
    function ReportController($rootScope) {
        var vm = this;
        $rootScope.showSplash = false;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.ref-subdis', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.ref-subdis', {
                url: '/ref-subdis',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ref-subdis/ref-subdis.html',
                        controller: 'RefSubdisController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-subdis')
    .controller('UploadRefSubdisController', UploadRefSubdisController);

  UploadRefSubdisController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadRefSubdisController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.upload = upload;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    function upload() {
      angular.element.blockUI();

      vm.FileUpload.uploadAll();
    }

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/refsubdis/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/refsubdis/downloadTemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';
  angular
    .module('app.ref-subdis')
    .controller('RefSubdisController', RefSubdisController);

  RefSubdisController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    'AppAPI',
    'Auth',
    '$localStorage',
    '$filter',
    '$http',
    'config',
    '$element',
    'Form'
  ];
  /** @ngInject */
  function RefSubdisController(
    $document,
    DataService,
    $mdDialog,
    AppAPI,
    Auth,
    $localStorage,
    $filter,
    $http,
    config,
    $element,
    Form
  ) {
    var vm = this;
    var endPoint = AppAPI.RefSubdis();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getDataCode = getDataCode;
    vm.openUpload = openUpload;
    vm.company = $localStorage.empsite;

    activate();

    function openUpload(ev) {
      $mdDialog.show({
        controller: 'UploadRefSubdisController as vm',
        templateUrl: 'app/main/ref-subdis/upload-file.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        }
      });
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.sales_code = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined') {
        vm.Form.objForm.sales_code = item.id;
        vm.Form.objForm.name = item.name
        vm.isDisabled = true;

      }
    }

    function getDataCode(searchText) {
      return $http
        .get(config.api + 'api/refsubdis?action=searchSalesCode&id=' + searchText)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        company_name: vm.Form.objForm.company_name,
        address: vm.address,
        contact: vm.contact
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'RefSubdisInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ref-subdis/ref-subdis-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'RefSubdisEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ref-subdis/ref-subdis-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-subdis')
    .controller('RefSubdisInputController', RefSubdisInputController);

  RefSubdisInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function RefSubdisInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.RefSubdis();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-subdis')
    .controller('RefSubdisEditController', RefSubdisEditController);

  RefSubdisEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function RefSubdisEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.RefSubdis();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);
      console.log(data)
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.company_name = data.company_name;
      vm.Form.objForm.address = data.address;
      vm.Form.objForm.contact = data.contact;
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();
(function () {
    'use strict';

    angular
        .module('app.ref-sales-type', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.ref-sales-type', {
                url: '/ref-sales-type',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ref-sales-type/ref-sales-type.html',
                        controller: 'RefSalesTypeController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-sales-type')
    .controller('RefSalesTypeController', RefSalesTypeController);

  RefSalesTypeController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    'AppAPI',
    'Auth',
    '$filter',
    '$localStorage',
    '$http',
    'config',
    'Form'
  ];
  /** @ngInject */
  function RefSalesTypeController(
    $document,
    DataService,
    $mdDialog,
    AppAPI,
    Auth,
    $filter,
    $localStorage,
    $http,
    config,
    Form
  ) {
    var vm = this;
    var endPoint = AppAPI.RefSalesType();
    var schmeme = AppAPI.InsentifSkema();

    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getDataCode = getDataCode;
    vm.company = $localStorage.empsite;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    vm.listSchemeType = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];
    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];
    getSchemeObject();
    function getSchemeObject() {
      var response = schmeme.query({ action: 'getSchemeObject' });
      response.$promise.then(fetchSchemeObject);
      response.$promise.catch(errorFetchSchemeObject);
    }

    function fetchSchemeObject(data) {
      vm.listSchemeObject = data;
    }

    function errorFetchSchemeObject() {
      vm.listSchemeObject = [];
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.type_code = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined') {
        vm.Form.objForm.type_code = item.id;
        vm.Form.objForm.name = item.name
        vm.isDisabled = true;

      }
    }

    function getDataCode(searchText) {
      return $http
        .get(config.api + 'api/refsalestype?action=searchSalesType&id=' + searchText)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        channel: vm.channel,
        schema_object: vm.ref_schema_object_id,
        schema_type: vm.scheme_type,
        type_code: vm.Form.objForm.type_code,
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'RefSalesTypeInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ref-sales-type/ref-sales-type-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'RefSalesTypeEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ref-sales-type/ref-sales-type-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-sales-type')
    .controller('RefSalesTypeInputController', RefSalesTypeInputController);

  RefSalesTypeInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$filter'
  ];
  /** @ngInject */
  function RefSalesTypeInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.RefSalesType();
    var schmeme = AppAPI.InsentifSkema();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;

    vm.listSchemeType = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];
    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];
    getSchemeObject();
    function getSchemeObject() {
      var response = schmeme.query({ action: 'getSchemeObject' });
      response.$promise.then(fetchSchemeObject);
      response.$promise.catch(errorFetchSchemeObject);
    }

    function fetchSchemeObject(data) {
      vm.listSchemeObject = data;
    }

    function errorFetchSchemeObject() {
      vm.listSchemeObject = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-sales-type')
    .controller('RefSalesTypeEditController', RefSalesTypeEditController);

  RefSalesTypeEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$filter'
  ];
  /** @ngInject */
  function RefSalesTypeEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.RefSalesType();
    var scheme = AppAPI.InsentifSkema();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;

    vm.listSchemeType = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];
    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];

    getSchemeObject();
    function getSchemeObject() {
      var response = scheme.query({ action: 'getSchemeObject' });
      response.$promise.then(fetchSchemeObject);
      response.$promise.catch(errorFetchSchemeObject);
    }

    function fetchSchemeObject(data) {
      vm.listSchemeObject = data;
    }

    function errorFetchSchemeObject() {
      vm.listSchemeObject = [];
    }

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.id = data.id;
      vm.Form.objForm.channel = data.channel;
      vm.Form.objForm.scheme_type = data.schema_type;
      vm.Form.objForm.ref_schema_object_id = data.ref_schema_object_id;
      vm.Form.objForm.channel = data.channel;
      vm.Form.objForm.type_code_edit = data.type_code;
      vm.Form.objForm.type_name = data.type_name;
      vm.Form.objForm.description = data.description;
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.type_code = vm.Form.objForm.type_code_edit
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app.ref-sales-code', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.ref-sales-code', {
                url: '/ref-sales-code',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ref-sales-code/ref-sales-code.html',
                        controller: 'RefSalesCodeController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-sales-code')
    .controller('UploadRefSalesCodeController', UploadRefSalesCodeController);

  UploadRefSalesCodeController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadRefSalesCodeController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.upload = upload;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    function upload() {
      angular.element.blockUI();

      vm.FileUpload.uploadAll();
    }

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/refsalescode/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/refsalescode/downloadTemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';
  angular
    .module('app.ref-sales-code')
    .controller('RefSalesCodeController', RefSalesCodeController);

  RefSalesCodeController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    'AppAPI',
    'Auth',
    '$localStorage',
    '$filter',
    '$http',
    'config',
    '$element',
    'Form'
  ];
  /** @ngInject */
  function RefSalesCodeController(
    $document,
    DataService,
    $mdDialog,
    AppAPI,
    Auth,
    $localStorage,
    $filter,
    $http,
    config,
    $element,
    Form
  ) {
    var vm = this;
    var endPoint = AppAPI.RefSalesCode();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getDataCode = getDataCode;
    vm.openUpload = openUpload;
    vm.company = $localStorage.empsite;

    activate();

    function openUpload(ev) {
      $mdDialog.show({
        controller: 'UploadRefSalesCodeController as vm',
        templateUrl: 'app/main/ref-sales-code/upload-file.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        }
      });
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.sales_code = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined') {
        vm.Form.objForm.sales_code = item.id;
        vm.Form.objForm.name = item.name
        vm.isDisabled = true;

      }
    }

    function getDataCode(searchText) {
      return $http
        .get(config.api + 'api/refsalescode?action=searchSalesCode&id=' + searchText)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function getSalesType() {
      var response = endPoint.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function getAreaSales() {
      var response = endPoint.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function activate() {
      vm.selected = [];
      loadData(1);
      getSalesType()
      getAreaSales()
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        sales_code: vm.Form.objForm.sales_code,
        sales_type: vm.Form.objForm.ref_sales_type_id,
        area_sales: vm.Form.objForm.area_sales_id
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'RefSalesCodeInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ref-sales-code/ref-sales-code-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'RefSalesCodeEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ref-sales-code/ref-sales-code-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-sales-code')
    .controller('RefSalesCodeInputController', RefSalesCodeInputController);

  RefSalesCodeInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function RefSalesCodeInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.RefSalesCode();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;

    getAreaSales();
    getDivision();
    getSalesType();
    getSalesBehaviour();

    function saveData(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.sales_code = vm.Form.objForm.salescode;
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function getSalesType() {
      var response = endPoint.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function getSalesBehaviour() {
      var response = endPoint.query({ action: 'getSalesBehaviour' });
      response.$promise.then(fetchSalesBehaviour);
      response.$promise.catch(errorFetchSalesBehaviour);
    }

    function fetchSalesBehaviour(data) {
      vm.listSalesBehaviour = data;
    }

    function errorFetchSalesBehaviour() {
      vm.listSalesBehaviour = [];
    }

    function getAreaSales() {
      var response = endPoint.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function getDivision() {
      var response = endPoint.query({ action: 'getDivision' });
      response.$promise.then(fetchDivision);
      response.$promise.catch(errorFetchDivision);
    }

    function fetchDivision(data) {
      vm.listDivision = data;
    }

    function errorFetchDivision() {
      vm.listDivision = [];
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-sales-code')
    .controller('RefSalesCodeEditController', RefSalesCodeEditController);

  RefSalesCodeEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function RefSalesCodeEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.RefSalesCode();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;

    activate();

    function activate() {
      getAreaSales();
      getSalesType();
      getDivision();
      getSalesBehaviour();

      Form.initialForm();
      Form.setObject(endPoint);
      console.log(data)
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.salescode = data.sales_code;
      vm.Form.objForm.sales_behaviour = data.sales_behaviour;
      vm.Form.objForm.description = data.description;
      vm.Form.objForm.area_sales_id = data.area_sales_id;
      vm.Form.objForm.ref_master_divisi_id = data.ref_master_divisi_id;
      vm.Form.objForm.ref_sales_type_id = data.ref_sales_type_id;
    }

    function getSalesBehaviour() {
      var response = endPoint.query({ action: 'getSalesBehaviour' });
      response.$promise.then(fetchSalesBehaviour);
      response.$promise.catch(errorFetchSalesBehaviour);
    }

    function fetchSalesBehaviour(data) {
      vm.listSalesBehaviour = data;
    }

    function errorFetchSalesBehaviour() {
      vm.listSalesBehaviour = [];
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.sales_code = vm.Form.objForm.salescode;
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getDivision() {
      var response = endPoint.query({ action: 'getDivision' });
      response.$promise.then(fetchDivision);
      response.$promise.catch(errorFetchDivision);
    }

    function fetchDivision(data) {
      vm.listDivision = data;
    }

    function errorFetchDivision() {
      vm.listDivision = [];
    }

    function getSalesType() {
      var response = endPoint.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function getAreaSales() {
      var response = endPoint.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();
(function () {
    'use strict';

    angular
        .module('app.ref-master-sku', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.ref-master-sku', {
                url: '/ref-master-sku',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ref-master-sku/ref-master-sku.html',
                        controller: 'RefMasterSkuController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-master-sku')
    .controller('UploadRefMasterSkuController', UploadRefMasterSkuController);

  UploadRefMasterSkuController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadRefMasterSkuController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.upload = upload
    vm.detailInfo = []

    function upload(form) {
      angular.element.blockUI();
      var resp = vm.FileUpload.uploadAll();
    }

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/refmastersku/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/refmastersku/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';
  angular
    .module('app.ref-master-sku')
    .controller('RefMasterSkuController', RefMasterSkuController);

  RefMasterSkuController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function RefMasterSkuController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.RefMasterSku();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getSKU = getSKU;
    vm.stateEdit = false;
    vm.openUpload = openUpload;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.selected = [];

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.selected = angular.copy(vm.DataTables.list);
    }

    function unCheckAll() {
      vm.selected = [];
    }

    function deleteData(ev) {
      console.log(vm.selected)
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      vm.selected = [];
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        sku: vm.Form.objForm.sku
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getSKU(searchText) {
      return $http
        .get(config.api + 'api/refmastersku?action=searchSku&id=' + searchText)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function openUpload(ev) {
      $mdDialog.show({
        controller: 'UploadRefMasterSkuController as vm',
        templateUrl: 'app/main/ref-master-sku/upload-file.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        }
      });
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.sku = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof item !== 'undefined' && item) {
        vm.Form.objForm.sku = item.id;
        vm.Form.objForm.fullname = item.fullname
        vm.isDisabled = true;

      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.ref-bank', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.ref-bank', {
                url: '/ref-bank',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ref-bank/ref-bank.html',
                        controller: 'RefBankController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-bank')
    .controller('RefBankController', RefBankController);

  RefBankController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function RefBankController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.RefBank();
    var PayrollProcess = AppAPI.NewPayrollProcess();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.country = $localStorage.country;
    vm.stateEdit = false;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      LoadCountry();
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        bank_code: vm.bank_code,
        bank_name: vm.bank_name,
        country: vm.country
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'RefBankInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ref-bank/ref-bank-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'RefBankEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/ref-bank/ref-bank-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function LoadCountry() {
      var response = PayrollProcess.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-bank')
    .controller('RefBankInputController', RefBankInputController);

  RefBankInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$filter',
    '$http',
    'config'
  ];
  /** @ngInject */
  function RefBankInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $filter,
    $http,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.RefBank();
    var PayrollProcess = AppAPI.NewPayrollProcess();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;
    vm.Form.objForm.country = $localStorage.country;

    activate();

    function activate() {
      vm.selected = [];
      LoadCountry();
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function LoadCountry() {
      var response = PayrollProcess.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.ref-bank')
    .controller('RefBankEditController', RefBankEditController);

  RefBankEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$filter'
  ];
  /** @ngInject */
  function RefBankEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.RefBank();
    var PayrollProcess = AppAPI.NewPayrollProcess();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.id = data.id;
      vm.Form.objForm.bank_code = data.bank_code;
      vm.Form.objForm.bank_name = data.bank_name;
      vm.Form.objForm.country = data.country;
      LoadCountry();
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function LoadCountry() {
      var response = PayrollProcess.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }
  }
})();
(function() {
    'use strict';

    angular
        .module('app.ta.handover')
        .controller('TrainingGwRescheduleController', Controller);

    Controller.$inject = ['$state', '$mdDialog', 'AppAPI', 'reffData', 'Form'];
    /** @ngInject */
    function Controller($state, $mdDialog, AppAPI, reffData, Form) {
        var vm = this;
        var endpoint = AppAPI.HandoverGw();
        vm.hide = hide;
        vm.submit = submit;

        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(endpoint);

        // set form to controller
        vm.Form = Form;

        vm.tempDate = reffData.reschedule
            ? new Date(reffData.reschedule)
            : new Date();

        function submit(form) {
            var dt = angular.copy(vm.tempDate);
            vm.Form.objForm.taCompletionId = reffData.id;
            vm.Form.objForm.rescheduleDate = moment(dt).format('YYYY-MM-DD');
            var request = Form.saveData('rescheduleTraining', form, endpoint);
            request.then(function(response) {
                console.log(response);
            });
            request.catch(function(error) {
                console.log(error);
            });
        }

        function hide() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.production.handover-gw', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.production_handover_gw', {
            url: '/production-handover-gw',
            views: {
                'content@app': {
                    templateUrl: 'app/main/production-handover-gw/handover-gw.html',
                    controller: 'ProductionHandoverGwController as vm'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.production.handover-gw')
        .controller('ProductionHandoverGwProcessController', ProductionHandoverGwProcessController);

    ProductionHandoverGwProcessController.$inject = [
        '$state',
        '$mdDialog',
        'AppAPI',
        'reffData',
        'trainingDate',
        'isNumber',
        '$http',
        'config',
        'Form'
    ];
    /** @ngInject */
    function ProductionHandoverGwProcessController($state, $mdDialog, AppAPI, reffData, trainingDate, isNumber, $http, config, Form) {
        var vm = this;
        var endpoint = AppAPI.ProductionHandoverGw();
        vm.hide = hide;
        vm.submit = submit;
        vm.tempDate = new Date();
        vm.employee = '';
        vm.isNumber = isNumber;
        vm.loadAtasan = loadAtasan;
        vm.setLine = getLine;
        vm.selectedItemChanged = selectedItemChanged;
        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(endpoint);

        // set form to controller
        vm.Form = Form;

        getSector();
        getShiftGroup();

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;
            }
        }

        function submit(form, isNUmber) {
            if (isNUmber) {
                vm.Form.objForm.employee = [];
            } else {
                vm.Form.objForm.employee = reffData;
            }
            vm.Form.objForm.training_date = trainingDate;
            vm.Form.objForm.atasan = vm.atasan;

            var request = Form.saveData('setEmpSector', form, endpoint);
            request.then(function (response) {
                console.log(response);
            });
            request.catch(function (error) {
                console.log(error);
            });
        }

        function hide() {
            $mdDialog.hide();
        }

        function getSector() {
            var response = endpoint.query({
                action: "getSector"
            });
            response.$promise.then(fetchSector);
            response.$promise.catch(errorFetchSector);
        }

        function fetchSector(data) {
            vm.listSector = data;
        }

        function errorFetchSector() {
            vm.listSector = [];
        }

        function getLine(id) {
            var response = endpoint.query({
                action: "getLine",
                sectorId: id
            });
            response.$promise.then(fetchLine);
            response.$promise.catch(errorFetchLine);
        }

        function fetchLine(data) {
            vm.listLine = data;
        }

        function errorFetchLine() {
            vm.listLine = [];
        }

        function getShiftGroup() {
            var response = endpoint.query({
                action: "getShiftGroup"
            });
            response.$promise.then(fetchShiftGroup);
            response.$promise.catch(errorFetchShiftGroup);
        }

        function fetchShiftGroup(data) {
            vm.listShiftGroup = data;
        }

        function errorFetchShiftGroup() {
            vm.listShiftGroup = [];
        }

        function getDataByAmount() {
            var response = endpoint.query({
                action: "getDataByAmount",
                training_date: moment(trainingDate).format('YYYY-MM-DD'),
                limit: vm.Form.objForm.limit
            });
            response.$promise.then(getDataByAmount);
            response.$promise.catch(errorGetDataByAmount);
        }

        function getDataByAmount(data) {
            vm.listDataByAmount = data;
        }

        function errorGetDataByAmount() {
            vm.listDataByAmount = [];
        }

        function uniqBy(a, key) {
            var seen = {};
            return a.filter(function (item) {
                var k = key(item);
                return seen.hasOwnProperty(k) ? false : (seen[k] = true);
            })
        }

        function loadAtasan(search) {
            return $http
                .get(config.api + 'api/productionhandovergw?action=getAtasan&search=' + search)
                .then(function (res) {
                    return res.data;
                }).catch(function (err) {
                    console.log('err', err);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.production.handover-gw')
        .controller('ProductionHandoverGwController', ProductionHandoverGwController);

    ProductionHandoverGwController.$inject = [
        '$state',
        '$mdDialog',
        'AppAPI',
        'DataService',
        'Auth'
    ];
    /** @ngInject */
    function ProductionHandoverGwController($state, $mdDialog, AppAPI, DataService, Auth) {
        var vm = this;
        var endpoint = AppAPI.ProductionHandoverGw();
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.trainingDate = '';
        vm.hasSetSector = '0';
        vm.loadData = loadData;

        vm.hasSetSectorList = [
            { id: '0', description: 'Belum di Set' },
            { id: '1', description: 'Sudah di Set' }
        ];

        vm.showForm = showForm;
        vm.handover = handover;
        vm.removeHandover = removeHandover;
        vm.selected = [];
        vm.toggle = toggle;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.exists = exists;
        vm.DataTables.list = [];

        activate();

        function activate() {
            loadData(1);
        }

        function loadData(pageNo) {
            vm.selected = [];
            if (vm.trainingDate != '') {
                var trainingDt = moment(vm.trainingDate).format('YYYY-MM-DD');
            } else {
                var trainingDt = vm.trainingDate;
            }
            var resp = vm.DataTables.loadData(endpoint, pageNo, {
                action: 'viewData',
                training_date: trainingDt,
                has_set_sector: vm.hasSetSector
            });
            resp.catch(function (err) {
                console.log(err);
            });
        }

        function showForm(ev, item) {
            $mdDialog
                .show({
                    controller: 'TrainingGwRescheduleController as vm',
                    templateUrl: 'app/main/ta/handover-gw/reschedule.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item
                    }
                })
                .then(function () {
                    loadData(1);
                });
        }

        function handover(ev, item, isNumber, isSingle) {
            if (isSingle) {
                var listItem = [item];
            } else {
                var listItem = item;
            }
            $mdDialog
                .show({
                    controller: 'ProductionHandoverGwProcessController as vm',
                    templateUrl: 'app/main/production-handover-gw/handover.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: listItem,
                        trainingDate: vm.trainingDate,
                        isNumber: isNumber
                    }
                })
                .then(function () {
                    loadData(1);
                });
        }

        function removeHandover(ev, item) {
            var response = Auth.setToken();
            response.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Remove Handover')
                    .textContent(
                        'Are you sure want to remove ' +
                        item.nik +
                        ' - ' +
                        item.name +
                        ' from this handover ?'
                    )
                    .ariaLabel('handover')
                    .targetEvent(ev)
                    .ok('Yes')
                    .cancel('No');

                $mdDialog.show(confirm).then(function () {
                    var request = endpoint.save({
                        action: 'removeHandover',
                        new_emp_handover_id: item.new_emp_handover_id,
                        ta_completion_id: item.id
                    });

                    request.$promise.then(function (res) {
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Success')
                                .textContent(res.pesan)
                                .ariaLabel('Alert Dialog Demo')
                                .ok('OK')
                                .targetEvent(ev)
                        );
                        loadData(1);
                    });
                    request.$promise.catch(function (err) {
                        console.log(err);
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Failed')
                                .textContent(err.pesan)
                                .ariaLabel('Alert Dialog Demo')
                                .ok('OK')
                                .targetEvent(ev)
                        );
                        loadData(1);
                    });
                });
            });
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return (
                vm.selected.length !== 0 &&
                vm.selected.length !== vm.DataTables.list.length
            );
        }

        function isChecked() {
            return vm.selected.length === vm.DataTables.list.length && vm.DataTables.list.length > 0;
        }

        function toggleAll() {
            if (vm.selected.length > 0) {
                vm.selected = [];
            } else if (vm.selected.length === 0) {
                vm.DataTables.list.forEach(function (item) {
                    if (item.hr_completion == 0) {
                        vm.selected.push(item)
                    }
                });
            }
            vm.selected = uniqBy(vm.selected, JSON.stringify);
        }

        function uniqBy(a, key) {
            var seen = {};
            return a.filter(function (item) {
                var k = key(item);
                return seen.hasOwnProperty(k) ? false : (seen[k] = true);
            })
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.payslip', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.payslip', {
                url: '/payslip',
                views: {
                    'content@app': {
                        templateUrl:
                            'app/main/payslip/payslip.html',
                        controller: 'PayslipController as vm'
                    }
                }
            })
            .state('app.paysliprki', {
                url: '/payslip-rki',
                views: {
                    'content@app': {
                        templateUrl:
                            'app/main/payslip/paysliprki.html',
                        controller: 'PayslipRkiController as vm',
                        css: ['app/main/payslip/paysliprki.scss']
                    }
                }
            })
            .state('app.payslipmys', {
                url: '/payslip-mys',
                views: {
                    'content@app': {
                        templateUrl:
                            'app/main/payslip/payslipmys.html',
                        controller: 'PayslipMysController as vm',
                        css: ['app/main/payslip/payslipmys.scss']
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.payslip')
        .controller('PayslipRkiController', Controller);

    Controller.$inject = [
        'AppAPI',
        '$state',
        '$localStorage',
        '$scope',
        '$mdToast',
        'Auth',
        '$mdDialog',
        '$location',
        '$window',
        'config',
        'DataService'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $state,
        $localStorage,
        $scope,
        $mdToast,
        Auth,
        $mdDialog,
        $location,
        $window,
        config,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.Payslip();
        vm.loadData = loadData;
        vm.print = print;
        vm.period = null;
        vm.downloadPayslip = downloadPayslip;

        function downloadPayslip() {
            var token = Auth.setTokenPromise();
            var period = vm.period;
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewPayslip/exportpdf/' + period + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }
        
        activate();
        
        angular.element(document.querySelector(".md-whiteframe-4dp")).removeClass("box-shadow");

        function activate() {
            getPeriod();
            loadData();
        }

        function loadData() {
            angular.element.blockUI();
            var slip = new endpoint()
            var response=slip.$get({action:'getPayslip',period:vm.period});
            
            response.then(SetData);
            response.catch(setErrorLoad);
        }

        function SetData(data)
        {
            angular.element.unblockUI();
            vm.dataList = {};
            if(0 in data.dataList){
                vm.dataList = data.dataList[0];
            }
        }
        
        function setErrorLoad(data)
        {
            angular.element.unblockUI();
            vm.dataList = {};
        }

        function getPeriod() {
            var response=endpoint.query({action:'getPeriod'});
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }
        
        function fetchPeriod(data) {
            vm.listPeriod=data;
            vm.period = vm.listPeriod[0].id;
        }
    
        function errorFetchPeriod() {
            vm.listPeriod=[];
        }
    }

    function print (div) 
    {
        var elem = document.querySelector('#filter-data');

        elem.style.display = 'none';
        window.print();
        elem.style.display = 'block';
    }
})();

(function () {
    'use strict';

    angular
        .module('app.payslip')
        .controller('PayslipMysController', Controller);

    Controller.$inject = [
        'AppAPI',
        '$localStorage',
        'Auth',
        '$location',
        '$window',
        'config'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $localStorage,
        Auth,
        $location,
        $window,
        config
    ) {
        var vm = this;
        var endpoint = AppAPI.Payslip();
        vm.loadData = loadData;
        vm.print = print;
        vm.period = null;
        vm.downloadPayslip = downloadPayslip;

        function downloadPayslip() {
            var token = Auth.setTokenPromise();
            var period = vm.period;

            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/payrollnew/report/NewPayslip/exportpdf/' + period + '/' + $localStorage.lang + '/' + data.token, '_blank');
            }, function () {
                $window.alert('gagal load token')
            });
        }

        var dt = new Date();
        var dtM = (dt.getMonth());
        if (dtM < 10) {
            dtM = '0' + dtM
        }

        vm.period = dt.getFullYear() + '' + dtM;

        activate();

        angular.element(document.querySelector(".md-whiteframe-4dp")).removeClass("box-shadow");

        function activate() {
            getPeriod();
            loadData();
        }

        function loadData() {
            angular.element.blockUI();
            var slip = new endpoint()
            var response = slip.$get({ action: 'getPayslip', period: vm.period });

            response.then(SetData);
            response.catch(setErrorLoad);
        }

        function SetData(data) {
            angular.element.unblockUI();
            vm.dataList = {};
            if (0 in data.dataList) {
                vm.dataList = data.dataList[0];
            }
        }

        function setErrorLoad(data) {
            angular.element.unblockUI();
            vm.dataList = {};
        }

        function getPeriod() {
            var response = endpoint.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listPeriod = data;
            vm.period = vm.listPeriod[0].id;
        }

        function errorFetchPeriod() {
            vm.listPeriod = [];
        }
    }

    function print(div) {
        var elem = document.querySelector('#filter-data');

        elem.style.display = 'none';
        window.print();
        elem.style.display = 'block';
    }
})();

(function () {
    'use strict';

    angular
        .module('app.payslip')
        .controller('PayslipController', Controller);

    Controller.$inject = [
        'AppAPI',
        '$state',
        '$localStorage',
        '$scope',
        '$mdToast',
        'Auth',
        '$mdDialog',
        'DataService'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $state,
        $localStorage,
        $scope,
        $mdToast,
        Auth,
        $mdDialog,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.Payslip();
        vm.loadData = loadData;
        vm.print = print;

        if ($localStorage.empsite == "RK") {
            $state.go('app.paysliprki');
        }
        if ($localStorage.empsite == "EN") {
            $state.go('app.payslipmys');
        }

        var dt = new Date();
        var dtM = (dt.getMonth());
        if (dtM < 10) {
            dtM = '0' + dtM
        }

        vm.period = dt.getFullYear() + '' + dtM;

        activate();

        function activate() {
            getPeriod();
            loadData();
        }

        function loadData() {
            angular.element.blockUI();
            var slip = new endpoint()
            var response = slip.$get({ action: 'getPayslip', period: vm.period });

            response.then(SetData);
            response.catch(setErrorLoad);
        }

        function SetData(data) {
            angular.element.unblockUI();
            vm.dataList = {};
            if (0 in data.dataList) {
                vm.dataList = data.dataList[0];
            }
        }

        function setErrorLoad(data) {
            angular.element.unblockUI();
            vm.dataList = {};
        }

        function getPeriod() {
            var response = endpoint.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listPeriod = data;
        }

        function errorFetchPeriod() {
            vm.listPeriod = [];
        }
    }

    function print(div) {
        var elem = document.querySelector('#filter-data');

        elem.style.display = 'none';
        window.print();
        elem.style.display = 'block';
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpp.orgchart")
        .controller("ViewMppOverlapController", Controller);

    Controller.$inject = [
        "$mdDialog",
        "$q",
        "$element",
        "$http",
        "$timeout",
        "refData",
        "$scope",
        "$mdToast",
    ];

    /* @ngInject */
    function Controller(
        $mdDialog,
        $q,
        $element,
        $http,
        $timeout,
        refData,
        $scope,
        $mdToast
    ) {
       var vm = this;

       vm.data=refData;

        vm.hide=hide;
         function hide() {
      $mdDialog.hide();
    }

      }
})();

(function () {
    'use strict';

    angular
        .module('app.orgchart', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.orgchart', {
                url: '/orgchart',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/orgchart/orgchart.html',
                        controller: 'OrgchartmainController as vm'
                    }
                }
            })

            // .state('app.orgchart', {
            //     url: '/orgchart',
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/main/orgchart/orgcharttes.html',
            //             controller: 'OrgcharttestController as vm'
            //         }
            //     }
            // })
            .state('app.orgchartemp', {
                url: '/orgchartemp',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/orgchart/orgchartemp.html',
                        controller: 'OrgchartmainempController as vm'
                    }
                }
            });



    }

    /** @ngInject */
    /** @ngInject */

})();

(function () {
    'use strict';

    angular
        .module('app.orgchart')
        .controller('OrgcharttestController', Controller);

    Controller.$inject = ['$mdDialog', 'AppAPI', 'Auth'];

    /* @ngInject */
    function Controller($mdDialog, AppAPI, Auth) {
        var vm = this;
        vm.index = 10;
        vm.Message = "";
        var Orgchart = new AppAPI.Orgchart();
        vm.options = {};

        // var items = [
        //     new primitives.orgdiagram.ItemConfig({
        //         id: 0,
        //         parent: null,
        //         title: "Scott Aasrud",
        //         description: "Root",
        //         phone: "1 (416) 001-4567",
        //         email: "scott.aasrud@mail.com",
        //         image: "../images/photos/a.png",
        //         itemTitleColor: primitives.common.Colors.RoyalBlue
        //     }),
        //     new primitives.orgdiagram.ItemConfig({
        //         id: 1,
        //         parent: 0,
        //         title: "Ted Lucas",
        //         description: "Left",
        //         phone: "1 (416) 002-4567",
        //         email: "ted.lucas@mail.com",
        //         image: "../images/photos/b.png",
        //         itemTitleColor: primitives.common.Colors.RoyalBlue
        //     }),
        //     new primitives.orgdiagram.ItemConfig({
        //         id: 2,
        //         parent: 0,
        //         title: "Fritz Stuger",
        //         description: "Right",
        //         phone: "1 (416) 003-4567",
        //         email: "joao.stuger@mail.com",
        //         image: "../images/photos/c.png",
        //         itemTitleColor: primitives.common.Colors.RoyalBlue
        //     }),
        //     new primitives.orgdiagram.ItemConfig({
        //         id: 3,
        //         parent: 2,
        //         title: "Hidden Node",
        //         phone: "1 (416) 004-4567",
        //         email: "hidden.node@mail.com",
        //         description: "Dotted Node",
        //         image: "../images/photos/e.png",
        //         itemTitleColor: primitives.common.Colors.PaleVioletRed
        //     }),
        //     new primitives.orgdiagram.ItemConfig({
        //         id: 4,
        //         parent: 2,
        //         title: "Hidden Node",
        //         phone: "1 (416) 004-4567",
        //         email: "hidden.node@mail.com",
        //         description: "Dotted Node",
        //         image: "../images/photos/e.png",
        //         itemTitleColor: primitives.common.Colors.PaleVioletRed
        //     }),
        //     new primitives.orgdiagram.ItemConfig({
        //         id: 5,
        //         parent: 2,
        //         title: "Hidden Node",
        //         phone: "1 (416) 004-4567",
        //         email: "hidden.node@mail.com",
        //         description: "Dotted Node",
        //         image: "../images/photos/e.png",
        //         itemTitleColor: primitives.common.Colors.PaleVioletRed
        //     })
        // ];
        loadStructure();
        function loadStructure() {
            angular.element('#centerpanel').block();
            var response = Orgchart.query({
                action: 'viewdata',
                layer: 2,
                layerId: 258
            });
            response.$promise.then(loadOrgchart);
            response.$promise.catch(failedLoadChart);
        }
        var i = 0,
            jum = 0,
            items = [],
            objItem;

        function loadOrgchart(data) {
            jum = 0;
            jum = data.length;
            items = [];
            for (i = 0; i < jum; i++) {
                objItem = new primitives.orgdiagram.ItemConfig(data[i]);
                items.push(objItem);
            };
            angular.element('#centerpanel').unblock();

            vm.options.items = items;
        }



        function failedLoadChart() {
            angular.element('#centerpanel').unblock();
        }

        //vm.options.items = items;
        vm.options.cursorItem = 0;
        //vm.options.buttons = buttons;
        vm.options.highlightItem = 1;
        vm.options.hasSelectorCheckbox = primitives.common.Enabled.False;
        vm.options.pageFitMode = 1;
        vm.options.templates = [getContactTemplate()];
        vm.options.defaultTemplateName = "contactTemplate";
        vm.options.connectors = "step";
        vm.options.linesColor = primitives.common.Colors.Teal;

        vm.myOptions = vm.options;

        vm.setCursorItem = function (item) {
            vm.myOptions.cursorItem = item;
        };

        vm.setHighlightItem = function (item) {
            vm.myOptions.highlightItem = item;
        };

        vm.deleteItem = function (index) {
            vm.myOptions.items.splice(index, 1);
        }

        vm.addItem = function (index, parent) {
            var id = vm.index++;
            vm.myOptions.items.splice(index, 0, new primitives.orgdiagram.ItemConfig({
                id: id,
                parent: parent,
                title: "New title " + id,
                description: "New description " + id,
                image: "../images/photos/b.png"
            }));
        }

        vm.onMyCursorChanged = function () {
            vm.Message = "onMyCursorChanged";
        }

        vm.onMyHighlightChanged = function () {
            vm.Message = "onMyHighlightChanged";
        }

        function getContactTemplate() {
            var result = new primitives.orgdiagram.TemplateConfig();
            result.name = "contactTemplate";

            result.itemSize = new primitives.common.Size(220, 120);
            result.minimizedItemSize = new primitives.common.Size(5, 5);
            result.minimizedItemCornerRadius = 5;

            /* the following example demonstrates JSONML template see http://http://www.jsonml.org/ for details: */
            result.itemTemplate = ["div",
                {
                    style: {
                        width: result.itemSize.width + "px",
                        height: result.itemSize.height + "px",
                    },
                    "class": ["bp-item", "bp-corner-all", "bt-item-frame"]
                },
                ["div",
                    {
                        "name": "titleBackground",
                        "class": ["bp-item", "bp-corner-all", "bp-title-frame"],
                        "style": {
                            backgroundColor: "{{itemTitleColor}}",
                            top: "2px",
                            left: "2px",
                            width: "216px",
                            height: "20px"
                        }
                    },
                    ["div",
                        {
                            "name": "title",
                            style: {
                                top: "3px",
                                left: "6px",
                                width: "208px",
                                height: "18px"
                            },
                            "class": ["bp-item", "bp-title"]
                        },
                        "{{itemConfig.title}}"
                    ]
                ],
                ["div",
                    {
                        "style": {
                            top: "26px",
                            left: "2px",
                            width: "50px",
                            height: "60px"
                        },
                        "class": ["bp-item", "bp-photo-frame"]
                    },
                    ["img",
                        {
                            "name": "photo",
                            "src": "{{itemConfig.image}}",
                            "style": {
                                height: "60px",
                                width: "50px"
                            }
                        }
                    ]
                ],
                ["div",
                    {
                        "name": "phone",
                        "style": {
                            top: "26px",
                            left: "56px",
                            width: "162px",
                            height: "18px",
                            fontSize: "12px"
                        },
                        "class": "bp-item"
                    },
                    "{{itemConfig.phone}}"
                ],
                ["div",
                    {
                        "style": {
                            top: "44px",
                            left: "56px",
                            width: "162px",
                            height: "18px",
                            fontSize: "12px"
                        },
                        "class": "bp-item"
                    },
                    ["a",
                        {
                            "name": "email",
                            href: "mailto::{{itemConfig.email}}",
                            target: "_top"
                        },
                        "{{itemConfig.email}}"
                    ]
                ],
                ["div",
                    {
                        "name": "description",
                        "style": {
                            top: "62px",
                            left: "56px",
                            width: "162px",
                            height: "36px",
                            fontSize: "10px"
                        },
                        "class": "bp-item"
                    },
                    "{{itemConfig.description}}"
                ]
            ];

            return result;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.orgchart")
        .controller("OrgchartmainempController", Controller);

    Controller.$inject = ["$mdDialog", "AppAPI", "Auth", "$q"];

    /* @ngInject */
    function Controller($mdDialog, AppAPI, Auth, $q) {
        var vm = this;
        var d = new Date();
        var Orgchart = new AppAPI.Orgchartemp();

        vm.options = {};
        vm.listBT = [];
        vm.listTeamLayer = [];
        vm.searchTerm = "";
        vm.teamLayer;
        vm.layer = 1;
        vm.listLayer = [0, 1, 2, 3, 4, 5];
        vm.listYear = [2018, 2019, 2020, 2021];
        vm.year = d.getFullYear();
        vm.querySearchLayer = querySearchLayer;
        vm.selectedItemChange = selectedItemChange;

        var i = 0,
            jum = 0,
            items = [],
            objItem;

        vm.loadStructure = loadStructure;

        function selectedItemChange(item) {
            vm.teamLayer = item;
        }

        function querySearchLayer(query) {
            var defer = $q.defer();
            var search = angular.lowercase(query);
            var request = Orgchart.query({
                action: "viewdataorgchart",
                search: search,
            });
            request.$promise.then(function (res) {
                defer.resolve(res);
            });
            request.$promise.catch(function (err) {
                defer.reject([]);
            });
            return defer.promise;
        }

        function loadStructure() {
            if (!vm.teamLayer) {
                alert("Layer cannot be empty");
                return;
            }
            angular.element("#orgchart-area").block();
            var response = Orgchart.query({
                action: "viewdata",
                layer: vm.layer,
                layerId: vm.teamLayer.id,
            });
            response.$promise.then(loadOrgchart);
            response.$promise.catch(failedLoadChart);
        }

        function loadOrgchart(data) {
            jum = data.length;
            items = [];
            for (i = 0; i < jum; i++) {
                objItem = new primitives.orgdiagram.ItemConfig(data[i]);
                items.push(objItem);
            }
            angular.element("#orgchart-area").unblock();
            vm.options.items = items;
        }

        function failedLoadChart() {
            angular.element("#orgchart-area").unblock();
        }
        
        var buttons=[];
        buttons.push(
            new primitives.orgdiagram.ButtonConfig(
                "viewdetail",
                "ui-icon-person",
                "Add"
            )
        );

        vm.options.cursorItem = 0;
        vm.options.highlightItem = 1;
        vm.options.buttons = buttons;
        vm.options.hasSelectorCheckbox = primitives.common.Enabled.False;
        vm.options.pageFitMode = 1;
        vm.options.templates = [getContactTemplate()];
        vm.options.defaultTemplateName = "contactTemplate";
        vm.options.connectors = "step";
        vm.options.linesColor = primitives.common.Colors.Teal;
        vm.options.arrowsDirection = 2;
        vm.options.connectorType = 2;
        vm.options.onButtonClick = actionOrgChart;

        function actionOrgChart(e, data) {
            switch (data.name) {
                case "viewdetail":
                    $mdDialog
                        .show({
                            controller: "ViewMppOverlapController as vm",
                            templateUrl: "app/main/orgchart/view-mpp-overlap.html",
                            parent: angular.element(document.body),
                            targetEvent: e,
                            clickOutsideToClose: false,
                            fullscreen: true,
                            locals: {
                                refData: data
                            },
                        })
                        .then(function () {
                            //loadStructure();
                            // viewListLayer();
                        });
                    break;
                default:
                    break;
            }
        }

        function getContactTemplate() {
            var result = new primitives.orgdiagram.TemplateConfig();
            result.name = "contactTemplate";

            result.itemSize = new primitives.common.Size(225, 65);
            result.minimizedItemSize = new primitives.common.Size(10, 10);
            result.minimizedItemCornerRadius = 5;
            result.highlightPadding = new primitives.common.Thickness(
                2,
                2,
                2,
                2
            );

            result.itemTemplate = [
                "div",
                {
                    style: {
                        width: result.itemSize.width + "px",
                        height: result.itemSize.height + "px",
                    },
                    layout: "row",
                    class: [
                        "bp-item",
                        "bp-corner-all",
                        "emp-card-org",
                        "{{ itemConfig.HTMLclass }}",
                    ],
                },
                [
                    "div",
                    {
                        // "flex": "30"
                        style: {
                            width: "55px",
                        },
                    },
                    [
                        "img",
                        {
                            name: "photo",
                            src: "{{itemConfig.image}}",
                            onerror:
                                "this.src='assets/images/avatars/profile.jpg';",
                            style: {
                                width: "55px",
                                height: result.itemSize.height + "px",
                            },
                        },
                    ],
                ],
                [
                    "div",
                    {
                        flex: "",
                        layout: "column",
                        "layout-align": "center stretch",
                        class: ["emp-card-orgchart-wrapper"],
                    },
                    [
                        "div",
                        {
                            class: ["emp-card-orgchart-fullname"],
                        },
                        "{{itemConfig.fullName}}",
                    ],
                    [
                        "div",
                        {
                            class: ["emp-card-orgchart-desc"],
                        },
                        "{{itemConfig.description}}",
                    ],
                ],
            ];
            return result;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.orgchart')
    .service('orgService', orgService);

  function orgService(AppAPI, $q, filterFilter) {

    var Orgchart       = new AppAPI.Orgchart();
    this.getEmployee   = getEmployee;
    this.getSubArea    = getSubArea;
    this.getCbu        = getCbu;
    this.getSubDomain  = getSubDomain;
    this.getOrgLayer   = getOrgLayer;
    this.getListDetail = getListDetail;

    function getEmployee(abbr) {
      var response = Orgchart.query({
        action : 'getListEmployee',
        search : abbr
      });
      return response;
    }

    function getCbu() {
      var response = Orgchart.query({
        action : 'getListCbu'
      });
      return response;
    }

    function getSubDomain() {
      var response = Orgchart.query({
        action : 'getListSubDomain'
      });
      return response;
    }

    function getOrgLayer(abbr) {
      var response = Orgchart.query({
        action : 'getListOrgLayer',
        search : abbr
      });
      return response;
    }

    function getSubArea() {
      var response = Orgchart.query({
        action : 'getListSubArea'
      });
      return response;
    }

    function getListDetail(id) {
      var response = Orgchart.get({
        action : 'getListDetail',
        id : id
      });
      return response;
    }

  }

})();

(function () {
    "use strict";

    angular
        .module("app.orgchart")
        .controller("OrgchartmainController", Controller);

    Controller.$inject = ["$mdDialog", "AppAPI", "Auth"];

    /* @ngInject */
    function Controller($mdDialog, AppAPI, Auth) {
        var vm = this;
        vm.options = {};
        vm.listBT = [];
        var Orgchart = new AppAPI.Orgchart();
        vm.loadStructure = loadStructure;
        vm.listTeamLayer = [];
        vm.searchTerm;
        // vm.teamLayer = {
        //     'id': 0,
        //     'description': 'ALL'
        // };
        vm.clearSearchTerm = clearSearchTerm;

        vm.listLayer = [0, 1, 2, 3, 4, 5, 6];

        vm.listYear = [2018, 2019, 2020, 2021];

        vm.viewListLayer = viewListLayer;

        var d = new Date();
        vm.year = d.getFullYear();

        var i = 0,
            jum = 0,
            items = [],
            objItem;

        vm.layer = 1;

        var x, y, top, left, down;

        $("#chartContent").mousedown(function (e) {
            e.preventDefault();
            down = true;
            x = e.pageX;
            y = e.pageY;
            top = $(this).scrollTop();
            left = $(this).scrollLeft();
        });

        $("body").mousemove(function (e) {
            if (down) {
                var newX = e.pageX;
                var newY = e.pageY;
                $("#chartContent").scrollTop(top - newY + y);
                $("#chartContent").scrollLeft(left - newX + x);
            }
        });

        $("body").mouseup(function (e) {
            down = false;
        });

        function clearSearchTerm() {
            vm.searchTerm = "";
        }

        function viewListLayer(param) {
            var response = Orgchart.query({
                action: "viewdataorgchart",
                param: param,
            });

            return response;
        }

        function loadStructure() {
            angular.element("#orgchart-area").block();
            var response = Orgchart.query({
                action: "viewdata",
                layer: vm.layer,
                layerId: vm.teamLayer.id,
            });
            response.$promise.then(loadOrgchart);
            response.$promise.catch(failedLoadChart);
        }

        function loadOrgchart(data) {
            jum = data.length;
            items = [];
            for (i = 0; i < jum; i++) {
                objItem = new primitives.orgdiagram.ItemConfig(data[i]);
                items.push(objItem);
            }
            angular.element("#orgchart-area").unblock();
            vm.listTeamLayer = data;
            vm.options.items = items;
        }

        function failedLoadChart() {
            angular.element("#orgchart-area").unblock();
        }

        //        None: 0,
        // PageWidth: 1,
        // PageHeight: 2,
        // FitToPage: 3,
        // PrintPreview: 4,
        // AutoSize: 5,
        // SelectionOnly: 6

        var buttons = [];
        buttons.push(
            new primitives.orgdiagram.ButtonConfig(
                "edit",
                "ui-icon-gear",
                "Edit"
            )
        );
        buttons.push(
            new primitives.orgdiagram.ButtonConfig(
                "delete",
                "ui-icon-close",
                "Delete"
            )
        );
        buttons.push(
            new primitives.orgdiagram.ButtonConfig(
                "add",
                "ui-icon-person",
                "Add"
            )
        );
        buttons.push(
            new primitives.orgdiagram.ButtonConfig(
                "add_mpp",
                "ui-icon-wrench",
                "Add Mpp"
            )
        );

        vm.options.cursorItem = 0;
        vm.options.buttons = buttons;
        vm.options.highlightItem = 1;
        vm.options.hasSelectorCheckbox = primitives.common.Enabled.False;
        vm.options.pageFitMode = 3;
        vm.options.templates = [getContactTemplate()];
        vm.options.defaultTemplateName = "contactTemplate";
        vm.options.connectors = "step";
        vm.options.linesColor = primitives.common.Colors.Teal;
        vm.options.arrowsDirection = 2;
        vm.options.connectorType = 2;

        vm.options.onButtonClick = actionOrgChart;

        function actionOrgChart(e, data) {
            switch (data.name) {
                case "add":
                    $mdDialog
                        .show({
                            controller: "EditOrgChartController as vm",
                            templateUrl: "app/main/orgchart/edit-mpp.html",
                            parent: angular.element(document.body),
                            targetEvent: e,
                            clickOutsideToClose: false,
                            fullscreen: true,
                            locals: {
                                refData: data,
                                year: vm.year,
                                layerID: vm.teamLayer.id,
                                listTeamLayer: vm.listTeamLayer,
                            },
                        })
                        .then(function () {
                            loadStructure();
                            // viewListLayer();
                        });
                    break;
                case "edit":
                    $mdDialog
                        .show({
                            controller: "EditOrgChartController as vm",
                            templateUrl: "app/main/orgchart/edit-mpp.html",
                            parent: angular.element(document.body),
                            targetEvent: e,
                            clickOutsideToClose: false,
                            fullscreen: true,
                            locals: {
                                refData: data,
                                year: vm.year,
                                layerID: vm.teamLayer.id,
                                listTeamLayer: vm.listTeamLayer,
                            },
                        })
                        .then(function () {
                            loadStructure();
                            // viewListLayer();
                        });
                    break;
                case "delete":
                    var response = Auth.setToken();
                    response.then(function () {
                        var confirm = $mdDialog
                            .confirm()
                            .title("Delete Structure ?")
                            .textContent(
                                "Would you like to delete " +
                                data.context.description +
                                " layer from your structure ?"
                            )
                            .ariaLabel("delete structure")
                            .targetEvent(e)
                            .ok("Please do it!")
                            .cancel("No, Sorry");

                        $mdDialog.show(confirm).then(function () {
                            deleteChart(data.context.id);
                        });
                    });
                    break;
                case "add_mpp":
                    $mdDialog
                        .show({
                            controller: "FormAddMppController as vm",
                            templateUrl: "app/main/orgchart/add-mpp.html",
                            parent: angular.element(document.body),
                            targetEvent: e,
                            clickOutsideToClose: false,
                            fullscreen: true,
                            locals: {
                                refData: data,
                                year: vm.year,
                                layerID: vm.teamLayer.id,
                                listTeamLayer: vm.listTeamLayer,
                            },
                        })
                        .then(function () {
                            loadStructure();
                            // viewListLayer();
                        });
                    break;
                default:
                    break;
            }
        }

        function deleteChart(id) {
            angular.element("#orgchart-area").block();
            var response = Orgchart.delete({
                action: "deleteLayerWithEmp",
                layer_id: id,
            });
            response.$promise.then(successDelete);
            response.$promise.catch(failedDelete);
        }

        function cancelAction(id) {
            angular.element("#orgchart-area").block();
            var response = Mpp.delete({
                action: "cancelAction",
                id: id,
            });
            response.$promise.then(successCancel);
            response.$promise.catch(failedCancel);
        }

        function successDelete(e) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("MPP Alert Delete Data")
                        .textContent("Success Delete Data")
                        .ariaLabel("MPP alert")
                        .ok("Got it!")
                        .targetEvent(e)
                )
                .then(loadStructure);
        }

        function failedDelete(e) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("MPP Alert Delete data")
                        .textContent("Failed delete data")
                        .ariaLabel("MPP alert")
                        .ok("Got it!")
                        .targetEvent(e)
                )
                .then(function () {
                    angular.element("#orgchart-area").unblock();
                });
        }

        function failedCancel(e) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title("MPP Alert Cancel Action")
                        .textContent("Failed Cancel Action")
                        .ariaLabel("MPP alert")
                        .ok("Got it!")
                        .targetEvent(e)
                )
                .then(function () {
                    angular.element("#orgchart-area").unblock();
                });
        }

        function getContactTemplate() {
            var result = new primitives.orgdiagram.TemplateConfig();
            result.name = "contactTemplate";

            result.itemSize = new primitives.common.Size(150, 100);
            result.minimizedItemSize = new primitives.common.Size(10, 10);
            result.minimizedItemCornerRadius = 5;
            result.highlightPadding = new primitives.common.Thickness(
                2,
                2,
                2,
                2
            );

            // var itemTemplate = jQuery(
            //     '<div class="bp-item bp-corner-all bt-item-frame md-whiteframe-3dp" >' +
            //     '<div name="phone" class="bp-item" style="padding-left:0px;text-align:center;line-height: 110%;padding-top:10px;width:100%;">' +
            //     '<div style="padding-top:2px;font-style:italic;text-transform: capitalize;font-size:11px;text-align:center;"> {{itemConfig.description}}</div>' +
            //     '</div>' +
            //     '<div class="bp-item" style="top: 55px; left: 5px; width: 162px; height: 18px; font-size: 9px; font-style:italic;">HC :{{itemConfig.total_emp}}  Grade Level : {{itemConfig.job_level}}</div>'
            //     //+ '<div name="description" class="bp-item" style="top: 35px; left: 58px; width: 162px; height: 36px; font-size: 10px;">{{itemConfig.email}}</div>'
            //     +
            //     '</div>'
            // ).css({
            //     width: result.itemSize.width + "px",
            //     height: result.itemSize.height + "px"
            // });

            // result.itemTemplate = itemTemplate.wrap('<div>').parent().html();

            result.itemTemplate = [
                "div",
                {
                    style: {
                        width: result.itemSize.width + "px",
                        height: result.itemSize.height + "px",
                    },
                    layout: "column",
                    "layout-align": "center stretch",
                    class: [
                        "bp-item",
                        "bp-corner-all",
                        "md-whiteframe-3dp",
                        "{{itemConfig.HTMLclass}}",
                    ],
                },

                [
                    "div",
                    {
                        name: "phone",
                        class: "org-desc",
                        layout: "row",
                        "layout-align": "center center",
                        style: {
                            height: result.itemSize.height * 0.8 + "px",
                        },
                    },
                    ["div", {}, "{{itemConfig.description}}"],
                ],
                [
                    "div",
                    {
                        flex: "",
                        style: {
                            height: result.itemSize.height * 0.2 + "px",
                        },
                        class: "org-desc-footer",
                    },
                    "HC :{{itemConfig.total_emp}}  Grade Level : {{itemConfig.job_level}}",
                ],
            ];

            return result;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpp.orgchart")
        .controller("EditOrgChartController", Controller);

    Controller.$inject = [
        "$mdDialog",
        "$q",
        "$element",
        "$http",
        "$timeout",
        "refData",
        "config",
        "AppAPI",
        "Form",
        "Auth",
        "year",
        "orgService",
        "filterFilter",
        "layerID",
        "$scope",
        "listTeamLayer",
        "$mdToast",
    ];

    /* @ngInject */
    function Controller(
        $mdDialog,
        $q,
        $element,
        $http,
        $timeout,
        refData,
        config,
        AppAPI,
        Form,
        Auth,
        year,
        orgService,
        filterFilter,
        layerID,
        $scope,
        listTeamLayer,
        $mdToast
    ) {
        console.log(listTeamLayer);
        var vm = this;
        var Mpp = AppAPI.Mpp();
        var OrgChart = AppAPI.Orgchart();
        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(OrgChart);

        // set form to controller
        vm.Form = Form;

        vm.exists = exists;
        vm.listTeamLayer = listTeamLayer;
        vm.layerID = refData.context.id;
        vm.orgLevelID = refData.context.org_level_id;
        vm.classificationCode = [];
        vm.tbdQuantity = 1;
        vm.selectedItem = {
            employee: null,
            indirect: null,
            direct: null,
        };
        vm.searchText = {
            employee: null,
            indirect: null,
            direct: null,
        };
        vm.showErrorEmployee = false;
        vm.messagesErrorEmployee = "";
        vm.hide = hide;
        vm.cancel = cancel;
        vm.actionLists = [];
        vm.menuName = refData.name;
        vm.update = false;
        vm.create = false;
        vm.saveProcess = false;
        vm.updateProcess = false;
        vm.isTBD = false;
        vm.isTBDNull = false;
        vm.searchTermBT;
        vm.searchTermCBU;
        vm.searchTermSD;
        vm.searchTermSA;
        vm.loadingProgress = false;
        vm.listDataCountry = [];
        vm.superAkses = false;
        vm.Form.objForm.listEmp = [];
        vm.Form.objForm.is_parent = refData.context.is_parent;
        vm.Form.objForm.direct_report = refData.context.id;
        vm.Form.objForm.nodeType = refData.context.nodeType;
        vm.Form.objForm.indirect_report = {
            id: 0,
            description: "none",
        };

        vm.nodeType = [
            {
                id: 0,
                description: "Regular",
            },

            {
                id: 1,
                description: "Assistant",
            },
            {
                id: 2,
                description: "Advisor",
            },
        ];

        vm.Form.objForm.is_direct_change = false;
        vm.layerEffectiveDate = new Date();
        vm.Form.objForm.is_active = "1";
        vm.showEffectiveDate = false;
        vm.showIsActive = false;
        vm.listDirectReport = [];

        vm.transformChip = transformChip;
        vm.addTbdToChart = addTbdToChart;
        vm.saveData = saveData;
        vm.updateData = updateData;
        vm.getListDataDepartment = getListDataDepartment;
        vm.getCostCenter = getCostCenter;
        vm.getListDataGroupCluster = getListDataGroupCluster;
        vm.getBusinessTitle = getBusinessTitle;
        vm.getListDataJobTitle = getListDataJobTitle;
        vm.getCountry = getCountry;
        vm.getListDataDivisi = getListDataDivisi;
        vm.getSubArea = getSubArea;
        vm.changeDescriptionBT = changeDescriptionBT;
        vm.selectedItemChange = selectedItemChange;
        vm.querySearchIndirect = querySearchDefferedIndirect;
        vm.querySearchDirect = querySearchDefferedDirect;
        vm.querySearchEmployee = querySearchDeferredEmployee;
        vm.changeDescription = changeDescription;
        vm.loadDataParamCountry = loadDataParamCountry;
        vm.getListDataAffectedByBU = getListDataAffectedByBU;
        vm.clearSearchTerm = clearSearchTerm;
        vm.onLoadDirectReport = false;
        vm.onLoadTransactionType = false;
        vm.selectLoading = {
            businessTitle: false,
            jobTitle: false,
            costCenter: false,
        };
        vm.loadingMessage = "Please Wait";
        vm.listTransactionType = [];

        $element.find("input").on("keydown", function (ev) {
            ev.stopPropagation();
        });

        activate();

        getListTransaction();
        function activate() {
            console.log(refData);
            vm.loadingProgress = true;
            switchValue()
                .then(function () {
                    $timeout(function () {
                        vm.loadingProgress = false;
                    }, 1000);
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        function getLayerMember(layerID) {
            vm.onLoadDirectReport = true;
            var response = OrgChart.query({
                action: 'getLayerMember',
                layerID: layerID
            });
            response.$promise.then(fetchLayerMember);
            response.$promise.catch(errorFetchLayerMomber);
        }

        function getListTransaction() {
            vm.onLoadTransactionType = true;
            var response = OrgChart.query({
                action: 'getLayerTransaction',
                layerID: layerID
            });
            response.$promise.then(fetchTransaction)
            response.$promise.catch(errorFetchTransaction);
        }

        function fetchTransaction(data) {
            vm.listTransactionType = data;
            vm.onLoadTransactionType = false;
        }

        function errorFetchTransaction(data) {
            vm.listTransactionType = [];
            vm.onLoadTransactionType = false;
        }

        function fetchLayerMember(data) {
            vm.listDirectReport = data;
            vm.onLoadDirectReport = false;
        }

        function errorFetchLayerMomber(data) {
            vm.listDirectReport = [];
            vm.onLoadDirectReport = false;
        }

        // excute method affected by country id
        function loadDataParamCountry(country) { }

        // load data affected by BY
        function getListDataAffectedByBU(bu) {
            var defer = $q.defer();
            getCostCenter(bu)
                .then(getListDataDivisi.bind(this, bu))
                .then(getSubArea.bind(this, bu))
                .then(getEmpClassification.bind(this, bu))
                .then(function () {
                    defer.resolve();
                });
            return defer.promise;
        }

        function clearSearchTerm(f) {
            switch (f) {
                case 1:
                    vm.searchTermBT = "";
                    break;
                case 2:
                    vm.searchTermCBU = "";
                    break;
                case 3:
                    vm.searchTermSD = "";
                    break;
                case 4:
                    vm.searchTermSA = "";
                    break;
            }
        }

        function switchValue() {
            var defer = $q.defer();
            switch (refData.name) {
                case "edit":
                    vm.type = "UPDATE";
                    vm.update = true;
                    var collection = orgService.getListDetail(
                        refData.context.org_layer_transaction_id
                    );
                    collection.$promise.then(function (res) {
                        vm.update = true;
                        vm.Form.objForm.id = refData.context.id;
                        if (res.listEmp.length > 0) {
                            for (var i = 0; i < res.listEmp.length; i++) {
                                var temp = {
                                    nik: res.listEmp[i].nik,
                                    name: res.listEmp[i].name,
                                    date_fulfill: res.listEmp[i].date_fulfill,
                                    date_fulfill_formated: new Date(
                                        res.listEmp[i].date_fulfill
                                    ),
                                    effective_date: res.listEmp[i].effective_date,
                                    date_effective_formated: new Date(
                                        res.listEmp[i].effective_date
                                    ),
                                    position_name: res.listEmp[i].position_name,
                                    directReport: res.listEmp[i].directReport,
                                    is_planning: res.listEmp[i].is_planning,
                                    transactionType: res.listEmp[i].transactionType,
                                    id: res.listEmp[i].id
                                };
                                vm.Form.objForm.listEmp.push(temp);
                            }
                        }
                        vm.Form.objForm.country = res.country_id;
                        vm.Form.objForm.listArea = res.listArea;
                        vm.Form.objForm.clasification_code =
                            res.clasification_code;
                        vm.Form.objForm.description = res.description;
                        vm.Form.objForm.job_level = res.job_level;
                        vm.Form.objForm.cost_center_id = res.cost_center_id;
                        vm.Form.objForm.level = res.level;
                        vm.Form.objForm.org_level_id = res.org_level_id;
                        vm.Form.objForm.type = res.type;
                        vm.Form.objForm.is_parent = res.is_parent;
                        vm.Form.objForm.listSubDomain =
                            res.listSubDomain.length === 0
                                ? []
                                : res.listSubDomain;
                        vm.Form.objForm.direct_report = res.direct_report_obj;
                        vm.Form.objForm.indirect_report =
                            res.indirect_report_obj;
                        vm.Form.objForm.parent_id_old = res.parent_id_old;
                        vm.Form.objForm.division_id = res.division_id;
                        vm.Form.objForm.group_cluster = res.group_cluster;
                        vm.Form.objForm.department_id = res.department_id;
                        vm.Form.objForm.abreviation = res.abreviation;
                        vm.Form.objForm.entity_id = res.entity_id;
                        vm.Form.objForm.job_title_text = res.description;
                        vm.Form.objForm.bt_code =
                            res.listBtCode.length > 0 ? res.listBtCode[0] : {};
                        if (res.listBtCode.length > 0) {
                            vm.Form.objForm.job_function = vm.Form.objForm
                                .bt_code.code
                                ? vm.Form.objForm.bt_code.code.substring(0, 2)
                                : null;
                        }
                        vm.layerEffectiveDate = new Date(res.effective_date);
                        vm.Form.objForm.is_active = res.is_active;
                        getLayerMember(vm.Form.objForm.direct_report.id);

                        try {
                            getInfoUser()
                                .then(
                                    getCountry.bind(
                                        this,
                                        refData.context.countryName
                                    )
                                )
                                .then(getListDataCompany)
                                .then(
                                    getListDataDepartment.bind(
                                        this,
                                        res.division_id
                                    )
                                )
                                .then(getListDataJobTitle.bind(this, "all"))
                                .then(
                                    getListDataGroupCluster.bind(
                                        this,
                                        res.abreviation,
                                        "jt"
                                    )
                                )
                                .then(getBusinessTitle.bind(this, "all"))
                                .then(
                                    getListDataAffectedByBU.bind(
                                        this,
                                        res.entity_id
                                    )
                                )
                                .then(getListOrgLevel)
                                .then(function () {
                                    defer.resolve(true);
                                });
                        } catch (error) {
                            console.log(error);
                            defer.resolve(true);
                        }
                    });
                    break;

                case "add":
                    vm.type = "CREATE";
                    vm.create = true;
                    vm.listDataCountry = [];
                    getInfoUser()
                        .then(
                            getCountry.bind(this, refData.context.countryName)
                        )
                        .then(getListDataCompany)
                        .then(getListOrgLevel)
                        .then(
                            getEmpClassification.bind(
                                this,
                                refData.context.entity_id
                            )
                        )
                        .then(
                            getListDataDivisi.bind(
                                this,
                                refData.context.entity_id
                            )
                        )
                        .then(getSubArea.bind(this, refData.context.entity_id))
                        .then(function () {
                            defer.resolve(true);
                        }).
                        then(
                            getListDataGroupCluster.bind(
                                this,
                                refData.context.entity_id
                            )
                        );
                    break;
                default:
                    $timeout(function () {
                        defer.resolve([]);
                    }, 1000);
                    break;
            }
            return defer.promise;
        }

        function addTbdToChart(counter, d) {
            var tDate = new Date(d);
            for (var i = 0; i < counter; i++) {
                if (vm.isTBD) {
                    // var datum = {
                    //     nik: "TBD",
                    //     name: "TBD",
                    //     date_fulfill: moment(tDate).format("YYYY-MM-DD"),
                    //     date_fulfill_formated: tDate,
                    // };
                    var tmpData = {
                        date_fulfill: null,
                        directReport: null,
                        effective_date: null,
                        id: null,
                        is_budgeted: '1',
                        is_planning: '0',
                        name: 'TBD',
                        nik: 'TBD',
                        position_name: vm.Form.objForm.description,
                        transactionType: null
                    }
                } else if (vm.isTBDNull) {
                    // var datum = {
                    //     nik: "TBD-Null",
                    //     name: "TBD-Null",
                    //     date_fulfill: moment(tDate).format("YYYY-MM-DD"),
                    //     date_fulfill_formated: tDate,
                    // };
                    var tmpData = {
                        date_fulfill: null,
                        directReport: null,
                        effective_date: null,
                        id: null,
                        is_budgeted: '1',
                        is_planning: '1',
                        name: 'TBD',
                        nik: 'TBD',
                        position_name: vm.Form.objForm.description,
                        transactionType: null
                    }
                }
                vm.Form.objForm.listEmp.push(tmpData);
            }
            vm.isTBD = false;
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip;
            }
        }

        function querySearchDefferedIndirect(query) {
            var results = query
                ? vm.listTeamLayer.filter(createFilterFor(query))
                : vm.listTeamLayer;
            return results;
            // return $http
            //     .get(config.api + 'api/orglayer?action=getListOrgLayer&search=' + query)
            //     .then(function (item) {
            //         return item.data;
            //     });
        }

        function querySearchDefferedDirect(query) {
            // var results = query
            //     ? listTeamLayer.filter(createFilterFor(query))
            //     : listTeamLayer;
            // return results;
            return $http
                .get(config.api + 'api/orglayer?action=getListOrgLayerDirect&search=' + query + '&parent_id=' + layerID + '&flag=' + true)
                .then(function (item) {
                    return item.data;
                });
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(state) {
                return state.desc_search.indexOf(lowercaseQuery) > -1;
            };
        }

        function querySearchDeferredEmployee(query) {
            return $http
                .get(
                    config.api +
                    "api/orglayer?action=getListEmployee&search=" +
                    query
                )
                .then(function (item) {
                    if (item.data.length === 0) {
                        vm.searchText.employee = query;
                    }
                    return item.data;
                });
        }

        function exists(array, key, value) {
            if (angular.isArray(array)) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i][key] === value) {
                        return true;
                    }
                }
            }

            return false;
        }

        function selectedItemChange(item, type) {
            switch (type) {
                case "employee":
                    if (item) {
                        vm.showErrorEmployee = false;

                        if (!exists(vm.Form.objForm.listEmp, "nik", item.nik)) {
                            var validation = OrgChart.get({
                                action: "checkEmployeeExists",
                                nik: item.nik,
                            });

                            validation.$promise.then(function (response) {
                                if (response.status === 1) {
                                    // var dt = new Date("1970-01-01");
                                    // item.date_fulfill_formated = dt;
                                    // item.date_fulfill = moment(dt).format(
                                    //     "YYYY-MM-DD"
                                    // );
                                    var tmpData = {
                                        date_fulfill: null,
                                        directReport: null,
                                        effective_date: null,
                                        id: null,
                                        is_budgeted: '1',
                                        is_planning: null,
                                        name: item.name,
                                        nik: item.nik,
                                        position_name: vm.Form.objForm.description,
                                        transactionType: null
                                    }
                                    vm.Form.objForm.listEmp.push(tmpData);
                                    vm.searchText.employee = null;
                                    vm.selectedItem.employee = null;
                                } else {
                                    vm.showErrorEmployee = true;
                                    vm.messagesErrorEmployee =
                                        response.message +
                                        " on " +
                                        response.data.description +
                                        " | layer id " +
                                        response.data.layer_id;
                                }
                            });

                            validation.$promise.catch(function (error) {
                                // console.log(error);
                            });
                        }
                    }
                    break;
                case "direct":
                    if (item) {
                        vm.Form.objForm.direct_report = item;
                        if (item && vm.update) {
                            if (item.id != vm.Form.objForm.parent_id_old) {
                                vm.showEffectiveDate = true;
                            }
                        }
                    }
                    break;
                case "indirect":
                    if (item) {
                        vm.Form.objForm.indirect_report = item;
                    }
                    break;
            }
        }

        function saveData(ev, formController) {
            var tmpDate = angular.copy(vm.layerEffectiveDate);
            vm.saveProcess = true;
            vm.loadingProgress = true;
            vm.Form.objForm.effective_date = moment(tmpDate).format(
                "YYYY-MM-DD"
            );
            vm.Form.objForm.years = vm.year;
            // vm.Form.objForm.description = vm.Form.objForm.bt_code.description;
            if (vm.Form.objForm.listEmp.length > 0) {
                for (var i = 0; i < vm.Form.objForm.listEmp.length; i++) {
                    var date = moment(
                        vm.Form.objForm.listEmp[i].date_fulfill_formated
                    ).format("YYYY-MM-DD");
                    vm.Form.objForm.listEmp[i].date_fulfill = date;

                    date = moment(
                        vm.Form.objForm.listEmp[i].date_effective_formated
                    ).format("YYYY-MM-DD");
                    vm.Form.objForm.listEmp[i].effective_date = date;

                }
            }

            var promise = Form.saveData(
                "addLayerWithEmp",
                formController,
                OrgChart
            );
            promise.then(successSaveMpp);
            promise.catch(failedSaveMpp);
        }

        function updateData(ev, formController) {
            // console.log(formController);
            vm.updateProcess = true;
            vm.loadingProgress = true;
            var none = {
                id: "none",
                description: "none",
            };
            if (!vm.Form.objForm.direct_report) {
                vm.Form.objForm.direct_report = none;
            }
            if (!vm.Form.objForm.indirect_report) {
                vm.Form.objForm.indirect_report = none;
            }

            vm.Form.objForm.listArea = removeDuplicatesEmployess(
                vm.Form.objForm.listArea
            );

            // vm.Form.objForm.date_fulfill = moment(
            //     vm.Form.objForm.date_fulfill_formated
            // ).format("YYYY-MM-DD");

            var tmpDate = angular.copy(vm.layerEffectiveDate);
            vm.Form.objForm.effective_date = moment(tmpDate).format(
                "YYYY-MM-DD"
            );

            for (var i = 0; i < vm.Form.objForm.listEmp.length; i++) {
                var date = moment(
                    vm.Form.objForm.listEmp[i].date_fulfill_formated
                ).format("YYYY-MM-DD");
                vm.Form.objForm.listEmp[i].date_fulfill = date;

                date = moment(
                    vm.Form.objForm.listEmp[i].date_effective_formated
                ).format("YYYY-MM-DD");
                vm.Form.objForm.listEmp[i].effective_date = date;
            }

            // vm.Form.objForm.description = vm.Form.objForm.bt_code.description;

            var promise = Form.saveData(
                "editLayerWithEmp",
                formController,
                OrgChart
            );
            promise.then(successUpdate);
            promise.catch(failedUpdate);
        }

        function successSaveMpp() {
            vm.success = true;
            vm.saveProcess = false;
            vm.loadingProgress = false;
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent("Berhasil simpan data Layer")
                    .position("top right")
                    .hideDelay(3000)
                    .theme("success-toast")
            );
        }

        function failedSaveMpp() {
            vm.success = false;
            vm.saveProcess = false;
            vm.loadingProgress = false;
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent("Gagal simpan data Layer")
                    .position("top right")
                    .hideDelay(3000)
                    .theme("error-toast")
            );
        }

        function successUpdate() {
            hide();
            vm.success = true;
            vm.updateProcess = false;
            vm.loadingProgress = false;

            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent("Berhasil update data Layer")
                    .position("top right")
                    .hideDelay(3000)
                    .theme("success-toast")
            );
        }

        function failedUpdate() {
            vm.success = false;
            vm.updateProcess = false;
            vm.loadingProgress = false;
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent("Gagal update data Layer")
                    .position("top right")
                    .hideDelay(3000)
                    .theme("error-toast")
            );
        }

        function getEmpClassification(bu) {
            var defer = $q.defer();
            var response = Mpp.query({
                action: "getEmpClasification",
                bu: bu,
            });
            response.$promise.then(function (data) {
                vm.classificationCode = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                vm.classificationCode = [];
                defer.resolve([]);
            });
            return defer.promise;
        }

        function getCostCenter(id) {
            var defer = $q.defer();
            if (typeof id !== "undefined") {
                getListDataGroupCluster(id, "cm").then(function (res) {
                    var country_code = null;
                    if (vm.Form.objForm.country) {
                        var i = vm.listDataCountry
                            .map(function (e) {
                                return e.id;
                            })
                            .indexOf(vm.Form.objForm.country);

                        if (i != -1) {
                            country_code = vm.listDataCountry[i].countrycode;
                        }
                        vm.selectLoading.costCenter = true;
                        reqCostCenter(id, country_code).then(function (data) {
                            defer.resolve(data);
                            vm.selectLoading.costCenter = false;
                        });
                    } else {
                        defer.resolve([]);
                    }
                });
            } else {
                $timeout(function () {
                    defer.resolve([]);
                }, 1000);
            }
            return defer.promise;
        }

        function reqCostCenter(id, country_code) {
            var defer = $q.defer();
            var response = OrgChart.query({
                action: "getCostCenter",
                id: id,
                country_code: country_code,
            });
            response.$promise.then(function (data) {
                vm.costCenter = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                vm.costCenter = [];
                defer.resolve([]);
            });
            return defer.promise;
        }

        function getListOrgLevel() {
            var defer = $q.defer();
            var response = Mpp.query({
                action: "getListOrgLevel",
                org_level_id: vm.orgLevelID,
            });
            response.$promise.then(function (data) {
                vm.orgLevel = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                vm.orgLevel = [];
                defer.resolve([]);
            });
            return defer.promise;
        }

        function getBusinessTitle(search) {
            if (search == "all") {
                search = "";
            }
            var defer = $q.defer();
            var response = OrgChart.query({
                action: "getDataBusinessTitle",
                search: search,
                id: vm.Form.objForm.bt_code ? vm.Form.objForm.bt_code.id : "",
            });
            vm.selectLoading.businessTitle = true;
            response.$promise.then(function (data) {
                vm.listBusinessTitle = data;
                vm.selectLoading.businessTitle = false;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                vm.listBusinessTitle = [];
                vm.selectLoading.businessTitle = false;
                defer.resolve([]);
            });

            return defer.promise;
        }

        function getSubArea(id) {
            var defer = $q.defer();
            if (typeof id !== "undefined") {
                var country_code = null;
                if (vm.Form.objForm.country) {
                    var i = vm.listDataCountry
                        .map(function (e) {
                            return e.id;
                        })
                        .indexOf(vm.Form.objForm.country);

                    if (i != -1) {
                        country_code = vm.listDataCountry[i].countrycode;
                    }
                }
                var response = OrgChart.query({
                    action: "getListSubArea",
                    id: id,
                    country_code: country_code,
                });
                response.$promise.then(function (data) {
                    vm.listSubarea = data;
                    vm.listSubarea.unshift({
                        description: "All Area",
                        id: "0",
                    });
                    defer.resolve(data);
                });
                response.$promise.catch(function (data) {
                    vm.listSubarea = [];
                    defer.resolve([]);
                });
            } else {
                $timeout(function () {
                    defer.resolve([]);
                }, 1000);
            }
            return defer.promise;
        }

        function changeDescription(item) {
            try {
                vm.searchTermBT = "";
                if (item) {
                    vm.Form.objForm.description = item.description;
                    vm.Form.objForm.job_title_text = item.description;
                    vm.Form.objForm.job_function = item.code.substring(0, 2);
                    if (item.grade) {
                        vm.Form.objForm.job_level = item.grade;
                        vm.Form.objForm.job_level_set = true;
                    } else {
                        vm.Form.objForm.job_level = null;
                        vm.Form.objForm.job_level_set = false;
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

        function getListDataDivisi(id) {
            var defer = $q.defer();
            if (typeof id !== "undefined") {
                var response = OrgChart.query({
                    action: "getDataDivisi",
                    entity_id: id,
                });
                response.$promise.then(function (data) {
                    vm.listDataDivisi = data;
                    defer.resolve(data);
                });
                response.$promise.catch(function (data) {
                    vm.listDataDivisi = [];
                    defer.resolve([]);
                });
            } else {
                $timeout(function () {
                    defer.resolve([]);
                }, 1000);
            }
            return defer.promise;
        }

        function getListDataDepartment(divisi_id) {
            var defer = $q.defer();
            if (typeof divisi_id !== "undefined") {
                var response = OrgChart.query({
                    action: "getDataDepartment",
                    divisi_id: divisi_id,
                });
                response.$promise.then(function (data) {
                    vm.listDataDepartment = data;
                    defer.resolve(data);
                });
                response.$promise.catch(function (data) {
                    vm.listDataDepartment = [];
                    defer.resolve([]);
                });
            } else {
                $timeout(function () {
                    defer.resolve([]);
                }, 1000);
            }
            return defer.promise;
        }

        function getListDataJobTitle(search) {
            if (search == "all") {
                search = "";
            }
            var defer = $q.defer();
            var response = OrgChart.query({
                action: "getDataJobTitle",
                search: search,
                id: vm.Form.objForm.abreviation
                    ? vm.Form.objForm.abreviation
                    : "",
                company_id: vm.Form.objForm.entity_id
                    ? vm.Form.objForm.entity_id
                    : "",
            });
            vm.selectLoading.jobTitle = true;
            response.$promise.then(function (data) {
                vm.selectLoading.jobTitle = false;
                vm.listDataJobTitle = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                vm.selectLoading.jobTitle = false;
                vm.listDataJobTitle = [];
                defer.resolve([]);
            });
            return defer.promise;
        }

        function getListDataGroupCluster(data, from) {
            var defer = $q.defer();
            if (typeof data !== "undefined") {
                var id = data.substring(0, 2);
                if (from == "cm") {
                    id = data;
                }
                var response = OrgChart.query({
                    action: "getDataGroupCluster",
                    id: id,
                });
                response.$promise.then(function (data) {
                    vm.listDataGroupCluster = data;
                    defer.resolve(data);
                });
                response.$promise.catch(function (data) {
                    vm.listDataGroupCluster = [];
                    defer.resolve([]);
                });
            } else {
                $timeout(function () {
                    defer.resolve([]);
                }, 1000);
            }
            return defer.promise;
        }

        function getListDataCompany() {
            var defer = $q.defer();
            var response = OrgChart.query({
                action: "getDataCompany",
            });
            response.$promise.then(function (data) {
                vm.listDataCompany = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                vm.listDataCompany = [];
                defer.resolve([]);
            });
            return defer.promise;
        }

        function getCountry(search) {
            var defer = $q.defer();
            var response = OrgChart.query({
                action: "getDataCountry",
                search: search,
            });
            response.$promise.then(function (data) {
                vm.listDataCountry = data;
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                vm.listDataCountry = [];
                defer.resolve([]);
            });
            return defer.promise;
        }

        function getInfoUser() {
            var defer = $q.defer();
            var response = OrgChart.query({
                action: "getInfoUser",
            });
            response.$promise.then(function (data) {
                // vm.Form.objForm.country = null;
                // vm.Form.objForm.entity_id = null;
                if (!data[0].superAkses) {
                    vm.superAkses = false;
                    if (!vm.Form.objForm.country) {
                        vm.Form.objForm.country =
                            data[0].infoUser[0].country_id;
                    }

                    if (!vm.Form.objForm.entity_id) {
                        vm.Form.objForm.entity_id =
                            data[0].infoUser[0].company_id;
                    }
                } else {
                    vm.superAkses = true;
                }
                defer.resolve(data);
            });
            response.$promise.catch(function (data) {
                defer.resolve([]);
            });
            return defer.promise;
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function changeDescriptionBT() {
            vm.Form.objForm.job_title_text = vm.Form.objForm.description;
        }

        function removeDuplicatesEmployess(arr) {
            var unique_array = [];
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].id) {
                    if (
                        unique_array
                            .map(function (e) {
                                return e.id;
                            })
                            .indexOf(arr[i].id) == -1
                    ) {
                        unique_array.push(arr[i]);
                    }
                }
            }
            return unique_array;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.mpp.orgchart')
    .controller('EditOrgEmpChartController', Controller);

  Controller.$inject = ['$mdDialog', 'data', 'config', '$http', 'AppAPI', 'Form', 'Auth', 'year', 'orgService', 'filterFilter', '$q', '$element', 'layerID'];

  /* @ngInject */
  function Controller($mdDialog, data, config, $http, AppAPI, Form, Auth, year, orgService, filterFilter, $q, $element, layerID) {
    var vm = this;
    var Mpp = AppAPI.Mpp();
    var OrgChart = new AppAPI.Orgchartemp();
    var OrgLayer = new AppAPI.Orgchart();
    vm.exists = exists;
    console.log(data);

    vm.layerID = data.context.id;
    vm.orgLevelID = data.context.org_level_id;
    vm.classificationCode = [];
    vm.tbdQuantity = 1;

    vm.selectedItem = {
      'employee': null,
      'indirect': null,
      'direct': null
    };
    vm.searchText = {
      'employee': null,
      'indirect': null,
      'direct': null
    };

    vm.showErrorEmployee = false;
    vm.messagesErrorEmployee = '';
    vm.transformChip = transformChip;
    vm.hide = hide;
    vm.cancel = cancel;
    vm.actionLists = [];
    vm.menuName = data.name;
    vm.updateData = updateData;
    vm.update = false;
    vm.create = false;
    vm.selectedItemChange = selectedItemChange;
    vm.querySearchIndirect = querySearchDefferedIndirect;
    vm.querySearchDirect = querySearchDefferedDirect;
    vm.querySearchEmployee = querySearchDeferredEmployee;
    vm.saveProcess = false;
    vm.updateProcess = false;
    vm.addTbdToChart = addTbdToChart;
    vm.isTBD = false;
    vm.searchTermBT;
    vm.searchTermCBU;
    vm.searchTermSD;
    vm.searchTermSA;
    vm.clearSearchTerm = clearSearchTerm;

    // initial form
    Form.initialForm();

    // get constructor form
    var Mpp = AppAPI.Mpp();

    // set constructor form
    Form.setObject(OrgChart);

    // set form to controller
    vm.Form = Form;

    vm.Form.objForm.listEmp = [];

    vm.Form.objForm.is_parent = data.context.is_parent;
    vm.Form.objForm.direct_report = data.context.id;
    vm.Form.objForm.indirect_report = {
      'id': 0,
      'description': 'none'
    };

    activate();

    function clearSearchTerm(f) {
      switch (f) {
        case 1:
          vm.searchTermBT = '';
          break;
        case 2:
          vm.searchTermCBU;
          break;
        case 3:
          vm.searchTermSD;
          break;
        case 4:
          vm.searchTermSA;
          break;
      }
    };

    function activate() {
      angular.element(document.body.querySelector('#dialog-mpp')).block();

      var collection = OrgChart.get({
        action: 'getListDetail',
        id: data.context.id
      });
      collection.$promise.then(function (res) {
        vm.update = true;
        vm.Form.objForm.id = data.context.id;
        if (res.listEmp.length > 0) {
          for (var i = 0; i < res.listEmp.length; i++) {
            var temp = {
              'nik': res.listEmp[i].nik,
              'name': res.listEmp[i].name,
              'date_fulfill': res.listEmp[i].date_fulfill,
              'date_fulfill_formated': new Date(res.listEmp[i].date_fulfill)
            }
            vm.Form.objForm.listEmp.push(temp);
          }
        }
        vm.Form.objForm.listBtCode = res.listBtCode;
        vm.Form.objForm.listCbu = res.listCbu.length === 0 ? [] : res.listCbu;
        vm.Form.objForm.listArea = res.listArea;
        vm.Form.objForm.clasification_code = res.clasification_code;
        vm.Form.objForm.description = res.description;
        vm.Form.objForm.job_level = res.job_level;
        vm.Form.objForm.cost_center_id = res.cost_center_id;
        vm.Form.objForm.level = res.level;
        vm.Form.objForm.org_level_id = res.org_level_id;
        vm.Form.objForm.type = res.type;
        vm.Form.objForm.is_parent = res.is_parent;
        vm.Form.objForm.listSubDomain = res.listSubDomain.length === 0 ? [] : res.listSubDomain;
        vm.Form.objForm.direct_report = res.direct_report_obj;
        vm.Form.objForm.indirect_report = res.indirect_report_obj;
        vm.Form.objForm.parent_id_old = res.parent_id_old; 
        // console.log(vm.Form);
      }).then(function () {
        getCostCenter();
        getListOrgLevel();
        getBusinessTitle();
        getLocationMpp();
        getSubArea();
        getCbu();
        getSubDomain();
        getDirectReport();
        getEmpClassification();
      });
    }



    function addTbdToChart(counter, d) {
      var tDate = new Date(d);
      for (var i = 0; i < counter; i++) {
        var datum = {
          'nik': 'TBD',
          'name': 'TBD',
          'date_fulfill_formated': tDate,
          'date_fulfill': moment(tDate).format('YYYY-MM-DD')
        };
        vm.Form.objForm.listEmp.push(datum);
      }
      vm.isTBD = false;
    }

    function transformChip(chip) {
      if (angular.isObject(chip)) {
        return chip;
      }
    }


    function querySearchDefferedIndirect(query) {
      return $http
        .get(config.api + 'api/orglayeremp?action=getListOrgLayer&search=' + query)
        .then(function (item) {
          return item.data;
        });
    }

    function querySearchDefferedDirect(query) {
      return $http
        .get(config.api + 'api/orglayeremp?action=getListOrgLayerDirect&search=' + query + '&parent_id=' + layerID)
        .then(function (item) {
          if (item.data.length === 0) {
            vm.Form.objForm.direct_report = {
              'id': 0,
              'description': 'none'
            };
            vm.searchText.direct = query;
          }
          //console.log(item);
          return item.data;
        });
    }

    function querySearchDeferredEmployee(query) {
      return $http
        .get(config.api + 'api/orglayeremp?action=getListEmployee&search=' + query)
        .then(function (item) {
          if (item.data.length === 0) {
            vm.searchText.employee = query;
          }
          return item.data;
        });
    }

    function getDirectReport() {
      var response = OrgChart.query({
        action: 'getListOrgLayerDirect',
        parent_id: layerID,
        flag: false
      });

      response.$promise.then(fetchDirectReport);
      response.$promise.catch(catchIndirectReport);
    }

    function fetchDirectReport(data) {
      data.push({
        'id': 0,
        'description': 'none'
      });
      vm.listDirectReport = data;
      vm.listIndirectReport = data;
    }

    function catchIndirectReport(data) {
      vm.listDirectReport = [];
      vm.listIndirectReport = [];
    }

    function exists(array, key, value) {
      if (angular.isArray(array)) {
        for (var i = 0; i < array.length; i++) {
          if (array[i][key] === value) {
            return true;
          }
        }
      }
      return false;
    }

    function selectedItemChange(item, type) {
      switch (type) {
        case 'employee':
          if (item) {

            vm.showErrorEmployee = false;

            if (!exists(vm.Form.objForm.listEmp, 'nik', item.nik)) {

              var validation = OrgChart.get({
                action : 'checkEmployeeExists',
                nik : item.nik
              });

              validation.$promise.then(function(response){
                if (response.status === 1) {
                  var dt = new Date('1970-01-01');
                  item.date_fulfill_formated = dt;
                  item.date_fulfill = moment(dt).format('YYYY-MM-DD');
                  vm.Form.objForm.listEmp.push(item);
                  vm.searchText.employee = null;
                  vm.selectedItem.employee = null;
                } else {
                  vm.showErrorEmployee = true;
                  vm.messagesErrorEmployee = response.message + ' on ' + response.data.description + ' | layer id ' + response.data.layer_id;
                }
              });

              validation.$promise.catch(function (error) {
                console.log(error);
              })
            }
          }
          break;
        case 'direct':
          if (item) {
            vm.Form.objForm.direct_report = item;
          }
          break;
        case 'indirect':
          if (item) {
            vm.Form.objForm.indirect_report = item;
          }
          break;
      }
    }

    function hide() {
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    }



    function updateData(ev, formController) {
      vm.updateProcess = true;
      var promise = Form.saveData('editLayerWithEmp', formController, OrgChart);
      promise.then(successUpdate);
      promise.catch(failedUpdate);
    }


    function successUpdate() {
      vm.success = true;
      vm.updateProcess = false;
    }

    function failedUpdate() {
      vm.success = false;
      vm.updateProcess = false;
    }


    function getEmpClassification() {
      var response = Mpp.query({
        action: 'getEmpClasification'
      });
      response.$promise.then(fetchResponseEmpClassification);
      response.$promise.catch(catchResponseEmpClassification);
    }

    function fetchResponseEmpClassification(data) {
      vm.classificationCode = data;
    }

    function catchResponseEmpClassification(data) {
      vm.classificationCode = [];
    }


    function getCostCenter() {
      var response = Mpp.query({
        action: 'getCostCenter'
      });
      response.$promise.then(fetchResponseCostCenter);
      response.$promise.catch(catchResponseCostCenter);
    }

    function fetchResponseCostCenter(data) {
      vm.costCenter = data;

    }

    function catchResponseCostCenter(data) {
      vm.costCenter = [];
    }


    function getListOrgLevel() {
      var response = Mpp.query({
        action: 'getListOrgLevel',
        org_level_id: vm.orgLevelID
      });
      response.$promise.then(fetchResponseOrgLevel);
      response.$promise.catch(catchResponseOrgLevel);
    }

    function fetchResponseOrgLevel(data) {
      vm.orgLevel = data;

    }

    function catchResponseOrgLevel(data) {
      vm.orgLevel = [];
    }


    function getBusinessTitle() {
      var response = Mpp.query({
        action: 'getBusinessTitle'
      });
      response.$promise.then(fetchResponseBusinessTitle);
      response.$promise.catch(catchResponseBusinessTitle);
    }

    function fetchResponseBusinessTitle(data) {
      vm.listBusinessTitle = data;
    }

    function catchResponseBusinessTitle(data) {
      vm.listBusinessTitle = [];
    }


    function getSubArea() {
      var response = OrgChart.query({
        action: 'getListSubArea'
      });
      response.$promise.then(fetchSubArea);
      response.$promise.catch(catchSubArea);
    }

    function fetchSubArea(data) {
      vm.listSubarea = data;
    }

    function catchSubArea(data) {
      vm.listSubarea = [];
    }

    function getCbu() {
      var response = OrgChart.query({
        action: 'getListCbu'
      });
      response.$promise.then(fetchCbu);
      response.$promise.catch(catchCbu);
    }

    function fetchCbu(data) {
      vm.listCbu = data;
    }

    function catchCbu(data) {
      vm.listCbu = [];
    }


    function getSubDomain() {
      var response = OrgChart.query({
        action: 'getListSubDomain'
      });
      response.$promise.then(fetchSubDomain);
      response.$promise.catch(catchSubDomain);
    }

    function fetchSubDomain(data) {
      vm.listSubDomain = data;
    }

    function catchSubDomain(data) {
      vm.listSubDomain = [];
    }


    function getLocationMpp() {
      var response = Mpp.query({
        action: 'getLocationMpp'
      });
      response.$promise.then(fetchResponseLocation);
      response.$promise.catch(catchResponseLocation);
    }

    function fetchResponseLocation(data) {
      vm.location = data;
    }

    function catchResponseLocation(data) {
      vm.location = [];
    }



    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });




  }
})();

(function () {
    "use strict";

    angular
        .module("app.mpp.orgchart")
        .controller("FormAddMppController", Controller);

    Controller.$inject = [
        "$mdDialog",
        "$q",
        "$element",
        "$http",
        "$timeout",
        "refData",
        "config",
        "AppAPI",
        "Form",
        "Auth",
        "year",
        "orgService",
        "filterFilter",
        "layerID",
        "$scope",
        "listTeamLayer",
        "$mdToast",
    ];

    /* @ngInject */
    function Controller(
        $mdDialog,
        $q,
        $element,
        $http,
        $timeout,
        refData,
        config,
        AppAPI,
        Form,
        Auth,
        year,
        orgService,
        filterFilter,
        layerID,
        $scope,
        listTeamLayer,
        $mdToast
    ) {
        // console.log(data);
        var vm = this;
        var Mpp = AppAPI.Mpp();
        var OrgChart = AppAPI.Orgchart();
        // initial form
        Form.initialForm();

        // set constructor form
        Form.setObject(OrgChart);

        // set form to controller
        vm.Form = Form;
        vm.Form.objForm.listEmp = [];
        vm.Form.objForm.layer_id = refData.context.id;
        vm.Form.objForm.org_layer_transaction_id =
            refData.context.org_layer_transaction_id;
        vm.Form.objForm.parent = refData.context.parent;
        vm.Form.objForm.direct_report = refData.context.direct_report;
        vm.listTeamLayer = listTeamLayer;

        vm.loadingProgress = false;
        vm.isTBD = false;
        vm.tbdQuantity = 1;
        vm.isTBDNull = false;
        vm.selectedItem;
        vm.listDirectReport = [];
        vm.listTransactionType = [];
        vm.showErrorEmployee = false;
        vm.messagesErrorEmployee = "";
        vm.saveProccess = false;

        vm.querySearchEmployee = querySearchEmployee;
        vm.addTbdToChart = addTbdToChart;
        vm.selectedItemChange = selectedItemChange;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.saveData = saveData;
        vm.removeMpp = removeApp;
        vm.restoreMpp = restoreApp;
        vm.setToken = Auth.setToken;

        activate();

        function activate() {
            vm.loadingProgress = true;
            loadDirectReport()
                .then(loadTransaction)
                .then(loadDetail)
                .then(function () {
                    vm.loadingProgress = false;
                });
        }

        function removeApp(idx) {
            if (vm.Form.objForm.listEmp[idx].id === null) {
                vm.Form.objForm.listEmp.splice(idx, 1)
            } else {
                vm.Form.objForm.listEmp[idx].isDeleted = true;
            }
        }
        function restoreApp(idx) {

            vm.Form.objForm.listEmp[idx].isDeleted = false;

        }

        function loadDetail() {
            var defer = $q.defer();

            var request = orgService.getListDetail(
                refData.context.org_layer_transaction_id
            );

            request.$promise.then(function (res) {
                if (res.listEmp.length > 0) {
                    for (var i = 0; i < res.listEmp.length; i++) {
                        var temp = {
                            nik: res.listEmp[i].nik,
                            name: res.listEmp[i].name,
                            date_fulfill: res.listEmp[i].date_fulfill,
                            date_fulfill_formated: new Date(
                                res.listEmp[i].date_fulfill
                            ),
                            effective_date: res.listEmp[i].effective_date,
                            date_effective_formated: new Date(
                                res.listEmp[i].effective_date
                            ),
                            position_name: res.listEmp[i].position_name,
                            directReport: res.listEmp[i].directReport,
                            is_planning: res.listEmp[i].is_planning,
                            is_active: res.listEmp[i].is_active,
                            transactionType: res.listEmp[i].transactionType,
                            id: res.listEmp[i].id,
                            isDeleted: res.listEmp[i].isDeleted,
                            is_parent: res.listEmp[i].is_parent,
                            is_budgeted: res.listEmp[i].is_budgeted
                        };
                        vm.Form.objForm.listEmp.push(temp);
                    }
                }
                defer.resolve(true);
            });

            request.$promise.catch(function (err) {
                defer.resolve(true);
                vm.loadingProgress = false;
            });

            return defer.promise;
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function loadDirectReport() {
            var defer = $q.defer();
            var response = OrgChart.query({
                action: "getLayerMember",
                layerID: refData.context.parent,
            });
            response.$promise.then(function (res) {
                vm.listDirectReport = res;
                defer.resolve(res);
            });
            response.$promise.catch(function (err) {
                vm.listDirectReport = [];
                defer.resolve(res);
            });
            return defer.promise;
        }

        function loadTransaction() {
            var defer = $q.defer();
            var response = OrgChart.query({
                action: "getLayerTransaction",
                layerID: refData.context.id,
            });
            response.$promise.then(function (res) {
                vm.listTransactionType = res;
                defer.resolve(res);
            });
            response.$promise.catch(function (err) {
                vm.listTransactionType = [];
                defer.resolve(res);
            });
            return defer.promise;
        }

        function addTbdToChart(counter, d) {
            for (var i = 0; i < counter; i++) {
                if (vm.isTBD) {
                    var tmpData = {
                        date_fulfill: null,
                        directReport: null,
                        effective_date: null,
                        id: null,
                        is_budgeted: "1",
                        is_planning: "0",
                        name: "TBD",
                        nik: "TBD",
                        isDeleted: false,
                        is_active: '1',
                        position_name: refData.context.description,
                        transactionType: null,
                        is_parent: '0'
                    };
                } else if (vm.isTBDNull) {
                    var tmpData = {
                        date_fulfill: null,
                        directReport: null,
                        effective_date: null,
                        id: null,
                        is_budgeted: "1",
                        is_planning: "1",
                        isDeleted: false,
                        is_active: '1',
                        name: "TBD",
                        nik: "TBD",
                        position_name: refData.context.description,
                        transactionType: null,
                        is_parent: '0'
                    };
                }
                vm.Form.objForm.listEmp.push(tmpData);
            }
            vm.isTBD = false;
            vm.isTBDNull = false;
        }

        function querySearchEmployee(query) {
            return $http
                .get(
                    config.api +
                    "api/orglayer?action=getListEmployee&search=" +
                    query
                )
                .then(function (item) {
                    return item.data;
                });
        }

        function selectedItemChange(item) {
            if (item) {
                vm.showErrorEmployee = false;
                if (!exists(vm.Form.objForm.listEmp, "nik", item.nik)) {
                    var validation = OrgChart.get({
                        action: "checkEmployeeExists",
                        nik: item.nik,
                    });
                    validation.$promise.then(function (response) {
                        if (response.status === 1) {
                            var tmpData = {
                                date_fulfill: null,
                                directReport: null,
                                effective_date: null,
                                id: null,
                                is_budgeted: "1",
                                is_planning: null,
                                name: item.name,
                                nik: item.nik,
                                isDeleted: false,
                                is_active: '1',
                                position_name: refData.context.description,
                                transactionType: null,
                                is_parent: '0'
                            };
                            vm.Form.objForm.listEmp.push(tmpData);
                            vm.searchText = null;
                            vm.selectedItem = null;
                        } else {
                            vm.showErrorEmployee = true;
                            vm.messagesErrorEmployee =
                                response.message +
                                " on " +
                                response.data.description +
                                " | layer id " +
                                response.data.layer_id;
                        }
                    });

                    validation.$promise.catch(function (error) {
                        // console.log(error);
                    });
                }
            }
        }

        function exists(array, key, value) {
            if (angular.isArray(array)) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i][key] === value) {
                        return true;
                    }
                }
            }
            return false;
        }

        function saveData(ev, formController) {

            vm.loadingProgress = true;
            vm.saveProccess = true;
            if (vm.Form.objForm.listEmp.length > 0) {
                for (var i = 0; i < vm.Form.objForm.listEmp.length; i++) {
                    var date = moment(
                        vm.Form.objForm.listEmp[i].date_fulfill_formated
                    ).format("YYYY-MM-DD");
                    vm.Form.objForm.listEmp[i].date_fulfill = date;

                    date = moment(
                        vm.Form.objForm.listEmp[i].date_effective_formated
                    ).format("YYYY-MM-DD");
                    vm.Form.objForm.listEmp[i].effective_date = date;

                }
            }
            var promise = vm.Form.saveData(
                "saveEmployeeMpp",
                formController,
                OrgChart
            );
            promise.then(successUpdate);
            promise.catch(failedUpdate);
        }

        function successUpdate() {
            vm.loadingProgress = false;
            vm.success = true;
            vm.saveProccess = false;
            // hide();
        }

        function failedUpdate() {
            vm.loadingProgress = false;
            vm.success = false;
            vm.saveProccess = false;
            // hide();
        }
    }
})();

(function () {
    'use strict';
  
    angular
        .module('app.policy.user', [])
         .config(config);
  
    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.policy.user', {
                url: '/policy-user',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/nabati-policy-user/policy-user.html',
                        controller: 'PolicyUserController as vm'
                    }
                }
            });
    }
   })();
  
(function() {
  'use strict';
  angular
    .module('app.policy.user')
    .controller('PolicyUserController', PolicyUserController);

  PolicyUserController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'filterFilter',
    'config'
  ];
  /** @ngInject */
  function PolicyUserController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    filterFilter,
    config
  ) {
    var vm = this;
    var Policy = AppAPI.Policy();

    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    vm.dialogClose = dialogClose;
    vm.viewDetail = viewDetail;
    
    vm.isAdmin = false;
    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      Form.initialForm();
      Form.setObject(Policy);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(Policy, pageno, {
        action: 'viewDataUser'
      });

      resp.then(function(data) {
        vm.isAdmin = data.isAdmin;
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function  viewDetail(ev, data) 
    {
      $mdDialog.show({
          controller         : 'DetailPolicyController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/nabati-policy/detail-policy.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:false,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              
          },
          locals:{ 
              data : data
          }
      });
    }
  }
})();

(function () {
    'use strict';
  
    angular
        .module('app.policy', [])
         .config(config);
  
    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.policy', {
                url: '/policy',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/nabati-policy/policy.html',
                        controller: 'PolicyController as vm'
                    }
                }
            });
    }
   })();
  
(function() {
  'use strict';
  angular
    .module('app.policy')
    .controller('PolicyController', PolicyController);

  PolicyController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    '$q',
    'filterFilter',
    'config',
    'FileUploader',
    'Approvalinfo',
    'Newsinfo'
  ];
  /** @ngInject */
  function PolicyController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    $q,
    filterFilter,
    config,
    FileUploader
  ) {
    var vm = this;
    var Policy = AppAPI.Policy();
    var Attendancereport=AppAPI.Attendancereport();

    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.saveData = saveData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = [];
    vm.Form = Form;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company=$localStorage.empsite;
    vm.viewDetail = viewDetail;
    
    vm.isAdmin = false;
    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      Form.initialForm();
      Form.setObject(Policy);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(Policy, pageno, {
        action: 'viewData'
      });

      resp.then(function(data) {
        vm.isAdmin = data.isAdmin;
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InputPolicyController',
        controllerAs: 'vm',
        templateUrl: 'app/main/nabati-policy/policy-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'EditPolicyController',
        controllerAs: 'vm',
        templateUrl: 'app/main/nabati-policy/policy-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data  : data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to delete this ?')
          .textContent('Data your selected will be deleted and can not recovered.')
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('NO');

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = Policy.delete({
              action: 'deleteData',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('saveData', frm, news);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();

          vm.uploader.uploadAll();

          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(data.title)
            .textContent(data.pesan)
            .ariaLabel(data.title)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    var uploader = vm.uploader = new FileUploader({
        url:config.api+'api/policy/uploadFile', 
        removeAfterUpload:true,
        alias:'policyDocument',    
    });

      // a sync filter
    uploader.filters.push({
      name: 'syncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options) {
          return this.queue.length < 10;
      }
    });

    // an async filter
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
          setTimeout(deferred.resolve, 1e3);
      }
    });

    function  viewDetail(ev, data) {
      $mdDialog.show({
          controller         : 'DetailPolicyController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/nabati-policy/detail-policy.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:false,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
              
          },
          locals:{ 
              data : data
          }
      });
    }

    function inArray(param, array) {
      var length = array.length;
      for (var i = 0; i < length; i++) {
        if (array[i] == param)
          return true;
        }
      return false;
     }
  }
})();

(function() {
    'use strict';
    angular
      .module('app.policy')
      .controller('InputPolicyController', InputPolicyController);
  
    InputPolicyController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'config',
      'FileUploader'
    ];
    /** @ngInject */
    function InputPolicyController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      config,
      FileUploader
    ) {
      var vm = this;
      var Policy = AppAPI.Policy();
      var News   = AppAPI.News();
      var Attendancereport=AppAPI.Attendancereport();

      vm.Form = Form;
      vm.saveData = saveData;
      vm.getDivision = getDivision;
      vm.getBu = getBu;
      vm.dialogClose = dialogClose;
      vm.changeSelectedGrade = changeSelectedGrade
      vm.gradeList = [
        {'value':'all','name':'All'},
        {'value':'1A','name':'1A'},
        {'value':'1B','name':'1B'},
        {'value':'1C','name':'1C'},
        {'value':'2A','name':'2A'},
        {'value':'2B','name':'2B'},
        {'value':'2C','name':'2C'},
        {'value':'3A','name':'3A'},
        {'value':'3B','name':'3B'},
        {'value':'3C','name':'3C'},
        {'value':'4A','name':'4A'},
        {'value':'4B','name':'4B'},
        {'value':'4C','name':'4C'},
        {'value':'5A','name':'5A'},
        {'value':'5B','name':'5B'},
        {'value':'5C','name':'5C'},
        {'value':'6A','name':'6A'},
        {'value':'6B','name':'6B'},
        {'value':'6C','name':'6C'},
        {'value':'7A','name':'7A'},
        {'value':'7B','name':'7B'},
        {'value':'7C','name':'7C'},
      ];
      
      activate();
      
      function activate() {
        Form.initialForm();
        Form.setObject(Policy);
        loadDataCountry();
      }
      
      function loadDataBU(id) {
        var response=Policy.query({action:'viewCompany',id:id});
        response.$promise.then(fetchBU);
        response.$promise.catch(errorFetchBU);
      }
      function fetchBU(data) {
        vm.listBU=data;

      }
      function errorFetchBU() {
        vm.listBU=[];
      }
      
      function loadDataCountry() {
        var response=Policy.query({action:'viewCountry'});
        response.$promise.then(fetchCountry);
        response.$promise.catch(errorFetchCountry);
      }
      function fetchCountry(data) {
        vm.listCountry=data;

      }
      function errorFetchCountry() {
        vm.listCountry=[];
      }
      
      function loadDataDivision(idbu) {
        var arrStr = idbu.join(',');
        var response=Policy.query({action:'viewDivisi',id:arrStr});
        response.$promise.then(fetchDivisiBU);
        response.$promise.catch(errorDivisiBU);
      }
      function fetchDivisiBU(data) {
        vm.listDivision=data;
       }
       function errorDivisiBU() {
         vm.listDivision=[];
       }

      function loadDataSubArea(idbu) {
        var arrStr = idbu.join(',');
        var response=Policy.query({action:'viewSubarea',id:arrStr});
        response.$promise.then(fetchSubArea);
        response.$promise.catch(errorSubArea);
      }

     function fetchSubArea(data) {
      vm.subAreaList=data;
     }
     function errorSubArea() {
       vm.subAreaList=[];
     }
      
     function getDivision(param)
     {
        loadDataDivision(param);
        loadDataSubArea(vm.Form.objForm.bu)
    }
     
    function getBu(param)
     {
        loadDataBU(param);
    }

      function saveData(ev, frm) {
        angular.element.blockUI();
        var response = Form.saveData('saveData', frm, Policy);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            vm.uploader.uploadAll();
            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(data.title)
              .textContent(data.pesan)
              .ariaLabel(data.title)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }

      var uploader = vm.uploader = new FileUploader({
          url:config.api+'api/policy/uploadFile', 
          removeAfterUpload:true,
          alias:'policyDocument',    
      });

      // a sync filter
      uploader.filters.push({
        name: 'syncFilter',
        fn: function(item /*{File|FileLikeObject}*/, options) {
            return this.queue.length < 10;
        }
      });

      // an async filter
      uploader.filters.push({
        name: 'asyncFilter',
        fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
            setTimeout(deferred.resolve, 1e3);
        }
      });
    }

    function changeSelectedGrade(param,gradeList)
    {
      if(param.includes('all')){
        param = [];
        gradeList.forEach(function(item,index){
          param.push(item.value)
        })
      }

      return param;
    }
  })();
(function() {
    'use strict';
    angular
      .module('app.policy')
      .controller('DetailPolicyController', DetailPolicyController);
  
    DetailPolicyController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'data',
      '$sce'
    ];
    /** @ngInject */
    function DetailPolicyController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      data,
      $sce
    ) {
      var vm = this;
      var Policy = AppAPI.Policy();
      vm.Form = Form;
      vm.info = data;
      vm.dialogClose = dialogClose;
      vm.doc_type=false;
      activate();
  
      function activate() {
        if(data.filename!=null){
          if (data.filename.slice(-3) === 'mp4') {
            vm.video_type = true;
            vm.doc_type   = false;
            vm.images = false;
          }
          else if (data.filename.slice(-3) === 'pdf') {
              vm.doc_type = true;
              vm.video_type = false;
              vm.images = false;
          } else {
              vm.video_type = false;
              vm.doc_type = false;            
              vm.images = true;            
              vm.doc = data.filename;
          }
          vm.url = 'api/policydocument/'+data.filename+'?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
          console.log(vm.url);
        }
      }

      function dialogClose() {
        $mdDialog.hide();
        // $window.location.reload();
      }
    }
  })();
(function () {
    "use strict";

    angular.module("app.mympp", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mympp", {
            url: "/mympp",
            views: {
                "content@app": {
                    templateUrl: "app/main/mympp/mympp.html",
                    controller: "MyMppController as vm",
                },
            },
        });
    }
})();

(function () {
    "use strict";

    angular.module("app.mympp").controller("MyMppController", MyMppController);

    MyMppController.$inject = [
        "AppAPI",
        "$state",
        "$localStorage",
        "$scope",
        "$rootScope",
        "$mdToast",
        "Auth",
        "$mdDialog",
        "$q",
        "$location",
        "$window",
        "config"
    ];

    /* @ngInject */
    function MyMppController(
        AppAPI,
        $state,
        $localStorage,
        $scope,
        $rootScope,
        $mdToast,
        Auth,
        $mdDialog,
        $q,
        $location,
        $window,
        config
    ) {
        var vm = this;
        var MyMpp = new AppAPI.MyMpp();
        var dt = new Date();
        vm.listLayer = [0, 1, 2, 3, 4, 5];
        vm.listYear = [2018, 2019, 2020, 2021];
        vm.layer = 1;
        vm.year = dt.getFullYear();
        vm.querySearchLayer = querySearchLayer;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTerm;
        vm.months = [
            { id: 0, name: "Jan" },
            { id: 1, name: "Feb" },
            { id: 2, name: "Mar" },
            { id: 3, name: "Apr" },
            { id: 4, name: "Mei" },
            { id: 5, name: "Jun" },
            { id: 6, name: "Jul" },
            { id: 7, name: "Aug" },
            { id: 8, name: "Sep" },
            { id: 9, name: "Oct" },
            { id: 10, name: "Nov" },
            { id: 11, name: "Dec" },
        ];
        vm.listData = [];
        vm.loadLayer = loadLayer;
        vm.onClickDownload = onClickDownload;
        vm.searchListData = '';

        function selectedItemChange(item) {
            vm.teamLayer = item;
        }

        function querySearchLayer(query) {
            var defer = $q.defer();
            var search = angular.lowercase(query);
            var request = MyMpp.query({
                action: "viewdataorgchart",
                search: search,
            });
            request.$promise.then(function (res) {
                defer.resolve(res);
            });
            request.$promise.catch(function (err) {
                defer.reject([]);
            });
            return defer.promise;
        }
        
        function loadLayer() {
            angular.element("#orgchart-area").block();
            var response = MyMpp.query({
                action: "loadDataLayer",
                maxDepth: vm.layer,
                layerId: vm.teamLayer.id,
                year: vm.year,
            });
            response.$promise.then(function (data) {
                data.sort(function (a, b) {
                    var keyA = parseInt(a.level),
                        keyB = parseInt(b.level);
                    // Compare the 2 dates
                    if (keyA < keyB) return -1;
                    if (keyA > keyB) return 1;
                    return 0;
                });
                vm.listData = data;
                angular.element("#orgchart-area").unblock();
            });
            response.$promise.catch(function () {
                vm.listData = [];
                angular.element("#orgchart-area").unblock();
            });
        }
        
        function onClickDownload() {
            var token = Auth.setTokenPromise();
            token.then(
                function (data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            "://" +
                            host +
                            config.api +
                            "api/mympp/downloadReport/" +
                            vm.teamLayer.id +
                            "/" +
                            vm.year +
                            "/" +
                            vm.layer +
                            "/" +
                            data.token,
                        "_blank"
                    );
                },
                function () {
                    $window.alert("gagal load token");
                }
            );
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.mppmgr')
    .service('MppMgrService', MppMgrService);

  function MppMgrService($rootScope) {

    var date = new Date();
    var years = date.getFullYear() + 1;
    var layer = 1;
    var maxDepth = 1;
    var teamLayer = 0;
    var toggleService = false;
    var toggleMonthVal = false;
    var togglePayment = false;
    var toggleCurrent = true;
    var toggleFuture = true;
    var toggleStatus = true;
    var toggleActual = true;
    var toggleAction = true;
    var toggleTotalPerMonth = false;
    var toggleMoneyShow = false;
    var approvalStatus = '-';
    var lastLevelOpened = 1;


    function reset() {
        date = new Date();
        years = date.getFullYear() + 1;
        layer = 1;
        maxDepth = 1;
        teamLayer = 0;
        toggleService = false;
        toggleMonthVal = false;
        togglePayment = false;
        toggleCurrent = true;
        toggleFuture = true;
        toggleStatus = true;
        toggleActual = true;
        toggleAction = true;
        toggleTotalPerMonth = false;
        toggleMoneyShow = false;
        approvalStatus = '-';
    }


    function setLayer(no) {
      layer = no;
    }

    function getLayer() {
      return layer;
    }

    function setLastLevelOpened(num) {
      lastLevelOpened = num;
    }

    function getLastLevelOpened() {
      return lastLevelOpened;
    }

    function setApprovalStatus(status) {
      approvalStatus = status;
      $rootScope.$broadcast('mppMgrStatusUpdated', status);
    }

    function setTeamLayer(team) {
      teamLayer = team;
    }

    function getTeamLayer() {
      return teamLayer;
    }

    function getApprovalStatus() {
      return approvalStatus;
    }

    function getToggleMoneyShow() {
      return toggleMoneyShow;
    }

    function setToggleMoneyShow(status) {
      toggleMoneyShow = status;
    }

    function setToggleTotalPerMonth(status) {
      toggleTotalPerMonth = status;
    }

    function getToggleTotalPerMonth() {
      return toggleTotalPerMonth;
    }

    function setToggleAction(act) {
      toggleAction = act;
    }

    function getToggleAction(act) {
      return toggleAction;
    }

    function setToggleCurrent(curr) {
      toggleCurrent = curr;
    }

    function getToggleCurrent() {
      return toggleCurrent;
    }

    function setToggleFuture(val) {
      toggleFuture = val;
    }

    function getToggleFuture() {
      return toggleFuture;
    }

    function setToggleStatus(val) {
      toggleStatus = val;
    }

    function getToggleStatus() {
      return toggleStatus;
    }

    function setToggleActual(val) {
      toggleActual = val;
    }

    function getToggleActual() {
      return toggleActual;
    }


    function setMaxDepth(depth) {
      maxDepth = depth;
    }

    function getMaxDepth() {
      return maxDepth;
    }

    function getTogglePayment() {
      return togglePayment;
    }

    function setTogglePayment(pay) {
      togglePayment = pay;
    }

    function setYears(year) {
      years = year;
    }

    function getYears() {
      return years;
    }

    function setToggleService(toggle) {
      toggleService = toggle;
    }

    function getToggleService() {
      return toggleService;
    }

    function setToggleMonth(toggle) {
      toggleMonthVal = toggle;
    }

    function getToggleMonth() {
      return toggleMonthVal;
    }

    return {
      setYears              : setYears,
      setLayer              : setLayer,
      setMaxDepth           : setMaxDepth,
      getMaxDepth           : getMaxDepth,
      getApprovalStatus     : getApprovalStatus,
      getTogglePayment      : getTogglePayment,
      getToggleService      : getToggleService,
      getToggleMonth        : getToggleMonth,
      getToggleFuture       : getToggleFuture,
      getToggleActual       : getToggleActual,
      getToggleCurrent      : getToggleCurrent,
      getToggleStatus       : getToggleStatus,
      getToggleAction       : getToggleAction,
      getToggleTotalPerMonth: getToggleTotalPerMonth,
      getToggleMoneyShow    : getToggleMoneyShow,
      getYears              : getYears,
      getTeamLayer          : getTeamLayer,
      getLayer              : getLayer,
      setToggleService      : setToggleService,
      setToggleMonth        : setToggleMonth,
      setTogglePayment      : setTogglePayment,
      setToggleActual       : setToggleActual,
      setToggleCurrent      : setToggleCurrent,
      setToggleFuture       : setToggleFuture,
      setToggleStatus       : setToggleStatus,
      setToggleAction       : setToggleAction,
      setToggleTotalPerMonth: setToggleTotalPerMonth,
      setToggleMoneyShow    : setToggleMoneyShow,
      setApprovalStatus     : setApprovalStatus,
      setTeamLayer          : setTeamLayer,
      reset                 : reset
    }

  }

})();

(function () {
    "use strict";

    angular
        .module("app.mppmgr")
        .controller("MppMgrController", MppMgrController);

    MppMgrController.$inject = [
        "AppAPI",
        "$state",
        "$localStorage",
        "MppMgrService",
        "$scope",
        "$rootScope",
        "$mdToast",
        "Auth",
        "$mdDialog",
        "$q",
    ];

    /* @ngInject */
    function MppMgrController(
        AppAPI,
        $state,
        $localStorage,
        MppMgrService,
        $scope,
        $rootScope,
        $mdToast,
        Auth,
        $mdDialog,
        $q
    ) {
        var vm = this;
        var Mpp = new AppAPI.MppMgr();
        var Orgchart = new AppAPI.Orgchartemp();
        var dt = new Date();

        vm.listLayer = [0, 1, 2, 3, 4, 5];
        vm.listYear = [2018, 2019, 2020, 2021];
        vm.layer = 1;
        vm.year = dt.getFullYear();
        vm.querySearchLayer = querySearchLayer;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTerm;
        vm.loaTableMpp = loaTableMpp;

        activate();

        function activate() {
            listenStateLoading();
            $state.go("app.mppmgr.table");
        }

        function selectedItemChange(item) {
            vm.teamLayer = item;
        }

        function querySearchLayer(query) {
            var defer = $q.defer();
            var search = angular.lowercase(query);
            var request = Orgchart.query({
                action: "viewdataorgchart",
                search: search,
            });
            request.$promise.then(function (res) {
                defer.resolve(res);
            });
            request.$promise.catch(function (err) {
                defer.reject([]);
            });
            return defer.promise;
        }

        function loaTableMpp() {
            $rootScope.$broadcast("PARENT::MPP_TABLE_LOAD_TABLE", {
                teamLayer: vm.teamLayer,
                year: vm.year,
                depth: vm.layer,
            });
        }

        function listenStateLoading() {
            $rootScope.$on("CHILD::MPP_TABLE_IS_LOADING", function (e, data) {
                console.log("CHILD::MPP_TABLE_IS_LOADING", data);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.mpp-report-hc", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mpp_report_hc", {
            url: "/mpp/report/hc",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp-report-hc/mpp-report-hc.html",
                    controller: "MppReportHeadcountController as vm"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.mpp-report-hc')
        .controller('MppReportHeadcountController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$scope',
        'Auth',
        '$location',
        '$window',
        'config'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $scope,
        Auth,
        $location,
        $window,
        config
    ) {
        var vm = this;
        var MppReport = new AppAPI.MppReportHC();
        var d = new Date();
        vm.years = [2018, 2019, 2020];
        vm.year = d.getFullYear() + 1;
        vm.count = 0;
        vm.getDataReport = getDataReport;
        vm.getDataLayers = getDataLayers;
        vm.showFilter = true;
        vm.printPDF = printPDF;
        vm.layers = [];
        vm.layer = {
            id: 0,
            description: 'ALL'
        };
        vm.listReport = [];
        vm.companies = [];
        vm.company = {};
        vm.searchTerm = '';
        vm.clearSearch = clearSearch;
        vm.printExcel = printExcel;
        vm.totalCurrEmp = 0;
        vm.totalNextEmp = 0;
        vm.totalNextEmpInternal = 0;
        vm.totalNextEmpExternal = 0;
        vm.totalNextEmpMutation = 0;
        vm.totalNextEmpTermination = 0;
        vm.totalPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        vm.totalRightBottom = 0;

        vm.empType = [
            {
                name: 'ALL',
                value: 'all'
            },
            {
                name: 'STAFF',
                value: 'SAP'
            },
            {
                name: 'GENERAL WORKER',
                value: 'HRIS'
            }
        ];

        vm.selectedEmpType = 'all';

        activate();

        function activate() {
            getDataCompanies();
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function getDataReport() {
            angular.element('#tableMpp').block();
            var response = MppReport.query({
                action: 'getDataReport',
                years: vm.year,
                layerID: vm.layer.id,
                empType: vm.selectedEmpType
            });
            response.$promise.then(fetchResponseDataReport);
            response.$promise.catch(catchResponseDataReport);
        }

        function fetchResponseDataReport(data) {
            vm.listReport = data;
            $localStorage.reportHC = data;
            setTotal(data);
            angular.element('#tableMpp').unblock();
        }

        function catchResponseDataReport(params) {
            vm.listReport = [];
            angular.element('#tableMpp').unblock();
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-hc', {
                obj: {
                    years: vm.year,
                    list: vm.listReport
                }
            });
        }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            '://' +
                            host +
                            '/' +
                            config.api +
                            'api/mppreporthc/exportData/' +
                            vm.layer.id +
                            '/' +
                            vm.year +
                            '/' +
                            vm.selectedEmpType +
                            '/' +
                            data.token,
                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }

        function getDataCompanies() {
            var response = MppReport.query({
                action: 'getListCompany'
            });
            response.$promise.then(fetchResponseCompanies);
            response.$promise.catch(catchResponseCompanies);
        }

        function fetchResponseCompanies(response) {
            vm.companies = response;
        }

        function catchResponseCompanies(response) {
            vm.companies = [];
        }

        function getDataLayers() {
            var response = MppReport.query({
                action: 'getListLayer',
                years: vm.year,
                company: vm.company.id
            });
            response.$promise.then(fetchResponseLayers);
            response.$promise.catch(catchResponseLayers);
        }

        function fetchResponseLayers(response) {
            var plain = response;
            vm.layers = plain.reverse();
        }

        function catchResponseLayers(response) {
            vm.layers = [];
        }

        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        $scope.$on('$destroy', function() {
            delete $localStorage.reportHC;
        });

        function setTotal(data) {
            var ctr = data.length;
            vm.totalCurrEmp = 0;
            vm.totalNextEmp = 0;
            vm.totalNextEmpInternal = 0;
            vm.totalNextEmpExternal = 0;
            vm.totalNextEmpMutation = 0;
            vm.totalNextEmpTermination = 0;
            vm.totalPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            vm.totalRightBottom = 0;
            for (var i = 0; i < ctr; i++) {
                vm.totalCurrEmp += Number(data[i].curr.total);
                vm.totalNextEmp += Number(data[i].next.total);
                vm.totalNextEmpInternal += Number(data[i].next.internal);
                vm.totalNextEmpExternal += Number(data[i].next.external);
                vm.totalNextEmpMutation += Number(data[i].next.mutation);
                vm.totalNextEmpTermination += Number(data[i].next.termination);
                for (var j = 0; j < data[i].next.listPerMonth.length; j++) {
                    vm.totalPerMonth[j] += Number(data[i].next.listPerMonth[j]);
                }
                vm.totalRightBottom += data[i].totalRightPerRow;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.mpp-report-cost-budget", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mpp_report_cost_budget", {
            url: "/mpp/report/cost/budget",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp-report-cost-budget/mpp-report-cost-budget.html",
                    controller: "MppReportCostBudgetController as vm"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.mpp-report-cost-budget')
        .controller('MppReportCostBudgetController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$mdDialog',
        '$scope',
        '$location',
        'Auth',
        '$window',
        'config'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $mdDialog,
        $scope,
        $location,
        Auth,
        $window,
        config
    ) {
        var vm = this;
        var MppReportCost = new AppAPI.MppReportCostBudget();
        var d = new Date();
        vm.years = [2018, 2019, 2020];
        vm.year = d.getFullYear() + 1;
        vm.count = 0;
        vm.costCenter = {
            id: 'all',
            description: 'ALL'
        };
        vm.searchTerm = '';
        vm.listCostCenter = [];
        vm.listReport = [];
        vm.showFilter = true;
        vm.getDataReport = getDataReport;
        vm.getDataCostCenter = getDataCostCenter;
        vm.getDataLayers = getDataLayers;
        vm.printPDF = printPDF;
        vm.layers = [];
        vm.layer = {
            id: 0,
            description: 'ALL'
        };
        vm.companies = [];
        vm.company = {};
        vm.clearSearch = clearSearch;
        vm.printExcel = printExcel;
        // vm.showDetail = showDetail;

        vm.empType = [
            {
                name: 'ALL',
                value: 'all'
            },
            {
                name: 'STAFF',
                value: 'SAP'
            },
            {
                name: 'GENERAL WORKER',
                value: 'HRIS'
            }
        ];

        vm.selectedEmpType = 'all';

        activate();

        function activate() {
            getDataCompanies();
        }

        function getDataReport() {
            angular.element('#costReport').block();
            var response = MppReportCost.query({
                action: 'getDataReport',
                years: vm.year,
                company: vm.company.id,
                costCenter: vm.costCenter.id,
                layerID: vm.layer.id,
                empType: vm.selectedEmpType
            });
            response.$promise.then(fetchResponseDataReport);
            response.$promise.catch(catchResponseDataReport);
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-cost', {
                obj: {
                    years: vm.year,
                    list: vm.listReport
                }
            });
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function fetchResponseDataReport(data) {
            vm.listReport = data;
            $localStorage.reportCost = data;
            console.log(vm.listReport);
            angular.element('#costReport').unblock();
        }

        function catchResponseDataReport(params) {
            angular.element('#costReport').unblock();
            vm.listReport = [];
        }

        function getDataCostCenter() {
            var response = MppReportCost.query({
                action: 'getListCostCenter',
                years: vm.year,
                company: vm.company.id
            });
            response.$promise.then(fetchResponseCostCenter);
            response.$promise.catch(catchResponseCostCenter);
        }

        function fetchResponseCostCenter(response) {
            vm.listCostCenter = response;
        }

        function catchResponseCostCenter() {
            vm.listCostCenter = [];
        }

        function getDataLayers() {
            var response = MppReportCost.query({
                action: 'getListLayer',
                years: vm.year,
                company: vm.company.id
            });
            response.$promise.then(fetchResponseLayers);
            response.$promise.catch(catchResponseLayers);
        }

        function fetchResponseLayers(response) {
            var plain = response;
            vm.layers = plain.reverse();
        }

        function catchResponseLayers(response) {
            vm.layers = [];
        }

        function getDataCompanies() {
            var response = MppReportCost.query({
                action: 'getListCompany'
            });
            response.$promise.then(fetchResponseCompanies);
            response.$promise.catch(catchResponseCompanies);
        }

        function fetchResponseCompanies(response) {
            vm.companies = response;
        }

        function catchResponseCompanies(response) {
            vm.companies = [];
        }

        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        // function showDetail(ev) {
        //     $mdDialog
        //         .show({
        //             controller: "MppReportCostUserDetailController",
        //             controllerAs: "vm",
        //             templateUrl: "app/main/mpp/report/cost/detail/detail.html",
        //             parent: angular.element(document.body),
        //             targetEvent: ev,
        //             clickOutsideToClose: true,
        //             fullscreen: true,
        //             locals: {
        //                 years: vm.year,
        //                 layerID: vm.layer.id,
        //                 costCenter: vm.costCenter.id,
        //                 company: vm.company.id
        //             }
        //         });
        // }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            '://' +
                            host +
                            '/' +
                            config.api +
                            'api/mppreportcost/exportData/' +
                            vm.year +
                            '/' +
                            vm.costCenter.id +
                            '/' +
                            vm.layer.id +
                            '/' +
                            vm.company.id +
                            '/' +
                            vm.selectedEmpType +
                            '/' +
                            data.token,
                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }

        $scope.$on('$destroy', function() {
            delete $localStorage.reportCost;
        });
    }
})();

(function() {
    "use strict";

    angular.module("app.mpp-report-cost", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mpp_report_cost", {
            url: "/mpp/report/cost",
            views: {
                "content@app": {
                    templateUrl:
                        "app/main/mpp-report-cost/mpp-report-cost.html",
                    controller: "MppReportCostController as vm"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.mpp-report-cost')
        .controller('MppReportCostController', Controller);

    Controller.$inject = [
        '$state',
        'AppAPI',
        '$element',
        '$localStorage',
        '$mdDialog',
        '$scope',
        '$location',
        'Auth',
        '$window',
        'config'
    ];

    /* @ngInject */
    function Controller(
        $state,
        AppAPI,
        $element,
        $localStorage,
        $mdDialog,
        $scope,
        $location,
        Auth,
        $window,
        config
    ) {
        var vm = this;
        var MppReportCost = new AppAPI.MppReportCost();
        var d = new Date();
        vm.years = [2018, 2019, 2020];
        vm.year = d.getFullYear() + 1;
        vm.count = 0;
        vm.costCenter = {
            id: 'all',
            description: 'ALL'
        };
        vm.searchTerm = '';
        vm.listCostCenter = [];
        vm.listReport = [];
        vm.showFilter = true;
        vm.getDataReport = getDataReport;
        vm.getDataCostCenter = getDataCostCenter;
        vm.getDataLayers = getDataLayers;
        vm.printPDF = printPDF;
        vm.layers = [];
        vm.layer = {
            id: 0,
            description: 'ALL'
        };
        vm.companies = [];
        vm.company = {};
        vm.clearSearch = clearSearch;
        vm.showDetail = showDetail;
        vm.printExcel = printExcel;

        vm.empType = [
            {
                name: 'ALL',
                value: 'all'
            },
            {
                name: 'STAFF',
                value: 'SAP'
            },
            {
                name: 'GENERAL WORKER',
                value: 'HRIS'
            }
        ];

        vm.selectedEmpType = 'all';

        activate();

        function activate() {
            getDataCompanies();
        }

        function getDataReport() {
            angular.element('#costReport').block();
            var response = MppReportCost.query({
                action: 'getDataReport',
                years: vm.year,
                company: vm.company.id,
                costCenter: vm.costCenter.id,
                layerID: vm.layer.id,
                empType: vm.selectedEmpType
            });
            response.$promise.then(fetchResponseDataReport);
            response.$promise.catch(catchResponseDataReport);
        }

        function printPDF() {
            $state.goNewTab('app.report.mpp-cost', {
                obj: {
                    years: vm.year,
                    list: vm.listReport
                }
            });
        }

        function clearSearch() {
            vm.searchTerm = '';
        }

        function fetchResponseDataReport(data) {
            vm.listReport = data;
            $localStorage.reportCost = data;
            console.log(vm.listReport);
            angular.element('#costReport').unblock();
        }

        function catchResponseDataReport(params) {
            angular.element('#costReport').unblock();
            vm.listReport = [];
        }

        function getDataCostCenter() {
            var response = MppReportCost.query({
                action: 'getListCostCenter',
                years: vm.year,
                company: vm.company.id
            });
            response.$promise.then(fetchResponseCostCenter);
            response.$promise.catch(catchResponseCostCenter);
        }

        function fetchResponseCostCenter(response) {
            vm.listCostCenter = response;
        }

        function catchResponseCostCenter() {
            vm.listCostCenter = [];
        }

        function getDataLayers() {
            var response = MppReportCost.query({
                action: 'getListLayer',
                years: vm.year,
                company: vm.company.id
            });
            response.$promise.then(fetchResponseLayers);
            response.$promise.catch(catchResponseLayers);
        }

        function fetchResponseLayers(response) {
            var plain = response;
            vm.layers = plain.reverse();
        }

        function catchResponseLayers(response) {
            vm.layers = [];
        }

        function getDataCompanies() {
            var response = MppReportCost.query({
                action: 'getListCompany'
            });
            response.$promise.then(fetchResponseCompanies);
            response.$promise.catch(catchResponseCompanies);
        }

        function fetchResponseCompanies(response) {
            vm.companies = response;
        }

        function catchResponseCompanies(response) {
            vm.companies = [];
        }

        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function showDetail(ev) {
            $mdDialog.show({
                controller: 'MppReportCostUserDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/mpp/report/cost/detail/detail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    years: vm.year,
                    layerID: vm.layer.id,
                    costCenter: vm.costCenter.id,
                    company: vm.company.id,
                    empType: vm.selectedEmpType
                }
            });
        }

        function printExcel() {
            var token = Auth.setTokenPromise();
            token.then(
                function(data) {
                    var protocol = $location.protocol();
                    var host = $location.host();
                    $window.open(
                        protocol +
                            '://' +
                            host +
                            '/' +
                            config.api +
                            'api/mppreportcost/exportData/' +
                            vm.year +
                            '/' +
                            vm.costCenter.id +
                            '/' +
                            vm.layer.id +
                            '/' +
                            vm.company.id +
                            '/' +
                            vm.selectedEmpType +
                            '/' +
                            data.token,
                        '_blank'
                    );
                },
                function() {
                    $window.alert('gagal load token');
                }
            );
        }

        $scope.$on('$destroy', function() {
            delete $localStorage.reportCost;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mpp')
        .service('mppService', mppService);

    function mppService($rootScope) {

        var date = new Date();
        var years = date.getFullYear() + 1;
        var layer = 1;
        var maxDepth = 1;
        var teamLayer = 0;
        var toggleService = false;
        var toggleMonthVal = false;
        var togglePayment = false;
        var toggleCurrent = true;
        var toggleFuture = true;
        var toggleStatus = true;
        var toggleActual = true;
        var toggleAction = true;
        var toggleTotalPerMonth = false;
        var toggleMoneyShow = false;
        var approvalStatus = '-';
        var lastLevelOpened = 1;


        function reset() {
            date = new Date();
            years = date.getFullYear() + 1;
            layer = 1;
            maxDepth = 1;
            teamLayer = 0;
            toggleService = false;
            toggleMonthVal = false;
            togglePayment = false;
            toggleCurrent = true;
            toggleFuture = true;
            toggleStatus = true;
            toggleActual = true;
            toggleAction = true;
            toggleTotalPerMonth = false;
            toggleMoneyShow = false;
            approvalStatus = '-';
        }


        function setLayer(no) {
            layer = no;
        }

        function getLayer() {
            return layer;
        }

        function setLastLevelOpened(num) {
            lastLevelOpened = num;
        }

        function getLastLevelOpened() {
            return lastLevelOpened;
        }

        function setApprovalStatus(status) {
            approvalStatus = status;
            $rootScope.$broadcast('statusUpdated', status);
        }

        function setTeamLayer(team) {
            teamLayer = team;
        }

        function getTeamLayer() {
            return teamLayer;
        }

        function getApprovalStatus() {
            return approvalStatus;
        }

        function getToggleMoneyShow() {
            return toggleMoneyShow;
        }

        function setToggleMoneyShow(status) {
            toggleMoneyShow = status;
        }

        function setToggleTotalPerMonth(status) {
            toggleTotalPerMonth = status;
        }

        function getToggleTotalPerMonth() {
            return toggleTotalPerMonth;
        }

        function setToggleAction(act) {
            toggleAction = act;
        }

        function getToggleAction(act) {
            return toggleAction;
        }

        function setToggleCurrent(curr) {
            toggleCurrent = curr;
        }

        function getToggleCurrent() {
            return toggleCurrent;
        }

        function setToggleFuture(val) {
            toggleFuture = val;
        }

        function getToggleFuture() {
            return toggleFuture;
        }

        function setToggleStatus(val) {
            toggleStatus = val;
        }

        function getToggleStatus() {
            return toggleStatus;
        }

        function setToggleActual(val) {
            toggleActual = val;
        }

        function getToggleActual() {
            return toggleActual;
        }


        function setMaxDepth(depth) {
            maxDepth = depth;
        }

        function getMaxDepth() {
            return maxDepth;
        }

        function getTogglePayment() {
            return togglePayment;
        }

        function setTogglePayment(pay) {
            togglePayment = pay;
        }

        function setYears(year) {
            years = year;
        }

        function getYears() {
            return years;
        }

        function setToggleService(toggle) {
            toggleService = toggle;
        }

        function getToggleService() {
            return toggleService;
        }

        function setToggleMonth(toggle) {
            toggleMonthVal = toggle;
        }

        function getToggleMonth() {
            return toggleMonthVal;
        }

        return {
            setYears: setYears,
            setLayer: setLayer,
            setMaxDepth: setMaxDepth,
            getMaxDepth: getMaxDepth,
            getApprovalStatus: getApprovalStatus,
            getTogglePayment: getTogglePayment,
            getToggleService: getToggleService,
            getToggleMonth: getToggleMonth,
            getToggleFuture: getToggleFuture,
            getToggleActual: getToggleActual,
            getToggleCurrent: getToggleCurrent,
            getToggleStatus: getToggleStatus,
            getToggleAction: getToggleAction,
            getToggleTotalPerMonth: getToggleTotalPerMonth,
            getToggleMoneyShow: getToggleMoneyShow,
            getYears: getYears,
            getTeamLayer: getTeamLayer,
            getLayer: getLayer,
            setToggleService: setToggleService,
            setToggleMonth: setToggleMonth,
            setTogglePayment: setTogglePayment,
            setToggleActual: setToggleActual,
            setToggleCurrent: setToggleCurrent,
            setToggleFuture: setToggleFuture,
            setToggleStatus: setToggleStatus,
            setToggleAction: setToggleAction,
            setToggleTotalPerMonth: setToggleTotalPerMonth,
            setToggleMoneyShow: setToggleMoneyShow,
            setApprovalStatus: setApprovalStatus,
            setTeamLayer: setTeamLayer,
            reset: reset
        }

    }

})();

(function () {
  'use strict';

  angular
    .module('app.mpp')
    .directive('mppDynamic', mppDynamic);

  function mppDynamic($window, $document) {

    var directive = {
      restrict: 'A',
      link: link,
      scope: {
        toggle: '@'
      }
    };

    return directive;

    /** @ngInject */

    function link(scope, element, attrs) {
      var w = angular.element($window);
      var mppToolbarArea = angular.element(document.body.querySelector('#mppToolbarArea'));
      var toolbar = angular.element(document.body.querySelector('#toolbar'));
      var elOrgTable = angular.element(element[0]);
      var elOrgTablePayment = angular.element(element[0].querySelector('#orgTablePayment'));
      var elOrgTableContent = angular.element(element[0].querySelector('#orgTableContent'));

      scope.getWindowsHeight = function () {
        return w.outerHeight();
      }

      scope.$watch(scope.getWindowsHeight, function (newVal) {
        var baseHeight = (newVal - toolbar.outerHeight()) - mppToolbarArea.outerHeight();
        elOrgTable.css('height', baseHeight);
        elOrgTableContent.css('height', baseHeight);
      }, true);


      attrs.$observe('toggle', function (status) {
        var baseHeight = element[0].clientHeight - mppToolbarArea.outerHeight();
        if (status === 'true') {
          elOrgTablePayment.css('height', baseHeight * (50 / 100));
          elOrgTableContent.css('height', baseHeight - (baseHeight * (50 / 100)));
        } else {
          elOrgTableContent.css('height', baseHeight);
        }
      });

      w.bind('resize', function () {
        scope.$apply();
      });

    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.mpp')
        .controller('MppController', MppController);


    MppController.$inject = [
        'AppAPI',
        '$state',
        '$localStorage',
        'mppService',
        '$scope',
        '$rootScope',
        '$mdToast',
        'Auth',
        '$mdDialog'
    ];

    /* @ngInject */
    function MppController(
        AppAPI,
        $state,
        $localStorage,
        mppService,
        $scope,
        $rootScope,
        $mdToast,
        Auth,
        $mdDialog
    ) {
        var vm = this;
        var d = new Date();
        var Mpp = new AppAPI.Mpp();
        var MppApproval = new AppAPI.MppApproval();
        vm.listTeamLayer = [];
        vm.teamLayer = {
            'id': 0,
            'description': 'all'
        };
        vm.listLayer = [1, 2, 3, 4, 5];
        vm.listYear = [2018, 2019, 2020, 2021];
        vm.year = mppService.getYears();
        vm.layer = 1;
        vm.gotoStructure = gotoStructure;
        vm.gotoTable = gotoTable;
        vm.gotoCompareChart = gotoCompareChart;
        vm.setFilter = setFilter;
        vm.filterCost = false;
        vm.filterMonth = false;
        vm.filterPayment = false;
        vm.filterCurrent = true;
        vm.filterFuture = true;
        vm.filterStatus = true;
        vm.filterActual = true;
        vm.filterAction = true;
        vm.filterTotalPerMonth = false;
        vm.disableFilter = false;
        vm.showUpload = showUpload;
        vm.showLegend = showLegend;
        vm.switchToMoney = switchToMoney;
        vm.showReset = showReset;
        vm.approvalStatus = mppService.getApprovalStatus();
        vm.showApprovalStatus = false;
        vm.isCanSubmitMpp = isCanSubmitMpp;
        vm.back = false;
        vm.state = $state;
        vm.selectedMppType = {
            'type': 'myPlan',
            'text': 'MyPlan'
        };
        vm.showCostFilter = false;

        vm.showSubmit = showSubmit;
        vm.gotoExportPDF = gotoExportPDF;

        activate();


        $scope.$watch('vm.year', function (newval) {
            viewListLayer();
            mppService.setYears(newval);
        });

        $scope.$watch('vm.layer', function (newVal) {
            mppService.setTeamLayer(vm.teamLayer.id);
            mppService.setLayer(newVal);
            $rootScope.$broadcast('years_updated', newVal);
        })


        $scope.$watch(function () {
            return $state.$current.name
        }, function (newval) {
            if (newval == 'app.mpp_main.orgtable') {
                vm.disableFilter = false;
                vm.showApprovalStatus = true;
            } else {
                vm.disableFilter = true;
                vm.showApprovalStatus = false;
            }
        });


        function activate() {
            viewListLayer();
            isCanSubmitMpp();
            checkGroup();
        }

        function checkGroup() {
            var valid = Mpp.get({
                action: 'getUserGroup'
            });

            valid.$promise.then(function (response) {
                if (response.status === 1) {
                    vm.showCostFilter = true;
                } else {
                    vm.showCostFilter = false;
                }
            });

            valid.$promise.catch(function () {
                vm.showCostFilter = false;
            })
        }

        function switchToMoney() {
            $rootScope.$broadcast('switch_money', vm.switchMoney);
            vm.switchMoney = !vm.switchMoney;
        }

        function viewListLayer() {
            var response = Mpp.query({
                action: 'viewListLayerTeam',
                year: vm.year
            });
            response.$promise.then(fetchListLayer);
            response.$promise.catch(errorFetchLayer);
        }

        $scope.$on('statusUpdated', function (e, data) {
            vm.approvalStatus = data;
        });

        function setFilter(no) {
            mppService.setTogglePayment(vm.filterPayment);
            mppService.setToggleService(vm.filterCost);
            mppService.setToggleTotalPerMonth(vm.filterTotalPerMonth);
            mppService.setToggleMonth(vm.filterMonth);
            mppService.setToggleCurrent(vm.filterCurrent);
            mppService.setToggleFuture(vm.filterFuture);
            mppService.setToggleStatus(vm.filterStatus);
            mppService.setToggleActual(vm.filterActual);
            mppService.setToggleAction(vm.filterAction);
            $rootScope.$broadcast('filter_updated');
        }

        function gotoExportPDF() {
            $state.go('app.report.mpp', {
                obj: {
                    'years': mppService.getYears(),
                    'teamLayer': vm.teamLayer.description
                }
            })
        }

        function fetchListLayer(data) {
            if (data.length === 0) {
                vm.listTeamLayer = [];
                vm.listTeamLayer.push({
                    'id': 0,
                    'description': 'Data Not Found'
                });
                vm.teamLayer = vm.listTeamLayer[0];
            } else {
                vm.listTeamLayer = data;
                vm.listTeamLayer.push({
                    'id': 0,
                    'description': 'ALL'
                });
                vm.teamLayer = vm.listTeamLayer[vm.listTeamLayer.length - 1];
            }
            console.log(data);
        }

        function errorFetchLayer() {
            vm.listTeamLayer = [];
        }

        function gotoStructure() {
            vm.filterPayment = false;
            mppService.setTogglePayment(vm.filterPayment);
            vm.disableFilter = true;
            var data = {
                'layer': vm.layer,
                'year': vm.year,
                'idTeamLayer': vm.teamLayer.id
            }
            $state.go('app.mpp_main.orgchart', {
                obj: data
            });
        }


        function gotoCompareChart() {
            vm.filterPayment = false;
            mppService.setTogglePayment(vm.filterPayment);
            vm.disableFilter = true;
            var data = {
                'layer': vm.layer,
                'year': vm.year,
                'idTeamLayer': vm.teamLayer.id
            }
            $state.go('app.mpp_main.compare-chart', {
                obj: data
            });
        }


        function gotoTable() {
            vm.layer = 1;
            vm.disableFilter = false;
            var data = {
                'layer': vm.layer,
                'year': vm.year,
                'idTeamLayer': vm.teamLayer.id,
                'flag': 1
            }
            $state.go('app.mpp_main.orgtable', {
                obj: data
            });
        }

        function showUpload(ev) {
            $rootScope.$broadcast('upload_mpp', ev);
        }

        function showLegend() {
            $mdToast.show({
                hideDelay: 99999999,
                position: 'bottom right',
                controller: 'OrgLegendController',
                controllerAs: 'vm',
                bindToController: true,
                templateUrl: 'app/main/mpp/orglegend/orglegend.html'
            });
        }


        function showReset(e) {
            var response = Auth.setToken();
            response.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Reset MPP ?')
                    .textContent('Would you like to reset MPP ' + vm.year + ' ?')
                    .ariaLabel('delete structure')
                    .targetEvent(e)
                    .ok('Yes')
                    .cancel('No');

                var verify = $mdDialog.confirm()
                    .title('Verify answer')
                    .textContent('Your action cannot be recover, are you sure ?')
                    .ariaLabel('Reset MPP')
                    .targetEvent(e)
                    .ok('Yes')
                    .cancel('Cancel');

                $mdDialog.show(confirm).then(function () {
                    $mdDialog.show(verify).then(function () {
                        resetMpp();
                    })
                });
            });
        }

        function showSubmit(e) {
            var response = Auth.setToken();
            response.then(function () {
                var confirm = $mdDialog.confirm()
                    .title('Submit MPP ?')
                    .textContent('Would you like to submit MPP ' + vm.year + ' ?')
                    .ariaLabel('Submit Mpp')
                    .targetEvent(e)
                    .ok('Yes')
                    .cancel('No');

                $mdDialog.show(confirm).then(function () {
                    submitMpp();
                });
            });
        }

        function submitMpp() {
            var response = Mpp.save({
                action: 'submitMpp',
                year: vm.year
            });
            response.$promise.then(successSubmit);
            response.$promise.catch(failedSubmit);
        }

        function resetMpp() {
            var response = Mpp.save({
                action: 'resetMpp',
                year: vm.year
            });
            response.$promise.then(successReset);
            response.$promise.catch(failedReset);
        }

        function successSubmit(e) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert Submit Data')
                .textContent('Success Submit Data')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
            ).then(function () {
                $state.reload();
            });
        }

        function failedSubmit(e) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert Submit Data')
                .textContent('Failed Submit Data')
                .ariaLabel('MPP alert')
                .ok('OK')
                .targetEvent(e)
            ).then(function () {
                $state.reload();
            });
        }


        function successReset(e) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert Delete Data')
                .textContent('Success Reset Data')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
            ).then(function () {
                $state.reload();
            });
        }

        function failedReset(e) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('MPP Alert Reset Data')
                .textContent('Failed Reset Data')
                .ariaLabel('MPP alert')
                .ok('Got it!')
                .targetEvent(e)
            ).then(function () {
                $state.reload();
            });
        }

        $scope.$watch('vm.year', function (newval) {
            mppService.setYears(newval);
            viewListLayer();
        });

        function isCanSubmitMpp() {
            var response = MppApproval.get({
                action: 'isCanSubmitMpp',
                year: vm.year
            });

            response.$promise.then(function (data) {
                console.log(data);
                vm.isCanSubmitMpp = data.isDisabledSubmit;
            });

            response.$promise.catch(function (err) {
                vm.isCanSubmitMpp = false;
            });
        }

        $scope.$on('$destroy', function () {
            mppService.reset();
        })


    }

})();

(function () {
    "use strict";

    angular
        .module("app.login")
        .controller("TokenloginController", EmploginController);

    EmploginController.$inject = [
        "$state"
    ];

    /** @ngInject */
    function EmploginController(
        $state
    ) {
       
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.login')
        .controller('SetPasswordController', SetPasswordController);

     SetPasswordController.$inject=['$state','$resource','$mdDialog','Auth','AppAPI','config','GeneralService','$localStorage','$timeout','Form'];   

    /** @ngInject */
    function SetPasswordController($state,$resource,$mdDialog,Auth,AppAPI,config,GeneralService,$localStorage,$timeout,Form)
    {
        var vm = this;
        
         vm.username=$localStorage.user;
         // initial form
         Form.initialForm();

         var Password=  AppAPI.Password();

         // set constructor form
         Form.setObject(Password);

         // set form to controller
         vm.Form = Form;

        vm.saveDataPass=saveDataPass;

        vm.clearMeesage=clearMeesage;

        function saveDataPass(ev,formController) {

            Form.objForm.username=vm.username;
            if(Form.objForm.password==Form.objForm.confirm_password){
                  angular.element.blockUI();
                     var response=Form.saveData('save', formController, Password);
                     response.then(function(){
                         vm.messageTheme='blue';
                          showDialogPass(ev);
                           angular.element.unblockUI();
                     });

            }else{
                $mdDialog.show(
                $mdDialog.alert()
                .textContent('Password Not Match!')
                 .ok('OK')
                 );  
            }

        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
            

        function closeDialogPass()
     {
        $mdDialog.hide();
        logout();
     }

     function showDialogPass(ev) {
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Success Save Password')
            .textContent('Process Set Password was Success. Please login again')
            .ariaLabel('Success Save Password')
            .ok('OK')
            .targetEvent(ev)
        ).then(function(){
            closeDialogPass();
        });
    }

    function logout()
        {
            angular.element.blockUI();
            
                     var Logout=AppAPI.Logout();
                     var objLogout= new Logout();

                     var promise=objLogout.$logout();
                          promise.then(function(rdata){
                            var resultNum=parseInt(rdata.status);
                            if(resultNum===1)
                            {
                                  GeneralService.clearStorage();
                             // $location.path('/');
                              $state.go('app.login.emplogin');
                              angular.element.unblockUI();
                            }else
                            {
                              $window.alert('failed proses logout');
                              angular.element.unblockUI();
                            }
                          },function(){
                             $window.alert('failed proses logout');
                              angular.element.unblockUI();
                          });
        }
       
        
    }
})();
(function () {
    "use strict";

    angular
        .module("app.login")
        .controller("MainloginController", MainloginController);

    MainloginController.$inject = ["LoginService", "$state"];

    /** @ngInject */
    function MainloginController(LoginService, $state) {
        LoginService.stateLogin = "main";
    }
})();

(function() {
    'use strict';

    angular
        .module('app.login')
        .service('LoginService', LoginService);

    /* @ngInject */
    function LoginService() {
        this.stateLogin = 'main';
    }
})();
(function () {
    "use strict";

    angular.module("app.login").controller("LoginController", LoginController);

    LoginController.$inject = ["LoginService", "AppAPI"];

    /** @ngInject */
    function LoginController(LoginService, AppAPI) {
        var vm = this;
        vm.LoginService = LoginService;
        var backgroundImage = AppAPI.LoginBackground();
        var vm = this;
        vm.LoginService = LoginService;
        var backgroundImage = new AppAPI.LoginBackground();
        var promise = backgroundImage.get();
        promise.$promise.then(setBackground);
        promise.$promise.catch(failedBackground);

        function setBackground(data) {
            console.log(data.background);
            vm.sideStyle = {
                // 'background': data.background,
                background: 'url("' + data.background + '")',
                "background-repeat": "no-repeat",
                "background-color": "#fff",
                "background-size": "cover",
                "background-position": "center",
            };
        }

        function failedBackground(data) {
            vm.sideStyle = {
                // 'background': data.background,
                background: 'url("/assets/images/backgrounds/january_1.jpg")',
                "background-repeat": "no-repeat",
                "background-color": "#fff",
                "background-size": "cover",
                "background-position": "center",
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.login")
        .controller("EmploginController", EmploginController);

    EmploginController.$inject = [
        "$state",
        "$resource",
        "$mdDialog",
        "Auth",
        "AppAPI",
        "config",
        "GeneralService",
        "msNavigationService",
        "LoginService",
        "Newsinfo",
        "Approvalinfo",
        "Newslist",
        "Insurancealert",
        "Claimalert",
        "Contractalert",
        "$timeout",
        "$localStorage",
    ];

    /** @ngInject */
    function EmploginController(
        $state,
        $resource,
        $mdDialog,
        Auth,
        AppAPI,
        config,
        GeneralService,
        msNavigationService,
        LoginService,
        Newsinfo,
        Approvalinfo,
        Newslist,
        Insurancealert,
        Claimalert,
        Contractalert,
        $timeout,
        $localStorage
    ) {
        var vm = this;
        var news = AppAPI.News();
        var EmpSurvey = AppAPI.EmpSurvey();
        var reminder = AppAPI.Reminder();
        var response = Auth.setCookie();
        response.then(Auth.setToken);
        var User = AppAPI.Login();
        vm.user = new User();
        vm.wrongCredentials = false;
        vm.login = login;
        vm.event = null;
        vm.loginEcheckIn = loginEcheckIn;
        vm.loginEcheckInGw = loginEcheckInGw;
        LoginService.stateLogin = "Employee";
        vm.showDisclaimer = showDisclaimer;

        ////////////////

        function login(ev) {
            angular.element.blockUI();
            vm.event = ev;
            vm.user.appID = config.appID;
            var promise = vm.user.$save();
            promise.then(SuccessLogin, FailedLogin);
        }

        function SuccessLogin(data) {
            vm.wrongCredentials = false;
            GeneralService.setStorage(data);
            vm.group = data.group;
            var objMenu = angular.fromJson(data.menu1);
            var jumMenu = objMenu.length,
                i = 0;
            for (i; i < jumMenu; i++) {
                    msNavigationService.saveItem(objMenu[i].menuname, {
                    title    : objMenu[i].title,
                    icon     : objMenu[i].icon,
                    group    :(objMenu[i].group=='0')?false:true,
                    state    : objMenu[i].state,
                     weight   : objMenu[i].level
                });
                objMenu[i].options.weight = parseInt(objMenu[i].options.weight);
                msNavigationService.saveItem(
                    objMenu[i].menuname,
                    objMenu[i].options
                );
            }

           // checkSurvey();

            switch (vm.group) {
                case "1":
                    $state.go("app.app_dashboard");
                    break;
                case "99":
                    $state.go("app.login.setpassword");
                    break;
                case "2":
                case "6":
                case "7":
                case "8":
                    $state.go("app.app_dashboard");
                    break;
                case "3":
                    $state.go("app.app_dashboard");
                    break;
                default:
                    // $state.go('app.pms_dashboard');
                    $state.go("app.app_dashboard");

                    setTimeout(function () {
                        reminder.query({ action: "getReminderOnboarding" });
                    }, 6000);
            }

            if (vm.group != 99) {
                setTimeout(function () {
                    var response = news.query({ action: "viewNewsDetail" });
                    response.$promise.then(fetchNewsDetail);
                    response.$promise.catch(errorFetchNewsDetail);
                }, 3000);
            }

            angular.element.unblockUI();
        }

        function FailedLogin(rdata) {
            vm.wrongCredentials = true;
            vm.pesan = rdata.data.pesan;
            angular.element.unblockUI();
            Auth.setToken();
            $mdDialog.show(
                $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector("#login")))
                    .clickOutsideToClose(true)
                    .title("Error Login")
                    .textContent(vm.pesan)
                    .ariaLabel("Error Login")
                    .ok("Got it!")
                    .targetEvent(vm.event)
            );
        }

        function loginEcheckIn(ev) {
            $mdDialog
                .show({
                    controller: "CheckinloginCtrl",
                    controllerAs: "vm",
                    templateUrl: "app/main/login/echeckin/echeckin.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true, // Only for -xs, -sm breakpoints.
                })
                .then(
                    function (answer) {},
                    function () {}
                );
        }

        function loginEcheckInGw(ev) {
            $mdDialog
                .show({
                    controller: "CheckingwloginCtrl",
                    controllerAs: "vm",
                    templateUrl: "app/main/login/echeckingw/echeckingw.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true, // Only for -xs, -sm breakpoints.
                })
                .then(
                    function (answer) {},
                    function () {}
                );
        }

        // Methods
        function countUnReadNews() {
            var response = news.get({ action: "getCountUnReadNews" });
            response.$promise.then(fetchUnreadNews);
            response.$promise.catch(errorFetchNewsCategory);
        }

        function fetchUnreadNews(data) {
            Newsinfo.getInfoNews = data;
        }

        function errorFetchNewsCategory() {
            Newsinfo.getInfoNews = {};
        }

        function fetchNewsDetail(data) {
            if (data.length > 0) {
                if (data[0].doc_path != null) {
                    $mdDialog.show({
                        controller: "NewsTabController",
                        controllerAs: "vm",
                        templateUrl:
                            "app/quick-panel/tabs/news/news-view-doc.html",
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            countUnReadNews();
                            infoApproval();
                            loadDataNewsCategory();
                        },
                        locals: {
                            data: data[0],
                        },
                    });
                } else {
                    $mdDialog.show({
                        controller: "NewsTabController",
                        controllerAs: "vm",
                        templateUrl:
                            "app/quick-panel/tabs/news/news-detail.html",
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            countUnReadNews();
                            infoApproval();
                            loadDataNewsCategory();
                        },
                        locals: {
                            data: data[0],
                        },
                    });
                }
            }
        }

        function errorFetchNewsDetail() {}

        function infoApproval() {
            var ListApproval = AppAPI.InfoApproval();
            var lsApproval = new ListApproval();
            var promise = lsApproval.$get({ action: "viewData" });
            promise.then(processInfo);
            promise.catch(errorProcessInfo);
        }

        function processInfo(data) {
            // vm.data=data;
            GeneralService.setInfoApproval(data);
            Approvalinfo.getInfoApproval = data;
            // console.log(vm.data);
        }

        function errorProcessInfo() {
            // vm.data=[];
            Approvalinfo.getInfoApproval = {};
        }

        // Methods
        function loadDataNewsCategory() {
            var response = news.query({ action: "viewNewsList" });
            response.$promise.then(fetchNewsCategory);
            response.$promise.catch(errorFetchNewsCategory);
        }

        function fetchNewsCategory(data) {
            Newslist.getListNews = data;
        }

        function errorFetchNewsCategory() {
            Newslist.getListNews = [];
        }

        function infoInsurance() {
            var ListInsurance = AppAPI.InfoApproval();
            var lsInsurance = new ListInsurance();
            var promise = lsInsurance.$get({ action: "infoInsurance" });
            promise.then(infoInsuranceSucess);
            promise.catch(infoInsuranceFailed);
        }

        function infoInsuranceSucess(data) {
            GeneralService.setInfoInsurance(data);
            Insurancealert.infoInsurance = data;
        }

        function infoInsuranceFailed() {
            Insurancealert.infoInsurance = {};
        }

        function infoClaim() {
            var ListClaim = AppAPI.InfoApproval();
            var lsClaim = new ListClaim();
            var promise = lsClaim.$get({ action: "infoClaim" });
            promise.then(infoClaimSucess);
            promise.catch(infoClaimFailed);
        }

        function infoClaimSucess(data) {
            GeneralService.setInfoClaim(data);
            Claimalert.infoClaim = data;
        }

        function infoClaimFailed() {
            Claimalert.infoClaim = {};
        }

        function infoContract() {
            var contract = AppAPI.Employe();
            var contractInfo = new contract();
            var resp = contractInfo.$get({ action: "infoContract" });
            resp.then(infoSucess);
            resp.catch(infoFailed);
        }

        function infoSucess(data) {
            GeneralService.setInfoContract(data);
            Contractalert.infoContract = data.data;
        }

        function infoFailed() {
            Contractalert.infoContract = {};
        }

        function checkSurvey() {
            angular.element.blockUI();
            var promises = EmpSurvey.query({
                action: "getActiveSurvey",
                nik: $localStorage.user,
            });
            promises.$promise.then(function (data) {
                angular.element.unblockUI();
                if (typeof data[0] !== "undefined") {
                    loadDataSurvey();
                }
            });
            promises.$promise.catch(function () {
                angular.element.unblockUI();
            });
        }
        function loadDataSurvey() {
            angular.element.blockUI();
            var promises = EmpSurvey.query({ action: "get_profile" });
            promises.$promise.then(function (data) {
                if (typeof data[0] !== "undefined") {
                    vm.profile = data;

                    loadSurveyData();
                }
            });
            promises.$promise.catch(function () {
                angular.element.unblockUI();
            });
        }

        function loadSurveyData() {
            angular.element.blockUI();
            var promises = EmpSurvey.query({
                action: "get_employee_surveys",
                nik: $localStorage.user,
            });
            promises.$promise.then(function (data) {
                vm.surveys = data;

                if (data.length > 0) {
                    vm.surveys = data;
                    $localStorage.isSurvey = 1;
                } else {
                    $localStorage.isSurvey = 0;

                    vm.showDisclaimer();
                }

                angular.element.unblockUI();
            });
            promises.$promise.catch(errorSurveyFetch);
        }

        function errorSurveyFetch() {
            vm.score = {};
            angular.element.unblockUI();
        }

        function showDisclaimer() {
            $mdDialog
                .show({
                    controller: DialogController,
                    controllerAs: "vm",
                    templateUrl:
                        "app/main/emp-survey/emp-survey-from-login.html",
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: true,
                    locals: {
                        language: vm.language,
                        languageList: vm.languageList,
                    },
                })
                .then(
                    function (isConfirm) {
                        if (isConfirm) {
                            vm.isConfirmDisclaimer = true;
                            vm.showinfoStatusDisclaimer = true;

                            $timeout(function () {
                                loadStatementsData();
                            }, 500);
                        } else {
                            vm.showinfoStatusDisclaimer = true;
                        }
                    },
                    function () {
                        vm.isConfirmDisclaimer = false;
                        vm.showinfoStatusDisclaimer = true;
                    }
                );
        }

        function loadStatementsData() {
            angular.element(".ms-form-wizard").block();

            var dataPromise = EmpSurvey.query({
                action: "get_statements",
                nik: $localStorage.user,
            });
            dataPromise.$promise.then(fetchStatementsData);
            dataPromise.$promise.catch(errorStatementsFetch);
        }

        function fetchStatementsData(data) {
            vm.listInput = data;

            vm.totalResult = 0;
            angular.forEach(vm.listInput, function (obj) {
                vm.totalResult += obj.result;
            });
            // angular.element.unblockUI();
            angular.element(".ms-form-wizard").unblock();
        }

        function errorStatementsFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function DialogController($scope, language, languageList, $mdDialog) {
            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.language = language;
            vm.language = $scope.language;

            $scope.languageList = languageList;

            $scope.confirmDisclaimer = function (confirm) {
                if (confirm) {
                    $mdDialog.hide(confirm);
                    $state.go("app.emp_survey_from_login");
                } else {
                    $mdDialog.hide();
                }
            };
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.lock_transaction', ['app.lock_transaction.input-lock-transaction'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.lock_transaction', {
                url    : '/lock-transaction',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/lock-transaction/lock-transaction.html',
                        controller : 'LockTransactionController as vm'
                    }
                }
            });

       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.lock_transaction')
        .controller('LockTransactionController', LockTransactionController) 


    LockTransactionController.$inject=['DataService','$state','$mdDialog','$mdToast','$localStorage','$window','AppAPI','Auth','Form','$timeout','$stateParams'];
    /** @ngInject */
    function LockTransactionController(DataService,$state,$mdDialog,$mdToast,$localStorage,$window,AppAPI,Auth,Form,$timeout,$stateParams)
    {

        var vm= this;
        var Locktransaction= AppAPI.Locktransaction();
        
        loadData();
        ////////////////

        function loadData() {
           angular.element.blockUI();
           var promises = Locktransaction.query({action:'viewData'});
           promises.$promise.then(fetchData);
           promises.$promise.catch(errorFetchData); 
        }

        function fetchData(data) {
            vm.listData=data;
            angular.element.unblockUI();
        }

        function errorFetchData() { 
            vm.listData=[];    
            angular.element.unblockUI();
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.lock-setting', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.lock-setting', {
                url: '/lock-setting',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/lock-setting/lock-setting.html',
                        controller: 'LockSettingController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.lock-setting')
    .controller('LockSettingController', LockSettingController);

  LockSettingController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    'AppAPI',
    '$filter',
    'Form'
  ];
  /** @ngInject */
  function LockSettingController(
    $document,
    DataService,
    $mdDialog,
    AppAPI,
    $filter,
    Form
  ) {
    var vm = this;
    var endPoint = AppAPI.LockSetting();
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.dialogClose = dialogClose;
    vm.stateEdit = false;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData'
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'LockSettingEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/lock-setting/lock-setting-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.lock-setting')
    .controller('LockSettingEditController', LockSettingEditController);

  LockSettingEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$filter'
  ];
  /** @ngInject */
  function LockSettingEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.LockSetting();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.type = data.type;
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.lock_date = new Date(data.lock_date);
      vm.Form.objForm.lock_time = data.lock_time;
      vm.Form.objForm.period = data.period;
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();
(function () {
    'use strict';
    angular
        .module('app.job_evaluation', [
            'app.job_evaluation.form_job_evaluation'
        ])
        .config(config)

    config.$inject = ['$stateProvider', '$mdThemingProvider'];

    function config($stateProvider, $mdThemingProvider) {

        $stateProvider
            .state('app.job_evaluation', {
                url: '/job-evaluation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/job-evaluation/list-job-evaluation.html',
                        controller: 'JobEvaluationController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.job_evaluation_verified', {
                url: '/job-evaluation-verified',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/job-evaluation/approval-job-evaluation.html',
                        controller: 'JobEvaluationVerifiedController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.job_evaluation_approval', {
                url: '/job-evaluation-approval',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/job-evaluation/approval-job-evaluation.html',
                        controller: 'JobEvaluationApprovalController as vm'
                    }
                }
            });

    }
})();

(function () {
    'use strict'

    angular
        .module('app.job_evaluation')
        .controller('JobEvaluationController', JobEvaluationController);

    JobEvaluationController.$inject = ['DataService', '$window', '$state', '$location', '$localStorage', 'AppAPI', 'config', 'Auth'];

    function JobEvaluationController(DataService, $window, $state, $location, $localStorage, AppAPI, config, Auth) {
        var vm = this;
        var JobEvaluation = AppAPI.jobEvaluation();
        var Assessment = AppAPI.Assessment();
        vm.DataTable = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.viewDetail = viewDetail;
        vm.edit = edit;
        vm.data = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.deleteList = deleteList;
        vm.ExportToExcel = ExportToExcel;

        loadData(1);
        loadDataBU();

        function loadData(pageno) {
            vm.DataTable.loadData(JobEvaluation, pageno, {
                action: 'viewdata',
                bu: vm.bu,
                evaluatedDate: vm.dateEval
            });
            angular.element.unblockUI();
        }

        function loadDataBU() {
            var response = Assessment.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBu = data;
        }

        function errorFetchBU() {
            vm.listBu = [];
            angular.element.unblockUI();
        }

        function viewDetail(id) {
            $state.go('app.job_evaluation_view', {
                id: id
            });
        }

        function edit(id) {
            $state.go('app.job_evaluation_input', {
                id: id
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;

                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = [];
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function deleteList(ev) {
            console.log(vm.listSelected);

            /* $mdDialog.show({
                controller: 'DeactiveController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insurance/endorsment/deactive.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                locals: {
                    data: vm.listSelected
                }
            }); */
        }

        function ExportToExcel() {
            var token = Auth.setTokenPromise();
            token.then(function (data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.api + 'api/jobevaluation/exportexcel/' + data.token, '_blank');
            }, function () {

                $window.alert('gagal load token');
            });
        }

    }
})();

(function () {
    'use strict'

    angular
        .module('app.job_evaluation')
        .controller('JobEvaluationVerifiedController', JobEvaluationVerifiedController);

    JobEvaluationVerifiedController.$inject = ['DataService', '$mdDialog', '$window', '$state', '$localStorage', 'AppAPI', 'Auth'];

    function JobEvaluationVerifiedController(DataService, $mdDialog, $window, $state, $localStorage, AppAPI, Auth) {
        var vm = this;
        var JobEvaluation = AppAPI.jobEvaluation();
        var Assessment = AppAPI.Assessment();
        vm.DataTable = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.viewDetail = viewDetail;
        vm.edit = edit;
        vm.data = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.approveList = approveList;
        vm.rejectList = rejectList;
        vm.listSelected = [];

        loadData(1);
        loadDataBU();

        function loadData(pageno) {
            vm.DataTable.loadData(JobEvaluation, pageno, {
                action: 'viewdataverification',
                approved: $localStorage.user
            });
            angular.element.unblockUI();
        }

        function loadDataBU() {
            var response = Assessment.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBu = data;
        }

        function errorFetchBU() {
            vm.listBu = [];
            angular.element.unblockUI();
        }

        function viewDetail(id) {
            $state.go('app.job_evaluation_view', {
                id: id
            });
        }

        function edit(id) {
            $state.go('app.job_evaluation_input', {
                id: id
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;

                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = [];
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function approveList(ev) {
            var jum = vm.listSelected.length;
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var jobEvaluation = new JobEvaluation();
                        jobEvaluation.data = vm.listSelected;
                        jobEvaluation.action = 'approve';

                        var response = jobEvaluation.$save();
                        //var response=tm.$delete({action:'approve'});
                        response.then(function () {
                            loadData();
                            vm.listOtselected = [];
                            $window.alert('Success approved');
                        });
                        response.catch(function () {
                            $window.alert('Failed approved');
                            vm.listOtselected = [];
                            angular.element.unblockUI();
                        });
                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention!')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function rejectList(ev) {
            var jum = vm.listOtselected.length,
                i, ids = [];
            if (jum > 0) {
                $mdDialog.show({
                    controller: 'AbnormaltRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/cb/abnormal-approval/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        loadData();
                        vm.listOtselected = [];
                    },
                    locals: {
                        id: vm.listOtselected
                    }
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention!')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }

        }

    }
})();

(function () {
    'use strict'

    angular
        .module('app.job_evaluation')
        .controller('JobEvaluationApprovalController', JobEvaluationApprovalController);

    JobEvaluationApprovalController.$inject = ['DataService', '$mdDialog', '$window', '$state', '$localStorage', 'AppAPI', 'Auth'];

    function JobEvaluationApprovalController(DataService, $mdDialog, $window, $state, $localStorage, AppAPI, Auth) {
        var vm = this;
        var JobEvaluation = AppAPI.jobEvaluation();
        var Assessment = AppAPI.Assessment();
        vm.DataTable = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.viewDetail = viewDetail;
        vm.edit = edit;
        vm.data = [];
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.approveList = approveList;
        vm.rejectList = rejectList;
        vm.listSelected = [];

        loadData(1);
        loadDataBU();

        function loadData(pageno) {
            vm.DataTable.loadData(JobEvaluation, pageno, {
                action: 'viewdataapproval',
                approved: $localStorage.user
            });
            angular.element.unblockUI();
        }

        function loadDataBU() {
            var response = Assessment.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBu = data;
        }

        function errorFetchBU() {
            vm.listBu = [];
            angular.element.unblockUI();
        }

        function viewDetail(id) {
            $state.go('app.job_evaluation_view', {
                id: id
            });
        }

        function edit(id) {
            $state.go('app.job_evaluation_input', {
                id: id
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;

                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = [];
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function approveList(ev) {
            var jum = vm.listSelected.length;
            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        angular.element.blockUI();
                        var jobEvaluation = new JobEvaluation();
                        jobEvaluation.data = vm.listSelected;
                        jobEvaluation.action = 'approve';

                        var response = jobEvaluation.$save();
                        //var response=tm.$delete({action:'approve'});
                        response.then(function () {
                            loadData();
                            vm.listOtselected = [];
                            $window.alert('Success approved');
                        });
                        response.catch(function () {
                            $window.alert('Failed approved');
                            vm.listOtselected = [];
                            angular.element.unblockUI();
                        });
                    }, function () {
                        // $scope.status = 'You decided to keep your debt.';
                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention!')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }
        }

        function rejectList(ev) {
            var jum = vm.listOtselected.length,
                i, ids = [];
            if (jum > 0) {
                $mdDialog.show({
                    controller: 'AbnormaltRejectCommentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/cb/abnormal-approval/comment-reject.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        loadData();
                        vm.listOtselected = [];
                    },
                    locals: {
                        id: vm.listOtselected
                    }
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Attention!')
                    .textContent('No data selected')
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
                ).then(function () {
                    loadData();
                });
            }

        }

    }
})();

(function(){
  'use strict';

  angular.module('app.insurance',['app.insurance.insurance-plan', 'app.insurance.insurance-type', 'app.insurance.emp-insurance', 'app.insurance.emp-claim', 'app.insurance.endorsment'] )
    .config(config);
  config.$inject = ['$stateProvider'];
  /** @ngInject **/

  function config($stateProvider) {
    // State progres claim admin
    $stateProvider
      .state('app.insurance_modules',{
        url : '/insurance',
        views : {
          'content@app' : {
            templateUrl: 'app/main/insurance/insurance.html',
            controller : 'InsuranceController as vm'
          },
        }
      });

    // State progres claim employe
    $stateProvider
      .state('app.insurance-employe_modules',{
        url : '/insurance-employe',
        views : {
          'content@app' : {
            templateUrl: 'app/main/insurance/insurance-employe.html',
            controller : 'InsuranceEmployeController as vm'
          },
        }
      })
      
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.insurance')
        .controller('ListDetailController', ListDetailController);

    /** @ngInject */
    function ListDetailController($mdDialog,data){
    	var vm = this;
    	vm.data = data;
    	vm.closeModal = closeModal;

    	function closeModal(){
    		$mdDialog.cancel();
    	}
    }
})();
(function(){
	'use strict';

	angular 
		.module("app.insurance")
		.controller('InsuranceController', InsuranceController);

		InsuranceController.$inject=['$state', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService'];

		function InsuranceController($state, $log, $mdDialog, AppAPI, Auth, DataService) {
			var vm = this;
			vm.listJum = [2,5,25,50,75,100,200];
			vm.listStatus = ['DIBAYAR', 'DALAM_ANALISA', 'PROSES_ULANG', 'TOLAK'];
			vm.DataTable = new DataService();
			vm.loadData = loadData;

			vm.showDetail = showDetail;

			vm.loadDataDivision=loadDataDivision;
			vm.loadDataDepartment=loadDataDepartment;

			
			var Insurance=AppAPI.Insurance();

			loadData(1);
			loadDataBU();
			loadDataDivision(vm.company);
			loadDataDepartment(vm.divisi);

      function loadData(pageno) {      
      	vm.DataTable.loadData(Insurance, pageno,{
					action:'viewdata', 
					start_date:vm.start_date, 
					end_date:vm.end_date, 
					nik:vm.nik,
					company:vm.company,
					divisi:vm.divisi,
					status: vm.status_klaim,
					department:vm.department
				});
      }


      function showDetail(data, ev){
  	    $mdDialog.show({
          controller         : 'ListDetailController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/insurance/listDetail.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise){

          },
          locals:{
          	data:data
          }
        }); 
      }


      // load bu
      function loadDataBU(){
      	var response = Insurance.query({action:'viewBU'});
      	response.$promise.then(fetchBU);
      	response.$promise.catch(errorFetchBU);
      }

	    function fetchBU(data) {
	      vm.listBU=data;
	    }

	    function errorFetchBU() {
	      vm.listBU=[];
	    }


			// load division
		  function loadDataDivision(idbu) {
	      var response=Insurance.query({action:'viewDivisiBu',idbu:idbu});
	      response.$promise.then(fetchDivisiBU);
	      response.$promise.catch(errorDivisiBU);
	    }

	    function fetchDivisiBU(data) {
	     vm.listDivision=data;
	    }

	    function errorDivisiBU() {
	      vm.listDivision=[];
	    }

	    // load department
	    function loadDataDepartment(iddivisi) {
	      var response=Insurance.query({action:'viewDivisiDept',idbu:vm.company,iddivisi:iddivisi});
	      response.$promise.then(fetchDepartment);
	      response.$promise.catch(errorDepartment);
	    }

	    function fetchDepartment(data) {
	      vm.listDepartment=data;
	    }

	    function errorDepartment() {
	      vm.listDepartment=[];
	    }


		}
})();
(function(){
	'use strict';

	angular 
		.module("app.insurance")
		.controller('InsuranceProgressController', InsuranceProgressController);

		InsuranceProgressController.$inject=['$state', '$log', '$mdDialog', '$stateParams', '$window', 'AppAPI', 'Auth', 'DataService'];

		function InsuranceProgressController($state, $log, $mdDialog, $stateParams, $window, AppAPI, Auth, DataService) {
			var vm = this;
			vm.listJum = [2,5,25,50,75,100,200];
			vm.DataTable = new DataService();
			vm.loadData = loadData;
			vm.showDetail = showDetail;
			vm.back = back;

			var nik = $stateParams.nik;
			var regNo = $stateParams.regNo;
			var registerDate = $stateParams.registerDate;

			/*var nik = "15000204";
			var regNo = "1682a";
			var registerDate = "2018-01-24";*/
			
			var Insurance=AppAPI.Insurance();

			loadData(1);

      function loadData(pageno) {      
      	vm.DataTable.loadData(Insurance, pageno,{
					action:'viewProgress', 
					registerDate:registerDate,
					nik:nik,	
					regNo:regNo
				});
      }

      function showDetail(data, ev){
  	    $mdDialog.show({
          controller         : 'ListDetailController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/insurance/listDetail.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise){

          },
          locals:{
          	data:data
          }
        }); 
      }

      function back() {
        $window.history.back();
      }

		}
})();
(function(){
	'use strict';

	angular 
		.module("app.insurance")
		.controller('InsuranceEmployeController', InsuranceEmployeController);

		InsuranceEmployeController.$inject=['$state', '$log', '$mdDialog', 'AppAPI', 'Auth', 'DataService', '$localStorage'];

		function InsuranceEmployeController($state, $log, $mdDialog, AppAPI, Auth, DataService, $localStorage) {
			var vm = this;
			vm.nik = $localStorage.user;
			vm.listJum = [2,5,25,50,75,100,200];
			vm.DataTable = new DataService();
			vm.loadData = loadData;

			vm.showDetail = showDetail;
			
			var Insurance=AppAPI.Insurance();

			loadData(1);

      function loadData(pageno) {      
      	vm.DataTable.loadData(Insurance, pageno,{
					action:'viewdata', 
					start_date:vm.start_date, 
					end_date:vm.end_date, 
					nik:vm.nik,
				});
      }

      function showDetail(data, ev){
  	    $mdDialog.show({
          controller         : 'ListDetailController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/insurance/listDetailEmploye.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise){

          },
          locals:{
          	data:data
          }
        }); 
      }





		}
})();
(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.insentif-upload-master-cb', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.insentif-upload-master-cb', {
        url: '/insentif-upload-master-cb',
        views: {
          'content@app': {
            templateUrl: 'app/main/insentif-upload-master-cb/insentif-upload-master-cb.html',
            controller: 'InsentifUploadMasterCbController as vm'
          }
        }
      });
  }
}());
(function () {
  'use strict';
  angular
    .module('app.insentif-upload-master-cb')
    .controller('UploadInsentifUploadMasterCbController', UploadInsentifUploadMasterCbController);

  UploadInsentifUploadMasterCbController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadInsentifUploadMasterCbController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.upload = upload
    vm.detailInfo = []

    function upload(form) {
      angular.element.blockUI();
      var resp = vm.FileUpload.uploadAll();
    }

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/insentifuploadmastercb/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifuploadmastercb/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-barcode-bsr/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
    'use strict';

    angular
        .module('app.insentif-upload-master-cb')
        .controller('InsentifUploadMasterCbController', InsentifUploadMasterCbController);

    InsentifUploadMasterCbController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function InsentifUploadMasterCbController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var $translate = $filter('translate');

        Form.initialForm();

        var endPoint = AppAPI.InsentifUploadMasterCb();
        var kpiSales = AppAPI.InsentifKpiSetting();

        Form.setObject(endPoint);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.arr_area = [];
        vm.selected = [];
        vm.openUpload = openUpload;
        vm.deleteData = deleteData;

        function deleteData(ev) {
            var message = $translate('PAYROLL.MESSAGE.CONFDEL');
            var note = $translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = $translate('PAYROLL.MESSAGE.YES');
            var no = $translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(
                    function () {
                        var data = [];
                        for (var index = 0; index < vm.selected.length; index++) {
                            data.push(vm.selected[index].id);
                        }
                        angular.element.blockUI();
                        var response = endPoint.delete({
                            action: 'delete',
                            data: angular.toJson(data)
                        });
                        response.$promise.then(function (resp) {
                            dialogClose();
                            angular.element.unblockUI();
                            showDialogInfo(ev, resp);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialogInfo(ev, data) {
            vm.selected = [];
            var message = $translate(data.pesan);
            var status = $translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadData(pageno) {
            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                salesCode: vm.ref_sales_code_id,
                productCode: vm.ref_master_product_id
            });
        }

        getSalesCode();
        function getSalesCode() {
            var response = endPoint.query({ action: 'getSalesCode' });
            response.$promise.then(fetchSalesCode);
            response.$promise.catch(errorFetchSalesCode);
        }

        function fetchSalesCode(data) {
            vm.listSalesCode = data;
        }

        function errorFetchSalesCode() {
            vm.listSalesCode = [];
        }

        getProductCode();
        function getProductCode() {
            var response = endPoint.query({ action: 'getProductCode' });
            response.$promise.then(fetchProductCode);
            response.$promise.catch(errorFetchProductCode);
        }

        function fetchProductCode(data) {
            vm.listProductCode = data;
        }

        function errorFetchProductCode() {
            vm.listProductCode = [];
        }

        loadPeriod()
        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                vm.selected = [];
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.selected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.selected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadInsentifUploadMasterCbController as vm',
                templateUrl: 'app/main/insentif-upload-master-cb/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.insentif-transfer', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.insentif_transfer', {
                url    : '/insentif-transfer',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/insentif-transfer/insentiftransfer.html',
                    controller : 'InsentiftransferController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.insentif-transfer')
        .controller('InsentiftransferController', InsentiftransferController);

    InsentiftransferController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function InsentiftransferController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window, $element) {
       
       var vm = this;
       var endPoint=AppAPI.Insentiftransfer();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExporttoExcel = ExporttoExcel;

       vm.company       = $localStorage.empsite;
       vm.loadDivision  = loadDivision;
       vm.LoadRegional  = loadRegional;
       vm.LoadCabang    = loadCabang;
       vm.LoadWilayah   = loadWilayah;

       vm.reqWil    = false;
       vm.reqArea   = true;

       LoadPeriod();
       LoadSubPeriod();
       LoadCompany()
       loadWilayah();
       LoadAreaDefault(vm.company);

       function LoadAreaDefault(company) 
        {
            var response=endPoint.query({action:'getArea', companyid:company});
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

       function fetchAreaDefault(data) {
            vm.listarea=data;
       }

       function errorFetchAreaDefault() {
            vm.listarea=[];
       }

      function LoadPeriod() 
      {
          var response=endPoint.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 
      
       function LoadSubPeriod() 
      {
          var response=endPoint.query({action:'getSubPeriod'});
          response.$promise.then(fetchSubPeriod);
          response.$promise.catch(errorFetchSubPeriod);
       }

       function fetchSubPeriod(data) {
            vm.listsubperiod=data;
       }

       function errorFetchSubPeriod() {
            vm.listsubperiod=[];
       } 

       function LoadCompany() {
          var response=endPoint.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

        function LoadArea(company,cabangid) 
        {
            loadDivision(company);
            loadWilayah();
            var response=endPoint.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadDivision(company) {
          var response=endPoint.query({action:'getDivision', companyid:company});
          response.$promise.then(fetchDivision);
          response.$promise.catch(errorFetchDivision);
       }

       function fetchDivision(data) {
            vm.listDivision=data;
       }

       function errorFetchDivision() {
            vm.listDivision=[];
       }  
       
       function loadWilayah() {
          var response=endPoint.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=endPoint.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=endPoint.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  
       
       function ExporttoExcel(form) 
       {    
            var subPeriod   = encodeURIComponent(window.btoa(vm.subperiod));
            var token       = Auth.setTokenPromise();
            var period      = encodeURIComponent(window.btoa(vm.period));
            var company     = encodeURIComponent(window.btoa(vm.company));
            var area        = encodeURIComponent(window.btoa(vm.area));
            var division    = encodeURIComponent(window.btoa(vm.division));
            var wilayah     = encodeURIComponent(window.btoa(vm.wilayah));
            var regional    = encodeURIComponent(window.btoa(vm.regional));
            var cabang      = encodeURIComponent(window.btoa(vm.cabang));
            var action      = encodeURIComponent(window.btoa('downloadReport'));
            
            token.then(function(data) 
            {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/insentiftransfer/lgexportexcel/' + period + '/' + company  + '/' + area + '/' + division + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + subPeriod + '/' +  data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-target-absolute', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-target-absolute', {
                url: '/insentif-target-absolute',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-target-absolute/insentif-target-absolute.html',
                        controller: 'InsentifTargetAbsoluteController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-target-absolute')
        .controller('viewDocInsentifTargetAbsolute', viewDocInsentifTargetAbsolute);

    viewDocInsentifTargetAbsolute.$inject = ['$http', '$mdDialog', 'config', 'img'];

    /* @ngInject */
    function viewDocInsentifTargetAbsolute($http, $mdDialog, config, img) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal() {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage() {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = config.api + 'api/upload/target-absolute/' + vm.doc + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            // console.log(link);
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/target-absolute/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Document Not Found')
                        .textContent('Document not Found')
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-target-absolute')
        .controller('viewInsentifTargetAbsoluteDetailController', viewInsentifTargetAbsoluteDetailController);

    viewInsentifTargetAbsoluteDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewInsentifTargetAbsoluteDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var endPoint = AppAPI.InsentifTargetAbsolute();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var penalty = AppAPI.InsentifPinalty();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];

        loadPeriod();

        loadDetail();

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.description = data[0].description;
            vm.Form.objForm.start_year = data[0].start_year;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.end_year = data[0].end_year;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_created_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.empno = data[0].surkom_created_by;

            vm.Form.objForm.listFocus = data[0].listFocus;
            var i;
            for (i = 0; i < data[0].listFocus.length; i++) {
                vm.Form.objForm.listFocus[i].amountFocus = parseFloat(vm.Form.objForm.listFocus[i].amountFocus);
            }
            vm.Form.objForm.listPrincipal = data[0].listPrincipal;
            var i;
            for (i = 0; i < data[0].listPrincipal.length; i++) {
                vm.Form.objForm.listPrincipal[i].roa = parseFloat(vm.Form.objForm.listPrincipal[i].roa);
                vm.Form.objForm.listPrincipal[i].ec = parseFloat(vm.Form.objForm.listPrincipal[i].ec);
            }
            //set targetAbsolute
            vm.Form.objForm.listTargetAbsolute = data[0].listTargetAbsolute;
            var i;
            for (i = 0; i < data[0].listTargetAbsolute.length; i++) {
                vm.Form.objForm.listTargetAbsolute[i].roa = parseFloat(vm.Form.objForm.listTargetAbsolute[i].roa);
                vm.Form.objForm.listTargetAbsolute[i].ec = parseFloat(vm.Form.objForm.listTargetAbsolute[i].ec);
            }
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        loadYear()
        function loadYear() {
            var response = penalty.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-target-absolute')
    .controller('InsentifTargetAbsoluteController', InsentifTargetAbsoluteController);

  InsentifTargetAbsoluteController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function InsentifTargetAbsoluteController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifTargetAbsolute();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.editData = editData;
    vm.copyData = copyData;
    vm.selectedItem = null;
    vm.searchText = null;

    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.downloadDoc = downloadDoc;
    vm.viewFile = viewFile;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.selectedItemChangedNo = selectedItemChangedNo;
    vm.getDataCode = getDataCode;

    vm.listStatus = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];


    activate();

    function activate() {
      vm.selected = [];
      loadData(1);

      loadSalesType();
      loadAbsoluteType();
      loadPrincipal();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.surkom_creator = '';
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined' && employee) {
        vm.surkom_creator = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;
      }
    }

    function getDataCode(searchText) {
      return $http
        .get(config.api + 'api/insentiftargetabsolute?action=searchSurkomNumber&id=' + searchText)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChangedNo(item) {
      vm.surkom_no = '';
      vm.Form.objForm.name = '';
      vm.Form.objForm.name = vm.searchStringSurkom;
      if (typeof item !== 'undefined' && item) {
        vm.surkom_no = item.id;
        vm.Form.objForm.name = item.name
      }
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        status: vm.status,
        surkom_date: vm.surkom_date,
        surkom_no: vm.surkom_no,
        surkom_creator: vm.surkom_creator,
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifTargetAbsoluteInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-target-absolute/insentif-target-absolute-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifTargetAbsoluteEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-target-absolute/insentif-target-absolute-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function copyData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifTargetAbsoluteCopyController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-target-absolute/insentif-target-absolute-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewInsentifTargetAbsoluteDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-target-absolute/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function loadSalesType() {
      var response = kpiSales.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function loadAbsoluteType() {
      var response = endPoint.query({ action: 'getAbsoluteType' });
      response.$promise.then(fetchAbsoluteType);
      response.$promise.catch(errorFetchAbsoluteType);
    }

    function fetchAbsoluteType(data) {
      vm.listAbsoluteType = data;
    }

    function errorFetchAbsoluteType() {
      vm.listAbsoluteType = [];
    }

    function loadPrincipal() {
      var response = endPoint.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.listprincipal = data;
    }

    function errorFetchPrincipal() {
      vm.listprincipal = [];
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();

            vm.objForm = new endPoint();
            vm.objForm.action = 'delete';
            vm.objForm.data = vm.selected;
            var response = vm.objForm.$save();

            response.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = $translate(expmess[0]) + ', ' + expmess[1] + ' ' + $translate(expmess[2]) + ' ' + expmess[3] + ' ' + $translate(expmess[4]);
      } else {
        var message = $translate(data.pesan);
      }

      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function downloadDoc(ev, filename) {
      var name = filename;
      if (name !== null && name !== '') {
        $http({
          method: 'GET',
          url: config.api + 'api/upload/target-absolute' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        }).success(function (data, status, headers) {
          headers = headers();
          var filename = name;
          var contentType = headers['content-type'];

          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], { type: contentType });
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
          } catch (ex) {
            console.log(ex);
          }
        }).error(function (data) {
          console.log(data);
        });
      } else {
        var message = $translate('HCTICKET.MESSAGE.FILENOTFOUND');
        var status = $translate('PAYROLL.MESSAGE.FAILED');

        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
        ).then(function () {
          // closeModal();
        });
      }
    }

    function viewFile(ev, img) {
      $mdDialog.show({
        controller: 'viewDocInsentifTargetAbsolute',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-target-absolute/view-doc.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        multiple: true,
        onRemoving: function (element, removePromise) {
          viewData();
        },
        locals: {
          img: img
        }
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-target-absolute')
    .controller('InsentifTargetAbsoluteInputController', InsentifTargetAbsoluteInputController);

  InsentifTargetAbsoluteInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$filter',
    'FileUploader',
    '$http',
    '$localStorage',
    '$element',
    'config'
  ];
  /** @ngInject */
  function InsentifTargetAbsoluteInputController(
    $mdDialog,
    AppAPI,
    Form,
    $filter,
    FileUploader,
    $http,
    $localStorage,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifTargetAbsolute();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var penalty = AppAPI.InsentifPinalty();
    var $translate = $filter('translate');

    vm.upload = upload;

    vm.selectedItem = null;
    vm.searchText = null;
    vm.edit = false;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.getSku = getSku;
    vm.fileSizeError = true;
    vm.showData = vm.showData2 = false;
    vm.company = $localStorage.empsite;
    vm.toggle = toggle;
    vm.exists = exists;
    vm.saveData = saveData;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.listStatus = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];

    activate();

    function activate() {
      vm.selected = [];
      loadSalesType();
      loadAbsoluteType();
      loadFocus();
      loadPrincipal();
      loadPeriod();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function loadSalesType() {
      var response = kpiSales.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    loadYear()
    function loadYear() {
      var response = penalty.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function loadAbsoluteType() {
      var response = endPoint.query({ action: 'getAbsoluteType', isFocus: 0 });
      response.$promise.then(fetchAbsoluteType);
      response.$promise.catch(errorFetchAbsoluteType);
    }

    function fetchAbsoluteType(data) {
      vm.Form.objForm.listTargetAbsolute = data;
      var i;
      for (i = 0; i < data.length; i++) {
        vm.Form.objForm.listTargetAbsolute[i].roa = parseFloat(data[i].roa);
        vm.Form.objForm.listTargetAbsolute[i].ec = parseFloat(data[i].ec);
      }
    }

    function errorFetchAbsoluteType() {
      vm.Form.objForm.listTargetAbsolute = [];
    }

    function loadFocus() {
      var response = endPoint.query({ action: 'getAbsoluteType', isFocus: 1 });
      response.$promise.then(fetchFocus);
      response.$promise.catch(errorFetchFocus);
    }

    function fetchFocus(data) {
      vm.Form.objForm.listFocus = data;
      var i;
      for (i = 0; i < data.length; i++) {
        vm.Form.objForm.listFocus[i].amountFocus = parseFloat(data[i].amountFocus);
      }
    }

    function errorFetchFocus() {
      vm.Form.objForm.listFocus = [];
    }

    function loadPrincipal() {
      var response = endPoint.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.Form.objForm.listPrincipal = data;
      var i;
      for (i = 0; i < data.length; i++) {
        vm.Form.objForm.listPrincipal[i].roa = parseFloat(vm.Form.objForm.listPrincipal[i].roa);
        vm.Form.objForm.listPrincipal[i].ec = parseFloat(vm.Form.objForm.listPrincipal[i].ec);
      }
    }

    function errorFetchPrincipal() {
      vm.Form.objForm.listPrincipal = [];
    }

    function selectedItemChanged(item) {
      console.log(item)
      vm.Form.objForm.nik1 = '';
      if (typeof item !== 'undefined' && item) {
        vm.showData = true;
      }
    }

    function getSku(searchText) {
      return $http
        .get(config.api + 'api/InsentifTargetAbsolute?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function upload(form) {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/insentiftargetabsolute/upload',
      removeAfterUpload: true,
      alias: 'fileName',
      onBeforeUploadItem: function (item) {
        var dt = new Date(item.formData[0].surkom_date);
        var listTargetAbsolute = JSON.stringify(item.formData[0].listTargetAbsolute);
        var listPrincipal = JSON.stringify(item.formData[0].listPrincipal);
        var listFocus = JSON.stringify(item.formData[0].listFocus);

        var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
        item.formData[0].surkom_date = newdate;
        item.formData[0].listTargetAbsolute = listTargetAbsolute;
        item.formData[0].listPrincipal = listPrincipal;
        item.formData[0].listFocus = listFocus;

        angular.element.blockUI();
      },
      onSuccessItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }, onErrorItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }
    });

    uploaderPhoto.filters.push({
      name: 'enforceMaxFileSize',
      fn: function (item) {
        vm.itemSize = formatBytes(item.size);
        if (item.size > 0) {
          vm.fileSizeError = false;
          return true;
        } else {
          vm.fileSizeError = true;
          return false;
        }
      }
    });

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function formatBytes(bytes) {
      if (bytes < 1024) return bytes + ' Bytes';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
      else return (bytes / 1073741824).toFixed(3) + ' GB';
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-target-absolute')
        .controller('InsentifTargetAbsoluteEditController', InsentifTargetAbsoluteEditController);

    InsentifTargetAbsoluteEditController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function InsentifTargetAbsoluteEditController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var $translate = $filter('translate');

        var endPoint = AppAPI.InsentifTargetAbsolute();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var penalty = AppAPI.InsentifPinalty();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.upload = upload
        vm.edit = true
        vm.fileSizeError = true;
        vm.company = $localStorage.empsite;

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        vm.saveData = saveData;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getEmployee = getEmployee;

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];

        loadPeriod();
        loadDetail();

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.id = data[0].id;
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.link_file = data[0].link_file;
            vm.Form.objForm.description = data[0].description;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.start_year = data[0].start_year;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.end_year = data[0].end_year;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_created_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.empnik = data[0].surkom_created_by;

            vm.Form.objForm.listFocus = data[0].listFocus;
            var i;
            for (i = 0; i < data[0].listFocus.length; i++) {
                vm.Form.objForm.listFocus[i].amountFocus = parseFloat(vm.Form.objForm.listFocus[i].amountFocus);
            }
            vm.Form.objForm.listPrincipal = data[0].listPrincipal;
            var i;
            for (i = 0; i < data[0].listPrincipal.length; i++) {
                vm.Form.objForm.listPrincipal[i].roa = parseFloat(vm.Form.objForm.listPrincipal[i].roa);
                vm.Form.objForm.listPrincipal[i].ec = parseFloat(vm.Form.objForm.listPrincipal[i].ec);
            }
            //set targetAbsolute
            vm.Form.objForm.listTargetAbsolute = data[0].listTargetAbsolute;
            var i;
            for (i = 0; i < data[0].listTargetAbsolute.length; i++) {
                vm.Form.objForm.listTargetAbsolute[i].roa = parseFloat(vm.Form.objForm.listTargetAbsolute[i].roa);
                vm.Form.objForm.listTargetAbsolute[i].ec = parseFloat(vm.Form.objForm.listTargetAbsolute[i].ec);
            }
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        loadYear()
        function loadYear() {
            var response = penalty.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();
            var response = Form.saveData('update', frm, endPoint);
            response.then(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var message = $translate(data.pesan);
            var status = $translate(data.status);

            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function upload(form) {
            var resp = vm.FileUploaderPhoto.uploadAll();
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/insentiftargetabsolute/upload',
            removeAfterUpload: true,
            alias: 'fileName',
            onBeforeUploadItem: function (item) {
                var dt = new Date(item.formData[0].surkom_date);
                var listTargetAbsolute = JSON.stringify(item.formData[0].listTargetAbsolute);
                var listPrincipal = JSON.stringify(item.formData[0].listPrincipal);
                var listFocus = JSON.stringify(item.formData[0].listFocus);

                var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                item.formData[0].surkom_date = newdate;
                item.formData[0].listTargetAbsolute = listTargetAbsolute;
                item.formData[0].listPrincipal = listPrincipal;
                item.formData[0].listFocus = listFocus;

                angular.element.blockUI();
            },
            onSuccessItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }, onErrorItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }
        });

        function formatBytes(bytes) {
            if (bytes < 1024) return bytes + ' Bytes';
            else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
            else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
            else return (bytes / 1073741824).toFixed(3) + ' GB';
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;

            if (typeof employee !== 'undefined' && employee) {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.empno = '';
                    }
                    return item.data;
                });
        }

        uploaderPhoto.filters.push({
            name: 'enforceMaxFileSize',
            fn: function (item) {
                vm.itemSize = formatBytes(item.size);
                if (item.size > 0) {
                    vm.fileSizeError = false;
                    return true;
                } else {
                    vm.fileSizeError = true;
                    return false;
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-target-absolute')
        .controller('InsentifTargetAbsoluteCopyController', InsentifTargetAbsoluteCopyController);

    InsentifTargetAbsoluteCopyController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function InsentifTargetAbsoluteCopyController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var $translate = $filter('translate');

        var endPoint = AppAPI.InsentifTargetAbsolute();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var penalty = AppAPI.InsentifPinalty();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.upload = upload
        vm.edit = true
        vm.fileSizeError = true;
        vm.company = $localStorage.empsite;

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        vm.saveData = saveData;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getEmployee = getEmployee;

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];

        loadPeriod();
        loadDetail();

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.listFocus = data[0].listFocus;
            vm.Form.objForm.status = data[0].status;
            var i;
            for (i = 0; i < data[0].listFocus.length; i++) {
                vm.Form.objForm.listFocus[i].amountFocus = parseFloat(vm.Form.objForm.listFocus[i].amountFocus);
            }
            vm.Form.objForm.listPrincipal = data[0].listPrincipal;
            var i;
            for (i = 0; i < data[0].listPrincipal.length; i++) {
                vm.Form.objForm.listPrincipal[i].roa = parseFloat(vm.Form.objForm.listPrincipal[i].roa);
                vm.Form.objForm.listPrincipal[i].ec = parseFloat(vm.Form.objForm.listPrincipal[i].ec);
            }
            //set targetAbsolute
            vm.Form.objForm.listTargetAbsolute = data[0].listTargetAbsolute;
            var i;
            for (i = 0; i < data[0].listTargetAbsolute.length; i++) {
                vm.Form.objForm.listTargetAbsolute[i].roa = parseFloat(vm.Form.objForm.listTargetAbsolute[i].roa);
                vm.Form.objForm.listTargetAbsolute[i].ec = parseFloat(vm.Form.objForm.listTargetAbsolute[i].ec);
            }
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        loadYear()
        function loadYear() {
            var response = penalty.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();
            var response = Form.saveData('save', frm, endPoint);
            response.then(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var message = $translate(data.pesan);
            var status = $translate(data.status);

            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function upload(form) {
            var resp = vm.FileUploaderPhoto.uploadAll();
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/insentiftargetabsolute/upload',
            removeAfterUpload: true,
            alias: 'fileName',
            onBeforeUploadItem: function (item) {
                var dt = new Date(item.formData[0].surkom_date);
                var listTargetAbsolute = JSON.stringify(item.formData[0].listTargetAbsolute);
                var listPrincipal = JSON.stringify(item.formData[0].listPrincipal);
                var listFocus = JSON.stringify(item.formData[0].listFocus);

                var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                item.formData[0].surkom_date = newdate;
                item.formData[0].listTargetAbsolute = listTargetAbsolute;
                item.formData[0].listPrincipal = listPrincipal;
                item.formData[0].listFocus = listFocus;

                angular.element.blockUI();
            },
            onSuccessItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }, onErrorItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }
        });

        function formatBytes(bytes) {
            if (bytes < 1024) return bytes + ' Bytes';
            else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
            else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
            else return (bytes / 1073741824).toFixed(3) + ' GB';
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;

            if (typeof employee !== 'undefined' && employee) {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.empno = '';
                    }
                    return item.data;
                });
        }

        uploaderPhoto.filters.push({
            name: 'enforceMaxFileSize',
            fn: function (item) {
                vm.itemSize = formatBytes(item.size);
                if (item.size > 0) {
                    vm.fileSizeError = false;
                    return true;
                } else {
                    vm.fileSizeError = true;
                    return false;
                }
            }
        });
    }
})();
(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.insentif-sku-focus-general', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.insentif-sku-focus-general', {
        url: '/insentif-sku-focus-general',
        views: {
          'content@app': {
            templateUrl: 'app/main/insentif-sku-focus-general/insentif-sku-focus-general.html',
            controller: 'InsentifSkuFocusGeneralController as vm'
          }
        }
      });
  }
}());
(function () {
    'use strict';

    angular
        .module('app.insentif-sku-focus-general')
        .controller('InsentifSkuFocusGeneralController', InsentifSkuFocusGeneralController);

    InsentifSkuFocusGeneralController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function InsentifSkuFocusGeneralController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var endPoint = AppAPI.InsentifSkuFocusGeneral();
        var refSalesCode = AppAPI.RefSalesCode();

        Form.setObject(endPoint);

        vm.Form = Form;
        vm.company = $localStorage.empsite;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputData = inputData;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.editData = editData;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getSku = getSku;

        function selectedItemChanged(item) {
            vm.productId = '';
            vm.Form.objForm.name = '';
            vm.isDisabled = false;
            vm.Form.objForm.name = vm.searchStringData;
            if (typeof item !== 'undefined' && item) {
                vm.productId = item.skuid;
                vm.Form.objForm.name = item.name
            }
        }

        function getSku(searchText) {
            return $http
                .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.ref_master_product_id = '';
                    }
                    return item.data;
                });
        }

        loadData();
        function loadData(pageno) {
            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                productId: vm.productId,
                start_date: vm.start_date,
                end_date: vm.end_date
            });
        }

        function inputData(ev) {
            $mdDialog.show({
                controller: 'InputInsentifSkuFocusGeneralController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-sku-focus-general/input-insentif-sku-focus-general.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editData(ev, data) {
            $mdDialog.show({
                controller: 'EditInsentifSkuFocusGeneralController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-sku-focus-general/input-insentif-sku-focus-general.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                vm.listSelected = [];
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.insentif-sku-focus-general')
    .controller('InputInsentifSkuFocusGeneralController', InputInsentifSkuFocusGeneralController);

  InputInsentifSkuFocusGeneralController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter', '$element'];

  /* @ngInject */
  function InputInsentifSkuFocusGeneralController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter, $element) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;

    Form.initialForm();

    var endPoint = AppAPI.InsentifSkuFocusGeneral();
    var refSalesCode = AppAPI.RefSalesCode();

    // set constructor form
    Form.setObject(endPoint);

    // set form to controller
    vm.Form = Form;

    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.saveData = saveData;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.selectedItemChangedUser = selectedItemChangedUser;
    vm.getEmployee = getEmployee;
    vm.getSku = getSku;

    vm.checkRoa = checkRoa
    vm.roa = false;
    function checkRoa(param) {
      if (typeof param != 'undefined' && param != 0) {
        vm.roa = true;
      } else {
        vm.roa = false;
      }
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChangedUser(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchStringUser;
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.ref_master_product_id = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined' && item) {
        vm.Form.objForm.ref_master_product_id = item.skuid;
        vm.Form.objForm.name = item.name
      }
    }

    function getSku(searchText) {
      return $http
        .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.ref_master_product_id = '';
          }
          return item.data;
        });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, endPoint);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    $scope.isDisabled = true;
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-sku-focus-general')
        .controller('EditInsentifSkuFocusGeneralController', EditInsentifSkuFocusGeneralController);

    EditInsentifSkuFocusGeneralController.$inject = ['$localStorage', 'data', '$mdDialog', 'Form', 'AppAPI', 'config', '$http', '$filter', '$element'];

    /* @ngInject */
    function EditInsentifSkuFocusGeneralController($localStorage, data, $mdDialog, Form, AppAPI, config, $http, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;
        vm.company = $localStorage.empsite;
        vm.isCb = false;

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.InsentifSkuFocusGeneral();
        var refSalesCode = AppAPI.RefSalesCode();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.saveData = saveData;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getSku = getSku;
        vm.selectedItemChangedUser = selectedItemChangedUser;
        vm.getEmployee = getEmployee;

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.empno = '';
                    }
                    return item.data;
                });
        }

        function selectedItemChangedUser(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchStringUser;
            if (typeof employee !== 'undefined' && employee) {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function selectedItemChanged(item) {
            vm.Form.objForm.ref_master_product_id = '';
            vm.Form.objForm.name = '';
            vm.isDisabled = false;
            vm.Form.objForm.name = vm.searchString;
            if (typeof item !== 'undefined' && item) {
                vm.Form.objForm.ref_master_product_id = item.skuid;
                vm.Form.objForm.name = item.name
            }
        }

        function getSku(searchText) {
            return $http
                .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.ref_master_product_id = '';
                    }
                    return item.data;
                });
        }

        vm.checkRoa = checkRoa
        vm.roa = false;
        function checkRoa(param) {
            if (typeof param != 'undefined' && param != 0) {
                vm.roa = true;
            } else {
                vm.roa = false;
            }
        }

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.surkom_no = data.surkom_no;
        if (data.surkom_date != '1970-01-01') {
            vm.Form.objForm.surkom_date = new Date(data.surkom_date);
        }
        vm.Form.objForm.roa = parseFloat(data.roa);
        vm.Form.objForm.nik = data.surkom_creator + ' - ' + data.surkom_creator_name;
        vm.Form.objForm.nikEmp = data.surkom_creator;
        vm.Form.objForm.skuid = data.sku_code + ' - ' + data.sku_name;
        vm.Form.objForm.start_date = new Date(data.start_date);
        vm.Form.objForm.end_date = new Date(data.end_date);
        vm.Form.objForm.ref_master_product_id = data.ref_master_product_id;
        vm.Form.objForm.product_id = data.ref_master_product_id;
        vm.Form.objForm.target_source = data.target_source;

        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, endPoint);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                errorDialog(data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.insentif-sales-target', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.insentif-sales-target', {
        url: '/insentif-sales-target',
        views: {
          'content@app': {
            templateUrl: 'app/main/insentif-sales-target/insentif-sales-target.html',
            controller: 'InsentifSalesTargetController as vm'
          }
        }
      });
  }
}());
(function () {
  'use strict';
  angular
    .module('app.insentif-sales-target')
    .controller('UploadInsentifSalesTargetController', UploadInsentifSalesTargetController);

  UploadInsentifSalesTargetController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadInsentifSalesTargetController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/insentifsalestarget/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifsalestarget/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.insentif-sku-focus', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.insentif-sku-focus', {
        url: '/insentif-sku-focus',
        views: {
          'content@app': {
            templateUrl: 'app/main/insentif-sku-focus/insentif-sku-focus.html',
            controller: 'InsentifSkuFocusController as vm'
          }
        }
      });
  }
}());
(function () {
    'use strict';

    angular
        .module('app.insentif-sku-focus')
        .controller('InsentifSkuFocusController', InsentifSkuFocusController);

    InsentifSkuFocusController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function InsentifSkuFocusController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var endPoint = AppAPI.InsentifSkuFocus();
        var refSalesCode = AppAPI.RefSalesCode();

        Form.setObject(endPoint);

        vm.Form = Form;
        vm.company = $localStorage.empsite;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputData = inputData;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.editData = editData;
        vm.openUpload = openUpload;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getSku = getSku;

        vm.getAreaSales = getAreaSales;
        getAreaSales();
        function getAreaSales() {
            var response = refSalesCode.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        function selectedItemChanged(item) {
            vm.productId = '';
            vm.Form.objForm.name = '';
            vm.isDisabled = false;
            vm.Form.objForm.name = vm.searchStringData;
            if (typeof item !== 'undefined' && item) {
                vm.productId = item.skuid;
                vm.Form.objForm.name = item.name
            }
        }

        function getSku(searchText) {
            return $http
                .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.ref_master_product_id = '';
                    }
                    return item.data;
                });
        }

        loadData();
        function loadData(pageno) {
            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                productId: vm.productId,
                area_sales_id: vm.area_sales_id,
                start_date: vm.start_date,
                end_date: vm.end_date
            });
        }

        function inputData(ev) {
            $mdDialog.show({
                controller: 'InputInsentifSkuFocusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-sku-focus/input-insentif-sku-focus.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editData(ev, data) {
            $mdDialog.show({
                controller: 'EditInsentifSkuFocusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-sku-focus/input-insentif-sku-focus.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                vm.listSelected = [];
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadInsentifSkuFocusController as vm',
                templateUrl: 'app/main/insentif-sku-focus/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.insentif-sku-focus')
    .controller('InputInsentifSkuFocusController', InputInsentifSkuFocusController);

  InputInsentifSkuFocusController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter', '$element'];

  /* @ngInject */
  function InputInsentifSkuFocusController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter, $element) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;
    vm.changeTarget = changeTarget

    vm.listTargetSource = [
      {
        'id': 'ABSOLUTE',
        'name': 'ABSOLUTE',
      },
      {
        'id': 'CB',
        'name': 'CB',
      },
      {
        'id': 'ACTUAL',
        'name': 'ACTUAL',
      },
    ];

    Form.initialForm();

    var endPoint = AppAPI.InsentifSkuFocus();
    var refSalesCode = AppAPI.RefSalesCode();

    // set constructor form
    Form.setObject(endPoint);

    // set form to controller
    vm.Form = Form;

    vm.Form.objForm.target_source = 'ABSOLUTE';
    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.saveData = saveData;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.selectedItemChangedUser = selectedItemChangedUser;
    vm.getEmployee = getEmployee;
    vm.getSku = getSku;
    vm.isRoaValue = false;

    vm.getAreaSales = getAreaSales;
    getAreaSales();
    function getAreaSales() {
      var response = refSalesCode.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function changeTarget(param) {
      if (param == 'CB') {
        vm.isCb = true;
      } else {
        vm.isCb = false;
      }
      if (param == 'ACTUAL') {
        vm.isRoaValue = true;
      } else {
        vm.isRoaValue = false;
      }
    }

    vm.checkRoa = checkRoa
    vm.roa = false;
    function checkRoa(param) {
      if (typeof param != 'undefined' && param != 0) {
        vm.roa = true;
      } else {
        vm.roa = false;
      }
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChangedUser(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchStringUser;
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.ref_master_product_id = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined' && item) {
        vm.Form.objForm.ref_master_product_id = item.skuid;
        vm.Form.objForm.name = item.name
      }
    }

    function getSku(searchText) {
      return $http
        .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.ref_master_product_id = '';
          }
          return item.data;
        });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, endPoint);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    $scope.isDisabled = true;
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-sku-focus')
        .controller('EditInsentifSkuFocusController', EditInsentifSkuFocusController);

    EditInsentifSkuFocusController.$inject = ['$localStorage', 'data', '$mdDialog', 'Form', 'AppAPI', 'config', '$http', '$filter', '$element'];

    /* @ngInject */
    function EditInsentifSkuFocusController($localStorage, data, $mdDialog, Form, AppAPI, config, $http, $filter, $element) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;
        vm.company = $localStorage.empsite;
        vm.isCb = false;
        vm.isRoaValue = false;
        vm.changeTarget = changeTarget;

        vm.listTargetSource = [
            {
                'id': 'ABSOLUTE',
                'name': 'ABSOLUTE',
            },
            {
                'id': 'CB',
                'name': 'CB',
            },
            {
                'id': 'ACTUAL',
                'name': 'ACTUAL',
            },
        ];

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.InsentifSkuFocus();
        var refSalesCode = AppAPI.RefSalesCode();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.saveData = saveData;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getSku = getSku;
        vm.selectedItemChangedUser = selectedItemChangedUser;
        vm.getEmployee = getEmployee;

        vm.getAreaSales = getAreaSales;
        getAreaSales();
        function getAreaSales() {
            var response = refSalesCode.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        function changeTarget(param) {
            if (param == 'CB') {
                vm.isCb = true;
            } else {
                vm.isCb = false;
            }
            if (param == 'ACTUAL') {
                vm.isRoaValue = true;
            } else {
                vm.isRoaValue = false;
            }
        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.empno = '';
                    }
                    return item.data;
                });
        }

        function selectedItemChangedUser(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchStringUser;
            if (typeof employee !== 'undefined' && employee) {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function selectedItemChanged(item) {
            vm.Form.objForm.ref_master_product_id = '';
            vm.Form.objForm.name = '';
            vm.isDisabled = false;
            vm.Form.objForm.name = vm.searchString;
            if (typeof item !== 'undefined' && item) {
                vm.Form.objForm.ref_master_product_id = item.skuid;
                vm.Form.objForm.name = item.name
            }
        }

        function getSku(searchText) {
            return $http
                .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.ref_master_product_id = '';
                    }
                    return item.data;
                });
        }

        vm.checkRoa = checkRoa
        vm.roa = false;
        function checkRoa(param) {
            if (typeof param != 'undefined' && param != 0) {
                vm.roa = true;
            } else {
                vm.roa = false;
            }
        }

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.surkom_no = data.surkom_no;
        if (data.surkom_date != '1970-01-01') {
            vm.Form.objForm.surkom_date = new Date(data.surkom_date);
        }
        vm.Form.objForm.roa = parseFloat(data.roa);
        vm.Form.objForm.nik = data.surkom_creator + ' - ' + data.surkom_creator_name;
        vm.Form.objForm.nikEmp = data.surkom_creator;
        vm.Form.objForm.skuid = data.sku_code + ' - ' + data.sku_name;
        vm.Form.objForm.start_date = new Date(data.start_date);
        vm.Form.objForm.end_date = new Date(data.end_date);
        vm.Form.objForm.ref_master_product_id = data.ref_master_product_id;
        vm.Form.objForm.product_id = data.ref_master_product_id;
        vm.Form.objForm.target_source = data.target_source;
        vm.Form.objForm.area_sales_id = data.area_sales_id;

        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, endPoint);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                errorDialog(data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-skema-override', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-skema-override', {
                url: '/insentif-skema-override',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-skema-override/insentif-skema-override.html',
                        controller: 'InsentifSkemaOverrideController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-skema-override')
        .controller('viewInsentifSkemaOverrideDetailController', viewInsentifSkemaOverrideDetailController);

    viewInsentifSkemaOverrideDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewInsentifSkemaOverrideDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var endPoint = AppAPI.InsentifSkemaOverride();
        var skema = AppAPI.InsentifSkema();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var SalesCode = AppAPI.RefSalesCode();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.company = $localStorage.empsite
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        vm.listKpi = [];
        var obj = {};
        obj["is_sku_focus"] = false;
        obj["criteria"] = '';
        obj["weight"] = 0;
        obj["target"] = 0;
        obj["description"] = '';
        obj["start_range"] = 0;
        obj["end_range"] = 0;
        obj["sales_type"] = [];
        obj["multiple_index"] = 0;
        obj["is_checked"] = false;
        obj["list_ach"] = [];
        obj["achievement"] = 'A';
        vm.listKpi.push(obj);

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];

        loadPeriod();
        loadCriteria();
        getSchemeObject();
        loadPrincipal();

        loadDetail();
        getAreaSales();

        function getAreaSales() {
            var response = SalesCode.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            angular.element.blockUI();
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            angular.element.unblockUI();

            vm.Form.objForm.id = data[0].id;
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.channel = data[0].channel;
            vm.Form.objForm.schema_object = data[0].schema_object_id;
            vm.Form.objForm.scheme_type = data[0].scheme_type;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.area_sales_id = data[0].area_sales_id;

            getWilayah(data[0].channel)
            loadSalesType(data[0].channel)
            vm.listKpi = data[0].listKpi;
            var i;
            for (i = 0; i < vm.listKpi.length; i++) {
                vm.listKpi[i].weight = parseFloat(vm.listKpi[i].weight);
                vm.listKpi[i].is_checked = 0;
                if (vm.listKpi[i].is_sku_focus == 1) {
                    vm.listKpi[i].is_checked = 1;
                }
                var j;
                for (j = 0; j < vm.listKpi[i].ach.length; j++) {
                    vm.listKpi[i].ach[j].start_range = parseFloat(vm.listKpi[i].ach[j].start_range);
                    vm.listKpi[i].ach[j].end_range = parseFloat(vm.listKpi[i].ach[j].end_range);
                    vm.listKpi[i].ach[j].multiple_index = parseFloat(vm.listKpi[i].ach[j].multiple_index);
                }
            }
        }

        function errorFetchDetail() {
            angular.element.unblockUI();
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        vm.listSchemeType = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];
        vm.listChannel = [
            {
                'id': 'GT',
                'name': 'GT'
            },
            {
                'id': 'MT',
                'name': 'MT'
            },
        ];

        function loadCriteria() {
            var response = kpiSales.query({ action: 'getKpiCriteria' });
            response.$promise.then(fetchCriteria);
            response.$promise.catch(errorFetchCriteria);
        }

        function fetchCriteria(data) {
            vm.listCriteria = data;
        }

        function errorFetchCriteria() {
            vm.listCriteria = [];
        }

        function getSchemeObject() {
            var response = endPoint.query({ action: 'getSchemeObject' });
            response.$promise.then(fetchSchemeObject);
            response.$promise.catch(errorFetchSchemeObject);
        }

        function fetchSchemeObject(data) {
            vm.listSchemeObject = data;
        }

        function errorFetchSchemeObject() {
            vm.listSchemeObject = [];
        }

        function loadPrincipal() {
            var response = endPoint.query({ action: 'getPrincipal' });
            response.$promise.then(fetchPrincipal);
            response.$promise.catch(errorFetchPrincipal);
        }

        function fetchPrincipal(data) {
            vm.listPrincipal = data;
        }

        function errorFetchPrincipal() {
            vm.listPrincipal = [];
        }

        function getWilayah(salesType) {
            var response = endPoint.query({ action: 'getWilayah', sales_type: salesType });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadSalesType(channel) {
            var response = endPoint.query({ action: 'getSalesType', channel: channel });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;

            var i;
            for (i = 0; i < data.length; i++) {
                vm.listSalesType[i].amount = parseFloat(data[i].amount);
            }

            vm.listKpi[0].sales_type = vm.listSalesType;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-skema-override')
    .controller('InsentifSkemaOverrideController', InsentifSkemaOverrideController);

  InsentifSkemaOverrideController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function InsentifSkemaOverrideController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifSkemaOverride();
    var skema = AppAPI.InsentifSkema();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.editData = editData;
    vm.selectedItem = null;
    vm.searchText = null;

    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.stateEdit = false;

    vm.listSchemeType = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];

    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);

      loadPeriod();
      getSchemeObject();
    }

    function getSchemeObject() {
      var response = endPoint.query({ action: 'getSchemeObject' });
      response.$promise.then(fetchSchemeObject);
      response.$promise.catch(errorFetchSchemeObject);
    }

    function fetchSchemeObject(data) {
      vm.listSchemeObject = data;
    }

    function errorFetchSchemeObject() {
      vm.listSchemeObject = [];
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function loadData(pageno) {
      var dt = new Date();
      var year = dt.getFullYear()

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
      var endDate = typeof vm.end != 'undefined' ? year + "-" + vm.end + "-01" : "";

      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        channel: vm.channel,
        schema_object: vm.schema_object,
        scheme_type: vm.scheme_type,
        start_date: startDate,
        end_date: endDate,
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifSkemaOverrideInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-skema-override/insentif-skema-override-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          _data: null
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifSkemaOverrideEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-skema-override/insentif-skema-override-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewInsentifSkemaOverrideDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-skema-override/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function loadSalesType() {
      var response = kpiSales.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function loadAbsoluteType() {
      var response = endPoint.query({ action: 'getAbsoluteType' });
      response.$promise.then(fetchAbsoluteType);
      response.$promise.catch(errorFetchAbsoluteType);
    }

    function fetchAbsoluteType(data) {
      vm.listAbsoluteType = data;
    }

    function errorFetchAbsoluteType() {
      vm.listAbsoluteType = [];
    }

    function loadPrincipal() {
      var response = endPoint.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.listprincipal = data;
    }

    function errorFetchPrincipal() {
      vm.listprincipal = [];
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();

            vm.objForm = new endPoint();
            vm.objForm.action = 'delete';
            vm.objForm.data = vm.selected;
            var response = vm.objForm.$save();

            response.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = $translate(expmess[0]) + ', ' + expmess[1] + ' ' + $translate(expmess[2]) + ' ' + expmess[3] + ' ' + $translate(expmess[4]);
      } else {
        var message = $translate(data.pesan);
      }

      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-skema-override')
    .controller('InsentifSkemaOverrideInputController', InsentifSkemaOverrideInputController);

  InsentifSkemaOverrideInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$filter',
    '$http',
    '$localStorage',
    'FileUploader',
    '$element',
    '$document',
    '_data',
    'config'
  ];
  /** @ngInject */
  function InsentifSkemaOverrideInputController(
    $mdDialog,
    AppAPI,
    Form,
    $filter,
    $http,
    $localStorage,
    FileUploader,
    $element,
    $document,
    _data,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifSkemaOverride();
    var skema = AppAPI.InsentifSkema();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var SalesCode = AppAPI.RefSalesCode();

    var $translate = $filter('translate');

    vm.listData = _data;

    vm.selectedItem = null;
    vm.searchText = null;
    vm.edit = false;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.fileSizeError = true;
    vm.showData = vm.showData2 = false;
    vm.company = $localStorage.empsite;
    vm.toggle = toggle;
    vm.exists = exists;
    vm.saveData = saveData;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.getWilayah = getWilayah;
    vm.addAch = addAch;
    vm.delListAch = delListAch;
    vm.detailAch = detailAch;
    vm.addCriteria = addCriteria;
    vm.checkIsSKUFocus = checkIsSKUFocus;
    vm.showIsSkuFocus = 0;
    vm.changeCriteria = changeCriteria;
    vm.loadDetailRef = loadDetailRef;
    vm.selectedPrincipal = [];

    vm.listAch = [];
    vm.listKpi = [];

    vm.listSchemeType = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];
    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];

    vm.listPrincipal = [
      {
        'id': '1',
        'name': 'KSNI'
      },
      {
        'id': '2',
        'name': 'LOTTE'
      },
      {
        'id': '3',
        'name': 'SIMBA'
      },
    ];

    vm.listDataz = [
      {
        'cols': [
          {
            'id': '1',
            'header': 'TX1',
            'data': 0,
          },
          {
            'id': '2',
            'header': 'TX2',
            'data': 0
          },
          {
            'id': '3',
            'header': 'TX3',
            'data': 0
          },
          {
            'id': '4',
            'header': 'TX4',
            'data': 0
          },
          {
            'id': '5',
            'header': 'KV1',
            'data': 0
          },
          {
            'id': '6',
            'header': 'KV2',
            'data': 0
          },
        ]
      },
    ];

    activate();

    function activate() {
      vm.selected = [];

      loadPrincipal();
      loadPeriod();
      loadCriteria();
      getSchemeObject();
      loadRefScheme();
      getAreaSales();
    }

    function loadDetailRef(id) {
      angular.element.blockUI();
      var response = endPoint.query({ action: 'viewDetail', id: id, isRef: '1' });
      response.$promise.then(fetchDetail);
      response.$promise.catch(errorFetchDetail);
    }

    function fetchDetail(data) {
      angular.element.unblockUI();

      vm.Form.objForm.id = data[0].id;
      vm.Form.objForm.channel = data[0].channel;
      vm.Form.objForm.schema_object = data[0].schema_object_id;
      vm.Form.objForm.scheme_type = data[0].scheme_type;
      vm.Form.objForm.start = data[0].start;
      vm.Form.objForm.end = data[0].end;
      vm.Form.objForm.wilayah = data[0].wilayah;

      getWilayah(data[0].channel)
      loadSalesType(data[0].channel)
      vm.listKpi = data[0].listKpi;
      var i;
      for (i = 0; i < vm.listKpi.length; i++) {
        vm.listKpi[i].weight = parseFloat(vm.listKpi[i].weight);
        vm.listKpi[i].is_checked = 0;
        if (vm.listKpi[i].is_sku_focus == 1) {
          vm.listKpi[i].is_checked = 1;
        }
        var j;
        for (j = 0; j < vm.listKpi[i].ach.length; j++) {
          vm.listKpi[i].ach[j].start_range = parseFloat(vm.listKpi[i].ach[j].start_range);
          vm.listKpi[i].ach[j].end_range = parseFloat(vm.listKpi[i].ach[j].end_range);
          vm.listKpi[i].ach[j].multiple_index = parseFloat(vm.listKpi[i].ach[j].multiple_index);
        }
      }
    }

    function errorFetchDetail() {
      vm.targetDepartmentList = [];
    }

    function changeCriteria(list, param) {
      if (param == 1) {
        list.showIsSkuFocus = 1;
      } else {
        list.showIsSkuFocus = 0;
      }
      return list;
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function checkIsSKUFocus(item) {
      if (item.is_sku_focus == false || typeof item.is_sku_focus === 'undefined') {
        item.is_checked = true
      } else {
        item.is_checked = false
      }
    }

    function loadRefScheme() {
      var response = endPoint.query({ action: 'getRefScheme' });
      response.$promise.then(fetchRefScheme);
      response.$promise.catch(errorFetchRefScheme);
    }

    function fetchRefScheme(data) {
      vm.listRefScheme = data;
    }

    function errorFetchRefScheme() {
      vm.listRefScheme = [];
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(parent, item) {
      parent.ref_master_product_id = '';
      parent.name = '';
      vm.isDisabled = false;
      parent.name = parent.searchString;
      if (typeof item !== 'undefined' && item) {
        parent.ref_master_product_id = item.skuid;
        parent.name = item.name
      }

      return parent;
    }

    vm.getSku = getSku;
    function getSku(searchText) {
      return $http
        .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.ref_master_product_id = '';
          }
          return item.data;
        });
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function getWilayah(salesType) {
      var response = endPoint.query({ action: 'getWilayah', sales_type: salesType });
      response.$promise.then(fetchWilayah);
      response.$promise.catch(errorFetchWilayah);

      loadSalesType(salesType);
    }

    function fetchWilayah(data) {
      vm.listWilayah = data;
    }

    function errorFetchWilayah() {
      vm.listWilayah = [];
    }

    function getSchemeObject() {
      var response = endPoint.query({ action: 'getSchemeObject' });
      response.$promise.then(fetchSchemeObject);
      response.$promise.catch(errorFetchSchemeObject);
    }

    function fetchSchemeObject(data) {
      vm.listSchemeObject = data;
    }

    function errorFetchSchemeObject() {
      vm.listSchemeObject = [];
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function loadSalesType(channel) {
      var response = endPoint.query({ action: 'getSalesType', channel: channel });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
      // vm.listSalesType = [
      //   {
      //     'cols': [
      //       {
      //         'id': '1',
      //         'header': 'TX1',
      //         'data': 0,
      //       },
      //       {
      //         'id': '2',
      //         'header': 'TX2',
      //         'data': 0
      //       },
      //       {
      //         'id': '3',
      //         'header': 'TX3',
      //         'data': 0
      //       },
      //       {
      //         'id': '4',
      //         'header': 'TX4',
      //         'data': 0
      //       },
      //       {
      //         'id': '5',
      //         'header': 'KV1',
      //         'data': 0
      //       },
      //       {
      //         'id': '6',
      //         'header': 'KV2',
      //         'data': 0
      //       },
      //     ]
      //   },
      // ];
      var i;
      for (i = 0; i < vm.listSalesType[0].cols.length; i++) {
        vm.listSalesType[0].cols[i].amount = parseFloat(0);
      }

      vm.achList = [];
      //set achList
      var objAch = {};
      objAch["start_range"] = 0;
      objAch["end_range"] = 0;
      objAch["multiple_index"] = 0;
      objAch["achievement"] = 0;
      objAch["sales_type"] = vm.listSalesType;
      vm.achList.push(objAch);

      var obj = {};
      obj["is_sku_focus"] = false;
      obj["criteria"] = '';
      obj["weight"] = 0;
      obj["target"] = 0;
      obj["description"] = '';
      obj["start_range"] = 0;
      obj["end_range"] = 0;
      obj["multiple_index"] = 0;
      obj["is_checked"] = false;
      obj["ach"] = vm.achList;
      obj["listPrincipal"] = vm.listPrincipal;
      obj["selectedPrincipal"] = [];
      obj["achievement"] = 'Z';
      obj["sales_type"] = vm.listSalesType;
      obj["showIsSkuFocus"] = 0;
      obj["skuid"] = '';
      obj["percentage_requirement"] = 0;
      obj["searchString"] = '';
      obj["ref_master_product_id"] = '';
      obj["name"] = '';
      // vm.listKpi.push(obj);
    }

    function getAreaSales() {
      var response = SalesCode.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function loadSalesTypeAch() {
      var response = endPoint.query({ action: 'getSalesType', channel: vm.Form.objForm.channel });
      response.$promise.then(fetchSalesTypeAch);
      response.$promise.catch(errorFetchSalesTypeAch);
    }

    function fetchSalesTypeAch(data) {
      // vm.listSalesType = data;
      vm.listSalesType = [
        {
          'cols': [
            {
              'id': '1',
              'header': 'TX1',
              'data': 0,
            },
            {
              'id': '2',
              'header': 'TX2',
              'data': 0
            },
            {
              'id': '3',
              'header': 'TX3',
              'data': 0
            },
            {
              'id': '4',
              'header': 'TX4',
              'data': 0
            },
            {
              'id': '5',
              'header': 'KV1',
              'data': 0
            },
            {
              'id': '6',
              'header': 'KV2',
              'data': 0
            },
          ]
        },
      ];

      // var i;
      // for (i = 0; i < data.length; i++) {
      //   vm.listSalesType[i].amount = parseFloat(data[i].amount);
      // }
    }

    function errorFetchSalesTypeAch() {
      vm.listSalesType = [];
    }

    function loadPrincipal() {
      var response = endPoint.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.listPrincipal = data;
    }

    function errorFetchPrincipal() {
      vm.listPrincipal = [];
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.nik1 = '';
      if (typeof item !== 'undefined' && item) {
        vm.showData = true;
      }
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function saveData(ev, frm) {
      angular.element.blockUI();

      vm.principal = [];
      if (vm.selectedPrincipal.length > 0) {
        for (var i = 0; i < vm.selectedPrincipal.length; i++) {
          vm.principal.push(vm.selectedPrincipal[i].id);
        }
      }

      var dt = new Date();
      var year = dt.getFullYear()

      var endDate = typeof vm.Form.objForm.end != 'undefined' ? year + "-" + vm.Form.objForm.end + "-01" : "9999-12-01";

      vm.Form.objForm.start_date = year + "-" + vm.Form.objForm.start + "-01";
      vm.Form.objForm.end_date = endDate;
      vm.Form.objForm.listKPI = vm.listKpi;
      vm.Form.objForm.principal = vm.principal;
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function loadCriteria() {
      var response = kpiSales.query({ action: 'getKpiCriteria' });
      response.$promise.then(fetchCriteria);
      response.$promise.catch(errorFetchCriteria);
    }

    function fetchCriteria(data) {
      vm.listCriteria = data;
    }

    function errorFetchCriteria() {
      vm.listCriteria = [];
    }

    function addAch(params) {
      // loadSalesTypeAch();
      // setTimeout(function (item) {

      vm.listSalesType = [
        {
          'cols': [
            {
              'id': '1',
              'header': 'TX1',
              'data': 0,
            },
            {
              'id': '2',
              'header': 'TX2',
              'data': 0
            },
            {
              'id': '3',
              'header': 'TX3',
              'data': 0
            },
            {
              'id': '4',
              'header': 'TX4',
              'data': 0
            },
            {
              'id': '5',
              'header': 'KV1',
              'data': 0
            },
            {
              'id': '6',
              'header': 'KV2',
              'data': 0
            },
          ]
        },
      ];

      var objAch = {};
      objAch["start_range"] = 0;
      objAch["end_range"] = 0;
      objAch["multiple_index"] = 0;
      objAch["achievement"] = 0;
      objAch["sales_type"] = vm.listSalesType;

      params.push(objAch);
      // }, 1000);
    }

    function addCriteria(channel) {
      loadPrincipal();

      loadSalesType(channel)
    }

    function delListAch(params, idx) {
      var index = -1;

      var comArr = eval(params);
      console.log(comArr)
      for (var i = 0; i < comArr.length; i++) {
        if (comArr[i].id === idx) {
          index = i;
          break;
        }
      }
      if (index === -1) {
        alert("Something gone wrong");
      }
      params.splice(index, 1);
    }

    function detailAch(ev, data) {
      $mdDialog.show({
        controller: 'InsentifSkemaInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-skema/insentif-skema-detail-ach.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        multiple: true,
        fullscreen: true,
        locals: {
          _data: data
        }
      });
    }

    vm.upload = upload;
    function upload(form) {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/insentifskemaoverride/upload',
      removeAfterUpload: true,
      alias: 'fileName',
      onBeforeUploadItem: function (item) {
        var dt = new Date(item.formData[0].surkom_date);
        var listKpi = JSON.stringify(item.formData[0].listKpi);

        var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
        item.formData[0].surkom_date = newdate;
        item.formData[0].listKpi = listKpi;

        angular.element.blockUI();
      },
      onSuccessItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }, onErrorItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }
    });

    uploaderPhoto.filters.push({
      name: 'enforceMaxFileSize',
      fn: function (item) {
        vm.itemSize = formatBytes(item.size);
        if (item.size > 0) {
          vm.fileSizeError = false;
          return true;
        } else {
          vm.fileSizeError = true;
          return false;
        }
      }
    });

    function formatBytes(bytes) {
      if (bytes < 1024) return bytes + ' Bytes';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
      else return (bytes / 1073741824).toFixed(3) + ' GB';
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-skema-override')
        .controller('InsentifSkemaOverrideEditController', InsentifSkemaOverrideEditController);

    InsentifSkemaOverrideEditController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function InsentifSkemaOverrideEditController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var $translate = $filter('translate');

        var endPoint = AppAPI.InsentifSkemaOverride();
        var skema = AppAPI.InsentifSkema();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var SalesCode = AppAPI.RefSalesCode();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.edit = true
        vm.fileSizeError = true;
        vm.company = $localStorage.empsite;
        vm.showData = vm.showData2 = false;

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        vm.saveData = saveData;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getEmployee = getEmployee;

        vm.toggle = toggle;
        vm.saveData = saveData;
        vm.getWilayah = getWilayah;
        vm.addAch = addAch;
        vm.delListAch = delListAch;
        vm.detailAch = detailAch;
        vm.addCriteria = addCriteria;
        vm.checkIsSKUFocus = checkIsSKUFocus;
        vm.showIsSkuFocus = 0;
        vm.changeCriteria = changeCriteria;
        vm.selectedPrincipal = [];

        angular.element.blockUI();

        vm.listAch = [];
        vm.listKpi = [];

        vm.listSchemeType = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];
        vm.listChannel = [
            {
                'id': 'GT',
                'name': 'GT'
            },
            {
                'id': 'MT',
                'name': 'MT'
            },
        ];

        vm.listPrincipal = [
            {
                'id': '1',
                'name': 'KSNI'
            },
            {
                'id': '2',
                'name': 'LOTTE'
            },
            {
                'id': '3',
                'name': 'SIMBA'
            },
        ];

        vm.listDataz = [
            {
                'cols': [
                    {
                        'id': '1',
                        'header': 'TX1',
                        'data': 0,
                    },
                    {
                        'id': '2',
                        'header': 'TX2',
                        'data': 0
                    },
                    {
                        'id': '3',
                        'header': 'TX3',
                        'data': 0
                    },
                    {
                        'id': '4',
                        'header': 'TX4',
                        'data': 0
                    },
                    {
                        'id': '5',
                        'header': 'KV1',
                        'data': 0
                    },
                    {
                        'id': '6',
                        'header': 'KV2',
                        'data': 0
                    },
                ]
            },
        ];

        loadPeriod();
        loadDetail();
        loadPrincipal();
        loadCriteria();
        getSchemeObject();
        getAreaSales();

        function getAreaSales() {
            var response = SalesCode.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        function getSchemeObject() {
            var response = endPoint.query({ action: 'getSchemeObject' });
            response.$promise.then(fetchSchemeObject);
            response.$promise.catch(errorFetchSchemeObject);
        }

        function fetchSchemeObject(data) {
            vm.listSchemeObject = data;
        }

        function errorFetchSchemeObject() {
            vm.listSchemeObject = [];
        }

        function loadCriteria() {
            var response = kpiSales.query({ action: 'getKpiCriteria' });
            response.$promise.then(fetchCriteria);
            response.$promise.catch(errorFetchCriteria);
        }

        function fetchCriteria(data) {
            vm.listCriteria = data;
        }

        function errorFetchCriteria() {
            vm.listCriteria = [];
        }

        function addAch(params) {
            // loadSalesTypeAch();
            // setTimeout(function (item) {

            vm.listSalesType = [
                {
                    'cols': [
                        {
                            'id': '1',
                            'header': 'TX1',
                            'data': 0,
                        },
                        {
                            'id': '2',
                            'header': 'TX2',
                            'data': 0
                        },
                        {
                            'id': '3',
                            'header': 'TX3',
                            'data': 0
                        },
                        {
                            'id': '4',
                            'header': 'TX4',
                            'data': 0
                        },
                        {
                            'id': '5',
                            'header': 'KV1',
                            'data': 0
                        },
                        {
                            'id': '6',
                            'header': 'KV2',
                            'data': 0
                        },
                    ]
                },
            ];

            var objAch = {};
            objAch["start_range"] = 0;
            objAch["end_range"] = 0;
            objAch["multiple_index"] = 0;
            objAch["achievement"] = 0;
            objAch["sales_type"] = vm.listSalesType;

            params.push(objAch);
            // }, 1000);
        }

        function delListAch(params, idx) {
            var index = -1;

            var comArr = eval(params);

            for (var i = 0; i < comArr.length; i++) {
                if (comArr[i].id === idx) {
                    index = i;
                    break;
                }
            }
            if (index === -1) {
                alert("Something gone wrong");
            }
            params.splice(index, 1);
        }

        function detailAch(ev, data) {
            $mdDialog.show({
                controller: 'InsentifSkemaInputController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-skema/insentif-skema-detail-ach.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                clickOutsideToClose: true,
                multiple: true,
                fullscreen: true,
                locals: {
                    _data: data
                }
            });
        }

        function addCriteria(channel) {
            loadPrincipal();

            loadSalesType(channel)
        }

        function checkIsSKUFocus(item) {
            if (item.is_sku_focus == false || typeof item.is_sku_focus === 'undefined') {
                item.is_checked = true
            } else {
                item.is_checked = false
            }
        }

        function changeCriteria(list, param) {
            if (param == 1) {
                list.showIsSkuFocus = 1;
            } else {
                list.showIsSkuFocus = 0;
            }
            return list;
        }

        function loadPrincipal() {
            var response = endPoint.query({ action: 'getPrincipal' });
            response.$promise.then(fetchPrincipal);
            response.$promise.catch(errorFetchPrincipal);
        }

        function fetchPrincipal(data) {
            vm.listPrincipal = data;
        }

        function errorFetchPrincipal() {
            vm.listPrincipal = [];
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            angular.element.blockUI();
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.id = data[0].id;
            vm.Form.objForm.link_file = data[0].link_file;
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.nikEmp = data[0].surkom_by;
            vm.Form.objForm.channel = data[0].channel;
            vm.Form.objForm.schema_object = data[0].schema_object_id;
            vm.Form.objForm.scheme_type = data[0].scheme_type;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.area_sales_id = data[0].area_sales_id;

            getWilayah(data[0].channel)
            loadSalesType(data[0].channel)
            vm.listKpi = data[0].listKpi;
            var i;
            for (i = 0; i < vm.listKpi.length; i++) {
                vm.listKpi[i].weight = parseFloat(vm.listKpi[i].weight);
                vm.listKpi[i].is_checked = 0;
                if (vm.listKpi[i].is_sku_focus == 1) {
                    vm.listKpi[i].is_checked = 1;
                }

                var j;
                for (j = 0; j < vm.listKpi[i].ach.length; j++) {
                    vm.listKpi[i].ach[j].start_range = parseFloat(vm.listKpi[i].ach[j].start_range);
                    vm.listKpi[i].ach[j].end_range = parseFloat(vm.listKpi[i].ach[j].end_range);
                    vm.listKpi[i].ach[j].multiple_index = parseFloat(vm.listKpi[i].ach[j].multiple_index);
                }
            }
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        function getWilayah(salesType) {
            var response = endPoint.query({ action: 'getWilayah', sales_type: salesType });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadSalesType(channel) {
            var response = endPoint.query({ action: 'getSalesType', channel: channel });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;

            var i;
            for (i = 0; i < data.length; i++) {
                vm.listSalesType[i].amount = parseFloat(data[i].amount);
            }

            vm.listKpi[0].sales_type = vm.listSalesType;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();

            vm.principal = [];
            if (vm.selectedPrincipal.length > 0) {
                for (var i = 0; i < vm.selectedPrincipal.length; i++) {
                    vm.principal.push(vm.selectedPrincipal[i].id);
                }
            }

            var dt = new Date();
            var year = dt.getFullYear()

            var endDate = typeof vm.Form.objForm.end != 'undefined' ? year + "-" + vm.Form.objForm.end + "-01" : "9999-12-01";

            vm.Form.objForm.start_date = year + "-" + vm.Form.objForm.start + "-01";
            vm.Form.objForm.end_date = endDate;
            vm.Form.objForm.listKPI = vm.listKpi;
            vm.Form.objForm.principal = vm.principal;
            var response = Form.saveData('update', frm, endPoint);
            response.then(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var message = $translate(data.pesan);
            var status = $translate(data.status);

            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;

            if (typeof employee !== 'undefined' && employee) {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.empno = '';
                    }
                    return item.data;
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-skema-override')
        .controller('InsentifSkemaOverrideDetailAchController', InsentifSkemaOverrideDetailAchController);

    InsentifSkemaOverrideDetailAchController.$inject = [
        '$mdDialog',
        'AppAPI',
        '_data'
    ];
    /** @ngInject */
    function InsentifSkemaOverrideDetailAchController(
        $mdDialog,
        AppAPI,
        _data
    ) {
        var vm = this;
        vm.dialogClose = dialogClose;

        vm.listData = _data;

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();

(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.insentif-skema-ass-adjust', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.insentif-skema-ass-adjust', {
        url: '/insentif-skema-ass-adjust',
        views: {
          'content@app': {
            templateUrl: 'app/main/insentif-skema-ass-adjust/insentif-skema-ass-adjust.html',
            controller: 'InsentifSkemaAssAdjustController as vm'
          }
        }
      });
  }
}());
(function () {
    'use strict';

    angular
        .module('app.insentif-skema-ass-adjust')
        .controller('InsentifSkemaAssAdjustController', InsentifSkemaAssAdjustController);

    InsentifSkemaAssAdjustController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function InsentifSkemaAssAdjustController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var endPoint = AppAPI.InsentifSkemaAssAdjust();
        var refSalesCode = AppAPI.RefSalesCode();

        Form.setObject(endPoint);

        vm.Form = Form;
        vm.company = $localStorage.empsite;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputData = inputData;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.editData = editData;

        loadData();
        function loadData(pageno) {
            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                start_date: vm.start_date,
                end_date: vm.end_date
            });
        }

        function inputData(ev) {
            $mdDialog.show({
                controller: 'InputInsentifSkemaAssAdjustController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-skema-ass-adjust/input-insentif-skema-ass-adjust.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editData(ev, data) {
            $mdDialog.show({
                controller: 'EditInsentifSkemaAssAdjustController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-skema-ass-adjust/input-insentif-skema-ass-adjust.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                vm.listSelected = [];
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.insentif-skema-ass-adjust')
    .controller('InputInsentifSkemaAssAdjustController', InputInsentifSkemaAssAdjustController);

  InputInsentifSkemaAssAdjustController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter'];

  /* @ngInject */
  function InputInsentifSkemaAssAdjustController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;

    Form.initialForm();

    var endPoint = AppAPI.InsentifSkemaAssAdjust();
    var refSalesCode = AppAPI.RefSalesCode();

    // set constructor form
    Form.setObject(endPoint);

    // set form to controller
    vm.Form = Form;

    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.saveData = saveData;
    vm.stateEdit = false;

    vm.checkRoa = checkRoa
    vm.roa = false;
    function checkRoa(param) {
      if (typeof param != 'undefined' && param != 0) {
        vm.roa = true;
      } else {
        vm.roa = false;
      }
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, endPoint);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    $scope.isDisabled = true;
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-skema-ass-adjust')
        .controller('EditInsentifSkemaAssAdjustController', EditInsentifSkemaAssAdjustController);

    EditInsentifSkemaAssAdjustController.$inject = ['$localStorage', 'data', '$mdDialog', 'Form', 'AppAPI', 'config', '$http', '$filter'];

    /* @ngInject */
    function EditInsentifSkemaAssAdjustController($localStorage, data, $mdDialog, Form, AppAPI, config, $http, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;
        vm.company = $localStorage.empsite;
        vm.isCb = false;

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.InsentifSkemaAssAdjust();
        var refSalesCode = AppAPI.RefSalesCode();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.saveData = saveData;
        vm.stateEdit = false;

        vm.checkRoa = checkRoa
        vm.roa = false;
        function checkRoa(param) {
            if (typeof param != 'undefined' && param != 0) {
                vm.roa = true;
            } else {
                vm.roa = false;
            }
        }

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.start_date = new Date(data.start_date);
        vm.Form.objForm.end_date = new Date(data.end_date);
        vm.Form.objForm.target_req = parseFloat(data.target_req);
        vm.Form.objForm.target_tobe = parseFloat(data.target_tobe);

        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, endPoint);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                errorDialog(data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-skema', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-skema', {
                url: '/insentif-skema',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-skema/insentif-skema.html',
                        controller: 'InsentifSkemaController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-skema')
        .controller('viewInsentifSkemaDetailController', viewInsentifSkemaDetailController);

    viewInsentifSkemaDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewInsentifSkemaDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var endPoint = AppAPI.InsentifSkema();
        var kpiSales = AppAPI.InsentifKpiSetting();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.selectedPrincipal = [];

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        vm.listKpi = [];
        var obj = {};
        obj["is_sku_focus"] = false;
        obj["criteria"] = '';
        obj["weight"] = 0;
        obj["target"] = 0;
        obj["description"] = '';
        obj["start_range"] = 0;
        obj["end_range"] = 0;
        obj["sales_type"] = [];
        obj["multiple_index"] = 0;
        obj["is_checked"] = false;
        obj["list_ach"] = [];
        obj["achievement"] = 'A';
        vm.listKpi.push(obj);

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];

        loadPeriod();
        loadCriteria();
        getSchemeObject();
        loadPrincipal();

        loadDetail();

        function exists(item, list) {
            var index, len;
            for (index = 0, len = list.length; index < len; ++index) {
                if (list[index].id == item.id) {
                    return true;
                }
            }
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            angular.element.blockUI();
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            angular.element.unblockUI();

            vm.Form.objForm.id = data[0].id;
            vm.Form.objForm.description = data[0].description;
            vm.Form.objForm.channel = data[0].channel;
            vm.Form.objForm.schema_object = data[0].schema_object_id;
            vm.Form.objForm.scheme_type = data[0].scheme_type;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.wilayah = data[0].wilayah;
            vm.selectedPrincipal = data[0].selectedPrincipal

            getWilayah(data[0].channel)
            loadSalesType(data[0].channel)
            vm.listKpi = data[0].listKpi;
            var i;
            for (i = 0; i < vm.listKpi.length; i++) {
                vm.listKpi[i].weight = parseFloat(vm.listKpi[i].weight);
                vm.listKpi[i].is_checked = 0;
                if (vm.listKpi[i].is_sku_focus == 1) {
                    vm.listKpi[i].is_checked = 1;
                }
                vm.listKpi[i].is_merge_checked = 0;
                if (vm.listKpi[i].is_merge == 1) {
                    vm.listKpi[i].is_merge_checked = 1;
                }
                var j;
                for (j = 0; j < vm.listKpi[i].ach.length; j++) {
                    vm.listKpi[i].ach[j].start_range = parseFloat(vm.listKpi[i].ach[j].start_range);
                    vm.listKpi[i].ach[j].end_range = parseFloat(vm.listKpi[i].ach[j].end_range);
                    vm.listKpi[i].ach[j].multiple_index = parseFloat(vm.listKpi[i].ach[j].multiple_index);
                }
            }
        }

        function errorFetchDetail() {
            angular.element.unblockUI();
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        vm.listSchemeType = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];
        vm.listChannel = [
            {
                'id': 'GT',
                'name': 'GT'
            },
            {
                'id': 'MT',
                'name': 'MT'
            },
        ];

        function loadCriteria() {
            var response = kpiSales.query({ action: 'getKpiCriteria' });
            response.$promise.then(fetchCriteria);
            response.$promise.catch(errorFetchCriteria);
        }

        function fetchCriteria(data) {
            vm.listCriteria = data;
        }

        function errorFetchCriteria() {
            vm.listCriteria = [];
        }

        function getSchemeObject() {
            var response = endPoint.query({ action: 'getSchemeObject' });
            response.$promise.then(fetchSchemeObject);
            response.$promise.catch(errorFetchSchemeObject);
        }

        function fetchSchemeObject(data) {
            vm.listSchemeObject = data;
        }

        function errorFetchSchemeObject() {
            vm.listSchemeObject = [];
        }

        function loadPrincipal() {
            var response = endPoint.query({ action: 'getPrincipal' });
            response.$promise.then(fetchPrincipal);
            response.$promise.catch(errorFetchPrincipal);
        }

        function fetchPrincipal(data) {
            vm.listPrincipal = data;
        }

        function errorFetchPrincipal() {
            vm.listPrincipal = [];
        }

        function getWilayah(salesType) {
            var response = endPoint.query({ action: 'getWilayah', sales_type: salesType });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadSalesType(channel) {
            var response = endPoint.query({ action: 'getSalesType', channel: channel });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;

            var i;
            for (i = 0; i < data.length; i++) {
                vm.listSalesType[i].amount = parseFloat(data[i].amount);
            }

            vm.listKpi[0].sales_type = vm.listSalesType;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-skema')
    .controller('UploadInsentifSkemaController', UploadInsentifSkemaController);

  UploadInsentifSkemaController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadInsentifSkemaController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.upload = upload;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    function upload() {
      angular.element.blockUI();

      vm.FileUpload.uploadAll();
    }

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/insentifskema/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/upload/template_upload_skema.xlsx', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-barcode-bsr/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';
  angular
    .module('app.insentif-skema')
    .controller('InsentifSkemaController', InsentifSkemaController);

  InsentifSkemaController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function InsentifSkemaController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifSkema();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.editData = editData;
    vm.selectedItem = null;
    vm.searchText = null;

    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.stateEdit = false;
    vm.openUpload = openUpload;


    function openUpload(ev) {
      $mdDialog.show({
        controller: 'UploadInsentifSkemaController as vm',
        templateUrl: 'app/main/insentif-skema/upload-file.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        }
      });
    }

    vm.listSchemeType = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];

    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);

      loadPeriod();
      getSchemeObject();
    }

    function getSchemeObject() {
      var response = endPoint.query({ action: 'getSchemeObject' });
      response.$promise.then(fetchSchemeObject);
      response.$promise.catch(errorFetchSchemeObject);
    }

    function fetchSchemeObject(data) {
      vm.listSchemeObject = data;
    }

    function errorFetchSchemeObject() {
      vm.listSchemeObject = [];
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function loadData(pageno) {
      var dt = new Date();
      var year = dt.getFullYear()

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
      var endDate = typeof vm.end != 'undefined' ? year + "-" + vm.end + "-01" : "";

      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        channel: vm.channel,
        schema_object: vm.schema_object,
        scheme_type: vm.scheme_type,
        start_date: startDate,
        end_date: endDate,
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifSkemaInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-skema/insentif-skema-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          _data: null
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifSkemaEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-skema/insentif-skema-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewInsentifSkemaDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-skema/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function loadSalesType() {
      var response = kpiSales.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function loadAbsoluteType() {
      var response = endPoint.query({ action: 'getAbsoluteType' });
      response.$promise.then(fetchAbsoluteType);
      response.$promise.catch(errorFetchAbsoluteType);
    }

    function fetchAbsoluteType(data) {
      vm.listAbsoluteType = data;
    }

    function errorFetchAbsoluteType() {
      vm.listAbsoluteType = [];
    }

    function loadPrincipal() {
      var response = endPoint.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.listprincipal = data;
    }

    function errorFetchPrincipal() {
      vm.listprincipal = [];
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();

            vm.objForm = new endPoint();
            vm.objForm.action = 'delete';
            vm.objForm.data = vm.selected;
            var response = vm.objForm.$save();

            response.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = $translate(expmess[0]) + ', ' + expmess[1] + ' ' + $translate(expmess[2]) + ' ' + expmess[3] + ' ' + $translate(expmess[4]);
      } else {
        var message = $translate(data.pesan);
      }

      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-skema')
    .controller('InsentifSkemaInputController', InsentifSkemaInputController);

  InsentifSkemaInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$filter',
    '$http',
    '$localStorage',
    '$element',
    '$document',
    '_data',
    'config'
  ];
  /** @ngInject */
  function InsentifSkemaInputController(
    $mdDialog,
    AppAPI,
    Form,
    $filter,
    $http,
    $localStorage,
    $element,
    $document,
    _data,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifSkema();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    vm.listData = _data;

    vm.selectedItem = null;
    vm.searchText = null;
    vm.edit = false;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.fileSizeError = true;
    vm.showData = vm.showData2 = false;
    vm.company = $localStorage.empsite;
    vm.toggle = toggle;
    vm.exists = exists;
    vm.saveData = saveData;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.getWilayah = getWilayah;
    vm.addAch = addAch;
    vm.delListAch = delListAch;
    vm.detailAch = detailAch;
    vm.addCriteria = addCriteria;
    vm.checkIsSKUFocus = checkIsSKUFocus;
    vm.checkIsMerge = checkIsMerge;
    vm.showIsSkuFocus = 0;
    vm.changeCriteria = changeCriteria;
    vm.selectedPrincipal = [];
    vm.showAddCriteria = false;
    vm.disableObject = true;
    vm.disableType = true;
    vm.changeObject = changeObject;
    vm.changeType = changeType;

    getProductCategory('KSNI')
    getProductCategory('LOTTE')
    getProductCategory('SIMBA')

    function changeObject(param) {
      if (param == true) {
        vm.disableObject = false;
      } else {
        vm.disableObject = true;
      }
    }

    function changeType(param) {
      if (param == true) {
        vm.disableType = false;
      } else {
        vm.disableType = true;
      }
    }

    vm.listAch = [];
    vm.listKpi = [];

    vm.listSchemeType = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];
    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];

    vm.listPrincipal = [
      {
        'id': '1',
        'name': 'KSNI'
      },
      {
        'id': '2',
        'name': 'LOTTE'
      },
      {
        'id': '3',
        'name': 'SIMBA'
      },
    ];

    vm.listDataz = [
      {
        'cols': [
          {
            'id': '1',
            'header': 'TX1',
            'data': 0,
          },
          {
            'id': '2',
            'header': 'TX2',
            'data': 0
          },
          {
            'id': '3',
            'header': 'TX3',
            'data': 0
          },
          {
            'id': '4',
            'header': 'TX4',
            'data': 0
          },
          {
            'id': '5',
            'header': 'KV1',
            'data': 0
          },
          {
            'id': '6',
            'header': 'KV2',
            'data': 0
          },
        ]
      },
    ];

    activate();

    function activate() {
      vm.selected = [];

      loadPrincipal();
      loadPeriod();
      loadCriteria();
      getSchemeObject();
    }

    function changeCriteria(list, param) {
      if (param == 1) {
        list.showIsSkuFocus = 1;
      } else {
        list.showIsSkuFocus = 0;
      }
      return list;
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function checkIsSKUFocus(item) {
      if (item.is_sku_focus == false || typeof item.is_sku_focus === 'undefined') {
        item.is_checked = true
      } else {
        item.is_checked = false
      }
    }

    function checkIsMerge(item) {
      if (item.is_merge == false || typeof item.is_merge === 'undefined') {
        item.is_merge_checked = true
      } else {
        item.is_merge_checked = false
      }
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(parent, item) {
      parent.ref_master_product_id = '';
      parent.name = '';
      vm.isDisabled = false;
      parent.name = parent.searchString;
      if (typeof item !== 'undefined' && item) {
        parent.ref_master_product_id = item.skuid;
        parent.name = item.name
      }

      return parent;
    }

    vm.getSku = getSku;
    function getSku(searchText) {
      return $http
        .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.ref_master_product_id = '';
          }
          return item.data;
        });
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function getProductCategory(param) {
      var response = endPoint.query({ action: 'getProductCategory', principal: param });
      if (param == 'KSNI') {
        response.$promise.then(fetchProductCategoryKSNI);
        response.$promise.catch(errorFetchProductCategoryKSNI);
      } else if (param == 'LOTTE') {
        response.$promise.then(fetchProductCategoryLOTTE);
        response.$promise.catch(errorFetchProductCategoryLOTTE);
      } else if (param == 'SIMBA') {
        response.$promise.then(fetchProductCategorySIMBA);
        response.$promise.catch(errorFetchProductCategorySIMBA);
      }
    }

    function fetchProductCategoryKSNI(data) {
      vm.productCategoryKsniList = data;
    }
    function errorFetchProductCategoryKSNI() {
      vm.productCategoryKsniList = [];
    }

    function fetchProductCategoryLOTTE(data) {
      vm.productCategoryLotteList = data;
    }
    function errorFetchProductCategoryLOTTE() {
      vm.productCategoryLotteList = [];
    }

    function fetchProductCategorySIMBA(data) {
      vm.productCategorySimbaList = data;
    }
    function errorFetchProductCategorySIMBA() {
      vm.productCategorySimbaList = [];
    }

    function getWilayah(channel, schemeObject, schemeType) {
      angular.element.blockUI();
      vm.listKpi = [];
      var response = endPoint.query({ action: 'getWilayah', sales_type: channel });
      response.$promise.then(fetchWilayah);
      response.$promise.catch(errorFetchWilayah);

      if (typeof channel != 'undefined' && typeof schemeObject != 'undefined' && typeof schemeType != 'undefined') {
        loadSalesType(channel, schemeObject, schemeType);
        loadSalesTypeAch();
        vm.showAddCriteria = true;
      }
    }

    function fetchWilayah(data) {
      angular.element.unblockUI();
      vm.listWilayah = data;
    }

    function errorFetchWilayah() {
      angular.element.unblockUI();
      vm.listWilayah = [];
    }

    function getSchemeObject() {
      var response = endPoint.query({ action: 'getSchemeObject' });
      response.$promise.then(fetchSchemeObject);
      response.$promise.catch(errorFetchSchemeObject);
    }

    function fetchSchemeObject(data) {
      vm.listSchemeObject = data;
    }

    function errorFetchSchemeObject() {
      vm.listSchemeObject = [];
    }

    function toggle(item, list, kpi) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }

      var dontHideList = [];

      if (list.length > 0) {
        for (var i = 0; i < list.length; i++) {
          dontHideList.push(list[i].name);
          if (list[i].name == 'KSNI') {
            kpi.showKSNI = true;
          } else if (list[i].name == 'LOTTE') {
            kpi.showLOTTE = true;
          } else if (list[i].name == 'SIMBA') {
            kpi.showSIMBA = true;
          } else {

          }
        }

        for (var i = 0; i < vm.listPrincipal.length; i++) {
          if (!dontHideList.includes(vm.listPrincipal[i].name)) {
            if (vm.listPrincipal[i].name == 'KSNI') {
              kpi.showKSNI = false;
            }
            if (vm.listPrincipal[i].name == 'LOTTE') {
              kpi.showLOTTE = false;
            }
            if (vm.listPrincipal[i].name == 'SIMBA') {
              kpi.showSIMBA = false;
            }
          }
        }
      }
    }

    function loadSalesType(channel, schemeObject, schemeType) {
      var response = endPoint.query({
        action: 'getSalesType',
        channel: channel,
        schemeObject: schemeObject,
        schemeType: schemeType
      });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
      // setTimeout(function () {
      var i;
      for (i = 0; i < vm.listSalesType[0].cols.length; i++) {
        vm.listSalesType[0].cols[i].amount = parseFloat(0);
      }

      vm.achList = [];
      //set achList
      var objAch = {};
      objAch["start_range"] = 0;
      objAch["end_range"] = 0;
      objAch["multiple_index"] = 0;
      objAch["achievement"] = 0;
      objAch["quantity"] = 0;
      objAch["skuid"] = '';
      objAch["sales_type"] = vm.listSalesType;
      vm.achList.push(objAch);

      // var objAch = {};
      // objAch["start_range"] = 0;
      // objAch["end_range"] = 0;
      // objAch["multiple_index"] = 0;
      // objAch["achievement"] = 0;
      // objAch["quantity"] = 0;
      // objAch["skuid"] = '';
      // objAch["sales_type"] = vm.listSalesTypez;
      // vm.achList.push(objAch);

      var obj = {};
      obj["is_sku_focus"] = false;
      obj["criteria"] = '';
      obj["deduction"] = 0;
      obj["weight"] = 0;
      obj["target"] = 0;
      obj["description"] = '';
      obj["start_range"] = 0;
      obj["end_range"] = 0;
      obj["multiple_index"] = 0;
      obj["is_checked"] = false;
      obj["ach"] = vm.achList;
      obj["listPrincipal"] = vm.listPrincipal;
      obj["productCategoryKsniList"] = vm.productCategoryKsniList
      obj["productCategoryLotteList"] = vm.productCategoryLotteList
      obj["productCategorySimbaList"] = vm.productCategorySimbaList
      obj["product_category_ksni"] = [];
      obj["product_category_lotte"] = [];
      obj["product_category_simba"] = [];
      obj["showKSNI"] = false;
      obj["showLOTTE"] = false;
      obj["showSIMBA"] = false;
      obj["selectedPrincipal"] = [];
      obj["achievement"] = 'Z';
      obj["sales_type"] = vm.listSalesType;
      obj["showIsSkuFocus"] = 0;
      obj["skuid"] = '';
      obj["percentage_requirement"] = 0;
      obj["is_merge_checked"] = false;
      obj["is_merge"] = false;
      obj["searchString"] = '';
      obj["ref_master_product_id"] = '';
      obj["name"] = '';
      vm.listKpi.push(obj);
      // }, 2000);
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function loadSalesTypeAch() {
      var response = endPoint.query({
        action: 'getSalesType',
        channel: vm.Form.objForm.channel,
        schemeObject: vm.Form.objForm.schema_object,
        schemeType: vm.Form.objForm.scheme_type
      });
      response.$promise.then(fetchSalesTypeAch);
      response.$promise.catch(errorFetchSalesTypeAch);
    }

    function fetchSalesTypeAch(data) {
      vm.listSalesTypez = data;
    }

    function errorFetchSalesTypeAch() {
      vm.listSalesType = [];
    }

    function loadPrincipal() {
      var response = endPoint.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.listPrincipal = data;
    }

    function errorFetchPrincipal() {
      vm.listPrincipal = [];
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.nik1 = '';
      if (typeof item !== 'undefined' && item) {
        vm.showData = true;
      }
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function saveData(ev, frm) {
      angular.element.blockUI();

      vm.principal = [];
      if (vm.selectedPrincipal.length > 0) {
        for (var i = 0; i < vm.selectedPrincipal.length; i++) {
          vm.principal.push(vm.selectedPrincipal[i].name);
        }
      }

      var dt = new Date();
      var year = dt.getFullYear()

      var endDate = typeof vm.Form.objForm.end != 'undefined' ? year + "-" + vm.Form.objForm.end + "-01" : "9999-12-01";

      vm.Form.objForm.start_date = year + "-" + vm.Form.objForm.start + "-01";
      vm.Form.objForm.end_date = endDate;
      vm.Form.objForm.listKPI = vm.listKpi;
      vm.Form.objForm.principal = vm.principal;
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function loadCriteria() {
      var response = kpiSales.query({ action: 'getKpiCriteria' });
      response.$promise.then(fetchCriteria);
      response.$promise.catch(errorFetchCriteria);
    }

    function fetchCriteria(data) {
      vm.listCriteria = data;
    }

    function errorFetchCriteria() {
      vm.listCriteria = [];
    }

    function addAch(params) {
      loadSalesTypeAch()
      var objAch = {};
      objAch["start_range"] = 0;
      objAch["end_range"] = 0;
      objAch["multiple_index"] = 0;
      objAch["achievement"] = 0;
      objAch["quantity"] = 0;
      objAch["skuid"] = '';
      objAch["sales_type"] = vm.listSalesTypez;

      params.push(objAch);
      // }, 1000);
    }

    function addCriteria(channel, schemeObject, schemeType) {
      loadPrincipal();

      loadSalesType(channel, schemeObject, schemeType)
      loadSalesTypeAch()
    }

    function delListAch(params, idx) {

      params.splice(idx, 1);
    }

    function detailAch(ev, data) {
      $mdDialog.show({
        controller: 'InsentifSkemaInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-skema/insentif-skema-detail-ach.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        multiple: true,
        fullscreen: true,
        locals: {
          _data: data
        }
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-skema')
        .controller('InsentifSkemaEditController', InsentifSkemaEditController);

    InsentifSkemaEditController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function InsentifSkemaEditController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var endPoint = AppAPI.InsentifSkema();
        var kpiSales = AppAPI.InsentifKpiSetting();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.toggle = toggle
        vm.saveData = saveData;
        vm.selectedItemChanged = selectedItemChanged;
        vm.delListAch = delListAch;
        vm.addAch = addAch;
        vm.showAddCriteria = false;
        vm.addCriteria = addCriteria
        vm.checkIsSKUFocus = checkIsSKUFocus
        vm.checkIsMerge = checkIsMerge
        vm.selectedPrincipal = [];

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        vm.listKpi = [];
        var obj = {};
        obj["is_sku_focus"] = false;
        obj["criteria"] = '';
        obj["weight"] = 0;
        obj["deduction"] = 0;
        obj["target"] = 0;
        obj["description"] = '';
        obj["start_range"] = 0;
        obj["end_range"] = 0;
        obj["sales_type"] = [];
        obj["multiple_index"] = 0;
        obj["is_checked"] = false;
        obj["list_ach"] = [];
        obj["achievement"] = 'A';
        vm.listKpi.push(obj);

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];

        loadPeriod();
        loadCriteria();
        getSchemeObject();
        loadPrincipal();

        loadDetail();


        function getProductCategory(param) {
            var response = kpiSales.query({ action: 'getProductCategory', principal: param });
            response.$promise.then(fetchProductCategory);
            response.$promise.catch(errorFetchProductCategory);
        }

        function fetchProductCategory(data) {
            vm.productCategoryList = data;
        }

        function errorFetchProductCategory() {
            vm.productCategoryList = [];
        }

        function checkIsSKUFocus(item) {
            if (item.is_sku_focus == false || typeof item.is_sku_focus === 'undefined') {
                item.is_checked = true
            } else {
                item.is_checked = false
            }
        }

        function checkIsMerge(item) {
            if (item.is_merge == false || typeof item.is_merge === 'undefined') {
                item.is_merge_checked = true
            } else {
                item.is_merge_checked = false
            }
        }

        function loadSalesTypeAch() {
            var response = endPoint.query({
                action: 'getSalesType',
                channel: vm.Form.objForm.channel,
                schemeObject: vm.Form.objForm.schema_object,
                schemeType: vm.Form.objForm.scheme_type
            });
            response.$promise.then(fetchSalesTypeAch);
            response.$promise.catch(errorFetchSalesTypeAch);
        }

        function fetchSalesTypeAch(data) {
            vm.listSalesTypez = data;
        }

        function errorFetchSalesTypeAch() {
            vm.listSalesType = [];
        }

        function addAch(params) {
            loadSalesTypeAch()
            var objAch = {};
            objAch["start_range"] = 0;
            objAch["end_range"] = 0;
            objAch["multiple_index"] = 0;
            objAch["achievement"] = 0;
            objAch["quantity"] = 0;
            objAch["skuid"] = '';
            objAch["sales_type"] = vm.listSalesTypez;

            params.push(objAch);
            // }, 1000);
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            angular.element.blockUI();
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function exists(item, list) {
            var index, len;
            for (index = 0, len = list.length; index < len; ++index) {
                if (list[index].id == item.id) {
                    return true;
                }
            }
        }

        function toggle(item, list) {
            var index, len;
            for (index = 0, len = list.length; index < len; ++index) {
                if (list[index].id == item.id) {
                    var idx = index;
                    break;
                }
            }

            if (typeof idx != 'undefined') {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function fetchDetail(data) {
            angular.element.unblockUI();

            vm.Form.objForm.id = data[0].id;
            vm.Form.objForm.description = data[0].description;
            vm.Form.objForm.channel = data[0].channel;
            vm.Form.objForm.schema_object = data[0].schema_object_id;
            vm.Form.objForm.scheme_type = data[0].scheme_type;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.wilayah = data[0].wilayah;

            vm.selectedPrincipal = data[0].selectedPrincipal

            getWilayah(data[0].channel, data[0].schema_object_id, data[0].scheme_type)

            vm.listKpi = data[0].listKpi;
            var i;
            for (i = 0; i < vm.listKpi.length; i++) {
                vm.listKpi[i].weight = parseFloat(vm.listKpi[i].weight);
                vm.listKpi[i].is_checked = 0;
                if (vm.listKpi[i].is_sku_focus == 1) {
                    vm.listKpi[i].is_checked = 1;
                }
                vm.listKpi[i].is_merge_checked = 0;
                if (vm.listKpi[i].is_merge == 1) {
                    vm.listKpi[i].is_merge_checked = 1;
                }

                var j;
                for (j = 0; j < vm.listKpi[i].ach.length; j++) {
                    vm.listKpi[i].ach[j].start_range = parseFloat(vm.listKpi[i].ach[j].start_range);
                    vm.listKpi[i].ach[j].end_range = parseFloat(vm.listKpi[i].ach[j].end_range);
                    vm.listKpi[i].ach[j].multiple_index = parseFloat(vm.listKpi[i].ach[j].multiple_index);
                }
            }
        }

        function errorFetchDetail() {
            angular.element.unblockUI();
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        vm.listSchemeType = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];
        vm.listChannel = [
            {
                'id': 'GT',
                'name': 'GT'
            },
            {
                'id': 'MT',
                'name': 'MT'
            },
        ];

        function loadCriteria() {
            var response = kpiSales.query({ action: 'getKpiCriteria' });
            response.$promise.then(fetchCriteria);
            response.$promise.catch(errorFetchCriteria);
        }

        function fetchCriteria(data) {
            vm.listCriteria = data;
        }

        function errorFetchCriteria() {
            vm.listCriteria = [];
        }

        function getSchemeObject() {
            var response = endPoint.query({ action: 'getSchemeObject' });
            response.$promise.then(fetchSchemeObject);
            response.$promise.catch(errorFetchSchemeObject);
        }

        function fetchSchemeObject(data) {
            vm.listSchemeObject = data;
        }

        function errorFetchSchemeObject() {
            vm.listSchemeObject = [];
        }

        function loadPrincipal() {
            var response = endPoint.query({ action: 'getPrincipal' });
            response.$promise.then(fetchPrincipal);
            response.$promise.catch(errorFetchPrincipal);
        }

        function fetchPrincipal(data) {
            vm.listPrincipal = data;
        }

        function errorFetchPrincipal() {
            vm.listPrincipal = [];
        }


        function addCriteria(channel, schemeObject, schemeType) {
            loadPrincipal();

            loadSalesType(channel, schemeObject, schemeType)
            loadSalesTypeAch()
        }

        function getWilayah(channel, schemeObject, schemeType) {
            angular.element.blockUI();
            vm.listKpi = [];
            var response = endPoint.query({ action: 'getWilayah', sales_type: channel });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);

            if (typeof channel != 'undefined' && typeof schemeObject != 'undefined' && typeof schemeType != 'undefined') {
                loadSalesType(channel, schemeObject, schemeType);
                loadSalesTypeAch();
                vm.showAddCriteria = true;
            }
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
            angular.element.unblockUI();
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
            angular.element.unblockUI();
        }

        function loadSalesType(channel, schemeObject, schemeType) {
            var response = endPoint.query({
                action: 'getSalesType',
                channel: channel,
                schemeObject: schemeObject,
                schemeType: schemeType
            });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;
            var i;
            for (i = 0; i < data.length; i++) {
                vm.listSalesType[i].amount = parseFloat(data[i].amount);
            }

            vm.listKpi[0].sales_type = vm.listSalesType;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }

        function selectedItemChanged(parent, item) {
            parent.ref_master_product_id = '';
            parent.name = '';
            vm.isDisabled = false;
            parent.name = parent.searchString;
            if (typeof item !== 'undefined' && item) {
                parent.ref_master_product_id = item.skuid;
                parent.name = item.name
            }

            return parent;
        }

        function delListAch(params, idx) {

            params.splice(idx, 1);
        }

        vm.getSku = getSku;
        function getSku(searchText) {
            return $http
                .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.ref_master_product_id = '';
                    }
                    return item.data;
                });
        }

        function saveData(ev, frm) {
            angular.element.blockUI();

            vm.principal = [];
            if (vm.selectedPrincipal.length > 0) {
                for (var i = 0; i < vm.selectedPrincipal.length; i++) {
                    vm.principal.push(vm.selectedPrincipal[i].name);
                }
            }

            var dt = new Date();
            var year = dt.getFullYear()

            var endDate = typeof vm.Form.objForm.end != 'undefined' ? year + "-" + vm.Form.objForm.end + "-01" : "9999-12-01";

            vm.Form.objForm.start_date = year + "-" + vm.Form.objForm.start + "-01";
            vm.Form.objForm.end_date = endDate;
            vm.Form.objForm.listKPI = vm.listKpi;
            vm.Form.objForm.principal = vm.principal;
            var response = Form.saveData('update', frm, endPoint);
            response.then(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-skema')
        .controller('InsentifSkemaDetailAchController', InsentifSkemaDetailAchController);

    InsentifSkemaDetailAchController.$inject = [
        '$mdDialog',
        'AppAPI',
        '_data'
    ];
    /** @ngInject */
    function InsentifSkemaDetailAchController(
        $mdDialog,
        AppAPI,
        _data
    ) {
        var vm = this;
        vm.dialogClose = dialogClose;

        vm.listData = _data;

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();

(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.insentif-sales-target-contribution', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.insentif-sales-target-contribution', {
        url: '/insentif-sales-target-contribution',
        views: {
          'content@app': {
            templateUrl: 'app/main/insentif-sales-target-contribution/insentif-sales-target-contribution.html',
            controller: 'InsentifSalesTargetContributionController as vm'
          }
        }
      });
  }
}());
(function () {
  'use strict';
  angular
    .module('app.insentif-sales-target-contribution')
    .controller('UploadInsentifSalesTargetContributionController', UploadInsentifSalesTargetContributionController);

  UploadInsentifSalesTargetContributionController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadInsentifSalesTargetContributionController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/insentifsalestargetcontribution/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifsalestargetcontribution/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
    'use strict';

    angular
        .module('app.insentif-sales-target-contribution')
        .controller('InsentifSalesTargetContributionController', InsentifSalesTargetContributionController);

    InsentifSalesTargetContributionController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function InsentifSalesTargetContributionController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var endPoint = AppAPI.InsentifSalesTargetContribution();
        var kpiSales = AppAPI.InsentifKpiSetting();

        Form.setObject(endPoint);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputData = inputData;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.editData = editData;
        vm.openUpload = openUpload;

        function loadData(pageno) {
            var dt = new Date();
            var year = dt.getFullYear()

            var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
            var endDate = typeof vm.end != 'undefined' ? year + "-" + vm.end + "-01" : "";
            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                salesCode: vm.ref_sales_code_id,
                startDate: startDate,
                endDate: endDate
            });
        }

        getSalesCode();
        function getSalesCode() {
            var response = endPoint.query({ action: 'getSalesCode' });
            response.$promise.then(fetchSalesCode);
            response.$promise.catch(errorFetchSalesCode);
        }

        function fetchSalesCode(data) {
            vm.listSalesCode = data;
        }

        function errorFetchSalesCode() {
            vm.listSalesCode = [];
        }

        loadPeriod()
        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function inputData(ev) {
            $mdDialog.show({
                controller: 'InputInsentifSalesTargetContributionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-sales-target-contribution/input-insentif-sales-target-contribution.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editData(ev, data) {
            $mdDialog.show({
                controller: 'EditInsentifSalesTargetContributionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-sales-target-contribution/input-insentif-sales-target-contribution.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                vm.listSelected = [];
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadInsentifSalesTargetContributionController as vm',
                templateUrl: 'app/main/insentif-sales-target-contribution/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.insentif-sales-target-contribution')
    .controller('InputInsentifSalesTargetContributionController', InputInsentifSalesTargetContributionController);

  InputInsentifSalesTargetContributionController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter'];

  /* @ngInject */
  function InputInsentifSalesTargetContributionController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;

    Form.initialForm();

    var endPoint = AppAPI.InsentifSalesTargetContribution();
    var kpiSales = AppAPI.InsentifKpiSetting();

    // set constructor form
    Form.setObject(endPoint);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.saveData = saveData;
    vm.stateEdit = false;

    getSalesCode();
    function getSalesCode() {
      var response = endPoint.query({ action: 'getSalesCode' });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    getSalesTarget();
    function getSalesTarget() {
      var response = endPoint.query({ action: 'getSalesTarget' });
      response.$promise.then(fetchSalesTarget);
      response.$promise.catch(errorFetchSalesTarget);
    }

    function fetchSalesTarget(data) {
      vm.listSalesTarget = data;
    }

    function errorFetchSalesTarget() {
      vm.listSalesTarget = [];
    }

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {

      var dt = new Date();
      var year = dt.getFullYear()

      var endDate = typeof vm.Form.objForm.end != 'undefined' ? year + "-" + vm.Form.objForm.end + "-01" : "9999-12-01";

      vm.Form.objForm.start_date = year + "-" + vm.Form.objForm.start + "-01";
      vm.Form.objForm.end_date = endDate;

      var promise = Form.saveData('save', formController, endPoint);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    $scope.isDisabled = true;
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-sales-target-contribution')
        .controller('EditInsentifSalesTargetContributionController', EditInsentifSalesTargetContributionController);

    EditInsentifSalesTargetContributionController.$inject = ['$localStorage', 'data', '$mdDialog', 'Form', 'AppAPI', 'config', '$http', '$filter'];

    /* @ngInject */
    function EditInsentifSalesTargetContributionController($localStorage, data, $mdDialog, Form, AppAPI, config, $http, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.InsentifSalesTargetContribution();
        var kpiSales = AppAPI.InsentifKpiSetting();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.saveData = saveData;
        vm.stateEdit = false;

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.ref_sales_code_id = data.ref_sales_code_id;
        vm.Form.objForm.incentive_sales_value_target_id = data.incentive_sales_value_target_id;
        vm.Form.objForm.contribution = parseFloat(data.contribution);
        vm.Form.objForm.start = data.start;
        vm.Form.objForm.end = data.end;

        getSalesTarget();
        function getSalesTarget() {
            var response = endPoint.query({ action: 'getSalesTarget' });
            response.$promise.then(fetchSalesTarget);
            response.$promise.catch(errorFetchSalesTarget);
        }

        function fetchSalesTarget(data) {
            vm.listSalesTarget = data;
        }

        function errorFetchSalesTarget() {
            vm.listSalesTarget = [];
        }

        getSalesCode();
        function getSalesCode() {
            var response = endPoint.query({ action: 'getSalesCode' });
            response.$promise.then(fetchSalesCode);
            response.$promise.catch(errorFetchSalesCode);
        }

        function fetchSalesCode(data) {
            vm.listSalesCode = data;
        }

        function errorFetchSalesCode() {
            vm.listSalesCode = [];
        }

        loadPeriod()
        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {

            var dt = new Date();
            var year = dt.getFullYear()

            var endDate = typeof vm.Form.objForm.end != 'undefined' ? year + "-" + vm.Form.objForm.end + "-01" : "9999-12-01";

            vm.Form.objForm.start_date = year + "-" + vm.Form.objForm.start + "-01";
            vm.Form.objForm.end_date = endDate;

            var promise = Form.saveData('update', formController, endPoint);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                errorDialog(data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-sales-target')
    .controller('UploadFileInsentifSalesTargetController', UploadFileInsentifSalesTargetController);

  UploadFileInsentifSalesTargetController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadFileInsentifSalesTargetController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.upload = upload;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    function upload() {
      angular.element.blockUI();

      vm.FileUpload.uploadAll();
    }

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/insentifsalestarget/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/upload/template_upload_target.xlsx', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
    'use strict';

    angular
        .module('app.insentif-sales-target')
        .controller('InsentifSalesTargetController', InsentifSalesTargetController);

    InsentifSalesTargetController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function InsentifSalesTargetController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var calculation = AppAPI.InsentifCalculation();
        var endPoint = AppAPI.InsentifSalesTarget();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var salesCode = AppAPI.RefSalesCode();

        Form.setObject(endPoint);

        vm.Form = Form;
        vm.company = $localStorage.empsite;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputData = inputData;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.editData = editData;
        vm.openUpload = openUpload;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getSku = getSku;

        function selectedItemChanged(item) {
            vm.productId = '';
            vm.Form.objForm.name = '';
            vm.isDisabled = false;
            vm.Form.objForm.name = vm.searchString;
            if (typeof item !== 'undefined' && item) {
                vm.productId = item.skuid;
                vm.Form.objForm.name = item.name
            }
        }

        function getSku(searchText) {
            return $http
                .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.ref_master_product_id = '';
                    }
                    return item.data;
                });
        }

        loadYear()
        function loadYear() {
            var response = calculation.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        getAreaSales()
        function getAreaSales() {
            var response = salesCode.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        function loadData(pageno) {
            var year = vm.year

            var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
            var endDate = typeof vm.end != 'undefined' ? year + "-" + vm.end + "-01" : "";
            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                area: vm.area,
                productId: vm.productId,
                startDate: startDate,
                endDate: endDate
            });
        }

        getSalesCode();
        function getSalesCode() {
            var response = endPoint.query({ action: 'getSalesCode' });
            response.$promise.then(fetchSalesCode);
            response.$promise.catch(errorFetchSalesCode);
        }

        function fetchSalesCode(data) {
            vm.listSalesCode = data;
        }

        function errorFetchSalesCode() {
            vm.listSalesCode = [];
        }

        loadPeriod()
        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function inputData(ev) {
            $mdDialog.show({
                controller: 'InputInsentifSalesTargetController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-sales-target/input-insentif-sales-target.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editData(ev, data) {
            $mdDialog.show({
                controller: 'EditInsentifSalesTargetController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-sales-target/input-insentif-sales-target.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                vm.listSelected = [];
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadFileInsentifSalesTargetController as vm',
                templateUrl: 'app/main/insentif-sales-target/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.insentif-sales-target')
    .controller('InputInsentifSalesTargetController', InputInsentifSalesTargetController);

  InputInsentifSalesTargetController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter'];

  /* @ngInject */
  function InputInsentifSalesTargetController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;

    Form.initialForm();

    var endPoint = AppAPI.InsentifSalesTarget();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var salesCode = AppAPI.RefSalesCode();

    // set constructor form
    Form.setObject(endPoint);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.saveData = saveData;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getSku = getSku;

    function selectedItemChanged(item) {
      vm.Form.objForm.ref_master_product_id = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined' && item) {
        vm.Form.objForm.ref_master_product_id = item.skuid;
        vm.Form.objForm.name = item.name
      }
    }

    function getSku(searchText) {
      return $http
        .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.ref_master_product_id = '';
          }
          return item.data;
        });
    }

    getAreaSales()
    function getAreaSales() {
      var response = salesCode.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {

      var dt = new Date();
      var year = dt.getFullYear()

      var endDate = typeof vm.Form.objForm.end != 'undefined' ? year + "-" + vm.Form.objForm.end + "-01" : "9999-12-01";

      vm.Form.objForm.start_date = year + "-" + vm.Form.objForm.start + "-01";
      vm.Form.objForm.end_date = endDate;

      var promise = Form.saveData('save', formController, endPoint);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    $scope.isDisabled = true;
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-sales-target')
        .controller('EditInsentifSalesTargetController', EditInsentifSalesTargetController);

    EditInsentifSalesTargetController.$inject = ['$localStorage', 'data', '$mdDialog', 'Form', 'AppAPI', 'config', '$http', '$filter'];

    /* @ngInject */
    function EditInsentifSalesTargetController($localStorage, data, $mdDialog, Form, AppAPI, config, $http, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;
        vm.company = $localStorage.empsite;

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.InsentifSalesTarget();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var salesCode = AppAPI.RefSalesCode();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.saveData = saveData;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getSku = getSku;

        function selectedItemChanged(item) {
            vm.Form.objForm.ref_master_product_id = '';
            vm.Form.objForm.name = '';
            vm.isDisabled = false;
            vm.Form.objForm.name = vm.searchString;
            if (typeof item !== 'undefined' && item) {
                vm.Form.objForm.ref_master_product_id = item.skuid;
                vm.Form.objForm.name = item.name
            }
        }

        function getSku(searchText) {
            return $http
                .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.ref_master_product_id = '';
                    }
                    return item.data;
                });
        }

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.skuid = data.sku_code + ' - ' + data.sku_name;
        vm.Form.objForm.area_sales_id = data.area_sales_id;
        vm.Form.objForm.ref_master_product_id = data.ref_master_product_id;
        vm.Form.objForm.product_id = data.ref_master_product_id;
        vm.Form.objForm.qty_target = parseFloat(data.qty_target);
        vm.Form.objForm.sales_value = parseFloat(data.sales_value);
        vm.Form.objForm.start = data.start;
        vm.Form.objForm.year = data.year;
        vm.Form.objForm.end = data.end;

        getAreaSales()
        function getAreaSales() {
            var response = salesCode.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        loadPeriod()
        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var year = vm.Form.objForm.year

            var endDate = typeof vm.Form.objForm.end != 'undefined' ? year + "-" + vm.Form.objForm.end + "-01" : "9999-12-01";

            vm.Form.objForm.start_date = year + "-" + vm.Form.objForm.start + "-01";
            vm.Form.objForm.end_date = endDate;

            var promise = Form.saveData('update', formController, endPoint);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                errorDialog(data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-sales-target')
    .controller('UploadInsentifSalesTargetController', UploadInsentifSalesTargetController);

  UploadInsentifSalesTargetController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadInsentifSalesTargetController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/insentifsalestarget/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifsalestarget/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.insentif-requirement-sku', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.insentif-requirement-sku', {
        url: '/insentif-requirement-sku',
        views: {
          'content@app': {
            templateUrl: 'app/main/insentif-requirement-sku/insentif-requirement-sku.html',
            controller: 'InsentifRequirementSkuController as vm'
          }
        }
      });
  }
}());
(function () {
    'use strict';

    angular
        .module('app.insentif-requirement-sku')
        .controller('InsentifRequirementSkuController', InsentifRequirementSkuController);

    InsentifRequirementSkuController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function InsentifRequirementSkuController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var refSalesCode = AppAPI.RefSalesCode();
        var endPoint = AppAPI.InsentifRequirementSku();

        Form.setObject(endPoint);

        vm.Form = Form;
        vm.company = $localStorage.empsite;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputData = inputData;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.editData = editData;
        vm.openUpload = openUpload;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getSku = getSku;
        vm.getSchemeDetailList = getSchemeDetailList;

        function selectedItemChanged(item) {
            vm.productId = '';
            vm.Form.objForm.name = '';
            vm.isDisabled = false;
            vm.Form.objForm.name = vm.searchString;
            if (typeof item !== 'undefined' && item) {
                vm.productId = item.skuid;
                vm.Form.objForm.name = item.name
            }
        }

        getSalesType()
        function getSalesType() {
            var response = refSalesCode.query({ action: 'getSalesType' });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }

        function getSku(searchText) {
            return $http
                .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.ref_master_product_id = '';
                    }
                    return item.data;
                });
        }

        loadData();
        function loadData(pageno) {
            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                productId: vm.productId,
                schemaDetailId: vm.Form.objForm.incentive_schema_detail_id
            });
        }

        function getSchemeDetailList(id) {
            var response = endPoint.query({ action: 'getSchemeDetailList', id: id });
            response.$promise.then(fetchSchemeDetai);
            response.$promise.catch(errorFetchSchemeDetai);
        }

        function fetchSchemeDetai(data) {
            vm.listSchemeDetai = data;
        }

        function errorFetchSchemeDetai() {
            vm.listSchemeDetai = [];
        }

        function inputData(ev) {
            $mdDialog.show({
                controller: 'InputInsentifRequirementSkuController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-requirement-sku/input-insentif-requirement-sku.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editData(ev, data) {
            $mdDialog.show({
                controller: 'EditInsentifRequirementSkuController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-requirement-sku/input-insentif-requirement-sku.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                vm.listSelected = [];
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadInsentifRequirementSkuController as vm',
                templateUrl: 'app/main/insentif-requirement-sku/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.insentif-requirement-sku')
    .controller('InputInsentifRequirementSkuController', InputInsentifRequirementSkuController);

  InputInsentifRequirementSkuController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter'];

  /* @ngInject */
  function InputInsentifRequirementSkuController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;

    Form.initialForm();

    var endPoint = AppAPI.InsentifRequirementSku();
    var refSalesCode = AppAPI.RefSalesCode();

    // set constructor form
    Form.setObject(endPoint);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.saveData = saveData;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getSku = getSku;
    vm.getSchemeDetailList = getSchemeDetailList

    function selectedItemChanged(item) {
      vm.Form.objForm.ref_master_product_id = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined' && item) {
        vm.Form.objForm.ref_master_product_id = item.skuid;
        vm.Form.objForm.name = item.name
      }
    }

    getSalesType()
    function getSalesType() {
      var response = refSalesCode.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function getSku(searchText) {
      return $http
        .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.ref_master_product_id = '';
          }
          return item.data;
        });
    }

    function getSchemeDetailList(id) {
      var response = endPoint.query({ action: 'getSchemeDetailList', id: id });
      response.$promise.then(fetchSchemeDetai);
      response.$promise.catch(errorFetchSchemeDetai);
    }

    function fetchSchemeDetai(data) {
      vm.listSchemeDetai = data;
    }

    function errorFetchSchemeDetai() {
      vm.listSchemeDetai = [];
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, endPoint);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    $scope.isDisabled = true;
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-requirement-sku')
        .controller('EditInsentifRequirementSkuController', EditInsentifRequirementSkuController);

    EditInsentifRequirementSkuController.$inject = ['$localStorage', 'data', '$mdDialog', 'Form', 'AppAPI', 'config', '$http', '$filter'];

    /* @ngInject */
    function EditInsentifRequirementSkuController($localStorage, data, $mdDialog, Form, AppAPI, config, $http, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;
        vm.company = $localStorage.empsite;
        vm.getSchemeDetailList = getSchemeDetailList

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.InsentifRequirementSku();
        var refSalesCode = AppAPI.RefSalesCode();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.saveData = saveData;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getSku = getSku;

        function selectedItemChanged(item) {
            vm.Form.objForm.ref_master_product_id = '';
            vm.Form.objForm.name = '';
            vm.isDisabled = false;
            vm.Form.objForm.name = vm.searchString;
            if (typeof item !== 'undefined' && item) {
                vm.Form.objForm.ref_master_product_id = item.skuid;
                vm.Form.objForm.name = item.name
            }
        }

        getSalesType()
        function getSalesType() {
            var response = refSalesCode.query({ action: 'getSalesType' });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }

        function getSku(searchText) {
            return $http
                .get(config.api + 'api/InsentifRequirementSku?action=searchSku&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.ref_master_product_id = '';
                    }
                    return item.data;
                });
        }

        function getSchemeDetailList(id) {
            var response = endPoint.query({ action: 'getSchemeDetailList', id: id });
            response.$promise.then(fetchSchemeDetai);
            response.$promise.catch(errorFetchSchemeDetai);
        }

        function fetchSchemeDetai(data) {
            vm.listSchemeDetai = data;
        }

        function errorFetchSchemeDetai() {
            vm.listSchemeDetai = [];
        }

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.skuid = data.sku_code + ' - ' + data.sku_name;
        vm.Form.objForm.incentive_schema_detail_id = data.incentive_schema_detail_id;
        vm.Form.objForm.ref_master_product_id = data.ref_master_product_id;
        vm.Form.objForm.product_id = data.ref_master_product_id;
        vm.Form.objForm.ref_sales_type_id = data.ref_sales_type_id;
        vm.Form.objForm.percentage_requirement = parseFloat(data.percentage_requirement);
        getSchemeDetailList(data.ref_sales_type_id);

        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, endPoint);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                errorDialog(data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.insentif-report', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.insentif_report', {
                url    : '/insentif-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/insentif-report/insentifreport.html',
                    controller : 'InsentifreportController as vm'
                    }
                }
                  
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.insentif-report')
        .controller('InsentifreportController', InsentifreportController);

    InsentifreportController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window', '$element'];

    /* @ngInject */
    function InsentifreportController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window, $element) {
       
       var vm = this;
       var endPoint=AppAPI.Insentifreport();
       vm.DataTable= new DataService();
       vm.LoadPeriod = LoadPeriod;
       vm.LoadCompany = LoadCompany;
       vm.LoadArea = LoadArea;
       vm.listJum=[2,5,25,50,75,100,200];
       vm.ExporttoExcel = ExporttoExcel;

       vm.company       = $localStorage.empsite;
       vm.loadDivision  = loadDivision;
       vm.LoadRegional  = loadRegional;
       vm.LoadCabang    = loadCabang;
       vm.LoadWilayah   = loadWilayah;

       vm.reqWil    = false;
       vm.reqArea   = true;

       LoadPeriod();
       LoadSubPeriod();
       LoadCompany()
       loadWilayah();
       LoadAreaDefault(vm.company);

       function LoadAreaDefault(company) 
        {
            var response=endPoint.query({action:'getArea', companyid:company});
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

       function fetchAreaDefault(data) {
            vm.listarea=data;
       }

       function errorFetchAreaDefault() {
            vm.listarea=[];
       }

      function LoadPeriod() 
      {
          var response=endPoint.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       } 
      
       function LoadSubPeriod() 
      {
          var response=endPoint.query({action:'getSubPeriod'});
          response.$promise.then(fetchSubPeriod);
          response.$promise.catch(errorFetchSubPeriod);
       }

       function fetchSubPeriod(data) {
            vm.listsubperiod=data;
       }

       function errorFetchSubPeriod() {
            vm.listsubperiod=[];
       } 

       function LoadCompany() {
          var response=endPoint.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

        function LoadArea(company,cabangid) 
        {
            loadDivision(company);
            loadWilayah();
            var response=endPoint.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
       
       function loadDivision(company) {
          var response=endPoint.query({action:'getDivision', companyid:company});
          response.$promise.then(fetchDivision);
          response.$promise.catch(errorFetchDivision);
       }

       function fetchDivision(data) {
            vm.listDivision=data;
       }

       function errorFetchDivision() {
            vm.listDivision=[];
       }  
       
       function loadWilayah() {
          var response=endPoint.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=endPoint.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=endPoint.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }  
       
       function ExporttoExcel(form) 
       {    
            var subPeriod   = encodeURIComponent(window.btoa(vm.subperiod));
            var token       = Auth.setTokenPromise();
            var period      = encodeURIComponent(window.btoa(vm.period));
            var company     = encodeURIComponent(window.btoa(vm.company));
            var area        = encodeURIComponent(window.btoa(vm.area));
            var division    = encodeURIComponent(window.btoa(vm.division));
            var wilayah     = encodeURIComponent(window.btoa(vm.wilayah));
            var regional    = encodeURIComponent(window.btoa(vm.regional));
            var cabang      = encodeURIComponent(window.btoa(vm.cabang));
            var action      = encodeURIComponent(window.btoa('downloadReport'));
            
            token.then(function(data) 
            {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifreport/lgexportexcel/' + period + '/' + company  + '/' + area + '/' + division + '/' + wilayah + '/' + regional + '/' + cabang + '/' + action + '/' + subPeriod + '/' +  data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-process-ass', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-process-ass', {
                url: '/insentif-process-ass',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-process-ass/insentif-process-ass.html',
                        controller: 'InsentifProcessAssController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-process-ass')
        .controller('newInsentifProcessAssController', newInsentifProcessAssController);

    newInsentifProcessAssController.$inject = [
        '$localStorage',
        '$mdDialog',
        '$log',
        '$window',
        '$location',
        'Form',
        'AppAPI',
        '$element',
        '$filter',
        'Auth'
    ];
    /* @ngInject */
    function newInsentifProcessAssController(
        $localStorage,
        $mdDialog,
        $log,
        $window,
        $location,
        Form,
        AppAPI,
        $element,
        $filter,
        Auth
    ) {
        var vm = this;
        var translate = $filter('translate');
        var kpiSales = AppAPI.InsentifKpiSetting();
        var endPoint = AppAPI.InsentifProcessAss();

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        vm.company = $localStorage.empsite;
        vm.processData = processData;
        vm.getSalesCode = getSalesCode;
        vm.dialogClose = dialogClose;

        activate();

        function activate() {
            vm.selected = [];

            loadPeriod();
            getAreaSales();
            loadYear();
        }

        function getAreaSales() {
            var response = endPoint.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        function getSalesType() {
            var response = endPoint.query({ action: 'getSalesType' });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function loadYear() {
            var response = endPoint.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function processData() {
            var year = vm.year;

            var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
            angular.element.blockUI();
            var response = endPoint.query({
                action: 'processData',
                area_sales_id: vm.Form.objForm.area_sales_id,
                sales_code: vm.sales_code,
                start: startDate,
                nik: vm.Form.objForm.empno,
                hke_sales: vm.hke_sales
            });
            response.$promise.then(fetchLoad);
            response.$promise.catch(errorFetchLoad);

        }

        function fetchLoad(data) {
            angular.element.unblockUI();
            showDialogInfo(data[0])
        }

        function isEmptyObject(obj) {
            return JSON.stringify(obj) === '{}';
        }

        function errorFetchLoad() {
            angular.element.unblockUI();
            vm.results = [];
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function reindex_array_keys(array, start) {
            var temp = [];
            start = typeof start == 'undefined' ? 0 : start;
            start = typeof start != 'number' ? 0 : start;
            for (var i in array) {
                temp[start++] = array[i];
            }
            return temp;
        }

        function saveData(ev, form) {
            angular.element.blockUI();

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Are you sure want to process ?')
                    .textContent('All data will be processed and can not recovered.')
                    .ariaLabel('process dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        vm.Form.objForm.subPeriod = vm.subperiod,
                            vm.Form.objForm.period = vm.period,
                            vm.Form.objForm.company = vm.company,
                            vm.Form.objForm.area = vm.area,
                            vm.Form.objForm.division = vm.division,
                            vm.Form.objForm.wilayah = vm.wilayah,
                            vm.Form.objForm.regional = vm.regional,
                            vm.Form.objForm.cabang = vm.cabang

                        var response = Form.saveData('processumut', form, endPoint);
                        response.then(function (data) {
                            angular.element.unblockUI();
                            form.$setPristine();
                            showDialogInfo(ev, data);
                        });

                        response.catch(function (data) {
                            angular.element.unblockUI();
                            form.$setPristine();
                            showDialogInfo(ev, data);
                        });
                    },
                    function () { }
                );
            });
        }

        function showDialogInfo(data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.messages.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.messages);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                )
                .then(function () {
                    dialogClose();
                    if ('moreInfo' in data && data.moreInfo.length > 0) {
                        $mdDialog.show({
                            controller: 'logFailGwController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: true,
                            onRemoving: function (element, removePromise) {
                                // loadData(1);
                            },
                            locals: {
                                data: data.moreInfo
                            }
                        });
                    } else {
                        // loadData(1);
                    }
                });
        }

        function getSalesCode(area) {
            angular.element.blockUI();
            var year = vm.year;
            var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

            var response = endPoint.query({ action: 'getSalesCode', area: area, date: startDate });
            response.$promise.then(fetchSalesCode);
            response.$promise.catch(errorFetchSalesCode);
        }

        function fetchSalesCode(data) {
            angular.element.unblockUI();
            vm.listSalesCode = data;
        }

        function errorFetchSalesCode() {
            angular.element.unblockUI();
            vm.listSalesCode = [];
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-process-ass')
    .controller('InsentifProcessAssController', InsentifProcessAssController);

  InsentifProcessAssController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$location',
    '$window',
    '$element'
  ];
  /** @ngInject */
  function InsentifProcessAssController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $location,
    $window,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifProcessAss();
    var endPointUmutReport = AppAPI.Umutreport();
    var insentifApproval = AppAPI.InsentifApproval();
    var endPointUmutReport = AppAPI.Umutreport();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.results = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.getSalesCode = getSalesCode;
    vm.isEmptyObject = isEmptyObject;

    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.area = $localStorage.empSubarea;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.processData = processData;
    vm.LoadArea = LoadArea;
    vm.showProcessForm = showProcessForm;
    vm.viewComment = viewComment;
    vm.sumbitData = sumbitData;
    vm.disabledSubmit = disabledSubmit;
    vm.detail = detail;

    activate();

    function activate() {
      vm.selected = [];

      vm.LoadRegional = loadRegional;
      vm.LoadCabang = loadCabang;
      vm.LoadWilayah = loadWilayah;

      vm.reqWil = false;
      vm.reqArea = true;

      getSalesType();
      getAreaSales();
      loadYear();
      LoadPeriod();
      LoadSubPeriod();
      LoadCompany();
      loadWilayah();
    }

    function detail(ev, data) {
      $mdDialog.show({
        controller: 'InsentifApprovalDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-approval/insentif-approval-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function disabledSubmit() {
      var result = false;
      if (typeof vm.DataTable.list == 'undefined' || vm.DataTable.list.length == 0) {
        result = true;
      }

      return result;
    }

    function sumbitData(ev) {
      var jum = vm.DataTable.list.length;
      var i = 0;
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Are you sure want to submit ?')
            .textContent('All data will be submitted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new endPoint();
            ot.data = [];
            ot.action = 'submitData';
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.DataTable.list[i]);
            }
            var response = ot.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              if (data.status == 1) {
                successApproved(ev, data);
              } else {
                failedApproved(ev, data);
              }
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
            });
          }, function () {

          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'AdditionalUmutViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          vm.listOtselected = [];
        },
        locals: {
          id: id
        }
      });
    }

    function showProcessForm() {
      $mdDialog.show({
        controller: 'newInsentifProcessAssController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-process-ass/new-insentif-process-ass.html',
        parent: angular.element($document.body),
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];

    function LoadArea(company, cabangid) {
      loadWilayah();
      var response = insentifApproval.query({ action: 'getArea', companyid: company, cabangid: cabangid });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listarea = data;
    }

    function errorFetchArea() {
      vm.listarea = [];
    }

    function LoadAreaDefault(company) {
      var response = insentifApproval.query({ action: 'getArea', companyid: company });
      response.$promise.then(fetchAreaDefault);
      response.$promise.catch(errorFetchAreaDefault);
    }

    function fetchAreaDefault(data) {
      vm.listarea = data;
    }

    function errorFetchAreaDefault() {
      vm.listarea = [];
    }

    function loadWilayah() {
      var response = insentifApproval.query({ action: 'getWilayah', companyid: vm.company });
      response.$promise.then(fetchWilayah);
      response.$promise.catch(errorFetchWilayah);
    }

    function fetchWilayah(data) {
      vm.listWilayah = data;
    }

    function errorFetchWilayah() {
      vm.listWilayah = [];
    }

    function loadRegional(id) {
      vm.listarea = [];
      vm.reqWil = true;
      vm.reqArea = false;
      var response = insentifApproval.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
      response.$promise.then(fetchRegional);
      response.$promise.catch(errorFetchRegional);
    }

    function fetchRegional(data) {
      vm.listRegional = data;
    }

    function errorFetchRegional() {
      vm.listRegional = [];
    }

    function loadCabang(id) {
      var response = insentifApproval.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
      response.$promise.then(fetchCabang);
      response.$promise.catch(errorFetchCabang);
    }

    function fetchCabang(data) {
      vm.listCabang = data;
    }

    function errorFetchCabang() {
      vm.listCabang = [];
    }

    function LoadSubPeriod() {
      var response = insentifApproval.query({ action: 'getSubPeriod' });
      response.$promise.then(fetchSubPeriod);
      response.$promise.catch(errorFetchSubPeriod);
    }

    function fetchSubPeriod(data) {
      vm.listsubperiod = data;
    }

    function errorFetchSubPeriod() {
      vm.listsubperiod = [];
    }

    function LoadPeriod() {
      var response = endPointUmutReport.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listperiod = data;
    }

    function errorFetchPeriod() {
      vm.listperiod = [];
    }

    function LoadCompany() {
      var response = insentifApproval.query({ action: 'getCompany' });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listcompany = data;
    }

    function errorFetchCompany() {
      vm.listcompany = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function getAreaSales() {
      var response = endPoint.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listarea = data;
    }

    function errorFetchAreaSales() {
      vm.listarea = [];
    }

    function getSalesType() {
      var response = endPoint.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function getSalesCode(area) {
      angular.element.blockUI();
      var year = vm.year;
      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

      var response = endPoint.query({ action: 'getSalesCode', area: area, date: startDate });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      angular.element.unblockUI();
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      angular.element.unblockUI();
      vm.listSalesCode = [];
    }

    function loadYear() {
      var response = endPoint.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function loadData(pageno) {
      vm.listOtselected = [];
      var resp = vm.DataTable.loadData(endPoint, pageno, {
        action: 'viewdata',
        period: vm.period,
        type: vm.type,
        company: vm.company,
        wilayah: vm.wilayah,
        regional: vm.regional,
        cabang: vm.cabang,
        area: vm.area
      });
      vm.listGhk = [];
    }

    function processData() {
      var year = vm.year;

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
      angular.element.blockUI();
      var response = endPoint.query({
        action: 'processData',
        area_sales_id: vm.Form.objForm.area_sales_id,
        sales_code: vm.sales_code,
        start: startDate,
        nik: vm.Form.objForm.empno,
        hke_sales: vm.hke_sales
      });
      response.$promise.then(fetchLoad);
      response.$promise.catch(errorFetchLoad);

    }

    function fetchLoad(data) {
      angular.element.unblockUI();
      showDialogInfo(data[0])
    }

    function isEmptyObject(obj) {
      return JSON.stringify(obj) === '{}';
    }

    function errorFetchLoad() {
      angular.element.unblockUI();
      vm.results = [];
    }

    function showDialogInfo(data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.messages.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.messages);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function successApproved(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Information')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              // loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          // loadData(1);
        }
      });

    }

    function failedApproved(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });

    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-process', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-process', {
                url: '/insentif-process',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-process/insentif-process.html',
                        controller: 'InsentifProcessController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-process')
        .controller('newInsentifProcessController', newInsentifProcessController);

    newInsentifProcessController.$inject = [
        '$localStorage',
        '$mdDialog',
        '$log',
        '$window',
        '$location',
        'Form',
        'AppAPI',
        '$element',
        '$filter',
        'Auth'
    ];
    /* @ngInject */
    function newInsentifProcessController(
        $localStorage,
        $mdDialog,
        $log,
        $window,
        $location,
        Form,
        AppAPI,
        $element,
        $filter,
        Auth
    ) {
        var vm = this;
        var translate = $filter('translate');
        var kpiSales = AppAPI.InsentifKpiSetting();
        var endPoint = AppAPI.InsentifProcess();

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        vm.company = $localStorage.empsite;
        vm.processData = processData;
        vm.getSalesCode = getSalesCode;
        vm.dialogClose = dialogClose;

        activate();

        function activate() {
            vm.selected = [];

            loadPeriod();
            getSalesType();
            getAreaSales();
            loadYear();
        }

        function getAreaSales() {
            var response = endPoint.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        function getSalesType() {
            var response = endPoint.query({ action: 'getSalesType' });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function loadYear() {
            var response = endPoint.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function processData() {
            var year = vm.year;

            var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
            angular.element.blockUI();
            var response = endPoint.query({
                action: 'processData',
                area_sales_id: vm.Form.objForm.area_sales_id,
                sales_code: vm.sales_code,
                start: startDate,
                nik: vm.Form.objForm.empno,
                hke_sales: vm.hke_sales
            });
            response.$promise.then(fetchLoad);
            response.$promise.catch(errorFetchLoad);

        }

        function fetchLoad(data) {
            angular.element.unblockUI();
            showDialogInfo(data[0])
        }

        function isEmptyObject(obj) {
            return JSON.stringify(obj) === '{}';
        }

        function errorFetchLoad() {
            angular.element.unblockUI();
            vm.results = [];
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });

        function reindex_array_keys(array, start) {
            var temp = [];
            start = typeof start == 'undefined' ? 0 : start;
            start = typeof start != 'number' ? 0 : start;
            for (var i in array) {
                temp[start++] = array[i];
            }
            return temp;
        }

        function saveData(ev, form) {
            angular.element.blockUI();

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title('Are you sure want to process ?')
                    .textContent('All data will be processed and can not recovered.')
                    .ariaLabel('process dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        vm.Form.objForm.subPeriod = vm.subperiod,
                            vm.Form.objForm.period = vm.period,
                            vm.Form.objForm.company = vm.company,
                            vm.Form.objForm.area = vm.area,
                            vm.Form.objForm.division = vm.division,
                            vm.Form.objForm.wilayah = vm.wilayah,
                            vm.Form.objForm.regional = vm.regional,
                            vm.Form.objForm.cabang = vm.cabang

                        var response = Form.saveData('processumut', form, endPoint);
                        response.then(function (data) {
                            angular.element.unblockUI();
                            form.$setPristine();
                            showDialogInfo(ev, data);
                        });

                        response.catch(function (data) {
                            angular.element.unblockUI();
                            form.$setPristine();
                            showDialogInfo(ev, data);
                        });
                    },
                    function () { }
                );
            });
        }

        function showDialogInfo(data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.messages.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.messages);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                )
                .then(function () {
                    dialogClose();
                    if ('moreInfo' in data && data.moreInfo.length > 0) {
                        $mdDialog.show({
                            controller: 'logFailGwController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: true,
                            onRemoving: function (element, removePromise) {
                                // loadData(1);
                            },
                            locals: {
                                data: data.moreInfo
                            }
                        });
                    } else {
                        // loadData(1);
                    }
                });
        }

        function getSalesCode(area) {
            angular.element.blockUI();
            var year = vm.year;
            var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

            var response = endPoint.query({ action: 'getSalesCode', area: area, date: startDate });
            response.$promise.then(fetchSalesCode);
            response.$promise.catch(errorFetchSalesCode);
        }

        function fetchSalesCode(data) {
            angular.element.unblockUI();
            vm.listSalesCode = data;
        }

        function errorFetchSalesCode() {
            angular.element.unblockUI();
            vm.listSalesCode = [];
        }

        function dialogClose() {
            $mdDialog.hide();
        }
    }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-process')
    .controller('InsentifProcessController', InsentifProcessController);

  InsentifProcessController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$location',
    '$window',
    '$element'
  ];
  /** @ngInject */
  function InsentifProcessController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $location,
    $window,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifProcess();
    var endPointUmutReport = AppAPI.Umutreport();
    var insentifApproval = AppAPI.InsentifApproval();
    var endPointUmutReport = AppAPI.Umutreport();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.results = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.getSalesCode = getSalesCode;
    vm.isEmptyObject = isEmptyObject;

    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.area = $localStorage.empSubarea;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.processData = processData;
    vm.LoadArea = LoadArea;
    vm.showProcessForm = showProcessForm;
    vm.viewComment = viewComment;
    vm.sumbitData = sumbitData;
    vm.disabledSubmit = disabledSubmit;
    vm.detail = detail;

    activate();

    function activate() {
      vm.selected = [];

      vm.LoadRegional = loadRegional;
      vm.LoadCabang = loadCabang;
      vm.LoadWilayah = loadWilayah;

      vm.reqWil = false;
      vm.reqArea = true;

      getSalesType();
      getAreaSales();
      loadYear();
      LoadPeriod();
      LoadSubPeriod();
      LoadCompany();
      loadWilayah();
    }

    function detail(ev, data) {
      $mdDialog.show({
        controller: 'InsentifApprovalDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-approval/insentif-approval-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function disabledSubmit() {
      var result = false;
      if (typeof vm.DataTable.list == 'undefined' || vm.DataTable.list.length == 0) {
        result = true;
      }

      return result;
    }

    function sumbitData(ev) {
      var jum = vm.DataTable.list.length;
      var i = 0;
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Are you sure want to submit ?')
            .textContent('All data will be submitted and can not recovered.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new endPoint();
            ot.data = [];
            ot.action = 'submitData';
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.DataTable.list[i]);
            }
            var response = ot.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              if (data.status == 1) {
                successApproved(ev, data);
              } else {
                failedApproved(ev, data);
              }
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
            });
          }, function () {

          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'AdditionalUmutViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          vm.listOtselected = [];
        },
        locals: {
          id: id
        }
      });
    }

    function showProcessForm() {
      $mdDialog.show({
        controller: 'newInsentifProcessController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-process/new-insentif-process.html',
        parent: angular.element($document.body),
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];

    function LoadArea(company, cabangid) {
      loadWilayah();
      var response = insentifApproval.query({ action: 'getArea', companyid: company, cabangid: cabangid });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listarea = data;
    }

    function errorFetchArea() {
      vm.listarea = [];
    }

    function LoadAreaDefault(company) {
      var response = insentifApproval.query({ action: 'getArea', companyid: company });
      response.$promise.then(fetchAreaDefault);
      response.$promise.catch(errorFetchAreaDefault);
    }

    function fetchAreaDefault(data) {
      vm.listarea = data;
    }

    function errorFetchAreaDefault() {
      vm.listarea = [];
    }

    function loadWilayah() {
      var response = insentifApproval.query({ action: 'getWilayah', companyid: vm.company });
      response.$promise.then(fetchWilayah);
      response.$promise.catch(errorFetchWilayah);
    }

    function fetchWilayah(data) {
      vm.listWilayah = data;
    }

    function errorFetchWilayah() {
      vm.listWilayah = [];
    }

    function loadRegional(id) {
      vm.listarea = [];
      vm.reqWil = true;
      vm.reqArea = false;
      var response = insentifApproval.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
      response.$promise.then(fetchRegional);
      response.$promise.catch(errorFetchRegional);
    }

    function fetchRegional(data) {
      vm.listRegional = data;
    }

    function errorFetchRegional() {
      vm.listRegional = [];
    }

    function loadCabang(id) {
      var response = insentifApproval.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
      response.$promise.then(fetchCabang);
      response.$promise.catch(errorFetchCabang);
    }

    function fetchCabang(data) {
      vm.listCabang = data;
    }

    function errorFetchCabang() {
      vm.listCabang = [];
    }

    function LoadSubPeriod() {
      var response = insentifApproval.query({ action: 'getSubPeriod' });
      response.$promise.then(fetchSubPeriod);
      response.$promise.catch(errorFetchSubPeriod);
    }

    function fetchSubPeriod(data) {
      vm.listsubperiod = data;
    }

    function errorFetchSubPeriod() {
      vm.listsubperiod = [];
    }

    function LoadPeriod() {
      var response = endPointUmutReport.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listperiod = data;
    }

    function errorFetchPeriod() {
      vm.listperiod = [];
    }

    function LoadCompany() {
      var response = insentifApproval.query({ action: 'getCompany' });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listcompany = data;
    }

    function errorFetchCompany() {
      vm.listcompany = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function getAreaSales() {
      var response = endPoint.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listarea = data;
    }

    function errorFetchAreaSales() {
      vm.listarea = [];
    }

    function getSalesType() {
      var response = endPoint.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function getSalesCode(area) {
      angular.element.blockUI();
      var year = vm.year;
      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

      var response = endPoint.query({ action: 'getSalesCode', area: area, date: startDate });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      angular.element.unblockUI();
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      angular.element.unblockUI();
      vm.listSalesCode = [];
    }

    function loadYear() {
      var response = endPoint.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function loadData(pageno) {
      vm.listOtselected = [];
      var resp = vm.DataTable.loadData(endPoint, pageno, {
        action: 'viewdata',
        period: vm.period,
        type: vm.type,
        company: vm.company,
        wilayah: vm.wilayah,
        regional: vm.regional,
        cabang: vm.cabang,
        area: vm.area,
        subperiod: vm.subperiod
      });
      vm.listGhk = [];
    }

    function processData() {
      var year = vm.year;

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
      angular.element.blockUI();
      var response = endPoint.query({
        action: 'processData',
        area_sales_id: vm.Form.objForm.area_sales_id,
        sales_code: vm.sales_code,
        start: startDate,
        nik: vm.Form.objForm.empno,
        hke_sales: vm.hke_sales
      });
      response.$promise.then(fetchLoad);
      response.$promise.catch(errorFetchLoad);

    }

    function fetchLoad(data) {
      angular.element.unblockUI();
      showDialogInfo(data[0])
    }

    function isEmptyObject(obj) {
      return JSON.stringify(obj) === '{}';
    }

    function errorFetchLoad() {
      angular.element.unblockUI();
      vm.results = [];
    }

    function showDialogInfo(data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.messages.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.messages);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function successApproved(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Information')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              // loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          // loadData(1);
        }
      });

    }

    function failedApproved(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });

    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-pinalty-sp', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-pinalty-sp', {
                url: '/insentif-pinalty-sp',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-pinalty-sp/insentif-pinalty-sp.html',
                        controller: 'InsentifPinaltySpController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-pinalty-sp')
        .controller('viewDocInsentifPinaltySp', viewDocInsentifPinaltySp);

    viewDocInsentifPinaltySp.$inject = ['$http', '$mdDialog', 'config', 'img'];

    /* @ngInject */
    function viewDocInsentifPinaltySp($http, $mdDialog, config, img) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal() {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage() {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = config.api + 'api/upload/incentive-pinalty-sp/' + vm.doc + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            // console.log(link);
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/incentive-pinalty-sp/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Document Not Found')
                        .textContent('Document not Found')
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-pinalty-sp')
        .controller('viewInsentifPinaltySpDetailController', viewInsentifPinaltySpDetailController);

    viewInsentifPinaltySpDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewInsentifPinaltySpDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var endPoint = AppAPI.InsentifPinaltySp();
        var kpiSales = AppAPI.InsentifKpiSetting();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.viewFile = viewFile
        vm.downloadDoc = downloadDoc

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];
        vm.listChannel = [
            {
                'id': 'GT',
                'name': 'GT'
            },
            {
                'id': 'MT',
                'name': 'MT'
            },
        ];
        vm.listSp = [
            {
                'id': 'SP1',
                'name': 'SP1'
            },
            {
                'id': 'SP2',
                'name': 'SP2'
            },
            {
                'id': 'SP3',
                'name': 'SP3'
            },
        ];

        loadPeriod();

        loadDetail();

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        loadYear()
        function loadYear() {
            var response = endPoint.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.channel = data[0].channel;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_created_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.empno = data[0].surkom_created_by;
            vm.Form.objForm.format = data[0].format;
            vm.Form.objForm.filename = data[0].filename;

            //set Item
            vm.listItem = data[0].listItem;
            var i, j;
            for (i = 0; i < vm.listItem.length; i++) {
                for (j = 0; j < vm.listItem[i].ach.length; j++) {
                    vm.listItem[i].ach[j].barcode = parseFloat(vm.listItem[i].ach[j].barcode);
                    vm.listItem[i].ach[j].pinalty = parseFloat(vm.listItem[i].ach[j].pinalty);
                }
            }
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        function downloadDoc(ev, filename) {
            var name = filename;
            if (name !== null && name !== '') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/incentive-pinalty' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                var message = $translate('HCTICKET.MESSAGE.FILENOTFOUND');
                var status = $translate('PAYROLL.MESSAGE.FAILED');

                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(message)
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }

        function viewFile(ev, img) {
            $mdDialog.show({
                controller: 'viewDocInsentifPinaltySp',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-pinalty-sp/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    img: img
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-pinalty-sp')
    .controller('InsentifPinaltySpController', InsentifPinaltySpController);

  InsentifPinaltySpController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function InsentifPinaltySpController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifPinaltySp();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.editData = editData;
    vm.copyData = copyData;
    vm.selectedItem = null;
    vm.searchText = null;

    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.downloadDoc = downloadDoc;
    vm.viewFile = viewFile;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.selectedItemChangedNo = selectedItemChangedNo;
    vm.getDataCode = getDataCode;

    vm.listStatus = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];

    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];


    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.surkom_creator = '';
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined' && employee) {
        vm.surkom_creator = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;
      }
    }

    function getDataCode(searchText) {
      return $http
        .get(config.api + 'api/insentifpinaltysp?action=searchSurkomNumber&id=' + searchText)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChangedNo(item) {
      vm.surkom_no = '';
      vm.Form.objForm.name = '';
      vm.Form.objForm.name = vm.searchStringSurkom;
      if (typeof item !== 'undefined' && item) {
        vm.surkom_no = item.id;
        vm.Form.objForm.name = item.name
      }
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        status: vm.status,
        surkom_date: vm.surkom_date,
        surkom_no: vm.surkom_no,
        surkom_creator: vm.surkom_creator,
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifPinaltySpInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-pinalty-sp/insentif-pinalty-sp-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifPinaltySpEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-pinalty-sp/insentif-pinalty-sp-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function copyData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifPinaltySpCopyController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-pinalty-sp/insentif-pinalty-sp-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewInsentifPinaltySpDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-pinalty-sp/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();

            vm.objForm = new endPoint();
            vm.objForm.action = 'delete';
            vm.objForm.data = vm.selected;
            var response = vm.objForm.$save();

            response.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = $translate(expmess[0]) + ', ' + expmess[1] + ' ' + $translate(expmess[2]) + ' ' + expmess[3] + ' ' + $translate(expmess[4]);
      } else {
        var message = $translate(data.pesan);
      }

      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function downloadDoc(ev, filename) {
      var name = filename;
      if (name !== null && name !== '') {
        $http({
          method: 'GET',
          url: config.api + 'api/upload/incentive-pinalty' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        }).success(function (data, status, headers) {
          headers = headers();
          var filename = name;
          var contentType = headers['content-type'];

          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], { type: contentType });
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
          } catch (ex) {
            console.log(ex);
          }
        }).error(function (data) {
          console.log(data);
        });
      } else {
        var message = $translate('HCTICKET.MESSAGE.FILENOTFOUND');
        var status = $translate('PAYROLL.MESSAGE.FAILED');

        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
        ).then(function () {
          // closeModal();
        });
      }
    }

    function viewFile(ev, img) {
      $mdDialog.show({
        controller: 'viewDocInsentifPinaltySp',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-pinalty-sp/view-doc.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        multiple: true,
        onRemoving: function (element, removePromise) {
          viewData();
        },
        locals: {
          img: img
        }
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-pinalty-sp')
    .controller('InsentifPinaltySpInputController', InsentifPinaltySpInputController);

  InsentifPinaltySpInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$filter',
    'FileUploader',
    '$http',
    '$localStorage',
    '$element',
    'config'
  ];
  /** @ngInject */
  function InsentifPinaltySpInputController(
    $mdDialog,
    AppAPI,
    Form,
    $filter,
    FileUploader,
    $http,
    $localStorage,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifPinaltySp();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    vm.upload = upload;

    vm.selectedItem = null;
    vm.searchText = null;
    vm.edit = false;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.fileSizeError = true;
    vm.showData = vm.showData2 = false;
    vm.company = $localStorage.empsite;
    vm.toggle = toggle;
    vm.exists = exists;
    vm.saveData = saveData;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.addAch = addAch;
    vm.addItem = addItem;
    vm.listAch = [];
    vm.listItem = [];

    vm.listStatus = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];
    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];
    vm.listSp = [
      {
        'id': 'SP1',
        'name': 'SP1'
      },
      {
        'id': 'SP2',
        'name': 'SP2'
      },
      {
        'id': 'SP3',
        'name': 'SP3'
      },
    ];

    vm.achList = [];
    //set achList
    var objAch = {};
    objAch["barcode"] = 0;
    objAch["operator"] = '<';
    objAch["pinalty"] = 0;
    vm.achList.push(objAch);

    loadYear()
    function loadYear() {
      var response = endPoint.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    var obj = {};
    obj["start"] = '';
    obj["start_year"] = '';
    obj["end"] = '';
    obj["ach"] = vm.achList;
    vm.listItem.push(obj);

    vm.delListAch = delListAch;

    function addAch(params) {
      var objAch = {};
      objAch["barcode"] = 0;
      objAch["operator"] = '<';
      objAch["pinalty"] = 0;

      params.push(objAch);
    }

    function delListAch(params, idx) {
      params.splice(idx, 1);
    }

    function addItem() {
      vm.achList = [];
      //set achList
      var objAch = {};
      objAch["barcode"] = 0;
      objAch["operator"] = '<';
      objAch["pinalty"] = 0;
      vm.achList.push(objAch);

      var obj = {};
      obj["start"] = '';
      obj["start_year"] = '';
      obj["end"] = '';
      obj["ach"] = vm.achList;
      vm.listItem.push(obj);
    }

    vm.Form.objForm.channel = 'GT';
    vm.Form.objForm.status = 'direct';

    activate();

    function activate() {
      vm.selected = [];
      loadPeriod();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function selectedItemChanged(item) {
      console.log(item)
      vm.Form.objForm.nik1 = '';
      if (typeof item !== 'undefined' && item) {
        vm.showData = true;
      }
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function upload(form) {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/insentifpinaltysp/upload',
      removeAfterUpload: true,
      alias: 'fileName',
      onBeforeUploadItem: function (item) {
        var dt = new Date(item.formData[0].surkom_date);
        var listItem = JSON.stringify(item.formData[0].listItem);

        var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
        item.formData[0].surkom_date = newdate;
        item.formData[0].listItem = listItem;

        angular.element.blockUI();
      },
      onSuccessItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }, onErrorItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }
    });

    uploaderPhoto.filters.push({
      name: 'enforceMaxFileSize',
      fn: function (item) {
        vm.itemSize = formatBytes(item.size);
        if (item.size > 0) {
          vm.fileSizeError = false;
          return true;
        } else {
          vm.fileSizeError = true;
          return false;
        }
      }
    });

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function formatBytes(bytes) {
      if (bytes < 1024) return bytes + ' Bytes';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
      else return (bytes / 1073741824).toFixed(3) + ' GB';
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-pinalty-sp')
        .controller('InsentifPinaltySpEditController', InsentifPinaltySpEditController);

    InsentifPinaltySpEditController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function InsentifPinaltySpEditController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var $translate = $filter('translate');

        var endPoint = AppAPI.InsentifPinaltySp();
        var kpiSales = AppAPI.InsentifKpiSetting();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.upload = upload
        vm.edit = true
        vm.fileSizeError = true;
        vm.company = $localStorage.empsite;
        vm.addAch = addAch;
        vm.addItem = addItem;
        vm.delListAch = delListAch;

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        vm.saveData = saveData;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getEmployee = getEmployee;
        vm.listAch = [];
        vm.Form.objForm.listItem = [];

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];
        vm.listChannel = [
            {
                'id': 'GT',
                'name': 'GT'
            },
            {
                'id': 'MT',
                'name': 'MT'
            },
        ];
        vm.listSp = [
            {
                'id': 'SP1',
                'name': 'SP1'
            },
            {
                'id': 'SP2',
                'name': 'SP2'
            },
            {
                'id': 'SP3',
                'name': 'SP3'
            },
        ];

        loadPeriod();
        loadDetail();
        loadYear()
        function loadYear() {
            var response = endPoint.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.id = data[0].id;
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.channel = data[0].channel;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_created_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.empno = data[0].surkom_created_by;
            vm.Form.objForm.nikEmp = data[0].surkom_created_by;
            vm.Form.objForm.format = data[0].format;
            vm.Form.objForm.filename = data[0].filename;

            //set Item
            vm.Form.objForm.listItem = data[0].listItem;
            var i, j;
            for (i = 0; i < vm.Form.objForm.listItem.length; i++) {
                for (j = 0; j < vm.Form.objForm.listItem[i].ach.length; j++) {
                    vm.Form.objForm.listItem[i].ach[j].barcode = parseFloat(vm.Form.objForm.listItem[i].ach[j].barcode);
                    vm.Form.objForm.listItem[i].ach[j].pinalty = parseFloat(vm.Form.objForm.listItem[i].ach[j].pinalty);
                }
            }
        }

        function errorFetchDetail() {
            //
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();
            var response = Form.saveData('update', frm, endPoint);
            response.then(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var message = $translate(data.pesan);
            var status = $translate(data.status);

            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function upload(form) {
            var resp = vm.FileUploaderPhoto.uploadAll();
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/insentifpinaltysp/upload',
            removeAfterUpload: true,
            alias: 'fileName',
            onBeforeUploadItem: function (item) {
                var dt = new Date(item.formData[0].surkom_date);
                var listTargetAbsolute = JSON.stringify(item.formData[0].listTargetAbsolute);
                var listPrincipal = JSON.stringify(item.formData[0].listPrincipal);
                var listFocus = JSON.stringify(item.formData[0].listFocus);

                var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                item.formData[0].surkom_date = newdate;
                item.formData[0].listTargetAbsolute = listTargetAbsolute;
                item.formData[0].listPrincipal = listPrincipal;
                item.formData[0].listFocus = listFocus;

                angular.element.blockUI();
            },
            onSuccessItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }, onErrorItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }
        });

        function formatBytes(bytes) {
            if (bytes < 1024) return bytes + ' Bytes';
            else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
            else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
            else return (bytes / 1073741824).toFixed(3) + ' GB';
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;

            if (typeof employee !== 'undefined' && employee) {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.empno = '';
                    }
                    return item.data;
                });
        }

        function addAch(params) {
            var objAch = {};
            objAch["barcode"] = 0;
            objAch["pinalty"] = 0;

            params.push(objAch);
        }

        function delListAch(params, idx) {
            params.splice(idx, 1);
        }

        function addItem() {
            vm.achList = [];
            //set achList
            var objAch = {};
            objAch["barcode"] = 0;
            objAch["pinalty"] = 0;
            vm.achList.push(objAch);

            var obj = {};
            obj["start"] = '';
            obj["start_year"] = '';
            obj["end"] = '';
            obj["ach"] = vm.achList;
            vm.Form.objForm.listItem.push(obj);
        }

        uploaderPhoto.filters.push({
            name: 'enforceMaxFileSize',
            fn: function (item) {
                vm.itemSize = formatBytes(item.size);
                if (item.size > 0) {
                    vm.fileSizeError = false;
                    return true;
                } else {
                    vm.fileSizeError = true;
                    return false;
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-pinalty', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-pinalty', {
                url: '/insentif-pinalty',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-pinalty/insentif-pinalty.html',
                        controller: 'InsentifPinaltyController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-pinalty')
        .controller('viewDocInsentifPinalty', viewDocInsentifPinalty);

    viewDocInsentifPinalty.$inject = ['$http', '$mdDialog', 'config', 'img'];

    /* @ngInject */
    function viewDocInsentifPinalty($http, $mdDialog, config, img) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal() {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage() {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = config.api + 'api/upload/incentive-pinalty/' + vm.doc + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            // console.log(link);
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/incentive-pinalty/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Document Not Found')
                        .textContent('Document not Found')
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-pinalty')
        .controller('viewInsentifPinaltyDetailController', viewInsentifPinaltyDetailController);

    viewInsentifPinaltyDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewInsentifPinaltyDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var endPoint = AppAPI.InsentifPinalty();
        var kpiSales = AppAPI.InsentifKpiSetting();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.viewFile = viewFile
        vm.downloadDoc = downloadDoc

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];
        vm.listChannel = [
            {
                'id': 'GT',
                'name': 'GT'
            },
            {
                'id': 'MT',
                'name': 'MT'
            },
        ];
        vm.listOperator = [
            {
                'id': '<',
                'name': '<'
            },
            {
                'id': '<=',
                'name': '<='
            },
            {
                'id': '>',
                'name': '>'
            },
            {
                'id': '>=',
                'name': '>='
            },
            {
                'id': '=',
                'name': '='
            },
        ];

        loadPeriod();

        loadDetail();

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        loadYear()
        function loadYear() {
            var response = endPoint.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.channel = data[0].channel;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_created_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.empno = data[0].surkom_created_by;
            vm.Form.objForm.format = data[0].format;
            vm.Form.objForm.filename = data[0].filename;

            //set Item
            vm.listItem = data[0].listItem;
            var i, j;
            for (i = 0; i < vm.listItem.length; i++) {
                for (j = 0; j < vm.listItem[i].ach.length; j++) {
                    vm.listItem[i].ach[j].barcode = parseFloat(vm.listItem[i].ach[j].barcode);
                    vm.listItem[i].ach[j].pinalty = parseFloat(vm.listItem[i].ach[j].pinalty);
                }
            }
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        function downloadDoc(ev, filename) {
            var name = filename;
            if (name !== null && name !== '') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/incentive-pinalty' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                var message = $translate('HCTICKET.MESSAGE.FILENOTFOUND');
                var status = $translate('PAYROLL.MESSAGE.FAILED');

                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(message)
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }

        function viewFile(ev, img) {
            $mdDialog.show({
                controller: 'viewDocInsentifPinalty',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-pinalty/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    img: img
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-pinalty')
    .controller('InsentifPinaltyController', InsentifPinaltyController);

  InsentifPinaltyController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function InsentifPinaltyController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifPinalty();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.editData = editData;
    vm.copyData = copyData;
    vm.selectedItem = null;
    vm.searchText = null;

    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.downloadDoc = downloadDoc;
    vm.viewFile = viewFile;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.selectedItemChangedNo = selectedItemChangedNo;
    vm.getDataCode = getDataCode;

    vm.listStatus = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];

    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];


    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.surkom_creator = '';
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined' && employee) {
        vm.surkom_creator = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;
      }
    }

    function getDataCode(searchText) {
      return $http
        .get(config.api + 'api/insentifpinalty?action=searchSurkomNumber&id=' + searchText)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChangedNo(item) {
      vm.surkom_no = '';
      vm.Form.objForm.name = '';
      vm.Form.objForm.name = vm.searchStringSurkom;
      if (typeof item !== 'undefined' && item) {
        vm.surkom_no = item.id;
        vm.Form.objForm.name = item.name
      }
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        status: vm.status,
        surkom_date: vm.surkom_date,
        surkom_no: vm.surkom_no,
        surkom_creator: vm.surkom_creator,
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifPinaltyInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-pinalty/insentif-pinalty-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifPinaltyEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-pinalty/insentif-pinalty-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function copyData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifPinaltyCopyController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-pinalty/insentif-pinalty-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewInsentifPinaltyDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-pinalty/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();

            vm.objForm = new endPoint();
            vm.objForm.action = 'delete';
            vm.objForm.data = vm.selected;
            var response = vm.objForm.$save();

            response.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = $translate(expmess[0]) + ', ' + expmess[1] + ' ' + $translate(expmess[2]) + ' ' + expmess[3] + ' ' + $translate(expmess[4]);
      } else {
        var message = $translate(data.pesan);
      }

      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function downloadDoc(ev, filename) {
      var name = filename;
      if (name !== null && name !== '') {
        $http({
          method: 'GET',
          url: config.api + 'api/upload/incentive-pinalty' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        }).success(function (data, status, headers) {
          headers = headers();
          var filename = name;
          var contentType = headers['content-type'];

          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], { type: contentType });
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
          } catch (ex) {
            console.log(ex);
          }
        }).error(function (data) {
          console.log(data);
        });
      } else {
        var message = $translate('HCTICKET.MESSAGE.FILENOTFOUND');
        var status = $translate('PAYROLL.MESSAGE.FAILED');

        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
        ).then(function () {
          // closeModal();
        });
      }
    }

    function viewFile(ev, img) {
      $mdDialog.show({
        controller: 'viewDocInsentifPinalty',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-pinalty/view-doc.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        multiple: true,
        onRemoving: function (element, removePromise) {
          viewData();
        },
        locals: {
          img: img
        }
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-pinalty')
    .controller('InsentifPinaltyInputController', InsentifPinaltyInputController);

  InsentifPinaltyInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$filter',
    'FileUploader',
    '$http',
    '$localStorage',
    '$element',
    'config'
  ];
  /** @ngInject */
  function InsentifPinaltyInputController(
    $mdDialog,
    AppAPI,
    Form,
    $filter,
    FileUploader,
    $http,
    $localStorage,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifPinalty();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    vm.upload = upload;

    vm.selectedItem = null;
    vm.searchText = null;
    vm.edit = false;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.fileSizeError = true;
    vm.showData = vm.showData2 = false;
    vm.company = $localStorage.empsite;
    vm.toggle = toggle;
    vm.exists = exists;
    vm.saveData = saveData;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.addAch = addAch;
    vm.addItem = addItem;
    vm.listAch = [];
    vm.listItem = [];

    vm.listStatus = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];
    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];
    vm.listOperator = [
      {
        'id': '<',
        'name': '<'
      },
      {
        'id': '<=',
        'name': '<='
      },
      {
        'id': '>',
        'name': '>'
      },
      {
        'id': '>=',
        'name': '>='
      },
      {
        'id': '=',
        'name': '='
      },
    ];

    vm.achList = [];
    //set achList
    var objAch = {};
    objAch["barcode"] = 0;
    objAch["operator"] = '<';
    objAch["pinalty"] = 0;
    vm.achList.push(objAch);

    loadYear()
    function loadYear() {
      var response = endPoint.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    var obj = {};
    obj["start"] = '';
    obj["start_year"] = '';
    obj["end"] = '';
    obj["ach"] = vm.achList;
    vm.listItem.push(obj);

    vm.delListAch = delListAch;

    function addAch(params) {
      var objAch = {};
      objAch["barcode"] = 0;
      objAch["operator"] = '<';
      objAch["pinalty"] = 0;

      params.push(objAch);
    }

    function delListAch(params, idx) {
      params.splice(idx, 1);
    }

    function addItem() {
      vm.achList = [];
      //set achList
      var objAch = {};
      objAch["barcode"] = 0;
      objAch["operator"] = '<';
      objAch["pinalty"] = 0;
      vm.achList.push(objAch);

      var obj = {};
      obj["start"] = '';
      obj["start_year"] = '';
      obj["end"] = '';
      obj["ach"] = vm.achList;
      vm.listItem.push(obj);
    }

    vm.Form.objForm.channel = 'GT';
    vm.Form.objForm.status = 'direct';

    activate();

    function activate() {
      vm.selected = [];
      loadPeriod();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function selectedItemChanged(item) {
      console.log(item)
      vm.Form.objForm.nik1 = '';
      if (typeof item !== 'undefined' && item) {
        vm.showData = true;
      }
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function upload(form) {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/insentifpinalty/upload',
      removeAfterUpload: true,
      alias: 'fileName',
      onBeforeUploadItem: function (item) {
        var dt = new Date(item.formData[0].surkom_date);
        var listItem = JSON.stringify(item.formData[0].listItem);

        var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
        item.formData[0].surkom_date = newdate;
        item.formData[0].listItem = listItem;

        angular.element.blockUI();
      },
      onSuccessItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }, onErrorItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }
    });

    uploaderPhoto.filters.push({
      name: 'enforceMaxFileSize',
      fn: function (item) {
        vm.itemSize = formatBytes(item.size);
        if (item.size > 0) {
          vm.fileSizeError = false;
          return true;
        } else {
          vm.fileSizeError = true;
          return false;
        }
      }
    });

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function formatBytes(bytes) {
      if (bytes < 1024) return bytes + ' Bytes';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
      else return (bytes / 1073741824).toFixed(3) + ' GB';
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-pinalty')
        .controller('InsentifPinaltyEditController', InsentifPinaltyEditController);

    InsentifPinaltyEditController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function InsentifPinaltyEditController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var $translate = $filter('translate');

        var endPoint = AppAPI.InsentifPinalty();
        var kpiSales = AppAPI.InsentifKpiSetting();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.upload = upload
        vm.edit = true
        vm.fileSizeError = true;
        vm.company = $localStorage.empsite;
        vm.addAch = addAch;
        vm.addItem = addItem;
        vm.delListAch = delListAch;

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        vm.saveData = saveData;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getEmployee = getEmployee;
        vm.listAch = [];
        vm.Form.objForm.listItem = [];

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];
        vm.listChannel = [
            {
                'id': 'GT',
                'name': 'GT'
            },
            {
                'id': 'MT',
                'name': 'MT'
            },
        ];
        vm.listOperator = [
            {
                'id': '<',
                'name': '<'
            },
            {
                'id': '<=',
                'name': '<='
            },
            {
                'id': '>',
                'name': '>'
            },
            {
                'id': '>=',
                'name': '>='
            },
            {
                'id': '=',
                'name': '='
            },
        ];

        loadPeriod();
        loadDetail();
        loadYear()
        function loadYear() {
            var response = endPoint.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.id = data[0].id;
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.channel = data[0].channel;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_created_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.empno = data[0].surkom_created_by;
            vm.Form.objForm.nikEmp = data[0].surkom_created_by;
            vm.Form.objForm.format = data[0].format;
            vm.Form.objForm.filename = data[0].filename;

            //set Item
            vm.Form.objForm.listItem = data[0].listItem;
            var i, j;
            for (i = 0; i < vm.Form.objForm.listItem.length; i++) {
                for (j = 0; j < vm.Form.objForm.listItem[i].ach.length; j++) {
                    vm.Form.objForm.listItem[i].ach[j].barcode = parseFloat(vm.Form.objForm.listItem[i].ach[j].barcode);
                    vm.Form.objForm.listItem[i].ach[j].pinalty = parseFloat(vm.Form.objForm.listItem[i].ach[j].pinalty);
                }
            }
        }

        function errorFetchDetail() {
            //
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();
            var response = Form.saveData('update', frm, endPoint);
            response.then(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var message = $translate(data.pesan);
            var status = $translate(data.status);

            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function upload(form) {
            var resp = vm.FileUploaderPhoto.uploadAll();
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/InsentifPinalty/upload',
            removeAfterUpload: true,
            alias: 'fileName',
            onBeforeUploadItem: function (item) {
                var dt = new Date(item.formData[0].surkom_date);
                var listTargetAbsolute = JSON.stringify(item.formData[0].listTargetAbsolute);
                var listPrincipal = JSON.stringify(item.formData[0].listPrincipal);
                var listFocus = JSON.stringify(item.formData[0].listFocus);

                var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                item.formData[0].surkom_date = newdate;
                item.formData[0].listTargetAbsolute = listTargetAbsolute;
                item.formData[0].listPrincipal = listPrincipal;
                item.formData[0].listFocus = listFocus;

                angular.element.blockUI();
            },
            onSuccessItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }, onErrorItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }
        });

        function formatBytes(bytes) {
            if (bytes < 1024) return bytes + ' Bytes';
            else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
            else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
            else return (bytes / 1073741824).toFixed(3) + ' GB';
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;

            if (typeof employee !== 'undefined' && employee) {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.empno = '';
                    }
                    return item.data;
                });
        }

        function addAch(params) {
            var objAch = {};
            objAch["barcode"] = 0;
            objAch["operator"] = '<';
            objAch["pinalty"] = 0;

            params.push(objAch);
        }

        function delListAch(params, idx) {
            params.splice(idx, 1);
        }

        function addItem() {
            vm.achList = [];
            //set achList
            var objAch = {};
            objAch["barcode"] = 0;
            objAch["operator"] = '<';
            objAch["pinalty"] = 0;
            vm.achList.push(objAch);

            var obj = {};
            obj["start"] = '';
            obj["start_year"] = '';
            obj["end"] = '';
            obj["ach"] = vm.achList;
            vm.Form.objForm.listItem.push(obj);
        }

        uploaderPhoto.filters.push({
            name: 'enforceMaxFileSize',
            fn: function (item) {
                vm.itemSize = formatBytes(item.size);
                if (item.size > 0) {
                    vm.fileSizeError = false;
                    return true;
                } else {
                    vm.fileSizeError = true;
                    return false;
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-override-target-absolute', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-override-target-absolute', {
                url: '/insentif-override-target-absolute',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-override-target-absolute/insentif-override-target-absolute.html',
                        controller: 'InsentifOverrideTargetAbsoluteController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-override-target-absolute')
        .controller('viewDocInsentifOverrideTargetAbsolute', viewDocInsentifOverrideTargetAbsolute);

    viewDocInsentifOverrideTargetAbsolute.$inject = ['$http', '$mdDialog', 'config', 'img'];

    /* @ngInject */
    function viewDocInsentifOverrideTargetAbsolute($http, $mdDialog, config, img) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal() {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage() {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = config.api + 'api/upload/target-absolute/' + vm.doc + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            // console.log(link);
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/target-absolute/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Document Not Found')
                        .textContent('Document not Found')
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-override-target-absolute')
        .controller('viewInsentifOverrideTargetAbsoluteDetailController', viewInsentifOverrideTargetAbsoluteDetailController);

    viewInsentifOverrideTargetAbsoluteDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewInsentifOverrideTargetAbsoluteDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var endPoint = AppAPI.InsentifOverrideTargetAbsolute();
        var absolute = AppAPI.InsentifTargetAbsolute();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var SalesCode = AppAPI.RefSalesCode();
        var penalty = AppAPI.InsentifPinalty();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.company = $localStorage.empsite;
        vm.dialogClose = dialogClose
        vm.exists = exists

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];

        loadPeriod();
        getAreaSales();
        loadDetail();

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function getAreaSales() {
            var response = SalesCode.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.description = data[0].description;
            vm.Form.objForm.start_year = data[0].start_year;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.end_year = data[0].end_year;
            vm.Form.objForm.area_sales_id = data[0].area_sales_id;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_created_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.empno = data[0].surkom_created_by;

            vm.Form.objForm.listFocus = data[0].listFocus;
            var i;
            for (i = 0; i < data[0].listFocus.length; i++) {
                vm.Form.objForm.listFocus[i].amountFocus = parseFloat(vm.Form.objForm.listFocus[i].amountFocus);
            }
            vm.Form.objForm.listPrincipal = data[0].listPrincipal;
            var i;
            for (i = 0; i < data[0].listPrincipal.length; i++) {
                vm.Form.objForm.listPrincipal[i].roa = parseFloat(vm.Form.objForm.listPrincipal[i].roa);
                vm.Form.objForm.listPrincipal[i].ec = parseFloat(vm.Form.objForm.listPrincipal[i].ec);
            }
            //set targetAbsolute
            vm.Form.objForm.listTargetAbsolute = data[0].listTargetAbsolute;
            var i;
            for (i = 0; i < data[0].listTargetAbsolute.length; i++) {
                vm.Form.objForm.listTargetAbsolute[i].roa = parseFloat(vm.Form.objForm.listTargetAbsolute[i].roa);
                vm.Form.objForm.listTargetAbsolute[i].ec = parseFloat(vm.Form.objForm.listTargetAbsolute[i].ec);
            }
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        loadYear()
        function loadYear() {
            var response = penalty.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-override-target-absolute')
    .controller('InsentifOverrideTargetAbsoluteController', InsentifOverrideTargetAbsoluteController);

  InsentifOverrideTargetAbsoluteController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function InsentifOverrideTargetAbsoluteController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifOverrideTargetAbsolute();
    var absolute = AppAPI.InsentifTargetAbsolute();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.editData = editData;
    vm.copyData = copyData;
    vm.selectedItem = null;
    vm.searchText = null;

    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.downloadDoc = downloadDoc;
    vm.viewFile = viewFile;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.selectedItemChangedNo = selectedItemChangedNo;
    vm.getDataCode = getDataCode;

    vm.listStatus = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];


    activate();

    function activate() {
      vm.selected = [];
      loadData(1);

      loadSalesType();
      loadAbsoluteType();
      loadPrincipal();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.surkom_creator = '';
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined' && employee) {
        vm.surkom_creator = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;
      }
    }

    function getDataCode(searchText) {
      return $http
        .get(config.api + 'api/insentiftargetabsolute?action=searchSurkomNumber&id=' + searchText)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChangedNo(item) {
      vm.surkom_no = '';
      vm.Form.objForm.name = '';
      vm.Form.objForm.name = vm.searchStringSurkom;
      if (typeof item !== 'undefined' && item) {
        vm.surkom_no = item.id;
        vm.Form.objForm.name = item.name
      }
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        status: vm.status,
        surkom_date: vm.surkom_date,
        surkom_no: vm.surkom_no,
        surkom_creator: vm.surkom_creator,
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifOverrideTargetAbsoluteInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-override-target-absolute/insentif-override-target-absolute-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifTargetAbsoluteEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-override-target-absolute/insentif-override-target-absolute-edit.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function copyData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifTargetAbsoluteCopyController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-override-target-absolute/insentif-override-target-absolute-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewInsentifOverrideTargetAbsoluteDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-override-target-absolute/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function loadSalesType() {
      var response = kpiSales.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function loadAbsoluteType() {
      var response = endPoint.query({ action: 'getAbsoluteType' });
      response.$promise.then(fetchAbsoluteType);
      response.$promise.catch(errorFetchAbsoluteType);
    }

    function fetchAbsoluteType(data) {
      vm.listAbsoluteType = data;
    }

    function errorFetchAbsoluteType() {
      vm.listAbsoluteType = [];
    }

    function loadPrincipal() {
      var response = endPoint.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.listprincipal = data;
    }

    function errorFetchPrincipal() {
      vm.listprincipal = [];
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();

            vm.objForm = new endPoint();
            vm.objForm.action = 'delete';
            vm.objForm.data = vm.selected;
            var response = vm.objForm.$save();

            response.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = $translate(expmess[0]) + ', ' + expmess[1] + ' ' + $translate(expmess[2]) + ' ' + expmess[3] + ' ' + $translate(expmess[4]);
      } else {
        var message = $translate(data.pesan);
      }

      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function downloadDoc(ev, filename) {
      var name = filename;
      if (name !== null && name !== '') {
        $http({
          method: 'GET',
          url: config.api + 'api/upload/target-absolute' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        }).success(function (data, status, headers) {
          headers = headers();
          var filename = name;
          var contentType = headers['content-type'];

          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], { type: contentType });
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
          } catch (ex) {
            console.log(ex);
          }
        }).error(function (data) {
          console.log(data);
        });
      } else {
        var message = $translate('HCTICKET.MESSAGE.FILENOTFOUND');
        var status = $translate('PAYROLL.MESSAGE.FAILED');

        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
        ).then(function () {
          // closeModal();
        });
      }
    }

    function viewFile(ev, img) {
      $mdDialog.show({
        controller: 'viewDocInsentifTargetAbsolute',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-override-target-absolute/view-doc.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        multiple: true,
        onRemoving: function (element, removePromise) {
          viewData();
        },
        locals: {
          img: img
        }
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-override-target-absolute')
    .controller('InsentifOverrideTargetAbsoluteInputController', InsentifOverrideTargetAbsoluteInputController);

  InsentifOverrideTargetAbsoluteInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$filter',
    'FileUploader',
    '$http',
    '$localStorage',
    '$element',
    'config'
  ];
  /** @ngInject */
  function InsentifOverrideTargetAbsoluteInputController(
    $mdDialog,
    AppAPI,
    Form,
    $filter,
    FileUploader,
    $http,
    $localStorage,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifOverrideTargetAbsolute();
    var absolute = AppAPI.InsentifTargetAbsolute();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var penalty = AppAPI.InsentifPinalty();
    var SalesCode = AppAPI.RefSalesCode();

    var $translate = $filter('translate');

    vm.upload = upload;

    vm.selectedItem = null;
    vm.searchText = null;
    vm.edit = false;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.getSku = getSku;
    vm.fileSizeError = true;
    vm.showData = vm.showData2 = false;
    vm.company = $localStorage.empsite;
    vm.toggle = toggle;
    vm.exists = exists;
    vm.saveData = saveData;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.loadDetail = loadDetail;
    vm.listStatus = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];

    var dt = new Date();
    vm.year = dt.getFullYear();
    vm.Form.objForm.start_year = vm.year;
    vm.Form.objForm.end_year = vm.year;

    activate();

    function activate() {
      vm.selected = [];
      loadSalesType();
      loadAbsoluteType();
      loadFocus();
      loadPrincipal();
      loadPeriod();
      loadRefAbsolute();
      getAreaSales();
    }

    function getAreaSales() {
      var response = SalesCode.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function loadDetail(id) {
      var response = endPoint.query({ action: 'viewDetail', id: id, type: 'ref' });
      response.$promise.then(fetchDetail);
      response.$promise.catch(errorFetchDetail);
    }

    function fetchDetail(data) {
      vm.Form.objForm.id = data[0].id;
      vm.Form.objForm.surkom_no_ref = data[0].surkom_no;
      vm.Form.objForm.status = data[0].status;
      vm.Form.objForm.start_year = data[0].start_year;
      vm.Form.objForm.start = data[0].start;
      vm.Form.objForm.end = data[0].end;
      vm.Form.objForm.end_year = data[0].end_year;
      vm.Form.objForm.surkom_date_ref = new Date(data[0].surkom_date);
      vm.Form.objForm.nik_ref = data[0].surkom_created_by + ' - ' + data[0].surkom_creator;

      vm.Form.objForm.listFocus = data[0].listFocus;
      var i;
      for (i = 0; i < data[0].listFocus.length; i++) {
        vm.Form.objForm.listFocus[i].amountFocus = parseFloat(vm.Form.objForm.listFocus[i].amountFocus);
      }
      vm.Form.objForm.listPrincipal = data[0].listPrincipal;
      var i;
      for (i = 0; i < data[0].listPrincipal.length; i++) {
        vm.Form.objForm.listPrincipal[i].roa = parseFloat(vm.Form.objForm.listPrincipal[i].roa);
        vm.Form.objForm.listPrincipal[i].ec = parseFloat(vm.Form.objForm.listPrincipal[i].ec);
      }
      //set targetAbsolute
      vm.Form.objForm.listTargetAbsolute = data[0].listTargetAbsolute;
      var i;
      for (i = 0; i < data[0].listTargetAbsolute.length; i++) {
        vm.Form.objForm.listTargetAbsolute[i].roa = parseFloat(vm.Form.objForm.listTargetAbsolute[i].roa);
        vm.Form.objForm.listTargetAbsolute[i].ec = parseFloat(vm.Form.objForm.listTargetAbsolute[i].ec);
      }
    }

    function errorFetchDetail() {
      vm.targetDepartmentList = [];
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function loadRefAbsolute() {
      var response = endPoint.query({ action: 'searchSurkomNumberAbsolute' });
      response.$promise.then(fetchRefAbsolute);
      response.$promise.catch(errorFetchRefAbsolute);
    }

    function fetchRefAbsolute(data) {
      vm.listRefAbsolute = data;
    }

    function errorFetchRefAbsolute() {
      vm.listRefAbsolute = [];
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function loadSalesType() {
      var response = kpiSales.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    loadYear()
    function loadYear() {
      var response = penalty.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function loadAbsoluteType() {
      var response = endPoint.query({ action: 'getAbsoluteType', isFocus: 0 });
      response.$promise.then(fetchAbsoluteType);
      response.$promise.catch(errorFetchAbsoluteType);
    }

    function fetchAbsoluteType(data) {
      vm.Form.objForm.listTargetAbsolute = data;
      var i;
      for (i = 0; i < data.length; i++) {
        vm.Form.objForm.listTargetAbsolute[i].roa = parseFloat(data[i].roa);
        vm.Form.objForm.listTargetAbsolute[i].ec = parseFloat(data[i].ec);
      }
    }

    function errorFetchAbsoluteType() {
      vm.Form.objForm.listTargetAbsolute = [];
    }

    function loadFocus() {
      var response = endPoint.query({ action: 'getAbsoluteType', isFocus: 1 });
      response.$promise.then(fetchFocus);
      response.$promise.catch(errorFetchFocus);
    }

    function fetchFocus(data) {
      vm.Form.objForm.listFocus = data;
      var i;
      for (i = 0; i < data.length; i++) {
        vm.Form.objForm.listFocus[i].amountFocus = parseFloat(data[i].amountFocus);
      }
    }

    function errorFetchFocus() {
      vm.Form.objForm.listFocus = [];
    }

    function loadPrincipal() {
      var response = endPoint.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.Form.objForm.listPrincipal = data;
      var i;
      for (i = 0; i < data.length; i++) {
        vm.Form.objForm.listPrincipal[i].roa = parseFloat(vm.Form.objForm.listPrincipal[i].roa);
        vm.Form.objForm.listPrincipal[i].ec = parseFloat(vm.Form.objForm.listPrincipal[i].ec);
      }
    }

    function errorFetchPrincipal() {
      vm.Form.objForm.listPrincipal = [];
    }

    function selectedItemChanged(item) {
      console.log(item)
      vm.Form.objForm.nik1 = '';
      if (typeof item !== 'undefined' && item) {
        vm.showData = true;
      }
    }

    function getSku(searchText) {
      return $http
        .get(config.api + 'api/insentifoverridetargetabsolute?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function upload(form) {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/insentifoverridetargetabsolute/upload',
      removeAfterUpload: true,
      alias: 'fileName',
      onBeforeUploadItem: function (item) {
        var dt = new Date(item.formData[0].surkom_date);
        var listTargetAbsolute = JSON.stringify(item.formData[0].listTargetAbsolute);
        var listPrincipal = JSON.stringify(item.formData[0].listPrincipal);
        var listFocus = JSON.stringify(item.formData[0].listFocus);

        var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
        item.formData[0].surkom_date = newdate;
        item.formData[0].listTargetAbsolute = listTargetAbsolute;
        item.formData[0].listPrincipal = listPrincipal;
        item.formData[0].listFocus = listFocus;

        angular.element.blockUI();
      },
      onSuccessItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }, onErrorItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }
    });

    uploaderPhoto.filters.push({
      name: 'enforceMaxFileSize',
      fn: function (item) {
        vm.itemSize = formatBytes(item.size);
        if (item.size > 0) {
          vm.fileSizeError = false;
          return true;
        } else {
          vm.fileSizeError = true;
          return false;
        }
      }
    });

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function formatBytes(bytes) {
      if (bytes < 1024) return bytes + ' Bytes';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
      else return (bytes / 1073741824).toFixed(3) + ' GB';
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-override-target-absolute')
        .controller('InsentifOverrideTargetAbsoluteEditController', InsentifOverrideTargetAbsoluteEditController);

    InsentifOverrideTargetAbsoluteEditController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function InsentifOverrideTargetAbsoluteEditController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var $translate = $filter('translate');

        var endPoint = AppAPI.InsentifOverrideTargetAbsolute();
        var absolute = AppAPI.InsentifTargetAbsolute();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var penalty = AppAPI.InsentifPinalty();
        var SalesCode = AppAPI.RefSalesCode();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.upload = upload
        vm.edit = true
        vm.fileSizeError = true;
        vm.company = $localStorage.empsite;

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        vm.saveData = saveData;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getEmployee = getEmployee;

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];

        loadPeriod();
        loadDetail();
        getAreaSales();

        function getAreaSales() {
            var response = SalesCode.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.id = data[0].id;
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.link_file = data[0].link_file;
            vm.Form.objForm.description = data[0].description;
            vm.Form.objForm.status = data[0].status;
            vm.Form.objForm.start_year = data[0].start_year;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.end_year = data[0].end_year;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_created_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.empnik = data[0].surkom_created_by;

            vm.Form.objForm.listFocus = data[0].listFocus;
            var i;
            for (i = 0; i < data[0].listFocus.length; i++) {
                vm.Form.objForm.listFocus[i].amountFocus = parseFloat(vm.Form.objForm.listFocus[i].amountFocus);
            }
            vm.Form.objForm.listPrincipal = data[0].listPrincipal;
            var i;
            for (i = 0; i < data[0].listPrincipal.length; i++) {
                vm.Form.objForm.listPrincipal[i].roa = parseFloat(vm.Form.objForm.listPrincipal[i].roa);
                vm.Form.objForm.listPrincipal[i].ec = parseFloat(vm.Form.objForm.listPrincipal[i].ec);
            }
            //set targetAbsolute
            vm.Form.objForm.listTargetAbsolute = data[0].listTargetAbsolute;
            var i;
            for (i = 0; i < data[0].listTargetAbsolute.length; i++) {
                vm.Form.objForm.listTargetAbsolute[i].roa = parseFloat(vm.Form.objForm.listTargetAbsolute[i].roa);
                vm.Form.objForm.listTargetAbsolute[i].ec = parseFloat(vm.Form.objForm.listTargetAbsolute[i].ec);
            }
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        loadYear()
        function loadYear() {
            var response = penalty.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();
            var response = Form.saveData('update', frm, endPoint);
            response.then(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var message = $translate(data.pesan);
            var status = $translate(data.status);

            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function upload(form) {
            var resp = vm.FileUploaderPhoto.uploadAll();
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/insentifOverridetargetabsolute/upload',
            removeAfterUpload: true,
            alias: 'fileName',
            onBeforeUploadItem: function (item) {
                var dt = new Date(item.formData[0].surkom_date);
                var listTargetAbsolute = JSON.stringify(item.formData[0].listTargetAbsolute);
                var listPrincipal = JSON.stringify(item.formData[0].listPrincipal);
                var listFocus = JSON.stringify(item.formData[0].listFocus);

                var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                item.formData[0].surkom_date = newdate;
                item.formData[0].listTargetAbsolute = listTargetAbsolute;
                item.formData[0].listPrincipal = listPrincipal;
                item.formData[0].listFocus = listFocus;

                angular.element.blockUI();
            },
            onSuccessItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }, onErrorItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }
        });

        function formatBytes(bytes) {
            if (bytes < 1024) return bytes + ' Bytes';
            else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
            else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
            else return (bytes / 1073741824).toFixed(3) + ' GB';
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;

            if (typeof employee !== 'undefined' && employee) {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.empno = '';
                    }
                    return item.data;
                });
        }

        uploaderPhoto.filters.push({
            name: 'enforceMaxFileSize',
            fn: function (item) {
                vm.itemSize = formatBytes(item.size);
                if (item.size > 0) {
                    vm.fileSizeError = false;
                    return true;
                } else {
                    vm.fileSizeError = true;
                    return false;
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-override-target-absolute')
        .controller('InsentifOverrideTargetAbsoluteCopyController', InsentifOverrideTargetAbsoluteCopyController);

    InsentifOverrideTargetAbsoluteCopyController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function InsentifOverrideTargetAbsoluteCopyController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var $translate = $filter('translate');

        var endPoint = AppAPI.InsentifOverrideTargetAbsolute();
        var endPoint = AppAPI.InsentifTargetAbsolute();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var penalty = AppAPI.InsentifPinalty();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists
        vm.upload = upload
        vm.edit = true
        vm.fileSizeError = true;
        vm.company = $localStorage.empsite;

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        vm.saveData = saveData;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getEmployee = getEmployee;

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];

        loadPeriod();
        loadDetail();

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.listFocus = data[0].listFocus;
            vm.Form.objForm.status = data[0].status;
            var i;
            for (i = 0; i < data[0].listFocus.length; i++) {
                vm.Form.objForm.listFocus[i].amountFocus = parseFloat(vm.Form.objForm.listFocus[i].amountFocus);
            }
            vm.Form.objForm.listPrincipal = data[0].listPrincipal;
            var i;
            for (i = 0; i < data[0].listPrincipal.length; i++) {
                vm.Form.objForm.listPrincipal[i].roa = parseFloat(vm.Form.objForm.listPrincipal[i].roa);
                vm.Form.objForm.listPrincipal[i].ec = parseFloat(vm.Form.objForm.listPrincipal[i].ec);
            }
            //set targetAbsolute
            vm.Form.objForm.listTargetAbsolute = data[0].listTargetAbsolute;
            var i;
            for (i = 0; i < data[0].listTargetAbsolute.length; i++) {
                vm.Form.objForm.listTargetAbsolute[i].roa = parseFloat(vm.Form.objForm.listTargetAbsolute[i].roa);
                vm.Form.objForm.listTargetAbsolute[i].ec = parseFloat(vm.Form.objForm.listTargetAbsolute[i].ec);
            }
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        loadYear()
        function loadYear() {
            var response = penalty.query({ action: 'getYear' });
            response.$promise.then(fetchYear);
            response.$promise.catch(errorFetchYear);
        }

        function fetchYear(data) {
            vm.listYear = data;
        }

        function errorFetchYear() {
            vm.listYear = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();
            var response = Form.saveData('save', frm, endPoint);
            response.then(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var message = $translate(data.pesan);
            var status = $translate(data.status);

            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function upload(form) {
            var resp = vm.FileUploaderPhoto.uploadAll();
        }

        var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
            url: config.api + 'api/insentifOverridetargetabsolute/upload',
            removeAfterUpload: true,
            alias: 'fileName',
            onBeforeUploadItem: function (item) {
                var dt = new Date(item.formData[0].surkom_date);
                var listTargetAbsolute = JSON.stringify(item.formData[0].listTargetAbsolute);
                var listPrincipal = JSON.stringify(item.formData[0].listPrincipal);
                var listFocus = JSON.stringify(item.formData[0].listFocus);

                var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
                item.formData[0].surkom_date = newdate;
                item.formData[0].listTargetAbsolute = listTargetAbsolute;
                item.formData[0].listPrincipal = listPrincipal;
                item.formData[0].listFocus = listFocus;

                angular.element.blockUI();
            },
            onSuccessItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }, onErrorItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                var ev = '';
                showDialogInfo(ev, response);
            }
        });

        function formatBytes(bytes) {
            if (bytes < 1024) return bytes + ' Bytes';
            else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
            else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
            else return (bytes / 1073741824).toFixed(3) + ' GB';
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;

            if (typeof employee !== 'undefined' && employee) {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }

        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.empno = '';
                    }
                    return item.data;
                });
        }

        uploaderPhoto.filters.push({
            name: 'enforceMaxFileSize',
            fn: function (item) {
                vm.itemSize = formatBytes(item.size);
                if (item.size > 0) {
                    vm.fileSizeError = false;
                    return true;
                } else {
                    vm.fileSizeError = true;
                    return false;
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-monitoring-lph', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-monitoring-lph', {
                url: '/insentif-monitoring-lph',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-monitoring-lph/insentif-monitoring-lph.html',
                        controller: 'InsentifMonitoringLphController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-monitoring-lph')
    .controller('InsentifMonitoringLphController', InsentifMonitoringLphController);

  InsentifMonitoringLphController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function InsentifMonitoringLphController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var $translate = $filter('translate');
    var endPoint = AppAPI.Insentifmonitoringlph();

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];

    vm.company = $localStorage.empsite;

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        date: vm.date,
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-calculationass', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-calculationass', {
                url: '/insentif-calculationass',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-calculationass/insentif-calculationass.html',
                        controller: 'InsentifCalculationassController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-calculationass')
    .controller('InsentifMonitoringController', InsentifMonitoringController);

  InsentifMonitoringController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$location',
    '$window',
    '$element'
  ];
  /** @ngInject */
  function InsentifMonitoringController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $location,
    $window,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.Insentifmonitoring();
    var insentifCalculation = AppAPI.InsentifCalculation();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.download = download;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.results = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.getSalesCode = getSalesCode;
    vm.isEmptyObject = isEmptyObject;
    vm.download = download;

    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    LoadArea(vm.company)

    function download() {
      var year = vm.year;

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

      var token = Auth.setTokenPromise();
      var area_sales_id = vm.Form.objForm.area_sales_id
      var sales_code = vm.sales_code
      var start = startDate

      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifcalculationass/exportpdf/' + area_sales_id + '/' + sales_code + '/' + start + '/' + data.token, '_blank');
      }, function () {
        $window.alert('gagal load token')
      });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function LoadArea(company) {
      var response = insentifCalculation.query({ action: 'getAreaSales', companyid: company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listarea = data;
    }

    function errorFetchArea() {
      vm.listarea = [];
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    activate();

    function activate() {
      vm.selected = [];

      loadPeriod();
      loadYear();
    }

    function getSalesCode(area) {
      angular.element.blockUI();
      var year = vm.year;
      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

      var response = endPoint.query({ action: 'getSalesCode', area: area, date: startDate });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      angular.element.unblockUI();
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      angular.element.unblockUI();
      vm.listSalesCode = [];
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function loadYear() {
      var response = endPoint.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function loadData(pageno) {
      var year = vm.year;

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
      angular.element.blockUI();
      var response = endPoint.query({
        action: 'viewData',
        area_sales_id: vm.area,
        sales_code: vm.sales_code,
        start: startDate,
        nik: vm.Form.objForm.empno,
        hke_sales: vm.hke_sales
      });
      response.$promise.then(fetchLoad);
      response.$promise.catch(errorFetchLoad);

    }

    function download() {
      var year = vm.year;

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

      var token = Auth.setTokenPromise();
      var area_sales_id = vm.area
      var sales_code = vm.sales_code
      var start = startDate

      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifmonitoring/exportexcel/' + area_sales_id + '/' + sales_code + '/' + start + '/' + data.token, '_blank');
      }, function () {
        $window.alert('gagal load token')
      });
    }

    function fetchLoad(data) {
      angular.element.unblockUI();
      vm.results = data[0];
    }

    function isEmptyObject(obj) {
      return JSON.stringify(obj) === '{}';
    }

    function errorFetchLoad() {
      angular.element.unblockUI();
      vm.results = [];
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.insentif-lph', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.insentif-lph', {
        url: '/insentif-lph',
        views: {
          'content@app': {
            templateUrl: 'app/main/insentif-lph/insentif-lph.html',
            controller: 'InsentifLphController as vm'
          }
        }
      });
  }
}());
(function () {
  'use strict';
  angular
    .module('app.insentif-lph')
    .controller('UploadInsentifLphController', UploadInsentifLphController);

  UploadInsentifLphController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadInsentifLphController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.upload = upload
    vm.detailInfo = []

    function upload(form) {
      angular.element.blockUI();
      var resp = vm.FileUpload.uploadAll();
    }

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/insentiflph/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentiflph/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-barcode-bsr/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
    'use strict';

    angular
        .module('app.insentif-lph')
        .controller('InsentifLphDetailController', InsentifLphDetailController);

    InsentifLphDetailController.$inject = ['AppAPI', 'data', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function InsentifLphDetailController(AppAPI, data, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var $translate = $filter('translate');

        Form.initialForm();

        var endPoint = AppAPI.InsentifLph();
        var kpiSales = AppAPI.InsentifKpiSetting();

        Form.setObject(endPoint);

        vm.Form = Form;
        vm.dialogClose = dialogClose
        function dialogClose() {
            $mdDialog.hide();
        }

        vm.DataTable = new DataService();
        vm.loadData = loadDetail;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];

        loadDetail(1);
        function loadDetail(pageno) {
            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewDetail',
                id: data.id
            });
        }

        getSalesCode();
        function getSalesCode() {
            var response = endPoint.query({ action: 'getSalesCode' });
            response.$promise.then(fetchSalesCode);
            response.$promise.catch(errorFetchSalesCode);
        }

        function fetchSalesCode(data) {
            vm.listSalesCode = data;
        }

        function errorFetchSalesCode() {
            vm.listSalesCode = [];
        }

        getProductCode();
        function getProductCode() {
            var response = endPoint.query({ action: 'getProductCode' });
            response.$promise.then(fetchProductCode);
            response.$promise.catch(errorFetchProductCode);
        }

        function fetchProductCode(data) {
            vm.listProductCode = data;
        }

        function errorFetchProductCode() {
            vm.listProductCode = [];
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-lph')
        .controller('InsentifLphController', InsentifLphController);

    InsentifLphController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function InsentifLphController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var $translate = $filter('translate');

        Form.initialForm();

        var endPoint = AppAPI.InsentifLph();
        var kpiSales = AppAPI.InsentifKpiSetting();

        Form.setObject(endPoint);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.arr_area = [];
        vm.selected = [];
        vm.openUpload = openUpload;
        vm.deleteData = deleteData;
        vm.viewDetail = viewDetail;

        function viewDetail(ev, data) {
            $mdDialog.show({
                controller: 'InsentifLphDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-lph/insentif-lph-detail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
        }

        function deleteData(ev) {
            var message = $translate('PAYROLL.MESSAGE.CONFDEL');
            var note = $translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = $translate('PAYROLL.MESSAGE.YES');
            var no = $translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(
                    function () {
                        var data = [];
                        for (var index = 0; index < vm.selected.length; index++) {
                            data.push(vm.selected[index].id);
                        }
                        angular.element.blockUI();
                        var response = endPoint.delete({
                            action: 'delete',
                            data: angular.toJson(data)
                        });
                        response.$promise.then(function (resp) {
                            dialogClose();
                            angular.element.unblockUI();
                            showDialogInfo(ev, resp);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialogInfo(ev, data) {
            vm.selected = [];
            var message = $translate(data.pesan);
            var status = $translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadData(pageno) {
            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                salesCode: vm.ref_sales_code_id,
                productCode: vm.ref_master_product_id
            });
        }

        getSalesCode();
        function getSalesCode() {
            var response = endPoint.query({ action: 'getSalesCode' });
            response.$promise.then(fetchSalesCode);
            response.$promise.catch(errorFetchSalesCode);
        }

        function fetchSalesCode(data) {
            vm.listSalesCode = data;
        }

        function errorFetchSalesCode() {
            vm.listSalesCode = [];
        }

        getProductCode();
        function getProductCode() {
            var response = endPoint.query({ action: 'getProductCode' });
            response.$promise.then(fetchProductCode);
            response.$promise.catch(errorFetchProductCode);
        }

        function fetchProductCode(data) {
            vm.listProductCode = data;
        }

        function errorFetchProductCode() {
            vm.listProductCode = [];
        }

        loadPeriod()
        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                vm.selected = [];
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.selected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.selected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadInsentifLphController as vm',
                templateUrl: 'app/main/insentif-lph/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }
        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-lock-sales', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-lock-sales', {
                url: '/insentif-lock-sales',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-lock-sales/insentif-lock-sales.html',
                        controller: 'InsentifLockSalesController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-lock-sales')
    .controller('InsentifLockSalesController', InsentifLockSalesController);

  InsentifLockSalesController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    'AppAPI',
    '$filter',
    'Form'
  ];
  /** @ngInject */
  function InsentifLockSalesController(
    $document,
    DataService,
    $mdDialog,
    AppAPI,
    $filter,
    Form
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifLockSales();
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.dialogClose = dialogClose;
    vm.stateEdit = false;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData'
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'InsentifLockSalesEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-lock-sales/insentif-lock-sales-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-lock-sales')
    .controller('InsentifLockSalesEditController', InsentifLockSalesEditController);

  InsentifLockSalesEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$filter'
  ];
  /** @ngInject */
  function InsentifLockSalesEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifLockSales();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.type = data.type;
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.lock_date = new Date(data.lock_date);
      vm.Form.objForm.lock_time = data.lock_time;
      vm.Form.objForm.type = data.type;
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-kpi-setting', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-kpi-setting', {
                url: '/insentif-kpi-setting',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-kpi-setting/insentif-kpi-setting.html',
                        controller: 'InsentifKpiSettingController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-kpi-setting')
        .controller('viewDocInsentifKpiSetting', viewDocInsentifKpiSetting);

    viewDocInsentifKpiSetting.$inject = ['$http', '$mdDialog', 'config', 'img'];

    /* @ngInject */
    function viewDocInsentifKpiSetting($http, $mdDialog, config, img) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal() {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage() {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = config.api + 'api/upload/' + vm.doc + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev) {
            var name = vm.doc;

            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Document Not Found')
                        .textContent('Document not Found')
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-kpi-setting')
        .controller('viewInsentifKpiSettingDetailController', viewInsentifKpiSettingDetailController);

    viewInsentifKpiSettingDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewInsentifKpiSettingDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var endPoint = AppAPI.InsentifKpiSetting();
        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.viewFile = viewFile
        vm.downloadDoc = downloadDoc
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        loadSalesType();
        loadCriteria();
        loadPeriod();
        loadArea();
        loadPrincipal();

        loadDetail();

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function loadSalesType() {
            var response = endPoint.query({ action: 'getSalesType' });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }

        function loadCriteria() {
            var response = endPoint.query({ action: 'getKpiCriteria' });
            response.$promise.then(fetchCriteria);
            response.$promise.catch(errorFetchCriteria);
        }

        function fetchCriteria(data) {
            vm.listCriteria = data;
        }

        function errorFetchCriteria() {
            vm.listCriteria = [];
        }

        function loadPrincipal() {
            var response = endPoint.query({ action: 'getPrincipal' });
            response.$promise.then(fetchPrincipal);
            response.$promise.catch(errorFetchPrincipal);
        }

        function fetchPrincipal(data) {
            vm.listPrincipal = data;
        }

        function errorFetchPrincipal() {
            vm.listPrincipal = [];
        }

        function loadArea() {
            var response = endPoint.query({ action: 'getAreaSales' });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listArea = data;
        }

        function errorFetchArea() {
            vm.listArea = [];
        }

        function loadPeriod() {
            var response = endPoint.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', detail_id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function downloadDoc(ev, filename) {
            var name = filename;
            if (name !== null && name !== '') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                var message = translate('HCTICKET.MESSAGE.FILENOTFOUND');
                var status = translate('PAYROLL.MESSAGE.FAILED');

                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(message)
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }

        function fetchDetail(data) {
            vm.salesType = data[0].ref_sales_type_id
            vm.criteria = data[0].ref_kpi_salesman_id
            vm.area = data[0].area_sales_id
            vm.description = data[0].description
            vm.start = data[0].start_date
            vm.end = data[0].end_date
            vm.target = parseFloat(data[0].target, 10);
            // vm.isChecked = false;
            vm.isChecked = data[0].is_sku_focus == '1' ? true : false;
            vm.filename = data[0].filename
            vm.format = data[0].format
            vm.selectedPrincipal = data[0].principals
            vm.selectedDatas = data[0].sku
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function viewFile(ev, img) {
            $mdDialog.show({
                controller: 'viewDocInsentifKpiSetting',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-kpi-setting/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    img: img
                }
            });
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-kpi-setting')
    .controller('InsentifKpiSettingController', InsentifKpiSettingController);

  InsentifKpiSettingController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function InsentifKpiSettingController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;

    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.downloadDoc = downloadDoc;
    vm.viewFile = viewFile;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getSku = getSku;
    vm.stateEdit = false;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);

      loadSalesType();
      loadCriteria();
      loadPeriod();
      loadArea();
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        sales_type: vm.salesType,
        start: vm.start,
        end: vm.end,
        area: vm.area,
        criteria: vm.criteria
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifKpiSettingInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-kpi-setting/insentif-kpi-setting-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewInsentifKpiSettingDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-kpi-setting/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function loadSalesType() {
      var response = endPoint.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function loadCriteria() {
      var response = endPoint.query({ action: 'getKpiCriteria' });
      response.$promise.then(fetchCriteria);
      response.$promise.catch(errorFetchCriteria);
    }

    function fetchCriteria(data) {
      vm.listCriteria = data;
    }

    function errorFetchCriteria() {
      vm.listCriteria = [];
    }

    function loadArea() {
      var response = endPoint.query({ action: 'getAreaSales' });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listArea = data;
    }

    function errorFetchArea() {
      vm.listArea = [];
    }

    function loadPeriod() {
      var response = endPoint.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();

            vm.objForm = new endPoint();
            vm.objForm.action = 'delete';
            vm.objForm.data = vm.selected;
            var response = vm.objForm.$save();

            response.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = $translate(expmess[0]) + ', ' + expmess[1] + ' ' + $translate(expmess[2]) + ' ' + expmess[3] + ' ' + $translate(expmess[4]);
      } else {
        var message = $translate(data.pesan);
      }

      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function downloadDoc(ev, filename) {
      var name = filename;
      if (name !== null && name !== '') {
        $http({
          method: 'GET',
          url: config.api + 'api/upload/' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        }).success(function (data, status, headers) {
          headers = headers();
          var filename = name;
          var contentType = headers['content-type'];

          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], { type: contentType });
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
          } catch (ex) {
            console.log(ex);
          }
        }).error(function (data) {
          console.log(data);
        });
      } else {
        var message = $translate('HCTICKET.MESSAGE.FILENOTFOUND');
        var status = $translate('PAYROLL.MESSAGE.FAILED');

        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
        ).then(function () {
          // closeModal();
        });
      }
    }

    function viewFile(ev, img) {
      $mdDialog.show({
        controller: 'viewDocInsentifKpiSetting',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-kpi-setting/view-doc.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        multiple: true,
        onRemoving: function (element, removePromise) {
          viewData();
        },
        locals: {
          img: img
        }
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getSku(searchText) {
      return $http
        .get(config.api + 'api/insentifkpisetting?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.sku = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined') {
        vm.Form.objForm.sku = item.empno;
        vm.Form.objForm.name = item.name
        vm.isDisabled = true;

      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-kpi-setting')
    .controller('InsentifKpiSettingInputController', InsentifKpiSettingInputController);

  InsentifKpiSettingInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$filter',
    'FileUploader',
    '$http',
    '$localStorage',
    '$element',
    'config'
  ];
  /** @ngInject */
  function InsentifKpiSettingInputController(
    $mdDialog,
    AppAPI,
    Form,
    $filter,
    FileUploader,
    $http,
    $localStorage,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    vm.upload = upload;

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.fileSizeError = true;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getSku = getSku;
    vm.showData = vm.showData2 = false;
    vm.company = $localStorage.empsite;
    vm.checkIsSKUFocus = checkIsSKUFocus;
    vm.toggle = toggle;
    vm.exists = exists;

    vm.selectedDatas = [];
    vm.selectedPrincipal = [];
    vm.tempSelectedData = [];
    vm.autocompleteDemoRequireMatch = true;
    vm.transformChip = transformChip;

    /**
     * Return the proper object when the append is called.
     */
    function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }

      // Otherwise, create a new one
      return { name: chip, type: 'new' };
    }

    activate();
    function activate() {
      vm.selected = [];
      loadSalesType();
      loadCriteria();
      loadPrincipal();
      loadPeriod();
      loadArea();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function loadSalesType() {
      var response = endPoint.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function loadCriteria() {
      var response = endPoint.query({ action: 'getKpiCriteria' });
      response.$promise.then(fetchCriteria);
      response.$promise.catch(errorFetchCriteria);
    }

    function fetchCriteria(data) {
      vm.listCriteria = data;
    }

    function errorFetchCriteria() {
      vm.listCriteria = [];
    }

    function loadPrincipal() {
      var response = endPoint.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.listPrincipal = data;
    }

    function errorFetchPrincipal() {
      vm.listPrincipal = [];
    }

    function loadArea() {
      var response = endPoint.query({ action: 'getAreaSales' });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listArea = data;
    }

    function errorFetchArea() {
      vm.listArea = [];
    }

    function loadPeriod() {
      var response = endPoint.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function checkIsSKUFocus() {
      if (vm.isSKUFocus == false || typeof vm.isSKUFocus === 'undefined') {
        vm.isChecked = true
        if (vm.tempSelectedData.length > 0) {
          vm.selectedDatas = vm.tempSelectedData
        }
      } else {
        vm.tempSelectedData = vm.selectedDatas
        vm.selectedDatas = [];
        vm.isChecked = false
      }
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.nik1 = '';
      if (typeof item !== 'undefined' && item) {
        vm.showData = true;
      }
    }

    function getSku(searchText) {
      return $http
        .get(config.api + 'api/insentifkpisetting?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function upload(form) {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/insentifkpisetting/upload',
      removeAfterUpload: true,
      alias: 'fileName',
      onBeforeUploadItem: function (item) {

        vm.selectedSku = [];
        if (item.formData[0].is_sku_focus == true) {
          if (vm.selectedDatas.length > 0) {
            for (var i = 0; i < vm.selectedDatas.length; i++) {
              vm.selectedSku.push(vm.selectedDatas[i].skuid);
            }
          }
        }
        vm.principal = [];
        console.log(vm.selectedPrincipal)
        if (vm.selectedPrincipal.length > 0) {
          for (var i = 0; i < vm.selectedPrincipal.length; i++) {
            vm.principal.push(vm.selectedPrincipal[i].id);
          }
        }
        item.formData[0].sku = vm.selectedSku;
        item.formData[0].principal = vm.principal;

        angular.element.blockUI();
      },
      onSuccessItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }, onErrorItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }
    });

    uploaderPhoto.filters.push({
      name: 'enforceMaxFileSize',
      fn: function (item) {
        vm.itemSize = formatBytes(item.size);
        if (item.size > 0) {
          vm.fileSizeError = false;
          return true;
        } else {
          vm.fileSizeError = true;
          return false;
        }
      }
    });

    function formatBytes(bytes) {
      if (bytes < 1024) return bytes + ' Bytes';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
      else return (bytes / 1073741824).toFixed(3) + ' GB';
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-hke-employee', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-hke-employee', {
                url: '/insentif-hke-employee',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-hke-employee/insentif-hke-employee.html',
                        controller: 'InsentifHkeEmployeeController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-hke-employee')
    .controller('InsentifHkeEmployeeController', InsentifHkeEmployeeController);

  InsentifHkeEmployeeController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function InsentifHkeEmployeeController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpHkeAreaSubdis();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var penalty = AppAPI.InsentifPinalty();

    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.viewDetail = viewDetail;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listMonth = data;
    }

    function errorFetchPeriod() {
      vm.listMonth = [];
    }

    loadYear()
    function loadYear() {
      var response = penalty.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        year: vm.year,
        month: vm.month,
        nik: vm.Form.objForm.empno
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InputInsentifHkeEmployeeController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-hke-employee/insentif-hke-employee-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewEmpSubdistDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-hke-employee/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'EditInsentifHkeEmployeeController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-hke-employee/insentif-hke-employee-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsubdis?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    getSubdis();
    function getSubdis() {
      var response = endPoint.query({ action: 'getSubdis' });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSubdis = data;
    }

    function errorFetchSalesCode() {
      vm.listSubdis = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-hke-employee')
    .controller('InputInsentifHkeEmployeeController', InputInsentifHkeEmployeeController);

  InputInsentifHkeEmployeeController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$filter',
    '$http',
    '$element',
    'config'
  ];
  /** @ngInject */
  function InputInsentifHkeEmployeeController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $filter,
    $http,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpHkeAreaSubdis();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var penalty = AppAPI.InsentifPinalty();

    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;

    vm.Form.objForm.sales_behaviour = 'VIRTUAL';

    activate();

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listMonth = data;
    }

    function errorFetchPeriod() {
      vm.listMonth = [];
    }

    loadYear()
    function loadYear() {
      var response = penalty.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      vm.selected = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsubdis?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-hke-employee')
    .controller('EditInsentifHkeEmployeeController', EditInsentifHkeEmployeeController);

  EditInsentifHkeEmployeeController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function EditInsentifHkeEmployeeController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpHkeAreaSubdis();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var penalty = AppAPI.InsentifPinalty();

    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;

    activate();

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listMonth = data;
    }

    function errorFetchPeriod() {
      vm.listMonth = [];
    }

    loadYear()
    function loadYear() {
      var response = penalty.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.nik = data.nik + ' - ' + data.name;
      vm.Form.objForm.empno = data.nik;
      vm.Form.objForm.nik_upd = data.nik;
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.year = data.year;
      vm.Form.objForm.month = data.month;
      vm.Form.objForm.hke = parseInt(data.hke);
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsubdis?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-hke-area', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-hke-area', {
                url: '/insentif-hke-area',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-hke-area/insentif-hke-area.html',
                        controller: 'InsentifHkeAreaController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-hke-area')
    .controller('UploadInsentifHkeAreaController', UploadInsentifHkeAreaController);

  UploadInsentifHkeAreaController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadInsentifHkeAreaController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.upload = upload;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    function upload() {
      angular.element.blockUI();

      vm.FileUpload.uploadAll();
    }

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/hkeareasubdis/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/hkeareasubdis/downloadTemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';
  angular
    .module('app.insentif-hke-area')
    .controller('InsentifHkeAreaController', InsentifHkeAreaController);

  InsentifHkeAreaController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    'AppAPI',
    'Auth',
    '$localStorage',
    '$filter',
    '$http',
    'config',
    '$element',
    'Form'
  ];
  /** @ngInject */
  function InsentifHkeAreaController(
    $document,
    DataService,
    $mdDialog,
    AppAPI,
    Auth,
    $localStorage,
    $filter,
    $http,
    config,
    $element,
    Form
  ) {
    var vm = this;
    var endPoint = AppAPI.HkeAreaSubdis();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var penalty = AppAPI.InsentifPinalty();

    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getDataCode = getDataCode;
    vm.openUpload = openUpload;
    vm.company = $localStorage.empsite;

    activate();

    function openUpload(ev) {
      $mdDialog.show({
        controller: 'UploadInsentifHkeAreaController as vm',
        templateUrl: 'app/main/insentif-hke-area/upload-file.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        }
      });
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.sales_code = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined') {
        vm.Form.objForm.sales_code = item.id;
        vm.Form.objForm.name = item.name
        vm.isDisabled = true;

      }
    }

    function getDataCode(searchText) {
      return $http
        .get(config.api + 'api/hkeareasubdis?action=searchSalesCode&id=' + searchText)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        year: vm.Form.objForm.year,
        month: vm.month,
        area_sales_id: vm.area_sales_id
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifHkeAreaInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-hke-area/insentif-hke-area-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'InsentifHkeAreaEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-hke-area/insentif-hke-area-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listMonth = data;
    }

    function errorFetchPeriod() {
      vm.listMonth = [];
    }

    loadArea();

    function loadArea() {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listAreaSales = data;
    }

    function errorFetchArea() {
      vm.listAreaSales = [];
    }

    loadYear()
    function loadYear() {
      var response = penalty.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-hke-area')
    .controller('InsentifHkeAreaInputController', InsentifHkeAreaInputController);

  InsentifHkeAreaInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function InsentifHkeAreaInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.HkeAreaSubdis();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var penalty = AppAPI.InsentifPinalty();

    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listMonth = data;
    }

    function errorFetchPeriod() {
      vm.listMonth = [];
    }

    loadArea();

    function loadArea() {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listAreaSales = data;
    }

    function errorFetchArea() {
      vm.listAreaSales = [];
    }

    loadYear()
    function loadYear() {
      var response = penalty.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-hke-area')
    .controller('InsentifHkeAreaEditController', InsentifHkeAreaEditController);

  InsentifHkeAreaEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function InsentifHkeAreaEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.HkeAreaSubdis();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var penalty = AppAPI.InsentifPinalty();

    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;

    activate();

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listMonth = data;
    }

    function errorFetchPeriod() {
      vm.listMonth = [];
    }

    loadArea();

    function loadArea() {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listAreaSales = data;
    }

    function errorFetchArea() {
      vm.listAreaSales = [];
    }

    loadYear()
    function loadYear() {
      var response = penalty.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);
      console.log(data)
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.hke = parseInt(data.hke);
      vm.Form.objForm.month = data.month;
      vm.Form.objForm.year = data.year;
      vm.Form.objForm.area_sales_id = data.area_sales_id;
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-calculationass')
    .controller('InsentifCalculationassController', InsentifCalculationassController);

  InsentifCalculationassController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$location',
    '$window',
    '$element'
  ];
  /** @ngInject */
  function InsentifCalculationassController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $location,
    $window,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifCalculationass();
    var insentifCalculation = AppAPI.InsentifCalculation();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.results = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.getSalesCode = getSalesCode;
    vm.isEmptyObject = isEmptyObject;
    vm.download = download;

    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    LoadArea(vm.company)

    function download() {
      var year = vm.year;

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

      var token = Auth.setTokenPromise();
      var area_sales_id = vm.Form.objForm.area_sales_id
      var sales_code = vm.sales_code
      var start = startDate

      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifcalculationass/exportpdf/' + area_sales_id + '/' + sales_code + '/' + start + '/' + data.token, '_blank');
      }, function () {
        $window.alert('gagal load token')
      });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function LoadArea(company) {
      var response = insentifCalculation.query({ action: 'getAreaSales', companyid: company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listarea = data;
    }

    function errorFetchArea() {
      vm.listarea = [];
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    activate();

    function activate() {
      vm.selected = [];

      loadPeriod();
      loadYear();
    }

    function getSalesCode(area) {
      angular.element.blockUI();
      var year = vm.year;
      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

      var response = endPoint.query({ action: 'getSalesCode', area: area, date: startDate });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      angular.element.unblockUI();
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      angular.element.unblockUI();
      vm.listSalesCode = [];
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function loadYear() {
      var response = endPoint.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function loadData(pageno) {
      var year = vm.year;

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
      angular.element.blockUI();
      var response = endPoint.query({
        action: 'viewData',
        area_sales_id: vm.area,
        sales_code: vm.sales_code,
        start: startDate,
        nik: vm.Form.objForm.empno,
        hke_sales: vm.hke_sales
      });
      response.$promise.then(fetchLoad);
      response.$promise.catch(errorFetchLoad);

    }

    function fetchLoad(data) {
      angular.element.unblockUI();
      vm.results = data[0];
    }

    function isEmptyObject(obj) {
      return JSON.stringify(obj) === '{}';
    }

    function errorFetchLoad() {
      angular.element.unblockUI();
      vm.results = [];
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-calculation', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-calculation', {
                url: '/insentif-calculation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-calculation/insentif-calculation.html',
                        controller: 'InsentifCalculationController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-calculation')
    .controller('InsentifCalculationController', InsentifCalculationController);

  InsentifCalculationController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$location',
    '$window',
    '$element'
  ];
  /** @ngInject */
  function InsentifCalculationController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $location,
    $window,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifCalculation();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.results = [];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.getSalesCode = getSalesCode;
    vm.isEmptyObject = isEmptyObject;
    vm.download = download;

    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;

    function download() {
      var year = vm.year;

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

      var token = Auth.setTokenPromise();
      var area_sales_id = vm.Form.objForm.area_sales_id
      var sales_code = vm.sales_code
      var start = startDate

      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifcalculation/exportpdf/' + area_sales_id + '/' + sales_code + '/' + start + '/' + data.token, '_blank');
      }, function () {
        $window.alert('gagal load token')
      });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    activate();

    function activate() {
      vm.selected = [];

      loadPeriod();
      getSalesType();
      getAreaSales();
      loadYear();
    }

    function getAreaSales() {
      var response = endPoint.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function getSalesType() {
      var response = endPoint.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function getSalesCode(area) {
      angular.element.blockUI();
      var year = vm.year;
      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";

      var response = endPoint.query({ action: 'getSalesCode', area: area, date: startDate });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      angular.element.unblockUI();
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      angular.element.unblockUI();
      vm.listSalesCode = [];
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function loadYear() {
      var response = endPoint.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function loadData(pageno) {
      var year = vm.year;

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
      angular.element.blockUI();
      var response = endPoint.query({
        action: 'viewData',
        area_sales_id: vm.Form.objForm.area_sales_id,
        sales_code: vm.sales_code,
        start: startDate,
        nik: vm.Form.objForm.empno,
        hke_sales: vm.hke_sales
      });
      response.$promise.then(fetchLoad);
      response.$promise.catch(errorFetchLoad);

    }

    function fetchLoad(data) {
      angular.element.unblockUI();
      vm.results = data[0];
    }

    function isEmptyObject(obj) {
      return JSON.stringify(obj) === '{}';
    }

    function errorFetchLoad() {
      angular.element.unblockUI();
      vm.results = [];
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-barcode-bsr', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-barcode-bsr', {
                url: '/insentif-barcode-bsr',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-barcode-bsr/insentif-barcode-bsr.html',
                        controller: 'InsentifBarcodeBsrController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-barcode-bsr')
    .controller('UploadInsentifBarcodeBsrController', UploadInsentifBarcodeBsrController);

  UploadInsentifBarcodeBsrController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadInsentifBarcodeBsrController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.upload = upload;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    function upload() {
      angular.element.blockUI();

      vm.FileUpload.uploadAll();
    }

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/insentifbarcodebsr/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifbarcodebsr/downloadTemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-barcode-bsr/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';
  angular
    .module('app.insentif-barcode-bsr')
    .controller('InsentifBarcodeBsrController', InsentifBarcodeBsrController);

  InsentifBarcodeBsrController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    'AppAPI',
    'Auth',
    '$localStorage',
    '$filter',
    '$http',
    'config',
    '$element',
    'Form'
  ];
  /** @ngInject */
  function InsentifBarcodeBsrController(
    $document,
    DataService,
    $mdDialog,
    AppAPI,
    Auth,
    $localStorage,
    $filter,
    $http,
    config,
    $element,
    Form
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifBarcodeBsr();
    var calculation = AppAPI.InsentifCalculation();
    var kpiSales = AppAPI.InsentifKpiSetting();

    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.openUpload = openUpload;
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.company = $localStorage.empsite;
    vm.getSalesCode = getSalesCode;

    activate();

    loadYear()
    function loadYear() {
      var response = calculation.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function openUpload(ev) {
      $mdDialog.show({
        controller: 'UploadInsentifBarcodeBsrController as vm',
        templateUrl: 'app/main/insentif-barcode-bsr/upload-file.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        }
      });
    }

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.sales_code = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined') {
        vm.Form.objForm.sales_code = item.id;
        vm.Form.objForm.name = item.name
        vm.isDisabled = true;

      }
    }

    getAreaSales()
    function getAreaSales() {
      var response = calculation.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function getSalesCode(area_sales_id) {
      var response = endPoint.query({ action: 'getSalesCode', area_sales_id: area_sales_id });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        area_sales: vm.Form.objForm.area_sales_id,
        sales_code: vm.Form.objForm.ref_sales_code_id
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifBarcodeBsrInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-barcode-bsr/insentif-barcode-bsr-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'InsentifBarcodeBsrEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-barcode-bsr/insentif-barcode-bsr-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-barcode-bsr')
    .controller('InsentifBarcodeBsrInputController', InsentifBarcodeBsrInputController);

  InsentifBarcodeBsrInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$element',
    '$http',
    'config',
    '$filter'
  ];
  /** @ngInject */
  function InsentifBarcodeBsrInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $element,
    $http,
    config,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifBarcodeBsr();
    var calculation = AppAPI.InsentifCalculation();
    var kpiSales = AppAPI.InsentifKpiSetting();

    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;
    vm.selectedItemChangedUser = selectedItemChangedUser;
    vm.getEmployee = getEmployee;
    vm.getSalesCode = getSalesCode;

    getAreaSales()
    function getAreaSales() {
      var response = calculation.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    loadYear()
    function loadYear() {
      var response = calculation.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    function selectedItemChangedUser(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchStringUser;
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var dt = new Date();
      var year = dt.getFullYear()

      var endDate = typeof vm.Form.objForm.end != 'undefined' ? year + "-" + vm.Form.objForm.end + "-01" : "9999-12-01";

      vm.Form.objForm.start_date = year + "-" + vm.Form.objForm.start + "-01";
      vm.Form.objForm.end_date = endDate;

      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function getSalesCode(area_sales_id) {
      var response = endPoint.query({ action: 'getSalesCode', area_sales_id: area_sales_id });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-barcode-bsr')
    .controller('InsentifBarcodeBsrEditController', InsentifBarcodeBsrEditController);

  InsentifBarcodeBsrEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$element',
    '$http',
    'config',
    '$filter'
  ];
  /** @ngInject */
  function InsentifBarcodeBsrEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $element,
    $http,
    config,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifBarcodeBsr();
    var calculation = AppAPI.InsentifCalculation();
    var kpiSales = AppAPI.InsentifKpiSetting();

    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.selectedItemChangedUser = selectedItemChangedUser;
    vm.getEmployee = getEmployee;
    vm.getSalesCode = getSalesCode;

    activate();

    getAreaSales()
    function getAreaSales() {
      var response = calculation.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function getSalesCode(area_sales_id) {
      var response = endPoint.query({ action: 'getSalesCode', area_sales_id: area_sales_id });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    loadYear()
    function loadYear() {
      var response = calculation.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function selectedItemChangedUser(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchStringUser;
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.id = data.id;
      vm.Form.objForm.ref_sales_code_id = data.ref_sales_code_id;
      vm.Form.objForm.area_sales_id = data.area_sales_id;
      vm.Form.objForm.surkom_number = data.surkom_number;
      vm.Form.objForm.surkom_date = new Date(data.surkom_date);
      vm.Form.objForm.nik = data.surkom_by + ' - ' + data.surkom_by_name;
      vm.Form.objForm.nik_upd = data.surkom_by;
      vm.Form.objForm.barcode = parseFloat(data.barcode);
      vm.Form.objForm.year = data.year;
      vm.Form.objForm.month = data.month;
      getSalesCode(data.area_sales_id)
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.sales_code = vm.Form.objForm.salescode;
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-barcode', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-barcode', {
                url: '/insentif-barcode',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-barcode/insentif-barcode.html',
                        controller: 'InsentifBarcodeController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-barcode')
    .controller('UploadInsentifBarcodeController', UploadInsentifBarcodeController);

  UploadInsentifBarcodeController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadInsentifBarcodeController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.upload = upload;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    function upload() {
      angular.element.blockUI();

      vm.FileUpload.uploadAll();
    }

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/insentifbarcode/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/insentifbarcode/downloadTemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-barcode-bsr/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';
  angular
    .module('app.insentif-barcode')
    .controller('InsentifBarcodeController', InsentifBarcodeController);

  InsentifBarcodeController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    'AppAPI',
    'Auth',
    '$localStorage',
    '$filter',
    '$http',
    'config',
    '$element',
    'Form'
  ];
  /** @ngInject */
  function InsentifBarcodeController(
    $document,
    DataService,
    $mdDialog,
    AppAPI,
    Auth,
    $localStorage,
    $filter,
    $http,
    config,
    $element,
    Form
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifBarcode();
    var calculation = AppAPI.InsentifCalculation();
    var kpiSales = AppAPI.InsentifKpiSetting();

    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getSalesCode = getSalesCode;
    vm.openUpload = openUpload;
    vm.company = $localStorage.empsite;

    activate();

    function openUpload(ev) {
      $mdDialog.show({
        controller: 'UploadInsentifBarcodeController as vm',
        templateUrl: 'app/main/insentif-barcode/upload-file.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        }
      });
    }

    loadYear()
    function loadYear() {
      var response = calculation.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.sales_code = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined') {
        vm.Form.objForm.sales_code = item.id;
        vm.Form.objForm.name = item.name
        vm.isDisabled = true;

      }
    }

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    getAreaSales()
    function getAreaSales() {
      var response = calculation.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function getSalesCode(area_sales_id) {
      var response = endPoint.query({ action: 'getSalesCode', area_sales_id: area_sales_id });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        area_sales: vm.Form.objForm.area_sales_id,
        sales_code: vm.Form.objForm.ref_sales_code_id
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifBarcodeInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-barcode/insentif-barcode-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'InsentifBarcodeEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-barcode/insentif-barcode-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-barcode')
    .controller('InsentifBarcodeInputController', InsentifBarcodeInputController);

  InsentifBarcodeInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function InsentifBarcodeInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifBarcode();
    var calculation = AppAPI.InsentifCalculation();
    var kpiSales = AppAPI.InsentifKpiSetting();

    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;

    vm.getSalesCode = getSalesCode;

    loadYear()
    function loadYear() {
      var response = calculation.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();

      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    getAreaSales()
    function getAreaSales() {
      var response = calculation.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function getSalesCode(area_sales_id) {
      var response = endPoint.query({ action: 'getSalesCode', area_sales_id: area_sales_id });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-barcode')
    .controller('InsentifBarcodeEditController', InsentifBarcodeEditController);

  InsentifBarcodeEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function InsentifBarcodeEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifBarcode();
    var calculation = AppAPI.InsentifCalculation();
    var kpiSales = AppAPI.InsentifKpiSetting();

    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;

    vm.getSalesCode = getSalesCode;

    activate();

    loadYear()
    function loadYear() {
      var response = calculation.query({ action: 'getYear' });
      response.$promise.then(fetchYear);
      response.$promise.catch(errorFetchYear);
    }

    function fetchYear(data) {
      vm.listYear = data;
    }

    function errorFetchYear() {
      vm.listYear = [];
    }

    loadPeriod()
    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);
      console.log(data)
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.ref_sales_code_id = data.ref_sales_code_id;
      vm.Form.objForm.barcode = parseFloat(data.barcode);
      vm.Form.objForm.area_sales_id = data.area_sales_id;
      vm.Form.objForm.year = data.year;
      vm.Form.objForm.month = data.month;
      getSalesCode(data.area_sales_id)
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      vm.Form.objForm.sales_code = vm.Form.objForm.salescode;
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getSalesCode() {
      var response = endPoint.query({ action: 'getSalesCode' });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    getAreaSales()
    function getAreaSales() {
      var response = calculation.query({ action: 'getAreaSales', companyid: vm.company });
      response.$promise.then(fetchAreaSales);
      response.$promise.catch(errorFetchAreaSales);
    }

    function fetchAreaSales(data) {
      vm.listAreaSales = data;
    }

    function errorFetchAreaSales() {
      vm.listAreaSales = [];
    }

    function getSalesCode(area_sales_id) {
      var response = endPoint.query({ action: 'getSalesCode', area_sales_id: area_sales_id });
      response.$promise.then(fetchSalesCode);
      response.$promise.catch(errorFetchSalesCode);
    }

    function fetchSalesCode(data) {
      vm.listSalesCode = data;
    }

    function errorFetchSalesCode() {
      vm.listSalesCode = [];
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-approval-ass', [])
        .config(config);

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.insentif-approval-ass', {
                url: '/insentifapproval-ass',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-approval-ass/insentif-approval-ass.html',
                        controller: 'InsentifApprovalAssController as vm'
                    }
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
    }
})(); 
(function () {
  'use strict';

  angular
    .module('app.insentif-approval-ass')
    .controller('InsentifApprovalAssController', InsentifApprovalAssController);


  InsentifApprovalAssController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function InsentifApprovalAssController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {
    var vm = this;
    var translate = $filter('translate');

    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;

    var endPoint = AppAPI.InsentifApprovalAss();
    var endPointUmutReport = AppAPI.Umutreport();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var nik = $localStorage.user;

    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.unapproveAll = unapproveAll;
    vm.Reject = Reject;
    vm.viewComment = viewComment;
    vm.UnReject = UnReject;
    vm.UnApproved = UnApproved;
    vm.LoadPeriod = LoadPeriod;
    vm.LoadArea = LoadArea;
    vm.detail = detail;

    vm.company = $localStorage.empsite;

    var date = new Date();
    vm.tahun = date.getFullYear();
    vm.bulan = date.getMonth() + 1;
    vm.getPeriode = getPeriode;
    // vm.tgl=date.getDate();
    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];
    vm.toggleSelectedAll = toggleSelectedAll;

    if (vm.tgl >= 25 && vm.tgl <= 31) {
      if (vm.bulan == 12) {
        vm.bulan = '01';
      } else {
        vm.bulan = vm.bulan + 1;
      }
    }
    if (vm.bulan < 10) {
      vm.bulan = '0' + vm.bulan;
    }

    vm.listtahun = [2014, 2015, 2016, 2017, 2018, 2019];
    vm.listbulan = [{ name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'Maret', value: '03' },
    { name: 'April', value: '04' },
    { name: 'Mei', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'Desember', value: '12' }];

    vm.LoadRegional = loadRegional;
    vm.LoadCabang = loadCabang;
    vm.LoadWilayah = loadWilayah;

    vm.reqWil = false;
    vm.reqArea = true;

    LoadPeriod();
    LoadSubPeriod();
    LoadCompany()
    loadWilayah();
    LoadAreaDefault(vm.company);

    function detail(ev, data) {
      $mdDialog.show({
        controller: 'InsentifApprovalAssDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-approval-ass/insentif-approval-ass-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function LoadAreaDefault(company) {
      var response = endPoint.query({ action: 'getArea', companyid: company });
      response.$promise.then(fetchAreaDefault);
      response.$promise.catch(errorFetchAreaDefault);
    }

    function fetchAreaDefault(data) {
      vm.listarea = data;
    }

    function errorFetchAreaDefault() {
      vm.listarea = [];
    }

    function LoadSubPeriod() {
      var response = endPoint.query({ action: 'getSubPeriod' });
      response.$promise.then(fetchSubPeriod);
      response.$promise.catch(errorFetchSubPeriod);
    }

    function fetchSubPeriod(data) {
      vm.listsubperiod = data;
    }

    function errorFetchSubPeriod() {
      vm.listsubperiod = [];
    }

    function LoadCompany() {
      var response = endPoint.query({ action: 'getCompany' });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listcompany = data;
    }

    function errorFetchCompany() {
      vm.listcompany = [];
    }

    function LoadArea(company, cabangid) {
      loadWilayah();
      var response = endPoint.query({ action: 'getArea', companyid: company, cabangid: cabangid });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listarea = data;
    }

    function errorFetchArea() {
      vm.listarea = [];
    }

    function loadWilayah() {
      var response = endPoint.query({ action: 'getWilayah', companyid: vm.company });
      response.$promise.then(fetchWilayah);
      response.$promise.catch(errorFetchWilayah);
    }

    function fetchWilayah(data) {
      vm.listWilayah = data;
    }

    function errorFetchWilayah() {
      vm.listWilayah = [];
    }

    function loadRegional(id) {
      vm.listarea = [];
      vm.reqWil = true;
      vm.reqArea = false;
      var response = endPoint.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
      response.$promise.then(fetchRegional);
      response.$promise.catch(errorFetchRegional);
    }

    function fetchRegional(data) {
      vm.listRegional = data;
    }

    function errorFetchRegional() {
      vm.listRegional = [];
    }

    function loadCabang(id) {
      var response = endPoint.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
      response.$promise.then(fetchCabang);
      response.$promise.catch(errorFetchCabang);
    }

    function fetchCabang(data) {
      vm.listCabang = data;
    }

    function errorFetchCabang() {
      vm.listCabang = [];
    }

    function getPeriode() {
      var res = Attendanceemploye.query({ action: 'getPeriode', tahun: vm.tahun, bulan: vm.bulan });
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data) {
      vm.periode = data[0]['periode'];
      loadData(1);
    }

    function errorfetchPeriode(data) {
      console.log('error');
    }

    function loadData(pageno) {
      vm.listOtselected = [];
      var resp = vm.DataTable.loadData(endPoint, pageno, {
        action: 'viewdata',
        period: vm.period,
        type: vm.type,
        company: vm.company,
        wilayah: vm.wilayah,
        regional: vm.regional,
        cabang: vm.cabang,
        area: vm.area
      });
      vm.listGhk = [];
    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.DataTable.list);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Approve this list?')
            .textContent('All data your selected will be approve.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new endPoint();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              if (data.status == 1) {
                successApproved(ev, data);
              } else {
                failedApproved(ev, data);
              }
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
            });
          }, function () {

          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function unapproveAll(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Un-Approve this list?')
            .textContent('All data your selected will be un-approve.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new endPoint();
            ot.data = [];
            ot.action = 'unapprove';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              if (data.status == 1) {
                successApproved(ev, data);
              } else {
                failedApproved(ev, data);
              }
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
            });
          }, function () {

          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function successApproved(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          loadData(1);
        }
      });

    }

    function failedApproved(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });

    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        $mdDialog.show({
          controller: 'InsentifCommentAssController',
          controllerAs: 'vm',
          templateUrl: 'app/main/additional-insentif-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'AdditionalInsentifViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          vm.listOtselected = [];
        },
        locals: {
          id: id
        }
      });
    }

    function UnReject(ev, id) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = endPoint.delete({ action: 'unreject', data: angular.toJson(id) });
          response.$promise.then(function (data) {
            succesUnreject(ev, data);
          });
          response.$promise.catch(function () {
            angular.element.unblockUI();
            succesUnreject(ev, data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function UnApproved(ev, id) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to unapprove this list?')
          .textContent('All data you selected will be set to unapproved.')
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = endPoint.delete({ action: 'unapproved', data: angular.toJson(id) });
          // console.log(response);
          response.$promise.then(function (data) {
            if (data.status == 1) {
              successApproved(ev, data);
            } else {
              failedApproved(ev, data);
            }
          });
          response.$promise.catch(function (data) {
            failedUnapproved(ev, data);
          });
          angular.element.unblockUI();
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function succesUnapproved(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnapproved();
      } else {
        showDialog();
      }
      loadData();
    }

    function succesUnreject(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnreject();
      } else {
        showDialogUnreject(data);
      }
      loadData();
    }

    function failedUnapproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.data)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }

    function showFailedUnapproved() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unapproved Data')
          .textContent('Transaction Locked By System.')
          .ariaLabel('Transaction Locked By System')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showFailedUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unreject Data')
          .textContent('Transaction Locked By System.')
          .ariaLabel('Transaction Locked By System')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialog() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialogUnreject(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(data.status)
          .textContent(translate(data.pesan))
          .ariaLabel(data.status)
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function LoadPeriod() {
      var response = endPointUmutReport.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listperiod = data;
    }

    function errorFetchPeriod() {
      vm.listperiod = [];
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-approval-ass')
        .controller('InsentifViewRejectCommentAssController', InsentifViewRejectCommentAssController);

    InsentifViewRejectCommentAssController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config'];

    /* @ngInject */
    function InsentifViewRejectCommentAssController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config) {
        var vm = this;
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.Form.objForm.data = id;
        vm.stateView = true;
        // console.log(id);

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-approval-ass')
        .controller('InsentifCommentAssController', InsentifCommentAssController);

    InsentifCommentAssController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function InsentifCommentAssController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.InsentifApprovalAss();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;
        // console.log(id);

        function saveData(ev, formController) {
            var promise = Form.saveData('reject', formController, endPoint);
            promise.then(function (data) {
                if (data.status == 1) {
                    successApproved(ev, data);
                } else {
                    failedApproved(ev, data);
                }
            });

            promise.catch(function () {
                ShowFailed(ev, data)
            });
        }

        function successApproved(ev, data) {
            var expmess = data.pesan.split("_");
            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save data')
                    .textContent(message)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                if ('moreInfo' in data && data.moreInfo.length > 0) {
                    $mdDialog.show({
                        controller: 'logFailGwController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            // loadData(1);
                        },
                        locals: {
                            data: data.moreInfo
                        }
                    });
                } else {
                    // loadData(1);
                }
            });

        }

        function failedApproved(ev, data) {
            var expmess = data.pesan.split("_");
            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save data')
                    .textContent(message)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                if ('moreInfo' in data && data.moreInfo.length > 0) {
                    $mdDialog.show({
                        controller: 'logFailGwController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            // loadData(1);
                        },
                        locals: {
                            data: data.moreInfo
                        }
                    });
                } else {
                    // loadData(1);
                }
            });

        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-approval-ass')
    .controller('InsentifApprovalAssDetailController', InsentifApprovalAssDetailController);

  InsentifApprovalAssDetailController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$filter'
  ];
  /** @ngInject */
  function InsentifApprovalAssDetailController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifApprovalAss();
    var $translate = $filter('translate');

    vm.results = []
    vm.dialogClose = closeModal

    loadDetail();

    function loadDetail() {
      angular.element.blockUI();
      var response = endPoint.query({ action: 'viewDetail', id: data.id });
      response.$promise.then(fetchDetail);
      response.$promise.catch(errorFetchDetail);
    }

    function fetchDetail(data) {
      angular.element.unblockUI();
      console.log(data)
      vm.results = data;
    }

    function errorFetchDetail() {
      angular.element.unblockUI();
      vm.results = [];
    }

    function closeModal() {
      $mdDialog.hide();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-approval', [])
        .config(config);

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.insentif-approval', {
                url: '/insentifapproval',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-approval/insentif-approval.html',
                        controller: 'InsentifApprovalController as vm'
                    }
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
    }
})(); 
(function () {
  'use strict';

  angular
    .module('app.insentif-approval')
    .controller('InsentifApprovalController', InsentifApprovalController);


  InsentifApprovalController.$inject = ['$state', '$mdDialog', 'DataService', 'AppAPI', 'Auth', 'GeneralService', '$localStorage', '$filter'];
  /** @ngInject */
  function InsentifApprovalController($state, $mdDialog, DataService, AppAPI, Auth, GeneralService, $localStorage, $filter) {
    var vm = this;
    var translate = $filter('translate');

    vm.loadData = loadData
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.DataTable = new DataService();
    vm.loadData = loadData;

    var endPoint = AppAPI.InsentifApproval();
    var endPointUmutReport = AppAPI.Umutreport();
    var Attendanceemploye = AppAPI.Attendanceemploye();
    var nik = $localStorage.user;

    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.unapproveAll = unapproveAll;
    vm.Reject = Reject;
    vm.viewComment = viewComment;
    vm.UnReject = UnReject;
    vm.UnApproved = UnApproved;
    vm.LoadPeriod = LoadPeriod;
    vm.LoadArea = LoadArea;
    vm.detail = detail;

    vm.company = $localStorage.empsite;

    var date = new Date();
    vm.tahun = date.getFullYear();
    vm.bulan = date.getMonth() + 1;
    vm.getPeriode = getPeriode;
    // vm.tgl=date.getDate();
    vm.type = 'waiting approval';
    vm.listType = ['waiting approval', 'approved', 'rejected'];
    vm.toggleSelectedAll = toggleSelectedAll;

    if (vm.tgl >= 25 && vm.tgl <= 31) {
      if (vm.bulan == 12) {
        vm.bulan = '01';
      } else {
        vm.bulan = vm.bulan + 1;
      }
    }
    if (vm.bulan < 10) {
      vm.bulan = '0' + vm.bulan;
    }

    vm.listtahun = [2014, 2015, 2016, 2017, 2018, 2019];
    vm.listbulan = [{ name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'Maret', value: '03' },
    { name: 'April', value: '04' },
    { name: 'Mei', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'Desember', value: '12' }];

    vm.LoadRegional = loadRegional;
    vm.LoadCabang = loadCabang;
    vm.LoadWilayah = loadWilayah;

    vm.reqWil = false;
    vm.reqArea = true;

    LoadPeriod();
    LoadSubPeriod();
    LoadCompany()
    loadWilayah();
    LoadAreaDefault(vm.company);

    function detail(ev, data) {
      $mdDialog.show({
        controller: 'InsentifApprovalDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-approval/insentif-approval-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function LoadAreaDefault(company) {
      var response = endPoint.query({ action: 'getArea', companyid: company });
      response.$promise.then(fetchAreaDefault);
      response.$promise.catch(errorFetchAreaDefault);
    }

    function fetchAreaDefault(data) {
      vm.listarea = data;
    }

    function errorFetchAreaDefault() {
      vm.listarea = [];
    }

    function LoadSubPeriod() {
      var response = endPoint.query({ action: 'getSubPeriod' });
      response.$promise.then(fetchSubPeriod);
      response.$promise.catch(errorFetchSubPeriod);
    }

    function fetchSubPeriod(data) {
      vm.listsubperiod = data;
    }

    function errorFetchSubPeriod() {
      vm.listsubperiod = [];
    }

    function LoadCompany() {
      var response = endPoint.query({ action: 'getCompany' });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listcompany = data;
    }

    function errorFetchCompany() {
      vm.listcompany = [];
    }

    function LoadArea(company, cabangid) {
      loadWilayah();
      var response = endPoint.query({ action: 'getArea', companyid: company, cabangid: cabangid });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listarea = data;
    }

    function errorFetchArea() {
      vm.listarea = [];
    }

    function loadWilayah() {
      var response = endPoint.query({ action: 'getWilayah', companyid: vm.company });
      response.$promise.then(fetchWilayah);
      response.$promise.catch(errorFetchWilayah);
    }

    function fetchWilayah(data) {
      vm.listWilayah = data;
    }

    function errorFetchWilayah() {
      vm.listWilayah = [];
    }

    function loadRegional(id) {
      vm.listarea = [];
      vm.reqWil = true;
      vm.reqArea = false;
      var response = endPoint.query({ action: 'getRegional', wilayahid: id, companyid: vm.company });
      response.$promise.then(fetchRegional);
      response.$promise.catch(errorFetchRegional);
    }

    function fetchRegional(data) {
      vm.listRegional = data;
    }

    function errorFetchRegional() {
      vm.listRegional = [];
    }

    function loadCabang(id) {
      var response = endPoint.query({ action: 'getCabang', regionalid: id, companyid: vm.company });
      response.$promise.then(fetchCabang);
      response.$promise.catch(errorFetchCabang);
    }

    function fetchCabang(data) {
      vm.listCabang = data;
    }

    function errorFetchCabang() {
      vm.listCabang = [];
    }

    function getPeriode() {
      var res = Attendanceemploye.query({ action: 'getPeriode', tahun: vm.tahun, bulan: vm.bulan });
      res.$promise.then(fetchPeriode);
      res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data) {
      vm.periode = data[0]['periode'];
      loadData(1);
    }

    function errorfetchPeriode(data) {
      console.log('error');
    }

    function loadData(pageno) {
      vm.listOtselected = [];
      var resp = vm.DataTable.loadData(endPoint, pageno, {
        action: 'viewdata',
        period: vm.period,
        type: vm.type,
        company: vm.company,
        wilayah: vm.wilayah,
        regional: vm.regional,
        cabang: vm.cabang,
        area: vm.area,
        subperiod: vm.subperiod
      });
      vm.listGhk = [];
    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.DataTable.list);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Approve this list?')
            .textContent('All data your selected will be approve.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new endPoint();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              if (data.status == 1) {
                successApproved(ev, data);
              } else {
                failedApproved(ev, data);
              }
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
            });
          }, function () {

          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function unapproveAll(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Un-Approve this list?')
            .textContent('All data your selected will be un-approve.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new endPoint();
            ot.data = [];
            ot.action = 'unapprove';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              if (data.status == 1) {
                successApproved(ev, data);
              } else {
                failedApproved(ev, data);
              }
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
            });
          }, function () {

          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function successApproved(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          loadData(1);
        }
      });

    }

    function failedApproved(ev, data) {
      var expmess = data.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });

    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        $mdDialog.show({
          controller: 'InsentifCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/additional-insentif-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function viewComment(ev, id) {
      $mdDialog.show({
        controller: 'AdditionalInsentifViewRejectCommentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/approval-ghk/comment-reject.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          vm.listOtselected = [];
        },
        locals: {
          id: id
        }
      });
    }

    function UnReject(ev, id) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = endPoint.delete({ action: 'unreject', data: angular.toJson(id) });
          response.$promise.then(function (data) {
            succesUnreject(ev, data);
          });
          response.$promise.catch(function () {
            angular.element.unblockUI();
            failedUnapproved(ev, data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function UnApproved(ev, id) {
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title('Would you like to unapprove this list?')
          .textContent('All data you selected will be set to unapproved.')
          .ariaLabel('unapprove dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();
          var response = endPoint.delete({ action: 'unapproved', data: angular.toJson(id) });
          // console.log(response);
          response.$promise.then(function (data) {
            if (data.status == 1) {
              successApproved(ev, data);
            } else {
              failedApproved(ev, data);
            }
          });
          response.$promise.catch(function (data) {
            failedUnapproved(ev, data);
          });
          angular.element.unblockUI();
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }

    function succesUnapproved(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnapproved();
      } else {
        showDialog();
      }
      loadData();
    }

    function succesUnreject(ev, data) {
      if (data.hasil == 'expired') {
        showFailedUnreject();
      } else {
        showDialogUnreject(data);
      }
      loadData();
    }

    function failedUnapproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.data)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }

    function showFailedUnapproved() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unapproved Data')
          .textContent('Transaction Locked By System.')
          .ariaLabel('Transaction Locked By System')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showFailedUnreject() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Unreject Data')
          .textContent('Transaction Locked By System.')
          .ariaLabel('Transaction Locked By System')
          .ok('OK')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialog() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function showDialogUnreject(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(data.status)
          .textContent(translate(data.pesan))
          .ariaLabel(data.status)
          .ok('close')
      ).then(function () {
        $mdDialog.hide();
      });
    }

    function LoadPeriod() {
      var response = endPointUmutReport.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listperiod = data;
    }

    function errorFetchPeriod() {
      vm.listperiod = [];
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-approval')
        .controller('InsentifViewRejectCommentController', InsentifViewRejectCommentController);

    InsentifViewRejectCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config'];

    /* @ngInject */
    function InsentifViewRejectCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config) {
        var vm = this;
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.Form.objForm.data = id;
        vm.stateView = true;
        // console.log(id);

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-approval')
        .controller('InsentifCommentController', InsentifCommentController);

    InsentifCommentController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', '$log', 'FileUploader', 'config', '$filter'];

    /* @ngInject */
    function InsentifCommentController($localStorage, id, $mdDialog, Form, AppAPI, $log, FileUploader, config, $filter) {
        var vm = this;

        var translate = $filter('translate');

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.InsentifApproval();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;

        vm.closeModal = closeModal;
        vm.saveData = saveData;
        vm.Form.objForm.data = id;
        vm.stateView = false;
        // console.log(id);

        function saveData(ev, formController) {
            var promise = Form.saveData('reject', formController, endPoint);
            promise.then(function (data) {
                if (data.status == 1) {
                    successApproved(ev, data);
                } else {
                    failedApproved(ev, data);
                }
            });

            promise.catch(function () {
                ShowFailed(ev, data)
            });
        }

        function successApproved(ev, data) {
            var expmess = data.pesan.split("_");
            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Success save data')
                    .textContent(message)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                if ('moreInfo' in data && data.moreInfo.length > 0) {
                    $mdDialog.show({
                        controller: 'logFailGwController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            // loadData(1);
                        },
                        locals: {
                            data: data.moreInfo
                        }
                    });
                } else {
                    // loadData(1);
                }
            });

        }

        function failedApproved(ev, data) {
            var expmess = data.pesan.split("_");
            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed save data')
                    .textContent(message)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                if ('moreInfo' in data && data.moreInfo.length > 0) {
                    $mdDialog.show({
                        controller: 'logFailGwController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true,
                        onRemoving: function (element, removePromise) {
                            // loadData(1);
                        },
                        locals: {
                            data: data.moreInfo
                        }
                    });
                } else {
                    // loadData(1);
                }
            });

        }

        function closeModal() {
            $mdDialog.hide();
        }

    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-approval')
    .controller('InsentifApprovalDetailController', InsentifApprovalDetailController);

  InsentifApprovalDetailController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$filter'
  ];
  /** @ngInject */
  function InsentifApprovalDetailController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifApproval();
    var $translate = $filter('translate');

    vm.results = []
    vm.dialogClose = closeModal

    loadDetail();

    function loadDetail() {
      angular.element.blockUI();
      var response = endPoint.query({ action: 'viewDetail', id: data.id });
      response.$promise.then(fetchDetail);
      response.$promise.catch(errorFetchDetail);
    }

    function fetchDetail(data) {
      angular.element.unblockUI();
      console.log(data)
      vm.results = data;
    }

    function errorFetchDetail() {
      angular.element.unblockUI();
      vm.results = [];
    }

    function closeModal() {
      $mdDialog.hide();
    }
  }
})();
(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.insentif-adjustment-target-absolute', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.insentif-adjustment-target-absolute', {
        url: '/insentif-adjustment-target-absolute',
        views: {
          'content@app': {
            templateUrl: 'app/main/insentif-adjustment-target-absolute/insentif-adjustment-target-absolute.html',
            controller: 'InsentifAdjustmentTargetAbsoluteController as vm'
          }
        }
      });
  }
}());
(function () {
    'use strict';

    angular
        .module('app.insentif-adjustment-target-absolute')
        .controller('InsentifAdjustmentTargetAbsoluteController', InsentifAdjustmentTargetAbsoluteController);

    InsentifAdjustmentTargetAbsoluteController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function InsentifAdjustmentTargetAbsoluteController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var endPoint = AppAPI.InsentifAdjustmentTargetAbsolute();
        var refSalesCode = AppAPI.RefSalesCode();

        Form.setObject(endPoint);

        vm.Form = Form;
        vm.company = $localStorage.empsite;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputData = inputData;
        vm.listSelected = [];
        vm.arr_area = [];
        vm.Delete = Delete;
        vm.editData = editData;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getSku = getSku;

        function selectedItemChanged(item) {
            vm.productId = '';
            vm.Form.objForm.name = '';
            vm.isDisabled = false;
            vm.Form.objForm.name = vm.searchStringData;
            if (typeof item !== 'undefined' && item) {
                vm.productId = item.skuid;
                vm.Form.objForm.name = item.name
            }
        }

        function getSku(searchText) {
            return $http
                .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.ref_master_product_id = '';
                    }
                    return item.data;
                });
        }

        loadData();
        function loadData(pageno) {
            vm.DataTable.loadData(endPoint, pageno, {
                action: 'viewdata',
                start_date: vm.start_date,
                end_date: vm.end_date
            });
        }

        function inputData(ev) {
            $mdDialog.show({
                controller: 'InputInsentifAdjustmentTargetAbsoluteController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-adjustment-target-absolute/input-insentif-adjustment-target-absolute.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editData(ev, data) {
            $mdDialog.show({
                controller: 'EditInsentifAdjustmentTargetAbsoluteController',
                controllerAs: 'vm',
                templateUrl: 'app/main/insentif-adjustment-target-absolute/input-insentif-adjustment-target-absolute.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    data: data
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                vm.listSelected = [];
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.listSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function Delete(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = endPoint.delete({
                        action: 'delete',
                        data: angular.toJson(vm.listSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });


        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.insentif-adjustment-target-absolute')
    .controller('InputInsentifAdjustmentTargetAbsoluteController', InputInsentifAdjustmentTargetAbsoluteController);

  InputInsentifAdjustmentTargetAbsoluteController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter'];

  /* @ngInject */
  function InputInsentifAdjustmentTargetAbsoluteController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;

    Form.initialForm();

    var endPoint = AppAPI.InsentifAdjustmentTargetAbsolute();
    var refSalesCode = AppAPI.RefSalesCode();

    // set constructor form
    Form.setObject(endPoint);

    // set form to controller
    vm.Form = Form;

    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.saveData = saveData;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;
    vm.selectedItemChangedUser = selectedItemChangedUser;
    vm.getEmployee = getEmployee;
    vm.getSku = getSku;

    vm.checkRoa = checkRoa
    vm.roa = false;
    function checkRoa(param) {
      if (typeof param != 'undefined' && param != 0) {
        vm.roa = true;
      } else {
        vm.roa = false;
      }
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChangedUser(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchStringUser;
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function selectedItemChanged(item) {
      vm.Form.objForm.ref_master_product_id = '';
      vm.Form.objForm.name = '';
      vm.isDisabled = false;
      vm.Form.objForm.name = vm.searchString;
      if (typeof item !== 'undefined' && item) {
        vm.Form.objForm.ref_master_product_id = item.skuid;
        vm.Form.objForm.name = item.name
      }
    }

    function getSku(searchText) {
      return $http
        .get(config.api + 'api/insentifsalestarget?action=searchSku&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.ref_master_product_id = '';
          }
          return item.data;
        });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, endPoint);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    $scope.isDisabled = true;
  }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-adjustment-target-absolute')
        .controller('EditInsentifAdjustmentTargetAbsoluteController', EditInsentifAdjustmentTargetAbsoluteController);

    EditInsentifAdjustmentTargetAbsoluteController.$inject = ['$localStorage', 'data', '$mdDialog', 'Form', 'AppAPI', 'config', '$http', '$filter'];

    /* @ngInject */
    function EditInsentifAdjustmentTargetAbsoluteController($localStorage, data, $mdDialog, Form, AppAPI, config, $http, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;
        vm.company = $localStorage.empsite;
        vm.isCb = false;

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.InsentifAdjustmentTargetAbsolute();
        var refSalesCode = AppAPI.RefSalesCode();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.saveData = saveData;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        vm.selectedItemChangedUser = selectedItemChangedUser;
        vm.getEmployee = getEmployee;

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    if (item.data.length === '') {
                        vm.empno = '';
                    }
                    return item.data;
                });
        }

        function selectedItemChangedUser(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchStringUser;
            if (typeof employee !== 'undefined' && employee) {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function selectedItemChanged(item) {
            vm.Form.objForm.ref_master_product_id = '';
            vm.Form.objForm.name = '';
            vm.isDisabled = false;
            vm.Form.objForm.name = vm.searchString;
            if (typeof item !== 'undefined' && item) {
                vm.Form.objForm.ref_master_product_id = item.skuid;
                vm.Form.objForm.name = item.name
            }
        }

        vm.Form.objForm.id = data.id;
        vm.Form.objForm.ba_no = data.ba_no;
        if (data.ba_date != '1970-01-01') {
            vm.Form.objForm.ba_date = new Date(data.ba_date);
        }
        vm.Form.objForm.percentage = parseFloat(data.percentage);
        vm.Form.objForm.nik = data.ba_creator + ' - ' + data.ba_creator_name;
        vm.Form.objForm.nikEmp = data.ba_creator;
        vm.Form.objForm.start_date = new Date(data.start_date);
        vm.Form.objForm.end_date = new Date(data.end_date);

        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, endPoint);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                errorDialog(data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insentif-adjustment-kpi', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-adjustment-kpi', {
                url: '/insentif-adjustment-kpi',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-adjustment-kpi/insentif-adjustment-kpi.html',
                        controller: 'InsentifAdjustKpiController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-adjustment-kpi')
        .controller('viewInsentifAdjustKpiDetailController', viewInsentifAdjustKpiDetailController);

    viewInsentifAdjustKpiDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewInsentifAdjustKpiDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var endPoint = AppAPI.InsentifAdjusmentKpi();
        var skema = AppAPI.InsentifSkema();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var SalesCode = AppAPI.RefSalesCode();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.status = data.status
        vm.company = $localStorage.empsite
        vm.refData = data
        vm.dialogClose = dialogClose
        vm.exists = exists

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        vm.listKpi = [];
        var obj = {};
        obj["is_sku_focus"] = false;
        obj["criteria"] = '';
        obj["weight"] = 0;
        obj["target"] = 0;
        obj["description"] = '';
        obj["start_range"] = 0;
        obj["end_range"] = 0;
        obj["sales_type"] = [];
        obj["multiple_index"] = 0;
        obj["is_checked"] = false;
        obj["list_ach"] = [];
        obj["achievement"] = 'A';
        vm.listKpi.push(obj);

        vm.listStatus = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];

        loadPeriod();
        loadCriteria();
        getSchemeObject();
        loadPrincipal();

        loadDetail();
        getAreaSales();

        function getAreaSales() {
            var response = SalesCode.query({ action: 'getAreaSales', companyid: vm.company });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorFetchAreaSales);
        }

        function fetchAreaSales(data) {
            vm.listAreaSales = data;
        }

        function errorFetchAreaSales() {
            vm.listAreaSales = [];
        }

        function exists(item, list) {
            return list.indexOf(item.id) > -1;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            angular.element.blockUI();
            var response = endPoint.query({ action: 'viewDetail', id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            angular.element.unblockUI();

            vm.Form.objForm.id = data[0].id;
            vm.Form.objForm.surkom_no = data[0].surkom_no;
            vm.Form.objForm.surkom_date = new Date(data[0].surkom_date);
            vm.Form.objForm.nik = data[0].surkom_by + ' - ' + data[0].surkom_creator;
            vm.Form.objForm.channel = data[0].channel;
            vm.Form.objForm.schema_object = data[0].schema_object_id;
            vm.Form.objForm.scheme_type = data[0].scheme_type;
            vm.Form.objForm.start = data[0].start;
            vm.Form.objForm.end = data[0].end;
            vm.Form.objForm.area_sales_id = data[0].area_sales_id;

            getWilayah(data[0].channel)
            loadSalesType(data[0].channel)
            vm.listKpi = data[0].listKpi;
            var i;
            for (i = 0; i < vm.listKpi.length; i++) {
                vm.listKpi[i].weight = parseFloat(vm.listKpi[i].weight);
                vm.listKpi[i].is_checked = 0;
                if (vm.listKpi[i].is_sku_focus == 1) {
                    vm.listKpi[i].is_checked = 1;
                }
                var j;
                for (j = 0; j < vm.listKpi[i].ach.length; j++) {
                    vm.listKpi[i].ach[j].start_range = parseFloat(vm.listKpi[i].ach[j].start_range);
                    vm.listKpi[i].ach[j].end_range = parseFloat(vm.listKpi[i].ach[j].end_range);
                    vm.listKpi[i].ach[j].multiple_index = parseFloat(vm.listKpi[i].ach[j].multiple_index);
                }
            }
        }

        function errorFetchDetail() {
            angular.element.unblockUI();
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function loadPeriod() {
            var response = kpiSales.query({ action: 'getPeriod' });
            response.$promise.then(fetchPeriod);
            response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
            vm.listStart = data;
            vm.listEnd = data;
        }

        function errorFetchPeriod() {
            vm.listStart = [];
            vm.listEnd = [];
        }

        vm.listSchemeType = [
            {
                'id': 'direct',
                'name': 'DIRECT'
            },
            {
                'id': 'indirect',
                'name': 'INDIRECT'
            },
        ];
        vm.listChannel = [
            {
                'id': 'GT',
                'name': 'GT'
            },
            {
                'id': 'MT',
                'name': 'MT'
            },
        ];

        function loadCriteria() {
            var response = kpiSales.query({ action: 'getKpiCriteria' });
            response.$promise.then(fetchCriteria);
            response.$promise.catch(errorFetchCriteria);
        }

        function fetchCriteria(data) {
            vm.listCriteria = data;
        }

        function errorFetchCriteria() {
            vm.listCriteria = [];
        }

        function getSchemeObject() {
            var response = endPoint.query({ action: 'getSchemeObject' });
            response.$promise.then(fetchSchemeObject);
            response.$promise.catch(errorFetchSchemeObject);
        }

        function fetchSchemeObject(data) {
            vm.listSchemeObject = data;
        }

        function errorFetchSchemeObject() {
            vm.listSchemeObject = [];
        }

        function loadPrincipal() {
            var response = endPoint.query({ action: 'getPrincipal' });
            response.$promise.then(fetchPrincipal);
            response.$promise.catch(errorFetchPrincipal);
        }

        function fetchPrincipal(data) {
            vm.listPrincipal = data;
        }

        function errorFetchPrincipal() {
            vm.listPrincipal = [];
        }

        function getWilayah(salesType) {
            var response = endPoint.query({ action: 'getWilayah', sales_type: salesType });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function loadSalesType(channel) {
            var response = endPoint.query({ action: 'getSalesType', channel: channel });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;

            var i;
            for (i = 0; i < data.length; i++) {
                vm.listSalesType[i].amount = parseFloat(data[i].amount);
            }

            vm.listKpi[0].sales_type = vm.listSalesType;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.insentif-adjustment-kpi')
    .controller('InsentifAdjustKpiController', InsentifAdjustKpiController);

  InsentifAdjustKpiController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function InsentifAdjustKpiController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifAdjusmentKpi();
    var skema = AppAPI.InsentifSkema();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var $translate = $filter('translate');

    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.editData = editData;
    vm.selectedItem = null;
    vm.searchText = null;

    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.stateEdit = false;

    vm.listSchemeType = [
      {
        'id': 'direct',
        'name': 'DIRECT'
      },
      {
        'id': 'indirect',
        'name': 'INDIRECT'
      },
    ];

    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);

      loadPeriod();
      getSchemeObject();
    }

    function getSchemeObject() {
      var response = endPoint.query({ action: 'getSchemeObject' });
      response.$promise.then(fetchSchemeObject);
      response.$promise.catch(errorFetchSchemeObject);
    }

    function fetchSchemeObject(data) {
      vm.listSchemeObject = data;
    }

    function errorFetchSchemeObject() {
      vm.listSchemeObject = [];
    }

    function loadPeriod() {
      var response = kpiSales.query({ action: 'getPeriod' });
      response.$promise.then(fetchPeriod);
      response.$promise.catch(errorFetchPeriod);
    }

    function fetchPeriod(data) {
      vm.listStart = data;
      vm.listEnd = data;
    }

    function errorFetchPeriod() {
      vm.listStart = [];
      vm.listEnd = [];
    }

    function loadData(pageno) {
      var dt = new Date();
      var year = dt.getFullYear()

      var startDate = typeof vm.start != 'undefined' ? year + "-" + vm.start + "-01" : "";
      var endDate = typeof vm.end != 'undefined' ? year + "-" + vm.end + "-01" : "";

      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        channel: vm.channel,
        schema_object: vm.schema_object,
        scheme_type: vm.scheme_type,
        start_date: startDate,
        end_date: endDate,
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'InsentifAdjustKpiInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-adjustment-kpi/insentif-adjustment-kpi-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          _data: null
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, item) {
      $mdDialog.show({
        controller: 'InsentifAdjustKpiEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-adjustment-kpi/insentif-adjustment-kpi-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: item
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewInsentifSkemaOverrideDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insentif-adjustment-kpi/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function loadSalesType() {
      var response = kpiSales.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function loadAbsoluteType() {
      var response = endPoint.query({ action: 'getAbsoluteType' });
      response.$promise.then(fetchAbsoluteType);
      response.$promise.catch(errorFetchAbsoluteType);
    }

    function fetchAbsoluteType(data) {
      vm.listAbsoluteType = data;
    }

    function errorFetchAbsoluteType() {
      vm.listAbsoluteType = [];
    }

    function loadPrincipal() {
      var response = endPoint.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.listprincipal = data;
    }

    function errorFetchPrincipal() {
      vm.listprincipal = [];
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();

            vm.objForm = new endPoint();
            vm.objForm.action = 'delete';
            vm.objForm.data = vm.selected;
            var response = vm.objForm.$save();

            response.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = $translate(expmess[0]) + ', ' + expmess[1] + ' ' + $translate(expmess[2]) + ' ' + expmess[3] + ' ' + $translate(expmess[4]);
      } else {
        var message = $translate(data.pesan);
      }

      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.insentif-adjustment-kpi')
    .controller('InsentifAdjustKpiInputController', InsentifAdjustKpiInputController);

  InsentifAdjustKpiInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$filter',
    '$http',
    '$localStorage',
    'FileUploader',
    '$element',
    '$document',
    '_data',
    'config'
  ];
  /** @ngInject */
  function InsentifAdjustKpiInputController(
    $mdDialog,
    AppAPI,
    Form,
    $filter,
    $http,
    $localStorage,
    FileUploader,
    $element,
    $document,
    _data,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.InsentifAdjusmentKpi();
    var kpiSales = AppAPI.InsentifKpiSetting();
    var refSalesCode = AppAPI.RefSalesCode();
    var skema = AppAPI.InsentifSkema();

    var $translate = $filter('translate');

    vm.listData = _data;

    vm.selectedItem = null;
    vm.searchText = null;
    vm.edit = false;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.saveData = saveData;
    vm.getWilayah = getWilayah;
    vm.loadDetailRef = loadDetailRef;
    vm.exists = exists;
    vm.toggle = toggle;
    vm.getSalesType = getSalesType;
    vm.selectedPrincipal = [];

    vm.listChannel = [
      {
        'id': 'GT',
        'name': 'GT'
      },
      {
        'id': 'MT',
        'name': 'MT'
      },
    ];
    activate();

    function activate() {
      vm.selected = [];
      loadRefScheme();
      loadCriteria();
      loadPrincipal();
      getSalesType()
    }


    function loadPrincipal() {
      var response = skema.query({ action: 'getPrincipal' });
      response.$promise.then(fetchPrincipal);
      response.$promise.catch(errorFetchPrincipal);
    }

    function fetchPrincipal(data) {
      vm.listPrincipal = data;
    }

    function errorFetchPrincipal() {
      vm.listPrincipal = [];
    }

    function getSalesType() {
      var response = refSalesCode.query({ action: 'getSalesType' });
      response.$promise.then(fetchSalesType);
      response.$promise.catch(errorFetchSalesType);
    }

    function fetchSalesType(data) {
      vm.listSalesType = data;
    }

    function errorFetchSalesType() {
      vm.listSalesType = [];
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      var index, len;
      for (index = 0, len = list.length; index < len; ++index) {
        if (list[index].id == item.id) {
          return true;
        }
      }
    }

    function loadCriteria() {
      var response = kpiSales.query({ action: 'getKpiCriteria' });
      response.$promise.then(fetchCriteria);
      response.$promise.catch(errorFetchCriteria);
    }

    function fetchCriteria(data) {
      vm.listCriteria = data;
    }

    function errorFetchCriteria() {
      vm.listCriteria = [];
    }

    function loadDetailRef(id) {
      angular.element.blockUI();
      var response = endPoint.query({ action: 'viewDetail', id: id, isRef: '1' });
      response.$promise.then(fetchDetail);
      response.$promise.catch(errorFetchDetail);
    }

    function fetchDetail(data) {
      angular.element.unblockUI();

      getWilayah(data[0].channel)

      vm.listKpi = data[0].listKpi;

      var i;
      for (i = 0; i < vm.listKpi.length; i++) {
        vm.listKpi[i].percentage = parseFloat(vm.listKpi[i].percentage);
      }
    }

    function errorFetchDetail() {
      //
    }

    function loadRefScheme() {
      var response = endPoint.query({ action: 'getRefScheme' });
      response.$promise.then(fetchRefScheme);
      response.$promise.catch(errorFetchRefScheme);
    }

    function fetchRefScheme(data) {
      vm.listRefScheme = data;
    }

    function errorFetchRefScheme() {
      vm.listRefScheme = [];
    }

    function getWilayah(salesType) {
      var response = endPoint.query({ action: 'getWilayah', sales_type: salesType });
      response.$promise.then(fetchWilayah);
      response.$promise.catch(errorFetchWilayah);
    }

    function fetchWilayah(data) {
      vm.listWilayah = data;
    }

    function errorFetchWilayah() {
      vm.listWilayah = [];
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function saveData(ev, frm) {
      angular.element.blockUI();

      vm.Form.objForm.listKPI = vm.listKpi;

      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.insentif-adjustment-kpi')
        .controller('InsentifAdjustKpiEditController', InsentifAdjustKpiEditController);

    InsentifAdjustKpiEditController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function InsentifAdjustKpiEditController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var $translate = $filter('translate');

        var endPoint = AppAPI.InsentifAdjusmentKpi();
        var kpiSales = AppAPI.InsentifKpiSetting();
        var refSalesCode = AppAPI.RefSalesCode();
        var skema = AppAPI.InsentifSkema();

        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.dialogClose = dialogClose
        vm.edit = true
        vm.fileSizeError = true;
        vm.company = $localStorage.empsite;

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        vm.saveData = saveData;

        vm.saveData = saveData;
        vm.getWilayah = getWilayah;
        vm.toggle = toggle;
        vm.getSalesType = getSalesType;
        vm.selectedPrincipal = [];

        angular.element.blockUI();

        vm.listChannel = [
            {
                'id': 'GT',
                'name': 'GT'
            },
            {
                'id': 'MT',
                'name': 'MT'
            },
        ];

        function loadDetail(id) {
            var response = endPoint.query({ action: 'viewDetail', id: id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function fetchDetail(data) {
            vm.Form.objForm.principal = data[0].principal
            vm.Form.objForm.ref_sales_type_id = data[0].sales_type
        }

        function errorFetchDetail() {
            vm.Form.objForm.principal = [];
            vm.Form.objForm.ref_sales_type_id = [];
        }

        loadDetail(data.id);
        getWilayah(data.channel);
        vm.Form.objForm.id = data.id;
        vm.Form.objForm.channel = data.channel;
        vm.Form.objForm.wilayah = data.regional_sales_id;
        vm.Form.objForm.criteria = data.ref_kpi_salesman_id;
        vm.Form.objForm.start_date = new Date(data.start_date);
        vm.Form.objForm.end_date = new Date(data.end_date);
        vm.Form.objForm.percentage = parseFloat(data.percentage);
        loadCriteria();
        getSalesType()
        loadPrincipal()

        function loadPrincipal() {
            var response = skema.query({ action: 'getPrincipal' });
            response.$promise.then(fetchPrincipal);
            response.$promise.catch(errorFetchPrincipal);
        }

        function fetchPrincipal(data) {
            vm.listPrincipal = data;
        }

        function errorFetchPrincipal() {
            vm.listPrincipal = [];
        }

        function getSalesType() {
            var response = refSalesCode.query({ action: 'getSalesType' });
            response.$promise.then(fetchSalesType);
            response.$promise.catch(errorFetchSalesType);
        }

        function fetchSalesType(data) {
            vm.listSalesType = data;
        }

        function errorFetchSalesType() {
            vm.listSalesType = [];
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function loadCriteria() {
            var response = kpiSales.query({ action: 'getKpiCriteria' });
            response.$promise.then(fetchCriteria);
            response.$promise.catch(errorFetchCriteria);
        }

        function fetchCriteria(data) {
            vm.listCriteria = data;
        }

        function errorFetchCriteria() {
            vm.listCriteria = [];
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function getWilayah(salesType) {
            var response = endPoint.query({ action: 'getWilayah', sales_type: salesType });
            response.$promise.then(fetchWilayah);
            response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah = data;
        }

        function errorFetchWilayah() {
            vm.listWilayah = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();

            var response = Form.saveData('update', frm, endPoint);
            response.then(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });

            response.catch(function (data) {
                angular.element.unblockUI();
                frm.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var message = $translate(data.pesan);
            var status = $translate(data.status);

            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }
    }
})();
(function() {
    "use strict";

    angular
        .module("app.indisciplinary-validation")
        .controller("IndisciplinaryValidationController", Controller);

    Controller.$inject = [
        "AppAPI",
        "Auth",
        "$mdDialog",
        "config",
        "$localStorage",
        "DataService",
        "$state"
    ];

    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        config,
        $localStorage,
        DataService,
        $state
    ) {
        var vm = this;
        var endpoint = AppAPI.IndisciplinaryValidation();
        var Attendancereport = AppAPI.Attendancereport();
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.DataTable.jumDataPerPage = 5;
        vm.confirmStatus = confirmStatus;
        vm.showFilter = true;
        vm.subArea = "all";
        vm.status = "0";
        vm.listSubArea = [];
        vm.updateForm = updateForm;
        vm.getStatus = getStatus;

        activate();

        function activate() {
            loadSubArea();
            loadData(1);
        }

        function loadData(pageNo) {
            vm.DataTable.loadData(endpoint, pageNo, {
                action: "view",
                sub_area_id: vm.subArea,
                status: vm.status
            });
        }

        function confirmStatus(ev, item) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title("Confirmation")
                    .textContent("Are you sure ?")
                    .ariaLabel("confirm dialog")
                    .targetEvent(ev)
                    .ok("YES")
                    .cancel("NO");

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        var response = endpoint.save({
                            action: "setConfirm",
                            data: item
                        });
                        response.$promise.then(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data.data);
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.message)
                        .ariaLabel(data.title)
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function() {
                    loadData(1);
                });
        }

        function loadSubArea() {
            var response = Attendancereport.query({ action: "viewSubArea" });
            response.$promise.then(function(res) {
                vm.listSubArea = res;
                if (res.length > 0) {
                    vm.subArea = res[0].subarea_id;
                }
            });
            response.$promise.catch(function(err) {
                vm.listSubArea = [];
            });
        }

        function updateForm(ev, refData) {
            $mdDialog
                .show({
                    controller: "FormIndisciplynaryValidationController as vm",
                    templateUrl:
                        "app/main/indisciplinary-validation/update/update.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    multiple: true,
                    fullscreen: true,
                    locals: {
                        REF_DATA: refData
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function getStatus(status) {
            switch (status) {
                case "0":
                    return "REGISTER";
                case "1":
                    return "VALID";
                case "2":
                    return "INVALID";
            }
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.indisciplinary-request")
        .controller("IndisciplinaryRequestController", Controller);

    Controller.$inject = [
        "AppAPI",
        "$state",
        "$localStorage",
        "$scope",
        "$mdToast",
        "Auth",
        "$mdDialog",
        "DataService"
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $state,
        $localStorage,
        $scope,
        $mdToast,
        Auth,
        $mdDialog,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.IndisciplinaryRequest();
        vm.DataTable = new DataService();
        vm.leterType = "all";
        vm.loadData = loadData;
        vm.listJum = [5, 10, 20, 25, 50];
        vm.DataTable.jumDataPerPage = 20;
        vm.isCheckAction = false;
        vm.isCheckActionPrint = false;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isChecked = isChecked;
        vm.checked = [];
        vm.checkedAll = false;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.disabledSelectAll = disabledSelectAll;
        vm.showFilter = true;
        vm.showFormDialog = showFormDialog;
        vm.showDeleteDialog = showDeleteDialog;
        vm.printPDF = printPDF;
        vm.switchStatusResult = switchStatusResult;
        vm.viewDetail = viewDetail;
        vm.letters = [];
        vm.importDocument = importDocument;
        vm.actionDialog = actionDialog;
        vm.isApproved = isApproved;
        vm.canDelete = canDelete;
        vm.getStatus = getStatus;
        vm.viewNotes = viewNotes;
        vm.viewUpdateForm = viewUpdateForm;

        activate();

        function activate() {
            loadLetter();
            loadData(1);
        }

        function loadData(pageno) {
            vm.DataTable.loadData(endpoint, pageno, {
                action: "view",
                letter_type: vm.leterType
            });
        }

        function loadLetter() {
            var request = endpoint.query({ action: "getLetter" });
            request.$promise.then(function(response) {
                vm.letters = response;
            });
            request.$promise.catch(function(error) {
                vm.letters = [];
            });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function switchStatusResult(status) {
            if (!status) {
                return 0;
            } else {
                if (status === "approve") {
                    return 1;
                } else {
                    return 2;
                }
            }
        }

        function toggle(item) {
            var idx = vm.checked.indexOf(item);
            if (idx > -1) {
                vm.checked.splice(idx, 1);
            } else {
                vm.checked.push(item);
            }
            console.log(vm.checked);
        }

        function exists(item) {
            return vm.checked.indexOf(item) > -1;
        }

        function isChecked() {
            return vm.checked.length === vm.DataTable.list.length;
        }

        function isIndeterminate() {
            return (
                vm.checked.length !== 0 &&
                vm.checked.length !== vm.DataTable.list.length
            );
        }

        function toggleAll() {
            if (vm.checked.length === vm.DataTable.list.length) {
                vm.checked = [];
            } else if (vm.checked.length === 0 || vm.checked.length > 0) {
                angular.forEach(vm.DataTable.list, function(v, k) {
                    if (!exists(v.id)) {
                        if (v.letter_type !== "suspension-letter") {
                            vm.checked.push(v.id);
                        } else {
                            if (v.status_approval === "approved") {
                                vm.checked.push(v.id);
                            }
                        }
                    }
                });
            }
        }

        function disabledSelectAll() {
            var response = false;
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].status == "progress") {
                    response = true;
                    break;
                }
            }
            return response;
        }

        function showFormDialog(ev, type, item, isAdmin) {
            $mdDialog
                .show({
                    controller: "IndisciplinaryRequestFormController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/form/form.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        dialogType: type,
                        reffData: item,
                        isAdmin: isAdmin
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function showDeleteDialog(ev, item) {
            // check if request is already approved
            if (isApproved(item.approval)) {
                showDialog(ev, {
                    title: "Attention",
                    message: "This request is already approved"
                });
                return;
            }

            // check if request is confirmation
            // and item is already validating
            if (item.type == "confirm") {
                if (item.is_valid == 1) {
                    showDialog(ev, {
                        title: "Attention",
                        message: "This request is already validated"
                    });
                    return;
                }
            }

            var payload = {
                id: item.id,
                type: item.type
            };
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title("Would you like to delete this ?")
                    .textContent(
                        "Data your selected will be deleted and can not recovered."
                    )
                    .ariaLabel("delete dialog")
                    .targetEvent(ev)
                    .ok("YES")
                    .cancel("NO");

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        var response = endpoint.delete({
                            action: "delete",
                            data: angular.toJson(payload)
                        });
                        response.$promise.then(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.message)
                        .ariaLabel(data.title)
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function() {
                    loadData(1);
                });
        }

        function printPDF(params) {
            var str = "";
            var ctr = vm.checked.length;
            for (var i = 0; i < ctr; i++) {
                str += vm.checked[i];
                if (i !== ctr - 1) {
                    str += "-";
                }
            }
            $state.goNewTab("app.report.correspondence.pma", {
                data: str
            });
        }

        function viewDetail(ev, item) {
            $mdDialog
                .show({
                    controller:
                        "IndisciplinaryRequestViewApprovalController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/view-approval/view-approval.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function importDocument(ev, item) {
            $mdDialog
                .show({
                    controller: "IndisciplinaryUploadDocumentController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/upload/upload.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function actionDialog(ev, item) {
            $mdDialog
                .show({
                    controller: "IndisciplinaryFormOtherController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/form-other/form-other.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function canDelete(approval) {
            var ctr = approval.length;
            for (var i = 0; i < ctr; i++) {
                if (approval[i].approval_status == 2) {
                    return true;
                }
            }
            return false;
        }

        function isApproved(approval) {
            var ctr = approval.length;
            for (var i = 0; i < ctr; i++) {
                if (approval[i].is_last_approval == 1) {
                    if (approval[i].approval_status == 2) {
                        return true;
                    }
                }
            }
            return false;
        }

        function getStatus(status) {
            switch (status) {
                case "0":
                    return "REGISTER";
                case "1":
                    return "VALID";
                case "2":
                    return "INVALID, CLICK TO UPDATE";
            }
        }

        function viewNotes(ev, item) {
            $mdDialog
                .show({
                    controller: "IndisciplinaryRequestNotesController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/notes/notes.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        REF_DATA: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function viewUpdateForm(ev, item) {
            $mdDialog
                .show({
                    controller: "IndisciplinaryRequestUpdateController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/update/update/update.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }
    }
})();

(function() {
    "use strict";

    angular.module("app.indisciplinary-confirm", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.indisciplinary_confirm", {
            url: "/indisciplinary-confirm",
            views: {
                "content@app": {
                    templateUrl:
                        "app/main/indisciplinary-confirm/indisciplinary-confirm.html",
                    controller: "IndisciplinaryConfirmController as vm"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.indisciplinary-confirm')
        .controller('IndisciplinaryConfirmController', Controller);

    Controller.$inject = [
        'AppAPI',
        'Auth',
        '$mdDialog',
        'config',
        '$localStorage',
        'DataService',
        '$state'
    ];

    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        config,
        $localStorage,
        DataService,
        $state
    ) {
        var vm = this;
        var endpoint = AppAPI.IndisciplinaryConfirm();
        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.DataTable.jumDataPerPage = 5;
        vm.confirmStatus = confirmStatus;

        activate();

        function activate() {
            loadData(1);
        }

        function loadData(pageNo) {
            vm.DataTable.loadData(endpoint, pageNo, {
                action: 'view'
            });
        }

        function confirmStatus(ev, item) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Confirmation')
                    .textContent('Are you sure ?')
                    .ariaLabel('confirm dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        var response = endpoint.save({
                            action: 'setConfirm',
                            data: item
                        });
                        response.$promise.then(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data.data);
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.message)
                        .ariaLabel(data.title)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    loadData(1);
                });
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("app.indisciplinary-approval")
        .controller("IndisciplinaryApprovalController", Controller);

    Controller.$inject = [
        "AppAPI",
        "$state",
        "$localStorage",
        "$scope",
        "$mdToast",
        "Auth",
        "$mdDialog",
        "DataService"
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        $state,
        $localStorage,
        $scope,
        $mdToast,
        Auth,
        $mdDialog,
        DataService
    ) {
        var vm = this;
        var endpoint = AppAPI.IndisciplinaryApproval();
        vm.DataTable = new DataService();
        vm.isCheckAction = false;
        vm.isCheckActionPrint = false;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isChecked = isChecked;
        vm.checked = [];
        vm.checkedAll = false;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.disabledSelectAll = disabledSelectAll;
        vm.showFilter = true;
        vm.listJum = [5, 10, 20, 25, 30];
        vm.status = "1";
        vm.loadData = loadData;
        vm.showApproveDialog = showApproveDialog;
        vm.showRequestDialog = showRequestDialog;
        vm.showFormExport = showFormExport;
        vm.switchStatusApproval = switchStatusApproval;
        vm.viewDetail = viewDetail;

        activate();

        function activate() {
            loadData(1);
        }

        function loadData(pageno) {
            vm.checked = [];
            vm.DataTable.loadData(endpoint, pageno, {
                action: "view",
                approval_status: vm.status
            });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function toggle(item) {
            if (item.approval_status == "0") {
                return;
            }
            var idx = vm.checked.indexOf(item);
            if (idx > -1) {
                vm.checked.splice(idx, 1);
            } else {
                vm.checked.push(item);
            }
        }

        function exists(item) {
            return vm.checked.indexOf(item) > -1;
        }

        function isChecked() {
            return vm.checked.length === vm.DataTable.list.length;
        }

        function isIndeterminate() {
            return (
                vm.checked.length !== 0 &&
                vm.checked.length !== vm.DataTable.list.length
            );
        }

        function toggleAll() {
            if (vm.checked.length === vm.DataTable.list.length) {
                vm.checked = [];
            } else if (vm.checked.length === 0 || vm.checked.length > 0) {
                angular.forEach(vm.DataTable.list, function(v, k) {
                    if (!exists(v)) {
                        vm.checked.push(v);
                    }
                });
            }
        }

        function disabledSelectAll() {
            var response = false;
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].status == "progress") {
                    response = true;
                    break;
                }
            }
            return response;
        }

        function showApproveDialog(ev) {
            console.log(vm.checked);
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title("Would you like to approve this ?")
                    .textContent("Data your selected will be approved.")
                    .ariaLabel("approve dialog")
                    .targetEvent(ev)
                    .ok("YES")
                    .cancel("NO");

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        var response = endpoint.save({
                            action: "setStatusApproval",
                            approval: vm.checked,
                            transaction: "APPROVE"
                        });
                        response.$promise.then(function(data) {
                            angular.element.unblockUI();
                            vm.checked = [];
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data.data);
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showRequestDialog(ev, transaction, item) {
            switch (transaction) {
                case "REJECT":
                    var confirm = $mdDialog
                        .prompt()
                        .title(
                            "What would you give a " +
                                transaction +
                                " comment ?"
                        )
                        .textContent(transaction + " Comment")
                        .placeholder("Insert Comment")
                        .ariaLabel("reject Comment")
                        .initialValue("no comment")
                        .targetEvent(ev)
                        .ok("OK")
                        .cancel("NO");

                    $mdDialog.show(confirm).then(
                        function(result) {
                            var payload = {
                                transaction: transaction,
                                indisciplinary_id: item.indisciplinary_id,
                                notes: result,
                                action: "setStatusApproval"
                            };
                            sendRequest(ev, payload);
                        },
                        function() {
                            var payload = {
                                transaction: transaction,
                                indisciplinary_id: item.indisciplinary_id,
                                notes: "none",
                                action: "setStatusApproval"
                            };
                            sendRequest(ev, payload);
                        }
                    );
                    break;
                case "UNREJECT":
                case "UNAPPROVE":
                    var payload = {
                        transaction: transaction,
                        indisciplinary_id: item.indisciplinary_id,
                        nik: item.nik,
                        action: "setStatusApproval"
                    };
                    sendRequest(ev, payload);
                    break;
            }
        }

        function sendRequest(ev, payload) {
            angular.element.blockUI();
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title(
                        "Would you like to " + payload.transaction + " this ?"
                    )
                    .textContent(
                        "Data your selected will be " + payload.transaction
                    )
                    .ariaLabel(payload.transaction + "dialog")
                    .targetEvent(ev)
                    .ok("YES")
                    .cancel("NO");

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        var response = endpoint.save(payload);
                        response.$promise.then(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.message)
                        .ariaLabel(data.title)
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function() {
                    vm.isCheckAction = false;
                    dialogClose();
                    loadData(1);
                });
        }

        function showFormExport(ev) {
            $mdDialog
                .show({
                    controller: "IndisciplinaryExportController as vm",
                    templateUrl:
                        "app/main/indisciplinary-approval/export/export.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                .then(function() {
                    loadData(1);
                });
        }

        function switchStatusApproval(status) {
            switch (status) {
                case "0":
                    return "None";
                case "1":
                    return "Waiting Approval";
                case "2":
                    return "Approved";
                case "3":
                    return "Revised";
                case "4":
                    return "Rejected";
            }
        }

        function viewDetail(ev, item) {
            $mdDialog
                .show({
                    controller:
                        "IndisciplinaryRequestViewApprovalController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/view-approval/view-approval.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.indisciplinary-alert')
        .controller('IndisciplinaryAlertController', Controller);

    Controller.$inject = [
        'AppAPI',
        'Auth',
        '$mdDialog',
        'Form',
        '$timeout',
        '$http',
        'config',
        '$localStorage',
        'DataService',
        '$state'
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        $timeout,
        $http,
        config,
        $localStorage,
        DataService,
        $state
    ) {
        var vm = this;
        var endpoint = AppAPI.IndisciplinaryAlert();
        vm.DataTable = new DataService();
        vm.leterType = 'all';
        vm.loadData = loadData;
        vm.listJum = [5, 10, 20, 25, 50];
        vm.DataTable.jumDataPerPage = 20;
        vm.isCheckAction = false;
        vm.isCheckActionPrint = false;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isChecked = isChecked;
        vm.checked = [];
        vm.checkedAll = false;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.disabledSelectAll = disabledSelectAll;
        vm.showFilter = true;
        vm.showFormDialog = showFormDialog;
        vm.showDeleteDialog = showDeleteDialog;
        vm.printPDF = printPDF;
        vm.switchStatusResult = switchStatusResult;
        vm.viewDetail = viewDetail;
        vm.letters = [];
        vm.importDocument = importDocument;
        vm.actionDialog = actionDialog;
        vm.isApproved = isApproved;
        vm.canDelete = canDelete;
        vm.showFormExport = showFormExport;
        vm.anulir = anulir;
        vm.letter = 'all';
        vm.search = search;

        activate();

        function activate() {
            loadLetter();
            loadData(1);
        }

        function loadData(pageno) {
            vm.DataTable.loadData(endpoint, pageno, {
                action: 'view',
                letter_type: vm.letter
            });
        }

        function loadLetter() {
            var all = { code: 'all', name: 'All', validity_period: '0' };
            var request = endpoint.query({ action: 'getLetter' });
            request.$promise.then(function(response) {
                vm.letters = response;
                vm.letters.unshift(all);
            });
            request.$promise.catch(function(error) {
                vm.letters = [];
            });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function search(query) {
            console.log(query);
        }

        function switchStatusResult(status) {
            if (!status) {
                return 0;
            } else {
                if (status === 'approve') {
                    return 1;
                } else {
                    return 2;
                }
            }
        }

        function toggle(item) {
            var idx = vm.checked.indexOf(item);
            if (idx > -1) {
                vm.checked.splice(idx, 1);
            } else {
                vm.checked.push(item);
            }
            console.log(vm.checked);
        }

        function exists(item) {
            return vm.checked.indexOf(item) > -1;
        }

        function isChecked() {
            return vm.checked.length === vm.DataTable.list.length;
        }

        function isIndeterminate() {
            return (
                vm.checked.length !== 0 &&
                vm.checked.length !== vm.DataTable.list.length
            );
        }

        function toggleAll() {
            if (vm.checked.length === vm.DataTable.list.length) {
                vm.checked = [];
            } else if (vm.checked.length === 0 || vm.checked.length > 0) {
                angular.forEach(vm.DataTable.list, function(v, k) {
                    if (!exists(v.id)) {
                        if (v.letter_type !== 'suspension-letter') {
                            vm.checked.push(v.id);
                        } else {
                            if (v.status_approval === 'approved') {
                                vm.checked.push(v.id);
                            }
                        }
                    }
                });
            }
        }

        function disabledSelectAll() {
            var response = false;
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].status == 'progress') {
                    response = true;
                    break;
                }
            }
            return response;
        }

        function showFormDialog(ev, type, item, isAdmin) {
            $mdDialog
                .show({
                    controller: 'IndisciplinaryAlertFormController as vm',
                    templateUrl: 'app/main/indisciplinary-alert/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        dialogType: type,
                        reffData: item,
                        isAdmin: isAdmin
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function showDeleteDialog(ev) {
            var promise = Auth.setToken();
            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Would you like to delete this ?')
                    .textContent(
                        'Data your selected will be deleted and can not recovered.'
                    )
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        var response = endpoint.delete({
                            action: 'delete',
                            data: angular.toJson(vm.checked)
                        });
                        response.$promise.then(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(document.querySelector('#contentDialog'))
                        )
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.message)
                        .ariaLabel(data.title)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    dialogClose();
                    loadData(1);
                });
        }

        function printPDF() {
            var str = '';
            var ctr = vm.checked.length;
            for (var i = 0; i < ctr; i++) {
                str += vm.checked[i];
                if (i !== ctr - 1) {
                    str += '-';
                }
            }
            $state.goNewTab('app.report.correspondence.pma', {
                data: str
            });
        }

        function viewDetail(ev, item) {
            $mdDialog
                .show({
                    controller: 'IndisciplinaryRequestViewApprovalController as vm',
                    templateUrl:
                        'app/main/indisciplinary-request/view-approval/view-approval.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function importDocument(ev, item) {
            $mdDialog
                .show({
                    controller: 'IndisciplinaryUploadDocumentController as vm',
                    templateUrl:
                        'app/main/indisciplinary-request/upload/upload.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function actionDialog(ev, item) {
            $mdDialog
                .show({
                    controller: 'IndisciplinaryFormOtherController as vm',
                    templateUrl:
                        'app/main/indisciplinary-request/form-other/form-other.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item
                    }
                })
                .then(function() {
                    loadData(1);
                });
        }

        function canDelete(approval) {
            var ctr = approval.length;
            for (var i = 0; i < ctr; i++) {
                if (approval[i].approval_status === '2') {
                    return false;
                }
            }
            return true;
        }

        function isApproved(approval) {
            var ctr = approval.length;
            for (var i = 0; i < ctr; i++) {
                if (approval[i].is_last_approval == 1) {
                    if (approval[i].approval_status == 2) {
                        return true;
                    }
                }
            }
            return false;
        }

        function showFormExport(ev) {
            $mdDialog
                .show({
                    controller: 'IndisciplinaryExportController as vm',
                    templateUrl:
                        'app/main/indisciplinary-approval/export/export.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                .then(function() {
                    loadData(1);
                });
        }

        function anulir(ev, item, status) {
            var promise = Auth.setToken();
            var message = 'Anulir';

            if (status === '0') {
                message = 'Re-anulir (di kembalikan ke status asal)';
            }

            promise.then(function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Konfirmasi anulir permintaan')
                    .textContent(
                        'Permintaan dari ' + item.created_by + ' akan di' + message
                    )
                    .ariaLabel('anulir dialog')
                    .targetEvent(ev)
                    .ok('YES')
                    .cancel('NO');

                $mdDialog.show(confirm).then(
                    function() {
                        angular.element.blockUI();
                        var response = endpoint.save({
                            action: 'anulir',
                            id: item.id,
                            status: status
                        });
                        response.$promise.then(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function(data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });
                    },
                    function() {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.indisciplinary-admin', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.indiciplinary_admin', {
            url: '/indisciplinary-admin',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/indisciplinary-admin/indisciplinary-admin.html',
                    controller: 'IndisciplinaryAdminController as vm'
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.indisciplinary-admin")
        .controller("IndisciplinaryAdminController", Controller);

    Controller.$inject = [
        "AppAPI",
        "Auth",
        "$mdDialog",
        "Form",
        "$timeout",
        "$http",
        "config",
        "$localStorage",
        "DataService",
        "$state",
    ];

    /** @ngInject */
    function Controller(
        AppAPI,
        Auth,
        $mdDialog,
        Form,
        $timeout,
        $http,
        config,
        $localStorage,
        DataService,
        $state
    ) {
        var vm = this;
        var endpoint = AppAPI.IndisciplinaryAdmin();
        var Attendancereport = AppAPI.Attendancereport();
        var Subarea = AppAPI.Subarea();
        vm.DataTable = new DataService();
        vm.leterType = "all";
        vm.loadData = loadData;
        vm.listJum = [5, 10, 20, 25, 50];
        vm.DataTable.jumDataPerPage = 20;
        vm.isCheckAction = false;
        vm.isCheckActionPrint = false;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isChecked = isChecked;
        vm.checked = [];
        vm.checkedAll = false;
        vm.toggleAll = toggleAll;
        vm.isIndeterminate = isIndeterminate;
        vm.disabledSelectAll = disabledSelectAll;
        vm.showFilter = true;
        vm.showFormDialog = showFormDialog;
        vm.showDeleteDialog = showDeleteDialog;
        vm.printPDF = printPDF;
        vm.switchStatusResult = switchStatusResult;
        vm.viewDetail = viewDetail;
        vm.letters = [];
        vm.importDocument = importDocument;
        vm.actionDialog = actionDialog;
        vm.isApproved = isApproved;
        vm.canDelete = canDelete;
        vm.showFormExport = showFormExport;
        vm.anulir = anulir;
        vm.letter = "all";
        vm.search = search;
        vm.company = $localStorage.empsite;
        vm.division = "all";
        vm.department = "all";
        vm.subArea = "all";
        vm.listCompany = [];
        vm.listDepartment = [];
        vm.listDivision = [];
        vm.listSubArea = [];
        vm.approvalStatus = "all";
        vm.confirmationStatus = "all";
        vm.approvalStatusList = [
            {
                value: "all",
                name: "all",
            },
            {
                value: 1,
                name: "waiting",
            },
            {
                value: 2,
                name: "approved",
            },
            {
                value: 3,
                name: "reject",
            },
        ];
        vm.confirmationStatusList = [
            {
                value: "all",
                name: "all",
            },
            {
                value: 1,
                name: "confirmed",
            },
            {
                value: 0,
                name: "unconfirmed",
            },
        ];

        vm.loadSubArea = loadSubArea;
        vm.loadDataBU = loadDataBU;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;

        activate();

        function activate() {
            angular.element.blockUI("please wait, preparing filter");
            loadLetter();
            loadDataBU()
                .then(loadDataDivision)
                .then(loadDataDepartment)
                .then(loadSubArea)
                .then(function (res) {
                    angular.element.unblockUI();
                });
            // .then(loadData.bind(null, 1));
        }

        function loadData(pageno) {
            vm.DataTable.loadData(endpoint, pageno, {
                action: "view",
                letter_type: vm.letter,
                company: vm.company,
                division: vm.division,
                department: vm.department,
                sub_area_id: vm.subArea,
                confirmation: vm.confirmationStatus,
                approval: vm.approvalStatus,
            });
        }

        function loadDataDepartment() {
            var response = Attendancereport.query({
                action: "viewDivisiDept",
                idbu: vm.company,
                iddivisi: vm.division,
            });
            response.$promise.then(function (res) {
                vm.listDepartment = res;
            });
            response.$promise.catch(function (err) {
                vm.listDepartment = [];
            });
            return response.$promise;
        }

        function loadDataDivision() {
            var response = Attendancereport.query({
                action: "viewDivisiBu",
                idbu: vm.company,
            });
            response.$promise.then(function (res) {
                vm.listDivision = res;
            });
            response.$promise.catch(function () {
                vm.listDivision = [];
            });
            return response.$promise;
        }

        function loadDataBU() {
            var response = Attendancereport.query({
                action: "viewBu",
            });
            response.$promise.then(function (res) {
                vm.listCompany = res;
            });
            response.$promise.catch(function (err) {
                vm.listCompany = [];
            });
            return response.$promise;
        }

        function loadSubArea() {
            var response = Attendancereport.query({ action: "viewSubArea" });
            response.$promise.then(function (res) {
                vm.listSubArea = res;
                if (res.length > 0) {
                    vm.subArea = res[0].subarea_id;
                }
            });
            response.$promise.catch(function (err) {
                vm.listSubArea = [];
            });
            return response.$promise;
        }

        function loadLetter() {
            var all = { code: "all", name: "All", validity_period: "0" };
            var request = endpoint.query({ action: "getLetter" });
            request.$promise.then(function (response) {
                vm.letters = response;
                vm.letters.unshift(all);
            });
            request.$promise.catch(function (error) {
                vm.letters = [];
            });
            return request.$promise;
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function search(query) {
            console.log(query);
        }

        function switchStatusResult(status) {
            if (!status) {
                return 0;
            } else {
                if (status === "approve") {
                    return 1;
                } else {
                    return 2;
                }
            }
        }

        function toggle(item) {
            var idx = vm.checked.indexOf(item);
            if (idx > -1) {
                vm.checked.splice(idx, 1);
            } else {
                vm.checked.push(item);
            }
            // console.log(vm.checked);
        }

        function exists(item) {
            return vm.checked.indexOf(item) > -1;
        }

        function isChecked() {
            return vm.checked.length === vm.DataTable.list.length;
        }

        function isIndeterminate() {
            return (
                vm.checked.length !== 0 &&
                vm.checked.length !== vm.DataTable.list.length
            );
        }

        function toggleAll() {
            if (vm.checked.length === vm.DataTable.list.length) {
                vm.checked = [];
            } else if (vm.checked.length === 0 || vm.checked.length > 0) {
                angular.forEach(vm.DataTable.list, function (v, k) {
                    if (!exists(v.id)) {
                        if (v.letter_type !== "suspension-letter") {
                            vm.checked.push(v.id);
                        } else {
                            if (v.status_approval === "approved") {
                                vm.checked.push(v.id);
                            }
                        }
                    }
                });
            }
        }

        function disabledSelectAll() {
            var response = false;
            for (var i = 0; i < vm.DataTable.list.length; i++) {
                if (vm.DataTable.list[i].status == "progress") {
                    response = true;
                    break;
                }
            }
            return response;
        }

        function showFormDialog(ev, type, item, isAdmin) {
            $mdDialog
                .show({
                    controller: "IndisciplinaryRequestFormController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/form/form.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        dialogType: type,
                        reffData: item,
                        isAdmin: isAdmin,
                    },
                })
                .then(function () {
                    loadData(1);
                });
        }

        function showDeleteDialog(ev) {
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title("Would you like to delete this ?")
                    .textContent(
                        "Data your selected will be deleted and can not recovered."
                    )
                    .ariaLabel("delete dialog")
                    .targetEvent(ev)
                    .ok("YES")
                    .cancel("NO");

                var payload = [];
                vm.checked.map(function (val) {
                    var tmp = vm.DataTable.list.find(function (res) {
                        return res.id == val;
                    });
                    payload.push({
                        id: tmp.id,
                        type: tmp.type,
                    });
                });

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = endpoint.delete({
                            action: "delete",
                            data: angular.toJson(payload),
                        });
                        response.$promise.then(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }

        function showDialog(ev, data) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(
                            angular.element(
                                document.querySelector("#contentDialog")
                            )
                        )
                        .clickOutsideToClose(true)
                        .title(data.title)
                        .textContent(data.message)
                        .ariaLabel(data.title)
                        .ok("OK")
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                    loadData(1);
                });
        }

        function printPDF() {
            var str = "";
            var ctr = vm.checked.length;
            for (var i = 0; i < ctr; i++) {
                str += vm.checked[i];
                if (i !== ctr - 1) {
                    str += "-";
                }
            }
            $state.goNewTab("app.report.correspondence.pma", {
                data: str,
            });
        }

        function viewDetail(ev, item) {
            $mdDialog
                .show({
                    controller:
                        "IndisciplinaryRequestViewApprovalController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/view-approval/view-approval.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item,
                    },
                })
                .then(function () {
                    loadData(1);
                });
        }

        function importDocument(ev, item) {
            $mdDialog
                .show({
                    controller: "IndisciplinaryUploadDocumentController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/upload/upload.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item,
                    },
                })
                .then(function () {
                    loadData(1);
                });
        }

        function actionDialog(ev, item) {
            $mdDialog
                .show({
                    controller: "IndisciplinaryFormOtherController as vm",
                    templateUrl:
                        "app/main/indisciplinary-request/form-other/form-other.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        reffData: item,
                    },
                })
                .then(function () {
                    loadData(1);
                });
        }

        function canDelete(approval) {
            var ctr = approval.length;
            for (var i = 0; i < ctr; i++) {
                if (approval[i].approval_status === "2") {
                    return false;
                }
            }
            return true;
        }

        function isApproved(approval) {
            var ctr = approval.length;
            for (var i = 0; i < ctr; i++) {
                if (approval[i].is_last_approval == 1) {
                    if (approval[i].approval_status == 2) {
                        return true;
                    }
                }
            }
            return false;
        }

        function showFormExport(ev) {
            $mdDialog
                .show({
                    controller: "IndisciplinaryExportController as vm",
                    templateUrl:
                        "app/main/indisciplinary-approval/export/export.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                })
                .then(function () {
                    loadData(1);
                });
        }

        function anulir(ev, item, status) {
            var promise = Auth.setToken();
            var message = "Anulir";

            if (status === "0") {
                message = "Re-anulir (di kembalikan ke status asal)";
            }

            promise.then(function () {
                var confirm = $mdDialog
                    .confirm()
                    .title("Konfirmasi anulir permintaan")
                    .textContent(
                        "Permintaan dari " +
                            item.created_by +
                            " akan di" +
                            message
                    )
                    .ariaLabel("anulir dialog")
                    .targetEvent(ev)
                    .ok("YES")
                    .cancel("NO");

                $mdDialog.show(confirm).then(
                    function () {
                        angular.element.blockUI();
                        var response = endpoint.save({
                            action: "anulir",
                            id: item.id,
                            status: status,
                        });
                        response.$promise.then(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });

                        response.$promise.catch(function (data) {
                            angular.element.unblockUI();
                            showDialog(ev, data);
                        });
                    },
                    function () {
                        // $scope.status = 'You decided to keep your debt.';
                    }
                );
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.hcticket', ['ui.tinymce'])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.hcticket', {
                url: '/hc-tiket',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/hcticket/hctiket.html',
                        controller: 'HcTiketController as vm'
                    }
                }
            });
        $stateProvider
            .state('app.hcticket-user', {
                url: '/hc-ticket-user/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/hcticket/hctiket-user.html',
                        controller: 'HcTiketUserController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.hcticket')
        .controller('viewDocHcTicket', viewDocHcTicket);

    viewDocHcTicket.$inject = ['$http', '$mdDialog', 'config', 'img'];

    /* @ngInject */
    function viewDocHcTicket($http, $mdDialog, config, img) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal() {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage() {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = config.api + 'api/upload/' + vm.doc + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            // console.log(link);
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Document Not Found')
                        .textContent('Document not Found')
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.hcticket')
        .controller('viewHcTiketDetailController', viewHcTiketDetailController);

    viewHcTiketDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewHcTiketDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var Tiket = AppAPI.HcTicket();
        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.saveData = saveData;
        vm.closeTicket = closeTicket;
        vm.viewFile = viewFile
        vm.upload = upload
        vm.checkIsNeddFile = checkIsNeddFile
        vm.downloadDoc = downloadDoc
        vm.isSysdev = data.is_sysdev
        vm.status = data.status
        vm.refData = data
        vm.delegateToSysdev = delegateToSysdev

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(Tiket);

        vm.tinymceOptions = {
            height: 250,
            theme: 'modern',
            plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
            toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
            templates: [
                { title: 'template 1', content: 'Template 1' },
                { title: 'template 2', content: 'Template 2' }
            ],
        };

        loadTiketDetail();

        function loadTiketDetail() {
            var response = Tiket.query({ action: 'viewDetail', detail_id: data.id });
            response.$promise.then(fetchTiketDetail);
            response.$promise.catch(errorFetchTiketDetail);
        }

        function downloadDoc(ev, filename) {
            var name = filename;
            if (name !== null && name !== '') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                var message = translate('HCTICKET.MESSAGE.FILENOTFOUND');
                var status = translate('PAYROLL.MESSAGE.FAILED');

                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(message)
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }

        function fetchTiketDetail(data) {
            vm.id = data[0].id
            vm.errorType = data[0].errorType
            vm.type = data[0].type
            vm.isAdmin = data[0].isAdmin
            vm.title = data[0].title
            vm.description = (data[0].description == null || data[0].description === "") ? '<p>-</p>' : data[0].description
            vm.solutions = (data[0].note == null || data[0].note === "") ? '<p>-</p>' : data[0].note
            vm.requestedBy = data[0].requested_by + '-' + data[0].name
            vm.ticketStatus = data[0].statuss
            vm.company = data[0].company
            vm.area = data[0].area
            vm.estimation = (data[0].estimation != '0.0' && data[0].estimation != '0.00') ? data[0].estimation + ' ' + translate('MENU.MAIN.CB.HOUR') : '';
            vm.workDuration = (data[0].workDuration != '0.0' && data[0].workDuration != '0.00') ? data[0].workDuration + ' ' + translate('MENU.MAIN.CB.HOUR') : '';
            vm.phone = data[0].pic_phone
            vm.priority = data[0].priority
            vm.isRequested = data[0].is_requested
            vm.ticketRespons = data[0].respons
            vm.filename = data[0].filename
            vm.format = data[0].format
            vm.needSendMail = data[0].needSendMail
            vm.mailTo = data[0].mailTo

            vm.isClosed = data[0].status == '4' ? true : false;
            vm.message = translate('PAYROLL.MESSAGE.CLOSETICKETNOTIF');

            var tmpdate = new Date(data[0].created_at);
            var dd = tmpdate.getDate();
            var mm = tmpdate.getMonth() + 1; //January is 0!

            var yyyy = tmpdate.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            var tmpdate = dd + '/' + mm + '/' + yyyy;
            vm.requestedAt = tmpdate
        }

        function errorFetchTiketDetail() {
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();
            //set value
            vm.Form.objForm.ticket_id = data.id;
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.answer = vm.answer;
            var response = Form.saveData('reply', frm, Tiket);
            response.then(function (dataRespons) {
                loadTiketDetail()
                angular.element.unblockUI();
                frm.$setPristine();
                vm.answer = '';

                //sendEmail
                if (vm.needSendMail) {
                    vm.Form.objForm.title = data.title;
                    vm.Form.objForm.mailTo = vm.mailTo;
                    Form.saveData('sendMail', frm, Tiket);
                    // setTimeout(function () {
                    //     var promise = Auth.setToken();
                    //     promise.then(function () {
                    //         vm.objForm = new Tiket();
                    //         vm.objForm.action = 'sendMail';
                    //         //set value
                    //         vm.objForm.ticket_id = data.id;
                    //         vm.objForm.ticket_id = data.id;
                    //         vm.objForm.mailTo = vm.mailTo;
                    //         vm.objForm.$save();
                    //         var response = vm.objForm.$save();
                    //         response.then(function (data) {
                    //             Auth.setToken()
                    //         });
                    //         response.catch(function (data) {
                    //             Auth.setToken()
                    //         });
                    //     });
                    // }, 2000);
                    vm.showMessage = false;
                }
            });

            response.catch(function (data) {
                vm.showMessage = false;
                angular.element.unblockUI();
                frm.$setPristine();
            });
        }

        function closeTicket(ev, frm) {
            var message = translate('PAYROLL.MESSAGE.CONFIRMCLOSETICKET');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .ariaLabel('dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                // $mdDialog.show(confirm).then(function () {
                angular.element('#attView').block({
                    message: ' <span>Loading...</span>'
                });
                angular.element.blockUI();
                vm.objForm = new Tiket();
                vm.objForm.action = 'closeTicket';
                //set value
                vm.objForm.ticket_id = data.id;
                vm.objForm.is_closed = '4';
                var response = vm.objForm.$save();

                response.then(function (data) {
                    angular.element.unblockUI();
                    showDialogInfo(ev, data);
                });
                response.catch(function (data) {
                    angular.element.unblockUI();
                    showDialogInfo(ev, data);
                });

                // }, function () {
                //     angular.element('#attView').unblock();

                // });
            });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function viewFile(ev, img) {
            $mdDialog.show({
                controller: 'viewDocHcTicket',
                controllerAs: 'vm',
                templateUrl: 'app/main/hcticket/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    img: img
                }
            });
        }

        function checkIsNeddFile() {
            if (vm.isNeddUploadFile == false || typeof vm.isNeddUploadFile === 'undefined') {
                vm.isChecked = true
            } else {
                vm.isChecked = false
            }
        }

        function upload(form) {
            var vidFileLength = $("#uploadData")[0].files.length;
            if (vidFileLength === 0) {
                vm.showMessage = true;
                vm.alertMessage = translate('MENU.MAIN.PLEASECHOOSEAFILE');
            } else {
                vm.showMessage = false;
                angular.element.blockUI();
                var resp = vm.FileUploader.uploadAll();
            }
        }

        vm.FileUploader = new FileUploader({
            url: config.api + 'api/emphcticket/uploadReply',
            removeAfterUpload: true,
            alias: 'fileName',
            onSuccessItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                vm.answer = '';
                vm.isChecked = false;
                loadTiketDetail();//sendEmail
                if (vm.needSendMail) {
                    // vm.Form.objForm.title = data.title;
                    // vm.Form.objForm.mailTo = vm.mailTo;
                    // Form.saveData('sendMail', frm, Tiket);
                    // setTimeout(function () {
                    var promise = Auth.setToken();
                    promise.then(function () {
                        vm.objForm = new Tiket();
                        vm.objForm.action = 'sendMail';
                        //set value
                        vm.objForm.title = data.title;
                        vm.objForm.mailTo = vm.mailTo;
                        vm.objForm.$save();
                        var response = vm.objForm.$save();
                        response.then(function (data) {
                            Auth.setToken()
                        });
                        response.catch(function (data) {
                            Auth.setToken()
                        });
                    });
                    // }, 2000);
                }

            }, onErrorItem: function (item, response, status, headers) {
                angular.element.unblockUI();
            }
        });

        function delegateToSysdev(item, status) {
            angular.element.blockUI();
            var ev = "";
            var objForm = new Tiket();
            objForm.action = 'delegateToSysdev';
            objForm.id = item.id;
            objForm.status = status;
            var response = objForm.$save();
            response.then(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data);
            });
            response.catch(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data.data);
            });
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.hcticket')
    .controller('HcTiketController', HcTiketController);

  HcTiketController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    '$state',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function HcTiketController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    $state,
    Form,
    $element
  ) {
    var vm = this;
    var Tiket = AppAPI.HcTicket();
    var $translate = $filter('translate');
    Form.setObject(Tiket);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = [];
    vm.editData = editData;
    vm.updateStatus = updateStatus;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.downloadDoc = downloadDoc;
    vm.viewFile = viewFile;
    vm.closeTicket = closeTicket;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.company = $localStorage.empsite;
    vm.getArea = loadArea;
    vm.delegateToSysdev = delegateToSysdev;
    vm.status = '1';

    getPermission();
    setTimeout(function () { activate(); }, 1500);

    function activate() {
      vm.selected = [];
      loadData(1);
      loadTiketType()
      loadCompany()
      loadArea()
      loadStatus()

      vm.listDelegatedStatus = [
        {
          'id': 'all',
          'name': 'All'
        },
        {
          'id': '1',
          'name': 'PAYROLL.MESSAGE.YES'
        },
        {
          'id': '0',
          'name': 'PAYROLL.MESSAGE.NO'
        }
      ]
    }

    function getPermission() {
      var response = Tiket.query({ action: 'getPermission' });
      response.$promise.then(fetchGetPermission);
      response.$promise.catch(errorFetchGetPermission);
    }

    function fetchGetPermission(data) {
      vm.delegated = '0';
      if (data[0].isAdmin == false) {
        $state.go('app.hcticket-user');
      } else {
        if (data[0].isDev == '1') {
          vm.delegated = '1';
        }
      }
    }

    function errorFetchGetPermission() {

    }

    function loadCompany() {
      var response = Tiket.query({ action: 'getCompany' });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listCompany = data;
    }

    function errorFetchCompany() {
      vm.listCompany = [];
    }

    function loadArea() {
      var response = Tiket.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listArea = data;
    }

    function errorFetchArea() {
      vm.listArea = [];
    }

    function loadTiketType() {
      var response = Tiket.query({ action: 'getTicketType' });
      response.$promise.then(fetchTicketType);
      response.$promise.catch(errorFetchTicketType);
    }

    function fetchTicketType(data) {
      vm.ticketList = data;
    }

    function errorFetchTicketType() {
      vm.ticketList = [];
    }

    function loadStatus() {
      var response = Tiket.query({ action: 'getStatus' });
      response.$promise.then(fetchStatus);
      response.$promise.catch(errorFetchStatus);
    }

    function fetchStatus(data) {
      vm.listStatus = data;
    }

    function errorFetchStatus() {
      vm.listStatus = [];
    }

    function loadData(pageno) {
      vm.currentPage = pageno;
      var resp = vm.DataTables.loadData(Tiket, pageno, {
        action: 'viewData',
        type: vm.type,
        status: vm.status,
        company: vm.company,
        area: vm.area,
        isDev: vm.delegated,
        nik: vm.empno
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
        vm.isAdmin = data.isAdmin;
        vm.isDev = data.isDev;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'HcTiketInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcticket/hctiket-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(vm.currentPage);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewHcTiketDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcticket/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(vm.currentPage);
        },
        locals: {
          data: data
        }
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'HcTiketEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcticket/hctiket-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(vm.currentPage);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function updateStatus(ev, data) {
      $mdDialog.show({
        controller: 'HcTiketUpdateStatusController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcticket/hctiket-update-status.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(vm.currentPage);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = Tiket.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(vm.currentPage);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function downloadDoc(ev, filename) {
      var name = filename;
      if (name !== null && name !== '') {
        $http({
          method: 'GET',
          url: config.api + 'api/upload/' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        }).success(function (data, status, headers) {
          headers = headers();
          var filename = name;
          var contentType = headers['content-type'];

          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], { type: contentType });
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
          } catch (ex) {
            console.log(ex);
          }
        }).error(function (data) {
          console.log(data);
        });
      } else {
        var message = $translate('HCTICKET.MESSAGE.FILENOTFOUND');
        var status = $translate('PAYROLL.MESSAGE.FAILED');

        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
        ).then(function () {
          // closeModal();
        });
      }
    }

    function viewFile(ev, img) {
      $mdDialog.show({
        controller: 'viewDocHcTicket',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcticket/view-doc.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        multiple: true,
        onRemoving: function (element, removePromise) {
          loadData(vm.currentPage);
        },
        locals: {
          img: img
        }
      });
    }

    function closeTicket(ev, data) {
      var message = $translate('PAYROLL.MESSAGE.CONFIRMCLOSETICKET');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(message)
          .ariaLabel('dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        // $mdDialog.show(confirm).then(function () {
        angular.element('#attView').block({
          message: ' <span>Loading...</span>'
        });
        angular.element.blockUI();
        vm.objForm = new Tiket();
        vm.objForm.action = 'closeTicket';
        //set value
        vm.objForm.ticket_id = data.id;
        vm.objForm.is_closed = '4';
        var response = vm.objForm.$save();

        response.then(function (data) {
          angular.element.unblockUI();
          showDialogInfo(ev, data);
        });
        response.catch(function (data) {
          angular.element.unblockUI();
          showDialogInfo(ev, data);
        });

        // }, function () {
        //   angular.element('#attView').unblock();

        // });
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/emphcticket?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function delegateToSysdev(item, status) {
      var conf = $translate('PAYROLL.MESSAGE.CONFDELEGATETOSYSDEV');
      var note = $translate('PAYROLL.MESSAGE.DELEGATESYSNOTE');
      if (status == '0') {
        var conf = $translate('PAYROLL.MESSAGE.CONFCALCELDELEGATETOSYSDEV');
        var note = $translate('PAYROLL.MESSAGE.DELTOSYSNOTE');
      }
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');
      var ev = '';
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('dialog')
          .ok(yes)
          .cancel(no);
        $mdDialog.show({
          multiple: true
        });
        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();

          var objForm = new Tiket();
          objForm.action = 'delegateToSysdev';
          objForm.id = item.id;
          objForm.status = status;
          var response = objForm.$save();
          response.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
          response.catch(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data.data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.hcticket')
    .controller('HcTiketUserController', HcTiketUserController);

  HcTiketUserController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function HcTiketUserController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var Tiket = AppAPI.HcTicket();
    var $translate = $filter('translate');
    Form.setObject(Tiket);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = [];
    vm.editData = editData;
    vm.updateStatus = updateStatus;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.downloadDoc = downloadDoc;
    vm.viewFile = viewFile;
    vm.closeTicket = closeTicket;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.company = $localStorage.empsite;
    vm.getArea = loadArea;
    vm.delegateToSysdev = delegateToSysdev;
    vm.isChangeStatus = '0';
    vm.setChangeStatus = setChangeStatus;
    vm.status = 'all';
    vm.delegated = 'all';

    activate();
    getPermission();
    var cv = 1;
    function setChangeStatus() {
      vm.isChangeStatus = '1';
    }

    function getPermission() {
      var response = Tiket.query({ action: 'getPermission' });
      response.$promise.then(fetchGetPermission);
      response.$promise.catch(errorFetchGetPermission);
    }

    function fetchGetPermission(data) {
      if (data[0].isAdmin == true) {
        $state.go('app.hcticket');
      }
    }

    function errorFetchGetPermission() {

    }

    function activate() {
      vm.selected = [];
      loadData(1);
      loadTiketType()
      loadCompany()
      loadArea()
      loadStatus()
    }

    function loadCompany() {
      var response = Tiket.query({ action: 'getCompany' });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listCompany = data;
    }

    function errorFetchCompany() {
      vm.listCompany = [];
    }

    function loadArea() {
      var response = Tiket.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listArea = data;
    }

    function errorFetchArea() {
      vm.listArea = [];
    }

    function loadTiketType() {
      var response = Tiket.query({ action: 'getTicketType' });
      response.$promise.then(fetchTicketType);
      response.$promise.catch(errorFetchTicketType);
    }

    function fetchTicketType(data) {
      vm.ticketList = data;
    }

    function errorFetchTicketType() {
      vm.ticketList = [];
    }

    function loadStatus() {
      var response = Tiket.query({ action: 'getStatus' });
      response.$promise.then(fetchStatus);
      response.$promise.catch(errorFetchStatus);
    }

    function fetchStatus(data) {
      vm.listStatus = data;
    }

    function errorFetchStatus() {
      vm.listStatus = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(Tiket, pageno, {
        action: 'viewData',
        type: vm.type,
        status: vm.status,
        company: vm.company,
        area: vm.area,
        isDev: vm.delegated,
        nik: vm.empno
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'HcTiketInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcticket/hctiket-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewHcTiketDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcticket/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'HcTiketEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcticket/hctiket-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function updateStatus(ev, data) {
      $mdDialog.show({
        controller: 'HcTiketUpdateStatusController',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcticket/hctiket-update-status.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = Tiket.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function downloadDoc(ev, filename) {
      var name = filename;
      if (name !== null && name !== '') {
        $http({
          method: 'GET',
          url: config.api + 'api/upload/' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        }).success(function (data, status, headers) {
          headers = headers();
          var filename = name;
          var contentType = headers['content-type'];

          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], { type: contentType });
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
          } catch (ex) {
            console.log(ex);
          }
        }).error(function (data) {
          console.log(data);
        });
      } else {
        var message = $translate('HCTICKET.MESSAGE.FILENOTFOUND');
        var status = $translate('PAYROLL.MESSAGE.FAILED');

        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
        ).then(function () {
          // closeModal();
        });
      }
    }

    function viewFile(ev, img) {
      $mdDialog.show({
        controller: 'viewDocHcTicket',
        controllerAs: 'vm',
        templateUrl: 'app/main/hcticket/view-doc.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        multiple: true,
        onRemoving: function (element, removePromise) {
          viewData();
        },
        locals: {
          img: img
        }
      });
    }

    function closeTicket(ev, data) {
      var message = $translate('PAYROLL.MESSAGE.CONFIRMCLOSETICKET');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(message)
          .ariaLabel('dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        // $mdDialog.show(confirm).then(function () {
        angular.element('#attView').block({
          message: ' <span>Loading...</span>'
        });
        angular.element.blockUI();
        vm.objForm = new Tiket();
        vm.objForm.action = 'closeTicket';
        //set value
        vm.objForm.ticket_id = data.id;
        vm.objForm.is_closed = '4';
        var response = vm.objForm.$save();

        response.then(function (data) {
          angular.element.unblockUI();
          showDialogInfo(ev, data);
        });
        response.catch(function (data) {
          angular.element.unblockUI();
          showDialogInfo(ev, data);
        });

        // }, function () {
        //   angular.element('#attView').unblock();

        // });
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/emphcticket?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function delegateToSysdev(item, status) {
      var conf = $translate('PAYROLL.MESSAGE.CONFDELEGATETOSYSDEV');
      var note = $translate('PAYROLL.MESSAGE.DELEGATESYSNOTE');
      if (status == '0') {
        var conf = $translate('PAYROLL.MESSAGE.CONFCALCELDELEGATETOSYSDEV');
        var note = $translate('PAYROLL.MESSAGE.DELTOSYSNOTE');
      }
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');
      var ev = '';
      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog.confirm()
          .title(conf)
          .textContent(note)
          .ariaLabel('dialog')
          .ok(yes)
          .cancel(no);
        $mdDialog.show({
          multiple: true
        });
        $mdDialog.show(confirm).then(function () {
          angular.element.blockUI();

          var objForm = new Tiket();
          objForm.action = 'delegateToSysdev';
          objForm.id = item.id;
          objForm.status = status;
          var response = objForm.$save();
          response.then(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data);
          });
          response.catch(function (data) {
            angular.element.unblockUI();
            showDialogInfo(ev, data.data);
          });
        }, function () {
          // $scope.status = 'You decided to keep your debt.';
        });
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.hcticket')
    .controller('HcTiketUpdateStatusController', HcTiketUpdateStatusController);

  HcTiketUpdateStatusController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'data',
    'config',
    '$filter',
    'FileUploader'
  ];
  /** @ngInject */
  function HcTiketUpdateStatusController(
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    data,
    config,
    $filter,
    FileUploader
  ) {
    var vm = this;
    var Tiket = AppAPI.HcTicket();
    var $translate = $filter('translate');

    vm.isDone = false;

    vm.Form = Form;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;

    function loadStatus() {
      var response = Tiket.query({ action: 'getStatus' });
      response.$promise.then(fetchStatus);
      response.$promise.catch(errorFetchStatus);
    }

    function fetchStatus(data) {
      vm.statusList = data;
    }

    function errorFetchStatus() {
      vm.statusList = [];
    }

    function loadErrorType() {
      var response = Tiket.query({ action: 'getErrorType' });
      response.$promise.then(fetchErrorType);
      response.$promise.catch(errorFetchErrorType);
    }

    function fetchErrorType(data) {
      vm.errorTypeList = data;
    }

    function errorFetchErrorType() {
      vm.errorTypeList = [];
    }

    vm.checkStatus = checkStatus;

    activate();

    function activate() {
      Form.initialForm();
      Form.setObject(Tiket);

      vm.Form.objForm.id = data.id;
      vm.Form.objForm.title = data.title;
      vm.Form.objForm.status = data.statuss;
      vm.Form.objForm.type = data.type;
      vm.Form.objForm.created_at = data.created_at;
      vm.Form.objForm.requested_by = data.requested_by;

      loadStatus()
      loadErrorType()
    }

    function checkStatus(status) {
      if (status == '3') {
        vm.isDone = true;
      } else {
        vm.isDone = false;
      }
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('updateStatus', frm, Tiket);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.hcticket')
    .controller('HcTiketInputController', HcTiketInputController);

  HcTiketInputController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'filterFilter',
    '$filter',
    'FileUploader',
    'config'
  ];
  /** @ngInject */
  function HcTiketInputController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    filterFilter,
    $filter,
    FileUploader,
    config
  ) {
    var vm = this;
    var Tiket = AppAPI.HcTicket();
    var $translate = $filter('translate');

    vm.upload = upload;
    vm.checkIsNeddFile = checkIsNeddFile

    function checkIsNeddFile() {
      if (vm.isNeddUploadFile == false || typeof vm.isNeddUploadFile === 'undefined') {
        vm.isChecked = true
      } else {
        vm.isChecked = false
      }
    }

    loadTiketType();

    function loadTiketType() {
      var response = Tiket.query({ action: 'getTicketType' });
      response.$promise.then(fetchTicketType);
      response.$promise.catch(errorFetchTicketType);
    }

    function fetchTicketType(data) {
      vm.ticketList = data;
    }

    function errorFetchTicketType() {
      vm.ticketList = [];
    }

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(Tiket);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.priority = [
      { 'value': '1', 'name': 'Low', 'class': 'priority-low' },
      { 'value': '2', 'name': 'Middle', 'class': 'priority-middle' },
      { 'value': '3', 'name': 'High', 'class': 'priority-high' }
    ];

    vm.tinymceOptions = {
      height: 250,
      theme: 'modern',
      plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
      toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
      templates: [
        { title: 'template 1', content: 'Template 1' },
        { title: 'template 2', content: 'Template 2' }
      ],
    };
    activate();

    function activate() {
      vm.selected = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, Tiket);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function upload(form) {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/emphcticket/upload',
      removeAfterUpload: true,
      alias: 'fileName',
      onSuccessItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }, onErrorItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.hcticket')
    .controller('HcTiketEditController', HcTiketEditController);

  HcTiketEditController.$inject = [
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'data',
    'config',
    '$filter',
    'FileUploader'
  ];
  /** @ngInject */
  function HcTiketEditController(
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    data,
    config,
    $filter,
    FileUploader
  ) {
    var vm = this;
    var Tiket = AppAPI.HcTicket();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.tinymceOptions = {
      height: 250,
      theme: 'modern',
      plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
      toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
      templates: [
        { title: 'template 1', content: 'Template 1' },
        { title: 'template 2', content: 'Template 2' }
      ],
    };
    vm.priority = [
      { 'value': 'Low', 'name': 'Low', 'class': 'priority-low' },
      { 'value': 'Middle', 'name': 'Middle', 'class': 'priority-middle' },
      { 'value': 'High', 'name': 'High', 'class': 'priority-high' }
    ];

    activate();

    vm.upload = upload;
    vm.checkIsNeddFile = checkIsNeddFile

    function checkIsNeddFile() {
      if (vm.isNeddUploadFile == false || typeof vm.isNeddUploadFile === 'undefined') {
        vm.isChecked = true
      } else {
        vm.isChecked = false
      }
    }

    function activate() {
      Form.initialForm();
      Form.setObject(Tiket);

      // vm.isChecked = data.filename ? true : false;

      vm.Form.objForm.title = data.title;
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.type = data.type;
      vm.Form.objForm.pic_phone = data.pic_phone;
      vm.Form.objForm.description = data.description;
      vm.Form.objForm.priority = data.priority;
      vm.Form.objForm.status = data.status;
    }

    loadTicketType();

    function loadTicketType() {
      var response = Tiket.query({ action: 'getTicketType' });
      response.$promise.then(fetchTicketType);
      response.$promise.catch(errorFetchTicketType);
    }

    function fetchTicketType(data) {
      vm.ticketList = data;
    }

    function errorFetchTicketType() {
      vm.ticketList = [];
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, Tiket);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function upload(form) {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/emphcticket/upload',
      removeAfterUpload: true,
      alias: 'fileName',
      onSuccessItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }, onErrorItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.hcdashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.hcdashboard', {
                url    : '/hc-dashboard',
                views  : {
                    'main@' : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                    'content@app.hcdashboard': {
                        templateUrl: 'app/main/hcdashboard/hcdashboardnew.html',
                        controller : 'HcdashboardController as vm'
                    }
                },
                  bodyClass: 'hcdashboard'
            });

           // Translation
       // $translatePartialLoaderProvider.addPart('app/main/login');

       
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.hcdashboard')
        .controller('HcdashboardController', HcdashboardController);

    HcdashboardController.$inject = ['AppAPI','DataService'];

    /* @ngInject */
    function HcdashboardController(AppAPI,DataService) {
        var vm = this;
        vm.title = 'Controller';

         var Division = AppAPI.Division();
      var Kpi = AppAPI.Kpi();
      vm.viewDataDivision=viewDataDivision;
      vm.projects=[
       {
           name:'Performance Management System',
           progress:100,
           steps:[
              {
                name:'Design System',
                 progressColor: "md-primary",
                value:100,
                items:[
                {
                    name:'Information Gathering',
                    checked:true
                },
                {
                    name:'Design Database',
                    checked:true
                },
                {
                    name:'Design Interface and Logical Process',
                    checked:true
                }
                ]
              },
              {
                name:'Development system',
                 progressColor: "md-accent",
                value:100,
                items:[
                    {
                    name:'Coding and module testing',
                    checked:true
                   },
                   {
                    name:'Application Testing',
                    checked:true
                   }
                ]
              },
              {
                name:'User Aceptance Testing',
                 progressColor: "md-warn",
                value:100,
                items:[
                   {
                    name:'End User Testing',
                    checked:true
                   },
                   {
                    name:'Fix Error Logical',
                    checked:true
                   },
                   {
                    name:'Testing Error Logical',
                    checked:true
                   }
                ]
              },
              {
                name:'Deployment',
                 progressColor: "md-primary md-hue-3",
                value:70,
                items:[
                 {name:'Deployment to End Users',checked:false}
                ]
              }
           ]
       },
       {
           name:'Attendances System',
           steps:[
              {
                name:'Design System',
                 progressColor: "md-primary",
                value:100,
                items:[
                {
                    name:'Information Gathering',
                    checked:true
                },
                {
                    name:'Design Database',
                    checked:true
                },
                {
                    name:'Design Interface and Logical Process',
                    checked:true
                }
                ]
              },
              {
                name:'Development system',
                 progressColor: "md-accent",
                value:100,
                items:[
                    {
                    name:'Coding and module testing',
                    checked:true
                   },
                   {
                    name:'Application Testing',
                    checked:true
                   }
                ]
              },
              {
                name:'User Aceptance Testing',
                 progressColor: "md-warn",
                value:80,
                items:[
                   {
                    name:'End User Testing',
                    checked:true
                   },
                   {
                    name:'Fix Error Logical',
                    checked:true
                   },
                   {
                    name:'Testing Error Logical',
                    checked:false
                   }
                ]
              },
              {
                name:'Deployment',
                 progressColor: "md-primary md-hue-3",
                value:10,
                items:[
                 {name:'Deployment to End Users',checked:false}
                ]
              }
           ]
       },
       {
           name:'E-Career',
           steps:[
              {
                name:'Design System',
                 progressColor: "md-primary",
                value:100,
                items:[
                {
                    name:'Information Gathering',
                    checked:true
                },
                {
                    name:'Design Database',
                    checked:true
                },
                {
                    name:'Design Interface and Logical Process',
                    checked:true
                }
                ]
              },
              {
                name:'Development system',
                 progressColor: "md-accent",
                value:60,
                items:[
                    {
                    name:'Coding and module testing',
                    checked:true
                   },
                   {
                    name:'Application Testing',
                    checked:false
                   }
                ]
              },
              {
                name:'User Aceptance Testing',
                 progressColor: "md-warn",
                value:0,
                items:[
                   {
                    name:'End User Testing',
                    checked:false
                   },
                   {
                    name:'Fix Error Logical',
                    checked:false
                   },
                   {
                    name:'Testing Error Logical',
                    checked:false
                   }
                ]
              },
              {
                name:'Deployment',
                 progressColor: "md-primary md-hue-3",
                value:0,
                items:[
                 {name:'Deployment to End Users',checked:false}
                ]
              }
           ]
       },
       {
           name:'E-Check In',
           steps:[
              {
                name:'Design System',
                 progressColor: "md-primary",
                value:100,
                items:[
                {
                    name:'Information Gathering',
                    checked:true
                },
                {
                    name:'Design Database',
                    checked:true
                },
                {
                    name:'Design Interface and Logical Process',
                    checked:true
                }
                ]
              },
              {
                name:'Development system',
                 progressColor: "md-accent",
                value:100,
                items:[
                    {
                    name:'Coding and module testing',
                    checked:true
                   },
                   {
                    name:'Application Testing',
                    checked:true
                   }
                ]
              },
              {
                name:'User Aceptance Testing',
                 progressColor: "md-warn",
                value:100,
                items:[
                   {
                    name:'End User Testing',
                    checked:true
                   },
                   {
                    name:'Fix Error Logical',
                    checked:true
                   },
                   {
                    name:'Testing Error Logical',
                    checked:true
                   }
                ]
              },
              {
                name:'Deployment',
                 progressColor: "md-primary md-hue-3",
                value:100,
                items:[
                 {name:'Deployment to End Users',checked:true}
                ]
              }
           ]
       }
      ];
      
      
      // var responseDivision=Kpi.query({action:'viewDivision'});
      // responseDivision.$promise.then(fetchDivision);
      // responseDivision.$promise.catch(errorFetchDivision);

     //  loadDataPa();
      function loadDataPa() {
        angular.element('#allChart').block();
         var response=Kpi.get({action:'viewAllChart',id:'all',type:'group'});
         response.$promise.then(fetchDataAllChart);
         response.$promise.catch(errorFetchDataAllChart);
      }

      function fetchDataAllChart(data) {
           vm.dataMutu= [data.mutu1];
           vm.dataAdj1=[data.adj1];
            vm.dataAdj2=[data.adj2];
            vm.dataAll=[data.mutu1,data.adj1,data.adj2];
        var ticks = data.tick;
        vm.optionsBadj={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2={
           title:'After Adjustment 2',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

        vm.optionsAadjAll={
           title:'After Adjustment 2',
           seriesColors:['#E91E63','#FF9800','#4CAF50'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                }
            }
        };

          angular.element('#allChart').unblock();
      }

       function errorFetchDataAllChart() {
        angular.element('#allChart').unblock();
      }

      function fetchDivision(data) {
        vm.listDivision=data;
      }

      function errorFetchDivision() {
        vm.listDivision=[];
      }

      function viewDataDivision(id,name) {
        angular.element('#chartPaByDIvision').block();
        vm.DivisionName=name;
        var response=Kpi.get({action:'viewAllChart',id:id,type:'group'});
         response.$promise.then(fetchDataDivisionChart);
         response.$promise.catch(errorFetchDataDivisionChart);
      }

      function fetchDataDivisionChart(data) {
         vm.dataMutuDiv= [data.mutu1];
           vm.dataAdj1Div=[data.adj1];
            vm.dataAdj2Div=[data.adj2];
        var ticks = data.tick;
        vm.optionsBadjDiv={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1Div={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2Div={
           title:'After Adjustment 2',
          seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };
          angular.element('#chartPaByDIvision').unblock();
        
      }

      function errorFetchDataDivisionChart(data) {
       angular.element('#chartPaByDIvision').unblock();
      }
         vm.mystyle={
         	'max-height':'400px',
         	'min-height':'400px',
         	'height':'400px'
         };
      var gw1=[
             ['2016-01-01',600],
             ['2016-02-01',589],
             ['2016-03-01',570],
             ['2016-04-01',560],
             ['2016-05-01',586],
             ['2016-06-01',602],
             ['2016-07-01',612],
             ['2016-08-01',580],
             ['2016-09-01',590],
             ['2016-10-01',570],
             ['2016-11-01',560],
             ['2016-12-01',590]
             ];
       var gw2=[
             ['2016-01-01',400],
             ['2016-02-01',410],
             ['2016-03-01',390],
             ['2016-04-01',410],
             ['2016-05-01',400],
             ['2016-06-01',400],
             ['2016-07-01',390],
             ['2016-08-01',385],
             ['2016-09-01',395],
             ['2016-10-01',395],
             ['2016-11-01',402],
             ['2016-12-01',402]
             ];   
         var gs=[
             ['2016-01-01',310],
             ['2016-02-01',310],
             ['2016-03-01',290],
             ['2016-04-01',310],
             ['2016-05-01',300],
             ['2016-06-01',300],
             ['2016-07-01',290],
             ['2016-08-01',285],
             ['2016-09-01',295],
             ['2016-10-01',295],
             ['2016-11-01',302],
             ['2016-12-01',302]
             ]; 
         var sh=[
             ['2016-01-01',110],
             ['2016-02-01',110],
             ['2016-03-01',90],
             ['2016-04-01',110],
             ['2016-05-01',100],
             ['2016-06-01',100],
             ['2016-07-01',90],
             ['2016-08-01',85],
             ['2016-09-01',95],
             ['2016-10-01',95],
             ['2016-11-01',90],
             ['2016-12-01',90]
             ];  
        var dh=[
             ['2016-01-01',40],
             ['2016-02-01',41],
             ['2016-03-01',44],
             ['2016-04-01',44],
             ['2016-05-01',40],
             ['2016-06-01',40],
             ['2016-07-01',40],
             ['2016-08-01',41],
             ['2016-09-01',42],
             ['2016-10-01',42],
             ['2016-11-01',42],
             ['2016-12-01',42]
             ]; 
          vm.dataHc=[gw1,gw2,gs,sh,dh];
           vm.HcOption={
          
      axes:{
        xaxis:{
          renderer:$.jqplot.DateAxisRenderer, 
          tickOptions:{formatString:'%b-%y'},
          tickInterval:'1 month'
        }
      },
      seriesDefaults: {
          rendererOptions: {
              smooth: true
          }},
      series:[
          {lineWidth:4, markerOptions:{style:'square'},label:'General Worker 1'},
           {lineWidth:4, markerOptions:{style:'diamond'},label:'General Worker 2'},
           {lineWidth:4, markerOptions:{style:'x'},label:'General Staff'},
             {lineWidth:4, markerOptions:{style:'circle'},label:'Section Head'},
             {lineWidth:4, markerOptions:{style:'filledSquare'},label:'Department Head'}
          ],
      highlighter: {
         sizeAdjust: 10,
         tooltipLocation: 'n',
         tooltipAxes: 'y',
         show:true,
         tooltipFormatString: ' %.2f',
         useAxesFormatters: false
     },
     cursor: {
         show: true
     },
     legend: {
                show: true,
                location: 'e',
                placement: 'outside'
            }
           };  







        
    }
})();
(function() {
    "use strict";
    /**
     *  Module
     *
     * Description
     */
    angular.module('app.employeereport', []).config(config);

    config.$inject=['$stateProvider'];

    function config($stateProvider) 
    {
   	    $stateProvider
            .state('app.employeereport', {
                url    : '/employee-report',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/employeereport/employeereport.html',
                    controller : 'EmployeereportController as vm'
                    }
                }
            });
   }
}());
(function() {
    'use strict';

    angular
        .module('app.employeereport')
        .controller('EmployeereportController', EmployeereportController);

    EmployeereportController.$inject = ['$localStorage','$state','$stateParams','$log','$mdDialog','config','AppAPI','Auth','DataService', '$document', '$location', '$window','$element','$translate'];

    /* @ngInject */
    function EmployeereportController($localStorage,$state,$stateParams,$log,$mdDialog,config,AppAPI,Auth,DataService, $document, $location, $window,$element, $translate) 
    {
        var vm = this;
        var endPoint = AppAPI.EmployeeReport();
        vm.DataTable= new DataService();
        vm.LoadCompany = LoadCompany;
        vm.LoadArea = LoadArea;
        vm.listJum=[2,5,25,50,75,100,200];
        vm.ExporttoExcel = ExporttoExcel;
        vm.company = $localStorage.empsite;

        LoadCompany()
        LoadArea(vm.company);

       function LoadCompany() {
          var response=endPoint.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

       function LoadArea(company) 
       {
          var response=endPoint.query({action:'getArea', companyid:company});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
       }

       function fetchArea(data) 
       {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }  
 
       
       function ExporttoExcel(form) {
            var token = Auth.setTokenPromise();
            var company = encodeURIComponent(window.btoa(vm.company));
            var area = encodeURIComponent(window.btoa(vm.area));
            var lang = encodeURIComponent(window.btoa($localStorage.lang));
            var dt= new Date(vm.effective_date);
            var dtM=(dt.getMonth()+1);
            var dtD=dt.getDate();
            if(dtM < 10){
                dtM='0'+dtM
            }
            if(dtD<10)
            {
                dtD='0'+dtD;
            }

            var newdate= encodeURIComponent(window.btoa(dt.getFullYear()+'-'+dtM+'-'+dtD));
            
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/employeereport/lgexportexcel/' + company  + '/' + area  + '/' + lang + '/' + newdate + '/' + data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employee-exchange', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.employee-exchange', {
                url: '/employee-exchange',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/employee-exchange/employee-exchange.html',
                        controller: 'EmployeeExchangeController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee-exchange')
        .controller('viewDocEmployeeExchange', viewDocEmployeeExchange);

    viewDocEmployeeExchange.$inject = ['$http', '$mdDialog', 'config', 'img'];

    /* @ngInject */
    function viewDocEmployeeExchange($http, $mdDialog, config, img) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.downloadDoc = downloadDoc;

        function closeModal() {
            $mdDialog.hide();
        }

        loadImage();

        function loadImage() {
            vm.doc = img;
            if (vm.doc.slice(-3) === 'pdf') {
                vm.doc_type = true;
            } else {
                vm.doc_type = false;
            }
            vm.url = config.api + 'api/upload/employee-exchange/' + vm.doc + '?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;';
        }

        function downloadDoc(ev) {
            var name = vm.doc;
            // console.log(link);
            if (name !== null && name !== '-') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/employee-exchange/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    // console.log(data);
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Document Not Found')
                        .textContent('Document not Found')
                        .ariaLabel('Failed Save Data')
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.employee-exchange')
        .controller('viewEmployeeExchangeDetailController', viewEmployeeExchangeDetailController);

    viewEmployeeExchangeDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewEmployeeExchangeDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var endPoint = AppAPI.EmployeeExchange();
        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.viewFile = viewFile
        vm.downloadDoc = downloadDoc
        vm.status = data.status
        vm.refData = data
        vm.dialogClose = dialogClose

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);

        loadDetail();

        function dialogClose() {
            $mdDialog.hide();
        }

        function loadDetail() {
            var response = endPoint.query({ action: 'viewDetail', detail_id: data.id });
            response.$promise.then(fetchDetail);
            response.$promise.catch(errorFetchDetail);
        }

        function downloadDoc(ev, filename) {
            var name = filename;
            if (name !== null && name !== '') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/employee-exchange' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                var message = translate('HCTICKET.MESSAGE.FILENOTFOUND');
                var status = translate('PAYROLL.MESSAGE.FAILED');

                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(message)
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }

        function fetchDetail(data) {
            vm.Form.objForm.ba_no = data[0].ba_no
            vm.Form.objForm.effective_date = data[0].effective_date
            vm.Form.objForm.description = data[0].description
            vm.Form.objForm.nikParam = data[0].nik1
            vm.Form.objForm.nikParam2 = data[0].nik2
            vm.areaName1 = data[0].areaName1
            vm.areaName2 = data[0].areaName2
            vm.jobTitle1 = data[0].jobTitle1
            vm.jobTitle2 = data[0].jobTitle2
            vm.costCenterCnb1 = data[0].costCenterCnb1
            vm.costCenterNonCnb1 = data[0].costCenterNonCnb1
            vm.subArea2 = data[0].subArea2
            vm.costCenterCnb2 = data[0].costCenterCnb2
            vm.costCenterNonCnb2 = data[0].costCenterNonCnb2
            vm.filename = data[0].filename
            vm.format = data[0].format
        }

        function errorFetchDetail() {
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function viewFile(ev, img) {
            $mdDialog.show({
                controller: 'viewDocEmployeeExchange',
                controllerAs: 'vm',
                templateUrl: 'app/main/employee-exchange/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    img: img
                }
            });
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.employee-exchange')
    .controller('EmployeeExchangeController', EmployeeExchangeController);

  EmployeeExchangeController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function EmployeeExchangeController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.EmployeeExchange();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;

    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.viewDetail = viewDetail;
    vm.downloadDoc = downloadDoc;
    vm.viewFile = viewFile;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        effective_date: vm.effective_date,
        ba_no: vm.ba_no
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'EmployeeExchangeInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee-exchange/employee-exchange-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewEmployeeExchangeDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee-exchange/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            angular.element.blockUI();

            vm.objForm = new endPoint();
            vm.objForm.action = 'delete';
            vm.objForm.data = vm.selected;
            var response = vm.objForm.$save();

            response.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = $translate(expmess[0]) + ', ' + expmess[1] + ' ' + $translate(expmess[2]) + ' ' + expmess[3] + ' ' + $translate(expmess[4]);
      } else {
        var message = $translate(data.pesan);
      }

      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    function downloadDoc(ev, filename) {
      var name = filename;
      if (name !== null && name !== '') {
        $http({
          method: 'GET',
          url: config.api + 'api/upload/employee-exchange/' + name,
          params: { name: name },
          responseType: 'arraybuffer'
        }).success(function (data, status, headers) {
          headers = headers();
          var filename = name;
          var contentType = headers['content-type'];

          var linkElement = document.createElement('a');
          try {
            var blob = new Blob([data], { type: contentType });
            var url = window.URL.createObjectURL(blob);

            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", filename);

            var clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
          } catch (ex) {
            console.log(ex);
          }
        }).error(function (data) {
          console.log(data);
        });
      } else {
        var message = $translate('HCTICKET.MESSAGE.FILENOTFOUND');
        var status = $translate('PAYROLL.MESSAGE.FAILED');

        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(message)
            .ok('OK')
            .targetEvent(ev)
        ).then(function () {
          // closeModal();
        });
      }
    }

    function viewFile(ev, img) {
      $mdDialog.show({
        controller: 'viewDocEmployeeExchange',
        controllerAs: 'vm',
        templateUrl: 'app/main/employee-exchange/view-doc.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        multiple: true,
        onRemoving: function (element, removePromise) {
          viewData();
        },
        locals: {
          img: img
        }
      });
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/employeeexchange?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.employee-exchange')
    .controller('EmployeeExchangeInputController', EmployeeExchangeInputController);

  EmployeeExchangeInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$filter',
    'FileUploader',
    '$http',
    '$localStorage',
    '$element',
    'config'
  ];
  /** @ngInject */
  function EmployeeExchangeInputController(
    $mdDialog,
    AppAPI,
    Form,
    $filter,
    FileUploader,
    $http,
    $localStorage,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.EmployeeExchange();
    var $translate = $filter('translate');

    vm.upload = upload;

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.fileSizeError = true;
    vm.selectedItemChanged = selectedItemChanged;
    vm.selectedItemChangedNik2 = selectedItemChangedNik2;
    vm.getEmployee = getEmployee;
    vm.getEmployeeNik2 = getEmployeeNik2;
    vm.showData = vm.showData2 = false;
    vm.company = $localStorage.empsite;
    vm.changeArea1 = vm.changeArea2 = vm.changeArea11 = 1;
    vm.setChangeArea1 = setChangeArea1
    vm.setChangeArea2 = setChangeArea2

    activate();

    function setChangeArea1() {
      vm.changeArea1 = 0;
    }

    function setChangeArea2() {
      vm.changeArea2 = 0;
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.nik1 = '';
      vm.Form.objForm.emp_cost_center_id_old1 = '';
      vm.Form.objForm.emp_cost_center_id_new2 = '';
      vm.Form.objForm.emp_sub_area_id_old1 = '';
      vm.Form.objForm.emp_sub_area_id_new2 = '';
      if (typeof employee !== 'undefined' && employee) {
        vm.showData = true;
        vm.changeArea11 = 0;
        vm.Form.objForm.nik1 = employee.empno;
        vm.nik1 = employee.empno;
        vm.Form.objForm.emp_cost_center_id_old1 = employee.empCostCenterId;
        vm.Form.objForm.emp_cost_center_id_new2 = employee.empCostCenterId
        vm.Form.objForm.emp_sub_area_id_old1 = employee.empSubAreaId
        vm.Form.objForm.emp_sub_area_id_new2 = employee.empSubAreaId
        vm.Form.objForm.sub_area_id_new2 = employee.subAreaId
        vm.areaName1 = employee.areaName
        vm.jobTitle1 = employee.job_title
        vm.costCenterCnb1 = employee.cnb
        vm.costCenterNonCnb1 = employee.noncnb
        vm.refIdCnb1 = employee.ref_id_cnb
        vm.refIdNonCnb1 = employee.ref_id_noncnb
      }
    }

    function selectedItemChangedNik2(employee) {
      vm.Form.objForm.nik2 = '';
      vm.Form.objForm.emp_cost_center_id_old2 = '';
      vm.Form.objForm.emp_cost_center_id_new1 = '';
      vm.Form.objForm.emp_sub_area_id_old2 = '';
      vm.Form.objForm.emp_sub_area_id_new1 = '';
      if (typeof employee !== 'undefined' && employee) {
        vm.showData2 = true;
        vm.Form.objForm.nik2 = employee.empno;
        vm.Form.objForm.emp_cost_center_id_old2 = employee.empCostCenterId;
        vm.Form.objForm.emp_cost_center_id_new1 = employee.empCostCenterId
        vm.Form.objForm.emp_sub_area_id_old2 = employee.empSubAreaId
        vm.Form.objForm.emp_sub_area_id_new1 = employee.empSubAreaId
        vm.Form.objForm.sub_area_id_new1 = employee.subAreaId
        vm.areaName2 = employee.areaName
        vm.jobTitle2 = employee.job_title
        vm.costCenterCnb2 = employee.cnb
        vm.costCenterNonCnb2 = employee.noncnb
        vm.refIdCnb2 = employee.ref_id_cnb
        vm.refIdNonCnb2 = employee.ref_id_noncnb
      }
    }

    function loadSubArea(param) {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      if (param == 1) {
        response.$promise.then(fetchSubArea);
        response.$promise.catch(errorFetchSubArea);
      } else {
        response.$promise.then(fetchSubArea2);
        response.$promise.catch(errorFetchSubArea2);
      }
    }

    function fetchSubArea(data) {
      vm.listSubArea = data;
    }

    function errorFetchSubArea() {
      vm.listSubArea = [];
    }

    function fetchSubArea2(data) {
      vm.listSubArea2 = data;
    }

    function errorFetchSubArea2() {
      vm.listSubArea2 = [];
    }


    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/employeeexchange?action=searchEmployee&id=' + searchText + '&company=' + vm.company + '&area=' + vm.subArea1)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function getEmployeeNik2(searchText) {
      return $http
        .get(config.api + 'api/employeeexchange?action=searchEmployee&id=' + searchText + '&company=' + vm.company + '&nik=' + vm.Form.objForm.nik1 + '&area=' + vm.subArea2)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function activate() {
      vm.selected = [];
      loadSubArea(1);
      loadSubArea(2);
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function upload(form) {
      var resp = vm.FileUploaderPhoto.uploadAll();
    }

    var uploaderPhoto = vm.FileUploaderPhoto = new FileUploader({
      url: config.api + 'api/employeeexchange/upload',
      removeAfterUpload: true,
      alias: 'fileName',
      onBeforeUploadItem: function (item) {

        var dt = new Date(item.formData[0].effective_date);

        var newdate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
        item.formData[0].effective_date = newdate;
        angular.element.blockUI();
      },
      onSuccessItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }, onErrorItem: function (item, response, status, headers) {
        angular.element.unblockUI();
        var ev = '';
        showDialogInfo(ev, response);
      }
    });

    uploaderPhoto.filters.push({
      name: 'enforceMaxFileSize',
      fn: function (item) {
        vm.itemSize = formatBytes(item.size);
        if (item.size > 0) {
          vm.fileSizeError = false;
          return true;
        } else {
          vm.fileSizeError = true;
          return false;
        }
      }
    });

    function formatBytes(bytes) {
      if (bytes < 1024) return bytes + ' Bytes';
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
      else return (bytes / 1073741824).toFixed(3) + ' GB';
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.emp_surveys', ['app.emp_surveys.emp-surveys-detail'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.emp_surveys', {
                url    : '/emp-surveys',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/emp-surveys/emp-surveys.html',
                        controller : 'EmpSurveysController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.emp_surveys')
        .controller('EmpSurveysController', EmpSurveysController);


    EmpSurveysController.$inject=['DataService','$state','config','$localStorage','Auth','AppAPI','DTColumnDefBuilder','$mdDialog', '$location', '$window'];
    /** @ngInject */
    function EmpSurveysController(DataService,$state,config,$localStorage,Auth,AppAPI,DTColumnDefBuilder,$mdDialog, $location, $window)
    {
        
        var vm                = this;
        var EmpSurveys        = AppAPI.EmpSurveys();
        vm.listJum            = [2,5,25,50,75,100,200];
        vm.username           = $localStorage.nama;
        vm.user               = $localStorage.user;
        vm.setView            = setView;
        vm.loadData           = loadData;
        vm.icon               = "icon-plus";
        vm.result             = false;
        vm.visibleSubChild    = [];
        vm.DataTable          = new DataService();
        vm.loadDataDivision   = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.showSummary        = showSummary;
        vm.exportToExcel      = exportToExcel;

        loadData(1);
        loadDataBU();


        function loadData(pageno) {          

            vm.DataTable.loadData(EmpSurveys,pageno,{action:'viewData',bu:vm.bu,divisi:vm.divisi,department:vm.department});
             angular.element.unblockUI(); 

        }

        function loadDataBU() {
            var response=EmpSurveys.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBu=data;

            // if(vm.group === '110' || vm.group === '116') {
            //     vm.bu = vm.empsite;
            //     loadDataDivision(vm.bu);
            // }

        }

        function errorFetchBU() {
            vm.listBu=[];
            angular.element.unblockUI(); 
        }

        function loadDataDivision(idbu) {

            vm.divisi='';
            vm.department='';
            var response=EmpSurveys.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
           vm.listDivisi=data;
           vm.listDepartment=[];
           loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivisi=[];
            angular.element.unblockUI(); 
        }

        function loadDataDepartment(iddivisi) {
            vm.department='';
            var response=EmpSurveys.query({action:'viewDivisiDept',idbu:vm.bu,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment=data;
            loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment=[];
            angular.element.unblockUI(); 
        }

        function showSummary(ev)
        {

            $mdDialog.show({
                controller: 'EmpSurveysSummaryController',
                controllerAs:'vm',
                templateUrl: 'app/main/emp-surveys/emp-surveys-summary.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                // locals:{
                //     listInput:vm.listInput,
                //     input: input                   
                // },
                onRemoving:function(element, removePromise)
                {
                    loadData(1);
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function setView(nik) {
            $state.go('app.emp_surveys_detail',{id:nik});
        }

        function exportToExcel() {
            var token = Auth.setTokenPromise();
            // console.log(typeof vm.bu);
            var bu = "-";
            var divisi = "-";
            var department = "-";
            if (vm.bu !== "") {
                bu = vm.bu;
            }
            if (vm.divisi !== "") {
                divisi = vm.divisi;
            }
            if (vm.department !== "") {
                department = vm.department;
            }
            token.then(function(data) {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + '/' + config.api + 'api/empsurveys/exportexcel/' + bu + '/' + divisi + '/' + department + '/' + data.token, '_blank');
                console.log(config.api);
            }, function() {
                $window.alert('gagal load token')
            });
        }

        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.emp_surveys')
        .controller('EmpSurveysSummaryController', EmpSurveysSummaryController);


    EmpSurveysSummaryController.$inject=['DataService','$state','$localStorage','AppAPI','DTColumnDefBuilder','$mdDialog'];
    /** @ngInject */
    function EmpSurveysSummaryController(DataService,$state,$localStorage,AppAPI,DTColumnDefBuilder,$mdDialog)
    {
        
        var vm                = this;
        var EmpSurveys        = AppAPI.EmpSurveys();
        vm.cancel             = cancel;

        loadData();

        function loadData() {
            var response=EmpSurveys.query({action:'get_summary'});
            response.$promise.then(fetch);
            response.$promise.catch(errorFetch);
        }

        function fetch(data) {
            vm.listSummary = data;

            console.log('vm.listSummary', vm.listSummary);

        }

        function errorFetch() {
            vm.listBu=[];
            angular.element.unblockUI(); 
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.emp_survey', [])
        .config(config);

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        // State 
        $stateProvider
            .state('app.emp_survey', {
                url: '/emp-survey',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/emp-survey/emp-survey.html',
                        controller: 'SetEmpSurveyController as vm'
                    }
                }
            })
            .state('app.emp_survey_from_login', {
                url: '/emp-surveys',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/emp-survey/emp-survey.html',
                        controller: 'SetEmpSurveyFromLoginController as vm'
                    }
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.emp_survey')
        .controller('SetEmpSurveyController', SetEmpSurveyController)
        .directive('mdButtonsToggleSurvey', SetEmpSurveyDirective);


    SetEmpSurveyController.$inject = ['DataService', '$state', '$mdDialog', '$mdToast', '$localStorage', '$window', 'AppAPI', 'Auth', 'Form', 'DTColumnDefBuilder', '$timeout', '$stateParams'];
    /** @ngInject */
    function SetEmpSurveyController(DataService, $state, $mdDialog, $mdToast, $localStorage, $window, AppAPI, Auth, Form, DTColumnDefBuilder, $timeout, $stateParams) {

        var vm = this;
        var EmpSurvey = AppAPI.EmpSurvey();
        vm.username = $localStorage.user;
        vm.nik = vm.username;
        vm.profile = {};
        vm.score = {};
        vm.inputData = inputData;
        vm.saveData = saveData;
        vm.sendForm = sendForm;
        vm.setSummaryClass = setSummaryClass;
        vm.isConfirmDisclaimer = false;
        vm.showDisclaimer = showDisclaimer;

        vm.islastStep = false;

        vm.ratingLists = [];
        vm.languageList = [
            { value: 'ID', label: 'Indonesia' },
            { value: 'EN', label: 'English' }
        ];
        vm.isDisabled = true;
        vm.selected = 'ID';
        vm.language = 'ID';
        vm.changeLanguage = changeLanguage;

        vm.statementAgreementValues = [
            { value: 'SA', label: 'Strongly Agree' },
            { value: 'A', label: 'Agree' },
            { value: 'D', label: 'Disagree' },
            { value: 'SD', label: 'Strongly Disagree' }
        ];

        vm.statementImportanceValues = [
            { value: 'VI', label: 'Very Important' },
            { value: 'I', label: 'Important' },
            { value: 'NI', label: 'Not Important' },
            { value: 'VNI', label: 'Very Not Important' }
        ];

        Form.initialForm();

        Form.setObject(EmpSurvey);
        vm.Form = Form;

        vm.setToken = Auth.setToken;

        loadData();

        function changeLanguage(lang) {
            vm.language = lang;
        }

        function loadData() {
            angular.element.blockUI();
            var promises = EmpSurvey.query({ action: 'get_profile' });
            promises.$promise.then(fetchData);
            promises.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            if (typeof (data[0]) !== 'undefined') {
                vm.profile = data;

                loadSurveyData();

            }
        }

        function errorFetch() {
            vm.profile = {};
            angular.element.unblockUI();
        }

        function loadStatementsData() {

            angular.element('.ms-form-wizard').block();

            var dataPromise = EmpSurvey.query({ action: 'get_statements', nik: vm.nik });
            dataPromise.$promise.then(fetchStatementsData);
            dataPromise.$promise.catch(errorStatementsFetch);

        }

        function fetchStatementsData(data) {

            vm.listInput = data;

            vm.totalResult = 0;
            angular.forEach(vm.listInput, function (obj) {
                vm.totalResult += obj.result;
            });
            // angular.element.unblockUI();
            angular.element('.ms-form-wizard').unblock();


        }

        function errorStatementsFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadSurveyData() {
            angular.element.blockUI();
            var promises = EmpSurvey.query({ action: 'get_employee_surveys', nik: vm.nik });
            promises.$promise.then(fetchSurveyData);
            promises.$promise.catch(errorSurveyFetch);
        }

        function fetchSurveyData(data) {

            vm.surveys = data;

            if (data.length > 0) {
                vm.surveys = data;
            } else {

                vm.showDisclaimer();

            }

            angular.element.unblockUI();
        }

        function errorSurveyFetch() {
            vm.score = {};
            angular.element.unblockUI();
        }

        function setSummaryClass(summary_id) {
            var summary_color = '';
            switch (summary_id) {
                case 1:
                    summary_color = 'red-700-fg';
                    break;
                case 2:
                    summary_color = 'blue-700-fg';
                    break;
                case 3:
                    summary_color = 'green-700-fg';
                    break;
            }

            return summary_color;
        }

        function sendForm(e) {

            vm.Form.objForm.datas = [];
            for (var i = 0; i <= (vm.listInput.length - 1); i++) {
                vm.Form.objForm.datas.push({
                    agreement: vm.listInput[i].agreement,
                    agreement_remarks: vm.listInput[i].agreement_remarks,
                    importance: vm.listInput[i].importance,
                    importance_remarks: vm.listInput[i].importance_remarks,
                    periode: vm.listInput[i].periode,
                    periode_end: vm.listInput[i].periode_end,
                    survey_period_id: vm.listInput[i].survey_period_id,
                    survey_id: vm.listInput[i].id
                });
            }

            var form = angular.element(document.getElementById('wizardStep_' + (vm.listInput.length - 1)));
            $timeout(function () {
                form.triggerHandler("submit");
            });

        }

        function saveData(ev, formController) {

            var promise = Form.saveData('save', formController, EmpSurvey);

            promise.then(successSaveData);
            promise.catch(failedSaveData);

        }

        function successSaveData() {
            $localStorage.isSurvey = 1;
            vm.Form.tampilPesan = false;
            vm.messageTheme = 'green';

            $mdToast.show(
                $mdToast.simple()
                    .textContent(vm.Form.pesan)
                    .position('top right')
                    .hideDelay(3000)
                    .theme("success-toast")
            );

            var textContent = (vm.language === 'ID') ? 'Kontribusi Anda sangat dihargai.' : 'Your contributions are greatly appreciated.';
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#input')))
                    .clickOutsideToClose(true)
                    .title((vm.language === 'ID') ? 'Terima kasih' : 'Thank You')
                    .textContent(textContent)
                    .ariaLabel('Thank You for agree')
                    .ok((vm.language === 'ID') ? 'Tutup' : 'Close')
            );

            $timeout(function () {
                loadSurveyData();
                location.reload();
            }, 500);

            // $timeout(function() {
            //     vm.Form.tampilPesan = false;
            // }, 2000);

            vm.setToken();

        }

        function failedSaveData() {
            vm.messageTheme = 'red';

            vm.setToken();
        }

        function inputData(ev, input) {

            if (!input.nik) {
                input.nik = vm.nik;
            };

            $mdDialog.show({
                controller: 'inputEmpSurveyController',
                controllerAs: 'vm',
                templateUrl: 'app/main/pms/emp-survey/set-input-survey-member.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    listInput: vm.listInput,
                    input: input
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function showDisclaimer() {
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'vm',
                templateUrl: 'app/main/emp-survey/emp-survey-disclaimer.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    language: vm.language,
                    languageList: vm.languageList
                }
            })
                .then(function (isConfirm) {

                    if (isConfirm) {
                        vm.isConfirmDisclaimer = true;
                        vm.showinfoStatusDisclaimer = true;

                        // var textContent = (vm.language === 'ID')?'Kontribusi Anda sangat dihargai. Pastikan Anda mengisi survei ini dengan benar':'Your contributions are greatly appreciated. Please ensure that you fill out this survey correctly';

                        // $mdDialog.show(
                        //   $mdDialog.alert()
                        //     .parent(angular.element(document.querySelector('#input')))
                        //     .clickOutsideToClose(true)
                        //     .title((vm.language === 'ID')?'Terima kasih':'Thank You')
                        //     .textContent(textContent)
                        //     .ariaLabel('Thank You for agree')
                        //     .ok((vm.language === 'ID')?'Tutup':'Close')
                        // );

                        $timeout(function () {
                            loadStatementsData();
                        }, 500);

                    } else {
                        vm.showinfoStatusDisclaimer = true;
                    }
                }, function () {
                    vm.isConfirmDisclaimer = false;
                    vm.showinfoStatusDisclaimer = true;
                });
        }

        function DialogController($scope, language, languageList, $mdDialog) {

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.language = language;
            vm.language = $scope.language;

            $scope.languageList = languageList;

            $scope.confirmDisclaimer = function (confirm) {
                vm.language = $scope.language;
                $mdDialog.hide(confirm);
            };
        }

    };

    function SetEmpSurveyDirective() {

        return {
            template: '<div layout="row" layout-align="center center">' +
                '<md-button ng-repeat="option in items" class="md-group md-raised" ng-class="{\'{{selectedClass}}\': option.value == ngModel,left: $index == 0, right: $last}" ng-click="change(option.value)" ng-bind="option.label" ng-disabled="ngDisabled"></md-button></div>',
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                ngModel: '=',
                items: '=',
                ngDisabled: '=',
                selectedClass: '@?'
            },
            link: function (scope, elem, attrs) {
                if (angular.isUndefined(scope.selectedClass)) {
                    scope.selectedClass = 'md-primary';
                }

                angular.forEach(scope.items, function (value, key) {
                    if (!angular.isObject(value)) {
                        scope.items[key] = { value: value, label: value };
                    }
                });

                scope.change = function (key) {
                    scope.ngModel = key;
                };
            }
        };

    }

})();
(function () {
    'use strict';

    angular
        .module('app.emp_survey')
        .controller('SetEmpSurveyFromLoginController', SetEmpSurveyFromLoginController)
        .directive('mdButtonsToggleSurvey', SetEmpSurveyDirective);


    SetEmpSurveyFromLoginController.$inject = ['DataService', '$state', '$mdDialog', '$mdToast', '$localStorage', '$window', 'AppAPI', 'Auth', 'Form', 'DTColumnDefBuilder', '$timeout', '$stateParams'];
    /** @ngInject */
    function SetEmpSurveyFromLoginController(DataService, $state, $mdDialog, $mdToast, $localStorage, $window, AppAPI, Auth, Form, DTColumnDefBuilder, $timeout, $stateParams) {

        var vm = this;
        var EmpSurvey = AppAPI.EmpSurvey();
        vm.username = $localStorage.user;
        vm.nik = vm.username;
        vm.profile = {};
        vm.score = {};
        vm.inputData = inputData;
        vm.saveData = saveData;
        vm.sendForm = sendForm;
        vm.setSummaryClass = setSummaryClass;
        vm.isConfirmDisclaimer = false;
        vm.showDisclaimer = showDisclaimer;

        vm.islastStep = false;

        vm.ratingLists = [];
        vm.languageList = [
            { value: 'ID', label: 'Indonesia' },
            { value: 'EN', label: 'English' }
        ];
        vm.isDisabled = true;
        vm.selected = 'ID';
        vm.language = 'ID';
        vm.changeLanguage = changeLanguage;

        // vm.statementAgreementValues = [
        //     { value: 'SA', label: 'Strongly Agree' },
        //     { value: 'A', label: 'Agree' },
        //     { value: 'D', label: 'Disagree' },
        //     { value: 'SD', label: 'Strongly Disagree' }
        // ];
        console.log(vm.language);

          vm.statementAgreementValues = [
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' }
        ];

        vm.statementImportanceValues = [
            { value: 'VI', label: 'Very Important' },
            { value: 'I', label: 'Important' },
            { value: 'NI', label: 'Not Important' },
            { value: 'VNI', label: 'Very Not Important' }
        ];

        Form.initialForm();

        Form.setObject(EmpSurvey);
        vm.Form = Form;

        vm.setToken = Auth.setToken;

        loadData()

        function changeLanguage(lang) {
            vm.language = lang;
        }

        function loadData() {
            angular.element.blockUI();
            var promises = EmpSurvey.query({ action: 'get_profile' });
            promises.$promise.then(fetchData);
            promises.$promise.catch(errorFetch);
        }

        function fetchData(data) {
            if (typeof (data[0]) !== 'undefined') {
                vm.profile = data;

                loadSurveyData();

            }
        }

        function errorFetch() {
            vm.profile = {};
            angular.element.unblockUI();
        }

        function loadStatementsData() {

            angular.element('.ms-form-wizard').block();

            var dataPromise = EmpSurvey.query({ action: 'get_statements', nik: vm.nik });
            dataPromise.$promise.then(fetchStatementsData);
            dataPromise.$promise.catch(errorStatementsFetch);

        }

        function fetchStatementsData(data) {

            vm.listInput = data;

            vm.totalResult = 0;
            angular.forEach(vm.listInput, function (obj) {
                vm.totalResult += obj.result;
            });
            // angular.element.unblockUI();
            angular.element('.ms-form-wizard').unblock();


        }

        function errorStatementsFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function loadSurveyData() {
            angular.element.blockUI();
            var promises = EmpSurvey.query({ action: 'get_employee_surveys', nik: vm.nik });
            promises.$promise.then(fetchSurveyData);
            promises.$promise.catch(errorSurveyFetch);
        }

        function fetchSurveyData(data) {

            vm.surveys = data;

            if (data.length > 0) {
                vm.surveys = data;
            } else {

                vm.showDisclaimer();

            }

            angular.element.unblockUI();
        }

        function errorSurveyFetch() {
            vm.score = {};
            angular.element.unblockUI();
        }

        function setSummaryClass(summary_id) {
            var summary_color = '';
            switch (summary_id) {
                case 1:
                    summary_color = 'red-700-fg';
                    break;
                case 2:
                    summary_color = 'blue-700-fg';
                    break;
                case 3:
                    summary_color = 'green-700-fg';
                    break;
            }

            return summary_color;
        }

        function sendForm(e) {

            vm.Form.objForm.datas = [];
            for (var i = 0; i <= (vm.listInput.length - 1); i++) {
                vm.Form.objForm.datas.push({
                    agreement: vm.listInput[i].agreement,
                    agreement_remarks: vm.listInput[i].agreement_remarks,
                    importance: vm.listInput[i].importance,
                    importance_remarks: vm.listInput[i].importance_remarks,
                    periode: vm.listInput[i].periode,
                    periode_end: vm.listInput[i].periode_end,
                    survey_period_id: vm.listInput[i].survey_period_id,
                    survey_id: vm.listInput[i].id
                });
            }

            var form = angular.element(document.getElementById('wizardStep_' + (vm.listInput.length - 1)));
            $timeout(function () {
                form.triggerHandler("submit");
            });

        }

        function saveData(ev, formController) {

            var promise = Form.saveData('save', formController, EmpSurvey);

            promise.then(successSaveData);
            promise.catch(failedSaveData);

        }

        function successSaveData() {
            $localStorage.isSurvey = 1;
            vm.Form.tampilPesan = false;
            vm.messageTheme = 'green';

            $mdToast.show(
                $mdToast.simple()
                    .textContent(vm.Form.pesan)
                    .position('top right')
                    .hideDelay(3000)
                    .theme("success-toast")
            );

            var textContent = (vm.language === 'ID') ? 'Kontribusi Anda sangat dihargai.' : 'Your contributions are greatly appreciated.';
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#input')))
                    .clickOutsideToClose(true)
                    .title((vm.language === 'ID') ? 'Terima kasih' : 'Thank You')
                    .textContent(textContent)
                    .ariaLabel('Thank You for agree')
                    .ok((vm.language === 'ID') ? 'Tutup' : 'Close')
            );

            $timeout(function () {
                loadSurveyData();
                location.reload();
            }, 500);

            // $timeout(function() {
            //     vm.Form.tampilPesan = false;
            // }, 2000);

            vm.setToken();

        }

        function failedSaveData() {
            vm.messageTheme = 'red';

            vm.setToken();
        }

        function inputData(ev, input) {

            if (!input.nik) {
                input.nik = vm.nik;
            };

            $mdDialog.show({
                controller: 'inputEmpSurveyController',
                controllerAs: 'vm',
                templateUrl: 'app/main/pms/emp-survey/set-input-survey-member.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    listInput: vm.listInput,
                    input: input
                },
                onRemoving: function (element, removePromise) {
                    loadData();
                },
                fullscreen: true // Only for -xs, -sm breakpoints.
            });
        }

        function showDisclaimer() {
            vm.isConfirmDisclaimer = true;
            vm.showinfoStatusDisclaimer = true;
            $timeout(function () {
                loadStatementsData();
            }, 500);
        }

        function DialogController($scope, language, languageList, $mdDialog) {

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.language = language;
            vm.language = $scope.language;

            $scope.languageList = languageList;

            $scope.confirmDisclaimer = function (confirm) {
                vm.language = $scope.language;
                $mdDialog.hide(confirm);
            };
        }

    };

    function SetEmpSurveyDirective() {

        return {
            template: '<div layout="row" layout-align="center center">' +
                '<md-button ng-repeat="option in items" class="md-group md-raised" ng-class="{\'{{selectedClass}}\': option.value == ngModel,left: $index == 0, right: $last}" ng-click="change(option.value)" ng-bind="option.label" ng-disabled="ngDisabled"></md-button></div>',
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                ngModel: '=',
                items: '=',
                ngDisabled: '=',
                selectedClass: '@?'
            },
            link: function (scope, elem, attrs) {
                if (angular.isUndefined(scope.selectedClass)) {
                    scope.selectedClass = 'md-primary';
                }

                angular.forEach(scope.items, function (value, key) {
                    if (!angular.isObject(value)) {
                        scope.items[key] = { value: value, label: value };
                    }
                });

                scope.change = function (key) {
                    scope.ngModel = key;
                };
            }
        };

    }

})();
(function () {
    'use strict';

    angular
        .module('app.emp-sales-code')
        .controller('viewEmpSalesCodeDetailController', viewEmpSalesCodeDetailController);

    viewEmpSalesCodeDetailController.$inject = ['$mdDialog', 'data', '$localStorage', 'config', 'AppAPI', 'DataService', 'Auth', '$filter', 'Form', '$state', 'FileUploader', '$http'];

    /* @ngInject */
    function viewEmpSalesCodeDetailController($mdDialog, data, $localStorage, config, AppAPI, DataService, Auth, $filter, Form, $state, FileUploader, $http) {
        var vm = this;
        var translate = $filter('translate');

        var Tiket = AppAPI.HcTicket();
        vm.DataTable = new DataService();
        vm.closeModal = closeModal;
        vm.showAlert = false;
        vm.saveData = saveData;
        vm.closeTicket = closeTicket;
        vm.viewFile = viewFile
        vm.upload = upload
        vm.checkIsNeddFile = checkIsNeddFile
        vm.downloadDoc = downloadDoc
        vm.isSysdev = data.is_sysdev
        vm.status = data.status
        vm.refData = data
        vm.delegateToSysdev = delegateToSysdev

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(Tiket);

        vm.tinymceOptions = {
            height: 250,
            theme: 'modern',
            plugins: 'print preview fullpage searchreplace autolink code directionality visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
            toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
            templates: [
                { title: 'template 1', content: 'Template 1' },
                { title: 'template 2', content: 'Template 2' }
            ],
        };

        loadTiketDetail();

        function loadTiketDetail() {
            var response = Tiket.query({ action: 'viewDetail', detail_id: data.id });
            response.$promise.then(fetchTiketDetail);
            response.$promise.catch(errorFetchTiketDetail);
        }

        function downloadDoc(ev, filename) {
            var name = filename;
            if (name !== null && name !== '') {
                $http({
                    method: 'GET',
                    url: config.api + 'api/upload/' + name,
                    params: { name: name },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    headers = headers();
                    var filename = name;
                    var contentType = headers['content-type'];

                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], { type: contentType });
                        var url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                }).error(function (data) {
                    console.log(data);
                });
            } else {
                var message = translate('HCTICKET.MESSAGE.FILENOTFOUND');
                var status = translate('PAYROLL.MESSAGE.FAILED');

                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(message)
                        .ok('OK')
                        .targetEvent(ev)
                ).then(function () {
                    // closeModal();
                });
            }
        }

        function fetchTiketDetail(data) {
            vm.id = data[0].id
            vm.errorType = data[0].errorType
            vm.type = data[0].type
            vm.isAdmin = data[0].isAdmin
            vm.title = data[0].title
            vm.description = (data[0].description == null || data[0].description === "") ? '<p>-</p>' : data[0].description
            vm.solutions = (data[0].note == null || data[0].note === "") ? '<p>-</p>' : data[0].note
            vm.requestedBy = data[0].requested_by + '-' + data[0].name
            vm.ticketStatus = data[0].statuss
            vm.company = data[0].company
            vm.area = data[0].area
            vm.estimation = (data[0].estimation != '0.0' && data[0].estimation != '0.00') ? data[0].estimation + ' ' + translate('MENU.MAIN.CB.HOUR') : '';
            vm.workDuration = (data[0].workDuration != '0.0' && data[0].workDuration != '0.00') ? data[0].workDuration + ' ' + translate('MENU.MAIN.CB.HOUR') : '';
            vm.phone = data[0].pic_phone
            vm.priority = data[0].priority
            vm.isRequested = data[0].is_requested
            vm.ticketRespons = data[0].respons
            vm.needSendMail = data[0].needSendMail
            vm.mailTo = data[0].mailTo

            vm.isClosed = data[0].status == '4' ? true : false;
            vm.message = translate('PAYROLL.MESSAGE.CLOSETICKETNOTIF');

            var tmpdate = new Date(data[0].created_at);
            var dd = tmpdate.getDate();
            var mm = tmpdate.getMonth() + 1; //January is 0!

            var yyyy = tmpdate.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            var tmpdate = dd + '/' + mm + '/' + yyyy;
            vm.requestedAt = tmpdate
        }

        function errorFetchTiketDetail() {
            vm.targetDepartmentList = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, frm) {
            angular.element.blockUI();
            //set value
            vm.Form.objForm.ticket_id = data.id;
            vm.Form.objForm.title = data.title;
            vm.Form.objForm.answer = vm.answer;
            var response = Form.saveData('reply', frm, Tiket);
            response.then(function (dataRespons) {
                loadTiketDetail()
                angular.element.unblockUI();
                frm.$setPristine();
                vm.answer = '';

                //sendEmail
                if (vm.needSendMail) {
                    vm.Form.objForm.title = data.title;
                    vm.Form.objForm.mailTo = vm.mailTo;
                    Form.saveData('sendMail', frm, Tiket);
                    // setTimeout(function () {
                    //     var promise = Auth.setToken();
                    //     promise.then(function () {
                    //         vm.objForm = new Tiket();
                    //         vm.objForm.action = 'sendMail';
                    //         //set value
                    //         vm.objForm.ticket_id = data.id;
                    //         vm.objForm.ticket_id = data.id;
                    //         vm.objForm.mailTo = vm.mailTo;
                    //         vm.objForm.$save();
                    //         var response = vm.objForm.$save();
                    //         response.then(function (data) {
                    //             Auth.setToken()
                    //         });
                    //         response.catch(function (data) {
                    //             Auth.setToken()
                    //         });
                    //     });
                    // }, 2000);
                    vm.showMessage = false;
                }
            });

            response.catch(function (data) {
                vm.showMessage = false;
                angular.element.unblockUI();
                frm.$setPristine();
            });
        }

        function closeTicket(ev, frm) {
            var message = translate('PAYROLL.MESSAGE.CONFIRMCLOSETICKET');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');

            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .ariaLabel('dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                // $mdDialog.show(confirm).then(function () {
                angular.element('#attView').block({
                    message: ' <span>Loading...</span>'
                });
                angular.element.blockUI();
                vm.objForm = new Tiket();
                vm.objForm.action = 'closeTicket';
                //set value
                vm.objForm.ticket_id = data.id;
                vm.objForm.is_closed = '4';
                var response = vm.objForm.$save();

                response.then(function (data) {
                    angular.element.unblockUI();
                    showDialogInfo(ev, data);
                });
                response.catch(function (data) {
                    angular.element.unblockUI();
                    showDialogInfo(ev, data);
                });

                // }, function () {
                //     angular.element('#attView').unblock();

                // });
            });
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function showDialogInfo(ev, data) {
            if (data.status == 1) {
                data.status = 'PAYROLL.MESSAGE.SUCCESS';
            } else if (data.status == 0) {
                data.status = 'PAYROLL.MESSAGE.FAILED';
            }

            var expmess = data.pesan.split("_");

            if (expmess.length > 1) {
                var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
            } else {
                var message = translate(data.pesan);
            }

            var status = translate(data.status);
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title(status)
                        .textContent(message)
                        .ariaLabel(status)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function () {
                    dialogClose();
                });
        }

        function viewFile(ev, img) {
            $mdDialog.show({
                controller: 'viewDocHcTicket',
                controllerAs: 'vm',
                templateUrl: 'app/main/hcticket/view-doc.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                onRemoving: function (element, removePromise) {
                    viewData();
                },
                locals: {
                    img: img
                }
            });
        }

        function checkIsNeddFile() {
            if (vm.isNeddUploadFile == false || typeof vm.isNeddUploadFile === 'undefined') {
                vm.isChecked = true
            } else {
                vm.isChecked = false
            }
        }

        function upload(form) {
            var vidFileLength = $("#uploadData")[0].files.length;
            if (vidFileLength === 0) {
                vm.showMessage = true;
                vm.alertMessage = translate('MENU.MAIN.PLEASECHOOSEAFILE');
            } else {
                vm.showMessage = false;
                angular.element.blockUI();
                var resp = vm.FileUploader.uploadAll();
            }
        }

        vm.FileUploader = new FileUploader({
            url: config.api + 'api/emphcticket/uploadReply',
            removeAfterUpload: true,
            alias: 'fileName',
            onSuccessItem: function (item, response, status, headers) {
                angular.element.unblockUI();
                vm.answer = '';
                vm.isChecked = false;
                loadTiketDetail();//sendEmail
                if (vm.needSendMail) {
                    // vm.Form.objForm.title = data.title;
                    // vm.Form.objForm.mailTo = vm.mailTo;
                    // Form.saveData('sendMail', frm, Tiket);
                    // setTimeout(function () {
                    var promise = Auth.setToken();
                    promise.then(function () {
                        vm.objForm = new Tiket();
                        vm.objForm.action = 'sendMail';
                        //set value
                        vm.objForm.title = data.title;
                        vm.objForm.mailTo = vm.mailTo;
                        vm.objForm.$save();
                        var response = vm.objForm.$save();
                        response.then(function (data) {
                            Auth.setToken()
                        });
                        response.catch(function (data) {
                            Auth.setToken()
                        });
                    });
                    // }, 2000);
                }

            }, onErrorItem: function (item, response, status, headers) {
                angular.element.unblockUI();
            }
        });

        function delegateToSysdev(item, status) {
            angular.element.blockUI();
            var ev = "";
            var objForm = new Tiket();
            objForm.action = 'delegateToSysdev';
            objForm.id = item.id;
            objForm.status = status;
            var response = objForm.$save();
            response.then(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data);
            });
            response.catch(function (data) {
                angular.element.unblockUI();
                showDialogInfo(ev, data.data);
            });
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.emp-sales-code')
    .controller('EmpSalesCodeController', EmpSalesCodeController);

  EmpSalesCodeController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function EmpSalesCodeController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpSalesCode();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.viewDetail = viewDetail;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.getArea = loadArea;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      loadArea();
    }

    function loadArea() {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listArea = data;
    }

    function errorFetchArea() {
      vm.listArea = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        startDate: vm.start_date,
        endDate: vm.end_date,
        area: vm.area,
        nik: vm.empno
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'EmpSalesCodeInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-sales-code/emp-sales-code-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewEmpSalesCodetDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-sales-code/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'EmpSalesCodeEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-sales-code/emp-sales-code-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/emphcticket?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-sales-code')
    .controller('EmpSalesCodeInputController', EmpSalesCodeInputController);

  EmpSalesCodeInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$filter',
    '$http',
    'config'
  ];
  /** @ngInject */
  function EmpSalesCodeInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $filter,
    $http,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpSalesCode();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;

    activate();

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      vm.selected = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-sales-code')
    .controller('EmpSalesCodeEditController', EmpSalesCodeEditController);

  EmpSalesCodeEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$filter'
  ];
  /** @ngInject */
  function EmpSalesCodeEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpSalesCode();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;

    activate();

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.nik = data.nik + ' - ' + data.name;
      vm.Form.objForm.empno = data.nik;
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.start_date = new Date(data.start_date);
      vm.Form.objForm.end_date = new Date(data.end_date);
      vm.Form.objForm.sales_code = data.sales_code;
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empsalescode?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }
  }
})();
(function() {
    'use strict';

    angular
        .module('app.emp-category', [])
        .config(config)
        .filter('slice', function() {
            return function(arr, start, end) {
                return arr.slice(start, end);
            };
        });

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.emp_category', {
                url: '/emp-category',
                views: {
                    'content@app': {
                        templateUrl:
                            'app/main/emp-category/emp-category.html',
                        controller: 'EmpCategoryController as vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';
    angular
      .module('app.emp-category')
      .controller('UploadEmpCategoryController', UploadEmpCategoryController);
  
    UploadEmpCategoryController.$inject = ['$mdDialog','$localStorage','FileUploader','config','Auth','$location','$window','$filter','AppAPI','DataService','$document','$element'];
    /** @ngInject */
    function UploadEmpCategoryController($mdDialog,$localStorage,FileUploader,config,Auth,$location,$window,$filter,AppAPI,DataService,$document,$element) {
      var vm = this;
      var translate = $filter('translate');
      vm.closeModal = closeModal
      
      var endPoint = AppAPI.EmpCategory();
      
      vm.dialogClose = dialogClose;
      
      vm.uploadSuccess = vm.uploadError = vm.isMoreInfo =  false;
      vm.uploadNotif = '';
      vm.DownloadTemplate = DownloadTemplate;
      vm.viewMoreInfo = viewMoreInfo
      vm.detailInfo = []
      
      vm.FileUploader = new FileUploader({
        url: config.api + 'api/Empcategory/uploadFile',
        removeAfterUpload: true,
        alias: 'fileupload',
        formData: [{
            action: 'uploadFile'
        }],
        onAfterAddingAll: function() {
          vm.uploadSuccess = false;
          vm.uploadError = false;
        },
        headers: {
          tokenAuth: $localStorage.tokenAuth
        }
      });
  
      vm.FileUploader.onSuccessItem = function(data, status, headers, config) {
        if ( status.status == 0 ) {
          vm.uploadSuccess = false;
          vm.uploadError   = true;
        } else {
          vm.uploadSuccess = true;
          vm.uploadError   = false;
        }
        
        var expmess = status.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
          var message = translate(status.pesan);
        }
        vm.uploadNotif = message
        
        if ('moreInfo' in status && status.moreInfo.length>0) {
            vm.isMoreInfo = true;
            vm.detailInfo = status.moreInfo;
        }
        
        angular.element('#uploadCutOff').val('');
        
      };
  
      vm.FileUploader.onErrorItem = function() {
        vm.uploadSuccess = false;
        vm.uploadError = true;
        
      };
      
      function closeModal()
      {
        $mdDialog.hide();
      }
  
      function DownloadTemplate()
      {
        var token=Auth.setTokenPromise();
          token.then(function(data){
                  var protocol=$location.protocol();
                  var host=$location.host();
                 $window.open(protocol+'://'+host+config.port+config.api+'api/Empcategory/downloadTemplate', '_blank');
          },function(){
              $window.alert('gagal load token');
          });
      }

      function viewMoreInfo(detail)
      {
        $mdDialog.show({
          controller         : 'logFailGwController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          {
           
          },
          locals:{
            data:detail
          }
        });
      }
      
      function dialogClose() {
        $mdDialog.hide();
      }
    }
  })();
(function() {
    'use strict';

    angular
        .module('app.emp-category')
        .controller('newEmpCategoryController', newEmpCategoryController);

    newEmpCategoryController.$inject = [
        '$mdDialog',
        'Form',
        'AppAPI',
        '$http',
        'config',
        '$filter'
    ];
    /* @ngInject */
    function newEmpCategoryController(
        $mdDialog,
        Form,
        AppAPI,
        $http,
        config,
        $filter
    ) {
        var vm = this;
        var translate = $filter('translate');
        var endPoint=AppAPI.EmpCategory();

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        
        vm.selectedEmployee = selectedEmployee;
        vm.lookupEmployee   = lookupEmployee;
        vm.dialogClose      = dialogClose;
        vm.saveData         = saveData;

        getType();

        function dialogClose() {
            $mdDialog.hide();
        }

        function saveData(ev,form) 
        {
            angular.element.blockUI();
            
            var response = Form.saveData('saveData', form, endPoint);
            response.then(function(data) {
                angular.element.unblockUI();
                form.$setPristine(); 
                showDialogInfo(ev, data);
            });

            response.catch(function(data) {
                angular.element.unblockUI();
                form.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var title = 'Success';
            if(data.status==0){
                var title = 'Failed';
            }
            var expmess = data.pesan.split("_");
            if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
            }else{
                var message = translate(data.pesan);
            }
            $mdDialog
              .show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('#contentDialog')))
                  .clickOutsideToClose(true)
                  .title(title)
                  .textContent(message)
                  .ariaLabel(title)
                  .ok('OK')
                  .targetEvent(ev)
              )
              .then(function() {
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    dialogClose();
                }
              });
        }

        function selectedEmployee(employee) {
            vm.Form.objForm.nik='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.nik=employee.nik;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;
            }
        }

        function getType() 
        {
            var response=endPoint.query({action:'getType'});
            response.$promise.then(fetchType);
            response.$promise.catch(errorFetchType);
        }

        function fetchType(data) {
                vm.listType=data;
        }

        function errorFetchType() {
                vm.listType=[];
        } 

        function lookupEmployee(searchText) {
            return $http
                .get(config.api + 'api/empcategory?action=searchEmployee&search=' + searchText)
                .then(function(item) {
                    if(item.data.length===''){
                        Form.objForm.nik='';
                    }   
                    return item.data;
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.emp-category')
        .controller('EmpCategoryController', EmpCategoryController);

    EmpCategoryController.$inject = [
        '$mdDialog',
        'DataService',
        'AppAPI',
        'Auth',
        '$document',
        '$filter'
    ];
    /** @ngInject */
    function EmpCategoryController(
        $mdDialog,
        DataService,
        AppAPI,
        Auth,
        $document,
        $filter
    ) {
        var vm = this;
        var translate = $filter('translate');
        var endPoint=AppAPI.EmpCategory();
        vm.DataTables = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;
        vm.newProcess = newProcess;
        vm.edit = edit;
        vm.detail = detail;
        vm.upload = upload;
        vm.deleteData = deleteData;
        vm.items = [];
        loadData(1);

       function newProcess(ev) {
        $mdDialog.show({
          controller: 'newEmpCategoryController',
          controllerAs: 'vm',
          templateUrl: 'app/main/emp-category/new-emp-category.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          onRemoving: function(element, removePromise) {
            loadData(1);
          },
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        });
      }
       
      function edit(ev, data) {
        $mdDialog.show({
            controller: 'EditEmpCategoryController',
            controllerAs: 'vm',
            templateUrl: 'app/main/emp-category/new-emp-category.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
                data: data
            },
            onRemoving: function (element, removePromise) {
                loadData();
            }
        });
      }

      function detail(ev,data) {
          data.period = vm.period;
          data.subPeriod = vm.subperiod;
        $mdDialog.show({
            controller: 'UmutProcessDetailController',
            controllerAs: 'vm',
            templateUrl: 'app/main/umut-process/umut-process-detail.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            onRemoving: function(element, removePromise) {
              loadData(1);
            },
            clickOutsideToClose: true,
            fullscreen: true,
            locals : { 
                _data : data
            }
          });
      }

       function loadData(pageno) {
        var resp = vm.DataTables.loadData(endPoint, pageno, {
          action: 'viewData',
          subPeriod   : vm.subperiod,
          period      : vm.period,
          company     : vm.company,
          area        : vm.area,
          division    : vm.division,
          wilayah     : vm.wilayah,
          regional    : vm.regional,
          cabang      : vm.cabang
        });
  
        resp.then(function(data) {
          angular.element.unblockUI();
          vm.selected = [];
          vm.items = data.list;
        });
      }

      function toggle(item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        } else {
          list.push(item);
        }
      }
  
      function exists(item, list) {
        return list.indexOf(item) > -1;
      }
  
      function isIndeterminate() {
        return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
      }
  
      function isChecked() {
        return vm.selected.length === vm.items.length;
      }
  
      function toggleAll() {
        if (vm.selected.length === vm.items.length) {
          vm.selected = [];
        } else if (vm.selected.length === 0 || vm.selected.length > 0) {
          vm.selected = vm.items.slice(0);
        }
      } 

        function deleteData(ev) {
          var message = translate('PAYROLL.MESSAGE.CONFDEL');
          var note    = translate('PAYROLL.MESSAGE.DELNOTE');
          var yes     = translate('PAYROLL.MESSAGE.YES');
          var no      = translate('PAYROLL.MESSAGE.NO');
    console.log(vm.selected)
          var promise = Auth.setToken();
          promise.then(function () {
            var confirm = $mdDialog.confirm()
                .title(message)
                .textContent(note)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok(yes)
                .cancel(no);

              $mdDialog.show(confirm).then(function () {
                  angular.element.blockUI();
                  var response = endPoint.delete({
                      action: 'delete',
                      data: angular.toJson(vm.selected)
                  });
                  response.$promise.then(function(resp) {
                    dialogClose();
                    angular.element.unblockUI();
                    showDialogInfo(ev, resp);
                  });
                  response.$promise.catch(function(resp) {
                    angular.element.unblockUI();
                  })
              }, function () {});
          });
            
        }
  
        function dialogClose() {
          $mdDialog.hide();
        }
        
        function showDialogInfo(ev, data) {
          var message = translate(data.pesan);
          var status = translate(data.status);
          $mdDialog
            .show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#contentDialog')))
                .clickOutsideToClose(true)
                .title(status)
                .textContent(message)
                .ariaLabel(status)
                .ok('OK')
                .targetEvent(ev)
            )
            .then(function() {
              dialogClose();
              loadData(1);
            });
        }

        function upload(ev) {
          $mdDialog.show({
            controller: 'UploadEmpCategoryController',
            controllerAs: 'vm',
            templateUrl: 'app/main/emp-category/upload-form.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            onRemoving: function(element, removePromise) {
              loadData(1);
            },
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.emp-category')
        .controller('EditEmpCategoryController', EditEmpCategoryController);

    EditEmpCategoryController.$inject = [
        '$mdDialog',
        'Form',
        'AppAPI',
        'data',
        '$http',
        'config',
        '$filter'
    ];
    /* @ngInject */
    function EditEmpCategoryController(
        $mdDialog,
        Form,
        AppAPI,
        data,
        $http,
        config,
        $filter
    ) {
        var vm = this;
        var translate = $filter('translate');
        var endPoint=AppAPI.EmpCategory();

        vm.Form = Form;
        Form.initialForm();
        Form.setObject(endPoint);
        
        vm.stateEdit = true;
        //set data
        vm.Form.objForm.nik = data.nik;
        vm.Form.objForm.fullname = data.name;
        vm.Form.objForm.type = data.type;
        vm.Form.objForm.effective = new Date(data.effective_date);

        vm.changeNik        = changeNik;
        vm.lookupEmployee   = lookupEmployee;
        vm.dialogClose      = dialogClose;
        vm.saveData         = saveData;
        vm.selectedEmployee = selectedEmployee;

        getType();

        function selectedEmployee(employee) {
            vm.Form.objForm.nik='';
            vm.Form.objForm.fullname='';
            vm.isDisabled=false;
            vm.Form.objForm.fullname=vm.searchString; 
            if(typeof employee!=='undefined')
            {
                vm.Form.objForm.nik=employee.nik;
                vm.Form.objForm.fullname=employee.fullname;
                vm.isDisabled=true;
            }
        }

        function dialogClose() {
            $mdDialog.hide();
        }

        function getType() 
        {
            var response=endPoint.query({action:'getType'});
            response.$promise.then(fetchType);
            response.$promise.catch(errorFetchType);
        }

        function fetchType(data) {
                vm.listType=data;
        }

        function errorFetchType() {
                vm.listType=[];
        }

        function saveData(ev,form) 
        {
            angular.element.blockUI();
            
            var response = Form.saveData('saveData', form, endPoint);
            response.then(function(data) {
                angular.element.unblockUI();
                form.$setPristine(); 
                showDialogInfo(ev, data);
            });

            response.catch(function(data) {
                angular.element.unblockUI();
                form.$setPristine();
                showDialogInfo(ev, data);
            });
        }

        function showDialogInfo(ev, data) {
            var title = 'Success';
            if(data.status==0){
                var title = 'Failed';
            }
            var expmess = data.pesan.split("_");
            if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
            }else{
                var message = translate(data.pesan);
            }
            $mdDialog
              .show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('#contentDialog')))
                  .clickOutsideToClose(true)
                  .title(title)
                  .textContent(message)
                  .ariaLabel(title)
                  .ok('OK')
                  .targetEvent(ev)
              )
              .then(function() {
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    dialogClose();
                }
              });
        }

        function changeNik(data) {
            if (data.nik) {
                vm.Form.objForm.nik = data.nik.nik   
            }
        }

        function lookupEmployee(searchText) {
            return $http
                .get(config.api + 'api/empcategory?action=searchEmployee&search=' + searchText)
                .then(function(item) {
                    if(item.data.length===''){
                        Form.objForm.nik='';
                    }   
                    return item.data;
                });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.emp_assessment', ['ui.tinymce'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.emp_assessment', {
                url    : '/emp_assessment',
                views  : {
                    'main@' : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                    'content@app.emp_assessment': {
                        templateUrl: 'app/main/emp-assessment/emp-assessment.html',
                        controller : 'EmpAssessmentController as vm'
                    }
                },
                  bodyClass: 'assessment'
            });

           // Translation
        //$translatePartialLoaderProvider.addPart('app/main/login');

       
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.emp_assessment')
        .controller('EmpAssessmentController', EmpAssessmentController);

     EmpAssessmentController.$inject=['$state','$resource','$mdDialog','$mdToast','$mdSidenav','Auth','AppAPI','config','GeneralService','msNavigationService', '$localStorage', 'Form', '$timeout'];   

    /** @ngInject */
    function EmpAssessmentController($state,$resource,$mdDialog,$mdToast,$mdSidenav,Auth,AppAPI,config,GeneralService,msNavigationService, $localStorage, Form, $timeout)
    {
        var vm                  = this;
        var EmpAssessment       = AppAPI.EmpAssessment();

        vm.nik                  = $localStorage.user;
        vm.deleteAnswer         = deleteAnswer;
        vm.submitAnswer         = submitAnswer;
        vm.saveAnswer           = saveAnswer;
        vm.saveAnswerChoice     = saveAnswerChoice;
        vm.saveAssessment       = saveAssessment;
        vm.setTemporary         = setTemporary;
        vm.showParentQuestion   = showParentQuestion;
        vm.showPreviousQuestion = showPreviousQuestion;
        vm.selectedIndex        = 0;
        vm.question             = {};
        vm.completion           = {};
        vm.answers              = [];
        vm.answersChoiceList    = [];
        vm.is_completed         = false;
        vm.autosave_is_well  = true;
        vm.answerList           = [
            {answer : ''}
        ];

        vm.tinymceOptions = {
          height: 350,
          forced_root_block: false,
          plugins: 'template, table, code'
        };

        Form.initialForm();
        Form.setObject(EmpAssessment);
        vm.setToken = Auth.setToken;
        vm.Form     = Form;

        vm.isFull = false;
        vm.toggleShow = buildToggler('right');
        vm.toggleHide = buildToggler('right');
        function buildToggler(componentId) {
            // vm.isFull = (vm.isFull)?false:true;
            return function() {
                $mdSidenav(componentId).toggle();
            }
        }

    
        loadQuestions();
        loadIsCompleted();

        function reloadToken() {
            vm.setToken();
            angular.element.unblockUI();
        }

        function loadQuestions() {
          
            var response = EmpAssessment.query({
                action: 'get_questions',
                nik: vm.nik
            });
            response.$promise.then(fetchQuestions);
            response.$promise.catch(errorQuestions);
        }

        function fetchQuestions(data) {            

            if(typeof(data[0]) !== 'undefined') {
                vm.question = data[0];
                vm.question_file = vm.question.filepath + "?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;";
                
                if(vm.question.id === '7' && vm.question.count > 1) {
                    // vm.question.count = 5; // for testing only...
                    for(var i = 0; i <= (vm.question.count - 1); i++) {
                        vm.answersChoiceList.push({
                            question: (i + 1),
                            answer: ''
                        });
                    }
                }

                if(typeof(vm.question.answer_tmp) !== 'undefined' && vm.question.answer_tmp.length > 0) {
                    vm.answerList = vm.question.answer_tmp;
                    if(vm.question.id === '7' && typeof(vm.question.answer_tmp[0]) !== 'undefined') {                        
                        // vm.answersChoiceList = [];
                        for(var ii = 0; ii <= (vm.question.count - 1); ii++) {
                            var answerItem = vm.question.answer_tmp[0].answer[ii];
                            //console.log('answerItem', answerItem);
                            //vm.answersChoiceList.push(answerItem);
                            if(typeof(answerItem.answer) !== 'undefined') {
                                vm.answersChoiceList[ii].answer = answerItem.answer;
                            }
                        }                        
                    }
                }

                vm.parent_question_file = '';
                if(vm.question.parent_question && typeof(vm.question.parent_question.filepath) !== 'undefined') {
                    vm.parent_question_file = vm.question.parent_question.filepath + "?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;";
                }

                if(vm.question.sort === '5') {
                    vm.tinymceOptions = {
                      height: 350,
                      forced_root_block: false,
                      plugins: 'template, table, code',
                      templates: [
                        { title: 'Answer 1', content: section5_answer1() },
                        { title: 'Answer 2', content: section5_answer2() },
                        { title: 'Answer 3', content: section5_answer3() },
                        { title: 'Answer 4', content: section5_answer4() }
                      ]
                    };
                }

                if(typeof(initAutosave) !== 'undefined') {
                    $timeout.cancel(initAutosave);
                }

                if(!vm.is_completed) {
                    // console.log('vm.question.id', vm.question.id);
                    var initAutosave = autoSaveSection2();
                }
                
            }
        }

        function autoSaveSection2() {


            if(!vm.is_completed) {
            
                //console.log('vm.answerList', vm.answerList);
                //setTemporary();

                vm.Form.objForm.questions_id = vm.question.id;
                vm.Form.objForm.periode = vm.question.periode;
                vm.Form.objForm.periode_end = vm.question.periode_end;
                vm.Form.objForm.answers = vm.answerList;
                vm.Form.objForm.type = 'freetext';
                if(vm.question.id === '7') {
                    vm.Form.objForm.answers = vm.answersChoiceList;
                    vm.Form.objForm.type = 'choice';
                }
                

                var form = angular.element(document.getElementById('frmAnswersTemporary'));
                $timeout(function () {
                    form.triggerHandler("submit");
                });

                $timeout(function() {
                    autoSaveSection2();
                }, 10000);

            } else {
                if(typeof(initAutosave) !== 'undefined') {
                   $timeout.cancel(initAutosave);
               }
            }

        }

        function setTemporary(ev, formController) {

            var promise = Form.saveData('set_temporary', formController, EmpAssessment);

            promise.then(fetchTemporary);
            promise.catch(errorTemporary);

        }

        function fetchTemporary(data) {
            // console.log('data', data);
            if(data) {
                vm.autosave_is_well = true;
            } 
            if(!data.token) {
                vm.autosave_is_well = false;
            }
        }

        function errorTemporary(data) {
            vm.autosave_is_well = false;
            reloadToken();
        }

        function section5_answer1() {
            var htmlText = '<table style="height: 323px;" width="811" border="1">';
                htmlText += '<tbody>';
                htmlText += '<tr style="height: 35px;">';
                htmlText += '<td style="width: 260px; text-align: center; height: 35px;"><strong>Masalah</strong></td>';
                htmlText += '<td style="width: 262px; text-align: center; height: 35px;"><strong>Penyebab</strong></td>';
                htmlText += '<td style="width: 267px; text-align: center; height: 35px;"><strong>Mengapa penting untuk dipecahkan segera?</strong></td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 54px;">';
                htmlText += '<td style="width: 260px; height: 54px;">&nbsp;</td>';
                htmlText += '<td style="width: 262px; height: 54px;">&nbsp;</td>';
                htmlText += '<td style="width: 267px; height: 54px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 54px;">';
                htmlText += '<td style="width: 260px; height: 54px;">&nbsp;</td>';
                htmlText += '<td style="width: 262px; height: 54px;">&nbsp;</td>';
                htmlText += '<td style="width: 267px; height: 54px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 55px;">';
                htmlText += '<td style="width: 260px; height: 55px;">&nbsp;</td>';
                htmlText += '<td style="width: 262px; height: 55px;">&nbsp;</td>';
                htmlText += '<td style="width: 267px; height: 55px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 55px;">';
                htmlText += '<td style="width: 260px; height: 55px;">&nbsp;</td>';
                htmlText += '<td style="width: 262px; height: 55px;">&nbsp;</td>';
                htmlText += '<td style="width: 267px; height: 55px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 55px;">';
                htmlText += '<td style="width: 260px; height: 55px;">&nbsp;</td>';
                htmlText += '<td style="width: 262px; height: 55px;">&nbsp;</td>';
                htmlText += '<td style="width: 267px; height: 55px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '</tbody>';
                htmlText += '</table>';
            return htmlText;
        }


        function section5_answer2() {
            var htmlText = '<table style="height: 340px;" width="811" border="1">';
                htmlText += '<tbody>';
                htmlText += '<tr style="height: 36px;">';
                htmlText += '<td style="width: 397px; text-align: center; height: 36px;"><strong>Tantangan</strong></td>';
                htmlText += '<td style="width: 398px; text-align: center; height: 36px;"><strong>Strategi untuk Mengatasi</strong></td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 78px;">';
                htmlText += '<td style="width: 397px; height: 78px;">&nbsp;</td>';
                htmlText += '<td style="width: 398px; height: 78px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 78px;">';
                htmlText += '<td style="width: 397px; height: 78px;">&nbsp;</td>';
                htmlText += '<td style="width: 398px; height: 78px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 78px;">';
                htmlText += '<td style="width: 397px; height: 78px;">&nbsp;</td>';
                htmlText += '<td style="width: 398px; height: 78px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 78px;">';
                htmlText += '<td style="width: 397px; height: 78px;">&nbsp;</td>';
                htmlText += '<td style="width: 398px; height: 78px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 78px;">';
                htmlText += '<td style="width: 397px; height: 78px;">&nbsp;</td>';
                htmlText += '<td style="width: 398px; height: 78px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '</tbody>';
                htmlText += '</table>';
            return htmlText;
        }

        function section5_answer3() {
            var htmlText = '<table style="height: 336px;" width="810" border="1">';
                htmlText += '<tbody>';
                htmlText += '<tr style="height: 33px;">';
                htmlText += '<td style="width: 262px; text-align: center; height: 33px;"><strong>Masalah</strong></td>';
                htmlText += '<td style="width: 263px; text-align: center; height: 33px;"><strong>Rekomendasi Solusi &amp; Alternatif</strong></td>';
                htmlText += '<td style="width: 263px; text-align: center; height: 33px;"><strong>Alasan/Pertimbangan</strong></td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 77px;">';
                htmlText += '<td style="width: 262px; height: 77px;">&nbsp;</td>';
                htmlText += '<td style="width: 263px; height: 77px;">&nbsp;</td>';
                htmlText += '<td style="width: 263px; height: 77px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 77px;">';
                htmlText += '<td style="width: 262px; height: 77px;">&nbsp;</td>';
                htmlText += '<td style="width: 263px; height: 77px;">&nbsp;</td>';
                htmlText += '<td style="width: 263px; height: 77px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 77px;">';
                htmlText += '<td style="width: 262px; height: 77px;">&nbsp;</td>';
                htmlText += '<td style="width: 263px; height: 77px;">&nbsp;</td>';
                htmlText += '<td style="width: 263px; height: 77px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 77px;">';
                htmlText += '<td style="width: 262px; height: 77px;">&nbsp;</td>';
                htmlText += '<td style="width: 263px; height: 77px;">&nbsp;</td>';
                htmlText += '<td style="width: 263px; height: 77px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 77px;">';
                htmlText += '<td style="width: 262px; height: 77px;">&nbsp;</td>';
                htmlText += '<td style="width: 263px; height: 77px;">&nbsp;</td>';
                htmlText += '<td style="width: 263px; height: 77px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '</tbody>';
                htmlText += '</table>';
            return htmlText;
        }

        function section5_answer4() {
            var htmlText = '<table style="height: 337px;" width="810" border="1">';
                htmlText += '<tbody>';
                htmlText += '<tr style="height: 56px;">';
                htmlText += '<td style="width: 109px; text-align: center; height: 56px;"><strong>Rekomendasi Solusi</strong></td>';
                htmlText += '<td style="width: 109px; text-align: center; height: 56px;"><strong>Target Terukur&nbsp;</strong></td>';
                htmlText += '<td style="width: 109px; text-align: center; height: 56px;"><strong>Sumber Daya&nbsp;</strong></td>';
                htmlText += '<td style="width: 109px; text-align: center; height: 56px;"><strong>Hambatan</strong></td>';
                htmlText += '<td style="width: 109px; text-align: center; height: 56px;"><strong>&nbsp;Cara Mengatasi</strong></td>';
                htmlText += '<td style="width: 109px; text-align: center; height: 56px;"><strong>Pihak yang akan dilibatkan</strong></td>';
                htmlText += '<td style="width: 110px; text-align: center; height: 56px;"><strong>Jangka Waktu Implementasi</strong></td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 69px;">';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 110px; height: 69px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 69px;">';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 110px; height: 69px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 69px;">';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 110px; height: 69px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 69px;">';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 110px; height: 69px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '<tr style="height: 69px;">';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 109px; height: 69px;">&nbsp;</td>';
                htmlText += '<td style="width: 110px; height: 69px;">&nbsp;</td>';
                htmlText += '</tr>';
                htmlText += '</tbody>';
                htmlText += '</table>';
            return htmlText;
        }

        function errorQuestions() {
            vm.question = {};
            vm.question_file = '';
            reloadToken();
        }     

        function loadIsCompleted() {
          
            var response = EmpAssessment.query({
                action: 'is_completed',
                nik: vm.nik
            });
            response.$promise.then(fetchIsCompleted);
            response.$promise.catch(errorIsCompleted);
        }

        function fetchIsCompleted(data) {
            if(typeof(data[0]) !== 'undefined') {
                vm.completion = data[0];

                if(vm.completion.total_assessment === vm.completion.total_answer) {
                    vm.is_completed = true;

                    loadAssessmentAnswers();

                }
            }
        }

        function errorIsCompleted() {
            vm.completion = {};
            reloadToken();
        }      

        function loadAssessmentAnswers() {
          
            var response = EmpAssessment.query({
                action: 'get_answers',
                nik: vm.nik
            });
            response.$promise.then(fetchAssessmentAnswers);
            response.$promise.catch(errorAssessmentAnswers);
        }

        function fetchAssessmentAnswers(data) {
            if(typeof(data[0]) !== 'undefined') {
                vm.answers = data;
            }
        }

        function errorAssessmentAnswers() {
            vm.answered = [];
            reloadToken();
        }        

        function submitAnswer(ev, list) {
           // console.log('Editor content:', vm.answerList);
            vm.answerList.push({answer:''});
        };

        function deleteAnswer(ev, list) {
            // console.log('list', list);
            var index = vm.answerList.indexOf(list);
            vm.answerList.splice(index, 1);
            // console.log('Editor content:', vm.answerList);
        };

        function saveAnswer(ev) {

            vm.Form.objForm.questions_id = vm.question.id;
            vm.Form.objForm.periode = vm.question.periode;
            vm.Form.objForm.periode_end = vm.question.periode_end;
            vm.Form.objForm.answers = vm.answerList;
            vm.Form.objForm.type = 'freetext';

            var form = angular.element(document.getElementById('frmAnswers_0'));
            $timeout(function () {
                form.triggerHandler("submit");
            });
        }

        function saveAnswerChoice(ev) {

            // console.log('vm.answersChoiceList', vm.answersChoiceList);

            vm.Form.objForm.questions_id = vm.question.id;
            vm.Form.objForm.periode = vm.question.periode;
            vm.Form.objForm.periode_end = vm.question.periode_end;
            vm.Form.objForm.answers = vm.answersChoiceList;
            vm.Form.objForm.type = 'choice';

            var form = angular.element(document.getElementById('frmAnswersChoice'));
            $timeout(function () {
                form.triggerHandler("submit");
            });
        }

        function saveAssessment(ev, formController) {        

            var promiseAssessment = Form.saveData('save', formController, EmpAssessment);

            promiseAssessment.then(successSaveAssessment);
            promiseAssessment.catch(failedSaveAssessment);

        }

        function successSaveAssessment(data) {

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.Form.pesan)
                .position('top right')
                .hideDelay(3000)
                .theme("success-toast")
            );


            if(data) {

                $timeout(function() {
                    // location.reload();
                    vm.question = {};
                    vm.question_file = '';

                    vm.answersChoiceList = [];

                    loadQuestions();
                    loadIsCompleted();

                    vm.answerList = [
                        {answer : ''}
                    ];
                    vm.selectedIndex  = 0;

                }, 0);

            }

        }

        function failedSaveAssessment() {
            vm.messageTheme='red';
            reloadToken();
        }

        function showParentQuestion(ev)
        {

            $mdDialog.show({
                controller: 'EmpAssessmentParentQuestionController',
                controllerAs:'vm',
                templateUrl: 'app/main/emp-assessment/emp-assessment-parent-question.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    parentquestion: vm.question.parent_question
                },
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                fullscreen: true
            });
        }

        function showPreviousQuestion(ev, data)
        {

            $mdDialog.show({
                controller: 'EmpAssessmentPreviousQuestionController',
                controllerAs:'vm',
                templateUrl: 'app/main/emp-assessment/emp-assessment-previous-question.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                locals:{
                    data: data
                },
                onRemoving:function(element, removePromise)
                {
                    loadData();
                },
                fullscreen: true
            });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.emp_assessment')
        .controller('EmpAssessmentPreviousQuestionController', EmpAssessmentPreviousQuestionController);

    EmpAssessmentPreviousQuestionController.$inject=['$state','$resource','$mdDialog','data','$mdToast','$mdSidenav','Auth','AppAPI','config','GeneralService','msNavigationService', '$localStorage', 'Form', '$timeout'];   

    /** @ngInject */
    function EmpAssessmentPreviousQuestionController($state,$resource,$mdDialog,data,$mdToast,$mdSidenav,Auth,AppAPI,config,GeneralService,msNavigationService, $localStorage, Form, $timeout)
    {
        var vm = this;
        vm.hide = hide;
        vm.cancel = cancel;
        vm.data = data;

        vm.parent_question_file = '';
        if(data && typeof(data.filepath) !== 'undefined') {
            vm.previous_question_file = data.filepath + "?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;";
        }

        function hide() {
            $mdDialog.hide();
        }
       
        function cancel() {
            $mdDialog.cancel();
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.emp_assessment')
        .controller('EmpAssessmentParentQuestionController', EmpAssessmentParentQuestionController);

    EmpAssessmentParentQuestionController.$inject=['$state','$resource','$mdDialog','parentquestion','$mdToast','$mdSidenav','Auth','AppAPI','config','GeneralService','msNavigationService', '$localStorage', 'Form', '$timeout'];   

    /** @ngInject */
    function EmpAssessmentParentQuestionController($state,$resource,$mdDialog,parentquestion,$mdToast,$mdSidenav,Auth,AppAPI,config,GeneralService,msNavigationService, $localStorage, Form, $timeout)
    {
        var vm = this;
        vm.hide = hide;
        vm.cancel = cancel;
        // console.log('parentquestion', parentquestion);

        vm.parent_question_file = '';
        if(parentquestion && typeof(parentquestion.filepath) !== 'undefined') {
            vm.parent_question_file = parentquestion.filepath + "?page=hsn#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true;disableprint=true;";
        }

        function hide() {
            $mdDialog.hide();
        }
       
        function cancel() {
            $mdDialog.cancel();
        }


    }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-appraisal')
    .controller('UploadEmpAppraisalController', UploadEmpAppraisalController);

  UploadEmpAppraisalController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadEmpAppraisalController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.detailInfo = []

    vm.FileUpload = new FileUploader({
      url: config.api + 'api/empappraisal/uploadfile',
      removeAfterUpload: true,
      alias: 'file',
      formData: [{
        action: 'uploadfile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function (data, status) {
      vm.uploadSuccess = false;
      vm.uploadError = true;

      vm.uploadNotif = status
    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/empappraisal/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';

  angular
    .module('app.emp-appraisal')
    .controller('InputEmpAppraisalController', InputEmpAppraisalController);

  InputEmpAppraisalController.$inject = ['$localStorage', '$mdDialog', 'Form', 'AppAPI', '$http', 'config', '$scope', '$filter'];

  /* @ngInject */
  function InputEmpAppraisalController($localStorage, $mdDialog, Form, AppAPI, $http, config, $scope, $filter) {
    var vm = this;
    var translate = $filter('translate');
    var dt = new Date();
    var year = dt.getFullYear();
    vm.saveData = saveData;

    Form.initialForm();

    var EmpAppraisal = AppAPI.EmpAppraisal();

    // set constructor form
    Form.setObject(EmpAppraisal);

    // set form to controller
    vm.Form = Form;
    vm.closeModal = closeModal;
    /*vm.LoadCutOffPeriod = LoadCutOffPeriod;*/
    vm.saveData = saveData;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.selectedItemChanged = selectedItemChanged;

    vm.Form.objForm.empno = '';
    vm.Form.objForm.effective_date = new Date();

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;
      }
    }

    vm.LoadCompany = LoadCompany;
    vm.Form.objForm.country = $localStorage.country;
    vm.Form.objForm.company = $localStorage.empsite

    LoadCompany();
    getType();

    function LoadCompany() {
      var KPI = AppAPI.teamMember();
      var response = KPI.query({
        action: 'viewBu'
      });
      response.$promise.then(fetchBU);
      response.$promise.catch(errorFetchBU);
    }

    function fetchBU(data) {
      vm.listcompany = data;
    }

    function errorFetchBU() {
      vm.listcompany = [];
    }

    function getType() {
      var response = EmpAppraisal.query({
        action: 'getTypes'
      });
      response.$promise.then(fetchType);
      response.$promise.catch(errorFetchType);
    }

    function fetchType(data) {
      vm.listType = data;
    }

    function errorFetchType() {
      vm.listType = [];
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empappraisal?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            Form.objForm.empno = '';
          }
          return item.data;
        });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function saveData(ev, formController) {
      var promise = Form.saveData('save', formController, EmpAppraisal);
      promise.then(function (data) {
        showDialog(ev, data);
      });
      promise.catch(function (data) {
        errorDialog(data);
      });
    }

    function errorDialog(data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed')
          .textContent(data.data)
          .ariaLabel(data.data)
          .ok('OK')
      ).then(function () {
        closeModal();
      });
    }

    function showDialog(ev, data) {
      var message = translate(data.pesan);
      var status = translate(data.status);

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(status)
          .textContent(message)
          .ariaLabel(status)
          .ok('OK')
          .targetEvent(ev)
      ).then(function () {
        closeModal();
      });
    }
    $scope.isDisabled = true;
  }
})();
(function () {
    'use strict';

    angular
        .module('app.emp-appraisal')
        .controller('EmpAppraisalController', EmpAppraisalController);

    EmpAppraisalController.$inject = ['AppAPI', '$localStorage', 'DataService', '$mdDialog', 'Form', 'Auth', '$document', '$http', 'config', '$location', '$window', '$element', '$filter'];

    /* @ngInject */
    function EmpAppraisalController(AppAPI, $localStorage, DataService, $mdDialog, Form, Auth, $document, $http, config, $location, $window, $element, $filter) {

        var vm = this;
        var translate = $filter('translate');

        Form.initialForm();

        var EmpAppraisal = AppAPI.EmpAppraisal();
        var PayrollEmployee = AppAPI.NewPayrollEmployee();


        Form.setObject(EmpAppraisal);

        vm.Form = Form;

        vm.DataTable = new DataService();
        vm.loadData = loadData;
        vm.toggleSelectedAll = toggleSelectedAll;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.inputEmpAppraisal = inputEmpAppraisal;
        vm.lisEmpAppraisalSelected = [];
        vm.arr_area = [];
        vm.DeleteEmpAppraisal = DeleteEmpAppraisal;
        vm.editEmpAppraisal = editEmpAppraisal;
        vm.openUpload = openUpload;

        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;
        vm.Form.objForm.empno = '';

        vm.LoadCompany = LoadCompany;
        vm.company = $localStorage.empsite
        vm.country = $localStorage.country;
        vm.type = 'all';

        LoadCompany();
        getType();

        function loadData(pageno) {
            var nik = '';
            var company = '';

            if (typeof (vm.Form.objForm.empno) != 'undefined')
                nik = vm.Form.objForm.empno;
            if (typeof (vm.company) != 'undefined')
                company = vm.company;

            vm.DataTable.loadData(EmpAppraisal, pageno, {
                action: 'viewdata',
                nik: nik,
                country: vm.country,
                company: vm.company,
                effective_date: vm.Form.objForm.effective_date,
                type: vm.type,
            });
        }

        function selectedItemChanged(employee) {
            vm.Form.objForm.empno = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined') {
                vm.Form.objForm.empno = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empappraisal?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.empno = '';
                    }
                    return item.data;
                });
        }

        function LoadCompany() {
            var KPI = AppAPI.teamMember();
            var response = KPI.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listcompany = data;
        }

        function errorFetchBU() {
            vm.listcompany = [];
        }

        function getType() {
            var response = EmpAppraisal.query({
                action: 'getTypes'
            });
            response.$promise.then(fetchType);
            response.$promise.catch(errorFetchType);
        }

        function fetchType(data) {
            vm.listType = data;
        }

        function errorFetchType() {
            vm.listType = [];
        }

        function inputEmpAppraisal(ev) {
            $mdDialog.show({
                controller: 'InputEmpAppraisalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/emp-appraisal/input-emp-appraisal.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        function editEmpAppraisal(ev, id) {
            $mdDialog.show({
                controller: 'EditEmpAppraisalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/emp-appraisal/input-emp-appraisal.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                },
                locals: {
                    id: id
                }
            });
        }

        function successDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.lisEmpAppraisalSelected = angular.copy(vm.DataTable.list);
        }

        function unCheckAll() {
            vm.lisEmpAppraisalSelected = [];
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function DeleteEmpAppraisal(ev) {
            var message = translate('PAYROLL.MESSAGE.CONFDEL');
            var note = translate('PAYROLL.MESSAGE.DELNOTE');
            var yes = translate('PAYROLL.MESSAGE.YES');
            var no = translate('PAYROLL.MESSAGE.NO');
            var promise = Auth.setToken();
            promise.then(function () {
                var confirm = $mdDialog.confirm()
                    .title(message)
                    .textContent(note)
                    .ariaLabel('delete dialog')
                    .targetEvent(ev)
                    .ok(yes)
                    .cancel(no);

                $mdDialog.show(confirm).then(function () {
                    angular.element.blockUI();
                    var response = EmpAppraisal.delete({
                        action: 'delete',
                        data: angular.toJson(vm.lisEmpAppraisalSelected)
                    });

                    response.$promise.then(function (data) {
                        angular.element.unblockUI();
                        successDialog(ev, data);
                        loadData(1);
                    });
                    response.$promise.catch(function (data) {
                        angular.element.unblockUI();
                        errorDialog(data);
                    });
                }, function () {
                    // $scope.status = 'You decided to keep your debt.';
                });
            });
        }

        function openUpload(ev) {
            $mdDialog.show({
                controller: 'UploadEmpAppraisalController as vm',
                templateUrl: 'app/main/emp-appraisal/upload-file.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    loadData(1);
                }
            });
        }

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.emp-appraisal')
        .controller('EditEmpAppraisalController', EditEmpAppraisalController);

    EditEmpAppraisalController.$inject = ['$localStorage', 'id', '$mdDialog', 'Form', 'AppAPI', 'config', '$http', '$filter'];

    /* @ngInject */
    function EditEmpAppraisalController($localStorage, id, $mdDialog, Form, AppAPI, config, $http, $filter) {
        var vm = this;
        var translate = $filter('translate');
        var dt = new Date();
        var year = dt.getFullYear();
        vm.saveData = saveData;

        // initial form
        Form.initialForm();

        var EmpAppraisal = AppAPI.EmpAppraisal();

        // set constructor form
        Form.setObject(EmpAppraisal);
        // set form to controller
        vm.Form = Form;
        vm.closeModal = closeModal;

        vm.saveData = saveData;
        vm.getEmployee = getEmployee;
        vm.stateEdit = false;
        vm.selectedItemChanged = selectedItemChanged;

        function selectedItemChanged(employee) {
            console.log("masuk")
            vm.Form.objForm.nikemp = '';
            vm.Form.objForm.fullname = '';
            vm.isDisabled = false;
            vm.Form.objForm.fullname = vm.searchString;
            if (typeof employee !== 'undefined' && employee !== null) {
                vm.Form.objForm.nikemp = employee.empno;
                vm.Form.objForm.fullname = employee.fullname
                vm.isDisabled = true;

            }
        }

        vm.Form.objForm.id = id.id;
        vm.Form.objForm.country = $localStorage.country;
        vm.Form.objForm.company = id.company;
        vm.Form.objForm.type = id.type;
        vm.Form.objForm.effective_date = new Date(id.effective_date);
        vm.Form.objForm.nik = id.nik + ' - ' + id.emp_name;
        vm.Form.objForm.nikemp = id.nik;
        vm.Form.objForm.ganteng = id.nik;
        console.log(vm.Form.objForm);

        LoadCompany();
        getType();

        function LoadCompany() {
            var KPI = AppAPI.teamMember();
            var response = KPI.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listcompany = data;
        }

        function errorFetchBU() {
            vm.listcompany = [];
        }

        function getType() {
            var response = EmpAppraisal.query({
                action: 'getTypes'
            });
            response.$promise.then(fetchType);
            response.$promise.catch(errorFetchType);
        }

        function fetchType(data) {
            vm.listType = data;
        }

        function errorFetchType() {
            vm.listType = [];
        }

        function getEmployee(searchText) {
            return $http
                .get(config.api + 'api/empappraisal?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
                .then(function (item) {
                    // Map the response object to the data object.
                    if (item.data.length === '') {
                        Form.objForm.nikemp = '';
                    }
                    return item.data;
                });
        }

        vm.closeModal = closeModal;

        function closeModal() {
            $mdDialog.hide();
        }

        function saveData(ev, formController) {
            var promise = Form.saveData('update', formController, EmpAppraisal);
            promise.then(function (data) {
                showDialog(ev, data);
            });
            promise.catch(function (data) {
                errorDialog(data)

            });
        }

        function showDialog(ev, data) {
            var message = translate(data.pesan);
            var status = translate(data.status);

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title(status)
                    .textContent(message)
                    .ariaLabel(status)
                    .ok('OK')
                    .targetEvent(ev)
            ).then(function () {
                closeModal();
            });
        }

        function errorDialog(data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed')
                    .textContent(data.data)
                    .ariaLabel(data.data)
                    .ok('OK')
            ).then(function () {
                closeModal();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.emp-adjustment-allowance', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.emp-adjustment-allowance', {
                url: '/emp-adjustment-allowance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/emp-adjustment-allowance/emp-adjustment-allowance.html',
                        controller: 'EmpAdjustmentAllowanceController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-adjustment-allowance')
    .controller('EmpAdjustmentAllowanceController', EmpAdjustmentAllowanceController);

  EmpAdjustmentAllowanceController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function EmpAdjustmentAllowanceController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpAdjustmentAllowance();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.getArea = loadArea;
    vm.upload = upload;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      loadArea();
      loadSalaryComp();
    }

    function upload(ev) {
      $mdDialog.show({
        controller: 'UploadEmpAdjustmentAllowanceController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-adjustment-allowance/upload.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        }
      });
    }

    function loadArea() {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listArea = data;
    }

    function errorFetchArea() {
      vm.listArea = [];
    }

    function loadSalaryComp() {
      var response = endPoint.query({ action: 'getSalaryComponent', company: vm.company });
      response.$promise.then(fetchSalaryComp);
      response.$promise.catch(errorFetchSalaryComp);
    }

    function fetchSalaryComp(data) {
      vm.listSalaryComp = data;
    }

    function errorFetchSalaryComp() {
      vm.listSalaryComp = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        startDate: vm.start_date,
        endDate: vm.end_date,
        salCompId: vm.salCompId,
        area: vm.area,
        nik: vm.empno
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'EmpAdjustmentAllowanceInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-adjustment-allowance/emp-adjustment-allowance-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'EmpAdjustmentAllowanceEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/emp-adjustment-allowance/emp-adjustment-allowance-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empadjustmentallowance?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-adjustment-allowance')
    .controller('UploadEmpAdjustmentAllowanceController', UploadEmpAdjustmentAllowanceController);

  UploadEmpAdjustmentAllowanceController.$inject = ['$mdDialog', '$localStorage', 'FileUploader', 'config', 'Auth', '$location', '$window', '$filter'];
  /** @ngInject */
  function UploadEmpAdjustmentAllowanceController($mdDialog, $localStorage, FileUploader, config, Auth, $location, $window, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.closeModal = closeModal

    vm.uploadSuccess = false;
    vm.uploadError = false;
    vm.uploadNotif = '';
    vm.DownloadTemplate = DownloadTemplate;
    vm.isMoreInfo = false
    vm.viewMoreInfo = viewMoreInfo
    vm.upload = upload
    vm.detailInfo = []

    function upload() {
      angular.element.blockUI();
      vm.FileUpload.uploadAll();
    }
    vm.FileUpload = new FileUploader({
      url: config.api + 'api/empadjustmentallowance/uploadfile',
      removeAfterUpload: true,
      alias: 'filedata',
      formData: [{
        action: 'uploadFile'
      }],
      onAfterAddingAll: function () {
        vm.uploadSuccess = false;
        vm.uploadError = false;
      },
      headers: {
        tokenAuth: $localStorage.tokenAuth
      }
    });

    vm.FileUpload.onSuccessItem = function (data, status, headers, config) {
      angular.element.unblockUI();
      if (status.status == 0) {
        vm.uploadSuccess = false;
        vm.uploadError = true;
      } else {
        vm.uploadSuccess = true;
        vm.uploadError = false;
      }

      var expmess = status.pesan.split("_");
      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(status.pesan);
      }
      vm.uploadNotif = message
      if ('moreInfo' in status && status.moreInfo.length > 0) {
        vm.isMoreInfo = true;
        vm.detailInfo = status.moreInfo;
      }

      angular.element('#uploadCutOff').val('');

    };

    vm.FileUpload.onErrorItem = function () {
      angular.element.unblockUI();
      vm.uploadSuccess = false;
      vm.uploadError = true;

    };

    function closeModal() {
      $mdDialog.hide();
    }

    function DownloadTemplate() {
      var token = Auth.setTokenPromise();
      token.then(function (data) {
        var protocol = $location.protocol();
        var host = $location.host();
        $window.open(protocol + '://' + host + config.port + config.api + 'api/empadjustmentallowance/downloadtemplate', '_blank');
      }, function () {

        $window.alert('gagal load token');
      });
    }

    function viewMoreInfo() {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: vm.detailInfo
        }
      });
    }
  }
})();  
(function () {
  'use strict';
  angular
    .module('app.emp-adjustment-allowance')
    .controller('EmpAdjustmentAllowanceInputController', EmpAdjustmentAllowanceInputController);

  EmpAdjustmentAllowanceInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$filter',
    '$http',
    'config'
  ];
  /** @ngInject */
  function EmpAdjustmentAllowanceInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $filter,
    $http,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpAdjustmentAllowance();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;

    activate();

    loadSalaryComp();
    function loadSalaryComp() {
      var response = endPoint.query({ action: 'getSalaryComponent', company: vm.company });
      response.$promise.then(fetchSalaryComp);
      response.$promise.catch(errorFetchSalaryComp);
    }

    function fetchSalaryComp(data) {
      vm.listSalaryComp = data;
    }

    function errorFetchSalaryComp() {
      vm.listSalaryComp = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      vm.selected = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empadjustmentallowance?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.emp-adjustment-allowance')
    .controller('EmpAdjustmentAllowanceEditController', EmpAdjustmentAllowanceEditController);

  EmpAdjustmentAllowanceEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$filter'
  ];
  /** @ngInject */
  function EmpAdjustmentAllowanceEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.EmpAdjustmentAllowance();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;

    activate();

    loadSalaryComp();
    function loadSalaryComp() {
      var response = endPoint.query({ action: 'getSalaryComponent', company: vm.company });
      response.$promise.then(fetchSalaryComp);
      response.$promise.catch(errorFetchSalaryComp);
    }

    function fetchSalaryComp(data) {
      vm.listSalaryComp = data;
    }

    function errorFetchSalaryComp() {
      vm.listSalaryComp = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.nik = data.nik + ' - ' + data.name;
      vm.Form.objForm.empno = data.nik;
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.start_date = new Date(data.start_date);
      vm.Form.objForm.end_date = new Date(data.end_date);
      vm.Form.objForm.salary_component_id = data.salary_component_id;
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/empadjustmentallowance?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.echeckingw', [])
        .config(config);

    /** @ngInject */
    config.$inject=['$stateProvider'];
   /** @ngInject */
    function config($stateProvider)
    {
       
        // State
        $stateProvider
            .state('app.echeckingw', {
                url    : '/echeckingw',
                views  : {
                'main@' : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.echeckingw': {
                     templateUrl: 'app/main/echeckingw/echeckingw.html',
                        controller:'EcheckingwController as vm'
                }

                   
                }
            })
            ; 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.echeckingw')
        .controller('EcheckingwController', EcheckingwController);

    EcheckingwController.$inject = ['$localStorage','$window','$timeout','$state','AppAPI','Form','GeneralService'];

    /* @ngInject */
    function EcheckingwController($localStorage,$window,$timeout,$state,AppAPI,Form,GeneralService) {
        var vm = this;
        var empID=$localStorage.username;
        vm.user = $localStorage.nama;
        vm.logout=logout;
        vm.agama = ['Islam','Kristen','Kristen Protestan','Katolik','Hindu','Buddha','Kong hu cu'];
        vm.jenjangPendidikan = ['SMA','SMK','D3','S1'];
        vm.addAnak=addAnak;
        vm.delAnak=delAnak;
        vm.addPengalaman=addPengalaman;
        vm.delPengalaman=delPengalaman;
        vm.addKontak=addKontak;
        vm.delKontak=delKontak;
        vm.submit=submit;

        vm.statusMenikah=statusMenikah;
        vm.Form={};
       

        Form.initialForm();

         // get constructor form
        var Echeckingw=AppAPI.Echeckingw();
        var Lokasi=  AppAPI.Infolokasi();

         // set constructor form
        Form.setObject(Echeckingw);

        // set form to controller
        vm.Form = Form; 

        vm.loadKab = loadKab; 
        vm.loadKec = loadKec; 


       view();

       function view ()
       {
        var resp=vm.Form.objForm.$get({action:'viewdetail',id:empID});
        resp.then(resp_awal);

        function resp_awal(data){
         
          vm.Form.objForm.step1.tglLahir=new Date(data.step1.tglLahir);
          if(data.step1.expired_date!='1970-01-01'){
            vm.Form.objForm.step1.berlakuSampai=new Date(data.step1.expired_date);
          }
          vm.gender = data.step1.gender;
           var jum=vm.Form.objForm.step2.dependents.length,i;
           for(i=0;i<jum;i++){
           vm.Form.objForm.step2.dependents[i].tglLahir=new Date(data.step2.dependents[i].tglLahir);            
           }

           var jum5=vm.Form.objForm.step5.pengalaman.length,i;
           for(i=0;i<jum5;i++){
           vm.Form.objForm.step5.pengalaman[i].dari=new Date(data.step5.pengalaman[i].dari);            
           vm.Form.objForm.step5.pengalaman[i].sampai=new Date(data.step5.pengalaman[i].sampai);   
           getProv();         
           }
        }
       }
        
    function getProv() {
        angular.element.blockUI();
        var resp = Lokasi.query({action:'infoPropinsi'});
        resp.$promise.then(fetchDataProv);
        resp.$promise.catch(errorFetchProv);
    }

    function fetchDataProv(data) {
        vm.listProvince = data;
        angular.element.unblockUI();
        loadKab(vm.Form.objForm.step1.provinsi);
    }

    function errorFetchProv() {
        vm.listProvince = [];
        angular.element.unblockUI();
    }

    //KTP
    function loadKab(prov)
    {
      angular.element.blockUI();
      var dataPromise = Lokasi.query({action:'infoKabupaten',kode:prov});
      dataPromise.$promise.then(fetchKab);
      dataPromise.$promise.catch(errorFetchKab);
    }

    function fetchKab(data) {
        vm.listKab = data;
        angular.element.unblockUI();
        loadKec(vm.Form.objForm.step1.kab_kota);
    }

    function errorFetchKab() {
        vm.listKab = [];
        angular.element.unblockUI();
    }

    function loadKec(kab)
    {
      var dataPromise = Lokasi.query({action:'viewKecamatan',kode:kab});
      dataPromise.$promise.then(fetchKec);
      dataPromise.$promise.catch(errorFetchKec);
    }

    function fetchKec(data) {
        vm.listKec = data;
        angular.element.unblockUI();
    }

    function errorFetchKec() {
        vm.listKec = [];
        angular.element.unblockUI();
    }

        ////////////////

        function statusMenikah(status)
        {
          var jenkel='P';
          var title = 'Istri';
          if(vm.gender=='P'){
            var jenkel='L';
            var title='Suami';
          }

            switch(status)
            {
              case 'Menikah':
                vm.Form.objForm.step2.dependents.push({
                  title:title,
                  type:'spouse',
                  first_name:null,
                  last_name:null,
                  birth_place:'-',
                  tglLahir:null,
                  jenkel:jenkel,
                });
              break;
              default:
              vm.Form.objForm.step2.dependents=[];
              break;
            }
        }

    function addAnak(idx)
    { 
      // push an empty object onto the array

      vm.Form.objForm.step2.dependents.push({
                title:'Anak',
                type:'anak',
                first_name:null,
                last_name:null,
                birth_place:'-',
                tglLahir:null,
                jenkel:null,
              });
    }

    function delAnak(idx){ 
      // push an empty object onto the array
      vm.Form.objForm.step2.dependents.splice(idx,1);
    }


    function addPengalaman(idx){ 
      // push an empty object onto the array
      if(idx<=2)
      {
        vm.Form.objForm.step5.pengalaman.push({
          namaPerusahaan:null,
          departemen:null,
          section:null,
          dari:null,
          sampai:null,
        });
      }else{
        alert('limit abis');
      }
      
    }


    function delPengalaman(idx){ 
      // push an empty object onto the array
      vm.Form.objForm.step5.pengalaman.splice(idx,1);
      console.log(idx);
    }

     function addKontak(idx){ 
      // push an empty object onto the array
      if(idx<=2)
      {
        vm.Form.objForm.step6.kontak.push({
          nama:null,
          alamat:null,
          hubungan:null,
          hp:null,
        });
      }else{
        alert('limit abis');
      }
      
    }


    function delKontak(idx){ 
      // push an empty object onto the array
      vm.Form.objForm.step6.kontak.splice(idx,1);
    }

      function logout()
      {
        angular.element.blockUI();
            

        var Logout=AppAPI.Logout();
        var objLogout= new Logout();

        var promise=objLogout.$logout();
        promise.then(function(rdata){
          var resultNum=parseInt(rdata.status);
          if(resultNum===1)
          {
            GeneralService.clearStorage();
            // $location.path('/');
            $state.go('app.login.candidategwlogin');
            angular.element.unblockUI();
          }else
          {
            $window.alert('failed proses logout');
            angular.element.unblockUI();
          }
        },function(){
            $window.alert('failed proses logout');
            angular.element.unblockUI();
        });
      }

 
      function submit(formController)
      {
        Form.objForm.empID=empID;

        angular.element.blockUI();
        //    var resp=Form.updateData('updatedata',formController,Echeckingw,empID,'aiewEcheckinGw');

        var response=vm.Form.saveData('save', formController, Echeckingw);
        response.then(function(){
            vm.messageTheme='blue';
            angular.element.unblockUI();
            //formController.$setPristine();
            $timeout(function() {
                vm.Form.tampilPesan=false;
            }, 3000);
            view();
        });

        response.catch(function(){
            vm.messageTheme='pink';
            angular.element.unblockUI();
              view();
        });      
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .service('Echeckin', Service);

    /* @ngInject */
    function Service() {
        this.breadcrumb =[];
        this.checkComplete = {};
    }
})();
(function() {
    'use strict';

    angular
        .module('app.echeckin')
        .controller('EcheckinController', EcheckinController);

    EcheckinController.$inject = ['$localStorage','$window','$state','Echeckin','AppAPI','GeneralService'];

    /* @ngInject */
    function EcheckinController($localStorage,$window,$state,Echeckin,AppAPI,GeneralService) {
        var vm = this;
        var Profiles=AppAPI.Profiles();
        vm.user = $localStorage.nama;
        vm.Echeckin=Echeckin;
        vm.logout=logout;
        var empID=$localStorage.username;

        loadData();

        function loadData() {
        //    angular.element.blockUI();
           var promises = Profiles.query({action:'checkCompletionData', id:empID});
           promises.$promise.then(fetchData);
           promises.$promise.catch(errorFetch);
        }

        function fetchData(data) {
          console.log(data);
            if(typeof(data[0]) !== 'undefined') {
                vm.check = data[0];
                Echeckin.checkComplete = data[0];
                // console.log(vm.check);
            }
        }

        function errorFetch() {
            vm.check = {};
            angular.element.unblockUI();
        }

        ////////////////

        function logout()
        {
            angular.element.blockUI();

                     var Logout=AppAPI.Logout();
                     var objLogout= new Logout();

                     var promise=objLogout.$logout();
                          promise.then(function(rdata){
                            var resultNum=parseInt(rdata.status);
                            if(resultNum===1)
                            {
                                  GeneralService.clearStorage();
                             // $location.path('/');
                              $state.go('app.login.candidatelogin');
                              angular.element.unblockUI();
                            }else
                            {
                              $window.alert('failed proses logout');
                              angular.element.unblockUI();
                            }
                          },function(){
                             $window.alert('failed proses logout');
                              angular.element.unblockUI();
                          });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.department-business', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.department-business', {
                url: '/department-business',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/department-business/department-business.html',
                        controller: 'DepartmentBusinessController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.department-business')
    .controller('DepartmentBusinessController', DepartmentBusinessController);

  DepartmentBusinessController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function DepartmentBusinessController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.DepartmentBusiness();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.loadDepartment = loadDepartment;
    vm.LoadDivisi = LoadDivisi;
    vm.stateEdit = false;
    vm.requiredDepartpemnt = false;

    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
      loadBusinessTitle();
      LoadCountry();
      LoadCompany();

      vm.listFlag = [
        { 'id': 'sap', 'name': 'STAFF' },
        { 'id': 'hris', 'name': 'General Worker' }
      ];
      vm.listLaborType = [
        { 'id': 'DL', 'name': 'DL' },
        { 'id': 'IDL', 'name': 'IDL' }
      ];
    }

    function LoadCountry() {
      var response = endPoint.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }

    function LoadCompany() {
      var response = endPoint.query({
        action: 'getCompany'
      });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listcompany = data;
    }

    function errorFetchCompany() {
      vm.listcompany = [];
    }

    function LoadDivisi(company) {
      var response = endPoint.query({
        action: 'getDivision',
        company_id: company
      });
      response.$promise.then(fetchDivisi);
      response.$promise.catch(errorFetchDivisi);

      loadBusinessTitle(company);
    }

    function fetchDivisi(data) {
      vm.listdivisi = data;
    }

    function errorFetchDivisi() {
      vm.listdivisi = [];
    }

    function loadDepartment(divisi) {
      vm.requiredDepartpemnt = true;
      var response = endPoint.query({
        action: 'getDepartment',
        idbu: vm.Form.objForm.company_id,
        iddivisi: divisi
      });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorFetchDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
    }

    function errorFetchDepartment() {
      vm.listDepartment = [];
    }

    function loadBusinessTitle() {
      var response = endPoint.query({ action: 'getBusinessTitle' });
      response.$promise.then(fetchBusinessTitle);
      response.$promise.catch(errorFetchBusinessTitle);
    }

    function fetchBusinessTitle(data) {
      vm.listBusinessTitle = data;
    }

    function errorFetchBusinessTitle() {
      vm.listBusinessTitle = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        department: vm.department,
        business_title: vm.business_title,
        flag: vm.flag,
        company_id: vm.Form.objForm.company_id,
        country_id: vm.Form.objForm.country_id,
        labor_type: vm.labor_type
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'DepartmentBusinessInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/department-business/department-business-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'DepartmentBusinessEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/department-business/department-business-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function (resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.department-business')
    .controller('DepartmentBusinessInputController', DepartmentBusinessInputController);

  DepartmentBusinessInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$filter',
    '$http',
    '$element',
    'config'
  ];
  /** @ngInject */
  function DepartmentBusinessInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $filter,
    $http,
    $element,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.DepartmentBusiness();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.loadDepartment = loadDepartment;
    vm.loadBusinessTitle = loadBusinessTitle;
    vm.loadDivision = LoadDivisi;
    vm.loadPositionId = loadPositionId;
    vm.setBt = setBt;
    vm.grade = '';
    vm.listGroupCluster = [];
    vm.listPositionId = [];
    vm.listJobFunction = [];

    activate();

    function activate() {
      vm.listFlag = [
        { 'id': 'sap', 'name': 'STAFF' },
        { 'id': 'hris', 'name': 'General Worker' }
      ];
      vm.listLaborType = [
        { 'id': 'DL', 'name': 'DL' },
        { 'id': 'IDL', 'name': 'IDL' }
      ];
    }

    LoadCountry();
    LoadCompany();

    function LoadCountry() {
      var response = endPoint.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }


    function LoadCompany() {
      var response = endPoint.query({
        action: 'getCompany'
      });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listcompany = data;
    }

    function errorFetchCompany() {
      vm.listcompany = [];
    }

    function LoadDivisi(company) {
      LoadDivisi_(company);
      loadPositionId(company);
      loadBusinessTitle(company);
      loadGroupCluster(vm.Form.objForm.country_id, company);
      loadJobFunction();
    }

    function LoadDivisi_(company) {
      var response = endPoint.query({
        action: 'getDivision',
        company_id: company
      });
      response.$promise.then(fetchDivisi);
      response.$promise.catch(errorFetchDivisi);
    }

    function fetchDivisi(data) {
      vm.listdivisi = data;
    }

    function errorFetchDivisi() {
      vm.listdivisi = [];
    }


    function loadDepartment(company, divisi) {
      var response = endPoint.query({
        action: 'getDepartment',
        idbu: company,
        iddivisi: divisi
      });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorFetchDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
    }

    function errorFetchDepartment() {
      vm.listDepartment = [];
    }

    function loadBusinessTitle(company) {
      var response = endPoint.query({ action: 'getBusinessTitle', company_id: company });
      response.$promise.then(fetchBusinessTitle);
      response.$promise.catch(errorFetchBusinessTitle);
    }

    function fetchBusinessTitle(data) {
      vm.listBusinessTitle = data;
    }

    function errorFetchBusinessTitle() {
      vm.listBusinessTitle = [];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function loadPositionId(company) {
      var response = endPoint.query({
        action: 'getPositionId',
        company_id: company
      });
      response.$promise.then(fetchPositionId);
      response.$promise.catch(errorFetchPositionId);
    }

    function fetchPositionId(data) {
      vm.listPositionId = data;
    }

    function errorFetchPositionId() {
      vm.listPositionId = [];
    }

    function setBt() {
      vm.grade = vm.listBusinessTitle[vm.Form.objForm.business_title_id].grade;
      vm.Form.objForm.grade = vm.grade;
    }

    function loadGroupCluster(country, company) {
      var response = endPoint.query({
        action: 'getGroupCluster',
        country_id: country,
        company_id: company
      });
      response.$promise.then(fetchGroupCluster);
      response.$promise.catch(errorFetchGroupCluster);
    }

    function fetchGroupCluster(data) {
      vm.listGroupCluster = data;
    }

    function errorFetchGroupCluster() {
      vm.listGroupCluster = [];
    }

    function loadJobFunction() {
      var response = endPoint.query({
        action: 'getJobFunction'
      });
      response.$promise.then(fetchJobFunction);
      response.$promise.catch(errorFetchJobFunction);
    }

    function fetchJobFunction(data) {
      vm.listJobFunction = data;
    }

    function errorFetchJobFunction() {
      vm.listJobFunction = [];
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.department-business')
    .controller('DepartmentBusinessEditController', DepartmentBusinessEditController);

  DepartmentBusinessEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$element',
    '$filter'
  ];
  /** @ngInject */
  function DepartmentBusinessEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $element,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.DepartmentBusiness();
    var $translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.loadDepartment = loadDepartment;
    vm.loadBusinessTitle = loadBusinessTitle;
    vm.loadDivision = LoadDivisi;

    vm.loadPositionId = loadPositionId;
    vm.setBt = setBt;
    vm.grade = '';
    vm.listGroupCluster = [];
    vm.listPositionId = [];
    vm.listJobFunction = [];

    activate();

    function activate() {
      vm.listFlag = [
        { 'id': 'sap', 'name': 'STAFF' },
        { 'id': 'hris', 'name': 'General Worker' }
      ];
      vm.listLaborType = [
        { 'id': 'DL', 'name': 'DL' },
        { 'id': 'IDL', 'name': 'IDL' }
      ];

      Form.initialForm();
      Form.setObject(endPoint);

      LoadCountry();
      LoadCompany();
      LoadDivisi(data.company_id);
      loadDepartment(data.division_id, data.company_id);

      loadPositionId(data.company_id);
      loadBusinessTitle(data.company_id);
      loadGroupCluster(data.country_id, data.company_id);
      loadJobFunction();

      vm.Form.objForm.id = data.id
      vm.Form.objForm.country_id = data.country_id
      vm.Form.objForm.company_id = data.company_id
      vm.Form.objForm.division_id = data.division_id
      vm.Form.objForm.department_id = data.department_id
      vm.Form.objForm.business_title_id = data.business_title_id
      vm.Form.objForm.flag = data.flag
      vm.Form.objForm.labor_type = data.labor_type
      vm.Form.objForm.position_id = data.positionID
      vm.Form.objForm.group_cluster = data.group_id
      vm.Form.objForm.grade = data.grade
    }

    function LoadCountry() {
      var response = endPoint.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listcountry = data;
    }

    function errorFetchCountry() {
      vm.listcountry = [];
    }

    function LoadCompany() {
      var response = endPoint.query({
        action: 'getCompany'
      });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listcompany = data;
    }

    function errorFetchCompany() {
      vm.listcompany = [];
    }

    function LoadDivisi(company) {
      var response = endPoint.query({
        action: 'getDivision',
        company_id: company
      });
      response.$promise.then(fetchDivisi);
      response.$promise.catch(errorFetchDivisi);

      loadBusinessTitle(company);
    }

    function fetchDivisi(data) {
      vm.listdivisi = data;
    }

    function errorFetchDivisi() {
      vm.listdivisi = [];
    }

    function loadBusinessTitle(company) {
      var response = endPoint.query({ action: 'getBusinessTitle', company_id: company });
      response.$promise.then(fetchBusinessTitle);
      response.$promise.catch(errorFetchBusinessTitle);
    }

    function fetchBusinessTitle(data) {
      vm.listBusinessTitle = data;
    }

    function errorFetchBusinessTitle() {
      vm.listBusinessTitle = [];
    }

    function loadDepartment(divisi, company) {
      var response = endPoint.query({
        action: 'getDepartment',
        idbu: company,
        iddivisi: divisi
      });
      response.$promise.then(fetchDepartment);
      response.$promise.catch(errorFetchDepartment);
    }

    function fetchDepartment(data) {
      vm.listDepartment = data;
    }

    function errorFetchDepartment() {
      vm.listDepartment = [];
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });


    function loadPositionId(company) {
      var response = endPoint.query({
        action: 'getPositionId',
        company_id: company
      });
      response.$promise.then(fetchPositionId);
      response.$promise.catch(errorFetchPositionId);
    }

    function fetchPositionId(data) {
      vm.listPositionId = data;
    }

    function errorFetchPositionId() {
      vm.listPositionId = [];
    }

    function setBt() {
      vm.grade = vm.listBusinessTitle[vm.Form.objForm.business_title_id].grade;
      vm.Form.objForm.grade = vm.grade;
    }

    function loadGroupCluster(country, company) {
      var response = endPoint.query({
        action: 'getGroupCluster',
        country_id: country,
        company_id: company
      });
      response.$promise.then(fetchGroupCluster);
      response.$promise.catch(errorFetchGroupCluster);
    }

    function fetchGroupCluster(data) {
      vm.listGroupCluster = data;
    }

    function errorFetchGroupCluster() {
      vm.listGroupCluster = [];
    }

    function loadJobFunction() {
      var response = endPoint.query({
        action: 'getJobFunction'
      });
      response.$promise.then(fetchJobFunction);
      response.$promise.catch(errorFetchJobFunction);
    }

    function fetchJobFunction(data) {
      vm.listJobFunction = data;
    }

    function errorFetchJobFunction() {
      vm.listJobFunction = [];
    }

  }
})();
(function () {
    "use strict";

    angular.module("app.dashboard", ["nvd3", "chart.js"]).config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, ChartJsProvider) {
        ChartJsProvider.setOptions({
            chartColors: ["#12d3cf", "#67eaca", "#b0f4e6"],
            responsive: true,
            maintainAspectRatio: false,
        });
        // State
        $stateProvider.state("app.app_dashboard", {
            url: "/dashboard",
            views: {
                "content@app": {
                    templateUrl: "app/main/dashboard/dashboard.html",
                    controller: "DashboardMainController as vm",
                },
            },
            resolve: {
                DashboardData: function (msApi) {
                    return msApi.resolve("dashboard.widget@get");
                },
            },
            bodyClass: "dashboard-main",
        });

        msApiProvider.register("dashboard.widget", [
            "app/data/dashboard/widget.json",
        ]);
    }
})();

(function () {
    "use strict";

    angular
        .module("app.dashboard")
        .controller("DashboardMainController", DashboardMainController);

    /** @ngInject */
    function DashboardMainController(DashboardData) {
        var vm = this;

        var dt = new Date();
        vm.date = moment().format("MMM Do YYYY HH:mm A");

        vm.dashboardData = DashboardData;
        vm.colors = [
            "blue-bg",
            "blue-grey-bg",
            "orange-bg",
            "pink-bg",
            "purple-bg",
        ];

        vm.widget1 = {
            title: vm.dashboardData.widget1.title,
            onlineUsers: vm.dashboardData.widget1.onlineUsers,
            bigChart: {
                options: {
                    chart: {
                        type: "lineWithFocusChart",
                        color: ["#92C9C1"],
                        height: 400,
                        margin: {
                            top: 32,
                            right: 32,
                            bottom: 64,
                            left: 48,
                        },
                        isArea: true,
                        useInteractiveGuideline: true,
                        duration: 1,
                        clipEdge: false,
                        clipVoronoi: true,
                        interpolate: "cardinal",
                        showLegend: false,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        xAxis: {
                            showMaxMin: false,
                            tickFormat: function (d) {
                                var date = new Date(new Date().setDate(d));
                                return d3.time.format("%b %d")(date);
                            },
                        },
                        yAxis: {
                            showMaxMin: true,
                            axisLabel: "Turn Over Rate",
                            orient: "left",
                        },
                        x2Axis: {
                            showMaxMin: false,
                            tickFormat: function (d) {
                                var date = new Date(new Date().setDate(d));
                                return d3.time.format("%b %d")(date);
                            },
                        },
                        y2Axis: {
                            showMaxMin: false,
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: "s",
                                classes: "gravity-s",
                            },
                        },
                        legend: {
                            margin: {
                                top: 8,
                                right: 0,
                                bottom: 32,
                                left: 0,
                            },
                            rightAlign: false,
                        },
                    },
                },
                data: vm.dashboardData.widget1.bigChart.chart,
            },
            sessions: {
                title: vm.dashboardData.widget1.sessions.title,
                value: vm.dashboardData.widget1.sessions.value,
                previous: vm.dashboardData.widget1.sessions.previous,
                options: {
                    chart: {
                        type: "historicalBarChart",
                        color: ["#009688"],
                        height: 40,
                        margin: {
                            top: 4,
                            right: 4,
                            bottom: 4,
                            left: 4,
                        },
                        isArea: true,
                        interpolate: "cardinal",
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        xAxis: {
                            tickFormat: function (d) {
                                var date = new Date(
                                    new Date().setMonth(
                                        1 + d
                                    )
                                );
                                return d3.time.format("%B %Y")(date);
                            },
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: "s",
                                classes: "gravity-s",
                            },
                        },
                    },
                },
                data: vm.dashboardData.widget1.sessions.chart,
            },
            pageviews: {
                title: vm.dashboardData.widget1.pageviews.title,
                value: vm.dashboardData.widget1.pageviews.value,
                previous: vm.dashboardData.widget1.pageviews.previous,
                options: {
                    chart: {
                        type: "historicalBarChart",
                        color: ["#009688"],
                        height: 40,
                        margin: {
                            top: 4,
                            right: 4,
                            bottom: 4,
                            left: 4,
                        },
                        isArea: true,
                        interpolate: "cardinal",
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        xAxis: {
                            tickFormat: function (d) {
                                var date = new Date(
                                    new Date().setMonth(
                                        1 + d
                                    )
                                );
                                return d3.time.format("%B %Y")(date);
                            },
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: "s",
                                classes: "gravity-s",
                            },
                        },
                    },
                },
                data: vm.dashboardData.widget1.pageviews.chart,
            },
            pagesSessions: {
                title: vm.dashboardData.widget1.pagesSessions.title,
                value: vm.dashboardData.widget1.pagesSessions.value,
                previous: vm.dashboardData.widget1.pagesSessions.previous,
                options: {
                    chart: {
                        type: "historicalBarChart",
                        color: ["#009688"],
                        height: 40,
                        margin: {
                            top: 4,
                            right: 4,
                            bottom: 4,
                            left: 4,
                        },
                        isArea: true,
                        interpolate: "cardinal",
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        xAxis: {
                            tickFormat: function (d) {
                                var date = new Date(
                                    new Date().setMonth(
                                        1 + d
                                    )
                                );
                                return d3.time.format("%B %Y")(date);
                            },
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: "s",
                                classes: "gravity-s",
                            },
                        },
                    },
                },
                data: vm.dashboardData.widget1.pagesSessions.chart,
            },
            avgSessionDuration: {
                title: vm.dashboardData.widget1.avgSessionDuration.title,
                value: vm.dashboardData.widget1.avgSessionDuration.value,
                previous: vm.dashboardData.widget1.avgSessionDuration.previous,
                options: {
                    chart: {
                        type: "historicalBarChart",
                        color: ["#009688"],
                        height: 40,
                        margin: {
                            top: 4,
                            right: 4,
                            bottom: 4,
                            left: 4,
                        },
                        isArea: true,
                        interpolate: "cardinal",
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        xAxis: {
                            tickFormat: function (d) {
                                var date = new Date(
                                    new Date().setMonth(
                                        1 + d
                                    )
                                );
                                return d3.time.format("%B %Y")(date);
                            },
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: "s",
                                classes: "gravity-s",
                            },
                        },
                    },
                },
                data: vm.dashboardData.widget1.avgSessionDuration.chart,
            },
        };

        vm.colors = ["#92C9C1", "#F594AF", "#92C9C1"];

        vm.labels = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mei",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        vm.data = [
            [13900, 14200, 14500, 14400, 14710, 0, 0, 0, 0, 0, 0, 0],
            [2000000, 2010000, 2040000, 2035000, 2130000, 0, 0, 0, 0, 0, 0, 0],
        ];
        vm.datasetOverride = [
            {
                label: "Headcount",
                borderWidth: 1,
                type: "bar",
                yAxisID: "y-axis-1",
                display: true,
            },
            {
                label: "Cost",
                borderWidth: 3,
                hoverBackgroundColor: "rgba(255,99,132,0.4)",
                hoverBorderColor: "rgba(255,99,132,1)",
                type: "line",
                yAxisID: "y-axis-2",
                display: true,
                fill: false,
            },
        ];

        vm.options = {
            layout: {
                padding: {
                    left: 20,
                    right: 20,
                    top: 20,
                    bottom: 10,
                },
            },
            scales: {
                yAxes: [
                    {
                        id: "y-axis-1",
                        type: "linear",
                        display: true,
                        position: "left",
                        scaleLabel: {
                            display: true,
                            labelString: "Headcount",
                        },
                    },
                    {
                        id: "y-axis-2",
                        type: "linear",
                        display: true,
                        position: "right",
                        scaleLabel: {
                            display: true,
                            labelString: "Cost",
                        },
                    },
                ],
            },
        };

        vm.listDept = [
            {
                id: "FA",
                title: "Finance Accounting Score",
                standardScore: "80",
                targetScore: 6880,
                currentScore: "4565",
                percentage: 66,
                targetNps: "688",
                detractor: "263",
                passive: "355",
                promoter: "70",
                detractorPercentage: 38,
                passivePercentage: 52,
                promoterPercentage: 10,
                npsScore: -28,
                color: "red",
            },
            {
                id: "HC",
                title: "Human Capital Score",
                standardScore: "50",
                targetScore: 4300,
                currentScore: "2917",
                percentage: 68,
                targetNps: "430",
                detractor: "155",
                passive: "231",
                promoter: "44",
                detractorPercentage: 36,
                passivePercentage: 54,
                promoterPercentage: 10,
                npsScore: -26,
                color: "red",
            },
            {
                id: "Operation",
                title: "Operation Score",
                standardScore: "50",
                targetScore: 4300,
                currentScore: "3170",
                percentage: 74,
                targetNps: "430",
                detractor: "98",
                passive: "238",
                promoter: "94",
                detractorPercentage: 23,
                passivePercentage: 55,
                promoterPercentage: 22,
                npsScore: -1,
                color: "red",
            },
            {
                id: "RISK",
                title: "Risk Management Score",
                standardScore: "40",
                targetScore: 3440,
                currentScore: "2333",
                percentage: 68,
                targetNps: "344",
                detractor: "128",
                passive: "177",
                promoter: "39",
                detractorPercentage: 37,
                passivePercentage: 51,
                promoterPercentage: 11,
                npsScore: -26,
                color: "red",
            },
            {
                id: "GSC",
                title: "GSC Score",
                standardScore: "30",
                targetScore: 2580,
                currentScore: "1882",
                percentage: 73,
                targetNps: "258",
                detractor: "58",
                passive: "160",
                promoter: "40",
                detractorPercentage: 22,
                passivePercentage: 62,
                promoterPercentage: 16,
                npsScore: -6,
                color: "red",
            },
        ];
    }
})();

(function() {
    'use strict';

    angular
        .module('app.hcnews.hc-news')
        .controller('detailCompletenessController', detailCompletenessController);

    detailCompletenessController.$inject = ['$mdDialog','data','param','$localStorage','config','AppAPI','DataService'];

    /* @ngInject */
    function detailCompletenessController($mdDialog,data,param,$localStorage,config,AppAPI,DataService) 
    {
        var vm = this; 

        var Completeness = AppAPI.Completeness();
        vm.closeModal=closeModal;
        vm.listData=data.logReader;

        vm.DataTable = new DataService();
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.loadData = loadData;
        vm.selected = [];
        vm.items = [];

        loadData(1);

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadData()
        {
            var response=Completeness.query({action:'viewDetail',code:data.code,param:param});
            response.$promise.then(fetchData);
            response.$promise.catch(errorFetchData);
        }
        function fetchData(data) {
            vm.listData=data;
        }
        function errorFetchData() {
            vm.listData=[];
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.completeness', [])
        .config(config);

    config.$inject=['$stateProvider'];
    /** @ngInject */
    function config($stateProvider)
    {   
        // State
        $stateProvider
            .state('app.completeness', {
                url    : '/completeness',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/completeness-of-attendance/completeness.html',
                        controller : 'CompletenessController as vm'
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.completeness')
        .controller('CompletenessController', CompletenessController);


    CompletenessController.$inject = ['$state', '$window', '$localStorage', '$location', '$document', '$mdDialog', 'AppAPI', 'DataService', 'config', 'Auth', 'Form'];
    /** @ngInject */
    function CompletenessController($state, $window, $localStorage, $location, $document, $mdDialog, AppAPI, DataService, config, Auth, Form)

    {
        var vm = this;
        Form.initialForm();
        var Completeness = AppAPI.Completeness();
        var Attendancereport = AppAPI.Attendancereport();

        Form.setObject(Completeness);
        vm.Form = Form;
        vm.listJum = [2, 5, 25, 50, 75, 100, 200];
        vm.DataTable = new DataService();
        vm.detailItem = detailItem;
        vm.loadData = loadData;

        vm.closeModal = closeModal;

        vm.listData = [];
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;
        vm.loadBuilding = loadDataBuilding;
        vm.loadSector = loadDataSector;

        vm.company = $localStorage.empsite;
        vm.groupLogin = $localStorage.group;
        vm.user = $localStorage.user;
        vm.divisi = 'all';
        vm.department = 'all';
        vm.divdeptdisabled = false;
        vm.typedisabled = false;
        vm.budisabled = true;
        vm.typeEmp = [{
                "view": "Staff",
                "value": "SAP"
            },
            {
                "view": "General Worker",
                "value": "HRIS"
            }
        ];

        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();

        function loadData() {
            // angular.element.blockUI();
            angular.element('#attendance-completion').block({
                message: 'please wait..'
            });
            var response = Completeness.query({
                action: 'viewData',
                company: vm.company,
                division: vm.divisi,
                department: vm.department,
                subArea: vm.subarea,
                empType: vm.employeeType,
                building: vm.building,
                sector: vm.sector
            });
            response.$promise.then(fetchData);
            response.$promise.catch(errorFetchData);

            vm.param = {
                'company': vm.company,
                'division': vm.divisi,
                'department': vm.department,
                'subArea': vm.subarea,
                'empType': vm.employeeType,
                'building': vm.building,
                'sector': vm.sector
            };
        }

        function fetchData(data) {
            // angular.element.unblockUI();
            angular.element('#attendance-completion').unblock();
            vm.listData = data;
        }

        function errorFetchData() {
            // angular.element.unblockUI();
            angular.element('#attendance-completion').unblock();
            vm.listData = [];
        }

        function detailItem(item, param) {
            $mdDialog.show({
                controller: 'detailCompletenessController',
                controllerAs: 'vm',
                templateUrl: 'app/main/completeness-of-attendance/view-detail.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    // loadData();
                },
                locals: {
                    data: item,
                    param: param
                }
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        /** -load department- */
        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        /** -load division- */
        function loadDataDivision(idbu) {
            var response = Attendancereport.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        /** -load business unit- */
        function loadDataBU() {
            var response = Attendancereport.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;
        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        /** -load sub area- */
        function loadSubArea() {
            var response = Attendancereport.query({
                action: 'viewSubArea'
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
            // vm.subArea=vm.subArea.slice(0, -1);
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        /** -load building- */
        function loadDataBuilding(subAreaId) {
            var response = Completeness.query({
                action: 'viewBuilding',
                subAreaId: subAreaId
            });
            response.$promise.then(fetchBuilding);
            response.$promise.catch(errorFetchBuilding);
        }

        function fetchBuilding(data) {
            vm.listBuilding = data;
        }

        function errorFetchBuilding() {
            vm.listBuilding = [];
        }

        /** -load sector- */
        function loadDataSector(buildingId) {
            var response = Completeness.query({
                action: 'viewSector',
                buildingId: buildingId
            });
            response.$promise.then(fetchSector);
            response.$promise.catch(errorFetchSector);
        }

        function fetchSector(data) {
            vm.listSector = data;
        }

        function errorFetchSector() {
            vm.listSector = [];
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.changepassword', [])
        .config(config);

         config.$inject=['$stateProvider'];

    /** @ngInject */
   /** @ngInject */
   function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.changepassword', {
                url    : '/changepassword',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/changepassword/changepassword.html',
                        controller : 'ChangepasswordController as vm'
                    }
                }
            });

       
        

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.changepassword')
        .controller('ChangepasswordController',ChangepasswordController);


    ChangepasswordController.$inject=['$state','$resource','$mdDialog','Auth','AppAPI','config','GeneralService','$localStorage','$timeout','Form'];
    /** @ngInject */
    function ChangepasswordController($state,$resource,$mdDialog,Auth,AppAPI,config,GeneralService,$localStorage,$timeout,Form)
    {
        
        var vm = this; 
        vm.username=$localStorage.user;
        vm.Breadhome="app";
        vm.Breadlist=[ 
                    {link:'#',name:'',active:'0'}
                    ];

        var Changepassword=  AppAPI.Changepassword();
        vm.pass=new Changepassword();
         // set constructor form
         Form.setObject(Changepassword);

         // set form to controller
         vm.Form = Form;
         
         vm.saveDataPass=saveDataPass;

        vm.clearMeesage=clearMeesage;

        function saveDataPass(ev) {

            vm.pass.username=vm.username;
            if(vm.pass.password==vm.pass.passwordConfirm){
                    angular.element.blockUI();
                    vm.event=ev;
                    vm.pass.appID=config.appID;
                    var promise= vm.pass.$save();
                    promise.then(Success,Failed);

            }else{
                $mdDialog.show(
                $mdDialog.alert()
                .textContent('Password Not Match!')
                 .ok('OK')
                 );  
            }

        }

        function clearMeesage() {
            vm.Form.tampilPesan=false;
        }
            

        function closeDialogPass()
         {
            $mdDialog.hide();
            logout();
         }

        

        function Failed (rdata) {
            vm.wrongCredentials=true;
            vm.pesan=rdata.data.pesan;
            angular.element.unblockUI();
            Auth.setToken();
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.querySelector('#reset-password')))
                .clickOutsideToClose(true)
                .title('Error Change Pasword')
                .textContent(vm.pesan)
                .ariaLabel('Error Change Pasword')
                .ok('Got it!')
                .targetEvent(vm.event)
            );
        }

     function Success() {
        angular.element.unblockUI();
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Success Change Password')
            .textContent('Process Change Password was Success. Please login again')
            .ariaLabel('Success Change Password')
            .ok('OK')
            .targetEvent()
        ).then(function(){
            closeDialogPass();
        });
    }

    function logout()
        {
            angular.element.blockUI();
            
                     var Logout=AppAPI.Logout();
                     var objLogout= new Logout();

                     var promise=objLogout.$logout();
                          promise.then(function(rdata){
                            var resultNum=parseInt(rdata.status);
                            if(resultNum===1)
                            {
                                  GeneralService.clearStorage();
                             // $location.path('/');
                              $state.go('app.login.main');
                              angular.element.unblockUI();
                            }else
                            {
                              $window.alert('failed proses logout');
                              angular.element.unblockUI();
                            }
                          },function(){
                             $window.alert('failed proses logout');
                              angular.element.unblockUI();
                          });
        }
  

    }
})();

(function ()
{
    'use strict';
 
    angular
        .module('app.ceo-dashboard', [])
        .config(config);

    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider,menuProvider)
    {

         // State
        $stateProvider
            .state('app.ceo_dashboard', {
                url    : '/ceo-dashboard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/ceo-dashboard/ceo-dashboard.html',
                        controller:'CeodashboardController as vm'
                    }
                }
            }); 
        // Navigation
        // msNavigationServiceProvider.saveItem('ceo-dashboard', {
        //     title : 'Dashboard',
        //     icon :'icon-tile-four', 
        //     group : false,
        //     state:'app.ceo_dashboard',
        //     weight: 1,
        //     hidden:function(){return menuProvider.checkRule('0');}
        // });

      
    } 
})();
(function ()
{
    'use strict';

    angular
        .module('app.ceo-dashboard')
        .controller('CeodashboardController', CeodashboardController);


     CeodashboardController.$inject=['AppAPI','DataService'];
    /** @ngInject */
    function CeodashboardController(AppAPI,DataService)
    {
        
        var vm =this;
      var Division = AppAPI.Division();
      var Kpi = AppAPI.Kpi();
      vm.viewDataDivision=viewDataDivision;
      
      
      var responseDivision=Kpi.query({action:'viewDivision'});
      responseDivision.$promise.then(fetchDivision);
      responseDivision.$promise.catch(errorFetchDivision);

       loadDataPa();
      function loadDataPa() {
        angular.element('#allChart').block();
         var response=Kpi.get({action:'viewAllChart',id:'all',type:'group'});
         response.$promise.then(fetchDataAllChart);
         response.$promise.catch(errorFetchDataAllChart);
      }

      function fetchDataAllChart(data) {
           vm.dataMutu= [data.mutu1];
           vm.dataAdj1=[data.adj1];
            vm.dataAdj2=[data.adj2];
            vm.dataAll=[data.mutu1,data.adj1,data.adj2];
        var ticks = data.tick;
        vm.optionsBadj={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2={
           title:'After Adjustment 2',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

        vm.optionsAadjAll={
           title:'After Adjustment 2',
           seriesColors:['#E91E63','#FF9800','#4CAF50'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                }
            }
        };

          angular.element('#allChart').unblock();
      }

     var s1 = [2, 6, 7, 10];
        var s2 = [7, 5, 3, 2];
         var ticks = ['a', 'b', 'c', 'd'];
      vm.dataKpi=[
       [
        [25,1], [25,2], [25,3], [25,4]
       ],
       [
        [25,1], [25,2], [25,3], [25,4]
       ],
       [
        [0,1], [25,2], [25,3], [25,4]
       ],
       [
        [0,1], [25,2], [20,3], [25,4]
       ],
        [
        [0,1], [10,2], [0,3], [8,4]
       ]
      ];
      vm.optionsKpi={
         stackSeries: true,
            captureRightClick: true,
             seriesColors:['#F44336','#FFEB3B','#CDDC39','#8BC34A','#4CAF50','#E91E63'],
            seriesDefaults:{
                renderer:$.jqplot.BarRenderer,
                shadowAngle: 135,
               
                rendererOptions: {
                    barDirection: 'horizontal',
                     barMargin:25,
                    highlightMouseDown: true   
                },
                pointLabels: {show: false, formatString: '%d'+' %'}
            },
            legend: {
                show: true,
                location: 'e',
                placement: 'inside'
            },
            axes: {
                yaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer
                },
                pad:5
            },
            series:[
                {label:'below 25%'},
                 {label:'below 50%'},
                  {label:'below 75%'},
                   {label:'below 100%'},
                    {label:'above 100%'}
            ]
      };

      var gw1=[
             ['2016-01-01',600],
             ['2016-02-01',589],
             ['2016-03-01',570],
             ['2016-04-01',560],
             ['2016-05-01',586],
             ['2016-06-01',602],
             ['2016-07-01',612],
             ['2016-08-01',580],
             ['2016-09-01',590],
             ['2016-10-01',570],
             ['2016-11-01',560],
             ['2016-12-01',590]
             ];
       var gw2=[
             ['2016-01-01',400],
             ['2016-02-01',410],
             ['2016-03-01',390],
             ['2016-04-01',410],
             ['2016-05-01',400],
             ['2016-06-01',400],
             ['2016-07-01',390],
             ['2016-08-01',385],
             ['2016-09-01',395],
             ['2016-10-01',395],
             ['2016-11-01',402],
             ['2016-12-01',402]
             ];   
         var gs=[
             ['2016-01-01',310],
             ['2016-02-01',310],
             ['2016-03-01',290],
             ['2016-04-01',310],
             ['2016-05-01',300],
             ['2016-06-01',300],
             ['2016-07-01',290],
             ['2016-08-01',285],
             ['2016-09-01',295],
             ['2016-10-01',295],
             ['2016-11-01',302],
             ['2016-12-01',302]
             ]; 
         var sh=[
             ['2016-01-01',110],
             ['2016-02-01',110],
             ['2016-03-01',90],
             ['2016-04-01',110],
             ['2016-05-01',100],
             ['2016-06-01',100],
             ['2016-07-01',90],
             ['2016-08-01',85],
             ['2016-09-01',95],
             ['2016-10-01',95],
             ['2016-11-01',90],
             ['2016-12-01',90]
             ];  
        var dh=[
             ['2016-01-01',40],
             ['2016-02-01',41],
             ['2016-03-01',44],
             ['2016-04-01',44],
             ['2016-05-01',40],
             ['2016-06-01',40],
             ['2016-07-01',40],
             ['2016-08-01',41],
             ['2016-09-01',42],
             ['2016-10-01',42],
             ['2016-11-01',42],
             ['2016-12-01',42]
             ];                   
                      

           vm.dataHc=[gw1,gw2,gs,sh,dh];
           vm.HcOption={
          
      axes:{
        xaxis:{
          renderer:$.jqplot.DateAxisRenderer, 
          tickOptions:{formatString:'%b-%y'},
          tickInterval:'1 month'
        }
      },
      seriesDefaults: {
          rendererOptions: {
              smooth: true
          }},
      series:[
          {lineWidth:4, markerOptions:{style:'square'},label:'General Worker 1'},
           {lineWidth:4, markerOptions:{style:'diamond'},label:'General Worker 2'},
           {lineWidth:4, markerOptions:{style:'x'},label:'General Staff'},
             {lineWidth:4, markerOptions:{style:'circle'},label:'Section Head'},
             {lineWidth:4, markerOptions:{style:'filledSquare'},label:'Department Head'}
          ],
      highlighter: {
         sizeAdjust: 10,
         tooltipLocation: 'n',
         tooltipAxes: 'y',
         show:true,
         tooltipFormatString: ' %.2f',
         useAxesFormatters: false
     },
     cursor: {
         show: true
     },
     legend: {
                show: true,
                location: 'e',
                placement: 'outside'
            }
           };  

        vm.dataHcMovement=[[1460,621,23,5,-4,-32,-3,-120,-518,-6]];
        var thickMovement=[
        'HC Dec 2015',
        'Recruitment',
        'Intra-Group transfer IN',
        'International Assigment IN',
        'Dismissal',
        'Intra-Group transfer OUT',
        'Retirement',
        'Resignation',
        'Other Departures',
        'International Assigment OUT',
        'HC Dec 2016'];   

     //  vm.dataHcMovement = [[14, 0, 13, 0, -5, -9, 3, 7]];
     // thickMovement = ['2008', 'Apricots', 'Tomatoes', 'Potatoes', 'Rhubarb', 'Squash', 'Grapes', 'Peanuts', '2009'];
       vm.HcOptionMovement={
        seriesColors:['#4CAF50','#03A9F4','#03A9F4','#03A9F4','#F44336','#F44336','#F44336','#F44336','#F44336','#F44336','#4CAF50'],
        seriesDefaults:{
            renderer:$.jqplot.BarRenderer,  
            rendererOptions:{
                waterfall:true,
                varyBarColor: true,
                 useNegativeColors:false
            },
            pointLabels: {
                show: true,
                hideZeros: false
            },
            yaxis:'y2axis'
        },
        axes:{
            xaxis:{
                renderer:$.jqplot.CategoryAxisRenderer, 
                ticks:thickMovement,
                tickRenderer: $.jqplot.CanvasAxisTickRenderer,
                tickOptions: {
                    angle: 45,
                    fontSize: '10pt',
                    showMark: false,
                    showGridline: true
                }
            }
        }
       };
      function errorFetchDataAllChart() {
        angular.element('#allChart').unblock();
      }

      function fetchDivision(data) {
        vm.listDivision=data;
      }

      function errorFetchDivision() {
        vm.listDivision=[];
      }

      function viewDataDivision(id,name) {
        angular.element('#chartPaByDIvision').block();
        vm.DivisionName=name;
        var response=Kpi.get({action:'viewAllChart',id:id,type:'group'});
         response.$promise.then(fetchDataDivisionChart);
         response.$promise.catch(errorFetchDataDivisionChart);
      }

      function fetchDataDivisionChart(data) {
         vm.dataMutuDiv= [data.mutu1];
           vm.dataAdj1Div=[data.adj1];
            vm.dataAdj2Div=[data.adj2];
        var ticks = data.tick;
        vm.optionsBadjDiv={
          title:'Before Adjustment',
           seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                  max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj1Div={
           title:'After Adjustment 1',
            seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };

         vm.optionsAadj2Div={
           title:'After Adjustment 2',
          seriesColors:['#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#E91E63'],
            seriesDefaults: {
                renderer:$.jqplot.BarRenderer,
                pointLabels: { show: true },
                rendererOptions: {
                // Set varyBarColor to tru to use the custom colors on the bars.
                varyBarColor: true
            }
            },
            axes: {
                xaxis: {
                    renderer: $.jqplot.CategoryAxisRenderer,
                    ticks: ticks
                },
                yaxis:{
                  min:0,
                   max:data.max,
                  tickInterval:data.interval
                }
            }
        };
          angular.element('#chartPaByDIvision').unblock();
        
      }

      function errorFetchDataDivisionChart(data) {
       angular.element('#chartPaByDIvision').unblock();
      }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.assessment', ['app.assessment.assessment-detail'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.assessment', {
                url    : '/assessment',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/assessment/assessment.html',
                        controller : 'AssessmentController as vm'
                    }
                }
            });

       
        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/assessment');

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.assessment')
        .controller('AssessmentController', AssessmentController);


    AssessmentController.$inject=['DataService','$state','$localStorage','AppAPI','DTColumnDefBuilder','$mdDialog'];
    /** @ngInject */
    function AssessmentController(DataService,$state,$localStorage,AppAPI,DTColumnDefBuilder,$mdDialog)
    {
        
        var vm                = this;
        var Assessment        = AppAPI.Assessment();
        vm.listJum            = [2,5,25,50,75,100,200];
        vm.username           = $localStorage.nama;
        vm.user               = $localStorage.user;
        vm.setView            = setView;
        vm.loadData           = loadData;
        vm.icon               = "icon-plus";
        vm.result             = false;
        vm.visibleSubChild    = [];
        vm.DataTable          = new DataService();
        vm.loadDataDivision   = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;

        loadData(1);
        loadDataBU();


        function loadData(pageno) {          

            vm.DataTable.loadData(Assessment,pageno,{action:'viewData',bu:vm.bu,divisi:vm.divisi,department:vm.department});
             angular.element.unblockUI(); 

        }

        function loadDataBU() {
            var response=Assessment.query({action:'viewBu'});
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBu=data;

            // if(vm.group === '110' || vm.group === '116') {
            //     vm.bu = vm.empsite;
            //     loadDataDivision(vm.bu);
            // }

        }

        function errorFetchBU() {
            vm.listBu=[];
            angular.element.unblockUI(); 
        }

        function loadDataDivision(idbu) {

            vm.divisi='';
            vm.department='';
            var response=Assessment.query({action:'viewDivisiBu',idbu:idbu});
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
           vm.listDivisi=data;
           vm.listDepartment=[];
           loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivisi=[];
            angular.element.unblockUI(); 
        }

        function loadDataDepartment(iddivisi) {
            vm.department='';
            var response=Assessment.query({action:'viewDivisiDept',idbu:vm.bu,iddivisi:iddivisi});
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment=data;
            loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment=[];
            angular.element.unblockUI(); 
        }

        function setView(nik) {
            $state.go('app.assessment_detail',{id:nik});
        }

        
    }
})();

(function () {
    'use strict';

    angular
        .module('app.bank-ops-transfer', ['ui.tinymce'])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.bank_ops_transfer', {
                url: '/bank-ops-transfer',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/bank-ops-transfer/bot.html',
                        controller: 'BankOpsTransferController as vm'
                    }
                }
            });
    }
})();

(function() {
  'use strict';
  angular
    .module('app.bank-ops-transfer')
    .controller('BankOpsTransferController', BankOpsTransferController);

  BankOpsTransferController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth', 
    '$q',
    'filterFilter',
    'config',
    '$filter',
    '$http',
    'FileUploader'
  ];
  /** @ngInject */
  function BankOpsTransferController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth, 
    $q,
    filterFilter,
    config,
    $filter,
    $http,
    FileUploader
  ) {
    var vm = this;
    var endPoint = AppAPI.BankOpsTransfer();
    var $translate = $filter('translate');
    
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData; 
    vm.selectedItem = null;
    vm.searchText = null;
    vm.listNC = []; 
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.company=$localStorage.empsite;
    activate();

    function activate() {
      vm.selected = [];
      loadData(1);
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData'
      });

      resp.then(function(data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'BankOpsTransferInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/bank-ops-transfer/bot-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function(element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function editData(ev, data) {
      $mdDialog.show({
        controller: 'BankOpsTransferEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/bank-ops-transfer/bot-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function() {
          loadData(1);
        },
        locals: {
          data : data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note    = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes     = $translate('PAYROLL.MESSAGE.YES');
      var no      = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function() {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function() {
            var data = [];
            for (var index = 0; index < vm.selected.length; index++) {
              data.push(vm.selected[index].id);
            }
            angular.element.blockUI();
            var response = endPoint.delete({
              action: 'delete',
              data: angular.toJson(data)
            });
            response.$promise.then(function(resp) {
              dialogClose();
              angular.element.unblockUI();
              showDialogInfo(ev, resp);
            });
          },
          function() {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('app.bank-ops-transfer')
    .controller('BankOpsTransferInputController', BankOpsTransferInputController);

  BankOpsTransferInputController.$inject = [
    '$document',
    'DataService',
    '$state',
    '$mdDialog',
    '$localStorage',
    '$window',
    '$timeout',
    'AppAPI',
    'Auth',
    'Form',
    'filterFilter',
    '$filter',
    'FileUploader',
    'config'
  ];
  /** @ngInject */
  function BankOpsTransferInputController(
    $document,
    DataService,
    $state,
    $mdDialog,
    $localStorage,
    $window,
    $timeout,
    AppAPI,
    Auth,
    Form,
    filterFilter,
    $filter,
    FileUploader,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.BankOpsTransfer();
    var $translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    Form.initialForm();
    Form.setObject(endPoint); 
    vm.dialogClose = dialogClose;
    vm.saveData=saveData;
    
    activate();

    function activate() {
      vm.selected = []; 
    }

    loadArea();

    function loadArea() {
          var response=endPoint.query({action:'getArea'});
          response.$promise.then(fetchArea);
          response.$promise.catch(errorFetchArea);
    }
    
    function fetchArea(data) {
          vm.areaList=data;
    }

    function errorFetchArea() {
          vm.areaList=[];
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function(data) {
          angular.element.unblockUI();
          frm.$setPristine(); 
          showDialogInfo(ev, data);
      });

      response.catch(function(data) {
          angular.element.unblockUI();
          frm.$setPristine();
          showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status  = $translate(data.status);

      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function() {
          dialogClose();
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }
  }
})();

(function() {
    'use strict';
    angular
      .module('app.bank-ops-transfer')
      .controller('BankOpsTransferEditController', BankOpsTransferEditController);
  
    BankOpsTransferEditController.$inject = [
      'DataService',
      '$state',
      '$mdDialog',
      '$localStorage',
      '$window',
      '$timeout',
      'AppAPI',
      'Auth',
      'Form',
      'data',
      'config',
      '$filter',
      'FileUploader'
    ];
    /** @ngInject */
    function BankOpsTransferEditController(
      DataService,
      $state,
      $mdDialog,
      $localStorage,
      $window,
      $timeout,
      AppAPI,
      Auth,
      Form,
      data,
      config,
      $filter,
      FileUploader
    ) {
      var vm = this;
      var endPoint = AppAPI.BankOpsTransfer();
      var $translate = $filter('translate');

      vm.Form = Form;
      vm.info = data;
      vm.saveData = updateData;
      vm.dialogClose = dialogClose;
      vm.company=$localStorage.empsite;

      activate();

      loadArea();

      function loadArea() {
            var response=endPoint.query({action:'getArea'});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
      }
      
      function fetchArea(data) {
            vm.areaList=data;
      }

      function errorFetchArea() {
            vm.areaList=[];
      }
      
      function activate() 
      {
        Form.initialForm();
        Form.setObject(endPoint);

        vm.Form.objForm.id=data.id;
        vm.Form.objForm.sub_area_id=data.sub_area_id;
        vm.Form.objForm.rekening_number=data.rekening_number;
        vm.Form.objForm.effective_date= new Date(data.effective_date);
      }
      
      function updateData(ev, frm) 
      {
        angular.element.blockUI();
        var response = Form.saveData('update', frm, endPoint);
        response.then(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();

            showDialogInfo(ev, data);
        });
  
        response.catch(function(data) {
            angular.element.unblockUI();
            frm.$setPristine();
            showDialogInfo(ev, data);
        });
      }
  
      function showDialogInfo(ev, data) {
        var message = $translate(data.pesan);
        var status  = $translate(data.status);
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('#contentDialog')))
              .clickOutsideToClose(true)
              .title(status)
              .textContent(message)
              .ariaLabel(status)
              .ok('OK')
              .targetEvent(ev)
          )
          .then(function() {
            dialogClose();
          });
      }
  
      function dialogClose() {
        $mdDialog.hide();
      }
    }
  })();
  
(function () {
    'use strict';

    angular
        .module('app.application-admin', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.application-admin', {
                url: '/application-admin',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/application-admin/application-admin.html',
                        controller: 'ApplicationAdminController as vm'
                    }
                }
            });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.application-admin')
    .controller('ApplicationAdminController', ApplicationAdminController);

  ApplicationAdminController.$inject = [
    '$document',
    'DataService',
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Auth',
    'config',
    '$filter',
    '$http',
    'Form',
    '$element'
  ];
  /** @ngInject */
  function ApplicationAdminController(
    $document,
    DataService,
    $mdDialog,
    $localStorage,
    AppAPI,
    Auth,
    config,
    $filter,
    $http,
    Form,
    $element
  ) {
    var vm = this;
    var endPoint = AppAPI.ApplicationAdmin();
    var $translate = $filter('translate');
    Form.setObject(endPoint);
    vm.Form = Form;
    vm.DataTables = new DataService();
    vm.listJum = [2, 5, 25, 50, 75, 100, 200];
    vm.loadData = loadData;
    vm.selected = [];
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.items = [];
    vm.addData = addData;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.editData = editData;
    vm.deleteData = deleteData;
    vm.dialogClose = dialogClose;
    vm.viewDetail = viewDetail;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.stateEdit = false;
    vm.getArea = loadArea;

    activate();

    function activate() {
      vm.selected = [];
      loadArea();
      loadAdminType();
    }

    function loadAdminType() {
      var response = endPoint.query({
        action: 'getAdminType'
      });
      response.$promise.then(fetchAdminType);
      response.$promise.catch(errorFetchAdminType);
    }

    function fetchAdminType(data) {
      vm.listAdminType = data;
    }

    function errorFetchAdminType() {
      vm.listAdminType = [];
    }

    function loadArea() {
      var response = endPoint.query({ action: 'getArea', company: vm.company });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listArea = data;
    }

    function errorFetchArea() {
      vm.listArea = [];
    }

    function loadData(pageno) {
      var resp = vm.DataTables.loadData(endPoint, pageno, {
        action: 'viewData',
        adminType: vm.admin_type
      });

      resp.then(function (data) {
        vm.selected = [];
        vm.items = data.list;
      });
    }

    function addData(ev) {
      $mdDialog.show({
        controller: 'ApplicationAdminInputController',
        controllerAs: 'vm',
        templateUrl: 'app/main/application-admin/application-admin-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function viewDetail(ev, data) {
      $mdDialog.show({
        controller: 'viewApplicationAdmintDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/main/application-admin/view-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        fullscreen: true,
        onRemoving: function (element, removePromise) {
          loadData(1);
        },
        locals: {
          data: data
        }
      });
    }

    function editData(ev, data) {
      data.admin_type = vm.admin_type;
      $mdDialog.show({
        controller: 'ApplicationAdminEditController',
        controllerAs: 'vm',
        templateUrl: 'app/main/application-admin/application-admin-input.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        onRemoving: function () {
          loadData(1);
        },
        locals: {
          data: data
        },
        clickOutsideToClose: true,
        fullscreen: true // Only for -xs, -sm breakpoints.
      });
    }

    function deleteData(ev) {
      var message = $translate('PAYROLL.MESSAGE.CONFDEL');
      var note = $translate('PAYROLL.MESSAGE.DELNOTE');
      var yes = $translate('PAYROLL.MESSAGE.YES');
      var no = $translate('PAYROLL.MESSAGE.NO');

      var promise = Auth.setToken();
      promise.then(function () {
        var confirm = $mdDialog
          .confirm()
          .title(message)
          .textContent(note)
          .ariaLabel('delete dialog')
          .targetEvent(ev)
          .ok(yes)
          .cancel(no);

        $mdDialog.show(confirm).then(
          function () {
            var objForm = new endPoint();
            objForm.data = vm.selected;
            objForm.action = 'delete';
            objForm.adminType = vm.admin_type;

            var response = objForm.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data)
            });
            response.catch(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data)
            });
          },
          function () {
            // $scope.status = 'You decided to keep your debt.';
          }
        );
      });
    }

    function showDialogInfo(ev, data) {
      var message = $translate(data.pesan);
      var status = $translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function toggle(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return vm.selected.length !== 0 && vm.selected.length !== vm.items.length;
    }

    function isChecked() {
      return vm.selected.length === vm.items.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.items.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.items.slice(0);
      }
    }

    vm.clearSearchTerm = function () {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/emphcticket?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.application-admin')
    .controller('ApplicationAdminInputController', ApplicationAdminInputController);

  ApplicationAdminInputController.$inject = [
    '$mdDialog',
    'AppAPI',
    'Form',
    '$localStorage',
    '$filter',
    '$http',
    'config'
  ];
  /** @ngInject */
  function ApplicationAdminInputController(
    $mdDialog,
    AppAPI,
    Form,
    $localStorage,
    $filter,
    $http,
    config
  ) {
    var vm = this;
    var endPoint = AppAPI.ApplicationAdmin();
    var AdminDepartment = AppAPI.AdminDepartment();
    var Completeness = AppAPI.Completeness();

    var translate = $filter('translate');

    vm.selectedItem = null;
    vm.searchText = null;
    vm.Form = Form;
    vm.isSector = false;
    Form.initialForm();
    Form.setObject(endPoint);
    vm.dialogClose = dialogClose;
    vm.saveData = saveData;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.loadArea = loadArea;
    vm.setIsDisabled = setIsDisabled;
    vm.loadGroupShift = loadGroupShift;
    vm.getListGedung = getListGedung;
    vm.getListSector = getListSector;
    vm.isSectorStatus = isSectorStatus;
    vm.isHasSelectType = true;

    activate();

    function isSectorStatus(param) {
      if (param == "all") {
        vm.isSector = false;
      } else {
        vm.isSector = true;
      }
    }

    function getListGedung(subareaId) {
      var response = AdminDepartment.query({ action: 'getSelectListGedung', sub_area_id: subareaId });
      response.$promise.then(fetchGedung);
      response.$promise.catch(errorFetchGedung);
    }

    function fetchGedung(data) {
      vm.listGedung = data;
    }

    function errorFetchGedung() {
      vm.listGedung = [];
    }

    function getListSector(buildingId) {
      angular.element.blockUI();
      var resp = Completeness.query({ action: 'viewSector', buildingId: buildingId });
      resp.$promise.then(function (data) {
        vm.listSector = data
        vm.Form.objForm.sector_id = 'all';
        angular.element.unblockUI();
      });
      resp.$promise.catch(function (data) {
        vm.listSector = []
        angular.element.unblockUI();
      });
    }

    function setIsDisabled(adminType) {
      if (typeof adminType != 'undefined') {
        vm.isHasSelectType = false
      }
    }

    function LoadCountry() {
      var response = endPoint.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listCountry = data;
    }

    function errorFetchCountry() {
      vm.listCountry = [];
    }

    function loadAdminType() {
      var response = endPoint.query({
        action: 'getAdminType'
      });
      response.$promise.then(fetchAdminType);
      response.$promise.catch(errorFetchAdminType);
    }

    function fetchAdminType(data) {
      vm.listAdminType = data;
    }

    function errorFetchAdminType() {
      vm.listAdminType = [];
    }

    function LoadCompany() {
      var response = endPoint.query({
        action: 'getCompany'
      });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listCompany = data;
    }

    function errorFetchCompany() {
      vm.listCompany = [];
    }

    function loadArea(company) {
      var response = endPoint.query({
        action: 'getArea',
        company: company,
      });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listArea = data;
    }

    function errorFetchArea() {
      vm.listArea = [];
    }

    function loadGroupShift(area) {
      var response = endPoint.query({
        action: 'getGroupShift',
        area: area
      });
      response.$promise.then(fetchGroupShift);
      response.$promise.catch(errorFetchGroupShift);

      getListGedung(area);
    }

    function fetchGroupShift(data) {
      vm.listGroupShift = data;
    }

    function errorFetchGroupShift() {
      vm.listGroupShift = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined' && employee) {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      vm.selected = [];
      loadAdminType();
      LoadCountry();
      LoadCompany();
    }

    function saveData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('save', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/applicationadmin?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.application-admin')
    .controller('ApplicationAdminEditController', ApplicationAdminEditController);

  ApplicationAdminEditController.$inject = [
    '$mdDialog',
    '$localStorage',
    'AppAPI',
    'Form',
    'data',
    '$http',
    'config',
    '$filter'
  ];
  /** @ngInject */
  function ApplicationAdminEditController(
    $mdDialog,
    $localStorage,
    AppAPI,
    Form,
    data,
    $http,
    config,
    $filter
  ) {
    var vm = this;
    var endPoint = AppAPI.ApplicationAdmin();
    var AdminDepartment = AppAPI.AdminDepartment();
    var Completeness = AppAPI.Completeness();
    var translate = $filter('translate');

    vm.Form = Form;
    vm.info = data;
    vm.saveData = updateData;
    vm.dialogClose = dialogClose;
    vm.company = $localStorage.empsite;
    vm.selectedItemChanged = selectedItemChanged;
    vm.getEmployee = getEmployee;
    vm.isSector = false;
    vm.setIsDisabled = setIsDisabled;
    vm.loadGroupShift = loadGroupShift;
    vm.getListGedung = getListGedung;
    vm.getListSector = getListSector;
    vm.isSectorStatus = isSectorStatus;
    vm.isHasSelectType = false;

    activate();

    function isSectorStatus(param) {
      if (param == "all") {
        vm.isSector = false;
      } else {
        vm.isSector = true;
      }
    }

    function getListGedung(subareaId) {
      var response = AdminDepartment.query({ action: 'getSelectListGedung', sub_area_id: subareaId });
      response.$promise.then(fetchGedung);
      response.$promise.catch(errorFetchGedung);
    }

    function fetchGedung(data) {
      vm.listGedung = data;
    }

    function errorFetchGedung() {
      vm.listGedung = [];
    }

    function getListSector(buildingId) {
      angular.element.blockUI();
      var resp = Completeness.query({ action: 'viewSector', buildingId: buildingId });
      resp.$promise.then(function (data) {
        vm.listSector = data
        vm.Form.objForm.sector_id = 'all';
        angular.element.unblockUI();
      });
      resp.$promise.catch(function (data) {
        vm.listSector = []
        angular.element.unblockUI();
      });
    }

    function setIsDisabled(adminType) {
      if (typeof adminType != 'undefined') {
        vm.isHasSelectType = false
      }
    }

    function LoadCountry() {
      var response = endPoint.query({
        action: 'getCountry'
      });
      response.$promise.then(fetchCountry);
      response.$promise.catch(errorFetchCountry);
    }

    function fetchCountry(data) {
      vm.listCountry = data;
      angular.element.unblockUI();
    }

    function errorFetchCountry() {
      vm.listCountry = [];
      angular.element.unblockUI();
    }

    function loadAdminType() {
      var response = endPoint.query({
        action: 'getAdminType'
      });
      response.$promise.then(fetchAdminType);
      response.$promise.catch(errorFetchAdminType);
    }

    function fetchAdminType(data) {
      vm.listAdminType = data;
    }

    function errorFetchAdminType() {
      vm.listAdminType = [];
    }

    function LoadCompany() {
      var response = endPoint.query({
        action: 'getCompany'
      });
      response.$promise.then(fetchCompany);
      response.$promise.catch(errorFetchCompany);
    }

    function fetchCompany(data) {
      vm.listCompany = data;
    }

    function errorFetchCompany() {
      vm.listCompany = [];
    }

    function loadArea(company) {
      var response = endPoint.query({
        action: 'getArea',
        company: company,
      });
      response.$promise.then(fetchArea);
      response.$promise.catch(errorFetchArea);
    }

    function fetchArea(data) {
      vm.listArea = data;
    }

    function errorFetchArea() {
      vm.listArea = [];
    }

    function loadGroupShift(area) {
      var response = endPoint.query({
        action: 'getGroupShift',
        area: area
      });
      response.$promise.then(fetchGroupShift);
      response.$promise.catch(errorFetchGroupShift);

      getListGedung(area);
    }

    function fetchGroupShift(data) {
      vm.listGroupShift = data;
    }

    function errorFetchGroupShift() {
      vm.listGroupShift = [];
    }

    function selectedItemChanged(employee) {
      vm.Form.objForm.empno = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.empno = employee.empno;
        vm.Form.objForm.fullname = employee.fullname
        vm.isDisabled = true;

      }
    }

    function activate() {
      loadAdminType();
      LoadCountry();
      LoadCompany();
      loadArea(data.company);
      getListGedung(data.sub_area)
      getListSector(data.gedung_id)
      loadGroupShift(data.sub_area)

      Form.initialForm();
      Form.setObject(endPoint);

      vm.Form.objForm.nik = data.nik + ' - ' + data.name;
      vm.Form.objForm.empno = data.nik;
      vm.Form.objForm.id = data.id;
      vm.Form.objForm.country = $localStorage.country;
      vm.Form.objForm.company = data.company;
      vm.Form.objForm.area = data.sub_area;
      vm.Form.objForm.gedung_id = data.gedung_id;
      vm.Form.objForm.group_shift = data.group_shift_id;
      vm.Form.objForm.sector_id = data.sector_id;
      vm.Form.objForm.admin_type = data.admin_type;
    }

    function updateData(ev, frm) {
      angular.element.blockUI();
      var response = Form.saveData('update', frm, endPoint);
      response.then(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();

        showDialogInfo(ev, data);
      });

      response.catch(function (data) {
        angular.element.unblockUI();
        frm.$setPristine();
        showDialogInfo(ev, data);
      });
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {
      return $http
        .get(config.api + 'api/applicationadmin?action=searchEmployee&id=' + searchText + '&company=' + vm.company)
        .then(function (item) {
          if (item.data.length === '') {
            vm.empno = '';
          }
          return item.data;
        });
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.additionalumutapproval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.umut_approval', {
                url    : '/umut-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/additional-umut-approval/additional-umut-approval.html',
                        controller : 'AdditionalUmutApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.additionalumutapproval')
        .controller('AdditionalUmutApprovalController', AdditionalUmutApprovalController);


    AdditionalUmutApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$filter'];
    /** @ngInject */
    function AdditionalUmutApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$filter)
    {  
      var vm = this; 
      var translate = $filter('translate');

      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      
      var endPoint=AppAPI.AdditionalUmutApproval();
      var endPointUmutReport=AppAPI.Umutreport();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var nik= $localStorage.user;

      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveOT=approveOT;
      vm.Reject=Reject;
      vm.viewComment=viewComment;
      vm.UnReject=UnReject;
      vm.UnApproved=UnApproved; 
      vm.unapproveAll=unapproveAll;

      vm.LoadPeriod=LoadPeriod;
      vm.LoadArea=LoadArea;
      vm.company = $localStorage.empsite;

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      // vm.tgl=date;
      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected']; 
      vm.toggleSelectedAll=toggleSelectedAll;

      if(vm.tgl >=25 && vm.tgl <=31)
      { 
        if(vm.bulan==12){
          vm.bulan='01';
        }else{
          vm.bulan=vm.bulan+1;
        }
      }
      if(vm.bulan < 10){
        vm.bulan='0'+vm.bulan;
      }

      vm.listtahun=[2014,2015,2016,2017,2018,2019];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
      
      vm.LoadRegional  = loadRegional;
      vm.LoadCabang    = loadCabang;
      vm.LoadWilayah   = loadWilayah;

      vm.reqWil    = false;
      vm.reqArea   = true;

      LoadPeriod();
      LoadSubPeriod();
      LoadCompany()
      loadWilayah();
      LoadAreaDefault(vm.company);

      function LoadAreaDefault(company) 
        {
            var response=endPoint.query({action:'getArea', companyid:company});
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

      function fetchAreaDefault(data) {
            vm.listarea=data;
      }

      function errorFetchAreaDefault() {
            vm.listarea=[];
      }

      function LoadSubPeriod() 
      {
          var response=endPoint.query({action:'getSubPeriod'});
          response.$promise.then(fetchSubPeriod);
          response.$promise.catch(errorFetchSubPeriod);
        }

        function fetchSubPeriod(data) {
            vm.listsubperiod=data;
        }

        function errorFetchSubPeriod() {
            vm.listsubperiod=[];
        } 

        function LoadCompany() {
          var response=endPoint.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
        }

        function fetchCompany(data) {
            vm.listcompany=data;
        }

        function errorFetchCompany() {
            vm.listcompany=[];
        } 

        function LoadArea(company,cabangid) 
        {
            loadWilayah();
            var response=endPoint.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

        function fetchArea(data) {
            vm.listarea=data;
        }

        function errorFetchArea() {
            vm.listarea=[];
        }
        
        function loadWilayah() {
          var response=endPoint.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
        }

        function fetchWilayah(data) {
            vm.listWilayah=data;
        }

        function errorFetchWilayah() {
            vm.listWilayah=[];
        }  
        
        function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=endPoint.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
        }

        function fetchRegional(data) {
            vm.listRegional=data;
        }

        function errorFetchRegional() {
            vm.listRegional=[];
        }  
        
        function loadCabang(id) {
          var response=endPoint.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
        }

        function fetchCabang(data) {
            vm.listCabang=data;
        }

        function errorFetchCabang() {
            vm.listCabang=[];
        }
        
        function LoadPeriod() 
        {
          var response=endPointUmutReport.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
        }

        function fetchPeriod(data) {
              vm.listperiod=data;
        }

        function errorFetchPeriod() {
              vm.listperiod=[];
        }

    function unapproveAll(ev)
    {
      var jum=vm.listOtselected.length,i,ids=[];
      if(jum>0)
      {
        var promise=Auth.setToken();
        promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Un-Approve this list?')
              .textContent('All data your selected will be un-approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
            });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var ot= new endPoint();
                ot.data=[];
                ot.action='unapprove';
                ot.nik=nik;   
                for (i=0;i<jum;i++) {
                  ot.data.push(vm.listOtselected[i]);
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                response.then(function(data){
                  angular.element.unblockUI();
                  if (data.status == 1) {
                    successApproved(ev,data);
                  } else {
                    failedApproved(ev,data);
                  }
                });
                response.catch(function(data){
                  failedApproved(ev,data.data);
                  angular.element.unblockUI();
                });
            }, function() {

          });
        });
      }else{
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Attention!')
        .textContent('No data selected')
        .ariaLabel('Attention')
        .ok('close')
        .targetEvent(ev)
        ).then(function(){
            loadData();
        });
      } 
    }
    function getPeriode()
    {
        var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data)
    {
      vm.periode=data[0]['periode'];
      loadData(1);
    }

    function errorfetchPeriode(data)
    {
      console.log('error');
    }

    function loadData(pageno)
    { 
      vm.listOtselected=[];
      var resp=vm.DataTable.loadData(endPoint,pageno,{
        action      :'viewdata',
        type        : vm.type,
        subPeriod   : vm.subperiod,
        period      : vm.period,
        company     : vm.company,
        area        : vm.area,
        wilayah     : vm.wilayah,
        regional    : vm.regional,
        tgl         : vm.tgl,
        cabang      : vm.cabang
      });
      vm.listGhk=[];
    } 

    function isChecked(ls)
    {
        return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event)
    {
        if ( event )
        {
            event.stopPropagation();
        }

        var idx = vm.listOtselected.indexOf(ls);

        if ( idx > -1 )
        {
            vm.listOtselected.splice(idx, 1);
        }
        else
        {
            vm.listOtselected.push(ls);
        }
    }

    function toggleSelectedAll(state)
    {
      switch(state)
      {
          case true:
          checkAll();
          break;
          case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() 
    {
       vm.listOtselected=angular.copy(vm.DataTable.list);
    }

    function unCheckAll() 
    {
       vm.listOtselected=[];
    }

    function approveOT(ev)
    {
      var jum=vm.listOtselected.length,i,ids=[];
      if(jum>0)
      {
        var promise=Auth.setToken();
        promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
            });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var ot= new endPoint();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;   
                for (i=0;i<jum;i++) {
                  ot.data.push(vm.listOtselected[i]);
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                response.then(function(data){
                  angular.element.unblockUI();
                  if (data.status == 1) {
                    successApproved(ev,data);
                  } else {
                    failedApproved(ev,data);
                  }
                });
                response.catch(function(data){
                  failedApproved(ev,data.data);
                  angular.element.unblockUI();
                });
            }, function() {

          });
        });
      }else{
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Attention!')
        .textContent('No data selected')
        .ariaLabel('Attention')
        .ok('close')
        .targetEvent(ev)
        ).then(function(){
            loadData();
        });
      } 
    }

    function successApproved(ev,data)
    {
        var expmess = data.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(data.pesan);
        }

          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
            if ('moreInfo' in data && data.moreInfo.length>0) {
              $mdDialog.show({
                  controller         : 'logFailGwController',
                  controllerAs       : 'vm',
                  templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                  parent: angular.element(document.body),
                  clickOutsideToClose:true,
                  fullscreen: true,
                  onRemoving:function(element, removePromise)
                  {
                      loadData(1);
                  },
                  locals:{
                    data:data.moreInfo
                  }
              });
            }else{
              loadData(1);
            }
          });
        
      }

      function failedApproved(ev,data)
      {
        var expmess = data.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(data.pesan);
        }

          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

    function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          $mdDialog.show({
              controller         : 'AdditionalUmutCommentController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/additional-umut-approval/comment-reject.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData();
                  vm.listOtselected=[];
              },
              locals:{
                id:vm.listOtselected
              }
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

    function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'AdditionalUmutViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/approval-ghk/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              vm.listOtselected=[];
          },
          locals:{
            id:id
          }
      });
    }

    function UnReject(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
          var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
          angular.element.blockUI();
          var response=endPoint.delete({action:'unreject',data:angular.toJson(id)});
          response.$promise.then(function(data){
            succesUnreject(ev,data);
          });
          response.$promise.catch(function(){
            angular.element.unblockUI();
            failedUnapproved(ev,data);
          });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

    function UnApproved(ev,id)
      {
        var promise=Auth.setToken();
         promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

         $mdDialog.show(confirm).then(function() {
         angular.element.blockUI();
         var response=endPoint.delete({action:'unapproved',data:angular.toJson(id)});
          // console.log(response);
          response.$promise.then(function(data){
            if (data.status == 1) {
              successApproved(ev,data);
            } else {
              failedApproved(ev,data);
            }
          });
           response.$promise.catch(function(data){
            failedUnapproved(ev,data);
           });
          angular.element.unblockUI();
            }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
         });
      }

      function succesUnapproved(ev,data)
      {
        if(data.hasil=='expired'){
          showFailedUnapproved();
        }else{
          showDialog();
        }
        loadData();
      } 

      function succesUnreject(ev,data)
      {
        if(data.hasil=='expired'){
          showFailedUnreject();
        }else{
          showDialogUnreject(data);
        }
        loadData();
      }

      function failedUnapproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.data)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
      }

      function showFailedUnapproved() {
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Failed Unapproved Data')
        .textContent('Transaction Locked By System.')
        .ariaLabel('Transaction Locked By System')
        .ok('OK')
        ).then(function(){
            $mdDialog.hide();
        });
      }

      function showFailedUnreject() {
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Failed Unreject Data')
        .textContent('Transaction Locked By System.')
        .ariaLabel('Transaction Locked By System')
        .ok('OK')
        ).then(function(){
            $mdDialog.hide();
        });
      }

      function showDialog() {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
          ).then(function(){
            $mdDialog.hide();
          });
      }

      function showDialogUnreject(data) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(data.status)
          .textContent(data.pesan)
          .ariaLabel(data.status)
          .ok('close')
          ).then(function(){
            $mdDialog.hide();
          });
      }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.additionalumutapproval')
        .controller('AdditionalUmutViewRejectCommentController', AdditionalUmutViewRejectCommentController);

    AdditionalUmutViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function AdditionalUmutViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.additionalumutapproval')
        .controller('AdditionalUmutCommentController', AdditionalUmutCommentController);

    AdditionalUmutCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$filter'];

    /* @ngInject */
    function AdditionalUmutCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) 
    {
        var vm = this; 

        var translate = $filter('translate');

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.AdditionalUmutApproval();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;
        // console.log(id);

        function saveData(ev,formController)
        { 
            var promise= Form.saveData('reject', formController, endPoint);
            promise.then(function(data){
                if (data.status == 1) {
                    successApproved(ev,data);
                } else {
                    failedApproved(ev,data);
                }
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function successApproved(ev,data)
        {
            var expmess = data.pesan.split("_");
            if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
            }else{
                var message = translate(data.pesan);
            }

            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success save data')
            .textContent(message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    // loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            var expmess = data.pesan.split("_");
            if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
            }else{
                var message = translate(data.pesan);
            }

            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed save data')
            .textContent(message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                // loadData();
            });
            
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.additionalinsentifapproval', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.insentif_approval', {
                url    : '/insentif-approval',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/additional-insentif-approval/additional-insentif-approval.html',
                        controller : 'AdditionalInsentifApprovalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.additionalinsentifapproval')
        .controller('AdditionalInsentifApprovalController', AdditionalInsentifApprovalController);


    AdditionalInsentifApprovalController.$inject=['$state','$mdDialog','DataService','AppAPI','Auth','GeneralService','$localStorage','$filter'];
    /** @ngInject */
    function AdditionalInsentifApprovalController($state,$mdDialog,DataService,AppAPI,Auth,GeneralService,$localStorage,$filter)
    {  
      var vm = this; 
      var translate = $filter('translate');

      vm.loadData=loadData
      vm.listJum=[2,5,25,50,75,100,200];
      vm.DataTable= new DataService();
      vm.loadData=loadData; 
      
      var endPoint=AppAPI.AdditionalInsentifApproval();
      var endPointUmutReport=AppAPI.Umutreport();
      var Attendanceemploye=AppAPI.Attendanceemploye();
      var nik= $localStorage.user;

      vm.isChecked=isChecked;
      vm.toggleCheck = toggleCheck;
      vm.listOtselected=[];
      vm.approveOT=approveOT;
      vm.unapproveAll=unapproveAll;
      vm.Reject=Reject;
      vm.viewComment=viewComment;
      vm.UnReject=UnReject;
      vm.UnApproved=UnApproved; 
      vm.LoadPeriod=LoadPeriod;
      vm.LoadArea=LoadArea;

      vm.company       = $localStorage.empsite;

      var date=new Date();
      vm.tahun=date.getFullYear();
      vm.bulan=date.getMonth()+1;
      vm.getPeriode=getPeriode;
      // vm.tgl=date.getDate();
      vm.type='waiting approval';
      vm.listType=['waiting approval','approved','rejected']; 
      vm.toggleSelectedAll=toggleSelectedAll;

      if(vm.tgl >=25 && vm.tgl <=31)
      { 
        if(vm.bulan==12){
          vm.bulan='01';
        }else{
          vm.bulan=vm.bulan+1;
        }
      }
      if(vm.bulan < 10){
        vm.bulan='0'+vm.bulan;
      }

      vm.listtahun=[2014,2015,2016,2017,2018,2019];
      vm.listbulan=[{name:'January',value:'01'},
                    {name:'February',value:'02'},
                    {name:'Maret',value:'03'},
                    {name:'April',value:'04'},
                    {name:'Mei',value:'05'},
                    {name:'June',value:'06'},
                    {name:'July',value:'07'},
                    {name:'August',value:'08'},
                    {name:'September',value:'09'},
                    {name:'October',value:'10'},
                    {name:'November',value:'11'},
                    {name:'Desember',value:'12'}];
 
      vm.LoadRegional  = loadRegional;
      vm.LoadCabang    = loadCabang;
      vm.LoadWilayah   = loadWilayah;

      vm.reqWil    = false;
      vm.reqArea   = true;

      LoadPeriod();
      LoadSubPeriod();
      LoadCompany()
      loadWilayah();
      LoadAreaDefault(vm.company);

      function LoadAreaDefault(company) 
        {
            var response=endPoint.query({action:'getArea', companyid:company});
            response.$promise.then(fetchAreaDefault);
            response.$promise.catch(errorFetchAreaDefault);
        }

      function fetchAreaDefault(data) {
            vm.listarea=data;
      }

      function errorFetchAreaDefault() {
            vm.listarea=[];
      }

      function LoadSubPeriod() 
      {
          var response=endPoint.query({action:'getSubPeriod'});
          response.$promise.then(fetchSubPeriod);
          response.$promise.catch(errorFetchSubPeriod);
       }

       function fetchSubPeriod(data) {
            vm.listsubperiod=data;
       }

       function errorFetchSubPeriod() {
            vm.listsubperiod=[];
       } 

       function LoadCompany() {
          var response=endPoint.query({action:'getCompany'});
          response.$promise.then(fetchCompany);
          response.$promise.catch(errorFetchCompany);
       }

       function fetchCompany(data) {
            vm.listcompany=data;
       }

       function errorFetchCompany() {
            vm.listcompany=[];
       } 

        function LoadArea(company,cabangid) 
        {
            loadWilayah();
            var response=endPoint.query({action:'getArea', companyid:company,cabangid:cabangid});
            response.$promise.then(fetchArea);
            response.$promise.catch(errorFetchArea);
        }

       function fetchArea(data) {
            vm.listarea=data;
       }

       function errorFetchArea() {
            vm.listarea=[];
       }
       
       function loadWilayah() {
          var response=endPoint.query({action:'getWilayah',companyid:vm.company});
          response.$promise.then(fetchWilayah);
          response.$promise.catch(errorFetchWilayah);
       }

       function fetchWilayah(data) {
            vm.listWilayah=data;
       }

       function errorFetchWilayah() {
            vm.listWilayah=[];
       }  
       
       function loadRegional(id) {
        vm.listarea=[];
        vm.reqWil    = true;
        vm.reqArea   = false;
          var response=endPoint.query({action:'getRegional', wilayahid:id,companyid:vm.company});
          response.$promise.then(fetchRegional);
          response.$promise.catch(errorFetchRegional);
       }

       function fetchRegional(data) {
            vm.listRegional=data;
       }

       function errorFetchRegional() {
            vm.listRegional=[];
       }  
       
       function loadCabang(id) {
          var response=endPoint.query({action:'getCabang', regionalid:id,companyid:vm.company});
          response.$promise.then(fetchCabang);
          response.$promise.catch(errorFetchCabang);
       }

       function fetchCabang(data) {
            vm.listCabang=data;
       }

       function errorFetchCabang() {
            vm.listCabang=[];
       }

    function getPeriode()
    {
        var res=Attendanceemploye.query({action:'getPeriode',tahun:vm.tahun,bulan:vm.bulan});
        res.$promise.then(fetchPeriode);
        res.$promise.catch(errorfetchPeriode);
    }

    function fetchPeriode(data)
    {
      vm.periode=data[0]['periode'];
      loadData(1);
    }

    function errorfetchPeriode(data)
    {
      console.log('error');
    }

    function loadData(pageno)
    { 
      vm.listOtselected=[];
      var resp=vm.DataTable.loadData(endPoint,pageno,{
        action:'viewdata',
        period:vm.period,
        type:vm.type,
        company:vm.company,
        wilayah:vm.wilayah,
        regional:vm.regional,
        cabang:vm.cabang,
        area:vm.area,
        subperiod:vm.subperiod
      });
      vm.listGhk=[];
    } 

    function isChecked(ls)
    {
        return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event)
    {
        if ( event )
        {
            event.stopPropagation();
        }

        var idx = vm.listOtselected.indexOf(ls);

        if ( idx > -1 )
        {
            vm.listOtselected.splice(idx, 1);
        }
        else
        {
            vm.listOtselected.push(ls);
        }
    }

    function toggleSelectedAll(state)
    {
      switch(state)
      {
          case true:
          checkAll();
          break;
          case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() 
    {
       vm.listOtselected=angular.copy(vm.DataTable.list);
    }

    function unCheckAll() 
    {
       vm.listOtselected=[];
    }

    function approveOT(ev)
    {
      var jum=vm.listOtselected.length,i,ids=[];
      if(jum>0)
      {
        var promise=Auth.setToken();
        promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Approve this list?')
              .textContent('All data your selected will be approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
            });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var ot= new endPoint();
                ot.data=[];
                ot.action='approve';
                ot.nik=nik;   
                for (i=0;i<jum;i++) {
                  ot.data.push(vm.listOtselected[i]);
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                response.then(function(data){
                  angular.element.unblockUI();
                  if (data.status == 1) {
                    successApproved(ev,data);
                  } else {
                    failedApproved(ev,data);
                  }
                });
                response.catch(function(data){
                  failedApproved(ev,data.data);
                  angular.element.unblockUI();
                });
            }, function() {

          });
        });
      }else{
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Attention!')
        .textContent('No data selected')
        .ariaLabel('Attention')
        .ok('close')
        .targetEvent(ev)
        ).then(function(){
            loadData();
        });
      } 
    }
    
    function unapproveAll(ev)
    {
      var jum=vm.listOtselected.length,i,ids=[];
      if(jum>0)
      {
        var promise=Auth.setToken();
        promise.then(function(){
              var confirm = $mdDialog.confirm()
              .title('Would you like to Un-Approve this list?')
              .textContent('All data your selected will be un-approve.')
              .ariaLabel('delete dialog')
              .targetEvent(ev)
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
            });      
          $mdDialog.show(confirm).then(function() {
                angular.element.blockUI();
                var ot= new endPoint();
                ot.data=[];
                ot.action='unapprove';
                ot.nik=nik;   
                for (i=0;i<jum;i++) {
                  ot.data.push(vm.listOtselected[i]);
                }
                var idtx=encodeURIComponent(angular.toJson(ids));
                var response=ot.$save(); 
                response.then(function(data){
                  angular.element.unblockUI();
                  if (data.status == 1) {
                    successApproved(ev,data);
                  } else {
                    failedApproved(ev,data);
                  }
                });
                response.catch(function(data){
                  failedApproved(ev,data.data);
                  angular.element.unblockUI();
                });
            }, function() {

          });
        });
      }else{
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Attention!')
        .textContent('No data selected')
        .ariaLabel('Attention')
        .ok('close')
        .targetEvent(ev)
        ).then(function(){
            loadData();
        });
      } 
    }

    function successApproved(ev,data)
    {
        var expmess = data.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(data.pesan);
        }

          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
            if ('moreInfo' in data && data.moreInfo.length>0) {
              $mdDialog.show({
                  controller         : 'logFailGwController',
                  controllerAs       : 'vm',
                  templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                  parent: angular.element(document.body),
                  clickOutsideToClose:true,
                  fullscreen: true,
                  onRemoving:function(element, removePromise)
                  {
                      loadData(1);
                  },
                  locals:{
                    data:data.moreInfo
                  }
              });
            }else{
              loadData(1);
            }
          });
        
      }

      function failedApproved(ev,data)
      {
        var expmess = data.pesan.split("_");
        if(expmess.length>1){
          var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
        }else{
            var message = translate(data.pesan);
        }

          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        
      }

    function Reject(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          $mdDialog.show({
              controller         : 'AdditionalInsentifCommentController',
              controllerAs       : 'vm',
              templateUrl        : 'app/main/additional-insentif-approval/comment-reject.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: true,
              onRemoving:function(element, removePromise)
              {
                  loadData();
                  vm.listOtselected=[];
              },
              locals:{
                id:vm.listOtselected
              }
          });
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
        } 
      }

    function viewComment(ev,id)
    {
      $mdDialog.show({
          controller         : 'AdditionalInsentifViewRejectCommentController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/cb/approval-ghk/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: true,
          onRemoving:function(element, removePromise)
          { 
              vm.listOtselected=[];
          },
          locals:{
            id:id
          }
      });
    }

    function UnReject(ev,id)
    {
      var promise=Auth.setToken();
      promise.then(function(){
          var confirm = $mdDialog.confirm()
          .title('Would you like to unreject this list?')
          .textContent('All data you selected will be set to unreject.')
          .ariaLabel('unreject dialog')
          .targetEvent(ev)
          .ok('YES')
          .cancel('no');

      $mdDialog.show(confirm).then(function() {
          angular.element.blockUI();
          var response=endPoint.delete({action:'unreject',data:angular.toJson(id)});
          response.$promise.then(function(data){
            succesUnreject(ev,data);
          });
          response.$promise.catch(function(){
            angular.element.unblockUI();
            failedUnapproved(ev,data);
          });
          }, function() {
           // $scope.status = 'You decided to keep your debt.';
          });
      });
    }

    function UnApproved(ev,id)
      {
        var promise=Auth.setToken();
         promise.then(function(){
                var confirm = $mdDialog.confirm()
            .title('Would you like to unapprove this list?')
            .textContent('All data you selected will be set to unapproved.')
            .ariaLabel('unapprove dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');

         $mdDialog.show(confirm).then(function() {
         angular.element.blockUI();
         var response=endPoint.delete({action:'unapproved',data:angular.toJson(id)});
          // console.log(response);
          response.$promise.then(function(data){
            if (data.status == 1) {
              successApproved(ev,data);
            } else {
              failedApproved(ev,data);
            }
          });
           response.$promise.catch(function(data){
            failedUnapproved(ev,data);
           });
          angular.element.unblockUI();
            }, function() {
             // $scope.status = 'You decided to keep your debt.';
            });
         });
      }

      function succesUnapproved(ev,data)
      {
        if(data.hasil=='expired'){
          showFailedUnapproved();
        }else{
          showDialog();
        }
        loadData();
      } 

      function succesUnreject(ev,data)
      {
        if(data.hasil=='expired'){
          showFailedUnreject();
        }else{
          showDialogUnreject(data);
        }
        loadData();
      }

      function failedUnapproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.data)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              loadData();
          });
      }

      function showFailedUnapproved() {
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Failed Unapproved Data')
        .textContent('Transaction Locked By System.')
        .ariaLabel('Transaction Locked By System')
        .ok('OK')
        ).then(function(){
            $mdDialog.hide();
        });
      }

      function showFailedUnreject() {
        $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#contentDialog')))
        .clickOutsideToClose(true)
        .title('Failed Unreject Data')
        .textContent('Transaction Locked By System.')
        .ariaLabel('Transaction Locked By System')
        .ok('OK')
        ).then(function(){
            $mdDialog.hide();
        });
      }

      function showDialog() {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent('Process Data was Success.')
          .ariaLabel('Attention')
          .ok('close')
          ).then(function(){
            $mdDialog.hide();
          });
      }

      function showDialogUnreject(data) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title(data.status)
          .textContent(data.pesan)
          .ariaLabel(data.status)
          .ok('close')
          ).then(function(){
            $mdDialog.hide();
          });
      }

      function LoadPeriod() 
      {
          var response=endPointUmutReport.query({action:'getPeriod'});
          response.$promise.then(fetchPeriod);
          response.$promise.catch(errorFetchPeriod);
       }

       function fetchPeriod(data) {
            vm.listperiod=data;
       }

       function errorFetchPeriod() {
            vm.listperiod=[];
       }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.additionalinsentifapproval')
        .controller('AdditionalInsentifViewRejectCommentController', AdditionalInsentifViewRejectCommentController);

    AdditionalInsentifViewRejectCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config'];

    /* @ngInject */
    function AdditionalInsentifViewRejectCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config) {
        var vm = this; 
        // initial form
        Form.initialForm();

        var Abnormalapproval = AppAPI.Abnormalapproval();

        // set constructor form
        Form.setObject(Abnormalapproval);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal; 
        vm.Form.objForm.data=id;
        vm.stateView=true;
        // console.log(id);
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.additionalinsentifapproval')
        .controller('AdditionalInsentifCommentController', AdditionalInsentifCommentController);

    AdditionalInsentifCommentController.$inject = ['$localStorage','id','$mdDialog','Form','AppAPI','$log','FileUploader','config','$filter'];

    /* @ngInject */
    function AdditionalInsentifCommentController($localStorage,id,$mdDialog,Form,AppAPI,$log,FileUploader,config,$filter) 
    {
        var vm = this; 

        var translate = $filter('translate');

        // initial form
        Form.initialForm();

        var endPoint = AppAPI.AdditionalInsentifApproval();

        // set constructor form
        Form.setObject(endPoint);

        // set form to controller
        vm.Form = Form; 

        vm.closeModal = closeModal;
        vm.saveData=saveData; 
        vm.Form.objForm.data=id;
        vm.stateView=false;
        // console.log(id);

        function saveData(ev,formController)
        { 
            var promise= Form.saveData('reject', formController, endPoint);
            promise.then(function(data){
                if (data.status == 1) {
                    successApproved(ev,data);
                } else {
                    failedApproved(ev,data);
                }
            });

            promise.catch(function(){
               ShowFailed(ev,data)  
            });
        }

        function successApproved(ev,data)
        {
            var expmess = data.pesan.split("_");
            if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
            }else{
                var message = translate(data.pesan);
            }

            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Success save data')
            .textContent(message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    // loadData(1);
                }
            });
            
        }

        function failedApproved(ev,data)
        {
            var expmess = data.pesan.split("_");
            if(expmess.length>1){
                var message = translate(expmess[0])+', '+expmess[1]+' '+translate(expmess[2])+' '+expmess[3]+' '+translate(expmess[4]);
            }else{
                var message = translate(data.pesan);
            }

            $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Failed save data')
            .textContent(message)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
            ).then(function(){
                if ('moreInfo' in data && data.moreInfo.length>0) {
                    $mdDialog.show({
                        controller         : 'logFailGwController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/cb/ghk-gw/log-fail.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: true,
                        onRemoving:function(element, removePromise)
                        {
                            // loadData(1);
                        },
                        locals:{
                            data:data.moreInfo
                        }
                    });
                }else{
                    // loadData(1);
                }
            });
            
        }
          
        function closeModal()
        {
            $mdDialog.hide();
        }
 
    }
})();
/**
 * dirPagination - AngularJS module for paginating (almost) anything.
 *
 *
 * Credits
 * =======
 *
 * Daniel Tabuenca: https://groups.google.com/d/msg/angular/an9QpzqIYiM/r8v-3W1X5vcJ
 * for the idea on how to dynamically invoke the ng-repeat directive.
 *
 * I borrowed a couple of lines and a few attribute names from the AngularUI Bootstrap project:
 * https://github.com/angular-ui/bootstrap/blob/master/src/pagination/pagination.js
 *
 * Copyright 2014 Michael Bromley <michael@michaelbromley.co.uk>
 */

(function() {

    /**
     * Config
     */
    var moduleName = 'angularUtils.directives.dirPagination';
    var DEFAULT_ID = '__default';

    /**
     * Module
     */
    angular.module(moduleName, [])
        .directive('dirPaginate', ['$compile', '$parse', 'paginationService', dirPaginateDirective])
        .directive('dirPaginateNoCompile', noCompileDirective)
        .directive('dirPaginationControls', ['paginationService', 'paginationTemplate', dirPaginationControlsDirective])
        .filter('itemsPerPage', ['paginationService', itemsPerPageFilter])
        .service('paginationService', paginationService)
        .provider('paginationTemplate', paginationTemplateProvider)
        .run(['$templateCache',dirPaginationControlsTemplateInstaller]);

    function dirPaginateDirective($compile, $parse, paginationService) {

        return  {
            terminal: true,
            multiElement: true,
            priority: 100,
            compile: dirPaginationCompileFn
        };

        function dirPaginationCompileFn(tElement, tAttrs){

            var expression = tAttrs.dirPaginate;
            // regex taken directly from https://github.com/angular/angular.js/blob/v1.4.x/src/ng/directive/ngRepeat.js#L339
            var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

            var filterPattern = /\|\s*itemsPerPage\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
            if (match[2].match(filterPattern) === null) {
                throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
            }
            var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
            var collectionGetter = $parse(itemsPerPageFilterRemoved);

            addNoCompileAttributes(tElement);

            // If any value is specified for paginationId, we register the un-evaluated expression at this stage for the benefit of any
            // dir-pagination-controls directives that may be looking for this ID.
            var rawId = tAttrs.paginationId || DEFAULT_ID;
            paginationService.registerInstance(rawId);

            return function dirPaginationLinkFn(scope, element, attrs){

                // Now that we have access to the `scope` we can interpolate any expression given in the paginationId attribute and
                // potentially register a new ID if it evaluates to a different value than the rawId.
                var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;
                
                // (TODO: this seems sound, but I'm reverting as many bug reports followed it's introduction in 0.11.0.
                // Needs more investigation.)
                // In case rawId != paginationId we deregister using rawId for the sake of general cleanliness
                // before registering using paginationId
                // paginationService.deregisterInstance(rawId);
                paginationService.registerInstance(paginationId);

                var repeatExpression = getRepeatExpression(expression, paginationId);
                addNgRepeatToElement(element, attrs, repeatExpression);

                removeTemporaryAttributes(element);
                var compiled =  $compile(element);

                var currentPageGetter = makeCurrentPageGetterFn(scope, attrs, paginationId);
                paginationService.setCurrentPageParser(paginationId, currentPageGetter, scope);

                if (typeof attrs.totalItems !== 'undefined') {
                    paginationService.setAsyncModeTrue(paginationId);
                    scope.$watch(function() {
                        return $parse(attrs.totalItems)(scope);
                    }, function (result) {
                        if (0 <= result) {
                            paginationService.setCollectionLength(paginationId, result);
                        }
                    });
                } else {
                    paginationService.setAsyncModeFalse(paginationId);
                    scope.$watchCollection(function() {
                        return collectionGetter(scope);
                    }, function(collection) {
                        if (collection) {
                            var collectionLength = (collection instanceof Array) ? collection.length : Object.keys(collection).length;
                            paginationService.setCollectionLength(paginationId, collectionLength);
                        }
                    });
                }

                // Delegate to the link function returned by the new compilation of the ng-repeat
                compiled(scope);
                 
                // (TODO: Reverting this due to many bug reports in v 0.11.0. Needs investigation as the
                // principle is sound)
                // When the scope is destroyed, we make sure to remove the reference to it in paginationService
                // so that it can be properly garbage collected
                // scope.$on('$destroy', function destroyDirPagination() {
                //     paginationService.deregisterInstance(paginationId);
                // });
            };
        }

        /**
         * If a pagination id has been specified, we need to check that it is present as the second argument passed to
         * the itemsPerPage filter. If it is not there, we add it and return the modified expression.
         *
         * @param expression
         * @param paginationId
         * @returns {*}
         */
        function getRepeatExpression(expression, paginationId) {
            var repeatExpression,
                idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPage\s*:[^|]*:[^|]*)/);

            if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
                repeatExpression = expression.replace(/(\|\s*itemsPerPage\s*:\s*[^|\s]*)/, "$1 : '" + paginationId + "'");
            } else {
                repeatExpression = expression;
            }

            return repeatExpression;
        }

        /**
         * Adds the ng-repeat directive to the element. In the case of multi-element (-start, -end) it adds the
         * appropriate multi-element ng-repeat to the first and last element in the range.
         * @param element
         * @param attrs
         * @param repeatExpression
         */
        function addNgRepeatToElement(element, attrs, repeatExpression) {
            if (element[0].hasAttribute('dir-paginate-start') || element[0].hasAttribute('data-dir-paginate-start')) {
                // using multiElement mode (dir-paginate-start, dir-paginate-end)
                attrs.$set('ngRepeatStart', repeatExpression);
                element.eq(element.length - 1).attr('ng-repeat-end', true);
            } else {
                attrs.$set('ngRepeat', repeatExpression);
            }
        }

        /**
         * Adds the dir-paginate-no-compile directive to each element in the tElement range.
         * @param tElement
         */
        function addNoCompileAttributes(tElement) {
            angular.forEach(tElement, function(el) {
                if (el.nodeType === 1) {
                    angular.element(el).attr('dir-paginate-no-compile', true);
                }
            });
        }

        /**
         * Removes the variations on dir-paginate (data-, -start, -end) and the dir-paginate-no-compile directives.
         * @param element
         */
        function removeTemporaryAttributes(element) {
            angular.forEach(element, function(el) {
                if (el.nodeType === 1) {
                    angular.element(el).removeAttr('dir-paginate-no-compile');
                }
            });
            element.eq(0).removeAttr('dir-paginate-start').removeAttr('dir-paginate').removeAttr('data-dir-paginate-start').removeAttr('data-dir-paginate');
            element.eq(element.length - 1).removeAttr('dir-paginate-end').removeAttr('data-dir-paginate-end');
        }

        /**
         * Creates a getter function for the current-page attribute, using the expression provided or a default value if
         * no current-page expression was specified.
         *
         * @param scope
         * @param attrs
         * @param paginationId
         * @returns {*}
         */
        function makeCurrentPageGetterFn(scope, attrs, paginationId) {
            var currentPageGetter;
            if (attrs.currentPage) {
                currentPageGetter = $parse(attrs.currentPage);
            } else {
                // If the current-page attribute was not set, we'll make our own.
                // Replace any non-alphanumeric characters which might confuse
                // the $parse service and give unexpected results.
                // See https://github.com/michaelbromley/angularUtils/issues/233
                // Adding the '_' as a prefix resolves an issue where paginationId might be have a digit as its first char
                // See https://github.com/michaelbromley/angularUtils/issues/400
                var defaultCurrentPage = '_' + (paginationId + '__currentPage').replace(/\W/g, '_');
                scope[defaultCurrentPage] = 1;
                currentPageGetter = $parse(defaultCurrentPage);
            }
            return currentPageGetter;
        }
    }

    /**
     * This is a helper directive that allows correct compilation when in multi-element mode (ie dir-paginate-start, dir-paginate-end).
     * It is dynamically added to all elements in the dir-paginate compile function, and it prevents further compilation of
     * any inner directives. It is then removed in the link function, and all inner directives are then manually compiled.
     */
    function noCompileDirective() {
        return {
            priority: 5000,
            terminal: true
        };
    }

    function dirPaginationControlsTemplateInstaller($templateCache) {
        $templateCache.put('angularUtils.directives.dirPagination.template', '<ul class="pagination" ng-if="1 < pages.length || !autoHide"><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li><li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }"><a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li><li ng-if="boundaryLinks"  ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li></ul>');
    }

    function dirPaginationControlsDirective(paginationService, paginationTemplate) {

        var numberRegex = /^\d+$/;

        var DDO = {
            restrict: 'AE',
            scope: {
                maxSize: '=?',
                onPageChange: '&?',
                paginationId: '=?',
                autoHide: '=?'
            },
            link: dirPaginationControlsLinkFn
        };

        // We need to check the paginationTemplate service to see whether a template path or
        // string has been specified, and add the `template` or `templateUrl` property to
        // the DDO as appropriate. The order of priority to decide which template to use is
        // (highest priority first):
        // 1. paginationTemplate.getString()
        // 2. attrs.templateUrl
        // 3. paginationTemplate.getPath()
        var templateString = paginationTemplate.getString();
        if (templateString !== undefined) {
            DDO.template = templateString;
        } else {
            DDO.templateUrl = function(elem, attrs) {
                return attrs.templateUrl || paginationTemplate.getPath();
            };
        }
        return DDO;

        function dirPaginationControlsLinkFn(scope, element, attrs) {

            // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding dir-paginate directive has
            // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
            // no corresponding dir-paginate directive and wrongly throwing an exception.
            var rawId = attrs.paginationId ||  DEFAULT_ID;
            var paginationId = scope.paginationId || attrs.paginationId ||  DEFAULT_ID;

            if (!paginationService.isRegistered(paginationId) && !paginationService.isRegistered(rawId)) {
                var idMessage = (paginationId !== DEFAULT_ID) ? ' (id: ' + paginationId + ') ' : ' ';
                if (window.console) {
                    console.warn('Pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive, which was not found at link time.');
                }
            }

            if (!scope.maxSize) { scope.maxSize = 9; }
            scope.autoHide = scope.autoHide === undefined ? true : scope.autoHide;
            scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
            scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;

            var paginationRange = Math.max(scope.maxSize, 5);
            scope.pages = [];
            scope.pagination = {
                last: 1,
                current: 1
            };
            scope.range = {
                lower: 1,
                upper: 1,
                total: 1
            };

            scope.$watch('maxSize', function(val) {
                if (val) {
                    paginationRange = Math.max(scope.maxSize, 5);
                    generatePagination();
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return (paginationService.getCollectionLength(paginationId) + 1) * paginationService.getItemsPerPage(paginationId);
                }
            }, function(length) {
                if (0 < length) {
                    generatePagination();
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return (paginationService.getItemsPerPage(paginationId));
                }
            }, function(current, previous) {
                if (current != previous && typeof previous !== 'undefined') {
                    goToPage(scope.pagination.current);
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return paginationService.getCurrentPage(paginationId);
                }
            }, function(currentPage, previousPage) {
                if (currentPage != previousPage) {
                    goToPage(currentPage);
                }
            });

            scope.setCurrent = function(num) {
                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
                    num = parseInt(num, 10);
                    paginationService.setCurrentPage(paginationId, num);
                }
            };

            /**
             * Custom "track by" function which allows for duplicate "..." entries on long lists,
             * yet fixes the problem of wrongly-highlighted links which happens when using
             * "track by $index" - see https://github.com/michaelbromley/angularUtils/issues/153
             * @param id
             * @param index
             * @returns {string}
             */
            scope.tracker = function(id, index) {
                return id + '_' + index;
            };

            function goToPage(num) {
                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
                    var oldPageNumber = scope.pagination.current;

                    scope.pages = generatePagesArray(num, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = num;
                    updateRangeValues();

                    // if a callback has been set, then call it with the page number as the first argument
                    // and the previous page number as a second argument
                    if (scope.onPageChange) {
                        scope.onPageChange({
                            newPageNumber : num,
                            oldPageNumber : oldPageNumber
                        });
                    }
                }
            }

            function generatePagination() {
                if (paginationService.isRegistered(paginationId)) {
                    var page = parseInt(paginationService.getCurrentPage(paginationId)) || 1;
                    scope.pages = generatePagesArray(page, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = page;
                    scope.pagination.last = scope.pages[scope.pages.length - 1];
                    if (scope.pagination.last < scope.pagination.current) {
                        scope.setCurrent(scope.pagination.last);
                    } else {
                        updateRangeValues();
                    }
                }
            }

            /**
             * This function updates the values (lower, upper, total) of the `scope.range` object, which can be used in the pagination
             * template to display the current page range, e.g. "showing 21 - 40 of 144 results";
             */
            function updateRangeValues() {
                if (paginationService.isRegistered(paginationId)) {
                    var currentPage = paginationService.getCurrentPage(paginationId),
                        itemsPerPage = paginationService.getItemsPerPage(paginationId),
                        totalItems = paginationService.getCollectionLength(paginationId);

                    scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
                    scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
                    scope.range.total = totalItems;
                }
            }
            function isValidPageNumber(num) {
                return (numberRegex.test(num) && (0 < num && num <= scope.pagination.last));
            }
        }

        /**
         * Generate an array of page numbers (or the '...' string) which is used in an ng-repeat to generate the
         * links used in pagination
         *
         * @param currentPage
         * @param rowsPerPage
         * @param paginationRange
         * @param collectionLength
         * @returns {Array}
         */
        function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
            var pages = [];
            var totalPages = Math.ceil(collectionLength / rowsPerPage);
            var halfWay = Math.ceil(paginationRange / 2);
            var position;

            if (currentPage <= halfWay) {
                position = 'start';
            } else if (totalPages - halfWay < currentPage) {
                position = 'end';
            } else {
                position = 'middle';
            }

            var ellipsesNeeded = paginationRange < totalPages;
            var i = 1;
            while (i <= totalPages && i <= paginationRange) {
                var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);

                var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
                var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
                if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                    pages.push('...');
                } else {
                    pages.push(pageNumber);
                }
                i ++;
            }
            return pages;
        }

        /**
         * Given the position in the sequence of pagination links [i], figure out what page number corresponds to that position.
         *
         * @param i
         * @param currentPage
         * @param paginationRange
         * @param totalPages
         * @returns {*}
         */
        function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
            var halfWay = Math.ceil(paginationRange/2);
            if (i === paginationRange) {
                return totalPages;
            } else if (i === 1) {
                return i;
            } else if (paginationRange < totalPages) {
                if (totalPages - halfWay < currentPage) {
                    return totalPages - paginationRange + i;
                } else if (halfWay < currentPage) {
                    return currentPage - halfWay + i;
                } else {
                    return i;
                }
            } else {
                return i;
            }
        }
    }

    /**
     * This filter slices the collection into pages based on the current page number and number of items per page.
     * @param paginationService
     * @returns {Function}
     */
    function itemsPerPageFilter(paginationService) {

        return function(collection, itemsPerPage, paginationId) {
            if (typeof (paginationId) === 'undefined') {
                paginationId = DEFAULT_ID;
            }
            if (!paginationService.isRegistered(paginationId)) {
                throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
            }
            var end;
            var start;
            if (angular.isObject(collection)) {
                itemsPerPage = parseInt(itemsPerPage) || 9999999999;
                if (paginationService.isAsyncMode(paginationId)) {
                    start = 0;
                } else {
                    start = (paginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
                }
                end = start + itemsPerPage;
                paginationService.setItemsPerPage(paginationId, itemsPerPage);

                if (collection instanceof Array) {
                    // the array just needs to be sliced
                    return collection.slice(start, end);
                } else {
                    // in the case of an object, we need to get an array of keys, slice that, then map back to
                    // the original object.
                    var slicedObject = {};
                    angular.forEach(keys(collection).slice(start, end), function(key) {
                        slicedObject[key] = collection[key];
                    });
                    return slicedObject;
                }
            } else {
                return collection;
            }
        };
    }

    /**
     * Shim for the Object.keys() method which does not exist in IE < 9
     * @param obj
     * @returns {Array}
     */
    function keys(obj) {
        if (!Object.keys) {
            var objKeys = [];
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    objKeys.push(i);
                }
            }
            return objKeys;
        } else {
            return Object.keys(obj);
        }
    }

    /**
     * This service allows the various parts of the module to communicate and stay in sync.
     */
    function paginationService() {

        var instances = {};
        var lastRegisteredInstance;

        this.registerInstance = function(instanceId) {
            if (typeof instances[instanceId] === 'undefined') {
                instances[instanceId] = {
                    asyncMode: false
                };
                lastRegisteredInstance = instanceId;
            }
        };

        this.deregisterInstance = function(instanceId) {
            delete instances[instanceId];
        };
        
        this.isRegistered = function(instanceId) {
            return (typeof instances[instanceId] !== 'undefined');
        };

        this.getLastInstanceId = function() {
            return lastRegisteredInstance;
        };

        this.setCurrentPageParser = function(instanceId, val, scope) {
            instances[instanceId].currentPageParser = val;
            instances[instanceId].context = scope;
        };
        this.setCurrentPage = function(instanceId, val) {
            instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
        };
        this.getCurrentPage = function(instanceId) {
            var parser = instances[instanceId].currentPageParser;
            return parser ? parser(instances[instanceId].context) : 1;
        };

        this.setItemsPerPage = function(instanceId, val) {
            instances[instanceId].itemsPerPage = val;
        };
        this.getItemsPerPage = function(instanceId) {
            return instances[instanceId].itemsPerPage;
        };

        this.setCollectionLength = function(instanceId, val) {
            instances[instanceId].collectionLength = val;
        };
        this.getCollectionLength = function(instanceId) {
            return instances[instanceId].collectionLength;
        };

        this.setAsyncModeTrue = function(instanceId) {
            instances[instanceId].asyncMode = true;
        };

        this.setAsyncModeFalse = function(instanceId) {
            instances[instanceId].asyncMode = false;
        };

        this.isAsyncMode = function(instanceId) {
            return instances[instanceId].asyncMode;
        };
    }

    /**
     * This provider allows global configuration of the template path used by the dir-pagination-controls directive.
     */
    function paginationTemplateProvider() {

        var templatePath = 'angularUtils.directives.dirPagination.template';
        var templateString;

        /**
         * Set a templateUrl to be used by all instances of <dir-pagination-controls>
         * @param {String} path
         */
        this.setPath = function(path) {
            templatePath = path;
        };

        /**
         * Set a string of HTML to be used as a template by all instances
         * of <dir-pagination-controls>. If both a path *and* a string have been set,
         * the string takes precedence.
         * @param {String} str
         */
        this.setString = function(str) {
            templateString = str;
        };

        this.$get = function() {
            return {
                getPath: function() {
                    return templatePath;
                },
                getString: function() {
                    return templateString;
                }
            };
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('aiko',[]);
})();

(function() {
    'use strict';

    angular
        .module('aiko')
        .service('Form', Form);

    Form.$inject = ['$q','$localStorage','Auth'];

    /* @ngInject */
    function Form($q,$localStorage,Auth) {
     var obj=this;
     obj.objForm=null;
     /*obj.successForm=successForm;
     obj.failedFormInfo=failedFormInfo;*/
     obj.initialForm=initialForm;
     obj.saveData=saveData;
     obj.updateData=updateData;
     obj.updateDataParamObject = updateDataParamObject;
     obj.setObject=setObject;

        ////////////////

        function successForm(pesan) {
        obj.succesForm=true;
        obj.failedForm=false;
        obj.tampilPesan=true;
        obj.pesan=pesan;
        }

        function failedFormInfo(pesan)
        {
        	obj.succesForm=false;
        	obj.failedForm=true;
        	obj.tampilPesan=true;
        	obj.pesan=pesan;
        }

        function initialForm (loadingState) {
            loadingState = typeof loadingState !== 'undefined' ? loadingState : true;
        	  obj.succesForm=false;
            obj.failedForm=false;
            obj.tampilPesan=false;
            obj.pesan='';
            obj.objForm={};
            Auth.setToken(loadingState);
        }
        function failedSave(data)
       {
         if(!!data.data.token)
         {

             failedFormInfo(data.data.pesan);
             $localStorage.token=data.data.token;
         }else
         {
             failedFormInfo(data.data);
         }
         return false;
       }

       function saveData(action,formControl,Constructor)
       {
         if(formControl.$valid)
         {
           obj.objForm.action=action;
           //console.log('obj.objForm', obj.objForm);
           //console.log('Constructor', Constructor);
           var promise=obj.objForm.$save();
           promise.then(function(data){
            //console.log(data);
              if(!!data.pesan)
              {
                
                formControl.$setUntouched();
                 obj.objForm = new Constructor();
                 $localStorage.token=data.token;
                 successForm(data.pesan);
              }else
              {
                 var err={

                        data:'Failed save data, please click reload token / refresh form button '

                };
                failedSave(err);
              }
              
           },failedSave);

           return promise;
         }else
         {
           failedFormInfo('Make sure all data was correct');
         }
       }

       function updateData(action,formControl,Constructor,id,actionGet)
       {
         if(formControl.$valid)
         {
           obj.objForm.action=action;
           var promise=obj.objForm.$save();
           var result=promise.then(function(data){ 
              if(!!data.pesan)
              {
                
                formControl.$setUntouched();
                 obj.objForm = new Constructor();
                 var promise2=obj.objForm.$get({action:actionGet,id:id});
                 $localStorage.token=data.token;
                 successForm(data.pesan);
                 return promise2;
              }else
              { 
                 var err={

                        data:'Failed save data, please click reload token / refresh form button '

                };
                failedSave(err);
              }

              
           },failedSave);

           
           return result;
         }else
         {
           failedFormInfo('Make sure all data was correct');
           return false;
         }
       }
       function updateDataParamObject(action,formControl,Constructor,$paramObject)
       {
         if(formControl.$valid)
         {
           obj.objForm.action=action;
           var promise=obj.objForm.$save();
           var result=promise.then(function(data){ 

              if(!!data.pesan)
              {
                
                formControl.$setUntouched();

                 obj.objForm = new Constructor();

                 var promise2=obj.objForm.$get($paramObject);
                 $localStorage.token=data.token;
                 successForm(data.pesan);
                 return promise2;
              }else
              {
                 var err={

                        data:'Failed save data, please click reload token / refresh form button'

                };
                failedSave(err);
              }
              
           },failedSave);

           
           return result;
         }else
         {
           failedFormInfo('Make sure all data was correct');
           return false;
         }
       }

       function setObject(Constructor)
       {
         obj.objForm = new Constructor();
       }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'blue-grey',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A700'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pacific-blue'     : {
            primary   : {
                name: 'light-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '300',
                    'hue-3'  : 'A700'
                }
            },
            accent    : {
                name: 'deep-purple',
                hues: {
                    'default': '400',
                    'hue-1'  : '600',
                    'hue-2'  : '800',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'purple'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'material-dark'     : {
            primary   : {
                name: 'deep-purple',
                hues: {
                    'default': '800',
                    'hue-1'  : '500',
                    'hue-2'  : '300',
                    'hue-3'  : 'A700'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A700'
                }
            },
            warn      : {name: 'grey'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'fruit-salad'     : {
            primary   : {
                name: 'green',
                hues: {
                    'default': '800',
                    'hue-1'  : 'A400',
                    'hue-2'  : '500',
                    'hue-3'  : '100'
                }
            },
            accent    : {
                name: 'blue-grey',
                hues: {
                    'default': '200',
                    'hue-1'  : '500',
                    'hue-2'  : '800',
                    'hue-3'  : 'A700'
                }
            },
            warn      : {
                    name: 'orange',
                    hues: {
                        'default': '200'
                    }
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'green-tea'     : {
            primary   : {
                name: 'lime',
                hues: {
                    'default': 'A700',
                    'hue-1'  : 'A400',
                    'hue-2'  : '500',
                    'hue-3'  : '100'
                }
            },
            accent    : {
                name: 'green',
                hues: {
                    'default': '600',
                    'hue-1'  : '500',
                    'hue-2'  : '800',
                    'hue-3'  : 'A700'
                }
            },
            warn      : {name: 'grey'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
         'hrlink' :{
             primary :{
                 name : 'hrlink-teal',
                 hues :{
                    'default': '500',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                 }
             },
              accent: {
                  name : 'hrlink-purple',
                  hues :{
                    'default': '500',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                  }
                 },
                 warn :{
                     name : 'red',
                     hues :{
                    'default': '500',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                     }
                 },
                 background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }


             }
            //  ,
            //  'pasdigit001' :{
            //  primary :{
            //      name : 'pasdigit-001-purple',
            //      hues :{
            //         'default': '500',
            //         'hue-1'  : '600',
            //         'hue-2'  : '500',
            //         'hue-3'  : 'A100'
            //      }
            //  },
            //   accent: {
            //       name : 'pasdigit-001-yellow',
            //       hues :{
            //         'default': '500',
            //         'hue-1'  : '600',
            //         'hue-2'  : '500',
            //         'hue-3'  : 'A100'
            //       }
            //      },
            //      warn :{
            //          name : 'pasdigit-001-red',
            //          hues :{
            //         'default': '500',
            //         'hue-1'  : '600',
            //         'hue-2'  : '500',
            //         'hue-3'  : 'A100'
            //          }
            //      },
            //      background: {
            //     name: 'grey',
            //     hues: {
            //         'default': 'A100',
            //         'hue-1'  : 'A100',
            //         'hue-2'  : '100',
            //         'hue-3'  : '300'
            //     }
            // }


            //  }
         
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'hrlink-purple',
            options:{
                '50': '#f3e5f5',
                '100': '#e1bee7',
                '200': '#ce93d8',
                '300': '#ba68c8',
                '400': '#ab47bc',
                '500': '#9A338E',
                '600': '#8e24aa',
                '700': '#7b1fa2',
                '800': '#6a1b9a',
                '900': '#4a148c',
                'A100': '#ea80fc',
                'A200': '#e040fb',
                'A400': '#d500f9',
                'A700': '#aa00ff',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
            {
                name:'hrlink-teal',
                options: {
                    '50': '#e0f2f1',
                    '100': '#b2dfdb',
                    '200': '#80cbc4',
                    '300': '#4db6ac',
                    '400': '#26a69a',
                    '500': '#00C9B7',
                    '600': '#00897b',
                    '700': '#00796b',
                    '800': '#00695c',
                    '900': '#004d40',
                    'A100': '#a7ffeb',
                    'A200': '#64ffda',
                    'A400': '#a7ffeb',
                    'A700': '#00bfa5',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '300 400'
                }
               
            }
            // ,

            // {
            //     name:'pasdigit-001-red',
            //     options: {
            //         '50': '#f7e3e6',
            //         '100': '#ecb9c1',
            //         '200': '#df8b98',
            //         '300': '#d25d6e',
            //         '400': '#c83a4f',
            //         '500': '#be1730',
            //         '600': '#b8142b',
            //         '700': '#af1124',
            //         '800': '#a70d1e',
            //         '900': '#990713',
            //         'A100': '#ffc6c9',
            //         'A200': '#ff9398',s
            //         'A400': '#ff6068',
            //         'A700': '#ff4750',
            //         'contrastDefaultColor': 'light',
            //         'contrastDarkColors': '50 100 200 A100',
            //         'contrastStrongLightColors': '300 400'
            //     }
               
            // },
            // {
            //     name:'pasdigit-001-yellow',
            //     options: {
            //           '50': '#fdfaeb',
            //           '100': '#faf3ce',
            //           '200': '#f6ebae',
            //           '300': '#f2e38d',
            //           '400': '#f0dd74',
            //           '500': '#edd75c',
            //           '600': '#ebd354',
            //           '700': '#e8cd4a',
            //           '800': '#e5c741',
            //           '900': '#e0be30',
            //           'A100': '#ffffff',
            //           'A200': '#fffcf1',
            //           'A400': '#fff1be',
            //           'A700': '#ffeca4',
            //           'contrastDefaultColor': 'light',
            //           'contrastDarkColors': '50 100 200 A100',
            //           'contrastStrongLightColors': '300 400'
            //     }
               
            // },
            // {
            //     name:'pasdigit-001-purple',
            //     options: {
            //           '50': '#f0e7ef',
            //           '100': '#dac3d7',
            //           '200': '#c29cbc',
            //           '300': '#aa74a1',
            //           '400': '#97568d',
            //           '500': '#853879',
            //           '600': '#7d3271',
            //           '700': '#722b66',
            //           '800': '#68245c',
            //           '900': '#551749',
            //           'A100': '#ff91e8',
            //           'A200': '#ff5edd',
            //           'A400': '#ff2bd2',
            //           'A700': '#ff12cd',
            //            'contrastDefaultColor': 'light',
            //           'contrastDarkColors': '50 100 200 A100',
            //           'contrastStrongLightColors': '300 400'
            //     }
               
            // },
            // {
            //     name:'pasdigit-001-green',
            //     options: {
            //            '50': '#e0f8f3',
            //           '100': '#b3efe0',
            //           '200': '#80e4cb',
            //           '300': '#4dd9b6',
            //           '400': '#26d0a7',
            //           '500': '#00c897',
            //           '600': '#00c28f',
            //           '700': '#00bb84',
            //           '800': '#00b47a',
            //           '900': '#00a769',
            //           'A100': '#d1ffeb',
            //           'A200': '#9effd5',
            //           'A400': '#6bffbf',
            //           'A700': '#52ffb5',
            //            'contrastDefaultColor': 'light',
            //           'contrastDarkColors': '50 100 200 A100',
            //           'contrastStrongLightColors': '300 400'
            //     }
               
            // }

        

    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.

            //hanya untuk sementara theme set default nabati1
            // fuseTheming.setActiveTheme('nabati1');

            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function() {
    'use strict';

    angular.module('app.core').factory('sessionService', SessionService);

    /** @ngInject */
    function SessionService(jwtHelper, $localStorage, $location, AppAPI,config) {
        var service = {
            setToken: setToken,
            getToken: getToken,
            getTokenId: getTokenId,
            toLogin: toLogin,
            clearToken: clearToken,
            refreshToken: refreshToken,
            isExpiredToken: isExpiredToken,
            generateNewToken: generateNewToken
        };

        return service;

        function setToken(token) {
            var decoded = jwtHelper.decodeToken(token);
            $localStorage.token = token;
            $localStorage.jti = decoded.jti;
            for (var i in decoded.data) {
                $localStorage[i] = decoded.data[i];
            }
        }

        function generateNewToken(token,menuID) {
            var auth = AppAPI.TokenAuth();
            var request = auth.generate({
                token: token,
                 appID: config.appID,
                // mainAppID:mainAppID,
                // username: username,
                action: 'generateNewToken',
                menuID:menuID
            });
            return request.$promise;
        }

        function getToken() {
            return $localStorage.token;
        }

        function getTokenId() {
            return $localStorage.jti;
        }

        function toLogin() {
            $location.path('/login');
        }

        function clearToken() {
            $localStorage.$reset();
        }

        function refreshToken() {
            var auth = AppAPI.TokenAuth();
            var request = auth.refresh({
                tokenID: getTokenId(),
                appID: 'hcportalmobile',
                action: 'refreshToken'
            });
            return request.$promise;
        }

        function isExpiredToken(token) {
            return jwtHelper.isTokenExpired(token);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
  'use strict';

	angular.module('app.core').filter('typeOf', function() {
	  return function(obj) {
	    return typeof obj
	  };
	});
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('toRoman', function () {
      return function (num) {
        if (num !== 'undefined') {
          var result = '';
          var decimal = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
          var roman = ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"];
          for (var i = 0; i <= decimal.length; i++) {
            while (num % decimal[i] < num) {
              result += roman[i];
              num -= decimal[i];
            }
          }
          return result;
        }
      };
    });
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
    "use strict";

    /**
     * Main module of the Fuse
     */
    angular
        .module("hcportal", [
            "ngMap",

            // Core
            "app.core",

            /*additional module*/
            "angular-jwt",
            "ngStorage",
            "datatables",
            "checklist-model",
            "angularFileUpload",
            "angular-flot",
            "ui.chart",
            "angular-jquery-maskedinput",
            "BasicPrimitives",
            /*end additional module*/

            // Navigation
            "app.navigation",

            // Toolbar
            "app.toolbar",

            // Quick Panel
            "app.quick-panel",

            // aikoframework
            "aiko",
            //ceo dashboard
            "app.ceo-dashboard",

            // main dashboard
            "app.dashboard",

            //master data
            "app.master-data",

            // employee
            "app.employee",

            // Sample
            "app.login",

            //pms
            "app.pms",

            //utilitas
            "app.utility",

            //behaviour performance
            "app.behivor",

            "app.hrservices",

            // echeck-in
            "app.echeckin",

            "app.echeckingw",

            //C&B
            "app.cb",

            //ta
            "app.ta",

            //change password
            "app.changepassword",

            // dashboard buat TV
            "app.hcdashboard",

            "app.hrbp",

            // Emplopyee Satisfaction Survey (ESS)
            "app.emp_survey",
            "app.emp_surveys",

            // Assessment
            "app.emp_assessment",
            "app.assessment",
            "app.development",

            //locktransaction
            "app.lock_transaction",

            //insurance
            "app.insurance",

            //MPN
            "app.mpn",
            //insurance
            "app.insurance",
            "app.hcnews",
            //payroll
            "app.payroll",
            "app.payroll-pma",
            "app.payroll-new",

            //travel
            "app.travel",

            //sfa
            "app.sfa",

            //offboarding
            "app.offboarding",
            "app.completeness",
            "app.mpp",
            "app.orgchart",
            "app.mppmgr",
            "app.jic",
            "app.report",
            "app.mpp-report-cost",
            "app.mpp-report-hc",
            "app.correspondence",
            "app.completeness",
            "app.policy",
            "app.policy.user",
            "app.onboarding",
            "app.mpp-report-cost-budget",
            "app.mpp-report-hc-cc",
            "app.job_evaluation",
            "app.payslip",
            // 'app.correspondence-pma',
            // 'app.correspondence-pma-approval',
            "app.tiket",
            "app.indisciplinary-request",
            "app.indisciplinary-approval",
            "app.indisciplinary-admin",
            "app.indisciplinary-alert",
            "app.mpn-gw",
            "app.cb.replacement-holiday",
            "app.structure_area",
            "app.employeereport",
            "app.hcticket",
            "app.umut-report",
            "app.insentif-report",
            "app.uploadadditionalumut",
            "app.uploadadditionalinsentif",
            "app.additionalumutapproval",
            "app.additionalinsentifapproval",
            "app.umut-transfer",
            "app.training-gw",
            "app.gwmoving",
            "app.shortleavegw",
            "app.insentif-transfer",
            "app.bank-ops-transfer",
            "app.production-products",
            "app.pkwt",
            "app.machine",
            "app.bank-ops-transfer",
            "app.indisciplinary-confirm",
            "app.indisciplinary-validation",
            "app.production.handover-gw",
            "app.umut-process",
            "app.umut-log",
            "app.emp-category",
            "app.umut-history",
            "app.emp-sales-code",
            "app.application-admin",
            "app.department-business",
            "app.employee-exchange",
            "app.ref-bank",
            "app.emp-adjustment-allowance",
            "app.wfh",
            "app.ref-sales-type",
            "app.ref-sales-code",
            "app.lock-setting",
            "app.uploadwfhumut",
            "app.wfh-report-health",
            "app.insentif-kpi-setting",
            "app.insentif-skema",
            "app.insentif-skema-override",
            "app.insentif-sales-target",
            "app.insentif-target-absolute",
            "app.insentif-override-target-absolute",
            "app.insentif-lph",
            "app.insentif-calculation",
            "app.insentif-calculationass",
            "app.ref-master-sku",
            "app.insentif-requirement-sku",
            "app.insentif-barcode",
            "app.insentif-barcode-bsr",
            "app.insentif-pinalty",
            "app.insentif-pinalty-sp",
            "app.insentif-process",
            "app.insentif-process-ass",
            "app.insentif-lock-sales",
            "app.insentif-approval",
            "app.insentif-approval-ass",
            "app.insentif-sku-focus",
            "app.insentif-sku-focus-general",
            "app.insentif-skema-ass-adjust",
            "app.insentif-sales-target-contribution",
            "app.insentif-adjustment-kpi",
            "app.insentif-adjustment-target-absolute",
            "app.wfh-report-health",
            "app.emp-appraisal",
            "app.lock-setting",
            "app.uploadwfhumut",
            "app.wfh-report-health",
            "app.mtx",
            "app.elearning",
            "app.insentif-monitoring",
            "app.ref-subdis",
            "app.emp-subdis",
            "app.insentif-hke-area",
            "app.insentif-hke-employee",
            "app.insentif-monitoring-lph",
            "app.insentif-upload-master-cb",
            "app.mympp",
        ])
        .config(config);

    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart("app");
    }
})();

(function () {
    "use strict";

    angular.module("hcportal").controller("MainController", MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $translatePartialLoader) {
        am4core.addLicense("CH211444723");

        // Data
        //////////

        // Remove the splash screen
        $scope.$on("$viewContentAnimationEnded", function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast("msSplashScreen::remove");
            }
        });
    }
})();

(function() {
  'use strict';
   angular.module('ui.chart', [])
  .directive('uiChart', function ($window) {
    return {
      restrict: 'EACM',
      template: '<div></div>',
      replace: true,
      link: function (scope, elem, attrs) {

        var renderChart = function () {
          var data = scope.$eval(attrs.uiChart);
          var objchart={};
          elem.html('');
          
          
          if (!angular.isArray(data)) {
            return;
          }
 
          var opts = {};
          if (!angular.isUndefined(attrs.chartOptions)) {
            opts = scope.$eval(attrs.chartOptions);
            if (!angular.isObject(opts)) {
              throw 'Invalid ui.chart options attribute';
            }
          }
         
          var uichartobj= elem.jqplot(data, opts);
           
           
        };

        scope.$watch(attrs.uiChart, function () {
          renderChart();
        }, true);

        scope.$watch(attrs.chartOptions, function () {
          renderChart();
        });
      }
    };
  });
}());




(function () {
    "use strict";

    angular
        .module("app.quick-panel")
        .controller("QuickPanelController", QuickPanelController);

    /** @ngInject */

    function QuickPanelController(
        $state,
        msApi,
        $localStorage,
        $mdDialog,
        AppAPI,
        Approvalinfo,
        Insurancealert,
        Claimalert,
        Form,
        Newsinfo,
        Newslist
    ) {
        var vm = this;
        // vm.data=$localStorage.InfoApproval;
        var news = AppAPI.News();
        vm.viewListApp = viewListApp;
        vm.viewNewsDetail = viewNewsDetail;
        vm.viewListAppAbnormal = viewListAppAbnormal;
        vm.viewListAppGHK = viewListAppGHK;
        vm.infoApproval = infoApproval;
        vm.viewListUpFinger = viewListUpFinger;
        vm.viewListOT = viewListOT;
        vm.viewListOTGw = viewListOTGw;
        vm.viewListChangeshift = viewListChangeshift;
        vm.unReadNews = Newsinfo;
        vm.listNC = Newslist;
        vm.viewListAppGHKholiday = viewListAppGHKholiday;
        vm.viewListAppGHKhalfday = viewListAppGHKhalfday;
        vm.closeModal = closeModal;
        vm.viewListAppOutletMapping = viewListAppOutletMapping;
        vm.viewListAppSicMapping = viewListAppSicMapping;

        vm.Insurancealert = Insurancealert;
        vm.Claimalert = Claimalert;

        vm.viewListGrade = viewListGrade;
        vm.viewListRekening = viewListRekening;
        vm.viewListChild = viewListChild;
        vm.viewListMarital = viewListMarital;
        vm.viewJumRegisterNumber = viewJumRegisterNumber;
        vm.viewClaim = viewClaim;
        vm.groupLogin = $localStorage.group;
        vm.ofbApproval = ofbApproval;
        vm.ofbExitApproval = ofbExitApproval;
        vm.ofbHandoverApproval = ofbHandoverApproval;
        vm.Approvalinfo = Approvalinfo;
        vm.ofbSetClearance = ofbSetClearance;
        vm.toIndisciplinaryConfirm = toIndisciplinaryConfirm;
        vm.toIndisciplinaryApproval = toIndisciplinaryApproval;
        vm.toIndisciplinaryValidation = toIndisciplinaryValidation;
        vm.viewResetSLT = viewResetSLT;

        vm.viewMpn = function () {
            $state.go(vm.Approvalinfo.getInfoApproval.urlMpn);
        };

        vm.viewMpnGw = function () {
            $state.go("app.mpn_gw_list_approval");
        };

        vm.viewTiket = function () {
            $state.go(vm.Approvalinfo.getInfoApproval.urlTiket);
        };

        // Data
        // console.log($localStorage.group);

        // infoApproval();
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud: false,
            retro: true
        };

        // if (vm.groupLogin != 99) {
        //     activate();
        // }

        // function activate() {
        //     Form.initialForm();
        //     Form.setObject(news);
        // }

        msApi.request(
            "quickPanel.activities@get",
            {},
            // Success
            function (response) {
                vm.activities = response.data;
            }
        );

        msApi.request(
            "quickPanel.events@get",
            {},
            // Success
            function (response) {
                vm.events = response.data;
            }
        );

        msApi.request(
            "quickPanel.notes@get",
            {},
            // Success
            function (response) {
                vm.notes = response.data;
            }
        );

        // Methods
        function loadDataNewsCategory() {
            var response = news.query({
                action: "viewNewsList"
            });
            response.$promise.then(fetchNewsCategory);
            response.$promise.catch(errorFetchNewsCategory);
        }

        function fetchNewsCategory(data) {
            Newslist.getListNews = data;
        }

        function errorFetchNewsCategory() {
            Newslist.getListNews = [];
        }

        function fetchNewsDetail(data) {
            if (data.length > 0) {
                $mdDialog.show({
                    controller: "NewsTabController",
                    controllerAs: "vm",
                    templateUrl: "app/quick-panel/tabs/news/news-detail.html",
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        // countUnReadNews();
                        infoApproval();
                        // $state.reload();
                    },
                    locals: {
                        data: data[0]
                    }
                });
            }
        }

        function errorFetchNewsDetail() { }

        // Methods
        function countUnReadNews() {
            var response = news.get({
                action: "getCountUnReadNews"
            });
            response.$promise.then(fetchUnreadNews);
            response.$promise.catch(errorFetchNewsCategory);
        }

        function fetchUnreadNews(data) {
            Newsinfo.getInfoNews = data;
        }

        function errorFetchNewsCategory() {
            Newsinfo.getInfoNews = 0;
        }
        //////////
        function viewListApp(ev) {
            $mdDialog.show({
                controller: "ListApprovalController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {}
            });
            // console.log('test');

            // $state.go('app.cb_approval_absence');
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function viewNewsDetail(ev, data) {
            if (data.content == null || data.content.length == 0) {
                $mdDialog.show({
                    controller: "NewsTabController",
                    controllerAs: "vm",
                    templateUrl: "app/quick-panel/tabs/news/news-view-doc.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        countUnReadNews();
                        infoApproval();
                        loadDataNewsCategory();
                    },
                    locals: {
                        data: data
                    }
                });
            } else {
                $mdDialog.show({
                    controller: "NewsTabController",
                    controllerAs: "vm",
                    templateUrl: "app/quick-panel/tabs/news/news-detail.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true,
                    onRemoving: function (element, removePromise) {
                        countUnReadNews();
                        infoApproval();
                        loadDataNewsCategory();
                    },
                    locals: {
                        data: data
                    }
                });
            }
        }

        function viewListAppAbnormal(ev) {
            $mdDialog.show({
                controller: "ListApprovalAbnormalController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-abnormal.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {
                    // id:id
                }
            });
            // $state.go('app.cb_abnormal_approval');
        }

        function viewListAppGHK(ev) {
            $mdDialog.show({
                controller: "ListApprovalGHKController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-ghk.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {
                    // id:id
                    type: "ghk"
                }
            });
            // $state.go('app.cb_approval_ghk');
        }

        function viewListAppGHKholiday(ev) {
            $mdDialog.show({
                controller: "ListApprovalGHKController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-ghk.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {
                    // id:id
                    type: "ghkholiday"
                }
            });
            // $state.go('app.cb_approval_ghk');
        }

        function viewListAppGHKhalfday(ev) {
            $mdDialog.show({
                controller: "ListApprovalGHKController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-ghk.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {
                    // id:id
                    type: "ghkhalfday"
                }
            });
            // $state.go('app.cb_approval_ghk');
        }

        function infoApproval() {
            var ListApproval = AppAPI.InfoApproval();
            var lsApproval = new ListApproval();
            var promise = lsApproval.$get({
                action: "viewData"
            });
            promise.then(processInfo);
            promise.catch(errorProcessInfo);
        }

        function processInfo(data) {
            // vm.data=data;
            Approvalinfo.getInfoApproval = data;
            // console.log(vm.data);
        }

        function errorProcessInfo() {
            // vm.data=[];
            Approvalinfo.getInfoApproval = {};
        }

        function infoInsurance() {
            var ListInsurance = AppAPI.InfoApproval();
            var lsInsurance = new ListInsurance();
            var promise = lsInsurance.$get({
                action: "infoInsurance"
            });
            promise.then(infoInsuranceSucess);
            promise.catch(infoInsuranceFailed);
        }

        function infoInsuranceSucess(data) {
            Insurancealert.infoInsurance = data;
        }

        function infoInsuranceFailed() {
            Insurancealert.infoInsurance = {};
        }

        function infoClaim() {
            var ListClaim = AppAPI.InfoApproval();
            var lsClaim = new ListClaim();
            var promise = lsClaim.$get({
                action: "infoClaim"
            });
            promise.then(infoClaimSucess);
            promise.catch(infoClaimFailed);
        }

        function infoClaimSucess(data) {
            Claimalert.infoClaim = data;
        }

        function infoClaimFailed() {
            Claimealert.infoClaim = {};
        }

        function viewListUpFinger(ev) {
            $mdDialog.show({
                controller: "ListApprovalFingerController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-finger.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {
                    // id:id
                }
            });
            // $state.go('app.cb_update_finger_approval');
        }

        function viewListOT(ev) {
            $mdDialog.show({
                controller: "ListApprovalOTController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-ot.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {}
            });
            // $state.go('app.cb_approval_ot');
        }

        function viewListOTGw(ev) {
            $mdDialog.show({
                controller: "ListApprovalOTGwController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-otgw.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {}
            });
            // $state.go('app.cb_approval_ot');
        }

        function viewListChangeshift(ev) {
            $mdDialog.show({
                controller: "ListApprovalChangeShiftController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-changeshift.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {
                    // id:id
                }
            });
            // $state.go('app.cb_changeshift_approval');
        }

        function viewListGrade(ev) {
            $mdDialog.show({
                controller: "ListApprovalChangeGrade",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-changegrade.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoInsurance();
                    // $state.reload();
                },
                locals: {
                    // id:id
                }
            });
        }

        function viewListRekening(ev) {
            $mdDialog.show({
                controller: "ListApprovalChangeBankAccount",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-changebankaccount.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoInsurance();
                    // $state.reload();
                },
                locals: {
                    // id:id
                }
            });
        }

        function viewListMarital(ev) {
            $mdDialog.show({
                controller: "ListApprovalChangeMarital",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-changemarital.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoInsurance();
                    // $state.reload();
                },
                locals: {
                    // id:id
                }
            });
        }

        function viewListChild(ev) {
            $mdDialog.show({
                controller: "ListApprovalMember",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-member.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoInsurance();
                    // $state.reload();
                },
                locals: {
                    // id:id
                }
            });
        }

        function viewJumRegisterNumber() {
            $state.go("app.endorsment-set-register-number");
        }

        function viewClaim() {
            $state.go("app.insurance_emp-claim_list");
        }

        function viewListAppOutletMapping(ev) {
            $mdDialog.show({
                controller: "ListOutletMappingController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/mapping/list-outlet-mapping.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {
                    // id:id
                }
            });
            // $state.go('app.cb_abnormal_approval');
        }

        function viewListAppSicMapping(ev) {
            $mdDialog.show({
                controller: "ListSicMappingController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/mapping/list-sic-mapping.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                    // $state.reload();
                },
                locals: {
                    // id:id
                }
            });
            // $state.go('app.cb_abnormal_approval');
        }

        function ofbApproval(ev) {
            $mdDialog.show({
                controller: "ListApprovalOffboardingController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-approval-ofb.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoApproval();
                },
                locals: {
                    // id:id
                }
            });

            // $state.go('app.ofb-registration_list');
        }

        function ofbExitApproval() {
            $state.go("app.ofb-exit_clearance_approval");
        }

        function ofbHandoverApproval() {
            $state.go("app.ofb-handover");
        }

        function ofbSetClearance() {
            $state.go("app.ofb-registration_list");
        }

        function toIndisciplinaryConfirm() {
            var data = angular.copy(
                vm.Approvalinfo.getInfoApproval.indisciplinaryConfirm
            );
            vm.Approvalinfo.getInfoApproval.totalApproval -=
                vm.Approvalinfo.getInfoApproval.jumIndisConfirm;
            vm.Approvalinfo.getInfoApproval.jumIndisConfirm = 0;
            vm.Approvalinfo.getInfoApproval.indisciplinaryConfirm = [];
            $state.go("app.indisciplinary_confirm", data);
        }

        function toIndisciplinaryApproval() {
            vm.Approvalinfo.getInfoApproval.totalApproval -=
                vm.Approvalinfo.getInfoApproval.jumIndisApproval;
            vm.Approvalinfo.getInfoApproval.jumIndisApproval = 0;
            $state.go("app.indisciplinary-approval");
        }

        function toIndisciplinaryValidation() {
            var data = angular.copy(
                vm.Approvalinfo.getInfoApproval.indisciplinaryValidation
            );
            vm.Approvalinfo.getInfoApproval.totalApproval -=
                vm.Approvalinfo.getInfoApproval.jumIndisValidation;
            vm.Approvalinfo.getInfoApproval.jumIndisValidation = 0;
            vm.Approvalinfo.getInfoApproval.indisciplinaryValidation = [];
            $state.go("app.indisciplinary_validation", data);
        }

        vm.viewMpnGwRevise = function () {
            $state.go("app.mpn_gw_list");
        };

        vm.viewMpnGwRecruit = function () {
            $state.go("app.mpn_gw_list_ta");
        };

        vm.viewMpnGwStoped = function () {
            $state.go("app.mpn_gw_list_change_quantity");
        };

        vm.viewAssignment = function () {
            if (vm.groupLogin == '135') {
                $state.go("app.cb_hr_team_assignment_approval");
            } else {
                $state.go("app.cb_team_assignment_approval");
            }
        };

        vm.viewJic = function () {
            $state.go("app.emp_jic");
        };

        vm.viewHcTicket = function () {
            $state.go("app.hcticket");
        };

        function viewResetSLT(ev) {
            $mdDialog.show({
                controller: "ListResetSltController",
                controllerAs: "vm",
                templateUrl:
                    "app/quick-panel/tabs/list-approval/list-reset-slt.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    infoInsurance();
                    // $state.reload();
                },
                locals: {
                    // id:id
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ListSicMappingController', ListSicMappingController);

    /** @ngInject */
    function ListSicMappingController(msApi,$localStorage,Form,$mdDialog,AppAPI,$http,config,Auth,Approvalinfo)
    {
        var vm = this;
        vm.data=$localStorage.InfoApproval;
        // vm.listApproval=id;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected=[]; 
        vm.closeModal = closeModal; 
        vm.approveSicMapping=approveSicMapping;

        var Sicmappingapproval=AppAPI.Sicmappingapproval();
        var InfoApproval=AppAPI.InfoApproval();
        var nik= $localStorage.user;
        
        vm.loadProcess=true;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.toogleSubChild=toogleSubChild;
		vm.visibleSubChild=[];
		
        // console.log(id);
        loadData();
        //////////

        function loadData() { 
          var lsApproval= new InfoApproval();
          var promise=lsApproval.$get({action:'viewDataApproval',type:'sicmapping'});
          promise.then(processInfo);
          promise.catch(errorProcessInfo);
        }

        function processInfo(data) {
          // vm.data=data;
          vm.listApproval=data.data[0];
          vm.loadProcess=false;
          // Approvalinfo.getInfoApproval=data;
          // console.log(vm.data);
        }

        function errorProcessInfo() {
          // vm.data=[];
          vm.listApproval=[];
          vm.loadProcess=false;
          // Approvalinfo.getInfoApproval={};
        } 

        function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
        {
            if ( event )
              {
                  event.stopPropagation();
              }

            var idx = vm.listOtselected.indexOf(ls);

            if ( idx > -1 )
              {
                  vm.listOtselected.splice(idx, 1);
              }
              else
              {
                  vm.listOtselected.push(ls);
              }
        }

    function toggleSelectedAll(state)
      {
        // console.log(state);
          switch(state)
          {
              case true:
              checkAll();
              break;
              case false:
              unCheckAll();
              break;
          }
      }

      function checkAll() {
         vm.listOtselected=angular.copy(vm.listApproval);
         // console.log(vm.listOtselected);
      }

      function unCheckAll() {
         vm.listOtselected=[];
      }
	  
	  function approveSicMapping(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    // console.log(vm.listOtselected);
                    var ot= new Sicmappingapproval();
                    ot.data=[];
                    ot.action='approve';
                    ot.nik=nik;  
                    for (i=0;i<jum;i++) {
                      ot.data.push({id:vm.listOtselected[i].id});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    //var response=tm.$delete({action:'approve'});
                    response.then(function(data){
                      // console.log(data.pesan);
                      successApproved(ev,data);
                      angular.element.unblockUI();
					});
				    response.catch(function(data){
					   // console.log(data.data);
					   failedApproved(ev,data.data);
					   angular.element.unblockUI();
					});
                }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
            }); 
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              Approvalinfo.getInfoApproval(); 
          });
        } 
      }
	  
      function successApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              // loadData();
              angular.element.unblockUI();
          });
        
      }

      function failedApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              // loadData();
              angular.element.unblockUI();
          });
        
      }

    function closeModal()
	{
		$mdDialog.hide();
	}
		
	function toogleSubChild(idx) {
		switch(vm.visibleSubChild[idx])
		{
			case true :
			vm.visibleSubChild[idx]=false;
			vm.icon='icon-minus';
			break;
			case false :
			vm.visibleSubChild[idx]=true;
			 vm.icon='icon-plus';
			break;
			default:
			   vm.visibleSubChild[idx]=true;
				vm.icon='icon-minus';
			break;
		}

	}

    } 
})();
(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('ListResetSltController', ListResetSltController);

  /** @ngInject */
  function ListResetSltController(
    $mdDialog,
    $state,
    AppAPI
  ) {
    var vm = this;
    var appApi = AppAPI.MpnResetSLT();

    vm.list = [];
    vm.closeModal = closeModal;
    vm.detail = detail;
    loadData();

    function loadData() {
      var promise = appApi.query({
        action: 'viewDataApproval'
      });
      promise.$promise.then(processInfo);
      promise.$promise.catch(errorProcessInfo);
    }

    function processInfo(data) {
      console.log(data);

      vm.list = data;
    }

    function errorProcessInfo(data) {
      vm.list = [];
      console.log(data);

    }

    function closeModal() {
      $mdDialog.hide();
    }

    function detail(id) {
      $mdDialog.hide();
      $state.go("app.mpn_request_view", {
        id: id
      });
    }
  }



})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ListOutletMappingController', ListOutletMappingController);

    /** @ngInject */
    function ListOutletMappingController(msApi,$localStorage,Form,$mdDialog,AppAPI,$http,config,Auth,Approvalinfo)
    {
        var vm = this;
        vm.data=$localStorage.InfoApproval;
        // vm.listApproval=id;
        vm.isChecked=isChecked;
        vm.toggleCheck = toggleCheck;
        vm.listOtselected=[]; 
        vm.closeModal = closeModal; 
        vm.approveOutletMapping=approveOutletMapping;

        var Amoutletmappingapproval=AppAPI.Amoutletmappingapproval();
        var InfoApproval=AppAPI.InfoApproval();
        var nik= $localStorage.user;
        
        vm.loadProcess=true;
        vm.toggleSelectedAll=toggleSelectedAll;
        vm.toogleSubChild=toogleSubChild;
		vm.visibleSubChild=[];
		
        // console.log(id);
        loadData();
        //////////

        function loadData() { 
          var lsApproval= new InfoApproval();
          var promise=lsApproval.$get({action:'viewDataApproval',type:'outletmapping'});
          promise.then(processInfo);
          promise.catch(errorProcessInfo);
        }

        function processInfo(data) {
          // vm.data=data;
          vm.listApproval=data.data[0];
          vm.loadProcess=false;
          // Approvalinfo.getInfoApproval=data;
          // console.log(vm.data);
        }

        function errorProcessInfo() {
          // vm.data=[];
          vm.listApproval=[];
          vm.loadProcess=false;
          // Approvalinfo.getInfoApproval={};
        } 

        function isChecked(ls)
        {
            return vm.listOtselected.indexOf(ls) > -1;
        }

        function toggleCheck(ls, event)
        {
            if ( event )
              {
                  event.stopPropagation();
              }

            var idx = vm.listOtselected.indexOf(ls);

            if ( idx > -1 )
              {
                  vm.listOtselected.splice(idx, 1);
              }
              else
              {
                  vm.listOtselected.push(ls);
              }
        }

    function toggleSelectedAll(state)
      {
        // console.log(state);
          switch(state)
          {
              case true:
              checkAll();
              break;
              case false:
              unCheckAll();
              break;
          }
      }

      function checkAll() {
         vm.listOtselected=angular.copy(vm.listApproval);
         // console.log(vm.listOtselected);
      }

      function unCheckAll() {
         vm.listOtselected=[];
      }
	  
	  function approveOutletMapping(ev)
      {
        var jum=vm.listOtselected.length,i,ids=[];
        if(jum>0)
        {
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                    angular.element.blockUI();
                    // console.log(vm.listOtselected);
                    var ot= new Amoutletmappingapproval();
                    ot.data=[];
                    ot.action='approve';
                    ot.nik=nik;  
                    for (i=0;i<jum;i++) {
                      ot.data.push({id:vm.listOtselected[i].id});
                    }
                    var idtx=encodeURIComponent(angular.toJson(ids));
                    var response=ot.$save(); 
                    //var response=tm.$delete({action:'approve'});
                    response.then(function(data){
                      // console.log(data.pesan);
                      successApproved(ev,data);
                      angular.element.unblockUI();
					});
				    response.catch(function(data){
					   // console.log(data.data);
					   failedApproved(ev,data.data);
					   angular.element.unblockUI();
					});
                }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
            }); 
        }else{
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Attention!')
          .textContent('No data selected')
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              Approvalinfo.getInfoApproval(); 
          });
        } 
      }
	  
      function successApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              // loadData();
              angular.element.unblockUI();
          });
        
      }

      function failedApproved(ev,data)
      {
          $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
          ).then(function(){
              // loadData();
              angular.element.unblockUI();
          });
        
      }

    function closeModal()
	{
		$mdDialog.hide();
	}
		
	function toogleSubChild(idx) {
		switch(vm.visibleSubChild[idx])
		{
			case true :
			vm.visibleSubChild[idx]=false;
			vm.icon='icon-minus';
			break;
			case false :
			vm.visibleSubChild[idx]=true;
			 vm.icon='icon-plus';
			break;
			default:
			   vm.visibleSubChild[idx]=true;
				vm.icon='icon-minus';
			break;
		}

	}

    } 
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ListApprovalOffboardingController', ListApprovalOffboardingController);

    /** @ngInject */
    function ListApprovalOffboardingController($localStorage, $mdDialog, $http, $state, config, DataService, AppAPI, Auth)
    {
        var vm = this;
        vm.DataTable = new DataService();
        var OfbRegistration = AppAPI.OfbRegistration();
        
        vm.closeModal = closeModal;

        vm.listOfbselected = [];
        vm.toggleSelectedAll = toggleSelectedAll; 
        vm.approve = approve;
        vm.Reject = Reject;
        vm.detail = detail;

        loadData();

        function loadData() {
            return $http
                .get(config.api + 'api/ofb/registration/notifApproval')
                .then(function (item) {
                    processInfo(item.data[0].aData);
                });
        }

        function processInfo(data) {
            vm.list = data;
            
        }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function toggleSelectedAll(state) {
            switch (state) {
                case true:
                    checkAll();
                    break;
                case false:
                    unCheckAll();
                    break;
            }
        }

        function checkAll() {
            vm.listOfbselected = angular.copy(vm.list);
        }

        function unCheckAll() {
            vm.listOfbselected = [];
        }

        function approve(ev) {
            var jum = vm.listOfbselected.length, i, ids = [];
            var nik = $localStorage.user;
            

            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Approve this list?')
                        .textContent('All data your selected will be approve.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        // angular.element.blockUI();
                        console.log(vm.listOfbselected);

                        var ot = new OfbRegistration();
                        ot.data = [];
                        ot.action = 'batchApproval';
                        ot.status = 1;
                        
                        for (i = 0; i < jum; i++) {
                            if (vm.listOfbselected[i].approved_by == nik){
                                var approved = "n1"
                            }
                            else{
                                var approved = "hr"
                            }
                            ot.data.push({ id: vm.listOfbselected[i].id, approveBy: approved });
                        }
                        var response = ot.$save();  
                        
                        response.then(function (data) {
                            successApproved(ev, data);
                            angular.element.unblockUI();
                        });
                        response.catch(function (data) {
                            failedApproved(ev, data.data);
                            angular.element.unblockUI();
                        });
                    }, function () {
                    });
                });
            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention!')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    closeModal();
                });
            }

        }

        function successApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Thanks for Approval')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                // loadData();
            });

        }

        function failedApproved(ev, data) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#contentDialog')))
                    .clickOutsideToClose(true)
                    .title('Failed Approval')
                    .textContent(data.pesan)
                    .ariaLabel('Attention')
                    .ok('close')
                    .targetEvent(ev)
            ).then(function () {
                // loadData();
            });

        }

        function Reject(ev) {
            var jum = vm.listOfbselected.length, i, ids = [];
            var nik = $localStorage.user;

            if (jum > 0) {
                var promise = Auth.setToken();
                promise.then(function () {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to Reject this list?')
                        .textContent('All data your selected will be reject.')
                        .ariaLabel('delete dialog')
                        .targetEvent(ev)
                        .ok('YES')
                        .cancel('no');
                    $mdDialog.show({
                        multiple: true
                    });
                    $mdDialog.show(confirm).then(function () {
                        // angular.element.blockUI();
                        console.log(vm.listOfbselected);

                        var ot = new OfbRegistration();
                        ot.data = [];
                        ot.action = 'batchApproval';
                        ot.status = 2;

                        for (i = 0; i < jum; i++) {
                            if (vm.listOfbselected[i].approved_by == nik) {
                                var approved = "n1"
                            }
                            else {
                                var approved = "hr"
                            }
                            ot.data.push({ id: vm.listOfbselected[i].id, approveBy: approved });
                        }
                        var response = ot.$save();

                        response.then(function (data) {
                            successApproved(ev, data);
                            angular.element.unblockUI();
                        });
                        response.catch(function (data) {
                            failedApproved(ev, data.data);
                            angular.element.unblockUI();
                        });
                    }, function () {
                    });
                });



            } else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#contentDialog')))
                        .clickOutsideToClose(true)
                        .title('Attention!')
                        .textContent('No data selected')
                        .ariaLabel('Attention')
                        .ok('close')
                        .targetEvent(ev)
                ).then(function () {
                    closeModal();
                    // Approvalinfo.getInfoApproval();
                });
            }
        }

        function detail(id) {
            $state.go('app.ofb-registration_detail', { id: id });
        }
    } 
})();
(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('ListApprovalController', ListApprovalController);

  /** @ngInject */
  function ListApprovalController(msApi, $localStorage, Form, $mdDialog, AppAPI, $http, config, Auth, Approvalinfo, $filter) {
    var vm = this;
    var translate = $filter('translate');
    vm.data = $localStorage.InfoApproval;

    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.closeModal = closeModal;
    vm.Reject = Reject;
    var Approvalabsence = AppAPI.Approvalabsence();
    var InfoApproval = AppAPI.InfoApproval();
    vm.loadProcess = true;
    vm.toggleSelectedAll = toggleSelectedAll;

    // console.log(id);
    loadData();

    //////////

    function loadData() {
      var lsApproval = new InfoApproval();
      var promise = lsApproval.$get({ action: 'viewDataApproval', type: 'leave' });
      promise.then(processInfo);
      promise.catch(errorProcessInfo);
    }

    function processInfo(data) {
      // vm.data=data;

      vm.listApproval = data.data;
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval=data;
      // console.log(vm.data);
    }

    function errorProcessInfo() {
      // vm.data=[];
      vm.listApproval = [];
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval={};
    }


    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.listApproval);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      var nik = $localStorage.user;
      $localStorage.InfoApproval = [];
      // console.log(vm.listOtselected);
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            // console.log(vm.listOtselected);
            var ot = new Approvalabsence();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            ot.approval_type = 'n1';
            for (i = 0; i < jum; i++) {
              ot.data.push({ id: vm.listOtselected[i].id });
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              // console.log(data.pesan);
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
            response.catch(function (data) {
              // console.log(data.data);
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          closeModal();
          // Approvalinfo.getInfoApproval();
        });
      }

    }

    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        // loadData();
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        // loadData();
      });

    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {

        $mdDialog.show({
          controller: 'LeaveRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/approval-absence/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            closeModal();
            // Approvalinfo.getInfoApproval();
            vm.listOtselected = [];
          },
          locals: {

            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          closeModal();
          // Approvalinfo.getInfoApproval();
        });
      }
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('ListApprovalOTGwController', ListApprovalOTGwController);
  
    ListApprovalOTGwController.$inject = ['msApi',
      '$localStorage',
      'Form',
      '$mdDialog',
      'AppAPI',
      '$http',
      'config',
      'Auth',
      'Approvalinfo'];
  /** @ngInject */
  function ListApprovalOTGwController(
    msApi,
    $localStorage,
    Form,
    $mdDialog,
    AppAPI,
    $http,
    config,
    Auth,
    Approvalinfo
  ) {
    var vm = this;

    var Employegw = AppAPI.ApprovalOvertimeGw(); 
    // set constructor form
    Form.setObject(Employegw); 
    // set form to controller
    vm.Form = Form;

    vm.data = $localStorage.InfoApproval;
    // vm.listApproval=id;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.closeModal = closeModal;
    vm.Reject = Reject;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.nik = $localStorage.user;
    var InfoApproval = AppAPI.InfoApproval();
    vm.loadProcess = true;
    var Employegw = AppAPI.ApprovalOvertimeGw();

    vm.loadData = loadData;
    vm.stateEdit=false;
    vm.getEmployee=getEmployee;
    vm.selectedItemChanged=selectedItemChanged;

    // set constructor form
    Form.setObject(Employegw);

    // console.log(id);
    loadData();
    //////////

    function loadData() {
      var lsApproval = new InfoApproval();
      var promise = lsApproval.$get({
        action: 'viewDataApproval',
        type: 'overtimegw',
        date:vm.ot_date,
        nik:vm.Form.objForm.nik,
        atasan:vm.Form.objForm.atasan
      });
      promise.then(processInfo);
      promise.catch(errorProcessInfo);
    }

    function processInfo(data) {
      // vm.data=data;

      vm.listApproval = data.data;
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval=data;
      // console.log(vm.data);
    }

    function errorProcessInfo() {
      // vm.data=[];
      vm.listApproval = [];
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval={};
    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      } else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.listApproval);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title('Would you like to Approve this list?')
            .textContent('All data your selected will be approve.')
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok('YES')
            .cancel('no');
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new Employegw();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = vm.nik;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              successApproved(ev, data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
            response.catch(function (data) {
              failedApproved(ev, data.data);
              angular.element.unblockUI();
              vm.listOtselected = [];
            });
          }, function () {
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        if ('moreInfo' in data && data.moreInfo.length > 0) {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            onRemoving: function (element, removePromise) {
              loadData(1);
            },
            locals: {
              data: data.moreInfo
            }
          });
        } else {
          loadData(1);
        }
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.message)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        loadData();
      });
    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        $mdDialog.show({
          controller: 'OvertimeGwRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/approval-overtime-gw/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }
    }

    // function approveOT(ev) {
    //   var jum = vm.listOtselected.length,
    //     i,
    //     ids = [];
    //   if (jum > 0) {
    //     var nik = $localStorage.user;
    //     var promise = Auth.setToken();
    //     promise.then(function () {
    //       var confirm = $mdDialog
    //         .confirm()
    //         .title('Would you like to Approve this list?')
    //         .textContent('All data your selected will be approve.')
    //         .ariaLabel('delete dialog')
    //         .targetEvent(ev)
    //         .ok('YES')
    //         .cancel('no');
    //       $mdDialog.show({
    //         multiple: true
    //       });
    //       $mdDialog.show(confirm).then(
    //         function () {
    //           angular.element.blockUI();
    //           // console.log(vm.listOtselected);
    //           var ot = new Approvalot();
    //           ot.data = [];
    //           ot.action = 'approve';
    //           ot.nik = nik;
    //           for (i = 0; i < jum; i++) {
    //             ot.data.push({ id: vm.listOtselected[i].id });
    //           }
    //           var idtx = encodeURIComponent(angular.toJson(ids));
    //           var response = ot.$save();
    //           response.then(function (data) {
    //             // console.log(data.pesan);
    //             successApproved(ev, data);
    //             angular.element.unblockUI();
    //           });
    //           response.catch(function (data) {
    //             // console.log(data.data);
    //             failedApproved(ev, data.data);
    //             angular.element.unblockUI();
    //           });
    //         },
    //         function () {
    //           // $scope.status = 'You decided to keep your debt.';
    //         }
    //       );
    //     });
    //   } else {
    //     $mdDialog
    //       .show(
    //         $mdDialog
    //           .alert()
    //           .parent(
    //             angular.element(
    //               document.querySelector('#contentDialog')
    //             )
    //           )
    //           .clickOutsideToClose(true)
    //           .title('Attention!')
    //           .textContent('No data selected')
    //           .ariaLabel('Attention')
    //           .ok('close')
    //           .targetEvent(ev)
    //       )
    //       .then(function () {
    //         // Approvalinfo.getInfoApproval();
    //         angular.element.unblockUI();
    //       });
    //   }
    // }

    // function successApproved(ev, data) {

    //   var confirm = $mdDialog
    //     .confirm()
    //     .multiple(true)
    //     .title('Thanks for Approval')
    //     .textContent(data.pesan)
    //     .ariaLabel('Attention')
    //     .clickOutsideToClose(true)
    //     .targetEvent(ev)
    //     .ok('close')
    //     .cancel('More Info');

    //   $mdDialog.show(confirm).then(
    //     function () { },
    //     function () {
    //       $mdDialog.show({
    //         controller: 'logFailGwController',
    //         controllerAs: 'vm',
    //         multiple: true,
    //         templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
    //         parent: angular.element(document.body),
    //         clickOutsideToClose: true,
    //         fullscreen: true,
    //         locals: {
    //           data: data.moreInfo
    //         }
    //       });
    //     }
    //   );
    // }

    // function failedApproved(ev, data) {
    //   $mdDialog
    //     .show(
    //       $mdDialog
    //         .alert()
    //         .parent(
    //           angular.element(document.querySelector('#contentDialog'))
    //         )
    //         .clickOutsideToClose(true)
    //         .title('Failed Approval')
    //         .textContent(data.pesan)
    //         .ariaLabel('Attention')
    //         .ok('close')
    //         .targetEvent(ev)
    //     )
    //     .then(function () {
    //       // loadData();
    //     });
    // }

    // function Reject(ev) {
    //   var jum = vm.listOtselected.length,
    //     i,
    //     ids = [];
    //   if (jum > 0) {
    //     $mdDialog.show({
    //       controller: 'ApproveOtRejectCommentController',
    //       controllerAs: 'vm',
    //       templateUrl: 'app/main/cb/approval-ot/comment-reject.html',
    //       parent: angular.element(document.body),
    //       targetEvent: ev,
    //       clickOutsideToClose: true,
    //       fullscreen: true,
    //       onRemoving: function (element, removePromise) {
    //         loadData();
    //         vm.listOtselected = [];
    //       },
    //       locals: {
    //         id: vm.listOtselected
    //       }
    //     });
    //   } else {
    //     $mdDialog
    //       .show(
    //         $mdDialog
    //           .alert()
    //           .parent(
    //             angular.element(
    //               document.querySelector('#contentDialog')
    //             )
    //           )
    //           .clickOutsideToClose(true)
    //           .title('Attention!')
    //           .textContent('No data selected')
    //           .ariaLabel('Attention')
    //           .ok('close')
    //           .targetEvent(ev)
    //       )
    //       .then(function () {
    //         // Approvalinfo.getInfoApproval();
    //         angular.element.unblockUI();
    //       });
    //   }
    // }

    function closeModal() {
      $mdDialog.hide();
    }

    function getEmployee(searchText){

        return $http
      .get(config.api + 'api/approvalovertimegw?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
      .then(function(item) {
        // Map the response object to the data object.
        if(item.data.length===''){
          Form.objForm.empno='';
        } 
          return item.data;
      });
    }
    
    function selectedItemChanged(employee)
    {
          
          vm.Form.objForm.atasan='';
          vm.Form.objForm.fullname='';
          vm.isDisabled=false;
          vm.Form.objForm.fullname=vm.searchString; 
          if(typeof employee!=='undefined')
          {
            vm.Form.objForm.atasan=employee.empno;
            vm.Form.objForm.fullname=employee.fullname;
            vm.isDisabled=true;
    
          }
    }

    function viewMoreInfo(detail) {
      $mdDialog.show({
        controller: 'logFailGwController',
        controllerAs: 'vm',
        multiple: true,
        templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        locals: {
          data: detail
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('ListApprovalOTController', ListApprovalOTController);

  /** @ngInject */
  function ListApprovalOTController(
    msApi,
    $localStorage,
    Form,
    $mdDialog,
    AppAPI,
    $http,
    config,
    Auth,
    $filter,
    Approvalinfo
  ) {
    var vm = this;
    vm.data = $localStorage.InfoApproval;
    // vm.listApproval=id;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.closeModal = closeModal;
    vm.Reject = Reject;
    var Approvalot = AppAPI.Approvalot();
    var InfoApproval = AppAPI.InfoApproval();
    vm.loadProcess = true;
    vm.toggleSelectedAll = toggleSelectedAll;

    var translate = $filter('translate');
    loadData();
    //////////

    function loadData() {
      var lsApproval = new InfoApproval();
      var promise = lsApproval.$get({
        action: 'viewDataApproval',
        type: 'overtime'
      });
      promise.then(processInfo);
      promise.catch(errorProcessInfo);
    }

    function processInfo(data) {
      // vm.data=data;

      vm.listApproval = data.data;
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval=data;
      // console.log(vm.data);
    }

    function errorProcessInfo() {
      // vm.data=[];
      vm.listApproval = [];
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval={};
    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      } else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.listApproval);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveOT(ev) {
      var jum = vm.listOtselected.length,
        i,
        ids = [];
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var nik = $localStorage.user;
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog
            .confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(
            function () {
              angular.element.blockUI();
              // console.log(vm.listOtselected);
              var ot = new Approvalot();
              ot.data = [];
              ot.action = 'approve';
              ot.nik = nik;
              for (i = 0; i < jum; i++) {
                ot.data.push({ id: vm.listOtselected[i].id });
              }
              var idtx = encodeURIComponent(angular.toJson(ids));
              var response = ot.$save();
              response.then(function (data) {
                // console.log(data.pesan);
                angular.element.unblockUI();
                showDialogInfo(ev, data);
              });
              response.catch(function (data) {
                // console.log(data.data);
                angular.element.unblockUI();
                showDialogInfo(ev, data.data);
              });
            },
            function () {
              // $scope.status = 'You decided to keep your debt.';
            }
          );
        });
      } else {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(
                angular.element(
                  document.querySelector('#contentDialog')
                )
              )
              .clickOutsideToClose(true)
              .title('Attention!')
              .textContent('No data selected')
              .ariaLabel('Attention')
              .ok('close')
              .targetEvent(ev)
          )
          .then(function () {
            // Approvalinfo.getInfoApproval();
            angular.element.unblockUI();
          });
      }
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              onRemoving: function (element, removePromise) {
                loadData(1);
              },
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        });
    }
    function successApproved(ev, data) {
      // $mdDialog
      //     .show(
      //         $mdDialog
      //             .alert()
      //             .parent(
      //                 angular.element(document.querySelector('#contentDialog'))
      //             )
      //             .clickOutsideToClose(true)
      //             .title('Thanks for Approval')
      //             .textContent(data.pesan)
      //             .ariaLabel('Attention')
      //             .ok('close')
      //             .targetEvent(ev)
      //     )
      //     .then(function() {
      //         // loadData();
      //     });

      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title('Thanks for Approval')
        .textContent(data.pesan)
        .ariaLabel('Attention')
        .clickOutsideToClose(true)
        .targetEvent(ev)
        .ok('close')
        .cancel('More Info');

      $mdDialog.show(confirm).then(
        function () { },
        function () {
          $mdDialog.show({
            controller: 'logFailGwController',
            controllerAs: 'vm',
            multiple: true,
            templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
              data: data.moreInfo
            }
          });
        }
      );
    }

    function failedApproved(ev, data) {
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(
              angular.element(document.querySelector('#contentDialog'))
            )
            .clickOutsideToClose(true)
            .title('Failed Approval')
            .textContent(data.pesan)
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        )
        .then(function () {
          // loadData();
        });
    }

    function Reject(ev) {
      var jum = vm.listOtselected.length,
        i,
        ids = [];
      if (jum > 0) {
        $mdDialog.show({
          controller: 'ApproveOtRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/approval-ot/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog
          .show(
            $mdDialog
              .alert()
              .parent(
                angular.element(
                  document.querySelector('#contentDialog')
                )
              )
              .clickOutsideToClose(true)
              .title('Attention!')
              .textContent('No data selected')
              .ariaLabel('Attention')
              .ok('close')
              .targetEvent(ev)
          )
          .then(function () {
            // Approvalinfo.getInfoApproval();
            angular.element.unblockUI();
          });
      }
    }

    function closeModal() {
      $mdDialog.hide();
    }
  }

  function viewMoreInfo(detail) {
    $mdDialog.show({
      controller: 'logFailGwController',
      controllerAs: 'vm',
      multiple: true,
      templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: true,
      locals: {
        data: detail
      }
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ListApprovalMember', ListApprovalMember);

    /** @ngInject */
    ListApprovalMember.$inject = ['$state', '$log', '$mdDialog', '$window', '$location', 'config', 'AppAPI', 'Auth'];
    function ListApprovalMember($state, $log, $mdDialog, $window, $location, config, AppAPI, Auth)
    {
        var vm = this;
        vm.approve=approve;
        vm.closeModal = closeModal;
        var InfoApproval=AppAPI.InfoApproval();
        var Insurance = AppAPI.Insurance();
        vm.loadProcess=true;

        loadData();

        function loadData() { 
          var promise = InfoApproval.query({action:'viewDataApprovalInsurance', type:'member'});
          promise.$promise.then(processInfo);
          promise.$promise.catch(errorProcessInfo);
        }

        function processInfo(data) {
          vm.listApproval=data;
          vm.loadProcess=false;
        }

        function errorProcessInfo() {
          vm.listApproval=[];
          vm.loadProcess=false;
        }
        
        function approve(ev){
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                var response=Insurance.save({action:'activateMember', data:angular.toJson(vm.listApproval), effectiveDate:vm.date} );
                response.$promise.then( function(data){
                ExportToExcel();
                });          
              }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
          }); 

        }

        function ExportToExcel() {
         
          var confirm = $mdDialog.confirm()
              .title('Download file')
              .textContent('Would you want download file?')
              .ariaLabel('delete dialog')
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {     

            var token=Auth.setTokenPromise();
            token.then(function(){
                var protocol=$location.protocol();
                var host=$location.host();
                $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirPenambahan/'+token+'/download', '_blank');
                closeModal();
            },function(){
                $window.alert('gagal load token');
            });

          }, function() { 

            var token=Auth.setTokenPromise();
            token.then(function(){
                var protocol=$location.protocol();
                var host=$location.host();
                $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirPenambahan/'+token+'/undownload', '_blank');
                closeModal();
            },function(){
                $window.alert('gagal load token');
            });

          });
        }

        function closeModal(){
          $mdDialog.hide();
        }
        
      } 

})();

(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('ListApprovalGHKController', ListApprovalGHKController);

  /** @ngInject */
  function ListApprovalGHKController(msApi, $localStorage, Form, $mdDialog, AppAPI, $http, config, Auth, Approvalinfo, type, $filter) {
    var vm = this;

    var translate = $filter('translate');

    vm.data = $localStorage.InfoApproval;
    // vm.listApproval=id;
    var Employegw = AppAPI.ApprovalOvertimeGw();
    // set constructor form
    Form.setObject(Employegw);
    // set form to controller
    vm.Form = Form;

    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveOT = approveOT;
    vm.closeModal = closeModal;
    vm.Reject = Reject;
    var Approvalghk = AppAPI.Approvalghk();
    var InfoApproval = AppAPI.InfoApproval();
    vm.loadProcess = true;
    vm.toggleSelectedAll = toggleSelectedAll;
    vm.type_id = '0';

    vm.loadData = loadData;
    vm.stateEdit = false;
    vm.getEmployee = getEmployee;
    vm.selectedItemChanged = selectedItemChanged;

    switch (type) {
      case 'ghk':
        vm.type_id = '0';
        break;
      case 'ghkholiday':
        vm.type_id = '1';
        break;
      case 'ghkhalfday':
        vm.type_id = '2';
        break;
      default:
        vm.type_id = '0';
        break;
    }

    vm.Form.objForm.atasan = '';

    loadData();
    //////////

    function loadData() {
      var lsApproval = new InfoApproval();
      var promise = lsApproval.$get({ action: 'viewDataApproval', type: type, date: vm.date, nik: vm.Form.objForm.nik, atasan: vm.Form.objForm.atasan });
      promise.then(processInfo);
      promise.catch(errorProcessInfo);
    }

    function processInfo(data) {
      // vm.data=data;

      vm.listApproval = data.data;
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval=data;
    }

    function errorProcessInfo() {
      // vm.data=[];
      vm.listApproval = [];
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval={};
    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.listApproval);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }


    function approveOT(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var nik = $localStorage.user;
        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            var ot = new Approvalghk();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            ot.type = vm.type_id;
            for (i = 0; i < jum; i++) {
              ot.data.push(vm.listOtselected[i]);
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
            response.catch(function (data) {
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          // Approvalinfo.getInfoApproval();
          angular.element.unblockUI();
        });
      }
    }

    function successApproved(ev, data) {

      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title('Thanks for Approval')
        .textContent(data.pesan)
        .ariaLabel('Attention')
        .clickOutsideToClose(true)
        .targetEvent(ev)
        .ok('close');

      $mdDialog.show(confirm).then(
        function () { },
        function () {
          if ('moreInfo' in data && data.moreInfo.length > 0) {
            $mdDialog.show({
              controller: 'logFailGwController',
              controllerAs: 'vm',
              multiple: true,
              templateUrl: 'app/main/cb/ghk-gw/log-fail.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true,
              locals: {
                data: data.moreInfo
              }
            });
          } else {
            loadData(1);
          }
        }
      );

      // $mdDialog.show(
      //   $mdDialog.alert()
      //     .parent(angular.element(document.querySelector('#contentDialog')))
      //     .clickOutsideToClose(true)
      //     .title('Thanks for Approval')
      //     .textContent(data.pesan)
      //     .ariaLabel('Attention')
      //     .ok('close')
      //     .targetEvent(ev)
      // ).then(function () {
      //   // loadData();
      //   angular.element.unblockUI();
      // });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        // loadData();
        angular.element.unblockUI();
      });
    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {

        $mdDialog.show({
          controller: 'GhkRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/approval-ghk/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          // Approvalinfo.getInfoApproval();
          angular.element.unblockUI();
        });
      }
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function getEmployee(searchText) {

      return $http
        .get(config.api + 'api/approvalovertimegw?action=searchEmployee&id=' + searchText + '&company=' + $localStorage.empsite)
        .then(function (item) {
          // Map the response object to the data object.
          if (item.data.length === '') {
            Form.objForm.empno = '';
          }
          return item.data;
        });
    }

    function selectedItemChanged(employee) {

      vm.Form.objForm.atasan = '';
      vm.Form.objForm.fullname = '';
      vm.isDisabled = false;
      vm.Form.objForm.fullname = vm.searchString;
      if (typeof employee !== 'undefined') {
        vm.Form.objForm.atasan = employee.empno;
        vm.Form.objForm.fullname = employee.fullname;
        vm.isDisabled = true;

      }
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('ListApprovalFingerController', ListApprovalFingerController);

  /** @ngInject */
  function ListApprovalFingerController(msApi, $localStorage, Form, $mdDialog, AppAPI, $http, config, Auth, Approvalinfo, $filter) {
    var vm = this;

    var translate = $filter('translate');

    vm.data = $localStorage.InfoApproval;
    // vm.listApproval=id;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.closeModal = closeModal;
    vm.approveAbnormal = approveAbnormal;
    var Approvalfinger = AppAPI.Approvalfinger();
    vm.Reject = Reject;
    var InfoApproval = AppAPI.InfoApproval();
    vm.loadProcess = true;
    vm.toggleSelectedAll = toggleSelectedAll;

    // console.log(id);
    loadData();
    //////////

    function loadData() {
      var lsApproval = new InfoApproval();
      var promise = lsApproval.$get({ action: 'viewDataApproval', type: 'upfinger' });
      promise.then(processInfo);
      promise.catch(errorProcessInfo);
    }

    function processInfo(data) {
      // vm.data=data;

      vm.listApproval = data.data;
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval=data;
      // console.log(vm.data);
    }

    function errorProcessInfo() {
      // vm.data=[];
      vm.listApproval = [];
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval={};
    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.listApproval);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveAbnormal(ev) {
      // console.log(vm.listOtselected);
      var nik = $localStorage.user;
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            // console.log(vm.listOtselected);
            var ot = new Approvalfinger();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push({
                id: vm.listOtselected[i].id
              });
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              // console.log(data.pesan);
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
            response.catch(function (data) {
              // console.log(data.data);
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          Approvalinfo.getInfoApproval();
        });
      }
    }

    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        // loadData();
        angular.element.unblockUI();
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        // loadData();
        angular.element.unblockUI();
      });

    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        $mdDialog.show({
          controller: 'UpFingerRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/update-finger-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }

    }

    function closeModal() {
      $mdDialog.hide();
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('ListApprovalChangeShiftController', ListApprovalChangeShiftController);

  /** @ngInject */
  function ListApprovalChangeShiftController(msApi, $localStorage, Form, $mdDialog, AppAPI, $http, config, Auth, Approvalinfo, $filter) {
    var vm = this;

    var translate = $filter('translate');

    vm.data = $localStorage.InfoApproval;
    // vm.listApproval=id;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.approveChangeshift = approveChangeshift;
    vm.closeModal = closeModal;
    vm.Reject = Reject;
    var Changeshiftapproval = AppAPI.Changeshiftapproval();
    var InfoApproval = AppAPI.InfoApproval();
    vm.loadProcess = true;
    vm.toggleSelectedAll = toggleSelectedAll;

    // console.log(id);
    loadData();

    //////////

    function loadData() {
      var lsApproval = new InfoApproval();
      var promise = lsApproval.$get({ action: 'viewDataApproval', type: 'changeshift' });
      promise.then(processInfo);
      promise.catch(errorProcessInfo);
    }

    function processInfo(data) {
      // vm.data=data;

      vm.listApproval = data.data;
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval=data;
      // console.log(vm.data);
    }

    function errorProcessInfo() {
      // vm.data=[];
      vm.listApproval = [];
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval={};
    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }

    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.listApproval);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }


    function approveChangeshift(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      var nik = $localStorage.user;
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            // console.log(vm.listOtselected);
            var ot = new Changeshiftapproval();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push({
                id: vm.listOtselected[i].id,
                idshift: vm.listOtselected[i].idshift,
                nik: vm.listOtselected[i].nik,
                iStartShift: vm.listOtselected[i].iStartShift,
                iEndShift: vm.listOtselected[i].iEndShift,
                tgl: vm.listOtselected[i].tgl,
                level: vm.listOtselected[i].level,
                lastApproval: vm.listOtselected[i].is_last_approval,
                days_limit_approval: vm.listOtselected[i].days_limit_approval,
                approvalId: vm.listOtselected[i].approvalId
              });

              // ot.data.push({id:vm.listOtselected[i].id,
              //               idshift:vm.listOtselected[i].idshift,
              //               nik:vm.listOtselected[i].nik,
              //               tgl:vm.listOtselected[i].tgl});
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              // console.log(data.pesan);
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
            response.catch(function (data) {
              // console.log(data.data);
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
            // angular.element.unblockUI();
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          // Approvalinfo.getInfoApproval();
          angular.element.unblockUI();
          closeModal();
        });
      }
    }

    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        // loadData();
        angular.element.unblockUI();
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        // loadData();
        angular.element.unblockUI();
      });
    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var data = [];
        for (i = 0; i < jum; i++) {
          data.push({
            id: vm.listOtselected[i].id,
            idshift: vm.listOtselected[i].idshift,
            nik: vm.listOtselected[i].nik,
            tgl: vm.listOtselected[i].tgl
          });
        }

        $mdDialog.show({
          controller: 'ChangeshiftRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/changeshift-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
          },
          locals: {
            id: data
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          // Approvalinfo.getInfoApproval();
          angular.element.unblockUI();
          closeModal();
        });
      }
    }

    function closeModal() {
      $mdDialog.hide();
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ListApprovalChangeMarital', ListApprovalChangeMarital);

    /** @ngInject */
    ListApprovalChangeMarital.$inject = ['$state', '$log', '$mdDialog', '$window', '$location', 'config', 'AppAPI', 'Auth'];
    function ListApprovalChangeMarital($state, $log, $mdDialog, $window, $location, config, AppAPI, Auth)
    {
        var vm = this;
        vm.approve=approve;
        vm.closeModal = closeModal;
        var InfoApproval=AppAPI.InfoApproval();
        vm.loadProcess=true;

        loadData();

        function loadData() { 
          var promise = InfoApproval.query({action:'viewDataApprovalInsurance', type:'marital'});
          promise.$promise.then(processInfo);
          promise.$promise.catch(errorProcessInfo);
        }

        function processInfo(data) {
          vm.listApproval=data;
          vm.loadProcess=false;
        }

        function errorProcessInfo() {
          vm.listApproval=[];
          vm.loadProcess=false;
        }
        
        function approve(ev){
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                ExportToExcel();
              }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
          }); 

        }

        function ExportToExcel() {
         
          var confirm = $mdDialog.confirm()
              .title('Download file')
              .textContent('Would you want download file?')
              .ariaLabel('delete dialog')
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {     

            var token=Auth.setTokenPromise();
            token.then(function(){
                var protocol=$location.protocol();
                var host=$location.host();
                $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirUbahMarital/'+token+'/download', '_blank');
                closeModal();
            },function(){
                $window.alert('gagal load token');
            });

          }, function() { 

            var token=Auth.setTokenPromise();
            token.then(function(){
                var protocol=$location.protocol();
                var host=$location.host();
                $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirUbahMarital/'+token+'/undownload', '_blank');
                closeModal();
            },function(){
                $window.alert('gagal load token');
            });

          });
        }

        function closeModal(){
          $mdDialog.hide();
        }

      } 

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ListApprovalChangeGrade', ListApprovalChangeGrade);

    /** @ngInject */
    ListApprovalChangeGrade.$inject = ['$state', '$log', '$mdDialog', '$window', '$location', 'config', 'AppAPI', 'Auth'];
    function ListApprovalChangeGrade($state, $log, $mdDialog, $window, $location, config, AppAPI, Auth)
    {
        var vm = this;
        vm.approve=approve;
        vm.closeModal = closeModal;
        var InfoApproval=AppAPI.InfoApproval();
        vm.loadProcess=true;

        loadData();

        function loadData() { 
          var promise = InfoApproval.query({action:'viewDataApprovalInsurance', type:'grade'});
          promise.$promise.then(processInfo);
          promise.$promise.catch(errorProcessInfo);
        }

        function processInfo(data) {
          vm.listApproval=data;
          vm.loadProcess=false;
        }

        function errorProcessInfo() {
          vm.listApproval=[];
          vm.loadProcess=false;
        }
        
        function approve(ev){
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                ExportToExcel();
              }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
          }); 

        }

        function ExportToExcel() {
          var confirm = $mdDialog.confirm()
              .title('Download file')
              .textContent('Would you want download file?')
              .ariaLabel('delete dialog')
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {

              var token=Auth.setTokenPromise();
              token.then(function(){
                  var protocol=$location.protocol();
                  var host=$location.host();
                  $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirUbahGrade/'+token+'/download', '_blank');
                  closeModal();
              },function(){
                  $window.alert('gagal load token');
              });

          }, function() {

              var token=Auth.setTokenPromise();
              token.then(function(){
                  var protocol=$location.protocol();
                  var host=$location.host();
                  $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirUbahGrade/'+token+'/undownload', '_blank');
                  closeModal();
              },function(){
                  $window.alert('gagal load token');
              });

          });

        }
       
        function closeModal(){
            $mdDialog.hide();
        }
        
      } 

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ListApprovalChangeBankAccount', ListApprovalChangeBankAccount);

    /** @ngInject */
    ListApprovalChangeBankAccount.$inject = ['$state', '$log', '$mdDialog', '$window', '$location', 'config', 'AppAPI', 'Auth'];
    function ListApprovalChangeBankAccount($state, $log, $mdDialog, $window, $location, config, AppAPI, Auth)
    {
        var vm = this;
        vm.approve=approve;
        vm.closeModal = closeModal;
        var InfoApproval=AppAPI.InfoApproval();
        vm.loadProcess=true;

        loadData();

        function loadData() { 
          var promise = InfoApproval.query({action:'viewDataApprovalInsurance', type:'rekening'});
          promise.$promise.then(processInfo);
          promise.$promise.catch(errorProcessInfo);
        }

        function processInfo(data) {
          vm.listApproval=data;
          vm.loadProcess=false;
        }

        function errorProcessInfo() {
          vm.listApproval=[];
          vm.loadProcess=false;
        }
        
        function approve(ev){
          var promise=Auth.setToken();
              promise.then(function(){
                  var confirm = $mdDialog.confirm()
                  .title('Would you like to Approve this list?')
                  .textContent('All data your selected will be approve.')
                  .ariaLabel('delete dialog')
                  .targetEvent(ev)
                  .ok('YES')
                  .cancel('no');
              $mdDialog.show({
                    multiple: true
               });      
              $mdDialog.show(confirm).then(function() {
                ExportToExcel();
              }, function() {
                  // $scope.status = 'You decided to keep your debt.';
                  // angular.element.unblockUI();
              });
          }); 

        }

        function ExportToExcel() {
         
          var confirm = $mdDialog.confirm()
              .title('Download file')
              .textContent('Would you want download file?')
              .ariaLabel('delete dialog')
              .ok('YES')
              .cancel('no');
          $mdDialog.show({
                multiple: true
           });      
          $mdDialog.show(confirm).then(function() {     

            var token=Auth.setTokenPromise();
            token.then(function(){
                var protocol=$location.protocol();
                var host=$location.host();
                $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirUbahRekening/'+token+'/download', '_blank');
                closeModal();
            },function(){
                $window.alert('gagal load token');
            });

          }, function() { 

            var token=Auth.setTokenPromise();
            token.then(function(){
                var protocol=$location.protocol();
                var host=$location.host();
                $window.open(protocol+'://'+host+config.api+'api/insurance/exportExcellFormulirUbahRekening/'+token+'/undownload', '_blank');
                closeModal();
            },function(){
                $window.alert('gagal load token');
            });

          });
        }
       
        function closeModal(){
          $mdDialog.hide();
        }

      } 

})();
(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('ListApprovalAbnormalController', ListApprovalAbnormalController);

  /** @ngInject */
  function ListApprovalAbnormalController(msApi, $localStorage, Form, $mdDialog, AppAPI, $http, config, Auth, Approvalinfo, $filter) {
    var vm = this;
    var translate = $filter('translate');

    vm.data = $localStorage.InfoApproval;
    // vm.listApproval=id;
    vm.isChecked = isChecked;
    vm.toggleCheck = toggleCheck;
    vm.listOtselected = [];
    vm.closeModal = closeModal;
    vm.approveAbnormal = approveAbnormal;
    var Abnormalapproval = AppAPI.Abnormalapproval();
    vm.Reject = Reject;
    var InfoApproval = AppAPI.InfoApproval();
    vm.loadProcess = true;
    vm.toggleSelectedAll = toggleSelectedAll;


    // console.log(id);
    loadData();
    //////////

    function loadData() {
      var lsApproval = new InfoApproval();
      var promise = lsApproval.$get({ action: 'viewDataApproval', type: 'abnormal' });
      promise.then(processInfo);
      promise.catch(errorProcessInfo);
    }

    function processInfo(data) {
      // vm.data=data;

      vm.listApproval = data.data;
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval=data;
      // console.log(vm.data);
    }

    function errorProcessInfo() {
      // vm.data=[];
      vm.listApproval = [];
      vm.loadProcess = false;
      // Approvalinfo.getInfoApproval={};
    }

    function isChecked(ls) {
      return vm.listOtselected.indexOf(ls) > -1;
    }

    function toggleCheck(ls, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = vm.listOtselected.indexOf(ls);

      if (idx > -1) {
        vm.listOtselected.splice(idx, 1);
      }
      else {
        vm.listOtselected.push(ls);
      }
    }
    function toggleSelectedAll(state) {
      // console.log(state);
      switch (state) {
        case true:
          checkAll();
          break;
        case false:
          unCheckAll();
          break;
      }
    }

    function checkAll() {
      vm.listOtselected = angular.copy(vm.listApproval);
      // console.log(vm.listOtselected);
    }

    function unCheckAll() {
      vm.listOtselected = [];
    }

    function approveAbnormal(ev) {
      // console.log(vm.listOtselected);
      var nik = $localStorage.user;
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        var conf = translate('KPI.MESSAGE.CONFAPP');
        var note = translate('KPI.MESSAGE.APPNOTE');
        var yes = translate('PAYROLL.MESSAGE.YES');
        var no = translate('PAYROLL.MESSAGE.NO');

        var promise = Auth.setToken();
        promise.then(function () {
          var confirm = $mdDialog.confirm()
            .title(conf)
            .textContent(note)
            .ariaLabel('delete dialog')
            .targetEvent(ev)
            .ok(yes)
            .cancel(no);
          $mdDialog.show({
            multiple: true
          });
          $mdDialog.show(confirm).then(function () {
            angular.element.blockUI();
            // console.log(vm.listOtselected);
            var ot = new Abnormalapproval();
            ot.data = [];
            ot.action = 'approve';
            ot.nik = nik;
            for (i = 0; i < jum; i++) {
              ot.data.push({
                id: vm.listOtselected[i].id
              });
            }
            var idtx = encodeURIComponent(angular.toJson(ids));
            var response = ot.$save();
            response.then(function (data) {
              // console.log(data.pesan);
              angular.element.unblockUI();
              showDialogInfo(ev, data);
            });
            response.catch(function (data) {
              // console.log(data.data);
              angular.element.unblockUI();
              showDialogInfo(ev, data.data);
            });
          }, function () {
            // $scope.status = 'You decided to keep your debt.';
          });
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          // Approvalinfo.getInfoApproval(); 
        });
      }
    }

    function successApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Thanks for Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        // loadData();
        angular.element.unblockUI();
      });

    }

    function failedApproved(ev, data) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#contentDialog')))
          .clickOutsideToClose(true)
          .title('Failed Approval')
          .textContent(data.pesan)
          .ariaLabel('Attention')
          .ok('close')
          .targetEvent(ev)
      ).then(function () {
        // loadData();
        angular.element.unblockUI();
      });
    }

    function Reject(ev) {
      var jum = vm.listOtselected.length, i, ids = [];
      if (jum > 0) {
        $mdDialog.show({
          controller: 'AbnormaltRejectCommentController',
          controllerAs: 'vm',
          templateUrl: 'app/main/cb/abnormal-approval/comment-reject.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true,
          onRemoving: function (element, removePromise) {
            loadData();
            vm.listOtselected = [];
          },
          locals: {
            id: vm.listOtselected
          }
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title('Attention!')
            .textContent('No data selected')
            .ariaLabel('Attention')
            .ok('close')
            .targetEvent(ev)
        ).then(function () {
          loadData();
        });
      }

    }

    function closeModal() {
      $mdDialog.hide();
    }

    function dialogClose() {
      $mdDialog.hide();
    }

    function showDialogInfo(ev, data) {
      if (data.status == 1) {
        data.status = 'PAYROLL.MESSAGE.SUCCESS';
      } else if (data.status == 0) {
        data.status = 'PAYROLL.MESSAGE.FAILED';
      }

      var expmess = data.pesan.split("_");

      if (expmess.length > 1) {
        var message = translate(expmess[0]) + ', ' + expmess[1] + ' ' + translate(expmess[2]) + ' ' + expmess[3] + ' ' + translate(expmess[4]);
      } else {
        var message = translate(data.pesan);
      }

      var status = translate(data.status);
      $mdDialog
        .show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('#contentDialog')))
            .clickOutsideToClose(true)
            .title(status)
            .textContent(message)
            .ariaLabel(status)
            .ok('OK')
            .targetEvent(ev)
        )
        .then(function () {
          dialogClose();
          loadData(1);
        });
    }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ViewDetailManufactureController', Controller);

    /** @ngInject */
    function Controller($state, $mdDialog, reffData, $timeout) {
        var vm = this;

        vm.isLoading = true;
        vm.listAbsence = [];
        vm.hide = hideModal;
        vm.data = reffData;

        activate();

        function activate() {
            console.log(reffData);
            vm.listAbsence = reffData.detail;
            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function hideModal() {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('viewContractAlertController', viewContractAlertController);

    /** @ngInject */
    function viewContractAlertController($state,msApi,$localStorage,Form,$mdDialog,AppAPI,$http,config,Auth,id,$element,$location,$window)
    {
        var vm = this;  
        // vm.loadProcess=true;
        vm.closeModal=closeModal;
        vm.listData=id;
        vm.loadData=loadData;
        vm.checkProfiles=checkProfiles;
        vm.company = $localStorage.empsite;
        vm.loadDataDivision = loadDataDivision;
        vm.loadDataDepartment = loadDataDepartment;
        vm.loadSubArea = loadSubArea;
        vm.flagAppList = ['SAP','HRIS'];
        var Attendancereport = AppAPI.Attendancereport();
        var ListAlert=AppAPI.Notification();
        var Subarea =AppAPI.Subarea();
        vm.loadSalesArea=loadSalesArea;

        vm.ExporttoExcel = ExporttoExcel;

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        vm.today = yyyy + '-' + mm + '-' + dd;

        ////////// 
        loadDataBU();
        loadDataDivision(vm.company);
        loadSubArea();
        
        function loadData(pageno)
        {
            angular.element.blockUI();
            var lsAlert= new ListAlert();
            var promise=lsAlert.$get({action:'viewAlert',company:vm.company,divisi:vm.divisi,department:vm.department,area:vm.subarea,flagApp:vm.flagApp});
            promise.then(processInfo);
            promise.catch(errorProcessInfo);
        }

        function processInfo(data) {
            angular.element.unblockUI();
            vm.listData=data.contractList;
        }

        function errorProcessInfo() {
            angular.element.unblockUI();
            vm.listData=[];
        }

       function checkProfiles(ls)
       {
          $state.go('app.employee_employe_edit.profile',{id:ls.employe_id});
          closeModal();
       }

        function closeModal()
        {
            $mdDialog.hide();
        }

        function loadDataDepartment(iddivisi) {
            var response = Attendancereport.query({
                action: 'viewDivisiDept',
                idbu: vm.company,
                iddivisi: iddivisi
            });
            response.$promise.then(fetchDepartment);
            response.$promise.catch(errorDepartment);
        }

        function fetchDepartment(data) {
            vm.listDepartment = data;

            // loadData(1);
        }

        function errorDepartment() {
            vm.listDepartment = [];
        }

        function loadDataDivision(idbu) {
            if(idbu=='PM')
            {
                vm.dataSales=true;
                loadSalesArea();
            }
            var response = Attendancereport.query({
                action: 'viewDivisiBu',
                idbu: idbu
            });
            response.$promise.then(fetchDivisiBU);
            response.$promise.catch(errorDivisiBU);
        }

        function fetchDivisiBU(data) {
            vm.listDivision = data;
            // vm.listDivision.push(data);
            // loadData(1);
        }

        function errorDivisiBU() {
            vm.listDivision = [];
        }

        function loadDataBU() {
            var response = Attendancereport.query({
                action: 'viewBu'
            });
            response.$promise.then(fetchBU);
            response.$promise.catch(errorFetchBU);
        }

        function fetchBU(data) {
            vm.listBU = data;

        }

        function errorFetchBU() {
            vm.listBU = [];
        }

        function loadSubArea() {
            // console.log('test');
            var response = Attendancereport.query({
                action: 'viewSubArea'
            });
            response.$promise.then(fetchArea);
            response.$promise.catch(errorfetchArea);
        }

        function fetchArea(data) {
            vm.subArea = data;
            if(vm.company=='PM')
            { 
                vm.wilayah=null;
                vm.region=null;
                vm.cabang=null;
                vm.area=null;
                loadSalesArea();
            } 
        }

        function errorfetchArea(data) {
            vm.subArea = [];
        }

        vm.clearSearchTerm = function() {
            vm.searchTerm = '';
        };
        
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        function ExporttoExcel(form) 
       {    
            var token       = Auth.setTokenPromise();
            var company     = encodeURIComponent(window.btoa(vm.company));
            var divisi      = encodeURIComponent(window.btoa(vm.divisi));
            var department  = encodeURIComponent(window.btoa(vm.department));
            var area        = encodeURIComponent(window.btoa(vm.subarea));
            var flagApp     = encodeURIComponent(window.btoa(vm.flagApp));
            
            token.then(function(data) 
            {
                var protocol = $location.protocol();
                var host = $location.host();
                $window.open(protocol + '://' + host + config.port + config.api + 'api/notification/lgexportexcel/' + company  + '/' + divisi  + '/' + department  + '/' + area + '/' + flagApp + '/' +  data.token, '_blank');
            }, function() {
                $window.alert('gagal load token')
            });
        }

        function loadSalesArea()
        {   
            // vm.wilayah=null;
            // vm.region=null;
            // vm.cabang=null;
            // vm.area=null;
            var response = Subarea.query({
                action: 'getAreaSales',
                subarea:vm.subarea,
                wilayah:vm.wilayah,
                region:vm.region,
                cabang:vm.cabang

            });
            response.$promise.then(fetchAreaSales);
            response.$promise.catch(errorfetchAreaSales)
        }

        function fetchAreaSales(data) {
            vm.areaSales = data[0].area;
            vm.cabangSales = data[0].cabang;
            vm.regionSales = data[0].region;
            vm.wilayahSales = data[0].wilayah;
            // vm.wilayah=null;
            // vm.region=null;
            // vm.cabang=null;
            // vm.area=null;

        }

        function errorfetchAreaSales(data) 
        { 
            vm.areaSales = [];
            vm.cabangSales = [];
            vm.regionSales = [];
            vm.wilayahSales = [];
            // vm.wilayah=null;
            // vm.region=null;
            // vm.cabang=null;
            // vm.area=null;
        }
    } 
})();
(function () {
    'use strict';

    angular.module('app.toolbar').controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController(
        $rootScope,
        $q,
        $state,
        $timeout,
        $mdSidenav,
        $translate,
        $mdToast,
        msNavigationService,
        $window,
        $location,
        $localStorage,
        AppAPI,
        GeneralService,
        Approvalinfo,
        Contractalert,
        Insurancealert,
        $mdDialog,
        Claimalert,
        Newsinfo,
        Newslist,
        config,
        $http
    ) {
        var vm = this;
        var news = AppAPI.News();
        var EmpSurvey = AppAPI.EmpSurvey();
        vm.data = [];

        vm.Approvalinfo = Approvalinfo;
        vm.Contractalert = Contractalert;
        vm.Insurancealert = Insurancealert;
        vm.Claimalert = Claimalert;
        vm.showDisclaimer = showDisclaimer;

        vm.photo = $localStorage.photo;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];
        vm.languages = {
            en: {
                title: 'English',
                translation: 'TOOLBAR.ENGLISH',
                code: 'en',
                flag: 'us'
            },
            // es: {
            //     'title'      : 'Spanish',
            //     'translation': 'TOOLBAR.SPANISH',
            //     'code'       : 'es',
            //     'flag'       : 'es'
            // },
            // tr: {
            //     'title'      : 'Turkish',
            //     'translation': 'TOOLBAR.TURKISH',
            //     'code'       : 'tr',
            //     'flag'       : 'tr'
            // },
            tr: {
                title: 'Indonesia',
                translation: 'TOOLBAR.INDONESIA',
                code: 'id',
                flag: 'id'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.username = $localStorage.nama;
        vm.empno = $localStorage.empno;
        vm.Myprofiles = Myprofiles;
        vm.viewContractAlert = viewContractAlert;
        vm.group = $localStorage.group;
        vm.alert = $localStorage.alert;
        vm.employeeAlertList = [];
        vm.viewManufactureAlert = viewManufactureAlert;
        // var data=Approvalinfo.getInfoApproval();
        // vm.data=$localStorage.infoApproval;
        // console.log('group : '+$localStorage.group);

        // console.log('data '+data);

        //////////

        init();
        if (vm.group != '99') {
            setTimeout(function () {
                alertData();
                checkSurvey();
            }, 1000);
        }

        function checkSurvey() {
            angular.element.blockUI();
            var promises = EmpSurvey.query({ action: 'getActiveSurvey', nik: $localStorage.user });
            promises.$promise.then(function (data) {
                angular.element.unblockUI();
                if (typeof (data[0]) !== 'undefined') {
                    loadDataSurvey();
                }
            });
            promises.$promise.catch(function () {
                angular.element.unblockUI();
            });
        }
        function loadDataSurvey() {
            angular.element.blockUI();
            var promises = EmpSurvey.query({ action: 'get_profile' });
            promises.$promise.then(fetchDataSurvey);
            promises.$promise.catch(function () {
                angular.element.unblockUI();
            });
        }

        function fetchDataSurvey(data) {
            if (typeof (data[0]) !== 'undefined') {
                vm.profile = data;

                loadSurveyData();

            }
        }

        function loadSurveyData() {
            angular.element.blockUI();
            var promises = EmpSurvey.query({ action: 'get_employee_surveys', nik: $localStorage.user });
            promises.$promise.then(fetchSurveyData);
            promises.$promise.catch(errorSurveyFetch);
        }

        function fetchSurveyData(data) {

            vm.surveys = data;

            if (data.length > 0) {
                vm.surveys = data;
            } else {

                vm.showDisclaimer();

            }

            angular.element.unblockUI();
        }

        function errorSurveyFetch() {
            vm.score = {};
            angular.element.unblockUI();
        }

        function showDisclaimer() {
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'vm',
                templateUrl: 'app/main/emp-survey/emp-survey-from-login.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    language: vm.language,
                    languageList: vm.languageList
                }
            })
                .then(function (isConfirm) {

                    if (isConfirm) {
                        vm.isConfirmDisclaimer = true;
                        vm.showinfoStatusDisclaimer = true;

                        $timeout(function () {
                            loadStatementsData();
                        }, 500);

                    } else {
                        vm.showinfoStatusDisclaimer = true;
                    }
                }, function () {
                    vm.isConfirmDisclaimer = false;
                    vm.showinfoStatusDisclaimer = true;
                });
        }

        function loadStatementsData() {

            angular.element('.ms-form-wizard').block();

            var dataPromise = EmpSurvey.query({ action: 'get_statements', nik: $localStorage.user });
            dataPromise.$promise.then(fetchStatementsData);
            dataPromise.$promise.catch(errorStatementsFetch);

        }

        function fetchStatementsData(data) {

            vm.listInput = data;

            vm.totalResult = 0;
            angular.forEach(vm.listInput, function (obj) {
                vm.totalResult += obj.result;
            });
            // angular.element.unblockUI();
            angular.element('.ms-form-wizard').unblock();


        }

        function errorStatementsFetch() {
            vm.listInput = [];
            angular.element.unblockUI();
        }

        function DialogController($scope, language, languageList, $mdDialog) {

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.language = language;
            vm.language = $scope.language;

            $scope.languageList = languageList;

            $scope.confirmDisclaimer = function (confirm) {
                if (confirm) {
                    $mdDialog.hide(confirm);
                    $state.go('app.emp_survey_from_login');
                } else {
                    $mdDialog.hide();
                }
            };
        }

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];
            $localStorage.lang = $translate.preferredLanguage();
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            loadEmployeeAlert();
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            angular.element.blockUI();

            var Logout = AppAPI.Logout();
            var objLogout = new Logout();

            var promise = objLogout.$logout();
            promise.then(
                function (rdata) {
                    var resultNum = parseInt(rdata.status);
                    if (resultNum === 1) {
                        GeneralService.clearStorage();
                        // $location.path('/');
                        $state.go('app.login.emplogin');
                        angular.element.unblockUI();
                    } else {
                        $window.alert('failed proses logout');
                        angular.element.unblockUI();
                    }
                },
                function () {
                    $window.alert('failed proses logout');
                    angular.element.unblockUI();
                }
            );
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */

            // if ( lang.code !== 'en' || lang.code !== 'id')
            // {
            //     var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

            //     $mdToast.show({
            //         template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            //         hideDelay: 7000,
            //         position : 'top right',
            //         parent   : '#content'
            //     });

            //     return;
            // }
            // delete $localStorage.lang;

            // Change the language
            $localStorage.lang = lang.code;
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (
                        angular
                            .lowercase(item.title)
                            .search(angular.lowercase(query)) > -1
                    ) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }

        function Myprofiles() {
            if (vm.empno !== '') {
                var userNik = encodeURIComponent(window.btoa($localStorage.user));
                $localStorage.currentNik = userNik;
                // $state.go('app.employee_employe_edit.profile',{id:vm.empno});
                $state.go('app.employee_myemploye_edit.profile', {
                    id: encodeURIComponent(window.btoa(vm.empno)),
                    nik: userNik
                });
            }
        }

        function alertData() {
            var ListAlert = AppAPI.Notification();
            var lsAlert = new ListAlert();
            var promise = lsAlert.$get({ action: 'viewAlert' });
            promise.then(processInfo);
            promise.catch(errorProcessInfo);
        }

        function processInfo(data) {
            Approvalinfo.getInfoApproval = data;
            Contractalert.infoContract = data.contractList;
            Insurancealert.infoInsurance = data.insuranceList;
            Claimalert.infoClaim = data.claimList;
            Newsinfo.getInfoNews = data.newsCount;
            Newslist.getListNews = data.newsList;
        }

        function errorProcessInfo() {
            Approvalinfo.getInfoApproval = {};
            Contractalert.infoContract = {};
            Insurancealert.infoInsurance = {};
            Claimalert.infoClaim = {};
            Newsinfo.getInfoNews = {};
            Newslist.getListNews = {};
        }

        function infoInsurance() {
            var ListInsurance = AppAPI.InfoApproval();
            var lsInsurance = new ListInsurance();
            var promise = lsInsurance.$get({ action: 'infoInsurance' });
            promise.then(infoInsuranceSucess);
            promise.catch(infoInsuranceFailed);
        }

        function infoInsuranceSucess(data) {
            Insurancealert.infoInsurance = data;
        }

        function infoInsuranceFailed() {
            Insurancealert.infoInsurance = {};
        }

        function infoClaim() {
            var ListClaim = AppAPI.InfoApproval();
            var lsClaim = new ListClaim();
            var promise = lsClaim.$get({ action: 'infoClaim' });
            promise.then(infoClaimSucess);
            promise.catch(infoClaimFailed);
        }

        function infoClaimSucess(data) {
            Claimalert.infoClaim = data;
        }

        function infoClaimFailed() {
            Claimalert.infoClaim = {};
        }

        function infoContract() {
            var contract = AppAPI.Employe();
            var contractInfo = new contract();
            var resp = contractInfo.$get({ action: 'infoContract' });
            resp.then(infoSucess);
            resp.catch(infoFailed);
        }

        function infoSucess(data) {
            Contractalert.infoContract = data.data;
        }

        function infoFailed() {
            Contractalert.infoContract = {};
        }

        function viewContractAlert(ev) {
            // console.log(vm.Contractalert.infoContract);
            $mdDialog.show({
                controller: 'viewContractAlertController',
                controllerAs: 'vm',
                templateUrl: 'app/toolbar/view-contract-alert.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                onRemoving: function (element, removePromise) {
                    alertData();
                },
                locals: {
                    id: vm.Contractalert.infoContract
                }
            });
        }

        function viewManufactureAlert(ev, data) {
            // console.log(vm.Contractalert.infoContract);
            $mdDialog.show({
                controller: 'ViewDetailManufactureController',
                controllerAs: 'vm',
                templateUrl: 'app/toolbar/view-manufacture.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    reffData: data
                }
            });
        }

        // Methods
        function countUnReadNews() {
            var response = news.get({ action: 'getCountUnReadNews' });
            response.$promise.then(fetchUnreadNews);
            response.$promise.catch(errorFetchNewsCategory);
        }

        function fetchUnreadNews(data) {
            Newsinfo.getInfoNews = data;
        }

        function errorFetchNewsCategory() {
            Newsinfo.getInfoNews = 0;
        }

        function loadDataNewsCategory() {
            var response = news.query({ action: 'viewNewsList' });
            response.$promise.then(fetchNewsCategory);
            response.$promise.catch(errorFetchNewsCategory);
        }

        function fetchNewsCategory(data) {
            Newslist.getListNews = data;
        }

        function errorFetchNewsCategory() {
            Newslist.getListNews = [];
        }

        function loadEmployeeAlert() {
            var endpoint = config.api + 'api/employeealert/getEmployeeAlertDetail';
            var request = $http.get(endpoint);
            request.then(
                function (response) {
                    vm.employeeAlertList = response.data;
                },
                function (error) {
                    vm.employeeAlertList = [];
                    console.log(error);
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = true;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('aiko') 
        .directive('sticky', sticky);

       sticky.$inject=['$mdSticky','$compile'];
    /** @ngInject */
    function sticky($mdSticky,$compile)
    {

        var SELECT_TEMPLATE =
      '<md-select ng-model="selected">' +
        '<md-option>Option 1</md-option>' +
      '</md-select>';
        return {
            restrict: 'A',
            template:SELECT_TEMPLATE,
            link: function(scope,element) {
               $mdSticky(scope, element,$compile(SELECT_TEMPLATE)(scope));
            }
        }

    }   
})();
(function () {
    'use strict';

    angular
        .module('aiko')
        .service('Replacement', Replacement);
    Replacement.$inject = [];
    /* @ngInject */
    function Replacement() {
        var obj = this;
        obj.dataReplacement = {};
    }


}());

(function () {
  'use strict';

  angular
    .module('aiko')
    .directive('mppChartViewport', mppChartViewport);

  function mppChartViewport($window) {

    var directive = {
      restrict: 'A',
      link: link,
      scope: {
        toggle: '@'
      }
    };

    return directive;

    /** @ngInject */

    function link(scope, element, attrs) {
      var w = angular.element($window);
      var mppToolbarArea = angular.element(document.body.querySelector('#mppToolbarArea'));
      var toolbar = angular.element(document.body.querySelector('#toolbar'));
      var orgChart = angular.element(element[0]);
      var orgChartPanel = angular.element(element[0].querySelector('#centerpanel'));
      var orgChartContent = angular.element(element[0].querySelector('#chartContent'));


      scope.getWindowsHeight = function () {
        return w.outerHeight();
      }

      scope.$watch(scope.getWindowsHeight, function (newVal) {
        var baseHeight = (newVal - toolbar.outerHeight()) - mppToolbarArea.outerHeight();
        // console.log(baseHeight);
        orgChart.css('height', baseHeight);
        orgChartPanel.css('height', baseHeight);
        orgChartContent.css('height', baseHeight);
      }, true);

      w.bind('resize', function () {
        scope.$apply();
      });

    }
  }
})();

(function() {
    angular.module('aiko').directive('onErrorSrc', function() {
        return {
            link: function(scope, element, attrs) {
                element.bind('error', function() {
                    if (attrs.src != attrs.onErrorSrc) {
                        attrs.$set('src', attrs.onErrorSrc);
                    }
                });
            }
        };
    });
})();

(function ()
{
    'use strict';

    angular
        .module('aiko')
        .factory('Newsinfo', Newsinfo);
     /* @ngInject */
      function Newsinfo() {
        return info;
        function info() {
          var obj=this;  
          obj.getInfoNews={};
        }
      }

   
}());       
(function ()
{
    'use strict';

    angular
        .module('aiko')
        .service('Newslist', Newslist);
        Newslist.$inject = [];
     /* @ngInject */
      function Newslist() {
        var obj=this;  
        obj.getListNews=[];
      }

   
}());       
(function() {
  'use strict';
   /* for genaral Service */
       angular
        .module('aiko')
        .provider('menu', Menu);

     

    /* @ngInject */
    function Menu() {

      this.$get=function(){
        return {};
      };



      this.checkRule=checkRule;
       function checkRule(idmenu) {
           var listMenu=angular.fromJson(localStorage.getItem('ngStorage-listMenu'));
           var isObject=angular.isObject(listMenu);
        /*   console.log(listMenu);*/
           if(isObject)
           {
                var lengthMenu=listMenu.loadMenu.length,i=0,hidden=true;
                if(lengthMenu>0)
                {

                    for(i=0;i<lengthMenu;i++)
                    {
                      if(listMenu.loadMenu[i].menuID===idmenu)
                      {
                          hidden=false;
                          break;
                      }
                      // check has child menu
                      if(hidden===true)
                      {
                          if(listMenu.loadMenu[i].hassub==='1')
                          {
                             hidden=checkChild(idmenu,hidden,listMenu.loadMenu[i].listChild);
                          }
                      }
                    }

                    return hidden;
                }else
                {
                  return hidden;
                }
           }else
            {
              return true;
            }
         }
 

         function checkChild(menuID,hidden,listMenu)
         {
            var lengthMenu=listMenu.length,i=0;
            for(i=0;i<lengthMenu;i++)
            {
                   if(listMenu[i].menuID===menuID)
                   {
                    hidden=false;
                    break;
                   }

                   if(hidden===true)
                   {
                       if(listMenu[i].hassub==='1')
                       {
                        hidden=checkChild(menuID,hidden,listMenu[i].listChild);
                       }
                   }
            }
            return hidden;
         }

      /* function menuRule()
       {
         var service={
            checkRule:checkRule
         };
         return service;

         
           
       }*/
    }

}());


(function ()
{ 
    'use strict';

    angular
        .module('aiko')
        .service('Insurancealert', Insurancealert);
        Insurancealert.$inject = ['$q','$localStorage','$http','AppAPI','config'];
     /* @ngInject */
      function Insurancealert($q,$localStorage,$http,AppAPI,config) {
        var obj=this;  
        obj.infoInsurance={};
      }

   
}());       
(function() {
    angular.module('aiko').directive('imageonload', [
        '$timeout',
        function($timeout) {
            return {
                link: function($scope, element, attrs) {
                    function waitForImage(url) {
                        var tempImg = new Image();
                        tempImg.onload = function() {
                            $timeout(function() {
                                element.attr('src', url);
                            });
                        };
                        tempImg.onerror = function() {
                            $timeout(function() {
                                element.attr('src', 'assets/images/no-images.svg');
                            });
                        };
                        tempImg.src = url;
                    }

                    attrs.$observe('imageonload', function(newValue) {
                        if (newValue) {
                            waitForImage(newValue);
                        }
                    });
                }
            };
        }
    ]);
})();

(function () {
    angular


        .module('aiko')


        // Angular File Upload module does not include this directive
        // Only for example


        /**
         * The ng-thumb directive
         * @author: nerv
         * @version: 0.1.2, 2014-01-09
         */
        .directive('ngThumb', ['$window', function ($window) {
            var helper = {
                support: !!($window.FileReader && $window.CanvasRenderingContext2D),
                isFile: function (item) {
                    return angular.isObject(item) && item instanceof $window.File;
                },
                isImage: function (file) {
                    var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                    return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
                }
            };

            return {
                restrict: 'A',
                template: '<canvas/>',
                link: function (scope, element, attributes) {
                    if (!helper.support) return;

                    var params = scope.$eval(attributes.ngThumb);

                    if (!helper.isFile(params.file)) return;
                    if (!helper.isImage(params.file)) return;

                    var canvas = element.find('canvas');
                    var reader = new FileReader();

                    reader.onload = onLoadFile;
                    reader.readAsDataURL(params.file);

                    function onLoadFile(event) {
                        var img = new Image();
                        img.onload = onLoadImage;
                        img.src = event.target.result;
                    }

                    function onLoadImage() {
                        var width = params.width || this.width / this.height * params.height;
                        var height = params.height || this.height / this.width * params.width;
                        canvas.attr({
                            width: width,
                            height: height
                        });
                        canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
                    }
                }
            };
        }]);
})();

(function () {
    'use strict';
    /* for genaral Service */
    angular.module('aiko').service('GeneralService', GeneralService);

    GeneralService.$inject = ['$localStorage', 'msNavigationService'];

    /* @ngInject */
    function GeneralService($localStorage, msNavigationService) {
        this.clearStorage = clearStorage;
        this.setStorage = setStorage;
        this.setInfoApproval = setInfoApproval;
        this.setInfoContract = setInfoContract;
        this.setInfoInsurance = setInfoInsurance;
        this.setInfoClaim = setInfoClaim;
        this.getJWTToken = getJWTToken;
        this.findIndexObject = findIndexObject;
        this.setStorageCheckIn = setStorageCheckIn;

        ////////////////

        function clearStorage() {
            delete $localStorage.username;
            delete $localStorage.user;
            delete $localStorage.group;
            delete $localStorage.tokenAuth;
            delete $localStorage.token;
            delete $localStorage.tokenJWT;
            delete $localStorage.loadPermision;
            delete $localStorage.empno;
            delete $localStorage.listMenu;
            delete $localStorage.listMenu1;
            delete $localStorage.nama;
            delete $localStorage.empsite;
            delete $localStorage.photo;
            delete $localStorage.infoApproval;
            delete $localStorage.infoContract;
            delete $localStorage.infoInsurance;
            delete $localStorage.infoClaim;
            delete $localStorage.country;
            delete $localStorage.isSurvey;

            /*clear navigation*/
            msNavigationService.clearNavigation();
            //delete $sessionStorage.infoDisposi;
        }
        function setStorage(data) {
            // console.log(data);
            $localStorage.isSurvey = data.isSurvey;
            $localStorage.user = data.username;
            $localStorage.group = data.group;
            $localStorage.tokenAuth = data.tokenAuth;
            $localStorage.tokenJWT = data.tokenJWT;
            $localStorage.empno = data.empno;
            $localStorage.nama = data.nama;
            $localStorage.empsite = data.empsite;
            $localStorage.listMenu = angular.fromJson(data.menu);
            $localStorage.listMenu1 = angular.fromJson(data.menu1);
            $localStorage.photo = data.photo;
            $localStorage.country = data.country;
            $localStorage.alert = {
                bgClass: data.alert_bg_class,
                fontColor: data.alert_font_color,
                alert_type: data.alert_type,
                alert_id: data.alert_id
            };
        }

        function setInfoApproval(data) {
            $localStorage.infoApproval = { getInfoApproval: data };
        }

        function setInfoContract(data) {
            $localStorage.infoContract = { infoContract: data };
        }

        function setInfoInsurance(data) {
            $localStorage.infoInsurance = { infoInsurance: data };
        }

        function setInfoClaim(data) {
            $localStorage.infoClaim = { infoClaim: data };
        }

        function setStorageCheckIn(data) {
            $localStorage.username = encodeURIComponent(window.btoa(data.username));
            $localStorage.tokenAuth = data.tokenAuth;
            $localStorage.nama = data.nama;
        }
        function getJWTToken() {
            return $localStorage.tokenJWT;
        }
        function findIndexObject(search, list, keySearch) {
            var idx = 0;
            angular.forEach(list, function (val, key) {
                angular.forEach(val, function (val1, key1) {
                    if (key1 === keySearch && search === val1) {
                        idx = key;
                    }
                });
            });

            return idx;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('aiko') 
        .directive('dateMask', dateMask);

    /** @ngInject */
    function dateMask()
    {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elem){
                (elem).mask('99/99/9999',{placeholder:"-"}); 
     
            }
        }

    }   
})();
(function () {
    'use strict';

    angular
        .module('aiko')
        .factory('DataService', DataService);

    /* @ngInject */
    function DataService() {

        return DataTable;

        ////////////////

        function DataTable() {
            var obj = this;
            obj.loadData = loadData;
            obj.loadDatas = loadDatas;
            obj.jumDataPerPage = 25;
            obj.noPage = 1;
            obj.offset = 0;

            ////////////////

            function loadData(Constructor, noPage, param) {
                obj.noPage = parseInt(noPage);
                angular.element.blockUI();
                obj.offset = (obj.noPage - 1) * obj.jumDataPerPage;
                if (obj.offset < 0 || isNaN(obj.offset)) {
                    obj.offset = 0;
                }
                var addParam = {
                    offset: obj.offset,
                    jumPage: obj.jumDataPerPage,
                    search: obj.searchParam
                };

                angular.extend(param, addParam);

                var response = Constructor.query(param);
                var promise = response.$promise.then(fetchData);
                response.$promise.catch(errorData);

                return promise;
            }

            function errorData() {
                angular.element.unblockUI();
            }

            function fetchData(rdata) {
                if ('reader_by_company' in rdata[0]) {
                    obj.readerByCompany = rdata[0].reader_by_company;
                }
                if ('isAdmin' in rdata[0]) {
                    obj.isAdmin = rdata[0].isAdmin;
                }
                if ('isDev' in rdata[0]) {
                    obj.isDev = rdata[0].isDev;
                }
                if ('headcount' in rdata[0]) {
                    obj.headcount = rdata[0].headcount;
                }
                obj.list = rdata[0].aData;
                obj.iTotalDisplayRecords = parseInt(rdata[0].iTotalDisplayRecords);
                obj.iTotalRecords = parseInt(rdata[0].iTotalRecords);

                var jumpage = Math.ceil((obj.iTotalDisplayRecords / obj.jumDataPerPage));
                var nav = [];
                if (obj.iTotalRecords > obj.jumDataPerPage) {

                    if (obj.noPage > 1) {
                        nav.push({ noPage: (obj.noPage - 1), label: 'Prev', disabled: 0, class: '' });
                    } else {
                        nav.push({ noPage: 0, label: 'Prev', disabled: 1, class: '' });
                    }
                    var showPage;
                    var page = 1;
                    for (page = 1; page <= jumpage; page++) {

                        if (((page >= obj.noPage - 3) && (page <= obj.noPage + 3)) || (page === 1) || (page === jumpage)) {

                            if ((showPage === 1) && (page !== 2)) {
                                nav.push({ noPage: 0, label: '...', disabled: 1, class: '' });
                            }
                            if ((showPage !== (jumpage - 1)) && (page === jumpage)) {
                                nav.push({ noPage: 0, label: '...', disabled: 1, class: '' });
                            }
                            if (page === obj.noPage) {
                                nav.push({ noPage: page, label: page, disabled: 0, class: 'active' });
                            } else {

                                nav.push({ noPage: page, label: page, disabled: 0, class: '' });
                            }
                            showPage = page;
                        }
                    }
                    if (obj.noPage < jumpage) {
                        nav.push({ noPage: (obj.noPage + 1), label: 'Next', disabled: 0, class: '' });
                    } else {
                        nav.push({ noPage: 0, label: 'Next', disabled: 1, class: '' });
                    }
                }
                //angular.element('ul.pagination')
                obj.listNav = nav;
                var info;
                if (obj.iTotalRecords === obj.iTotalDisplayRecords) {
                    info = ' Showing ' + (obj.offset + 1) + ' to ' + (obj.offset + rdata[0].aData.length) + ' of ' + obj.iTotalRecords + ' entries ';
                } else {
                    info = 'Showing ' + (obj.offset + 1) + ' to ' + (obj.offset + rdata[0].aData.length) + ' of ' + (obj.iTotalDisplayRecords) + ' entries (filtered from ' + obj.iTotalRecords + ' total entries)';
                }
                obj.info = info;
                angular.element.unblockUI();
                return obj;
            }

            function loadDatas(Constructor, noPage, param) {
                obj.noPage = parseInt(noPage);
                angular.element.blockUI();
                obj.offset = (obj.noPage - 1) * obj.jumDataPerPage;
                if (obj.offset < 0 || isNaN(obj.offset)) {
                    obj.offset = 0;
                }
                var addParam = {
                    offset: obj.offset,
                    jumPage: obj.jumDataPerPage,
                    search: obj.searchParam
                };
                angular.extend(param, addParam);

                var response = Constructor.query(param);
                var promise = response.$promise.then(fetchDatas);
                response.$promise.catch(errorDatas);

                return promise;
            }

            function errorDatas() {
                angular.element.unblockUI();
            }

            function fetchDatas(rdata) {
                if ('reader_by_company' in rdata[0].data) {
                    obj.readerByCompany = rdata[0].data.reader_by_company;
                }
                obj.isAdmin = 'isAdmin' in rdata[0] ? rdata[0].isAdmin : false;
                obj.expireDate = 'expireDate' in rdata[0] ? rdata[0].expireDate : '';
                obj.bobotavailable = 'bobotavailable' in rdata[0] ? rdata[0].bobotavailable : '';
                obj.list = rdata[0].data.aData;
                obj.iTotalDisplayRecords = parseInt(rdata[0].data.iTotalDisplayRecords);
                obj.iTotalRecords = parseInt(rdata[0].data.iTotalRecords);

                var jumpage = Math.ceil((obj.iTotalDisplayRecords / obj.jumDataPerPage));
                var nav = [];
                if (obj.iTotalRecords > obj.jumDataPerPage) {
                    if (obj.noPage > 1) {
                        nav.push({ noPage: (obj.noPage - 1), label: 'Prev', disabled: 0, class: '' });
                    } else {
                        nav.push({ noPage: 0, label: 'Prev', disabled: 1, class: '' });
                    }
                    var showPage;
                    var page = 1;
                    for (page = 1; page <= jumpage; page++) {
                        if (((page >= obj.noPage - 3) && (page <= obj.noPage + 3)) || (page === 1) || (page === jumpage)) {
                            if ((showPage === 1) && (page !== 2)) {
                                nav.push({ noPage: 0, label: '...', disabled: 1, class: '' });
                            }
                            if ((showPage !== (jumpage - 1)) && (page === jumpage)) {
                                nav.push({ noPage: 0, label: '...', disabled: 1, class: '' });
                            }
                            if (page === obj.noPage) {
                                nav.push({ noPage: page, label: page, disabled: 0, class: 'active' });
                            } else {
                                nav.push({ noPage: page, label: page, disabled: 0, class: '' });
                            }
                            showPage = page;
                        }
                    }
                    if (obj.noPage < jumpage) {
                        nav.push({ noPage: (obj.noPage + 1), label: 'Next', disabled: 0, class: '' });
                    } else {
                        nav.push({ noPage: 0, label: 'Next', disabled: 1, class: '' });
                    }
                }

                obj.listNav = nav;
                var info;
                if (obj.iTotalRecords === obj.iTotalDisplayRecords) {
                    info = ' Showing ' + (obj.offset + 1) + ' to ' + (obj.offset + rdata[0].data.aData.length) + ' of ' + obj.iTotalRecords + ' entries ';
                } else {
                    info = 'Showing ' + (obj.offset + 1) + ' to ' + (obj.offset + rdata[0].data.aData.length) + ' of ' + (obj.iTotalDisplayRecords) + ' entries (filtered from ' + obj.iTotalRecords + ' total entries)';
                }
                obj.info = info;
                angular.element.unblockUI();
                return obj;
            }
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('aiko')
        .service('CorrespondenceAlert', CorrespondenceAlert);

    /* @ngInject */
    CorrespondenceAlert.$inject = ['$q', '$localStorage', '$http', 'AppAPI', 'config'];

    function CorrespondenceAlert($q, $localStorage, $http, AppAPI, config) {
        var obj = this;
        obj.infoCorrespondence = {};
    }


}());

(function ()
{ 
    'use strict';

    angular
        .module('aiko')
        .service('Contractalert', Contractalert);
        Contractalert.$inject = [];
     /* @ngInject */
      function Contractalert() {
        var obj=this;  
        obj.infoContract={};       // obj.data=[];
   
  
          ////////////////
   

      }

   
}());       
(function ()
{ 
    'use strict';

    angular
        .module('aiko')
        .service('Claimalert', Claimalert);
        Claimalert.$inject = ['$q','$localStorage','$http','AppAPI','config'];
     /* @ngInject */
      function Claimalert($q,$localStorage,$http,AppAPI,config) {
        var obj=this;  
        obj.infoClaim={};
      }

   
}());       
(function ()
{
    'use strict';

    angular
        .module('aiko')
        .service('Auth', Auth);
        Auth.$inject = ['$q','$localStorage','$http','AppAPI','config','jwtHelper'];
     /* @ngInject */
      function Auth($q,$localStorage,$http,AppAPI,config,jwtHelper) {
        var obj=this;  
        obj.setToken=setToken;
        obj.setTokenPromise=setTokenPromise;
        obj.setCookie=setCookie;
        obj.refreshJWT=refreshJWT;
   
  
          ////////////////
  
          function setToken(loadingState) {
            loadingState = typeof loadingState !== 'undefined' ? loadingState : true;
            var Tkn= AppAPI.TokenApi();
            var token = new Tkn();
            if(loadingState) {
              angular.element.blockUI();
            }
            var promise= token.$getToken({action:'getToken'});    
            promise.then(function(data){
            $localStorage.token=data.token;
            if(loadingState) {
              angular.element.unblockUI();
            }
          });
            return promise;
          }

          function setTokenPromise () {
            var Tkn= AppAPI.TokenApi();
            var token = new Tkn();
            return token.$getToken({action:'getToken'});    
          }
          function setCookie () {
            var Tkn= AppAPI.TokenApi();
            var token = new Tkn();
            return token.$setCookie({action:'setCookie'}); 
          }

          function refreshJWT () {

            // sementara ini di matikan masih error untuk promise dari resource
          var jwttoken=$localStorage.tokenJWT;
          var tokenPayload = jwtHelper.decodeToken(jwttoken);
          var httpOption={
              url: config.api+'api/token/refreshJWT',
              skipAuthorization: true,
              method: 'POST',
              data:{
              tokenID:tokenPayload.jti,
              appID:tokenPayload.iss
              }
             };
          return $http(httpOption)
              .then(returnNewToken)
              .catch(errorReturnNewToken); 

            /* return promise;*/
          }

          function returnNewToken (response) {
            var idToken = response.data.data;
                  $localStorage.tokenJWT=idToken;
                  return idToken;
          }

          function errorReturnNewToken () {
            return null;
          }


      }

   
}());       
(function ()
{
    'use strict';

    angular
        .module('aiko')
        .service('Approvalinfo', Approvalinfo);
        Approvalinfo.$inject = [];
     /* @ngInject */
      function Approvalinfo() {
        var obj=this;  
        obj.getInfoApproval={};       // obj.data=[];
   
  
          ////////////////
  
          // function getInfoApproval() {  
            // var ListApproval=AppAPI.InfoApproval();
            // var lsApproval= new ListApproval();
            // var promise=lsApproval.$get({action:'viewData'});    
            // promise.then(function(data){  
            //     $localStorage.InfoApproval=data;
            //     // console.log(data);
            //     // obj.data=data;  
            //   });
            // console.log(obj.data); 
            // return promise;
          // } 

      }

   
}());       
(function() {
    angular.module('aiko').directive('animateHeight', [
        '$timeout',
        function($timeout) {
            return {
                link: function($scope, element, attrs) {
                    $scope.$watch(
                        function() {
                            return element.height();
                        },
                        function(newValue, oldValue) {
                            // console.log(newValue);
                            if (newValue != oldValue) {
                                if (parseInt(newValue) > parseInt(oldValue)) {
                                    element.attr(
                                        'style',
                                        'animation: slideInDown 2s'
                                    );
                                } else {
                                    element.attr('style', 'animation: slideInUp 2s');
                                }
                                // Do something ...
                                console.log(newValue);
                            }
                        },
                        1000,
                        false
                    );
                }
            };
        }
    ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider, $provide) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        $provide.decorator('$state', ['$delegate', '$window',
            function ($delegate, $window) {
                var extended = {
                    goNewTab: function (stateName, params) {
                        $window.open(
                            $delegate.href(stateName, params, {
                                absolute: true
                            }), '_blank');
                    }
                };
                angular.extend($delegate, extended);
                return $delegate;
            }
        ]);

        /*eslint-enable */
    }
})();

(function () {
    'use strict';

    angular
        .module('hcportal')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state) {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
            $rootScope.loadingProgress = true;

        });


        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function () {
    "use strict";

    angular.module("hcportal").config(routeConfig);

    /** @ngInject */
    function routeConfig(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ) {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise("/login/emplogin");

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(["ngCookies"]).invoke([
            "$cookies",
            function (_$cookies) {
                $cookies = _$cookies;
            },
        ]);

        //untuk se entara layout di set vertical
        //var layoutStyle = "verticalNavigation";
         var layoutStyle = "horizontalNavigation";
        // Get active layout
        //var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: "app/core/layouts/vertical-navigation.html",
                toolbar: "app/toolbar/layouts/vertical-navigation/toolbar.html",
                navigation:
                    "app/navigation/layouts/vertical-navigation/navigation.html",
            },
            verticalNavigationFullwidthToolbar: {
                main:
                    "app/core/layouts/vertical-navigation-fullwidth-toolbar.html",
                toolbar:
                    "app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html",
                navigation:
                    "app/navigation/layouts/vertical-navigation/navigation.html",
            },
            verticalNavigationFullwidthToolbar2: {
                main:
                    "app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html",
                toolbar:
                    "app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html",
                navigation:
                    "app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html",
            },
            horizontalNavigation: {
                main: "app/core/layouts/horizontal-navigation.html",
                toolbar:
                    "app/toolbar/layouts/horizontal-navigation/toolbar.html",
                navigation:
                    "app/navigation/layouts/horizontal-navigation/navigation.html",
            },
            contentOnly: {
                main: "app/core/layouts/content-only.html",
                toolbar: "",
                navigation: "",
            },
            contentWithToolbar: {
                main: "app/core/layouts/content-with-toolbar.html",
                toolbar:
                    "app/toolbar/layouts/content-with-toolbar/toolbar.html",
                navigation: "",
            },
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider.state("app", {
            abstract: true,
            views: {
                "main@": {
                    templateUrl: layouts[layoutStyle].main,
                    controller: "MainController as vm",
                },
                "toolbar@app": {
                    templateUrl: layouts[layoutStyle].toolbar,
                    controller: "ToolbarController as vm",
                },
                "navigation@app": {
                    templateUrl: layouts[layoutStyle].navigation,
                    controller: "NavigationController as vm",
                },
                "quickPanel@app": {
                    templateUrl: "app/quick-panel/quick-panel.html",
                    controller: "QuickPanelController as vm",
                },
            },
        });
    }
})();

(function () {
    "use strict";

    angular.module("hcportal").factory("authInterceptor", authInterceptor);

    authInterceptor.$inject = ["$q", "$location", "$localStorage"];

    /* @ngInject */
    function authInterceptor($q, $location, $localStorage) {
        return {
            request: request,
            responseError: responseError,
        };

        ////////////////////
        function request(config) {
            config.headers = config.headers || {};
            if (!!$localStorage.token) {
                config.headers.token = $localStorage.token;
            }
            if (!!$localStorage.tokenAuth) {
                config.headers.tokenAuth = $localStorage.tokenAuth;
            }

            // ini tidak perlu di tambahkan disini karna sudh menggunakan jwtInterceptors
            if (!!$localStorage.tokenJWT) {
                //pastikan di file .httaccess alow kan Authorization header
                config.headers.Authorization =
                    "Bearer " + $localStorage.tokenJWT;
            }
            return config;
        }

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.user;
                delete $localStorage.group;
                delete $localStorage.tokenAuth;
                delete $localStorage.token;
                // $location.path('/login');
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('hcportal')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, $rootScope) {
        var vm = this;
        // fuseTheming.setActiveTheme('nabati1');

        // fuseTheming.setActiveTheme('fruit-salad');

      // fuseTheming.setActiveTheme('tealTheme');

       fuseTheming.setActiveTheme('pasdigit001');

     //  fuseTheming.setActiveTheme('hrlink');

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();

(function () {
        'use strict';
        angular.module('hcportal').constant('config', {
                name: 'production',
                api: '/',
                appID: 'pasdigit-001',
                port: ''
        });
})();

(function () {
    'use strict';

    angular.module('hcportal').config(config);

    /** @ngInject */
    function config(
        $translateProvider,
        $httpProvider,
        $mdThemingProvider,
        $localStorageProvider,
        msNavigationServiceProvider,
        $translatePartialLoaderProvider,
        $mdDateLocaleProvider
    ) {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
        $httpProvider.interceptors.push('authInterceptor');
        $translatePartialLoaderProvider.addPart('app');

    

        var blueGrey = $mdThemingProvider.extendPalette('blue-grey', {
            '400': '#06a354',
            '500': '#349041',
            '600': '#48773c',
            '700': '#41693d'
        });

       
        $mdThemingProvider.definePalette('my-blue-grey', blueGrey);


     

        /*==========================================
            =            config theme color            =
            ==========================================*/
       $mdThemingProvider.definePalette('pasdigit-001-red', {
   '50': 'ffebef',
  '100': 'ffcdd4',
  '200': 'f89a9c',
  '300': 'f27175',
  '400': 'fe4d52',
  '500': 'ff3735',
  '600': 'f52c36',
  '700': 'e31f2f',
  '800': 'd61428',
  '900': 'c8001a',
  'A100': 'ffffff',
  'A200': 'fffcfc',
  'A400': 'ffc9c9',
  'A700': 'ffafaf',
  'contrastDefaultColor': 'light',
  'contrastDarkColors': [
    '50',
    '100',
    '200',
    '300',
    '400',
    'A100',
    'A200',
    'A400',
    'A700'
  ],
  'contrastLightColors': [
    '500',
    '600',
    '700',
    '800',
    '900'
  ]
});

       $mdThemingProvider.definePalette('pasdigit-001-yellow', {
  '50': 'fdfaeb',
  '100': 'faf3ce',
  '200': 'f6ebae',
  '300': 'f2e38d',
  '400': 'f0dd74',
  '500': 'edd75c',
  '600': 'ebd354',
  '700': 'e8cd4a',
  '800': 'e5c741',
  '900': 'e0be30',
  'A100': 'ffffff',
  'A200': 'fffcf1',
  'A400': 'fff1be',
  'A700': 'ffeca4',
  'contrastDefaultColor': 'light',
  'contrastDarkColors': [
    '50',
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    'A100',
    'A200',
    'A400',
    'A700'
  ],
  'contrastLightColors': []
});

   $mdThemingProvider.definePalette('pasdigit-001-purple', {
  '50': 'f0e7ef',
  '100': 'dac3d7',
  '200': 'c29cbc',
  '300': 'aa74a1',
  '400': '97568d',
  '500': '853879',
  '600': '7d3271',
  '700': '722b66',
  '800': '68245c',
  '900': '551749',
  'A100': 'ff91e8',
  'A200': 'ff5edd',
  'A400': 'ff2bd2',
  'A700': 'ff12cd',
  'contrastDefaultColor': 'light',
  'contrastDarkColors': [
    '50',
    '100',
    '200',
    '300',
    'A100',
    'A200'
  ],
  'contrastLightColors': [
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    'A400',
    'A700'
  ]
});

   $mdThemingProvider.definePalette('pasdigit-001-green', {
   '50': 'd7f8f5',
  '100': '97eee4',
  '200': '1fe3d3',
  '300': '00d4be',
  '400': '00c6ad',
  '500': '00b89b',
  '600': '00aa8d',
  '700': '00987b',
  '800': '00886b',
  '900': '006a4b',
  'A100': 'bdffec',
  'A200': '8affdd',
  'A400': '57ffcf',
  'A700': '3dffc7',
  'contrastDefaultColor': 'light',
  'contrastDarkColors': [
    '50',
    '100',
    '200',
    '300',
    '400',
    'A100',
    'A200',
    'A400',
    'A700'
  ],
  'contrastLightColors': [
    '500',
    '600',
    '700',
    '800',
    '900'
  ]
});


   /*=====================end color pallate======================*/ 

    $mdThemingProvider.theme('pasdigit001')
    .primaryPalette('pasdigit-001-green', {
      'default': '500', // by default use shade 400 from the pink palette for primary intentions
      'hue-1'  : '600', // use shade 100 for the <code>md-hue-1</code> class
      'hue-2'  : '200', // use shade 600 for the <code>md-hue-2</code> class
      'hue-3'  : 'A100'// use shade A100 for the <code>md-hue-3</code> class
    })
    // If you specify less than all of the keys, it will inherit from the
    // default shades
    .accentPalette('pasdigit-001-yellow', {
      'default': '500', // by default use shade 400 from the pink palette for primary intentions
      'hue-1'  : '600', // use shade 100 for the <code>md-hue-1</code> class
      'hue-2'  : '500', // use shade 600 for the <code>md-hue-2</code> class
      'hue-3'  : 'A100'// use shade A100 for the <code>md-hue-3</code> class
    })
    .warnPalette('pasdigit-001-red',{
      'default': '700', // by default use shade 400 from the pink palette for primary intentions
      'hue-1'  : '600', // use shade 100 for the <code>md-hue-1</code> class
      'hue-2'  : '500', // use shade 600 for the <code>md-hue-2</code> class
      'hue-3'  : 'A100'// use shade A100 for the <code>md-hue-3</code> class
    }).
    backgroundPalette('grey',{
        'default': 'A100',
        'hue-1'  : 'A100',
        'hue-2'  : '100',
        'hue-3'  : '300'
    });


//    $mdThemingProvider.theme('pasdigit-001')
//     .primaryPalette('pasdigit-001-red')
//     .accentPalette('pasdigit-001-yellow')
//     .warnPalette('pasdigit-001-red')
//     .backgroundPalette('grey');     

var blackPallete = $mdThemingProvider.extendPalette('grey', {
            '500': '#000000',
            '600': '#011627',
            '700': '#011627',
            '800': '#07BEB8',
            '900': '#8F3985',
            contrastDefaultColor: 'dark'
        });
        $mdThemingProvider.definePalette('black', blackPallete);

        /*=====  End of config theme color  ======*/

        /* theme for sidenav */
        // $mdThemingProvider
        //     .theme('left-sidenav-theme')
        //     .primaryPalette('pasdigit001p', {
        //         'hue-1': '100' // background color for header menu
        //     })
        //     .warnPalette('pasdigit001p', {
        //         'hue-3': '400' // background color active
        //     })
        //     .accentPalette('pasdigit001p', {
        //         'default': '600',
        //         'hue-3': '200', // this for font color
        //         'hue-2': '300' // color for title header text
        //     })
        //     .backgroundPalette('pasdigit001p', {
        //         'hue-1': '500' // background color left-side-nav
        //     });

        /* theme for table */
        $mdThemingProvider
            .theme('table-theme')
            .primaryPalette('black', {
                default: '900'
            })
            .warnPalette('grey', {
                'hue-3': '50' // background color active
            })
            .accentPalette('orange', {
                default: '500',
                'hue-3': '800', // this for font color
                'hue-2': '800' // color for nabati group text
            });

        /* theme for modal */
        $mdThemingProvider
            .theme('modal-theme')
            .primaryPalette('teal', {
                default: '200'
            })
            .warnPalette('deep-orange')
            .accentPalette('orange');

        $mdThemingProvider
            .theme('modal-theme-red')
            .primaryPalette('red')
            .warnPalette('deep-orange')
            .accentPalette('orange');


        $mdThemingProvider
            .theme('table-toolbar-theme')
            .primaryPalette('blue', {
                default: '500'
            })
            .warnPalette('red')
            .accentPalette('cyan', {
                default: '700'
            });
   




        /* set menu */
        var objMenu = $localStorageProvider.get('listMenu1');
        if (!!objMenu) {
            var jumMenu = objMenu.length,
                i = 0;
            for (i; i < jumMenu; i++) {
                //console.log( typeOf parseInt(objMenu[i].options.weight));
                objMenu[i].options.weight = parseInt(objMenu[i].options.weight);
                msNavigationServiceProvider.saveItem(
                    objMenu[i].menuname,
                    objMenu[i].options
                );
            }
        }

        /*----------  format date  ----------*/

        $mdDateLocaleProvider.formatDate = function (date) {
            if (typeof date !== 'undefined' && date != null) {
                var day = date.getDate();
                var monthIndex = date.getMonth();
                var year = date.getFullYear();

                return day + '/' + (monthIndex + 1) + '/' + year;
            }
            return null;
        };
    }
})();

(function () {
    "use strict";

    angular.module("hcportal").factory("AppAPI", apiService);
    apiService.$inject = ["$resource", "config"];
    /** @ngInject */
    function apiService($resource, config) {
        var service = {
            auth: auth,
            TokenApi: TokenApi,
            Login: Login,
            Logout: Logout,
            Kpi: kpi,
            BU: bu,
            Division: division,
            Department: department,
            Level: level,
            Jobtitle: jobtitle,
            Jfm: jfm,
            KpiScales: kpiScales,
            Profiles: profiles,
            Employement: employement,
            Employe: employe,
            Password: password,
            Group: group,
            Module: module,
            User: user,
            Attendance: Attendance,
            Mpp: mpp,
            Mpn: mpn,
            MpnApproval: mpnApproval,
            teamMember: teamMember,
            kpiResult: kpiResult,
            Behivor: behivor,
            Infolokasi: infolokasi,
            Menu: menu,
            Modules: modules,
            LoginEcheckIn: LoginEcheckIn,
            LoginEcheckInGw: LoginEcheckInGw,
            Address: address,
            Bank: bank,
            Certification: certification,
            Dependents: dependents,
            Employements: employements,
            Worklocation: worklocation,
            Status: status,
            Skjic: skjic,
            Document: document1,
            Education: education,
            Emergency: emergency,
            Experience: experiences,
            Imigration: imigration,
            Language: language,
            Tax: tax,
            Training: training,
            Administration: administration,
            EcheckinPass: echeckinpass,
            EcheckinPassGw: echeckinpassgw,
            Changepassword: changepassword,
            Echeckingw: echeckingw,
            Grouppermission: grouppermission,
            Kpimaster: kpimaster,
            Kpisetting: kpisetting,
            Kpiteam: kpiteam,
            Behivorteam: behivorteam,
            Papeople: papeople,
            Reportchartpa: reportchartpa,
            Reportchartpabu: reportchartpabu,
            Reportkpi: reportkpi,
            Reportkpinonpeople: reportkpinonpeople,
            Reportkpipeople: reportkpipeople,
            Reportpa: reportpa,
            Overtime: overtime,
            Employeot: employeot,
            Employeabsence: employeabsence,
            Approvalot: approvalot,
            Approvalabsence: approvalabsence,
            Employeghk: employeghk,
            Approvalghk: approvalghk,
            Attendanceemploye: attendanceemploye,
            Shiftlocation: shiftlocation,
            Employeshift: employeshift,
            Empbreakfinger: empbreakfinger,
            Changeshiftapproval: changeshiftapproval,
            Abnormalapproval: abnormalapproval,
            Saldoghk: saldoghk,
            Listovertime: listovertime,
            Attendanceteam: attendanceteam,
            Businesstrip: businesstrip,
            Approvalfinger: approvalfinger,
            Echeckinlist: echeckinlist,
            Abnormal: abnormal,
            Changeshift: changeshift,
            Updatefinger: updatefinger,
            Leavereport: leavereport,
            Empjoinholiday: empjoinholiday,
            Shiftghkreport: shiftghkreport,
            Abnormalreport: abnormalreport,
            Attendancereport: attendancereport,
            DownloadReportAttendance: DownloadReportAttendance,
            InfoApproval: infoApproval,
            Halfdayreport: halfdayreport,
            Truant: truant,
            Leaveupload: leaveupload,
            Employeshifttemplate: employeshifttemplate,
            Leavebalance: leavebalance,
            Leavebalanceemp: leavebalanceemp,
            Termination: termination,
            Competency: competency,
            CompetencyReview: competencyreview,
            JobCodeProfile: jobcodeprofile,
            CompetencyTeam: competencyteam,
            TalentReview: talentreview,
            Edp: edp,
            Idp: idp,
            EmpJobCode: empjobcode,
            EmpPotential: emppotential,
            Employeshiftunschedule: employeshiftunschedule,
            Employeotoutlet: employeotoutlet,
            Sicleaveapproval: sicleaveapproval,
            Sicabnormalapproval: sicabnormalapproval,
            Sicapprovalfinger: sicapprovalfinger,
            Amleaveapproval: amleaveapproval,
            Amapprovalot: amapprovalot,
            Amabnormalapproval: amabnormalapproval,
            Amapprovalfinger: amapprovalfinger,
            Hrbpattendanceteam: hrbpattendanceteam,
            Hrbpkpiteam: hrbpkpiteam,
            CrProgress: crprogress,
            Hrbpleavereport: hrbpleavereport,
            Employeghkholiday: employeghkholiday,
            Approvalghkholiday: approvalghkholiday,
            EmpSurvey: empsurvey,
            EmpSurveys: empsurveys,
            EmpAssessment: empassessment,
            Sicmapping: sicmapping,
            Sicmappingapproval: sicmappingapproval,
            Employeoutletteam: employeoutletteam,
            Amoutletmappingapproval: amoutletmappingapproval,
            Outletmapping: outletmapping,
            Sicteam: sicteam,
            Assessment: assessment,
            Sicchangeshiftapproval: sicchangeshiftapproval,
            Employeupdateapproval: employeupdateapproval,
            Locktransaction: locktransaction,
            Insurance: insurance,
            StoreIncharge: storeIncharge,
            NationalHoliday: getHoliday,
            LeaveHold: getLeaveHold,
            JoinHoliday: getJoinHoliday,
            CommitAttendance: commitattendance,
            EmpCategory: EmpCategory,
            UmutProcess: UmutProcess,
            UmutHistory: UmutHistory,
            CutOffPeriode: getCutOffPeriode,
            EmpLaborType: getEmpLaborType,
            Overtimeconfiguration: overtimeconfiguration,
            Employeecostcenter: employeecostcenter,
            Costcenter: costcenter,
            Teamassignment: teamassignment,
            Subarea: subarea,
            Promotion: promotion,
            Uploadfinger: uploadfinger,
            BoronganTransaction: boronganTransaction,
            Gedung: gedung,
            Borongan: borongan,
            Helpdesk: helpdesk,
            EmployeApraisal: employeApraisal,
            School: school,
            NewsCategory: NewsCategory,
            News: News,
            GhkHolidayGw: GhkHolidayGw,
            ApprovalghkholidayGw: ApprovalghkholidayGw,
            AnnualLeaveRules: AnnualLeaveRules,
            UpdateFingerReason: UpdateFingerReason,
            TypeShiftMatrix: TypeShiftMatrix,
            Notification: notification,
            //payroll
            Payroll: payroll,
            SalaryComponent: salarycomponent,
            PayrollEmployee: payrollemployee,
            Ptkp: ptkp,
            TaxParameter: taxparameter,
            Jamsostek: jamsostek,
            SyncEmployee: syncemployee,
            EmployeeGroup: employeegroup,
            // CutOffParameter:cutoffparameter,
            AbsentRate: absentrate,
            ShiftRate: shiftrate,
            PositionRate: positionrate,
            TaxLocation: taxlocation,
            ProrateParameter: prorateparameter,
            OtParameter: otparameter,
            EncashmentLeave: EncashmentLeave,
            FixEntry: fixentry,
            GroupEntry: groupentry,
            NonFixEntry: nonfixentry,
            PayrollProcess: payrollprocess,
            PayrollProcesspma: payrollprocesspma,
            GradeRate: graderate,
            LaporanProsesPayroll: laporanprosespayroll,
            LaporanGaji: laporangaji,
            LaporanGajipma: laporangajipma,
            LaporanGajiDetailpma: laporangajidetailpma,
            LaporanPajak: laporanpajak,
            LaporanPajakA1: laporanpajaka1,
            LaporanLembur: laporanlembur,
            Espttax: espttax,
            Banktransfer: banktransfer,
            Banktransferpma: banktransferpma,
            JurnalGajipma: JurnalGajipma,
            RekapGajipma: RekapGajipma,
            Banktransferthrpma: banktransferthrpma,
            Payslip: payslip,
            AllowanceFix: allowancefix,
            DeductionNonFix: deductionnonfix,
            DeductionFix: deductionfix,
            CarTransaction: cartransaction,
            CarRate: carrate,
            LaporanBpjsTk: laporanbpjstk,
            KeluarBpjs: keluarbpjs,
            PerubahanUpah: perubahanupah,
            FormulirBpjs: formulirbpjs,
            PendaftaranBpjs: pendaftaranbpjs,
            UploadFixNonFix: uploadfixnonfix,
            SAPReport: sapreport,
            DaftarMutasi: daftarmutasi,
            NonAktif: nonaktif,
            PerubahanGaji: perubahangaji,
            ClosePayroll: closepayroll,
            AnalisaCostCentre: analisacostcentre,
            GajiCostCentre: gajicostcentre,
            //endpayroll
            Town: town,
            SubstitutionLeaveOT: SubstitutionLeaveOT,
            AdminDepartment: AdminDepartment,
            GhkGw: GhkGw,
            ApprovalGhkGw: ApprovalGhkGw,
            EmployeOvertimeGw: EmployeOvertimeGw,
            ApprovalOvertimeGw: ApprovalOvertimeGw,
            EmployeGhkHalfday: EmployeGhkHalfday,
            ApprovalGhkHalfday: ApprovalGhkHalfday,
            GhkHalfdayGw: GhkHalfdayGw,
            ApprovalGhkHalfdayGw: ApprovalGhkHalfdayGw,
            ChecklistAttendanceGw: ChecklistAttendanceGw,
            ChecklistAttendanceGwAdmin: ChecklistAttendanceGwAdmin,
            SaldoghkGw: saldoghkGw,
            AreaManager: areaManager,
            OutletTeamList: outletTeamList,
            SicTeamMapping: sicTeamMapping,
            ViewOutletTeam: viewOutletTeam,
            EmployeActing: EmployeActing,
            UserSFA: userSFA,
            OfbRefCheck: ofbRefCheck,
            Orgchart: Orgchart,
            OfbRegistration: OfbRegistration,
            OfbApprovalGroup: OfbApprovalGroup,
            Orgchartemp: Orgchartemp,
            MppApproval: MppApproval,
            MppOrgtable: MppOrgtable,
            MppMgr: MppMgr,
            EmpJic: EmpJic,
            Completeness: Completeness,
            OfbExitInterview: OfbExitInterview,
            Ofbhandover: Ofbhandover,
            MppReportCost: MppReportCost,
            MppReportHC: MppReportHC,
            MppReportCostUser: MppReportCostUser,
            MppReportHCUser: MppReportHCUser,
            Correspondence: Correspondence,
            Policy: Policy,
            Onboarding: Onboarding,
            Reminder: Reminder,
            MppReportCostBudget: MppReportCostBudget,
            MppReportHCCCAdmin: MppReportHCCCAdmin,
            MppReportHCCCUser: MppReportHCCCUser,
            EmployeShiftMigrate: EmployeShiftMigrate,
            jobEvaluation: jobEvaluation,
            CorrespondencePma: CorrespondencePma,
            CorrespondencePmaApproval: CorrespondencePmaApproval,
            Tiket: tiket,
            TiketApproval: tiketApproval,
            IndisciplinaryRequest: IndisciplinaryRequest,
            Replacement: Replacement,
            LaporanThr: laporanthr,
            ThrProcess: thrprocess,
            IndisciplinaryApproval: IndisciplinaryApproval,
            MpnGw: MpnGw,
            WilayahSales: WilayahSales,
            RegionalSales: RegionalSales,
            CabangSales: CabangSales,
            AreaSales: AreaSales,
            EmpAreaSales: EmpAreaSales,
            AreaSalesStatus: AreaSalesStatus,
            AdminAreaIncharge: AdminAreaIncharge,
            EmployeeAlert: EmployeeAlert,
            EmployeeAlertProcess: EmployeeAlertProcess,
            WarningLetter: WarningLetter,
            JobCode: JobCode,
            IndisciplinaryAdmin: IndisciplinaryAdmin,
            AMStoreIncharge: amStoreIncharge,
            NewSalaryComponent: NewSalaryComponent,
            NewPayrollProcess: NewPayrollProcess,
            NewAbsentRate: NewAbsentRate,
            NewGradeRate: NewGradeRate,
            NewPositionRate: NewPositionRate,
            NewTaxParameter: NewTaxParameter,
            NewTaxLocation: NewTaxLocation,
            NewJamsostek: NewJamsostek,
            NewOtParameter: NewOtParameter,
            NewProrateparameter: NewProrateparameter,
            NewPtkp: NewPtkp,
            NewCarRate: NewCarRate,
            NewPayrollEmployee: NewPayrollEmployee,
            NewFixEntry: NewFixEntry,
            New13Salary: New13Salary,
            NewBonus: NewBonus,
            NewGroupentry: NewGroupentry,
            NewLaporanProsesPayroll: NewLaporanProsesPayroll,
            NewCarTransaction: NewCarTransaction,
            NewUploadFixNonFix: NewUploadFixNonFix,
            NewNonFixEntry: NewNonFixEntry,
            EncashmentLeaveManagement: EncashmentLeaveManagement,
            NewAllowanceFix: NewAllowanceFix,
            NewDeductionFix: NewDeductionFix,
            NewDeductionNonFix: NewDeductionNonFix,
            NewClosePayroll: NewClosePayroll,
            NewThrProcess: NewThrProcess,
            NewPublishPayslip: NewPublishPayslip,
            NewPublishThr: NewPublishThr,
            NewPayslip: NewPayslip,
            NewLaporanGaji: NewLaporanGaji,
            NewLaporanGajiDetail: NewLaporanGajiDetail,
            NewAnalisaCostCentre: NewAnalisaCostCentre,
            NewBanktransfer: NewBankTransfer,
            NewEspttax: NewEspttax,
            NewGajiCostCentre: NewGajiCostCentre,
            NewDaftarMutasi: NewDaftarMutasi,
            NewNonAktif: NewDaftarMutasi,
            NewPerubahanGaji: NewDaftarMutasi,
            NewLaporanbpjstk: NewLaporanbpjstk,
            NewKeluarBpjs: NewLaporanbpjstk,
            NewPerubahanUpah: NewLaporanbpjstk,
            NewFormulirBpjs: NewLaporanbpjstk,
            NewPendaftaranBpjs: NewLaporanbpjstk,
            NewLaporanLembur: NewLaporanLembur,
            NewLaporanPajakA1: NewLaporanPajak,
            NewLaporanPajak: NewLaporanPajak,
            NewLaporanThr: NewLaporanThr,
            NewSAPReport: NewSAPReport,
            EmployeeReport: EmployeeReport,
            HcTicket: HcTicket,
            Umutreport: Umutreport,
            Insentifreport: Insentifreport,
            AdditionalUMUT: AdditionalUMUT,
            AdditionalInsentif: AdditionalInsentif,
            Umuttransfer: Umuttransfer,
            Insentiftransfer: Insentiftransfer,
            UploadHoliday: UploadHoliday,
            HrCompletion: HrCompletion,
            HandoverGw: HandoverGw,
            ProductionHandoverGw: ProductionHandoverGw,
            TrainingGw: TrainingGw,
            GwMoving: GwMoving,
            ShortLeaveGw: ShortLeaveGw,
            AdditionalUmutApproval: AdditionalUmutApproval,
            BankOpsTransfer: BankOpsTransfer,
            AdditionalInsentifApproval: AdditionalInsentifApproval,
            MppStandard: MppStandard,
            TimestudyStandard: TimestudyStandard,
            EmpLinePosition: EmpLinePosition,
            ProductMachinePosition: ProductMachinePosition,
            ProductionProduct: ProductionProduct,
            Productions: Productions,
            PkwtManagementIr: PkwtManagementIr,
            PkwtManagementTa: PkwtManagementTa,
            MacProductSpecification: MacProductSpecification,
            MacoutputSpecification: MacoutputSpecification,
            MachineLine: MachineLine,
            BpjsMalaysiaEis: BpjsMalaysiaEis,
            BpjsMalaysiaEpf: BpjsMalaysiaEpf,
            BpjsMalaysiaSocso: BpjsMalaysiaSocso,
            TaxMalaysia: TaxMalaysia,
            SyncPma: SyncPma,
            IndisciplinaryConfirm: IndisciplinaryConfirm,
            IndisciplinaryValidation: IndisciplinaryValidation,
            Approvalassignment: Approvalassignment,
            ActivityForeman: ActivityForeman,
            MovingLocation: MovingLocation,
            AreaCoverage: AreaCoverage,
            Employeeadmin: employeeadmin,
            EmpSalesCode: EmpSalesCode,
            ApplicationAdmin: ApplicationAdmin,
            DepartmentBusiness: DepartmentBusiness,
            EmployeeExchange: EmployeeExchange,
            RefBank: RefBank,
            EmpAdjustmentAllowance: EmpAdjustmentAllowance,
            WfhFe: WfhFe,
            RefSalesType: RefSalesType,
            RefSalesCode: RefSalesCode,
            WfhReport: WfhReport,
            Wfhadmin: Wfhadmin,
            LockSetting: LockSetting,
            InsentifKpiSetting: InsentifKpiSetting,
            InsentifTargetAbsolute: InsentifTargetAbsolute,
            InsentifOverrideTargetAbsolute: InsentifOverrideTargetAbsolute,
            InsentifSkema: InsentifSkema,
            InsentifSkemaOverride: InsentifSkemaOverride,
            InsentifSalesTarget: InsentifSalesTarget,
            InsentifSalesTargetContribution: InsentifSalesTargetContribution,
            InsentifLph: InsentifLph,
            UploadWfhUmut: UploadWfhUmut,
            InsentifCalculation: InsentifCalculation,
            InsentifCalculationass: InsentifCalculationass,
            RefMasterSku: RefMasterSku,
            MpnResetSLT: mpnResetSLT,
            MpnMassRole: mpnMassRole,
            InsentifRequirementSku: InsentifRequirementSku,
            InsentifSkuFocus: InsentifSkuFocus,
            InsentifBarcode: InsentifBarcode,
            InsentifBarcodeBsr: InsentifBarcodeBsr,
            InsentifPinalty: InsentifPinalty,
            InsentifPinaltySp: InsentifPinaltySp,
            InsentifProcess: InsentifProcess,
            InsentifProcessAss: InsentifProcessass,
            InsentifApproval: InsentifApproval,
            InsentifApprovalAss: InsentifApprovalAss,
            InsentifLockSales: InsentifLockSales,
            LoginBackground: LoginBackground,
            EmpAppraisal: EmpAppraisal,
            Mtx: Mtx,
            Certificateprograms: Certificateprograms,
            Elearning: Elearning,
            InsentifSkemaAssAdjust: InsentifSkemaAssAdjust,
            InsentifAdjusmentKpi: InsentifAdjusmentKpi,
            InsentifAdjustmentTargetAbsolute: InsentifAdjustmentTargetAbsolute,
            InsentifSkuFocusGeneral: InsentifSkuFocusGeneral,
            InsuranceGovernment: InsuranceGovernment,
            Certificateclassrooms: Certificateclassrooms,
            Certificate: Certificate,
            Approvalcertificate: Approvalcertificate,
            Insentifmonitoring: Insentifmonitoring,
            Insentifmonitoringlph: Insentifmonitoringlph,
            RefSubdis: RefSubdis,
            HkeAreaSubdis: HkeAreaSubdis,
            EmpHkeAreaSubdis: EmpHkeAreaSubdis,
            EmpSubdis: EmpSubdis,
            MyMpp: MyMpp,
            InsentifUploadMasterCb: InsentifUploadMasterCb,
            BusinessTravel: businessTravel,
            ViewOrgEmployee: viewOrgEmployee,
            TP: tp,
            ApprovalTP: ApprovalTP,
            ApprovalTA: ApprovalTA,
            ApprovalTR: ApprovalTR,
            HRcheckA: HRcheckA,
            HRcheckL: HRcheckL,
            BusinesstripMaster: businesstripMaster,
             TokenAuth: tokenAuth
        };

        return service;

        function auth() {
            return $resource(config.api + "api/token");
        }

        function TokenApi() {
            var objToken = $resource(config.api + "api/token", null, {
                setCookie: {
                    method: "POST",
                    withCredentials: false,
                },
                getToken: {
                    method: "GET",
                    withCredentials: false,
                },
                refreshJWT: {
                    method: "POST",
                    withCredentials: false,
                    params: {
                        action: "refreshJWT",
                    },
                },
            });
            return objToken;
        }

        function Login() {
            var objLogin = $resource(config.api + "api/login/cekLogin", null, {
                save: {
                    method: "POST",
                    withCredentials: false,
                },
            });
            return objLogin;
        }

        function LoginBackground() {
            return $resource(config.api + "api/login/loginBackground");
        }

        function LoginEcheckIn() {
            var objLogin = $resource(config.api + "api/login/echeckin", null, {
                save: {
                    method: "POST",
                    withCredentials: false,
                },
            });
            return objLogin;
        }

        function LoginEcheckInGw() {
            var objLogin = $resource(
                config.api + "api/login/echeckingw",
                null,
                {
                    save: {
                        method: "POST",
                        withCredentials: false,
                    },
                }
            );
            return objLogin;
        }

        function Logout() {
            var objLogin = $resource(config.api + "api/login/logout", null, {
                logout: {
                    method: "GET",
                    withCredentials: false,
                },
            });
            return objLogin;
        }

        function kpi() {
            return $resource(config.api + "api/kpi");
        }

        function bu() {
            return $resource(config.api + "api/bu");
        }

        function division() {
            return $resource(config.api + "api/division");
        }

        function department() {
            return $resource(config.api + "api/department");
        }

        function level() {
            return $resource(config.api + "api/level");
        }

        function jobtitle() {
            return $resource(config.api + "api/jobtitle");
        }

        function jfm() {
            return $resource(config.api + "api/jfm");
        }

        function kpiScales() {
            return $resource(config.api + "api/kpiscales");
        }

        function profiles() {
            return $resource(config.api + "api/profiles");
        }

        function employement() {
            return $resource(config.api + "api/employement");
        }

        function employe() {
            return $resource(config.api + "api/employe");
        }

        function password() {
            return $resource(config.api + "api/password");
        }

        function group() {
            return $resource(config.api + "api/group");
        }

        function module() {
            return $resource(config.api + "api/module");
        }

        function user() {
            return $resource(config.api + "api/user");
        }

        function Attendance() {
            return $resource(config.api + "api/attendance");
        }

        function mpp() {
            return $resource(config.api + "api/mpp");
        }

        function mpn() {
            return $resource(config.api + "api/mpn");
        }

        function mpnApproval() {
            var obj = $resource(config.api + "api/mpnapproval", null, {
                approvalstatus: {
                    method: "POST",
                    url: config.api + "api/mpnapproval?action=approvalstatus",
                },
                updatestatus: {
                    method: "POST",
                    url: config.api + "api/mpnapproval?action=updatestatus",
                },
            });

            return obj;
        }

        function teamMember() {
            return $resource(config.api + "api/teammember");
        }

        function kpiResult() {
            return $resource(config.api + "api/kpiresult");
        }

        function behivor() {
            return $resource(config.api + "api/behivor");
        }

        function infolokasi() {
            return $resource(config.api + "api/infolokasi");
        }

        function menu() {
            return $resource(config.api + "api/menus");
        }

        function modules() {
            return $resource(config.api + "api/modules");
        }

        function address() {
            return $resource(config.api + "api/address");
        }

        function bank() {
            return $resource(config.api + "api/bank");
        }

        function certification() {
            return $resource(config.api + "api/certification");
        }

        function dependents() {
            return $resource(config.api + "api/dependents");
        }

        function employements() {
            return $resource(config.api + "api/employements");
        }

        function worklocation() {
            return $resource(config.api + "api/worklocation");
        }

        function status() {
            return $resource(config.api + "api/status");
        }

        function skjic() {
            return $resource(config.api + "api/skjic");
        }

        function document1() {
            return $resource(config.api + "api/documents");
        }

        function education() {
            return $resource(config.api + "api/education");
        }

        function emergency() {
            return $resource(config.api + "api/emergency");
        }

        function experiences() {
            return $resource(config.api + "api/experiences");
        }

        function imigration() {
            return $resource(config.api + "api/imigration");
        }

        function language() {
            return $resource(config.api + "api/language");
        }

        function tax() {
            return $resource(config.api + "api/tax");
        }

        function training() {
            return $resource(config.api + "api/training");
        }

        function administration() {
            return $resource(config.api + "api/administration");
        }

        function echeckinpass() {
            return $resource(config.api + "api/passwordecheckin");
        }

        function echeckinpassgw() {
            return $resource(config.api + "api/passwordecheckingw");
        }

        function echeckingw() {
            return $resource(config.api + "api/echeckingw");
        }

        function changepassword() {
            var objLogin = $resource(
                config.api + "api/changepassword/savechange",
                null,
                {
                    save: {
                        method: "POST",
                        withCredentials: false,
                    },
                }
            );
            return objLogin;
        }

        function grouppermission() {
            return $resource(config.api + "api/grouppermission");
        }

        function kpimaster() {
            return $resource(config.api + "api/kpimaster");
        }

        function kpisetting() {
            return $resource(config.api + "api/kpisetting");
        }

        function kpiteam() {
            return $resource(config.api + "api/kpiteam");
        }

        function behivorteam() {
            return $resource(config.api + "api/behivorteam");
        }

        function papeople() {
            return $resource(config.api + "api/papeople");
        }

        function reportchartpa() {
            return $resource(config.api + "api/reportchartpa");
        }

        function reportchartpabu() {
            return $resource(config.api + "api/reportchartpabu");
        }

        function reportkpi() {
            return $resource(config.api + "api/reportkpi");
        }

        function reportkpinonpeople() {
            return $resource(config.api + "api/reportkpinonpeople");
        }

        function reportkpipeople() {
            return $resource(config.api + "api/reportkpipeople");
        }

        function reportpa() {
            return $resource(config.api + "api/reportpa");
        }

        function overtime() {
            return $resource(config.api + "api/overtime");
        }

        function employeot() {
            return $resource(config.api + "api/employeot");
        }

        function employeabsence() {
            return $resource(config.api + "api/employeabsence");
        }

        function approvalot() {
            return $resource(config.api + "api/approvalot");
        }

        function approvalabsence() {
            return $resource(config.api + "api/approvalabsence");
        }

        function employeghk() {
            return $resource(config.api + "api/employeghk");
        }

        function approvalghk() {
            return $resource(config.api + "api/approvalghk");
        }

        function AdditionalUmutApproval() {
            return $resource(config.api + "api/additionalumutapproval");
        }

        function BankOpsTransfer() {
            return $resource(config.api + "api/bankopstransfer");
        }

        function AdditionalInsentifApproval() {
            return $resource(config.api + "api/additionalinsentifapproval");
        }

        function InsentifLockSales() {
            return $resource(config.api + "api/insentiflocksales");
        }

        function attendanceemploye() {
            return $resource(config.api + "api/attendanceemploye");
        }

        function shiftlocation() {
            return $resource(config.api + "api/shiftlocation");
        }

        function employeshift() {
            return $resource(config.api + "api/employeshift");
        }

        function EmployeShiftMigrate() {
            return $resource(config.api + "api/employeshiftmigrate");
        }

        function empbreakfinger() {
            return $resource(config.api + "api/empbreakfinger");
        }

        function changeshiftapproval() {
            return $resource(config.api + "api/changeshiftapproval");
        }

        function abnormalapproval() {
            return $resource(config.api + "api/abnormalapproval");
        }

        function saldoghk() {
            return $resource(config.api + "api/saldoghk");
        }

        function listovertime() {
            return $resource(config.api + "api/listovertime");
        }

        function attendanceteam() {
            return $resource(config.api + "api/attendanceteam");
        }

        function businesstrip() {
            return $resource(config.api + "api/businesstrip");
        }

        function approvalfinger() {
            return $resource(config.api + "api/approvalfinger");
        }

        function echeckinlist() {
            return $resource(config.api + "api/echeckinlist");
        }

        function abnormal() {
            return $resource(config.api + "api/abnormal");
        }

        function changeshift() {
            return $resource(config.api + "api/changeshift");
        }

        function updatefinger() {
            return $resource(config.api + "api/updatefinger");
        }

        function leavereport() {
            return $resource(config.api + "api/leavereport");
        }

        function empjoinholiday() {
            return $resource(config.api + "api/empjoinholiday");
        }

        function shiftghkreport() {
            return $resource(config.api + "api/shiftghkreport");
        }

        function abnormalreport() {
            return $resource(config.api + "api/abnormalreport");
        }

        function attendancereport() {
            return $resource(config.api + "api/attendancereport");
        }

        function DownloadReportAttendance() {
            return $resource(config.api + "api/downloadreportattendance");
        }

        function infoApproval() {
            return $resource(config.api + "api/infoapproval");
        }

        function halfdayreport() {
            return $resource(config.api + "api/halfdayreport");
        }

        function truant() {
            return $resource(config.api + "api/truant");
        }

        function leaveupload() {
            return $resource(config.api + "api/leaveupload");
        }

        function employeshifttemplate() {
            return $resource(config.api + "api/employeshifttemplate");
        }

        function competency() {
            return $resource(config.api + "api/competency");
        }

        function competencyreview() {
            return $resource(config.api + "api/competencyreview");
        }

        function jobcodeprofile() {
            return $resource(config.api + "api/jobcodeprofile");
        }

        function competencyteam() {
            return $resource(config.api + "api/competencyteam");
        }

        function talentreview() {
            return $resource(config.api + "api/talentreview");
        }

        function empjobcode() {
            return $resource(config.api + "api/empjobcode");
        }

        function leavebalance() {
            return $resource(config.api + "api/leavebalance");
        }

        function leavebalanceemp() {
            return $resource(config.api + "api/leavebalanceemp");
        }

        function termination() {
            return $resource(config.api + "api/termination");
        }

        function emppotential() {
            return $resource(config.api + "api/emppotential");
        }

        function employeshiftunschedule() {
            return $resource(config.api + "api/employeshiftunschedule");
        }

        function employeotoutlet() {
            return $resource(config.api + "api/employeotoutlet");
        }

        function sicleaveapproval() {
            return $resource(config.api + "api/sicleaveapproval");
        }

        function edp() {
            return $resource(config.api + "api/edp");
        }

        function sicabnormalapproval() {
            return $resource(config.api + "api/sicabnormalapproval");
        }

        function sicapprovalfinger() {
            return $resource(config.api + "api/sicapprovalfinger");
        }

        function amleaveapproval() {
            return $resource(config.api + "api/amleaveapproval");
        }

        function amapprovalot() {
            return $resource(config.api + "api/amapprovalot");
        }

        function amabnormalapproval() {
            return $resource(config.api + "api/amabnormalapproval");
        }

        function amapprovalfinger() {
            return $resource(config.api + "api/amapprovalfinger");
        }

        function idp() {
            return $resource(config.api + "api/idp");
        }

        function hrbpattendanceteam() {
            return $resource(config.api + "api/hrbpattendanceteam");
        }

        function hrbpkpiteam() {
            return $resource(config.api + "api/hrbpkpiteam");
        }

        function crprogress() {
            return $resource(config.api + "api/crprogress");
        }

        function hrbpleavereport() {
            return $resource(config.api + "api/hrbpleavereport");
        }

        function employeghkholiday() {
            return $resource(config.api + "api/employeghkholiday");
        }

        function approvalghkholiday() {
            return $resource(config.api + "api/approvalghkholiday");
        }

        function empsurvey() {
            return $resource(config.api + "api/empsurvey");
        }

        function empsurveys() {
            return $resource(config.api + "api/empsurveys");
        }

        function empassessment() {
            return $resource(config.api + "api/empassessment");
        }

        function sicmapping() {
            return $resource(config.api + "api/sicmapping");
        }

        function sicmappingapproval() {
            return $resource(config.api + "api/sicmappingapproval");
        }

        function employeoutletteam() {
            return $resource(config.api + "api/employeoutletteam");
        }

        function amoutletmappingapproval() {
            return $resource(config.api + "api/amoutletmappingapproval");
        }

        function outletmapping() {
            return $resource(config.api + "api/outletmapping");
        }

        function sicteam() {
            return $resource(config.api + "api/sicteam");
        }

        function assessment() {
            return $resource(config.api + "api/assessment");
        }

        function sicchangeshiftapproval() {
            return $resource(config.api + "api/sicchangeshiftapproval");
        }

        function employeupdateapproval() {
            return $resource(config.api + "api/employeupdateapproval");
        }

        function locktransaction() {
            return $resource(config.api + "api/locktransaction");
        }

        function insurance() {
            return $resource(config.api + "api/insurance");
        }

        function storeIncharge() {
            return $resource(config.api + "api/storeincharge");
        }

        function getLeaveHold() {
            return $resource(config.api + "api/leavehold");
        }

        function getJoinHoliday() {
            return $resource(config.api + "api/joinholiday");
        }

        function getHoliday() {
            return $resource(config.api + "api/nationalholiday");
        }

        function commitattendance() {
            return $resource(config.api + "api/commitattendance");
        }

        function EmpCategory() {
            return $resource(config.api + "api/Empcategory");
        }

        function UmutProcess() {
            return $resource(config.api + "api/umutprocess");
        }

        function UmutHistory() {
            return $resource(config.api + "api/umuthistory");
        }

        function getCutOffPeriode() {
            return $resource(config.api + "api/cutoffperiode");
        }

        function getEmpLaborType() {
            return $resource(config.api + "api/employelabortype");
        }

        function overtimeconfiguration() {
            return $resource(config.api + "api/overtimeconfiguration");
        }

        function employeecostcenter() {
            return $resource(config.api + "api/employeecostcenter");
        }

        function costcenter() {
            return $resource(config.api + "api/costcenter");
        }

        function teamassignment() {
            return $resource(config.api + "api/teamassignment");
        }

        function subarea() {
            return $resource(config.api + "api/subarea");
        }

        function borongan() {
            return $resource(config.api + "api/borongan");
        }

        function uploadfinger() {
            return $resource(config.api + "api/uploadfinger");
        }

        function boronganTransaction() {
            return $resource(config.api + "api/borongantransaction");
        }

        function gedung() {
            return $resource(config.api + "api/gedung");
        }

        function promotion() {
            return $resource(config.api + "api/promotion");
        }

        function helpdesk() {
            return $resource(config.api + "api/helpdesk");
        }

        function outletTeamList() {
            return $resource(config.api + "api/outletteamlist");
        }

        function sicTeamMapping() {
            return $resource(config.api + "api/sicteammapping");
        }

        function viewOutletTeam() {
            return $resource(config.api + "api/viewoutletteam");
        }

        function areaManager() {
            return $resource(config.api + "api/areamanager");
        }

        function employeApraisal() {
            return $resource(config.api + "api/employeapraisal");
        }

        function AnnualLeaveRules() {
            return $resource(config.api + "api/annualleaverules");
        }

        function NewsCategory() {
            return $resource(config.api + "api/hcnewscategory");
        }

        function school() {
            return $resource(config.api + "api/school");
        }

        function GhkHolidayGw() {
            return $resource(config.api + "api/ghkholidaygw");
        }

        function ApprovalghkholidayGw() {
            return $resource(config.api + "api/approvalghkholidaygw");
        }

        function SubstitutionLeaveOT() {
            return $resource(config.api + "api/substitutionleaveot");
        }

        function notification() {
            return $resource(config.api + "api/notification");
        }

        function payroll() {
            return $resource(config.api + "api/payroll");
        }

        function salarycomponent() {
            return $resource(config.api + "api/payroll/salarycomponent");
        }

        function payrollemployee() {
            return $resource(config.api + "api/payroll/payrollemployee");
        }

        function ptkp() {
            return $resource(config.api + "api/payroll/ptkp");
        }

        function taxparameter() {
            return $resource(config.api + "api/payroll/taxparameter");
        }

        function jamsostek() {
            return $resource(config.api + "api/payroll/jamsostek");
        }

        function syncemployee() {
            return $resource(config.api + "api/payroll/syncemployee");
        }

        function employeegroup() {
            return $resource(config.api + "api/payroll/employeegroup");
        }

        /*function cutoffparameter() {
    return $resource(config.api+'api/payroll/cutoffparameter');
    }*/

        function absentrate() {
            return $resource(config.api + "api/payroll/absentrate");
        }

        function shiftrate() {
            return $resource(config.api + "api/payroll/shiftrate");
        }

        function positionrate() {
            return $resource(config.api + "api/payroll/positionrate");
        }

        function taxlocation() {
            return $resource(config.api + "api/payroll/taxlocation");
        }

        function prorateparameter() {
            return $resource(config.api + "api/payroll/prorateparameter");
        }

        function otparameter() {
            return $resource(config.api + "api/payroll/otparameter");
        }

        function fixentry() {
            return $resource(config.api + "api/payroll/fixentry");
        }

        function groupentry() {
            return $resource(config.api + "api/payroll/groupentry");
        }

        function nonfixentry() {
            return $resource(config.api + "api/payroll/nonfixentry");
        }

        function payrollprocess() {
            return $resource(config.api + "api/payroll/payrollprocess");
        }

        function graderate() {
            return $resource(config.api + "api/payroll/graderate");
        }

        function laporanprosespayroll() {
            return $resource(config.api + "api/payroll/laporanprosespayroll");
        }

        function laporangaji() {
            return $resource(config.api + "api/payroll/laporangaji");
        }

        function laporangajipma() {
            return $resource(
                config.api + "api/payrollpma/report/laporangajipma"
            );
        }

        function laporangajidetailpma() {
            return $resource(
                config.api + "api/payrollpma/report/laporangajidetailpma"
            );
        }

        function banktransferpma() {
            return $resource(
                config.api + "api/payrollpma/report/banktransferpma"
            );
        }

        function JurnalGajipma() {
            return $resource(
                config.api + "api/payrollpma/report/jurnalgajipma"
            );
        }

        function RekapGajipma() {
            return $resource(config.api + "api/payrollpma/report/rekapgajipma");
        }

        function banktransferthrpma() {
            return $resource(
                config.api + "api/payrollpma/report/banktransferthrpma"
            );
        }

        function payrollprocesspma() {
            return $resource(config.api + "api/payrollpma/payrollprocesspma");
        }

        function laporanpajak() {
            return $resource(config.api + "api/payroll/laporanpajak");
        }

        function laporanpajaka1() {
            return $resource(config.api + "api/payroll/laporanpajak");
        }

        function laporanlembur() {
            return $resource(config.api + "api/payroll/laporanlembur");
        }

        function espttax() {
            return $resource(config.api + "api/payroll/espttax");
        }

        function Onboarding() {
            return $resource(config.api + "api/onboarding");
        }

        function banktransfer() {
            return $resource(config.api + "api/payroll/banktransfer");
        }

        function payslip() {
            return $resource(config.api + "api/payroll/report/payslip");
        }

        function allowancefix() {
            return $resource(config.api + "api/payroll/allowancefix");
        }

        function deductionnonfix() {
            return $resource(config.api + "api/payroll/deductionnonfix");
        }

        function deductionfix() {
            return $resource(config.api + "api/payroll/deductionfix");
        }

        function cartransaction() {
            return $resource(config.api + "api/payroll/cartransaction");
        }

        function carrate() {
            return $resource(config.api + "api/payroll/carrate");
        }

        function gajicostcentre() {
            return $resource(config.api + "api/payroll/report/gajicostcentre");
        }

        function News() {
            return $resource(config.api + "api/hcnews");
        }

        function notification() {
            return $resource(config.api + "api/notification");
        }

        function AdminDepartment() {
            return $resource(config.api + "api/admindepartment");
        }

        function GhkGw() {
            return $resource(config.api + "api/ghkgw");
        }

        function ChecklistAttendanceGw() {
            return $resource(config.api + "api/checklistattendancegw");
        }

        function ChecklistAttendanceGwAdmin() {
            return $resource(config.api + "api/checklistattendancegwadmin");
        }

        function ApprovalGhkGw() {
            return $resource(config.api + "api/approvalghkgw");
        }

        function saldoghkGw() {
            return $resource(config.api + "api/saldoghkgw");
        }

        function Reminder() {
            return $resource(config.api + "api/reminder");
        }

        function EmployeActing() {
            return $resource(config.api + "api/employeacting");
        }

        function EmployeOvertimeGw() {
            return $resource(config.api + "api/employeovertimegw");
        }

        function ApprovalOvertimeGw() {
            return $resource(config.api + "api/approvalovertimegw");
        }

        function EmployeGhkHalfday() {
            return $resource(config.api + "api/employeghkhalfday");
        }

        function ApprovalGhkHalfday() {
            return $resource(config.api + "api/approvalghkhalfday");
        }

        function GhkHalfdayGw() {
            return $resource(config.api + "api/ghkhalfdaygw");
        }

        function ApprovalGhkHalfdayGw() {
            return $resource(config.api + "api/approvalghkhalfdaygw");
        }

        function UpdateFingerReason() {
            return $resource(config.api + "api/updatefingerreason");
        }

        function TypeShiftMatrix() {
            return $resource(config.api + "api/typeshiftmatrix");
        }

        function SubstitutionLeaveOT() {
            return $resource(config.api + "api/substitutionleaveot");
        }

        function notification() {
            return $resource(config.api + "api/notification");
        }

        function userSFA() {
            return $resource(config.api + "api/sfa");
        }

        function town() {
            return $resource(config.api + "api/town");
        }

        function ofbRefCheck() {
            return $resource(config.api + "api/ofbrefcheck");
        }

        function Orgchart() {
            return $resource(config.api + "api/orglayer");
        }

        function Orgchartemp() {
            return $resource(config.api + "api/orglayeremp");
        }

        function OfbRegistration() {
            return $resource(config.api + "api/ofb/registration");
        }

        function MppApproval() {
            return $resource(config.api + "api/mppapproval");
        }

        function MppOrgtable() {
            return $resource(config.api + "api/mpporgtable");
        }

        function MppMgr() {
            return $resource(config.api + "api/mppmgr");
        }

        function EmpJic() {
            return $resource(config.api + "api/jic/empjic");
        }

        function MppReportCost() {
            return $resource(config.api + "api/mppreportcost/mppreportcost");
        }

        function MppReportCostBudget() {
            return $resource(
                config.api + "api/mppreportcostbudget/mppreportcostbudget"
            );
        }

        function MppReportHC() {
            return $resource(config.api + "api/mppreporthc/mppreporthc");
        }

        function MppReportCostUser() {
            return $resource(
                config.api + "api/mppreport/mppreportcostuser/mppreportcostuser"
            );
        }

        function Policy() {
            return $resource(config.api + "api/policy");
        }

        function MppReportHCUser() {
            return $resource(
                config.api + "api/mppreport/mppreporthcuser/mppreporthcuser"
            );
        }

        function Correspondence() {
            var obj = {
                administrator: $resource(
                    config.api + "api/correspondence/correspondenceadmin"
                ),
                requestor: $resource(
                    config.api + "api/correspondence/correspondencerequestor"
                ),
            };
            return obj;
        }

        function OfbApprovalGroup() {
            return $resource(config.api + "api/ofb/approvalgroup");
        }

        function Completeness() {
            return $resource(config.api + "api/completeness");
        }
        // function OfbExitInterview()
        // {
        //     return $resource(config.api + "api/ofb/exitinterview/exinadmin/");
        // }
        function OfbExitInterview(isAdmin) {
            if (isAdmin) {
                return $resource(
                    config.api + "api/ofb/exitinterview/exinadmin"
                );
            }
            return $resource(config.api + "api/ofb/exitinterview/exinuser");
        }

        function Ofbhandover() {
            return $resource(config.api + "api/ofb/handover");
        }

        //updateapi
        function laporanbpjstk() {
            return $resource(config.api + "api/payroll/laporanbpjstk");
        }

        function keluarbpjs() {
            return $resource(config.api + "api/payroll/laporanbpjstk");
        }

        function perubahanupah() {
            return $resource(config.api + "api/payroll/laporanbpjstk");
        }

        function formulirbpjs() {
            return $resource(config.api + "api/payroll/laporanbpjstk");
        }

        function pendaftaranbpjs() {
            return $resource(config.api + "api/payroll/laporanbpjstk");
        }

        function uploadfixnonfix() {
            return $resource(config.api + "api/payroll/uploadfixnonfix");
        }

        function sapreport() {
            return $resource(config.api + "api/payroll/sapreport");
        }

        function daftarmutasi() {
            return $resource(config.api + "api/payroll/laporanbpjskes");
        }

        function nonaktif() {
            return $resource(config.api + "api/payroll/laporanbpjskes");
        }

        function perubahangaji() {
            return $resource(config.api + "api/payroll/laporanbpjskes");
        }

        function closepayroll() {
            return $resource(config.api + "api/payroll/closepayroll");
        }

        function analisacostcentre() {
            return $resource(config.api + "api/payroll/analisacostcentre");
        }

        function gajicostcentre() {
            return $resource(config.api + "api/payroll/gajicostcentre");
        }
        //updateapi
        function MppReportHCCCAdmin() {
            return $resource(config.api + "api/mppreporthccc/admin");
        }

        function MppReportHCCCUser() {
            return $resource(config.api + "api/mppreporthccc/user");
        }

        function jobEvaluation() {
            return $resource(config.api + "api/jobevaluation");
        }

        function IndisciplinaryRequest() {
            return $resource(config.api + "api/indisciplinary");
        }

        function IndisciplinaryApproval() {
            return $resource(config.api + "api/indisciplinaryapproval");
        }

        function IndisciplinaryAdmin() {
            return $resource(config.api + "api/indisciplinaryadmin");
        }

        function tiket() {
            return $resource(config.api + "api/tiket/tiket/tiket");
        }

        function tiketApproval() {
            return $resource(
                config.api + "api/tiket/tiketapproval/tiketapproval"
            );
        }

        function CorrespondencePma() {
            return $resource(config.api + "api/correspondencepma");
        }

        function CorrespondencePmaApproval() {
            return $resource(config.api + "api/correspondencepmaapproval");
        }

        function Replacement() {
            return $resource(config.api + "api/replacement");
        }

        function AdminAreaIncharge() {
            return $resource(config.api + "api/areaincharge");
        }

        function EmployeeAlert() {
            return $resource(config.api + "api/employeealert");
        }

        function EmployeeAlertProcess() {
            return $resource(config.api + "api/employeealertprocess");
        }

        function WarningLetter() {
            return $resource(config.api + "api/warningletter");
        }

        function laporanthr() {
            return $resource(config.api + "api/payrollpma/report/laporanthr");
        }

        function thrprocess() {
            return $resource(config.api + "api/payrollpma/thrprocess");
        }

        function MpnGw() {
            var obj = {
                request: $resource(config.api + "api/mpngw/mpngwrequest"),
                approval: $resource(config.api + "api/mpngw/mpngwapproval"),
            };
            return obj;
        }

        function WilayahSales() {
            return $resource(config.api + "api/structurearea/wilayahsales");
        }

        function RegionalSales() {
            return $resource(config.api + "api/structurearea/regionalsales");
        }

        function CabangSales() {
            return $resource(config.api + "api/structurearea/cabangsales");
        }

        function AreaSales() {
            return $resource(config.api + "api/structurearea/areasales");
        }

        function EmpAreaSales() {
            return $resource(config.api + "api/structurearea/empareasales");
        }

        function AreaSalesStatus() {
            return $resource(config.api + "api/structurearea/areasalesstatus");
        }

        function JobCode() {
            return $resource(config.api + "api/jobcode");
        }

        function amStoreIncharge() {
            return $resource(config.api + "api/amstoreincharge");
        }

        function NewSalaryComponent() {
            return $resource(config.api + "api/payrollnew/NewSalarycomponent");
        }

        function NewPayrollProcess() {
            return $resource(config.api + "api/payrollnew/NewPayrollprocess");
        }

        function NewAbsentRate() {
            return $resource(config.api + "api/payrollnew/NewAbsentrate");
        }

        function NewGradeRate() {
            return $resource(config.api + "api/payrollnew/NewGraderate");
        }

        function NewPositionRate() {
            return $resource(config.api + "api/payrollnew/NewPositionrate");
        }

        function NewTaxParameter() {
            return $resource(config.api + "api/payrollnew/NewTaxparameter");
        }

        function NewTaxLocation() {
            return $resource(config.api + "api/payrollnew/NewTaxlocation");
        }

        function NewJamsostek() {
            return $resource(config.api + "api/payrollnew/NewJamsostek");
        }

        function NewOtParameter() {
            return $resource(config.api + "api/payrollnew/NewOtparameter");
        }

        function EncashmentLeave() {
            return $resource(config.api + "api/payrollnew/NewEncashmentLeave");
        }

        function NewProrateparameter() {
            return $resource(config.api + "api/payrollnew/NewProrateparameter");
        }

        function NewPtkp() {
            return $resource(config.api + "api/payrollnew/NewPtkp");
        }

        function NewCarRate() {
            return $resource(config.api + "api/payrollnew/NewCarrate");
        }

        function NewPayrollEmployee() {
            return $resource(config.api + "api/payrollnew/NewPayrollemployee");
        }

        function NewFixEntry() {
            return $resource(config.api + "api/payrollnew/NewFixentry");
        }

        function New13Salary() {
            return $resource(config.api + "api/payrollnew/New13thSalary");
        }

        function NewBonus() {
            return $resource(config.api + "api/payrollnew/NewBonus");
        }

        function NewGroupentry() {
            return $resource(config.api + "api/payrollnew/NewGroupentry");
        }

        function NewLaporanProsesPayroll() {
            return $resource(
                config.api + "api/payrollnew/NewLaporanprosespayroll"
            );
        }

        function NewCarTransaction() {
            return $resource(config.api + "api/payrollnew/NewCartransaction");
        }

        function NewUploadFixNonFix() {
            return $resource(config.api + "api/payrollnew/NewUploadfixnonfix");
        }

        function NewNonFixEntry() {
            return $resource(config.api + "api/payrollnew/NewNonfixentry");
        }

        function EncashmentLeaveManagement() {
            return $resource(
                config.api + "api/payrollnew/NewEncashmentLeaveManagement"
            );
        }

        function NewAllowanceFix() {
            return $resource(config.api + "api/payrollnew/NewAllowancefix");
        }

        function NewDeductionFix() {
            return $resource(config.api + "api/payrollnew/NewDeductionfix");
        }

        function NewDeductionNonFix() {
            return $resource(config.api + "api/payrollnew/NewDeductionnonfix");
        }

        function NewClosePayroll() {
            return $resource(config.api + "api/payrollnew/NewClosepayroll");
        }

        function NewThrProcess() {
            return $resource(config.api + "api/payrollnew/NewThrprocess");
        }

        function NewPublishPayslip() {
            return $resource(config.api + "api/payrollnew/NewPublishpayslip");
        }

        function NewPublishThr() {
            return $resource(config.api + "api/payrollnew/NewPublishthr");
        }

        function NewPayslip() {
            return $resource(config.api + "api/payrollnew/report/NewPayslip");
        }

        function NewLaporanGaji() {
            return $resource(
                config.api + "api/payrollnew/report/NewLaporangaji"
            );
        }

        function NewLaporanGajiDetail() {
            return $resource(
                config.api + "api/payrollnew/report/NewLaporangajidetail"
            );
        }

        function NewAnalisaCostCentre() {
            return $resource(
                config.api + "api/payrollnew/report/NewAnalisacostcentre"
            );
        }

        function NewBankTransfer() {
            return $resource(
                config.api + "api/payrollnew/report/NewBanktransfer"
            );
        }

        function NewEspttax() {
            return $resource(config.api + "api/payrollnew/report/NewEspttax");
        }

        function NewGajiCostCentre() {
            return $resource(
                config.api + "api/payrollnew/report/NewGajicostcentre"
            );
        }

        function NewDaftarMutasi() {
            return $resource(
                config.api + "api/payrollnew/report/NewLaporanbpjskes"
            );
        }

        function NewLaporanbpjstk() {
            return $resource(
                config.api + "api/payrollnew/report/NewLaporanbpjstk"
            );
        }

        function NewLaporanLembur() {
            return $resource(
                config.api + "api/payrollnew/report/NewLaporanlembur"
            );
        }

        function NewLaporanPajak() {
            return $resource(
                config.api + "api/payrollnew/report/NewLaporanpajak"
            );
        }

        function NewLaporanThr() {
            return $resource(
                config.api + "api/payrollnew/report/NewLaporanthr"
            );
        }

        function NewSAPReport() {
            return $resource(config.api + "api/payrollnew/report/NewSapreport");
        }

        function EmployeeReport() {
            return $resource(config.api + "api/employeereport/Employeereport");
        }

        function HcTicket() {
            return $resource(config.api + "api/emphcticket");
        }

        function Umutreport() {
            return $resource(config.api + "api/umutreport");
        }

        function Insentifreport() {
            return $resource(config.api + "api/insentifreport");
        }

        function AdditionalUMUT() {
            return $resource(config.api + "api/additionalumut");
        }

        function AdditionalInsentif() {
            return $resource(config.api + "api/additionalinsentif");
        }

        function Umuttransfer() {
            return $resource(config.api + "api/umuttransfer");
        }

        function Insentiftransfer() {
            return $resource(config.api + "api/insentiftransfer");
        }

        function UploadHoliday() {
            return $resource(config.api + "api/uploadholiday");
        }

        function HrCompletion() {
            return $resource(config.api + "api/hrcompletion");
        }

        function HandoverGw() {
            return $resource(config.api + "api/handovergw");
        }

        function ProductionHandoverGw() {
            return $resource(config.api + "api/productionhandovergw");
        }

        function TrainingGw() {
            return $resource(config.api + "api/traininggw");
        }

        function GwMoving() {
            return $resource(config.api + "api/gwmoving");
        }

        function ShortLeaveGw() {
            return $resource(config.api + "api/shortleavegw");
        }

        function MppStandard() {
            return $resource(config.api + "api/mppstandard");
        }

        function TimestudyStandard() {
            return $resource(config.api + "api/timestudystandard");
        }

        function EmpLinePosition() {
            return $resource(config.api + "api/emplineposition");
        }

        function ProductMachinePosition() {
            return $resource(config.api + "api/productmachineposition");
        }

        function ProductionProduct() {
            return $resource(config.api + "api/productionproducts");
        }

        function Productions() {
            return $resource(config.api + "api/productions");
        }

        function PkwtManagementIr() {
            return $resource(config.api + "api/pkwt/pkwtmanagementir");
        }

        function PkwtManagementTa() {
            return $resource(config.api + "api/pkwt/pkwtmanagementta");
        }

        function MacProductSpecification() {
            return $resource(config.api + "api/macproductspec");
        }

        function MacoutputSpecification() {
            return $resource(config.api + "api/macoutputspec");
        }

        function MachineLine() {
            return $resource(config.api + "api/machineline");
        }

        function BpjsMalaysiaEis() {
            return $resource(config.api + "api/payrollnew/NewBpjsMalaysiaEis");
        }

        function BpjsMalaysiaEpf() {
            return $resource(config.api + "api/payrollnew/NewBpjsMalaysiaEpf");
        }

        function BpjsMalaysiaSocso() {
            return $resource(
                config.api + "api/payrollnew/NewBpjsMalaysiaSocso"
            );
        }

        function TaxMalaysia() {
            return $resource(config.api + "api/payrollnew/NewTaxMalaysia");
        }

        function SyncPma() {
            return $resource(config.api + "api/syncpma");
        }

        function IndisciplinaryConfirm() {
            return $resource(config.api + "api/indisciplinaryconfirm");
        }

        function IndisciplinaryValidation() {
            return $resource(config.api + "api/indisciplinaryvalidation");
        }

        function ActivityForeman() {
            return $resource(config.api + "api/activityforeman");
        }

        function MovingLocation() {
            return $resource(config.api + "api/movinglocation");
        }

        function Approvalassignment() {
            return $resource(config.api + "api/approvalassignment");
        }

        function AreaCoverage() {
            return $resource(config.api + "api/areacoverage");
        }

        function employeeadmin() {
            return $resource(config.api + "api/employeeadmin");
        }

        function EmpSalesCode() {
            return $resource(config.api + "api/empsalescode");
        }

        function DepartmentBusiness() {
            return $resource(config.api + "api/departmentbussinesstitle");
        }

        function ApplicationAdmin() {
            return $resource(config.api + "api/applicationadmin");
        }
        function EmployeeExchange() {
            return $resource(config.api + "api/employeeexchange");
        }

        function RefBank() {
            return $resource(config.api + "api/refbank");
        }

        function EmpAdjustmentAllowance() {
            return $resource(config.api + "api/empadjustmentallowance");
        }

        function WfhFe() {
            return $resource(config.api + "api/wfhfe");
        }

        function LockSetting() {
            return $resource(config.api + "api/locksetting");
        }

        function UploadWfhUmut() {
            return $resource(config.api + "api/wfhumut");
        }

        function RefSalesType() {
            return $resource(config.api + "api/refsalestype");
        }

        function RefSalesCode() {
            return $resource(config.api + "api/refsalescode");
        }

        function WfhReport() {
            return $resource(config.api + "api/wfhreport");
        }

        function EmpAppraisal() {
            return $resource(config.api + "api/empappraisal");
        }

        function Wfhadmin() {
            return $resource(config.api + "api/wfhadmin");
        }

        function InsentifKpiSetting() {
            return $resource(config.api + "api/insentifkpisetting");
        }

        function InsentifTargetAbsolute() {
            return $resource(config.api + "api/insentiftargetabsolute");
        }

        function InsentifOverrideTargetAbsolute() {
            return $resource(config.api + "api/insentifoverridetargetabsolute");
        }

        function InsentifSkema() {
            return $resource(config.api + "api/insentifskema");
        }

        function InsentifSkemaOverride() {
            return $resource(config.api + "api/insentifskemaoverride");
        }

        function InsentifSalesTarget() {
            return $resource(config.api + "api/insentifsalestarget");
        }

        function InsentifSalesTargetContribution() {
            return $resource(
                config.api + "api/insentifsalestargetcontribution"
            );
        }

        function InsentifLph() {
            return $resource(config.api + "api/insentiflph");
        }

        function mpnResetSLT() {
            return $resource(config.api + "api/mpnresetslt");
        }

        function InsentifCalculation() {
            return $resource(config.api + "api/insentifcalculation");
        }

        function InsentifCalculationass() {
            return $resource(config.api + "api/insentifcalculationass");
        }

        function InsentifRequirementSku() {
            return $resource(config.api + "api/insentifrequirementsku");
        }

        function InsentifSkuFocus() {
            return $resource(config.api + "api/insentifskufokus");
        }

        function RefMasterSku() {
            return $resource(config.api + "api/refmastersku");
        }

        function InsentifBarcode() {
            return $resource(config.api + "api/insentifbarcode");
        }

        function InsentifBarcodeBsr() {
            return $resource(config.api + "api/insentifbarcodebsr");
        }

        function InsentifPinalty() {
            return $resource(config.api + "api/insentifpinalty");
        }

        function InsentifPinaltySp() {
            return $resource(config.api + "api/insentifpinaltysp");
        }

        function InsentifProcess() {
            return $resource(config.api + "api/insentifprocess");
        }

        function InsentifProcessass() {
            return $resource(config.api + "api/insentifprocessass");
        }

        function InsentifApproval() {
            return $resource(config.api + "api/insentifapproval");
        }

        function InsentifApprovalAss() {
            return $resource(config.api + "api/insentifapprovalass");
        }
        function InsuranceGovernment() {
            return $resource(config.api + "api/insurancegovernment");
        }

        function Mtx() {
            return $resource(config.api + "api/mtx");
        }
        function InsentifSkuFocusGeneral() {
            return $resource(config.api + "api/insentifskufokusgeneral");
        }
        function InsentifSkemaAssAdjust() {
            return $resource(config.api + "api/insentifskemaassadjust");
        }
        function InsentifAdjusmentKpi() {
            return $resource(config.api + "api/insentifadjustkpi");
        }
        function InsentifAdjustmentTargetAbsolute() {
            return $resource(config.api + "api/insentifadjustmenttargetabsolute");
        }

        function mpnMassRole() {
            return $resource(config.api + "api/mpnmassrole");
        }

        function Certificateprograms() {
            return $resource(config.api + "api/certificateprograms");
        }

        function Elearning() {
            return $resource(config.api + "api/elearning");
        }

        function Certificateclassrooms() {
            return $resource(config.api + "api/certificateclassrooms");
        }

        function Certificate() {
            return $resource(config.api + "api/certificate");
        }

        function Approvalcertificate() {
            return $resource(config.api + "api/approvalcertificate");
        }
        function Insentifmonitoring() {
            return $resource(config.api + "api/insentifmonitoring");
        }

        function Insentifmonitoringlph() {
            return $resource(config.api + "api/insentifmonitoringlph");
        }

        function RefSubdis() {
            return $resource(config.api + "api/refsubdis");
        }

        function EmpSubdis() {
            return $resource(config.api + "api/empsubdis");
        }

        function HkeAreaSubdis() {
            return $resource(config.api + "api/hkeareasubdis");
        }

        function EmpHkeAreaSubdis() {
            return $resource(config.api + "api/hkeemployeesubdis");
        }
        function MyMpp() {
            return $resource(config.api + "api/mympp");
        }
        function InsentifUploadMasterCb() {
            return $resource(config.api + "api/insentifuploadmastercb");
        }

        function businessTravel() {
            var current_url = config.api + 'api/businesstravel';
            return $resource(current_url, null, {
                'createbusinesstravel': {
                    method: 'POST',
                    url: current_url + '?action=savetraveldetail'
                },
                'getemptraveldetail': {
                    method: 'POST',
                    url: current_url + '?action=viewdataitenerary'
                },
                'deletetraveldetail': {
                    method: 'POST',
                    url: current_url + '?action=deletetravdetail'
                },
                'updatebusinesstravel': {
                    method: 'POST',
                    url: current_url + '?action=updatetraveldetail'
                },
                'getemplodgelist': {
                    method: 'POST',
                    url: current_url + '?action=viewtravellodge'
                },
                'gethistory': {
                    method: 'POST',
                    url: current_url + '?action=viewhistory'
                },
                'createtravlodge': {
                    method: 'POST',
                    url: current_url + '?action=savetravlodge'
                },
                'getlodgelist': {
                    method: 'GET',
                    url: current_url + '/lodge'
                },
                'updatetravlodge': {
                    method: 'POST',
                    url: current_url + '?action=updatetravlodge'
                },
                'createtravellist': {
                    method: 'POST',
                    url: current_url + '?action=update'
                },
                'updatetravellist': {
                    method: 'POST',
                    url: current_url + '?action=update'
                },
                'getTransportationList': {
                    method: 'POST',
                    url: current_url + '?action=transportationlist'
                },
                'getTransportationType': {
                    method: 'POST',
                    url: current_url + '?action=transportationtype'
                },
                'getTransportationDetail': {
                    method: 'POST',
                    url: current_url + '?action=transportationdetail'
                },
                'getemppolicylist': {
                    method: 'GET',
                    url: current_url + '?action=viewtravelpolicy'
                },
                'createcashadvance': {
                    method: 'POST',
                    url: current_url + '?action=savecashadvance'
                },
                'createreimbursment': {
                    method: 'POST',
                    url: current_url + '?action=savereimbursment'
                },
                'createtravpolicy': {
                    method: 'POST',
                    url: current_url + '?action=savetravpolicy'
                },
                'updatetravpolicy': {
                    method: 'POST',
                    url: current_url + '?action=updatetravpolicy'
                },
                'deletetravelpolicy': {
                    method: 'POST',
                    url: current_url + '?action=deltravpolicy'
                },
                'getviewcashadvance': {
                    method: 'GET',
                    url: current_url
                },
                'getviewreimbursment': {
                    method: 'POST',
                    url: current_url + '?action=viewreimbursment'
                },
                'deletecashadvance': {
                    method: 'POST',
                    url: current_url + '?action=delcashadvance'
                },
                'deletereimbursment': {
                    method: 'POST',
                    url: current_url + '?action=deletereimbursment'
                },
                'getcostdetail': {
                    method: 'POST',
                    url: current_url + '?action=costdetail'
                },
                'travelorigin': {
                    method: 'GET',
                    url: current_url + '?action=viewregional'
                },
                'getsuperior': {
                    method: 'GET',
                    url: current_url + '?action=issuperior'
                }

            });
        }

        function viewOrgEmployee() {
            return $resource(config.api + 'api/businesstravel/request_structure');
        }

        function tp() {
            return $resource(config.api + 'api/travelplan');
        }

        function ApprovalTP() {
            var current_url = config.api + 'api/approvaltravelplan';
            return $resource(current_url, null, {
                'getemptraveldetail': {
                    method: 'POST',
                    url: current_url + '?action=viewdetail'
                },
                'getemppolicylist': {
                    method: 'GET',
                    url: current_url + '?action=viewtravelpolicy'
                },
            });
        }

        function ApprovalTA() {
            return $resource(config.api + 'api/approvaltraveladvance');
        }

        function ApprovalTR() {
            return $resource(config.api + 'api/approvaltravelreumbestment');
        }

        function HRcheckA() {
            return $resource(config.api + 'api/hrdtravelcheck');
        }

        function HRcheckL() {
            return $resource(config.api + 'api/hrdlodgecheck');
        }

        function businesstripMaster() {
            return $resource(config.api + "api/businesstravelmaster");
        }
         function tokenAuth() {
              return $resource(config.api + 'api/endpoint/auth', null, {
                login: {
                    method: 'POST',
                    withCredentials: false
                },
                refresh: {
                    method: 'POST',
                    withCredentials: false
                },
                generate: {
                    method: 'POST',
                    withCredentials: false
                }
            });
        }
    }
})();

(function() {
    "use strict";

    angular.module("app.report.mpp_hc_report", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.report.mpp-hc", {
            url: "/mpp-headcount",
            views: {
                report: {
                    templateUrl: "app/main/report/mpp/headcount/hc.html",
                    controller: "MppReportHeadCountController as vm"
                }
            },
            params: {
                obj: null
            }
        });
    }
})();

(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.perubahangaji', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_perubahangaji', {
                url    : '/new-payroll/report/perubahangaji',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/perubahangaji/perubahangaji.html',
                    controller : 'NewLaporanPerubahanGajiController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.keluarbpjs', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_keluarbpjs1b', {
                url    : '/new-payroll/report/keluarbpjs',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/keluarbpjs/keluarbpjs.html',
                    controller : 'NewLaporanKeluarBpjsController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll-new.report.formulirbpjs', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_new_formulirbpjs', {
                url    : '/new-payroll/report/formulirbpjs',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll-new/report/formulirbpjs/formulirbpjs.html',
                    controller : 'NewFormulirBpjsController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.perubahangaji', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_perubahangaji', {
                url    : '/payroll/report/perubahangaji',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/perubahangaji/perubahangaji.html',
                    controller : 'LaporanPerubahanGajiController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.keluarbpjs', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_keluarbpjs1b', {
                url    : '/payroll/report/keluarbpjs',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/keluarbpjs/keluarbpjs.html',
                    controller : 'LaporanKeluarBpjsController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function() {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
   angular.module('app.payroll.report.formulirbpjs', []).config(config);

   config.$inject=['$stateProvider'];


   function config($stateProvider) {

   	 $stateProvider
            .state('app.payroll_formulirbpjs', {
                url    : '/payroll/report/formulirbpjs',
                views  : {
                    'content@app' : {
                    templateUrl: 'app/main/payroll/report/formulirbpjs/formulirbpjs.html',
                    controller : 'FormulirBpjsController as vm'
                    }
                }
                  
            });

      // Translation
     //$translatePartialLoaderProvider.addPart('app');
   }
}());
(function () {
    'use strict';

    angular
        .module('app.jic.emp_jic.add', [])
        .config(config);

    config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        // State 
        $stateProvider
            .state('app.emp_jic_add', {
                url: '/jic/emp_jic/add',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/jic/empjic/add/empjic-add.html',
                        controller: 'EmpJicAddController as vm'
                    }
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/master-data/business-unit');

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.job_code_profile.input-job-code-profile', [
        ])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State 
        $stateProvider
            .state('app.pms_job_code_profile_input', {
                url    : '/pms/job_code_profile/input',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/job-code-profile/input-job-code-profile/input-job-code-profile.html',
                        controller : 'InputJobCodeProfileController as vm'
                    }
                }
            })
        $stateProvider
            .state('app.pms_competency_job_edit', {
                url    : '/pms/competency_job/edit-competency_job/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/competency-job/input-competency_job/input-competency_job.html',
                        controller : 'EditCompetencyJobController as vm'
                    }
                }
            })
       
        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/master-data/level');
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.papeople', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pms_papeople', {
                url    : '/pms/papeople',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pms/papeople/papeople.html',
                        controller : 'PapeopleController as vm'
                    }
                }
            });

       
        // Translation
      //  $translatePartialLoaderProvider.addPart('app/main/pms/kpi-result');
        // Navigation
  /*  msNavigationServiceProvider.saveItem('pms', {
        title : 'PMS',
        group : true,
        weight: 1,
        hidden:function(){return false;}
    });
    // Apps.Dashboards
    msNavigationServiceProvider.saveItem('pms.dashboard', {
         title    : 'Dashboard',
            icon     : 'icon-tile-four',
            state    : 'app.pms_dashboard',
            weight   : 1,
             hidden:function(){return false;}
    });
       */

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pms.ebook_view', [
        ])
        .config(config);

    config.$inject=['$translatePartialLoaderProvider','$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider,$stateProvider)
    {       

        $stateProvider
        .state('app.pms_ebook_view', {
            url    : '/pms/ebook_view/:url',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pms/ebook/ebook-view.html',
                    controller : 'EbookViewController as vm'
                }
            }
        });

        // $translatePartialLoaderProvider.addPart('app/main/pms/competency');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.mtx.transaksi', [
            'app.mtx.transaksi.mtx-assesment-setting',
            'app.mtx.transaksi.mtx-assesment',
            'app.mtx.transaksi.mtx-monitoring-score',
            'app.mtx.transaksi.mtx-assesment-list',
            'app.mtx.transaksi.mtx-assesment-list-category',
            'app.mtx.transaksi.mtx-assesment-list-monitoring',
            'app.mtx.transaksi.mtx-assesment-approval'
        ]).config(config);

    function config(msNavigationServiceProvider, menuProvider, $translatePartialLoaderProvider) {
        // Translation
        $translatePartialLoaderProvider.addPart('app');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mtx.master', [
            'app.mtx.master.mtx-ref-group',
            'app.mtx.master.mtx-main-category',
            'app.mtx.master.mtx-category',
            'app.mtx.master.mtx-main-activity',
            'app.mtx.master.mtx-activity',
            'app.mtx.master.mtx-skill-activity',
            'app.mtx.master.mtx-sub-area-has-category',
            'app.mtx.master.mtx-import-emp-assestment'
        ]).config(config);

    function config(msNavigationServiceProvider, menuProvider, $translatePartialLoaderProvider) {
        // Translation
        $translatePartialLoaderProvider.addPart('app');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mtx.dashboard', [
            'app.mtx.dashboard.mtx-dashboard'
        ]).config(config);

    function config(msNavigationServiceProvider, menuProvider, $translatePartialLoaderProvider) {
        // Translation
        $translatePartialLoaderProvider.addPart('app');
    }
})();

(function () {
    "use strict";

    angular.module("app.mpp-report-hc-cc.user", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.mpp_report_hc_cc_user", {
            url: "/mpp/report/hc-cc/user",
            views: {
                "content@app": {
                    templateUrl: "app/main/mpp-report-hc-cc/user/user.html",
                    controller: "MppReportHeadcountCCUserController as vm"
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("app.mpp.report", ["app.mpp.report.hc", "app.mpp.report.cost"]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.cb.employee-leave-balance', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_employee_leave_balance', {
                url    : '/cb/employee-leave-balance',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/employee-leave-balance/employee-leave-balance.html',
                        controller : 'EmployeeLeaveBalanceController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function ()
{
    'use strict';

    angular
        .module('app.cb.abnormal', [])
        .config(config);  

    config.$inject=['$stateProvider','$translatePartialLoaderProvider'];
    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
       
     // State
        $stateProvider
            .state('app.cb_abnormal', {
                url    : '/cb/abnormal',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cb/abnormal/abnormal.html',
                        controller : 'AbnormalController as vm'
                    }
                }
            });

       
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/cb/employe-overtime');
      
    }
})(); 
(function () {
    'use strict';

    angular
        .module('app.wfh', [
            'app.wfh.wfh-main','app.wfh.wfhadmin'
        ]);


})();

(function ()
{
    'use strict';

    angular
        .module('app.utility', [
                                'app.utility.permission',
                                'app.utility.modul',
                                'app.utility.user',
                                'app.utility.menu',
                                'app.utility.modules',
                                'app.utility.group_permission'
        ])
        .config(config);

    /** @ngInject */
   /** @ngInject */
    function config(msNavigationServiceProvider,menuProvider)
    {
        // Navigation
       //  msNavigationServiceProvider.saveItem('utility', {
       //      title : 'Utility',
       //      icon  : 'icon-cog',
       //      group : false,
       //      weight: 2,
       //      hidden:function(){return menuProvider.checkRule('155');}
       //  });

       //  msNavigationServiceProvider.saveItem('utility.permission', {
       //      title    : 'Permission',
       //      icon     : 'icon-library-books',
       //      state    : 'app.utility_permission',
       //      weight   : 1,
       //      hidden:function(){return menuProvider.checkRule('156');}
       // });
       //  msNavigationServiceProvider.saveItem('utility.modul', {
       //      title    : 'Module',
       //      icon     : 'icon-library-books',
       //      state    : 'app.utility_modul',
       //      weight   : 1,
       //      hidden:function(){return menuProvider.checkRule('157');}
       // });

       //  msNavigationServiceProvider.saveItem('utility.user', {
       //      title    : 'Users',
       //      icon     : 'icon-account-multiple',
       //      state    : 'app.utility_user',
       //      weight   : 1,
       //      hidden:function(){return menuProvider.checkRule('159');}
       // });

       //  msNavigationServiceProvider.saveItem('utility.menu', {
       //      title    : 'Menu',
       //      icon     : 'icon-account-multiple',
       //      state    : 'app.utility_menu',
       //      weight   : 1,
       //      hidden:function(){return menuProvider.checkRule('169');}
       // });

       //  msNavigationServiceProvider.saveItem('utility.modules', {
       //      title    : 'Modules',
       //      icon     : 'icon-account-multiple',
       //      state    : 'app.utility_modules',
       //      weight   : 1,
       //      hidden:function(){return menuProvider.checkRule('170');}
       // });

       //  msNavigationServiceProvider.saveItem('utility.group_permission', {
       //      title    : 'Group Permission',
       //      icon     : 'icon-account-multiple',
       //      state    : 'app.utility_group_permission',
       //      weight   : 1,
       //      hidden:function(){return menuProvider.checkRule('173');}
       // });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.shortleavegw', [
            'app.shortleavegw.shortleavegwlist'
        ])
        .config(config);

    function config(msNavigationServiceProvider, menuProvider) {

    }
})();

(function () {
  'use strict';

  angular
    .module('app.structure_area', [
      'app.structure_area.wilayah_sales',
      'app.structure_area.regional_sales',
      'app.structure_area.cabang_sales',
      'app.structure_area.area_sales',
      'app.structure_area.emp_area_sales',
      'app.structure_area.area_sales_status'
    ]);

  /** @ngInject */

})();

(function(){
	'use strict';

	angular
		.module('app.travel', [
			'app.travel.travel-list',
			'app.travel.travel-managment',
		])
		.config(config);

	function config(msNavigationServiceProvider,menuProvider,$translatePartialLoaderProvider) {
			// Translation
      $translatePartialLoaderProvider.addPart('app');
	}	

})();
(function ()
{
    'use strict';

    angular
        .module('app.tiket', [
            'app.tiket.tiket',
            'app.tiket.tiket-approval'
        ])
        .config(config);

    /** @ngInject */
    /** @ngInject */
    function config(msNavigationServiceProvider,menuProvider)
    {
       //    
    }
})();
(function() {
    'use strict';

    angular
        .module('app.ta', [
            'app.ta.passwordecheckin',
            'app.ta.echeckin-list',
            'app.ta.helpdesk',
            'app.ta.handover'
        ])
        .config(config);

    /** @ngInject */
    /** @ngInject */
    function config(msNavigationServiceProvider, menuProvider) {
        // Navigation
        //  msNavigationServiceProvider.saveItem('ta', {
        //      title : 'TA',
        //      group : true,
        //      weight: 1,
        //      hidden:function(){return menuProvider.checkRule('174');}
        //  });
        //  msNavigationServiceProvider.saveItem('ta.passwordecheckin', {
        //      title    : 'Password Echeckin',
        //      icon     : 'icon-library-books',
        //      state    : 'app.ta_passwordecheckin',
        //      weight   : 2,
        //      hidden:function(){return menuProvider.checkRule('175');}
        // });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sfa', [
            'app.sfa.sfa_user',
            'app.sfa.form_sfa_user'
        ])
        .config(config);

    /** @ngInject */
   /** @ngInject */
    function config(msNavigationServiceProvider,menuProvider)
    {
    }
})();
(function () {
	'use strict';

	angular.module('app.production-products', ['app.production-products.production']).config(config);

	/** @ngInject */
    function config($stateProvider) {}
})();
(function () {
    'use strict';

    angular
        .module('app.pms', [
            'app.pms.dashboard',
            'app.pms.kpi',
            'app.pms.kpi_team',
            'app.pms.kpi_result',
            'app.pms.kpi_nabati',
            'app.pms.mpp',
            'app.pms.password',
            'app.pms.masterkpi',
            'app.pms.kpi-scales',
            'app.pms.upload-data',
            'app.pms.reports',
            'app.pms.permissionpms',
            'app.pms.behaviour_performance',
            'app.pms.behaviour_performance_team',
            'app.pms.papeople',
            'app.pms.competency',
            'app.pms.competency_review',
            'app.pms.competency_team',
            'app.pms.job_code_profile',
            'app.pms.talent_review',
            'app.pms.emp_job_code',
            'app.pms.ebook',
            'app.pms.emp_potential',
            'app.pms.tutorial',
            'app.pms.edp',
            'app.pms.idp',
            'app.pms.cr_progress',
            'app.pms.tutorial2',
            'app.pms.employe_apraisal',
            'app.pms.talent_review_admin'
        ])
        .config(config);

    /** @ngInject */
    /** @ngInject */
    function config(msNavigationServiceProvider, menuProvider) {

        // Navigation
        //  msNavigationServiceProvider.saveItem('pms', {
        //      title : 'PMS',
        //      group : true,
        //      weight: 1,
        //      hidden:function(){return menuProvider.checkRule('151');}
        //  });

        //   msNavigationServiceProvider.saveItem('pms.dashboard', {
        //      title    : 'Dashboard',
        //      icon     : 'icon-tile-four',
        //      state    : 'app.pms_dashboard',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('150');}
        // });
        //    msNavigationServiceProvider.saveItem('pms.password', {
        //      title    : 'Set Password',
        //      icon     : 'icon-tile-four',
        //      state    : 'app.pms_password',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('157');}
        // });
        //   msNavigationServiceProvider.saveItem('pms.masterkpi', {
        //      title    : 'Master KPI',
        //      icon     : 'icon-library-books',
        //      state    : 'app.pms_masterkpi',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('132');}
        // });

        //    msNavigationServiceProvider.saveItem('pms.kpi-scales', {
        //      title    : 'KPI Scales',
        //      icon     : 'icon-library-books',
        //      state    : 'app.pms_kpi_scales',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('135');}
        // });

        //    msNavigationServiceProvider.saveItem('pms.upload-data', {
        //      title    : 'Upload Data',
        //      icon     : 'icon-box-upload',
        //      state    : 'app.pms_upload_data',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('136');}
        // });

        //     msNavigationServiceProvider.saveItem('pms.reports', {
        //      title    : 'Reports',
        //      icon     : 'icon-file-multiple',
        //      state    : '',
        //      weight   : 2,
        //       hidden:function(){
        //         return menuProvider.checkRule('143');
        //      }
        // });

        //     msNavigationServiceProvider.saveItem('pms.permissionpms', {
        //      title    : 'Permission',
        //      icon     : 'icon-file-multiple',
        //      state    : 'app.pms_permissionpms',
        //      weight   : 1,
        //       hidden:function(){
        //         return menuProvider.checkRule('162');
        //      }
        // });

        // msNavigationServiceProvider.saveItem('pms.mpp', {
        //       title    : 'Man Power PLan',
        //       icon     : 'icon-account-switch',
        //       state    : 'app.pms_mpp',
        //       weight   : 2,
        //        hidden:function(){
        //          return menuProvider.checkRule('161');
        //       }
        //  });


        //      msNavigationServiceProvider.saveItem('pms.kpi', {
        //       title    : 'kpi setting',
        //       icon     : 'icon-account-switch',
        //       state    : 'app.pms_kpi',
        //       weight   : 2,
        //        hidden:function(){
        //          return menuProvider.checkRule('162');
        //       }
        //  });
        //      msNavigationServiceProvider.saveItem('pms.kpi_team', {
        //       title    : 'KPI Team',
        //       icon     : 'icon-account-check',
        //       state    : 'app.pms_kpi_team',
        //       weight   : 2,
        //        hidden:function(){
        //          return menuProvider.checkRule('163');
        //       }
        //  });

        //       msNavigationServiceProvider.saveItem('pms.kpi_result', {
        //       title    : 'KPI Result',
        //       icon     : 'icon-account-switch',
        //       state    : 'app.pms_kpi_result',
        //       weight   : 2,
        //        hidden:function(){
        //          return menuProvider.checkRule('164');
        //       }
        //  });

        //         msNavigationServiceProvider.saveItem('pms.kpi_nabati', {
        //       title    : 'KPI Nabati Group',
        //       icon     : 'icon-account-check',
        //       state    : 'app.pms_kpi_nabati',
        //       weight   : 2,
        //        hidden:function(){
        //          return menuProvider.checkRule('165');
        //       }
        //  });


        //          msNavigationServiceProvider.saveItem('pms.behaviour_performance', {
        //       title    : 'T S T E',
        //       icon     : 'icon-library-books',
        //       state    : 'app.pms_behaviour_performance',
        //       weight   : 2,
        //        hidden:function(){
        //          return menuProvider.checkRule('166');
        //       }
        //  });

        //            msNavigationServiceProvider.saveItem('pms.papeople', {
        //       title    : 'PA Result',
        //       icon     : 'icon-account-switch',
        //       state    : 'app.pms_papeople',
        //       weight   : 3,
        //        hidden:function(){
        //          return menuProvider.checkRule('167');
        //       }
        //  });

        //            msNavigationServiceProvider.saveItem('pms.behaviour_performance_team', {
        //       title    : 'T S T E Team',
        //       icon     : 'icon-library-books',
        //       state    : 'app.pms_behaviour_performance_team',
        //       weight   : 2,
        //        hidden:function(){
        //          return menuProvider.checkRule('168');
        //       }
        //  });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-new', [
            'app.payroll-new.salarycomponent',
            'app.payroll-new.payrollprocess',
            'app.payroll-new.absentrate',
            'app.payroll-new.graderate',
            'app.payroll-new.positionrate',
            'app.payroll-new.taxparameter',
            'app.payroll-new.taxlocation',
            'app.payroll-new.jamsostek',
            'app.payroll-new.otparameter',
            'app.payroll-new.encashment-leave-paramenter',
            'app.payroll-new.encashment-leave',
            'app.payroll-new.prorateparameter',
            'app.payroll-new.ptkp',
            'app.payroll-new.carrate',
            'app.payroll-new.payrollemployee',
            'app.payroll-new.fixentry',
            'app.payroll-new.fixentry-mgr',
            'app.payroll-new.groupentry',
            'app.payroll-new.laporanprosespayroll',
            'app.payroll-new.cartransaction',
            'app.payroll-new.uploadfixnonfix',
            'app.payroll-new.uploadfixnonfix-mgr',
            'app.payroll-new.nonfixentry',
            'app.payroll-new.nonfixentry-mgr',
            'app.payroll-new.allowancefix',
            'app.payroll-new.allowancefix-mgr',
            'app.payroll-new.deductionfix',
            'app.payroll-new.deductionfix-mgr',
            'app.payroll-new.deductionnonfix-mgr',
            'app.payroll-new.deductionnonfix',
            'app.payroll-new.closepayroll',
            'app.payroll-new.thrprocess',
            'app.payroll-new.publishthr',
            'app.payroll-new.publishpayslip',
            'app.payroll-new.report.payslip',
            'app.payroll-new.report.laporangaji',
            'app.payroll-new.report.laporangajidetail',
            'app.payroll-new.report.analisacostcentre',

            'app.payroll-new.report.banktransfer',
            'app.payroll-new.report.espttax',
            'app.payroll-new.report.gajicostcentre',
            'app.payroll-new.report.daftarmutasi',
            'app.payroll-new.report.nonaktif',
            'app.payroll-new.report.laporanbpjstk',
            'app.payroll-new.report.laporanlembur',
            'app.payroll-new.report.laporanpajak',
            'app.payroll-new.report.laporanpajaka1',
            'app.payroll-new.report.laporanthr',
            'app.payroll-new.report.sapreport',
            'app.payroll-new.report.nonaktif',
            'app.payroll-new.report.perubahangaji',
            'app.payroll-new.report.keluarbpjs',
            'app.payroll-new.report.perubahanupah',
            'app.payroll-new.report.formulirbpjs',
            'app.payroll-new.report.pendaftaranbpjs',
            'app.payroll-new.report.socsoreport',
            'app.payroll-new.report.socsoreport-mgr',
            'app.payroll-new.report.epfreport',
            'app.payroll-new.report.epfreport-mgr',
            'app.payroll-new.report.eisreport',
            'app.payroll-new.report.eisreport-mgr',
            'app.payroll-new.report.pcbreport',
            'app.payroll-new.report.pcbreport-mgr',
            'app.payroll-new.bpjsmalaysiaeiscomponent',
            'app.payroll-new.bpjsmalaysiaepfcomponent',
            'app.payroll-new.bpjsmalaysiasocsocomponent',
            'app.payroll-new.taxmalaysiacomponent',
            'app.payroll-new.13salary',
            'app.payroll-new.13salary-mgr',
            'app.payroll-new.bonus',
            'app.payroll-new.report.deductionreport',
            'app.payroll-new.report.deductionreport-mgr',
            'app.payroll-new.report.allowancereport',
            'app.payroll-new.report.allowancereport-mgr',
            'app.payroll-new.report.overtimereport',
            'app.payroll-new.report.overtimereport-mgr',
            'app.payroll-new.report.bonusreport',
            'app.payroll-new.report.bonusreport-mgr',
            'app.payroll-new.report.staffreport',
            'app.payroll-new.report.staffreport-mgr',
            'app.payroll-new.report.staff-and-salary-report',
            'app.payroll-new.report.staff-and-salary-report-mgr',
            'app.payroll-new.report.costcentresummaryreport',
            'app.payroll-new.report.costcentresummaryreport-mgr',
            'app.payroll-new.report.individualsummaryreport',
            'app.payroll-new.report.individualsummaryreport-mgr',
            'app.payroll-new.bonus-mgr'
        ])
        .config(config);

    /** @ngInject */
    /** @ngInject */
    function config(msNavigationServiceProvider, menuProvider, $translatePartialLoaderProvider) {
        // Translation
        $translatePartialLoaderProvider.addPart('app');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll-pma', [
            'app.payroll-pma.payrollprocess',
            'app.payroll-pma.thrprocess',
            'app.payroll-pma.report.laporangaji',
            'app.payroll-pma.report.laporangajidetail',
            'app.payroll-pma.report.banktransfer',
            'app.payroll-pma.report.banktransferthr',
            'app.payroll-pma.report.laporanthr',
            'app.payroll-pma.report.jurnalgaji',
            'app.payroll-pma.report.rekapgaji',
            'app.payroll-pma.report.reportcost',
            'app.payroll-pma.report.reportcostarea',
            'app.payroll-pma.report.estimasigaji',
            'app.payroll-pma.report.reportcostmgr',
            'app.payroll-pma.report.reportcostnonmgr',
        ])
        .config(config);

    /** @ngInject */
    /** @ngInject */
    function config(msNavigationServiceProvider, menuProvider, $translatePartialLoaderProvider) {

        // Translation
        $translatePartialLoaderProvider.addPart('app');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.payroll', [
            'app.payroll.salarycomponent',
            'app.payroll.payrollemployee',
            'app.payroll.ptkp',
            'app.payroll.taxparameter',
            'app.payroll.jamsostek',
            'app.payroll.syncemployee',
            'app.payroll.employeegroup',
            //'app.payroll.cutoffparameter',
            'app.payroll.absentrate',
            'app.payroll.shiftrate',
            'app.payroll.positionrate',
            'app.payroll.taxlocation',
            'app.payroll.prorateparameter',
            'app.payroll.otparameter',
            'app.payroll.fixentry',
            'app.payroll.groupentry',
            //'app.payroll.nonfixentry',
            'app.payroll.allowancefix',
            'app.payroll.nonfixentry',
            'app.payroll.deductionnonfix',
            'app.payroll.payrollprocess',
            'app.payroll.graderate',
            'app.payroll.laporanprosespayroll',
            'app.payroll.report.laporangaji',
            'app.payroll.report.laporanpajak',
            'app.payroll.report.laporanpajaka1',
            'app.payroll.report.laporanlembur',
            'app.payroll.report.espttax',
            'app.payroll.report.banktransfer',
            'app.payroll.report.payslip',
            'app.payroll.deductionfix',
            'app.payroll.carrate',
            'app.payroll.cartransaction',
            'app.payroll.uploadfixnonfix',
            'app.payroll.report.laporanbpjstk',
            'app.payroll.report.keluarbpjs',
            'app.payroll.report.perubahanupah',
            'app.payroll.report.formulirbpjs',
            'app.payroll.report.pendaftaranbpjs',
            'app.payroll.report.sapreport',
            'app.payroll.report.daftarmutasi',
            'app.payroll.report.nonaktif',
            'app.payroll.report.perubahangaji',
            'app.payroll.closepayroll',
            'app.payroll.report.analisacostcentre', 
            'app.payroll.report.gajicostcentre', 
            'app.payroll.sync_pma',
            'app.payroll.attendance_sync' 
        ])
        .config(config);

    /** @ngInject */
    /** @ngInject */
    function config(msNavigationServiceProvider, menuProvider, $translatePartialLoaderProvider) {
        // Navigation
        //  msNavigationServiceProvider.saveItem('master-data', {
        //      title : 'Master Data',
        //      icon :'icon-window-open',
        //      group : false,
        //      weight: 1,
        //      hidden:function(){return menuProvider.checkRule('153');}
        //  });

        //  msNavigationServiceProvider.saveItem('master-data.business-unit', {
        //   title    : 'Business Unit',
        //      state    : 'app.masterdata_business_unit',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('133');}
        // });

        //   msNavigationServiceProvider.saveItem('master-data.division', {
        //   title    : 'Division',
        //      state    : 'app.masterdata_division',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('134');}
        // });

        //     msNavigationServiceProvider.saveItem('master-data.department', {
        //   title    : 'Department',
        //      state    : 'app.masterdata_department',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('137');}
        // });

        //       msNavigationServiceProvider.saveItem('master-data.level', {
        //   title    : 'Level',
        //      state    : 'app.masterdata_level',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('138');}
        // });

        //         msNavigationServiceProvider.saveItem('master-data.job-title', {
        //   title    : 'Job Title',
        //      state    : 'app.masterdata_jobtitle',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('139');}
        // });

        //           msNavigationServiceProvider.saveItem('master-data.jfm', {
        //   title    : 'JFM',
        //      state    : 'app.masterdata_jfm',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('140');}
        // });

        // Translation
        $translatePartialLoaderProvider.addPart('app');

    }
})();
(function(){
	'use strict';

	angular
		.module('app.onboarding', [
			'app.onboarding.dashboard',
			'app.onboarding.firstday',
			'app.onboarding.orientation',
			'app.onboarding.orientation.detail',
			'app.onboarding.ojt',
			'app.onboarding.ojt.discussion',
			'app.onboarding.summary',
			'app.onboarding.review',
			'app.onboarding.upload.resource',
			'app.onboarding.user.register',
			'app.onboarding.resource.category',
			'app.onboarding.discussion.approval',
			'app.onboarding.tutorial',
			'app.onboarding.feedback'
		])
		.config(config);

	function config(msNavigationServiceProvider,menuProvider,$translatePartialLoaderProvider) {
			// Translation
      $translatePartialLoaderProvider.addPart('app');
	}	

})();
(function ()
{
    'use strict';

    angular
        .module('app.offboarding', [
            'app.offboarding.ofb_reff_checklist',
            'app.offboarding.ofb_registration_list',
            'app.offboarding.ofb_approval_group',
            'app.offboarding.ofb_approval_exit_clearance',
            'app.offboarding.ofb_varklaring',
            'app.offboarding.ofb_exit_interview_user',
            'app.offboarding.ofb_exit_interview_admin',
            'app.offboarding.ofb_handover'
        ])
        .config(config);

   /** @ngInject */
    function config(msNavigationServiceProvider,menuProvider)
    {
    }
})();

(function () {
    'use strict';


    angular
        .module('app.mtx', [
            'app.mtx.master',
            'app.mtx.transaksi',
            'app.mtx.dashboard',
            'ui.tinymce'
        ])
        .config(config);

    function config(msNavigationServiceProvider, menuProvider, $translatePartialLoaderProvider) {
        // Translation
        $translatePartialLoaderProvider.addPart('app');
    }
})();

(function () {
    "use strict";

    angular.module("app.mpp-report-hc-cc", [
        'app.mpp-report-hc-cc.admin',
        'app.mpp-report-hc-cc.user'
    ]);
})();

(function () {
    'use strict';

    angular.module('app.mpn-gw', ['app.mpn-gw.request', 'app.mpn-gw.approval', 'app.mpn-gw.ta', 'app.mpn-gw.dashboard', 'app.mpn-gw.other-business-title', 'app.mpn-gw.mass-role']).config(config);

    /** @ngInject */
    function config($stateProvider) { }
})();

(function() {
    'use strict';

    angular
        .module('app.mpn', [
            'ui.tinymce',
            'angular.filter',
            'app.mpn.request',
            'app.mpn.approval',
            'app.mpn.admin',
            'app.mpn.adminpms',
            'app.mpn.tutorial'
        ])
        .config(config);

    /** @ngInject */
    /** @ngInject */
    function config(
        msNavigationServiceProvider,
        menuProvider,
        $translatePartialLoaderProvider
    ) {
        // Translation
        $translatePartialLoaderProvider.addPart('app');
    }

    angular.module('app.mpn').service('MPNService', function() {
        var data = {};
        this.save = function(data) {
            this.data = data;
        };

        this.getData = function() {
            return this.data;
        };
    });

    angular.module('app.mpn').filter('range', function() {
        return function(input, total) {
            total = parseInt(total);
            for (var i = 0; i < total; i++) input.push(i);
            return input;
        };
    });

    function printDirective() {
        var printSection = document.getElementById('printSection');

        // if there is no printing section, create one
        if (!printSection) {
            printSection = document.createElement('div');
            printSection.id = 'printSection';
            //document.body.appendChild(printSection);
        }

        function link(scope, element, attrs) {
            element.on('click', function() {
                var elemToPrint = document.getElementById(attrs.printElementId);
                if (elemToPrint) {
                    printElement(elemToPrint);
                    window.print();
                }
            });

            window.onafterprint = function() {
                // clean the print section before adding new content
                printSection.innerHTML = '';
            };
        }

        function printElement(elem) {
            // clones the element you want to print
            var domClone = elem.cloneNode(true);
            printSection.appendChild(domClone);
        }

        return {
            link: link,
            restrict: 'A'
        };
    }

    angular.module('app.mpn').directive('ngPrint', [printDirective]);
})();

(function () {
    'use strict';

    angular
        .module('app.master-data', [
            'app.master-data.business-unit',
            'app.master-data.division',
            'app.master-data.department',
            'app.master-data.level',
            'app.master-data.job-title',
            'app.master-data.jfm',
            'app.master-data.cost-center',
            'app.master-data.borongan',
            'app.master-data.gedung',
            'app.master-data.school',
            'app.master-data.update-finger-reason',
            'app.master-data.job_code'
        ])
        .config(config);

    /** @ngInject */
    /** @ngInject */
    function config(msNavigationServiceProvider, menuProvider, $translatePartialLoaderProvider) {
        // Navigation
        //  msNavigationServiceProvider.saveItem('master-data', {
        //      title : 'Master Data',
        //      icon :'icon-window-open',
        //      group : false,
        //      weight: 1,
        //      hidden:function(){return menuProvider.checkRule('153');}
        //  });

        //  msNavigationServiceProvider.saveItem('master-data.business-unit', {
        //   title    : 'Business Unit',
        //      state    : 'app.masterdata_business_unit',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('133');}
        // });

        //   msNavigationServiceProvider.saveItem('master-data.division', {
        //   title    : 'Division',
        //      state    : 'app.masterdata_division',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('134');}
        // });

        //     msNavigationServiceProvider.saveItem('master-data.department', {
        //   title    : 'Department',
        //      state    : 'app.masterdata_department',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('137');}
        // });

        //       msNavigationServiceProvider.saveItem('master-data.level', {
        //   title    : 'Level',
        //      state    : 'app.masterdata_level',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('138');}
        // });

        //         msNavigationServiceProvider.saveItem('master-data.job-title', {
        //   title    : 'Job Title',
        //      state    : 'app.masterdata_jobtitle',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('139');}
        // });

        //           msNavigationServiceProvider.saveItem('master-data.jfm', {
        //   title    : 'JFM',
        //      state    : 'app.masterdata_jfm',
        //      weight   : 1,
        //       hidden:function(){return menuProvider.checkRule('140');}
        // });

        // Translation
        $translatePartialLoaderProvider.addPart('app');

    }
})();

(function() {
    'use strict';

    angular
        .module('app.machine', 
            [
                'app.machine.machine-line',
                'app.machine.product-specification',
                'app.machine.output-specification'
            ])
        .config(config);

    /** @ngInject */
    /** @ngInject */

    function config() {}
})();

(function () {
    'use strict';

    angular
        .module('app.jic', [
            'app.jic.emp_jic',
            'app.jic.approval'
        ]);

    /** @ngInject */
    /** @ngInject */

})();

(function () {
    'use strict';

    angular
        .module('app.insentif-monitoring', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.insentif-monitoring', {
                url: '/insentif-monitoring',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insentif-monitoring/insentif-monitoring.html',
                        controller: 'InsentifMonitoringController as vm'
                    }
                }
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.hrservices', [])
        .config(config);

    /** @ngInject */
   /** @ngInject */
    function config(msNavigationServiceProvider,menuProvider)
    {
       
       // Navigation
        // msNavigationServiceProvider.saveItem('services', {
        //     title : 'SERVICES',
        //     group : true,
        //     weight: 2,
        //     hidden:function(){return menuProvider.checkRule('176');}
        // });
        //  msNavigationServiceProvider.saveItem('services.attendance', {
        //     title : 'Attendance',
        //     icon  : 'icon-cog',
        //     group : false,
        //     weight: 2,
        //     hidden:function(){return menuProvider.checkRule('177');}
        // }); 

       //  msNavigationServiceProvider.saveItem('services.attendance.attendancelist', {
       //      title    : 'Atttendance List',
       //      icon     : 'icon-library-books',
       //      state    : 'app.attendance_attendancelist',
       //      weight   : 2,
       //      hidden:function(){return menuProvider.checkRule('178');}
       // }); 

         
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hrbp', [
            'app.hrbp.hrbp-attendance-team'
            ,'app.hrbp.hrbp-kpi-team'
            ,'app.hrbp.competency'
            ,'app.hrbp.job_code_profile'
            ,'app.hrbp.emp_job_code'
            ,'app.hrbp.kpi_nabati'
            ,'app.hrbp.performance-value'
            ,'app.hrbp.charts-pa'
            ,'app.hrbp.charts-bu'
            ,'app.hrbp.emp-leave'
        ])
        .config(config);

    /** @ngInject */
   /** @ngInject */
    function config(msNavigationServiceProvider,menuProvider)
    {
       
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hcnews', [
            'app.hcnews.hc-news-category',
            'app.hcnews.hc-news'
        ])
        .config(config);

    /** @ngInject */
   /** @ngInject */
    function config(msNavigationServiceProvider,menuProvider)
    {
       
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.gwmoving', [
            'app.gwmoving.gwlist',
            'app.gwmoving.gwrequest',
            'app.gwmoving.gwtransfer',
            'app.gwmoving.areacoverage'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, menuProvider) {


    }
})();

(function () {
    'use strict';

    angular
        .module('app.employee', [
            'app.employee.profiles',
            'app.employee.employement',
            'app.employee.employe',
            'app.employee.employe-update-approval',
            'app.employee.emplabortype',
            'app.employee.employe-update-approval',
            'app.employee.team-assignment',
            'app.employee.employee-cost-center',
            'app.employee.subarea',
            'app.employee.borongan-transaction',
            'app.employee.promotion',
            'app.employee.town',
            'app.employee.download-employee',
            'app.employee.uploadgedung',
            'app.employee.hr_completion',
            'app.employee.employe-uniform',
            'app.employee.employee-reports',
            'app.employee.employe_admin'
        ]);

    /** @ngInject */
    /** @ngInject */

})();

(function () {
    'use strict';

    angular
        .module('app.emp-sales-code', [])
        .config(config);

    config.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /** @ngInject */
    function config($translatePartialLoaderProvider, $stateProvider) {
        $stateProvider
            .state('app.emp-sales-code', {
                url: '/emp-sales-code',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/emp-sales-code/emp-sales-code.html',
                        controller: 'EmpSalesCodeController as vm'
                    }
                }
            });
    }
})();

(function () {
  "use strict";
  /**
   *  Module
   *
   * Description
   */
  angular.module('app.emp-appraisal', []).config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.emp-appraisal', {
        url: '/emp-appraisal',
        views: {
          'content@app': {
            templateUrl: 'app/main/emp-appraisal/emp-appraisal.html',
            controller: 'EmpAppraisalController as vm'
          }
        }
      });
  }
}());
(function () {
  'use strict';

  angular.module('app.elearning', ['app.elearning.practicalearning']).config(config);

  /** @ngInject */
  function config($stateProvider) { }
})();
(function ()
{
    'use strict';
 
    angular
        .module('app.development', [
             'app.development.download'

        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider,menuProvider)
    {
       
      
    }
})();
(function () {
    "use strict";

    angular
        .module("app.correspondence", [
            "app.correspondence.administrator",
            "app.correspondence.requestor",
            "app.correspondence.requirement",
            "app.correspondence.decision_letter",
            "app.correspondence.assignment_letter"
        ]).config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state("app.correspondence", {
            url: "/correspondence",
            views: {
                "content@app": {}
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.cb', ['app.cb.administrator' 
            , 'app.cb.attendancelist'
            , 'app.cb.uploadslip'
            , 'app.cb.overtime'
            , 'app.cb.attendance'
            , 'app.cb.attendance_employe'
            , 'app.cb.employe-overtime'
            , 'app.cb.employe-absence'
            , 'app.cb.approval-ot'
            , 'app.cb.approval-absence'
            , 'app.cb.emp-ghk'
            , 'app.cb.approval-ghk'
            , 'app.cb.shiftlocation'
            , 'app.cb.employe-shift'
            , 'app.cb.employe-break-finger'
            , 'app.cb.changeshift-approval'
            , 'app.cb.abnormal-approval'
            , 'app.cb.passwordecheckingw'
            , 'app.cb.saldo-ghk'
            , 'app.cb.list-overtime'
            , 'app.cb.attendance-team'
            , 'app.cb.business-trip'
            , 'app.cb.update-finger-approval'
            , 'app.cb.abnormal'
            , 'app.cb.changeshift'
            , 'app.cb.update-finger'
            , 'app.cb.leave-report'
            , 'app.cb.emp-join-holiday'
            , 'app.cb.shift-ghk-report'
            , 'app.cb.abnormal-report'
            , 'app.cb.attendance-report'
            , 'app.cb.halfday-report'
            , 'app.cb.truant'
            , 'app.cb.employe-shift-template'
            , 'app.cb.upload-annual-leave'
            , 'app.cb.leave-balance'
            , 'app.cb.employee-leave-balance'
            , 'app.cb.approval-absence-hr'
            , 'app.cb.employe-shift-unschedule'
            , 'app.cb.employe-outlet-ot'
            , 'app.cb.sic-leave-approval'
            , 'app.cb.sic-abnormal-approval'
            , 'app.cb.sic-update-finger-approval'
            , 'app.cb.sic-changeshift-approval'
            , 'app.cb.sic-approval-ghk'
            , 'app.cb.am-leave-approval'
            , 'app.cb.am-approval-ot'
            , 'app.cb.am-abnormal-approval'
            , 'app.cb.am-update-finger-approval'
            , 'app.cb.am-changeshift-approval'
            , 'app.cb.am-approval-ghk'
            , 'app.cb.download-attendance'
            , 'app.cb.download-attendance-pma'
            , 'app.cb.emp-ghk-holiday'
            , 'app.cb.approval-ghk-holiday'
            , 'app.cb.itinerary'
            , 'app.cb.am-sic-mapping'
            , 'app.cb.am-sic-mapping-approval'
            , 'app.cb.hr-sic-mapping-approval'
            , 'app.cb.sic-outlet-team'
            , 'app.cb.am-outlet-mapping-approval'
            , 'app.cb.hr-crew-mapping-approval'
            , 'app.cb.sic-outlet-mapping'
            , 'app.cb.am-sic-team'
            , 'app.cb.lock-transaction'
            , 'app.cb.store-incharge'
            , 'app.cb.nationalholiday'
            , 'app.cb.leavehold'
            , 'app.cb.joinholiday'
            , 'app.cb.commit-attendance'
            , 'app.cb.overtime-configuration'
            , 'app.cb.cutoffperiode'
            , 'app.cb.upload-finger'
            , 'app.cb.outlet-team-list'
            , 'app.cb.sic-team-mapping'
            , 'app.cb.view-outlet-team'
            , 'app.cb.ghk-holiday-gw'
            , 'app.cb.approval-ghk-holiday-gw'
            , 'app.cb.area-manager'
            , 'app.cb.type-shift-matrix'
            , 'app.cb.substitution-leave-ot'
            , 'app.cb.annual-leave-rules'
            , 'app.cb.employe-acting'
            , 'app.cb.admin-department'
            , 'app.cb.ghk-gw'
            , 'app.cb.checklist-attendance-gw'
            , 'app.cb.checklist-attendance-gw-admin'
            , 'app.cb.saldo-ghk-gw'
            , 'app.cb.approval-ghk-gw'
            , 'app.cb.employe-overtime-gw'
            , 'app.cb.approval-overtime-gw'
            , 'app.cb.emp-ghk-halfday'
            , 'app.cb.approval-ghk-halfday'
            , 'app.cb.ghk-halfday-gw'
            , 'app.cb.approval-ghk-halfday-gw'
            , 'app.cb.hr-update-finger-approval'
            , 'app.cb.upload-attendance'
            , 'app.cb.employe-shift-migrate'
            , 'app.cb.am-team-assignment'
            , 'app.cb.admin-area-incharge'
            , 'app.cb.employee-alert'
            , 'app.cb.warning-letter'
            , 'app.cb.am-store-incharge'
            , 'app.uploadholiday'
            , 'app.cb.team-assignment-approval'
            , 'app.cb.hr-team-assignment-approval'
            , 'app.cb.upload-ghk-abnormal'
            , 'app.cb.new-replacement-holiday'
            , 'app.cb.attendance-outlet-team'
            , 'app.cb.mapping-mpp-setting'
            , 'app.cb.employee-certificates'
            , 'app.cb.approval-employee-certificates'
        ]) 
        .config(config);

    /** @ngInject */
    /** @ngInject */

    function config() { }
})();

(function ()
{
    'use strict';
 
    angular
        .module('app.behivor', ['app.behivor.config','app.behivor.ref','app.behivor.input'])
        .config(config);

    /** @ngInject */
   /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider,menuProvider)
    {
        // Navigation
       //  msNavigationServiceProvider.saveItem('behivor', {
       //      title : 'Behaviour Performance',
       //      icon :'icon-cog', 
       //      group : false,
       //      weight: 1,
       //      hidden:function(){return menuProvider.checkRule('170');}
       //  });

       //  msNavigationServiceProvider.saveItem('behivor.config', {
       //      title    : 'Config',
       //      icon     : 'icon-library-books',
       //      state    : 'app.behivor_config',
       //      weight   : 1,
       //      hidden:function(){return menuProvider.checkRule('171');}
       // });
      
       //  msNavigationServiceProvider.saveItem('behivor.ref', {
       //      title    : 'Reference',
       //      icon     : 'icon-library-books',
       //      state    : 'app.behivor_ref',
       //      weight   : 1,
       //      hidden:function(){return menuProvider.checkRule('172');}
       // });
      
       //  msNavigationServiceProvider.saveItem('behivor.input', {
       //      title    : 'Input',
       //      icon     : 'icon-library-books',
       //      state    : 'app.behivor_input',
       //      weight   : 1,
       //      hidden:function(){return menuProvider.checkRule('173');}
       // });
      
    } 
})();
angular.module("aiko").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.NEWS\">NEWS</span> <span class=\"md-deep-orange-500-bg unread-message-count\" \nstyle=\"position: absolute;\n                right: 30px;\n                bottom: 14px;\n                width: 20px;\n                height: 20px;\n                z-index: 10;\n                border-radius: 50%;\n                text-align: center;\n                line-height: 18px;\n                font-size: 10px;\n                padding-top: 1px\" \nng-if=\"vm.unReadNews.getInfoNews.count>0\">{{vm.unReadNews.getInfoNews.count}}</span></md-tab-label><md-tab-body>\n<md-content class=\"news-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/news/news-tab.html\'\" \nng-controller=\"QuickPanelController as vm\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/toolbar/view-contract-alert.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>List employee finish contract</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>\nFilter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nng-disabled=\"vm.budisabled\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" \nng-disabled=\"vm.divdeptdisabled\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div\n ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" \nng-disabled=\"vm.divdeptdisabled\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Sub Area</label><md-select \nng-model=\"vm.subarea\" name=\"subarea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.subarea_id}}\" \nng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.flagApp\" name=\"flagApp\"><md-option \nng-repeat=\"ls in vm.flagAppList\" placeholder=\"Flag App\" value=\"{{ls}}\">{{ls}}</md-option></md-select><div \nng-messages=\"frmEmploye.flagApp.$error\" role=\"alert\"><div ng-message=\"required\"><span>flagApp field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-button class=\"md-mini md-raised md-primary\" \ntype=\"submit\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search\n</span></md-button></md-input-container><md-input-container flex><md-button type=\"button\" \nng-click=\"vm.ExporttoExcel(frmEmploye)\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\"><i \nclass=\"icon icon-file-excel\"></i> Download</md-button></md-input-container></div></form></div></div></md-content><div \nlayout=\"column\"><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table>\n<thead><tr><th class=\"text-center\">No</th><th class=\"text-center\">NIK</th><th class=\"text-center\">Name</th><th \nclass=\"text-center\">Start Contract</th><th class=\"text-center\">End Contract</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listData\" ng-dblclick=\"vm.checkProfiles(ls)\" \nng-class=\"ls.end_date < vm.today ? \'md-yellow-100-bg\' : \'\'\"><td class=\"text-center\">{{$index+1}}</td><td \nclass=\"text-center\">{{ls.nik}}</td><td>{{ls.name}}</td><td class=\"text-center\"><span>{{ls.join_date}}</span></td><td \nclass=\"text-center\"><span>{{ls.end_date}}</span></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"></md-dialog-actions></md-dialog>");
$templateCache.put("app/toolbar/view-manufacture.html","<md-dialog id=\"alert-dialog\" flex=\"50\" aria-label=\"dialog\"><form ng-cloak><md-toolbar ng-class=\"vm.data.modal_class\">\n<div class=\"md-toolbar-tools\"><h2>Absence Detail</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"50\" md-mode=\"indeterminate\"></md-progress-circular><div \nstyle=\"margin: 2em\">Please Wait</div></div><div layout=\"column\" ng-show=\"!vm.isLoading\"><div flex layout=\"column\" \nclass=\"simple-table-container md-whiteframe-2dp\"><table id=\"table-absence\" class=\"simple\" ms-responsive-table><thead>\n<tr><th class=\"text-left\">No</th><th>Absence Date</th><th class=\"text-left\">Absence Type</th></tr></thead><tbody><tr \nng-if=\"vm.status != 4\" ng-repeat=\"item in vm.listAbsence\"><td>{{$index + 1}}</td><td class=\"text-center\">\n{{item.absence_date}}</td><td class=\"text-left\">{{item.absence_type}}</td></tr><tr \nng-if=\"vm.listAbsence.length === 0 || vm.status == 4\"><td class=\"text-center\" colspan=\"4\">List Absence Clear</td></tr>\n</tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.hide()\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex \nclass=\"md-warn-bg show-gt-sm hide-gt-sm\"></div></div><div id=\"content-container\" flex layout=\"column\"><md-content \nid=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\" \nmd-theme=\"left-sidenav-theme\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up\" ms-scroll ui-view=\"content\" flex layout-fill></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\" \nmd-theme=\"pacific-blue\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/aiko/pagination/pagination.tpl.html","<ul class=\"pagination\" ng-if=\"1 < pages.length || !autoHide\"><li ng-if=\"boundaryLinks\" \nng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(1)\">&laquo;</a></li><li \nng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" \nng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></li><li \nng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" \nng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a href=\"\" \nng-click=\"setCurrent(pageNumber)\">{{ pageNumber }}</a></li><li ng-if=\"directionLinks\" \nng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" \nng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></li><li ng-if=\"boundaryLinks\" \nng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.last)\">\n&raquo;</a></li></ul>");
$templateCache.put("app/main/additional-insentif-approval/additional-insentif-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"UMUT.MENU.INSENTIFAPPROVAL\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formGHK\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span></div><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><md-select \nng-model=\"vm.type\" name=\"type\" required ng-change=\"vm.loadData(1)\"><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}\n</md-option></md-select><div ng-messages=\"formGHK.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nType field is required.</span></div></div></md-input-container><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"formGHK.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"formGHK.subperiod.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"formGHK.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><i class=\"icon icon-search\"></i> Search</md-button></form></div>\n</div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nng-if=\"vm.type==\'waiting approval\'\" width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><i class=\"icon-delete\"></i> <span>Reject</span></md-button>\n</md-menu-item></md-menu-content><md-menu-content ng-if=\"vm.type==\'approved\'\" width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.unapproveAll($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Un-Approve\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=\"vm.type==\'approved\'\" \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.unapproveAll($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nUn-Approve</md-tooltip><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\"></span></md-button><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.approveOT($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Approve</md-tooltip><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.APPROVE\">Aprove</span></md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Reject</md-tooltip><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.REJECT\">Reject</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\"><span \nng-if=\"vm.type ==\'waiting approval\' || vm.type ==\'approved\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NAME\"></span></span></th><th class=\"\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.JOBTITLE\"></span></span></th><th class=\"\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PERIOD\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.INSENTIF\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UPLOADEDBY\"></span></span></th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.STATUS\">\nApproval Status</th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==\'0\' || ls.approval==\'1\'\"><input \ntype=\"checkbox\" checklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td class=\"text-center\">\n{{($index + 1)}}</td><td class=\"\">{{ls.nik}}/{{ls.nama}}</td><td class=\"\">{{ls.job_title}}</td><td class=\"\">\n{{ls.sub_area}}</td><td class=\"text-center\">{{ls.period}}</td><td class=\"text-center\">{{ls.insentif | currency:\"\"}}\n</td><td class=\"text-center\"><span>{{ls.created_by}}/{{ls.created_name}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.approval!==\'2\'\">{{ls.status}}</span> <span ng-if=\"ls.approval==\'2\'\"><a href=\"\" \nng-click=\"vm.viewComment($event,ls)\">{{ls.status}}</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span>\n</td><td class=\"text-center\"><md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-if=\"ls.approval==\'1\'\"><md-button ng-click=\"vm.UnApproved($event,ls)\" \naria-label=\"Flip widget\"><span translate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\">Unapprove</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"ls.approval==\'2\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" \naria-label=\"Flip widget\"><span translate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNREJECT\">Unreject</span></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td \ncolspan=\"13\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/additional-insentif-approval/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.rejected_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span><md-button \nng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/additional-umut-approval/additional-umut-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"UMUT.MENU.UMUTAPPROVAL\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.loadData(1)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" \nrequired ng-change=\"vm.loadData(1)\"><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}\n</md-option></md-select><div ng-messages=\"formGHK.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nType field is required.</span></div></div></md-input-container><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tgl\" \nplaceholder=\"Date\" name=\"tgl\"></md-datepicker></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-search\"></i> Search</md-button></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nng-if=\"vm.type==\'waiting approval\'\" width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><i class=\"icon-delete\"></i> <span>Reject</span></md-button>\n</md-menu-item></md-menu-content><md-menu-content ng-if=\"vm.type==\'approved\'\" width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.unapproveAll($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Un-Approve\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=\"vm.type==\'approved\'\" \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.unapproveAll($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nUn-Approve</md-tooltip><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\"></span></md-button><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.approveOT($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Approve</md-tooltip><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.APPROVE\">Aprove</span></md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Reject</md-tooltip><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.REJECT\">Reject</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\"><span \nng-if=\"vm.type ==\'waiting approval\' || vm.type ==\'approved\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NAME\"></span></span></th><th class=\"\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.JOBTITLE\"></span></span></th><th class=\"\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.DATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UMM\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.BBM2LT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.SEWAMOTOR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PAKETLEMBUR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PAKETLUARKOTA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.KOMISI\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UPLOADEDBY\"></span></span></th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.STATUS\">\nApproval Status</th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==\'0\' || ls.approval==\'1\'\"><input \ntype=\"checkbox\" checklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td class=\"text-center\">\n{{($index + 1)}}</td><td class=\"\">{{ls.nik}}/{{ls.nama}}</td><td class=\"\">{{ls.job_title}}</td><td class=\"\">\n{{ls.sub_area}}</td><td class=\"\">{{ls.tanggal}}</td><td class=\"\">{{ls.umm | currency:\"\"}}</td><td class=\"text-center\">\n{{ls.bbm2lt | currency:\"\"}}</td><td class=\"text-center\">{{ls.sewa_motor | currency:\"\"}}</td><td class=\"text-center\">\n<span>{{ls.paket_lembur | currency:\"\"}}</span></td><td class=\"text-center\"><span>{{ls.paket_luar_kota | currency:\"\"}}\n</span></td><td class=\"text-center\"><span>{{ls.komisi | currency:\"\"}}</span></td><td class=\"text-center\"><span>\n{{ls.created_by}}/{{ls.created_name}}</span></td><td class=\"text-center\"><span ng-if=\"ls.approval!==\'2\'\">{{ls.status}}\n</span> <span ng-if=\"ls.approval==\'2\'\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\">{{ls.status}}</a><md-tooltip \nmd-direction=\"top\">View Comment</md-tooltip></span></td><td class=\"text-center\"><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.approval==\'1\'\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==\'2\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"15\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/additional-umut-approval/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.rejected_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span><md-button \nng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/assessment/assessment.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Assessment</md-subheader><div class=\"white-bg\"><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Business Unit</label><md-select \nng-disabled=\"vm.group === \'110\' || vm.group === \'116\'\" ng-change=\"vm.loadDataDivision(vm.bu)\" ng-model=\"vm.bu\">\n<md-option ng-value=\"\">All</md-option><md-option ng-repeat=\"bu in vm.listBu\" ng-value=\"bu.id\">{{bu.description}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Division</label>\n<md-select ng-change=\"vm.loadDataDepartment(vm.divisi)\" ng-model=\"vm.divisi\"><md-option ng-value=\"\">All</md-option>\n<md-option ng-repeat=\"divisi in vm.listDivisi\" ng-value=\"{{divisi.id}}\">{{divisi.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Department</label><md-select \nng-change=\"vm.loadData(1)\" ng-model=\"vm.department\"><md-option ng-value=\"\">All</md-option><md-option \nng-repeat=\"department  in vm.listDepartment\" ng-value=\"{{department.id}}\">{{department.description}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex><input id=\"formSearch\" name=\"searchParam\" \nng-model=\"vm.DataTable.searchParam\" placeholder=\"Search..\" type=\"text\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EMP_JOB_CODE.TABLEEMP_JOB_CODE.HEADER.NO\">No</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"EMP_JOB_CODE.TABLEEMP_JOB_CODE.HEADER.NIK\">NIK</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">EMPLOYEE NAME</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">DATE JOIN</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">#</span></div>\n</th></tr></thead><tbody><tr ng-dblclick=\"vm.editData(ls.id)\" ng-repeat=\"ls in vm.DataTable.list\"><td \nclass=\"text-center\">{{ $index + 1 }}</td><td class=\"text-center\">{{ ls.nik }}</td><td class=\"text-center\">\n{{ ls.title + \'. \' + ls.firstName + \' \' + ls.lastName | uppercase }}</td><td class=\"text-center\">{{ ls.dateJoin }}</td>\n<td><md-button aria-label=\"View Surveys\" class=\"md-icon-button\" ng-click=\"vm.setView(ls.nik)\" \nstyle=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip>\n<span>View Surveys</span></md-tooltip></md-button></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li class=\"{{nav.class}}\" ng-class=\"{disabled:(nav.disabled===1)}\" \nng-repeat=\"nav in vm.DataTable.listNav\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav>\n</div></md-content></div></div></div></md-content></div>");
$templateCache.put("app/main/application-admin/application-admin-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.ADMINCONFIG\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label><span \ntranslate=\"KPI.LABEL.ADMINTYPE\"></span></label><md-select ng-model=\"vm.Form.objForm.admin_type\" name=\"admin_type\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.setIsDisabled(vm.Form.objForm.admin_type)\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"admin_type\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAdminType | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.admin_type.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ADMINTYPE\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.Form.objForm.country\" \nname=\"country\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCountry | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.country.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"PAYROLL.MENU.COUNTRY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label><span translate=\"KPI.LABEL.COMPANY\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.loadArea(vm.Form.objForm.company)\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"company\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCompany | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.company.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.COMPANY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.NIK\">\n</label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nng-if=\"vm.Form.objForm.admin_type!=\'admin-department\'\" flex flex-gt-sm><label><span translate=\"KPI.LABEL.AREA\"></span>\n</label><md-select multiple=\"true\" ng-model=\"vm.Form.objForm.area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.loadGroupShift(vm.Form.objForm.area)\" ng-disabled=\"vm.isHasSelectType\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"area\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listArea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.admin_type.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.AREA\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nng-if=\"vm.Form.objForm.admin_type==\'admin-department\'\" flex flex-gt-sm><label><span translate=\"KPI.LABEL.AREA\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.loadGroupShift(vm.Form.objForm.area)\" ng-disabled=\"vm.isHasSelectType\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"area\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listArea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.admin_type.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.AREA\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label>\n<span translate=\"MACHINE.MENU.GEDUNG\"></span></label><md-select ng-model=\"vm.Form.objForm.gedung_id\" \nplaceholder=\"{{\'MACHINE.MENU.GEDUNG\' | translate}}\" ng-change=\"vm.getListSector(vm.Form.objForm.gedung_id)\" \nname=\"gedung_id\" required><md-option ng-repeat=\"ls in vm.listGedung\" value=\"{{ls.id}}\">{{ls.gedung_name}}</md-option>\n</md-select><div ng-messages=\"frmBT.gedung_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MACHINE.MENU.GEDUNG\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label><span translate=\"MACHINE.MENU.SECTOR\">\n</span></label><md-select ng-model=\"vm.Form.objForm.sector_id\" \nng-change=\"vm.isSectorStatus(vm.Form.objForm.sector_id)\" name=\"sector_id\"><md-option ng-repeat=\"ls in vm.listSector\" \nplaceholder=\"{{\'MACHINE.MENU.SECTOR\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmBT.sector_id.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MACHINE.MENU.GEDUNG\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label><span translate=\"KPI.LABEL.GROUPSHIFT\"></span></label><md-select \nng-model=\"vm.Form.objForm.group_shift\" name=\"group_shift\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header\n class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"group_shift\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listGroupShift | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.admin_type.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.GROUPSHIFT\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"KPI.LABEL.EFFECTIVEDATE\"></label><md-datepicker md-hide-icons=\"calendar\" \nmd-max-date=\"vm.Form.objForm.effective_date\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" \nng-required=\"vm.isSector\"></md-datepicker><div ng-messages=\"frmBT.effective_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/application-admin/application-admin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ADMINCONFIG\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label><span translate=\"KPI.LABEL.ADMINTYPE\"></span></label><md-select ng-model=\"vm.admin_type\" name=\"admin_type\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"admin_type\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAdminType | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.admin_type.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.ADMINTYPE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" aria-label=\"search\">\n<md-icon hide class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nng-if=\"vm.admin_type==\'admin-department\'\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr>\n<th width=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.AREA\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MACHINE.MENU.GEDUNG\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MACHINE.MENU.SECTOR\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.GROUPSHIFT\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NIK\"></span>/<span translate=\"KPI.LABEL.NAME\"></span></span></th><th \nwidth=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td \nclass=\"\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.sub_area_name}}</td><td \nclass=\"\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.gedung_name}}</td><td class=\"\">\n<md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n{{item.sector_name!=null ? item.sector_name : \'All\'}}</td><td class=\"\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.shift_group_name}}</td><td class=\"\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.nik}} / {{item.name}}</td><td class=\"text-center\"><section \nlayout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/bank-ops-transfer/bot-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.BANKOPSTRANSFERFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"UMUT.MENU.AREA\"></span></label><md-select ng-model=\"vm.Form.objForm.sub_area_id\" name=\"type\" required>\n<md-option ng-repeat=\"ls in vm.areaList\" value=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div \nng-messages=\"frmBT.sub_area_id.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"UMUT.MENU.AREA\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"UMUT.MENU.REKENING\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.rekening_number\" \nname=\"rekening_number\" required><div ng-messages=\"frmBT.rekening_number.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"UMUT.MENU.REKENING\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"TABLE.EFFECTIVE_DATE\"></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" required>\n</md-datepicker><div ng-messages=\"formInputGhk.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.EFFECTIVE_DATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"button\" ng-if=\"vm.isChecked\" class=\"md-raised md-accent\" \nng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button><md-button type=\"submit\" ng-if=\"!vm.isChecked\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/bank-ops-transfer/bot.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.BANKOPSTRANSFER\"></span></md-subheader><div class=\"white-bg\"><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" ng-click=\"vm.addDataNews(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-button></md-menu-item><md-menu-item><span><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></span></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.PROFITCENTER\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.AREA\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.REKENING\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"TABLE.EFFECTIVE_DATE\"></span></span></th><th width=\"5%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.profit_center}}</td><td class=\"\">\n{{item.area_name}}</td><td class=\"text-center\"><span>{{item.rekening_number}}</span></td><td class=\"text-center\"><span>\n{{item.effective_date}}</span></td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" \nclass=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\">\n<md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"HCTICKET.MENU.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-border-color\"></md-icon><p flex><span translate=\"HCTICKET.MENU.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/ceo-dashboard/ceo-dashboard.html","<div id=\"dashboard-project\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\nCEO Dashboard</md-subheader><div class=\"white-bg\"><div class=\"center\" flex ms-scroll><md-content \nclass=\"content white-bg\"><md-tabs md-dynamic-height><md-tab><md-tab-label><md-icon md-font-icon=\"icon-apps\" \nclass=\"icon\"></md-icon>HC Dashboard</md-tab-label><md-tab-body><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nHuman Capital Dashboard Jan-17</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap flex><div \nlayout=\"column\" flex=\"100\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \ncolspan=\"2\" style=\"border-top:none\"></th><th class=\"grey-bg white-fg\" width=\"8%\">SPOT</th><th class=\"grey-bg white-fg\" \nwidth=\"8%\">YTD</th><th class=\"grey-bg white-fg\" width=\"8%\">TARGET</th><th class=\"grey-bg white-fg\" width=\"8%\">TREND\n</th></tr></thead><tbody><tr><td class=\"green-fg\" style=\"font-weight:bold\">HR Digitation</td><td class=\"grey-fg\">\n3 Function (TA, Comben, PM) Go live</td><td style=\"text-align: center\">1</td><td style=\"text-align: center\">4</td><td \nstyle=\"text-align: center\">3</td><td style=\"text-align:center\"><md-icon class=\"green-fg\" \nmd-font-icon=\"icon-trending-up\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">\nNabati Development Center</td><td class=\"grey-fg\">2 hrs / empl (annual)</td><td style=\"text-align: center\">8%</td><td \nstyle=\"text-align: center\">41%</td><td style=\"text-align: center\">100%</td><td style=\"text-align:center\"><md-icon \nclass=\"red-fg\" md-font-icon=\"icon-trending-up\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">RTC N-1 &amp; Identified Key Position</td><td class=\"grey-fg\">100% by Q3 1:1</td><td \nstyle=\"text-align: center\">20%</td><td style=\"text-align: center\">43%</td><td style=\"text-align: center\">100%</td><td \nstyle=\"text-align:center\"><md-icon class=\"red-fg\" md-font-icon=\"icon-trending-up\" class=\"icon\"></md-icon></td></tr><tr>\n<td class=\"green-fg\" style=\"font-weight:bold\">HR Standarization Project</td><td class=\"grey-fg\">\nCorporate HR Policies by Q4 100%</td><td style=\"text-align: center\">5%</td><td style=\"text-align: center\">21%</td><td \nstyle=\"text-align: center\">100%</td><td style=\"text-align:center\"><md-icon class=\"red-fg\" \nmd-font-icon=\"icon-trending-down\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">\nEmployee Satisfaction Level to HC</td><td class=\"grey-fg\">Survey Result</td><td style=\"text-align: center\">75%</td><td \nstyle=\"text-align: center\">75%</td><td style=\"text-align: center\">70%</td><td style=\"text-align:center\"><md-icon \nclass=\"green-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">Headcount</td><td class=\"grey-fg\"></td><td style=\"text-align: center\">1,488</td><td \nstyle=\"text-align: center\">1,488</td><td style=\"text-align: center\">1,391</td><td style=\"text-align:center\"><md-icon \nclass=\"red-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nrowspan=\"2\" style=\"font-weight:bold\">Turn Over</td><td class=\"grey-fg\">Voluntary</td><td style=\"text-align: center\">5%\n</td><td style=\"text-align: center\">11.3%</td><td class=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon \nclass=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"grey-fg\">\nNon Voluntary</td><td style=\"text-align: center\">17.3%%</td><td style=\"text-align: center\">17.3%</td><td \nclass=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" \nclass=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">Gender Ratio</td><td \nclass=\"grey-fg\">% Female</td><td style=\"text-align: center\">25%</td><td style=\"text-align: center\">25%</td><td \nclass=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" \nclass=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">Span of Control</td><td \nclass=\"grey-fg\"></td><td style=\"text-align: center\">7.2</td><td style=\"text-align: center\">7.2</td><td class=\"grey-bg\">\n</td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\">\n</md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">HC Ratio</td><td class=\"grey-fg\">% Staff</td><td \nstyle=\"text-align: center\">21%</td><td style=\"text-align: center\">21%</td><td class=\"grey-bg\"></td><td \nstyle=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">WF Compensation</td><td class=\"grey-fg\">K Millon IDR</td><td \nstyle=\"text-align: center\">5300</td><td style=\"text-align: center\">5300</td><td class=\"grey-bg\"></td><td \nstyle=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">WF Normal Working Hours</td><td class=\"grey-fg\">in hour</td><td \nstyle=\"text-align: center\">246,698</td><td style=\"text-align: center\">246,698</td><td class=\"grey-bg\"></td><td \nstyle=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" rowspan=\"3\" style=\"font-weight:bold\">Overtime</td><td class=\"grey-fg\">K Million IDR</td>\n<td style=\"text-align: center\">3,180</td><td style=\"text-align: center\">3,180</td><td class=\"grey-bg\"></td><td \nstyle=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"grey-fg\">Hours</td><td style=\"text-align: center\">74,010</td><td style=\"text-align: center\">74,010\n</td><td class=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"grey-fg\">Ratio</td><td \nstyle=\"text-align: center\">30%</td><td style=\"text-align: center\">30%</td><td class=\"grey-bg\"></td><td \nstyle=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr></tbody></table></div></div></ms-widget-front></ms-widget></div></md-tab-body></md-tab><md-tab \nlabel=\"Key Performance Indicators\"><md-tab-label><md-icon md-font-icon=\"icon-chart-line\" class=\"icon\"></md-icon>\nPerformance Apraisal</md-tab-label><md-tab-body><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Apraisal Nabati Group 2016</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button aria-label=\"Flip widget\">2017</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Refresh widget\">2016</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" \nflex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataMutu\" chart-options=\"vm.optionsBadj\" id=\"chart1\"></div></div><div \nclass=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1\" \nchart-options=\"vm.optionsAadj1\" id=\"chart2\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataAdj2\" chart-options=\"vm.optionsAadj2\" id=\"chart3\"></div></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Chart By Divisi {{vm.DivisionName}} 2016</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item ng-repeat=\"oDivision in vm.listDivision\"><md-button \nng-click=\"vm.viewDataDivision(oDivision.id,oDivision.description)\" aria-label=\"{{oDivision.description}} widget\">\n{{oDivision.description}}</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div \nui-chart=\"vm.dataMutuDiv\" chart-options=\"vm.optionsBadjDiv\" id=\"chart4\"></div></div><div class=\"p-16\" layout=\"row\" \nflex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1Div\" chart-options=\"vm.optionsAadj1Div\" id=\"chart5\">\n</div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj2Div\" \nchart-options=\"vm.optionsAadj2Div\" id=\"chart6\"></div></div></div></div></ms-widget-front></ms-widget></div>\n</md-tab-body></md-tab><md-tab label=\"Key Performance Indicators\"><md-tab-label><md-icon \nmd-font-icon=\"icon-beaker-outline\" class=\"icon\"></md-icon>Key Performance Indicators</md-tab-label><md-tab-body><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\"><strong>KPI Progress YTD N-1 2017</strong></div>\n<div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Flip widget\">Nevyndatama Putranta\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">Frans Bastian Sutanto Hutapea\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">Christianta Sitepu</md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">Chong Kok Yeow Kenny</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" \nlayout=\"column\" flex=\"100\"><div ui-chart=\"vm.dataKpi\" chart-options=\"vm.optionsKpi\" id=\"chart11\"></div></div></div><div\n layout=\"row\" layout-align=\"start center\" layout-wrap flex><div layout=\"column\" flex=\"100\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"1%\">KPI NO.</th><th>KPI</th>\n<th>DESCRIPTION</th><th>UOM</th><th>TARGET</th><th>WEIGHT</th><th>RESULT YTD</th></tr></thead><tbody><tr><td>1</td><td>\nHR Digitalization</td><td>HR Digitalization for HC</td><td>Index</td><td>3 Function (TA, Comben, PM) Go live</td><td>\n30%</td><td>TA Go live</td></tr><tr><td>2</td><td>Nabati Development Center</td><td>Learning for all Employee</td><td>\nHour</td><td>20000</td><td>20%</td><td>30000</td></tr><tr><td>3</td><td>RTC N-1 &amp; identified Key Position</td><td>\nRTC N-1 &amp; identified Key Position</td><td>Unit</td><td>100% by Q3 1:1</td><td>25%</td><td>Q3 1:0.65</td></tr><tr>\n<td>4</td><td>HR Standardization Project</td><td>Standardize process on Human Capital</td><td>Time</td><td>\nCorporate HR Policies by Q4 100% (HR in the Box) Implementation</td><td>25%</td><td>Q3 all Policies go to Deployment\n</td></tr></tbody></table></div></div></ms-widget-front></ms-widget></div></md-tab-body></md-tab><md-tab \nlabel=\"Head Count\"><md-tab-label><md-icon md-font-icon=\"icon-account-multiple-plus\" class=\"icon\"></md-icon>Head Count\n</md-tab-label><md-tab-body><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"light-green-bg white-fg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">KSNI</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-green-900-fg font-size-72 line-height-72\">560</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 light-green-bg white-fg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span \nclass=\"h4 ml-8\">160</span> <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span \nclass=\"h4 ml-8\">300</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div><div class=\"border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">YTD 2017</span></div></div><div class=\"border-bottom\" layout=\"row\" \nlayout-align=\"start center\"><div><i class=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div \nclass=\"h4 text-bold\" flex>Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"red-bg white-fg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">RKI</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-900-fg font-size-72 line-height-72\">467</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 red-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span class=\"h4 ml-8\">200</span>\n <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span class=\"h4 ml-8\">267</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div><div class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">YTD 2017\n</span></div></div><div class=\"border-bottom\" layout=\"row\" layout-align=\"start center\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div class=\"h4 text-bold\" flex>\nTurnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div class=\"border-bottom\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"blue-bg white-fg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">ENERLIFE</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-900-fg font-size-72 line-height-72\">230</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 blue-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span class=\"h4 ml-8\">100</span>\n <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span class=\"h4 ml-8\">130</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div><div class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">YTD 2017\n</span></div></div><div class=\"border-bottom\" layout=\"row\" layout-align=\"start center\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div class=\"h4 text-bold\" flex>\nTurnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div class=\"border-bottom\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"brown-bg white-fg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">PMA</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"brown-900-fg font-size-72 line-height-72\">980</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 brown-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span class=\"h4 ml-8\">400</span>\n <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span class=\"h4 ml-8\">580</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div><div class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">YTD 2017\n</span></div></div><div class=\"border-bottom\" layout=\"row\" layout-align=\"start center\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div class=\"h4 text-bold\" flex>\nTurnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div class=\"border-bottom\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3 grey-600-fg\"><strong>\nHead Count Overview KSNI YTD 2016</strong></div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button aria-label=\"Flip widget\">KSNI</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Refresh widget\">RKI</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">ENERLIFE\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">PMA</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" \nlayout=\"column\" flex=\"90\"><div ui-chart=\"vm.dataHc\" style=\"height:450px\" chart-options=\"vm.HcOption\" id=\"chart12\">\n</div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"pv-8 h3 grey-600-fg\"><strong>Headcount Movement 2016</strong></div><div class=\"pv-8\" layout=\"row\" \nlayout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Flip widget\">KSNI</md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Refresh widget\">RKI</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Refresh widget\">ENERLIFE</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">PMA\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"p-16\" layout=\"column\" flex=\"90\"><div ui-chart=\"vm.dataHcMovement\" style=\"height:650px\" \nchart-options=\"vm.HcOptionMovement\" id=\"chart13\"></div></div></div></ms-widget-front></ms-widget></div></md-tab-body>\n</md-tab><md-tab label=\"Productivity\"><md-tab-label><md-icon md-font-icon=\"icon-basket-unfill\" class=\"icon\"></md-icon>\nProductivity</md-tab-label><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" \nflex=\"100\"><ms-widget-front class=\"white-bg\"></ms-widget-front></ms-widget></div></md-tab></md-tabs></md-content></div>\n</div></div></md-content></div>");
$templateCache.put("app/main/changepassword/changepassword.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\">\n<span><img src=\"assets/images/logos/logo.png\" alt=\"\"></span></div><div class=\"title\">Reset your password</div><form \nname=\"resetPasswordForm\" novalidate ng-submit=\"vm.saveDataPass($event)\"><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.pass.password\" placeholder=\"Password\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.pass.passwordConfirm\" placeholder=\"Password (Confirm)\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword (Confirm) field is required</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"UPDATE MY PASSWORD\" \nng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\">RESET MY PASSWORD</md-button></form></div>\n</div></div>");
$templateCache.put("app/main/completeness-of-attendance/completeness.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Completeness of Attendance</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\">\n<div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmCompleteness\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmCompleteness.company.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.divisi\" ng-disabled=\"vm.divdeptdisabled\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmCompleteness.divisi.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.department\" ng-disabled=\"vm.divdeptdisabled\" name=\"department\">\n<md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmCompleteness.department.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Department field is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" class=\"mt-30\"><md-input-container flex><label>Sub Area</label><md-select ng-model=\"vm.subarea\" \nname=\"subarea\" ng-change=\"vm.loadBuilding(vm.subarea)\" required><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"Subarea\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.building\" ng-disabled=\"vm.typedisabled\" name=\"building\" \nng-change=\"vm.loadSector(vm.building)\" required><md-option ng-repeat=\"ls in vm.listBuilding\" \nplaceholder=\"Building List\" value=\"{{ls.id}}\">{{ls.name | uppercase}}</md-option></md-select><div \nng-messages=\"frmCompleteness.building.$error\" role=\"alert\"><div ng-message=\"required\"><span>Building field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.sector\" \nng-disabled=\"vm.typedisabled\" name=\"sector\" required><md-option ng-repeat=\"ls in vm.listSector\" \nplaceholder=\"Sector List\" value=\"{{ls.id}}\">{{ls.name | uppercase}}</md-option></md-select><div \nng-messages=\"frmCompleteness.sector.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sector field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.employeeType\" \nng-disabled=\"vm.typedisabled\" name=\"employeeType\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"Employee Type\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select><div \nng-messages=\"frmCompleteness.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmCompleteness.$invalid || frmCompleteness.$pristine\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span>\n</md-button></md-input-container></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"></div></md-toolbar><md-content id=\"attendance-completion\" layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\"><thead><tr><th width=\"15\" class=\"text-center\">NO</th><th class=\"\">ITEM</th><th width=\"40\" \nclass=\"text-center\">TOTAL</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td>{{ $index + 1 }}.</td><td>\n{{ls.item_name}}</td><td class=\"text-center\"><span ng-if=\"ls.total > 0\"><a href=\"\" \nng-click=\"vm.detailItem(ls,vm.param)\">{{ls.total}}</a><md-tooltip md-direction=\"top\">View Detail</md-tooltip></span>\n<span ng-if=\"ls.total == 0\">{{ls.total}}</span></td></tr><tr class=\"text-center\" ng-if=\"vm.listData.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/completeness-of-attendance/view-detail.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"70\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>View Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th width=\"15%\" class=\"text-center\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.NIK\">NIK</span></th>\n<th width=\"15%\" class=\"text-center\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.NAME\">Name</span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td class=\"text-center\"><span>{{ls.nik}}</span></td><td \nclass=\"text-center\"><span>{{ls.name}}</span></td></tr><tr ng-if=\"vm.listData.length <= 0\"><td colspan=\"3\" \nclass=\"text-center\"><span>No Data Available</span></td></tr></tbody></table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/correspondence/detail.html","<md-dialog aria-label=\"Create Correspondence Request\" md-theme=\"modal-theme\" ms-scroll flex=\"50\" \nid=\"correspondence-dialog\"><md-toolbar><div class=\"md-toolbar-tools title\"><h4>Create Correspondence Request</h4><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"dialogClose()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear ng-show=\"vm.loadingProgress\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-dialog-content layout-fill style=\"margin-top:0px\"><div layout=\"row\" \nflex layout-padding id=\"requestDetail\"><div flex layout layout-align=\"start center\"><div flex=\"15\" \nclass=\"img-container\"><img ng-src=\"{{ \'api/pasfoto/\' + items.photo_address }}\" \nonerror=\"this.src=\'assets/images/avatars/profile.jpg\'\"></div><div flex class=\"request-container\" layout=\"column\" \nlayout-align=\"start stretch\"><div class=\"explaining-text\" flex layout=\"row\"><span class=\"title\" flex=\"20\">Nik / Name\n</span> <span flex=\"5\">:</span> <span flex>{{ items.requestor }} / {{ items.name }}</span></div><div \nclass=\"explaining-text\" flex layout=\"row\"><span class=\"title\" flex=\"20\">Request Type</span> <span flex=\"5\">:</span> \n<span flex>{{ items.request_type_name }}</span></div><div class=\"explaining-text\" flex layout=\"row\"><span \nclass=\"title\" flex=\"20\">Status</span> <span flex=\"5\">:</span> <span class=\"title\" flex>{{ items.status }}</span></div>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" flex><div flex layout-align=\"end center\" \nlayout=\"row\"><md-button ng-if=\"vm.create\" class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.storeRequest($event,formCorrespondence)\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\">\n</md-icon>Save</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/dashboard/dashboard.html","<div class=\"page-layout simple fullwidth\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\"><div layout=\"column\" flex><div \nclass=\"h3 secondary-text pb-8\">{{vm.widget1.sessions.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">\n{{vm.widget1.sessions.value}}</div><div><nvd3 class=\"h-40\" options=\"vm.widget1.sessions.options\" \ndata=\"vm.widget1.sessions.data\"></nvd3></div></div></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 grey-50-bg\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" flex><div class=\"h3 secondary-text pb-8\">\n{{vm.widget1.pageviews.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pageviews.value}}</div>\n<div><nvd3 class=\"h-40\" options=\"vm.widget1.pageviews.options\" data=\"vm.widget1.pageviews.data\"></nvd3></div></div>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 grey-50-bg\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" flex><div class=\"h3 secondary-text pb-8\">\n{{vm.widget1.pagesSessions.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">\n{{vm.widget1.pagesSessions.value}}</div><div><nvd3 class=\"h-40\" options=\"vm.widget1.pagesSessions.options\" \ndata=\"vm.widget1.pagesSessions.data\"></nvd3></div></div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\"><div layout=\"column\" flex><div \nclass=\"h3 secondary-text pb-8\">{{vm.widget1.avgSessionDuration.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.avgSessionDuration.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.avgSessionDuration.options\" data=\"vm.widget1.avgSessionDuration.data\"></nvd3></div></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><div \nclass=\"text-boxed green-600-bg white-fg\">{{vm.date}}</div></div><div class=\"pb-32 border-bottom\"><chart-turn-over \nstyle=\"width: 100%; height: 500px\" chartid=\"chart1\"></chart-turn-over></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"p-24\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nPeople Cost</div><div class=\"text-boxed green-600-bg white-fg\">{{vm.date}}</div></div><div class=\"pb-32 pt-10\">\n<people-cost-chart style=\"width: 100%; height: 500px\"></people-cost-chart></div></ms-widget-front></ms-widget></div>\n<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"p-24\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nCompany Performances</div><div class=\"text-boxed green-600-bg white-fg\">{{vm.date}}</div></div><div \nclass=\"pb-32 pt-10\" layout=\"row\"><peformance-chart style=\"height: 200px\" chart-id=\"vm.listDept[0].id\" \ndata=\"vm.listDept[0]\"></peformance-chart><peformance-chart style=\"height: 200px\" chart-id=\"vm.listDept[1].id\" \ndata=\"vm.listDept[1]\"></peformance-chart><peformance-chart style=\"height: 200px\" chart-id=\"vm.listDept[2].id\" \ndata=\"vm.listDept[2]\"></peformance-chart><peformance-chart style=\"height: 200px\" chart-id=\"vm.listDept[3].id\" \ndata=\"vm.listDept[3]\"></peformance-chart><peformance-chart style=\"height: 200px\" chart-id=\"vm.listDept[4].id\" \ndata=\"vm.listDept[4]\"></peformance-chart></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/department-business/department-business-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.DEPARTMENTBUSINESSTITLE\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nclass=\"width-filter\"><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.Form.objForm.country_id\" name=\"country_id\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"country_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"width-filter\"><label><span translate=\"KPI.LABEL.COMPANY\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.company_id\" name=\"company_id\" \nng-change=\"vm.loadDivision(vm.Form.objForm.company_id)\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"company_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcompany | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"width-filter\"><label><span translate=\"KPI.LABEL.DIVISION\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.division_id\" name=\"division_id\" \nng-change=\"vm.loadDepartment(vm.Form.objForm.company_id,vm.Form.objForm.division_id)\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"division_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listdivisi | filter:vm.searchTerm\">\n{{ls.description}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"width-filter\">\n<label><span translate=\"KPI.LABEL.DEPARTMENT\"></span></label><md-select ng-model=\"vm.Form.objForm.department_id\" \nname=\"department\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a department...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"department\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDepartment | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"width-filter\"><label><span \ntranslate=\"FILTER.FLAG_APP\"></span></label><md-select ng-model=\"vm.Form.objForm.flag\" name=\"flag\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"flag\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listFlag | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"width-filter\"><label><span \ntranslate=\"KPI.LABEL.LABORTYPE\"></span></label><md-select ng-model=\"vm.Form.objForm.labor_type\" name=\"labor_type\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"labor_type\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listLaborType | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"width-filter\"><label><span \ntranslate=\"MENU.MAIN.BUSINESSTITLE\"></span></label><md-select ng-model=\"vm.Form.objForm.business_title_id\" \nname=\"department\" md-on-close=\"vm.clearSearchTerm()\" required ng-change=\"vm.setBt()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a business title...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"business_title\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listBusinessTitle | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"width-filter\"><label><span translate=\"MENU.MAIN.POSITIONID\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.position_id\" name=\"position_id\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a job title...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"position_id\">\n<md-option value=\"{{ls.positionID}}\" ng-repeat=\"ls in vm.listPositionId | filter:vm.searchTerm\">\n{{ls.description}} ({{ls.positionID}})</md-option></md-optgroup></md-select></md-input-container><md-input-container \nclass=\"width-filter\"><label><span translate=\"MENU.MAIN.GROUPCLUSTER\"></span></label><md-select \nng-model=\"vm.Form.objForm.group_cluster\" name=\"group_cluster\"><md-optgroup label=\"group_cluster\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listGroupCluster\">{{ls.description}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"width-filter\"><md-tooltip><span translate=\"MENU.MAIN.NEWJT\"></span>\n</md-tooltip><md-checkbox aria-label=\"empLaborChecked\" ng-model=\"vm.Form.objForm.new_job_title\"><span \ntranslate=\"MENU.MAIN.NEWJT\"></span></md-checkbox></md-input-container></div><div layout=\"row\" \nng-if=\"vm.Form.objForm.new_job_title\"><md-input-container class=\"width-filter\"><label><span \ntranslate=\"MENU.MAIN.JOB_FUNCTION\"></span></label><md-select ng-model=\"vm.Form.objForm.job_function\" \nname=\"job_function\"><md-optgroup label=\"job_function\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listJobFunction\">{{ls.description}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container class=\"width-filter\"><label><span translate=\"MENU.MAIN.JOB_TITLE\"></span></label><input \ntype=\"text\" ng-model=\"vm.Form.objForm.job_title\" name=\"job_title\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/department-business/department-business.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.DEPARTMENTBUSINESSTITLE\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container \nclass=\"width-filter\"><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.Form.objForm.country_id\" name=\"country_id\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"country_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"width-filter\"><label><span translate=\"KPI.LABEL.COMPANY\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.company_id\" name=\"company_id\" \nng-change=\"vm.LoadDivisi(vm.Form.objForm.company_id)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"company_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcompany | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"width-filter\"><label><span translate=\"KPI.LABEL.DIVISION\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.division_id\" name=\"division_id\" \nng-change=\"vm.loadDepartment(vm.Form.objForm.division_id)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listdivisi | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"width-filter\"><label><span translate=\"KPI.LABEL.DEPARTMENT\"></span>\n</label><md-select ng-model=\"vm.department\" name=\"department\" md-on-close=\"vm.clearSearchTerm()\" \nng-required=\"vm.requiredDepartpemnt\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a department...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"department\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listDepartment | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"width-filter\"><label><span \ntranslate=\"MENU.MAIN.BUSINESSTITLE\"></span></label><md-select ng-model=\"vm.business_title\" name=\"department\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a business title...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"business_title\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listBusinessTitle | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"width-filter\"><label>\n<span translate=\"FILTER.FLAG_APP\"></span></label><md-select ng-model=\"vm.flag\" name=\"flag\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"flag\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listFlag | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container class=\"width-filter\"><label><span translate=\"KPI.LABEL.LABORTYPE\">\n</span></label><md-select ng-model=\"vm.labor_type\" name=\"labor_type\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"labor_type\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listLaborType | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span><span translate=\"PAYROLL.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.DEPARTMENT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.BUSINESSTITLE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.JOB_TITLE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"FILTER.FLAG_APP\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.LABORTYPE\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr ng-dblclick=\"vm.editData($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n<md-checkbox aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.no}}</td><td class=\"\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.department}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.business_title}}</td><td class=\"text-center\"><md-tooltip>\n<span translate=\"MENU.MAIN.JOB_TITLE\"></span></md-tooltip>{{item.job_title}}</td><td class=\"text-center\"><md-tooltip>\n<span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.flag | uppercase}}</td><td class=\"text-center\">\n<md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.labor_type}}</td><td class=\"text-center\">\n<section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/echeckingw/echeckingw.html","<div class=\"page-layout carded fullwidth grey-200-bg\" id=\"echeckin\" layout=\"row\"><div class=\"top-bg md-primary-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-image\"><img src=\"assets/images/logos/new_logo.png\" height=\"5\" \nstyle=\"max-height: 50px;margin-right: 20px;margin-top: 10px\"> </span><span class=\"logo-text h1 white-fg hide-xs\">\nE-Check In GW</span> <span flex></span> <span class=\"logo-text h3 white-fg\"><md-icon md-font-icon=\"icon-account\" \nclass=\"s24\"></md-icon>{{vm.user}} | <a href=\"\" ng-click=\"vm.logout()\"><md-icon md-font-icon=\"icon-logout\" class=\"s24\">\n</md-icon>Logout</a></span></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"breadcrumb text-truncate md-headline\" layout=\"row\" \nlayout-align=\"start center\"></div></div><md-content class=\"content\" flex ms-scroll ui-view><form \nname=\"verticalStepper\" ms-vertical-stepper=\"\" ng-submit=\"vm.submit(verticalStepper)\" ng-model=\"vm.Form.objForm\" \nnovalidate=\"\"><div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div \nclass=\"ms-stepper-steps\"><ms-vertical-stepper-step ng-form=\"verticalStep1\" step=\"1\" step-title=\"\'Data Pribadi\'\" \nmd-selected=\"selected\"><div class=\"ms-stepper-step-content\" style=\"display: inline\"><div class=\"\"><div \nclass=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" class=\"layout-gt-xs-row layout-column flex\">\n<md-input-container flex=\"100\" flex-gt-xs=\"50\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100 ng-animate md-input-invalid\" data-ng-animate=\"2\" style=\"\">\n<label tabindex=\"-1\" class=\"ng-scope md-required\" role=\"button\" for=\"input_318\">Nama Depan</label><input type=\"text\" \nname=\"namaDepan\" ng-model=\"vm.Form.objForm.step1.namaDepan\" required=\"\" \nclass=\"md-input ng-empty ng-invalid ng-invalid-required ng-pristine ng-touched\" id=\"input_318\" aria-invalid=\"true\" \nstyle=\"\"><div class=\"md-errors-spacer\"></div><div ng-messages=\"verticalStep1.namaDepan.$error\" \nng-show=\"verticalStep1.namaDepan.$touched\" role=\"alert\" class=\"md-input-messages-animation ng-active\" \naria-live=\"assertive\" aria-hidden=\"false\"><div ng-message=\"required\" \nclass=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>Nama Depan field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" class=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label tabindex=\"-1\" class=\"ng-scope\" \nrole=\"button\" for=\"input_319\">Nama Belakang</label><input type=\"text\" name=\"namaBelakang\" \nng-model=\"vm.Form.objForm.step1.namaBelakang\" class=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" \nid=\"input_319\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div><div \nng-messages=\"verticalStep1.namaBelakang.$error\" ng-show=\"verticalStep1.namaBelakang.$touched\" role=\"alert\" \nclass=\"md-input-messages-animation ng-inactive ng-hide\" aria-live=\"assertive\" aria-hidden=\"true\"></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label tabindex=\"-1\" class=\"ng-scope\" role=\"button\" \nfor=\"input_319\">Tgl Lahir</label><md-datepicker name=\"tglLahir\" md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.step1.tglLahir\" id=\"input_319\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" class=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\" ng-disabled=\"true\"><label tabindex=\"-1\" \nclass=\"ng-scope md-required\" role=\"button\" for=\"input_319\">No. KTP</label><input type=\"text\" name=\"noKtp\" \nng-model=\"vm.Form.objForm.step1.noKtp\" class=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" required=\"\" \nid=\"input_319\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div><div ng-messages=\"verticalStep1.noKtp.$error\" \nng-show=\"verticalStep1.noKtp.$touched\" role=\"alert\" class=\"md-input-messages-animation ng-active\" \naria-live=\"assertive\" aria-hidden=\"false\"><div ng-message=\"required\" \nclass=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>No. KTP field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label tabindex=\"-1\" class=\"ng-scope\" role=\"button\" \nfor=\"input_319\">Berlaku Sampai (kosongkan jika seumur hidup)</label><md-datepicker autocomplete=\"off\" \nname=\"berlakuSampai\" md-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.step1.berlakuSampai\" id=\"input_319\">\n</md-datepicker></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label tabindex=\"-1\" class=\"ng-scope md-required\" \nrole=\"button\" for=\"input_319\">Dikeluarkan di</label><input type=\"text\" name=\"dikeluarkan\" \nng-model=\"vm.Form.objForm.step1.dikeluarkan\" class=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" \nid=\"input_319\" aria-invalid=\"false\" required=\"\"><div class=\"md-errors-spacer\"></div><div \nng-messages=\"verticalStep1.dikeluarkan.$error\" ng-show=\"verticalStep1.dikeluarkan.$touched\" role=\"alert\" \nclass=\"md-input-messages-animation ng-inactive ng-hide\" aria-live=\"assertive\" aria-hidden=\"true\"></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" class=\"layout-gt-xs-row layout-column flex\">\n<md-radio-group ng-model=\"vm.Form.objForm.step1.jenkel\" layout-gt-md=\"row\" required><md-radio-button value=\"L\" \nstyle=\"width:100px\">Laki laki</md-radio-button><md-radio-button value=\"P\" style=\"width:150px\">Perempuan\n</md-radio-button></md-radio-group><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label>Agama</label><md-select \nng-model=\"vm.Form.objForm.step1.agama\" required><md-option ng-repeat=\"g in vm.agama\" ng-value=\"g\">{{g}}</md-option>\n</md-select><div ng-messages=\"verticalStep1.agama.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAgama is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label tabindex=\"-1\" class=\"ng-scope md-required\" \nrole=\"button\" for=\"input_319\">No. HP</label><input type=\"number\" name=\"noHp\" ng-model=\"vm.Form.objForm.step1.noHp\" \nclass=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" required=\"\" id=\"input_319\" aria-invalid=\"false\"><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"verticalStep1.noHp.$error\" ng-show=\"verticalStep1.noHp.$touched\" \nrole=\"alert\" class=\"md-input-messages-animation ng-active\" aria-live=\"assertive\" aria-hidden=\"false\"><div \nng-message=\"required\" class=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>No. HP field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label tabindex=\"-1\" class=\"ng-scope\" role=\"button\" \nfor=\"input_319\">Email</label><input type=\"text\" name=\"email\" ng-model=\"vm.Form.objForm.step1.email\" \nclass=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" id=\"input_319\" aria-invalid=\"false\"><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"verticalStep1.email.$error\" ng-show=\"verticalStep1.email.$touched\" \nrole=\"alert\" class=\"md-input-messages-animation ng-active\" aria-live=\"assertive\" aria-hidden=\"false\"></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" class=\"layout-gt-xs-row layout-column flex\">\n<md-input-container flex><label tabindex=\"-1\" class=\"ng-scope md-required\" role=\"button\" for=\"input_319\">Alamat</label>\n<input type=\"text\" name=\"address\" ng-model=\"vm.Form.objForm.step1.address\" \nclass=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" required=\"\" id=\"input_319\" aria-invalid=\"false\"><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"verticalStep1.address.$error\" \nng-show=\"verticalStep1.address.$touched\" role=\"alert\" class=\"md-input-messages-animation ng-active\" \naria-live=\"assertive\" aria-hidden=\"false\"><div ng-message=\"required\" \nclass=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>Alamat field is required.</span></div></div></md-input-container><md-input-container flex><label>Provinsi</label>\n<md-select ng-model=\"vm.Form.objForm.step1.provinsi\" ng-change=\"vm.loadKab(vm.Form.objForm.step1.provinsi)\" \nname=\"provinsi\" required><md-option ng-repeat=\"prov in vm.listProvince\" ng-value=\"prov.lokasi_kode\">\n{{prov.lokasi_nama}}</md-option></md-select><div ng-messages=\"verticalStep1.provinsi.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Provinsi Harus Diisi.</span></div></div></md-input-container>\n<md-input-container flex><label>Kota/Kabupaten</label><md-select ng-model=\"vm.Form.objForm.step1.kab_kota\" \nng-change=\"vm.loadKec(vm.Form.objForm.step1.kab_kota)\" name=\"kab_kota\" required><md-option \nng-repeat=\"prov in vm.listKab\" ng-value=\"prov.lokasi_kode\">{{prov.lokasi_nama}}</md-option></md-select><div \nng-messages=\"verticalStep1.kab_kota.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nKota/Kabupaten Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>Kecamatan</label>\n<md-select ng-model=\"vm.Form.objForm.step1.kec\" name=\"kec\" required><md-option ng-repeat=\"prov in vm.listKec\" \nng-value=\"prov.lokasi_kode\">{{prov.lokasi_nama}}</md-option></md-select><div ng-messages=\"verticalStep1.kec.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Kecamatan Harus Diisi.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" class=\"layout-gt-xs-row layout-column flex\">\n<md-input-container flex><label tabindex=\"-1\" class=\"ng-scope md-required\" role=\"button\" for=\"input_319\">Kelurahan\n</label><input type=\"text\" name=\"kelurahan\" ng-model=\"vm.Form.objForm.step1.kelurahan\" \nclass=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" required=\"\" id=\"input_319\" aria-invalid=\"false\"><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"verticalStep1.kelurahan.$error\" \nng-show=\"verticalStep1.kelurahan.$touched\" role=\"alert\" class=\"md-input-messages-animation ng-active\" \naria-live=\"assertive\" aria-hidden=\"false\"><div ng-message=\"required\" \nclass=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>Kelurahan field is required.</span></div></div></md-input-container><md-input-container flex><label \ntabindex=\"-1\" class=\"ng-scope md-required\" role=\"button\" for=\"input_319\">RT</label><input type=\"text\" name=\"rt\" \nng-model=\"vm.Form.objForm.step1.rt\" class=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" required=\"\" \nid=\"input_319\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div><div ng-messages=\"verticalStep1.rt.$error\" \nng-show=\"verticalStep1.rt.$touched\" role=\"alert\" class=\"md-input-messages-animation ng-active\" aria-live=\"assertive\" \naria-hidden=\"false\"><div ng-message=\"required\" class=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>RT field is required.</span></div></div></md-input-container><md-input-container flex><label tabindex=\"-1\" \nclass=\"ng-scope md-required\" role=\"button\" for=\"input_319\">RW</label><input type=\"text\" name=\"rw\" \nng-model=\"vm.Form.objForm.step1.rw\" class=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" required=\"\" \nid=\"input_319\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div><div ng-messages=\"verticalStep1.rw.$error\" \nng-show=\"verticalStep1.rw.$touched\" role=\"alert\" class=\"md-input-messages-animation ng-active\" aria-live=\"assertive\" \naria-hidden=\"false\"><div ng-message=\"required\" class=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>RW field is required.</span></div></div></md-input-container><md-input-container flex><label tabindex=\"-1\" \nclass=\"ng-scope md-required\" role=\"button\" for=\"input_319\">Kode Pos</label><input type=\"text\" name=\"kode_pos\" \nng-model=\"vm.Form.objForm.step1.kode_pos\" class=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" required=\"\" \nid=\"input_319\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div><div \nng-messages=\"verticalStep1.kode_pos.$error\" ng-show=\"verticalStep1.kode_pos.$touched\" role=\"alert\" \nclass=\"md-input-messages-animation ng-active\" aria-live=\"assertive\" aria-hidden=\"false\"><div ng-message=\"required\" \nclass=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>Kode Pos field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nflex=\"\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex><label tabindex=\"-1\" \nclass=\"ng-scope md-required\" role=\"button\" for=\"input_319\">No. KK</label><input type=\"text\" name=\"documentNo\" \nng-model=\"vm.Form.objForm.step1.documentNo\" class=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" required=\"\" \nid=\"input_319\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div><div \nng-messages=\"verticalStep1.documentNo.$error\" ng-show=\"verticalStep1.documentNo.$touched\" role=\"alert\" \nclass=\"md-input-messages-animation ng-active\" aria-live=\"assertive\" aria-hidden=\"false\"><div ng-message=\"required\" \nclass=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>No. KK field is required.</span></div></div></md-input-container><md-input-container flex><label tabindex=\"-1\" \nclass=\"ng-scope md-required\" role=\"button\" for=\"input_319\">Nama Ibu Kandung</label><input type=\"text\" \nname=\"biological_mother\" ng-model=\"vm.Form.objForm.step1.biological_mother\" \nclass=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" required=\"\" id=\"input_319\" aria-invalid=\"false\"><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"verticalStep1.biological_mother.$error\" \nng-show=\"verticalStep1.biological_mother.$touched\" role=\"alert\" class=\"md-input-messages-animation ng-active\" \naria-live=\"assertive\" aria-hidden=\"false\"><div ng-message=\"required\" \nclass=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>Nama Ibu Kandung field is required.</span></div></div></md-input-container><md-input-container flex><label \ntabindex=\"-1\" class=\"ng-scope\" role=\"button\" for=\"input_319\">Gol. Darah</label><input type=\"text\" name=\"bloodType\" \nng-model=\"vm.Form.objForm.step1.bloodType\" class=\"ng-valid md-input ng-empty ng-pristine ng-untouched\" id=\"input_319\" \naria-invalid=\"false\"><div class=\"md-errors-spacer\"></div><div ng-messages=\"verticalStep1.bloodType.$error\" \nng-show=\"verticalStep1.bloodType.$touched\" role=\"alert\" class=\"md-input-messages-animation ng-active\" \naria-live=\"assertive\" aria-hidden=\"false\"><div ng-message=\"required\" \nclass=\"md-input-message-animation ng-scope ng-enter ng-enter-active\" \nstyle=\"opacity: 1; margin-top: 0px; transition-duration: 0.3s; transition-timing-function: linear; transition-property: all\">\n<span>Gol. Darah field is required.</span></div></div></md-input-container></div></div></div></div><div \nclass=\"ms-stepper-controls layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\" aria-hidden=\"false\" style=\"\"><button \nclass=\"md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\" disabled=\"disabled\">Back</button> <button\n class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" \nng-click=\"MsStepper.gotoNextStep()\" disabled=\"disabled\" style=\"\">Next</button></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep2\" step=\"2\" step-title=\"\'Status Pernikahan\'\"><div \nclass=\"ms-stepper-step-content\" style=\"display: none\"><div class=\"ng-scope\"><div class=\"md-inline-form ng-scope\"><p>\nApakah anda sudah Menikah ?</p><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" \nclass=\"layout-gt-xs-row layout-column flex\"><md-radio-group ng-model=\"vm.Form.objForm.step2.statusNikah\" ng-switch \non=\"vm.Form.objForm.step2.statusNikah\" flex required ng-click=\"vm.statusMenikah(vm.Form.objForm.step2.statusNikah)\">\n<div flex layout=\"row\" layout-align=\"start center\"><md-radio-button ng-model=\"statusNikah\" name=\"statusNikah\" \nvalue=\"Menikah\">Menikah</md-radio-button>&nbsp;&nbsp;<md-radio-button ng-model=\"statusNikah\" name=\"statusNikah\" \nvalue=\"Belum\">Belum Menikah</md-radio-button></div></md-radio-group></div><md-item-content flex><div \nng-switch=\"vm.Form.objForm.step2.statusNikah\"><div ng-switch-when=\"Menikah\"><span \nng-repeat=\"item in  vm.Form.objForm.step2.dependents \" class=\"form-group row\"><div layout=\"column\" layout-gt-xs=\"row\" \nflex=\"\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex=\"100\" class=\"md-default-theme flex-100\">\n<label class=\"ng-scope\" ng-class=\"{\'md-required\':!$last || $first}\">nama depan {{item.title}}</label><input \ntype=\"text\" name=\"anak[$index]\" ng-model=\" vm.Form.objForm.step2.dependents[$index].first_name\" \nng-required=\"!$last  || $first\"></md-input-container><md-input-container flex=\"100\" class=\"md-default-theme flex-100\">\n<label>nama belakang {{item.title}}</label><input type=\"text\" name=\"anak[$index]\" \nng-model=\" vm.Form.objForm.step2.dependents[$index].last_name\"></md-input-container><md-radio-group \nng-model=\"vm.Form.objForm.step2.dependents[$index].jenkel\" layout-gt-xs=\"row\"><md-radio-button value=\"L\" \nstyle=\"width:100px\">Laki laki</md-radio-button><md-radio-button value=\"P\" style=\"width:150px\">Perempuan\n</md-radio-button></md-radio-group><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label tabindex=\"-1\" class=\"ng-scope\" role=\"button\" \nfor=\"input_319\">Tgl Lahir</label><md-datepicker name=\"tglLahir[$index]\" md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.step2.dependents[$index].tglLahir\" id=\"input_319\"></md-datepicker></md-input-container>\n<md-button class=\"md-raised md-mini\" ng-click=\"vm.delAnak($index)\" ng-if=\"!$last && $index>0\">DEL</md-button><md-button\n class=\"md-raised md-mini\" ng-click=\"vm.addAnak($index)\" ng-if=\"$last\">ADD</md-button></div></span></div></div>\n</md-item-content></div></div></div><div class=\"ms-stepper-controls layout-align-start-center layout-row ng-hide\" \nlayout=\"row\" layout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\" aria-hidden=\"true\" \nstyle=\"\"><button class=\"md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\" disabled=\"disabled\">Back</button> <button\n class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" \nng-click=\"MsStepper.gotoNextStep()\" disabled=\"disabled\" style=\"\">Next</button></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" step-title=\"\'Bank\'\"><div class=\"ms-stepper-step-content\" \nstyle=\"display: none\"><div class=\"ng-scope\"><div class=\"md-inline-form ng-scope\"><p>\nApakah Anda sudah mempunyai rekening yang aktif pada bank Mandiri ?</p><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" \nclass=\"layout-gt-xs-row layout-column flex\"><md-radio-group ng-model=\"vm.Form.objForm.step3.statusBank\" ng-switch \non=\"vm.Form.objForm.step3.statusBank\" flex required><div flex layout=\"row\" layout-align=\"start center\"><md-radio-button\n ng-model=\"statusBank\" name=\"statusBank\" value=\"Sudah\">Sudah</md-radio-button>&nbsp;&nbsp;<md-radio-button \nng-model=\"statusBank\" name=\"statusBank\" value=\"Belum\">Belum punya</md-radio-button></div></md-radio-group></div>\n<md-item-content flex><div ng-switch=\"vm.Form.objForm.step3.statusBank\"><div ng-switch-when=\"Sudah\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex=\"100\" \nclass=\"md-default-theme flex-100\"><label for=\"norek\">input no. rekening</label><input type=\"number\" name=\"norek\" \nid=\"norek\" ng-model=\"vm.Form.objForm.step3.norek\" ng-required=\"!$last  || $first\"></md-input-container></div></div>\n</div></md-item-content></div></div></div><div \nclass=\"ms-stepper-controls layout-align-start-center layout-row ng-hide\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\" aria-hidden=\"true\" style=\"\"><button \nclass=\"md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\" disabled=\"disabled\">Back</button> <button\n class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" \nng-click=\"MsStepper.gotoNextStep()\" disabled=\"disabled\" style=\"\">Next</button></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep4\" step=\"4\" step-title=\"\'Pendidikan Terakhir\'\"><div \nclass=\"ms-stepper-step-content\" style=\"display: none\"><div class=\"ng-scope\"><div class=\"md-inline-form ng-scope\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" class=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label>Jenjang Pendidikan</label>\n<md-select ng-model=\"vm.Form.objForm.step4.jenjangPendidikan\" required><md-option \nng-repeat=\"g in vm.jenjangPendidikan\" ng-value=\"g\">{{g}}</md-option></md-select><div \nng-messages=\"verticalStep4.jenjangPendidikan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJenjang Pendidikan is required.</span></div></div></md-input-container><md-input-container flex=\"100\" \nclass=\"md-default-theme flex-100\"><label for=\"namaInstitusi\">Nama Institusi/Sekolah</label><input type=\"text\" \nname=\"namaInstitusi\" id=\"namaInstitusi\" ng-model=\"vm.Form.objForm.step4.namaInstitusi\" required></md-input-container>\n<md-input-container flex=\"100\" class=\"md-default-theme flex-100\"><label for=\"jurusan\">Jurusan</label><input \ntype=\"text\" name=\"jurusan\" id=\"jurusan\" ng-model=\"vm.Form.objForm.step4.jurusan\" required></md-input-container>\n<md-input-container flex=\"100\" class=\"md-default-theme flex-100\"><label for=\"tahunMulai\">Tahun Mulai</label><input \ntype=\"number\" min=\"1990\" max=\"2017\" name=\"tahunMulai\" id=\"tahunMulai\" ng-model=\"vm.Form.objForm.step4.tahunMulai\" \nrequired></md-input-container><md-input-container flex=\"100\" class=\"md-default-theme flex-100\"><label for=\"tahunTamat\">\nTahun Tamat</label><input type=\"number\" min=\"1990\" max=\"3000\" name=\"tahunTamat\" id=\"tahunTamat\" \nng-model=\"vm.Form.objForm.step4.tahunTamat\" required></md-input-container></div></div></div></div><div \nclass=\"ms-stepper-controls layout-align-start-center layout-row ng-hide\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\" aria-hidden=\"true\" style=\"\"><button \nclass=\"md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\" disabled=\"disabled\">Back</button> <button\n class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" \nng-click=\"MsStepper.gotoNextStep()\" disabled=\"disabled\" style=\"\">Next</button></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep5\" step=\"5\" step-title=\"\'Pengalaman Pekerjaan\'\"><div \nclass=\"ms-stepper-step-content\" style=\"display: none\"><div class=\"ng-scope\"><div class=\"md-inline-form ng-scope\"><span \nng-repeat=\"item in vm.Form.objForm.step5.pengalaman\" class=\"form-group row\"><div layout=\"column\" layout-gt-xs=\"row\" \nflex=\"\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex=\"100\" class=\"md-default-theme flex-100\">\n<label>Nama Perusahaan</label><input type=\"text\" name=\"namaPerusahaan[$index]\" \nng-model=\"vm.Form.objForm.step5.pengalaman[$index].namaPerusahaan\"></md-input-container><md-input-container flex=\"100\" \nclass=\"md-default-theme flex-100\"><label>Departemen</label><input type=\"text\" name=\"departemen[$index]\" \nng-model=\"vm.Form.objForm.step5.pengalaman[$index].departemen\"></md-input-container><md-input-container flex=\"100\" \nclass=\"md-default-theme flex-100\"><label>Section</label><input type=\"text\" name=\"section[$index]\" \nng-model=\"vm.Form.objForm.step5.pengalaman[$index].section\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" class=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label tabindex=\"-1\" class=\"ng-scope\" \nrole=\"button\" for=\"input_319\">Dari</label><md-datepicker md-hide-icons=\"calendar\" name=\"dari[$index]\" \nng-model=\"vm.Form.objForm.step5.pengalaman[$index].dari\" id=\"input_319\"></md-datepicker></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100\"><label \ntabindex=\"-1\" class=\"ng-scope\" role=\"button\" for=\"input_319\">Sampai</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"sampai[$index]\" ng-model=\"vm.Form.objForm.step5.pengalaman[$index].sampai\" id=\"input_319\"></md-datepicker>\n</md-input-container><md-button class=\"md-raised md-mini\" ng-click=\"vm.delPengalaman($index)\" \nng-if=\"!$last && $index>0\">DEL</md-button><md-button class=\"md-raised md-mini\" ng-click=\"vm.addPengalaman($index)\" \nng-if=\"$last\">ADD</md-button></div></span></div></div></div><div \nclass=\"ms-stepper-controls layout-align-start-center layout-row ng-hide\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\" aria-hidden=\"true\" style=\"\"><button \nclass=\"md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\" disabled=\"disabled\">Back</button> <button\n class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" \nng-click=\"MsStepper.gotoNextStep()\" disabled=\"disabled\" style=\"\">Next</button></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep6\" step=\"6\" step-title=\"\'Kontak Darurat\'\"><div \nclass=\"ms-stepper-step-content\" style=\"display: none\"><div class=\"ng-scope\"><div class=\"md-inline-form ng-scope\"><span \nng-repeat=\"item in  vm.Form.objForm.step6.kontak\" class=\"form-group row\"><div layout=\"column\" layout-gt-xs=\"row\" \nflex=\"\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex=\"100\" class=\"md-default-theme flex-100\">\n<label ng-class=\"{\'md-required\':!$last || $first}\">Nama</label><input type=\"text\" name=\"nama[$index]\" \nng-model=\"vm.Form.objForm.step6.kontak[$index].nama\" ng-required=\"!$last  || $first\"></md-input-container>\n<md-input-container flex=\"100\" class=\"md-default-theme flex-100\"><label ng-class=\"{\'md-required\':!$last || $first}\">\nAlamat</label><input type=\"text\" name=\"alamat[$index]\" ng-model=\"vm.Form.objForm.step6.kontak[$index].alamat\" \nng-required=\"!$last  || $first\"></md-input-container><md-input-container flex=\"100\" class=\"md-default-theme flex-100\">\n<label ng-class=\"{\'md-required\':!$last || $first}\">Hubungan</label><input type=\"text\" name=\"hubungan[$index]\" \nng-model=\"vm.Form.objForm.step6.kontak[$index].hubungan\" ng-required=\"!$last  || $first\"></md-input-container>\n<md-input-container flex=\"100\" class=\"md-default-theme flex-100\"><label ng-class=\"{\'md-required\':!$last || $first}\">\nNo. HP</label><input type=\"number\" name=\"hp[$index]\" ng-model=\"vm.Form.objForm.step6.kontak[$index].hp\" \nng-required=\"!$last  || $first\"></md-input-container><md-button class=\"md-raised md-mini\" \nng-click=\"vm.delKontak($index)\" ng-if=\"!$last && $index>0\">DEL</md-button><md-button class=\"md-raised md-mini\" \nng-click=\"vm.addKontak($index)\" ng-if=\"$last\">ADD</md-button></div></span></div></div></div><div \nclass=\"ms-stepper-controls layout-align-start-center layout-row ng-hide\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\" aria-hidden=\"true\" style=\"\"><button \nclass=\"md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\" disabled=\"disabled\">Back</button> <button\n class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" \nng-click=\"MsStepper.gotoNextStep()\" disabled=\"disabled\" style=\"\">Next</button></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep7\" step=\"7\" step-title=\"\'NPWP\'\"><div class=\"ms-stepper-step-content\" \nstyle=\"display: none\"><div class=\"ng-scope\"><div class=\"md-inline-form ng-scope\"><p>\nApakah Anda sudah memiliki no. NPWP ?</p><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" \nclass=\"layout-gt-xs-row layout-column flex\"><md-radio-group ng-model=\"vm.Form.objForm.step7.statusNpwp\" ng-switch \non=\"vm.Form.objForm.step7.statusNpwp\" flex required><div flex layout=\"row\" layout-align=\"start center\"><md-radio-button\n ng-model=\"statusNpwp\" name=\"statusNpwp\" value=\"Sudah\">Sudah</md-radio-button>&nbsp;&nbsp;<md-radio-button \nng-model=\"statusNpwp\" name=\"statusNpwp\" value=\"Belum\">Belum</md-radio-button></div></md-radio-group></div>\n<md-item-content flex><div ng-switch=\"vm.Form.objForm.step7.statusNpwp\"><div ng-switch-when=\"Sudah\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex=\"100\" \nclass=\"md-default-theme flex-100\"><label>no. npwp</label><input type=\"number\" name=\"npwp\" \nng-model=\"vm.Form.objForm.step7.npwp\" ng-required=\"!$last  || $first\"></md-input-container></div></div></div>\n</md-item-content></div></div></div><div class=\"ms-stepper-controls layout-align-start-center layout-row ng-hide\" \nlayout=\"row\" layout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\" aria-hidden=\"true\" \nstyle=\"\"><button class=\"md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\" disabled=\"disabled\">Back</button> <button\n class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" \nng-click=\"MsStepper.gotoNextStep()\" disabled=\"disabled\" style=\"\">Next</button></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep8\" step=\"8\" step-title=\"\'Jamsostek\'\"><div \nclass=\"ms-stepper-step-content\" style=\"display: none\"><div class=\"ng-scope\"><div class=\"md-inline-form ng-scope\"><p>\nApakah Anda sudah memiliki BPJS Ketenagakerjaan / Jamsostek ?</p><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" \nclass=\"layout-gt-xs-row layout-column flex\"><md-radio-group ng-model=\"vm.Form.objForm.step8.statusJamsostek\" ng-switch \non=\"vm.Form.objForm.step8.statusJamsostek\" flex required><div flex layout=\"row\" layout-align=\"start center\">\n<md-radio-button ng-model=\"statusJamsostek\" name=\"statusJamsostek\" value=\"Sudah\">Sudah</md-radio-button>&nbsp;&nbsp;\n<md-radio-button ng-model=\"statusJamsostek\" name=\"statusJamsostek\" value=\"Belum\">Belum</md-radio-button></div>\n</md-radio-group></div><md-item-content flex><div ng-switch=\"vm.Form.objForm.step8.statusJamsostek\"><div \nng-switch-when=\"Sudah\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" class=\"layout-gt-xs-row layout-column flex\">\n<md-input-container flex=\"100\" class=\"md-default-theme flex-100\"><label>no. Jamsostek anda..</label><input \ntype=\"number\" name=\"jamsostek\" ng-model=\"vm.Form.objForm.step8.jamsostek\" ng-required=\"!$last  || $first\">\n</md-input-container></div></div></div></md-item-content></div></div></div><div \nclass=\"ms-stepper-controls layout-align-start-center layout-row ng-hide\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\" aria-hidden=\"true\" style=\"\"><button \nclass=\"md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\" disabled=\"disabled\">Back</button> <button\n class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" \nng-click=\"MsStepper.gotoNextStep()\" disabled=\"disabled\" style=\"\">Next</button></div></ms-vertical-stepper-step></div>\n</div></form></md-content></div></div></div>");
$templateCache.put("app/main/echeckin/echeckin.html","<div class=\"page-layout carded fullwidth grey-200-bg\" id=\"echeckin\" layout=\"row\"><div class=\"top-bg md-yellow-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"headers\"><div class=\"user\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-image\"><img src=\"assets/images/logos/angular.png\" height=\"5\" \nstyle=\"max-height: 70px;margin-right: 20px\"> </span><span class=\"logo-text h1 white-fg hide-xs\">E-Check In</span> <span\n flex></span> <span class=\"logo-text h3 white-fg\"><md-icon md-font-icon=\"icon-account\" class=\"s24\"></md-icon>\n{{vm.user}} | <a href=\"\" ng-click=\"vm.logout()\"><md-icon md-font-icon=\"icon-logout\" class=\"s24\"></md-icon>Logout</a>\n</span></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar md-red-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"breadcrumb text-truncate md-headline\"><span \nng-repeat=\"bd in vm.Echeckin.breadcrumb\"><a ui-sref=\"{{bd.state}}\" ng-if=\"bd.active==0\">{{bd.name}}</a> <span \nng-if=\"bd.active==1\">{{bd.name}}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"icon separator md-headline\" \nng-if=\"bd.active==0\"></md-icon></span></div></div><md-content class=\"content\" flex ms-scroll ui-view \nstyle=\"padding-top:10px\"></md-content></div></div></div>");
$templateCache.put("app/main/emp-adjustment-allowance/emp-adjustment-allowance-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.ADJUSTMENTALLOWANCE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.NIK\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label><span translate=\"MENU.MAIN.SALARYCOMP\"></span></label><md-select \nng-model=\"vm.Form.objForm.salary_component_id\" name=\"salary\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a salary...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"salary\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSalaryComp | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SALARYCOMP\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" md-max-date=\"vm.Form.objForm.end_date\" \nname=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTDATE\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"KPI.LABEL.ENDDATE\"></label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.Form.objForm.start_date\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\"></md-datepicker><div \nng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDDATE\"></span>\n <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/emp-adjustment-allowance/emp-adjustment-allowance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ADJUSTMENTALLOWANCE\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"KPI.LABEL.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" md-max-date=\"vm.end_date\" \nname=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.ENDDATE\">\n</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\">\n</md-datepicker><div ng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"submit\" layout=\"row\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm aria-label=\"Delete\" type=\"button\" \nng-click=\"vm.upload($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"UMUT.MENU.UPLOAD\">click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"UMUT.MENU.UPLOAD\">Upload Data</span></md-button>\n<span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NIK\"></span>/<span translate=\"KPI.LABEL.NAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"MENU.MAIN.SALARYCOMP\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.STARTDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.ENDDATE\"></span></span></th><th width=\"5%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td \nclass=\"\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.nik}} / {{item.name}}</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.salary_component}}\n</td><td class=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.start_date}}\n</td><td class=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.end_date}}\n</td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"ACTION.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/emp-adjustment-allowance/upload.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif | translate }}</span></div><div \nng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">\n{{ vm.uploadNotif | translate }}</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.upload()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/emp-appraisal/emp-appraisal.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EMPAPPRAISAL\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"KPI.LABEL.COMPANY\">\n</label><md-select ng-model=\"vm.company\" name=\"company\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"PAYROLL.MENU.TYPE\"></label><md-select ng-model=\"vm.type\" name=\"type\">\n<md-option ng-repeat=\"ls in vm.listType\" placeholder=\"type\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.EFFECTIVEDATE\"></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\">\n</md-datepicker><div ng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.EFFECTIVEDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label>NIK</label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                                            border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmEmploye.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span>\n <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" \nlayout-align=\"space-between center\" layout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputEmpAppraisal($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">New</md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.lisEmpAppraisalSelected.length == 0\" ng-click=\" vm.DeleteEmpAppraisal()\"><md-icon \nng-if=\"vm.lisEmpAppraisalSelected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon \nng-if=\"vm.lisEmpAppraisalSelected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.lisEmpAppraisalSelected.length > 0\" class=\"red-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> \n<span ng-if=\"vm.lisEmpAppraisalSelected.length == 0\" class=\"grey-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span>\n</span> <span style=\"color:red\" ng-if=\"vm.lisEmpAppraisalSelected.length > 0\">{{ vm.lisEmpAppraisalSelected.length }} \n<span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload</md-tooltip>\n<md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span>NIK</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></span></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.TYPE\"></span></span></th><th width=\"5%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.COMPANY\"></span></span></th><th width=\"5%\" class=\"text-center\"></th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editEmpAppraisal($event,ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.lisEmpAppraisalSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ls.nik}}</td><td class=\"\">{{ls.emp_name}}</td><td class=\"text-center\">\n{{ls.effective_date | date : \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.type}}</td><td class=\"text-center\">\n{{ls.company}}</td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editEmpAppraisal($event, ls)\"><div layout=\"row\" \nflex><md-tooltip><span translate=\"ACTION.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/emp-appraisal/input-emp-appraisal.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"formData\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formData)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.EMPAPPRAISAL\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.COMPANY\"></label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"PAYROLL.MENU.TYPE\"></label><md-select ng-model=\"vm.Form.objForm.type\" \nname=\"type\"><md-option ng-repeat=\"ls in vm.listType\" placeholder=\"type\" value=\"{{ls.id}}\">{{ls.name}}</md-option>\n</md-select></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.EFFECTIVEDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\"></md-datepicker><div ng-messages=\"frmEmploye.start_date.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label>NIK</label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmEmploye.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span>\n <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formData.$invalid || formData.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/emp-appraisal/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/emp-assessment/emp-assessment-parent-question.html","<md-dialog aria-label=\"{{vm.title}} Background Information\" flex=\"100\"><form ng-cloak class=\"md-inline-form\" \nnovalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Background Information</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nclass=\"ng-scope layout-row\"><div flex-gt-sm=\"100\" flex=\"100\"><iframe ng-if=\"vm.parent_question_file\" \nng-src=\"{{vm.parent_question_file}}\" style=\"width:100%; height:100vh\" frameborder=\"0\"></iframe></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-teal-500-bg md-raised white-fg\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-refresh white-fg\"></md-icon>Close</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/emp-assessment/emp-assessment-previous-question.html","<md-dialog aria-label=\"Previous section {{vm.data.sort}}: {{vm.data.name}}\" flex=\"100\"><form ng-cloak \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nPrevious section {{vm.data.sort}}: {{vm.data.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" class=\"ng-scope layout-row\"><div flex-gt-sm=\"100\" \nflex=\"100\"><iframe ng-if=\"vm.previous_question_file\" ng-src=\"{{vm.previous_question_file}}\" \nstyle=\"width:100%; height:100vh\" frameborder=\"0\"></iframe></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/emp-assessment/emp-assessment.html","<div class=\"page-layout simple tabbed left-sidenav\" layout=\"row\"><div flex ng-if=\"vm.is_completed\" layout=\"column\" \nng-cloak><md-toolbar class=\"md-warn\"><div class=\"md-toolbar-tools\"><h2 class=\"md-flex\">\nYou have completed this assessment</h2></div></md-toolbar><md-content flex layout-padding><table class=\"simple\" \nstyle=\"width: 100%\"><thead><tr><th>No</th><th>Section / Questions</th><th>Answer</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.answers track by $index\"><td>{{$index + 1}}</td><td>{{ls.questions_name}}</td><td \nng-if=\"ls.type === \'freetext\'\" ng-bind-html=\"ls.answer\">{{ls.answer}}</td><td ng-if=\"ls.type === \'choice\'\"><md-list \nclass=\"md-dense\" flex><md-list-item ng-repeat=\"nc in ls.answer track by $index\" style=\"min-height: 23px; height: 23px\">\nJawaban soal no. {{nc.question}}: {{nc.answer}}</md-list-item></md-list></td></tr></tbody></table></md-content></div>\n<div ng-if=\"!vm.is_completed\" class=\"content\" flex ms-scroll layout=\"column\"><div \nstyle=\"position: absolute; right: 50%; margin: 7px 7px 0px 0px\"><md-button style=\"padding-top:7px\" ng-if=\"!vm.isFull\" \nng-click=\"vm.toggleHide(); vm.isFull = true;\" class=\"md-fab md-mini md-orange-800-bg\" aria-label=\"Hide Form\"><i \nclass=\"icon-fullscreen grey-50-fg\"></i></md-button><md-button style=\"padding-top:7px\" ng-if=\"vm.isFull\" \nng-click=\"vm.toggleShow(); vm.isFull = false;\" class=\"md-fab md-mini md-orange-800-bg\" aria-label=\"Show Form\"><i \nclass=\"icon-fullscreen-exit grey-50-fg\"></i></md-button></div><div layout=\"row\"><md-button layout=\"column\" \nng-if=\"vm.parent_question_file\" class=\"md-primary md-raised demo-dialog-open-button\" \nng-click=\"vm.showParentQuestion($event)\">Section 1</md-button><md-button \nng-repeat=\"p in vm.question.previous_question\" layout=\"column\" ng-if=\"vm.question.previous_question\" \nclass=\"md-primary md-raised demo-dialog-open-button\" ng-click=\"vm.showPreviousQuestion($event, p)\">Section {{p.sort}}\n</md-button></div><iframe ng-if=\"vm.question_file\" ng-src=\"{{vm.question_file}}\" style=\"width:100%; height:100vh\" \nframeborder=\"0\"></iframe><div ng-if=\"!vm.question_file && !vm.question\">No assessment available for you</div></div>\n<md-sidenav ng-if=\"vm.question.count > 1\" class=\"content center\" md-is-open=\"true\" md-disable-backdrop \nmd-whiteframe=\"4\" flex ms-scroll layout=\"column\" md-component-id=\"right\" style=\"min-width: 50%\"><div flex \nclass=\"header md-green-800-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Section {{vm.question.sort}}: {{vm.question.name}}</span>\n</div></div><div flex layout=\"column\"><form id=\"frmAnswersChoice\" name=\"frmAnswersChoice\" method=\"post\" novalidate \nng-submit=\"vm.saveAssessment($event, frmAnswersChoice)\"><div flex><md-list class=\"md-dense\" flex><md-list-item \nng-repeat=\"n in vm.answersChoiceList track by $index\">Jawaban Soal No. {{$index + 1}}: <span style=\"margin-left: 20px\">\n<md-radio-group ng-model=\"n.answer\" name=\"jawaban_{{$index}}\" required layout=\"row\"><md-radio-button value=\"A\" \nclass=\"md-primary\">A</md-radio-button><md-radio-button value=\"B\" class=\"md-primary\">B</md-radio-button>\n</md-radio-group></span></md-list-item></md-list></div><div flex layout=\"column\" class=\"center end\"><div layout=\"row\">\n<md-button flex=\"90\" ng-disabled=\"frmAnswersChoice.$invalid\" ng-click=\"vm.saveAnswerChoice($event)\" \nclass=\"md-raised md-primary\">Save & Next</md-button><md-button flex=\"20\" ng-click=\"vm.setToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\">Reload Token</md-button></div><div style=\"height: 20px\"></div></div></form>\n</div></md-sidenav><md-sidenav ng-if=\"!vm.is_completed && vm.question.count === \'1\'\" class=\"content center\" \nmd-is-open=\"true\" md-disable-backdrop md-whiteframe=\"4\" flex ms-scroll layout=\"column\" md-component-id=\"right\" \nstyle=\"min-width: 50%\"><div class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\n<span class=\"h2\">Section {{vm.question.sort}}: {{vm.question.name}}</span></md-subheader><div flex ms-scroll \nlayout=\"column\"><div flex=\"90\" ms-scroll><md-tabs md-selected=\"selectedIndex\" md-autoselect md-swipe-content \nmd-dynamic-height md-border-bottom><md-tab ng-repeat=\"list in vm.answerList\" label=\"Answer {{($index + 1)}}\"><form \nid=\"frmAnswers_{{$index}}\" name=\"frmAnswers[$index]\" method=\"post\" novalidate \nng-submit=\"vm.saveAssessment($event, frmAnswers[$index])\"><div style=\"margin-top: 10px\"><md-button \nng-disabled=\"frmAnswers[$index].$invalid\" ng-click=\"vm.submitAnswer($event, list)\" class=\"md-raised md-primary\">Submit\n</md-button><span ng-if=\"vm.autosave_is_well\" class=\"green-300-fg\"><md-icon md-font-icon=\"icon-backup-restore\" \nclass=\"icon green-300-fg small\"></md-icon><small>Autosave is successfully.</small></span> <span \nng-if=\"!vm.autosave_is_well\" class=\"red-300-fg\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"icon red-300-fg\">\n</md-icon><small>Autosave is failed.</small></span><md-button ng-if=\"$index > 0\" \nng-click=\"vm.deleteAnswer($event, list)\" class=\"md-raised red-700-bg grey-50-fg\" style=\"float: right\">Delete\n</md-button></div><div style=\"padding: 7px\"><textarea rows=\"15\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"list.answer\" \nrequired></textarea></div></form></md-tab></md-tabs></div><div flex=\"10\" layout=\"column\" class=\"center end\"><div \nlayout=\"row\"><md-button flex ng-if=\"vm.question_file && vm.question\" ng-disabled=\"frmAnswers[0].$invalid\" \nng-click=\"vm.saveAnswer($event)\" class=\"md-raised md-primary\">Save & Next</md-button><md-button \nng-click=\"vm.setToken()\" class=\"md-blue-300-bg md-raised white-fg\">Reload Token</md-button><md-button \nng-if=\"!vm.question_file\" disabled=\"disabled\" class=\"md-raised md-primary btn-ui-serif\">Save & Next</md-button></div>\n</div></div></div></md-content></div></md-sidenav><form style=\"display: none\" id=\"frmAnswersTemporary\" \nname=\"frmAnswersTemporary\" method=\"post\" novalidate ng-submit=\"vm.setTemporary($event, frmAnswersTemporary)\"></form>\n</div>");
$templateCache.put("app/main/emp-category/emp-category.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EMPCATEGORY\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.newProcess($event)\"><md-icon md-font-icon=\"icon-pencil\" style=\"font-size: 15px\"></md-icon><span><span \ntranslate=\"UMUT.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon>\n<span><span translate=\"UMUT.MENU.UPLOAD\"></span></span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-collapse=\"collapseData()\" on-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\">\n</ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" ng-click=\"vm.upload(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"UMUT.MENU.UPLOAD\"></span></md-button></md-menu-item><md-menu-item><span><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></span></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.NIK\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.NAME\"></span></span></th><th width=\"5%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.TYPE\"></span></span></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-dblclick=\"vm.edit($event,item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox\n aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.nik}}</td><td class=\"\">\n{{item.name}}</td><td class=\"text-center\">{{item.type}}</td><td class=\"text-center\">{{item.effective_date}}</td></tr>\n<tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"13\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/emp-category/new-emp-category.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"25\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" ng-submit=\"vm.saveData($event,basicForm)\" novalidate flex>\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.EMPCATEGORY\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout=\"column\"><md-autocomplete style=\"margin-top:10px\" flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedEmployee(item)\" \nmd-items=\"item in vm.lookupEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"item.nik + \' - \' + item.fullname\">{{item.nik + \' - \' + item.fullname}}</span></md-item-template>\n</md-autocomplete><md-input-container flex><md-label>Type</md-label><md-select ng-model=\"vm.Form.objForm.type\" \nname=\"type\" required><md-option ng-repeat=\"ls in vm.listType\" value=\"{{ls.id}}\" \nstyle=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">{{ls.description}}</md-option></md-select><div \nng-messages=\"basicForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Type </span><span \ntranslate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container><md-label><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></md-label><input type=\"date\" name=\"effective\" \nng-model=\"vm.Form.objForm.effective\" ng-change=\"vm.selectedEffectiveDate()\" required><div \nng-messages=\"basicForm.effective.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span> <span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-hue-1 md-primary\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/emp-category/upload-form.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.EMPCATEGORY\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset><legend><span translate=\"MENU.MAIN.EMPCATEGORY\"></span> - <span \ntranslate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFile\" nv-file-select \nuploader=\"vm.FileUploader\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUploader.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-primary md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/emp-sales-code/emp-sales-code-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.EMPSALESCODE\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.NIK\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"KPI.LABEL.SALESCODE\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.sales_code\" \nname=\"sales_code\" required><div ng-messages=\"frmBT.sales_code.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.SALESCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" md-max-date=\"vm.Form.objForm.end_date\" \nname=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"KPI.LABEL.ENDDATE\"></label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.Form.objForm.start_date\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\"></md-datepicker><div \nng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDDATE\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/emp-sales-code/emp-sales-code.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EMPSALESCODE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"KPI.LABEL.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" md-max-date=\"vm.end_date\" \nname=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.ENDDATE\">\n</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\">\n</md-datepicker><div ng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon\n hide class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NIK\"></span>/<span translate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.SALESCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.STARTDATE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.ENDDATE\"></span></span></th><th width=\"5%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.no}}</td><td \nclass=\"\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.nik}} / {{item.name}}</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.sales_code}}</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.start_date}}</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.end_date}}</td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"ACTION.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/emp-sales-code/view-detail.html","<md-dialog aria-label=\"Form View Detail\" flex-md=\"80\" flex-gt-md=\"70\"><form ng-cloack name=\"fReply\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2><span translate=\"HCTICKET.MENU.DETAIL\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout-padding flex><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.isClosed==1\" style=\"margin-top:10px;margin-bottom:10px\" flex layout layout-align=\"center center\" \nlayout-padding><span>{{vm.message}}</span></md-whiteframe><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"MENU.MAIN.CB.TITLE\"></span></label><input type=\"text\" ng-model=\"vm.title\" name=\"title\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.TYPE\"></span></label><input \ntype=\"text\" ng-model=\"vm.type\" name=\"title\" ng-disabled=\"true\"></md-input-container><md-input-container \nng-if=\"vm.isAdmin\" flex><label><span translate=\"MENU.MAIN.ERRORTYPE\"></span></label><input type=\"text\" \nng-model=\"vm.errorType\" name=\"title\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.STATUS\"></span></label><input type=\"text\" \nng-model=\"vm.ticketStatus\" name=\"title\" ng-disabled=\"true\"></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.ESTIMATION\"></span></label><input type=\"text\" ng-model=\"vm.estimation\" name=\"estimation\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"HCTICKET.MENU.REQUESTEDBY\"></span></label><input type=\"text\" ng-model=\"vm.requestedBy\" name=\"requestedBy\" \nng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"!vm.isRequested && vm.isAdmin\" flex><label><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span></label><input type=\"text\" ng-model=\"vm.company\" name=\"company\" \nng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"!vm.isRequested && vm.isAdmin\" flex><label><span \ntranslate=\"PAYROLL.MENU.AREA\"></span></label><input type=\"text\" ng-model=\"vm.area\" name=\"area\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex><label><span translate=\"HCTICKET.MENU.REQUESTEDAT\"></span></label><input \ntype=\"text\" ng-model=\"vm.requestedAt\" name=\"requestedAt\" ng-disabled=\"true\"></md-input-container></div><label \nclass=\"text-grey\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></label><div layout=\"row\"><fieldset flex><div \nclass=\"text-grey\" ng-bind-html=\"vm.description\" class=\"alert-information\"></div></fieldset></div><label \nng-if=\"!vm.isRequested && vm.isAdmin\" class=\"text-grey\"><span translate=\"HCTICKET.MENU.SOLUTION\"></span></label><div \nng-if=\"!vm.isRequested && vm.isAdmin\" layout=\"row\"><fieldset flex><div class=\"text-grey\" ng-bind-html=\"vm.solutions\" \nclass=\"alert-information\"></div></fieldset></div><fieldset style=\"margin-top: 30px;background-color: aliceblue\" flex>\n<legend style=\"background-color: grey; font-weight: bold; color:white\"><span translate=\"MENU.MAIN.DISCUSSION\"></span>\n</legend><div ng-repeat=\"ls in vm.ticketRespons\"><div layout=\"row\"><fieldset class=\"mg-10\" \nng-style=\"{\'background-color\': ls.bColor}\" flex><legend ng-style=\"{\'background-color\': ls.color}\" align=\"{{ls.align}}\">\n{{ls.username}} - {{ls.timestamp}}</legend><div class=\"text-grey\" style=\"color: black\" ng-bind-html=\"ls.respons\" \nclass=\"alert-information\"></div><br ng-if=\"ls.filename\"><br ng-if=\"ls.filename\"><a \nng-if=\"ls.filename&&ls.format==\'img\'\" ng-click=\"vm.viewFile($event,ls.filename)\"><span class=\"show-file\">View File\n</span></a> <a ng-if=\"ls.filename&&ls.format==\'file\'\" ng-click=\"vm.downloadDoc($event,ls.filename)\"><span \nclass=\"show-file\">Download</span></a></fieldset></div></div><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar upper-case-header\" ms-responsive-table><tbody><tr \nclass=\"md-table-content-row\"><td><textarea rows=\"7\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.answer\" \nrequired=\"true\"></textarea></td></tr></tbody></table><br><div layout=\"row\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked\" ng-click=\"vm.checkIsNeddFile()\" ng-model=\"vm.isNeddUploadFile\" aria-label=\"\"><span \ntranslate=\"HCTICKET.MENU.NEEDUPLOAD\"></span></md-checkbox></div><br><md-input-container ng-if=\"vm.isChecked\" \nmd-no-float class=\"md-block\"><input required=\"true\" type=\"file\" id=\"uploadData\" nv-file-select required \nuploader=\"vm.FileUploader\" \noptions=\"{ formData: [{\n                            action: \'uploadReply\',\n                            ticket_id: vm.id,\n                            title: vm.title,\n                            mailTo: vm.mailTo,\n                            answer: vm.answer}] }\">\n</md-input-container><br><br><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.showMessage\" class=\"fade\"><ms-widget-front class=\"red-400-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.alertMessage}}</p></ms-widget-front></ms-widget>\n<md-button ng-if=\"!vm.isChecked\" type=\"button\" ng-click=\"vm.saveData($event, fReply)\" \nclass=\"md-raised md-mini md-primary\" ng-disabled=\"fReply.$invalid || fReply.$pristine\" aria-label=\"Submit\" \ntranslate=\"MENU.MAIN.REPLY\">Reply</md-button><md-button ng-if=\"vm.isChecked\" type=\"button\" \nng-click=\"vm.upload(fReply)\" class=\"md-raised md-mini md-primary\" ng-disabled=\"fReply.$invalid || fReply.$pristine\" \naria-label=\"Submit\" translate=\"MENU.MAIN.REPLY\">Reply</md-button><md-button type=\"button\" \nng-click=\"vm.closeTicket($event, fReply)\" class=\"md-raised md-mini md-warn\" ng-disabled=\"vm.isClosed==\'1\'\" \naria-label=\"Close\" translate=\"MENU.MAIN.CLOSETICKET\">Close Ticket</md-button><md-button \nng-if=\"vm.isAdmin&&vm.isSysdev==\'0\'&&vm.status==\'1\'\" class=\"md-mini md-primary\" \nng-click=\"vm.delegateToSysdev(vm.refData,\'1\')\"><span translate=\"PAYROLL.MENU.DELEGATETOSYSDEV\"></span></md-button>\n<md-button ng-if=\"vm.isAdmin&&vm.isSysdev==\'1\'&&vm.status==\'1\'\" class=\"md-mini md-primary\" \nng-click=\"vm.delegateToSysdev(vm.refData,\'0\')\"><span translate=\"PAYROLL.MENU.CANCELDELEGATION\"></span></md-button><span\n ng-if=\"vm.isAdmin&&vm.isSysdev==\'1\'&&vm.status!=\'1\'\" translate=\"PAYROLL.MENU.ISSYSDEV\"></span></div></fieldset>\n</md-dialog-content><hr></form></md-dialog>");
$templateCache.put("app/main/emp-survey/emp-survey-disclaimer.html","<md-dialog class=\"md-nabati1-theme\" flex=\"70\" aria-label=\"Survey Disclaimer\"><form \nclass=\"md-inline-form popup-input-form\" ng-cloak><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Survey Disclaimer {{vm.language}}</h2><span flex></span></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><div><h1>\nMohon Maaf, Mohon luangkan waktu anda untuk mengisi survey ini. Terima Kasih</h1><h2>EMPLOYEE SATISFACTION SURVEY</h2>\n<pre>\n              - Apa itu?\n                ESS adalah survei yang dilakukan untuk mengukur kepuasan karyawan terhadap layanan yang diberikan oleh HC\n              - Untuk apa survei ini?\n                Untuk meningkatkan service level dari HC berdasarkan seberapa penting layanan tersebut terhadap pekerjaan anda\n              - Bagaimana saya berkontribusi?\n                Dengan mengisi survei sejujur mungkin dan berkontribusi untuk HC yang lebih baik\n          \n</pre></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-input-container \nclass=\"md-block md-input-has-value\"><md-buttons-toggle-potential items=\"languageList\" ng-model=\"vm.language\" \nselected-class=\"md-accent\"></md-buttons-toggle-potential></md-input-container><div flex></div><md-button \nng-click=\"confirmDisclaimer(false)\">{{(vm.language ==\'ID\')?\'Batal\':\'Cancel\'}}</md-button><md-button \nclass=\"md-raised md-primary btn-ui-serif\" ng-click=\"confirmDisclaimer(true)\">&nbsp;&nbsp; ISI SURVEY &nbsp;&nbsp;\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/emp-survey/emp-survey-from-login.html","<md-dialog class=\"md-nabati1-theme\" flex=\"70\" aria-label=\"Survey Disclaimer\"><form \nclass=\"md-inline-form popup-input-form\" ng-cloak><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Survey Disclaimer {{vm.language}}</h2><span flex></span></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><div><h1>\nMohon Maaf, Mohon luangkan waktu anda untuk mengisi survey ini. Terima Kasih</h1><h2>EMPLOYEE SATISFACTION SURVEY</h2>\n<pre>\n              - Apa itu?\n                ESS adalah survei yang dilakukan untuk mengukur kepuasan karyawan terhadap layanan yang diberikan oleh HC\n              - Untuk apa survei ini?\n                Untuk meningkatkan service level dari HC berdasarkan seberapa penting layanan tersebut terhadap pekerjaan anda\n              - Bagaimana saya berkontribusi?\n                Dengan mengisi survei sejujur mungkin dan berkontribusi untuk HC yang lebih baik\n          \n</pre></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-input-container \nclass=\"md-block md-input-has-value\"><md-buttons-toggle-potential items=\"languageList\" ng-model=\"vm.language\" \nselected-class=\"md-accent\"></md-buttons-toggle-potential></md-input-container><div flex></div><md-button \nclass=\"md-raised md-primary btn-ui-serif\" ng-click=\"confirmDisclaimer(true)\">&nbsp;&nbsp; ISI SURVEY &nbsp;&nbsp;\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/emp-survey/emp-survey.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Employee Satisfaction Survey</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><div id=\"contentSetPotentialMember\"><div class=\"\" id=\"inputView\" \nlayout=\"column\"><div layout=\"row\"><div flex=\"\" layout=\"column\" style=\"padding: 7px\"><div layout=\"row\"><div flex=\"20\">\n<b>Nik</b></div><div flex=\"50\"><b>: {{vm.profile[0].nik}}</b></div></div><div layout=\"row\"><div flex=\"20\"><b>Name</b>\n</div><div flex=\"50\"><b>: {{vm.profile[0].title + \'. \' + vm.profile[0].first_name + \' \' + vm.profile[0].last_name}}</b>\n</div></div></div><div flex=\"20\" id=\"input_button_toggle\" layout=\"row\"></div><div flex layout=\"row\" \nng-if=\"vm.surveys[0].timestamp\"><h4 class=\"green-700-fg\">The survey was submitted on {{vm.surveys[0].timestamp}}</h4>\n</div></div><ms-widget class=\"fade\" flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\"><ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p \nclass=\"form-messages\"><md-icon class=\"s16\" md-font-icon=\"icon-alert\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front>\n</ms-widget><table class=\"simple\" id=\"inputTable\" ms-responsive-table=\"\" ng-if=\"vm.surveys[0].timestamp\"><thead><tr><th\n rowspan=\"2\">No</th><th rowspan=\"2\">Statement</th><th rowspan=\"2\">Score</th></tr></thead><tbody><tr \nng-repeat=\"input in vm.surveys\"><td align=\"center\">{{($index + 1)}}</td><td><div ng-if=\"vm.language !== \'ID\'\">\n{{input.statement_en}}</div><div ng-if=\"vm.language === \'ID\'\">{{input.statement}}</div></td><td \nstyle=\"text-align:center; white-space: nowrap\">{{input.score}}</td></tr></tbody></table><ms-form-wizard flex=\"\" \nng-if=\"!vm.surveys[0].timestamp && vm.isConfirmDisclaimer\"><md-tabs md-center-tabs=\"true\" md-dynamic-height=\"\" \nmd-selected=\"msWizard.selectedIndex\"><md-tab ng-disabled=\"wizardStep[($index + 1)].$invalid\" \nng-repeat=\"input in vm.listInput\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-class=\"{\'grey-100-bg\':msWizard.selectedIndex !== $index}\" \nng-if=\"wizardStep[$index].$invalid\">{{$index + 1}} </span><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep[$index].$valid\"><i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">\nQuestion {{$index + 1}}</span></span></md-tab-label><md-tab-body><form class=\"md-inline-form\" \nid=\"wizardStep_{{$index}}\" ms-form-wizard-form=\"\" name=\"wizardStep[$index]\" \nng-submit=\"vm.saveData($event, wizardStep[$index])\" novalidate=\"\"><div flex=\"\" layout=\"columnt\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\"><h2><blockquote>\n{{$index + 1}}. {{(vm.language === \'ID\')?input.statement:input.statement_en}}</blockquote></h2></md-input-container>\n</div><div flex=\"\" layout=\"column\" layout-gt-xs=\"row\"><fieldset flex=\"100\" flex-padding=\"\" layout=\"row\" \nstyle=\"margin-bottom: 10px\"><legend>\n{{(vm.language === \'ID\')?\'Berikan score anda terhadap pernyataan diatas\':\'Give your score for the statement stated\'}}\n</legend><div layout=\"row\"><span flex=\"20\" class=\"text-center\">Sangat Tidak Setuju </span><span flex \nclass=\"text-center\"><span style=\"font-size: 20px\">&#8826;</span>\n&ndash;&ndash;&ndash;&ndash;&ndash;&ndash;&ndash;&ndash;<span style=\"font-size: 20px\">&#8827;</span></span> <span \nflex=\"20\" class=\"text-left\">Sangat Setuju Sekali</span></div><md-input-container flex=\"100\" \nstyle=\"margin-bottom: 30px\"><md-radio-group ng-model=\"input.agreement\" ng-change=\"vm.setAgreement(input)\" \naria-label=\"Select an option\" required=\"required\"><md-radio-button style=\"margin-left: 60px\" \nng-repeat=\"r in vm.statementAgreementValues\" value=\"{{r.value}}\">{{r.label}}</md-radio-button></md-radio-group><div \nng-messages=\"wizardStep[$index].agreement.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAgreement field is required</span></div></div></md-input-container><md-input-container flex=\"100\"><textarea \nname=\"agreement_remarks\" ng-model=\"input.agreement_remarks\" placeholder=\"Remarks...\" rows=\"2\">\n                                                  </textarea></md-input-container></fieldset></div></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!vm.surveys[0].timestamp\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\">Previous</md-button><div class=\"steps\"><span \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\" ng-repeat=\"form in msWizard.forms\"></span></div>\n<md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-disabled=\"msWizard.currentStepInvalid()\" \nng-hide=\"msWizard.isLastStep()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.sendForm($event); msWizard.resetForm();\" ng-disabled=\"msWizard.formsIncomplete()\" \nng-show=\"msWizard.isLastStep()\">Finish & Send</md-button><md-button class=\"md-raised md-default-theme\" \nng-click=\"vm.setToken();\" ng-show=\"msWizard.isLastStep()\">Reload Token</md-button><input ng-model=\"vm.islastStep\" \nng-value=\"{{msWizard.isLastStep()}}\" type=\"hidden\"></div></ms-form-wizard><div \nng-if=\"!vm.isConfirmDisclaimer && vm.showinfoStatusDisclaimer\">\n{{(vm.language === \'ID\')?\'Terima kasih, mungkin Anda akan mengikuti survey ini di lain waktu.\':\'Thank you, maybe you will follow this survey later.\'}}\n</div></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/emp-surveys/emp-surveys-summary.html","<md-dialog aria-label=\"{{vm.title}} Competency Review\" flex=\"70\" id=\"formCompetencyReview\"><form ng-cloak \nname=\"formCompetencyReview\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,formCompetencyReview)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Employee Satisfaction Survey Summary</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><input type=\"hidden\" \nng-model=\"vm.Form.objForm.job_code\"> <input type=\"hidden\" ng-model=\"vm.Form.objForm.job_code_profile_id\"> <input \ntype=\"hidden\" ng-model=\"vm.Form.objForm.emp_nik\"><div layout=\"row\" class=\"ng-scope layout-row\"><div flex><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th align=\"center\">No.</th><th \nalign=\"center\">Statements</th><th align=\"center\">SA</th><th align=\"center\">A</th><th align=\"center\">D</th><th \nalign=\"center\">SD</th><th align=\"center\">VI</th><th align=\"center\">I</th><th align=\"center\">NI</th><th align=\"center\">\nVNI</th></tr></thead><tbody><tr ng-repeat=\"list in vm.listSummary\"><td align=\"center\">{{$index + 1}}</td><td>\n{{list.statement}}</td><td align=\"center\">{{list.SA}}</td><td align=\"center\">{{list.A}}</td><td align=\"center\">\n{{list.D}}</td><td align=\"center\">{{list.SD}}</td><td align=\"center\">{{list.VI}}</td><td align=\"center\">{{list.I}}</td>\n<td align=\"center\">{{list.NI}}</td><td align=\"center\">{{list.VNI}}</td></tr></tbody></table></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-blue-grey-300-bg md-raised white-fg\" \nng-click=\"vm.cancel()\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/emp-surveys/emp-surveys.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Employee Satifaction Survey</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\">\n<div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label><md-select \nng-disabled=\"vm.group === \'110\' || vm.group === \'116\'\" ng-change=\"vm.loadDataDivision(vm.bu)\" ng-model=\"vm.bu\">\n<md-option ng-value=\"\">All</md-option><md-option ng-repeat=\"bu in vm.listBu\" ng-value=\"bu.id\">{{bu.description}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Division</label>\n<md-select ng-change=\"vm.loadDataDepartment(vm.divisi)\" ng-model=\"vm.divisi\"><md-option ng-value=\"\">All</md-option>\n<md-option ng-repeat=\"divisi in vm.listDivisi\" ng-value=\"{{divisi.id}}\">{{divisi.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Department</label><md-select \nng-change=\"vm.loadData(1)\" ng-model=\"vm.department\"><md-option ng-value=\"\">All</md-option><md-option \nng-repeat=\"department  in vm.listDepartment\" ng-value=\"{{department.id}}\">{{department.description}}</md-option>\n</md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div>\n</form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container\n hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.showSummary($event)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Summary</md-tooltip><md-icon md-font-icon=\"icon-clipboard-text\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Summary</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" \nng-click=\"vm.exportToExcel($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Download</md-tooltip>\n<md-icon md-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span>Download</span>\n</md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th><div class=\"table-header\"></div></th><th width=\"5%\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">NIK</span></div></th>\n<th><div class=\"table-header\"><span class=\"column-title\">EMPLOYEE NAME</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\">COMPLETED</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">\nDATE JOIN</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">#</span></div></th></tr></thead>\n<tbody><tr ng-dblclick=\"vm.editData(ls.id)\" ng-repeat=\"ls in vm.DataTable.list\"><td></td><td>{{ $index + 1 }}</td><td>\n{{ ls.nik }}</td><td>{{ ls.title + \'. \' + ls.firstName + \' \' + ls.lastName | uppercase }}</td><td>\n{{ ls.survey_issued }}</td><td>{{ ls.dateJoin }}</td><td><md-button aria-label=\"View Surveys\" class=\"md-icon-button\" \nng-click=\"vm.setView(ls.nik)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>View Surveys</span></md-tooltip></md-button></td></tr></tbody></table>\n<div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employeereport/employeereport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.EMPLOYEEREPORT.HEADER\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExporttoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"MENU.EMPLOYEEREPORT.EFFECTIVE_DATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" \nname=\"effective_date\" ng-model=\"vm.effective_date\" required></md-datepicker><div \nng-messages=\"SalcomForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.EMPLOYEEREPORT.EFFECTIVE_DATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.COMPANY\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"{{ \'PAYROLL.MENU.SEARCH\' | translate }}\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.area.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.AREA\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><md-button \ntype=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee-exchange/employee-exchange-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.EMPLOYEEEXCHANGE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.BANUMBER\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.ba_no\" name=\"ba_no\" required><div \nng-messages=\"frmBT.ba_no.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.BANUMBER\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"KPI.LABEL.EFFECTIVEDATE\"></label><md-datepicker md-hide-icons=\"calendar\" \nname=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"frmBT.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.EFFECTIVEDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><div layout=\"column\" flex=\"50\"><fieldset style=\"min-height: 450px\">\n<legend><span translate=\"KPI.LABEL.KARYAWAN\"></span> 1</legend><br><div layout-gt-sm=\"row\"><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.AREA\"></span></label><md-select ng-model=\"vm.subArea1\" \nname=\"subArea1\" ng-change=\"vm.setChangeArea1()\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"subArea1\"><md-option value=\"{{ls.subarea_id}}\" \nng-repeat=\"ls in vm.listSubArea | filter:vm.searchTerm\">{{ls.description | uppercase}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmBT.subArea1.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.AREA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Sub Area Required.</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm><label>NIK</label>\n<md-autocomplete ng-disabled=\"vm.changeArea1==1\" name=\"nik1\" \nstyle=\"margin-top: 3px; background: transparent;\n                      border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nikParam\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" md-min-length=\"2\" \nng-model=\"vm.Form.objForm.nikParam\" md-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nikParam)\" \nrequired><md-item-template><span md-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete><div ng-messages=\"frmBT.nik1.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.showData\"><md-input-container flex><label><span translate=\"KPI.LABEL.AREA\"></span></label><input \nng-model=\"vm.areaName1\" ng-readonly=\"true\" placeholder=\"{{ \'KPI.LABEL.AREA\' | translate}}\" name=\"areaName1\">\n</md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.showData\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.COSTCENTRECNB\"></span></label><input ng-model=\"vm.costCenterCnb1\" ng-readonly=\"true\" \nplaceholder=\"{{ \'KPI.LABEL.COSTCENTRECNB\' | translate}}\" name=\"costCenterCnb1\"></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.showData\"><md-input-container flex><label><span translate=\"KPI.LABEL.COSTCENTRENONCNB\">\n</span></label><input ng-model=\"vm.costCenterNonCnb1\" ng-readonly=\"true\" \nplaceholder=\"{{ \'KPI.LABEL.COSTCENTRENONCNB\' | translate}}\" name=\"costCenterNonCnb1\"></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.showData\"><md-input-container flex><label><span translate=\"UMUT.MENU.JOBTITLE\"></span>\n</label><input ng-model=\"vm.jobTitle1\" ng-readonly=\"true\" placeholder=\"{{ \'UMUT.MENU.JOBTITLE\' | translate}}\" \nname=\"jobTitle1\"></md-input-container></div></fieldset></div><div layout=\"column\" flex=\"50\"><fieldset \nstyle=\"min-height: 450px\"><legend><span translate=\"KPI.LABEL.KARYAWAN\"></span> 2</legend><br><div layout-gt-sm=\"row\">\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.AREA\"></span></label><md-select \nng-model=\"vm.subArea2\" name=\"subArea2\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.setChangeArea2()\" \nng-disabled=\"vm.changeArea11==1\" required><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"subArea2\"><md-option \nvalue=\"{{ls.subarea_id}}\" ng-repeat=\"ls in vm.listSubArea2 | filter:vm.searchTerm\">{{ls.description | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.subArea2.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.AREA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Sub Area Required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm><label>NIK</label>\n<md-autocomplete ng-disabled=\"vm.changeArea2\" name=\"nik2\" \nstyle=\"margin-top: 3px; background: transparent;\n                      border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nikParam2\" md-search-text=\"vm.searchStringNik2\" \nmd-items=\"item in vm.getEmployeeNik2(vm.searchStringNik2)\" md-item-text=\"item.fullname\" md-min-length=\"2\" \nng-model=\"vm.Form.objForm.nikParam2\" md-selected-item-change=\"vm.selectedItemChangedNik2(vm.Form.objForm.nikParam2)\" \nrequired><md-item-template><span md-highlight-text=\"vm.searchStringNik2\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete><div ng-messages=\"frmBT.nik2.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.showData2\"><md-input-container flex><label><span translate=\"KPI.LABEL.AREA\"></span></label><input \nng-model=\"vm.areaName2\" ng-readonly=\"true\" placeholder=\"{{ \'KPI.LABEL.AREA\' | translate}}\" name=\"areaName2\">\n</md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.showData2\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.COSTCENTRECNB\"></span></label><input ng-model=\"vm.costCenterCnb2\" ng-readonly=\"true\" \nplaceholder=\"{{ \'KPI.LABEL.COSTCENTRECNB\' | translate}}\" name=\"costCenterCnb2\"></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.showData2\"><md-input-container flex><label><span translate=\"KPI.LABEL.COSTCENTRENONCNB\">\n</span></label><input ng-model=\"vm.costCenterNonCnb2\" ng-readonly=\"true\" \nplaceholder=\"{{ \'KPI.LABEL.COSTCENTRENONCNB\' | translate}}\" name=\"costCenterNonCnb2\"></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.showData2\"><md-input-container flex><label><span translate=\"UMUT.MENU.JOBTITLE\"></span>\n</label><input ng-model=\"vm.jobTitle2\" ng-readonly=\"true\" placeholder=\"{{ \'UMUT.MENU.JOBTITLE\' | translate}}\" \nname=\"jobTitle2\"></md-input-container></div></fieldset></div></div><label class=\"text-grey\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm><div \nstyle=\"padding: 2px\"><textarea rows=\"2\" ng-model=\"vm.Form.objForm.description\" ng-required=\"true\"></textarea></div><div\n ng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><label class=\"text-grey\"><span translate=\"KPI.LABEL.CHOOSEFILE\"></span></label><div \nlayout=\"row\"><md-input-container md-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nrequired uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n              action:\'uploadData\',\n              ba_no:vm.Form.objForm.ba_no,\n              effective_date:vm.Form.objForm.effective_date,\n              description:vm.Form.objForm.description,\n              nik1:vm.Form.objForm.nik1,\n              nik2:vm.Form.objForm.nik2,\n              emp_cost_center_id_old1:vm.Form.objForm.emp_cost_center_id_old1,\n              emp_cost_center_id_old2:vm.Form.objForm.emp_cost_center_id_old2,\n              emp_cost_center_id_new1:vm.Form.objForm.emp_cost_center_id_new1,\n              emp_cost_center_id_new2:vm.Form.objForm.emp_cost_center_id_new2,\n              emp_sub_area_id_old1:vm.Form.objForm.emp_sub_area_id_old1,\n              emp_sub_area_id_old2:vm.Form.objForm.emp_sub_area_id_old2,\n              emp_sub_area_id_new1:vm.Form.objForm.emp_sub_area_id_new1,\n              emp_sub_area_id_new2:vm.Form.objForm.emp_sub_area_id_new2,\n              sub_area_id_new1:vm.Form.objForm.sub_area_id_new1,\n              sub_area_id_new2:vm.Form.objForm.sub_area_id_new2,\n              ref_id_cnb1:vm.refIdCnb1,\n              ref_id_noncnb1:vm.refIdNonCnb1,\n              cnb1:vm.costCenterCnb1,\n              noncnb1:vm.costCenterNonCnb1,\n              ref_id_cnb2:vm.refIdCnb2,\n              ref_id_noncnb2:vm.refIdNonCnb2,\n              cnb2:vm.costCenterCnb2,\n              noncnb2:vm.costCenterNonCnb2\n            }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee-exchange/employee-exchange.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EMPLOYEEEXCHANGE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container \nclass=\"width-filter\"><label translate=\"KPI.LABEL.BANUMBER\"></label><input type=\"text\" ng-model=\"vm.ba_no\" name=\"ba_no\">\n<div ng-messages=\"frmBT.ba_no.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.BANUMBER\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"width-filter\"><label translate=\"KPI.LABEL.EFFECTIVEDATE\"></label><md-datepicker md-hide-icons=\"calendar\" \nname=\"effective_date\" ng-model=\"vm.effective_date\"></md-datepicker><div ng-messages=\"frmBT.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container layout=\"column\" \nstyle=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span><span translate=\"PAYROLL.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.BANUMBER\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span><span \ntranslate=\"KPI.LABEL.KARYAWAN\"></span> 1</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>\n<span translate=\"KPI.LABEL.KARYAWAN\"></span> 2</span></span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></span></th><th class=\"text-center\" width=\"10%\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.CREATEDAT\"></span></span></th><th class=\"text-center\" \nwidth=\"10%\"><span class=\"column-title\"><span>FILE</span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" ng-dblclick=\"vm.viewDetail($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.ba_no}}</td><td class=\"\">{{item.nik1}} <span \ntranslate=\"KPI.LABEL.TOAREA\">to Area</span> {{item.area1}}</td><td class=\"\">{{item.nik2}} <span \ntranslate=\"KPI.LABEL.TOAREA\">to Area</span> {{item.area2}}</td><td class=\"text-center\">{{item.effective_date}}</td><td \nclass=\"text-center\">{{item.created_at}}</td><td class=\"text-center\"><md-button \nng-if=\"item.filename&&item.format==\'img\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.viewFile($event, item.filename)\"><div layout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\">\n</span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button ng-if=\"item.filename&&item.format==\'file\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.downloadDoc($event, item.filename)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-menu-align-target md-font-icon=\"icon-download\"></md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p>\n</div></md-button></td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-if=\"item.filename&&item.format==\'img\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.viewFile($event, item.filename)\"><div layout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\">\n</span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button ng-if=\"item.filename&&item.format==\'file\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.downloadDoc($event, item.filename)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-menu-align-target md-font-icon=\"icon-download\"></md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p>\n</div></md-button><md-button class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.viewDetail($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"PAYROLL.MENU.DOWNLOAD\">\n</span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"UMUT.MENU.DETAIL\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td>\n</tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee-exchange/view-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.EMPLOYEEEXCHANGE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.BANUMBER\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.ba_no\" ng-readonly=\"true\" \nname=\"ba_no\" required></md-input-container><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.EFFECTIVEDATE\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.effective_date\" \nng-readonly=\"true\" name=\"ba_no\" required></md-input-container></div><div layout=\"row\"><div layout=\"column\" flex=\"50\">\n<fieldset style=\"min-height: 450px\"><legend>Employee 1</legend><br><div layout-gt-sm=\"row\"><md-input-container flex \nflex-gt-sm><label>NIK</label><input type=\"text\" ng-model=\"vm.Form.objForm.nikParam\" ng-readonly=\"true\" name=\"ba_no\" \nrequired></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.AREA\"></span></label><input ng-model=\"vm.areaName1\" ng-readonly=\"true\" \nplaceholder=\"{{ \'KPI.LABEL.AREA\' | translate}}\" name=\"areaName1\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"KPI.LABEL.COSTCENTRECNB\"></span></label><input \nng-model=\"vm.costCenterCnb1\" ng-readonly=\"true\" placeholder=\"{{ \'KPI.LABEL.COSTCENTRECNB\' | translate}}\" \nname=\"costCenterCnb1\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.COSTCENTRENONCNB\"></span></label><input ng-model=\"vm.costCenterNonCnb1\" ng-readonly=\"true\" \nplaceholder=\"{{ \'KPI.LABEL.COSTCENTRENONCNB\' | translate}}\" name=\"costCenterNonCnb1\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"UMUT.MENU.JOBTITLE\"></span></label><input \nng-model=\"vm.jobTitle1\" ng-readonly=\"true\" placeholder=\"{{ \'UMUT.MENU.JOBTITLE\' | translate}}\" name=\"jobTitle1\">\n</md-input-container></div></fieldset></div><div layout=\"column\" flex=\"50\"><fieldset style=\"min-height: 450px\"><legend>\nEmployee 2</legend><br><div layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm><label>NIK</label><input \ntype=\"text\" ng-model=\"vm.Form.objForm.nikParam2\" ng-readonly=\"true\" name=\"ba_no\" required></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.AREA\"></span></label><input \nng-model=\"vm.areaName2\" ng-readonly=\"true\" placeholder=\"{{ \'KPI.LABEL.AREA\' | translate}}\" name=\"areaName2\">\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.COSTCENTRECNB\"></span></label><input ng-model=\"vm.costCenterCnb2\" ng-readonly=\"true\" \nplaceholder=\"{{ \'KPI.LABEL.COSTCENTRECNB\' | translate}}\" name=\"costCenterCnb2\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.COSTCENTRENONCNB\"></span></label><input \nng-model=\"vm.costCenterNonCnb2\" ng-readonly=\"true\" placeholder=\"{{ \'KPI.LABEL.COSTCENTRENONCNB\' | translate}}\" \nname=\"costCenterNonCnb2\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"UMUT.MENU.JOBTITLE\"></span></label><input ng-model=\"vm.jobTitle2\" ng-readonly=\"true\" \nplaceholder=\"{{ \'UMUT.MENU.JOBTITLE\' | translate}}\" name=\"jobTitle2\"></md-input-container></div></fieldset></div></div>\n<label class=\"text-grey\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div layout=\"row\">\n<md-input-container flex flex-gt-sm><div style=\"padding: 7px\"><textarea rows=\"2\" ng-readonly=\"true\" \nng-model=\"vm.Form.objForm.description\" ng-required=\"true\"></textarea></div></md-input-container></div><div \nlayout=\"row\"><a ng-if=\"vm.filename&&vm.format==\'img\'\" ng-click=\"vm.viewFile($event,vm.filename)\"><span \nclass=\"show-file\">View File</span></a> <a ng-if=\"vm.filename&&vm.format==\'file\'\" \nng-click=\"vm.downloadDoc($event,vm.filename)\"><span class=\"show-file\">Download</span></a></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee-exchange/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.VIEWFILE\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" \nclass=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content>\n<md-dialog-content ng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><img \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" \nsrc=\"api/upload/employee-exchange/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/hcdashboard/hcdashboard.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<md-content class=\"content md-background-bg\"><md-tabs md-dynamic-height><md-tab><md-tab-label><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon>HC Dashboard</md-tab-label><md-tab-body><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8 h3\">Human Capital Dashboard YTD 2017</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap flex><div \nlayout=\"column\" flex=\"100\"><table class=\"simple bordered\" ms-responsive-table><thead><tr><th colspan=\"2\" \nstyle=\"border-top:none\"></th><th class=\"grey-bg white-fg\" width=\"8%\">SPOT</th><th class=\"grey-bg white-fg\" width=\"8%\">\nYTD</th><th class=\"grey-bg white-fg\" width=\"8%\">TARGET</th><th class=\"grey-bg white-fg\" width=\"8%\">TREND</th></tr>\n</thead><tbody><tr><td class=\"green-fg\" style=\"font-weight:bold\">HR Digitization</td><td class=\"grey-fg\">\n3 Function (TA, Comben, PM) Go live</td><td style=\"text-align: center\">2</td><td style=\"text-align: center\">2</td><td \nstyle=\"text-align: center\">3</td><td style=\"text-align:center\"><md-icon class=\"red-fg\" md-font-icon=\"icon-trending-up\" \nclass=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">Nabati Development Center</td><td \nclass=\"grey-fg\">2 hrs / empl (annual)</td><td style=\"text-align: center\">0%</td><td style=\"text-align: center\">0%</td>\n<td style=\"text-align: center\">100%</td><td style=\"text-align:center\"><md-icon class=\"red-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">RTC N-1 &amp; Identified Key Position</td><td class=\"grey-fg\">100% by Q3 1:1</td><td \nstyle=\"text-align: center\">0%</td><td style=\"text-align: center\">0%</td><td style=\"text-align: center\">100%</td><td \nstyle=\"text-align:center\"><md-icon class=\"red-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">HR Standarization Project</td><td class=\"grey-fg\">\nCorporate HR Policies by Q4 100%</td><td style=\"text-align: center\">40%</td><td style=\"text-align: center\">40%</td><td \nstyle=\"text-align: center\">100%</td><td style=\"text-align:center\"><md-icon class=\"red-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">Employee Satisfaction Level to HC</td><td class=\"grey-fg\">Survey Result</td><td \nstyle=\"text-align: center\">0%</td><td style=\"text-align: center\">%</td><td style=\"text-align: center\">70%</td><td \nstyle=\"text-align:center\"><md-icon class=\"red-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">Headcount</td><td class=\"grey-fg\"></td><td \nstyle=\"text-align: center\">18,658</td><td style=\"text-align: center\">18,658</td><td style=\"text-align: center\"></td><td\n style=\"text-align:center\"><md-icon class=\"red-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" rowspan=\"2\" style=\"font-weight:bold\">Turn Over</td><td class=\"grey-fg\">Voluntary</td><td \nstyle=\"text-align: center\">1.99%</td><td style=\"text-align: center\">1.87%</td><td style=\"text-align: center\">5%</td><td\n style=\"text-align:center\"><md-icon class=\"green-fg\" md-font-icon=\"icon-trending-up\" class=\"icon\"></md-icon></td></tr>\n<tr><td class=\"grey-fg\">Non Voluntary</td><td style=\"text-align: center\"></td><td style=\"text-align: center\"></td><td \nclass=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" \nclass=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">Gender Ratio</td><td \nclass=\"grey-fg\">% Female</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-fg\" \nstyle=\"text-align: center\">n/a</td><td class=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">Training Hours</td><td class=\"grey-fg\">Total Training Hours of Total Employee</td><td \nclass=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td \nclass=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" \nclass=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">LTDR</td><td class=\"grey-fg\">\nLoss Time Day Rate</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-fg\" \nstyle=\"text-align: center\">n/a</td><td class=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">WF Normal Working Hours</td><td class=\"grey-fg\">in hour</td><td class=\"grey-fg\" \nstyle=\"text-align: center\">n/a</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-bg\"></td><td \nstyle=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" rowspan=\"3\" style=\"font-weight:bold\">Overtime</td><td class=\"grey-fg\">K Million IDR</td>\n<td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td \nclass=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" \nclass=\"icon\"></md-icon></td></tr><tr><td class=\"grey-fg\">Hours</td><td class=\"grey-fg\" style=\"text-align: center\">n/a\n</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-bg\"></td><td style=\"text-align:center\">\n<md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"grey-fg\">\nRatio</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-fg\" style=\"text-align: center\">n/a\n</td><td class=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr></tbody></table></div></div></ms-widget-front>\n</ms-widget></div></md-tab-body></md-tab><md-tab><md-tab-label><md-icon md-font-icon=\"icon-harddisk\" class=\"icon\">\n</md-icon>Digitization</md-tab-label><md-tab-body><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nProgress Project YTD 2017</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" \nflex-sm=\"100\"></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap flex><div flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\" ng-repeat=\"project in vm.projects\"><div class=\"h2 m-16 pb-16 border-bottom\">\n{{project.name}}<br>{{project.progress}} %</div><div class=\"p-16 pb-32\" ng-repeat=\"step in project.steps\"><div \nclass=\"pb-8\" layout=\"row\" layout-align=\"space-between start\"><span class=\"h3\">{{step.name}}</span> <span \nclass=\"h3 secondary-text font-weight-500\">{{step.value}}%</span></div><md-progress-linear \nclass=\"{{step.progressColor}} md-red-500-bg\" md-mode=\"determinate\" value=\"{{step.value}}\"></md-progress-linear><div \nstyle=\"padding-top: 10px\"><div flex=\"100\" ng-repeat=\"item in step.items\"><md-checkbox ng-checked=\"item.checked\">\n{{ item.name }}</md-checkbox></div></div></div></div></div></ms-widget-front></ms-widget></div></md-tab-body></md-tab>\n<md-tab label=\"Key Performance Indicators\"><md-tab-label><md-icon md-font-icon=\"icon-chart-line\" class=\"icon\">\n</md-icon>Performance Apraisal</md-tab-label><md-tab-body><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Apraisal Nabati Group 2016</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button aria-label=\"Flip widget\">2017</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Refresh widget\">2016</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" \nflex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataMutu\" chart-options=\"vm.optionsBadj\" id=\"chart1\"></div></div><div \nclass=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1\" \nchart-options=\"vm.optionsAadj1\" id=\"chart2\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataAdj2\" chart-options=\"vm.optionsAadj2\" id=\"chart3\"></div></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Chart By Divisi {{vm.DivisionName}} 2016</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item ng-repeat=\"oDivision in vm.listDivision\"><md-button \nng-click=\"vm.viewDataDivision(oDivision.id,oDivision.description)\" aria-label=\"{{oDivision.description}} widget\">\n{{oDivision.description}}</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div \nui-chart=\"vm.dataMutuDiv\" chart-options=\"vm.optionsBadjDiv\" id=\"chart4\"></div></div><div class=\"p-16\" layout=\"row\" \nflex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1Div\" chart-options=\"vm.optionsAadj1Div\" id=\"chart5\">\n</div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj2Div\" \nchart-options=\"vm.optionsAadj2Div\" id=\"chart6\"></div></div></div></div></ms-widget-front></ms-widget></div>\n</md-tab-body></md-tab><md-tab label=\"Key Performance Indicators\"><md-tab-label><md-icon \nmd-font-icon=\"icon-beaker-outline\" class=\"icon\"></md-icon>Key Performance Indicators</md-tab-label><md-tab-body><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\"><strong>KPI Progress YTD N-1 2017</strong></div>\n<div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Flip widget\">Nevyndatama Putranta\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">Frans Bastian Sutanto Hutapea\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">Christianta Sitepu</md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">Chong Kok Yeow Kenny</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" \nlayout=\"column\" flex=\"100\"><div ui-chart=\"vm.dataKpi\" chart-options=\"vm.optionsKpi\" id=\"chart11\"></div></div></div><div\n layout=\"row\" layout-align=\"start center\" layout-wrap flex><div layout=\"column\" flex=\"100\"><table class=\"simple\" \nms-responsive-table><thead><tr><th width=\"1%\">KPI NO.</th><th>KPI</th><th>DESCRIPTION</th><th>UOM</th><th>TARGET</th>\n<th>WEIGHT</th><th>RESULT YTD</th></tr></thead><tbody><tr><td>1</td><td>HR Digitalization</td><td>\nHR Digitalization for HC</td><td>Index</td><td>3 Function (TA, Comben, PM) Go live</td><td>30%</td><td>TA Go live</td>\n</tr><tr><td>2</td><td>Nabati Development Center</td><td>Learning for all Employee</td><td>Hour</td><td>20000</td><td>\n20%</td><td>30000</td></tr><tr><td>3</td><td>RTC N-1 &amp; identified Key Position</td><td>\nRTC N-1 &amp; identified Key Position</td><td>Unit</td><td>100% by Q3 1:1</td><td>25%</td><td>Q3 1:0.65</td></tr><tr>\n<td>4</td><td>HR Standardization Project</td><td>Standardize process on Human Capital</td><td>Time</td><td>\nCorporate HR Policies by Q4 100% (HR in the Box) Implementation</td><td>25%</td><td>Q3 all Policies go to Deployment\n</td></tr></tbody></table></div></div></ms-widget-front></ms-widget></div></md-tab-body></md-tab><md-tab \nlabel=\"Head Count\"><md-tab-label><md-icon md-font-icon=\"icon-account-multiple-plus\" class=\"icon\"></md-icon>Head Count\n</md-tab-label><md-tab-body><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"light-green-bg white-fg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">KSNI</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-green-900-fg font-size-72 line-height-72\">560</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 light-green-bg white-fg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span \nclass=\"h4 ml-8\">160</span> <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span \nclass=\"h4 ml-8\">300</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div><div class=\"border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">YTD 2017</span></div></div><div class=\"border-bottom\" layout=\"row\" \nlayout-align=\"start center\"><div><i class=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div \nclass=\"h4 text-bold\" flex>Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"red-bg white-fg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">RKI</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-900-fg font-size-72 line-height-72\">467</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 red-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span class=\"h4 ml-8\">200</span>\n <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span class=\"h4 ml-8\">267</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div><div class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">YTD 2017\n</span></div></div><div class=\"border-bottom\" layout=\"row\" layout-align=\"start center\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div class=\"h4 text-bold\" flex>\nTurnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div class=\"border-bottom\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"blue-bg white-fg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">ENERLIFE</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-900-fg font-size-72 line-height-72\">230</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 blue-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span class=\"h4 ml-8\">100</span>\n <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span class=\"h4 ml-8\">130</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div><div class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">YTD 2017\n</span></div></div><div class=\"border-bottom\" layout=\"row\" layout-align=\"start center\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div class=\"h4 text-bold\" flex>\nTurnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div class=\"border-bottom\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"brown-bg white-fg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">PMA</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"brown-900-fg font-size-72 line-height-72\">980</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 brown-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span class=\"h4 ml-8\">400</span>\n <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span class=\"h4 ml-8\">580</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div><div class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">YTD 2017\n</span></div></div><div class=\"border-bottom\" layout=\"row\" layout-align=\"start center\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div class=\"h4 text-bold\" flex>\nTurnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div class=\"border-bottom\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3 grey-600-fg\"><strong>\nHead Count Overview KSNI YTD 2016</strong></div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button aria-label=\"Flip widget\">KSNI</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Refresh widget\">RKI</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">ENERLIFE\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">PMA</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" \nlayout=\"column\" flex=\"90\"><div ui-chart=\"vm.dataHc\" style=\"height:450px\" chart-options=\"vm.HcOption\" id=\"chart12\">\n</div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"pv-8 h3 grey-600-fg\"><strong>Headcount Movement 2016</strong></div><div class=\"pv-8\" layout=\"row\" \nlayout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Flip widget\">KSNI</md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Refresh widget\">RKI</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Refresh widget\">ENERLIFE</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">PMA\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"p-16\" layout=\"column\" flex=\"90\"><div ui-chart=\"vm.dataHcMovement\" style=\"height:650px\" \nchart-options=\"vm.HcOptionMovement\" id=\"chart13\"></div></div></div></ms-widget-front></ms-widget></div></md-tab-body>\n</md-tab><md-tab label=\"Productivity\"><md-tab-label><md-icon md-font-icon=\"icon-basket-unfill\" class=\"icon\"></md-icon>\nProductivity</md-tab-label><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" \nflex=\"100\"><ms-widget-front class=\"white-bg\"></ms-widget-front></ms-widget></div></md-tab></md-tabs></md-content></div>\n</div>");
$templateCache.put("app/main/hcdashboard/hcdashboard__old.html","<div id=\"header-action\" class=\"page-layout simple fullwidth\" layout=\"row\" flex><div class=\"center\" flex ms-scroll>\n<md-content class=\"hcdashboard-content\" flex><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">Human Capital Dashboard Jan-17</div>\n<div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"></div></div><div \nlayout=\"row\" layout-align=\"start start\" layout-wrap flex><div layout=\"column\" flex=\"100\"><table \nclass=\"simple bordered\" ms-responsive-table><thead><tr><th colspan=\"2\" style=\"border-top:none\"></th><th \nclass=\"grey-bg white-fg\" width=\"8%\">SPOT</th><th class=\"grey-bg white-fg\" width=\"8%\">YTD</th><th \nclass=\"grey-bg white-fg\" width=\"8%\">TARGET</th><th class=\"grey-bg white-fg\" width=\"8%\">TREND</th></tr></thead><tbody>\n<tr><td class=\"green-fg\" style=\"font-weight:bold\">HR Digitation</td><td class=\"grey-fg\">\n3 Function (TA, Comben, PM) Go live</td><td style=\"text-align: center\">1</td><td style=\"text-align: center\">4</td><td \nstyle=\"text-align: center\">3</td><td style=\"text-align:center\"><md-icon class=\"green-fg\" \nmd-font-icon=\"icon-trending-up\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">\nNabati Development Center</td><td class=\"grey-fg\">2 hrs / empl (annual)</td><td style=\"text-align: center\">8%</td><td \nstyle=\"text-align: center\">41%</td><td style=\"text-align: center\">100%</td><td style=\"text-align:center\"><md-icon \nclass=\"red-fg\" md-font-icon=\"icon-trending-up\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">RTC N-1 &amp; Identified Key Position</td><td class=\"grey-fg\">100% by Q3 1:1</td><td \nstyle=\"text-align: center\">20%</td><td style=\"text-align: center\">43%</td><td style=\"text-align: center\">100%</td><td \nstyle=\"text-align:center\"><md-icon class=\"red-fg\" md-font-icon=\"icon-trending-up\" class=\"icon\"></md-icon></td></tr><tr>\n<td class=\"green-fg\" style=\"font-weight:bold\">HR Standarization Project</td><td class=\"grey-fg\">\nCorporate HR Policies by Q4 100%</td><td style=\"text-align: center\">5%</td><td style=\"text-align: center\">21%</td><td \nstyle=\"text-align: center\">100%</td><td style=\"text-align:center\"><md-icon class=\"red-fg\" \nmd-font-icon=\"icon-trending-down\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">\nEmployee Satisfaction Level to HC</td><td class=\"grey-fg\">Survey Result</td><td style=\"text-align: center\">75%</td><td \nstyle=\"text-align: center\">75%</td><td style=\"text-align: center\">70%</td><td style=\"text-align:center\"><md-icon \nclass=\"green-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr></tbody></table></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"50\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"pv-8 h3\">Head Count Jan-17</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"></div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap flex><div \nlayout=\"column\" flex=\"100\"><table class=\"simple bordered\" ms-responsive-table><thead><tr><th class=\"grey-bg white-fg\" \nrowspan=\"3\">Business Unit</th><th class=\"grey-bg white-fg\" colspan=\"6\" width=\"8%\">Head Count</th></tr><tr><th \nclass=\"grey-bg white-fg\" colspan=\"2\" width=\"8%\">OEC</th><th class=\"grey-bg white-fg\" colspan=\"2\" width=\"8%\">FTC</th><th\n class=\"grey-bg white-fg\" colspan=\"2\" width=\"8%\">Sumplementary</th></tr><tr><th class=\"grey-bg white-fg\" width=\"2%\">M\n</th><th class=\"grey-bg white-fg\" width=\"2%\">F</th><th class=\"grey-bg white-fg\" width=\"2%\">M</th><th \nclass=\"grey-bg white-fg\" width=\"2%\">F</th><th class=\"grey-bg white-fg\" width=\"2%\">M</th><th class=\"grey-bg white-fg\" \nwidth=\"2%\">F</th></tr></thead><tbody><tr><td class=\"green-fg\" style=\"font-weight:bold\">CORPORATE</td><td \nclass=\"grey-fg\" style=\"text-align: center\">1244</td><td class=\"grey-fg\" style=\"text-align: center\">44</td><td \nclass=\"grey-fg\" style=\"text-align: center\">666</td><td class=\"grey-fg\" style=\"text-align: center\">66</td><td \nclass=\"grey-fg\" style=\"text-align:center\">66</td><td class=\"grey-fg\" style=\"text-align:center\">6666</td></tr><tr><td \nclass=\"green-fg\" style=\"font-weight:bold\">KSNI</td><td class=\"grey-fg\" style=\"text-align: center\">1244</td><td \nclass=\"grey-fg\" style=\"text-align: center\">44</td><td class=\"grey-fg\" style=\"text-align: center\">666</td><td \nclass=\"grey-fg\" style=\"text-align: center\">66</td><td class=\"grey-fg\" style=\"text-align:center\">66</td><td \nclass=\"grey-fg\" style=\"text-align:center\">6666</td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">RKI</td><td \nclass=\"grey-fg\" style=\"text-align: center\">1244</td><td class=\"grey-fg\" style=\"text-align: center\">44</td><td \nclass=\"grey-fg\" style=\"text-align: center\">666</td><td class=\"grey-fg\" style=\"text-align: center\">66</td><td \nclass=\"grey-fg\" style=\"text-align:center\">66</td><td class=\"grey-fg\" style=\"text-align:center\">6666</td></tr><tr><td \nclass=\"green-fg\" style=\"font-weight:bold\">PMA</td><td class=\"grey-fg\" style=\"text-align: center\">1244</td><td \nclass=\"grey-fg\" style=\"text-align: center\">44</td><td class=\"grey-fg\" style=\"text-align: center\">666</td><td \nclass=\"grey-fg\" style=\"text-align: center\">66</td><td class=\"grey-fg\" style=\"text-align:center\">66</td><td \nclass=\"grey-fg\" style=\"text-align:center\">6666</td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">ENERLIFE</td>\n<td class=\"grey-fg\" style=\"text-align: center\">1244</td><td class=\"grey-fg\" style=\"text-align: center\">44</td><td \nclass=\"grey-fg\" style=\"text-align: center\">666</td><td class=\"grey-fg\" style=\"text-align: center\">66</td><td \nclass=\"grey-fg\" style=\"text-align:center\">66</td><td class=\"grey-fg\" style=\"text-align:center\">6666</td></tr></tbody>\n</table></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nHC Evolution</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"></div>\n</div><div layout=\"row\" layout-align=\"start center\" layout-wrap flex><div layout=\"column\" flex=\"100\"><div \nui-chart=\"vm.dataHc\" style=\"height:318px;width: 90%\" chart-options=\"vm.HcOption\" id=\"chart12\"></div></div></div>\n</ms-widget-front></ms-widget></div></md-content></div></div>");
$templateCache.put("app/main/hcdashboard/hcdashboardnew.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<md-content class=\"content md-background-bg\"><md-tabs md-dynamic-height><md-tab><md-tab-label><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon>HC Dashboard</md-tab-label><md-tab-body><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8 h3\">Human Capital Dashboard YTD 2017</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap flex><div \nlayout=\"column\" flex=\"100\"><table class=\"simple bordered\" ms-responsive-table><thead><tr><th colspan=\"2\" \nstyle=\"border-top:none\"></th><th class=\"grey-bg white-fg\" width=\"8%\">SPOT</th><th class=\"grey-bg white-fg\" width=\"8%\">\nYTD</th><th class=\"grey-bg white-fg\" width=\"8%\">TARGET</th><th class=\"grey-bg white-fg\" width=\"8%\">TREND</th></tr>\n</thead><tbody><tr><td class=\"green-fg\" style=\"font-weight:bold\">HR Digitization</td><td class=\"grey-fg\">\n3 Function (TA, Comben, PM) Go live</td><td style=\"text-align: center\">2</td><td style=\"text-align: center\">2</td><td \nstyle=\"text-align: center\">3</td><td style=\"text-align:center\"><md-icon class=\"red-fg\" md-font-icon=\"icon-trending-up\" \nclass=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">Nabati Development Center</td><td \nclass=\"grey-fg\">2 hrs / empl (annual)</td><td style=\"text-align: center\">0%</td><td style=\"text-align: center\">0%</td>\n<td style=\"text-align: center\">100%</td><td style=\"text-align:center\"><md-icon class=\"red-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">RTC N-1 &amp; Identified Key Position</td><td class=\"grey-fg\">100% by Q3 1:1</td><td \nstyle=\"text-align: center\">0%</td><td style=\"text-align: center\">0%</td><td style=\"text-align: center\">100%</td><td \nstyle=\"text-align:center\"><md-icon class=\"red-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">HR Standarization Project</td><td class=\"grey-fg\">\nCorporate HR Policies by Q4 100%</td><td style=\"text-align: center\">40%</td><td style=\"text-align: center\">40%</td><td \nstyle=\"text-align: center\">100%</td><td style=\"text-align:center\"><md-icon class=\"red-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">Employee Satisfaction Level to HC</td><td class=\"grey-fg\">Survey Result</td><td \nstyle=\"text-align: center\">0%</td><td style=\"text-align: center\">%</td><td style=\"text-align: center\">70%</td><td \nstyle=\"text-align:center\"><md-icon class=\"red-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">Headcount</td><td class=\"grey-fg\"></td><td \nstyle=\"text-align: center\">18,658</td><td style=\"text-align: center\">18,658</td><td style=\"text-align: center\"></td><td\n style=\"text-align:center\"><md-icon class=\"red-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" rowspan=\"2\" style=\"font-weight:bold\">Turn Over</td><td class=\"grey-fg\">Voluntary</td><td \nstyle=\"text-align: center\">1.99%</td><td style=\"text-align: center\">1.87%</td><td style=\"text-align: center\">5%</td><td\n style=\"text-align:center\"><md-icon class=\"green-fg\" md-font-icon=\"icon-trending-up\" class=\"icon\"></md-icon></td></tr>\n<tr><td class=\"grey-fg\">Non Voluntary</td><td style=\"text-align: center\"></td><td style=\"text-align: center\"></td><td \nclass=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" \nclass=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">Gender Ratio</td><td \nclass=\"grey-fg\">% Female</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-fg\" \nstyle=\"text-align: center\">n/a</td><td class=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">Training Hours</td><td class=\"grey-fg\">Total Training Hours of Total Employee</td><td \nclass=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td \nclass=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" \nclass=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" style=\"font-weight:bold\">LTDR</td><td class=\"grey-fg\">\nLoss Time Day Rate</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-fg\" \nstyle=\"text-align: center\">n/a</td><td class=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"green-fg\" \nstyle=\"font-weight:bold\">WF Normal Working Hours</td><td class=\"grey-fg\">in hour</td><td class=\"grey-fg\" \nstyle=\"text-align: center\">n/a</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-bg\"></td><td \nstyle=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td>\n</tr><tr><td class=\"green-fg\" rowspan=\"3\" style=\"font-weight:bold\">Overtime</td><td class=\"grey-fg\">K Million IDR</td>\n<td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td \nclass=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" \nclass=\"icon\"></md-icon></td></tr><tr><td class=\"grey-fg\">Hours</td><td class=\"grey-fg\" style=\"text-align: center\">n/a\n</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-bg\"></td><td style=\"text-align:center\">\n<md-icon class=\"grey-fg\" md-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr><tr><td class=\"grey-fg\">\nRatio</td><td class=\"grey-fg\" style=\"text-align: center\">n/a</td><td class=\"grey-fg\" style=\"text-align: center\">n/a\n</td><td class=\"grey-bg\"></td><td style=\"text-align:center\"><md-icon class=\"grey-fg\" \nmd-font-icon=\"icon-trending-neutral\" class=\"icon\"></md-icon></td></tr></tbody></table></div></div></ms-widget-front>\n</ms-widget></div></md-tab-body></md-tab><md-tab><md-tab-label><md-icon md-font-icon=\"icon-harddisk\" class=\"icon\">\n</md-icon>Digitization</md-tab-label><md-tab-body><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nProgress Project YTD 2017</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" \nflex-sm=\"100\"></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap flex><div flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\" ng-repeat=\"project in vm.projects\"><div class=\"h2 m-16 pb-16 border-bottom\">\n{{project.name}}<br>{{project.progress}} %</div><div class=\"p-16 pb-32\" ng-repeat=\"step in project.steps\"><div \nclass=\"pb-8\" layout=\"row\" layout-align=\"space-between start\"><span class=\"h3\">{{step.name}}</span> <span \nclass=\"h3 secondary-text font-weight-500\">{{step.value}}%</span></div><md-progress-linear \nclass=\"{{step.progressColor}} md-red-500-bg\" md-mode=\"determinate\" value=\"{{step.value}}\"></md-progress-linear><div \nstyle=\"padding-top: 10px\"><div flex=\"100\" ng-repeat=\"item in step.items\"><md-checkbox ng-checked=\"item.checked\">\n{{ item.name }}</md-checkbox></div></div></div></div></div></ms-widget-front></ms-widget></div></md-tab-body></md-tab>\n<md-tab label=\"Key Performance Indicators\"><md-tab-label><md-icon md-font-icon=\"icon-chart-line\" class=\"icon\">\n</md-icon>Performance Apraisal</md-tab-label><md-tab-body><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Apraisal Nabati Group 2016</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button aria-label=\"Flip widget\">2017</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Refresh widget\">2016</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" \nflex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataMutu\" chart-options=\"vm.optionsBadj\" id=\"chart1\"></div></div><div \nclass=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1\" \nchart-options=\"vm.optionsAadj1\" id=\"chart2\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataAdj2\" chart-options=\"vm.optionsAadj2\" id=\"chart3\"></div></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Chart By Divisi {{vm.DivisionName}} 2016</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item ng-repeat=\"oDivision in vm.listDivision\"><md-button \nng-click=\"vm.viewDataDivision(oDivision.id,oDivision.description)\" aria-label=\"{{oDivision.description}} widget\">\n{{oDivision.description}}</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div \nui-chart=\"vm.dataMutuDiv\" chart-options=\"vm.optionsBadjDiv\" id=\"chart4\"></div></div><div class=\"p-16\" layout=\"row\" \nflex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1Div\" chart-options=\"vm.optionsAadj1Div\" id=\"chart5\">\n</div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj2Div\" \nchart-options=\"vm.optionsAadj2Div\" id=\"chart6\"></div></div></div></div></ms-widget-front></ms-widget></div>\n</md-tab-body></md-tab><md-tab label=\"Key Performance Indicators\"><md-tab-label><md-icon \nmd-font-icon=\"icon-beaker-outline\" class=\"icon\"></md-icon>Key Performance Indicators</md-tab-label><md-tab-body><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\"><strong>KPI Progress YTD N-1 2017</strong></div>\n<div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Flip widget\">Nevyndatama Putranta\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">Frans Bastian Sutanto Hutapea\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">Christianta Sitepu</md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">Chong Kok Yeow Kenny</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" \nlayout=\"column\" flex=\"100\"><div ui-chart=\"vm.dataKpi\" chart-options=\"vm.optionsKpi\" id=\"chart11\"></div></div></div><div\n layout=\"row\" layout-align=\"start center\" layout-wrap flex><div layout=\"column\" flex=\"100\"><table class=\"simple\" \nms-responsive-table><thead><tr><th width=\"1%\">KPI NO.</th><th>KPI</th><th>DESCRIPTION</th><th>UOM</th><th>TARGET</th>\n<th>WEIGHT</th><th>RESULT YTD</th></tr></thead><tbody><tr><td>1</td><td>HR Digitalization</td><td>\nHR Digitalization for HC</td><td>Index</td><td>3 Function (TA, Comben, PM) Go live</td><td>30%</td><td>TA Go live</td>\n</tr><tr><td>2</td><td>Nabati Development Center</td><td>Learning for all Employee</td><td>Hour</td><td>20000</td><td>\n20%</td><td>30000</td></tr><tr><td>3</td><td>RTC N-1 &amp; identified Key Position</td><td>\nRTC N-1 &amp; identified Key Position</td><td>Unit</td><td>100% by Q3 1:1</td><td>25%</td><td>Q3 1:0.65</td></tr><tr>\n<td>4</td><td>HR Standardization Project</td><td>Standardize process on Human Capital</td><td>Time</td><td>\nCorporate HR Policies by Q4 100% (HR in the Box) Implementation</td><td>25%</td><td>Q3 all Policies go to Deployment\n</td></tr></tbody></table></div></div></ms-widget-front></ms-widget></div></md-tab-body></md-tab><md-tab \nlabel=\"Head Count\"><md-tab-label><md-icon md-font-icon=\"icon-account-multiple-plus\" class=\"icon\"></md-icon>Head Count\n</md-tab-label><md-tab-body><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"light-green-bg white-fg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">KSNI</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-green-900-fg font-size-72 line-height-72\">560</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 light-green-bg white-fg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span \nclass=\"h4 ml-8\">160</span> <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span \nclass=\"h4 ml-8\">300</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div><div class=\"border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">YTD 2017</span></div></div><div class=\"border-bottom\" layout=\"row\" \nlayout-align=\"start center\"><div><i class=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div \nclass=\"h4 text-bold\" flex>Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"red-bg white-fg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">RKI</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-900-fg font-size-72 line-height-72\">467</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 red-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span class=\"h4 ml-8\">200</span>\n <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span class=\"h4 ml-8\">267</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div><div class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">YTD 2017\n</span></div></div><div class=\"border-bottom\" layout=\"row\" layout-align=\"start center\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div class=\"h4 text-bold\" flex>\nTurnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div class=\"border-bottom\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"blue-bg white-fg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">ENERLIFE</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-900-fg font-size-72 line-height-72\">230</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 blue-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span class=\"h4 ml-8\">100</span>\n <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span class=\"h4 ml-8\">130</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div><div class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">YTD 2017\n</span></div></div><div class=\"border-bottom\" layout=\"row\" layout-align=\"start center\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div class=\"h4 text-bold\" flex>\nTurnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div class=\"border-bottom\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"brown-bg white-fg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">PMA</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"brown-900-fg font-size-72 line-height-72\">980</div><div \nclass=\"h3 secondary-text font-weight-500\">Head Count</div></div><div class=\"p-16 brown-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Male:</span> <span class=\"h4 ml-8\">400</span>\n <span flex></span> <span class=\"h4 secondary-text text-truncate\">Female:</span> <span class=\"h4 ml-8\">580</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div><div class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top:15px;margin-bottom: 10px\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">YTD 2017\n</span></div></div><div class=\"border-bottom\" layout=\"row\" layout-align=\"start center\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-down green-fg\"></i></div><div class=\"h4 text-bold\" flex>\nTurnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">3.3%</div></div><div class=\"border-bottom\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-up red-fg\"></i></div><div class=\"h4 text-bold\" flex>\nVoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div><div \nclass=\"border-bottom\" layout=\"row\" layout-align=\"start center\" style=\"margin-top:5px\"><div><i \nclass=\"icon pr-16 mr-16 border-right icon-trending-neutral grey-fg\"></i></div><div class=\"h4 text-bold\" flex>\nInvoluntary Turnover YTD 2017</div><div class=\"h4 font-weight-500 secondary-text\">1.1%</div></div></div>\n</ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3 grey-600-fg\"><strong>\nHead Count Overview KSNI YTD 2016</strong></div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button aria-label=\"Flip widget\">KSNI</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Refresh widget\">RKI</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">ENERLIFE\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">PMA</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" \nlayout=\"column\" flex=\"90\"><div ui-chart=\"vm.dataHc\" style=\"height:450px\" chart-options=\"vm.HcOption\" id=\"chart12\">\n</div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"pv-8 h3 grey-600-fg\"><strong>Headcount Movement 2016</strong></div><div class=\"pv-8\" layout=\"row\" \nlayout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Flip widget\">KSNI</md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Refresh widget\">RKI</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Refresh widget\">ENERLIFE</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Refresh widget\">PMA\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"p-16\" layout=\"column\" flex=\"90\"><div ui-chart=\"vm.dataHcMovement\" style=\"height:650px\" \nchart-options=\"vm.HcOptionMovement\" id=\"chart13\"></div></div></div></ms-widget-front></ms-widget></div></md-tab-body>\n</md-tab><md-tab label=\"Productivity\"><md-tab-label><md-icon md-font-icon=\"icon-basket-unfill\" class=\"icon\"></md-icon>\nProductivity</md-tab-label><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" \nflex=\"100\"><ms-widget-front class=\"white-bg\"></ms-widget-front></ms-widget></div></md-tab></md-tabs></md-content></div>\n</div>");
$templateCache.put("app/main/hcticket/hctiket-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"HCTICKET.MENU.HEADERFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.CB.TITLE\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.title\" name=\"title\" required><div \nng-messages=\"frmBT.title.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.CB.TITLE\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.TYPE\"></span></label><md-select \nng-model=\"vm.Form.objForm.type\" name=\"type\" required><md-option ng-repeat=\"ls in vm.ticketList\" value=\"{{ls.name}}\" \nrequired>{{ls.name}}</md-option></md-select><div ng-messages=\"frmBT.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.TYPE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div><label class=\"text-grey\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *\n</label><div layout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 7px\"><textarea rows=\"7\" \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.Form.objForm.description\" ng-required=\"true\"></textarea></div><div \nng-messages=\"frmBT.deliverable.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked\" \nng-click=\"vm.checkIsNeddFile()\" ng-model=\"vm.isNeddUploadFile\" aria-label=\"\"><span \ntranslate=\"HCTICKET.MENU.NEEDUPLOAD\"></span></md-checkbox></div><md-input-container ng-if=\"vm.isChecked\" md-no-float \nclass=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n            action:\'uploadData\',\n            title:vm.Form.objForm.title,\n            id:vm.Form.objForm.id,\n            type:vm.Form.objForm.type,\n            description:vm.Form.objForm.description,\n            priority:vm.Form.objForm.priority,\n            pic_phone:vm.Form.objForm.pic_phone}] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"button\" ng-if=\"vm.isChecked\" class=\"md-raised md-accent\" \nng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button><md-button type=\"submit\" ng-if=\"!vm.isChecked\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/hcticket/hctiket-update-status.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"60\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"HCTICKET.MENU.UPDATESTATUS\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.STATUS\"></span></label><md-select ng-change=\"vm.checkStatus(vm.Form.objForm.status)\" \nng-model=\"vm.Form.objForm.status\" name=\"status\" required><md-option ng-repeat=\"ls in vm.statusList\" value=\"{{ls.id}}\" \nrequired>{{ls.name}}</md-option></md-select><div ng-messages=\"frmBT.status.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.STATUS\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div><div layout=\"row\" ng-if=\"vm.Form.objForm.status==\'2\'\"><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.ESTIMATION\"></span> <span style=\"font-style:italic\">(dalam satuan jam)</span>\n</label><input type=\"number\" ng-model=\"vm.Form.objForm.estimation\" name=\"estimation\" required><div \nng-messages=\"frmBT.estimation.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.ESTIMATION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div ng-if=\"vm.isDone\" layout=\"row\"><md-input-container flex><label><span \ntranslate=\"MENU.MAIN.ERRORTYPE\"></span></label><md-select ng-model=\"vm.Form.objForm.errorType\" name=\"errorType\" \nrequired><md-option ng-repeat=\"ls in vm.errorTypeList\" value=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select>\n<div ng-messages=\"frmBT.errorType.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.ERRORTYPE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><label ng-if=\"vm.isDone\" class=\"text-grey\"><span translate=\"HCTICKET.MENU.SOLUTION\"></span>\n *</label><div ng-if=\"vm.isDone\" layout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 7px\"><textarea \nrows=\"7\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.Form.objForm.solusi\" ng-required=\"true\"></textarea></div><div \nng-messages=\"frmBT.deliverable.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HCTICKET.MENU.SOLUTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/hcticket/hctiket-user.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"HCTICKET.MENU.HEADER\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container \nclass=\"width-filter\"><label><span translate=\"PAYROLL.MENU.TYPE\"></span></label><md-select ng-model=\"vm.type\" \nname=\"type\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a type...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"type\"><md-option value=\"{{ls.name}}\" ng-repeat=\"ls in vm.ticketList | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"width-filter\"><label>\n<span translate=\"MYPROFILE.MENU.STATUS\"></span></label><md-select ng-model=\"vm.status\" name=\"status\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.setChangeStatus()\"><md-select-header class=\"demo-select-header\"><input\n ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a status...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"status\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" \nstyle=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span><span translate=\"PAYROLL.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.CB.TITLE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.TYPE\"></span></span></th><th width=\"15%\" class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.STATUS\"></span></span></th><th width=\"7%\" class=\"text-center\"><span class=\"column-title\">\n<span translate=\"PAYROLL.MENU.ESTIMATION\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" ng-dblclick=\"vm.viewDetail($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox ng-if=\"item.status==\'1\'\" aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}} <span ng-if=\"item.respondCount>0\" \nclass=\"badge white-fg ng-binding ng-scope badge-bc-unread\" \nstyle=\"background: red;\n                      height: 25px;\n                      font-size: 16px;\n                      width: 25px;\n                      padding-top: 3px;\n                      border-radius: 50%;\n                      display: inline-block\">\n?</span></td><td class=\"\"><a style=\"cursor: pointer\" ng-click=\"vm.viewDetail($event, item)\">{{item.title}}</a></td><td \nclass=\"\">{{item.type}}</td><td class=\"text-center\"><span class=\"{{item.class}}\">{{item.statuss}}</span></td><td \nclass=\"text-center\"><span ng-if=\"item.estimation!=\'0.0\' && item.estimation!=\'0.00\'\">\n{{item.estimation}} {{ \'MENU.MAIN.CB.HOUR\' | translate}}</span></td><td class=\"text-center\"><section layout=\"row\" \nlayout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-if=\"item.status==\'1\'\" class=\"md-mini md-primary\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"HCTICKET.MENU.EDIT\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-border-color\">\n</md-icon><p flex><span translate=\"HCTICKET.MENU.EDIT\"></span></p></div></md-button><md-button \nng-if=\"item.filename&&item.format==\'img\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.viewFile($event, item.filename)\"><div layout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\">\n</span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button ng-if=\"item.filename&&item.format==\'file\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.downloadDoc($event, item.filename)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-menu-align-target md-font-icon=\"icon-download\"></md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p>\n</div></md-button><md-button ng-if=\"item.status!=\'4\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.closeTicket($event,item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.CLOSETICKET\">\n</span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-window-closed\"></md-icon><p flex><span \ntranslate=\"MENU.MAIN.CLOSETICKET\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section>\n</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/hcticket/hctiket.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"HCTICKET.MENU.HEADER\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container \nclass=\"width-filter\"><label><span translate=\"PAYROLL.MENU.TYPE\"></span></label><md-select ng-model=\"vm.type\" \nname=\"type\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a type...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"type\"><md-option value=\"{{ls.name}}\" ng-repeat=\"ls in vm.ticketList | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"width-filter\"><label>\n<span translate=\"MYPROFILE.MENU.STATUS\"></span></label><md-select ng-model=\"vm.status\" name=\"status\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a status...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"status\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.isAdmin\" class=\"width-filter\"><label><span\n translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select ng-model=\"vm.company\" name=\"company\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.getArea()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a company...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"company\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCompany | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.isAdmin\" \nclass=\"width-filter\"><label><span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"area\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listArea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"width-filter\"><label><span \ntranslate=\"PAYROLL.MENU.ISSYSDEV\"></span></label><md-select ng-model=\"vm.delegated\" name=\"isSysdev\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"isSysdev\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listDelegatedStatus | filter:vm.searchTerm\">{{ls.name | translate}}</md-option>\n</md-optgroup></md-select></md-input-container><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete \nng-if=\"vm.isAdmin\" style=\"width: 500px;margin-top: 5px\" flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"{{\'HCTICKET.MENU.REQUESTEDBY\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div>\n<md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.CB.TITLE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.TYPE\"></span></span></th><th ng-if=\"vm.isAdmin\" class=\"text-center\" width=\"12%\"><span \nclass=\"column-title\"><span translate=\"HCTICKET.MENU.REQUESTEDBY\"></span></span></th><th ng-if=\"vm.isAdmin\" \nclass=\"text-center\" width=\"5%\"><span class=\"column-title\"><span translate=\"HCTICKET.MENU.REQUESTEDAT\"></span></span>\n</th><th ng-if=\"vm.isAdmin\" class=\"text-center\" width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span></span></th><th ng-if=\"vm.isAdmin\" class=\"text-center\" width=\"15%\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.AREA\"></span></span></th><th width=\"15%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MYPROFILE.MENU.STATUS\"></span></span></th><th ng-if=\"!vm.isAdmin\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></span></th><th \nwidth=\"7%\" class=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.ESTIMATION\"></span></span></th>\n<th ng-if=\"vm.isAdmin\" width=\"7%\" class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.ISSYSDEV\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" ng-dblclick=\"vm.viewDetail($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox ng-if=\"item.status==\'1\'\" aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}} <span ng-if=\"item.respondCount>0\" \nclass=\"badge white-fg ng-binding ng-scope badge-bc-unread\" \nstyle=\"background: red;\n                      height: 25px;\n                      font-size: 16px;\n                      width: 25px;\n                      padding-top: 3px;\n                      border-radius: 50%;\n                      display: inline-block\">\n?</span></td><td class=\"\"><a style=\"cursor: pointer\" ng-click=\"vm.viewDetail($event, item)\">{{item.title}}</a></td><td \nclass=\"\">{{item.type}}</td><td ng-if=\"vm.isAdmin\" class=\"\">{{item.requested_by}} - {{item.name}}</td><td \nng-if=\"vm.isAdmin\" class=\"text-center\">{{item.requested_at}}</td><td ng-if=\"vm.isAdmin\" class=\"text-center\">\n{{item.company}}</td><td ng-if=\"vm.isAdmin\" class=\"\">{{item.area}}</td><td class=\"text-center\"><span \nclass=\"{{item.class}}\">{{item.statuss}}</span></td><td ng-if=\"!vm.isAdmin\" class=\"\"><div class=\"text-grey\" \nng-bind-html=\"item.description\" class=\"alert-information\"></div></td><td class=\"text-center\"><span \nng-if=\"item.estimation!=\'0.0\' && item.estimation!=\'0.00\'\">{{item.estimation}} {{ \'MENU.MAIN.CB.HOUR\' | translate}}\n</span></td><td ng-if=\"vm.isAdmin\" class=\"text-center\"><span ng-if=\"item.is_sysdev==\'0\'\" \ntranslate=\"PAYROLL.MESSAGE.NO\"></span> <span ng-if=\"item.is_sysdev==\'1\'\" translate=\"PAYROLL.MESSAGE.YES\"></span></td>\n<td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-if=\"item.status==\'1\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"HCTICKET.MENU.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex><span \ntranslate=\"HCTICKET.MENU.EDIT\"></span></p></div></md-button><md-button ng-if=\"item.filename&&item.format==\'img\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewFile($event, item.filename)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button \nng-if=\"item.filename&&item.format==\'file\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.downloadDoc($event, item.filename)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-download\">\n</md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p></div></md-button><md-button ng-if=\"vm.isAdmin\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.updateStatus($event, item)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"HCTICKET.MENU.UPDATESTATUS\"></span></md-tooltip><md-icon \nmd-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"HCTICKET.MENU.UPDATESTATUS\"></span></p></div></md-button><md-button ng-if=\"item.status!=\'4\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.closeTicket($event,item)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.CLOSETICKET\"></span></md-tooltip><md-icon \nmd-menu-align-target md-font-icon=\"icon-window-closed\"></md-icon><p flex><span translate=\"MENU.MAIN.CLOSETICKET\">\n</span></p></div></md-button><md-button ng-if=\"vm.isAdmin&&item.is_sysdev==\'0\'&&item.status==\'1\'\" \nng-disabled=\"vm.selected.length > 0\" class=\"md-mini md-primary\" ng-click=\"vm.delegateToSysdev(item,\'1\')\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"PAYROLL.MENU.DELEGATE\"></span></md-tooltip><md-icon \nmd-menu-align-target md-font-icon=\"icon-arrow-right-bold-circle-outline\"></md-icon><p flex><span \ntranslate=\"PAYROLL.MENU.DELEGATE\"></span></p></div></md-button><md-button \nng-if=\"vm.isAdmin&&item.is_sysdev==\'1\'&&item.status==\'1\'\" ng-disabled=\"vm.selected.length > 0\" \nclass=\"md-mini md-primary\" ng-click=\"vm.delegateToSysdev(item,\'0\')\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"PAYROLL.MENU.CANCELDELEGATION\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-cancel\">\n</md-icon><p flex><span translate=\"PAYROLL.MENU.CANCELDELEGATION\"></span></p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/hcticket/view-detail.html","<md-dialog aria-label=\"Form View Detail\" flex-md=\"80\" flex-gt-md=\"70\"><form ng-cloack name=\"fReply\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2><span translate=\"HCTICKET.MENU.DETAIL\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout-padding flex><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.isClosed==1\" style=\"margin-top:10px;margin-bottom:10px\" flex layout layout-align=\"center center\" \nlayout-padding><span>{{vm.message}}</span></md-whiteframe><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"MENU.MAIN.CB.TITLE\"></span></label><input type=\"text\" ng-model=\"vm.title\" name=\"title\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.TYPE\"></span></label><input \ntype=\"text\" ng-model=\"vm.type\" name=\"title\" ng-disabled=\"true\"></md-input-container><md-input-container \nng-if=\"vm.isAdmin\" flex><label><span translate=\"MENU.MAIN.ERRORTYPE\"></span></label><input type=\"text\" \nng-model=\"vm.errorType\" name=\"title\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.STATUS\"></span></label><input type=\"text\" \nng-model=\"vm.ticketStatus\" name=\"title\" ng-disabled=\"true\"></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.ESTIMATION\"></span></label><input type=\"text\" ng-model=\"vm.estimation\" name=\"estimation\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"HCTICKET.MENU.REQUESTEDBY\"></span></label><input type=\"text\" ng-model=\"vm.requestedBy\" name=\"requestedBy\" \nng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"!vm.isRequested && vm.isAdmin\" flex><label><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span></label><input type=\"text\" ng-model=\"vm.company\" name=\"company\" \nng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"!vm.isRequested && vm.isAdmin\" flex><label><span \ntranslate=\"PAYROLL.MENU.AREA\"></span></label><input type=\"text\" ng-model=\"vm.area\" name=\"area\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex><label><span translate=\"HCTICKET.MENU.REQUESTEDAT\"></span></label><input \ntype=\"text\" ng-model=\"vm.requestedAt\" name=\"requestedAt\" ng-disabled=\"true\"></md-input-container></div><label \nclass=\"text-grey\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></label><div layout=\"row\"><fieldset flex><div \nclass=\"text-grey\" ng-bind-html=\"vm.description\" class=\"alert-information\"></div></fieldset></div><label \nng-if=\"vm.filename!=\'\'\" class=\"text-grey\"><span translate=\"KPI.LABEL.FILE\"></span></label><div ng-if=\"vm.filename!=\'\'\" \nlayout=\"row\"><a ng-if=\"vm.filename&&vm.format==\'img\'\" ng-click=\"vm.viewFile($event,vm.filename)\"><span \nclass=\"show-file\" translate=\"MENU.MAIN.VIEWFILE\">View File</span></a> <a ng-if=\"vm.filename&&vm.format==\'file\'\" \nng-click=\"vm.downloadDoc($event,vm.filename)\"><span class=\"show-file\" translate=\"PAYROLL.MENU.DOWNLOAD\">Download</span>\n</a></div><label ng-if=\"!vm.isRequested && vm.isAdmin\" class=\"text-grey\"><span translate=\"HCTICKET.MENU.SOLUTION\">\n</span></label><div ng-if=\"!vm.isRequested && vm.isAdmin\" layout=\"row\"><fieldset flex><div class=\"text-grey\" \nng-bind-html=\"vm.solutions\" class=\"alert-information\"></div></fieldset></div><fieldset \nstyle=\"margin-top: 30px;background-color: aliceblue\" flex><legend \nstyle=\"background-color: grey; font-weight: bold; color:white\"><span translate=\"MENU.MAIN.DISCUSSION\"></span></legend>\n<div ng-repeat=\"ls in vm.ticketRespons\"><div layout=\"row\"><fieldset class=\"mg-10\" \nng-style=\"{\'background-color\': ls.bColor}\" flex><legend ng-style=\"{\'background-color\': ls.color}\" align=\"{{ls.align}}\">\n{{ls.username}} - {{ls.timestamp}}</legend><div class=\"text-grey\" style=\"color: black\" ng-bind-html=\"ls.respons\" \nclass=\"alert-information\"></div><br ng-if=\"ls.filename\"><br ng-if=\"ls.filename\"><a \nng-if=\"ls.filename&&ls.format==\'img\'\" ng-click=\"vm.viewFile($event,ls.filename)\"><span class=\"show-file\" \ntranslate=\"MENU.MAIN.VIEWFILE\">View File</span></a> <a ng-if=\"ls.filename&&ls.format==\'file\'\" \nng-click=\"vm.downloadDoc($event,ls.filename)\"><span class=\"show-file\" translate=\"PAYROLL.MENU.DOWNLOAD\">Download</span>\n</a></fieldset></div></div><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar upper-case-header\" ms-responsive-table><tbody><tr \nclass=\"md-table-content-row\"><td><textarea rows=\"7\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.answer\" \nrequired=\"true\"></textarea></td></tr></tbody></table><br><div layout=\"row\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked\" ng-click=\"vm.checkIsNeddFile()\" ng-model=\"vm.isNeddUploadFile\" aria-label=\"\"><span \ntranslate=\"HCTICKET.MENU.NEEDUPLOAD\"></span></md-checkbox></div><br><md-input-container ng-if=\"vm.isChecked\" \nmd-no-float class=\"md-block\"><input required=\"true\" type=\"file\" id=\"uploadData\" nv-file-select required \nuploader=\"vm.FileUploader\" \noptions=\"{ formData: [{\n                            action: \'uploadReply\',\n                            ticket_id: vm.id,\n                            title: vm.title,\n                            mailTo: vm.mailTo,\n                            answer: vm.answer}] }\">\n</md-input-container><br><br><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.showMessage\" class=\"fade\"><ms-widget-front class=\"red-400-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.alertMessage}}</p></ms-widget-front></ms-widget>\n<md-button ng-if=\"!vm.isChecked\" type=\"button\" ng-click=\"vm.saveData($event, fReply)\" \nclass=\"md-raised md-mini md-primary\" ng-disabled=\"fReply.$invalid || fReply.$pristine\" aria-label=\"Submit\" \ntranslate=\"MENU.MAIN.REPLY\">Reply</md-button><md-button ng-if=\"vm.isChecked\" type=\"button\" \nng-click=\"vm.upload(fReply)\" class=\"md-raised md-mini md-primary\" ng-disabled=\"fReply.$invalid || fReply.$pristine\" \naria-label=\"Submit\" translate=\"MENU.MAIN.REPLY\">Reply</md-button><md-button type=\"button\" \nng-click=\"vm.closeTicket($event, fReply)\" class=\"md-raised md-mini md-warn\" ng-disabled=\"vm.isClosed==\'1\'\" \naria-label=\"Close\" translate=\"MENU.MAIN.CLOSETICKET\">Close Ticket</md-button><md-button \nng-if=\"vm.isAdmin&&vm.isSysdev==\'0\'&&vm.status==\'1\'\" class=\"md-mini md-primary\" \nng-click=\"vm.delegateToSysdev(vm.refData,\'1\')\"><span translate=\"PAYROLL.MENU.DELEGATETOSYSDEV\"></span></md-button>\n<md-button ng-if=\"vm.isAdmin&&vm.isSysdev==\'1\'&&vm.status==\'1\'\" class=\"md-mini md-primary\" \nng-click=\"vm.delegateToSysdev(vm.refData,\'0\')\"><span translate=\"PAYROLL.MENU.CANCELDELEGATION\"></span></md-button><span\n ng-if=\"vm.isAdmin&&vm.isSysdev==\'1\'&&vm.status!=\'1\'\" translate=\"PAYROLL.MENU.ISSYSDEV\"></span></div></fieldset>\n</md-dialog-content><hr></form></md-dialog>");
$templateCache.put("app/main/hcticket/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.VIEWFILE\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" \nclass=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content>\n<md-dialog-content ng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><img \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/upload/{{vm.doc}}\">\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/indisciplinary-admin/indisciplinary-admin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nIndisciplinary Admin</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content><form name=\"frmAdmin\" \nclass=\"form-filter-admin\" ng-submit=\"vm.loadData(1)\" layout=\"column\" layout-align=\"end center\" novalidate><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-fill flex-gt-sm><md-input-container flex-gt-sm><label>Company</label>\n<md-select ng-model=\"vm.company\" aria-label=\"company\" name=\"company\"><md-option ng-repeat=\"ls in vm.listCompany\" \nplaceholder=\"COMPANY\" ng-value=\"ls.id\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmAdmin.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex-gt-sm><label>Division</label><md-select \nng-change=\"vm.loadDataDepartment()\" ng-model=\"vm.division\" aria-label=\"division\" name=\"division\"><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"DIVISION\" ng-value=\"ls.id\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmAdmin.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division field is required.\n</span></div></div></md-input-container><md-input-container flex-gt-sm><label>Department</label><md-select \nng-model=\"vm.department\" aria-label=\"department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"DEPARTMENT\" ng-value=\"ls.id\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmAdmin.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division field is required.</span>\n</div></div></md-input-container><md-input-container flex-gt-sm><label>Sub Area</label><md-select \nng-model=\"vm.subArea\" aria-label=\"subarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.listSubArea\" \nplaceholder=\"SUB AREA\" ng-value=\"ls.subarea_id\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmAdmin.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub area field is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\" layout=\"column\" layout-fill flex-gt-sm>\n<md-input-container flex-gt-sm><label>Letter Type</label><md-select ng-model=\"vm.letter\" aria-label=\"letters\" \nname=\"letters\"><md-option ng-repeat=\"ls in vm.letters\" ng-selected=\"vm.letter == ls.code\" placeholder=\"Letter Type\" \nng-value=\"ls.code\">{{ls.name | uppercase}}</md-option></md-select><div ng-messages=\"frmAdmin.letters.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Letter field is required.</span></div></div></md-input-container>\n<md-input-container flex-gt-sm ng-if=\"vm.company !== \'PM\'\"><label>Approval Status</label><md-select \nng-model=\"vm.approvalStatus\" aria-label=\"approvalStatus\" name=\"approvalStatus\"><md-option \nng-repeat=\"ls in vm.approvalStatusList\" placeholder=\"APPROVAL\" ng-value=\"ls.value\">{{ls.name}}</md-option></md-select>\n<div ng-messages=\"frmAdmin.approvalStatus.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nApproval Status field is required.</span></div></div></md-input-container><md-input-container flex-gt-sm \nng-if=\"vm.company !== \'PM\'\"><label>Confirmation Status</label><md-select ng-model=\"vm.confirmationStatus\" \naria-label=\"confirmation\" name=\"confirmation\"><md-option ng-repeat=\"ls in vm.confirmationStatusList\" \nplaceholder=\"CONFIRMATION\" ng-value=\"ls.value\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmAdmin.confirmation.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nConfirmation field is required.</span></div></div></md-input-container><span hide show-gt-sm flex></span> <span hide \nshow-gt-sm flex ng-if=\"vm.company === \'PM\'\"></span> <span hide show-gt-sm flex ng-if=\"vm.company === \'PM\'\"></span>\n</div><md-button class=\"md-primary md-raised md-icon-button\" flex type=\"submit\" ng-click=\"vm.loadData(1)\"><div \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-filter\"></md-icon></div></md-button></form>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button style=\"margin:0\" \nlayout=\"row\" layout-align=\"center\" class=\"md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction || vm.isCheckActionPrint\" ng-click=\"vm.showFormDialog($event, \'create\', null, true)\">\n<md-icon style=\"font-size:12px\" md-font-icon=\"icon-clipboard-check\"></md-icon><span style=\"font-size:12px\">Create\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" \nlayout-align=\"center\" class=\"md-warn\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction || vm.isCheckActionPrint\" \nng-click=\"vm.isCheckAction = !vm.isCheckAction; vm.isDelete = true; vm.isPrint = false;\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Delete</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" \nclass=\"md-primary custom-action\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction || vm.isCheckActionPrint\" ng-click=\"vm.isCheckActionPrint = !vm.isCheckActionPrint\">\n<md-icon style=\"font-size:12px\" md-font-icon=\"icon-printer\"></md-icon><span style=\"font-size:12px\">Print</span>\n</md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" \nlayout-align=\"center\" class=\"md-primary custom-action\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction || vm.isCheckActionPrint\" ng-click=\"vm.showFormExport()\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-file-excel-box\n                        \"></md-icon><span style=\"font-size:12px\">Export</span>\n</md-button><div ng-if=\"vm.isCheckActionPrint\" class=\"divider-vertical\" hide show-gt-sm></div><md-button \nng-click=\"vm.showDeleteDialog($event)\" ng-if=\"vm.isCheckAction\" ng-disabled=\"vm.checked.length == 0\" \nclass=\"md-icon-btn md-primary md-mini md-small\"><md-icon class=\"green-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span style=\"font-size:12px\">Apply</span></md-button>\n<md-button ng-click=\"vm.isCheckAction = !vm.isCheckAction; vm.checked = []\" ng-if=\"vm.isCheckAction\" \nclass=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\">Cancel</span></md-button><md-button \nng-click=\"vm.printPDF($event)\" ng-if=\"vm.isCheckActionPrint\" ng-disabled=\"vm.checked.length == 0\" \nclass=\"md-icon-btn md-primary md-mini md-small\"><md-icon class=\"green-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span style=\"font-size:12px\">Apply</span></md-button>\n<md-button ng-click=\"vm.isCheckActionPrint = !vm.isCheckActionPrint; vm.checked = []\" ng-if=\"vm.isCheckActionPrint\" \nclass=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\">Cancel</span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar>\n<md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon md-font-icon=\"icon-print\"></md-icon><span>PRINT\n</span></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\" ms-scroll><div id=\"tableIndisciplinary\"><table \nclass=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th \nstyle=\"text-align: center; vertical-align: middle\" ng-if=\"vm.isCheckAction || vm.isCheckActionPrint\"><md-checkbox \nstyle=\"transform: scale(0.6); margin: 0; margin-left: 5px\" ng-if=\"vm.isCheckAction || vm.isCheckActionPrint\" \nng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" aria-label=\"checkall\">\n</md-checkbox></th><th class=\"text-left\">No</th><th>NIK</th><th class=\"text-left\">Name</th><th>Sub Area</th><th>\nPosition</th><th class=\"text-left\">Letter</th><th class=\"text-left\">Type Of Action</th><th>Valid From</th><th>Valid To\n</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTable.list\"><td \nstyle=\"text-align: center; vertical-align:middle\" ng-if=\"vm.isCheckAction || vm.isCheckActionPrint\"><div layout=\"row\" \nflex layout-align=\"center\"><md-checkbox style=\"transform: scale(0.6); margin: 0\" \nng-if=\"vm.isCheckAction || vm.isCheckActionPrint\" ng-checked=\"vm.exists(item.id)\" ng-click=\"vm.toggle(item.id)\" \naria-label=\"checked\"></md-checkbox></div></td><td>{{$index + 1}}</td><td class=\"text-center\">{{item.nik}}</td><td>\n{{item.name}}</td><td>{{item.sub_area_name}}</td><td>{{item.position}}</td><td>{{item.letter_name}}</td><td>\n{{item.type_of_action}}</td><td class=\"text-center\">{{item.valid_from}}</td><td class=\"text-center\">{{item.valid_to}}\n</td><td class=\"text-center\"><div flex layout-align=\"row\" layout=\"row\" layout><md-icon \nmd-font-icon=\"icon-clipboard-check\" \nng-class=\"{\'green-400-fg\' : vm.isApproved(item.approval), \'orange-400-fg\': !vm.isApproved(item.approval)}\"><md-tooltip>\nApproval : {{ vm.isApproved(item.approval) ? \'Approved\' : \'Waiting\' }}</md-tooltip></md-icon><md-icon \nstyle=\"cursor: pointer\" ng-if=\"item.is_temporary === \'0\'\" md-font-icon=\"icon-account-remove\" \nclass=\"grey-400-fg pl-5 pr-5\"><md-tooltip>Anulir</md-tooltip></md-icon><md-icon style=\"cursor: pointer\" \nng-if=\"item.is_cancelled === \'0\' && item.is_temporary === \'1\'\" md-font-icon=\"icon-account-remove\" \nng-click=\"vm.anulir($event, item, \'1\')\" class=\"red-400-fg pl-5 pr-5\"><md-tooltip>Anulir</md-tooltip></md-icon><md-icon \nstyle=\"cursor: pointer\" ng-if=\"item.is_cancelled === \'1\' && item.is_temporary === \'1\'\" \nmd-font-icon=\"icon-account-remove\" ng-click=\"vm.anulir($event, item, \'0\')\" class=\"green-400-fg pl-5 pr-5\"><md-tooltip>\nRe-anulir</md-tooltip></md-icon><md-icon style=\"cursor: pointer\" class=\"pl-5 pr-5\" \nng-class=\"{\'orange-700-fg\' : item.is_document_uploaded === \'0\', \'green-700-fg\': item.is_document_uploaded === \'1\' }\" \nmd-font-icon=\"icon-document\" ng-click=\"vm.importDocument($event, item)\"><md-tooltip>Upload Document</md-tooltip>\n</md-icon><md-icon style=\"cursor: pointer\" hide show-gt-sm class=\"blue-700-fg pl-5 pr-5\" md-font-icon=\"icon-eye\" \nng-click=\"vm.viewDetail($event, item)\"><md-tooltip>View Detail</md-tooltip></md-icon></div></td></tr></tbody></table>\n</div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/indisciplinary-alert/indisciplinary-alert.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nWarning Letter</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmAdmin\" \nclass=\"md-inline-form\" flex ng-submit=\"vm.loadData(1)\" layout=\"row\" layout-align=\"end center\" novalidate><div layout \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"end center\" flex-gt-sm=\"30\"><md-input-container class=\"md-block\" flex>\n<label>Letter Type</label><md-select ng-model=\"vm.letter\" aria-label=\"letters\" name=\"letters\"><md-option \nng-repeat=\"ls in vm.letters\" ng-selected=\"vm.letter == ls.code\" placeholder=\"Letter Type\" ng-value=\"ls.code\">\n{{ls.name | uppercase}}</md-option></md-select><div ng-messages=\"frmAdmin.letters.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Letter field is required.</span></div></div></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmAdmin.$invalid || frmAdmin.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" \nng-click=\"vm.printPDF()\"><md-icon md-font-icon=\"icon-print\"></md-icon><span>PRINT</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\" ms-scroll><div id=\"tableIndisciplinary\"><table class=\"simple bordered stripped\" cellpadding=\"0\" \ncellspacing=\"0\" ms-responsive-table><thead><tr><th style=\"text-align: center; vertical-align: middle\" \nng-if=\"vm.isCheckAction || vm.isCheckActionPrint\"><md-checkbox \nstyle=\"transform: scale(0.6); margin: 0; margin-left: 5px\" ng-if=\"vm.isCheckAction || vm.isCheckActionPrint\" \nng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" aria-label=\"checkall\">\n</md-checkbox></th><th class=\"text-left\">No</th><th>NIK</th><th class=\"text-left\">Name</th><th class=\"text-left\">Letter\n</th><th class=\"text-left\">Type Of Action</th><th>Valid From</th><th>Valid To</th><th>Actual</th><th>Action</th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.DataTable.list\"><td style=\"text-align: center; vertical-align:middle\" \nng-if=\"vm.isCheckAction || vm.isCheckActionPrint\"><div layout=\"row\" flex layout-align=\"center\"><md-checkbox \nstyle=\"transform: scale(0.6); margin: 0\" ng-if=\"vm.isCheckAction || vm.isCheckActionPrint\" \nng-checked=\"vm.exists(item.id)\" ng-click=\"vm.toggle(item.id)\" aria-label=\"checked\"></md-checkbox></div></td><td>\n{{$index + 1}}</td><td class=\"text-center\">{{item.nik}}</td><td>{{item.name}}</td><td>{{item.letter_name}}</td><td>\n{{item.type_of_action}}</td><td class=\"text-center\">{{item.valid_from}}</td><td class=\"text-center\">{{item.valid_to}}\n</td><td class=\"text-center\"><md-icon ng-if=\"item.is_temporary==\'0\'\" class=\"md-primary\" \nmd-font-icon=\"icon-check-circle green-500-fg\"></md-icon><md-icon ng-if=\"item.is_temporary==\'1\'\" class=\"md-primary\" \nmd-font-icon=\"icon-check-circle grey-500-fg\"></md-icon></td><td class=\"text-center\"><div flex layout-align=\"row\" \nlayout=\"row\" layout><md-icon ng-if=\"item.is_temporary==\'1\'\" md-font-icon=\"icon-pencil\" \nng-click=\"vm.showFormDialog($event, \'create\', item, true)\" class=\"green-400-fg\"><md-tooltip>Create Warning Letter\n</md-tooltip></md-icon><md-icon ng-if=\"item.is_temporary==\'0\'\" md-font-icon=\"icon-pencil\" class=\"grey-400-fg\">\n<md-tooltip>Create Warning Letter</md-tooltip></md-icon></div></td></tr></tbody></table></div><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/indisciplinary-approval/indisciplinary-approval.html","<div id=\"correspondence-pma\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nIndisciplinary Approval</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout=\"row\" layout-align=\"end center\" ng-submit=\"vm.loadData(1)\" novalidate>\n<div layout=\"row\" layout-align=\"end center\" flex-gt-sm=\"30\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex><label>Approval Status</label><md-select required name=\"status\" ng-model=\"vm.status\"><md-option value=\"1\">\nWaiting Approval</md-option><md-option value=\"2\">Approved</md-option><md-option value=\"4\">Rejected</md-option>\n</md-select></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmFilter.$invalid || frmFilter.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" \nstyle=\"margin-right:5px\" layout=\"row\" layout-align=\"start center\" hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span>Entries</span></div><div class=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" \nlayout-align=\"center\" class=\"md-primary\" type=\"button\" ng-disabled=\"vm.checked.length === 0\" \nng-click=\"vm.showApproveDialog($event)\"><span style=\"font-size:12px\">Approve</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><span flex></span><ms-search-bar style=\"padding:0px\" \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" class=\"bouncy-slide-left\"></ms-search-bar>\n</div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><div \nid=\"tableIndisciplinary\"><table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table>\n<thead><tr><th style=\"text-align: center; vertical-align: middle\"></th><th class=\"text-left\">No</th><th>NIK</th><th \nclass=\"text-left\">Name</th><th class=\"text-left\">Position</th><th class=\"text-left\">Sub Area</th><th class=\"text-left\">\nLetter Name</th><th>Type Of Action</th><th class=\"text-left\">Approval type</th><th class=\"text-left\">Status</th><th>\nAction</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTable.list\"><td \nstyle=\"text-align: center; vertical-align:middle\"><div layout=\"row\" flex layout-align=\"center\"><md-checkbox \nstyle=\"transform: scale(0.7); margin: 0\" ng-checked=\"vm.exists(item)\" ng-disabled=\"item.approval_status == 2\" \nng-click=\"vm.toggle(item)\" aria-label=\"checked\"></md-checkbox></div></td><td>{{$index + 1}}</td><td \nclass=\"text-center\">{{item.nik}}</td><td>{{item.fullname}}</td><td><span>\n{{item.position | limitTo:40 }} {{ item.position.length > 40 ? \'...\' : \'\' }}</span></td><td>{{item.sub_area_name}}</td>\n<td>{{item.letter_name}}</td><td class=\"text-left\">\n{{ item.type_of_action | limitTo:30 }} {{ item.type_of_action.length > 20 ? \'...\' : \'\' }}</td><td class=\"text-left\">\n{{item.approval_type}}</td><td class=\"text-left\">{{ vm.switchStatusApproval(item.approval_status) }} <span \nng-if=\"item.approval_status == 4\"><sup style=\"color: blue; cursor: pointer\">?</sup><md-tooltip>{{item.reject_comment}}\n</md-tooltip></span></td><td class=\"text-center\"><div flex layout-align=\"row\" layout=\"row\" layout><md-icon \nng-disabled=\"item.approval_status !== \'1\'\" ng-style=\"{cursor: item.approval_status !== \'1\' ? \'disabled\' : \'pointer\'}\" \nng-class=\"{\'grey-600-fg\': item.approval_status !== \'1\'}\" class=\"red-700-fg pl-5 pr-5\" \nmd-font-icon=\"icon-account-remove\" \nng-click=\"item.approval_status !== \'1\' || vm.showRequestDialog($event, \'REJECT\', item)\"><md-tooltip>Reject</md-tooltip>\n</md-icon><md-icon ng-disabled=\"item.approval_status !== \'2\'\" \nng-style=\"{cursor: item.approval_status !== \'2\' ? \'disabled\' : \'pointer\'}\" \nng-class=\"{\'grey-600-fg\': item.approval_status !== \'2\'}\" class=\"orange-700-fg pl-5 pr-5\" \nmd-font-icon=\"icon-account-minus\" \nng-click=\"item.approval_status !== \'2\' || vm.showRequestDialog($event, \'UNAPPROVE\', item)\"><md-tooltip>Unapprove\n</md-tooltip></md-icon><md-icon ng-disabled=\"item.approval_status !== \'4\'\" \nng-style=\"{cursor: item.approval_status !== \'4\' ? \'disabled\' : \'pointer\'}\" \nng-class=\"{\'grey-600-fg\': item.approval_status !== \'4\'}\" class=\"green-700-fg pl-5 pr-5\" \nmd-font-icon=\"icon-account-plus\" \nng-click=\"item.approval_status !== \'4\' || vm.showRequestDialog($event, \'UNREJECT\', item)\"><md-tooltip>Unreject\n</md-tooltip></md-icon><md-icon style=\"cursor: pointer\" class=\"blue-700-fg pl-5 pr-5\" md-font-icon=\"icon-eye\" \nng-click=\"vm.viewDetail($event, item)\"><md-tooltip>View Detail</md-tooltip></md-icon></div></td></tr></tbody></table>\n</div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/indisciplinary-confirm/indisciplinary-confirm.html","<div id=\"correspondence-pma\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nIndisciplinary Employee Confirmation</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout=\"row\" layout-align=\"end center\" ng-submit=\"vm.loadData(1)\" novalidate>\n<div layout=\"row\" layout-align=\"end center\" flex-gt-sm=\"30\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex><label>Approval Status</label><md-select required name=\"status\" ng-model=\"vm.status\"><md-option value=\"all\">ALL\n</md-option><md-option value=\"1\">Waiting Approval</md-option><md-option value=\"2\">Approved</md-option><md-option \nvalue=\"4\">Rejected</md-option></md-select></md-input-container><md-button class=\"md-primary md-icon-button md-small\" \ntype=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmFilter.$invalid || frmFilter.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" style=\"margin-right:5px\" layout=\"row\" \nlayout-align=\"start center\" hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in [5, 10, 15, 20]\"></select><span>Entries</span></div>\n<md-button ng-click=\"vm.loadData(1)\" class=\"md-primary\">reload</md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><span flex></span><ms-search-bar style=\"padding:0px\" on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\" class=\"bouncy-slide-left\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><div id=\"tableIndisciplinary\">\n<table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th \nclass=\"text-left\">No</th><th>NIK</th><th class=\"text-left\">Name</th><th class=\"text-left\">Position</th><th \nclass=\"text-left\">Letter Name</th><th>Valid From</th><th>Valid To</th><th>Type Of Action</th><th>Reason</th><th>Action\n</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTable.list\"><td>{{$index + 1}}</td><td class=\"text-center\">\n{{item.nik}}</td><td>{{item.employee.name}}</td><td><span>\n{{item.job_title | limitTo:40 }} {{ item.job_title.length > 40 ? \'...\' : \'\' }}</span></td><td>{{item.letter_name}}</td>\n<td>{{item.valid_from}}</td><td>{{item.valid_to}}</td><td class=\"text-left\">\n{{ item.type_of_action_name | limitTo:30 }} {{ item.type_of_action_name.length > 20 ? \'...\' : \'\' }}</td><td \nclass=\"text-left\">{{item.reason}}</td><td class=\"text-center\"><md-button ng-click=\"vm.confirmStatus($event, item)\" \nng-disabled=\"item.is_confirmed == \'1\'\" class=\"md-raised md-primary md-button\"><md-icon \nmd-font-icon=\"icon-check-bookmark\"></md-icon><span>Confirm</span></md-button></td></tr></tbody></table></div><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/indisciplinary-request/indisciplinary-request.html","<div id=\"correspondence-pma\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nIndisciplinary Request</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout=\"row\" layout-align=\"end center\" ng-submit=\"vm.loadData(1)\" novalidate>\n<div layout=\"row\" layout-align=\"end center\" flex-gt-sm=\"30\" flex><md-input-container class=\"md-block\" flex><label>\nLetter Type</label><md-select required name=\"leterType\" ng-model=\"vm.leterType\"><md-option value=\"all\">ALL</md-option>\n<md-option ng-repeat=\"item in vm.letters\" ng-value=\"item.code\">{{item.name}}</md-option></md-select>\n</md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" \nng-click=\"vm.loadData(1)\" ng-disabled=\"frmFilter.$invalid || frmFilter.$pristine\"><md-icon style=\"font-size:14px\" \nmd-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" style=\"margin-right:5px\" layout=\"row\" \nlayout-align=\"start center\" hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span>Entries</span></div>\n<md-menu md-offset=\"0 -7\" flex hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 12px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-button md-ink-ripple md-mini\" type=\"button\" \nstyle=\"font-size:12px\" aria-label=\"printcost\" ng-click=\"vm.isCheckActionPrint = !vm.isCheckActionPrint\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><span style=\"font-size:12px\">PRINT</span></md-button></md-menu-item>\n<md-menu-item><md-button type=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.isCheckActionPrint\" \nclass=\"md-button md-ink-ripple md-mini\" ng-click=\"vm.showFormDialog($event, \'create\', null, false)\"><md-icon \nmd-font-icon=\"icon-clipboard-check\"></md-icon><span style=\"font-size:12px\">CREATE</span></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" \nlayout=\"row\" layout-align=\"center\" class=\"md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction || vm.isCheckActionPrint\" ng-click=\"vm.showFormDialog($event, \'create\', null, false)\">\n<md-icon style=\"font-size:12px\" md-font-icon=\"icon-clipboard-check\"></md-icon><span style=\"font-size:12px\">Create\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" \nlayout-align=\"center\" class=\"md-primary blue-700-fg custom-action\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckActionPrint || vm.isCheckAction\" ng-click=\"vm.isCheckActionPrint = !vm.isCheckActionPrint\">\n<md-icon class=\"blue-700-fg\" style=\"font-size:12px\" md-font-icon=\"icon-printer\"></md-icon><span style=\"font-size:12px\">\nPrint</span></md-button><div ng-if=\"vm.isCheckActionPrint\" class=\"divider-vertical\" hide show-gt-sm></div><md-button \nng-click=\"vm.printPDF($event)\" ng-if=\"vm.isCheckActionPrint\" ng-disabled=\"vm.checked.length == 0\" \nclass=\"md-icon-btn md-primary md-mini md-small\"><md-icon class=\"green-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span style=\"font-size:12px\">Apply</span></md-button>\n<md-button ng-click=\"vm.isCheckActionPrint = !vm.isCheckActionPrint; vm.checked = []\" ng-if=\"vm.isCheckActionPrint\" \nclass=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\">Cancel</span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar style=\"padding:0px\" on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" \nclass=\"bouncy-slide-left\"></ms-search-bar></div></md-toolbar><div layout=\"column\" layout layout-padding ms-scroll>\n<md-content class=\"list-container\"><md-list flex style=\"padding-top: 0; padding-bottom: 0\"><md-subheader \nclass=\"grey-300-bg\"><span class=\"title grey-700-fg\">REQUEST LIST</span></md-subheader><md-list-item \nclass=\"md-3-line md-dense md-no-proxy\" ng-repeat-start=\"item in vm.DataTable.list\"><md-checkbox \nng-if=\"vm.isCheckAction\" ng-disabled=\"item.action.delete\" ng-checked=\"vm.exists(item.id)\" \nng-click=\"vm.toggle(item.id)\" aria-label=\"checked\"></md-checkbox><md-checkbox ng-if=\"vm.isCheckActionPrint\" \nng-disabled=\"item.action.print\" ng-checked=\"vm.exists(item.id)\" ng-click=\"vm.toggle(item.id)\" aria-label=\"checked\">\n</md-checkbox><div class=\"md-list-item-text\"><h3 class=\"title-content\">({{item.nik}}) - {{item.name}}</h3><p \nclass=\"text-container\"><span class=\"title-text\">Jenis Surat</span> <span class=\"spacer-text\">:</span> <span \nclass=\"content\">{{item.letter_name | uppercase }}</span><br><span class=\"title-text\">Jenis Tindakan</span> <span \nclass=\"spacer-text\">:</span> <span class=\"content\">{{item.type_of_action}}</span><br></p></div><div \nclass=\"md-secondary\"><md-button hide show-gt-sm ng-if=\"item.type === \'normal\'\" class=\"md-icon-button\" ng-click=\"null\">\n<md-icon ng-class=\"{\'green-400-fg\' : vm.isApproved(item.approval), \'orange-400-fg\': !vm.isApproved(item.approval)}\" \nmd-font-icon=\"icon-clipboard-check\"><md-tooltip>{{ vm.isApproved(item.approval) ? \'Approved\' : \'Waiting\' }}\n</md-tooltip></md-icon></md-button><md-button hide show-gt-sm ng-if=\"item.type === \'normal\'\" class=\"md-icon-button\" \nng-click=\"vm.importDocument($event, item)\"><md-icon \nng-class=\"{\'orange-700-fg\' : item.is_document_uploaded === \'0\', \'green-700-fg\': item.is_document_uploaded === \'1\' }\" \nmd-font-icon=\"icon-document\"><md-tooltip>Upload Document</md-tooltip></md-icon></md-button><md-button hide show-gt-sm \nclass=\"md-icon-button\" ng-click=\"vm.viewDetail($event, item)\"><md-icon class=\"cyan-700-fg\" md-font-icon=\"icon-eye\">\n<md-tooltip>View Detail</md-tooltip></md-icon></md-button><md-button hide show-gt-sm class=\"md-icon-button md-warn\" \nng-click=\"vm.viewNotes($event, item)\" ng-if=\"item.type === \'confirm\' && item.is_valid != 1\"><md-icon \nclass=\"cyan-700-fg\" style=\"cursor: pointer\" md-font-icon=\"icon-pencil\"><md-tooltip>Update</md-tooltip></md-icon>\n</md-button><md-button hide ng-if=\"item.company == \'PM\'\" show-gt-sm ng-disabled=\"vm.isApproved(item.approval)\" \nclass=\"md-icon-button md-warn\" ng-click=\"vm.showDeleteDialog($event, item)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip>{{ vm.isApproved(item.approval) ? \'This request is already approved\' : \'Delete\' }}</md-tooltip>\n</md-button><md-button hide show-gt-sm ng-if=\"item.company == \'KS\' || item.company == \'RK\'\" \nng-disabled=\"vm.isApproved(item.approval) || item.is_valid == 1\" class=\"md-icon-button md-warn\" \nng-click=\"vm.showDeleteDialog($event, item)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>\n{{ vm.isApproved(item.approval) ? \'This request is already approved\' : \'Delete\' }}</md-tooltip></md-button><md-menu \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.viewDetail($event, item)\"><md-icon class=\"cyan-700-fg\" md-font-icon=\"icon-eye\"><md-tooltip>\nView Detail</md-tooltip></md-icon>View Detail</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.importDocument($event, item)\"><md-icon \nng-class=\"{\'orange-700-fg\' : item.is_document_uploaded === \'0\', \'green-700-fg\': item.is_document_uploaded === \'1\' }\" \nmd-menu-align-target md-font-icon=\"icon-document\"></md-icon>Document</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item ng-if=\"item.company == \'PM\'\"><md-button ng-click=\"vm.showDeleteDialog($event, item)\">\n<md-icon ng-class=\"{\'grey-400-fg\' : vm.isApproved(item.approval), \'red-400-fg\': !vm.isApproved(item.approval)}\" \nmd-menu-align-target md-font-icon=\"icon-trash\"></md-icon>DELETE</md-button></md-menu-item><md-menu-item \nng-if=\"item.company == \'KS\' || item.company == \'RK\'\"><md-button ng-disabled=\"item.is_valid == 1\" \nng-click=\"vm.showDeleteDialog($event, item)\"><md-icon \nng-class=\"{\'grey-400-fg\' : item.is_valid == 1, \'red-400-fg\':  item.is_valid == 0}\" md-menu-align-target \nmd-font-icon=\"icon-trash\"></md-icon>DELETE</md-button></md-menu-item></md-menu-content></md-menu></div></md-list-item>\n<md-divider ng-repeat-end></md-divider></md-list></md-content></div><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/indisciplinary-validation/indisciplinary-validation.html","<div id=\"correspondence-pma\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nIndisciplinary Validation</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout=\"row\" layout-align=\"end center\" ng-submit=\"vm.loadData(1)\" novalidate>\n<div layout=\"row\" layout-align=\"end center\" flex-gt-sm=\"60\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex><label>Sub Area</label><md-select required name=\"sub_area\" ng-model=\"vm.subArea\"><md-option \nng-repeat=\"item in vm.listSubArea\" ng-value=\"item.subarea_id\">{{item.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Status</label><md-select required name=\"status\" \nng-model=\"vm.status\"><md-option value=\"all\">ALL</md-option><md-option value=\"0\">REGISTER</md-option><md-option \nvalue=\"1\">VALID</md-option><md-option value=\"2\">INVALID</md-option></md-select></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmFilter.$invalid\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button>\n</div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools no-padding\">\n<div class=\"select-entries\" style=\"margin-right:5px\" layout=\"row\" layout-align=\"start center\" hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in [5, 10, 15, 20]\"></select><span>Entries</span></div><span flex></span><ms-search-bar \nstyle=\"padding:0px\" on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" \nclass=\"bouncy-slide-left\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\" ms-scroll><div id=\"tableIndisciplinary\"><table class=\"simple bordered stripped\" \ncellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th class=\"text-left\">No</th><th>NIK</th><th \nclass=\"text-left\">Name</th><th class=\"text-left\">Position</th><th class=\"text-left\">Area</th><th class=\"text-left\">\nLetter Name</th><th>Type Of Action</th><th>Reason</th><th>Status</th><th>Action</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTable.list\"><td>{{$index + 1}}</td><td class=\"text-center\">{{item.nik}}</td><td>\n{{item.employee.name}}</td><td><span>{{item.job_title | limitTo:40 }} {{ item.job_title.length > 40 ? \'...\' : \'\' }}\n</span></td><td class=\"text-left\">{{item.sub_area_name}}</td><td>{{item.letter_name}}</td><td class=\"text-left\">\n{{ item.type_of_action_name | limitTo:30 }} {{ item.type_of_action_name.length > 20 ? \'...\' : \'\' }}</td><td \nclass=\"text-left\">{{item.reason}}</td><td class=\"text-center\">{{vm.getStatus(item.is_valid)}}</td><td \nclass=\"text-center\"><md-button \nng-class=\"{\'md-primary\': item.is_valid == 1, \'md-accent\': item.is_valid == 0, \'md-warn\': item.is_valid == 2}\" \nng-click=\"vm.updateForm($event, item)\" class=\"md-raised md-button\"><md-icon md-font-icon=\"icon-check-bookmark\">\n</md-icon><span>Check</span></md-button></td></tr></tbody></table></div><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-adjustment-kpi/insentif-adjustment-kpi-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.ADJUSTKPI\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\">\n</label><md-select ng-model=\"vm.Form.objForm.channel\" ng-change=\"vm.getWilayah(vm.Form.objForm.channel)\" \nname=\"channel\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\"></label><md-select \nng-model=\"vm.Form.objForm.wilayah\" name=\"wilayah\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah\">{{ls.name}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.CRITERIA\"></span></label><md-select \nng-model=\"vm.Form.objForm.criteria\" name=\"criteria{{parentIndex}}\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"criteria\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select>\n<div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.CRITERIA\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.DECREASEPERCENTAGE\"></span></label><input name=\"percentage{{parentIndex}}\" \nng-model=\"vm.Form.objForm.percentage\" placeholder=\"{{ \'PAYROLL.MENU.DECREASEPERCENTAGE\' | translate}}\" required \ntype=\"number\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label \ntranslate=\"KPI.LABEL.PRINCIPAL\"></label><md-select multiple=\"true\" ng-model=\"vm.Form.objForm.principal\" \nname=\"principal\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a principal...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"principal\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listPrincipal | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"MENU.MAIN.SALESTYPE\"></label><md-select \nmultiple=\"true\" ng-model=\"vm.Form.objForm.ref_sales_type_id\" name=\"ref_sales_type_id\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sales type...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"ref_sales_type_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesType | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><label translate=\"PAYROLL.MENU.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"PAYROLL.MENU.ENDDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" \nng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div ng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-adjustment-kpi/insentif-adjustment-kpi.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ADJUSTKPI\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"PAYROLL.MENU.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.ENDDATE\">\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.end_date\"></md-datepicker><div \nng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.CRITERIA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.DECREASEPERCENTAGE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span\n translate=\"KPI.LABEL.WILAYAH\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.STARTDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.ENDDATE\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" ng-dblclick=\"vm.editData($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.kpi}}</td><td class=\"text-center\">\n{{item.percentage}}</td><td class=\"text-center\">{{item.region}}</td><td class=\"text-center\">\n{{item.start_date | date : \'dd MMMM yyyy\'}}</td><td class=\"text-center\">{{item.end_date | date : \'dd MMMM yyyy\'}}</td>\n<td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" \nflex><md-tooltip><span translate=\"KPI.LABEL.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-pencil\"></md-icon><p flex><span translate=\"KPI.LABEL.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-adjustment-kpi/view-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.SCHEMAINCENTIVEOVERRIDE\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nflex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMNO\"></label><input readonly=\"readonly\" type=\"text\" \nng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" required><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\">\n</label><md-datepicker ng-disabled=\"true\" md-hide-icons=\"calendar\" name=\"surkom_date\" \nng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div ng-messages=\"frmBT.surkom_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.nik\" name=\"nik\" \nreadonly=\"readonly\" required><div ng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NIK\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\"></label><md-select \nng-disabled=\"true\" ng-model=\"vm.Form.objForm.channel\" ng-change=\"vm.getWilayah(vm.Form.objForm.channel)\" \nname=\"channel\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select \nng-disabled=\"true\" ng-model=\"vm.Form.objForm.schema_object\" name=\"schema_object\" ng-required=\"true\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeObject\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.scheme_type\" name=\"scheme_type\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSchemeType\">{{ls.name}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-disabled=\"true\" ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-disabled=\"true\" \nng-disabled=\"true\" ng-model=\"vm.Form.objForm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><fieldset \nstyle=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" ng-repeat=\"ls in vm.listKpi\"><legend>KPI {{parentIndex+1}}\n</legend><div layout=\"row\" ng-if=\"vm.listKpi[parentIndex].showIsSkuFocus==1\"><md-checkbox ng-disabled=\"true\" \nclass=\"no-label\" ng-checked=\"vm.listKpi[parentIndex].is_checked\" \nng-click=\"vm.checkIsSKUFocus(vm.listKpi[parentIndex])\" ng-model=\"vm.listKpi[parentIndex].is_sku_focus\" aria-label=\"\">\n<span translate=\"KPI.LABEL.ISSKUFOCUS\"></span></md-checkbox></div><br><div layout=\"row\"><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.CRITERIA\"></span></label><md-select ng-disabled=\"true\" \nng-model=\"vm.listKpi[parentIndex].criteria\" name=\"criteria{{parentIndex}}\" \nng-change=\"vm.changeCriteria(vm.listKpi[parentIndex],vm.listKpi[parentIndex].criteria)\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"criteria\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.CRITERIA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.WEIGHT\"></span>\n</label><input readonly=\"readonly\" name=\"weight{{parentIndex}}\" ng-model=\"vm.listKpi[parentIndex].weight\" \nplaceholder=\"{{ \'KPI.LABEL.WEIGHT\' | translate}}\" required type=\"number\"></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.listKpi[parentIndex].criteria==3\" flex><label><span translate=\"KPI.LABEL.TARGET\"></span></label><input \nreadonly=\"readonly\" name=\"target{{parentIndex}}\" ng-model=\"vm.listKpi[parentIndex].target\" \nplaceholder=\"{{ \'KPI.LABEL.TARGET\' | translate}}\" required type=\"number\"></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.listKpi[parentIndex].criteria==1\"><md-input-container flex><label><span>SKU Requirements\n</span></label><input type=\"text\" ng-model=\"vm.listKpi[parentIndex].skuid\" name=\"nik\" readonly=\"readonly\" required>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.DECREASEPERCENTAGE\"></span></label>\n<input name=\"percentage_requirement\" ng-model=\"vm.listKpi[parentIndex].percentage_requirement\" \nplaceholder=\"{{ \'PAYROLL.MENU.DECREASEPERCENTAGE\' | translate}}\" type=\"number\"><div \nng-messages=\"frmBT.percentage_requirement.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.DECREASEPERCENTAGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><label class=\"text-grey\">\n<span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm>\n<div style=\"padding: 2px\"><textarea rows=\"2\" ng-model=\"vm.listKpi[parentIndex].description\" ng-disabled=\"true\" \nng-required=\"true\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"achIndex = $index\" \nng-repeat=\"lsach in vm.listKpi[parentIndex].ach\"><legend><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> *</legend><div\n layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.STARTRANGE\"></span></label><input \nreadonly=\"readonly\" type=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].start_range\" \nname=\"start_range{{parentIndex}}\" required><div ng-messages=\"frmBT.start_range.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTRANGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label>\n<md-input-container flex><label><span translate=\"KPI.LABEL.ENDRANGE\"></span></label><input readonly=\"readonly\" \ntype=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].end_range\" name=\"end_range{{parentIndex}}\" required><div \nng-messages=\"frmBT.end_range.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDRANGE\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span></label><input readonly=\"readonly\" type=\"number\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].multiple_index\" name=\"multiple_index{{parentIndex}}\"><div \nng-messages=\"frmBT.multiple_index.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.Form.objForm.channel==\'MT\'\" flex><label><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span></label><input \nreadonly=\"readonly\" type=\"text\" maxlength=\"1\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].achievement\" \nname=\"achievement{{parentIndex}}\"><div ng-messages=\"frmBT.achievement.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><th class=\"text-center\" \nng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.header}}</span></th></tr></thead><tbody><tr \nng-init=\"childIndex = $index\" ng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><input readonly=\"readonly\" \nname=\"amount{{childIndex2}}\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].sales_type[childIndex].cols[childIndex2].data\" required type=\"number\">\n</td></tr></tbody></table></md-content></div></fieldset></fieldset></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/insentif-adjustment-target-absolute/input-insentif-adjustment-target-absolute.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"frmBT\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmBT)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.ADJUSTABSOLUTE\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"row\"><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.BANO\"></label>\n<input type=\"text\" ng-model=\"vm.Form.objForm.ba_no\" name=\"ba_no\" ng-required=\"true\"><div \nng-messages=\"frmBT.ba_no.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.BANO\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"MENU.MAIN.BADATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"ba_date\" \nng-model=\"vm.Form.objForm.ba_date\" ng-required=\"vm.roa\"></md-datepicker><div ng-messages=\"frmBT.ba_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.BADATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"MENU.MAIN.BACREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchStringUser\" \nmd-items=\"item in vm.getEmployee(vm.searchStringUser)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChangedUser(vm.Form.objForm.nik)\" ng-required=\"true\"><md-item-template><span \nmd-highlight-text=\"vm.searchStringUser\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.PERCENTAGE\"></label><input type=\"number\" \nng-model=\"vm.Form.objForm.percentage\" ng-required=\"true\" name=\"percentage\"><div ng-messages=\"frmBT.percentage.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.PERCENTAGE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label style=\"margin-top: 25px\" \nflex=\"10\"><span>%</span></label><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.STARTDATE\"></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required>\n</md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.ENDDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div \nng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-adjustment-target-absolute/insentif-adjustment-target-absolute.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ADJUSTABSOLUTE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm><label \ntranslate=\"PAYROLL.MENU.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.ENDDATE\">\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"ba_date\" ng-model=\"vm.end_date\"></md-datepicker><div \nng-messages=\"frmBT.ba_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" \nlayout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div\n class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputData($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listSelected.length == 0\" ng-click=\" vm.Delete()\"><md-icon ng-if=\"vm.listSelected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listSelected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.BANO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.BADATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.BACREATOR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PERCENTAGE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.STARTDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.ENDDATE\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editData($event,ls)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ls.ba_no}}</td><td class=\"text-center\">{{ls.ba_date_name}}</td><td \nclass=\"text-left\">{{ls.ba_creator}} - {{ls.ba_creator_name}}</td><td class=\"text-right\">{{ls.percentage}}%</td><td \nclass=\"text-center\">{{ls.start_date_name}}</td><td class=\"text-center\">{{ls.end_date_name}}</td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, ls)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"ACTION.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"11\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-approval/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.rejected_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span><md-button \nng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/insentif-approval/insentif-approval-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"UMUT.MENU.INSENTIFAPPROVAL\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset style=\"margin-bottom: 30px\" ng-repeat=\"list in vm.results\"><legend>\n{{list.empname}}</legend><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in list.header\"><th class=\"text-center\" ng-repeat=\"col in row.cols\"><span class=\"column-title\">\n{{col.header}}</span></th></tr></thead><tbody><tr ng-init=\"childIndex = $index\" ng-repeat=\"row in list.header\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.data}}\n</span></td></tr></tbody></table><br><br><table ng-if=\"list.data.length>0\" class=\"simple with-toolbar bordered\" \nms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"HCTICKET.MENU.NO\"></span>\n</span></th><th class=\"text-center\"><span class=\"column-title\">KRITERIA</span></th><th class=\"text-center\"><span \nclass=\"column-title\">KETERANGAN</span></th><th class=\"text-center\"><span class=\"column-title\">TARGET</span></th><th \nclass=\"text-center\"><span class=\"column-title\">REAL(*)</span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\">ACH</span></th><th class=\"text-center\"><span class=\"column-title\">NILAI INSENTIF</span></th></tr>\n</thead><tbody ng-repeat=\"ls in list.data track by $index\"><tr ng-repeat=\"item in ls.data\"><td \nrowspan=\"{{ls.data.length}}\" ng-hide=\"$index>0\" class=\"text-center\">{{(ls.order)}}</td><td \nrowspan=\"{{ls.data.length}}\" ng-hide=\"$index>0\" class=\"text-left\">{{ls.criteria}}</td><td class=\"text-left\">\n{{item.description}}</td><td class=\"text-right\">{{item.target}}</td><td class=\"text-right\">{{item.real}}</td><td \nclass=\"text-center\">{{item.ach}}%</td><td rowspan=\"{{ls.data.length}}\" ng-hide=\"$index>0\" class=\"text-right\">\n{{ls.incentive_value}}</td></tr></tbody></table><br><table ng-if=\"list.data.length>0\" \nclass=\"simple with-toolbar bordered\" ms-responsive-table><tbody><tr><td class=\"text-center\">TOTAL INSENTIF</td><td \nwidth=\"10%\" class=\"text-right\">{{list.total}}</td></tr><tr><td class=\"text-center\">PENALTY (SCAN BARCODE)</td><td \nwidth=\"10%\" class=\"text-right\">{{list.barcode}}</td></tr><tr><td class=\"text-center\">PENALTY (SP)</td><td width=\"10%\" \nclass=\"text-right\">{{list.sp}}</td></tr><tr><td class=\"text-center\">TOTAL INSENTIF YANG DIBAYARKAN</td><td width=\"10%\" \nclass=\"text-right\">{{list.endTotal}}</td></tr></tbody></table></fieldset></md-dialog-content><md-dialog-actions \nlayout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-approval/insentif-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"UMUT.MENU.INSENTIFAPPROVAL\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formGHK\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span></div><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><md-select \nng-model=\"vm.type\" name=\"type\" required ng-change=\"vm.loadData(1)\"><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}\n</md-option></md-select><div ng-messages=\"formGHK.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nType field is required.</span></div></div></md-input-container><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"formGHK.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"formGHK.subperiod.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"formGHK.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><i class=\"icon icon-search\"></i> Search</md-button></form></div>\n</div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nng-if=\"vm.type==\'waiting approval\'\" width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><i class=\"icon-delete\"></i> <span>Reject</span></md-button>\n</md-menu-item></md-menu-content><md-menu-content ng-if=\"vm.type==\'approved\'\" width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.unapproveAll($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Un-Approve\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=\"vm.type==\'approved\'\" \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.unapproveAll($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nUn-Approve</md-tooltip><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\"></span></md-button><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.approveOT($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Approve</md-tooltip><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.APPROVE\">Aprove</span></md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Reject</md-tooltip><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.REJECT\">Reject</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\"><span \nng-if=\"vm.type ==\'waiting approval\' || vm.type ==\'approved\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NAME\"></span></span></th><th class=\"\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.JOBTITLE\"></span></span></th><th class=\"\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PERIOD\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.INSENTIF\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UPLOADEDBY\"></span></span></th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.STATUS\">\nApproval Status</th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==\'0\' || ls.approval==\'1\'\"><input \ntype=\"checkbox\" checklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td class=\"text-center\">\n{{($index + 1)}}</td><td class=\"\">{{ls.nik}}/{{ls.nama}}</td><td class=\"\">{{ls.job_title}}</td><td class=\"\">\n{{ls.sub_area}}</td><td class=\"text-center\">{{ls.period}}</td><td class=\"text-center\">{{ls.insentif | currency:\"\"}}\n</td><td class=\"text-center\"><span>{{ls.created_by}}/{{ls.created_name}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.approval!==\'2\'\">{{ls.status}}</span> <span ng-if=\"ls.approval==\'2\'\"><a href=\"\" \nng-click=\"vm.viewComment($event,ls)\">{{ls.status}}</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span>\n</td><td class=\"text-center\"><md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" aria-label=\"Flip widget\"><span>Detail\n</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==\'1\'\"><md-button \nng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==\'2\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"13\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-approval-ass/comment-reject-ass.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.rejected_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span><md-button \nng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/insentif-approval-ass/insentif-approval-ass-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"UMUT.MENU.INSENTIFAPPROVALASS\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset style=\"margin-bottom: 30px\" ng-repeat=\"list in vm.results\"><legend>\n{{list.empname}}</legend><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in list.header\"><th class=\"text-center\" ng-repeat=\"col in row.cols\"><span class=\"column-title\">\n{{col.header}}</span></th></tr></thead><tbody><tr ng-init=\"childIndex = $index\" ng-repeat=\"row in list.header\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.data}}\n</span></td></tr></tbody></table><br><br><table ng-if=\"list.data.length>0\" class=\"simple with-toolbar bordered\" \nms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"HCTICKET.MENU.NO\"></span>\n</span></th><th class=\"text-center\"><span class=\"column-title\">KRITERIA</span></th><th class=\"text-center\"><span \nclass=\"column-title\">KETERANGAN</span></th><th class=\"text-center\"><span class=\"column-title\">TARGET</span></th><th \nclass=\"text-center\"><span class=\"column-title\">REAL(*)</span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\">ACH</span></th><th class=\"text-center\"><span class=\"column-title\">NILAI INSENTIF</span></th></tr>\n</thead><tbody ng-repeat=\"ls in list.data track by $index\"><tr ng-repeat=\"item in ls.data\"><td \nrowspan=\"{{ls.data.length}}\" ng-hide=\"$index>0\" class=\"text-center\">{{(ls.order)}}</td><td \nrowspan=\"{{ls.data.length}}\" ng-hide=\"$index>0\" class=\"text-left\">{{ls.criteria}}</td><td class=\"text-left\">\n{{item.description}}</td><td class=\"text-right\">{{item.target}}</td><td class=\"text-right\">{{item.real}}</td><td \nclass=\"text-center\">{{item.ach}}%</td><td rowspan=\"{{ls.data.length}}\" ng-hide=\"$index>0\" class=\"text-right\">\n{{ls.incentive_value}}</td></tr></tbody></table><br><table ng-if=\"list.data.length>0\" \nclass=\"simple with-toolbar bordered\" ms-responsive-table><tbody><tr><td class=\"text-center\">TOTAL INSENTIF</td><td \nwidth=\"10%\" class=\"text-right\">{{list.total}}</td></tr><tr><td class=\"text-center\">PENALTY (SCAN BARCODE)</td><td \nwidth=\"10%\" class=\"text-right\">{{list.barcode}}</td></tr><tr><td class=\"text-center\">PENALTY (SP)</td><td width=\"10%\" \nclass=\"text-right\">{{list.sp}}</td></tr><tr><td class=\"text-center\">TOTAL INSENTIF YANG DIBAYARKAN</td><td width=\"10%\" \nclass=\"text-right\">{{list.endTotal}}</td></tr></tbody></table></fieldset></md-dialog-content><md-dialog-actions \nlayout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-approval-ass/insentif-approval-ass.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"UMUT.MENU.INSENTIFAPPROVALASS\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formGHK\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<md-select ng-model=\"vm.type\" name=\"type\" required ng-change=\"vm.loadData(1)\"><md-option \nng-repeat=\"val in vm.listType\" placeholder=\"{{ \'MENU.CB.APPROVAL_GHK.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" \nvalue=\"{{val}}\">{{val | uppercase}}</md-option></md-select><div ng-messages=\"formGHK.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Month</label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"formGHK.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Month is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"formGHK.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><i class=\"icon icon-search\"></i> Search</md-button></form></div>\n</div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nng-if=\"vm.type==\'waiting approval\'\" width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><i class=\"icon-delete\"></i> <span>Reject</span></md-button>\n</md-menu-item></md-menu-content><md-menu-content ng-if=\"vm.type==\'approved\'\" width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.unapproveAll($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Un-Approve\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=\"vm.type==\'approved\'\" \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.unapproveAll($event)\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nUn-Approve</md-tooltip><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\"></span></md-button><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.approveOT($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Approve</md-tooltip><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.APPROVE\">Aprove</span></md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Reject</md-tooltip><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.REJECT\">Reject</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\"><span \nng-if=\"vm.type ==\'waiting approval\' || vm.type ==\'approved\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NAME\"></span></span></th><th class=\"\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.JOBTITLE\"></span></span></th><th class=\"\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PERIOD\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.INSENTIF\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UPLOADEDBY\"></span></span></th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.STATUS\">\nApproval Status</th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==\'0\' || ls.approval==\'1\'\"><input \ntype=\"checkbox\" checklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td class=\"text-center\">\n{{($index + 1)}}</td><td class=\"\">{{ls.nik}}/{{ls.nama}}</td><td class=\"\">{{ls.job_title}}</td><td class=\"\">\n{{ls.sub_area}}</td><td class=\"text-center\">{{ls.period}}</td><td class=\"text-center\">{{ls.insentif | currency:\"\"}}\n</td><td class=\"text-center\"><span>{{ls.created_by}}/{{ls.created_name}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.approval!==\'2\'\">{{ls.status}}</span> <span ng-if=\"ls.approval==\'2\'\"><a href=\"\" \nng-click=\"vm.viewComment($event,ls)\">{{ls.status}}</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span>\n</td><td class=\"text-center\"><md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" aria-label=\"Flip widget\"><span>Detail\n</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==\'1\'\"><md-button \nng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==\'2\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"13\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-barcode/insentif-barcode-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.INCENTIVEBARCODE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.AREA\">\n</label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" \nng-change=\"vm.getSalesCode(vm.Form.objForm.area_sales_id)\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SALESCODE\"></label>\n<md-select ng-model=\"vm.Form.objForm.ref_sales_code_id\" name=\"ref_sales_code_id\" required><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSalesCode\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.ref_sales_code_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.SALESCODE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.INCENTIVEBARCODE\"></label><input \ntype=\"number\" ng-model=\"vm.Form.objForm.barcode\" name=\"barcode\" required><div ng-messages=\"frmBT.barcode.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.INCENTIVEBARCODE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label style=\"margin-top: 25px\" \nflex=\"10\"><span>%</span></label></div><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"FILTER.YEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.year\" name=\"year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmEmploye.year.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"FILTER.YEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.month\" name=\"month\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"month\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmEmploye.month.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/insentif-barcode/insentif-barcode.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.INCENTIVEBARCODE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label>\n<md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" \nng-change=\"vm.getSalesCode(vm.Form.objForm.area_sales_id)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SALESCODE\"></label><md-select \nng-model=\"vm.Form.objForm.ref_sales_code_id\" name=\"ref_sales_code_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSalesCode\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.ref_sales_code_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.SALESCODE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon\n hide class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" \nlayout-align=\"space-between center\" layout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" \nhide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload\n</md-tooltip><md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>Upload\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nwidth=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.AREA\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.SALESCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.INCENTIVEBARCODE\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"FILTER.YEAR\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"FILTER.MONTH\"></span></span></th><th width=\"5%\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td \nclass=\"\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.area}}</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.sales_code}}</td><td \nclass=\"text-right\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.barcode}}%</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.year}}</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.month_name}}</td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"ACTION.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-barcode/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insentif-barcode-bsr/insentif-barcode-bsr-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.INCENTIVEBARCODE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_number\" \nname=\"surkom_number\" ng-required=\"vm.roa\"><div ng-messages=\"frmBT.surkom_number.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" ng-required=\"vm.roa\">\n</md-datepicker><div ng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label>\n<md-autocomplete style=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchStringUser\" \nmd-items=\"item in vm.getEmployee(vm.searchStringUser)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChangedUser(vm.Form.objForm.nik)\" ng-required=\"vm.roa\"><md-item-template><span \nmd-highlight-text=\"vm.searchStringUser\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" \nname=\"area_sales_id\" ng-change=\"vm.getSalesCode(vm.Form.objForm.area_sales_id)\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"area_sales_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.SALESCODE\"></label><md-select ng-model=\"vm.Form.objForm.ref_sales_code_id\" \nname=\"ref_sales_code_id\" required><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesCode\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"frmEmploye.ref_sales_code_id.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.SALESCODE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.INCENTIVEBARCODE\"></label><input \ntype=\"number\" ng-model=\"vm.Form.objForm.barcode\" name=\"barcode\" required><div ng-messages=\"frmBT.barcode.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.INCENTIVEBARCODE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label style=\"margin-top: 25px\" \nflex=\"10\"><span>%</span></label></div><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"FILTER.YEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.year\" name=\"year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmEmploye.year.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"FILTER.YEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.month\" name=\"month\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"month\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmEmploye.month.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/insentif-barcode-bsr/insentif-barcode-bsr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.INCENTIVEBARCODE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label>\n<md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" \nng-change=\"vm.getSalesCode(vm.Form.objForm.area_sales_id)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SALESCODE\"></label><md-select \nng-model=\"vm.Form.objForm.ref_sales_code_id\" name=\"ref_sales_code_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSalesCode\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.ref_sales_code_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.SALESCODE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon\n hide class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" \nlayout-align=\"space-between center\" layout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" \nhide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload\n</md-tooltip><md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>Upload\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nwidth=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.SURKOMNO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.SURKOMDATE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.SURKOMCREATOR\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.AREA\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.SALESCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.INCENTIVEBARCODE\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"FILTER.YEAR\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"FILTER.MONTH\"></span></span></th><th width=\"5%\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.surkom_number}}</td>\n<td class=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.surkom_date}}\n</td><td class=\"text-left\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n{{item.surkom_by}} - {{item.surkom_by_name}}</td><td class=\"text-left\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.area}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.sales_code}}</td><td class=\"text-right\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.barcode}}%</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.year}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.month_name}}</td><td class=\"text-center\"><section \nlayout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-barcode-bsr/log-fail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Log</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"\">Row</th><th class=\"text-center\">Note</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.logFail\"><td class=\"text-left\">{{ls.row}}</td><td class=\"text-left\">{{ls.note}}</td></tr></tbody>\n</table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/insentif-barcode-bsr/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insentif-calculation/insentif-calculation.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CALCULATION\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container class=\"drop-mod\" \nflex><label><span translate=\"FILTER.YEAR\"></span></label><md-select ng-model=\"vm.year\" name=\"year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmEmploye.year.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"FILTER.YEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span>\n</label><md-select ng-model=\"vm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmEmploye.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" \nng-change=\"vm.getSalesCode(vm.Form.objForm.area_sales_id)\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SALESCODE\"></label>\n<md-select ng-model=\"vm.sales_code\" name=\"sales_code\" required><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSalesCode\">{{ls.name}}</md-option></md-select><div ng-messages=\"frmEmploye.sales_code.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.SALESCODE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container layout=\"column\" \nstyle=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" aria-label=\"search\">\n<md-icon hide class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container><md-input-container layout=\"column\" \nstyle=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.download(1)\" \nclass=\"md-mini md-raised md-primary\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" aria-label=\"search\">\n<md-icon hide class=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"download\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></md-input-container></div></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><fieldset style=\"margin-bottom: 30px\" ng-repeat=\"list in vm.results\">\n<legend>{{list.empname}}</legend><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in list.header\"><th class=\"text-center\" ng-repeat=\"col in row.cols\"><span class=\"column-title\">\n{{col.header}}</span></th></tr></thead><tbody><tr ng-init=\"childIndex = $index\" ng-repeat=\"row in list.header\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.data}}\n</span></td></tr></tbody></table><br><br><table ng-if=\"list.data.length>0\" class=\"simple with-toolbar bordered\" \nms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"HCTICKET.MENU.NO\"></span>\n</span></th><th class=\"text-center\"><span class=\"column-title\">KRITERIA</span></th><th class=\"text-center\"><span \nclass=\"column-title\">KETERANGAN</span></th><th class=\"text-center\"><span class=\"column-title\">TARGET</span></th><th \nclass=\"text-center\"><span class=\"column-title\">REAL(*)</span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\">ACH</span></th><th class=\"text-center\"><span class=\"column-title\">NILAI INSENTIF</span></th></tr>\n</thead><tbody ng-repeat=\"ls in list.data track by $index\"><tr ng-repeat=\"item in ls.data\"><td \nrowspan=\"{{ls.data.length}}\" ng-hide=\"$index>0\" class=\"text-center\">{{(ls.order)}}</td><td \nrowspan=\"{{ls.data.length}}\" ng-hide=\"$index>0\" class=\"text-left\">{{ls.criteria}}</td><td class=\"text-left\">\n{{item.description}}</td><td class=\"text-right\">{{item.target}}</td><td class=\"text-right\">{{item.real}}</td><td \nclass=\"text-center\">{{item.ach}}%</td><td rowspan=\"{{ls.data.length}}\" ng-hide=\"$index>0\" class=\"text-right\">\n{{ls.incentive_value}}</td></tr></tbody></table><br><table ng-if=\"list.data.length>0\" \nclass=\"simple with-toolbar bordered\" ms-responsive-table><tbody><tr><td class=\"text-center\">TOTAL INSENTIF</td><td \nwidth=\"10%\" class=\"text-right\">{{list.total}}</td></tr><tr><td class=\"text-center\">PENALTY (SCAN BARCODE)</td><td \nwidth=\"10%\" class=\"text-right\">{{list.barcode}}</td></tr><tr><td class=\"text-center\">PENALTY (SP)</td><td width=\"10%\" \nclass=\"text-right\">{{list.sp}}</td></tr><tr><td class=\"text-center\">TOTAL INSENTIF YANG DIBAYARKAN</td><td width=\"10%\" \nclass=\"text-right\">{{list.endTotal}}</td></tr></tbody></table></fieldset><fieldset class=\"text-center\" \nng-if=\"vm.isEmptyObject(vm.results)\"><span translate=\"KPI.LABEL.NODATA\">No Data Available</span></fieldset>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-calculationass/insentif-calculationass.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CALCULATION\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container class=\"drop-mod\" \nflex><label><span translate=\"FILTER.YEAR\"></span></label><md-select ng-model=\"vm.year\" name=\"year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmEmploye.year.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"FILTER.YEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span>\n</label><md-select ng-model=\"vm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmEmploye.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label>\nArea</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a area...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" aria-label=\"search\">\n<md-icon hide class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><fieldset style=\"margin-bottom: 30px\" ng-repeat=\"list in vm.results\">\n<legend>{{list.empname}}</legend><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in list.header\"><th class=\"text-center\" ng-repeat=\"col in row.cols\"><span class=\"column-title\">\n{{col.header}}</span></th></tr></thead><tbody><tr ng-init=\"childIndex = $index\" ng-repeat=\"row in list.header\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.data}}\n</span></td></tr></tbody></table><br><br><table ng-if=\"list.data.length>0\" class=\"simple with-toolbar bordered\" \nms-responsive-table><thead><tr><th width=\"5%\" rowspan=\"2\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\">\nNAMA SALESMAN</span></th><th class=\"text-center\" width=\"30%\" rowspan=\"2\"><span class=\"column-title\">TIM</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\">DIVISI</span></th><th class=\"text-center\" \nng-repeat=\"lsH1 in list.subHeader1\" colspan=\"{{lsH1.cols}}\"><span class=\"column-title\">{{lsH1.contentSubHeader1}}\n</span></th></tr><tr><th class=\"text-center\" ng-repeat=\"lsH in list.subHeader\"><span class=\"column-title\">\n{{ lsH.contentSubHeader }}</span></th></tr></thead><tbody ng-repeat=\"ls in list.data track by $index\"><td \nclass=\"text-right\">{{$index+1}}</td><td class=\"text-left\">{{ls.nama_salesman}}</td><td class=\"text-left\">{{ls.tim}}\n</td><td class=\"text-center\">{{ls.divisi}}</td><td class=\"text-right\" ng-repeat=\"lsv in ls.values\">\n{{lsv.value | currency:\"\"}}</td></tbody><tbody ng-repeat=\"ls in list.subTotal track by $index\"><td class=\"text-center\" \ncolspan=\"4\"><b>SUB TOTAL</b></td><td class=\"text-right\" ng-repeat=\"lsv in ls.values\"><b>{{lsv.value | currency:\"\"}}</b>\n</td></tbody><tbody ng-repeat=\"ls in list.ach track by $index\"><td class=\"text-center\" colspan=\"4\"><b>ACH (%)</b></td>\n<td class=\"text-center\" ng-repeat=\"lsv in ls.values\" colspan=\"2\"><b>{{lsv.value}}</b></td></tbody><tbody \nng-repeat=\"ls in list.achValues track by $index\"><td class=\"text-center\"><b>{{ls.achPercent}}%</b></td><td \nclass=\"text-center\" colspan=\"3\"></td><td class=\"text-right\" ng-repeat=\"lsv in ls.values\" colspan=\"2\"><b>\n{{lsv.value | currency:\"\"}}</b></td></tbody><tbody ng-repeat=\"ls in list.subTotalInsentif track by $index\"><td \nclass=\"text-center\" colspan=\"4\"><b>SUB TOTAL INSENTIF</b></td><td class=\"text-right\" ng-repeat=\"lsv in ls.values\" \ncolspan=\"2\"><b>{{lsv.value | currency:\"\"}}</b></td></tbody></table><br><table ng-if=\"list.data.length>0\" \nclass=\"simple with-toolbar bordered\" ms-responsive-table><tbody><tr><td class=\"text-center\" colspan=\"2\"><b>\nTOTAL INSENTIF</b></td><td width=\"10%\" class=\"text-right\"><b>{{list.total}}</b></td></tr><tr><td class=\"text-center\">\n<b>PENALTY (SCAN BARCODE)</b></td><td width=\"2%\" class=\"text-center\"><b>{{ list.barcodePercent }}</b></td><td \nwidth=\"10%\" class=\"text-right\"><b>{{list.barcode}}</b></td></tr><tr><td class=\"text-center\" colspan=\"2\"><b>PENALTY (SP)\n</b></td><td width=\"10%\" class=\"text-right\"><b>{{list.sp}}</b></td></tr><tr><td class=\"text-center\" colspan=\"2\"><b>\nTOTAL INSENTIF YANG DIBAYARKAN</b></td><td width=\"10%\" class=\"text-right\"><b>{{list.endTotal}}</b></td></tr></tbody>\n</table></fieldset><fieldset class=\"text-center\" ng-if=\"vm.isEmptyObject(vm.results)\"><span \ntranslate=\"KPI.LABEL.NODATA\">No Data Available</span></fieldset></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-hke-area/insentif-hke-area-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.HKEAREA\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"PAYROLL.MENU.YEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.year\" name=\"year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.year.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"PAYROLL.MENU.YEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.month\" name=\"month\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"month\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listMonth | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.month.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" \nng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.HKE\"></label><input type=\"number\" \nng-model=\"vm.Form.objForm.hke\" name=\"hke\" required><div ng-messages=\"frmBT.hke.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MENU.MAIN.HKE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-hke-area/insentif-hke-area.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.HKEAREA\"></span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span></div><div \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container class=\"drop-mod\" flex><label>\n<span translate=\"PAYROLL.MENU.YEAR\"></span></label><md-select ng-model=\"vm.year\" name=\"year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.year.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"PAYROLL.MENU.YEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span></label>\n<md-select ng-model=\"vm.month\" name=\"month\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"month\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listMonth | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.month.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.area_sales_id\" name=\"area_sales_id\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"area_sales_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" \nstyle=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span><span translate=\"PAYROLL.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" \nhide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload\n</md-tooltip><md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>Upload\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nwidth=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.YEAR\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"FILTER.MONTH\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.AREA\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.HKE\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr ng-dblclick=\"vm.editData($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n<md-checkbox aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.year}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.month_view}}</td><td class=\"\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.area}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.hke}}</td><td class=\"text-center\"><section layout=\"row\" \nlayout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-hke-area/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insentif-hke-employee/insentif-hke-employee-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.HKEEMPLOYEE\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label>NIK</label>\n<md-autocomplete style=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container class=\"drop-mod\" \nflex><label><span translate=\"PAYROLL.MENU.YEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.year\" name=\"year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.year.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"PAYROLL.MENU.YEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.month\" name=\"month\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"month\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listMonth | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.month.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"MENU.MAIN.HKE\"></label><input type=\"number\" ng-model=\"vm.Form.objForm.hke\" name=\"hke\" required><div \nng-messages=\"frmBT.hke.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.HKE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/insentif-hke-employee/insentif-hke-employee.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.HKEEMPLOYEE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"KPI.LABEL.NIK\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container class=\"drop-mod\" \nflex><label><span translate=\"PAYROLL.MENU.YEAR\"></span></label><md-select ng-model=\"vm.year\" name=\"year\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"year\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.year.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.YEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span></label>\n<md-select ng-model=\"vm.month\" name=\"month\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"month\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listMonth | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.month.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container layout=\"column\" \nstyle=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span><span translate=\"PAYROLL.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>NIK</span>/<span \ntranslate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.HKE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.YEAR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"FILTER.MONTH\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\>\n</md-icon></span></th></tr></thead><tbody><tr ng-dblclick=\"vm.editData($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n<md-checkbox aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.no}}</td><td class=\"\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.nikname}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.hke}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.year}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.month_view}}</td><td class=\"text-center\"><section \nlayout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-lock-sales/insentif-lock-sales-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.LOCKSETTING\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.LOCKDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"lock_date\" \nng-model=\"vm.Form.objForm.lock_date\" required></md-datepicker><div ng-messages=\"frmBT.lock_date.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"MENU.MAIN.LOCKDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.LOCKTIME\">\n</label><input type=\"text\" name=\"lock_time\" ng-model=\"vm.Form.objForm.lock_time\" ng-max=\"24\" mask=\"99:99:99\" \nmask-placeholder=\"hh:ii:ss\" autocomplete=\"off\" required><div ng-messages=\"frmBT.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MENU.MAIN.LOCKTIME\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.TYPE\"></label>\n<input type=\"text\" ng-model=\"vm.Form.objForm.type\" readonly=\"readonly\" name=\"type\" required><div \nng-messages=\"frmBT.type.$error\" role=\"alert\"><div ng-message=\"required\"><span readonly=\"readonly\" \ntranslate=\"PAYROLL.MENU.TYPE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/insentif-lock-sales/insentif-lock-sales.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.LOCKSETTING\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex></div></md-content><md-toolbar></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span>\n</th><th class=\"text-center\"><span class=\"column-title\"><span translate=\"MENU.MAIN.LOCKDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"MENU.MAIN.LOCKTIME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.TYPE\"></span></span></th><th width=\"5%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\"><md-tooltip>\n<span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.lock_date | date:\"dd MMMM y\"}}</td><td class=\"text-center\">\n<md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.lock_time}}</td><td class=\"text-center\">\n<md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.type}}</td><td class=\"text-center\">\n<section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-kpi-setting/insentif-kpi-setting-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"KPI.LABEL.KPISETTING\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.SALESTYPE\"></span></label><md-select ng-model=\"vm.salesType\" name=\"salesType\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"salesType\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesType | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.salesType.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.SALESTYPE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.CRITERIA\"></span></label><md-select ng-model=\"vm.criteria\" name=\"criteria\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"criteria\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.CRITERIA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><label class=\"text-grey\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> *\n</label><div layout=\"row\"><md-input-container class=\"drop-mod\" ng-repeat=\"item in vm.listPrincipal\" flex=\"10\">\n<md-checkbox flex aria-label=\"Checked\" ng-checked=\"vm.exists(item, vm.selectedPrincipal)\" \nng-click=\"vm.toggle(item, vm.selectedPrincipal)\">{{item.name | uppercase}}</md-checkbox><div \nng-messages=\"frmBT.principal.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.PRINCIPAL\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked\" ng-click=\"vm.checkIsSKUFocus()\" ng-model=\"vm.isSKUFocus\" \naria-label=\"\"><span translate=\"KPI.LABEL.ISSKUFOCUS\"></span></md-checkbox></div><div layout=\"row\"><md-input-container \nflex flex-gt-sm><label translate=\"KPI.LABEL.SKUFOCUS\"></label><md-chips ng-required=\"vm.isSKUFocus\" \nng-disabled=\"!vm.isSKUFocus\" ng-model=\"vm.selectedDatas\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"vm.autocompleteDemoRequireMatch\" input-aria-label=\"\">\n<md-autocomplete ng-disabled=\"!vm.isSKUFocus\" \nstyle=\"background: transparent;\n                      border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.skuid\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getSku(vm.searchString)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.skuid)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete><md-chip-template><span>\n{{$chip.name}}</span></md-chip-template></md-chips><div ng-if=\"vm.isSKUFocus\" ng-messages=\"frmBT.skufocus.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.SKUFOCUS\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"KPI.LABEL.TARGET\"></label><input type=\"number\" ng-model=\"vm.target\" name=\"target\" required><div \nng-messages=\"frmBT.target.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.TARGET\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select \nng-model=\"vm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-model=\"vm.end\" \nname=\"end\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"end\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"KPI.LABEL.ENDMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"drop-mod\" flex=\"50\"><label><span \ntranslate=\"KPI.LABEL.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\" \nrequired><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"area\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listArea | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.area.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.AREA\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><label class=\"text-grey\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm><div \nstyle=\"padding: 2px\"><textarea rows=\"2\" ng-model=\"vm.description\" ng-required=\"true\"></textarea></div><div \nng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><label class=\"text-grey\"><span translate=\"KPI.LABEL.SURKOM\"></span></label><div \nlayout=\"row\"><md-input-container md-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nrequired uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n              action:\'upload\',\n              sales_type:vm.salesType,\n              criteria:vm.criteria,\n              principal:\'\',\n              sku:\'\',\n              description:vm.description,\n              is_sku_focus:vm.isSKUFocus,\n              target:vm.target,\n              start_month:vm.start,\n              end_month:vm.end,\n              area_sales:vm.area\n            }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-kpi-setting/insentif-kpi-setting.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.KPISALES\"></span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" \nclass=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span></div><div \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container class=\"drop-mod\" flex><label>\n<span translate=\"KPI.LABEL.SALESTYPE\"></span></label><md-select ng-model=\"vm.salesType\" name=\"salesType\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"salesType\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesType | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.salesType.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.SALESTYPE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.CRITERIA\"></span>\n</label><md-select ng-model=\"vm.criteria\" name=\"criteria\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"criteria\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select>\n<div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.CRITERIA\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.start\" \nname=\"start\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-model=\"vm.end\" name=\"end\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.AREA\"></span></label>\n<md-select ng-model=\"vm.area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"area\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listArea | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.area.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.AREA\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container layout=\"column\" \nstyle=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span><span translate=\"PAYROLL.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SALESTYPE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span><span \ntranslate=\"KPI.LABEL.CRITERIA\"></span></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span><span\n translate=\"KPI.LABEL.TARGET\"></span></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.START\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.END\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.AREA\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\"><span>FILE\n</span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr>\n</thead><tbody><tr ng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" \nng-dblclick=\"vm.viewDetail($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.sales_type}}</td><td \nclass=\"\">{{item.criteria}}</td><td class=\"text-center\">{{item.target}}</td><td class=\"text-center\">\n{{item.start_date | date : \'MMMM yyyy\'}}</td><td class=\"text-center\">{{item.end_date | date : \'MMMM yyyy\'}}</td><td \nclass=\"\">{{item.area}}</td><td class=\"text-center\"><md-button ng-if=\"item.filename&&item.format==\'img\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewFile($event, item.filename)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button \nng-if=\"item.filename&&item.format==\'file\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.downloadDoc($event, item.filename)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-download\">\n</md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p></div></md-button></td><td class=\"text-center\">\n<section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-if=\"item.filename&&item.format==\'img\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewFile($event, item.filename)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button \nng-if=\"item.filename&&item.format==\'file\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.downloadDoc($event, item.filename)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-download\">\n</md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p></div></md-button><md-button \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewDetail($event, item)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"UMUT.MENU.DETAIL\"></span></p></div>\n</md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-kpi-setting/view-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"KPI.LABEL.KPISETTING\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.SALESTYPE\"></span></label><md-select ng-model=\"vm.salesType\" name=\"salesType\" disabled=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"salesType\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesType | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.salesType.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.SALESTYPE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.CRITERIA\"></span></label><md-select ng-model=\"vm.criteria\" name=\"criteria\" disabled=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"criteria\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.CRITERIA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><label class=\"text-grey\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> *\n</label><div layout=\"row\"><md-input-container class=\"drop-mod\" ng-repeat=\"item in vm.listPrincipal\" flex=\"10\">\n<md-checkbox flex aria-label=\"Checked\" disabled=\"true\" ng-checked=\"vm.exists(item, vm.selectedPrincipal)\">\n{{item.name | uppercase}}</md-checkbox><div ng-messages=\"frmBT.principal.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div ng-if=\"vm.isChecked\" layout=\"row\"><md-checkbox ng-disabled=\"true\" \nclass=\"no-label\" ng-checked=\"vm.isChecked\" ng-click=\"vm.checkIsSKUFocus()\" ng-model=\"vm.isSKUFocus\" aria-label=\"\"><span\n translate=\"KPI.LABEL.ISSKUFOCUS\"></span></md-checkbox></div><div layout=\"row\"><md-input-container \nng-if=\"!vm.isChecked\" flex flex-gt-sm><md-checkbox ng-disabled=\"true\" class=\"no-label\" ng-checked=\"vm.isChecked\" \nng-click=\"vm.checkIsSKUFocus()\" ng-model=\"vm.isSKUFocus\" aria-label=\"\"><span translate=\"KPI.LABEL.ISSKUFOCUS\"></span>\n</md-checkbox></md-input-container><md-input-container ng-if=\"vm.isChecked\" flex flex-gt-sm><md-chips readonly=\"true\" \nng-required=\"vm.isSKUFocus\" ng-disabled=\"true\" ng-model=\"vm.selectedDatas\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"vm.autocompleteDemoRequireMatch\" input-aria-label=\"\">\n<md-chip-template><span>{{$chip.name}}</span></md-chip-template></md-chips><div ng-if=\"vm.isSKUFocus\" \nng-messages=\"frmBT.skufocus.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.SKUFOCUS\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"KPI.LABEL.TARGET\"></label><input type=\"number\" ng-model=\"vm.target\" disabled=\"true\" \nname=\"target\" required><div ng-messages=\"frmBT.target.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.TARGET\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.start\" name=\"start\" disabled=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-model=\"vm.end\" name=\"end\" disabled=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"end\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"KPI.LABEL.ENDMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"drop-mod\" flex=\"50\"><label><span \ntranslate=\"KPI.LABEL.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" disabled=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"area\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listArea | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.area.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.AREA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><label class=\"text-grey\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div \nlayout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 2px\"><textarea rows=\"2\" disabled=\"true\" \nng-model=\"vm.description\" ng-required=\"true\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><label class=\"text-grey\"><span \ntranslate=\"KPI.LABEL.SURKOM\"></span></label><div layout=\"row\"><md-button ng-if=\"vm.filename&&vm.format==\'img\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewFile($event, vm.filename)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button \nng-if=\"vm.filename&&vm.format==\'file\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.downloadDoc($event, vm.filename)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-download\">\n</md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p></div></md-button></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/insentif-kpi-setting/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.VIEWFILE\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" \nclass=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content>\n<md-dialog-content ng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><img \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/upload/{{vm.doc}}\">\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/insentif-lph/insentif-lph-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.INCENTIVELPH\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content class=\"content padding\" \nlayout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\"><span \ntranslate=\"MENU.MAIN.INCENTIVELPH\"></span></md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\">\n<div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"MENU.MAIN.SALESCODE\"></label>\n<md-select ng-model=\"vm.ref_sales_code_id\" name=\"ref_sales_code_id\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sales code...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"ref_sales_code_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesCode | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label translate=\"MENU.MAIN.PRODUCTCODE\">\n</label><md-select ng-model=\"vm.ref_master_product_id\" name=\"ref_master_product_id\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sales code...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"ref_master_product_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listProductCode | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" \nstyle=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div><div layout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\">\n</div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.SALESCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.PRODUCTCODE\"></span>/<span translate=\"KPI.LABEL.NAME\"></span></span>\n</th><th class=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.QTYTARGET\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.QTYACTUAL\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.QTYPERCENT\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.SALESVALUETARGET\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.SALESVALUEACTUAL\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.SALESVALUEPERCENT\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.CB\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.ROA\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.CBROAPERCENT\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.SC\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.EC\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.SCECPERCENT\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.IPTTARGET\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.IPTACTUAL\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.IPTPERCENT\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.JUMLAHITEM\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.DATE\"></span></span></th></tr></thead><tbody>\n<tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($event,ls)\"><td class=\"text-center\">{{ls.sales_code}}\n</td><td class=\"text-center\">{{ls.product_code}}</td><td class=\"text-right\">{{ls.qty_target}}</td><td \nclass=\"text-right\">{{ls.qty_actual}}</td><td class=\"text-center\">{{ls.qty_percentage}}</td><td class=\"text-right\">\n{{ls.sales_value_target}}</td><td class=\"text-right\">{{ls.sales_value_actual}}</td><td class=\"text-center\">\n{{ls.sales_value_percentage}}</td><td class=\"text-right\">{{ls.cb}}</td><td class=\"text-right\">{{ls.roa}}</td><td \nclass=\"text-center\">{{ls.cb_roa_percentage}}</td><td class=\"text-right\">{{ls.sc}}</td><td class=\"text-right\">{{ls.ec}}\n</td><td class=\"text-center\">{{ls.sc_ec_percentage}}</td><td class=\"text-right\">{{ls.ipt_target}}</td><td \nclass=\"text-right\">{{ls.ipt_actual}}</td><td class=\"text-center\">{{ls.ipt_percentage}}</td><td class=\"text-right\">\n{{ls.jml_item}}</td><td class=\"text-right\">{{ls.date}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"21\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/insentif-lph/insentif-lph.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.INCENTIVELPH\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"MENU.MAIN.SALESCODE\">\n</label><md-select ng-model=\"vm.ref_sales_code_id\" name=\"ref_sales_code_id\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sales code...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"ref_sales_code_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesCode | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label translate=\"MENU.MAIN.PRODUCTCODE\">\n</label><md-select ng-model=\"vm.ref_master_product_id\" name=\"ref_master_product_id\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sales code...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"ref_master_product_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listProductCode | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" \nstyle=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div><div layout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\">\n</div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Upload</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div\n class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\"><span translate=\"MENU.MAIN.SALESCODE\"></span>\n</span></th><th class=\"text-center\"><span class=\"column-title\"><span translate=\"MENU.MAIN.PRODUCTCODE\"></span>/<span \ntranslate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.QTYTARGET\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.QTYACTUAL\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.QTYPERCENT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SALESVALUETARGET\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SALESVALUEACTUAL\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SALESVALUEPERCENT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.CB\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.ROA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.CBROAPERCENT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SC\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.EC\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SCECPERCENT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.IPTTARGET\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.IPTACTUAL\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.IPTPERCENT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.JUMLAHITEM\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.DATE\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\>\n</md-icon></span></th></tr></thead><tbody><tr ng-dblclick=\"vm.viewDetail($event, ls)\" \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($event,ls)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.selected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.sales_code}}</td>\n<td class=\"text-center\">{{ls.product_code}}</td><td class=\"text-right\">{{ls.qty_target}}</td><td class=\"text-right\">\n{{ls.qty_actual}}</td><td class=\"text-center\">{{ls.qty_percentage}}</td><td class=\"text-right\">\n{{ls.sales_value_target}}</td><td class=\"text-right\">{{ls.sales_value_actual}}</td><td class=\"text-center\">\n{{ls.sales_value_percentage}}</td><td class=\"text-right\">{{ls.cb}}</td><td class=\"text-right\">{{ls.roa}}</td><td \nclass=\"text-center\">{{ls.cb_roa_percentage}}</td><td class=\"text-right\">{{ls.sc}}</td><td class=\"text-right\">{{ls.ec}}\n</td><td class=\"text-center\">{{ls.sc_ec_percentage}}</td><td class=\"text-right\">{{ls.ipt_target}}</td><td \nclass=\"text-right\">{{ls.ipt_actual}}</td><td class=\"text-center\">{{ls.ipt_percentage}}</td><td class=\"text-right\">\n{{ls.jml_item}}</td><td class=\"text-right\">{{ls.date}}</td><td class=\"text-center\"><section layout=\"row\" \nlayout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.viewDetail($event, ls)\"><div layout=\"row\" flex><md-tooltip><span translate=\"UMUT.MENU.DETAIL\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"UMUT.MENU.DETAIL\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td>\n</tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"21\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-lph/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.upload()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insentif-monitoring/insentif-monitoring.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.MONITORING\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container class=\"drop-mod\" \nflex><label><span translate=\"FILTER.YEAR\"></span></label><md-select ng-model=\"vm.year\" name=\"year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmEmploye.year.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"FILTER.YEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span>\n</label><md-select ng-model=\"vm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmEmploye.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label>\nArea</label><md-select ng-model=\"vm.area\" name=\"area\" required md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"ACTION.SUBMIT\"></span></md-button>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"button\" layout=\"row\" ng-click=\"vm.download(1)\" class=\"md-mini md-raised md-primary\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-download\" aria-label=\"download\"></md-icon><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span>\n</md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><fieldset style=\"margin-bottom: 30px\" ng-repeat=\"list in vm.results\"><table \nng-if=\"list.data.length>0\" class=\"simple with-toolbar bordered\" ms-responsive-table><thead><tr><th width=\"5%\" \nrowspan=\"2\"><span class=\"column-title\"><span translate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\">NAMA SALESMAN</span></th><th class=\"text-center\" width=\"30%\" rowspan=\"2\"><span \nclass=\"column-title\">TIM</span></th><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\">DIVISI</span></th>\n<th class=\"text-center\" ng-repeat=\"lsH1 in list.subHeader1\" colspan=\"{{lsH1.cols}}\"><span class=\"column-title\">\n{{lsH1.contentSubHeader1}}</span></th></tr><tr><th class=\"text-center\" ng-repeat=\"lsH in list.subHeader\"><span \nclass=\"column-title\">{{ lsH.contentSubHeader }}</span></th></tr></thead><tbody \nng-repeat=\"ls in list.data track by $index\"><td class=\"text-right\">{{$index+1}}</td><td class=\"text-left\">\n{{ls.nama_salesman}}</td><td class=\"text-left\">{{ls.tim}}</td><td class=\"text-center\">{{ls.divisi}}</td><td \nclass=\"text-right\" ng-repeat=\"lsv in ls.values\">{{lsv.value}}</td></tbody><tbody \nng-repeat=\"ls in list.subTotal track by $index\"><td class=\"text-center\" colspan=\"4\"><b>SUB TOTAL</b></td><td \nclass=\"text-right\" ng-repeat=\"lsv in ls.values\"><b>{{lsv.value | currency:\"\"}}</b></td></tbody></table><br></fieldset>\n<fieldset class=\"text-center\" ng-if=\"vm.isEmptyObject(vm.results)\"><span translate=\"KPI.LABEL.NODATA\">No Data Available\n</span></fieldset></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-monitoring-lph/insentif-monitoring-lph.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.MONITORINGLPH\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"KPI.LABEL.DATE\"></label><md-datepicker md-hide-icons=\"calendar\" required name=\"surkom_date\" \nng-model=\"vm.surkom_date\"></md-datepicker><div ng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\">\n<span translate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NAME\"></span></span></th></tr></thead><tbody><tr \nng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" ng-dblclick=\"vm.viewDetail($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">\n{{item.area_name}}</td><td class=\"\">{{item.nik}} / {{item.emp_name}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-override-target-absolute/insentif-override-target-absolute-edit.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.OVERRIDETARGETABSOLUTE\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nflex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" \nname=\"surkom_no\" required><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" \nng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><label class=\"text-grey\"><span translate=\"KPI.LABEL.SALESTYPE\"></span> *</label><div \nlayout=\"row\" layout-align=\"center center\" ng-repeat=\"ls in vm.Form.objForm.listTargetAbsolute\"><md-input-container \nflex><input name=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].name\" required \nreadonly=\"readonly\"></md-input-container><md-input-container flex=\"10\"><input name=\"ec{{$index}}\" \nng-model=\"vm.Form.objForm.listTargetAbsolute[$index].ec\" placeholder=\"EC\" required type=\"number\"></md-input-container>\n<md-input-container flex=\"10\"><input name=\"roa{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].roa\" \nplaceholder=\"ROA\" required type=\"number\"></md-input-container></div><label class=\"text-grey\"><span \ntranslate=\"KPI.LABEL.PRINCIPAL\"></span> *</label><div layout=\"row\" layout-align=\"center center\" \nng-repeat=\"ls in vm.Form.objForm.listPrincipal\"><md-input-container flex><input name=\"name{{$index}}\" \nng-model=\"vm.Form.objForm.listPrincipal[$index].name\" required readonly=\"readonly\"></md-input-container>\n<md-input-container flex=\"5\"><input name=\"ec{{$index}}\" ng-model=\"vm.Form.objForm.listPrincipal[$index].ec\" \nplaceholder=\"EC\" required type=\"number\"></md-input-container><label style=\"margin-top: -10px\" flex=\"5\">%</label>\n<md-input-container flex=\"5\"><input name=\"roa{{$index}}\" ng-model=\"vm.Form.objForm.listPrincipal[$index].roa\" \nplaceholder=\"ROA\" required type=\"number\"></md-input-container><label style=\"margin-top: -10px\" flex=\"5\">%</label></div>\n<label class=\"text-grey\"><span translate=\"KPI.LABEL.SKUFOCUS\"></span> *</label><div layout=\"row\" \nlayout-align=\"left left\" ng-repeat=\"lsFocus in vm.Form.objForm.listFocus\"><md-input-container flex=\"20\"><input \nname=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listFocus[$index].name\" \nplaceholder=\"{{\'ATTENDANCE.LABEL.TYPE\' | translate}}\" required readonly=\"readonly\"></md-input-container>\n<md-input-container flex=\"5\"><input name=\"amountFocus{{$index}}\" \nng-model=\"vm.Form.objForm.listFocus[$index].amountFocus\" required type=\"number\"></md-input-container><label \nstyle=\"margin-top: 20px\" flex=\"5\">%</label></div><label class=\"text-grey\"><span translate=\"UMUT.MENU.NOTE\"></span>\n</label><div layout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 2px\"><textarea rows=\"2\" \nng-model=\"vm.Form.objForm.description\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"UMUT.MENU.NOTE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.start_year\" name=\"start_year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start_year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start_year.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.end_year\" name=\"end_year\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end_year\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><label class=\"text-grey\">\n<span translate=\"KPI.LABEL.SURKOM\"></span></label><div layout=\"row\"><md-input-container md-no-float class=\"md-block\">\n<input type=\"file\" id=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n            action:\'uploadData\',\n            id:vm.Form.objForm.id,\n            description:vm.Form.objForm.description,\n            surkom_no:vm.Form.objForm.surkom_no,\n            surkom_date:vm.Form.objForm.surkom_date,\n            empno:vm.Form.objForm.nik.empno,\n            empnik:vm.Form.objForm.empnik,\n            status:vm.Form.objForm.status,\n            listTargetAbsolute:vm.Form.objForm.listTargetAbsolute,\n            listPrincipal:vm.Form.objForm.listPrincipal,\n            listFocus:vm.Form.objForm.listFocus,\n            start_year:vm.Form.objForm.start_year,\n            start:vm.Form.objForm.start,\n            end_year:vm.Form.objForm.end_year,\n            end:vm.Form.objForm.end\n          }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button ng-if=\"vm.edit&&(!vm.fileSizeError)\" type=\"button\" class=\"md-raised md-accent\" \nng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button><md-button ng-if=\"vm.edit&&vm.fileSizeError\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-override-target-absolute/insentif-override-target-absolute-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.OVERRIDETARGETABSOLUTE\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><md-input-container class=\"drop-mod\" \nflex><label><span>Ref. Surkom</span></label><md-select ng-model=\"vm.Form.objForm.ref_id\" \nng-change=\"vm.loadDetail(vm.Form.objForm.ref_id)\" name=\"ref_id\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"ref_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRefAbsolute | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmBT.ref_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ref. Surkom</span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><fieldset><legend>\nRef. Target Absolute</legend><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no_ref\" \nname=\"surkom_no_ref\" readonly=\"readonly\" required><div ng-messages=\"frmBT.surkom_no_ref.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"surkom_date_ref\" ng-disabled=\"disabled\" \nng-model=\"vm.Form.objForm.surkom_date_ref\" required></md-datepicker><div ng-messages=\"frmBT.surkom_date_ref.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><input type=\"text\" \nng-model=\"vm.Form.objForm.nik_ref\" name=\"surkom_no\" readonly=\"readonly\" required><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.STATUS\"></label><md-select ng-disabled=\"disabled\" ng-model=\"vm.Form.objForm.status\" name=\"status\" \nng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option></md-select>\n</md-input-container></div></fieldset><br><br><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nrequired><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" \nng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><fieldset style=\"margin-bottom: 30px\"><legend><span translate=\"KPI.LABEL.SALESTYPE\"></span>\n *</legend><div layout=\"row\" layout-align=\"center center\" ng-repeat=\"ls in vm.Form.objForm.listTargetAbsolute\">\n<md-input-container flex><input name=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].name\" \nrequired readonly=\"readonly\"></md-input-container><md-input-container flex=\"10\"><input name=\"ec{{$index}}\" \nng-model=\"vm.Form.objForm.listTargetAbsolute[$index].ec\" placeholder=\"EC\" required type=\"number\"></md-input-container>\n<md-input-container flex=\"10\"><input name=\"roa{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].roa\" \nplaceholder=\"ROA\" required type=\"number\"></md-input-container></div></fieldset><fieldset style=\"margin-bottom: 30px\">\n<legend><span translate=\"KPI.LABEL.OTHERPRINCIPAL\"></span> *</legend><div layout=\"row\" layout-align=\"center center\" \nng-repeat=\"ls in vm.Form.objForm.listPrincipal\"><md-input-container flex><input name=\"name{{$index}}\" \nng-model=\"vm.Form.objForm.listPrincipal[$index].name\" required readonly=\"readonly\"></md-input-container>\n<md-input-container flex=\"5\"><input name=\"ec{{$index}}\" ng-model=\"vm.Form.objForm.listPrincipal[$index].ec\" \nplaceholder=\"EC\" required type=\"number\"></md-input-container><label style=\"margin-top: -10px\" flex=\"10\"><span \ntranslate=\"KPI.LABEL.PERCENTKSNI\"></span></label><md-input-container flex=\"5\"><input name=\"roa{{$index}}\" \nng-model=\"vm.Form.objForm.listPrincipal[$index].roa\" placeholder=\"ROA\" required type=\"number\"></md-input-container>\n<label style=\"margin-top: -10px\" flex=\"10\"><span translate=\"KPI.LABEL.PERCENTKSNI\"></span></label></div></fieldset>\n<fieldset style=\"margin-bottom: 30px\"><legend><span translate=\"KPI.LABEL.SKUFOCUS\"></span> *</legend><div layout=\"row\" \nlayout-align=\"left left\" ng-repeat=\"lsFocus in vm.Form.objForm.listFocus\" flex><md-input-container flex=\"20\"><input \nname=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listFocus[$index].name\" \nplaceholder=\"{{\'ATTENDANCE.LABEL.TYPE\' | translate}}\" required readonly=\"readonly\"></md-input-container>\n<md-input-container flex=\"5\"><input name=\"amountFocus{{$index}}\" \nng-model=\"vm.Form.objForm.listFocus[$index].amountFocus\" required type=\"number\"></md-input-container><label \nstyle=\"margin-top: 20px\" flex=\"5\">%</label></div></fieldset><label class=\"text-grey\"><span translate=\"UMUT.MENU.NOTE\">\n</span></label><div layout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 2px\"><textarea rows=\"2\" \nng-model=\"vm.Form.objForm.description\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"UMUT.MENU.NOTE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.start_year\" name=\"start_year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start_year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start_year.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.end_year\" name=\"end_year\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end_year\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><label class=\"text-grey\">\n<span translate=\"KPI.LABEL.UPLOADSURKOM\"></span></label><div layout=\"row\"><md-input-container md-no-float \nclass=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n              action:\'uploadData\',\n              area_sales_id:vm.Form.objForm.area_sales_id,\n              description:vm.Form.objForm.description,\n              surkom_no:vm.Form.objForm.surkom_no,\n              surkom_date:vm.Form.objForm.surkom_date,\n              empno:vm.Form.objForm.nik.empno,\n              status:vm.Form.objForm.status,\n              listTargetAbsolute:vm.Form.objForm.listTargetAbsolute,\n              listPrincipal:vm.Form.objForm.listPrincipal,\n              listFocus:vm.Form.objForm.listFocus,\n              start_year:vm.Form.objForm.start_year,\n              start:vm.Form.objForm.start,\n              end_year:vm.Form.objForm.end_year,\n              end:vm.Form.objForm.end\n            }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-override-target-absolute/insentif-override-target-absolute.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.OVERRIDETARGETABSOLUTE\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"MENU.MAIN.SURKOMNO\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.id\" md-search-text=\"vm.searchStringSurkom\" \nmd-items=\"item in vm.getDataCode(vm.searchStringSurkom)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.id\" \nmd-selected-item-change=\"vm.selectedItemChangedNo(vm.Form.objForm.id)\"><md-item-template><span \nmd-highlight-text=\"vm.searchStringSurkom\">{{item.name}}</span></md-item-template></md-autocomplete>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.surkom_date\"></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.status\" name=\"status\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMCREATOR\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.STATUS\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span>AREA</span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\"><span>FILE</span></span>\n</th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody>\n<tr ng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" ng-dblclick=\"vm.viewDetail($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.surkom_no}}</td><td class=\"text-center\">\n{{item.surkom_date | date : \'dd MMMM yyyy\'}}</td><td class=\"\">{{item.surkom_created_by}} / {{item.surkom_creator}}</td>\n<td class=\"text-center\">{{item.status}}</td><td class=\"text-center\">{{item.sub_area}}</td><td class=\"text-center\">\n<md-button ng-if=\"item.filename&&item.format==\'img\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.viewFile($event, item.filename)\"><div layout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\">\n</span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button ng-if=\"item.filename&&item.format==\'file\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.downloadDoc($event, item.filename)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-menu-align-target md-font-icon=\"icon-download\"></md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p>\n</div></md-button></td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewDetail($event, item)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"UMUT.MENU.DETAIL\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"UMUT.MENU.DETAIL\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-override-target-absolute/view-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.TARGETABSOLUTE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nreadonly=\"readonly\" required><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-disabled=\"true\" ng-model=\"vm.Form.objForm.surkom_date\" required>\n</md-datepicker><div ng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMCREATOR\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.nik\" name=\"nik\" \nreadonly=\"readonly\" required><div ng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NIK\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" \nname=\"area_sales_id\" ng-required=\"true\" ng-disabled=\"disabled\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><label class=\"text-grey\"><span translate=\"KPI.LABEL.SALESTYPE\"></span> *</label><div \nlayout=\"row\" layout-align=\"center center\" ng-repeat=\"ls in vm.Form.objForm.listTargetAbsolute\"><md-input-container \nflex><input name=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].name\" required \nreadonly=\"readonly\"></md-input-container><md-input-container flex=\"10\"><input name=\"ec{{$index}}\" \nng-model=\"vm.Form.objForm.listTargetAbsolute[$index].ec\" placeholder=\"EC\" readonly=\"readonly\" required type=\"number\">\n</md-input-container><md-input-container flex=\"10\"><input name=\"roa{{$index}}\" \nng-model=\"vm.Form.objForm.listTargetAbsolute[$index].roa\" placeholder=\"ROA\" readonly=\"readonly\" required type=\"number\">\n</md-input-container></div><label class=\"text-grey\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> *</label><div \nlayout=\"row\" layout-align=\"center center\" ng-repeat=\"ls in vm.Form.objForm.listPrincipal\"><md-input-container flex>\n<input name=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listPrincipal[$index].name\" required readonly=\"readonly\">\n</md-input-container><md-input-container flex=\"5\"><input name=\"ec{{$index}}\" \nng-model=\"vm.Form.objForm.listPrincipal[$index].ec\" placeholder=\"EC\" readonly=\"readonly\" required type=\"number\">\n</md-input-container><label style=\"margin-top: -10px\" flex=\"5\">%</label><md-input-container flex=\"5\"><input \nname=\"roa{{$index}}\" ng-model=\"vm.Form.objForm.listPrincipal[$index].roa\" placeholder=\"ROA\" readonly=\"readonly\" \nrequired type=\"number\"></md-input-container><label style=\"margin-top: -10px\" flex=\"5\">%</label></div><label \nclass=\"text-grey\"><span translate=\"KPI.LABEL.FOCUS\"></span> *</label><div layout=\"row\" layout-align=\"left left\" \nng-repeat=\"lsFocus in vm.Form.objForm.listFocus\"><md-input-container flex=\"20\"><input name=\"name{{$index}}\" \nng-model=\"vm.Form.objForm.listFocus[$index].name\" placeholder=\"{{\'ATTENDANCE.LABEL.TYPE\' | translate}}\" required \nreadonly=\"readonly\"></md-input-container><md-input-container flex=\"5\"><input name=\"amountFocus{{$index}}\" \nng-model=\"vm.Form.objForm.listFocus[$index].amountFocus\" readonly=\"readonly\" required type=\"number\">\n</md-input-container><label style=\"margin-top: 20px\" flex=\"5\">%</label></div><label class=\"text-grey\"><span \ntranslate=\"UMUT.MENU.NOTE\"></span></label><div layout=\"row\"><md-input-container flex flex-gt-sm><div \nstyle=\"padding: 2px\"><textarea readonly=\"readonly\" rows=\"2\" ng-model=\"vm.Form.objForm.description\"></textarea></div>\n<div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"UMUT.MENU.NOTE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select \nng-disabled=\"true\" ng-model=\"vm.Form.objForm.start_year\" name=\"start_year\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"start_year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.start_year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTYEAR\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select \nng-model=\"vm.Form.objForm.start\" name=\"start\" ng-disabled=\"true\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" ng-disabled=\"true\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.end_year\" name=\"end_year\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end_year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDYEAR\"></span>\n <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select \nng-model=\"vm.Form.objForm.end\" name=\"end\" ng-disabled=\"true\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/insentif-override-target-absolute/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.VIEWFILE\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" \nclass=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content>\n<md-dialog-content ng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><img \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/upload/target-absolute/{{vm.doc}}\">\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/insentif-pinalty/insentif-pinalty-edit.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.INCENTIVEPINALTY\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nrequired><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.Form.objForm.channel\" name=\"channel\" ng-required=\"true\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.Form.objForm.status\" \nname=\"status\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option>\n</md-select></md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" \nng-repeat=\"ls in vm.Form.objForm.listItem\"><legend>PERIOD {{parentIndex+1}}</legend><div layout=\"row\">\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select \nng-model=\"vm.Form.objForm.listItem[parentIndex].start_year\" name=\"start_year\" md-on-close=\"vm.clearSearchTerm()\" \nrequired><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"start_year\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.start_year.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.STARTYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.listItem[parentIndex].start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.listItem[parentIndex].end_year\" \nname=\"end_year\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"end_year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.ENDYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\">\n</span></label><md-select ng-model=\"vm.Form.objForm.listItem[parentIndex].end\" name=\"end\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"pinaltyIndex = $index\" \nng-repeat=\"lsach in vm.Form.objForm.listItem[parentIndex].ach\"><legend><span>Rule</span> *</legend><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"MENU.MAIN.OPERATOR\"></span></label><md-select \nng-model=\"vm.Form.objForm.listItem[parentIndex].ach[pinaltyIndex].operator\" name=\"operator\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"operator\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listOperator | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MENU.MAIN.OPERATOR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span></span></label><md-input-container \nflex><label><span translate=\"MENU.MAIN.INCENTIVEBARCODE\"></span></label><input type=\"number\" \nng-model=\"vm.Form.objForm.listItem[parentIndex].ach[pinaltyIndex].barcode\" name=\"barcode{{parentIndex}}\" required><div \nng-messages=\"frmBT.barcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.INCENTIVEBARCODE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex><label>\n<span translate=\"MENU.MAIN.INCENTIVEPINALTY\"></span></label><input type=\"number\" \nng-model=\"vm.Form.objForm.listItem[parentIndex].ach[pinaltyIndex].pinalty\" name=\"pinalty{{parentIndex}}\"><div \nng-messages=\"frmBT.pinalty.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.INCENTIVEPINALTY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><md-button \nng-if=\"pinaltyIndex!=0\" ng-click=\"vm.delListAch(vm.Form.objForm.listItem[parentIndex].ach,pinaltyIndex)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"KPI.LABEL.DELETE\"></span></md-button></fieldset><md-button \nng-click=\"vm.addAch(vm.Form.objForm.listItem[parentIndex].ach)\" class=\"md-mini md-raised md-primary\" \nstyle=\"height:20px\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Add Item</md-button></fieldset><md-button \nng-click=\"vm.addItem()\" class=\"md-raised md-mini md-primary\" style=\"height:20px\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>Add Period</md-button><br><br><br><label class=\"text-grey\"><span translate=\"KPI.LABEL.UPLOADSURKOM\"></span>\n</label><div layout=\"row\"><md-input-container md-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" \nnv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n            action:\'uploadData\',\n            surkom_no:vm.Form.objForm.surkom_no,\n            surkom_date:vm.Form.objForm.surkom_date,\n            empno:vm.Form.objForm.nik.empno,\n            status:vm.Form.objForm.status,\n            channel:vm.Form.objForm.channel,\n            listItem:vm.Form.objForm.listItem\n          }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button ng-if=\"vm.edit&&(!vm.fileSizeError)\" type=\"button\" class=\"md-raised md-accent\" \nng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" \ntranslate=\"ACTION.SUBMIT\">ganteng</md-button><md-button ng-if=\"vm.edit&&vm.fileSizeError\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-pinalty/insentif-pinalty-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.INCENTIVEPINALTY\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nrequired><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.Form.objForm.channel\" name=\"channel\" ng-required=\"true\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.Form.objForm.status\" \nname=\"status\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option>\n</md-select></md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" \nng-repeat=\"ls in vm.listItem\"><legend>PERIOD {{parentIndex+1}}</legend><div layout=\"row\"><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].start_year\" name=\"start_year\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"start_year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.start_year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTYEAR\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].end_year\" name=\"end_year\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end_year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDYEAR\"></span>\n <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><fieldset \nstyle=\"margin-bottom: 30px\" ng-init=\"pinaltyIndex = $index\" ng-repeat=\"lsach in vm.listItem[parentIndex].ach\"><legend>\n<span>Rule</span> *</legend><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"MENU.MAIN.OPERATOR\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].ach[pinaltyIndex].operator\" name=\"operator\" md-on-close=\"vm.clearSearchTerm()\" \nrequired><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"operator\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listOperator | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.OPERATOR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span></span></label><md-input-container flex><label>\n<span translate=\"MENU.MAIN.INCENTIVEBARCODE\"></span></label><input type=\"number\" \nng-model=\"vm.listItem[parentIndex].ach[pinaltyIndex].barcode\" name=\"barcode{{parentIndex}}\" required><div \nng-messages=\"frmBT.barcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.INCENTIVEBARCODE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex><label>\n<span translate=\"MENU.MAIN.INCENTIVEPINALTY\"></span></label><input type=\"number\" \nng-model=\"vm.listItem[parentIndex].ach[pinaltyIndex].pinalty\" name=\"pinalty{{parentIndex}}\"><div \nng-messages=\"frmBT.pinalty.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.INCENTIVEPINALTY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><md-button \nng-if=\"pinaltyIndex!=0\" ng-click=\"vm.delListAch(vm.listItem[parentIndex].ach,pinaltyIndex)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"KPI.LABEL.DELETE\"></span></md-button></fieldset><md-button \nng-click=\"vm.addAch(vm.listItem[parentIndex].ach)\" class=\"md-mini md-raised md-primary\" style=\"height:20px\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Add Item</md-button></fieldset><md-button ng-click=\"vm.addItem()\" \nclass=\"md-raised md-mini md-primary\" style=\"height:20px\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Add Period\n</md-button><br><br><br><label class=\"text-grey\"><span translate=\"KPI.LABEL.UPLOADSURKOM\"></span></label><div \nlayout=\"row\"><md-input-container md-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nrequired uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n              action:\'uploadData\',\n              surkom_no:vm.Form.objForm.surkom_no,\n              surkom_date:vm.Form.objForm.surkom_date,\n              empno:vm.Form.objForm.nik.empno,\n              status:vm.Form.objForm.status,\n              channel:vm.Form.objForm.channel,\n              listItem:vm.listItem\n            }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-pinalty/insentif-pinalty.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.INCENTIVEPINALTY\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"MENU.MAIN.SURKOMNO\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.id\" md-search-text=\"vm.searchStringSurkom\" \nmd-items=\"item in vm.getDataCode(vm.searchStringSurkom)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.id\" \nmd-selected-item-change=\"vm.selectedItemChangedNo(vm.Form.objForm.id)\"><md-item-template><span \nmd-highlight-text=\"vm.searchStringSurkom\">{{item.name}}</span></md-item-template></md-autocomplete>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.status\" name=\"status\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><label\n translate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.channel\" name=\"channel\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMCREATOR\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.CHANNEL\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.STATUS\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span>FILE</span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span>\n</th></tr></thead><tbody><tr ng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" \nng-dblclick=\"vm.viewDetail($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.surkom_no}}</td><td \nclass=\"text-center\">{{item.surkom_date | date : \'dd MMMM yyyy\'}}</td><td class=\"\">\n{{item.surkom_created_by}} / {{item.surkom_creator}}</td><td class=\"text-center\">{{item.channel}}</td><td \nclass=\"text-center\">{{item.status}}</td><td class=\"text-center\"><md-button ng-if=\"item.filename&&item.format==\'img\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewFile($event, item.filename)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button \nng-if=\"item.filename&&item.format==\'file\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.downloadDoc($event, item.filename)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-download\">\n</md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p></div></md-button></td><td class=\"text-center\">\n<section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.viewDetail($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"UMUT.MENU.DETAIL\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"UMUT.MENU.DETAIL\"></span></p></div></md-button><md-button class=\"md-mini md-primary\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"KPI.LABEL.EDIT\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-pencil\"></md-icon><p \nflex><span translate=\"KPI.LABEL.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu>\n</section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-pinalty/view-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.INCENTIVEPINALTY\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nreadonly=\"readonly\" required><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" ng-disabled=\"true\" required>\n</md-datepicker><div ng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMCREATOR\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.nik\" name=\"nik\" \nreadonly=\"readonly\" required><div ng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NIK\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.Form.objForm.channel\" \nname=\"channel\" ng-disabled=\"true\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.STATUS\">\n</label><md-select ng-model=\"vm.Form.objForm.status\" name=\"status\" ng-disabled=\"true\" ng-required=\"true\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option></md-select></md-input-container></div>\n<fieldset style=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" ng-repeat=\"ls in vm.listItem\"><legend>\nPERIOD {{parentIndex+1}}</legend><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select ng-model=\"vm.listItem[parentIndex].start_year\" \nng-disabled=\"true\" name=\"start_year\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start_year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.start_year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTYEAR\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required ng-disabled=\"true\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].end_year\" name=\"end_year\" md-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"true\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"end_year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDYEAR\"></span>\n <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"true\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><fieldset \nstyle=\"margin-bottom: 30px\" ng-init=\"pinaltyIndex = $index\" ng-repeat=\"lsach in vm.listItem[parentIndex].ach\"><legend>\n<span>Rule</span> {{pinaltyIndex+1}}</legend><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"MENU.MAIN.OPERATOR\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].ach[pinaltyIndex].operator\" name=\"operator\" md-on-close=\"vm.clearSearchTerm()\" \nng-disabled=\"true\" required><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"operator\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listOperator | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.OPERATOR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span></span></label><md-input-container flex><label>\n<span translate=\"MENU.MAIN.INCENTIVEBARCODE\"></span></label><input type=\"number\" \nng-model=\"vm.listItem[parentIndex].ach[pinaltyIndex].barcode\" name=\"barcode{{parentIndex}}\" readonly=\"readonly\" \nrequired><div ng-messages=\"frmBT.barcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.INCENTIVEBARCODE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex><label>\n<span translate=\"MENU.MAIN.INCENTIVEPINALTY\"></span></label><input type=\"number\" \nng-model=\"vm.listItem[parentIndex].ach[pinaltyIndex].pinalty\" readonly=\"readonly\" name=\"pinalty{{parentIndex}}\"><div \nng-messages=\"frmBT.pinalty.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.INCENTIVEPINALTY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div></fieldset></fieldset><label\n class=\"text-grey\"><span translate=\"KPI.LABEL.SURKOM\"></span></label><br><md-button \nng-if=\"vm.Form.objForm.filename&&vm.Form.objForm.format==\'img\'\" class=\"md-mini md-primary\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewFile($event, vm.Form.objForm.filename)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button \nng-if=\"vm.Form.objForm.filename&&vm.Form.objForm.format==\'file\'\" class=\"md-mini md-primary\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.downloadDoc($event, vm.Form.objForm.filename)\"><div layout=\"row\" \nflex><md-tooltip><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-download\"></md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p></div></md-button>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/insentif-pinalty/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.VIEWFILE\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" \nclass=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content>\n<md-dialog-content ng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><img \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" \nsrc=\"api/upload/incentive-pinalty/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/insentif-pinalty-sp/insentif-pinalty-sp-edit.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.INCENTIVEPINALTYSP\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nrequired><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.Form.objForm.channel\" name=\"channel\" ng-required=\"true\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.Form.objForm.status\" \nname=\"status\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option>\n</md-select></md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" \nng-repeat=\"ls in vm.Form.objForm.listItem\"><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.listItem[parentIndex].start_year\" \nname=\"start_year\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start_year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start_year.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.listItem[parentIndex].start\" \nname=\"start\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.listItem[parentIndex].end_year\" \nname=\"end_year\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"end_year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.ENDYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\">\n</span></label><md-select ng-model=\"vm.Form.objForm.listItem[parentIndex].end\" name=\"end\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"pinaltyIndex = $index\" \nng-repeat=\"lsach in vm.Form.objForm.listItem[parentIndex].ach\"><legend><span>Rule</span> *</legend><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span>SP</span></label><md-select \nng-model=\"vm.Form.objForm.listItem[parentIndex].ach[pinaltyIndex].sp\" name=\"sp\" md-on-close=\"vm.clearSearchTerm()\" \nrequired><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"sp\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSp | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span>SP</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label style=\"margin-top: 25px\" \nflex=\"10\"><span></span></label><md-input-container flex><label><span translate=\"MENU.MAIN.INCENTIVEPINALTYSP\"></span>\n</label><input type=\"number\" ng-model=\"vm.Form.objForm.listItem[parentIndex].ach[pinaltyIndex].pinalty\" \nname=\"pinalty{{parentIndex}}\"><div ng-messages=\"frmBT.pinalty.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.INCENTIVEPINALTYSP\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><md-button \nng-if=\"pinaltyIndex!=0\" ng-click=\"vm.delListAch(vm.Form.objForm.listItem[parentIndex].ach,pinaltyIndex)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"KPI.LABEL.DELETE\"></span></md-button></fieldset><md-button \nng-click=\"vm.addAch(vm.Form.objForm.listItem[parentIndex].ach)\" class=\"md-mini md-raised md-primary\" \nstyle=\"height:20px\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Add Item</md-button></fieldset><br><br><br><label \nclass=\"text-grey\"><span translate=\"KPI.LABEL.UPLOADSURKOM\"></span></label><div layout=\"row\"><md-input-container \nmd-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select required \nuploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n            action:\'uploadData\',\n            id:vm.Form.objForm.id,\n            surkom_no:vm.Form.objForm.surkom_no,\n            surkom_date:vm.Form.objForm.surkom_date,\n            empno:vm.Form.objForm.nik.empno,\n            nikEmp:vm.Form.objForm.nikEmp,\n            status:vm.Form.objForm.status,\n            channel:vm.Form.objForm.channel,\n            listItem:vm.Form.objForm.listItem\n          }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button ng-if=\"vm.edit&&(!vm.fileSizeError)\" type=\"button\" class=\"md-raised md-accent\" \nng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" \ntranslate=\"ACTION.SUBMIT\">ganteng</md-button><md-button ng-if=\"vm.edit&&vm.fileSizeError\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-pinalty-sp/insentif-pinalty-sp-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.INCENTIVEPINALTYSP\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nrequired><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.Form.objForm.channel\" name=\"channel\" ng-required=\"true\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.Form.objForm.status\" \nname=\"status\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option>\n</md-select></md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" \nng-repeat=\"ls in vm.listItem\"><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select ng-model=\"vm.listItem[parentIndex].start_year\" \nname=\"start_year\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start_year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start_year.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.listItem[parentIndex].start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select ng-model=\"vm.listItem[parentIndex].end_year\" name=\"end_year\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end_year\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span>\n</label><md-select ng-model=\"vm.listItem[parentIndex].end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><fieldset \nstyle=\"margin-bottom: 30px\" ng-init=\"pinaltyIndex = $index\" ng-repeat=\"lsach in vm.listItem[parentIndex].ach\"><legend>\n<span>Rule</span> *</legend><div layout-gt-sm=\"row\"><md-input-container flex><label><span>SP</span></label><md-select \nng-model=\"vm.listItem[parentIndex].ach[pinaltyIndex].sp\" name=\"sp\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"sp\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSp | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span>SP</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label style=\"margin-top: 25px\" \nflex=\"10\"><span></span></label><md-input-container flex><label><span translate=\"MENU.MAIN.INCENTIVEPINALTYSP\"></span>\n</label><input type=\"number\" ng-model=\"vm.listItem[parentIndex].ach[pinaltyIndex].pinalty\" \nname=\"pinalty{{parentIndex}}\"><div ng-messages=\"frmBT.pinalty.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.INCENTIVEPINALTYSP\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><md-button \nng-if=\"pinaltyIndex!=0\" ng-click=\"vm.delListAch(vm.listItem[parentIndex].ach,pinaltyIndex)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"KPI.LABEL.DELETE\"></span></md-button></fieldset><md-button \nng-click=\"vm.addAch(vm.listItem[parentIndex].ach)\" class=\"md-mini md-raised md-primary\" style=\"height:20px\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Add Item</md-button></fieldset><br><br><br><label class=\"text-grey\"><span \ntranslate=\"KPI.LABEL.UPLOADSURKOM\"></span></label><div layout=\"row\"><md-input-container md-no-float class=\"md-block\">\n<input type=\"file\" id=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n              action:\'uploadData\',\n              surkom_no:vm.Form.objForm.surkom_no,\n              surkom_date:vm.Form.objForm.surkom_date,\n              empno:vm.Form.objForm.nik.empno,\n              status:vm.Form.objForm.status,\n              channel:vm.Form.objForm.channel,\n              listItem:vm.listItem\n            }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-pinalty-sp/insentif-pinalty-sp.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.INCENTIVEPINALTYSP\"></span></md-subheader><div class=\"white-bg\"><md-content\n class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"MENU.MAIN.SURKOMNO\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.id\" md-search-text=\"vm.searchStringSurkom\" \nmd-items=\"item in vm.getDataCode(vm.searchStringSurkom)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.id\" \nmd-selected-item-change=\"vm.selectedItemChangedNo(vm.Form.objForm.id)\"><md-item-template><span \nmd-highlight-text=\"vm.searchStringSurkom\">{{item.name}}</span></md-item-template></md-autocomplete>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.status\" name=\"status\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><label\n translate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.channel\" name=\"channel\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMCREATOR\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.CHANNEL\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.STATUS\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span>FILE</span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span>\n</th></tr></thead><tbody><tr ng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" \nng-dblclick=\"vm.viewDetail($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.surkom_no}}</td><td \nclass=\"text-center\">{{item.surkom_date | date : \'dd MMMM yyyy\'}}</td><td class=\"\">\n{{item.surkom_created_by}} / {{item.surkom_creator}}</td><td class=\"text-center\">{{item.channel}}</td><td \nclass=\"text-center\">{{item.status}}</td><td class=\"text-center\"><md-button ng-if=\"item.filename&&item.format==\'img\'\" \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewFile($event, item.filename)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button \nng-if=\"item.filename&&item.format==\'file\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.downloadDoc($event, item.filename)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-download\">\n</md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p></div></md-button></td><td class=\"text-center\">\n<section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.viewDetail($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"UMUT.MENU.DETAIL\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"UMUT.MENU.DETAIL\"></span></p></div></md-button><md-button class=\"md-mini md-primary\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"KPI.LABEL.EDIT\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-pencil\"></md-icon><p \nflex><span translate=\"KPI.LABEL.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu>\n</section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-pinalty-sp/view-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.INCENTIVEPINALTYSP\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nreadonly=\"readonly\" required><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" ng-disabled=\"true\" required>\n</md-datepicker><div ng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMCREATOR\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.nik\" name=\"nik\" \nreadonly=\"readonly\" required><div ng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NIK\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.Form.objForm.channel\" \nname=\"channel\" ng-disabled=\"true\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.STATUS\">\n</label><md-select ng-model=\"vm.Form.objForm.status\" name=\"status\" ng-disabled=\"true\" ng-required=\"true\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option></md-select></md-input-container></div>\n<fieldset style=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" ng-repeat=\"ls in vm.listItem\"><div layout=\"row\">\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].start_year\" ng-disabled=\"true\" name=\"start_year\" md-on-close=\"vm.clearSearchTerm()\" \nrequired><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"start_year\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.start_year.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.STARTYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span>\n</label><md-select ng-model=\"vm.listItem[parentIndex].start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required \nng-disabled=\"true\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].end_year\" name=\"end_year\" md-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"true\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"end_year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDYEAR\"></span>\n <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select \nng-model=\"vm.listItem[parentIndex].end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"true\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><fieldset \nstyle=\"margin-bottom: 30px\" ng-init=\"pinaltyIndex = $index\" ng-repeat=\"lsach in vm.listItem[parentIndex].ach\"><legend>\n<span>Rule</span> {{pinaltyIndex+1}}</legend><div layout-gt-sm=\"row\"><md-input-container flex><label><span>SP</span>\n</label><md-select ng-model=\"vm.listItem[parentIndex].ach[pinaltyIndex].sp\" name=\"sp\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"true\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"sp\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSp | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>SP</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span></span></label><md-input-container flex><label><span \ntranslate=\"MENU.MAIN.INCENTIVEPINALTY\"></span></label><input type=\"number\" \nng-model=\"vm.listItem[parentIndex].ach[pinaltyIndex].pinalty\" readonly=\"readonly\" name=\"pinalty{{parentIndex}}\"><div \nng-messages=\"frmBT.pinalty.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.INCENTIVEPINALTY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div></fieldset></fieldset><label\n class=\"text-grey\"><span translate=\"KPI.LABEL.SURKOM\"></span></label><br><md-button \nng-if=\"vm.Form.objForm.filename&&vm.Form.objForm.format==\'img\'\" class=\"md-mini md-primary\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewFile($event, vm.Form.objForm.filename)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"MENU.MAIN.VIEWFILE\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button \nng-if=\"vm.Form.objForm.filename&&vm.Form.objForm.format==\'file\'\" class=\"md-mini md-primary\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.downloadDoc($event, vm.Form.objForm.filename)\"><div layout=\"row\" \nflex><md-tooltip><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-download\"></md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p></div></md-button>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/insentif-pinalty-sp/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.VIEWFILE\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" \nclass=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content>\n<md-dialog-content ng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><img \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" \nsrc=\"api/upload/incentive-pinalty-sp/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/insentif-process/insentif-process.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.INCENTIVEPROCESS\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formGHK\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span></div><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Month</label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"formGHK.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Month is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label>\n<md-select ng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"formGHK.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"formGHK.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><i class=\"icon icon-search\"></i> Search</md-button></form></div>\n</div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.showProcessForm()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Process</span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span>Process</span></md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button ng-disabled=\"vm.disabledSubmit()\" class=\"md-mini md-raised md-primary btn-ui-serif\" \nhide show-gt-sm type=\"button\" ng-click=\"vm.sumbitData($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Submit Data</md-tooltip><md-icon md-font-icon=\"icon-arrow-right\"></md-icon><span>\nSubmit Data</span></md-button><div ng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NAME\"></span></span></th><th class=\"\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.JOBTITLE\"></span></span></th><th class=\"\"><span class=\"column-title\">\n<span translate=\"UMUT.MENU.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PERIOD\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.INSENTIF\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>Processed By\n</span></span></th><th width=\"20%\" class=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.STATUS\">\n</span></span></th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"\">{{ls.nik}}/{{ls.nama}}</td><td class=\"\">{{ls.job_title}}</td><td \nclass=\"\">{{ls.sub_area}}</td><td class=\"text-center\">{{ls.period}}</td><td class=\"text-center\">\n{{ls.insentif | currency:\"\"}}</td><td class=\"text-center\"><span>{{ls.created_by}}/{{ls.created_name}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.approval_status!==\'4\'\">{{ls.app}}</span> <span ng-if=\"ls.approval_status==\'4\'\"><a \nhref=\"\" ng-click=\"vm.viewComment($event,ls)\">{{ls.app}}</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip>\n</span></td><td class=\"text-center\"><md-menu><md-button class=\"md-icon-button action-selector\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button>\n<md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" \naria-label=\"Flip widget\"><span>Detail</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==\'1\'\">\n<md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==\'2\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"13\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-process/new-insentif-process.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"frmEmploye\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span>Process</span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.YEAR\"></span></label><md-select \nng-model=\"vm.year\" name=\"year\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmEmploye.year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.YEAR\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span></label><md-select ng-model=\"vm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmEmploye.start.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select \nng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" \nng-change=\"vm.getSalesCode(vm.Form.objForm.area_sales_id)\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SALESCODE\"></label>\n<md-select ng-model=\"vm.sales_code\" name=\"sales_code\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesCode\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"frmEmploye.sales_code.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.SALESCODE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"button\" \nng-click=\"vm.processData()\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" class=\"md-primary md-hue-1\" \naria-label=\"SUBMIT\"><span>Process</span></md-button><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" \nng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-process-ass/insentif-process-ass.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.INCENTIVEPROCESSASS\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formGHK\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<label>Month</label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"formGHK.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Month is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"formGHK.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"formGHK.$invalid || formGHK.$pristine\"><i class=\"icon icon-search\"></i> Search</md-button></form></div>\n</div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"formGHK.$invalid || formGHK.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.showProcessForm()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Process</span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span>Process</span></md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button ng-disabled=\"vm.disabledSubmit()\" class=\"md-mini md-raised md-primary btn-ui-serif\" \nhide show-gt-sm type=\"button\" ng-click=\"vm.sumbitData($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Submit Data</md-tooltip><md-icon md-font-icon=\"icon-arrow-right\"></md-icon><span>\nSubmit Data</span></md-button><div ng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NAME\"></span></span></th><th class=\"\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.JOBTITLE\"></span></span></th><th class=\"\"><span class=\"column-title\">\n<span translate=\"UMUT.MENU.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PERIOD\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.INSENTIF\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>Processed By\n</span></span></th><th width=\"20%\" class=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.STATUS\">\n</span></span></th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"\">{{ls.nik}}/{{ls.nama}}</td><td class=\"\">{{ls.job_title}}</td><td \nclass=\"\">{{ls.sub_area}}</td><td class=\"text-center\">{{ls.period}}</td><td class=\"text-center\">\n{{ls.insentif | currency:\"\"}}</td><td class=\"text-center\"><span>{{ls.created_by}}/{{ls.created_name}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.approval_status!==\'4\'\">{{ls.app}}</span> <span ng-if=\"ls.approval_status==\'4\'\"><a \nhref=\"\" ng-click=\"vm.viewComment($event,ls)\">{{ls.app}}</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip>\n</span></td><td class=\"text-center\"><md-menu><md-button class=\"md-icon-button action-selector\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button>\n<md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" \naria-label=\"Flip widget\"><span>Detail</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==\'1\'\">\n<md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==\'2\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"13\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-process-ass/new-insentif-process-ass.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"frmEmploye\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span>Process</span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.YEAR\"></span></label><md-select \nng-model=\"vm.year\" name=\"year\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmEmploye.year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.YEAR\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"FILTER.MONTH\"></span></label><md-select ng-model=\"vm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmEmploye.start.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"FILTER.MONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select \nng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"button\" \nng-click=\"vm.processData()\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" class=\"md-primary md-hue-1\" \naria-label=\"SUBMIT\"><span>Process</span></md-button><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" \nng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-report/insentifreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Insentif Report</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExporttoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Division</label><md-select ng-model=\"vm.division\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub division...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download</md-button>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-requirement-sku/input-insentif-requirement-sku.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"frmBT\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmBT)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.INCENTIVEREQUIREMENTSKU\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label translate=\"MENU.MAIN.SALESTYPE\"></label><md-select ng-model=\"vm.Form.objForm.ref_sales_type_id\" \nname=\"ref_sales_type_id\" ng-change=\"vm.getSchemeDetailList(vm.Form.objForm.ref_sales_type_id)\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sales type...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"ref_sales_type_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesType | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.FOCUS\"></label><md-select ng-model=\"vm.Form.objForm.incentive_schema_detail_id\" \nname=\"incentive_schema_detail_id\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"incentive_schema_detail_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSchemeDetai | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.incentive_schema_detail_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.FOCUS\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><md-autocomplete required \nstyle=\"background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.skuid\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getSku(vm.searchString)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.skuid)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PERCENTAGE\"></span></label><input \nname=\"percentage_requirement\" ng-model=\"vm.Form.objForm.percentage_requirement\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" required type=\"number\"><div \nng-messages=\"frmBT.percentage_requirement.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PERCENTAGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-requirement-sku/insentif-requirement-sku.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.INCENTIVEREQUIREMENTSKU\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><md-autocomplete required \nstyle=\"background: transparent;\n                                            border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.skuid\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getSku(vm.searchString)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.skuid)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container flex><label translate=\"MENU.MAIN.SALESTYPE\"></label><md-select \nng-model=\"vm.Form.objForm.ref_sales_type_id\" name=\"ref_sales_type_id\" \nng-change=\"vm.getSchemeDetailList(vm.Form.objForm.ref_sales_type_id)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sales type...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"ref_sales_type_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesType | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.FOCUS\"></label>\n<md-select ng-model=\"vm.Form.objForm.incentive_schema_detail_id\" name=\"incentive_schema_detail_id\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"incentive_schema_detail_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSchemeDetai | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.incentive_schema_detail_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.FOCUS\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon\n hide class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" \nlayout-align=\"space-between center\" layout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputData($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">New</md-tooltip><md-icon\n md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listSelected.length == 0\" ng-click=\" vm.Delete()\"><md-icon ng-if=\"vm.listSelected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listSelected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.PRODUCTCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MACHINE.MENU.PRODUCTNAME\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.SALESTYPE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.FOCUS\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PERCENTAGE\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($event,ls)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.sku_code}}\n</td><td class=\"\">{{ls.sku_name}}</td><td class=\"text-center\">{{ls.sales_type}}</td><td class=\"text-left\">\n{{ls.schema_detail}}</td><td class=\"text-right\">{{ls.percentage_requirement}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-requirement-sku/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insentif-sales-target/input-insentif-sales-target.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"frmBT\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmBT)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.SALESTARGET\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label>\n<md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"area_sales_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.area_sales_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.AREA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex><label><span>Product</span></label><md-autocomplete required \nstyle=\"background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.skuid\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getSku(vm.searchString)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.skuid)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.QTY\"></span></label><input \nname=\"qty_target\" ng-model=\"vm.Form.objForm.qty_target\" placeholder=\"{{ \'KPI.LABEL.QTY\' | translate}}\" required \ntype=\"number\"><div ng-messages=\"frmBT.qty_target.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.QTY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container>\n<md-input-container flex><label><span translate=\"KPI.LABEL.SALESVALUE\"></span></label><input name=\"sales_value\" \nng-model=\"vm.Form.objForm.sales_value\" placeholder=\"{{ \'KPI.LABEL.SALESVALUE\' | translate}}\" required type=\"number\">\n<div ng-messages=\"frmBT.sales_value.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.SALESVALUE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.end\" name=\"end\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-sales-target/insentif-sales-target.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SALESTARGET\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label>\n<md-select ng-model=\"vm.area\" name=\"area_sales_id\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label><span>Product</span></label><md-autocomplete required \nstyle=\"background: transparent;\n                                            border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.skuid\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getSku(vm.searchString)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.skuid)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"FILTER.YEAR\"></span></label><md-select \nng-model=\"vm.year\" name=\"year\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmEmploye.year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.YEAR\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.start\" \nname=\"start\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-model=\"vm.end\" name=\"end\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon\n hide class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" \nlayout-align=\"space-between center\" layout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputData($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">New</md-tooltip><md-icon\n md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listSelected.length == 0\" ng-click=\" vm.Delete()\"><md-icon ng-if=\"vm.listSelected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listSelected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Upload</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.AREA\"></span></span></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.PRODUCTCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MACHINE.MENU.PRODUCTNAME\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.SALESVALUE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.QTY\"></span></span></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span></span></th><th width=\"10%\" class=\"text-center\">\n<span class=\"column-title\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($event,ls)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td class=\"\">{{ls.area_sales}}</td><td \nclass=\"text-center\">{{ls.sku_code}}</td><td class=\"\">{{ls.sku_name}}</td><td class=\"text-right\">{{ls.sales_value}}</td>\n<td class=\"text-right\">{{ls.qty_target}}</td><td class=\"text-right\">{{ls.start_date | date : \"MMMM yyyy\"}}</td><td \nclass=\"text-right\">{{ls.end_date | date : \"MMMM yyyy\"}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-sales-target/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insentif-sales-target-contribution/input-insentif-sales-target-contribution.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"frmBT\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmBT)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.SALESTARGETCONTRIBUTION\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label translate=\"MENU.MAIN.SALESTARGET\"></label><md-select \nng-model=\"vm.Form.objForm.incentive_sales_value_target_id\" name=\"incentive_sales_value_target_id\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"incentive_sales_value_target_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSalesTarget | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.incentive_sales_value_target_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SALESTARGET\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label translate=\"MENU.MAIN.SALESCODE\">\n</label><md-select ng-model=\"vm.Form.objForm.ref_sales_code_id\" name=\"ref_sales_code_id\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sales code...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"ref_sales_code_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesCode | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.ref_sales_code_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.SALESCODE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.CONTRIBUTION\">\n</span></label><input name=\"contribution\" ng-model=\"vm.Form.objForm.contribution\" \nplaceholder=\"{{ \'KPI.LABEL.CONTRIBUTION\' | translate}}\" required type=\"number\"><div \nng-messages=\"frmBT.contribution.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.CONTRIBUTION\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.end\" name=\"end\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-sales-target-contribution/insentif-sales-target-contribution.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SALESTARGETCONTRIBUTION\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"MENU.MAIN.SALESCODE\">\n</label><md-select ng-model=\"vm.ref_sales_code_id\" name=\"ref_sales_code_id\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sales code...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"ref_sales_code_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesCode | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.ref_sales_code_id.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span>\n</label><md-select ng-model=\"vm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-model=\"vm.end\" \nname=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"end\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"KPI.LABEL.ENDMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon\n hide class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" \nlayout-align=\"space-between center\" layout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputData($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">New</md-tooltip><md-icon\n md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listSelected.length == 0\" ng-click=\" vm.Delete()\"><md-icon ng-if=\"vm.listSelected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listSelected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Upload</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th width=\"10%\" class=\"text-center\">\n<span class=\"column-title\"><span translate=\"MENU.MAIN.SALESCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.SALESTARGET\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.CONTRIBUTION\"></span></span></th><th width=\"10%\" class=\"text-center\">\n<span class=\"column-title\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span></span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($event,ls)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td class=\"\">{{ls.sales_code}}</td><td \nclass=\"\">{{ls.sales_target}}</td><td class=\"text-right\">{{ls.contribution}}%</td><td class=\"text-center\">\n{{ls.start_date | date : \"MMMM yyyy\"}}</td><td class=\"text-center\">{{ls.end_date | date : \"MMMM yyyy\"}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-sales-target-contribution/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insentif-skema-ass-adjust/input-insentif-skema-ass-adjust.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"frmBT\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmBT)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.SKEMAASSADJUST\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.TARGETREQ\">\n</label><input type=\"number\" ng-model=\"vm.Form.objForm.target_req\" ng-required=\"true\" name=\"target_req\"><div \nng-messages=\"frmBT.target_req.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.TARGETREQ\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.TARGETTOBE\"></label><input type=\"number\" ng-model=\"vm.Form.objForm.target_tobe\" \nng-required=\"true\" name=\"target_tobe\"><div ng-messages=\"frmBT.target_tobe.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MENU.MAIN.TARGETTOBE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label>\n<md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.STARTDATE\"></label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.STARTDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"PAYROLL.MENU.ENDDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" \nng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div ng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-skema-ass-adjust/insentif-skema-ass-adjust.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SKEMAASSADJUST\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm><label \ntranslate=\"PAYROLL.MENU.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.ENDDATE\">\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.end_date\"></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" \nlayout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div\n class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputData($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listSelected.length == 0\" ng-click=\" vm.Delete()\"><md-icon ng-if=\"vm.listSelected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listSelected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.TARGETREQ\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.TARGETTOBE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.STARTDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.ENDDATE\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editData($event,ls)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-right\">{{ls.target_req}}%</td><td class=\"text-right\">{{ls.target_tobe}}%</td>\n<td class=\"text-center\">{{ls.start_date_name}}</td><td class=\"text-center\">{{ls.end_date_name}}</td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, ls)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"ACTION.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"11\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-skema/insentif-skema-detail-ach.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-500-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"KPI.LABEL.SALESTYPE\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead>\n<tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.SALESTYPE\"></span></span></th><th width=\"5%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead>\n<tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.listData\"><td class=\"text-center\">{{($index + 1)}}</td>\n<td class=\"text-center\">{{item.name}}</td><td class=\"text-center\">{{item.amount}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.listData.length <= 0\"><td colspan=\"13\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"UMUT.MENU.CLOSE\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-skema/insentif-skema-edit.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.SCHEMAINCENTIVE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><label class=\"text-grey\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> *</label>\n<div layout=\"row\"><md-input-container class=\"drop-mod\" ng-init=\"principalIndex = $index\" \nng-repeat=\"litem in vm.listPrincipal\" flex=\"10\"><md-checkbox flex aria-label=\"Checked\" \nng-checked=\"vm.exists(litem, vm.selectedPrincipal)\" ng-click=\"vm.toggle(litem, vm.selectedPrincipal)\">\n{{litem.name | uppercase}}</md-checkbox><div ng-messages=\"frmBT.principal.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><label class=\"text-grey\"><span \ntranslate=\"MYPROFILE.MENU.HEADERDESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm>\n<div style=\"padding: 2px\"><textarea rows=\"2\" ng-model=\"vm.Form.objForm.description\" ng-required=\"true\"></textarea>\n</div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\"></label>\n<md-select ng-model=\"vm.Form.objForm.channel\" ng-change=\"vm.getWilayah(vm.Form.objForm.channel)\" name=\"channel\" \nng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select \nng-model=\"vm.Form.objForm.schema_object\" name=\"schema_object\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSchemeObject\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select ng-model=\"vm.Form.objForm.scheme_type\" name=\"scheme_type\" \nng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeType\">{{ls.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.WILAYAH\"></label>\n<md-select multiple=\"true\" ng-model=\"vm.Form.objForm.wilayah\" name=\"wilayah\" ng-required=\"true\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select \nng-model=\"vm.Form.objForm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select \nng-model=\"vm.Form.objForm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><fieldset \nstyle=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" ng-repeat=\"ls in vm.listKpi\"><legend>KPI {{parentIndex+1}}\n</legend><div layout=\"row\" ng-if=\"vm.listKpi[parentIndex].showIsSkuFocus==1\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.listKpi[parentIndex].is_checked\" ng-click=\"vm.checkIsSKUFocus(vm.listKpi[parentIndex])\" \nng-model=\"vm.listKpi[parentIndex].is_sku_focus\" aria-label=\"\"><span translate=\"KPI.LABEL.ISSKUFOCUS\"></span>\n</md-checkbox></div><br><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.CRITERIA\"></span></label><md-select ng-model=\"vm.listKpi[parentIndex].criteria\" \nname=\"criteria{{parentIndex}}\" ng-change=\"vm.changeCriteria(vm.listKpi[parentIndex],vm.listKpi[parentIndex].criteria)\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"criteria\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.CRITERIA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.WEIGHT\"></span>\n</label><input name=\"weight{{parentIndex}}\" ng-model=\"vm.listKpi[parentIndex].weight\" \nplaceholder=\"{{ \'KPI.LABEL.WEIGHT\' | translate}}\" required type=\"number\"></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.listKpi[parentIndex].criteria==3 || vm.Form.objForm.schema_object==5\" flex><label><span \ntranslate=\"KPI.LABEL.TARGET\"></span></label><input name=\"target{{parentIndex}}\" \nng-model=\"vm.listKpi[parentIndex].target\" placeholder=\"{{ \'KPI.LABEL.TARGET\' | translate}}\" required type=\"number\">\n</md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.listKpi[parentIndex].criteria==1\"><md-input-container \nflex><label><span>SKU Requirements</span></label><md-autocomplete \nstyle=\"background: transparent;\n                  border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.listKpi[parentIndex].skuid\" md-search-text=\"vm.listKpi[parentIndex].searchString\" \nmd-items=\"item in vm.getSku(vm.listKpi[parentIndex].searchString)\" md-item-text=\"item.name\" \nng-model=\"vm.listKpi[parentIndex].skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.listKpi[parentIndex],vm.listKpi[parentIndex].skuid)\">\n<md-item-template><span md-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERCENTAGE\"></span></label><input \nname=\"percentage_requirement\" ng-model=\"vm.listKpi[parentIndex].percentage_requirement\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" type=\"number\"><div \nng-messages=\"frmBT.percentage_requirement.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PERCENTAGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><div layout=\"row\">\n<md-checkbox class=\"no-label\" ng-checked=\"vm.listKpi[parentIndex].is_merge_checked\" \nng-click=\"vm.checkIsMerge(vm.listKpi[parentIndex])\" ng-model=\"vm.listKpi[parentIndex].is_merge\" aria-label=\"\"><span \ntranslate=\"KPI.LABEL.ISMERGE\"></span></md-checkbox></div><br><label class=\"text-grey\"><span \ntranslate=\"KPI.LABEL.PRINCIPAL\"></span> *</label><div layout=\"row\"><md-input-container class=\"drop-mod\" \nng-init=\"principalIndex = $index\" ng-repeat=\"litem in vm.listKpi[parentIndex].listPrincipal\" flex=\"10\"><md-checkbox \nflex aria-label=\"Checked\" ng-checked=\"vm.exists(litem, vm.listKpi[parentIndex].selectedPrincipal)\" \nng-click=\"vm.toggle(litem, vm.listKpi[parentIndex].selectedPrincipal)\">{{litem.name | uppercase}}</md-checkbox><div \nng-messages=\"frmBT.principal.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.PRINCIPAL\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><label \nclass=\"text-grey\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container \nflex flex-gt-sm><div style=\"padding: 2px\"><textarea rows=\"2\" ng-model=\"vm.listKpi[parentIndex].description\" \nng-required=\"true\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"achIndex = $index\" \nng-repeat=\"lsach in vm.listKpi[parentIndex].ach\"><legend><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> *</legend><div\n layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.STARTRANGE\"></span></label><input \ntype=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].start_range\" name=\"start_range{{parentIndex}}\" required>\n<div ng-messages=\"frmBT.start_range.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.STARTRANGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex><label>\n<span translate=\"KPI.LABEL.ENDRANGE\"></span></label><input type=\"number\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].end_range\" name=\"end_range{{parentIndex}}\" required><div \nng-messages=\"frmBT.end_range.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDRANGE\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span></label><input type=\"number\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].multiple_index\" name=\"multiple_index{{parentIndex}}\"><div \nng-messages=\"frmBT.multiple_index.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.Form.objForm.channel==\'MT\'\" flex><label><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span></label><input \ntype=\"text\" maxlength=\"1\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].achievement\" \nname=\"achievement{{parentIndex}}\"><div ng-messages=\"frmBT.achievement.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><th class=\"text-center\" \nng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.header}}</span></th></tr></thead><tbody><tr \nng-init=\"childIndex = $index\" ng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><input name=\"amount{{childIndex2}}\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].sales_type[childIndex].cols[childIndex2].data\" required type=\"number\">\n</td></tr></tbody></table></md-content></div><md-button ng-if=\"achIndex!=0\" \nng-click=\"vm.delListAch(vm.listKpi[parentIndex].ach,achIndex)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"KPI.LABEL.DELETE\"></span></md-button></fieldset><md-button \nng-click=\"vm.addAch(vm.listKpi[parentIndex].ach)\" class=\"md-mini md-raised md-primary\" style=\"height:20px\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Add Achievement</md-button></fieldset></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-skema/insentif-skema-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.SCHEMAINCENTIVE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><label class=\"text-grey\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> *</label>\n<div layout=\"row\"><md-input-container class=\"drop-mod\" ng-init=\"principalIndex = $index\" \nng-repeat=\"litem in vm.listPrincipal\" flex=\"10\"><md-checkbox flex aria-label=\"Checked\" \nng-checked=\"vm.exists(litem, vm.selectedPrincipal)\" ng-click=\"vm.toggle(litem, vm.selectedPrincipal)\">\n{{litem.name | uppercase}}</md-checkbox><div ng-messages=\"frmBT.principal.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><label class=\"text-grey\"><span \ntranslate=\"MYPROFILE.MENU.HEADERDESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm>\n<div style=\"padding: 2px\"><textarea rows=\"2\" ng-model=\"vm.Form.objForm.description\" ng-required=\"true\"></textarea>\n</div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\"></label>\n<md-select ng-model=\"vm.Form.objForm.channel\" \nng-change=\"vm.getWilayah(vm.Form.objForm.channel,vm.Form.objForm.schema_object,vm.Form.objForm.scheme_type)\" \nname=\"channel\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select \nng-change=\"vm.getWilayah(vm.Form.objForm.channel,vm.Form.objForm.schema_object,vm.Form.objForm.scheme_type)\" \nng-model=\"vm.Form.objForm.schema_object\" name=\"schema_object\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSchemeObject\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select \nng-change=\"vm.getWilayah(vm.Form.objForm.channel,vm.Form.objForm.schema_object,vm.Form.objForm.scheme_type)\" \nng-model=\"vm.Form.objForm.scheme_type\" name=\"scheme_type\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSchemeType\">{{ls.name}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label translate=\"KPI.LABEL.WILAYAH\"></label><md-select multiple=\"true\" \nng-model=\"vm.Form.objForm.wilayah\" name=\"wilayah\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select \nng-model=\"vm.Form.objForm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select \nng-model=\"vm.Form.objForm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><fieldset \nstyle=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" ng-repeat=\"ls in vm.listKpi\"><legend>KPI {{parentIndex+1}}\n</legend><div layout=\"row\" ng-if=\"vm.listKpi[parentIndex].showIsSkuFocus==1\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.listKpi[parentIndex].is_checked\" ng-click=\"vm.checkIsSKUFocus(vm.listKpi[parentIndex])\" \nng-model=\"vm.listKpi[parentIndex].is_sku_focus\" aria-label=\"\"><span translate=\"KPI.LABEL.ISSKUFOCUS\"></span>\n</md-checkbox><md-button ng-if=\"parentIndex!=0\" class=\"md-mini\" ng-click=\"vm.delListAch(vm.listKpi,parentIndex)\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"KPI.LABEL.DELETE\"></span></md-button></div><br><div \nlayout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.CRITERIA\"></span></label>\n<md-select ng-model=\"vm.listKpi[parentIndex].criteria\" name=\"criteria{{parentIndex}}\" \nng-change=\"vm.changeCriteria(vm.listKpi[parentIndex],vm.listKpi[parentIndex].criteria)\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"criteria\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.CRITERIA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.WEIGHT\"></span>\n</label><input name=\"weight{{parentIndex}}\" ng-model=\"vm.listKpi[parentIndex].weight\" \nplaceholder=\"{{ \'KPI.LABEL.WEIGHT\' | translate}}\" required type=\"number\"></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.listKpi[parentIndex].criteria==3 || vm.Form.objForm.schema_object==5\" flex><label><span \ntranslate=\"KPI.LABEL.TARGET\"></span></label><input name=\"target{{parentIndex}}\" \nng-model=\"vm.listKpi[parentIndex].target\" placeholder=\"{{ \'KPI.LABEL.TARGET\' | translate}}\" required type=\"number\">\n</md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.listKpi[parentIndex].criteria==1\"><md-input-container \nflex><label><span>SKU Requirements</span></label><md-autocomplete \nstyle=\"background: transparent;\n                  border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.listKpi[parentIndex].skuid\" md-search-text=\"vm.listKpi[parentIndex].searchString\" \nmd-items=\"item in vm.getSku(vm.listKpi[parentIndex].searchString)\" md-item-text=\"item.name\" \nng-model=\"vm.listKpi[parentIndex].skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.listKpi[parentIndex],vm.listKpi[parentIndex].skuid)\">\n<md-item-template><span md-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERCENTAGE\"></span></label><input \nname=\"percentage_requirement\" ng-model=\"vm.listKpi[parentIndex].percentage_requirement\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" type=\"number\"><div \nng-messages=\"frmBT.percentage_requirement.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PERCENTAGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><div layout=\"row\">\n<md-checkbox class=\"no-label\" ng-checked=\"vm.listKpi[parentIndex].is_merge_checked\" \nng-click=\"vm.checkIsMerge(vm.listKpi[parentIndex])\" ng-model=\"vm.listKpi[parentIndex].is_merge\" aria-label=\"\"><span \ntranslate=\"KPI.LABEL.ISMERGE\"></span></md-checkbox></div><br><label class=\"text-grey\"><span \ntranslate=\"KPI.LABEL.PRINCIPAL\"></span> *</label><div layout=\"row\"><md-input-container class=\"drop-mod\" \nng-init=\"principalIndex = $index\" ng-repeat=\"litem in vm.listKpi[parentIndex].listPrincipal\" flex=\"10\"><md-checkbox \nflex aria-label=\"Checked\" ng-checked=\"vm.exists(litem, vm.listKpi[parentIndex].selectedPrincipal)\" \nng-click=\"vm.toggle(litem, vm.listKpi[parentIndex].selectedPrincipal, vm.listKpi[parentIndex])\">\n{{litem.name | uppercase}}</md-checkbox><div ng-messages=\"frmBT.principal.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container width=\"50px\" \nng-init=\"categoryIndex = $index\" ng-if=\"vm.listKpi[parentIndex].showKSNI\" flex=\"20\"><label \ntranslate=\"MENU.MAIN.PRODUCTCATEGORYKSNI\"></label><md-select multiple=\"true\" \nng-model=\"vm.listKpi[parentIndex].product_category_ksni\" name=\"product_category_ksni\" ng-required=\"true\"><md-option \nvalue=\"{{litem.id}}\" ng-repeat=\"litem in vm.listKpi[parentIndex].productCategoryKsniList\">{{litem.name}}</md-option>\n</md-select><div ng-messages=\"frmBT.product_category_ksni.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.PRODUCTCATEGORYKSNI\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container width=\"50px\" ng-init=\"categoryIndex = $index\" \nng-if=\"vm.listKpi[parentIndex].showLOTTE\" flex=\"20\"><label translate=\"MENU.MAIN.PRODUCTCATEGORYLOTTE\"></label>\n<md-select multiple=\"true\" ng-model=\"vm.listKpi[parentIndex].product_category_lotte\" name=\"product_category_lotte\" \nng-required=\"true\"><md-option value=\"{{litem.id}}\" \nng-repeat=\"litem in vm.listKpi[parentIndex].productCategoryLotteList\">{{litem.name}}</md-option></md-select><div \nng-messages=\"frmBT.product_category_lotte.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.PRODUCTCATEGORYLOTTE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container width=\"50px\" ng-init=\"categoryIndex = $index\" \nng-if=\"vm.listKpi[parentIndex].showSIMBA\" flex=\"20\"><label translate=\"MENU.MAIN.PRODUCTCATEGORYSIMBA\"></label>\n<md-select multiple=\"true\" ng-model=\"vm.listKpi[parentIndex].product_category_simba\" name=\"product_category_simba\" \nng-required=\"true\"><md-option value=\"{{litem.id}}\" \nng-repeat=\"litem in vm.listKpi[parentIndex].productCategorySimbaList\">{{litem.name}}</md-option></md-select><div \nng-messages=\"frmBT.product_category_simba.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.PRODUCTCATEGORYSIMBA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><label class=\"text-grey\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div \nlayout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 2px\"><textarea rows=\"2\" \nng-model=\"vm.listKpi[parentIndex].description\" ng-required=\"true\"></textarea></div><div \nng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"achIndex = $index\" \nng-repeat=\"lsach in vm.listKpi[parentIndex].ach\"><legend><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> *</legend><div\n layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.STARTRANGE\"></span></label><input \ntype=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].start_range\" name=\"start_range{{parentIndex}}\" required>\n<div ng-messages=\"frmBT.start_range.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.STARTRANGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex \nng-if=\"vm.listKpi[parentIndex].is_checked==0\"><label><span translate=\"KPI.LABEL.ENDRANGE\"></span></label><input \ntype=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].end_range\" name=\"end_range{{parentIndex}}\" required><div \nng-messages=\"frmBT.end_range.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDRANGE\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\" ng-if=\"vm.listKpi[parentIndex].is_checked==0\"><span>%</span></label>\n<md-input-container flex><label><span translate=\"KPI.LABEL.MULTIPLIERVALUE\"></span></label><input type=\"number\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].multiple_index\" name=\"multiple_index{{parentIndex}}\"><div \nng-messages=\"frmBT.multiple_index.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.Form.objForm.channel==\'MT\'\" flex><label><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span></label><input \ntype=\"text\" maxlength=\"1\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].achievement\" \nname=\"achievement{{parentIndex}}\"><div ng-messages=\"frmBT.achievement.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.listKpi[parentIndex].is_checked==1\" flex><label><span \ntranslate=\"MENU.MAIN.QUANTITY\"></span></label><input type=\"number\" maxlength=\"1\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].quantity\" name=\"quantity{{parentIndex}}\"><div \nng-messages=\"frmBT.quantity.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.QUANTITY\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><th class=\"text-center\" \nng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.header}}</span></th></tr></thead><tbody><tr \nng-init=\"childIndex = $index\" ng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><input name=\"amount{{childIndex2}}\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].sales_type[childIndex].cols[childIndex2].data\" required type=\"number\">\n</td></tr></tbody></table></md-content></div><md-button ng-if=\"achIndex!=0\" \nng-click=\"vm.delListAch(vm.listKpi[parentIndex].ach,achIndex)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"KPI.LABEL.DELETE\"></span></md-button></fieldset><md-button \nng-click=\"vm.addAch(vm.listKpi[parentIndex].ach)\" class=\"md-mini md-raised md-primary\" style=\"height:20px\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Add Achievement</md-button></fieldset><md-button ng-if=\"vm.showAddCriteria\" \nng-click=\"vm.addCriteria(vm.Form.objForm.channel,vm.Form.objForm.schema_object,vm.Form.objForm.scheme_type)\" \nclass=\"md-raised md-mini md-primary\" style=\"height:20px\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Add Criteria\n</md-button></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/insentif-skema/insentif-skema.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SCHEMAINCENTIVE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label \ntranslate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.channel\" name=\"channel\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select ng-model=\"vm.schema_object\" name=\"schema_object\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeObject\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select \nng-model=\"vm.scheme_type\" name=\"scheme_type\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeType\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"start\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span>\n</label><md-select ng-model=\"vm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Upload</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.CHANNEL\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SCHEMEOBJECT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SCHEMETYPE\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.START\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.END\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" ng-dblclick=\"vm.viewDetail($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.channel}}</td><td class=\"text-center\">\n{{item.schema_object}}</td><td class=\"text-center\">{{item.schema_type | uppercase}}</td><td class=\"text-center\">\n{{item.start_date | date : \'MMMM yyyy\'}}</td><td class=\"text-center\">{{item.end_date | date : \'MMMM yyyy\'}}</td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewDetail($event, item)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"UMUT.MENU.DETAIL\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"UMUT.MENU.DETAIL\"></span></p></div></md-button><md-button \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" \nflex><md-tooltip><span translate=\"KPI.LABEL.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-pencil\"></md-icon><p flex><span translate=\"KPI.LABEL.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-skema/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insentif-skema/view-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.SCHEMAINCENTIVE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><label class=\"text-grey\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> *</label>\n<div layout=\"row\"><md-input-container class=\"drop-mod\" ng-init=\"principalIndex = $index\" \nng-repeat=\"litem in vm.listPrincipal\" flex=\"10\"><md-checkbox ng-disabled=\"true\" flex aria-label=\"Checked\" \nng-checked=\"vm.exists(litem, vm.selectedPrincipal)\" ng-click=\"vm.toggle(litem, vm.selectedPrincipal)\">\n{{litem.name | uppercase}}</md-checkbox><div ng-messages=\"frmBT.principal.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><label class=\"text-grey\"><span \ntranslate=\"MYPROFILE.MENU.HEADERDESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm>\n<div style=\"padding: 2px\"><textarea ng-disabled=\"true\" rows=\"2\" ng-model=\"vm.Form.objForm.description\" \nng-required=\"true\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label \ntranslate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.Form.objForm.channel\" ng-disabled=\"true\" \nng-change=\"vm.getWilayah(vm.Form.objForm.channel)\" name=\"channel\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select ng-model=\"vm.Form.objForm.schema_object\" \nname=\"schema_object\" ng-required=\"true\" ng-disabled=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSchemeObject\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select ng-model=\"vm.Form.objForm.scheme_type\" name=\"scheme_type\" \nng-required=\"true\" ng-disabled=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeType\">{{ls.name}}\n</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex><label \ntranslate=\"KPI.LABEL.WILAYAH\"></label><md-select multiple=\"true\" ng-model=\"vm.Form.objForm.wilayah\" name=\"wilayah\" \nng-required=\"true\" ng-disabled=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah\">{{ls.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required ng-disabled=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.end\" name=\"end\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"end\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"KPI.LABEL.ENDMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" \nng-repeat=\"ls in vm.listKpi\"><legend>KPI {{parentIndex+1}}</legend><div layout=\"row\"><md-checkbox ng-disabled=\"true\" \nclass=\"no-label\" ng-checked=\"vm.listKpi[parentIndex].is_checked\" \nng-click=\"vm.checkIsSKUFocus(vm.listKpi[parentIndex])\" ng-model=\"vm.listKpi[parentIndex].is_sku_focus\" aria-label=\"\">\n<span translate=\"KPI.LABEL.ISSKUFOCUS\"></span></md-checkbox></div><br><div layout=\"row\"><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.CRITERIA\"></span></label><md-select \nng-model=\"vm.listKpi[parentIndex].criteria\" name=\"criteria{{parentIndex}}\" md-on-close=\"vm.clearSearchTerm()\" required \nng-disabled=\"true\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"criteria\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.CRITERIA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.WEIGHT\"></span></label><input \nname=\"weight{{parentIndex}}\" readonly=\"readonly\" ng-model=\"vm.listKpi[parentIndex].weight\" \nplaceholder=\"{{ \'KPI.LABEL.WEIGHT\' | translate}}\" required type=\"number\"></md-input-container><md-input-container \nng-if=\"vm.listKpi[parentIndex].criteria==3\" flex><label><span translate=\"KPI.LABEL.TARGET\"></span></label><input \nname=\"target{{parentIndex}}\" readonly=\"readonly\" ng-model=\"vm.listKpi[parentIndex].target\" \nplaceholder=\"{{ \'KPI.LABEL.TARGET\' | translate}}\" required type=\"number\"></md-input-container></div><label \nclass=\"text-grey\"><span translate=\"KPI.LABEL.PRINCIPAL\"></span> *</label><div layout=\"row\"><md-input-container \nclass=\"drop-mod\" ng-init=\"principalIndex = $index\" ng-repeat=\"litem in vm.listKpi[parentIndex].listPrincipal\" \nflex=\"10\"><md-checkbox flex aria-label=\"Checked\" ng-disabled=\"true\" \nng-checked=\"vm.exists(litem, vm.listKpi[parentIndex].selectedPrincipal)\" \nng-click=\"vm.toggle(litem, vm.listKpi[parentIndex].selectedPrincipal)\">{{litem.name | uppercase}}</md-checkbox><div \nng-messages=\"frmBT.principal.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.PRINCIPAL\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.listKpi[parentIndex].criteria==1\"><md-input-container flex><label><span>SKU Requirements\n</span></label><input name=\"skuid\" ng-model=\"vm.listKpi[parentIndex].skuid\" type=\"text\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERCENTAGE\"></span></label><input \nname=\"percentage_requirement\" ng-model=\"vm.listKpi[parentIndex].percentage_requirement\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" type=\"number\" readonly=\"readonly\"><div \nng-messages=\"frmBT.percentage_requirement.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PERCENTAGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><label class=\"text-grey\">\n<span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm>\n<div style=\"padding: 2px\"><textarea readonly=\"readonly\" rows=\"2\" ng-model=\"vm.listKpi[parentIndex].description\" \nng-required=\"true\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"achIndex = $index\" \nng-repeat=\"lsach in vm.listKpi[parentIndex].ach\"><legend><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> *</legend><div\n layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.STARTRANGE\"></span></label><input \nreadonly=\"readonly\" type=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].start_range\" \nname=\"start_range{{parentIndex}}\" required><div ng-messages=\"frmBT.start_range.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTRANGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label>\n<md-input-container flex><label><span translate=\"KPI.LABEL.ENDRANGE\"></span></label><input readonly=\"readonly\" \ntype=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].end_range\" name=\"end_range{{parentIndex}}\" required><div \nng-messages=\"frmBT.end_range.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDRANGE\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span></label><input readonly=\"readonly\" type=\"number\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].multiple_index\" name=\"multiple_index{{parentIndex}}\"><div \nng-messages=\"frmBT.multiple_index.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.Form.objForm.channel==\'MT\'\" flex><label><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span></label><input \nreadonly=\"readonly\" type=\"text\" maxlength=\"1\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].achievement\" \nreadonly=\"readonly\" name=\"achievement{{parentIndex}}\"><div ng-messages=\"frmBT.achievement.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container ng-if=\"vm.listKpi[parentIndex].is_checked==1\" flex><label>\n<span translate=\"MENU.MAIN.QUANTITY\"></span></label><input readonly=\"readonly\" type=\"number\" maxlength=\"1\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].quantity\" name=\"quantity{{parentIndex}}\"><div \nng-messages=\"frmBT.quantity.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.QUANTITY\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><th class=\"text-center\" \nng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.header}}</span></th></tr></thead><tbody><tr \nng-init=\"childIndex = $index\" ng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><md-input-container flex><p>\n{{ vm.listKpi[parentIndex].ach[achIndex].sales_type[childIndex].cols[childIndex2].data | currency : \"\"}}</p>\n</md-input-container></td></tr></tbody></table></md-content></div></fieldset></fieldset></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/insentif-skema-override/insentif-skema-override-detail-ach.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-500-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"KPI.LABEL.SALESTYPE\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead>\n<tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.SALESTYPE\"></span></span></th><th width=\"5%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead>\n<tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.listData\"><td class=\"text-center\">{{($index + 1)}}</td>\n<td class=\"text-center\">{{item.name}}</td><td class=\"text-center\">{{item.amount}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.listData.length <= 0\"><td colspan=\"13\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"UMUT.MENU.CLOSE\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-skema-override/insentif-skema-override-edit.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.SCHEMAINCENTIVEOVERRIDE\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nflex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" \nname=\"surkom_no\" required><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.channel\" ng-change=\"vm.getWilayah(vm.Form.objForm.channel)\" name=\"channel\" \nng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select \nng-disabled=\"true\" ng-model=\"vm.Form.objForm.schema_object\" name=\"schema_object\" ng-required=\"true\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeObject\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.scheme_type\" name=\"scheme_type\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSchemeType\">{{ls.name}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" \nname=\"area_sales_id\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select \nng-model=\"vm.Form.objForm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><fieldset \nstyle=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" ng-repeat=\"ls in vm.listKpi\"><legend>KPI {{parentIndex+1}}\n</legend><div layout=\"row\" ng-if=\"vm.listKpi[parentIndex].showIsSkuFocus==1\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.listKpi[parentIndex].is_checked\" ng-click=\"vm.checkIsSKUFocus(vm.listKpi[parentIndex])\" \nng-model=\"vm.listKpi[parentIndex].is_sku_focus\" aria-label=\"\"><span translate=\"KPI.LABEL.ISSKUFOCUS\"></span>\n</md-checkbox></div><br><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.CRITERIA\"></span></label><md-select ng-disabled=\"true\" \nng-model=\"vm.listKpi[parentIndex].criteria\" name=\"criteria{{parentIndex}}\" \nng-change=\"vm.changeCriteria(vm.listKpi[parentIndex],vm.listKpi[parentIndex].criteria)\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"criteria\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.CRITERIA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.WEIGHT\"></span>\n</label><input readonly=\"readonly\" name=\"weight{{parentIndex}}\" ng-model=\"vm.listKpi[parentIndex].weight\" \nplaceholder=\"{{ \'KPI.LABEL.WEIGHT\' | translate}}\" required type=\"number\"></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.listKpi[parentIndex].criteria==3\" flex><label><span translate=\"KPI.LABEL.TARGET\"></span></label><input \nreadonly=\"readonly\" name=\"target{{parentIndex}}\" ng-model=\"vm.listKpi[parentIndex].target\" \nplaceholder=\"{{ \'KPI.LABEL.TARGET\' | translate}}\" required type=\"number\"></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.listKpi[parentIndex].criteria==1\"><md-input-container flex><label><span>SKU Requirements\n</span></label><md-autocomplete style=\"background: transparent;\n                  border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.listKpi[parentIndex].skuid\" \nmd-search-text=\"vm.listKpi[parentIndex].searchString\" \nmd-items=\"item in vm.getSku(vm.listKpi[parentIndex].searchString)\" md-item-text=\"item.name\" \nng-model=\"vm.listKpi[parentIndex].skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.listKpi[parentIndex],vm.listKpi[parentIndex].skuid)\">\n<md-item-template><span md-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERCENTAGE\"></span></label><input \nname=\"percentage_requirement\" ng-model=\"vm.listKpi[parentIndex].percentage_requirement\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" type=\"number\"><div \nng-messages=\"frmBT.percentage_requirement.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PERCENTAGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><label class=\"text-grey\">\n<span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm>\n<div style=\"padding: 2px\"><textarea rows=\"2\" ng-model=\"vm.listKpi[parentIndex].description\" ng-required=\"true\">\n</textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"achIndex = $index\" \nng-repeat=\"lsach in vm.listKpi[parentIndex].ach\"><legend><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> *</legend><div\n layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.STARTRANGE\"></span></label><input \nreadonly=\"readonly\" type=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].start_range\" \nname=\"start_range{{parentIndex}}\" required><div ng-messages=\"frmBT.start_range.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTRANGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label>\n<md-input-container flex><label><span translate=\"KPI.LABEL.ENDRANGE\"></span></label><input readonly=\"readonly\" \ntype=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].end_range\" name=\"end_range{{parentIndex}}\" required><div \nng-messages=\"frmBT.end_range.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDRANGE\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span></label><input readonly=\"readonly\" type=\"number\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].multiple_index\" name=\"multiple_index{{parentIndex}}\"><div \nng-messages=\"frmBT.multiple_index.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.Form.objForm.channel==\'MT\'\" flex><label><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span></label><input \nreadonly=\"readonly\" type=\"text\" maxlength=\"1\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].achievement\" \nname=\"achievement{{parentIndex}}\"><div ng-messages=\"frmBT.achievement.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><th class=\"text-center\" \nng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.header}}</span></th></tr></thead><tbody><tr \nng-init=\"childIndex = $index\" ng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><input name=\"amount{{childIndex2}}\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].sales_type[childIndex].cols[childIndex2].data\" required type=\"number\">\n</td></tr></tbody></table></md-content></div></fieldset></fieldset><label class=\"text-grey\"><span \ntranslate=\"KPI.LABEL.UPLOADSURKOM\"></span></label><div layout=\"row\"><md-input-container md-no-float class=\"md-block\">\n<input type=\"file\" id=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n              action:\'uploadData\',\n              id:vm.Form.objForm.id,\n              area_sales_id:vm.Form.objForm.area_sales_id,\n              surkom_no:vm.Form.objForm.surkom_no,\n              surkom_date:vm.Form.objForm.surkom_date,\n              empno:vm.Form.objForm.nik.empno,\n              channel:vm.Form.objForm.channel,\n              schema_object:vm.Form.objForm.schema_object,\n              scheme_type:vm.Form.objForm.scheme_type,\n              start:vm.Form.objForm.start,\n              end:vm.Form.objForm.end,\n              listKpi:vm.listKpi\n            }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button ng-if=\"vm.edit&&(!vm.fileSizeError)\" type=\"button\" class=\"md-raised md-accent\" \nng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button><md-button ng-if=\"vm.edit&&vm.fileSizeError\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-skema-override/insentif-skema-override-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.SCHEMAINCENTIVEOVERRIDE\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><md-input-container class=\"drop-mod\" \nflex><label><span>Ref. Incentive Scheme</span></label><md-select ng-model=\"vm.Form.objForm.ref_id\" \nng-change=\"vm.loadDetailRef(vm.Form.objForm.ref_id)\" name=\"ref_id\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"ref_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRefScheme | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select>\n<div ng-messages=\"frmBT.ref_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ref. Surkom</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><div layout=\"row\"><md-input-container \nflex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" \nname=\"surkom_no\" required><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.channel\" ng-change=\"vm.getWilayah(vm.Form.objForm.channel)\" name=\"channel\" \nng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select \nng-disabled=\"true\" ng-model=\"vm.Form.objForm.schema_object\" name=\"schema_object\" ng-required=\"true\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeObject\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.scheme_type\" name=\"scheme_type\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSchemeType\">{{ls.name}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" \nname=\"area_sales_id\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span>\n</label><md-select ng-disabled=\"true\" ng-model=\"vm.Form.objForm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" \nrequired><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><fieldset \nstyle=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" ng-repeat=\"ls in vm.listKpi\"><legend>KPI {{parentIndex+1}}\n</legend><div layout=\"row\" ng-if=\"vm.listKpi[parentIndex].showIsSkuFocus==1\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.listKpi[parentIndex].is_checked\" ng-click=\"vm.checkIsSKUFocus(vm.listKpi[parentIndex])\" \nng-model=\"vm.listKpi[parentIndex].is_sku_focus\" aria-label=\"\"><span translate=\"KPI.LABEL.ISSKUFOCUS\"></span>\n</md-checkbox></div><br><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.CRITERIA\"></span></label><md-select ng-disabled=\"true\" \nng-model=\"vm.listKpi[parentIndex].criteria\" name=\"criteria{{parentIndex}}\" \nng-change=\"vm.changeCriteria(vm.listKpi[parentIndex],vm.listKpi[parentIndex].criteria)\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"criteria\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.CRITERIA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.WEIGHT\"></span>\n</label><input readonly=\"readonly\" name=\"weight{{parentIndex}}\" ng-model=\"vm.listKpi[parentIndex].weight\" \nplaceholder=\"{{ \'KPI.LABEL.WEIGHT\' | translate}}\" required type=\"number\"></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.listKpi[parentIndex].criteria==3\" flex><label><span translate=\"KPI.LABEL.TARGET\"></span></label><input \nreadonly=\"readonly\" name=\"target{{parentIndex}}\" ng-model=\"vm.listKpi[parentIndex].target\" \nplaceholder=\"{{ \'KPI.LABEL.TARGET\' | translate}}\" required type=\"number\"></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.listKpi[parentIndex].criteria==1\"><md-input-container flex><label><span>SKU Requirements\n</span></label><md-autocomplete style=\"background: transparent;\n                  border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.listKpi[parentIndex].skuid\" \nmd-search-text=\"vm.listKpi[parentIndex].searchString\" \nmd-items=\"item in vm.getSku(vm.listKpi[parentIndex].searchString)\" md-item-text=\"item.name\" \nng-model=\"vm.listKpi[parentIndex].skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.listKpi[parentIndex],vm.listKpi[parentIndex].skuid)\">\n<md-item-template><span md-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERCENTAGE\"></span></label><input \nname=\"percentage_requirement\" ng-model=\"vm.listKpi[parentIndex].percentage_requirement\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" type=\"number\"><div \nng-messages=\"frmBT.percentage_requirement.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PERCENTAGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><label class=\"text-grey\">\n<span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm>\n<div style=\"padding: 2px\"><textarea rows=\"2\" ng-model=\"vm.listKpi[parentIndex].description\" ng-required=\"true\">\n</textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"achIndex = $index\" \nng-repeat=\"lsach in vm.listKpi[parentIndex].ach\"><legend><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> *</legend><div\n layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.STARTRANGE\"></span></label><input \nreadonly=\"readonly\" type=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].start_range\" \nname=\"start_range{{parentIndex}}\" required><div ng-messages=\"frmBT.start_range.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTRANGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label>\n<md-input-container flex><label><span translate=\"KPI.LABEL.ENDRANGE\"></span></label><input readonly=\"readonly\" \ntype=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].end_range\" name=\"end_range{{parentIndex}}\" required><div \nng-messages=\"frmBT.end_range.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDRANGE\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span></label><input readonly=\"readonly\" type=\"number\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].multiple_index\" name=\"multiple_index{{parentIndex}}\"><div \nng-messages=\"frmBT.multiple_index.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.Form.objForm.channel==\'MT\'\" flex><label><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span></label><input \nreadonly=\"readonly\" type=\"text\" maxlength=\"1\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].achievement\" \nname=\"achievement{{parentIndex}}\"><div ng-messages=\"frmBT.achievement.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><th class=\"text-center\" \nng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.header}}</span></th></tr></thead><tbody><tr \nng-init=\"childIndex = $index\" ng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><input name=\"amount{{childIndex2}}\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].sales_type[childIndex].cols[childIndex2].data\" required type=\"number\">\n</td></tr></tbody></table></md-content></div></fieldset></fieldset><label class=\"text-grey\"><span \ntranslate=\"KPI.LABEL.UPLOADSURKOM\"></span></label><div layout=\"row\"><md-input-container md-no-float class=\"md-block\">\n<input type=\"file\" id=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n              action:\'uploadData\',\n              area_sales_id:vm.Form.objForm.area_sales_id,\n              surkom_no:vm.Form.objForm.surkom_no,\n              surkom_date:vm.Form.objForm.surkom_date,\n              empno:vm.Form.objForm.nik.empno,\n              channel:vm.Form.objForm.channel,\n              schema_object:vm.Form.objForm.schema_object,\n              scheme_type:vm.Form.objForm.scheme_type,\n              start:vm.Form.objForm.start,\n              end:vm.Form.objForm.end,\n              listKpi:vm.listKpi\n            }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-skema-override/insentif-skema-override.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SCHEMAINCENTIVEOVERRIDE\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label \ntranslate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.channel\" name=\"channel\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select ng-model=\"vm.schema_object\" name=\"schema_object\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeObject\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select \nng-model=\"vm.scheme_type\" name=\"scheme_type\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeType\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"start\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span>\n</label><md-select ng-model=\"vm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.CHANNEL\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SCHEMEOBJECT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SCHEMETYPE\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.START\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.END\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" ng-dblclick=\"vm.viewDetail($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.channel}}</td><td class=\"text-center\">\n{{item.schema_object}}</td><td class=\"text-center\">{{item.schema_type | uppercase}}</td><td class=\"text-center\">\n{{item.start_date | date : \'MMMM yyyy\'}}</td><td class=\"text-center\">{{item.end_date | date : \'MMMM yyyy\'}}</td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewDetail($event, item)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"UMUT.MENU.DETAIL\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"UMUT.MENU.DETAIL\"></span></p></div></md-button><md-button \nclass=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" \nflex><md-tooltip><span translate=\"KPI.LABEL.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-pencil\"></md-icon><p flex><span translate=\"KPI.LABEL.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-skema-override/view-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.SCHEMAINCENTIVEOVERRIDE\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nflex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMNO\"></label><input readonly=\"readonly\" type=\"text\" \nng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" required><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\">\n</label><md-datepicker ng-disabled=\"true\" md-hide-icons=\"calendar\" name=\"surkom_date\" \nng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div ng-messages=\"frmBT.surkom_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.nik\" name=\"nik\" \nreadonly=\"readonly\" required><div ng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NIK\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\"></label><md-select \nng-disabled=\"true\" ng-model=\"vm.Form.objForm.channel\" ng-change=\"vm.getWilayah(vm.Form.objForm.channel)\" \nname=\"channel\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select \nng-disabled=\"true\" ng-model=\"vm.Form.objForm.schema_object\" name=\"schema_object\" ng-required=\"true\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeObject\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.scheme_type\" name=\"scheme_type\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSchemeType\">{{ls.name}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-disabled=\"true\" ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.start\" name=\"start\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select ng-disabled=\"true\" \nng-disabled=\"true\" ng-model=\"vm.Form.objForm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><fieldset \nstyle=\"margin-bottom: 30px\" ng-init=\"parentIndex = $index\" ng-repeat=\"ls in vm.listKpi\"><legend>KPI {{parentIndex+1}}\n</legend><div layout=\"row\" ng-if=\"vm.listKpi[parentIndex].showIsSkuFocus==1\"><md-checkbox ng-disabled=\"true\" \nclass=\"no-label\" ng-checked=\"vm.listKpi[parentIndex].is_checked\" \nng-click=\"vm.checkIsSKUFocus(vm.listKpi[parentIndex])\" ng-model=\"vm.listKpi[parentIndex].is_sku_focus\" aria-label=\"\">\n<span translate=\"KPI.LABEL.ISSKUFOCUS\"></span></md-checkbox></div><br><div layout=\"row\"><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.CRITERIA\"></span></label><md-select ng-disabled=\"true\" \nng-model=\"vm.listKpi[parentIndex].criteria\" name=\"criteria{{parentIndex}}\" \nng-change=\"vm.changeCriteria(vm.listKpi[parentIndex],vm.listKpi[parentIndex].criteria)\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"criteria\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCriteria | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.criteria.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.CRITERIA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.WEIGHT\"></span>\n</label><input readonly=\"readonly\" name=\"weight{{parentIndex}}\" ng-model=\"vm.listKpi[parentIndex].weight\" \nplaceholder=\"{{ \'KPI.LABEL.WEIGHT\' | translate}}\" required type=\"number\"></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.listKpi[parentIndex].criteria==3\" flex><label><span translate=\"KPI.LABEL.TARGET\"></span></label><input \nreadonly=\"readonly\" name=\"target{{parentIndex}}\" ng-model=\"vm.listKpi[parentIndex].target\" \nplaceholder=\"{{ \'KPI.LABEL.TARGET\' | translate}}\" required type=\"number\"></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.listKpi[parentIndex].criteria==1\"><md-input-container flex><label><span>SKU Requirements\n</span></label><input type=\"text\" ng-model=\"vm.listKpi[parentIndex].skuid\" name=\"nik\" readonly=\"readonly\" required>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERCENTAGE\"></span></label><input \nname=\"percentage_requirement\" ng-model=\"vm.listKpi[parentIndex].percentage_requirement\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" type=\"number\"><div \nng-messages=\"frmBT.percentage_requirement.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PERCENTAGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label></div><label class=\"text-grey\">\n<span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm>\n<div style=\"padding: 2px\"><textarea rows=\"2\" ng-model=\"vm.listKpi[parentIndex].description\" ng-disabled=\"true\" \nng-required=\"true\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><fieldset style=\"margin-bottom: 30px\" ng-init=\"achIndex = $index\" \nng-repeat=\"lsach in vm.listKpi[parentIndex].ach\"><legend><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> *</legend><div\n layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.STARTRANGE\"></span></label><input \nreadonly=\"readonly\" type=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].start_range\" \nname=\"start_range{{parentIndex}}\" required><div ng-messages=\"frmBT.start_range.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTRANGE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label>\n<md-input-container flex><label><span translate=\"KPI.LABEL.ENDRANGE\"></span></label><input readonly=\"readonly\" \ntype=\"number\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].end_range\" name=\"end_range{{parentIndex}}\" required><div \nng-messages=\"frmBT.end_range.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDRANGE\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><label \nstyle=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span></label><input readonly=\"readonly\" type=\"number\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].multiple_index\" name=\"multiple_index{{parentIndex}}\"><div \nng-messages=\"frmBT.multiple_index.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.MULTIPLIERVALUE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container \nng-if=\"vm.Form.objForm.channel==\'MT\'\" flex><label><span translate=\"KPI.LABEL.ACHIEVEMENT\"></span></label><input \nreadonly=\"readonly\" type=\"text\" maxlength=\"1\" ng-model=\"vm.listKpi[parentIndex].ach[achIndex].achievement\" \nname=\"achievement{{parentIndex}}\"><div ng-messages=\"frmBT.achievement.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.ACHIEVEMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><th class=\"text-center\" \nng-repeat=\"col in row.cols\"><span class=\"column-title\">{{col.header}}</span></th></tr></thead><tbody><tr \nng-init=\"childIndex = $index\" ng-repeat=\"row in vm.listKpi[parentIndex].ach[achIndex].sales_type\"><td \nclass=\"text-center\" ng-init=\"childIndex2 = $index\" ng-repeat=\"col in row.cols\"><input readonly=\"readonly\" \nname=\"amount{{childIndex2}}\" \nng-model=\"vm.listKpi[parentIndex].ach[achIndex].sales_type[childIndex].cols[childIndex2].data\" required type=\"number\">\n</td></tr></tbody></table></md-content></div></fieldset></fieldset></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/insentif-sku-focus-general/input-insentif-sku-focus-general.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"frmBT\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmBT)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.SKUFOCUSGENERAL\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nng-required=\"vm.roa\"><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" ng-required=\"vm.roa\">\n</md-datepicker><div ng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label>\n<md-autocomplete style=\"margin-top: 3px; background: transparent;\n              border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchStringUser\" \nmd-items=\"item in vm.getEmployee(vm.searchStringUser)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChangedUser(vm.Form.objForm.nik)\" ng-required=\"vm.roa\"><md-item-template><span \nmd-highlight-text=\"vm.searchStringUser\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Product</label><md-autocomplete required \nstyle=\"background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.skuid\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getSku(vm.searchString)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.skuid)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container flex flex-gt-sm><label>ROA</label><input type=\"number\" ng-model=\"vm.Form.objForm.roa\" \nng-required=\"vm.isCb\" ng-change=\"vm.checkRoa(vm.Form.objForm.roa)\" name=\"roa\"><div ng-messages=\"frmBT.roa.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>ROA</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div>\n</div></md-input-container><label style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label><md-input-container flex \nflex-gt-sm><label translate=\"PAYROLL.MENU.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"PAYROLL.MENU.ENDDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-sku-focus-general/insentif-sku-focus-general.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SKUFOCUSGENERAL\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Product</label><md-autocomplete \nstyle=\"background: transparent;\n                                            border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.skuid\" md-search-text=\"vm.searchStringData\" \nmd-items=\"item in vm.getSku(vm.searchStringData)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.skuid)\"><md-item-template><span \nmd-highlight-text=\"vm.searchStringData\">{{item.name}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.STARTDATE\"></label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.ENDDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.end_date\"></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" \nlayout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div\n class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputData($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listSelected.length == 0\" ng-click=\" vm.Delete()\"><md-icon ng-if=\"vm.listSelected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listSelected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMCREATOR\"></span></span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\">\n<span translate=\"MENU.MAIN.PRODUCTCODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MACHINE.MENU.PRODUCTNAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>ROA\n</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span>\n</span></th><th class=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span></span>\n</th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody>\n<tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($event,ls)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.surkom_no}}\n</td><td class=\"text-center\">{{ls.surkom_date_name}}</td><td class=\"text-left\">\n{{ls.surkom_creator}} - {{ls.surkom_creator_name}}</td><td class=\"text-center\">{{ls.sku_code}}</td><td class=\"\">\n{{ls.sku_name}}</td><td class=\"text-right\">{{ls.roa}}%</td><td class=\"text-center\">{{ls.start_date_name}}</td><td \nclass=\"text-center\">{{ls.end_date_name}}</td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" \nclass=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\">\n<md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, ls)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"11\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-sku-focus/input-insentif-sku-focus.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"frmBT\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmBT)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.SKUFOCUS\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"row\"><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMNO\"></label>\n<input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" ng-required=\"vm.roa\"><div \nng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMNO\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"surkom_date\" \nng-model=\"vm.Form.objForm.surkom_date\" ng-required=\"vm.roa\"></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchStringUser\" \nmd-items=\"item in vm.getEmployee(vm.searchStringUser)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChangedUser(vm.Form.objForm.nik)\" ng-required=\"vm.roa\"><md-item-template><span \nmd-highlight-text=\"vm.searchStringUser\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" \nname=\"area_sales_id\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"MENU.MAIN.TARGETSOURCE\"></label><md-select \nng-model=\"vm.Form.objForm.target_source\" ng-change=\"vm.changeTarget(vm.Form.objForm.target_source)\" \nname=\"target_source\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listTargetSource\">{{ls.name}}</md-option></md-select><div ng-messages=\"frmBT.target_source.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.TARGETSOURCE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nng-if=\"!vm.isRoaValue\" flex flex-gt-sm><label>ROA</label><input type=\"number\" ng-model=\"vm.Form.objForm.roa\" \nng-required=\"vm.isCb\" ng-change=\"vm.checkRoa(vm.Form.objForm.roa)\" name=\"roa\"><div ng-messages=\"frmBT.roa.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>ROA</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div>\n</div></md-input-container><label ng-if=\"!vm.isRoaValue\" style=\"margin-top: 25px\" flex=\"10\"><span>%</span></label>\n<md-input-container ng-if=\"vm.isRoaValue\" flex flex-gt-sm><label>VALUE</label><input type=\"number\" \nng-model=\"vm.Form.objForm.roa_value\" ng-required=\"vm.isRoaValue\" name=\"roa_value\"><div \nng-messages=\"frmBT.roa_value.$error\" role=\"alert\"><div ng-message=\"required\"><span>VALUE</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Product</label><md-autocomplete required \nstyle=\"background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.skuid\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getSku(vm.searchString)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.skuid)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.STARTDATE\"></label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.STARTDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"PAYROLL.MENU.ENDDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-sku-focus/insentif-sku-focus.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SKUFOCUS\"></span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Product</label><md-autocomplete \nstyle=\"background: transparent;\n                                            border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.skuid\" md-search-text=\"vm.searchStringData\" \nmd-items=\"item in vm.getSku(vm.searchStringData)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.skuid\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.skuid)\"><md-item-template><span \nmd-highlight-text=\"vm.searchStringData\">{{item.name}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.area_sales_id\" \nname=\"area_sales_id\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.STARTDATE\"></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.ENDDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.end_date\"></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" \nlayout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div\n class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputData($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listSelected.length == 0\" ng-click=\" vm.Delete()\"><md-icon ng-if=\"vm.listSelected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listSelected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMCREATOR\"></span></span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\">\n<span translate=\"MENU.MAIN.PRODUCTCODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MACHINE.MENU.PRODUCTNAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.TARGETSOURCE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>ROA\n</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span>\n</span></th><th class=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span></span>\n</th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody>\n<tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($event,ls)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.surkom_no}}\n</td><td class=\"text-center\">{{ls.surkom_date_name}}</td><td class=\"text-left\">\n{{ls.surkom_creator}} - {{ls.surkom_creator_name}}</td><td class=\"text-center\">{{ls.sku_code}}</td><td class=\"\">\n{{ls.sku_name}}</td><td class=\"text-center\">{{ls.area_sales}}</td><td class=\"text-center\">{{ls.target_source}}</td><td \nclass=\"text-right\">{{ls.roa_view}}</td><td class=\"text-center\">{{ls.start_date_name}}</td><td class=\"text-center\">\n{{ls.end_date_name}}</td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" \nclass=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\">\n<md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, ls)\"><div \nlayout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"11\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-sku-focus/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insentif-target-absolute/insentif-target-absolute-edit.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.TARGETABSOLUTE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nrequired><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.Form.objForm.status\" name=\"status\" ng-required=\"true\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option></md-select></md-input-container>\n</div><label class=\"text-grey\"><span translate=\"KPI.LABEL.SALESTYPE\"></span> *</label><div layout=\"row\" \nlayout-align=\"center center\" ng-repeat=\"ls in vm.Form.objForm.listTargetAbsolute\"><md-input-container flex><input \nname=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].name\" required readonly=\"readonly\">\n</md-input-container><md-input-container flex=\"10\"><input name=\"ec{{$index}}\" \nng-model=\"vm.Form.objForm.listTargetAbsolute[$index].ec\" placeholder=\"EC\" required type=\"number\"></md-input-container>\n<md-input-container flex=\"10\"><input name=\"roa{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].roa\" \nplaceholder=\"ROA\" required type=\"number\"></md-input-container></div><label class=\"text-grey\"><span \ntranslate=\"KPI.LABEL.PRINCIPAL\"></span> *</label><div layout=\"row\" layout-align=\"center center\" \nng-repeat=\"ls in vm.Form.objForm.listPrincipal\"><md-input-container flex><input name=\"name{{$index}}\" \nng-model=\"vm.Form.objForm.listPrincipal[$index].name\" required readonly=\"readonly\"></md-input-container>\n<md-input-container flex=\"5\"><input name=\"ec{{$index}}\" ng-model=\"vm.Form.objForm.listPrincipal[$index].ec\" \nplaceholder=\"EC\" required type=\"number\"></md-input-container><label style=\"margin-top: -10px\" flex=\"5\">%</label>\n<md-input-container flex=\"5\"><input name=\"roa{{$index}}\" ng-model=\"vm.Form.objForm.listPrincipal[$index].roa\" \nplaceholder=\"ROA\" required type=\"number\"></md-input-container><label style=\"margin-top: -10px\" flex=\"5\">%</label></div>\n<label class=\"text-grey\"><span translate=\"KPI.LABEL.SKUFOCUS\"></span> *</label><div layout=\"row\" \nlayout-align=\"left left\" ng-repeat=\"lsFocus in vm.Form.objForm.listFocus\"><md-input-container flex=\"20\"><input \nname=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listFocus[$index].name\" \nplaceholder=\"{{\'ATTENDANCE.LABEL.TYPE\' | translate}}\" required readonly=\"readonly\"></md-input-container>\n<md-input-container flex=\"5\"><input name=\"amountFocus{{$index}}\" \nng-model=\"vm.Form.objForm.listFocus[$index].amountFocus\" required type=\"number\"></md-input-container><label \nstyle=\"margin-top: 20px\" flex=\"5\">%</label></div><label class=\"text-grey\"><span translate=\"UMUT.MENU.NOTE\"></span>\n</label><div layout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 2px\"><textarea rows=\"2\" \nng-model=\"vm.Form.objForm.description\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"UMUT.MENU.NOTE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.start_year\" name=\"start_year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start_year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start_year.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.end_year\" name=\"end_year\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end_year\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><label class=\"text-grey\">\n<span translate=\"KPI.LABEL.SURKOM\"></span></label><div layout=\"row\"><md-input-container md-no-float class=\"md-block\">\n<input type=\"file\" id=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n            action:\'uploadData\',\n            id:vm.Form.objForm.id,\n            surkom_no:vm.Form.objForm.surkom_no,\n            description:vm.Form.objForm.description,\n            surkom_date:vm.Form.objForm.surkom_date,\n            empno:vm.Form.objForm.nik.empno,\n            empnik:vm.Form.objForm.empnik,\n            status:vm.Form.objForm.status,\n            listTargetAbsolute:vm.Form.objForm.listTargetAbsolute,\n            listPrincipal:vm.Form.objForm.listPrincipal,\n            listFocus:vm.Form.objForm.listFocus,\n            start_year:vm.Form.objForm.start_year,\n            start:vm.Form.objForm.start,\n            end_year:vm.Form.objForm.end_year,\n            end:vm.Form.objForm.end\n          }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button ng-if=\"vm.edit&&(!vm.fileSizeError)\" type=\"button\" class=\"md-raised md-accent\" \nng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" \ntranslate=\"ACTION.SUBMIT\">ganteng</md-button><md-button ng-if=\"vm.edit&&vm.fileSizeError\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-target-absolute/insentif-target-absolute-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.TARGETABSOLUTE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nrequired><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.Form.objForm.surkom_date\" required></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.Form.objForm.status\" name=\"status\" ng-required=\"true\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option></md-select></md-input-container>\n</div><fieldset style=\"margin-bottom: 30px\"><legend><span translate=\"KPI.LABEL.SALESTYPE\"></span> *</legend><div \nlayout=\"row\" layout-align=\"center center\" ng-repeat=\"ls in vm.Form.objForm.listTargetAbsolute\"><md-input-container \nflex><input name=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].name\" required \nreadonly=\"readonly\"></md-input-container><md-input-container flex=\"10\"><input name=\"ec{{$index}}\" \nng-model=\"vm.Form.objForm.listTargetAbsolute[$index].ec\" placeholder=\"EC\" required type=\"number\"></md-input-container>\n<md-input-container flex=\"10\"><input name=\"roa{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].roa\" \nplaceholder=\"ROA\" required type=\"number\"></md-input-container></div></fieldset><fieldset style=\"margin-bottom: 30px\">\n<legend><span translate=\"KPI.LABEL.OTHERPRINCIPAL\"></span> *</legend><div layout=\"row\" layout-align=\"center center\" \nng-repeat=\"ls in vm.Form.objForm.listPrincipal\"><md-input-container flex><input name=\"name{{$index}}\" \nng-model=\"vm.Form.objForm.listPrincipal[$index].name\" required readonly=\"readonly\"></md-input-container>\n<md-input-container flex=\"5\"><input name=\"ec{{$index}}\" ng-model=\"vm.Form.objForm.listPrincipal[$index].ec\" \nplaceholder=\"EC\" required type=\"number\"></md-input-container><label style=\"margin-top: -10px\" flex=\"10\"><span \ntranslate=\"KPI.LABEL.PERCENTKSNI\"></span></label><md-input-container flex=\"5\"><input name=\"roa{{$index}}\" \nng-model=\"vm.Form.objForm.listPrincipal[$index].roa\" placeholder=\"ROA\" required type=\"number\"></md-input-container>\n<label style=\"margin-top: -10px\" flex=\"10\"><span translate=\"KPI.LABEL.PERCENTKSNI\"></span></label></div></fieldset>\n<fieldset style=\"margin-bottom: 30px\"><legend><span translate=\"KPI.LABEL.SKUFOCUS\"></span> *</legend><div layout=\"row\" \nlayout-align=\"left left\" ng-repeat=\"lsFocus in vm.Form.objForm.listFocus\" flex><md-input-container flex=\"20\"><input \nname=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listFocus[$index].name\" \nplaceholder=\"{{\'ATTENDANCE.LABEL.TYPE\' | translate}}\" required readonly=\"readonly\"></md-input-container>\n<md-input-container flex=\"5\"><input name=\"amountFocus{{$index}}\" \nng-model=\"vm.Form.objForm.listFocus[$index].amountFocus\" required type=\"number\"></md-input-container><label \nstyle=\"margin-top: 20px\" flex=\"5\">%</label></div></fieldset><label class=\"text-grey\"><span translate=\"UMUT.MENU.NOTE\">\n</span></label><div layout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 2px\"><textarea rows=\"2\" \nng-model=\"vm.Form.objForm.description\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"UMUT.MENU.NOTE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.start_year\" name=\"start_year\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start_year\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start_year.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select ng-model=\"vm.Form.objForm.start\" name=\"start\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"start\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">\n{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.start.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select ng-model=\"vm.Form.objForm.end_year\" name=\"end_year\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"end_year\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDYEAR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.end\" name=\"end\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><label class=\"text-grey\">\n<span translate=\"KPI.LABEL.UPLOADSURKOM\"></span></label><div layout=\"row\"><md-input-container md-no-float \nclass=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n              action:\'uploadData\',\n              surkom_no:vm.Form.objForm.surkom_no,\n              description:vm.Form.objForm.description,\n              surkom_date:vm.Form.objForm.surkom_date,\n              empno:vm.Form.objForm.nik.empno,\n              status:vm.Form.objForm.status,\n              listTargetAbsolute:vm.Form.objForm.listTargetAbsolute,\n              listPrincipal:vm.Form.objForm.listPrincipal,\n              listFocus:vm.Form.objForm.listFocus,\n              start_year:vm.Form.objForm.start_year,\n              start:vm.Form.objForm.start,\n              end_year:vm.Form.objForm.end_year,\n              end:vm.Form.objForm.end\n            }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.upload(frmBT)\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.fileSizeError\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insentif-target-absolute/insentif-target-absolute.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.TARGETABSOLUTE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inli`-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"MENU.MAIN.SURKOMNO\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.id\" md-search-text=\"vm.searchStringSurkom\" \nmd-items=\"item in vm.getDataCode(vm.searchStringSurkom)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.id\" \nmd-selected-item-change=\"vm.selectedItemChangedNo(vm.Form.objForm.id)\"><md-item-template><span \nmd-highlight-text=\"vm.searchStringSurkom\">{{item.name}}</span></md-item-template></md-autocomplete>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-model=\"vm.surkom_date\"></md-datepicker><div \nng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MENU.MAIN.SURKOMDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.status\" name=\"status\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStatus\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"MENU.MAIN.SURKOMCREATOR\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete></md-input-container>\n<md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.SURKOMCREATOR\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.STATUS\"></span></span></th><th class=\"text-center\" width=\"10%\"><span class=\"column-title\">\n<span>FILE</span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span>\n</th></tr></thead><tbody><tr ng-class=\"{\'md-table-content-row blink\' : item.respondCount>0}\" \nng-dblclick=\"vm.viewDetail($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.surkom_no}}</td><td \nclass=\"text-center\">{{item.surkom_date | date : \'dd MMMM yyyy\'}}</td><td class=\"\">\n{{item.surkom_created_by}} / {{item.surkom_creator}}</td><td class=\"text-center\">{{item.status}}</td><td \nclass=\"text-center\"><md-button ng-if=\"item.filename&&item.format==\'img\'\" class=\"md-mini md-primary\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewFile($event, item.filename)\"><div layout=\"row\" flex><md-tooltip>\n<span translate=\"MENU.MAIN.VIEWFILE\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\">\n</md-icon><p flex><span translate=\"MENU.MAIN.VIEWFILE\"></span></p></div></md-button><md-button \nng-if=\"item.filename&&item.format==\'file\'\" class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.downloadDoc($event, item.filename)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-download\">\n</md-icon><p flex><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></p></div></md-button></td><td class=\"text-center\">\n<section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-mini md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.viewDetail($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"UMUT.MENU.DETAIL\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"UMUT.MENU.DETAIL\"></span></p></div></md-button><md-button class=\"md-mini md-primary\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"KPI.LABEL.EDIT\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-pencil\"></md-icon><p \nflex><span translate=\"KPI.LABEL.EDIT\"></span></p></div></md-button><md-button class=\"md-mini md-primary\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.copyData($event, item)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"MENU.MAIN.COPY\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-content-copy\">\n</md-icon><p flex><span translate=\"MENU.MAIN.COPY\"></span></p></div></md-button></md-menu-item></md-menu-content>\n</md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-target-absolute/view-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.TARGETABSOLUTE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMNO\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.surkom_no\" name=\"surkom_no\" \nreadonly=\"readonly\" required><div ng-messages=\"frmBT.surkom_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMNO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.SURKOMDATE\"></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"surkom_date\" ng-disabled=\"true\" ng-model=\"vm.Form.objForm.surkom_date\" required>\n</md-datepicker><div ng-messages=\"frmBT.surkom_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.SURKOMDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.SURKOMCREATOR\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.nik\" name=\"nik\" \nreadonly=\"readonly\" required><div ng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NIK\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container>\n<md-input-container flex><label translate=\"KPI.LABEL.STATUS\"></label><md-select ng-model=\"vm.Form.objForm.status\" \nng-disabled=\"true\" name=\"status\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listStatus\">\n{{ls.name}}</md-option></md-select></md-input-container></div><label class=\"text-grey\"><span \ntranslate=\"KPI.LABEL.SALESTYPE\"></span> *</label><div layout=\"row\" layout-align=\"center center\" \nng-repeat=\"ls in vm.Form.objForm.listTargetAbsolute\"><md-input-container flex><input name=\"name{{$index}}\" \nng-model=\"vm.Form.objForm.listTargetAbsolute[$index].name\" required readonly=\"readonly\"></md-input-container>\n<md-input-container flex=\"10\"><input name=\"ec{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].ec\" \nplaceholder=\"EC\" readonly=\"readonly\" required type=\"number\"></md-input-container><md-input-container flex=\"10\"><input \nname=\"roa{{$index}}\" ng-model=\"vm.Form.objForm.listTargetAbsolute[$index].roa\" placeholder=\"ROA\" readonly=\"readonly\" \nrequired type=\"number\"></md-input-container></div><label class=\"text-grey\"><span translate=\"KPI.LABEL.PRINCIPAL\">\n</span> *</label><div layout=\"row\" layout-align=\"center center\" ng-repeat=\"ls in vm.Form.objForm.listPrincipal\">\n<md-input-container flex><input name=\"name{{$index}}\" ng-model=\"vm.Form.objForm.listPrincipal[$index].name\" required \nreadonly=\"readonly\"></md-input-container><md-input-container flex=\"5\"><input name=\"ec{{$index}}\" \nng-model=\"vm.Form.objForm.listPrincipal[$index].ec\" placeholder=\"EC\" readonly=\"readonly\" required type=\"number\">\n</md-input-container><label style=\"margin-top: -10px\" flex=\"5\">%</label><md-input-container flex=\"5\"><input \nname=\"roa{{$index}}\" ng-model=\"vm.Form.objForm.listPrincipal[$index].roa\" placeholder=\"ROA\" readonly=\"readonly\" \nrequired type=\"number\"></md-input-container><label style=\"margin-top: -10px\" flex=\"5\">%</label></div><label \nclass=\"text-grey\"><span translate=\"KPI.LABEL.FOCUS\"></span> *</label><div layout=\"row\" layout-align=\"left left\" \nng-repeat=\"lsFocus in vm.Form.objForm.listFocus\"><md-input-container flex=\"20\"><input name=\"name{{$index}}\" \nng-model=\"vm.Form.objForm.listFocus[$index].name\" placeholder=\"{{\'ATTENDANCE.LABEL.TYPE\' | translate}}\" required \nreadonly=\"readonly\"></md-input-container><md-input-container flex=\"5\"><input name=\"amountFocus{{$index}}\" \nng-model=\"vm.Form.objForm.listFocus[$index].amountFocus\" readonly=\"readonly\" required type=\"number\">\n</md-input-container><label style=\"margin-top: 20px\" flex=\"5\">%</label></div><label class=\"text-grey\"><span \ntranslate=\"UMUT.MENU.NOTE\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm><div \nstyle=\"padding: 2px\"><textarea readonly=\"readonly\" rows=\"2\" ng-model=\"vm.Form.objForm.description\"></textarea></div>\n<div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"UMUT.MENU.NOTE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTYEAR\"></span></label><md-select \nng-disabled=\"true\" ng-model=\"vm.Form.objForm.start_year\" name=\"start_year\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"start_year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.start_year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTYEAR\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.STARTMONTH\"></span></label><md-select \nng-model=\"vm.Form.objForm.start\" name=\"start\" ng-disabled=\"true\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" ng-disabled=\"true\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"start\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listStart | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div\n ng-messages=\"frmBT.start.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTMONTH\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDYEAR\"></span></label><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.end_year\" name=\"end_year\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"end_year\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listYear | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end_year.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDYEAR\"></span>\n <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.ENDMONTH\"></span></label><md-select \nng-model=\"vm.Form.objForm.end\" name=\"end\" ng-disabled=\"true\" md-on-close=\"vm.clearSearchTerm()\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"end\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listEnd | filter:vm.searchTerm\">{{ls.name | uppercase}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.end.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDMONTH\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/insentif-target-absolute/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.VIEWFILE\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" \nclass=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content>\n<md-dialog-content ng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><img \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/upload/target-absolute/{{vm.doc}}\">\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/insentif-transfer/insentiftransfer.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Insentif Transfer</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExporttoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Division</label><md-select ng-model=\"vm.division\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub division...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download</md-button>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insentif-upload-master-cb/insentif-upload-master-cb.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.MASTERCB\"></span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"></form></div></div>\n</md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Upload</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"></md-content>\n</div></div></md-content></div>");
$templateCache.put("app/main/insentif-upload-master-cb/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.upload()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insurance/insurance-employe.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Inrurance Employee</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><span flex hide \nshow-gt-sm></span><md-input-container flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"frmInsurance.start_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.end_date\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \nng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>\n<span>Search</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th>Patient Name\n</th><th>Relation</th><th>Claim Status</th><th>Register Date</th><th>Location</th><th>Claim Proposed</th><th>\nClaim Accepted</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td>{{ls.name}}</td><td>\n{{ls.relation}}</td><td>{{ls.status_klaim}}</td><td>{{ls.register_date}}</td><td>{{ls.location}}</td><td>\n{{ls.tot_claim_proposed | currency:\"Rp. \":0}}</td><td>{{ls.tot_accepted_claim | currency:\"Rp. \":0}}</td><td><md-button \ntype=\"button\" layout=\"row\" ng-click=\"vm.showDetail(ls, $event)\" class=\"md-raised md-primary\" aria-label=\"search\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-file-document-box\" aria-label=\"icon-file-document-box\"></md-icon>\nDetail</md-button></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/insurance-progress.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati5\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nClaim Progres</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div class=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select\n name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.back()\"><md-tooltip md-direction=\"up\" \nmd-visible=\"tooltipVisible\">Back To Claim List</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-keyboard-backspace material-icons\"></md-icon>Back</md-button></div></md-toolbars><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th>NIK</th><th>Name</th><th>Patient Name\n</th><th>Relation</th><th>Claim Status</th><th>Register Date</th><th>Location</th><th>Claim Proposed</th><th>\nClaim Accepted</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td>{{ls.nik}}</td><td>\n{{ls.empName}}</td><td>{{ls.name}}</td><td>{{ls.relation}}</td><td>{{ls.status_klaim}}</td><td>{{ls.register_date}}\n</td><td>{{ls.location}}</td><td>{{ls.tot_claim_proposed | currency:\"Rp. \":0}}</td><td>\n{{ls.tot_accepted_claim | currency:\"Rp. \":0}}</td><td><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.showDetail(ls, $event)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-file-document-box\" aria-label=\"icon-file-document-box\"></md-icon>Detail</md-button></td></tr>\n</tbody></table></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/insurance/insurance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Claim Progres</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmInsurance\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmInsurance.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmInsurance.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\" \nrequired><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmInsurance.department.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Department field is required.</span></div></div></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\" \nclass=\"mt-30\"><md-input-container flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"frmInsurance.start_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label>End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" \nng-model=\"vm.end_date\"></md-datepicker><div ng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.status_klaim\" name=\"status_klaim\" required><md-option ng-repeat=\"ls in vm.listStatus\" \nplaceholder=\"Claim Status\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-input-container flex>\n<input type=\"text\" placeholder=\"NIK / Nama\" ng-model=\"vm.nik\" id=\"formSearch\"></md-input-container><md-button \ntype=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div>\n</form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container\n hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"inputTable\"><thead><tr><th>NIK</th><th>Name</th><th>Patient Name</th><th>Relation</th><th>\nClaim Status</th><th>Register Date</th><th>Location</th><th>Claim Proposed</th><th>Claim Accepted</th><th>Action</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td>{{ls.nik}}</td><td>{{ls.empName}}</td><td>{{ls.name}}\n</td><td>{{ls.relation}}</td><td>{{ls.status_klaim}}</td><td>{{ls.register_date}}</td><td>{{ls.location}}</td><td>\n{{ls.tot_claim_proposed | currency:\"Rp. \":0}}</td><td>{{ls.tot_accepted_claim | currency:\"Rp. \":0}}</td><td><md-button \ntype=\"button\" layout=\"row\" ng-click=\"vm.showDetail(ls, $event)\" class=\"md-raised md-primary\" aria-label=\"search\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-file-document-box\" aria-label=\"icon-file-document-box\"></md-icon>\nDetail</md-button></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/listDetail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>List Detail Claim</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><div\n layout-sm=\"column\" layout=\"row\" layout-align=\"center center\" layout-padding><div flex=\"35\"><div class=\"md-subhead\">\n<strong>Employe Name</strong></div><div class=\"info\">{{vm.data.empName}}</div></div><div flex=\"15\"><div \nclass=\"md-subhead\"><strong>NIK</strong></div><div class=\"info\">{{vm.data.nik}}</div></div><div flex=\"25\"><div \nclass=\"md-subhead\"><strong>Klaimrun</strong></div><div class=\"info\">{{vm.data.klaimrun}}</div></div><div flex=\"25\"><div\n class=\"md-subhead\"><strong>Register Claimno</strong></div><div class=\"info\">{{vm.data.register_claimno}}</div></div>\n</div><md-divider></md-divider><div layout-sm=\"column\" layout=\"row\" layout-align=\"center center\" layout-padding><div \nflex=\"20\"><div class=\"md-subhead\"><strong>Register Number</strong></div><div class=\"info\">{{vm.data.reg_no}}</div>\n</div><div flex=\"35\"><div class=\"md-subhead\"><strong>Patient Name</strong></div><div class=\"info\">{{vm.data.name}}\n</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>Relation</strong></div><div class=\"info\">\n{{vm.data.relation}}</div></div><div flex=\"25\"><div class=\"md-subhead\"><strong>Location</strong></div><div \nclass=\"info\">{{vm.data.location}}</div></div></div><md-divider></md-divider><div layout-sm=\"column\" layout=\"row\" \nlayout-align=\"start center\" layout-padding><div flex=\"20\"><div class=\"md-subhead\"><strong>Register Date</strong></div>\n<div class=\"info\">{{vm.data.register_date}}</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>Payment Date\n</strong></div><div class=\"info\">{{vm.data.tgl_bayar}}</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>\nReceipt Date</strong></div><div class=\"info\">{{vm.data.check_out}}</div></div><div flex=\"20\"><div class=\"md-subhead\">\n<strong>Date Of Illness</strong></div><div class=\"info\">{{vm.data.date_of_loss_or_check_in}}</div></div></div>\n<md-divider></md-divider><div layout-sm=\"column\" layout=\"row\" layout-align=\"start center\" layout-padding><div flex><div\n class=\"md-subhead\"><strong>Diagnosis Description</strong></div><div class=\"info\">{{vm.data.diagnosis_desc}}</div>\n</div></div><md-divider></md-divider><div layout-sm=\"column\" layout=\"row\" layout-align=\"start center\" layout-padding>\n<div flex><div class=\"md-subhead\"><strong>Claim Note</strong></div><div class=\"info\">{{vm.data.claim_note}}</div></div>\n</div><md-divider></md-divider><div layout=\"column\"><table class=\"simple bordered\" ms-responsive-table><thead><tr><th \nclass=\"secondary-text\" flex=\"40\"><div class=\"table-header\"><span class=\"column-title\">Benefit Name</span></div></th><th\n class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">Claim Proposed</span></div></th>\n<th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">Claim Accepted</span></div>\n</th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">Not Approved Claim\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"lsd in vm.data.detail_claim\"><td>{{lsd.benefit_name}}</td><td>\n{{lsd.claim_proposed | currency:\"Rp. \":0}}</td><td>{{lsd.claim_accepted | currency:\"Rp. \":0}}</td><td>\n{{lsd.amt_not_approved | currency:\"Rp. \":0}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insurance/listDetailEmploye.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>List Detail Claim</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-gt-sm=\"row\" layout-padding><div\n flex=\"20\"><div class=\"md-subhead\"><strong>Register Number</strong></div><div class=\"info\">{{vm.data.reg_no}}</div>\n</div><div flex=\"35\"><div class=\"md-subhead\"><strong>Patient Name</strong></div><div class=\"info\">{{vm.data.name}}\n</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>Relation</strong></div><div class=\"info\">\n{{vm.data.relation}}</div></div><div flex=\"25\"><div class=\"md-subhead\"><strong>Location</strong></div><div \nclass=\"info\">{{vm.data.location}}</div></div></div><md-divider></md-divider><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-padding><div flex=\"20\"><div class=\"md-subhead\"><strong>Register Date</strong></div><div class=\"info\">\n{{vm.data.register_date}}</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>Payment Date</strong></div><div \nclass=\"info\">{{vm.data.tgl_bayar}}</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>Receipt Date</strong>\n</div><div class=\"info\">{{vm.data.check_out}}</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>Date Of Illness\n</strong></div><div class=\"info\">{{vm.data.date_of_loss_or_check_in}}</div></div></div><md-divider></md-divider><div \nlayout-sm=\"column\" layout=\"row\" layout-align=\"start center\" layout-padding><div flex><div class=\"md-subhead\"><strong>\nDiagnosis Description</strong></div><div class=\"info\">{{vm.data.diagnosis_desc}}</div></div></div><md-divider>\n</md-divider><div layout-sm=\"column\" layout=\"row\" layout-align=\"start center\" layout-padding><div flex><div \nclass=\"md-subhead\"><strong>Claim Note</strong></div><div class=\"info\">{{vm.data.claim_note}}</div></div></div>\n<md-divider></md-divider><div layout=\"column\"><table class=\"simple bordered\" ms-responsive-table><thead><tr><th \nclass=\"secondary-text\" flex=\"40\"><div class=\"table-header\"><span class=\"column-title\">Benefit Name</span></div></th><th\n class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">Claim Proposed</span></div></th>\n<th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">Claim Accepted</span></div>\n</th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">Not Approved Claim\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"lsd in vm.data.detail_claim\"><td>{{lsd.benefit_name}}</td><td>\n{{lsd.claim_proposed | currency:\"Rp. \":0}}</td><td>{{lsd.claim_accepted | currency:\"Rp. \":0}}</td><td>\n{{lsd.amt_not_approved | currency:\"Rp. \":0}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/lock-setting/lock-setting-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.LOCKSETTING\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.LOCKDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"lock_date\" \nng-model=\"vm.Form.objForm.lock_date\" required></md-datepicker><div ng-messages=\"frmBT.lock_date.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"MENU.MAIN.LOCKDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"MENU.MAIN.LOCKTIME\">\n</label><input type=\"text\" name=\"lock_time\" ng-model=\"vm.Form.objForm.lock_time\" ng-max=\"24\" mask=\"99:99:99\" \nmask-placeholder=\"hh:ii:ss\" autocomplete=\"off\" required><div ng-messages=\"frmBT.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MENU.MAIN.LOCKTIME\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.PERIOD\"></label><input\n type=\"text\" ng-model=\"vm.Form.objForm.period\" readonly=\"readonly\" name=\"period\" required><div \nng-messages=\"frmBT.period.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.PERIOD\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/lock-setting/lock-setting.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.LOCKSETTING\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex></div></md-content><md-toolbar></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span>\n</th><th class=\"text-center\"><span class=\"column-title\"><span translate=\"MENU.MAIN.LOCKDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"MENU.MAIN.LOCKTIME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.TYPE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.PERIOD\"></span></span></th><th width=\"5%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\"><md-tooltip>\n<span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.lock_date | date:\"dd MMMM y\"}}</td><td class=\"text-center\">\n<md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.lock_time}}</td><td class=\"text-center\">\n<md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.type}}</td><td class=\"text-center\">\n<md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.period}}</td><td class=\"text-center\">\n<section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/job-evaluation/approval-job-evaluation.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Job Evaluation</md-subheader><div class=\"white-bg\"><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Business Unit</label><md-select \nng-disabled=\"vm.group === \'110\' || vm.group === \'116\'\" ng-change=\"vm.loadDataDivision(vm.bu)\" ng-model=\"vm.bu\">\n<md-option ng-value=\"\">All</md-option><md-option ng-repeat=\"bu in vm.listBu\" ng-value=\"bu.id\">{{bu.description}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Business Title</label>\n<md-select ng-change=\"vm.loadDataDepartment(vm.divisi)\" ng-model=\"vm.divisi\"><md-option ng-value=\"\">All</md-option>\n<md-option ng-repeat=\"divisi in vm.listDivisi\" ng-value=\"{{divisi.id}}\">{{divisi.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Evaluation Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex><input id=\"formSearch\" name=\"searchParam\" \nng-model=\"vm.DataTable.searchParam\" placeholder=\"Search..\" type=\"text\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveList($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Approve</span></md-button><md-button \nclass=\"md-mini md-raised\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.rejectList($event)\"><md-tooltip\n md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span>Reject</span></md-button><span\n flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th width=\"5%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TABLE.NO\">SATU</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title\" translate=\"TABLE.COMPANY_ID\">DUA</span></div></th><th>\n<div class=\"table-header\"><span class=\"column-title\" translate=\"TABLE.JOBCODE_CODE\">TIGA</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TABLE.JOBCODE_DESCRIPTION\">EMPAT</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TABLE.EVALUATED_BY\">#</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TABLE.EVALUATED_DATE\">#</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TABLE.TOTAL_POINT\">#</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TABLE.POSITION_CLASS\">#</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TABLE.JV_GRADE\">#</span></div></th></tr></thead><tbody><tr \nng-dblclick=\"vm.viewDetail(ls.id)\" ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ $index + 1 }}</td><td \nclass=\"text-center\">{{ ls.business_unit }}</td><td class=\"text-center\">{{ ls.code }}</td><td>{{ ls.description }}</td>\n<td>{{ ls.evaluated_by }}</td><td>{{ ls.evaluation_date }}</td><td class=\"text-right\">{{ ls.total_point }}</td><td \nclass=\"text-right\">{{ ls.position_class }}</td><td class=\"text-center\">{{ ls.grade }}</td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li class=\"{{nav.class}}\" \nng-class=\"{disabled:(nav.disabled===1)}\" ng-repeat=\"nav in vm.DataTable.listNav\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></div></md-content>\n</div>");
$templateCache.put("app/main/job-evaluation/list-job-evaluation.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Job Evaluation</md-subheader><div class=\"white-bg\"><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Business Unit</label><md-select \nng-change=\"vm.loadDataDivision(vm.bu)\" ng-model=\"vm.bu\"><md-option ng-value=\"\">All</md-option><md-option \nng-repeat=\"bu in vm.listBu\" ng-value=\"bu.id\" ng-model=\"vm.bu\">{{bu.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Evaluation Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.dateEval\" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex><input id=\"formSearch\" name=\"searchParam\" \nng-model=\"vm.DataTable.searchParam\" placeholder=\"Search..\" type=\"text\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.ExportToExcel()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Export to Excel</md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"md-font icon-archive material-icons\"></md-icon><span>Export to Excel</span>\n</md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th width=\"5%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TABLE.NO\">SATU</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TABLE.COMPANY_ID\">DUA</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TABLE.JOBCODE_CODE\">TIGA</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TABLE.JOBCODE_DESCRIPTION\">EMPAT</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TABLE.EVALUATED_BY\">#</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TABLE.EVALUATED_DATE\">#</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TABLE.TOTAL_POINT\">#</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TABLE.POSITION_CLASS\">#</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TABLE.JV_GRADE\">#</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TABLE.STATUS\">#</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-dblclick=\"vm.viewDetail(ls.id)\" \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ $index + 1 }}</td><td class=\"text-center\">{{ ls.business_unit }}\n</td><td class=\"text-center\">{{ ls.code }}</td><td>{{ ls.description }}</td><td>{{ ls.evaluated_by }}</td><td>\n{{ ls.evaluation_date }}</td><td class=\"text-right\">{{ ls.total_point }}</td><td class=\"text-right\">\n{{ ls.position_class }}</td><td class=\"text-center\">{{ ls.grade }}</td><td><span ng-if=\"ls.approval_status==1\">\nWaiting Approval</span> <span ng-if=\"ls.approval_status==2\">Approved</span> <span ng-if=\"ls.approval_status==4\">\nRejected</span></td><td class=\"text-center\"><md-menu><md-button class=\"md-icon-button action-selector\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button>\n<md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item><md-button ng-click=\"vm.viewDetail(ls.id)\" \naria-label=\"Flip widget\"><span>View Detail</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval_status==1\"><md-button ng-click=\"vm.edit(ls.id)\" aria-label=\"Flip widget\"><span>Edit</span>\n</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li class=\"{{nav.class}}\" ng-class=\"{disabled:(nav.disabled===1)}\" \nng-repeat=\"nav in vm.DataTable.listNav\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav>\n</div></md-content></div></div></div></md-content></div>");
$templateCache.put("app/main/lock-transaction/lock-transaction.html","<div id=\"header-action\" class=\"page-layout simple fullwidth with-toolbar-content\" layout=\"column\"><div \nclass=\"header nabati2\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cog\"></md-icon></span><span \nclass=\"logo-text\"><span>Lock Transaction</span></span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\"></div></div></div></div><div layout=\"column\" layout-fill class=\"content padding\"><div \nclass=\"md-whiteframe-2dp\"><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"Inert\" ui-sref=\"app.lock_transaction_input_lock_transaction\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon>Create New</md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.lock_transaction_input_lock_transaction\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>Create New\n</md-button><span flex></span></div></md-toolbar><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><th width=\"1%\" style=\"text-align: center\">No.</th><th width=\"30%\" class=\"text-center\">Time Lock</th><th \nwidth=\"20%\" class=\"text-center\">Lock By</th><th style=\"text-align: center\">Transaction date lock</th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td style=\"text-align: center\">{{($index + 1)}}</td><td \nstyle=\"text-align: center\">{{ls.effective_date}} {{ls.effective_time}}</td><td style=\"text-align: center\">\n{{ls.lock_by}}-{{ls.nama}}</td><td style=\"text-align: center\">{{ls.date_lock}}</td><td style=\"text-align: center\"></td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/login/emplogin.html","<div layout=\"column\" layout-wrap flex><form name=\"loginForm\" novalidate ng-submit=\"vm.login()\"><md-input-container \nclass=\"md-block\"><label>Username</label><input type=\"text\" name=\"nik\" ng-model=\"vm.user.username\" \nplaceholder=\"Username\" required><div ng-messages=\"loginForm.username.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>username field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>Password</label><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" \nplaceholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Password field is required</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-warn submit-button\" aria-label=\"LOG IN\">LOG IN</md-button></form></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" block-ui=\"loginForm\" layout=\"row\" layout-align=\"start\"><div flex hide show-gt-sm class=\"wrapper-intro\" \nlayout=\"row\" layout-align=\"start start\"><div id=\"login-intro\" flex layout-align=\"start start\" layout=\"column\"><div \nclass=\"title\">Welcome to KFC HR Link</div></div></div><div id=\"login-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div class=\"logo\"><img \nsrc=\"assets/images/logos/kfc.png\" alt=\"\"></div><div class=\"title\"><span class=\"font-satisfy\" style=\"color:#C31230\">\nHR Link</span> <small class=\"text-super font-size-14 green-800-fg state-area\" \nng-if=\"vm.LoginService.stateLogin!=\'main\'\"><em>{{vm.LoginService.stateLogin}}</em></small></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"area-app animate-slide-right\" ui-view=\"loginArea\"></div><div class=\"separator\">\n</div></div></div></div>");
$templateCache.put("app/main/login/mainlogin.html","<md-button flex=\"33\" class=\"action-button md-raised\" ui-sref=\"app.login.emplogin\"><div layout=\"column\"><md-icon \nmd-font-icon=\"icon-account\" class=\"s80 employee green-400-fg\"></md-icon><div class=\"md-subhead employee\">Employee</div>\n</div></md-button><md-button flex=\"33\" class=\"action-button md-raised\" ui-sref=\"app.login.candidatelogin\"><div \nlayout=\"column\"><md-icon md-font-icon=\"icon-account-check\" class=\"s80 candidate amber-700-fg\"></md-icon><div \nclass=\"md-subhead candidate\">E-Check In</div></div></md-button>");
$templateCache.put("app/main/login/set-password.html","<div id=\"\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"\" layout=\"column\" layout-align=\"center center\">\n<div id=\"\" class=\"\"><div class=\"title\">Set Password</div><b>{{vm.username}}</b><form name=\"loginForm\" novalidate \nng-submit=\"vm.saveDataPass($event,loginForm)\"><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.Form.objForm.password\" placeholder=\"Password\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"confirm_password\" ng-model=\"vm.Form.objForm.confirm_password\" \nplaceholder=\"Confirm Password\" required compare-to=\"vm.Form.objForm.password\"><div \nng-messages=\"loginForm.confirm_password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nConfirm Password field is required</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\">\nLOG IN</md-button></form></div></div></div>");
$templateCache.put("app/main/mpp/mpp.html","<div id=\"mppToolbarArea\" hide show-gt-sm><div class=\"mpp-main-subheader\"><div class=\"md-whiteframe-3dp\" \nlayout=\"column\"><div flex layout layout=\"row\" layout-align=\"start center\" ng-style=\"{\'height\' : \'35px\'}\"><div \nflex=\"20\" layout=\"row\" class=\"md-primary\" layout-align=\"start center\"><md-button class=\"md-primary md-mini\">\nMan Power Planning | <strong style=\"text-transform:capitalize; color: #0b709b\">MyPlan</strong></md-button></div><div \nflex layout=\"row\" layout-align=\"start center\"><span style=\"font-size:0.9rem; padding-left:2px; padding-right:2px\">\n<strong>PERIODE : </strong>{{vm.year}} </span><span style=\"font-size:0.9rem; padding-left:2px; padding-right:2px\">\n<strong>LAYER : </strong>{{vm.teamLayer.description}} </span><span \nstyle=\"font-size:0.9rem; padding-left:2px; padding-right:2px\"><strong>LEVEL : </strong>{{vm.layer}}</span></div><div \nflex layout=\"row\" layout-align=\"end center\"><div><md-button aria-label=\"filter menu\" class=\"md-primary md-mini\">\nCURRENT STATUS : <b ng-style=\"{\'color\' : (vm.approvalStatus === \'draft\') ? \'orange\' : \'green\'}\">{{vm.approvalStatus}}\n</b><md-tooltip md-direction=\"bottom\">Action</md-tooltip></md-button></div><div><md-menu \nmd-position-mode=\"target bottom\"><md-button aria-label=\"filter menu\" ng-disabled=\"vm.disableFilter\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon style=\"font-size:1.5rem\" md-menu-origin \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip md-direction=\"bottom\">Filter</md-tooltip></md-button><md-menu-content \nwidth=\"3\" layout=\"column\" layout-align=\"center start\"><md-menu-item class=\"pl-10\"><md-checkbox md-menu-align-target \nng-model=\"vm.filterMonth\" ng-change=\"vm.setFilter(1)\">Month</md-checkbox></md-menu-item><md-menu-item \nng-if=\"vm.showCostFilter\" class=\"pl-10\"><md-checkbox md-menu-align-target ng-model=\"vm.filterCost\" \nng-change=\"vm.setFilter(2)\">Cost</md-checkbox></md-menu-item><md-menu-item class=\"pl-10\" ng-if=\"vm.showCostFilter\">\n<md-checkbox md-menu-align-target ng-model=\"vm.filterPayment\" ng-change=\"vm.setFilter(3)\">Total (Summary)</md-checkbox>\n</md-menu-item><md-menu-item class=\"pl-10\" ng-if=\"vm.showCostFilter\"><md-checkbox md-menu-align-target \nng-model=\"vm.filterTotalPerMonth\" ng-change=\"vm.setFilter(4)\">Total (PerMonth)</md-checkbox></md-menu-item>\n<md-menu-item class=\"pl-10\"><md-checkbox md-menu-align-target ng-model=\"vm.filterActual\" ng-change=\"vm.setFilter(5)\">\nActual</md-checkbox></md-menu-item><md-menu-item class=\"pl-10\"><md-checkbox md-menu-align-target \nng-model=\"vm.filterCurrent\" ng-change=\"vm.setFilter(5)\">Current</md-checkbox></md-menu-item><md-menu-item \nclass=\"pl-10\"><md-checkbox md-menu-align-target ng-model=\"vm.filterFuture\" ng-change=\"vm.setFilter(6)\">Future\n</md-checkbox></md-menu-item><md-menu-item class=\"pl-10\"><md-checkbox md-menu-align-target ng-model=\"vm.filterStatus\" \nng-change=\"vm.setFilter(7)\">Status</md-checkbox></md-menu-item><md-menu-item class=\"pl-10\"><md-checkbox \nmd-menu-align-target ng-model=\"vm.filterAction\" ng-change=\"vm.setFilter(8)\">Action</md-checkbox></md-menu-item>\n</md-menu-content></md-menu></div><div ng-if=\"vm.showCostFilter\"><md-button ng-click=\"null\" class=\"md-icon-button\">\n<md-icon style=\"font-size:1.5rem\" md-font-icon=\"icon-flattr\"></md-icon><md-tooltip md-direction=\"bottom\">\nSwitch to money</md-tooltip></md-button></div><div><md-button ng-click=\"vm.showLegend()\" class=\"md-icon-button\">\n<md-icon style=\"font-size:1.5rem\" md-font-icon=\"icon-white-balance-incandescent\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Legend</md-tooltip></md-button></div><md-menu-bar class=\"padding-0\"><md-menu><md-button \naria-label=\"filter menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon style=\"font-size:1.5rem\" \nmd-font-icon=\"icon-cog\"></md-icon><md-tooltip md-direction=\"bottom\">Settings</md-tooltip></md-button><md-menu-content>\n<md-menu-item><md-menu><md-button ng-click=\"$mdMenu.open()\">Years <b \nstyle=\"padding-left:5px; text-transform: uppercase; font-size: 1rem\">{{vm.year}}</b></md-button><md-menu-content>\n<md-menu-item ng-repeat=\"year in vm.listYear\"><md-button ng-class=\"{\'md-primary\' : vm.year === year}\" \nng-click=\"vm.year = year\" md-prevent-menu-close=\"md-prevent-menu-close\">{{year}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-item><md-menu><md-button ng-click=\"$mdMenu.open()\">My MPP Team <b \nstyle=\"padding-left:5px; text-transform: uppercase; font-size: 1rem\">{{vm.teamLayer.description}}</b></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"teamLayer in vm.listTeamLayer\"><md-button \nng-class=\"{\'md-primary\' : vm.teamLayer.id === teamLayer.id}\" ng-click=\"vm.teamLayer = teamLayer\" \nmd-prevent-menu-close=\"md-prevent-menu-close\">{{teamLayer.description}}</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-item><md-menu-item><md-menu><md-button ng-click=\"$mdMenu.open()\">No of Layer <b \nstyle=\"padding-left:5px; text-transform: uppercase; font-size: 1rem\">{{vm.layer}}</b></md-button><md-menu-content>\n<md-menu-item ng-repeat=\"layer in vm.listLayer\"><md-button ng-class=\"{\'md-primary\' : vm.layer === layer}\" \nng-click=\"vm.layer = layer\">{{layer}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div><md-button ng-click=\"vm.gotoCompareChart()\" class=\"md-icon-button\">\n<md-icon style=\"font-size:1.5rem\" md-font-icon=\"icon-compare\"></md-icon><md-tooltip md-direction=\"bottom\">\nCompare Structure</md-tooltip></md-button></div><div><md-button ng-click=\"vm.gotoStructure()\" class=\"md-icon-button\">\n<md-icon style=\"font-size:1.5rem\" md-font-icon=\"icon-account-network\"></md-icon><md-tooltip md-direction=\"bottom\">\nLoad Structure</md-tooltip></md-button></div><div><md-button ng-click=\"vm.gotoTable()\" class=\"md-icon-button\"><md-icon \nstyle=\"font-size:1.5rem\" md-font-icon=\"icon-table-large\"></md-icon><md-tooltip md-direction=\"bottom\">Load Table\n</md-tooltip></md-button></div><div><md-menu md-position-mode=\"target bottom\"><md-button aria-label=\"filter menu\" \nclass=\"md-primary md-mini\" ng-click=\"$mdMenu.open($event)\">Action<md-tooltip md-direction=\"bottom\">Action</md-tooltip>\n</md-button><md-menu-content width=\"2\" layout=\"column\" layout-align=\"center start\"><md-menu-item><md-button \nclass=\"md-primary md-mini md-block\" ng-disabled=\"vm.isCanSubmitMpp\" ng-click=\"vm.showSubmit($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-content-save\"></md-icon><span>Submit</span></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-primary md-warn md-mini md-block\" ng-click=\"vm.showReset($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-backup-restore\"></md-icon><span>Reset</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div></div></div><div ui-view=\"mppView\" id=\"mppViewer\" hide show-gt-sm>\n</div><div layout=\"column\" layout layout-fill layout-align=\"center center\" layout-align-xs=\"center center\" hide-gt-sm>\n<div><span style=\"font-size:50px\">&#9785;</span></div><div>Sorry, this feature is not supported on mobile</div></div>");
$templateCache.put("app/main/mpp-report-cost/mpp-report-cost.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">Cost Report\n</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\" layout=\"column\" ng-hide=\"!vm.showFilter\">\n<div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmCost\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Years</label><md-select ng-model=\"vm.year\" aria-label=\"years\" name=\"years\"><md-option \nng-repeat=\"ls in vm.years\" placeholder=\"YEARS\" ng-value=\"ls\">{{ ls }}</md-option></md-select><div \nng-messages=\"frmCost.years.$error\" role=\"alert\"><div ng-message=\"required\"><span>Years field is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Company</label><md-select ng-model=\"vm.company\" \naria-label=\"company\" name=\"company\" ng-change=\"vm.getDataCostCenter()\"><md-option ng-repeat=\"ls in vm.companies\" \nplaceholder=\"COMPANY\" ng-value=\"ls\">{{ ls.description }}</md-option></md-select><div \nng-messages=\"frmCost.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Cost Center</label><md-select \nng-model=\"vm.costCenter\" required ng-disabled=\"vm.listCostCenter.length === 0\" aria-label=\"costCenter\" \nng-change=\"vm.getDataLayers()\" name=\"costCenter\"><md-option ng-repeat=\"ls in vm.listCostCenter\" \nplaceholder=\"COST CENTER\" ng-value=\"ls\">{{ ls.description }}</md-option></md-select><div \nng-messages=\"frmCost.costCenter.$error\" role=\"alert\"><div ng-message=\"required\"><span>Cost Center field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Layers</label><md-select ng-model=\"vm.layer\" \nrequired data-md-container-class=\"selectHeader\" md-on-close=\"vm.clearSearch()\" ng-disabled=\"vm.layers.length === 0\" \naria-label=\"layer\" name=\"layer\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for layer\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=\"select Layers\">\n<md-option ng-repeat=\"ls in vm.layers | filter:vm.searchTerm\" placeholder=\"Layers\" ng-selected=\"vm.layer.id === ls.id\" \nng-value=\"ls\">{{ ls.description }}</md-option></md-optgroup></md-select><div ng-messages=\"frmCost.layer.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Layer field is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Employee Type</label><md-select ng-model=\"vm.selectedEmpType\" required \naria-label=\"employee type\" name=\"empType\"><md-option ng-repeat=\"ls in vm.empType\" placeholder=\"Employee Type\" \nng-value=\"ls.value\">{{ ls.name }}</md-option></md-select><div ng-messages=\"frmCost.empType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee Type field is required.</span></div></div></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.getDataReport()\" \nng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-button ng-disabled=\"vm.listReport.length == 0\" \nclass=\"md-primary md-icon-button md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printPDF()\">\n<md-icon style=\"font-size:14px\" md-font-icon=\"icon-printer\"></md-icon></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-primary md-icon-button md-small\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printExcel()\"><md-icon style=\"font-size:14px\" \nmd-font-icon=\"icon-file-excel-box\"></md-icon></md-button><md-button ng-disabled=\"vm.listReport.length == 0\" \nclass=\"md-primary md-icon-button md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.showDetail()\">\n<md-icon style=\"font-size:14px\" md-font-icon=\"icon-eye\"></md-icon></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><span flex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-button md-ink-ripple md-mini\" type=\"button\" \naria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon md-font-icon=\"icon-print\"></md-icon><span>PRINT</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content id=\"costReport\" layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\" ms-scroll><table ng-repeat=\"item in vm.listReport\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><tr><th class=\"title-header-top\">\n{{ item.description }} Cost Element</th><td class=\"month-title\">Jan</td><td class=\"month-title\">Feb</td><td \nclass=\"month-title\">Mar</td><td class=\"month-title\">Apr</td><td class=\"month-title\">May</td><td class=\"month-title\">Jun\n</td><td class=\"month-title\">Jul</td><td class=\"month-title\">Aug</td><td class=\"month-title\">Sep</td><td \nclass=\"month-title\">Oct</td><td class=\"month-title\">Nov</td><td class=\"month-title\">Dec</td><td class=\"month-title\">\nTotal</td></tr><tr><th class=\"title-header\">Beban Gaji Dan Upah</th><td class=\"text-right\" \nng-repeat=\"val in item.cost.list\">{{ val.gajiPokok | roundedMoney }}</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">{{ item.cost.gaji_pokok | roundedMoney }}</td></tr><tr><th class=\"title-header\">\nBeban Upah Harian</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">0</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">0</td></tr><tr><th class=\"title-header\">Tunjangan Karyawan</th><td class=\"text-right\" \nng-repeat=\"val in item.cost.list\">{{ val.tunjangan | roundedMoney }}</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">{{ item.cost.tunjangan | roundedMoney }}</td></tr><tr><th class=\"title-header\">\nTunjangan Hari Raya</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.thr | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.thr | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\">Bonus</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.bonus | roundedMoney }}\n</td><td class=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.bonus | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\">Lembur</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.lembur | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.lembur | roundedMoney }}</td></tr><tr><th class=\"title-header\">Pesangon Karyawan</th><td \nclass=\"text-right\" ng-repeat=\"val in item.cost.list\">0</td><td class=\"title-header-right\" style=\"font-weight: bold\">0\n</td></tr><tr><th class=\"title-header\">Tunjangan Lainnya</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.tunjanganLain | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.tunjangan_lain | roundedMoney }}</td></tr><tr><th class=\"title-header\">Beban Pengobatan</th><td \nclass=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.bpjsKesehatan | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.bpjs_kesehatan | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\">Beban Jamsostek</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.jamsostek | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.jamsostek | roundedMoney }}</td></tr><tr><th class=\"title-header\">Tunjangan kendaraan</th><td \nclass=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.tunjanganCop | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.tunjangan_cop | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\">Pajak</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.pajak | roundedMoney }}\n</td><td class=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.pajak | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\">Total</th><td class=\"text-right\" style=\"font-weight: bold\" ng-repeat=\"val in item.cost.list\">\n{{ val.totalCost | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.totalCost | roundedMoney }}</td></tr></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpp-report-cost-budget/mpp-report-cost-budget.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">Cost Report\n</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\" layout=\"column\" ng-hide=\"!vm.showFilter\">\n<div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmCost\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Years</label><md-select ng-model=\"vm.year\" aria-label=\"years\" name=\"years\"><md-option \nng-repeat=\"ls in vm.years\" placeholder=\"YEARS\" ng-value=\"ls\">{{ ls }}</md-option></md-select><div \nng-messages=\"frmCost.years.$error\" role=\"alert\"><div ng-message=\"required\"><span>Years field is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Company</label><md-select ng-model=\"vm.company\" \naria-label=\"company\" name=\"company\" ng-change=\"vm.getDataCostCenter()\"><md-option ng-repeat=\"ls in vm.companies\" \nplaceholder=\"COMPANY\" ng-value=\"ls\">{{ ls.description }}</md-option></md-select><div \nng-messages=\"frmCost.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Cost Center</label><md-select \nng-model=\"vm.costCenter\" required ng-disabled=\"vm.listCostCenter.length === 0\" aria-label=\"costCenter\" \nng-change=\"vm.getDataLayers()\" name=\"costCenter\"><md-option ng-repeat=\"ls in vm.listCostCenter\" \nplaceholder=\"COST CENTER\" ng-value=\"ls\">{{ ls.description }}</md-option></md-select><div \nng-messages=\"frmCost.costCenter.$error\" role=\"alert\"><div ng-message=\"required\"><span>Cost Center field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Layers</label><md-select ng-model=\"vm.layer\" \nrequired data-md-container-class=\"selectHeader\" md-on-close=\"vm.clearSearch()\" ng-disabled=\"vm.layers.length === 0\" \naria-label=\"layer\" name=\"layer\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for layer\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=\"select Layers\">\n<md-option ng-repeat=\"ls in vm.layers | filter:vm.searchTerm\" placeholder=\"Layers\" ng-selected=\"vm.layer.id === ls.id\" \nng-value=\"ls\">{{ ls.description }}</md-option></md-optgroup></md-select><div ng-messages=\"frmCost.layer.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Layer field is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Employee Type</label><md-select ng-model=\"vm.selectedEmpType\" required \naria-label=\"employee type\" name=\"empType\"><md-option ng-repeat=\"ls in vm.empType\" placeholder=\"Employee Type\" \nng-value=\"ls.value\">{{ ls.name }}</md-option></md-select><div ng-messages=\"frmCost.empType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee Type field is required.</span></div></div></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.getDataReport()\" \nng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-button ng-disabled=\"vm.listReport.length == 0\" \nclass=\"md-primary md-icon-button md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printPDF()\">\n<md-icon style=\"font-size:14px\" md-font-icon=\"icon-printer\"></md-icon></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-primary md-icon-button md-small\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printExcel()\"><md-icon style=\"font-size:14px\" \nmd-font-icon=\"icon-file-excel-box\"></md-icon></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><span \nflex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-disabled=\"vm.listReport.length == 0\" class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" \nng-click=\"vm.printPDF()\"><md-icon md-font-icon=\"icon-print\"></md-icon><span>PRINT</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content id=\"costReport\" layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\" ms-scroll><table ng-repeat=\"item in vm.listReport\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><tr><th class=\"title-header-top\">\n{{ item.description }} Cost Element</th><td class=\"month-title\">Jan</td><td class=\"month-title\">Feb</td><td \nclass=\"month-title\">Mar</td><td class=\"month-title\">Apr</td><td class=\"month-title\">May</td><td class=\"month-title\">Jun\n</td><td class=\"month-title\">Jul</td><td class=\"month-title\">Aug</td><td class=\"month-title\">Sep</td><td \nclass=\"month-title\">Oct</td><td class=\"month-title\">Nov</td><td class=\"month-title\">Dec</td><td class=\"month-title\">\nTotal</td></tr><tr><th class=\"title-header\">Beban Gaji Dan Upah</th><td class=\"text-right\" \nng-repeat=\"val in item.cost.list\">{{ val.gajiPokok | roundedMoney }}</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">{{ item.cost.gaji_pokok | roundedMoney }}</td></tr><tr><th class=\"title-header\">\nBeban Upah Harian</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">0</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">0</td></tr><tr><th class=\"title-header\">Tunjangan Karyawan</th><td class=\"text-right\" \nng-repeat=\"val in item.cost.list\">{{ val.tunjangan | roundedMoney }}</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">{{ item.cost.tunjangan | roundedMoney }}</td></tr><tr><th class=\"title-header\">\nTunjangan Hari Raya</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.thr | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.thr | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\">Bonus</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.bonus | roundedMoney }}\n</td><td class=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.bonus | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\">Lembur</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.lembur | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.lembur | roundedMoney }}</td></tr><tr><th class=\"title-header\">Pesangon Karyawan</th><td \nclass=\"text-right\" ng-repeat=\"val in item.cost.list\">0</td><td class=\"title-header-right\" style=\"font-weight: bold\">0\n</td></tr><tr><th class=\"title-header\">Tunjangan Lainnya</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.tunjanganLain | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.tunjangan_lain | roundedMoney }}</td></tr><tr><th class=\"title-header\">Beban Pengobatan</th><td \nclass=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.bpjsKesehatan | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.bpjs_kesehatan | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\">Beban Jamsostek</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.jamsostek | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.jamsostek | roundedMoney }}</td></tr><tr><th class=\"title-header\">Tunjangan kendaraan</th><td \nclass=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.tunjanganCop | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.tunjangan_cop | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\">Pajak</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.pajak | roundedMoney }}\n</td><td class=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.pajak | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\">Total</th><td class=\"text-right\" style=\"font-weight: bold\" ng-repeat=\"val in item.cost.list\">\n{{ val.totalCost | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.totalCost | roundedMoney }}</td></tr></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpp-report-hc/mpp-report-hc.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nHeadcount Report</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Years</label><md-select ng-model=\"vm.year\" aria-label=\"years\" name=\"years\"><md-option \nng-repeat=\"ls in vm.years\" placeholder=\"YEARS\" ng-value=\"ls\">{{ls}}</md-option></md-select><div \nng-messages=\"frmCost.years.$error\" role=\"alert\"><div ng-message=\"required\"><span>Years field is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Company</label><md-select ng-model=\"vm.company\" \naria-label=\"company\" name=\"company\" ng-change=\"vm.getDataLayers()\"><md-option ng-repeat=\"ls in vm.companies\" \nplaceholder=\"COMPANY\" ng-value=\"ls\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmCost.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Layers</label><md-select ng-model=\"vm.layer\" required \ndata-md-container-class=\"selectHeader\" md-on-close=\"vm.clearSearch()\" ng-disabled=\"vm.layers.length === 0\" \naria-label=\"layer\" name=\"layer\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for layer\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=\"select Layers\">\n<md-option ng-repeat=\"ls in vm.layers | filter:vm.searchTerm\" placeholder=\"Layers\" ng-selected=\"vm.layer.id === ls.id\" \nng-value=\"ls\">{{ ls.description }}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex>\n<label>Employee Type</label><md-select ng-model=\"vm.selectedEmpType\" required aria-label=\"employee type\" \nname=\"empType\"><md-option ng-repeat=\"ls in vm.empType\" placeholder=\"Employee Type\" ng-value=\"ls.value\">{{ ls.name }}\n</md-option></md-select><div ng-messages=\"frmCost.empType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee Type field is required.</span></div></div></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.getDataReport()\" \nng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-button ng-disabled=\"vm.listReport.length == 0\" \nclass=\"md-primary md-icon-button md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printPDF()\">\n<md-icon style=\"font-size:14px\" md-font-icon=\"icon-printer\"></md-icon></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-primary md-icon-button md-small\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printExcel()\"><md-icon style=\"font-size:14px\" \nmd-font-icon=\"icon-file-excel-box\"></md-icon></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><span \nflex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon \nmd-font-icon=\"icon-print\"></md-icon><span>PRINT</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><div id=\"tableMpp\">\n<table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th rowspan=\"2\">\nNo</th><th rowspan=\"2\">BT Code</th><th rowspan=\"2\">Level</th><th style=\"width: 20%\" rowspan=\"2\">Jabatan</th><th \nstyle=\"width: 5%\" rowspan=\"2\">Jumlah Karyawan Saat Ini</th><th style=\"width: 5%\" rowspan=\"2\">\nJumlah Karyawan yang akan datang</th><th colspan=\"2\">Karyawan</th><th colspan=\"2\">Karyawan</th><th colspan=\"12\">\nJadwal Pemenuhan</th><th rowspan=\"2\">Total</th></tr><tr><th style=\"width: 5%\">Internal</th><th style=\"width: 5%\">\nExternal</th><th style=\"width: 5%\">Mutasi</th><th style=\"width: 5%\">Terminasi</th><th>Jan</th><th>Feb</th><th>Mar</th>\n<th>Apr</th><th>Mei</th><th>Jun</th><th>Jul</th><th>Aug</th><th>Sep</th><th>Oct</th><th>Nov</th><th>Des</th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.listReport\"><td>{{$index + 1}}</td><td>{{ item.bt_code }}</td><td>\n{{ item.job_level }}</td><td>{{item.description}}</td><td>{{ item.curr.total }}</td><td>{{ item.next.total }}</td><td>\n{{ item.next.internal }}</td><td>{{ item.next.external }}</td><td>{{ item.next.mutation }}</td><td>\n{{ item.next.termination }}</td><td ng-repeat=\"i in item.next.listPerMonth track by $index\">{{ i }}</td><td>\n{{ item.totalRightPerRow }}</td></tr><tr ng-if=\"vm.listReport.length > 0\"><td class=\"total-hc\" colspan=\"4\">TOTAL</td>\n<td>{{ vm.totalCurrEmp }}</td><td>{{ vm.totalNextEmp }}</td><td>{{ vm.totalNextEmpInternal }}</td><td>\n{{ vm.totalNextEmpExternal }}</td><td>{{ vm.totalNextEmpMutation }}</td><td>{{ vm.totalNextEmpTermination }}</td><td \nng-repeat=\"j in vm.totalPerMonth track by $index\">{{ j }}</td><td>{{ vm.totalRightBottom }}</td></tr></tbody></table>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mppmgr/mppmgr.html","<div id=\"mppToolbarArea\" hide show-gt-sm><div class=\"mpp-main-subheader\"><div class=\"md-whiteframe-3dp\" \nlayout=\"column\"><div flex layout layout=\"row\" layout-align=\"start center\" ng-style=\"{\'height\' : \'35px\'}\"><div \nflex=\"15\" layout=\"row\" class=\"md-primary\" layout-align=\"start center\"><md-button class=\"md-primary md-mini\">MPP\n</md-button></div><div flex layout=\"row\" layout-align=\"end center\"><div layout=\"row\" class=\"search-layer-container\">\n<div class=\"parent-org-layer-title\">Parent Layer</div><md-autocomplete md-selected-item=\"vm.teamLayer\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-search-text=\"vm.searchTerm\" \nmd-items=\"item in vm.querySearchLayer(vm.searchTerm)\" md-item-text=\"item.description\" \nplaceholder=\"Ex. Head of Human Capital\" required md-delay=\"500\" md-autocomplete-snap=\"240\" md-min-length=\"3\">\n<md-item-template><span md-highlight-text=\"vm.searchTerm\">{{item.description}}</span></md-item-template><md-not-found>\nNo Layer matching \"{{vm.searchTerm}}\" were found.</md-not-found></md-autocomplete></div><div \nclass=\"select-layer-container\"><label for=\"numLayer\">Org. Depth Layer:</label><select id=\"numLayer\" \nng-model=\"vm.layer\"><option ng-repeat=\"item in vm.listLayer\" ng-value=\"item\">{{item}}</option></select></div><div \nclass=\"select-layer-container\"><label for=\"numYear\">Year:</label><select id=\"numYear\" ng-model=\"vm.year\"><option \nng-repeat=\"item in vm.listYear\" ng-value=\"item\">{{item}}</option></select></div><div class=\"divider-vertical\"></div>\n<div><md-button ng-click=\"vm.loaTableMpp()\" class=\"md-primary md-mini\">Load Table<md-tooltip md-direction=\"bottom\">Load\n</md-tooltip></md-button></div></div></div></div></div></div><div class=\"page-layout\" mpp-chart-viewport \nid=\"orgchart-area\" hide show-gt-sm><div layout=\"column\" style=\"padding:0; margin: 0\" class=\"content-card\"><div \nui-view=\"mppMgrView\" id=\"mppViewer\"></div></div></div><div layout=\"column\" layout layout-align=\"center center\" \nlayout-align-xs=\"center center\" hide-gt-sm><div layout=\"row\">Sorry, this feature is not supported on mobile</div></div>");
$templateCache.put("app/main/mympp/mympp.html","<div id=\"mppToolbarArea\" hide show-gt-sm><div class=\"mpp-main-subheader\"><div class=\"md-whiteframe-3dp\" \nlayout=\"column\"><div flex layout layout=\"row\" layout-align=\"start center\" ng-style=\"{\'height\' : \'35px\'}\"><div \nflex=\"15\" layout=\"row\" class=\"md-primary\" layout-align=\"start center\"><md-button class=\"md-primary md-mini\">MPP\n</md-button></div><div flex layout=\"row\" layout-align=\"end center\"><div layout=\"row\" class=\"search-layer-container\">\n<div class=\"parent-org-layer-title\">Parent Layer</div><md-autocomplete md-selected-item=\"vm.teamLayer\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-search-text=\"vm.searchTerm\" \nmd-items=\"item in vm.querySearchLayer(vm.searchTerm)\" md-item-text=\"item.description\" \nplaceholder=\"Ex. Head of Human Capital\" required md-delay=\"500\" md-autocomplete-snap=\"240\" md-min-length=\"3\">\n<md-item-template><span md-highlight-text=\"vm.searchTerm\">{{item.description}}</span></md-item-template><md-not-found>\nNo Layer matching \"{{vm.searchTerm}}\" were found.</md-not-found></md-autocomplete></div><div \nclass=\"select-layer-container\"><label for=\"numLayer\">Org. Depth Layer:</label><select id=\"numLayer\" \nng-model=\"vm.layer\"><option ng-repeat=\"item in vm.listLayer\" ng-value=\"item\">{{item}}</option></select></div><div \nclass=\"select-layer-container\"><label for=\"numYear\">Year:</label><select id=\"numYear\" ng-model=\"vm.year\"><option \nng-repeat=\"item in vm.listYear\" ng-value=\"item\">{{item}}</option></select></div><div class=\"divider-vertical\"></div>\n<div><md-button ng-click=\"vm.loadLayer()\" class=\"md-primary md-mini\">Load Table<md-tooltip md-direction=\"bottom\">Load\n</md-tooltip></md-button></div></div></div></div></div></div><div class=\"page-layout\" mpp-chart-viewport \nid=\"orgchart-area\" hide show-gt-sm><div layout=\"column\" style=\"padding:0; margin: 0\" class=\"content-card\"><div \nid=\"mppViewer\"><div class=\"page-layout\" id=\"mpp-org-table\"><div class=\"mpp-toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"vm.listData.length === 0\" ng-click=\"vm.onClickDownload()\" \nclass=\"md-primary md-raised md-mini\" aria-label=\"org mpp\">Download</md-button><input \nng-disabled=\"vm.listData.length === 0\" class=\"search-input\" type=\"text\" ng-model=\"vm.searchListData\" \nplaceholder=\"ex: head of ..\"></div><div class=\"flex-table-container\" ms-scroll><div flex layout=\"row\" \nclass=\"table-content table-header\"><div class=\"table-item head-item first-item multi-height\">Layer Name</div><div \nclass=\"table-item-container\" layout=\"column\"><div class=\"table-item-title\">{{vm.prevYear}}</div><div \nclass=\"table-item-content\" layout=\"row\"><div class=\"table-item head-item text-center headcount-item\">HC</div></div>\n</div><div class=\"table-item-container\"><div class=\"table-item-title\">{{vm.year}}</div><div class=\"table-item-content\" \nlayout=\"row\"><div class=\"table-item head-item text-center headcount-item\">HC</div><div \nclass=\"table-item head-item month-item\" ng-repeat=\"item in vm.months\">{{item.name}}</div></div></div></div><div flex \nlayout=\"row\" class=\"table-content\" ng-repeat=\"item in vm.listData | filter:{ description: vm.searchListData }\"><div \nclass=\"table-item first-item small-font-size left-background no-icon\">{{item.description}}</div><div \nclass=\"table-item text-center small-font-size headcount-item no-icon\">{{item.total_mpp_detail_prev}}</div><div \nclass=\"table-item text-center small-font-size headcount-item no-icon\">{{item.total_mpp_detail}}</div><div \nclass=\"table-item text-center small-font-size no-icon month-item\" ng-repeat=\"m in vm.months\">{{item.stats_mpp[m.id]}}\n</div></div></div></div></div></div></div>");
$templateCache.put("app/main/nabati-policy/detail-policy.html","<md-dialog aria-label=\"Form Update Finger Data\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"80\"><form \nng-cloak class=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Detail</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-content ng-if=\"vm.doc_type\" class=\"md-background-bg has-upload\" id=\"contentDialog\"><iframe \nsrc=\"{{vm.url}}\" style=\"width:100%; height:100vh\" frameborder=\"0\"></iframe></md-content><md-dialog-content \nng-if=\"vm.images\"><img style=\"display: block;margin-left: auto;margin-right: auto;width: 100%; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/policydocument/{{vm.doc}}\"></md-dialog-content><video ng-show=\"vm.video_type\" \nwidth=\"100%\" controls autoplay><source src=\"{{vm.url}}\" type=\"video/mp4\"></video></form></md-dialog>");
$templateCache.put("app/main/nabati-policy/policy-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Upload Data</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div \nlayout=\"row\"><md-input-container flex><label>Policy Name</label><input type=\"text\" ng-model=\"vm.Form.objForm.name\" \nname=\"name\" required><div ng-messages=\"frmBT.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nName field is required.</span></div></div></md-input-container><md-input-container flex><label>Country</label>\n<md-select ng-model=\"vm.Form.objForm.country\" name=\"country\" ng-change=\"vm.getBu(vm.Form.objForm.country)\" required>\n<md-option ng-repeat=\"ls in vm.listCountry\" placeholder=\"country\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.country.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCountry field is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select multiple=\"\" ng-model=\"vm.Form.objForm.bu\" name=\"bu\" ng-change=\"vm.getDivision(vm.Form.objForm.bu)\" required>\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.bu.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><label>Division</label>\n<md-select multiple=\"\" ng-model=\"vm.Form.objForm.divisi\" name=\"divisi\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"Division\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Sub Area</label><md-select multiple=\"\" \nng-model=\"vm.Form.objForm.subarea\" name=\"subarea\" required><md-option ng-repeat=\"ls in vm.subAreaList\" \nplaceholder=\"Sub Area\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Grade</label><md-select multiple=\"\" \nng-model=\"vm.Form.objForm.grade\" name=\"grade\" ng-change=\"vm.changeSelectedGrade(vm.Form.objForm.grade,vm.gradeList)\" \nrequired><md-option ng-repeat=\"ls in vm.gradeList\" placeholder=\"Grade\" value=\"{{ls.value}}\">{{ls.name}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.grade.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nGrade field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-content layout=\"column\" \nclass=\"_md layout-column md-nabati1-theme\"><md-input-container class=\"md-nabati1-theme\"><input \nng-model=\"vm.Form.objForm.file\" accept=\"application/pdf\" type=\"file\" nv-file-select=\"\" uploader=\"vm.uploader\" \noptions=\"{ formData: [{  \n                                  country:vm.Form.objForm.country,\n                                  bu:vm.Form.objForm.bu,\n                                  name:vm.Form.objForm.name,\n                                  subarea:vm.Form.objForm.subarea,\n                                  grade:vm.Form.objForm.grade,\n                                  divisi:vm.Form.objForm.divisi\n                                }]}\">\n<div class=\"md-errors-spacer\"></div></md-input-container><md-progress-linear md-mode=\"determinate\" value=\"0\" \nclass=\"md-accent hue-2 md-nabati1-theme\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" aria-valuenow=\"0\">\n<div class=\"md-container md-mode-determinate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\" style=\"transform: translateX(-50%) scale(0, 1)\"></div></div></md-progress-linear></md-content>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Upload</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/nabati-policy/policy.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Policy List</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select ng-if=\"vm.isAdmin\" style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span ng-if=\"vm.isAdmin\" hide \nshow-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;Entries</span><div ng-if=\"vm.isAdmin\" \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button ng-if=\"vm.isAdmin\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span>Upload</span></md-button><div \nng-if=\"vm.isAdmin\" class=\"divider-vertical\" hide show-gt-sm></div><md-button ng-if=\"vm.isAdmin\" \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span style=\"color:red\" \nng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" upload=\"vm.addDataNews(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>Upload\n</md-button></md-menu-item><md-menu-item><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">\nUn-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content \nstyle=\"background:white\" hide-gt-sm><span flex=\"5\"></span><md-list class=\"md-dense\" flex><md-list-item \nclass=\"md-3-line\" ng-repeat=\"item in vm.DataTables.list\" ng-click=\"null\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4>TEST</h4><md-checkbox class=\"md-secondary\" aria-label=\"CutOffChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></div><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypmenu\" class=\"md-icon-button\" \nstyle=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex>edit</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu><md-divider style=\"border-width:0.5px; border-color:whitesmoke; border-style: solid\">\n</md-divider></md-list-item></md-list><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th ng-if=\"vm.isAdmin\" width=\"2%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th><th class=\"text-center\" width=\"5%\"><span class=\"column-title\">No</span>\n</th><th ng-if=\"vm.isAdmin\" class=\"text-center\" width=\"20%\"><span class=\"column-title\">Country</span></th><th \nng-if=\"vm.isAdmin\" class=\"text-center\"><span class=\"column-title\">Company</span></th><th ng-if=\"vm.isAdmin\" \nclass=\"text-center\"><span class=\"column-title\">Division</span></th><th ng-if=\"vm.isAdmin\" class=\"text-center\"><span \nclass=\"column-title\">Sub Area</span></th><th ng-if=\"vm.isAdmin\" class=\"text-center\"><span class=\"column-title\">Grade\n</span></th><th class=\"text-center\"><span class=\"column-title\">Policy Name</span></th><th width=\"5%\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td ng-if=\"vm.isAdmin\"><md-checkbox \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{$index+1}}</td><td ng-if=\"vm.isAdmin\" class=\"text-center\">\n{{item.country_name}}</td><td ng-if=\"vm.isAdmin\" class=\"text-center\">{{item.company}}</td><td ng-if=\"vm.isAdmin\" \nclass=\"text-center\">{{item.division==null ? \'All\' : item.division}}</td><td ng-if=\"vm.isAdmin\" class=\"text-center\">\n{{item.subarea==null ? \'All\' : item.subarea}}</td><td ng-if=\"vm.isAdmin\" class=\"text-center\">\n{{item.grade==null ? \'All\' : item.grade}}</td><td class=\"text-center\">{{item.name}}</td><td class=\"text-center\">\n<section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.viewDetail($event, item)\"><div layout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-eye\">\n</md-icon><p flex>Detail</p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div ng-if=\"vm.isAdmin\" \nclass=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/nabati-policy-user/policy-user.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Policy List</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select ng-if=\"vm.isAdmin\" style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span ng-if=\"vm.isAdmin\" hide \nshow-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;Entries</span><div ng-if=\"vm.isAdmin\" \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button ng-if=\"vm.isAdmin\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span>Upload</span></md-button><div \nng-if=\"vm.isAdmin\" class=\"divider-vertical\" hide show-gt-sm></div><md-button ng-if=\"vm.isAdmin\" \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span style=\"color:red\" \nng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" upload=\"vm.addDataNews(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>Upload\n</md-button></md-menu-item><md-menu-item><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">\nUn-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content \nstyle=\"background:white\" hide-gt-sm><span flex=\"5\"></span><md-list class=\"md-dense\" flex><md-list-item \nclass=\"md-3-line\" ng-repeat=\"item in vm.DataTables.list\" ng-click=\"null\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4>TEST</h4><md-checkbox class=\"md-secondary\" aria-label=\"CutOffChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></div><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypmenu\" class=\"md-icon-button\" \nstyle=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex>edit</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu><md-divider style=\"border-width:0.5px; border-color:whitesmoke; border-style: solid\">\n</md-divider></md-list-item></md-list><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"text-center\" width=\"5%\"><span class=\"column-title\">No</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Policy Name</span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\">{{$index+1}}</td><td class=\"text-center\">{{item.name}}\n</td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewDetail($event, item)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex>Detail</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div ng-if=\"vm.isAdmin\" \nclass=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/orgchart/add-mpp.html","<md-dialog aria-label=\"Setup Mpp\" md-theme=\"modal-theme\" ms-scroll flex=\"85\" id=\"dialog-create-mpp\"><form ng-cloak \nname=\"frmRequest\" class=\"md-inline-form\" novalidate ng-submit=\"\"><md-toolbar><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"md-toolbar-tools title\"><div class=\"h4\">Setup MPP</div><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear ng-show=\"vm.loadingProgress\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-dialog-content layout-fill style=\"margin-top:0px\"><div \nclass=\"form-overlay-wrapper-mpp animate-fade-in-out\" ng-show=\"vm.loadingProgress\"><div flex layout=\"column\" \nlayout-fill layout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div layout=\"column\" flex \nlayout-padding><div layout=\"row\" flex layout-align=\"start center\"><div \nflex=\"{{ (vm.isTBD || vm.isTBDNull) ? 45 : 75 }}\" layout=\"row\" layout-align=\"start center\"><md-input-container flex>\n<md-autocomplete md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.querySearchEmployee(vm.searchText)\" \nmd-item-text=\"item.name\" md-delay=\"500\" placeholder=\"Search for employee\" md-min-length=\"3\"><md-item-template><span \nmd-highlight-text=\"vm.searchText.employee\" md-highlight-flags=\"^i\">{{item.nik}} | {{item.name}}</span>\n</md-item-template><md-not-found>No employee matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete>\n</md-input-container></div><div flex ng-style=\"{\'margin-left\' : \'10px\' }\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex=\"{{(vm.isTBD || vm.isTBDNull)   ? \'nogrow\' : \'\'}}\" \nlayout-align=\"start center\"><md-checkbox ng-hide=\"vm.isTBDNull\" ng-model=\"vm.isTBD\" aria-label=\"TBD\"></md-checkbox>\n<span ng-hide=\"vm.isTBDNull\" ng-if=\"!vm.isTBD\">TBD ?</span></div><div layout=\"row\" \nflex=\"{{ (vm.isTBD || vm.isTBDNull) ? \'nogrow\' : \'\'}}\" layout-align=\"start center\"><md-checkbox ng-hide=\"vm.isTBD\" \nng-model=\"vm.isTBDNull\" aria-label=\"TBDNull\"></md-checkbox><span ng-hide=\"vm.isTBD\" ng-if=\"!vm.isTBDNull\">IN PLANNING ?\n</span></div><div flex ng-if=\"vm.isTBD || vm.isTBDNull\" layout=\"row\" layout-align=\"space-between center\"><div>\n<md-input-container><label>Qty</label><input style=\"width:60%\" placeholder=\"Qty\" type=\"number\" \nng-model=\"vm.tbdQuantity\"></md-input-container></div><div><md-button class=\"md-primary md-mini md-icon-button\" \nstyle=\"margin-left:5px\" ng-disabled=\"vm.tbdQuantity === 0\" ng-click=\"vm.addTbdToChart(vm.tbdQuantity)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div></div><div layout=\"column\" flex \nng-show=\"vm.Form.objForm.listEmp.length > 0\"><md-content ms-scroll><table class=\"simple\" ms-responsive-table><thead><th\n width=\"1%\">NO.</th><th class=\"text-start\" width=\"5%\">NIK</th><th class=\"text-start\" width=\"15%\">NAME</th><th \nclass=\"text-start\" width=\"25%\">POSITION</th><th class=\"text-start\" width=\"5%\">FULFILLMENT</th><th class=\"text-start\" \nwidth=\"5%\">EFFECTIVE</th><th class=\"text-start\" width=\"25%\">DIRECT REPORT</th><th width=\"5%\">IN<br>PLANNING</th><th \nwidth=\"2%\">TRANSACTION<br>TYPE</th><th width=\"2%\">IS<br>ACTIVE</th><th width=\"1%\">ACTION</th></thead><tbody><tr \nng-repeat=\"item in vm.Form.objForm.listEmp track by $index\" ng-class=\"{\'deleted-item-mpp-org\':item.isDeleted}\"><td>\n{{($index+1)}}</td><td>{{item.nik}}</td><td>{{item.name}}</td><td><md-input-container md-no-float \nclass=\"md-block invisible-error-port\"><input required placeholder=\"Position Name\" \nng-model=\"vm.Form.objForm.listEmp[$index].position_name\" type=\"text\"></md-input-container></td><td><md-datepicker \nrequired style=\"margin-top:0px; padding-top: 0px; padding-bottom: 0px\" md-hide-icons=\"all\" \nmd-placeholder=\"FulFill date\" md-open-on-focus ng-model=\"vm.Form.objForm.listEmp[$index].date_fulfill_formated\" \nmd-current-view=\"month\" name=\"dateFulfil{{vm.Form.objForm.listEmp[$index].nik}}\" class=\"date-fulfill-emp\">\n</md-datepicker></td><td><md-datepicker required style=\"margin-top:0px; padding-top: 0px; padding-bottom: 0px\" \nmd-hide-icons=\"all\" md-placeholder=\"effective data\" md-open-on-focus \nng-model=\"vm.Form.objForm.listEmp[$index].date_effective_formated\" md-current-view=\"month\" \nname=\"dateEffective{{vm.Form.objForm.listEmp[$index].nik}}\" class=\"date-fulfill-emp\"></md-datepicker></td><td>\n<md-select required ng-model=\"vm.Form.objForm.listEmp[$index].directReport\"><md-option><em>None</em></md-option>\n<md-option ng-repeat=\"dt in vm.listDirectReport\" ng-init=\"idxDirect=$index\" ng-value=\"dt.id\">{{dt.description}}\n</md-option></md-select></td><td><md-select required ng-model=\"vm.Form.objForm.listEmp[$index].is_planning\"><md-option \nvalue=\"1\">YES</md-option><md-option value=\"0\">NO</md-option></md-select></td><td><md-select required \nng-model=\"vm.Form.objForm.listEmp[$index].transactionType\"><md-option><em>None</em></md-option><md-option \nng-repeat=\"dt in vm.listTransactionType\" ng-value=\"dt.id\">{{dt.description}}</md-option></md-select></td><td><md-select\n required ng-model=\"vm.Form.objForm.listEmp[$index].is_active\"><md-option value=\"1\">YES</md-option><md-option \nvalue=\"0\">NO</md-option></md-select></td><td><md-button class=\"md-icon-button\" ng-click=\"vm.removeMpp($index)\" \nstyle=\"margin:0px\" ng-if=\"!item.isDeleted\"><md-icon \nng-style=\"{\'color\' : \'red\', \'font-size\' : \'20px\',\'padding\':\'0px\',\'margin\':\'0px\'}\" md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Delete</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.restoreMpp($index)\" style=\"margin:0px\" ng-if=\"item.isDeleted\"><md-icon \nng-style=\"{\'color\' : \'green\', \'font-size\' : \'20px\',\'padding\':\'0px\',\'margin\':\'0px\'}\" md-font-icon=\"icon-backup-restore\">\n</md-icon><md-tooltip md-direction=\"bottom\">cancel delete</md-tooltip></md-button></td></tr></tbody></table>\n</md-content></div><div class=\"messageError\" ng-show=\"vm.showErrorEmployee\">{{ vm.messagesErrorEmployee }}</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" flex><div flex class=\"form-message\" \nng-class=\"{success:vm.success,error:!vm.success}\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{vm.Form.pesan}}</div>\n<div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.saveData($event,  frmRequest)\" ng-disabled=\"frmRequest.$invalid || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon>Save</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/orgchart/edit-mpp-emp.html","<md-dialog aria-label=\"Create Layer Mpp\" md-theme=\"modal-theme\" ms-scroll flex=\"60\" id=\"dialog-create-mpp\"><form \nng-cloak name=\"formCreateLayerMpp\" class=\"md-inline-form\" novalidate ng-submit=\"\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h4>Add Member To Layer</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-warn\" ng-show=\"vm.updateProcess\"></md-progress-linear><md-dialog-content \nlayout-padding style=\"margin-top:0px; font-size: 12px\"><div layout=\"column\" flex><div layout=\"row\" flex \nlayout-align=\"start center\" style=\"padding-top:0px; padding-bottom: 0px\"><md-input-container flex \nstyle=\"margin-bottom:0px\"><label>Layer Type</label><input type=\"text\" disabled=\"disabled\" name=\"type\" \nng-model=\"vm.Form.objForm.type\"></md-input-container><md-input-container flex style=\"margin-bottom:0px\"><label>\nCost Center</label><input type=\"text\" disabled=\"disabled\" name=\"costCenter\" ng-model=\"vm.Form.objForm.cost_center_id\">\n</md-input-container><md-input-container flex style=\"margin-bottom:0px\"><label>Grade Level</label><input type=\"text\" \ndisabled=\"disabled\" name=\"jobLevel\" ng-model=\"vm.Form.objForm.job_level\"></md-input-container></div><div layout=\"row\" \nflex layout-align=\"start center\" style=\"padding-top:0px\"><md-input-container flex><label>Classification Code</label>\n<md-select name=\"classification_code\" ng-model=\"vm.Form.objForm.clasification_code\" disabled=\"disabled\"><md-option><em>\nNone</em></md-option><md-option ng-repeat=\"ls in vm.classificationCode\" value=\"{{ls.id}}\">\n{{ls.id}} / {{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Scope\n</label><md-select name=\"scope\" ng-model=\"vm.Form.objForm.org_level_id\" disabled=\"disabled\"><md-option \nng-repeat=\"ls2 in vm.orgLevel\" value=\"{{ls2.id}}\">{{ls2.description}}</md-option></md-select></md-input-container>\n</div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex><label>Indirect Report</label>\n<md-select disabled=\"disabled\" ng-model=\"vm.Form.objForm.indirect_report\"><md-option ng-value=\"item\" \nng-selected=\"item.id == vm.Form.objForm.indirect_report.id\" ng-repeat=\"item in vm.listDirectReport\">\n{{item.description}}</md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.update\"><label>\nDirect Report</label><md-select disabled=\"disabled\" ng-model=\"vm.Form.objForm.direct_report\"><md-option \nng-value=\"item\" ng-selected=\"item.id == vm.Form.objForm.direct_report.id\" ng-repeat=\"item in vm.listDirectReport\">\n{{item.description}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex><label>Business Title</label><md-select disabled=\"disabled\" \nng-model=\"vm.Form.objForm.listBtCode\" md-on-close=\"vm.clearSearchTerm(1)\" data-md-container-class=\"selectHeader\" \nmultiple=\"multiple\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermBT\" type=\"search\" \nplaceholder=\"Search for Core Business Unit\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup \nlabel=\"select core business unit\"><md-option ng-value=\"item\" \nng-selected=\"vm.exists(vm.Form.objForm.listBtCode, \'id\', item.id)\" \nng-repeat=\"item in vm.listBusinessTitle |\n                        filter:vm.searchTerm\">{{item.description}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Core Business Unit</label>\n<md-select disabled=\"disabled\" ng-model=\"vm.Form.objForm.listCbu\" md-on-close=\"vm.clearSearchTerm(2)\" \ndata-md-container-class=\"selectHeader\" multiple=\"multiple\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTermCBU\" type=\"search\" placeholder=\"Search for Core Business Unit\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup label=\"select core business unit\"><md-option ng-value=\"item\" \nng-selected=\"vm.exists(vm.Form.objForm.listCbu, \'id\', item.id)\" \nng-repeat=\"item in vm.listCbu |\n                    filter:vm.searchTerm\">{{item.description}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex><label>Sub Domain</label><md-select disabled=\"disabled\" \nng-model=\"vm.Form.objForm.listSubDomain\" md-on-close=\"vm.clearSearchTerm(3)\" data-md-container-class=\"selectHeader\" \nmultiple=\"multiple\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermSD\" type=\"search\" \nplaceholder=\"Search for Sub Domain\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup \nlabel=\"select sub domain\"><md-option ng-value=\"item\" \nng-selected=\"vm.exists(vm.Form.objForm.listSubDomain, \'id\', item.id)\" \nng-repeat=\"item in vm.listSubDomain | filter:vm.searchTerm\">{{item.description}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Sub Area</label><md-select disabled=\"disabled\" \nng-model=\"vm.Form.objForm.listArea\" md-on-close=\"vm.clearSearchTerm(4)\" data-md-container-class=\"selectHeader\" \nmultiple=\"multiple\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermSA\" type=\"search\" \nplaceholder=\"Search for a area..\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup \nlabel=\"select sub area\"><md-option ng-value=\"item\" ng-selected=\"vm.exists(vm.Form.objForm.listArea, \'id\', item.id)\" \nng-repeat=\"item in vm.listSubarea |\n                    filter:vm.searchTerm\">{{item.description}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><div flex=\"60\" \nlayout=\"row\" layout-align=\"start center\"><md-autocomplete md-selected-item=\"vm.selectedItem.employee\" \nmd-search-text=\"vm.searchText.employee\" md-selected-item-change=\"vm.selectedItemChange(item, \'employee\')\" \nmd-items=\"item in vm.querySearchEmployee(vm.searchText.employee, \'employee\')\" md-item-text=\"item.name\" \nplaceholder=\"Search for employee\" md-min-length=\"3\"><md-item-template><span md-highlight-text=\"vm.searchText.employee\" \nmd-highlight-flags=\"^i\">{{item.nik}} | {{item.name}}</span></md-item-template><md-not-found>\nNo employee matching \"{{vm.searchText.employee}}\" were found.</md-not-found></md-autocomplete></div><div flex=\"40\" \nlayout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox ng-model=\"vm.isTBD\" \naria-label=\"TBD\"></md-checkbox><span ng-if=\"!vm.isTBD\">TBD ?</span></div><div ng-if=\"vm.isTBD\" layout=\"row\" \nlayout-align=\"space-between center\"><div><md-input-container><label>Qty</label><input style=\"width:70%\" \nplaceholder=\"Qty\" type=\"number\" ng-model=\"vm.tbdQuantity\"></md-input-container></div><div><md-datepicker \nstyle=\"padding-bottom:0px\" md-hide-icons=\"all\" md-placeholder=\"Date FulFill\" md-open-on-focus \nng-model=\"vm.tbdDateFulfil\" md-current-view=\"month\"></md-datepicker></div><div><md-button class=\"md-primary md-mini\" \nstyle=\"margin-left:0px\" ng-disabled=\"vm.tbdQuantity === 0 || !vm.tbdDateFulfil\" \nng-click=\"vm.addTbdToChart(vm.tbdQuantity,vm.tbdDateFulfil)\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div></div></div></div><div layout=\"column\" class=\"md-whiteframe-3dp\" flex><md-content style=\"max-height:200px\" \nms-scroll><md-list class=\"list-content\" flex><md-list-item style=\"border-bottom:1px solid #ccc; font-size: 10px\" \nng-repeat=\"item in vm.Form.objForm.listEmp\" flex layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"body-font\" layout-align=\"start center\" flex=\"30\">{{item.nik}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"30\">{{item.name}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"30\"><md-datepicker style=\"margin-top:0px; padding-top: 0px; padding-bottom: 0px\" \nmd-hide-icons=\"all\" md-placeholder=\"Date FulFill\" md-open-on-focus \nng-model=\"vm.Form.objForm.listEmp[$index].date_fulfill_formated\" md-current-view=\"month\" \nname=\"dateFulfil{{vm.Form.objForm.listEmp[$index].nik}}\"></md-datepicker></div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"10\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Form.objForm.listEmp.splice($index, 1)\"><md-icon ng-style=\"{\'color\' : \'red\', \'font-size\' : \'10px\'}\" \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\">Delete</md-tooltip></md-button></div>\n</md-list-item></md-list></md-content></div><div class=\"messageError\" ng-show=\"vm.showErrorEmployee\">\n{{ vm.messagesErrorEmployee }}</div></div></md-dialog-content><md-dialog-actions layout=\"row\" flex><div flex \nclass=\"form-message\" ng-class=\"{success:vm.success,error:!vm.success}\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n{{vm.Form.pesan}}</div><div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.updateData($event,formCreateLayerMpp)\" \nng-disabled=\"formCreateLayerMpp.$invalid || vm.updateProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save Data</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/orgchart/edit-mpp.html","<md-dialog aria-label=\"Create Layer Mpp\" md-theme=\"modal-theme\" ms-scroll flex=\"85\" id=\"dialog-create-mpp\"><form \nng-cloak name=\"formCreateLayerMpp\" class=\"md-inline-form\" novalidate ng-submit=\"\"><md-toolbar><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"md-toolbar-tools title\"><div class=\"h4\">{{vm.type}} Layer MPP</div><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear ng-show=\"vm.loadingProgress\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-dialog-content layout-fill style=\"margin-top:0px\"><div \nclass=\"form-overlay-wrapper-mpp animate-fade-in-out\" ng-show=\"vm.loadingProgress\"><div flex layout=\"column\" \nlayout-fill layout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div layout=\"column\" flex \nlayout-padding><div layout=\"row\" flex layout-align=\"start center\" style=\"padding-top:0px\" \nng-hide=\"vm.Form.objForm.isNewJobTitle\"><md-input-container flex><label>Country</label><md-select \nng-model=\"vm.Form.objForm.country\" data-md-container-class=\"selectHeader\" ng-disabled=\"!vm.superAkses\" required \nng-change=\"vm.loadDataParamCountry(vm.Form.objForm.entity_id)\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTermCountry\" type=\"search\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 800, \'blur\': 0} }\" \nplaceholder=\"Search for Country\" class=\"header-searchbox md-text\" ng-change=\"vm.getCountry(vm.searchTermCountry)\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.listDataCountry | filter:vm.searchTermCompany\">{{item.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Company</label><md-select ng-model=\"vm.Form.objForm.entity_id\" \nng-change=\"vm.getListDataAffectedByBU(vm.Form.objForm.entity_id)\" data-md-container-class=\"selectHeader\" \nng-disabled=\"!vm.superAkses\" required><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermCompany\" \ntype=\"search\" placeholder=\"Search for Company\" ng-keydown=\"$event.stopPropagation()\" class=\"header-searchbox md-text\">\n</md-select-header><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.listDataCompany | filter:vm.searchTermCompany\">\n{{item.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Division</label>\n<md-select ng-model=\"vm.Form.objForm.division_id\" md-on-close=\"vm.getListDataDepartment(vm.Form.objForm.division_id)\" \ndata-md-container-class=\"selectHeader\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermDivisi\" \ntype=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for Division\" class=\"header-searchbox md-text\">\n</md-select-header><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.listDataDivisi | filter:vm.searchTermDivisi\">\n{{item.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Department</label>\n<md-select ng-model=\"vm.Form.objForm.department_id\" data-md-container-class=\"selectHeader\"><md-select-header \nclass=\"select-header\"><input ng-model=\"vm.searchTermDepartment\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"Search for Department\" class=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.listDataDepartment | filter:vm.searchTermDepartment\">{{item.description}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex layout-align=\"start center\" style=\"padding-top:0px\" \nng-hide=\"!vm.Form.objForm.isNewJobTitle\"><md-input-container flex><label>Country</label><md-select \nng-model=\"vm.Form.objForm.country\" data-md-container-class=\"selectHeader\" ng-disabled=\"!vm.superAkses\" required>\n<md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermCountry\" type=\"search\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 800, \'blur\': 0} }\" \nplaceholder=\"Search for Country\" class=\"header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-change=\"vm.getCountry(vm.searchTermCountry)\"></md-select-header><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.listDataCountry | filter:vm.searchTermCompany\">{{item.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Company</label><md-select ng-model=\"vm.Form.objForm.entity_id\" \nmd-on-close=\"vm.getCostCenter(vm.Form.objForm.entity_id)\" data-md-container-class=\"selectHeader\" \nng-disabled=\"!vm.superAkses\" required><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermCompany\" \ntype=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for Company\" class=\"header-searchbox md-text\">\n</md-select-header><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.listDataCompany | filter:vm.searchTermCompany\">\n{{item.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Division</label>\n<md-select ng-model=\"vm.Form.objForm.division_id\" md-on-close=\"vm.getListDataDepartment(vm.Form.objForm.division_id)\" \ndata-md-container-class=\"selectHeader\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermDivisi\" \ntype=\"search\" ng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 800, \'blur\': 0} }\" \nplaceholder=\"Search for Division\" class=\"header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\" \nng-change=\"vm.getListDataDivisi(vm.Form.objForm.entity_id)\"></md-select-header><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.listDataDivisi | filter:vm.searchTermDivisi\">{{item.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Department</label><md-select \nng-model=\"vm.Form.objForm.department_id\" data-md-container-class=\"selectHeader\"><md-select-header \nclass=\"select-header\"><input ng-model=\"vm.searchTermDepartment\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"Search for Department\" class=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.listDataDepartment | filter:vm.searchTermDepartment\">{{item.description}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex><label>\nBusiness Title</label><md-select ng-model=\"vm.Form.objForm.bt_code\" \nmd-on-close=\"vm.changeDescription(vm.Form.objForm.bt_code)\" data-md-container-class=\"selectHeader\"><md-select-header \nclass=\"select-header\"><input ng-model=\"vm.searchTermBT\" type=\"search\" placeholder=\"Search for Business Title\" \nclass=\"header-searchbox md-text\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 800, \'blur\': 0} }\" \nng-keydown=\"$event.stopPropagation()\" ng-change=\"vm.getBusinessTitle(vm.searchTermBT)\"></md-select-header>\n<md-progress-linear ng-show=\"vm.selectLoading.businessTitle\" md-mode=\"indeterminate\"></md-progress-linear><md-option \nng-value=\"item\" ng-selected=\"vm.Form.objForm.bt_code.id == item.id\" \nng-repeat=\"item in vm.listBusinessTitle | filter:vm.searchTermBT\">{{item.code_description}}</md-option></md-select>\n</md-input-container><md-input-container ng-hide=\"!vm.Form.objForm.isNewJobTitle\"><md-checkbox \nng-hide=\"!vm.Form.objForm.bt_code\" ng-model=\"vm.Form.objForm.isNewJobTitle\" aria-label=\"isNewJobTitle\"></md-checkbox>\n<span ng-hide=\"!vm.Form.objForm.bt_code\">New Job Title ?</span></md-input-container><div flex \nng-hide=\"vm.Form.objForm.isNewJobTitle\" class=\"job-title-new\"><label class=\"job-title-checkbox\">Job Title <span \nng-hide=\"!vm.Form.objForm.bt_code\">/ New Job Title ? <input ng-hide=\"!vm.Form.objForm.bt_code\" type=\"checkbox\" \nng-model=\"vm.Form.objForm.isNewJobTitle\" aria-label=\"isNewJobTitle\"></span></label><md-select \nng-model=\"vm.Form.objForm.abreviation\" data-md-container-class=\"selectHeader\" \nmd-on-close=\"vm.getListDataGroupCluster(vm.Form.objForm.abreviation,\'jt\')\"><md-select-header class=\"select-header\">\n<input ng-model=\"vm.searchJobTitle\" type=\"search\" placeholder=\"Search for Job Title\" class=\"header-searchbox md-text\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 800, \'blur\': 0} }\" \nng-change=\"vm.getListDataJobTitle(vm.searchJobTitle)\" ng-keydown=\"$event.stopPropagation()\"></md-select-header>\n<md-progress-linear ng-show=\"vm.selectLoading.jobTitle\" md-mode=\"indeterminate\"></md-progress-linear><md-option \nng-value=\"item.id\" ng-repeat=\"item in vm.listDataJobTitle\">{{item.description}}</md-option></md-select></div>\n<md-input-container flex ng-hide=\"vm.Form.objForm.isNewJobTitle\"><label>Group Cluster</label><md-select \nng-model=\"vm.Form.objForm.group_cluster\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.listDataGroupCluster\">\n{{item.description}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"start center\" style=\"padding-top:0px\"><md-input-container layout=\"row\" flex><label>Description</label>\n<input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" ng-change=\"vm.changeDescriptionBT()\" \nrequired></md-input-container><md-input-container layout=\"row\" class=\"md-block\" flex><label>Layer Type</label>\n<md-select required name=\"type\" ng-model=\"vm.Form.objForm.type\"><md-option><em>None</em></md-option><md-option \nvalue=\"division\">DIVISION</md-option><md-option value=\"department\">DEPARTMENT</md-option><md-option value=\"function\">\nFUNCTION</md-option></md-select></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\" \nng-hide=\"!vm.Form.objForm.isNewJobTitle\"><md-input-container layout=\"row\" flex><label>Job Title</label><input \ntype=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.job_title_text\"></md-input-container><md-input-container \nlayout=\"row\" class=\"md-block\" flex><label>Group Cluster</label><md-select ng-model=\"vm.Form.objForm.group_cluster\">\n<md-option ng-value=\"item.id\" ng-repeat=\"item in vm.listDataGroupCluster\">{{item.description}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex><label>\nCost Center</label><md-select required name=\"costCenter\" ng-model=\"vm.Form.objForm.cost_center_id\" \ndata-md-container-class=\"selectHeader\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTermCostCenter\" type=\"search\" placeholder=\"Search for Cost Center\" class=\"header-searchbox md-text\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 800, \'blur\': 0} }\" \nng-keydown=\"$event.stopPropagation()\" ng-change=\"vm.getCostCenter(vm.Form.objForm.entity_id)\"></md-select-header>\n<md-option><em>None</em></md-option><md-progress-linear ng-show=\"vm.selectLoading.costCenter\" md-mode=\"indeterminate\">\n</md-progress-linear><md-option ng-repeat=\"ls1 in vm.costCenter | filter:vm.searchTermCostCenter\" ng-value=\"ls1.id\">\n{{ls1.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Scope</label><md-select\n required name=\"scope\" ng-model=\"vm.Form.objForm.org_level_id\"><md-option ng-repeat=\"ls2 in vm.orgLevel\" \nvalue=\"{{ls2.id}}\">{{ls2.description}}</md-option></md-select></md-input-container><md-input-container flex><label>\nGrade Level</label><md-select required name=\"jobLevel\" ng-model=\"vm.Form.objForm.job_level\" \nng-disabled=\"vm.Form.objForm.job_level_set\"><md-option><em>None</em></md-option><md-option value=\"1A\">1A</md-option>\n<md-option value=\"1B\">1B</md-option><md-option value=\"1C\">1C</md-option><md-option value=\"2A\">2A</md-option><md-option \nvalue=\"2B\">2B</md-option><md-option value=\"2C\">2C</md-option><md-option value=\"3A\">3A</md-option><md-option value=\"3B\">\n3B</md-option><md-option value=\"3C\">3C</md-option><md-option value=\"4A\">4A</md-option><md-option value=\"4B\">4B\n</md-option><md-option value=\"4C\">4C</md-option><md-option value=\"5A\">5A</md-option><md-option value=\"5B\">5B\n</md-option><md-option value=\"5C\">5C</md-option><md-option value=\"6A\">6A</md-option><md-option value=\"6B\">6B\n</md-option><md-option value=\"6C\">6C</md-option><md-option value=\"7\">7</md-option></md-select></md-input-container>\n</div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex ng-if=\"vm.update\"><label>\nDirect Report</label><md-autocomplete md-selected-item=\"vm.Form.objForm.direct_report\" \nmd-selected-item-change=\"vm.selectedItemChange(item, \'direct\')\" md-search-text=\"vm.searchText.direct\" \nmd-items=\"item in vm.querySearchDirect(vm.searchText.direct)\" md-item-text=\"item.description\" md-delay=\"500\" \nplaceholder=\"Search for Direct Report\" md-min-length=\"3\"><md-item-template><span \nmd-highlight-text=\"vm.searchText.direct\">{{item.description}}</span></md-item-template><md-not-found>\nNo Layer matching \"{{vm.searchText.direct}}\" were found.</md-not-found></md-autocomplete></md-input-container>\n<md-input-container flex><label>Behavior Layer</label><md-select required name=\"scope\" \nng-model=\"vm.Form.objForm.nodeType\"><md-option ng-repeat=\"ls in vm.nodeType\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><div \nlayout=\"row\" flex layout-align=\"start center\"><md-input-container flex><label>Classification Code</label><md-select \nrequired name=\"classification_code\" md-on-open=\"vm.getEmpClassification(vm.Form.objForm.entity_id)\" \nng-model=\"vm.Form.objForm.clasification_code\"><md-option><em>None</em></md-option><md-option \nng-repeat=\"ls in vm.classificationCode\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container></div><md-input-container flex><label>Work Location</label><md-select \nng-model=\"vm.Form.objForm.listArea\" md-on-close=\"vm.clearSearchTerm(4)\" data-md-container-class=\"selectHeader\" \nmultiple=\"multiple\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header class=\"select-header\"><input \nng-keydown=\"$event.stopPropagation()\" ng-change=\"vm.getSubArea(vm.Form.objForm.entity_id)\" ng-model=\"vm.searchTermSA\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 800, \'blur\': 0} }\" type=\"search\" \nplaceholder=\"Search for a area..\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup \nlabel=\"select sub area\"><md-option ng-value=\"item\" ng-selected=\"vm.exists(vm.Form.objForm.listArea, \'id\', item.id)\" \nng-repeat=\"item in vm.listSubarea | filter:vm.searchTermSA track by item.id\">{{item.description}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex class=\"effective-date-mpp\"><label>\nEffective Date</label><md-datepicker md-open-on-focus md-hide-icons=\"all\" required ng-model=\"vm.layerEffectiveDate\" \nname=\"effective_date\"></md-datepicker></md-input-container><md-input-container flex=\"10\"><label>Is Active</label>\n<md-select required ng-model=\"vm.Form.objForm.is_active\"><md-option value=\"1\">Yes</md-option><md-option value=\"0\">No\n</md-option></md-select></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"></div><fieldset>\n<legend>MPP LIST</legend><div layout=\"column\" flex ng-show=\"vm.Form.objForm.listEmp.length > 0\"><md-content ms-scroll>\n<table class=\"simple\" ms-responsive-table><thead><th width=\"1%\">NO.</th><th width=\"5%\">NIK</th><th width=\"15%\">NAME\n</th><th width=\"25%\">POSITION</th><th width=\"5%\">FULFILLMENT</th><th width=\"5%\">EFFECTIVE</th><th width=\"25%\">\nDIRECT REPORT</th><th width=\"5%\">IN<br>PLANNING</th><th width=\"2%\">TRANSACTION<br>TYPE</th><th width=\"1%\">ACTION</th>\n</thead><tbody><tr ng-repeat=\"item in vm.Form.objForm.listEmp\" track by $index><td>{{($index+1)}}</td><td>{{item.nik}}\n</td><td>{{item.name}}</td><td><md-input-container md-no-float class=\"md-block invisible-error-port\"><input \ndisabled=\"disabled\" placeholder=\"Position Name\" ng-model=\"vm.Form.objForm.listEmp[$index].position_name\" type=\"text\">\n</md-input-container></td><td><md-datepicker ng-disabled=\"true\" \nstyle=\"margin-top:0px; padding-top: 0px; padding-bottom: 0px\" md-hide-icons=\"all\" md-placeholder=\"FulFill date\" \nmd-open-on-focus ng-model=\"vm.Form.objForm.listEmp[$index].date_fulfill_formated\" md-current-view=\"month\" \nname=\"dateFulfil{{vm.Form.objForm.listEmp[$index].nik}}\" class=\"date-fulfill-emp\"></md-datepicker></td><td>\n<md-datepicker ng-disabled=\"true\" style=\"margin-top:0px; padding-top: 0px; padding-bottom: 0px\" md-hide-icons=\"all\" \nmd-placeholder=\"effective data\" md-open-on-focus ng-model=\"vm.Form.objForm.listEmp[$index].date_effective_formated\" \nmd-current-view=\"month\" name=\"dateEffective{{vm.Form.objForm.listEmp[$index].nik}}\" class=\"date-fulfill-emp\">\n</md-datepicker></td><td><md-select ng-disabled=\"true\" ng-model=\"vm.Form.objForm.listEmp[$index].directReport\" \nng-disabled=\"vm.onLoadDirectReport\"><md-option><em>None</em></md-option><md-option \nng-repeat=\"dt in vm.listDirectReport\" ng-init=\"idxDirect=$index\" ng-value=\"dt.id\">{{dt.description}}</md-option>\n</md-select></td><td><md-select ng-disabled=\"true\" ng-model=\"vm.Form.objForm.listEmp[$index].is_planning\"><md-option \nvalue=\"1\">YES</md-option><md-option value=\"0\">NO</md-option></md-select></td><td><md-select ng-disabled=\"true\" \nng-model=\"vm.Form.objForm.listEmp[$index].transactionType\" ng-disabled=\"vm.onLoadTransactionType\"><md-option><em>None\n</em></md-option><md-option ng-repeat=\"dt in vm.listTransactionType\" ng-init=\"idxTrans=$index\" ng-value=\"dt.id\">\n{{dt.description}}</md-option></md-select></td><td></td></tr></tbody></table></md-content></div></fieldset><div \nclass=\"messageError\" ng-show=\"vm.showErrorEmployee\">{{ vm.messagesErrorEmployee }}</div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" flex><div flex class=\"form-message\" ng-class=\"{success:vm.success,error:!vm.success}\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{vm.Form.pesan}}</div><div flex=\"40\" layout-align=\"end center\" \nlayout=\"row\"><md-button ng-if=\"vm.create\" class=\"md-raised md-accent\" \nng-click=\"vm.saveData($event,formCreateLayerMpp)\" ng-disabled=\"formCreateLayerMpp.$invalid || vm.saveProcess\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Save</md-button><md-button ng-if=\"vm.update\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateData($event,formCreateLayerMpp)\" \nng-disabled=\"formCreateLayerMpp.$invalid || vm.updateProcess\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon>Update</md-button><md-button ng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\nRefresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/orgchart/orgchart.html","<div id=\"mppToolbarArea\" hide show-gt-sm><div class=\"mpp-main-subheader\"><div class=\"md-whiteframe-3dp\" \nlayout=\"column\"><div flex layout=\"row\" layout-align=\"start center\" ng-style=\"{\'height\' : \'35px\'}\"><div flex=\"15\" \nlayout=\"row\" class=\"md-primary\" layout-align=\"start center\"><md-button class=\"md-primary md-mini\">Organization Layer\n</md-button></div><div flex layout=\"row\" layout-align=\"end center\"><label id=\"parentID\" class=\"label\">Parent Org Layer\n</label><md-autocomplete ng-disabled=\"false\" md-no-cache=\"false\" id=\"layerID\" md-selected-item=\"vm.teamLayer\" \nmd-search-text=\"ctrl.searchText\" md-items=\"item in vm.viewListLayer(ctrl.searchText)\" md-item-text=\"item.description\" \nmd-min-length=\"1\" md-escape-options=\"clear\" placeholder=\"Ex. Head of Human Capital\" input-aria-labelledby=\"parentID\" \nmd-menu-class=\"autocomplete-layer-id\" md-autocomplete-snap=\"240\" md-menu-container-class=\"custom-container\">\n<md-item-template><span class=\"item-title\">{{item.description}}</span></md-item-template><md-not-found>\nNo states matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete><div class=\"divider-vertical\"></div>\n<div layout=\"row\" layout-align=\"space-between center\" class=\"group-action\"><span class=\"label\">Org. depth Level</span>\n<md-select ng-model=\"vm.layer\" placeholder=\"level\" class=\"md-no-underline\"><md-option \nng-repeat=\"layer in vm.listLayer\" ng-value=\"layer\">{{layer}}</md-option></md-select></div><div \nclass=\"divider-vertical\"></div><div><md-button ng-click=\"vm.loadStructure()\" class=\"md-primary md-mini\">View Layer\n<md-tooltip md-direction=\"bottom\">Load Structure</md-tooltip></md-button></div></div></div></div></div></div><div \nclass=\"page-layout\" mpp-chart-viewport id=\"orgchart-area\" hide show-gt-sm><div layout=\"column\" \nstyle=\"padding:0; margin: 0\" class=\"content-card\"><md-content id=\"centerpanel\" class=\"org-chart\" \nstyle=\"overflow:hidden; padding: 0px; margin: 0px; border: 0px;cursor:pointer\"><div id=\"chartContent\" bp-org-diagram \ndata-options=\"vm.options\" flex=\"100\" style=\"overflow:unset\" ms-scroll></div></md-content></div></div><div \nlayout=\"column\" layout-align=\"center center\" layout-align-xs=\"center center\" hide-gt-sm><div layout=\"row\">\nSorry, this feature is not supported on mobile</div></div>");
$templateCache.put("app/main/orgchart/orgchartemp.html","<div id=\"mppToolbarArea\" hide show-gt-sm><div class=\"mpp-main-subheader\"><div class=\"md-whiteframe-3dp\" \nlayout=\"column\"><div flex layout layout=\"row\" layout-align=\"start center\" ng-style=\"{\'height\' : \'35px\'}\"><div \nflex=\"15\" layout=\"row\" class=\"md-primary\" layout-align=\"start center\"><md-button class=\"md-primary md-mini\">\nOrganization Layer</md-button></div><div flex layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nclass=\"search-layer-container\"><div class=\"parent-org-layer-title\">Parent Org Layer</div><md-autocomplete \nmd-selected-item=\"vm.teamLayer\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-search-text=\"vm.searchTerm\" \nmd-items=\"item in vm.querySearchLayer(vm.searchTerm)\" md-item-text=\"item.description\" \nplaceholder=\"Ex. Head of Human Capital\" required md-delay=\"500\" md-menu-class=\"autocomplete-layer-id\" \nmd-autocomplete-snap=\"240\" md-menu-container-class=\"custom-container\" md-min-length=\"3\"><md-item-template><span \nmd-highlight-text=\"vm.searchTerm\">{{item.description}}</span></md-item-template><md-not-found>\nNo Layer matching \"{{vm.searchTerm}}\" were found.</md-not-found></md-autocomplete></div><div \nclass=\"select-layer-container\"><label for=\"numLayer\">Org. Depth Layer:</label><select id=\"numLayer\" \nng-model=\"vm.layer\"><option ng-repeat=\"item in vm.listLayer\" ng-value=\"item\">{{item}}</option></select></div><div \nclass=\"divider-vertical\"></div><div><md-button ng-click=\"vm.loadStructure()\" class=\"md-primary md-mini\">View Layer\n<md-tooltip md-direction=\"bottom\">Load Structure</md-tooltip></md-button></div></div></div></div></div></div><div \nclass=\"page-layout\" mpp-chart-viewport id=\"orgchart-area\" hide show-gt-sm><div layout=\"column\" \nstyle=\"padding:0; margin: 0\" class=\"content-card\"><md-content id=\"centerpanel\" class=\"org-chart\" \nstyle=\"overflow:hidden; padding: 0px; margin: 0px; border: 0px\"><div id=\"chartContent\" bp-org-diagram \ndata-options=\"vm.options\" flex=\"100\" style=\"overflow:unset\" ms-scroll></div></md-content></div></div><div \nlayout=\"column\" layout layout-align=\"center center\" layout-align-xs=\"center center\" hide-gt-sm><div layout=\"row\">\nSorry, this feature is not supported on mobile</div></div>");
$templateCache.put("app/main/orgchart/orgcharttes.html","<div id=\"mppToolbarArea\" hide show-gt-sm><div class=\"mpp-main-subheader\"><div class=\"md-whiteframe-3dp\" \nlayout=\"column\"><div flex layout layout=\"row\" layout-align=\"start center\" ng-style=\"{\'height\' : \'35px\'}\"><div \nflex=\"15\" layout=\"row\" class=\"md-primary\" layout-align=\"start center\"><md-button class=\"md-primary md-mini\">\nOrganization Layer</md-button></div><div flex layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"padding-0\">\n<md-menu><md-button aria-label=\"filter menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nstyle=\"font-size:1.5rem\" md-font-icon=\"icon-cog\"></md-icon><md-tooltip md-direction=\"bottom\">Settings</md-tooltip>\n</md-button><md-menu-content><md-menu-item><md-menu><md-button ng-click=\"$mdMenu.open()\">My MPP Team <b \nstyle=\"padding-left:5px; text-transform: uppercase; font-size: 1rem\">{{vm.teamLayer.description}}</b></md-button>\n<md-menu-content><md-menu-item><input style=\"padding-left: 20px\" placeholder=\"search\" type=\"search\" \nng-model=\"vm.searchTerm\"></md-menu-item><div flex style=\"overflow-y:scroll; width: 100%; max-height: 200px\" \nid=\"team-layer-container\"><md-menu-item \nng-repeat=\"teamLayer in vm.listTeamLayer | filter:vm.searchTerm track by teamLayer.id\"><md-button \nng-style=\"{\'font-size\' : \'1rem\'}\" ng-class=\"{\'md-primary\' : vm.teamLayer.id === teamLayer.id}\" \nng-click=\"vm.teamLayer = teamLayer\" md-prevent-menu-close=\"md-prevent-menu-close\">{{teamLayer.description}}</md-button>\n</md-menu-item></div></md-menu-content></md-menu></md-menu-item><md-menu-item><md-menu><md-button \nng-click=\"$mdMenu.open()\">No of Layer <b style=\"padding-left:5px; text-transform: uppercase; font-size: 1rem\">\n{{vm.layer}}</b></md-button><md-menu-content><md-menu-item ng-repeat=\"layer in vm.listLayer\"><md-button \nng-class=\"{\'md-primary\' : vm.layer === layer}\" ng-click=\"vm.layer = layer\">{{layer}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item></md-menu-content></md-menu></md-menu-bar><div><md-button \nng-click=\"vm.loadStructure()\" class=\"md-icon-button\"><md-icon style=\"font-size:1.5rem\" md-font-icon=\"icon-reload\">\n</md-icon><md-tooltip md-direction=\"bottom\">Load Structure</md-tooltip></md-button></div></div></div></div></div></div>\n<div hide show-gt-sm mpp-chart-viewport class=\"page-layout\" id=\"orgchart-area1\"><div layout=\"column\" \nstyle=\"padding:0; margin: 0\" class=\"content-card\"><div id=\"centerpanel\" \nstyle=\"overflow: hidden; padding: 0px; margin: 0px; border: 0px\"><div bp-org-diagram data-options=\"vm.myOptions\" \ndata-on-highlight-changed=\"vm.onMyHighlightChanged()\" data-on-cursor-changed=\"vm.onMyCursorChanged()\" \nstyle=\"width: 800px; height: 600px; border-style: dotted; border-width: 1px\"></div></div></div></div><div \nlayout=\"column\" layout layout-align=\"center center\" layout-align-xs=\"center center\" hide-gt-sm><div layout=\"row\">\nSorry, this feature is not supported on mobile</div></div>");
$templateCache.put("app/main/orgchart/view-mpp-overlap.html","<md-dialog aria-label=\"Create Layer Mpp\" md-theme=\"modal-theme\" ms-scroll flex=\"60\" id=\"dialog-create-mpp\"><form \nng-cloak name=\"formCreateLayerMpp\" class=\"md-inline-form\" novalidate ng-submit=\"\"><md-toolbar><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"md-toolbar-tools title\"><div class=\"h4\">\nView Detail Headcount {{vm.data.context.description}}</div><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout-fill style=\"margin-top:0px\"><div flex-xs flex-gt-xs=\"100\" layout=\"row\"><md-card \nng-repeat=\" dto in vm.data.context.listOverLap\" flex=\"50\"><md-card-title><md-card-title-text><span class=\"md-headline\">\n{{dto.fullName}}</span> <span class=\"md-subhead\">NIK : {{dto.nik}}</span> <span class=\"md-subhead\" \nng-if=\"dto.inactive_date\">In Active Date : {{dto.inactive_date}}</span></md-card-title-text><md-card-title-media><div \nclass=\"md-media-sm card-media\"><img ng-if=\"dto.image\" ng-src=\"{{dto.image}}\" \nonerror=\"this.src=\'assets/images/avatars/profile.jpg\'\" class=\"md-card-image\" alt=\"Washed Out\"> <img ng-if=\"!dto.image\" \nng-src=\"{{dto.image}}\" src=\"assets/images/avatars/profile.jpg\" class=\"md-card-image\" alt=\"Washed Out\"></div>\n</md-card-title-media></md-card-title></md-card></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payslip/payslip.html","<div id=\"viewpayroll-pma\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"white-bg rounded\"><md-content id=\"filter-data\" class=\"\" \nlayout=\"column\"><div layout=\"column\" flex=\"10\"><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon>Select Period</div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"10\"><md-select ng-model=\"vm.period\" name=\"period\" ng-change=\"vm.loadData()\"><md-option \nng-repeat=\"ls in vm.listPeriod\" placeholder=\"Period\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.print();\"><span>Print</span></md-button></md-input-container></div>\n</form></div></div></md-content><div id=\"view-payslip\" \nstyle=\"margin:0px 30px 0px 30px;border-style: double;border-width: thick\"><div><table style=\"width: 100%\"><tr><td \nclass=\"right_hd\"><table style=\"width: 100%\"><tr><td class=\"ganteng\">NAMA</td><td>: {{vm.dataList.NAME}}</td></tr><tr>\n<td>NIK</td><td>: {{vm.dataList.NIK}}</td></tr><tr><td>JABATAN</td><td>: {{vm.dataList.Jobtitle}}</td></tr><tr><td>SITE\n</td><td>: {{vm.dataList.ORG_UNIT}}</td></tr><tr><td>PERIODE</td><td>: {{vm.dataList.Period}}</td></tr></table></td><td\n style=\"width: 40%\"><u>PRIVATE & CONFIDENTIAL</u></td><td><img \nstyle=\"margin-right: -100px;\n                                margin-left: auto\" src=\"assets/images/pinus.png\"></td>\n</tr></table></div><hr><hr><div><div style=\"float: left;width: 50%;padding-left:10px\"><p><b><u>INCOME</u></b></p><div \nng-if=\"vm.dataList.Basic_salary!=\'0.00\'\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">\nBASIC SALARY</div><div flex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.Basic_salary }}</div></div><div \nng-if=\"vm.dataList.Management_allowance!=\'0.00\'\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" \nflex=\"55\">POSITION ALLOWANCE</div><div flex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.Management_allowance }}</div>\n</div><div ng-if=\"vm.dataList.functional_allowance!=\'0.00\'\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"55\">FUNCTIONAL ALLOWANCE</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.functional_allowance }}</div></div><div ng-if=\"vm.dataList.communication_allowance!=\'0.00\'\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">COMMUNICATION ALLOWANCE</div><div \nflex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.communication_allowance }}</div></div><div \nng-if=\"vm.dataList.transportation_allowance!=\'0.00\'\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" \nflex=\"55\">TRANSPORT ALLOWANCE</div><div flex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.transportation_allowance }}</div>\n</div><div ng-if=\"vm.dataList.Meal_allowance!=\'0.00\'\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"55\">MEAL ALLOWANCE</div><div flex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.Meal_allowance }}</div>\n</div><div ng-if=\"vm.dataList.Promotion_allowance!=\'0.00\'\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"55\">ACTING ALLOWANCE</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.Promotion_allowance }}</div></div><div ng-if=\"vm.dataList.Rapel!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">RAPEL</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.Rapel }}</div></div><div ng-if=\"vm.dataList.administration!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">ADMINISTRATION</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{vm.dataList.administration}}</div></div><div ng-if=\"vm.dataList.OT!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">OVER TIME</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.OT }}</div></div><div ng-if=\"vm.dataList.thr!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">THR</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{vm.dataList.thr}}</div></div><div ng-if=\"vm.dataList.pph21!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">PPH21</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{vm.dataList.pph21}}</div></div><div ng-if=\"vm.dataList.Other_Allowance!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">OTHERS</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.Other_Allowance }}</div></div><div ng-if=\"vm.dataList.adjustment_um!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">ADJUSTMENT UM</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.adjustment_um }}</div></div><div ng-if=\"vm.dataList.adjustment_ut!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">ADJUSTMENT UT</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.adjustment_ut }}</div></div><div ng-if=\"vm.dataList.umm!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">UMM</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.umm }}</div></div><div ng-if=\"vm.dataList.bbm2lt!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">BBM 2LT</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.bbm2lt }}</div></div><div ng-if=\"vm.dataList.sewa_motor!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">SEWA MOTOR</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.sewa_motor }}</div></div><div ng-if=\"vm.dataList.paket_lebur!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">PAKET LEMBUR</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.paket_lebur }}</div></div><div ng-if=\"vm.dataList.paket_luar_kota!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">PAKET LUAR KOTA</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.paket_luar_kota }}</div></div><div ng-if=\"vm.dataList.uang_pisah!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">UANG PISAH</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.uang_pisah }}</div></div><div ng-if=\"vm.dataList.uang_pencairan_cuti!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">UANG PENCAIRAN CUTI</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.uang_pencairan_cuti }}</div></div><div ng-if=\"vm.dataList.komisi!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">KOMISI</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.komisi }}</div></div><br><div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" \nflex=\"55\">BPJS</div></div><div ng-if=\"vm.dataList.ER_JKK!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">JKK</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.ER_JKK }}</div></div><div ng-if=\"vm.dataList.ER_JKM!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">JKM</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.ER_JKM }}</div></div><div ng-if=\"vm.dataList.ER_JHT!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">JHT</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.ER_JHT }}</div></div><div ng-if=\"vm.dataList.ER_JP!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">JP</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.ER_JP }}</div></div><div ng-if=\"vm.dataList.ER_BPJSKes!=\'0.00\'\" class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">BPJS Kesehatan</div><div class=\"marg-left\" \nflex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.ER_BPJSKes }}</div></div></div><div style=\"float: left;width: 50%\"><p><b>\n<u>DEDUCTION</u></b></p><div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">BPJS</div>\n</div><div ng-if=\"vm.dataList.jkk_emp!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"35\">JKK EMPL</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">: Rp. {{vm.dataList.jkk_emp}}\n</div></div><div ng-if=\"vm.dataList.jkm_emp!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\">\n<div flex-order=\"4\" flex=\"35\">JKM EMPL</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">\n: Rp. {{vm.dataList.jkm_emp}}</div></div><div ng-if=\"vm.dataList.EE_BPJSTK!=\'0.00\'\" class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">JHT EMPL</div><div class=\"marg-left\" \nflex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.EE_BPJSTK }}</div></div><div ng-if=\"vm.dataList.EE_JP!=\'0.00\'\" \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">JP EMPL</div><div \nclass=\"marg-left\" flex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.EE_JP }}</div></div><div \nng-if=\"vm.dataList.EE_BPJSKes!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"35\">BPJS KES EMPL</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.EE_BPJSKes }}</div></div><div ng-if=\"vm.dataList.ER_JKK!=\'0.00\'\" class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">JKK COMP</div><div class=\"marg-left\" \nflex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.ER_JKK }}</div></div><div ng-if=\"vm.dataList.ER_JKM!=\'0.00\'\" \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">JKM COMP</div><div \nclass=\"marg-left\" flex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.ER_JKM }}</div></div><div \nng-if=\"vm.dataList.ER_JHT!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" \nflex=\"35\">JHT COMP</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.ER_JHT }}</div></div><div \nng-if=\"vm.dataList.ER_JP!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" \nflex=\"35\">JP COMP</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.ER_JP }}</div></div><div \nng-if=\"vm.dataList.ER_BPJSKes!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"35\">BPJS KES COMP</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.ER_BPJSKes }}</div></div><br><div ng-if=\"vm.dataList.ABSENT_Deduction!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">POT. ABSEN</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.ABSENT_Deduction }}</div></div><div ng-if=\"vm.dataList.pph21!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">PPH21</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{vm.dataList.pph21}}</div></div><div ng-if=\"vm.dataList.lop!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">LOP</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.lop }}</div></div><div ng-if=\"vm.dataList.cop!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">COP</div><div flex-order=\"5\" flex=\"35\">\n: Rp. {{ vm.dataList.cop }}</div></div><div ng-if=\"vm.dataList.loan!=\'0.00\'\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">LOAN</div><div flex-order=\"5\" flex=\"35\">: Rp. 0</div></div>\n<div ng-if=\"vm.dataList.Other_Deduction!=\'0.00\'\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" \nflex=\"35\">OTHERS</div><div flex-order=\"5\" flex=\"35\">: Rp. {{ vm.dataList.Other_Deduction }}</div></div></div></div><div\n style=\"margin-top:420px;padding-left:10px\"><div style=\"float: left;width: 50%\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"55\"><b><u>TOTAL INCOME</u></b></div><div flex-order=\"5\" \nflex=\"35\"><b>: Rp. {{vm.dataList.total_income}}</b></div></div></div><div style=\"float: left;width: 50%\"><div flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"35\"><b><u>TOTAL DEDUCTION</u></b></div><div \nflex-order=\"5\" flex=\"35\"><b>: Rp. {{vm.dataList.total_deduction}}</b></div></div><div flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"35\"><b>NET THP</b></div><div flex-order=\"5\" flex=\"35\"><b>\n: Rp. {{vm.dataList.TOTAL}}</b></div></div></div></div><br><hr><div><table style=\"width: 100%\"><tr><td><div \nstyle=\"float: left;width: 50%;padding-left:10px\"><div flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"55\">ABSENCE QUOTA</div><div flex-order=\"5\" flex=\"35\">: {{vm.dataList.absence_quota}}</div></div>\n<div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">BALANCE</div><div flex-order=\"5\" \nflex=\"35\">: {{vm.dataList.balance}}</div></div><div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" \nflex=\"55\">ANNUAL LEAVE</div><div flex-order=\"5\" flex=\"35\">: {{vm.dataList.annual_leave}}</div></div><div flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">PERSONAL LEAVE</div><div flex-order=\"5\" \nflex=\"35\">: {{vm.dataList.personal_leave}}</div></div><div flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"55\">SICK LEAVE W/CERTIFICATE</div><div flex-order=\"5\" flex=\"35\">: {{vm.dataList.sick_leave}}</div>\n</div><div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"55\">LOAN</div><div flex-order=\"5\" \nflex=\"35\">: {{vm.dataList.loan}}</div></div></div><div style=\"float: left;width: 50%\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"35\">RESIDUAL LEAVE</div><div flex-order=\"5\" flex=\"35\">: -</div>\n</div></div></td></tr></table></div><br></div></div></md-content></div>");
$templateCache.put("app/main/payslip/payslipmys.html","<div id=\"paysliprki\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\" layout=\"column\"><div \nid=\"filter-data\" class=\"header nabati5 csm-header md-whiteframe-4dp\" layout=\"column\" flex=\"nogrow\"><div \nclass=\"header-content\" layout=\"column\" flex><div class=\"header-bottom has-selected\" layout=\"row\" flex><md-icon \nmd-font-icon=\"icon-calendar\" class=\"mr-10\"></md-icon><md-input-container flex flex-gt-sm=\"25\"><md-select \nng-model=\"vm.period\" name=\"period\" ng-change=\"vm.loadData()\"><md-option ng-repeat=\"ls in vm.listPeriod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex flex-gt-sm=\"25\">\n<md-button class=\"md-primary md-mini\" ng-click=\"vm.loadData()\"><md-tooltip md-direction=\"right\">View</md-tooltip>View\n</md-button></md-input-container><span flex hide show-gt-sm></span><md-input-container layout=\"row\" \nlayout-align=\"right right\"><md-button class=\"md-fab md-mini md-accent\" ng-click=\"vm.downloadPayslip()\"><md-tooltip \nmd-direction=\"left\">Download</md-tooltip><md-icon md-font-icon=\"icon-box-download\"></md-icon></md-button>\n</md-input-container></div></div></div><md-content id=\"paysliprki-content\" class=\"content padding\" flex ms-scroll><div \nid=\"view-payslip\" style=\"font-size: 12pt; color: #000; width: 100%\"><div><table style=\"width: 100%\"><tr><td \nstyle=\"width:160px\"></td><td><b>NABATI FOOD MALAYSIA SDN BHD</b> <span style=\"font-size: 10px\">(1104777-W) </span></td>\n<td></td></tr></table></div><div><div style=\"float: left;width: 10%;padding-left:10px\"><div flex layout=\"row\" \nlayout-align=\"start center\"><img style=\"margin-left: auto\" src=\"assets/images/nabatien.png\" width=\"150\"></div></div>\n<div style=\"float: left;width: 75%; border: 3px solid #333; border-style: thin; border-radius: 0 !important\"><div \nstyle=\"float: left;width: 40%\"><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"25\">NAME</div><div class=\"marg-left\" flex-order=\"5\" flex=\"60\">: {{ vm.dataList.emp_name }}</div>\n</div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"25\">IC NUMBER\n</div><div class=\"marg-left\" flex-order=\"5\" flex=\"60\">: {{ vm.dataList.ktp }}</div></div><div class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"25\">DEPT</div><div class=\"marg-left\" flex-order=\"5\" \nflex=\"60\">: {{ vm.dataList.department }}</div></div><div class=\"padd-left\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"25\">BANK A/C NO</div><div class=\"marg-left\" flex-order=\"5\" \nflex=\"60\">: {{ vm.dataList.bank_account }}</div></div></div><div style=\"float: left;width: 25%;padding-left:10px\"><div \nflex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"55\"></div><div flex-order=\"5\" flex=\"35\"></div>\n</div><div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"80\">\nEMPLOYEE NO : {{ vm.dataList.nik }}</div></div><div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" \nflex=\"55\"></div><div flex-order=\"5\" flex=\"35\"></div></div></div><div style=\"float: left;width: 35%\"><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"20\">SOCSO</div><div \nclass=\"marg-left\" flex-order=\"5\" flex=\"35\">: {{ vm.dataList.socso }}</div></div><div class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"20\">EPF</div><div class=\"marg-left\" flex-order=\"5\" \nflex=\"35\">: {{ vm.dataList.epf }}</div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"20\">TAX</div><div class=\"marg-left\" flex-order=\"5\" flex=\"35\">: {{ vm.dataList.tax }}</div></div>\n</div></div><div style=\"float: left;width: 15%\"><br><div class=\"padd-left\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"35\"></div><b>Payslip For<br>{{ vm.dataList.period }}</b></div>\n</div></div><div><div style=\"float: left;width: 10%;padding-left:10px\"><div flex layout=\"row\" \nlayout-align=\"start center\"></div></div><div style=\"float: left;width: 75%\"><div style=\"float: left;width: 50%\"><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\"><b>Earnings</b></div><div\n style=\"text-align: right\" flex-order=\"5\" flex=\"25\"><b>RM</b></div></div><div ng-if=\"vm.dataList.basic_salary!=\'0.00\'\" \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Basic Salary</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"25\">{{ vm.dataList.basic_salary }}</div></div><div \nng-if=\"vm.dataList.management_allowance!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Management Allowance</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">\n{{ vm.dataList.management_allowance }}</div></div><div ng-if=\"vm.dataList.communication_allowance!=\'0.00\'\" \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Communication Allowance\n</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">{{ vm.dataList.communication_allowance }}</div></div><div\n ng-if=\"vm.dataList.car_allowance!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Car Allowance</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">\n{{ vm.dataList.car_allowance }}</div></div><div ng-if=\"vm.dataList.Housing_Allowance!=\'0.00\'\" class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Housing Allowance</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"25\">{{ vm.dataList.Housing_Allowance }}</div></div><div \nng-if=\"vm.dataList.back_pay!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Back Pay</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">\n{{ vm.dataList.back_pay }}</div></div><div ng-if=\"vm.dataList.encashment_leave!=\'0.00\'\" class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Encashment Leave</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"25\">{{ vm.dataList.encashment_leave }}</div></div><div \nng-if=\"vm.dataList.sales_incentive!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Sales Incentive</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">\n{{ vm.dataList.sales_incentive }}</div></div><div ng-if=\"vm.dataList.delivery_incentive!=\'0.00\'\" class=\"padd-left\" \nflex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Delivery Incentive</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"25\">{{ vm.dataList.delivery_incentive }}</div></div><div \nng-if=\"vm.dataList.operation_incentive!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Operation Incentive</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">\n{{ vm.dataList.operation_incentive }}</div></div><div ng-if=\"vm.dataList.bonus!=\'0.00\'\" class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Bonus</div><div style=\"text-align: right\" \nflex-order=\"5\" flex=\"25\">{{ vm.dataList.bonus }}</div></div><div ng-if=\"vm.dataList.month13salary!=\'0.00\'\" \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">13th Month Salary</div>\n<div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">{{ vm.dataList.month13salary }}</div></div><div \nng-if=\"vm.dataList.total_ot!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Overtime</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">\n{{ vm.dataList.total_ot }}</div></div><div ng-if=\"vm.dataList.travel_allowance!=\'0.00\'\" class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Travel Allowance</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"25\">{{ vm.dataList.travel_allowance }}</div></div><div \nng-if=\"vm.dataList.adjustment_statutory!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Adjustment Statutory</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">\n{{ vm.dataList.adjustment_statutory }}</div></div><div ng-if=\"vm.dataList.adjustment_tax!=\'0.00\'\" class=\"padd-left\" \nflex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Adjustment Tax</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"25\">{{ vm.dataList.adjustment_tax }}</div></div><div \nng-if=\"vm.dataList.acting_allowance!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Acting Allowance</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">\n{{ vm.dataList.acting_allowance }}</div></div><div ng-if=\"vm.dataList.reimbursement!=\'0.00\'\" class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Reimbursement</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"25\">{{ vm.dataList.reimbursement }}</div></div><div \nng-if=\"vm.dataList.gratuity!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Gratuity</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\">\n{{ vm.dataList.gratuity }}</div></div><div ng-if=\"vm.dataList.compensation!=\'0.00\'\" class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Compensation</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"25\">{{ vm.dataList.compensation }}</div></div></div><div \nstyle=\"float: left;width: 50%\"><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\"><b>Deduction</b></div><div style=\"text-align: right\" flex-order=\"5\" flex=\"35\"><b>RM</b></div>\n</div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">EPF Employee\n</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"35\">{{ vm.dataList.ee_epf }}</div></div><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">SOCSO Employee</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"35\">{{ vm.dataList.ee_socso }}</div></div><div class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">EIS Employee</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"35\">{{ vm.dataList.ee_eis }}</div></div><div class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Income TAX PCB</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"35\">{{ vm.dataList.pcb }}</div></div><div \nng-if=\"vm.dataList.absence_deduction!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Absence Deduction</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"35\">\n{{ vm.dataList.absence_deduction }}</div></div><div ng-if=\"vm.dataList.unpaid_leave!=\'0.00\'\" class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Unpaid Leave</div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"35\">{{ vm.dataList.unpaid_leave }}</div></div><div \nng-if=\"vm.dataList.lop!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" \nflex=\"60\">LOP</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"35\">{{ vm.dataList.lop }}</div></div><div \nng-if=\"vm.dataList.cop!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" \nflex=\"60\">COP</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"35\">{{ vm.dataList.cop }}</div></div><div \nng-if=\"vm.dataList.short_notice!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Short Notice</div><div style=\"text-align: right\" flex-order=\"5\" flex=\"35\">\n{{ vm.dataList.short_notice }}</div></div><div ng-if=\"vm.dataList.cp38!=\'0.00\'\" class=\"padd-left\" flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">CP38</div><div style=\"text-align: right\" flex-order=\"5\" \nflex=\"35\">{{ vm.dataList.cp38 }}</div></div></div></div><div style=\"float: left;width: 15%;height: 250px\"></div></div>\n<div><div style=\"float: left;width: 10%;padding-left:10px\"><div flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\" style=\"color: rgb(245,245,245)\">.</div></div></div><div style=\"float: left;width: 75%\"><div \nstyle=\"float: left;width: 50%\"><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\"><b>Total Earning</b></div><div style=\"text-align: right\" flex-order=\"5\" flex=\"25\"><b>\n{{ vm.dataList.total_earning }}</b></div></div></div><div style=\"float: left;width: 50%\"><div class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\"><b>Total Deduction</b></div><div \nstyle=\"text-align: right\" flex-order=\"5\" flex=\"35\"><b>{{ vm.dataList.total_deduction }}</b></div></div></div></div><div\n style=\"float: left;width: 15%\"><br><br></div></div><div><div style=\"float: left;width: 12.5%\"><div class=\"padd-left\" \nflex layout=\"row\" layout-align=\"start center\" style=\"border-top:2px solid black\"><div flex-order=\"4\" flex=\"60\" \nstyle=\"color: rgb(245,245,245)\">.</div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">Current Mth</div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\">\n<div flex-order=\"4\" flex=\"60\">YTD</div></div></div><div style=\"float: left;width: 12.5%\"><div class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\" \nstyle=\"border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black\"><div flex-order=\"4\" \nflex=\"60\"><b>PCB</b></div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-right:2px solid black\"><div flex-order=\"4\" flex=\"60\">{{ vm.dataList.pcb }}</div></div><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" style=\"border-right:2px solid black\"><div \nflex-order=\"4\" flex=\"60\">{{ vm.dataList.ytd_pcb }}</div></div></div><div style=\"float: left;width: 12.5%\"><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black\"><div flex-order=\"4\" \nflex=\"60\"><b>EPF ee</b></div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-right:2px solid black\"><div flex-order=\"4\" flex=\"60\">{{ vm.dataList.ee_epf }}</div></div><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" style=\"border-right:2px solid black\"><div \nflex-order=\"4\" flex=\"60\">{{ vm.dataList.ytd_ee_epf }}</div></div></div><div style=\"float: left;width: 12.5%\"><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black\"><div flex-order=\"4\" \nflex=\"60\"><b>EPF er</b></div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-right:2px solid black\"><div flex-order=\"4\" flex=\"60\">{{ vm.dataList.er_epf }}</div></div><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" style=\"border-right:2px solid black\"><div \nflex-order=\"4\" flex=\"60\">{{ vm.dataList.ytd_er_epf }}</div></div></div><div style=\"float: left;width: 12.5%\"><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black\"><div flex-order=\"4\" \nflex=\"60\"><b>SOCSO ee</b></div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-right:2px solid black\"><div flex-order=\"4\" flex=\"60\">{{ vm.dataList.ee_socso }}</div></div><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" style=\"border-right:2px solid black\"><div \nflex-order=\"4\" flex=\"60\">{{ vm.dataList.ytd_ee_socso }}</div></div></div><div style=\"float: left;width: 12.5%\"><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black\"><div flex-order=\"4\" \nflex=\"60\"><b>SOCSO er</b></div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-right:2px solid black\"><div flex-order=\"4\" flex=\"60\">{{ vm.dataList.er_socso }}</div></div><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" style=\"border-right:2px solid black\"><div \nflex-order=\"4\" flex=\"60\">{{ vm.dataList.ytd_er_socso }}</div></div></div><div style=\"float: left;width: 12.5%\"><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black\"><div flex-order=\"4\" \nflex=\"60\"><b>EIS ee</b></div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-right:2px solid black\"><div flex-order=\"4\" flex=\"60\">{{ vm.dataList.ee_eis }}</div></div><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" style=\"border-right:2px solid black\"><div \nflex-order=\"4\" flex=\"60\">{{ vm.dataList.ytd_ee_eis }}</div></div></div><div style=\"float: left;width: 12.5%\"><div \nclass=\"padd-left\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"border-top:2px solid black;border-bottom:2px solid black\"><div flex-order=\"4\" flex=\"60\"><b>EIS er</b></div>\n</div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">\n{{ vm.dataList.er_eis }}</div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"60\">{{ vm.dataList.ytd_er_eis }}</div></div></div></div><div><div style=\"float: left;width: 85%\">\n<br><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\" \nstyle=\"font-size: 10px\">ee : Employee</div></div><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\">\n<div flex-order=\"4\" flex=\"60\" style=\"font-size: 10px\">ee : Employer</div></div><br><div class=\"padd-left\" flex \nlayout=\"row\" layout-align=\"start center\"><div flex-order=\"4\" flex=\"60\">Notes:</div></div></div><div \nstyle=\"float: left;width: 15%\"><br><br><div class=\"padd-left\" flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"4\" flex=\"100\" style=\"font-size: 20px; border:2px solid black;text-align: right\"><b>\nNet Pay RM {{ vm.dataList.net_salary }}</b></div></div><br></div></div></div></md-content></div>");
$templateCache.put("app/main/payslip/paysliprki.html","<div id=\"paysliprki\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\" layout=\"column\"><div \nid=\"filter-data\" class=\"header nabati5 csm-header md-whiteframe-4dp\" layout=\"column\" flex=\"nogrow\"><div \nclass=\"header-content\" layout=\"column\" flex><div class=\"header-bottom has-selected\" layout=\"row\" flex><md-icon \nmd-font-icon=\"icon-calendar\" class=\"mr-10\"></md-icon><md-input-container flex flex-gt-sm=\"25\"><md-select \nng-model=\"vm.period\" name=\"period\" ng-change=\"vm.loadData()\"><md-option ng-repeat=\"ls in vm.listPeriod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><span flex hide show-gt-sm></span>\n<md-input-container layout=\"row\" layout-align=\"right right\"><md-button class=\"md-fab md-mini md-accent\" \nng-click=\"vm.downloadPayslip()\"><md-tooltip md-direction=\"left\">Download</md-tooltip><md-icon \nmd-font-icon=\"icon-box-download\"></md-icon></md-button></md-input-container></div></div></div><md-content \nid=\"paysliprki-content\" class=\"content padding\" flex ms-scroll><div id=\"wrapper-data\" class=\"md-whiteframe-1dp\" \nlayout=\"column\" flex><md-content class=\"white-bg p-20\"><table ms-responsive-table \nstyle=\"border: 5px solid #333; border-style: double; border-radius: 0 !important; font-size: 12pt; color: #000; width: 100%\">\n<tbody><tr style=\"font-size: 6pt\"><td colspan=\"6\" style=\"min-width: 450px\">&nbsp;</td><td style=\"width: 60px\">&nbsp;\n</td><td style=\"min-width: 150px\">&nbsp;</td><td colspan=\"4\" style=\"min-width: 226px\">&nbsp;</td></tr><tr><td \nstyle=\"min-width: 60px\">&nbsp;</td><td colspan=\"3\"><u>PRIVATE & CONFIDENTIAL</u><br>PRIBADI & RAHASIA</td><td \ncolspan=\"3\" class=\"text-center\" style=\"vertical-align: middle\"><img id=\"logo-image\" src=\"assets/images/rki.png\" \nstyle=\"height: 70px; width: auto; max-width: none\"></td><td colspan=\"4\" style=\"min-width: 250px\"><table \nstyle=\"width: 100%; font-size: 11pt\"><tbody><tr><td style=\"width: 60px\">&nbsp;</td><td width=\"60px\" \nstyle=\"vertical-align: top\">Nama</td><td width=\"10px\" style=\"vertical-align: top\">:</td><td rowspan=\"2\" \nstyle=\"vertical-align: top\">{{vm.dataList.NAME}}</td></tr><tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr><tr>\n<td>&nbsp;</td><td>NIK</td><td>:</td><td>{{vm.dataList.NIK}}</td></tr><tr><td>&nbsp;</td><td>Periode</td><td>:</td><td>\n{{vm.dataList.Period}}</td></tr></tbody></table></td><td style=\"min-width: 60px\">&nbsp;</td></tr><tr \nstyle=\"font-size: 6pt\"><td colspan=\"12\" style=\"border-bottom: 1px solid #333\">&nbsp;</td></tr><tr><td \nstyle=\"min-width: 60px\">&nbsp;</td><td colspan=\"4\" class=\"text-bold header-pd\">PENERIMAAN</td><td>&nbsp;</td><td \ncolspan=\"5\" class=\"text-bold header-pd\">PENGURANGAN</td><td style=\"min-width: 60px\">&nbsp;</td></tr><tr><td \nstyle=\"min-width: 60px\">&nbsp;</td><td style=\"min-width: 220px\">Gaji Pokok</td><td class=\"no-padding text-center\" \nwidth=\"10px\">:</td><td width=\"30px\">Rp</td><td class=\"no-padding text-right\" width=\"120px\">\n{{ vm.dataList.Basic_salary }}</td><td style=\"min-width: 60px\">&nbsp;</td><td style=\"min-width: 220px\" colspan=\"2\">\nPotongan Absensi</td><td class=\"no-padding text-center\" width=\"10px\">:</td><td width=\"30px\">Rp</td><td \nclass=\"no-padding text-right\" width=\"120px\">{{ vm.dataList.ABSENT_Deduction }}</td><td style=\"min-width: 60px\">&nbsp;\n</td></tr><tr><td>&nbsp;</td><td class=\"no-padding\">Tunjangan Golongan</td><td class=\"no-padding text-center\">:</td><td\n class=\"no-padding\">Rp</td><td class=\"no-padding text-right\">{{ vm.dataList.Management_allowance }}</td><td>&nbsp;</td>\n<td colspan=\"2\" class=\"no-padding\">Potongan Pinjaman 1</td><td class=\"no-padding text-center\">:</td><td \nclass=\"no-padding\">Rp</td><td class=\"no-padding text-right\">{{ vm.dataList.loan }}</td><td>&nbsp;</td></tr><tr><td>\n&nbsp;</td><td class=\"no-padding\">Premi</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{ vm.dataList.Premi_Attendance }}</td><td>&nbsp;</td><td colspan=\"2\" class=\"no-padding\">\nPotongan Lain Lain</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{ vm.dataList.Other_Deduction }}</td><td>&nbsp;</td></tr><tr><td>&nbsp;</td><td \nclass=\"no-padding\">Tunjangan U. Makan</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{ vm.dataList.Meal_allowance }}</td><td>&nbsp;</td><td colspan=\"2\" class=\"no-padding\">\nPotongan BPJS Kesehatan</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{ vm.dataList.EE_BPJSKes }}</td><td>&nbsp;</td></tr><tr><td>&nbsp;</td><td \nclass=\"no-padding\">Incentive</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{ vm.dataList.insentif }}</td><td>&nbsp;</td><td colspan=\"2\" class=\"no-padding\">\nPotongan Jamsostek</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{ vm.dataList.EE_BPJSTK }}</td><td>&nbsp;</td></tr><tr><td>&nbsp;</td><td \nclass=\"no-padding\">Pendapatan Lain-lain</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{ vm.dataList.Other_Allowance }}</td><td colspan=\"7\">&nbsp;</td></tr><tr><td>&nbsp;</td>\n<td class=\"no-padding\">Lembur</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{ vm.dataList.OT }}</td><td colspan=\"7\">&nbsp;</td></tr><tr><td>&nbsp;</td><td \nclass=\"no-padding\">THR</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{ vm.dataList.thr }}</td><td colspan=\"7\">&nbsp;</td></tr><tr><td colspan=\"12\">&nbsp;\n</td></tr><tr><td colspan=\"3\"></td><td colspan=\"2\" style=\"border-bottom: 1px solid #333\"></td><td colspan=\"4\"></td><td \ncolspan=\"2\" style=\"border-bottom: 1px solid #333\"></td><td></td></tr><tr><td>&nbsp;</td><td class=\"no-padding\">\nTotal Penerimaan</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{vm.dataList.total_income}}</td><td>&nbsp;</td><td colspan=\"2\" class=\"no-padding\">\nTotal Potongan</td><td class=\"no-padding text-center\">:</td><td class=\"no-padding\">Rp</td><td \nclass=\"no-padding text-right\">{{vm.dataList.total_deduction}}</td><td>&nbsp;</td></tr><tr><td colspan=\"3\"></td><td \ncolspan=\"2\" style=\"border-top: 5px solid #333; border-top-style: double\"></td><td colspan=\"4\"></td><td colspan=\"2\" \nstyle=\"border-top: 5px solid #333; border-top-style: double\"></td><td></td></tr><tr><td colspan=\"12\">&nbsp;</td></tr>\n<tr id=\"footer-area\" style=\"font-size: 14pt\"><td>&nbsp;</td><td class=\"no-padding text-bold\">Take Home Pay</td><td \nclass=\"no-padding text-bold text-center\">:</td><td class=\"no-padding text-bold\">Rp</td><td \nclass=\"no-padding text-bold text-right\">{{vm.dataList.TOTAL}}</td><td colspan=\"7\">&nbsp;</td></tr><tr><td colspan=\"12\">\n&nbsp;</td></tr><tr><td colspan=\"12\">&nbsp;</td></tr></tbody></table></md-content></div></md-content></div>");
$templateCache.put("app/main/production-handover-gw/handover-gw.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding content-wrapper\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex \nclass=\"logo-text\">{{ \'MENU.MAIN.PRODUCTIONHANDOVERGW\' | translate}}</div></div></md-subheader><div class=\"white-bg\">\n<md-content class=\"filter-form\" layout-padding><form name=\"userForm\"><div layout-gt-xs=\"row\"><md-input-container>\n<label>Training Date</label><input type=\"date\" ng-model=\"vm.trainingDate\"></md-input-container><md-input-container>\n<md-select ng-model=\"vm.hasSetSector\" name=\"hasSetSector\" aria-label=\"hasSetSector\" required><md-option \nng-repeat=\"ls in vm.hasSetSectorList track by $index\" placeholder=\"Sector\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"formInputOT.hasSetSector.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>This field is required.</span></div></div></md-input-container><md-button ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-primary\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button ng-disabled=\"vm.selected.length == 0\" \nclass=\"md-primary md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.handover($event, vm.selected, false, false)\"><md-icon style=\"font-size:16px\" \nmd-font-icon=\"icon-debug-step-over\"></md-icon><span translate=\"PRODHANDOVERGW.LABEL.PROCESSBYSELECTEDITEM\"></span>\n<md-tooltip><span translate=\"PRODHANDOVERGW.LABEL.PROCESSBYSELECTEDITEM\"></span></md-tooltip></md-button><md-button \nng-disabled=\"vm.selected.length >0\" class=\"md-primary md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.handover($event, vm.selected, true, false)\"><md-icon style=\"font-size:16px\" \nmd-font-icon=\"icon-debug-step-over\"></md-icon><span translate=\"PRODHANDOVERGW.LABEL.PROCESSBYAMOUNT\"></span>\n<md-tooltip><span translate=\"PRODHANDOVERGW.LABEL.PROCESSBYAMOUNT\"></span></md-tooltip></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\">\n</ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><div \nclass=\"table-container-content\"><table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" \nms-responsive-table><thead><tr><th><div flex layout-align=\"center\" layout=\"row\"><input type=\"checkbox\" \nng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></div></th><th>No</th>\n<th>NIK</th><th>Name</th><th>Atasan</th><th>Gedung</th><th>Sector</th><th>Shift Group</th><th class=\"action-table\">\nAction</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTables.list\"><td><div flex layout-align=\"center\" \nlayout=\"row\"><input ng-if=\"item.hr_completion==\'0\'\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\" type=\"checkbox\"></div></td><td class=\"text-center\">{{ $index + 1}}</td><td \nclass=\"text-center\">{{ item.nik }}</td><td class=\"text-center\">{{ item.name | uppercase }}</td><td class=\"\">\n{{ item.atasan | uppercase }}</td><td class=\"text-center\">{{ item.gedung_name }}</td><td class=\"text-center\">\n{{ item.sector_name }}</td><td class=\"text-center\">{{ item.shift_group_name }}</td><td class=\"action-table\"><div \nlayout=\"row\" layout-align=\"center\"><md-button ng-disabled=\"item.hr_completion==\'1\'\" class=\"md-primary md-small\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.handover($event, item, false,true)\"><md-icon \nstyle=\"font-size:16px\" md-font-icon=\"icon-debug-step-over\"></md-icon><span translate=\"PRODHANDOVERGW.LABEL.PROCESS\">\n</span><md-tooltip><span translate=\"PRODHANDOVERGW.LABEL.PROCESS\"></span></md-tooltip></md-button></div></td></tr>\n</tbody></table></div><div ng-if=\"vm.DataTables.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/production-handover-gw/handover.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll flex=\"30\"><form ng-cloak name=\"formReschedule\" \nclass=\"md-inline-form\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><h4><span \ntranslate=\"PRODHANDOVERGW.LABEL.PROCESS\"></span></h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"margin-top:0px\"><div layout=\"column\" flex layout-padding><md-input-container \nng-if=\"vm.isNumber\" layout=\"row\" flex><label><span translate=\"PRODHANDOVERGW.LABEL.AMOUNT\"></span></label><input \nrequired name=\"amount\" min=\"1\" ng-model=\"vm.Form.objForm.limit\" type=\"number\"></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.Form.objForm.sector\" name=\"sector\" ng-change=\"vm.setLine(vm.Form.objForm.sector)\" \naria-label=\"Sector\" required><md-option ng-repeat=\"ls in vm.listSector track by $index\" placeholder=\"Sector\" \nvalue=\"{{ls.id}}\">{{ls.sector_name}}</md-option></md-select><div ng-messages=\"formInputOT.sector.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Sector is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.Form.objForm.shift_group\" name=\"shift_group\" aria-label=\"Shift Group\" required><md-option \nng-repeat=\"ls in vm.listShiftGroup track by $index\" placeholder=\"Shift Group\" value=\"{{ls.id}}\">{{ls.name}}</md-option>\n</md-select><div ng-messages=\"formInputOT.shift_group.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nShift Group is required.</span></div></div></md-input-container><md-input-container flex><label>Atasan</label>\n<md-autocomplete md-no-cache=\"true\" required md-selected-item=\"vm.atasan\" \nstyle=\"margin-top: 15px; background: transparent;border-bottom: 2px dotted #8f8383\" md-search-text=\"searchText\" \nmd-items=\"item in vm.loadAtasan(searchText)\" md-item-text=\"item.nik + \' - \' + item.name\" ng-model=\"vm.atasan\">\n<md-item-template><span md-highlight-text=\"searchText\">{{item.nik + \' - \' + item.name}}</span></md-item-template>\n</md-autocomplete></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" flex><div \nlayout-align=\"start center\" flex class=\"form-message\" ng-class=\"{success:vm.success, error:!vm.success}\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{ vm.Form.pesan }}</div><div flex=\"40\" layout-align=\"end center\" \nlayout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.submit(formReschedule,vm.isNumber)\" \nng-disabled=\"formReschedule.$invalid || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Submit</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/production-handover-gw/reschedule.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll flex=\"50\"><form ng-cloak name=\"formReschedule\" \nclass=\"md-inline-form\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><h4>Reschedule</h4><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"margin-top:0px\"><div \nlayout=\"column\" flex layout-padding><md-input-container layout=\"row\" class=\"md-block\" flex><label>Reschedule Date\n</label><input required name=\"date\" ng-model=\"vm.tempDate\" type=\"date\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" flex><div layout-align=\"start center\" flex class=\"form-message\" \nng-class=\"{success:vm.success, error:!vm.success}\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{ vm.Form.pesan }}</div>\n<div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.submit(formReschedule)\" ng-disabled=\"formReschedule.$invalid || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/ref-bank/ref-bank-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.BANKMANAGEMENT\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.Form.objForm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" required md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.country.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"KPI.LABEL.BANKCODE\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.bank_code\" \nname=\"bank_code\" required><div ng-messages=\"frmBT.bank_code.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.BANKCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.BANKNAME\"></label><input \ntype=\"text\" ng-model=\"vm.Form.objForm.bank_name\" name=\"bank_name\" required><div ng-messages=\"frmBT.bank_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.BANKNAME\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/ref-bank/ref-bank.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.BANKMANAGEMENT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.BANKCODE\"></label><input type=\"text\" ng-model=\"vm.bank_code\" name=\"bank_code\">\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.BANKNAME\"></label><input \ntype=\"text\" ng-model=\"vm.bank_name\" name=\"bank_name\"></md-input-container><md-input-container flex=\"nogrow\"><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span></md-button></md-input-container>\n</div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><select \nstyle=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span><span translate=\"PAYROLL.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NO\"></span></span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.BANKCODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.BANKNAME\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr ng-dblclick=\"vm.editData($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n<md-checkbox aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.bank_code}}</td><td class=\"\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.bank_name}}</td><td class=\"text-center\"><section \nlayout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/ref-master-sku/ref-master-sku.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.MASTERSKU\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label><span translate=\"PAYROLL.MENU.CODE\"></span> / <span translate=\"KPI.LABEL.NAME\"></span></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.id\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getSKU(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.id\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.id)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\"></span>\n / <span translate=\"KPI.LABEL.NAME\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button\n type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon\n hide class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \naria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Upload</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div\n class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th width=\"5%\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.CODE\"></span>/<span \ntranslate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.CATEGORY\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.MARK\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.PCS\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.CRT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.ISI\"></span></span></th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTables.list\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.selected\" checklist-value=\"item\"></td><td \nclass=\"text-center\">{{item.no}}</td><td class=\"\">{{item.sku_code}} / {{item.sku_name}}</td><td class=\"text-left\">\n{{item.category}}</td><td class=\"text-center\">{{item.mark}}</td><td class=\"text-right\">{{item.crt}}</td><td \nclass=\"text-right\">{{item.pcs}}</td><td class=\"text-right\">{{item.isi}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/ref-master-sku/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.upload()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ref-sales-type/ref-sales-type-edit.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.SALESTYPE\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\">\n</label><md-select ng-model=\"vm.Form.objForm.channel\" name=\"channel\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select ng-model=\"vm.Form.objForm.ref_schema_object_id\" \nname=\"ref_schema_object_id\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeObject\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select ng-model=\"vm.Form.objForm.scheme_type\" name=\"scheme_type\" \nng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeType\">{{ls.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.CODE\">\n</label><input type=\"text\" ng-model=\"vm.Form.objForm.type_code_edit\" name=\"type_code\" required><div \nng-messages=\"frmBT.type_code.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"KPI.LABEL.NAME\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.type_name\" \nname=\"type_name\" required><div ng-messages=\"frmBT.type_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NAME\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container>\n<md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.DESCRIPTION\"></label><input type=\"text\" \nng-model=\"vm.Form.objForm.description\" name=\"description\" required><div ng-messages=\"frmBT.description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/ref-sales-type/ref-sales-type-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.SALESTYPE\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.CHANNEL\">\n</label><md-select ng-model=\"vm.Form.objForm.channel\" name=\"channel\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select ng-model=\"vm.Form.objForm.ref_schema_object_id\" \nname=\"ref_schema_object_id\" ng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeObject\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select ng-model=\"vm.Form.objForm.scheme_type\" name=\"scheme_type\" \nng-required=\"true\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeType\">{{ls.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.CODE\">\n</label><input type=\"text\" ng-model=\"vm.Form.objForm.type_code\" name=\"type_code\" required><div \nng-messages=\"frmBT.type_code.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"KPI.LABEL.NAME\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.type_name\" \nname=\"type_name\" required><div ng-messages=\"frmBT.type_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NAME\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container>\n<md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.DESCRIPTION\"></label><input type=\"text\" \nng-model=\"vm.Form.objForm.description\" name=\"description\" required><div ng-messages=\"frmBT.description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/ref-sales-type/ref-sales-type.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SALESTYPE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label \ntranslate=\"KPI.LABEL.CHANNEL\"></label><md-select ng-model=\"vm.channel\" name=\"channel\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listChannel\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.SCHEMEOBJECT\"></label><md-select ng-model=\"vm.ref_schema_object_id\" \nname=\"ref_schema_object_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeObject\">{{ls.name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.SCHEMETYPE\"></label><md-select \nng-model=\"vm.scheme_type\" name=\"scheme_type\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSchemeType\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex=\"20\"><label \ntranslate=\"PAYROLL.MENU.CODE\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.id\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getDataCode(vm.searchString)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.id\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.id)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.CHANNEL\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SCHEMEOBJECT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SCHEMETYPE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.CODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.DESCRIPTION\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr ng-dblclick=\"vm.editData($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n<md-checkbox aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.channel}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.schema_object}}</td><td class=\"text-center\"><md-tooltip>\n<span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.schema_type}}</td><td class=\"text-center\">\n<md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.type_code}}</td><td class=\"\"><md-tooltip>\n<span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.type_name}}</td><td class=\"\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.description}}</td><td class=\"text-center\"><section \nlayout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/ref-sales-code/ref-sales-code-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.SALESCODE\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"PAYROLL.MENU.CODE\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.salescode\" name=\"code\" required><div\n ng-messages=\"frmBT.code.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"PAYROLL.MENU.SALESBEHAVIOUR\"></label><md-select \nng-model=\"vm.Form.objForm.sales_behaviour\" name=\"sales_behaviour\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sales code...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"sales_behaviour\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesBehaviour | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"frmBT.sales_behaviour.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.SALESBEHAVIOUR\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"PAYROLL.MENU.DESCRIPTION\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.description\" \nname=\"description\" required><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label translate=\"MENU.MAIN.SALESTYPE\"></label>\n<md-select ng-model=\"vm.Form.objForm.ref_sales_type_id\" name=\"ref_sales_type_id\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sales type...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"ref_sales_type_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSalesType | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"KPI.LABEL.AREA\"></label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" \nng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"area_sales_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"KPI.LABEL.DIVISION\"></label><md-select \nng-model=\"vm.Form.objForm.ref_master_divisi_id\" name=\"ref_master_divisi_id\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"ref_master_divisi_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/ref-sales-code/ref-sales-code.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SALESCODE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"PAYROLL.MENU.CODE\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.id\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getDataCode(vm.searchString)\" md-item-text=\"item.name\" ng-model=\"vm.Form.objForm.id\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.id)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.name}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.MAIN.SALESTYPE\"></label><md-select ng-model=\"vm.Form.objForm.ref_sales_type_id\" \nname=\"ref_sales_type_id\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sales type...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"ref_sales_type_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSalesType | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"KPI.LABEL.AREA\"></label><md-select \nng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"area_sales_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span><span translate=\"PAYROLL.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" \nhide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload\n</md-tooltip><md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>Upload\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nwidth=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.CODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.DIVISION\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.SALESBEHAVIOUR\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.SALESTYPE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.AREA\"></span></span></th><th width=\"5%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.sales_code}}</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.divisi_name}}</td><td\n class=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.sales_behaviour}}\n</td><td class=\"\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.description}}</td><td \nclass=\"\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.sales_type}}</td><td class=\"\">\n<md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.area_sales}}</td><td class=\"text-center\">\n<section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/ref-sales-code/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ref-subdis/ref-subdis-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.REFSUBDIS\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.MAIN.COMPANYNAME\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.company_name\" \nname=\"company_name\" required><div ng-messages=\"frmBT.company_name.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"MENU.MAIN.COMPANYNAME\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.ADDRESS\"></label><input \ntype=\"text\" ng-model=\"vm.Form.objForm.address\" name=\"address\" required><div ng-messages=\"frmBT.address.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ADDRESS\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label translate=\"MENU.MAIN.CONTACT\"></label><input type=\"text\" ng-model=\"vm.Form.objForm.contact\" name=\"contact\" \nrequired><div ng-messages=\"frmBT.contact.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.CONTACT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/ref-subdis/ref-subdis.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.REFSUBDIS\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" \nhide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload\n</md-tooltip><md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>Upload\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nwidth=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.COMPANYNAME\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.ADDRESS\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.CONTACT\"></span></span></th><th width=\"5%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{$index+1}}</td><td \nclass=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.company_name}}</td>\n<td class=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.address}}</td><td\n class=\"\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.contact}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/ref-subdis/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/report/report.html","<div layout=\"column\" layout-padding layout-align=\"center center\" id=\"report\" ui-view=\"report\"></div>");
$templateCache.put("app/main/training-gw/traininggwlist.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Training Score</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\">\n<md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Division\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\" ng-change=\"vm.loadBt(vm.department)\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.btcode\" name=\"businessTitle\"><md-option placeholder=\"Business Title\" ng-repeat=\"ls in vm.listBt\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\" \nclass=\"mt-40\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>Start Training Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" md-placeholder=\"Start Training Date\" name=\"tglmulai\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>End Training Date\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" md-placeholder=\"End Training Date\" \nname=\"tglakhir\"></md-datepicker></md-input-container><md-input-container flex-gt-sm=\"20\" flex><md-select \nng-model=\"vm.status\" name=\"status\"><md-option placeholder=\"Status\" ng-repeat=\"ls in vm.listStatus\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" \ntype=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" layout-align=\"end center\">Submit</md-button>\n</div></form></div></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear><div class=\"md-toolbar-tools table-tools\" layout-align=\"start center\">\n<md-input-container><input type=\"file\" id=\"uploadPhoto\" name=\"fileupload\" nv-file-select=\"\" \nuploader=\"vm.FileUploaderPhoto\" options=\"{ formData: [{action:\'uploadScore\'}]}\"><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload File</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload File</span></md-whiteframe></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n class=\"secondary-text\">Entries</span></md-input-container><md-button \nclass=\"md-raised reference-button md-primary md-hue-2\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span>Upload Training Score</span></md-button><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-click=\"vm.exportToExcel($event)\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span>Download Training List</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>NIK</th><th>\nNAME</th><th>DIVISION</th><th>DEPARTMENT</th><th>BUSINESS TITLE</th><th>EDUCATION</th><th>MAJOR</th><th>TRAINING DATE\n</th><th>PSIKOTEST SCORE</th><th>PRE SCORE</th><th>POST SCORE</th><th>TRAINING RATE</th><th>SKIP TRAINING</th><th>\nSKIP TO</th><th>UPLOAD BY</th><th>TIMESTAMP</th><th>STATUS</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td>{{ ls.nik }}</td><td>{{ ls.nama }}</td><td>\n{{ ls.division }}</td><td>{{ ls.department }}</td><td>{{ ls.businessTitle }}</td><td>{{ ls.tingkatPendidikan }}</td>\n<td>{{ ls.jurusan }}</td><td>{{ ls.trainingDate}}</td><td>{{ ls.score_test }}</td><td>{{ ls.score }}</td><td>\n{{ ls.post_score }}</td><td>{{ ls.training_rate }}</td><td>{{ ls.skip_training }}</td><td>{{ ls.skip_training_date }}\n</td><td>{{ ls.upload_by }}</td><td>{{ ls.timestamp }}</td><td>{{ ls.STATUS }}</td></tr></tbody></table><div \nclass=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/umut-history/umut-history-detail-date.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-500-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"UMUT.MENU.DETAILWORKINGDATE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead>\n<tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.DATE\"></span></span></th><th width=\"5%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.ISWORKING\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NOTE\"></span></span></th></tr></thead><tbody>\n<tr class=\"md-table-content-row\" ng-repeat=\"item in vm.listData | filter : vm.searchTerm\"><td \nng-if=\"item.is_working==0\" class=\"text-center md-red-300-bg\" style=\"color: #e6eff7\">{{($index + 1)}}</td><td \nng-if=\"item.is_working==1\" class=\"text-center\">{{($index + 1)}}</td><td ng-if=\"item.is_working==0\" \nclass=\"text-center md-red-300-bg\" style=\"color: #e6eff7\">{{item.date}}</td><td ng-if=\"item.is_working==1\" \nclass=\"text-center\">{{item.date}}</td><td ng-if=\"item.is_working==0\" class=\"text-center md-red-300-bg\" \nstyle=\"color: #e6eff7\"><span ng-if=\"item.is_working==1\" translate=\"UMUT.MENU.YES\"></span> <span \nng-if=\"item.is_working==0\" translate=\"UMUT.MENU.NOT\"></span></td><td ng-if=\"item.is_working==1\" class=\"text-center\">\n<span ng-if=\"item.is_working==1\" translate=\"UMUT.MENU.YES\"></span> <span ng-if=\"item.is_working==0\" \ntranslate=\"UMUT.MENU.NOT\"></span></td><td ng-if=\"item.is_working==0\" class=\"md-red-300-bg\" style=\"color: #e6eff7\">\n{{item.note}}</td><td ng-if=\"item.is_working==1\" class=\"\">{{item.note}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.listData.length <= 0\"><td colspan=\"13\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"UMUT.MENU.CLOSE\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/umut-history/umut-history.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.UMUTHISTORY\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.loadData()\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Sub-Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub-Period is required.</span></div></div></md-input-container></div><md-button \ntype=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-filter\" style=\"font-size: 15px\"></i>\n Filter</md-button></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><select \nstyle=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span flex hide show-gt-sm>\n</span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\">\n<span translate=\"UMUT.MENU.NO\"></span></span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PERIOD\"></span></span></th><th width=\"5%\" class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.SUBPERIOD\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.REALWORKINGDAY\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UM\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UMVAL\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UTVAL\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UMM\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.BBM2LT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.SEWAMOTOR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PAKETLEMBUR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PAKETLUARKOTA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.KOMISI\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.TOTAL\"></span></span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.ACTION\"></span></span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\">{{item.no}}</td><td class=\"text-center\">\n{{item.period_label}}</td><td class=\"text-center\">{{item.sub_period}}</td><td class=\"text-center\">\n{{item.real_work_day}} <span translate=\"UMUT.MENU.DAY\"></span></td><td class=\"text-right\">{{item.um}}</td><td \nclass=\"text-right\">{{item.um_val}}</td><td class=\"text-right\">{{item.ut}}</td><td class=\"text-right\">{{item.ut_val}}\n</td><td class=\"text-right\">{{item.umm}}</td><td class=\"text-right\">{{item.bbm2lt}}</td><td class=\"text-right\">\n{{item.sewa_motor}}</td><td class=\"text-right\">{{item.paket_lembur}}</td><td class=\"text-right\">\n{{item.paket_luar_kota}}</td><td class=\"text-right\">{{item.komisi}}</td><td class=\"text-right\">{{item.total}}</td><td \nclass=\"text-center\"><md-button type=\"button\" ng-click=\"vm.detail($event,item)\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" aria-label=\"Detail\"><i class=\"icon icon-eye\" \nstyle=\"font-size: 15px\"></i> Detail</md-button></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"15\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/umut-log/umutlog.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Log UM-UT</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExporttoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Division</label><md-select ng-model=\"vm.division\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub division...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download</md-button>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/umut-process/new-umut-process.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"UMUT.MENU.UMUTPROCESS\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Month</label><md-select ng-model=\"vm.period\" name=\"period\" required>\n<md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Month is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Period</label><md-select ng-model=\"vm.subperiod\" \nname=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option>\n</md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPeriod is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Division</label><md-select ng-model=\"vm.division\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub division...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.saveData($event,basicForm)\" \nclass=\"md-primary md-hue-1\" aria-label=\"SUBMIT\"><span translate=\"ACTION.SUBMIT\"></span></md-button><md-button \nng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span><span translate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/umut-process/umut-process-detail-date.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-500-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"UMUT.MENU.DETAILWORKINGDATE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><p>{{ vm.nik}} : {{ vm.name}}</p><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\">\n<span translate=\"UMUT.MENU.NO\"></span></span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.DATE\"></span></span></th><th width=\"5%\" class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.ISWORKING\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NOTE\"></span></span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.listData | filter : vm.searchTerm\"><td ng-if=\"item.is_working==0\" \nclass=\"text-center md-red-300-bg\" style=\"color: #e6eff7\">{{($index + 1)}}</td><td ng-if=\"item.is_working==1\" \nclass=\"text-center\">{{($index + 1)}}</td><td ng-if=\"item.is_working==0\" class=\"text-center md-red-300-bg\" \nstyle=\"color: #e6eff7\">{{item.date}}</td><td ng-if=\"item.is_working==1\" class=\"text-center\">{{item.date}}</td><td \nng-if=\"item.is_working==0\" class=\"text-center md-red-300-bg\" style=\"color: #e6eff7\"><span ng-if=\"item.is_working==1\" \ntranslate=\"UMUT.MENU.YES\"></span> <span ng-if=\"item.is_working==0\" translate=\"UMUT.MENU.NOT\"></span></td><td \nng-if=\"item.is_working==1\" class=\"text-center\"><span ng-if=\"item.is_working==1\" translate=\"UMUT.MENU.YES\"></span> <span\n ng-if=\"item.is_working==0\" translate=\"UMUT.MENU.NOT\"></span></td><td ng-if=\"item.is_working==0\" class=\"md-red-300-bg\" \nstyle=\"color: #e6eff7\">{{item.note}}</td><td ng-if=\"item.is_working==1\" class=\"\">{{item.note}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.listData.length <= 0\"><td colspan=\"13\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"UMUT.MENU.CLOSE\">Close</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/umut-process/umut-process-detail.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"UMUT.MENU.DETAIL\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead>\n<tr><th width=\"5%\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NIK\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.JOBTITLE\"></span></span></th><th width=\"5%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.GRADE\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.ACTION\"></span></span></th></tr></thead>\n<tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.listData | filter : vm.searchTerm\"><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.nik}}</td><td class=\"\">{{item.name}}</td><td \nclass=\"\">{{item.job_title}}</td><td class=\"text-center\">{{item.grade}}</td><td class=\"text-center\"><md-button \ntype=\"button\" style=\"color: rgb(27, 181, 0)\" ng-click=\"vm.detail($event,item)\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" aria-label=\"Detail\"><i class=\"icon icon-eye\" \nstyle=\"font-size: 15px;color: rgb(27, 181, 0)\"></i> <span translate=\"UMUT.MENU.DETAILWORKINGDATE\"></span></md-button>\n<md-button type=\"button\" ng-if=\"item.is_current_period==\'1\'\" ng-click=\"vm.reProcess($event,item)\" \nstyle=\"color: rgb(0, 42, 255)\" class=\"md-button md-ink-ripple md-mini\" aria-label=\"Detail\"><i \nclass=\"icon icon-refresh\" style=\"font-size: 15px;color: rgb(0, 42, 255)\"></i> <span translate=\"UMUT.MENU.REPROCESS\">\n</span></md-button></td></tr><tr class=\"text-center\" ng-if=\"vm.listData.length <= 0\"><td colspan=\"13\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"UMUT.MENU.CLOSE\">\nClose</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/umut-process/umut-process.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"UMUT.MENU.UMUTPROCESS\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.loadData()\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Division</label><md-select ng-model=\"vm.division\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub division...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-filter\" style=\"font-size: 15px\"></i>\n Filter</md-button></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><select \nstyle=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.newProcess($event)\"><md-icon md-font-icon=\"icon-pencil\" \nstyle=\"font-size: 15px\"></md-icon><span><span translate=\"UMUT.MENU.NEW\"></span></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-collapse=\"collapseData()\" on-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" \ndebounce=\"300\"></ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"\" ng-click=\"vm.upload(ev)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span translate=\"UMUT.MENU.UPLOAD\"></span></md-button></md-menu-item>\n<md-menu-item><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">\nUn-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"2%\"><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"></md-checkbox></th><th \nwidth=\"5%\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.STARTDATE\"></span></span></th><th \nwidth=\"10%\" class=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.ENDDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.AREA\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.PROCESSEDBY\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.REMARK\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.ACTION\"></span></span></th></tr></thead>\n<tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox \nng-if=\"item.is_current_period==\'1\'\" aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td \nclass=\"text-center\">{{item.start_date}}</td><td class=\"text-center\">{{item.end_date}}</td><td class=\"\">{{item.area}}\n</td><td class=\"text-center\">{{item.commited_by}}</td><td class=\"\">{{item.remarks}}</td><td class=\"text-center\">\n<md-button type=\"button\" ng-click=\"vm.detail($event,item)\" class=\"md-button md-ink-ripple md-primary md-mini\" \naria-label=\"Detail\"><i class=\"icon icon-eye\" style=\"font-size: 15px\"></i> Detail</md-button></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"13\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/umut-report/umutreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">UM-UT Report</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExporttoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Division</label><md-select ng-model=\"vm.division\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub division...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download</md-button>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/umut-transfer/umuttransfer.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">UM-UT Transfer</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExporttoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Division</label><md-select ng-model=\"vm.division\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub division...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download</md-button>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/uploadadditionalinsentif/upload-data.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ADDITIONALINSENTIF\"></span></md-subheader><div class=\"white-bg\"><md-content\n class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.loadData(1)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Division</label><md-select ng-model=\"vm.division\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub division...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-search\"></i> Search</md-button></form>\n</div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide \nshow-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">\n&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button\n class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span><span translate=\"UMUT.MENU.UPLOAD\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-collapse=\"collapseData()\" on-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" \ndebounce=\"300\"></ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"\" ng-click=\"vm.upload(ev)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span translate=\"UMUT.MENU.UPLOAD\"></span></md-button></md-menu-item>\n<md-menu-item><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">\nUn-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon>\n</span></th><th width=\"5%\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NAME\"></span></span></th><th class=\"\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.JOBTITLE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span>Month</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.PERIOD\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.INSENTIF\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.UPLOADEDBY\"></span></span></th><th width=\"20%\" class=\"text-center\"><span class=\"column-title\">\n<span translate=\"UMUT.MENU.STATUS\"></span></span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox ng-if=\"item.is_has_approved==\'0\'\" aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"\">{{item.nik}}/{{item.name}}</td><td class=\"\">\n{{item.job_title_name}}</td><td class=\"text-center\">{{item.period}}</td><td class=\"\">{{item.subPeriod}}</td><td \nclass=\"\">{{item.area}}</td><td class=\"text-center\">{{item.insentif | currency:\"\"}}</td><td class=\"text-center\"><span>\n{{item.created_by}}/{{item.created_name}}</span></td><td class=\"text-center\"><span ng-if=\"item.approval_status!==\'4\'\">\n{{item.app}}</span> <span ng-if=\"item.approval_status==\'4\'\"><a href=\"\" ng-click=\"vm.viewComment($event,item)\">\n{{item.app}}</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"11\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/uploadadditionalinsentif/upload-form.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.ADDITIONALINSENTIF\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset><legend><span translate=\"MENU.MAIN.ADDITIONALINSENTIF\"></span> - <span\n translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFile\" nv-file-select \nuploader=\"vm.FileUploader\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUploader.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-primary md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/uploadadditionalumut/change-area.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"30\" flex-gt-md=\"20\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"UMUT.MENU.CHANGEAREA\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Area</label><md-select ng-model=\"vm.area\" name=\"area\" \nng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button \ntype=\"button\" ng-click=\"vm.changeArea($event,basicForm)\" class=\"md-primary md-hue-1\" aria-label=\"SUBMIT\"><span \ntranslate=\"ACTION.SUBMIT\"></span></md-button><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" \nng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/uploadadditionalumut/upload-data.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ADDITIONALUMUT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.loadData(1)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Month</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth is required.</span></div></div></md-input-container><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.subperiod\" name=\"subperiod\" required><md-option ng-repeat=\"ls in vm.listsubperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.subperiod.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Division</label><md-select ng-model=\"vm.division\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub division...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tgl\" \nplaceholder=\"Date\" name=\"tgl\"></md-datepicker></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-search\"></i> Search</md-button></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span><span translate=\"UMUT.MENU.UPLOAD\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-collapse=\"collapseData()\" on-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" \ndebounce=\"300\"></ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"\" ng-click=\"vm.upload(ev)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span translate=\"UMUT.MENU.UPLOAD\"></span></md-button></md-menu-item>\n<md-menu-item><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">\nUn-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon>\n</span></th><th width=\"5%\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.JOBTITLE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.DATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.AREA\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.UMM\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.BBM2LT\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.SEWAMOTOR\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.PAKETLEMBUR\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.PAKETLUARKOTA\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.KOMISI\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.RAPEL\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.UPLOADEDBY\"></span></span></th><th \nwidth=\"20%\" class=\"text-center\"><span class=\"column-title\"><span translate=\"UMUT.MENU.STATUS\"></span></span></th></tr>\n</thead><tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox \nng-if=\"item.is_has_approved==\'0\'\" aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"\">\n{{item.nik}}/{{item.name}}</td><td class=\"\">{{item.job_title_name}}</td><td class=\"\">{{item.tanggal}}</td><td class=\"\">\n<span ng-if=\"item.is_has_approved!=\'0\'\">{{item.area}}</span> <span ng-if=\"item.is_has_approved==\'0\'\"><a href=\"#0\" \nng-click=\"vm.changeArea($event,item)\">{{item.area}}</a></span></td><td class=\"\">{{item.umm | currency:\"\"}}</td><td \nclass=\"text-right\">{{item.bbm2lt | currency:\"\"}}</td><td class=\"text-right\">{{item.sewa_motor | currency:\"\"}}</td><td \nclass=\"text-right\"><span>{{item.paket_lembur | currency:\"\"}}</span></td><td class=\"text-right\"><span>\n{{item.paket_luar_kota | currency:\"\"}}</span></td><td class=\"text-right\"><span>{{item.komisi | currency:\"\"}}</span>\n</td><td class=\"text-right\"><span>{{item.rapel | currency:\"\"}}</span></td><td class=\"text-center\"><span>\n{{item.created_by}}/{{item.created_name}}</span></td><td class=\"text-center\"><span ng-if=\"item.approval_status!==\'4\'\">\n{{item.app}}</span> <span ng-if=\"item.approval_status==\'4\'\"><a href=\"\" ng-click=\"vm.viewComment($event,item)\">\n{{item.app}}</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"15\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/uploadadditionalumut/upload-form.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.ADDITIONALUMUT\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset><legend><span translate=\"MENU.MAIN.ADDITIONALUMUT\"></span> - <span \ntranslate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFile\" nv-file-select \nuploader=\"vm.FileUploader\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUploader.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-primary md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/uploadwfhumut/upload-form.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.EMPWFH\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset><legend><span translate=\"MENU.MAIN.EMPWFH\"></span> - <span \ntranslate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFile\" nv-file-select \nuploader=\"vm.FileUploader\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUploader.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-primary md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/uploadwfhumut/uploadwfhumut.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EMPWFH\"></span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.loadData(1)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.startDate\" placeholder=\"{{ \'KPI.LABEL.STARTDATE\' | translate}}\" name=\"startDate\"></md-datepicker>\n</md-input-container><md-input-container flex><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.endDate\" \nplaceholder=\"{{ \'KPI.LABEL.ENDDATE\' | translate}}\" name=\"startDate\"></md-datepicker></md-input-container>\n<md-input-container flex><label>Company</label><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadArea(vm.company)\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany is required.</span></div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-search\"></i> Search</md-button></form>\n</div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide \nshow-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">\n&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button\n class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span><span translate=\"UMUT.MENU.UPLOAD\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-collapse=\"collapseData()\" on-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" \ndebounce=\"300\"></ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"\" ng-click=\"vm.upload(ev)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span translate=\"UMUT.MENU.UPLOAD\"></span></md-button></md-menu-item>\n<md-menu-item><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">\nUn-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon>\n</span></th><th width=\"5%\"><span class=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th class=\"\">\n<span class=\"column-title\"><span translate=\"UMUT.MENU.NAME\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.DATE\"></span></span></th><th class=\"\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.AREA\"></span></span></th><th class=\"\"><span class=\"column-title\"><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.REASON\"></span></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"\">{{item.nik}}/{{item.name}}</td><td class=\"text-center\">\n{{item.date | date : \"dd MMMM y\"}}</td><td class=\"\">{{item.area}}</td><td class=\"\">{{item.reason}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"15\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/wfh-report-health/wfh-report-health.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.REPORTHEALTH\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadArea(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"{{ \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"{{ \'PAYROLL.MENU.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"{{ \'PAYROLL.MENU.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option ng-value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.HEALTHSTATUS\"></label>\n<md-select multiple=\"true\" ng-model=\"vm.status\" name=\"status\" ng-change=\"vm.selectStatus(vm.status)\"><md-option \nng-repeat=\"ls in vm.listStatus\" placeholder=\"{{ \'PAYROLL.MENU.HEALTHSTATUS\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" md-max-date=\"vm.end_date\" \nname=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.ENDDATE\">\n</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\">\n</md-datepicker><div ng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label>NIK</label><md-chips ng-model=\"vm.selectedDatas\" \nmd-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"vm.autocompleteDemoRequireMatch\" \ninput-aria-label=\"\"><md-autocomplete \nstyle=\"background: transparent;\n                              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><md-chip-template>\n<span>{{$chip.fullname}}</span></md-chip-template></md-chips><div ng-messages=\"frmBT.product.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div>\n</div></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\"><md-input-container layout=\"column\" \nstyle=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container>\n<md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button \naria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.DownloadEmployee(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno, vm.wilayah, vm.regional, vm.cabang)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span>\n</md-tooltip><md-icon md-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></md-input-container></div></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered\" ms-responsive-table><thead><tr>\n<th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\"><span>NO</span></span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\"><span>NIK</span></span></th><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.RELATIONSHIP\"></span></span></th><th class=\"text-center\" rowspan=\"2\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.DATE\"></span></span></th><th class=\"text-center\" colspan=\"4\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.STATUS\"></span></span></th><th class=\"text-center\" rowspan=\"2\">\n<span class=\"column-title\"><span translate=\"MENU.MAIN.ISSAMEHOME\"></span></span></th></tr><tr><th class=\"text-center\">\n<span class=\"column-title\"><span translate=\"MENU.MAIN.MORNING\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.NOTE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.AFTERNOON\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.NOTE\"></span></span></th></tr></thead><tbody><tr \nng-style=\"{\'background-color\':ls.color}\" ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editPayrollEmployee($event,ls.id)\"><td class=\"text-center\">{{$index+1}}</td><td class=\"text-center\">\n{{ls.nik}}</td><td>{{ls.emp_name}}</td><td class=\"\">{{ls.type_of_family}}</td><td class=\"text-center\">\n{{ls.checking_date}}</td><td class=\"text-center\">{{ls.morning}}</td><td class=\"\">{{ls.health_status_morning}}</td><td \nclass=\"text-center\">{{ls.afternoon}}</td><td class=\"\">{{ls.health_status_afternoon}}</td><td class=\"text-center\">\n{{ls.is_same_home==1 ? \'Yes\' : \'No\'}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td \ncolspan=\"10\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\"></div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgba(0,0,0,0.6)\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular \nclass=\"md-accent\" md-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></div></label><input \nid=\"ms-search-bar-input\" type=\"text\" placeholder=\"Search\" flex ng-model=\"MsSearchBar.query\" \nng-model-options=\"MsSearchBar.queryOptions\" ng-blur=\"MsSearchBar.blurred()\" \nng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button class=\"ms-search-bar-collapser md-icon-button\" \nng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\"><md-icon md-font-icon=\"icon-close\" class=\"icon s24\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><div class=\"ms-search-bar-results\" ng-if=\"MsSearchBar.results\" \nms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\" style=\"color:rgba(0,0,0,0.6)\"></md-icon><div \nng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">\n{{shortcut.title}}</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\">\n<md-button class=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon\n md-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" style=\"color:rgba(0,0,0,0.6)\" ng-hide=\"!MsShortcuts.mobileBarActive\">\n</md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\" layout id=\"layout-horizontal-navigation\"><ms-navigation-horizontal>\n</ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp md-warn custom-nav-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-image\"><img src=\"assets/images/logos/kfc.png\" height=\"20\" alt=\"\"> </span><span \nclass=\"logo-text md-accent-fg md-hue-3\">HR LINK</span></div><md-icon class=\"fold-toggle s18 md-accent-fg md-hue-3\" \nmd-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar>\n<ms-navigation class=\"scrollable bg-nav\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/mapping/list-outlet-mapping.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Outlet Mapping Waiting Approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveOutletMapping($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.approveOutletMapping($event)\"><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span>Aprove</span></md-button></div></md-toolbar><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th><span><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th>No</th><th>\nRequest By</th><th>Status</th><th>View</th></tr></thead><tbody><tr \nng-init=\"mainIdx=$index;vm.visibleSubChild[$index]=false\" ng-repeat-start=\"ls in vm.listApproval track by $index\"><td \nclass=\"text-center\"><span ng-if=\"ls.approval==0\"><input type=\"checkbox\" checklist-model=\"vm.listOtselected\" \nchecklist-value=\"ls\"></span></td><td>{{mainIdx+1}}</td><td>{{ls.requestby}}-{{ls.nama}}</td><td>{{ls.approvalinfo}}\n</td><td><md-button class=\"md-icon-button\" aria-label=\"View Detail\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.toogleSubChild(mainIdx)\" ng-if=\"ls.listSic.length>0\"><md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\">\n</md-icon><md-tooltip><span>click for view team</span></md-tooltip></md-button></td></tr><tr \nng-show=\"vm.visibleSubChild[mainIdx]\" style=\"background: rgba(0,0,0,0.08)\"><th align=\"right\">No</th><th \nstyle=\"padding-left:20px !important\">Name</th><th>Current Outlet</th><th>Next Outlet</th><th>Effective Date</th></tr>\n<tr ng-show=\"vm.visibleSubChild[mainIdx]\" style=\"background: rgba(0,0,0,0.08)\" \nng-repeat=\"lstSubTeam in ls.listSic track by $index\"><td align=\"right\">{{$index+1}}</td><td \nstyle=\"padding-left:20px !important\">{{lstSubTeam.nik}}-{{lstSubTeam.nama}}</td><td>{{lstSubTeam.currAreaName}}</td>\n<td>{{lstSubTeam.nextAreaName}}</td><td>{{lstSubTeam.effective_date}}</td></tr><tr ng-repeat-end></tr></tbody></table>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/quick-panel/tabs/mapping/list-sic-mapping.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>SIC Mapping Waiting Approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveSicMapping($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.approveSicMapping($event)\"><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span>Aprove</span></md-button></div></md-toolbar><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th><span><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th>No</th><th>\nRequest By</th><th>Status</th><th>View</th></tr></thead><tbody><tr \nng-init=\"mainIdx=$index;vm.visibleSubChild[$index]=false\" ng-repeat-start=\"ls in vm.listApproval track by $index\"><td \nclass=\"text-center\"><span ng-if=\"ls.approval==0\"><input type=\"checkbox\" checklist-model=\"vm.listOtselected\" \nchecklist-value=\"ls\"></span></td><td>{{mainIdx+1}}</td><td>{{ls.requestby}}-{{ls.nama}}</td><td>{{ls.approvalinfo}}\n</td><td><md-button class=\"md-icon-button\" aria-label=\"View Detail\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.toogleSubChild(mainIdx)\" ng-if=\"ls.listSic.length>0\"><md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\">\n</md-icon><md-tooltip><span>click for view team</span></md-tooltip></md-button></td></tr><tr \nng-show=\"vm.visibleSubChild[mainIdx]\" style=\"background: rgba(0,0,0,0.08)\"><th align=\"right\">No</th><th \nstyle=\"padding-left:20px !important\">Name</th><th>Current Outlet</th><th>Next Outlet</th><th>Effective Date</th></tr>\n<tr ng-show=\"vm.visibleSubChild[mainIdx]\" style=\"background: rgba(0,0,0,0.08)\" \nng-repeat=\"lstSubTeam in ls.listSic track by $index\"><td align=\"right\">{{$index+1}}</td><td \nstyle=\"padding-left:20px !important\">{{lstSubTeam.nik}}-{{lstSubTeam.nama}}</td><td>{{lstSubTeam.currAreaName}}</td>\n<td>{{lstSubTeam.nextAreaName}}</td><td>{{lstSubTeam.effective_date}}</td></tr><tr ng-repeat-end></tr></tbody></table>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-abnormal.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Abnormal waiting approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveAbnormal($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveAbnormal($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove\n</span></md-button><div class=\"toolbar-separator\"></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\">Reject</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th rowspan=\"2\"><span><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</span></th><th rowspan=\"2\">Name</th><th rowspan=\"2\">Working Date</th><th colspan=\"4\" class=\"text-center\">Actual Data\n</th><th colspan=\"4\" class=\"text-center\">Update Data</th><th rowspan=\"2\">Description</th></tr><tr><th>IN</th><th>\nBreak Out</th><th>Break In</th><th>Out</th><th>IN</th><th>Break Out</th><th>Break In</th><th>Out</th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.listApproval\"><td class=\"text-center\"><span ng-if=\"ls.approval==0\"><input \ntype=\"checkbox\" checklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td>{{ls.nama}}</td><td>\n{{ls.working_date}}</td><td class=\"text-center\"><span ng-if=\"ls.actIn !=\'empty\'\">{{ls.actIn}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.actbreakOut !=\'empty\'\">{{ls.actbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actOut !=\'empty\'\">\n{{ls.actOut}}</span></td><td class=\"text-center\"><span ng-if=\"ls.updateIn !=\'empty\'\">{{ls.updateIn}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.updateBreakOut !=\'empty\'\">{{ls.updateBreakOut}}</span></td><td class=\"text-center\">\n<span ng-if=\"ls.updateBreakIn !=\'empty\'\">{{ls.updateBreakIn}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.updateOut !=\'empty\'\">{{ls.updateOut}}</span></td><td>{{ls.description}}</td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-changebankaccount.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Change bank account approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveChangeshift($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approve($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th rowspan=\"2\" flex>No Register</th><th rowspan=\"2\" flex>Name</th><th rowspan=\"2\" flex>Gender</th><th colspan=\"3\" \nflex>Bank Account</th><th rowspan=\"2\" flex>Bank Account Name</th></tr><tr><th flex>Bank</th><th flex>Branch</th><th \nflex>Bank Account</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listApproval\"><td>{{ls.no_register}}</td><td>\n{{ls.name}}</td><td>{{ls.gender}}</td><td>{{ls.bank_name}}</td><td>{{ls.branch_name}}</td><td>{{ls.empRekening}}</td>\n<td>{{ls.name}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-changegrade.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Change grade approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveChangeshift($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approve($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th flex>No Register</th><th flex>Name</th><th flex>Gender</th><th flex>Current Plan</th><th flex>New Plan</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.listApproval\"><td>{{ls.no_register}}</td><td>{{ls.name}}</td><td>\n{{ls.gender}}</td><td>{{ls.plan.description}}</td><td>{{ls.empPlan.description}}</td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-changemarital.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Change Marital Status approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveChangeshift($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approve($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th flex>NIK</th><th flex>No Register</th><th flex>Employe Name</th><th flex>Grade</th><th flex>Plan</th><th flex>\nLast Status</th><th flex>Current Status</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listApproval\"><td>{{ls.nik}}\n</td><td>{{ls.no_register}}</td><td>{{ls.name}}</td><td>{{ls.empPlan.description}}</td><td>{{ls.grade}}</td><td>\n{{ls.marital_status}}</td><td>{{ls.empMarital}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-changeshift.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Change shift waiting approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveChangeshift($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveChangeshift($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>\nAprove</span></md-button><div class=\"toolbar-separator\"></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\">\nReject</span></md-button></div></md-toolbar><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th rowspan=\"2\">\n<span><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th \nrowspan=\"2\">Name</th><th rowspan=\"2\">Date</th><th rowspan=\"2\">DWS Code</th><th colspan=\"2\">Full Day</th><th \ncolspan=\"2\">Half Day</th></tr><tr><th>Start Time</th><th>End Time</th><th>Start Time</th><th>End Time</th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.listApproval\"><td><span ng-if=\"ls.approval==1\"><input type=\"checkbox\" \nchecklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td>{{ls.nama}}</td><td>{{ls.tgl}}</td><td>\n{{ls.idshift}}</td><td>{{ls.startTimeF}}</td><td>{{ls.endTimeF}}</td><td>{{ls.startTimeH}}</td><td>{{ls.endTimeH}}</td>\n</tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-finger.html","actIn<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"upnormalForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Update finger waiting approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveAbnormal($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveAbnormal($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove\n</span></md-button><div class=\"toolbar-separator\"></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\">Reject</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th rowspan=\"2\"><span><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</span></th><th rowspan=\"2\">Name</th><th rowspan=\"2\">Working Date</th><th colspan=\"4\">Actual Data</th><th colspan=\"4\">\nUpdate Data</th><th rowspan=\"2\">Description</th></tr><tr><th>IN</th><th>Break Out</th><th>Break In</th><th>Out</th><th>\nIN</th><th>Break Out</th><th>Break In</th><th>Out</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listApproval\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></td><td>\n{{ls.nama}}</td><td>{{ls.working_date}}</td><td class=\"text-center\"><span ng-if=\"ls.actIn !=\'empty\'\">{{ls.actIn}}\n</span></td><td class=\"text-center\"><span ng-if=\"ls.actbreakOut !=\'empty\'\">{{ls.actbreakOut}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.actOut !=\'empty\'\">{{ls.actOut}}</span></td><td class=\"text-center\"><span ng-if=\"ls.updateIn !=\'empty\'\">\n{{ls.updateIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.updateBreakOut !=\'empty\'\">{{ls.updateBreakOut}}\n</span></td><td class=\"text-center\"><span ng-if=\"ls.updateBreakIn !=\'empty\'\">{{ls.updateBreakIn}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.updateOut !=\'empty\'\">{{ls.updateOut}}</span></td><td>{{ls.description}}</td></tr>\n</tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-ghk-holiday.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Ghk Holiday waiting approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveOT($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove</span>\n</md-button><div class=\"toolbar-separator\"></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\">Reject</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th>\n<th>Nik/Name</th><th>Holiday</th><th>Working Day</th><th>Shift Time</th><th>Reason</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listApproval\"><td><input type=\"checkbox\" checklist-model=\"vm.listOtselected\" checklist-value=\"ls\">\n</td><td>{{ls.nik}}/{{ls.nama}}</td><td>{{ls.holiday_date}}</td><td>{{ls.working_date}}</td><td>{{ls.time_shift}}</td>\n<td>{{ls.reason}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-ghk.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Ghk waiting approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><div layout-gt-sm=\"row\"><md-input-container flex><label>\nWorking Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"ot_date\" ng-model=\"vm.date\" required></md-datepicker>\n<div ng-messages=\"upnormalForm.date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Working Date is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" placeholder=\"employee name / nik\" \nng-model=\"vm.Form.objForm.nik\" id=\"formSearch\"></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete \nflex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"NIK Atasan\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nng-disabled=\"(upnormalForm.$invalid || upnormalForm.$pristine)\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon></md-button></md-input-container></div><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveOT($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove</span>\n</md-button><div class=\"toolbar-separator\"></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\">Reject</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th>\n<th>Nik/Name</th><th translate=\"TABLE.DEPARTMENT\">Department</th><th ng-if=\"vm.type_id!=\'2\'\" translate=\"TABLE.OFFDAY\">\nTotal Off Day</th><th ng-if=\"vm.type_id!=\'2\'\">Holiday</th><th>Working Day</th><th>Shift Time</th><th>Reason</th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.listApproval\"><td><input type=\"checkbox\" checklist-model=\"vm.listOtselected\" \nchecklist-value=\"ls\"></td><td>{{ls.nik}}/{{ls.nama}}</td><td>{{ls.department}}</td><td ng-if=\"vm.type_id!=\'2\'\" \nclass=\"text-center\">{{ls.offday}}</td><td ng-if=\"vm.type_id!=\'2\'\">{{ls.holiday_date}}</td><td>{{ls.working_date}}</td>\n<td>{{ls.time_shift}}</td><td>{{ls.reason}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-indisciplinary.html","");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-member.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Approve Member</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container flex=\"20\"><md-datepicker ng-model=\"vm.date\" \nplaceholder=\"Submit Date\" md-hide-icons=\"calendar\" name=\"submit_date\" required></md-datepicker></md-input-container>\n<md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approve($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th flex>NIK</th><th flex>Employe Name</th><th flex>Name</th><th flex>No Register</th><th flex>Grade</th><th flex>\nRelation</th><th flex>Date Of Birth</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listApproval\"><td>{{ls.nik}}</td>\n<td>{{ls.empName}}</td><td>{{ls.name}}</td><td>{{ls.no_register}}</td><td>{{ls.grade}}</td><td>{{ls.ocupation}}</td>\n<td>{{ls.tanggal_lahir}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-ofb.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Offboarding approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approve($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approve($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove</span>\n</md-button><div class=\"toolbar-separator\"></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\">Reject</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th class=\"text-center\"><span><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th>NIK</th><th>Name</th><th>Effective Date</th><th>Job Title\n</th><th>Reason</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.list\" ng-dblclick=\"vm.detail(ls.id)\"><td \nclass=\"text-center\"><span><input type=\"checkbox\" checklist-model=\"vm.listOfbselected\" checklist-value=\"ls\"></span></td>\n<td>{{ls.nik}}</td><td>{{ls.empName}}</td><td>{{ls.effective_date}}</td><td>{{ls.job_title}}</td><td>{{ls.reason}}</td>\n</tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-ot.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Overtime waiting approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveOT($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove</span>\n</md-button><div class=\"toolbar-separator\"></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\">Reject</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th>\n<th>Type</th><th>Date</th><th>Start Time</th><th>End Time</th><th>Rest Hour</th><th>Request By</th><th>Reason</th><th \nwidth=\"20%\">Team</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listApproval\"><td><span><input type=\"checkbox\" \nchecklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td>{{ls.ot_type}}</td><td>{{ls.ot_date}}</td><td>\n{{ls.start_time}}</td><td>{{ls.end_time}}</td><td>{{ls.rest_hour}}</td><td>{{ls.requestname}}</td><td>{{ls.reason}}\n</td><td>{{ls.team}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval-otgw.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Overtime GW waiting approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><div layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.OVETIME_DATE\">Overtime Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"ot_date\" ng-model=\"vm.ot_date\" required></md-datepicker><div ng-messages=\"upnormalForm.ot_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>OT Date is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" placeholder=\"employee name / nik\" ng-model=\"vm.Form.objForm.nik\" \nid=\"formSearch\"></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"NIK Atasan\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nng-disabled=\"(upnormalForm.$invalid || upnormalForm.$pristine)\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon></md-button></md-input-container></div><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveOT($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove</span>\n</md-button><div class=\"toolbar-separator\"></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\">Reject</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th>\n<th>NIK</th><th>Name</th><th>Type</th><th>Date</th><th>Start Time</th><th>End Time</th><th>Rest Hour</th><th>Request By\n</th><th>Reason</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listApproval\"><td><span><input type=\"checkbox\" \nchecklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td>{{ls.nik}}</td><td>{{ls.nama}}</td><td>\n{{ls.ot_type}}</td><td style=\"white-space: nowrap\">{{ls.ot_date}}</td><td>{{ls.start_time}}</td><td>{{ls.end_time}}\n</td><td>{{ls.rest_hour}}</td><td style=\"white-space: nowrap\">{{ls.atasan}}</td><td>{{ls.reason}}</td></tr></tbody>\n</table></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span class=\"orange-800-fg\">\nThe maximum limit is 1000 lines, please process the data that appears first.</span></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-approval.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>leave waiting approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveOT($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span>Reject</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Aprove</span>\n</md-button><div class=\"toolbar-separator\"></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\">Reject</span></md-button></div>\n</md-toolbar><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead>\n<tr><th class=\"text-center\"><span><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th>Name</th><th>Type</th><th>Type Name</th><th>Start Date\n</th><th>End Date</th><th>Start Time</th><th>End Time</th><th>Description</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listApproval\"><td class=\"text-center\"><span><input type=\"checkbox\" \nchecklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td>{{ls.nama}}</td><td>{{ls.absence_type}}</td>\n<td>{{ls.abssencecode}}</td><td>{{ls.start_date}}</td><td>{{ls.end_date}}</td><td>{{ls.start_time}}</td><td>\n{{ls.end_time}}</td><td>{{ls.description}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/list-approval/list-reset-slt.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"90\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Reset SLT approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.loadProcess\">\n</md-progress-linear><md-dialog-content><div layout=\"column\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>MPN Number\n</th><th>Business Title</th><th>Budget Type</th><th>Qty</th><th>PIC</th><th>Create Date</th><th>Request Date</th><th>\nExpected Join Date</th><th>Lead Time</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.list\" \nng-dblclick=\"vm.detail(ls.id)\"><td>{{ls.mpn_number}}</td><td>{{ls.business_title_text}}</td><td>{{ls.budget_type}}</td>\n<td>Replacement : {{ls.quantity_replacement}}; New : {{ls.quantity_new_position}}</td><td>{{ls.pic}}</td><td>\n{{ls.created_at}}</td><td>{{ls.request_date}}</td><td>{{ls.expected_join_date}}</td><td>\n{{ls.lt}} Working days after mpn approve</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider \nng-if=\"vm.Approvalinfo.getInfoApproval.jumLeave>0 || vm.Approvalinfo.getInfoApproval.jumAbnormal>0 || vm.Approvalinfo.getInfoApproval.jumUpFinger>0 || vm.Approvalinfo.getInfoApproval.jumGhK>0 || vm.Approvalinfo.getInfoApproval.jumGhkHoliday>0 || vm.Approvalinfo.getInfoApproval.jumOT>0 || vm.Approvalinfo.getInfoApproval.jumChangeshift>0 || vm.Approvalinfo.getInfoApproval.jumOutletTeam>0 || vm.Approvalinfo.getInfoApproval.jumSicTeam>0 || vm.Approvalinfo.getInfoApproval.jumMpn>0 || vm.Approvalinfo.getInfoApproval.jumTiket>0\">\n</md-divider><md-list><md-subheader \nng-if=\"vm.Approvalinfo.getInfoApproval.jumLeave>0 || vm.Approvalinfo.getInfoApproval.jumAbnormal>0 || vm.Approvalinfo.getInfoApproval.jumUpFinger>0 || vm.Approvalinfo.getInfoApproval.jumGhK>0 || vm.Approvalinfo.getInfoApproval.jumGhkHoliday>0 || vm.Approvalinfo.getInfoApproval.jumOT>0 || vm.Approvalinfo.getInfoApproval.jumChangeshift>0 || vm.Approvalinfo.getInfoApproval.jumOutletTeam>0 || vm.Approvalinfo.getInfoApproval.jumSicTeam>0\" \nclass=\"md-no-sticky\"><span><b>Approval Events</b></span></md-subheader><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumLeave>0\" ng-click=\"vm.viewListApp($event)\"><h3>Leave</h3><span \nclass=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumLeave}}</span></md-list-item><md-list-item\n ng-if=\"vm.Approvalinfo.getInfoApproval.jumAbnormal>0\" ng-click=\"vm.viewListAppAbnormal($event)\"><h3>Abnormal</h3><span\n class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumAbnormal}}</span></md-list-item>\n<md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumUpFinger>0\" ng-click=\"vm.viewListUpFinger($event)\"><h3>\nUpdate Finger</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumUpFinger}}</span>\n</md-list-item><md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumGhK>0\" ng-click=\"vm.viewListAppGHK($event)\"><h3>\nGHK</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumGhK}}</span></md-list-item>\n<md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumGhkHoliday>0\" ng-click=\"vm.viewListAppGHKholiday($event)\"><h3>\nGHK Holiday</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumGhkHoliday}}</span>\n</md-list-item><md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumGhkHalfday>0\" \nng-click=\"vm.viewListAppGHKhalfday($event)\"><h3>GHK Halfday</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Approvalinfo.getInfoApproval.jumGhkHalfday}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumOT>0\" ng-click=\"vm.viewListOT($event)\"><h3>Over Time</h3><span \nclass=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumOT}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumOTGw>0\" ng-click=\"vm.viewListOTGw($event)\"><h3>Over Time GW</h3><span \nclass=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumOTGw}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumChangeshift>0\" ng-click=\"vm.viewListChangeshift($event)\"><h3>Change Shift\n</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumChangeshift}}</span>\n</md-list-item><md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumOutletTeam>0\" \nng-click=\"vm.viewListAppOutletMapping($event)\"><h3>Outlet Mapping Team</h3><span \nclass=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumOutletTeam}}</span></md-list-item>\n<md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumSicTeam>0\" ng-click=\"vm.viewListAppSicMapping($event)\"><h3>\nSM Mapping Team</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumSicTeam}}</span>\n</md-list-item><md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumMpn>0\" ng-click=\"vm.viewMpn();\"><h3>\nMan Power Need</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumMpn}}</span>\n</md-list-item><md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumMpnGw>0\" ng-click=\"vm.viewMpnGw();\"><h3>\nMan Power Need</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumMpnGw}}</span>\n</md-list-item><md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumMpnGwRevise>0\" ng-click=\"vm.viewMpnGwRevise();\">\n<h3>Revised Man Power Need</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Approvalinfo.getInfoApproval.jumMpnGwRevise}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumMpnGwRecruit>0\" ng-click=\"vm.viewMpnGwRecruit();\"><h3>Recruit Man Power Need\n</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumMpnGwRecruit}}</span>\n</md-list-item><md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumMpnGwStoped>0\" ng-click=\"vm.viewMpnGwStoped();\">\n<h3>Change Headcount Man Power Need</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Approvalinfo.getInfoApproval.jumMpnGwStoped}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumTiket>0\" ng-click=\"vm.viewTiket();\"><h3>E-Ticket Approval</h3><span \nclass=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumTiket}}</span></md-list-item><md-list-item\n ng-if=\"vm.Approvalinfo.getInfoApproval.jumAssignment>0\" ng-click=\"vm.viewAssignment();\"><h3>Temporary Assignment</h3>\n<span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumAssignment}}</span></md-list-item>\n<md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumJic>0\" ng-click=\"vm.viewJic();\"><h3>JIC</h3><span \nclass=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumJic}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumHcTicket>0\" ng-click=\"vm.viewHcTicket();\"><h3><span \ntranslate=\"MENU.MAIN.HCTICKET\"></span></h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Approvalinfo.getInfoApproval.jumHcTicket}}</span></md-list-item></md-list><md-divider \nng-if=\"vm.Approvalinfo.getInfoApproval.insuranceList.jumMarital > 0 ||\n    vm.Approvalinfo.getInfoApproval.insuranceList.jumGrade > 0 || vm.Approvalinfo.getInfoApproval.insuranceList.jumChild\n    > 0 ||\n    vm.Approvalinfo.getInfoApproval.insuranceList.jumRekening > 0 ||\n    vm.Approvalinfo.getInfoApproval.insuranceList.jumRegisterNumber >\n    0 ||\n    vm.Claimalert.infoClaim.total > 0\">\n</md-divider><md-list><md-subheader \nng-if=\"vm.Approvalinfo.getInfoApproval.insuranceList.jumMarital > 0 ||\n        vm.Approvalinfo.getInfoApproval.insuranceList.jumGrade > 0\n        || vm.Approvalinfo.getInfoApproval.insuranceList.jumChild > 0 ||\n        vm.Approvalinfo.getInfoApproval.insuranceList.jumRekening > 0\n        ||\n        vm.Approvalinfo.getInfoApproval.insuranceList.jumRegisterNumber > 0 || vm.Claimalert.infoClaim.total > 0\" \nclass=\"md-no-sticky\"><span>Insurance Notification </span></md-subheader><md-list-item \nng-if=\"vm.Insurancealert.infoInsurance.jumMarital > 0\" ng-click=\"vm.viewListMarital($event)\"><h3>Marital Status Changed\n</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Insurancealert.infoInsurance.jumMarital}}</span></md-list-item>\n<md-list-item ng-if=\"vm.Insurancealert.infoInsurance.jumGrade > 0\" ng-click=\"vm.viewListGrade($event)\"><h3>\nGrade Changed</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Insurancealert.infoInsurance.jumGrade}}</span>\n</md-list-item><md-list-item ng-if=\"vm.Insurancealert.infoInsurance.jumChild > 0\" ng-click=\"vm.viewListChild($event)\">\n<h3>Need To Be Approved</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Insurancealert.infoInsurance.jumChild}}\n</span></md-list-item><md-list-item ng-if=\"vm.Insurancealert.infoInsurance.jumRekening > 0\" \nng-click=\"vm.viewListRekening($event)\"><h3>Bank Account Changed</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Insurancealert.infoInsurance.jumRekening}}</span></md-list-item><md-list-item \nng-if=\"vm.Insurancealert.infoInsurance.jumRegisterNumber > 0\" ng-click=\"vm.viewJumRegisterNumber()\"><h3>\nUnset Register Number</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Insurancealert.infoInsurance.jumRegisterNumber}}</span></md-list-item><md-list-item \nng-if=\"vm.Claimalert.infoClaim.total > 0\" ng-click=\"vm.viewClaim()\"><h3>Claim Need To Be Approved</h3><span \nclass=\"badge white-fg md-purple-500-bg\">{{vm.Claimalert.infoClaim.total}}</span></md-list-item></md-list><md-divider \nng-if=\"vm.Approvalinfo.getInfoApproval.ofbExitApproval>0 || vm.Approvalinfo.getInfoApproval.ofbApproval>0 || vm.Approvalinfo.getInfoApproval.ofbHandoverApproval>0\">\n</md-divider><md-list><md-subheader \nng-if=\"vm.Approvalinfo.getInfoApproval.ofbExitApproval>0 || vm.Approvalinfo.getInfoApproval.ofbApproval>0 || vm.Approvalinfo.getInfoApproval.ofbHandoverApproval>0\" \nclass=\"md-no-sticky\"><span><b>Employee Offboarding</b></span></md-subheader><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.ofbApproval>0\" ng-click=\"vm.ofbApproval($event)\"><h3>Offboarding Approval</h3>\n<span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.ofbApproval}}</span></md-list-item>\n<md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.jumOfb>0\" ng-click=\"vm.ofbApproval($event)\"><h3>\nOffboarding Approval</h3><span class=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumOfb}}\n</span></md-list-item><md-list-item ng-if=\"vm.Approvalinfo.getInfoApproval.ofbExitApproval>0\" \nng-click=\"vm.ofbExitApproval($event)\"><h3>Exit Clearance Approval</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Approvalinfo.getInfoApproval.ofbExitApproval}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.ofbHandoverApproval>0\" ng-click=\"vm.ofbHandoverApproval($event)\"><h3>\nJob Handover Approval</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Approvalinfo.getInfoApproval.ofbHandoverApproval}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.ofbSetClearance>0\" ng-click=\"vm.ofbSetClearance($event)\"><h3>\nOffboarding need to set clearance</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Approvalinfo.getInfoApproval.ofbSetClearance}}</span></md-list-item></md-list><md-divider \nng-if=\"vm.Approvalinfo.getInfoApproval.indisciplinaryApproval > 0 || vm.Approvalinfo.getInfoApproval.indisciplinaryConfirm > 0 || vm.Approvalinfo.getInfoApproval.indisciplinaryValidation > 0\">\n</md-divider><md-list><md-subheader \nng-if=\"vm.Approvalinfo.getInfoApproval.indisciplinaryApproval > 0 || vm.Approvalinfo.getInfoApproval.indisciplinaryConfirm > 0 || vm.Approvalinfo.getInfoApproval.indisciplinaryValidation > 0\" \nclass=\"md-no-sticky\"><span><b>Indisciplinary Information</b></span></md-subheader><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumIndisApproval>0\" ng-click=\"vm.toIndisciplinaryApproval($event)\"><h3>\nIndisciplinary Approval</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Approvalinfo.getInfoApproval.jumIndisApproval}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumIndisConfirm>0\" ng-click=\"vm.toIndisciplinaryConfirm($event)\"><h3>\nIndisciplinary Confirm</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Approvalinfo.getInfoApproval.jumIndisConfirm}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumIndisValidation>0\" ng-click=\"vm.toIndisciplinaryValidation($event)\"><h3>\nIndisciplinary Validation</h3><span class=\"badge white-fg md-purple-500-bg\">\n{{vm.Approvalinfo.getInfoApproval.jumIndisValidation}}</span></md-list-item><md-list-item \nng-if=\"vm.Approvalinfo.getInfoApproval.jumSLTReset>0\" ng-click=\"vm.viewResetSLT($event)\"><h3>MPN Reset SLT</h3><span \nclass=\"badge white-fg md-purple-500-bg\">{{vm.Approvalinfo.getInfoApproval.jumSLTReset}}</span></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/news/news-detail.html","<md-dialog md-disable-backdrop aria-label=\"Form Update Finger Data\" md-theme=\"modal-theme\" flex flex-md=\"60\" \nflex-gt-md=\"80\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"HC_NEWS.TITLE\">Hc News</h2>\n<span flex></span></div></md-toolbar><md-content><div ng-style=\"{\'padding-left\':\'25px\',\'padding-right\':\'25px\'}\"><h1>\n{{vm.title}}</h1><p><i ng-style=\"{\'font-size\': \'15px\',\'color\': \'rgba(73, 70, 70, 0.6)\'}\">{{vm.category}}</i><br><i \nng-style=\"{\'font-size\': \'15px\',\'color\': \'rgba(73, 70, 70, 0.6)\'}\">{{vm.date}}</i><br><i \nng-style=\"{\'font-size\': \'15px\',\'color\': \'rgba(73, 70, 70, 0.6)\'}\">Publish By: {{vm.publishBy}}</i></p><div \nng-bind-html=\"vm.content\"></div></div></md-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.dialogClose()\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/news/news-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"HC_NEWS.NEWS_LIST\">News List</span></md-subheader><md-list-item ng-repeat=\"ls in vm.listNC.getListNews\" \nng-style=\"{\n            \'font\': !ls.is_read? \'italic bold 15px Arial Bold\' : \'\' \n        }\" \nng-click=\"vm.viewNewsDetail($event, ls)\"><span class=\"badge black-fg\">{{ls.title}}</span></md-list-item></md-list>\n<md-divider></md-divider></div>");
$templateCache.put("app/quick-panel/tabs/news/news-view-doc.html","<md-dialog aria-label=\"Form Update Finger Data\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"80\"><form \nng-cloak class=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-content ng-if=\"vm.doc_type\" class=\"md-background-bg has-upload\" id=\"contentDialog\"><iframe \nng-src=\"{{vm.url}}\" frameborder=\"0\"></iframe></md-content><md-dialog-content ng-if=\"vm.images\"><img \nstyle=\"display: block;margin-left: auto;margin-right: auto;width: 100%; max-width: 100%\" alt=\"Lush mango tree\" \nsrc=\"api/newsdocument/{{vm.doc}}\"></md-dialog-content><video ng-show=\"vm.video_type\" width=\"100%\" controls autoplay>\n<source src=\"{{vm.url}}\" type=\"video/mp4\"></video></form></md-dialog>");
$templateCache.put("app/main/assessment/assessment-detail/assessment-detail.html","<div class=\"page-layout simple fullwidth\" id=\"input\" layout=\"column\"><div class=\"header header-talent\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-cog\"></md-icon></span><span class=\"logo-text\"><span>Assessment Result\n</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"start center\"></div></div></div><div class=\"content\" \nid=\"contentSetPotentialMember\"><div class=\"md-whiteframe-4dp\" id=\"inputView\" layout=\"column\"><div layout=\"row\"><div \nflex layout=\"column\" style=\"padding: 7px\"><div layout=\"row\"><div flex=\"20\"><b>Nik</b></div><div flex=\"50\"><b>\n: {{vm.profile[0].nik}}</b></div></div><div layout=\"row\"><div flex=\"20\"><b>Name</b></div><div flex=\"50\"><b>\n: {{vm.profile[0].title + \'. \' + vm.profile[0].first_name + \' \' + vm.profile[0].last_name}}</b></div></div></div><div \nflex layout=\"row\" style=\"text-align: right\"><button class=\"md-raised md-button\" ui-sref=\"app.assessment\" \nstyle=\"width: 200px; height: 39px\">Back</button>&nbsp; <button class=\"md-raised md-accent md-button\" \nng-click=\"vm.downloadAnswer($event)\" style=\"width: 200px; height: 39px\">Download</button></div></div><ms-widget \nclass=\"fade\" flippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nclass=\"s16\" md-font-icon=\"icon-alert\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><table \nclass=\"simple\" id=\"inputTable\" ms-responsive-table=\"\"><thead><tr><th>No</th><th>Section / Questions</th><th>Answer</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.answers track by $index\"><td align=\"center\">{{$index + 1}}</td><td \nstyle=\"white-space: nowrap\">{{ls.questions_name}}</td><td ng-if=\"ls.type === \'freetext\'\" ng-bind-html=\"ls.answer\">\n{{ls.answer}}</td><td ng-if=\"ls.type === \'choice\'\"><a href=\"javascript:void(0);\" ng-click=\"vm.dowloadPapikostik()\" \nclass=\"md-display-1\" style=\"padding-left: 12px\"><md-icon class=\"icon icon-file-excel\"></md-icon></a><md-list \nclass=\"md-dense\" flex><md-list-item ng-repeat=\"nc in ls.answer track by $index\" style=\"min-height: 23px; height: 23px\">\nJawaban soal no. {{nc.question}}: {{nc.answer}}</md-list-item></md-list></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/correspondence/administrator/administrator.html","<div id=\"correspondence\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nCorrespondence Administrator</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Request Type</label><md-select required \nname=\"request_type\" ng-model=\"vm.type\"><md-option ng-repeat=\"item in vm.requestTypeFilter\" ng-value=\"item.id\">\n{{ item.name }}</md-option></md-select></md-input-container><md-input-container flex><label>Status</label><md-select \nrequired name=\"status\" ng-model=\"vm.status\"><md-option value=\"all\">ALL</md-option><md-option value=\"register\">REGISTER\n</md-option><md-option value=\"progress\">PROGRESS</md-option><md-option value=\"finished\">FINISHED</md-option><md-option \nvalue=\"rejected\">REJECTED</md-option></md-select></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmFilter.$invalid || frmFilter.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" style=\"margin-right:5px\" layout=\"row\" \nlayout-align=\"start center\" hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span>Entries</span></div><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" \nclass=\"md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" \nng-click=\"vm.goToRequirement()\"><md-icon style=\"font-size:12px\" md-font-icon=\"icon-book-multiple-variant\"></md-icon>\n<span style=\"font-size:12px\">Requirement</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" ng-click=\"vm.goToDecisionLetter()\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-clipboard-check\"></md-icon><span style=\"font-size:12px\">SK PROMOSI</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" \nclass=\"md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" \nng-click=\"vm.goToAssignmentLetter()\"><md-icon style=\"font-size:12px\" md-font-icon=\"icon-clipboard-check\"></md-icon>\n<span style=\"font-size:12px\">SK PENUGASAN</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-warn\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" ng-click=\"vm.isCheckAction = !vm.isCheckAction\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Delete Request</span>\n</md-button><div ng-if=\"vm.isCheckAction\" class=\"divider-vertical\" hide show-gt-sm></div><md-button \nng-click=\"vm.deleteRequest()\" ng-if=\"vm.isCheckAction\" ng-disabled=\"vm.checked.length == 0\" \nclass=\"md-icon-btn md-primary md-mini md-small\"><md-icon class=\"green-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span style=\"font-size:12px\">Apply</span></md-button>\n<md-button ng-click=\"vm.isCheckAction = !vm.isCheckAction; vm.checked = []\" ng-if=\"vm.isCheckAction\" \nclass=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\">Cancel</span></md-button><span flex hide show-gt-sm>\n</span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 12px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-button md-ink-ripple md-mini\" type=\"button\" \nstyle=\"font-size:12px\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<span style=\"font-size:12px\">PRINT</span></md-button></md-menu-item></md-menu-content></md-menu><span flex show \nhide-gt-sm></span><ms-search-bar style=\"padding:0px\" on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" \ndebounce=\"300\" class=\"bouncy-slide-left\"></ms-search-bar></div></md-toolbar><div layout=\"column\" layout layout-padding \nms-scroll hide show-gt-sm><md-subheader id=\"headerTableList\"><md-list class=\"md-dense\" flex><md-list-item \nclass=\"compact\" style=\"padding-left:15px; padding-right:15px\"><div flex layout=\"row\" layout-align=\"start center\"><div \nflex-order=\"1\" flex=\"5\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.isCheckAction\"><md-checkbox \nng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" aria-label=\"checkall\">\n</md-checkbox></div><div flex-order=\"2\" flex=\"5\">No</div><div flex-order=\"3\" flex=\"10\">Requestor</div><div \nflex-order=\"4\" flex=\"15\">Name</div><div flex-order=\"5\" flex=\"10\">Status</div><div flex-order=\"6\" flex=\"20\">Request Type\n</div><div flex-order=\"7\" flex=\"10\">Created At</div><div flex-order=\"8\" flex=\"10\">Finished At</div><div flex-order=\"9\" \nflex=\"15\">Lead Time</div><div flex-order=\"10\" ng-if=\"!vm.isCheckAction\" flex=\"5\" layout=\"row\" layout-align=\"center\">\nAction</div></div></md-list-item><md-divider></md-divider></md-list></md-subheader><md-content \nstyle=\"max-height:400px; padding: 0\"><md-list class=\"white-bg md-dense\" flex><md-list-item class=\"compact slide-down\" \nng-repeat-start=\"item in vm.DataTable.list\" style=\"padding-left:15px; padding-right:15px\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"1\" flex=\"5\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.isCheckAction\"><md-checkbox ng-checked=\"vm.exists(item.id)\" ng-click=\"vm.toggle(item.id)\" \naria-label=\"checked\"></md-checkbox></div><div flex-order=\"2\" flex=\"5\">{{ $index + 1 }}</div><div flex-order=\"3\" \nflex=\"10\">{{ item.requestor }}</div><div flex-order=\"4\" flex=\"15\">{{ item.name }}</div><div flex-order=\"5\" flex=\"10\">\n{{ item.status.toUpperCase() }}</div><div flex-order=\"6\" flex=\"20\">{{ item.request_type_name }}</div><div \nflex-order=\"7\" flex=\"10\">{{ item.created_at }}</div><div flex-order=\"8\" flex=\"10\">\n{{ vm.getFinishedAt(item.finished_at) }}</div><div flex-order=\"9\" flex=\"15\">\n{{ vm.getLeadTime(item.created_at, item.finished_at) }}</div><div flex-order=\"10\" ng-if=\"!vm.isCheckAction\" flex=\"5\" \nlayout=\"row\" layout-align=\"center\"><md-menu><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 14px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button class=\"md-icon-btn\" ng-click=\"vm.showRequestDialog($event, \'edit\', item)\"><md-icon class=\"blue-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-eye\" md-menu-align-target></md-icon><span>Update Request</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"item.status != \'progress\'\" \nng-click=\"vm.updateStatusRequest($event, item, \'progress\')\"><md-button class=\"md-icon-btn\"><md-icon \nclass=\"orange-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-account-search\"></md-icon><span>Set Progress</span>\n</md-button></md-menu-item><md-menu-item ng-if=\"item.status != \'finished\'\" \nng-click=\"vm.updateStatusRequest($event, item, \'finished\')\"><md-button class=\"md-icon-btn\"><md-icon \nclass=\"green-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-account-check\"></md-icon><span>Finish Request</span>\n</md-button></md-menu-item><md-menu-item ng-if=\"item.status != \'rejected\'\" \nng-click=\"vm.updateStatusRequest($event, item, \'rejected\')\"><md-button class=\"md-icon-btn\"><md-icon class=\"red-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-account-remove\"></md-icon><span>Reject Request</span></md-button>\n</md-menu-item><md-menu-item ng-click=\"vm.printPDF(item)\"><md-button class=\"md-icon-btn\"><md-icon \nclass=\"purple-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-printer\"></md-icon><span>Print Out</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></md-list-item><md-divider ng-repeat-end></md-divider></md-list>\n</md-content></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></md-content></div>");
$templateCache.put("app/main/correspondence/assignment-letter/assignment-letter.html","<div id=\"correspondence\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nCorrespondence Assignment Letter</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Status</label><md-select required name=\"status\" \nng-model=\"vm.status\"><md-option value=\"all\">ALL</md-option><md-option value=\"register\">REGISTERED</md-option><md-option\n value=\"progress\">ON PROGRESS</md-option><md-option value=\"finish\">FINISHED</md-option></md-select>\n</md-input-container><md-input-container flex><label>Type</label><md-select required name=\"code\" ng-model=\"vm.code\">\n<md-option value=\"all\">ALL</md-option><md-option ng-repeat=\"item in vm.decisionTypeList\" ng-value=\"item.code\">\n{{item.name}}</md-option></md-select></md-input-container><md-button class=\"md-primary md-icon-button md-small\" \ntype=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmFilter.$invalid || frmFilter.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" layout=\"row\" layout-align=\"start center\" \nhide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span>Entries</span></div><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-primary\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" \nng-click=\"vm.showRequestDialog($event, \'create\', null)\"><md-icon style=\"font-size:12px\" md-font-icon=\"icon-plus-box\">\n</md-icon><span style=\"font-size:12px\">CREATE</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-warn\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" ng-click=\"vm.isCheckAction = !vm.isCheckAction\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Delete</span></md-button><div \nng-if=\"vm.isCheckAction\" class=\"divider-vertical\" hide show-gt-sm></div><md-button ng-click=\"vm.deleteRequest()\" \nng-if=\"vm.isCheckAction\" ng-disabled=\"vm.checked.length == 0\" class=\"md-icon-btn md-primary md-mini md-small\"><md-icon \nclass=\"green-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span \nstyle=\"font-size:12px\">Apply</span></md-button><md-button \nng-click=\"vm.isCheckAction = !vm.isCheckAction; vm.checked = []\" ng-if=\"vm.isCheckAction\" \nclass=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\">Cancel</span></md-button><span flex hide show-gt-sm>\n</span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 12px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-button md-ink-ripple md-mini\" type=\"button\" \nstyle=\"font-size:12px\" aria-label=\"printcost\" ng-click=\"vm.vm.showRequestDialog($event, \'create\', null)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Create Data</span></md-button></md-menu-item>\n</md-menu-content></md-menu><span flex show hide-gt-sm></span><ms-search-bar style=\"padding:0px\" \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" class=\"bouncy-slide-left\"></ms-search-bar>\n</div></md-toolbar><div layout=\"column\" layout layout-padding ms-scroll hide show-gt-sm><md-subheader \nid=\"headerTableList\"><md-list class=\"md-dense\" flex><md-list-item class=\"compact\" \nstyle=\"padding-left:15px; padding-right:15px\"><div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"1\" \nflex=\"5\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.isCheckAction\"><md-checkbox ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" aria-label=\"checkall\"></md-checkbox></div><div \nflex-order=\"2\" flex=\"5\">No</div><div flex-order=\"4\" flex=\"25\">Location</div><div flex-order=\"5\" flex=\"15\">Type</div>\n<div flex-order=\"6\" flex=\"10\">Created At</div><div flex-order=\"7\" flex=\"10\">Finished At</div><div flex-order=\"8\" \nflex=\"20\">Lead Time</div><div flex-order=\"9\" flex=\"10\" ng-if=\"!vm.isCheckAction\">status</div><div flex-order=\"10\" \nflex=\"5\" ng-if=\"!vm.isCheckAction\" layout=\"row\" layout-align=\"center\">Action</div></div></md-list-item><md-divider>\n</md-divider></md-list></md-subheader><md-content style=\"max-height:400px; padding: 0\"><md-list \nclass=\"white-bg md-dense\" flex><md-list-item class=\"compact slide-down\" ng-repeat-start=\"item in vm.DataTable.list\" \nstyle=\"padding-left:15px; padding-right:15px\"><div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"1\" \nflex=\"5\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.isCheckAction\"><md-checkbox \nng-checked=\"vm.exists(item.id)\" ng-click=\"vm.toggle(item.id)\" aria-label=\"checked\"></md-checkbox></div><div \nflex-order=\"2\" flex=\"5\">{{$index + 1}}</div><div flex-order=\"4\" flex=\"25\">{{item.location}}</div><div flex-order=\"5\" \nflex=\"15\">{{item.decision_type_name}}</div><div flex-order=\"6\" flex=\"10\">{{item.created_at}}</div><div flex-order=\"7\" \nflex=\"10\">{{vm.getFinishedAt(item.finished_at)}}</div><div flex-order=\"8\" flex=\"20\">\n{{vm.getLeadTime(item.created_at, item.finished_at)}}</div><div flex-order=\"9\" flex=\"10\" ng-if=\"!vm.isCheckAction\">\n{{item.status.toUpperCase()}}</div><div flex-order=\"10\" ng-if=\"!vm.isCheckAction\" flex=\"5\" layout=\"row\" \nlayout-align=\"space-between center\"><md-menu><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 14px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button class=\"md-icon-btn\" ng-click=\"vm.showRequestDialog($event, \'view\', item)\"><md-icon class=\"blue-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-eye\" md-menu-align-target></md-icon><span>View Detail</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"item.status != \'progress\'\" \nng-click=\"vm.updateStatusRequest($event, item, \'progress\')\"><md-button class=\"md-icon-btn\"><md-icon \nclass=\"orange-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-account-search\"></md-icon><span>Set Progress</span>\n</md-button></md-menu-item><md-menu-item ng-if=\"item.status != \'finished\'\" \nng-click=\"vm.updateStatusRequest($event, item, \'finish\')\"><md-button class=\"md-icon-btn\"><md-icon class=\"green-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-account-check\"></md-icon><span>Set Finish</span></md-button></md-menu-item>\n<md-menu-item ng-click=\"vm.printPDF(item)\"><md-button class=\"md-icon-btn\"><md-icon class=\"purple-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-printer\"></md-icon><span>Print Out</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content>\n</div></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></md-content></div>");
$templateCache.put("app/main/correspondence/decision-letter/decision-letter.html","<div id=\"correspondence\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nCorrespondence Decision Letter</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Status</label><md-select required name=\"status\" \nng-model=\"vm.status\"><md-option value=\"all\">ALL</md-option><md-option value=\"register\">REGISTERED</md-option><md-option\n value=\"progress\">ON PROGRESS</md-option><md-option value=\"finish\">FINISHED</md-option></md-select>\n</md-input-container><md-input-container flex><label>Type</label><md-select required name=\"code\" ng-model=\"vm.code\">\n<md-option value=\"all\">ALL</md-option><md-option ng-repeat=\"item in vm.decisionTypeList\" ng-value=\"item.code\">\n{{item.name}}</md-option></md-select></md-input-container><md-button class=\"md-primary md-icon-button md-small\" \ntype=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmFilter.$invalid || frmFilter.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" layout=\"row\" layout-align=\"start center\" \nhide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span>Entries</span></div><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-primary\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" \nng-click=\"vm.showRequestDialog($event, \'create\', null)\"><md-icon style=\"font-size:12px\" md-font-icon=\"icon-plus-box\">\n</md-icon><span style=\"font-size:12px\">CREATE</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-warn\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" ng-click=\"vm.isCheckAction = !vm.isCheckAction\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Delete</span></md-button><div \nng-if=\"vm.isCheckAction\" class=\"divider-vertical\" hide show-gt-sm></div><md-button ng-click=\"vm.deleteRequest()\" \nng-if=\"vm.isCheckAction\" ng-disabled=\"vm.checked.length == 0\" class=\"md-icon-btn md-primary md-mini md-small\"><md-icon \nclass=\"green-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span \nstyle=\"font-size:12px\">Apply</span></md-button><md-button \nng-click=\"vm.isCheckAction = !vm.isCheckAction; vm.checked = []\" ng-if=\"vm.isCheckAction\" \nclass=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\">Cancel</span></md-button><span flex hide show-gt-sm>\n</span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 12px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-button md-ink-ripple md-mini\" type=\"button\" \nstyle=\"font-size:12px\" aria-label=\"printcost\" ng-click=\"vm.vm.showRequestDialog($event, \'create\', null)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Create Data</span></md-button></md-menu-item>\n</md-menu-content></md-menu><span flex show hide-gt-sm></span><ms-search-bar style=\"padding:0px\" \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" class=\"bouncy-slide-left\"></ms-search-bar>\n</div></md-toolbar><div layout=\"column\" layout layout-padding ms-scroll hide show-gt-sm><md-subheader \nid=\"headerTableList\"><md-list class=\"md-dense\" flex><md-list-item class=\"compact\" \nstyle=\"padding-left:15px; padding-right:15px\"><div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"1\" \nflex=\"5\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.isCheckAction\"><md-checkbox ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" aria-label=\"checkall\"></md-checkbox></div><div \nflex-order=\"2\" flex=\"5\">No</div><div flex-order=\"3\" flex=\"10\">NIK</div><div flex-order=\"4\" flex=\"20\">Name</div><div \nflex-order=\"5\" flex=\"10\">Type</div><div flex-order=\"6\" flex=\"20\">Created At</div><div flex-order=\"7\" flex=\"20\">\nFinished At</div><div flex-order=\"8\" flex=\"20\">Lead Time</div><div flex-order=\"9\" flex=\"10\" ng-if=\"!vm.isCheckAction\">\nstatus</div><div flex-order=\"10\" flex=\"5\" ng-if=\"!vm.isCheckAction\" layout=\"row\" layout-align=\"center\">Action</div>\n</div></md-list-item><md-divider></md-divider></md-list></md-subheader><md-content \nstyle=\"max-height:400px; padding: 0\"><md-list class=\"white-bg md-dense\" flex><md-list-item class=\"compact slide-down\" \nng-repeat-start=\"item in vm.DataTable.list\" style=\"padding-left:15px; padding-right:15px\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"1\" flex=\"5\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.isCheckAction\"><md-checkbox ng-checked=\"vm.exists(item.id)\" ng-click=\"vm.toggle(item.id)\" \naria-label=\"checked\"></md-checkbox></div><div flex-order=\"2\" flex=\"5\">{{$index + 1}}</div><div flex-order=\"3\" \nflex=\"10\">{{item.nik}}</div><div flex-order=\"4\" flex=\"20\">{{item.name}}</div><div flex-order=\"5\" flex=\"10\">\n{{item.decision_type_name}}</div><div flex-order=\"6\" flex=\"20\">{{item.created_at}}</div><div flex-order=\"7\" flex=\"20\">\n{{vm.getFinishedAt(item.finished_at)}}</div><div flex-order=\"8\" flex=\"20\">\n{{vm.getLeadTime(item.created_at, item.finished_at)}}</div><div flex-order=\"9\" flex=\"10\" ng-if=\"!vm.isCheckAction\">\n{{item.status.toUpperCase()}}</div><div flex-order=\"10\" ng-if=\"!vm.isCheckAction\" flex=\"5\" layout=\"row\" \nlayout-align=\"space-between center\"><md-menu><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 14px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button class=\"md-icon-btn\" ng-click=\"vm.showRequestDialog($event, \'view\', item)\"><md-icon class=\"blue-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-eye\" md-menu-align-target></md-icon><span>View Detail</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"item.status != \'progress\'\" \nng-click=\"vm.updateStatusRequest($event, item, \'progress\')\"><md-button class=\"md-icon-btn\"><md-icon \nclass=\"orange-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-account-search\"></md-icon><span>Set Progress</span>\n</md-button></md-menu-item><md-menu-item ng-if=\"item.status != \'finished\'\" \nng-click=\"vm.updateStatusRequest($event, item, \'finish\')\"><md-button class=\"md-icon-btn\"><md-icon class=\"green-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-account-check\"></md-icon><span>Set Finish</span></md-button></md-menu-item>\n<md-menu-item ng-click=\"vm.printPDF(item)\"><md-button class=\"md-icon-btn\"><md-icon class=\"purple-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-printer\"></md-icon><span>Print Out</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content>\n</div></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></md-content></div>");
$templateCache.put("app/main/correspondence/requestor/requestor.html","<div id=\"correspondence\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nCorrespondence Request</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Request Type</label><md-select required \nname=\"request_type\" ng-model=\"vm.type\"><md-option ng-repeat=\"item in vm.requestTypeFilter\" ng-value=\"item.id\">\n{{ item.name }}</md-option></md-select></md-input-container><md-input-container flex><label>Status</label><md-select \nrequired name=\"status\" ng-model=\"vm.status\"><md-option value=\"all\">ALL</md-option><md-option value=\"register\">REGISTER\n</md-option><md-option value=\"progress\">PROGRESS</md-option><md-option value=\"finished\">FINISHED</md-option><md-option \nvalue=\"rejected\">REJECTED</md-option></md-select></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmFilter.$invalid || frmFilter.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" layout=\"row\" layout-align=\"start center\" \nhide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span>Entries</span></div><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button style=\"margin:0\" ng-disabled=\"vm.isCheckAction\" layout=\"row\" layout-align=\"center\" \nclass=\"md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.showRequestDialog($event, \'create\', null)\"><md-icon style=\"font-size:12px\" md-font-icon=\"icon-plus-box\">\n</md-icon><span style=\"font-size:12px\">Create Request</span></md-button><div class=\"divider-vertical\" hide show-gt-sm>\n</div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-warn\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" ng-click=\"vm.isCheckAction = !vm.isCheckAction\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Delete Request</span>\n</md-button><div ng-if=\"vm.isCheckAction\" class=\"divider-vertical\" hide show-gt-sm></div><md-button \nng-click=\"vm.deleteRequest()\" ng-if=\"vm.isCheckAction\" ng-disabled=\"vm.checked.length == 0\" \nclass=\"md-icon-btn md-primary md-mini md-small\"><md-icon class=\"green-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span style=\"font-size:12px\">Apply</span></md-button>\n<md-button ng-click=\"vm.isCheckAction = !vm.isCheckAction; vm.checked = []\" ng-if=\"vm.isCheckAction\" \nclass=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\">Cancel</span></md-button><span flex hide show-gt-sm>\n</span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 12px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-button md-ink-ripple md-mini\" type=\"button\" \nstyle=\"font-size:12px\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<span style=\"font-size:12px\">PRINT</span></md-button></md-menu-item></md-menu-content></md-menu><span flex show \nhide-gt-sm></span><ms-search-bar style=\"padding:0px\" on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" \ndebounce=\"300\" class=\"bouncy-slide-left\"></ms-search-bar></div></md-toolbar><div layout=\"column\" layout layout-padding \nms-scroll hide show-gt-sm><md-subheader id=\"headerTableList\"><md-list flex><md-list-item class=\"compact\" \nstyle=\"padding-left:15px; padding-right:15px\"><div flex layout=\"row\" layout-align=\"start center\"><div flex=\"5\">No</div>\n<div flex=\"10\">Requestor</div><div flex=\"20\">Name</div><div flex=\"10\">Status</div><div flex=\"20\">Request Type</div><div\n flex=\"15\">Created At</div><div flex=\"10\" layout=\"row\" layout-align=\"center\">Action</div><div flex=\"10\" layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.isCheckAction\" class=\"fade\"><md-checkbox ng-disabled=\"vm.disabledSelectAll()\" \nclass=\"md-checkbox-sm\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \naria-label=\"checkall\"></md-checkbox></div></div></md-list-item><md-divider></md-divider></md-list></md-subheader>\n<md-content style=\"max-height:500px; padding: 0\"><md-list class=\"white-bg\" flex><md-list-item \nclass=\"compact slide-down\" ng-repeat-start=\"item in vm.DataTable.list\" style=\"padding-left:15px; padding-right:15px\">\n<div flex layout=\"row\" layout-align=\"start center\"><div flex=\"5\">{{ $index + 1 }}</div><div flex=\"10\">\n{{ item.requestor }}</div><div flex=\"20\">{{ item.name }}</div><div flex=\"10\">{{ item.status.toUpperCase() }}</div><div \nflex=\"20\">{{ item.request_type_name }}</div><div flex=\"15\">{{ item.created_at }}</div><div flex=\"10\" layout=\"row\" \nlayout-align=\"center\"><md-button class=\"md-icon-btn md-mini md-small\" \nng-click=\"vm.showRequestDialog($event, \'view\', item)\"><md-icon class=\"deep-purple-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-eye\"></md-icon></md-button><md-button class=\"md-icon-btn md-mini md-small\" \nng-disabled=\"item.status != \'register\'\" ng-click=\"vm.showRequestDialog($event, \'edit\', item)\"><md-icon \nclass=\"blue-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-pencil\"></md-icon></md-button></div><div flex=\"10\" \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.isCheckAction\"><md-checkbox ng-disabled=\"item.status != \'register\'\" \nng-checked=\"vm.exists(item.id)\" ng-click=\"vm.toggle(item.id)\" aria-label=\"checked\"></md-checkbox></div></div>\n</md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content></div><div layout=\"column\" flex \nlayout-fill hide-gt-sm><md-content layout-fill><md-list class=\"white-bg\" flex><md-list-item class=\"md-3-line\" \nng-repeat-start=\"item in vm.DataTable.list\" ng-click=\"null\"><img ng-src=\"{{ \'api/pasfoto/\' + item.photo_address }}\" \nonerror=\"this.src=\'assets/images/avatars/profile.jpg\'\" class=\"md-avatar\" alt=\"{{item.who}}\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{ item.name }}</h3><h4>{{ item.request_type_name }}</h4><p>\n{{ item.requirement }}</p></div></md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content></div>\n</div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></md-content></div>");
$templateCache.put("app/main/correspondence/requirement/requirement.html","<div id=\"correspondence\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nCorrespondence Requirement</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Status</label><md-select required name=\"status\" \nng-model=\"vm.status\"><md-option value=\"all\">ALL</md-option><md-option value=\"active\">active</md-option><md-option \nvalue=\"inactive\">inactive</md-option></md-select></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmFilter.$invalid || frmFilter.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" layout=\"row\" layout-align=\"start center\" \nhide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span>Entries</span></div><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-primary\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" \nng-click=\"vm.showRequestDialog($event, \'create\', null)\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-book-multiple-variant\"></md-icon><span style=\"font-size:12px\">Create</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" \nclass=\"md-warn\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" \nng-click=\"vm.isCheckAction = !vm.isCheckAction\"><md-icon style=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon>\n<span style=\"font-size:12px\">Delete</span></md-button><div ng-if=\"vm.isCheckAction\" class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button ng-click=\"vm.deleteRequest()\" ng-if=\"vm.isCheckAction\" \nng-disabled=\"vm.checked.length == 0\" class=\"md-icon-btn md-primary md-mini md-small\"><md-icon class=\"green-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span style=\"font-size:12px\">Apply\n</span></md-button><md-button ng-click=\"vm.isCheckAction = !vm.isCheckAction; vm.checked = []\" \nng-if=\"vm.isCheckAction\" class=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\">Cancel</span></md-button><span \nflex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 12px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-button md-ink-ripple md-mini\" type=\"button\" \nstyle=\"font-size:12px\" aria-label=\"printcost\" ng-click=\"vm.vm.showRequestDialog($event, \'create\', null)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Create Data</span></md-button></md-menu-item>\n</md-menu-content></md-menu><span flex show hide-gt-sm></span><ms-search-bar style=\"padding:0px\" \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" class=\"bouncy-slide-left\"></ms-search-bar>\n</div></md-toolbar><div layout=\"column\" layout layout-padding ms-scroll hide show-gt-sm><md-subheader \nid=\"headerTableList\"><md-list class=\"md-dense\" flex><md-list-item class=\"compact\" \nstyle=\"padding-left:15px; padding-right:15px\"><div flex layout=\"row\" layout-align=\"start center\"><div flex-order=\"1\" \nflex=\"5\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.isCheckAction\"><md-checkbox ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" aria-label=\"checkall\"></md-checkbox></div><div \nflex-order=\"2\" flex=\"5\">No</div><div flex-order=\"3\" flex=\"75\">Name</div><div flex-order=\"4\" flex=\"10\" \nng-if=\"!vm.isCheckAction\">status</div><div flex-order=\"5\" flex=\"10\" ng-if=\"!vm.isCheckAction\" layout=\"row\" \nlayout-align=\"center\">Action</div></div></md-list-item><md-divider></md-divider></md-list></md-subheader><md-content \nstyle=\"max-height:400px; padding: 0\"><md-list class=\"white-bg md-dense\" flex><md-list-item class=\"compact slide-down\" \nng-repeat-start=\"item in vm.DataTable.list\" style=\"padding-left:15px; padding-right:15px\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div flex-order=\"1\" flex=\"5\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.isCheckAction\"><md-checkbox ng-checked=\"vm.exists(item.id)\" ng-click=\"vm.toggle(item.id)\" \naria-label=\"checked\"></md-checkbox></div><div flex-order=\"2\" flex=\"5\">{{ $index + 1 }}</div><div flex-order=\"3\" \nflex=\"75\">{{ item.name }}</div><div flex-order=\"4\" flex=\"10\" ng-if=\"!vm.isCheckAction\"><md-switch \nng-model=\"item.status\" ng-change=\"vm.setStatus(item)\" ng-true-value=\"\'active\'\" ng-false-value=\"\'inactive\'\">\n{{item.status}}</md-switch></div><div flex-order=\"5\" ng-if=\"!vm.isCheckAction\" flex=\"10\" layout=\"row\" \nlayout-align=\"center\"><md-button class=\"md-icon-btn md-primary\" ng-click=\"vm.showRequestDialog($event, \'edit\', item)\">\n<md-icon class=\"blue-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-pencil\"></md-icon></md-button></div></div>\n</md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content></div></div><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></md-content></div>");
$templateCache.put("app/main/behivor/config/config.html","<div id=\"cfg\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header Oct\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></span><span class=\"logo-text\"><span>Behaviour Config</span></span></div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"start center\"></div></div></div><div class=\"content\"><div id=\"cfgView\" class=\"md-whiteframe-4dp\" \nlayout=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \naria-label=\"add cfg\" ng-click=\"vm.addData($event)\">Add Config<md-tooltip><span>click this button to Add Config</span>\n</md-tooltip></md-button></div><table class=\"simple\" ms-responsive-table id=\"cfgTable\"><thead><tr><th>No.</th><th>\nEffective Date</th><th>Reference</th><th></th></tr></thead><tbody><tr ng-repeat=\"cfg in vm.listConfig\"><td width=\"5%\" \nstyle=\"text-align: center\">{{($index + 1)}}</td><td>{{cfg.effectiveDate}}</td><td><span ng-repeat=\"x in cfg.ref\">\n{{vm.listRef[x-1].initial}}</span></td><td width=\"15%\"><section layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" layout-wrap><md-button class=\"md-icon-button\" aria-label=\"Edit\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.editData($event, cfg)\"><md-icon \nmd-font-icon=\"icon-table-edit\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>click for edit</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.deleteData($event, cfg)\"><md-icon md-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip>\n<span>click for delete</span></md-tooltip></md-button></section></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/behivor/ref/ref.html","<div id=\"ref\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header Oct\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></span><span class=\"logo-text\"><span>Behaviour Reference</span></span></div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"start center\"></div></div></div><div class=\"content\"><div id=\"refView\" class=\"md-whiteframe-4dp\" \nlayout=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \naria-label=\"add ref\" ng-click=\"vm.addData($event)\">Add Reference<md-tooltip><span>click this button to Add Reference\n</span></md-tooltip></md-button></div><table class=\"simple\" ms-responsive-table id=\"refTable\"><thead><tr><th>No.</th>\n<th>Initial</th><th>Decription</th><th></th></tr></thead><tbody><tr ng-repeat=\"ref in vm.listRef\"><td width=\"5%\" \nstyle=\"text-align: center\">{{($index + 1)}}</td><td width=\"15%\" style=\"text-align: center\">{{ref.initial}}</td><td>\n{{ref.description}}</td><td width=\"15%\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" \nlayout-wrap><md-button class=\"md-icon-button\" aria-label=\"Edit\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.editData($event, ref)\"><md-icon md-font-icon=\"icon-table-edit\" class=\"blue-500-fg\"></md-icon><md-tooltip>\n<span>click for edit</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.deleteData($event, ref.id)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip><span>click for delete</span></md-tooltip>\n</md-button></section></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/behivor/input/input.html","<div id=\"input\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header Oct\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-cog\"></md-icon></span><span class=\"logo-text\"><span>\nInput Periode {{vm.currentDate}}</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\">\n</div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">Periode</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"period in vm.listPeriod\"><md-button \naria-label=\"{{period.effectiveDate}}\" ng-click=\"vm.showBehivor(period.effectiveDate)\"><span class=\"secondary-text\">\n<span><md-icon ng-if=\"period.effectiveDate == vm.currentDate\" md-font-icon=\"icon-check\"></md-icon><md-icon \nng-if=\"!period.effectiveDate\"></md-icon>{{period.effectiveDate}}</span></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div><div class=\"content\"><div id=\"inputView\" class=\"md-whiteframe-4dp\" \nlayout=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \naria-label=\"add input\" ng-click=\"vm.addData($event)\" ng-if=\"!vm.totalResult\">Input Performance<md-tooltip><span>\nclick this button to Add input</span></md-tooltip></md-button><md-button class=\"md-raised\" aria-label=\"add input\" \nng-click=\"vm.editData($event)\" ng-if=\"vm.totalResult\">Edit Performance<md-tooltip><span>click this button to Add input\n</span></md-tooltip></md-button></div><table class=\"simple\" ms-responsive-table id=\"inputTable\"><thead><tr><th>No.</th>\n<th>Result</th><th>Reference</th><th>Description</th></tr></thead><tbody><tr ng-repeat=\"input in vm.listInput\"><td \nstyle=\"text-align: center\">{{($index + 1)}}</td><td>{{input.result}}</td><td>{{input.initial}}</td><td>\n{{input.description}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/development/download/download.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">GHK Holiday</md-subheader><div class=\"white-bg\"><div class=\"content\"><div layout-xs=\"column\" \nlayout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><button md-button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.ExportAllEmployeetoExcel()\"><i \nclass=\"icon icon-file-excel\"></i> Download Talent Review for All Employee</button> <button md-button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.ExportRcPrToExcel()\"><i \nclass=\"icon icon-file-excel\"></i> Download Competency Review & Potential Review Report</button></div></div></div></div>\n</div></md-content></div>");
$templateCache.put("app/main/elearning/practicalearning/practicalearning-detail.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\"><md-button class=\"md-icon-button launch\" ng-click=\"vm.back()\"><i \nclass=\"icon-chevron-double-left\"></i></md-button>Practical Learning Detail</md-subheader><div class=\"white-bg\">\n<md-content layout=\"column\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Personal Information\">\n<md-content class=\"md-padding\"><div layout-gt-xs=\"row\" layout=\"column\"><fieldset layout-gt-xs=\"column\" layout=\"row\" \nclass=\"form-fieldset\" layout-align=\"start\" layout-padding flex-gt-sm=\"55\" flex><legend>Employee</legend><div \nlayout=\"row\" layout-gt-xs=\"column\" layout-padding><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex><div class=\"md-subhead\"><strong>NIK</strong></div><div class=\"info\">{{vm.personalInformation.nik}}</div>\n<md-divider></md-divider></md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>Nama</strong>\n</div><div class=\"info\">{{vm.personalInformation.emp_name}}</div><md-divider></md-divider></md-input-container>\n<md-input-container flex><div class=\"md-subhead\"><strong>Title</strong></div><div class=\"info\">\n{{vm.personalInformation.bt}}</div><md-divider></md-divider></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex><div class=\"md-subhead\"><strong>Employe Category</strong></div><div \nclass=\"info\">{{vm.personalInformation.emp_category}}</div><md-divider></md-divider></md-input-container>\n<md-input-container flex><div class=\"md-subhead\"><strong>Employe Grade</strong></div><div class=\"info\">\n{{vm.personalInformation.emp_grade}}</div><md-divider></md-divider></md-input-container><md-input-container flex><div \nclass=\"md-subhead\"><strong>Job Grade</strong></div><div class=\"info\">{{vm.personalInformation.job_grade}}</div>\n<md-divider></md-divider></md-input-container></div></div></fieldset><fieldset layout-gt-xs=\"column\" layout=\"row\" \nclass=\"form-fieldset\" layout-align=\"start\" layout-padding flex-gt-sm=\"40\" flex><legend>Modules Pool</legend><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><div class=\"md-subhead\"><strong>Pool Name</strong>\n</div><div class=\"info\">{{vm.personalInformation.pool_name}}</div><md-divider></md-divider></md-input-container>\n<md-input-container flex><div class=\"md-subhead\"><strong>Learning Type</strong></div><element \nng-switch=\"vm.personalInformation.learning_type\"><div class=\"info\" ng-switch-when=\"1\">Competency</div><div \nclass=\"info\" ng-switch-when=\"2\">Matrix Skill</div><div class=\"info\" ng-switch-when=\"3\">Matrix Skill & Competency</div>\n</element><md-divider></md-divider></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex><div class=\"md-subhead\"><strong>Pool Type</strong></div><div class=\"info\">\n{{vm.personalInformation.pool_type}}</div><md-divider></md-divider></md-input-container><md-input-container flex><div \nclass=\"md-subhead\"><strong>Start Date</strong></div><div class=\"info\">{{vm.personalInformation.start_date}}</div>\n<md-divider></md-divider></md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>Start Date\n</strong></div><div class=\"info\">{{vm.personalInformation.end_date}}</div><md-divider></md-divider>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><div \nclass=\"md-subhead\"><strong>Pre Test Status</strong></div><element \nng-switch=\"vm.personalInformation.pre_test.test_status\"><div class=\"info\" ng-switch-when=\"0\">Not Pass</div><div \nclass=\"info\" ng-switch-when=\"1\">Pass</div></element><md-divider></md-divider></md-input-container><md-input-container \nflex><div class=\"md-subhead\"><strong>Pre Test Score</strong></div><div class=\"info\">\n{{vm.personalInformation.pre_test.score}}</div><md-divider></md-divider></md-input-container><md-input-container flex>\n<div class=\"md-subhead\"><strong>Post Test Status</strong></div><element \nng-switch=\"vm.personalInformation.post_test.test_status\"><div class=\"info\" ng-switch-when=\"0\">Not Pass</div><div \nclass=\"info\" ng-switch-when=\"1\">Pass</div></element><md-divider></md-divider></md-input-container><md-input-container \nflex><div class=\"md-subhead\"><strong>Post Test Score</strong></div><div class=\"info\">\n{{vm.personalInformation.post_test.score}}</div><md-divider></md-divider></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><div class=\"md-subhead\"><strong>Pool Description\n</strong></div><div class=\"info\">{{vm.personalInformation.module_pool_description}}</div><md-divider></md-divider>\n</md-input-container></div></fieldset></div><div layout-gt-xs=\"row\" layout=\"column\"><fieldset layout=\"column\" \nclass=\"form-fieldset\" layout-align=\"start\" layout-padding flex><legend>Modules List</legend><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>TITLE</th>\n<th>TYPE</th><th>NEED ASSESMENT</th><th>ASSESMENT PARAMETER</th><th>ASSESMENT DURATION</th><th>SCORE</th><th>STATUS\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.modulePoolList\" ng-class=\"div.mpn_class\"><td>{{ ls.module_title }}\n</td><td>{{ ls.module_type }}</td><td ng-switch=\"ls.is_need_assesment\"><element ng-switch-when=\"0\">No</element><element\n ng-switch-when=\"1\">Yes</element></td><td ng-switch=\"ls.is_need_assesment\"><element ng-switch-when=\"0\">-</element>\n<element ng-switch-when=\"1\">{{ ls.assesment_parameter }}</element></td><td ng-switch=\"ls.is_need_assesment\"><element \nng-switch-when=\"0\">-</element><element ng-switch-when=\"1\">{{ ls.assesment_duration }}</element></td><td \nng-switch=\"ls.is_need_assesment\"><element ng-switch-when=\"0\">-</element><element ng-switch-when=\"1\">{{ ls.score }}\n</element></td><td ng-switch=\"ls.assesment_status\"><element ng-switch-when=\"0\">Not Pass</element><element \nng-switch-when=\"1\">Pass</element><element ng-switch-default>-</element></td></tr></tbody></table></fieldset></div>\n</md-content></md-tab><md-tab label=\"Competencies\"><md-content class=\"md-padding\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>Competency\n</th><th>Start Date</th><th>End Date</th><th>Start Level</th><th>Target Level</th></tr></thead><tbody \nng-repeat=\"row in vm.competenciesList\" ng-class=\"div.mpn_class\"><tr><td><span class=\"p-3 strong\">{{row.competency}}\n</span></td><td><span class=\"p-4\">{{row.practicePool[0].start_date}}</span></td><td><span class=\"p-4\">\n{{row.practicePool[0].end_date}}</span></td><td style=\"text-align: right\"><span class=\"p-4\">{{row.start_level}}</span>\n</td><td style=\"text-align: right\"><span class=\"p-4\">{{row.target_level}}</span></td></tr><tr><td colspan=\"5\">\n<fieldset><legend>Practice List</legend><div class=\"practice-container\"><md-list ng-cloak><md-list-item \nng-repeat=\"pool in row.practicePool\"><p>{{ pool.item_name}}</p><md-checkbox class=\"md-secondary\" \nng-model=\"topping.wanted\" \nng-click=\"vm.approve(pool, vm.personalInformation.job_code, vm.personalInformation.nik, vm.personalInformation.el_module_pool_id)\" \nng-if=\"pool.score != \'1\' \"></md-checkbox><i ng-if=\"pool.score == \'1\' \" class=\"icon-check-bookmark\"></i></md-list-item>\n</md-list></div></fieldset></td></tr></tbody></table></md-content></md-tab><md-tab label=\"Skill Matrix\"><md-content \nclass=\"md-padding\"><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table>\n<thead><tr><th>Skill Indicator</th><th>Success Criteria</th></tr></thead><tbody><tr \nng-repeat=\"row in vm.skillIndicatorList\"><td><span class=\"p-3 strong\">{{row.description}}</span></td><td><span \nclass=\"p-4\">{{row.success_criteria}}</span></td></tr></tbody></table></md-content></md-tab></md-tabs></md-content>\n</div></div></md-content></div>");
$templateCache.put("app/main/elearning/practicalearning/practicalearning.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Practical Learning List Employee</md-subheader><div class=\"white-bg\">\n<md-content layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n class=\"secondary-text\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"50px\">NO</th><th class=\"text-center\">Name</th><th \nclass=\"text-center\">Position</th><th class=\"text-center\">Pool Name</th><th class=\"text-center\">Pool Type</th><th \nclass=\"text-center\" width=\"50px\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editData(ls)\"><td class=\"text-center\"><span style=\"font-weight: bold\">{{$index+1}}</span></td><td>\n{{ls.nik}} - {{ls.nama}}</td><td>{{ls.position}}</td><td>{{ls.pool_name}}</td><td>{{ls.pool_type}}</td><td \nwidth=\"50px\"><md-button class=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.viewDetail(ls.id)\"><span>Detail</span></md-button></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/echeckin/bahasa/bahasa.html","<md-toolbar md-theme=\"table-toolbar-theme\" class=\"md-white-bg\" style=\"min-height: 10px\"><div class=\"start-align\">\n<md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect md-hue-2\" \nng-click=\"vm.goBack()\" show-gt-sm type=\"button\" aria-label=\"Inert\"><md-icon md-font-icon=\"icon-undo\"></md-icon>Kembali\n</md-button><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.openInputLanguage($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle\"></md-icon>Tambah</md-button><md-button \nclass=\"md-button md-ink-ripple md-warn md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon>Hapus</md-button></div></md-toolbar><div class=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\">Bahasa</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tingkatan</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listData\" ng-dblclick=\"vm.editInputLanguage($event,div)\" ng-click=\"vm.checkone(div)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td \nclass=\"text-center\">{{ ($index + 1)}}</td><td>{{ div.language_code | uppercase}}</td><td>{{ div.level | uppercase}}\n</td></tr></tbody></table></div>");
$templateCache.put("app/main/echeckin/bahasa/inputbahasa.html","<md-dialog aria-label=\"Form Input Language\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"langForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,langForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Bahasa</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Bahasa</label><md-select ng-model=\"vm.Form.objForm.languageCode\" \nng-required=\"true\" name=\"language\"><md-option ng-repeat=\"lang in vm.listLang\" ng-value=\"lang.languagename\">\n{{lang.languagename}}</md-option></md-select><div ng-messages=\"profilForm.language.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Bahasa harus di pilih.</span></div></div></md-input-container><md-input-container flex>\n<label>Level</label><md-select ng-model=\"vm.Form.objForm.level\" ng-required=\"true\" name=\"level\"><md-option \nvalue=\"beginner\">Pemula</md-option><md-option value=\"intermediate\">Menengah</md-option><md-option value=\"advanced\">\nMahir</md-option></md-select><div ng-messages=\"profilForm.level.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLevel harus di pilih.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"langForm.$invalid || langForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/bank/bank.html","<div layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\"><div class=\"form-wrapper md-whiteframe-1dp\" \nflex-gt-sm=\"80\" flex-sm=\"90\" flex-gt-xs=\"100\" flex-xs=\"100\"><form name=\"bankForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(bankForm)\"><div layout=\"row\" layout-align=\"end center\"><md-button \nui-sref=\"app.echeckin.dashboard\" type=\"button\" md-no-ink class=\"md-raised md-hue-2\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-undo\"></md-icon>Kembali</md-button><md-button ng-if=\"!vm.stateEdit\" ng-click=\"vm.ChangeState()\" \ntype=\"button\" class=\"md-raised md-blue-500-bg white-fg mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \naria-label=\"Submit\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Edit</md-button><md-button ng-if=\"vm.stateEdit\" \nng-click=\"vm.ChangeState()\" type=\"button\" \nclass=\"md-raised md-orange-500-bg white-fg mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \naria-label=\"Submit\"><md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>Cancel Edit</md-button><md-button \nng-if=\"!vm.check.doc_mandiri && !hasUpload && vm.Form.objForm.accountNumber!=null\" \nng-click=\"vm.uploadAccMandiri($event)\" type=\"button\" \nclass=\"md-raised md-grey-500-bg white-fg mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \naria-label=\"Submit\" ng-disabled=\"vm.Form.objForm.accountNumber==null\">Upload Acc Mandiri</md-button><md-button \nng-if=\"vm.check.doc_mandiri\" ng-click=\"vm.viewDokumen($event,vm.Form.objForm.link)\" type=\"button\" \nclass=\"md-raised md-green-300-bg white-fg\" aria-label=\"View NPWP\">View Account Mandiri</md-button></div><div \nclass=\"form-title\">Bank</div><md-input-container flex><md-radio-group ng-model=\"vm.Form.objForm.acc_mandiri\" \nname=\"acc_mandiri\" ng-change=\"vm.changeNpwp()\" ng-disabled=\"true\"><md-radio-button value=\"1\" class=\"md-warn md-raised\">\nMemiliki Account Mandiri</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"0\" class=\"md-warn md-raised\">\nTidak Memiliki Account Mandiri</md-radio-button>&nbsp;&nbsp;</md-radio-group></md-input-container><md-input-container \nclass=\"md-block\"><label>Nama Bank {{vm.Form.objForm.bankName}}</label><input ng-model=\"vm.Form.objForm.bankName\" \nmd-maxlength=\"45\" required placeholder=\"Nama Bank\" name=\"bankName\" readonly=\"readonly\"><div \nng-messages=\"bankForm.bankName.$error\" role=\"alert\"><div ng-message=\"required\"><span>Nama Bank harus di isi.</span>\n</div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 45 huruf.</span></div></div></md-input-container>\n<md-input-container md-no-float class=\"md-block\" style=\"padding-bottom:20px\"><label>Currency</label><md-select \nname=\"currency\" ng-model=\"vm.Form.objForm.currency\" required ng-disabled=\"!vm.stateEdit\"><md-option \nng-repeat=\"doc in vm.listCurrency\" ng-value=\"doc.currency\">{{doc.currency}}</md-option></md-select>\n</md-input-container><md-input-container md-no-float class=\"md-block\"><label>Nama Cabang</label><input \nng-model=\"vm.Form.objForm.branchName\" required placeholder=\"Nama Cabang\" md-maxlength=\"45\" name=\"branchName\" \nng-disabled=\"!vm.stateEdit\"><div ng-messages=\"bankForm.branchName.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Nama Cabang harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 45 huruf.\n</span></div></div></md-input-container><md-input-container md-no-float class=\"md-block\"><label>No Rekening</label>\n<input ng-model=\"vm.Form.objForm.accountNumber\" required placeholder=\"No Rekening\" md-maxlength=\"45\" \nname=\"accountNumber\" ng-disabled=\"!vm.stateEdit\"><div ng-messages=\"bankForm.accountNumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>No Rekening harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 45 huruf.</span></div></div></md-input-container><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><div \nlayout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.stateEdit\" type=\"submit\" \nng-disabled=\"bankForm.$invalid || bankForm.$pristine\" class=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\">\nUpdate</md-button></div></form></div></div>");
$templateCache.put("app/main/echeckin/bank/upload.html","<md-dialog aria-label=\"Form Upload Pajak\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadAccMandiri\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Upload Account</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container flex><label>Tanggal Dikeluarkan</label>\n<md-datepicker name=\"issuedDate\" ng-change=\"vm.ChangeDate()\" md-hide-icons=\"calendar\" ng-model=\"vm.issuedDate\" \nrequired></md-datepicker><div ng-messages=\"uploadAccMandiri.issuedDate.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tanggal harus di isi.</span></div></div></md-input-container><md-input-container md-no-float class=\"md-block\">\n<input type=\"file\" id=\"uploadAccMandiri\" nv-file-select required uploader=\"vm.FileUploaderAccMandiri\" \noptions=\"{ formData: [{\n          action: \'uploadijazah\',\n          documentNo: vm.documentNo,\n          empID:vm.empID,\n          typeOfDocument: \'9\',\n          docSeumurhidup:true,\n          expiredDate: \'9999-12-31\',\n          issuedDate: vm.issuedDate,\n          description: vm.description\n        }]}\">\n <small>Max file upload 2Mb</small><md-whiteframe ng-show=\"vm.uploadAccMandiriStateError\" \nclass=\"md-whiteframe-1dp md-red-500-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.uploadAccMandiriStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadAccMandiri.$invalid\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/alamat/alamat.html","<div layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\"><div class=\"form-wrapper md-whiteframe-1dp\" \nflex-gt-sm=\"80\" flex-sm=\"90\" flex-gt-xs=\"100\" flex-xs=\"100\"><form name=\"alamatForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveAddress(alamatForm)\"><div layout=\"row\" layout-align=\"end center\"><md-button \nui-sref=\"app.echeckin.dashboard\" type=\"button\" md-no-ink class=\"md-raised md-hue-2\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-undo\"></md-icon>Kembali</md-button><md-button ng-if=\"!vm.stateEdit\" ng-click=\"vm.ChangeState()\" \ntype=\"button\" class=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon>Edit</md-button><md-button ng-if=\"vm.stateEdit\" ng-click=\"vm.ChangeState()\" type=\"button\" \nclass=\"md-raised md-yellow-300-bg black-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>Cancel Edit</md-button></div><div class=\"form-title\">Alamat KTP</div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-checkbox ng-checked=\"vm.checkKTP\" data-ng-readonly=\"true\" \nng-true-value=\"\'Sudah Upload KTP\'\" ng-flase-value=\"\'Belum Upload KTP\'\" ng-disabled=\"!vm.checkKTP\" \naria-label=\"Checkbox 1\" readonly=\"readonly\" name=\"checkKTP\" required><span ng-if=\"!vm.checkKTP\" \nstyle=\"color:#D32F2F; cursor:default\">Sebelum melengkapi data alamat, anda harus upload file KTP</span> <span \nng-if=\"vm.checkKTP\" style=\"color:#00C853; cursor:default\">Sudah Upload KTP</span></md-checkbox></div><div \nng-if=\"vm.stateEdit\"><md-menu class=\"\"><md-button aria-label=\"Open menu with custom trigger\" \nclass=\"{{vm.checkKTP?\'md-green-500-bg\':\'md-red-A400-bg\'}} md-button\" ng-mouseenter=\"$mdMenu.open()\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"md-font icon-archive material-icons\"></md-icon><span \nng-mouseenter=\"$mdMenu.open()\">{{vm.checkKTP?\'View ID/KTP\':\'Upload ID/KTP\'}}</span></md-button><md-menu-content \nwidth=\"4\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item ng-if=\"!vm.checkKTP\"><md-button \nclass=\"md-button md-ink-ripple md-primary md-hue-2\" ng-click=\"vm.Uploadktp($event)\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>UPLOAD</md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.checkKTP\"><md-button class=\"md-button md-ink-ripple md-primary\" ng-click=\"vm.editKTP($event)\">\n<md-icon md-font-icon=\"icon-edit\" class=\"md-font icon-archive material-icons\"></md-icon>EDIT</md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.checkKTP\"><md-button class=\"md-button md-ink-ripple md-accent\" ng-click=\"vm.viewDoc($event)\">\n<md-icon md-font-icon=\"icon-eye\" class=\"md-font icon-archive material-icons\"></md-icon>VIEW</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nAlamat KTP</label><textarea ng-model=\"vm.Form.objForm.addressKtp\" name=\"addressKtp\" md-maxlength=\"150\" max-rows=\"5\" \nng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required></textarea><div ng-messages=\"alamatForm.addressKtp.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Alamat Harus Diisi.</span></div><div \nng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 150 huruf.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Telepon</label><input \nng-model=\"vm.Form.objForm.phoneKtp\" name=\"phoneKtp\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\"></md-input-container>\n<md-input-container flex><label>Kode Pos</label><input ng-model=\"vm.Form.objForm.kodePosKtp\" name=\"kodePosKtp\" \nrequired ng-disabled=\"!vm.stateEdit || !vm.checkKTP\"><div ng-messages=\"alamatForm.kodePosKtp.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Kode Pos Harus Diisi.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>PROVINSI</label><md-select \nng-model=\"vm.Form.objForm.provinsiKtp\" ng-change=\"vm.loadKabKtp(vm.Form.objForm.provinsiKtp)\" name=\"provinsiKtp\" \nng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option ng-repeat=\"prov in vm.listProvince\" \nng-value=\"prov.lokasi_kode\">{{prov.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.provinsiKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nProvinsi Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>KABUPATEN / KOTA</label>\n<md-select ng-model=\"vm.Form.objForm.kabKotaKtp\" name=\"kabKotaKtp\" \nng-change=\"vm.loadKecKtp(vm.Form.objForm.kabKotaKtp)\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option \nng-repeat=\"kab in vm.listKabKtp\" ng-value=\"kab.lokasi_kode\">{{kab.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.kabKotaKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nKabupaten / Kota Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>KECAMATAN</label>\n<md-select ng-model=\"vm.Form.objForm.kecKtp\" name=\"kecKtp\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required>\n<md-option ng-repeat=\"kec in vm.listKecKtp\" ng-value=\"kec.lokasi_kode\">{{kec.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.kecKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nKecamatan Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>KELURAHAN</label><input \nng-model=\"vm.Form.objForm.kelurahanKtp\" name=\"kelurahanKtp\" required ng-disabled=\"!vm.stateEdit || !vm.checkKTP\"><div \nng-messages=\"alamatForm.kelurahanKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nKelurahan Harus Diisi.</span></div></div></md-input-container></div><div class=\"form-title\">Alamat Sekarang</div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.alamatsekarangdigunakan\" ng-change=\"vm.alamatsekarang()\" ng-required=\"true\" \nname=\"alamatsekarangdigunakan\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\"><md-radio-button value=\"noktp\" \nclass=\"md-warn md-raised\">Tidak Sama Dengan KTP</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"ktp\" \nclass=\"md-warn md-raised\">Sama Dengan KTP</md-radio-button>&nbsp;&nbsp;</md-radio-group><div \nng-messages=\"alamatForm.alamatsekarangdigunakan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Pilih salah satu.\n</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><label>Alamat Sekarang</label>\n<textarea ng-model=\"vm.Form.objForm.addressCurrent\" name=\"addressCurrent\" md-maxlength=\"150\" max-rows=\"5\" required \nng-disabled=\"!vm.stateEdit || !vm.checkKTP\"></textarea><div ng-messages=\"alamatForm.addressCurrent.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Alamat Harus Diisi.</span></div><div \nng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 150 huruf.</span></div></div></md-input-container><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Telepon</label><input \nng-model=\"vm.Form.objForm.phoneCurrent\" name=\"phoneCurrent\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\">\n</md-input-container><md-input-container flex><label>Kode Pos</label><input ng-model=\"vm.Form.objForm.kodePosCurrent\" \nname=\"kodePosCurrent\" required ng-disabled=\"!vm.stateEdit\"><div ng-messages=\"alamatForm.kodePosCurrent.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Kode Pos Harus Diisi.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>PROVINSI</label>\n<md-select ng-model=\"vm.Form.objForm.provinsiCurrent\" ng-change=\"vm.loadKab(vm.Form.objForm.provinsiCurrent)\" \nname=\"provinsiCurrent\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option \nng-repeat=\"prov in vm.listProvince\" ng-value=\"prov.lokasi_kode\">{{prov.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.provinsiCurrent.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRW Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>KABUPATEN / KOTA</label>\n<md-select ng-model=\"vm.Form.objForm.kabKotaCurrent\" name=\"kabKotaCurrent\" \nng-change=\"vm.loadKec(vm.Form.objForm.kabKotaCurrent)\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option \nng-repeat=\"kab in vm.listKab\" ng-value=\"kab.lokasi_kode\">{{kab.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.kabKotaCurrent.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nRW Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>KECAMATAN</label><md-select \nng-model=\"vm.Form.objForm.kecCurrent\" name=\"kecCurrent\" ng-change=\"vm.loadKel(vm.Form.objForm.kecCurrent)\" \nng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option ng-repeat=\"kec in vm.listKec\" \nng-value=\"kec.lokasi_kode\">{{kec.lokasi_nama}}</md-option></md-select><div ng-messages=\"alamatForm.kecCurrent.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>RW Harus Diisi.</span></div></div>\n</md-input-container><md-input-container flex><label>KELURAHAN</label><input \nng-model=\"vm.Form.objForm.kelurahanCurrent\" name=\"kelurahanCurrent\" required \nng-disabled=\"!vm.stateEdit || !vm.checkKTP\"><div ng-messages=\"alamatForm.kelurahanCurrent.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Kelurahan Harus Diisi.</span></div></div></md-input-container>\n</div><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" \nclass=\"fade\"><ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front>\n</ms-widget><div layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.stateEdit\" type=\"submit\" \nclass=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\" \nng-disabled=\"alamatForm.$invalid || alamatForm.$pristine || !vm.checkKTP\">Update</md-button></div></form></div></div>");
$templateCache.put("app/main/echeckin/alamat/upload-ktp.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Upload ID/KTP</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container md-no-float class=\"md-block\"><label>\nID No</label><input ng-model=\"vm.documentNo\" name=\"documentNo\" readonly=\"readonly\" required md-maxlength=\"100\"><div \nng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Dokumen No harus di isi.\n</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div></div>\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-inpur-container flex><md-checkbox \nng-model=\"vm.seumurhidupChecked\" ng-change=\"vm.isChecked()\" aria-label=\"Checkbox 1\"></md-checkbox><label>\nBerlaku Seumur Hidup</label></md-inpur-container><md-input-container ng-if=\"!vm.seumurhidupChecked\" flex><label>\nBerlaku Dari</label><md-datepicker name=\"issuedDate\" md-hide-icons=\"calendar\" ng-model=\"vm.issuedDate\" required>\n</md-datepicker><div ng-messages=\"uploadPhoto.issuedDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal harus di isi.</span></div></div></md-input-container><md-input-container ng-if=\"!vm.seumurhidupChecked\" flex>\n<label>Berlaku Sampai</label><md-datepicker name=\"expiredDate\" md-hide-icons=\"calendar\" ng-model=\"vm.expiredDate\">\n</md-datepicker><div ng-messages=\"uploadPhoto.expiredDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal harus di isi.</span></div></div></md-input-container><md-input-container ng-if=\"vm.seumurhidupChecked\" flex>\n<label>Tanggal KTP Diterbitkan</label><md-datepicker name=\"issuedDate\" md-hide-icons=\"calendar\" \nng-model=\"vm.issuedDate\" required></md-datepicker><div ng-messages=\"uploadPhoto.issuedDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tanggal harus di isi.</span></div></div></md-input-container></div><md-input-container \nmd-no-float class=\"md-block\"><label>Description</label><input ng-model=\"vm.description\" name=\"description\">\n</md-input-container><md-input-container md-no-float class=\"md-block\"><input type=\"file\" multiple=\"multiple\" \nid=\"uploadPhoto\" name=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadktp\',typeOfDocument:vm.typeOfDocument,documentNo:vm.documentNo,description:vm.description,issuedDate:vm.issuedDate,expiredDate:vm.expiredDate,empID:vm.empID,ktpSeumurHidup:vm.ktpSeumurHidup}] }\">\n <small>file Size : {{vm.sizefile/1024/1024 | number:2 }} MB of Max file upload 2Mb</small><div \nng-messages=\"uploadPhoto.uploadPhoto.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.sizefile>2097152\"><span>\nMaximum file size 2 MB</span></div></div><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid || uploadPhoto.$pristine || vm.sizefile>2097152\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/alamat/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span translate=\"MYPROFILE.MENU.VIEWKTP\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" \nclass=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content>\n<md-dialog-content ng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><img \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\">\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/echeckin/dashboard/dashboard.html","<div class=\"alert-info success italic md-body-1\" ng-if=\"vm.check.submit==1\"><div layout=\"row\" flex=\"100\"><div \nclass=\"alert-dashboard\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-check\" class=\"s16 green-900-fg\"></md-icon>\nTerimakasih. Data-data anda sudah terkirim dan tidak bisa diubah kembali</p></div></div></div><div layout=\"row\" \nlayout-align=\"end end\" style=\"padding: 0px\"><md-button type=\"button\" class=\"md-raised blue-200-bg white-fg\" \naria-label=\"Helpdesk\" ng-click=\"vm.helpdesk()\"><md-icon md-font-icon=\"icon-phone\" class=\"s24\"></md-icon>Helpdesk\n</md-button><form name=\"submitForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($this,submitForm)\"><input \ntype=\"hidden\" ng-model=\"vm.Form.objForm.submit\" name=\"submit\"><md-button type=\"submit\" \nng-disabled=\"!vm.check.complete || vm.check.submit==1\" \nclass=\"md-raised md-{{vm.check.submit==1?\'green-200\':(vm.check.complete?\'green-800\':\'grey-300\')}}-bg white-fg\" \naria-label=\"Submit\">{{vm.check.submit==1?\'submited\':\'submit\'}}</md-button></form></div><div \nclass=\"alert-info warning italic md-body-1\" ng-if=\"!vm.check.complete || vm.check.submit==0 \"><div layout=\"row\" \nflex=\"100\" ng-if=\"vm.check.complete && vm.check.submit==0\"><div class=\"alert-dashboard\" style=\"text-align: center\"><p \nclass=\"form-messages\">Jika data anda sudah lengkap, klik tombol submit untuk melanjutkan proses echeckin</p></div>\n</div><div layout=\"row\" layout-align=\"center start\"><div flex=\"100\"><ul class=\"dashboard-notif\"><li \nng-if=\"!vm.cek_profiles\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>\nData Profile Belum Lengkap</li><li ng-if=\"!vm.cek_address\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Data Alamat Belum Lengkap</li><li ng-if=\"!vm.cek_education\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>Data Pendidikan Belum Lengkap</li>\n<li ng-if=\"!vm.cek_doc_ijazah\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\">\n</md-icon>Anda Belum Upload Ijazah</li><li ng-if=\"!vm.cek_experience\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Data Pengalaman Kerja Belum Lengkap</li><li \nng-if=\"!vm.cek_dependents\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>\nData Keluarga Belum Lengkap</li><li ng-if=\"!vm.check.doc_kk\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Anda Belum Upload Kartu keluarga</li><li \nng-if=\"!vm.check.doc_buku_nikah\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\">\n</md-icon>Anda Belum Upload Buku Nikah</li><li ng-if=\"!vm.cek_bank\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Data Bank Belum Lengkap</li><li ng-if=\"!vm.doc_mandiri\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>\nAnda Belum Upload Account Bank Mandiri</li><li ng-if=\"!vm.cek_tax\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Data Pajak Belum Lengkap</li><li ng-if=\"!vm.check.doc_npwp\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>Anda Belum Upload NPWP</li><li \nng-if=\"!vm.cek_emergency\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>\nInfo Darurat Anda Belum Lengkap</li><li ng-if=\"!vm.cek_doc_ktp\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Anda Belum Upload KTP</li><li ng-if=\"!vm.cek_doc_sim\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>Anda Belum Upload SIM</li><li \nng-if=\"!vm.cek_jamsostek\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>\nAnda Belum Upload Jamsostek</li><li ng-if=\"!vm.cek_doc_bpjs\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Anda Belum Upload BPJS</li></ul></div></div></div><div \nng-if=\"vm.check.submit==0\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\">\n<ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\">\n<ms-widget-front class=\"p-16 blue\" layout=\"row\" flex ng-click=\"vm.profile()\"><div class=\"pt-7 pb-7\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-home\" class=\"s48\"></md-icon>\n</div><div class=\"font-weight-500 secondary-text\">Profil</div><md-tooltip ng-if=\"!vm.cek_profiles\" md-direction=\"top\">\nProfile Anda Belum Lengkap</md-tooltip></div></ms-widget-front><span ng-if=\"!vm.cek_profiles\" \nclass=\"notification_badge\">!</span></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" \nflex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front class=\"p-16 cyan\" layout=\"row\" flex \nng-click=\"vm.alamat()\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-map-marker\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Alamat</div><md-tooltip ng-if=\"!vm.cek_address\" md-direction=\"top\">\nAlamat Anda Belum Lengkap</md-tooltip><md-tooltip ng-if=\"!vm.cek_doc_ktp\" md-direction=\"top\">Anda Belum Upload KTP\n</md-tooltip></div></ms-widget-front><span ng-if=\"!vm.cek_address || !vm.cek_doc_ktp\" class=\"notification_badge\">!\n</span></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" \nflex-gt-md=\"10\"><ms-widget-front class=\"p-16 teal\" layout=\"row\" flex ng-click=\"vm.pendidikan()\"><div class=\"pt-8 pb-8\" \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-school\" \nclass=\"s48\"></md-icon></div><div class=\"font-weight-500 secondary-text\">Pendidikan</div><md-tooltip \nng-if=\"!vm.cek_education\" md-direction=\"top\">Data Pendidikan Anda Belum Lengkap</md-tooltip><md-tooltip \nng-if=\"!vm.cek_doc_ijazah\" md-direction=\"top\">Anda Belum Upload Ijazah</md-tooltip></div></ms-widget-front><span \nng-if=\"!vm.cek_education || !vm.cek_doc_ijazah\" class=\"notification_badge\">!</span></ms-widget><ms-widget \nclass=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 green\" layout=\"row\" flex ng-click=\"vm.pengalamankerja()\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-briefcase-checked\" \nclass=\"s48\"></md-icon></div><div class=\"font-weight-500 secondary-text\">Pengalaman Kerja</div><md-tooltip \nng-if=\"!vm.cek_experience\" md-direction=\"top\">Data Pengalaman Kerja Anda Belum Lengkap</md-tooltip></div>\n</ms-widget-front><span ng-if=\"!vm.cek_experience\" class=\"notification_badge\">!</span></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\"><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 deep-purple\" layout=\"row\" flex ng-click=\"vm.keluarga()\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-human-male-female\" \nclass=\"s48\"></md-icon></div><div class=\"font-weight-500 secondary-text\">Keluarga</div><md-tooltip \nng-if=\"!vm.cek_dependents\" md-direction=\"top\">Data Keluarga Anda Belum Lengkap</md-tooltip><md-tooltip \nng-if=\"!vm.check.doc_kk\" md-direction=\"top\">Anda Belum Upload Kartu keluarga</md-tooltip></div></ms-widget-front><span \nng-if=\"!vm.cek_dependents || !vm.check.doc_kk\" class=\"notification_badge\">!</span></ms-widget><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 purple\" layout=\"row\" flex ng-click=\"vm.bank()\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-bank\" class=\"s48\">\n</md-icon></div><div class=\"font-weight-500 secondary-text\">Bank</div><md-tooltip ng-if=\"!vm.cek_bank\" \nmd-direction=\"top\">Data Bank Anda Belum Lengkap</md-tooltip><md-tooltip ng-if=\"!vm.doc_mandiri\" md-direction=\"top\">\nAnda Belum Upload Account Bank Mandiri</md-tooltip></div></ms-widget-front><span \nng-if=\"!vm.cek_bank || !vm.doc_mandiri\" class=\"notification_badge\">!</span></ms-widget><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 pink\" layout=\"row\" flex ng-click=\"vm.pajak()\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-cash-multiple\" \nclass=\"s48\"></md-icon></div><div class=\"font-weight-500 secondary-text\">NPWP</div><md-tooltip ng-if=\"!vm.cek_tax\" \nmd-direction=\"top\">Data Pajak Anda Belum Lengkap</md-tooltip><md-tooltip ng-if=\"!vm.check.doc_npwp\" md-direction=\"top\">\nData Pajak Anda Belum Lengkap</md-tooltip></div></ms-widget-front><span ng-if=\"!vm.cek_tax || !vm.check.doc_npwp\" \nclass=\"notification_badge\">!</span></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" \nflex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front class=\"p-16 red\" layout=\"row\" flex \nng-click=\"vm.infogawat()\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-phone\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Info Gawat Darurat</div><md-tooltip ng-if=\"!vm.cek_emergency\" \nmd-direction=\"top\">Data Info Darurat Anda Belum Lengkap</md-tooltip></div></ms-widget-front><span \nng-if=\"!vm.cek_emergency\" class=\"notification_badge\">!</span></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap layout-align=\"center start\"><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" \nflex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front class=\"p-16 orange\" layout=\"row\" flex \nng-click=\"vm.bahasa()\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-comment-processing-outline\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Penguasaan Bahasa</div><md-tooltip ng-if=\"!vm.cek_language\" md-direction=\"top\">\nData Bahasa Anda Belum Lengkap</md-tooltip></div></ms-widget-front><span ng-if=\"!vm.cek_language\" \nclass=\"notification_badge\">!</span></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" \nflex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front class=\"p-16 deep-orange\" layout=\"row\" flex \nng-click=\"vm.training()\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-run\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Training</div><md-tooltip ng-if=\"!vm.cek_training\" md-direction=\"top\">\nData Training Anda Belum Lengkap</md-tooltip></div></ms-widget-front><span ng-if=\"!vm.cek_training\" \nclass=\"notification_badge\">!</span></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" \nflex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front class=\"p-16 brown\" layout=\"row\" flex \nng-click=\"vm.ijazah()\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-file-document\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Salinan Ijazah / Traskrip</div><md-tooltip ng-if=\"!vm.cek_doc_ijazah\" \nmd-direction=\"top\">Data Ijazah / Traskrip Anda Belum Lengkap</md-tooltip></div></ms-widget-front><span \nng-if=\"!vm.cek_doc_ijazah\" class=\"notification_badge\">!</span></ms-widget><ms-widget class=\"h-140\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front class=\"p-16 blue-grey\" \nlayout=\"row\" flex ng-click=\"vm.dokumen()\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div\n class=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-library-books\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Dokumen Penting</div><md-tooltip ng-if=\"!vm.cek_doc_ktp\" md-direction=\"top\">\nAnda Belum Upload KTP</md-tooltip><md-tooltip ng-if=\"!vm.cek_doc_sim\" md-direction=\"top\">Anda Belum Upload SIM\n</md-tooltip><md-tooltip ng-if=\"!vm.check.doc_npwp\" md-direction=\"top\">Anda Belum Upload NPWP</md-tooltip><md-tooltip \nng-if=\"!vm.cek_jamsostek\" md-direction=\"top\">Anda Belum Upload Jamsostek</md-tooltip><md-tooltip \nng-if=\"!vm.check.doc_buku_nikah\" md-direction=\"top\">Anda Belum Upload Buku Nikah</md-tooltip><md-tooltip \nng-if=\"!vm.check.doc_kk\" md-direction=\"top\">Anda Belum Upload Kartu Keluarga</md-tooltip><md-tooltip \nng-if=\"!vm.check.doc_mandiri\" md-direction=\"top\">Anda Belum Upload Account Bank Mandiri</md-tooltip><md-tooltip \nng-if=\"!vm.check.doc_bpjs\" md-direction=\"top\">Anda Belum Upload BPJS</md-tooltip></div></ms-widget-front><span \nng-if=\"!vm.cek_doc_ktp || !vm.cek_doc_sim || !vm.cek_jamsostek || !vm.check.doc_buku_nikah || !vm.check.doc_npwp || !vm.check.doc_kk || !vm.check.doc_mandiri || !vm.check.doc_bpjs\" \nclass=\"notification_badge\">!</span></ms-widget></div></div><div ng-if=\"vm.check.submit==1\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\"><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front class=\"p-16 grey\" layout=\"row\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\"><div class=\"md-display-1 pb-8\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s48\"></md-icon></div><div class=\"font-weight-500 secondary-text\">Profil</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" \nflex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front class=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\"><md-icon \nmd-font-icon=\"icon-map-marker\" class=\"s48\"></md-icon></div><div class=\"font-weight-500 secondary-text\">Alamat</div>\n</div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" \nflex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front class=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-school\" \nclass=\"s48\"></md-icon></div><div class=\"font-weight-500 secondary-text\">Pendidikan</div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" \nflex-gt-md=\"10\"><ms-widget-front class=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-briefcase-checked\" \nclass=\"s48\"></md-icon></div><div class=\"font-weight-500 secondary-text\">Pengalaman Kerja</div></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\"><ms-widget \nclass=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-human-male-female\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Keluarga</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-bank\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Bank</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-cash-multiple\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Pajak</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-phone\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Info Gawat Darurat</div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\"><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-comment-processing-outline\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Penguasaan Bahasa</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-run\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Training</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-file-document\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Salinan Ijazah / Traskrip</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-xs=\"50\" flex-gt-sm=\"20\" flex-gt-md=\"10\"><ms-widget-front \nclass=\"p-16 grey\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-library-books\" class=\"s48\"></md-icon></div><div \nclass=\"font-weight-500 secondary-text\">Dokumen Penting</div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/echeckin/dokumen/dokumen.html","<div layout=\"row\"><div class=\"text-warning\" ng-if=\"!vm.check.doc_buku_nikah\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Belum upload surat/buku nikah</div><div class=\"text-warning\" \nng-if=\"!vm.check.doc_ktp\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>\nBelum upload KTP</div><div class=\"text-warning\" ng-if=\"!vm.check.doc_sim\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Belum upload SIM</div><div class=\"text-warning\" \nng-if=\"!vm.check.doc_ijazah\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\">\n</md-icon>Belum upload Ijazah</div><div class=\"text-warning\" ng-if=\"!vm.check.jamsostek\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>Belum upload Jamsostek</div><div \nclass=\"text-warning\" ng-if=\"!vm.check.doc_kk\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Belum upload Kartu Keluarga</div><div class=\"text-warning\" \nng-if=\"!vm.check.doc_npwp\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"md-ink-ripple md-danger md-mini\"></md-icon>\nBelum upload NPWP</div><div class=\"text-warning\" ng-if=\"!vm.check.doc_bpjs\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Belum upload BPJS</div></div><md-toolbar \nmd-theme=\"table-toolbar-theme\" class=\"md-white-bg\" style=\"min-height: 10px\"><div class=\"start-align\"><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect md-hue-2\" \nng-click=\"vm.goBack()\" show-gt-sm type=\"button\" aria-label=\"Inert\"><md-icon md-font-icon=\"icon-undo\"></md-icon>Kembali\n</md-button><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.openInputEducation($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle\"></md-icon>Tambah</md-button><md-button \nclass=\"md-button md-ink-ripple md-warn md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-ink-ripple md-warn md-mini\"></md-icon>Hapus</md-button></div></md-toolbar><div \nclass=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tipe Dokumen</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">No Dokumen</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Masa Berlaku</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Keterangan</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">View</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listData\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td \nclass=\"text-center\">{{ ($index + 1)}}</td><td>{{ div.typenames | translate | uppercase}}</td><td>{{ div.documentNo}}\n</td><td>{{ div.expired_dateV | translate | uppercase}}</td><td>{{ div.description | uppercase}}</td><td \nclass=\"text-center\"><md-button class=\"md-icon-button launch\" ng-click=\"vm.viewDokumen($event,div.link)\" \ntitle=\"View Dokumen\" aria-label=\"view dokumen\"><md-icon class=\"icon-eye\"></md-icon></md-button></td></tr></tbody>\n</table></div>");
$templateCache.put("app/main/echeckin/dokumen/edit-dokumen.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"uploadPhoto\" class=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Edit Dokumen</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Type Dokumen</label><input \nng-model=\"vm.Form.objForm.typeOfDocument | translate\" name=\"typeOfDocument\" ng-disabled=\"true\" \nplaceholder=\"typeOfDocument\" md-maxlength=\"100\"><div ng-messages=\"uploadPhoto.typeOfDocument.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ini harus di pilih.</span></div></div></md-input-container></div><md-input-container \nmd-no-float class=\"md-block\"><label>Dokumen No</label><input ng-model=\"vm.Form.objForm.documentNo\" name=\"documentNo\" \nplaceholder=\"Dokumen No\" md-maxlength=\"100\"><div ng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Dokumen No harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 100 huruf.</span></div></div></md-input-container><md-input-container md-no-float \nclass=\"md-block\" ng-if=\"vm.showExipred\"><label>Berlaku Sampai</label><md-datepicker name=\"expiredDate\" \nmd-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.expiredDate\"></md-datepicker><div \nng-messages=\"uploadPhoto.expiredDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal harus di isi.</span>\n</div></div></md-input-container><md-input-container md-no-float class=\"md-block\"><label>Description</label><input \nng-model=\"vm.Form.objForm.description\" name=\"description\" placeholder=\"Description\"></md-input-container>\n<md-input-container md-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadijazah\',typeOfDocument:vm.Form.objForm.typeOfDocument,documentNo:vm.Form.objForm.documentNo,description:vm.Form.objForm.description,expiredDate:vm.Form.objForm.expiredDate,empID:vm.Form.objForm.empID,Id:vm.Form.objForm.id}] }\">\n <small>Max file upload 2Mb.</small><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid \"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/dokumen/input-dokumen.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"uploadPhoto\" class=\"md-inline-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Input Dokumen</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nType Dokumen</label><md-select name=\"typeOfDocument\" ng-model=\"vm.Form.objForm.typeOfDocument\" \nng-change=\"vm.changeTypeDoc()\" required><md-option ng-repeat=\"doc in vm.listDoc\" ng-if=\"doc.id !=3 && doc.id !=4\" \nng-value=\"doc.id\">{{doc.typename | translate | uppercase}}</md-option></md-select><div \nng-messages=\"uploadPhoto.typeOfDocument.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ini harus di pilih.\n</span></div></div></md-input-container></div><md-input-container md-no-float class=\"md-block\" ng-if=\"vm.reqno\"><label>\nDokumen No</label><input ng-model=\"vm.Form.objForm.documentNo\" name=\"documentNo\" ng-required=\"vm.reqno\" \nplaceholder=\"Dokumen No\" md-maxlength=\"100\"><div ng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Dokumen No harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 100 huruf.</span></div></div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Tanggal Diterbitkan</label><md-datepicker name=\"issuedDate\" \nng-model=\"vm.Form.objForm.issuedDate\" md-hide-icons=\"calendar\" ng-change=\"vm.changeStarDate()\" required>\n</md-datepicker><div ng-messages=\"uploadPhoto.issuedDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal harus di isi.</span></div></div></md-input-container><md-input-container flex ng-if=\"!vm.docSeumurhidup\">\n<label>Berlaku Sampai</label><md-datepicker name=\"expiredDate\" md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.expiredDate\" md-min-date=\"vm.minDate\" required></md-datepicker><div \nng-messages=\"uploadPhoto.expiredDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal harus di isi.</span>\n</div></div></md-input-container></div><md-input-container md-no-float class=\"md-block\"><label>Description</label>\n<input ng-model=\"vm.Form.objForm.description\" name=\"description\" placeholder=\"Description\"></md-input-container>\n<md-input-container md-no-float class=\"md-block\"><input type=\"file\" name=\"uploadPhoto\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadijazah\',typeOfDocument:vm.Form.objForm.typeOfDocument,documentNo:vm.Form.objForm.documentNo,description:vm.Form.objForm.description,issuedDate:vm.Form.objForm.issuedDate,expiredDate:vm.Form.objForm.expiredDate,empID:vm.Form.objForm.empID,docSeumurhidup:vm.docSeumurhidup}] }\">\n <small>file Size : {{vm.sizefile/1024/1024 | number:2 }} MB of Max file upload 2Mb.</small><div \nng-messages=\"uploadPhoto.uploadPhoto.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.sizefile>2097152\"><span>\nMaximum file size 2 MB</span></div></div><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid || uploadPhoto.$pristine || vm.sizefile>2097152\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/dokumen/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View Document</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/echeckin/helpdesk/form.html","<div layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\"><div class=\"form-wrapper md-whiteframe-1dp\" \nflex-gt-sm=\"80\" flex-sm=\"90\" flex-gt-xs=\"100\" flex-xs=\"100\"><form name=\"form\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(form)\"><div class=\"form-title\">Form Helpdesk</div><md-input-container class=\"md-block\" \nstyle=\"padding-bottom:20px\"><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.notif.success || vm.notif.error\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\" ng-if=\"vm.notif.success\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.notif.success}}</p><p class=\"form-messages\" \nng-if=\"vm.notif.error\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.notif.error}}</p>\n</ms-widget-front></ms-widget></md-input-container><md-input-container class=\"md-block\"><label>Email</label><input \nng-model=\"vm.Form.objForm.email\" md-maxlength=\"100\" required placeholder=\"Email\" name=\"email\" type=\"email\"><div \nng-messages=\"form.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Email harus di isi.</span></div><div \nng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div><div ng-if=\"!form.email.$valid\"><span>\nFormat email tidak valid.</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Pesan\n</label><textarea ng-model=\"vm.Form.objForm.message\" required name=\"message\"></textarea><div \nng-messages=\"form.message.$error\" role=\"alert\"><div ng-message=\"required\"><span>Pesan harus di isi.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.attach\" aria-label=\"Attach Image\">\nAttach Image</md-checkbox></md-input-container><md-input-container md-no-float class=\"md-block\" ng-if=\"vm.attach\">\n<input type=\"file\" id=\"uploadPhoto\" ng-model=\"vm.Form.objForm.image\" nv-file-select uploader=\"vm.FileUploaderPhoto\" \nng-change=\"vm.setUpload($event)\"> <img ng-src=\"{{imageSrc}}\"> <small>Max file upload 2Mb.</small></md-input-container>\n<div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.attach\"><md-button type=\"button\" ng-click=\"vm.upload()\" \nng-disabled=\"form.$invalid || form.$pristine\" class=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\">Submit\n</md-button></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.attach\"><md-button type=\"submit\" \nng-disabled=\"form.$invalid || form.$pristine\" class=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\">Submit\n</md-button></div></form></div></div>");
$templateCache.put("app/main/echeckin/info-gawat/info-gawat.html","<md-toolbar md-theme=\"table-toolbar-theme\" class=\"md-white-bg\" style=\"min-height: 10px\"><div class=\"start-align\">\n<md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect md-hue-2\" \nng-click=\"vm.goBack()\" show-gt-sm type=\"button\" aria-label=\"Inert\"><md-icon md-font-icon=\"icon-undo\"></md-icon>Kembali\n</md-button><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.openInputEducation($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle\"></md-icon>Tambah</md-button><md-button \nclass=\"md-button md-ink-ripple md-warn md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon>Hapus</md-button></div></md-toolbar><div class=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" \nwidth=\"10%\"><div class=\"table-header\"><span class=\"column-title\">Nama</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Alamat</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Telepon</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Hubungan Keluarga</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listData\" ng-dblclick=\"vm.editInputEducation($event,div)\" ng-click=\"vm.checkone(div)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td>\n{{ div.first_name | uppercase}} {{ div.last_name | uppercase}}</td><td>{{ div.address | uppercase}}</td><td \nclass=\"text-center\">{{ div.phone_number}}</td><td>{{ div.type_of_family | uppercase}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/echeckin/info-gawat/input-info-gawat.html","<md-dialog aria-label=\"Form Input Info Gawat Darurat\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form \nng-cloack name=\"infoForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,infoForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Info Gawat Darurat</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" \nname=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Nama Lengkap</label><input ng-model=\"vm.fullname\" name=\"fullname\" required md-maxlength=\"45\"><div \nng-messages=\"infoForm.fullname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Nama Lengkap harus di isi.</span>\n</div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 45 huruf.</span></div></div></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container flex><label>Telepon/HP</label><input \nng-model=\"vm.Form.objForm.phoneNumber\" name=\"phoneNumber\" required placeholder=\"Telepon\"><div \nng-messages=\"infoForm.phoneNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>Telepon harus di isi.</span>\n</div></div></md-input-container><md-input-container flex><label>Hubungan Keluarga</label><input \nng-model=\"vm.Form.objForm.typeOfFamily\" name=\"typeOfFamily\" required placeholder=\"Hubungan Keluarga\"><div \nng-messages=\"infoForm.typeOfFamily.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nHubungan keluarga harus di isi.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Alamat</label><textarea ng-model=\"vm.Form.objForm.address\" md-maxlength=\"250\" \nmax-rows=\"5\" required></textarea><div ng-messages=\"infoForm.address.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Alamat Harus Diisi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 250 huruf.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"infoForm.$invalid || infoForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/keluarga/inputkeluarga.html","<md-dialog aria-label=\"Form Input Keluarga\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"keluargaForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,keluargaForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Keluarga</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" \nname=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Hubungan Keluarga</label><md-select ng-model=\"vm.Form.objForm.typeOfFamily\" \nng-change=\"vm.changeTypeOfFamily()\" ng-required=\"true\" name=\"typeOfFamily\"><md-option ng-repeat=\"p in vm.keluarga\" \nng-value=\"p.id\">{{p.id | uppercase}}</md-option></md-select><div ng-messages=\"keluargaForm.typeOfFamily.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Type family harus di pilih.</span></div></div></md-input-container>\n<md-input-container flex><label>Nama Lengkap</label><input ng-model=\"vm.fullname\" name=\"fullname\" required \nmd-maxlength=\"45\"><div ng-messages=\"keluargaForm.fullname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNama harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 45 huruf.</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Tanggal Lahir</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"dateOfBirth\" ng-required=\"true\" ng-model=\"vm.Form.objForm.dateOfBirth\" required>\n</md-datepicker><div ng-messages=\"keluargaForm.dateOfBirth.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Lahir Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>Tempat Lahir</label>\n<input ng-model=\"vm.Form.objForm.birthPlace\" ng-required=\"true\" md-maxlength=\"100\" name=\"birthPlace\"><div \nng-messages=\"keluargaForm.birthPlace.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 100 huruf.</span></div><div ng-message=\"required\"><span>Tempat Lahir harus diisi.</span></div>\n</div></md-input-container><md-input-container flex><label>Jenis Kelamin</label><md-select \nng-model=\"vm.Form.objForm.gender\" name=\"gender\" ng-disabled=\"vm.genderDisabled\" required><md-option \nng-repeat=\"g in vm.gender\" ng-value=\"g\">{{g}}</md-option></md-select><div ng-messages=\"keluargaForm.gender.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Jenis Kelamin Harus Diisi.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"keluargaForm.$invalid || keluargaForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/keluarga/keluarga.html","<md-toolbar md-theme=\"table-toolbar-theme\" class=\"md-white-bg\" style=\"min-height: 10px\"><div class=\"start-align\">\n<md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect md-hue-2\" \nng-click=\"vm.goBack()\" show-gt-sm type=\"button\" aria-label=\"Inert\"><md-icon md-font-icon=\"icon-undo\"></md-icon>Kembali\n</md-button><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.openInputEducation($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle\"></md-icon>Tambah</md-button><md-button \nclass=\"md-button md-ink-ripple md-warn md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon>Hapus</md-button><md-button ng-if=\"!vm.doc\" \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button-fab mdl-js-ripple-effect md-red-A400-bg\" \nshow-gt-sm type=\"button\" aria-label=\"Upload\" ng-click=\"vm.uploadKK($event)\"><md-tooltip>Wajib Upload KK</md-tooltip>\n<md-icon md-font-icon=\"icon-upload\"></md-icon>UPLOAD KK</md-button><md-button ng-if=\"vm.doc\" \nclass=\"md-button md-ink-ripple md-accent md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Upload\" ng-click=\"vm.viewKK($event)\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\nVIEW KK</md-button></div></md-toolbar><div class=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Hubungan Keluarga</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nama</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tempat Lahir</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tanggal Lahir</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Jenis Kelamin</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listData[0].data\" ng-dblclick=\"vm.editInputEducation($event,div)\" ng-click=\"vm.checkone(div)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td \nclass=\"text-center\">{{ ($index + 1)}}</td><td>{{div.type_of_family | uppercase}}</td><td>\n{{ div.first_name | uppercase}} {{ div.last_name | uppercase}}</td><td>{{ div.birth_place | uppercase}}</td><td \nclass=\"text-center\">{{ div.date_of_birth}}</td><td><span ng-if=\"div.gender==\'L\'\">LAKI LAKI</span> <span \nng-if=\"div.gender==\'P\'\">PEREMPUAN</span></td></tr></tbody></table></div>");
$templateCache.put("app/main/echeckin/keluarga/upload-kk.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>\nUpload Kartu Keluarga</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-input-container md-no-float class=\"md-block\"><label>No Kartu Keluarga</label><input \nng-model=\"vm.Form.objForm.documentNo\" name=\"documentNo\" required placeholder=\"Nomor Kartu Keluarga\" md-maxlength=\"100\">\n<div ng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Dokumen No harus di isi.\n</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div></div>\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Tanggal Dikeluarkan\n</label><md-datepicker name=\"issuedDate\" ng-change=\"vm.ChangeDate()\" md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.issuedDate\" required></md-datepicker><div ng-messages=\"uploadPhoto.issuedDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tanggal harus di isi.</span></div></div></md-input-container></div>\n<md-input-container md-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select required \nuploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadkk\',typeOfDocument:vm.Form.objForm.typeOfDocument,documentNo:vm.Form.objForm.documentNo,description:vm.Form.objForm.description,issuedDate:vm.issuedDate,expiredDate:vm.expiredDate,empID:vm.Form.objForm.empID}] }\">\n <small>file Size : {{vm.sizefile/1024/1024 | number:2 }} MB of Max file upload 2Mb</small><div \nng-messages=\"uploadPhoto.uploadPhoto.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.sizefile>2097152\"><span>\nMaximum file size 2 MB</span></div></div><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid || uploadPhoto.$pristine || vm.sizefile>2097152\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/keluarga/view-kk.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View Kartu Keluarga</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" \nclass=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content>\n<md-dialog-content ng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><img \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\">\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/echeckin/pajak/pajak-upload.html","<md-dialog aria-label=\"Form Upload Pajak\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadNpwp\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Upload ID</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container md-no-float class=\"md-block\"><label>\nID No</label><input ng-model=\"vm.documentNo\" name=\"documentNo\" required md-maxlength=\"100\"><div \nng-messages=\"uploadNpwp.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Dokumen No harus di isi.\n</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div></div>\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Tanggal NPWP Diterbitkan\n</label><md-datepicker name=\"issuedDate\" md-hide-icons=\"calendar\" ng-model=\"vm.issuedDate\" required></md-datepicker>\n<div ng-messages=\"uploadNpwp.issuedDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal harus di isi.\n</span></div></div></md-input-container></div><md-input-container md-no-float class=\"md-block\"><label>Description\n</label><input ng-model=\"vm.description\" name=\"description\"></md-input-container><div class=\"md-block\"><input \ntype=\"file\" id=\"uploadNpwp\" nv-file-select required uploader=\"vm.FileUploaderNpwp\" \noptions=\"{ formData: [{\n          action: \'uploadnpwp\',\n          documentNo: vm.documentNo,\n          empID:vm.empID,\n          typeOfDocument: \'npwp\',\n          expiredDate: \'9999-12-31\',\n          issuedDate: vm.issuedDate,\n          description: vm.description\n        }]}\">\n<br><small>Max size file upload 2Mb</small><md-whiteframe ng-show=\"vm.UploadNpwpStateError\" \nclass=\"md-whiteframe-1dp md-red-500-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadNpwpStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" ng-click=\"vm.upload()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadNpwp.$invalid || uploadNpwp.$pristine\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\">\n</md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/pajak/pajak-view.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View NPWP</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><img style=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" \nsrc=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/echeckin/pajak/pajak.html","<div layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\"><div class=\"form-wrapper md-whiteframe-1dp\" \nflex-gt-sm=\"80\" flex-sm=\"90\" flex-gt-xs=\"100\" flex-xs=\"100\"><form name=\"bankForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(bankForm)\"><div layout=\"row\" layout-align=\"end center\"><md-button \nui-sref=\"app.echeckin.dashboard\" type=\"button\" md-no-ink class=\"md-raised md-hue-2\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-undo\"></md-icon>Kembali</md-button><md-button ng-if=\"!vm.stateEdit\" ng-click=\"vm.ChangeState()\" \ntype=\"button\" class=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon>Edit</md-button><md-button ng-if=\"vm.stateEdit\" ng-click=\"vm.ChangeState()\" type=\"button\" \nclass=\"md-raised md-orange-500-bg white-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>Cancel Edit</md-button></div><div layout=\"row\" layout-align=\"space-between center\"><div class=\"form-title\">\nPajak</div><div ng-if=\"vm.stateEdit\"><md-button \nng-show=\"!vm.check.doc_npwp && !hasUpload && vm.Form.objForm.taxNumber!=null && vm.Form.objForm.taxNumber !=\'-\'\" \nng-click=\"vm.uploadNpwp($event)\" type=\"button\" class=\"md-raised md-grey-500-bg white-fg btn-uplod\" aria-label=\"Submit\">\nUpload NPWP</md-button><md-button ng-if=\"vm.check.doc_npwp\" ng-click=\"vm.viewNpwp($event)\" type=\"button\" \nclass=\"md-raised md-green-300-bg\" aria-label=\"View NPWP\">View NPWP</md-button></div></div><md-input-container flex>\n<md-radio-group ng-model=\"vm.optionNpwp\" name=\"optionNpwp\" ng-change=\"vm.changeNpwp()\" ng-disabled=\"!vm.stateEdit\">\n<md-radio-button value=\"1\" class=\"md-warn md-raised\" ng-disabled=\"true\">Punya NPWP</md-radio-button>&nbsp;&nbsp;\n<md-radio-button value=\"0\" class=\"md-warn md-raised\" ng-disabled=\"true\">Tidak Punya NPWP</md-radio-button>&nbsp;&nbsp;\n</md-radio-group></md-input-container><md-input-container ng-if=\"vm.optionNpwp==\'1\'\" class=\"md-block\"><label>No Pajak\n</label><input ng-model=\"vm.Form.objForm.taxNumber\" md-maxlength=\"50\" required name=\"taxNumber\" \nng-disabled=\"!vm.stateEdit\"><div ng-messages=\"bankForm.taxNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNo Pajak harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 50 huruf.</span></div>\n</div></md-input-container><md-input-container ng-if=\"vm.optionNpwp==\'0\'\" class=\"md-block\"><label>No Pajak</label>\n<input type=\"text\" ng-model=\"vm.Form.objForm.taxNumber\" name=\"taxNumber\" ng-readonly=\"true\"></md-input-container>\n<md-input-container md-no-float class=\"md-block\"><label>Status Pajak</label><input \nng-model=\"vm.Form.objForm.taxStatus\" required placeholder=\"Status Pajak\" md-maxlength=\"45\" name=\"taxStatus\" \nng-disabled=\"!vm.stateEdit\" readonly=\"readonly\"><div ng-messages=\"bankForm.taxStatus.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Status Pajak harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 45 huruf.</span></div></div></md-input-container><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-align=\"center center\"><md-button ng-if=\"vm.stateEdit\" type=\"submit\" \nng-disabled=\"bankForm.$invalid || bankForm.$pristine \" class=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\">\nUpdate</md-button></div></form></div></div>");
$templateCache.put("app/main/echeckin/pendidikan/edit-ijazah.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"uploadPhoto\" class=\"md-inline-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Update Ijazah/ Transkrip</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><md-radio-group ng-model=\"vm.Form.objForm.typeOfDocument\" ng-disabled=\"true\" \nng-required=\"true\" name=\"typeOfDocument\"><md-radio-button value=\"3\" class=\"md-warn md-raised\">Ijazah</md-radio-button>\n&nbsp;&nbsp;<md-radio-button value=\"4\" class=\"md-warn md-raised\">Trasnkrip</md-radio-button>&nbsp;&nbsp;\n</md-radio-group><div ng-messages=\"uploadPhoto.typeOfDocument.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIni harus di pilih.</span></div></div></md-input-container></div><md-input-container md-no-float class=\"md-block\">\n<label>No Ijazah/transkrip</label><input ng-model=\"vm.Form.objForm.documentNo\" name=\"documentNo\" md-maxlength=\"100\">\n<div ng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Dokumen No harus di isi.\n</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div></div>\n</md-input-container><md-input-container md-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" \nnv-file-select uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadijazah\',typeOfDocument:vm.Form.objForm.typeOfDocument,documentNo:vm.Form.objForm.documentNo,description:vm.Form.objForm.description,expiredDate:vm.Form.objForm.expiredDate,empID:vm.Form.objForm.empID,Id:vm.Form.objForm.id}] }\">\n <small>file Size : {{vm.sizefile/1024/1024 | number:2 }} MB of Max file upload 2Mb.</small><div \nng-messages=\"uploadPhoto.uploadPhoto.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.sizefile>2097152\"><span>\nMaximum file size 2 MB</span></div></div><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid || vm.sizefile>2097152\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/pendidikan/input-ijazah.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"uploadPhoto\" class=\"md-inline-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload Ijazah/ Transkrip</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><md-radio-group ng-model=\"vm.Form.objForm.typeOfDocument\" ng-required=\"true\" \nng-disabled=\"true\" name=\"typeOfDocument\"><md-radio-button value=\"3\" class=\"md-warn md-raised\">Ijazah</md-radio-button>\n&nbsp;&nbsp;<md-radio-button value=\"4\" class=\"md-warn md-raised\">Transkrip</md-radio-button>&nbsp;&nbsp;\n</md-radio-group><div ng-messages=\"uploadPhoto.typeOfDocument.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIni harus di pilih.</span></div></div></md-input-container></div><md-input-container md-no-float class=\"md-block\">\n<label>No Ijazah/transkrip</label><input ng-model=\"vm.Form.objForm.documentNo\" name=\"documentNo\" required \nmd-maxlength=\"100\"><div ng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNo Ijazah harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div>\n</div></md-input-container><md-input-container flex><label>Tanggal Diterbitkan</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"issuedDate\" ng-model=\"vm.Form.objForm.issuedDate\" required></md-datepicker><div \nng-messages=\"uploadPhoto.issuedDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Diterbitkan harus diisi</span></div></div></md-input-container><md-input-container md-no-float \nclass=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" aria-label=\"uplaodPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadijazah\',typeOfDocument:vm.Form.objForm.typeOfDocument,documentNo:vm.Form.objForm.documentNo,description:vm.Form.objForm.description,issuedDate:vm.Form.objForm.issuedDate,expiredDate:vm.Form.objForm.expiredDate,empID:vm.Form.objForm.empID}]}\">\n <small>file Size : {{vm.sizefile/1024/1024 | number:2 }} MB of Max file upload 2Mb.</small><div \nng-messages=\"uploadPhoto.uploadPhoto.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.sizefile>2097152\"><span>\nMaximum file size 2 MB</span></div></div><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid || uploadPhoto.$pristine || vm.sizefile>2097152\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/pendidikan/inputpendidikan.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"eduForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,eduForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Pendidikan</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" \nname=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout=\"row\" layout-gt-sm=\"row\">\n<md-autocomplete flex md-no-cache=\"vm.noCache\" md-hide-autocomplete-on-enter md-selected-item=\"vm.schoolID\" \nmd-search-text=\"vm.Form.objForm.schoolName\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getUniversity(vm.Form.objForm.schoolName)\" \nmd-min-length=\"3\" md-input-name=\"schoolID\" md-item-text=\"item.schoolName\" required \nmd-floating-label=\"Nama Sekolah/Universitas\" md-require-match=\"true\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.schoolName\">{{item.schoolName}}</span></md-item-template><md-not-found>\nAjukan nama universitas/sekolah melalui<span><md-button ng-click=\"vm.helpdesk()\">Helpdesk</md-button></span>\n</md-not-found></md-autocomplete><md-input-container flex><label>Jurusan</label><md-select name=\"majority\" \nng-model=\"vm.Form.objForm.majority\" required><md-option ng-repeat=\"p in vm.jurusan\" ng-value=\"p.description\">\n{{p.description}}</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label>Tingkat Pendidikan</label><md-select ng-model=\"vm.Form.objForm.pendidikan\" name=\"pendidikan\" \nng-change=\"vm.changeRequired(vm.Form.objForm.pendidikan)\" required><md-option ng-repeat=\"p in vm.pendidikan\" \nng-value=\"p\">{{p}}</md-option></md-select><div ng-messages=\"eduForm.pendidikan.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Pendidikan Harus Diisi.</span></div></div></md-input-container><md-input-container flex>\n<label>Tahun Masuk</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.startStudy\" required \nng-change=\"vm.ChangeStartStudy()\"></md-datepicker><div ng-messages=\"eduForm.startStudy.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun masuk harus diisi</span></div></div></md-input-container><md-input-container flex>\n<label>Tahun Lulus</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.finishStudy\" \nmd-min-date=\"vm.minDate\" required></md-datepicker><div ng-messages=\"eduForm.finishStudy.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun lulus harus diisi</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>IPK/Nilai Akhir</label><input type=\"number\" name=\"finalGrade\" \nng-model=\"vm.Form.objForm.finalGrade\" required><div ng-messages=\"eduForm.finalGrade.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ini harus di pilih.</span></div></div></md-input-container><md-input-container flex><label>\nGelar</label><input ng-model=\"vm.Form.objForm.eduTitle\" ng-required=\"vm.required\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"eduForm.$invalid || eduForm.$pristine\">Simpan</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/pendidikan/pendidikan.html","<md-toolbar md-theme=\"table-toolbar-theme\" class=\"md-white-bg\" style=\"min-height: 10px\"><div class=\"start-align\">\n<md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect md-hue-2\" \nng-click=\"vm.goBack()\" show-gt-sm type=\"button\" aria-label=\"Inert\"><md-icon md-font-icon=\"icon-undo\"></md-icon>Kembali\n</md-button><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.openInputEducation($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle\"></md-icon>Tambah</md-button><md-button \nclass=\"md-button md-ink-ripple md-warn md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon>Hapus</md-button><md-menu class=\"\"><md-button aria-label=\"Open menu with custom trigger\" \nclass=\"md-button md-ink-ripple md-mini {{vm.ijazah?\'md-accent\':\'md-warn\'}}\" ng-mouseenter=\"$mdMenu.open()\"><md-icon \nid=\"icon-ijazah\" md-font-icon=\"icon-file-document\" class=\"md-font icon-archive material-icons\"></md-icon><span \nng-mouseenter=\"$mdMenu.open()\">{{vm.ijazah?\'\':\'Upload\'}} Ijazah terakhir</span></md-button><md-menu-content width=\"4\" \nng-mouseleave=\"$mdMenu.close()\"><md-menu-item ng-if=\"!vm.ijazah\"><md-button \nclass=\"md-button md-ink-ripple md-primary md-hue-2\" ng-click=\"vm.openInputIjazah($event,3)\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>UPLOAD</md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.ijazah\"><md-button class=\"md-button md-ink-ripple md-primary\" \nng-click=\"vm.editInputIjazah($event, vm.id_ijazah)\"><md-icon md-font-icon=\"icon-edit\" \nclass=\"md-font icon-archive material-icons\"></md-icon>EDIT</md-button></md-menu-item><md-menu-item ng-if=\"vm.ijazah\">\n<md-button class=\"md-button md-ink-ripple md-accent\" ng-click=\"vm.viewIjazahDoc($event,\'ijazah\')\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"md-font icon-archive material-icons\"></md-icon>VIEW</md-button></md-menu-item>\n</md-menu-content></md-menu><span class=\"divider-vertical\"></span><md-menu><md-button \naria-label=\"Open menu with custom trigger\" \nclass=\"md-button md-ink-ripple {{vm.transkrip?\'md-accent\':\'md-warn\'}} md-mini\" ng-mouseenter=\"$mdMenu.open()\"><md-icon \nid=\"icon-ijazah\" md-font-icon=\"icon-file-document\" class=\"md-font icon-archive material-icons\"></md-icon><span \nng-mouseenter=\"$mdMenu.open()\">{{vm.transkrip?\'\':\'Upload\'}} Transkrip Nilai</span></md-button><md-menu-content \nwidth=\"4\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item ng-if=\"!vm.transkrip\"><md-button \nclass=\"md-button md-ink-ripple md-primary md-hue-2\" ng-click=\"vm.openInputIjazah($event,4)\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>UPLOAD</md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.transkrip\"><md-button class=\"md-button md-ink-ripple md-primary\" \nng-click=\"vm.editInputIjazah($event, vm.id_transkrip)\"><md-icon md-font-icon=\"icon-edit\" \nclass=\"md-font icon-archive material-icons\"></md-icon>EDIT</md-button></md-menu-item><md-menu-item \nng-if=\"vm.transkrip\"><md-button class=\"md-button md-ink-ripple md-accent\" \nng-click=\"vm.viewIjazahDoc($event,\'transkrip\')\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"md-font icon-archive material-icons\"></md-icon>VIEW</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><div class=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\">Nama Sekolah / Universitas</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Jurusan</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tingkat Pendidikan</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Gelar</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tahun Masuk</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tahun Lulus</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listData\" ng-dblclick=\"vm.editInputEducation($event,div)\" ng-click=\"vm.checkone(div)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td \nclass=\"text-center\">{{ ($index + 1)}}</td><td>{{ div.school_name}}</td><td>{{ div.majority}}</td><td>\n{{ div.final_grade}}</td><td>{{ div.title}}</td><td class=\"text-center\">{{ div.start_study}}</td><td \nclass=\"text-center\">{{ div.finish_study}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/echeckin/pendidikan/view-ijazah.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View Ijazah</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.ijazah}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/echeckin/pendidikan/view-transkrip.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View Transkrip</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.urll}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.transkrip}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/echeckin/pengalamankerja/inputpengalamankerja.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"expForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,expForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Pengalaman Kerja</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" \nname=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><md-input-container class=\"md-block\">\n<label>Nama Perusahaan</label><input ng-model=\"vm.Form.objForm.companyName\" name=\"companyName\" required \nplaceholder=\"Nama Perusahaan\" md-maxlength=\"150\"><div ng-messages=\"expForm.companyName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Nama Perusahaanharus di isi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 150 huruf.</span></div></div></md-input-container><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Departement</label><input ng-model=\"vm.Form.objForm.departmentName\" name=\"departmentName\" required \nplaceholder=\"Department\" md-maxlength=\"150\"><div ng-messages=\"expForm.departmentName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 150 huruf.</span></div></div></md-input-container><md-input-container flex><label>Section\n</label><input ng-model=\"vm.Form.objForm.sectionName\" name=\"sectionName\" required placeholder=\"Section\" \nmd-maxlength=\"150\"><div ng-messages=\"expForm.sectionName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSection harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 150 huruf.</span></div>\n</div></md-input-container></div><md-input-container class=\"md-block\"><label>Job Description</label><textarea \nng-model=\"vm.Form.objForm.jobDescription\" required placeholder=\"Job Description\" md-maxlength=\"250\" max-rows=\"5\">\n</textarea><div ng-messages=\"expForm.jobDescription.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Job Descrption Harus Diisi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 250 huruf.</span></div></div></md-input-container><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Start</label><md-datepicker md-hide-icons=\"calendar\" name=\"startDate\" ng-model=\"vm.Form.objForm.startDate\" \nrequired ng-change=\"vm.chnageStartDate()\"></md-datepicker></md-input-container><md-input-container flex><label>Finish\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"finishDate\" ng-model=\"vm.Form.objForm.finishDate\" required \nmd-min-date=\"vm.minDate\"></md-datepicker></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"expForm.$invalid || expForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/pengalamankerja/pengalaman-kerja.html","<md-toolbar md-theme=\"table-toolbar-theme\" class=\"md-white-bg\" style=\"min-height: 10px\"><div class=\"start-align\">\n<md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect md-hue-2\" \nng-click=\"vm.goBack()\" show-gt-sm type=\"button\" aria-label=\"Inert\"><md-icon md-font-icon=\"icon-undo\"></md-icon>Kembali\n</md-button><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.openInputEducation($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle\"></md-icon>Tambah</md-button><md-button \nclass=\"md-button md-ink-ripple md-warn md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon>Hapus</md-button></div></md-toolbar><div class=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\">Nama Perusahaan</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Department</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Section</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Job Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Start</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Finish</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listData\" ng-dblclick=\"vm.editInputEducation($event,div)\" ng-click=\"vm.checkone(div)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td \nclass=\"text-center\">{{ ($index + 1)}}</td><td>{{ div.company_name}}</td><td>{{ div.department_name}}</td><td>\n{{ div.section_name}}</td><td><pre>{{ div.job_description}}</pre></td><td class=\"text-center\">{{ div.start_date}}</td>\n<td class=\"text-center\">{{ div.finish_date}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/echeckin/ijazah/edit-ijazah.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-accent hue-3\"><div class=\"md-toolbar-tools\"><h2>Update Ijazah/ Transkrip\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.typeOfDocument\" ng-disabled=\"true\" ng-required=\"true\" name=\"typeOfDocument\"><md-radio-button \nvalue=\"3\" class=\"md-warn md-raised\">Ijazah</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"4\" \nclass=\"md-warn md-raised\">Trasnkrip</md-radio-button>&nbsp;&nbsp;</md-radio-group><div \nng-messages=\"uploadPhoto.typeOfDocument.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ini harus di pilih.\n</span></div></div></md-input-container></div><md-input-container md-no-float class=\"md-block\"><label>Ijazah No</label>\n<input ng-model=\"vm.Form.objForm.documentNo\" name=\"documentNo\" placeholder=\"Ijazah No\" md-maxlength=\"100\"><div \nng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Dokumen No harus di isi.\n</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div></div>\n</md-input-container><md-input-container md-no-float class=\"md-block\"><label>Description</label><input \nng-model=\"vm.Form.objForm.description\" name=\"description\" placeholder=\"Description\"></md-input-container>\n<md-input-container md-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadijazah\',typeOfDocument:vm.Form.objForm.typeOfDocument,documentNo:vm.Form.objForm.documentNo,description:vm.Form.objForm.description,expiredDate:vm.Form.objForm.expiredDate,empID:vm.Form.objForm.empID,Id:vm.Form.objForm.id}] }\">\n <small>Max file upload 2Mb.</small><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid \"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/ijazah/ijazah.html","<md-toolbar md-theme=\"table-toolbar-theme\" class=\"md-white-bg\" style=\"min-height: 10px\"><div class=\"start-align\">\n<md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect md-hue-2\" \nng-click=\"vm.goBack()\" show-gt-sm type=\"button\" aria-label=\"Inert\"><md-icon md-font-icon=\"icon-undo\"></md-icon>Kembali\n</md-button></div></md-toolbar><div class=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tipe Dokumen</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">No Dokument</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Keterangan</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">View</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listData\" \nng-click=\"vm.checkone(div)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" \nchecklist-value=\"div\"></td><td class=\"text-center\">{{ ($index + 1)}}</td><td>{{ div.typename | uppercase}}</td><td>\n{{ div.documentNo}}</td><td>{{ div.description | uppercase}}</td><td class=\"text-center\"><md-button \nclass=\"md-icon-button launch\" ng-click=\"vm.viewDokumen($event,div.link)\" title=\"View Dokumen\" \naria-label=\"view dokumen\"><md-icon class=\"icon-eye\"></md-icon></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/echeckin/ijazah/input-ijazah.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-accent hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload Ijazah/ Transkrip\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.typeOfDocument\" ng-required=\"true\" name=\"typeOfDocument\"><md-radio-button value=\"3\" \nclass=\"md-warn md-raised\">Ijazah</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"4\" class=\"md-warn md-raised\">\nTranskrip</md-radio-button>&nbsp;&nbsp;</md-radio-group><div ng-messages=\"uploadPhoto.typeOfDocument.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Ini harus di pilih.</span></div></div></md-input-container></div>\n<md-input-container md-no-float class=\"md-block\"><label>Ijazah No</label><input ng-model=\"vm.Form.objForm.documentNo\" \nname=\"documentNo\" required placeholder=\"Ijazah No\" md-maxlength=\"100\"><div ng-messages=\"uploadPhoto.documentNo.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Dokumen No harus di isi.</span></div><div ng-message=\"md-maxlength\">\n<span>Tidak boleh lebih dari 100 huruf.</span></div></div></md-input-container><md-input-container md-no-float \nclass=\"md-block\"><label>Description</label><input ng-model=\"vm.Form.objForm.description\" name=\"description\" \nplaceholder=\"Description\"></md-input-container><md-input-container md-no-float class=\"md-block\"><input type=\"file\" \nid=\"uploadPhoto\" nv-file-select uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadijazah\',typeOfDocument:vm.Form.objForm.typeOfDocument,documentNo:vm.Form.objForm.documentNo,description:vm.Form.objForm.description,expiredDate:vm.Form.objForm.expiredDate,empID:vm.Form.objForm.empID}] }\">\n <small>Max file upload 2Mb.</small><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid || uploadPhoto.$pristine\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\">\n</md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/ijazah/view-ijazah.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View Document</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/echeckin/profile/profile.html","<div layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center start\"><div class=\"form-wrapper md-whiteframe-1dp\" \nflex-gt-sm=\"80\" flex-sm=\"90\" flex-gt-xs=\"100\" flex-xs=\"100\"><form name=\"profilForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(profilForm)\"><div class=\"form-title\">Profil</div><div layout=\"row\" layout-align=\"end center\">\n<md-button ui-sref=\"app.echeckin.dashboard\" type=\"button\" md-no-ink class=\"md-raised md-hue-2\" aria-label=\"Submit\">\n<md-icon md-font-icon=\"icon-undo\"></md-icon>Kembali</md-button><md-button ng-if=\"!vm.stateEdit\" \nng-click=\"vm.ChangeState()\" type=\"button\" class=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon>Edit</md-button><md-button ng-if=\"vm.stateEdit\" ng-click=\"vm.ChangeState()\" \ntype=\"button\" class=\"md-raised md-yellow-300-bg black-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\"></md-icon>Batal Edit</md-button></div><div class=\"center\" layout=\"row\" \nlayout-align=\"start center\"><md-card-avatar ng-if=\"!vm.Form.objForm.photo_address\"><img \nsrc=\"assets/images/avatars/profile.jpg\" class=\"profile-image huge avatar profpict\" \nng-click=\"vm.openUploadPhoto($event)\"></md-card-avatar><md-card-avatar ng-if=\"vm.Form.objForm.photo_address\"><img \nsrc=\"api/empdocument/{{vm.Form.objForm.photo_address}}\" ng-click=\"vm.openUploadPhoto($event)\" \nclass=\"profile-image huge avatar profpict\"></md-card-avatar></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><md-radio-group ng-model=\"vm.Form.objForm.title\" ng-change=\"vm.changeTitle()\" \nng-disabled=\"!vm.stateEdit\" ng-required=\"true\" name=\"title\"><md-radio-button value=\"Mr\" class=\"md-warn md-raised\">Mr\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"Mrs\" class=\"md-warn md-raised\">Mrs</md-radio-button>&nbsp;&nbsp;\n<md-radio-button value=\"Miss\" class=\"md-warn md-raised\">Miss</md-radio-button></md-radio-group><div \nng-messages=\"profilForm.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ini harus di pilih.</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"fullname\" ng-model=\"vm.fullname\" placeholder=\"Nama Lengkap\" required md-maxlength=\"200\" \nng-disabled=\"!vm.stateEdit\"><div ng-messages=\"profilForm.fullname.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Nama Lengkap harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 200 huruf.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\">\n<md-input-container flex><input type=\"text\" name=\"nickname\" ng-model=\"vm.Form.objForm.nickName\" \nplaceholder=\"Nama Panggilan\" md-maxlength=\"45\" ng-disabled=\"!vm.stateEdit\"><div \nng-messages=\"profilForm.nickname.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 45 huruf.</span></div></div></md-input-container><md-input-container flex><label>Jenis Kelamin\n</label><md-select ng-model=\"vm.Form.objForm.jenkel\" ng-required=\"true\" name=\"jenkel\" ng-disabled=\"true\"><md-option \nvalue=\"L\">LAKI-LAKI</md-option><md-option value=\"P\">PEREMPUAN</md-option></md-select><div \nng-messages=\"profilForm.jenkel.$error\" role=\"alert\"><div ng-message=\"required\"><span>Jenis Kelamin harus di pilih.\n</span></div></div></md-input-container><md-input-container flex><label>Agama</label><md-select \nng-model=\"vm.Form.objForm.religion\" ng-required=\"true\" name=\"religion\" ng-disabled=\"!vm.stateEdit\"><md-option \nvalue=\"Islam\">ISLAM</md-option><md-option value=\"Kristen Protestan\">KRISTEN PROTESTAN</md-option><md-option \nvalue=\"Katolik\">KATOLIK</md-option><md-option value=\"Hindu\">HINDU</md-option><md-option value=\"Buddha\">BUDHA\n</md-option><md-option value=\"Kong hu cu\">KONG HU CU</md-option></md-select><div \nng-messages=\"profilForm.religion.$error\" role=\"alert\"><div ng-message=\"required\"><span>Agama harus di pilih.</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container \nflex><label>Tanggal Lahir</label><md-datepicker md-hide-icons=\"calendar\" ng-required=\"true\" \nng-model=\"vm.Form.objForm.dateOfBirth\" md-placeholder=\"Tanggal lahir\" name=\"dateOfBirth\" ng-disabled=\"!vm.stateEdit\">\n</md-datepicker><div ng-messages=\"profilForm.dateOfBirth.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Lahir Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>Tempat lahir</label>\n<input ng-model=\"vm.Form.objForm.placeOfBirth\" ng-required=\"true\" md-maxlength=\"100\" name=\"placeOfBirth\" \nng-disabled=\"!vm.stateEdit\"><div ng-messages=\"profilForm.placeOfBirth.$error\" role=\"alert\"><div \nng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div><div ng-message=\"required\"><span>\nTempat lahir Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>Status Pernikahan\n</label><md-select ng-model=\"vm.Form.objForm.maritalStatus\" name=\"maritalStatus\" ng-required=\"true\" \nng-disabled=\"!vm.stateEdit\"><md-option ng-repeat=\"status in vm.maritalStatuses\" ng-value=\"status.id\">\n{{status.value | uppercase}}</md-option></md-select><div ng-messages=\"profilForm.maritalStatus.$error\" role=\"alert\">\n<div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div><div ng-message=\"required\"><span>\nMaritalStatus Harus Diisi.</span></div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-input-container flex><label>Negara Tempat Lahir</label><md-select \nng-model=\"vm.Form.objForm.countrycode_of_birth\" name=\"countrycode_of_birth\" ng-required=\"true\" \nng-disabled=\"!vm.stateEdit\"><md-option ng-repeat=\"country in vm.listCountry\" ng-value=\"country.countrycode\">\n{{country.name}}</md-option></md-select><div ng-messages=\"profilForm.countrycode_of_birth.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Negara Tempat lahir Harus Diisi.</span></div></div></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex><label>Tinggi Badan (CM)</label><input \nng-model=\"vm.Form.objForm.height\" type=\"text\" name=\"height\" min=\"100\" max=\"200\" ng-disabled=\"!vm.stateEdit\" \nng-pattern=\"/^[0-9]*$/\"><div ng-messages=\"profilForm.height.$error\" role=\"alert\"><div ng-message=\"min\"><span>\nMinimum 100 cm.</span></div><div ng-message=\"max\"><span>maximum 200 cm.</span></div><div ng-message=\"pattern\"><span>\nkarakter input tidak izinkan.</span></div></div></md-input-container><md-input-container flex><label>Golongan Darah\n</label><md-select ng-model=\"vm.Form.objForm.bloodType\" ng-disabled=\"!vm.stateEdit\"><md-option \nng-repeat=\"blood in vm.bloods\" ng-value=\"blood\">{{blood}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Kewarganegaraan</label><md-select ng-model=\"vm.Form.objForm.nationality\" \nng-required=\"true\" ng-disabled=\"!vm.stateEdit\"><md-option ng-repeat=\"country in vm.listCountry\" \nng-value=\"country.countrycode\">{{country.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><md-input-container flex><label>Suku Bangsa</label><input \nng-model=\"vm.Form.objForm.sukuBangsa\" name=\"sukuBangsa\" md-maxlength=\"45\" ng-disabled=\"!vm.stateEdit\"><div \nng-messages=\"profilForm.sukuBangsa.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 45 huruf.</span></div></div></md-input-container><md-input-container flex><label>Nomor Telepon\n</label><input ng-model=\"vm.Form.objForm.personalPhoneNumber\" ng-required=\"true\" name=\"personalPhoneNumber\" \nmd-maxlength=\"30\" ng-disabled=\"!vm.stateEdit\" ng-pattern=\"/^[0-9]*$/\"><div \nng-messages=\"profilForm.personalPhoneNumber.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 30 huruf.</span></div><div ng-message=\"required\"><span>Telpon wajib diisi.</span></div><div \nng-message=\"pattern\"><span>karakter input tidak izinkan.</span></div></div></md-input-container><md-input-container \nflex><label>Alamat Email</label><input type=\"email\" ng-model=\"vm.Form.objForm.empEmail\" placeholder=\"Email\" \nng-required=\"true\" name=\"email\" ng-disabled=\"!vm.stateEdit\"><div ng-messages=\"profilForm.email.$error\" role=\"alert\">\n<div ng-message=\"email\"><span>Format email harus benar.</span></div><div ng-message=\"required\"><span>Email wajib diisi.\n</span></div></div></md-input-container></div><fieldset class=\"demo-fieldset fieldset-area\" flex><legend \nclass=\"demo-legend\">Document Checklist</legend><div class=\"text-warning\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-ink-ripple md-danger md-mini\"></md-icon>Berikan Centang Pada Checkbox Jika anda memiliki dokumen dibawah ini\n</div><div layout=\"row\"><div layout=\"column\" flex=\"50\"><div><md-checkbox md-no-ink aria-label=\"checkbox-experience\" \nname=\"empExp\" ng-model=\"vm.Form.objForm.empExp\" class=\"md-primary\" ng-disabled=\"!vm.stateEdit\">\nMemiliki pengalaman kerja</md-checkbox></div><div><md-checkbox md-no-ink aria-label=\"checkbox-sim\" name=\"empSim\" \nng-model=\"vm.Form.objForm.empSim\" class=\"md-primary\" ng-disabled=\"!vm.stateEdit\">Memiliki SIM</md-checkbox></div><div>\n<md-checkbox md-no-ink aria-label=\"checkbox-jamsostek\" name=\"jamsostek\" ng-model=\"vm.Form.objForm.jamsostek\" \nclass=\"md-primary\" ng-disabled=\"!vm.stateEdit\">Memiliki Jamsostek / BPJS Ketenagakerjaan</md-checkbox></div></div><div \nlayout=\"column\" flex=\"50\"><div><md-checkbox md-no-ink aria-label=\"checkbox-acc_mandiri\" name=\"acc_mandiri\" \nng-model=\"vm.Form.objForm.acc_mandiri\" class=\"md-primary\" ng-disabled=\"!vm.stateEdit\">Memiliki rekening Bank Mandiri\n</md-checkbox></div><div><md-checkbox md-no-ink aria-label=\"checkbox-npwp\" name=\"npwp\" ng-model=\"vm.Form.objForm.npwp\" \nclass=\"md-primary\" ng-disabled=\"!vm.stateEdit\">Memiliki NPWP</md-checkbox></div><div><md-checkbox md-no-ink \naria-label=\"checkbox-bpjs\" name=\"bpjs\" ng-model=\"vm.Form.objForm.bpjs\" class=\"md-primary\" ng-disabled=\"!vm.stateEdit\">\nMemiliki BPJS Kesehatan</md-checkbox></div></div></div></fieldset><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><div \nlayout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.stateEdit\" type=\"submit\" \nng-disabled=\"profilForm.$invalid || profilForm.$pristine\" class=\"md-raised md-blue-500-bg white-fg\" \naria-label=\"Submit\">Update</md-button></div></form></div></div>");
$templateCache.put("app/main/echeckin/profile/upload-photo.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-accent hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload Photo</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\" style=\"margin-bottom: 15px\"><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload Photo\n</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nflex layout layout-align=\"center center\" layout-padding><span>Success Upload Photo</span></md-whiteframe></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><input type=\"file\" \nid=\"uploadPhoto\" nv-file-select uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadPhoto\',empID:vm.Form.objForm.id}] }\"></div><div flex><img \nsrc=\"assets/images/avatars/profile.jpg\" alt=\"example photo\" class=\"profile-image huge avatar profpict\"></div></div>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload</md-button></md-dialog-actions></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/echeckin/training/inputtraining.html","<md-dialog aria-label=\"Form Input Training\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"trainForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,trainForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Training</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" \nname=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout=\"column\"><md-input-container \nflex><label>Jenis Training</label><input ng-model=\"vm.Form.objForm.typeOfTraining\" required></md-input-container>\n<md-input-container md-no-float class=\"md-block\" flex><label>Penjelasan singkat tentang training</label><textarea \nng-model=\"vm.Form.objForm.specificationOfTraining\" required placeholder=\"Spesifikasi Training\"></textarea>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Tanggal Mulai</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.startDate\" required ng-change=\"vm.chnageStartDate()\">\n</md-datepicker></md-input-container><md-input-container flex><label>Tanggal Akhir</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.finishDate\" required md-min-date=\"vm.minDate\"></md-datepicker>\n</md-input-container></div><md-input-container flex><md-radio-group ng-model=\"vm.Form.objForm.isCertificate\" \nng-required=\"true\" ng-change=\"vm.changeCertificate()\" name=\"isCertificate\"><md-radio-button value=\"1\" \nclass=\"md-warn md-raised\">Bersertifikat</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"0\" \nclass=\"md-warn md-raised\">Tidak Bersertifikat</md-radio-button></md-radio-group></md-input-container>\n<md-input-container md-no-float class=\"md-block\"><div ng-if=\"vm.cert\"><input type=\"file\" id=\"uploadPhoto\" \nname=\"uploadPhoto\" ng-model=\"vm.Form.objForm.image\" nv-file-select uploader=\"vm.FileUploaderPhoto\" \nng-change=\"vm.setUpload($event)\"> <img ng-src=\"{{imageSrc}}\"> <small>\nfile Size : {{vm.sizefile/1024/1024 | number:2 }} MB of Max file upload 2Mb.</small><div \nng-messages=\"trainForm.uploadPhoto.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.sizefile>2097152\"><span>\nMaximum file size 2 MB</span></div></div></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><div layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.cert\" type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" ng-disabled=\"form.$invalid || form.$pristine || vm.sizefile>2097152\" \nclass=\"md-raised md-blue-500-bg\" aria-label=\"Submit\">Submit</md-button><md-button ng-if=\"!vm.cert\" type=\"submit\" \nclass=\"md-raised md-blue-500-bg\" aria-label=\"Submit\" ng-disabled=\"form.$invalid || form.$pristine\">Submit</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/training/training.html","<md-toolbar md-theme=\"table-toolbar-theme\" class=\"md-white-bg\" style=\"min-height: 10px\"><div class=\"start-align\">\n<md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect md-hue-2\" \nng-click=\"vm.goBack()\" show-gt-sm type=\"button\" aria-label=\"Inert\"><md-icon md-font-icon=\"icon-undo\"></md-icon>Kembali\n</md-button><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini mdl-js-button mdl-button--fab mdl-js-ripple-effect\" show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.openInputTraining($event)\"><md-icon md-font-icon=\"icon-plus-circle\">\n</md-icon>Tambah</md-button><md-button \nclass=\"md-button md-ink-ripple md-warn md-mini mdl-js-button mdl-button--fab mdl-js-ripple-effect\" show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Hapus\n</md-button></div></md-toolbar><div class=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Jenis Training</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Spesifikasi Training</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Start</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Finish</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listData\" ng-dblclick=\"vm.editInputTraining($event,div)\" ng-click=\"vm.checkone(div)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td \nclass=\"text-center\">{{ ($index + 1)}}</td><td>{{ div.type_of_training | uppercase}}</td><td>\n{{ div.specification_of_training | uppercase}}</td><td class=\"text-center\">{{ div.start_date | uppercase}}</td><td \nclass=\"text-center\">{{ div.finish_date | uppercase}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/emp-category/emp-appraisal/emp-appraisal.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EMPAPPRAISAL\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"KPI.LABEL.COMPANY\">\n</label><md-select ng-model=\"vm.company\" name=\"company\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"PAYROLL.MENU.TYPE\"></label><md-select ng-model=\"vm.type\" name=\"type\">\n<md-option ng-repeat=\"ls in vm.listType\" placeholder=\"type\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.EFFECTIVEDATE\"></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\">\n</md-datepicker><div ng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.EFFECTIVEDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label>NIK</label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                                            border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmEmploye.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span>\n <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div layout=\"row\" layout-padding=\"1\" \nlayout-align=\"space-between center\" layout-padding=\"\"></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputEmpAppraisal($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">New</md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.lisEmpAppraisalSelected.length == 0\" ng-click=\" vm.DeleteEmpAppraisal()\"><md-icon \nng-if=\"vm.lisEmpAppraisalSelected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon \nng-if=\"vm.lisEmpAppraisalSelected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.lisEmpAppraisalSelected.length > 0\" class=\"red-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> \n<span ng-if=\"vm.lisEmpAppraisalSelected.length == 0\" class=\"grey-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span>\n</span> <span style=\"color:red\" ng-if=\"vm.lisEmpAppraisalSelected.length > 0\">{{ vm.lisEmpAppraisalSelected.length }} \n<span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload</md-tooltip>\n<md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span>NIK</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></span></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.TYPE\"></span></span></th><th width=\"5%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.COMPANY\"></span></span></th><th width=\"5%\" class=\"text-center\"></th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editEmpAppraisal($event,ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.lisEmpAppraisalSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ls.nik}}</td><td class=\"\">{{ls.emp_name}}</td><td class=\"text-center\">\n{{ls.effective_date | date : \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.type}}</td><td class=\"text-center\">\n{{ls.company}}</td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editEmpAppraisal($event, ls)\"><div layout=\"row\" \nflex><md-tooltip><span translate=\"ACTION.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/emp-category/emp-appraisal/input-emp-appraisal.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"formData\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formData)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.EMPAPPRAISAL\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.COMPANY\"></label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"PAYROLL.MENU.TYPE\"></label><md-select ng-model=\"vm.Form.objForm.type\" \nname=\"type\"><md-option ng-repeat=\"ls in vm.listType\" placeholder=\"type\" value=\"{{ls.id}}\">{{ls.name}}</md-option>\n</md-select></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.EFFECTIVEDATE\"></label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\"></md-datepicker><div ng-messages=\"frmEmploye.start_date.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label>NIK</label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmEmploye.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span>\n <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formData.$invalid || formData.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/emp-category/emp-appraisal/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/emp-category/emp-sales-code/emp-sales-code-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.EMPSALESCODE\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"PAYROLL.MENU.TYPE\"></label><md-select ng-model=\"vm.Form.objForm.sales_behaviour\" name=\"sales_behaviour\" \nng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sales code...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"sales_behaviour\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSalesBehaviour | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container ng-if=\"vm.Form.objForm.sales_behaviour==\'REAL\'\" flex flex-gt-sm><label>NIK\n</label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex flex-gt-sm>\n<label>NIK ASS</label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nikass\" md-search-text=\"vm.searchStringAss\" \nmd-items=\"item in vm.getEmployee(vm.searchStringAss)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nikass\" \nmd-selected-item-change=\"vm.selectedItemChangedAss(vm.Form.objForm.nikass)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchStringAss\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK ASS</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.MAIN.SALESCODE\"></label><md-select ng-model=\"vm.Form.objForm.ref_sales_code_id\" \nname=\"ref_sales_code_id\" ng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sales code...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"ref_sales_code_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSalesCode | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" md-max-date=\"vm.Form.objForm.end_date\" \nname=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"KPI.LABEL.ENDDATE\"></label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.Form.objForm.start_date\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\"></md-datepicker><div \nrole=\"alert\"><span style=\"color:red\">Jika end date tidak diketahui, biarkan kosong (Blank)</span></div><div \nng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDDATE\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/emp-category/emp-sales-code/emp-sales-code.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EMPSALESCODE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"KPI.LABEL.NIK\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.MAIN.SALESCODE\"></label><md-select ng-model=\"vm.Form.objForm.ref_sales_code_id\" \nname=\"ref_sales_code_id\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sales code...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"ref_sales_code_id\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSalesCode | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.STARTDATE\"></label><md-datepicker \nmd-hide-icons=\"calendar\" md-max-date=\"vm.end_date\" name=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div \nng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.STARTDATE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"KPI.LABEL.ENDDATE\"></label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\"></md-datepicker><div \nng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDDATE\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nlayout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>NIK</span>/<span \ntranslate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>NIK ASS</span>/\n<span translate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SALESCODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.SALESBEHAVIOUR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.STARTDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.ENDDATE\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \n\\></md-icon></span></th></tr></thead><tbody><tr ng-dblclick=\"vm.editData($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n<md-checkbox aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.no}}</td><td class=\"\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.nikname}}</td><td class=\"\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.nik_ass ? item.nik_ass + \'/\' + item.ass_name : \'\'}}</td><td\n class=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.sales_code}}</td><td\n class=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.sales_behaviour}}\n</td><td class=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.start_date}}\n</td><td class=\"text-center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.end_date}}\n</td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"ACTION.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/emp-category/emp-sales-code/view-detail.html","<md-dialog aria-label=\"Form View Detail\" flex-md=\"80\" flex-gt-md=\"70\"><form ng-cloack name=\"fReply\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2><span translate=\"HCTICKET.MENU.DETAIL\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout-padding flex><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.isClosed==1\" style=\"margin-top:10px;margin-bottom:10px\" flex layout layout-align=\"center center\" \nlayout-padding><span>{{vm.message}}</span></md-whiteframe><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"MENU.MAIN.CB.TITLE\"></span></label><input type=\"text\" ng-model=\"vm.title\" name=\"title\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.TYPE\"></span></label><input \ntype=\"text\" ng-model=\"vm.type\" name=\"title\" ng-disabled=\"true\"></md-input-container><md-input-container \nng-if=\"vm.isAdmin\" flex><label><span translate=\"MENU.MAIN.ERRORTYPE\"></span></label><input type=\"text\" \nng-model=\"vm.errorType\" name=\"title\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.STATUS\"></span></label><input type=\"text\" \nng-model=\"vm.ticketStatus\" name=\"title\" ng-disabled=\"true\"></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.ESTIMATION\"></span></label><input type=\"text\" ng-model=\"vm.estimation\" name=\"estimation\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"HCTICKET.MENU.REQUESTEDBY\"></span></label><input type=\"text\" ng-model=\"vm.requestedBy\" name=\"requestedBy\" \nng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"!vm.isRequested && vm.isAdmin\" flex><label><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span></label><input type=\"text\" ng-model=\"vm.company\" name=\"company\" \nng-disabled=\"true\"></md-input-container><md-input-container ng-if=\"!vm.isRequested && vm.isAdmin\" flex><label><span \ntranslate=\"PAYROLL.MENU.AREA\"></span></label><input type=\"text\" ng-model=\"vm.area\" name=\"area\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex><label><span translate=\"HCTICKET.MENU.REQUESTEDAT\"></span></label><input \ntype=\"text\" ng-model=\"vm.requestedAt\" name=\"requestedAt\" ng-disabled=\"true\"></md-input-container></div><label \nclass=\"text-grey\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></label><div layout=\"row\"><fieldset flex><div \nclass=\"text-grey\" ng-bind-html=\"vm.description\" class=\"alert-information\"></div></fieldset></div><label \nng-if=\"!vm.isRequested && vm.isAdmin\" class=\"text-grey\"><span translate=\"HCTICKET.MENU.SOLUTION\"></span></label><div \nng-if=\"!vm.isRequested && vm.isAdmin\" layout=\"row\"><fieldset flex><div class=\"text-grey\" ng-bind-html=\"vm.solutions\" \nclass=\"alert-information\"></div></fieldset></div><fieldset style=\"margin-top: 30px;background-color: aliceblue\" flex>\n<legend style=\"background-color: grey; font-weight: bold; color:white\"><span translate=\"MENU.MAIN.DISCUSSION\"></span>\n</legend><div ng-repeat=\"ls in vm.ticketRespons\"><div layout=\"row\"><fieldset class=\"mg-10\" \nng-style=\"{\'background-color\': ls.bColor}\" flex><legend ng-style=\"{\'background-color\': ls.color}\" align=\"{{ls.align}}\">\n{{ls.username}} - {{ls.timestamp}}</legend><div class=\"text-grey\" style=\"color: black\" ng-bind-html=\"ls.respons\" \nclass=\"alert-information\"></div><br ng-if=\"ls.filename\"><br ng-if=\"ls.filename\"><a \nng-if=\"ls.filename&&ls.format==\'img\'\" ng-click=\"vm.viewFile($event,ls.filename)\"><span class=\"show-file\">View File\n</span></a> <a ng-if=\"ls.filename&&ls.format==\'file\'\" ng-click=\"vm.downloadDoc($event,ls.filename)\"><span \nclass=\"show-file\">Download</span></a></fieldset></div></div><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar upper-case-header\" ms-responsive-table><tbody><tr \nclass=\"md-table-content-row\"><td><textarea rows=\"7\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.answer\" \nrequired=\"true\"></textarea></td></tr></tbody></table><br><div layout=\"row\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked\" ng-click=\"vm.checkIsNeddFile()\" ng-model=\"vm.isNeddUploadFile\" aria-label=\"\"><span \ntranslate=\"HCTICKET.MENU.NEEDUPLOAD\"></span></md-checkbox></div><br><md-input-container ng-if=\"vm.isChecked\" \nmd-no-float class=\"md-block\"><input required=\"true\" type=\"file\" id=\"uploadData\" nv-file-select required \nuploader=\"vm.FileUploader\" \noptions=\"{ formData: [{\n                            action: \'uploadReply\',\n                            ticket_id: vm.id,\n                            title: vm.title,\n                            mailTo: vm.mailTo,\n                            answer: vm.answer}] }\">\n</md-input-container><br><br><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.showMessage\" class=\"fade\"><ms-widget-front class=\"red-400-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.alertMessage}}</p></ms-widget-front></ms-widget>\n<md-button ng-if=\"!vm.isChecked\" type=\"button\" ng-click=\"vm.saveData($event, fReply)\" \nclass=\"md-raised md-mini md-primary\" ng-disabled=\"fReply.$invalid || fReply.$pristine\" aria-label=\"Submit\" \ntranslate=\"MENU.MAIN.REPLY\">Reply</md-button><md-button ng-if=\"vm.isChecked\" type=\"button\" \nng-click=\"vm.upload(fReply)\" class=\"md-raised md-mini md-primary\" ng-disabled=\"fReply.$invalid || fReply.$pristine\" \naria-label=\"Submit\" translate=\"MENU.MAIN.REPLY\">Reply</md-button><md-button type=\"button\" \nng-click=\"vm.closeTicket($event, fReply)\" class=\"md-raised md-mini md-warn\" ng-disabled=\"vm.isClosed==\'1\'\" \naria-label=\"Close\" translate=\"MENU.MAIN.CLOSETICKET\">Close Ticket</md-button><md-button \nng-if=\"vm.isAdmin&&vm.isSysdev==\'0\'&&vm.status==\'1\'\" class=\"md-mini md-primary\" \nng-click=\"vm.delegateToSysdev(vm.refData,\'1\')\"><span translate=\"PAYROLL.MENU.DELEGATETOSYSDEV\"></span></md-button>\n<md-button ng-if=\"vm.isAdmin&&vm.isSysdev==\'1\'&&vm.status==\'1\'\" class=\"md-mini md-primary\" \nng-click=\"vm.delegateToSysdev(vm.refData,\'0\')\"><span translate=\"PAYROLL.MENU.CANCELDELEGATION\"></span></md-button><span\n ng-if=\"vm.isAdmin&&vm.isSysdev==\'1\'&&vm.status!=\'1\'\" translate=\"PAYROLL.MENU.ISSYSDEV\"></span></div></fieldset>\n</md-dialog-content><hr></form></md-dialog>");
$templateCache.put("app/main/emp-category/emp-subdis/emp-subdis-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.EMPSUBDIS\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label>NIK</label>\n<md-autocomplete style=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.MAIN.REFSUBDIS\"></label><md-select ng-model=\"vm.Form.objForm.ref_subdis_id\" name=\"ref_subdis_id\" \nng-required=\"true\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"ref_subdis_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSubdis | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label translate=\"KPI.LABEL.AREA\">\n</label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" ng-required=\"true\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"area_sales_id\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listAreaSales | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/emp-category/emp-subdis/emp-subdis.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EMPSUBDIS\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm>\n<label translate=\"KPI.LABEL.NIK\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span\n translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.MAIN.REFSUBDIS\"></label><md-select ng-model=\"vm.Form.objForm.ref_subdis_id\" name=\"ref_subdis_id\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"ref_subdis_id\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSubdis | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" style=\"margin-top:-10px\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon hide class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span><span translate=\"PAYROLL.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>NIK</span>/<span \ntranslate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.REFSUBDIS\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.AREA\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\>\n</md-icon></span></th></tr></thead><tbody><tr ng-dblclick=\"vm.editData($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n<md-checkbox aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.no}}</td><td class=\"\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.nikname}}</td><td class=\"text-center\"><md-tooltip><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.company_name}}</td><td class=\"text-center\"><md-tooltip>\n<span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{item.area}}</td><td class=\"text-center\"><section \nlayout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-primary\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span translate=\"ACTION.EDIT\"></span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eyedropper-variant\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></section></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/admin-department/index.html","<div id=\"correspondence-pma\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span class=\"logo-text\">Admin Department</span></md-subheader><div class=\"white-bg\"><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" \nstyle=\"margin-right:5px\" layout=\"row\" layout-align=\"start center\" hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span>Entries</span></div><div class=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" \nlayout-align=\"center\" class=\"md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction\" ng-click=\"vm.create()\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-clipboard-check\"></md-icon><span style=\"font-size:12px\">Create</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" \nclass=\"md-warn\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData()\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Delete</span></md-button><span \nflex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 12px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.create()\"><md-icon style=\"font-size:12px\" md-font-icon=\"icon-clipboard-check\"></md-icon><span \nstyle=\"font-size:12px\">Create</span></md-button></md-menu-item><md-menu-item><md-button style=\"margin:0\" layout=\"row\" \nlayout-align=\"center\" class=\"md-warn\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" g-click=\"vm.deleteData()\">\n<md-icon style=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Delete</span>\n</md-button></md-menu-item></md-menu-content></md-menu><span flex show hide-gt-sm></span><ms-search-bar \nstyle=\"padding:0px\" on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" \nclass=\"bouncy-slide-left\"></ms-search-bar></div></md-toolbar><div layout=\"column\" layout layout-padding ms-scroll hide \nshow-gt-sm><table class=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th></th><th \ntranslate=\"TABLE.SUB_AREA\">Sub Area</th><th translate=\"TABLE.GEDUNG\">Gedung</th><th translate=\"TABLE.SECTOR\">Sector\n</th><th translate=\"TABLE.NIK_NAME\">NIK/NAME</th><th>GROUP SHIFT</th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData(ls)\" ng-repeat=\"ls in vm.DataTable.list\"><td><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{ls.sub_area_name}}</td><td>\n{{ls.gedung_name}}</td><td>{{ls.sector_name!=null ? ls.sector_name : \'All\'}}</td><td>{{ls.nik}} / {{ls.name}}</td><td>\n{{ls.shift_group_name}}</td></tr></tbody></table><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</div></md-content></div>");
$templateCache.put("app/main/cb/administrator/administrator.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.ADMINISTRATION.INDEX.HEADER.TITLE\">Administration</span></md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Years</label><md-select\n ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"Year\" value=\"{{val}}\">{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MENU.CB.ADMINISTRATION.INDEX.FILTER.FROM_DATE\">From Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.fromdate\" \nmd-placeholder=\"{{ \'MENU.CB.ADMINISTRATION.INDEX.FILTER.FROM_DATE\' | translate }}\" name=\"from\" required>\n</md-datepicker></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.ADMINISTRATION.INDEX.FILTER.UNTIL_DATE\">Until DATE</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.untildate\" md-placeholder=\"{{ \'MENU.CB.ADMINISTRATION.INDEX.FILTER.UNTIL_DATE\' | translate }}\" \nname=\"until\" required></md-datepicker></md-input-container><md-button class=\"md-mini md-raised md-primary\" \ntype=\"button\" aria-label=\"{{ \'MENU.CB.ADMINISTRATION.INDEX.FILTER.SUBMIT\' | translate }}\" \nng-disabled=\"frmCB.$invalid || frmCB.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n translate=\"MENU.CB.ADMINISTRATION.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.openUploadPhoto($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"MENU.CB.ADMINISTRATION.INDEX.ACTION.UPLOAD\">\nUpload File</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th><span class=\"column-title\" translate=\"MENU.CB.ADMINISTRATION.INDEX.TABLE.NO\">No\n</span></th><th><span class=\"column-title\" translate=\"MENU.CB.ADMINISTRATION.INDEX.TABLE.NIK\">NIK</span></th><th><span \nclass=\"column-title\" translate=\"MENU.CB.ADMINISTRATION.INDEX.TABLE.FIRST_NAME\">First Name</span></th><th><span \nclass=\"column-title\" translate=\"MENU.CB.ADMINISTRATION.INDEX.TABLE.TRANSACTION_DATE\">Transaction Date</span></th><th>\n<span class=\"column-title\" translate=\"MENU.CB.ADMINISTRATION.INDEX.TABLE.TRANSACTION_TIME\">Transaction Time</span></th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td>{{ls.no}}</td><td>{{ls.nik }}</td><td>{{ls.first_name}}\n</td><td>{{ls.transation_date}}</td><td>{{ls.transaction_time}}</td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/administrator/upload-file.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload File</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\" options=\"{ formData: [{action:\'uploadPhoto\',empID:vm.Form.objForm.id}] }\"></div><div \nclass=\"text-right\" flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\">\n</md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/am-abnormal-approval/am-abnormal-approval.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.HEADER.TITLE\">\nAbnormal Approval</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent grey-A100-fg\" translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.HEADER.TITLE\">Abnormal Approval</span></div>\n</div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div></div>\n<div class=\"content\"><div class=\"md-whiteframe-4dp\" layout=\"column\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"row\" layout-padding layout-align=\"space-between center\"><md-input-container md-no-float class=\"md-block\" \nflex=\"30\">Shows :<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><span flex></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex><md-input-container \nmd-no-float class=\"md-block\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\"></md-icon>\n<input type=\"text\" placeholder=\"Search..\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div></md-content><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-menu md-offset=\"18 48\"><md-button \naria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-raised reference-button md-warn md-hue-2\" \nng-click=\"vm.approveAbnormal($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.ACTION.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item>\n<md-button class=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-undo-variant\"></md-icon><span translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.ACTION.REJECT\">Reject\n</span></md-button></md-menu-item></md-menu-content></md-menu></div><table class=\"simple\" ms-responsive-table \nid=\"inputTable\"><thead><tr><th rowspan=\"2\"></th><th rowspan=\"2\" translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.NAME\">\nName</th><th rowspan=\"2\" translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.WORKING_DATE\">Working Date</th><th \ncolspan=\"4\" translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.ACTUAL_DATE\">Actual Data</th><th colspan=\"4\" \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.UPDATE_DATA\">Update Data</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.DESCRIPTION\">Description</th></tr><tr><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.IN\">IN</th><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.BREAK_IN\">Break In</th><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.OUT\">Out</th><th translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.IN\">\nIN</th><th translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.BREAK_IN\">Break In</th><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.OUT\">Out</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listApp\"><td \nclass=\"text-center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{ls.nama}}</td><td>\n{{ls.working_date}}</td><td class=\"text-center\"><span ng-if=\"ls.actin !=\'empty\'\">{{ls.actin}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.actbreakOut !=\'empty\'\">{{ls.actbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actout !=\'empty\'\">\n{{ls.actout}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curin !=\'empty\'\">{{ls.curin}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.curbreakOut !=\'empty\'\">{{ls.curbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.curbreakIn !=\'empty\'\">{{ls.curbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curout !=\'empty\'\">\n{{ls.curout}}</span></td><td>{{ls.description}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/cb/am-approval-ghk/am-approval-ghk.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span translate=\"MENU.CB.APPROVAL_GHK.INDEX.HEADER.TITLE\">\nApproval GHK</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent grey-A100-fg\" translate=\"MENU.CB.APPROVAL_GHK.INDEX.HEADER.TITLE\">Approval GHK</span></div></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div></div><div \nclass=\"content\"><div class=\"md-whiteframe-4dp\" layout=\"column\"><md-content class=\"\" layout=\"column\"></md-content><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-menu md-offset=\"18 48\"><md-button \naria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-raised reference-button md-warn md-hue-2\" \nng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item><md-button\n class=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-undo-variant\"></md-icon><span translate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.REJECT\">Reject</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><table class=\"simple\" ms-responsive-table id=\"inputTable\">\n<thead><tr><th></th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.NIK_NAME\">Nik/Name</th><th \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.WORKING_DAY\">Working Day</th><th \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.REASON\">Reason</th><th \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.DWS_CODE\">DWS Code</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listGhk\"><td><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td>{{ls.nik}}/{{ls.nama}}</td><td>{{ls.workdayname}} / {{ls.working_date}}</td><td>{{ls.reason}}\n</td><td>{{ls.dws_code}}</td></tr></tbody></table><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</div>");
$templateCache.put("app/main/cb/am-approval-ot/am-approval-ot.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span translate=\"MENU.CB.APPROVAL_OT.INDEX.HEADER.TITLE\">\nApproval Overtime</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent grey-A100-fg\" translate=\"MENU.CB.APPROVAL_OT.INDEX.HEADER.TITLE\">Approval Overtime</span></div></div><div\n class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div></div><div \nclass=\"content\"><div class=\"md-whiteframe-4dp\" layout=\"column\"><md-toolbars><div class=\"md-toolbar-tools table-tools\">\n<md-menu md-offset=\"0 -7\"><md-button aria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action\n<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-raised reference-button md-warn md-hue-2\" \nng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_OT.INDEX.ACTION.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-undo-variant\"></md-icon><span translate=\"MENU.CB.APPROVAL_OT.INDEX.ACTION.REJECT\">Reject</span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><span flex hide \nshow-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex><md-input-container md-no-float \nclass=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\" hide \nshow-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\">\n</md-input-container></form></div><table class=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr>\n<th></th><th translate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.TYPE\">Type</th><th \ntranslate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.DATE\">Date</th><th translate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.START_TIME\">\nStart Time</th><th translate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.END_TIME\">End Time</th><th \ntranslate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.REST_HOUR\">Rest Hour</th><th \ntranslate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.REQUEST_BY\">Request By</th><th \ntranslate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.REASON\">Reason</th><th translate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.STATUS\">\nStatus</th><th></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td><span \nng-if=\"ls.appstatus==\'-1\' || ls.appstatus==\'99\'\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></span></td><td>{{ls.ot_type}}</td><td>{{ls.ot_date}}</td><td>{{ls.start_time}}</td><td>{{ls.end_time}}\n</td><td>{{ls.rest_hour}}</td><td>{{ls.requestname}}</td><td>{{ls.reason}}</td><td>{{ls.appstatusname}}</td><td>\n<md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.setViewTeam($event,ls)\" aria-label=\"Refresh widget\">View Team</md-button>\n</md-menu-item><md-menu-item ng-if=\"ls.appstatus==\'1\'\"><md-button ng-click=\"vm.UnApproved($event,ls)\" \naria-label=\"Flip widget\">UnApprove</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><div\n class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-toolbars></div></div></div>");
$templateCache.put("app/main/cb/am-changeshift-approval/am-changeshift-approval.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span translate=\"MENU.CB.APPROVAL_CHANGE_SHIFT.INDEX.HEADER.TITLE\">\nChange Shift Approval</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div\n layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent grey-A100-fg\" translate=\"MENU.CB.APPROVAL_CHANGE_SHIFT.INDEX.HEADER.TITLE\">Change Shift Approval</span>\n</div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div>\n</div><div class=\"content\"><div class=\"md-whiteframe-4dp\" layout=\"column\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"row\" layout-padding layout-align=\"space-between center\"><md-input-container md-no-float class=\"md-block\" \nflex=\"30\">Shows :<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><span flex></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex><md-input-container \nmd-no-float class=\"md-block\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\"></md-icon>\n<input type=\"text\" placeholder=\"Search..\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div></md-content><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-menu md-offset=\"18 48\"><md-button \naria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span \ntranslate=\"MENU.CB.APPROVAL_CHANGE_SHIFT.INDEX.ACTION.ACTION\">Action</span><md-icon md-font-icon=\"icon-chevron-down\">\n</md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button class=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.approveChangeshift($event)\">\n<md-icon md-font-icon=\"icon-check\"></md-icon><span translate=\"MENU.CB.APPROVAL_CHANGE_SHIFT.INDEX.ACTION.APPROVE\">\nApprove</span></md-button></md-menu-item></md-menu-content></md-menu></div><table class=\"simple\" ms-responsive-table \nid=\"inputTable\"><thead><tr><th></th><th translate=\"MENU.CB.APPROVAL_CHANGE_SHIFT.INDEX.TABLE.NAME\">Name</th><th \ntranslate=\"MENU.CB.APPROVAL_CHANGE_SHIFT.INDEX.TABLE.DATE\">Date</th><th \ntranslate=\"MENU.CB.APPROVAL_CHANGE_SHIFT.INDEX.TABLE.DWS_CODE\">DWS Code</th><th \ntranslate=\"MENU.CB.APPROVAL_CHANGE_SHIFT.INDEX.TABLE.START_TIME\">Start Time</th><th \ntranslate=\"MENU.CB.APPROVAL_CHANGE_SHIFT.INDEX.TABLE.END_TIME\">End Time</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td>{{ls.nama}}</td><td>{{ls.tgl}}</td><td>{{ls.idshift}}</td><td>{{ls.start_time}}</td><td>\n{{ls.end_time}}</td></tr></tbody></table><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/cb/am-leave-approval/am-leave-approval.html","<div id=\"header-action\" class=\"page-layout simple fullwidth with-toolbar-content\" layout=\"column\"><div \nclass=\"header nabati6\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"></span> <span class=\"logo-text\"><span \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.HEADER.TITLE\">Approval Absence</span></span></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span class=\"parent grey-A100-fg\" \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.HEADER.TITLE\">Approval Absence</span></div></div><div class=\"header-bottom\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'MENU.CB.LEAVE_APPROVAL.INDEX.FILTER.YEAR\' | translate }}\" \nvalue=\"{{val}}\">{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\" required><md-option \nng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container></div></form></div></div></md-content></div><div \nid=\"attView\"><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action\n<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip>\n</md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.ACTION.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item>\n<md-button class=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\">\n</md-icon><span translate=\"MENU.CB.LEAVE_APPROVAL.INDEX.ACTION.REJECT\">Reject</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span class=\"secondary-text\">Entries</span>\n</md-input-container><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.ACTION.APPROVE\">Aprove</span></md-button><div class=\"toolbar-separator\"></div>\n<md-button class=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\" \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.ACTION.REJECT\">Reject</span></md-button><span flex></span><form \nng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex><md-input-container md-no-float class=\"md-block\" flex=\"100\"><md-icon \nmd-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\"></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\">\n</md-input-container></form></div></md-toolbar><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th></th><th \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.TABLE.NAME\">Name</th><th translate=\"MENU.CB.LEAVE_APPROVAL.INDEX.TABLE.TYPE\">\nType</th><th translate=\"MENU.CB.LEAVE_APPROVAL.INDEX.TABLE.TYPE_NAME\">Type Name</th><th \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.TABLE.START_DATE\">Start Date</th><th \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.TABLE.END_DATE\">End Date</th><th \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.TABLE.START_TIME\">Start Time</th><th \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.TABLE.END_TIME\">End Time</th><th \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.TABLE.DESCRIPTION\">Description</th><th \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.TABLE.STATUS\">Status</th><th \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.TABLE.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td><span ng-if=\"ls.allowapproval\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td>{{ls.nama}}</td><td>\n{{ls.absence_type}}</td><td>{{ls.abssencecode}}</td><td>{{ls.start_date}}</td><td>{{ls.end_date}}</td><td>\n{{ls.start_time}}</td><td>{{ls.end_time}}</td><td>{{ls.description}}</td><td><span ng-if=\"ls.approval!==\'Rejected\'\">\n{{ls.approval}}</span> <span ng-if=\"ls.approval==\'Rejected\'\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\">\n{{ls.approval}}</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span></td><td><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.document_addres!==null\"><md-button ng-click=\"vm.ViewDocument(ls.document_addres)\" \naria-label=\"Refresh widget\"><md-icon md-font-icon=\"icon-eye\" class=\"teal-800-fg\"></md-icon><span \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.ACTION.VIEW_DOCUMENT\">View Document</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"ls.allowunapprove\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==\'Rejected\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.LEAVE_APPROVAL.INDEX.ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/cb/abnormal-report/abnormal-report.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span \ntranslate=\"MENU.CB.ABNORMAL_REPORT.INDEX.HEADER.TITLE\">Abnormal Report</span></span></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" layout-align=\"center start\"></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div><md-fab-speed-dial \nmd-direction=\"left\" class=\"action-button md-scale\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-blue-500-bg\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Menu</md-tooltip><md-icon \nmd-font-icon=\"icon-menu\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Twitter\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" class=\"md-fab md-raised md-mini\" \nng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\" \ntranslate=\"MENU.CB.ABNORMAL_REPORT.INDEX.ACTION.EXPORT\">Export to Excel</md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div>\n</div></div><div class=\"content\"><div class=\"simple-table-container\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"MENU.CB.ABNORMAL_REPORT.INDEX.FILTER.TITLE\">Filter Data</span>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-disabled=\"true\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.ABNORMAL_REPORT.INDEX.FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ABNORMAL_REPORT.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.ABNORMAL_REPORT.INDEX.FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"{{ MENU.CB.ABNORMAL_REPORT.INDEX.FILTER.YEAR | translate }}\" \nvalue=\"{{val}}\">{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\" required><md-option \nng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex layout-align=\"right right\">\n<md-button type=\"submit\" layout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span translate=\"MENU.CB.ABNORMAL_REPORT.INDEX.ACTION.SUBMIT\">\nSubmit</span></md-button></md-input-container></div></form></div></div></md-content><div id=\"attView\"><table \nclass=\"simple striped\" ms-responsive-table style=\"margin-top:0\"><thead><tr><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.NO\">No</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.NIK\">NIK</span></th><th width=\"15%\"><span \nclass=\"column-title\" translate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.NAME\">Name</span></th><th width=\"15%\"><span \nclass=\"column-title\" translate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.DATE\">Date</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.CLOCK_IN\">Clock In</span>\n</th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.TERMINAL_ID1\">Terminal ID1</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.CLOCK_OUT\">Clock Out\n</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.TERMINAL_ID2\">Terminal ID2</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.START_OF_BREAK\">\nStart of Break</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.TERMINAL_ID3\">Terminal ID3</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.END_OF_BREAK\">\nEnd Of Break</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.TERMINAL_ID4\">Terminal ID4</span></th><th><span class=\"column-title\" \ntranslate=\"MENU.CB.ABNORMAL_REPORT.INDEX.TABLE.DOWNLOAD\">Download</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listData\"><td class=\"text-center\">{{ls.no}}</td><td class=\"text-center\">{{ls.nik }}</td><td \nclass=\"text-center\">{{ls.empName }}</td><td class=\"text-center\">{{ls.transaction_date }}</td><td class=\"text-center\">\n{{ls.clockIn}}</td><td class=\"text-center\">{{ls.terminalId1 }}</td><td class=\"text-center\">{{ls.clockOut}}</td><td \nclass=\"text-center\">{{ls.terminalId2}}</td><td class=\"text-center\">{{ls.startOfbreak}}</td><td class=\"text-center\">\n{{ls.terminalId3}}</td><td class=\"text-center\">{{ls.endOfbreak}}</td><td class=\"text-center\">{{ls.terminalId4}}</td><td\n class=\"text-center\"><span ng-if=\"ls.download\"><md-icon class=\"green-500-fg\" md-font-icon=\"icon-check\"></md-icon>\n</span></td></tr><tr ng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>No Data Available</span>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/cb/abnormal/abnormal.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\n<span translate=\"MENU.CB.ABNORMAL.INDEX.HEADER.TITLE\">Abnormal</span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option \nng-repeat=\"ls in vm.appstatus\" placeholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" \nvalue=\"{{ls.value}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"formInputOT.status.$error\" role=\"alert\"><div \nng-message=\"required\"><span>abs_code field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" flex=\"30\"></md-datepicker><div \nng-messages=\"formInputOT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" flex=\"30\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \nng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>\n<span>Search</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span>Entries</span></md-input-container><span flex \nhide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.WORKING_DATE\">Working Date</th><th colspan=\"4\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.ACTUAL_DATA\">Actual Data</th><th colspan=\"4\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.UPDATE_DATA\">Update Data</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.DESCRIPTION\">Description</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.STATUS\">Status</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.ACTION\">Action</th></tr><tr><th class=\"text-center\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.IN\">IN</th><th class=\"text-center\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th class=\"text-center\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.BREAK_IN\">Break In</th><th class=\"text-center\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.OUT\">Out</th><th class=\"text-center\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.IN\">IN</th><th class=\"text-center\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th class=\"text-center\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.BREAK_IN\">Break In</th><th class=\"text-center\" \ntranslate=\"MENU.CB.ABNORMAL.INDEX.TABLE.OUT\">Out</th></tr></thead><tbody><tr class=\"text-center\" \nng-repeat=\"ls in vm.DataTable.list\"><td>{{ls.working_date}}</td><td class=\"text-center\"><span \nng-if=\"ls.actin !=\'empty\'\">{{ls.actin}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actbreakOut !=\'empty\'\">\n{{ls.actbreakOut}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span>\n</td><td class=\"text-center\"><span ng-if=\"ls.actout !=\'empty\'\">{{ls.actout}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.curin !=\'empty\'\">{{ls.curin}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curbreakOut !=\'empty\'\">\n{{ls.curbreakOut}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curbreakIn !=\'empty\'\">{{ls.curbreakIn}}</span>\n</td><td class=\"text-center\"><span ng-if=\"ls.curout !=\'empty\'\">{{ls.curout}}</span></td><td class=\"text-center\">\n{{ls.description}}</td><td class=\"text-center\"><span ng-if=\"ls.approval==1\">Approved</span> <span \nng-if=\"ls.approval==0\">Waiting Approval</span> <span ng-if=\"ls.approval==2\"><a href=\"\" \nng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span></td>\n<td class=\"text-center\"><span ng-if=\"ls.approval==\'0\'\"><md-button class=\"md-icon-button\" aria-label=\"Favorite\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.deleteAbnormal($event,ls.id)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip><span>click for delete</span></md-tooltip>\n</md-button></span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"12\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/abnormal/abnormal_backup.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">HGK Holiday</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.InputGhk($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>New Shift 2</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>New</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.deleteData()\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Delete Shift lalla</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"></th><th \ntranslate=\"MENU.CB.GHK_HOLIDAY.TABLE.DWS_CODE\">DWS Code</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.VARIAN\">Varian\n</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.HOLIDAY\">Holiday</th><th \ntranslate=\"MENU.CB.GHK_HOLIDAY.TABLE.WORKING_DAY\">Working Day</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.REASON\">\nReason</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.STATUS\">Status</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"(ls.approval==0)?vm.editData($event,ls.id):\'\'\"><td><md-checkbox \nng-if=\"ls.approval==0\" class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{ls.dws_code}}</td>\n<td>{{ls.variant}} Day</td><td>{{ls.holidayname}} / {{ls.holiday_date}}</td><td>\n{{ls.workdayname}} / {{ls.working_date}}</td><td>{{ls.reason}}</td><td><span ng-if=\"ls.approval==1\">Approved</span> \n<span ng-if=\"ls.approval==2\">border-top-right-radius: 5px !important; border-top-left-radius: 5px; <a href=\"\" \nng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span><span \nng-if=\"ls.approval==0\">Waiting Aproval</span></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div><div id=\"simple-table\" class=\"page-layout simple is-simple fullwidth\"><div \nlayout-fill class=\"content\" flex><div class=\"simple-table-container md-whiteframe-4dp\" layout-fill><div \nclass=\"table-title\">Abnormal</div><div id=\"attView\" class=\"table-2 is-table-simple\" layout-fill><md-toolbar \nmd-theme=\"table-toolbar-theme\" class=\"has-toolbar-edit\"><div class=\"md-toolbar-tools table-tools has-csm-input\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><div layout=\"column\" class=\"data-grid\"><div layout=\"row\" flex=\"100\">\n<div flex=\"5\">Working Date</div><div flex=\"20\" layout=\"column\"><div>Actual Date</div><div layout=\"row\"><div flex>IN\n</div><div flex>Break Out</div><div flex>Break In</div><div flex>OUT</div></div></div><div flex=\"20\" layout=\"column\">\n<div>Update Date</div><div layout=\"row\"><div flex>IN</div><div flex>Break Out</div><div flex>Break In</div><div flex>\nOUT</div></div></div><div flex=\"10\">Description</div><div flex=\"10\">Status</div><div flex>Action</div></div><md-content\n layout-fill ms-scroll layout=\"column\" layout-warap style=\"overflow: auto\"></md-content></div><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div></div>");
$templateCache.put("app/main/cb/am-outlet-mapping-approval/am-outlet-mapping-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.OUTLET_MAPING_APPROVAL.INDEX.HEADER.TITLE\">Outlet Mapping Approval</span>\n</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu icon\"></md-icon></md-button><md-menu-content width=\"2\"></md-menu-content>\n</md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Approve()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span>\n</md-tooltip><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.OUTLET_MAPING_APPROVAL.INDEX.ACTION.APPROVE\">Approve</span></md-button><span flex hide show-gt-sm>\n</span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nid=\"inputTable\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"50px\"></th><th \nclass=\"text-center\" translate=\"MENU.CB.OUTLET_MAPING_APPROVAL.INDEX.TABLE.NO\" width=\"50px\">No</th><th \ntranslate=\"MENU.CB.OUTLET_MAPING_APPROVAL.INDEX.TABLE.REQUEST_BY\">Request By</th><th class=\"text-center\" \ntranslate=\"MENU.CB.OUTLET_MAPING_APPROVAL.INDEX.TABLE.STATUS\" width=\"150px\">status</th><th \ntranslate=\"MENU.CB.OUTLET_MAPING_APPROVAL.INDEX.TABLE.REQUEST_DATE\" width=\"100px\">Request Date</th><th \nclass=\"text-center\" width=\"50px\">#</th></tr></thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\"><td \nclass=\"text-center\"><span ng-if=\"team.approval==0\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(team)\" \nng-click=\"vm.toggleCheck(team, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(team)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></span></td><td class=\"text-center\">{{team.no}}</td><td>{{team.requestby}} - {{team.nama}}</td><td \nclass=\"text-center\">{{team.approvalinfo}}</td><td>{{team.timestamp}}</td><td class=\"text-center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.setViewTeam($event,team)\"><md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip>\n<span>click for view team</span></md-tooltip></md-button></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/abnormal-approval/abnormal-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.ABNORMAL_APPROVAL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmSearchViewDataAbnormal\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate \nlayout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.STARTDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"{{\'KPI.LABEL.STARTDATE\' | translate}}\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"frmSearchViewDataAbnormal.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.STARTDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.ENDDATE\"></span></label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"frmSearchViewDataAbnormal.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" required \nng-change=\"vm.loadData(1)\"><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.ABNORMAL_APPROVAL.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"frmSearchViewDataAbnormal.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"ATTENDANCE.LABEL.TYPE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \nng-click=\"vm.loadData(1)\" ng-disabled=\"frmSearchViewDataAbnormal.$invalid || frmSearchViewDataAbnormal.$pristine\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\">Search</span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmSearchViewDataAbnormal.$invalid || frmSearchViewDataAbnormal.$pristine\"></select><span \ntranslate=\"KPI.LABEL.ENTRIES\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" \nng-disabled=\"frmSearchViewDataAbnormal.$invalid || frmSearchViewDataAbnormal.$pristine\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveAbnormal($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.ACTION.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item>\n<md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"frmSearchViewDataAbnormal.$invalid || frmSearchViewDataAbnormal.$pristine\"><i class=\"icon-delete\"></i> \n<span translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.ACTION.REJECT\">Reject</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-button ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveAbnormal($event)\" \nng-disabled=\"frmSearchViewDataAbnormal.$invalid || frmSearchViewDataAbnormal.$pristine\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">click for view actions</md-tooltip><md-icon \nmd-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.ACTION.APPROVE\">Aprove</span></md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\" ng-disabled=\"frmSearchViewDataAbnormal.$invalid || frmSearchViewDataAbnormal.$pristine\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Reject Absence</md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.ACTION.REJECT\">Reject</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\" class=\"text-center\"><span \nng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th rowspan=\"2\" \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.NAME\">Name</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.WORKING_DATE\">Working Date</th><th colspan=\"4\" \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.ACTUAL_DATE\">Actual Data</th><th colspan=\"4\" \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.UPDATE_DATA\">Update Data</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.DESCRIPTION\">Description</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.STATUS\">Status</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.ACTION\">Action</th></tr><tr><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.IN\">IN</th><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.BREAK_IN\">Break In</th><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.OUT\">Out</th><th translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.IN\">\nIN</th><th translate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.BREAK_IN\">Break In</th><th \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.TABLE.OUT\">Out</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==0\"><input type=\"checkbox\" \nchecklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td>{{ls.nama}}</td><td>{{ls.working_date}}</td>\n<td class=\"text-center\"><span ng-if=\"ls.actin !=\'empty\'\">{{ls.actin}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.actbreakOut !=\'empty\'\">{{ls.actbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actout !=\'empty\'\">\n{{ls.actout}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curin !=\'empty\'\">{{ls.curin}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.curbreakOut !=\'empty\'\">{{ls.curbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.curbreakIn !=\'empty\'\">{{ls.curbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curout !=\'empty\'\">\n{{ls.curout}}</span></td><td>{{ls.description}}</td><td class=\"text-center\"><span ng-if=\"ls.approval==1\">Approved\n</span> <span ng-if=\"ls.approval==2\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip \nmd-direction=\"top\">View Comment</md-tooltip></span><span ng-if=\"ls.approval==0\">Waiting Approval</span></td><td>\n<md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.approval==1\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.ACTION.UNAPPROVE\">Un-approve</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==2\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.INDEX.ACTION.UNREJECT\">Un-reject</span></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"14\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>\n<style type=\"text/css\">.btn-ui-serif {\n    line-height: 3.8rem !important;\n  }</style>");
$templateCache.put("app/main/cb/abnormal-approval/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\"><div layout=\"column\">\n<div layout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\" {{ \'MENU.CB.ABNORMAL_APPROVAL.COMMENT_REJECT.COMMENT\' | translate }} \" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span><md-button \nng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\" \ntranslate=\"MENU.CB.ABNORMAL_APPROVAL.COMMENT_REJECT.ACTION.REJECT\">Reject</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/am-sic-mapping/am-sic-mapping.html","<div id=\"simple-table\" layout=\"column\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\">\n<md-content class=\"content padding\" layout=\"column\"><div class=\"md-whiteframe-4dp white-bg rounded\" layout=\"column\">\n<md-subheader class=\"white-bg\"><span translate=\"MENU.CB.SIC_MAPING.INDEX.HEADER.TITLE\">Store Manager</span>\n</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nid=\"inputTable\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" \ntranslate=\"MENU.CB.SIC_MAPING.INDEX.TABLE.NO\">No</th><th translate=\"MENU.CB.SIC_MAPING.INDEX.TABLE.REQUEST_BY\">\nRequest By</th><th class=\"text-center\" translate=\"MENU.CB.SIC_MAPING.INDEX.TABLE.STATUS\">status</th><th \nclass=\"text-center\">#</th></tr></thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\"><td class=\"text-center\">\n{{team.no}}</td><td>{{team.requestby}} - {{team.nama}}</td><td class=\"text-center\"><span ng-if=\"team.approval==0\">\nWaiting Approval</span> <span ng-if=\"team.approval==1\">Approved N1</span> <span ng-if=\"team.approval==2\">Rejected N1\n</span> <span ng-if=\"team.approval==3\">Approved HR</span> <span ng-if=\"team.approval==4\">Rejected HR</span></td><td \nclass=\"text-center\"><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setViewTeam($event,team)\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>click for view team</span></md-tooltip></md-button></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\" ng-if=\"nav.disabled!==1\">{{nav.label}}</a> <span ng-if=\"nav.disabled===1\">\n{{nav.label}}</span></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/am-sic-mapping/new-mapping.html","<md-dialog aria-label=\"New SM\" flex=\"70\" id=\"formKpiPeople\" md-theme=\"modal-theme\"><form ng-cloak \nname=\"formSicMapping\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveMapping($event,formSicMapping)\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.SIC_MAPING.NEW_MAPING.HEADER.TITLE\">Store Manager Mapping</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content style=\"background: #ffffff\"><table class=\"simple\" ms-responsive-table id=\"kpiTable\" \nstyle=\"margin-top:10px\"><thead><tr><th></th><th translate=\"MENU.CB.SIC_MAPING.NEW_MAPING.TABLE.NAME\">Name</th><th \ntranslate=\"MENU.CB.SIC_MAPING.NEW_MAPING.TABLE.CURRENT_OUTLET\">Current Outlet</th><th \ntranslate=\"MENU.CB.SIC_MAPING.NEW_MAPING.TABLE.NEXT_OUTLET\">Next Outlet</th><th \ntranslate=\"MENU.CB.SIC_MAPING.NEW_MAPING.TABLE.EFFECTIVE_DATE\">Effective Date</th><th></th></tr></thead><tbody><tr \nng-repeat=\"scale in vm.Form.objForm.listSic\"><td>{{($index + 1)}}</td><td><md-input-container flex><input \ntype=\"hidden\" name=\"nik{{$index}}\" ng-model=\"vm.Form.objForm.listSic[$index].nik\" placeholder=\"NIK\" required><div \nng-messages=\"formSicMapping[\'nik\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK is required.</span>\n</div></div></md-input-container><span>{{vm.Form.objForm.listSic[$index].nama}}</span></td><td><md-input-container \nflex><input type=\"hidden\" name=\"currentArea{{$index}}\" ng-model=\"vm.Form.objForm.listSic[$index].sub_area_id\" \nplaceholder=\"currentArea\" required><div ng-messages=\"formSicMapping[\'currentArea\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\"><span>current area is required.</span></div></div></md-input-container><span>\n{{vm.Form.objForm.listSic[$index].sub_area_name}}</span></td><td><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.listSic[$index].nextArea\" ng-required=\"true\" placeholder=\"next outlet\" name=\"nextArea\">\n<md-option ng-repeat=\"ls in vm.listOutlet\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"formSicMapping[\'nextArea\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nnextArea harus di pilih.</span></div></div></md-input-container></td><td><md-input-container flex><md-datepicker \nmd-hide-icons=\"calendar\" name=\"effective_date\" ng-model=\"vm.Form.objForm.listSic[$index].effective_date\" required>\n</md-datepicker><div ng-messages=\"formSicMapping[\'effective_date\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\"><span>Effective Date Date is required.</span></div></div></md-input-container></td></tr></tbody>\n</table><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" \nclass=\"fade\"><ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" type=\"submit\">\n<md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon><span \ntranslate=\"MENU.CB.SIC_MAPING.NEW_MAPING.ACTION.SAVE\">Save</span></md-button><md-button \nclass=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh white-fg\">\n</md-icon><span translate=\"MENU.CB.SIC_MAPING.NEW_MAPING.ACTION.RELOAD_TOKEN\">Reload Token</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/am-sic-mapping-approval/am-sic-mapping-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.SIC_MAPING.MAPING_APPROVAL.INDEX.HEADER.TITLE\">Store Manager Mapping Approval\n</span></md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container \nhide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Approve()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"MENU.CB.SIC_MAPING.MAPING_APPROVAL.INDEX.ACTION.APPROVE\">Approve</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.Reject($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nReject</span></md-tooltip><md-icon md-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\">\n</md-icon><span translate=\"MENU.CB.SIC_MAPING.MAPING_APPROVAL.INDEX.ACTION.REJECT\">Reject</span></md-button><span flex \nhide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Approve()\"><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span translate=\"MENU.CB.SIC_MAPING.MAPING_APPROVAL.INDEX.ACTION.APPROVE\">\nApprove</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span \ntranslate=\"MENU.CB.SIC_MAPING.MAPING_APPROVAL.INDEX.ACTION.REJECT\">Reject</span></md-button></md-menu-item>\n</md-menu-content></md-menu></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th></th><th class=\"text-center\" \ntranslate=\"MENU.CB.SIC_MAPING.MAPING_APPROVAL.INDEX.TABLE.NO\">No</th><th \ntranslate=\"MENU.CB.SIC_MAPING.MAPING_APPROVAL.INDEX.TABLE.REQUEST_BY\">Request By</th><th class=\"text-center\" \ntranslate=\"MENU.CB.SIC_MAPING.MAPING_APPROVAL.INDEX.TABLE.STATUS\">status</th><th class=\"text-center\">#</th></tr>\n</thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\"><td><span ng-if=\"team.approval==0\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(team)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td class=\"text-center\">{{team.no}}\n</td><td>{{team.requestby}}-{{team.nama}}</td><td class=\"text-center\">{{team.approvalinfo}}</td><td \nclass=\"text-center\"><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setViewTeam($event,team)\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>click for view team</span></md-tooltip></md-button></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/am-store-incharge/am-store-incharge.html","<div id=\"simple-table\" layout=\"column\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\">\n<md-content class=\"content padding\" ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.STORE_INCHARGE.INDEX.HEADER.TITLE\">Store Manager</span></md-subheader><div \nclass=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools ph-0\" layout=\"row\"><md-menu hide-gt-sm \nflex=\"nogrow\" class=\"top-bar\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" class=\"md-primary-fg\"></md-icon>\n</md-button><md-menu-content width=\"2\" class=\"md-background-bg csm-dropdown\"><md-menu-item><md-button \nng-click=\"vm.ExportToExcel()\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.newMapping()\"><md-icon md-font-icon=\"icon-account-network\"></md-icon><span translate=\"ACTION.NEW_MAPING\">\nNew Mapping</span></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button \nui-sref=\"app.cb_sic_am-input-sic\"><span translate=\"ACTION.ADD_SIC\">Add SM</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteSIC($event)\"><span translate=\"ACTION.DELETE_SIC\">Delete SM</span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-input-container class=\"ml-10\" hide show-gt-sm flex=\"nogrow\">\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span translate=\"TABLE.ENTRIES\">Entries</span></md-input-container>\n<md-input-container class=\"ml-10\" hide-gt-sm flex><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span translate=\"TABLE.ENTRIES\">\nEntries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.ExportToExcel()\"><md-tooltip\n md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD\">Download</span></md-tooltip><md-icon\n md-font-icon=\"icon-file-excel\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-accent md-raised reference-button\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.newMapping()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.NEW_MAPING\">New Mapping</span></md-tooltip><md-icon md-font-icon=\"icon-account-network\"></md-icon>\n<span translate=\"MENU.CB.SIC_TEAM.INDEX.ACTION.NEW_MAPING\">New Mapping</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-icon-button md-backgroud-bg md-raised\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.cb_sic_am-input-sic\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.ADD_SIC\">Add SM</span></md-tooltip><md-icon md-font-icon=\"icon-person-plus\"></md-icon></md-button>\n<md-button class=\"md-icon-button md-warn md-raised\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.deleteSIC($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.DELETE_SIC\">Delete SM</span></md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n<span flex hide show-gt-sm></span><ms-search-bar on-collapse=\"vm.onCollapse()\" on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nhide show-gt-sm><thead><tr><th width=\"60px\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span>\n</th><th width=\"60px\" translate=\"TABLE.NO\">No</th><th translate=\"TABLE.NIK_NAME\">NIK / Name</th><th width=\"30%\" \ntranslate=\"TABLE.CURRENT_OUTLET\">Current Outlet</th><th width=\"15%\">Effective Date</th><th width=\"15%\" \ntranslate=\"TABLE.STATUS\">Status</th></tr></thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\" \nng-dblclick=\"vm.editData(team.id)\"><td class=\"text-center\"><span><md-checkbox class=\"no-label\" \nng-click=\"vm.toggle(team, vm.listSicSelected)\"></md-checkbox></span></td><td class=\"text-center\">{{team.no}}</td><td>\n{{team.nik}} - {{team.nama}}</td><td>{{team.description}}</td><td class=\"text-center\">{{team.effective_date}}</td><td \nclass=\"text-center\"><span ng-if=\"team.status==\'1\'\" translate=\"TABLE.ACTIVE\">Active</span> <span \nng-if=\"team.status==\'0\'\" translate=\"TABLE.NON_ACTIVE\">Non Active</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0 || (vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"5\" \nclass=\"text-center\"><span ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\">Loading</span> <span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\" ng-if=\"vm.DataTable.list.length <= 0\">No Data Available</span></td></tr></tbody>\n</table><md-list hide-gt-sm id=\"mobile-area-front\"><md-list-item ng-repeat-start=\"team in vm.DataTable.list\" \nlayout=\"row\" ng-class=\"$index > 0 ? \'mt-20\' : \'\'\" class=\"mb-15\"><div layout=\"row\" layout-align=\"start stretch\" flex>\n<span flex=\"10\" style=\"margin-top: 7px\"><md-checkbox class=\"no-label\" ng-click=\"vm.toggle(team, vm.listSicSelected)\">\n</md-checkbox></span><span flex=\"10\" style=\"margin-top: 7px\">{{team.no}}</span><div layout=\"column\" flex><div flex \nlayout=\"row\"><p flex=\"30\" translate=\"TABLE.NIK_NAME\">NIK / Name</p><p flex>{{team.nik}} - {{team.nama}}</p></div><div \nflex layout=\"row\"><p flex=\"30\" translate=\"TABLE.CURRENT_OUTLET\">Current Outlet</p><p flex>{{team.description}}</p>\n</div><div flex layout=\"row\"><p flex=\"30\">Effective Date</p><p flex>{{team.effective_date}}</p></div><div flex \nlayout=\"row\"><p flex=\"30\" translate=\"TABLE.STATUS\">Status</p><p ng-if=\"team.status==\'1\'\" translate=\"TABLE.ACTIVE\" flex>\nActive</p><p ng-if=\"team.status==\'0\'\" translate=\"TABLE.NON_ACTIVE\" flex>Non Active</p></div></div></div></md-list-item>\n<md-divider ng-repeat-end></md-divider></md-list><div class=\"pv-20 ph-24 mb-8 is-bottom-nav\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info mv-5\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\" class=\"mv-5\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\" \nng-if=\"nav.disabled!==1\">{{nav.label}}</a> <span ng-if=\"nav.disabled===1\">{{nav.label}}</span></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/am-sic-team/am-sic-team-mapping.html","<md-dialog aria-label=\"New SM\" flex=\"100\" flex-gt-sm=\"90\" id=\"formKpiPeople\" md-theme=\"modal-theme\"><form ng-cloak \nid=\"formSicMapping\" name=\"formSicMapping\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveMapping($event,formSicMapping)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>SM Mapping</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content style=\"background: #ffffff\"><input type=\"hidden\" name=\"nik{{$index}}\" \nng-model=\"vm.Form.objForm.listSic[$index].nik\"> <input type=\"hidden\" name=\"currentArea{{$index}}\" \nng-model=\"vm.Form.objForm.listSic[$index].sub_area_id\"><table class=\"simple with-toolbar mt-10\" id=\"kpiTable\" \nms-responsive-table hide show-gt-sm><thead class=\"simple bordered\"><tr><th width=\"60px\"></th><th>NIK / Name</th><th \nwidth=\"25%\">Current Outlet</th><th width=\"25%\">Next Outlet</th><th width=\"100px\">Effective Date</th></tr></thead>\n<tbody><tr ng-repeat=\"scale in vm.Form.objForm.listSic\"><td class=\"text-center\">{{($index + 1)}}</td><td><span>\n{{vm.Form.objForm.listSic[$index].nik}} - {{vm.Form.objForm.listSic[$index].nama}}</span></td><td><span>\n{{vm.Form.objForm.listSic[$index].sub_area_name}}</span></td><td><div layout=\"column\"><md-input-container flex><label>\nNext Outlet</label><md-select ng-model=\"vm.Form.objForm.listSic[$index].nextArea\" ng-required=\"true\" name=\"nextArea\" \nmd-on-close=\"vm.clearSearchTermSA($index)\"><md-select-header><input ng-model=\"vm.searchTermSA[$index]\" type=\"search\" \nplaceholder=\"Search for sub area\" class=\"md-text\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listOutlet | filter:vm.searchTermSA[$index]\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"formSicMapping[\'nextArea\'+$index].$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Next Outlet harus di pilih.</span></div></div></md-input-container></div></td><td \nclass=\"md-lime-300-bg\"><div layout=\"column\"><md-input-container flex><md-datepicker md-hide-icons=\"calendar\" \nname=\"effective_date\" ng-model=\"vm.Form.objForm.listSic[$index].effective_date\" required></md-datepicker><div \nng-messages=\"formSicMapping[\'effective_date\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date Date is required.</span></div></div></md-input-container></div></td></tr></tbody></table><md-list \nhide-gt-sm id=\"mobile-area\"><md-list-item ng-repeat-start=\"scale in vm.Form.objForm.listSic\" \nlayout-align=\"start stretch\" ng-class=\"$index > 0 ? \'mt-20\' : \'\'\"><span flex=\"10\" style=\"margin-top: 7px\">\n{{($index + 1)}}</span><div layout=\"column\" flex><div flex layout=\"row\"><p flex=\"30\">NIK / Name</p><p flex>\n{{vm.Form.objForm.listSic[$index].nik}} - {{vm.Form.objForm.listSic[$index].nama}}</p></div><div flex layout=\"row\"><p \nflex=\"30\">Current Outlet</p><p flex>{{vm.Form.objForm.listSic[$index].sub_area_name}}</p></div><md-input-container \nflex layout=\"column\"><label>Next Outlet</label><md-select ng-model=\"vm.Form.objForm.listSic[$index].nextArea\" \nng-required=\"true\" name=\"nextArea\" md-on-close=\"vm.clearSearchTermSA($index)\"><md-select-header><input \nng-model=\"vm.searchTermSA[$index]\" type=\"search\" placeholder=\"Search for sub area\" class=\"md-text\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"ls in vm.listOutlet | filter:vm.searchTermSA[$index]\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"formSicMapping[\'nextArea\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNext Outlet harus di pilih.</span></div></div></md-input-container><md-input-container flex layout=\"column\" \nclass=\"mt-20 mb-30\"><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.listSic[$index].effective_date\" required></md-datepicker><div \nng-messages=\"formSicMapping[\'effective_date\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date Date is required.</span></div></div></md-input-container></div></md-list-item><md-divider ng-repeat-end>\n</md-divider></md-list><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button \nclass=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh white-fg\">\n</md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/am-sic-team/am-sic-team.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.SIC_TEAM.INDEX.HEADER.TITLE\">Store Manager Team</span></md-subheader><div \nclass=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span>\n<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip>\n</md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.newMapping()\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span\n translate=\"MENU.CB.SIC_TEAM.INDEX.ACTION.NEW_MAPING\">New Mapping</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.newMapping()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions\n</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MENU.CB.SIC_TEAM.INDEX.ACTION.NEW_MAPING\">New Mapping</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table id=\"inputTable\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th></th><th class=\"text-center\" \ntranslate=\"MENU.CB.SIC_TEAM.INDEX.TABLE.NAME\">Name</th><th class=\"text-center\" \ntranslate=\"MENU.CB.SIC_TEAM.INDEX.TABLE.OUTLET\">Outlet</th><th class=\"text-center\" \ntranslate=\"MENU.CB.SIC_TEAM.INDEX.TABLE.STATUS\">Status</th></tr></thead><tbody><tr><td colspan=\"6\" \nng-if=\"!vm.loadFinish\" style=\"text-align: center;vertical-align: middle\"><div layout=\"row\"><span flex></span>\n<md-progress-circular ng-disabled=\"!vm.loadFinish\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span \nstyle=\"margin-left:10px\">Loading...</span><span flex></span></div></td></tr><tr ng-repeat=\"team in vm.listEmpOutlet\">\n<td><span><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(team)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td>\n{{team.nik}}-{{team.nama}}</td><td>{{team.sub_area_name}}</td><td class=\"text-center\"><span ng-if=\"team.status==\'1\'\">\nActive</span> <span ng-if=\"team.status==\'0\'\">Non Active</span></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/am-update-finger-approval/am-update-finger-approval.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span translate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.HEADER.TITLE\">\nUpdate Finger Approval</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div>\n<div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span\n class=\"parent grey-A100-fg\" translate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.HEADER.TITLE\">Abnormal Approval</span>\n</div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div>\n</div><div class=\"content\"><div class=\"md-whiteframe-4dp\" layout=\"column\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"row\" layout-padding layout-align=\"space-between center\"><md-input-container md-no-float class=\"md-block\" \nflex=\"30\">Shows :<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><span flex></span>\n<form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex><md-input-container md-no-float class=\"md-block\" flex=\"100\">\n<md-icon md-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\"></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\">\n</md-input-container></form></div></md-content><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-menu \nmd-offset=\"18 48\"><md-button aria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-raised reference-button md-warn md-hue-2\" \nng-click=\"vm.approveAbnormal($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.ACTION.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item>\n<md-button class=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-undo-variant\"></md-icon><span translate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.ACTION.REJECT\">Reject\n</span></md-button></md-menu-item></md-menu-content></md-menu></div><table class=\"simple\" ms-responsive-table \nid=\"inputTable\"><thead><tr><th rowspan=\"2\"></th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.NAME\">Name</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.WORKING_DATE\">Working Date</th><th colspan=\"4\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.ACTUAL_DATE\">Actual Date</th><th colspan=\"4\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.UPDATE_DATA\">Update Data</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.DESCRIPTION\">Description</th></tr><tr><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.IN\">IN</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_IN\">Break In</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.OUT\">Out</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.IN\">IN</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_IN\">Break In</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.OUT\">Out</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listApp\"><td class=\"text-center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td>{{ls.nama}}</td><td>{{ls.working_date}}</td><td class=\"text-center\"><span \nng-if=\"ls.actin !=\'empty\'\">{{ls.actin}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actbreakOut !=\'empty\'\">\n{{ls.actbreakOut}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span>\n</td><td class=\"text-center\"><span ng-if=\"ls.actout !=\'empty\'\">{{ls.actout}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.curin !=\'empty\'\">{{ls.curin}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curbreakOut !=\'empty\'\">\n{{ls.curbreakOut}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curbreakIn !=\'empty\'\">{{ls.curbreakIn}}</span>\n</td><td class=\"text-center\"><span ng-if=\"ls.curout !=\'empty\'\">{{ls.curout}}</span></td><td class=\"text\">\n{{ls.description}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/cb/am-team-assignment/am-detail-team-assignment.html","<md-dialog aria-label=\"Mango (Fruit)\" class=\"popup-input-form\" flex flex-gt-xs=\"80\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Detail Team Temporary Assignment</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 0 !important\" \nlayout=\"column\" class=\"page-layout simple fullwidth\"><div class=\"md-dialog-content content\" flex ms-scroll \nstyle=\"position: relative; padding-left: 0 !important; padding-right: 0 !important\"><div layout=\"column\" class=\"mb-25\" \nstyle=\"padding-left: 15px !important; padding-right: 15px !important\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"50px\">No</th><th>NIK / Nama\n</th><th width=\"100px\">NSO</th><th width=\"150px\">Distance</th><th width=\"200px\" ng-repeat=\"ls in vm.listOfBenefits\" \nstyle=\"word-wrap: break-word; white-space: normal\">{{ls.description}}</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.detail\"><td class=\"text-center\">{{item.no}}</td><td class=\"font-size-12\">\n{{item.nik}} - {{item.empName}}<br><span><small>Sub Area Asal: {{item.sa_asal}}</small></span></td><td \nclass=\"text-center\">{{item.new_employee == \'1\' ? \'Yes\' : \'No\'}}</td><td class=\"text-center\">{{item.distance_name}}</td>\n<td ng-repeat=\"ls in vm.listOfBenefits\"><div flex layout=\"column\"><div layout=\"row\"><div flex=\"nogrow\" \nclass=\"text-bold\">Grade</div><div flex=\"10\" flex-offset=\"5\"><span \nng-if=\"item.benefits[$index].grouping == ls.grouping\" ng-repeat=\"ben in item.benefits\">\n{{!item.benefits[$index].grade ? \'-\' : item.benefits[$index].grade}} </span><span \nng-if=\"item.benefits[$index].grouping != ls.grouping\" ng-repeat-end>-</span></div></div><div flex layout=\"row\"><div \nflex=\"nogrow\" class=\"text-bold\">Amount</div><div flex flex-offset=\"5\"><span \nng-if=\"item.benefits[$index].grouping == ls.grouping\" ng-repeat=\"ben in item.benefits\">\n{{!item.benefits[$index].formated_amount ? \'-\' : item.benefits[$index].formated_amount}} / {{!item.benefits[$index].unit ? \'-\' : item.benefits[$index].unit}} \n</span><span ng-if=\"item.benefits[$index].grouping != ls.grouping\" ng-repeat-end>- / -</span></div></div></div></td>\n</tr></tbody></table></div><md-divider style=\"margin-left: 15px !important; margin-right: 15px !important\">\n</md-divider><div layout=\"column\" layout-gt-sm=\"row\"><div layout=\"column\" flex-gt-sm=\"60\"><div layout=\"row\" \nclass=\"mv-15\" style=\"padding-left: 15px !important; padding-right: 15px !important\"><div layout=\"row\" flex><div \nflex=\"nogrow\" class=\"text-bold\">Start Date</div><div flex flex-offset=\"5\">{{vm.data.startDate_parsed}}</div></div><div \nlayout=\"row\" flex><div flex=\"nogrow\" class=\"text-bold\">End Date</div><div flex flex-offset=\"5\">\n{{vm.data.endDate_parsed}}</div></div></div><md-divider \nstyle=\"margin-left: 15px !important; margin-right: 15px !important\"></md-divider><div layout=\"row\" class=\"mv-15\" \nstyle=\"padding-left: 15px !important; padding-right: 15px !important\"><div flex=\"nogrow\" class=\"text-bold\">\nSub Area Tujuan</div><div flex flex-offset=\"5\">{{vm.data.subAreaName}}</div></div><md-divider \nstyle=\"margin-left: 15px !important; margin-right: 15px !important\"></md-divider><div layout=\"row\" class=\"mv-15\" \nstyle=\"padding-left: 15px !important; padding-right: 15px !important\"><div layout=\"row\" flex><div layout=\"row\" flex>\n<div flex=\"nogrow\" class=\"text-bold\">Company</div><div flex flex-offset=\"5\">{{vm.data.companyName}}</div></div><div \nlayout=\"row\" flex><div flex=\"nogrow\" class=\"text-bold\">Divisi</div><div flex flex-offset=\"5\">{{vm.data.divisionName}}\n</div></div></div><div layout=\"row\" flex><div flex=\"nogrow\" class=\"text-bold\">Departement</div><div flex \nflex-offset=\"5\">{{vm.data.departmentName}}</div></div></div><md-divider \nstyle=\"margin-left: 15px !important; margin-right: 15px !important\"></md-divider><div layout=\"row\" class=\"mv-15\" \nstyle=\"padding-left: 15px !important; padding-right: 15px !important\"><div flex=\"nogrow\" class=\"text-bold\">\nCost Center CNB</div><div flex flex-offset=\"5\">{{vm.data.descCnb}}<br><span class=\"small text-italic\"><small>\nBukan untuk karyawan baru NSO</small></span></div></div><md-divider \nstyle=\"margin-left: 15px !important; margin-right: 15px !important\"></md-divider><div layout=\"row\" class=\"mv-15\" \nstyle=\"padding-left: 15px !important; padding-right: 15px !important\"><div flex=\"nogrow\" class=\"text-bold\">\nCost Center Non CNB</div><div flex flex-offset=\"5\">{{vm.data.descNonCnb}}<br><span class=\"text-italic\"><small>\nBukan untuk karyawan baru NSO</small></span></div></div><md-divider \nstyle=\"margin-left: 15px !important; margin-right: 15px !important\"></md-divider><div layout=\"row\" class=\"mv-15\" \nstyle=\"padding-left: 15px !important; padding-right: 15px !important\"><div flex=\"nogrow\" class=\"text-bold\">\nDirect Report Name</div><div flex flex-offset=\"5\">{{vm.data.direct_report}} - {{vm.data.directReportName}}</div></div>\n<md-divider style=\"margin-left: 15px !important; margin-right: 15px !important\"></md-divider><div layout=\"column\" \nclass=\"mv-15\" style=\"padding-left: 15px !important; padding-right: 15px !important\"><div flex class=\"text-bold\">\nDescription</div><div flex>{{vm.data.description}}</div></div></div><span hide show-gt-sm flex-gt-sm=\"1\" class=\"bl\">\n</span><div layout=\"column\" flex-gt-sm=\"40\"><div ms-scroll><md-list id=\"list-approval\" class=\"mh-15\"><md-subheader \nclass=\"md-no-sticky md-grey-200-bg text-bold\">Approval</md-subheader><md-list-item \nclass=\"secondary-button-padding md-3-line md-long-text\" ng-class=\"app.approval_status==\'4\' ? \'md-2-line\' : \'\'\" \nng-repeat-start=\"app in vm.data.approval_data\"><div class=\"md-list-item-text\" layout=\"column\"><h4 \nng-if=\"app.approval_status!=\'4\'\" \nng-class=\"app.approval_status==\'2\' ? \'md-primary-fg\' : app.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nclass=\"text-bold m-0 font-size-10\" layout=\"column\" layout-align=\"center start\">\n{{app.approval_type | uppercase}}: {{app.status_name}}</h4><h4 ng-if=\"app.approval_status==\'4\'\" \nclass=\"text-bold md-accent-fg m-0 font-size-10\" layout=\"column\" layout-align=\"center start\">\n{{app.approval_type | uppercase}}: {{app.status_name}}</h4><p>{{app.appNameNoTitle}}</p><p \nng-if=\"app.approval_status==\'2\'\">{{app.approval_date}}</p><p ng-if=\"app.approval_status==\'4\'\">{{app.approval_date}}<br>\n{{app.rejected_comment}}</p></div></md-list-item><md-divider ng-repeat-end></md-divider></md-list></div></div></div>\n</div></md-dialog-content><md-dialog-actions style=\"min-height: 45px !important\" layout=\"column\" flex=\"nogrow\"><div \nlayout=\"row\" class=\"mv-5\" style=\"width: 100%; padding-left: 15px !important; padding-right: 15px !important\"><div \nflex=\"nogrow\" class=\"text-bold\">Request By</div><div flex flex-offset=\"5\">\n{{vm.data.assign_by}} - {{vm.data.assignByName}}</div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/am-team-assignment/am-insert-team-assignment.html","<md-dialog aria-label=\"Form Update Finger Data\" flex flex-gt-sm=\"80\" layout=\"row\" class=\"m-10\"><form ng-cloack \nid=\"FormTeamAssignment\" name=\"FormTeamAssignment\" class=\"popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,FormTeamAssignment)\" layout=\"column\" flex><md-toolbar class=\"md-cyan-600-bg has-toolbar\">\n<div class=\"md-toolbar-tools\"><h2>Team Temporary Assignment</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\" layout=\"column\" \nstyle=\"padding: 0 !important\"><div class=\"scrollable\" layout=\"column\" ms-scroll=\"{suppressScrollX: true}\"><div \nlayout=\"column\" flex md-theme=\"nabati1\" class=\"m-15\"><div layout=\"column\" layout-align=\"start end\" class=\"mb-10\" flex>\n<md-button flex=\"nogrow\" class=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Insert\" \nng-click=\"vm.addEmployee($event)\"><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-plus material-icons\">\n</md-icon><span>Add Employee</span></md-button></div><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"60px\">No</th><th style=\"min-width: 200px\">NIK / Nama</th><th width=\"100px\">\nNew Employee NSO</th><th width=\"200px\" ng-repeat=\"ls in vm.listBenefits\" \nstyle=\"word-wrap: break-word; white-space: normal\">{{ls.description}}</th><th width=\"40px\"></th></tr></thead><tbody><tr\n ng-repeat=\"data in vm.Form.objForm.employee\" ng-init=\"parentIdx = $index\"><td class=\"text-center\">{{parentIdx + 1}}\n</td><td><md-input-container class=\"mt-20 nik-inputer\" layout=\"row\"><md-autocomplete md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedItem[parentIdx]\" md-search-text-change=\"vm.searchTextChange(parentIdx)\" \nmd-search-text=\"vm.searchText[parentIdx]\" md-selected-item-change=\"vm.selectedItemChange(ls, parentIdx)\" \nmd-items=\"ls in vm.querySearch(vm.searchText[parentIdx])\" md-item-text=\"ls.display\" md-min-length=\"0\" \nmd-floating-label=\"NIK / Name\" md-input-name=\"autocomplete[{{parentIdx}}]\" required flex><md-item-template><span \nmd-highlight-flags=\"^i\">{{ls.display}}</span></md-item-template><md-not-found>\nNo NIK/NAME matching \"{{vm.searchText[parentIdx]}}\" were found.</md-not-found><div \nng-messages=\"FormTeamAssignment.autocomplete[parentIdx].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNIK / Name Required.</span></div></div></md-autocomplete></md-input-container></td><td><md-input-container \nlayout=\"row\" class=\"mt-20\" layout-align=\"start center\"><md-checkbox \nng-model=\"vm.Form.objForm.employee[parentIdx].new_employee\" name=\"new_employee\" class=\"mt-5 mb-10\" flex=\"nogrow\">\nNew Employee NSO</md-checkbox></md-input-container></td><td ng-repeat=\"ls in vm.listBenefits\" custom-repeat-directive>\n<md-input-container><md-select ng-model=\"vm.Form.objForm.employee[parentIdx].benefits[$index]\" \nng-if=\"!vm.Form.objForm.employee[parentIdx].new_employee\" placeholder=\"{{ls.description}}\" \nng-disabled=\"vm.getEmptyDataNIK(vm.Form.objForm.employee[parentIdx].nik)\" required \nname=\"benefit_id[{{parentIdx}}][{{$index}}]\"><md-option class=\"list-option\" ng-value=\"item\" \nng-repeat=\"item in ls.benefits\" \nng-selected=\"item.grade === vm.Form.objForm.employee[$parent.parentIdx].benefit[parentIdx] ? \'selected\' : \'\'\" \narial-label=\"{{item.grade}}\" style=\"height: auto\"><div layout=\"column\" class=\"pv-10\"><div>Grade: {{item.grade}}</div>\n<div>{{item.description}}</div><div>{{item.amount_formated}}</div></div></md-option></md-select><div \nng-messages=\"FormTeamAssignment.benefit_id[parentIdx][$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ls.description}} Required.</span></div></div><span class=\"hint-text\" \nng-if=\"vm.Form.objForm.employee[parentIdx].new_employee\">No Benefit Available</span></md-input-container></td><td>\n<md-button class=\"md-icon-button md-warn-fg mt-5\" ng-click=\"vm.cancelEmployee($event, parentIdx)\" flex><md-tooltip \nmd-direction=\"bottom\">Cancel Employee</md-tooltip><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr>\n</tbody></table></div><md-divider flex class=\"mh-15 mt-30\"></md-divider><div layout=\"column\" flex class=\"m-15\"><div \nlayout=\"column\" class=\"pt-15 pb-25\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm=\"25\">\n<label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"startDate\" ng-model=\"vm.Form.objForm.startDate\" \nrequired ng-change=\"vm.reinitEndDate(vm.Form.objForm.startDate)\"></md-datepicker><div \nng-messages=\"FormTeamAssignment.startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date Required.\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm=\"25\" flex-offset-gt-sm=\"5\"><label>End Date\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"endDate\" md-min-date=\"vm.initDate\" \nng-model=\"vm.Form.objForm.endDate\" required></md-datepicker><div ng-messages=\"FormTeamAssignment.endDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date Required.</span></div></div></md-input-container>\n<md-input-container flex flex-gt-sm=\"40\" flex-offset-gt-sm=\"5\"><label>Sub Area</label><md-select \nng-model=\"vm.Form.objForm.sub_area_id\" ng-change=\"vm.loadDirectName()\" name=\"sub_areaId\" required \nmd-on-close=\"vm.clearSearchTermSA()\"><md-select-header><input ng-model=\"vm.searchTermSA\" type=\"search\" \nplaceholder=\"Search for sub area\" class=\"md-text\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listSubArea | filter:vm.searchTermSA\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><span class=\"hint-text\">Sub Area Tujuan</span><div \nng-messages=\"FormTeamAssignment.sub_areaId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSub Area field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex flex-gt-sm=\"25\"><label>Company</label><md-select ng-model=\"vm.Form.objForm.company_id\" \nname=\"company_id\" ng-change=\"vm.loadDataDivision(vm.Form.objForm.company_id)\" required \nng-disabled=\"!vm.Form.objForm.employee[0].nik\"><md-option ng-repeat=\"ls in vm.listBU\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"FormTeamAssignment.company_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container flex \nflex-gt-sm=\"25\" flex-offset-gt-sm=\"5\"><label>Division</label><md-select ng-model=\"vm.Form.objForm.dvision_id\" \nng-disabled=\"!vm.Form.objForm.company_id\" name=\"dvision_id\" \nng-change=\"vm.loadDataDepartment(vm.Form.objForm.dvision_id)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><span class=\"hint-text\">Divisi Tujuan</span><div \nng-messages=\"FormTeamAssignment.dvision_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivision field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-sm=\"40\" \nflex-offset-gt-sm=\"5\"><label>Department</label><md-select ng-model=\"vm.Form.objForm.department_id\" \nng-change=\"vm.loadDirectName()\" ng-disabled=\"!vm.Form.objForm.dvision_id\" name=\"department_id\" required><md-option \nng-repeat=\"ls in vm.listDepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><span \nclass=\"hint-text\">Department Tujuan</span><div ng-messages=\"FormTeamAssignment.department_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm=\"45\"><label>Cost Center CNB</label><md-select \nng-model=\"vm.Form.objForm.cost_center_cnb\" name=\"cost_center_cnb\" required md-on-close=\"vm.clearSearchTermCCC()\">\n<md-select-header><input ng-model=\"vm.searchTermCCC\" type=\"search\" placeholder=\"Search for Cost Center CNB\" \nclass=\"md-text\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"ls in vm.listcnb | filter:vm.searchTermCCC\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n<span class=\"hint-text\">Cost Center CNB yang berlaku (Bukan karyawan baru NSO)</span><div \nng-messages=\"FormTeamAssignment.cost_center_cnb.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCost Center CNB Required.</span></div></div></md-input-container><md-input-container flex flex-gt-sm=\"45\" \nflex-offset-gt-sm=\"10\"><label>Cost Center Non CNB</label><md-select ng-model=\"vm.Form.objForm.cost_center_noncnb\" \nname=\"cost_center_noncnb\" required md-on-close=\"vm.clearSearchTermCCNC()\"><md-select-header><input \nng-model=\"vm.searchTermCCNC\" type=\"search\" placeholder=\"Search for Cost Center Non CNB\" class=\"md-text\" \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"ls in vm.listnoncnb | filter:vm.searchTermCCNC\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n<span class=\"hint-text\">Cost Center Non CNB yang berlaku (Bukan karyawan baru NSO)</span><div \nng-messages=\"FormTeamAssignment.cost_center_noncnb.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCost Center Non CNB Required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Direct Report Name</label><md-select ng-model=\"vm.Form.objForm.directReport\" \nng-disabled=\"!vm.Form.objForm.sub_area_id\" name=\"directReport\" required \nng-change=\"vm.directReportNamChanged(vm.Form.objForm.directReport)\"><md-option ng-repeat=\"ls in vm.listDirectName\" \nvalue=\"{{ls.nik}}\">{{ls.nik}} - {{ls.fullname}} {{vm.getDetailDirectReport(ls)}}</md-option></md-select><span \nclass=\"hint-text\">Direct Report Incharge tujuan</span><div ng-messages=\"FormTeamAssignment.directReport.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Direct Report field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\"><md-input-container flex><label>Description</label><input \nng-model=\"vm.Form.objForm.description\" name=\"description\" required minlength=\"50\" \nng-keyup=\"vm.getStrLength(vm.Form.objForm.description)\"><div class=\"hint\">\nCharacter: {{vm.getMinLength(vm.Form.objForm.description)}}</div><div \nng-messages=\"FormTeamAssignment.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription field is required.</span></div><div ng-message=\"minlength\"><span>\nDescription field is too short minimum 50 Characters.</span></div></div></md-input-container></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\" style=\"min-height: fit-content\"><ms-widget\n flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" \nstyle=\"padding: 0\"><ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front\"><p class=\"form-messages\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex>\n</span><md-button type=\"button\" ng-click=\"vm.reloadToken()\" class=\"md-raised md-secondary-fg\" aria-label=\"Reload\"><span\n translate=\"ACTION.RELOAD_TOKEN\">Reload Token</span></md-button><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"FormTeamAssignment.$invalid || FormTeamAssignment.$pristine\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/am-team-assignment/am-team-assignment.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Team Temporary Assignment</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary md-button md-nabati1-theme md-ink-ripple pt-5\" type=\"button\" aria-label=\"Insert\" \nui-sref=\"app.cb_am_team_input_assignment\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nNew Data Existing Team Temporary Assignment</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>New Existing Assignment</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-button md-nabati1-theme md-ink-ripple pt-5\" type=\"button\" aria-label=\"Insert\" \nui-sref=\"app.cb_am_team_nso_input_assignment\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nNew Data NSO Team Temporary Assignment</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>New NSO Assignment</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-icon-button md-warn md-raised\" \nhide show-gt-sm type=\"button\" aria-label=\"Delete\" ng-click=\"vm.deleteData($event)\" \nng-disabled=\"vm.listOtselected.length == 0\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nDelete Data Team Temporary Assignment</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" style=\"font-size: 20px\">\n</md-icon></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\" on-collapse=\"vm.onCollapse()\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" rowspan=\"2\" \nwidth=\"50px\"><div layout=\"row\" layout-align=\"center center\"><md-checkbox style=\"margin: 0; max-width: 20px !important\" \nng-model=\"vm.selectAll\" ng-checked=\"vm.isCheckedAll()\" md-indeterminate=\"vm.isIndeterminate()\" \nng-click=\"vm.toggleSelectedAll()\"></md-checkbox></div></th><th width=\"50px\" class=\"text-center\" rowspan=\"2\">No.</th><th\n width=\"70px\" class=\"text-center\" rowspan=\"2\"></th><th class=\"text-center\" colspan=\"2\">Date</th><th \nclass=\"text-center\" colspan=\"2\">Cost Center</th><th width=\"200px\" class=\"text-center\" rowspan=\"2\">Department</th><th \nclass=\"text-center\" rowspan=\"2\">Sub Area</th><th width=\"150px\" class=\"text-center\" rowspan=\"2\">Approval</th></tr><tr>\n<th width=\"100px\" class=\"text-center\">Start</th><th width=\"100px\" class=\"text-center\">End</th><th class=\"text-center\">\nCNB</th><th class=\"text-center\">Non CNB</th></tr></thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\"><td \nclass=\"text-center\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"team.approval==0\"><md-checkbox \nstyle=\"margin: 0\" ng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team, $event)\"></md-checkbox></div></td><td \nclass=\"text-center\">{{team.no}}</td><td class=\"text-center\"><md-button class=\"md-icon-button\" layout=\"row\" \naria-label=\"More\" ng-click=\"vm.viewDetail($event, team, team.employee)\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n<span class=\"ml-5\">{{team.employee.length}}</span></md-button></td><td class=\"text-center\">{{team.startDate}}</td><td \nclass=\"text-center\">{{team.endDate}}</td><td>{{team.descCnb}}</td><td>{{team.descNonCnb}}</td><td>\n{{team.departmentName}}</td><td>{{team.subAreaName}}</td><td><div layout=\"column\" flex=\"noshrink\"><span \nng-if=\"inls.approval_status!=\'4\'\" flex=\"noshrink\" layout=\"row\" ng-repeat-start=\"inls in team.approval_data\"><md-tooltip\n md-direction=\"bottom\">{{inls.approval_type | uppercase}}: {{inls.appName}}</md-tooltip><md-icon \nng-if=\"inls.approval_type != \'admin-emp\' && inls.approval_status==\'1\'\" md-font-icon=\"icon-account\" \nng-class=\"inls.approval_status==\'2\' ? \'md-primary-fg\' : inls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nflex=\"nogrow\"></md-icon><md-icon \nng-if=\"(inls.approval_type == \'admin-emp\' && (inls.approval_status==\'1\' || inls.approval_status==\'2\'))\" \nmd-font-icon=\"icon-account-key\" \nng-class=\"inls.approval_status==\'2\' ? \'md-primary-fg\' : inls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nflex=\"nogrow\"></md-icon><span \nng-if=\"(inls.approval_type != \'admin-emp\' && inls.approval_status==\'1\') || (inls.approval_type == \'admin-emp\' && (inls.approval_status==\'1\' || inls.approval_status==\'2\'))\" \nng-class=\"inls.approval_status==\'2\' ? \'md-primary-fg\' : inls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nclass=\"font-size-12 line-height-24 ml-5\" flex>{{inls.status_name}}</span> </span><span \nng-if=\"inls.approval_status==\'4\'\" flex=\"noshrink\" layout=\"row\" ng-repeat-end><md-icon \nng-if=\"inls.approval_type != \'admin-emp\'\" md-font-icon=\"icon-account\" class=\"md-accent-fg\" flex=\"nogrow\"><md-tooltip \nmd-direction=\"bottom\">{{inls.approval_type | uppercase}}: {{inls.appName}}</md-tooltip></md-icon><md-icon \nng-if=\"inls.approval_type == \'admin-emp\'\" md-font-icon=\"icon-account-key\" class=\"black-fg\" flex=\"nogrow\"><md-tooltip \nmd-direction=\"bottom\">{{inls.approval_type | uppercase}}: {{inls.appName}}</md-tooltip></md-icon><md-button md-no-ink \nclass=\"md-accent-fg\" ng-click=\"vm.viewComment($event,inls)\" class=\"font-size-12 line-height-24 ml-5\" flex>\n{{inls.status_name}}</md-button><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span></div></td></tr><tr \nclass=\"text-center\" ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"10\" class=\"text-center\"><span>\nLoading, Please Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\" \nng-if=\"nav.disabled!==1\">{{nav.label}}</a> <span ng-if=\"nav.disabled===1\">{{nav.label}}</span></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/annual-leave-rules/index.html","<div id=\"header-action\" class=\"page-layout simple fullwidth with-toolbar-content\"><div class=\"header nabati1\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span translate=\"MENU.CB.ANUAL_LEAVE_RULES.INDEX.HEADER.TITLE\">\nAnual Leave Rules</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent grey-A100-fg\" translate=\"MENU.CB.ANUAL_LEAVE_RULES.INDEX.HEADER.TITLE\">Anual Leave Rules</span></div>\n</div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div></div>\n<div layout=\"column\" layout-fill class=\"content padding\"><div class=\"md-whiteframe-2dp white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex></div></md-content><md-toolbars><div class=\"md-toolbar-tools table-tools\">\n<md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.create()\"><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span translate=\"MENU.CB.LEAVE.INDEX.ACTION.NEW\">New</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.deleteData()\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"MENU.CB.LEAVE.INDEX.ACTION.DELETE\">Delete</span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.create()\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"MENU.CB.LEAVE.INDEX.ACTION.NEW\">New</span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.deleteData()\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"MENU.CB.LEAVE.INDEX.ACTION.DELETE\">Delete</span></md-button><span flex hide show-gt-sm></span><form \nng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex><md-input-container md-no-float class=\"md-block form-search-input\" \nflex=\"100\"><md-icon md-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input \ntype=\"text\" placeholder=\"Search..\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar stripped\" ms-responsive-table><thead><tr><th></th><th translate=\"TABLE.BU\">BU</th><th \ntranslate=\"TABLE.COUNTRY\">COUNTRY</th><th translate=\"TABLE.GRADE\">EMP_GRADE</th><th translate=\"TABLE.PAY_LEAVE_CARRY\">\nPAY_LEAVE_CARRY</th><th translate=\"TABLE.MAX_CARRY\">MAX_CARRY</th><th translate=\"TABLE.RULE_PAY\">RULE_PAY</th><th \ntranslate=\"TABLE.ANNUAL_LEAVE_TOTAL\">ANNUAL_LEAVE_TOTAL</th><th translate=\"TABLE.SERVICE_MONTH_START\">\nSERVICE MONTH START</th><th translate=\"TABLE.SERVICE_MONTH_END\">SERVICE MONTH END</th><th \ntranslate=\"TABLE.STEP_ANNIVERSARY\">STEP ANNIVERSARY</th><th translate=\"TABLE.EFFECTIVE_DATE\">EFECTIVE_DATE</th><th>\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{ls.bu_description}}</td><td>\n{{ls.country_name}}</td><td>{{ls.grade_description}}</td><td><span ng-if=\"ls.is_pay_leave_carry == 0\">NO</span> <span \nng-if=\"ls.is_pay_leave_carry == 1\">YES</span></td><td class=\"text-center\">{{ls.max_carry}}</td><td>{{ls.rule_pay}}</td>\n<td>{{ls.annual_leave_total}}</td><td>{{ls.service_month_start}}</td><td>{{ls.service_month_end}}</td><td>\n{{ls.step_anniversary}}</td><td>{{ls.effective_date}}</td><td><md-button class=\"md-button md-ink-ripple\" type=\"button\" \nhide show-gt-sm aria-label=\"Edit\" ng-click=\"vm.editData($event,ls)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-font icon-archive material-icons\"></md-icon><md-tooltip><span>Edit</span></md-tooltip></md-button></td></tr>\n</tbody></table><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-toolbars></div></div></div>");
$templateCache.put("app/main/cb/approval-absence/approval-absence.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.ABSENCE_APPROVAL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formSearchAbsenceApp\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\">\n<div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label><span \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSearchAbsenceApp.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'MENU.CB.LEAVE.INDEX.HEADER.START_DATE\' | translate}} {{\'MYPROFILE.MESSAGE.ISREQUIRED\' | translate}}.</span></div>\n</div></md-input-container><md-input-container flex><label>{{\'MENU.CB.LEAVE.INDEX.HEADER.END_DATE\' | translate}}\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"formSearchAbsenceApp.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'MENU.CB.LEAVE.INDEX.HEADER.END_DATE\' | translate}} {{\'MYPROFILE.MESSAGE.ISREQUIRED\' | translate}}</span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" required><md-option \nng-repeat=\"val in vm.listType\" placeholder=\"{{\'ATTENDANCE.LABEL.APPROVALTYPE\' | translate}}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"formSearchAbsenceApp.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>\n{{\'ATTENDANCE.LABEL.APPROVALTYPE\' | translate}} {{\'MYPROFILE.MESSAGE.ISREQUIRED\' | translate}}</span></div></div>\n</md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"formSearchAbsenceApp.$invalid || formSearchAbsenceApp.$pristine\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formSearchAbsenceApp.$invalid || formSearchAbsenceApp.$pristine\"></select>\n{{\'KPI.LABEL.ENTRIES\' | translate}}</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>\n{{\'KPI.LABEL.APPROVE\' | translate}}</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.reject($event)\"><i \nclass=\"icon-delete\"></i> <span>{{\'ACTION.REJECT\' | translate}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-button ng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" \nng-disabled=\"formSearchAbsenceApp.$invalid || formSearchAbsenceApp.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">{{\'KPI.LABEL.APPROVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon>{{\'KPI.LABEL.APPROVE\' | translate}}</md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.Reject($event)\" type=\"button\" \nng-disabled=\"formSearchAbsenceApp.$invalid || formSearchAbsenceApp.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>{{\'ACTION.REJECT\' | translate}}</span></md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span>\n{{\'ACTION.REJECT\' | translate}}</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"40\" class=\"text-center\"><span \nng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th><span translate=\"KPI.LABEL.NAME\"></span></th><th><span \ntranslate=\"PAYROLL.MENU.AREA\"></span></th><th width=\"50\"><span translate=\"PAYROLL.MENU.TYPE\"></span></th><th><span \ntranslate=\"ATTENDANCE.LABEL.TYPENAME\"></span></th><th width=\"100\"><span \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\"></span></th><th width=\"100\"><span \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\"></span></th><th><span translate=\"KPI.LABEL.DESCRIPTION\"></span></th>\n<th><span translate=\"KPI.LABEL.STATUS\"></span></th><th width=\"75\"><span translate=\"KPI.LABEL.ACTION\"></span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.allowapproval\"><input \ntype=\"checkbox\" checklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td>{{ls.nik}} - {{ls.nama}}</td>\n<td>{{ls.request_sub_area}}</td><td class=\"text-center\">{{ls.absence_type}}</td><td>{{ls.abssencecode}}</td><td \nclass=\"text-center\" ng-bind-html=\"ls.start_date + (ls.start_time ? \'<br/>\' + ls.start_time : \'\')\"></td><td \nclass=\"text-center\" ng-bind-html=\"ls.end_date + (ls.end_time ? \'<br/>\' + ls.end_time : \'\')\"></td><td>{{ls.description}}\n</td><td><span ng-if=\"ls.approval!==\'Rejected\'\">{{ls.approval}}</span> <span ng-if=\"ls.approval==\'Rejected\'\"><a \nhref=\"\" ng-click=\"vm.viewComment($event,ls)\">{{ls.approval}}</a><md-tooltip md-direction=\"top\"><span \ntranslate=\"ATTENDANCE.LABEL.VIEWCOMMENT\"></span></md-tooltip></span></td><td><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.document_addres!==null\"><md-button ng-click=\"vm.ViewDocument($event,ls.document_addres)\" \naria-label=\"Refresh widget\"><md-icon md-font-icon=\"icon-eye\" class=\"teal-800-fg\"></md-icon><span \ntranslate=\"ATTENDANCE.LABEL.VIEWDOCUMENT\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==\'Approved\'\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"KPI.LABEL.UNAPPROVE\"></span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==\'Rejected\'\">\n<md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span translate=\"ACTION.UNREJECT\"></span>\n</md-button></md-menu-item><md-menu-item ng-if=\"ls.allowapproveOther\"><md-button \nng-click=\"vm.approveOtherType($event,ls)\" aria-label=\"Flip widget\"><span translate=\"ACTION.APPOVEOTHER\"><span \ntranslate=\"ACTION.UNREJECT\"></span></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"11\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/approval-absence/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" placeholder=\"Comment\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.reject_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button ng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span translate=\"ACTION.REJECT\"></span>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-absence-hr/approval-absence-hr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">HR Approval Absence</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"!vm.budisabled\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\" \nrequired><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" class=\"mt-30\"><md-input-container flex><md-select ng-model=\"vm.flag_app\" \nng-change=\"vm.getPeriode()\" name=\"flag_app\" ng-disabled=\"vm.flagAppDisabled\" required><md-option \nng-repeat=\"val in vm.flagApp\" placeholder=\"{{ \'FILTER.FLAG_APP\' | translate }}\" value=\"{{val}}\"><span \ntranslate=\"FILTER.{{val}}\">{{val}}</span></md-option></md-select><div ng-messages=\"frmEmploye.flag_app.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"frmSearchViewDataAbnormal.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"frmSearchViewDataAbnormal.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.type\" name=\"type\" required><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Building</label><md-select ng-model=\"vm.gedung\" \nname=\"building\"><md-option ng-repeat=\"val in vm.listGedung\" placeholder=\"Building\" value=\"{{val.id}}\">{{val.name}}\n</md-option></md-select><div ng-messages=\"frmEmploye.building.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBuilding field is required.</span></div></div></md-input-container><md-button type=\"button\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></div></form></div>\n</div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical\"></div><md-button ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" hide show-gt-sm>\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span>Approve</span></md-button><div\n ng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical\" hide show-gt-sm></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" aria-label=\"Delete\" ng-click=\"vm.Reject($event)\" \ntype=\"button\" hide show-gt-sm><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Reject</span>\n</md-tooltip><md-icon md-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span>\nReject</span></md-button><span flex></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-toolbar hide-gt-sm><div class=\"md-toolbar-tools table-tools\" \nlayout=\"row\"><md-button ng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" flex><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\n<span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Approve</span></md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical\" flex=\"nogrow\"></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" aria-label=\"Delete\" ng-click=\"vm.Reject($event)\" \ntype=\"button\" flex=\"nogrow\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Reject</span>\n</md-tooltip><md-icon md-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span>\nReject</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th></th><th \ntranslate=\"TABLE.NIK\">NIK</th><th translate=\"TABLE.NAME\">Name</th><th translate=\"TABLE.TYPE\">Type</th><th \ntranslate=\"TABLE.TYPE_NAME\">Type Name</th><th translate=\"TABLE.START_DATE\">Start Date</th><th \ntranslate=\"TABLE.END_TIME\">End Date</th><th translate=\"TABLE.START_TIME\">Start Time</th><th translate=\"TABLE.END_TIME\">\nEnd Time</th><th translate=\"TABLE.DESCRIPTION\">Description</th><th translate=\"TABLE.STATUS\">Status</th><th \ntranslate=\"TABLE.ACTION\">Action</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td><span \nng-if=\"ls.allowapproval\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></span></td><td>{{ls.nik}}</td><td>{{ls.nama}}</td><td>{{ls.absence_type}} <span \nng-if=\"ls.other_type!=\'\'\" style=\"font-style: italic;font-size:12px;color:#000\"><br><br>{{ls.other_type}}</span></td>\n<td>{{ls.abssencecode}} <span ng-if=\"ls.approveother_typename!=\'\'\" \nstyle=\"font-style: italic;font-size:12px;color:#000\"><br><br>{{ls.approveother_typename}}</span></td><td>\n{{ls.start_date}}</td><td>{{ls.end_date}}</td><td>{{ls.start_time}}</td><td>{{ls.end_time}}</td><td>{{ls.description}}\n</td><td><span ng-if=\"ls.approval!==\'Rejected\'\">{{ls.approval}}</span> <span ng-if=\"ls.approval==\'Rejected\'\"><a \nhref=\"\" ng-click=\"vm.viewComment($event,ls)\">{{ls.approval}}</a><md-tooltip md-direction=\"top\">View Comment\n</md-tooltip></span></td><td><md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-if=\"ls.document_addres!==null\"><md-button \nng-click=\"vm.ViewDocument($event,ls.document_addres)\" aria-label=\"Refresh widget\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"teal-800-fg\"></md-icon><span translate=\"ACTION.VIEW_DOCUMENT\">View Document</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"ls.allowunapprove\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==\'Rejected\'\">\n<md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span translate=\"ACTION.UNREJECT\">Unreject</span>\n</md-button></md-menu-item><md-menu-item ng-if=\"ls.allowapproveOther\"><md-button \nng-click=\"vm.approveOtherType($event,ls)\" aria-label=\"Flip widget\"><span translate=\"ACTION.APPOVEOTHER\">Unreject</span>\n</md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0 || (vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"12\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/approval-absence-hr/approve-other-type.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Approve Other Type</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\"><div layout-gt-sm=\"row\"><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.abs_codeN\" name=\"abs_code\" ng-disabled=\"true\" required><md-option \nng-repeat=\"ls in vm.listAbsenceType\" placeholder=\"{{ \'MENU.CB.LEAVE.FORM_INPUT.ABSENCE_TYPE\' | translate}}\" \nvalue=\"{{ls.abs_code}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"formInputOT.abs_code.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>abs_code field is required.</span></div></div></md-input-container></div>\n<div ng-if=\"vm.isShowCustomDate\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.start_date\" flex=\"30\" ng-disabled=\"true\"></md-datepicker><div \nng-messages=\"formInputOT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" ng-disabled=\"true\" flex=\"30\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.days\" name=\"days\" \nng-required=\"vm.isShowCustomDate\"><md-option ng-repeat=\"ls in vm.dayNumber\" placeholder=\"day\" value=\"{{ls.value}}\">\n{{ls.name}}</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" name=\"comment\" ng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.approve_other_comment\" \nplaceholder=\"Comment\" required><div ng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>comment is required.</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p>\n</ms-widget-front></ms-widget><span flex></span><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\">Approve</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-absence-hr/view-doc-abs.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View Document</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/leavedocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/approval-employee-certificates/approval-employee-certificates.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Certificates</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formEmployeeCertificates\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align-gt-sm=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">Filter Data\n</span></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end start\"><md-input-container flex><md-select\n ng-model=\"vm.type\" name=\"type\" required ng-change=\"vm.loadData(1)\"><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}\n</md-option></md-select><div ng-messages=\"formEmployeeCertificates.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type field is required.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"TABLE.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"start date\" name=\"tglmulai\"></md-datepicker></md-input-container><md-input-container flex><label \ntranslate=\"TABLE.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nplaceholder=\"end date\" name=\"tglakhir\"></md-datepicker></md-input-container><div hide show-gt-sm flex flex-gt-sm=\"10\" \nclass=\"ml-10\"></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end start\"><md-input-container \nflex flex-gt-sm=\"20\"><label>Country</label><md-select ng-model=\"vm.country\" name=\"country\" \nmd-on-close=\"vm.clearSearchTermCountry()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTermCountry\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTermCountry\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex flex-gt-sm=\"40\"><label>Program</label><md-select ng-model=\"vm.program\" \nname=\"program\" md-on-close=\"vm.clearSearchTermPrograms()\" ng-keydown=\"$event.stopPropagation()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTermPrograms\" type=\"search\" placeholder=\"Search for a program...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"program\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listPrograms | filter:vm.searchTermPrograms\">{{ls.groupProgram}}</md-option></md-optgroup>\n</md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \nng-click=\"vm.loadData(1)\" flex flex-gt-sm=\"10\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container layout=\"row\">\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"formSearchUpFingerApp.$invalid || formSearchUpFingerApp.$pristine\">\n</select><span translate=\"KPI.LABEL.ENTRIES\" class=\"ml-5 mt-5\">Entries</span></md-input-container><div \nclass=\"divider-vertical\"></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.approveOT($event)\"><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span>{{\'KPI.LABEL.APPROVE\' | translate}}</span></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" \nng-click=\"vm.reject($event)\"><i class=\"icon-delete\"></i> <span>{{\'ACTION.REJECT\' | translate}}</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" \nng-disabled=\"formSearchAbsenceApp.$invalid || formSearchAbsenceApp.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">{{\'KPI.LABEL.APPROVE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon>{{\'KPI.LABEL.APPROVE\' | translate}}</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.Reject($event)\" type=\"button\" \nng-disabled=\"formSearchAbsenceApp.$invalid || formSearchAbsenceApp.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>{{\'ACTION.REJECT\' | translate}}</span></md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span>\n{{\'ACTION.REJECT\' | translate}}</span></md-button><span flex></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table id=\"list-hr-approval\" class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"text-center\" rowspan=\"2\" style=\"min-width: 40px !important\"><md-checkbox \nstyle=\"margin: 0; max-width: 20px !important\" ng-model=\"vm.selectAll\" ng-checked=\"vm.isCheckedAll()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll()\"></md-checkbox></th><th class=\"text-center\" \nrowspan=\"2\">No</th><th class=\"text-center\" rowspan=\"2\">NIK/Nama</th><th class=\"text-center\" rowspan=\"2\">Program</th><th\n class=\"text-center\" rowspan=\"2\">Code Class</th><th class=\"text-center\" colspan=\"2\">Tanggal Pelaksanaan</th><th \nclass=\"text-center\" rowspan=\"2\">Status Approval</th><th class=\"text-center\" rowspan=\"2\" width=\"160px\">Certificate</th>\n<th class=\"text-center\" rowspan=\"2\" width=\"30px\"></th></tr><tr><th class=\"text-center\">Tanggal Mulai</th><th \nclass=\"text-center\">Tanggal Selesai</th></tr><tr></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nclass=\"text-center\"><md-checkbox style=\"margin: 0\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-if=\"ls.approval_status<=\'1\'\"></md-checkbox></td><td class=\"text-center\">{{ (vm.DataTable.offset + $index + 1)}}</td>\n<td>{{ls.nik}} - {{ls.emp_name}}</td><td class=\"text-center\">{{ls.program_description}}</td><td class=\"text-center\">\n{{ls.code_class}}</td><td class=\"text-center\">{{ls.start_date}}</td><td class=\"text-center\">{{ls.end_date}}</td><td \nclass=\"text-center\"><div ng-if=\"ls.approval_status!=\'4\'\" flex=\"noshrink\" layout=\"row\" layout-align=\"center\"><md-tooltip\n md-direction=\"bottom\">{{ls.approval_type | uppercase}}: {{ls.emp_approval_name}}</md-tooltip><div \nng-class=\"ls.approval_status==\'2\' ? \'md-primary-fg\' : ls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nclass=\"font-size-12 line-height-24\" flex=\"nogrow\"><md-icon md-font-icon=\"icon-account\" \nng-class=\"ls.approval_status==\'2\' ? \'md-primary-fg\' : ls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nflex=\"nogrow\" class=\"m-0 mr-5\"></md-icon>{{ls.status_name}}</div></div><div ng-if=\"ls.approval_status==\'4\'\" \nflex=\"noshrink\" layout=\"column\" layout-align=\"center\"><md-button md-no-ink class=\"md-accent-fg\" \nng-click=\"vm.viewComment($event,ls)\" class=\"font-size-12 line-height-24 ml-5\" flex><md-icon \nmd-font-icon=\"icon-account\" class=\"md-accent-fg\" flex=\"nogrow\"></md-icon>{{ls.status_name}}<md-tooltip \nmd-direction=\"bottom\">{{ls.approval_type | uppercase}}: {{ls.emp_approval_name}}<br>View Comment</md-tooltip>\n</md-button></div></td><td class=\"text-center\"><div layout=\"column\" ng-if=\"ls.certificate_number && ls.approval_date\">\n<span>{{ls.certificate_number ? ls.certificate_number : \'&nbsp;\'}}</span> <span>{{ls.approval_date}}</span></div><span \nng-if=\"!ls.certificate_number || !ls.approval_date\"><small>N/A</small></span></td><td class=\"text-center\"><div \nlayout=\"row\" layout-align=\"center\"><md-button class=\"md-icon-button\" layout=\"row\" aria-label=\"More\" \nng-click=\"vm.viewDetail($event, ls)\" style=\"padding: 0; height: 24px\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n<md-tooltip md-direction=\"bottom\">View Detail</md-tooltip></md-button><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\" style=\"padding: 0; height: 24px\">\n<md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\" \nng-disabled=\"ls.approval_status<=\'1\' || ls.approval_status==\'4\'\"><span translate=\"KPI.LABEL.UNAPPROVE\"></span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\" \nng-disabled=\"ls.approval_status<=\'1\' || ls.approval_status==\'2\'\"><span translate=\"ACTION.UNREJECT\"></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></td></tr><tr class=\"text-center\" \nng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"10\" class=\"text-center\"><span>Loading, Please Wait\n</span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\" \nng-if=\"nav.disabled!==1\">{{nav.label}}</a> <span ng-if=\"nav.disabled===1\">{{nav.label}}</span></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/approval-ghk-gw/approval-form.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.TITLE\">Form Input GHK</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.WORKING_DAY\">Working Day</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"working_date\" ng-model=\"vm.Form.objForm.working_date\" required \nng-disabled=\"vm.disable\"></md-datepicker><div ng-messages=\"formInputGhk.working_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Holiday Date Date is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"column\"><md-input-container flex><md-radio-group layout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" \nng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\" ng-disabled=\"vm.disable\"><md-radio-button \nvalue=\"group\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.GROUP\">Group</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" ng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" ng-required=\"true\" \nname=\"location\" ng-disabled=\"vm.disable\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}\n</md-option></md-select><div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLocation harus di pilih.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.unscheduleshift\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.START_TIME\">\nStart Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99:99\" \nmask-placeholder=\"_\" required ng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div>\n<div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" mask=\"99:99\" mask-placeholder=\"_\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\">\n<div flex layout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button \nng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">\n{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\"><div flex \nlayout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" flex \nng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">{{ls.start_time}} - {{ls.end_time}}</md-radio-button>\n</div></div></md-radio-group><div ng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Template is required.</span></div></div></md-input-container><div \nlayout-gt-sm=\"column\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.REASON\">Reason</label>\n<input type=\"text\" name=\"reason\" ng-model=\"vm.Form.objForm.reason\" required ng-disabled=\"vm.disable\"><div \nng-messages=\"formInputGhk.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div>\n</div></md-input-container></div><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\" \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span translate=\"ACTION.APPROVE\">\nAprove</span></md-button><md-button ng-if=\"vm.isApproved\" class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.unapprove($event)\"><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span>Un-Aprove</span></md-button><div ng-if=\"vm.isWaiting\" class=\"toolbar-separator\"></div><md-button \nng-if=\"vm.isReject\" class=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.unrejected($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span \nclass=\"red-700-fg\">Un-Reject</span></md-button><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\" \ntranslate=\"ACTION.REJECT\">Reject</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\"><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\">\n</md-checkbox></span></th><th translate=\"TABLE.NIK\">Request By</th><th translate=\"TABLE.NAME\">Name</th><th \ntranslate=\"MENU.PMS.EMP_JOB_CODE.INDEX.TABLE.NIK_ATASAN\">Atasan</th><th translate=\"TABLE.DEPARTMENT\">Department</th><th\n translate=\"TABLE.OFFDAY\">Total Off Day</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nclass=\"text-center\"><span><md-checkbox class=\"no-label\" ng-checked=\"vm.exists(ls, vm.listSelected)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></span></td><td class=\"text-center\">{{ls.nik}}</td><td>{{ls.nama}}</td><td>N1 : {{ls.n1}}<span \nng-if=\"ls.n2!=\'\'\"><br>N2: {{ls.n2}}</span></td><td>{{ls.department}}</td><td class=\"text-center\">{{ls.offday}}</td>\n</tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-gw/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK_HOLIDAY.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.data.rejected_comment}}</span></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p>\n</ms-widget-front></ms-widget><span flex></span><md-button ng-if=\"!vm.stateView\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-gw/detail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.TITLE\">Form Input GHK</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.WORKING_DAY\">Working Day</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"working_date\" ng-model=\"vm.Form.objForm.working_date\" required \nng-disabled=\"vm.disable\"></md-datepicker><div ng-messages=\"formInputGhk.working_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Holiday Date Date is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"column\"><md-input-container flex><md-radio-group layout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" \nng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\" ng-disabled=\"vm.disable\"><md-radio-button \nvalue=\"group\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.GROUP\">Group</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" ng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" ng-required=\"true\" \nname=\"location\" ng-disabled=\"vm.disable\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}\n</md-option></md-select><div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLocation harus di pilih.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.unscheduleshift\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.START_TIME\">\nStart Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99:99\" \nmask-placeholder=\"_\" required ng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div>\n<div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" mask=\"99:99\" mask-placeholder=\"_\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\">\n<div flex layout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button \nng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">\n{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\"><div flex \nlayout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" flex \nng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">{{ls.start_time}} - {{ls.end_time}}</md-radio-button>\n</div></div></md-radio-group><div ng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Template is required.</span></div></div></md-input-container><div \nlayout-gt-sm=\"column\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.REASON\">Reason</label>\n<input type=\"text\" name=\"reason\" ng-model=\"vm.Form.objForm.reason\" required ng-disabled=\"vm.disable\"><div \nng-messages=\"formInputGhk.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div>\n</div></md-input-container></div><table class=\"simple\" id=\"inputTable\"><thead><tr><th width=\"5%\"></th><th \ntranslate=\"TABLE.NIK\">NIK</th><th translate=\"TABLE.NAME\">Name</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listSelected\"><td class=\"text-center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" \nng-disabled=\"vm.disable\"></md-checkbox></td><td>{{ls.nik}}</td><td>{{ls.nama}}</td></tr></tbody></table>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Back\" translate=\"ACTION.BACK\" \nng-click=\"vm.closeModal()\">Back</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-gw/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">GHK GW Approval</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formSearchGhkGw\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><sapn translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.FILTER.TITLE\">Filter Data\n</sapn></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSearchGhkGw.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.</span>\n</div></div></md-input-container><md-input-container flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"formSearchGhkGw.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" \nng-change=\"vm.setButton(vm.type)\" required><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"formSearchGhkGw.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-raised md-primary\" aria-label=\"search\" ng-disabled=\"formSearchGhkGw.$invalid || formSearchGhkGw.$pristine\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.FILTER.SEARCH\">Search</span></md-button></md-input-container></div>\n</form></div></div></md-content><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formSearchGhkGw.$invalid || formSearchGhkGw.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><span translate=\"\">Search Employee</span></md-button><span flex></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"20%\" class=\"text-center\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.WORKING_DAY\">Working Day</th><th width=\"15%\" class=\"text-center\" \ntranslate=\"TABLE.EXPIRED\">Expired</th><th class=\"text-left\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.REASON\">Reason</th><th width=\"15%\" class=\"text-center\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.STATUS\">Status</th><th width=\"15%\" class=\"text-center\" \ntranslate=\"TABLE.REQUEST_BY\">REQUEST_BY</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span>{{ls.working_date}} {{ls.start_time}}-{{ls.end_time}}\n</span></td><td class=\"text-center\">{{ls.expireddatename}} / {{ls.expireddate}}</td><td class=\"text-left\">{{ls.reason}}\n</td><td class=\"text-center\"><span>{{ls.total_waiting}} {{vm.type}}</span></td><td class=\"text-center\">\n{{ls.requested_by}}</td><td class=\"text-center\"><md-menu><md-button class=\"md-icon-button action-selector\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button>\n<md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" \naria-label=\"Flip widget\"><span translate=\"ACTION.VIEW\">View</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==1\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"ls.approval==2\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"7\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/approval-ghk-gw/search-employee.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span>Search Employee</span> <span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\">\n</md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\"><md-input-container flex><label>Working Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"ot_date\" ng-model=\"vm.ot_date\" required></md-datepicker><div \nng-messages=\"upnormalForm.ot_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Working Date is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" placeholder=\"employee name / nik\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete\n flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"NIK Atasan\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nng-disabled=\"(upnormalForm.$invalid || upnormalForm.$pristine)\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon></md-button></md-input-container></div><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n class=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span translate=\"ACTION.APPROVE\">\nAprove</span></md-button><md-button ng-if=\"vm.isApproved\" class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.unapprove($event)\"><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span>Un-Aprove</span></md-button><div ng-if=\"vm.isWaiting\" class=\"toolbar-separator\"></div><md-button \nng-if=\"vm.isReject\" class=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.unrejected($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span \nclass=\"red-700-fg\">Un-Reject</span></md-button><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\" \ntranslate=\"ACTION.REJECT\">Reject</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\" width=\"1%\"><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\">\n</md-checkbox></span></th><th class=\"text-left\" translate=\"TABLE.NIK\">Nik</th><th class=\"text-left\" \ntranslate=\"TABLE.NAME\">Name</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\">\n<span><md-checkbox class=\"no-label\" ng-checked=\"vm.exists(ls, vm.listSelected)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td \nclass=\"text-center\">{{ls.nik}}</td><td>{{ls.nama}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Back\" translate=\"ACTION.BACK\" \nng-click=\"vm.closeModal()\">Back</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-ghk/approval-ghk.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.GHK_APPROVAL\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formGHK\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">Filter Data</span></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"TABLE.START_DATE\">Start Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\">\n</md-datepicker><div ng-messages=\"formGHK.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.START_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label translate=\"TABLE.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"formGHK.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TABLE.END_DATE\"></span> \n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.type\" name=\"type\" required ng-change=\"vm.loadData(1)\"><md-option \nng-repeat=\"val in vm.listType\" placeholder=\"{{ \'MENU.CB.APPROVAL_GHK.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" \nvalue=\"{{val}}\">{{val | uppercase}}</md-option></md-select><div ng-messages=\"formGHK.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type field is required.</span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"formGHK.$invalid\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>{{ \'PAYROLL.MENU.SEARCH\' | translate}}</span>\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" ng-disabled=\"formGHK.$invalid\"></select>\n{{ \'KPI.LABEL.ENTRIES\' | translate}}</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" ng-disabled=\"formGHK.$invalid || vm.listOtselected.length == 0\">\n<md-icon md-font-icon=\"icon-verified\"></md-icon>{{ \'KPI.LABEL.APPROVE\' | translate}}</md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" \nng-click=\"vm.Reject($event)\" ng-disabled=\"formGHK.$invalid || vm.listOtselected.length == 0\"><i class=\"icon-delete\">\n</i> <span>{{ \'ACTION.REJECT\' | translate}}</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.approveOT($event)\" ng-disabled=\"formGHK.$invalid || vm.listOtselected.length == 0\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">{{ \'KPI.LABEL.APPROVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-verified\"></md-icon>{{ \'KPI.LABEL.APPROVE\' | translate}}</md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\" ng-disabled=\"formGHK.$invalid || vm.listOtselected.length == 0\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">{{ \'ACTION.REJECT\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon><span>{{ \'ACTION.REJECT\' | translate}}</span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\"><span \nng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.NIK_NAME\">\nNik/Name</th><th translate=\"TABLE.DEPARTMENT\">Department</th><th translate=\"TABLE.OFFDAY\">Total Off Day</th><th \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.WORKING_DATE\">Working Day</th><th>Shift Time</th><th \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.REASON\">Reason</th><th translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.STATUS\">\nApproval Status</th><th translate=\"KPI.LABEL.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==\'0\'\"><input type=\"checkbox\" \nchecklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td class=\"text-center\">{{ls.nik}}/{{ls.nama}}\n</td><td>{{ls.department}}</td><td class=\"text-center\">{{ls.offday}}</td><td class=\"text-center\"><span>\n{{ls.workdayname}}/{{ls.working_date}}</span></td><td ng-bind-html=\"ls.time_shift\" class=\"text-center\"></td><td \nclass=\"text-center\">{{ls.reason}}</td><td class=\"text-center\"><span ng-if=\"ls.approval!==\'2\'\">{{ls.status}}</span> \n<span ng-if=\"ls.approval==\'2\'\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\">{{ls.status}}</a><md-tooltip \nmd-direction=\"top\">{{ \'ATTENDANCE.LABEL.VIEWCOMMENT\' | translate}}</md-tooltip></span></td><td class=\"text-center\">\n<md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.approval==\'1\'\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==\'2\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr><tr class=\"text-center\" ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"9\" \nclass=\"text-center\"><span>Loading, Please wait</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"9\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/approval-ghk/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.rejected_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button ng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-halfday/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.note_approval}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan | translate}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button ng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span translate=\"ACTION.REJECT\">Reject\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-halfday/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.GHK_HALFDAY_APPROVAL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formGhkHalfdayApp\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div\n class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">Filter Data\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"TABLE.START_DATE\">\nStart Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" placeholder=\"start date\" required \nname=\"tglmulai\"></md-datepicker><div ng-messages=\"formGhkHalfdayApp.tglmulai.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"TABLE.START_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex><label translate=\"TABLE.END_DATE\">End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"formGhkHalfdayApp.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.END_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" ng-change=\"vm.loadData()\" name=\"type\" \nrequired><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}\n</md-option></md-select><div ng-messages=\"formGhkHalfdayApp.type.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.FILTER.APPROVAL_TYPE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"formGhkHalfdayApp.$invalid || formGhkHalfdayApp.$pristine\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span>\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formGhkHalfdayApp.$invalid || formGhkHalfdayApp.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"KPI.LABEL.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" \nng-disabled=\"formGhkHalfdayApp.$invalid || formGhkHalfdayApp.$pristine\"><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span translate=\"KPI.LABEL.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formGhkHalfdayApp.$invalid || formGhkHalfdayApp.$pristine\"><i class=\"icon-delete\"></i> <span \ntranslate=\"ACTION.REJECT\">Reject</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.approveOT($event)\" ng-disabled=\"formGhkHalfdayApp.$invalid || formGhkHalfdayApp.$pristine\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.APPROVE\">Aprove</span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span translate=\"KPI.LABEL.APPROVE\">Aprove</span></md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\" ng-disabled=\"formGhkHalfdayApp.$invalid || formGhkHalfdayApp.$pristine\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.REJECT\">Reject</span></md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.REJECT\">Reject</span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\"></th><th \nwidth=\"30%\" class=\"text-left\" translate=\"TABLE.NIK_NAME\">Nik/Name</th><th width=\"5%\" class=\"text-center\" width=\"2%\" \ntranslate=\"TABLE.IDSHIFT\">IDSHIFT</th><th width=\"15%\" class=\"text-center\" width=\"10%\" translate=\"TABLE.SHIFT_TIME\">\nSHIFT TIME</th><th width=\"15%\" class=\"text-center\" width=\"15%\" translate=\"TABLE.HALFDAY_DATE\">Halfday Date</th><th \nclass=\"text-left\" translate=\"TABLE.DESCRIPTION\">Description</th><th width=\"15%\" class=\"text-center\" width=\"15%\" \ntranslate=\"TABLE.STATUS\">Status</th><th width=\"5%\" class=\"text-center\" translate=\"TABLE.ACTION\">Action</th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==\'0\'\"><input \ntype=\"checkbox\" checklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td class=\"text-left\">\n{{ls.nik}}/{{ls.nama}}</td><td class=\"text-center\">{{ ls.dws_code }}</td><td class=\"text-center\">\n{{ls.start_time}}-{{ls.end_time}}</td><td class=\"text-center\">{{ls.workdayname}} / {{ls.working_date}}</td><td \nclass=\"text-left\">{{ls.reason}}</td><td class=\"text-center\"><span ng-if=\"ls.status!==\'Rejected\'\">{{ls.status}}</span> \n<span ng-if=\"ls.status==\'Rejected\'\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\">{{ls.status}}</a><md-tooltip \nmd-direction=\"top\"><span translate=\"ATTENDANCE.LABEL.VIEWCOMMENT\"></span></md-tooltip></span></td><td \nclass=\"text-center\"><md-menu ng-if=\"ls.status !== \'Waiting Approval\'\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.status==\'Approved\'\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\">\n<span translate=\"ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.status==\'Rejected\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/approval-ghk-holiday/approval-ghk-holiday.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.GHK_HOLIDAY_APPROVAL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formSearchGhkHoliday\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\">\n<div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"TABLE.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSearchGhkHoliday.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.START_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label translate=\"TABLE.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"formSearchGhkHoliday.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.END_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" required><md-option \nng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"formSearchGhkHoliday.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"formSearchGhkHoliday.$invalid || formSearchGhkHoliday.$pristine\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>{{ \'PAYROLL.MENU.SEARCH\' | translate}}</span>\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formSearchGhkHoliday.$invalid || formSearchGhkHoliday.$pristine\"></select>\n{{ \'KPI.LABEL.ENTRIES\' | translate}}</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" \nng-disabled=\"formSearchGhkHoliday.$invalid || formSearchGhkHoliday.$pristine\"><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span translate=\"KPI.LABEL.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formSearchGhkHoliday.$invalid || formSearchGhkHoliday.$pristine\"><i class=\"icon-delete\"></i> <span \ntranslate=\"ACTION.REJECT\">Reject</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.approveOT($event)\" ng-disabled=\"formSearchGhkHoliday.$invalid || formSearchGhkHoliday.$pristine\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.APPROVE\">Approve</span>\n</md-tooltip><md-icon md-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"KPI.LABEL.APPROVE\">Approve</span></md-button><div ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formSearchGhkHoliday.$invalid || formSearchGhkHoliday.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.REJECT\">Reject</span></md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.REJECT\">\nReject</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th class=\"text-center\"><span ng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th class=\"text-left\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.NIK_NAME\">Nik/Name</th><th translate=\"TABLE.DEPARTMENT\">Department\n</th><th translate=\"TABLE.OFFDAY\">Total Off Day</th><th translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.HOLIDAY\">\nHoliday</th><th translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.WORKING_DAY\">Working Day</th><th \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.REASON\">Reason</th><th \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.STATUS\">Status</th><th \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==\'0\'\"><input type=\"checkbox\" \nchecklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td>{{ls.nik}}/{{ls.nama}}</td><td>\n{{ls.department}}</td><td class=\"text-center\">{{ls.offday}}</td><td class=\"text-center\">\n{{ls.holidayname}} / {{ls.holiday_date}}</td><td class=\"text-center\"><span>{{ls.workdayname}}/{{ls.working_date}}\n</span> <span>{{ls.start_time}}-{{ls.end_time}}</span></td><td class=\"text-center\">{{ls.reason}}</td><td \nclass=\"text-center\"><span ng-if=\"ls.approval!==\'2\'\">{{ls.status}}</span> <span ng-if=\"ls.approval==\'2\'\"><a href=\"\" \nng-click=\"vm.viewComment($event,ls)\">{{ls.status}}</a><md-tooltip md-direction=\"top\">\n{{ \'ATTENDANCE.LABEL.VIEWCOMMENT\' | translate}}</md-tooltip></span></td><td class=\"text-center\"><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.approval==1\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"ls.approval==2\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"9\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/approval-ghk-holiday/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.rejected_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button ng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-halfday-gw/approval-form.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear>\n<md-dialog-content><div layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.HALFDAY\">Halfday</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"working_date\" ng-model=\"vm.Form.objForm.working_date\" required ng-disabled=\"vm.disable\"></md-datepicker><div \nng-messages=\"upnormalForm.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nHoliday Date Date is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"column\">\n<md-input-container flex><md-radio-group layout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" \nng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\" ng-disabled=\"vm.disable\"><md-radio-button \nvalue=\"group\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.GROUP\">Group</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" ng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" ng-required=\"true\" \nname=\"location\" ng-disabled=\"vm.disable\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}\n</md-option></md-select><div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLocation harus di pilih.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.unscheduleshift\"><md-input-container flex><label translate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.START_TIME\">\nStart Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99:99\" \nmask-placeholder=\"_\" required ng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div>\n<div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" mask=\"99:99\" mask-placeholder=\"_\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\">\n<div flex layout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button \nng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">\n{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\"><div flex \nlayout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" flex \nng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">{{ls.start_time}} - {{ls.end_time}}</md-radio-button>\n</div></div></md-radio-group><div ng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Template is required.</span></div></div></md-input-container><div \nlayout-gt-sm=\"column\"><md-input-container flex><label translate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.DESCRIPTION\">\nDescription</label><input type=\"text\" name=\"reason\" ng-model=\"vm.Form.objForm.reason\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"upnormalForm.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nReason is required.</span></div></div></md-input-container></div><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n class=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span translate=\"ACTION.APPROVE\">\nAprove</span></md-button><md-button ng-if=\"vm.isApproved\" class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.unapprove($event)\"><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span>Un-Aprove</span></md-button><div ng-if=\"vm.isWaiting\" class=\"toolbar-separator\"></div><md-button \nng-if=\"vm.isReject\" class=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.unrejected($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span \nclass=\"red-700-fg\">Un-Reject</span></md-button><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\" \ntranslate=\"ACTION.REJECT\">Reject</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\"><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\">\n</md-checkbox></span></th><th class=\"text-left\" translate=\"TABLE.NIK\">Request By</th><th class=\"text-left\" \ntranslate=\"TABLE.NAME\">Name</th><th translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.TABLE.NIK_ATASAN\">Atasan</th><th \ntranslate=\"TABLE.DEPARTMENT\">Department</th><th translate=\"TABLE.OFFDAY\">Total Off Day</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span><md-checkbox class=\"no-label\" \nng-checked=\"vm.exists(ls, vm.listSelected)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td class=\"text-center\">{{ls.nik}}</td>\n<td>{{ls.nama}}</td><td>N1 : {{ls.n1}}<span ng-if=\"ls.n2!=\'\'\"><br>N2: {{ls.n2}}</span></td><td>{{ls.department}}</td>\n<td>{{ls.offday}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Back\" translate=\"ACTION.BACK\" \nng-click=\"vm.closeModal()\">Back</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-halfday-gw/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK_HOLIDAY.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.data.rejected_comment}}</span></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p>\n</ms-widget-front></ms-widget><span flex></span><md-button ng-if=\"!vm.stateView\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-halfday-gw/detail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.TITLE\">Form Input GHK</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.HALFDAY\">Halfday</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"halfday_date\" ng-model=\"vm.Form.objForm.halfday_date\" required ng-disabled=\"vm.disable\">\n</md-datepicker><div ng-messages=\"upnormalForm.halfday_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nHoliday Date Date is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"column\">\n<md-input-container flex><md-radio-group layout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" \nng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\" ng-disabled=\"vm.disable\"><md-radio-button \nvalue=\"group\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.GROUP\">Group</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" ng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" ng-required=\"true\" \nname=\"location\" ng-disabled=\"vm.disable\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}\n</md-option></md-select><div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLocation harus di pilih.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.unscheduleshift\"><md-input-container flex><label translate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.START_TIME\">\nStart Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99:99\" \nmask-placeholder=\"_\" required ng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div>\n<div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"MENU.CB.APPROVAL_GHK_HALFDAY.FORM.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" mask=\"99:99\" mask-placeholder=\"_\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\">\n<div flex layout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button \nng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">\n{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\"><div flex \nlayout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" flex \nng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">{{ls.start_time}} - {{ls.end_time}}</md-radio-button>\n</div></div></md-radio-group><div ng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Template is required.</span></div></div></md-input-container><div \nlayout-gt-sm=\"column\"><md-input-container flex><label translate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.DESCRIPTION\">\nDescription</label><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"upnormalForm.description.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Description is required.</span></div></div></md-input-container></div><table class=\"simple\" id=\"inputTable\">\n<thead><tr><th width=\"5%\"></th><th translate=\"TABLE.NIK\">NIK</th><th translate=\"TABLE.NAME\">Name</th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.listSelected\"><td class=\"text-center\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" ng-disabled=\"vm.disable\"></md-checkbox></td><td>{{ls.nik}}</td>\n<td>{{ls.nama}}</td></tr></tbody></table></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Back\" translate=\"ACTION.BACK\" \nng-click=\"vm.closeModal()\">Back</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-halfday-gw/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">GHK Halfday GW Approval</md-subheader><div class=\"white-bg\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formSearchAppGhkHalfdayGw\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><sapn translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.FILTER.TITLE\">Filter Data\n</sapn></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSearchAppGhkHalfdayGw.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"formSearchAppGhkHalfdayGw.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.type\" ng-change=\"vm.setButton(vm.type)\" name=\"type\" required><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}</md-option></md-select><div \nng-messages=\"formSearchAppGhkHalfdayGw.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-raised md-primary\" aria-label=\"search\" \nng-disabled=\"formSearchAppGhkHalfdayGw.$invalid || formSearchAppGhkHalfdayGw.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"FILTER.SEARCH\">Search\n</span></md-button></md-input-container></div></form></div></div><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n class=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span \ntranslate=\"\">Search Employee</span></md-button><span flex></span></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th class=\"text-center\" width=\"2%\" translate=\"TABLE.IDSHIFT\">IDSHIFT</th><th class=\"text-center\" \nwidth=\"10%\" translate=\"TABLE.SHIFT_TIME\">SHIFT TIME</th><th class=\"text-center\" width=\"15%\" \ntranslate=\"TABLE.HALFDAY_DATE\">Halfday Date</th><th class=\"text-left\" translate=\"TABLE.DESCRIPTION\">Description</th><th\n class=\"text-center\" width=\"15%\" translate=\"TABLE.STATUS\">Status</th><th width=\"15%\" class=\"text-center\" \ntranslate=\"TABLE.REQUEST_BY\">REQUEST_BY</th><th class=\"text-center\" width=\"5%\" translate=\"TABLE.ACTION\">Action</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\">{{ls.dws_code}}</td><td \nclass=\"text-center\">{{ls.start_time}} - {{ls.end_time}}</td><td class=\"text-center\">\n{{ls.workdayname}} / {{ls.working_date}}</td><td class=\"text-left\">{{ls.reason}}</td><td class=\"text-center\"><span>\n{{ls.total_waiting}} {{vm.type}}</span></td><td class=\"text-center\">{{ls.requested_by}}</td><td><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" aria-label=\"Flip widget\"><span translate=\"ACTION.VIEW\">View\n</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==1\"><md-button ng-click=\"vm.UnApproved($event,ls)\" \naria-label=\"Flip widget\"><span translate=\"ACTION.UNAPPROVE\">Unapprove</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.approval==2\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/approval-ghk-holiday-gw/approval-form.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.TITLE\">Form Input GHK</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.HOLIDAY\">Holiday</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"holiday_date\" ng-change=\"vm.changeHoliday()\" ng-model=\"vm.Form.objForm.holiday_date\" \nrequired ng-disabled=\"vm.disable\"></md-datepicker><div ng-messages=\"formInputGhk.holiday_date.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Holiday Date Date is required.</span></div></div></md-input-container><md-input-container \nng-if=\"vm.required\" flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.WORKING_DAY\">Working Day</label><md-select \nng-model=\"vm.Form.objForm.working_date\" name=\"working_date\" ng-required=\"vm.required\" ng-disabled=\"vm.disable\">\n<md-option ng-repeat=\"ls in vm.listworkingday\" value=\"{{ls.holiday_date}}\">{{ls.holiday_name}}</md-option></md-select>\n<div ng-messages=\"formAbsence.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking Date field is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"column\">\n<md-input-container flex><md-radio-group layout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" \nng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\" ng-disabled=\"vm.disable\"><md-radio-button \nvalue=\"group\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.GROUP\">Group</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" ng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" ng-required=\"true\" \nname=\"location\" ng-disabled=\"vm.disable\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}\n</md-option></md-select><div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLocation harus di pilih.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.unscheduleshift\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.START_TIME\">\nStart Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99:99\" \nmask-placeholder=\"_\" required ng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div>\n<div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" mask=\"99:99\" mask-placeholder=\"_\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\">\n<div flex layout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button \nng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">\n{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\"><div flex \nlayout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" flex \nng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">{{ls.start_time}} - {{ls.end_time}}</md-radio-button>\n</div></div></md-radio-group><div ng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Template is required.</span></div></div></md-input-container><div \nlayout-gt-sm=\"column\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.REASON\">Reason</label>\n<input type=\"text\" name=\"reason\" ng-model=\"vm.Form.objForm.reason\" required ng-disabled=\"vm.disable\"><div \nng-messages=\"formInputGhk.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div>\n</div></md-input-container></div><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\" \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span translate=\"ACTION.APPROVE\">\nAprove</span></md-button><md-button ng-if=\"vm.isApproved\" class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.unapprove($event)\"><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span>Un-Aprove</span></md-button><div ng-if=\"vm.isWaiting\" class=\"toolbar-separator\"></div><md-button \nng-if=\"vm.isReject\" class=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.unrejected($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span \nclass=\"red-700-fg\">Un-Reject</span></md-button><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\" \ntranslate=\"ACTION.REJECT\">Reject</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\" width=\"5%\"><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\">\n</md-checkbox></span></th><th class=\"text-center\" translate=\"TABLE.NIK\">Request By</th><th class=\"text-center\" \ntranslate=\"TABLE.NAME\">Name</th><th translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.TABLE.NIK_ATASAN\">Atasan</th><th \ntranslate=\"TABLE.DEPARTMENT\">Department</th><th translate=\"TABLE.OFFDAY\">Total Off Day</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span><md-checkbox class=\"no-label\" \nng-checked=\"vm.exists(ls, vm.listSelected)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td class=\"text-center\">{{ls.nik}}</td>\n<td>{{ls.nama}}</td><td>N1 : {{ls.n1}}<span ng-if=\"ls.n2!=\'\'\"><br>N2: {{ls.n2}}</span></td><td>{{ls.department}}</td>\n<td class=\"text-center\">{{ls.offday}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-holiday-gw/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK_HOLIDAY.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.data.rejected_comment}}</span></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p>\n</ms-widget-front></ms-widget><span flex></span><md-button ng-if=\"!vm.stateView\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-holiday-gw/detail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.TITLE\">Form Input GHK</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.HOLIDAY\">Holiday</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"holiday_date\" ng-change=\"vm.changeHoliday()\" ng-model=\"vm.Form.objForm.holiday_date\" \nrequired ng-disabled=\"vm.disable\"></md-datepicker><div ng-messages=\"formInputGhk.holiday_date.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Holiday Date Date is required.</span></div></div></md-input-container><md-input-container \nng-if=\"vm.required\" flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.WORKING_DAY\">Working Day</label><md-select \nng-model=\"vm.Form.objForm.working_date\" name=\"working_date\" ng-required=\"vm.required\" ng-disabled=\"vm.disable\">\n<md-option ng-repeat=\"ls in vm.listworkingday\" value=\"{{ls.holiday_date}}\">{{ls.holiday_name}}</md-option></md-select>\n<div ng-messages=\"formAbsence.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking Date field is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"column\">\n<md-input-container flex><md-radio-group layout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" \nng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\" ng-disabled=\"vm.disable\"><md-radio-button \nvalue=\"group\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.GROUP\">Group</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" ng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" ng-required=\"true\" \nname=\"location\" ng-disabled=\"vm.disable\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}\n</md-option></md-select><div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLocation harus di pilih.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.unscheduleshift\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.START_TIME\">\nStart Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99:99\" \nmask-placeholder=\"_\" required ng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div>\n<div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" mask=\"99:99\" mask-placeholder=\"_\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\">\n<div flex layout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button \nng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">\n{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\"><div flex \nlayout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" flex \nng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">{{ls.start_time}} - {{ls.end_time}}</md-radio-button>\n</div></div></md-radio-group><div ng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Template is required.</span></div></div></md-input-container><div \nlayout-gt-sm=\"column\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.REASON\">Reason</label>\n<input type=\"text\" name=\"reason\" ng-model=\"vm.Form.objForm.reason\" required ng-disabled=\"vm.disable\"><div \nng-messages=\"formInputGhk.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div>\n</div></md-input-container></div><table class=\"simple\" id=\"inputTable\"><thead><tr><th width=\"5%\"></th><th \ntranslate=\"TABLE.NIK\">NIK</th><th translate=\"TABLE.NAME\">Name</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listSelected\"><td class=\"text-center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" \nng-disabled=\"vm.disable\"></md-checkbox></td><td>{{ls.nik}}</td><td>{{ls.nama}}</td></tr></tbody></table>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Back\" translate=\"ACTION.BACK\" \nng-click=\"vm.closeModal()\">Back</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-ghk-holiday-gw/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">GHK Holiday GW Approval</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formSearchGhkHolidayGw\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><sapn translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.FILTER.TITLE\">\nFilter Data</sapn></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Start Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\">\n</md-datepicker><div ng-messages=\"formSearchGhkHolidayGw.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"formSearchGhkHolidayGw.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.type\" name=\"type\" ng-change=\"vm.setButton(vm.type)\" required><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"formSearchGhkHolidayGw.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type field is required.</span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"formSearchGhkHolidayGw.$invalid || formSearchGhkHolidayGw.$pristine\"><span>Search</span></md-button></div>\n</form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action\n<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip>\n</md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.approveOT($event)\" \nng-disabled=\"formSearchGhkHolidayGw.$invalid || formSearchGhkHolidayGw.$pristine\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.ACTION.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item>\n<md-button class=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formSearchGhkHolidayGw.$invalid || formSearchGhkHolidayGw.$pristine\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.ACTION.REJECT\">Reject</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formSearchGhkHolidayGw.$invalid || formSearchGhkHolidayGw.$pristine\"></select><span \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><span translate=\"\">Search Employee</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"10%\" class=\"text-center\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.HOLIDAY\">Holiday</th><th width=\"10%\" class=\"text-center\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.WORKING_DAY\">Working Day</th><th class=\"text-left\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.REASON\">Reason</th><th width=\"15%\" class=\"text-center\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.STATUS\">Status</th><th width=\"20%\" class=\"text-center\" \ntranslate=\"TABLE.REQUEST_BY\">REQUEST_BY</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.TABLE.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\">{{ls.holidayname}} / {{ls.holiday_date}}</td><td \nclass=\"text-center\"><span>{{ls.workdayname}}/{{ls.working_date}}</span> <span>{{ls.start_time}}-{{ls.end_time}}</span>\n</td><td class=\"text-left\">{{ls.reason}}</td><td class=\"text-center\"><span>{{ls.total_waiting}} {{vm.type}}</span></td>\n<td class=\"text-center\">{{ls.requested_by}} - {{ls.requested_name}}</td><td class=\"text-center\"><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" aria-label=\"Flip widget\"><span translate=\"ACTION.VIEW\">View\n</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==1\"><md-button ng-click=\"vm.UnApproved($event,ls)\" \naria-label=\"Flip widget\"><span translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.ACTION.UNAPPROVE\">Unapprove</span>\n</md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==2\"><md-button ng-click=\"vm.UnReject($event,ls)\" \naria-label=\"Flip widget\"><span translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.INDEX.ACTION.UNREJECT\">Unreject</span>\n</md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"7\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/approval-ot/approval-ot.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.OVERTIME_APPROVAL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formSearchOTApproval\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\">\n<div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"TABLE.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSearchOTApproval.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.START_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label translate=\"TABLE.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"formSearchOTApproval.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.END_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" required><md-option \nng-repeat=\"val in vm.listType\" placeholder=\"{{ \'MENU.CB.APPROVAL_OT.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" \nvalue=\"{{val}}\">{{val | uppercase}}</md-option></md-select><div ng-messages=\"formSearchOTApproval.type.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>type field is required.</span></div></div></md-input-container><md-button\n class=\"md-mini md-raised md-primary\" type=\"button\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"(formSearchOTApproval.$invalid || formSearchOTApproval.$pristine)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>{{ \'PAYROLL.MENU.SEARCH\' | translate}}</span>\n</md-button></div></form></div></div></md-content><div class=\"form-wrapper-period\" layout=\"column\" \nlayout-align=\"start left\" flex><label><span>{{ \'ATTENDANCE.LABEL.CURRENTPERIOD\' | translate}} : <b>{{vm.periode}}</b>\n</span></label><label><span>{{ \'ATTENDANCE.LABEL.OVERTIMECONSUMPTION\' | translate}} : <b>\n{{vm.currentot}} {{ \'ATTENDANCE.LABEL.HOUR\' | translate}}</b> </span></label></div><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formSearchOTApproval.$invalid || formSearchOTApproval.$pristine\"></select>\n{{ \'KPI.LABEL.ENTRIES\' | translate}}</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveOT($event)\" \nng-disabled=\"formSearchOTApproval.$invalid || formSearchOTApproval.$pristine\"><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span>{{ \'KPI.LABEL.APPROVE\' | translate}}</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formSearchOTApproval.$invalid || formSearchOTApproval.$pristine\"><i class=\"icon-delete\"></i> <span>\n{{ \'ACTION.REJECT\' | translate}}</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.approveOT($event)\" ng-disabled=\"formSearchOTApproval.$invalid || formSearchOTApproval.$pristine\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">{{ \'KPI.LABEL.APPROVE\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span>{{ \'KPI.LABEL.APPROVE\' | translate}}</span></md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.Reject($event)\" ng-disabled=\"formSearchOTApproval.$invalid || formSearchOTApproval.$pristine\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Reject OT</md-tooltip><md-icon md-font-icon=\"icon-close-circle\">\n</md-icon><span>{{ \'ACTION.REJECT\' | translate}}</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\" class=\"text-center\"><span \nng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th translate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.TYPE\" \nwidth=\"40\">Type</th><th translate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.DATE\" width=\"70\">Date</th><th \ntranslate=\"TABLE.START_DATE\" width=\"100\">Start Date Time</th><th translate=\"TABLE.END_DATE\" width=\"100\">End Date Time\n</th><th translate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.REST_HOUR\" width=\"90\">Rest Hour</th><th \ntranslate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.REQUEST_BY\" width=\"100\">Request By</th><th translate=\"UMUT.MENU.AREA\">\nSub Area</th><th translate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.REASON\">Reason</th><th \ntranslate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.STATUS\" width=\"120\">Status</th><th width=\"100\" translate=\"KPI.LABEL.ACTION\">\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span \nng-if=\"ls.appstatus==\'-1\' || ls.appstatus==\'99\'\"><input type=\"checkbox\" checklist-model=\"vm.listOtselected\" \nchecklist-value=\"ls\"></span></td><td>{{ls.ot_type}}</td><td class=\"text-center\">{{ls.ot_date}}</td><td \nclass=\"text-center\">{{ls.parsed_date_start | date : \"d/M/yyyy\"}}<br>{{ls.parsed_time_start}}</td><td \nclass=\"text-center\">{{ls.parsed_date_end | date : \"d/M/yyyy\"}}<br>{{ls.parsed_time_end}}</td><td class=\"text-center\">\n{{ls.rest_hour}}</td><td>{{ls.requestname}}</td><td>{{ls.sub_area_name}}</td><td>{{ls.reason}}</td><td><span \nng-if=\"ls.appstatus!==\'0\'\">{{ls.appstatusname}}</span> <span ng-if=\"ls.appstatus==\'0\'\"><a href=\"\" \nng-click=\"vm.viewComment($event,ls)\">{{ls.appstatusname}}</a><md-tooltip md-direction=\"top\">\n{{ \'ATTENDANCE.LABEL.VIEWCOMMENT\' | translate}}</md-tooltip></span></td><td><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.setViewTeam($event,ls)\" aria-label=\"Refresh widget\"><span \ntranslate=\"MENU.CB.APPROVAL_OT.INDEX.ACTION.VIEW_TEAM\">View Team</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.appstatus==\'1\'\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_OT.INDEX.ACTION.UNAPPROVE\">UnApprove</span></md-button></md-menu-item><md-menu-item \nng-if=\"ls.appstatus==\'0\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.APPROVAL_OT.INDEX.ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>\n<style type=\"text/css\">.btn-ui-serif {\n    line-height: 3.8rem !important;\n  }</style>");
$templateCache.put("app/main/cb/approval-ot/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" placeholder=\"Comment\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.rejected_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button ng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span translate=\"ACTION.REJECT\"></span>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-overtime-gw/approval-form.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span translate=\"MENU.CB.EMPLOYEE_OT_GW.FORM_INPUT.TITLE\">Input Employe Overtime GW</span> \n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\">\n<md-input-container flex><md-radio-group ng-model=\"vm.Form.objForm.ot_type\" ng-disabled=\"vm.disable\" \nng-required=\"true\" name=\"ot_type\"><md-radio-button value=\"NORMAL\" name=\"ot_type\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.NORMAL\">NORMAL</span></md-radio-button>&nbsp;&nbsp;<md-radio-button \nvalue=\"KHL\" name=\"ot_type\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.KHL\">KHL</span>\n</md-radio-button></md-radio-group><div ng-messages=\"upnormalForm.ot_type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Type is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.OVETIME_DATE\">Overtime Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-disabled=\"vm.disable\" name=\"ot_date\" ng-model=\"vm.Form.objForm.ot_date\" \nrequired></md-datepicker><div ng-messages=\"upnormalForm.ot_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nOT Date is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.START_TIME\">Start Time</label><input type=\"text\" name=\"start_time\" \nng-model=\"vm.Form.objForm.start_time\" ng-max=\"24\" ng-disabled=\"vm.disable\" mask=\"99:99\" mask-placeholder=\"_\" required>\n<div ng-messages=\"upnormalForm.start_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start time is required.\n</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span>\n</div></div></md-input-container><md-input-container flex><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.END_TIME\">\nEnd Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" \nng-disabled=\"vm.disable\" mask=\"99:99\" mask-placeholder=\"_\" required><div ng-messages=\"upnormalForm.end_time.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End time is required.</span></div><div ng-message=\"max\"><span>Max 2.\n</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"20\"><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.REST_HOURS\">Rest Hours\n</label><input type=\"number\" name=\"resthour\" ng-model=\"vm.Form.objForm.resthour\" ng-disabled=\"vm.disable\" required><div\n ng-messages=\"upnormalForm.resthour.$error\" role=\"alert\"><div ng-message=\"required\"><span>Rest Hour is required.</span>\n</div></div></md-input-container><md-input-container flex=\"80\"><input type=\"text\" name=\"reason\" \nng-model=\"vm.Form.objForm.reason\" placeholder=\"{{ \'MENU.CB.EMPLOYEE_OT.FORM_INPUT.REASON\' | translate }}\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"upnormalForm.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nreason is required.</span></div></div></md-input-container></div><label ng-if=\"vm.Form.objForm.ot_type==\'NORMAL\'\" \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.QUESTION\">Apakah overtime setelah atau sebelum jam kerja?</label>\n<md-input-container ng-if=\"vm.Form.objForm.ot_type==\'NORMAL\'\" flex><md-radio-group ng-model=\"vm.Form.objForm.isafter\" \nng-disabled=\"vm.disable\" ng-required=\"true\" name=\"isafter\"><md-radio-button value=\"1\" name=\"isafter\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.AFTER_TIME\">setelah jam kerja normal</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"0\" name=\"isafter\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BEFORE_TIME\">sebelum jam kerja normal</span></md-radio-button>\n</md-radio-group><div ng-messages=\"upnormalForm.isafter.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nOT Type is required.</span></div></div></md-input-container><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n class=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span translate=\"ACTION.APPROVE\">\nAprove</span></md-button><md-button ng-if=\"vm.isApproved\" class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.unapprove($event)\"><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span>Un-Aprove</span></md-button><div ng-if=\"vm.isWaiting\" class=\"toolbar-separator\"></div><md-button \nng-if=\"vm.isReject\" class=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.unrejected($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span \nclass=\"red-700-fg\">Un-Reject</span></md-button><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\" \ntranslate=\"ACTION.REJECT\">Reject</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\"><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\">\n</md-checkbox></span></th><th class=\"text-left\" translate=\"TABLE.NIK\">NIK</th><th class=\"text-left\" \ntranslate=\"TABLE.NAME\">Name</th><th translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.TABLE.NIK_ATASAN\">Atasan</th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span><md-checkbox class=\"no-label\" \nng-checked=\"vm.exists(ls, vm.listSelected)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td class=\"text-center\">{{ls.nik}}</td>\n<td>{{ls.nama}}</td><td>N1 : {{ls.n1}}<span ng-if=\"ls.n2!=\'\'\"><br>N2: {{ls.n2}}</span></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Back\" translate=\"ACTION.BACK\" \nng-click=\"vm.closeModal()\">Back</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-overtime-gw/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.APPROVAL_GHK_HOLIDAY.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK_HOLIDAY.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.data.rejected_comment}}</span></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p>\n</ms-widget-front></ms-widget><span flex></span><md-button ng-if=\"!vm.stateView\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/approval-overtime-gw/detail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span translate=\"MENU.CB.EMPLOYEE_OT_GW.FORM_INPUT.TITLE\">Input Employe Overtime GW</span> \n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\">\n<md-input-container flex><md-radio-group ng-model=\"vm.Form.objForm.ot_type\" ng-disabled=\"vm.disable\" \nng-required=\"true\" name=\"ot_type\"><md-radio-button value=\"NORMAL\" name=\"ot_type\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.NORMAL\">NORMAL</span></md-radio-button>&nbsp;&nbsp;<md-radio-button \nvalue=\"KHL\" name=\"ot_type\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.KHL\">KHL</span>\n</md-radio-button></md-radio-group><div ng-messages=\"upnormalForm.ot_type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Type is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.OVETIME_DATE\">Overtime Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-disabled=\"vm.disable\" name=\"ot_date\" ng-model=\"vm.Form.objForm.ot_date\" \nrequired></md-datepicker><div ng-messages=\"upnormalForm.ot_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nOT Date is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.START_TIME\">Start Time</label><input type=\"text\" name=\"start_time\" \nng-model=\"vm.Form.objForm.start_time\" ng-max=\"24\" ng-disabled=\"vm.disable\" mask=\"99:99\" mask-placeholder=\"_\" required>\n<div ng-messages=\"upnormalForm.start_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start time is required.\n</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span>\n</div></div></md-input-container><md-input-container flex><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.END_TIME\">\nEnd Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" \nng-disabled=\"vm.disable\" mask=\"99:99\" mask-placeholder=\"_\" required><div ng-messages=\"upnormalForm.end_time.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End time is required.</span></div><div ng-message=\"max\"><span>Max 2.\n</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"20\"><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.REST_HOURS\">Rest Hours\n</label><input type=\"number\" name=\"resthour\" ng-model=\"vm.Form.objForm.resthour\" ng-disabled=\"vm.disable\" required><div\n ng-messages=\"upnormalForm.resthour.$error\" role=\"alert\"><div ng-message=\"required\"><span>Rest Hour is required.</span>\n</div></div></md-input-container><md-input-container flex=\"80\"><input type=\"text\" name=\"reason\" \nng-model=\"vm.Form.objForm.reason\" placeholder=\"{{ \'MENU.CB.EMPLOYEE_OT.FORM_INPUT.REASON\' | translate }}\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"upnormalForm.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nreason is required.</span></div></div></md-input-container></div><label ng-if=\"vm.Form.objForm.ot_type==\'NORMAL\'\" \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.QUESTION\">Apakah overtime setelah atau sebelum jam kerja?</label>\n<md-input-container ng-if=\"vm.Form.objForm.ot_type==\'NORMAL\'\" flex><md-radio-group ng-model=\"vm.Form.objForm.isafter\" \nng-disabled=\"vm.disable\" ng-required=\"true\" name=\"isafter\"><md-radio-button value=\"1\" name=\"isafter\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.AFTER_TIME\">setelah jam kerja normal</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"0\" name=\"isafter\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BEFORE_TIME\">sebelum jam kerja normal</span></md-radio-button>\n</md-radio-group><div ng-messages=\"upnormalForm.isafter.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nOT Type is required.</span></div></div></md-input-container><table class=\"simple\" id=\"inputTable\"><thead><tr><th \nwidth=\"5%\"></th><th translate=\"TABLE.NIK\">NIK</th><th translate=\"TABLE.NAME\">Name</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listSelected\"><td class=\"text-center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" \nng-disabled=\"vm.disable\"></md-checkbox></td><td>{{ls.nik}}</td><td>{{ls.nama}}</td></tr></tbody></table>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Back\" translate=\"ACTION.BACK\" \nng-click=\"vm.closeModal()\">Back</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/approval-overtime-gw/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Overtime GW Approval</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"MENU.CB.APPROVAL_OT.INDEX.FILTER.TITLE\">Filter Data</span>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.tahun\" \nng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_OT.INDEX.FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" \nng-change=\"vm.getPeriode()\" name=\"bulan\" required><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" \nng-change=\"vm.setButton(vm.type)\" required><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_OT.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}\n</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" ng-disabled=\"vm.divdeptdisabled\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" \nrequired><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" ng-disabled=\"vm.divdeptdisabled\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container><md-input-container layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" ng-disabled=\"vm.searchComplete\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"MENU.CB.APPROVAL_OT.INDEX.FILTER.SEARCH\">\nSearch</span></md-button></md-input-container></div></form></div></div></md-content></div><div id=\"attView\"><div \nlayout=\"column\" layout-align=\"start left\" flex><label><span>Current Period : {{vm.periode}}</span></label><label><span>\nOvertime Consumption : {{vm.currentot}} Hours </span></label></div><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n class=\"secondary-text\" translate=\"MENU.CB.APPROVAL_OT.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><span translate=\"\">Search Employee</span></md-button><span flex></span><form ng-submit=\"vm.loadData(1)\" \nname=\"formSearch\" flex><md-input-container md-no-float class=\"md-block\" flex=\"100\"><md-icon \nmd-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\"></md-icon><input type=\"text\" \nplaceholder=\"Search by name/nik..\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form>\n</div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\" class=\"text-center\" \ntranslate=\"TABLE.TYPE\">Type</th><th width=\"10%\" class=\"text-center\" translate=\"TABLE.DATE\">Date</th><th width=\"5%\" \nclass=\"text-center\" translate=\"TABLE.START_TIME\">Start Time</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"TABLE.END_TIME\">End Time</th><th width=\"5%\" class=\"text-center\" translate=\"TABLE.REST_HOUR\">Rest Hour</th>\n<th class=\"text-left\" translate=\"TABLE.REASON\">Reason</th><th width=\"15%\" class=\"text-center\" translate=\"TABLE.STATUS\">\nStatus</th><th width=\"15%\" class=\"text-center\" translate=\"TABLE.REQUEST_BY\">REQUEST_BY</th><th width=\"5%\"></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\">{{ls.ot_type}}</td><td \nclass=\"text-center\">{{ls.ot_date}}</td><td class=\"text-center\">{{ls.start_time}}</td><td class=\"text-center\">\n{{ls.end_time}}</td><td class=\"text-center\">{{ls.rest_hour}}</td><td class=\"text-left\">{{ls.reason}}</td><td \nclass=\"text-center\"><span>{{ls.total_waiting}} {{vm.type}}</span></td><td class=\"text-center\">{{ls.requestby}}</td><td \nclass=\"text-center\"><md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"ACTION.VIEW\">View</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==\'1\'\"><md-button \nng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span translate=\"ACTION.UNAPPROVE\">Unapprove</span>\n</md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==\'2\'\"><md-button ng-click=\"vm.UnReject($event,ls)\" \naria-label=\"Flip widget\"><span translate=\"ACTION.UNREJECT\">Unreject</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/approval-overtime-gw/search-employee-ot.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span>Search Employee Overtime</span> <span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\">\n</md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.OVETIME_DATE\">Overtime Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"ot_date\" ng-model=\"vm.ot_date\" required></md-datepicker><div ng-messages=\"upnormalForm.ot_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>OT Date is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" placeholder=\"employee name / nik\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"NIK Atasan\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nng-disabled=\"(upnormalForm.$invalid || upnormalForm.$pristine)\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon></md-button></md-input-container></div><md-toolbar md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n class=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span translate=\"ACTION.APPROVE\">\nAprove</span></md-button><md-button ng-if=\"vm.isApproved\" class=\"md-button md-ink-ripple md-primary md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.unapprove($event)\"><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span>Un-Aprove</span></md-button><div ng-if=\"vm.isWaiting\" class=\"toolbar-separator\"></div><md-button \nng-if=\"vm.isReject\" class=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.unrejected($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span \nclass=\"red-700-fg\">Un-Reject</span></md-button><md-button ng-if=\"vm.isWaiting\" \nclass=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\" \ntranslate=\"ACTION.REJECT\">Reject</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\" width=\"1%\"><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\">\n</md-checkbox></span></th><th class=\"text-left\" translate=\"TABLE.NIK\">Nik</th><th class=\"text-left\" \ntranslate=\"TABLE.NAME\">Name</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\">\n<span><md-checkbox class=\"no-label\" ng-checked=\"vm.exists(ls, vm.listSelected)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td \nclass=\"text-center\">{{ls.nik}}</td><td>{{ls.nama}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Back\" translate=\"ACTION.BACK\" \nng-click=\"vm.closeModal()\">Back</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/area-incharge/create.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.AREAINCHARGE.FORM.TITLE\">Form</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"column\"><md-input-container flex>\n<label translate=\"MENU.CB.AREAINCHARGE.FORM.NIK\">NIK</label><input type=\"text\" name=\"nik\" \nng-model=\"vm.Form.objForm.nik\" ng-disabled=\"vm.isUpdate\" md-maxlength=\"8\" ng-change=\"vm.getArea(vm.Form.objForm.nik)\" \nrequired><div ng-messages=\"upnormalForm.nik.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 8 Character.\n</span></div><div ng-message=\"required\"><span>NIK is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MENU.CB.AREAINCHARGE.TABLE.SUBAREANAME\">Sub Area</label><md-select \nmultiple=\"true\" ng-model=\"vm.Form.objForm.sub_area_ids\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listArea | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"upnormalForm.sub_area.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nsub area field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.AREAINCHARGE.TABLE.TYPE\">Type</label><md-select ng-model=\"vm.Form.objForm.type\" name=\"type\" \nrequired><md-option ng-repeat=\"val in vm.listType\" placeholder=\"{{ \'MENU.CB.AREAINCHARGE.TABLE.TYPE\' | translate }}\" \nvalue=\"{{val.id}}\">{{val.name}}</md-option></md-select><div ng-messages=\"upnormalForm.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type field is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine\" translate=\"MENU.CB.AREAINCHARGE.FORM.SAVE\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/area-incharge/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.AREAINCHARGE.HEADER\">Admin Area Incharge Management</span></md-subheader><div\n class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header\n class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listArea | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\"><md-option \nng-repeat=\"val in vm.listType\" placeholder=\"Type\" value=\"{{val.id}}\">{{val.name}}</md-option></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.SEARCH\">Search</span></md-button></md-input-container></div></form></div>\n</div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button md-mini\" ng-click=\"$mdMenu.open($event)\"><md-icon \nstyle=\"font-size:12px\" md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-raised md-primary btn-ui-serif md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Input($event)\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-border-color\"></md-icon><span style=\"font-size:12px\" translate=\"MENU.CB.AREAINCHARGE.NEW\">New</span>\n</md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" \nng-disabled=\"vm.listselected.length == 0\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i class=\"icon-delete\">\n</i> <span style=\"font-size:12px\" ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span style=\"font-size:12px\" ng-if=\"vm.listselected.length == 0\" \nclass=\"grey-700-fg\" translate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span style=\"font-size:12px\" \nng-if=\"vm.listselected.length > 0\">{{ vm.listselected.length }} selected</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"vm.DataTable.list.length==0\"></select><span class=\"secondary-text\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-primary\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.Input($event)\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-border-color\"></md-icon><span style=\"font-size:12px\" translate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span>\n</md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \nng-disabled=\"vm.listselected.length == 0\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData()\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-delete\" ng-if=\"vm.listselected.length == 0\" class=\"grey-500-fg\"></md-icon>\n<md-icon style=\"font-size:12px\" md-font-icon=\"icon-delete\" ng-if=\"vm.listselected.length > 0\" class=\"red-500-fg\">\n</md-icon><span style=\"font-size:12px\" ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span style=\"font-size:12px\" ng-if=\"vm.listselected.length == 0\" \nclass=\"grey-700-fg\" translate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span style=\"font-size:12px\" \nng-if=\"vm.listselected.length > 0\">{{ vm.listselected.length }} selected</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><span flex></span> <span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"1%\"><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"></md-checkbox></th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.AREAINCHARGE.TABLE.NIK\">NIK</th><th class=\"text-center\" translate=\"MENU.CB.AREAINCHARGE.TABLE.NAME\">\nNAME</th><th width=\"15%\" class=\"text-center\" translate=\"MENU.CB.AREAINCHARGE.TABLE.SUBAREANAME\">SUBAREANAME</th><th \nwidth=\"5%\" class=\"text-center\" translate=\"MENU.CB.AREAINCHARGE.TABLE.TYPE\">TYPE</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.Edit($event,ls)\"><td class=\"text-center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.exists(ls, vm.listselected)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">\n{{ls.nik}}</td><td class=\"\">{{ls.name}}</td><td class=\"\">{{ls.area_name}}</td><td class=\"\">{{ls.type}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/area-manager/area-manager.html","<div layout=\"column\" layout-fill><md-toolbar class=\"md-menu-toolbar md-whiteframe-1dp\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"start center\"><h2>Menu</h2><md-menu flex id=\"projects-menu\" md-offset=\"0 64\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg csm-dropdown\"><md-button ui-sref=\"app.cb_am_input-am\"><span \ntranslate=\"ACTION.ADD_AREA_MANAGER\">Add Area Manager</span></md-button><md-button ng-click=\"vm.deleteAM($event)\"><span \ntranslate=\"ACTION.DELETE_AREA_MANAGER\">Delete Area Manager</span></md-button></md-menu-content></md-menu></div>\n</md-toolbar><md-content flex layout=\"column\" ms-scroll><div id=\"simple-table\" \nclass=\"simple fullwidth carded with-toolbar-content white-bg\"><md-content class=\"content padding\" layout-fill><div \nclass=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\"><span translate=\"\">Area Manager\n</span></md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container \nhide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" \non-collapse=\"vm.onCollapse()\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nwidth=\"5%\"></th><th width=\"5%\">No</th><th>Nik / Name</th><th>Regional Manager</th><th>Effective Date</th><th \nwidth=\"8%\">Sub Area</th></tr></thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\" \nng-dblclick=\"vm.editData(team.id)\"><td class=\"text-center\"><span><md-checkbox class=\"no-label\" \nng-click=\"vm.toggle(team, vm.listAMSelected)\"></md-checkbox></span></td><td class=\"text-center\">{{team.no}}</td><td>\n{{team.nik}} - {{team.nama}}</td><td>{{team.nik_atasan}} - {{team.nama_atasan}}</td><td class=\"text-center\">\n{{team.effective_date}}</td><td class=\"text-center\"><md-button ng-click=\"vm.detailAction(team.id)\"><div layout=\"row\" \nflex layout-align=\"center center\"><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex>\n{{team.count_sub_area}}</p></div></md-button></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0 || (vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"6\" \nclass=\"text-center\"><span ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\">Loading</span> <span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\" ng-if=\"vm.DataTable.list.length <= 0\">No Data Available</span></td></tr></tbody>\n</table><div class=\"p-12 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\" ng-if=\"nav.disabled!==1\">{{nav.label}}</a> <span ng-if=\"nav.disabled===1\">\n{{nav.label}}</span></li></ul></nav></div></md-content></div></div></md-content></div></md-content></div>");
$templateCache.put("app/main/cb/attendance/attendance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Attendance</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nclass=\"mt-40\"><md-input-container flex><label>Mulai Tanggal</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglmulai\" md-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.START_DATE\' | translate }}\" required \nname=\"tglmulai\"></md-datepicker><div ng-messages=\"frmEmploye.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>Sampai Tanggal\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.END_DATE\' | translate }}\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"frmEmploye.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nplaceholder=\"employee name / nik\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit\n</md-button><md-button type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine || !vm.DataTable.searchParam\" \nng-click=\"vm.downloadAttendance()\"><i class=\"icon icon-download\" style=\"font-size: 15px\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\" \nng-if=\"vm.country==\'CHN\' || vm.group==\'1\'\"><div class=\"md-toolbar-tools table-tools\"><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.uploadAttendance($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">UPLOAD</span></md-button></div></md-toolbar><md-content id=\"attView\" layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered\" ms-responsive-table \nid=\"attendance\"><thead><tr><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.NO\">No</span></th><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.NIK\">NIK</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.NAME\">Nama</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.DAY_DATE\">\nHari/Tanggal</span></th><th class=\"text-center\" colspan=\"2\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.SHIFT\">Shift</span></th><th class=\"text-center\" colspan=\"4\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.ACTUAL\">Actual</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.OT_APPROVED\">OT Approved</span></th>\n<th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.OT_UNAPPROVED\">OT Unapproved</span></th><th class=\"text-center\" rowspan=\"2\">\n<span class=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.FINGER_STATUS\">Finger Status</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.NOTE\">Note</span>\n</th><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\">#</span></th></tr><tr><th class=\"text-center\"><span\n class=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.IN\">In</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.OUT\">Out</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.IN\">In</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.BREAK_OUT\">Break Out</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.BREAK_IN\">Break In</span>\n</th><th class=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCES.INDEX.TABLE.OUT\">Out</span></th>\n</tr></thead><tbody><tr style=\"display:none\" ng-init=\"idemp=$index\" \nng-repeat-start=\"lsemp in vm.DataTable.list track by $index\"></tr><tr><td rowspan=\"{{lsemp.rowd}}\">{{lsemp.no }}</td>\n<td rowspan=\"{{lsemp.rowd}}\">{{lsemp.nik }}</td><td rowspan=\"{{lsemp.rowd}}\">{{lsemp.emp_name }}</td></tr><tr \nng-init=\"idatt=$index\" ng-repeat=\"ls in lsemp.listAttendances track by $index\" \nng-class=\"{\'empholiday\':ls.isHoliday,\'emptruant\':ls.infoAbsence[0].code==\'Z301\',\'empinactive\':!ls.isAsEmployeeActive,\'empghkkerja\':ls.isGhkKerja,\'empsubsitusileave\':ls.infoAbsence[0].code==\'Z102\',\'empleave\':(ls.infoAbsence[0].full ==\'1\' && ls.infoAbsence[0].leaveStatus ==\'1\')}\">\n<td class=\"text-center\">{{ls.day}}/{{ls.date}}</td><td class=\"text-center\">{{ls.shift.tampilStartDate}}<storng>\n{{ls.shift.tampilStartTime}}</storng></td><td class=\"text-center\">{{ls.shift.tampilEndDate}} <strong>\n{{ls.shift.tampilEndTime}}</strong></td><td class=\"text-center\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.in==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.in!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateIn>0\">\n{{ls.listFingerDate.in}} <strong>{{ls.listFinger.in}}</strong><md-tooltip md-direction=\"top\">{{ls.lateIn}}</md-tooltip>\n</span><span ng-if=\"ls.lateIn==0\">{{ls.listFingerDate.in}} <strong>{{ls.listFinger.in}}</strong></span></span></td><td \nclass=\"text-center\" ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakOut==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakOut!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFingerDate.breakOut}} <strong>{{ls.listFinger.breakOut}}</strong><md-tooltip md-direction=\"top\">\n{{ls.lateBreakIn}}</md-tooltip></span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFingerDate.breakOut}} <strong>\n{{ls.listFinger.breakOut}}</strong></span></span></td><td class=\"text-center\" ng-if=\"!ls.requiredBreakFinger\"></td><td \nclass=\"text-center\" ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakIn==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakIn!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFingerDate.breakIn}} <strong>{{ls.listFinger.breakIn}}</strong><md-tooltip md-direction=\"top\">\n{{ls.lateBreakIn}}</md-tooltip></span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFingerDate.breakIn}} <strong>\n{{ls.listFinger.breakIn}}</strong></span></span></td><td class=\"text-center\" ng-if=\"!ls.requiredBreakFinger\"></td><td \nclass=\"text-center\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.out==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.out!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.earlyOut>0\">\n{{ls.listFingerDate.out}} <strong>{{ls.listFinger.out}}</strong><md-tooltip md-direction=\"top\">{{ls.earlyOut}}\n</md-tooltip></span><span ng-if=\"ls.earlyOut==0\">{{ls.listFingerDate.out}} <strong>{{ls.listFinger.out}}</strong>\n</span></span></td><td class=\"text-center\"><span ng-if=\"ls.approvedOT>0\">{{ls.approvedOT}}</span><span \nng-if=\"ls.approvedOT==0\"></span></td><td class=\"text-center\"><span ng-if=\"ls.unApprovedOT>0\">{{ls.unApprovedOT}}</span>\n<span ng-if=\"ls.unApprovedOT==0\"></span></td><td class=\"text-center\"><span ng-repeat=\"statusFin in ls.fingerStatus\">\n<span class=\"red-500-fg\">{{statusFin}}</span></span></td><td class=\"text-center\"><span \nng-repeat=\"abs in ls.infoAbsence\"><span class=\"red-500-fg\" ng-if=\"abs.code==\'Z301\' || abs.code==\'0000\'\">{{abs.name}} \n<span ng-if=\"abs.full==0\">:{{abs.total}}</span> </span><span ng-if=\"!(abs.code==\'Z301\' || abs.code==\'0000\')\">\n{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span> </span></span><span \nng-if=\"ls.isHoliday && ls.isOt && ls.splOTType==\'NORMAL\'\">| <a href=\"\" ng-click=\"vm.OtInfo($event,ls)\"><span \nclass=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">View overtime request</md-tooltip></span>\n<span ng-if=\"!ls.isHoliday && ls.isWorking && ls.isOt && ls.splOTType==\'KHL\'\">| <a href=\"\" \nng-click=\"vm.OtInfo($event,ls)\"><span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">\nView overtime request</md-tooltip></span><span ng-if=\"ls.isHoliday && !ls.isOt && ls.listFingerLength >0\">| <a href=\"\" \nng-click=\"vm.OtInfo($event,ls)\"><span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">\nView overtime request</md-tooltip></span></td><td><md-menu ng-if=\"ls.isAsEmployeeActive\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Click for view action</md-tooltip><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-button \nng-click=\"vm.fingerLog($event,ls,lsemp.nik)\" aria-label=\"Refresh widget\">Finger Log</md-button><md-button \nng-click=\"vm.infoTransaction($event,ls,lsemp.nik)\" aria-label=\"Refresh widget\">Info Transaction</md-button>\n</md-menu-content></md-menu></td></tr><tr style=\"display:none\" ng-repeat-end></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/attendance/finger-log.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.FINGERLOG.TITLE\">Finger Log</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nclass=\"alert-info warning italic md-body-1\"><div layout-gt-sm=\"row\"><span>Working Date</span> : <span>\n{{vm.Form.objForm.tanggal}}</span><div class=\"divider-vertical hide show-gt-sm\"></div><span>Shift Time</span> : <span>\n{{vm.Form.objForm.shift.tampilStart}}-{{vm.Form.objForm.shift.tampilEnd}}</span></div><div layout-gt-sm=\"row\"><span>\nRange Finger:</span></div><div layout-gt-sm=\"row\"><span class=\"red-500-fg\">In : {{vm.startRange}} to {{vm.endShift}}\n</span></div><div layout-gt-sm=\"row\" ng-if=\"vm.Form.objForm.requiredBreakFinger\"><span class=\"red-500-fg\">\nBreak Out : {{vm.startShift}} to {{vm.endShift}}</span></div><div layout-gt-sm=\"row\" \nng-if=\"vm.Form.objForm.requiredBreakFinger\"><span class=\"red-500-fg\">Break In : {{vm.startShift}} to {{vm.endShift}}\n</span></div><div layout-gt-sm=\"row\"><span class=\"red-500-fg\">Out : {{vm.startShift}} to {{vm.endRange}}</span></div>\n</div><div layout-gt-sm=\"row\"><table class=\"simple\" id=\"inputTable\"><thead><tr><th \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.FINGERLOG.TABLE.HEADER.FINGER_TIME\">Finger Time</th><th \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.FINGERLOG.TABLE.HEADER.TYPE\">Type</th><th \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.FINGERLOG.TABLE.HEADER.MESIN_NO\">Mesin No</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.logfinger\"><td>{{ls.transaction_time}}</td><td>{{ls.typename}}</td><td>{{ls.mesin_no}}</td></tr>\n</tbody></table></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/attendance/info-transaction.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"90\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Transaction attendance list date : {{vm.Form.objForm.tanggal}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\"><table class=\"simple\" id=\"inputTable\"><thead><tr><th translate=\"TABLE.TRANSACTION_TYPE\" \nclass=\"text-center\">Transaction Type</th><th translate=\"TABLE.REQUEST_DATE\" class=\"text-center\">Request Date</th><th \ntranslate=\"TABLE.APPROVAL_STATUS\" class=\"text-center\">Approval Status</th><th translate=\"TABLE.APPROVAL_DATE\" \nclass=\"text-center\">Approval Date</th><th></th></tr></thead><tbody><tr \nng-init=\"mainIdx=$index;vm.visibleSubChild[mainIdx]=false\" ng-repeat-start=\"ls in vm.listTransaction track by $index\" \nid=\"row-$index\"><td class=\"text-center\">{{ls.mainInfo[0][\'transaction-name\'] | uppercase}}</td><td class=\"text-center\">\n{{ls.mainInfo[0][\'request-date\'] | uppercase}}</td><td class=\"text-center\">\n{{ls.mainInfo[0][\'approval-status\'] | uppercase}}</td><td class=\"text-center\">\n{{ls.mainInfo[0][\'approval-date\'] | uppercase}}</td><td><md-icon md-font-icon=\"icon-minus\" class=\"24 separator\" \nng-click=\"vm.toogleSubChild(mainIdx)\" ng-show=\"vm.visibleSubChild[mainIdx]\"><md-tooltip md-direction=\"top\">Close Detail\n</md-tooltip></md-icon><md-icon md-font-icon=\"icon-magnify\" class=\"24 separator\" ng-click=\"vm.toogleSubChild(mainIdx)\" \nng-show=\"!vm.visibleSubChild[mainIdx]\"><md-tooltip md-direction=\"top\">Show Detail</md-tooltip></md-icon></td></tr><tr \nng-show=\"vm.visibleSubChild[mainIdx]\"><td colspan=\"5\"><table class=\"simple\"><tbody><tr><td colspan=\"5\" \nclass=\"text-center\"><span>Detail Transaction</span></td></tr><tr><td ng-repeat=\"dh in ls.detailInfoHead\" \nclass=\"text-center\">{{dh | uppercase}}</td></tr><tr ng-repeat=\"det in ls.detailInfo track by $index\"><td \nclass=\"text-center\" ng-repeat=\"dh1 in ls.detailInfoHead\">{{det[dh1]}}</td></tr></tbody></table></td></tr><tr \nng-show=\"vm.visibleSubChild[mainIdx]\"><td colspan=\"5\"><table class=\"simple\"><tbody><tr><td colspan=\"4\" \nclass=\"text-center\"><span>List Approval</span></td></tr><tr><td class=\"text-center\">Approval Type</td><td \nclass=\"text-center\">Approval Status</td><td class=\"text-center\">Approval Level</td><td class=\"text-center\">Approval By\n</td></tr><tr ng-repeat=\"app in ls.approvalInfo[0]\"><td class=\"text-center\">{{app.approval_type | uppercase}}</td><td \nclass=\"text-center\">{{app.approvalStatus | uppercase}}<br ng-if=\"app.approval_status === \'4\'\"><span \nng-if=\"app.approval_status === \'4\'\">{{app.reject_comment}}</span></td><td class=\"text-center\">\n{{app.approval_level | uppercase}}</td><td class=\"text-center\">{{app.approvalName | uppercase}}</td></tr></tbody>\n</table></td></tr><tr ng-repeat-end></tr></tbody></table></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/attendance/upload-file.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.UPLOADATTENDANCEWFH\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset><legend><span translate=\"MENU.MAIN.UPLOADATTENDANCEWFH\"></span> - \n<span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFile\" nv-file-select \nuploader=\"vm.FileUploader\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUploader.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfo)\" \nclass=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span translate=\"PAYROLL.MENU.MOREINFO\"></span></span>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/attendance-outlet-team/attendance-outlet-team.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Attendance Outlet Team</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><div \nlayout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\" flex layout-align=\"end center\"><md-input-container flex \nflex-gt-xs=\"40\"><md-select ng-model=\"vm.tahun\" name=\"tahun\" required><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_TEAM.INDEX.FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"40\"><md-select \nng-model=\"vm.bulan\" name=\"bulan\" required><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_TEAM.INDEX.FILTER.MONTH\' | translate }}\" value=\"{{val.value}}\">{{val.name}}\n</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex \nclass=\"mt-30\"><md-input-container flex><label><span translate=\"KPI.LABEL.AREA\"></span></label><md-select \nng-model=\"vm.subarea\" name=\"subarea\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.changeArea(vm.subarea)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sub area...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.subarea_id}}\" ng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">\n{{ls.description}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>NIK/Name\n</label><md-select ng-model=\"vm.nik\" ng-change=\"vm.ChangeNik()\" name=\"nik\" required><md-option \nng-repeat=\"ls in vm.listteam\" placeholder=\"{{ \'MENU.CB.ATTENDANCE_TEAM.INDEX.FILTER.NIK\' | translate }}\" \nvalue=\"{{ls.nik}}\">{{vm.clearSingleQuote(ls.nik)}} - {{ls.nama}}</md-option></md-select><div \nng-messages=\"frmEmploye.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK field is required.</span></div>\n</div></md-input-container></div></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"nogrow\" layout-align=\"center end\" \nflex-offset-gt-xs=\"5\"><md-button class=\"md-mini md-raised md-primary\" type=\"button\" ng-click=\"vm.loadData(1)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.FILTER.SUBMIT\">Submit</span></md-button></div></div></form></div></div>\n</md-content><md-content id=\"attView\" layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered\" ms-responsive-table id=\"attendance\"><thead><tr><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.DAY_DATE\">Day/Date</span></th><th\n class=\"text-center\" colspan=\"2\" layout-align=\"center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.SHIFT\">Shift</span></th><th class=\"text-center\" colspan=\"4\" \nlayout-align=\"center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.ACTUAL\">Actual</span>\n</th><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.OT_APPROVED\">OT Approved</span></th><th class=\"text-center\" rowspan=\"2\">\n<span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.OT_UNAPPROVED\">OT Unapproved</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.FINGER_STATUS\">Finger Status</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.NOTE\">Note</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\">#</span></th></tr><tr><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.IN\">IN</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.OUT\">OUT</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.IN\">IN</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.BREAK_OUT\">Break Out</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.BREAK_IN\">Break In</span>\n</th><th class=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.OUT\">OUT</span>\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listAttendance track by $index\" \nng-class=\"{\'empholiday\':ls.isHoliday,\'emptruant\':ls.infoAbsence[0].code==\'Z301\',\'empinactive\':!ls.isAsEmployeeActive,\'empghkkerja\':ls.isGhkKerja,\'empsubsitusileave\':ls.infoAbsence[0].code==\'Z102\',\'empleave\':(ls.infoAbsence[0].full ==\'1\' && ls.infoAbsence[0].leaveStatus ==\'1\')}\">\n<td class=\"text-right\">{{ls.day}}/{{ls.date}}</td><td class=\"text-center\">{{ls.shift.tampilStartDate}}<storng>\n{{ls.shift.tampilStartTime}}</storng></td><td class=\"text-center\">{{ls.shift.tampilEndDate}} <strong>\n{{ls.shift.tampilEndTime}}</strong></td><td class=\"text-center\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.in==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.in!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateIn>0\">\n{{ls.listFingerDate.in}} <strong>{{ls.listFinger.in}}</strong><md-tooltip md-direction=\"top\">{{ls.lateIn}}</md-tooltip>\n</span><span ng-if=\"ls.lateIn==0\">{{ls.listFingerDate.in}} <strong>{{ls.listFinger.in}}</strong></span></span></td><td \nclass=\"text-center\" ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakOut==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakOut!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFingerDate.breakOut}} <strong>{{ls.listFinger.breakOut}}</strong><md-tooltip md-direction=\"top\">\n{{ls.lateBreakIn}}</md-tooltip></span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFingerDate.breakOut}} <strong>\n{{ls.listFinger.breakOut}}</strong></span></span></td><td class=\"text-center\" ng-if=\"!ls.requiredBreakFinger\"></td><td \nclass=\"text-center\" ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakIn==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakIn!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFingerDate.breakIn}} <strong>{{ls.listFinger.breakIn}}</strong><md-tooltip md-direction=\"top\">\n{{ls.lateBreakIn}}</md-tooltip></span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFingerDate.breakIn}} <strong>\n{{ls.listFinger.breakIn}}</strong></span></span></td><td class=\"text-center\" ng-if=\"!ls.requiredBreakFinger\"></td><td \nclass=\"text-center\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.out==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.out!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.earlyOut>0\">\n{{ls.listFingerDate.out}} <strong>{{ls.listFinger.out}}</strong><md-tooltip md-direction=\"top\">{{ls.earlyOut}}\n</md-tooltip></span><span ng-if=\"ls.earlyOut==0\">{{ls.listFingerDate.out}} <strong>{{ls.listFinger.out}}</strong>\n</span></span></td><td class=\"text-center\"><span ng-if=\"ls.approvedOT>0\">{{ls.approvedOT}}</span><span \nng-if=\"ls.approvedOT==0\"></span></td><td class=\"text-center\"><span ng-if=\"ls.unApprovedOT>0\">{{ls.unApprovedOT}}</span>\n<span ng-if=\"ls.unApprovedOT==0\"></span></td><td class=\"text-center\"><span ng-repeat=\"statusFin in ls.fingerStatus\">\n<span class=\"red-500-fg\">{{statusFin}}</span></span></td><td class=\"text-center\"><span \nng-repeat=\"abs in ls.infoAbsence\"><span class=\"red-500-fg\" ng-if=\"abs.name==\'Truant\' || abs.name==\'Undisciplined\'\">\n{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span> </span><span \nng-if=\"!(abs.name==\'Truant\' || abs.name==\'Undisciplined\')\">{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span>\n</span></span></td><td><md-menu ng-if=\"ls.isAsEmployeeActive\"><md-button class=\"md-icon-button action-selector\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nClick for view action</md-tooltip><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content \nwidth=\"3\" class=\"md-background-bg\"><md-button ng-click=\"vm.fingerLog($event,ls,vm.nik)\" aria-label=\"Refresh widget\">\nFinger Log</md-button><md-button ng-click=\"vm.infoTransaction($event,ls,vm.nik)\" aria-label=\"Refresh widget\">\nInfo Transaction</md-button></md-menu-content></md-menu></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div><style type=\"text/css\">\n.btn-ui-serif {\n    line-height: 3.8rem !important;\n  }</style>");
$templateCache.put("app/main/cb/attendance-employe/attendance-employe.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\" layout=\"column\">\n<md-content class=\"content padding\" style=\"height:100%; overflow: hidden\" layout-fill layout=\"column\"><div \nclass=\"md-whiteframe-4dp white-bg rounded\" layout-fill layout=\"column\"><md-subheader class=\"white-bg\">\nEmployee Attendances</md-subheader><div class=\"white-bg\" layout=\"column\" flex><md-toolbar class=\"open-toolbar\"><div \nclass=\"md-toolbar-tools table-tools\"><span flex hide show-gt-sm></span><md-input-container flex><md-select \nng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"Year\" value=\"{{val}}\">{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container flex><md-select ng-model=\"vm.bulan\" \nng-change=\"vm.getPeriode()\" name=\"bulan\" required><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container></div></md-toolbar><div style=\"height:8px\"></div><md-content \nid=\"attendance-container\" hide show-gt-sm layout=\"column\" flex class=\"white-bg\"><md-subheader flex layout-fill \nclass=\"attendance-subheader\"><md-list layout=\"column\" layout-fill class=\"no-padding\"><md-list-item \nclass=\"container-item\"><div flex class=\"wrapper-item\" layout=\"row\" layout-fill layout-align=\"start center\"><div \nflex=\"5\" class=\"single-item\" layout=\"row\" layout-align=\"center\"><md-icon md-font-icon=\"icon-cog\"></md-icon></div><div \nflex class=\"single-item\" layout=\"row\" layout-align=\"start center\"><span flex=\"grow\" class=\"text-center\">DAY/DATE</span>\n</div><div flex class=\"multiple-item\" layout=\"column\" layout-fill layout-align=\"start center\"><div flex class=\"item\" \nlayout-align=\"center center\" layout=\"row\" layout-fill><span flex=\"grow\">SHIFT</span></div><div class=\"item\" \nlayout=\"row\"><div class=\"item-child\">IN</div><div class=\"item-child\">OUT</div></div></div><div flex \nclass=\"multiple-item\" layout=\"column\" layout-align=\"start center\"><div flex class=\"item\" layout-align=\"center center\" \nlayout=\"row\" layout-fill><span flex=\"grow\">ACTUAL</span></div><div class=\"item\" layout=\"row\"><div class=\"item-child\">\n<span>IN</span></div><div class=\"item-child\"><span>BREAK OUT</span></div><div class=\"item-child\"><span>BREAK IN</span>\n</div><div class=\"item-child\"><span>OUT</span></div></div></div><div flex class=\"single-item\" layout=\"row\" \nlayout-align=\"start center\"><span flex=\"grow\" class=\"text-center\">OT APPROVED</span></div><div flex \nclass=\"single-item\" layout=\"row\" layout-align=\"start center\"><span flex=\"grow\" class=\"text-center\">OT UNAPPROVED</span>\n</div><div flex class=\"single-item\" layout=\"row\" layout-align=\"start center\"><span flex=\"grow\" class=\"text-center\">\nFINGER STATUS</span></div><div flex class=\"single-item\" layout=\"row\" layout-align=\"start center\"><span flex=\"grow\" \nclass=\"text-center\">NOTE</span></div></div></md-list-item></md-list></md-subheader><div id=\"attendance-content\" \nlayout-fill ms-scroll class=\"mb-10\"><div layout=\"column\" style=\"min-height:200px\" class=\"slide-down\" layout-padding \nng-if=\"vm.isLoading\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n<div layout=\"row\" style=\"margin-top:20px\">Please wait ...</div></div><md-list layout=\"column\" \nclass=\"no-padding slide-down\" ng-if=\"!vm.isLoading\"><md-list-item class=\"container-item\" \nng-repeat=\"ls in vm.listAttendance track by $index\" layout=\"column\"><div flex \nclass=\"wrapper-item wrapper-item-content\" layout=\"row\" layout-fill \nng-class=\"{\'empholiday\':ls.isHoliday,\'emptruant\':ls.infoAbsence[0].code==\'Z301\',\'empinactive\':!ls.isAsEmployeeActive,\'empghkkerja\':ls.isGhkKerja,\'empsubsitusileave\':ls.infoAbsence[0].code==\'Z102\',\'empleave\':(ls.infoAbsence[0].full ==\'1\' && ls.infoAbsence[0].leaveStatus ==\'1\'),\'empinvalidshift\':ls.invalidSchedule}\" \nlayout-align=\"start stretch\"><div flex=\"5\" class=\"single-item\" style=\"width:20px !important\" layout=\"row\" \nlayout-align=\"center center\"><md-menu ng-if=\"ls.isAsEmployeeActive\"><md-icon ng-click=\"$mdOpenMenu()\" \nstyle=\"cursor:pointer\" md-font-icon=\"icon-dots-horizontal\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nClick for view action</md-tooltip></md-icon><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item \nng-if=\"!ls.isHoliday && ls.isWorking && !ls.isGhkKerja\"><md-button ng-click=\"vm.changeShift($event,ls)\" \naria-label=\"Refresh widget\" translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.CHANGE_SIFT\">Change Shift\n</md-button></md-menu-item><md-menu-item \nng-if=\"ls.isWorking && (ls.listFinger.in==\'empty\' || ls.listFinger.out==\'empty\') || (ls.requiredBreakFinger==true && (ls.listFinger.breakOut==\'empty\' || ls.listFinger.breakOut==\'empty\' || ls.fingerStatus==\'Missing Finger Break In / Break Out\')) || (ls.isHoliday && isOt)\">\n<md-button ng-click=\"vm.inputUpnormal($event,ls)\" aria-label=\"Flip widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.INPUT_ABNORMAL\">Input Abnormal</md-button>\n</md-menu-item><md-menu-item \nng-if=\"!ls.isHoliday && ls.isWorking && (ls.typeEmployee != \'parttime\' || !ls.isUnscheduled)\"><md-button \nng-click=\"vm.InputAbsence($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.ABSENCE_REQUEST\">Absence Request</md-button>\n</md-menu-item><md-menu-item \nng-if=\"ls.isWorking && (((!ls.requiredBreakFinger && ls.listFinger.in==\'empty\' && ls.listFinger.out==\'empty\') || (!ls.requiredBreakFinger && ls.listFinger.in!=\'empty\' && ls.listFinger.out!=\'empty\')) ||\n                                          ((ls.requiredBreakFinger && ls.listFinger.in==\'empty\' && ls.listFinger.out==\'empty\' && ls.listFinger.breakIn==\'empty\' && ls.listFinger.breakOut==\'empty\' )||\n                                          (ls.requiredBreakFinger && ls.listFinger.in!=\'empty\' && ls.listFinger.out!=\'empty\' && ls.listFinger.breakIn!=\'empty\' && ls.listFinger.breakOut!=\'empty\')))\n                                          || (ls.isHoliday && isOt)\">\n<md-button ng-click=\"vm.UpdateFingertime($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.UPDATE_FINGER_TIME\">Update Finger Time</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.fingerLog($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.FINGER_LOG\">Finger Log</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.infoTransaction($event,ls,vm.nik)\" aria-label=\"Refresh widget\">Info Transaction\n</md-button></md-menu-item></md-menu-content></md-menu></div><div flex class=\"single-item\" layout=\"row\" \nlayout-align=\"start center\"><span flex=\"grow\"><span>{{ls.day}}</span>/{{ls.date}}</span></div><div flex \nclass=\"multiple-item\" layout=\"column\"><div flex class=\"item\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"center center\" class=\"item-child\"><span>{{ls.shift.tampilStartDate}}<br><strong>\n{{ls.shift.tampilStartTime}}</strong></span></div><div layout=\"row\" layout-align=\"center center\" class=\"item-child\">\n<span>{{ls.shift.tampilEndDate}}<br><strong>{{ls.shift.tampilEndTime}}</strong></span></div></div></div><div flex \nclass=\"multiple-item\" layout=\"column\"><div flex class=\"item\" layout=\"row\" layout-align=\"center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"item-child\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.in==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.in!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateIn>0\">\n{{ls.listFingerDate.in}}<br><strong>{{ls.listFinger.in}}</strong><md-tooltip md-direction=\"top\">{{ls.lateIn}}\n</md-tooltip></span><span ng-if=\"ls.lateIn==0\">{{ls.listFingerDate.in}}<br><strong>{{ls.listFinger.in}}</strong></span>\n</span></div><div layout=\"row\" layout-align=\"center center\" class=\"item-child\"><span ng-if=\"ls.requiredBreakFinger\">\n<span class=\"red-500-fg\" ng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakOut==\'empty\') && ls.isWorking==true\">\nmissing</span> <span ng-if=\"ls.listFingerLength>0 && ls.listFinger.breakOut!=\'empty\'\"><span class=\"red-500-fg\" \nng-if=\"ls.lateBreakIn>0\">{{ls.listFingerDate.breakOut}}<br><strong>{{ls.listFinger.breakOut}}</strong><md-tooltip \nmd-direction=\"top\">{{ls.lateBreakIn}}</md-tooltip></span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFingerDate.breakOut}}\n<br><strong>{{ls.listFinger.breakOut}}</strong></span></span></span></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"item-child\"><span ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakIn==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakIn!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFingerDate.breakIn}}<br><strong>{{ls.listFinger.breakIn}}</strong><md-tooltip md-direction=\"top\">\n{{ls.lateBreakIn}}</md-tooltip></span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFingerDate.breakIn}}<br><strong>\n{{ls.listFinger.breakIn}}</strong></span></span></span></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"item-child\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.out==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.out!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.earlyOut>0\">\n{{ls.listFingerDate.out}}<br><strong>{{ls.listFinger.out}}</strong><md-tooltip md-direction=\"top\">{{ls.earlyOut}}\n</md-tooltip></span><span ng-if=\"ls.earlyOut==0\">{{ls.listFingerDate.out}}<br><strong>{{ls.listFinger.out}}</strong>\n</span></span></div></div></div><div flex class=\"single-item\" layout=\"row\" layout-align=\"start center\"><span \nng-if=\"ls.approvedOT>0\">{{ls.approvedOT}}</span> <span ng-if=\"ls.approvedOT==0\"></span></div><div flex \nclass=\"single-item\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"ls.unApprovedOT>0\">{{ls.unApprovedOT}}</span>\n <span ng-if=\"ls.unApprovedOT==0\"></span></div><div flex class=\"single-item\" layout=\"row\" layout-align=\"start center\">\n<span ng-repeat=\"statusFin in ls.fingerStatus\"><span class=\"red-500-fg\">{{statusFin}}</span></span></div><div flex \nclass=\"single-item\" layout=\"row\" layout-align=\"start center\"><span ng-repeat=\"abs in ls.infoAbsence\"><span \nclass=\"red-500-fg\" ng-if=\"abs.code==\'Z301\' || abs.code==\'0000\'\">{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}\n</span> </span><span ng-if=\"!(abs.code==\'Z301\' || abs.code==\'0000\')\">{{abs.name}} <span ng-if=\"abs.full==0\">\n:{{abs.total}}</span> </span></span><span ng-if=\"ls.isHoliday && ls.isOt && ls.splOTType==\'NORMAL\'\">| <a href=\"\" \nng-click=\"vm.OtInfo($event,ls)\"><span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">\nView overtime request</md-tooltip></span><span ng-if=\"!ls.isHoliday && ls.isWorking && ls.isOt && ls.splOTType==\'KHL\'\">\n| <a href=\"\" ng-click=\"vm.OtInfo($event,ls)\"><span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip \nmd-direction=\"top\">View overtime request</md-tooltip></span><span \nng-if=\"ls.isHoliday && !ls.isOt && ls.listFingerLength >0\">| <a href=\"\" ng-click=\"vm.OtInfo($event,ls)\"><span \nclass=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">View overtime request</md-tooltip></span>\n</div></div></md-list-item><md-list-item class=\"container-item\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\" ng-if=\"vm.listAttendance.length == 0\" layout-fill>Data Not Found</md-list-item></md-list></div></md-content>\n<md-content id=\"mobileView\" flex layout-fill hide-gt-sm flex class=\"white-bg\"><md-progress-linear ng-if=\"vm.isLoading\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-list flex><md-list-item class=\"container-mobile slide-down\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\" ng-if=\"vm.listAttendance.length == 0\" layout-fill>\nData Not Found</md-list-item><md-list-item class=\"container-mobile slide-down\" \nng-class=\"{\'empholiday\':ls.isHoliday,\'emptruant\':ls.infoAbsence[0].code==\'Z301\',\'empinactive\':!ls.isAsEmployeeActive,\'empghkkerja\':ls.isGhkKerja,\'empsubsitusileave\':ls.infoAbsence[0].code==\'Z102\',\'empleave\':(ls.infoAbsence[0].full ==\'1\' && ls.infoAbsence[0].leaveStatus ==\'1\'),\'empinvalidshift\':ls.invalidSchedule}\" \nng-repeat-start=\"ls in vm.listAttendance track by $index\" layout=\"row\" ng-click=\"null\" \nlayout-align=\"space-between center\"><div flex=\"90\" layout=\"row\" layout-align=\"start\"><div flex=\"100\" layout=\"column\">\n<div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" \nlayout-align=\"start center\">DAY/DATE</div><span class=\"divider\" style=\"padding-right:10px\">:</span><div flex \nlayout=\"row\" layout-align=\"start center\"><span>{{ls.day}}</span>/{{ls.date}}</div></div><div layout=\"row\" \nclass=\"item-mobile\" layout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" layout-align=\"start center\">SHIFT IN\n</div><span class=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" layout-align=\"start center\">\n<span>{{ls.shift.tampilStartDate}} <strong>{{ls.shift.tampilStartTime}}</strong></span></div></div><div layout=\"row\" \nclass=\"item-mobile\" layout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" layout-align=\"start center\">SHIFT OUT\n</div><span class=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" layout-align=\"start center\">\n<span>{{ls.shift.tampilEndDate}} <strong>{{ls.shift.tampilEndTime}}</strong></span></div></div><div layout=\"row\" \nclass=\"item-mobile\" layout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" layout-align=\"start center\">ACT IN\n</div><span class=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" layout-align=\"start center\"><span\n class=\"red-500-fg\" ng-if=\"(ls.listFingerLength>0 && ls.listFinger.in==\'empty\') && ls.isWorking==true\">missing</span> \n<span ng-if=\"ls.listFingerLength>0 && ls.listFinger.in!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateIn>0\">\n{{ls.listFingerDate.in}} <strong>{{ls.listFinger.in}}</strong><md-tooltip md-direction=\"top\">{{ls.lateIn}}</md-tooltip>\n</span><span ng-if=\"ls.lateIn==0\">{{ls.listFingerDate.in}} <strong>{{ls.listFinger.in}}</strong></span></span></div>\n</div><div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" \nlayout-align=\"start center\">ACT BREAK OUT</div><span class=\"divider\" style=\"padding-right:10px\">:</span><div flex \nlayout=\"row\" layout-align=\"start center\"><span ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakOut==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakOut!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFingerDate.breakOut}} <strong>{{ls.listFinger.breakOut}}</strong><md-tooltip md-direction=\"top\">\n{{ls.lateBreakIn}}</md-tooltip></span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFingerDate.breakOut}} <strong>\n{{ls.listFinger.breakOut}}</strong></span></span></span></div></div><div layout=\"row\" class=\"item-mobile\" \nlayout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" layout-align=\"start center\">ACT BREAK IN</div><span \nclass=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" layout-align=\"start center\"><span \nng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakIn==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakIn!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFingerDate.breakIn}} <strong>{{ls.listFinger.breakIn}}</strong><md-tooltip md-direction=\"top\">\n{{ls.lateBreakIn}}</md-tooltip></span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFingerDate.breakIn}} <strong>\n{{ls.listFinger.breakIn}}</strong></span></span></span></div></div><div layout=\"row\" class=\"item-mobile\" \nlayout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" layout-align=\"start center\">ACT OUT</div><span \nclass=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" layout-align=\"start center\"><span \nclass=\"red-500-fg\" ng-if=\"(ls.listFingerLength>0 && ls.listFinger.out==\'empty\') && ls.isWorking==true\">missing</span> \n<span ng-if=\"ls.listFingerLength>0 && ls.listFinger.out!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.earlyOut>0\">\n{{ls.listFingerDate.out}} <strong>{{ls.listFinger.out}}</strong><md-tooltip md-direction=\"top\">{{ls.earlyOut}}\n</md-tooltip></span><span ng-if=\"ls.earlyOut==0\">{{ls.listFingerDate.out}} <strong>{{ls.listFinger.out}}</strong>\n</span></span></div></div><div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><div flex=\"30\" \nlayout=\"row\" layout-align=\"start center\">OT APPROVED</div><span class=\"divider\" style=\"padding-right:10px\">:</span><div\n flex layout=\"row\" layout-align=\"start center\"><span ng-if=\"ls.approvedOT>0\">{{ls.approvedOT}}</span> <span \nng-if=\"ls.approvedOT==0\"></span></div></div><div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><div\n flex=\"30\" layout=\"row\" layout-align=\"start center\">OT UNAPPROVED</div><span class=\"divider\" \nstyle=\"padding-right:10px\">:</span><div flex layout=\"row\" layout-align=\"start center\"><span ng-if=\"ls.unApprovedOT>0\">\n{{ls.unApprovedOT}}</span> <span ng-if=\"ls.unApprovedOT==0\"></span></div></div><div layout=\"row\" class=\"item-mobile\" \nlayout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" layout-align=\"start center\">FINGER STATUS</div><span \nclass=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" layout-align=\"start center\"><span \nng-repeat=\"statusFin in ls.fingerStatus\"><span class=\"red-500-fg\">{{statusFin}}</span></span></div></div><div \nlayout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" \nlayout-align=\"start center\">NOTE</div><span class=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" \nlayout-align=\"start center\"><span ng-repeat=\"abs in ls.infoAbsence\"><span class=\"red-500-fg\" \nng-if=\"abs.code==\'Z301\' || abs.code==\'0000\'\">{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span> </span><span \nng-if=\"!(abs.code==\'Z301\' || abs.code==\'0000\')\">{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span> </span>\n</span><span ng-if=\"ls.isHoliday && ls.isOt && ls.splOTType==\'NORMAL\'\">| <a href=\"\" ng-click=\"vm.OtInfo($event,ls)\">\n<span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">View overtime request</md-tooltip>\n</span><span ng-if=\"!ls.isHoliday && ls.isWorking && ls.isOt && ls.splOTType==\'KHL\'\">| <a href=\"\" \nng-click=\"vm.OtInfo($event,ls)\"><span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">\nView overtime request</md-tooltip></span><span ng-if=\"ls.isHoliday && !ls.isOt && ls.listFingerLength >0\">| <a href=\"\" \nng-click=\"vm.OtInfo($event,ls)\"><span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">\nView overtime request</md-tooltip></span></div></div></div></div><div flex=\"10\" layout=\"row\" layout-align=\"center end\">\n<md-menu ng-if=\"ls.isAsEmployeeActive\"><md-button ng-click=\"$mdOpenMenu()\"><md-icon md-font-icon=\"icon-dots-vertical\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Click for view action</md-tooltip></md-icon></md-button>\n<md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item \nng-if=\"!ls.isHoliday && ls.isWorking && !ls.isGhkKerja\"><md-button ng-click=\"vm.changeShift($event,ls)\" \naria-label=\"Refresh widget\" translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.CHANGE_SIFT\">Change Shift\n</md-button></md-menu-item><md-menu-item \nng-if=\"ls.isWorking && (ls.listFinger.in==\'empty\' || ls.listFinger.out==\'empty\') || (ls.requiredBreakFinger==true && (ls.listFinger.breakOut==\'empty\' || ls.listFinger.breakOut==\'empty\' || ls.fingerStatus==\'Missing Finger Break In / Break Out\')) || (ls.isHoliday && isOt)\">\n<md-button ng-click=\"vm.inputUpnormal($event,ls)\" aria-label=\"Flip widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.INPUT_ABNORMAL\">Input Abnormal</md-button>\n</md-menu-item><md-menu-item \nng-if=\"!ls.isHoliday && ls.isWorking && (ls.typeEmployee != \'parttime\' || !ls.isUnscheduled)\"><md-button \nng-click=\"vm.InputAbsence($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.ABSENCE_REQUEST\">Absence Request</md-button>\n</md-menu-item><md-menu-item \nng-if=\"ls.isWorking && (((!ls.requiredBreakFinger && ls.listFinger.in==\'empty\' && ls.listFinger.out==\'empty\') || (!ls.requiredBreakFinger && ls.listFinger.in!=\'empty\' && ls.listFinger.out!=\'empty\')) ||\n                                          ((ls.requiredBreakFinger && ls.listFinger.in==\'empty\' && ls.listFinger.out==\'empty\' && ls.listFinger.breakIn==\'empty\' && ls.listFinger.breakOut==\'empty\' )||\n                                          (ls.requiredBreakFinger && ls.listFinger.in!=\'empty\' && ls.listFinger.out!=\'empty\' && ls.listFinger.breakIn!=\'empty\' && ls.listFinger.breakOut!=\'empty\'))) \n                                          || (ls.isHoliday && isOt)\">\n<md-button ng-click=\"vm.UpdateFingertime($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.UPDATE_FINGER_TIME\">Update Finger Time</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.fingerLog($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.FINGER_LOG\">Finger Log</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.infoTransaction($event,ls,vm.nik)\" aria-label=\"Refresh widget\">Info Transaction\n</md-button></md-menu-item></md-menu-content></md-menu></div></md-list-item><md-divider ng-repeat-end></md-divider>\n</md-list></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/attendance-employe/attendance-employe_new.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" style=\"height:100%; overflow: hidden\" layout-fill><div \nclass=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\">Employee Attendances\n</md-subheader><div class=\"white-bg\"><md-toolbar class=\"open-toolbar\"><div class=\"md-toolbar-tools table-tools\"><span \nflex hide show-gt-sm></span><md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" \nname=\"tahun\" required><md-option ng-repeat=\"val in vm.listtahun\" placeholder=\"Year\" value=\"{{val}}\">{{val}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\" \nrequired><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container></div></md-toolbar><div style=\"height:8px\"></div>\n<md-content id=\"attendance-container\" hide show-gt-sm layout=\"column\" flex class=\"white-bg\"><md-subheader flex \nlayout-fill class=\"attendance-subheader\"><md-list layout=\"column\" layout-fill class=\"no-padding\"><md-list-item \nclass=\"container-item\"><div flex class=\"wrapper-item\" layout=\"row\" layout-fill layout-align=\"start center\"><div \nflex=\"5\" class=\"single-item\" layout=\"row\" layout-align=\"center\"><md-icon md-font-icon=\"icon-cog\"></md-icon></div><div \nflex class=\"single-item\" layout=\"row\" layout-align=\"start center\"><span flex=\"grow\">DAY/DATE</span></div><div flex \nclass=\"multiple-item\" layout=\"column\" layout-fill layout-align=\"start center\"><div flex class=\"item\" \nlayout-align=\"center center\" layout=\"row\" layout-fill><span flex=\"grow\">SHIFT</span></div><div class=\"item\" \nlayout=\"row\"><div class=\"item-child\">IN</div><div class=\"item-child\">OUT</div></div></div><div flex \nclass=\"multiple-item\" layout=\"column\" layout-align=\"start center\"><div flex class=\"item\" layout-align=\"center center\" \nlayout=\"row\" layout-fill><span flex=\"grow\">ACTUAL</span></div><div class=\"item\" layout=\"row\"><div class=\"item-child\">\n<span>IN</span></div><div class=\"item-child\"><span>BREAK IN</span></div><div class=\"item-child\"><span>BREAK OUT</span>\n</div><div class=\"item-child\"><span>OUT</span></div></div></div><div flex class=\"single-item\" layout=\"row\" \nlayout-align=\"start center\"><span>OT APPROVED</span></div><div flex class=\"single-item\" layout=\"row\" \nlayout-align=\"start center\"><span>OT UNAPPROVED</span></div><div flex class=\"single-item\" layout=\"row\" \nlayout-align=\"start center\"><span>FINGER STATUS</span></div><div flex class=\"single-item\" layout=\"row\" \nlayout-align=\"start center\"><span>NOTE</span></div></div></md-list-item></md-list></md-subheader><div \nstyle=\"max-height:520px\" id=\"attendance-content\" layout-fill ms-scroll><md-list layout=\"column\" class=\"no-padding\">\n<md-list-item class=\"container-item slide-down\" ng-repeat=\"ls in vm.listAttendance track by $index\"><div flex \nclass=\"wrapper-item wrapper-item-content\" layout=\"row\" layout-fill \nng-class=\"{\'empholiday\':ls.isHoliday,\'emptruant\':ls.infoAbsence[0].code==\'Z301\',\'empinactive\':!ls.isAsEmployeeActive,\'empghkkerja\':ls.isGhkKerja,\'empsubsitusileave\':ls.infoAbsence[0].code==\'Z102\',\'empleave\':(ls.infoAbsence[0].full ==\'1\' && ls.infoAbsence[0].leaveStatus ==\'1\'),\'empinvalidshift\':ls.invalidSchedule}\" \nlayout-align=\"start center\"><div flex=\"5\" class=\"single-item\" style=\"width:20px !important\" layout=\"row\" \nlayout-align=\"center center\"><md-menu ng-if=\"ls.isAsEmployeeActive\"><md-icon ng-click=\"$mdOpenMenu()\" \nstyle=\"cursor:pointer;color:#818181\" md-font-icon=\"icon-dots-vertical\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Click for view action</md-tooltip></md-icon><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-if=\"!ls.isHoliday && ls.isWorking && !ls.isGhkKerja\"><md-button \nng-click=\"vm.changeShift($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.CHANGE_SIFT\">Change Shift</md-button></md-menu-item>\n<md-menu-item \nng-if=\"ls.isWorking && (ls.listFinger.in==\'empty\' || ls.listFinger.out==\'empty\') || (ls.requiredBreakFinger==true && (ls.listFinger.breakOut==\'empty\' || ls.listFinger.breakOut==\'empty\' || ls.fingerStatus==\'Missing Finger Break In / Break Out\')) || (ls.isHoliday && isOt)\">\n<md-button ng-click=\"vm.inputUpnormal($event,ls)\" aria-label=\"Flip widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.INPUT_ABNORMAL\">Input Abnormal</md-button>\n</md-menu-item><md-menu-item ng-if=\"(!ls.isHoliday && ls.isWorking)\"><md-button ng-click=\"vm.InputAbsence($event,ls)\" \naria-label=\"Refresh widget\" translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.ABSENCE_REQUEST\">\nAbsence Request</md-button></md-menu-item><md-menu-item \nng-if=\"ls.isWorking && (((!ls.requiredBreakFinger && ls.listFinger.in==\'empty\' && ls.listFinger.out==\'empty\') || (!ls.requiredBreakFinger && ls.listFinger.in!=\'empty\' && ls.listFinger.out!=\'empty\')) ||\n                                          ((ls.requiredBreakFinger && ls.listFinger.in==\'empty\' && ls.listFinger.out==\'empty\' && ls.listFinger.breakIn==\'empty\' && ls.listFinger.breakOut==\'empty\' )||\n                                          (ls.requiredBreakFinger && ls.listFinger.in!=\'empty\' && ls.listFinger.out!=\'empty\' && ls.listFinger.breakIn!=\'empty\' && ls.listFinger.breakOut!=\'empty\')))\n                                          || (ls.isHoliday && isOt)\">\n<md-button ng-click=\"vm.UpdateFingertime($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.UPDATE_FINGER_TIME\">Update Finger Time</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.fingerLog($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.FINGER_LOG\">Finger Log</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.infoTransaction($event,ls,vm.nik)\" aria-label=\"Refresh widget\">Info Transaction\n</md-button></md-menu-item></md-menu-content></md-menu></div><div flex class=\"single-item\" layout=\"row\" \nlayout-align=\"start center\"><span flex=\"grow\"><span>{{ls.day}}</span>/{{ls.date}}</span></div><div flex \nclass=\"multiple-item\" layout=\"column\"><div flex class=\"item\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"center center\" class=\"item-child\"><span>{{ls.shift.tampilStart}}</span></div><div \nlayout=\"row\" layout-align=\"center center\" class=\"item-child\"><span>{{ls.shift.tampilEnd}}</span></div></div></div><div \nflex class=\"multiple-item\" layout=\"column\"><div flex class=\"item\" layout=\"row\" layout-align=\"center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"item-child\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.in==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.in!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateIn>0\">\n{{ls.listFinger.in}}<md-tooltip md-direction=\"top\">{{ls.lateIn}}</md-tooltip></span><span ng-if=\"ls.lateIn==0\">\n{{ls.listFinger.in}}</span></span></div><div layout=\"row\" layout-align=\"center center\" class=\"item-child\"><span \nng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakOut==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakOut!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFinger.breakOut}}<md-tooltip md-direction=\"top\">{{ls.lateBreakIn}}</md-tooltip></span><span \nng-if=\"ls.lateBreakIn==0\">{{ls.listFinger.breakOut}}</span></span></span></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"item-child\"><span ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakIn==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakIn!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFinger.breakIn}}<md-tooltip md-direction=\"top\">{{ls.lateBreakIn}}</md-tooltip></span><span \nng-if=\"ls.lateBreakIn==0\">{{ls.listFinger.breakIn}}</span></span></span></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"item-child\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.out==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.out!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.earlyOut>0\">\n{{ls.listFinger.out}}<md-tooltip md-direction=\"top\">{{ls.earlyOut}}</md-tooltip></span><span ng-if=\"ls.earlyOut==0\">\n{{ls.listFinger.out}}</span></span></div></div></div><div flex class=\"single-item\" layout=\"row\" \nlayout-align=\"start center\"><span ng-if=\"ls.approvedOT>0\">{{ls.approvedOT}}</span> <span ng-if=\"ls.approvedOT==0\">\n</span></div><div flex class=\"single-item\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"ls.unApprovedOT>0\">\n{{ls.unApprovedOT}}</span> <span ng-if=\"ls.unApprovedOT==0\"></span></div><div flex class=\"single-item\" layout=\"row\" \nlayout-align=\"start center\"><span ng-repeat=\"statusFin in ls.fingerStatus\"><span class=\"red-500-fg\">{{statusFin}}\n</span></span></div><div flex class=\"single-item\" layout=\"row\" layout-align=\"start center\"><span \nng-repeat=\"abs in ls.infoAbsence\"><span class=\"red-500-fg\" ng-if=\"abs.code==\'Z301\' || abs.code==\'0000\'\">{{abs.name}} \n<span ng-if=\"abs.full==0\">:{{abs.total}}</span> </span><span ng-if=\"!(abs.code==\'Z301\' || abs.code==\'0000\')\">\n{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span> </span></span><span \nng-if=\"ls.isHoliday && ls.isOt && ls.splOTType==\'NORMAL\'\">| <a href=\"\" ng-click=\"vm.OtInfo($event,ls)\"><span \nclass=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">View overtime request</md-tooltip></span>\n<span ng-if=\"!ls.isHoliday && ls.isWorking && ls.isOt && ls.splOTType==\'KHL\'\">| <a href=\"\" \nng-click=\"vm.OtInfo($event,ls)\"><span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">\nView overtime request</md-tooltip></span><span ng-if=\"ls.isHoliday && !ls.isOt && ls.listFingerLength >0\">| <a href=\"\" \nng-click=\"vm.OtInfo($event,ls)\"><span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">\nView overtime request</md-tooltip></span></div></div></md-list-item></md-list></div></md-content><md-content \nid=\"mobileView\" flex layout-fill hide-gt-sm flex class=\"white-bg\"><md-list flex><md-list-item class=\"container-mobile\" \nng-class=\"{\'empholiday\':ls.isHoliday,\'emptruant\':ls.infoAbsence[0].code==\'Z301\',\'empinactive\':!ls.isAsEmployeeActive,\'empghkkerja\':ls.isGhkKerja,\'empsubsitusileave\':ls.infoAbsence[0].code==\'Z102\',\'empleave\':(ls.infoAbsence[0].full ==\'1\' && ls.infoAbsence[0].leaveStatus ==\'1\'),\'empinvalidshift\':ls.invalidSchedule}\" \nng-repeat-start=\"ls in vm.listAttendance track by $index\" layout=\"row\" ng-click=\"null\" \nlayout-align=\"space-between center\"><div flex=\"90\" layout=\"row\" layout-align=\"start\"><div flex=\"40\" layout=\"column\" \nclass=\"item-header\"><div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><span>DAY/DATE</span><span \nclass=\"divider\">:</span></div><div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><span>SHIFT IN\n</span><span class=\"divider\">:</span></div><div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\">\n<span>SHIFT OUT</span><span class=\"divider\">:</span></div><div layout=\"row\" class=\"item-mobile\" \nlayout-align=\"space-between end\"><span>ACT IN</span><span class=\"divider\">:</span></div><div layout=\"row\" \nclass=\"item-mobile\" layout-align=\"space-between end\"><span>ACT BREAK OUT</span><span class=\"divider\">:</span></div><div\n layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><span>ACT BREAK IN</span><span class=\"divider\">:\n</span></div><div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><span>ACT OUT</span><span \nclass=\"divider\">:</span></div><div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><span>OT APPROVED\n</span><span class=\"divider\">:</span></div><div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\">\n<span>OT UNAPPROVED</span><span class=\"divider\">:</span></div><div layout=\"row\" class=\"item-mobile\" \nlayout-align=\"space-between end\"><span>FINGER STATUS</span><span class=\"divider\">:</span></div><div layout=\"row\" \nclass=\"item-mobile\" layout-align=\"space-between end\"><span>NOTE</span><span class=\"divider\">:</span></div></div><div \nflex layout=\"column\"><div layout=\"row\" class=\"item-mobile\"><span>{{ls.day}}</span>/{{ls.date}}</div><div layout=\"row\" \nclass=\"item-mobile\"><span>{{ls.shift.tampilStart}}</span></div><div layout=\"row\" class=\"item-mobile\"><span>\n{{ls.shift.tampilEnd}}</span></div><div layout=\"row\" class=\"item-mobile\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.in==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.in!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateIn>0\">\n{{ls.listFinger.in}}<md-tooltip md-direction=\"top\">{{ls.lateIn}}</md-tooltip></span><span ng-if=\"ls.lateIn==0\">\n{{ls.listFinger.in}}</span></span></div><div layout=\"row\" class=\"item-mobile\"><span ng-if=\"ls.requiredBreakFinger\">\n<span class=\"red-500-fg\" ng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakOut==\'empty\') && ls.isWorking==true\">\nmissing</span> <span ng-if=\"ls.listFingerLength>0 && ls.listFinger.breakOut!=\'empty\'\"><span class=\"red-500-fg\" \nng-if=\"ls.lateBreakIn>0\">{{ls.listFinger.breakOut}}<md-tooltip md-direction=\"top\">{{ls.lateBreakIn}}</md-tooltip>\n</span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFinger.breakOut}}</span></span></span></div><div layout=\"row\" \nclass=\"item-mobile\"><span ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakIn==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakIn!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFinger.breakIn}}<md-tooltip md-direction=\"top\">{{ls.lateBreakIn}}</md-tooltip></span><span \nng-if=\"ls.lateBreakIn==0\">{{ls.listFinger.breakIn}}</span></span></span></div><div layout=\"row\" class=\"item-mobile\">\n<span class=\"red-500-fg\" ng-if=\"(ls.listFingerLength>0 && ls.listFinger.out==\'empty\') && ls.isWorking==true\">missing\n</span> <span ng-if=\"ls.listFingerLength>0 && ls.listFinger.out!=\'empty\'\"><span class=\"red-500-fg\" \nng-if=\"ls.earlyOut>0\">{{ls.listFinger.out}}<md-tooltip md-direction=\"top\">{{ls.earlyOut}}</md-tooltip></span><span \nng-if=\"ls.earlyOut==0\">{{ls.listFinger.out}}</span></span></div><div layout=\"row\" class=\"item-mobile\"><span \nng-if=\"ls.approvedOT>0\">{{ls.approvedOT}}</span> <span ng-if=\"ls.approvedOT==0\"></span></div><div layout=\"row\" \nclass=\"item-mobile\"><span ng-if=\"ls.unApprovedOT>0\">{{ls.unApprovedOT}}</span> <span ng-if=\"ls.unApprovedOT==0\"></span>\n</div><div layout=\"row\" class=\"item-mobile\"><span ng-repeat=\"statusFin in ls.fingerStatus\"><span class=\"red-500-fg\">\n{{statusFin}}</span></span></div><div layout=\"row\" class=\"item-mobile\"><span ng-repeat=\"abs in ls.infoAbsence\"><span \nclass=\"red-500-fg\" ng-if=\"abs.code==\'Z301\' || abs.code==\'0000\'\">{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}\n</span> </span><span ng-if=\"!(abs.code==\'Z301\' || abs.code==\'0000\')\">{{abs.name}} <span ng-if=\"abs.full==0\">\n:{{abs.total}}</span> </span></span><span ng-if=\"ls.isHoliday && ls.isOt && ls.splOTType==\'NORMAL\'\">| <a href=\"\" \nng-click=\"vm.OtInfo($event,ls)\"><span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">\nView overtime request</md-tooltip></span><span ng-if=\"!ls.isHoliday && ls.isWorking && ls.isOt && ls.splOTType==\'KHL\'\">\n| <a href=\"\" ng-click=\"vm.OtInfo($event,ls)\"><span class=\"red-500-fg\">Wrong OT type</span></a><md-tooltip \nmd-direction=\"top\">View overtime request</md-tooltip></span><span \nng-if=\"ls.isHoliday && !ls.isOt && ls.listFingerLength >0\">| <a href=\"\" ng-click=\"vm.OtInfo($event,ls)\"><span \nclass=\"red-500-fg\">Wrong OT type</span></a><md-tooltip md-direction=\"top\">View overtime request</md-tooltip></span>\n</div></div></div><div flex=\"10\" layout=\"row\" layout-align=\"center end\"><md-menu ng-if=\"ls.isAsEmployeeActive\">\n<md-button ng-click=\"$mdOpenMenu()\"><md-icon md-font-icon=\"icon-dots-vertical\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Click for view action</md-tooltip></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-if=\"!ls.isHoliday && ls.isWorking && !ls.isGhkKerja\"><md-button \nng-click=\"vm.changeShift($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.CHANGE_SIFT\">Change Shift</md-button></md-menu-item>\n<md-menu-item \nng-if=\"ls.isWorking && (ls.listFinger.in==\'empty\' || ls.listFinger.out==\'empty\') || (ls.requiredBreakFinger==true && (ls.listFinger.breakOut==\'empty\' || ls.listFinger.breakOut==\'empty\' || ls.fingerStatus==\'Missing Finger Break In / Break Out\')) || (ls.isHoliday && isOt)\">\n<md-button ng-click=\"vm.inputUpnormal($event,ls)\" aria-label=\"Flip widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.INPUT_ABNORMAL\">Input Abnormal</md-button>\n</md-menu-item><md-menu-item ng-if=\"(!ls.isHoliday && ls.isWorking)\"><md-button ng-click=\"vm.InputAbsence($event,ls)\" \naria-label=\"Refresh widget\" translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.ABSENCE_REQUEST\">\nAbsence Request</md-button></md-menu-item><md-menu-item \nng-if=\"ls.isWorking && (((!ls.requiredBreakFinger && ls.listFinger.in==\'empty\' && ls.listFinger.out==\'empty\') || (!ls.requiredBreakFinger && ls.listFinger.in!=\'empty\' && ls.listFinger.out!=\'empty\')) ||\n                                          ((ls.requiredBreakFinger && ls.listFinger.in==\'empty\' && ls.listFinger.out==\'empty\' && ls.listFinger.breakIn==\'empty\' && ls.listFinger.breakOut==\'empty\' )||\n                                          (ls.requiredBreakFinger && ls.listFinger.in!=\'empty\' && ls.listFinger.out!=\'empty\' && ls.listFinger.breakIn!=\'empty\' && ls.listFinger.breakOut!=\'empty\')))\n                                          || (ls.isHoliday && isOt)\">\n<md-button ng-click=\"vm.UpdateFingertime($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.UPDATE_FINGER_TIME\">Update Finger Time</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.fingerLog($event,ls)\" aria-label=\"Refresh widget\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.ACTION.FINGER_LOG\">Finger Log</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.infoTransaction($event,ls,vm.nik)\" aria-label=\"Refresh widget\">Info Transaction\n</md-button></md-menu-item></md-menu-content></md-menu></div></md-list-item><md-divider ng-repeat-end></md-divider>\n</md-list></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/attendance-employe/finger-log.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.FINGERLOG.TITLE\">Finger Log</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nclass=\"alert-info warning italic md-body-1\"><div layout-gt-sm=\"row\"><span>Working Date</span> : <span>\n{{vm.Form.objForm.tanggal}}</span><div class=\"divider-vertical\"></div><span>Shift Time</span> : <span>\n{{vm.Form.objForm.shift.tampilStart}}-{{vm.Form.objForm.shift.tampilEnd}}</span></div><div layout-gt-sm=\"row\"><span>\nRange Finger:</span></div><div layout-gt-sm=\"row\"><span class=\"red-500-fg\">In : {{vm.startRange}} to {{vm.endShift}}\n</span></div><div layout-gt-sm=\"row\" ng-if=\"vm.Form.objForm.requiredBreakFinger\"><span class=\"red-500-fg\">\nBreak Out : {{vm.startShift}} to {{vm.endShift}}</span></div><div layout-gt-sm=\"row\" \nng-if=\"vm.Form.objForm.requiredBreakFinger\"><span class=\"red-500-fg\">Break In : {{vm.startShift}} to {{vm.endShift}}\n</span></div><div layout-gt-sm=\"row\"><span class=\"red-500-fg\">Out : {{vm.startShift}} to {{vm.endRange}}</span></div>\n</div><div layout-gt-sm=\"row\"><table class=\"simple with-toolbar bordered stripped\" id=\"inputTable\" ms-responsive-table \nstyle=\"width: 100%\"><thead><tr><th translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.FINGERLOG.TABLE.HEADER.FINGER_TIME\">\nFinger Time</th><th translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.FINGERLOG.TABLE.HEADER.TYPE\">Type</th><th \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.FINGERLOG.TABLE.HEADER.MESIN_NO\">Mesin No</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.logfinger\"><td>{{ls.transaction_time}}</td><td>{{ls.typename}}</td><td>{{ls.mesin_no}}</td></tr>\n</tbody></table></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/attendance-employe/input-abnormal.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Abnormal</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\"><div layout=\"column\"><div class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>Working Date</span> : <span>{{vm.Form.objForm.tanggal}}</span><div class=\"divider-vertical\">\n</div><span>Shift Time</span> : <span>{{vm.Form.objForm.shift.tampilStart}}-{{vm.Form.objForm.shift.tampilEnd}}</span>\n</div><div layout-gt-sm=\"row\"><span>Input time pada range berikut :</span></div><div layout-gt-sm=\"row\"><span \nclass=\"red-500-fg\">In : {{vm.startRange}} to {{vm.endShift}}</span></div><div layout-gt-sm=\"row\" \nng-if=\"vm.Form.objForm.requiredBreakFinger\"><span class=\"red-500-fg\">Break Out : {{vm.startShift}} to {{vm.endShift}}\n</span></div><div layout-gt-sm=\"row\" ng-if=\"vm.Form.objForm.requiredBreakFinger\"><span class=\"red-500-fg\">\nBreak In : {{vm.startShift}} to {{vm.endShift}}</span></div><div layout-gt-sm=\"row\"><span class=\"red-500-fg\">\nOut : {{vm.startShift}} to {{vm.endRange}}</span></div></div><br><div class=\"form-title\" style=\"margin-bottom: 10px\">\nActual Data</div><div layout-gt-sm=\"row\" class=\"mt-10\"><md-input-container flex><label>Time In</label><input \ntype=\"text\" ng-max=\"24\" name=\"atimein\" ng-model=\"vm.in\" mask=\"99:99\" ng-disabled=\"true\" mask-placeholder=\"_\"><div \nng-messages=\"upnormalForm.atimein.$error\" role=\"alert\"><div ng-message=\"required\"><span>Time In is required.</span>\n</div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container><md-input-container flex><label>Break Out</label><input type=\"text\" ng-max=\"24\" \nname=\"abreakout\" ng-model=\"vm.breakOut\" mask=\"99:99\" mask-placeholder=\"_\" ng-disabled=\"true\"><div \nng-messages=\"upnormalForm.abreakout.$error \" role=\"alert\"><div ng-message=\"required\"><span>Time In is required.</span>\n</div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container><md-input-container flex><label>Break In</label><input type=\"text\" ng-max=\"24\" \nname=\"abreakin\" ng-model=\"vm.breakIn\" mask=\"99:99\" ng-disabled=\"true\" mask-placeholder=\"_\"><div \nng-messages=\"upnormalForm.abreakin.$error\" role=\"alert\"><div ng-message=\"required\"><span>Time In is required.</span>\n</div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container><md-input-container flex><label>Time Out</label><input type=\"text\" ng-max=\"24\" \nname=\"atimeout\" ng-model=\"vm.out\" mask=\"99:99\" ng-disabled=\"true\" mask-placeholder=\"_\"><div \nng-messages=\"upnormalForm.atimeout.$error\" role=\"alert\"><div ng-message=\"required\"><span>Time Out is required.</span>\n</div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container></div><div class=\"form-title\" style=\"margin-bottom: 10px\">Update Data</div><div \nlayout-gt-sm=\"row\" class=\"mt-10\"><md-input-container flex><label>Time In</label><input type=\"text\" ng-max=\"24\" \nname=\"timein\" ng-model=\"vm.Form.objForm.timein\" mask=\"99:99\" mask-placeholder=\"_\" required><div \nng-messages=\"upnormalForm.timein.$error\" role=\"alert\"><div ng-message=\"required\"><span>Time In is required.</span>\n</div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container><md-input-container flex><label>Break Out</label><input type=\"text\" ng-max=\"24\" \nname=\"breakout\" ng-model=\"vm.Form.objForm.breakout\" mask=\"99:99\" mask-placeholder=\"_\" \nng-required=\"vm.requiredBreakFinger\"><div ng-messages=\"upnormalForm.breakout.$error \" role=\"alert\"><div \nng-message=\"required\"><span>Time In is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex><label>\nBreak In</label><input type=\"text\" ng-max=\"24\" name=\"breakin\" ng-model=\"vm.Form.objForm.breakin\" mask=\"99:99\" \nmask-placeholder=\"_\" ng-required=\"vm.requiredBreakFinger\"><div ng-messages=\"upnormalForm.breakin.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Time In is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex><label>\nTime Out</label><input type=\"text\" ng-max=\"24\" name=\"timeout\" ng-model=\"vm.Form.objForm.timeout\" mask=\"99:99\" \nmask-placeholder=\"_\" required><div ng-messages=\"upnormalForm.timeout.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Time Out is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\">\n<span>Max Length 2.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"upnormalForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>description is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox ng-model=\"data.check\" \naria-label=\"Checkbox 2\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"md-warn md-align-top-left\" flex><span \nclass=\"ipsum\">Sebelum menyimpan data abnormal, periksa kembali shift, clock-in dan clock-out time apakah sudah benar?\n</span></md-checkbox></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front>\n</ms-widget><span flex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(upnormalForm.$invalid || upnormalForm.$pristine) || !data.check || vm.saveProcess\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/attendance-employe/input-absence.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.ABSENCE_REQUEST.TITLE\">Form Input Absence</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout=\"column\"><md-input-container flex ng-if=\"!vm.halfday\"><md-select ng-disabled=\"vm.isdisabled\" \nng-model=\"vm.Form.objForm.abs_code\" ng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.abs_code)\" name=\"abs_code\" \nrequired><md-option ng-repeat=\"ls in vm.listAbsenceType\" placeholder=\"Absence Type\" value=\"{{ls.abs_code}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"formAbsence.abs_code.$error\" role=\"alert\"><div \nng-message=\"required\"><span>abs_code field is required.</span></div></div></md-input-container><div \nclass=\"alert-info warning italic md-body-1\" ng-if=\"vm.leavBalance>0\"><div layout-gt-sm=\"row\"><p class=\"form-messages\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.ABSENCE_REQUEST.NOTIF_CUTI_1\">\nSaldo cuti tahunan (annual leave) anda masih tersedia sejumlah </span>{{vm.leavBalance}} <span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.ABSENCE_REQUEST.NOTIF_CUTI_2\">hari, apakah anda akan menggunakan saldo cuti ?\n</span></p></div><md-input-container flex><md-radio-group><md-radio-button value=\"annualleave\" name=\"daytype\" \nng-click=\"vm.viewLeaveBalance()\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.ABSENCE_REQUEST.GUNAKAN_SALDO_CUTI\">Gunakan saldo cuti</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"personalleave\" name=\"daytype\" ng-click=\"vm.personalleaveonly()\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.ABSENCE_REQUEST.TIDAK_GUNAKAN_SALDO_CUTI\">\nTidak gunakan saldo cuti</span></md-radio-button></md-radio-group></md-input-container></div><div ng-if=\"vm.halfday\">\n<md-input-container flex><md-radio-group layout=\"column\" ng-model=\"vm.Form.objForm.timetype\" \nng-change=\"vm.ChangeTime()\" ng-required=\"true\" name=\"timetype\"><md-radio-button ng-if=\"vm.latein > 0\" value=\"latein\" \nng-disabled=\"vm.isdisabled\" class=\"md-warn md-raised\">{{vm.latestart}} - {{vm.lateend}}</md-radio-button>&nbsp;&nbsp;\n<md-radio-button ng-if=\"vm.earlyOut > 0\" value=\"earlyout\" ng-disabled=\"vm.isdisabled\" class=\"md-warn md-raised\">\n{{vm.earlystart}} - {{vm.earlyend}}</md-radio-button></md-radio-group><div ng-messages=\"formAbsence.timetype.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tyme Type Type is required.</span></div></div></md-input-container></div>\n<md-input-container flex><input type=\"text\" name=\"description\" ng-disabled=\"vm.isdisabled\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"formAbsence.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>description is required.\n</span></div></div></md-input-container><md-input-container \nng-if=\"vm.requestdocument==\'1\' && !vm.stateEdit && !vm.request\" md-no-float class=\"md-block\"><input type=\"file\" \nid=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'upload\',absence_id:vm.absence_id,abs_code:vm.Form.objForm.abs_code,daytype:vm.Form.objForm.daytype,start_date:vm.Form.objForm.start_date,end_date:vm.Form.objForm.end_date,start_time:vm.Form.objForm.start_time, end_time:vm.Form.objForm.end_time,description:vm.Form.objForm.description}] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n<div layout=\"column\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"{{vm.messageTheme}}-400-fg\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>\n{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><span flex></span><md-button \nng-if=\"vm.requestdocument==\'0\' && !vm.stateEdit && !vm.request\" type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"formAbsence.$invalid || formAbsence.$pristine\">Save</md-button><md-button \nng-if=\"vm.requestdocument==\'1\' && !vm.stateEdit && !vm.request\" type=\"button\" ng-click=\"vm.upload()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"formAbsence.$invalid || formAbsence.$pristine\n      \"><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.ABSENCE_REQUEST.SAVE\">Save/Upload</span></md-button><md-button \nng-if=\"vm.requestdocument==\'0\' && vm.stateEdit\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formAbsence.$invalid || formAbsence.$pristine\">Update</md-button><md-button \nng-if=\"vm.requestdocument==\'1\' && vm.stateEdit\" type=\"button\" ng-click=\"vm.upload()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"formAbsence.$invalid || formAbsence.$pristine\"><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.ABSENCE_REQUEST.UPDATE\">Update/Upload</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/cb/attendance-employe/input-changeshift.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar \nclass=\"has-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Form Request Change Shift</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nclass=\"alert-info warning italic md-body-1 csm-arlert-info\"><div layout-gt-sm=\"row\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.CHANGE_SHIFT.WORKING_DATE\">Working Date</span> : <span>\n{{vm.Form.objForm.tanggal}}</span><div class=\"divider-vertical hide show-gt-sm\"></div><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.CHANGE_SHIFT.SHIFT_TIME\">Shift Time</span>: <span>\n{{vm.Form.objForm.currentshift.tampilStart}}-{{vm.Form.objForm.currentshift.tampilEnd}}</span></div></div><div \nlayout-gt-sm=\"column\"><md-input-container ng-if=\"vm.company==\'RK\'\" flex><md-radio-group layout=\"row\" \nng-model=\"vm.Form.objForm.shifttype\" ng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\">\n<md-radio-button value=\"group\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.CHANGE_SHIFT.GROUP\">Group</span></md-radio-button>&nbsp;&nbsp;<md-radio-button\n value=\"nongroup\" ng-disabled=\"vm.company==\'KS\'\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.CHANGE_SHIFT.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group>\n<div ng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nshifttype Type is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.Form.objForm.shifttype==\'nongroup\'\"><md-input-container flex><label \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.START_TIME\">Start Time</label><input type=\"text\" ng-max=\"24\" \nname=\"start_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" \nautocomplete=\"off\" required><div ng-messages=\"upnormalForm.start_time.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" \nng-model=\"vm.Form.objForm.end_time\" mask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" \nrequired><div ng-messages=\"upnormalForm.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container flex \nng-if=\"vm.Form.objForm.shifttype==\'group\'\"><md-radio-group ng-model=\"vm.Form.objForm.start_template\" \nng-change=\"vm.getChangeshiftExist()\" ng-required=\"true\"><div class=\"row\"><div flex layout=\"column\"><md-radio-button \nng-repeat=\"ls in vm.listLocation\" flex ng-value=\"ls.dws_code\" class=\"md-primary\" name=\"start_template\">\n{{ls.shift_time}}</md-radio-button></div></div></md-radio-group><div ng-messages=\"ShiftForm.start_template.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Template is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button class=\"md-raised md-accent\" ng-disabled=\"(upnormalForm.$invalid || upnormalForm.$pristine) || vm.request\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.CHANGE_SHIFT.SAVE\" type=\"submit\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/attendance-employe/ot-info.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.OT_INFO.TITLE\">Overtime Info</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\"><table class=\"simple\"><thead><tr><th translate=\"TABLE.DATE\">Date</th><th translate=\"TABLE.OT_TYPE\">\nOT Type</th><th translate=\"TABLE.START_TIME\">Start Time</th><th translate=\"TABLE.END_TIME\">End Time</th></tr></thead>\n<tbody><tr ng-if=\"vm.data.splOTstart ==\'\' && vm.data.splOTEnd ==\'\'\"><td colspan=\"4\" class=\"text-center\"><span><i>\nNo overtime request</i></span></td></tr><tr ng-if=\"vm.data.splOTstart !==\'\' && vm.data.splOTEnd !==\'\'\"><td>\n{{vm.data.date}}</td><td>{{vm.data.splOTType}}</td><td>{{vm.data.splOTstart}}</td><td>{{vm.data.splOTEnd}}</td></tr>\n</tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/attendance-employe/update-finger.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.TITLE\">Form Update Finger Time</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nclass=\"alert-info warning italic md-body-1\"><div layout-gt-sm=\"row\"><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.WORKING_DATE\">Working Date</span> : <span>\n{{vm.Form.objForm.tanggal}}</span><div class=\"divider-vertical\"></div><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.SHIFT_TIME\">Shift Time</span> : <span>\n{{vm.Form.objForm.shift.tampilStart}}-{{vm.Form.objForm.shift.tampilEnd}}</span></div><div layout-gt-sm=\"row\"><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.NOTIF_INPUT\">Input time pada range berikut :</span></div>\n<div layout-gt-sm=\"row\"><span class=\"red-500-fg\">In : {{vm.startRange}} to {{vm.endShift}}</span></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.Form.objForm.requiredBreakFinger\"><span class=\"red-500-fg\">\nBreak Out : {{vm.startShift}} to {{vm.endShift}}</span></div><div layout-gt-sm=\"row\" \nng-if=\"vm.Form.objForm.requiredBreakFinger\"><span class=\"red-500-fg\">Break In : {{vm.startShift}} to {{vm.endShift}}\n</span></div><div layout-gt-sm=\"row\"><span class=\"red-500-fg\">Out : {{vm.startShift}} to {{vm.endRange}}</span></div>\n</div><br><div class=\"form-title\" translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.ACTUAL_DATA\">Actual Data\n</div><div layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.TIME_IN\">Time In</label><input type=\"text\" ng-max=\"24\" \nname=\"atimein\" ng-model=\"vm.in\" mask=\"99:99\" ng-disabled=\"true\" mask-placeholder=\"_\"><div \nng-messages=\"upnormalForm.atimein.$error\" role=\"alert\"><div ng-message=\"required\"><span>Time In is required.</span>\n</div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.BREAK_OUT\">Break Out</label><input type=\"text\" ng-max=\"24\" \nname=\"abreakout\" ng-model=\"vm.breakOut\" mask=\"99:99\" mask-placeholder=\"_\" ng-disabled=\"true\"><div \nng-messages=\"upnormalForm.abreakout.$error \" role=\"alert\"><div ng-message=\"required\"><span>Time In is required.</span>\n</div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.BREAK_IN\">Break In</label><input type=\"text\" ng-max=\"24\" \nname=\"abreakin\" ng-model=\"vm.breakIn\" mask=\"99:99\" ng-disabled=\"true\" mask-placeholder=\"_\"><div \nng-messages=\"upnormalForm.abreakin.$error\" role=\"alert\"><div ng-message=\"required\"><span>Time In is required.</span>\n</div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.TIME_OUT\">Time Out</label><input type=\"text\" ng-max=\"24\" \nname=\"atimeout\" ng-model=\"vm.out\" mask=\"99:99\" ng-disabled=\"true\" mask-placeholder=\"_\"><div \nng-messages=\"upnormalForm.atimeout.$error\" role=\"alert\"><div ng-message=\"required\"><span>Time Out is required.</span>\n</div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container></div><div class=\"form-title\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.UPDATE_DATA\">Update Data</div><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.TIME_IN\">Time In</label>\n<input type=\"text\" ng-max=\"24\" name=\"timein\" ng-model=\"vm.Form.objForm.timein\" mask=\"99:99\" mask-placeholder=\"_\" \nrequired><div ng-messages=\"upnormalForm.timein.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTime In is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.BREAK_OUT\">Break Out</label><input type=\"text\" ng-max=\"24\" \nname=\"breakout\" ng-model=\"vm.Form.objForm.breakout\" mask=\"99:99\" mask-placeholder=\"_\" \nng-required=\"vm.requiredBreakFinger\"><div ng-messages=\"upnormalForm.breakout.$error \" role=\"alert\"><div \nng-message=\"required\"><span>Time In is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.BREAK_IN\">Break In</label><input type=\"text\" ng-max=\"24\" \nname=\"breakin\" ng-model=\"vm.Form.objForm.breakin\" mask=\"99:99\" mask-placeholder=\"_\" \nng-required=\"vm.requiredBreakFinger\"><div ng-messages=\"upnormalForm.breakin.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Time In is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.TIME_OUT\">Time Out</label><input type=\"text\" ng-max=\"24\" \nname=\"timeout\" ng-model=\"vm.Form.objForm.timeout\" mask=\"99:99\" mask-placeholder=\"_\" required><div \nng-messages=\"upnormalForm.timeout.$error\" role=\"alert\"><div ng-message=\"required\"><span>Time Out is required.</span>\n</div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container></div><div layout=\"column\"><md-input-container flex ng-if=\"!vm.otherReason\"><md-select \nng-model=\"vm.Form.objForm.description\" ng-change=\"vm.changeReasonUpdatefinger()\" name=\"description\" required><md-option\n ng-repeat=\"ls in vm.reasonUpdateFinger\" placeholder=\"Description\" value=\"{{ls.description}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"upnormalForm.description.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>description field is required.</span></div></div></md-input-container><md-input-container flex \nng-if=\"vm.otherReason\"><input type=\"text\" name=\"description1\" ng-pattern=\"/^[a-zA-Z0-9\\ ]*$/\" ng-minlength=\"2\" \nng-model=\"vm.Form.objForm.description1\" placeholder=\"Description\" required><div \nng-messages=\"upnormalForm.description1.$error\" role=\"alert\"><div ng-message=\"required\"><span>description is required.\n</span></div><div ng-message=\"pattern\"><span>character input not allowed.</span></div><div ng-message=\"minlength\">\n<span>Minimum 2 character input.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox \nng-model=\"data.check\" aria-label=\"Checkbox 2\" ng-true-value=\"true\" ng-false-value=\"false\" \nclass=\"md-warn md-align-top-left\" flex><span class=\"ipsum\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.NOTIF\">\nSebelum menyimpan data update finger, periksa kembali shift, clock in dan clock out time apakah sudah benar?</span>\n</md-checkbox></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(upnormalForm.$invalid || upnormalForm.$pristine) || !data.check\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.UPDATE_FINGER_TIME.SAVE\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/attendance-report/attendance-report.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.HEADER.TITLE\">Attendance Report</span></md-subheader>\n<div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.FILTER.TITLE\">Filter Data</span></div><div ng-if=\"vm.groupLogin !=11\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea()\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.INDEX.FILTER.COMPANY\' \n                          | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.INDEX.FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container flex><md-select ng-model=\"vm.flag_app\" \nname=\"flag_app\" ng-change=\"vm.getPeriode()\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.INDEX.FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">\n{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.INDEX.FILTER.YEAR\' | translate }}\" \nvalue=\"{{val}}\">{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\">\n<md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.INDEX.FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon>Search\n</md-button></div></div><div ng-if=\"vm.groupLogin==11\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.INDEX.FILTER.COMPANY\' \n                          | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.INDEX.FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container flex><md-select ng-model=\"vm.flag_app\" \nng-change=\"vm.getPeriode()\" name=\"flag_app\" required><md-option ng-repeat=\"val in vm.flagApp\" \nplaceholder=\"{{ \'FILTER.FLAG_APP\' | translate }}\" value=\"{{val}}\"><span translate=\"FILTER.{{val}}\">{{val}}</span>\n</md-option></md-select><div ng-messages=\"frmEmploye.flag_app.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.INDEX.FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon>Search</md-button></div></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item ng-if=\"vm.groupLogin!=11\">\n<md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-click=\"vm.ExportTotxt()\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Download Attendance</md-tooltip><md-icon md-font-icon=\"icon-file\" class=\"teal-800-fg\">\n</md-icon></md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=\"vm.groupLogin!=11\" \naria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" \nhide show-gt-sm ng-click=\"vm.ExportTotxt()\"><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\nDownload Attendance</md-tooltip>Download Attendance <span flex hide show-gt-sm></span></md-button></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.NO\">No</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.NIK\">NIK</span></th><th width=\"15%\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.NAME\">Name</span></th><th width=\"15%\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.DATE\">Date</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.CLOCK_IN\">Clock In\n</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.MACHINE_CO_CI\">Machine No CI</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.CLOCK_OUT\">Clock Out\n</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.MACHINE_NO_CO\">Machine No CO</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.START_OF_BREAK\">\nStart of Break</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.MACHINE_NO_SB\">Machine No SB</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.END_OF_BREAK\">\nEnd Of Break</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.MACHINE_NO_EB\">Machine No EB</span></th><th><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.TABLE.DOWNLOAD\">Download</span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.listData\"><td class=\"text-center\">{{ls.no}}</td><td class=\"text-center\">{{ls.nik }}</td>\n<td class=\"text-center\">{{ls.empName}}</td><td class=\"text-center\">{{ls.tanggal}}</td><td class=\"text-center\">{{ls.in}}\n</td><td class=\"text-center\">{{ls.terminalId1 }}</td><td class=\"text-center\">{{ls.out}}</td><td class=\"text-center\">\n{{ls.terminalId2}}</td><td class=\"text-center\">{{ls.breakOut}}</td><td class=\"text-center\">{{ls.terminalId3}}</td><td \nclass=\"text-center\">{{ls.breakIn}}</td><td class=\"text-center\">{{ls.terminalId4}}</td><td class=\"text-center\"><span \nng-if=\"ls.download\"><md-icon class=\"green-500-fg\" md-font-icon=\"icon-check\"></md-icon></span></td></tr><tr \nng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>No Data Available</span></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/attendance-team/attendance-team.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Attendance Team</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.tahun\" name=\"tahun\" required><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'MENU.CB.ATTENDANCE_TEAM.INDEX.FILTER.YEAR\' | translate }}\" \nvalue=\"{{val}}\">{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.bulan\" name=\"bulan\" required><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_TEAM.INDEX.FILTER.MONTH\' | translate }}\" value=\"{{val.value}}\">{{val.name}}\n</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.nik\" \nng-change=\"vm.ChangeNik()\" name=\"nik\" required><md-option ng-repeat=\"ls in vm.listteam\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_TEAM.INDEX.FILTER.NIK\' | translate }}\" value=\"{{ls.nik}}\">{{ls.nik}} - {{ls.nama}}\n</md-option></md-select><div ng-messages=\"frmEmploye.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" \ntype=\"button\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.FILTER.SUBMIT\">Submit</span></md-button>\n</div></form></div></div></md-content><md-content id=\"attView\" layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered\" ms-responsive-table id=\"attendance\"><thead><tr><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.DAY_DATE\">\nDay/Date</span></th><th class=\"text-center\" colspan=\"2\" layout-align=\"center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.SHIFT\">Shift</span></th><th class=\"text-center\" colspan=\"4\" \nlayout-align=\"center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.ACTUAL\">Actual</span>\n</th><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.OT_APPROVED\">OT Approved</span></th><th class=\"text-center\" rowspan=\"2\">\n<span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.OT_UNAPPROVED\">OT Unapproved</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\" \ntranslate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.FINGER_STATUS\">Finger Status</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.NOTE\">Note</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\">#</span></th></tr><tr><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.IN\">IN</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.OUT\">OUT</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.IN\">IN</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.BREAK_OUT\">Break Out</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.BREAK_IN\">Break In</span>\n</th><th class=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.ATTENDANCE_TEAM.INDEX.TABLE.OUT\">OUT</span>\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listAttendance track by $index\" \nng-class=\"{\'empholiday\':ls.isHoliday,\'emptruant\':ls.infoAbsence[0].code==\'Z301\',\'empinactive\':!ls.isAsEmployeeActive,\'empghkkerja\':ls.isGhkKerja,\'empsubsitusileave\':ls.infoAbsence[0].code==\'Z102\',\'empleave\':(ls.infoAbsence[0].full ==\'1\' && ls.infoAbsence[0].leaveStatus ==\'1\')}\">\n<td class=\"text-right\">{{ls.day}}/{{ls.date}}</td><td class=\"text-center\">{{ls.shift.tampilStartDate}}<storng>\n{{ls.shift.tampilStartTime}}</storng></td><td class=\"text-center\">{{ls.shift.tampilEndDate}} <strong>\n{{ls.shift.tampilEndTime}}</strong></td><td class=\"text-center\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.in==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.in!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateIn>0\">\n{{ls.listFingerDate.in}} <strong>{{ls.listFinger.in}}</strong><md-tooltip md-direction=\"top\">{{ls.lateIn}}</md-tooltip>\n</span><span ng-if=\"ls.lateIn==0\">{{ls.listFingerDate.in}} <strong>{{ls.listFinger.in}}</strong></span></span></td><td \nclass=\"text-center\" ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakOut==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakOut!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFingerDate.breakOut}} <strong>{{ls.listFinger.breakOut}}</strong><md-tooltip md-direction=\"top\">\n{{ls.lateBreakIn}}</md-tooltip></span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFingerDate.breakOut}} <strong>\n{{ls.listFinger.breakOut}}</strong></span></span></td><td class=\"text-center\" ng-if=\"!ls.requiredBreakFinger\"></td><td \nclass=\"text-center\" ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakIn==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakIn!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFingerDate.breakIn}} <strong>{{ls.listFinger.breakIn}}</strong><md-tooltip md-direction=\"top\">\n{{ls.lateBreakIn}}</md-tooltip></span><span ng-if=\"ls.lateBreakIn==0\">{{ls.listFingerDate.breakIn}} <strong>\n{{ls.listFinger.breakIn}}</strong></span></span></td><td class=\"text-center\" ng-if=\"!ls.requiredBreakFinger\"></td><td \nclass=\"text-center\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.out==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.out!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.earlyOut>0\">\n{{ls.listFingerDate.out}} <strong>{{ls.listFinger.out}}</strong><md-tooltip md-direction=\"top\">{{ls.earlyOut}}\n</md-tooltip></span><span ng-if=\"ls.earlyOut==0\">{{ls.listFingerDate.out}} <strong>{{ls.listFinger.out}}</strong>\n</span></span></td><td class=\"text-center\"><span ng-if=\"ls.approvedOT>0\">{{ls.approvedOT}}</span><span \nng-if=\"ls.approvedOT==0\"></span></td><td class=\"text-center\"><span ng-if=\"ls.unApprovedOT>0\">{{ls.unApprovedOT}}</span>\n<span ng-if=\"ls.unApprovedOT==0\"></span></td><td class=\"text-center\"><span ng-repeat=\"statusFin in ls.fingerStatus\">\n<span class=\"red-500-fg\">{{statusFin}}</span></span></td><td class=\"text-center\"><span \nng-repeat=\"abs in ls.infoAbsence\"><span class=\"red-500-fg\" ng-if=\"abs.name==\'Truant\' || abs.name==\'Undisciplined\'\">\n{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span> </span><span \nng-if=\"!(abs.name==\'Truant\' || abs.name==\'Undisciplined\')\">{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span>\n</span></span></td><td><md-menu ng-if=\"ls.isAsEmployeeActive\"><md-button class=\"md-icon-button action-selector\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nClick for view action</md-tooltip><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content \nwidth=\"3\" class=\"md-background-bg\"><md-button ng-click=\"vm.fingerLog($event,ls,vm.nik)\" aria-label=\"Refresh widget\">\nFinger Log</md-button><md-button ng-click=\"vm.infoTransaction($event,ls,vm.nik)\" aria-label=\"Refresh widget\">\nInfo Transaction</md-button></md-menu-content></md-menu></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div><style type=\"text/css\">\n.btn-ui-serif {\n    line-height: 3.8rem !important;\n  }</style>");
$templateCache.put("app/main/cb/business-trip/business-trip.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.BUSINESSTRIP\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.FILTER_DATA\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option ng-repeat=\"ls in vm.appstatus\" \nplaceholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" value=\"{{ls.value}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"formInputOT.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nabs_code field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.start_date\" flex=\"30\"></md-datepicker><div ng-messages=\"formInputOT.start_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" flex=\"30\"></md-datepicker>\n<div ng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputBusinesstrip($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.NEW\">New</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span translate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.DELETE\">Delete</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.InputBusinesstrip($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>New</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.NEW\">New\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listselected.length == 0\" ng-click=\" vm.deleteData()\"><md-icon ng-if=\"vm.listselected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listselected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"1%\"></th><th width=\"6%\" \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.TABLE.TYPE\">Type</th><th width=\"20%\" \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.TABLE.TYPE_NAME\" class=\"text-center\">Type Name</th><th width=\"8%\" \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.TABLE.START_DATE\">Start Date</th><th width=\"8%\" \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.TABLE.END_DATE\">End Date</th><th width=\"2%\" \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.TABLE.DAY\">Day</th><th \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.TABLE.DESCRIPTION\" class=\"text-left\">Description</th><th width=\"5%\" \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.TABLE.STATUS\">Status</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td><md-checkbox ng-if=\"ls.appstatus==\'1\'\" class=\"no-label\" \nng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ls.absence_type}}\n</td><td class=\"text-center\">{{ls.type_name}}</td><td class=\"text-center\">{{ls.start_date}}</td><td \nclass=\"text-center\">{{ls.end_date}}</td><td class=\"text-center\">{{ls.day}}</td><td class=\"text-left\">{{ls.description}}\n</td><td class=\"text-center\"><span ng-if=\"ls.appstatus==\'1\'\" translate=\"ATTENDANCE.LABEL.WAITINGAPPROVAL\">\nWaiting Approval</span> <span ng-if=\"ls.appstatus==\'2\'\" translate=\"KPI.LABEL.APPROVED\"></span> <span \nng-if=\"ls.appstatus==\'4\'\" translate=\"MYPROFILE.MENU.REJECTED\">Rejected</span> <span ng-if=\"ls.appstatus==3\">\nWaiting HR Approval</span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/business-trip/input-business-trip.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"ATTENDANCE.LABEL.FORMINOPUTBUSINESSTRIP\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nflex ng-show=\"!vm.isdisabled\"><md-select ng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.abs_code\" \nng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.abs_code)\" name=\"abs_code\" required><md-option \nng-repeat=\"ls in vm.listAbsenceType\" placeholder=\"{{ \'MENU.CB.BUSINESS_TRIP.FORM_INPUT.ABSENCE_TYPE\' | translate }}\" \nvalue=\"{{ls.abs_code}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"formAbsence.abs_code.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>abs_code field is required.</span></div></div></md-input-container><div \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"MENU.CB.BUSINESS_TRIP.FORM_INPUT.START_DATE\">Start Date\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required>\n</md-datepicker><div ng-messages=\"formInputOT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart Date is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.BUSINESS_TRIP.FORM_INPUT.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.Form.objForm.start_date\" ng-disabled=\"vm.Form.objForm.daytype==\'halfday\'\" name=\"end_date\" \nng-model=\"vm.Form.objForm.end_date\" ng-required=\"vm.enddaterequire\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container></div><md-input-container flex><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"{{ \'KPI.LABEL.DESCRIPTION\' | translate}}\" required><div \nng-messages=\"formAbsence.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>description is required.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formAbsence.$invalid || formAbsence.$pristine\" translate=\"MENU.CB.BUSINESS_TRIP.FORM_INPUT.SUBMIT\">Submit\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/attendancelist/attendancelist-back.html","<div id=\"attendance\" class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon ui-sref=\"{{vm.Breadhome}}\" md-font-icon=\"icon-home\" class=\"s16\"></md-icon><div \nng-repeat-start=\"ls  in vm.Breadlist\"></div><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\" ui-sref=\"{{ls.link}}\">{{ls.name}}</span><div ng-repeat-end></div></div><div class=\"title\">\nAttendance</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-click=\"vm.IMportFile($event)\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span>Add Employement</span></md-button></div></div><div class=\"content\"><div \nclass=\"simple-table-container\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>\nSearch Employe</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" name=\"emp_no\" \nng-keyup=\"vm.EmpKeyUp()\" maxlength=\"8\" ng-model=\"vm.emp_no\" placeholder=\"Employe No\" required><div \nng-messages=\"frmEmploye.emp_no.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employe No field is required.\n</span></div></div></md-input-container><md-autocomplete flex md-no-cache=\"vm.noCache\" md-selected-item=\"vm.emp_id\" \nmd-search-text=\"vm.emp_name\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-items=\"item in vm.querySearch(vm.emp_name)\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-min-length=\"3\" md-input-name=\"emp_id\" md-item-text=\"item.emp_nama\" md-floating-label=\"Employe Name\">\n<md-item-template><span md-highlight-text=\"vm.searchString\">{{item.emp_nama}}</span></md-item-template>\n</md-autocomplete><md-input-container flex><label>Position</label><input type=\"text\" name=\"position\" \nng-disabled=\"vm.isDisabled\" ng-model=\"vm.position\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Periode</label><md-select ng-model=\"vm.periode\" required><md-option \nng-repeat=\"ls in vm.listperiode\" value=\"{{ls.value}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.periode.$error\" role=\"alert\"><div ng-message=\"required\"><span>periode No field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Years</label><md-select ng-model=\"vm.years\" \nrequired><md-option ng-repeat=\"ls in vm.listyears\" value=\"{{ls.value}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.periode.$error\" role=\"alert\"><div ng-message=\"required\"><span>periode No field is required.\n</span></div></div></md-input-container><md-input-container flex layout-align=\"right right\"><md-button type=\"submit\" \nlayout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-sync\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon>\n</md-button></md-input-container></div></form></div></div></md-content><div id=\"attView\"><table class=\"simple\" \nms-responsive-table style=\"margin-top:0\"><thead><tr><th><span class=\"column-title\">No</span></th><th><span \nclass=\"column-title\">Link</span></th><th ng-repeat=\"t in vm.listData.time\"><span class=\"column-title\">{{t}}</span></th>\n<th><span class=\"column-title\">Link</span></th><th><span class=\"column-title\">Link</span></th><th><span \nclass=\"column-title\">Link</span></th><th><span class=\"column-title\">Link</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listData.list\"><td>{{ls.no}}</td><td>{{ls.tgl }}</td><td ng-repeat=\"dt in ls.listtime\">{{dt.time}}\n</td><td></td><td></td><td></td><td></td></tr></tbody></table></div><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</div>");
$templateCache.put("app/main/cb/attendancelist/attendancelist.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.ATTENDANCE_REPORT.INDEX.HEADER.TITLE\">Attendance list</span></md-subheader>\n<div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\" required><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEAPRTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"mt-10\"><md-input-container\n flex><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nmd-placeholder=\"{{ \'FILTER.START_DATE\' | translate }}\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"frmEmploye.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.</span>\n</div></div></md-input-container><md-input-container flex><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglakhir\" md-placeholder=\"{{ \'FILTER.END_DATE\' | translate }}\" required name=\"tglakhir\"></md-datepicker>\n<div ng-messages=\"frmEmploye.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.</span>\n</div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span>Submit</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.openUploadPhoto($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Upload File</md-tooltip><span \ntranslate=\"MENU.PMS.EMP_JOB_CODE.INDEX.ACTION.UPLOAD\">Upload File</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-blue-300-bg md-raised white-fg\" \nhide show-gt-sm type=\"button\" ng-click=\"vm.Reloadatt($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Reload</md-tooltip><span>Reload</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th><span class=\"column-title\" \ntranslate=\"TABLE.NO\">No</span></th><th><span class=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th><span \nclass=\"column-title\" translate=\"TABLE.NAME\">Name</span></th><th><span class=\"column-title\" translate=\"TABLE.DAY_DATE\">\nDay/Date</span></th><th><span class=\"column-title\" translate=\"TABLE.SHIFT\">Shift</span></th><th><span \nclass=\"column-title\" translate=\"TABLE.IN\">IN</span></th><th><span class=\"column-title\" translate=\"TABLE.BREAK_OUT\">\nBreak Out</span></th><th><span class=\"column-title\" translate=\"TABLE.BREAK_IN\">Break In</span></th><th><span \nclass=\"column-title\" translate=\"TABLE.OUT\">Out</span></th><th><span class=\"column-title\" \ntranslate=\"TABLE.OT_UNAPPROVED\">OT Un-Approved</span></th><th><span class=\"column-title\" translate=\"TABLE.OT_APPROVED\">\nOT Approved</span></th></tr></thead><tbody><tr style=\"display:none\" ng-repeat-start=\"ls in vm.DataTable.list\"></tr><tr>\n<td rowspan=\"{{ls.rowd}}\">{{ls.no }}</td><td rowspan=\"{{ls.rowd}}\">{{ls.nik }}</td><td rowspan=\"{{ls.rowd}}\">\n{{ls.empname }}</td></tr><tr ng-repeat=\"l in ls.att\"><td>{{l.tanggal }}</td><td>{{l.shift }}</td><td>{{l.masuk }}</td>\n<td>{{l.breakout }}</td><td>{{l.breakin }}</td><td>{{l.pulang }}</td><td></td><td></td></tr><tr style=\"display:none\" \nng-repeat-end></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/attendancelist/upload-file.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload File</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\" options=\"{ formData: [{action:\'uploadPhoto\',empID:vm.Form.objForm.id}] }\"></div><div \nclass=\"text-right\" flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/changeshift/changeshift.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\nChange Shift</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.status\" name=\"status\" ng-change=\"vm.loadData(1)\"><md-option ng-repeat=\"ls in vm.appstatus\" \nplaceholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" value=\"{{ls.value}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"formInputOT.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nabs_code field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.start_date\" flex=\"30\"></md-datepicker><div ng-messages=\"formInputOT.start_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" flex=\"30\"></md-datepicker>\n<div ng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \nng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>\n<span>Search</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span>Entries</span></md-input-container><span flex \nhide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th rowspan=\"2\" translate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.NAME\">Name</th><th \nrowspan=\"2\" translate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.DATE\">Date</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.DWS_CODE\">DWS Code</th><th colspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.FULL_DAY\">Full Day</th><th colspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.HALF_DAY\">Half Day</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.STATUS\">Status</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.ACTION\">Action</th></tr><tr><th \ntranslate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.START_TIME\">Start Time</th><th \ntranslate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.END_TIME\">End Time</th><th \ntranslate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.START_TIME\">Start Time</th><th \ntranslate=\"MENU.CB.CHANGE_SHIFT.INDEX.TABLE.END_TIME\">End Time</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td>{{ls.nama}}</td><td>{{ls.tgl}}</td><td>{{ls.idshift}}</td><td>{{ls.startFull}}\n</td><td>{{ls.endfull}}</td><td>{{ls.startHalf}}</td><td>{{ls.endHalf}}</td><td><span ng-if=\"ls.approval==1\">\nWaiting Approval</span> <span ng-if=\"ls.approval==2\">Approved</span> <span ng-if=\"ls.approval==4\"><a href=\"\" \nng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span></td>\n<td><span ng-if=\"ls.approval===\'1\'\"><md-button class=\"md-icon-button\" aria-label=\"Favorite\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.deleteChangeshift($event,ls.id)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip><span>click for delete</span></md-tooltip>\n</md-button></span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"9\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/changeshift-approval/changeshift-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.CHANGESHIFT_APPROVAL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formViewDataChangeshiftApp\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate \nlayout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"KPI.LABEL.FILTERDATA\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><label translate=\"TABLE.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formViewDataChangeshiftApp.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.START_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label translate=\"TABLE.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"formViewDataChangeshiftApp.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.END_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" ng-change=\"vm.loadData()\" \nrequired><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"formViewDataChangeshiftApp.bulan.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.FILTER.APPROVAL_TYPE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"formViewDataChangeshiftApp.$invalid\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" \nng-disabled=\"formViewDataChangeshiftApp.$invalid || formViewDataChangeshiftApp.$pristine\"></select>\n{{ \'KPI.LABEL.ENTRIES\' | translate}}</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveChangeshift($event)\" \nng-disabled=\"formViewDataChangeshiftApp.$invalid || vm.listOtselected.length == 0\"><md-icon \nmd-font-icon=\"icon-verified\"></md-icon><span translate=\"KPI.LABEL.APPROVE\">Approve</span></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" \nng-click=\"vm.Reject($event)\" ng-disabled=\"formViewDataChangeshiftApp.$invalid || vm.listOtselected.length == 0\"><i \nclass=\"icon-delete\"></i> <span translate=\"ACTION.REJECT\">Reject</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-button ng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide \nshow-gt-sm type=\"button\" ng-click=\"vm.approveChangeshift($event)\" \nng-disabled=\"formViewDataChangeshiftApp.$invalid || vm.listOtselected.length == 0\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.APPROVE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"KPI.LABEL.APPROVE\">\nAprove</span></md-button><div ng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button ng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Inert\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formViewDataChangeshiftApp.$invalid || vm.listOtselected.length == 0\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.REJECT\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.REJECT\">Reject</span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\" class=\"text-center\"><span \nng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th rowspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.NAME\">Name</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.DATE\">Date</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.DWS_CODE\">DWS Code</th><th colspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.FULL_DAY\">Full Day</th><th colspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.HALF_DAY\">Half Day</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.STATUS\">Status</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.ACTION\">Action</th></tr><tr><th \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.START_TIME\">Start Time</th><th \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.END_TIME\">End Time</th><th \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.START_TIME\">Start Time</th><th \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.TABLE.END_TIME\">End Time</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==1\"><input type=\"checkbox\" \nchecklist-model=\"vm.listOtselected\" checklist-value=\"ls\" ng-click=\"vm.changeChecked()\"></span></td><td>\n{{ls.nik}}-{{ls.nama}}</td><td>{{ls.tgl}}</td><td>{{ls.idshift}}</td><td>{{ls.startFull}}</td><td>{{ls.endfull}}</td>\n<td>{{ls.startHalf}}</td><td>{{ls.endHalf}}</td><td><span ng-if=\"ls.approval==1\" \ntranslate=\"ATTENDANCE.LABEL.WAITINGAPPROVAL\">Waiting Approval</span> <span ng-if=\"ls.approval==2\" \ntranslate=\"KPI.LABEL.APPROVED\">Approved</span> <span ng-if=\"ls.approval==4\" translate=\"MYPROFILE.MENU.REJECTED\"><a \nhref=\"\" ng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip md-direction=\"top\"><span \ntranslate=\"ATTENDANCE.LABEL.VIEWCOMMENT\"></span></md-tooltip></span></td><td><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.approval==2\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.ACTION.UNAPPROVE\">Un-approve</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"ls.approval==4\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.ACTION.UNREJECT\">Un-reject</span></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>\n<style type=\"text/css\">.btn-ui-serif {\n    line-height: 3.8rem !important;\n  }</style>");
$templateCache.put("app/main/cb/changeshift-approval/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg has-upload\"><div layout=\"column\"><div layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"description\" ng-disabled=\"vm.isdisabled\" \nng-model=\"vm.Form.objForm.comment\" placeholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.COMMENT\' | translate }}\" required><div\n ng-messages=\"formAbsence.description.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></span>\n</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>\n{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span flex></span><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span translate=\"ACTION.REJECT\">Reject\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/checklist-attendance-gw-admin/checklist-attendance-gw-admin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\" layout=\"column\">\n<md-content class=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill>\n<md-subheader class=\"white-bg\"><span>Checklist Attendance GW</span></md-subheader><div layout=\"column\" flex><div \nclass=\"form-wrapper\" style=\"background: #F5F6F7\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"MENU.CB.LEAVE.INDEX.HEADER.FILTER_DATA\">Filter Data</span>\n</div><div layout=\"row\" class=\"form-inlinez\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.objGedung\" aria-label=\"Building\" name=\"gedung\" ng-change=\"vm.getSector(vm.objGedung)\"><md-option \nng-repeat=\"ls in vm.listGedung track by $index\" ng-selected=\"ls.gedung_id == vm.filterData.gedung\" \nplaceholder=\"Building\" value=\"{{ls}}\">{{ls.gedung_name}}</md-option></md-select></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.sector\" name=\"sector\" aria-label=\"Sector\" required \nng-change=\"vm.recordFilterData()\"><md-option ng-repeat=\"ls in vm.listSector track by $index\" placeholder=\"Sector\" \nng-selected=\"ls.sector_id == vm.filterData.sector\" value=\"{{ls.sector_id}}\">{{ls.sector_name}}</md-option></md-select>\n<div ng-messages=\"formInputOT.sector.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sector is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Working Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"working_date\" ng-model=\"vm.working_date\" ng-change=\"vm.recordFilterData()\">\n</md-datepicker><div ng-messages=\"formInputOT.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking Date is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.shiftGroup\" aria-label=\"shiftGroup\" name=\"shiftGroup\" ng-change=\"vm.recordFilterData()\" required>\n<md-option ng-repeat=\"ls in vm.listShiftGroup track by $index\" placeholder=\"Shift Group\" \nng-selected=\"ls.id == vm.filterData.shiftGroup\" ng-value=\"ls.id\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.line\" aria-label=\"line\" name=\"line\" \nng-change=\"vm.recordFilterData()\"><md-option ng-repeat=\"ls in vm.listLines track by $index\" placeholder=\"Line\" \nng-selected=\"ls.id == vm.filterData.line\" ng-value=\"ls.id\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" ng-click=\"vm.loadData(1)\" \nclass=\"md-raised md-primary\" aria-label=\"search\" ng-disabled=\"formInputOT.$invalid || formInputOT.$pristine\" \nstyle=\"margin-top: 0px\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>\nSearch&nbsp;</md-button></md-input-container></div></form></div></div><md-toolbars md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container></div></md-toolbars><div\n class=\"content\"><table class=\"simple with-toolbar bordered fullwidth-table stripped upper-case-header\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"2%\" rowspan=\"2\"></th><th \nclass=\"text-center\" width=\"20%\" rowspan=\"2\"><span translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.NIK_NAME\"></span>\n</th><th class=\"text-center\" colspan=\"6\"><span>Actual</span></th><th class=\"text-center\" colspan=\"8\"><span \ntranslate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.ATTENDANCE_CODE\">Checklist</span></th></tr><tr><th class=\"text-center\" \nwidth=\"10%\"><span translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.START_SHIFT\"></span></th><th class=\"text-center\" \nwidth=\"10%\"><span translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.END_SHIFT\"></span></th><th class=\"text-center\"><span>\nIn</span></th><th class=\"text-center\"><span>Break Out</span></th><th class=\"text-center\"><span>Break In</span></th><th \nclass=\"text-center\"><span>Out</span></th><th class=\"text-center\" width=\"10%\"><span \ntranslate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.START_SHIFT\"></span></th><th class=\"text-center\" width=\"10%\"><span \ntranslate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.END_SHIFT\"></span></th><th class=\"text-center\"><span>Line</span></th>\n<th class=\"text-center\"><span>In</span></th><th class=\"text-center\"><span>Break Out</span></th><th class=\"text-center\">\n<span>Break In</span></th><th class=\"text-center\"><span>Out</span></th><th class=\"text-center\"><span>Line</span></th>\n</tr></thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\"><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span><md-checkbox ng-if=\"!team.isChecked\" class=\"no-label\" aria-label=\"Select Employee\" \nng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team,$event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(team)?\'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td class=\"text-left\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n{{team.nik}} / <span ng-if=\"team.name\">{{team.name}}</span><span ng-if=\"team.nama\">{{team.nama}}</span></td><td \nclass=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.shift_default.iStartShift\">{{ team.shift_default.iStartShift * 1000 | date:\'dd/MMM HH:mm\'}} </span>\n<span ng-if=\"!team.shift_default.iStartShift\">-</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.shift_default.iEndShift\">{{ team.shift_default.iEndShift * 1000 | date:\'dd/MMM HH:mm\'}} </span><span \nng-if=\"!team.shift_default.iEndShift\">-</span></td><td colspan=\"4\" ng-if=\"team.infoAbsence.length > 0\" \nclass=\"text-center\">{{team.infoAbsence[0].name}}</td><td ng-if=\"team.infoAbsence.length == 0\" class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.finger.in\">{{team.finger.in}}</span></td><td ng-if=\"team.infoAbsence.length == 0\" \nclass=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.finger.break_out\">{{team.finger.break_out}}</span></td><td ng-if=\"team.infoAbsence.length == 0\" \nclass=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.finger.break_in\">{{team.finger.break_in}}</span></td><td ng-if=\"team.infoAbsence.length == 0\" \nclass=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.finger.out\">{{team.finger.out}}</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.start_shift\">{{ team.checklist.start_shift * 1000 | date:\'dd/MMM HH:mm\'}} </span><span \nng-if=\"!team.checklist.start_shift\">-</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.end_shift\">{{ team.checklist.end_shift * 1000 | date:\'dd/MMM HH:mm\'}} </span><span \nng-if=\"!team.checklist.end_shift\">-</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.line_in\">{{team.checklist.line_in}}</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.tab_in\">{{team.checklist.tab_in}}</span></td><td class=\"text-center\" \nng-if=\"team.checklist.tab_break_in\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<md-icon md-font-icon=\"icon-check\"></md-icon></td><td class=\"text-center\" ng-if=\"!team.checklist.tab_break_in\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n</td><td class=\"text-center\" ng-if=\"team.checklist.tab_break_out\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<md-icon md-font-icon=\"icon-check\"></md-icon></td><td class=\"text-center\" ng-if=\"!team.checklist.tab_break_out\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n</td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.tab_out\">{{team.checklist.tab_out}}</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.tab_out\">{{team.checklist.line_out}}</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" \nclass=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></md-content></div>");
$templateCache.put("app/main/cb/checklist-attendance-gw/checklist-attendance-gw.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\" layout=\"column\">\n<md-content class=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill>\n<md-subheader class=\"white-bg\"><span>Checklist Attendance GW</span></md-subheader><div layout=\"column\" flex><div \nclass=\"form-wrapper\" style=\"background: #F5F6F7\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"MENU.CB.LEAVE.INDEX.HEADER.FILTER_DATA\">Filter Data</span>\n</div><div layout=\"row\" class=\"form-inlinez\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.objGedung\" aria-label=\"Building\" name=\"gedung\" ng-change=\"vm.getSector(vm.objGedung)\"><md-option \nng-repeat=\"ls in vm.listGedung track by $index\" ng-selected=\"ls.gedung_id == vm.filterData.gedung\" \nplaceholder=\"Building\" value=\"{{ls}}\">{{ls.gedung_name}}</md-option></md-select></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.sector\" name=\"sector\" aria-label=\"Sector\" required \nng-change=\"vm.recordFilterData()\"><md-option ng-repeat=\"ls in vm.listSector track by $index\" placeholder=\"Sector\" \nng-selected=\"ls.sector_id == vm.filterData.sector\" value=\"{{ls.sector_id}}\">{{ls.sector_name}}</md-option></md-select>\n<div ng-messages=\"formInputOT.sector.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sector is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Working Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"working_date\" ng-model=\"vm.working_date\" ng-change=\"vm.recordFilterData()\">\n</md-datepicker><div ng-messages=\"formInputOT.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking Date is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.shiftGroup\" aria-label=\"shiftGroup\" name=\"shiftGroup\" ng-change=\"vm.recordFilterData()\" required>\n<md-option ng-repeat=\"ls in vm.listShiftGroup track by $index\" placeholder=\"Shift Group\" \nng-selected=\"ls.id == vm.filterData.shiftGroup\" ng-value=\"ls.id\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.line\" aria-label=\"line\" name=\"line\" \nng-change=\"vm.recordFilterData()\"><md-option ng-repeat=\"ls in vm.listLines track by $index\" placeholder=\"Line\" \nng-selected=\"ls.id == vm.filterData.line\" ng-value=\"ls.id\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" ng-click=\"vm.loadData(1)\" \nclass=\"md-raised md-primary\" aria-label=\"search\" ng-disabled=\"formInputOT.$invalid || formInputOT.$pristine\" \nstyle=\"margin-top: 0px\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>\nSearch&nbsp;</md-button></md-input-container></div></form></div></div><md-toolbars md-theme=\"table-toolbar-theme\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span hide>Entries</span></md-input-container>\n<md-button class=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.cb_checklist_attendance_gw_input_checklist\" style=\"padding-top: 4px\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><span>Input</span></md-button><md-button class=\"md-button md-ink-ripple md-warn md-mini\" show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Delete Selected Attendance</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon>Delete\n</md-button><div class=\"divider-vertical hide show-gt-sm\" show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.uploadData($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nUpload Checklist Attendance Data</md-tooltip><md-icon md-font-icon=\"icon-upload\"></md-icon>Upload</md-button><span \nflex></span> <span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div></md-toolbars><div \nclass=\"content\"><table class=\"simple with-toolbar bordered fullwidth-table stripped upper-case-header\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"2%\" rowspan=\"2\"></th><th \nclass=\"text-center\" width=\"20%\" rowspan=\"2\"><span translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.NIK_NAME\"></span>\n</th><th class=\"text-center\" colspan=\"6\"><span>Actual</span></th><th class=\"text-center\" colspan=\"8\"><span \ntranslate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.ATTENDANCE_CODE\">Checklist</span></th><th class=\"text-center\" \nwidth=\"15%\" rowspan=\"2\"><span>Action</span></th></tr><tr><th class=\"text-center\" width=\"10%\"><span \ntranslate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.START_SHIFT\"></span></th><th class=\"text-center\" width=\"10%\"><span \ntranslate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.END_SHIFT\"></span></th><th class=\"text-center\"><span>In</span></th><th \nclass=\"text-center\"><span>Break Out</span></th><th class=\"text-center\"><span>Break In</span></th><th \nclass=\"text-center\"><span>Out</span></th><th class=\"text-center\" width=\"10%\"><span \ntranslate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.START_SHIFT\"></span></th><th class=\"text-center\" width=\"10%\"><span \ntranslate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.END_SHIFT\"></span></th><th class=\"text-center\"><span>Line</span></th>\n<th class=\"text-center\"><span>In</span></th><th class=\"text-center\"><span>Break Out</span></th><th class=\"text-center\">\n<span>Break In</span></th><th class=\"text-center\"><span>Out</span></th><th class=\"text-center\"><span>Line</span></th>\n</tr></thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\"><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span><md-checkbox ng-if=\"!team.isChecked\" class=\"no-label\" aria-label=\"Select Employee\" \nng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team,$event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(team)?\'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td class=\"text-left\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n{{team.nik}} / {{team.name}}</td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.shift_default.iStartShift\">{{ team.shift_default.iStartShift * 1000 | date:\'dd/MMM HH:mm\'}} </span>\n<span ng-if=\"!team.shift_default.iStartShift\">-</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.shift_default.iEndShift\">{{ team.shift_default.iEndShift * 1000 | date:\'dd/MMM HH:mm\'}} </span><span \nng-if=\"!team.shift_default.iEndShift\">-</span></td><td colspan=\"4\" ng-if=\"team.infoAbsence.length > 0\" \nclass=\"text-center\">{{team.infoAbsence[0].name}}</td><td ng-if=\"team.infoAbsence.length == 0\" class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.finger.in\">{{team.finger.in}}</span></td><td ng-if=\"team.infoAbsence.length == 0\" \nclass=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.finger.break_out\">{{team.finger.break_out}}</span></td><td ng-if=\"team.infoAbsence.length == 0\" \nclass=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.finger.break_in\">{{team.finger.break_in}}</span></td><td ng-if=\"team.infoAbsence.length == 0\" \nclass=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.finger.out\">{{team.finger.out}}</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.start_shift\">{{ team.checklist.start_shift * 1000 | date:\'dd/MMM HH:mm\'}} </span><span \nng-if=\"!team.checklist.start_shift\">-</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.end_shift\">{{ team.checklist.end_shift * 1000 | date:\'dd/MMM HH:mm\'}} </span><span \nng-if=\"!team.checklist.end_shift\">-</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.line_in\">{{team.checklist.line_in}}</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.tab_in\">{{team.checklist.tab_in}}</span></td><td class=\"text-center\" \nng-if=\"team.checklist.tab_break_in\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<md-icon md-font-icon=\"icon-check\"></md-icon></td><td class=\"text-center\" ng-if=\"!team.checklist.tab_break_in\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n</td><td class=\"text-center\" ng-if=\"team.checklist.tab_break_out\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<md-icon md-font-icon=\"icon-check\"></md-icon></td><td class=\"text-center\" ng-if=\"!team.checklist.tab_break_out\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n</td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.tab_out\">{{team.checklist.tab_out}}</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<span ng-if=\"team.checklist.tab_out\">{{team.checklist.line_out}}</span></td><td class=\"text-center\" \nng-style=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift)) && {\'color\': \'#9c27b0\'} || {}\">\n<md-button class=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.replaceShift(team)\" \nng-if=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift))\" \nstyle=\"width: max-content;min-width: max-content\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nReplace Shift</md-tooltip><md-icon md-font-icon=\"icon-sync\"></md-icon></md-button><span \nng-if=\"team.shift_default && team.checklist && ((team.shift_default.iStartShift != team.checklist.start_shift) || (team.shift_default.iEndShift != team.checklist.end_shift))\">\n||</span><md-button class=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputComment($event, team)\" style=\"width: max-content;min-width: max-content\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Edit Attendance</md-tooltip><md-icon \nmd-font-icon=\"icon-clipboard-text\"></md-icon></md-button>||<md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.viewComment($event, team)\" style=\"width: max-content;min-width: max-content\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">View Comment</md-tooltip><md-icon md-font-icon=\"icon-comment-text\">\n</md-icon></md-button></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></md-content></div>");
$templateCache.put("app/main/cb/checklist-attendance-gw/view-comment.html","<md-dialog aria-label=\"Comments Checklist Attendance GW\" flex-md=\"70\" flex-gt-md=\"60\"><md-toolbar \nclass=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Comments Checklist Attendance GW</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><div class=\"timeline\" layout=\"column\"><div \nclass=\"timeline-item md-whiteframe-1dp\"><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"comment-count\">{{vm.listData.length}} comments<md-icon md-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div>\n<div class=\"comment\" layout=\"row\" layout-fill ng-repeat=\"comment in vm.listData\"><div flex layout=\"column\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.input_by}} - {{comment.nama}}</span> <span \nclass=\"time\">{{comment.timestamp}}</span></div><div class=\"message\">{{comment.comment}}</div></div></div></footer>\n</div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-accent md-primary btn-ui-serif\" ng-click=\"vm.closeModal()\">Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/commit-attendance/commit-attendance.html","<div id=\"correspondence-pma\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\"><span \ntranslate=\"MENU.CB.COMMIT_ATTENDANCE.INDEX.HEADER.TITLE\">Commit Attendance</span></div><md-icon \nng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout=\"row\" layout-align=\"start center\" ng-submit=\"vm.loadData(1)\" novalidate>\n<div layout=\"column\" flex layout-align-gt-xs=\"end center\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.COMMIT_ATTENDANCE.FORM.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'MENU.CB.COMMIT_ATTENDANCE.FORM.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" \nng-change=\"vm.getPeriode()\" name=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"{{ \'MENU.CB.COMMIT_ATTENDANCE.FORM.MONTH\' | translate }}\" value=\"{{val.value}}\">{{val.name}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBulan field is required.</span></div></div></md-input-container><md-input-container flex><label>Range Periode</label>\n<md-select required ng-model=\"vm.rangePeriode\" placeholder=\"Range Periode\" name=\"rangePeriode\"><md-option \nng-repeat=\"item in vm.listPeriode\" ng-value=\"item\">{{item}}</md-option></md-select><div \nng-messages=\"frmEmploye.rangePeriode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRange periode field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.employeeType\" name=\"employeeType\"><md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"Employee Type\" \nvalue=\"{{ls.value}}\" required>{{ls.name | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee field is required.\n</span></div></div></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmFilter.$invalid || frmFilter.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" \nstyle=\"margin-right:5px\" layout=\"row\" layout-align=\"start center\"><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span>Entries</span></div><div class=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" \nlayout-align=\"center\" class=\"md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction\" ng-click=\"vm.newCommit($event)\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-clipboard-check\"></md-icon><span style=\"font-size:12px\">Create</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" \nclass=\"md-warn\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" \nng-click=\"vm.isCheckAction = !vm.isCheckAction;\"><md-icon style=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon>\n<span style=\"font-size:12px\">Delete</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nng-click=\"vm.deleteData($event)\" ng-if=\"vm.isCheckAction\" ng-disabled=\"vm.checked.length == 0\" \nclass=\"md-icon-btn md-primary md-mini md-small\"><md-icon class=\"green-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span style=\"font-size:12px\">Apply</span></md-button>\n<md-button ng-click=\"vm.isCheckAction = !vm.isCheckAction; vm.selectedItems = []\" ng-if=\"vm.isCheckAction\" \nclass=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\">Cancel</span></md-button><span flex hide show-gt-sm>\n</span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 12px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-primary\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction\" ng-click=\"vm.newCommit($event)\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-clipboard-check\"></md-icon><span style=\"font-size:12px\">Create</span></md-button><md-button \nstyle=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-warn\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction\" ng-click=\"vm.deleteData($event)\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu><span flex show hide-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\" on-collapse=\"vm.onCollapse()\"></ms-search-bar></div></md-toolbar><div \nlayout=\"column\" layout layout-padding ms-scroll><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th style=\"width:5%; text-align: center\" ng-if=\"vm.isCheckAction\"><div layout=\"row\" \nlayout-align=\"center center\"><md-checkbox style=\"left: 10%\" ng-model=\"vm.checkAll\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></md-checkbox></div></th><th class=\"text-center\" \ntranslate=\"TABLE.NO\">No</th><th class=\"text-center\" translate=\"TABLE.SUB_AREA\">Subarea</th><th class=\"text-center\" \ntranslate=\"TABLE.START_PERIOD\">Start Period</th><th class=\"text-center\" translate=\"TABLE.END_PERIOD\">End Period</th><th\n class=\"text-center\" translate=\"TABLE.FLAG_APP\">Flag App</th><th class=\"text-center\" translate=\"TABLE.COMMITED_BY\">\nCommited By</th><th class=\"text-center\" translate=\"TABLE.CREATED_BY\">Created Date</th></tr></thead><tbody><tr \nng-repeat=\"team in vm.DataTable.list\"><td ng-if=\"vm.isCheckAction\" style=\"text-align: center\"><md-checkbox \nng-checked=\"vm.exists(team, vm.selectedItems)\" ng-click=\"vm.toggle(team, vm.selectedItems)\"></md-checkbox></td><td \nclass=\"text-center\">{{vm.DataTable.offset + $index+1}}</td><td>{{team.subareaName}}</td><td class=\"text-center\">\n{{team.start_date}}</td><td class=\"text-center\">{{team.end_date}}</td><td class=\"text-center\">\n{{vm.flagTranslate(team.flag_app)}}</td><td class=\"text-center\">{{team.commited_by}}</td><td class=\"text-center\">\n{{team.date_data}}</td></tr><tr class=\"text-center\" ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td \ncolspan=\"8\" class=\"text-center\"><span>Please Do Filter First</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table></div><div class=\"p-24 mb-8\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/cb/commit-attendance/new-commit-attendance.html","<div class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content class=\"content padding\" \nlayout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\"><span \ntranslate=\"MENU.CB.COMMIT_ATTENDANCE.INDEX.HEADER.TITLE\">Commit Attendance</span></md-subheader><div class=\"white-bg\" \nlayout-padding><form ng-cloack name=\"frmEmploye\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmEmploye)\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company); vm.loadSubArea()\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'MENU.CB.COMMIT_ATTENDANCE.FORM.COMPANY\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.COMMIT_ATTENDANCE.FORM.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.COMMIT_ATTENDANCE.FORM.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'MENU.CB.COMMIT_ATTENDANCE.FORM.YEAR\' | translate }}\" value=\"{{val}}\">\n{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Range Periode</label><md-select required \nng-model=\"vm.rangePeriode\" placeholder=\"Range Periode\" name=\"rangePeriode\"><md-option \nng-repeat=\"item in vm.listPeriode\" ng-value=\"item\">{{item}}</md-option></md-select><div \nng-messages=\"frmEmploye.rangePeriode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRange periode field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.employeeType\" name=\"employeeType\"><md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"Employee Type\" \nvalue=\"{{ls.value}}\" required>{{ls.name | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee field is required.\n</span></div></div></md-input-container></div><div layout=\"row\" class=\"toolbar-subarea\"><md-checkbox \nng-model=\"vm.checkAll\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"isIndeterminate()\" ng-click=\"vm.toggleAll()\"><span\n ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></div><div layout=\"column\" layout-gt-xs=\"row\" \nclass=\"checkbox-container\"><div ng-repeat=\"column in vm.block\" flex=\"25\"><md-checkbox \nng-class=\"{\'fade-in\' : vm.subArea.length > 0, \'fade-out\' : vm.subArea.length === 0 }\" \nng-checked=\"vm.exists(ls, vm.selectedSubarea)\" ng-click=\"vm.toggle(ls, vm.selectedSubarea)\" \nng-repeat-start=\"ls in vm.subArea | slice:column.start:column.end\">{{ls.name}}</md-checkbox><div ng-repeat-end></div>\n</div></div><div loyout=\"column\" layout-gt-xs=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nng-click=\"vm.reloadToken()\" class=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\" \ntranslate=\"MENU.CB.LEAVE.FORM_INPUT.RELOAD_TOKEN\">Reload Token</md-button><md-button type=\"submit\" layout=\"row\" \nclass=\"md-raised md-primary\" aria-label=\"{{ \'ACTION.SUBMIT\' | translate }}\" \nng-disabled=\"(frmEmploye.$invalid || frmEmploye.$pristine) || vm.selectedSubarea.length === 0 || vm.saveProcess\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\"></md-icon>Submit</md-button></div>\n</form></div></div></md-content></div>");
$templateCache.put("app/main/cb/cut-off-periode/cut-off-periode.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span class=\"logo-text\" translate=\"MENU.CB.CUT_OFF_PERIOD.INDEX.HEADER.TITLE\">Cut Off Periode</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" aria-label=\"company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" aria-label=\"divisi\" \nname=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><label translate=\"FILTER.DEPARTMENT\">Department</label>\n<md-select ng-model=\"vm.department\" aria-label=\"department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"FILTER.SUB_AREA\">Sub Area</label><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\">\n<md-option ng-repeat=\"ls in vm.subArea\" value=\"{{ls.sub_area_id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \naria-label=\"FilterCutOff\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><span \ntranslate=\"ACTION.SUBMIT\">Submit</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div\n class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"TABLE.ENTRIES\">Entries\n</span></span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.UploadCutOffPeriode($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload Data</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" type=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.selected.length == 0\" \nng-click=\"vm.deleteDataCutOff($event)\"><md-icon ng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\">\n</md-icon><md-icon ng-if=\"vm.selected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.selected.length > 0\" class=\"red-700-fg\" translate=\"ACTION.DELETE\">Delete</span> <span \nng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\" translate=\"ACTION.DELETE\">Delete</span> <span \nng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span>\n<span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"AddCutOffPeriode\" \nng-click=\"vm.UploadCutOffPeriode($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button></md-menu-item><md-menu-item><span><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></span></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\">\n</th><th width=\"5%\"><span class=\"column-title\" translate=\"TABLE.NO\">NO</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.NAME\">Name</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.START_PERIOD\">start periode</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.END_PERIOD\">end periode</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.EFFECTIVE_DATE\">Effective Date</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.SUB_AREA\">Sub area</span></th><th width=\"2%\"></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\" ng-dblclick=\"vm.detailLeaveHold($event, item)\"><td>\n<md-checkbox aria-label=\"LeaveHoldChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td>{{($index + 1)}}</td><td class=\"text-center\">\n{{item.nik}}</td><td class=\"text-center\">{{item.name}}</td><td class=\"text-center\">{{item.start_periode}}</td><td \nclass=\"text-center\">{{item.end_periode}}</td><td class=\"text-center\">{{item.effective_date}}</td><td \nclass=\"text-center\">{{item.location}}</td><td><section layout=\"row\" layout-sm=\"column\" class=\"no-padding\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"LeaveHoldMenu\" class=\"md-icon-button\" style=\"padding:0;margin:0;height: 24px;width: 24px\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.EditCutOffPeriode($event, item)\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-border-color\"></md-icon><p flex>edit</p></div></md-button></md-menu-item></md-menu-content>\n</md-menu></section></td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>\nNo Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/download-attendance-pma/download-attendance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\">Download Report Attendance</md-subheader><div class=\"white-bg\"><md-content \nid=\"attendance-completion\" layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th width=\"15\" \nclass=\"text-center\">NO</th><th class=\"\">Report List</th><th width=\"40\" class=\"text-center\">#</th></tr></thead><tbody>\n<tr ng-repeat=\"ls in vm.listReport\"><td>{{ $index + 1 }}.</td><td>{{ls.reportname}}</td><td class=\"text-center\"><div \nflex><md-button type=\"button\" ng-click=\"vm.Download($event,ls.target)\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon><span>Download</span></md-button></div></td></tr><tr class=\"text-center\" \nng-if=\"vm.listReport.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/emp-ghk/emp-ghk.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.EMP_GHK\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\">\n<md-option ng-repeat=\"ls in vm.appstatus\" placeholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" \nvalue=\"{{ls.value}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"formInputOT.status.$error\" role=\"alert\"><div \nng-message=\"required\"><span>abs_code field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" flex=\"30\"></md-datepicker><div \nng-messages=\"formInputOT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" flex=\"30\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputGhk($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span translate=\"UMUT.MENU.NEW\">\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" \naria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i class=\"icon-delete\"></i> <span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.InputGhk($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"UMUT.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"UMUT.MENU.NEW\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listselected.length == 0\" ng-click=\" vm.deleteData()\"><md-icon ng-if=\"vm.listselected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listselected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\">\n</th><th width=\"8%\" translate=\"MENU.CB.EMPLOYEE_GHK.INDEX.TABLE.DWS_CODE\">DWS Code</th><th width=\"8%\" \ntranslate=\"MENU.CB.EMPLOYEE_GHK.INDEX.TABLE.VARIAN\">Variant</th><th width=\"12%\" \ntranslate=\"MENU.CB.EMPLOYEE_GHK.INDEX.TABLE.WORKING_DATE\">Working Date</th><th width=\"12%\" \ntranslate=\"MENU.CB.EMPLOYEE_GHK.INDEX.TABLE.EXPIRED_DATE\">Expired Date</th><th class=\"text-left\" \ntranslate=\"MENU.CB.EMPLOYEE_GHK.INDEX.TABLE.REASON\">Reason</th><th width=\"10%\" \ntranslate=\"MENU.CB.EMPLOYEE_GHK.INDEX.TABLE.STATUS\">Status</th><th width=\"5%\"><span translate=\"KPI.LABEL.ACTION\">\n</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td><md-checkbox \nng-if=\"ls.approval_status==0 || ls.approval_status==1\" class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td class=\"text-center\">{{ls.dws_code}}</td><td class=\"text-center\">{{ls.variant}} Day</td><td \nclass=\"text-center\">{{ls.workdayname}} / {{ls.working_date}}</td><td class=\"text-center\">\n{{ls.expireddatename}} / {{ls.expireddate}}</td><td>{{ls.reason}}</td><td class=\"text-center\"><span \nng-if=\"ls.approval_status==1 || ls.approval_status==0\"><span translate=\"ATTENDANCE.LABEL.WAITINGAPPROVAL\"></span>\n</span> <span ng-if=\"ls.approval_status==2\"><span translate=\"KPI.LABEL.APPROVED\"></span></span> <span \nng-if=\"ls.approval_status==4\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\"><span \ntranslate=\"MYPROFILE.MENU.REJECTED\"></span></a><md-tooltip md-direction=\"top\"><span \ntranslate=\"ATTENDANCE.LABRL.VIEWCOMMENT\"></span></md-tooltip></span></td><td class=\"text-center\"><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.editData($event,ls.detail_id,ls.approval)\" aria-label=\"Edit\"><md-icon \nclass=\"blue-500-fg\" md-font-icon=\"icon-pencil\"></md-icon><span translate=\"MENU.CB.EMPLOYEE_GHK.INDEX.ACTION.EDIT\">Edit\n</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/emp-ghk/inputghk.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.TITLE\">\nForm Input GHK</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"column\"><md-input-container flex><md-radio-group \nlayout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" ng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\">\n<md-radio-button value=\"group\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.GROUP\">Group\n</span></md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" ng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" ng-required=\"true\" \nname=\"location\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}</md-option></md-select>\n<div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>Location harus di pilih.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.START_TIME\">Start Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" \nautocomplete=\"off\" required><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" \nng-model=\"vm.Form.objForm.end_time\" mask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" \nrequired><div ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\"><div class=\"row\"><div flex \nlayout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" \nng-model=\"vm.Form.objForm.start_template\" flex ng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">\n{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><div layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.WORKING_DAY\">Working Day</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"kerjadate\" ng-model=\"vm.Form.objForm.kerjadate\" required ng-disabled=\"vm.approval == 1\"></md-datepicker><div \nng-messages=\"formInputGhk.kerjadate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MENU.CB.EMPLOYEE_GHK.FORM_INPUT.WORKING_DAY\' | translate}} is required.</span></div></div></md-input-container>\n</div><div layout-gt-sm=\"column\"><md-input-container flex><input type=\"text\" name=\"reason\" \nng-model=\"vm.Form.objForm.reason\" placeholder=\"{{ \'TABLE.REASON\' | translate}}\" required \nng-disabled=\"vm.approval == 2\"><div ng-messages=\"formInputGhk.reason.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{ \'TABLE.REASON\' | translate}} is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine\" translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.SAVE\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/download-attendance/attendance-summary.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.DOWNLOAD_ATTENDANCE.INDEX.LEGEND.DOWNLOAD_ATTENDANCE\">Download Attendance</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.groupLogin!=11\" \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\" \nclass=\"no-errors-spacer\"><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" required></md-datepicker><div \nng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" \nname=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker><div ng-messages=\"frmEmploye.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><span flex>\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nflex-gt-xs=\"30\"><md-select ng-model=\"vm.flag_app\" name=\"flag_app\"><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view}}</md-option></md-select><div \nng-messages=\"frmEmploye.flag_app.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee field is required.\n</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" required><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><span flex></span></div></div><div ng-if=\"vm.groupLogin==11\" layout=\"column\">\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\" required></md-datepicker><div ng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><md-input-container flex \nclass=\"no-errors-spacer\"><label translate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker><div \nng-messages=\"frmEmploye.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><span flex></span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex flex-gt-xs=\"50\"><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><span flex></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.employeeType\" \nname=\"employeeType\"><md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" \nvalue=\"{{ls.value}}\">{{ls.view}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container><md-input-container\n flex><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\" required><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><span flex></span><md-button type=\"button\" layout=\"row\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-click=\"vm.download()\" ng-disabled=\"frmEmploye.$invalid\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-download\" aria-label=\"android\"></md-icon><span translate=\"ACTION.DOWNLOAD\">Download</span>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/download-attendance/attendances.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.DOWNLOAD_ATTENDANCE.INDEX.LEGEND.DOWNLOAD_ATTENDANCE\">Download Attendance</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.groupLogin!=11\" \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\" \nclass=\"no-errors-spacer\"><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" required></md-datepicker><div \nng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" \nname=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker><div ng-messages=\"frmEmploye.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><span flex>\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"40\"><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nflex-gt-xs=\"50\"><md-select ng-model=\"vm.flag_app\" name=\"flag_app\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"50\"><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" ng-change=\"vm.selectSubarea()\" required><md-option \nng-repeat=\"ls in vm.subArea\" placeholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-offset-gt-xs=\"50\" flex-gt-xs=\"50\"><md-select \nng-model=\"vm.page\" name=\"page\" required><md-option ng-repeat=\"val in vm.listPage\" placeholder=\"Page\" \nvalue=\"{{val.value}}\">{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.page.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Page field is required.</span></div></div></md-input-container><md-input-container flex \nflex-gt-xs=\"50\"><input type=\"text\" placeholder=\"employee nik\" ng-model=\"vm.nik\" name=\"employe_nik\">\n</md-input-container></div></div><div ng-if=\"vm.groupLogin==11\" layout=\"column\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\" required></md-datepicker><div ng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><md-input-container flex \nflex-gt-xs=\"30\" class=\"no-errors-spacer\"><label translate=\"FILTER.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker>\n<div ng-messages=\"frmEmploye.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container><span flex></span></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"mt-10\">\n<md-input-container flex flex-gt-xs=\"30\"><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\"><md-select ng-model=\"vm.flag_app\" \nname=\"flag_app\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\" ng-change=\"vm.selectSubarea()\" \nrequired><md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" \nvalue=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.selectedBuilding\" name=\"building\" \nng-change=\"vm.getListSector(vm.selectedBuilding)\"><md-option ng-repeat=\"ls in vm.listGedung\" placeholder=\"Building\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"frmEmploye.building.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Building field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.selectedSector\" name=\"sector\"><md-option ng-repeat=\"ls in vm.listSector\" \nplaceholder=\"Sector\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"frmEmploye.sector.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sector field is required.</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-offset-gt-xs=\"75\" flex-gt-xs=\"25\"><md-select \nng-model=\"vm.page\" name=\"page\"><md-option ng-repeat=\"val in vm.listPage\" placeholder=\"Page\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.page.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-input-container flex layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vm.download()\" \nng-disabled=\"frmEmploye.$invalid\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\">\n</md-icon><span translate=\"ACTION.DOWNLOAD\">Download</span></md-button></md-input-container></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/download-attendance/download-attendance-pma.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"65\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.DOWNLOAD_ATTENDANCE.INDEX.HEADER.TITLE\">Download Attendance</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout=\"column\" layout-padding layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nname=\"company\" ng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.selectedSubarea\" \nname=\"subarea\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.subarea_id}}\" \nng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-padding layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.flag_app\" name=\"flag_app\" ng-change=\"vm.getPeriode()\"><md-option \nng-repeat=\"ls in vm.typeEmp\" placeholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">\n{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container><md-input-container \nflex><md-datepicker required name=\"startDate\" md-hide-icons=\"calendar\" ng-change=\"vm.changeDate(vm.startDate)\" \nng-model=\"vm.startDate\" md-current-view=\"year\" md-placeholder=\"Enter Start Date\"></md-datepicker><div \nng-messages=\"frmEmploye.startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date field is required.\n</span></div></div></md-input-container><md-input-container flex><md-datepicker required name=\"endDate\" \nmd-hide-icons=\"calendar\" ng-model=\"vm.endDate\" md-current-view=\"year\" md-min-date=\"vm.startDate\" \nmd-max-date=\"vm.endDt\" md-placeholder=\"Enter End Date\"></md-datepicker><div ng-messages=\"frmEmploye.endDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.page\" name=\"page\" required><md-option ng-repeat=\"val in vm.listPage\" \nplaceholder=\"Page\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.page.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Page field is required.</span></div></div></md-input-container></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-input-container flex layout-align=\"right right\">\n<md-button type=\"button\" layout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vm.download()\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon><span translate=\"ACTION.DOWNLOAD\">Download</span></md-button></md-input-container>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/download-attendance/download-attendance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\">Download Report Attendance</md-subheader><div class=\"white-bg\"><md-content \nid=\"attendance-completion\" layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th width=\"15\" \nclass=\"text-center\">NO</th><th class=\"\">Report List</th><th width=\"40\" class=\"text-center\">#</th></tr></thead><tbody>\n<tr ng-repeat=\"ls in vm.listReport\"><td>{{ $index + 1 }}.</td><td>{{ls.reportname}}</td><td class=\"text-center\"><div \nflex><md-button type=\"button\" ng-click=\"vm.Download($event,ls.target)\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon><span>Download</span></md-button></div></td></tr><tr class=\"text-center\" \nng-if=\"(vm.listReport | typeOf) == \'undefined\'\"><td colspan=\"3\" class=\"text-center\"><span>Loading, Please Wait</span>\n</td></tr><tr class=\"text-center\" ng-if=\"vm.listReport.length <= 0\"><td colspan=\"3\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/cb/download-attendance/leave-waiting-approval.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.DOWNLOAD_ATTENDANCE.LEAVE_WAITING_APPROVAL.TITLE\">Leave Waiting Approval</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.groupLogin!=11\" \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nname=\"company\" ng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"  .department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.employeeType\" \nname=\"employeeType\"><md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' }}\" \nvalue=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container>\n<md-input-container flex layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-click=\"vm.download()\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\"></md-icon><span translate=\"ACTION.DOWNLOAD\">\nDownload</span></md-button></md-input-container></div></div><div ng-if=\"vm.groupLogin==11\" layout=\"column\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\">\n<md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" \nname=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">\n{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.employeeType\" name=\"employeeType\">\n<md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">\n{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container><md-input-container \nflex layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-click=\"vm.download()\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-download\" aria-label=\"android\"></md-icon><span translate=\"ACTION.DOWNLOAD\">Download</span>\n</md-button></md-input-container></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/download-attendance/payleave-download.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.DOWNLOAD_ATTENDANCE.DOWNLOAD_PAYLEAVE\">Download Payleave</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.groupLogin!=11\" \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\" \nclass=\"no-errors-spacer\"><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" required></md-datepicker><div \nng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" \nname=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker><div ng-messages=\"frmEmploye.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><span flex>\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"35\"><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"35\"><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{\'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.flag_app\" name=\"flag_app\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.flag_app.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" required><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container></div></div><div ng-if=\"vm.groupLogin==11\" layout=\"column\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\" required></md-datepicker><div ng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><md-input-container flex \nflex-gt-xs=\"30\" class=\"no-errors-spacer\"><label translate=\"FILTER.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker>\n<div ng-messages=\"frmEmploye.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container><span flex></span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex flex-gt-xs=\"30\"><md-select ng-model=\"vm.company\" name=\"company\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" required><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-input-container flex layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-click=\"vm.download()\" ng-disabled=\"frmEmploye.$invalid\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-download\" aria-label=\"android\"></md-icon><span translate=\"ACTION.DOWNLOAD\">Download</span>\n</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/download-attendance/resignation-payleave-download.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Download Resignation Payleave</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nflex-gt-xs=\"30\" class=\"no-errors-spacer\"><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" required></md-datepicker><div \nng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" \nname=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker><div ng-messages=\"frmEmploye.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><span flex>\n</span></div></div><div layout=\"column\" layout-padding><fieldset><legend>Format file accepted (.xlxs)</legend>\n<md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" \nid=\"upload\" nv-file-select uploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">\nCancel</md-button><md-button type=\"submit\" ng-click=\"vm.Download()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD\">Download</span></md-button><span flex hide show-gt-xs></span><md-input-container flex \nlayout-align=\"right right\"><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button></md-input-container></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/cb/download-attendance/sva-download.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.DOWNLOAD_ATTENDANCE.INDEX.LEGEND.DOWNLOAD_SCHEDULE_ACTUAL\">Download Attendance</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.groupLogin!=11\" \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\" \nclass=\"no-errors-spacer\"><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" required></md-datepicker><div \nng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" \nname=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker><div ng-messages=\"frmEmploye.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><span flex>\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"40\"><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nflex-gt-xs=\"50\"><md-select ng-model=\"vm.flag_app\" name=\"flag_app\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"50\"><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" ng-change=\"vm.selectSubarea()\" required><md-option \nng-repeat=\"ls in vm.subArea\" placeholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-offset-gt-xs=\"75\" flex-gt-xs=\"25\"><md-select \nng-model=\"vm.page\" name=\"page\" required><md-option ng-repeat=\"val in vm.listPage\" placeholder=\"Page\" \nvalue=\"{{val.value}}\">{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.page.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Page field is required.</span></div></div></md-input-container></div></div><div \nng-if=\"vm.groupLogin==11\" layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nflex-gt-xs=\"30\" class=\"no-errors-spacer\"><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" required></md-datepicker><div \nng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" \nname=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker><div ng-messages=\"frmEmploye.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><span flex>\n</span></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"mt-10\"><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.flag_app\" name=\"flag_app\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\" ng-change=\"vm.selectSubarea()\" \nrequired><md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" \nvalue=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.selectedBuilding\" name=\"building\" \nng-change=\"vm.getListSector(vm.selectedBuilding)\"><md-option ng-repeat=\"ls in vm.listGedung\" placeholder=\"Building\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"frmEmploye.building.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Building field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.selectedSector\" name=\"sector\"><md-option ng-repeat=\"ls in vm.listSector\" \nplaceholder=\"Sector\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"frmEmploye.sector.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sector field is required.</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-offset-gt-xs=\"75\" flex-gt-xs=\"25\"><md-select \nng-model=\"vm.page\" name=\"page\"><md-option ng-repeat=\"val in vm.listPage\" placeholder=\"Page\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.page.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-input-container flex layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vm.download()\" \nng-disabled=\"frmEmploye.$invalid\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\">\n</md-icon><span translate=\"ACTION.DOWNLOAD\">Download</span></md-button></md-input-container></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/download-attendance/transaction-download.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.DOWNLOAD_ATTENDANCE.DOWNLOAD_TRANSACTION_WAITING_APPROVAL\">\nDownload Transaction Waiting Approval</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div ng-if=\"vm.groupLogin!=11 && vm.groupLogin!=127\" layout=\"column\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\" required></md-datepicker><div ng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><md-input-container flex \nflex-gt-xs=\"30\" class=\"no-errors-spacer\"><label translate=\"FILTER.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker>\n<div ng-messages=\"frmEmploye.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container><span flex></span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex flex-gt-xs=\"30\"><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"35\"><md-select ng-model=\"vm.divisi\" \nname=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"35\"><md-select ng-model=\"vm.department\" \nname=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.flag_app\" name=\"flag_app\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view}}</md-option></md-select><div \nng-messages=\"frmEmploye.flag_app.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee field is required.\n</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"35\"><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" required><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"35\"><md-select ng-model=\"vm.type\" \nname=\"type\" required><md-option ng-repeat=\"ls in vm.transactionType\" \nplaceholder=\"{{ \'FILTER.TRANSACTION_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view}}</md-option></md-select><div \nng-messages=\"frmEmploye.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Transaction type field is required.\n</span></div></div></md-input-container></div></div><div ng-if=\"vm.groupLogin==11 || vm.groupLogin==127\" \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\" \nclass=\"no-errors-spacer\"><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" required></md-datepicker><div \nng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" \nname=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker><div ng-messages=\"frmEmploye.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><span flex>\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nname=\"company\" required><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.flag_app\" name=\"flag_app\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view}}</md-option></md-select><div \nng-messages=\"frmEmploye.flag_app.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\" required><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" required>\n<md-option ng-repeat=\"ls in vm.transactionType\" placeholder=\"{{ \'FILTER.TRANSACTION_TYPE\' | translate }}\" \nvalue=\"{{ls.value}}\">{{ls.view}}</md-option></md-select><div ng-messages=\"frmEmploye.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Transaction type field is required.</span></div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button \ntype=\"button\" layout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vm.download()\" \nng-disabled=\"frmEmploye.$invalid\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\">\n</md-icon><span translate=\"ACTION.DOWNLOAD\">Download</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/emp-ghk-halfday/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div layout-fill class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.GHK_HALFDAY\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper\" style=\"background: #F5F6F7\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.FILTER_DATA\">Filter Data</span></div><div layout=\"row\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option ng-repeat=\"ls in vm.appstatus\" \nplaceholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" value=\"{{ls.value}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"formInputOT.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nabs_code field is required.</span></div></div></md-input-container><md-input-container flex=\"30\"><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.start_date\" flex=\"30\"></md-datepicker><div ng-messages=\"formInputOT.start_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container>\n<md-input-container flex=\"30\"><label translate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.end_date\" flex=\"30\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button \ntype=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar \nmd-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"KPI.LABEL.ENTRIES\">Entries</span></md-input-container><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputGhk($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span translate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputGhk($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listselected.length == 0\" ng-click=\" vm.deleteData()\"><md-icon ng-if=\"vm.listselected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listselected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex></span><form\n ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex><md-input-container md-no-float class=\"md-block\"><md-icon \nmd-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\"></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\">\n</md-input-container></form></div></md-toolbar><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"text-center\" width=\"1%\"></th><th class=\"text-center\" width=\"2%\" \ntranslate=\"TABLE.IDSHIFT\">IDSHIFT</th><th class=\"text-center\" width=\"10%\" translate=\"TABLE.SHIFT_TIME\">SHIFT TIME</th>\n<th class=\"text-center\" width=\"15%\" translate=\"TABLE.HALFDAY_DATE\">Halfday Date</th><th class=\"text-left\" \ntranslate=\"TABLE.DESCRIPTION\">Description</th><th class=\"text-center\" width=\"15%\" translate=\"TABLE.STATUS\">Status</th>\n<th class=\"text-center\" width=\"5%\"></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"(ls.approval==0)?vm.editData($event,ls.id):\'\'\"><td class=\"text-center\"><md-checkbox \nng-if=\"ls.approval_status==0 || ls.approval_status==1\" class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td class=\"text-center\">{{ls.idshift}}</td><td class=\"text-center\">{{ls.time_shift}}</td><td \nclass=\"text-center\">{{ls.dayname}} / {{ls.date}}</td><td class=\"text-left\">{{ls.description}}</td><td \nclass=\"text-center\"><span ng-if=\"ls.approval_status==1 || ls.approval_status==0\" \ntranslate=\"ATTENDANCE.LABEL.WAITINGAPPROVAL\">Waiting Approval</span> <span ng-if=\"ls.approval_status==2\" \ntranslate=\"KPI.LABEL.APPROVED\">Approved</span> <span ng-if=\"ls.approval_status==4\"><a href=\"\" \nng-click=\"vm.viewComment($event,ls)\" translate=\"MYPROFILE.MENU.REJECTED\">Rejected</a><md-tooltip md-direction=\"top\" \ntranslate=\"ATTENDANCE.LABRL.VIEWCOMMENT\">View Comment</md-tooltip></span></td><td class=\"text-center\"><md-menu-item>\n<md-button ng-click=\"vm.detail($event,ls)\" aria-label=\"View\"><md-icon class=\"blue-500-fg\" md-font-icon=\"icon-magnify\">\n</md-icon><span translate=\"ACTION.VIEW\">View</span></md-button></md-menu-item></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" \nclass=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></md-content></div>");
$templateCache.put("app/main/cb/emp-ghk-halfday/input.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.TITLE\">Form Input GHK</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.HALFDAY\">Halfday</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"halfday_date\" ng-model=\"vm.Form.objForm.halfday_date\" required ng-disabled=\"vm.disable\">\n</md-datepicker><div ng-messages=\"upnormalForm.holiday_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nHoliday Date Date is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"column\">\n<md-input-container flex><md-radio-group layout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" \nng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\" ng-disabled=\"vm.disable\"><md-radio-button \nvalue=\"group\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.GROUP\">Group</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"upnormalForm.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" ng-disabled=\"vm.disable\" \nng-change=\"vm.changeRefshift(vm.Form.objForm.locationid,vm.Form.objForm.holiday_date)\" ng-required=\"true\" \nname=\"location\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}</md-option></md-select>\n<div ng-messages=\"upnormalForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>Location harus di pilih.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.START_TIME\">Start Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" \nautocomplete=\"off\" required><div ng-messages=\"upnormalForm.start_time.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" \nng-model=\"vm.Form.objForm.end_time\" mask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" \nrequired><div ng-messages=\"upnormalForm.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\"><div class=\"row\"><div flex \nlayout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" flex \nng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\" ng-disabled=\"vm.disable\">\n{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button></div></div></md-radio-group><div \nng-messages=\"upnormalForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart Template is required.</span></div></div></md-input-container><div layout-gt-sm=\"column\"><md-input-container flex>\n<label translate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.DESCRIPTION\">Description</label><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" required ng-disabled=\"vm.disable\"><div \nng-messages=\"upnormalForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Description is required.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine || vm.listSelected.length <= 0\" translate=\"ACTION.SAVE\" \nng-if=\"!vm.edit\">Save</md-button><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Edit\" \ntranslate=\"ACTION.EDIT\" ng-click=\"vm.setEdit(false)\" ng-if=\"vm.edit && vm.disable && vm.canModify == 1\">Edit\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Udate\" translate=\"ACTION.UPDATE\" \nng-if=\"vm.edit && !vm.disable\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine || vm.listSelected.length <= 0\">Update</md-button>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Cancel\" translate=\"ACTION.CANCEL\" \nng-if=\"vm.edit && !vm.disable\" ng-click=\"vm.setEdit(true)\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/emp-join-holiday/emp-join-holiday.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span \ntranslate=\"MENU.CB.EMPLOYEE_JOIN_HOLIDAY.INDEX.HEADER.TITLE\">Employee Join Holiday</span></span></div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" layout-align=\"center start\">\n</div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div><md-fab-speed-dial \nmd-direction=\"left\" class=\"action-button md-scale\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-blue-500-bg\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.MENU\">Menu</span></md-tooltip><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button aria-label=\"Twitter\" class=\"md-fab md-raised md-mini\" \nui-sref=\"app.cb_cb_employe_join_holiday_input_join_holiday\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.INPUT_OT\">Input OT</span></md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" class=\"teal-800-fg\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>\n</div><div class=\"content\"><div class=\"simple-table-container\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\" \nrequired><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.tahun\" \nng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\" required><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" \nvalue=\"{{val.value}}\">{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex \nlayout-align=\"right right\"><md-button type=\"submit\" layout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon>Submit</md-button></md-input-container></div></form></div></div>\n</md-content><div id=\"attView\"><table class=\"simple striped\" ms-responsive-table style=\"margin-top:0\"><thead><tr><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.NO\">No</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th><span class=\"column-title\" translate=\"TABLE.NAME\">Name\n</span></th><th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.START_DATE\">Start Date</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.END_DATE\">End Date</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listData\"><td class=\"text-center\">{{ls.no}}</td><td class=\"text-center\">{{ls.nik }}</td><td>\n{{ls.empname }}</td><td class=\"text-center\">{{ls.start_time }}</td><td class=\"text-center\">{{ls.end_time}}</td><td \nclass=\"text-center\">{{ls.rest_hour}}</td></tr><tr ng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\">\n<span>No Data Available</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/cb/emp-ghk-holiday/emp-ghk-holiday.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.GHK_HOLIDAY\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\">\n<md-option ng-repeat=\"ls in vm.appstatus\" placeholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" \nvalue=\"{{ls.value}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"formInputOT.status.$error\" role=\"alert\"><div \nng-message=\"required\"><span>abs_code field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" flex=\"30\"></md-datepicker><div \nng-messages=\"formInputOT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" flex=\"30\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputGhk($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span translate=\"UMUT.MENU.NEW\">\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" \naria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i class=\"icon-delete\"></i> <span><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.InputGhk($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"UMUT.MENU.NEW\"></span></md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"UMUT.MENU.NEW\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listselected.length == 0\" ng-click=\" vm.deleteData()\"><md-icon ng-if=\"vm.listselected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listselected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.WORKING_DAY\">\nWorking Day</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.REPLACEMENT_TYPE\">Replacement Type</th><th \ntranslate=\"MENU.CB.GHK_HOLIDAY.TABLE.STARTSHIFT\">Start Shift</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.ENDSHIFT\">\nEnd Shift</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.HOLIDAY\">Holiday</th><th \ntranslate=\"MENU.CB.GHK_HOLIDAY.TABLE.REASON\">Reason</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.STATUS\">Status</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($event,ls.detail_id,ls.approval)\">\n<td><md-checkbox ng-if=\"ls.approval_status==0 || ls.approval_status==1\" class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td class=\"text-center\">{{ls.workdayname}} / {{ls.working_date}}</td><td class=\"text-leftr\">\n{{ls.replacementType}}</td><td class=\"text-center\">{{ls.istart_time}}</td><td class=\"text-center\">{{ls.iend_time}}</td>\n<td class=\"text-center\">{{ls.holiday}}</td><td class=\"text-left\">{{ls.reason}}</td><td class=\"text-center\"><span \nng-if=\"ls.approval_status==2\"><span translate=\"KPI.LABEL.APPROVED\"></span></span> <span ng-if=\"ls.approval_status==4\">\n<a href=\"\" ng-click=\"vm.viewComment($event,ls.approval)\"><span translate=\"MYPROFILE.MENU.REJECTED\"></span></a>\n<md-tooltip md-direction=\"top\"><span translate=\"ATTENDANCE.LABEL.VIEWCOMMENT\"></span></md-tooltip></span><span \nng-if=\"lsls.approval_status==0 || ls.approval_status==1\"><span translate=\"ATTENDANCE.LABEL.WAITINGAPPROVAL\"></span>\n</span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/emp-ghk-holiday/emp-ghk-holiday_bak.html","<div id=\"simple-table\" class=\"page-layout simple is-simple fullwidth doc-page element-doc-page ng-scope\"><div \nclass=\"header md-accent-bg layout-align-space-between-stretch layout-row\" layout=\"row\" layout-align=\"space-between\">\n<div layout=\"column\" layout-align=\"center start\" class=\"layout-align-center-start layout-column\"><div \nclass=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 md-default-theme md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon>\n<md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"parent\">C&B</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"parent\">GHK Holiday</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\">GHK Holiday</div><div id=\"attView\" \nclass=\"table-2 is-table-simple\"><md-toolbar md-theme=\"table-toolbar-theme\" class=\"has-toolbar-edit\"><div \nclass=\"md-toolbar-tools table-tools has-csm-input\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"is-md-accent md-raised reference-button md-accent md-hue-4\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputGhk($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New Shift 2</span>\n</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span>New\n</span></md-button><md-button class=\"is-md-warn md-raised reference-button md-warn md-hue-2\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.deleteData()\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Delete Shift lalla</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><table class=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr>\n<th>ahiw</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.DWS_CODE\">DWS Code</th><th \ntranslate=\"MENU.CB.GHK_HOLIDAY.TABLE.VARIAN\">Varian</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.HOLIDAY\">Holiday</th>\n<th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.WORKING_DAY\">Working Day</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.REASON\">\nReason</th><th translate=\"MENU.CB.GHK_HOLIDAY.TABLE.STATUS\">Status</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"(ls.approval==0)?vm.editData($event,ls.id):\'\'\"><td><md-checkbox \nng-if=\"ls.approval==0\" class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{ls.dws_code}}</td>\n<td>{{ls.variant}} Day</td><td>{{ls.holidayname}} / {{ls.holiday_date}}</td><td>\n{{ls.workdayname}} / {{ls.working_date}}</td><td>{{ls.reason}}</td><td><span ng-if=\"ls.approval==1\">Approved</span> \n<span ng-if=\"ls.approval==2\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip \nmd-direction=\"top\">View Comment</md-tooltip></span><span ng-if=\"ls.approval==0\">Waiting Aproval</span></td></tr>\n</tbody></table></div><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/cb/emp-ghk-holiday/inputghkholiday.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.TITLE\">\nForm Input GHK</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content>\n<div layout-gt-sm=\"row\"><md-input-container flex=\"50\"><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.WORKING_DAY\">\nWorking Day</label><input ng-if=\"vm.approval == 2\" type=\"text\" name=\"working_date\" \nng-model=\"vm.Form.objForm.kerjadate\" required ng-disabled=\"vm.approval == 2\"><md-select ng-if=\"vm.approval != 2\" \nng-model=\"vm.Form.objForm.kerjadate\" name=\"working_date\" ng-change=\"vm.changeWorkingDay()\" ng-required=\"vm.required\" \nng-disabled=\"vm.approval == 2\"><md-option ng-repeat=\"ls in vm.listworkingday\" value=\"{{ls.holiday_date}}\">\n{{ls.holiday_name}}</md-option></md-select><div ng-messages=\"formAbsence.working_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Working Date field is required.</span></div></div></md-input-container><md-input-container \nflex=\"50\"><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.HOLIDAY\">Holiday Date</label><input \nng-if=\"vm.approval == 2\" type=\"text\" name=\"working_date\" ng-model=\"vm.Form.objForm.holiday_date\" required \nng-disabled=\"vm.approval == 2\"><md-select ng-if=\"vm.approval != 2\" ng-model=\"vm.Form.objForm.holiday_date\" \nname=\"holiday_date\" ng-disabled=\"vm.approval == 2\"><md-option ng-repeat=\"ls in vm.listholiday\" \nvalue=\"{{ls.working_date}}\">{{ls.workingday_name}}</md-option></md-select><div \nng-messages=\"formAbsence.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking Date field is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"column\">\n<md-input-container flex><md-radio-group layout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" \nng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\"><md-radio-button value=\"group\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.GROUP\">Group</span></md-radio-button>\n&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" \nng-change=\"vm.changeRefshift(vm.Form.objForm.locationid,vm.Form.objForm.holiday_date)\" ng-required=\"true\" \nname=\"location\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}</md-option></md-select>\n<div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>Location harus di pilih.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.START_TIME\">Start Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" \nautocomplete=\"off\"><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\">\n<span>Max Length 2.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" \nng-model=\"vm.Form.objForm.end_time\" mask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\"><div\n ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>End time is required.</span>\n</div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex><md-radio-group \nng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\"><div class=\"row\"><div flex layout=\"column\" layout-padding \nlayout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.shiftcode\" \nclass=\"md-primary\" name=\"start_template\">{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button>\n</div></div></md-radio-group><div ng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Template is required.</span></div></div></md-input-container><div \nlayout-gt-sm=\"column\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.REASON\">Reason</label>\n<input type=\"text\" name=\"reason\" ng-model=\"vm.Form.objForm.reason\" required><div \nng-messages=\"formInputGhk.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div>\n</div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine\" translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SAVE\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employe-absence/employe-absence.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.EMPLOYE_ABSENCE\"></span></md-subheader><div class=\"white-bg\"><md-content\n class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.abs_code\" name=\"abs_code\">\n<md-option ng-repeat=\"ls in vm.listAbsenceType\" \nplaceholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.ABSENCE_TYPE\' | translate }}\" value=\"{{ls.abs_code}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"formInputOT.abs_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nabs_code field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.status\" name=\"status\"><md-option ng-repeat=\"ls in vm.appstatus\" \nplaceholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" value=\"{{ls.value}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"formInputOT.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nabs_code field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.start_date\" flex=\"30\"></md-datepicker><div ng-messages=\"formInputOT.start_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" flex=\"30\"></md-datepicker>\n<div ng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span>\n</md-input-container><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item ng-if=\"!vm.addDisabled\">\n<md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.cb_employe_absence_input_employe_absence\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"UMUT.MENU.NEW\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span><span translate=\"KPI.LABEL.DELETE\"></span></span></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"divider-vertical hide show-gt-sm\" ng-if=\"!vm.addDisabled\" hide show-gt-sm>\n</div><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nui-sref=\"app.cb_employe_absence_input_employe_absence\" ng-if=\"!vm.addDisabled\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"UMUT.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span><span \ntranslate=\"UMUT.MENU.NEW\"></span></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listselected.length == 0\" ng-click=\" vm.deleteData()\"><md-icon ng-if=\"vm.listselected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listselected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></span></th><th translate=\"MENU.CB.LEAVE.INDEX.TABLE.TYPE\" width=\"50px\">Type</th><th \ntranslate=\"MENU.CB.LEAVE.INDEX.TABLE.TYEP_NAME\" class=\"text-center\">Type Name</th><th \ntranslate=\"MENU.CB.LEAVE.INDEX.TABLE.START_DATE\" width=\"90px\">Start Date</th><th \ntranslate=\"MENU.CB.LEAVE.INDEX.TABLE.END_DATE\" width=\"90px\">End Date</th><th \ntranslate=\"MENU.CB.LEAVE.INDEX.TABLE.DURATION\">Duration</th><th translate=\"MENU.CB.LEAVE.INDEX.TABLE.START_TIME\" \nwidth=\"90px\">Start Time</th><th translate=\"MENU.CB.LEAVE.INDEX.TABLE.END_TIME\" width=\"90px\">End Time</th><th \ntranslate=\"MENU.CB.LEAVE.INDEX.TABLE.DESCRIPTION\" width=\"20%\">Description</th><th \ntranslate=\"MENU.CB.LEAVE.INDEX.TABLE.STATUS\" width=\"170px\">Status</th><th width=\"65px\"><span \ntranslate=\"KPI.LABEL.ACTION\"></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td><md-checkbox \nng-if=\"ls.approval_status==\'0\'\" class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">\n{{ls.absence_type}} <span ng-if=\"ls.other_type!=\'\'\" style=\"font-style: italic;font-size:12px;color:#000\"><br><br>\n{{ls.other_type}}</span></td><td class=\"\">{{ls.type_name}} <span ng-if=\"ls.approveother_typename!=\'\'\" \nstyle=\"font-style: italic;font-size:12px;color:#000\"><br><br>{{ls.approveother_typename}}</span></td><td \nclass=\"text-center\">{{ls.start_date}}</td><td class=\"text-center\">{{ls.end_date}}</td><td class=\"text-center\">\n{{ls.day}}</td><td class=\"text-center\">{{ls.start_time}}</td><td class=\"text-center\">{{ls.end_time}}</td><td \nclass=\"text-center\">{{ls.description}}</td><td class=\"text-center\"><span ng-if=\"ls.approval_status!=\'4\'\">\n{{ls.approval_type | uppercase}}: {{ls.status_name}}</span> <span ng-if=\"ls.approval_status==\'4\'\">\n{{ls.approval_type.toUpperCase()}}: <a href=\"\" ng-click=\"vm.viewComment($event,ls)\">{{ls.status_name}}</a><md-tooltip \nmd-direction=\"top\"><span translate=\"ATTENDANCE.LABEL.VIEWCOMMENT\"></span></md-tooltip></span></td><td \nclass=\"text-center\"><md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-if=\"ls.document_addres!==null\"><md-button \nng-click=\"vm.ViewDocument($event,ls.document_addres)\" aria-label=\"Refresh widget\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"teal-800-fg\"></md-icon><span translate=\"ATTENDANCE.LABEL.VIEWDOCUMENT\"></span></md-button></md-menu-item>\n<md-menu-item ng-if=\"ls.approval==\'Waiting Approval\' || ls.approval==\'Waiting HR Approval\'\"><md-button \nng-if=\"vm.group!=140\" class=\"md-button md-button-action md-ink-ripple\" \nng-if=\"ls.approval==\'Waiting Approval\' || ls.approval==\'Waiting HR Approval\'\" hide show-gt-sm \naria-label=\"Refresh widget\" ng-click=\"vm.resendMail($event,ls)\"><md-icon md-font-icon=\"icon-email\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ATTENDANCE.LABEL.RESENDEMAIL\"></span>\n<md-tooltip><span translate=\"ATTENDANCE.LABEL.RESENDEMAIL\"></span></md-tooltip></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"11\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employe-outlet-ot/employe-outlet-ot.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.EMPLOYEE_OUTLET_OT.INDEX.HEADER.TITLE\">Employe Outlet Overtime</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<label translate=\"TABLE.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSearchOTApproval.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.START_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label translate=\"TABLE.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"formSearchOTApproval.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.END_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" required><md-option \nng-repeat=\"val in vm.listType\" placeholder=\"{{ \'FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" placeholder=\"employee name / nik\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\">\n</md-input-container><md-button type=\"button\" class=\"md-mini md-raised md-primary\" ng-disabled=\"vm.searchComplete\" \nng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>\n<span translate=\"FILTER.SEARCH\">Search</span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.cb_employe_outlet-ot_input_emp_outlet_ot\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.NEW\">New</span></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon><span translate=\"ACTION.DELETE\">Delete</span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nui-sref=\"app.cb_employe_outlet-ot_input_emp_outlet_ot\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\n<span translate=\"ACTION.NEW\">New</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.NEW\">New</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.deleteData($event)\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Delete Shift</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><span flex hide show-gt-sm></span>\n</div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th></th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.NIKNAME\">Nik/Name</th><th translate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.TYPE\">\nType</th><th translate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.DATE\">Date</th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.START_TIME\">Start Time</th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.END_TIME\">End Time</th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.REST_HOUR\">Rest Hour</th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.REASON\">Reason</th><th translate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.STATUS\">\nStatus</th><th></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td><md-checkbox \nng-if=\"ls.allowcontroll\" class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>\n{{ls.emp_ot}}/{{ls.emp_ot_name}}</td><td>{{ls.ot_type}}</td><td>{{ls.ot_date}}</td><td>{{ls.start_time}}</td><td>\n{{ls.end_time}}</td><td>{{ls.rest_hour}}</td><td>{{ls.reason}}</td><td>\n{{ls.approval_status_name}} by {{ls.lastStatusByName}} <span ng-if=\"ls.reject_comment !=null && ls.reject_comment!=\'\'\">\n{{ls.reject_comment}}</span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employe-break-finger/employe-break-finger.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Employee Break Finger</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmBreakFinger\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><md-select ng-model=\"vm.company\" ng-disabled=\"vm.budisabled\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmBreakFinger.company.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Sub Area</label><md-select ng-model=\"vm.subarea\" name=\"subarea\" \nng-change=\"vm.loadBuilding(vm.subarea)\" required><md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"Subarea\" \nvalue=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.building\" ng-disabled=\"vm.typedisabled\" name=\"building\"><md-option \nng-repeat=\"ls in vm.listBuilding\" placeholder=\"Building List\" value=\"{{ls.id}}\">{{ls.name | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmBreakFinger.building.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBuilding field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.employeeType\" ng-disabled=\"vm.typedisabled\" name=\"employeeType\" required><md-option \nng-repeat=\"ls in vm.typeEmp\" placeholder=\"Employee Type\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmBreakFinger.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nplaceholder=\"employee name / nik\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container>\n<md-input-container flex><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" \nng-disabled=\"frmBreakFinger.$invalid || frmBreakFinger.$pristine\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></md-input-container></div>\n</form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm class=\"md-primary-bg\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-green-300-bg md-raised md-primary white-fg\" \nng-click=\" vm.uploadData($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload Data</md-tooltip>\n<md-icon md-font-icon=\"icon-upload\" class=\"teal-800-fg\"></md-icon>Upload Data</md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmBreakFinger.$invalid || frmBreakFinger.$pristine\"></select></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" ng-click=\" vm.uploadData($event)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Upload Data</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-800-fg\"></md-icon>Upload Data</md-button></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\"><thead><tr><th width=\"40\" class=\"text-center\">NIK</th><th class=\"text-center\">NAME</th><th \nwidth=\"40\" class=\"text-center\">EFFECTIVE DATE</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nclass=\"text-center\">{{ls.nik}}</td><td>{{ls.full_name}}</td><td class=\"text-center\">{{ls.effective_date}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employe-break-finger/upload-form.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/employe-overtime-gw/create.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span translate=\"MENU.CB.EMPLOYEE_OT_GW.FORM_INPUT.TITLE\">Input Employe Overtime GW</span> \n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content \nng-init=\"vm.setForm(upnormalForm)\"><div layout-gt-sm=\"row\"><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.ot_type\" ng-disabled=\"vm.disable || vm.isEdit || vm.hasApprove\" ng-required=\"true\" \nname=\"ot_type\" ng-click=\"vm.getEmployelist()\"><md-radio-button value=\"NORMAL\" name=\"ot_type\" class=\"md-warn md-raised\">\n<span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.NORMAL\">NORMAL</span></md-radio-button>&nbsp;&nbsp;<md-radio-button \nvalue=\"KHL\" name=\"ot_type\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.KHL\">KHL</span>\n</md-radio-button></md-radio-group><div ng-messages=\"upnormalForm.ot_type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Type is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.OVETIME_DATE\">Overtime Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-disabled=\"vm.disable || vm.canDelete==0 || vm.hasApprove\" name=\"ot_date\" \nng-model=\"vm.Form.objForm.ot_date\" required ng-change=\"vm.getEmployelist()\"></md-datepicker><div \nng-messages=\"upnormalForm.ot_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>OT Date is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Start Time (tanggal/bulan/tahun jam:menit)</label>\n<input type=\"text\" name=\"start_time\" ng-model=\"vm.Form.objForm.start_time\" ng-max=\"24\" ng-disabled=\"vm.disable\" \nmask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" required><div \nng-messages=\"upnormalForm.start_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start time is required.\n</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span>\n</div></div></md-input-container><md-input-container flex><label>End Time (tanggal/bulan/tahun jam:menit)</label><input\n type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" ng-disabled=\"vm.disable\" \nmask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" required><div \nng-messages=\"upnormalForm.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>End time is required.</span>\n</div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"20\"><label \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.REST_HOURS\">Rest Hours</label><input type=\"number\" ng-min=\"vm.minHour\" \nname=\"resthour\" ng-model=\"vm.Form.objForm.resthour\" ng-disabled=\"vm.disable || vm.hasApprove\" required><div \nng-messages=\"upnormalForm.resthour.$error\" role=\"alert\"><div ng-message=\"required\"><span>Rest Hour is required.</span>\n</div><div ng-message=\"min\"><span>Rest Hour minimum is {{vm.minHour}} hour</span></div></div></md-input-container>\n<md-input-container flex=\"80\"><input type=\"text\" name=\"reason\" ng-model=\"vm.Form.objForm.reason\" \nplaceholder=\"{{ \'MENU.CB.EMPLOYEE_OT.FORM_INPUT.REASON\' | translate }}\" required \nng-disabled=\"vm.disable || vm.hasApprove\"><div ng-messages=\"upnormalForm.reason.$error\" role=\"alert\"><div \nng-message=\"required\"><span>reason is required.</span></div></div></md-input-container></div><label \nng-if=\"vm.Form.objForm.ot_type==\'NORMAL\'\" translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.QUESTION\">\nApakah overtime setelah atau sebelum jam kerja?</label><md-input-container ng-if=\"vm.Form.objForm.ot_type==\'NORMAL\'\" \nflex><md-radio-group ng-model=\"vm.Form.objForm.isafter\" ng-disabled=\"vm.disable || vm.hasApprove\" ng-required=\"true\" \nname=\"isafter\"><md-radio-button value=\"1\" name=\"isafter\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.AFTER_TIME\">setelah jam kerja normal</span></md-radio-button>&nbsp;&nbsp;\n<md-radio-button value=\"0\" name=\"isafter\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BEFORE_TIME\">sebelum jam kerja normal</span></md-radio-button>\n<md-radio-button value=\"2\" name=\"isafter\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BEFORE_AND_AFTER_TIME\">sebelum dan setelah jam kerja normal</span>\n</md-radio-button></md-radio-group><div ng-messages=\"upnormalForm.isafter.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Type is required.</span></div></div></md-input-container><div layout=\"row\"><div \nlayout=\"column\" flex=\"50\"><fieldset style=\"min-height: 550px\"><legend>List Employee</legend><table \nclass=\"with-toolbar dataTable row-border hover simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th width=\"5%\" class=\"text-center\"><md-checkbox \nclass=\"no-label\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\" \nng-disabled=\"vm.disable || vm.hasApprove\"></md-checkbox></th><th width=\"15%\" class=\"text-center\" translate=\"TABLE.NIK\">\nNIK</th><th class=\"text-left\" translate=\"TABLE.NAME\">Name</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.items\" \nng-click=\"vm.toggleCheck(ls, $event)\" style=\"height: 24px !important\"><td width=\"5%\" class=\"text-center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" ng-disabled=\"vm.disable || vm.hasApprove\"></md-checkbox></td><td \nwidth=\"15%\">{{ls.nik}}</td><td class=\"text-left\">{{ls.name}}</td></tr></tbody><tfoot><tr><td colspan=\"3\" \nclass=\"text-right\"><md-button class=\"md-secondary\" ng-disabled=\"vm.disable && vm.listSelected.length <= 0\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.AddEmployeeList()\" class=\"md-button\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"blue-500-fg\"></md-icon><md-tooltip md-direction=\"top\">Add Employee</md-tooltip>\n</md-button></td></tr></tfoot></table></fieldset></div><div layout=\"column\" flex=\"50\"><fieldset \nstyle=\"height: 550px;overflow-y: scroll\"><legend>List Employee Selected</legend><div layout=\"column\" \nng-repeat=\"sel in vm.empSelected track by $index\"><md-list-item class=\"md-primary\" style=\"max-height:24px !important\">\n<div class=\"md-list-item-text\"><span>{{$index+1}}. {{sel.nik}}-{{sel.nama}}</span></div><md-button \nclass=\"md-secondary\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.removeEmployee(sel)\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-if=\"vm.isStatus(sel) == \'Waiting Approval\' || vm.isStatus(sel) == \'-\'\">\n<md-icon md-font-icon=\"icon-minus\" class=\"red-500-fg\"></md-icon><md-tooltip md-direction=\"top\">Remove Employee\n</md-tooltip></md-button></md-list-item></div></fieldset></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine || vm.empSelected.length <= 0\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SAVE\" ng-if=\"!vm.edit\">Save</md-button><md-button type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Edit\" translate=\"ACTION.EDIT\" ng-click=\"vm.setEdit(false)\" \nng-if=\"vm.edit && vm.disable\">Edit</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Udate\" \ntranslate=\"ACTION.UPDATE\" ng-if=\"vm.edit && !vm.disable\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine || vm.empSelected.length <= 0\">Update</md-button>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Cancel\" translate=\"ACTION.CANCEL\" \nng-if=\"vm.edit && !vm.disable\" ng-click=\"vm.setEdit(true)\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employe-overtime-gw/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.OVERTIME_GW\">Employee Overtime Gw</span></md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"Year\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\" required><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" \nvalue=\"{{val.value}}\">{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.type\" name=\"type\" required><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.EMPLOYEE_OT.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Overtime Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.workingDate\" md-placeholder=\"Overtime Date\" required name=\"Overtime Date\">\n</md-datepicker><div ng-messages=\"frmEmploye.workingDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Harus Diisi.</span></div></div></md-input-container><md-input-container layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" ng-disabled=\"vm.searchComplete\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.SEARCH\">\nSearch</span></md-button></md-input-container></div></form></div></div></md-content><div layout=\"column\" \nlayout-align=\"start left\" flex><label><span>Current Period : {{vm.periode}}</span></label><label><span>\nOvertime Consumption : {{vm.currentot}} Hours </span></label><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.InputGhk($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Upload($event)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-primary md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span>Search Employee</span>\n</md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" \naria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i class=\"icon-delete\"></i> <span \nng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" translate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span \nng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\" translate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span \nng-if=\"vm.listselected.length > 0\">{{ vm.listselected.length }} selected</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div\n class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.InputGhk($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n<span translate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span translate=\"\">Search Employee\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData()\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-500-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} selected</span></md-button><span flex></span><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"1%\" class=\"text-center\"></th>\n<th width=\"5%\" class=\"text-center\" translate=\"TABLE.TYPE\">Type</th><th width=\"10%\" class=\"text-center\" \ntranslate=\"TABLE.DATE\">Date</th><th width=\"5%\" class=\"text-center\" translate=\"TABLE.START_TIME\">Start Time</th><th \nwidth=\"5%\" class=\"text-center\" translate=\"TABLE.END_TIME\">End Time</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"TABLE.REST_HOUR\">Rest Hour</th><th class=\"text-left\" translate=\"TABLE.REASON\">Reason</th><th width=\"15%\" \nclass=\"text-left\" translate=\"TABLE.REQUEST_BY\">Requst By</th><th width=\"15%\" class=\"text-left\" \ntranslate=\"TABLE.STATUS\">Status</th><th width=\"5%\" class=\"text-center\" translate=\"TABLE.ACTION\">Action</th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"(ls.approval==0)?vm.editData($event,ls.id):\'\'\"><td>\n<md-checkbox ng-if=\"ls.can_delete==1\" class=\"no-label\" ng-checked=\"vm.exists(ls, vm.listselected)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td class=\"text-center\">{{ls.ot_type}}</td><td class=\"text-center\">{{ls.ot_date}}</td><td \nclass=\"text-center\">{{ls.start_time}}</td><td class=\"text-center\">{{ls.end_time}}</td><td class=\"text-center\">\n{{ls.rest_hour}}</td><td class=\"text-left\">{{ls.reason}}</td><td class=\"text-left\">{{ls.requestname}}</td><td \nclass=\"text-left\"><span>{{ls.total_waiting}} Waiting Aproval of {{ ls.total_all }}</span></td><td class=\"text-center\">\n<md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Click for view action</md-tooltip><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" aria-label=\"View\"><md-icon class=\"blue-500-fg\" \nmd-font-icon=\"icon-magnify\"></md-icon><span translate=\"ACTION.VIEW\">View</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.detailApproval($event,ls)\" aria-label=\"View\"><md-icon class=\"blue-500-fg\" \nmd-font-icon=\"icon-table\"></md-icon>Approval Detail</md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></div></md-content>\n</div>");
$templateCache.put("app/main/cb/employe-overtime-gw/search-employee.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"searcEmployee\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,searcEmployee)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span>Search Employee</span> <span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\">\n</md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\"><md-input-container flex><label>Overtime Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"ot_date\" ng-model=\"vm.ot_date\" required></md-datepicker><div \nng-messages=\"searcEmployee.ot_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Working Date is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" placeholder=\"employee name / nik\" \nng-model=\"vm.nik\" id=\"formSearch\"></md-input-container><md-input-container layout=\"column\" layout-align=\"right right\">\n<md-button type=\"button\" ng-disabled=\"(searcEmployee.$invalid || searcEmployee.$pristine)\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"MENU.CB.APPROVAL_OT.INDEX.FILTER.SEARCH\">\nSearch</span></md-button></md-input-container></div><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-left\">Nik/Name</th><th class=\"text-left\">Shift</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.items\" \nng-dblclick=\"vm.detail($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Double Click for Edit\n</md-tooltip><td class=\"text-center\">{{ls.nik}}-{{ls.name}}</td><td>{{ls.iStart_time}} s/d {{ls.iEnd_time}}</td></tr>\n<tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Back\" translate=\"ACTION.BACK\" \nng-click=\"vm.closeModal()\">Back</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employe-overtime-gw/upload.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.SUBMIT\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/employe-shift/employe-shift.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.EMPLOYEE_SHIFT.INDEX.HEADER.TITLE\">Employe Shift</span></md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\" required><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\" class=\"mt-40\"><md-input-container \nflex><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"formInputOT.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" \nng-model=\"vm.end_date\"></md-datepicker><div ng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" placeholder=\"{{ \'FILTER.NIK_NAME\' | translate }}\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon\n class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"FILTER.SEARCH\">\nSearch</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" \nng-click=\"vm.uploadShift($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.UPLOAD_SHIFT\">Upload Shift</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-800-fg\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm \nng-click=\" vm.uploadShift($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.UPLOAD_SHIFT\">Upload Shift</span></md-tooltip><span translate=\"ACTION.UPLOAD_SHIFT\">Upload Shift\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm ng-click=\" vm.uploadShiftNonGroup($event)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.UPLOAD_SHIFT_NONGROUP\">\nUpload Shift Non Group</span></md-tooltip><span translate=\"ACTION.UPLOAD_SHIFT_NONGROUP\">Upload Shift Non Group</span>\n</md-button><span flex hide show-gt-sm></span><md-button aria-label=\"Twitter\" \nclass=\"md-icon-button md-primary md-button md-default-theme md-ink-ripple\" hide show-gt-sm \nng-click=\" vm.unsetShiftDetail(vm.unsetShift, $event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\n<span translate=\"ACTION.VIEW_DETAIL\">Show Details</span></md-tooltip><md-icon md-font-icon=\"icon-document\" \nclass=\"teal-800-fg\"></md-icon></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"inputTable\"><thead><tr><th class=\"text-center\">\n<span class=\"column-title\" translate=\"TABLE.EMPLOYE_NAME\">Employe Name</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.DATE_WORKING\">Date Working</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.DWS_CODE\">DWS Code</span></th><th class=\"text-center\"><span class=\"column-title\">\nTIME SHIFT</span></th><th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.ACTION\">Action</span></th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\">{{ls.empName}}</td><td \nclass=\"text-center\">{{ls.tgl}}</td><td class=\"text-center\">{{ls.idshift}}</td><td class=\"text-center\">{{ls.timeShift}}\n</td><td class=\"text-center\"><span><md-button class=\"md-icon-button\" aria-label=\"Favorite\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.DeleteData($event,ls)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-500-fg\"></md-icon><md-tooltip><span>click for delete</span></md-tooltip></md-button></span></td></tr>\n</tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employe-shift/input-employe-shift.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"locationForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,locationForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.EMPLOYEE_SHIFT.FORM.TITLE\">Form Input Employe Shift</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-autocomplete flex md-no-cache=\"vm.noCache\" md-selected-item=\"vm.emp_id\" \nmd-search-text=\"vm.emp_name\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-items=\"item in vm.querySearch(vm.emp_name)\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-min-length=\"3\" md-input-name=\"emp_id\" md-item-text=\"item.emp_nama\" md-floating-label=\"Employe Name\">\n<md-item-template><span md-highlight-text=\"vm.searchString\">{{item.emp_nama}}</span></md-item-template>\n</md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.EMPLOYEE_SHIFT.FORM.LOCATION\">Location</label><md-select ng-model=\"vm.Form.objForm.location\" \nng-required=\"true\" name=\"location\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.locationshiftname}}\n</md-option></md-select><div ng-messages=\"locationForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLocation harus di pilih.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.EMPLOYEE_SHIFT.FORM.EFFECTIVE_DATE\">Effective Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"locationForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\neffective_date Date is required.</span></div></div></md-input-container></div><div class=\"md-title\" \ntranslate=\"MENU.CB.EMPLOYEE_SHIFT.FORM.START_TEMPLATE\">Start Template</div><div layout-gt-sm=\"row\"><md-input-container \nflex><md-radio-group ng-model=\"vm.Form.objForm.starttemplate\" ng-required=\"true\" name=\"starttemplate\"><md-radio-button \nvalue=\"1\" name=\"starttemplate\" class=\"md-warn md-raised\">Shift 1</md-radio-button>&nbsp;&nbsp;<md-radio-button \nvalue=\"2\" name=\"starttemplate\" class=\"md-warn md-raised\">Shift 2</md-radio-button><md-radio-button value=\"3\" \nname=\"starttemplate\" class=\"md-warn md-raised\">Shift 3</md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.starttemplate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Day Type is required.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"locationForm.$invalid || locationForm.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employe-shift/unset-shift.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"locationForm\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2 translate=\"MENU.CB.EMPLOYEE_SHIFT.DETAIL.TITLE\">List Detail Unset Shift</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><th translate=\"TABLE.NIK\">NIK</th><th translate=\"TABLE.NAME\">Name</th><th \ntranslate=\"TABLE.JOIN_DATE\">Join Date</th><th translate=\"TABLE.EFFECTIVE_DATE\">Effective Date</th><th \ntranslate=\"TABLE.TOTAL_INCOMPLETE\">Total Incomplete</th></thead><tbody><tr ng-repeat=\"lsd in vm.data\"><td>{{lsd.nik}}\n</td><td>{{lsd.name}}</td><td>{{lsd.joinDate}}</td><td>{{lsd.effective_date}}</td><td>{{lsd.totalIncomplete}}</td></tr>\n</tbody></table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/employe-shift/upload-shift-ng.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.EMPLOYEE_SHIFT.UPLOAD.TITLE_NONGROUP\">Upload Shift Non Group</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" class=\"md-inline-form\" flex novalidate><fieldset><legend>\nFormat file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD \">Upload</span></md-button><span flex></span>\n<md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span>\n</md-button><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/employe-shift/upload-shift.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.EMPLOYEE_SHIFT.UPLOAD.TITLE\">Upload Shift</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-padding><form name=\"basicForm\" class=\"md-inline-form\" flex novalidate><fieldset><legend>\nFormat file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD \">Upload</span></md-button><md-button \ntype=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/employe-overtime/employe-overtime.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.EMPLOYE_OVERTIME\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"TABLE.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSearchOTApproval.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.START_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label translate=\"TABLE.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"formSearchOTApproval.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.END_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" required><md-option \nng-repeat=\"val in vm.listType\" placeholder=\"{{ \'MENU.CB.EMPLOYEE_OT.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" \nvalue=\"{{val}}\">{{val | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" placeholder=\"{{ \'KPI.LABEL.NIK\' | translate}} / {{ \'KPI.LABEL.NAME\' | translate}}\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" ng-click=\"vm.loadData(1)\" ng-disabled=\"vm.searchComplete\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>\n{{ \'PAYROLL.MENU.SEARCH\' | translate}}</span></md-button></div></form></div></div></md-content><div \nclass=\"form-wrapper-period\" layout=\"column\" layout-align=\"start left\" flex><label><span>\n{{ \'ATTENDANCE.LABEL.CURRENTPERIOD\' | translate}} : <b>{{vm.periode}}</b></span></label><label><span>\n{{ \'ATTENDANCE.LABEL.OVERTIMECONSUMPTION\' | translate}} : <b>{{vm.currentot}} {{ \'ATTENDANCE.LABEL.HOUR\' | translate}}\n</b> </span></label></div><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>\n{{ \'KPI.LABEL.ENTRIES\' | translate}}</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ui-sref=\"app.cb_employe_overtime_input_employe_ot\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon><span>{{ \'UMUT.MENU.NEW\' | translate}}</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span>{{ \'KPI.LABEL.DELETE\' | translate}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ui-sref=\"app.cb_employe_overtime_input_employe_ot\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>{{ \'UMUT.MENU.NEW\' | translate}}</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span>\n{{ \'UMUT.MENU.NEW\' | translate}}</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listselected.length == 0\" ng-click=\" vm.deleteData()\"><md-icon ng-if=\"vm.listselected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listselected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide \nshow-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th></th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.NIKNAME\">Nik/Name</th><th translate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.TYPE\">\nType</th><th translate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.DATE\">Date</th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.START_TIME\">Start Time</th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.END_TIME\">End Time</th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.REST_HOUR\">Rest Hour</th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.REASON\">Reason</th><th translate=\"MENU.CB.EMPLOYEE_OT.INDEX.TABLE.STATUS\">\nStatus</th><th></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td><md-checkbox \nng-if=\"ls.allowcontroll\" class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>\n{{ls.emp_ot}}/{{ls.emp_ot_name}}</td><td>{{ls.ot_type}}</td><td>{{ls.ot_date}}</td><td>{{ls.start_time}}</td><td>\n{{ls.end_time}}</td><td>{{ls.rest_hour}}</td><td>{{ls.reason}}</td><td>\n{{ls.approval_status_name}} by {{ls.lastStatusByName}} <span ng-if=\"ls.reject_comment !=null && ls.reject_comment!=\'\'\">\n{{ls.reject_comment}}</span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>\n<style type=\"text/css\">.btn-ui-serif {\n    line-height: 3.8rem !important;\n  }</style>");
$templateCache.put("app/main/cb/employe-overtime/employeeot-team.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"ATTENDANCE.LABEL.VIEWEMPLOYEEOT\"></span></h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><table \nclass=\"simple\" ms-responsive-table id=\"inputTable\"><thead><tr><th><span translate=\"KPI.LABEL.NO\"></span></th><th><span \ntranslate=\"KPI.LABEL.NIK\"></span></th><th><span translate=\"KPI.LABEL.NAME\"></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listtime track by $index\"><td>{{$index+1}}</td><td>{{ls.nik}}</td><td>{{ls.nama}}</td></tr></tbody>\n</table></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/employe-shift-unschedule/employe-shift-unschedule.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.EMPLOYEE_SHIFT_UNSCHEDULE.INDEX.HEADER.TITLE\">Employe Shift Unschedule</span>\n</md-subheader><div class=\"white-bg\"><md-toolbar class=\"open-toolbar\"><div class=\"md-toolbar-tools table-tools\"><span \nflex hide show-gt-sm></span><md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" \nname=\"tahun\" required><md-option ng-repeat=\"val in vm.listtahun\" placeholder=\"Year\" value=\"{{val}}\">{{val}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\" \nrequired><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Bulan field is required.</span></div></div></md-input-container></div></md-toolbar><md-toolbar class=\"mt-10\"><div\n class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" \nng-click=\"vm.uploadShiftUnschedule($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.UPLOAD_SHIFT_UNSCHEDULE\">Upload Shift Unschedule</span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-800-fg\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.uploadShiftUnschedule($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.UPLOAD_SHIFT_UNSCHEDULE\">Upload Shift Unschedule</span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"ACTION.UPLOAD_SHIFT_UNSCHEDULE\">Upload Shift Unschedule</span></md-button><div class=\"\" \nss=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"inputTable\"><thead><tr><th class=\"text-center\">\n<span class=\"column-title\" translate=\"TABLE.NIK\">Nik</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.NAME\">Name</span></th><th class=\"text-center\"><span class=\"column-title\">Total</span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\" width=\"10%\">{{ls.nik}}</td><td><div \nlayout=\"row\"><span flex>{{ls.name}}</span> <span flex=\"10\"></span> <span flex=\"nogrow\" ng-if=\"vm.cekStatus(ls.status)\">\n(Parttime)</span> <span flex=\"nogrow\" ng-if=\"ls.new_data == \'1\'\" class=\"label md-blue-500-bg font-size-10\" \nstyle=\"padding: 2px 5px\">NEW!</span></div></td><td class=\"text-center\" width=\"10%\" temp=\"{{ls.total}}\"><span \nng-if=\"ls.total * 1 > 0\"><a href=\"\" ng-click=\"vm.viewDetail(ls.nik,ls.name,vm.bulan,vm.tahun,ls.status,$event)\">\n{{ls.total}}</a><md-tooltip md-direction=\"top\">View Detail</md-tooltip></span><span ng-if=\"ls.total * 1 == 0\">\n{{ls.total}}</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0 || (vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody><tbody></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/cb/employe-shift-unschedule/upload-shift-unschedule.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\" flex-gt-sm=\"{{vm.width}}\"><md-toolbar flex><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.EMPLOYEE_SHIFT_UNSCHEDULE.UPLOAD.INDEX.HEADER.TITLE\">\nUpload Shift Unschedule</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\"><div layout=\"column\" layout-padding flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span \nng-bind-html=\"vm.splitNotif(vm.uploadNotif)\"></span></div></div></form></div><span flex=\"5\" ng-if=\"vm.isMoreInfo\">\n</span><div layout=\"column\" ng-if=\"vm.isMoreInfo\" flex ng-class=\"vm.isMoreInfo ? \'ml-10\' : \'\'\"><table \nclass=\"with-toolbar bordered stripped full-width\" style=\"border-collapse: collapse\" ms-responsive-table><thead><tr><th \nclass=\"text-center pv-5 ph-10 md-red-500-bg border\">NIK</th><th class=\"text-center pv-5 ph-10 md-red-500-bg border\">\nFailed Note</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.detailInfo\"><td class=\"text-center pv-5 ph-10 border\">\n{{ls.nik}}</td><td class=\"text-left pv-5 ph-10 border\">{{ls.note}}</td></tr></tbody></table></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.uploadProcess()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD \">Upload</span></md-button><span flex></span>\n<md-button type=\"button\" ng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span>\n</md-button><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/employe-shift-unschedule/view-detail.html","<div class=\"md-dialog-container\" id=\"ShiftDialog\" layout=\"row\" flex><md-dialog flex=\"80\" aria-label=\"Mango (Fruit)\" \nlayout=\"column\" style=\"height: 90%\"><form ng-cloak class=\"popup-input-form\" layout=\"column\" flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"content-wrapper\" flex style=\"padding: 0 !important\">\n<div layout=\"column\" layout-fill class=\"content\"><md-toolbar md-scroll-shrink class=\"md-grey-200-bg mb-5\"><div \nclass=\"md-toolbar-tools md-grey-200-bg\"><h4 flex=\"20\" class=\"md-input-container\"><b>NIK</b>: {{vm.nik}}</h4><h4 flex \nclass=\"md-input-container\"><b>Name</b>: {{vm.name}}</h4><h4 flex=\"nogrow\" class=\"md-input-container\" \nng-if=\"vm.cekStatus(vm.status)\">Parttime</h4></div></md-toolbar><div class=\"scrollable\" flex layout=\"column\" ms-scroll>\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"20%\" \nclass=\"text-center\"><span class=\"column-title\">Date</span></th><th width=\"40%\" class=\"text-center\"><span \nclass=\"column-title\">Start Time</span></th><th width=\"40%\" class=\"text-center\"><span class=\"column-title\">End Time\n</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span><b>{{ls.date}}\n</b></span></td><td class=\"text-center\"><span ng-bind-html=\"\'<b>\' + ls.start_date + \'</b> \' + ls.start_time\"></span>\n</td><td class=\"text-center\"><span ng-bind-html=\"\'<b>\' + ls.end_date + \'</b> \' + ls.end_time\"></span></td></tr><tr \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"4\" class=\"text-center\"><span>No Data Available</span></td></tr>\n</tbody></table></div><div class=\"p-24 mb-0 pb-0 is-bottom-nav bt\" layout=\"row\" layout-align=\"space-between center\">\n<span ng-if=\"vm.DataTable.list.length > 0\" class=\"tbl-info\">{{vm.DataTable.info}}</span></div></div>\n</md-dialog-content></form></md-dialog></div>");
$templateCache.put("app/main/cb/employe-shift-migrate/employe-shift-migrate.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.EMPLOYEE_SHIFT.INDEX.HEADER.TITLE\">Employe Shift</span></md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.objGedung\" aria-label=\"Building\" name=\"gedung\" ng-change=\"vm.getSector(vm.objGedung)\">\n<md-option ng-repeat=\"ls in vm.listGedung\" placeholder=\"Building\" value=\"{{ls}}\">{{ls.gedung_name}}</md-option>\n</md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.sector\" name=\"sector\" \naria-label=\"Sector\"><md-option ng-repeat=\"ls in vm.listSector\" placeholder=\"Sector\" value=\"{{ls.sector_id}}\">\n{{ls.sector_name}}</md-option></md-select><div ng-messages=\"formInputOT.sector.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sector is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"FILTER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\" required></md-datepicker><div ng-messages=\"formInputOT.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" \nng-model=\"vm.end_date\" required></md-datepicker><div ng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" placeholder=\"{{ \'FILTER.NIK_NAME\' | translate }}\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"FILTER.SEARCH\">Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill style=\"overflow: hidden\" class=\"white-bg\"><table class=\"simple with-toolbar bordered\" \nms-responsive-table id=\"\"><thead><tr><th ng-repeat=\"col in vm.header track by $index\">{{col}}</th></tr></thead><tbody>\n<tr ng-repeat=\"row in vm.DataTable.list track by $index\"><td ng-repeat=\"col in row track by $index\"><div \nng-if=\"vm.isObject(col)===true\"><a href=\"\" ng-click=\"vm.viewDetail(col,$event)\"><span ng-bind-html=\"col.name\"></span>\n</a><md-tooltip md-direction=\"top\">View Detail</md-tooltip></div><div ng-if=\"vm.isObject(col)===false\"><span \nng-bind-html=\"col\"></span></div></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employe-shift-migrate/view-detail.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"70\"><form ng-cloack name=\"frmShiftMigrate\" \nng-submit=\"vm.update($event, frmShiftMigrate)\" class=\"md-inline-form popup-input-form\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>View Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\"><span \nclass=\"column-title\">Actual</span></th><th class=\"text-center\"><span class=\"column-title\">Action</span></th><th \nclass=\"text-center\"><span class=\"column-title\">System</span></th></tr></thead><tbody><tr><td class=\"text-center\"><span>\n{{vm.items.new_value.shift_actual}}</span></td><td class=\"text-center\"><button \nclass=\"md-accent md-raised md-hue-1 md-button md-ink-ripple\" type=\"submit\"><i class=\"icon-arrow-right-bold\"></i>\n<md-tooltip md-direction=\"top\">Ubah shift time system dengan actual</md-tooltip></button></td><td class=\"text-center\">\n<span>{{vm.items.old_value.shift_system}}</span></td></tr></tbody></table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/employee-alert/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.EMPLOYEEALERT.HEADER\">Employee Alert</span></md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"val in vm.listPeriod\" placeholder=\"Period\" value=\"{{val.id}}\">{{val.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\"><md-option \nng-repeat=\"val in vm.listType\" placeholder=\"Emp Type\" value=\"{{val.id}}\">{{val.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.flagApp\" name=\"flagApp\"><md-option \nng-repeat=\"val in vm.listFlagApp\" placeholder=\"Emp Status\" value=\"{{val.id}}\">{{val.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.laborType\" name=\"laborType\"><md-option \nng-repeat=\"val in vm.listLaborType\" placeholder=\"Labor Type\" value=\"{{val.id}}\">{{val.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.alertType\" name=\"alertType\"><md-option \nng-repeat=\"val in vm.listAlertType\" placeholder=\"Alert Type\" value=\"{{val.id}}\">{{val.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.alertStatus\" name=\"alertStatus\"><md-option \nng-repeat=\"val in vm.listAlertStatus\" placeholder=\"Alert Status\" value=\"{{val.id}}\">{{val.name}}</md-option>\n</md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.costCenterGroup\" \nname=\"costCenterGroup\"><md-option ng-repeat=\"val in vm.listCostCenterGroup\" placeholder=\"Area\" value=\"{{val.id}}\">\n{{val.name}}</md-option></md-select></md-input-container><md-input-container layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" class=\"md-mini md-raised md-primary\" aria-label=\"search\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.SEARCH\">Search</span></md-button></md-input-container></div></form></div>\n</div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.processData($event)\"><span translate=\"MENU.CB.EMPLOYEEALERT.PROCESS\">Process</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical\" hide \nshow-gt-sm></div><div class=\"divider-vertical\" hide show-gt-sm></div><div><span style=\"color:#000000\">\nHeadcount : &nbsp;&nbsp;</span></div><div ng-repeat=\"item in vm.headcount\"><div class=\"text-center alert-button\" \nng-if=\"item.color==\'green\'\" id=\"green-box\"><span style=\"color:#000000\">{{item.total}}</span></div><div \nclass=\"text-center alert-button\" ng-if=\"item.color==\'yellow\'\" id=\"yellow-box\"><span style=\"color:#000000\">\n{{item.total}}</span></div><div class=\"text-center alert-button\" ng-if=\"item.color==\'red\'\" id=\"red-box\"><span \nstyle=\"color:#ffffff\">{{item.total}}</span></div><div class=\"text-center alert-button\" ng-if=\"item.color==\'black\'\" \nid=\"black-box\"><span style=\"color:#ffffff\">{{item.total}}</span></div></div><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.NIK\">NIK</th><th class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.NAME\">NAME</th><th class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.PERIOD\">PERIOD</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.FLAGAPP\">FLAG APP</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.TYPE\">TYPE</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.LABORTYPE\">LABOR TYPE</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.ALERTTYPE\">Alert Type</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.ALFA\">ALFA</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.IZIN\">IZIN</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.SAKIT\">SAKIT</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.STATUSPEMANGGILAN\">Status Pemanggilan</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.EMPLOYEEALERT.TABLE.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list track by $index\" ng-dblclick=\"vm.detail($event,ls)\"><td class=\"text-center\">\n{{vm.DataTable.list[$index].nik}}</td><td class=\"\">{{ls.name}}</td><td class=\"text-center\">{{ls.period}}</td><td \nclass=\"text-center\">{{ls.flag_app}}</td><td class=\"\">{{ls.emp_type}}</td><td class=\"text-center\">{{ls.labor_type}}</td>\n<td class=\"text-center\"><div ng-if=\"ls.alert_type==\'1\'\" id=\"yellow-box\"><span style=\"color:#000000\">{{ls.sp_code}}\n</span></div><div ng-if=\"ls.alert_type==\'2\'\" id=\"red-box\"><span style=\"color:#ffffff\">{{ls.sp_code}}</span></div><div \nng-if=\"ls.alert_type==\'3\'\" id=\"black-box\"><span style=\"color:#ffffff\">{{ls.sp_code}}</span></div><div \nng-if=\"ls.alert_type==\'4\'\" id=\"green-box\"><span style=\"color:#000000\">{{ls.sp_code}}</span></div><div \nng-if=\"ls.alert_type==\'5\'\" id=\"white-box\"><span style=\"color:#000000\">{{ls.sp_code}}</span></div></td><td \nclass=\"text-center\">{{ls.alfa}}</td><td class=\"text-center\">{{ls.izin}}</td><td class=\"text-center\">{{ls.sakit}}</td>\n<td class=\"text-center\">{{ls.status_pemanggilan}}</td><td class=\"text-center\"><div flex layout-align=\"row\" \nlayout=\"row\" layout><md-icon ng-if=\"ls.is_temporary==\'1\'\" md-font-icon=\"icon-pencil\" \nng-click=\"vm.showFormDialog($event, \'create\', ls, true)\" class=\"green-400-fg\"><md-tooltip>Create Warning Letter\n</md-tooltip></md-icon><md-icon ng-if=\"ls.is_temporary==\'0\'\" md-font-icon=\"icon-pencil\" class=\"grey-400-fg\">\n<md-tooltip>Create Warning Letter</md-tooltip></md-icon><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-icon md-font-icon=\"icon-clipboard-alert\" \nng-click=\"vm.processAlert($event, SalcomForm, ls)\" class=\"green-400-fg\"><md-tooltip>Process Alert</md-tooltip>\n</md-icon></form></div></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"12\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employee-alert/input-alert.html","<md-dialog aria-label=\"Form Input Warning Alert\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.EMPLOYEEALERT.FORM.TITLE\">\nForm Input GHK</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"column\"><md-input-container flex><label \ntranslate=\"MENU.CB.EMPLOYEEALERT.FORM.STARTDATE\">START DATE</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"startDate\" ng-model=\"vm.Form.objForm.startDate\" required></md-datepicker><div \nng-messages=\"formInput.startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date Date is required.\n</span></div></div></md-input-container><md-input-container flex><label translate=\"MENU.CB.EMPLOYEEALERT.FORM.ENDDATE\">\nEND DATE</label><md-datepicker md-hide-icons=\"calendar\" name=\"endDate\" ng-model=\"vm.Form.objForm.endDate\">\n</md-datepicker><div ng-messages=\"formInput.endDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd Date is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.warningLetter\" name=\"warningLetter\"><md-option ng-repeat=\"val in vm.listRefWarningLetter\" \nplaceholder=\"List\" value=\"{{val.id}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"formInput.warningLetter.$error\" role=\"alert\"><div ng-message=\"required\"><span>This field is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"column\"><md-input-container flex><input type=\"text\" \nname=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"formInput.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Description is required.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine\" translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.SAVE\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employee-alert/process-form.html","<md-dialog aria-label=\"Form Input Warning Alert\" flex=\"80\" md-theme=\"modal-theme\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,SalcomForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.EMPLOYEEALERT.FORM.TITLE\">\nForm Input GHK</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Country</label><md-select ng-model=\"vm.country\" name=\"countryid\" \nng-change=\"vm.LoadCompany(vm.country)\" required><md-option ng-repeat=\"ls in vm.listCountry\" value=\"{{ls.id}}\" required>\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Country is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Company</label><md-select ng-model=\"vm.company\" name=\"companyid\" ng-change=\"vm.LoadArea(vm.country,vm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div\n ng-messages=\"SalcomForm.companyid.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.Form.objForm.area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.area.$error\" role=\"alert\"><div ng-message=\"required\"><span>Area is required.</span></div></div>\n</md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container flex><label>MPP Effective Date</label><md-datepicker md-min-date=\"vm.prevMonth\" \nmd-max-date=\"vm.today\" md-hide-icons=\"calendar\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" \nrequired></md-datepicker><div ng-messages=\"SalcomForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Effective Date is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\" translate=\"MENU.CB.EMPLOYEEALERT.PROCESS\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employee-alert/view-detail.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"70\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2 translate=\"MENU.CB.EMPLOYEEALERT.DETAIL\">View Detail</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"15%\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.EMPLOYEEALERT.TABLE.ABSENCETYPE\">\">ANBSENCE TYPE</span></th><th width=\"15%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.EMPLOYEEALERT.TABLE.ABSENCEDATE\">\">ABSENCE DATE\n</span></th></tr></thead><tbody><tr style=\"display:none\" ng-init=\"idemp=$index\" \nng-repeat-start=\"lsdetail in vm.items track by $index\"></tr><tr><td class=\"text-center\" rowspan=\"{{lsdetail.rowd}}\">\n{{lsdetail.absence_type }}</td></tr><tr ng-init=\"idatt=$index\" ng-repeat=\"ls in lsdetail.dates track by $index\"><td \nclass=\"text-center\">{{ls.date }}</td></tr><tr style=\"display:none\" ng-repeat-end></tr><tr ng-if=\"vm.items.length <= 0\">\n<td colspan=\"4\" class=\"text-center\"><span>No Data Available</span></td></tr></tbody></table></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/cb/employee-leave-balance/employee-leave-balance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.EMPLOYEE_LEAVE_BALANCE.INDEX.HEADER.TITLE\">Employee Leave Balance</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData()\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span \ntranslate=\"FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nflex-gt-xs=\"30\"><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required>\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate  }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container \nlayout=\"column\" flex flex-gt-xs=\"30\"><md-input-container layout=\"column\" flex><md-select flex ng-model=\"vm.divisi\" \nname=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div flex \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container></md-input-container><md-input-container layout=\"column\" flex flex-gt-xs=\"30\">\n<md-input-container layout=\"column\" flex><md-select ng-model=\"vm.department\" name=\"department\" required><md-option \nng-repeat=\"ls in vm.listDepartment track by $index\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n</md-input-container><md-button flex type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n</div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item ng-if=\"vm.groupLogin!=11\"><md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-click=\"vm.ExportTotxt()\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.EXPORT_EXCEL\">Export Excel</span></md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button ng-if=\"vm.groupLogin!=11\" aria-label=\"Twitter\" class=\"md-raised md-primary btn-ui-serif\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" hide show-gt-sm ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.EXPORT_EXCEL\">Export Excel</span></md-tooltip>\n<span translate=\"ACTION.EXPORT_EXCEL\">Export Excel</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" on-collapse=\"vm.onCollapse()\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple extended with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\" \ntranslate=\"TABLE.NIK_NAME\">NIK/Name</th><th class=\"text-center\" colspan=\"2\" translate=\"TABLE.LEAVE_PERIOD\">Leave Period\n</th><th class=\"text-center\" colspan=\"2\" translate=\"TABLE.USAGE_PERIOD\">Usage Period</th><th class=\"text-center\" \nrowspan=\"2\" translate=\"TABLE.ANNUAL_LEAVE\">Annual Leave</th><th class=\"text-center\" rowspan=\"2\" \ntranslate=\"TABLE.JOIN_HOLIDAY\">Join Holiday</th><th class=\"text-center\" rowspan=\"2\" translate=\"TABLE.HOLD_LEAVE\">\nHold Leave</th><th rowspan=\"2\" translate=\"TABLE.CARRY\">Carry</th><th rowspan=\"2\" translate=\"TABLE.PAYLEAVE\">Payleave\n</th><th rowspan=\"2\" translate=\"TABLE.LEAVE_BALANCE\">Leave Balance</th></tr><tr><th class=\"text-center\" \ntranslate=\"TABLE.START_DATE\">Start Date</th><th class=\"text-center\" translate=\"TABLE.END_DATE\">End Date</th><th \nclass=\"text-center\" translate=\"TABLE.START_DATE\">Start Date</th><th class=\"text-center\" translate=\"TABLE.END_DATE\">\nEnd Date</th></tr></thead><tbody><tr ng-repeat-start=\"lsemp in vm.listData track by $index\" \nng-class=\"vm.classChanger($index)\"><td rowspan=\"{{lsemp.rowleave}}\">{{lsemp.nik}} - {{lsemp.emp_name}}</td><td \nclass=\"text-center\">{{lsemp.leave[0].startPeriode}}</td><td class=\"text-center\">{{lsemp.leave[0].endPeriode}}</td><td \nclass=\"text-center\">{{ lsemp.leave[0].startUsage}}</td><td class=\"text-center\">{{ lsemp.leave[0].endUsage}}</td><td \nclass=\"text-center\"><span ng-if=\" lsemp.leave[0].totalAnnualLeave > 0\"><a href=\"\" \nng-click=\"vm.viewAnnuaLeaveLog(lsemp.leave[0],$event)\">{{ lsemp.leave[0].totalAnnualLeave}}</a><md-tooltip \nmd-direction=\"top\"><span translate=\"ACTION.VIEW_ANNUAL_LEAVE_LOG\">View Annual Leave Log</span></md-tooltip></span></td>\n<td class=\"text-center\"><span ng-if=\" lsemp.leave[0].totalSubs > 0\"><a href=\"\" \nng-click=\"vm.viewSubsLeaveLog(lsemp.leave[0],$event)\">{{ lsemp.leave[0].totalSubs}}</a><md-tooltip md-direction=\"top\">\n<span translate=\"ACTION.VIEW_JOIN_HOLIDAY_LOG\">View Joint Holiday Log</span></md-tooltip></span></td><td \nclass=\"text-center\"><span ng-if=\" lsemp.leave[0].totalHoldLeave>0\"><a \nng-click=\"vm.viewHoldLeaveLog(lsemp.leave[0],$event)\">{{ lsemp.leave[0].totalHoldLeave}}</a><md-tooltip \nmd-direction=\"top\"><span translate=\"ACTION.VIEW_HOLD_LEAVE_LOG\">View Hold Leave Log</span></md-tooltip></span></td><td \nclass=\"text-center\"><span ng-if=\" lsemp.leave[0].carry > 0\">{{ lsemp.leave[0].carry}}</span></td><td \nclass=\"text-center\"><span ng-if=\" lsemp.leave[0].payLeave > 0\">{{ lsemp.leave[0].payLeave}}</span></td><td \nclass=\"text-center\">{{ lsemp.leave[0].totalLeave}}</td></tr><tr ng-repeat=\"ls in lsemp.leave.slice(1,entries.length)\" \nng-repeat-end ng-class=\"vm.classChanger($parent.$index)\"><td class=\"text-center\">{{ls.startPeriode}}</td><td \nclass=\"text-center\">{{ls.endPeriode}}</td><td class=\"text-center\">{{ls.startUsage}}</td><td class=\"text-center\">\n{{ls.endUsage}}</td><td class=\"text-center\"><span ng-if=\"ls.totalAnnualLeave > 0\"><a href=\"\" \nng-click=\"vm.viewAnnuaLeaveLog(ls,$event)\">{{ls.totalAnnualLeave}}</a><md-tooltip md-direction=\"top\"><span \ntranslate=\"ACTION.VIEW_ANNUAL_LEAVE_LOG\">View Annual Leave Log</span></md-tooltip></span></td><td class=\"text-center\">\n<span ng-if=\"ls.totalSubs > 0\"><a href=\"\" ng-click=\"vm.viewSubsLeaveLog(ls,$event)\">{{ls.totalSubs}}</a><md-tooltip \nmd-direction=\"top\"><span translate=\"ACTION.VIEW_JOIN_HOLIDAY_LOG\">View Joint Holiday Log</span></md-tooltip></span>\n</td><td class=\"text-center\"><span ng-if=\"ls.totalHoldLeave>0\"><a ng-click=\"vm.viewHoldLeaveLog(ls,$event)\">\n{{ls.totalHoldLeave}}</a><md-tooltip md-direction=\"top\"><span translate=\"ACTION.VIEW_HOLD_LEAVE_LOG\">\nView Hold Leave Log</span></md-tooltip></span></td><td class=\"text-center\"><span ng-if=\"ls.carry > 0\">{{ls.carry}}\n</span></td><td class=\"text-center\"><span ng-if=\"ls.payLeave > 0\">{{ls.payLeave}}</span></td><td class=\"text-center\">\n{{ls.totalLeave}}</td></tr><tr class=\"text-center\" ng-if=\"(vm.listData | typeOf) == \'undefined\'\"><td colspan=\"11\" \nclass=\"text-center\"><span>Please Do Filter First.</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.listData.length <= 0\"><td colspan=\"11\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employee-certificates/employee-certificates-configurations-components.html","<md-dialog aria-label=\"Form Input Dependent\" flex flex-gt-md=\"40\" class=\"md-inline-form popup-input-form\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Class Rooms Components</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm1.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\" class=\"pv-5 ph-10\"><div layout=\"row\" \nng-repeat=\"lssub in vm1.data\" class=\"mt-5\" layout-align=\"start start\"><div flex=\"15\" \nclass=\"md-green-600-bg p-5 text-center\">{{lssub.passing_grade}}</div><span flex class=\"mt-5 ml-20\">\n{{lssub.description}}</span></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/cb/employee-certificates/employee-certificates-configurations.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Configuration Class Rooms</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\">\n<div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formSearchUpFingerApp\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">Filter Data</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"end start\"><md-input-container flex flex-gt-sm=\"20\"><label>Country\n</label><md-select ng-model=\"vm.country\" name=\"country\" md-on-close=\"vm.clearSearchTermCountry()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTermCountry\" type=\"search\" placeholder=\"Search for a country...\" \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTermCountry\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label>Program</label><md-select ng-model=\"vm.program\" \nname=\"program\" md-on-close=\"vm.clearSearchTermPrograms()\" ng-keydown=\"$event.stopPropagation()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTermPrograms\" type=\"search\" placeholder=\"Search for a program...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"program\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listPrograms | filter:vm.searchTermPrograms\">{{ls.groupProgram}}</md-option></md-optgroup>\n</md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \nng-click=\"vm.loadData(1)\" flex flex-gt-sm=\"10\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"formSearchUpFingerApp.$invalid || formSearchUpFingerApp.$pristine\">\n</select><span translate=\"KPI.LABEL.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputConfigurations()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nAdd Class Room</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Add Class Room</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.deleteData($event)\"><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.DELETE\">DELETE</span></md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon><span>\nDelete Class Room</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\" on-collapse=\"vm.onCollapse()\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table id=\"list-hr-approval\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" rowspan=\"2\" \nwidth=\"40px\"><md-checkbox style=\"margin: 0; max-width: 20px !important\" ng-model=\"vm.selectAll\" \nng-checked=\"vm.isCheckedAll()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll()\"></md-checkbox>\n</th><th class=\"text-center\" rowspan=\"2\" width=\"80px\">No</th><th class=\"text-center\" rowspan=\"2\">Code Class</th><th \nclass=\"text-center\" rowspan=\"2\">Program</th><th class=\"text-center\" rowspan=\"2\" width=\"100\">Komponen</th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editInputConfigurations($event, ls.id)\"><td \nclass=\"text-center\"><md-input-container class=\"m-0\"><md-checkbox class=\"m-0\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\"></md-checkbox></md-input-container></td><td class=\"text-center\">\n{{ (vm.DataTable.offset + $index + 1)}}</td><td class=\"text-center\">{{ls.code_class}}</td><td>{{ls.description}}</td>\n<td class=\"text-center\"><md-button class=\"md-icon-button\" layout=\"row\" aria-label=\"More\" \nng-click=\"vm.viewDetailComponents($event, ls.components)\" style=\"padding: 0; height: 24px\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><span class=\"ml-5\">{{ls.components.length}}</span></md-button></td></tr><tr \nclass=\"text-center\" ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"7\" class=\"text-center\"><span>\nLoading, Please Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"7\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\" \nng-if=\"nav.disabled!==1\">{{nav.label}}</a> <span ng-if=\"nav.disabled===1\">{{nav.label}}</span></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employee-certificates/employee-certificates-detail.html","<md-dialog aria-label=\"Form Input Dependent\" flex flex-gt-md=\"60\" class=\"md-inline-form popup-input-form\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Detail Peserta</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm1.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-toolbar class=\"md-cyan-600-bg has-toolbar\" \nstyle=\"max-height: none; height: auto\"><div class=\"md-toolbar-tools font-size-12\" layout=\"row\"><span flex=\"30\" \nmd-truncate>No. Certificate: {{vm1.certificateResolve(vm1.data.certificate_number)}}</span><div layout=\"column\" \nng-if=\"vm1.data.approval_status!=\'0\' && vm1.data.approval_status!=\'1\'\">{{vm1.data.approval_date}}</div><span flex=\"5\" \nng-if=\"vm1.data.approval_status!=\'0\' && vm1.data.approval_status!=\'1\'\"></span><div layout=\"column\"><div \nng-if=\"vm1.data.approval_status!=\'4\'\" flex=\"noshrink\" layout=\"row\" layout-align=\"center\"><div \nng-class=\"vm1.data.approval_status==\'2\' ? \'md-primary-fg\' : vm1.data.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nclass=\"font-size-12 line-height-24\" flex=\"nogrow\"><md-icon md-font-icon=\"icon-account\" \nng-class=\"vm1.data.approval_status==\'2\' ? \'md-primary-fg\' : vm1.data.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nflex=\"nogrow\" class=\"m-0 mr-5\"></md-icon>\n{{vm1.data.approval_type | uppercase}} ({{vm1.data.status_name}}): {{vm1.data.emp_approval_name}}</div></div><div \nng-if=\"vm1.data.approval_status==\'4\'\" class=\"md-accent-fg\" flex=\"noshrink\" layout=\"column\" layout-align=\"center\"><span \nflex class=\"font-size-12 line-height-24\"><md-icon md-font-icon=\"icon-account\" class=\"md-accent-fg\" flex=\"nogrow\">\n</md-icon>{{vm1.data.approval_type | uppercase}} ({{vm1.data.status_name}}): {{vm1.data.emp_approval_name}}</span><p>\n{{vm1.data.reject_comment}}</p></div></div></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" \nid=\"contentDialog\" style=\"padding-bottom: 30px !important\"><div layout=\"column\"><div layout=\"column\"><div layout=\"row\">\n<span flex=\"20\">NIK/Name</span> <span flex><p class=\"text-bold mt-0\">{{vm1.data.nik + \' - \' + vm1.data.emp_name}}</p>\n<p>Sub Area: {{vm1.data.sub_area_name}}</p></span></div></div><div layout=\"column\" class=\"mt-10\"><div layout=\"row\">\n<span flex=\"20\">Program</span> <span flex class=\"text-bold\">{{vm1.data.groupName}}</span></div></div><div \nlayout=\"column\" class=\"mt-10\"><div layout=\"row\"><span flex=\"20\">Classrooms</span> <span flex class=\"text-bold\">\n{{vm1.data.code_class}}</span></div></div><div layout=\"column\" class=\"mt-10\"><div layout=\"row\"><span flex=\"20\">Date\n</span> <span flex class=\"text-bold\">{{vm1.data.start_date}} - {{vm1.data.end_date}}</span></div></div><div \nlayout=\"column\" class=\"mt-30\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><td \nclass=\"text-center\">Komponen</td><td class=\"text-center\">Passing Grade</td><td class=\"text-center\">Value</td></tr>\n</thead><tbody><tr ng-if=\"vm1.data.components.length == 0\"><td colspan=\"3\" class=\"text-center font-size-12\"><span \nclass=\"pv-15\">N/A</span></td></tr><tr ng-if=\"vm1.data.components.length > 0\" ng-repeat=\"ls in vm1.data.components\" \nng-init=\"parentIdx = $index\"><td style=\"min-width: 100px; vertical-align: top\"><div layout=\"column\"><span \nclass=\"ph-10 pv-5 mt-10\">{{ls.description}}</span></div></td><td class=\"pd-10\" width=\"90px\" \nstyle=\"vertical-align: top\"><div class=\"md-green-600-bg p-5 mt-10 text-center\">{{ls.passing_grade}}</div></td><td \nclass=\"pd-10\" width=\"90px\" style=\"vertical-align: top\"><div class=\"md-blue-600-bg p-5 mt-10 text-center\">{{ls.value}}\n</div></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions><div layout=\"row\" \nclass=\"font-size-10\" flex><div layout=\"column\" flex><span>Insert By:</span> <span>\n{{vm1.data.insert_by}} - {{vm1.data.insert_by_name}}</span> <span>{{vm1.data.timestamp}}</span></div><div \nlayout=\"column\" flex><span ng-if=\"vm1.data.modified_by && vm1.data.modified_time\">Modified By:</span> <span \nng-if=\"vm1.data.modified_by && vm1.data.modified_time\">{{vm1.data.modified_by}} - {{vm1.data.modified_by_name}}</span> \n<span ng-if=\"vm1.data.modified_by && vm1.data.modified_time\">{{vm1.data.modified_time}}</span></div></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/employee-certificates/employee-certificates-programs.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Configuration Programs</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formSearchUpFingerApp\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">Filter Data</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"end center\"><md-input-container flex flex-gt-sm=\"20\"><label>Country\n</label><md-select ng-model=\"vm.country\" name=\"country\" md-on-close=\"vm.clearSearchTermCountry()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTermCountry\" type=\"search\" placeholder=\"Search for a country...\" \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTermCountry\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \nng-click=\"vm.loadData(1)\" flex flex-gt-sm=\"10\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputPrograms()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Add Program</span>\n</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span>\nAdd Program</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.deleteData($event)\"><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DELETE\">DELETE</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete Program</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" \non-collapse=\"vm.onCollapse()\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\" style=\"width: 50px\"><div layout=\"row\" layout-align=\"center\"><md-input-container class=\"m-0\">\n<md-checkbox style=\"max-width: 20px !important\" class=\"m-0\" ng-model=\"vm.selectAll\" ng-checked=\"vm.isCheckedAll()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll()\"></md-checkbox></md-input-container></div>\n</th><th style=\"width: 70px\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th \nclass=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">Program Name</span></div></th><th \nclass=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th class=\"text-center\">\n<div class=\"table-header\"><span class=\"column-title\">Group</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editInputPrograms($event, ls.id)\"><td class=\"text-center\">\n<md-input-container class=\"m-0\"><md-checkbox class=\"m-0\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\"></md-checkbox></md-input-container></td><td class=\"text-center\">\n{{ (vm.DataTable.offset + $index + 1)}}</td><td>{{ ls.description }}</td><td class=\"text-center\">{{ ls.short_code }}\n</td><td class=\"text-center\">{{ ls.groupName }}</td></tr><tr class=\"text-center\" \nng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"5\" class=\"text-center\"><span>Loading, Please Wait\n</span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"5\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employee-certificates/employee-certificates-report.html","<md-dialog aria-label=\"Form Update Finger Data\" flex flex-gt-sm=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"frmReportKepesertaan\" class=\"md-inline-form popup-input-form\" \nng-submit=\"vm.DownloadReport($event,frmReportKepesertaan)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Download Kepesertaan</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout-padding flex><div layout=\"column\" flex><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"end start\"><md-input-container flex><label translate=\"TABLE.START_DATE\">Start Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" placeholder=\"start date\" name=\"tglmulai\" required>\n</md-datepicker><div ng-messages=\"frmReportKepesertaan.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart Date Required.</span></div></div></md-input-container><md-input-container flex flex-offset-gt-sm=\"5\"><label \ntranslate=\"TABLE.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nplaceholder=\"end date\" name=\"tglakhir\" required></md-datepicker><div \nng-messages=\"frmReportKepesertaan.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date Required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end start\">\n<md-input-container flex flex-gt-sm=\"20\"><label>Country</label><md-select ng-model=\"vm.country\" name=\"country\" \nmd-on-close=\"vm.clearSearchTermCountry()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTermCountry\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTermCountry\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmReportKepesertaan.country.$error\" role=\"alert\"><div ng-message=\"required\"><span>Program harus di isi.\n</span></div></div></md-input-container><md-input-container flex flex-offset-gt-sm=\"5\"><label>Program</label><md-select\n ng-model=\"vm.program\" name=\"program\" md-on-close=\"vm.clearSearchTermPrograms()\" required \nng-change=\"vm.LoadClassrooms(vm.program)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTermPrograms\" type=\"search\" placeholder=\"Search for a program...\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"program\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listPrograms | filter:vm.searchTermPrograms\">{{ls.groupProgram}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmReportKepesertaan.program.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nProgram harus di isi.</span></div></div></md-input-container><md-input-container flex flex-gt-sm=\"30\" \nflex-offset-gt-sm=\"5\"><label>Classroom</label><md-select ng-model=\"vm.configuration\" name=\"configuration\" \nmd-on-close=\"vm.clearSearchTermConfiguration()\" ng-change=\"vm.lookUpComponents(vm.configuration)\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermConfiguration\" type=\"search\" \nplaceholder=\"Search for a Classroom ...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header>\n<md-optgroup label=\"classrooms\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listClassrooms | filter:vm.searchTerm\">{{ls.code_class}}</md-option></md-optgroup></md-select><div \nng-messages=\"certificateForm.configuration.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nClassroom harus di isi.</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-primary md-hue-1 mv-0\" aria-label=\"Download\" \nng-disabled=\"frmReportKepesertaan.$invalid || frmReportKepesertaan.$pristine\"><md-icon md-font-icon=\"icon-download\">\n</md-icon><span translate=\"ACTION.DOWNLOAD\">Download</span></md-button><span flex hide show-gt-xs></span>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employee-certificates/employee-certificates-upload.html","<md-dialog aria-label=\"Form Update Finger Data\" flex flex-gt-sm=\"40\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"frmEmploye\" class=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\">\n<div class=\"md-toolbar-tools\"><h2>Upload Kepesertaan</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\"><fieldset><legend>Format file accepted (.xlxs)</legend><md-content\n layout=\"column\" class=\"mv-15 mh-10\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input \ntype=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div \nflex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" style=\"padding:3px\"><span \nstyle=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div><div class=\"mt-20\" \nlayout=\"column\" ng-if=\"vm.isMoreInfo\" flex ng-class=\"vm.isMoreInfo ? \'ml-10\' : \'\'\"><table \nclass=\"with-toolbar bordered stripped full-width\" style=\"border-collapse: collapse\" ms-responsive-table><thead><tr><th \nclass=\"text-center pv-5 ph-10 md-red-500-bg border\">NIK</th><th class=\"text-center pv-5 ph-10 md-red-500-bg border\">\nFailed/Warning Note</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.detailInfo\"><td \nclass=\"text-center pv-5 ph-10 border\">{{ls.nik}}</td><td class=\"text-left pv-5 ph-10 border\">{{ls.note}}</td></tr>\n</tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">\nCancel</md-button><md-button type=\"submit\" ng-click=\"vm.Upload()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-upload\" aria-label=\"android\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><span flex hide show-gt-xs></span><md-button \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1 mv-0\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employee-certificates/employee-certificates.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Certificates</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formEmployeeCertificates\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align-gt-sm=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">Filter Data\n</span></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end start\"><md-input-container flex><md-select\n ng-model=\"vm.type\" name=\"type\" required ng-change=\"vm.loadData(1)\"><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}\n</md-option></md-select><div ng-messages=\"formEmployeeCertificates.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type field is required.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"TABLE.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"start date\" name=\"tglmulai\"></md-datepicker></md-input-container><md-input-container flex><label \ntranslate=\"TABLE.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nplaceholder=\"end date\" name=\"tglakhir\"></md-datepicker></md-input-container><div hide show-gt-sm flex flex-gt-sm=\"10\" \nclass=\"ml-10\"></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end start\"><md-input-container \nflex flex-gt-sm=\"20\"><label>Country</label><md-select ng-model=\"vm.country\" name=\"country\" \nmd-on-close=\"vm.clearSearchTermCountry()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTermCountry\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTermCountry\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex flex-gt-sm=\"40\"><label>Program</label><md-select ng-model=\"vm.program\" \nname=\"program\" md-on-close=\"vm.clearSearchTermPrograms()\" ng-keydown=\"$event.stopPropagation()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTermPrograms\" type=\"search\" placeholder=\"Search for a program...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"program\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listPrograms | filter:vm.searchTermPrograms\">{{ls.groupProgram}}</md-option></md-optgroup>\n</md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \nng-click=\"vm.loadData(1)\" flex flex-gt-sm=\"10\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container layout=\"row\">\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"formSearchUpFingerApp.$invalid || formSearchUpFingerApp.$pristine\">\n</select><span translate=\"KPI.LABEL.ENTRIES\" class=\"ml-5 mt-5\">Entries</span></md-input-container><div \nclass=\"divider-vertical\"></div><md-menu hide-gt-sm md-offset=\"0 -7\"><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.openInput()\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>Add Kepesertaan</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\nDelete Kepesertaan</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button \nng-click=\"vm.uploadDialog($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon>Upload Kepesertaan</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.DownloadReportForm($event)\"><md-icon md-font-icon=\"icon-download\">\n</md-icon>Download Kepesertaan</md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-mini md-raised md-blue-700-bg md-background-fg btn-ui-serif\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInput()\" hide show-gt-sm><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nAdd Kepesertaan</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-background-fg\"></md-icon><span>\nAdd Kepesertaan</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" aria-label=\"Delete\" ng-click=\"vm.deleteData($event)\" hide show-gt-sm><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DELETE\">DELETE</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete Kepesertaan</span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-light-green-600-bg md-background-fg btn-ui-serif md-fab\" \ntype=\"button\" aria-label=\"Inert\" hide show-gt-sm ng-click=\"vm.uploadDialog($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Upload Kepesertaan</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-background-fg\"></md-icon></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-light-green-500-bg md-background-fg btn-ui-serif md-fab\" type=\"button\" aria-label=\"Inert\" \nhide show-gt-sm ng-click=\"vm.DownloadReportForm($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\n<span>Download Kepesertaan</span></md-tooltip><md-icon md-font-icon=\"icon-download\" class=\"md-background-fg\"></md-icon>\n</md-button><span flex></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" \ndebounce=\"300\" on-collapse=\"vm.onCollapse()\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table id=\"list-hr-approval\" class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"text-center\" rowspan=\"2\" style=\"min-width: 40px !important\"><md-checkbox \nstyle=\"margin: 0; max-width: 20px !important\" ng-model=\"vm.selectAll\" ng-checked=\"vm.isCheckedAll()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll()\"></md-checkbox></th><th class=\"text-center\" \nrowspan=\"2\">No</th><th class=\"text-center\" rowspan=\"2\">NIK/Nama</th><th class=\"text-center\" rowspan=\"2\">Program</th><th\n class=\"text-center\" rowspan=\"2\">Code Class</th><th class=\"text-center\" colspan=\"2\">Tanggal Pelaksanaan</th><th \nclass=\"text-center\" rowspan=\"2\" width=\"150px\">Status Approval</th><th class=\"text-center\" rowspan=\"2\" width=\"160px\">\nCertificate</th><th class=\"text-center\" rowspan=\"2\" width=\"30px\"></th></tr><tr><th class=\"text-center\" width=\"100px\" \nstyle=\"white-space: normal\">Tanggal Mulai</th><th class=\"text-center\" width=\"100px\" style=\"white-space: normal\">\nTanggal Selesai</th></tr><tr></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editInput($event, ls.id)\"><td class=\"text-center\"><md-checkbox style=\"margin: 0\" \nng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-if=\"ls.approval_status<=\'1\'\"></md-checkbox></td>\n<td class=\"text-center\">{{ (vm.DataTable.offset + $index + 1)}}</td><td>{{ls.nik}} - {{ls.emp_name}}</td><td>\n{{ls.program_description}}</td><td class=\"text-center\">{{ls.code_class}}</td><td class=\"text-center\">{{ls.start_date}}\n</td><td class=\"text-center\">{{ls.end_date}}</td><td class=\"text-center\"><div ng-if=\"ls.approval_status!=\'4\'\" \nflex=\"noshrink\" layout=\"row\" layout-align=\"center\"><md-tooltip md-direction=\"bottom\">\n{{ls.approval_type | uppercase}}: {{ls.emp_approval_name}}</md-tooltip><div \nng-class=\"ls.approval_status==\'2\' ? \'md-primary-fg\' : ls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nclass=\"font-size-12 line-height-24\" flex=\"nogrow\"><md-icon md-font-icon=\"icon-account\" \nng-class=\"ls.approval_status==\'2\' ? \'md-primary-fg\' : ls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nflex=\"nogrow\" class=\"m-0 mr-5\"></md-icon>{{ls.status_name}}</div></div><div ng-if=\"ls.approval_status==\'4\'\" \nflex=\"noshrink\" layout=\"column\" layout-align=\"center\"><md-icon md-font-icon=\"icon-account\" class=\"md-accent-fg\" \nflex=\"nogrow\"><md-tooltip md-direction=\"bottom\">{{ls.approval_type | uppercase}}: {{ls.emp_approval_name}}</md-tooltip>\n</md-icon><md-button md-no-ink class=\"md-accent-fg\" ng-click=\"vm.viewComment($event,ls)\" \nclass=\"font-size-12 line-height-24 ml-5\" flex><md-tooltip md-direction=\"top\">View Comment</md-tooltip>\n{{ls.status_name}}</md-button></div></td><td class=\"text-center\"><div layout=\"column\" \nng-if=\"ls.certificate_number && ls.approval_date\"><span>{{ls.certificate_number ? ls.certificate_number : \'&nbsp;\'}}\n</span> <span>{{ls.approval_date}}</span></div><span ng-if=\"!ls.certificate_number || !ls.approval_date\"><small>N/A\n</small></span></td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button class=\"md-icon-button\" \nlayout=\"row\" aria-label=\"More\" ng-click=\"vm.viewDetail($event, ls)\" style=\"padding: 0; height: 24px\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><md-tooltip md-direction=\"bottom\">View Detail</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.viewDetailComponents($event, ls)\" \nstyle=\"padding: 0; height: 24px; width: 24px\" ng-disabled=\"ls.approval_status!=\'2\'\"><md-icon \nmd-font-icon=\"icon-file-find s24\" style=\"padding: 0; height: 24px; width: 24px\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Preview Certificate {{ls.approval_status!=\'2\' ? \'not available\' : \'\'}}</md-tooltip></md-button>\n</div></td></tr><tr class=\"text-center\" ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"10\" \nclass=\"text-center\"><span>Loading, Please Wait</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\" ng-if=\"nav.disabled!==1\">{{nav.label}}</a> <span \nng-if=\"nav.disabled===1\">{{nav.label}}</span></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employee-shift-template/employee-shift-template.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.EMPLOYEE_SHIFT_TEMPLATE.INDEX.HEADER.TITLE\">Employe Shift Template</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\" required><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container \nflex><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"formInputOT.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" \nng-model=\"vm.end_date\"></md-datepicker><div ng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" placeholder=\"{{ \'FILTER.NIK_NAME\' | translate }}\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\" \naria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"FILTER.SEARCH\">Search</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div\n class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" \nng-click=\"vm.uploadShift($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.UPLOAD_TEMPLATE_SHIFT\">Upload Template Shift</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-800-fg\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm \nng-click=\" vm.uploadShift($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.UPLOAD_TEMPLATE_SHIFT\">Upload Template Shift</span></md-tooltip><span>Upload Template shift</span>\n</md-button><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listselected.length == 0\" ng-click=\" vm.Delete($event)\"><md-icon ng-if=\"vm.listselected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.listselected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\">Delete\n</span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\">Delete</span> <span \nng-if=\"vm.listselected.length > 0\" class=\"grey-700-fg\">{{ vm.listselected.length }} selected</span></md-button><span \nflex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" width=\"1%\"><span>\n<md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\"></md-checkbox></span></th><th class=\"text-left\" \nwidth=\"30%\"><span class=\"column-title\" translate=\"TABLE.NIK_NAME\">Employe NIK/Name</span></th><th class=\"text-center\">\n<span class=\"column-title\" translate=\"TABLE.LOCATION\">Location</span></th><th class=\"text-center\" width=\"20%\"><span \nclass=\"column-title\" translate=\"TABLE.SHIFT_NAME\">Shift Name</span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\" translate=\"TABLE.EFFECTIVE_DATE\">Effective Date</span></th><th class=\"text-center\" width=\"10%\">\n<span class=\"column-title\" translate=\"TABLE.START_TEMPLATE\">Start Template</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span><md-checkbox class=\"no-label\" \nng-checked=\"vm.exists(ls, vm.listselected)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td>{{ls.nik}}-{{ls.empName}}</td><td \nclass=\"text-center\">{{ls.location}}</td><td class=\"text-center\">{{ls.shiftname}}</td><td class=\"text-center\">\n{{ls.effective_date}}</td><td class=\"text-center\">{{ls.start_dws}}</td></tr></tbody><tbody></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employee-shift-template/upload-shift-template.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.EMPLOYEE_SHIFT_TEMPLATE.UPLOAD.TITLE\">Upload Shift Template</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" class=\"md-inline-form\" novalidate><fieldset><legend>\nFormat file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD \">Upload</span></md-button><md-button \ntype=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/ghk-gw/create.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.TITLE\">Form Input GHK</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.WORKING_DAY\">Working Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"working_date\" ng-change=\"vm.getDataListEmploye()\" \nng-model=\"vm.Form.objForm.working_date\" required ng-disabled=\"vm.disable || vm.disableDate\"></md-datepicker><div \nng-messages=\"formInputGhk.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking Date Date is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"column\">\n<md-input-container flex><md-radio-group layout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" \nng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\" ng-disabled=\"vm.disable\"><md-radio-button \nvalue=\"group\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.GROUP\">Group</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" ng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" ng-required=\"true\" \nname=\"location\" ng-disabled=\"vm.disable\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}\n</md-option></md-select><div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLocation harus di pilih.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.unscheduleshift\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.START_TIME\">\nStart Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99:99\" \nmask-placeholder=\"_\" required ng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div>\n<div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" mask=\"99:99\" mask-placeholder=\"_\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\">\n<div flex layout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button \nng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">\n{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><div layout-gt-sm=\"column\"><md-input-container flex><label \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.REASON\">Reason</label><input type=\"text\" name=\"reason\" \nng-model=\"vm.Form.objForm.reason\" required ng-disabled=\"vm.disable\"><div ng-messages=\"formInputGhk.reason.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div></div></md-input-container></div><div \nlayout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"50\" layout=\"column\"><div><fieldset class=\"standard\"><legend>\nFilter List Employee</legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"item in vm.listDepartment\">\n<md-checkbox ng-checked=\"vm.existsDept(item, vm.selectedDepartment)\" \nng-click=\"vm.toggleDeparment(item, vm.selectedDepartment)\" ng-disabled=\"vm.disable\">{{ item.gedung_name }}\n</md-checkbox></div></div></fieldset></div></div><div flex=\"100\" flex-gt-sm=\"50\" layout=\"column\"><div><fieldset \nclass=\"standard\"><legend>Sector</legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"item in vm.sectorList\"><md-checkbox ng-checked=\"vm.existsDept(item, vm.selectedDepartment)\" \nng-click=\"vm.toggleDeparment(item, vm.selectedDepartment)\" ng-disabled=\"true\">{{ item.gedung_name }}</md-checkbox>\n<fieldset class=\"standard\"><md-checkbox ng-repeat=\"sector in item.sectors\" \nng-checked=\"vm.existsSector(sector, vm.selectedSector)\" ng-click=\"vm.toggleSector(sector, vm.selectedSector)\" \nng-disabled=\"vm.disableSector\">{{ sector.name }}</md-checkbox></fieldset></div></div></fieldset></div></div></div><div \nlayout=\"row\"><div layout=\"column\" flex=\"50\"><fieldset style=\"min-height: 550px\"><legend>List Employee</legend><table \nclass=\"with-toolbar dataTable row-border hover simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th width=\"5%\" class=\"text-center\"><md-checkbox \nclass=\"no-label\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\"></md-checkbox></th><th \nwidth=\"15%\" class=\"text-center\" translate=\"TABLE.NIK\">NIK</th><th class=\"text-left\" translate=\"TABLE.NAME\">Name</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.items\" ng-click=\"vm.toggleCheck(ls, $event)\" \nstyle=\"height: 24px !important\"><td width=\"5%\" class=\"text-center\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(ls)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" \nng-disabled=\"vm.disable\"></md-checkbox></td><td width=\"15%\">{{ls.nik}}</td><td class=\"text-left\">{{ls.name}}</td></tr>\n</tbody><tfoot><tr><td colspan=\"3\" class=\"text-right\"><md-button class=\"md-secondary\" \nng-disabled=\"vm.disable && vm.listSelected.length <= 0\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.AddEmployeeList()\" class=\"md-button\"><md-icon md-font-icon=\"icon-plus\" class=\"blue-500-fg\"></md-icon>\n<md-tooltip md-direction=\"top\">Add Employee</md-tooltip></md-button></td></tr></tfoot></table></fieldset></div><div \nlayout=\"column\" flex=\"50\"><fieldset style=\"height: 550px;overflow-y: scroll\"><legend>List Employee Selected</legend>\n<div layout=\"column\" ng-repeat=\"sel in vm.empSelected track by $index\"><md-list-item class=\"md-primary\" \nstyle=\"max-height:24px !important\"><div class=\"md-list-item-text\"><span>{{$index+1}}. {{sel.nik}}-{{sel.nama}}</span>\n</div><md-button class=\"md-secondary\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.removeEmployee(sel)\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-if=\"vm.isStatus(sel) == \'Waiting Approval\' || vm.isStatus(sel) == \'-\'\">\n<md-icon md-font-icon=\"icon-minus\" class=\"red-500-fg\"></md-icon><md-tooltip md-direction=\"top\">Remove Employee\n</md-tooltip></md-button></md-list-item></div></fieldset></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine || vm.empSelected.length <= 0\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SAVE\" ng-if=\"!vm.edit\">Save</md-button><md-button type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Edit\" translate=\"ACTION.EDIT\" ng-click=\"vm.setEdit(false)\" \nng-if=\"vm.edit && vm.disable\">Edit</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Udate\" \ntranslate=\"ACTION.UPDATE\" ng-if=\"vm.edit && !vm.disable\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine || vm.empSelected.length <= 0\">Update</md-button>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Cancel\" translate=\"ACTION.CANCEL\" \nng-if=\"vm.edit && !vm.disable\" ng-click=\"vm.setEdit(true)\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/ghk-gw/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.GHKGW\">Employee GHK GW</span></md-subheader><div layout=\"column\" flex>\n<div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"Year\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\" required><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" \nvalue=\"{{val.value}}\">{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Working Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.workingDate\" \nmd-placeholder=\"Working Date\" required name=\"Working Date\"></md-datepicker><div \nng-messages=\"frmEmploye.workingDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.</span>\n</div></div></md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button \ntype=\"button\" ng-disabled=\"vm.searchComplete\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.SEARCH\">Search</span></md-button>\n</md-input-container></div></form></div></div><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-raised md-primary btn-ui-serif\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.InputGhk($event)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span translate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Upload($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<span>Search Employee</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} selected</span></md-button></md-menu-item></md-menu-content></md-menu><md-input-container \nhide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"MENU.CB.GHK_HOLIDAY.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.InputGhk($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n<span translate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button class=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span translate=\"\">Search Employee\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData()\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-500-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} selected</span></md-button><span flex></span><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"1%\"></th><th width=\"5%\" \nclass=\"text-center\" translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.START_SHIFT\">DWS Code</th><th width=\"5%\" \nclass=\"text-center\" translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.END_SHIFT\">Varian</th><th width=\"15%\" \nclass=\"text-center\" translate=\"MENU.CB.GHK_HOLIDAY.TABLE.WORKING_DAY\">Working Day</th><th width=\"15%\" \nclass=\"text-center\" translate=\"TABLE.EXPIRED\">Expired Date</th><th class=\"text-left\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.TABLE.REASON\">Reason</th><th width=\"15%\" class=\"text-left\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.TABLE.STATUS\">Status</th><th width=\"15%\" class=\"text-center\" translate=\"ACTION.ACTION\">\nAction</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"(ls.approval==0)?vm.editData($event,ls.id):\'\'\"><td class=\"text-center\"><md-checkbox \nng-if=\"ls.can_delete==1\" class=\"no-label\" ng-checked=\"vm.exists(ls, vm.listselected)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td class=\"text-center\">{{ls.iStartShift}}</td><td class=\"text-center\">{{ls.iEndShift}}</td><td \nclass=\"text-center\">{{ls.workdayname}} / {{ls.working_date}}</td><td class=\"text-center\">\n{{ls.expireddatename}} / {{ls.expireddate}}</td><td class=\"text-left\">{{ls.reason}}</td><td class=\"text-left\"><span>\n{{ls.total_waiting}} Waiting Aproval of {{ ls.total_all }}</span></td><td class=\"text-center\"><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"menu\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Click for view action</md-tooltip><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg menu\"><md-menu-item><md-button \nng-click=\"vm.detail($event,ls)\" aria-label=\"View\"><md-icon class=\"blue-500-fg\" md-font-icon=\"icon-magnify\"></md-icon>\n<span translate=\"ACTION.VIEW\">View</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.detailApproval($event,ls)\" aria-label=\"View\"><md-icon class=\"blue-500-fg\" md-font-icon=\"icon-table\">\n</md-icon>Approval Detail</md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" \nclass=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></md-content></div>");
$templateCache.put("app/main/cb/ghk-gw/log-fail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Log</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"\">NIK</th><th class=\"text-center\">Note</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.logFail\"><td class=\"text-left\">{{ls.nik}}</td><td class=\"text-left\">{{ls.note}}</td></tr></tbody>\n</table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/cb/ghk-gw/upload.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.SUBMIT\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/ghk-halfday-gw/create.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.TITLE\">Form Input GHK</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.HALFDAY\">Halfday</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"working_date\" ng-model=\"vm.Form.objForm.working_date\" \nng-change=\"vm.getDataListEmploye()\" required ng-disabled=\"vm.disable\"></md-datepicker><div \nng-messages=\"upnormalForm.halfday_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Halfday Date is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"column\"><md-input-container flex><md-radio-group \nlayout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" ng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\" \nng-disabled=\"vm.disable\"><md-radio-button value=\"group\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.GROUP\">Group</span></md-radio-button>&nbsp;&nbsp;<md-radio-button \nvalue=\"nongroup\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.NON_GROUP\">Non-Group</span>\n</md-radio-button></md-radio-group><div ng-messages=\"upnormalForm.timetype.$error\" role=\"alert\"><div \nng-message=\"required\"><span>shifttype Type is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container flex><label \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SHIFT\">Shift</label><md-select ng-model=\"vm.Form.objForm.locationid\" \nng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" ng-required=\"true\" name=\"location\" ng-disabled=\"vm.disable\">\n<md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}</md-option></md-select><div \nng-messages=\"upnormalForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>Location harus di pilih.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.START_TIME\">Start Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99:99\" mask-placeholder=\"_\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"upnormalForm.start_time.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" \nng-model=\"vm.Form.objForm.end_time\" mask=\"99:99\" mask-placeholder=\"_\" required ng-disabled=\"vm.disable\"><div \nng-messages=\"upnormalForm.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>End time is required.</span>\n</div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container><md-input-container flex><md-checkbox class=\"no-label\" \nng-checked=\"(vm.isStartSameDate==\'1\') ? 1:0\" ng-model=\"vm.isSameDate\" ng-click=\"vm.setSameDate(vm.isStartSameDate)\" \naria-label=\"isStartSameDate\" name=\"isStartSameDate\">Is Start Same Date</md-checkbox></md-input-container></div>\n<md-input-container ng-if=\"!vm.unscheduleshift\" flex><md-radio-group ng-model=\"vm.Form.objForm.start_template\" \nng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\"><div flex layout=\"column\" layout-padding \nlayout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.shiftcode\" \nclass=\"md-primary\" name=\"start_template\">{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button>\n</div></div></md-radio-group><div ng-messages=\"upnormalForm.start_template.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Template is required.</span></div></div></md-input-container><div \nlayout-gt-sm=\"column\"><md-input-container flex><label translate=\"MENU.CB.GHK_HALFDAY.FORM_INPUT.DESCRIPTION\">\nDescription</label><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.reason\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"upnormalForm.description.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Description is required.</span></div></div></md-input-container></div><div layout=\"row\" layout-wrap><div \nflex=\"100\" flex-gt-sm=\"50\" layout=\"column\"><div><fieldset class=\"standard\"><legend>Filter List Employee</legend><div \nlayout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"item in vm.listDepartment\"><md-checkbox \nng-checked=\"vm.existsDept(item, vm.selectedDepartment)\" ng-click=\"vm.toggleDeparment(item, vm.selectedDepartment)\" \nng-disabled=\"vm.disable\">{{ item.gedung_name }}</md-checkbox></div></div></fieldset></div></div><div flex=\"100\" \nflex-gt-sm=\"50\" layout=\"column\"><div><fieldset class=\"standard\"><legend>Sector</legend><div layout=\"row\" layout-wrap \nflex><div flex=\"50\" ng-repeat=\"item in vm.sectorList\"><md-checkbox \nng-checked=\"vm.existsDept(item, vm.selectedDepartment)\" ng-click=\"vm.toggleDeparment(item, vm.selectedDepartment)\" \nng-disabled=\"true\">{{ item.gedung_name }}</md-checkbox><fieldset class=\"standard\"><md-checkbox \nng-repeat=\"sector in item.sectors\" ng-checked=\"vm.existsSector(sector, vm.selectedSector)\" \nng-click=\"vm.toggleSector(sector, vm.selectedSector)\" ng-disabled=\"vm.disableSector\">{{ sector.name }}</md-checkbox>\n</fieldset></div></div></fieldset></div></div></div><div layout=\"row\"><div layout=\"column\" flex=\"50\"><fieldset \nstyle=\"min-height: 550px\"><legend>List Employee</legend><table class=\"with-toolbar dataTable row-border hover simple\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th width=\"5%\" \nclass=\"text-center\"><md-checkbox class=\"no-label\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" \nng-model=\"vm.selectAll\"></md-checkbox></th><th width=\"15%\" class=\"text-center\" translate=\"TABLE.NIK\">NIK</th><th \nclass=\"text-left\" translate=\"TABLE.NAME\">Name</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.items\" \nng-click=\"vm.toggleCheck(ls, $event)\" style=\"height: 24px !important\"><td width=\"5%\" class=\"text-center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" ng-disabled=\"vm.disable\"></md-checkbox></td><td width=\"15%\">\n{{ls.nik}}</td><td class=\"text-left\">{{ls.name}}</td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-right\">\n<md-button class=\"md-secondary\" ng-disabled=\"vm.disable && vm.listSelected.length <= 0\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.AddEmployeeList()\" class=\"md-button\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"blue-500-fg\"></md-icon><md-tooltip md-direction=\"top\">Add Employee</md-tooltip>\n</md-button></td></tr></tfoot></table></fieldset></div><div layout=\"column\" flex=\"50\"><fieldset \nstyle=\"height: 550px;overflow-y: scroll\"><legend>List Employee Selected</legend><div layout=\"column\" \nng-repeat=\"sel in vm.empSelected track by $index\"><md-list-item class=\"md-primary\" style=\"max-height:24px !important\">\n<div class=\"md-list-item-text\"><span>{{$index+1}}. {{sel.nik}}-{{sel.nama}}</span></div><md-button \nclass=\"md-secondary\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.removeEmployee(sel)\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-if=\"vm.isStatus(sel) == \'Waiting Approval\' || vm.isStatus(sel) == \'-\'\">\n<md-icon md-font-icon=\"icon-minus\" class=\"red-500-fg\"></md-icon><md-tooltip md-direction=\"top\">Remove Employee\n</md-tooltip></md-button></md-list-item></div></fieldset></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine || vm.empSelected.length <= 0\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SAVE\" ng-if=\"!vm.edit\">Save</md-button><md-button type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Edit\" translate=\"ACTION.EDIT\" ng-click=\"vm.setEdit(false)\" \nng-if=\"vm.edit && vm.disable\">Edit</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Udate\" \ntranslate=\"ACTION.UPDATE\" ng-if=\"vm.edit && !vm.disable\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine || vm.empSelected.length <= 0\">Update</md-button>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Cancel\" translate=\"ACTION.CANCEL\" \nng-if=\"vm.edit && !vm.disable\" ng-click=\"vm.setEdit(true)\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/ghk-halfday-gw/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.GHK_HALFDAY_GW\">Employee GHK Half Day GW</span></md-subheader><div \nclass=\"white-bg\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.TITLE\">Filter Data\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.tahun\" \nng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option ng-repeat=\"val in vm.listtahun\" placeholder=\"Year\" \nvalue=\"{{val}}\">{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\" required><md-option \nng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex><label>Working Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.workingDate\" md-placeholder=\"Working Date\" required \nname=\"Working Date\"></md-datepicker><div ng-messages=\"frmEmploye.workingDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tanggal Harus Diisi.</span></div></div></md-input-container><md-input-container \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" ng-disabled=\"vm.searchComplete\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.SEARCH\">\nSearch</span></md-button></md-input-container></div></form></div></div><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.InputGhk($event)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span translate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Upload($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-primary md-mini\" \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<span>Search Employee</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} selected</span></md-button></md-menu-item></md-menu-content></md-menu><md-input-container \nhide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"MENU.CB.GHK_HOLIDAY.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.InputGhk($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n<span translate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button class=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span translate=\"\">Search Employee\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData()\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-500-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} selected</span></md-button><span flex></span><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" width=\"1%\"></th>\n<th width=\"5%\" class=\"text-center\" translate=\"MENU.CB.GHK_HOLIDAY.TABLE.START_SHIFT\">DWS Code</th><th width=\"5%\" \nclass=\"text-center\" translate=\"MENU.CB.GHK_HOLIDAY.TABLE.END_SHIFT\">Varian</th><th class=\"text-center\" width=\"15%\" \ntranslate=\"TABLE.HALFDAY_DATE\">Halfday Date</th><th class=\"text-left\" translate=\"TABLE.DESCRIPTION\">Description</th><th\n class=\"text-left\" width=\"15%\" translate=\"TABLE.STATUS\">Status</th><th class=\"text-center\" width=\"5%\"></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"(ls.approval==0)?vm.editData($event,ls.id):\'\'\"><td>\n<md-checkbox ng-if=\"ls.can_modify==1\" class=\"no-label\" ng-checked=\"vm.exists(ls, vm.listselected)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td class=\"text-center\">{{ls.iStartShift}}</td><td class=\"text-center\">{{ls.iEndShift}}</td><td \nclass=\"text-center\">{{ls.workdayname}} / {{ls.working_date}}</td><td class=\"text-left\">{{ls.reason}}</td><td \nclass=\"text-left\"><span>{{ls.total_waiting}} Waiting Aproval of {{ ls.total_all }}</span></td><td class=\"text-center\">\n<md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Click for view action</md-tooltip><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" aria-label=\"View\"><md-icon class=\"blue-500-fg\" \nmd-font-icon=\"icon-magnify\"></md-icon><span translate=\"ACTION.VIEW\">View</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.detailApproval($event,ls)\" aria-label=\"View\"><md-icon class=\"blue-500-fg\" \nmd-font-icon=\"icon-table\"></md-icon>Approval Detail</md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"7\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/ghk-halfday-gw/upload.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.SUBMIT\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/ghk-holiday-gw/create.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><form ng-cloack name=\"upnormalForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,upnormalForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.TITLE\">\nForm Input GHK</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content>\n<div layout-gt-sm=\"row\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.WORKING_DAY\">\nTanggal Kerja</label><md-datepicker md-hide-icons=\"calendar\" name=\"working_date\" ng-change=\"vm.getDataListEmploye()\" \nng-model=\"vm.Form.objForm.working_date\" required ng-disabled=\"vm.disable ||  vm.disableDate\"></md-datepicker><div \nng-messages=\"formInputGhk.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Kerja harus diisi.\n</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.HOLIDAY\">Working Day</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"holiday_date\" ng-change=\"vm.getDataListEmploye()\" ng-model=\"vm.Form.objForm.holiday_date\" \nng-disabled=\"vm.disable ||  vm.disableDate\"></md-datepicker><div ng-messages=\"formInputGhk.holiday_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tanggal Libur Harus Diisi.</span></div></div></md-input-container></div>\n<div layout-gt-sm=\"column\"><md-input-container flex><md-radio-group layout=\"row\" ng-model=\"vm.Form.objForm.shifttype\" \nng-change=\"vm.changeShiftType()\" ng-required=\"true\" name=\"shifttype\" ng-disabled=\"vm.disable\"><md-radio-button \nvalue=\"group\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.GROUP\">Group</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"nongroup\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.NON_GROUP\">Non-Group</span></md-radio-button></md-radio-group><div \nng-messages=\"formAbsence.timetype.$error\" role=\"alert\"><div ng-message=\"required\"><span>shifttype Type is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.unscheduleshift\"><md-input-container \nflex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SHIFT\">Shift</label><md-select \nng-model=\"vm.Form.objForm.locationid\" ng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" ng-required=\"true\" \nname=\"location\" ng-disabled=\"vm.disable\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.shift_name}}\n</md-option></md-select><div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLocation harus di pilih.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.unscheduleshift\"><md-input-container flex><label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.START_TIME\">\nStart Time</label><input type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.start_time\" mask=\"99:99\" \nmask-placeholder=\"_\" required ng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div>\n<div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" mask=\"99:99\" mask-placeholder=\"_\" required \nng-disabled=\"vm.disable\"><div ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd time is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>\nMax Length 2.</span></div></div></md-input-container></div><md-input-container ng-if=\"!vm.unscheduleshift\" flex>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\" ng-disabled=\"vm.disable\"><div class=\"row\">\n<div flex layout=\"column\" layout-padding layout-align=\"start left\"><md-radio-button \nng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.shiftcode\" class=\"md-primary\" name=\"start_template\">\n{{ls.start_time}} - {{ls.end_time}} | {{ls.variant}} day</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><div layout-gt-sm=\"column\"><md-input-container flex><label \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.REASON\">Reason</label><input type=\"text\" name=\"reason\" \nng-model=\"vm.Form.objForm.reason\" required ng-disabled=\"vm.disable\"><div ng-messages=\"formInputGhk.reason.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div></div></md-input-container></div><div \nlayout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"50\" layout=\"column\"><div><fieldset class=\"standard\"><legend>\nFilter List Employee</legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"item in vm.listDepartment\">\n<md-checkbox ng-checked=\"vm.existsDept(item, vm.selectedDepartment)\" \nng-click=\"vm.toggleDeparment(item, vm.selectedDepartment)\" ng-disabled=\"vm.disable\">{{ item.gedung_name }}\n</md-checkbox></div></div></fieldset></div></div><div flex=\"100\" flex-gt-sm=\"50\" layout=\"column\"><div><fieldset \nclass=\"standard\"><legend>Sector</legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"item in vm.sectorList\"><md-checkbox ng-checked=\"vm.existsDept(item, vm.selectedDepartment)\" \nng-click=\"vm.toggleDeparment(item, vm.selectedDepartment)\" ng-disabled=\"true\">{{ item.gedung_name }}</md-checkbox>\n<fieldset class=\"standard\"><md-checkbox ng-repeat=\"sector in item.sectors\" \nng-checked=\"vm.existsSector(sector, vm.selectedSector)\" ng-click=\"vm.toggleSector(sector, vm.selectedSector)\" \nng-disabled=\"vm.disableSector\">{{ sector.name }}</md-checkbox></fieldset></div></div></fieldset></div></div></div><div \nlayout=\"row\"><div layout=\"column\" flex=\"50\"><fieldset style=\"min-height: 550px\"><legend>List Employee</legend><table \nclass=\"with-toolbar dataTable row-border hover simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th width=\"5%\" class=\"text-center\"><md-checkbox \nclass=\"no-label\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\"></md-checkbox></th><th \nwidth=\"15%\" class=\"text-center\" translate=\"TABLE.NIK\">NIK</th><th class=\"text-left\" translate=\"TABLE.NAME\">Name</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.items\" ng-click=\"vm.toggleCheck(ls, $event)\" \nstyle=\"height: 24px !important\"><td width=\"5%\" class=\"text-center\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(ls)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" \nng-disabled=\"vm.disable\"></md-checkbox></td><td width=\"15%\">{{ls.nik}}</td><td class=\"text-left\">{{ls.name}}</td></tr>\n</tbody><tfoot><tr><td colspan=\"3\" class=\"text-right\"><md-button class=\"md-secondary\" \nng-disabled=\"vm.disable && vm.listSelected.length <= 0\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.AddEmployeeList()\" class=\"md-button\"><md-icon md-font-icon=\"icon-plus\" class=\"blue-500-fg\"></md-icon>\n<md-tooltip md-direction=\"top\">Add Employee</md-tooltip></md-button></td></tr></tfoot></table></fieldset></div><div \nlayout=\"column\" flex=\"50\"><fieldset style=\"height: 550px;overflow-y: scroll\"><legend>List Employee Selected</legend>\n<div layout=\"column\" ng-repeat=\"sel in vm.empSelected track by $index\"><md-list-item class=\"md-primary\" \nstyle=\"max-height:24px !important\"><div class=\"md-list-item-text\"><span>{{$index+1}}. {{sel.nik}}-{{sel.nama}}</span>\n</div><md-button class=\"md-secondary\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.removeEmployee(sel)\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-if=\"vm.isStatus(sel) == \'Waiting Approval\' || vm.isStatus(sel) == \'-\'\">\n<md-icon md-font-icon=\"icon-minus\" class=\"red-500-fg\"></md-icon><md-tooltip md-direction=\"top\">Remove Employee\n</md-tooltip></md-button></md-list-item></div></fieldset></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex>\n{{vm.empSelected.length}}</span><md-button type=\"submit\" class=\"md-green-300-bg md-raised md-primary white-fg\" \naria-label=\"Submit\" ng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine || vm.empSelected.length <= 0\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SAVE\" ng-if=\"!vm.edit\">Save</md-button><md-button type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Edit\" translate=\"ACTION.EDIT\" ng-click=\"vm.setEdit(false)\" \nng-if=\"vm.edit && vm.disable\">Edit</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Udate\" \ntranslate=\"ACTION.UPDATE\" ng-if=\"vm.edit && !vm.disable\" \nng-disabled=\"upnormalForm.$invalid || upnormalForm.$pristine || vm.empSelected.length <= 0\">Update</md-button>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Cancel\" translate=\"ACTION.CANCEL\" \nng-if=\"vm.edit && !vm.disable\" ng-click=\"vm.setEdit(true)\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/ghk-holiday-gw/detail-approval.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Approval Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"\">NIK/NAME</th><th class=\"text-center\">Approval 1</th><th \nclass=\"text-center\">Approval 2</th><th class=\"text-center\">Note</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.items\">\n<td class=\"text-left\">{{ls.nik}}/{{ls.nama}}</td><td class=\"text-left\">{{ls.nik_approval1}}</td><td class=\"text-left\">\n{{ls.nik_approval2}}</td><td class=\"text-left\">{{ls.status1}}<br>{{ls.status2}}</td></tr></tbody></table>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/cb/ghk-holiday-gw/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.GHK_HOLIDAY_GW\">Employee GHK</span></md-subheader><div class=\"white-bg\">\n<div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"Year\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\" required><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" \nvalue=\"{{val.value}}\">{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Working Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.workingDate\" \nmd-placeholder=\"Working Date\" required name=\"Working Date\"></md-datepicker><div \nng-messages=\"frmEmploye.workingDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.</span>\n</div></div></md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button \ntype=\"button\" ng-disabled=\"vm.searchComplete\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.SEARCH\">Search</span></md-button>\n</md-input-container></div></form></div><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.Upload($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span>Search Employee</span>\n</md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" \naria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i class=\"icon-delete\"></i> <span \nng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" translate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span \nng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\" translate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span \nng-if=\"vm.listselected.length > 0\">{{ vm.listselected.length }} selected</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"MENU.CB.GHK_HOLIDAY.ENTRIES\">\nEntries</span></md-input-container><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputGhk($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button class=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.searchEmployee($event)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span translate=\"\">Search Employee\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData()\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-500-fg\"></md-icon><span ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length == 0\" class=\"grey-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span ng-if=\"vm.listselected.length > 0\">\n{{ vm.listselected.length }} selected</span></md-button><span flex></span> <span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th widht=\"5%\"><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"></md-checkbox></th><th width=\"5%\" translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.START_SHIFT\">\nStart Shift</th><th width=\"5%\" translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.END_SHIFT\">End Shift</th><th \nwidth=\"15%\" translate=\"MENU.CB.GHK_HOLIDAY.TABLE.HOLIDAY\">Holiday</th><th width=\"15%\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.TABLE.WORKING_DAY\">Working Day</th><th class=\"text-left\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.TABLE.REASON\">Reason</th><th width=\"15%\" translate=\"MENU.CB.GHK_HOLIDAY.TABLE.STATUS\">\nStatus</th><th width=\"15%\" translate=\"ACTION.ACTION\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"(ls.approval==0)?vm.editData($event,ls.id):\'\'\"><td widht=\"5%\" \nclass=\"text-center\"><md-checkbox ng-if=\"ls.can_delete==1\" class=\"no-label\" ng-checked=\"vm.exists(ls, vm.listselected)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td class=\"text-center\">{{ls.iStartShift}}</td><td class=\"text-center\">{{ls.iEndShift}}</td><td \nclass=\"text-center\">{{ls.holidayname}} / {{ls.holiday_date}}</td><td class=\"text-center\">\n{{ls.workdayname}} / {{ls.working_date}}</td><td class=\"text-left\">{{ls.reason}}</td><td class=\"text-left\"><span>\n{{ls.total_waiting}} Waiting Aproval of {{ ls.total_all }}</span></td><td width=\"5%\" class=\"text-center\"><md-menu>\n<md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Click for view action</md-tooltip><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.detail($event,ls)\" aria-label=\"View\"><md-icon class=\"blue-500-fg\" \nmd-font-icon=\"icon-magnify\"></md-icon><span translate=\"ACTION.VIEW\">View</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.detailApproval($event,ls)\" aria-label=\"View\"><md-icon class=\"blue-500-fg\" \nmd-font-icon=\"icon-table\"></md-icon>Approval Detail</md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr\n class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/ghk-holiday-gw/search-employee.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"searcEmployee\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,searcEmployee)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span>Search Employee</span> <span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\">\n</md-progress-linear><md-dialog-content><div layout-gt-sm=\"row\"><md-input-container flex><label>Working Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"working_date\" ng-model=\"vm.working_date\" required></md-datepicker><div \nng-messages=\"searcEmployee.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Working Date is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" placeholder=\"employee name / nik\" \nng-model=\"vm.nik\" id=\"formSearch\"></md-input-container><md-input-container layout=\"column\" layout-align=\"right right\">\n<md-button type=\"button\" ng-disabled=\"(searcEmployee.$invalid || searcEmployee.$pristine)\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"MENU.CB.APPROVAL_OT.INDEX.FILTER.SEARCH\">\nSearch</span></md-button></md-input-container></div><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-left\">Nik/Name</th><th class=\"text-left\">Shift</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.items\" \nng-dblclick=\"vm.detail($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Double Click for Edit\n</md-tooltip><td class=\"text-center\">{{ls.nik}}-{{ls.name}}</td><td>{{ls.iStartShift}} s/d {{ls.iEndShift}}</td></tr>\n<tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Back\" translate=\"ACTION.BACK\" \nng-click=\"vm.closeModal()\">Back</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/ghk-holiday-gw/upload.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.SUBMIT\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/halfday-report/halfday-report.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span \ntranslate=\"MENU.CB.HALF_DAY_REPORT.INDEX.HEADER.TITLE\">Half Day Report</span></span></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" layout-align=\"center start\"></div></div>\n</div><div class=\"content\"><div class=\"simple-table-container\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"FILTER.TITLE\">Filter Data,/</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\">\n<md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" \nname=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">\n{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><label translate=\"FILTER.SUB_AREA\">Sub Area</label><md-select\n class=\"md-block\" flex-gt-xs ng-model=\"vm.selectedSubarea\" md-on-close=\"vm.clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" multiple=\"multiple\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Search for a Subarea..\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-optgroup label=\"subArea\"><md-option ng-value=\"ls.id\" \nng-repeat=\"ls in vm.subArea |\n                            filter:searchTerm\">{{ls.description}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex layout-align=\"right right\"><md-button \ntype=\"submit\" layout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n</md-input-container></div></form></div></div></md-content><div id=\"attView\"><md-toolbars><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span>\n</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-button aria-label=\"Twitter\" class=\"md-mini\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" hide show-gt-sm ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD\">Download</span></md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon><span translate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel\n</span></md-button><span flex hide show-gt-sm></span></div><table class=\"simple striped\" ms-responsive-table \nstyle=\"margin-top:0\"><thead><tr><th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.NIK\">NIK</span>\n</th><th width=\"15%\"><span class=\"column-title\" translate=\"TABLE.NAME\">Name</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.START_DATE\">Start Date</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.END_DATE\">End Date</span></th><th class=\"text-center\">\n<span class=\"column-title\" translate=\"TABLE.START_TIME\">Start Time</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.END_TIME\">End Time</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.DESCRIPTION\">Description</span></th><th width=\"15%\"><span class=\"column-title\" \ntranslate=\"TABLE.HALF_DAY_TYPE\">Half Day Type</span></th><th><span class=\"column-title\" translate=\"TABLE.DOWNLOAD\">\nDownload</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td class=\"text-center\">{{ls.nik }}</td><td>\n{{ls.nama }}</td><td class=\"text-center\">{{ls.start_date}}</td><td class=\"text-center\">{{ls.start_date}}</td><td \nclass=\"text-center\">{{ls.start_time }}</td><td class=\"text-center\">{{ls.end_time}}</td><td>{{ls.description}}</td><td>\n{{ls.halfday_type}}</td><td class=\"text-center\"><span ng-if=\"ls.download\"><md-icon class=\"green-500-fg\" \nmd-font-icon=\"icon-check\"></md-icon></span></td></tr><tr ng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span>No Data Available</span></td></tr></tbody></table></md-toolbars></div></div></div></div>");
$templateCache.put("app/main/cb/hr-crew-mapping-approval/hr-crew-mapping-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.CREW_MAPPING_APPROVAL.INDEX.HEADER.TITLE\">Crew Mapping Approval</span>\n</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Approve()\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span translate=\"ACTION.APPROVE\">Approve</span>\n</md-button></md-menu-item><md-menu-item></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Approve()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.APPROVE\">\nApprove</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th></th><th \nclass=\"text-center\" translate=\"TABLE.NO\">No</th><th translate=\"TABLE.REQUEST_BY\">Request By</th><th \nclass=\"text-center\" translate=\"TABLE.STATUS\">status</th><th class=\"text-center\">#</th></tr></thead><tbody><tr \nng-repeat=\"team in vm.DataTable.list\"><td><span ng-if=\"team.approval==0\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(team)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td class=\"text-center\">{{team.no}}\n</td><td>{{team.requestby}}-{{team.nama}}</td><td class=\"text-center\">{{team.approvalinfo}}</td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"start center\" layout-wrap><md-button \nclass=\"md-icon-button\" ng-if=\"team.approval==1\" aria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.unApprove($event,team)\"><md-icon md-font-icon=\"icon-cancel\" class=\"red-500-fg\"></md-icon><md-tooltip>\n<span>click for Unapprove</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setViewTeam($event,team)\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>click for view team</span></md-tooltip></md-button></section></td></tr>\n</tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/hr-crew-mapping-approval/view-team-mapping.html","<md-dialog aria-label=\"New SM\" flex=\"70\" id=\"formKpiPeople\" md-theme=\"modal-theme\"><form ng-cloak \nname=\"formSicMapping\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveMapping($event,formSicMapping)\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.OUTLET_MAPPING.INDEX.HEADER.TITLE\">Outlet Mapping</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content style=\"background: #ffffff\"><table class=\"simple\"><thead><tr><th translate=\"TABLE.NAME\">Name</th><th\n translate=\"TABLE.CURRENT_OUTLET\">Current Outlet</th><th translate=\"TABLE.NEXT_OUTLET\">Next Outlet</th><th \ntranslate=\"TABLE.EFFECTIVE_DATE\">Effective Date</th><th>MPP Detail</th></tr></thead><tbody><tr \nng-repeat=\"lstSubTeam in vm.listSic\"><td>{{lstSubTeam.nik}} - {{lstSubTeam.nama}}</td><td>{{lstSubTeam.currAreaName}}\n</td><td>{{lstSubTeam.nextAreaName}}</td><td>{{lstSubTeam.effective_date}}</td><td><div layout=\"column\" \nng-if=\"lstSubTeam.jobTitleName || lstSubTeam.nama_mpp_emp\"><h5 class=\"mv-5\">{{ lstSubTeam.jobTitleName }}</h5><p \nclass=\"m-0 font-size-12\">{{ lstSubTeam.nik_nama_mpp_emp }}</p><p class=\"font-size-12\">\nManpower Target: {{ lstSubTeam.fullfilmentType }}</p></div></td></tr></tbody></table></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/cb/hr-sic-mapping-approval/hr-sic-mapping-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.SIC_MAPING.MAPING_APPROVAL.INDEX.HEADER.TITLE\">SM Mapping Approval</span>\n</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Approve()\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span translate=\"ACTION.APPROVE\">Approve</span>\n</md-button></md-menu-item><md-menu-item></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Approve()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.APPROVE\">\nApprove</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th></th><th \nclass=\"text-center\" translate=\"TABLE.NO\">No</th><th translate=\"TABLE.REQUEST_BY\">Request By</th><th \nclass=\"text-center\" translate=\"TABLE.STATUS\">status</th><th class=\"text-center\">#</th></tr></thead><tbody><tr \nng-repeat=\"team in vm.DataTable.list\"><td><span ng-if=\"team.approval==0\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(team)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td class=\"text-center\">{{team.no}}\n</td><td>{{team.requestby}}-{{team.nama}}</td><td class=\"text-center\">{{team.approvalinfo}}</td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"start center\" layout-wrap><md-button \nclass=\"md-icon-button\" aria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.setViewTeam($event,team)\"><md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip>\n<span>click for view team</span></md-tooltip></md-button></section></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/hr-team-assignment-approval/hr-team-assignment-approval-print.html","<md-dialog aria-label=\"Mango (Fruit)\" class=\"popup-input-form\" flex flex-gt-sm=\"50\"><form ng-cloack \nid=\"FormPrintAssignment\" name=\"FormPrintAssignment\" class=\"popup-input-form\" novalidate layout=\"column\" flex>\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Output Documents</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-checkbox \nng-model=\"vm.Form.objForm.print_assignment.sk\" name=\"new_employee\" class=\"mt-5\" flex>Surat Keputusan</md-checkbox>\n</md-input-container><md-input-container flex><md-checkbox ng-model=\"vm.Form.objForm.print_assignment.surkom\" \nname=\"new_employee\" class=\"mt-5\" flex>Surat Komunikasi DLK</md-checkbox></md-input-container><span style=\"width: 15%\" \nhide show-gt-sm></span></div><div layout=\"column\"><div layout=\"column\"><md-input-container flex class=\"mb-0\">\n<md-checkbox ng-model=\"vm.Form.objForm.print_assignment.ba\" name=\"new_employee\" class=\"mt-5 mb-10\" flex \nng-disabled=\"vm.penyesuaian.length == 0\">BA Penyesuaian Tunjangan</md-checkbox></md-input-container><table \nclass=\"simple with-toolbar bordered stripped font-size-12\" ms-responsive-table><thead><tr><th style=\"min-width: 120px\">\nNIK / Nama</th><th width=\"120px\" ng-repeat=\"ls in vm.masterBenefits\" \nstyle=\"word-wrap: break-word; white-space: normal\" class=\"font-size-10\">{{ls.description}}</th><th width=\"60px\"></th>\n</tr></thead><tbody><tr ng-repeat=\"item in vm.detail\"><td>{{item.nik}} - {{item.empName}}</td><td \nng-repeat=\"ls in vm.masterBenefits\" class=\"font-size-10\"><div layout=\"row\" layout-align=\"center center\"><span \nng-if=\"item.benefits[$index].grouping == ls.grouping\" ng-repeat=\"ben in item.benefits\" class=\"text-center\"><span \nng-if=\"vm.indexOfFunction(item.penyesuaian, item.benefits[$index].id) >= 0\" style=\"color: #CC6600\">Penyesuaian Grade\n</span> <span ng-if=\"vm.indexOfFunction(item.penyesuaian, item.benefits[$index].id) < 0\">Sesuai Grade</span></span>\n</div></td><td class=\"text-center\" md-theme=\"defaultTheme\"><md-checkbox ng-if=\"item.penyesuaian.length > 0\" \nng-checked=\"true\" flex class=\"m-0\" readonly=\"readonly\"></md-checkbox></td></tr></tbody></table></div></div><span \nclass=\"mt-20\"></span><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-left: -15px !important; margin-right: -15px !important; margin-bottom: -15px !important\"><md-toolbar \nclass=\"md-blue-grey-50-bg\" flex><div class=\"md-toolbar-tools\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex layout=\"column\" style=\"margin: 0\"><md-checkbox ng-model=\"vm.Form.objForm.print_assignment.kop\" \nname=\"new_employee\" class=\"mt-5\" flex>Dengan Kop Surat</md-checkbox></md-input-container></div></md-toolbar></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"white-bg\" style=\"min-height: auto\"><md-button \nclass=\"md-button blue-A400-fg\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.download()\" \nng-disabled=\"!(vm.Form.objForm.print_assignment.sk || vm.Form.objForm.print_assignment.surkom || vm.Form.objForm.print_assignment.ba)\">\n<md-icon md-font-icon=\"icon-download\" class=\"blue-A400-fg\"></md-icon><span>Preview Documents</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/hr-team-assignment-approval/hr-team-assignment-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.ASSIGNMENTAPPROVAL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formSearchUpFingerApp\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\">\n<div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"TABLE.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSearchUpFingerApp.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.START_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label translate=\"TABLE.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"formSearchUpFingerApp.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.END_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" required><md-option \nng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"formSearchUpFingerApp.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"ATTENDANCE.LABEL.APPROVALTYPE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span>\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formSearchUpFingerApp.$invalid || formSearchUpFingerApp.$pristine\"></select><span \ntranslate=\"KPI.LABEL.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content style=\"width: 2\"><md-menu-item><md-button class=\"md-button md-mini\" \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon>\n<span translate=\"ACTION.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\"><i \nclass=\"icon-delete\"></i> <span translate=\"ACTION.REJECT\">Reject</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" hide show-gt-sm \ntype=\"button\" ng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.APPROVE\">Aprove</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nReject Absence</md-tooltip><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.REJECT\">Reject\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table id=\"list-hr-approval\" class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"text-center\" rowspan=\"2\" style=\"min-width: 40px !important\"><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.type ==\'waiting approval\' || vm.type ==\'all\'\"><md-checkbox \nstyle=\"margin: 0; max-width: 20px !important\" ng-model=\"vm.selectAll\" ng-checked=\"vm.isCheckedAll()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll()\"></md-checkbox></div></th><th \nclass=\"text-center\" rowspan=\"2\" style=\"min-width: 60px !important\"><span translate=\"KPI.LABEL.NO\"></span></th><th \nclass=\"text-center\" rowspan=\"2\"></th><th class=\"text-center\" colspan=\"2\" style=\"min-width: 180px !important\"><span \ntranslate=\"KPI.LABEL.DATE\"></span></th><th class=\"text-center\" colspan=\"2\" style=\"min-width: 240px !important\"><span \ntranslate=\"KPI.LABEL.COSTCENTRE\"></span></th><th class=\"text-center\" rowspan=\"2\" style=\"min-width: 120px !important\">\n<span translate=\"KPI.LABEL.DEPARTMENT\"></span></th><th class=\"text-center\" rowspan=\"2\" \nstyle=\"min-width: 120px !important\"><span translate=\"KPI.LABEL.AREA\"></span></th><th class=\"text-center\" rowspan=\"2\" \nstyle=\"min-width: 120px !important\"><span translate=\"KPI.LABEL.REQUESTBY\"></span></th><th class=\"text-center\" \nrowspan=\"2\" style=\"min-width: 120px !important\"><span translate=\"KPI.LABEL.APPROVAL\"></span></th></tr><tr><th \nclass=\"text-center\" style=\"min-width: 90px !important\"><span translate=\"MYPROFILE.MENU.START\"></span></th><th \nclass=\"text-center\" style=\"min-width: 90px !important\"><span translate=\"MYPROFILE.MENU.END\"></span></th><th \nclass=\"text-center\" style=\"min-width: 120px !important\"><span translate=\"KPI.LABEL.CNB\"></span></th><th \nclass=\"text-center\" style=\"min-width: 120px !important\"><span translate=\"KPI.LABEL.NONCNB\"></span></th></tr></thead>\n<tbody><tr ng-repeat=\"team in vm.DataTable.list\"><td class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"(vm.type ==\'waiting approval\' || vm.type ==\'all\') && team.approval==0\"><md-checkbox\n style=\"margin: 0\" ng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team, $event)\"></md-checkbox></div></td><td\n class=\"text-center\">{{team.no}}</td><td class=\"text-center\"><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\" style=\"overflow: visible\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon><div \nclass=\"md-background-bg md-hue-3 detail-assignment-counter ng-binding ng-scope\">{{team.employee.length}}</div>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item><md-button aria-label=\"More\" \nng-click=\"vm.viewDetail($event, team, team.employee)\" layout=\"row\"><span flex translate=\"UMUT.MENU.DETAIL\">Detail\n</span> <span class=\"badge-assignment-approval md-background-bg md-hue-3\">{{team.employee.length}}</span></md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item layout=\"column\" \nng-style=\"team.last_previewed && {\'height\':\'96px\'} || {\'height\': \'48px\'}\" layout-align=\"start\"><md-button \naria-label=\"More\" ng-click=\"vm.printLetter($event, team, team.employee)\" ng-disabled=\"team.approval!=1\" \nng-style=\"team.last_previewed && {\'height\': \'48px\'}\"><md-icon md-font-icon=\"icon-printer\"></md-icon><span \ntranslate=\"KPI.LABEL.PRINT\"></span></md-button><div layout=\"column\" ng-if=\"team.approval==1 && team.last_previewed\">\n<span><small>Last Previewed</small></span> <span ng-if=\"!team.last_previewed\"><small>-</small></span> <span \nng-if=\"team.last_previewed\"><small>{{vm.resolveDate(team.last_previewed)}}</small></span></div></md-menu-item>\n<md-divider></md-divider><md-menu-item ng-if=\"inls.approval_type == \'admin-emp\'\" \nng-repeat-start=\"inls in team.approval_data\"><md-button ng-click=\"vm.UnApproved($event,team.id)\" \nng-disabled=\"inls.approval_status!=\'2\'\" aria-label=\"\"><span translate=\"ACTION.UNAPPROVE\">Un-approve</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"inls.approval_type == \'admin-emp\'\" ng-repeat-end><md-button \nng-click=\"vm.UnReject($event,inls)\" ng-disabled=\"inls.approval_status!=\'4\'\" aria-label=\"{{inls.approval_status!=\'4\'}}\">\n<span translate=\"ACTION.UNREJECT\">Un-reject</span></md-button></md-menu-item></md-menu-content></md-menu></td><td \nclass=\"text-center\">{{team.startDate}}</td><td class=\"text-center\">{{team.endDate}}</td><td>{{team.descCnb}}</td><td>\n{{team.descNonCnb}}</td><td>{{team.departmentName}}</td><td>{{team.subAreaName}}</td><td>\n{{team.assign_by}} - {{team.assignByName}}</td><td style=\"min-width: 120px !important\"><div layout=\"column\" \nflex=\"noshrink\"><span ng-if=\"inls.approval_status!=\'4\'\" flex=\"noshrink\" layout=\"row\" \nng-repeat-start=\"inls in team.approval_data\"><md-tooltip md-direction=\"bottom\">\n{{inls.approval_type | uppercase}}: {{inls.appName}}</md-tooltip><md-icon \nng-if=\"inls.approval_type != \'admin-emp\' && inls.approval_status==\'1\'\" md-font-icon=\"icon-account\" \nng-class=\"inls.approval_status==\'2\' ? \'md-primary-fg\' : inls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nflex=\"nogrow\"></md-icon><md-icon \nng-if=\"inls.approval_type == \'admin-emp\' && (inls.approval_status==\'1\' || inls.approval_status==\'2\')\" \nmd-font-icon=\"icon-account-key\" \nng-class=\"inls.approval_status==\'2\' ? \'md-primary-fg\' : inls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nflex=\"nogrow\"></md-icon><span \nng-if=\"(inls.approval_type != \'admin-emp\' && inls.approval_status==\'1\') || (inls.approval_type == \'admin-emp\' && (inls.approval_status==\'1\' || inls.approval_status==\'2\'))\" \nng-class=\"inls.approval_status==\'2\' ? \'md-primary-fg\' : inls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nclass=\"font-size-12 line-height-24 ml-5\" flex>{{inls.status_name}}</span> </span><span \nng-if=\"inls.approval_status==\'4\'\" flex=\"noshrink\" layout=\"row\" ng-repeat-end><md-icon \nng-if=\"inls.approval_type != \'admin-emp\'\" md-font-icon=\"icon-account\" class=\"md-accent-fg\" flex=\"nogrow\"><md-tooltip \nmd-direction=\"bottom\">{{inls.approval_type | uppercase}}: {{inls.appName}}</md-tooltip></md-icon><md-icon \nng-if=\"inls.approval_type == \'admin-emp\'\" md-font-icon=\"icon-account-key\" class=\"black-fg\" flex=\"nogrow\"><md-tooltip \nmd-direction=\"bottom\">{{inls.approval_type | uppercase}}: {{inls.appName}}</md-tooltip></md-icon><md-button md-no-ink \nclass=\"md-accent-fg\" ng-click=\"vm.viewComment($event,inls)\" class=\"font-size-12 line-height-24 ml-5\" flex>\n{{inls.status_name}}</md-button><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span></div></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr><tr class=\"text-center\" \nng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"KPI.MESSAGE.PLEASEFILTERDATA\">Please, Filter Data</span></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\" \nng-if=\"nav.disabled!==1\">{{nav.label}}</a> <span ng-if=\"nav.disabled===1\">{{nav.label}}</span></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/itinerary/itinerary.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span class=\"parent\" translate=\"MENU.CB.ITINERARY.INDEX.HEADER.TITLE\">Itinerary</span></md-subheader>\n<div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><form \nname=\"basicForm\" class=\"md-inline-form has-upload\" novalidate><fieldset><legend \ntranslate=\"MENU.CB.ITINERARY.INDEX.HEADER.UPLOAD_ITINERARY\">Upload Itinerary</legend><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFilePeople\" nv-file-select \nuploader=\"vm.FileuploaderItenerary\"></div><div class=\"text-right\" flex><md-button type=\"button\" \nng-click=\"vm.FileuploaderItenerary.uploadAll()\" class=\"md-raised md-green-500-bg green-50-fg\" aria-label=\"Submit\">\n<md-icon md-font-icon=\"icon-download\" class=\"green-50-fg\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button></div></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileuploaderItenerary.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadIteneraryStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span translate=\"NOTIF.ERROR_UPLOAD\">Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadIteneraryStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span translate=\"NOTIF.SUCCESS_UPLOAD\">Success Upload data</span>\n</md-whiteframe></md-content></fieldset></form></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/hr-update-finger-approval/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\"><div layout=\"column\"><div layout-gt-sm=\"row\" ng-if=\"!vm.stateView\">\n<md-input-container flex><input type=\"text\" name=\"comment\" ng-disabled=\"vm.isdisabled\" \nng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.UPDATE_FINGER_APPROVAL.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.rejected_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span><md-button \nng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/cb/hr-update-finger-approval/hr-update-finger-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Update Finger Approval</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"!vm.budisabled\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\" \nrequired><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container flex><md-select ng-model=\"vm.flag_app\" \nng-disabled=\"vm.flagAppDisabled\" ng-change=\"vm.getPeriode()\" name=\"flag_app\" required><md-option \nng-repeat=\"val in vm.flagApp\" placeholder=\"{{ \'FILTER.FLAG_APP\' | translate }}\" value=\"{{val}}\"><span \ntranslate=\"FILTER.{{val}}\">{{val}}</span></md-option></md-select><div ng-messages=\"frmEmploye.flag_app.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"frmSearchViewDataAbnormal.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"frmSearchViewDataAbnormal.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.type\" name=\"type\" required><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Building</label><md-select ng-model=\"vm.gedung\" name=\"building\" required><md-option \nng-repeat=\"val in vm.listGedung\" placeholder=\"Building\" value=\"{{val.id}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.building.$error\" role=\"alert\"><div ng-message=\"required\"><span>Building field is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \nng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>\n<span>Search</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span>Entries</span></md-input-container><div \nclass=\"divider-vertical\"></div><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" type=\"button\" hide \nshow-gt-sm type=\"button\" ng-click=\"vm.approveData($event)\"><md-icon md- font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.ACTION.APPROVE\">Aprove</span></md-button><div class=\"divider-vertical\" \nhide show-gt-sm></div><md-button class=\"md-warn md-mini\" aria-label=\"Inert\" ng-click=\"vm.Reject($event)\" hide \nshow-gt-sm><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Reject Absence</md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon><span translate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.ACTION.REJECT\">Reject\n</span></md-button><span flex></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-toolbar hide-gt-sm><div class=\"md-toolbar-tools table-tools\" \nlayout=\"row\"><md-button ng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveData($event)\" flex><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\n<span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Approve</span></md-button><div \nng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical\" flex=\"nogrow\"></div><md-button \nng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" aria-label=\"Delete\" ng-click=\"vm.Reject($event)\" \ntype=\"button\" flex=\"nogrow\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Reject</span>\n</md-tooltip><md-icon md-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span>\nReject</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\">\n<span ng-if=\"vm.type ==\'waiting approval\'\"><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\">\n</md-checkbox></span></th><th rowspan=\"2\" translate=\"TABLE.NIK\">NIK</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.NAME\">Name</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.WORKING_DATE\">Working Date</th><th colspan=\"4\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.ACTUAL_DATE\">Actual Data</th><th colspan=\"4\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.UPDATE_DATA\">Update Data</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.DESCRIPTION\">Description</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.STATUS\">Status</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.ACTION\">Action</th></tr><tr><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.IN\">IN</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_IN\">Break In</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.OUT\">Out</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.IN\">IN</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_IN\">Break In</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.OUT\">Out</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list track by $index \"><td class=\"text-center\"><span ng-if=\"ls.approval==0\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.exists(ls, vm.listOtselected)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td>{{ls.nik}}</td>\n<td>{{ls.nama}}</td><td>{{ls.working_date}}</td><td class=\"text-center\"><span ng-if=\"ls.actin !=\'empty\'\">{{ls.actin}}\n</span></td><td class=\"text-center\"><span ng-if=\"ls.actbreakOut !=\'empty\'\">{{ls.actbreakOut}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.actout !=\'empty\'\">{{ls.actout}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curin !=\'empty\'\">\n{{ls.curin}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curbreakOut !=\'empty\'\">{{ls.curbreakOut}}</span></td>\n<td class=\"text-center\"><span ng-if=\"ls.curbreakIn !=\'empty\'\">{{ls.curbreakIn}}</span></td><td class=\"text-center\">\n<span ng-if=\"ls.curout !=\'empty\'\">{{ls.curout}}</span></td><td>{{ls.description}}</td><td class=\"text-center\"><span \nng-if=\"ls.approval==1\">Approved</span> <span ng-if=\"ls.approval==2\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\">\nRejected</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span><span ng-if=\"ls.approval==0\">\nWaiting Approval</span></td><td><md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-if=\"ls.approval==1\"><md-button ng-click=\"vm.UnApproved($event,ls)\" \naria-label=\"Flip widget\"><span translate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.ACTION.UNAPPROVE\">Un-approve</span>\n</md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==2\"><md-button ng-click=\"vm.UnReject($event,ls)\" \naria-label=\"Flip widget\"><span translate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.ACTION.UNREJECT\">Un-reject</span>\n</md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"15\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length>0\" class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/join-holiday/join-holiday.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span class=\"logo-text\" translate=\"MENU.CB.JOIN_HOLIDAY.INDEX.HEADER.TITLE\">Join Holiday</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" aria-label=\"company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required>\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.divisi\" aria-label=\"divisi\" name=\"{{ \'FILTER.DIVISI\' | translate }}\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Department</label><md-select ng-model=\"vm.department\" \naria-label=\"department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Sub Area</label><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" value=\"{{ls.subarea_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"FilterLeaveHold\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n</div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addJoinHoliday($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Create new</span></md-tooltip><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.NEW\">Create new</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteData($event)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete</span></md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span class=\"red-700-fg\" \ntranslate=\"ACTION.DELETE\">Delete</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"filter\" ng-click=\"\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"FILTER.TITLE\">Filter</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"addJoinHoliday\" ng-click=\"vm.addJoinHoliday()\">\n<md-icon md-font-icon=\"icon-border-color\"></md-icon><span translate=\"ACTION.NEW\">Create New</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content style=\"background:white\" hide-gt-sm><span \nflex=\"5\"></span><md-list class=\"md-dense\" flex><md-list-item class=\"md-3-line\" ng-repeat=\"item in vm.DataTables.list\" \nng-click=\"null\"><div class=\"md-list-item-text\" layout=\"column\"><h4>Hold By {{ item.name }} | {{ item.nik }}</h4><p>\nStart Date : {{ item.start_date }}</p><p>End Date : {{item.end_date}}</p><p>Sub Area : {{item.description}}</p></div>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"LeaveHoldMenu\" class=\"md-icon-button\" \nstyle=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.editLeaveHold($event, item)\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-border-color\"></md-icon><p flex><span translate=\"ACTION.EDIT\">edit</span></p></div></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.detailLeaveHold($event, item)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"ACTION.VIEW_DETAIL\">View detail</span>\n</p></div></md-button></md-menu-item></md-menu-content></md-menu><md-divider \nstyle=\"border-width:0.5px; border-color:whitesmoke; border-style: solid\"></md-divider></md-list-item></md-list><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\" translate=\"TABLE.NO\">NO</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.HOLD_BY\">Hold By</span></th><th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.NIK\">\nNIK</span></th><th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.START_DATE\">start date</span></th>\n<th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.END_DATE\">end date</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.DESCRIPTION\">Description</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.SUB_AREA\">Sub area</span></th><th width=\"2%\"></th></tr>\n</thead><tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\" \nng-dblclick=\"vm.detailLeaveHold($event, item)\"><td class=\"text-center\"><md-checkbox aria-label=\"LeaveHoldChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.name}}</td><td class=\"text-center\">{{item.nik}}\n</td><td class=\"text-center\">{{item.start_date}}</td><td class=\"text-center\">{{item.end_date}}</td><td \nclass=\"text-center\">{{item.description}}</td><td class=\"text-center\">{{item.subarea}}</td><td><section layout=\"row\" \nlayout-sm=\"column\" class=\"no-padding\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"LeaveHoldMenu\" class=\"md-icon-button\" \nstyle=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"vm.convertTime(item.start_date) < vm.currentDate\" ng-click=\"vm.editLeaveHold($event, item)\"><div \nlayout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\">edit</span></p></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.detailLeaveHold($event, item)\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"ACTION.VIEW_DETAIL\">View detail</span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span>No Data Available</span></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employee-acting/employe-acting-extend.html","<md-dialog aria-label=\"Employee Acting Extend\" flex=\"50\"><form ng-cloak name=\"frmActingExtend\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.submitActingExtend($event)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nEmployee Acting Extend</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\"><div flex-gt-sm=\"100\" flex=\"100\" layout=\"column\"><md-subheader \nclass=\"searchForm\"><md-input-container style=\"width: 100%\"><label>Search</label><input ng-model=\"vm.searchParam\">\n</md-input-container></md-subheader><md-content layout=\"column\" layout-gt-xs=\"row\" style=\"max-height:400px\"><md-list \nflex><md-list-item ng-if=\"vm.isLoadingLoadEmployee\"><md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\">\n</md-progress-circular></md-list-item><md-list-item class=\"md-3-line\" \nng-repeat-start=\"item in vm.empList | filter:vm.searchParam\" ng-click=\"vm.selectEmployee(item)\"><div \nclass=\"md-list-item-text\" layout=\"column\"><input type=\"hidden\" name=\"nik\" ng-model=\"item.nik\"> <input type=\"hidden\" \nname=\"idJic\" ng-model=\"item.id\"><h3>{{ item.nama_karyawan }} ({{item.nik}})</h3></div><div layout=\"column\" \nclass=\"md-secondary\"><md-input-container md-no-float class=\"md-block\" flex><label>Effective Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"effectiveDate\" ng-model=\"item.effectiveDate\" required></md-datepicker><div \nng-messages=\"frmActingExtend.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\neffectiveDate Date Required.</span></div></div></md-input-container></div></md-list-item><md-divider ng-repeat-end>\n</md-divider></md-list></md-content><div style=\"padding: 0em 1em\"><div class=\"is-bottom-nav margin-top-5\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\" \nclass=\"white-bg\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button\n class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-refresh white-fg\">\n</md-icon>CANCEL</md-button><md-button type=\"submit\" class=\"blue-500-bg md-raised white-fg\" \nng-disabled=\"frmActingExtend.$invalid\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>SAVE</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employee-acting/employee-acting.html","<div id=\"header-action\" class=\"page-layout simple fullwidth with-toolbar-content\" layout=\"column\"><div \nclass=\"header nabati2\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cog\"></md-icon></span><span \nclass=\"logo-text\" translate=\"EMP.ACTING.HEADER\"></span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\"></div></div></div></div><div layout=\"column\" layout-fill class=\"content padding\"><div \nclass=\"md-whiteframe-2dp\"><div class=\"form-wrapper\"></div><md-content class=\"\" layout=\"column\"><div layout=\"column\" \nflex><div class=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>\nFilter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Type</label><md-select \nng-model=\"vm.type\" required><md-option ng-repeat=\"val in vm.listType\" placeholder=\"Type\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.company\" ng-disabled=\"vm.budisabled\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\"><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" ng-disabled=\"vm.divdeptdisabled\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\">\n<md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" \nng-disabled=\"vm.divdeptdisabled\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"right right\"><md-input-container flex><label>Start Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div \nng-messages=\"frmInsurance.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.end_date\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-input-container flex><md-button type=\"submit\" layout=\"row\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon>Submit</md-button></md-input-container></div></form></div></div>\n</md-content><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools\"><select style=\"font-size:14px\" \nhide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">\n&nbsp;Entries</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.processData($event,\'pass\')\"><md-icon \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-check blue-700-fg\"></md-icon><md-icon \nng-if=\"vm.selected.length == 0\" md-font-icon=\"icon-check grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" \nclass=\"blue-700-fg\" translate=\"EMP.ACTING.PASS\"></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\" \ntranslate=\"EMP.ACTING.PASS\"></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.processData($event, \'fail\')\"><md-icon \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-account-remove red-700-fg\"></md-icon><md-icon \nng-if=\"vm.selected.length == 0\" md-font-icon=\"icon-account-remove grey-700-fg\"></md-icon><span \nng-if=\"vm.selected.length > 0\" class=\"red-700-fg\" translate=\"EMP.ACTING.FAIL\"></span> <span \nng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\" translate=\"EMP.ACTING.FAIL\"></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.extendActing($event)\"><md-icon \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-account-multiple green-700-fg\"></md-icon><md-icon \nng-if=\"vm.selected.length == 0\" md-font-icon=\"icon-account-multiple grey-700-fg\"></md-icon><span \nng-if=\"vm.selected.length > 0\" class=\"green-700-fg\" translate=\"EMP.ACTING.EXTEND\"></span> <span \nng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\" translate=\"EMP.ACTING.EXTEND\"></span></md-button><span flex hide \nshow-gt-sm></span><div layout layout-padding flex><form ng-submit=\"vm.loadData(1)\" style=\"margin-bottom:0\" \nname=\"formSearch\" flex><md-input-container md-no-float class=\"md-block\" style=\"margin-bottom:0\" flex><md-icon \nmd-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\"></md-icon><input type=\"text\" placeholder=\"Nik/Name\" \nng-model=\"vm.DataTables.searchParam\" id=\"formSearch\"></md-input-container></form></div></div></md-toolbar><div \nclass=\"simple-table-container\" hide show-gt-sm><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar stripped upper-case-header\" ms-responsive-table><thead><tr><th width=\"5%\">\n</th><th width=\"5%\"><span class=\"column-title\" translate=\"EMP.ACTING.TABLE.NO\"></span></th><th class=\"text-center\">\n<span class=\"column-title\" translate=\"EMP.ACTING.TABLE.NIK\"></span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"EMP.ACTING.TABLE.NAME\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.EFFECTIVE_DATE\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.COMPANY\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.OLD_GRADE\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.NEW_GRADE\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.DIRECT_REPORT\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.OLD_ABBREVIATION\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.NEW_ABBREVIATION\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.OLD_COST_CNB\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.NEW_COST_CNB\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.OLD_COST_NONCNB\"></span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"EMP.ACTING.TABLE.NEW_COST_NONCNB\"></span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox ng-if=\"item.acting_result == \'progress\'\" \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td>{{($index + 1)}}</td><td class=\"text-center\">{{item.nik}}</td><td class=\"text-center\">\n{{item.nama_karyawan}}</td><td class=\"text-center\">{{item.effective_date}}</td><td class=\"text-center\">{{item.company}}\n</td><td class=\"text-center\">{{item.old_emp_grade}}</td><td class=\"text-center\">{{item.to_empgrade}}</td><td \nclass=\"text-center\">{{item.direct_report}}</td><td class=\"text-center\">{{item.old_abbreviattion}}</td><td \nclass=\"text-center\">{{item.to_abbreviation}}</td><td class=\"text-center\">{{item.old_cnb}}</td><td class=\"text-center\">\n{{item.to_cnb}}</td><td class=\"text-center\">{{item.old_noncnb}}</td><td class=\"text-center\">{{item.to_noncnb}}</td>\n</tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"12\" class=\"text-center\"><span \ntranslate=\"EMP.ACTING.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div></div></div>");
$templateCache.put("app/main/cb/leave-hold/leave-hold.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span class=\"logo-text\" translate=\"MENU.CB.LEAVE_HOLD.INDEX.HEADER.TITLE\">Leave Hold</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" aria-label=\"company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.divisi\" aria-label=\"divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" \nrequired><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVIS\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Department</label><md-select ng-model=\"vm.department\" aria-label=\"department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"FILTER.SUB_AREA\">Sub Area</label><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\">\n<md-option ng-repeat=\"ls in vm.subArea\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \naria-label=\"FilterLeaveHold\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><span \ntranslate=\"ACTION.SUBMIT\">Submit</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div\n class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"TABLE.ENTRIES\">Entries\n</span></span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-raised md-primary btn-ui-serif\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addLeaveHold($event)\"><span translate=\"ACTION.NEW\">\nCreate new</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.selected.length == 0\" \nng-click=\"vm.deleteDataGroup($event)\"><md-icon ng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\">\n</md-icon><md-icon ng-if=\"vm.selected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.selected.length > 0\" class=\"red-700-fg\" translate=\"ACTION.DELETE\">Delete</span> <span \nng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\" translate=\"ACTION.DELETE\">Delete</span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"filter\" ng-click=\"\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span translate=\"FILTER.TITLE\">Filter</span></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"Addleavehold\" \nng-click=\"vm.addLeaveHold()\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span translate=\"ACTION.NEW\">\nCreate New</span></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"></th><th width=\"5%\"><span class=\"column-title\" translate=\"TABLE.NO\">NO\n</span></th><th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.HOLD_BY\">Hold By</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.START_DATE\">start date</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.END_DATE\">end date</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.DESCRIPTION\">Description</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.SUB_AREA\">Sub area</span></th><th width=\"2%\"></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\" ng-dblclick=\"vm.detailLeaveHold($event, item)\"><td>\n<md-checkbox aria-label=\"LeaveHoldChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td>{{($index + 1)}}</td><td class=\"text-center\">\n{{item.name}}</td><td class=\"text-center\">{{item.hold_by}}</td><td class=\"text-center\">{{item.start_date}}</td><td \nclass=\"text-center\">{{item.end_date}}</td><td class=\"text-center\">{{item.description}}</td><td class=\"text-center\">\n{{item.subarea}}</td><td><section layout=\"row\" layout-sm=\"column\" class=\"no-padding\" layout-align=\"start center\" \nlayout-wrap><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"LeaveHoldMenu\" \nclass=\"md-icon-button\" style=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-disabled=\"vm.convertTime(item.start_date) < vm.currentDate\" ng-click=\"vm.editLeaveHold($event, item)\">\n<div layout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex><span \ntranslate=\"ACTION.EDIT\">edit</span></p></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.detailLeaveHold($event, item)\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"ACTION.VIEW_DETAIL\">View detail</span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span>No Data Available</span></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/leave-balance/leave-balance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.LEAVE_BALANCE\"></span></md-subheader><div class=\"white-bg\"><md-toolbar>\n<md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.NewLeaveRequest($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"UMUT.MENU.NEW\"></span></md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"md-toolbar-tools table-tools\"><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" \nng-click=\"vm.NewLeaveRequest($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"UMUT.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"UMUT.MENU.NEW\"></span></md-button></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" colspan=\"2\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.LEAVE_PERIOD\">Leave Period</th><th class=\"text-center\" colspan=\"2\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.USAGE_PERIOD\">Usage Period</th><th class=\"text-center\" rowspan=\"2\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.ANNUAL_LEAVE\">Annual Leave</th><th class=\"text-center\" rowspan=\"2\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.JOIN_HOLIDAY\">Join Holiday</th><th class=\"text-center\" rowspan=\"2\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.HOLD_LEAVE\">Hold Leave</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.CARRY\">Carry</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.PAYLEAVE\">Payleave</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.LEAVE_BALANCE\">Leave Balance</th></tr><tr><th class=\"text-center\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.START_DATE\">Start Date</th><th class=\"text-center\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.END_DATE\">End Date</th><th class=\"text-center\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.START_DATE\">Start Date</th><th class=\"text-center\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.INDEX.TABLE.END_DATE\">End Date</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listDataLeave\"><td class=\"text-center\">{{ls.startPeriode}}</td><td class=\"text-center\">\n{{ls.endPeriode}}</td><td class=\"text-center\">{{ls.startUsage}}</td><td class=\"text-center\">{{ls.endUsage}}</td><td \nclass=\"text-center\"><span ng-if=\"ls.totalAnnualLeave > 0\"><a href=\"\" ng-click=\"vm.viewAnnuaLeaveLog(ls,$event)\">\n{{ls.totalAnnualLeave}}</a><md-tooltip md-direction=\"top\"><span translate=\"ATTENDANCE.LABEL.VIEWANNUALLEAVELOG\"></span>\n</md-tooltip></span></td><td class=\"text-center\"><span ng-if=\"ls.totalSubs > 0\"><a href=\"\" \nng-click=\"vm.viewSubsLeaveLog(ls,$event)\">{{ls.totalSubs}}</a><md-tooltip md-direction=\"top\"><span \ntranslate=\"ATTENDANCE.LABEL.VIEWJOINHOLIDAYLOG\"></span></md-tooltip></span></td><td class=\"text-center\"><span \nng-if=\"ls.totalHoldLeave>0\"><a href=\"\" ng-click=\"vm.viewHoldLeaveLog(ls,$event)\">{{ls.totalHoldLeave}}</a><md-tooltip \nmd-direction=\"top\"><span translate=\"ATTENDANCE.LABEL.VIEWHOLDLEAVELOG\"></span></md-tooltip></span></td><td \nclass=\"text-center\"><span ng-if=\"ls.carry > 0\">{{ls.carry}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.payLeave > 0\">{{ls.payLeave}}</span></td><td class=\"text-center\">{{ls.totalLeave}}</td></tr><tr \nclass=\"text-center\" ng-if=\"(vm.listDataLeave | typeOf) == \'undefined\'\"><td colspan=\"10\" class=\"text-center\"><span>\nLoading, Please Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.listDataLeave.length <= 0\"><td colspan=\"10\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/leave-balance/new-leave-request.html","<md-dialog aria-label=\"Form Input Leave\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"frmLeaveRequest\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmLeaveRequest)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.LEAVE_BALANCE.FORM_INPUT.TITLE\">Form Input Annual Leave</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout=\"column\" class=\"ph-5\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE_BALANCE.FORM_INPUT.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"frmLeaveRequest.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex flex-offset-gt-sm=\"5\"><label \ntranslate=\"MENU.CB.LEAVE_BALANCE.FORM_INPUT.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.Form.objForm.start_date\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\"></md-datepicker><div \nng-messages=\"frmLeaveRequest.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container></div><div layout=\"column\"><md-input-container flex><input type=\"text\" \nname=\"description\" ng-model=\"vm.Form.objForm.description\" \nplaceholder=\"{{ \'MENU.CB.LEAVE_BALANCE.FORM_INPUT.DESCRIPTION\' | translate }}\" required><div \nng-messages=\"frmLeaveRequest.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>description is required.\n</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" class=\"is-md-accent md-accent md-button\" aria-label=\"Submit\" \nng-disabled=\"frmLeaveRequest.$invalid || frmLeaveRequest.$pristine\" translate=\"MENU.CB.LEAVE_BALANCE.FORM_INPUT.SAVE\">\nSave</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/leave-balance/view-annualleave-log.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2 translate=\"MENU.CB.LEAVE_BALANCE.VIEW_ANNUAL_LOG.TITLE\">View Annual Leave Log</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><table \nclass=\"simple striped\" ms-responsive-table style=\"margin-top:0\"><thead><tr><th width=\"15%\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.LEAVE_BALANCE.VIEW_ANNUAL_LOG.START_DATE\">Start Date</span></th><th \nwidth=\"15%\" class=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.LEAVE_BALANCE.VIEW_ANNUAL_LOG.END_DATE\">\nEnd Date</span></th><th width=\"15%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.VIEW_ANNUAL_LOG.DURATION\">Duration</span></th><th width=\"15%\" class=\"text-center\">\n<span class=\"column-title\" translate=\"MENU.CB.LEAVE_BALANCE.VIEW_ANNUAL_LOG.HOLIDAY\">Holiday</span></th><th \nwidth=\"15%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.VIEW_ANNUAL_LOG.DESCRIPTION\">Description</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listData\" ng-class=\"{\'empholiday\':ls.jumHoliday>0}\"><td class=\"text-center\"><span \nng-if=\"ls.jumHoliday>0\" class=\"text-italic\">{{ls.start_date}}</span> <span ng-if=\"ls.jumHoliday==0\">{{ls.start_date}}\n</span></td><td class=\"text-center\"><span ng-if=\"ls.jumHoliday>0\" class=\"text-italic\">{{ls.end_date}}</span> <span \nng-if=\"ls.jumHoliday==0\">{{ls.end_date}}</span></td><td class=\"text-center\"><span ng-if=\"ls.jumHoliday>0\" \nclass=\"text-italic\">{{ls.jumDays}}</span> <span ng-if=\"ls.jumHoliday==0\">{{ls.jumDays}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.jumHoliday>0\" class=\"text-italic\">{{ls.jumHoliday}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.jumHoliday>0\" class=\"text-italic\">{{ls.description}}</span> <span \nng-if=\"ls.jumHoliday==0\">{{ls.description}}</span></td></tr><tr ng-if=\"vm.listData.length <= 0\"><td colspan=\"3\" \nclass=\"text-center\"><span>No Data Available</span></td></tr></tbody></table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/leave-balance/view-holdleave-log.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2 translate=\"MENU.CB.LEAVE_BALANCE.VIEW_HOLD_LOG.TITLE\">View Hold Leave Log</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"15%\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.LEAVE_BALANCE.VIEW_HOLD_LOG.START_DATE\">Start Date</span></th><th width=\"15%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"MENU.CB.LEAVE_BALANCE.VIEW_HOLD_LOG.END_DATE\">End Date</span>\n</th><th width=\"15%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.VIEW_HOLD_LOG.DESCRIPTION\">Description</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listData\"><td class=\"text-center\"><span>{{ls.start_date}}</span></td><td class=\"text-center\"><span>\n{{ls.end_date}}</span></td><td class=\"text-center\"><span>{{ls.description}}</span></td></tr><tr \nng-if=\"vm.listData.length <= 0\"><td colspan=\"3\" class=\"text-center\"><span>No Data Available</span></td></tr></tbody>\n</table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/leave-balance/view-subsleave-log.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2 translate=\"MENU.CB.LEAVE_BALANCE.VIEW_SUBSLEAVE_LOG.TITLE\">View Hold Leave Log</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"15%\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"MENU.CB.LEAVE_BALANCE.VIEW_SUBSLEAVE_LOG.START_DATE\">Start Date</span></th><th \nwidth=\"15%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.VIEW_SUBSLEAVE_LOG.END_DATE\">End Date</span></th><th width=\"15%\" class=\"text-center\">\n<span class=\"column-title\" translate=\"MENU.CB.LEAVE_BALANCE.VIEW_SUBSLEAVE_LOG.DURATION\">Duration</span></th><th \nwidth=\"15%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.LEAVE_BALANCE.VIEW_SUBSLEAVE_LOG.HOLIDAY\">Holiday</span></th><th width=\"15%\" class=\"text-center\">\n<span class=\"column-title\" translate=\"MENU.CB.LEAVE_BALANCE.VIEW_SUBSLEAVE_LOG.DESCRIPTION\">Description</span></th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\" ng-class=\"{\'empholiday\':ls.jumHoliday>0}\"><td \nclass=\"text-center\"><span ng-if=\"ls.jumHoliday>0\" class=\"text-italic\">{{ls.start_date}}</span> <span \nng-if=\"ls.jumHoliday==0\">{{ls.start_date}}</span></td><td class=\"text-center\"><span ng-if=\"ls.jumHoliday>0\" \nclass=\"text-italic\">{{ls.end_date}}</span> <span ng-if=\"ls.jumHoliday==0\">{{ls.end_date}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.jumHoliday>0\" class=\"text-italic\">{{ls.jumDays}}</span> <span \nng-if=\"ls.jumHoliday==0\">{{ls.jumDays}}</span></td><td class=\"text-center\"><span ng-if=\"ls.jumHoliday>0\" \nclass=\"text-italic\">{{ls.jumHoliday}}</span></td><td class=\"text-center\"><span ng-if=\"ls.jumHoliday>0\" \nclass=\"text-italic\">{{ls.description}}</span> <span ng-if=\"ls.jumHoliday==0\">{{ls.description}}</span></td></tr><tr \nng-if=\"vm.listData.length <= 0\"><td colspan=\"3\" class=\"text-center\"><span>No Data Available</span></td></tr></tbody>\n</table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/leave-report/leave-report.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.LEAVE_REPORT.INDEX.HEADER.TITLE\">Leave Report</span></md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"FILTER.TITLE\">Filter Data</span></div><div ng-if=\"vm.groupLogin!=11\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\">\n<md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container flex><md-select ng-model=\"vm.flag_app\" \nname=\"flag_app\" ng-change=\"vm.getPeriode()\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon>Search</md-button></div></div><div ng-if=\"vm.groupLogin==11\"><div\n layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\">\n<md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.flag_app\" name=\"flag_app\" \nng-change=\"vm.getPeriode()\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Search</span></md-button></div>\n</div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div ng-if=\"vm.groupLogin!=11\" \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span>\n</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-button aria-label=\"Twitter\" class=\"md-raised md-primary btn-ui-serif\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" hide show-gt-sm ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD\">Download</span></md-tooltip><span \ntranslate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-button></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th width=\"15%\">\n<span class=\"column-title\" translate=\"TABLE.NAME\">Name</span></th><th width=\"15%\"><span class=\"column-title\" \ntranslate=\"TABLE.LEAVE_NAME\">Leave Name</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.START_DATE\">Start Date</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.END_DATE\">End Date</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.START_TIME\">Start Time</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.END_TIME\">End Time</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.DESCRIPTION\">Description</span></th><th><span class=\"column-title\" translate=\"TABLE.DOWNLOAD\">Download\n</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td class=\"text-center\">{{ls.nik }}</td><td>\n{{ls.empname }}</td><td>{{ls.code}}-{{ls.name}}</td><td class=\"text-center\">{{ls.tanggal}}</td><td class=\"text-center\">\n{{ls.tanggal}}</td><td class=\"text-center\"><span ng-if=\"ls.start_time !==\'00:00\'\">{{ls.start_time }}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.end_time !==\'00:00\'\">{{ls.absence.end_time}}</span></td><td>{{ls.description}}</td>\n<td class=\"text-center\"><span ng-if=\"ls.download\"><md-icon class=\"green-500-fg\" md-font-icon=\"icon-check\"></md-icon>\n</span></td></tr><tr ng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>No Data Available</span>\n</td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/list-overtime/list-overtime.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.LIST_OVERTIME\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.FILTER_DATA\">Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option ng-repeat=\"ls in vm.appstatus\" \nplaceholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" value=\"{{ls.value}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"formInputOT.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nabs_code field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.start_date\" flex=\"30\"></md-datepicker><div ng-messages=\"formInputOT.start_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" flex=\"30\"></md-datepicker>\n<div ng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span>\n</md-input-container><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th translate=\"MENU.CB.LIST_OVERTIME.INDEX.TABLE.TYPE\">Type</th><th \ntranslate=\"MENU.CB.LIST_OVERTIME.INDEX.TABLE.DATE\">Date</th><th \ntranslate=\"MENU.CB.LIST_OVERTIME.INDEX.TABLE.START_TIME\">Start Time</th><th \ntranslate=\"MENU.CB.LIST_OVERTIME.INDEX.TABLE.END_TIME\">End Time</th><th \ntranslate=\"MENU.CB.LIST_OVERTIME.INDEX.TABLE.REST_HOUR\">Rest Hour</th><th \ntranslate=\"MENU.CB.LIST_OVERTIME.INDEX.TABLE.REASON\">Reason</th><th \ntranslate=\"MENU.CB.LIST_OVERTIME.INDEX.TABLE.STATUS\">Status</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"(ls.approval==0)?vm.editData(ls.id):\'\'\"><td>{{ls.ot_type}}</td><td>\n{{ls.ot_date}}</td><td>{{ls.start_time}}</td><td>{{ls.end_time}}</td><td>{{ls.rest_hour}}</td><td>{{ls.reason}}</td>\n<td><span ng-if=\"ls.approval==1\">Approved</span> <span ng-if=\"ls.approval==0\">Waiting Approval</span> <span \nng-if=\"ls.approval==2\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip md-direction=\"top\">\nView Comment</md-tooltip></span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td \ncolspan=\"7\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/lock-transaction/input-lock-transaction.html","<md-dialog aria-label=\"Uplaod\" flex=\"80\" md-theme=\"modal-theme\"><form ng-cloack name=\"lockTransactionForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,lockTransactionForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.LOCK_TRANSACTION.FORM.TITLE\">\nForm Input Lock Transaction</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon\n md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\" style=\"margin-bottom: 0 !important\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadSubArea()\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.COMMIT_ATTENDANCE.FORM.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LOCK_TRANSACTION.FORM.EFFECTIVE_DATE\">Effective Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"lockTransactionForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LOCK_TRANSACTION.FORM.EFFECTIVE_TIME\">Effective Time</label><input type=\"text\" ng-max=\"24\" \nname=\"effective_time\" ng-model=\"vm.Form.objForm.effective_time\" mask=\"99:99\" mask-placeholder=\"_\" required><div \nng-messages=\"lockTransactionForm.effective_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\">\n<span>Max Length 2.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LOCK_TRANSACTION.FORM.DATE_LOCK\">Date Lock</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"date_lock\" ng-model=\"vm.Form.objForm.date_lock\" required></md-datepicker><div \nng-messages=\"lockTransactionForm.date_lock.$error\" role=\"alert\"><div ng-message=\"required\"><span>Date Lock is required.\n</span></div></div></md-input-container><md-input-container flex><label translate=\"MENU.CB.LOCK_TRANSACTION.FORM.FLAG\">\nFlag</label><md-select ng-model=\"vm.Form.objForm.flag_app\" name=\"flag_app\"><md-option ng-repeat=\"ls in vm.flagList\" \nplaceholder=\"Flag\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"lockTransactionForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Flag is required.\n</span></div></div></md-input-container></div><div layout=\"row\" class=\"toolbar-subarea\"><md-checkbox \nng-model=\"vm.checkAll\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"isIndeterminate()\" ng-click=\"vm.toggleAll()\"><span\n ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></div><div layout=\"column\" layout-gt-xs=\"row\" \nclass=\"checkbox-container\"><div ng-repeat=\"column in vm.block\" flex=\"25\"><md-checkbox \nng-class=\"{\'fade-in\' : vm.subArea.length > 0, \'fade-out\' : vm.subArea.length === 0 }\" \nng-checked=\"vm.exists(ls, vm.selectedSubarea)\" ng-click=\"vm.toggle(ls, vm.selectedSubarea)\" \nng-repeat-start=\"ls in vm.subArea | slice:column.start:column.end\">{{ls.description}}</md-checkbox><div ng-repeat-end>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"lockTransactionForm.$invalid || lockTransactionForm.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/lock-transaction/lock-transaction-detail.html","<md-dialog aria-label=\"Form Update Finger Data\" md-theme=\"modal-theme\" flex-md=\"80\" flex-gt-md=\"50\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>View Sub Area List</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"column\" layout-fill class=\"content padding\"><div class=\"md-whiteframe-2dp\"><div \nclass=\"md-toolbar-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;Entries</span><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" \nng-disabled=\"vm.listSelected.length==0\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteArea($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete</span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button class=\"md-mini md-raised md-warn btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-disabled=\"vm.listSelected.length==0\" ng-click=\"vm.deleteArea($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Delete</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon><span>Delete</span>\n</md-button></div><div class=\"simple-table-container\" hide show-gt-sm><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar stripped upper-case-header\" ms-responsive-table><thead><tr><th width=\"5%\" \nclass=\"text-center\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></th>\n<th width=\"15%\" class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.NO\">NO</span></th><th \nclass=\"text-left\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.NAME\">Name</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTables.list\"><td width=\"5%\" class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td style=\"text-align: center\">{{($index + 1)}}</td><td \nclass=\"text-left\"><span>{{ls.subarea_name}}</span></td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"3\" \nclass=\"text-center\"><span>No Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div></div></md-dialog>");
$templateCache.put("app/main/cb/lock-transaction/lock-transaction.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.LOCK_TRANSACTION.INDEX.HEADER.TITLE\">Lock Transaction</span></md-subheader>\n<div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputLockTransaction($event,ls)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.NEW_LOCK_TRANSACTION\">\nNew Lock Transaction</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"TABLE.ENTRIES\">Entries</span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputLockTransaction($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.NEW_LOCK_TRANSACTION\">New Lock Transaction</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.NEW\">New\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"1%\" style=\"text-align: center\" translate=\"TABLE.NO\">No.</th><th width=\"30%\" \nclass=\"text-center\" translate=\"TABLE.TIME_LOCK\">Time Lock</th><th width=\"20%\" class=\"text-center\" \ntranslate=\"TABLE.LOCK_BY\">Lock By</th><th style=\"text-align: center\" translate=\"TABLE.TRANSACTION_DATE_LOCK\">\nTransaction date lock</th><th style=\"text-align: center\" translate=\"MENU.CB.LOCK_TRANSACTION.FORM.FLAG\">Flag</th></tr>\n</thead><tbody><tr class=\"hover-tr\" ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.viewDetail(ls.id)\"><td \nstyle=\"text-align: center\">{{($index + 1)}}</td><td style=\"text-align: center\">\n{{ls.effective_date}} {{ls.effective_time}}</td><td style=\"text-align: center\">{{ls.lock_by}}-{{ls.nama}}</td><td \nstyle=\"text-align: center\">{{ls.date_lock}}</td><td style=\"text-align: center\">{{ls.flag_app}}</td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/mapping-mpp-setting/mapping-mpp-setting.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nid=\"mapping-mpp-setting\" class=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill layout=\"column\"><md-subheader class=\"white-bg\">Mapping MPP Setting</md-subheader><div class=\"white-bg\" \nflex layout=\"column\"><md-content class=\"\" layout=\"column\" layout-fill><div class=\"white-bg content-wrapper\" \nlayout=\"column\" flex><md-tabs layout-fill layout=\"column\" md-selected=\"vm.activePaneIndex\" \nclass=\"mapping-mpp-setting-tabs\" md-dynamic-height=\"{{vm.dynamicHeight}}\" flex><md-tab flex><md-tab-label>Mails\n</md-tab-label><md-tab-body><div layout=\"column\" layout-fill class=\"pb-10 content mapping-mpp-setting-list-pane\"><div \nclass=\"scrollable\" ms-scroll=\"{suppressScrollX: true}\" flex><section ng-repeat=\"item in vm.items\"><md-subheader \nclass=\"md-primary\">{{ item.title }}</md-subheader><md-list class=\"pl-10\"><div ng-repeat=\"item in item.items\" \nng-include=\"\'treeview.html\'\"></div></md-list></section></div><md-toolbar class=\"md-hue-2\" flex=\"nogrow\"><div \nclass=\"md-toolbar-tools pr-5\" layout=\"column\" layout-align=\"center end\"><md-button class=\"md-fab md-mini md-primary\" \naria-label=\"Favorite\" layout-align=\"center end\" ng-click=\"vm.showHierarkiDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></md-toolbar></div></md-tab-body></md-tab><md-tab flex>\n<md-tab-label>Read Pane</md-tab-label><md-tab-body><div class=\"content mapping-mpp-setting-detail-pane\" \nlayout=\"column\"><div layout=\"column\" layout-align=\"center center\" flex><md-icon md-font-icon=\"icon-library-books\" \nclass=\"s120 grey-400-fg md-default-theme m-0\" role=\"img\" aria-label=\"icon-library-books\"></md-icon><span \nclass=\"hint-text\">Select a message to read</span></div></div></md-tab-body></md-tab></md-tabs></div></md-content></div>\n</div></md-content></div><script type=\"text/ng-template\" id=\"treeview.html\">\n<md-list-item ng-if=\"item.items.length == 0\" hide-gt-sm>\n    <md-icon class=\"material-icons\">\n      <i class=\"icon icon-close s18 mv-3\"></i>\n    </md-icon>\n    <p>{{ item.title }}</p>\n    <md-icon class=\"material-icons\" ng-if=\"item.items.length == 0\">\n      <i class=\"icon icon-library-books s18 mv-3\"></i>\n    </md-icon>\n  </md-list-item>\n  <md-list-item ng-if=\"item.items.length == 0\" hide show-gt-sm>\n    <md-icon class=\"material-icons\">\n      <i class=\"icon icon-close s18 mv-3\"></i>\n    </md-icon>\n    <p>{{ item.title }}</p>\n    <md-icon class=\"material-icons\" ng-if=\"item.items.length == 0\">\n      <i class=\"icon icon-library-books s18 mv-3\"></i>\n    </md-icon>\n  </md-list-item>\n  <md-list-item ng-click=\"vm.toggleRetrieveItems(item)\" ng-if=\"item.items.length > 0\" hide-gt-sm>\n    <md-icon class=\"material-icons\">\n      <i class=\"icon icon-close s18 mv-3\"></i>\n    </md-icon>\n    <p>{{ item.title }}</p>\n    <md-icon class=\"material-icons\" ng-if=\"item.items.length == 0\">\n      <i class=\"icon icon-library-books s18 mv-3\"></i>\n    </md-icon>\n    <md-icon class=\"material-icons\">\n      <i class=\"icon {{item.expanded ? \'icon-chevron-up\' : \'icon-chevron-right\'}}\"></i>\n    </md-icon>\n  </md-list-item>\n  <md-list-item ng-click=\"vm.toggleItems(item)\" ng-if=\"item.items.length > 0\" hide show-gt-sm>\n    <md-icon class=\"material-icons\">\n      <i class=\"icon icon-close s18 mv-3\"></i>\n    </md-icon>\n    <p>{{ item.title }}</p>\n    <md-icon class=\"material-icons\" ng-if=\"item.items.length == 0\">\n      <i class=\"icon icon-library-books s18 mv-3\"></i>\n    </md-icon>\n    <md-icon class=\"material-icons\">\n      <i class=\"icon {{item.expanded ? \'icon-chevron-up\' : \'icon-chevron-right\'}}\"></i>\n    </md-icon>\n  </md-list-item>\n  <md-list class=\"md-blue-grey-50-bg\" flex ng-if=\"item.items.length > 0\" ng-show=\"item.expanded\">\n    <div ng-repeat=\"item in item.items\" ng-include=\"\'treeview.html\'\"></div>\n  </md-list>\n</script>");
$templateCache.put("app/main/cb/national-holiday/edit-data-dialog.html","<md-dialog layout aria-label=\"Input holiday\" ng-style=\"vm.styleDialog\" md-theme=\"modal-theme\"><form \nname=\"formDataHoliday\" ng-cloak style=\"width:800px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nInput data nationdal holiday</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div><md-input-container><label>Holiday</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.holidaydate\" name=\"holidaydate\" required></md-datepicker><div \nng-messages=\"formDataHoliday.holidaydate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nHoliday Date Date is required.</span></div></div></md-input-container><md-input-container><label>Holiday Name</label>\n<input type=\"text\" name=\"holidayname\" ng-model=\"vm.holidayname\" required><div \nng-messages=\"formDataHoliday.holidayname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nHoliday name is required.</span></div></div></md-input-container></div><div><h2>Choose Sub Area</h2></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.dialogClose()\">Cancel\n</md-button><md-button ng-click=\"vm.saveDataHoliday($event,formDataHoliday)\" aria-label=\"Submit\" \nng-disabled=\"formDataHoliday.$invalid || basicForm.$pristine || vm.selected.length == 0\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/national-holiday/edit-national-holiday.html","<md-dialog aria-label=\"Input Data Employee Labor Type\" md-theme=\"modal-theme\" layout layout-wrap><form \nname=\"frmHoliday\" ng-submit=\"vm.updateEmpLabor($event, frmHoliday)\" novalidate flex><md-toolbar flex><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.NATIONAL_HOLIDAY.FORM.TITLE_EDIT\">Edit data national holiday</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.CB.NATIONAL_HOLIDAY.FORM.NIK\">NIK</label><input type=\"text\" value=\"{{ vm.nik }}\" disabled=\"disabled\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.CB.NATIONAL_HOLIDAY.FORM.NAME\">Name</label><input type=\"text\" value=\"{{ vm.name }}\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.CB.NATIONAL_HOLIDAY.FORM.TYPE\">Type</label><md-select ng-model=\"vm.selectedLaborType\" name=\"labortype\">\n<md-option ng-repeat=\"ls in vm.labortype\" value=\"{{ ls }}\">{{ ls }}</md-option></md-select><div \nng-messages=\"frmHoliday.labortype.$error\" role=\"alert\"><div ng-message=\"required\"><span>Labor Type field is required.\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"MENU.CB.NATIONAL_HOLIDAY.FORM.EFFECTIVE_DATE\">Effective Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.effectiveDate\" name=\"effectiveDate\" required></md-datepicker><div \nng-messages=\"frmHoliday.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective date field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\"><span translate=\"ACTION.CANCEL\">Cancel</span></md-button><md-button\n type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmHoliday.$invalid || frmHoliday.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/national-holiday/national-holiday.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\"><span translate=\"FILTER.YEAR\">YEARS</span></div><md-menu id=\"projects-menu\" md-offset=\"0 48\">\n<md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-model=\"vm.yearSelected\" ng-repeat=\"year in vm.years\"><md-button \naria-label=\"{{ year }}\" ng-click=\"vm.showHoliday(year)\"><span class=\"secondary-text\"><span><md-icon \nng-if=\"vm.yearSelected == year\" md-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"vm.yearSelected != year\"></md-icon>\n{{ year }}</span></span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span class=\"logo-text\"><span translate=\"MENU.CB.NATIONAL_HOLIDAY.INDEX.HEADER.TITLE\">National Holiday\n</span> {{ vm.yearSelected}}</span></md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" aria-label=\"company\" name=\"company\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"FILTER.SUB_AREA\">Sub Area</label><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option \nng-repeat=\"ls in vm.subArea\" value=\"{{ls.sub_area_id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \naria-label=\"FilterNationalHoliday\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">\n<span translate=\"ACTION.SUBMIT\">Submit</span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.showDialogInput($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Create new</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.NEW\">\nCreate new</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-disabled=\"vm.selected.length == 0\" \nng-click=\"vm.deleteData(vm.selected)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"ACTION.DELETE\">Delete</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div><md-menu\n md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"addNationalHoliday\" ng-click=\"vm.showDialog($event)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span translate=\"ACTION.NEW\">Create New</span></md-button></md-menu-item>\n</md-menu-content></md-menu></md-toolbar><md-content hide-gt-sm><span flex=\"5\"></span><md-list class=\"md-dense\" flex>\n<md-list-item class=\"md-3-line\" ng-repeat=\"item in vm.DataTables.list\" ng-click=\"null\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4>{{item.description}}</h4><p>Dates : {{item.tgl}}</p><p>Location : {{item.location}}</p></div>\n<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"NationalHolidayMenu\" class=\"md-icon-button\" \nstyle=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"\"><div layout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex>\n<span translate=\"ACTION.EDIT\">edit</span></p></div></md-button></md-menu-item></md-menu-content></md-menu><md-divider \nstyle=\"border-width:0.5px; border-color:whitesmoke; border-style: solid\"></md-divider></md-list-item></md-list><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\">\n</th><th width=\"5%\"><span class=\"column-title\" translate=\"TABLE.NO\">NO</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.DATE\">Dates</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.DESCRIPTION\">Description</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.SUB_AREA\">Sub area</span></th><th width=\"2%\"></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox \naria-label=\"nationalHolidayChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td>{{($index + 1)}}</td><td class=\"text-center\">{{item.tgl}}</td><td class=\"text-center\">\n{{item.description}}</td><td class=\"text-center\">{{item.location}}</td><td><section layout=\"row\" layout-sm=\"column\" \nclass=\"no-padding\" layout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"LeaveHoldMenu\" class=\"md-icon-button\" style=\"padding:0;margin:0;height: 24px;width: 24px\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.showDialogEdit($event, item)\"><div layout=\"row\" flex>\n<md-icon md-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex><span translate=\"ACTION.EDIT\">edit\n</span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.detailLeaveHold($event, item)\"><div \nlayout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"ACTION.VIEW_DETAIL\">View detail</span></p></div></md-button></md-menu-item></md-menu-content></md-menu>\n</section></td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>\nNo Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/new-replacement-holiday/new-replacement-holiday.html","<div class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content class=\"content padding\" \nlayout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\"><span>\nNew Replacement</span></md-subheader><div class=\"white-bg\" layout-padding><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmEmploye)\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company); vm.loadSubArea()\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.COMMIT_ATTENDANCE.FORM.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><label>Start Date Payroll\n</label><input type=\"date\" name=\"start_date\" ng-model=\"vm.start_date\" required><div \nng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date field is required.\n</span></div></div></md-input-container><md-input-container flex><label>End Date Payroll</label><input type=\"date\" \nname=\"end_date\" ng-model=\"vm.end_date\" required><div ng-messages=\"frmEmploye.end_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End Date field is required.</span></div></div></md-input-container></div><div layout=\"row\" \nclass=\"toolbar-subarea\"><md-checkbox ng-model=\"vm.checkAll\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"isIndeterminate()\" ng-click=\"vm.toggleAll()\"><span ng-if=\"vm.isChecked()\">Un-</span>Select All\n</md-checkbox></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"checkbox-container\"><div \nng-repeat=\"column in vm.block\" flex=\"25\"><md-checkbox \nng-class=\"{\'fade-in\' : vm.subArea.length > 0, \'fade-out\' : vm.subArea.length === 0 }\" \nng-checked=\"vm.exists(ls, vm.selectedSubarea)\" ng-click=\"vm.toggle(ls, vm.selectedSubarea)\" \nng-repeat-start=\"ls in vm.subArea | slice:column.start:column.end\">{{ls.description}}</md-checkbox><div ng-repeat-end>\n</div></div></div><div loyout=\"column\" layout-gt-xs=\"row\"><div layout=\"row\" class=\"toolbar-subarea\"><md-checkbox \nng-model=\"vm.checkAllJobTitle\" ng-checked=\"vm.isCheckedJobTitle()\" md-indeterminate=\"isIndeterminateJobTitle()\" \nng-click=\"vm.toggleAllJobTitle()\"><span ng-if=\"vm.isCheckedJobTitle()\">Un-</span>Select All</md-checkbox></div><a \nclass=\"md-raised md-primary md-fab md-mini md-button\" ng-click=\"vm.loadJobTitle()\" style=\"margin: 15px\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-reload\" aria-label=\"android\"></md-icon></a></div><div layout=\"column\" \nlayout-gt-xs=\"row\" class=\"checkbox-container\"><div ng-repeat=\"column in vm.blockJobTitle\" flex=\"25\"><md-checkbox \nng-class=\"{\'fade-in\' : vm.jobTitle.length > 0, \'fade-out\' : vm.jobTitle.length === 0 }\" \nng-checked=\"vm.existsJobTitle(ls, vm.selectedJobTitle)\" ng-click=\"vm.toggleJobTitle(ls, vm.selectedJobTitle)\" \nng-repeat-start=\"ls in vm.jobTitle | slice:column.start:column.end\">{{ls.jobtitle}}</md-checkbox><div ng-repeat-end>\n</div></div></div><div layout=\"row\" class=\"toolbar-subarea\"><md-checkbox ng-model=\"vm.checkAllGrade\" \nng-checked=\"vm.isCheckedGrade()\" md-indeterminate=\"isIndeterminateGrade()\" ng-click=\"vm.toggleAllGrade()\"><span \nng-if=\"vm.isCheckedGrade()\">Un-</span>Select All</md-checkbox></div><div \nclass=\"widget-group layout-wrap layout-row flex-100\" layout=\"row\" flex=\"100\"><div flex=\"100\" flex-gt-xs=\"100\" \nflex-gt-md=\"30\" style=\"margin: 1vh\" layout-gt-sm=\"column\"><div layout=\"column\" layout-gt-xs=\"row\" \nclass=\"checkbox-container\"><div ng-repeat=\"column in vm.blockGrade\" flex=\"25\"><md-checkbox \nng-class=\"{\'fade-in\' : vm.Grade.length > 0, \'fade-out\' : vm.Grade.length === 0 }\" \nng-checked=\"vm.existsGrade(ls, vm.selectedGrade)\" ng-click=\"vm.toggleJobTitle(ls, vm.selectedGrade)\" \nng-repeat-start=\"ls in vm.Grade | slice:column.start:column.end\">{{ls}}</md-checkbox><div ng-repeat-end></div></div>\n</div></div><div flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"65\" style=\"margin: 1vh\" layout-gt-sm=\"column\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\" style=\"font-size: 12px\" \nng-hide=\"vm.tableActivityScoreAktif\"><thead><tr><th class=\"text-center\" width=\"50px\"><a ng-click=\"vm.addDate()\">\n<md-icon md-font-icon=\"icon-plus\" style=\"font-size: 12px\"></md-icon></a></th><th class=\"text-center\">Start Date</th><th\n class=\"text-center\">End Date</th><th class=\"text-center\">Start Time</th><th class=\"text-center\">End Time</th><th \nclass=\"text-center\" width=\"50px\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listDate\"><td class=\"text-center\">\n<span style=\"font-weight: bold\">{{$index+1}}</span></td><td><input type=\"date\" name=\"start_date\" \nng-model=\"ls.start_date\" class=\"input-table-dot\" required></td><td><input type=\"date\" name=\"end_date\" \nng-model=\"ls.end_date\" class=\"input-table-dot\" required></td><td><input type=\"time\" name=\"start_time\" \nng-model=\"ls.start_time\" class=\"input-table-dot\" min=\"00:00\" max=\"23:59\" required></td><td><input type=\"time\" \nname=\"end_time\" ng-model=\"ls.end_time\" class=\"input-table-dot\" required min=\"00:00\" max=\"23:59\"></td><td><md-button \nclass=\"md-warn md-mini\" type=\"button\" ng-click=\"vm.deleteListDate($index)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table></div></div><div loyout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\" translate=\"MENU.CB.LEAVE.FORM_INPUT.RELOAD_TOKEN\">\nReload Token</md-button><md-button type=\"submit\" layout=\"row\" class=\"md-raised md-primary\" \naria-label=\"{{ \'ACTION.SUBMIT\' | translate }}\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon>Download</md-button></div></form></div></div></md-content></div>");
$templateCache.put("app/main/cb/outlet-team-list/outlet-team-list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.OUTLET_TEAM_MAPPING_LIST.INDEX.HEADER.TITLE\">Outlet Team Mapping List</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" ng-change=\"vm.loadData(1)\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" ng-value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\">\n<md-option ng-repeat=\"val in vm.listtahun\" placeholder=\"{{ FILTER.YEAR | translate }}\" value=\"{{val}}\">{{val}}\n</md-option></md-select><div ng-messages=\"frmOutletList.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmOutletList.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" aria-label=\"Submit\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-download\" ng-click=\"vm.loadData(1)\" aria-label=\"android\"></md-icon>Submit\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div\n class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Download Excel</span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" ng-click=\"vm.ExportToExcel()\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel\n</span></md-tooltip><md-icon md-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\" \ntranslate=\"TABLE.NO\">No</th><th translate=\"TABLE.REQUEST_BY\">Request by</th><th translate=\"TABLE.DATE_REQUEST\">\nTgl Request</th><th translate=\"TABLE.MAPPING_PERSON\">Mapping Person</th><th translate=\"TABLE.CURRENT_AREA\">Current Area\n</th><th translate=\"TABLE.NEXT_AREA\">Next Area</th><th translate=\"TABLE.DATE_MAPPING\">Tgl Mapping</th><th translate=\"\">\nAtasan Next Area</th></tr></thead><tr ng-repeat=\"team in vm.DataTable.list\" ng-dblclick=\"vm.editData(team.id)\"><td>\n{{team.no}}</td><td>{{team.nik_request}}-{{team.nama_request}}</td><td>{{team.tgl_request}}</td><td>\n{{team.nik_mapping}}-{{team.nama_mapping}}</td><td>{{team.current_area}}</td><td>{{team.next_area}}</td><td>\n{{team.tgl_mapping}}</td><td>{{team.nik_atasan}}</td></tr></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/overtime/overtime.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Over Time</span></md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"FILTER.TITLE\">Filter Data</span></div><div \nng-if=\"vm.groupLogin !=11\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea()\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container\n flex><md-select ng-model=\"vm.flag_app\" name=\"flag_app\" ng-change=\"vm.getPeriode()\" required><md-option \nng-repeat=\"ls in vm.typeEmp\" placeholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">\n{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\">\n<md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">\nSearch</span></md-button></div></div><div ng-if=\"vm.groupLogin==11\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.flag_app\" name=\"flag_app\" ng-change=\"vm.getPeriode()\" required><md-option \nng-repeat=\"ls in vm.typeEmp\" placeholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">\n{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-button type=\"submit\" layout=\"row\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Search</span></md-button></div></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div ng-if=\"vm.groupLogin!=11\" class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" ass=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span>\n</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-button aria-label=\"Twitter\" class=\"md-raised md-primary btn-ui-serif\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" hide show-gt-sm ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD\">Download</span></md-tooltip><span \ntranslate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-button><md-button aria-label=\"Twitter\" \nclass=\"md-raised md-primary btn-ui-serif\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" hide show-gt-sm \nng-click=\"vm.ExportToExcelUnapproved()\"><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.DOWNLOAD\">Download</span></md-tooltip><span translate=\"ACTION.DOWNLOAD_EXCEL_UNAPPROVED\">\nDownload Excel Unapproved</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\" translate=\"TABLE.NO\">No</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"TABLE.OT_DATE\">OT Date</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\" translate=\"TABLE.NAME\">Name</span></th><th class=\"text-center\" colspan=\"2\" layout-align=\"center\">\n<span class=\"column-title\" translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.HEADER.SPL\">SPL</span></th><th \nclass=\"text-center\" colspan=\"2\" layout-align=\"center\"><span class=\"column-title\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.HEADER.ACTUAL\">Actual</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"TABLE.REST_HOUR\">Rest Hour</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.HEADER.OT_APPROVED\">\nOT Approved</span></th><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\" \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.TABLE_ATTENDANCE.HEADER.OT_UNAPPROVED\">OT Unapproved</span></th></tr><tr><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.START_TIME\">Start Time</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.END_TIME\">End Time</span></th><th class=\"text-center\">\n<span class=\"column-title\" translate=\"TABLE.START_TIME\">Start Time</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.END_TIME\">End Time</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listData\"><td class=\"text-center\">{{ls.no}}</td><td>{{ls.dayname }} / {{ls.transaction_date }}</td>\n<td class=\"text-center\">{{ls.nik }}</td><td>{{ls.empname }}</td><td class=\"text-center\">{{ls.spl_start_time }}</td><td \nclass=\"text-center\">{{ls.spl_end_time}}</td><td class=\"text-center\">{{ls.start_time }}</td><td class=\"text-center\">\n{{ls.end_time}}</td><td class=\"text-center\">{{ls.rest_hour}}</td><td class=\"text-center\"><span ng-if=\"ls.approvedOT>0\">\n{{ls.approvedOT}}</span><span ng-if=\"ls.approvedOT==0\"></span></td><td class=\"text-center\"><span \nng-if=\"ls.unApprovedOT>0\">{{ls.unApprovedOT}}</span><span ng-if=\"ls.unApprovedOT==0\"></span></td></tr><tr \nng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>No Data Available</span></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/overtime-configuration/edit-overtime-config.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"FormOTConfig\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,FormOTConfig)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.OVERTIME_CONFIGURATION.EDIT.TITLE\">Edit Overtime Configuration</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><label \ntranslate=\"MENU.CB.OVERTIME_CONFIGURATION.EDIT.NIK\">NIK</label><input ng-model=\"vm.Form.objForm.nik\" name=\"nik\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.OVERTIME_CONFIGURATION.EDIT.NAME\">Name</label><input ng-model=\"vm.name\" name=\"name\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"drop-mod\" flex><label \ntranslate=\"MENU.CB.OVERTIME_CONFIGURATION.EDIT.TYPE\">Type</label><md-select ng-model=\"vm.Form.objForm.ottype\" \nname=\"ottype\" required><md-option ng-repeat=\"ls in vm.listType\" placeholder=\"Type\" value=\"{{ls.id}}\">{{ls.type}}\n</md-option></md-select><div ng-messages=\"FormOTConfig.ottype.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.OVERTIME_CONFIGURATION.EDIT.JOIN_DATE\">Join Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"effectivedate\" ng-model=\"vm.Form.objForm.effectivedate\" required></md-datepicker><div \nng-messages=\"FormOTConfig.effectivedate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Date Join Required.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front>\n</ms-widget><span flex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"FormOTConfig.$invalid || FormOTConfig.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/overtime-configuration/overtime-configuration.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.OVERTIME_CONFIGURATION.INDEX.HEADER.TITLE\">Overtime Configuration</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><label>Divisi</label>\n<md-select ng-model=\"vm.divisi\" ng-disabled=\"!vm.company\" name=\"{{ \'FILTER.DIVISI\' | translate }}\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Department</label><md-select ng-model=\"vm.department\" ng-disabled=\"!vm.divisi\" name=\"department\" required>\n<md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"FILTER.NIK_NAME\">Employee name / nik</label><input type=\"text\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" ng-click=\"vm.loadData(1)\" ng-disabled=\"vm.searchComplete\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div>\n</form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container\n hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.uploadOvertimeConfig($this)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.IMPORT_FROM_EXCEL\">Upload</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload Data</span></md-button>\n<span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nstyle=\"text-align: center\" translate=\"TABLE.NO\">No.</th><th class=\"text-center\" translate=\"TABLE.NIK\">NIK</th><th \nclass=\"text-center\" translate=\"TABLE.NAME\">Employee Name</th><th style=\"text-align: center\" translate=\"TABLE.TYPE\">Type\n</th><th style=\"text-align: center\" translate=\"TABLE.EFFECTIVE_DATE\">Effective Date</th></tr></thead><tbody><tr \nclass=\"hover-tr\" ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($this,ls)\"><td \nstyle=\"text-align: center\">{{($index + 1)}}</td><td style=\"text-align: center\">{{ls.nik}}</td><td>{{ls.empName}}</td>\n<td style=\"text-align: center\">{{ls.type}}</td><td style=\"text-align: center\">{{ls.effective_date}}</td></tr></tbody>\n</table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/overtime-configuration/upload-overtime-config.html","<md-dialog aria-label=\"Uplaod\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2 translate=\"MENU.CB.OVERTIME_CONFIGURATION.UPLOAD.TITLE\">Upload Overtime Configuration</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div class=\"text-right\" flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-50-fg\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button>\n</div></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span translate=\"NOTIF.ERROR_UPLOAD\">Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span translate=\"NOTIF.SUCCESS_UPLOAD\">Success Upload File</span>\n</md-whiteframe></md-content></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/replacement-holiday/replacement-holiday.html","<div id=\"replacement-holiday\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nReplacement Holiday</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout=\"row\" layout-align=\"end center\" ng-submit=\"vm.loadData(1)\" novalidate>\n<div layout=\"column\" flex layout-gt-xs=\"row\"><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company); vm.loadSubArea()\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmFilter.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><label>Divisi</label>\n<md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmFilter.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><label>Department</label>\n<md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmFilter.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Sub Area</label><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" required><md-option value=\"all\">All</md-option><md-option \nng-repeat=\"ls in vm.subArea\" placeholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmFilter.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSub Area field is required.</span></div></div></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmFilter.$invalid || frmFilter.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" style=\"margin-right:5px\" layout=\"row\" \nlayout-align=\"start center\" hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span>Entries</span></div><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" \nclass=\"md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.openUpload($event)\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-upload\"></md-icon><span style=\"font-size:12px\">Upload</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" \nclass=\"md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.newReplacement()\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-new\"></md-icon><span style=\"font-size:12px\">New Replacement</span>\n</md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon style=\"font-size:12px\" \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon style=\"font-size:12px\" \nng-if=\"vm.selected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" \nclass=\"red-700-fg\">Delete</span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span \nstyle=\"color:red\" ng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} selected</span></md-button><span flex hide \nshow-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 12px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-button md-ink-ripple md-mini\" type=\"button\" \nstyle=\"font-size:12px\" aria-label=\"printcost\" ng-click=\"null\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \nstyle=\"font-size:12px\">UPLOAD</span></md-button></md-menu-item></md-menu-content></md-menu><span flex show hide-gt-sm>\n</span><ms-search-bar style=\"padding:0px\" on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" \nclass=\"bouncy-slide-left\"></ms-search-bar></div></md-toolbar><div layout=\"column\" layout layout-padding ms-scroll hide \nshow-gt-sm><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" \nwidht=\"5%\"><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.checked()\" md-indeterminate=\"vm.isIndeterminate()\" \nng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"></md-checkbox></th><th>NO</th><th>NIK</th><th>Holiday Date</th><th>\nworking date</th><th>start shift</th><th>end shift</th><th>upload by</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTable.list\"><td class=\"text-center\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(item)\" ng-click=\"vm.toggleCheck(item, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{$index+1}}</td><td class=\"text-center\">\n{{item.nik}} / {{item.fullname}}</td><td class=\"text-center\">{{item.holiday_date}}</td><td class=\"text-center\">\n{{item.working_date}}</td><td class=\"text-center\">{{item.start_shift}}</td><td class=\"text-center\">{{item.end_shift}}\n</td><td class=\"text-center\">{{item.upload_by}}</td></tr></tbody></table></div><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/cb/passwordecheckingw/passwordecheckingw.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span \ntranslate=\"MENU.CB.PASSWORD_ECHECKIN_GW.INDEX.HEADER.TITLE\">Password Echeckin GW</span></span></div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon ui-sref=\"{{vm.Breadhome}}\" \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><div ng-repeat-start=\"ls  in vm.Breadlist\"></div><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\" ui-sref=\"{{ls.link}}\">\n{{ls.name}}</span><div ng-repeat-end></div><span class=\"parent grey-A100-fg\" \ntranslate=\"MENU.CB.PASSWORD_ECHECKIN_GW.INDEX.HEADER.TITLE\">Password Echeckin GW</span></div></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div><md-fab-speed-dial \nmd-direction=\"left\" class=\"action-button md-scale\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-blue-500-bg\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.MENU\">Menu</span></md-tooltip><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button aria-label=\"Twitter\" class=\"md-fab md-raised md-mini\" \nui-sref=\"app.cb_passwordecheckingw_input-password-echeckingw\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.INPUT\">Input</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"teal-800-fg\"></md-icon></md-button></md-fab-actions><md-fab-actions><md-button \naria-label=\"Twitter\" class=\"md-fab md-raised md-mini\" ng-click=\"vm.uploadEmployee($event)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.UPLOAD_DATA_EMPLOYEE\">Upload data employee\n</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" class=\"teal-800-fg\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div></div><div class=\"content\" layout=\"column\" flex><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div layout=\"row\" layout-padding layout-align=\"space-between center\">\n<md-input-container md-no-float class=\"md-block\" flex=\"30\">Shows :<select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block\" flex=\"100\"><label translate=\"FILTER.NAME\">Employe Name Search</label>\n<input type=\"text\" placeholder=\"{{ \'FILTER.SEARCH\' | translate }}\" name=\"search\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"><md-icon md-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\"></md-icon></md-input-container></form>\n</div><div><table class=\"simple stripped\" ms-responsive-table style=\"margin-top:0\"><thead><tr><th><span \nclass=\"column-title\" translate=\"TABLE.NO\">No</span></th><th><span class=\"column-title\" translate=\"TABLE.NAME\">NAME\n</span></th><th><span class=\"column-title\" translate=\"TABLE.NO_KTP\">NO KTP</span></th><th><span class=\"column-title\" \ntranslate=\"TABLE.GENDER\">GENDER</span></th><th><span class=\"column-title\" translate=\"TABLE.PASSWORD\">Password</span>\n</th><th><span class=\"column-title\" translate=\"TABLE.COMPANY_ID\">COMPANY ID</span></th><th><span class=\"column-title\" \ntranslate=\"TABLE.WORKLOCATION_ID\">WORKLOCATION_ID</span></th><th><span class=\"column-title\" \ntranslate=\"TABLE.INTERNAL_ID\">INTERNAL ID</span></th><th><span class=\"column-title\" translate=\"TABLE.NIK\">NIK</span>\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls.noktp)\"><td>{{ls.no}}</td>\n<td>{{ls.title }} {{ls.firstName }} {{ls.lastName }}</td><td>{{ls.noktp}}</td><td>{{ls.gender}}</td><td>{{ls.password}}\n</td><td>{{ls.companyid}}</td><td>{{ls.worklocationid}}</td><td>{{ls.internalid}}</td><td>{{ls.nik}}</td></tr></tbody>\n</table></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/cb/saldo-ghk/apply-subtitution.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"45\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.GHK_BALANCE.FORM_INPUT.TITLE\">\nForm Apply Subtitution</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\"><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.holiday_date\" name=\"holiday_date\" required><md-option ng-repeat=\"ls in vm.listHoliday\" \nplaceholder=\"{{ \'MENU.CB.GHK_BALANCE.FORM_INPUT.DATE\' | translate }}\" value=\"{{ls.tanggal}}\">\n{{ls.namahari}} / {{ls.tanggal}}</md-option></md-select><div ng-messages=\"formAbsence.holiday_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Holiday Date field is required.</span></div></div></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\" \nng-disabled=\"formAbsence.$invalid || formAbsence.$pristine\" translate=\"MENU.CB.GHK_BALANCE.FORM_INPUT.SAVE\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/saldo-ghk/saldo-ghk.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.GHK_BALANCE\"></span></md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th translate=\"MENU.CB.GHK_BALANCE.INDEX.TABLE.DWS_CODE\" width=\"150px\">DWS Code</th><th \ntranslate=\"MENU.CB.GHK_BALANCE.INDEX.TABLE.VARIANT\" width=\"150px\">Variant</th><th \ntranslate=\"MENU.CB.GHK_BALANCE.INDEX.TABLE.WORKING_DATE\" width=\"150px\">Working Date</th><th \ntranslate=\"MENU.CB.GHK_BALANCE.INDEX.TABLE.HOLIDAY_STATUS\">Holiday Status</th><th \ntranslate=\"MENU.CB.GHK_BALANCE.INDEX.TABLE.HOLIDAY_DATE\" width=\"150px\">Holiday Date</th><th width=\"250px\">#</th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.listsaldoGhk\"><td class=\"text-center\">{{ls.dws_code}}</td><td \nclass=\"text-center\">{{ls.variant}} Day</td><td class=\"text-center\">{{ls.workdayname}} / {{ls.working_date}}</td><td \nclass=\"text-center\"><div layout=\"column\" layout-align=\"center center\"><span class=\"label md-green-600-bg ph-5\" \nng-if=\"ls.holidaystatus==\'Approved\'\" flex=\"nogrow\">{{ls.holidaystatus}} </span><span \nng-if=\"ls.holidaystatus!=\'Approved\'\">{{ls.holidaystatus}} </span><span class=\"mt-5\" \nng-if=\"ls.holidaystatus!=\'Available\'\">{{ls.approved_by}} - {{ls.approved_by_name}}</span> <span class=\"mt-5\" \nng-if=\"ls.holidaystatus==\'Approved\'\">{{ls.approval_time}}</span></div></td><td class=\"text-center\"><span \nng-if=\"ls.absence_date\">{{ls.holidayname}} / {{ls.absence_date}}</span></td><td class=\"text-center\"><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.SubtitutionRequest($event,ls)\" aria-label=\"more\" \nng-disabled=\"!ls.applyrequest\"><md-icon md-font-icon=\"icon-bookmark-check\"></md-icon><span \ntranslate=\"ACTION.APPLY_SUBTITUTION\">Apply Subtitution</span></md-button></td></tr><tr class=\"text-center\" \nng-if=\"(vm.listsaldoGhk | typeOf) == \'undefined\'\"><td colspan=\"6\" class=\"text-center\"><span>Loading, Please Wait</span>\n</td></tr><tr class=\"text-center\" ng-if=\"vm.listsaldoGhk.length <= 0\"><td colspan=\"6\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/saldo-ghk-gw/apply-subtitution-gw.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"45\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.GHK_BALANCE.FORM_INPUT.TITLE\">Form Apply Subtitution</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><md-select ng-model=\"vm.Form.objForm.holiday_date\" \nname=\"holiday_date\" required><md-option ng-repeat=\"ls in vm.listHoliday\" \nplaceholder=\"{{ \'MENU.CB.GHK_BALANCE.FORM_INPUT.DATE\' | translate }}\" value=\"{{ls.tanggal}}\">\n{{ls.namahari}} / {{ls.tanggal}}</md-option></md-select><div ng-messages=\"formAbsence.holiday_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Holiday Date field is required.</span></div></div></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formAbsence.$invalid || formAbsence.$pristine\" translate=\"MENU.CB.GHK_BALANCE.FORM_INPUT.SAVE\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/saldo-ghk-gw/saldo-ghk-gw.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span translate=\"MENU.CB.GHK_BALANCE.INDEX.HEADER.TITLE\">Saldo GHK\n</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent grey-A100-fg\" translate=\"MENU.CB.GHK_BALANCE.INDEX.HEADER.TITLE\">Saldo GHK</span></div></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div></div><div \nclass=\"content\"><div class=\"md-whiteframe-4dp\" layout=\"column\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper\" style=\"background: #F5F6F7\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" ng-style=\"{\'width\':\'30%\'}\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\">\n<div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.FILTER_DATA\">Filter Data</span></div><div layout=\"row\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.gedung\" name=\"gedung\"><md-option ng-repeat=\"ls in vm.listGedung\" \nplaceholder=\"GEDUNG\" value=\"{{ls.id}}\">{{ls.gedung_name}}</md-option></md-select></md-input-container>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></md-input-container></div></form></div>\n</div></md-content><md-toolbar style=\"color:#000000\"><div class=\"md-toolbar-tools table-tools\"><md-input-container \nmd-no-float class=\"md-block\" flex=\"30\"></md-input-container><span flex></span><form ng-submit=\"vm.loadData(1)\" \nname=\"formSearch\" flex><md-input-container md-no-float class=\"md-block\" flex=\"100\"><md-icon \nmd-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\"></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\">\n</md-input-container></form></div></md-toolbar><table class=\"simple\" ms-responsive-table id=\"inputTable\"><thead><tr><th\n width=\"10%\" class=\"text-center\" translate=\"HC_NEWS.TABLE.NIK\">Nik</th><th translate=\"HC_NEWS.TABLE.NAME\">Name</th><th \nwidth=\"5%\" class=\"text-center\" translate=\"MENU.CB.GHK_BALANCE.INDEX.TABLE.DWS_CODE\">DWS Code</th><th width=\"5%\" \nclass=\"text-center\" translate=\"MENU.CB.GHK_BALANCE.INDEX.TABLE.VARIANT\">Variant</th><th width=\"15%\" \nclass=\"text-center\" translate=\"MENU.CB.GHK_BALANCE.INDEX.TABLE.WORKING_DATE\">Working Date</th><th width=\"5%\" \nclass=\"text-center\" translate=\"MENU.CB.GHK_BALANCE.INDEX.TABLE.HOLIDAY_STATUS\">Holiday Status</th><th width=\"2%\" \nclass=\"text-center\" translate=\"MENU.CB.ABNORMAL.INDEX.TABLE.ACTION\">ACTION</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"(ls.approval==0)?vm.editData(ls.id):\'\'\"><td class=\"text-center\">\n{{ls.nik}}</td><td>{{ls.name}}</td><td class=\"text-center\">{{ls.dws_code}}</td><td class=\"text-center\">\n{{ls.variant}} Day</td><td class=\"text-center\">{{ls.workdayname}} / {{ls.working_date}}</td><td class=\"text-center\">\n{{ls.holidaystatus}}</td><td class=\"text-center\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item ng-if=\"ls.applyrequest\"><md-button ng-click=\"vm.SubtitutionRequest($event,ls)\" aria-label=\"Flip widget\">\n<span translate=\"ACTION.APPLY_SUBTITUTION\">Apply Subtitution</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/cb/shift-ghk-report/shift-ghk-report.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.SHIFT_GHK_REPORT.INDEX.HEADER.TITLE\">Shift/GHK Report</span></md-subheader>\n<div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"FILTER.TITLE\">Filter Data</span></div><div ng-if=\"vm.groupLogin!=11\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\">\n<md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container flex><md-select ng-model=\"vm.flag_app\" \nname=\"flag_app\"><md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" \nvalue=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option \nng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\">\n<md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon>\n<span>Search</span></md-button></div></div><div ng-if=\"vm.groupLogin==11\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.flag_app\" name=\"flag_app\"><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-button type=\"submit\" layout=\"row\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span>Submit</span></md-button></div></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div ng-if=\"vm.groupLogin!=11\" class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span>\n</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-button class=\"md-raised md-primary btn-ui-serif\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" hide show-gt-sm ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD\">Download</span></md-tooltip><span \ntranslate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-button></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.NO\">No</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th width=\"15%\"><span \nclass=\"column-title\" translate=\"TABLE.NAME\">Name</span></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.DATE\">Date</span></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.DWS_CODE\">DWS Code</span></th><th><span class=\"column-title\" \ntranslate=\"TABLE.DOWNLOAD\">Download</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td \nclass=\"text-center\">{{ls.no}}</td><td class=\"text-center\">{{ls.emp_nik}}</td><td>{{ls.emp_name}}</td><td \nclass=\"text-center\">{{ls.tanggal}}</td><td class=\"text-center\">{{ls.dwsCode}}</td><td class=\"text-center\"><span \nng-if=\"ls.download\"><md-icon class=\"green-500-fg\" md-font-icon=\"icon-check\"></md-icon></span></td></tr><tr \nng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>No Data Available</span></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/shiftlocation/input-shiftlocation.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"locationForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,locationForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.SHIFT_LOCATION.FORM.TITLE\">\nForm Input Shift Location</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.SHIFT_LOCATION.FORM.EFFECTIVE_DATE\">Effective Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"locationForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\neffective_date Date is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.SHIFT_LOCATION.FORM.SUB_AREA\">Sub Area</label><md-select ng-model=\"vm.Form.objForm.location\" \nng-required=\"true\" name=\"location\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.id}}\">{{l.description}}\n</md-option></md-select><div ng-messages=\"locationForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSub area harus di pilih.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.SHIFT_LOCATION.FORM.SHIFT_NAME\">Shift Name</label><md-select ng-model=\"vm.Form.objForm.shiftref\" \nng-change=\"vm.changeRefshift(vm.Form.objForm.shiftref)\" ng-required=\"true\" name=\"shiftref\"><md-option \nng-repeat=\"s in vm.listshiftref\" value=\"{{s}}\">{{s.shift_name}}</md-option></md-select><div \nng-messages=\"locationForm.shiftref.$error\" role=\"alert\"><div ng-message=\"required\"><span>Shift Ref harus di pilih.\n</span></div></div></md-input-container></div><div ng-if=\"vm.shift1\" layout-gt-sm=\"row\"><label>Shift 1 :</label>\n<md-input-container flex><label translate=\"MENU.CB.SHIFT_LOCATION.FORM.DWS\">DWS</label><md-select \nng-model=\"vm.Form.objForm.dwscode1\" ng-change=\"vm.changedws1(vm.Form.objForm.dwscode1)\" ng-required=\"true\" \nname=\"dwscode1\"><md-option ng-repeat=\"d1 in vm.listdws\" value=\"{{d1.dws_code}}\">{{d1.dws_code}} / {{d1.dws_text}}\n</md-option></md-select><div ng-messages=\"locationForm.listdws.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nShift Ref harus di pilih.</span></div></div></md-input-container><md-input-container flex><table \nng-if=\"vm.listdwsdetail1 !=\'\'\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \ntranslate=\"TABLE.NAME\">Name</th><th translate=\"TABLE.START_TIME\">Start Time</th><th translate=\"TABLE.END_TIME\">End Time\n</th></tr></thead><tbody><tr ng-repeat=\"dw1 in vm.listdwsdetail1\"><th>{{dw1.variant}}</th><th>{{dw1.start_time}}</th>\n<th>{{dw1.end_time}}</th></tr></tbody></table></md-input-container></div><div ng-if=\"vm.shift2\" layout-gt-sm=\"row\">\n<label>Shift 2 :</label><md-input-container flex><label translate=\"MENU.CB.SHIFT_LOCATION.FORM.DWS\">DWS</label>\n<md-select ng-model=\"vm.Form.objForm.dwscode2\" ng-change=\"vm.changedws2(vm.Form.objForm.dwscode2)\" ng-required=\"true\" \nname=\"dwscode2\"><md-option ng-repeat=\"d2 in vm.listdws\" value=\"{{d2.dws_code}}\">{{d2.dws_code}} / {{d2.dws_text}}\n</md-option></md-select><div ng-messages=\"locationForm.dwscode2.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDWS harus di pilih.</span></div></div></md-input-container><md-input-container flex><table \nng-if=\"vm.listdwsdetail2 !=\'\'\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \ntranslate=\"TABLE.NAME\">Name</th><th translate=\"TABLE.START_TIME\">Start Time</th><th translate=\"TABLE.END_TIME\">End Time\n</th></tr></thead><tbody><tr ng-repeat=\"dw2 in vm.listdwsdetail2\"><th>{{dw2.variant}}</th><th>{{dw2.start_time}}</th>\n<th>{{dw2.end_time}}</th></tr></tbody></table></md-input-container></div><div ng-if=\"vm.shift3\" layout-gt-sm=\"row\">\n<label>Shift 3 :</label><md-input-container flex><label translate=\"MENU.CB.SHIFT_LOCATION.FORM.DWS\">DWS</label>\n<md-select ng-model=\"vm.Form.objForm.dwscode3\" ng-change=\"vm.changedws3(vm.Form.objForm.dwscode3)\" ng-required=\"true\" \nname=\"dwscode3\"><md-option ng-repeat=\"d3 in vm.listdws\" value=\"{{d3.dws_code}}\">{{d3.dws_code}} / {{d3.dws_text}}\n</md-option></md-select><div ng-messages=\"locationForm.dwscode3.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDWS harus di pilih.</span></div></div></md-input-container><md-input-container flex><table \nng-if=\"vm.listdwsdetail3 !=\'\'\" class=\"simple striped\" ms-responsive-table><thead><tr><th translate=\"TABLE.NAME\">Name\n</th><th translate=\"TABLE.START_TIME\">Start Time</th><th translate=\"TABLE.END_TIME\">End Time</th></tr></thead><tbody>\n<tr ng-repeat=\"dw3 in vm.listdwsdetail3\"><th>{{dw3.variant}}</th><th>{{dw3.start_time}}</th><th>{{dw3.end_time}}</th>\n</tr></tbody></table></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\" \nng-disabled=\"locationForm.$invalid || locationForm.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/shiftlocation/shiftlocation.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Shift Location</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.inputShiftLocation($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nNew Employe Absence</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\">\n</md-icon><span>New</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteShiftlocation()\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Delete Shift</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th rowspan=\"3\" class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\" translate=\"TABLE.LOCATION_ID\">Location ID</span></th><th rowspan=\"3\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.LOCATION_NAME\">Location Name</span></th><th rowspan=\"3\" class=\"text-center\"><span\n class=\"column-title\" translate=\"TABLE.SHIFT_NAME\">Shift Name</span></th><th colspan=\"6\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.SHIFT\">Shift</span></th></tr><tr><th colspan=\"2\" class=\"text-center\"><span \nclass=\"column-title\">1</span></th><th colspan=\"2\" class=\"text-center\"><span class=\"column-title\">2</span></th><th \ncolspan=\"2\" class=\"text-center\"><span class=\"column-title\">3</span></th></tr><tr><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.FULL_DAY\">Full Day</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.HALF_DAY\">Half Day</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.FULL_DAY\">Full Day</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.HALF_DAY\">Half Day</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.FULL_DAY\">Full Day</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.HALF_DAY\">Half Day</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.lisShiftSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ls.id}}</td><td class=\"text-center\">{{ls.locationname}}</td><td class=\"text-center\">\n{{ls.shift_name}}</td><td class=\"text-center\">{{ls.full1}}</td><td class=\"text-center\">{{ls.half1}}</td><td \nclass=\"text-center\">{{ls.full2}}</td><td class=\"text-center\">{{ls.half2}}</td><td class=\"text-center\">{{ls.full3}}</td>\n<td class=\"text-center\">{{ls.half3}}</td></tr></tbody><tbody></tbody></table><div class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/sic-abnormal-approval/sic-abnormal-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"APP.CB.ABNORMAL_APPROVAL.TITLE\">Abnormal Approval</span></md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formSicAbnormalApproval\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSicAbnormalApproval.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"formSicAbnormalApproval.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.type\" name=\"type\" required><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}</md-option></md-select><div \nng-messages=\"formSicAbnormalApproval.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-button type=\"button\" \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"FILTER.SEARCH\">Search</span></md-button>\n</div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span \ntranslate=\"ACTION.ACTION\">Action</span><md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\">\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.approveAbnormal($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span translate=\"ACTION.APPROVE\">Approve</span></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.REJECT\">Reject</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formSicAbnormalApproval.$invalid || formSicAbnormalApproval.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveAbnormal($event)\" \nng-disabled=\"formSicAbnormalApproval.$invalid || formSicAbnormalApproval.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span translate=\"ACTION.APPROVE\">Aprove</span></md-button><div ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" type=\"button\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formSicAbnormalApproval.$invalid || formSicAbnormalApproval.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Reject</span></md-tooltip><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span class=\"red-700-fg\" translate=\"ACTION.REJECT\">Reject</span>\n</md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"2\"><span ng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th rowspan=\"2\" translate=\"TABLE.NAME\">Name</th><th \nrowspan=\"2\" translate=\"TABLE.WORKING_DATE\">Working Date</th><th colspan=\"4\" translate=\"TABLE.ACTUAL_DATA\">Actual Data\n</th><th colspan=\"4\" translate=\"TABLE.UPDATE_DATA\">Update Data</th><th rowspan=\"2\" translate=\"TABLE.DESCRIPTION\">\nDescription</th><th rowspan=\"2\" translate=\"TABLE.STATUS\">Status</th><th rowspan=\"2\" translate=\"TABLE.ACTION\">Action\n</th></tr><tr><th translate=\"TABLE.IN\">IN</th><th translate=\"TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"TABLE.BREAK_IN\">Break In</th><th translate=\"TABLE.OUT\">Out</th><th translate=\"TABLE.IN\">IN</th><th \ntranslate=\"TABLE.BREAK_OUT\">Break Out</th><th translate=\"TABLE.BREAK_IN\">Break In</th><th translate=\"TABLE.OUT\">Out\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==0\">\n<md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td>{{ls.nama}}</td><td>\n{{ls.working_date}}</td><td class=\"text-center\"><span ng-if=\"ls.actin !=\'empty\'\">{{ls.actin}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.actbreakOut !=\'empty\'\">{{ls.actbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actout !=\'empty\'\">\n{{ls.actout}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curin !=\'empty\'\">{{ls.curin}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.curbreakOut !=\'empty\'\">{{ls.curbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.curbreakIn !=\'empty\'\">{{ls.curbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curout !=\'empty\'\">\n{{ls.curout}}</span></td><td>{{ls.description}}</td><td class=\"text-center\"><span ng-if=\"ls.approval==1\">Approved\n</span> <span ng-if=\"ls.approval==2\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip \nmd-direction=\"top\">View Comment</md-tooltip></span><span ng-if=\"ls.approval==0\">Waiting Approval</span></td><td>\n<md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.approval==1\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"ACTION.UNAPPROVE\">Un-approve</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==2\">\n<md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span translate=\"UNREJECT\">Un-reject</span>\n</md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"14\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/sic-approval-ghk/sic-approval-ghk.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span translate=\"MENU.CB.SIC_APPROVAL_GHK.INDEX.HEADER.TITLE\">\nSM Approval GHK</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent grey-A100-fg\" translate=\"MENU.CB.SIC_APPROVAL_GHK.INDEX.HEADER.TITLE\">Approval GHK</span></div></div><div\n class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div></div><div \nclass=\"content\"><div class=\"md-whiteframe-4dp\" layout=\"column\"><md-content class=\"\" layout=\"column\"></md-content><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-menu md-offset=\"18 48\"><md-button \naria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span>\n<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-raised reference-button md-warn md-hue-2\" \nng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span translate=\"ACTION.APPROVE\">Approve\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button md-warn md-hue-2\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-undo-variant\"></md-icon><span translate=\"ACTION.REJECT\">Reject\n</span></md-button></md-menu-item></md-menu-content></md-menu></div><table class=\"simple\" ms-responsive-table \nid=\"inputTable\"><thead><tr><th></th><th translate=\"TABLE.NIK_NAME\">Nik/Name</th><th translate=\"TABLE.WORKING_DAY\">\nWorking Day</th><th translate=\"TABLE.REASON\">Reason</th><th translate=\"TABLE.DWS_CODE\">DWS Code</th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.listGhk\"><td><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td>{{ls.nik}}/{{ls.nama}}</td><td>{{ls.workdayname}} / {{ls.working_date}}</td><td>{{ls.reason}}\n</td><td>{{ls.dws_code}}</td></tr></tbody></table><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</div>");
$templateCache.put("app/main/cb/sic-changeshift-approval/sic-changeshift-approval.html","<div id=\"header-action\" class=\"page-layout simple fullwidth with-toolbar-content\" layout=\"column\"><div \nclass=\"header nabati6\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\"><span translate=\"MENU.CB.SIC_CHANGE_SHIFT_APPROVAL.INDEX.HEADER.TITLE\">Change Shift Approval</span>\n</span></div></div></div></div><div class=\"content\"><div class=\"simple-table-container\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"FILTER.TITLE\">Filter Data</span></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" \nname=\"tahun\" required><md-option ng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'FILTER.YEAR\' | translate }}\" \nvalue=\"{{val}}\">{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\" required><md-option \nng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container></div></form><div class=\"form-wrapper md-cyan-50-bg\">\n<form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"FILTER.TITLE\">Filter Data</span>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.tahun\" \nng-change=\"vm.getPeriode()\" name=\"tahun\" required><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\" required><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" \nvalue=\"{{val.value}}\">{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.type\" name=\"type\" required><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">{{val | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button \ntype=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"FILTER.SEARCH\">Search\n</span></md-button></md-input-container></div></form></div></div></div></md-content></div><div id=\"attView\"><md-toolbar\n md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">\nAction</span><md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span>\n</md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.approveChangeshift($event)\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><span translate=\"ACTION.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span translate=\"ACTION.REJECT\">Reject</span></md-button></md-menu-item></md-menu-content></md-menu><md-input-container\n hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveChangeshift($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"ACTION.APPROVE\">Aprove</span></md-button><div class=\"toolbar-separator\"></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle red-700-fg\"></md-icon><span class=\"red-700-fg\" \ntranslate=\"ACTION.REJECT\">Reject</span></md-button><span flex></span><form ng-submit=\"vm.loadData(1)\" \nname=\"formSearch\" flex><md-input-container md-no-float class=\"md-block\" flex=\"100\"><md-icon \nmd-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\"></md-icon><input type=\"text\" \nplaceholder=\"{{ \'FILTER.NIK_NAME\' | translate }}\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\">\n</md-input-container></form></div></md-toolbar><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th rowspan=\"2\">\n<span ng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th rowspan=\"2\" translate=\"TABLE.NAME\">Name</th><th \nrowspan=\"2\" translate=\"TABLE.DATE\">Date</th><th rowspan=\"2\" translate=\"TABLE.DWS_CODE\">DWS Code</th><th colspan=\"2\" \ntranslate=\"TABLE.FULL_DAY\">Full Day</th><th colspan=\"2\" translate=\"TABLE.HALF_DAY\">Half Day</th><th rowspan=\"2\" \ntranslate=\"TABLE.STATUS\">Status</th><th rowspan=\"2\" translate=\"TABLE.ACTION\">Action</th></tr><tr><th \ntranslate=\"TABLE.START_TIME\">Start Time</th><th translate=\"TABLE.END_TIME\">End Time</th><th \ntranslate=\"TABLE.START_TIME\">Start Time</th><th translate=\"TABLE.END_TIME\">End Time</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td><span ng-if=\"ls.approval==0\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td>{{ls.nama}}</td><td>{{ls.tgl}}</td>\n<td>{{ls.idshift}}</td><td>{{ls.startFull}}</td><td>{{ls.endfull}}</td><td>{{ls.startHalf}}</td><td>{{ls.endHalf}}</td>\n<td><span ng-if=\"ls.approval==0\" translate=\"TABLE.WAITING_APPROVAL\">Waiting Approval</span> <span \nng-if=\"ls.approval==1\" translate=\"TABLE.APPROVED\">Approved</span> <span ng-if=\"ls.approval==2\"><a href=\"\" \nng-click=\"vm.viewComment($event,ls)\" translate=\"TABLE.REJECTED\">Rejected</a><md-tooltip md-direction=\"top\"><span \ntranslate=\"TOOLTIP.VIEW_COMMENT\">View Comment</span></md-tooltip></span></td><td><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.approval==1\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"ACTION.UNAPPROVE\">Un-approve</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==2\">\n<md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span translate=\"ACTION.UNREJECT\">Un-reject\n</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/cb/sic-leave-approval/sic-leave-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.SIC_LEAVE_APPROVAL.INDEX.HEADER.TITLE\">Store Manager Leave Approval</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"fromSicLeaveApp\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Start Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\">\n</md-datepicker><div ng-messages=\"fromSicLeaveApp.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"fromSicLeaveApp.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" \nname=\"type\" required><md-option ng-repeat=\"val in vm.listType\" placeholder=\"{{ \'FILTER.APPROVAL_TYPE\' | translate }}\" \nvalue=\"{{val}}\">{{val | uppercase}}</md-option></md-select><div ng-messages=\"fromSicLeaveApp.bulan.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container>\n<md-button type=\"button\" class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"FILTER.SEARCH\">Search\n</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span translate=\"ACTION.APPROVE\">Approve\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.REJECT\">Reject\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" \nid=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"fromSicLeaveApp.$invalid || fromSicLeaveApp.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button ng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.approveOT($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span translate=\"ACTION.APPROVE\">Aprove</span></md-button><div ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" type=\"button\" ng-click=\"vm.Reject($event)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span>Reject</span></md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span class=\"red-700-fg\" \ntranslate=\"ACTION.REJECT\">Reject</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" on-collapse=\"vm.onCollapse()\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nid=\"inputTable\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th><span \nng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th>Name/Employee ID</th><th translate=\"TABLE.TYPE\">Type</th>\n<th translate=\"TABLE.TYPE_NAME\">Type Name</th><th translate=\"TABLE.START_DATE\">Start Date</th><th \ntranslate=\"TABLE.END_DATE\">End Date</th><th translate=\"TABLE.START_TIME\">Start Time</th><th translate=\"TABLE.END_TIME\">\nEnd Time</th><th translate=\"TABLE.DESCRIPTION\">Description</th><th translate=\"TABLE.STATUS\">Status</th><th \ntranslate=\"TABLE.ACTION\">Action</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td><span \nng-if=\"ls.allowapproval\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></span></td><td>{{ls.nik}} - {{ls.nama}}</td><td>{{ls.absence_type}}</td><td>{{ls.abssencecode}}</td><td>\n{{ls.start_date}}</td><td>{{ls.end_date}}</td><td>{{ls.start_time}}</td><td>{{ls.end_time}}</td><td>{{ls.description}}\n</td><td><span ng-if=\"ls.approval!==\'Rejected\'\">{{ls.approval}}</span> <span ng-if=\"ls.approval==\'Rejected\'\"><a \nhref=\"\" ng-click=\"vm.viewComment($event,ls)\">{{ls.approval}}</a><md-tooltip md-direction=\"top\">View Comment\n</md-tooltip></span></td><td><md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-if=\"ls.document_addres!==null\"><md-button \nng-click=\"vm.ViewDocument(ls.document_addres)\" aria-label=\"Refresh widget\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"teal-800-fg\"></md-icon><span translate=\"ACTION.VIEW_DOCUMENT\">View Document</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"ls.allowunapprove\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"ACTION.UNAPPROVE\">UnApprove</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==\'Rejected\'\">\n<md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span translate=\"ACTION.UNREJECT\">Unreject</span>\n</md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"11\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr><tr class=\"text-center\" ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td \ncolspan=\"11\" class=\"text-center\"><span>Please, Filter Data</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/sic-outlet-mapping/sic-outlet-mapping.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.OUTLET_MAPPING.INDEX.HEADER.TITLE\">Outlet Mapping</span></md-subheader><div \nclass=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><span flex hide show-gt-sm></span>\n</div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table id=\"inputTable\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" \ntranslate=\"TABLE.NO\" width=\"50px\">No</th><th translate=\"TABLE.REQUEST_DATE\" width=\"100px\">Request Date</th><th \nclass=\"text-center\" translate=\"TABLE.STATUS\" width=\"150px\">status</th><th class=\"text-center\" width=\"50px\">#</th></tr>\n</thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\"><td class=\"text-center\">{{team.no}}</td><td \nclass=\"text-center\">{{team.timestamp}}</td><td class=\"text-center\"><span ng-if=\"team.approval==0\">Waiting Approval\n</span> <span ng-if=\"team.approval==1\">Approved N1</span> <span ng-if=\"team.approval==2\">Rejected N1</span> <span \nng-if=\"team.approval==3\">Approved HR</span> <span ng-if=\"team.approval==4\">Rejected HR</span></td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"start center\" layout-wrap><md-button \nclass=\"md-icon-button\" aria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.setViewTeam($event,team)\"><md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip>\n<span>click for view team</span></md-tooltip></md-button><md-button ng-if=\"team.approval==0\" class=\"md-icon-button\" \naria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.Delete($event,team)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip><span>click for Delete</span></md-tooltip>\n</md-button></section></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/sic-outlet-team/outlet-team-mapping-lookupLayer.html","<md-dialog aria-label=\"Lookup Staf Employee\" flex=\"50\"><form ng-cloak name=\"frmApproval\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.submitApproval($event, frmApproval)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nLookup Job Title</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\" class=\"ph-20\"><h3>{{vm.AM.nik + \' - \' + vm.AM.full_name}}\n</h3><span flex></span><h3>{{vm.AM.description}}</h3></div><div layout=\"column\"><div flex-gt-sm=\"100\" flex=\"100\" \nlayout=\"column\"><md-subheader class=\"searchForm\"><md-input-container style=\"width: 100%\"><label>Search</label><input \nng-model=\"vm.searchParam\" ng-keyup=\"vm.loadLayerData(1)\"></md-input-container></md-subheader><md-content \nlayout=\"column\" layout-gt-xs=\"row\" style=\"max-height:390px\"><md-list flex><md-list-item \nng-if=\"vm.isLoadingLoadEmployee\"><md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n</md-list-item><md-list-item class=\"md-3-line jic-add-list-item-employee\" ng-repeat-start=\"item in vm.empList\" \nng-click=\"vm.selectEmployee(item)\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.jobTitleName }}</h3><p>\n{{item.fullname}}</p><p>Manpower Target: {{item.fullfilmentType}}</p></div><md-button type=\"submit\" \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.chooseEmployee(item)\"><md-icon md-font-icon=\"icon-check white-fg\">\n</md-icon>CHOOSE</md-button></md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content><div \nstyle=\"padding: 0em 1em\"><div class=\"is-bottom-nav margin-top-5\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\" class=\"white-bg\"><ul class=\"pagination\">\n<li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>CANCEL</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/sic-outlet-team/outlet-team-mapping.html","<md-dialog aria-label=\"Outlet Mapping\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloak id=\"formSicMapping\" \nname=\"formSicMapping\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveMapping($event,formSicMapping)\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.OUTLET_MAPPING.INDEX.HEADER.TITLE\">Outlet Mapping</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content style=\"background: #ffffff\"><table class=\"simple\" ms-responsive-table style=\"margin-top:10px\" \nstyle=\"color: #757575\"><thead><tr><th translate=\"TABLE.NO\">No</th><th translate=\"TABLE.NAME\">Employee Detail</th><th \ntranslate=\"TABLE.NEXT_OUTLET\" width=\"275px\">Next Outlet</th><th translate=\"TABLE.EFFECTIVE_DATE\" width=\"200px\">\nEffective Date</th><th width=\"10px\"></th></tr></thead><tbody><tr ng-repeat-start=\"scale in vm.Form.objForm.listteam\">\n<td rowspan=\"2\" class=\"text-center\">{{($index + 1)}}</td><td rowspan=\"2\"><md-input-container flex><div layout=\"column\">\n<span>{{vm.Form.objForm.listteam[$index].nik}} - {{vm.Form.objForm.listteam[$index].nama}}</span> <span class=\"mt-5\">\n{{vm.Form.objForm.listteam[$index].job_title}}</span> <span class=\"mt-5\">\n{{vm.Form.objForm.listteam[$index].sub_area_name}}</span></div><input type=\"hidden\" name=\"nik{{$index}}\" \nng-model=\"vm.Form.objForm.listteam[$index].nik\" required><div ng-messages=\"formSicMapping[\'nik\'+$index].$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>NIK is required.</span></div></div><input type=\"hidden\" \nname=\"currentArea{{$index}}\" ng-model=\"vm.Form.objForm.listteam[$index].sub_area_id\" required><div \nng-messages=\"formSicMapping[\'currentArea\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\ncurrent area is required.</span></div></div></md-input-container></td><td style=\"border: none\"><div layout=\"column\">\n<md-input-container flex><label>Next Outlet</label><md-select ng-model=\"vm.Form.objForm.listteam[$index].nextArea\" \nname=\"nextArea{{$index}}\" required md-on-close=\"vm.clearSearchTermSA($index)\" ng-click=\"vm.Form.tampilPesan = false;\">\n<md-select-header><input ng-model=\"vm.searchTermSA[$index]\" type=\"search\" placeholder=\"Search for sub area\" \nclass=\"md-text\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"ls in vm.listOutlet | filter:vm.searchTermSA[$index]\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"formSicMapping[\'nextArea\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nnextArea harus di pilih.</span></div></div></md-input-container></div></td><td style=\"border: none\"><div \nlayout=\"column\"><md-input-container flex><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date_raw{{$index}}\" \nng-model=\"vm.Form.objForm.listteam[$index].effective_date_raw\" required placeholder=\"Effective Date\" \nng-click=\"vm.Form.tampilPesan = false;\"></md-datepicker><div \nng-messages=\"formSicMapping[\'effective_date_raw\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date Date is required.</span></div></div></md-input-container></div></td></tr><tr ng-repeat-end><td \ncolspan=\"2\" style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12)\"><div layout=\"row\" layout-align=\"start none\">\n<md-input-container class=\"md-icon-float\" flex><label>Job Title</label><input type=\"text\" \nng-model=\"vm.Form.objForm.listteam[$index].jobTitleName\" ng-disabled=\"true\" name=\"jobTitle{{$index}}\" \nstyle=\"color: #757575\" required><div ng-messages=\"formSicMapping[\'jobTitleName\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\"><span>Job Title Required.</span></div></div><input type=\"hidden\" \nng-model=\"vm.Form.objForm.listteam[$index].jobTitle\" name=\"jobTitle{{$index}}\" required><div \nng-messages=\"formSicMapping[\'jobTitle\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJob Title Required.</span></div></div></md-input-container><div flex=\"nogrow\"><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\" \nng-if=\"!vm.Form.objForm.listteam[$index].effective_date && !vm.Form.objForm.listteam[$index].nextArea\"><span>\nNext Area dan Effective Date harus diisi</span></md-tooltip><md-button md-no-ink \nclass=\"md-primary jobTitle md-mini md-fab w-32 h-32\" \nng-click=\"vm.Form.tampilPesan = false;vm.lookupJobTitle($event,$index);\" \nng-disabled=\"!vm.Form.objForm.listteam[$index].effective_date_raw || !vm.Form.objForm.listteam[$index].nextArea\" \nstyle=\"margin-top: 10px\"><md-icon class=\"s16\" md-font-icon=\"icon-account-search\"></md-icon></md-button></div></div>\n</td><td></td></tr></tbody></table><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 mr-5\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" \nng-disabled=\"vm.disabledBtn\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><span translate=\"ACTION.SAVE\">Save\n</span></md-button><md-button class=\"md-mini md-raised md-default\" ng-click=\"vm.setToken()\" \nng-disabled=\"vm.disabledBtn\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><span translate=\"RELOAD_TOKEN\">Reload Token\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/sic-outlet-team/sic-outlet-team.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.OUTLET_TEAM.INDEX.HEADER.TITLE\">Outlet Team</span></md-subheader><div \nclass=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.newMapping()\" ng-disabled=\"vm.listOtselected.length == 0\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon><span>New Mapping</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.newMapping()\" \nng-disabled=\"vm.listOtselected.length == 0\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>New Mapping</span>\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table id=\"inputTable\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th></th><th class=\"text-center\" translate=\"TABLE.NAME\">Name</th><th class=\"text-center\" \ntranslate=\"TABLE.OUTLET\">Outlet</th><th class=\"text-center\" translate=\"TABLE.JOB_TITLE\">Job Title</th><th \nclass=\"text-center\">#</th></tr></thead><tbody><tr><td colspan=\"6\" ng-if=\"!vm.loadFinish\" \nstyle=\"text-align: center;vertical-align: middle\"><div layout=\"row\"><span flex></span><md-progress-circular \nng-disabled=\"!vm.loadFinish\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span style=\"margin-left:10px\">\nLoading...</span><span flex></span></div></td></tr><tr ng-repeat=\"team in vm.listEmpOutlet\"><td class=\"text-center\">\n<span><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(team)? \'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td>\n{{team.nik}} - {{team.nama}}</td><td>{{team.sub_area_name}}</td><td>{{team.job_title}}</td><td></td></tr></tbody>\n</table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/sic-update-finger-approval/sic-update-finger-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Update Finger Approval</span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formSicUpdatefingerApp\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate \nlayout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSicUpdatefingerApp.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.\n</span></div></div></md-input-container><md-input-container flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"formSicUpdatefingerApp.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" required>\n<md-option ng-repeat=\"val in vm.listType\" placeholder=\"{{ \'FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"formSicUpdatefingerApp.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" placeholder=\"{{ \'FILTER.NIK_NAME\' | translate }}\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container><md-button type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"search\" \nng-click=\"vm.loadData(1)\" ng-disabled=\"formSicUpdatefingerApp.$invalid || formSicUpdatefingerApp.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"FILTER.SEARCH\">Search\n</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\" \nng-disabled=\"formSicUpdatefingerApp.$invalid || formSicUpdatefingerApp.$pristine\"><span translate=\"ACTION.ACTION\">\nAction</span><md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span>\n</md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.approveAbnormal($event)\" \nng-disabled=\"formSicUpdatefingerApp.$invalid || formSicUpdatefingerApp.$pristine\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><span translate=\"ACTION.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formSicUpdatefingerApp.$invalid || formSicUpdatefingerApp.$pristine\"><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.REJECT\">Reject</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formSicUpdatefingerApp.$invalid || formSicUpdatefingerApp.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.approveAbnormal($event)\" \nng-disabled=\"formSicUpdatefingerApp.$invalid || formSicUpdatefingerApp.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span translate=\"ACTION.APPROVE\">Aprove</span></md-button><div ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button ng-if=\"vm.type==\'waiting approval\'\" \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" type=\"button\" ng-click=\"vm.Reject($event)\" \nng-disabled=\"formSicUpdatefingerApp.$invalid || formSicUpdatefingerApp.$pristine\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Reject</span></md-tooltip><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span class=\"red-700-fg\" translate=\"ACTION.REJECT\">Reject</span>\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table id=\"inputTable\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"2\"><span ng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th rowspan=\"2\" translate=\"TABLE.NAME\">Name</th><th \nrowspan=\"2\" translate=\"TABLE.WORKING_DATE\">Working Date</th><th colspan=\"4\" translate=\"TABLE.ACTUAL_DATA\">Actual Data\n</th><th colspan=\"4\" translate=\"TABLE.UPDATE_DATA\">Update Data</th><th rowspan=\"2\" translate=\"TABLE.DESCRIPTION\">\nDescription</th><th rowspan=\"2\" translate=\"TABLE.STATUS\">Status</th><th rowspan=\"2\" translate=\"TABLE.ACTION\">Action\n</th></tr><tr><th translate=\"TABLE.IN\">IN</th><th translate=\"TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"TABLE.BREAK_IN\">Break In</th><th translate=\"TABLE.OUT\">Out</th><th translate=\"TABLE.IN\">IN</th><th \ntranslate=\"TABLE.BREAK_OUT\">Break Out</th><th translate=\"TABLE.BREAK_IN\">Break In</th><th translate=\"TABLE.OUT\">Out\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><md-checkbox \nng-if=\"ls.approval==0\" class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" \nng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{ls.nama}}</td><td>\n{{ls.working_date}}</td><td class=\"text-center\"><span ng-if=\"ls.actin !=\'empty\'\">{{ls.actin}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.actbreakOut !=\'empty\'\">{{ls.actbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actout !=\'empty\'\">\n{{ls.actout}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curin !=\'empty\'\">{{ls.curin}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.curbreakOut !=\'empty\'\">{{ls.curbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.curbreakIn !=\'empty\'\">{{ls.curbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curout !=\'empty\'\">\n{{ls.curout}}</span></td><td>{{ls.description}}</td><td class=\"text-center\"><span ng-if=\"ls.approval==1\"><span>Approved\n</span></span> <span ng-if=\"ls.approval==2\"><a href=\"\" ng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip \nmd-direction=\"top\">View Comment</md-tooltip></span><span ng-if=\"ls.approval==0\">Waiting Approval</span></td><td>\n<md-menu><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.approval==1\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"ACTION.UNAPPROVE\">Un-approve</span></md-button></md-menu-item><md-menu-item ng-if=\"ls.approval==2\">\n<md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span translate=\"ACTION.UNREJECT\">Un-reject\n</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"14\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" \nclass=\"p-24 mb-8 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/sic-team-mapping/sic-team-mapping.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.SIC_TEAM_MAPING.INDEX.HEADER.TITLE\">SM Team Mapping List</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" ng-change=\"vm.loadData(1)\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" ng-value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\">\n<md-option ng-repeat=\"val in vm.listtahun\" placeholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}\n</md-option></md-select><div ng-messages=\"frmOutletList.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" name=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" \nplaceholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">{{val.name}}</md-option></md-select><div \nng-messages=\"frmOutletList.bulan.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-button type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" ng-click=\"vm.loadData(1)\" aria-label=\"android\"></md-icon>\n<span translate=\"ACTION.SUBMIT\">Submit</span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Twitter\" class=\"md-icon-button md-mini\" ng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div\n class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD\">Download</span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.Reject($event)\" \ntype=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete Shift</span></md-tooltip>\n<md-icon md-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span>\n</md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th width=\"5%\" translate=\"TABLE.NO\">No</th><th translate=\"TABLE.REQUEST_BY\">Request by</th><th \ntranslate=\"TABLE.DATE_REQUEST\">Tgl Request</th><th translate=\"TABLE.MAPPING_PERSON\">Mapping Person</th><th \ntranslate=\"TABLE.CURRENT_AREA\">Current Area</th><th translate=\"TABLE.NEXT_AREA\">Next Area</th><th \ntranslate=\"TABLE.DATE_MAPPING\">Tgl Mapping</th><th translate=\"\">Atasan Next Area</th></tr></thead><tbody><tr \nng-repeat=\"team in vm.DataTable.list\" ng-dblclick=\"vm.editData(team.id)\"><td>{{team.no}}</td><td>\n{{team.nik_request}}-{{team.nama_request}}</td><td>{{team.tgl_request}}</td><td>\n{{team.nik_mapping}}-{{team.nama_mapping}}</td><td>{{team.current_area}}</td><td>{{team.next_area}}</td><td>\n{{team.tgl_mapping}}</td><td>{{team.nik_atasan}}</td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/store-incharge/store-incharge.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\" layout=\"column\"><div \nclass=\"header nabati5 csm-header\" flex=\"nogrow\"><div class=\"header-content\" layout=\"column\" \nlayout-align=\"space-between\"><div class=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\"><div class=\"selected-action\">Menu</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg csm-dropdown\"><md-button ui-sref=\"app.cb_sic_input-sic\"><span translate=\"ACTION.ADD_SIC\">Add SM\n</span></md-button><md-button ng-click=\"vm.deleteSIC($event)\"><span translate=\"ACTION.DELETE_SIC\">Delete SM</span>\n</md-button></md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" flex ms-scroll><div\n class=\"md-whiteframe-4dp white-bg rounded\" layout=\"column\"><md-subheader class=\"white-bg\"><span \ntranslate=\"MENU.CB.STORE_INCHARGE.INDEX.HEADER.TITLE\">Store Manager</span></md-subheader><div class=\"white-bg\" \nlayout=\"column\"><md-content layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div\n class=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span>Filter Data</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Sub Area</label><md-select ng-model=\"vm.selectedSubarea\" \nflex-gt-sm=\"35\" name=\"subarea\" ng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTermSA()\"><md-select-header><input\n ng-model=\"vm.searchTermSA\" type=\"search\" placeholder=\"Search for sub area\" class=\"md-text\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"ls in vm.subArea | filter:vm.searchTermSA\" placeholder=\"Sub Area\" ng-value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select></md-input-container></div></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button\" \nng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-tooltip><md-icon md-font-icon=\"icon-file-excel\" \nclass=\"teal-800-fg\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div\n class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD\">Download</span></md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" on-collapse=\"vm.onCollapse()\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"50px\" translate=\"TABLE.NO\">No</th><th \ntranslate=\"TABLE.NIK_NAME\">Nik / Name</th><th width=\"300px\" translate=\"TABLE.CURRENT_OUTLET\">Current Outlet</th><th \nwidth=\"100px\">Effective Date</th><th width=\"150px\" translate=\"TABLE.STATUS\">Status</th></tr></thead><tbody><tr \nng-repeat=\"team in vm.DataTable.list\" ng-dblclick=\"vm.editData(team.id)\"><td class=\"text-center\"><span><md-checkbox \nclass=\"no-label\" ng-click=\"vm.toggle(team, vm.listSicSelected)\" aria-label=\"{{team.id}}\"></md-checkbox></span></td><td \nclass=\"text-center\">{{team.no}}</td><td>{{team.nik}} - {{team.nama}}</td><td>{{team.description}}</td><td \nclass=\"text-center\">{{team.effective_date}}</td><td class=\"text-center\"><span ng-if=\"team.status==\'1\'\" \ntranslate=\"TABLE.ACTIVE\">Active</span> <span ng-if=\"team.status==\'0\'\" translate=\"TABLE.NON_ACTIVE\">Non Active</span>\n</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0 || (vm.DataTable.list | typeOf) == \'undefined\'\">\n<td colspan=\"6\" class=\"text-center\"><span ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\">Loading</span> <span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\" ng-if=\"vm.DataTable.list.length <= 0\">No Data Available</span></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\" ng-if=\"nav.disabled!==1\">{{nav.label}}</a> <span ng-if=\"nav.disabled===1\">\n{{nav.label}}</span></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/substitution-leave-ot/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.SUBSTITUTION_LEAVE_OT.INDEX.HEADER.TITLE\">Substitution Leave OT</span>\n</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"FILTER.DIVISI\">Divisi</label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><label translate=\"FILTER.DEPARTMENT\">Department</label>\n<md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container\n flex><label>Sub Area</label><md-select ng-model=\"vm.subarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"Subarea\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Mulai Tanggal</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nmd-placeholder=\"{{ \'FILTER.START_DATE\' | translate }}\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"frmEmploye.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.</span>\n</div></div></md-input-container><md-input-container flex><label>Sampai Tanggal</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" md-placeholder=\"{{ \'FILTER.END_DATE\' | translate }}\" required \nname=\"tglakhir\"></md-datepicker><div ng-messages=\"frmEmploye.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tanggal Harus Diisi.</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">\nSearch</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\" translate=\"TABLE.NO\">No</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\" translate=\"TABLE.NAME\">Nama</span></th><th class=\"text-center\" colspan=\"6\"><span \nclass=\"column-title\" translate=\"TABLE.ABSENCE\">Absence</span></th><th class=\"text-center\" colspan=\"6\"><span \nclass=\"column-title\" translate=\"TABLE.OVERTIME\">Overtime</span></th><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\">#</span></th></tr><tr><th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.TYPE\">\nTYPE</span></th><th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.START_DATE\">START DATE</span></th>\n<th class=\"text-center\"><span class=\"column-title\" translate=\"TABLE.END_DATE\">END DATE</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.START_TIME\">START TIME</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.END_TIME\">END TIME</span></th><th class=\"text-center\">\n<span class=\"column-title\" translate=\"TABLE.DESCRIPTION\">DESCRIPTION</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"TABLE.TYPE\">TYPE</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.START_DATE\">START DATE</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.END_DATE\">END DATE</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.START_TIME\">START TIME</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.END_TIME\">END TIME</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.DESCRIPTION\">DESCRIPTION</span></th></tr></thead><tbody><tr style=\"display:none\" \nng-init=\"idemp=$index\" ng-repeat-start=\"lsemp in vm.DataTable.list track by $index\"></tr><tr><td \nrowspan=\"{{lsemp.rowd}}\">{{lsemp.no }}</td><td rowspan=\"{{lsemp.rowd}}\">{{lsemp.nik }}</td><td \nrowspan=\"{{lsemp.rowd}}\">{{lsemp.first_name }} {{lsemp.last_name }}</td><td class=\"text-center\">\n{{ lsemp.absence_type }}</td><td class=\"text-center\">{{ lsemp.start_date }}</td><td class=\"text-center\">\n{{ lsemp.end_date }}</td><td class=\"text-center\">{{ lsemp.start_time }}</td><td class=\"text-center\">\n{{ lsemp.end_time }}</td><td class=\"text-center\">{{ lsemp.description }}</td><td class=\"text-center\">\n{{ lsemp.ot_type }}</td><td class=\"text-center\">{{ lsemp.ot_date }}</td><td class=\"text-center\">{{ lsemp.ot_date }}\n</td><td class=\"text-center\">{{ lsemp.ot_start_time }}</td><td class=\"text-center\">{{ lsemp.ot_end_time }}</td><td \nclass=\"text-center\">{{ lsemp.ot_reason }}</td><td><md-menu><md-button class=\"md-icon-button action-selector\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nClick for view action</md-tooltip><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content \nwidth=\"3\" class=\"md-background-bg\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id_emp_absence\"><md-button \nng-click=\"vm.changeToOT($event,lsemp)\" aria-label=\"Refresh widget\">Change To OT</md-button></md-menu-content></md-menu>\n</td></tr><tr style=\"display:none\" ng-repeat-end></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/team-assignment-approval/team-assignment-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.ASSIGNMENTAPPROVAL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formSearchUpFingerApp\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\">\n<div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"TABLE.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"start date\" name=\"tglmulai\"></md-datepicker><div ng-messages=\"formSearchUpFingerApp.tglmulai.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"TABLE.START_DATE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"TABLE.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nplaceholder=\"end date\" name=\"tglakhir\"></md-datepicker><div ng-messages=\"formSearchUpFingerApp.tglakhir.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"TABLE.END_DATE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.type\" name=\"type\" required ng-change=\"vm.reinitCheckbox()\"><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"formSearchUpFingerApp.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.FILTER.APPROVAL_TYPE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span>\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formSearchUpFingerApp.$invalid || formSearchUpFingerApp.$pristine\"></select><span \ntranslate=\"KPI.LABEL.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"KPI.LABEL.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\"><i \nclass=\"icon-delete\"></i> <span translate=\"ACTION.REJECT\">Reject</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" hide show-gt-sm \ntype=\"button\" ng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"KPI.LABEL.APPROVE\">Aprove</span></md-button><div\n class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.REJECT\">Reject</span></md-tooltip><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span \ntranslate=\"ACTION.REJECT\">Reject</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" rowspan=\"2\" \nstyle=\"min-width: 40px !important\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.type ==\'waiting approval\' || vm.type ==\'all\'\"><md-checkbox style=\"margin: 0; max-width: 20px !important\" \nng-model=\"vm.selectAll\" ng-checked=\"vm.isCheckedAll()\" md-indeterminate=\"vm.isIndeterminate()\" \nng-click=\"vm.toggleSelectedAll()\"></md-checkbox></div></th><th class=\"text-center\" rowspan=\"2\" \nstyle=\"min-width: 60px !important\" translate=\"KPI.LABEL.NO\">No.</th><th class=\"text-center\" colspan=\"2\" \nstyle=\"min-width: 180px !important\" translate=\"KPI.LABEL.DATE\">Date</th><th class=\"text-center\" colspan=\"2\" \nstyle=\"min-width: 240px !important\" translate=\"KPI.LABEL.COSTCENTRE\">Cost Center</th><th class=\"text-center\" \nrowspan=\"2\" style=\"min-width: 120px !important\" translate=\"KPI.LABEL.DEPARTMENT\">Department</th><th \nclass=\"text-center\" rowspan=\"2\" style=\"min-width: 120px !important\" translate=\"KPI.LABEL.AREA\">Sub Area</th><th \nclass=\"text-center\" rowspan=\"2\" style=\"min-width: 120px !important\" translate=\"KPI.LABEL.REQUESTBY\">Request By</th><th \nclass=\"text-center\" rowspan=\"2\" style=\"min-width: 120px !important\" translate=\"KPI.LABEL.APPROVAL\">Approval</th><th \nclass=\"text-center\" rowspan=\"2\" translate=\"TABLE.ACTION\"></th></tr><tr><th class=\"text-center\" \nstyle=\"min-width: 90px !important\" translate=\"KPI.LABEL.START\">Start</th><th class=\"text-center\" \nstyle=\"min-width: 90px !important\" translate=\"KPI.LABEL.END\">End</th><th class=\"text-center\" \nstyle=\"min-width: 120px !important\" translate=\"KPI.LABEL.CNB\">CNB</th><th class=\"text-center\" \nstyle=\"min-width: 120px !important\" translate=\"KPI.LABEL.NONCNB\">Non CNB</th></tr></thead><tbody><tr \nng-repeat=\"team in vm.DataTable.list\"><td class=\"text-center\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"(vm.type ==\'waiting approval\' || vm.type ==\'all\') && team.approval==0\"><md-checkbox style=\"margin: 0\" \nng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team, $event)\"></md-checkbox></div></td><td \nclass=\"text-center\">{{team.no}}</td><td class=\"text-center\">{{team.startDate}}</td><td class=\"text-center\">\n{{team.endDate}}</td><td>{{team.descCnb}}</td><td>{{team.descNonCnb}}</td><td>{{team.departmentName}}</td><td>\n{{team.subAreaName}}</td><td>{{team.assign_by}} - {{team.assignByName}}</td><td style=\"min-width: 120px !important\">\n<div layout=\"column\" flex=\"noshrink\"><span ng-if=\"inls.approval_status!=\'4\'\" flex=\"noshrink\" layout=\"row\" \nng-repeat-start=\"inls in team.approval_data\"><md-tooltip md-direction=\"bottom\">\n{{inls.approval_type | uppercase}}: {{inls.appName}}</md-tooltip><md-icon \nng-if=\"inls.approval_type != \'admin-emp\' && inls.approval_status==\'1\'\" md-font-icon=\"icon-account\" \nng-class=\"inls.approval_status==\'2\' ? \'md-primary-fg\' : inls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nflex=\"nogrow\"></md-icon><md-icon \nng-if=\"inls.approval_type == \'admin-emp\' && (inls.approval_status==\'1\' || inls.approval_status==\'2\')\" \nmd-font-icon=\"icon-account-key\" \nng-class=\"inls.approval_status==\'2\' ? \'md-primary-fg\' : inls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nflex=\"nogrow\"></md-icon><span \nng-if=\"(inls.approval_type != \'admin-emp\' && inls.approval_status==\'1\') || (inls.approval_type == \'admin-emp\' && (inls.approval_status==\'1\' || inls.approval_status==\'2\'))\" \nng-class=\"inls.approval_status==\'2\' ? \'md-primary-fg\' : inls.approval_status==\'1\' ? \'blue-500-fg\' : \'md-secondary-fg\'\" \nclass=\"font-size-12 line-height-24 ml-5\" flex>{{inls.status_name}}</span> </span><span \nng-if=\"inls.approval_status==\'4\'\" flex=\"noshrink\" layout=\"row\" ng-repeat-end><md-icon \nng-if=\"inls.approval_type != \'admin-emp\'\" md-font-icon=\"icon-account\" class=\"md-accent-fg\" flex=\"nogrow\"><md-tooltip \nmd-direction=\"bottom\">{{inls.approval_type | uppercase}}: {{inls.appName}}</md-tooltip></md-icon><md-icon \nng-if=\"inls.approval_type == \'admin-emp\'\" md-font-icon=\"icon-account-key\" class=\"black-fg\" flex=\"nogrow\"><md-tooltip \nmd-direction=\"bottom\">{{inls.approval_type | uppercase}}: {{inls.appName}}</md-tooltip></md-icon><md-button md-no-ink \nclass=\"md-accent-fg\" ng-click=\"vm.viewComment($event,inls)\" class=\"font-size-12 line-height-24 ml-5\" flex>\n{{inls.status_name}}</md-button><md-tooltip md-direction=\"top\"><span translate=\"ATTENDANCE.LABEL.VIEWCOMMENT\"></span>\n</md-tooltip></span></div></td><td class=\"text-center\"><md-menu><md-button class=\"md-icon-button action-selector\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\" style=\"overflow: visible\"><md-icon md-font-icon=\"icon-dots-horizontal\">\n</md-icon><div class=\"md-background-bg md-hue-3 detail-assignment-counter ng-binding ng-scope\">{{team.employee.length}}\n</div></md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item><md-button aria-label=\"More\" \nng-click=\"vm.viewDetail($event, team, team.employee)\" layout=\"row\"><span flex translate=\"UMUT.MENU.DETAIL\">Detail\n</span> <span class=\"badge-assignment-approval md-background-bg md-hue-3\">{{team.employee.length}}</span></md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item \nng-if=\"inls.approval_type != \'admin-emp\' && inls.approved_by == vm.nik\" ng-repeat-start=\"inls in team.approval_data\">\n<md-button ng-click=\"vm.UnApproved($event,team.id)\" \nng-disabled=\"vm.checkApprovalData(inls, team.approval_data, $index)\" aria-label=\"\"><span \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.ACTION.UNAPPROVE\">Un-approve</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"inls.approval_type == \'admin-emp\'\" ng-repeat-end><md-button ng-click=\"vm.UnReject($event,inls)\" \nng-disabled=\"inls.approval_status!=\'4\'\" aria-label=\"{{inls.approval_status!=\'4\'}}\"><span \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.ACTION.UNREJECT\">Un-reject</span></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"11\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr><tr class=\"text-center\" \nng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"11\" class=\"text-center\"><span>Please, Filter Data\n</span></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\" ng-if=\"nav.disabled!==1\">{{nav.label}}</a> <span ng-if=\"nav.disabled===1\">\n{{nav.label}}</span></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/truant/truant.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.TRUANT.INDEX.HEADER.TITLE\">Employees Truant</span></md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"FILTER.TITLE\">Filter Data</span></div><div ng-if=\"vm.groupLogin!=11\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\">\n<md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container flex><md-select ng-model=\"vm.flag_app\" \nname=\"flag_app\" ng-change=\"vm.getPeriode()\"><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span>Search</span></md-button></div></div><div \nng-if=\"vm.groupLogin==11\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.flag_app\" ng-change=\"vm.getPeriode()\" name=\"flag_app\"><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\"><md-option ng-repeat=\"val in vm.listtahun\" \nplaceholder=\"{{ \'FILTER.YEAR\' | translate }}\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span>Search</span></md-button></div>\n</div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-mini\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span>\n</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-button aria-label=\"Twitter\" class=\"md-raised md-primary btn-ui-serif\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" hide show-gt-sm ng-click=\"vm.ExportToExcel()\"><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">Download</md-tooltip><span translate=\"ACTION.DOWNLOAD_EXCEL\">\nDownload Excel</span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th width=\"15%\"><span \nclass=\"column-title\" translate=\"TABLE.NAME\">Name</span></th><th width=\"15%\"><span class=\"column-title\" \ntranslate=\"TABLE.LEAVE_NAME\">Leave Name</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.START_DATE\">Start Date</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.END_DATE\">End Date</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.DESCRIPTION\">Description</span></th><th><span class=\"column-title\" translate=\"TABLE.DOWNLOAD\">Download\n</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td class=\"text-center\">{{ls.nik }}</td><td>\n{{ls.nama }}</td><td>{{ls.code}}-{{ls.name}}</td><td class=\"text-center\">{{ls.tanggal}}</td><td class=\"text-center\">\n{{ls.tanggal}}</td><td>{{ls.description}}</td><td class=\"text-center\"><span ng-if=\"ls.download\"><md-icon \nclass=\"green-500-fg\" md-font-icon=\"icon-check\"></md-icon></span></td></tr><tr ng-if=\"vm.listData.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span>No Data Available</span></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/update-finger/update-finger.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\n<span translate=\"MENU.CB.UPDATE_FINGER.INDEX.HEADER.TITLE\">Update Finger</span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option \nng-repeat=\"ls in vm.appstatus\" placeholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" \nvalue=\"{{ls.value}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"formInputOT.status.$error\" role=\"alert\"><div \nng-message=\"required\"><span>abs_code field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" flex=\"30\"></md-datepicker><div \nng-messages=\"formInputOT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" \nmd-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" flex=\"30\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \nng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>\n<span>Search</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" id=\"inputTable\" ms-responsive-table><thead><tr><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.WORKING_DATE\">Working Date</th><th colspan=\"4\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.ACTUAL_DATE\">Actual Data</th><th colspan=\"4\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.UPDATE_DATA\">Update Data</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.DESCRIPTION\">Description</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.STATUS\">Status</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.ACTION\">Action</th></tr><tr><th class=\"text-center\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.IN\">IN</th><th class=\"text-center\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.BREAK_OUT\">Break Out</th><th class=\"text-center\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.BREAK_IN\">Break In</th><th class=\"text-center\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.BREAK_OUT\">Out</th><th class=\"text-center\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.IN\">IN</th><th class=\"text-center\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.BREAK_OUT\">Break Out</th><th class=\"text-center\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.BREAK_IN\">Break In</th><th class=\"text-center\" \ntranslate=\"MENU.CB.UPDATE_FINGER.INDEX.TABLE.BREAK_OUT\">Out</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td>{{ls.working_date}}</td><td class=\"text-center\"><span \nng-if=\"ls.actin !=\'empty\'\">{{ls.actin}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actbreakOut !=\'empty\'\">\n{{ls.actbreakOut}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span>\n</td><td class=\"text-center\"><span ng-if=\"ls.actout !=\'empty\'\">{{ls.actout}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.curin !=\'empty\'\">{{ls.curin}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curbreakOut !=\'empty\'\">\n{{ls.curbreakOut}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curbreakIn !=\'empty\'\">{{ls.curbreakIn}}</span>\n</td><td class=\"text-center\"><span ng-if=\"ls.curout !=\'empty\'\">{{ls.curout}}</span></td><td><span>{{ls.description}}\n</span></td><td class=\"text-center\"><span ng-if=\"ls.approval==1\">Approved</span> <span \nng-if=\"ls.approval==0 && ls.approvaln1 !=\'1\'\">Waiting Approval</span> <span \nng-if=\"ls.approval==0 && ls.approvaln1 ==\'1\'\">Waiting Approval HR</span> <span ng-if=\"ls.approval==2\"><a href=\"\" \nng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip md-direction=\"top\">View Comment</md-tooltip></span></td>\n<td class=\"text-center\"><span ng-if=\"ls.approval==0\"><md-button class=\"md-icon-button\" aria-label=\"Favorite\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.deleteUpdate($event,ls.id)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip><span>click for delete</span></md-tooltip>\n</md-button></span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"12\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/type-shift-matrix/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.TYPE_SHIFT_MATRIX.INDEX.HEADER.TITLE\">Type Shift Matrix</span></md-subheader>\n<div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.create()\"><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.NEW\">New\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" \naria-label=\"Delete\" ng-click=\"vm.deleteData()\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.DELETE\">Delete</span></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Upload\" \nng-click=\"vm.uploadData($event)\"><md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\">\n</md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.create()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span>\n</md-tooltip><md-icon md-font-icon=\"icon-verified\"></md-icon><span translate=\"ACTION.NEW\">New</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm aria-label=\"Inert\" type=\"button\" \nng-click=\"vm.uploadData($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" type=\"button\" ng-click=\"vm.deleteData()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.DELETE\">Delete</span></md-button><span \nflex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th></th><th \ntranslate=\"TABLE.NIK\">NIK</th><th translate=\"TABLE.NAME\">NAME</th><th translate=\"TABLE.DATE_OFF\">DATE_OFF</th><th></th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($event,ls)\"><td><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{ls.nik}}</td><td>{{ls.first_name}}</td>\n<td>{{ls.date_off}}</td><td width=\"20%\"><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm \naria-label=\"Edit\" ng-click=\"vm.editData($event,ls)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-font icon-archive material-icons\"></md-icon><md-tooltip><span>Edit</span></md-tooltip></md-button></td></tr>\n</tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/update-finger-approval/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg has-upload\"><div layout=\"column\"><div layout-gt-sm=\"row\" \nng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" ng-disabled=\"vm.isdisabled\" \nng-model=\"vm.Form.objForm.comment\" placeholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.COMMENT\' | translate }}\" required><div\n ng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.rejected_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button ng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/cb/update-finger-approval/update-finger-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.UPDATE_FINGER_APPROVAL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formSearchUpFingerApp\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\">\n<div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"TABLE.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nplaceholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSearchUpFingerApp.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.START_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label translate=\"TABLE.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"formSearchUpFingerApp.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.END_DATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" ng-change=\"vm.loadData()\" \nrequired><md-option ng-repeat=\"val in vm.listType\" \nplaceholder=\"{{ \'MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" value=\"{{val}}\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"formSearchUpFingerApp.bulan.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.FILTER.APPROVAL_TYPE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span>\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"formSearchUpFingerApp.$invalid || formSearchUpFingerApp.$pristine\"></select><span>\n{{ \'KPI.LABEL.ENTRIES\' | translate}}</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approveData($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"KPI.LABEL.APPROVE\">Approve</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.Reject($event)\"><i \nclass=\"icon-delete\"></i> <span translate=\"ACTION.REJECT\">Reject</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-button ng-if=\"vm.type==\'waiting approval\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide \nshow-gt-sm type=\"button\" hide show-gt-sm type=\"button\" ng-click=\"vm.approveData($event)\"><md-icon \nmd-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"KPI.LABEL.APPROVE\">\nAprove</span></md-button><div ng-if=\"vm.type==\'waiting approval\'\" class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button ng-if=\"vm.type==\'waiting approval\'\" class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Inert\" ng-click=\"vm.Reject($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.REJECT\"></span></md-tooltip><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span \ntranslate=\"ACTION.REJECT\">Reject</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\"><span \nng-if=\"vm.type ==\'waiting approval\'\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.NAME\">Name</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.WORKING_DATE\">Working Date</th><th colspan=\"4\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.ACTUAL_DATE\">Actual Data</th><th colspan=\"4\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.UPDATE_DATA\">Update Data</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.DESCRIPTION\">Description</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.STATUS\">Status</th><th rowspan=\"2\" \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.ACTION\">Action</th></tr><tr><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.IN\">IN</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_IN\">Break In</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.OUT\">Out</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.IN\">IN</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_OUT\">Break Out</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.BREAK_IN\">Break In</th><th \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.TABLE.OUT\">Out</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span ng-if=\"ls.approval==0\"><input type=\"checkbox\" \nchecklist-model=\"vm.listOtselected\" checklist-value=\"ls\"></span></td><td>{{ls.nik}}-{{ls.nama}}</td><td>\n{{ls.working_date}}</td><td class=\"text-center\"><span ng-if=\"ls.actin !=\'empty\'\">{{ls.actin}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.actbreakOut !=\'empty\'\">{{ls.actbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.actbreakIn !=\'empty\'\">{{ls.actbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.actout !=\'empty\'\">\n{{ls.actout}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curin !=\'empty\'\">{{ls.curin}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.curbreakOut !=\'empty\'\">{{ls.curbreakOut}}</span></td><td class=\"text-center\"><span \nng-if=\"ls.curbreakIn !=\'empty\'\">{{ls.curbreakIn}}</span></td><td class=\"text-center\"><span ng-if=\"ls.curout !=\'empty\'\">\n{{ls.curout}}</span></td><td>{{ls.description}}</td><td class=\"text-center\"><span ng-if=\"ls.approval==1\" \ntranslate=\"KPI.LABEL.APPROVED\">Approved</span> <span ng-if=\"ls.approval==2\" translate=\"MYPROFILE.MENU.REJECTED\"><a \nhref=\"\" ng-click=\"vm.viewComment($event,ls)\">Rejected</a><md-tooltip md-direction=\"top\"><span \ntranslate=\"ATTENDANCE.LABEL.VIEWCOMMENT\"></span></md-tooltip></span><span ng-if=\"ls.approval==0\" \ntranslate=\"ATTENDANCE.LABEL.WAITINGAPPROVAL\">Waiting Approval</span></td><td><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.approval==1\"><md-button ng-click=\"vm.UnApproved($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.ACTION.UNAPPROVE\">Un-approve</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"ls.approval==2\"><md-button ng-click=\"vm.UnReject($event,ls)\" aria-label=\"Flip widget\"><span \ntranslate=\"MENU.CB.UPDATE_FINGER_APPROVAL.INDEX.ACTION.UNREJECT\">Un-reject</span></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"14\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/upload-annual-leave/leave-upload.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear ng-if=\"vm.loading\" md-mode=\"indeterminate\" value=\"{{vm.loading}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.uploadData()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" \nng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/upload-annual-leave/upload-annual-leave.html","<div id=\"correspondence-pma\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\"><span \ntranslate=\"MENU.CB.LEAVE_UPLOAD.INDEX.HEADER.TITLE\">Upload Leave</span></div><md-icon \nng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" style=\"padding-bottom:15px !important\" class=\"form-wrapper has-wrapper-coloum custom-filter\"><form \nname=\"frmFilter\" class=\"md-inline-form\" layout=\"row\" layout-align=\"start center\" ng-submit=\"vm.loadData(1)\" novalidate>\n<div layout=\"column\" flex layout-align=\"end center\" layout-gt-xs=\"row\"><md-input-container flex><label>Upload Date\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"upload_date\" ng-model=\"vm.upload_date\"></md-datepicker>\n</md-input-container><md-input-container flex><label>Start Date Leave</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker></md-input-container><md-input-container flex><label>\nEnd Date Leave</label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.end_date\"></md-datepicker>\n</md-input-container><md-input-container flex><label>Employee Name / Nik</label><input type=\"text\" \nplaceholder=\"employee name / nik\" ng-model=\"vm.empnik_name\" name=\"empnik_name\"></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools no-padding\"><div class=\"select-entries\" \nstyle=\"margin-right:5px\" layout=\"row\" layout-align=\"start center\" hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span>Entries</span></div><div class=\"divider-vertical\" hide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" \nlayout-align=\"center\" class=\"md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.uploadLeave($event)\"><md-icon style=\"font-size:12px\" md-font-icon=\"icon-clipboard-check\"></md-icon><span \ntranslate=\"ACTION.UPLOAD_LEAVE\" style=\"font-size:12px\">Upload Leave</span></md-button><div class=\"divider-vertical\" \nhide show-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-warn\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.isCheckActionn\" ng-click=\"vm.isCheckAction = !vm.isCheckAction;\">\n<md-icon style=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\">Delete</span>\n</md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button ng-click=\"vm.deleteData($event)\" \nng-if=\"vm.isCheckAction\" ng-disabled=\"vm.checked.length == 0\" class=\"md-icon-btn md-primary md-mini md-small\"><md-icon \nclass=\"green-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span \nstyle=\"font-size:12px\">Apply</span></md-button><md-button \nng-click=\"vm.isCheckAction = !vm.isCheckAction; vm.selectedItems = []\" ng-if=\"vm.isCheckAction\" \nclass=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" style=\"font-size:14px\" \nmd-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\">Cancel</span></md-button><span flex hide show-gt-sm>\n</span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nstyle=\"color:rgba(0,0,0,0.6); font-size: 12px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-primary\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction\" ng-click=\"vm.uploadLeave($event)\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-clipboard-check\"></md-icon><span translate=\"ACTION.UPLOAD_LEAVE\" style=\"font-size:12px\">Upload Leave\n</span></md-button></md-menu-item></md-menu-content></md-menu><span flex show hide-gt-sm></span><ms-search-bar \nstyle=\"padding:0px\" on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" \nclass=\"bouncy-slide-left\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nstyle=\"width:5%; text-align: center\" ng-if=\"vm.isCheckAction\"><div layout=\"row\" layout-align=\"center center\">\n<md-checkbox style=\"left: 10%\" ng-model=\"vm.checkAll\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></md-checkbox></div></th><th width=\"10%\"><span \nclass=\"column-title\" translate=\"TABLE.UPLOADED_BY\">Uploaded by</span></th><th width=\"5%\"><span class=\"column-title\">\nUploaded Date</span></th><th class=\"text-left\"><span class=\"column-title\" translate=\"TABLE.FILE_NAME\">File Name</span>\n</th><th width=\"5%\"><span class=\"column-title\">Status</span></th><th width=\"10%\"><span class=\"column-title\">NIK/Name\n</span></th><th width=\"5%\"><span class=\"column-title\">Absence Date</span></th><th width=\"15%\"><span \nclass=\"column-title\">Description</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nng-if=\"vm.isCheckAction\" style=\"text-align: center\"><md-checkbox ng-checked=\"vm.exists(ls, vm.selectedItems)\" \nng-click=\"vm.toggle(ls, vm.selectedItems)\"></md-checkbox></td><td class=\"text-center\">{{ls.uploadby}}/{{ls.uploadname}}\n</td><td>{{ls.upload_date}}</td><td>{{ls.filename }}</td><td class=\"text-center\"><span ng-if=\"ls.success == \'0\' \">\nSucess </span><span ng-if=\"ls.success == \'1\' \">Failed</span></td><td class=\"text-center\">{{ls.nik}}/{{ls.absname}}</td>\n<td class=\"text-center\">{{ls.absence_date}}</td><td class=\"text-center\">{{ls.description}}</td></tr></tbody></table>\n<div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/upload-annual-leave/view-error-leave-upload.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2 translate=\"MENU.CB.ERROR_UPLOAD_LEAVE.INDEX.HEADER.TITLE\">View Error Leave Upload</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"15%\"><span \nclass=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th width=\"15%\"><span class=\"column-title\" \ntranslate=\"TABLE.ABSENCE_TYPE\">Absence Type</span></th><th width=\"15%\"><span class=\"column-title\" \ntranslate=\"TABLE.START_DATE\">Start Date</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.END_DATE\">End Date</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.USAGE_PERIOD\">Usage Period</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td><span \nclass=\"red-500-fg\" ng-if=\"ls.errInfoNik==\'false\'\">{{ls.nik}}<md-tooltip md-direction=\"top\">{{ls.errInfoNik}}\n</md-tooltip></span><span ng-if=\"ls.errInfoNik==\'true\'\">{{ls.nik}}</span></td><td><span>{{ls.absence_type}}</span></td>\n<td><span class=\"red-500-fg\" ng-if=\"ls.errInfoStartDate==\'false\'\">{{ls.start_date}}<md-tooltip md-direction=\"top\">\n{{ls.errInfoStartDate}}</md-tooltip></span><span ng-if=\"ls.errInfoStartDate==\'true\'\">{{ls.start_date}}</span></td><td \nclass=\"text-center\"><span class=\"red-500-fg\" ng-if=\"ls.errInfoEndDate==\'false\'\">{{ls.end_date}}<md-tooltip \nmd-direction=\"top\">{{ls.errInfoEndDate}}</md-tooltip></span><span ng-if=\"ls.errInfoEndDate==\'true\'\">{{ls.end_date}}\n</span></td><td class=\"text-center\"><span class=\"red-500-fg\" ng-if=\"ls.errInfoUsage==\'false\'\">{{ls.periode_usage}}\n<md-tooltip md-direction=\"top\">{{ls.errInfoUsage}}</md-tooltip></span><span ng-if=\"ls.errInfoUsage==\'true\'\">\n{{ls.periode_usage}}</span></td></tr><tr ng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>\nNo Data Available</span></td></tr></tbody></table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/upload-finger/info-detail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-md=\"80\" flex-gt-md=\"60\"><md-toolbar class=\"md-orange-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Info Detail - {{vm.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label translate=\"MENU.CB.UPLOAD_FINGER.DETAIL.FILE_NAME\">File Name</label><input \nng-model=\"vm.listData.file_name\" readonly=\"readonly\"></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.UPLOAD_FINGER.DETAIL.UPLOADER\">Uploader</label><input ng-model=\"vm.listData.upload_username\" \nreadonly=\"readonly\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.UPLOAD_FINGER.DETAIL.UPLOAD_TIME\">Upload Time</label><input ng-model=\"vm.listData.upload_time\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><label translate=\"MENU.CB.UPLOAD_FINGER.DETAIL.INFO\">\nInfo</label><input ng-model=\"vm.listData.info\" readonly=\"readonly\"></md-input-container></div><div \nclass=\"white-bg md-whiteframe-1dp\" style=\"min-width: 500px\"><h2 ng-if=\"vm.listError.length == 0\">No Error</h2><table \nclass=\"simple\" ms-responsive-table ng-if=\"vm.listError.length > 0\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TABLE.NO\">no</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"TABLE.ERROR_INFO\">Error Info</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TABLE.DATA\">Data</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"div in vm.listError\"><td>{{($index + 1)}}</td><td>{{ div.error}}</td><td>\n{{ div.data}}</td></tr></tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/cb/upload-finger/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend><span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span>\n (.xlxs, .txt)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex>\n<input type=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,.txt\"></div></div>\n<span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\"><span \ntranslate=\"PAYROLL.MENU.CANCEL\"></span></md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" \nng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/upload-finger/upload-finger.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Upload Finger</span></md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span translate=\"ACTION.APPROVE\">Approve\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.REJECT\">Reject\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select \nclass=\"black-fg\" name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span class=\"black-fg\" translate=\"TABLE.ENTRIES\">Entries</span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openUploadPhoto($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">UPLOAD</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" type=\"button\" ng-click=\"vm.deleteData($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.DELETE\">DELETE\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th width=\"10%\" translate=\"TABLE.NO\">No</th><th \nclass=\"text-center\" translate=\"TABLE.FILE_NAME\">File Name</th><th class=\"text-center\" translate=\"TABLE.UPLOADER\">\nUploader</th><th class=\"text-center\" translate=\"TABLE.UPLOAD_TIME\">Upload Time</th><th class=\"text-center\" \ntranslate=\"TABLE.INFO\">Info</th></tr></thead><tbody><tr class=\"hover-tr\" ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.viewDetails($this,ls)\" ng-click=\"vm.checkone(ls)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listDataSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{($index + 1)}}</td><td \nclass=\"text-center\">{{ls.file_name}}</td><td class=\"text-center\">{{ls.upload_username}}</td><td class=\"text-center\">\n{{ls.upload_time}}</td><td title=\"Double click to view details\">{{ls.info}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/upload-attendance/upload-attendance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span class=\"parent\">Upload Attendance</span></md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><form name=\"basicForm\" \nclass=\"md-inline-form has-upload\" novalidate layout=\"row\"><fieldset flex><legend>Upload attendance</legend><md-content \nlayout=\"column\" class=\"text-center\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 0\">\n<div flex><md-button type=\"button\" ng-click=\"vm.uploadAttenddance($event)\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-50-fg\"></md-icon><span>Upload</span></md-button></div></div></md-content></fieldset></form></md-content>\n</div></div></md-content></div>");
$templateCache.put("app/main/cb/upload-attendance/upload-form.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/upload-ghk-abnormal/upload-ghk-abnormal-list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\">Upload GHK</md-subheader><div class=\"white-bg\"><md-content id=\"attendance-completion\" \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th width=\"15\" class=\"text-center\">NO</th><th class=\"\">Upload List\n</th><th width=\"40\" class=\"text-center\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listUpload\"><td>\n{{ $index + 1 }}.</td><td>{{ls.reportname}}</td><td class=\"text-center\"><div flex><md-button type=\"button\" \nng-click=\"vm.Upload($event,ls.target)\" class=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\">\n<md-icon md-font-icon=\"icon-download\" class=\"teal-50-fg\"></md-icon><span>Upload</span></md-button></div></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.listUpload.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/cb/upload-ghk-abnormal/upload-ghk-abnormal.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/upload-ghk-abnormal/view-error-upload-ghk-abnormal.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2 translate=\"MENU.CB.ERROR_UPLOAD_LEAVE.INDEX.HEADER.TITLE\">View Error Leave Upload</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"15%\"><span \nclass=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th width=\"15%\"><span class=\"column-title\" \ntranslate=\"TABLE.ABSENCE_TYPE\">Absence Type</span></th><th width=\"15%\"><span class=\"column-title\" \ntranslate=\"TABLE.START_DATE\">Start Date</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.END_DATE\">End Date</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"TABLE.USAGE_PERIOD\">Usage Period</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td><span \nclass=\"red-500-fg\" ng-if=\"ls.errInfoNik==\'false\'\">{{ls.nik}}<md-tooltip md-direction=\"top\">{{ls.errInfoNik}}\n</md-tooltip></span><span ng-if=\"ls.errInfoNik==\'true\'\">{{ls.nik}}</span></td><td><span>{{ls.absence_type}}</span></td>\n<td><span class=\"red-500-fg\" ng-if=\"ls.errInfoStartDate==\'false\'\">{{ls.start_date}}<md-tooltip md-direction=\"top\">\n{{ls.errInfoStartDate}}</md-tooltip></span><span ng-if=\"ls.errInfoStartDate==\'true\'\">{{ls.start_date}}</span></td><td \nclass=\"text-center\"><span class=\"red-500-fg\" ng-if=\"ls.errInfoEndDate==\'false\'\">{{ls.end_date}}<md-tooltip \nmd-direction=\"top\">{{ls.errInfoEndDate}}</md-tooltip></span><span ng-if=\"ls.errInfoEndDate==\'true\'\">{{ls.end_date}}\n</span></td><td class=\"text-center\"><span class=\"red-500-fg\" ng-if=\"ls.errInfoUsage==\'false\'\">{{ls.periode_usage}}\n<md-tooltip md-direction=\"top\">{{ls.errInfoUsage}}</md-tooltip></span><span ng-if=\"ls.errInfoUsage==\'true\'\">\n{{ls.periode_usage}}</span></td></tr><tr ng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>\nNo Data Available</span></td></tr></tbody></table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/upload-holiday/upload-form.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.UPLOADHOLIDAY\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset><legend><span translate=\"MENU.MAIN.UPLOADHOLIDAY\"></span> - <span \ntranslate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFile\" nv-file-select \nuploader=\"vm.FileUploader\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUploader.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-primary md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/upload-holiday/upload-holiday.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.UPLOADHOLIDAY\"></span></md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\"><div layout=\"column\" flex><div id=\"filterForm\" flex \nclass=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmAdmin\" class=\"md-inline-form\" flex \nng-submit=\"vm.loadData(1)\" layout=\"row\" layout-align=\"end center\" novalidate><md-input-container class=\"md-block\" flex>\n<label>Gedung</label><md-select ng-model=\"vm.gedung\" ng-change=\"vm.changeSector(vm.gedung)\" aria-label=\"gedung\" \nname=\"gedung\" required><md-option ng-repeat=\"ls in vm.listGedung\" placeholder=\"GEDUNG\" ng-value=\"ls.gedung_id\">\n{{ls.gedung_name}}</md-option></md-select><div ng-messages=\"frmAdmin.gedung.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Gedung field is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Sector</label><md-select ng-model=\"vm.sector\" aria-label=\"sector\" name=\"sector\" required>\n<md-option ng-repeat=\"ls in vm.listSector\" placeholder=\"SECTOR\" ng-value=\"ls.sector_id\">{{ls.sector_name}}</md-option>\n</md-select><div ng-messages=\"frmAdmin.sector.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSector field is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nGroup Shift</label><md-select ng-model=\"vm.shiftGroup\" aria-label=\"shiftGroup\" name=\"shiftGroup\" required><md-option \nng-repeat=\"ls in vm.listShiftGroup\" placeholder=\"Shift Group\" ng-value=\"ls.id\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmAdmin.shiftGroup.$error\" role=\"alert\"><div ng-message=\"required\"><span>Shift Group field is required.\n</span></div></div></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmAdmin.$invalid || frmAdmin.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></form></div></div></md-content><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span><span \ntranslate=\"MENU.MAIN.UPLOADHOLIDAY\"></span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.uploadWorkingDate($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span><span \ntranslate=\"MENU.MAIN.UPLOADWORKINGDATE\"></span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button ng-disabled=\"vm.selected.length == 0\" \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.downloadTemplateWorking()\"><md-icon md-font-icon=\"icon-download\"></md-icon><span><span \ntranslate=\"MENU.MAIN.DOWNLOADWORKINGDATE\"></span></span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-collapse=\"collapseData()\" on-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\">\n</ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" ng-click=\"vm.upload(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"UMUT.MENU.UPLOAD\"></span></md-button></md-menu-item><md-menu-item><span><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></span></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"UMUT.MENU.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.NIK_NAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"MENU.CB.GHK_HOLIDAY.TABLE.HOLIDAY\"></span></span></th>\n<th class=\"text-center\"><span class=\"column-title\"><span translate=\"MENU.CB.EMPLOYEE_GHK.INDEX.TABLE.WORKING_DATE\">\n</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.CHANGE_SHIFT.START_TIME\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.CHANGE_SHIFT.END_TIME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"MENU.CB.GHK_HOLIDAY.TABLE.REASON\"></span></span></th>\n</tr></thead><tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"\">{{item.nik}} / {{item.name}}</td><td \nclass=\"text-center\">{{item.holiday_date}}</td><td class=\"text-center\">{{item.working_date}}</td><td \nclass=\"text-center\">{{item.working_start_time}}</td><td class=\"text-center\">{{item.working_end_time}}</td><td class=\"\">\n{{item.description }}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"11\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/upload-holiday/upload-working-date-form.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.UPLOADWORKINGDATE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset><legend><span translate=\"MENU.MAIN.UPLOADWORKINGDATE\"></span> - <span \ntranslate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFile\" nv-file-select \nuploader=\"vm.FileUploaderWorking\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderWorking.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadWorkingError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotifWorking }}</span></div><div \nng-show=\"vm.uploadWorkingSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">\n{{ vm.uploadNotifWorking }}</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.FileUploaderWorking.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button \nng-if=\"vm.isMoreInfoWorking\" type=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoWorking)\" \nclass=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span translate=\"PAYROLL.MENU.MOREINFO\"></span></span>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/uploadslip/uploadslip.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span \ntranslate=\"MENU.CB.UPLOAD_SLIP.INDEX.HEADER.TITLE\">Pay Slip</span></span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon ui-sref=\"{{vm.Breadhome}}\" md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><div ng-repeat-start=\"ls  in vm.Breadlist\"></div><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\" ui-sref=\"{{ls.link}}\">{{ls.name}}</span><div ng-repeat-end></div>\n<span class=\"parent grey-A100-fg\" translate=\"MENU.CB.UPLOAD_SLIP.INDEX.HEADER.TITLE\">Pay Slip</span></div></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div><md-fab-speed-dial \nmd-direction=\"up\" class=\"action-button md-scale\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.MENU\">Menu</span></md-tooltip>\n<md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button \naria-label=\"Twitter\" class=\"md-fab md-raised md-mini\" ng-click=\"vm.openUploadPhoto($event)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.UPLOAD_FILE\">Upload File</span></md-tooltip>\n<md-icon md-font-icon=\"icon-upload\" class=\"md-primary-fg\"></md-icon></md-button><md-button aria-label=\"Twitter\" \nclass=\"md-fab md-raised md-mini\" ng-click=\"vm.Reloadatt($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.RELOAD\">Reload</span></md-tooltip><md-icon \nmd-font-icon=\"icon-reload\" class=\"md-primary-fg\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div>\n</div></div><div class=\"content\"><div class=\"simple-table-container\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper md-background-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"FILTER.TITLE\">Filter Data</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\" \nrequired><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Mulai Tanggal</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" md-placeholder=\"{{ \'FILTER.START_DATE\' | translate }}\" required \nname=\"tglmulai\"></md-datepicker><div ng-messages=\"frmEmploye.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><label>Sampai Tanggal\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nmd-placeholder=\"{{ \'FILTER.END_DATE\' | translate }}\" required name=\"tglakhir\"></md-datepicker><div \nng-messages=\"frmEmploye.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.</span>\n</div></div></md-input-container><md-input-container flex layout-align=\"right right\"><md-button type=\"submit\" \nlayout=\"row\" class=\"md-raised md-accent\" aria-label=\"{{ \'ACTION.SUBMIT\' | translate }}\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n</md-input-container></div></form></div></div></md-content><div id=\"attView\"><table class=\"simple\" ms-responsive-table \nstyle=\"margin-top:0\"><thead><tr><th><span class=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th><span \nclass=\"column-title\" translate=\"TABLE.NAME\">Nama</span></th><th><span class=\"column-title\" translate=\"TABLE.DAY_DATE\">\nHari/Tanggal</span></th><th><span class=\"column-title\" translate=\"TABLE.SHIFT\">Shift</span></th><th><span \nclass=\"column-title\" translate=\"TABLE.IN\">Masuk</span></th><th><span class=\"column-title\" translate=\"TABLE.BREAK_OUT\">\nIstirahat Keluar</span></th><th><span class=\"column-title\" translate=\"TABLE.BREAK_IN\">Istirahat Masuk</span></th><th>\n<span class=\"column-title\" translate=\"TABLE.OUT\">Pulang</span></th><th><span class=\"column-title\" \ntranslate=\"TABLE.OT_UNAPPROVED\">OT Un Approved</span></th><th><span class=\"column-title\" translate=\"TABLE.OT_APPROVED\">\nOT Approved</span></th></tr></thead><tbody ng-repeat=\"ls in vm.listData\"><tr ng-repeat=\"l in ls.att\"><td>{{ls.nik }}\n</td><td>{{ls.empname }}</td><td>{{l.tanggal }}</td><td>{{l.shift }}</td><td>{{l.masuk }}</td><td>{{l.breakout }}</td>\n<td>{{l.breakin }}</td><td>{{l.pulang }}</td><td></td><td></td></tr></tbody></table></div><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/cb/view-outlet-team/view-outlet-team.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.OUTLET_TEAM_LIST.INDEX.HEADER.TITLE\">Outlet Team List</span></md-subheader>\n<div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Twitter\" class=\"md-icon-button md-mini\" ng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD\">Download Excel</span></md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\" \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions\n</span></md-tooltip><md-icon md-font-icon=\"icon-file-excel\"></md-icon><span translate=\"ACTION.DOWNLOAD\">Download Excel\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table id=\"inputTable\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\" translate=\"TABLE.NO\">No\n</th><th translate=\"TABLE.NIK\">NIK</th><th translate=\"TABLE.NAME\">Name</th><th translate=\"TABLE.JOB_TITLE\">Job Title\n</th><th translate=\"UMUT.MENU.AREA\">Sub Area</th></tr></thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\" \nng-dblclick=\"vm.editData(team.id)\"><td class=\"text-center\">{{team.no}}</td><td class=\"text-center\">{{team.nik}}</td>\n<td>{{team.nama}}</td><td>{{team.job_title}}</td><td>{{team.sub_area_name}}</td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/warning-letter/create.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" novalidate flex><md-toolbar class=\"md-cyan-600-bg has-toolbar\">\n<div class=\"md-toolbar-tools\"><h2>Form</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div ng-if=\"!vm.isUpdate\" layout=\"row\" \nlayout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"nik\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div><div \nlayout=\"row\"><md-input-container flex><label translate=\"MENU.CB.WARNINGLETTER.TABLE.WORKINGDATE\">Working Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"working_date\" ng-model=\"vm.Form.objForm.working_date\" required>\n</md-datepicker><div ng-messages=\"frmBT.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking Date is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><label translate=\"MENU.CB.WARNINGLETTER.TABLE.REASON\">REASON</label><textarea rows=\"3\" \nng-model=\"vm.Form.objForm.reason\" name=\"reason\" ng-required=\"true\"></textarea><div ng-messages=\"frmBT.reason.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>reason field is required.</span></div></div></md-input-container></div>\n<div layout=\"row\"><md-content layout=\"column\" class=\"_md layout-column\"><md-input-container md-no-float \nclass=\"md-block\"><input accept=\"image/png, image/jpg, image/jpeg\" type=\"file\" id=\"uploadPhoto\" nv-file-select required \nuploader=\"vm.uploader\" \noptions=\"{ formData: [{\n                  nik:vm.Form.objForm.nik,\n                  working_date:vm.Form.objForm.working_date,\n                  reason:vm.Form.objForm.reason\n                }]}\">\n</md-input-container><md-progress-linear md-mode=\"determinate\" value=\"0\" class=\"md-accent hue-2 md-nabati1-theme\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" aria-valuenow=\"0\"><div \nclass=\"md-container md-mode-determinate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\" style=\"transform: translateX(-50%) scale(0, 1)\"></div></div></md-progress-linear></md-content>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"button\" ng-click=\"vm.upload(frmBT)\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/warning-letter/edit.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div \nng-if=\"!vm.isUpdate\" layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"nik\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div><div \nlayout=\"row\"><md-input-container flex><label translate=\"MENU.CB.WARNINGLETTER.TABLE.WORKINGDATE\">Working Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"working_date\" ng-model=\"vm.Form.objForm.working_date\" required>\n</md-datepicker><div ng-messages=\"frmBT.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking Date is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><label translate=\"MENU.CB.WARNINGLETTER.TABLE.REASON\">REASON</label><textarea rows=\"3\" \nng-model=\"vm.Form.objForm.reason\" name=\"reason\" ng-required=\"true\"></textarea><div ng-messages=\"frmBT.reason.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>reason field is required.</span></div></div></md-input-container></div>\n<div layout=\"row\"><md-content layout=\"column\" class=\"_md layout-column\"><md-input-container md-no-float \nclass=\"md-block\"><input accept=\"image/png, image/jpg, image/jpeg\" type=\"file\" id=\"uploadPhoto\" nv-file-select required \nuploader=\"vm.uploader\" \noptions=\"{ formData: [{  \n                      id:vm.Form.objForm.id,\n                      nik:vm.Form.objForm.nik,\n                      working_date:vm.Form.objForm.working_date,\n                      reason:vm.Form.objForm.reason\n                    }]}\">\n</md-input-container><md-progress-linear md-mode=\"determinate\" value=\"0\" class=\"md-accent hue-2 md-nabati1-theme\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" aria-valuenow=\"0\"><div \nclass=\"md-container md-mode-determinate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\" style=\"transform: translateX(-50%) scale(0, 1)\"></div></div></md-progress-linear></md-content>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/warning-letter/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.WARNINGLETTER.HEADER\">EMPLOYEE WARNING LETTER</span></md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.TITLE\">Filter Data</span></div><div flex=\"30\" layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"MENU.CB.WARNINGLETTER.TABLE.WORKINGDATE\">Working Date\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"working_date\" ng-model=\"vm.workingDate\" required></md-datepicker>\n<div ng-messages=\"frmBT.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Working Date is required.\n</span></div></div></md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button \ntype=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.INDEX.FILTER.SEARCH\">Search</span></md-button></md-input-container></div></form></div>\n</div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button md-mini\" ng-click=\"$mdMenu.open($event)\"><md-icon \nstyle=\"font-size:12px\" md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-raised md-primary btn-ui-serif md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Input($event)\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-border-color\"></md-icon><span style=\"font-size:12px\" translate=\"MENU.CB.WARNINGLETTER.NEW\">New\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" \nng-disabled=\"vm.listselected.length == 0\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i class=\"icon-delete\">\n</i> <span style=\"font-size:12px\" ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span style=\"font-size:12px\" ng-if=\"vm.listselected.length == 0\" \nclass=\"grey-700-fg\" translate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span style=\"font-size:12px\" \nng-if=\"vm.listselected.length > 0\">{{ vm.listselected.length }} selected</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"vm.DataTable.list.length==0\"></select><span class=\"secondary-text\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-primary\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.Input($event)\"><md-icon style=\"font-size:12px\" \nmd-font-icon=\"icon-border-color\"></md-icon><span style=\"font-size:12px\" translate=\"MENU.CB.GHK_HOLIDAY.NEW\">New</span>\n</md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \nng-disabled=\"vm.listselected.length == 0\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData()\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-delete\" ng-if=\"vm.listselected.length == 0\" class=\"grey-500-fg\"></md-icon>\n<md-icon style=\"font-size:12px\" md-font-icon=\"icon-delete\" ng-if=\"vm.listselected.length > 0\" class=\"red-500-fg\">\n</md-icon><span style=\"font-size:12px\" ng-if=\"vm.listselected.length > 0\" class=\"red-700-fg\" \ntranslate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span style=\"font-size:12px\" ng-if=\"vm.listselected.length == 0\" \nclass=\"grey-700-fg\" translate=\"MENU.CB.GHK_HOLIDAY.DELETE\">Delete</span> <span style=\"font-size:12px\" \nng-if=\"vm.listselected.length > 0\">{{ vm.listselected.length }} selected</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><span flex></span> <span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"1%\"><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"></md-checkbox></th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.WARNINGLETTER.TABLE.NIK\">NIK</th><th width=\"10%\" class=\"text-center\" \ntranslate=\"MENU.CB.WARNINGLETTER.TABLE.NAME\">NAME</th><th width=\"5%\" class=\"text-center\" \ntranslate=\"MENU.CB.WARNINGLETTER.TABLE.WORKINGDATE\">WORKING DATE</th><th class=\"text-center\" \ntranslate=\"MENU.CB.WARNINGLETTER.TABLE.REASON\">REASON</th><th width=\"1%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.Edit($event,ls)\"><td class=\"text-center\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.exists(ls, vm.listselected)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ls.nik}}</td><td \nclass=\"\">{{ls.name}}</td><td class=\"text-center\">{{ls.working_date}}</td><td class=\"\">{{ls.reason}}</td><td><md-menu>\n<md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.document_addres!==null\"><md-button ng-click=\"vm.ViewDocument($event,ls.file_name)\" \naria-label=\"Refresh widget\"><md-icon md-font-icon=\"icon-eye\" class=\"teal-800-fg\"></md-icon><span \ntranslate=\"ACTION.VIEW_DOCUMENT\">View Document</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n<tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/warning-letter/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View Document</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/src/modules/warningletter/document/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/emp-surveys/emp-surveys-detail/emp-surveys-detail.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\nEmployee Satisfaction Survey</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<div flex layout=\"row\" id=\"input_button_toggle\"><md-input-container class=\"md-block md-input-has-value\">\n<md-buttons-toggle-potential items=\"vm.languageList\" ng-model=\"vm.language\" selected-class=\"md-accent\">\n</md-buttons-toggle-potential></md-input-container></div><span flex hide show-gt-sm></span><div><md-button \nclass=\"md-blue-grey-300-bg md-raised white-fg\" ui-sref=\"app.emp_surveys\">Back</md-button></div></div></md-toolbar>\n<md-content layout=\"column\" layout-padding layout-fill class=\"white-bg\"><div layout=\"row\"><div flex layout=\"column\" \nstyle=\"padding: 7px\"><div layout=\"row\"><div flex=\"20\"><b>Nik</b></div><div flex=\"50\"><b>: {{vm.profile[0].nik}}</b>\n</div></div><div layout=\"row\"><div flex=\"20\"><b>Name</b></div><div flex=\"50\"><b>\n: {{vm.profile[0].title + \'. \' + vm.profile[0].first_name + \' \' + vm.profile[0].last_name}}</b></div></div></div><div \nng-if=\"vm.surveys[0].timestamp\" flex layout=\"row\" style=\"text-align: right\"><h4 class=\"green-700-fg\">\nThe survey was submitted on {{vm.surveys[0].timestamp}}</h4></div></div><ms-widget class=\"fade\" flippable=\"false\" \nlayout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-alert\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header mb-10 mt-10\" ms-responsive-table><thead><tr><th \nrowspan=\"2\">No</th><th rowspan=\"2\">Statement</th><th colspan=\"2\">Agreement</th><th colspan=\"2\">Importance</th></tr><tr>\n<th>Value</th><th>Remarks</th><th>Value</th><th>Remarks</th></tr></thead><tbody><tr ng-repeat=\"input in vm.surveys\"><td\n align=\"center\">{{($index + 1)}}</td><td><div ng-if=\"vm.language !== \'ID\'\">{{input.statement_en}}</div><div \nng-if=\"vm.language === \'ID\'\">{{input.statement}}</div></td><td style=\"text-align:center; white-space: nowrap\">\n{{input.agreement}}</td><td>{{input.agreement_remarks}}</td><td style=\"text-align:center; white-space: nowrap\">\n{{input.importance}}</td><td>{{input.importance_remarks}}</td></tr></tbody></table></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/employee/borongan-transaction/borongan-transaction-edit.html","<md-dialog aria-label=\"Input Data Borongan Transaction\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"40\"><form \nname=\"frmBT\" ng-submit=\"vm.updateData($event, frmBT)\" novalidate flex><md-toolbar flex><div class=\"md-toolbar-tools\">\n<h2>Edit Data {{ vm.info.name }} | {{ vm.info.nik}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nflex flex-gt-sm><label>Type</label><md-select ng-model=\"vm.selectedBoronganType\" name=\"boronganType\"><md-option \nng-repeat=\"ls in vm.boronganType\" value=\"{{ ls.id }}\">{{ ls.borongan_name }}</md-option></md-select><div \nng-messages=\"frmBT.boronganType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Borongan Type field is required.\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label>Select Month\n</label><md-select name=\"month\" ng-model=\"vm.selectedMonth\"><md-option ng-model=\"vm.month\" \nng-repeat=\"ls in vm.monthName\" value=\"{{ls.value}}\">{{ls.view}}</md-option></md-select><div \nng-messages=\"frmBT.month.$error\" role=\"alert\"><div ng-message=\"required\"><span>Month field is required.</span></div>\n</div></md-input-container><md-input-container flex flex-gt-sm><label>Select Years</label><md-select name=\"years\" \nng-model=\"vm.selectedYears\"><md-option ng-model=\"vm.years\" ng-repeat=\"ls in vm.years\" value=\"{{ls}}\">{{ls}}</md-option>\n</md-select><div ng-messages=\"frmBT.years.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nYears field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><label>Jumlah Pengerjaan</label><input type=\"text\" ng-model=\"vm.jumlahPengerjaan\" name=\"jumlahPengerjaan\" \nrequired><div ng-messages=\"frmBT.jumlahPengerjaan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJumlah Pengerjaan field is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\"></md-icon>Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/borongan-transaction/borongan-transaction-input.html","<md-dialog aria-label=\"Input Data Borongan Transaction\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"40\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Input Data Borongan Transaction</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><md-select \nng-model=\"vm.company\" aria-label=\"company\" name=\"company\" ng-change=\"vm.empList()\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmBT.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label>Type</label>\n<md-select ng-model=\"vm.selectedBoronganType\" name=\"boronganType\"><md-option ng-repeat=\"ls in vm.boronganType\" \nvalue=\"{{ ls.id }}\">{{ ls.borongan_name }}</md-option></md-select><div ng-messages=\"frmBT.boronganType.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Borongan Type field is required.</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex flex-gt-sm><label>Select Month</label><md-select name=\"month\" \nng-model=\"vm.selectedMonth\"><md-option ng-model=\"vm.month\" ng-repeat=\"ls in vm.monthName\" value=\"{{ls.value}}\">\n{{ls.view}}</md-option></md-select><div ng-messages=\"frmBT.month.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMonth field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label>Select Years\n</label><md-select name=\"years\" ng-model=\"vm.selectedYears\"><md-option ng-model=\"vm.years\" ng-repeat=\"ls in vm.years\" \nvalue=\"{{ls}}\">{{ls}}</md-option></md-select><div ng-messages=\"frmBT.years.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Years field is required.</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label>Jumlah Pengerjaan</label><input type=\"number\" min=\"0\" step=\"0.01\" \nng-model=\"vm.jumlahPengerjaan\" name=\"jumlahPengerjaan\" required><div ng-messages=\"frmBT.jumlahPengerjaan.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Jumlah Pengerjaan field is required.</span></div></div>\n</md-input-container></div><div layout=\"row\"><md-autocomplete flex flex-gt-sm md-selected-item=\"vm.selectedItem\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearchDeferred(vm.searchText)\" md-item-text=\"item.nik\" \nmd-input-name=\"nik\" placeholder=\"Search NIK Employee\" required><md-item-template><span \nmd-highlight-text=\"vm.searchText\">{{item.nik}} ({{item.name}})</span></md-item-template><md-not-found>\nNo NIK matching \"{{vm.searchText}}\" were found.</md-not-found><div ng-messages=\"frmBT.nik.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Nik field is required.</span></div></div></md-autocomplete></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\"></md-icon>Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/borongan-transaction/borongan-transaction-upload.html","<md-dialog aria-label=\"Upload Data Borongan Transaction\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload Data Borongan Transaction</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><div\n layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" class=\"md-inline-form\" novalidate><fieldset>\n<legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadBoronganTransaction\" nv-file-select \nuploader=\"vm.FileUploaderBoronganTransaction\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderBoronganTransaction.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadBoronganTransactionError\" flex layout \nlayout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">Failed Upload data</span></div><div \nng-show=\"vm.uploadBoronganTransactionSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">\nSuccess Upload data</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.FileUploaderBoronganTransaction.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon>Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/borongan-transaction/borongan-transaction.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Borongan Transaction</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" aria-label=\"company\" \nng-change=\"vm.loadDataDivisiAndSubArea(vm.company)\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-sm><label>Type Borongan</label><md-select \nng-model=\"vm.selectedBoronganType\" name=\"BoronganType\"><md-option ng-repeat=\"ls in vm.boronganType\" \nvalue=\"{{ ls.id }}\">{{ ls.borongan_name }}</md-option></md-select><div ng-messages=\"frmBT.BoronganType.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Borongan Type field is required.</span></div></div></md-input-container>\n<md-input-container flex flex-gt-sm><label>Select Month</label><md-select name=\"month\" ng-model=\"vm.selectedMonth\">\n<md-option ng-model=\"vm.month\" ng-repeat=\"ls in vm.monthName\" value=\"{{ls.value}}\">{{ls.view}}</md-option></md-select>\n<div ng-messages=\"frmBT.month.$error\" role=\"alert\"><div ng-message=\"required\"><span>Month field is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-sm><label>Select Years</label><md-select \nname=\"years\" ng-model=\"vm.selectedYears\"><md-option ng-model=\"vm.years\" ng-repeat=\"ls in vm.years\" value=\"{{ls}}\">\n{{ls}}</md-option></md-select><div ng-messages=\"frmBT.years.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nYears field is required.</span></div></div></md-input-container><md-button type=\"button\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"FilterCutOff\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"\" \nng-click=\"vm.addDataBoronganTransaction(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>Create New</md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"\" \nng-click=\"vm.UploadBoronganTransaction($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon>Upload Data</md-button>\n</md-menu-item><md-menu-item><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">\nUn-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu><md-input-container hide \nshow-gt-sm><select hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span>Entries</span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addDataBoronganTransaction($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span>Create new</span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.UploadBoronganTransaction($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-upload\"></md-icon><span>Upload Data</span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" \ntype=\"button\" aria-label=\"Delete\" ng-disabled=\"vm.selected.length == 0\" \nng-click=\" vm.deleteDataBoronganTransaction($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"></th><th width=\"5%\"><span \nclass=\"column-title\">NO</span></th><th class=\"text-center\"><span class=\"column-title\">NIK</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Name</span></th><th class=\"text-center\"><span class=\"column-title\">Month\n</span></th><th class=\"text-center\"><span class=\"column-title\">Year</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Jumlah Pengerjaan</span></th><th width=\"5%\"></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td>\n{{($index + 1)}}</td><td class=\"text-center\">{{item.nik}}</td><td class=\"text-center\">{{item.name}}</td><td \nclass=\"text-center\">{{item.month}}</td><td class=\"text-center\">{{item.year}}</td><td class=\"text-center\">\n{{item.jumlah_pengerjaan}}</td><td><section layout=\"row\" layout-sm=\"column\" class=\"no-padding\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" style=\"padding:0;margin:0;height: 24px;width: 24px\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editDataBoronganTransaction($event, item)\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-border-color\"></md-icon><p flex>edit</p></div></md-button></md-menu-item></md-menu-content>\n</md-menu></section></td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>\nNo Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/employe/echeckin-download.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Download Data E-Checkin</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container \nflex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"startrange\" ng-model=\"vm.startrange\">\n</md-datepicker></md-input-container><md-input-container flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"endrange\" ng-model=\"vm.endrange\"></md-datepicker></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button type=\"button\" layout=\"row\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vm.download()\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-download\" aria-label=\"android\"></md-icon>Download</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/employe-download.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack \nid=\"frmEmployeDownload\" name=\"frmEmploye\" class=\"md-inline-form popup-input-form\" novalidate><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Download Data Employee</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.groupLogin!=11\" \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nname=\"company\" md-on-close=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" ng-disabled=\"vm.budisabled\" required>\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><label>Division</label>\n<md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-disabled=\"vm.divdeptdisabled\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><label>Department</label><md-select ng-model=\"vm.department\" ng-disabled=\"vm.divdeptdisabled\" name=\"department\">\n<md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Start Range Join</label><md-datepicker md-hide-icons=\"calendar\" name=\"startrange\" \nng-model=\"vm.startrange\"></md-datepicker></md-input-container><md-input-container flex><label>End Range Join</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"endrange\" ng-model=\"vm.endrange\"></md-datepicker></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option ng-repeat=\"ls in vm.listStatus\" \nplaceholder=\"Status\" value=\"{{ls}}\">{{ls | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>status field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.contract\" name=\"contract\"><md-option \nng-repeat=\"ls in vm.typeContract\" placeholder=\"Contract\" value=\"{{ls}}\">{{ls | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.contract.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" ng-if=\"!vm.dataSales\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.employeeType\" name=\"employeeType\" ng-disabled=\"vm.typedisabled\" \nrequired><md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"Employee Type\" value=\"{{ls.value}}\">\n{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container><md-input-container \nflex><label>Sub Area</label><md-select ng-model=\"vm.subarea\" name=\"subarea\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sub area...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.subarea_id}}\" ng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">\n{{ls.description}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nng-if=\"vm.dataSales\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.employeeType\" \nname=\"employeeType\" ng-disabled=\"vm.typedisabled\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"Employee Type\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Sub Area</label><md-select \nng-model=\"vm.subarea\" name=\"subarea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.subarea_id}}\" \nng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.loadSalesArea()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a wilayah...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"wilayah\"><md-option value=\"{{ls.code_wilayah}}\" \nng-repeat=\"ls in vm.wilayahSales | filter:vm.searchTerm\">{{ls.wilayah}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Region</label><md-select ng-model=\"vm.region\" name=\"region\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"vm.wilayah==null\" ng-change=\"vm.loadSalesArea()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a region...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"sales\"><md-option value=\"{{ls.code_region}}\" \nng-repeat=\"ls in vm.regionSales | filter:vm.searchTerm\">{{ls.region}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Cabang</label><md-select ng-model=\"vm.cabang\" name=\"cabang\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"vm.region==null\" ng-change=\"vm.loadSalesArea()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a cabang...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"sales\"><md-option value=\"{{ls.code_cabang}}\" \nng-repeat=\"ls in vm.cabangSales | filter:vm.searchTerm\">{{ls.cabang}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Area Sales</label><md-select ng-model=\"vm.sales\" name=\"sales\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"vm.cabang==null\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"sales\"><md-option value=\"{{ls.code_area}}\" ng-repeat=\"ls in vm.areaSales | filter:vm.searchTerm\">\n{{ls.area}}</md-option></md-optgroup></md-select></md-input-container></div><md-divider flex class=\"mt-20 mb-30\">\n</md-divider><div layout=\"row\" layout-align=\"start none\" em-height-target><div layout=\"column\" flex=\"50\" \nstyle=\"min-height: 550px\"><fieldset em-height-source><legend>Field List</legend><table \nclass=\"with-toolbar dataTable row-border hover simple\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th width=\"5%\" style=\"text-align: center !important\">\n<md-checkbox class=\"no-label\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\" ng-model=\"vm.selectAll\" \nng-checked=\"vm.isCheckedAll\" style=\"max-width: 20px !important\"></md-checkbox></th><th style=\"display:none\" \nwidth=\"15%\" class=\"text-center\">ID</th><th class=\"text-left\">Field Name</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listCustomField\" ng-click=\"vm.toggleCheck(ls, $event)\" style=\"height: 24px !important\"><td \nwidth=\"5%\" class=\"text-center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" ng-disabled=\"vm.disable\"></md-checkbox></td><td \nstyle=\"display:none\" width=\"15%\"></td><td class=\"text-left\">{{ls.name}}</td></tr></tbody><tfoot><tr><td colspan=\"3\" \nclass=\"text-right\"><md-button type=\"button\" ng-disabled=\"vm.disable && vm.listSelected.length <= 0\" \nclass=\"md-green-300-bg md-raised md-primary white-fg md-button\" ng-click=\"vm.AddFieldList()\" \nstyle=\"margin-right: -7px\"><md-icon class=\"md-avatar-icon white-fg\" md-font-icon=\"icon-plus-circle-outline\" \naria-label=\"android\"></md-icon>Add Field</md-button></td></tr></tfoot></table></fieldset></div><div layout=\"column\" \nflex=\"50\" id=\"list-selected\"><fieldset flex layout=\"column\"><legend flex>List Field Selected</legend><div \nstyle=\"padding-top: 27px; margin-top: -27px\" flex layout=\"row\" layout-fill><md-list style=\"overflow-y: scroll\" \nlayout-fill><md-list-item ng-repeat-start=\"sel in vm.fieldSelected track by $index\" class=\"noright md-with-secondary\">\n<p>{{sel.name}}</p><md-icon class=\"md-secondary red-500-fg\" ng-click=\"vm.removeField(sel)\" aria-label=\"Chat\" \nmd-font-icon=\"icon-minus\"><md-tooltip md-direction=\"left\">Remove Field</md-tooltip></md-icon></md-list-item><md-divider\n ng-repeat-end ng-if=\"!$last\" class=\"mr-10\"></md-divider></md-list></div></fieldset></div></div></div><div \nng-if=\"vm.groupLogin==11\" layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nStart Range Join</label><md-datepicker md-hide-icons=\"calendar\" name=\"startrange\" ng-model=\"vm.startrange\">\n</md-datepicker></md-input-container><md-input-container flex><label>End Range Join</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"endrange\" ng-model=\"vm.endrange\"></md-datepicker></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option ng-repeat=\"ls in vm.listStatus\" \nplaceholder=\"Status\" value=\"{{ls}}\">{{ls | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>status field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.contract\" name=\"contract\">\n<md-option ng-repeat=\"ls in vm.typeContract\" placeholder=\"Contract Type\" value=\"{{ls}}\">{{ls | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layotu=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.employeeType\" name=\"employeeType\" ng-disabled=\"vm.typedisabled\">\n<md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"Employee Type\" value=\"{{ls.value}}\">{{ls.view | uppercase}}\n</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Employee field is required.</span></div></div></md-input-container><md-input-container flex><label>Sub Area\n</label><md-select ng-model=\"vm.subarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"Subarea\" \nvalue=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button type=\"button\" layout=\"row\" \nclass=\"md-icon-button md-button md-nabati1-theme md-ink-ripple\" aria-label=\"clear\" ng-click=\"vm.ClearFilter()\"><md-icon\n class=\"ng-scope md-nabati1-theme md-font material-icons icon-filter-remove-outline\" \nmd-font-icon=\"icon-filter-remove-outline\" aria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\">Clear Filter</md-tooltip></md-button><md-button type=\"button\" layout=\"row\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\" ng-click=\"vm.download()\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon>Download</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/employe.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"KPI.LABEL.KARYAWAN\"></span></md-subheader><div class=\"white-bg\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><md-content\n class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span>\n</label><md-select ng-model=\"vm.country\" name=\"country\" ng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" ng-disabled=\"vm.budisabled\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option ng-repeat=\"ls in vm.listBU\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.COMPANY\"></span> <span></span></div></div></md-input-container>\n<md-input-container flex><label><span translate=\"KPI.LABEL.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" \nng-disabled=\"vm.divdeptdisabled\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DIVISION\">\n</span> <span></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" ng-disabled=\"vm.divdeptdisabled\" \nname=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.DEPARTMENT\"></span> <span></span></div></div></md-input-container></div><div layout=\"column\" \nng-if=\"!vm.dataSales\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.AREA\"></span></label><md-select ng-model=\"vm.subarea\" name=\"subarea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.subarea_id}}\" \nng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label><span translate=\"FILTER.FLAG_APP\"></span></label><md-select \nng-model=\"vm.employeeType\" ng-disabled=\"vm.typedisabled\" name=\"employeeType\"><md-option ng-repeat=\"ls in vm.typeEmp\" \nvalue=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.FLAG_APP\"></span> <span></span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" \nplaceholder=\"{{ \'KPI.LABEL.NIK\' | translate}}/{{ \'KPI.LABEL.NAME\' | translate}}\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container><md-input-container flex ng-if=\"vm.eCheckin==\'true\'\"><md-switch \nclass=\"csm-md-switch\" ng-model=\"vm.viewEcheckin\" name=\"eCheckinview\" ng-change=\"vm.eCheckinchange()\" \naria-label=\"Switch 1\"><span translate=\"MENU.MAIN.ECHECKIN\"></span></md-switch></md-input-container><md-input-container \nflex=\"nogrow\"><md-button class=\"md-mini md-raised md-primary\" type=\"submit\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span>\n</md-button></md-input-container></div><div layout=\"column\" ng-if=\"vm.dataSales\" layout-gt-xs=\"row\" class=\"mt-30\">\n<md-input-container flex><label><span translate=\"KPI.LABEL.AREA\"></span></label><md-select ng-model=\"vm.subarea\" \nname=\"subarea\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.changeArea()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"subarea\"><md-option \nvalue=\"{{ls.subarea_id}}\" ng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">{{ls.description}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.WILAYAH\">\n</span></label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.loadSalesArea()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a wilayah...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.code_wilayah}}\" \nng-repeat=\"ls in vm.wilayahSales | filter:vm.searchTerm\">{{ls.wilayah}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.REGIONAL\"></span></label><md-select \nng-model=\"vm.region\" name=\"region\" md-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"vm.wilayah==null\" \nng-change=\"vm.loadSalesArea()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a region...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-optgroup label=\"sales\"><md-option value=\"{{ls.code_region}}\" \nng-repeat=\"ls in vm.regionSales | filter:vm.searchTerm\">{{ls.region}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.CABANG\"></span></label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"vm.region==null\" \nng-change=\"vm.loadSalesArea()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a cabang...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-optgroup label=\"sales\"><md-option value=\"{{ls.code_cabang}}\" \nng-repeat=\"ls in vm.cabangSales | filter:vm.searchTerm\">{{ls.cabang}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.AREASALES\"></span></label><md-select \nng-model=\"vm.sales\" name=\"sales\" md-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"vm.cabang==null\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area sales...\" \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"sales\"><md-option \nvalue=\"{{ls.code_area}}\" ng-repeat=\"ls in vm.areaSales | filter:vm.searchTerm\">{{ls.area}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><input type=\"text\" placeholder=\"Employee Name / NIK\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container><md-input-container flex=\"nogrow\"><md-button \nclass=\"md-mini md-raised md-button md-primary md-ink-ripple\" type=\"submit\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></div></div></md-content></form><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm class=\"md-primary-bg\"><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item ng-if=\"vm.upload\"><md-button \naria-label=\"Twitter\" class=\"md-green-300-bg md-raised md-primary white-fg\" ng-click=\" vm.uploadEmployee($event)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.UPLOADNEWEMPLOYEE\"></span>\n</md-tooltip><md-icon md-font-icon=\"icon-upload\" class=\"teal-800-fg\"></md-icon><span \ntranslate=\"KPI.LABEL.UPLOADNEWEMPLOYEE\"></span></md-button></md-menu-item><md-menu-item ng-if=\"vm.upload\"><md-button \naria-label=\"Twitter\" class=\"md-green-300-bg md-raised md-primary white-fg\" ng-click=\" vm.uploadContract($event)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.UPLOADEDITEMPLOYEE\"></span>\n</md-tooltip><md-icon md-font-icon=\"icon-upload\" class=\"teal-800-fg\"></md-icon><span \ntranslate=\"KPI.LABEL.UPLOADEDITEMPLOYEE\"></span></md-button></md-menu-item><md-menu-item ng-if=\"vm.eCheckin\"><md-button\n aria-label=\"Twitter\" class=\"md-green-300-bg md-raised md-primary white-fg\" ng-click=\"vm.downloadEmployee()\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.DOWNLOADECHECKIN\"></span>\n</md-tooltip><md-icon md-font-icon=\"icon-download\" class=\"teal-800-fg\"></md-icon><span \ntranslate=\"KPI.LABEL.DOWNLOADECHECKIN\"></span></md-button></md-menu-item><md-menu-item ng-if=\"vm.upload\"><md-button \naria-label=\"Twitter\" class=\"md-green-300-bg md-raised md-primary white-fg\" ng-click=\"vm.exportToExcel($event)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.EXPORTTOEXCEL\"></span>\n</md-tooltip><md-icon md-font-icon=\"icon-file-excel\" class=\"teal-800-fg\"></md-icon><span \ntranslate=\"KPI.LABEL.EXPORTTOEXCEL\"></span></md-button></md-menu-item></md-menu-content></md-menu><md-input-container \nhide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span translate=\"KPI.LABEL.ENTRIES\">Entries</span></md-input-container>\n<div class=\"divider-vertical hide show-gt-sm\" ng-if=\"vm.upload\" hide show-gt-sm></div><md-button ng-if=\"vm.upload\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\" vm.uploadEmployee($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"KPI.LABEL.UPLOADNEWEMPLOYEE\"></span></md-tooltip><span translate=\"KPI.LABEL.UPLOADNEWEMPLOYEE\"></span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" ng-if=\"vm.upload\" hide show-gt-sm></div><md-button \nng-if=\"vm.upload\" class=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\" vm.uploadContract($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\n<span translate=\"KPI.LABEL.UPLOADEDITEMPLOYEE\"></span></md-tooltip><span translate=\"KPI.LABEL.UPLOADEDITEMPLOYEE\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" ng-if=\"vm.eCheckin\" hide show-gt-sm></div><md-button \nng-if=\"vm.eCheckin\" class=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.downloadEmployee()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"KPI.LABEL.DOWNLOADECHECKIN\"></span></md-tooltip><span translate=\"KPI.LABEL.DOWNLOADECHECKIN\"></span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" ng-if=\"vm.download\" hide show-gt-sm></div><md-button \nng-if=\"vm.download\" class=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.exportToExcel()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"KPI.LABEL.EXPORTTOEXCEL\"></span></md-tooltip><span translate=\"KPI.LABEL.EXPORTTOEXCEL\"></span></md-button>\n</div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th \nclass=\"text-center font-size-12\"><span translate=\"KPI.LABEL.NO\"></span></th><th class=\"text-center font-size-12\"><span \ntranslate=\"KPI.LABEL.NIK\"></span>/<span translate=\"KPI.LABEL.NAME\"></span></th><th class=\"text-center font-size-12\">\n<span translate=\"KPI.LABEL.DIRECTREPORT\"></span></th><th class=\"text-center font-size-12\"><span \ntranslate=\"MYPROFILE.MENU.GENDER\"></span></th><th class=\"text-center font-size-12\"><span \ntranslate=\"KPI.LABEL.KARYAWAN\"></span></th><th class=\"text-center font-size-12\"><span \ntranslate=\"MYPROFILE.MENU.MARTIAL\"></span></th><th class=\"text-center font-size-12\"><span \ntranslate=\"KPI.LABEL.JOINDATE\"></span></th><th class=\"text-center font-size-12\"><span translate=\"KPI.LABEL.STATUS\">\n</span></th><th class=\"text-center font-size-12\"><span translate=\"HC_NEWS.TABLE.CATEGORY\"></span></th><th \nclass=\"text-center font-size-12\"><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.RESIGNDATE\"></span></th><th \nclass=\"text-center font-size-12\"><span translate=\"MYPROFILE.MENU.EMAIL\"></span></th><th \nclass=\"text-center font-size-12\"><span translate=\"KPI.LABEL.AREA\"></span></th><th ng-if=\"vm.country==\'MYS\'\" \nclass=\"text-center font-size-12\"><span translate=\"MYPROFILE.MENU.ISSPOUSEWORK\"></span></th><th \nclass=\"text-center font-size-12\"><span translate=\"MYPROFILE.MENU.LASTUPDATE\"></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.detailEmployee(ls.id,ls.eCheckin,ls.nik)\"><td class=\"font-size-12\">\n{{(ls.no)}}</td><td class=\"font-size-12\">{{ls.nik}} - {{ls.title}} {{ls.firstName}} {{ls.middle_name}} {{ls.lastName}}\n</td><td class=\"font-size-12\">{{ls.nik_atasan}} - {{ls.nama_atasan}}</td><td class=\"font-size-12\">{{ls.gender}}</td><td\n class=\"font-size-12\">{{ls.religion}}</td><td class=\"font-size-12\"><span ng-if=\"ls.maritalStatus\">{{ls.maritalStatus}}\n</span></td><td class=\"font-size-12\">{{ls.dateJoin}}</td><td class=\"font-size-12\">{{ls.status_active}}</td><td \nclass=\"font-size-12\">{{ls.kategori}}</td><td class=\"font-size-12\">{{ls.tgl_resign}}</td><td class=\"font-size-12\">\n{{ls.empEmail}}</td><td class=\"font-size-12\">{{ls.subAreaName}}</td><td class=\"text-center font-size-12\" \nng-if=\"vm.country==\'MYS\'\"><form name=\"formSpouseWork\" class=\"md-inline-form\"><md-switch \nng-if=\"ls.maritalStatus!=\'Married\' && ls.maritalStatus!=\'Menikah\'\" class=\"text-center\" \nng-disabled=\"ls.maritalStatus!=\'Married\' && ls.maritalStatus!=\'Menikah\'\" ng-model=\"ls.spousework\"></md-switch>\n<md-switch ng-if=\"ls.maritalStatus==\'Married\' || ls.maritalStatus==\'Menikah\'\" class=\"text-center\" \nng-click=\"vm.enableSpouseWork(formSpouseWork,ls.id,ls.spousework)\" ng-model=\"ls.spousework\"></md-switch></form></td><td\n class=\"font-size-12\">{{ls.updated_at}}</td></tr><tr class=\"text-center\" \nng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td ng-if=\"vm.country!=\'MYS\'\" colspan=\"13\" class=\"text-center\">\n<span class=\"font-size-12\">Please Do Filter First</span></td><td ng-if=\"vm.country==\'MYS\'\" colspan=\"14\" \nclass=\"text-center\"><span class=\"font-size-12\">Please Do Filter First</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td ng-if=\"vm.country!=\'MYS\'\" colspan=\"13\" class=\"text-center\"><span \nclass=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td><td ng-if=\"vm.country==\'MYS\'\" \ncolspan=\"14\" class=\"text-center\"><span class=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span>\n</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/employe-admin/employe-admin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Employee</md-subheader><div class=\"white-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon>Filter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<label>Sub Area</label><md-select ng-model=\"vm.subarea\" name=\"subarea\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.loadGedung(vm.subarea);vm.loadShiftGroup(vm.subarea)\"><md-select-header class=\"demo-select-header\"><input\n ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"subarea\"><md-option \nvalue=\"{{ls.subarea_id}}\" ng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">{{ls.description}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label>Gedung</label><md-select \nng-model=\"vm.gedung\" name=\"gedung\" ng-change=\"vm.loadSector(vm.gedung)\"><md-option ng-repeat=\"ls in vm.listGedung\" \nvalue=\"{{ls.gedung_id}}\">{{ls.gedung_name | uppercase}}</md-option></md-select></md-input-container><md-input-container\n flex><label>Sector</label><md-select ng-model=\"vm.sector\" name=\"sector\" ng-change=\"vm.loadLine()\"><md-option \nng-repeat=\"ls in vm.listSector\" value=\"{{ls.sector_id}}\">{{ls.sector_name | uppercase}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" ng-if=\"!vm.dataSales\" layout-gt-xs=\"row\" class=\"mt-30\">\n<md-input-container flex><label>Employee Status</label><md-select ng-model=\"vm.empstatus\" name=\"empstatus\"><md-option \nng-repeat=\"ls in vm.empStatus\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Shift Group</label><md-select ng-model=\"vm.shiftgroup\" \nname=\"shiftgroup\"><md-option ng-repeat=\"ls in vm.listShift\" value=\"{{ls.id}}\">{{ls.name | uppercase}}</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"text\" placeholder=\"Employee Name / NIK\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container><md-input-container flex=\"nogrow\"><md-button \nclass=\"md-mini md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.ClearFilter()\" layout=\"row\" \ntype=\"button\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Clear Filter</md-tooltip><md-icon \nmd-font-icon=\"icon-filter-remove-outline\" aria-hidden=\"true\"></md-icon></md-button></md-input-container>\n<md-input-container flex=\"nogrow\"><md-button class=\"md-mini md-raised md-primary\" type=\"submit\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button>\n</md-input-container></div></div></div></md-content></form><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm class=\"md-primary-bg\"><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item ng-if=\"vm.upload\"><md-button \nng-if=\"vm.upload\" class=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\" vm.uploadBuilding($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nUpload Building Employee</md-tooltip>Upload Building Employee</md-button></md-menu-item><md-menu-item \nng-if=\"vm.upload\"><md-button aria-label=\"Twitter\" class=\"md-green-300-bg md-raised md-primary white-fg\" \nng-click=\" vm.uploadContract($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload Edit Employee\n</md-tooltip><md-icon md-font-icon=\"icon-upload\" class=\"teal-800-fg\"></md-icon>Upload Edit Employee</md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.eCheckin\"><md-button ng-if=\"vm.upload\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\" vm.uploadEditAtasan($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nUpload Edit Atasan Employee</md-tooltip>Upload Edit Atasan Employee</md-button></md-menu-item><md-menu-item \nng-if=\"vm.upload\"><md-button ng-if=\"vm.upload\" class=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\" vm.uploadEditGroupShift($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Upload Group Shift Employee</md-tooltip>Upload Group Shift Employee</md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span>Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" ng-if=\"vm.upload\" hide show-gt-sm></div><md-button ng-if=\"vm.upload\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\" vm.uploadBuilding($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nUpload Building Employee</md-tooltip>Upload Building Employee</md-button><div class=\"divider-vertical hide show-gt-sm\" \nng-if=\"vm.upload\" hide show-gt-sm></div><md-button ng-if=\"vm.upload\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\" vm.uploadEditAtasan($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nUpload Edit Atasan Employee</md-tooltip>Upload Edit Atasan Employee</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" ng-if=\"vm.upload\" hide show-gt-sm></div><md-button ng-if=\"vm.upload\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\" vm.uploadEditGroupShift($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nUpload Group Shift Employee</md-tooltip>Upload Group Shift Employee</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" ng-if=\"vm.upload\" hide show-gt-sm></div><md-button ng-if=\"vm.upload\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\" vm.searchEmploye()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Search Employee\n</md-tooltip>Search Employee</md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><th class=\"text-center\">NO</th><th class=\"text-center\">EMP. NIK/NAME</th><th class=\"text-center\">DIRECT REPORT</th>\n<th class=\"text-center\">JOB TITLE</th><th class=\"text-center\">COST CENTER</th><th class=\"text-center\">LABOR CATEGORY\n</th><th class=\"text-center\">GEDUNG</th><th class=\"text-center\">SECTOR</th><th class=\"text-center\">LINE</th><th \nclass=\"text-center\">GROUP SHIFT</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td>{{(ls.no)}}</td>\n<td>{{ls.nik}} - {{ls.title}} {{ls.firstName}} {{ls.middle_name}} {{ls.lastName}}</td><td>\n{{ls.nik_atasan}} - {{ls.nama_atasan}}</td><td>{{ls.job_title}}</td><td>{{ls.cost_center}}</td><td>{{ls.laborType}}\n</td><td class=\"text-center\">{{ls.gedung_name}}</td><td class=\"text-center\">{{ls.sector_name}}</td><td \nclass=\"text-center\">{{ls.line_number}}</td><td class=\"text-center\">{{ls.shift_group_name}}</td></tr></tbody></table>\n<div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/employee-cost-center/download-employee-cost-center.html","<md-dialog aria-label=\"Download Data Employee Cost Center\" md-theme=\"modal-theme\" layout layout-wrap><form \nname=\"frmEmploye\" ng-submit=\"vm.download($event, frmEmploye)\" class=\"popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Download Data Employee Cost Center</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div \nlayout=\"row\"><md-input-container flex flex-gt-sm><md-select ng-model=\"vm.company\" aria-label=\"company\" name=\"company\" \nng-change=\"vm.loadDataDivisiSub(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label>Divisi</label><md-select ng-model=\"vm.divisi\" ng-disabled=\"!vm.company\" \nname=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>Department</label><md-select \nng-model=\"vm.department\" ng-disabled=\"!vm.divisi\" name=\"department\" required><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex>\n<label>Sub Area</label><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nvalue=\"{{ls.sub_area_id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container></div>\n<div layout=\"row\"><md-input-container flex flex-gt-sm><label>Employee Type</label><md-select \nng-model=\"vm.selectedEmpType\" name=\"emptype\"><md-option ng-repeat=\"ls in vm.empType\" value=\"{{ ls.value }}\">\n{{ ls.view }}</md-option></md-select><div ng-messages=\"frmEmploye.emptype.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee Type field is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\" \nclass=\"md-blue-grey-300-bg md-raised white-fg\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon>Download</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employee-cost-center/edit-employee-cost-center.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-md=\"50\" flex-gt-md=\"30\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"FormOTConfig\" class=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,FormOTConfig)\">\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Edit Employee Cost Center</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><label>NIK</label><input \nng-model=\"vm.Form.objForm.nik\" name=\"nik\" readonly=\"readonly\"></md-input-container><md-input-container flex><label>Name\n</label><input ng-model=\"vm.name\" name=\"name\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label>Cnb</label><md-select ng-model=\"vm.Form.objForm.refidcnb\" name=\"refidcnb\" required>\n<md-option ng-repeat=\"ls in vm.listcnb\" placeholder=\"Type\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"FormOTConfig.refidcnb.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label>Non Cnb</label><md-select \nng-model=\"vm.Form.objForm.refidnoncnb\" name=\"refidnoncnb\" required><md-option ng-repeat=\"ls in vm.listnoncnb\" \nplaceholder=\"Type\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"FormOTConfig.refidnoncnb.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Effective Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"effectivedate\" ng-model=\"vm.Form.objForm.effectivedate\" required></md-datepicker><div \nng-messages=\"FormOTConfig.effectivedate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDate Effective Date Required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front>\n</ms-widget><span flex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"FormOTConfig.$invalid || FormOTConfig.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employee-cost-center/employee-cost-center.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.EMPLOYEECOSTCENTRE\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\">Filter Data\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"KPI.LABEL.COMPANY\">\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required>\n<md-option ng-repeat=\"ls in vm.listBU\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.COMPANY\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.DIVISION\">Divisi</label><md-select ng-model=\"vm.divisi\" ng-disabled=\"!vm.company\" \nname=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DIVISION\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label translate=\"KPI.LABEL.DEPARTMENT\">Department</label><md-select ng-model=\"vm.department\" ng-disabled=\"!vm.divisi\" \nname=\"department\" required><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.DEPARTMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.NIK\"></span> / <span\n translate=\"KPI.LABEL.NAME\"></span></label><input type=\"text\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\">\n</md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\" \nng-cling-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><span translate=\"PAYROLL.MENU.SEARCH\">Search</span>\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-green-300-bg md-raised md-primary white-fg\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.uploadOvertimeConfig($this)\"><md-icon md-font-icon=\"icon-file-excel-box\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-green-300-bg md-raised md-primary white-fg\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.downloadEmployeeCostCenter($this)\"><md-icon md-font-icon=\"icon-download\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select class=\"black-fg\" name=\"see\" \nid=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\">\n</select><span class=\"black-fg\" translate=\"KPI.LABEL.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.uploadOvertimeConfig($this)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.downloadEmployeeCostCenter($this)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-font-icon=\"icon-download\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span \nflex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" ng-model=\"vm.searchParam\" id=\"formSearch\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"1%\" class=\"text-center\" translate=\"KPI.LABEL.NO\">No.</th><th width=\"10%\" \nclass=\"text-center\" translate=\"KPI.LABEL.NO\" class=\"text-center\" translate=\"KPI.LABEL.NIK\">nik</th><th \nclass=\"text-left\" class=\"text-center\" translate=\"KPI.LABEL.NAME\">Employee Name</th><th width=\"15%\" class=\"text-left\" \nclass=\"text-center\" translate=\"KPI.LABEL.CNB\">Cnb</th><th width=\"15%\" class=\"text-left\" class=\"text-center\" \ntranslate=\"KPI.LABEL.NONCNB\">Non Cnb</th><th width=\"10%\" class=\"text-center\" translate=\"PAYROLL.MENU.EFFECTIVEDATE\" \nstyle=\"text-align: center\">Effective Date</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editData($this,ls)\"><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{ls.nik}}\n</td><td class=\"text-left\">{{ls.empName}}</td><td class=\"text-left\">{{ls.cnbdescription}}</td><td class=\"text-left\">\n{{ls.noncnbdescription}}</td><td class=\"text-center\">{{ls.effective_date}}</td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/employee-cost-center/upload-employee-cost-center.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\" md-theme=\"modal-theme\"><form ng-cloack \nname=\"uploadPhoto\" class=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.UPLOAD\"></span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\">\n<md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" \nid=\"uploadPhoto\" nv-file-select uploader=\"vm.FileUploaderPhoto\"></div><div class=\"text-right\" flex><md-button \ntype=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" \naria-label=\"Submit\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon><span \ntranslate=\"PAYROLL.MENU.UPLOAD\"></span></md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>{{ vm.message | translate }}</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>{{ vm.message | translate }}</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/employee/employee-labor-type/employee-labor-type.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"KPI.LABEL.EMPLABORTYPE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" aria-label=\"company\" \nng-change=\"vm.loadDataDivisiAndSubArea(vm.company)\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'KPI.LABEL.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.COMPANY\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.divisi\" aria-label=\"divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" \nrequired><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'KPI.LABEL.DIVISION\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.DIVISION\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.DEPARTMENT\"></span>\n</label><md-select ng-model=\"vm.department\" aria-label=\"department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'KPI.LABEL.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.DEPARTMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.AREA\"></span>\n</label><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nvalue=\"{{ls.sub_area_id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.AREA\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" aria-label=\"FilterCutOff\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit</md-button></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select hide \nshow-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-raised md-primary btn-ui-serif\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addEmpLabor($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"UMUT.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-plus-box\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"UMUT.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-raised md-primary btn-ui-serif\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.UploadEmpLabor($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"UMUT.MENU.UPLOAD\"></span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"UMUT.MENU.UPLOAD\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteEmpLabor($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" ng-click=\"vm.addEmpLabor($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\nCreate New</md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" \naria-label=\"\" ng-click=\"vm.UploadEmpLabor($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon>Upload Data\n</md-button></md-menu-item><md-menu-item><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">\nUn-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content \nstyle=\"background:white\" hide-gt-sm><span flex=\"5\"></span><md-list class=\"md-dense\" flex><md-list-item \nclass=\"md-3-line\" ng-repeat=\"item in vm.DataTables.list\" ng-click=\"null\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4>{{ item.name }} | {{ item.nik }}</h4><p><span translate=\"KPI.LABEL.LABORTYPE\"></span>\n : {{ item.labor_type }}</p><p><span translate=\"KPI.LABEL.LOCATION\"></span> : {{item.location}}</p><p><span \ntranslate=\"KPI.LABEL.EFFECTIVEDATE\"></span> : {{item.effective_date}}</p><md-checkbox class=\"md-secondary\" \naria-label=\"CutOffChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></div><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypmenu\" \nclass=\"md-icon-button\" style=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editEmpLabor($event, item)\"><div layout=\"row\" flex>\n<md-icon md-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex><span translate=\"KPI.LABEL.EDIT\">\n</span></p></div></md-button></md-menu-item></md-menu-content></md-menu><md-divider \nstyle=\"border-width:0.5px; border-color:whitesmoke; border-style: solid\"></md-divider></md-list-item></md-list><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\">\n</th><th width=\"5%\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NIK\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.LABORTYPE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"KPI.LABEL.AREA\"></span></span></th><th width=\"2%\"></th>\n</tr></thead><tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td>{{($index + 1)}}</td><td class=\"text-center\">{{item.nik}}</td><td class=\"text-center\">\n{{item.name}}</td><td class=\"text-center\">{{item.labor_type}}</td><td class=\"text-center\">{{item.effective_date}}</td>\n<td class=\"text-center\">{{item.location}}</td><td><section layout=\"row\" layout-sm=\"column\" class=\"no-padding\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" style=\"padding:0;margin:0;height: 24px;width: 24px\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editEmpLabor($event, item)\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-border-color\"></md-icon><p flex><span translate=\"KPI.LABEL.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\"></span></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/employee-reports/emp-finish-contract.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>\nDownload Employee FInish Contract</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nflex-gt-xs=\"30\" class=\"no-errors-spacer\"><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" required></md-datepicker><div \nng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" \nname=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker><div ng-messages=\"frmEmploye.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><span flex>\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"40\"><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nflex-gt-xs=\"50\"><md-select ng-model=\"vm.flag_app\" name=\"flag_app\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"50\"><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" required><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-input-container flex layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-click=\"vm.download()\" ng-disabled=\"frmEmploye.$invalid\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-download\" aria-label=\"android\"></md-icon><span translate=\"ACTION.DOWNLOAD\">Download</span>\n</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employee-reports/employee-reports.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\">Employee Report</md-subheader><div class=\"white-bg\"><md-content id=\"attendance-completion\" \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th width=\"15\" class=\"text-center\">NO</th><th class=\"\">Report List\n</th><th width=\"40\" class=\"text-center\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listReport\"><td>\n{{ $index + 1 }}.</td><td>{{ls.reportname}}</td><td class=\"text-center\"><div flex><md-button type=\"button\" \nng-click=\"vm.Download($event,ls.target)\" class=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\">\n<md-icon md-font-icon=\"icon-download\" class=\"teal-50-fg\"></md-icon><span>Download</span></md-button></div></td></tr><tr\n class=\"text-center\" ng-if=\"vm.listReport.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/employee/employement/employement.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.EMPLOYEMENT\"></span></md-subheader><div class=\"white-bg\"><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><div\n class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.employee_employement_input\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"MYPROFILE.MENU.ADD\">Add Employement</span></md-tooltip><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"MYPROFILE.MENU.ADD\">Add Employement</span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.listEmployementSelected.length == 0\" ng-click=\" vm.deleteEmployement($event)\"><md-icon \nng-if=\"vm.listEmployementSelected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon \nng-if=\"vm.listEmployementSelected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.listEmployementSelected.length > 0\" class=\"red-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> \n<span ng-if=\"vm.listEmployementSelected.length == 0\" class=\"grey-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span>\n</span> <span style=\"color:red\" ng-if=\"vm.listEmployementSelected.length > 0\">{{ vm.listEmployementSelected.length }} \n<span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div\n class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"KPI.LABEL.NO\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"KPI.LABEL.NIK\">NIK</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"KPI.LABEL.DIRECTREPORT\">NIK ATASAN</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"UMUT.MENU.GRADE\">GRADE</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"KPI.LABEL.POSITIONID\">POSITION ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"KPI.LABEL.EMPPROFILEID\">EMP PROFILE ID</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listEmployement\" ng-dblclick=\"vm.editData(div.nik)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listEmployementSelected\" checklist-value=\"div\"></td><td class=\"text-center\">\n{{ ($index + 1)}}</td><td class=\"text-center\">{{ div.nik}}</td><td class=\"text-center\">{{ div.nik_atasan}}</td><td \nclass=\"text-center\">{{ div.grade}}</td><td class=\"text-center\">{{ div.positionid}}</td><td class=\"text-center\">\n{{ div.emp_profile_id}}</td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/employee-uniform/edit-employe-uniform.html","<md-dialog id=\"UniformDialog\" aria-label=\"Form Update Finger Data\" md-theme=\"modal-theme\" flex layout=\"column\"><form \nng-cloack name=\"FormEUConfig\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,FormEUConfig)\" flex layout=\"column\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Set Sent Uniform</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" flex id=\"contentDialog\" layout=\"column\" \nstyle=\"overflow: hidden\"><div layout=\"column\" id=\"uniform-wrapper\"><md-input-container flex><label>Effective Date\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"effectivedate\" ng-model=\"vm.Form.objForm.effectivedate\" required>\n</md-datepicker></md-input-container></div><div layout=\"column\" id=\"Selected-wrapper\" layout-fill flex \nclass=\"pb-10 content syllabus-list-pane\"><md-subheader>{{vm.data.length}} Selected</md-subheader><div \nclass=\"scrollable\" ms-scroll=\"{suppressScrollX: true}\" flex><section><md-list class=\"fixedRows\"><md-list-item \nclass=\"md-2-line contact-item\" ng-repeat=\"ls in vm.data\"><div class=\"md-list-item-text compact\"><h3>\n{{ls.nik + \' - \' + ls.fullName}}</h3><p>{{ls.subAreaName}}</p><p>{{ls.empEmail}}</p></div></md-list-item></md-list>\n</section></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"FormEUConfig.$invalid\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employee-uniform/employe-uniform.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EMPUNIFORM\"></span></md-subheader><div class=\"white-bg\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><md-content\n class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.COMPANY\"></span>\n</label><md-select ng-model=\"vm.company\" ng-disabled=\"vm.budisabled\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.COMPANY\"></span> <span translate=\"PAYROLL.MENU.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex><label><span translate=\"FILTER.FLAG_APP\"></span></label>\n<md-select ng-model=\"vm.employeeType\" ng-disabled=\"vm.typedisabled\" name=\"employeeType\"><md-option \nng-repeat=\"ls in vm.typeEmp\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.FLAG_APP\">\n</span> <span translate=\"PAYROLL.MENU.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"KPI.LABEL.AREA\"></span></label><md-select ng-model=\"vm.subarea\" name=\"subarea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.subarea_id}}\" \nng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" \nplaceholder=\"{{ \'KPI.LABEL.NIK\' | translate}} / {{ \'KPI.LABEL.NAME\' | translate}}\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container><md-input-container flex=\"nogrow\"><md-button class=\"md-mini md-raised md-primary\" \ntype=\"submit\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm class=\"mr-10\"><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \ntranslate=\"KPI.LABEL.ENTRIES\"></span></md-input-container><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button style=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-disabled=\"vm.isCheckAction\" \nng-click=\"vm.isCheckAction = !vm.isCheckAction;vm.isCheckActionAdd = true;vm.isCheckActionDelete = false;\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-clipboard-check\"></md-icon><span style=\"font-size:12px\"><span \ntranslate=\"KPI.LABEL.SENDING\"></span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nstyle=\"margin:0\" layout=\"row\" layout-align=\"center\" class=\"md-warn\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isCheckAction\" \nng-click=\"vm.isCheckAction = !vm.isCheckAction;vm.isCheckActionAdd = false;vm.isCheckActionDelete = true;\"><md-icon \nstyle=\"font-size:12px\" md-font-icon=\"icon-trash\"></md-icon><span style=\"font-size:12px\"><span \ntranslate=\"KPI.LABEL.RESETSENT\"></span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm \nng-if=\"vm.isCheckAction\"></div><md-button \nng-click=\"vm.applyData($event, vm.selectedItems);vm.isCheckActionAdd = false;vm.isCheckActionDelete = false;\" \nng-if=\"vm.isCheckAction\" ng-disabled=\"vm.checked.length == 0\" class=\"md-icon-btn md-primary md-mini md-small\"><md-icon \nclass=\"green-700-fg\" style=\"font-size:14px\" md-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span \nstyle=\"font-size:12px\"><span translate=\"KPI.LABEL.APPLY\"></span></span></md-button><md-button ng-click=\"vm.cancel()\" \nng-if=\"vm.isCheckAction\" class=\"md-icon-btn md-warn md-mini md-small\"><md-icon class=\"red-700-fg\" \nstyle=\"font-size:14px\" md-font-icon=\"icon-close\"></md-icon><span style=\"font-size:12px\"><span \ntranslate=\"ACTION.CANCEL\"></span></span></md-button></div></md-toolbar></form><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\"><thead><tr><td ng-if=\"vm.isCheckAction\" style=\"width: 5%; text-align: center\"><md-checkbox \nclass=\"mt-10\" ng-model=\"vm.checkAll\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" \nng-click=\"vm.toggleAll()\"></md-checkbox><th class=\"text-center\"><span class=\"mt-10 mb-5\" style=\"display: block\"><span \ntranslate=\"KPI.LABEL.NIK\"></span>/<span translate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\"><span \nclass=\"mt-10 mb-5\" style=\"display: block\"><span translate=\"KPI.LABEL.DIRECTREPORT\"></span></span></th><th \nclass=\"text-center\"><span class=\"mt-10 mb-5\" style=\"display: block\"><span translate=\"KPI.LABEL.AREA\"></span></span>\n</th><th class=\"text-center\"><span class=\"mt-10 mb-5\" style=\"display: block\"><span translate=\"KPI.LABEL.STATUS\"></span>\n</span></th><th class=\"text-center\"><span class=\"mt-10 mb-5\" style=\"display: block\"><span \ntranslate=\"KPI.LABEL.JOINDATE\"></span></span></th><th class=\"text-center\"><span class=\"mt-10 mb-5\" \nstyle=\"display: block\"><span translate=\"TABLE.WORKING_DAY\"></span></span></th><th class=\"text-center\"><span \nclass=\"mt-10 mb-5\" style=\"display: block\"><span translate=\"KPI.LABEL.UNIFORM\"></span></span></th></td></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.detailEmployee(ls.id,ls.nik)\"><td \nng-if=\"vm.isCheckAction\" style=\"text-align: center\"><md-checkbox ng-if=\"vm.parseIntAdd(ls.remaining_days) <= 0\" \nclass=\"mt-5 mb-5\" ng-checked=\"vm.exists(ls, vm.selectedItems)\" ng-click=\"vm.toggle(ls, vm.selectedItems)\">\n</md-checkbox></td><td>{{ls.nik}} - {{ls.fullName}}<br ng-if=\"ls.empEmail\"><small ng-if=\"ls.empEmail\">{{ls.empEmail}}\n</small></td><td>{{ls.nik_atasan}} - {{ls.nama_atasan}}</td><td>{{ls.subAreaName}}</td><td><span \nng-if=\"vm.cekStatus(ls.status_emp)\">Parttime</span></td><td class=\"text-center\">{{ls.dateJoin}}</td><td \nclass=\"text-center\">{{ls.working_days}} Days</td><td>\n{{ls.effective_date_uniform ? \'Sent\' : (vm.parseIntAdd(ls.remaining_days) > 0 ? ls.remaining_days + \' Days Remaining\' : \'Ready To Sent\')}}\n<br ng-if=\"ls.effective_date_uniform\"><small ng-if=\"ls.effective_date_uniform\">{{ls.effective_date_uniform}}</small>\n</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0 || (vm.DataTable.list | typeOf) == \'undefined\'\">\n<td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/employee-update-approval/approval-show-documents.html","<md-dialog aria-label=\"New SM\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>View Documents</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout layout-fill style=\"background: #ffffff\"><div layout=\"colum\" \nlayout-align=\"center\" flex layout-fill><div layout=\"column\" flex><div ng-bind-html=\"vm.templateKtp\"></div></div><div \nflex=\"5\"></div><div layout=\"column\" flex><div ng-bind-html=\"vm.templateMarital\"></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/employee-update-approval/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.reject_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button ng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span translate=\"ACTION.REJECT\">Reject\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employee-update-approval/employee-update-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.EMPLOYEEUPDATEAPPROVAL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label><span translate=\"ATTENDANCE.LABEL.TYPE\"></span>\n</label><md-select ng-model=\"vm.type\" required><md-option ng-repeat=\"val in vm.listType\" placeholder=\"Type\" \nvalue=\"{{val}}\">{{val}}</md-option></md-select><div ng-messages=\"frmEmploye.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"ATTENDANCE.LABEL.TYPE\"></span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.company\" ng-disabled=\"vm.budisabled\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.COMPANY\"></span></div></div></md-input-container>\n<md-input-container flex><label translate=\"TABLE.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglmulai\" name=\"tglmulai\"></md-datepicker></md-input-container><md-input-container flex><label \ntranslate=\"TABLE.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nname=\"tglakhir\"></md-datepicker></md-input-container><md-input-container flex><md-select ng-model=\"vm.employeeType\" \nname=\"employeeType\" required ng-disabled=\"vm.group==131\"><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.FLAG_APP\' | translate}}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"FILTER.FLAG_APP\"></span></div></div></md-input-container><md-button class=\"md-mini md-raised md-primary\" \ntype=\"submit\" ng-disabled=\"frmEmploye.$invalid\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"android\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Approve()\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span translate=\"KPI.LABEL.APPROVE\"></span>\n</md-button></md-menu-item><md-menu-item><md-button class=\"md-green-300-bg md-raised md-primary white-fg\" \nng-click=\"vm.download($event)\"><md-icon md-font-icon=\"icon-download\"></md-icon><span translate=\"PAYROLL.MENU.DOWNLOAD\">\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-warn md-mini\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.REJECT\">REJECT\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-warn md-mini\" \nng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"KPI.LABEL.DELETE\">\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.Approve()\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.APPROVE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"KPI.LABEL.APPROVE\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm type=\"button\" ng-click=\"vm.Reject($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.REJECT\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.REJECT\">\nREJECT</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" ng-click=\"vm.download($event)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-button class=\"md-warn md-mini\" hide show-gt-sm type=\"button\" ng-click=\"vm.deleteData($event)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span><span \ntranslate=\"KPI.LABEL.DELETE\"></span></span></md-button><span flex></span> <span flex hide show-gt-sm></span> <span \nflex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><tr><th></th><th class=\"text-center\" \ntranslate=\"KPI.LABEL.NIK\">NIK</th><th class=\"text-center\" translate=\"KPI.LABEL.NAME\">Employe Name</th><th \nclass=\"text-center\" translate=\"KPI.LABEL.COMPANY\">Company</th><th class=\"text-center\" translate=\"KPI.LABEL.UPDATETYPE\">\nUpdate Type</th><th class=\"text-center\">Modified Date</th><th class=\"text-center\" translate=\"KPI.LABEL.STATUS\">status\n</th><th class=\"text-center\" translate=\"KPI.LABEL.ACTION\">#</th></tr><tbody><tr \nng-repeat=\"team in vm.listData track by $index\"><td class=\"text-center\"><span ng-if=\"team.approval==0\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(team)\" ng-click=\"vm.toggleCheck(team,$event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(team)?\'Uncheck\':\'check\'}}\"></md-checkbox></span></td><td class=\"text-center\">\n{{team.emp_nik}}</td><td>{{team.emp_name}}</td><td class=\"text-center\">{{team.company}}</td><td class=\"text-center\">\n{{team.transactionType | uppercase}}</td><td class=\"text-center\">{{team.modifiedDate}}</td><td class=\"text-center\">\n<span ng-if=\"team.approvalinfo!==\'Rejected\'\">{{team.approvalinfo | uppercase}}</span> <span \nng-if=\"team.approvalinfo==\'Rejected\'\"><a href=\"\" ng-click=\"vm.viewComment($event,team)\">\n{{team.approvalinfo | uppercase}}</a><md-tooltip md-direction=\"top\"><span translate=\"ATTENDANCE.LABEL.VIEWCOMMENT\">\n</span></md-tooltip></span></td><td class=\"text-center\"><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setViewTeam($event,team)\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span translate=\"PAYROLL.MENU.VIEWDETAIL\">click for view detail update</span>\n</md-tooltip></md-button></td></tr><tr class=\"text-center\" ng-if=\"(vm.listData | typeOf) == \'undefined\'\"><td \ncolspan=\"8\" class=\"text-center\"><span>Loading, Please Wait</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"(vm.listData | typeOf) != \'undefined\' && vm.listData.length > 0\"><div \nclass=\"tbl-info\" ng-if=\"vm.listData.length <= 1\">Showing {{vm.listData.length}} entrie</div><div class=\"tbl-info\" \nng-if=\"vm.listData.length > 1\">Showing {{vm.listData.length}} entries</div></div></md-content></div></div></md-content>\n</div>");
$templateCache.put("app/main/employee/employee-update-approval/view-dependents-update.html","<md-dialog aria-label=\"New SM\" flex=\"70\" id=\"formKpiPeople\" md-theme=\"modal-theme\"><form ng-cloak \nname=\"formSicMapping\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveMapping($event,formSicMapping)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>View Dependents Update</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"background: #ffffff\"><div layout=\"column\"><div layout=\"row\"><div flex><div \nlayout=\"column\"><table class=\"simple\" ms-responsive-table><thead><tr><th class=\"text-center\" colspan=\"5\">Old Data</th>\n</tr><tr><th>Type Of Family</th><th>Name</th><th>Birth Place</th><th>Date of Birth</th><th>Gender</th></tr></thead>\n<tbody style=\"height: 200px; overflow-y: scroll\"><tr><td>{{vm.oldData.type_of_family}}</td><td>\n{{vm.oldData.first_name}} {{vm.oldData.last_name}}</td><td>{{vm.oldData.birth_place}}</td><td>\n{{vm.oldData.date_of_birth}}</td><td>{{vm.oldData.gender}}</td></tr></tbody></table></div></div></div><span flex>\n</span><div layout=\"row\"><div flex><div layout=\"column\"><table class=\"simple\" ms-responsive-table><thead><tr><th \nclass=\"text-center\" colspan=\"5\">New Data</th></tr><tr><th>Type Of Family</th><th>Name</th><th>Birth Place</th><th>\nDate of Birth</th><th>Gender</th></tr></thead><tbody style=\"height: 200px; overflow-y: scroll\"><tr><td>\n{{vm.newData.type_of_family}}</td><td>{{vm.newData.first_name}} {{vm.newData.last_name}}</td><td>\n{{vm.newData.birth_place}}</td><td>{{vm.newData.date_of_birth}}</td><td>{{vm.newData.gender}}</td></tr></tbody></table>\n</div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button \nclass=\"md-button md-ink-ripple md-accent md-hue-2\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.downLoadID($event)\">\n<md-icon md-font-icon=\"icon-download\"></md-icon>Download Document<md-tooltip><span>click for download ID</span>\n</md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employee-update-approval/view-detail-update.html","<md-dialog aria-label=\"New SM\" flex=\"70\" id=\"formKpiPeople\" md-theme=\"modal-theme\"><form ng-cloak \nname=\"formSicMapping\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveMapping($event,formSicMapping)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"ATTENDANCE.LABEL.VIEWDETAILUPDATE\"></span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"background: #ffffff\"><div \nlayout=\"column\" layout-fill><div layout=\"row\" flex layout-fill><table class=\"simple\" \nstyle=\"width:100%; border-bottom: 1px solid #ccc\"><thead><tr><th style=\"text-align: left\" colspan=\"4\" \ntranslate=\"KPI.LABEL.OLDDATA\">Old Data</th></tr><tr><th style=\"width:25%\" class=\"text-left\" translate=\"KPI.LABEL.NAME\">\nName</th><th style=\"width:20%\" class=\"text-left\" translate=\"MYPROFILE.MENU.DATEOFBIRTH\">Date Of Birth</th><th \nstyle=\"width:20%\" class=\"text-left\" translate=\"MYPROFILE.MENU.MARTIAL\">Marital Status</th><th style=\"width:35%\" \nclass=\"text-left\" translate=\"MYPROFILE.MENU.EMAIL\">Email</th></tr></thead><tbody><tr><td style=\"width:25%\" \nclass=\"text-left\">{{vm.oldData.first_name}} {{vm.oldData.middle_name}} {{vm.oldData.last_name}}</td><td \nstyle=\"width:20%\" class=\"text-left\">{{vm.oldData.place_of_birth}}/{{vm.oldData.dateOfBirth}}</td><td style=\"width:20%\" \nclass=\"text-left\">{{vm.oldData.maritalStatus}}</td><td style=\"width:35%\" class=\"text-left\">{{vm.oldData.empEmail}}</td>\n</tr></tbody></table></div><div flex style=\"margin:10px 0\"></div><div layout=\"row\" flex layout-fill><table \nclass=\"simple\" style=\"width:100%; border-bottom: 1px solid #ccc\"><thead><tr><th style=\"text-align: left\" colspan=\"4\" \ntranslate=\"KPI.LABEL.NEWDATA\">New Data</th></tr><tr><th style=\"width:25%\" class=\"text-left\" translate=\"KPI.LABEL.NAME\">\nName</th><th style=\"width:20%\" class=\"text-left\" translate=\"MYPROFILE.MENU.DATEOFBIRTH\">Date Of Birth</th><th \nstyle=\"width:20%\" class=\"text-left\" translate=\"MYPROFILE.MENU.MARTIAL\">Marital Status</th><th style=\"width:35%\" \nclass=\"text-left\" translate=\"MYPROFILE.MENU.EMAIL\">Email</th></tr></thead><tbody><tr><td style=\"width:25%\" \nclass=\"text-left\">{{vm.newData.firstName}} {{vm.newData.middleName}} {{vm.newData.lastName}}</td><td style=\"width:20%\" \nclass=\"text-left\">{{vm.newData.placeOfBirth}}/{{vm.newData.dateOfBirth}}</td><td style=\"width:20%\" class=\"text-left\">\n{{vm.newData.maritalStatus}}</td><td style=\"width:35%\" class=\"text-left\">{{vm.newData.empEmail}}</td></tr></tbody>\n</table></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><div layout=\"row\" \nlayout-align=\"start\" ng-if=\"vm.isDocumentNotExists\"><span style=\"color:red; font-size: 12px\" \nng-if=\"vm.attributeComplete.ktp\" translate=\"MYPROFILE.MESSAGE.IDENTITYCARDNOTUPLOAD\">KTP is Not Uploaded</span> <span \nstyle=\"margin-right:10px\"></span> <span style=\"color:red; font-size: 12px\" ng-if=\"vm.attributeComplete.marital\" \ntranslate=\"MYPROFILE.MESSAGE.MARRIAGEBOOKNOTUPLOAD\"></span> <span style=\"color:red; font-size: 12px\" \nng-if=\"vm.attributeComplete.maritalCerai\" translate=\"MYPROFILE.MESSAGE.DIVORCEPAPERSNOTUPLOAD\">\nAkta Cerai is Not Uploaded</span></div><div layout=\"row\" layout-align=\"end\"><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.isDocumentNotExists\" ng-click=\"vm.showDocuments($event)\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n<span translate=\"ATTENDANCE.LABEL.VIEWDOCUMENT\"></span><md-tooltip><span translate=\"ATTENDANCE.LABEL.VIEWDOCUMENT\">\n</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employee-update-approval/view-education-update.html","<md-dialog aria-label=\"New SM\" flex=\"70\" id=\"formKpiPeople\" md-theme=\"modal-theme\"><form ng-cloak \nname=\"formSicMapping\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveMapping($event,formSicMapping)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>View Education Update</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"background: #ffffff\"><div layout=\"column\"><div layout=\"row\"><div flex><div \nlayout=\"column\"><table class=\"simple\"><thead><tr><th class=\"text-center\" colspan=\"5\">Old Data</th></tr><tr><th>\nSchool Name</th><th>Department</th><th>Majority</th><th>Final Grade</th><th>Year</th></tr></thead><tbody \nstyle=\"height: 200px; overflow-y: scroll\"><tr><td>{{vm.oldData.school_name}}</td><td>{{vm.oldData.department}}</td><td>\n{{vm.oldData.majority}}</td><td>{{vm.oldData.final_grade}}</td><td>\n{{vm.oldData.start_study}}-{{vm.oldData.finish_study}}</td></tr></tbody></table></div></div></div><span flex></span>\n<div layout=\"row\"><div flex><div layout=\"column\"><table class=\"simple\"><thead><tr><th class=\"text-center\" colspan=\"5\">\nNew Data</th></tr><tr><th>School Name</th><th>Department</th><th>Majority</th><th>Final Grade</th><th>Year</th></tr>\n</thead><tbody style=\"height: 200px; overflow-y: scroll\"><tr><td>{{vm.newData.school_name}}</td><td>\n{{vm.newData.department}}</td><td>{{vm.newData.majority}}</td><td>{{vm.newData.final_grade}}</td><td>\n{{vm.newData.start_study}}-{{vm.newData.finish_study}}</td></tr></tbody></table></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button \nclass=\"md-button md-ink-ripple md-accent md-hue-2\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.downLoadID($event)\">\n<md-icon md-font-icon=\"icon-download\"></md-icon>Download Document<md-tooltip><span>click for download ID</span>\n</md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employee-update-approval/view-tax-update.html","<md-dialog aria-label=\"New SM\" flex=\"70\" id=\"formKpiPeople\" md-theme=\"modal-theme\"><form ng-cloak \nname=\"formSicMapping\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveMapping($event,formSicMapping)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>View Tax Update</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"background: #ffffff\"><div layout=\"column\"><div layout=\"row\"><div flex><div \nlayout=\"column\"><table class=\"simple\"><thead><tr><th class=\"text-center\" colspan=\"4\">Old Data</th></tr><tr><th>\nTax Number</th><th>Tax Status</th></tr></thead><tbody style=\"height: 200px; overflow-y: scroll\"><tr><td>\n{{vm.oldData.tax_number}}</td><td>{{vm.oldData.tax_status}}</td></tr></tbody></table></div></div></div><span flex>\n</span><div layout=\"row\"><div flex><div layout=\"column\"><table class=\"simple\"><thead><tr><th class=\"text-center\" \ncolspan=\"4\">New Data</th></tr><tr><th>Tax Number</th><th>Tax Status</th></tr></thead><tbody \nstyle=\"height: 200px; overflow-y: scroll\"><tr><td>{{vm.newData.tax_number}}</td><td>{{vm.newData.tax_status}}</td></tr>\n</tbody></table></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<md-button class=\"md-button md-ink-ripple md-accent md-hue-2\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.downLoadID($event)\"><md-icon md-font-icon=\"icon-download\"></md-icon>Download Document<md-tooltip><span>\nclick for download ID</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/hr-completion/hr-completion.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.HRCOMPLETION\"></span></md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n translate=\"KPI.LABEL.ENTRIES\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.submitToProfile()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"KPI.LABEL.SUBMITTOPROFILE\">Submit To Profile</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-send material-icons\"></md-icon><span translate=\"KPI.LABEL.SUBMITTOPROFILE\">Submit To Profile</span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-primary md-mini\" \nhide show-gt-sm aria-label=\"Upload HR Completion\" ng-click=\"vm.UploadHrCompletion($event)\" type=\"button\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.UPLOAD\">Upload HR Completion</span>\n</md-tooltip><md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload HR Completion</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th><span translate=\"KPI.LABEL.NO\"></span></th><th><span \ntranslate=\"KPI.LABEL.NIK\"></span></th><th><span translate=\"KPI.LABEL.NAME\"></span></th><th><span \ntranslate=\"MYPROFILE.MENU.DATEOFBIRTH\"></span></th><th><span translate=\"MYPROFILE.MENU.GENDER\"></span></th><th><span \ntranslate=\"KPI.LABEL.JOINDATE\"></span></th><th><span translate=\"MYPROFILE.MENU.PHONENUMBER\"></span></th><th><span \ntranslate=\"UMUT.MENU.GRADE\"></span></th><th><span translate=\"UMUT.MENU.JOBTITLE\"></span></th><th><span \ntranslate=\"PRODHANDOVERGW.LABEL.COMPLETION\"></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td\n class=\"text-center\"><input type=\"checkbox\" ng-model=\"ls.checked\" ng-click=\"vm.checkone($index, ls)\"></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{ls.nik}}</td><td>{{ls.nama}}</td><td \nclass=\"text-center\">{{ls.tglLahir | date:\'dd/MM/yyyy\'}}</td><td class=\"text-center\">\n{{(ls.gender === \'L\')?\'Laki-laki\':\'Perempuan\'}}</td><td class=\"text-center\">{{ls.joinDate | date:\'dd/MM/yyyy\'}}</td><td\n class=\"text-center\">{{ls.noHp}}</td><td class=\"text-center\">{{ls.empGrade}}</td><td>{{ls.jobTitle}}</td><td \nclass=\"text-center\">{{(ls.hr_completion === \'1\')?\'Completed\':\'\'}} <a ng-if=\"ls.hr_completion === \'0\'\" \nhref=\"javascript:void(0)\" ng-click=\"vm.viewCompletionForm($event, ls)\" class=\"md-button\"><span \ntranslate=\"PRODHANDOVERGW.LABEL.COMPLETION\"></span></a></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/profiles/profiles.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MYPROFILE.MENU.PROFILES\"></span></md-subheader><div class=\"white-bg\"><md-toolbar><div\n class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n translate=\"KPI.LABEL.ENTRIES\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.employee_profiles_input\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"UMUT.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"UMUT.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.deleteProfiles($event)\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"></div></th><th><span \ntranslate=\"KPI.LABEL.NO\"></span></th><th><span translate=\"KPI.LABEL.ID\"></span></th><th><span \ntranslate=\"KPI.LABEL.NAME\"></span></th><th><span translate=\"KPI.LABEL.JOINDATE\"></span></th><th><span \ntranslate=\"MYPROFILE.MESSAGE.GENDER\"></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editData(ls.id)\" ng-click=\"vm.checkone(div)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listProfilesSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{($index + 1)}}</td><td>\n{{ls.id}}</td><td>{{ls.title}} {{ls.firstName}} {{ls.lastName}}</td><td class=\"text-center\">{{ls.dateJoin}}</td><td \nclass=\"text-center\">{{ls.gender}}</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/promotion/create.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"promotionForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,promotionForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><span translate=\"KPI.LABEL.EMPPROMOTION\"></span> <span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" id=\"tb-kpi-setting\" \nms-responsive-table><thead><tr><th colspan=\"6\" style=\"text-align:center\"><span translate=\"KPI.LABEL.OLDJOB\"></span>\n</th></tr><tr><th style=\"text-align:center\"><span translate=\"KPI.LABEL.JOBGRADE\"></span></th><th \nstyle=\"text-align:center\"><span translate=\"KPI.LABEL.EMPGRADE\"></span></th><th style=\"text-align:center\"><span \ntranslate=\"KPI.LABEL.JOBLEVEL\"></span></th><th style=\"text-align:center\"><span translate=\"UMUT.MENU.JOBTITLE\"></span>\n</th><th style=\"text-align:center\"><span translate=\"KPI.LABEL.DIRECTREPORT\"></span></th><th style=\"text-align:center\">\n<span translate=\"KPI.LABEL.ABBREVIATION\"></span></th></tr></thead><tbody><tr><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_grade}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.emp_grade}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_level}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_title}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.direct_report}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.abreviation}}</td></tr></tbody></table></div><h3><span \ntranslate=\"KPI.LABEL.INPUTNEWJOB\"></span></h3><div class=\"layout-gt-sm-row border-horizontal\"></div><div \nclass=\"white-bg\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" name=\"oldId\" \nng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout-gt-sm=\"row\"><md-input-container flex \nflex-gt-sm><label>NIK</label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nikParam\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nikParam\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nikParam)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.SKNUMBER\"></span></label><input ng-model=\"vm.Form.objForm.skNo\" md-maxlength=\"150\" name=\"skNo\" \nrequired><div ng-messages=\"promotionForm.hiredate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.SKNUMBER\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label><span translate=\"KPI.LABEL.MPNNUMBER\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.mpn_replacement_id\" \nng-change=\"vm.setDisabled(vm.Form.objForm.mpn_replacement_id)\" name=\"mpn_replacement_id\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-disabled=\"vm.isDisabledMpnNumber\" ng-required=\"false\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"mpn_replacement_id\"><md-option value=\"{{ls.id}}-{{ls.mpn_number}}\" \nng-repeat=\"ls in vm.listMpnNumber | filter:vm.searchTerm\">{{ls.mpn_number}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmBT.mpn_replacement_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.MPNNUMBER\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.isDisabled\" flex><label><span translate=\"MENU.MAIN.BUSINESSTITLE\">\n</span></label><input ng-model=\"vm.Form.objForm.businessTitle\" ng-readonly=\"true\" \nplaceholder=\"{{ \'MENU.MAIN.BUSINESSTITLE\' | translate}}\" name=\"businessTitle\" required><div \nng-messages=\"promotionForm.businessTitle.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.BUSINESSTITLE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.DIRECTREPORT\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                  border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nikAtasanParam\" md-search-text=\"vm.searchStringAtasan\" \nmd-items=\"item in vm.getEmployee(vm.searchStringAtasan)\" md-item-text=\"item.fullname\" \nng-model=\"vm.Form.objForm.nikAtasanParam\" \nmd-selected-item-change=\"vm.selectedItemChangedAtasan(vm.Form.objForm.nikAtasanParam)\" required><md-item-template><span\n md-highlight-text=\"vm.searchStringAtasan\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DIRECTREPORT\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.COMPANY\"></span></label><md-select ng-model=\"vm.company\" \nng-change=\"vm.loadDataDivision(vm.Form.objForm.company)\" name=\"company\" ng-disabled=\"vm.isDisabled\" required><md-option\n ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'KPI.LABEL.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"promotionForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.COMPANY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.DIVISION\"></span>\n</label><md-select ng-model=\"vm.divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" name=\"divisi\" \nng-disabled=\"vm.isDisabled\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'KPI.LABEL.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"promotionForm.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DIVISION\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Required.</span></div></div></md-input-container>\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.DEPARTMENT\"></span></label><md-select \nng-model=\"vm.department\" name=\"department\" ng-change=\"vm.getJobTitle()\" ng-disabled=\"vm.isDisabled\" required><md-option\n ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'KPI.LABEL.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"promotionForm.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.DEPARTMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nDepartment Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label><span translate=\"KPI.LABEL.JOBGRADE\"></span></label><md-select ng-model=\"vm.Form.objForm.jobGrade\" \nname=\"jobGrade\" ng-disabled=\"vm.isDisabled\" required><md-option ng-repeat=\"g in vm.gradeJob\" ng-value=\"g\">{{g}}\n</md-option></md-select><div ng-messages=\"promotionForm.jobGrade.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.JOBGRADE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Job Grade Required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.EMPGRADE\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.empGrade\" ng-change=\"vm.getLevelCategory(vm.Form.objForm.empGrade)\" \nng-disabled=\"vm.isDisabled\" name=\"empGrade\" required><md-option ng-repeat=\"g in vm.gradeEmp\" ng-value=\"g\">{{g}}\n</md-option></md-select><div ng-messages=\"promotionForm.empGrade.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.EMPGRADE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Employee Grade Required.</span>\n</div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.AREA\">\n</span></label><md-select ng-model=\"vm.Form.objForm.subArea\" name=\"subArea\" ng-disabled=\"vm.isDisabled\" \nng-change=\"vm.loadGedung(vm.Form.objForm.subArea)\" required><md-option ng-repeat=\"jt in vm.listSubArea\" \nng-value=\"jt.subarea_id\">{{jt.description | uppercase}}</md-option></md-select><div \nng-messages=\"promotionForm.subArea.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.AREA\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Sub Area Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.isRequiredGedung\" flex><label><span translate=\"KPI.LABEL.BUILDING\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.gedung\" name=\"gedung\" ng-required=\"vm.isRequiredGedung\"><md-option \nng-repeat=\"jt in vm.listGedung\" ng-value=\"jt.id\">{{jt.gedung_name | uppercase}}</md-option></md-select><div \nng-messages=\"promotionForm.gedung.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.BUILDING\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Gedung Required.</span></div></div></md-input-container></div><div\n layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.EMPCATEGORY\"></span></label><input \nng-model=\"vm.Form.objForm.empCategory\" ng-readonly=\"true\" placeholder=\"{{ \'KPI.LABEL.EMPCATEGORY\' | translate}}\" \nname=\"empCategory\" required><div ng-messages=\"promotionForm.empCategory.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.EMPCATEGORY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nEmployee Category Required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.JOBLEVEL\"></span></label><input ng-model=\"vm.Form.objForm.jobLevel\" ng-readonly=\"true\" \nplaceholder=\"{{ \'KPI.LABEL.JOBLEVEL\' | translate}}\" name=\"jobLevel\" required><div \nng-messages=\"promotionForm.jobLevel.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.JOBLEVEL\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Job Level Required.</span></div>\n</div></md-input-container><md-input-container flex=\"70\"><label><span translate=\"UMUT.MENU.JOBTITLE\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.jobTitle\" name=\"jobTitle\" md-on-close=\"vm.clearSearchTerm()\" \nng-disabled=\"vm.department==null\" ng-change=\"vm.getJfm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"jobTitle\"><md-option value=\"{{ls.dsc}}\" ng-repeat=\"ls in vm.listJobTitle | filter:vm.searchTerm\">{{ls.dsc}}\n</md-option></md-optgroup></md-select><div ng-messages=\"promotionForm.jobTitle.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"UMUT.MENU.JOBTITLE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nJob Title Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nng-if=\"!vm.disabledAfterChangeJob\" flex><label><span translate=\"KPI.LABEL.JFM\"></span></label><md-select \nng-model=\"vm.Form.objForm.jfm\" name=\"jfm\" disabled=\"disabled\"><md-option ng-repeat=\"jt in vm.listJfm\" ng-value=\"jt.id\">\n{{jt.description}}</md-option></md-select><div ng-messages=\"promotionForm.jfm.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.JFM\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nJFM Required.</span></div></div></md-input-container><md-input-container ng-if=\"!vm.disabledAfterChangeJob\" flex>\n<label><span translate=\"KPI.LABEL.SUBJFM\"></span></label><input ng-model=\"vm.Form.objForm.jfmSub\" name=\"jfmSub\" \nng-readonly=\"true\" required><div ng-messages=\"promotionForm.jfmSub.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.SUBJFM\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Sub JFM Required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.COSTCENTRECNB\"></span></label><md-select ng-model=\"vm.Form.objForm.costcnb\" name=\"costcnb\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"costcnb\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRefCostCentreCnb | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"promotionForm.costcnb.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.COSTCENTRECNB\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\ncost centre cnb Required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.COSTCENTRENONCNB\"></span></label><md-select ng-model=\"vm.Form.objForm.costnoncnb\" \nname=\"costnoncnb\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"costnoncnb\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRefCostCentreNonCnb | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"promotionForm.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.COSTCENTRENONCNB\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">cost centre non cnb Required.</span></div></div></md-input-container>\n<md-input-container flex><label><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"effectiveDate\" ng-model=\"vm.Form.objForm.effectiveDate\" \nng-change=\"vm.changeEffectiveData()\" required></md-datepicker><div ng-messages=\"promotionForm.effectiveDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">Effective Date Required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.DESCRIPTION\"></span></label><input \nng-model=\"vm.Form.objForm.description\" name=\"description\" required><div ng-messages=\"promotionForm.description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DESCRIPTION\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">Description Required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><md-checkbox ng-model=\"vm.Form.objForm.acting\" name=\"acting\" \naria-label=\"Acting\" ng-checked=\"vm.isChecked\" ng-click=\"vm.checkActing()\" style=\"margin-top:5px\"><span><span \ntranslate=\"KPI.LABEL.ACTING\"></span></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.Form.objForm.acting==\'1\'\"><md-input-container flex><label><span translate=\"KPI.LABEL.STARTDATE\"></span>\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"act_startDate\" ng-model=\"vm.Form.objForm.act_startDate\" \nng-required=\"vm.Form.objForm.acting\" disabled=\"disabled\"></md-datepicker><div \nng-messages=\"promotionForm.act_startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.STARTDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Start Date Required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.ENDDATE\"></span></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"act_endDate\" ng-change=\"vm.setActing()\" \nng-model=\"vm.Form.objForm.act_endDate\" ng-required=\"vm.Form.objForm.acting\" \nmd-min-date=\"vm.Form.objForm.effectiveDate\"></md-datepicker><div ng-messages=\"promotionForm.act_endDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDDATE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">End Date Required.</span></div></div></md-input-container><md-input-container \nflex><label><span translate=\"KPI.LABEL.ACTINGRESULT\"></span></label><md-select ng-model=\"vm.Form.objForm.act_result\" \nname=\"act_result\" ng-required=\"vm.Form.objForm.acting\"><md-option ng-repeat=\"r in vm.actResult\" ng-value=\"r.id\" \ndisabled=\"disabled\">{{r.description | uppercase}}</md-option></md-select><div \nng-messages=\"promotionForm.act_result.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ACTINGRESULT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Acting Result Required.</span>\n</div></div></md-input-container></div></div><h3><span translate=\"KPI.LABEL.INPUTALLOWANCE\"></span></h3><div \nlayout-gt-sm=\"row\" ng-if=\"vm.Form.objForm.effectiveDate\" class=\"mb-10\"><md-input-container flex><label><span>NIK</span>\n</label><input ng-model=\"vm.Form.objForm.nik\" ng-readonly=\"true\" name=\"nik\"><div \nng-messages=\"promotionForm.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">Job Level Required.</span></div></div></md-input-container><md-input-container \nflex><label><span translate=\"PAYROLL.MENU.AMOUNT\"></span></label><input type=\"number\" ng-model=\"vm.Amount\" \nname=\"Amount\"><div ng-messages=\"promotionForm.Amount.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Job Level Required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.SALARYCOMP\"></span></label>\n<md-select ng-model=\"vm.ID_SalaryComponent\" name=\"ID_SalaryComponent\"><md-option \nng-repeat=\"r in vm.listSalaryComponent\" ng-value=\"r\">{{r.Description}}</md-option></md-select><div \nng-messages=\"promotionForm.ID_SalaryComponent.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.SALARYCOMP\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Acting Result Required.</span>\n</div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span>\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"act_startDate\" ng-model=\"vm.Form.objForm.effectiveDate\" \ndisabled=\"disabled\"></md-datepicker><div ng-messages=\"promotionForm.act_startDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nStart Date Required.</span></div></div></md-input-container><md-button ng-click=\"vm.addAllowance()\" \nclass=\"md-raised md-primary\" style=\"height:20px\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Add</md-button></div><div \nclass=\"layout-gt-sm-row border-horizontal mb-10\" ng-if=\"vm.Form.objForm.effectiveDate\"></div><div class=\"white-bg\">\n<table class=\"simple with-toolbar bordered stripped\" id=\"tb-kpi-setting\" ms-responsive-table><thead><tr><th \ncolspan=\"6\" style=\"text-align:center\"><span translate=\"KPI.LABEL.OLDALLOWANCELIST\"></span></th></tr><tr><th \nstyle=\"text-align:center\"><span translate=\"PAYROLL.MENU.SALARYCOMP\"></span></th><th style=\"text-align:center\"><span \ntranslate=\"KPI.LABEL.DESCRIPTION\"></span></th><th style=\"text-align:center\"><span translate=\"PAYROLL.MENU.AMOUNT\">\n</span></th><th style=\"text-align:center\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></th></tr></thead><tbody><tr\n ng-repeat=\"al in vm.oldAllowance\"><td style=\"text-align:center;background:#dbf7f4\">{{ al.ID_SalaryComponent }}</td><td\n style=\"text-align:center;background:#dbf7f4\">{{ al.Description }}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ al.Amount }}</td><td style=\"text-align:center;background:#dbf7f4\">\n{{ al.effective_date | date: \"dd/M/yyyy\"}}</td></tr></tbody></table></div><div \nclass=\"layout-gt-sm-row border-horizontal\"></div><div class=\"white-bg\" ng-if=\"vm.listAllowance.length > 0\" \nstyle=\"margin-bottom:20px\"><table class=\"simple with-toolbar bordered stripped\" id=\"tb-kpi-setting\" \nms-responsive-table><thead><tr><th colspan=\"6\" style=\"text-align:center\"><span translate=\"KPI.LABEL.ALLOWANCELIST\">\n</span></th></tr><tr><th><span translate=\"KPI.LABEL.NO\"></span></th><th style=\"text-align:center\"><span>NIK</span></th>\n<th style=\"text-align:center\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></th><th style=\"text-align:center\"><span \ntranslate=\"MENU.MAIN.SALARYCOMP\"></span></th><th style=\"text-align:center\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\">\n</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"l in vm.listAllowance\"><td>{{ $index + 1}}</td><td \nstyle=\"text-align:center\">{{ l.ID_employee}}</td><td style=\"text-align:center\">{{ l.Amount}}</td><td \nstyle=\"text-align:center\">{{ l.description}}</td><td style=\"text-align:center\">\n{{ l.effective_date | date: \"dd/M/yyyy\"}}</td><td style=\"\"><md-button ng-click=\"vm.delListAllowance($index)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"KPI.LABEL.DELETE\"></span></md-button></td></tr></tbody></table>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"promotionForm.$invalid || promotionForm.$pristine\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/promotion/edit.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"promotionForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,promotionForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><span translate=\"KPI.LABEL.EMPPROMOTION\"></span> <span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" id=\"tb-kpi-setting\" \nms-responsive-table><thead><tr><th colspan=\"6\" style=\"text-align:center\"><span translate=\"KPI.LABEL.OLDJOB\"></span>\n</th></tr><tr><th style=\"text-align:center\"><span translate=\"KPI.LABEL.JOBGRADE\"></span></th><th \nstyle=\"text-align:center\"><span translate=\"KPI.LABEL.EMPGRADE\"></span></th><th style=\"text-align:center\"><span \ntranslate=\"KPI.LABEL.JOBLEVEL\"></span></th><th style=\"text-align:center\"><span translate=\"UMUT.MENU.JOBTITLE\"></span>\n</th><th style=\"text-align:center\"><span translate=\"KPI.LABEL.DIRECTREPORT\"></span></th><th style=\"text-align:center\">\n<span translate=\"KPI.LABEL.ABBREVIATION\"></span></th></tr></thead><tbody><tr><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_grade}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.emp_grade}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_level}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_title}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.direct_report}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.abreviation}}</td></tr></tbody></table></div><h3><span \ntranslate=\"KPI.LABEL.INPUTNEWJOB\"></span></h3><div class=\"layout-gt-sm-row border-horizontal\"></div><div \nclass=\"white-bg\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" name=\"oldId\" \nng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout-gt-sm=\"row\"><md-input-container flex \nflex-gt-sm><label>NIK</label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nikParam\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nikParam\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nikParam)\" required><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.SKNUMBER\"></span></label><input ng-model=\"vm.Form.objForm.skNo\" md-maxlength=\"150\" name=\"skNo\" \nrequired><div ng-messages=\"promotionForm.hiredate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.SKNUMBER\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label><span translate=\"KPI.LABEL.MPNNUMBER\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.mpn_replacement_id\" name=\"mpn_replacement_id\" md-on-close=\"vm.clearSearchTerm()\" \nng-disabled=\"vm.isDisabledMpnNumber\" ng-change=\"vm.setDisabled(vm.Form.objForm.mpn_replacement_id)\" \nng-required=\"false\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"mpn_replacement_id\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listMpnNumber | filter:vm.searchTerm\">{{ls.mpn_number}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmBT.mpn_replacement_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.MPNNUMBER\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.isDisabled\" flex><label><span translate=\"MENU.MAIN.BUSINESSTITLE\">\n</span></label><input ng-model=\"vm.Form.objForm.businessTitle\" ng-readonly=\"true\" \nplaceholder=\"{{ \'MENU.MAIN.BUSINESSTITLE\' | translate}}\" name=\"businessTitle\" required><div \nng-messages=\"promotionForm.businessTitle.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MENU.MAIN.BUSINESSTITLE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.DIRECTREPORT\"></label><md-autocomplete \nstyle=\"margin-top: 3px; background: transparent;\n                  border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.nikAtasanParam\" md-search-text=\"vm.searchStringAtasan\" \nmd-items=\"item in vm.getEmployee(vm.searchStringAtasan)\" md-item-text=\"item.fullname\" \nng-model=\"vm.Form.objForm.nikAtasanParam\" \nmd-selected-item-change=\"vm.selectedItemChangedAtasan(vm.Form.objForm.nikAtasanParam)\" required><md-item-template><span\n md-highlight-text=\"vm.searchStringAtasan\">{{item.fullname}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmBT.product.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DIRECTREPORT\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.COMPANY\"></span></label><md-select ng-model=\"vm.company\" \nng-change=\"vm.loadDataDivision(vm.Form.objForm.company)\" name=\"company\" ng-disabled=\"vm.isDisabled\" required><md-option\n ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'KPI.LABEL.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"promotionForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.COMPANY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.DIVISION\"></span>\n</label><md-select ng-model=\"vm.divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" name=\"divisi\" \nng-disabled=\"vm.isDisabled\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'KPI.LABEL.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"promotionForm.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DIVISION\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Required.</span></div></div></md-input-container>\n<md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.DEPARTMENT\"></span></label><md-select \nng-model=\"vm.department\" name=\"department\" ng-change=\"vm.getJobTitle()\" ng-disabled=\"vm.isDisabled\" required><md-option\n ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'KPI.LABEL.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"promotionForm.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.DEPARTMENT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nDepartment Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label><span translate=\"KPI.LABEL.JOBGRADE\"></span></label><md-select ng-model=\"vm.Form.objForm.jobGrade\" \nname=\"jobGrade\" ng-disabled=\"vm.isDisabled\" required><md-option ng-repeat=\"g in vm.gradeJob\" ng-value=\"g\">{{g}}\n</md-option></md-select><div ng-messages=\"promotionForm.jobGrade.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.JOBGRADE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Job Grade Required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.EMPGRADE\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.empGrade\" ng-change=\"vm.getLevelCategory(vm.Form.objForm.empGrade)\" \nng-disabled=\"vm.isDisabled\" name=\"empGrade\" required><md-option ng-repeat=\"g in vm.gradeEmp\" ng-value=\"g\">{{g}}\n</md-option></md-select><div ng-messages=\"promotionForm.empGrade.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.EMPGRADE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Employee Grade Required.</span>\n</div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.AREA\">\n</span></label><md-select ng-model=\"vm.Form.objForm.subArea\" name=\"subArea\" ng-disabled=\"vm.isDisabled\" \nng-change=\"vm.loadGedung(vm.Form.objForm.subArea)\" required><md-option ng-repeat=\"jt in vm.listSubArea\" \nng-value=\"jt.subarea_id\">{{jt.description | uppercase}}</md-option></md-select><div \nng-messages=\"promotionForm.subArea.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.AREA\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Sub Area Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.isRequiredGedung\" flex><label><span translate=\"KPI.LABEL.BUILDING\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.gedung\" name=\"gedung\" ng-required=\"vm.isRequiredGedung\"><md-option \nng-repeat=\"jt in vm.listGedung\" ng-value=\"jt.id\">{{jt.gedung_name | uppercase}}</md-option></md-select><div \nng-messages=\"promotionForm.gedung.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.BUILDING\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Gedung Required.</span></div></div></md-input-container></div><div\n layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.EMPCATEGORY\"></span></label><input \nng-model=\"vm.Form.objForm.empCategory\" ng-readonly=\"true\" placeholder=\"{{ \'KPI.LABEL.EMPCATEGORY\' | translate}}\" \nname=\"empCategory\" required><div ng-messages=\"promotionForm.empCategory.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.EMPCATEGORY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nEmployee Category Required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.JOBLEVEL\"></span></label><input ng-model=\"vm.Form.objForm.jobLevel\" ng-readonly=\"true\" \nplaceholder=\"{{ \'KPI.LABEL.JOBLEVEL\' | translate}}\" name=\"jobLevel\" required><div \nng-messages=\"promotionForm.jobLevel.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.JOBLEVEL\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Job Level Required.</span></div>\n</div></md-input-container><md-input-container flex=\"70\"><label><span translate=\"UMUT.MENU.JOBTITLE\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.jobTitle\" name=\"jobTitle\" md-on-close=\"vm.clearSearchTerm()\" \nng-disabled=\"vm.department==null\" ng-change=\"vm.getJfm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"jobTitle\"><md-option value=\"{{ls.dsc}}\" ng-repeat=\"ls in vm.listJobTitle | filter:vm.searchTerm\">{{ls.dsc}}\n</md-option></md-optgroup></md-select><div ng-messages=\"promotionForm.jobTitle.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"UMUT.MENU.JOBTITLE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nJob Title Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nng-if=\"!vm.disabledAfterChangeJob\" flex><label><span translate=\"KPI.LABEL.JFM\"></span></label><md-select \nng-model=\"vm.Form.objForm.jfm\" name=\"jfm\" disabled=\"disabled\"><md-option ng-repeat=\"jt in vm.listJfm\" ng-value=\"jt.id\">\n{{jt.description}}</md-option></md-select><div ng-messages=\"promotionForm.jfm.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.JFM\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nJFM Required.</span></div></div></md-input-container><md-input-container ng-if=\"!vm.disabledAfterChangeJob\" flex>\n<label><span translate=\"KPI.LABEL.SUBJFM\"></span></label><input ng-model=\"vm.Form.objForm.jfmSub\" name=\"jfmSub\" \nng-readonly=\"true\" required><div ng-messages=\"promotionForm.jfmSub.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.SUBJFM\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Sub JFM Required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.COSTCENTRECNB\"></span></label><md-select ng-model=\"vm.Form.objForm.costcnb\" name=\"costcnb\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"costcnb\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRefCostCentreCnb | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"promotionForm.costcnb.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.COSTCENTRECNB\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\ncost centre cnb Required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.COSTCENTRENONCNB\"></span></label><md-select ng-model=\"vm.Form.objForm.costnoncnb\" \nname=\"costnoncnb\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"costnoncnb\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRefCostCentreNonCnb | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"promotionForm.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.COSTCENTRENONCNB\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">cost centre non cnb Required.</span></div></div></md-input-container>\n<md-input-container flex><label><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"effectiveDate\" ng-model=\"vm.Form.objForm.effectiveDate\" \nng-change=\"vm.changeEffectiveData()\" required></md-datepicker><div ng-messages=\"promotionForm.effectiveDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">Effective Date Required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.DESCRIPTION\"></span></label><input \nng-model=\"vm.Form.objForm.description\" name=\"description\" required><div ng-messages=\"promotionForm.description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DESCRIPTION\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">Description Required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><md-checkbox ng-model=\"vm.Form.objForm.acting\" name=\"acting\" \naria-label=\"Acting\" ng-checked=\"vm.isChecked\" ng-click=\"vm.checkActing()\" style=\"margin-top:5px\"><span><span \ntranslate=\"KPI.LABEL.ACTING\"></span></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.Form.objForm.acting==\'1\'\"><md-input-container flex><label><span translate=\"KPI.LABEL.STARTDATE\"></span>\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"act_startDate\" ng-model=\"vm.Form.objForm.act_startDate\" \nng-required=\"vm.Form.objForm.acting\" disabled=\"disabled\"></md-datepicker><div \nng-messages=\"promotionForm.act_startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.STARTDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Start Date Required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.ENDDATE\"></span></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"act_endDate\" ng-change=\"vm.setActing()\" \nng-model=\"vm.Form.objForm.act_endDate\" ng-required=\"vm.Form.objForm.acting\" \nmd-min-date=\"vm.Form.objForm.effectiveDate\"></md-datepicker><div ng-messages=\"promotionForm.act_endDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ENDDATE\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">End Date Required.</span></div></div></md-input-container><md-input-container \nflex><label><span translate=\"KPI.LABEL.ACTINGRESULT\"></span></label><md-select ng-model=\"vm.Form.objForm.act_result\" \nname=\"act_result\" ng-required=\"vm.Form.objForm.acting\"><md-option ng-repeat=\"r in vm.actResult\" ng-value=\"r.id\" \ndisabled=\"disabled\">{{r.description | uppercase}}</md-option></md-select><div \nng-messages=\"promotionForm.act_result.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ACTINGRESULT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Acting Result Required.</span>\n</div></div></md-input-container></div></div><h3><span translate=\"KPI.LABEL.INPUTALLOWANCE\"></span></h3><div \nclass=\"layout-gt-sm-row border-horizontal\" ng-if=\"vm.Form.objForm.effectiveDate\"></div><div class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" id=\"tb-kpi-setting\" ms-responsive-table><thead><tr><th colspan=\"6\" \nstyle=\"text-align:center\"><span translate=\"KPI.LABEL.OLDALLOWANCELIST\"></span></th></tr><tr><th \nstyle=\"text-align:center\"><span translate=\"PAYROLL.MENU.SALARYCOMP\"></span></th><th style=\"text-align:center\"><span \ntranslate=\"KPI.LABEL.DESCRIPTION\"></span></th><th style=\"text-align:center\"><span translate=\"PAYROLL.MENU.AMOUNT\">\n</span></th><th style=\"text-align:center\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></th></tr></thead><tbody><tr\n ng-repeat=\"al in vm.oldAllowance\"><td style=\"text-align:center;background:#dbf7f4\">{{ al.ID_SalaryComponent }}</td><td\n style=\"text-align:center;background:#dbf7f4\">{{ al.Description }}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ al.Amount }}</td><td style=\"text-align:center;background:#dbf7f4\">\n{{ al.effective_date }}</td></tr></tbody></table></div><div class=\"layout-gt-sm-row border-horizontal\"></div><div \nclass=\"white-bg\" ng-if=\"vm.listAllowance.length > 0\" style=\"margin-bottom:20px\"><table \nclass=\"simple with-toolbar bordered stripped\" id=\"tb-kpi-setting\" ms-responsive-table><thead><tr><th colspan=\"6\" \nstyle=\"text-align:center\"><span translate=\"KPI.LABEL.ALLOWANCELIST\"></span></th></tr><tr><th><span \ntranslate=\"KPI.LABEL.NO\"></span></th><th style=\"text-align:center\"><span>NIK</span></th><th style=\"text-align:center\">\n<span translate=\"PAYROLL.MENU.AMOUNT\"></span></th><th style=\"text-align:center\"><span translate=\"MENU.MAIN.SALARYCOMP\">\n</span></th><th style=\"text-align:center\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"l in vm.listAllowance\"><td>{{ $index + 1}}</td><td style=\"text-align:center\">{{ l.ID_employee}}\n</td><td style=\"text-align:center\">{{ l.Amount}}</td><td style=\"text-align:center\">{{ l.ID_SalaryComponent}}</td><td \nstyle=\"text-align:center\">{{ l.effective_date | date: \"M/dd/yyyy\"}}</td><td style=\"\"><md-button \nng-click=\"vm.delListAllowance($index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"KPI.LABEL.DELETE\"></span></md-button></td></tr></tbody></table></div><div layout-gt-sm=\"row\" \nng-if=\"vm.Form.objForm.effectiveDate\"><md-input-container flex><label><span>NIK</span></label><input \nng-model=\"vm.Form.objForm.nik\" ng-readonly=\"true\" name=\"nik\"><div ng-messages=\"promotionForm.nik.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>NIK</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Job Level Required.</span>\n</div></div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.AMOUNT\"></span></label>\n<input type=\"number\" ng-model=\"vm.Amount\" name=\"Amount\"><div ng-messages=\"promotionForm.Amount.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nJob Level Required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.SALARYCOMP\"></span></label><md-select ng-model=\"vm.ID_SalaryComponent\" \nname=\"ID_SalaryComponent\"><md-option ng-repeat=\"r in vm.listSalaryComponent\" ng-value=\"r.ID\">{{r.Description}}\n</md-option></md-select><div ng-messages=\"promotionForm.ID_SalaryComponent.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.SALARYCOMP\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nActing Result Required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.EFFECTIVEDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"act_startDate\" \nng-model=\"vm.Form.objForm.effectiveDate\" disabled=\"disabled\"></md-datepicker><div \nng-messages=\"promotionForm.act_startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.EFFECTIVEDATE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Start Date Required.</span>\n</div></div></md-input-container><md-button ng-click=\"vm.addAllowance()\" class=\"md-raised md-primary\" \nstyle=\"height:20px\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Add</md-button></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"promotionForm.$invalid || promotionForm.$pristine\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/promotion/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"KPI.LABEL.EMPPROMOTION\"></span></md-subheader><div class=\"white-bg\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><md-content\n class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span>\n</label><md-select ng-model=\"vm.country\" name=\"country\" ng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" ng-disabled=\"vm.budisabled\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option ng-repeat=\"ls in vm.listBU\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"KPI.LABEL.COMPANY\"></span> <span></span></div></div></md-input-container>\n<md-input-container flex><label><span translate=\"KPI.LABEL.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" \nng-disabled=\"vm.divdeptdisabled\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DIVISION\">\n</span> <span></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" ng-disabled=\"vm.divdeptdisabled\" \nname=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.DEPARTMENT\"></span> <span></span></div></div></md-input-container></div><div layout=\"column\" \nng-if=\"!vm.dataSales\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.AREA\"></span></label><md-select ng-model=\"vm.subarea\" name=\"subarea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.subarea_id}}\" \nng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label><span translate=\"FILTER.FLAG_APP\"></span></label><md-select \nng-model=\"vm.employeeType\" ng-disabled=\"vm.typedisabled\" name=\"employeeType\"><md-option ng-repeat=\"ls in vm.typeEmp\" \nvalue=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"FILTER.FLAG_APP\"></span> <span></span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" \nplaceholder=\"{{ \'KPI.LABEL.NIK\' | translate}}/{{ \'KPI.LABEL.NAME\' | translate}}\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container><md-input-container flex ng-if=\"vm.eCheckin==\'true\'\"><md-switch \nclass=\"csm-md-switch\" ng-model=\"vm.viewEcheckin\" name=\"eCheckinview\" ng-change=\"vm.eCheckinchange()\" \naria-label=\"Switch 1\"><span translate=\"MENU.MAIN.ECHECKIN\"></span></md-switch></md-input-container><md-input-container \nflex=\"nogrow\"><md-button class=\"md-mini md-raised md-primary\" type=\"submit\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">Search</span>\n</md-button></md-input-container></div><div layout=\"column\" ng-if=\"vm.dataSales\" layout-gt-xs=\"row\" class=\"mt-30\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.WILAYAH\"></span></label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.loadSalesArea()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a wilayah...\" \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.code_wilayah}}\" ng-repeat=\"ls in vm.wilayahSales | filter:vm.searchTerm\">{{ls.wilayah}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.REGIONAL\">\n</span></label><md-select ng-model=\"vm.region\" name=\"region\" md-on-close=\"vm.clearSearchTerm()\" \nng-disabled=\"vm.wilayah==null\" ng-change=\"vm.loadSalesArea()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a region...\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"sales\"><md-option \nvalue=\"{{ls.code_region}}\" ng-repeat=\"ls in vm.regionSales | filter:vm.searchTerm\">{{ls.region}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.CABANG\">\n</span></label><md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-disabled=\"vm.region==null\" ng-change=\"vm.loadSubArea()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a cabang...\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"sales\"><md-option \nvalue=\"{{ls.code_cabang}}\" ng-repeat=\"ls in vm.cabangSales | filter:vm.searchTerm\">{{ls.cabang}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.AREA\"></span>\n</label><md-select ng-model=\"vm.subarea\" name=\"subarea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"subarea\"><md-option \nvalue=\"{{ls.subarea_id}}\" ng-repeat=\"ls in vm.subArea | filter:vm.searchTerm\">{{ls.description}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex=\"nogrow\"><md-button \nclass=\"md-mini md-raised md-button md-primary md-ink-ripple\" type=\"submit\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</md-input-container></div></div></div></md-content></form><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" class=\"md-raised\" \nng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon md-font-icon=\"icon-chevron-down\">\n</md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" \nclass=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.openInputPromotion($event)\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span \ntranslate=\"UMUT.MENU.NEW\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.UploadPromotion($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon>\n<span>Upload Data</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span>Delete</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select style=\"font-size:14px\" hide \nshow-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.openInputPromotion($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"UMUT.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-verified\">\n</md-icon><span translate=\"UMUT.MENU.NEW\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm aria-label=\"Delete\" type=\"button\" \nng-click=\"vm.UploadPromotion($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"UMUT.MENU.UPLOAD\">click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"UMUT.MENU.UPLOAD\">Upload Data</span></md-button>\n<div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" \naria-label=\"Inert\" ng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteData($event)\"><md-icon \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-collapse=\"collapseData()\" on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div\n class=\"table-header\"><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"></md-checkbox></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\">\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NIK\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.SKNUMBER\"></span></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.DIRECTREPORT\">\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.TOJOBGRADE\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.TOEMPGRADE\"></span></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.TOCOMPANY\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.TODIVISION\">\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.TODEPARTMENT\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.TOAREA\"></span></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.TOBUILDING\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.JFM\"></span>\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SUBJFM\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.DESCRIPTION\"></span></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.ACTING\"></span></span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"div in vm.DataTable.list\" ng-dblclick=\"vm.editInputPromotion($event,div)\" \nng-click=\"vm.checkone(div)\"><td class=\"text-center\"><md-checkbox class=\"md-secondary\" aria-label=\"CutOffChecked\" \nng-checked=\"vm.exists(div, vm.selected)\" ng-click=\"vm.toggle(div, vm.selected)\"></md-checkbox></td><td class=\"\">\n{{ ($index + 1)}}</td><td class=\"text-center\">{{ div.nik}}</td><td class=\"text-center\">{{ div.skNo}}</td><td \nclass=\"text-center\">{{ div.effectiveDate}}</td><td class=\"text-center\">{{ div.directReport}}</td><td \nclass=\"text-center\">{{ div.jobGrade}}</td><td class=\"text-center\">{{ div.empGrade}}</td><td class=\"text-center\">\n{{ div.company}}</td><td class=\"\">{{ div.division}}</td><td class=\"\">{{ div.department}}</td><td class=\"\">\n{{ div.subArea}}</td><td class=\"\">{{ div.gedung}}</td><td class=\"\">{{ div.jfm}}</td><td class=\"text-center\">\n{{ div.jfmSub}}</td><td class=\"\">{{ div.description}}</td><td class=\"text-center\">{{ div.acting == \'1\'? \'YES\':\'NO\' }}\n</td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/promotion/upload-promotion.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif | translate }}</span></div><div \nng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">\n{{ vm.uploadNotif | translate }}</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.upload()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/subarea/subarea.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\nSub Area</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container \nhide show-gt-sm><select hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container>\n<div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addDataSubArea($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-verified\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Create new</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-green-500-bg md-raised md-primary white-fg\" ng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.DOWNLOAD\">Download</span></md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon><span translate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteDataSubArea($event)\"><md-icon \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" on-collapse=\"vm.onCollapse()\">\n</ms-search-bar></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-primary\" \nng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-tooltip><md-icon md-font-icon=\"icon-file-excel\" \nclass=\"teal-800-fg\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\" class=\"mb-0\" \nstyle=\"width: 20px !important\"></md-checkbox></th><th width=\"5%\"><span class=\"column-title\">NO</span></th><th \nclass=\"text-left\"><span class=\"column-title\">Sub Area</span></th><th width=\"8%\"><span class=\"column-title\">ID</span>\n</th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\">Company</span></th><th width=\"20%\" \nclass=\"text-left\"><span class=\"column-title\">Town</span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.DataTables.list\" ng-dblclick=\"vm.updateDataSubArea($event, item)\"><td class=\"text-center\">\n<md-checkbox aria-label=\"subareaChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\" class=\"mb-0\"></md-checkbox></td><td class=\"text-center\">{{(item.no)}}</td><td>\n{{item.description}}</td><td class=\"text-center\"><span class=\"label md-green-600-bg p-5\">{{item.id}}</span></td><td \nclass=\"text-center\">{{item.company}}</td><td>{{item.town_name}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"6\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr><tr class=\"text-center\" ng-if=\"(vm.DataTable.list | typeOf) == undefined\"><td \ncolspan=\"6\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/upload-building/upload-building.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"KPI.LABEL.UPLOADBUILDING\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nng-disabled=\"vm.budisabled\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'KPI.LABEL.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.COMPANY\"></span> <span translate=\"PAYROLL.MENU.ISREQUIRED\">Company field is required.</span></div>\n</div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" ng-disabled=\"vm.divdeptdisabled\" \nname=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'KPI.LABEL.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DIVISION\">\n</span> <span translate=\"PAYROLL.MENU.ISREQUIRED\">Divisi field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.department\" ng-disabled=\"vm.divdeptdisabled\" name=\"department\">\n<md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'KPI.LABEL.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.DEPARTMENT\"></span> <span translate=\"PAYROLL.MENU.ISREQUIRED\">\nDepartment field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nclass=\"mt-30\"><md-input-container flex><label><span translate=\"KPI.LABEL.AREA\"></span></label><md-select \nng-model=\"vm.subarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"Subarea\" \nvalue=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.employeeType\" ng-disabled=\"vm.typedisabled\" name=\"employeeType\"><md-option \nng-repeat=\"ls in vm.typeEmp\" placeholder=\"{{ \'FILTER.FLAG_APP\' | translate}}\" value=\"{{ls.value}}\">\n{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"FILTER.FLAG_APP\"></span> <span translate=\"PAYROLL.MENU.ISREQUIRED\">\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nplaceholder=\"{{ \'KPI.LABEL.NIK\' | translate}} / {{ \'KPI.LABEL.NAME\' | translate}}\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container><md-input-container flex><md-button class=\"md-mini md-raised md-primary\" \ntype=\"submit\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span><span \ntranslate=\"PAYROLL.MENU.SEARCH\"></span></span></md-button></md-input-container></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm \nclass=\"md-primary-bg\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n<md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button aria-label=\"Twitter\" class=\"md-raised md-primary white-fg\" ng-click=\"vm.ganteng(event)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-800-fg\"></md-icon><span translate=\"ACTION.UPLOAD\"></span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-raised md-primary white-fg\" ng-click=\"vm.uploadBuilding($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.UPLOAD\"></span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-800-fg\"></md-icon><span translate=\"ACTION.UPLOAD\"></span></md-button><span flex hide show-gt-sm></span>\n</div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th \nclass=\"text-center\"><span translate=\"KPI.LABEL.NIK\"></span>/<span translate=\"KPI.LABEL.NAME\"></span></th><th \nclass=\"text-center\"><span translate=\"KPI.LABEL.BUILDING\"></span></th><th class=\"text-center\"><span \ntranslate=\"KPI.LABEL.SECTOR\"></span></th><th class=\"text-center\"><span translate=\"KPI.LABEL.LINE\"></span></th><th \nclass=\"text-center\"><span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td>{{ls.nik}} - {{ls.fullName}}</td><td>{{ls.building}}</td><td>{{ls.sector}}</td>\n<td></td><td class=\"text-center\">{{ls.effectiveDate}}</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/upload-building/upload-form.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend><span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlxs)\n</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input \ntype=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div \nflex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" style=\"padding:3px\"><span \nstyle=\"color:red\">{{ vm.uploadNotif | translate }}</span></div><div ng-show=\"vm.uploadSuccess\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif | translate }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.DownloadTemplate(\'empline\')\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/town/town.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Town</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" class=\"md-raised\" \nng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon md-font-icon=\"icon-chevron-down\">\n</md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" \nclass=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.addDataTown($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span translate=\"EMP.TOWN.CREATE\">\nCreate</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\" vm.upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"EMP.TOWN.UPLOAD\">\nUpload Data</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<span translate=\"EMP.TOWN.DELETE\">Delete</span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span>Entries</span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addDataTown($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span \ntranslate=\"EMP.TOWN.CREATE\">Create</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-button class=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\" vm.upload($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"EMP.TOWN.UPLOAD\">Upload Data</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\" \ntranslate=\"EMP.TOWN.DELETE\">Delete</span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\" \ntranslate=\"EMP.TOWN.DELETE\">Delete</span> <span ng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} selected</span>\n</md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"2%\" class=\"text-center\"><md-checkbox aria-label=\"Select All\" \nng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\">\n</md-checkbox></th><th width=\"5%\"><span class=\"column-title\" translate=\"EMP.TOWN.TABLE.NO\">No</span></th><th \nwidth=\"20%\" class=\"text-center\"><span class=\"column-title\" translate=\"EMP.TOWN.TABLE.TOWN\">Town Name</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"EMP.TOWN.TABLE.COUNTRY\">Country Name</span></th></tr></thead>\n<tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\" \nng-dblclick=\"vm.updateData($event, item)\"><td class=\"text-center\"><md-checkbox aria-label=\"subareaChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td>{{(item.no)}}\n</td><td class=\"text-center\">{{item.town | uppercase}}</td><td class=\"text-center\">{{item.country | uppercase}}</td>\n</tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"EMP.TOWN.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/team-assignment/insert-team-assignment.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"FormTeamAssignment\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,FormTeamAssignment)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.CB.EMPLOYEEASSIGNMENT\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container class=\"drop-mod\" flex><label><span\n translate=\"KPI.LABEL.NIK\"></span> - <span translate=\"KPI.LABEL.NAME\"></span></label><md-select \nng-model=\"vm.Form.objForm.nik\" name=\"nik\" required><md-option ng-repeat=\"ls in vm.listEmp\" value=\"{{ls.nik}}\">\n{{ls.nik}} - {{ls.nama}}</md-option></md-select><div ng-messages=\"FormTeamAssignment.nik.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span> - <span translate=\"KPI.LABEL.NAME\"></span> <span \ntranslate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"row\"><md-input-container flex><label><span translate=\"TABLE.START_DATE\"></span></label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"startDate\" ng-model=\"vm.Form.objForm.startDate_resolved\" required></md-datepicker><div \nng-messages=\"FormTeamAssignment.startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.START_DATE\"></span> <span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"TABLE.END_DATE\"></span></label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"endDate\" md-min-date=\"vm.Form.objForm.startDate_resolved\" \nng-model=\"vm.Form.objForm.endDate_resolved\" required></md-datepicker><div \nng-messages=\"FormTeamAssignment.endDate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TABLE.END_DATE\"></span> <span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.CNB\"></span></label><md-select ng-model=\"vm.Form.objForm.cost_center_cnb\" name=\"costCenterCnb\" \nrequired><md-option ng-repeat=\"ls in vm.listcnb\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"FormTeamAssignment.costCenterCnb.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.CNB\"></span> <span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.NONCNB\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.cost_center_noncnb\" name=\"costCenterNoncnb\" required><md-option \nng-repeat=\"ls in vm.listnoncnb\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"FormTeamAssignment.costCenterNoncnb.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NONCNB\"></span> <span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.COMPANY\"></span></label><md-select ng-model=\"vm.Form.objForm.company_id\" name=\"companyId\" \nng-change=\"vm.loadDataDivision(vm.Form.objForm.company_id)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.companyId.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.COMPANY\"></span> <span \ntranslate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container class=\"drop-mod\" \nflex><label><span translate=\"KPI.LABEL.DIVISION\"></span></label><md-select ng-model=\"vm.Form.objForm.dvision_id\" \nng-disabled=\"!vm.Form.objForm.company_id\" name=\"dvisionId\" \nng-change=\"vm.loadDataDepartment(vm.Form.objForm.dvision_id)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.dvisionId.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DIVISION\"></span> <span \ntranslate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"row\"><md-input-container class=\"drop-mod\" flex><label><span translate=\"KPI.LABEL.DEPARTMENT\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.department_id\" ng-change=\"vm.loadDirectName()\" \nng-disabled=\"!vm.Form.objForm.dvision_id\" name=\"departmentId\" required><md-option ng-repeat=\"ls in vm.listDepartment\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.departmentId.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DEPARTMENT\"></span> <span \ntranslate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container class=\"drop-mod\" \nflex><label><span translate=\"KPI.LABEL.AREA\"></span></label><md-select ng-model=\"vm.Form.objForm.sub_area_id\" \nname=\"sub_areaId\" required><md-option ng-repeat=\"ls in vm.listSubArea\" value=\"{{ls.subarea_id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.sub_areaId.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.AREA\"></span> <span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"row\"><md-input-container class=\"drop-mod\" flex><label><span \ntranslate=\"KPI.LABEL.DIRECTREPORT\"></span></label><md-select ng-model=\"vm.Form.objForm.directReport\" \nng-disabled=\"!vm.Form.objForm.department_id\" name=\"directReport\" required><md-option \nng-repeat=\"ls in vm.listDirectName\" value=\"{{ls.nik}}\">{{ls.nik}} - {{ls.fullname}}</md-option></md-select><div \nng-messages=\"frmEmploye.directReport.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.DIRECTREPORT\"></span> <span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label><span translate=\"ATTENDANCE.LABEL.TYPE\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.directReport_type\" name=\"directReport_type\" required><md-option \nng-repeat=\"ls in vm.listType\" value=\"{{ls}}\">{{ls}}</md-option></md-select><div \nng-messages=\"frmEmploye.directReport_type.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"ATTENDANCE.LABEL.TYPE\"></span> <span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"column\"><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.DESCRIPTION\"></span></label><input ng-model=\"vm.Form.objForm.description\" name=\"description\" \nrequired><div ng-messages=\"FormTeamAssignment.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.DESCRIPTION\"></span> <span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"FormTeamAssignment.$invalid || FormTeamAssignment.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/employee/team-assignment/team-assignment.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.CB.EMPLOYEEASSIGNMENT\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formSearchAssignment\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\">\n<div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\"></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-offset-gt-xs=\"40\"><label><span \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglmulai\" placeholder=\"start date\" required name=\"tglmulai\"></md-datepicker><div \nng-messages=\"formSearchAssignment.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'MENU.CB.LEAVE.INDEX.HEADER.START_DATE\' | translate}} {{\'MYPROFILE.MESSAGE.ISREQUIRED\' | translate}}.</span></div>\n</div></md-input-container><md-input-container flex><label>{{\'MENU.CB.LEAVE.INDEX.HEADER.END_DATE\' | translate}}\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"formSearchAssignment.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'MENU.CB.LEAVE.INDEX.HEADER.END_DATE\' | translate}} {{\'MYPROFILE.MESSAGE.ISREQUIRED\' | translate}}</span></div></div>\n</md-input-container><md-button class=\"md-mini md-hue\" type=\"button\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-filter-remove-outline\" ng-click=\"vm.reset(formSearchAssignment)\" aria-label=\"search\"></md-icon>\n</md-button><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" \nng-disabled=\"formSearchAssignment.$invalid || formSearchAssignment.$pristine\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button>\n</div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \ntranslate=\"KPI.LABEL.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.insertData($this)\" ng-if=\"!vm.disableNew\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\n<span translate=\"MYPROFILE.MENU.ADD\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"MYPROFILE.MENU.ADD\">New Assignment</span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm ng-if=\"!vm.disableNew\"></div><md-button \nclass=\"md-button md-primary md-raised md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\" vm.uploadAssignment($event)\" ng-if=\"!vm.disableNew\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm ng-if=\"!vm.disableNew\"></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\" vm.downloadAssignment($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\" on-collapse=\"vm.onCollapse()\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" rowspan=\"2\" \ntranslate=\"KPI.LABEL.NO\">No.</th><th class=\"text-center\" rowspan=\"2\" style=\"white-space: normal\">Name/ Employee ID</th>\n<th class=\"text-center\" colspan=\"2\" translate=\"KPI.LABEL.DATE\">Date</th><th class=\"text-center\" colspan=\"2\" \ntranslate=\"KPI.LABEL.COSTCENTRE\">Cost Center</th><th class=\"text-center\" rowspan=\"2\" translate=\"KPI.LABEL.COMPANY\">\nCompany</th><th class=\"text-center\" rowspan=\"2\" translate=\"KPI.LABEL.DIVISION\">Division</th><th class=\"text-center\" \nrowspan=\"2\" translate=\"KPI.LABEL.DEPARTMENT\">Department</th><th class=\"text-center\" rowspan=\"2\" \nstyle=\"white-space: normal\">Origin Sub Area</th><th class=\"text-center\" rowspan=\"2\" style=\"white-space: normal\">\nDestination Sub Area</th><th class=\"text-center\" rowspan=\"2\" translate=\"KPI.LABEL.DIRECTREPORT\">Direct Report</th><th \nclass=\"text-center\" rowspan=\"2\" translate=\"KPI.LABEL.DESCRIPTION\">Description</th><th class=\"text-center\" rowspan=\"2\">\nID</th></tr><tr><th class=\"text-center\" translate=\"KPI.LABEL.START\">Start</th><th class=\"text-center\" \ntranslate=\"KPI.LABEL.END\">End</th><th class=\"text-center\" translate=\"KPI.LABEL.CNB\">CNB</th><th class=\"text-center\" \ntranslate=\"KPI.LABEL.NONCNB\">Non CNB</th></tr></thead><tbody><tr title=\"{{ls.empName}}\" class=\"hover-tr\" \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\">{{(vm.DataTable.offset + $index + 1)}}</td><td>\n{{ls.nik + \' - \' + ls.empName}}</td><td class=\"text-center\">{{ls.startDate}}</td><td class=\"text-center\">{{ls.endDate}}\n</td><td>{{ls.descCnb}}</td><td>{{ls.descNonCnb}}</td><td>{{ls.companyName}}</td><td>{{ls.divisionName}}</td><td>\n{{ls.departmentName}}</td><td>{{ls.subAreaName_origin}}</td><td>{{ls.subAreaName}}</td><td>\n{{ls.direct_report + \' - \' + ls.directReportName}}<br><span style=\"text-transform: uppercase; font-size: 11px\">\n{{ls.direct_report_type}}</span></td><td>{{ls.description}}</td><td>{{ls.id}}</td></tr><tr class=\"text-center\" \nng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td colspan=\"14\" class=\"text-center\"><span class=\"font-size-12\">\nPlease Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list <= 0\"><td colspan=\"14\" \nclass=\"text-center\"><span class=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr>\n</tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/download-employee/download-employee.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"header-content\" layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Download Employee\n</span></div><div class=\"title\">Download Employee</div></div></div><div class=\"content\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Download Employee</legend><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><md-button type=\"button\" \nng-click=\"vm.downloadEmployees($event)\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-50-fg\"></md-icon><span>download Employee</span></md-button></div></div>\n</md-content></fieldset><ms-widget flippable=\"true\" layout=\"column\" ng-show=\"basicForm.description.$valid\" \nclass=\"fade\"><ms-widget-front class=\"p-16 {{vm.messageTheme}}-400-bg white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>test</p></ms-widget-front></ms-widget><div layout=\"column\" \nlayout-align=\"center center\"></div></form></div></div></div></div>");
$templateCache.put("app/main/employee/download-employee/employee-download.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Download data employee</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.groupLogin!=11\" \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nname=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required multiple=\"multiple\"><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nStart Range Join</label><md-datepicker md-hide-icons=\"calendar\" name=\"startrange\" ng-model=\"vm.startrange\">\n</md-datepicker></md-input-container><md-input-container flex><label>End Range Join</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"endrange\" ng-model=\"vm.endrange\"></md-datepicker></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option ng-repeat=\"ls in vm.listStatus\" \nplaceholder=\"Status\" value=\"{{ls}}\">{{ls | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>status field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.contract\" name=\"contract\">\n<md-option ng-repeat=\"ls in vm.typeContract\" placeholder=\"contract\" value=\"{{ls}}\">{{ls | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.employeeType\" name=\"employeeType\"><md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"Employee Type\" \nvalue=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container></div>\n</div><div ng-if=\"vm.groupLogin==11\" layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nStart Range Join</label><md-datepicker md-hide-icons=\"calendar\" name=\"startrange\" ng-model=\"vm.startrange\">\n</md-datepicker></md-input-container><md-input-container flex><label>End Range Join</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"endrange\" ng-model=\"vm.endrange\"></md-datepicker></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option ng-repeat=\"ls in vm.listStatus\" \nplaceholder=\"Status\" value=\"{{ls}}\">{{ls | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>status field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.contract\" name=\"contract\">\n<md-option ng-repeat=\"ls in vm.typeContract\" placeholder=\"Contract Type\" value=\"{{ls}}\">{{ls | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.employeeType\" name=\"employeeType\"><md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"Employee Type\" \nvalue=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button type=\"button\" \nlayout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vm.download()\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon>Download</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/gw-moving/area-coverage/areacoverage-create.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-gt-sm=\"70\" flex md-theme=\"modal-theme\"><form name=\"formInput\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event, formInput)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Area Coverage Detail</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\" flex><div layout=\"row\"><div \nlayout=\"column\" flex=\"30\"><fieldset layout=\"column\" class=\"form-fieldset\" layout-align=\"start\"><legend>Detail Info\n</legend><md-input-container><label>Effective Date</label><input type=\"date\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required><div ng-messages=\"formInput.effective_date.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Effective Date is required.</span></div></div></md-input-container><md-input-container \nflex><label>Role</label><md-select ng-model=\"vm.Form.objForm.role\" name=\"role\" required><md-option \nng-repeat=\"ls in vm.listRole\" value=\"{{ls}}\">{{ls}}</md-option></md-select><div ng-messages=\"formInput.role.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Role is required.</span></div></div></md-input-container>\n<md-input-container flex class=\"tm-40\"><md-autocomplete md-no-cache=\"true\" required md-selected-item=\"vm.employee\" \nmd-selected-item-change=\"vm.choose(item)\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText, $index)\" md-item-text=\"item.description\" md-delay=\"300\" \nmd-floating-label=\"Search Employee\"><div layout=\"row\" class=\"item\"><span md-highlight-text=\"vm.searchText\">\n{{item.description}}</span></div></md-autocomplete><div style=\"opacity: 1; margin-top: -34px;font-size: 11px\">\nType 3 character to search employee, example: jon</div></md-input-container></fieldset></div><div layout=\"column\" \nflex=\"70\"><fieldset layout=\"column\" class=\"form-fieldset\" layout-align=\"start\"><legend>Location</legend><md-tabs \nmd-dynamic-height><md-tab label=\"Gedung / Department\"><div layout=\"row\" class=\"pt-15\"><div flex-xs flex=\"50\">\n<md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" \nng-click=\"vm.toggleAll()\"><span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></div></div><div \nclass=\"md-whiteframe-1dp content rounded\" layout-padding layout-wrap layout=\"row\" flex><div \nclass=\"demo-select-all-checkboxes\" flex=\"25\" ng-repeat=\"item in vm.listLocation.gedung\"><md-checkbox \nng-checked=\"vm.exists(item, vm.locationSelected)\" ng-click=\"vm.toggle(item, vm.locationSelected)\">\n{{ item.description }}</md-checkbox></div></div></md-tab><md-tab label=\"Sector / Sub Department\"><div layout=\"row\" \nclass=\"pt-15\"><div flex-xs flex=\"50\"><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isCheckedSector()\" \nmd-indeterminate=\"vm.isIndeterminateSector()\" ng-click=\"vm.toggleAllSector()\"><span ng-if=\"vm.isCheckedSector()\">Un-\n</span>Select All</md-checkbox></div></div><div class=\"md-whiteframe-1dp content rounded\" layout-padding layout-wrap \nlayout=\"row\" flex><div class=\"demo-select-all-checkboxes\" flex=\"25\" ng-repeat=\"item in vm.listLocation.sector\">\n<md-checkbox ng-checked=\"vm.exists(item, selected)\" ng-click=\"vm.toggle(item, selected)\">{{ item.description }}\n</md-checkbox></div></div></md-tab><md-tab label=\"Line\"><div layout=\"row\" class=\"pt-15\"><div flex-xs flex=\"50\">\n<md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isCheckedLine()\" md-indeterminate=\"vm.isIndeterminateLine()\" \nng-click=\"vm.toggleAllLine()\"><span ng-if=\"vm.isCheckedLine()\">Un-</span>Select All</md-checkbox></div></div><div \nclass=\"md-whiteframe-1dp content rounded\" layout-padding layout-wrap layout=\"row\" flex><div \nclass=\"demo-select-all-checkboxes\" flex=\"33\" ng-repeat=\"item in vm.listLocation.line\"><md-checkbox \nng-checked=\"vm.exists(item, selected)\" ng-click=\"vm.toggle(item, selected)\">{{ item.description }}</md-checkbox></div>\n</div></md-tab></md-tabs></fieldset></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><md-button \nclass=\"md-primary\" type=\"submit\" ng-disabled=\"formInput.$invalid || basicForm.$pristine\"><md-icon \nmd-font-icon=\"icon-account-check\" class=\"red-500-fg\"></md-icon>CREATE</md-button><md-button ng-click=\"vm.closeModal()\" \nclass=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"blue-500-fg\"></md-icon>CLOSE</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/gw-moving/area-coverage/areacoverage-detail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-gt-sm=\"70\" flex md-theme=\"modal-theme\"><form name=\"frmRequest\">\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Area Coverage Detail</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\" flex><fieldset layout=\"column\" \nclass=\"form-fieldset\" layout-align=\"start\" layout-padding flex><legend>Information Header</legend><div layout=\"column\" \nflex><div layout=\"row\"><dl flex><dt>NIK</dt><dd>{{vm.dataHeader.nik}}</dd></dl><dl flex><dt>NAMA</dt><dd>\n{{vm.dataHeader.nama}}</dd></dl><dl flex><dt>JOB TITLE</dt><dd>{{vm.dataHeader.job_title}}</dd></dl><dl flex><dt>\nEMP CATEGORY</dt><dd>{{vm.dataHeader.emp_category}}</dd></dl><dl flex><dt>SUPPERIOR NIK</dt><dd>\n{{vm.dataHeader.nik_atasan}}</dd></dl><dl flex><dt>SUPPERIOR NAME</dt><dd>{{vm.dataHeader.nama_atasan}}</dd></dl></div>\n</div></fieldset><fieldset><legend>Information Detail</legend><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th>EFFECTIVE DATE</th><th>GEDUNG</th><th>SECTOR</th><th>LINE</th><th>ROLE</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listDetail\" ng-class=\"div.mpn_class\"><td><input type=\"checkbox\" checklist-model=\"vm.listSelected\" \nchecklist-value=\"ls\"></td><td>{{ ls.effective_date }}</td><td>{{ ls.gedung }}</td><td>{{ ls.sector }}</td><td>\n{{ ls.line }}</td><td>{{ ls.tipe }}</td></tr></tbody></table></fieldset></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><md-button ng-click=\"vm.deleteDetail($event)\" class=\"md-primary\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon>DELETE</md-button><md-button ng-click=\"vm.closeModal()\" \nclass=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"blue-500-fg\"></md-icon>CLOSE</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/gw-moving/area-coverage/areacoverage-list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Employee Coverage List</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>Working Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.workingDate\" md-placeholder=\"Working Date\" name=\"workingDate\"></md-datepicker>\n</md-input-container><md-input-container flex><label>Gedung</label><md-select ng-model=\"vm.gedung\" name=\"gedung\" \nng-change=\"vm.getSector(vm.gedung)\"><md-option ng-repeat=\"ls in vm.listGedung\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Sector</label><md-select \nng-model=\"vm.sector\" name=\"sector\" ng-change=\"vm.getLine(vm.sector)\"><md-option ng-repeat=\"ls in vm.listSector\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Line\n</label><md-select ng-model=\"vm.line\" name=\"line\"><md-option ng-repeat=\"ls in vm.listLine\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" \ntype=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" layout-align=\"end center\"><md-icon \nmd-font-icon=\"icon-magnify\" \\></md-icon>Submit</md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n class=\"secondary-text\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.createArea($event)\"><md-icon \nmd-font-icon=\"icon-account-network\" \\></md-icon>Set Area Coverage</md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>NIK</th><th>\nNAME</th><th>JOB TITLE</th><th>EMP CATEGORY</th><th>SUPERIOR NIK</th><th>SUPERIOR NAME</th><th>ACTION</th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td>{{ ls.nik }}</td><td>{{ ls.nama }}</td><td>\n{{ ls.job_title }}</td><td>{{ ls.tipe }}</td><td>{{ ls.nik_atasan }}</td><td>{{ ls.nama_atasan }}</td><td><md-button \naria-label=\"View Detail\" class=\"md-icon-button\" ng-click=\"vm.viewDetail($event, ls)\" \nstyle=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip>\n<span>View Detail</span></md-tooltip></md-button></td></tr></tbody></table><div class=\"p-24 table-paging-area\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/gw-moving/gw-list/gwlist.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">GW List</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" \nflex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>Working Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.workingDate\" ng-change=\"vm.getLine()\" md-placeholder=\"Working Date\" \nname=\"workingDate\"></md-datepicker></md-input-container><md-input-container flex-gt-sm=\"20\" flex><md-select \nng-model=\"vm.line\" name=\"line\"><md-option placeholder=\"Line & Group\" ng-repeat=\"ls in vm.listLine\" value=\"{{ls}}\">\nLine : {{ls.line_number}}, Group : {{ls.shift_group_name}}</md-option></md-select></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-magnify\" \\></md-icon>Submit</md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" \nng-click=\"vm.requestTransfer($event)\"><md-icon md-font-icon=\"icon-login\" \\></md-icon>Request Transfer</md-button><span \nflex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>WORKING DATE\n</th><th>NIK</th><th>NAME</th><th>BUILDING / ZONE</th><th>SECTOR</th><th>LINE</th><th>GROUP</th><th>STATUS</th><th>\nACTION</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td>\n{{ ls.working_date }}</td><td>{{ ls.nik }}</td><td>{{ ls.nama }}</td><td>{{ ls.gedung_name }}</td><td>\n{{ ls.sector_name }}</td><td>{{ ls.line_number }}</td><td>{{ ls.shift_group_name }}</td><td><span \nng-if=\"ls.effective_date\">Transfer In</span></td><td><md-button class=\"md-mini md-raised md-primary\" \nng-click=\"vm.transfer($event, ls)\"><md-icon md-font-icon=\"icon-export\" \\></md-icon>Transfer</md-button></td></tr>\n</tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/gw-moving/gw-list/set-line-position.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"75\" md-theme=\"modal-theme\"><form name=\"frmRequest\" ng-cloack \nnovalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Set Line Position</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" \nlayout-padding flex><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label>Line</label>\n<md-select ng-model=\"vm.line\" name=\"line\" required><md-option placeholder=\"Line & Group\" ng-repeat=\"ls in vm.listLine\" \nvalue=\"{{ls}}\">Line : {{ls.line_number}}, Group : {{ls.shift_group_name}}</md-option></md-select><div \nng-messages=\"frmRequest.line.$error\" role=\"alert\"><div ng-message=\"required\"><span>Line is required.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label>Production Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.date\" md-placeholder=\"Production Date\" name=\"startDate\" required></md-datepicker>\n<div ng-messages=\"frmRequest.startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nProduction date is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\"><md-button class=\"md-mini md-raised md-primary\" layout-align=\"end center\" \nng-click=\"vm.loadDataLinePosition()\"><md-icon md-font-icon=\"icon-account-search\" \\></md-icon>Search</md-button>\n</md-input-container></div><div layout=\"row\"><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table>\n<thead><tr><th></th><th>PRODUCTION DATE</th><th>POSITION GROUP</th><th>POSITION NAME</th><th>SYMBOL / LOCATION</th><th>\nGENDER</th><th>MPP TYPE</th><th>QTY</th><th>NIK</th><th>EFFECTIVE DATE</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listLinePosition\"><td><input type=\"checkbox\" checklist-model=\"vm.listSelected\" \nchecklist-value=\"ls\"></td><td>{{ ls.production_date }}</td><td>{{ ls.position_group }}</td><td>{{ ls.position_name }}\n</td><td>{{ ls.symbol_location }}</td><td>{{ ls.gender }}</td><td>{{ ls.mpp_type }}</td><td>{{ ls.qty }}</td><td \nng-if=\"ls.mpp_type == \'foreman\'\">{{ ls.nik }}</td><td ng-if=\"ls.mpp_type != \'foreman\'\"><md-select ng-model=\"ls.nik\" \nname=\"nik\"><md-option placeholder=\"nik\" ng-repeat=\"lsn in vm.listGw\" value=\"{{lsn.nik}}\">( {{lsn.nik}} ) {{lsn.nama}}\n</md-option></md-select></td><td>{{ ls.effective_date }}</td></tr></tbody></table></md-content></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><md-button \nng-click=\"vm.saveData($event, frmRequest)\" class=\"md-primary\"><md-icon md-font-icon=\"icon-account-check\"></md-icon>Set\n</md-button><md-button ng-click=\"vm.close()\" class=\"md-primary\">Done</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/gw-moving/gw-list/transfer-history.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Transfer History</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.startDate\" md-placeholder=\"Start Date\" name=\"startDate\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.endDate\" md-placeholder=\"End Date\" name=\"endDate\"></md-datepicker>\n</md-input-container><md-input-container flex-gt-sm=\"20\" flex><md-select ng-model=\"vm.line\" name=\"line\"><md-option \nplaceholder=\"Line & Group\" ng-repeat=\"ls in vm.listLine\" value=\"{{ls}}\">\nLine : {{ls.line_number}}, Group : {{ls.shift_group_name}}</md-option></md-select></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-magnify\" \\></md-icon>Submit</md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>\nEFFECTIVE DATE</th><th>NIK</th><th>NAME</th><th>BUILDING / ZONE</th><th>SECTOR</th><th>LINE</th><th>\nDEFAULT BUILDING / ZONE</th><th>DEFAULT SECTOR</th><th>DEFAULT LINE</th><th>REQUEST BY</th><th>REQUEST DATE</th><th>\nREASON</th><th>TRANSFER BY</th><th>TRANSFER DATE</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td>\n{{ ls.effective_date }}</td><td>{{ ls.nik }}</td><td>{{ ls.emp_name }}</td><td>{{ ls.current_gedung }}</td><td>\n{{ ls.current_sector }}</td><td>{{ ls.current_line }}</td><td>{{ ls.default_gedung }}</td><td>{{ ls.default_sector }}\n</td><td>{{ ls.default_line }}</td><td>{{ ls.emp_name_request }}</td><td>{{ ls.request_date }}</td><td><span \nng-bind-html=\"ls.reason\"></span></td><td>{{ ls.emp_name_input }}</td><td>{{ ls.timestamp_transfer }}</td></tr></tbody>\n</table><div class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/gw-moving/gw-transfer/transfer-work-location.html","<div id=\"mpn-gw-request\" layout-fill class=\"page-layout fullwidth carded white-bg\" ms-scroll><md-content \nclass=\"white-bg\" layout-margin><div class=\"md-whiteframe-4dp content rounded\" layout-padding><md-subheader \nclass=\"subheader-sm\"><div layout=\"row\" flex=\"100\" layout-align=\"left\"><span>Filter</span></div></md-subheader><form \nname=\"formSearch\" class=\"md-inline-form\" novalidate ng-submit=\"vm.filterData($event, formSearch)\"><div layout=\"row\">\n<md-input-container flex><label>Gedung</label><md-select ng-model=\"vm.gedung\" name=\"gedung\" required \nng-change=\"vm.getSector(vm.gedung)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchGedung\" \ntype=\"search\" class=\"header-searchbox md-text\" placeholder=\"Search for a gedung..\" ng-keydown=\"vm.ketikSearch($event)\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listGedung | filter:vm.searchGedung\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Sector</label><md-select\n ng-model=\"vm.sector\" name=\"sector\" required ng-change=\"vm.getLine(vm.sector)\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchSector\" type=\"search\" class=\"header-searchbox md-text\" \nplaceholder=\"Search for a sector..\" ng-keydown=\"vm.ketikSearch($event)\"></md-select-header><md-option \nng-repeat=\"ls in vm.listSector | filter:vm.searchSector\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Line</label><md-select ng-model=\"vm.line\" name=\"line\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchLine\" type=\"search\" \nclass=\"header-searchbox md-text\" placeholder=\"Search for a line..\" ng-keydown=\"vm.ketikSearch($event)\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listLine | filter:vm.searchLine\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-md=\"column\" layout-align=\"end center\" flex>\n<md-button type=\"submit\" class=\"md-blue-300-bg md-raised md-primary btn-ui-serif\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-magnify\" \\=\"\" class=\"ng-scope md-nabati1-theme md-font material-icons icon-magnify\" \naria-hidden=\"true\"></md-icon>Search</md-button></div></form></div><div class=\"md-whiteframe-4dp content rounded\" \nlayout-padding><md-subheader class=\"subheader-sm\"><div layout=\"row\" flex=\"100\" layout-align=\"left\"><span>\nMPP WORK LOCATION</span></div></md-subheader><form name=\"formInput\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData($event, formInput)\"><div layout=\"row\"><div layout=\"column\" flex=\"30\"><fieldset layout=\"column\" \nclass=\"form-fieldset\" layout-align=\"start\"><legend>Detail Info</legend><md-input-container><label>Effective Date\n</label><input type=\"date\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" \nng-change=\"vm.getMppStandard(vm.Form.objForm.effective_date)\" required><div \nng-messages=\"formInput.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Effective Date is required.\n</span></div></div></md-input-container><md-input-container flex><label>Position</label><md-select \nng-model=\"vm.position\" name=\"position\" required ng-change=\"vm.setPosition(vm.position)\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchPosition\" type=\"search\" class=\"header-searchbox md-text\" \nplaceholder=\"Search for a position..\" ng-keydown=\"vm.ketikSearch($event)\"></md-select-header><md-option \nng-repeat=\"ls in vm.listMppStandard | filter:vm.searchPosition\" value=\"{{ls}}\">\n{{ls.position_name}} ( Require Qty : {{ls.require_qty}})</md-option></md-select><div \nng-messages=\"formInput.position.$error\" role=\"alert\"><div ng-message=\"required\"><span>Position is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Sub Line</label><md-select \nng-model=\"vm.Form.objForm.subLine\" name=\"subLine\" required><md-option ng-repeat=\"ls in vm.listSubLine\" value=\"{{ls}}\">\n{{ls}}</md-option></md-select><div ng-messages=\"formInput.position.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Position is required.</span></div></div></md-input-container><md-input-container flex><label for=\"note\">\nDescription</label><textarea rows=\"5\" type=\"textarea\" name=\"note\" id=\"note\" ng-model=\"vm.Form.objForm.description\">\n</textarea></md-input-container></fieldset></div><div layout=\"column\" flex=\"70\"><fieldset layout=\"column\" \nclass=\"form-fieldset\" layout-align=\"start\"><legend>Location</legend><md-tabs md-dynamic-height><md-tab label=\"Gedung\">\n<div layout=\"row\" class=\"pt-15\"><div flex-xs flex=\"50\"><md-checkbox aria-label=\"Select All\" \nng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"><span \nng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></div></div><div class=\"md-whiteframe-1dp content rounded\" \nlayout-padding layout-wrap layout=\"row\" flex><div class=\"demo-select-all-checkboxes\" flex=\"25\" \nng-repeat=\"item in vm.listLocation.gedung\"><md-checkbox ng-checked=\"vm.exists(item, vm.locationSelected)\" \nng-click=\"vm.toggle(item, vm.locationSelected)\">{{ item.description }}</md-checkbox></div></div></md-tab><md-tab \nlabel=\"Sector\"><div layout=\"row\" class=\"pt-15\"><div flex-xs flex=\"50\"><md-checkbox aria-label=\"Select All\" \nng-checked=\"vm.isCheckedSector()\" md-indeterminate=\"vm.isIndeterminateSector()\" ng-click=\"vm.toggleAllSector()\"><span \nng-if=\"vm.isCheckedSector()\">Un-</span>Select All</md-checkbox></div></div><div \nclass=\"md-whiteframe-1dp content rounded\" layout-padding layout-wrap layout=\"row\" flex><div \nclass=\"demo-select-all-checkboxes\" flex=\"25\" ng-repeat=\"item in vm.listLocation.sector\"><md-checkbox \nng-checked=\"vm.exists(item, selected)\" ng-click=\"vm.toggle(item, selected)\">{{ item.description }}</md-checkbox></div>\n</div></md-tab><md-tab label=\"Line\"><div layout=\"row\" class=\"pt-15\"><div flex-xs flex=\"50\"><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isCheckedLine()\" md-indeterminate=\"vm.isIndeterminateLine()\" \nng-click=\"vm.toggleAllLine()\"><span ng-if=\"vm.isCheckedLine()\">Un-</span>Select All</md-checkbox></div></div><div \nclass=\"md-whiteframe-1dp content rounded\" layout-padding layout-wrap layout=\"row\" flex><div \nclass=\"demo-select-all-checkboxes\" flex=\"33\" ng-repeat=\"item in vm.listLocation.line\"><md-checkbox \nng-checked=\"vm.exists(item, selected)\" ng-click=\"vm.toggle(item, selected)\">{{ item.description }}</md-checkbox></div>\n</div></md-tab></md-tabs></fieldset></div></div><div layout=\"column\" layout-padding ms-scroll><fieldset \nlayout=\"column\" class=\"form-fieldset\" layout-align=\"start\"><legend>My Team</legend><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th>No</th><th \nstyle=\"width: 10%\">NIK</th><th style=\"width: 22%\">NAME</th><th style=\"width: 18%\">POSITION NAME</th><th \nstyle=\"width: 50%\">LIST LOCATION</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listEmployee\" \nng-init=\"mppStandarIndex = $index\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" \nchecklist-value=\"ls\" ng-checked=\"vm.cekHeadCount()\"></td><td class=\"text-center\">{{mppStandarIndex+1}}</td><td \nclass=\"text-center\">{{ls.nik}}</td><td>{{ls.nama}}</td><td>{{ls.positionName}}</td><td><strong>Gedung</strong> :<br>\n<span>{{ls.gedung}}</span><br><strong>Sector : </strong><br><span>{{ls.sector}}</span><br><strong>Line :</strong><br>\n<span>{{ls.line}}</span></td></tr></tbody></table></fieldset></div><div layout=\"row\" layout-md=\"column\" \nlayout-align=\"center center\" flex><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" ng-disabled=\"formInput.$invalid || basicForm.$pristine\" \nng-hide=\"vm.oksubmit\">Submit</md-button><md-button type=\"button\" class=\"md-raised md-warn btn-ui-serif\" \naria-label=\"Submit\" ng-click=\"vm.delete($event)\">Delete Position</md-button><md-button type=\"button\" \nng-click=\"vm.getEmployeCek()\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Reload\">Back</md-button></div>\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" \nflex><ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon\n md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></form></div>\n</md-content></div>");
$templateCache.put("app/main/gw-moving/gw-transfer/transfer.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><form name=\"frmRequest\" ng-cloack \nnovalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Transfer GW</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" \nlayout-padding flex><div layout=\"row\"><md-input-container flex><label for=\"nik\">NIK</label><input id=\"nik\" type=\"text\" \nname=\"nik\" ng-model=\"vm.Form.objForm.nik\" flex ng-readonly=\"true\"></md-input-container><md-input-container flex><label \nfor=\"nama\">Name</label><input id=\"nama\" type=\"text\" name=\"nama\" ng-model=\"vm.Form.objForm.nama\" flex \nng-readonly=\"true\"></md-input-container><md-input-container flex><label for=\"sector_name\">Default Sector Name</label>\n<input id=\"sector_name\" type=\"text\" name=\"sector_name\" ng-model=\"vm.Form.objForm.sector_name\" flex ng-readonly=\"true\">\n</md-input-container><md-input-container flex><label for=\"default_line\">Default Line</label><input id=\"default_line\" \ntype=\"text\" name=\"default_line\" ng-model=\"vm.Form.objForm.line_number\" flex ng-readonly=\"true\"></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label>Destination Line</label><md-select \nng-model=\"vm.Form.objForm.line\" name=\"line\" required><md-option placeholder=\"Line & Group\" \nng-repeat=\"ls in vm.listLine\" value=\"{{ls}}\">Line : {{ls.line_number}}, Group : {{ls.shift_group_name}}</md-option>\n</md-select><div ng-messages=\"frmRequest.line.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDestination Line is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"30\"><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.start_date\" \nmd-placeholder=\"Start Date\" name=\"startDate\" required></md-datepicker><div ng-messages=\"frmRequest.startDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start date is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label>End Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.end_date\" md-placeholder=\"End Date\" name=\"endDate\" required></md-datepicker><div \nng-messages=\"frmRequest.endDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>End date is required.</span>\n</div></div></md-input-container></div></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button ng-click=\"vm.saveData($event, frmRequest)\" \nclass=\"md-primary\"><md-icon md-font-icon=\"icon-arrow-right-bold-hexagon-outline\"></md-icon>Transfer</md-button>\n<md-button ng-click=\"vm.close()\" class=\"md-primary\">Done</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/gw-moving/gw-request/moving-gw-delegate.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><form name=\"frmRequest\" ng-cloack \nnovalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>\nDelegate Request Transfer GW</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" \nlayout-padding flex><div layout=\"row\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th \nflex=\"5\"></th><th flex=\"10\">NIK</th><th flex=\"15\">NAME</th><th flex=\"15\">BUILDING / ZONE</th><th flex=\"55\">NOTE</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.listSpv\" ng-class=\"div.mpn_class\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td>{{ ls.nik }}</td><td>{{ ls.nama }}</td><td>\n{{ ls.gedung_name }}</td><td><md-input-container><input id=\"note\" type=\"text\" name=\"note\" ng-model=\"ls.note\" \nsize=\"100%\"></md-input-container></td></tr></tbody></table></md-content></div></div><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button ng-click=\"vm.saveData($event, frmRequest)\" \nclass=\"md-primary\"><md-icon md-font-icon=\"icon-arrow-left-bold-hexagon-outline\"></md-icon>Delegate</md-button>\n<md-button ng-click=\"vm.close()\" class=\"md-primary\">Done</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/gw-moving/gw-request/moving-gw-list-request.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">GW Request List</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.startDate\" md-placeholder=\"Start Date\" name=\"startgDate\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.endDate\" md-placeholder=\"End Date\" name=\"endDate\"></md-datepicker>\n</md-input-container><md-input-container flex-gt-sm=\"20\" flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option \nplaceholder=\"status\" ng-repeat=\"ls in vm.listStatus\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" layout-align=\"end center\"><md-icon \nmd-font-icon=\"icon-magnify\" \\></md-icon>Submit</md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span\n class=\"secondary-text\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>\nBUILDING / ZONE</th><th>SECTOR</th><th>LINE</th><th>START DATE</th><th>END DATE</th><th>REQUEST NAME</th><th>\nQTY REQUEST</th><th>FILLED QTY</th><th>RESIDUAL QTY</th><th>REQUEST DATE</th><th>DELEGATE BY</th><th>NOTE</th><th>\nSTATUS</th><th>ACTION</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td>\n{{ ls.gedung_name }}</td><td>{{ ls.sector_name }}</td><td>{{ ls.line_number }}</td><td>{{ ls.start_date }}</td><td>\n{{ ls.end_date }}</td><td>{{ ls.request_name }}</td><td>{{ ls.quantity }}</td><td>{{ ls.filled_qty }}</td><td>\n{{ ls.residual_qty }}</td><td>{{ ls.request_date }}</td><td>{{ ls.delegator }}</td><td>{{ ls.note }}</td><td>\n{{ ls.status_close }}</td><td><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.viewDetail(ls)\"><md-icon \nmd-font-icon=\"icon-eye\" \\></md-icon>Detail</md-button>||<md-button class=\"md-mini md-raised md-primary\" \nng-if=\"vm.user == ls.delegate_by\" ng-click=\"vm.delegate($this, ls)\"><md-icon md-font-icon=\"icon-account-network\" \\>\n</md-icon>Delegate</md-button></td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/gw-moving/gw-request/moving-gw-request-detail.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">GW Request Detail</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><fieldset layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" layout-padding>\n<legend>Request Detail</legend><div layout=\"row\" flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding flex><div \nflex><div class=\"md-subhead\"><strong>Request By</strong></div><div class=\"info\">{{vm.data.request_name}}</div></div>\n<div flex><div class=\"md-subhead\"><strong>Request Date</strong></div><div class=\"info\">{{vm.data.request_date}}</div>\n</div><div flex><div class=\"md-subhead\"><strong>Building / Zone</strong></div><div class=\"info\">{{vm.data.gedung_name}}\n</div></div><div flex><div class=\"md-subhead\"><strong>Sector</strong></div><div class=\"info\">{{vm.data.sector_name}}\n</div></div><div flex><div class=\"md-subhead\"><strong>Line</strong></div><div class=\"info\">{{vm.data.line_number}}\n</div></div><div flex><div class=\"md-subhead\"><strong>Qty Request</strong></div><div class=\"info\">{{vm.data.quantity}}\n</div></div><div flex><div class=\"md-subhead\"><strong>Filled Qty</strong></div><div class=\"info\">{{vm.data.filled_qty}}\n</div></div><div flex><div class=\"md-subhead\"><strong>Residual Qty</strong></div><div class=\"info\">\n{{vm.data.quantity - vm.data.filled_qty}}</div></div><div flex><div class=\"md-subhead\"><strong>Status</strong></div>\n<div class=\"info\">{{vm.data.status_close}}</div></div></div></div><div layout=\"row\" flex><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-padding flex><div class=\"md-subhead\"><strong>Reason</strong></div><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-padding><div ng-bind-html=\"vm.data.reason\"></div></div></div></div></fieldset><fieldset \nclass=\"form-fieldset\" layout-align=\"start\" layout-padding><div layout=\"row\" layout-gt-xs=\"column\"><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-padding flex><div flex><legend>Delegate To</legend><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>NIK</th><th>\nNAME</th><th>TIMESTAMP</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listDelegate\" ng-class=\"div.mpn_class\"><td>\n{{ ls.nik }}</td><td>{{ ls.nama }}</td><td>{{ ls.timestamp }}</td></tr></tbody></table></div><div flex><legend>\nEmp Transfer From</legend><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" \nms-responsive-table><thead><tr><th>NIK</th><th>NAME</th><th>BUILDING / ZONE</th><th>SECTOR</th><th>TRANSFER BY</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.listTransfer\" ng-class=\"div.mpn_class\"><td>{{ ls.nik }}</td><td>\n{{ ls.nama }}</td><td>{{ ls.gedung }}</td><td>{{ ls.sector }}</td><td>{{ ls.transfer_by }} ({{ ls.transfer_by_nik }})\n</td></tr></tbody></table></div></div></div></fieldset><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill \nng-if=\"vm.data.is_close == 0\"><md-subheader class=\"white-bg\">GW List</md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div \nlayout-gt-xs=\"row\" class=\"mt-40\"><md-input-container flex-gt-sm=\"20\" flex><md-select ng-model=\"vm.sector\" \nname=\"sector\" ng-change=\"vm.loadDataLine(vm.sector)\"><md-option placeholder=\"Sector\" ng-repeat=\"ls in vm.listSector\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex-gt-sm=\"20\" \nflex><md-select ng-model=\"vm.line\" name=\"line\"><md-option placeholder=\"Line\" ng-repeat=\"ls in vm.listLine\" \nvalue=\"{{ls.id}}\">Line : {{ls.line_number}}</md-option></md-select></md-input-container><md-input-container \nflex-gt-sm=\"20\" flex><md-select ng-model=\"vm.group\" name=\"group\"><md-option placeholder=\"Group\" \nng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\">Group : {{ls.description}}</md-option></md-select>\n</md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" layout-align=\"end center\"><md-icon \nmd-font-icon=\"icon-magnify\" \\></md-icon>Submit</md-button></div></form></div></div></md-content><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex>\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\">\n<div layout=\"column\" flex><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">Entries</span></md-input-container><span \nflex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th>WORKING DATE</th><th>NIK</th><th>NAME</th><th>BUILDING / ZONE</th><th>SECTOR</th><th>LINE</th><th>GROUP\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td>{{ ls.working_date }}</td><td>{{ ls.nik }}</td><td>\n{{ ls.nama }}</td><td>{{ ls.gedung_name }}</td><td>{{ ls.sector_name }}</td><td>{{ ls.line_number }}</td><td>\n{{ ls.shift_group_name }}</td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div><form name=\"frmRequest\" ng-cloack novalidate><div layout=\"column\" flex><md-toolbar class=\"mt-10\">\n<div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" \nlayout-align=\"end center\" ng-click=\"vm.saveData($event, frmRequest)\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline\" \\></md-icon>Transfer</md-button></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>WORKING DATE\n</th><th>NIK</th><th>NAME</th><th>BUILDING / ZONE</th><th>SECTOR</th><th>LINE</th><th>GROUP</th></tr></thead><tbody><tr\n ng-repeat=\"ls in vm.listSelected\"><td>{{ ls.working_date }}</td><td>{{ ls.nik }}</td><td>{{ ls.nama }}</td><td>\n{{ ls.gedung_name }}</td><td>{{ ls.sector_name }}</td><td>{{ ls.line_number }}</td><td>{{ ls.shift_group_name }}</td>\n</tr></tbody></table></md-content></div></form></div></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/gw-moving/gw-request/request-transfer.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><form name=\"frmRequest\" ng-cloack \nnovalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Request Transfer GW</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" \nlayout-padding flex><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\"><label>Destination Line\n</label><md-select ng-model=\"vm.Form.objForm.line\" name=\"line\" required><md-option placeholder=\"Line & Group\" \nng-repeat=\"ls in vm.listLine\" value=\"{{ls}}\">Line : {{ls.line_number}}, Group : {{ls.shift_group_name}}</md-option>\n</md-select><div ng-messages=\"frmRequest.line.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDestination Line is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><label>Quantity</label><input id=\"quantity\" ng-model=\"vm.Form.objForm.quantity\" type=\"number\" \nname=\"quantity\" required><div ng-messages=\"frmRequest.quantity.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nQuantity is required.</span></div></div><div ng-messages=\"frmRequest.number.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Quantity should be number.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.start_date\" md-placeholder=\"Start Date\" name=\"startDate\" required></md-datepicker><div \nng-messages=\"frmRequest.startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start date is required.</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\"><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.end_date\" md-placeholder=\"End Date\" name=\"endDate\" \nrequired></md-datepicker><div ng-messages=\"frmRequest.endDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd date is required.</span></div></div></md-input-container></div><div layout=\"row\"><div class=\"content-input\" flex>\n<textarea rows=\"7\" ui-tinymce=\"vm.tinymceOptions\" name=\"functional\" ng-model=\"vm.Form.objForm.reason\" \nng-required=\"true\"></textarea><div ng-messages=\"frmRequest.reason.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Reason is required.</span></div></div></div></div></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button ng-click=\"vm.saveData($event, frmRequest)\" \nclass=\"md-primary\"><md-icon md-font-icon=\"icon-arrow-left-bold-hexagon-outline\"></md-icon>Request</md-button><md-button\n ng-click=\"vm.close()\" class=\"md-primary\">Done</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/hcnews/hc-news/hc-news-edit.html","<md-dialog aria-label=\"Update Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.updateData($event, frmBT)\" novalidate flex>\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"HC_NEWS.LABEL_UPDATE\">\nUpdate Data News</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"HC_NEWS.TABLE.TITLE\">Title</label><input type=\"text\" ng-model=\"vm.title\" name=\"title\" required><div \nng-messages=\"frmBT.title.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"HC_NEWS.ERROR.TITLE\">\nTitle field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><md-select ng-model=\"vm.selectedListNC\" aria-label=\"category\" name=\"category\" required><md-option \nng-repeat=\"ls in vm.listNC\" placeholder=\"Category\" value=\"{{ls.id}}\">{{ls.category_name}}</md-option></md-select><div \nng-messages=\"frmBT.category.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"HC_NEWS.ERROR.CATEGORY\">\nCategory field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex>\n<label>Company</label><md-select multiple=\"{{false}}\" ng-model=\"vm.selectedCompany\" name=\"company\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>SAP STATUS</label><md-select \nmultiple=\"{{false}}\" ng-model=\"vm.selectedSap\" name=\"sapStatus\" required><md-option value=\"SAP\">SAP</md-option>\n<md-option value=\"NON SAP\">NON SAP</md-option></md-select><div ng-messages=\"frmEmploye.sapStatus.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>SAP STATUS field is required.</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><md-radio-group ng-model=\"vm.group1\"><md-radio-button ng-value=\"true\" \nng-checked=\"true\" class=\"md-primary\">Content</md-radio-button><md-radio-button ng-value=\"false\">Document\n</md-radio-button></md-radio-group></md-input-container></div><div ng-show=\"!vm.group1\" layout=\"row\"><md-content \nlayout=\"column\" class=\"_md layout-column md-nabati1-theme\"><div layout-gt-sm=\"column\" class=\"layout-gt-sm-column\">\n<md-input-container class=\"md-nabati1-theme\"><input \naccept=\"image/png, image/jpg, image/jpeg, image/jpg,application/pdf, video/mp4\" type=\"file\" nv-file-select=\"\" \nuploader=\"vm.uploader\" \noptions=\"{ formData: [{  \n                                          title:vm.title,\n                                          category:vm.selectedListNC,\n                                          content:vm.content,\n                                          company:vm.company,\n                                          isPublish:vm.isPublish\n                                        }]}\" \nng-required=\"!vm.group1\"><div class=\"md-errors-spacer\"></div><div ng-messages=\"frmBT.content.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"HC_NEWS.ERROR.CONTENT\">Content field is required.</span></div></div>\n</md-input-container></div><md-progress-linear md-mode=\"determinate\" value=\"0\" \nclass=\"md-accent hue-2 md-nabati1-theme\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" aria-valuenow=\"0\">\n<div class=\"md-container md-mode-determinate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\" style=\"transform: translateX(-50%) scale(0, 1)\"></div></div></md-progress-linear></md-content>\n</div><div ng-show=\"vm.group1\" layout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 7px\"><textarea \nrows=\"15\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.content\" name=\"tinyContent\" ng-required=\"vm.group1\"></textarea>\n</div><div ng-messages=\"frmBT.content.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HC_NEWS.ERROR.CONTENT\">Content field is required.</span></div></div></md-input-container><input \nname=\"image\" type=\"file\" id=\"upload\" style=\"display:none\" onchange=\"\"></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><md-checkbox ng-checked=\"(vm.selectedIsPublish==1) ? 1:0\" ng-model=\"vm.isPublish\" \nng-click=\"vm.selectedIsPublish=!vm.isPublish\" aria-label=\"publish\" name=\"publish\">Publish</md-checkbox>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/hcnews/hc-news/hc-news-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"HC_NEWS.LABEL_INPUT\">Input Data News\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"HC_NEWS.TABLE.TITLE\">Title</label><input type=\"text\" ng-model=\"vm.title\" name=\"title\" required><div \nng-messages=\"frmBT.title.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"HC_NEWS.ERROR.TITLE\">\nTitle field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><md-select ng-model=\"vm.category\" aria-label=\"category\" name=\"category\" required><md-option \nng-repeat=\"ls in vm.listNC\" placeholder=\"Category\" value=\"{{ls.id}}\">{{ls.category_name}}</md-option></md-select><div \nng-messages=\"frmBT.category.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"HC_NEWS.ERROR.CATEGORY\">\nCategory field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex>\n<label>Company</label><md-select multiple=\"{{false}}\" ng-model=\"vm.company\" name=\"company\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>SAP STATUS</label><md-select \nmultiple=\"{{false}}\" ng-model=\"vm.sap\" name=\"sapStatus\" required><md-option value=\"SAP\">SAP</md-option><md-option \nvalue=\"NON SAP\">NON SAP</md-option></md-select><div ng-messages=\"frmEmploye.sapStatus.$error\" role=\"alert\"><div \nng-message=\"required\"><span>SAP STATUS field is required.</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><md-radio-group ng-model=\"vm.group1\"><md-radio-button ng-value=\"true\" \nng-checked=\"true\" class=\"md-primary\">Content</md-radio-button><md-radio-button ng-value=\"false\">Document\n</md-radio-button></md-radio-group></md-input-container></div><div ng-show=\"!vm.group1\" layout=\"row\"><md-content \nlayout=\"column\" class=\"_md layout-column md-nabati1-theme\"><md-input-container class=\"md-nabati1-theme\"><input \naccept=\"image/png, image/jpg, image/jpeg, image/jpg,application/pdf,video/mp4 \" type=\"file\" nv-file-select=\"\" \nuploader=\"vm.uploader\" \noptions=\"{ formData: [{  \n                                        title:vm.title,\n                                        category:vm.category,\n                                        content:vm.content,\n                                        company:vm.company,\n                                        isPublish:vm.isPublish\n                                      }]}\" \nng-required=\"!vm.group1\"><div class=\"md-errors-spacer\"></div><div ng-messages=\"frmBT.content.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"HC_NEWS.ERROR.CONTENT\">Content field is required.</span></div></div>\n</md-input-container><md-progress-linear md-mode=\"determinate\" value=\"0\" class=\"md-accent hue-2 md-nabati1-theme\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" aria-valuenow=\"0\"><div \nclass=\"md-container md-mode-determinate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\" style=\"transform: translateX(-50%) scale(0, 1)\"></div></div></md-progress-linear></md-content>\n</div><div ng-show=\"vm.group1\" layout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 7px\"><textarea \nrows=\"15\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.content\" ng-required=\"vm.group1\"></textarea></div><div \nng-messages=\"frmBT.content.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"HC_NEWS.ERROR.CONTENT\">\nContent field is required.</span></div></div></md-input-container><input name=\"image\" type=\"file\" id=\"upload\" \nstyle=\"display:none\" onchange=\"\"></div><div layout=\"row\"><md-input-container flex flex-gt-sm><md-checkbox \nng-model=\"vm.isPublish\" aria-label=\"publish\" name=\"publish\">Publish</md-checkbox></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/hcnews/hc-news/hc-news.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">HC News</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;Entries</span><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button ng-if=\"vm.admin\" class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.addDataNews($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span>Create new\n</span></md-button><div ng-if=\"vm.admin\" class=\"divider-vertical\" hide show-gt-sm></div><md-button ng-if=\"vm.admin\" \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteDataNews($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span style=\"color:red\" \nng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" ng-click=\"vm.addDataNews(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\nCreate New</md-button></md-menu-item><md-menu-item><span><md-checkbox aria-label=\"Select All\" \nng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\">\n<span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-content style=\"background:white\" hide-gt-sm><span flex=\"5\"></span><md-list class=\"md-dense\" flex>\n<md-list-item class=\"md-3-line\" ng-repeat=\"item in vm.DataTables.list\" ng-click=\"null\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4>TEST</h4><md-checkbox class=\"md-secondary\" aria-label=\"CutOffChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></div><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypmenu\" class=\"md-icon-button\" \nstyle=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editDataNews($event, item)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex>edit</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu><md-divider style=\"border-width:0.5px; border-color:whitesmoke; border-style: solid\">\n</md-divider></md-list-item></md-list><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th ng-if=\"vm.admin\" width=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \n\\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.NO\">NO</span></th><th \nclass=\"text-center\" width=\"20%\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.TITLE\">Title</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.CATEGORY\">Category</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.COMPANY\">Company</span></th><th \nclass=\"text-center\"><span class=\"column-title\">SAP STATUS</span></th><th ng-if=\"vm.admin\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"HC_NEWS.TABLE.PUBLISH_STATUS\">Publish Status</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"HC_NEWS.TABLE.PUBLISH_DATE\">Publish Date</span></th><th class=\"text-center\" \nwidth=\"10%\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.TOTAL_READER\">Total Reader</span></th><th width=\"5%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td ng-if=\"vm.admin\"><md-checkbox \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.title}}</td><td \nclass=\"text-center\">{{item.category}}</td><td class=\"text-center\">{{item.scope}}</td><td class=\"text-center\">\n{{item.sap}}</td><td ng-if=\"vm.admin\" class=\"text-center\">{{item.is_publish==1 ? \"Publish\" : \"Unpublish\"}}</td><td \nclass=\"text-center\">{{ item.is_publish==1 ? item.updated_at : \"\"}}</td><td class=\"text-center\"><span \nng-if=\"item.reader > 0\"><a href=\"\" ng-click=\"vm.viewReaderLog(item,$event)\">{{item.reader}}</a><md-tooltip \nmd-direction=\"top\">View Reader Log</md-tooltip></span><span ng-if=\"item.reader == 0\">{{item.reader}}</span></td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-if=\"vm.admin\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editDataNews($event, item)\"><div layout=\"row\" flex>\n<md-icon md-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex>edit</p></div></md-button><md-button \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewNewsDetail($event, item)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex>Detail</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/hcnews/hc-news/view-reader-log.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"70\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2 translate=\"HC_NEWS.TABLE.TITLE_READER_LOG\">View Reader Log</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div><table><tr><td><b>Enerlife</b></td>\n<td><span>: {{vm.companyList.en}}</span></td><td><b>Kieber</b></td><td><span>: {{vm.companyList.ki}}</span></td><td><b>\nKSNI</b></td><td><span>: {{vm.companyList.ks}}</span></td><td><b>PMA</b></td><td><span>: {{vm.companyList.pm}}</span>\n</td><td><b>RKI</b></td><td><span>: {{vm.companyList.rk}}</span></td></tr></table></div><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;Entries</span></div></md-toolbar><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"15%\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"HC_NEWS.TABLE.NIK\">NIK</span></th><th width=\"15%\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"HC_NEWS.TABLE.NAME\">Name</span></th><th width=\"15%\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"HC_NEWS.TABLE.COMPANY\">Company</span></th><th width=\"15%\" class=\"text-center\"><span \nclass=\"column-title\" translate=\"HC_NEWS.TABLE.LAST_READ\">Last Read</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.items\"><td class=\"text-center\"><span>{{ls.nik}}</span></td><td class=\"text-center\"><span>\n{{ls.full_name}}</span></td><td class=\"text-center\"><span>{{ls.company}}</span></td><td class=\"text-center\"><span>\n{{ls.last_read}}</span></td></tr><tr ng-if=\"vm.items.length <= 0\"><td colspan=\"4\" class=\"text-center\"><span>\nNo Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/hcnews/hc-news-category/hc-news-category-edit.html","<md-dialog aria-label=\"Input Data News Category\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.updateData($event, frmBT)\" novalidate flex>\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"HC_NEWS.CATEGORY.LABEL_UPDATE\">Update Data News Category</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div \nlayout=\"row\"><md-input-container flex flex-gt-sm><label translate=\"HC_NEWS.CATEGORY.NAME\">Category Name</label><input \ntype=\"text\" ng-model=\"vm.category_name\" name=\"category_name\" required><div ng-messages=\"frmBT.category_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"HC_NEWS.CATEGORY.ERROR.NAME\">Category Name field is required.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/hcnews/hc-news-category/hc-news-category-input.html","<md-dialog aria-label=\"Input Data News Category\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><div \nclass=\"md-toolbar-tools\"><div class=\"md-toolbar-tools\"><h2 translate=\"HC_NEWS.CATEGORY.LABEL_INPUT\">\nInput Data News Category</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"HC_NEWS.CATEGORY.NAME\">Category Name</label><input type=\"text\" ng-model=\"vm.category_name\" \nname=\"category_name\" required><div ng-messages=\"frmBT.category_name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"HC_NEWS.CATEGORY.ERROR.NAME\">Category Name field is required.</span></div></div></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></div>\n</form></md-dialog>");
$templateCache.put("app/main/hcnews/hc-news-category/hc-news-category.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"HC_NEWS.CATEGORY.TITLE\">Hc News Category</span></md-subheader><div class=\"white-bg\">\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span>\n<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip>\n</md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.addDataNewsCategory($event)\"><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span translate=\"HC_NEWS.CATEGORY.LABEL_CREATE\">Create new</span></md-button></md-menu-item><md-menu-item>\n<md-button class=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\">\n</md-icon><span translate=\"ACTION.REJECT\">Delete</span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span>Entries</span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addDataNewsCategory($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span \ntranslate=\"HC_NEWS.CATEGORY.LABEL_CREATE\">Create new</span></md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.Reject($event)\">\n<md-icon ng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon \nng-if=\"vm.selected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" \nclass=\"red-700-fg\">Delete</span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span \nng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\" \ntranslate=\"HC_NEWS.CATEGORY.NO\">NO</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"HC_NEWS.CATEGORY.NAME\">Category Name</span></th><th width=\"5%\"></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\"><md-checkbox \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.category_name}}</td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding\" layout-align=\"start center\" \nlayout-wrap><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" \nclass=\"md-icon-button\" style=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editDataNewsCategory($event, item)\"><div layout=\"row\" \nflex><md-icon md-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex>edit</p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/hrbp/charts-bu/charts-bu.html","<div id=\"dashboard-server\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Performance Charts Nabati Group By Business Units</span></md-subheader><div class=\"white-bg\">\n<md-content id=\"widgets\" layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap id=\"chartByBu\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8 h3\">Performance Chart {{vm.namaBu}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item ng-repeat=\"oBu  in vm.listBu\"><md-button ng-click=\"vm.viewDataBu(oBu.id,oBu.description)\" \naria-label=\"{{oBu.description}} widget\">{{oBu.description}}</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" layout-wrap><div \nclass=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataMutuBu\" \nchart-options=\"vm.optionsBadjBu\" id=\"chart7\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataAdj1Bu\" chart-options=\"vm.optionsAadj1Bu\" id=\"chart8\"></div></div><div \nclass=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj2Bu\" \nchart-options=\"vm.optionsAadj2Bu\" id=\"chart9\"></div></div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap id=\"chartByDivisi\"><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Chart Business Unit {{vm.namaBu}} Divisi {{vm.nameDivisi}}</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item ng-repeat=\"oDivisi in vm.listDivisi\"><md-button \nng-click=\"vm.viewDataDivisi(oDivisi.id,oDivisi.description)\" aria-label=\"{{oDivisi.description}} widget\">\n{{oDivisi.description}}</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" \nflex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataMutudiv\" chart-options=\"vm.optionsBadjdiv\" id=\"chart10\"></div></div>\n<div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1div\" \nchart-options=\"vm.optionsAadj1div\" id=\"chart11\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataAdj2div\" chart-options=\"vm.optionsAadj2div\" id=\"chart12\"></div></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap id=\"chartByDept\">\n<ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Chart Business Unit {{vm.namaBu}} Department {{vm.nameDepartment}}</div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item ng-repeat=\"oDepartment in vm.listDepartment\"><md-button \nng-click=\"vm.viewDataDepartment(oDepartment.id,oDepartment.description)\" \naria-label=\"{{oDepartment.description}} widget\">{{oDepartment.description}}</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" \nlayout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataMutuDept\" \nchart-options=\"vm.optionsBadjDept\" id=\"chart13\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataAdj1Dept\" chart-options=\"vm.optionsAadj1Dept\" id=\"chart14\"></div></div><div \nclass=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj2Dept\" \nchart-options=\"vm.optionsAadj2Dept\" id=\"chart15\"></div></div></div></ms-widget-front></ms-widget></div></md-content>\n</div></div></md-content></div>");
$templateCache.put("app/main/hrbp/competency/competency.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">competency</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container>\n<span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th>\n<th><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Competency</span></div></th><th><div class=\"text-left\"><span class=\"column-title\">Description\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls.id)\"><td \nclass=\"text-center\">{{ ls.no }}</td><td class=\"text-center\">{{ ls.code | uppercase }}</td><td class=\"text-center\">\n{{ ls.competency | uppercase }}</td><td>{{ ls.description | uppercase }}</td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/hrbp/competency/upload-competency.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload Shift</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" \nstyle=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/hrbp/emp-job-code/emp-job-code.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Employee Job Code</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label><md-select ng-model=\"vm.company\" \nname=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\"><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Division</label><md-select ng-model=\"vm.divisi\" \nname=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Department</label><md-select ng-model=\"vm.department\" \nname=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th>\n<th><div class=\"table-header\"><span class=\"column-title\">NIK</span></div></th><th><div class=\"text-left\"><span \nclass=\"column-title\">Employee Name</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Job Code\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">EFFECTIVE DATE</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls.id)\"><td class=\"text-center\">\n{{ $index + 1 }}</td><td class=\"text-center\">{{ ls.nik }}</td><td>{{ ls.emp_name | uppercase }}</td><td \nclass=\"text-center\">{{ ls.job_code | uppercase }}</td><td class=\"text-center\">{{ ls.effective_date }}</td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/hrbp/emp-job-code/upload-emp-job-code.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload Employee Job Code\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" \nstyle=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/hrbp/emp-leave/emp-leave.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Employee Leave</span></md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\">\n<div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div\n ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\">\n<md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div class=\"mt-40\" layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.tahun\" ng-change=\"vm.getPeriode()\" name=\"tahun\">\n<md-option ng-repeat=\"val in vm.listtahun\" placeholder=\"Year\" value=\"{{val}}\">{{val}}</md-option></md-select><div \nng-messages=\"frmEmploye.tahun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tahun field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.bulan\" ng-change=\"vm.getPeriode()\" \nname=\"bulan\"><md-option ng-repeat=\"val in vm.listbulan\" placeholder=\"Period {{vm.periode}}\" value=\"{{val.value}}\">\n{{val.name}}</md-option></md-select><div ng-messages=\"frmEmploye.bulan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"Sub Area\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon>\n<span>submit</span></md-button></div></form></div></div></md-content><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\"><span class=\"column-title\">NIK</span></th><th width=\"15%\"><span class=\"column-title\">Name</span>\n</th><th width=\"15%\"><span class=\"column-title\">Leave Name</span></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\">Start Date</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\">End Date\n</span></th><th class=\"text-center\"><span class=\"column-title\">Start Time</span></th><th class=\"text-center\"><span \nclass=\"column-title\">End Time</span></th><th class=\"text-center\"><span class=\"column-title\">Description</span></th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td class=\"text-center\">{{ls.nik }}</td><td>{{ls.empname }}</td>\n<td>{{ls.code}}-{{ls.name}}</td><td class=\"text-center\">{{ls.tanggal}}</td><td class=\"text-center\">{{ls.tanggal}}</td>\n<td class=\"text-center\"><span ng-if=\"ls.start_time !==\'00:00:00\'\">{{ls.start_time }}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.end_time !==\'00:00:00\'\">{{ls.end_time}}</span></td><td>{{ls.description}}</td></tr>\n<tr ng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>No Data Available</span></td></tr>\n</tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/hrbp/hrbp-attendance-team/hrbp-attendance-team.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Attendance</span></md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div\n ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\" \nng-change=\"vm.disableEmp()\" required><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n</div><div class=\"mt-30\" layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" md-placeholder=\"Mulai Tanggal\" required name=\"tglmulai\">\n</md-datepicker><div ng-messages=\"frmEmploye.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Harus Diisi.</span></div></div></md-input-container><md-input-container flex><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" md-placeholder=\"Sampai Tanggal\" required name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"frmEmploye.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Harus Diisi.</span></div></div></md-input-container><md-autocomplete flex md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empNik\" md-search-text=\"vm.nama\" md-search-text-change=\"vm.searchTextChange(vm.nama)\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmp(vm.nama)\" md-min-length=\"3\" \nmd-input-name=\"empNik\" md-item-text=\"item.nama\" ng-disabled=\"vm.Disabled\" required \nmd-floating-label=\"Search Name / Nik\"><md-item-template><span md-highlight-text=\"vm.nama\">{{item.nama}}</span>\n</md-item-template></md-autocomplete><md-button class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \nng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span>Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table id=\"attendance\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\">No</span></th><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\">NIK</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\">Nama</span></th><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\">Hari/Tanggal</span></th><th class=\"text-center\" colspan=\"2\"><span class=\"column-title\">Shift\n</span></th><th class=\"text-center\" colspan=\"4\"><span class=\"column-title\">Actual</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\">OT Approved</span></th><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\">OT Unapproved</span></th><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\">\nFinger Status</span></th><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\">Note</span></th></tr><tr><th \nclass=\"text-center\"><span class=\"column-title\">In</span></th><th class=\"text-center\"><span class=\"column-title\">Out\n</span></th><th class=\"text-center\"><span class=\"column-title\">In</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Break Out</span></th><th class=\"text-center\"><span class=\"column-title\">Break In</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Out</span></th></tr></thead><tr style=\"display:none\" \nng-init=\"idemp=$index\" ng-repeat-start=\"lsemp in vm.DataTable.list track by $index\"></tr><tr><td \nrowspan=\"{{lsemp.rowd}}\">{{lsemp.no }}</td><td rowspan=\"{{lsemp.rowd}}\">{{lsemp.nik }}</td><td \nrowspan=\"{{lsemp.rowd}}\">{{lsemp.emp_name }}</td></tr><tr ng-init=\"idatt=$index\" \nng-repeat=\"ls in lsemp.listAttendances track by $index\" \nng-class=\"{\'empholiday\':ls.isHoliday,\'emptruant\':ls.infoAbsence[0].code==\'Z301\',\'empinactive\':!ls.isAsEmployeeActive,\'empghkkerja\':ls.isGhkKerja,\'empsubsitusileave\':ls.infoAbsence[0].code==\'Z102\',\'empleave\':(ls.infoAbsence[0].full ==\'1\' && ls.infoAbsence[0].leaveStatus ==\'1\')}\">\n<td class=\"text-center\">{{ls.day}}/{{ls.date}}</td><td class=\"text-center\">{{ls.shift.tampilStart}}</td><td \nclass=\"text-center\">{{ls.shift.tampilEnd}}</td><td class=\"text-center\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.in==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.in!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateIn>0\">\n{{ls.listFinger.in}}<md-tooltip md-direction=\"top\">{{ls.lateIn}}</md-tooltip></span><span ng-if=\"ls.lateIn==0\">\n{{ls.listFinger.in}}</span></span></td><td class=\"text-center\" ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakOut==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakOut!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFinger.breakOut}}<md-tooltip md-direction=\"top\">{{ls.lateBreakIn}}</md-tooltip></span><span \nng-if=\"ls.lateBreakIn==0\">{{ls.listFinger.breakOut}}</span></span></td><td class=\"text-center\" \nng-if=\"!ls.requiredBreakFinger\"></td><td class=\"text-center\" ng-if=\"ls.requiredBreakFinger\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.breakIn==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.breakIn!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.lateBreakIn>0\">\n{{ls.listFinger.breakIn}}<md-tooltip md-direction=\"top\">{{ls.lateBreakIn}}</md-tooltip></span><span \nng-if=\"ls.lateBreakIn==0\">{{ls.listFinger.breakIn}}</span></span></td><td class=\"text-center\" \nng-if=\"!ls.requiredBreakFinger\"></td><td class=\"text-center\"><span class=\"red-500-fg\" \nng-if=\"(ls.listFingerLength>0 && ls.listFinger.out==\'empty\') && ls.isWorking==true\">missing</span> <span \nng-if=\"ls.listFingerLength>0 && ls.listFinger.out!=\'empty\'\"><span class=\"red-500-fg\" ng-if=\"ls.earlyOut>0\">\n{{ls.listFinger.out}}<md-tooltip md-direction=\"top\">{{ls.earlyOut}}</md-tooltip></span><span ng-if=\"ls.earlyOut==0\">\n{{ls.listFinger.out}}</span></span></td><td class=\"text-center\"><span ng-if=\"ls.approvedOT>0\">{{ls.approvedOT}}</span>\n<span ng-if=\"ls.approvedOT==0\"></span></td><td class=\"text-center\"><span ng-if=\"ls.unApprovedOT>0\">{{ls.unApprovedOT}}\n</span><span ng-if=\"ls.unApprovedOT==0\"></span></td><td class=\"text-center\"><span \nng-repeat=\"statusFin in ls.fingerStatus\"><span class=\"red-500-fg\">{{statusFin}}</span></span></td><td \nclass=\"text-center\"><span ng-repeat=\"abs in ls.infoAbsence\"><span class=\"red-500-fg\" \nng-if=\"abs.name==\'Truant\' || abs.name==\'Undisciplined\'\">{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span> \n</span><span ng-if=\"!(abs.name==\'Truant\' || abs.name==\'Undisciplined\')\">{{abs.name}} <span ng-if=\"abs.full==0\">\n:{{abs.total}}</span></span></span></td></tr><tr style=\"display:none\" ng-repeat-end></tr></table></md-content></div>\n<div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></md-content></div>");
$templateCache.put("app/main/hrbp/hrbp-kpi-team/hrbp-kpi-team.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">KPI Team</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div\n ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\" \nng-change=\"vm.disableEmp()\" required><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" class=\"mt-20\"><md-input-container flex><md-select ng-model=\"vm.year\" \nname=\"year\" ng-change=\"vm.disableEmp()\" required><md-option ng-repeat=\"year in vm.years\" placeholder=\"Year\" \nvalue=\"{{year.year}}\">{{year.year}}</md-option></md-select><div ng-messages=\"frmEmploye.year.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Year field is required.</span></div></div></md-input-container><md-autocomplete flex \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empNik\" md-search-text=\"vm.nama\" \nmd-search-text-change=\"vm.searchTextChange(vm.nama)\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmp(vm.nama)\" md-min-length=\"3\" md-input-name=\"empNik\" md-item-text=\"item.nama\" \nng-disabled=\"vm.Disabled\" required md-floating-label=\"Search Name / Nik\"><md-item-template><span \nmd-highlight-text=\"vm.nama\">{{item.nama}}</span></md-item-template></md-autocomplete><md-button \nclass=\"md-mini md-raised md-primary\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-download\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon>Submit\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" id=\"kpiTable\" ms-responsive-table><thead><tr><th></th><th>No</th><th>KPI\n</th><th>WEIGHT</th><th>UOM</th><th>TARGET</th><th>START DATE</th><th>END DATE</th><th>KPI VALUE</th><th>RESULT DATE\n</th><th>STATUS APPROVAL</th></tr></thead><tbody><tr ng-repeat=\"ks in vm.DataTable.list\" ng-click=\"vm.select(ks)\"><td>\n<div ng-if=\"ks.status===\'Submitted\'\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ks)\" \nng-click=\"vm.toggleCheck(ks, $event)\" ng-model=\"isCovered\" \nng-change=\"formSetKpi.$setValidity(\'required\', vm.listKSSelected.length > 0)\" \naria-label=\"{{vm.isChecked(ks)? \'Uncheck\':\'check\'}}\"></md-checkbox></div><div ng-else></div></td><td>{{ ($index + 1)}}\n</td><td align=\"left\"><button ng-click=\"vm.viewScales($event,ks.idks)\" \nstyle=\"text-decoration:underline;text-align:left !important\" align=\"left\">{{ ks.kpi}}</button></td><td>{{ ks.bobot}} %\n</td><td>{{ ks.uom}}</td><td>{{ ks.target}}</td><td>{{ ks.effectiveDate}}</td><td>{{ ks.expiredDate}}</td><td \nalign=\"center\">{{ ks.kpiValue}}</td><td><button ng-click=\"vm.viewResult($event,ks)\" \nstyle=\"text-decoration:underline;text-align:left !important\" align=\"left\">{{ ks.resultDate}}</button></td><td \nalign=\"center\">{{ ks.status}}</td></tr></tbody></table><md-divider></md-divider><table id=\"attendance\" \nclass=\"mt-20 simple with-toolbar bordered stripped\" id=\"kpiTable\" ms-responsive-table><div \nclass=\"form-title text-center\"><span>PA Result</span></div><thead><tr><th>No.</th><th>Periode</th><th>KPI</th><th>\nProcess</th><th>IP</th><th>Mutu 1</th><th></th></tr></thead><tbody><tr ng-repeat=\"kpi in vm.listPA\"><td \nstyle=\"text-align: center\">{{($index + 1)}}</td><td style=\"text-align: center\">{{kpi.periode}}</td><td \nstyle=\"text-align: center\">{{kpi.kpiValue}}</td><td style=\"text-align: center\">{{kpi.behavior_performance}}</td><td \nstyle=\"text-align: center\">{{kpi.ip}}</td><td style=\"text-align: center\">{{kpi.nilai_mutu1}}</td><td><span \nng-if=\"kpi.paApproval==0\" class=\"green-500-fg\">Approved</span></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/hrbp/job-code-profile/job-code-profile.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Job Code Profile</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container md-no-float class=\"md-block\" flex=\"30\">Shows :<select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Twitter\" class=\"md-icon-button md-primary\" \nng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.DOWNLOAD_EXCEL\">Download Excel</span></md-tooltip><md-icon md-font-icon=\"icon-file-excel\" \nclass=\"teal-800-fg\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon>\n</span></th><th width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Job Code</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Competency Code</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">\nCompetency</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Req. Level</span></div></th><th \nwidth=\"5%\"><div class=\"text-center\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls.id)\"><td><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.modulesAction(ls.id)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex>View Action</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></td><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listModulSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ ls.no }}</td><td class=\"text-center\">{{ ls.job_code | uppercase }}\n</td><td class=\"text-center\">{{ ls.competency_code | uppercase }}</td><td class=\"text-center\">\n{{ ls.competency_name | uppercase }}</td><td class=\"text-center\">{{ ls.req_level | uppercase }}</td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/hrbp/job-code-profile/upload-job-code-profile.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>\nUpload Job Code Profile (Matrix)</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" \nnv-file-select uploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/hrbp/kpi-nabati/kpi-nabati.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Kpi Nabati Group</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>Business Unit</label><md-select ng-model=\"vm.bu\" \nng-change=\"vm.loadDataDivision(vm.bu)\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"bu in vm.listBu\" \nvalue=\"{{bu.id}}\">{{bu.description}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Division</label><md-select ng-model=\"vm.divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\">\n<md-option value=\"\">All</md-option><md-option ng-repeat=\"divisi in vm.listDivisi\" value=\"{{divisi.id}}\">\n{{divisi.description}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm>\n<label>Department</label><md-select ng-model=\"vm.department\" ng-change=\"vm.loadData(1)\"><md-option value=\"\">All\n</md-option><md-option ng-repeat=\"department  in vm.listDepartment\" value=\"{{department.id}}\">\n{{department.description}}</md-option></md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" \ntype=\"button\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" id=\"kpiTable\" ms-responsive-table><thead><tr><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th \nclass=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\">NIK</span></div></th><th \nclass=\"text-left\" width=\"30%\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">KPI</span></div></th><th \nstyle=\"text-align:center\"><span class=\"column-title\">TARGET SETTING</span></th><th class=\"secondary-text\" \nstyle=\"text-align:center\"><div class=\"table-header\"><span class=\"column-title\">WEIGHT STATUS</span></div></th><th \nclass=\"secondary-text\" style=\"text-align:center\"><div class=\"table-header\"><span class=\"column-title\">APPROVAL STATUS\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">VIEW</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\"><td class=\"text-center\">{{ ($index + 1)}}</td><td \nclass=\"text-center\">{{ team.nik}}</td><td>{{ team.name}}</td><td class=\"text-center\"><div ng-if=\"team.adakpi==\'1\'\">\n<md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></div><div ng-if=\"team.adakpi!=\'1\'\"><md-icon \nmd-font-icon=\"icon-check\" class=\"red-500-fg\"></md-icon></div></td><td align=\"center\"><div class=\"text-center\" \nng-if=\"team.adats===\'1\'\"><md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></div><div \nclass=\"text-center\" ng-if=\"team.adats!=\'1\' && team.jumTs >0\">{{team.jumTs}} waitting</div><div class=\"text-center\" \nng-if=\"team.adats!=\'1\' && team.jumTs ==0\"><md-icon md-font-icon=\"icon-check\" class=\"red-500-fg\"></md-icon></div></td>\n<td class=\"text-center\"><div ng-if=\"team.weightStat===\'100\'\"><md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\">\n</md-icon></div><div ng-if=\"team.weightStat!=\'100\'\">{{team.weightStat}}%</div></td><td class=\"text-center\"><md-icon \nng-if=\"(team.totApproval==\'0\' && team.adats==\'1\')\" md-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon><span \nng-if=\"team.totApproval>0\">{{team.totApproval}} waiting</span></td><td class=\"text-center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.setView(team.nik)\"><md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>\nclick for view</span></md-tooltip></md-button></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/hrbp/performance-value/performance-value.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">YEARS</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year.year}}\" \nng-click=\"vm.showKpi(year.year)\"><span class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill><div\n class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\">Sub Area</md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>\nPeriode</label><md-select ng-model=\"vm.periodeSelected\"><md-option value=\"yearly\">Yearly</md-option><md-option \nng-repeat=\"periode in vm.periode\" value=\"{{periode.periode}}\">{{periode.periode}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Business Unit</label><md-select \nng-model=\"vm.bu\" ng-change=\"vm.loadDataDivision(vm.bu)\"><md-option ng-repeat=\"bu in vm.listBu\" value=\"{{bu.id}}\">\n{{bu.description}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\nDivision</label><md-select ng-model=\"vm.divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option \nng-repeat=\"divisi in vm.listDivisi\" value=\"{{divisi.id}}\">{{divisi.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Department</label><md-select \nng-model=\"vm.department\" ng-change=\"vm.loadData(1)\"><md-option ng-repeat=\"department  in vm.listDepartment\" \nvalue=\"{{department.id}}\">{{department.description}}</md-option></md-select></md-input-container></div></form></div>\n</div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th>NO</th><th>Comp</th><th>NIK</th><th>\nNAME</th><th>DIV</th><th>DEPT</th><th>JOB TITLE</th><th>JOB LEVEL</th><th>ATASAN</th><th>GRADE</th><th>SERVICE YEAR\n</th><th>KPI</th><th>PROCESS</th><th>IP</th><th>MUTU 1</th><th>DEPT. PERFORMANCE</th><th>DIV. PERFORMANCE</th><th>\nNABATI GROUP</th><th>MUTU 2</th><th>ADJ 1</th><th>ADJ 2</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span>{{($index + 1)}}<md-tooltip md-direction=\"bottom\" \nmd-visible=\"tooltipVisible\">Row number</md-tooltip></span></td><td class=\"text-center\"><span>{{ls.company}}<md-tooltip \nmd-direction=\"bottom\">Company</md-tooltip></span></td><td class=\"text-center\"><span>{{ls.nik}}<md-tooltip \nmd-direction=\"bottom\">nik</md-tooltip></span></td><td>{{ls.title}} {{ls.first_name}} {{ls.last_name}}</td><td \nclass=\"text-center\">{{ls.division}}</td><td class=\"text-center\">{{ls.department}}</td><td class=\"text-center\">\n{{ls.jobtitle}}</td><td class=\"text-center\">{{ls.level}}</td><td class=\"text-center\">{{ls.namaAtasan}}</td><td \nclass=\"text-center\">{{ls.grade}}</td><td class=\"text-center\">{{ls.serviceYear}}</td><td class=\"text-center\">\n{{ls.kpiValue}}</td><td class=\"text-center\">{{ls.behavior_performance}}</td><td class=\"text-center\">{{ls.ip}}</td><td \nclass=\"text-center\">{{ls.nilai_mutu1}}</td><td class=\"text-center\"></td><td class=\"text-center\"></td><td \nclass=\"text-center\"></td><td class=\"text-center\">a</td><td class=\"text-center\">{{ls.adj1}}</td><td class=\"text-center\">\n{{ls.adj2}}</td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/hrbp/charts-pa/charts-pa.html","<div id=\"dashboard-server\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div id=\"widgets\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap id=\"allChart\"><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">Performance Chart Nabati Group</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"></div></div><div \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" \nlayout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataMutu\" chart-options=\"vm.optionsBadj\" \nid=\"chart1\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div \nui-chart=\"vm.dataAdj1\" chart-options=\"vm.optionsAadj1\" id=\"chart2\"></div></div><div class=\"p-16\" layout=\"row\" \nflex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj2\" chart-options=\"vm.optionsAadj2\" id=\"chart3\"></div>\n</div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nid=\"chartPaByDIvision\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Chart By Divisi {{vm.DivisionName}}</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item ng-repeat=\"oDivision in vm.listDivision\"><md-button \nng-click=\"vm.viewDataDivision(oDivision.id,oDivision.description)\" aria-label=\"{{oDivision.description}} widget\">\n{{oDivision.description}}</md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div \nui-chart=\"vm.dataMutuDiv\" chart-options=\"vm.optionsBadjDiv\" id=\"chart4\"></div></div><div class=\"p-16\" layout=\"row\" \nflex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1Div\" chart-options=\"vm.optionsAadj1Div\" id=\"chart5\">\n</div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj2Div\" \nchart-options=\"vm.optionsAadj2Div\" id=\"chart6\"></div></div></div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/indisciplinary-alert/form/form.html","<md-dialog aria-label=\"Create Indisciplinary Request\" ms-scroll flex=\"60\" id=\"indisciplinary-dialog\"><form ng-cloak \nname=\"formIndisciplinary\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><p>\n{{ vm.dialogType }} Warning Letter</p><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon\n ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-cloak class=\"content-animate-height\"><div layout=\"column\" class=\"animate-element\" layout-align=\"start center\" \nng-if=\"vm.loadingProgress\"><md-progress-circular md-diameter=\"30\" class=\"red-500-fg\" md-mode=\"indeterminate\">\n</md-progress-circular><span style=\"padding-top:10px\">Preparing</span></div><div layout=\"row\" \nclass=\"content-transaction\" ng-if=\"!vm.loadingProgress\" flex layout-align=\"start\"><div layout=\"row\" flex=\"15\" \nlayout-align=\"center start\"><img class=\"thumbnail\" \nimageonload=\"/hcportal/src/api/empdocument/{{vm.Form.objForm.photo_address}}\" src=\"assets/images/loader.svg\"></div><div\n layout=\"row\" class=\"employee-info\" flex=\"40\" layout-align=\"start\"><md-list flex class=\"md-dense\"><md-list-item flex>\n<div flex=\"30\">NIK</div><div flex>{{vm.Form.objForm.nik}}</div></md-list-item><md-divider></md-divider><md-list-item \nflex><div flex=\"30\">Nama</div><div flex>{{vm.Form.objForm.name}}</div></md-list-item><md-divider></md-divider>\n<md-divider></md-divider><md-divider></md-divider><md-divider ng-if=\"vm.isMessageAction\"></md-divider><md-list-item \nng-if=\"vm.isMessageAction\" flex><div flex style=\"color:red\">{{vm.messageAction}}</div></md-list-item></md-list></div>\n<div layout=\"column\" flex layout-align=\"start start\"><md-input-container md-no-float class=\"md-block\"><md-select \nrequired placeholder=\"Pilih Surat\" name=\"letter_type\" ng-model=\"vm.Form.objForm.letter_type\" \nng-change=\"vm.setLetterTypeOfAction(vm.Form.objForm.letter_type.code,vm.Form.objForm.nik)\"><md-option \nng-repeat=\"letter in vm.letter\" ng-value=\"letter\">{{letter.name}}</md-option></md-select></md-input-container><div \nlayout=\"row\" class=\"padding-left-5 animate-element\" ng-show=\"!vm.loadTypeOfAction && !vm.Form.objForm.letter_type\">\nPilih Surat untuk memilih jenis tindakan</div><div layout=\"row\" class=\"padding-left-5 animate-element\" \nng-show=\"!vm.loadTypeOfAction && vm.Form.objForm.letter_type\">Pilih jenis tindakan</div><div layout=\"row\" \nstyle=\"padding-top:10px\" ng-show=\"vm.loadTypeOfAction\"><md-progress-circular md-diameter=\"20\" class=\"red-500-fg\" \nmd-mode=\"indeterminate\"></md-progress-circular><span style=\"padding-left:10px\" ng-show=\"vm.loadTypeOfAction\">\nMohon Tunggu</span></div><div layout=\"column\" class=\"checkbox-wrapper\" layout-align=\"start\"><md-checkbox \nclass=\"animate-slide-down md-primary\" ng-show=\"!vm.loadTypeOfAction\" ng-repeat=\"action in vm.letterTypeOfAction\" \nng-model=\"action.isChecked\" ng-change=\"vm.setTypeOfAction(action)\" placeholder=\"Jenis Tindakan\">{{action.action}}\n</md-checkbox></div></div></div><div layout=\"column\" class=\"content-main animate-element\" ng-if=\"vm.isReady\" \nlayout-align=\"start\"><div layout=\"row\" class=\"padding-bottom-5\" flex layout-align=\"start center\"><div \nclass=\"inline-form-input\" ng-if=\"vm.showFormEntity.validFrom\" layout=\"row\" layout-align=\"start center\"><label \nfor=\"valid_from\">Berlaku dari</label><div class=\"form-input\" id=\"valid_from\"><md-datepicker md-hide-icons=\"calendar\" \nmd-placeholder=\"tanggal\" name=\"valid_from\" required md-open-on-focus ng-model=\"vm.tempValidFrom\" \nmd-current-view=\"month\"></md-datepicker></div></div><div class=\"spacer\" ng-if=\"vm.showFormEntity.validTo\"><span>sampai\n</span></div><div ng-if=\"vm.showFormEntity.validTo\"><md-datepicker md-hide-icons=\"calendar\" md-placeholder=\"tanggal\" \nname=\"valid_to\" required md-open-on-focus ng-model=\"vm.tempValidTo\" md-current-view=\"month\"></md-datepicker></div><div \nclass=\"spacer\" ng-if=\"vm.showFormEntity.validTo\"><span class=\"animate-element\" ng-bind-html=\"vm.validLabel\" \nng-if=\"vm.tempValidTo\"></span></div><div class=\"inline-form-input\"><label for=\"nomor_surat\">Nomor Surat</label><input \ntype=\"text\" class=\"form-input\" placeholder=\"Nomor Surat\" ng-model=\"vm.Form.objForm.nomor_surat\" name=\"nomor_surat\" \nid=\"nomor_surat\" required></div></div><div layout=\"row\" class=\"padding-bottom-5\" flex layout-align=\"start\"><div flex \nclass=\"other-input\"><label>Alasan Dibuatnya {{ vm.Form.objForm.letter_type.name }}</label><textarea required \nmd-placeholder=\"\" rows=\"3\" name=\"reason\" ng-model=\"vm.Form.objForm.reason\"></textarea></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" flex><div layout-align=\"start center\" flex \nclass=\"form-message animate-element\" ng-class=\"{success:vm.success, error:!vm.success}\" ng-show=\"vm.Form.tampilPesan\">\n{{ vm.Form.pesan }}</div><div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.submit($event, formIndisciplinary)\" \nng-disabled=\"formIndisciplinary.$invalid || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Submit</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/indisciplinary-approval/export/export.html","<md-dialog aria-label=\"Create Correspondence Request\" md-theme=\"modal-theme\" ms-scroll flex=\"60\" \nid=\"correspondence-pma-dialog\"><form ng-cloak name=\"formCorrespondence\" novalidate ng-submit=\"\"><md-toolbar><div \nclass=\"md-toolbar-tools title\"><h4>Indisciplinary Export Data</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-padding><md-input-container flex><label>Start Date</label>\n<md-datepicker name=\"start_date\" required md-hide-icons=\"calendar\" md-open-on-focus ng-model=\"vm.tempStartDate\" \nmd-current-view=\"month\"></md-datepicker></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker ng-disabled=\"vm.readOnly\" name=\"end_date\" required md-hide-icons=\"calendar\" md-open-on-focus \nng-model=\"vm.tempEndDate\" md-current-view=\"month\"></md-datepicker></md-input-container><md-input-container flex><label>\nSub Area</label><md-select ng-model=\"vm.subArea\" required data-md-container-class=\"selectHeader\" \nmd-on-close=\"vm.clearSearch()\" aria-label=\"sub_area\" name=\"sub_area\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for sub area\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup label=\"select sub area\"><md-option \nng-repeat=\"ls in vm.listSubArea | filter:vm.searchTerm\" placeholder=\"Sub Area\" ng-selected=\"vm.subArea == ls.id\" \nng-value=\"ls.id\">{{ ls.description }}</md-option></md-optgroup></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" flex><div flex=\"40\" layout-align=\"end center\" layout=\"row\">\n<md-button class=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.exportData()\" ng-disabled=\"formCorrespondence.$invalid\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-file-excel-box white-fg\"></md-icon>Export</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/indisciplinary-request/form/form.html","<md-dialog aria-label=\"Create Indisciplinary Request\" ms-scroll flex=\"60\" id=\"indisciplinary-dialog\"><form ng-cloak \nname=\"formIndisciplinary\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><p>\n{{ vm.dialogType }} Indisciplinary</p><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon\n ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-cloak class=\"content-animate-height\"><div layout=\"column\" class=\"animate-element\" layout-align=\"start center\" \nng-if=\"vm.loadingProgress\"><md-progress-circular md-diameter=\"30\" class=\"red-500-fg\" md-mode=\"indeterminate\">\n</md-progress-circular><span style=\"padding-top:10px\">Preparing</span></div><div layout=\"row\" flex \nclass=\"autocomplete-wrapper animate-element\" ng-if=\"!vm.loadingProgress\"><md-autocomplete md-delay=\"1000\" flex \nmd-selected-item=\"vm.selectedEmployee\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-require-match \nplaceholder=\"Cari Karyawan\" md-search-text=\"vm.searchText\" md-input-name=\"nik\" md-no-cache=\"true\" \nmd-menu-class=\"autocomplete-custom-template\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-min-length=\"2\"><md-item-template><span class=\"item-title\" md-highlight-text=\"vm.searchText\">\n{{ item.nik }} | {{ item.name }} | {{ item.job_title }}</span></md-item-template><md-not-found>\nNo Record matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></div><div layout-gt-sm=\"row\" \nlayout=\"column\" class=\"content-transaction\" flex ng-if=\"vm.isEmployeeFound\" layout-align=\"start\"><div layout=\"row\" \nflex-gt-sm=\"15\" flex layout-align=\"center start\"><img class=\"thumbnail\" \nimageonload=\"https://hcportal.nabatisnack.co.id/api/empdocument/{{vm.employee.photo_address}}\" \nsrc=\"assets/images/loader.svg\"></div><div layout=\"row\" class=\"employee-info\" flex-gt-sm=\"40\" flex layout-align=\"start\">\n<md-list flex class=\"md-dense\"><md-list-item flex><div flex=\"30\">NIK</div><div flex>{{vm.employee.nik}}</div>\n</md-list-item><md-divider></md-divider><md-list-item flex><div flex=\"30\">Nama</div><div flex>{{vm.employee.name}}\n</div></md-list-item><md-divider></md-divider><md-list-item flex><div flex=\"30\">Grade</div><div flex>\n{{vm.employee.emp_grade}}</div></md-list-item><md-divider></md-divider><md-list-item flex><div flex=\"30\">Jabatan</div>\n<div flex>{{vm.employee.job_title}}</div></md-list-item><md-divider></md-divider><md-list-item flex><div flex=\"30\">\nTgl Bergabung</div><div flex>{{vm.employee.join_date_id}} <sup style=\"color:blue\">?<md-tooltip>\n{{ vm.getLengthOfService(vm.employee.today, vm.employee.date_join)}}</md-tooltip></sup></div></md-list-item><md-divider\n ng-if=\"vm.isMessageAction\"></md-divider><md-list-item ng-if=\"vm.isMessageAction\" flex><div flex style=\"color:red\">\n{{vm.messageAction}}</div></md-list-item></md-list></div><div layout=\"column\" flex layout-align=\"start start\">\n<md-input-container md-no-float class=\"md-block\"><md-select required placeholder=\"Pilih Surat\" name=\"letter_type\" \nng-model=\"vm.Form.objForm.letter_type\" ng-change=\"vm.setLetterTypeOfAction(vm.Form.objForm.letter_type.code)\">\n<md-option ng-repeat=\"letter in vm.letter\" ng-value=\"letter\">{{letter.name}}</md-option></md-select>\n</md-input-container><div layout=\"row\" class=\"padding-left-5 animate-element\" \nng-show=\"!vm.loadTypeOfAction && !vm.Form.objForm.letter_type\">Pilih Surat untuk memilih jenis tindakan</div><div \nlayout=\"row\" class=\"padding-left-5 animate-element\" ng-show=\"!vm.loadTypeOfAction && vm.Form.objForm.letter_type\">\nPilih jenis tindakan</div><div layout=\"row\" style=\"padding-top:10px\" ng-show=\"vm.loadTypeOfAction\">\n<md-progress-circular md-diameter=\"20\" class=\"red-500-fg\" md-mode=\"indeterminate\"></md-progress-circular><span \nstyle=\"padding-left:10px\" ng-show=\"vm.loadTypeOfAction\">Mohon Tunggu</span></div><div layout=\"column\" \nclass=\"checkbox-wrapper\" layout-align=\"start\"><md-checkbox class=\"animate-slide-down md-primary\" \nng-show=\"!vm.loadTypeOfAction\" ng-repeat=\"action in vm.letterTypeOfAction\" ng-model=\"action.isChecked\" \nng-change=\"vm.setTypeOfAction(action)\" placeholder=\"Jenis Tindakan\">{{action.action}}</md-checkbox></div></div></div>\n<div layout=\"column\" class=\"content-main animate-element\" ng-if=\"vm.isReady\" layout-align=\"start\"><div \nlayout-gt-sm=\"row\" layout=\"column\" class=\"padding-bottom-5\" flex layout-align=\"start\" \nlayout-align-gt-sm=\"start center\"><div class=\"inline-form-input\" ng-if=\"vm.showFormEntity.validFrom\" layout=\"row\" \nlayout-align=\"start center\"><label for=\"valid_from\">Berlaku dari</label><div class=\"form-input\" id=\"valid_from\">\n<md-datepicker md-hide-icons=\"calendar\" md-placeholder=\"tanggal\" name=\"valid_from\" required md-open-on-focus \nng-model=\"vm.tempValidFrom\" md-current-view=\"month\"></md-datepicker></div></div><div class=\"inline-form-input\" \nng-if=\"vm.showFormEntity.validTo\" layout=\"row\" layout-align=\"start center\"><label for=\"valid_to\">Sampai</label><div \nclass=\"form-input\" id=\"valid_to\"><md-datepicker md-hide-icons=\"calendar\" md-placeholder=\"tanggal\" name=\"valid_to\" \nmd-open-on-focus ng-model=\"vm.tempValidTo\" ng-disabled=\"true\" md-current-view=\"month\"></md-datepicker></div></div><div \nclass=\"spacer\" ng-if=\"vm.showFormEntity.validTo\"><span class=\"animate-element\" ng-bind-html=\"vm.validLabel\" \nng-if=\"vm.tempValidTo\"></span></div><div class=\"inline-form-input\" ng-if=\"vm.showFormEntity.skorsingLengthDate\"><label \nfor=\"skorsing_length\">Skorsing selama (Bulan)</label><input type=\"number\" class=\"form-input\" \nng-model=\"vm.Form.objForm.skorsingDuration\" name=\"skorsing_length\" id=\"skorsing_length\" min=\"1\" max=\"12\"></div><div \nclass=\"spacer\" ng-if=\"vm.showFormEntity.skorsingLengthDate\"></div><div class=\"inline-form-input\" \nng-if=\"vm.showFormEntity.skorsingStartDate\" layout=\"row\" layout-align=\"start center\"><label for=\"skorsing_start_date\">\nMulai skorsing pada</label><div class=\"form-input\" id=\"skorsing_start_date\"><md-datepicker md-hide-icons=\"calendar\" \nmd-placeholder=\"tanggal\" name=\"skorsing_start_date\" required md-open-on-focus ng-model=\"vm.tempSkorsingStartDate\" \nmd-current-view=\"month\"></md-datepicker></div></div></div><div layout=\"row\" class=\"padding-bottom-5\" flex \nlayout-align=\"start\"><div flex ng-if=\"vm.showFormEntity.reason\" class=\"other-input\"><label>\nAlasan Dibuatnya {{ vm.Form.objForm.letter_type.name }}</label><textarea required md-placeholder=\"\" rows=\"3\" \nname=\"reason\" ng-model=\"vm.Form.objForm.reason\"></textarea></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" flex><div layout-align=\"start center\" flex class=\"form-message animate-element\" \nng-class=\"{success:vm.success, error:!vm.success}\" ng-show=\"vm.Form.tampilPesan\">{{ vm.Form.pesan }}</div><div \nflex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.submit($event, formIndisciplinary)\" ng-disabled=\"formIndisciplinary.$invalid || vm.saveProcess\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Submit</md-button><md-button \nng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/indisciplinary-request/detail/detail.html","<md-dialog aria-label=\"View Correspondence Request\" md-theme=\"modal-theme\" ms-scroll flex=\"60\"><form ng-cloak \nname=\"formCorrespondence\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><h4>\nDetail Correspondence Request PMA</h4><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon\n ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nng-show=\"vm.loadingProgress\" md-mode=\"indeterminate\"></md-progress-linear><md-dialog-content><div layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"row\" layout-align=\"start center\" flex=\"10\"><img \nimageonload=\"{{vm.baseImageUrl}}\" src=\"assets/images/loader.svg\"></div><div layout=\"row\" layout-align=\"start center\" \nflex=\"10\"></div></div></md-dialog-content><md-dialog-actions layout=\"row\" flex><div flex=\"40\" \nlayout-align=\"end center\" layout=\"row\"><md-button ng-if=\"vm.create\" class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.storeRequest($event,formCorrespondence)\" \nng-disabled=\"formCorrespondence.$invalid || vm.saveProcess || vm.employeeLists.length === 0\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-if=\"vm.update\" \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.updateRequest($event,formCorrespondence)\" \nng-disabled=\"formCorrespondence.$invalid || vm.updateProcess || formCorrespondence.$pristine\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Update</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/indisciplinary-request/upload/upload.html","<md-dialog aria-label=\"Form Upload Document Indisciplinary\" flex-md=\"40\" flex-gt-md=\"40\"><form ng-cloack \nname=\"uploadDocument\" class=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Upload Document</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" layout=\"column\" layout-align=\"center\" \nlayout-padding id=\"contentDialog\"><div layout=\"column\" layout-align=\"space-between center\"><iframe \nstyle=\"width: 100%; height: 50vh\" ng-src=\"{{vm.trustedFile}}\"></iframe><div style=\"margin-top:1.5em\"><input \ntype=\"file\" id=\"uploadDocument\" accept=\".pdf\" nv-file-select uploader=\"vm.fileUploadDocument\"></div></div><div \nlayout=\"row\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.fileUploadDocument.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div><div layout=\"row\" layout-align=\"space-between center\"><div flex>\n</div><md-button type=\"button\" ng-click=\"vm.fileUploadDocument.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\">\n</md-icon>Upload</md-button><md-button type=\"button\" ng-click=\"vm.downloadDocument()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Download</md-button></div><div layout=\"row\"><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadDocumentStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadDocumentStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/indisciplinary-request/view-approval/view-approval.html","<md-dialog aria-label=\"View Detail Request\" ms-scroll flex=\"50\"><form ng-cloak name=\"formRequest\" novalidate \nng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><h4 style=\"margin-block-start:15px\">Request Detail</h4>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear ng-show=\"vm.loadingProgress\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-dialog-content><div layout=\"column\" class=\"view-detail-container\" \nlayout-align=\"space-between start\" layout-padding layout-fill flex><div class=\"detail-container\" layout=\"row\"><img \nng-src=\"{{vm.data.photo_address ? vm.data.photo_address : \'no\'}}\" class=\"img-detail\" alt=\"{{item.fullname}}\" \non-error-src=\"assets/images/avatars/profile.jpg\"><table><tr ng-if=\"vm.data.type === \'confirm\'\"><td class=\"text-bold\">\nValidation</td><td>:</td><td class=\"text-bold\"><span ng-bind-html=\"vm.getStatus(vm.data.is_valid)\"></span></td></tr><tr\n ng-if=\"vm.data.type === \'confirm\'\"><td class=\"text-bold\">Confirmation</td><td>:</td><td class=\"text-bold\"><span \nng-bind-html=\"vm.getConfirmStatus(vm.data.is_confirmed)\"></span></td></tr><tr><th>NIK</th><td>:</td><td>{{vm.data.nik}}\n</td></tr><tr><th>Name</th><td>:</td><td>{{vm.data.name ? vm.data.name : vm.data.fullname}}</td></tr><tr><th>Position\n</th><td>:</td><td>{{vm.data.position}}</td></tr><tr><th>Sub Area</th><td>:</td><td>{{vm.data.sub_area_name}}</td></tr>\n<tr><th>Letter Name</th><td>:</td><td>{{vm.data.letter_name}}</td></tr><tr><th>Type of Action</th><td>:</td><td>\n{{vm.data.type_of_action}}</td></tr><tr><th>Valid From</th><td>:</td><td>{{vm.data.valid_from}}</td></tr><tr><th>\nValid To</th><td>:</td><td>{{vm.data.valid_to}}</td></tr><tr ng-if=\"vm.data.type === \'normal\'\"><th>Document</th><td>:\n</td><td><a href=\"{{vm.trustedFile}}\" target=\"_blank\">{{vm.data.document_filename}}</a></td></tr><tr><th>Reason</th>\n<td>:</td><td><textarea ng-disabled=\"{{true}}\" ng-model=\"vm.data.reason\" class=\"reason\" rows=\"4\" cols=\"50\"></textarea>\n</td></tr><tr><th>Anulir</th><td>:</td><td>{{vm.data.is_cancelled == 1 ? \'Ya\' : \'Tidak\'}}</td></tr></table></div><div \nclass=\"approval-container\" flex ng-if=\"vm.data.approval.length > 0\"><table class=\"simple\"><thead><tr><td>No</td><td>\nApproved By</td><td>Approval Type</td><td>Approval Status</td><td>Notes</td></tr></thead><tbody><tr \nng-repeat=\"item in vm.data.approval\"><td>{{$index + 1}}</td><td>{{item.approved_by}} ({{item.fullname}})</td><td>\n{{item.approval_type | uppercase}}</td><td>{{vm.switchStatusApproval(item.approval_status)}}</td><td>\n{{item.reject_comments}}</td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\" flex>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/indisciplinary-request/notes/notes.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" class=\"dialog-custom-wrapper\" ms-scroll flex=\"65\"><form \nng-cloak name=\"formRequest\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><h4>\nIndisciplinary Revise</h4><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon \nng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-init=\"vm.setForm(formRequest)\" style=\"margin-top:0px\" layout-padding><div class=\"overlay\" ng-show=\"vm.isLoading\">\n<div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\"><md-progress-circular \nmd-diameter=\"20px\" class=\"md-accent\"></md-progress-circular><div class=\"padding-top-10\">Please wait ..</div></div>\n</div><div flex layout=\"row\"><md-input-container flex><label>Jenis Surat</label><md-select \nng-change=\"vm.onChangeLetter(vm.data.letter_code)\" name=\"letter_code\" ng-model=\"vm.data.letter_code\"><md-option \nng-repeat=\"item in vm.letterList\" ng-value=\"item.code\">{{item.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Validity period (month)</label><input type=\"text\" required ng-readonly=\"\'true\'\" \nname=\"validity_period\" ng-model=\"vm.data.validity_period\"><div ng-messages=\"formRequest.validity_period.$error\" \nrole=\"alert\"><div ng-message=\"required\">Validity period is required</div></div></md-input-container><md-input-container\n flex><label>Type Of Action</label><md-select name=\"type_of_action\" required \nng-model=\"vm.data.letter_type_of_action_id\"><md-option ng-repeat=\"item in vm.letterTypeOfAction\" ng-value=\"item.id\">\n{{item.action}}</md-option></md-select><div ng-messages=\"formRequest.type_of_action.$error\" role=\"alert\"><div \nng-message=\"required\">Type of action is required</div></div></md-input-container></div><div flex layout=\"row\">\n<md-input-container flex><label>Valid from</label><input type=\"date\" name=\"temp_valid_from\" required \nng-model=\"vm.tempValidFrom\"><div ng-messages=\"formRequest.temp_valid_from.$error\" role=\"alert\"><div \nng-message=\"required\">Valid from is required</div></div></md-input-container><md-input-container flex><label>Valid to\n</label><input type=\"date\" name=\"temp_valid_to\" required ng-model=\"vm.tempValidTo\"><div \nng-messages=\"formRequest.temp_valid_to.$error\" role=\"alert\"><div ng-message=\"required\">Valid to is required</div></div>\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex><label>Indisciplinary Reason</label>\n<textarea type=\"text\" name=\"reason\" required ng-model=\"vm.data.reason\" minlength=\"50\">\n                    </textarea>\n<div ng-messages=\"formRequest.reason.$error\" role=\"alert\"><div ng-message=\"required\">Reason is required</div><div \nng-message=\"minlength\">Minimal character is 50 !</div></div></md-input-container></div><div flex layout=\"column\" \nclass=\"list-revise-container\"><div class=\"revise-header\">Revise Notes</div><div class=\"list-revise\" \nng-repeat=\"item in vm.listNotes\"><span class=\"number\">{{$index + 1}}</span> <span class=\"content-revise\">{{item.notes}}\n</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\" flex><div flex=\"40\" layout-align=\"end center\" \nlayout=\"row\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.submit($event, formRequest)\" \nng-disabled=\"formRequest.$invalid || formRequest.$pristine || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon>Update</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/indisciplinary-validation/update/update.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" class=\"dialog-custom-wrapper validation-form\" ms-scroll \nflex=\"70\"><form ng-cloak name=\"formRequest\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\">\n<h4>Update Indisciplinary</h4><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-init=\"vm.setForm(formRequest)\" style=\"margin-top:0px\" layout-padding><div class=\"overlay\" ng-show=\"vm.isLoading\">\n<div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\"><md-progress-circular \nmd-diameter=\"20px\" class=\"md-accent\"></md-progress-circular><div class=\"padding-top-10\">Please wait ..</div></div>\n</div><div flex layout=\"row\"><md-input-container flex><label>Jenis Surat</label><md-select \nng-change=\"vm.onChangeLetter(vm.data.letter_code)\" name=\"letter_code\" ng-model=\"vm.data.letter_code\"><md-option \nng-repeat=\"item in vm.letterList\" ng-value=\"item.code\">{{item.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Validity period (month)</label><input type=\"text\" required ng-readonly=\"\'true\'\" \nname=\"validity_period\" ng-model=\"vm.data.validity_period\"><div ng-messages=\"formRequest.validity_period.$error\" \nrole=\"alert\"><div ng-message=\"required\">Validity period is required</div></div></md-input-container></div><div flex \nlayout=\"row\"><md-input-container flex><label>Valid from</label><input type=\"date\" name=\"temp_valid_from\" required \nng-model=\"vm.tempValidFrom\"><div ng-messages=\"formRequest.temp_valid_from.$error\" role=\"alert\"><div \nng-message=\"required\">Valid from is required</div></div></md-input-container><md-input-container flex><label>Valid to\n</label><input type=\"date\" name=\"temp_valid_to\" required ng-model=\"vm.tempValidTo\"><div \nng-messages=\"formRequest.temp_valid_to.$error\" role=\"alert\"><div ng-message=\"required\">Valid to is required</div></div>\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex><label>Type Of Action</label><md-select \nname=\"type_of_action\" required ng-model=\"vm.data.action_type_id\"><md-option ng-repeat=\"item in vm.letterTypeOfAction\" \nng-value=\"item.id\">{{item.action}}</md-option></md-select><div ng-messages=\"formRequest.type_of_action.$error\" \nrole=\"alert\"><div ng-message=\"required\">Type of action is required</div></div></md-input-container><md-input-container \nflex><label>Indisciplinary Reason</label><input type=\"text\" name=\"reason\" required ng-model=\"vm.data.reason\"><div \nng-messages=\"formRequest.reason.$error\" role=\"alert\"><div ng-message=\"required\">Reason is required</div></div>\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex><label>Area</label><input type=\"text\" \nname=\"sub_area_name\" readonly=\"readonly\" ng-model=\"vm.data.sub_area_name\"></md-input-container><md-input-container \nflex><label>Position</label><input type=\"text\" name=\"position\" readonly=\"readonly\" ng-model=\"vm.data.job_title\">\n</md-input-container></div><div flex layout=\"column\"><div layout=\"row\">Notes Template</div><div layout=\"row\"><span \nng-repeat=\"item in vm.template\" ng-click=\"vm.addTemplate(item)\" class=\"text-boxed clickable margin-left-0\">\n{{item.text}}</span></div></div><div flex layout=\"row\"><md-input-container flex><label>Notes</label><textarea \nplaceholder=\"Put your notes here eg: is valid request\" name=\"notes\" required ng-model=\"vm.data.notes\" rows=\"2\">\n</textarea><div ng-messages=\"formRequest.notes.$error\" role=\"alert\"><div ng-message=\"required\">Notes is required</div>\n</div></md-input-container></div><div flex layout=\"row\" layout-align=\"start center\"><p class=\"margin-right-10\">Status\n</p><md-radio-group layout=\"row\" ng-model=\"vm.data.is_valid\"><md-radio-button ng-repeat=\"item in vm.isValid\" \nng-value=\"item.id\" class=\"md-primary\">{{item.name}}</md-radio-button></md-radio-group></div><div flex layout=\"column\" \nlayout-align=\"start\"><p class=\"margin-right-10\">History</p><div><table class=\"simple bordered stripped\" \nms-responsive-table><thead><tr><th>NIK</th><th>Name</th><th>Position</th><th>Area</th><th>Letter Code</th><th>Reason\n</th><th>Valid From</th><th>Valid To</th></tr></thead><tbody><tr ng-repeat=\"item in vm.data.history\"><td>{{item.nik}}\n</td><td>{{item.name}}</td><td>{{item.position}}</td><td>{{item.sub_area_name}}</td><td>{{item.letter_code}}</td><td>\n{{item.reason}}</td><td>{{item.valid_from}}</td><td>{{item.valid_to}}</td></tr></tbody></table></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" flex><div layout-align=\"start center\" flex \nng-class=\"{success:vm.success, error:!vm.success}\" ng-show=\"vm.showMessage\" class=\"form-message fade\">{{ vm.message }}\n</div><div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button ng-if=\"!vm.isEdit\" \nclass=\"md-primary md-raised white-fg\" ng-click=\"vm.confirmationDialog($event, formRequest)\" \nng-disabled=\"formRequest.$invalid || formRequest.$pristine || vm.saveProccess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insurance/emp-insurance/emp-insurance-detail.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header nabati4\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-multiple\"></md-icon></span><span class=\"md-title\">\nEmploye Insurance {{vm.Form.objForm.employeName}}</span></div></div></div></div><div class=\"content mt-30\" \nlayout=\"column\"><div layout=\"row\" layout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"90\" \nflex-sm=\"90\" flex-xs=\"100\" flex-md=\"90\"><div class=\"md-subhead\">Employe Insurance</div><div layout-sm=\"column\" \nlayout=\"row\" layout-align=\"start center\" layout-padding><div flex=\"30\"><div class=\"md-subhead\"><strong>Employe Name\n</strong></div><div class=\"info\">{{vm.Form.objForm.employeName}}</div></div><div flex=\"15\"><div class=\"md-subhead\">\n<strong>NIK</strong></div><div class=\"info\">{{vm.Form.objForm.nik}}</div></div><div flex=\"15\"><div class=\"md-subhead\">\n<strong>Bank Name</strong></div><div class=\"info\">Mandiri</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>\nAccount Number</strong></div><div class=\"info\">{{vm.Form.objForm.no_rekening}}</div></div><div flex=\"20\"><div \nclass=\"md-subhead\"><strong>Plan Code</strong></div><div class=\"info\">{{vm.Form.objForm.plan}}</div></div></div>\n<md-divider></md-divider><div layout-sm=\"column\" layout=\"row\" layout-align=\"start center\" layout-padding><div \nlayout-sm=\"column\" layout=\"row\" layout-align=\"start center\" layout-padding><div flex><table class=\"simple\" \nms-responsive-table border=\"1\" style=\"border-collapse: collapse; border-color:#e2e2e2\"><thead><tr><th \nstyle=\"background:rgb(245,245,245)!important; text-align: center\" rowspan=\"2\">Member Name</th><th \nstyle=\"background:rgb(245,245,245)!important; text-align: center\" colspan=\"3\">Inpatient</th><th \nstyle=\"background:rgb(245,245,245)!important; text-align: center\" colspan=\"3\">Outpatient</th><th \nstyle=\"background:rgb(245,245,245)!important; text-align: center\" colspan=\"3\">Dental</th><th \nstyle=\"background:rgb(245,245,245)!important; text-align: center\" colspan=\"3\">Glasses</th></tr><tr><th \nstyle=\"background:rgb(245,245,245)!important\">Benefit</th><th style=\"background:rgb(245,245,245)!important\">Usage</th>\n<th style=\"background:rgb(245,245,245)!important\">Residual</th><th style=\"background:rgb(245,245,245)!important\">\nBenefit</th><th style=\"background:rgb(245,245,245)!important\">Usage</th><th \nstyle=\"background:rgb(245,245,245)!important\">Residual</th><th style=\"background:rgb(245,245,245)!important\">Benefit\n</th><th style=\"background:rgb(245,245,245)!important\">Usage</th><th style=\"background:rgb(245,245,245)!important\">\nResidual</th><th style=\"background:rgb(245,245,245)!important\">Benefit</th><th \nstyle=\"background:rgb(245,245,245)!important\">Usage</th><th style=\"background:rgb(245,245,245)!important\">Residual</th>\n</tr></thead><tbody><tr ng-repeat=\"lsd in vm.claimRelationList\"><td class=\"name\">{{lsd.name}}</td><td class=\"name\">\n{{vm.ip | currency:\'Rp. \':0}}</td><td class=\"name\">{{lsd.residualIP | currency:\'Rp. \':0}}</td><td class=\"name\">\n{{vm.ip - lsd.residualIP | currency:\'Rp. \':0}}</td><td class=\"name\">{{vm.op|currency:\'Rp. \':0}}</td><td class=\"name\">\n{{lsd.residualOP |currency:\'Rp. \':0}}</td><td class=\"name\">{{vm.op - lsd.residualOP |currency:\'Rp. \':0}}</td><td \nclass=\"name\">{{vm.de|currency:\'Rp. \':0}}</td><td class=\"name\">{{lsd.residualDE |currency:\'Rp. \':0}}</td><td \nclass=\"name\">{{vm.de - lsd.residualDE |currency:\'Rp. \':0}}</td><td class=\"name\"><span \nng-if=\"lsd.member_type == \'Employe\'\">{{vm.eg|currency:\'Rp. \':0}}</span></td><td class=\"name\"><span \nng-if=\"lsd.member_type == \'Employe\'\">{{lsd.residualGL |currency:\'Rp. \':0}}</span></td><td class=\"name\"><span \nng-if=\"lsd.member_type == \'Employe\'\">{{vm.eg - lsd.residualGL |currency:\'Rp. \':0}}</span></td></tr></tbody></table>\n</div></div></div></div></div><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"90\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"90\"><span class=\"md-subhead\">\nEmploye Insurance Detail</span><div layout=\"column\"><table class=\"simple bordered\" ms-responsive-table><thead><tr><th \nwidth=\"2%\"></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Register Number</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Gender</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Place Of birth</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date Of birth</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Member relation</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Maternity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Effective Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"lsd in vm.Form.objForm.detail\"><td><md-menu md-position-mode=\"target-right target\">\n<md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.inputRegisterNumber(lsd)\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-account-check\"></md-icon><p flex>Input Register Number</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></td><td>{{lsd.no_register}}</td><td>{{lsd.name}}</td><td>{{lsd.gender}}</td><td>\n{{lsd.placeOfBirth}}</td><td>{{lsd.dateOfBirth}}</td><td>{{lsd.member_type}}</td><td>{{lsd.maternity}}</td><td>\n{{lsd.effective_date}}</td></tr></tbody></table></div></div></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"end center\"><md-button type=\"button\" ui-sref=\"app.insurance_emp-insurance_list\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\">Back</md-button></div></div></div>");
$templateCache.put("app/main/insurance/emp-insurance/emp-insurance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>List Employe Insurance</span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\">\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" placeholder=\"NIK / Nama\" ng-model=\"vm.nik\" id=\"formSearch\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nui-sref=\"app.insurance_emp-insurance_input\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nNew Employe Insurance</md-tooltip><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>New</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.deleteList()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nDelete Employe Insurance</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon><span>Delete</span></md-button><span\n flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"secondary-text\" width=\"2%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">NIK</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Bisnis Unit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Account Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Plan Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.detail(ls.id)\"><td><input type=\"checkbox\" checklist-model=\"vm.listTypeSelected\" checklist-value=\"ls\">\n</td><td>{{ ls.nik }}</td><td>{{ ls.empName}}</td><td>{{ ls.bu}}</td><td>{{ ls.no_rekening}}</td><td>{{ ls.plan_code}}\n</td><td><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.detail(ls.id)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex>View Detail</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/emp-insurance/input-emp-insurance-detail.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"50\" flex-gt-md=\"40\"><form ng-cloack name=\"detailForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,detailForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Input Detail Employe Insurance</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout-gt-sm=\"row\"><input type=\"hidden\" name=\"emp_insurance_id\" ng-model=\"vm.Form.objForm.emp_insurance_id\">\n<md-input-container flex=\"80\"><md-select ng-model=\"vm.Form.objForm.member_id\" name=\"member_id\" required><md-option \nng-repeat=\"ls in vm.listDependant\" placeholder=\"Member\" value=\"{{ls.id}}\">\n{{ls.typeOfFamily}} - {{ls.firstNameD}}&nbsp; {{ls.lastNameD}}</md-option></md-select><div \nng-messages=\"formInputEmpInsurance.plan_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>Plan is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><md-switch \nng-model=\"vm.Form.objForm.maternity\" aria-label=\"Maternity\"><span ng-if=\"vm.Form.objForm.maternity\">Maternity YES\n</span> <span ng-if=\"!vm.Form.objForm.maternity\">Maternity NO</span></md-switch></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"detailForm.$invalid || detailorm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insurance/emp-insurance/input-emp-insurance.html","<div id=\"header-action\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\" layout=\"column\">\n<md-content class=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill>\n<md-subheader class=\"white-bg\"><span translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.HEADER.TITLE\">Form Employe Insurance</span>\n</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"80\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form \nname=\"formInputEmpInsurance\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputEmpInsurance)\"><div \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"nik\" ng-model=\"vm.Form.objForm.nik\" \nng-readonly=\"true\" placeholder=\"NIK\" required><div ng-messages=\"formInputEmpInsurance.nik.$error\" role=\"alert\"><div \nng-message=\"required\"><span>NIK is required.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"empName\" ng-model=\"vm.Form.objForm.empName\" placeholder=\"Employe Name (Auto Input)\" \nng-readonly=\"true\"> <input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\" placeholder=\"Employe Name\"> \n<input type=\"hidden\" name=\"maternity\" ng-model=\"vm.Form.objForm.maternity\" placeholder=\"Employe Name\">\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.Form.objForm.plan_code\" name=\"plan_code\" \nrequired><md-option ng-repeat=\"ls in vm.listPlan\" placeholder=\"Plan\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"formInputEmpInsurance.plan_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlan is required.</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInputEmpInsurance.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"button\" \nui-sref=\"app.insurance_emp-insurance_list\" class=\"md-raised md-warn\" aria-label=\"Reload\">Back</md-button></div></form>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/emp-insurance/register-number.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"30\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Form Register Number</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\"><div class=\"form-wrapper\"><div layout=\"column\" layout=\"row\"><md-input-container \nflex=\"100\"><input type=\"text\" name=\"description\" ng-model=\"vm.registerNumber\" placeholder=\"Register Number\">\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button \nng-click=\"vm.submit()\" class=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\">Submit</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insurance/emp-claim/claim-timeline.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"70\" flex-gt-md=\"50\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Claim Timeline</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\" \nlayout-align=\"center center\"><table ms-responsive-table border=\"0\"><tr><th>EMPLOYEE -------------------------------->\n</th><th>LO --------------------------------></th><th>SINARMAS</th></tr><tr><td><strong>|</strong><br><strong>|\n</strong></td><td><strong>|</strong><br><strong>|</strong></td><td><strong>|</strong><br><strong>|</strong></td></tr>\n<tr><td>{{vm.data.submit_date}}<br>SUBMIT CLAIM</td><td ng-if=\"vm.data.status_time != \'0000-00-00 00:00:00\'\">\n{{vm.data.status_time}}<br>{{vm.data.status | uppercase}}</td><td ng-if=\"vm.data.status_time == \'0000-00-00 00:00:00\'\">\n{{vm.data.status | uppercase}} ...</td><td ng-if=\"vm.data.vendor.length == 0\" style=\"vertical-align: top\">WAITING ...\n</td><td ng-if=\"vm.data.vendor.length > 0\" style=\"vertical-align: top\">PROGRESS</td></tr><tr \nng-repeat=\"ls in vm.data.vendor\"><td></td><td></td><td>{{ls.register_date}}<br>TANGGAL PROSES<hr>{{ls.tgl_bayar}}<br>\n{{ls.status_klaim | uppercase}}</td></tr></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/insurance/emp-claim/emp-claim-detail.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">INSURANCE CLAIM DETAIL</md-subheader><div class=\"white-bg\"><div \nclass=\"page-layout simple right-sidenav\" layout=\"row\"><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><div class=\"content\"><span class=\"md-title\">Claim Detail</span><div layout-sm=\"column\" layout=\"row\" \nlayout-align=\"start center\" layout-padding><div flex=\"40\"><div class=\"md-subhead\"><strong>Employe Name</strong></div>\n<div class=\"info\">{{vm.Form.objForm.empName}}</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>NIK</strong>\n</div><div class=\"info\">{{vm.Form.objForm.nik}}</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>Submit Date\n</strong></div><div class=\"info\">{{vm.Form.objForm.submit_date | date:\'dd/MM/yyyy\'}}</div></div><div flex=\"20\"><div \nclass=\"md-subhead\"><strong>Status</strong></div><div class=\"info\">{{vm.Form.objForm.status}}</div></div></div>\n<md-divider></md-divider><div layout-sm=\"column\" layout=\"row\" layout-align=\"start center\" layout-padding><div \nflex=\"40\"><div class=\"md-subhead\"><strong>Patient Name</strong></div><div class=\"info\">{{vm.Form.objForm.memberName}}\n</div></div><div flex=\"15\"><div class=\"md-subhead\"><strong>Relation</strong></div><div class=\"info\">\n{{vm.Form.objForm.member_relation}}</div></div><div flex=\"15\"><div class=\"md-subhead\"><strong>Receipt Date</strong>\n</div><div class=\"info\">{{vm.Form.objForm.receipt_date | date:\'dd/MM/yyyy\'}}</div></div><div flex=\"30\"><div \nclass=\"md-subhead\"><strong>Claim Type</strong></div><div class=\"info\">{{vm.Form.objForm.typeClaimDetail}}</div></div>\n</div><md-divider></md-divider><div layout-sm=\"column\" layout=\"row\" layout-align=\"start center\" layout-padding><div \nflex=\"40\"><div class=\"md-subhead\"><strong>Currency</strong></div><div class=\"info\">{{vm.Form.objForm.currency}}</div>\n</div><div flex=\"40\"><div class=\"md-subhead\"><strong>Amount</strong></div><div class=\"info\">\n{{vm.Form.objForm.amount | currency:\" \":0}}</div></div></div><md-divider></md-divider><div layout-sm=\"column\" \nlayout=\"row\" layout-align=\"start center\" layout-padding><div flex><div class=\"md-subhead\"><strong>Claim Type Detail\n</strong></div><div class=\"info\">{{vm.Form.objForm.typeClaimDetail}}</div></div></div><md-divider></md-divider><p><span\n class=\"md-title\">Claim Comment</span></p><div class=\"timeline\" layout=\"column\"><div \nclass=\"timeline-item md-whiteframe-1dp\"><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"comment-count\">{{vm.Form.objForm.comment.length}} comments<md-icon md-font-icon=\"icon-keyboard_arrow_down\">\n</md-icon></div><div class=\"comment\" layout=\"row\" layout-fill ng-repeat=\"comment in vm.Form.objForm.comment\"><div flex \nlayout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user}}</span> <span \nclass=\"time\">{{comment.fullTime}}</span></div><div class=\"message\">{{comment.komentar}}</div></div></div><div \nclass=\"reply\" layout=\"row\" layout-align=\"end center\" layout-fill><form flex><textarea placeholder=\"Add a comment...\" \nng-model=\"vm.comment\"></textarea><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.postComment()\" \nclass=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\">Post Comment</md-button></div></form></div>\n</footer></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.back()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\">Back</md-button></div></md-content><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\"><span \nclass=\"text-boxed md-title\">List Document Claims</span></md-subheader><div ng-repeat=\"lsd in vm.Form.objForm.docs\">\n<md-list-item><p ng-click=\"vm.viewDocument($this, lsd, vm.data)\">{{$index +1}}. {{lsd.name.substr(0,6)}}... <i \nclass=\"icon icon-eye s20\"><md-tooltip><span>click for see</span></md-tooltip></i></p><p ng-click=\"vm.download(lsd)\"><i \nclass=\"icon icon-download s20\"><md-tooltip><span>Download</span></md-tooltip></i></p><p \nng-if=\"lsd.phisical_upload == 0 && vm.group == \'133\' \"><md-tooltip><span>Receive File</span></md-tooltip><input \ntype=\"checkbox\" ng-click=\"vm.checklist(lsd.id)\"></p><p ng-if=\"lsd.phisical_upload == 1\"><i class=\"icon icon-check s20\">\n<md-tooltip><span>File already received</span></md-tooltip></i></p><p \nng-if=\"lsd.phisical_upload == 1 && vm.group == \'128\' \"><md-tooltip><span>Reject file received</span></md-tooltip><input\n type=\"checkbox\" ng-click=\"vm.unchecklist(lsd.id)\"></p><p ng-if=\"lsd.phisical_upload == 1 && vm.group == \'133\' \">\n<md-tooltip><span>Reject file received</span></md-tooltip><input type=\"checkbox\" ng-click=\"vm.unchecklist(lsd.id)\"></p>\n</md-list-item><md-divider></md-divider></div></md-list></div></md-sidenav></div></div></div></md-content></div>");
$templateCache.put("app/main/insurance/emp-claim/emp-claim-employe.html","<div id=\"simple-table\" \nclass=\"page-layout simple fullwidth with-toolbar-content white-bg doc-page element-doc-page ng-scope\"><md-content \nclass=\"content padding\" layout-fill flex><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill flex><div \nid=\"dashboard-project\" class=\"page-layout\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\">\n<md-tabs md-dynamic-height><md-tab label=\"My Insurance Data\"><div class=\"widget-group\" layout=\"row\" flex layout-wrap>\n<ms-widget layout=\"row\" flex class=\"no-padding\"><ms-widget-front class=\"white-bg\"><div \nclass=\"form-wrapper md-white-50-bg\"><div layout=\"row\"><md-input-container flex=\"15\"><input type=\"text\" name=\"plan\" \nng-model=\"vm.noRegister\" placeholder=\"Register Number\" ng-disabled=\"true\"></md-input-container><md-input-container \nflex=\"10\"><input type=\"text\" name=\"plan\" ng-model=\"vm.planDescription\" placeholder=\"Plan\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex=\"25\"><input type=\"text\" name=\"annual_outpatient_claims\" \nvalue=\"{{vm.planAnnualOutpatientClaims|currency:\'Rp. \':0}}\" placeholder=\"Annual Outpatient Claims\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex=\"25\"><input type=\"text\" name=\"annual_dental_claims\" \nvalue=\"{{vm.planAnnualDentalClaims|currency:\'Rp. \':0}}\" placeholder=\"Annual Dental claims\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex=\"25\"><input type=\"text\" name=\"eyeglasses_anual_claims\" \nvalue=\"{{vm.planEyeglassesAnualClaims|currency:\'Rp. \':0}}\" placeholder=\"Eyeglasses Annual Claims\" ng-disabled=\"true\">\n</md-input-container></div></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"My Benefit\"><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\" class=\"no-padding\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"ml-16 text-boxed blue-bg white-fg\">\nShowing {{vm.planInsuranceDetail.length}} Benefit</span></div></div><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th>Benefit Name</th><th>Appropriately\n</th><th>Up Room Class</th></tr></thead><tbody><tr ng-repeat=\"lsd in vm.planInsuranceDetail\"><td class=\"name\">\n{{lsd.benefit}}</td><td class=\"name\">{{lsd.appropriately}}</td><td class=\"name\">{{lsd.up_room_class}}</td></tr></tbody>\n</table></ms-widget-front></ms-widget></md-tab><md-tab label=\"My Coverage\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" ng-repeat=\"lsd in vm.claimRelationList\" \nclass=\"no-padding\"><ms-widget-front class=\"white-bg\"><md-subheader class=\"white-bg\"><md-icon \nmd-font-icon=\"icon-account\" \\></md-icon>Set Register Number</md-subheader><div \nclass=\"pt-20 pb-20 pl-20 pr-20 csm-coverage\" layout=\"column\" layout-align=\"center\"><div layout=\"row\"><span \nclass=\"h4 secondary-text text-truncate\">Name</span> <span class=\"h4 ml-8\">: {{lsd.name}}</span></div><div layout=\"row\">\n<span class=\"h4 secondary-text text-truncate\">Place Of Birth</span> <span class=\"h4 ml-8\">: {{lsd.placeOfBirth}}</span>\n</div><div layout=\"row\"><span class=\"h4 secondary-text text-truncate\">Date Of Birth</span> <span class=\"h4 ml-8\">\n: {{lsd.dateOfBirth}}</span></div><div layout=\"row\"><span class=\"h4 secondary-text text-truncate\">Relation</span> <span\n class=\"h4 ml-8\">: {{lsd.member_type}}</span></div><div layout=\"row\"><span class=\"h4 secondary-text text-truncate\">\nMaternity</span> <span class=\"h4 ml-8\">: {{lsd.maternity}}</span></div></div></ms-widget-front></ms-widget></div>\n</md-tab><md-tab label=\"Benefit Usage\"><ms-widget flippable=\"false\" layout=\"row\" flex><ms-widget-front \nclass=\"white-bg\"><table class=\"simple\" ms-responsive-table border=\"1\" \nstyle=\"border-collapse: collapse; border-color:#e2e2e2\"><thead><tr><th class=\"text-center\" rowspan=\"2\">Member Name</th>\n<th class=\"text-center\" colspan=\"3\">Inpatient</th><th class=\"text-center\" colspan=\"3\">Outpatient</th><th \nclass=\"text-center\" colspan=\"3\">Dental</th><th class=\"text-center\" colspan=\"3\">Glasses</th></tr><tr><th \nclass=\"text-center\">Benefit</th><th class=\"text-center\">Usage</th><th class=\"text-center\">Residual</th><th \nclass=\"text-center\">Benefit</th><th class=\"text-center\">Usage</th><th class=\"text-center\">Residual</th><th \nclass=\"text-center\">Benefit</th><th class=\"text-center\">Usage</th><th class=\"text-center\">Residual</th><th \nclass=\"text-center\">Benefit</th><th class=\"text-center\">Usage</th><th class=\"text-center\">Residual</th></tr></thead>\n<tbody><tr ng-repeat=\"lsd in vm.claimRelationList\"><td class=\"name\">{{lsd.name}}</td><td class=\"name\">\n{{vm.planAnnualInpatientClaims | currency:\'Rp. \':0}}</td><td class=\"name\">{{lsd.residualIP | currency:\'Rp. \':0}}</td>\n<td class=\"name\">{{vm.planAnnualInpatientClaims - lsd.residualIP | currency:\'Rp. \':0}}</td><td class=\"name\">\n{{vm.planAnnualOutpatientClaims|currency:\'Rp. \':0}}</td><td class=\"name\">{{lsd.residualOP |currency:\'Rp. \':0}}</td><td \nclass=\"name\">{{vm.planAnnualOutpatientClaims - lsd.residualOP |currency:\'Rp. \':0}}</td><td class=\"name\">\n{{vm.planAnnualDentalClaims|currency:\'Rp. \':0}}</td><td class=\"name\">{{lsd.residualDE |currency:\'Rp. \':0}}</td><td \nclass=\"name\">{{vm.planAnnualDentalClaims - lsd.residualDE |currency:\'Rp. \':0}}</td><td class=\"name\">\n{{vm.planEyeglassesAnualClaims|currency:\'Rp. \':0}}</td><td class=\"name\">{{lsd.residualGL |currency:\'Rp. \':0}}</td><td \nclass=\"name\">{{vm.planEyeglassesAnualClaims - lsd.residualGL |currency:\'Rp. \':0}}</td></tr></tbody></table>\n</ms-widget-front></ms-widget></md-tab></md-tabs></div></div></div><div class=\"widget-group\" layout=\"row\" flex \nlayout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex><ms-widget-front class=\"md-white-bg\"><md-subheader \nclass=\"white-bg\"><div class=\"h3\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon>My Claim</div></md-subheader>\n<div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Start Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div \nng-messages=\"frmInsurance.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.end_date\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option \nng-repeat=\"ls in vm.listStatus\" placeholder=\"Status\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container>\n<md-input-container layout=\"column\" layout-align=\"right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></md-input-container></div></form></div>\n</div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.insurance_emp-claim_input\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Submit</span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ui-sref=\"app.insurance_emp-claim_input\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">New Claim</md-tooltip>Submit</md-button></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\"></md-icon></span>\n</th><th><div class=\"table-header\"><span class=\"column-title\">NIK</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Claimer Name</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">Relation</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Claim Type</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Submit Date</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Status\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Detail</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.detail(ls.id)\"><td><md-icon ng-if=\"ls.loComment > 0 \" \nmd-font-icon=\"icon-alert-circle\" \nclass=\"is-important red-600-fg ng-scope sm-default-theme sm-font material-icons icon-alert-circle\" role=\"img\" \naria-label=\"icon-alert-circle\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nYou have new comment from LO.!</md-tooltip></md-icon><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"Open kpi menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.detail(ls)\"><div layout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p \nflex>View Detail</p></div></md-button></md-menu-item></md-menu-content></md-menu></td><td>{{ ls.nik }}</td><td>\n{{ ls.empName }}</td><td>{{ ls.memberName }}</td><td>{{ ls.member_relation }}</td><td>{{ ls.typeClaim }}</td><td>\n{{ ls.receipt_date }}</td><td>{{ ls.submit_date }}</td><td>{{ ls.status }}</td><td><md-button \nclass=\"md-button md-ink-ripple\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.detail(ls.id)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Show Detail Claim</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-file-document-box material-icons\"></md-icon>Detail</md-button>\n<md-button class=\"md-icon-button\" aria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.progress(ls)\"><md-icon md-font-icon=\"icon-cube-unfolded\" class=\"green-500-fg\"></md-icon><md-tooltip><span>\nShow Progress Claim</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Favorite\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.timeLine($event,ls.id)\"><md-icon md-font-icon=\"icon-paw\" \nclass=\"cyan-500-fg\"></md-icon><md-tooltip><span>Time Line</span></md-tooltip></md-button><span \nng-if=\"ls.status == \'waiting\'\"><md-button class=\"md-button md-ink-ripple\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.editData(ls.id)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Edit Claim\n</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-pencil material-icons\"></md-icon>Edit\n</md-button></span></td></tr></tbody></table><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></ms-widget-front>\n</ms-widget></div></div></md-content></div>");
$templateCache.put("app/main/insurance/emp-claim/emp-claim-view-doc.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\nDocument Detail - {{vm.name}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><iframe \nsrc=\"{{vm.url}}\" style=\"width:100%; height:70vh\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><img style=\"margin: auto; max-width: 100%\" alt=\"Lush mango tree\" \nsrc=\"api/insurancedocument/{{vm.doc}}\"></md-dialog-content></md-dialog>");
$templateCache.put("app/main/insurance/emp-claim/emp-claim.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Employe claim list</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\">\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" class=\"mt-30\"><md-input-container flex=\"20\"><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div \nng-messages=\"frmInsurance.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex=\"20\"><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.end_date\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-input-container flex=\"20\"><md-select ng-model=\"vm.status\" name=\"status\"><md-option\n ng-repeat=\"ls in vm.listStatus\" placeholder=\"Status\" value=\"{{ls}}\">{{ls}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"30\"><input type=\"text\" placeholder=\"NIK / Name\" ng-model=\"vm.nik\" \nid=\"formSearch\"></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon\n class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">\nSearch</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.acceptList()\" ng-if=\"vm.group == 133 \"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon><span>Accept</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.rejectList()\" \nng-if=\"vm.group == 133 \"><i class=\"icon-delete\"></i> <span>Reject</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.acceptList()\" ng-if=\"vm.group == 133 \"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Accept</span></md-button><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.rejectList()\" \nng-if=\"vm.group == 133 \"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions\n</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span>\nReject</span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th width=\"5%\"></th><th width=\"5%\"><div class=\"table-header\"></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">NIK</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Name</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title\">Claimer Name</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Relation</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Claim Type</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Receipt Date\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Submit Date</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.detail(ls.id)\"><td><md-icon ng-if=\"ls.userComment > 0 \" md-font-icon=\"icon-alert-circle\" \nclass=\"is-important red-600-fg ng-scope sm-default-theme sm-font material-icons icon-alert-circle\" role=\"img\" \naria-label=\"icon-alert-circle\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nYou have new comment from User.!</md-tooltip></md-icon><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"Open kpi menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.detail(ls.id)\"><div layout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-file-document-box\">\n</md-icon><p flex>View Detail</p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.progress(ls)\">\n<div layout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-cube-unfolded\"></md-icon><p flex>View Progress\n</p></div></md-button></md-menu-item></md-menu-content></md-menu></td><td><span ng-if=\"ls.status == \'waiting\' \"><input \ntype=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\"></span></td><td>{{ ls.nik }}</td><td>\n{{ ls.empName}}</td><td>{{ ls.memberName}}</td><td>{{ ls.member_relation}}</td><td>{{ ls.typeClaim}}</td><td>\n{{ ls.receipt_date}}</td><td>{{ ls.submit_date}}</td><td>{{ ls.status}}</td><td><section layout=\"row\" \nlayout-sm=\"column\" layout-align=\"start center\" layout-wrap><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.detail(ls.id)\"><md-icon md-font-icon=\"icon-file-document-box\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>Show Detail Claim</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.progress(ls)\">\n<md-icon md-font-icon=\"icon-cube-unfolded\" class=\"green-500-fg\"></md-icon><md-tooltip><span>Show Progress Claim</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Favorite\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.timeLine($event,ls.id)\"><md-icon md-font-icon=\"icon-paw\" \nclass=\"cyan-500-fg\"></md-icon><md-tooltip><span>Time Line</span></md-tooltip></md-button></section></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/emp-claim/input-emp-claim.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Input Claim</md-subheader><form name=\"formInput\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInput)\"><div layout-xs=\"column\" layout=\"row\" class=\"m-10\"><div layout=\"column\" \nflex-gt-sm=\"65\" flex class=\"form-wrapper md-whiteframe-1dp\"><h2>Input Claim</h2><div layout-xs=\"column\" \nlayout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\"><md-input-container flex-gt-sm=\"30\" \nflex><input type=\"text\" name=\"nik\" ng-model=\"vm.Form.objForm.nik\" placeholder=\"NIK\" ng-readonly=\"true\">\n</md-input-container><md-input-container flex-gt-sm=\"70\" flex><input type=\"text\" name=\"nama\" \nng-model=\"vm.Form.objForm.empName\" placeholder=\"Nama\" ng-readonly=\"true\"></md-input-container></div><div \nlayout-xs=\"column\" layout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"30\" flex><md-datepicker \nng-model=\"vm.Form.objForm.receipt_date\" placeholder=\"Receipt Date\" md-hide-icons=\"calendar\" name=\"receipt_date\" \nrequired></md-datepicker><div ng-messages=\"formInput.receipt_date.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>receipt date is required.</span></div></div></md-input-container><md-input-container flex-gt-sm=\"70\" flex>\n<md-select ng-model=\"vm.Form.objForm.emp_insurance_detail_id\" name=\"emp_insurance_detail_id\" required><md-option \nng-repeat=\"ls in vm.claimRelationList\" placeholder=\"Insurance Member\" value=\"{{ls.id}}\">{{ls.name}}</md-option>\n</md-select><div ng-messages=\"formInput.emp_insurance_detail_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\ninsurance member is required.</span></div></div></md-input-container></div><div layout-xs=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex-gt-sm=\"45\" flex><md-select ng-model=\"vm.Form.objForm.claim_type_id\" name=\"claim_type_id\" \nng-change=\"vm.loadClaimTypeDetail(vm.Form.objForm.claim_type_id)\" required><md-option \nng-repeat=\"ls in vm.claimTypeList\" placeholder=\"Claim Type\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"formInput.claim_type_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nclaim type is required.</span></div></div></md-input-container><md-input-container flex-gt-sm=\"55\" flex><md-select \nng-model=\"vm.Form.objForm.claim_type_detail\" name=\"claim_type_detail\" required><md-option \nng-repeat=\"ls in vm.claimTypeDetailList\" placeholder=\"Claim Type Detail\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"formInput.claim_type_detail.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>claim type detail is required.</span></div></div></md-input-container></div><div layout-xs=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"40\" flex><md-select ng-model=\"vm.Form.objForm.currency\" \nname=\"currency required\"><md-option ng-repeat=\"ls in vm.countryList\" placeholder=\"Currency\" \nvalue=\"{{ls.name}} ( {{ls.currency}} )\">{{ls.name}} ( {{ls.currency}} )</md-option></md-select><div \nng-messages=\"formInput.currency.$error\" role=\"alert\"><div ng-message=\"required\"><span>currency is required.</span>\n</div></div></md-input-container><md-input-container flex-gt-sm=\"30\" flex><input type=\"text\" name=\"amount\" \nng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div ng-messages=\"formInput.amount.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>amount is required.</span></div></div></md-input-container></div></div>\n<div layout=\"column\" flex-gt-sm=\"35\" flex class=\"form-wrapper md-whiteframe-1dp\"><h2>Insurance Documents</h2><div \nlayout=\"row\" flex><md-dialog-content class=\"white-bg\" id=\"dialogContent_56\"><md-content layout=\"column\" \nclass=\"_md layout-column md-nabati1-theme\"><div layout-gt-sm=\"column\" class=\"layout-gt-sm-column\"><md-input-container \nclass=\"md-nabati1-theme\"><input type=\"file\" nv-file-select=\"\" uploader=\"vm.uploader\" multiple=\"multiple\" \noptions=\"{ formData: [{ \n                                            insuranceMember:vm.Form.objForm.emp_insurance_detail_id,\n                                            nik:vm.Form.objForm.nik, \n                                            submitDate:(vm.Form.objForm.submit_date|date:\'yyyy-MM-dd\')\n                                          }]}\">\n<div class=\"md-errors-spacer\"></div></md-input-container></div><md-progress-linear md-mode=\"determinate\" value=\"0\" \nclass=\"md-accent hue-2 md-nabati1-theme\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" aria-valuenow=\"0\">\n<div class=\"md-container md-mode-determinate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\" style=\"transform: translateX(-50%) scale(0, 1)\"></div></div></md-progress-linear></md-content>\n</md-dialog-content><section layout=\"row\" layout-sm=\"column\" layout-align=\"start center\" layout-wrap><md-button \nclass=\"md-icon-button\" aria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.uploader.clearQueue()\"><md-icon md-font-icon=\"icon-window-close\" class=\"red-500-fg\"></md-icon><md-tooltip>\n<span>click for Remove All</span></md-tooltip></md-button></section></div><div layout=\"row\" flex><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"80%\">Name</th><th width=\"20%\">\nAction</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.Form.objForm.docs\"><td><span \nstyle=\"font-size: 12px !important; font-weight: inherit !important\">{{ ls.name }}</span></td><td><section layout=\"row\" \nlayout-sm=\"column\" layout-align=\"start center\" layout-wrap><md-button class=\"md-icon-button text-center\" \naria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.hapusDocs(ls.doc_location)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip><span>click for Remove</span></md-tooltip>\n</md-button></section></td></tr><tr ng-repeat=\"item in vm.uploader.queue\"><td><strong>{{ item.file.name }}</strong>\n</td><td><section layout=\"row\" layout-sm=\"column\" layout-align=\"start center\" layout-wrap><md-button \nclass=\"md-icon-button\" aria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"item.remove()\">\n<md-icon md-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip><span>click for remove</span></md-tooltip>\n</md-button></section></td></tr></tbody></table></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-md=\"column\" layout-align=\"center center\" flex><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" ng-disabled=\"formInput.$invalid || basicForm.$pristine\">\nSubmit</md-button><md-button type=\"button\" ui-sref=\"app.insurance_emp-claim_listEmploye\" \nclass=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Reload\">Back</md-button></div></div></div></form></div>\n</md-content></div>");
$templateCache.put("app/main/insurance/insurance-plan/detail.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Insurance Plan Detail</md-subheader><div class=\"white-bg\"><md-content class=\"has-plan-header\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-book\" \\></md-icon><span>Plan Header</span></div><div><input type=\"hidden\" name=\"id\" \nng-model=\"vm.Form.objForm.id\"><div layout-sm=\"column\" layout=\"row\" layout-align=\"start center\" layout-padding><div \nflex=\"30\"><div class=\"md-subhead\"><strong>Plan</strong></div><div class=\"info\">{{vm.Form.objForm.description}}</div>\n</div><div flex=\"20\"><div class=\"md-subhead\"><strong>Grade</strong></div><div class=\"info\">{{vm.Form.objForm.grade}}\n</div></div></div><md-divider></md-divider><div class=\"md-subhead mt-20 ml-15\">Benefit</div><div layout-sm=\"column\" \nlayout=\"row\" layout-align=\"start center\" layout-padding><div flex=\"20\"><div class=\"md-subhead\"><strong>\nInpatient Benefit</strong></div><div class=\"info\">{{vm.Form.objForm.annual_inpatient_claims|currency:\'Rp. \':0}}</div>\n</div><div flex=\"20\"><div class=\"md-subhead\"><strong>Outpatient Benefit</strong></div><div class=\"info\">\n{{vm.Form.objForm.annual_outpatient_claims|currency:\'Rp. \':0}}</div></div><div flex=\"20\"><div class=\"md-subhead\">\n<strong>Dental Benefit</strong></div><div class=\"info\">{{vm.Form.objForm.annual_dental_claims|currency:\'Rp. \':0}}</div>\n</div><div flex=\"20\"><div class=\"md-subhead\"><strong>Eyeglasses Benefit</strong></div><div class=\"info\">\n{{vm.Form.objForm.eyeglasses_anual_claims|currency:\'Rp. \':0}}</div></div><div flex=\"20\"><div class=\"md-subhead\">\n<strong>MCU Benefit</strong></div><div class=\"info\">{{vm.Form.objForm.annual_mcu_claims|currency:\'Rp. \':0}}</div></div>\n</div></div></form></div></div></md-content><md-toolbars class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools has-md-toolbars\"><md-button class=\"md-button md-ink-ripple\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputDetail($event,vm.Form.objForm.id)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Add Detail Plan</md-tooltip><md-icon md-font-icon=\"icon-playlist-plus\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New Detail</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputPremi($event,vm.Form.objForm.id)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Add Plan Premi</md-tooltip><md-icon md-font-icon=\"icon-bookmark-plus\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New Premi</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" \ntype=\"button\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.deletePlanDetail()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Delete Detail Plan</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Delete Detail</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" \ntype=\"button\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.deletePremi()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Delete Plan Premi</md-tooltip><md-icon md-font-icon=\"icon-delete-variant\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Delete Premi</md-button></div></md-toolbars><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div class=\"md-title\">Plan Detail</div><table \nclass=\"simple bordered\" ms-responsive-table><thead><tr><th width=\"5%\"><div class=\"table-header\"></div></th><th \nclass=\"secondary-text\" flex=\"60\"><div class=\"table-header\"><span class=\"column-title\">Benefit Name</span></div></th><th\n class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">Appropriately</span></div></th>\n<th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">Up Room Class</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"lsd in vm.Form.objForm.detail\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listPlanDetailSelected\" checklist-value=\"lsd\"></td><td class=\"text-center\">{{lsd.benefit}}</td><td \nclass=\"text-center\">{{lsd.appropriately}}</td><td class=\"text-center\">{{lsd.up_room_class}}</td></tr></tbody></table>\n<div class=\"md-title\">Plan Premi</div><table class=\"simple bordered\" ms-responsive-table><thead><tr><th width=\"5%\"><div\n class=\"table-header\"></div></th><th class=\"secondary-text\" flex><div class=\"table-header\"><span class=\"column-title\">\nBenefit Code</span></div></th><th class=\"secondary-text\" flex><div class=\"table-header\"><span class=\"column-title\">\nRelation</span></div></th><th class=\"secondary-text\" flex><div class=\"table-header\"><span class=\"column-title\">Gender\n</span></div></th><th class=\"secondary-text\" flex><div class=\"table-header\"><span class=\"column-title\">Premi</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"lsd in vm.Form.objForm.premi\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listPlanPremiSelected\" checklist-value=\"lsd\"></td><td class=\"text-center\">\n{{lsd.benefit_code}}</td><td class=\"text-center\">{{lsd.relation}}</td><td class=\"text-center\">{{lsd.gender}}</td><td \nclass=\"text-center\">{{lsd.premi |currency:\'Rp. \':0}}</td></tr></tbody></table><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"end center\"><md-button type=\"button\" ui-sref=\"app.insurance_insurance-plan_list\" \nclass=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Reload\">Back</md-button></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/insurance/insurance-plan/input-detail.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"detailTypeForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,detailTypeForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Detail Plan</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\"> <input \ntype=\"hidden\" name=\"insurance_type_id\" ng-model=\"vm.Form.objForm.insurance_type_id\"><md-input-container flex><input \ntype=\"text\" name=\"benefit\" ng-model=\"vm.Form.objForm.benefit\" placeholder=\"Benefit\" required><div \nng-messages=\"detailTypeForm.benefit.$error\" role=\"alert\"><div ng-message=\"required\"><span>Benefit is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"appropriately\" ng-model=\"vm.Form.objForm.appropriately\" placeholder=\"Appropriately\" required><div \nng-messages=\"detailTypeForm.appropriately.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAppropriately is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"up_room_class\" ng-model=\"vm.Form.objForm.up_room_class\" placeholder=\"Up room class\" required><div \nng-messages=\"detailTypeForm.up_room_class.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nUp room class is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"detailTypeForm.$invalid || detailTypeForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/insurance/insurance-plan/input-premi.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"myForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,myForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Premi</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\"><md-input-container flex=\"50\"><label>\nRelation</label><md-select ng-model=\"vm.Form.objForm.relation\" ng-required=\"true\" name=\"relation\"><md-option \nvalue=\"Karyawan\">Employee</md-option><md-option value=\"Suami\">Husband</md-option><md-option value=\"Istri\">Wife\n</md-option><md-option value=\"Anak\">Child</md-option></md-select><div ng-messages=\"myForm.relation.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Relation Required.</span></div></div></md-input-container>\n<md-input-container flex=\"50\" ng-if=\"vm.Form.objForm.relation == \'Karyawan\'\"><label>Gender</label><md-select \nng-model=\"vm.Form.objForm.gender\" name=\"gender\"><md-option value=\"L\">Male</md-option><md-option value=\"P\">Female\n</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Benefit Type\n</label><md-select ng-model=\"vm.Form.objForm.benefitCode\" ng-required=\"true\" name=\"benefitCode\"><md-option value=\"ip\">\nInpatient</md-option><md-option value=\"op\">Outpatient</md-option><md-option value=\"de\">Dental</md-option><md-option \nvalue=\"ma\" ng-if=\" vm.Form.objForm.gender == \'P\' || vm.Form.objForm.relation == \'Istri\' \">Maternity</md-option>\n<md-option value=\"gl\" ng-if=\"vm.Form.objForm.relation == \'Karyawan\' \">Glasses</md-option></md-select><div \nng-messages=\"myForm.benefitCode.$error\" role=\"alert\"><div ng-message=\"required\"><span>Benefit Type Required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"number\" name=\"premi\" \nng-model=\"vm.Form.objForm.premi\" placeholder=\"Premi\" required><div ng-messages=\"myForm.premi.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Premi is required.</span></div><div ng-message=\"number\"><span>\noutpatient benefit must be number.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front red-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"myForm.$invalid || myForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insurance/insurance-plan/input.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">From Insurance Plan</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><form name=\"formInputInsurance\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputInsurance)\"><div flex=\"25\"><div class=\"md-headlines\"><strong>Description</strong></div>\n</div><div layout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\"><md-input-container flex>\n<input type=\"text\" name=\"plan\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Plan\" required><div \nng-messages=\"formInputInsurance.plan.$error\" role=\"alert\"><div ng-message=\"required\"><span>plan is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"grade\" \nng-model=\"vm.Form.objForm.grade\" placeholder=\"Grade\" required><div ng-messages=\"formInputInsurance.grade.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>plan is required.</span></div></div></md-input-container></div><div \nflex=\"25\"><div class=\"md-headlines\"><strong>Benefits</strong></div></div><div layout-gt-sm=\"row\"><md-input-container \nflex><input type=\"number\" name=\"annual_outpatient_claims\" ng-model=\"vm.Form.objForm.annual_outpatient_claims\" \nplaceholder=\"Outpatient Benefit\" required><div ng-messages=\"formInputInsurance.annual_outpatient_claims.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>outpatient benefit is required.</span></div><div ng-message=\"number\">\n<span>outpatient benefit must be number.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"annual_inpatient_claims\" ng-model=\"vm.Form.objForm.annual_inpatient_claims\" \nplaceholder=\"Inpatient Benefit\" required><div ng-messages=\"formInputInsurance.annual_inpatient_claims.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>inpatient benefit is required.</span></div><div ng-message=\"number\">\n<span>inpatient benefit must be number.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"annual_dental_claims\" ng-model=\"vm.Form.objForm.annual_dental_claims\" placeholder=\"Dental Benefit\" \nrequired><div ng-messages=\"formInputInsurance.annual_dental_claims.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>dental benefit is required.</span></div><div ng-message=\"number\"><span>dental benefit must be number.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"number\" name=\"eyeglasses_anual_claims\" \nng-model=\"vm.Form.objForm.eyeglasses_anual_claims\" placeholder=\"Eyeglasses Benefit\" required><div \nng-messages=\"formInputInsurance.eyeglasses_anual_claims.$error\" role=\"alert\"><div ng-message=\"required\"><span>\neyeglasses benefit is required.</span></div><div ng-message=\"number\"><span>eyeglasses benefit must be number.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"number\" name=\"annual_mcu_claims\" \nng-model=\"vm.Form.objForm.annual_mcu_claims\" placeholder=\"MCU Benefit\"><div \nng-messages=\"formInputInsurance.annual_mcu_claims.$error\" role=\"alert\"><div ng-message=\"number\"><span>\nmcu benefit must be number.</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInputInsurance.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"button\" \nui-sref=\"app.insurance_insurance-plan_list\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Reload\">Back\n</md-button></div></form></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/insurance-plan/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">List Plan</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.insurance_insurance-plan_input\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">New List\n</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>New\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" \ntype=\"button\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.deleteList()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Delete List</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"3%\"><div class=\"table-header\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></div></th><th width=\"10%\"><div \nclass=\"table-header text-left\"><span class=\"column-title\">Description</span></div></th><th><div \nclass=\"table-header text-left\"><span class=\"column-title\">Out Patient Benefit</span></div></th><th><div \nclass=\"table-header text-left\"><span class=\"column-title\">In Patient Benefit</span></div></th><th><div \nclass=\"table-header text-left\"><span class=\"column-title\">Dental Benefit</span></div></th><th><div \nclass=\"table-header text-left\"><span class=\"column-title\">Eyeglasses Benefit</span></div></th><th><div \nclass=\"table-header text-left\"><span class=\"column-title\">MCU Benefit</span></div></th><th width=\"5%\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.detail(ls.id)\"><td><md-menu md-position-mode=\"target-right target\">\n<md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.detail(ls.id)\"><div layout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-eye\">\n</md-icon><p flex>View Detail</p></div></md-button></md-menu-item></md-menu-content></md-menu></td><td><input \ntype=\"checkbox\" checklist-model=\"vm.listPlanSelected\" checklist-value=\"ls\"></td><td>{{ ls.description }}</td><td>\n{{ ls.annual_outpatient_claims | currency:\"Rp. \":0}}</td><td>{{ ls.annual_inpatient_claims | currency:\"Rp. \":0}}</td>\n<td>{{ ls.annual_dental_claims | currency:\"Rp. \":0}}</td><td>{{ ls.eyeglasses_anual_claims | currency:\"Rp. \":0}}</td>\n<td>{{ ls.annual_mcu_claims | currency:\"Rp. \":0}}</td><td class=\"text-center\"><section layout-align=\"start center\">\n<md-button class=\"md-icon-button\" aria-label=\"Favorite\" style=\"padding: 0;height: 24px\" ng-click=\"vm.editData(ls.id)\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"orange-500-fg\"></md-icon><md-tooltip><span>Edit Plan</span></md-tooltip>\n</md-button></section></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/insurance-type/input-insurance-type-detail.html","<md-dialog aria-label=\"Uplaod\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"detailTypeForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,detailTypeForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Detail Type</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\"> <input \ntype=\"hidden\" name=\"insurance_claim_type_id\" ng-model=\"vm.Form.objForm.insurance_claim_type_id\"><md-input-container \nflex><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required>\n<div ng-messages=\"detailTypeForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Benefit is required.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"detailTypeForm.$invalid || detailTypeForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/insurance/insurance-type/input-insurance-type.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Form Type Insurance</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><form name=\"formInput\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInput)\"><div layout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" \nng-model=\"vm.Form.objForm.id\"><md-input-container flex><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"description\" required><div \nng-messages=\"formInput.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>description is required.\n</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" ng-disabled=\"formInput.$invalid || basicForm.$pristine\">\nSubmit</md-button><md-button type=\"button\" ui-sref=\"app.insurance_insurance-type_list\" \nclass=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Reload\">Back</md-button></div></form></md-content></div>\n</div></md-content></div>");
$templateCache.put("app/main/insurance/insurance-type/insurance-type-detail.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Type Insurance Detail</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm \ntype=\"button\" hide show-gt-sm type=\"button\" ng-click=\"vm.inputDetail($event,vm.Form.objForm.id)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">New Type Detail</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>New</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.deletePlanDetail()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nDelete Type Detail</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon><span>Delete</span></md-button></div></md-toolbar><div layout=\"row\" layout-align=\"center center\" \nclass=\"mt-20\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"65\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"60\"><h2>\nType Header</h2><div layout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\">\n<md-input-container flex=\"50\"><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" \nplaceholder=\"Type Description\" ng-disabled=\"true\"></md-input-container></div></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"65\" flex-sm=\"90\" flex-xs=\"100\" \nflex-md=\"60\"><h2>Type Detail</h2><div layout=\"column\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"5%\"><div class=\"table-header\"></div></th><th class=\"secondary-text\" \nflex=\"95%\"><div class=\"table-header\"><span class=\"column-title\">Benefit Name</span></div></th></tr></thead><tbody><tr \nng-repeat=\"lsd in vm.Form.objForm.detail\"><td><input type=\"checkbox\" checklist-model=\"vm.listDetailSelected\" \nchecklist-value=\"lsd\"></td><td>{{lsd.description}}</td></tr></tbody></table></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-button type=\"button\" ui-sref=\"app.insurance_insurance-type_list\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\">Back</md-button></div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/insurance/insurance-type/insurance-type.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">List Type</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" hide show-gt-sm type=\"button\" \nui-sref=\"app.insurance_insurance-type_input\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">New List Type\n</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><spa>New\n</spa></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" ng-click=\"vm.deleteList()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Reject</md-tooltip><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span>Reject</span>\n</md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"1%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon>\n</span></th><th width=\"2%\"><div class=\"table-header\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\>\n</md-icon></span></div></th><th class=\"text-left\" width=\"75%\"><div class=\"table-header\"><span class=\"column-title\">\nDescription</span></div></th><th width=\"10%\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.detail(ls.id)\"><td><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.detail(ls.id)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex>View Detail</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></td><td><input type=\"checkbox\" checklist-model=\"vm.listTypeSelected\" checklist-value=\"ls\">\n</td><td>{{ ls.description }}</td><td class=\"text-center\"><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" \nhide show-gt-sm type=\"button\" ng-click=\"vm.editData(ls.id)\" aria-label=\"edit\" style=\"margin: auto\">Edit</md-button>\n</td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/endorsment/deactive.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"30\" md-theme=\"modal-theme\"><form \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Form Effective Date</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\"><div class=\"form-wrapper\"><div layout=\"column\" layout=\"row\"><md-input-container \nflex=\"70\"><md-datepicker ng-model=\"vm.deactiveDate\" placeholder=\"Deactivate Date\" md-icons=\"calendar\" \nname=\"deactiveDate\" md-open-on-focus required></md-datepicker><div ng-messages=\"deactiveDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>effective date is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\"><input type=\"text\" name=\"description\" ng-model=\"vm.description\" placeholder=\"Description\">\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button \nng-click=\"vm.submit()\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\">Submit</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/insurance/endorsment/efective-date.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"30\" md-theme=\"modal-theme\"><form \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Form Effective Date</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\"><div class=\"form-wrapper\"><div layout=\"column\" layout=\"row\"><md-input-container \nflex=\"70\"><md-datepicker ng-model=\"vm.effectiveDate\" placeholder=\"Effective Date\" md-icons=\"calendar\" \nname=\"effectiveDate\" md-open-on-focus required></md-datepicker><div ng-messages=\"effectiveDate.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>effective date is required.</span></div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button \nng-click=\"vm.submit()\" class=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\">Submit</md-button>\n</div></md-dialog-actions></form></md-dialog><pre>{{vm.listSelected | json}}</pre>");
$templateCache.put("app/main/insurance/endorsment/endorsment-deactive.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Deactive Member</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\">\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" placeholder=\"NIK / Name\" ng-model=\"vm.nik\" id=\"formSearch\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\" ng-click=\"vm.loadData()\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span>Search</span></md-button></div>\n</form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.acceptList($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-account-remove\" class=\"md-font icon-archive material-icons\"></md-icon><span>Deactive</span>\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th><div class=\"table-header\"><span class=\"column-title\">NIK\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Member Name</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Register Number</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">\nEffective Date</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Plafon/ Plan</span></div></th>\n<th><div class=\"table-header\"><span class=\"column-title\">Gender</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Date of Birth</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Relation\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.data\"><td><ng-switch on=\"ls.bankAccount\"><div \nng-switch-when=\"\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\" disabled=\"disabled\">\n<md-tooltip md-direction=\"up\" md-visible=\"tooltipVisible\">you can\'t check if bank account is empty</md-tooltip></div>\n<div ng-switch-default><input type=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\"></div></ng-switch>\n</td><td>{{ ls.nik }}</td><td>{{ ls.empName}}</td><td>{{ ls.memberName}}</td><td>{{ ls.no_register}}</td><td>\n{{ ls.effective_date}}</td><td>{{ ls.plan}}</td><td>{{ ls.gender}}</td><td>{{ ls.dateOfBirth}}</td><td>{{ ls.relation}}\n</td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/endorsment/endorsment-edit.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati7\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon></span><span class=\"md-title\">\nDEACTIVE MEMBER</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div class=\"content\"><div class=\"simple-table-container\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" \nflex><div class=\"form-wrapper md-cyan-50-bg\"><form name=\"frmInsurance\" class=\"md-inline-form\" \nng-submit=\"vm.loadData()\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\"><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" placeholder=\"NIK / Name\" ng-model=\"vm.nik\" id=\"formSearch\"></md-input-container><md-input-container \nlayout=\"column\" layout-align=\"right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData()\" \nclass=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon>Search</md-button></md-input-container></div></form></div></div></md-content><div \nclass=\"attview\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.effectiveDate()\"><md-tooltip md-direction=\"up\" \nmd-visible=\"tooltipVisible\">Set Effective Date</md-tooltip><md-icon md-font-icon=\"icon-calendar-multiple\" \nclass=\"md-font icon-account-remove material-icons\"></md-icon>Effective Date</md-button></div><table \nclass=\"simple stripped condensed\" ms-responsive-table style=\"margin-top:0\"><thead><tr><th width=\"5%\"></th><th \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th><div class=\"table-header\"><span class=\"column-title\">NIK\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Member Name</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Register Number</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">\nEffective Date</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Plafon/ Plan</span></div></th>\n<th><div class=\"table-header\"><span class=\"column-title\">Gender</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Date of Birth</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Relation\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.data\"><td><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.detail(ls.id)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex>View Detail</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></td><td><ng-switch on=\"ls.bankAccount\"><div ng-switch-when=\"\"><input type=\"checkbox\" \nchecklist-model=\"vm.listSelected\" checklist-value=\"ls\" disabled=\"disabled\"><md-tooltip md-direction=\"up\" \nmd-visible=\"tooltipVisible\">you can\'t check if bank account is empty</md-tooltip></div><div ng-switch-default><input \ntype=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\"></div></ng-switch></td><td>{{ ls.nik }}</td><td>\n{{ ls.empName}}</td><td>{{ ls.plan}}</td><td>{{ ls.no_register}}</td><td>{{ ls.effective_date}}</td><td>\n{{ ls.memberName}}</td><td>{{ ls.gender}}</td><td>{{ ls.dateOfBirth}}</td><td>{{ ls.relation}}</td></tr></tbody>\n</table></md-toolbars></div></div></div></div></div></div>");
$templateCache.put("app/main/insurance/endorsment/endorsment-employe.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">My Endorsment</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.submit($event)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span>Accept</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.loadData()\"><i \nclass=\"icon-delete\"></i> <span>Refresh</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.submit()\">\n<md-tooltip md-direction=\"up\" md-visible=\"tooltipVisible\"><span>Create Effective Date</span></md-tooltip><span>Accept\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-blue-300-bg md-raised white-fg\" hide show-gt-sm aria-label=\"Refresh\" ng-click=\"vm.loadData()\" type=\"button\">\n<md-tooltip md-direction=\"up\" md-visible=\"tooltipVisible\"><span>Refresh Record</span></md-tooltip><span>Refresh</span>\n</md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><div class=\"table-header\">\n<input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">NIK</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Gender</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title\">Date of Birth</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Grade</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Marital Status</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Relation\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Maternity</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Plafon/ Plan</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Bank Account</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.data\"><td \nclass=\"text-center\"><ng-switch on=\"ls.bankAccount\"><div ng-switch-when=\"\"><input type=\"checkbox\" \nchecklist-model=\"vm.listSelected\" checklist-value=\"ls\" disabled=\"disabled\"><md-tooltip md-direction=\"up\" \nmd-visible=\"tooltipVisible\">you can\'t check if bank account is empty</md-tooltip></div><div ng-switch-default><input \ntype=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\" ng-click=\"vm.checkSelected()\"></div></ng-switch>\n</td><td class=\"text-center\">{{ ls.nik }}</td><td class=\"text-center\">{{ ls.name}}</td><td class=\"text-center\">\n{{ ls.gender}}</td><td class=\"text-center\">{{ ls.birth}}</td><td class=\"text-center\">{{ ls.grade}}</td><td \nclass=\"text-center\">{{ ls.maritalStatus}}</td><td class=\"text-center\">{{ ls.relation}}</td><td class=\"text-center\">\n{{ ls.mater}}</td><td class=\"text-center\">{{ ls.plan}}</td><td class=\"text-center\">{{ ls.bankAccount}}</td></tr>\n</tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/endorsment/endorsment-log.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Log Endorsment</span></md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\">\n<div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\"><md-option ng-repeat=\"ls in vm.listType\" \nplaceholder=\"Type\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-input-container flex><label>\nStart Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" \nmd-open-on-focus=\"true\"></md-datepicker><div ng-messages=\"frmInsurance.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><md-input-container flex>\n<label>End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.end_date\" \nmd-open-on-focus=\"true\"></md-datepicker><div ng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><md-button type=\"button\" \naria-label=\"search\" class=\"md-mini md-raised md-primary\" ng-click=\"vm.download()\"><md-icon class=\"icon-download\" \nmd-font-icon=\"icon-download\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span>Download</span></md-button>\n</div></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/endorsment/endorsment-set-register-number.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Set Register Number</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\">\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" placeholder=\"NIK / Name\" ng-model=\"vm.nik\" id=\"formSearch\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"search\" ng-click=\"vm.loadData()\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span>Search\n</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\" vm.uploadNoreg($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.APPROVE\">\nUpload Register Number</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" ng-click=\"vm.downloadFormatNoreg()\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.APPROVE\">Download Format Register Number</span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\" vm.uploadNoreg($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Upload Register Number</span></md-button><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.downloadFormatNoreg()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-download\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Download Format Register Number</span></md-button><span \nflex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th><div class=\"table-header\"><span \nclass=\"column-title\">NIK</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Name</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title\">Member Name</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Register Number</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Effective Date</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">\nPlafon/ Plan</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Gender</span></div></th><th><div\n class=\"table-header\"><span class=\"column-title\">Date of Birth</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Relation</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.data\"><td><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.inputRegisterNumber(ls)\"><div layout=\"row\" flex>\n<md-icon md-menu-align-target md-font-icon=\"icon-account-check\"></md-icon><p flex>Input Register Number</p></div>\n</md-button></md-menu-item></md-menu-content></md-menu></td><td>{{ ls.nik }}</td><td>{{ ls.empName}}</td><td>\n{{ ls.memberName}}</td><td>{{ ls.no_register}}</td><td>{{ ls.effective_date}}</td><td>{{ ls.plan}}</td><td>\n{{ ls.gender}}</td><td>{{ ls.dateOfBirth}}</td><td>{{ ls.relation}}</td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/endorsment/endorsment.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Endorsement List</span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\">\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" placeholder=\"NIK / Name\" ng-model=\"vm.nik\" id=\"formSearch\"></md-input-container><md-button type=\"button\" \nlayout=\"row\" class=\"md-mini md-raised md-primary\" aria-label=\"search\" ng-click=\"vm.loadData()\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon><span>Search\n</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.acceptList()\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span translate=\"ACTION.APPROVE\">Accept\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" \nid=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.acceptList()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions\n</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Accept</span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\">\n<div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">NIK</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\">Name</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Gender</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">Date of Birth</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Grade</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Marital Status</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Relation\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Maternity</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Glasses</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Plafon/ Plan</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">\nBank Account</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.data\"><td><ng-switch on=\"ls.bankAccount\"><div\n ng-switch-when=\"\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\" disabled=\"disabled\">\n<md-tooltip md-direction=\"up\" md-visible=\"tooltipVisible\">you can\'t check if bank account is empty</md-tooltip></div>\n<div ng-switch-default><input type=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\"></div></ng-switch>\n</td><td>{{ ls.nik }}</td><td>{{ ls.name}}</td><td ng-if=\"ls.gender ==\'L\' \">Pria</td><td ng-if=\"ls.gender ==\'P\' \">\nWanita</td><td>{{ ls.birth |date:\'dd/MM/yyyy\'}}</td><td>{{ ls.grade}}</td><td>{{ ls.maritalStatus}}</td><td>\n{{ ls.relation}}</td><td>{{ ls.mater}}</td><td>{{ ls.empGlass}}</td><td>{{ ls.plan}}</td><td>{{ ls.bankAccount}}</td>\n</tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/insurance/endorsment/upload-noreg.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"UploadShiftTemplate\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload Registration Number</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><md-content layout=\"column\"><div \nlayout-gt-sm=\"column\"><md-input-container><input type=\"file\" id=\"uploadPhoto\" name=\"shifttemplate\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\" options=\"{ formData: [{action:\'uploadshifttemplate\'}]}\"></md-input-container></div>\n<md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\">\n</md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload File</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Success Upload File</span>\n</md-whiteframe></md-content></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button \ntype=\"button\" layout-align=\"center end\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\">\n</md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/job-evaluation/form/form-job-evaluation.html","<style>\ntable{\n        width: 100%;\n    }\n    th.dcp{\n        width: 5%;\n    }\n\n    th.fsf{\n        width:15%;\n    }\n\n    th.r{\n        width: 55%;\n    }\n\n    md-input-container{\n        margin-top:5px;\n        margin-bottom:0;\n    }\n\n    input[type=\'text\']{\n        text-align:center;\n    }\n</style><div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div class=\"subhead\">Submit Job Evaluation</div></md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div layout=\"row\" layout-xs=\"column\" \nclass=\"form-wrapper md-whiteframe-4dp pt-10\"><md-input-container flex><md-autocomplete \nmd-selected-item=\"vm.job.business_title\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.description\" md-min-length=\"2\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" placeholder=\"Business Titles\" flex required><md-item-template>\n<span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.code}} - {{item.description}}</span>\n</md-item-template><div ng-messages=\"searchForm.autocompleteField.$error\" \nng-if=\"searchForm.autocompleteField.$touched\"><div ng-message=\"required\">You <b>must</b> have a business titles.</div>\n<div ng-message=\"md-require-match\">Please select an business titles.</div><div ng-message=\"minlength\">\nYour entry is not long enough.</div></div><md-not-found>No business subhead matching \"{{vm.searchText}}\" were found.\n</md-not-found></md-autocomplete></md-input-container><md-input-container class=\"md-block\" flex><input type=\"text\" \nng-disabled=\"true\" ng-model=\"vm.job.evaluation_by\" placeholder=\"Evaluation By\"></md-input-container><md-input-container\n class=\"md-block\" flex><input type=\"text\" ng-disabled=\"true\" ng-model=\"vm.job.evaluation_date\" \nplaceholder=\"Evaluation Date\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"form-wrapper md-whiteframe-4dp\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered\"><thead><tr><th class=\"fsf\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\">Factor</span></div></th><th class=\"fsf\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\">Sub Factor</span></div></th><th class=\"dcp\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\">Degree</span></div></th><th class=\"dcp\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\"></span></div></th><th class=\"dcp\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\">Points</span></div></th><th class=\"r\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\">Remarks</span></div></th></tr></thead><tbody><tr \nng-repeat-start=\"ls in vm.job.factor track by $index\" ng-init=\"idx = $index\"><td rowspan=\"{{(ls.cSubFactor)}}\"><span \nclass=\"md-subhead\">{{ls.description}}</span></td><td><span class=\"md-subhead\">{{ls.subFactor[0].description}}</span>\n</td><td><md-input-container class=\"md-block\"><input type=\"text\" ng-disabled=\"{{ls.subFactor[0].isReadOnly}}\" \nng-model=\"vm.job.factor[idx].subFactor[0].degree\" \nng-keypress=\"vm.degreeConvertion(vm.job.factor[idx].subFactor[0].degree,idx,0, $event)\"></md-input-container></td><td>\n<md-input-container class=\"md-block\"><input type=\"text\" ng-disabled=\"true\" \nng-model=\"vm.job.factor[idx].subFactor[0].convertion\"></md-input-container></td><td rowspan=\"{{(ls.cSubFactor)}}\">\n<md-input-container class=\"md-block\"><input type=\"text\" ng-disabled=\"true\" ng-model=\"vm.job.factor[idx].points\">\n</md-input-container></td><td><md-input-container class=\"md-block\"><textarea \nng-model=\"vm.job.factor[idx].subFactor[0].remarks\" md-maxlength=\" 200\" max-rows=\"5\"></textarea></md-input-container>\n</td></tr><tr ng-repeat=\"lsd in ls.subFactor track by $index\" ng-init=\"dIdx = $index\" ng-if=\"$index >0\"><td><span \nclass=\"md-subhead\">{{lsd.description}}</span></td><td><md-input-container class=\"md-block\"><input type=\"text\" \nng-disabled=\"{{lsd.isReadOnly}}\" value=\"{{lsd.default}}\" ng-model=\"vm.job.factor[idx].subFactor[dIdx].degree\" \nng-keypress=\"vm.degreeConvertion(vm.job.factor[idx].subFactor[dIdx].degree,idx,dIdx, $event)\"></md-input-container>\n</td><td><md-input-container class=\"md-block\"><input type=\"text\" ng-disabled=\"true\" \nng-model=\"vm.job.factor[idx].subFactor[dIdx].convertion\"></md-input-container></td><td><md-input-container \nclass=\"md-block\"><textarea ng-model=\"vm.job.factor[idx].subFactor[dIdx].remarks\" md-maxlength=\"200\" max-rows=\"5\">\n</textarea></md-input-container></td></tr><tr ng-repeat-end></tr><tr><td rowspan=\"3\"><span class=\"md-subhead\">Summary\n</span></td><td colspan=\"2\"><span class=\"md-subhead\">Total Points :</span></td><td colspan=\"3\"><md-input-container \nclass=\"md-block\"><input type=\"text\" ng-model=\"vm.job.total_point\" ng-disabled=\"true\" style=\"text-align:left\">\n</md-input-container></td></tr><tr><td colspan=\"2\"><span class=\"md-subhead\">Position Class :</span></td><td \ncolspan=\"3\"><md-input-container class=\"md-block\"><input type=\"text\" ng-model=\"vm.job.position_class\" \nng-disabled=\"true\" style=\"text-align:left\"></md-input-container></td></tr><tr><td colspan=\"2\"><span class=\"md-subhead\">\nGrade :</span></td><td colspan=\"3\"><md-input-container class=\"md-block\"><input type=\"text\" ng-model=\"vm.job.grade\" \nng-disabled=\"true\" style=\"text-align:left\"></md-input-container></td></tr><tr><td colspan=\"6\"><md-input-container \nclass=\"md-block\"><label>TM Recomendation</label><textarea ng-model=\"vm.job.recomendation\" md-maxlength=\"500\" \nmax-rows=\"5\"></textarea></md-input-container></td></tr></tbody></table></md-content></div><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-md=\"column\" layout-align=\"center center\" flex><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" ng-click=\"vm.saveData()\" \nng-disabled=\"formJV.$invalid || basicForm.$pristine\" ng-show=\"vm.saveButton\">Submit</md-button><md-button \nclass=\"md-yelow-300-bg md-raised white-fg md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-click=\"vm.summaryResult()\" ng-show=\"vm.sumaryButton\">Summary Result</md-button></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/job-evaluation/form/view-job-evaluation.html","<style>\ntable{\n        width: 100%;\n    }\n    th.dcp{\n        width: 5%;\n    }\n\n    th.fsf{\n        width:15%;\n    }\n\n    th.r{\n        width: 55%;\n    }\n\n    md-input-container{\n        margin-top:5px;\n        margin-bottom:0;\n    }\n\n    input[type=\'text\']{\n        text-align:center;\n    }\n</style><div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div class=\"subhead\">Job Evaluation</div></md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div layout=\"row\" layout-xs=\"column\" \nclass=\"form-wrapper md-whiteframe-4dp\"><md-input-container class=\"md-block\" flex><md-autocomplete \nmd-selected-item=\"vm.job.business_title\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.description\" md-min-length=\"3\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" placeholder=\"Business Titles\" flex ng-disabled=\"true\">\n<md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.code}} - {{item.description}}\n</span></md-item-template><div ng-messages=\"searchForm.autocompleteField.$error\" \nng-if=\"searchForm.autocompleteField.$touched\"><div ng-message=\"required\">You <b>must</b> have a business titles.</div>\n<div ng-message=\"md-require-match\">Please select an business titles.</div><div ng-message=\"minlength\">\nYour entry is not long enough.</div></div><md-not-found>No business subhead matching \"{{vm.searchText}}\" were found.\n</md-not-found></md-autocomplete></md-input-container><md-input-container class=\"md-block\" flex><input type=\"text\" \nng-disabled=\"true\" ng-model=\"vm.job.evaluation_by\" placeholder=\"Evaluation By\"></md-input-container><md-input-container\n class=\"md-block\" flex><input type=\"text\" ng-disabled=\"true\" ng-model=\"vm.job.evaluation_date\" \nplaceholder=\"Evaluation Date\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"form-wrapper md-whiteframe-4dp\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered\"><thead><tr><th class=\"fsf\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\">Factor</span></div></th><th class=\"fsf\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\">Sub Factor</span></div></th><th class=\"dcp\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\">Degree</span></div></th><th class=\"dcp\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\"></span></div></th><th class=\"dcp\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\">Points</span></div></th><th class=\"r\"><div class=\"table-header text-center\"><span \nclass=\"column-subhead\">Remarks</span></div></th></tr></thead><tbody><tr \nng-repeat-start=\"ls in vm.job.factor track by $index\" ng-init=\"idx = $index\"><td rowspan=\"{{(ls.cSubFactor)}}\"><span \nclass=\"md-subhead\">{{ls.description}}</span></td><td><span class=\"md-subhead\">{{ls.subFactor[0].description}}</span>\n</td><td><md-input-container class=\"md-block\"><input type=\"text\" ng-disabled=\"true\" \nng-model=\"vm.job.factor[idx].subFactor[0].degree\" \nng-keypress=\"vm.degreeConvertion(vm.job.factor[idx].subFactor[0].degree,idx,0, $event)\"></md-input-container></td><td>\n<md-input-container class=\"md-block\"><input type=\"text\" ng-disabled=\"true\" \nng-model=\"vm.job.factor[idx].subFactor[0].convertion\"></md-input-container></td><td rowspan=\"{{(ls.cSubFactor)}}\">\n<md-input-container class=\"md-block\"><input type=\"text\" ng-disabled=\"true\" ng-model=\"vm.job.factor[idx].points\">\n</md-input-container></td><td><md-input-container class=\"md-block\"><textarea \nng-model=\"vm.job.factor[idx].subFactor[0].remarks\" ng-disabled=\"true\" md-maxlength=\" 200\" max-rows=\"5\"></textarea>\n</md-input-container></td></tr><tr ng-repeat=\"lsd in ls.subFactor track by $index\" ng-init=\"dIdx = $index\" \nng-if=\"$index >0\"><td><span class=\"md-subhead\">{{lsd.description}}</span></td><td><md-input-container class=\"md-block\">\n<input type=\"text\" ng-disabled=\"true\" value=\"{{lsd.default}}\" ng-model=\"vm.job.factor[idx].subFactor[dIdx].degree\" \nng-keypress=\"vm.degreeConvertion(vm.job.factor[idx].subFactor[dIdx].degree,idx,dIdx, $event)\"></md-input-container>\n</td><td><md-input-container class=\"md-block\"><input type=\"text\" ng-disabled=\"true\" \nng-model=\"vm.job.factor[idx].subFactor[dIdx].convertion\"></md-input-container></td><td><md-input-container \nclass=\"md-block\"><textarea ng-model=\"vm.job.factor[idx].subFactor[dIdx].remarks\" ng-disabled=\"true\" md-maxlength=\"200\" \nmax-rows=\"5\"></textarea></md-input-container></td></tr><tr ng-repeat-end></tr><tr><td rowspan=\"3\"><span \nclass=\"md-subhead\">Summary</span></td><td colspan=\"2\"><span class=\"md-subhead\">Total Points :</span></td><td \ncolspan=\"3\"><md-input-container class=\"md-block\"><input type=\"text\" ng-model=\"vm.job.total_point\" ng-disabled=\"true\" \nstyle=\"text-align:left\"></md-input-container></td></tr><tr><td colspan=\"2\"><span class=\"md-subhead\">Position Class :\n</span></td><td colspan=\"3\"><md-input-container class=\"md-block\"><input type=\"text\" ng-model=\"vm.job.position_class\" \nng-disabled=\"true\" style=\"text-align:left\"></md-input-container></td></tr><tr><td colspan=\"2\"><span class=\"md-subhead\">\nGrade :</span></td><td colspan=\"3\"><md-input-container class=\"md-block\"><input type=\"text\" ng-model=\"vm.job.grade\" \nng-disabled=\"true\" style=\"text-align:left\"></md-input-container></td></tr><tr><td colspan=\"6\"><md-input-container \nclass=\"md-block\"><label>TM Recomendation</label><textarea ng-model=\"vm.job.recomendation\" md-maxlength=\"500\" \nmax-rows=\"5\" ng-disable=\"true\"></textarea></md-input-container></td></tr></tbody></table></md-content></div><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-content></div>\n</div></md-content></div>");
$templateCache.put("app/main/lock-transaction/input-lock-transaction/input-lock-transaction.html","<div id=\"header-action\" class=\"page-layout simple fullwidth with-toolbar-content\" layout=\"column\"><div \nclass=\"header nabati3\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div\n class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Lock transaction</span>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Input lock transaction\n</span></div><div class=\"title\">Form Input Lock Transaction</div></div></div><div class=\"content\" layout=\"column\"><div \nlayout=\"row\" layout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" \nflex-xs=\"100\" flex-md=\"80\"><form name=\"formInputEmployement\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputEmployement)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" \nname=\"nik\" ng-model=\"vm.Form.objForm.nik\" placeholder=\"NIK\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputEmployement.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"nik_atasan\" \nng-model=\"vm.Form.objForm.nik_atasan\" placeholder=\"NIK Atasan\" required><div \nng-messages=\"formInputEmployement.nik_atasan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNIK Atasan is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"grade\" ng-model=\"vm.Form.objForm.grade\" placeholder=\"Grade\" required><div \nng-messages=\"formInputEmployement.grade.$error\" role=\"alert\"><div ng-message=\"required\"><span>Grade is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"positionid\" \nng-model=\"vm.Form.objForm.positionid\" placeholder=\"positionid\" required><div \nng-messages=\"formInputEmployement.positionid.$error\" role=\"alert\"><div ng-message=\"required\"><span>\npositionid is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"emp_profile_id\" ng-model=\"vm.Form.objForm.emp_profile_id\" placeholder=\"emp_profile_id\" required><div \nng-messages=\"formInputEmployement.emp_profile_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nemp_profile_id is required.</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputEmployement.$invalid || basicForm.$pristine\">Submit</md-button></div></form></div></div></div>\n</div>");
$templateCache.put("app/main/machine/machine-line/machine-line-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.MACHINELINE\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"MACHINE.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nng-change=\"vm.getGedung(vm.area)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" ng-repeat=\"ls in vm.areaList | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"MACHINE.MENU.GEDUNG\"></span></label><md-select ng-model=\"vm.gedung\" aria-label=\"Gedung\" name=\"gedung\" \nng-change=\"vm.getSector(vm.gedung)\"><md-option ng-repeat=\"ls in vm.gedungList track by $index\" placeholder=\"Gedung\" \nvalue=\"{{ls.id}}\">{{ls.gedung_name}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"MACHINE.MENU.SECTOR\"></span></label><md-select ng-model=\"vm.sector\" name=\"sector\" aria-label=\"Sector\" \nrequired ng-change=\"vm.getLine(vm.sector)\"><md-option ng-repeat=\"ls in vm.sectorList track by $index\" \nplaceholder=\"Sector\" value=\"{{ls.sector_id}}\">{{ls.sector_name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label><span translate=\"MACHINE.MENU.LINE\"></span></label><md-select \nng-model=\"vm.Form.objForm.gedung_sector_line_id\" name=\"type\" required><md-option ng-repeat=\"ls in vm.gedungSectorList\" \nvalue=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div ng-messages=\"frmBT.gedung_sector_line_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MACHINE.MENU.SECTORNAME\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MACHINE.MENU.MACHINENAME\"></label><input type=\"text\" \nng-model=\"vm.Form.objForm.machine_name\" name=\"machine_name\" required><div ng-messages=\"frmBT.machine_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MACHINE.MENU.MACHINENAME\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><label class=\"text-grey\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div layout=\"row\"><md-input-container flex flex-gt-sm><div \nstyle=\"padding: 7px\"><textarea rows=\"7\" ng-model=\"vm.Form.objForm.description\" ng-required=\"true\"></textarea></div><div\n ng-messages=\"frmBT.deliverable.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" ng-if=\"!vm.isChecked\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/machine/machine-line/machine-line.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.MACHINELINE\"></span></md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" ng-click=\"vm.addDataNews(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-button></md-menu-item><md-menu-item><span><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></span></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"HCTICKET.MENU.NO\"></span></span></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MACHINE.MENU.LINE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MACHINE.MENU.MACHINENAME\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span></span></th><th width=\"5%\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox ng-if=\"!item.hasChild\" \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.line_name}}</td><td \nclass=\"\">{{item.machine_name}}</td><td class=\"\"><span ng-bind-html=\"item.description\"></span></td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-tooltip><span \ntranslate=\"HCTICKET.MENU.EDIT\"></span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-border-color\">\n</md-icon><p flex><span translate=\"HCTICKET.MENU.EDIT\"></span></p></div></md-button></md-menu-item></md-menu-content>\n</md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/machine/output-specification/output-specification-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.OUTPUTSPECIFICATION\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.id\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.name\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getProduct(vm.Form.objForm.name)\" md-min-length=\"3\" md-input-name=\"id\" md-item-text=\"item.name\" \nmd-floating-label=\"Product Name\"><md-item-template><span md-highlight-text=\"vm.Form.objForm.name\">{{item.name}}</span>\n</md-item-template><div ng-messages=\"frmBT.id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-autocomplete></div><div layout=\"row\"><md-input-container\n flex flex-gt-sm><label translate=\"MACHINE.MENU.SPECVALUE\"></label><input type=\"number\" \nng-model=\"vm.Form.objForm.spec_value\" name=\"spec_value\" required><div ng-messages=\"frmBT.spec_value.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MACHINE.MENU.SPECVALUE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"MACHINE.MENU.UOM\"></label><input type=\"text\" \nng-model=\"vm.Form.objForm.uom\" name=\"uom\" md-maxlength=\"10\" required><div ng-messages=\"frmBT.uom.$error\" role=\"alert\">\n<div ng-message=\"md-maxlength\"><span>Max 10 Character.</span></div><div ng-message=\"required\"><span \ntranslate=\"MACHINE.MENU.UOM\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><label class=\"text-grey\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *</label><div \nlayout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 7px\"><textarea rows=\"7\" \nng-model=\"vm.Form.objForm.description\" ng-required=\"true\"></textarea></div><div ng-messages=\"frmBT.deliverable.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" ng-if=\"!vm.isChecked\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/machine/output-specification/output-specification.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.OUTPUTSPECIFICATION\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nstyle=\"width:40%\" name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate \nlayout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.id\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.name\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getProduct(vm.Form.objForm.name)\" md-min-length=\"3\" md-input-name=\"id\" md-item-text=\"item.name\" \nmd-floating-label=\"SKU\"><md-item-template><span md-highlight-text=\"vm.Form.objForm.name\">{{item.name}}</span>\n</md-item-template><div ng-messages=\"frmBT.id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-autocomplete><md-button style=\"margin-top:-10px\" \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">\n&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button\n class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Add New\" ng-click=\"vm.addData($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span>New\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide \nshow-gt-sm aria-label=\"Delete\" ng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteData($event)\" type=\"button\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete</span></md-tooltip><md-icon \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-delete red-700-fg\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-delete grey-700-fg\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span \nng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span \nstyle=\"color:red\" ng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\">\n</span></span></md-button><span flex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"\" \nng-click=\"vm.addDataNews(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span translate=\"PAYROLL.MENU.NEW\">\n</span></md-button></md-menu-item><md-menu-item><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">\nUn-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon>\n</span></th><th width=\"5%\"><span class=\"column-title\"><span translate=\"HCTICKET.MENU.NO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"MACHINE.MENU.SPECVALUE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"MACHINE.MENU.UOM\"></span></span></th><th width=\"5%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.spec_value}}</td><td class=\"text-center\"><span>\n{{item.uom}}</span></td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" \nclass=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\">\n<md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"HCTICKET.MENU.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-border-color\"></md-icon><p flex><span translate=\"HCTICKET.MENU.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/machine/product-specification/product-specification-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.PRODUCTSPECIFICATION\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.id\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.name\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getProduct(vm.Form.objForm.name)\" md-min-length=\"3\" md-input-name=\"id\" md-item-text=\"item.name\" \nmd-floating-label=\"Product Name\"><md-item-template><span md-highlight-text=\"vm.Form.objForm.name\">{{item.name}}</span>\n</md-item-template><div ng-messages=\"frmBT.id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-autocomplete></div><div layout=\"row\"><md-input-container\n flex flex-gt-sm><label translate=\"MACHINE.MENU.SPECVALUE\"></label><input type=\"number\" \nng-model=\"vm.Form.objForm.spec_value\" name=\"spec_value\" required><div ng-messages=\"frmBT.spec_value.$error\" \nrole=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 10 Character.</span></div><div ng-message=\"required\"><span \ntranslate=\"MACHINE.MENU.SPECVALUE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label translate=\"MACHINE.MENU.UOM\">\n</label><input type=\"text\" ng-model=\"vm.Form.objForm.uom\" name=\"uom\" md-maxlength=\"10\" required><div \nng-messages=\"frmBT.uom.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 10 Character.</span></div><div \nng-message=\"required\"><span translate=\"MACHINE.MENU.UOM\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div><label class=\"text-grey\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span> *\n</label><div layout=\"row\"><md-input-container flex flex-gt-sm><div style=\"padding: 7px\"><textarea rows=\"7\" \nng-model=\"vm.Form.objForm.description\" ng-required=\"true\"></textarea></div><div ng-messages=\"frmBT.deliverable.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button>\n<md-button type=\"submit\" ng-if=\"!vm.isChecked\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/machine/product-specification/product-specification.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.PRODUCTSPECIFICATION\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nstyle=\"width:40%\" name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate \nlayout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.id\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.name\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getProduct(vm.Form.objForm.name)\" md-min-length=\"3\" md-input-name=\"id\" md-item-text=\"item.name\" \nmd-floating-label=\"Product Name\"><md-item-template><span md-highlight-text=\"vm.Form.objForm.name\">{{item.name}}</span>\n</md-item-template><div ng-messages=\"frmBT.id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-autocomplete><md-button style=\"margin-top:-10px\" \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">\n&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span></span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button\n class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span><span translate=\"PAYROLL.MENU.NEW\">\n</span></span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" ng-click=\"vm.addDataNews(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-button></md-menu-item><md-menu-item><span><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></span></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"HCTICKET.MENU.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MACHINE.MENU.PRODUCTNAME\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MACHINE.MENU.SPECVALUE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MACHINE.MENU.UOM\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"MYPROFILE.MENU.DESCRIPTION\"></span></span></th><th width=\"5%\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.product_name}}</td><td class=\"text-center\">\n{{item.spec_value}}</td><td class=\"text-center\"><span>{{item.uom}}</span></td><td class=\"\"><span \nng-bind-html=\"item.description\"></span></td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" \nclass=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\">\n<md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex>\n<md-tooltip><span translate=\"HCTICKET.MENU.EDIT\"></span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-border-color\"></md-icon><p flex><span translate=\"HCTICKET.MENU.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/login/echeckingw/echeckingw-copy.html","<md-dialog aria-label=\"E-Check In GW Login Form\" flex=\"40\"><form ng-cloak name=\"loginForm\" novalidate \nng-submit=\"vm.login($event)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>E-Check In GW Login Form</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-window-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\" md-no-float><md-icon \nmd-font-icon=\"icon-account\"></md-icon><input type=\"text\" name=\"username\" ng-model=\"vm.user.username\" \nplaceholder=\"No KTP\" required><div ng-messages=\"loginForm.username.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>No KTP Tidak Boleh Kosong</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><md-icon md-font-icon=\"icon-account-key\"></md-icon><input type=\"password\" name=\"password\" \nng-model=\"vm.user.password\" placeholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Password tidak boleh kosong</span></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\">\n<md-icon md-font-icon=\"icon-login\"></md-icon>LOG IN</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/login/echeckingw/echeckingw.html","<div layout=\"column\" layout-wrap flex><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.login.main\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>BACK</md-button><span flex></span></div>\n<form name=\"loginForm\" novalidate ng-submit=\"vm.login($event)\"><md-input-container class=\"md-block\" md-no-float>\n<md-icon md-font-icon=\"icon-account\"></md-icon><input type=\"text\" name=\"username\" ng-model=\"vm.user.username\" \nplaceholder=\"No KTP\" required><div ng-messages=\"loginForm.username.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>No KTP is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><md-icon md-font-icon=\"icon-account-key\"></md-icon><input type=\"password\" name=\"password\" \nng-model=\"vm.user.password\" placeholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine || $root.loadingProgress\">LOG IN</md-button></form></div>");
$templateCache.put("app/main/login/echeckin/echeckin.html","<div layout=\"column\" layout-wrap flex><form name=\"loginForm\" novalidate ng-submit=\"vm.login($event)\">\n<md-input-container class=\"md-block\" md-no-float><md-icon md-font-icon=\"icon-account\"></md-icon><input type=\"text\" \nname=\"username\" ng-model=\"vm.user.username\" placeholder=\"No KTP\" required><div ng-messages=\"loginForm.username.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>No KTP is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><md-icon md-font-icon=\"icon-account-key\">\n</md-icon><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" placeholder=\"Password\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required</span>\n</div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine || $root.loadingProgress\">LOG IN</md-button>\n</form></div>");
$templateCache.put("app/main/master-data/borongan/borongan.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.BORONGAN\">Borongan</span></md-subheader><div class=\"white-bg\"><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.addBorongan($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span translate=\"UMUT.MENU.NEW\">\nCreate new</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteDataBorongan($event)\"><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.DELETE\">Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span class=\"secondary-text\" translate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addBorongan($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-plus-box\">\n</md-icon><span translate=\"UMUT.MENU.NEW\">Create new</span></md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" type=\"button\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteDataBorongan($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content style=\"background:white\" hide-gt-sm><span flex=\"5\"></span><md-list class=\"md-dense\" flex><md-list-item \nclass=\"md-3-line\" ng-repeat=\"item in vm.DataTables.list\" ng-click=\"null\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4>{{ item.borongan_name }}</h4><p>{{ item.price | currency : \"\" }}</p><p></p><p>\n{{ item.description }}</p><md-checkbox class=\"md-secondary\" aria-label=\"boronganChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></div><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"boronganMenu\" class=\"md-icon-button\" \nstyle=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"vm.selected.length > 0\" ng-click=\"\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-border-color\"></md-icon><p flex><span translate=\"KPI.LABEL.EDIT\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-divider \nstyle=\"border-width:0.5px; border-color:whitesmoke; border-style: solid\"></md-divider></md-list-item></md-list><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table id=\"inputTable\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr>\n<th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.DESCRIPTION\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.PRICE\"></span></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row hover-tr\" ng-dblclick=\"vm.editDataBorongan($event, item)\" \nng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\"><md-checkbox aria-label=\"boronganChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.borongan_name}}</td><td class=\"text-center\">\n{{item.description}}</td><td class=\"text-right\">{{item.price | currency : \"\"}}</td></tr><tr \nng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"KPI.LABEL.NODATA\">\nNo Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/borongan/edit-borongan.html","<md-dialog aria-label=\"Edit Data Borongan\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"40\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmUpdateBorongan\" \nng-submit=\"vm.updateDataBorongan($event, frmUpdateBorongan)\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Update Data Borongan</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Borongan Name</label><input \ntype=\"text\" name=\"boronganName\" ng-model=\"vm.name\" required><div ng-messages=\"frmUpdateBorongan.boronganName.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Name Field Is Required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-50><label>Price</label><input blur-to-currency amount=\"priceData\" \ncurrency-mask ng-model=\"vm.price\" name=\"boronganPrice\" required><div \nng-messages=\"frmUpdateBorongan.boronganPrice.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPrice Field Is Required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label for=\"boronganDesc\">Description</label><input type=\"text\" name=\"boronganDesc\" \nng-model=\"vm.desc\" required><div ng-messages=\"frmUpdateBorongan.boronganDesc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Description Field Is Required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\">Cancel</md-button><md-button\n type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon>Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/master-data/borongan/input-borongan.html","<md-dialog aria-label=\"Input Data Leave Hold\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"40\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBorongan\" ng-submit=\"vm.saveDataBorongan($event, frmBorongan)\" \nnovalidate flex><md-toolbar class=\"md-cyan-600-bg has-toolbar\" flex><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.BORONGAN\">Borongan</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container\n flex><label><span translate=\"KPI.LABEL.NAME\"></span></label><input type=\"text\" name=\"boronganName\" ng-model=\"vm.name\" \nrequired><div ng-messages=\"frmBorongan.boronganName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NAME\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Name Field Is Required.</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-50><label><span translate=\"KPI.LABEL.PRICE\">\n</span></label><input blur-to-currency amount=\"priceData\" currency-mask ng-model=\"vm.price\" name=\"boronganPrice\" \nrequired><div ng-messages=\"frmBorongan.boronganPrice.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.PRICE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Price Field Is Required.</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \nfor=\"boronganDesc\"><span translate=\"KPI.LABEL.DESCRIPTION\"></span></label><input type=\"text\" name=\"boronganDesc\" \nng-model=\"vm.desc\" required><div ng-messages=\"frmBorongan.boronganDesc.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.DESCRIPTION\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nDescription Field Is Required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\"><span translate=\"ACTION.CANCEL\"></span></md-button><md-button \ntype=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><span style=\"color:white\" translate=\"ACTION.SUBMIT\"></span>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/master-data/cost-center/cost-center.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\nCost Center</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" aria-label=\"company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmCost.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-sm><label>Cost Center Type</label><md-select \nng-model=\"vm.selectedType\" name=\"CostType\"><md-option ng-repeat=\"ls in vm.costType\" value=\"{{ ls.id }}\">\n{{ ls.description }}</md-option></md-select><div ng-messages=\"frmCost.costType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Cost Type field is required.</span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmCost.$invalid || frmCost.$pristine\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" ng-click=\"loadData(1)\" aria-label=\"android\"></md-icon>\n<span>Submit</span></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.insertData($this)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>New</span></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" ng-click=\"vm.ExportToExcel()\"><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon><span>Download Excel</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\" \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.insertData($this)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>New</span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-500-bg md-raised md-primary white-fg\" type=\"button\" aria-label=\"Inert\" hide show-gt-sm \nng-click=\"vm.ExportToExcel()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions\n</span></md-tooltip><md-icon md-font-icon=\"icon-file-excel\"></md-icon><span translate=\"ACTION.DOWNLOAD_EXCEL\">\nDownload Excel</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\" on-collapse=\"vm.onCollapse()\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table id=\"tb-kpi-setting\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\">No.</th><th \nclass=\"text-left\">Description</th><th width=\"10%\" class=\"text-center\">Type</th><th width=\"8%\" class=\"text-center\">ID\n</th><th width=\"20%\" class=\"text-center\">Group Cost Center</th><th width=\"13%\" class=\"text-center\">Company</th></tr>\n</thead><tbody><tr class=\"hover-tr\" ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($this,ls)\"><td \nclass=\"text-center\">{{vm.DataTable.offset + $index +1}}</td><td><span class=\"label md-blue-grey-100-bg p-5 mr-10\">\n{{ls.cost_center_code}}</span>{{ls.description}}</td><td class=\"text-center\"><span class=\"label md-blue-200-bg p-5\" \nng-if=\"ls.type == \'CNB\'\">{{ls.type}}</span> <span class=\"label md-blue-100-bg p-5\" ng-if=\"ls.type == \'Non CNB\'\">\n{{ls.type}}</span></td><td class=\"text-center\"><span class=\"label md-green-600-bg p-5\">{{ls.id}}</span></td><td \nclass=\"text-center\">{{ls.groupCost}}</td><td class=\"text-left\">{{ls.companyName}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"6\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr><tr class=\"text-center\" ng-if=\"(vm.DataTable.list | typeOf) == undefined\"><td \ncolspan=\"6\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/cost-center/input-cost-center.html","<md-dialog aria-label=\"Form Update Finger Data\" flex><form ng-cloack name=\"FormCostCenter\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,FormCostCenter)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Cost Center</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\"><div layout=\"column\" flex flex-gt-xs=\"45\">\n<md-input-container flex><label>Cost Center Code (SAP)</label><input ng-model=\"vm.Form.objForm.cost_center_code\" \nname=\"cost_center_code\" required><div ng-messages=\"FormCostCenter.cost_center_code.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Cost Center Code (SAP) field is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Description</label><input ng-model=\"vm.Form.objForm.description\" name=\"description\" \nrequired><div ng-messages=\"FormCostCenter.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription field is required.</span></div></div></md-input-container><div layout=\"row\"><md-input-container \nclass=\"drop-mod\" flex=\"40\"><label>Type</label><md-select ng-model=\"vm.Form.objForm.type\" name=\"type\" required>\n<md-option value=\"cnb\">CNB</md-option><md-option value=\"noncnb\">Non CNB</md-option></md-select><div \nng-messages=\"FormCostCenter.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Type field is required.</span>\n</div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label>Company</label><md-select \nng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listBU\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"FormCostCenter.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container></div></div><div \nflex-gt-xs=\"10\" hide show-gt-xs></div><div layout=\"column\" flex flex-gt-xs=\"45\"><md-input-container class=\"drop-mod\" \nflex><label>Group Cost Center</label><md-select ng-model=\"vm.Form.objForm.group_cost_id\" name=\"group_cost_id\" required>\n<md-option ng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\" layout=\"row\">{{ls.description}} ({{ls.postfix}})\n</md-option></md-select><div ng-messages=\"FormCostCenter.group_cost_id.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Group Cost field is required.</span></div></div></md-input-container><md-input-container flex><label>Country\n</label><md-select ng-model=\"vm.Form.objForm.country\" name=\"country\" required \nmd-on-close=\"vm.clearSearchTermCountry()\"><md-select-header><input ng-model=\"vm.searchTermCountry\" type=\"search\" \nplaceholder=\"Search for country\" class=\"md-text\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listCountry | filter:vm.searchTermCountry\" placeholder=\"Country\" \nng-value=\"ls.countrycode\">{{ls.nicename}} ({{ls.countrycode}})</md-option></md-select><div \nng-messages=\"FormCostCenter.country.$error\" role=\"alert\"><div ng-message=\"required\"><span>Country field is required.\n</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front>\n</ms-widget><span flex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"FormCostCenter.$invalid || FormCostCenter.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/master-data/department-division/department-division.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">MASTER DEPARTMENT DIVISION</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-button class=\"md-raised md-primary btn-ui-serif\" \nui-sref=\"app.masterdata_department_division_input\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Add</span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.deleteDepartment($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete</span></md-button></div></md-toolbar><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"text-left\"><div class=\"table-header\">\n<span class=\"column-title\">DESCRIPTION</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listDepartment\" \nng-dblclick=\"vm.editData(div.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listDepartmentSelected\" checklist-value=\"div\"></td><td class=\"text-center\">{{ ($index + 1)}}</td>\n<td class=\"text-center\">{{ div.id}}</td><td>{{ div.description}}</td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/department/department.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Master DEPARTMENT</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-button class=\"md-raised md-primary btn-ui-serif\" \nui-sref=\"app.masterdata_department_input\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Add Department\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.deleteDepartment($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete Department</span></md-button></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"text-left\"><div class=\"table-header\">\n<span class=\"column-title\">DESCRIPTION</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listDepartment\" \nng-dblclick=\"vm.editData(div.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listDepartmentSelected\" checklist-value=\"div\"></td><td class=\"text-center\">{{ ($index + 1)}}</td>\n<td class=\"text-center\">{{ div.id}}</td><td>{{ div.description}}</td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/division/division.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Master DIVISION</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" type=\"button\" ui-sref=\"app.masterdata_division_input\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Add Division</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Add Division</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.deleteDivision($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nDelete Division</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span>Delete Division</span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"text-left\"><div class=\"table-header\">\n<span class=\"column-title\">DESCRIPTION</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listDivision\" \nng-dblclick=\"vm.editData(div.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listDivisionSelected\" checklist-value=\"div\"></td><td class=\"text-center\">{{ ($index + 1)}}</td><td \nclass=\"text-center\">{{ div.id}}</td><td>{{ div.description}}</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/jfm/jfm.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Master JFM</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-button class=\"md-raised md-primary btn-ui-serif\" ui-sref=\"app.masterdata_jfm_input\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span>Add Jfm</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.deleteJfm($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete Jfm</span></md-button></div></md-toolbar><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"text-left\"><div class=\"table-header\">\n<span class=\"column-title\">DESCRIPTION</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listJfm\" \nng-dblclick=\"vm.editData(div.id)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listJfmSelected\" \nchecklist-value=\"div\"></td><td class=\"text-center\">{{ ($index + 1)}}</td><td class=\"text-center\">{{ div.id}}</td><td>\n{{ div.description}}</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/gedung/edit-gedung.html","<md-dialog aria-label=\"Input Data Gedung\" md-theme=\"modal-theme\" flex flex-md=\"80\" flex-gt-md=\"60\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmGedung\" ng-submit=\"vm.updateDataBorongan($event,frmGedung)\" \nnovalidate flex><md-toolbar class=\"md-cyan-600-bg has-toolbar\" flex><div class=\"md-toolbar-tools\"><h2>Edit Data Gedung\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nGedung Name</label><input ng-model=\"vm.gedung_name\" name=\"gedungName\" md-maxlength=\"150\" rows=\"3\" required><div \nng-messages=\"frmGedung.gedungName.$error\" role=\"alert\"><div ng-message=\"required\"><span>Gedung name field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" aria-label=\"company\" name=\"company\" ng-change=\"vm.loadSubArea(vm.company)\" required>\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmGedung.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Sub Area</label><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\" required>\n<md-option ng-repeat=\"ls in vm.subArea | filter:{ description:\'!all\' }\" ng-if=\"ls.description\" \nvalue=\"{{ls.sub_area_id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmGedung.subarea.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><fieldset id=\"custom-chips\"><legend>Sector</legend><div \nclass=\"chips-container\"><div class=\"chip-items\" layout layout-align=\"center\" ng-repeat=\"items in vm.sector\"><label \nclass=\"chip-name\">{{items.sector_name}}</label><span class=\"chip-remove\"><md-icon md-font-icon=\"icon-close\" \nng-click=\"vm.removeSector(items, $index)\"></md-icon></span></div></div><div class=\"chip-action\"><input type=\"text\" \nplaceholder=\"Create New Sector\" ng-model=\"vm.newSector\"><md-icon ng-click=\"vm.addSector()\" md-font-icon=\"icon-plus\">\n</md-icon><span ng-if=\"vm.promiseSector\" class=\"chip-message\" \nng-class=\"{\'chip-message-success\' : vm.successSector, \'chip-message-error\' : !vm.successSector}\">{{vm.messageSector}}\n</span></div></fieldset></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\" \nng-disabled=\"frmGedung.$invalid || frmEmploye.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/master-data/gedung/gedung.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Gedung</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" \nflex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" aria-label=\"company\" ng-change=\"vm.loadSubArea(vm.company)\" \nname=\"company\" required><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Sub Area</label><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nvalue=\"{{ls.sub_area_id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container>\n<md-button type=\"button\" class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span>\n<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip>\n</md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.addGedung($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span \ntranslate=\"ACTION.APPROVE\">Create new</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteDataGedung($event)\">\n<md-icon md-font-icon=\"icon-close-circle\"></md-icon><span>Delete</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-input-container hide show-gt-sm><select hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span>Entries</span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addGedung($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-plus-box\"></md-icon><span>Create new</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" \naria-label=\"Inert\" ng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteDataGedung($event)\"><md-icon \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content style=\"background:white\" hide-gt-sm><span flex=\"5\"></span><md-list class=\"md-dense\" flex><md-list-item \nclass=\"md-3-line\" ng-repeat=\"item in vm.DataTables.list\" ng-click=\"null\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4>Gedung : {{item.gedung_name}}</h4><p>Gedung ID : {{item.id}}</p><p>Company : {{item.company}}</p>\n<p>Location : {{item.description}}</p><md-checkbox class=\"md-secondary\" aria-label=\"CutOffChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></div><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypmenu\" class=\"md-icon-button\" \nstyle=\"padding:0;margin:0;height: 24px;width: 24px\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editGedung($event, item)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex>edit</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu><md-divider style=\"border-width:0.5px; border-color:whitesmoke; border-style: solid\">\n</md-divider></md-list-item></md-list><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\" hide show-gt-sm><table id=\"inputTable\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\">NO</span></th><th \nwidth=\"5%\"><span class=\"column-title\">Gedung ID</span></th><th class=\"text-center\"><span class=\"column-title\">\nGedung Name</span></th><th class=\"text-center\"><span class=\"column-title\">Company</span></th><th class=\"text-center\">\n<span class=\"column-title\">Sub area</span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.DataTables.list\" ng-dblclick=\"vm.editGedung($event, item)\"><td class=\"text-center\"><md-checkbox \naria-label=\"gedungChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.id}}</td><td \nclass=\"text-center\">{{item.gedung_name}}</td><td class=\"text-center\">{{item.company}}</td><td class=\"text-center\">\n{{item.description}}</td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>\nNo Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/gedung/input-gedung.html","<md-dialog aria-label=\"Input Data Gedung\" md-theme=\"modal-theme\" flex flex-md=\"80\" flex-gt-md=\"60\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmGedung\" ng-submit=\"vm.saveGedung($event,frmGedung)\" novalidate flex>\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\" flex><div class=\"md-toolbar-tools\"><h2>Input Data Gedung</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nGedung Name</label><input ng-model=\"vm.genung_name\" name=\"gedungName\" md-maxlength=\"150\" rows=\"3\" required><div \nng-messages=\"frmGedung.gedungName.$error\" role=\"alert\"><div ng-message=\"required\"><span>Gedung name field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" aria-label=\"company\" name=\"company\" ng-change=\"vm.loadSubArea(vm.company)\" required>\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmGedung.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Sub Area</label><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\" required>\n<md-option ng-repeat=\"ls in vm.subArea | filter:{ description:\'!all\' }\" ng-if=\"ls.description\" \nvalue=\"{{ls.sub_area_id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmGedung.subarea.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\">Cancel</md-button><md-button\n type=\"submit\" class=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\" \nng-disabled=\"frmGedung.$invalid || frmEmploye.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/master-data/job-code/job-code-add.html","<md-dialog aria-label=\"Form Add Job Code\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"frmAddJobCode\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddJobCode)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Add Job Code</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout=\"column\"><md-input-container flex><input type=\"text\" name=\"code\" ng-model=\"vm.Form.objForm.code\" \nplaceholder=\"Job Code\" required><div ng-messages=\"frmAddJobCode.code.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Job Code is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Job Description\" required><div \nng-messages=\"frmAddJobCode.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJob Description is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddJobCode.$invalid || frmAddJobCode.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/master-data/job-code/job-code-edit.html","<md-dialog aria-label=\"Form Edit Job Code\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"frmEditJobCode\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmEditJobCode)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Edit Job Code</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"code\" \nng-model=\"vm.Form.objForm.code\" placeholder=\"Job Code\" required><div ng-messages=\"frmEditJobCode.code.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Job Code is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" \nplaceholder=\"Job Description\" required><div ng-messages=\"frmEditJobCode.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Job Description is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditJobCode.$invalid || frmEditJobCode.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/master-data/job-code/job-code-table.html","<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nstyle=\"min-width: 50px; width: 80px\"></th><th width=\"10%\">CODE</th><th width=\"40%\" class=\"text-center\">DESCRIPTION</th>\n<th width=\"min-width: 50px;\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nstyle=\"min-width: 50px; text-align: center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td class=\"text-center\">{{ls.code}}</td><td>{{ls.description}}</td><td class=\"text-center\" \nstyle=\"white-space: nowrap\"><a href=\"javasccript:void(0);\" ng-click=\"vm.edit($event, ls)\" \nstyle=\"text-decoration: none\"><span class=\"icon-pencil\"></span></a></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"4\" class=\"text-center\"><span>No Data Available</span></td></tr>\n</tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/master-data/job-code/job-code-toolbar.html","<div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputBusinesstrip($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.NEW\">New</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span translate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.DELETE\">Delete</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.add($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New\n</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span translate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.NEW\">New</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Delete</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-mini blue-700-fg\" hide \nshow-gt-sm aria-label=\"Download\" ng-click=\"vm.download($event)\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Download</span></md-tooltip><md-icon md-font-icon=\"icon-download\" \nclass=\"md-font icon-archive material-icons blue-700-fg\"></md-icon><span>Download</span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div>");
$templateCache.put("app/main/master-data/job-code/job-code.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Master Data - Job Code</span></md-subheader><div class=\"white-bg\"><md-toolbar \nng-include=\"\'app/main/master-data/job-code/job-code-toolbar.html\'\"></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\" ng-include=\"\'app/main/master-data/job-code/job-code-table.html\'\">\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/job-title/jobtitle.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Master JOBTITLE</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-button class=\"md-raised md-primary btn-ui-serif\" \nui-sref=\"app.masterdata_jobtitle_input\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Add Jobtitle</span>\n</md-button><md-button class=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.deleteJobtitle($event)\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><span>Delete Jobtitle</span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.viewDataJobtitle(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div\n class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">No</span></div>\n</th><th class=\"text-center\" width=\"20%\"><div class=\"table-header\"><span class=\"column-title\">POSITION ID</span></div>\n</th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">DESCRIPTION</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"div in vm.DataTables.list\" ng-dblclick=\"vm.editData(div.positionid)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listJobtitleSelected\" checklist-value=\"div\"></td><td \nclass=\"text-center\">{{ ($index + 1)}}</td><td class=\"text-center\">{{ div.positionid}}</td><td>{{ div.description}}</td>\n</tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>No Data Available</span></td>\n</tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.viewDataJobtitle(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/master-data/level/level.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Master LEVEL</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nui-sref=\"app.masterdata_level_input\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Add Level</span>\n</md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.deleteLevel($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span>Delete Level</span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ui-sref=\"app.masterdata_level_input\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\n<span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Add Level\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" type=\"button\" ng-click=\"vm.deleteLevel($event)\"><md-tooltip\n md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"md-font icon-archive material-icons\"></md-icon><span>Delete Level</span>\n</md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table id=\"datatable\" class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"text-left\"><div class=\"table-header\">\n<span class=\"column-title\">DESCRIPTION</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listLevel\" \nng-dblclick=\"vm.editData(div.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listLevelSelected\" checklist-value=\"div\"></td><td class=\"text-center\">{{ ($index + 1)}}</td><td \nclass=\"text-center\">{{ div.id}}</td><td>{{ div.description}}</td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/update-finger-reason/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span class=\"parent\" translate=\"MENU.MASTER_DATA.UPDATE_FINGER_REASON.INDEX.HEADER.TITLE\">\nMaster Update Finger Reason</span></md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span translate=\"ACTION.APPROVE\">Approve\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.REJECT\">Reject\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.masterdata_update_finger_reason_input\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nclick for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"ACTION.NEW\">New</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-button class=\"md-warn md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.delete($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"ACTION.DELETE\">Delete</span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nid=\"datatable\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TABLE.NO\">No</span></div></th><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TABLE.ID\">ID</span></div></th><th \nclass=\"text-left\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TABLE.DESCRIPTION\">DESCRIPTION</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\" ng-dblclick=\"vm.editData(ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ ($index + 1)}}</td><td class=\"text-center\">{{ ls.id}}</td><td>{{ ls.description}}</td></tr>\n</tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/school/edit-school.html","<md-dialog aria-label=\"Input School\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"40\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmSchool\" ng-submit=\"vm.updateDataSchool($event, frmSchool)\" novalidate \nflex><md-toolbar class=\"md-cyan-600-bg has-toolbar\" flex><div class=\"md-toolbar-tools\"><h2>Update Data School Name</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nSchool Name</label><input type=\"text\" name=\"SchoolName\" ng-model=\"vm.Form.objForm.schoolName\" required><div \nng-messages=\"frmSchool.schoolName.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name Field Is Required.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmSchool.$invalid || frmSchool.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon>Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/master-data/school/input-school.html","<md-dialog aria-label=\"Input School\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"40\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmSchool\" ng-submit=\"vm.saveDataSchool($event, frmSchool)\" novalidate \nflex><md-toolbar class=\"md-cyan-600-bg has-toolbar\" flex><div class=\"md-toolbar-tools\"><h2>Input Data School Name</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nSchool Name</label><input type=\"text\" name=\"SchoolName\" ng-model=\"vm.Form.objForm.schoolName\" r 5equired><div \nng-messages=\"frmSchool.schoolName.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name Field Is Required.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmSchool.$invalid || frmSchool.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon>Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/master-data/school/school.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">School</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" class=\"md-raised\" \nng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon md-font-icon=\"icon-chevron-down\">\n</md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\" \nclass=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.addSchool($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span>Create new</span></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" ng-disabled=\"vm.selected.length == 0\" \nng-click=\"vm.deleteDataSchool($event)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><span>Delete</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select hide show-gt-sm name=\"see\" \nid=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\">\n</select>Entries</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addSchool($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-plus-box\" class=\"md-font icon-archive material-icons\"></md-icon><span>Create new</span></md-button>\n<div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" \naria-label=\"Inert\" ng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteDataSchool($event)\"><md-icon \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table id=\"inputTable\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead></thead><thead><tr><th width=\"5%\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\">NO\n</span></th><th width=\"5%\"><span class=\"column-title\">ID</span></th><th class=\"text-center\"><span class=\"column-title\">\nSchool Name</span></th></tr></thead><tbody><tr class=\"md-table-content-row hover-tr\" \nng-dblclick=\"vm.editSchool($event, item)\" ng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\"><md-checkbox \naria-label=\"boronganChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{ item.id }}</td><td class=\"text-center\">{{($index + 1)}}</td><td \nclass=\"text-center\">{{item.school_name}}</td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span>No Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/business-unit/business-unit.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Bussines Unit</span></md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nui-sref=\"app.masterdata_business_unit_input\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Add Bu\n</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"MENU.MASTER_DATA.BU.ADD_BU\">Add BU</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.deleteBu($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Bu</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"MENU.MASTER_DATA.BU.DELETE_BU\">Delete BU</span>\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\" width=\"5%\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"MENU.MASTER_DATA.BU.TABLEBU.HEADER.NO\">No</span></div></th><th \nclass=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"MENU.MASTER_DATA.BU.TABLEBU.HEADER.ID\">ID</span></div></th><th class=\"text-left\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"MENU.MASTER_DATA.BU.TABLEBU.HEADER.DESCRIPTION\">DESCRIPTION</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"bu in vm.listBu\" ng-dblclick=\"vm.editData(bu.id)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listBuSelected\" checklist-value=\"bu\"></td><td class=\"text-center\">{{ ($index + 1)}}\n</td><td class=\"text-center\">{{ bu.id}}</td><td>{{ bu.description}}</td></tr></tbody></table></md-content><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></md-content></div>");
$templateCache.put("app/main/mpn/tutorial/tutorial-view.html","<div id=\"page_talent\" class=\"page-layout simple fullwidth\"><div class=\"header header-talent md-accent-bg\"><span \nclass=\"md-display-1 font-weight-300\">Tutorial</span></div><div class=\"content\"><div layout-xs=\"column\" layout=\"row\">\n<div ng-if=\"vm.tutorial_type === \'video\'\" flex-xs flex-gt-xs=\"50\" layout=\"column\"><h3>Man Power Need Tutorial Video\n</h3><video class=\"tutorial\" controls=\"\" name=\"media\"><source src=\"{{vm.url}}\" type=\"video/mp4\">\nYour browser does not support the video tag.</video></div><div ng-if=\"vm.tutorial_type === \'ebook\'\" flex-xs \nflex-gt-xs=\"100\" layout=\"column\"><iframe src=\"{{vm.url}}\" style=\"width:100%; height:80vh\" frameborder=\"0\"></iframe>\n</div></div></div></div>");
$templateCache.put("app/main/mpn/tutorial/tutorial.html","<div id=\"page_talent\" class=\"page-layout simple fullwidth\"><div class=\"header header-talent md-accent-bg\"><span \nclass=\"md-display-1 font-weight-300\">Tutorial</span></div><div class=\"content\"><div layout-xs=\"column\" layout=\"row\">\n<div flex-xs flex-gt-xs=\"30\" layout=\"column\" ng-repeat=\"tutorial in vm.tutorialList\"><md-card \nmd-theme=\"{{ showDarkTheme ? \'dark-orange\' : \'default\' }}\" md-theme-watch><md-card-title><md-card-title-text \nstyle=\"cursor: pointer\"><a ui-sref=\"app.mpn_tutorial_view({tutorial_type: tutorial.type, url: tutorial.url})\"><span \nclass=\"md-headline blue-800-fg\">{{tutorial.title}}</span></a></md-card-title-text></md-card-title><md-card-content \nlayout=\"row\" style=\"height: {{tutorial.cover_height}}\"><div class=\"md-media-xl card-media\"><img \nui-sref=\"app.mpn_tutorial_view({tutorial_type: tutorial.type, url: tutorial.url})\" style=\"cursor: pointer\" \nng-src=\"{{\'assets/tutorial/\' + tutorial.cover}}\" alt=\"\"></div></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"blue-800-fg\" \nui-sref=\"app.mpn_tutorial_view({tutorial_type: tutorial.type, url: tutorial.url})\">View</md-button></md-card-actions>\n</md-card></div></div></div></div>");
$templateCache.put("app/main/mpn-gw/dashboard/dashboard.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Dashboard MPN Online</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData()\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex><md-select ng-model=\"vm.type\" name=\"type\"><md-option \nng-repeat=\"ls in vm.listType\" placeholder=\"Dashboard Type\" value=\"{{ls.id}}\">{{ls.desc}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex ng-if=\"vm.type==\'2\'\"><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDivision(vm.company)\"><md-option \nng-repeat=\"ls in vm.listCompany\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"vm.type==\'2\'\"><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nmultiple=\"multiple\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Division\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" \ntype=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit</md-button></div></form></div></div>\n</md-content><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" \nng-repeat=\"ls in vm.dashboard\" ng-click=\"vm.getChart(ls.id)\" ng-if=\"ls.data.length > 0\"><ms-widget-front \nclass=\"white-bg\" ng-click=\"vm.getChart(ls.id)\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{ls.description}}</div><div class=\"pv-16\"></div></div><div \nstyle=\"height: 450px\"><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" \nms-responsive-table><thead><tr><th rowspan=\"2\">COMPANY</th><th rowspan=\"2\">MPN NUMBER</th><th rowspan=\"2\">DEPARTMENT\n</th><th rowspan=\"2\">BUSINESS TITLE</th><th colspan=\"2\">QTY</th></tr><tr><th>NEW</th><th>REPLACEMENT</th></tr></thead>\n<tbody><tr ng-repeat=\"lsd in ls.data\" ng-click=\"vm.viewDetail(lsd.id)\"><td>{{lsd.company}}</td><td>{{lsd.mpn_number}}\n</td><td>{{lsd.department}}</td><td>{{lsd.bt_desc}}</td><td style=\"text-align: center\">{{lsd.qty_new}}</td><td \nstyle=\"text-align: center\">{{lsd.qty_replacement}}</td></tr></tbody></table></div><div class=\"pv-8 mh-16 border-top\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{ls.waiting_approval}} </span><span\n class=\"h4\">APPROVAL PROGRESS</span></div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" \nflex-gt-xs=\"50\"><span class=\"font-size-32\">{{ls.ta_progress}} </span><span class=\"h4\">TA PROGRESS</span></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" layout-wrap><div layout=\"column\" flex \nclass=\"md-whiteframe-4dp p-15\"><div class=\"md-title\">Yearly</div><div layout=\"row\"><div layout=\"column\" flex><div \nid=\"chartdiv\" style=\"height: 50vh\"></div></div></div><div layout=\"column\"><div layout=\"row\"><div layout=\"column\" flex>\n<div class=\"md-title\">By Grade</div><div id=\"chartdivGrade\" style=\"height: 50vh\"></div></div><div layout=\"column\" flex>\n<div class=\"md-title\">By {{vm.getTitle()}}</div><div id=\"chartdivDiv\" style=\"height: 50vh\"></div></div></div></div>\n</div></div><div class=\"widget-group\" layout=\"row\" layout-wrap><div layout=\"column\" flex \nclass=\"md-whiteframe-4dp p-15\"><div class=\"md-title\">Month to Month</div><div id=\"chartMultiple\" style=\"height: 50vh\">\n</div></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpn-gw/dashboard/list.html","<style>\n.with-toolbar-content md-toolbar {\n        max-height: 60px;\n        min-height: 60px;\n        background: #ffffff !important;\n    }\n\n    .mpn-completed {\n        font-style: italic;\n        background: #e9ffe7 !important;\n    }\n</style><div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Dashboard MPN Online</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\">\n<md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\" ng-change=\"vm.loadBt(vm.department)\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.btcode\" name=\"businessTitle\"><md-option placeholder=\"Business Title\" \nng-repeat=\"ls in vm.listBt\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.pic\" name=\"pic\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a PIC..\" \nclass=\"header-searchbox md-text\" ng-keydown=\"vm.ketikSearch($event)\"></md-select-header><md-option value=\"\">All\n</md-option><md-option ng-repeat=\"ls in vm.listPIC | filter:vm.searchTerm\" value=\"{{ls.nik}}\">{{ls.description}}\n</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.budgetType\" \nname=\"budgetType\"><md-option ng-repeat=\"ls in vm.listBudgetType\" placeholder=\"Budget Type\" value=\"{{ls}}\">{{ls}}\n</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\" class=\"mt-40\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"15\" flex><label>Start Request Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglmulai\" md-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.START_DATE\' | translate }}\" \nname=\"tglmulai\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label>\nEnd Request Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.END_DATE\' | translate }}\" name=\"tglakhir\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><md-select ng-model=\"vm.approvalStatus\" \nname=\"approvalStatus\"><md-option ng-repeat=\"ls in vm.listApprovalStatus\" placeholder=\"Approval Status\" value=\"{{ls}}\">\n{{ls}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><md-select\n ng-model=\"vm.mpnStatus\" name=\"mpnStatus\"><md-option ng-repeat=\"ls in vm.listMpnStatus\" placeholder=\"MPN Status\" \nvalue=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" \nflex><md-select ng-model=\"vm.readStatus\" name=\"readStatus\"><md-option ng-repeat=\"ls in vm.listReadStatus\" \nplaceholder=\"Read Status\" value=\"{{ls.value}}\">{{ls.desc}}</md-option></md-select></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">\nEntries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-show=\"vm.download\" ng-click=\"vm.exportToExcel($event)\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><span>Export to Excel MPN</span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>MPN NUMBER\n</th><th>REQUESTOR</th><th>WORK LOCATION</th><th>DIVISION</th><th>DEPARTMENT</th><th>BUSINESS TITLE</th><th>BUDGET TYPE\n</th><th>MPN STATUS</th><th>APPROVAL STATUS</th><th>REQUEST DATE</th><th>EXPECTED JOIN DATE</th><th>REQUEST QTY</th>\n<th>TA PIC</th><th>#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td>\n{{ ls.mpn_number }}</td><td>{{ ls.nama_request }}</td><td>{{ ls.work_location }}</td><td>{{ ls.division }}</td><td>\n{{ ls.department }}</td><td>{{ ls.business_title }}</td><td>{{ ls.budget_type}}</td><td>{{ ls.mpn_status}}</td><td>\n{{ ls.current_status}}</td><td>{{ ls.created_at }}</td><td>{{ ls.expected_join_date }}</td><td>{{ ls.total_qty }}</td>\n<td>{{ ls.nik_pic }} - {{ ls.nama_pic }}</td><td><md-button aria-label=\"View Request\" class=\"md-icon-button\" \nng-click=\"vm.viewDetail(ls.id, ls.approval_type)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>View Request</span></md-tooltip></md-button>\n</td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div><div class=\"pv-8 mh-16 border-top\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"33\"><span class=\"font-size-32\">{{vm.dashboard.all}}</span> <span \nclass=\"h4\">All MPN</span></div><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" \nflex-gt-xs=\"33\"><span class=\"font-size-32\">{{vm.dashboard.progress}}</span> <span class=\"h4\">MPN Progress</span></div>\n<div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"33\"><span class=\"font-size-32\">\n{{vm.dashboard.close}}</span> <span class=\"h4\">MPN Close</span></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpn-gw/approval/admin.change.qty.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>MPN Change Qty By Admin</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><md-content layout=\"column\" class=\"mt-20\"><fieldset \nlayout=\"column\" class=\"form-fieldset\" layout-align=\"start\" layout-padding><legend>Replacement</legend><div id=\"item\" \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Replacement Type</label>\n<md-select name=\"reason\" placholder=\"Replacement Type\" ng-model=\"vm.replacement_type\" required \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\"><md-optgroup label=\"Reason\"><md-option\n ng-repeat=\"ls in vm.listReplacementType\" value=\"{{ls}}\">{{ls}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-autocomplete md-no-cache=\"true\" required \nmd-selected-item=\"vm.employee\" md-selected-item-change=\"vm.choose(item)\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText, $index)\" md-item-text=\"item.description\" md-delay=\"300\" \nmd-floating-label=\"Search Employee\"><div layout=\"row\" class=\"item\"><span md-highlight-text=\"vm.searchText\">\n{{item.description}}</span></div></md-autocomplete><div style=\"opacity: 1; margin-top: -34px;font-size: 11px\">\nType 3 character to search employee, example: jon</div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.effective_date\" required></md-datepicker></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><md-button ng-click=\"vm.tambah()\" \nclass=\"md-icon-button md-accent md-button md-default-theme md-ink-ripple\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-plus-circle material-icons\"></md-icon></md-button></md-input-container></div><div layout=\"column\" \nms-scroll><table class=\"simple bordered\" ms-responsive-table><thead><tr><th class=\"secondary-text\" flex=\"10\"><div \nclass=\"table-header\"><span class=\"column-title\">NO</span></div></th><th class=\"secondary-text\" flex=\"40\"><div \nclass=\"table-header\"><span class=\"column-title\">NIK</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Subarea</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Replacement Type</span></div></th><th class=\"secondary-text\" flex=\"20\">\n<div class=\"table-header\"><span class=\"column-title\">Effective Date</span></div></th><th class=\"secondary-text\" \nflex=\"20\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"lsd in vm.dataReplacement\"><td>{{$index+1}}</td><td>{{lsd.nik}}</td><td>{{lsd.nama}}</td><td>{{lsd.subarea}}\n</td><td>{{lsd.replacement_type}}</td><td>{{lsd.effective_date}}</td><td><md-button ng-click=\"vm.hapus(lsd)\" \nclass=\"md-icon-button md-warn md-button md-default-theme md-ink-ripple\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-close-circle material-icons\"></md-icon></md-button></td></tr></tbody></table></div></fieldset><form\n name=\"formInput\"><fieldset layout=\"column\" layout-gt-xs=\"row\" class=\"form-fieldset\" layout-align=\"start\" \nlayout-padding><legend>New Qty</legend><div id=\"item\" layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex>\n<input type=\"number\" ng-model=\"vm.Form.objForm.qty_new\" placeholder=\"New Qty\" ng-change=\"vm.inputNew()\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Form.objForm.qty_replace\" \nplaceholder=\"Replacement Qty\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.Form.objForm.qty_total\" placeholder=\"Total Qty\" readonly=\"readonly\"></md-input-container></div></fieldset>\n</form></md-content></md-dialog-content><md-dialog-actions class=\"md-background-bg\"><md-button ng-click=\"vm.selesai()\" \nclass=\"md-primary\">Close</md-button><md-button type=\"submit\" class=\"md-primary\" ng-click=\"vm.submitForm(formInput)\">\nSave</md-button><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" \nclass=\"fade\" flex><ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front>\n</ms-widget></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mpn-gw/approval/change.quantity.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><form name=\"formInput\" \nng-submit=\"vm.submit(formInput)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>\nMPN Change Head Count</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"row\"><div layout=\"column\" flex><fieldset \nlayout=\"column\" class=\"form-fieldset\" layout-align=\"start\" layout-padding><legend>Quantity Request</legend>\n<md-input-container layout=\"column\"><label for=\"ageRange\">Replacement</label><input ng-model=\"vm.mpn.qty_replacement\" \ntype=\"number\" readonly=\"readonly\"></md-input-container><md-input-container layout=\"column\"><label for=\"ageRange\">New\n</label><input ng-model=\"vm.mpn.qty_new\" type=\"number\" readonly=\"readonly\"></md-input-container><md-input-container \nlayout=\"column\"><label for=\"ageRange\">Total</label><input ng-model=\"vm.mpn.qty_total\" type=\"number\" \nreadonly=\"readonly\"></md-input-container></fieldset></div><div layout=\"column\" flex><fieldset layout=\"column\" \nclass=\"form-fieldset\" layout-align=\"start\" layout-padding><legend>Quantity Fullfile</legend><md-input-container \nlayout=\"column\"><label for=\"ageRange\">Replacement</label><input ng-model=\"vm.mpn.totRecruitReplacement\" type=\"number\" \nreadonly=\"readonly\"></md-input-container><md-input-container layout=\"column\"><label for=\"ageRange\">New</label><input \nng-model=\"vm.mpn.totRecruitNew\" type=\"number\" readonly=\"readonly\"></md-input-container><md-input-container \nlayout=\"column\"><label for=\"ageRange\">Total</label><input \nvalue=\"{{vm.mpn.totRecruitReplacement + vm.mpn.totRecruitNew}}\" type=\"text\" readonly=\"readonly\"></md-input-container>\n</fieldset></div><div layout=\"column\" flex><fieldset layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" \nlayout-padding><legend>Quantity New Request</legend><md-input-container layout=\"column\"><label for=\"ageRange\">\nReplacement</label><input ng-model=\"vm.Form.objForm.final_qty_replacement\" type=\"number\" name=\"final_qty_replacement\" \nng-max=\"{{vm.mpn.qty_replacement}}\" ng-min=\"{{vm.mpn.totRecruitReplacement}}\" required><div \nng-messages=\"formInput.final_qty_replacement.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nQuantity replacement is required.</span></div><div ng-message=\"min\"><span>\nQuantity replacement minimum is {{vm.recruit.replacement}}.</span></div><div ng-message=\"max\"><span>\nQuantity replacement maximum is {{vm.mpn.qty_replacement}}.</span></div></div></md-input-container><md-input-container \nlayout=\"column\"><label for=\"ageRange\">New</label><input ng-model=\"vm.Form.objForm.final_qty_new\" type=\"number\" \nname=\"final_qty_new\" ng-keyup=\"vm.initForm(formInput)\" ng-max=\"{{vm.mpn.qty_new}}\" ng-min=\"{{vm.mpn.totRecruitNew}}\" \nrequired><div ng-messages=\"formInput.final_qty_new.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nQuantity new is required.</span></div><div ng-message=\"min\"><span>Quantity new minimum is {{vm.mpn.qty_new}}.</span>\n</div><div ng-message=\"max\"><span>Quantity new maximum is {{vm.mpn.qty_new}}.</span></div><div \nng-message=\"requiredReplacement\"><span>Replacement quantity is not full yet</span></div></div></md-input-container>\n<md-input-container layout=\"column\"><label for=\"ageRange\">Total</label><input \nvalue=\"{{vm.Form.objForm.final_qty_replacement + vm.Form.objForm.final_qty_new}}\" type=\"text\" readonly=\"readonly\">\n</md-input-container></fieldset></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><md-button ng-click=\"vm.closeModal()\" class=\"md-primary\">CANCEL</md-button><md-button \ntype=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInput.$invalid || basicForm.$pristine\">SUBMIT</md-button><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/mpn-gw/approval/list.change.quantity.html","<style>\n.with-toolbar-content md-toolbar {\n        max-height: 60px;\n        min-height: 60px;\n        background: #ffffff !important;\n    }\n\n    .mpn-completed {\n        font-style: italic;\n        background: #e9ffe7 !important;\n    }\n</style><div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Approval CHANGE HEAD COUNT MPN</md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\">\n<md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\" ng-change=\"vm.loadBt(vm.department)\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.btcode\" name=\"businessTitle\"><md-option placeholder=\"Business Title\" \nng-repeat=\"ls in vm.listBt\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container></div><div\n layout-gt-xs=\"row\" class=\"mt-40\"><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label>Start Request Date\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.START_DATE\' | translate }}\" name=\"tglmulai\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label>End Request Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.END_DATE\' | translate }}\" name=\"tglakhir\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><md-select ng-model=\"vm.approvalStatus\" \nname=\"approvalStatus\"><md-option ng-repeat=\"ls in vm.listApprovalStatus\" placeholder=\"Approval Status\" \nvalue=\"{{ls.id}}\">{{ls.desc}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><md-select ng-model=\"vm.budgetType\" name=\"budgetType\"><md-option ng-repeat=\"ls in vm.listBudgetType\" \nplaceholder=\"Budget Type\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">\nEntries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>MPN NUMBER\n</th><th>REQUESTOR</th><th>WORK LOCATION</th><th>DIVISION</th><th>DEPARTMENT</th><th>BUSINESS TITLE</th><th>BUDGET TYPE\n</th><th>MPN STATUS</th><th>APPROVAL STATUS</th><th>REQUEST DATE</th><th>EXPECTED JOIN DATE</th><th>NEW REQUEST QTY\n</th><th>FILLED QTY</th><th>RESIDUAL QTY</th><th>MPN STATUS</th><th>TA PIC</th><th>VACANCY CLOSE</th><th>#</th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td>{{ ls.mpn_number }}</td><td>\n{{ ls.nama_request }}</td><td>{{ ls.work_location }}</td><td>{{ ls.division }}</td><td>{{ ls.department }}</td><td>\n{{ ls.business_title }}</td><td>{{ ls.budget_type}}</td><td>{{ ls.current_status}}</td><td><div \nng-switch=\"ls.approval_status\"><div ng-switch-when=\"0\"><div class=\"info\">None</div></div><div ng-switch-when=\"1\"><div \nclass=\"info\">Waiting Approval</div></div><div ng-switch-when=\"2\"><div class=\"info\">Approve</div></div><div \nng-switch-when=\"3\"><div class=\"info\">Revert</div></div><div ng-switch-when=\"4\"><div class=\"info\">Reject</div></div>\n</div></td><td>{{ ls.created_at }}</td><td>{{ ls.expected_join_date }}</td><td>{{ ls.final_qty_total }}</td><td>\n{{ ls.filled_qty }}</td><td>{{ ls.final_qty_total - ls.filled_qty }}</td><td>{{ ls.mpn_status }}</td><td>\n{{ ls.nama_pic }}</td><td>{{ ls.vacancy_close_date }}</td><td><md-button aria-label=\"View Request\" \nclass=\"md-icon-button\" ng-click=\"vm.viewDetail(ls.id, ls.approval_type)\" style=\"padding: 0;height: 24px;width: 24px\">\n<md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>View Request</span></md-tooltip>\n</md-button></td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpn-gw/approval/list.html","<style>\n.with-toolbar-content md-toolbar {\n        max-height: 60px;\n        min-height: 60px;\n        background: #ffffff !important;\n    }\n\n    .mpn-completed {\n        font-style: italic;\n        background: #e9ffe7 !important;\n    }\n</style><div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Approval MPN Online</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\">\n<md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\" ng-change=\"vm.loadBt(vm.department)\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.btcode\" name=\"businessTitle\"><md-option placeholder=\"Business Title\" \nng-repeat=\"ls in vm.listBt\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container></div><div\n layout-gt-xs=\"row\" class=\"mt-40\"><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label>Start Request Date\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.START_DATE\' | translate }}\" name=\"tglmulai\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label>End Request Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.END_DATE\' | translate }}\" name=\"tglakhir\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><md-select ng-model=\"vm.approvalStatus\" \nname=\"approvalStatus\"><md-option ng-repeat=\"ls in vm.listApprovalStatus\" placeholder=\"Approval Status\" value=\"{{ls}}\">\n{{ls}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><md-select \nng-model=\"vm.mpnStatus\" name=\"mpnStatus\"><md-option ng-repeat=\"ls in vm.listMpnStatus\" placeholder=\"MPN Status\" \nvalue=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\">\n<md-select ng-model=\"vm.budgetType\" name=\"budgetType\"><md-option ng-repeat=\"ls in vm.listBudgetType\" \nplaceholder=\"Budget Type\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">\nEntries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-show=\"vm.download\" ng-click=\"vm.exportToExcel($event)\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><span>Export to Excel MPN</span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>MPN NUMBER\n</th><th>REQUESTOR</th><th>WORK LOCATION</th><th>DIVISION</th><th>DEPARTMENT</th><th>BUSINESS TITLE</th><th>BUDGET TYPE\n</th><th>MPN STATUS</th><th>APPROVAL STATUS</th><th>REQUEST DATE</th><th>EXPECTED JOIN DATE</th><th>REQUEST QTY</th>\n<th>TA PIC</th><th>#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td>\n{{ ls.mpn_number }}</td><td>{{ ls.nama_request }}</td><td>{{ ls.work_location }}</td><td>{{ ls.division }}</td><td>\n{{ ls.department }}</td><td>{{ ls.business_title }}</td><td>{{ ls.budget_type}}</td><td>{{ ls.mpn_status}}</td><td>\n{{ ls.current_status}}</td><td>{{ ls.created_at }}</td><td>{{ ls.expected_join_date }}</td><td>{{ ls.total_qty }}</td>\n<td>{{ ls.nik_pic }} - {{ ls.nama_pic }}</td><td><md-button aria-label=\"View Request\" class=\"md-icon-button\" \nng-click=\"vm.viewDetail(ls.id, ls.approval_type)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>View Request</span></md-tooltip></md-button>\n</td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpn-gw/approval/reject.resetslt.gw.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Reject Reset SLT</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><div\n layout=\"column\"><h2><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon>\nPlease make note for your rejection!</h2><md-input-container class=\"md-block mt-10\"><label>Comment</label><textarea \nname=\"notes\" ng-model=\"vm.notes\" md-maxlength=\"200\" max-rows=\"5\"></textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button ng-click=\"vm.closeModal()\" \nclass=\"md-primary\">CANCEL</md-button><md-button ng-click=\"vm.submit(4)\" class=\"md-primary\">REJECT</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mpn-gw/approval/reject.revise.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>{{vm.approval}} MPN</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\"><h2><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon>Please make note for your {{vm.approval}}!</h2>\n<md-input-container class=\"md-block mt-10\"><label>Comment</label><textarea name=\"notes\" ng-model=\"vm.notes\" \nmd-maxlength=\"200\" max-rows=\"5\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><md-button ng-click=\"vm.closeModal()\" class=\"md-primary\">CANCEL</md-button>\n<md-button ng-click=\"vm.submit(4)\" class=\"md-primary\" ng-if=\"vm.approval == \'Reject\' \">REJECT</md-button><md-button \nng-click=\"vm.submit(3)\" class=\"md-primary\" ng-if=\"vm.approval == \'Revice\' \">REVISE</md-button><md-button \nng-click=\"vm.submit(5)\" class=\"md-primary\" ng-if=\"vm.approval == \'reject change head count\' \">REJECT</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mpn-gw/approval/set.budget.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><form name=\"frmRequest\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>MPN Verification</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><div\n layout=\"column\"><h2><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon>\nPlease make sure you have chosen the right action!</h2><p>MPN Type:</p><md-radio-group ng-model=\"vm.budget_type\" \nname=\"mppType\"><md-radio-button value=\"Budgeted\" class=\"md-primary\">Budgeted MPN</md-radio-button><md-radio-button \nvalue=\"Unbudgeted\" class=\"md-primary\">Unbudgeted MPN</md-radio-button></md-radio-group><md-input-container \nclass=\"md-block mt-10\"><label>Comment</label><textarea name=\"notes\" ng-model=\"vm.notes\" md-maxlength=\"200\" \nmax-rows=\"5\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><md-button ng-click=\"vm.closeModal()\" class=\"md-primary\">CANCEL</md-button><md-button \nng-click=\"vm.submit(4)\" class=\"md-primary\">REJECT</md-button><md-button ng-click=\"vm.submit(2)\" class=\"md-primary\">\nAPPROVE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpn-gw/approval/set.delegate.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><form name=\"formInput\" \nng-submit=\"vm.submit(formInput)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>\nMPN Delegate Approval</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\"><h2><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon>Please make sure you have chosen the right person!</h2>\n<md-input-container flex><label>Delegate To</label><md-select ng-model=\"vm.delegate\" name=\"delegate\" required>\n<md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a PIC..\" \nng-keydown=\"vm.ketikSearch($event)\"></md-select-header><md-option \nng-repeat=\"ls in vm.listDelegate | filter:vm.searchTerm\" value=\"{{ls}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"formInput.delegate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Delegate is required.</span>\n</div></div></md-input-container><md-input-container class=\"md-block mt-10\"><label>Comment</label><textarea \nname=\"notes\" ng-model=\"vm.notes\" md-maxlength=\"200\" max-rows=\"5\" required></textarea><div \nng-messages=\"formInput.notes.$error\" role=\"alert\"><div ng-message=\"required\"><span>Comment is required.</span></div>\n</div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<md-button ng-click=\"vm.closeModal()\" class=\"md-primary\">CANCEL</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" ng-disabled=\"formInput.$invalid || basicForm.$pristine\">\nDELEGATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpn-gw/approval/set.pic.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><form name=\"formInput\" \nng-submit=\"vm.submit(formInput, 2)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>\nMPN Set PIC</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\"><h2><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon>Please make sure you have chosen the right person!</h2>\n<md-input-container flex><label>Set PIC To</label><md-select ng-model=\"vm.pic\" name=\"pic\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a PIC..\" class=\"header-searchbox md-text\" ng-keydown=\"vm.ketikSearch($event)\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listPIC | filter:vm.searchTerm\" value=\"{{ls.nik}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"formInput.pic.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPIC is required.</span></div></div></md-input-container><md-input-container class=\"md-block mt-10\"><label>Comment\n</label><textarea name=\"notes\" ng-model=\"vm.notes\" md-maxlength=\"200\" max-rows=\"5\" required></textarea><div \nng-messages=\"formInput.notes.$error\" role=\"alert\"><div ng-message=\"required\"><span>Comment is required.</span></div>\n</div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<md-button ng-click=\"vm.closeModal()\" class=\"md-primary\">CANCEL</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" ng-disabled=\"formInput.$invalid || basicForm.$pristine\">\nAPPROVE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpn-gw/mass-role/mass-role-form.html","<md-dialog aria-label=\"Upload\" flex=\"40\" md-theme=\"modal-theme\"><form ng-cloack name=\"FormInput\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,FormInput)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout-gt-sm=\"row\" layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"40\" class=\"pt-20\"><md-input-container \nclass=\"md-block\" flex><label>Business Unit</label><md-select ng-model=\"vm.Form.objForm.bu\" aria-label=\"approval_type\" \nname=\"bu\" required ng-change=\"vm.getWorkLocations()\"><md-option ng-repeat=\"ls in vm.listBu\" \nplaceholder=\"Business Unit\" value=\"{{ls.description}}\">{{ls.description}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"45\" class=\"pt-25\"><md-autocomplete flex required \nmd-input-name=\"autocompleteField\" md-input-minlength=\"2\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.Form.objForm.layer_id\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.description\" md-require-match \nmd-floating-label=\"Layer\" class=\"md-block\"><md-item-template><span md-highlight-text=\"vm.searchText\">\n{{item.description}}</span></md-item-template><div ng-messages=\"FormInput.description.$error\" \nng-if=\"FormInput.description.$touched\"><div ng-message=\"required\">Layer is required</div></div></md-autocomplete></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"FormInput.$invalid || FormInput.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpn-gw/mass-role/mass-role.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">MPN Mass Role Layer</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div layout-gt-xs=\"row\" class=\"mt-40\"></div></form>\n</div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">Entries</span></md-input-container>\n<md-button class=\"md-raised reference-button md-primary md-hue-2\" ng-click=\"vm.createItem($event)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span>Create</span></md-button><md-button \nclass=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.deleteItem($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th>COMPANY</th><th>LAYER ID</th><th>GROUP CLUSTER</th><th>BUSINESS TITLE</th><th>TYPE</th><th>JOB LEVEL\n</th><th>DIVISION</th><th>DEPARTMENT</th><th>INPUT BY</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-class=\"div.mpn_class\"><td><input type=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td>\n{{ ls.company }}</td><td>{{ ls.layer_id }}</td><td>{{ ls.group_cluster }}</td><td>{{ ls.description }}</td><td>\n{{ ls.type }}</td><td>{{ ls.job_level }}</td><td>{{ ls.division }}</td><td>{{ ls.department }}</td><td>\n{{ ls.input_by }}</td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpn-gw/other-business-title/approval-other-business-title.html","<md-dialog aria-label=\"Approval Other Business Title\" md-theme=\"modal-theme\" ms-scroll flex=\"60\" \nid=\"dialog-create-mpp\"><form ng-cloak name=\"formCreateLayerMpp\" class=\"md-inline-form\" novalidate ng-submit=\"\">\n<md-toolbar><div class=\"md-toolbar-tools title\"><h4>Approval Other Business Title</h4><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-progress-linear ng-show=\"vm.loadingProgress\" md-mode=\"indeterminate\">\n</md-progress-linear><md-dialog-content layout-fill style=\"margin-top:0px\"><div layout=\"column\" flex layout-padding>\n<div layout=\"row\" flex layout-align=\"start center\" style=\"padding-top:0px\"><md-input-container \nng-class=\"(!vm.dataApproval.dept_old || !vm.dataApproval.div_old) ? \'md-block\':\'md-block\'\" flex><label>Country</label>\n<md-select ng-model=\"vm.Form.objForm.country\" data-md-container-class=\"selectHeader\" \nng-disabled=\"!vm.superAkses || vm.dataApproval.approval_type == \'services\'\" required \nmd-on-close=\"vm.getCostCenter(vm.Form.objForm.entity_id)\" ng-change=\"vm.getCostCenter(vm.Form.objForm.entity_id)\">\n<md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermCountry\" type=\"search\" \nplaceholder=\"Search for Country\" class=\"header-searchbox md-text\" ng-keydown=\"vm.getCountry(vm.searchTermCountry)\">\n</md-select-header><md-option ng-value=\"item\" ng-repeat=\"item in vm.listDataCountry | filter:vm.searchTermCompany\">\n{{item.description}}</md-option></md-select></md-input-container><md-input-container \nng-class=\"(!vm.dataApproval.dept_old || !vm.dataApproval.div_old) ? \'md-block\':\'md-block\'\" flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.entity_id\" md-on-close=\"vm.getCostCenter(vm.Form.objForm.entity_id)\" \nng-change=\"vm.getListDataDivisi(vm.Form.objForm.entity_id)\" data-md-container-class=\"selectHeader\" \nng-disabled=\"!vm.superAkses || vm.dataApproval.approval_type == \'services\'\" required><md-select-header \nclass=\"select-header\"><input ng-model=\"vm.searchTermCompany\" type=\"search\" placeholder=\"Search for Company\" \nclass=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.listDataCompany | filter:vm.searchTermCompany\">{{item.description}}</md-option></md-select>\n</md-input-container><md-input-container ng-class=\"(!vm.dataApproval.div_old) ? \'layout-row\':\'md-block\'\" flex><label>\nDivision</label><input ng-model=\"vm.Form.objForm.division_new\" type=\"text\" ng-if=\"!vm.dataApproval.div_old\" \nng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-select ng-model=\"vm.Form.objForm.division_id\" \nmd-on-close=\"vm.getListDataDepartment(vm.Form.objForm.division_id)\" data-md-container-class=\"selectHeader\" \nng-disabled=\"vm.dataApproval.div_old || vm.dataApproval.approval_type == \'services\'\" ng-if=\"vm.dataApproval.div_old\">\n<md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermDivisi\" type=\"search\" \nplaceholder=\"Search for Division\" class=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.listDataDivisi | filter:vm.searchTermDivisi\">{{item.description}}</md-option></md-select>\n</md-input-container><md-input-container ng-class=\"(!vm.dataApproval.dept_old) ? \'layout-row\':\'md-block\'\" flex><label>\nDepartment</label><input type=\"text\" name=\"department_new\" ng-model=\"vm.Form.objForm.department_new\" \nng-if=\"!vm.dataApproval.dept_old\" ng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-select \nng-model=\"vm.Form.objForm.department_id\" data-md-container-class=\"selectHeader\" ng-if=\"vm.dataApproval.dept_old\" \nng-disabled=\"vm.dataApproval.dept_old || vm.dataApproval.approval_type == \'services\'\"><md-select-header \nclass=\"select-header\"><input ng-model=\"vm.searchTermDepartment\" type=\"search\" placeholder=\"Search for Department\" \nclass=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.listDataDepartment | filter:vm.searchTermDepartment\">{{item.description}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex layout-align=\"start center\" style=\"padding-top:0px\">\n<md-input-container layout=\"row\" flex><label>Other Business Title</label><input \nng-model=\"vm.Form.objForm.other_business_title\" type=\"text\" required \nng-disabled=\"vm.dataApproval.approval_type == \'services\'\"></md-input-container><md-input-container layout=\"row\" flex>\n<label>Other Business Title Description</label><input ng-model=\"vm.Form.objForm.other_business_title_description\" \ntype=\"text\" required ng-disabled=\"vm.dataApproval.approval_type == \'services\'\"></md-input-container></div><div \nlayout=\"row\" flex layout-align=\"start center\" style=\"padding-top:0px\"><md-input-container class=\"md-block\" flex><label>\nBusiness Title</label><md-select ng-model=\"vm.Form.objForm.bt_code\" \nmd-on-close=\"vm.changeDescription(vm.Form.objForm.bt_code)\" data-md-container-class=\"selectHeader\" \nng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTermBT\" type=\"search\" placeholder=\"Search for Business Title\" class=\"header-searchbox md-text\" \nng-keydown=\"vm.getBusinessTitle(vm.searchTermBT)\"></md-select-header><md-option ng-value=\"item\" \nng-selected=\"vm.Form.objForm.bt_code.id == item.id\" ng-repeat=\"item in vm.listBusinessTitle | filter:vm.searchTermBT\">\n{{item.code_description}}</md-option></md-select></md-input-container><md-input-container flex class=\"md-block\" \nng-hide=\"vm.Form.objForm.isNewJobTitle\"><label>Group Cluster</label><md-select \nng-model=\"vm.Form.objForm.group_cluster\" ng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-option \nng-value=\"item.id\" ng-repeat=\"item in vm.listDataGroupCluster\">{{item.description}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex layout-align=\"start center\" style=\"padding-top:0px\">\n<md-input-container class=\"md-block\" flex><label>Layer Report</label><md-select ng-required=\"vm.newMpp\" \nng-model=\"vm.Form.objForm.layerReport\" name=\"layer_report\" ng-change=\"vm.directReport(vm.Form.objForm.layerReport)\" \nng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTermLr\" type=\"search\" placeholder=\"Search for employee..\" class=\"header-searchbox md-text\" \nng-keydown=\"vm.ketikSearch($event)\"></md-select-header><md-option \nng-repeat=\"ls in vm.layerList | filter:vm.searchTermLr\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmRequest.layer_report.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLayer Report field is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Direct Report</label><md-select ng-required=\"vm.newMpp\" ng-model=\"vm.Form.objForm.other_bt_direct_report\" \nname=\"direct_report\" ng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-select-header class=\"select-header\">\n<input ng-model=\"vm.searchTermDr\" type=\"search\" placeholder=\"Search for employee..\" class=\"header-searchbox md-text\" \nng-keydown=\"vm.ketikSearch($event)\"></md-select-header><md-option \nng-repeat=\"ls in vm.directList | filter:vm.searchTermDr\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmRequest.direct_report.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDirect Report field is required.</span></div></div></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"start center\" style=\"padding-top:0px\"><md-input-container layout=\"row\" flex><label>Description</label>\n<input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" ng-change=\"vm.changeDescriptionBT()\" \nrequired ng-disabled=\"vm.dataApproval.approval_type == \'services\'\"></md-input-container><md-input-container \nlayout=\"row\" class=\"md-block\" flex><label>Layer Type</label><md-select required name=\"type\" \nng-model=\"vm.Form.objForm.type\" ng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-option><em>None</em>\n</md-option><md-option value=\"division\">DIVISION</md-option><md-option value=\"department\">DEPARTMENT</md-option>\n<md-option value=\"function\">FUNCTION</md-option></md-select></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex><label>Cost Center</label><md-select required name=\"costCenter\" \nng-model=\"vm.Form.objForm.cost_center_id\" data-md-container-class=\"selectHeader\"><md-select-header \nclass=\"select-header\"><input ng-model=\"vm.searchTermCostCenter\" type=\"search\" placeholder=\"Search for Cost Center\" \nclass=\"header-searchbox md-text\" ng-keydown=\"vm.getCostCenter(vm.Form.objForm.entity_id)\"></md-select-header>\n<md-option><em>None</em></md-option><md-option ng-repeat=\"ls1 in vm.costCenter | filter:vm.searchTermCostCenter\" \nvalue=\"{{ls1.id}}\">{{ls1.description}}</md-option></md-select></md-input-container><md-input-container flex><label>\nScope</label><md-select required name=\"scope\" ng-model=\"vm.Form.objForm.org_level_id\" \nng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-option ng-repeat=\"ls2 in vm.orgLevel\" value=\"{{ls2.id}}\">\n{{ls2.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Grade Level</label>\n<md-select required name=\"jobLevel\" ng-model=\"vm.Form.objForm.job_level\" \nng-disabled=\"vm.Form.objForm.job_level_set || vm.dataApproval.approval_type == \'services\'\"><md-option><em>None</em>\n</md-option><md-option value=\"1A\">1A</md-option><md-option value=\"1B\">1B</md-option><md-option value=\"1C\">1C\n</md-option><md-option value=\"2A\">2A</md-option><md-option value=\"2B\">2B</md-option><md-option value=\"2C\">2C\n</md-option><md-option value=\"3A\">3A</md-option><md-option value=\"3B\">3B</md-option><md-option value=\"3C\">3C\n</md-option><md-option value=\"4A\">4A</md-option><md-option value=\"4B\">4B</md-option><md-option value=\"4C\">4C\n</md-option><md-option value=\"5A\">5A</md-option><md-option value=\"5B\">5B</md-option><md-option value=\"5C\">5C\n</md-option><md-option value=\"6A\">6A</md-option><md-option value=\"6B\">6B</md-option><md-option value=\"6C\">6C\n</md-option><md-option value=\"7\">7</md-option></md-select></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex><label>Direct Report</label><md-autocomplete \nmd-selected-item=\"vm.Form.objForm.direct_report\" md-selected-item-change=\"vm.selectedItemChange(item, \'indirect\')\" \nmd-search-text=\"vm.searchText.indirect\" md-items=\"item in vm.querySearchIndirect(vm.searchText.indirect)\" \nmd-item-text=\"item.description\" placeholder=\"Search for Indirect Report\" md-min-length=\"3\" \nng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-item-template><span \nmd-highlight-text=\"vm.searchText.indirect\">{{item.description}}</span></md-item-template><md-not-found>\nNo Layer matching \"{{vm.searchText.indirect}}\" were found.</md-not-found></md-autocomplete></md-input-container>\n<md-input-container flex><label>Behavior Layer</label><md-select required name=\"scope\" \nng-model=\"vm.Form.objForm.nodeType\" ng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-option \nng-repeat=\"ls in vm.nodeType\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container></div>\n<div layout=\"row\" flex layout-align=\"start center\"><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex><label>Classification Code</label><md-select required name=\"classification_code\" \nng-model=\"vm.Form.objForm.clasification_code\" ng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-option><em>\nNone</em></md-option><md-option ng-repeat=\"ls in vm.classificationCode\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Sub Area</label><md-select \nname=\"listArea\" ng-model=\"vm.Form.objForm.listArea\" md-on-close=\"vm.clearSearchTerm(4)\" \nng-disabled=\"vm.dataApproval.approval_type == \'services\'\"><md-select-header class=\"select-header\"><input \nng-keydown=\"$event.stopPropagation();vm.getSubArea(vm.Form.objForm.entity_id);\" ng-model=\"vm.searchTermSA\" \ntype=\"search\" placeholder=\"Search for a area..\" class=\"header-searchbox md-text\"></md-select-header><md-option><em>None\n</em></md-option><md-option ng-repeat=\"item in vm.listSubarea | filter:vm.searchTermSA track by item.id\" \nvalue=\"{{item.id}}\">{{item.description}}</md-option></md-select></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" flex><div flex class=\"form-message\" \nng-class=\"{success:vm.success,error:!vm.success}\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{vm.Form.pesan}}</div>\n<div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button \nclass=\"md-raised reference-button md-primary md-hue-3\" ng-click=\"vm.approve($event,formCreateLayerMpp)\" \nng-disabled=\"formCreateLayerMpp.$invalid || vm.dataApproval.approval_status > 1\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><span>Approve</span></md-button><md-button ng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh\">\n</md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpn-gw/other-business-title/other-business-title.html","<style>\n.with-toolbar-content md-toolbar {\n        max-height: 60px;\n        min-height: 60px;\n        background: #ffffff !important;\n    }\n\n    .mpn-completed {\n        font-style: italic;\n        background: #e9ffe7 !important;\n    }\n</style><div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">MPN Online Other Business Title Approval</md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex \nhide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table style=\"font-size: 12px\"><thead><tr><th>NO</th><th>\nMPN NUMBER</th><th>DIVISION</th><th>DEPARTMENT</th><th>BUSINESS TITLE</th><th>BUSINESS TITLE DESCRIPTION</th><th>\nDIRECTION</th><th>APPROVAL STATUS</th><th>#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-class=\"div.mpn_class\"><td class=\"text-center\">{{$index+1}}</td><td class=\"text-center\">{{ ls.mpn_number }}</td><td>\n<span ng-if=\"ls.division_name_old\">{{ ls.division_name_old }}</span> <span ng-if=\"ls.new_division\">\n{{ ls.new_division }}</span></td><td><span ng-if=\"ls.departement_name_old\">{{ ls.departement_name_old }}</span> <span \nng-if=\"ls.new_department\">{{ ls.new_department }}</span></td><td>{{ ls.business_title }}</td><td>{{ ls.description }}\n</td><td class=\"text-center\">{{ ls.org_desc_direction}}</td><td class=\"text-center\"><div \nng-switch=\"ls.approval_status\"><div ng-switch-when=\"0\"><div class=\"info\">None</div></div><div ng-switch-when=\"1\"><div \nclass=\"info\">Waiting Approval</div></div><div ng-switch-when=\"2\"><div class=\"info\">Approve</div></div><div \nng-switch-when=\"3\"><div class=\"info\">Revert</div></div><div ng-switch-when=\"4\"><div class=\"info\">Reject</div></div>\n</div></td><td class=\"text-center\"><md-button aria-label=\"View Request\" class=\"md-icon-button\" \nng-click=\"vm.viewDetailApprove(ls)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>View Request</span></md-tooltip></md-button><md-button \nng-if=\"ls.current_status == \'Draft\' || ls.current_status == \'Revision\'\" aria-label=\"Edit Request\" \nclass=\"md-icon-button\" ng-click=\"vm.edit($event, ls.id)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>Edit Request</span></md-tooltip></md-button>\n</td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.viewData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpn-gw/request/detail.html","<div layout-fill class=\"page-layout scrollable fullwidth carded white-bg\" ms-scroll><md-content class=\"white-bg\" \nlayout-margin><div class=\"md-whiteframe-4dp content rounded\" layout-padding><md-subheader class=\"subheader-sm\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center\"><span>\nACTION {{vm.tipe}} {{vm.mpn.current_status}} {{vm.mpn.setPic}} {{vm.mpn.nik_pic}}</span></div></md-subheader><md-button\n class=\"md-raised reference-button md-info md-hue-3\" ng-click=\"vm.showReplacement($event)\"><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon><span>Replacement List</span></md-button><md-button \nclass=\"md-raised reference-button md-primary md-hue-2\" ng-click=\"vm.submit($event)\" \nng-if=\"vm.tipe==\'requestor\' && (vm.mpn.current_status==\'Draft\' || vm.mpn.current_status==\'Revision\') && vm.mpn.business_title != \'0\' \">\n<md-icon md-font-icon=\"icon-clipboard-check\"></md-icon><span>Submit For Approval</span></md-button><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-click=\"vm.edit($event);\" \nng-if=\"vm.tipe==\'requestor\' && (vm.mpn.current_status==\'Draft\' || vm.mpn.current_status==\'Revision\') && vm.mpn.setDelegate == 0\">\n<md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Edit Request</span></md-button><md-button \nclass=\"md-raised reference-button md-primary md-hue-3\" ng-click=\"vm.setPic($event)\" \nng-if=\"vm.tipe==\'tapic\' && vm.mpn.current_status==\'Approved\' && vm.mpn.setPic == 1 && !vm.mpn.nik_pic \"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Set PIC</span></md-button><md-button \nclass=\"md-raised reference-button md-primary md-hue-3\" ng-click=\"vm.approve($event)\" \nng-if=\"vm.tipe==\'approval\' && vm.mpn.my_status==\'1\' && vm.mpn.setPic == \'0\' && vm.mpn.setVerification == \'0\'\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button><md-button \nclass=\"md-raised reference-button md-primary md-hue-3\" ng-click=\"vm.approve($event)\" \nng-if=\"vm.tipe==\'approval\' && vm.mpn.my_status==\'1\' && vm.mpn.setVerification == \'1\'\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Verication</span></md-button><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-click=\"vm.adminChangeQty($event)\" \nng-if=\"vm.tipe==\'adm-personal\' && vm.mpn.my_status==\'1\'\"><md-icon md-font-icon=\"icon-account-alert\"></md-icon><span>\nChange Qty</span></md-button><md-button class=\"md-raised reference-button md-accent md-hue-3\" \nng-click=\"vm.reject($event, \'Revice\');\" \nng-if=\"(vm.tipe==\'approval\' || vm.tipe==\'adm-personal\') && vm.mpn.my_status==\'1\' \"><md-icon md-font-icon=\"icon-replay\">\n</md-icon><span>Ask to Revise</span></md-button><md-button class=\"md-raised reference-button md-warn md-hue-2\" \nng-click=\"vm.reject($event, \'Reject\');\" ng-if=\"vm.tipe==\'approval\' && vm.mpn.my_status==\'1\' \"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><span>Reject</span></md-button><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-click=\"vm.stopRecruit($event)\" \nng-if=\"vm.tipe==\'approval\' && vm.mpn.setStop==1 && vm.mpn.current_status==\'Approved\' &&\n                vm.mpn.change_head_count==\'0\' \">\n<md-icon md-font-icon=\"icon-account-minus\"></md-icon><span>Change Headcount</span></md-button><md-button \nclass=\"md-raised reference-button md-info md-hue-3\" ng-click=\"vm.showRecruit($event)\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon><span>Recruit List</span></md-button><md-button \nclass=\"md-raised reference-button md-info md-hue-3\" ng-click=\"vm.viewDocument($this, vm.mpn)\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><span>View Document</span></md-button><md-button \nclass=\"md-raised reference-button md-primary md-hue-3\" ng-click=\"vm.approveChangeHeadcount($event)\" \nng-if=\"vm.tipe==\'changeheadcount\' && vm.mpn.my_status_headcount==\'1\' \"><md-icon md-font-icon=\"icon-check\"></md-icon>\n<span>Approve Change Qty</span></md-button><md-button class=\"md-raised reference-button md-warn md-hue-2\" \nng-click=\"vm.reject($event, \'reject change head count\');\" \nng-if=\"vm.tipe==\'changeheadcount\' && vm.mpn.my_status_headcount==\'1\' \"><md-icon md-font-icon=\"icon-close\"></md-icon>\n<span>Reject Change Qty</span></md-button><md-button \nng-if=\"vm.tipe==\'tapic\' && vm.mpn.current_status==\'Approved\' && vm.mpn.is_allow_to_reset\" \nclass=\"md-primary md-raised md-primary-3\" ng-click=\"vm.resetSLT(vm.mpn, $event)\">Reset SLT</md-button><md-button \nng-if=\"vm.mpn.reset_approval\" class=\"md-raised reference-button md-primary\" ng-click=\"vm.approveResetSLT($event);\">\n<md-icon md-font-icon=\"icon-check\"></md-icon><span>Approve Reset SLT</span></md-button><md-button \nng-if=\"vm.mpn.reset_approval\" class=\"md-raised reference-button md-accent md-warn\" \nng-click=\"vm.rejectResetSLT($event);\"><md-icon md-font-icon=\"icon-close\"></md-icon><span>Reject Reset SLT</span>\n</md-button><md-button class=\"md-raised reference-button md-info md-hue-2\" ng-click=\"vm.back()\"><md-icon \nmd-font-icon=\"icon-home\"></md-icon><span>Back</span></md-button></div></md-content><md-content class=\"white-bg\" \nlayout-margin><div class=\"md-whiteframe-4dp content rounded\" layout-padding><md-subheader class=\"subheader-sm\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center\"><span>MAN POWER NEED <strong>( {{vm.mpn.mpn_number}} )</strong></span>\n</div></md-subheader><fieldset layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" layout-padding><legend>\nApproval Status</legend><div layout=\"column\" layout-gt-xs=\"row\" layout-padding ng-init=\"total = 0\"><table \nclass=\"simple approval\"><tr><th style=\"width: 45px\">No</th><th>Section</th><th>Position</th><th>Status</th><th>\nIssued Date</th><th>Lead Time</th></tr><tr><td>1</td><td><span ng-if=\"vm.mpn.is_no_verificator == \'1\' \">REQUESTOR\n</span> <span ng-if=\"vm.mpn.is_no_verificator == \'0\' \">REQUESTOR & VERIFICATOR</span>\n ({{vm.mpn.created_by}} - {{vm.mpn.nama_creator}})</td><td>{{vm.mpn.job_title}}</td><td><div class=\"info\">Requested\n</div></td><td style=\"text-align: center\">{{ vm.formatDate(vm.mpn.created_at) | date : \'dd MMMM yyyy, HH:mm\'}}</td><td>\n-</td></tr><tr ng-repeat=\"lsa in vm.approval\" ng-if=\"vm.mpn.created_by != lsa.approved_by \"><td>{{$index + 2}}</td><td>\n{{lsa.status_position}} ( {{lsa.approved_by}} - {{lsa.nama}} )<md-button \nng-if=\"(lsa.approval_status == 0 && \n                                    vm.mpn.setDelegate == 1 &&\n                                    vm.mpn.current_status == \'Waiting Approval\') \n                                    ||\n                                    (lsa.approval_status == 1 && \n                                    vm.mpn.setDelegate == 1 &&\n                                    vm.mpn.current_status == \'Waiting Approval\')\" \naria-label=\"Delegate\" class=\"md-icon-button\" ng-click=\"vm.setDelegate($event, lsa)\" \nstyle=\"padding: 0;top:-2px;height: 25px;width: 24px;min-height: 20px\"><md-icon md-font-icon=\"icon-account-switch\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>Delegate</span></md-tooltip></md-button><small>{{lsa.comment}}</small>\n</td><td>{{lsa.position}}</td><td style=\"font-weight: bold\"><div ng-switch=\"lsa.approval_status\"><div \nng-switch-when=\"0\"><div class=\"info\">None</div></div><div ng-switch-when=\"1\"><div class=\"info\" \nng-if=\"vm.mpn.current_status == \'Waiting Approval\'\">Waiting Approval</div><div class=\"info\" \nng-if=\"vm.mpn.current_status == \'Draft\' || vm.mpn.current_status\n                                            == \'Revision\'\">\nNone</div></div><div ng-switch-when=\"2\"><div class=\"info\">Approved</div></div><div ng-switch-when=\"3\"><div \nclass=\"info\">Revert</div></div><div ng-switch-when=\"4\"><div class=\"info\">Rejected</div></div></div></td><td \nstyle=\"text-align: center\">{{ vm.formatDate(lsa.approval_date) | date : \'dd MMMM yyyy, HH:mm\'}}</td><td>{{lsa.lt}}</td>\n</tr><tr ng-if=\"vm.approval.length == 0\"><td colspan=\"6\" \nstyle=\"background-color: red; color: silver; text-align: center\"><strong>Waiting for other business title approval\n</strong></td></tr><tr ng-if=\"vm.approval.length > 0\"><td style=\"font-weight: bold;text-align: right\" colspan=\"4\">\nTotal Lead Time</td><td>{{vm.mpn.lt}}</td></tr></table></div></fieldset><fieldset layout=\"column\" \nclass=\"form-fieldset\" layout-align=\"start\" layout-padding ng-if=\"vm.mpn.change_head_count==\'1\'\"><legend>\nChange Head Count Status</legend><div layout=\"column\" flex=\"80\" layout-align=\"center center\"><table \nclass=\"simple approval\"><tr><td></td><td>Old Quantity</td><td>New Quantity</td><td>Residual</td></tr><tr><th>\nReplacement</th><td>{{vm.mpn.qty_replacement}}</td><td>{{vm.mpn.final_qty_replacement}}</td><td>\n{{vm.mpn.qty_replacement - vm.mpn.final_qty_replacement}}</td></tr><tr><th>New</th><td>{{vm.mpn.qty_new}}</td><td>\n{{vm.mpn.final_qty_new}}</td><td>{{vm.mpn.qty_new - vm.mpn.final_qty_new}}</td></tr><tr><th>Total</th><td>\n{{vm.mpn.qty_total}}</td><td>{{vm.mpn.final_qty_replacement + vm.mpn.final_qty_new}}</td><td>\n{{ vm.mpn.qty_total - (vm.mpn.final_qty_replacement + vm.mpn.final_qty_new)}}</td></tr></table></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-padding ng-init=\"total = 0\"><table class=\"simple approval\"><tr><th \nstyle=\"width: 45px\">No</th><th>Section</th><th>Status</th><th>Issued Date</th><th>Lead Time</th></tr><tr><td>1</td><td>\nRequestor {{vm.mpn.change_head_count_by}} - {{vm.mpn.nama_creator}}</td><td><div class=\"info\">Requested</div></td><td \nstyle=\"text-align: center\">{{ vm.formatDate(vm.mpn.change_head_count_date) | date : \'dd MMMM yyyy, HH:mm\'}}</td><td>-\n</td></tr><tr ng-repeat=\"lsa in vm.approvalHeadcount\"><td>{{$index + 2}}</td><td>\n{{lsa.position}} ( {{lsa.approved_by}} - {{lsa.nama}} )<md-button \nng-if=\"(lsa.approval_status == 0 && \n                                    vm.mpn.setDelegate == 1 &&\n                                    vm.mpn.current_status == \'Waiting Approval\') \n                                    ||\n                                    (lsa.approval_status == 1 && \n                                    vm.mpn.setDelegate == 1 &&\n                                    vm.mpn.current_status == \'Waiting Approval\')\" \naria-label=\"Delegate\" class=\"md-icon-button\" ng-click=\"vm.setDelegate($event, lsa)\" \nstyle=\"padding: 0;top:-2px;height: 25px;width: 24px;min-height: 20px\"><md-icon md-font-icon=\"icon-account-switch\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>Delegate</span></md-tooltip></md-button><small>{{lsa.comment}}</small>\n</td><td style=\"font-weight: bold\"><div ng-switch=\"lsa.approval_status\"><div ng-switch-when=\"0\"><div class=\"info\">None\n</div></div><div ng-switch-when=\"1\"><div class=\"info\" ng-if=\"vm.mpn.current_status == \'Approved\'\">Waiting Approval\n</div><div class=\"info\" \nng-if=\"vm.mpn.current_status == \'Draft\' || vm.mpn.current_status\n                                            == \'Revision\'\">\nNone</div></div><div ng-switch-when=\"2\"><div class=\"info\">Approve</div></div><div ng-switch-when=\"3\"><div class=\"info\">\nRevert</div></div><div ng-switch-when=\"4\"><div class=\"info\">Reject</div></div></div></td><td \nstyle=\"text-align: center\">{{ vm.formatDate(lsa.approval_date) | date : \'dd MMMM yyyy, HH:mm\'}}</td><td>{{lsa.lt}}</td>\n</tr><tr><td style=\"font-weight: bold;text-align: right\" colspan=\"4\">Total Lead Time</td><td>{{vm.mpn.lt}}</td></tr>\n</table></div></fieldset><fieldset layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" layout-padding \nng-repeat=\"ls in vm.resetSLT\"><legend>Reset SLT - {{$index+1}}</legend><div layout=\"row\" flex><md-input-container \nflex=\"30\"><div class=\"md-subhead\"><strong>Reset To</strong></div><div class=\"info\">\n{{ vm.formatDate(ls.date_reset) | date : \'dd MMMM yyyy\'}}</div><md-divider></md-divider></md-input-container>\n<md-input-container flex=\"70\"><div class=\"md-subhead\"><strong>Reason</strong></div><div class=\"info\">{{ls.reason}}\n</div><md-divider></md-divider></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" layout-padding \nng-init=\"total = 0\"><table class=\"simple approval\"><tr><th style=\"width: 45px\">No</th><th>Section</th><th>Status</th>\n<th>Issued Date</th><th>Lead Time</th></tr><tr><td>1</td><td>Requestor {{ls.request_by}} - {{ls.nama}}</td><td><div \nclass=\"info\">Requested</div></td><td style=\"text-align: center\">\n{{ vm.formatDate(ls.timestamp) | date : \'dd MMMM yyyy, HH:mm\'}}</td><td>-</td></tr><tr ng-repeat=\"lsa in ls.approval\">\n<td>{{$index + 2}}</td><td>{{lsa.POSITION}} ( {{lsa.approved_by}} - {{lsa.nama}} ) <small>{{lsa.reject_comment}}\n</small></td><td style=\"font-weight: bold\"><div ng-switch=\"lsa.approval_status\"><div ng-switch-when=\"0\"><div \nclass=\"info\">None</div></div><div ng-switch-when=\"1\"><div class=\"info\">Waiting Approval</div></div><div \nng-switch-when=\"2\"><div class=\"info\">Approved</div></div><div ng-switch-when=\"3\"><div class=\"info\">Revert</div></div>\n<div ng-switch-when=\"4\"><div class=\"info\">Rejected</div></div></div></td><td style=\"text-align: center\">\n{{ vm.formatDate(lsa.approval_date) | date : \'dd MMMM yyyy, HH:mm\'}}</td><td>{{lsa.lt}}</td></tr><tr><td \nstyle=\"font-weight: bold;text-align: right\" colspan=\"4\">Total Lead Time</td><td>{{vm.mpn.lt}}</td></tr></table></div>\n</fieldset><fieldset layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" layout-padding><legend>Position Details\n</legend><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><div layout=\"column\" flex><md-input-container flex><div\n class=\"md-subhead\"><strong>MPN Number</strong></div><div class=\"info\">{{vm.mpn.mpn_number}}</div><md-divider>\n</md-divider></md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>Company</strong></div><div \nclass=\"info\">{{vm.mpn.company}}</div><md-divider></md-divider></md-input-container><md-input-container flex><div \nclass=\"md-subhead\"><strong>Business Title</strong></div><div class=\"info\">{{vm.mpn.business_title_name}}</div>\n<md-divider></md-divider></md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>Clasification\n</strong></div><div class=\"info\">{{vm.mpn.clasification_code}} ( {{vm.mpn.clasification_desc}} )</div><md-divider>\n</md-divider></md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>MPP Type</strong></div><div \nclass=\"info\">{{vm.mpn.budget_type}}</div><md-divider></md-divider></md-input-container><md-input-container flex \nng-if=\"vm.mpn.quantity_flag == \'0\' \"><div class=\"md-subhead\"><strong>Quantity</strong></div><div class=\"info\"><strong>\nReplacement Qty : </strong>{{vm.mpn.qty_replacement}} ; &nbsp;&nbsp;&nbsp; <strong>New Qty : </strong>\n{{vm.mpn.qty_new}} ; &nbsp;&nbsp;&nbsp; <strong>Total Qty : </strong>{{vm.mpn.qty_total}} ;</div><md-divider>\n</md-divider></md-input-container><md-input-container flex ng-if=\"vm.mpn.quantity_flag == \'1\' \"><div \nclass=\"md-subhead\"><strong>Quantity</strong></div><div class=\"info\"><strong>Replacement Qty : </strong>\n{{vm.mpn.final_qty_replacement}} ; &nbsp;&nbsp;&nbsp; <strong>New Qty : </strong>\n{{vm.mpn.final_qty_new}} ; &nbsp;&nbsp;&nbsp; <strong>Total Qty : </strong>\n{{vm.mpn.final_qty_new + vm.mpn.final_qty_replacement}} ;</div><md-divider></md-divider></md-input-container></div><div\n layout=\"column\" flex><md-input-container flex><div class=\"md-subhead\"><strong>Cost Center</strong></div><div \nclass=\"info\">{{vm.mpn.costcenter}}</div><md-divider></md-divider></md-input-container><md-input-container flex><div \nclass=\"md-subhead\"><strong>Division</strong></div><div class=\"info\">{{vm.mpn.division}}</div><md-divider></md-divider>\n</md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>Requestor</strong></div><div \nclass=\"info\">{{vm.mpn.nama_creator}}</div><md-divider></md-divider></md-input-container><md-input-container flex><div \nclass=\"md-subhead\"><strong>Employee Status</strong></div><div class=\"info\">{{vm.mpn.employment_status}}</div>\n<md-divider></md-divider></md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>\nPreferrable Gender</strong></div><div class=\"info\">{{vm.mpn.pref_gender}}</div><md-divider></md-divider>\n</md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>Expected Join Date</strong></div><div \nclass=\"info\">{{vm.mpn.expected_join_date}}</div><md-divider></md-divider></md-input-container></div><div \nlayout=\"column\" flex><md-input-container flex><div class=\"md-subhead\"><strong>Country</strong></div><div class=\"info\">\n{{vm.mpn.country_id}}</div><md-divider></md-divider></md-input-container><md-input-container flex><div \nclass=\"md-subhead\"><strong>Department</strong></div><div class=\"info\">{{vm.mpn.department}}</div><md-divider>\n</md-divider></md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>Grade</strong></div><div \nclass=\"info\">Grade {{vm.mpn.emp_grade}}</div><md-divider></md-divider></md-input-container><md-input-container flex>\n<div class=\"md-subhead\"><strong>Work Location</strong></div><div class=\"info\">{{vm.mpn.work_location_name}}</div>\n<md-divider></md-divider></md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>PIC</strong>\n</div><div class=\"info\">{{vm.mpn.nik_pic}} - {{vm.mpn.nama_pic}}</div><md-divider></md-divider></md-input-container>\n<md-input-container flex><div class=\"md-subhead\"><strong>Vacancy Close Date</strong></div><div class=\"info\">\n{{vm.mpn.vacancy_close_date}}</div><md-divider></md-divider></md-input-container></div></div><div layout=\"column\"><div \nclass=\"container-content\"><md-subheader class=\"content-header\"><div layout=\"row\" flex=\"100\" layout-align=\"center\">\n<span>Reason</span></div></md-subheader><p ng-bind-html=\"vm.mpn.reason\"></p></div></div></fieldset><fieldset \nlayout=\"column\" class=\"form-fieldset\" layout-align=\"start\" layout-padding><legend>\nResponsibilities And Qualification Details</legend><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><div \nlayout=\"column\" flex flex-gt-xs=\"50\"><div class=\"container-content\"><md-subheader class=\"content-header\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center\"><span>Short Job Description / Responsibilities</span></div>\n</md-subheader><p ng-bind-html=\"vm.mpn.job_desc\"></p></div><div class=\"container-content\"><md-subheader \nclass=\"content-header\"><div layout=\"row\" flex=\"100\" layout-align=\"center\"><span>Functional Competencies</span></div>\n</md-subheader><div class=\"content-input\"><p ng-bind-html=\"vm.mpn.job_func\"></p></div></div><div \nclass=\"container-content\"><md-subheader class=\"content-header\"><div layout=\"row\" flex=\"100\" layout-align=\"center\">\n<span>KPI 3 Month</span></div></md-subheader><div class=\"content-input\"><p ng-bind-html=\"vm.mpn.kpi\"></p></div></div>\n</div><div layout=\"column\" flex><div class=\"container-content\"><md-subheader class=\"content-header\"><div layout=\"row\" \nflex=\"100\" layout-align=\"center\"><span>Qualification</span></div></md-subheader><div class=\"content-input\" \nlayout=\"column\"><md-input-container flex><div class=\"md-subhead\"><strong>Experience</strong></div><div \nng-switch=\"vm.mpn.experience\"><div ng-switch-when=\"0\"><div class=\"info\">None</div></div><div ng-switch-when=\"1\"><div \nclass=\"info\">Less than 1 year</div></div><div ng-switch-when=\"2\"><div class=\"info\">1 - 3 year</div></div><div \nng-switch-when=\"3\"><div class=\"info\">More than 1 year</div></div></div><md-divider></md-divider></md-input-container>\n<div class=\"form-inline\"><label for=\"ageRange\"><strong>Min Age : </strong>{{vm.mpn.age_min}}</label><label \nfor=\"ageRange\"><strong>Max Age : </strong>{{vm.mpn.age_max}}</label><md-divider></md-divider></div><md-input-container \nflex><div class=\"md-subhead\"><strong>Education</strong></div><div class=\"info\">{{vm.mpn.education}}</div><md-divider>\n</md-divider></md-input-container><md-input-container flex><div class=\"md-subhead\"><strong>Major</strong></div><div \nclass=\"info\">{{vm.mpn.major}}</div><md-divider></md-divider></md-input-container><div class=\"container-content\">\n<md-subheader class=\"content-header\"><div layout=\"row\" flex=\"100\" layout-align=\"center\"><span>Note (if any)</span>\n</div></md-subheader><div class=\"content-input\"><p ng-bind-html=\"vm.mpn.qualification_note\"></p></div></div></div>\n</div><div class=\"container-content\"><md-subheader class=\"content-header\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center\"><span>Things you need to know</span></div></md-subheader><div class=\"content-anouncement\" \nlayout=\"row\"><div flex-gt-xs=\"50\" flex><p>Standard Lead Time (in average)</p><table class=\"grade-list-announcement\">\n<tr><td>Grade 1</td><td style=\"width: 5%\">:</td><td>{{vm.sltLabel[0]}}</td><td>Days</td></tr><tr><td>Grade 2</td><td \nstyle=\"width: 5%\">:</td><td>{{vm.sltLabel[1]}}</td><td>Days</td></tr><tr><td>Grade 3</td><td style=\"width: 5%\">:</td>\n<td>{{vm.sltLabel[2]}}</td><td>Days</td></tr><tr><td>Grade 4</td><td style=\"width: 5%\">:</td><td>{{vm.sltLabel[3]}}\n</td><td>Days</td></tr><tr><td>Grade 5</td><td style=\"width: 5%\">:</td><td>{{vm.sltLabel[4]}}</td><td>Days</td></tr>\n<tr><td>Grade 6 Above</td><td style=\"width: 5%\">:</td><td>{{vm.sltLabel[5]}}</td><td>Days</td></tr></table><p><small>\n<b><u>Note :</u></b><br>\nThe proccess could be faster/longer depends on the users and candidates availabillity for interview schedule.</small>\n</p></div><span flex=\"5\"></span><div flex class=\"contact-person\"><p><b>Contact Person</b></p><p><b>Supervisory below\n</b></p><p ng-if=\"vm.company == \'KS\' \"><u>Manufacturing and GSC</u></p><p ng-repeat=\"ls in vm.cp\">{{ls}}</p></div>\n</div></div></div></div></fieldset></div></md-content><md-content class=\"white-bg\" layout-margin><div \nclass=\"md-whiteframe-4dp content rounded\" layout-padding><md-subheader class=\"subheader-sm\"><div layout=\"row\" \nflex=\"100\" layout-align=\"center\"><span>MAN POWER NEED COMENTS</span></div></md-subheader><div class=\"timeline\" \nlayout=\"column\"><div class=\"timeline-item md-whiteframe-1dp\"><footer class=\"\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"comment-count\">{{vm.commnet.length}} comments<md-icon \nmd-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill \nng-repeat=\"comment in vm.comment\"><div flex layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"username\">{{comment.nik}} - {{comment.nama}}</span> <span class=\"time\">{{comment.timestamp}}</span></div><div \nclass=\"message\">{{comment.comment}}</div></div></div><div class=\"reply\" layout=\"row\" layout-align=\"end center\" \nlayout-fill><form flex><textarea placeholder=\"Add a comment...\" ng-model=\"vm.newComment\"></textarea><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.postComment()\" class=\"post-comment-button md-accent md-raised\" \naria-label=\"Post Comment\">Post Comment</md-button></div></form></div></footer></div></div></div></md-content></div>");
$templateCache.put("app/main/mpn-gw/request/list.html","<style>\n.with-toolbar-content md-toolbar {\n        max-height: 60px;\n        min-height: 60px;\n        background: #ffffff !important;\n    }\n\n    .mpn-completed {\n        font-style: italic;\n        background: #e9ffe7 !important;\n    }\n</style><div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">MPN Online</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\">\n<md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\" ng-change=\"vm.loadBt(vm.department)\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.btcode\" name=\"businessTitle\"><md-option placeholder=\"Business Title\" \nng-repeat=\"ls in vm.listBt\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container></div><div\n layout-gt-xs=\"row\" class=\"mt-40\"><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label>Start Request Date\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.START_DATE\' | translate }}\" name=\"tglmulai\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label>End Request Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.END_DATE\' | translate }}\" name=\"tglakhir\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><md-select ng-model=\"vm.approvalStatus\" \nname=\"approvalStatus\"><md-option ng-repeat=\"ls in vm.listApprovalStatus\" placeholder=\"Approval Status\" \nvalue=\"{{ls.id}}\">{{ls.desc}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\"><md-select ng-model=\"vm.budgetType\" name=\"budgetType\"><md-option ng-repeat=\"ls in vm.listBudgetType\" \nplaceholder=\"Budget Type\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">\nEntries</span></md-input-container><md-button class=\"md-raised reference-button md-primary md-hue-2\" \nui-sref=\"app.mpn_gw_request\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Create MPN</span></md-button>\n<md-button class=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.deleteRequest($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete MPN</span></md-button><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-click=\"vm.exportToExcel($event)\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span>Export to Excel MPN</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th>MPN NUMBER</th><th>WORK LOCATION</th><th>DIVISION</th><th>DEPARTMENT</th><th>BUSINESS TITLE</th><th>\nBUDGET TYPE</th><th>APPROVAL STATUS</th><th>REQUEST DATE</th><th>MPN STATUS</th><th>TA PIC</th><th>VACANCY CLOSE</th>\n<th>#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td \nng-if=\"ls.current_status == \'Draft\'\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"ls\">\n</td><td ng-if=\"ls.current_status != \'Draft\'\"></td><td>{{ ls.mpn_number }}</td><td>{{ ls.work_location }}</td><td>\n{{ ls.division }}</td><td>{{ ls.department }}</td><td>{{ ls.business_title }}</td><td>{{ ls.budget_type}}</td><td>\n{{ ls.current_status}}</td><td>{{ ls.created_at }}</td><td>{{ ls.mpn_status }}</td><td>{{ ls.nama_pic }}</td><td>\n{{ ls.vacancy_close_date }}</td><td><md-button aria-label=\"View Request\" class=\"md-icon-button\" \nng-click=\"vm.viewDetail(ls.id)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>View Request</span></md-tooltip></md-button><md-button \nng-if=\"ls.current_status == \'Draft\' || ls.current_status == \'Revision\'\" aria-label=\"Edit Request\" \nclass=\"md-icon-button\" ng-click=\"vm.edit($event, ls.id)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>Edit Request</span></md-tooltip></md-button>\n</td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpn-gw/request/replacement.list.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Replacement List</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><div\n layout=\"column\"><table class=\"simple bordered\" ms-responsive-table><thead><tr><th class=\"secondary-text\" flex=\"10\">\n<div class=\"table-header\"><span class=\"column-title\">NO</span></div></th><th class=\"secondary-text\" flex=\"40\"><div \nclass=\"table-header\"><span class=\"column-title\">NIK</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Position</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Sub Area</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Building</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Replacement Type</span></div></th><th class=\"secondary-text\" flex=\"20\">\n<div class=\"table-header\"><span class=\"column-title\">Effective Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"lsd in vm.data\"><td>{{$index+1}}</td><td>{{lsd.nik}}</td><td>{{lsd.nama}}</td><td>{{lsd.position}}</td><td>\n{{lsd.subarea}}</td><td>{{lsd.gedung_name}}</td><td>{{lsd.replacement_type}}</td><td>{{lsd.effective_date}}</td></tr>\n</tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/mpn-gw/request/replacement.upload.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Upload Replacement</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><md-content layout=\"column\"><div layout-gt-sm=\"column\">\n<md-input-container><input type=\"file\" id=\"uploadPhoto\" name=\"shifttemplate\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadshifttemplate\',\n                                                        bt: vm.bt_ }]}\">\n</md-input-container></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload File</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload File</span></md-whiteframe></md-content><md-content layout=\"column\" class=\"mt-20\" \nng-if=\"vm.failed > 0\"><fieldset layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" layout-padding><legend>\nFailed Upload</legend><div layout=\"column\" ms-scroll><md-button class=\"md-primary\" ng-click=\"vm.downloadFailed()\">\n<md-icon md-font-icon=\"icon-download\"></md-icon>Download Failed List</md-button><table class=\"simple bordered\" \nms-responsive-table><thead><tr><th class=\"secondary-text\" flex=\"10\"><div class=\"table-header\"><span \nclass=\"column-title\">NO</span></div></th><th class=\"secondary-text\" flex=\"40\"><div class=\"table-header\"><span \nclass=\"column-title\">NIK</span></div></th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span \nclass=\"column-title\">Reason</span></div></th></tr></thead><tbody><tr ng-repeat=\"lsd in vm.dataReplacementFailed\"><td>\n{{$index+1}}</td><td>{{lsd.nik}}</td><td>{{lsd.reason}}</td></tr></tbody></table></div></fieldset></md-content>\n<md-content layout=\"column\" class=\"mt-20\"><fieldset layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" \nlayout-padding><legend>Replacement</legend><div id=\"item\" layout=\"column\" layout-gt-xs=\"row\" flex><md-autocomplete \nflex class=\"input-height test\" required md-no-cache=\"true\" md-selected-item=\"item.selectedItem\" \nmd-selected-item-change=\"vm.choose(item)\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText, $index)\" md-item-text=\"item.description\" md-delay=\"300\" \nmd-escape-options=\"clear\" md-floating-label=\"Search Employee\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\">{{item.description}}</span></md-item-template></md-autocomplete><md-input-container \nflex class=\"input-height test\"><label>Replacement Type</label><md-select name=\"reason\" placholder=\"Replacement Type\" \nng-model=\"vm.replacement_type\"><md-option ng-repeat=\"ls in vm.listReplacementType\" value=\"{{ls}}\">{{ls}}</md-option>\n</md-select></md-input-container><md-input-container flex class=\"input-height test\"><label>Effective Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" ng-model=\"vm.effective_date\" required></md-datepicker>\n</md-input-container><md-input-container flex><md-button ng-click=\"vm.tambah()\" \nclass=\"md-icon-button md-accent md-button md-default-theme md-ink-ripple\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-plus-circle material-icons\"></md-icon></md-button></md-input-container></div><div layout=\"column\" \nms-scroll><table class=\"simple bordered\" ms-responsive-table><thead><tr><th class=\"secondary-text\" flex=\"10\"><div \nclass=\"table-header\"><span class=\"column-title\">NO</span></div></th><th class=\"secondary-text\" flex=\"40\"><div \nclass=\"table-header\"><span class=\"column-title\">NIK</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Subarea</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Building</span></div></th><th class=\"secondary-text\" flex=\"20\"><div \nclass=\"table-header\"><span class=\"column-title\">Replacement Type</span></div></th><th class=\"secondary-text\" flex=\"20\">\n<div class=\"table-header\"><span class=\"column-title\">Effective Date</span></div></th><th class=\"secondary-text\" \nflex=\"20\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"lsd in vm.dataReplacement\"><td>{{$index+1}}</td><td>{{lsd.nik}}</td><td>{{lsd.nama}}</td><td>{{lsd.subarea}}\n</td><td>{{lsd.gedung}}</td><td>{{lsd.replacement_type}}</td><td>{{lsd.effective_date}}</td><td><md-button \nng-click=\"vm.hapus(lsd)\" class=\"md-icon-button md-warn md-button md-default-theme md-ink-ripple\"><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-close-circle material-icons\"></md-icon></md-button></td></tr>\n</tbody></table></div></fieldset></md-content></md-dialog-content><md-dialog-actions class=\"md-background-bg\">\n<md-button ng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-primary\"><md-icon md-font-icon=\"icon-upload\">\n</md-icon>Upload</md-button><md-button class=\"md-primary\" ng-click=\"vm.downloadFormat()\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon>Download Format</md-button><md-button ng-click=\"vm.selesai()\" \nclass=\"md-primary\">Done</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mpn-gw/request/request.html","<form name=\"frmRequest\" ng-cloack novalidate><div ng-init=\"vm.initForm(frmRequest)\"></div><div id=\"mpn-gw-request\" \nlayout-fill class=\"carded white-bg\"><md-content class=\"white-bg\" layout-margin><div \nclass=\"md-whiteframe-4dp content rounded\" layout-padding><md-subheader class=\"subheader-sm\"><div layout=\"row\" \nflex=\"100\" layout-align=\"center\"><span><strong>POSITION DETAIL</strong></span></div></md-subheader><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-padding flex><blockquote><p>\nIf you cannot found the business title you want to request, please select <span style=\"color:red\">\"OTHERS\"</span>\n or kindly reach out to <span style=\"color:red\">Corporate Talent Management Team</span></p><footer><span \nstyle=\"color:red\">TM Contact Person: </span>Fiska Kireina fiska.kireina@nabatisnack.co.id</footer></blockquote></div>\n<div layout=\"column\" layout-gt-xs=\"row\" layout-padding flex><md-input-container flex ng-if=\"!vm.otherDivision\"><label>\nDivision</label><md-select ng-required=\"!vm.otherDivision\" ng-disabled=\"vm.rule.division\" \nng-model=\"vm.Form.objForm.division_id\" name=\"division\" ng-change=\"vm.loadDataDepartment(vm.Form.objForm.division_id)\">\n<md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermDiv\" type=\"search\" \nplaceholder=\"Search division..\" class=\"header-searchbox md-text\" ng-keydown=\"vm.ketikSearch($event)\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listDivision | filter:vm.searchTermDiv\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmRequest.division.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Division field is required.</span></div></div></md-input-container><md-input-container \nflex ng-if=\"vm.otherDivision\"><label>Other Division</label><input type=\"text\" name=\"newDivision\" \nng-model=\"vm.Form.objForm.other_bt_new_division\" ng-required=\"vm.otherDivision\"><md-icon \nmd-font-icon=\"icon-backup-restore\" ng-click=\"vm.setOtherDivision(0)\"></md-icon><div \nng-messages=\"frmRequest.newDivision.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNew Division field is required.</span></div></div></md-input-container><md-input-container flex \nng-if=\"!vm.otherDepartment\"><label>Department</label><md-select ng-disabled=\"vm.rule.department\" \nng-model=\"vm.Form.objForm.department_id\" name=\"department\" ng-change=\"vm.loadBt(vm.Form.objForm.department_id)\" \nng-required=\"!vm.otherDepartment\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermDep\" \ntype=\"search\" placeholder=\"Search division..\" class=\"header-searchbox md-text\" ng-keydown=\"vm.ketikSearch($event)\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listDepartment | filter:vm.searchTermDep\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmRequest.department.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container><md-input-container \nflex ng-if=\"vm.otherDepartment\"><label>New Department</label><input type=\"text\" name=\"newDepartment\" \nng-model=\"vm.Form.objForm.other_bt_new_department\" ng-required=\"vm.otherDepartment\"><md-icon \nmd-font-icon=\"icon-backup-restore\" ng-click=\"vm.setOtherDepartment(0)\"></md-icon><div \nng-messages=\"frmRequest.newDepartment.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNew Department field is required.</span></div></div></md-input-container><md-input-container flex ng-if=\"!vm.otherBT\">\n<label>Business Title</label><md-select ng-model=\"vm.Form.objForm.layer_id\" name=\"businessTitle\" \nng-disabled=\"vm.Form.objForm.other_bt\" ng-change=\"vm.loadCompetency(vm.Form.objForm.layer_id)\" \nng-required=\"!vm.otherBT\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermBt\" type=\"search\" \nplaceholder=\"Search business title..\" class=\"header-searchbox md-text\" ng-keydown=\"vm.ketikSearch($event)\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listBt | filter:vm.searchTermBt\" value=\"{{ls.layer_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmRequest.businessTitle.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Business title field is required.</span></div></div></md-input-container>\n<md-input-container flex ng-if=\"vm.otherBT\"><label>New Business Title</label><input type=\"text\" name=\"other_bt_name\" \nng-model=\"vm.Form.objForm.other_bt_name\" ng-required=\"vm.otherBT\"><md-icon md-font-icon=\"icon-backup-restore\" \nng-click=\"vm.setOtherBusinessTitle(0)\"></md-icon><div ng-messages=\"frmRequest.other_bt_name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>New Business Title field is required.</span></div></div></md-input-container></div><div \nflex ng-if=\"vm.newMpp && !vm.Form.objForm.other_bt\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-subheader \nclass=\"content-header\" flex><div layout=\"row\" flex layout-align=\"center\"><span>Set Direct Report</span></div>\n</md-subheader></div><div layout=\"column\" layout-gt-xs=\"row\"><div layout=\"row\" flex layout-padding><md-input-container \nflex=\"30\"><label>Layer Report</label><md-select ng-required=\"vm.newMpp\" ng-model=\"vm.layerReport\" name=\"layer_report\" \nng-change=\"vm.directReport(vm.layerReport)\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTermLr\" \ntype=\"search\" placeholder=\"Search for employee..\" class=\"header-searchbox md-text\" ng-keydown=\"vm.ketikSearch($event)\">\n</md-select-header><md-option ng-repeat=\"ls in vm.layerList | filter:vm.searchTermLr\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmRequest.layer_report.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Layer Report field is required.</span></div></div></md-input-container><md-input-container \nflex=\"35\"><label>Direct Report</label><md-select ng-required=\"vm.newMpp\" \nng-model=\"vm.Form.objForm.other_bt_direct_report\" name=\"direct_report\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTermDr\" type=\"search\" placeholder=\"Search for employee..\" class=\"header-searchbox md-text\" \nng-keydown=\"vm.ketikSearch($event)\"></md-select-header><md-option \nng-repeat=\"ls in vm.directList | filter:vm.searchTermDr\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmRequest.direct_report.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDirect Report field is required.</span></div></div></md-input-container></div></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-padding flex><md-input-container flex><label>MPP Type</label><md-select \nng-model=\"vm.Form.objForm.budget_type\" name=\"mppType\" ng-disabled=\"vm.rule.budget\"><md-option \nng-repeat=\"ls in vm.mppTypeList\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-input-container \nflex><label for=\"qty\">Replacement Qty</label><input type=\"number\" id=\"qtyReplacement\" name=\"qtyReplacement\" \nng-readonly=\"true\" ng-model=\"vm.Form.objForm.qty_replacement\" required min=\"0\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\" ng-if=\"!vm.otherBT\" ng-click=\"vm.uploadReplacement($event)\"></md-icon><div \nng-messages=\"frmRequest.qtyReplacement.$error\" role=\"alert\"><div ng-message=\"required\"><span>Put \"0\" if you not needed\n</span></div><div ng-message=\"min\"><span>Minimum qty is \"0\"</span></div></div></md-input-container><md-input-container \nflex><label for=\"qty\">New Hire Qty</label><input type=\"number\" id=\"qtyNew\" name=\"qtyNew\" \nng-model=\"vm.Form.objForm.qty_new\" ng-keyup=\"vm.cekQty()\" required min=\"0\"><div ng-messages=\"frmRequest.qtyNew.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Put \"0\" if you not needed</span></div><div ng-message=\"min\"><span>\nMinimum qty is \"0\"</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" layout-padding \nflex><md-input-container flex><label>Work Location</label><md-select ng-model=\"vm.Form.objForm.work_location\" \nname=\"workLocation\" required ng-disabled=\"vm.rule.work_location\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" class=\"header-searchbox md-text\" placeholder=\"Search work location..\" \nng-keydown=\"vm.ketikSearch($event)\"></md-select-header><md-option \nng-repeat=\"ls in vm.listLocations | filter:vm.searchTerm\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmRequest.workLocation.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWork location field is required.</span></div></div></md-input-container><md-input-container flex><label>Point Of Hiring\n</label><md-select ng-model=\"vm.Form.objForm.point_of_hiring\" name=\"pointOfHiring\" required><md-select-header><input \nng-model=\"vm.searchTermPoint\" type=\"search\" class=\"header-searchbox md-text\" placeholder=\"Search work location..\" \nng-keydown=\"vm.ketikSearch($event)\"></md-select-header><md-option \nng-repeat=\"ls in vm.listLocations | filter:vm.searchTermPoint\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmRequest.pointOfHiring.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPoint Of Hiring field is required.</span></div></div></md-input-container><md-input-container flex><label>\nEmployee Status</label><md-select ng-model=\"vm.Form.objForm.employment_status\" name=\"empStatus\" required><md-option \nng-repeat=\"ls in vm.EmploymentStatus\" value=\"{{ls}}\">{{ls}}</md-option></md-select><div \nng-messages=\"frmRequest.empStatus.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee status field is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-padding flex><md-input-container flex><label>Preferrable Gender</label><md-select \nng-model=\"vm.Form.objForm.pref_gender\" name=\"gender\" required><md-option ng-repeat=\"ls in vm.genderList\" \nvalue=\"{{ls}}\">{{ls}}</md-option></md-select><div ng-messages=\"frmRequest.gender.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Gender field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Expected Join Date</label><md-datepicker md-hide-icons=\"calendar\" md-open-on-focus \nng-model=\"vm.Form.objForm.expected_join_date\" md-current-view=\"month\" name=\"expectedJoinDate\" md-min-date=\"vm.minDate\" \nrequired></md-datepicker><div ng-messages=\"frmRequest.expectedJoinDate.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Expected join date field is required.</span></div></div></md-input-container><md-input-container flex><label>\nEmployee Grade</label><md-select ng-model=\"vm.Form.objForm.emp_grade\" name=\"grade\" ng-click=\"vm.setSlt()\" \nng-disabled=\"vm.rule.grade\" ng-required=\"!vm.Form.objForm.other_bt\"><md-option ng-repeat=\"ls in vm.gradeList\" \nvalue=\"{{ls}}\">{{ls}}</md-option></md-select><div ng-messages=\"frmRequest.grade.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Grade field is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-padding flex><md-input-container><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked\" \nng-click=\"vm.checkIsNeddFile()\" ng-model=\"vm.isNeddUploadFile\" aria-label=\"\"><span \ntranslate=\"HCTICKET.MENU.NEEDUPLOAD\"></span></md-checkbox></md-input-container><md-input-container \nng-if=\"vm.Form.objForm.attachment_link\"><a ng-click=\"vm.viewDocument($this, vm.mpn)\"><md-icon md-font-icon=\"icon-eye\">\n</md-icon>View Document</a></md-input-container><md-input-container ng-if=\"vm.isChecked\" md-no-float class=\"md-block\" \nflex><input type=\"file\" id=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n                          action:\'uploadData\',\n                          user: vm.nik,\n                          layer_id: vm.Form.objForm.layer_id,\n                          date: vm.Form.objForm.created_at                    \n                        }] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" layout-padding flex><md-input-container flex><md-subheader \nclass=\"content-header\"><div layout=\"row\" flex=\"100\" layout-align=\"center\"><span>MPN Reason</span></div></md-subheader>\n<div class=\"content-input\"><textarea rows=\"5\" ui-tinymce=\"vm.tinymceOptions\" name=\"reason\" id=\"reason\" flex \nng-model=\"vm.Form.objForm.reason\" ng-required=\"vm.reason\"></textarea><div ng-messages=\"frmRequest.reason.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Reason field is required.</span></div></div></div></md-input-container>\n</div></div></md-content></div><div id=\"mpn-gw-request\" layout-fill class=\"carded white-bg\"><md-content \nclass=\"white-bg\" layout-margin><div class=\"md-whiteframe-4dp content rounded\" layout-padding><md-subheader \nclass=\"subheader-sm\"><div layout=\"row\" flex=\"100\" layout-align=\"center\"><span><strong>\nRESPONSIBILITIES AND QUALIFICATION DETAIL</strong></span></div></md-subheader><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-padding flex><div flex><md-input-container flex><md-subheader class=\"content-header\"><div layout=\"row\" flex \nlayout-align=\"center\"><span>Short Job Description / Responsibilities</span></div></md-subheader><div \nclass=\"content-input\" flex><textarea rows=\"4\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.Form.objForm.job_desc\" \nname=\"jobdesc\" ng-required=\"!vm.otherBT\"></textarea><div ng-messages=\"frmRequest.jobdesc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Job description field is required.</span></div></div></div></md-input-container>\n<md-input-container flex><md-subheader class=\"content-header\"><div layout=\"row\" layout-align=\"center\"><span>\nFunctional Competencies</span></div></md-subheader><div class=\"content-input\" flex><textarea rows=\"\" \nui-tinymce=\"vm.tinymceOptions\" name=\"functional\" ng-model=\"vm.Form.objForm.job_func\" ng-required=\"!vm.otherBT\">\n</textarea><div ng-messages=\"frmRequest.functional.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nFunctional competencies field is required.</span></div></div></div></md-input-container></div><div flex><div \nclass=\"container-content\" layout-padding flex><md-subheader class=\"content-header\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center\"><span>Qualification</span></div></md-subheader><div class=\"content-input\" layout=\"column\">\n<md-input-container><label for=\"yearsOfExp\">experience</label><md-select ng-model=\"vm.Form.objForm.experience\" \nname=\"experience\" required flex><md-option ng-repeat=\"ls in vm.EmploymentExperience\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmRequest.experience.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Experience status field is required.</span></div></div></md-input-container><div \nlayout=\"row\" layout-padding><md-input-container flex layout=\"column\"><label for=\"ageRange\">Min Age</label><input \nid=\"minAge\" ng-model=\"vm.Form.objForm.age_min\" type=\"number\" name=\"minAge\" required ng-min=\"18\" ng-max=\"50\"><div \nng-messages=\"frmRequest.minAge.$error\" role=\"alert\"><div ng-message=\"required\"><span>Minimum age field is required.\n</span></div><div ng-message=\"min\"><span>Minimum age is 18.</span></div><div ng-message=\"max\"><span>Maximum age is 50.\n</span></div></div></md-input-container><md-input-container flex layout=\"column\"><label for=\"ageRange\">Max Age</label>\n<input id=\"maxAge\" ng-model=\"vm.Form.objForm.age_max\" type=\"number\" name=\"maxAge\" required ng-min=\"18\" ng-max=\"50\"><div\n ng-messages=\"frmRequest.maxAge.$error\" role=\"alert\"><div ng-message=\"required\"><span>Maximum age field is required.\n</span></div><div ng-message=\"min\"><span>Minimum age is 18.</span></div><div ng-message=\"max\"><span>Maximum age is 50.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-padding><md-input-container flex><label \nfor=\"education\">Education</label><md-select ng-model=\"vm.Form.objForm.education\" id=\"education\" name=\"education\" flex \nrequired><md-option ng-repeat=\"ls in vm.educationList\" value=\"{{ls}}\">{{ls}}</md-option></md-select><div \nng-messages=\"frmRequest.education.$error\" role=\"alert\"><div ng-message=\"required\"><span>Education field is required.\n</span></div></div></md-input-container><md-input-container flex><label for=\"major\">Major</label><input id=\"major\" \ntype=\"text\" name=\"major\" ng-model=\"vm.Form.objForm.major\" flex required><div ng-messages=\"frmRequest.major.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Major field is required.</span></div></div></md-input-container></div>\n</div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-padding flex><md-input-container flex>\n<md-subheader class=\"content-header\"><div layout=\"row\" flex=\"100\" layout-align=\"center\"><span>KPI 3 Month Probation\n</span></div></md-subheader><div class=\"content-input\" flex><textarea rows=\"7\" ui-tinymce=\"vm.tinymceOptions\" \nname=\"kpi\" ng-model=\"vm.Form.objForm.kpi\" ng-required=\"true\"></textarea><div ng-messages=\"frmRequest.kpi.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>KPI 3 month probation field is required.</span></div></div></div>\n</md-input-container><md-input-container flex><md-subheader class=\"content-header\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center\"><span>Additional Note For This Position</span></div></md-subheader><div class=\"content-input\" \nflex><textarea rows=\"5\" type=\"textarea\" name=\"note\" id=\"note\" ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.Form.objForm.qualification_note\"></textarea></div></md-input-container></div></div></md-content></div><div\n id=\"mpn-gw-request\" layout-fill class=\"carded white-bg\"><md-content class=\"white-bg\" layout-margin><div \nclass=\"md-whiteframe-4dp content rounded\" layout-padding><md-subheader class=\"subheader-sm\"><div layout=\"row\" \nflex=\"100\" layout-align=\"center\"><span><strong>OTHER INFORMATION</strong></span></div></md-subheader><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"center center\" flex><md-input-container flex><p><strong><u>\nStandard Lead Time (in working days)</u></strong></p><table class=\"grade-list-announcement\"><tr><td>Grade 1</td><td \nstyle=\"width: 5%\">:</td><td>{{vm.sltLabel[0]}}</td><td>Days</td></tr><tr><td>Grade 2</td><td style=\"width: 5%\">:</td>\n<td>{{vm.sltLabel[1]}}</td><td>Days</td></tr><tr><td>Grade 3</td><td style=\"width: 5%\">:</td><td>{{vm.sltLabel[2]}}\n</td><td>Days</td></tr><tr><td>Grade 4</td><td style=\"width: 5%\">:</td><td>{{vm.sltLabel[3]}}</td><td>Days</td></tr>\n<tr><td>Grade 5</td><td style=\"width: 5%\">:</td><td>{{vm.sltLabel[4]}}</td><td>Days</td></tr><tr><td>Grade 6</td><td \nstyle=\"width: 5%\">:</td><td>{{vm.sltLabel[5]}}</td><td>Days</td></tr></table></md-input-container><md-input-container \nflex><p><strong><u>Talent Acquisition Contact Person</u></strong></p><dl ng-repeat=\"ls in vm.cp\"><dt>{{ls.description}}\n</dt><dd ng-repeat=\"lsd in ls.person\">{{lsd.name}}<br>{{lsd.mail}}</dd></dl></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-padding flex><blockquote><p><span style=\"color:red\">\nThe proccess could be faster/longer depends on the users and candidates availabillity for interview schedule.</span>\n</p></blockquote></div><div layout=\"row\" layout-md=\"column\" layout-align=\"center center\" flex><md-button type=\"button\" \nng-click=\"vm.reloadToken()\" class=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-click=\"vm.saveData($event, frmRequest, \'Waiting Approval\')\" \nng-disabled=\"frmRequest.$invalid || basicForm.$pristine\" ng-if=\"!vm.showComment && !vm.Form.objForm.other_bt\">Submit\n</md-button><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-click=\"vm.saveData($event, frmRequest, \'Draft\')\" ng-disabled=\"frmRequest.$invalid || basicForm.$pristine\" \nng-if=\"!vm.showComment && !vm.Form.objForm.other_bt\">Save as draft</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-click=\"vm.saveData($event, frmRequest, \'waiting confirm\')\" ng-disabled=\"frmRequest.$invalid || basicForm.$pristine\" \nng-if=\"!vm.showComment && vm.Form.objForm.other_bt\">Save and waiting confirm by TM</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-click=\"vm.updateData($event, frmRequest, \'Waiting Approval\')\" \nng-disabled=\"frmRequest.$invalid || basicForm.$pristine\" ng-if=\"vm.showComment\">Submit Update</md-button><md-button \ntype=\"button\" ui-sref=\"app.mpn_gw_list\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Reload\">Back\n</md-button></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div></md-content>\n</div></form><div id=\"mpn-gw-comment\" class=\"carded white-bg\" ng-if=\"vm.showComment\"><md-content class=\"white-bg\" \nlayout-margin><div class=\"md-whiteframe-4dp content rounded\" layout-padding><md-subheader class=\"subheader-sm\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center\"><span><strong>MAN POWER NEED COMENTS</strong></span></div></md-subheader>\n<div class=\"timeline\" layout=\"column\"><div class=\"timeline-item md-whiteframe-1dp\"><footer class=\"\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"comment-count\">{{vm.commnet.length}} comments<md-icon \nmd-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill \nng-repeat=\"comment in vm.comment\"><div flex layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"username\">{{comment.nik}} - {{comment.nama}}</span> <span class=\"time\">{{comment.timestamp}}</span></div><div \nclass=\"message\">{{comment.comment}}</div></div></div><div class=\"reply\" layout=\"row\" layout-align=\"end center\" \nlayout-fill><form flex><textarea placeholder=\"Add a comment...\" ng-model=\"vm.newComment\"></textarea><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.postComment()\" class=\"post-comment-button md-accent md-raised\" \naria-label=\"Post Comment\">Post Comment</md-button></div></form></div></footer></div></div></div></md-content></div>");
$templateCache.put("app/main/mpn-gw/request/view-doc.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\nMPN Number - {{vm.name}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-if=\"vm.doc_type\" class=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content ng-if=\"!vm.doc_type\">\n<img style=\"margin: auto; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/mpndocument/{{vm.doc}}\"></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/mpn-gw/ta/list.html","<style>\n.with-toolbar-content md-toolbar {\n        max-height: 60px;\n        min-height: 60px;\n        background: #ffffff !important;\n    }\n\n    .mpn-completed {\n        font-style: italic;\n        background: #e9ffe7 !important;\n    }\n</style><div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">MPN Online TA</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\">\n<md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\" ng-change=\"vm.loadBt(vm.department)\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DEPARTMENT\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.btcode\" name=\"businessTitle\"><md-option placeholder=\"Business Title\" \nng-repeat=\"ls in vm.listBt\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>PIC</label><md-select ng-model=\"vm.pic\" name=\"pic\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a PIC..\" \nclass=\"header-searchbox md-text\" ng-keydown=\"vm.ketikSearch($event)\"></md-select-header><md-option value=\"\">All\n</md-option><md-option ng-repeat=\"ls in vm.listPIC | filter:vm.searchTerm\" value=\"{{ls.nik}}\">{{ls.description}}\n</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\" class=\"mt-40\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"15\" flex><label>Start Request Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglmulai\" md-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.START_DATE\' | translate }}\" \nname=\"tglmulai\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label>\nEnd Request Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.END_DATE\' | translate }}\" name=\"tglakhir\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><md-select ng-model=\"vm.approvalStatus\" \nname=\"approvalStatus\"><md-option ng-repeat=\"ls in vm.listApprovalStatus\" placeholder=\"Approval Status\" value=\"{{ls}}\">\n{{ls}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><md-select \nng-model=\"vm.mpnStatus\" name=\"mpnStatus\"><md-option ng-repeat=\"ls in vm.listMpnStatus\" placeholder=\"MPN Status\" \nvalue=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\">\n<md-select ng-model=\"vm.budgetType\" name=\"budgetType\"><md-option ng-repeat=\"ls in vm.listBudgetType\" \nplaceholder=\"Budget Type\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">\nEntries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-show=\"vm.download\" ng-click=\"vm.exportToExcel($event)\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><span>Export to Excel MPN</span></md-button><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>MPN NUMBER\n</th><th>REQUESTOR</th><th>WORK LOCATION</th><th>DIVISION</th><th>DEPARTMENT</th><th>BUSINESS TITLE</th><th>BUDGET TYPE\n</th><th>MPN STATUS</th><th>APPROVAL STATUS</th><th>REQUEST DATE</th><th>EXPECTED JOIN DATE</th><th>REQUEST QTY</th>\n<th>TA PIC</th><th>#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td>\n{{ ls.mpn_number }}</td><td>{{ ls.nama_request }}</td><td>{{ ls.work_location }}</td><td>{{ ls.division }}</td><td>\n{{ ls.department }}</td><td>{{ ls.business_title }}</td><td>{{ ls.budget_type}}</td><td>{{ ls.mpn_status}}</td><td>\n{{ ls.current_status}}</td><td>{{ ls.created_at }}</td><td>{{ ls.expected_join_date }}</td><td>{{ ls.total_qty }}</td>\n<td>{{ ls.nik_pic }} - {{ ls.nama_pic }}</td><td><md-button aria-label=\"View Request\" class=\"md-icon-button\" \nng-click=\"vm.viewDetail(ls.id, ls.approval_type)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>View Request</span></md-tooltip></md-button>\n</td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpn-gw/ta/recruit.list.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Recruit List</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\">\n<md-content layout=\"column\" ng-if=\"vm.tipe == \'tapic\' \"><div layout-gt-sm=\"column\"><md-input-container><input \ntype=\"file\" id=\"uploadPhoto\" name=\"filecandidate\" nv-file-select=\"\" uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadCandidate\', id: vm.id}]}\"><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload File</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload File</span></md-whiteframe></md-content><div layout=\"column\" ms-scroll><table \nclass=\"simple bordered\" ms-responsive-table><thead><tr><th ng-if=\"vm.isConfirm != 0\"></th><th class=\"secondary-text\" \nflex=\"10\"><div class=\"table-header\"><span class=\"column-title\">NO</span></div></th><th class=\"secondary-text\" \nflex=\"40\"><div class=\"table-header\"><span class=\"column-title\">REPLACEMENT FOR</span></div></th><th \nclass=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">REPLACEMENT TYPE</span></div>\n</th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">VACANCY CLOSED</span>\n</div></th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">MPN STATUS</span>\n</div></th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">CANDIDATE</span>\n</div></th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">DATE OF BIRTH\n</span></div></th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span class=\"column-title\">LEAD TIME\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"lsd in vm.data\"><td ng-if=\"vm.isConfirm == 1\"><input \ntype=\"checkbox\" checklist-model=\"vm.listSelected\" checklist-value=\"lsd\"></td><td ng-if=\"vm.isConfirm == 2\">check</td>\n<td>{{$index+1}}</td><td>{{lsd.nik}} - {{lsd.nama}}</td><td>{{lsd.replacement_type}}</td><td>{{lsd.vacancy_closed}}\n</td><td>{{lsd.mpn_status}}</td><td>{{lsd.candidate}}</td><td>{{lsd.date_of_birth}}</td><td ng-if=\"lsd.lt\">\n{{lsd.lt}} days</td><td ng-if=\"lsd.lt == null\">-</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><md-button class=\"md-raised reference-button md-accent md-hue-3\" \nng-click=\"vm.reOpen($event);\" ng-if=\"vm.taStatus==\'CLOSE\' \"><md-icon md-font-icon=\"icon-account-remove\"></md-icon>\n<span>Reopen MPN</span></md-button><md-button ng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-primary\" \nng-if=\"vm.tipe == \'tapic\'\"><md-icon md-font-icon=\"icon-upload\"></md-icon>Upload</md-button><md-button \nclass=\"md-primary\" ng-click=\"vm.downloadFormat()\" ng-if=\"vm.tipe == \'tapic\'\"><md-icon md-font-icon=\"icon-download\">\n</md-icon>Download Format</md-button><md-button class=\"md-primary\" ng-click=\"vm.downloadPKWT()\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon>Download Format PKWT</md-button><md-button ng-click=\"vm.closeModal()\" \nclass=\"md-primary\">Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mpn-gw/ta/request.resetslt.gw.html","<form name=\"frmRequest\" ng-cloack novalidate><md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" \nmd-theme=\"modal-theme\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>\nRequest Reset SLT</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\"><h2><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon>Please make reason for your request!</h2>\n<md-input-container><label>Reset To Date</label><md-datepicker md-hide-icons=\"calendar\" md-open-on-focus \nng-model=\"vm.Form.objForm.reset_date\" md-current-view=\"month\" name=\"resetDate\" required></md-datepicker><div \nng-messages=\"frmRequest.resetDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Reset date field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block mt-10\"><label>Reason</label><textarea \nname=\"reason\" ng-model=\"vm.Form.objForm.reason\" md-maxlength=\"200\" max-rows=\"5\" required></textarea><div \nng-messages=\"frmRequest.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>Reason field is required.</span>\n</div></div></md-input-container><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button ng-click=\"vm.closeModal()\" \nclass=\"md-primary\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-click=\"vm.submit(frmRequest)\" ng-disabled=\"frmRequest.$invalid || basicForm.$pristine\">SUBMIT\n</md-button></md-dialog-actions></md-dialog></form>");
$templateCache.put("app/main/mpp/activity-foreman/activity-foreman.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nActivity Foreman</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container><label>Effective Date</label><input type=\"date\" name=\"effective_date\" ng-model=\"vm.effective_date\">\n</md-input-container><md-input-container flex><label>Line Position</label><md-select ng-model=\"vm.line_id\" \nname=\"line_id\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchLine\" type=\"search\" \nclass=\"md-text\"></md-select-header><md-optgroup label=\"vm.productLists\"><md-option \nng-repeat=\"ls in vm.listLineForeman | filter:vm.searchLine\" value=\"{{ls.id}}\" \nstyle=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">{{ls.description}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmEditEmpLinePosition.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container flex><label>Product</label>\n<md-autocomplete md-no-cache=\"true\" md-selected-item=\"vm.product\" md-search-text=\"searchText\" \nmd-items=\"item in vm.loadProduct(searchText)\" md-item-text=\"item.sku + \', \' + item.description\" ng-model=\"vm.product\">\n<md-item-template><span md-highlight-text=\"searchText\">{{item.sku + \', \' + item.description}}</span></md-item-template>\n</md-autocomplete></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"Activity\" md-on-select=\"vm.tabChange(\'activity\')\"><md-content class=\"md-padding\">\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-mini md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Add New\" ng-click=\"vm.add($event, \'\')\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>New</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span>New</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete\n</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><div class=\"divider-vertical\" \nhide show-gt-sm></div><span flex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-mini md-primary\" type=\"button\" aria-label=\"Add New\" ng-click=\"vm.add($event, \'\')\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span>New\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-warn md-mini\" aria-label=\"Delete\" \nng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete\n</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></md-toolbar><table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" \nms-responsive-table><thead><tr><th style=\"min-width: 50px;width: 50px\"></th><th style=\"width: 50px\">No</th><th>Activity\n</th><th>Line</th><th>Effective Date</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTable.list\"><td \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(item)\" ng-click=\"vm.toggleCheck(item, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ item.no }}</td>\n<td><a ng-click=\"vm.emp_line_position(item)\" style=\"cursor: pointer\">{{ item.sku }}, {{ item.nama_produk }}</a></td><td\n class=\"text-center\">{{ item.line_number }}</td><td class=\"text-center\">{{ item.production_date | date:\'dd/MM/yyyy\' }}\n</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></md-tab><md-tab label=\"Member\" \nmd-on-select=\"vm.tabChange(\'member\')\"><md-content class=\"md-padding\"><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\" layout-align=\"space-between center\"><h2 style=\"color: #000000bd\">TEAM MEMBERS</h2>\n<div \nng-click=\"vm.filterBy({\n                                            attendance: \'HADIR\'\n                                        })\" \nclass=\"text-boxed green-bg white-fg m-0 clickable\" hide show-gt-sm>Hadir : {{vm.DataTableMember.list[1].summary.hadir}}\n</div><div \nng-click=\"vm.filterBy({\n                                            attendance: \'IZIN\'\n                                        })\" \nclass=\"text-boxed blue-bg white-fg m-0 clickable\" hide show-gt-sm>Ijin : {{vm.DataTableMember.list[1].summary.ijin}}\n</div><div \nng-click=\"vm.filterBy({\n                                            attendance: \'ALFA\'\n                                        })\" \nclass=\"text-boxed black-bg white-fg m-0 clickable\" hide show-gt-sm>Alfa : {{vm.DataTableMember.list[1].summary.alfa}}\n</div><div \nng-click=\"vm.filterBy({\n                                            attendance: \'SAKIT\'\n                                        })\" \nclass=\"text-boxed orange-bg white-fg m-0 clickable\" hide show-gt-sm>\nSakit : {{vm.DataTableMember.list[1].summary.sakit}}</div><div \nng-click=\"vm.filterBy({\n                                            attendance: \'OFF\'\n                                        })\" \nclass=\"text-boxed red-bg white-fg m-0 clickable\" hide show-gt-sm>Off : {{vm.DataTableMember.list[1].summary.off}}</div>\n<div \nng-click=\"vm.filterBy({\n                                            lineTransfer: \'TRANSFER_IN\'\n                                        })\" \nclass=\"text-boxed pink-bg white-fg m-0 clickable\" hide show-gt-sm>\nTransfer In : {{vm.DataTableMember.list[1].summary.transfer_in}}</div><div \nng-click=\"vm.filterBy({\n                                            lineTransfer: \'TRANSFER_OUT\'\n                                        })\" \nclass=\"text-boxed purple-bg white-fg m-0 clickable\" hide show-gt-sm>\nTransfer Out : {{vm.DataTableMember.list[1].summary.transfer_out}}</div><div ng-click=\"vm.filterBy(\'\')\" \nclass=\"text-boxed indigo-bg white-fg m-0 clickable\" hide show-gt-sm>{{vm.DataTableMember.list[1].data.length}} members\n</div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><div ng-click=\"vm.filterBy(\'hadir\')\" \nclass=\"text-boxed green-bg white-fg m-0 clickable\" style=\"margin: 10px\">\nHadir : {{vm.DataTableMember.list[1].summary.hadir}}</div></md-menu-item><md-menu-item><div \nng-click=\"vm.filterBy(\'ijin\')\" class=\"text-boxed blue-bg white-fg m-0 clickable\" style=\"margin: 10px\">\nIjin : {{vm.DataTableMember.list[1].summary.ijin}}</div></md-menu-item><md-menu-item><div \nng-click=\"vm.filterBy(\'alfa\')\" class=\"text-boxed black-bg white-fg m-0 clickable\" style=\"margin: 10px\">\nAlfa : {{vm.DataTableMember.list[1].summary.alfa}}</div></md-menu-item><md-menu-item><div \nng-click=\"vm.filterBy(\'sakit\')\" class=\"text-boxed orange-bg white-fg m-0 clickable\" style=\"margin: 10px\">\nSakit : {{vm.DataTableMember.list[1].summary.sakit}}</div></md-menu-item><md-menu-item><div \nng-click=\"vm.filterBy(\'off\')\" class=\"text-boxed red-bg white-fg m-0 clickable\" style=\"margin: 10px\">\nOff : {{vm.DataTableMember.list[1].summary.off}}</div></md-menu-item><md-menu-item><div \nng-click=\"vm.filterBy(\'transfer_in\')\" class=\"text-boxed pink-bg white-fg m-0 clickable\" style=\"margin: 10px\">\nTransfer In : {{vm.DataTableMember.list[1].summary.transfer_in}}</div></md-menu-item><md-menu-item><div \nng-click=\"vm.filterBy(\'transfer_out\')\" class=\"text-boxed purple-bg white-fg m-0 clickable\" style=\"margin: 10px\">\nTransfer Out : {{vm.DataTableMember.list[1].summary.transfer_out}}</div></md-menu-item><md-menu-item><div \nng-click=\"vm.filterBy(\'\')\" class=\"text-boxed indigo-bg white-fg m-0 clickable\" style=\"margin: 10px\">\n{{vm.DataTableMember.list[1].data.length}} members</div></md-menu-item></md-menu-content></md-menu></div></md-toolbar>\n<table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead \nclass=\"thead-member\"><tr><th style=\"width: 50px\">No</th><th style=\"width: 100px\">NIK</th><th style=\"width: 200px\">NAME\n</th><th style=\"width: 150px\">PRODUCT</th><th style=\"width: 150px\">POSITION</th><th style=\"width: 100px\">PHONE NUMBER\n</th><th style=\"width: 100px\">SYMBOL</th><th style=\"width: 100px\">DEFAULT LINE</th><th style=\"width: 100px\">ATT</th>\n</tr></thead><tbody class=\"tbody-member\"><tr ng-repeat=\"item in vm.DataTableMember.list[1].data | filter:vm.filter\"><td\n class=\"text-center\" style=\"width: 50px\">{{$index + 1}}</td><td class=\"text-center\" style=\"width: 100px\">{{ item.nik }}\n</td><td class=\"text-center\" style=\"width: 200px\">{{ item.name }}</td><td class=\"text-center\" style=\"width: 150px\">\n{{ item.product_name }}</td><td class=\"text-center\" style=\"width: 150px\">{{ item.position }}</td><td \nclass=\"text-center\" style=\"width: 100px\">{{ item.no_hp }}</td><td class=\"text-center\" style=\"width: 100px\">\n{{ item.symbol }}</td><td class=\"text-center\" style=\"width: 100px\">{{item.default_line}}</td><td class=\"text-center\" \nstyle=\"width: 100px\"><div ng-if=\"item.attendance == \'HADIR\'\" class=\"text-boxed green-bg white-fg m-0\">hadir</div><div \nng-if=\"item.attendance == \'IJIN\'\" class=\"text-boxed blue-bg white-fg m-0\">izin</div><div \nng-if=\"item.attendance == \'ALFA\'\" class=\"text-boxed black-bg white-fg m-0\">alfa</div><div \nng-if=\"item.attendance == \'SAKIT\'\" class=\"text-boxed orange-bg white-fg m-0\">sakit</div><div \nng-if=\"item.attendance == \'OFF\'\" class=\"text-boxed red-bg white-fg m-0\">Off</div><div \nng-if=\"item.attendance == \'TRANSFER_IN\'\" class=\"text-boxed pink-bg white-fg m-0\">Transfer In</div><div \nng-if=\"item.attendance == \'TRANSFER_OUT\'\" class=\"text-boxed purple-bg white-fg m-0\">Transfer In</div>\n{{(!item.attendance)?\'-\':\'\'}}</td></tr></tbody></table></md-content></md-tab></md-tabs></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/mpp/approval/approval-history.html","<div id=\"mppDialog\" flex-gt-sm=\"80\" flex=\"100\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-dialog \naria-label=\"Input\" flex><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>Approval History</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><md-list layout=\"column\" flex><md-list-item flex layout=\"row\" \nclass=\"list-title\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\" flex=\"5\">NO</div><div \nlayout=\"row\" layout-align=\"center center\" flex=\"15\">NAME</div><div layout=\"row\" layout-align=\"start center\" flex=\"10\">\nSTATUS</div><div layout=\"row\" layout-align=\"start center\" flex=\"15\">ISSUED AT</div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"15\">APPROVAL DATE</div><div layout=\"row\" layout-align=\"start center\" flex=\"15\">\nCREATED BY</div><div layout=\"row\" layout-align=\"start center\" flex=\"15\">APPROVED BY</div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\">TYPE</div></md-list-item></md-list><md-list class=\"list-content\" flex>\n<md-list-item ng-repeat=\"item in vm.listApprovalHistory\" flex layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" class=\"body-font\" layout-align=\"center center\" flex=\"5\">{{$index + 1}}</div><div layout=\"row\" \nclass=\"body-font\" layout-align=\"center center\" flex=\"15\">{{item.name}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"10\">{{item.status.toUpperCase()}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"15\">{{item.timestamp}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"15\">{{item.approval_date}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"15\">{{item.created_by}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"15\">{{item.approved_by}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"10\">{{item.type}}</div></md-list-item><md-divider></md-divider><md-list-item \nng-if=\"vm.listApprovalHistory.length == 0\" flex layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"body-font\" layout-align=\"center center\" flex>Not Submitted Yet</div></md-list-item></md-list>\n</md-dialog-content></md-dialog></div>");
$templateCache.put("app/main/mpp/approval/approval.html","<div id=\"mppApprovalArea\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\" translate=\"ACTION.YEAR\">YEARS</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year}}\" \nng-click=\"vm.getDataApproval(year)\"><span class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><div class=\"page-layout\" \nng-if=\"vm.disableRequestPanel\"><div layout=\"row\" class=\"content-card\"><div flex layout=\"column\" layout-padding layout>\n<md-toolbar class=\"approval-list\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\"><p><b>My Request</b></p></div></md-toolbar><md-content id=\"mppApprovalHistory\" ms-scroll>\n<md-subheader flex class=\"subheader-list\"><md-list layout=\"column\" flex><md-list-item flex layout=\"row\" \nclass=\"list-title\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\" flex=\"5\">NO</div><div \nlayout=\"row\" layout-align=\"center center\" flex=\"10\">YEARS</div><div layout=\"row\" layout-align=\"start center\" flex=\"10\">\nSTATUS</div><div layout=\"row\" layout-align=\"start center\" flex=\"15\">ISSUED AT</div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"15\">APPROVAL DATE</div><div layout=\"row\" layout-align=\"start center\" flex=\"15\">\nAPPROVED BY</div><div layout=\"row\" layout-align=\"start center\" flex=\"15\">NEXT APPROVAL</div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\">LEAD TIME</div><div layout=\"row\" layout-align=\"start center\" flex=\"5\">HISTORY\n</div></md-list-item></md-list></md-subheader><md-list class=\"list-content\" flex><md-list-item \nng-repeat=\"item in vm.requestorData\" flex layout=\"row\" layout-align=\"start center\"><div layout=\"row\" class=\"body-font\" \nlayout-align=\"center center\" flex=\"5\">{{$index + 1}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"center center\" flex=\"10\">{{item.years}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"10\">{{item.status_approval.toUpperCase()}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"15\">{{item.timestamp}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"15\">{{item.approval_date}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"15\">{{item.approved_by}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"15\">{{item.next_approval}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"10\">{{vm.leadTime(item.timestamp, item.approval_date)}}</div><div layout=\"row\" \nclass=\"body-font\" layout-align=\"start center\" flex=\"5\"><a href=\"javascript:;\" class=\"no-padding no-margin\" \nng-click=\"vm.showHistory(item, $event)\"><md-icon class=\"small-icon\" ng-style=\"{\'color\' : \'#449c73\'}\" \nmd-font-icon=\"icon-chart-line\"></md-icon><md-tooltip md-direction=\"bottom\">History</md-tooltip></a></div>\n</md-list-item><md-list-item ng-if=\"vm.requestorData.length == 0\" flex layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" class=\"body-font\" layout-align=\"center center\" flex>Not Submitted Yet</div></md-list-item></md-list>\n</md-content><md-list class=\"total-approval\" layout=\"column\" flex><md-list-item flex layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" flex=\"85\" layout-align=\"center center\">Total Lead Time</div><div \nlayout=\"row\" flex=\"15\" layout-align=\"start center\">0 Days</div></md-list-item><md-divider></md-divider></md-list></div>\n</div></div><div class=\"page-layout\"><div layout=\"row\" class=\"content-card\"><div flex layout=\"column\" layout-padding \nlayout><md-toolbar class=\"approval-list\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\"><p><b>Approval Request</b></p></div></md-toolbar><md-content id=\"mppApprovalContent\" \nms-scroll><md-subheader flex class=\"subheader-list\"><md-list layout=\"column\" flex><md-list-item flex layout=\"row\" \nclass=\"list-title\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\" flex=\"5\">NO</div><div \nlayout=\"row\" layout-align=\"center center\" flex=\"10\">NIK</div><div layout=\"row\" layout-align=\"start center\" flex=\"15\">\nNAME</div><div layout=\"row\" layout-align=\"start center\" flex=\"20\">BUSINESS TITLE</div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\">STATUS</div><div layout=\"row\" layout-align=\"center center\" flex=\"10\">APPROVED BY\n</div><div layout=\"row\" layout-align=\"center center\" flex=\"10\">ISSUED AT</div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"10\">LEAD TIME</div><div layout=\"row\" layout-align=\"center center\" flex=\"10\">ACTION\n</div></md-list-item></md-list></md-subheader><md-list class=\"list-content\" flex><md-list-item \nng-repeat=\"item in vm.listApproval\" flex layout=\"row\" layout-align=\"start center\"><div layout=\"row\" class=\"body-font\" \nlayout-align=\"center center\" flex=\"5\">{{$index + 1}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"center center\" flex=\"10\">{{item.created_by}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"15\">{{item.name.toUpperCase()}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"20\">{{item.description}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"start center\" flex=\"10\">{{item.status_approval.toUpperCase()}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"center center\" flex=\"10\">{{item.approved_by}}</div><div layout=\"row\" class=\"body-font\" \nlayout-align=\"center center\" flex=\"10\">{{item.approval_date ? item.approval_date : \'-\'}}</div><div layout=\"row\" \nclass=\"body-font\" layout-align=\"center center\" flex=\"10\">{{vm.leadTime(item.timestamp, item.approval_date)}}</div><div \nlayout=\"row\" class=\"body-font\" layout-align=\"center center\" flex=\"10\"><div><md-button \nclass=\"md-icon-button no-padding no-margin\" ng-click=\"vm.viewDetail(item)\"><md-icon class=\"small-icon\" \nng-style=\"{\'color\' : \'#357ebd\'}\" md-font-icon=\"icon-eye\"></md-icon><md-tooltip md-direction=\"bottom\">View Detail\n</md-tooltip></md-button></div><div><a href=\"javascript:;\" class=\"no-padding no-margin\" \nng-class=\"{\'approval-disabled\' : item.isDisabledApprove}\" ng-click=\"vm.showApprove(item, $event)\"><md-icon \nclass=\"small-icon\" ng-style=\"{\'color\' : item.isDisabledApprove ? \'#dddddd\' : \'#449c73\'}\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><md-tooltip md-direction=\"bottom\">Approve</md-tooltip></a>\n</div><div><a href=\"javascript:;\" class=\"no-padding no-margin\" \nng-class=\"{\'approval-disabled\' : item.isDisabledCancel}\" ng-click=\"vm.showCancel(item, $event)\"><md-icon \nclass=\"small-icon\" ng-style=\"{\'color\' : item.isDisabledCancel ? \'#dddddd\' : \'#f85853\'}\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><md-tooltip md-direction=\"bottom\">Cancel</md-tooltip></a>\n</div></div></md-list-item><md-list-item ng-if=\"vm.listApproval.length == 0\" flex layout=\"row\" \nlayout-align=\"center center\"><div layout=\"row\" class=\"body-font\" layout-align=\"center center\" flex>\nYou dont have request</div></md-list-item></md-list></md-content><md-list class=\"total-approval\" layout=\"column\" flex>\n<md-list-item flex layout=\"row\" layout-align=\"start center\"><div layout=\"row\" flex=\"80\" layout-align=\"center center\">\nTotal Lead Time</div><div layout=\"row\" flex=\"10\" layout-align=\"center center\">0 Days</div></md-list-item><md-divider>\n</md-divider></md-list></div></div></div></div>");
$templateCache.put("app/main/mpp/compare-chart/compare-chart.html","<div class=\"page-layout\" mpp-chart-viewport id=\"orgchart-area\"><div layout=\"column\" style=\"padding:0; margin: 0\" \nclass=\"content-card\"><md-content id=\"centerpanel\" class=\"org-chart\" \nstyle=\"overflow:hidden; padding: 0px; margin: 0px; border: 0px\"><div id=\"chartContent\" bp-org-diagram \ndata-options=\"vm.options\" flex=\"100\" style=\"overflow:unset\" ms-scroll></div></md-content></div></div>");
$templateCache.put("app/main/mpn/approval/reject.resetslt.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Reject Reset SLT</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><div\n layout=\"column\"><h2><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon>\nPlease make note for your rejection!</h2><md-input-container class=\"md-block mt-10\"><label>Comment</label><textarea \nname=\"notes\" ng-model=\"vm.notes\" md-maxlength=\"200\" max-rows=\"5\"></textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button ng-click=\"vm.closeModal()\" \nclass=\"md-primary\">CANCEL</md-button><md-button ng-click=\"vm.submit(4)\" class=\"md-primary\">REJECT</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mpn/approval/request.resetslt.html","<form name=\"frmRequest\" ng-cloack novalidate ng-click=\"vm.submit(frmRequest)\"><md-dialog \naria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\">\n<div class=\"md-toolbar-tools\"><h2>Request Reset SLT</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\"><h2>\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon>Please make reason for your request!</h2>\n<md-input-container><label>Reset To Date</label><md-datepicker md-hide-icons=\"calendar\" md-open-on-focus \nng-model=\"vm.Form.objForm.reset_date\" md-current-view=\"month\" name=\"resetDate\" required></md-datepicker><div \nng-messages=\"frmRequest.resetDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Reset date field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block mt-10\"><label>Reason</label><textarea \nname=\"reason\" ng-model=\"vm.Form.objForm.reason\" md-maxlength=\"200\" max-rows=\"5\"></textarea><div \nng-messages=\"frmRequest.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>Reason field is required.</span>\n</div></div></md-input-container><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button ng-click=\"vm.closeModal()\" \nclass=\"md-primary\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"frmRequest.$invalid || basicForm.$pristine\">SUBMIT</md-button></md-dialog-actions>\n</md-dialog></form>");
$templateCache.put("app/main/mpp/emp-line-position/emp-line-position-add.html","<md-dialog aria-label=\"Form Add Emp Line Position\" flex-md=\"70\" flex-gt-md=\"70\"><form ng-cloack \nname=\"frmAddEmpLinePosition\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmAddEmpLinePosition)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Add Emp Line Position</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container>\n<md-label>Effective Date</md-label><input type=\"date\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" \nng-change=\"vm.selectedEffectiveDate()\" required><div ng-messages=\"frmEditEmpLinePosition.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date is required.</span></div></div></md-input-container>\n<md-input-container flex><md-label>Line Position</md-label><md-select ng-model=\"vm.Form.objForm.line_position\" \nng-change=\"vm.selectedLinePosition(vm.Form.objForm.line_position)\" name=\"line_position\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchLine\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.productLists\"><md-option ng-repeat=\"ls in vm.listLineForeman | filter:vm.searchLine\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">{{ls.description}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmEditEmpLinePosition.product.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Parent field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-label>Product</md-label><md-select ng-model=\"vm.Form.objForm.product\" md-on-close=\"vm.clearSearchProduct()\" \nng-change=\"vm.selectedProduct(vm.Form.objForm.product)\" name=\"product\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchProduct\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.listProduct\"><md-option ng-repeat=\"ls in vm.listProduct | filter:vm.searchProduct\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.sku}} - {{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmEditEmpLinePosition.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table ng-repeat=\"mpp in vm.mppStandardLists\" ng-init=\"mppIndex = $index\"><thead><tr><th \nstyle=\"text-transform: uppercase\" colspan=\"23\">{{mpp.position_group}}</th></tr><tr><th \nstyle=\"text-transform: uppercase\">No</th><th style=\"text-transform: uppercase; width: 40%\">Position</th><th \nstyle=\"text-transform: uppercase; width: 10%\">Symbol Location</th><th style=\"text-transform: uppercase; width: 40%\">\nEmployee</th><th style=\"text-transform: uppercase\">Portion</th><th style=\"text-transform: uppercase\">Request</th></tr>\n</thead><tbody><tr ng-repeat=\"mpp_standar in mpp.mpp_standar\" ng-init=\"mppStandarIndex = $index\"><td \nclass=\"text-center\">{{mppStandarIndex+1}}</td><td>{{mpp_standar.position_name}}</td><td class=\"text-center\">\n{{mpp_standar.symbol_location}}</td><td><md-autocomplete ng-focus=\"mpp_standar.is_focus\" \nclass=\"md-autocomplete-atasan-baru\" \nstyle=\"margin-top: 15px; background: transparent;border-bottom: 2px dotted {{(mpp_standar.is_focus)?\'blue\':\'#d9d9d9\'}}\" \nmd-no-cache=\"true\" md-input-minlength=\"3\" md-selected-item=\"mpp_standar.nik\" \nmd-selected-item-change=\"vm.changeNik(mpp_standar,\'mpp\',mppStandarIndex,mppIndex)\" md-search-text=\"searchText\" \nmd-items=\"item in vm.lookupEmployee(searchText)\" md-item-text=\"item.nik + \', \' + item.fullname\" \nng-model=\"mpp_standar.nik\"><md-item-template><span md-highlight-text=\"searchText\">{{item.nik + \', \' + item.fullname}}\n</span></md-item-template></md-autocomplete></td><td class=\"text-center\"><md-radio-group layout=\"row\" \nng-change=\"vm.changePortion(mpp_standar,\'mpp\',mppStandarIndex,mppIndex)\" ng-disabled=\"mpp_standar.disabled\" \nlayout-align=\"start center\" ng-model=\"mpp_standar.portion\" ng-if=\"mpp_standar.nik\"><md-radio-button \nng-repeat=\"item in vm.portionList\" ng-value=\"item.value\" ng-if=\"item.value <= mpp_standar.portion_mpp\">{{item.label}}\n</md-radio-button></md-radio-group></td><td class=\"text-center\"><md-checkbox class=\"no-label\" \nng-model=\"mpp_standar.request\" aria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\" \nng-if=\"!mpp_standar.nik && vm.jumEmployee.countKur == 0\"></md-checkbox></td></tr></tbody></table><br><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th style=\"text-transform: uppercase\" \ncolspan=\"23\">Support Activity</th></tr><tr><th style=\"text-transform: uppercase\">No</th><th \nstyle=\"text-transform: uppercase; width: 40%\">Activity</th><th style=\"text-transform: uppercase; width: 40%\">Employee\n</th><th style=\"text-transform: uppercase\">Portion</th><th style=\"text-transform: uppercase\">Request</th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"lsItem in vm.supportActivities\"><td class=\"text-center\">{{$index+1}}</td><td><md-select \nng-model=\"lsItem.activity_id\" name=\"activity_id\"><md-option ng-repeat=\"ls in vm.supportActivityList\" value=\"{{ls.id}}\" \nstyle=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">{{ls.name}}</md-option></md-select></td><td>\n<md-autocomplete ng-focus=\"lsItem.is_focus\" class=\"md-autocomplete-atasan-baru\" \nstyle=\"background: transparent;border-bottom: 2px dotted {{(lsItem.is_focus)?\'blue\':\'#d9d9d9\'}}\" md-no-cache=\"true\" \nmd-input-minlength=\"3\" md-selected-item-change=\"vm.changeNik(lsItem,\'support\',$index)\" md-selected-item=\"lsItem.nik\" \nmd-search-text=\"searchTextSupport\" md-items=\"item in vm.lookupEmployee(searchTextSupport)\" \nmd-item-text=\"item.nik + \', \' + item.fullname\" ng-model=\"lsItem.nik\"><md-item-template><span \nmd-highlight-text=\"searchTextSupport\">{{item.nik + \', \' + item.fullname}}</span></md-item-template></md-autocomplete>\n</td><td class=\"text-center\"><md-radio-group layout=\"row\" ng-change=\"vm.changePortion(lsItem,\'support\',$index)\" \nng-disabled=\"lsItem.disabled\" layout-align=\"start center\" ng-model=\"lsItem.portion\"><md-radio-button \nng-repeat=\"item in vm.portionList\" ng-value=\"item.value\">{{item.label}}</md-radio-button></md-radio-group></td><td \nclass=\"text-center\"><md-checkbox class=\"no-label\" ng-model=\"lsItem.request\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\" ng-if=\"!lsItem.nik && vm.jumEmployee.countKur == 0\">\n</md-checkbox></td><td class=\"text-center\"><md-button type=\"button\" class=\"md-mini md-warn\" aria-label=\"Remove\" \nng-click=\"vm.removeRow(lsItem,$index)\">Remove</md-button></td></tr></tbody></table><div><md-button type=\"button\" \nclass=\"md-mini md-primary\" aria-label=\"Add\" ng-click=\"vm.addRow()\">Add row</md-button></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddEmpLinePosition.$invalid || frmAddEmpLinePosition.$pristine || vm.mppStandardLists.length == 0\">\nSubmit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpp/emp-line-position/emp-line-position-edit.html","<md-dialog aria-label=\"Form Edit Time Study Standard\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack \nname=\"frmEditEmpLinePosition\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmEditEmpLinePosition)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Edit Time Study Standard</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container>\n<md-label>Effective Date</md-label><input type=\"date\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" \nrequired><div ng-messages=\"frmEditEmpLinePosition.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date is required.</span></div></div></md-input-container><md-input-container flex><md-label>Line Position\n</md-label><md-select ng-model=\"vm.Form.objForm.line_position\" \nng-change=\"vm.selectedLinePosition(vm.Form.objForm.line_position)\" name=\"product\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchLine\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.productLists\"><md-option ng-repeat=\"ls in vm.listLineForeman | filter:vm.searchLine\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">{{ls.description}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"frmEditEmpLinePosition.product.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Parent field is required.</span></div></div></md-input-container><md-input-container flex>\n<md-label>Product</md-label><md-select ng-model=\"vm.Form.objForm.product\" md-on-close=\"vm.clearSearchProduct()\" \nng-change=\"vm.selectedProduct(vm.Form.objForm.product)\" name=\"product\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchProduct\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.productLists\"><md-option ng-repeat=\"ls in vm.productLists | filter:vm.searchProduct\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.sku}} - {{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmEditEmpLinePosition.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container flex><md-label>MPP Standard\n</md-label><md-select ng-model=\"vm.Form.objForm.mpp_standard_id\" md-on-close=\"vm.clearSearchMppStandard()\" \nng-change=\"vm.selectedMppStandard(vm.Form.objForm.mpp_standard_id)\" name=\"mpp_standard_id\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchMppStandard\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.mppStandardLists\"><md-option \nng-repeat=\"ls in vm.mppStandardLists | filter:vm.searchMppStandard\" value=\"{{ls.id}}\" \nstyle=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.position_name + \', Qty: \' + ls.qty + \', Type: \' + ls.mpp_type + \', Group: \' + ls.position_group + \', \' + ls.gender + \', \' + ls.symbol_location }}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmEditEmpLinePosition.mpp_standard_id.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Parent field is required.</span></div></div></md-input-container><md-input-container \nflex><md-label>Employee</md-label><md-autocomplete class=\"md-autocomplete-atasan-baru\" \nstyle=\"margin-top: 15px; background: #fff\" md-no-cache=\"true\" md-selected-item=\"vm.selectedNIK\" \nmd-search-text=\"searchText\" md-items=\"item in vm.lookupEmployee(searchText)\" \nmd-item-text=\"item.nik + \', \' + item.fullname\" md-selected-item-change=\"vm.selectedEmployee(item)\" required>\n<md-item-template><span md-highlight-text=\"searchText\">{{item.nik + \', \' + item.fullname}}</span></md-item-template>\n</md-autocomplete><span ng-if=\"!vm.selectedNIK\">{{vm.employee}}</span><div \nng-messages=\"frmEditEmpLinePosition.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditEmpLinePosition.$invalid || frmEditEmpLinePosition.$pristine\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpp/emp-line-position/emp-line-position.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nEmp Line Position</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container><label>Effective Date</label><input type=\"date\" name=\"effective_date\" ng-model=\"vm.effective_date\">\n</md-input-container><md-input-container flex><label>Line Position</label><md-select ng-model=\"vm.line_id\" \nname=\"line_id\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchLine\" type=\"search\" \nclass=\"md-text\"></md-select-header><md-optgroup label=\"vm.productLists\"><md-option \nng-repeat=\"ls in vm.listLineForeman | filter:vm.searchLine\" value=\"{{ls.id}}\" \nstyle=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">{{ls.description}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmEditEmpLinePosition.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container flex><label>Product</label>\n<md-autocomplete md-no-cache=\"true\" ng-disabled=\"true\" md-selected-item=\"vm.product\" md-search-text=\"searchText\" \nmd-items=\"item in vm.loadProduct(searchText)\" md-item-text=\"item.sku + \', \' + item.description\" ng-model=\"vm.product\">\n<md-item-template><span md-highlight-text=\"searchText\">{{item.sku + \', \' + item.description}}</span></md-item-template>\n</md-autocomplete></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-mini md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Add New\" ng-click=\"vm.add($event, \'\')\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>New</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span>New</span></md-button><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"blue-500-fg md-mini\" hide show-gt-sm \naria-label=\"Total Processing\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nTotal Processing</span></md-tooltip><span>Total Processing: <span style=\"color: red\">{{vm.processingIsiCount}}</span>\n/{{vm.processingCount}}</span></md-button><md-button class=\"blue-500-fg md-mini\" hide show-gt-sm \naria-label=\"Total Packaging\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nTotal Packaging</span></md-tooltip><span>Total Packaging: <span style=\"color: red\">{{vm.packagingIsiCount}}</span>\n/{{vm.packagingCount}}</span></md-button><md-button class=\"blue-500-fg md-mini\" hide show-gt-sm \naria-label=\"Total Packaging\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nTotal Packaging</span></md-tooltip><span>Team Members: <span style=\"color: red\">{{vm.jumEmployee.count}}</span>\n/{{vm.jumEmployee.jumTemp}}</span></md-button><span flex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" \nng-click=\"vm.printPDF()\"><md-icon md-font-icon=\"icon-print\"></md-icon><span>PRINT</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\" ms-scroll><div id=\"tableMpp\"><table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" \nms-responsive-table><thead><tr><th style=\"min-width: 50px\"></th><th>No</th><th>Product</th><th>MPP Standard</th><th>\nGroup</th><th>Employee</th><th>Line</th><th>Symbol</th><th>Effective Date</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTable.list\"><td ng-if=\"item.nik \" \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(item)\" ng-click=\"vm.toggleCheck(item, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\" ng-if=\"item.position_group != \'Support\'\"></md-checkbox></td><td \nng-if=\"!item.nik\" class=\"md-red-300-bg\" \nstyle=\"color: #e6eff7;;min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"></td><td\n ng-if=\"item.nik\" class=\"text-center\">{{ item.no }}</td><td ng-if=\"!item.nik\" class=\"text-center md-red-300-bg\" \nstyle=\"color: #e6eff7\">{{ item.no }}</td><td ng-if=\"item.nik\">{{ item.product_name }}</td><td ng-if=\"!item.nik\" \nclass=\"md-red-300-bg\" style=\"color: #e6eff7\">{{ item.product_name }}</td><td ng-if=\"item.nik\">{{ item.position_name }}\n</td><td ng-if=\"!item.nik\" class=\"md-red-300-bg\" style=\"color: #e6eff7\">{{ item.position_name }}</td><td \nclass=\"text-center\" ng-if=\"item.nik\"><span style=\"text-transform: capitalize\">{{ item.position_group }}</span></td><td \nclass=\"text-center md-red-300-bg\" ng-if=\"!item.nik\" style=\"color: #e6eff7\"><span style=\"text-transform: capitalize\">\n{{ item.position_group }}</span></td><td ng-if=\"item.nik\">{{ item.nik + \', \' + item.fullname }}</td><td \nng-if=\"!item.nik\" class=\"md-red-300-bg\" style=\"color: #e6eff7\"><a href=\"javascript:void(0);\" ng-if=\"!item.nik\" \nng-click=\"vm.add($event, item)\" style=\"text-decoration: none\"><i class=\"icon-account-plus white-500-fg\"></i></a></td>\n<td class=\"text-center\" ng-if=\"item.nik\">{{ item.line_number }}</td><td class=\"text-center md-red-300-bg\" \nng-if=\"!item.nik\" style=\"color: #e6eff7\">{{ item.line_number }}</td><td class=\"text-center\" ng-if=\"item.nik\">\n{{ item.symbol_location }}</td><td class=\"text-center md-red-300-bg\" ng-if=\"!item.nik\" style=\"color: #e6eff7\">\n{{ item.symbol_location }}</td><td class=\"text-center\" ng-if=\"item.nik\">{{ item.effective_date | date:\'dd/MM/yyyy\' }}\n</td><td class=\"text-center md-red-300-bg\" ng-if=\"!item.nik\" style=\"color: #e6eff7\">\n{{ item.effective_date | date:\'dd/MM/yyyy\' }}</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpp/mpp-standard/mpp-standard-add.html","<md-dialog aria-label=\"Form Add MPP Standard\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack name=\"frmAddMppStandard\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddMppStandard)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Add MPP Standard</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><md-label>Product</md-label><md-select \nng-model=\"vm.Form.objForm.product\" md-on-close=\"vm.clearSearchProduct()\" \nng-change=\"vm.selectedProduct(vm.Form.objForm.product)\" name=\"product\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchProduct\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.productLists\"><md-option ng-repeat=\"ls in vm.productLists | filter:vm.searchProduct\" \nvalue=\"{{ls.product_machine_position_id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.sku}} - {{ls.description}} - {{ls.machine_type}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmAddMppStandard.parent_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container flex><md-label>Position Name\n</md-label><input type=\"text\" name=\"position_name\" ng-model=\"vm.Form.objForm.position_name\" required><div \nng-messages=\"frmAddMppStandard.position_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPosition Name is required.</span></div></div></md-input-container><md-input-container flex><md-label>Qty</md-label>\n<input type=\"text\" name=\"qty\" ng-model=\"vm.Form.objForm.qty\" required><div ng-messages=\"frmAddMppStandard.qty.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Qty is required.</span></div></div></md-input-container>\n<md-input-container flex><md-label>MPP Type</md-label><md-select ng-model=\"vm.Form.objForm.mpp_type\" name=\"mpp_type\" \nrequired placeholder=\"MPP Type\"><md-option ng-repeat=\"ls in vm.mppTypeLists\" value=\"{{ls}}\">{{ls}}</md-option>\n</md-select><div ng-messages=\"frmAddRegionalSales.mpp_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMPP Type field is required.</span></div></div></md-input-container><md-input-container flex><md-label>Position Group\n</md-label><md-select ng-model=\"vm.Form.objForm.position_group\" name=\"position_group\" required \nplaceholder=\"Position Group\"><md-option ng-repeat=\"ls in vm.positionGroupLists\" value=\"{{ls}}\">{{ls}}</md-option>\n</md-select><div ng-messages=\"frmAddRegionalSales.position_group.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPosition Group field is required.</span></div></div></md-input-container><md-input-container flex><md-label>Gender\n</md-label><md-select ng-model=\"vm.Form.objForm.gender\" name=\"gender\" required placeholder=\"Gender\"><md-option \nvalue=\"Male\">Male</md-option><md-option value=\"Female\">Female</md-option><md-option value=\"Male/Female\">Male/Female\n</md-option></md-select><div ng-messages=\"frmAddRegionalSales.gender.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Gender field is required.</span></div></div></md-input-container><md-input-container><md-label>Symbol Location\n</md-label><input type=\"text\" name=\"symbol_location\" ng-model=\"vm.Form.objForm.symbol_location\" required><div \nng-messages=\"frmAddMppStandard.symbol_location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSymbol Location is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddMppStandard.$invalid || frmAddMppStandard.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/mpp/mpp-standard/mpp-standard-edit.html","<md-dialog aria-label=\"Form Edit MPP Standard\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack name=\"frmEditMppStandard\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmEditMppStandard)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Edit MPP Standard</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><md-label>Product</md-label><md-select \nng-model=\"vm.Form.objForm.product\" md-on-close=\"vm.clearSearchProduct()\" \nng-change=\"vm.selectedProduct(vm.Form.objForm.product)\" name=\"product\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchProduct\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.productLists\"><md-option ng-repeat=\"ls in vm.productLists | filter:vm.searchProduct\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.sku}} - {{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmEditMppStandard.parent_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container flex><md-label>Position Name\n</md-label><input type=\"text\" name=\"position_name\" ng-model=\"vm.Form.objForm.position_name\" required><div \nng-messages=\"frmEditMppStandard.position_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPosition Name is required.</span></div></div></md-input-container><md-input-container flex><md-label>Qty</md-label>\n<input type=\"text\" name=\"qty\" ng-model=\"vm.Form.objForm.qty\" required ng-disabled=\"true\"><div \nng-messages=\"frmEditMppStandard.qty.$error\" role=\"alert\"><div ng-message=\"required\"><span>Qty is required.</span></div>\n</div></md-input-container><md-input-container flex><md-label>MPP Type</md-label><md-select \nng-model=\"vm.Form.objForm.mpp_type\" name=\"mpp_type\" required placeholder=\"MPP Type\"><md-option \nng-repeat=\"ls in vm.mppTypeLists\" value=\"{{ls}}\">{{ls}}</md-option></md-select><div \nng-messages=\"frmAddRegionalSales.mpp_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMPP Type field is required.</span></div></div></md-input-container><md-input-container flex><md-label>Position Group\n</md-label><md-select ng-model=\"vm.Form.objForm.position_group\" name=\"position_group\" required \nplaceholder=\"Position Group\"><md-option ng-repeat=\"ls in vm.positionGroupLists\" value=\"{{ls}}\">{{ls}}</md-option>\n</md-select><div ng-messages=\"frmAddRegionalSales.position_group.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPosition Group field is required.</span></div></div></md-input-container><md-input-container flex><md-label>Gender\n</md-label><md-select ng-model=\"vm.Form.objForm.gender\" name=\"gender\" required placeholder=\"Gender\"><md-option \nvalue=\"Male\">Male</md-option><md-option value=\"Female\">Female</md-option><md-option value=\"Male/Female\">Male/Female\n</md-option></md-select><div ng-messages=\"frmAddRegionalSales.gender.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Gender field is required.</span></div></div></md-input-container><md-input-container><md-label>Symbol Location\n</md-label><input type=\"text\" name=\"symbol_location\" ng-model=\"vm.Form.objForm.symbol_location\" required><div \nng-messages=\"frmEditMppStandard.symbol_location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSymbol Location is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditMppStandard.$invalid || frmEditMppStandard.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/mpp/mpp-standard/mpp-standard.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nMPP Standard</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" flex layout-gt-xs=\"row\">\n<md-autocomplete flex-gt-sm required md-class=\"custom-autocomplete\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.product\" md-search-text=\"vm.searchProduct\" \nmd-selected-item-change=\"vm.selectedProductChange(item)\" md-items=\"item in vm.loadProduct(vm.searchProduct)\" \nmd-min-length=\"3\" md-input-name=\"id\" md-item-text=\"item.sku + \', \' + item.description\" \nmd-floating-label=\"Product Name\"><md-item-template><span md-highlight-text=\"vm.product\">\n{{item.sku + \', \' + item.description}}</span></md-item-template></md-autocomplete><md-input-container flex><label>\nMPP Type</label><md-select ng-model=\"vm.mppType\" aria-label=\"mpp_typ\" name=\"mpp_typ\" ng-change=\"vm.loadData(1)\">\n<md-option ng-value=\"\">-- All --</md-option><md-option ng-repeat=\"mt in vm.mppTypeLists\" ng-value=\"mt\" \nstyle=\"text-transform: uppercase\">{{mt}}</md-option></md-select></md-input-container><md-input-container flex><label>\nMachine Type</label><md-select ng-model=\"vm.machine_type\" aria-label=\"machine_type\" name=\"machine_type\" \nng-change=\"vm.loadData(1)\"><md-option ng-value=\"\">-- All --</md-option><md-option \nng-repeat=\"mt in vm.mppMachineTypeLists\" ng-value=\"mt\" style=\"text-transform: uppercase\">{{mt}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Position</label><md-select ng-model=\"vm.positionGroup\" \naria-label=\"position_group\" name=\"position_group\" ng-change=\"vm.loadData(1)\"><md-option ng-value=\"\">-- All --\n</md-option><md-option ng-repeat=\"ls in vm.positionGroupLists\" ng-value=\"ls\" style=\"text-transform: uppercase\">{{ls}}\n</md-option></md-select></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.getDataReport()\" ng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-mini md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Add New\" ng-click=\"vm.add($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>New</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span>New</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete\n</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><div class=\"divider-vertical\" \nhide show-gt-sm></div><md-button class=\"blue-500-fg md-mini\" hide show-gt-sm aria-label=\"Total Processing\" \ntype=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Total Processing</span></md-tooltip>\n<span>Total Processing: {{vm.processingCount}}</span></md-button><md-button class=\"blue-500-fg md-mini\" hide \nshow-gt-sm aria-label=\"Total Packaging\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\n<span>Total Packaging</span></md-tooltip><span>Total Packaging: {{vm.packagingCount}}</span></md-button><span flex \nhide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon \nmd-font-icon=\"icon-print\"></md-icon><span>PRINT</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><div id=\"tableMpp\">\n<table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th \nstyle=\"min-width: 50px\"></th><th>No</th><th>Product</th><th>Machine Type</th><th>Position Name</th><th>Position Group\n</th><th>MPP Type</th><th>Gender</th><th>Qty</th><th>Symbol Location</th><th>#</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTable.list\"><td \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(item)\" ng-click=\"vm.toggleCheck(item, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ $index + 1 }}</td>\n<td>{{ item.product_name }}</td><td>{{ item.machine_type }}</td><td>{{ item.position_name }}</td><td \nclass=\"text-center\" style=\"text-transform: uppercase\">{{ item.position_group }}</td><td class=\"text-center\" \nstyle=\"text-transform: uppercase\">{{ item.mpp_type }}</td><td class=\"text-center\">{{ item.gender }}</td><td \nclass=\"text-center\">{{ item.qty }}</td><td class=\"text-center\">{{ item.symbol_location }}</td><td class=\"text-center\">\n<a href=\"javascript:void(0);\" ng-click=\"vm.edit($event, item)\" style=\"text-decoration: none\"><span class=\"icon-pencil\">\n</span></a></td></tr></tbody></table></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpp/orglegend/orglegend.html","<md-toast id=\"toastMppTableLegend\"><div class=\"md-toast-content legend-table\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"header-fonts\">MPP TABLE LEGEND\n</div><div layout=\"row\" layout-align=\"end center\"><md-icon \nstyle=\"color:#fff; font-size:1.5rem; cursor: pointer; text-align: end\" ng-click=\"vm.closeToast()\" \nmd-font-icon=\"icon-close no-margin\"></md-icon></div></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"ls in vm.tableLegend\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"header-fonts\">{{ls.text}}</div><div layout=\"row\" layout-align=\"end center\" class=\"dot {{ls.class}}\"></div></div>\n</div></md-toast>");
$templateCache.put("app/main/mpp/orgchart/create-layer.html","<md-dialog aria-label=\"Create Layer Mpp\" md-theme=\"modal-theme\" flex=\"55\" id=\"dialog-create-mpp\"><form ng-cloak \nname=\"formCreateLayerMpp\" class=\"md-inline-form\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h4>\nCreate Layer MPPxx</h4><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding \nstyle=\"margin-top:0px\"><div layout=\"column\" flex layout-padding><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-bottom:0px\"><md-input-container flex style=\"margin-bottom:0px\"><label>Description</label><input \ntype=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" required></md-input-container></div><div \nlayout=\"row\" flex layout-align=\"start center\" style=\"padding-top:0px\"><md-input-container flex><label>Layer Type\n</label><md-select required name=\"type\" ng-model=\"vm.Form.objForm.type\"><md-option><em>None</em></md-option><md-option \nvalue=\"division\">DIVISION</md-option><md-option value=\"department\">DEPARTMENT</md-option><md-option value=\"function\">\nFUNCTION</md-option></md-select></md-input-container><md-input-container flex><label>Classification Code</label>\n<md-select required name=\"classification_code\" ng-model=\"vm.Form.objForm.clasification_code\"><md-option><em>None</em>\n</md-option><md-option ng-repeat=\"ls in vm.classificationCode\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex>\n<label>Cost Center</label><md-select required name=\"costCenter\" ng-model=\"vm.Form.objForm.cost_center_id\"><md-option>\n<em>None</em></md-option><md-option ng-repeat=\"ls1 in vm.costCenter\" value=\"{{ls1.id}}\">{{ls1.description}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Scope</label><md-select required name=\"scope\" \nng-model=\"vm.Form.objForm.org_level_id\"><md-option ng-repeat=\"ls2 in vm.orgLevel\" value=\"{{ls2.id}}\">\n{{ls2.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Grade Level</label>\n<md-select required name=\"jobLevel\" ng-model=\"vm.Form.objForm.job_level\"><md-option><em>None</em></md-option><md-option\n value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option>\n</md-select></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex>\n<label>Business Title</label><md-select required name=\"businessTitle\" ng-model=\"vm.Form.objForm.business_title_id\">\n<md-option><em>None</em></md-option><md-option ng-repeat=\"ls3 in vm.businessTitle\" value=\"{{ls3.id}}\">\n{{ls3.description}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex><label>Location</label><md-select required name=\"location\" \nng-model=\"vm.Form.objForm.sub_area_id\"><md-option><em>None</em></md-option><md-option ng-repeat=\"ls4 in vm.location\" \nvalue=\"{{ls4.id}}\">{{ls4.description}}</md-option></md-select></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div flex class=\"form-message\" ng-class=\"{success:vm.success,error:!vm.success}\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{vm.Form.pesan}}</div><div flex=\"40\" layout-align=\"end center\" \nlayout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.saveData(formCreateLayerMpp)\" \nng-disabled=\"formCreateLayerMpp.$invalid || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpp/orgchart/edit-mpp.html","<md-dialog aria-label=\"Edit Mpp\" md-theme=\"{{vm.modalTheme}}\" flex=\"55\" id=\"dialog-mpp\"><form ng-cloak \nname=\"formEditMpp\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveMpp($event,formEditMpp)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h4>{{vm.titleForm}}</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout-padding><div layout=\"row\" layout-padding><div flex=\"15\" flex-sm=\"20\" flex-xs=\"30\"><img name=\"photo\" \nsrc=\"{{vm.image}}\" onerror=\"this.src=\'assets/images/avatars/profile.jpg\'\"></div><div flex layout=\"column\" \nclass=\"badge-name\"><div layout=\"row\" ng-if=\"!vm.isNameShow\"><span flex=\"25\" flex-xs=\"40\">Name</span> <span flex>\n<md-autocomplete md-selected-item=\"vm.selectedEmployee\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-require-match md-search-text=\"vm.searchText\" md-input-name=\"nik\" md-no-cache=\"true\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" placeholder=\"Search for employee team\" \nrequired md-min-length=\"3\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.nik}} | {{item.name}}\n</span></md-item-template><md-not-found>No Record matching \"{{vm.searchText}}\" were found.</md-not-found>\n</md-autocomplete></span></div><div layout=\"row\" ng-if=\"vm.isNameShow\"><span flex=\"25\" flex-xs=\"40\">Name</span> <span \nflex>: {{vm.fullName}}</span></div><div layout=\"row\" layout-align=\"start center\"><span flex=\"25\" flex-xs=\"40\">\nLayer Of Organization</span> <span flex ng-if=\"vm.menuName!=\'add\'\">: {{vm.description}}</span><div flex=\"70\" \nflex-xs=\"60\" ng-if=\"vm.menuName==\'add\'\"><md-select name=\"layerID\" required ng-model=\"vm.Form.objForm.layerID\" \nplaceholder=\"Layer of Organization\"><md-option><em>None</em></md-option><md-option ng-repeat=\"layer in vm.listLayer\" \nng-value=\"layer.id\">{{layer.description}}</md-option></md-select></div></div><div layout=\"row\"><span flex=\"25\" \nflex-xs=\"40\">Report To</span> <span flex>: {{vm.parentDescription}}</span></div><div layout=\"row\" \nng-if=\"vm.menuName!=\'add\'\"><span flex=\"25\" flex-xs=\"40\">Employement Type</span> <span flex>: {{vm.empType}}</span>\n</div><div layout=\"row\" ng-if=\"vm.menuName!=\'add\'\"><span flex=\"25\" flex-xs=\"40\">Join Date</span> <span flex>\n: {{vm.joinDate}}</span></div><div layout=\"row\" ng-if=\"vm.menuName==\'add\'\" layout-align=\"start center\" class=\"field\">\n<span flex=\"25\" flex-xs=\"40\">Fulfilment Date</span> <span flex=\"30\"><md-datepicker name=\"dateFulfill\" \nng-disabled=\"vm.Form.objForm.transactionType == \'stay\'\" ng-required=\"vm.Form.objForm.transactionType != \'stay\'\" \nng-model=\"vm.Form.objForm.dateFulfill\" md-placeholder=\"Enter Fulfillment date\"></md-datepicker><span></span></span>\n</div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.menuName!=\'add\'\"><span flex=\"25\" flex-xs=\"40\">\nLength Of Services</span> <span flex>: {{vm.losYear}} years and {{vm.losMonth}} Months</span></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.menuName==\'add\'\"><span flex=\"25\" flex-xs=\"40\">Number of Required</span> <span \nflex><input type=\"number\" ng-disabled=\"vm.Form.objForm.transactionType == \'stay\'\" name=\"quantity\" \nng-disabled=\"vm.Form.objForm.transactionType==\'replacement\'\" ng-model=\"vm.Form.objForm.quantity\" \nng-required=\"vm.Form.objForm.transactionType != \'stay\'\" placeholder=\"Number of Required\"></span></div></div></div>\n<fieldset><legend>Choose Transaction Type</legend><md-radio-group ng-model=\"vm.Form.objForm.transactionType\" \nng-change=\"vm.setValue(vm.Form.objForm.transactionType)\"><md-radio-button ng-repeat=\"action in vm.actionLists \" \nname=\"transactionType\" required value=\"{{action.value}}\" style=\"margin-right: 15px\">{{action.description}}\n</md-radio-button></md-radio-group></fieldset><div layout=\"row\" \nng-if=\"vm.Form.objForm.transactionType != \'stay\' && vm.menuName !=\'add\' && vm.Form.objForm.transactionType != \'delete\'\" \nlayout-align=\"start center\" class=\"field\"><div flex=\"20\" flex-xs=\"40\" class=\"field-label\">Fulfillment Date</div><div \nflex=\"20\" flex-xs=\"60\"><md-datepicker name=\"dateFulfill\" required ng-model=\"vm.Form.objForm.dateFulfill\" \nmd-placeholder=\"Enter date Fulfillment\"></md-datepicker></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"field\" ng-if=\"vm.Form.objForm.transactionType == \'transfer out\'\"><div flex=\"20\" flex-xs=\"40\" \nclass=\"field-label\">Parent</div><div flex=\"70\" flex-xs=\"60\"><md-select ng-model=\"vm.Form.objForm.detail_parent\" \nng-change=\"vm.getListMppLayer(vm.Form.objForm.detail_parent)\" name=\"detail_parent\" placeholder=\"PARENT LAYER\">\n<md-option><em>None</em></md-option><md-option ng-repeat=\"mppParent in vm.mppParent\" ng-value=\"mppParent\">\n{{mppParent.description}}</md-option></md-select></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"field\" ng-if=\"vm.Form.objForm.transactionType == \'transfer out\'\"><div flex=\"20\" flex-xs=\"40\" \nclass=\"field-label\">Layer</div><div flex=\"70\" flex-xs=\"60\"><md-select ng-model=\"vm.Form.objForm.detail_layer\" \nname=\"detail_layer\" placeholder=\"LAYER\"><md-option><em>None</em></md-option><md-option \nng-repeat=\"ls in vm.layerDetail\" ng-value=\"ls\">{{ls.description}}</md-option></md-select></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"field\" \nng-if=\"vm.Form.objForm.transactionType!=\'stay\' && ( vm.Form.objForm.transactionType==\'promotion\' || vm.Form.objForm.transactionType==\'demotion\') \">\n<div flex=\"20\" flex-xs=\"40\" class=\"field-label\">Layer Of Organization</div><div flex=\"70\" flex-xs=\"60\"><md-select \nng-model=\"vm.Form.objForm.layerID\" required name=\"layerID\" placeholder=\"Layer of Organization\"><md-option><em>None</em>\n</md-option><md-option ng-repeat=\"layer in vm.listLayer\" ng-value=\"layer.id\">{{layer.description}}</md-option>\n</md-select></div></div><div layout=\"column\" layout-align=\"start center\" layout-gt-xs=\"row\" \nng-if=\"vm.Form.objForm.transactionType == \'new hire\'\"><md-checkbox name=\"isDuplicate\" class=\"md-checkbox-sm\" \nng-model=\"vm.Form.objForm.isDuplicate\" aria-label=\"duplicate\">Create Duplicate Layer</md-checkbox></div><div \nclass=\"messageError\" ng-show=\"vm.showErrorEmployee\">{{ vm.messagesErrorEmployee }}</div></md-dialog-content>\n<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.saveProcess\"></md-progress-linear>\n<md-dialog-actions layout=\"row\"><div flex class=\"form-message\" ng-class=\"{success:vm.success,error:!vm.success}\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{vm.Form.pesan}}</div><div flex=\"40\" layout-align=\"end center\" \nlayout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" ng-disabled=\"formEditMpp.$invalid || vm.saveProcess\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button \nng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpp/orgchart/menu.html","<md-dialog aria-label=\"menu\" md-theme=\"modal-theme\" flex=\"25\" id=\"dialog-create-mpp\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h4>Choose Actions</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout-padding style=\"margin-top:0px\"><md-select ng-model=\"vm.selectedOptions\"><md-option \nng-repeat=\"state in vm.listSelection\" ng-value=\"state\">{{state}}</md-option></md-select></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.hide(vm.selectedOptions)\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>OK</md-button><md-button ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Cancel</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mpp/orgchart/orgchart.html","<div class=\"page-layout\" mpp-chart-viewport id=\"orgchart-area\"><div layout=\"column\" style=\"padding:0; margin: 0\" \nclass=\"content-card\"><md-content id=\"centerpanel\" class=\"org-chart\" \nstyle=\"overflow:hidden; padding: 0px; margin: 0px; border: 0px\"><div id=\"chartContent\" bp-org-diagram \ndata-options=\"vm.options\" flex=\"100\" style=\"overflow:unset\" ms-scroll></div></md-content></div></div>");
$templateCache.put("app/main/mpp/product-machine-position/product-machine-position-add.html","<md-dialog aria-label=\"Form Add Product Machine Position\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack \nname=\"frmAddProductMachinePosition\" class=\"md-inline-form popup-input-form\" novalidate><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Add Product Machine Position</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input \ntype=\"file\" id=\"uploadPhoto\" nv-file-select uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadPhoto\',product_id: vm.data.id}] }\"></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\">\nSubmit & Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpp/product-machine-position/product-machine-position-edit.html","<md-dialog aria-label=\"Form Edit Product Machine Position\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack \nname=\"frmEditProductMachinePosition\" class=\"md-inline-form popup-input-form\" novalidate><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Edit Product Machine Position</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><img ng-if=\"vm.existingLinkImage\" src=\"{{vm.existingLinkImage}}\" alt=\"\"><div \nstyle=\"height: 20px\"></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" \nid=\"uploadPhoto\" nv-file-select uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadPhoto\',product_id: vm.data.id}] }\"></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span> \n<span class=\"orange-400-fg\"><i style=\"font-size: small\">Current image will be replace with new image uploaded.</i>\n</span><md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\">Submit Update & Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpp/product-machine-position/product-machine-position.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nProduct Machine Position</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form style=\"width:40%\" \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-autocomplete required flex md-no-cache=\"vm.noCache\" md-selected-item=\"vm.product\" \nmd-search-text=\"vm.searchProduct\" md-selected-item-change=\"vm.selectedProductChange(item)\" \nmd-items=\"item in vm.loadProduct(vm.searchProduct)\" md-min-length=\"3\" md-input-name=\"id\" \nmd-item-text=\"item.sku + \', \' + item.description\" md-floating-label=\"Product Name\"><md-item-template><span \nmd-highlight-text=\"vm.product\">{{item.sku + \', \' + item.description}}</span></md-item-template></md-autocomplete>\n<md-button style=\"margin-top:-10px\" class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div>\n</form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><span flex hide \nshow-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" \nms-scroll><div id=\"tableMpp\"><table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" \nms-responsive-table><thead><tr><th style=\"min-width: 50px\"></th><th>No</th><th>SKU</th><th>Description</th><th>\nCream Type</th><th>Country</th><th>Machine Position</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTable.list\">\n<td style=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(item)\" ng-click=\"vm.toggleCheck(item, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ $index + 1 }}</td>\n<td class=\"text-center\">{{ item.sku }}</td><td>{{ item.description }}</td><td class=\"text-center\">{{ item.cream_type }}\n</td><td class=\"text-center\">{{ item.country }}</td><td class=\"text-center\"><a ng-if=\"item.link_image\" \nhref=\"javascript:void(0);\" ng-click=\"vm.edit($event, item)\" style=\"text-decoration: none\"><span \nclass=\"icon-tooltip-image\"></span></a> <a ng-if=\"!item.link_image\" href=\"javascript:void(0);\" \nng-click=\"vm.uploadNew($event, item)\" style=\"text-decoration: none\"><span class=\"icon-upload\"></span></a></td></tr>\n</tbody></table></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpp/orgtable/orgtable.html","<div class=\"page-layout\" mpp-table-viewport toggle=\"{{vm.togglePayment}}\" id=\"orgTable\"><div layout=\"row\" \nclass=\"content-card\" style=\"background-color: #fff; padding-bottom:0px\"><div flex \nstyle=\"background-color: #fff; padding-top:0; padding-bottom:0\" layout=\"column\" layout-padding layout><md-content \nid=\"orgTableContent\" style=\"padding-top:0px; padding-left:0px; padding-right: 0px; background-color: #fff\" ms-scroll>\n<md-subheader ng-style=\"vm.flex.style\" id=\"mppSubHeader\" flex class=\"mpp-subheader-basket mpp-header-bg\"><md-list flex \nlayout layout=\"column\" class=\"no-padding\" style=\"background-color: #fff\"><md-list-item id=\"mainSubheader\" \nclass=\"mpp-header-list service\" layout=\"row\" layout-align=\"start center\"><div \nflex=\"{{vm.flex.main.businessTitle.flex_1}}\" flex-order=\"{{vm.flex.main.businessTitle.order}}\" \nclass=\"capitalize header-fonts stickyLeft blue\" layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left:5px; min-height: 33px\"><span>Business Title</span></div></div><div \nng-if=\"vm.flex.main.action.show\" style=\"padding-left:6px\" flex=\"{{vm.flex.main.action.flex_1}}\" \nflex-order=\"{{vm.flex.main.action.order}}\" class=\"capitalize header-fonts\" layout=\"row\" layout-align=\"start center\">\nAction</div><div ng-if=\"vm.flex.main.actual.show\" flex=\"{{vm.flex.main.actual.flex_1}}\" \nflex-order=\"{{vm.flex.main.actual.order}}\" class=\"normal header-fonts\" layout=\"column\"><div flex layout=\"column\" \nclass=\"normal header-fonts\"><div layout=\"row\" layout-align=\"center center\">ACTUAL</div><div layout=\"row\" \nlayout-align=\"center center\" class=\"border-mpp-header-bottom\" style=\"padding-bottom: 4px\">{{ vm.newDt }}</div><div \nlayout=\"row\"><div flex layout=\"row\" class=\"normal header-fonts\" layout-align=\"center center\">HC</div><div flex \nlayout=\"row\" class=\"normal header-fonts border-mpp-header-left\" layout-align=\"center center\">Total</div></div></div>\n</div><div ng-if=\"vm.flex.main.current.show\" flex=\"{{vm.flex.main.current.flex_1}}\" \nflex-order=\"{{vm.flex.main.current.order}}\" class=\"capitalize header-fonts\" layout=\"column\"><div flex layout=\"column\" \nclass=\"normal header-fonts\"><div layout=\"row\" layout-align=\"center center\">MPP</div><div layout=\"row\" \nlayout-align=\"center center\" class=\"border-mpp-header-bottom\" style=\"padding-bottom: 4px\">{{ vm.yearSelected - 1 }}\n</div><div layout=\"row\"><div flex layout=\"row\" class=\"normal header-fonts\" layout-align=\"center center\">HC</div><div \nflex layout=\"row\" class=\"normal header-fonts border-mpp-header-left\" layout-align=\"center center\">Total</div></div>\n</div></div><div ng-if=\"vm.flex.main.status.show\" flex=\"{{vm.flex.main.status.flex_1}}\" \nflex-order=\"{{vm.flex.main.status.order}}\" layout=\"row\" class=\"capitalize header-fonts\" layout-align=\"center center\">\nStatus</div><div ng-if=\"vm.flex.main.future.show\" flex=\"{{vm.flex.main.future.flex_1}}\" \nflex-order=\"{{vm.flex.main.future.order}}\" class=\"capitalize header-fonts\" layout=\"column\"><div flex layout=\"column\" \nclass=\"normal header-fonts\"><div layout=\"row\" layout-align=\"center center\">MPP</div><div layout=\"row\" \nlayout-align=\"center center\" class=\"border-mpp-header-bottom\" style=\"padding-bottom: 4px\">{{vm.yearSelected}}</div><div\n layout=\"row\"><div flex layout=\"row\" class=\"normal header-fonts\" layout-align=\"center center\">HC</div><div flex \nlayout=\"row\" class=\"normal header-fonts border-mpp-header-left\" layout-align=\"center center\">Total</div></div></div>\n</div><div ng-if=\"vm.flex.main.totalPerMonth.show\" flex=\"{{vm.flex.main.totalPerMonth.flex_1}}\" \nflex-order=\"{{vm.flex.main.totalPerMonth.order}}\" layout=\"row\"><div layout=\"row\" class=\"capitalize header-fonts\" flex \nlayout-align=\"center center\">Total</div></div><div ng-if=\"vm.flex.main.month.show\" \nflex=\"{{vm.flex.main.month.flex_1}}\" flex-order=\"{{vm.flex.main.month.order}}\" layout=\"row\"><div layout=\"row\" \nclass=\"capitalize header-fonts month-size\" flex layout-align=\"center center\" \nng-repeat=\"i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]\">{{ vm.convertMonth(i).substring(0,3) }}</div></div><div \nng-if=\"vm.flex.main.cost.show\" flex=\"{{vm.flex.main.cost.flex_1}}\" flex-order=\"{{vm.flex.main.cost.order}}\" \nlayout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" class=\"normal header-fonts padding-cost\">\nBeban Gaji dan Upah</div><div flex layout=\"row\" class=\"normal header-fonts padding-cost\">Tunjangan Karyawan</div><div \nflex layout=\"row\" class=\"normal header-fonts padding-cost\">Lembur</div><div flex layout=\"row\" \nclass=\"normal header-fonts padding-cost\">THR</div><div flex layout=\"row\" class=\"normal header-fonts padding-cost\">Bonus\n</div><div flex layout=\"row\" class=\"normal header-fonts padding-cost\">PHK Karyawan</div><div flex layout=\"row\" \nclass=\"normal header-fonts padding-cost\">Beban Jamsostek</div><div flex layout=\"row\" \nclass=\"normal header-fonts padding-cost\">Tunjangan & Insentif</div><div flex layout=\"row\" \nclass=\"normal header-fonts padding-cost\">Beban Sewa Kendaraan</div><div flex layout=\"row\" \nclass=\"normal header-fonts padding-cost\">Beban Asuransi Kesehatan</div><div flex layout=\"row\" \nclass=\"normal header-fonts padding-cost\">Beban Pajak</div></div></md-list-item></md-list></md-subheader><md-list flex \nlayout=\"column\" style=\"margin-top:20px\" class=\"no-padding\" ng-style=\"vm.flex.style\" ng-if=\"!vm.showEmptyData\"><div \nflex class=\"no-padding no-margin\" ng-repeat=\"item in vm.rootLayer\" ng-include=\"\'item-list.html\'\"></div></md-list>\n<md-list flex layout=\"column\" class=\"no-padding\" ng-style=\"vm.flex.style\" layout-align=\"center center\" \nng-if=\"vm.showEmptyData\"><md-list-item flex layout=\"row\" layout-align=\"center center\">Data Is Empty</md-list-item>\n</md-list></md-content></div></div><div layout=\"row\" class=\"content-card\" \nstyle=\"background-color: #fff; border-top: 5px solid #ccc\" ng-show=\"vm.togglePayment\"><div flex \nstyle=\"background-color: #fff; padding-top:0; padding-bottom:0\" layout=\"column\" layout-padding layout><md-content \nng-show=\"vm.togglePayment\" id=\"orgTablePayment\" ms-scroll \nstyle=\"padding-top:0px; padding-left: 0px; padding-right: 0; background-color: #fff\"><md-list flex class=\"no-padding\" \nlayout=\"column\" ng-style=\"{\'width\' : \'100%\'}\" style=\"background-color: #fff\"><md-list-item flex layout=\"row\" \nclass=\"normal body-fonts\"><div flex=\"{{vm.flex.main.businessTitle.flex_1}}\" layout=\"row\" class=\"stickyLeft\" \nstyle=\"padding-left:5px; min-height: 100%\"><strong style=\"color:#357ebd\">Month</strong></div><div flex \nflex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" \nclass=\"capitalize body-fonts\" ng-repeat=\"i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]\" layout-align=\"center center\" \nstyle=\"border: 1px solid #ccc\" flex><strong style=\"color:#357ebd\">{{ vm.convertMonth(i).substring(0,3) }}</strong>\n</div></div></md-list-item><md-divider></md-divider><md-list-item flex layout=\"row\" class=\"normal body-fonts\"><div \nflex=\"{{vm.flex.main.businessTitle.flex_1}}\" layout=\"row\" class=\"stickyLeft\" \nstyle=\"padding-left:5px; min-height: 100%\"><strong style=\"color:#357ebd\">Total</strong></div><div flex \nflex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" \nclass=\"capitalize body-fonts\" ng-repeat=\"ls in vm.rootLayer[0].listCost.list\" layout-align=\"center center\" \nstyle=\"border: 1px solid #ccc\" flex><strong style=\"color:#357ebd\">{{ ls.totalCost | shortenestMoney }}</strong></div>\n</div></md-list-item><md-divider></md-divider><md-list-item flex layout=\"row\" class=\"normal body-fonts\"><div \nflex=\"{{vm.flex.main.businessTitle.flex_1}}\" layout=\"row\" class=\"stickyLeft\" \nstyle=\"padding-left:5px; min-height: 100%\">Beban Gaji dan Upah</div><div flex \nflex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" \nclass=\"capitalize body-fonts\" layout-align=\"center center\" style=\"border: 1px solid #ccc\" flex \nng-repeat=\"pay in vm.rootLayer[0].listCost.list\">{{ pay.gajiPokok | shortenestMoney }}</div></div></md-list-item>\n<md-divider></md-divider><md-list-item flex layout=\"row\" class=\"normal body-fonts\"><div \nflex=\"{{vm.flex.main.businessTitle.flex_1}}\" class=\"stickyLeft\" layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left:5px; min-height: 100%\">Tunjangan Karyawan</div><div flex flex-order=\"{{vm.flex.main.month.order}}\" \nng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" class=\"capitalize body-fonts\" \nlayout-align=\"center center\" style=\"border: 1px solid #ccc\" flex ng-repeat=\"pay in vm.rootLayer[0].listCost.list\">\n{{ pay.tunjangan | shortenestMoney }}</div></div></md-list-item><md-divider></md-divider><md-list-item flex \nlayout=\"row\" class=\"normal body-fonts\"><div flex=\"{{vm.flex.main.businessTitle.flex_1}}\" class=\"stickyLeft\" \nlayout=\"row\" layout-align=\"start center\" style=\"padding-left:5px; min-height: 100%\">Lembur</div><div flex \nflex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" \nclass=\"capitalize body-fonts\" layout-align=\"center center\" style=\"border: 1px solid #ccc\" flex \nng-repeat=\"i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]\">-</div></div></md-list-item><md-divider></md-divider>\n<md-list-item flex layout=\"row\" class=\"normal body-fonts\"><div flex=\"{{vm.flex.main.businessTitle.flex_1}}\" \nclass=\"stickyLeft\" layout=\"row\" layout-align=\"start center\" style=\"padding-left:5px; min-height: 100%\">THR</div><div \nflex flex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" \nclass=\"capitalize body-fonts\" layout-align=\"center center\" style=\"border: 1px solid #ccc\" flex \nng-repeat=\"pay in vm.rootLayer[0].listCost.list\">{{pay.thr | shortenestMoney}}</div></div></md-list-item><md-divider>\n</md-divider><md-list-item flex layout=\"row\" class=\"normal body-fonts\"><div \nflex=\"{{vm.flex.main.businessTitle.flex_1}}\" class=\"stickyLeft\" layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left:5px; min-height: 100%\">Bonus</div><div flex flex-order=\"{{vm.flex.main.month.order}}\" \nng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" class=\"capitalize body-fonts\" \nlayout-align=\"center center\" style=\"border: 1px solid #ccc\" flex ng-repeat=\"pay in vm.rootLayer[0].listCost.list\">\n{{pay.bonus | shortenestMoney}}</div></div></md-list-item><md-divider></md-divider><md-list-item flex layout=\"row\" \nclass=\"normal body-fonts\"><div flex=\"{{vm.flex.main.businessTitle.flex_1}}\" class=\"stickyLeft\" layout=\"row\" \nlayout-align=\"start center\" style=\"padding-left:5px; min-height: 100%\">PHK Karyawan</div><div flex \nflex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" \nclass=\"capitalize body-fonts\" layout-align=\"center center\" style=\"border: 1px solid #ccc\" flex \nng-repeat=\"i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]\">-</div></div></md-list-item><md-divider></md-divider>\n<md-list-item flex layout=\"row\" class=\"normal body-fonts\"><div flex=\"{{vm.flex.main.businessTitle.flex_1}}\" \nclass=\"stickyLeft\" layout=\"row\" layout-align=\"start center\" style=\"padding-left:5px; min-height: 100%\">Beban Jamsostek\n</div><div flex flex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\"><div \nlayout=\"row\" class=\"capitalize body-fonts\" layout-align=\"center center\" style=\"border: 1px solid #ccc\" flex \nng-repeat=\"pay in vm.rootLayer[0].listCost.list\">{{pay.jamsostek | shortenestMoney}}</div></div></md-list-item>\n<md-divider></md-divider><md-list-item flex layout=\"row\" class=\"normal body-fonts\"><div \nflex=\"{{vm.flex.main.businessTitle.flex_1}}\" class=\"stickyLeft\" layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left:5px; min-height: 100%\">Tunjangan & Insentif</div><div flex \nflex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" \nclass=\"capitalize body-fonts\" layout-align=\"center center\" style=\"border: 1px solid #ccc\" flex \nng-repeat=\"pay in vm.rootLayer[0].listCost.list\">{{ pay.tunjanganLain | shortenestMoney }}</div></div></md-list-item>\n<md-divider></md-divider><md-list-item flex layout=\"row\" class=\"normal body-fonts\"><div \nflex=\"{{vm.flex.main.businessTitle.flex_1}}\" class=\"stickyLeft\" layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left:5px; min-height: 100%\">Beban Sewa Kendaraan</div><div flex \nflex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" \nclass=\"capitalize body-fonts\" layout-align=\"center center\" style=\"border: 1px solid #ccc\" flex \nng-repeat=\"pay in vm.rootLayer[0].listCost.list\">{{ pay.tunjanganCop | shortenestMoney }}</div></div></md-list-item>\n<md-divider></md-divider><md-list-item flex layout=\"row\" class=\"normal body-fonts\"><div \nflex=\"{{vm.flex.main.businessTitle.flex_1}}\" class=\"stickyLeft\" layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left:5px; min-height: 100%\">Beban Asuransi kesehatan</div><div flex \nflex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" \nclass=\"capitalize body-fonts\" layout-align=\"center center\" style=\"border: 1px solid #ccc\" flex \nng-repeat=\"pay in vm.rootLayer[0].listCost.list\">{{pay.bpjsKesehatan | shortenestMoney}}</div></div></md-list-item>\n<md-divider></md-divider><md-list-item flex layout=\"row\" class=\"normal body-fonts\"><div \nflex=\"{{vm.flex.main.businessTitle.flex_1}}\" class=\"stickyLeft\" layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left:5px; min-height: 100%\">Beban Pajak</div><div flex flex-order=\"{{vm.flex.main.month.order}}\" \nng-show=\"vm.flex.main.month.show\" layout=\"row\"><div layout=\"row\" class=\"capitalize body-fonts\" \nlayout-align=\"center center\" style=\"border: 1px solid #ccc\" flex ng-repeat=\"pay in vm.rootLayer[0].listCost.list\">\n{{pay.pajak | shortenestMoney}}</div></div></md-list-item></md-list></md-content></div></div></div><script \ntype=\"text/ng-template\" id=\"item-list.html\">\n<!-- Parent Rows -->\n  <md-list-item class=\"content-item\" flex layout=\"row\" layout-align=\"start center\" id=\"loadingBlock{{item.id}}\" >\n      <!-- first row -->\n      <div flex=\"{{vm.flex.main.businessTitle.flex_1}}\" class=\"stickyLeft\" flex-order=\"{{vm.flex.main.businessTitle.order}}\" layout=\"row\" layout-align=\"start center\">\n        <div flex=\"{{item.level == 0 ? 1 : (item.level + 1) * 5}}\" layout=\"row\" layout-align=\"start center\" style=\"padding-right:10px;\">\n          <md-icon flex layout=\"row\" layout-wrap layout-align=\"end center\" md-font-icon=\"{{item.CollapseClass}}\" ng-if=\"item.isParent == 1 || item.listDetail[vm.yearSelected].length > 0\"\n            ng-click=\"vm.toggleChildren(item, $event)\" style=\"font-size:1.5rem; cursor: pointer\">\n          </md-icon>\n        </div>\n        <div flex layout=\"row\" class=\"body-fonts\" ng-class=\"vm.setColorStatus(item)\" layout-align=\"start center\">\n          <strong>{{item.description.toUpperCase()}}</strong>\n        </div>\n      </div>\n\n      <div flex=\"{{vm.flex.main.action.flex_1}}\" flex-order=\"{{vm.flex.main.action.order}}\" ng-if=\"vm.flex.main.action.show\" layout=\"row\" layout-align=\"start center\">\n        <div>\n          <md-button class=\"md-icon-button no-padding no-margin\" ng-click=\"vm.showTransaction($event, item, 1, \'add\')\" ng-disabled=\"vm.disableAction\">\n            <md-icon flex class=\"no-margin\" md-font-icon=\"icon-account-plus\" ng-style=\"{\'color\' : !vm.disableAction ? \'green\' : \'grey\' }\" style=\"font-size:1.2rem; cursor:pointer\"></md-icon>\n            <md-tooltip md-direction=\"bottom\">Add</md-tooltip>\n          </md-button>\n        </div>\n        <!-- <div>\n          <md-button class=\"md-icon-button no-padding no-margin\" ng-click=\"vm.showCreateLayer($event, item)\" ng-disabled=\"vm.disableAction\">\n            <md-icon flex class=\"no-margin\" md-font-icon=\"icon-table-column-plus-after\" ng-style=\"{\'color\' : !vm.disableAction ? \'green\' : \'grey\' }\" style=\"font-size:1.2rem; cursor:pointer\"></md-icon>\n            <md-tooltip md-direction=\"bottom\">Create Layer</md-tooltip>\n          </md-button>\n        </div> -->\n      </div>\n\n      <!-- Actual-->\n      <div ng-if=\"vm.flex.main.actual.show\" flex-order=\"{{vm.flex.main.actual.order}}\" flex=\"{{vm.flex.main.actual.flex_1}}\" class=\"capitalize body-fonts\" layout=\"row\" layout-align=\"start center\">\n        <div flex layout=\"row\" class=\"capitalize body-fonts\">\n          <div flex layout=\"row\" class=\"capitalize body-fonts\" layout-align=\"center bottom\">\n            {{item.current.total}}\n          </div>\n          <div flex layout=\"row\" class=\"capitalize body-fonts\" layout-align=\"center bottom\" ng-click=\"vm.showMerge($event, item)\" style=\"cursor:pointer\">\n            {{ item.isParent == 1 || item.listDetail[vm.yearSelected].length > 0 ? item.current.totalAll : \'\' }}\n          </div>\n        </div>\n      </div>\n\n      <!-- year current -->\n      <div ng-if=\"vm.flex.main.current.show\" flex-order=\"{{vm.flex.main.current.order}}\" flex=\"{{vm.flex.main.current.flex_1}}\" class=\"capitalize body-fonts\" layout=\"row\" layout-align=\"start center\">\n        <div flex layout=\"row\" class=\"capitalize body-fonts\" layout-align=\"center bottom\">\n          {{item.totalDetail[vm.yearSelected - 1]}}\n        </div>\n        <div flex layout=\"row\" class=\"capitalize body-fonts\" layout-align=\"center bottom\">\n          {{ item.total[(vm.yearSelected-1)]}}\n        </div>\n      </div>\n\n      <!-- status -->\n      <div ng-if=\"vm.flex.main.status.show\" flex-order=\"{{vm.flex.main.status.order}}\" flex=\"{{vm.flex.main.status.flex_1}}\" class=\"capitalize header-fonts\" layout-align=\"center center\" layout=\"row\">\n      </div>\n\n      <!-- year future -->\n      <div ng-if=\"vm.flex.main.future.show\" flex-order=\"{{vm.flex.main.future.order}}\" flex=\"{{vm.flex.main.future.flex_1}}\" class=\"capitalize body-fonts\" layout=\"row\" layout-align=\"start center\">\n        <div flex layout=\"row\" class=\"capitalize body-fonts\" layout-align=\"center bottom\">\n          {{ item.totalDetail[(vm.yearSelected)] }}\n        </div>\n        <div flex layout=\"row\" class=\"capitalize body-fonts\" layout-align=\"center bottom\">\n          {{ item.total[vm.yearSelected]}}\n        </div>\n      </div>\n\n      <div ng-if=\"vm.flex.main.totalPerMonth.show\" flex=\"{{vm.flex.main.totalPerMonth.flex_1}}\" flex-order=\"{{vm.flex.main.totalPerMonth.order}}\"\n      layout=\"row\">\n        <div layout=\"row\" class=\"capitalize header-fonts\" flex layout-align=\"center center\">\n          {{ item.listCost.totalCost | shortenestMoney }}\n        </div>\n      </div>\n\n      <!--month rows-->\n      <div flex=\"{{vm.flex.main.month.flex_1}}\" flex-order=\"{{vm.flex.main.month.order}}\" ng-if=\"vm.flex.main.month.show\" class=\"capitalize body-fonts\" layout=\"row\" >\n        <div layout=\"row\"  layout-align=\"center center\" flex ng-repeat=\"i in item.totalInMonth\">\n            <span ng-show=\"vm.showMoneyMonth\">\n              {{ i.total }} / {{ item.listCost.list[$index].totalInMonth }}\n            </span>\n            <span ng-show=\"!vm.showMoneyMonth\">\n              {{ i.total }} / {{ item.listCost.list[$index].totalInMonth }}\n            </span>\n        </div>\n      </div>\n\n      <!-- cost row -->\n      <div flex=\"{{vm.flex.main.cost.flex_1}}\" flex-order=\"{{vm.flex.main.cost.order}}\" ng-if=\"vm.flex.main.cost.show\" layout=\"row\" layout-align=\"center center\">\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ item.listCost.gaji_pokok | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ item.listCost.tunjangan | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ 0 |shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ item.listCost.thr | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ item.listCost.bonus | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ 0 |shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ item.listCost.jamsostek | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ item.listCost.tunjangan_lain | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ item.listCost.tunjangan_cop | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ item.listCost.bpjs_kesehatan | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ item.listCost.pajak | shortenestMoney }}\n        </div>\n      </div>\n    </md-list-item>\n    <md-divider ng-if=\"item.childrenVisible\"></md-divider>\n\n    <!-- Child row start -->\n    <md-list-item class=\"content-item\" flex layout=\"row\" layout-align=\"start center\" ng-repeat=\"val in item.listDetail[vm.yearSelected]\" ng-if=\"item.childrenVisible\">\n      <div flex=\"{{vm.flex.main.businessTitle.flex_1}}\" class=\"stickyLeft\" flex-order=\"{{vm.flex.main.businessTitle.order}}\" layout=\"row\" layout-wrap layout-align=\"start center\">\n        <div flex=\"{{item.level == 0 ? 5 : (item.level + 1) * 5}}\" layout=\"row\" layout-align=\"end center\">\n          <md-icon style=\"font-size:1.5rem; cursor: pointer; margin:0px\">\n          </md-icon>\n        </div>\n        <div flex layout=\"row\" layout-align=\"start center\" class=\"body-fonts\">\n          <div flex=\"20\" style=\"padding-left: {{ val.nik == vm.user ? \'12px\' : \'\'}}\" layout=\"row\" layout-align=\"start center\" class=\"capitalize body-fonts\">\n            {{val.nik}}\n          </div>\n          <div flex layout=\"row\" layout-align=\"start center\" class=\"body-fonts\" style=\"text-transform:capitalize\">\n            {{val.name ? val.name.toLowerCase() : \'TBD\'}}\n          </div>\n        </div>\n      </div>\n\n      <div flex=\"{{vm.flex.main.action.flex_1}}\" flex-order=\"{{vm.flex.main.action.order}}\" ng-if=\"vm.flex.main.action.show\"  layout=\"row\" layout-align=\"start center\">\n        <div ng-if=\"(val.nik != vm.user)\">\n          <md-button class=\"md-icon-button no-padding no-margin\" ng-disabled=\"vm.disableAction\" ng-click=\"vm.showTransaction($event, val, 2, \'edit\')\">\n            <md-icon flex class=\"no-margin\" md-font-icon=\"icon-pencil\"  ng-style=\"{\'color\' : !vm.disableAction ? \'#0f82b4\' : \'grey\' }\"  style=\"font-size:1.2rem; cursor: pointer;\"></md-icon>\n            <md-tooltip md-direction=\"bottom\">Edit Action</md-tooltip>\n          </md-button>\n        </div>\n        <div ng-if=\"(val.transaction_type === \'promoted\') && (val.nik != vm.user)\">\n          <md-button class=\"md-icon-button no-padding no-margin\" ng-disabled=\"vm.disableAction\" ng-click=\"vm.showCancel(val, $event)\">\n            <md-icon flex class=\"no-margin\" md-font-icon=\"icon-cancel\" ng-style=\"{\'color\' :  !vm.disableAction ? \'#f19125\' : \'grey\' }\" style=\"font-size:1.2rem; cursor: pointer;\"></md-icon>\n            <md-tooltip md-direction=\"bottom\">Cancel Action</md-tooltip>\n          </md-button>\n        </div>\n        <div ng-if=\"(val.transaction_type === \'transfer in\') || (val.transaction_type === \'new hire\') || (val.transaction_type === \'new-hire-null\') && (val.nik != vm.user)\">\n          <md-button class=\"md-icon-button no-padding no-margin\" ng-disabled=\"vm.disableAction\" ng-click=\"vm.showDelete(val, $event)\">\n            <md-icon flex class=\"no-margin\" md-font-icon=\"icon-trash\" ng-style=\"{\'color\' : !vm.disableAction ? \'#f85853\' : \'grey\' }\" style=\"font-size:1.2rem; cursor: pointer;\"></md-icon>\n            <md-tooltip md-direction=\"bottom\">Delete Action</md-tooltip>\n          </md-button >\n        </div>\n      </div>\n\n\n\n      <!-- Actual -->\n      <div ng-show=\"vm.flex.main.actual.show\" flex-order=\"{{vm.flex.main.actual.order}}\" flex=\"{{vm.flex.main.actual.flex_1}}\" class=\"capitalize body-fonts\" layout=\"row\" layout-align=\"start center\">\n        <div flex layout=\"row\" class=\"capitalize body-fonts\" style=\"color:{{item.isParent == 1 || item.listDetail.length > 0 ? \'#989898\' : \'#000000\'}}; cursor: pointer;\"\n          layout-align=\"center bottom\">\n           {{ val.transaction_type == \'stay\' ? 1 : 0 }}\n        </div>\n        <div flex layout=\"row\" class=\"capitalize body-fonts\" style=\"color:{{item.isParent == 1 || item.listDetail.length > 0 ? \'#989898\' : \'#000000\'}}\"\n          layout-align=\"center bottom\">\n           {{ val.transaction_type == \'stay\' ? 1 : 0 }}\n        </div>\n      </div>\n\n      <!-- Current year -->\n      <div ng-show=\"vm.flex.main.current.show\" flex-order=\"{{vm.flex.main.current.order}}\" flex=\"{{vm.flex.main.current.flex_1}}\" style=\"color:{{item.isParent == 1 ?  \'#989898\' : \'#000000\'}}\" layout=\"row\"\n        layout-align=\"start center\">\n        <div flex layout=\"row\" class=\"capitalize body-fonts\" layout-align=\"center bottom\">\n          {{ (item.listDetail[vm.yearSelected - 1][$index].layer_id==item.layer_id ? 1 : 0) }}\n        </div>\n        <div flex layout=\"row\" class=\"capitalize body-fonts\" layout-align=\"center bottom\">\n           {{ (item.listDetail[vm.yearSelected - 1][$index].layer_id==item.layer_id ? 1 : 0) }}\n        </div>\n      </div>\n\n      <!-- Status -->\n      <div ng-show=\"vm.flex.main.status.show\"  flex-order=\"{{vm.flex.main.status.order}}\" flex=\"{{vm.flex.main.status.flex_1}}\" class=\"capitalize header-fonts\" layout-align=\"center center\" layout=\"row\">\n        <span ng-class=\"vm.dotStatus(val.transaction_type)\"></span>\n        <md-tooltip md-direction=\"right\">{{val.transaction_type}}</md-tooltip>\n      </div>\n\n      <!-- future year -->\n      <div ng-show=\"vm.flex.main.future.show\" flex-order=\"{{vm.flex.main.future.order}}\" flex=\"{{vm.flex.main.future.flex_1}}\"\n        class=\"capitalize body-fonts\" layout=\"row\" layout-align=\"start center\">\n        <div flex layout=\"row\" class=\"capitalize body-fonts\" style=\"color:{{item.isParent == 1 || item.listDetail.length > 0 ? \'#989898\' : \'#000000\'}}\"\n          layout-align=\"center bottom\">\n          {{ (val.transaction_type == \'termination\' || val.transaction_type == \'transfer out\') ? 0 : 1 }}\n        </div>\n        <div flex layout=\"row\" class=\"capitalize body-fonts\" style=\"color:{{item.isParent == 1 || item.listDetail.length > 0 ? \'#989898\' : \'#000000\'}}\"\n          layout-align=\"center bottom\">\n           {{ (val.transaction_type == \'termination\' || val.transaction_type == \'transfer out\') ? 0 : 1 }}\n        </div>\n      </div>\n\n      <div ng-if=\"vm.flex.main.totalPerMonth.show\" flex=\"{{vm.flex.main.totalPerMonth.flex_1}}\" flex-order=\"{{vm.flex.main.totalPerMonth.order}}\"\n      layout=\"row\">\n        <div layout=\"row\" class=\"capitalize header-fonts\" flex layout-align=\"center center\">\n          {{val.totalCost | shortenestMoney }}\n        </div>\n      </div>\n\n      <!-- View Month -->\n      <div flex=\"{{vm.flex.main.month.flex_1}}\" flex-order=\"{{vm.flex.main.month.order}}\" ng-show=\"vm.flex.main.month.show\" layout=\"row\">\n        <div layout=\"row\" class=\"capitalize body-fonts\" layout-align=\"center center\" flex ng-repeat=\"i in val.listCost\" ng-class=\"vm.switchBackgroundMonth($parent.isParent,  i.totalInMonth)\">\n          <span ng-show=\"vm.showMoneyMonth\">\n              {{ i.totalInMonth }}\n          </span>\n          <span ng-show=\"!vm.showMoneyMonth\">\n              {{ i.totalCost | shortenestMoney }}\n          </span>\n        </div>\n      </div>\n\n      <!-- view cost -->\n      <div flex=\"{{vm.flex.main.cost.flex_1}}\" flex-order=\"{{vm.flex.main.cost.order}}\" ng-show=\"vm.flex.main.cost.show\" layout=\"row\" layout-align=\"center center\">\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ val.gaji_pokok | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ val.tunjangan | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ 0 | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ val.thr | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ val.bonus | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ 0 | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ val.jamsostek | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ val.tunjangan_lain | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ val.tunjangan_cop | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ val.bpjs_kesehatan | shortenestMoney }}\n        </div>\n        <div flex layout=\"row\" class=\"normal body-fonts padding-cost\">\n          {{ val.pajak | shortenestMoney }}\n        </div>\n      </div>\n    </md-list-item>\n    <md-divider></md-divider>\n    <md-list class=\"no-padding\" flex ng-if=\"item.childrenVisible\" style=\"width:{{vm.flex.width}}\">\n      <div ng-repeat=\"item in item.child\" ng-include=\"\'item-list.html\'\"></div>\n    </md-list>\n</script>");
$templateCache.put("app/main/mpp/timestudy-standard/timestudy-standard-add.html","<md-dialog aria-label=\"Form Add Time Study Standard\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack \nname=\"frmAddTimestudyStandard\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmAddTimestudyStandard)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Add Time Study Standard</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nflex><md-label>Product</md-label><md-select ng-model=\"vm.Form.objForm.product\" md-on-close=\"vm.clearSearchProduct()\" \nng-change=\"vm.selectedProduct(vm.Form.objForm.product)\" name=\"product\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchProduct\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.productLists\"><md-option ng-repeat=\"ls in vm.productLists | filter:vm.searchProduct\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.sku}} - {{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmAddTimestudyStandard.parent_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container><md-label>Description</md-label>\n<input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" required><div \nng-messages=\"frmEditTimestudyStandard.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container><md-input-container><md-label>Time Value</md-label>\n<input type=\"text\" name=\"time_value\" ng-model=\"vm.Form.objForm.time_value\" required><div \nng-messages=\"frmEditTimestudyStandard.time_value.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTime Value is required.</span></div></div></md-input-container><md-input-container><md-label>UOM</md-label><input \ntype=\"text\" name=\"uom\" ng-model=\"vm.Form.objForm.uom\" required><div ng-messages=\"frmEditTimestudyStandard.uom.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>UOM is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddTimestudyStandard.$invalid || frmAddTimestudyStandard.$pristine\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpp/timestudy-standard/timestudy-standard-edit.html","<md-dialog aria-label=\"Form Edit Time Study Standard\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack \nname=\"frmEditTimestudyStandard\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmEditTimestudyStandard)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Edit Time Study Standard</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nflex><md-label>Product</md-label><md-select ng-model=\"vm.Form.objForm.product\" md-on-close=\"vm.clearSearchProduct()\" \nng-change=\"vm.selectedProduct(vm.Form.objForm.product)\" name=\"product\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchProduct\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.productLists\"><md-option ng-repeat=\"ls in vm.productLists | filter:vm.searchProduct\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.sku}} - {{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmEditTimestudyStandard.parent_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container><md-label>Description</md-label>\n<input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" required><div \nng-messages=\"frmEditTimestudyStandard.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container><md-input-container><md-label>Time Value</md-label>\n<input type=\"text\" name=\"time_value\" ng-model=\"vm.Form.objForm.time_value\" required><div \nng-messages=\"frmEditTimestudyStandard.time_value.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTime Value is required.</span></div></div></md-input-container><md-input-container><md-label>UOM</md-label><input \ntype=\"text\" name=\"uom\" ng-model=\"vm.Form.objForm.uom\" required><div ng-messages=\"frmEditTimestudyStandard.uom.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>UOM is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditTimestudyStandard.$invalid || frmEditTimestudyStandard.$pristine\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpp/timestudy-standard/timestudy-standard.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nTime Study Standard</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Product</label><md-select ng-model=\"vm.product\" aria-label=\"product\" name=\"product\" \nng-change=\"vm.loadData(1)\"><md-option ng-value=\"\">-- All --</md-option><md-option ng-repeat=\"ls in vm.productLists\" \nplaceholder=\"Product\" ng-value=\"ls.id\">{{ls.sku + \', \' + ls.description}}</md-option></md-select><div \nng-messages=\"frmCost.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>Product field is required.</span>\n</div></div></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.getDataReport()\" ng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-mini md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Add New\" ng-click=\"vm.add($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>New</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span>New</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete\n</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><span flex hide show-gt-sm></span>\n<md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon md-font-icon=\"icon-print\"></md-icon><span>PRINT\n</span></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\" ms-scroll><div id=\"tableMpp\"><table class=\"simple bordered stripped\" \ncellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th style=\"min-width: 50px\"></th><th>No</th><th>Product\n</th><th>Description</th><th>Time Value</th><th>UOM</th><th>#</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTable.list\"><td \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(item)\" ng-click=\"vm.toggleCheck(item, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ $index + 1 }}</td>\n<td>{{ item.product_name }}</td><td>{{ item.description }}</td><td class=\"text-center\">{{ item.time_value }}</td><td \nclass=\"text-center\">{{ item.uom }}</td><td class=\"text-center\"><a href=\"javascript:void(0);\" \nng-click=\"vm.edit($event, item)\" style=\"text-decoration: none\"><span class=\"icon-pencil\"></span></a></td></tr></tbody>\n</table></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpp-report-hc-cc/admin/admin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nHeadcount Report</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Years</label><md-select ng-model=\"vm.year\" aria-label=\"years\" name=\"years\"><md-option \nng-repeat=\"ls in vm.years\" placeholder=\"YEARS\" ng-value=\"ls\">{{ls}}</md-option></md-select><div \nng-messages=\"frmCost.years.$error\" role=\"alert\"><div ng-message=\"required\"><span>Years field is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Company</label><md-select ng-model=\"vm.company\" \naria-label=\"company\" name=\"company\" ng-change=\"vm.getDataCostCenter()\"><md-option ng-repeat=\"ls in vm.companies\" \nplaceholder=\"COMPANY\" ng-value=\"ls\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmCost.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Cost Center</label><md-select \nng-model=\"vm.costCenter\" required ng-disabled=\"vm.listCostCenter.length === 0\" aria-label=\"costCenter\" \nng-change=\"vm.getDataLayers()\" name=\"costCenter\"><md-option ng-repeat=\"ls in vm.listCostCenter\" \nplaceholder=\"COST CENTER\" ng-value=\"ls\">{{ ls.description }}</md-option></md-select><div \nng-messages=\"frmCost.costCenter.$error\" role=\"alert\"><div ng-message=\"required\"><span>Cost Center field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Layers</label><md-select ng-model=\"vm.layer\" \nrequired data-md-container-class=\"selectHeader\" md-on-close=\"vm.clearSearch()\" ng-disabled=\"vm.layers.length === 0\" \naria-label=\"layer\" name=\"layer\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for layer\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=\"select Layers\">\n<md-option ng-repeat=\"ls in vm.layers | filter:vm.searchTerm\" placeholder=\"Layers\" ng-selected=\"vm.layer.id === ls.id\" \nng-value=\"ls\">{{ ls.description }}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex>\n<label>Employee Type</label><md-select ng-model=\"vm.selectedEmpType\" required aria-label=\"employee type\" \nname=\"empType\"><md-option ng-repeat=\"ls in vm.empType\" placeholder=\"Employee Type\" ng-value=\"ls.value\">{{ ls.name }}\n</md-option></md-select><div ng-messages=\"frmCost.empType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee Type field is required.</span></div></div></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.getDataReport()\" \nng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-button ng-disabled=\"vm.listReport.length == 0\" \nclass=\"md-primary md-icon-button md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printPDF()\">\n<md-icon style=\"font-size:14px\" md-font-icon=\"icon-printer\"></md-icon></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-primary md-icon-button md-small\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printExcel()\"><md-icon style=\"font-size:14px\" \nmd-font-icon=\"icon-file-excel-box\"></md-icon></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><span \nflex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon \nmd-font-icon=\"icon-print\"></md-icon><span>PRINT</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><div id=\"tableMpp\">\n<table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th rowspan=\"2\">\nNo</th><th rowspan=\"2\">BT Code</th><th rowspan=\"2\">Level</th><th style=\"width: 20%\" rowspan=\"2\">Jabatan</th><th \nstyle=\"width: 5%\" rowspan=\"2\">Jumlah Karyawan Saat Ini</th><th style=\"width: 5%\" rowspan=\"2\">\nJumlah Karyawan yang akan datang</th><th colspan=\"2\">Karyawan</th><th colspan=\"2\">Karyawan</th><th colspan=\"12\">\nJadwal Pemenuhan</th><th rowspan=\"2\">Total</th></tr><tr><th style=\"width: 5%\">Internal</th><th style=\"width: 5%\">\nExternal</th><th style=\"width: 5%\">Mutasi</th><th style=\"width: 5%\">Terminasi</th><th>Jan</th><th>Feb</th><th>Mar</th>\n<th>Apr</th><th>Mei</th><th>Jun</th><th>Jul</th><th>Aug</th><th>Sep</th><th>Oct</th><th>Nov</th><th>Des</th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.listReport\"><td>{{$index + 1}}</td><td>{{ item.bt_code }}</td><td>\n{{ item.job_level }}</td><td>{{item.description}}</td><td>{{ item.curr.total }}</td><td>{{ item.next.total }}</td><td>\n{{ item.next.internal }}</td><td>{{ item.next.external }}</td><td>{{ item.next.mutation }}</td><td>\n{{ item.next.termination }}</td><td ng-repeat=\"i in item.next.listPerMonth track by $index\">{{ i }}</td><td>\n{{ item.totalRightPerRow }}</td></tr><tr ng-if=\"vm.listReport.length > 0\"><td class=\"total-hc\" colspan=\"4\">TOTAL</td>\n<td>{{ vm.totalCurrEmp }}</td><td>{{ vm.totalNextEmp }}</td><td>{{ vm.totalNextEmpInternal }}</td><td>\n{{ vm.totalNextEmpExternal }}</td><td>{{ vm.totalNextEmpMutation }}</td><td>{{ vm.totalNextEmpTermination }}</td><td \nng-repeat=\"j in vm.totalPerMonth track by $index\">{{ j }}</td><td>{{ vm.totalRightBottom }}</td></tr></tbody></table>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpp-report-hc-cc/user/user.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nHeadcount Report</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Years</label><md-select ng-model=\"vm.year\" aria-label=\"years\" name=\"years\"><md-option \nng-repeat=\"ls in vm.years\" placeholder=\"YEARS\" ng-value=\"ls\">{{ls}}</md-option></md-select><div \nng-messages=\"frmCost.years.$error\" role=\"alert\"><div ng-message=\"required\"><span>Years field is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Company</label><md-select ng-model=\"vm.company\" \nng-disabled=\"vm.disabledCompany\" aria-label=\"company\" name=\"company\"><md-option ng-repeat=\"ls in vm.companies\" \nng-selected=\"vm.company.id == ls.id\" placeholder=\"COMPANY\" ng-value=\"ls\">{{ls.description}}</md-option></md-select><div\n ng-messages=\"frmCost.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Cost Center</label><md-select \nng-model=\"vm.costCenter\" required ng-disabled=\"vm.listCostCenter.length === 0\" aria-label=\"costCenter\" \nng-change=\"vm.getDataLayers()\" name=\"costCenter\"><md-option ng-repeat=\"ls in vm.listCostCenter\" \nplaceholder=\"COST CENTER\" ng-value=\"ls\">{{ ls.description }}</md-option></md-select><div \nng-messages=\"frmCost.costCenter.$error\" role=\"alert\"><div ng-message=\"required\"><span>Cost Center field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Layers</label><md-select ng-model=\"vm.layer\" \nrequired data-md-container-class=\"selectHeader\" md-on-close=\"vm.clearSearch()\" ng-disabled=\"vm.layers.length === 0\" \naria-label=\"layer\" name=\"layer\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for layer\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=\"select Layers\">\n<md-option ng-repeat=\"ls in vm.layers | filter:vm.searchTerm\" placeholder=\"Layers\" ng-selected=\"vm.layer.id === ls.id\" \nng-value=\"ls\">{{ ls.description }}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex>\n<label>Employee Type</label><md-select ng-model=\"vm.selectedEmpType\" required aria-label=\"employee type\" \nname=\"empType\"><md-option ng-repeat=\"ls in vm.empType\" placeholder=\"Employee Type\" ng-value=\"ls.value\">{{ ls.name }}\n</md-option></md-select><div ng-messages=\"frmCost.empType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee Type field is required.</span></div></div></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.getDataReport()\" \nng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-button ng-disabled=\"vm.listReport.length == 0\" \nclass=\"md-primary md-icon-button md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printPDF()\">\n<md-icon style=\"font-size:14px\" md-font-icon=\"icon-printer\"></md-icon></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-primary md-icon-button md-small\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printExcel()\"><md-icon style=\"font-size:14px\" \nmd-font-icon=\"icon-file-excel-box\"></md-icon></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><span \nflex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon \nmd-font-icon=\"icon-print\"></md-icon><span>PRINT</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><div id=\"tableMpp\">\n<table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th rowspan=\"2\">\nNo</th><th rowspan=\"2\">BT Code</th><th rowspan=\"2\">Level</th><th style=\"width: 20%\" rowspan=\"2\">Jabatan</th><th \nstyle=\"width: 5%\" rowspan=\"2\">Jumlah Karyawan Saat Ini</th><th style=\"width: 5%\" rowspan=\"2\">\nJumlah Karyawan yang akan datang</th><th colspan=\"2\">Karyawan</th><th colspan=\"2\">Karyawan</th><th colspan=\"12\">\nJadwal Pemenuhan</th><th rowspan=\"2\">Total</th></tr><tr><th style=\"width: 5%\">Internal</th><th style=\"width: 5%\">\nExternal</th><th style=\"width: 5%\">Mutasi</th><th style=\"width: 5%\">Terminasi</th><th>Jan</th><th>Feb</th><th>Mar</th>\n<th>Apr</th><th>Mei</th><th>Jun</th><th>Jul</th><th>Aug</th><th>Sep</th><th>Oct</th><th>Nov</th><th>Des</th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.listReport\"><td>{{$index + 1}}</td><td>{{ item.bt_code }}</td><td>\n{{ item.job_level }}</td><td>{{item.description}}</td><td>{{ item.curr.total }}</td><td>{{ item.next.total }}</td><td>\n{{ item.next.internal }}</td><td>{{ item.next.external }}</td><td>{{ item.next.mutation }}</td><td>\n{{ item.next.termination }}</td><td ng-repeat=\"i in item.next.listPerMonth track by $index\">{{ i }}</td><td>\n{{ item.totalRightPerRow }}</td></tr><tr ng-if=\"vm.listReport.length > 0\"><td class=\"total-hc\" colspan=\"4\">TOTAL</td>\n<td>{{ vm.totalCurrEmp }}</td><td>{{ vm.totalNextEmp }}</td><td>{{ vm.totalNextEmpInternal }}</td><td>\n{{ vm.totalNextEmpExternal }}</td><td>{{ vm.totalNextEmpMutation }}</td><td>{{ vm.totalNextEmpTermination }}</td><td \nng-repeat=\"j in vm.totalPerMonth track by $index\">{{ j }}</td><td>{{ vm.totalRightBottom }}</td></tr></tbody></table>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mppmgr/mppmgr-chart/mppmgr-chart.html","<div class=\"page-layout\" mpp-chart-viewport id=\"orgchart-area\"><div layout=\"column\" style=\"padding:0; margin: 0\" \nclass=\"content-card\"><md-content id=\"centerpanel\" class=\"org-chart\" \nstyle=\"overflow:hidden; padding: 0px; margin: 0px; border: 0px\"><div id=\"chartContent\" bp-org-diagram \ndata-options=\"vm.options\" flex=\"100\" style=\"overflow:unset\" ms-scroll></div></md-content></div></div>");
$templateCache.put("app/main/mppmgr/mppmgr-compare/mppmgr-compare.html","<div class=\"page-layout\" mpp-chart-viewport id=\"orgchart-area\"><div layout=\"column\" style=\"padding:0; margin: 0\" \nclass=\"content-card\"><md-content id=\"centerpanel\" class=\"org-chart\" \nstyle=\"overflow:hidden; padding: 0px; margin: 0px; border: 0px\"><div id=\"chartContent\" bp-org-diagram \ndata-options=\"vm.options\" flex=\"100\" style=\"overflow:unset\" ms-scroll></div></md-content></div></div>");
$templateCache.put("app/main/mppmgr/mppmgr-table/mppmgr-table.html","<div class=\"page-layout\" id=\"mpp-org-table\"><div class=\"mpp-toolbar\" layout=\"row\" layout-align=\"start center\">\n<md-button ng-disabled=\"vm.listData.length === 0\" ng-click=\"vm.onClickDownload()\" class=\"md-primary md-raised md-mini\" \naria-label=\"org mpp\">Download Template</md-button><md-button ng-disabled=\"vm.listData.length === 0\" \nng-click=\"vm.onClickDownloadReport()\" class=\"md-primary md-raised md-mini\" aria-label=\"org mpp\">Download Report\n</md-button><md-button ng-disabled=\"vm.listData.length === 0\" ng-click=\"vm.onClickDownloadSummary()\" \nclass=\"md-primary md-raised md-mini\" aria-label=\"org mpp\">Download Summary</md-button><md-button \nng-click=\"vm.uploadMpp($event)\" class=\"md-accent md-raised md-mini\" aria-label=\"org mpp\">Upload</md-button><input \nng-disabled=\"vm.listData.length === 0\" class=\"search-input\" type=\"text\" ng-model=\"vm.searchListData\" \nplaceholder=\"ex: head of ..\"></div><div class=\"flex-table-container\" ms-scroll><div flex layout=\"row\" \nclass=\"table-content table-header\"><div class=\"table-item head-item first-item multi-height\">Layer Name</div><div \nng-if=\"vm.stateShow.prev\" class=\"table-item-container\" layout=\"column\"><div class=\"table-item-title\">{{vm.prevYear}}\n</div><div class=\"table-item-content\" layout=\"row\"><div class=\"table-item head-item text-center headcount-item\">HC\n</div></div></div><div ng-if=\"vm.stateShow.curr\" class=\"table-item-container\"><div class=\"table-item-title\">{{vm.year}}\n</div><div class=\"table-item-content\" layout=\"row\"><div class=\"table-item head-item text-center headcount-item\">HC\n</div><div class=\"table-item head-item month-item\" ng-repeat=\"item in vm.months\">{{item.name}}</div></div></div><div \nclass=\"table-item head-item text-center last-item multi-height\">Action</div></div><div flex layout=\"row\" \nclass=\"table-content\" ng-repeat=\"item in vm.listData | filter:{ description: vm.searchListData }\"><div \nclass=\"table-item first-item small-font-size left-background no-icon\">{{item.description}}</div><div \nng-if=\"vm.stateShow.prev\" class=\"table-item text-center small-font-size headcount-item no-icon\">\n{{item.total_mpp_detail_prev}}</div><div ng-if=\"vm.stateShow.curr\" \nclass=\"table-item text-center small-font-size headcount-item no-icon\">{{item.total_mpp_detail}}</div><div \nng-if=\"vm.stateShow.curr\" class=\"table-item text-center small-font-size no-icon month-item\" ng-repeat=\"m in vm.months\">\n{{item.stats_mpp[m.id]}}</div><div class=\"table-item text-center small-font-size last-item\"><md-button \nng-click=\"vm.action($event, item, \'add_mpp\')\" class=\"m-button md-primary md-raised md-mini\" aria-label=\"org mpp\">\n<md-icon md-font-icon=\"icon-worker\"></md-icon>UPDATE MPP</md-button></div></div></div></div>");
$templateCache.put("app/main/mppmgr/mppmgr-upload/mppmgr-upload.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll flex=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools title\"><h4>MPP Upload</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"margin-top:0px\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" layout-align=\"space-between center\" style=\"margin-bottom: 15px\"><div flex><input \ntype=\"file\" id=\"uploaderPhoto\" nv-file-select uploader=\"vm.uploadFile\"></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.uploadFile.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nng-show=\"vm.isUploaded\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>{{vm.messages}}</span></md-whiteframe></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-xs=\"column\" flex layout-align=\"end center\"><span hide \nshow-gt-sm flex></span> <span hide show-gt-sm flex></span> <span hide show-gt-sm flex></span> <span hide show-gt-sm \nflex></span><div flex><md-button type=\"button\" ng-click=\"vm.viewMore($event)\" \nclass=\"md-raised md-orange-500-bg white-fg\" aria-label=\"view-more\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-50-fg\"></md-icon>More</md-button></div><div flex><md-button type=\"button\" \nng-click=\"vm.uploadFile.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload</md-button></div><div flex><md-button \nng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon>close</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/mppmgr/mppmgr-upload/mppmgr-view-more.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll flex=\"85\"><md-toolbar><div \nclass=\"md-toolbar-tools title\"><h4>Upload Logs</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"margin-top:0px; min-height: 200px\"><table class=\"simple bordered stripped\" \nid=\"more-table\" ms-responsive-table><thead><tr><th class=\"text-start\">JOB TITLE</th><th>ROW INFO</th><th>SUCCESS</th>\n<th>FAILED</th><th>STATUS</th></tr></thead><tbody><tr ng-init=\"item.show_detail = false\" class=\"clickable\" \nng-click=\"item.show_detail = !item.show_detail\" dir-paginate-start=\"item in vm.filtered | itemsPerPage: vm.numPerPage\" \ntotal-items=\"vm.totalItems\" current-page=\"vm.currentPage\"><td class=\"text-start\">{{item.job_title}}</td><td \nclass=\"text-center\">{{item.status}}</td><td class=\"text-center\">{{item.results.success}}</td><td class=\"text-center\">\n{{item.results.failed}}</td><td class=\"text-center\"><div ng-if=\"item.results.status\" layout=\"row\" \nlayout-align=\"start center\"><div><md-icon class=\"green-400-fg\" md-font-icon=\"icon-check\"></md-icon></div><div>SUCCESS\n</div></div><div ng-if=\"!item.results.status\" layout=\"row\" layout-align=\"start center\"><div><md-icon \nclass=\"red-400-fg\" md-font-icon=\"icon-close\"></md-icon></div><div>FAILED</div></div></td></tr><tr dir-paginate-end \nng-show=\"item.show_detail\"><td colspan=\"5\"><div class=\"container-detail\"><table class=\"table-detail\"><thead><tr><th>\nMonth</th><th>Increase</th><th>Decrease</th><th>Source Hiring</th></tr></thead><tbody><tr class=\"clickable\" \nng-repeat-start=\"ls in item.monthly\" ng-init=\"ls.show_detail = false\" ng-click=\"ls.show_detail = !ls.show_detail\"><td>\n{{$index + 1}}</td><td>{{ls.results.increase.message}}</td><td>{{ls.results.decrease.message}}</td><td>\n{{ls.results.source_hiring.message}}</td></tr><tr ng-repeat-end ng-show=\"ls.show_detail\"><td colspan=\"5\"><div \nclass=\"container-detail padding-10\"><table class=\"table-detail\"><thead><tr><th colspan=\"2\">Increase</th><th \nrowspan=\"2\">Decrease</th><th rowspan=\"2\">Source Hiring</th></tr><tr><th>message</th><th>detail</th></tr></thead><tbody>\n<tr><td>{{ls.validation.increase.message}}</td><td><div layout=\"column\"><div>Match Pattern</div><ul><li \nng-repeat=\"p in ls.validation.increase.detail.match\">{{p.pattern}} , {{p.message}}</li></ul><div>Not Match Pattern\n</div><ul><li ng-repeat=\"p in ls.validation.increase.detail.match\">{{p.pattern}} , {{p.message}}</li></ul></div></td>\n<td>{{ls.validation.decrease.message}}</td><td>{{ls.validation.source_hiring.message}}</td></tr></tbody></table></div>\n</td></tr></tbody></table></div></td></tr></tbody></table><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><dir-pagination-controls on-page-change=\"vm.pageChanged(newPageNumber)\">\n</dir-pagination-controls></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-xs=\"column\" flex><span flex>\n</span><div flex=\"10\" layout-align=\"end center\" layout=\"row\"><md-button ng-click=\"vm.hide()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon>close</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/offboarding/approval-exit-clearance/approval-exit-clearance-detail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Clearance Approval</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout-sm=\"column\" layout=\"row\" \nlayout-align=\"center center\" layout-padding><div flex=\"35\"><div class=\"md-subhead\"><strong>Employe Name</strong></div>\n<div class=\"info\">{{vm.Form.objForm.empName}}</div></div><div flex=\"15\"><div class=\"md-subhead\"><strong>NIK</strong>\n</div><div class=\"info\">{{vm.Form.objForm.nik}}</div></div><div flex=\"25\"><div class=\"md-subhead\"><strong>Job Title\n</strong></div><div class=\"info\">{{vm.Form.objForm.job_title}}</div></div><div flex=\"25\"><div class=\"md-subhead\">\n<strong>Last Day</strong></div><div class=\"info\">{{vm.Form.objForm.last_day}}</div></div></div><md-divider>\n</md-divider><div layout=\"column\"><div class=\"md-subhead\"><strong>Clearace List</strong></div><table \nclass=\"simple bordered\" ms-responsive-table><thead><tr><th class=\"secondary-text\" flex=\"50\"><div class=\"table-header\">\n<span class=\"column-title\">Clearance</span></div></th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\">\n<span class=\"column-title\">Type</span></div></th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span \nclass=\"column-title\">Approved By</span></div></th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span \nclass=\"column-title\">Approved Date</span></div></th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\">\n<span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\" flex=\"20\"><div class=\"table-header\"><span\n class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"lsd in vm.Form.objForm.checklist\"><td>\n{{lsd.description}}</td><td>{{lsd.approval_type}}</td><td>{{lsd.status_by}}</td><td>{{lsd.status_date}}</td><td><span \nng-if=\"lsd.status == 0 \">Waiting Approval</span> <span ng-if=\"lsd.status == 1 \">Approved</span> <span \nng-if=\"lsd.status == 2 \">Rejected</span></td><td><md-menu \nng-if=\"lsd.status == 0 && (lsd.approval_type != \'IT\' || lsd.approval_type != \'N1\')\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.approval(\'1\', lsd.id)\" aria-label=\"Flip widget\">\nApprove</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.approval(\'2\', lsd.id)\" \naria-label=\"Flip widget\">Reject</md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-mini md-raised md-primary\" \nng-if=\" (lsd.description|lowercase) == \'serah terima tugas dan tanggung jawab\' && lsd.approval_type == \'N1\'\" \nng-click=\"vm.loadHandover(vm.Form.objForm.id, lsd.id, $event)\">Handover</md-button><md-button \nclass=\"md-mini md-raised md-primary\" ng-if=\"lsd.approval_type == \'Recruitment\'\" \nng-click=\"vm.exitInterview(vm.Form.objForm.nik)\">Exit Interview</md-button><md-button \nclass=\"md-mini md-raised md-primary\" \nng-if=\"(lsd.description|lowercase) == \'penutupan alamat email dan hak akses it lainnya\' && lsd.approval_type == \'IT\'\" \nng-click=\"vm.itForm(lsd, $event)\">Form IT</md-button></td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/offboarding/approval-exit-clearance/approval-exit-clearance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><md-subheader class=\"white-bg\"><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.EXITCLEARANCEAPPROVAL\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.COMPANY\' | translate }}\" value=\"{{ls.company}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label><span translate=\"KPI.LABEL.STARTDATE\"></span></label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.START_DATE\' | translate }}\" name=\"tglmulai\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label><span \ntranslate=\"KPI.LABEL.ENDDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.END_DATE\' | translate }}\" name=\"tglakhir\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><md-select ng-model=\"vm.reason\" \nname=\"reason\"><md-option ng-repeat=\"ls in vm.listReason\" \nplaceholder=\"{{ \'OFB.REGISTRATION_LIST.REASON\' | translate }}\" value=\"{{ls}}\">{{ls}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option \nng-repeat=\"ls in vm.appstatus\" placeholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" \nvalue=\"{{ls.value}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"20\" flex><input type=\"text\" \nplaceholder=\"{{ \'KPI.LABEL.NIK\' | translate}} / {{ \'KPI.LABEL.NAME\' | translate}}\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit</md-button></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \ntranslate=\"KPI.LABEL.ENTRIES\"></span></md-input-container><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n</md-menu-content></md-menu><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"2%\"><div\n class=\"table-header\"><span class=\"column-title\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.NIK\">NIK</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.NAME\">Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.REGISTRATION_LIST.JOB_TITLE\">Job Title</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.EFFECTIVE_DATE\">Effective Date</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.REGISTRATION_LIST.LAST_DAY\">Last Day</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.REASON\">Reason</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.detail(ls.id, $event)\"><td><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.detail(ls.id, $event)\"><div layout=\"row\" flex><md-icon\n md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex>View Detail</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></td><td>{{ls.nik }}</td><td>{{ls.empName}}</td><td>{{ls.job_title}}</td><td>\n{{ls.effective_date}}</td><td>{{ls.last_day}}</td><td>{{ls.reason}}</td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></md-content></div>");
$templateCache.put("app/main/offboarding/approval-exit-clearance/it-form.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>IT Form</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><form ng-cloack name=\"FormInput\" class=\"md-inline-form popup-input-form\" \nnovalidate ng-submit=\"vm.approval(\'1\', vm.data.id)\"><md-dialog-content class=\"md-background-bg has-upload\" \nid=\"contentDialog\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex=\"85\"><input type=\"email\" name=\"email\" ng-model=\"vm.itForm.email\" \nplaceholder=\"Email Address\" required><div ng-messages=\"FormInput.email.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Email Address is required.</span></div></div></md-input-container><md-input-container flex=\"15\"><label>\nDeleted Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.itForm.deletedEmail\" name=\"deletedEmail\" \nplaceholder=\"Deleted Date\" md-open-on-focus required></md-datepicker><div ng-messages=\"FormInput.deletedEmail.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Deleted date is required.</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"70\"><input type=\"email\" name=\"forwardEmail\" \nng-model=\"vm.itForm.forwardEmail\" placeholder=\"Forward Email Address\" required><div \nng-messages=\"FormInput.forwardEmail.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nForward Email Address is required.</span></div></div></md-input-container><md-input-container flex=\"15\"><label>\nStart Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.itForm.forwardEmailStart\" \nname=\"forwardEmailStart\" placeholder=\"Start Date\" md-open-on-focus required></md-datepicker><div \nng-messages=\"FormInput.forwardEmailStart.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nForward Email Address Start is required.</span></div></div></md-input-container><md-input-container flex=\"15\"><label>\nEnd Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.itForm.forwardEmailEnd\" name=\"forwardEmailEnd\" \nplaceholder=\"End Date\" md-open-on-focus required></md-datepicker><div ng-messages=\"FormInput.forwardEmailEnd.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Forward Email Address end is required.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"85\"><input type=\"text\" \nname=\"chat\" ng-model=\"vm.itForm.chat\" placeholder=\"Pandion / Sparks\"></md-input-container><md-input-container \nflex=\"15\"><label>Deleted Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.itForm.deletedChat\" \nname=\"deletedChat\" placeholder=\"Deleted Date\" md-open-on-focus></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"85\"><input type=\"text\" name=\"access\" \nng-model=\"vm.itForm.access\" placeholder=\"Portal / VPN\"></md-input-container><md-input-container flex=\"15\"><label>\nDeleted Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.itForm.deletedAccess\" name=\"deletedAccess\" \nplaceholder=\"Deleted Date\" md-open-on-focus></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex=\"85\"><input type=\"text\" name=\"other\" ng-model=\"vm.itForm.other\" \nplaceholder=\"Other System\"></md-input-container><md-input-container flex=\"15\"><label>Deleted Date</label><md-datepicker\n md-hide-icons=\"calendar\" ng-model=\"vm.itForm.deletedOther\" name=\"deletedOther\" placeholder=\"Deleted Date\" \nmd-open-on-focus></md-datepicker></md-input-container></div><md-input-container class=\"md-block\"><label>Note</label>\n<textarea ng-model=\"vm.itForm.note\"></textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\" ng-if=\"vm.status == 0 \"><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"FormInput.$invalid || FormInput.$pristine\" ng-if=\"vm.itForm.approved == 1\">Approve\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/offboarding/approval-group/approval-group.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"OFB.GROUP_APPROVED.TITLE\">Approval Group Offboarding</span></md-subheader><div \nclass=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container md-no-float \nclass=\"md-block\" flex=\"60\"><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries<md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.input()\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Add Approval Group</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"OFB.GROUP_APPROVED.ADD\">Add Approval Group</span></md-button><md-button class=\"md-warn md-mini md-primary\" \nhide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.deleteItem($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Delete Approval Group</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"OFB.GROUP_APPROVED.DELETE\">Delete Approval Group\n</span></md-button><md-button class=\"md-warn md-mini md-primary\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.deactiveItem($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nDeactivated Approval Group</md-tooltip><md-icon md-font-icon=\"icon-close\" class=\"md-font icon-archive material-icons\">\n</md-icon><span translate=\"OFB.GROUP_APPROVED.DEACTIVATED\">Deactivated Approval Group</span></md-button>\n</md-input-container><span flex></span> <span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th class=\"text-center\" width=\"1%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"OFB.GROUP_APPROVED.APPROVAL_TYPE\">approval_type</span></div></th><th \nclass=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.GROUP_APPROVED.NIK\">nik</span></div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"OFB.GROUP_APPROVED.NAME\">nama</span></div></th><th class=\"text-center\" \nwidth=\"10%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OFB.GROUP_APPROVED.COMPANY\">Company</span>\n</div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.GROUP_APPROVED.SUBAREA\">Subarea</span></div></th><th class=\"text-center\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFB.GROUP_APPROVED.STATUS\">status</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editUser(ls)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listModulSelected\" checklist-value=\"ls\"></td><td class=\"text-left\">\n{{ ls.approval_type }}</td><td class=\"text-left\">{{ ls.nik }}</td><td class=\"text-left\">{{ ls.name }}</td><td \nclass=\"text-left\">{{ ls.company }}</td><td class=\"text-left\">{{ ls.subarea }}</td><td class=\"text-left\"><span \nng-if=\"ls.status == 1\">Active </span><span ng-if=\"ls.status == 0\">Non Active</span></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/offboarding/approval-group/deactive-approval-group.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"OFB.GROUP_APPROVED.TITLE\">\nDeactive Group Approval</span> {{vm.nik}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\">\n<md-content class=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><div \nclass=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container md-no-float \nclass=\"md-block\" flex=\"80\"><md-button class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.setClearance($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nSet Clearance For NIK {{vm.nik}}</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"OFB.GROUP_APPROVED.SET_CLEARANCE\">\nAdd Approval Group</span></md-button><md-button class=\"md-warn md-mini md-primary\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.deactiveItem()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Deactivated Approval Group\n</md-tooltip><md-icon md-font-icon=\"icon-close\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"OFB.GROUP_APPROVED.DEACTIVATED\">Deactivated Approval Group</span></md-button></md-input-container><span \nflex></span> <span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th class=\"text-center\" width=\"1%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"OFB.GROUP_APPROVED.APPROVAL_TYPE\">approval_type</span></div></th><th \nclass=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.GROUP_APPROVED.NIK\">nik</span></div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"OFB.GROUP_APPROVED.NAME\">nama</span></div></th><th class=\"text-center\" \nwidth=\"10%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OFB.GROUP_APPROVED.COMPANY\">Company</span>\n</div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.GROUP_APPROVED.STATUS\">status</span></div></th><th class=\"text-center\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\">ACTION</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editUser(ls)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listModulSelected\" checklist-value=\"ls\"></td><td class=\"text-left\">{{ ls.approval_type }}</td><td \nclass=\"text-left\">{{ ls.nik }}</td><td class=\"text-left\">{{ ls.name }}</td><td class=\"text-left\">{{ ls.company }}</td>\n<td class=\"text-left\"><span ng-if=\"ls.status == 1\">Active </span><span ng-if=\"ls.status == 0\">Non Active</span></td>\n<td><md-button class=\"md-warn md-mini md-primary\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.deactive(ls)\" \nng-if=\"ls.status == 1\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Deactivated Approval Group\n</md-tooltip><md-icon md-font-icon=\"icon-close\" class=\"md-font icon-archive material-icons\"></md-icon><span>Deactive\n</span></md-button></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div></md-dialog>");
$templateCache.put("app/main/offboarding/handover/handover-detail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-gt-sm=\"50\" flex md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Job Handover</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><div\n layout-sm=\"column\" layout=\"row\" layout-align=\"center center\" layout-padding><div flex=\"40\"><div class=\"md-subhead\">\n<strong>Reason</strong></div><div class=\"info\">{{vm.Form.objForm.reason}}</div></div><div flex=\"20\"><div \nclass=\"md-subhead\"><strong>Effective Date</strong></div><div class=\"info\">{{vm.Form.objForm.effective_date}}</div>\n</div><div flex=\"40\"><div class=\"md-subhead\"><strong>Last Day</strong></div><div class=\"info\">\n{{vm.Form.objForm.last_day}}</div></div></div><md-divider></md-divider><div layout-sm=\"column\" layout=\"row\" \nlayout-align=\"center center\" layout-padding><div flex=\"40\"><div class=\"md-subhead\"><strong>Employe Name</strong></div>\n<div class=\"info\">{{vm.Form.objForm.empName}}</div></div><div flex=\"20\"><div class=\"md-subhead\"><strong>NIK</strong>\n</div><div class=\"info\">{{vm.Form.objForm.nik}}</div></div><div flex=\"40\"><div class=\"md-subhead\"><strong>Job Title\n</strong></div><div class=\"info\">{{vm.Form.objForm.job_title}}</div></div></div><md-divider></md-divider><div \nlayout-sm=\"column\" layout=\"row\" layout-align=\"center center\" layout-padding><div flex=\"40\"><div class=\"md-subhead\">\n<strong>Receiver Name</strong></div><div class=\"info\">{{vm.Form.objForm.receiverName}}</div></div><div flex=\"20\"><div \nclass=\"md-subhead\"><strong>Receiver NIK</strong></div><div class=\"info\">{{vm.Form.objForm.receiver_nik}}</div></div>\n<div flex=\"40\"><div class=\"md-subhead\"><strong>Receiver Job Title</strong></div><div class=\"info\">\n{{vm.Form.objForm.receiverJob}}</div></div></div><md-divider></md-divider><div class=\"md-subhead mt-50\"><strong>\nJob Item :</strong></div><div class=\"todo-items md-whiteframe-1dp\"><div class=\"todo-item\" md-ink-ripple layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"task in vm.Form.objForm.detail\"><div layout=\"row\" layout-align=\"start center\" \nflex><div class=\"info\" flex><div class=\"notes\">{{task.description}}</div></div></div></div></div></md-dialog-content>\n<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.Form.objForm.n1Name}}</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\"><span \nng-if=\"vm.Form.objForm.n1_status == 0\"><i class=\"icon icon-timer-sand s70\" style=\"color:#FBC02D\"><md-tooltip><span>\nWaiting Approval</span></md-tooltip></i></span><span ng-if=\"vm.Form.objForm.n1_status == 1\"><i \nclass=\"icon icon-check s70\" style=\"color:#4CAF50\"><md-tooltip><span>Approved</span></md-tooltip></i></span><span \nng-if=\"vm.Form.objForm.n1_status == 2\"><i class=\"icon icon-window-close s70\" style=\"color:#C62828\"><md-tooltip><span>\nRejected</span></md-tooltip></i></span></div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.Form.objForm.n1_date}}</span></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h3\">{{vm.Form.objForm.receiverName}}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\"><span \nng-if=\"vm.Form.objForm.receive_status == 0\"><i class=\"icon icon-timer-sand s70\" style=\"color:#FBC02D\"><md-tooltip>\n<span>Waiting Approval</span></md-tooltip></i></span><span ng-if=\"vm.Form.objForm.receive_status == 1\"><i \nclass=\"icon icon-check s70\" style=\"color:#4CAF50\"><md-tooltip><span>Approved</span></md-tooltip></i></span><span \nng-if=\"vm.Form.objForm.receive_status == 2\"><i class=\"icon icon-window-close s70\" style=\"color:#C62828\"><md-tooltip>\n<span>Rejected</span></md-tooltip></i></span></div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.Form.objForm.receive_date}}</span></div>\n</ms-widget-front></ms-widget></div><md-dialog-actions layout=\"row\" class=\"md-background-bg\" \nng-if=\"vm.status == 0 && vm.receiver == vm.nik\"><md-button class=\"md-raised md-accent\" aria-label=\"Approve\" \nng-click=\"vm.approval(\'2\', vm.Form.objForm.idHandover, \'receiver\')\">Reject</md-button><md-button \nclass=\"md-raised md-accent\" aria-label=\"Approve\" ng-click=\"vm.approval(\'1\', vm.Form.objForm.idHandover, \'receiver\')\">\nApprove</md-button></md-dialog-actions><md-dialog-actions layout=\"row\" class=\"md-background-bg\" \nng-if=\"vm.n1Status == 0 && vm.n1 == vm.nik\"><md-button class=\"md-raised md-accent\" aria-label=\"Approve\" \nng-click=\"vm.approval(\'2\', vm.Form.objForm.idHandover, \'n1\')\">Reject</md-button><md-button class=\"md-raised md-accent\" \naria-label=\"Approve\" ng-click=\"vm.approval(\'1\', vm.Form.objForm.idHandover, \'n1\')\">Approve</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/offboarding/handover/handover.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><md-subheader class=\"white-bg\"><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.JOBHANDOVER\"></span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.COMPANY\' | translate }}\" value=\"{{ls.company}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label><span translate=\"KPI.LABEL.STARTDATE\"></span></label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglmulai\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.START_DATE\' | translate }}\" name=\"tglmulai\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"15\" flex><label><span \ntranslate=\"KPI.LABEL.ENDDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.END_DATE\' | translate }}\" name=\"tglakhir\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><md-select ng-model=\"vm.reason\" \nname=\"reason\"><md-option ng-repeat=\"ls in vm.listReason\" \nplaceholder=\"{{ \'OFB.REGISTRATION_LIST.REASON\' | translate }}\" value=\"{{ls}}\">{{ls}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><input type=\"text\" \nplaceholder=\"employee name / nik\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit\n</md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span>\n</md-input-container><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"></md-menu-content></md-menu><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"2%\"><div\n class=\"table-header\"><span class=\"column-title\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.NIK\">NIK</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.NAME\">Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.REGISTRATION_LIST.JOB_TITLE\">Job Title</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.EFFECTIVE_DATE\">Effective Date</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.REGISTRATION_LIST.LAST_DAY\">Last Day</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.REASON\">Reason</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.ACTION\">\nAction</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.loadDetailOffboarding(ls.id, $event)\"><td><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"Open kpi menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.loadDetailOffboarding(ls.id)\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex>View Detail Offboarding</p></div></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.loadDetail(ls.id, $event)\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><p flex>View Handover</p></div></md-button></md-menu-item><md-menu-item \nng-if=\"!ls.idHandover\"><md-button ng-click=\"vm.createHandover(ls.id, $event)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex>Create Handover</p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></td><td>{{ls.nik }}</td><td>{{ls.empName}}</td><td>{{ls.job_title}}</td>\n<td>{{ls.effective_date}}</td><td>{{ls.last_day}}</td><td>{{ls.reason}}</td><td><center><a \nng-click=\"vm.viewDocument($event, ls.address_document, ls.id, ls.n1, ls.approved_status)\" \nclass=\"md-mini md-raised md-primary\">View Document</a></center></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></md-content></div>");
$templateCache.put("app/main/offboarding/reff-checklist/ofb-reff-checklist.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Ref Check List\"><div \nclass=\"md-whiteframe-4dp white-bg rounded mt-30\" layout-fill><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container md-no-float class=\"md-block\" flex=\"30\"><select name=\"see\" \nid=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\">\n</select>Entries<md-button class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.input()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Add Reference</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"OFB.REF_CHECKLIST.ADD_REFERENCE\">Add Reference</span></md-button><md-button class=\"md-warn md-mini\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.deleteItem($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Delete Reference</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"OFB.REF_CHECKLIST.DELETE_REFERENCE\">\nDelete Reference</span></md-button></md-input-container><span flex></span> <span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" width=\"1%\"><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.REF_CHECKLIST.DESCRIPTION\">DESCRIPTION</span></div></th><th class=\"text-center\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFB.REF_CHECKLIST.APPROVAL_TYPE\">APPROVAL TYPE</span></div>\n</th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.REF_CHECKLIST.BU\">BUSINESS UNIT</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editUser(ls)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listModulSelected\" checklist-value=\"ls\"></td><td class=\"text-left\">{{ ls.description }}</td><td \nclass=\"text-left\">{{ ls.approval_type }}</td><td class=\"text-left\">{{ ls.bu }}</td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-tab><md-tab label=\"Approval Type List\"><div \nclass=\"md-whiteframe-4dp white-bg rounded mt-30\" layout-fill><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container md-no-float class=\"md-block\" flex=\"30\"><select name=\"see\" \nid=\"ss\" ng-change=\"vm.loadDataApprovalType(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries<md-button class=\"md-mini md-raised md-primary btn-ui-serif\" \nhide show-gt-sm type=\"button\" ng-click=\"vm.inputApprovalType()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Add Approval Type</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"OFB.REF_CHECKLIST.ADD_APPROVALTYPE\">\nAdd Approval Type</span></md-button><md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.deleteItemApprovalType($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nDelete Approval Type</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon><span translate=\"OFB.REF_CHECKLIST.DELETE_REFERENCE\">Delete Approval Type</span></md-button>\n</md-input-container><span flex></span> <span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th class=\"text-center\" width=\"1%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"OFB.REF_CHECKLIST.DESCRIPTION\">DESCRIPTION</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"ls in vm.DataTableApprovalType.list\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listModulSelected2\" checklist-value=\"ls\"></td><td class=\"text-left\">{{ ls.description }}</td></tr>\n</tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTableApprovalType.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a \nhref=\"\" ng-click=\"vm.loadDataApprovalType(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div>\n</md-tab></md-tabs></md-content></div>");
$templateCache.put("app/main/offboarding/varklaring/varklaring.html","");
$templateCache.put("app/main/offboarding/registration/ofb-registration-detail.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div layout-xs=\"column\" layout=\"row\" class=\"mt-5 mb-5\" \nlayout-align=\"center center\"><div class=\"md-whiteframe-4dp white-bg rounded m-5\" flex flex-gt-md=\"85\" layout=\"column\">\n<md-subheader class=\"white-bg\">ACTIONS</md-subheader><div class=\"white-bg\"><div class=\"form-wrapper\" layout=\"row\" \nlayout-xs=\"column\"><md-button type=\"button\" ng-click=\"vm.approval(\'n1\', \'1\')\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-if=\"vm.myNik == vm.Form.objForm.nik_atasan && vm.Form.objForm.approved_status == 0\">Approve</md-button><md-button \ntype=\"button\" ng-click=\"vm.approval(\'n1\', \'2\')\" class=\"md-red-300-bg md-raised white-fg\" aria-label=\"Reload\" \nng-if=\"vm.myNik == vm.Form.objForm.nik_atasan && vm.Form.objForm.approved_status == 0\">Reject</md-button><md-button \ntype=\"button\" ng-click=\"vm.approval(\'hr\', \'1\')\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-if=\"vm.myNik == vm.Form.objForm.approved_hr && vm.Form.objForm.approved_hr_status == 0\">Approve</md-button>\n<md-button type=\"button\" ng-click=\"vm.approval(\'hr\', \'2\')\" class=\"md-red-300-bg md-raised white-fg\" \naria-label=\"Reload\" ng-if=\"vm.myNik == vm.Form.objForm.approved_hr && vm.Form.objForm.approved_hr_status == 0\">Reject\n</md-button><md-button type=\"button\" ng-click=\"vm.terminate(vm.Form.objForm, $event)\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-if=\"vm.Form.objForm.final_status == 1 && vm.Form.objForm.terminator == 1 && vm.clearance == 0 && vm.Form.objForm.setClearance != 0\">\nTerminate</md-button><md-button type=\"button\" \nng-click=\"vm.setClearance(vm.Form.objForm.id, vm.Form.objForm.nik, $event)\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" \nng-if=\"vm.Form.objForm.approved_status == 1 && vm.Form.objForm.approved_hr_status == 1 && vm.Form.objForm.setClearance == 0 && vm.Form.objForm.final_status == 0 && vm.Form.objForm.terminator == 1\">\nSet Clearance</md-button><md-button type=\"button\" ng-click=\"vm.cancel(vm.Form.objForm.id, $event)\" \nclass=\"md-raised md-orange-400-bg btn-ui-serif\" aria-label=\"Cancel\" \nng-if=\"vm.myNik == vm.Form.objForm.nik && vm.Form.objForm.final_status == 0\">Cancel</md-button><md-button \ntype=\"button\" ng-click=\"vm.cancel(vm.Form.objForm.id, $event)\" class=\"md-raised md-orange-400-bg btn-ui-serif\" \naria-label=\"Cancel\" ng-if=\"vm.myNik != vm.Form.objForm.nik && vm.Form.objForm.terminator == 1\">Cancel</md-button>\n<md-button type=\"button\" class=\"md-primary\" aria-label=\"Submit\" \nng-click=\"vm.viewDocument($event, vm.Form.objForm.address_document, vm.Form.objForm.id, vm.Form.objForm.nik_atasan, vm.Form.objForm.approved_status)\">\nView Document</md-button></div></div></div></div><div layout-xs=\"column\" layout=\"row\" class=\"mt-5 mb-5\" \nlayout-align=\"center center\"><div class=\"md-whiteframe-4dp white-bg rounded m-5\" flex flex-gt-md=\"85\" layout=\"column\">\n<md-subheader class=\"white-bg\">OFFBOARDING REGISTRATION DETAIL</md-subheader><div class=\"white-bg\"><div \nclass=\"form-wrapper\" layout=\"row\" layout-xs=\"column\"><div flex flex-gt-md=\"40\" layout=\"column\"><div class=\"md-subhead\">\n<strong>Employe Name</strong></div><div class=\"info\">{{vm.Form.objForm.empName}}</div><md-divider></md-divider></div>\n<div flex flex-gt-md=\"15\" layout=\"column\"><div class=\"md-subhead\"><strong>NIK</strong></div><div class=\"info\">\n{{vm.Form.objForm.nik}}</div><md-divider></md-divider></div><div flex flex-gt-md=\"45\" layout=\"column\"><div \nclass=\"md-subhead\"><strong>Job Title</strong></div><div class=\"info\">{{vm.Form.objForm.job_title}}</div><md-divider>\n</md-divider></div></div><div class=\"form-wrapper\" layout=\"row\" layout-xs=\"column\"><div flex flex-gt-md=\"40\" \nlayout=\"column\"><div class=\"md-subhead\"><strong>Employe Category</strong></div><div class=\"info\">\n{{vm.Form.objForm.emp_category}}</div><md-divider></md-divider></div><div flex flex-gt-md=\"15\" layout=\"column\"><div \nclass=\"md-subhead\"><strong>Grade</strong></div><div class=\"info\">{{vm.Form.objForm.grade}}</div><md-divider>\n</md-divider></div><div flex flex-gt-md=\"45\" layout=\"column\"><div class=\"md-subhead\"><strong>Direct Report</strong>\n</div><div class=\"info\">{{vm.Form.objForm.nik_atasan}}</div><md-divider></md-divider></div></div><div \nclass=\"form-wrapper\" layout=\"row\" layout-xs=\"column\"><div flex flex-gt-md=\"20\" layout=\"column\"><div class=\"md-subhead\">\n<strong>Effective Date</strong></div><div class=\"info\">{{vm.Form.objForm.effective_date}}</div><md-divider>\n</md-divider></div><div flex flex-gt-md=\"20\" layout=\"column\"><div class=\"md-subhead\"><strong>Last Day</strong></div>\n<div class=\"info\">{{vm.Form.objForm.last_day}}</div><md-divider></md-divider></div><div flex flex-gt-md=\"20\" \nlayout=\"column\"><div class=\"md-subhead\"><strong>Create Date</strong></div><div class=\"info\">\n{{vm.Form.objForm.create_date}}</div><md-divider></md-divider></div><div flex flex-gt-md=\"40\" layout=\"column\"><div \nclass=\"md-subhead\"><strong>Reason</strong></div><div class=\"info\">{{vm.Form.objForm.reason}}</div><md-divider>\n</md-divider></div></div><div class=\"form-wrapper\" layout=\"row\" layout-xs=\"column\"><div flex layout=\"column\"><div \nclass=\"md-subhead\"><strong>Reason Description</strong></div><div class=\"info\" \nng-bind-html=\"vm.Form.objForm.reason_description\"></div><md-divider></md-divider></div></div></div></div></div><div \nlayout-xs=\"column\" layout=\"row\" class=\"mt-5 mb-5\" layout-align=\"center center\"><div \nclass=\"md-whiteframe-4dp white-bg rounded m-5\" flex flex-gt-md=\"85\" layout=\"column\"><md-subheader class=\"white-bg\">\nOFFBOARDING REGISTRATION CHECKLIST</md-subheader><div class=\"white-bg\"><div layout=\"row\"><div class=\"form-wrapper\" \nlayout=\"column\" flex><ol class=\"htl-ol\"><li class=\"htl-li\"><p class=\"diplome\">N1 Approval</p><span class=\"point-ok\" \nng-if=\"vm.Form.objForm.approved_status == 1\"></span> <span class=\"point\" ng-if=\"vm.Form.objForm.approved_status != 1\">\n</span><p class=\"description\">{{vm.Form.objForm.n1Name}}</p></li><li class=\"htl-li\"><p class=\"diplome\">HR Approval</p>\n<span class=\"point\" ng-if=\"vm.Form.objForm.approved_hr_status != 1\"></span> <span class=\"point\" \nng-if=\"vm.Form.objForm.approved_hr_status == 1 && !vm.Form.objForm.approved_hr_date\"></span> <span class=\"point-ok\" \nng-if=\"vm.Form.objForm.approved_hr_status == 1 && !vm.Form.objForm.approved_hr_date && vm.Form.objForm.approved_status == 1\">\n</span> <span class=\"point-ok\" ng-if=\"vm.Form.objForm.approved_hr_status == 1 && vm.Form.objForm.approved_hr_date\">\n</span><p class=\"description\">{{vm.Form.objForm.hrName}}</p></li><li class=\"htl-li\"><p class=\"diplome\">Exit Clearance\n</p><span class=\"point-ok\" ng-if=\"vm.clearance == 0 && vm.Form.objForm.setClearance != 0\"></span> <span class=\"point\" \nng-if=\"vm.clearance == 0 && vm.Form.objForm.setClearance == 0 \"></span> <span class=\"point\" \nng-if=\"vm.clearance != 0 && vm.Form.objForm.setClearance != 0 \"></span><p class=\"description\">\n{{vm.Form.objForm.hrName}}</p></li><li class=\"htl-li\"><p class=\"diplome\">Verklaring</p><span class=\"point-ok\" \nng-if=\"vm.clearance == 0 && vm.Form.objForm.setClearance != 0\"></span> <span class=\"point\" \nng-if=\"vm.clearance == 0 && vm.Form.objForm.setClearance == 0 \"></span> <span class=\"point\" \nng-if=\"vm.clearance != 0 && vm.Form.objForm.setClearance != 0 \"></span><p class=\"description\"></p></li></ol></div>\n</div><div layout=\"row\"><div class=\"form-wrapper\" layout=\"column\" flex><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th>No</th><th>Type</th><th>Date</th><th>\nLead Time</th></tr></thead><tbody><tr ng-repeat=\"lsd in vm.Form.objForm.approval\"><td>{{$index +1}}</td><td>\n{{lsd.tipe}}</td><td>{{lsd.waktu}}</td><td>{{lsd.lt}}</td></tr></tbody></table></div></div><div layout=\"row\"><div \nclass=\"form-wrapper\" layout=\"column\" flex ng-if=\"vm.Form.objForm.final_status == 1\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th>No</th><th>Item</th><th>Category</th>\n<th>Approved By</th><th>Approved Date</th><th>Status</th><th>Action</th></tr></thead><tbody><tr \nng-repeat=\"lsd in vm.Form.objForm.checklist\"><td>{{$index +1}}</td><td>{{lsd.description}}</td><td>\n{{lsd.approval_type}}</td><td>{{lsd.status_by}}</td><td>{{lsd.status_date}}</td><td><center><i \nclass=\"icon icon-timer-sand\" ng-if=\"lsd.status == 0\" style=\"color:#FBC02D\"><md-tooltip><span>Waiting Approval</span>\n</md-tooltip></i><i class=\"icon icon-check-circle\" ng-if=\"lsd.status == 1\" style=\"color:#4CAF50\"><md-tooltip><span>\nApproved</span></md-tooltip></i><i class=\"icon icon-window-close\" ng-if=\"lsd.status == 2\" style=\"color:#C62828\">\n<md-tooltip><span>Rejected</span></md-tooltip></i></center></td><td><center><span \nng-if=\" (lsd.description|lowercase) == \'serah terima tugas dan tanggung jawab\' && lsd.status == 1\"><a \nng-click=\"vm.loadHandover(vm.Form.objForm.id, lsd.id, $event)\" class=\"md-mini md-raised md-primary\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">View Job Handover</md-tooltip><span>Job Handover</span> </a></span>\n<span ng-if=\" (lsd.description|lowercase) == \'serah terima tugas dan tanggung jawab\' && lsd.status == 0\"><a \nng-click=\"vm.createHandover(vm.Form.objForm.id, $event)\" class=\"md-mini md-raised md-primary\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Create Job Handover</md-tooltip><span>Job Handover</span> </a></span><a\n class=\"md-mini md-raised md-primary\" \nng-if=\"(lsd.description|lowercase) == \'penutupan alamat email dan hak akses it lainnya\' && lsd.approval_type == \'IT\'\" \nng-click=\"vm.itForm(lsd, $event)\">Form IT</a></center></td></tr><tr><td>{{vm.Form.objForm.checklist.length + 1}}</td>\n<td>Offboarding Document</td><td>Personalia</td><td colspan=\"2\"></td><td><center><i class=\"icon icon-check-circle\" \nstyle=\"color:#4CAF50\"><md-tooltip><span>Approved</span></md-tooltip></i></center></td><td><center><a \nng-click=\"vm.viewDocument($event, vm.Form.objForm.address_document, vm.Form.objForm.id, vm.Form.objForm.n1, vm.Form.objForm.approved_status)\" \nclass=\"md-mini md-raised md-primary\">View Document</a></center></td></tr><tr ng-if=\"vm.Form.objForm.verklaring == 1\">\n<td>{{vm.Form.objForm.checklist.length + 2}}</td><td>Verklaring</td><td>Personalia</td><td colspan=\"4\" align=\"right\"><a\n ng-href=\"{{vm.baseUrl}}api/ofb/varklaring/printVarklaringPDF/{{vm.Form.objForm.nik}}\" target=\"_blank\" \nng-if=\"vm.clearance == 0 && vm.Form.objForm.approved_hr_status == 1 && vm.Form.objForm.approved_status == 1\">Download\n</a></td></tr><tr ng-if=\"vm.Form.objForm.verklaring == 1\"><td>{{vm.Form.objForm.checklist.length + 3}}</td><td>\nVerklaring Disnaker</td><td>Personalia</td><td colspan=\"4\" align=\"right\"><a \nng-href=\"{{vm.baseUrl}}api/ofb/varklaring/printVarklaringDisnakerPDF/{{vm.Form.objForm.nik}}\" target=\"_blank\" \nng-if=\"vm.clearance == 0 && vm.Form.objForm.approved_hr_status == 1 && vm.Form.objForm.approved_status == 1\">Download\n</a></td></tr></tbody></table></div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/offboarding/registration/ofb-registration-list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><md-subheader class=\"white-bg\">Offboarding Registration</md-subheader><div \nclass=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.COMPANY\' | translate }}\" \nvalue=\"{{ls.company}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\">\n<md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglmulai\" md-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.START_DATE\' | translate }}\" \nname=\"tglmulai\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" \nmd-placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.END_DATE\' | translate }}\" name=\"tglakhir\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex><md-select ng-model=\"vm.reason\" name=\"reason\"><md-option\n ng-repeat=\"ls in vm.listReason\" placeholder=\"{{ \'OFB.REGISTRATION_LIST.REASON\' | translate }}\" value=\"{{ls}}\">{{ls}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"10\"><label>Grade</label>\n<md-select ng-model=\"vm.grade\" name=\"grade\"><md-option value=\"all\"><em>All</em></md-option><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option></md-select><div ng-messages=\"frmEmploye.grade.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Grade field is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Employee Type</label><md-select ng-model=\"vm.empType\" name=\"empType\"><md-option \nvalue=\"all\"><em>All</em></md-option><md-option value=\"sap\">STAFF</md-option><md-option value=\"hris\">GENERAL WORKER\n</md-option></md-select><div ng-messages=\"frmEmploye.empType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmploye Type field is required.</span></div></div></md-input-container></div><md-input-container class=\"md-block\" \nflex-offset-gt-sm=\"40\"><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit</md-button></md-input-container></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm>\n</span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" ng-model=\"vm.search\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"2%\"><div\n class=\"table-header\"><span class=\"column-title\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.NIK\">NIK</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.NAME\">Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.REGISTRATION_LIST.JOB_TITLE\">Job Title</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.EMP_CATEGORY\">Emp Category</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.REGISTRATION_LIST.GRADE\">Grade</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.EFFECTIVE_DATE\">Effective Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.LAST_DAY\">\nLast Day</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFB.REGISTRATION_LIST.REASON\">Reason</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"OFB.REGISTRATION_LIST.ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.detail(ls.id)\"><td><md-menu md-position-mode=\"target-right target\">\n<md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.detail(ls.id)\"><div layout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-eye\">\n</md-icon><p flex>View Detail</p></div></md-button></md-menu-item></md-menu-content></md-menu></td><td>{{ls.nik }}</td>\n<td>{{ls.empName}}</td><td>{{ls.job_title}}</td><td>{{ls.emp_category}}</td><td>{{ls.grade}}</td><td>\n{{ls.effective_date}}</td><td>{{ls.last_day}}</td><td>{{ls.reason}}</td><td><md-button \nng-if=\"!!ls.idHandover && ls.approved_status == 1 && ls.approved_hr_status == 1\" \nclass=\"md-mini md-raised md-primary btn-ui-serif\" type=\"button\" ng-click=\"vm.loadHandover(ls.id, $event)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">Job Handover</md-tooltip><md-icon md-font-icon=\"icon-clipboard-check\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Job Handover</span></md-button><md-button \nng-if=\"ls.setClearance == 0 && ls.approved_hr_status == 1 && ls.approved_status == 1 && ls.final_status == 0\" \nclass=\"md-mini md-raised md-info btn-ui-serif\" type=\"button\" ng-click=\"vm.setClearance(ls.id, ls.nik, $event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Set Exit Clearance</md-tooltip><md-icon \nmd-font-icon=\"icon-clipboard-text\" class=\"md-font icon-archive material-icons\"></md-icon><span>Set Clearance</span>\n</md-button></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></md-content></div>");
$templateCache.put("app/main/offboarding/registration/ofb-view-doc.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Document - {{vm.doc}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" \nclass=\"md-background-bg\" id=\"contentDialog\"><iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh\" frameborder=\"0\">\n</iframe></md-dialog-content><md-dialog-content ng-if=\"!vm.doc_type\"><img style=\"margin: auto; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/ofbdocument/{{vm.doc}}\"></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\" ng-if=\"vm.n1 == vm.user && vm.status ==0\"><md-button class=\"md-raised md-accent\" \naria-label=\"Approve\" ng-click=\"vm.approval(\'n1\', \'2\')\">Reject</md-button><md-button class=\"md-raised md-accent\" \naria-label=\"Approve\" ng-click=\"vm.approval(\'n1\', \'1\')\">Approve</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-dashboard/onboarding-dashboard.html","<div class=\"page-layout simple fullwidth\"><div class=\"content\" style=\"padding: 0px\"><div ng-cloak><md-content \nclass=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><md-card class=\"white-bg\"><md-card-title>\n<md-card-title-text><span class=\"md-display-1 font-weight-300\">{{ vm.dashboard.item_name}}</span> <span \nclass=\"md-subhead\"><p>{{ vm.dashboard.description}}</p></span></md-card-title-text><md-card-title-media><div \nclass=\"md-media-lg card-media\"><img src=\"assets/images/avatars/onboard.png\" alt=\"\"></div></md-card-title-media>\n</md-card-title></md-card></div></md-content><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex \nlayout=\"column\"><md-card class=\"white-bg\"><md-card-title><md-card-title-text><span class=\"md-headline text-center\">\nOn-Boarding</span></md-card-title-text></md-card-title><md-card-content><button class=\"card red\" \nng-click=\"vm.firstDayProgress()\"><span ng-if=\"vm.employee&&vm.frdProgress!=\'0%\'\" class=\"t-color\">{{vm.frdProgress}}\n</span><br><span class=\"t-color\">First Day</span></button> <img class=\"arrowxx\" src=\"assets/images/arrowright.png\" \nalt=\"\"> <button class=\"card {{ vm.oriExp ? \'green\' : \'disabled\' }}\" ng-click=\"vm.orientationProgress()\"><span \nng-if=\"vm.employee&&vm.oriProgress!=\'0%\'\" class=\"t-color\">{{vm.oriProgress}}</span><br><span class=\"t-color\">\nOrientation</span></button> <img class=\"arrowxx\" src=\"assets/images/arrowright.png\" alt=\"\"> <button \nclass=\"card purple\" ng-click=\"vm.ojtProgress()\"><span ng-if=\"vm.employee&&vm.ojtProgressValue!=\'0%\'\" class=\"t-color\">\n{{vm.ojtProgressValue}}</span><br><span class=\"t-color\">OJT</span></button> <img class=\"arrowxx\" \nsrc=\"assets/images/arrowright.png\" alt=\"\"> <button \nclass=\"card {{ vm.review || vm.employee==false ? \'cyan\' : \'disabled\' }}\" ng-click=\"vm.reviewProgress()\"><span \nclass=\"t-color\">Review</span></button></md-card-content></md-card></div><div flex layout=\"column\"><md-card \nclass=\"white-bg\"><md-card-content><button class=\"card-overview {{ vm.onbOverview ? \'teal\' : \'disabled\' }}\"><a \nng-click=\"vm.loadOverview()\"><span class=\"t-color\">On-Boarding Overview</span></a></button> <button \nclass=\"card-overview {{ vm.progress ? \'green\' : \'disabled\' }}\"><a ng-click=\"vm.progressStatus()\"><span class=\"t-color\">\nProgress Status</span></a></button> <button class=\"card-overview {{ vm.resource ? \'orange\' : \'disabled\' }}\"><a \nng-click=\"vm.uploadResource()\"><span class=\"t-color\">Resources</span></a></button></md-card-content></md-card></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/onboarding/onboarding-dashboard/onboarding-emp-progress.html","<md-dialog aria-label=\"View Detail\" md-theme=\"modal-theme\" flex-md=\"80\" flex-gt-md=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Progress Summary</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"column\" layout-fill class=\"content padding\"><md-content class=\"content padding\" layout-fill>\n<div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th class=\"text-center\" rowspan=\"3\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.NAME\">Name</span>\n</th><th class=\"text-center\" rowspan=\"3\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.DIRECTSPV\">\nDirect Supervisor</span></th><th class=\"text-center\" rowspan=\"3\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.JOINDATE\">Join Date</span></th><th class=\"text-center\" rowspan=\"3\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.DAYS\">Days</span></th><th class=\"text-center\" colspan=\"7\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.COMPRETIONPROG\">Completion Progress</span></th></tr><tr><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.FIRSTDAY\">First Day</span></th>\n<th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.ORIENTATIONP\">Orientation\n</span></th><th class=\"text-center\" colspan=\"4\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.OJT\">OJT</span>\n</th></tr><tr><th class=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.1ON1\">1 on 1</span></th>\n<th class=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.30DAY\">30 Dyas</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.60DAY\">60 Dyas</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.90DAY\">90 Dyas</span></th></tr></thead>\n<tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.listData\"><td class=\"text-center\">{{item.name}}</td><td \nclass=\"text-center\">{{item.spv_name}}</td><td class=\"text-center\">{{item.join_date}}</td><td class=\"text-center\">\n{{item.day}}</td><td class=\"text-center\"><span>{{ item.first_day!=null ? item.first_day : \'0\'}}%</span></td><td \nclass=\"text-center\"><span>{{ item.orientation!=null ? item.orientation : \'0\'}}%</span></td><td class=\"text-center\">\n<span>{{ item.oneonone!=null ? item.oneonone : \'0\'}}%</span></td><td class=\"text-center\"><span \nng-if=\"item.thirtyread==1&&item.thirtycomment==1&&item.thirtyday!=null\">{{item.thirtyday}}% </span><span \nng-if=\"item.thirtyread==0&&item.thirtyday!=null\">50% </span><span \nng-if=\"item.thirtycomment==0&&item.thirtyday==null || item.thirtycomment==1&&item.thirtyday==null\">0%</span></td><td \nclass=\"text-center\"><span ng-if=\"item.sixtyread==1&&item.sixtycomment==1&&item.sixtyday!=null\">{{item.sixtyday}}% \n</span><span ng-if=\"item.sixtyread==0&&item.sixtyday!=null\">50% </span><span \nng-if=\"item.sixtycomment==0&&item.sixtyday==null || item.sixtycomment==1&&item.sixtyday==null\">0%</span></td><td \nclass=\"text-center\" colspan=\"2\"><span ng-if=\"item.ninetyread==1&&item.ninetycomment==1&&item.ninetyday!=null\">\n{{item.ninetyday}}% </span><span ng-if=\"item.ninetyread==0&&item.ninetyday!=null\">50% </span><span \nng-if=\"item.ninetycomment==0&&item.ninetyday==null || item.sixtycomment==1&&item.sixtyday==null\">0%</span></td></tr>\n</tbody></table></md-content></div></div></md-content></div></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-discussion-approval/onboarding-discussion-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><div class=\"white-bg\">\n<md-subheader class=\"white-bg\">Onboarding Discussion Aproval</md-subheader><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container><md-select ng-model=\"vm.status\" name=\"status\" ng-change=\"vm.loadData(1)\"><md-option \nng-repeat=\"ls in vm.appstatus\" placeholder=\"{{ \'MENU.CB.LEAVE.INDEX.HEADER.APPROVAL_STATUS\' | translate }}\" \nvalue=\"{{ls.value}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"formInputOT.status.$error\" role=\"alert\"><div \nng-message=\"required\"><span>status field is required.</span></div></div></md-input-container></div></form></div></div>\n</md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" width=\"5%\">\n<span class=\"column-title\" translate=\"ONBOARDING.TABLE.NO\">No</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.NIK\">NIK</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.NAME\">Name</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.TARGET\">Target</span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTable.list\"><td class=\"text-center\">{{($index + 1)}}</td><td>\n{{item.nik}}</td><td>{{item.name}}</td><td class=\"text-center\"><a href=\"\" \nng-click=\"vm.viewDetail(item,vm.status,$event)\">{{item.target}}</a></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/onboarding/onboarding-discussion-approval/reject-comment.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formData\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formData)\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2 translate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div layout-gt-sm=\"row\" \nng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" ng-disabled=\"vm.isdisabled\" \nng-model=\"vm.comment\" placeholder=\"{{ \'MENU.CB.APPROVAL_GHK.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formData.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span></div>\n</div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.viewComment}}</span></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p>\n</ms-widget-front></ms-widget><span flex></span><md-button ng-if=\"!vm.stateView\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formData.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-discussion-approval/view-target.html","<md-dialog aria-label=\"View Detail\" md-theme=\"modal-theme\" flex-md=\"80\" flex-gt-md=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nlayout=\"column\" layout-fill class=\"content padding\"><div class=\"content\" style=\"padding: 0px\"><div ng-cloak>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-button ng-if=\"vm.status==\'0\'\" \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.approve($event,\'approve\',\'Approve\')\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nclick for view actions</md-tooltip><md-icon md-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\">\n</md-icon><span translate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.ACTION.APPROVE\">Aprove</span></md-button><md-button \nng-if=\"vm.status==\'1\'\" class=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.approve($event,\'unapprove\',\'Un-Approve\')\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nclick for view actions</md-tooltip><md-icon md-font-icon=\"icon-verified\" class=\"md-font icon-archive material-icons\">\n</md-icon><span translate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.ACTION.UNAPPROVE\">Un-Aprove</span></md-button><div \nng-if=\"vm.status==\'0\'\" class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nng-if=\"vm.status==\'0\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" ng-click=\"vm.reject($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Reject</md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon><span translate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.ACTION.REJECT\">Reject\n</span></md-button><md-button ng-if=\"vm.status==\'2\'\" class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Inert\" \nng-click=\"vm.approve($event,\'unreject\',\'Un-Reject\')\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nUn-Reject</md-tooltip><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span \ntranslate=\"MENU.CB.CHANGE_SHIFT_APPROVAL.INDEX.ACTION.UNREJECT\">Un-Reject</span></md-button></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><th width=\"5%\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.ROLE\">Role</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.SKILL\">Skill Required</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.ACTIONPLAN\">Action Plan</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.RESULT\">Result</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.TARGETDATE\">Target Date</span></th></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.listData\"><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{item.roles}}\n</td><td class=\"text-center\">{{item.skill_required}}</td><td class=\"text-center\">{{item.action_plan}}</td><td \nclass=\"text-center\">{{item.result}}</td><td class=\"text-center\">{{item.target_date}}</td></tr><tr \nng-if=\"vm.discussionList.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"ONBOARDING.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table></md-content></div></div></div></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-feedback/onboarding-feedback.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><div class=\"white-bg\">\n<md-content style=\"background:white\" hide-gt-sm><span flex=\"5\"></span><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nng-if=\"vm.admin\" width=\"2%\"><span class=\"is-gear\"></span></th><th width=\"5%\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NIK\">NIK</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NAME\">Name</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.FEEDBACK\">Feedback</span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.items\"><td ng-if=\"vm.admin\"><md-checkbox ng-if=\"item.is_on_progress==0&&item.is_completed==0\" \naria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\">\n</md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\" width=\"5%\">{{item.nik}}</td>\n<td>{{item.name}}</td><td class=\"text-left\"><div ng-bind-html=\"item.feedback\"></div></td></tr><tr class=\"text-center\" \nng-if=\"vm.items.length <= 0\"><td colspan=\"9\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/onboarding/onboarding-firstday/onboarding-firstday.html","<div class=\"page-layout simple fullwidth\"><div class=\"content\" style=\"padding: 0px\"><div ng-cloak><md-content \nclass=\"md-padding white-bg\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><fieldset class=\"white-bg\">\n<legend><a ui-sref=\"app.app_onboarding\"><span class=\"l-color\">On-Boarding Overview</span></a> > <a><span \nclass=\"l-color\">Firstday</span></a></legend><p>Hello! Yeay, It is your first day with us! Hope it is great!<br>\nIn this section, we want you to provide a ‘checklist’ on the check-box for each items/contents that you have already got in your first day. Please notice once the box are checked and submitted, it cannot be changed.\n</p></fieldset></div></md-content><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\">\n<span class=\"column-title\" translate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.ORIENTATION\">Orientation Overview</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.COMPLETED\">Completed</span></th><th \nwidth=\"15%\" class=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.DATE\">Date</span></th></tr>\n</thead><tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.listInput\"><td class=\"text-center\">\n{{($index + 1)}}</td><td><span><a href=\"\" ng-click=\"vm.viewDetail(item,$event)\">{{item.subject}}</a><p>\n{{item.description}}</p></span></td><td class=\"text-center\"><md-checkbox aria-label=\"empLaborChecked\" \nng-disabled=\"true\" ng-checked=\"item.is_complete\"></md-checkbox></td><td class=\"text-center\">{{item.completed_at}}</td>\n</tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"ONBOARDING.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></md-content></div></div></div>\n</div>");
$templateCache.put("app/main/onboarding/onboarding-firstday/view-detail.html","<md-dialog aria-label=\"View Detail\" md-theme=\"modal-theme\" flex-md=\"80\" flex-gt-md=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{vm.header}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"column\" layout-fill class=\"content padding\"><div class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.ITEM\">Item</span></th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.COMPLETED\">Completed</span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.listInput\"><td class=\"text-center\">{{($index + 1)}}</td><td><span><p>{{item.subject}}</p></span>\n</td><td class=\"text-center\"><md-checkbox ng-click=\"vm.changeStatus(item)\" ng-model=\"vm.changeComplete[item.id]\" \nng-disabled=\"vm.noChange&&item.is_submitted==1\" aria-label=\"empLaborChecked\"></md-checkbox></td></tr><tr \nng-if=\"vm.listInput.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"ONBOARDING.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><form name=\"formSubmitOrientation\" \nng-submit=\"vm.submitData($event, formSubmitOrientation)\" novalidate flex><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" class=\"md-raised md-primary md-hue-2\" aria-label=\"Submit\" \nng-disabled=\"vm.listInput.length <= 0 || vm.isComplete\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></form></div></div></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-ojt/onboarding-ojt.html","<div class=\"page-layout simple fullwidth\"><div class=\"content\" style=\"padding: 0px\"><div ng-cloak><md-content \nclass=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><fieldset><legend><a \nui-sref=\"app.app_onboarding\"><span class=\"l-color\">On-Boarding Overview</span></a> > <a><span class=\"l-color\">\nOJT / On The Job</span></a></legend><p>Hello!<br>\nIn this section, there are 5 process that you need to complete during this on-boarding program, starting from your first week until your 90 days. Do not forget to keep updating your progress monthly.\n</p></fieldset></div></md-content><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex \nlayout=\"column\"><md-card><md-card-title><md-card-title-text><div class=\"simple-table-container\" hide show-gt-sm><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead>\n<tr><th class=\"text-center\" width=\"5%\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.NO\">NO</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.OJTACTIVITY\">Orientation Overview</span>\n</th><th width=\"10%\" class=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.COMPLETED\">Completed\n</span></th><th width=\"15%\" class=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.DATE\">Date\n</span></th></tr></thead><tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.listInput\"><td \nclass=\"text-center\">{{($index + 1)}}</td><td><span><a href=\"\" \nng-click=\"(item.is_complete_before==1&&item.expired==0) ? vm.viewDetail(item,$event) : \'\'\">{{item.subject}}</a><p>\n{{item.description}}</p></span></td><td class=\"text-center\"><md-checkbox aria-label=\"empLaborChecked\" \nng-disabled=\"true\" ng-checked=\"item.is_complete\"></md-checkbox></td><td class=\"text-center\">{{item.completed_at}}</td>\n</tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"ONBOARDING.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></div></div>\n</md-card-title-text></md-card-title></md-card></div></md-content></div></div></div>");
$templateCache.put("app/main/onboarding/onboarding-ojt/view-feedback.html","<md-dialog aria-label=\"View Detail\" md-theme=\"modal-theme\" flex-md=\"80\" flex-gt-md=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{ vm.header }}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"column\" layout-fill class=\"content padding\"><div class=\"content\" style=\"padding: 0px\"><div \nng-cloak><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><md-card>\n<md-card-title><md-card-title-text><div class=\"simple-table-container\" hide show-gt-sm><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"fullwidth-table simple with-toolbar upper-case-header\" \nms-responsive-table><tbody><tr class=\"md-table-content-row\"><td><textarea rows=\"3\" ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.feedback\" ng-disabled=\"vm.isComplete\"></textarea></td></tr></tbody></table></div></div>\n</md-card-title-text></md-card-title></md-card><div class=\"container\"><form name=\"formSubmitOrientation\" \nng-submit=\"vm.processFeedback($event, formSubmitOrientation)\" novalidate flex><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" class=\"md-raised md-primary md-hue-2\" aria-label=\"Submit\" ng-disabled=\"vm.isComplete\" \ntranslate=\"ACTION.SUBMIT\">Confirm</md-button></md-dialog-actions></form></div></div></md-content></div></div></div>\n</md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-ojt/view-mylearning.html","<md-dialog aria-label=\"View Detail\" md-theme=\"modal-theme\" flex-md=\"80\" flex-gt-md=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{vm.header}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"column\" layout-fill class=\"content padding\"><div class=\"content\" style=\"padding: 0px\"><div \nng-cloak><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><md-card>\n<md-card-title><md-card-title-text><span class=\"md-subhead\"><label><span>\nPlease complete the following fields based on what you have gone through in the month. no further changes can be made once Submit is clicked.\n</span></label><br><br><label><span><b>New Commers:</b> {{vm.empName}}</span></label><br><label><span><b>Superordinate:\n</b> {{ vm.superordinate }}</span></label><br><label><span><b>Peer:</b> {{ vm.spvName }}</span></label><br><label>\n<span><b>Subordinate:</b> {{ vm.subordinate }}</span></label></span></md-card-title-text></md-card-title></md-card>\n</div></md-content><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><th width=\"5%\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.ROLE\">Role</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.SKILL\">Skill Required</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.ACTIONPLAN\">Action Plan</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.RESULT\">Result</span></th></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.discussionList\"><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">\n{{item.roles}}</td><td class=\"text-center\">{{item.skill_required}}</td><td class=\"text-center\">{{item.action_plan}}\n</td><td class=\"text-center\">{{item.result}}</td></tr><tr ng-if=\"vm.discussionList.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"ONBOARDING.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table>\n</md-content><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><md-card>\n<md-card-title><md-card-title-text><div class=\"simple-table-container\" hide show-gt-sm><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"fullwidth-table simple with-toolbar upper-case-header\" \nms-responsive-table><tbody><tr><td colspan=\"3\" class=\"grey\"><span class=\"t-color\">1. {{vm.qs1}}</span></td></tr><tr \nclass=\"md-table-content-row\"><td><textarea rows=\"3\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.ans1\"></textarea></td>\n</tr></tbody></table></div><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar upper-case-header\" ms-responsive-table><tbody><tr><td colspan=\"3\" \nclass=\"grey\"><span class=\"t-color\">2. {{vm.qs2}}</span></td></tr><tr class=\"md-table-content-row\"><td><textarea \nrows=\"3\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.ans2\"></textarea></td></tr></tbody></table></div><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"fullwidth-table simple with-toolbar upper-case-header\" \nms-responsive-table><tbody><tr><td colspan=\"3\" class=\"grey\"><span class=\"t-color\">3. {{vm.qs3}}</span></td></tr><tr \nclass=\"md-table-content-row\"><td><textarea rows=\"3\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.ans3\"></textarea></td>\n</tr></tbody></table></div><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar upper-case-header\" ms-responsive-table><tbody><tr><td colspan=\"3\" \nclass=\"grey\"><span class=\"t-color\">4. {{vm.qs4}}</span></td></tr><tr class=\"md-table-content-row\"><td><textarea \nrows=\"3\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.ans4\"></textarea></td></tr></tbody></table></div><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"fullwidth-table simple with-toolbar upper-case-header\" \nms-responsive-table><tbody><tr><td colspan=\"3\" class=\"grey text-center\"><span class=\"t-color\">Superordinate Feedback\n</span></td></tr><tr class=\"md-table-content-row\"><td><textarea rows=\"3\" ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.spvComment\" ng-disabled=\"vm.supervisor\"></textarea></td></tr></tbody></table><span ng-if=\"vm.status==\'1\'\" \nstyle=\"color:green\">Progress Approved, please see feedback above !</span> <span ng-if=\"vm.status==\'2\'\" \nstyle=\"color:red\">Progress Rejected, please see feedback above !</span></div></div></md-card-title-text>\n</md-card-title></md-card><div class=\"container\"><md-button type=\"button\" ng-click=\"vm.processLearning($event,\'save\')\" \nclass=\"md-raised md-primary md-hue-2\" aria-label=\"save\" ng-disabled=\"vm.status==\'0\' || vm.status==\'1\'\"><span \ntranslate=\"ONBOARDING.ACTION.SAVEASDRAF\">Save</span></md-button><md-button type=\"button\" \nng-click=\"vm.processLearning($event,\'submit\')\" class=\"md-raised md-primary md-hue-2\" aria-label=\"submit\" \nng-disabled=\"vm.status==\'0\' || vm.status==\'1\'\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button><md-button \ntype=\"button\" ng-click=\"vm.processLearning($event,\'completed\')\" class=\"md-raised md-primary md-hue-2\" \naria-label=\"submit\" ng-disabled=\"vm.readyToRead\"><span translate=\"ONBOARDING.TABLE.COMPLETED\">Completed</span>\n</md-button></div></div></md-content></div></div></div></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-ojt-discussion/onboarding-ojt-discussion-form.html","<md-dialog aria-label=\"View Detail\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmDiscussion\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmDiscussion)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"ONBOARDING.HEADER.DISCUSSION\"></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><div layout-gt-sm=\"column\">\n<md-input-container flex flex-gt-sm><label translate=\"ONBOARDING.TABLE.ROLE\"></label><input type=\"text\" \nng-model=\"vm.role\" name=\"role\" required><div ng-messages=\"frmDiscussion.role.$error\" role=\"alert\"><div \nng-message=\"required\"><span>This field is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"column\"><md-input-container flex flex-gt-sm><label translate=\"ONBOARDING.TABLE.SKILL\"></label><input \ntype=\"text\" ng-model=\"vm.skill\" name=\"skill\" required><div ng-messages=\"frmDiscussion.skill.$error\" role=\"alert\"><div \nng-message=\"required\"><span>This field is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"column\"><md-input-container flex flex-gt-sm><label translate=\"ONBOARDING.TABLE.ACTIONPLAN\"></label><input\n type=\"text\" ng-model=\"vm.actionplan\" name=\"actionplan\" required><div ng-messages=\"frmDiscussion.actionplan.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>This field is required.</span></div></div></md-input-container></div><div\n layout-gt-sm=\"column\"><md-input-container flex flex-gt-sm><label translate=\"ONBOARDING.TABLE.RESULT\"></label><textarea\n rows=\"3\" ng-model=\"vm.result\" name=\"result\" ng-required=\"true\"></textarea><div \nng-messages=\"frmDiscussion.result.$error\" role=\"alert\"><div ng-message=\"required\"><span>This field is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\" flex=\"50\"><md-input-container flex flex-gt-sm><label \ntranslate=\"ONBOARDING.TABLE.TARGET\"></label><md-select ng-model=\"vm.targetdate\" aria-label=\"ONBOARDING.TABLE.TARGET\" \nname=\"target\" required><md-option ng-repeat=\"ls in vm.targetList\" placeholder=\"ONBOARDING.TABLE.TARGET\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"frmDiscussion.targetdate.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>This field is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmDiscussion.$invalid || frmDiscussion.$pristine\" translate=\"MENU.CB.GHK_HOLIDAY.FORM_INPUT.SAVE\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-ojt-discussion/onboarding-ojt-discussion.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-content \nclass=\"md-padding white-bg\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><fieldset><legend><a \nui-sref=\"app.app_onboarding\"><span class=\"l-color\">On-Boarding Overview</span></a> > <a \nui-sref=\"app.app_onboarding_ojt\"><span class=\"l-color\">OJT / On The Job</span></a> > <a><span class=\"l-color\">\n{{vm.subHeader}}</span></a></legend><label><b><span>Instructions</span></b></label><ol><li><span>\nHave you 1-on-1 session with your Direct Supervisor within the first week on your joining</span></li><li><span>\nKey in what you have discussed in the relevant fields</span></li><li><span>\nClick Submit when completed, no change can be made after that</span></li><li><span>\nCheck the Completion boxes once task are complete</span></li></ol></fieldset></div></md-content><div class=\"white-bg\">\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-mini md-raised\" hide show-gt-sm \nmd-colors=\"vm.disableAct ? {background: \'grey\'} : {background: \'green\',color: \'grey-A100\'}\" type=\"button\" \nng-disabled=\"vm.disableAct\" translate=\"ACTION.ADD\" ng-click=\"vm.Input($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.ADD\">New</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.ADD\">New\n</span></md-button><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm \nmd-colors=\"vm.disableAct ? {background: \'grey\'} : {background: \'blue\', color: \'grey-A100\'}\" type=\"button\" \nng-disabled=\"vm.disableAct\" translate=\"ACTION.SUBMIT\" ng-click=\"vm.submitData($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.SUBMIT\">\nSubmit</span></md-button><md-button class=\"light-blue\" hide show-gt-sm type=\"button\" translate=\"ONBOARDING.JOBDES\" \nng-click=\"vm.jobdes($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ONBOARDING.JOBDES\">Job Dscriptions</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ONBOARDING.JOBDES\">Job Dscriptions</span>\n</md-button><md-button ng-if=\"vm.isComment\" class=\"light-blue\" hide show-gt-sm type=\"button\" \nng-click=\"vm.viewComment($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Reject Comment\n</span></md-tooltip><span>Reject Comment</span></md-button></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><th width=\"5%\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\">\n<span class=\"column-title\" translate=\"ONBOARDING.TABLE.ROLE\">Role</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.SKILL\">Skill Required</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.ACTIONPLAN\">Action Plan</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.RESULT\">Result</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.TARGETDATE\">Target Date</span></th><th width=\"5%\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.listData\" \nng-dblclick=\"!vm.disableAct ? vm.editData($event,item) : \'\'\"><td class=\"text-center\">{{($index + 1)}}</td><td \nclass=\"text-center\">{{item.roles}}</td><td class=\"text-center\">{{item.skill_required}}</td><td class=\"text-center\">\n{{item.action_plan}}</td><td class=\"text-center\">{{item.result}}</td><td class=\"text-center\">{{item.target_date}}</td>\n<td class=\"text-center\"><section ng-if=\"!vm.disableAct\" layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"!vm.disableAct\"><md-button ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex><span translate=\"ACTION.EDIT\"></span></p></div>\n</md-button><md-button ng-click=\"vm.deleteData($event, item.id)\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-delete\"></md-icon><p flex><span translate=\"ACTION.DELETE\"></span></p></div></md-button>\n</md-menu-item></md-menu-content></md-menu></section></td></tr><tr ng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"ONBOARDING.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/onboarding/onboarding-ojt-discussion/onboarding-ojt-jobdes.html","<md-dialog aria-label=\"View Detail\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"90\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Job Descriptions</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"column\" layout-fill class=\"content padding\"><md-content class=\"content padding\" layout-fill>\n<div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><br><fieldset class=\"white-bg\"><legend><a><span class=\"l-color\">\nWhy Does This Position Exist ?</span></a></legend><p>{{vm.whyDoes}}</p></fieldset><br><fieldset class=\"white-bg\">\n<legend><a><span class=\"l-color\">What Can Be Expected From This Position For The Organization ?</span></a></legend><p>\n{{vm.whatCan}}</p></fieldset><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><th \nclass=\"text-left\"><span class=\"column-title\">Area of Responsibility</span><br><span class=\"sub-title\">\nDescribe the nature, scope, level of improvements to new ideas, etc.</span></th><th class=\"text-left\"><span \nclass=\"column-title\">Level</span><br><span class=\"sub-title\">Full, Partial, Supportive</span></th><th \nclass=\"text-left\"><span class=\"column-title\">Measurement</span><br><span class=\"sub-title\">\nQuantitative or qualitaty criteria to archieve responsibility</span></th></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.listData\"><td class=\"text-left\">{{item.area}}</td><td \nclass=\"text-center\">{{item.level}}</td><td class=\"text-left\">{{item.measurement}}</td></tr><tr \nng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"ONBOARDING.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table></md-content></div></div></md-content></div></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-orientation/onboarding-orientation.html","<div class=\"page-layout simple fullwidth\"><div class=\"content\" style=\"padding: 0px\"><div ng-cloak><md-content \nclass=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><fieldset class=\"white-bg\"><legend><a \nui-sref=\"app.app_onboarding\"><span class=\"l-color\">On-Boarding Overview</span></a> > <a \nui-sref=\"app.app_onboarding_orientation\"><span class=\"l-color\">Orientation</span></a></legend><p>\nHello! Wish another great day for you!<br>\nIn this section, you have to complete the program by learn all information that is provided. Please notice that you only have 30 days since your first day to complete your learning process.\n</p></fieldset></div></md-content><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex \nlayout=\"column\"><md-card class=\"white-bg\"><md-card-title><md-card-title-text><div class=\"simple-table-container\" hide \nshow-gt-sm><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar stripped upper-case-header\" ms-responsive-table><thead><tr><th width=\"5%\">\n<span class=\"column-title\" translate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.ORIENTATION\">Orientation Overview</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.COMPLETED\">Completed</span></th><th \nwidth=\"15%\" class=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.DATE\">Date</span></th></tr>\n</thead><tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.listInput\"><td class=\"text-center\">\n{{($index + 1)}}</td><td><span><a href=\"\" ng-click=\"vm.viewDetail(item,$event)\">{{item.subject}}</a><p>\n{{item.description}}</p></span></td><td class=\"text-center\"><md-checkbox aria-label=\"empLaborChecked\" \nng-disabled=\"true\" ng-checked=\"item.is_complete\"></md-checkbox></td><td class=\"text-center\">{{item.completed_at}}</td>\n</tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"ONBOARDING.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></div></div>\n</md-card-title-text></md-card-title></md-card></div></md-content></div></div></div>");
$templateCache.put("app/main/onboarding/onboarding-orientation/view-detail.html","<md-dialog aria-label=\"View Detail\" md-theme=\"modal-theme\" flex-md=\"80\" flex-gt-md=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ONBOARDING.TABLE.VIEW\">View Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-fill class=\"content padding\"><div \nclass=\"md-whiteframe-2dp\"><h1>Isi Halaman Detail</h1></div></div></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-orientation-detail/onboarding-orientation-detail.html","<div class=\"page-layout simple fullwidth\"><div class=\"content\" style=\"padding: 0px\"><div ng-cloak><md-content \nclass=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><fieldset class=\"white-bg\"><legend><a \nui-sref=\"app.app_onboarding\" class=\"l-color\"><span class=\"l-color\">On-Boarding Overview</span></a> > <a \nui-sref=\"app.app_onboarding_orientation\"><span class=\"l-color\">Orientation</span></a> > <a><span class=\"l-color\">\n{{vm.subHeader}}</span></a></legend><p>Hello! Wish another great day for you!<br>\nIn this section, you have to complete the program by learn all information that is provided. Please notice that you only have 30 days since your first day to complete your learning process.\n</p></fieldset></div></md-content><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex \nlayout=\"column\"><md-card class=\"white-bg\"><md-card-title><md-card-title-text><div class=\"simple-table-container\" hide \nshow-gt-sm><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar stripped upper-case-header\" ms-responsive-table><thead><tr><th width=\"5%\">\n<span class=\"column-title\" translate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.ORIENTATION\">Orientation Overview</span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.COMPLETED\">Completed</span></th><th \nwidth=\"15%\" class=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.DATE\">Date</span></th></tr>\n</thead><tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.listInput\"><td class=\"text-center\">\n{{($index + 1)}}</td><td><span><a href=\"\" ng-click=\"vm.viewDetail(item,$event)\">{{item.subject}}</a><p>\n{{item.description}}</p></span></td><td class=\"text-center\"><md-checkbox aria-label=\"empLaborChecked\" \nng-disabled=\"true\" ng-checked=\"item.is_complete==1\"></md-checkbox></td><td class=\"text-center\">{{item.completed_at}}\n</td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"ONBOARDING.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></div></div>\n</md-card-title-text></md-card-title></md-card><div class=\"container\"><form name=\"formSubmitOrientation\" \nng-submit=\"vm.submitData($event, formSubmitOrientation)\" novalidate flex><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" class=\"md-raised md-primary md-hue-2\" aria-label=\"Submit\" ng-disabled=\"vm.isComplete\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></div></div></md-content></div></div></div>");
$templateCache.put("app/main/onboarding/onboarding-resource-category/onboarding-resource-category-form.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Resource Category Form</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label>Title</label><input\n type=\"text\" ng-model=\"vm.title\" name=\"title\" ng-disabled=\"vm.disableTitle\" required><div \nng-messages=\"frmBT.title.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"HC_NEWS.ERROR.TITLE\">\nTitle field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><md-select ng-model=\"vm.type\" aria-label=\"type\" name=\"type\" ng-disabled=\"vm.hasChild\" \nng-required=\"!vm.hasChild\"><md-option ng-repeat=\"ls in vm.listType\" placeholder=\"Type\" value=\"{{ls.slug}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"frmBT.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nType field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><div style=\"padding: 7px\"><label>Description</label><textarea rows=\"3\" ng-model=\"vm.description\" \nname=\"description\" ng-required=\"false\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Description field is required.</span></div></div></md-input-container><input name=\"image\" \ntype=\"file\" id=\"upload\" style=\"display:none\" onchange=\"\"></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-resource-category/onboarding-resource-category.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-content \nclass=\"md-padding white-bg\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"></div></md-content><div \nclass=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">\n&nbsp;Entries</span><div ng-if=\"vm.admin\" class=\"divider-vertical\" hide show-gt-sm></div><md-button ng-if=\"vm.admin\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span>New</span></md-button><div\n ng-if=\"vm.admin\" class=\"divider-vertical\" hide show-gt-sm></div><md-button ng-if=\"vm.admin\" class=\"md-warn md-mini\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.selected.length == 0\" \nng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\">\n</md-icon><md-icon ng-if=\"vm.selected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> <span ng-if=\"vm.selected.length == 0\" \nclass=\"grey-700-fg\">Delete</span> <span ng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} selected</span>\n</md-button></div></md-toolbar><md-content style=\"background:white\" hide-gt-sm><span flex=\"5\"></span><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nng-if=\"vm.admin\" width=\"2%\"><span class=\"is-gear\"></span></th><th width=\"5%\"><span class=\"column-title\" \ntranslate=\"HC_NEWS.TABLE.NO\">NO</span></th><th class=\"text-center\"><span class=\"column-title\">Title</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Description</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Type</span></th><th class=\"text-center\" width=\"15%\"><span class=\"column-title\">Created By</span>\n</th><th class=\"text-center\"><span class=\"column-title\" width=\"5%\">Date</span></th><th width=\"3%\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td ng-if=\"vm.admin\"><md-checkbox \nng-if=\"item.hasChild==0\" aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td>\n{{item.item_name}}</td><td>{{item.description}}</td><td class=\"text-center\">{{item.type}}</td><td class=\"text-center\">\n{{item.name!=null ? item.name : \'System\'}}</td><td class=\"text-center\">{{item.uploaded_at}}</td><td \nclass=\"text-center\"><section layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"\"><md-button aria-label=\"emplabortypemenu\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content><md-menu-item><md-button ng-if=\"vm.admin\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><p flex>Edit</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/onboarding/onboarding-resource-category/onboarding-view-detail.html","<md-dialog aria-label=\"Form Update Finger Data\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"80\"><form \nng-cloak class=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>View Document</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-content ng-if=\"vm.doc_type\" class=\"md-background-bg has-upload\" id=\"contentDialog\"><iframe \nsrc=\"{{vm.url}}\" style=\"width:100%; height:100vh\" frameborder=\"0\"></iframe></md-content></form></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-review/onboarding-review.html","<div class=\"page-layout simple fullwidth\"><div class=\"content\" style=\"padding: 0px\"><div ng-cloak><md-content \nclass=\"md-padding white-bg\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><fieldset><legend><a \nui-sref=\"app.app_onboarding\" class=\"l-color\"><span class=\"l-color\">On-Boarding Overview</span></a> > <a \nng-if=\"!vm.employee\" ui-sref=\"app.app_onboarding_summary\"><span class=\"l-color\">Summary</span></a> <span \nng-if=\"!vm.employee\">></span> <a><span class=\"l-color\">{{vm.subHeader}}</span></a></legend><label><b><span>Rating Scale\n</span></b></label><ol><li><span>Far Below Standard/ Expectation</span></li><li><span>Below Standard/ Expectation\n</span></li><li><span>Meet Standard/ Expectation</span></li><li><span>Above Standard/ Expectation</span></li><li><span>\nFar Above Standard/ Expectation</span></li></ol></fieldset></div></md-content><div class=\"white-bg\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div flex layout=\"column\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.ITEM\">ITEM</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.SCORE\">Score</span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.listInput\"><td class=\"text-center\">{{($index + 1)}}</td><td><span>{{item.description}}</span>\n</td><td class=\"text-center\"><md-radio-group ng-model=\"vm.score[item.id]\" name=\"score_{{ item.id }}\" layout=\"row\" \nng-disabled=\"vm.isComplete\"><md-radio-button ng-value=\"1\">1</md-radio-button><md-radio-button ng-value=\"2\">2\n</md-radio-button><md-radio-button ng-value=\"3\">3</md-radio-button><md-radio-button ng-value=\"4\">4</md-radio-button>\n<md-radio-button ng-value=\"5\">5</md-radio-button></md-radio-group></td></tr><tr ng-if=\"vm.DataTables.list.length <= 0\">\n<td colspan=\"8\" class=\"text-center\"><span translate=\"ONBOARDING.TABLE.NO_DATA\">No Data Available</span></td></tr>\n</tbody></table><md-toolbar><div class=\"md-toolbar-tools table-tools white-bg\"><md-button class=\"md-mini md-raised\" \nhide show-gt-sm md-colors=\"vm.isComplete ? {background: \'grey\'} : {background: \'green\',color: \'grey-A100\'}\" \ntype=\"button\" ng-click=\"vm.saveData($event)\" ng-disabled=\"vm.isComplete\" translate=\"ONBOARDING.ACTION.SAVEASDRAF\" \nng-click=\"vm.Input($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ONBOARDING.ACTION.SAVEASDRAF\">SAVE</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ONBOARDING.ACTION.SAVEASDRAF\">SAVE</span>\n</md-button><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm \nmd-colors=\"vm.isComplete ? {background: \'grey\'} : {background: \'blue\', color: \'grey-A100\'}\" type=\"button\" \nng-disabled=\"vm.isComplete\" translate=\"ACTION.SUBMIT\" ng-click=\"vm.submitData($event, \'spv\')\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"ACTION.SUBMIT\">\nSubmit</span></md-button></div></md-toolbar></div></md-content></div><md-content class=\"md-padding white-bg\" \nlayout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><div><h2><span class=\"{{vm.color}}\">Score: {{vm.totalPoint}}\n</span></h2><h3>{{vm.result}} <span class=\"{{vm.txColor}}\">{{vm.addResult}}</span></h3></div><fieldset><legend><a><span\n class=\"l-color\">Overall Review</span></a></legend><canvas id=\"radar\" class=\"chart chart-radar chart-review\" \nchart-data=\"vm.chartData\" chart-series=\"vm.series\" chart-colors=\"vm.chartColors\" chart-options=\"vm.options\" \nchart-labels=\"vm.chartLabels\"></canvas></fieldset><div class=\"md-toolbar-tools table-tools white-bg\"><md-button \nng-if=\"vm.admin\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \nmd-colors=\"vm.isConfirm ? {background: \'grey\'} : {background: \'blue\', color: \'grey-A100\'}\" type=\"button\" \nng-disabled=\"vm.isConfirm\" translate=\"ACTION.CONFIRM\" ng-click=\"vm.submitData($event, \'admin\')\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.CONFIRM\">Confirm</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"ACTION.CONFIRM\">Confirm</span></md-button></div></div></md-content></div></div></div>");
$templateCache.put("app/main/onboarding/onboarding-review/view-detail.html","<md-dialog aria-label=\"View Detail\" md-theme=\"modal-theme\" flex-md=\"80\" flex-gt-md=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ONBOARDING.TABLE.VIEW\">View Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><div layout=\"column\" layout-fill class=\"content padding\"><div \nclass=\"md-whiteframe-2dp\"><h1>Isi Halaman Detail</h1></div></div></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-summary/completeness.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex=\"80\"><form class=\"md-inline-form popup-input-form\" \nname=\"frmBT\" novalidate flex><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"ACTION.COMPLATENESS\">COMPLATENESS</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><div layout=\"column\" \nflex=\"50\"><fieldset style=\"min-height: 550px;overflow-y: scroll\"><legend>First Days List</legend><div class=\"row\"><div \nclass=\"col-lg-2\"><ul><li ng-repeat=\"item in vm.firstdayList\"><input ng-disabled=\"true\" type=\"checkbox\" \nng-model=\"item.selected\"> {{item.name}}<ul><li ng-repeat=\"row in item.child\"><input type=\"checkbox\" ng-disabled=\"true\" \nng-model=\"row.selected\"> {{row.name}}</li></ul></li></ul></div></div></fieldset></div><div layout=\"column\" flex=\"50\">\n<fieldset style=\"height: 550px;overflow-y: scroll\"><legend>Orientations List</legend><div class=\"row\"><div \nclass=\"col-lg-2\"><ul><li ng-repeat=\"item in vm.orientationList\"><input ng-disabled=\"true\" type=\"checkbox\" \nng-model=\"item.selected\"> {{item.name}}<ul><li ng-repeat=\"row in item.child\"><input type=\"checkbox\" ng-disabled=\"true\" \nng-model=\"row.selected\"> {{row.name}}</li></ul></li></ul></div></div></fieldset></div></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-summary/detail-reviewer.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Reviewer List</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"\">NIK/NAME</th><th class=\"text-center\">Type</th><th width=\"3\" \nclass=\"text-center\">Is Reviewed</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.items\"><td class=\"text-left\">\n{{ls.nik}}/{{ls.name}}</td><td class=\"text-left\">{{ls.type}}</td><td class=\"text-center\"><md-icon \nng-if=\"ls.is_completed!=null\" class=\"md-primary\" md-font-icon=\"icon-check\"></md-icon></td></tr></tbody></table>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-summary/onboarding-summary.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-content \nclass=\"md-padding white-bg\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><fieldset><legend><a \nui-sref=\"app.app_onboarding\"><span class=\"l-color\">On-Boarding Overview</span></a> > <a><span class=\"l-color\">Summary\n</span></a></legend><p>\nThis is an overview of the completion progress of your new employees. Click on pending to view new learning progress and provide your comments\n</p><p>*pending : pending superordinate feedback</p></fieldset></div></md-content><div class=\"white-bg\"><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button ng-if=\"vm.admin\" aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" hide show-gt-sm \nng-click=\"vm.Export()\"><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">Download</md-tooltip>Download <span \nflex hide show-gt-sm></span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\" rowspan=\"3\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.NO\">No</span></th><th \nclass=\"text-center\" rowspan=\"3\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.NAME\">Name</span></th><th \nclass=\"text-center\" rowspan=\"3\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.DIRECTSPV\">Direct Supervisor\n</span></th><th class=\"text-center\" rowspan=\"3\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.JOINDATE\">\nJoin Date</span></th><th class=\"text-center\" rowspan=\"3\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.DAYS\">\nDays</span></th><th class=\"text-center\" colspan=\"7\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.COMPRETIONPROG\">Completion Progress</span></th><th class=\"text-center\" rowspan=\"3\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.REVIEW\">Review</span></th></tr><tr><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.FIRSTDAY\">First Day</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.ORIENTATIONP\">Orientation</span>\n</th><th class=\"text-center\" colspan=\"4\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.OJT\">OJT</span></th>\n</tr><tr><th class=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.1ON1\">1 on 1</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.30DAY\">30 Dyas</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.60DAY\">60 Dyas</span></th><th \nclass=\"text-center\"><span class=\"column-title\" translate=\"ONBOARDING.TABLE.90DAY\">90 Dyas</span></th></tr></thead>\n<tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.DataTable.list\"><td class=\"text-center\">{{($index + 1)}}\n</td><td>{{item.name}}</td><td>{{item.spv_name}}</td><td class=\"text-center\">{{item.join_date}}</td><td \nclass=\"text-center\">{{item.day}}</td><td class=\"text-center\"><span>{{ item.first_day!=null ? item.first_day : \'0\'}}%\n</span></td><td class=\"text-center\"><span>{{ item.orientation!=null ? item.orientation : \'0\'}}%</span></td><td \nclass=\"text-center\"><span>{{ item.oneonone!=null ? item.oneonone : \'0\'}}%</span></td><td class=\"text-center\"><span \nng-if=\"!vm.admin&&item.thirtycomment==0&&item.thirtyday!=null\"><a href=\"\" \nng-click=\"vm.viewDetail(\'30day\',item,$event)\">Pending</a> </span><span \nng-if=\"vm.admin&&item.thirtycomment==0&&item.thirtyday!=null\"><a href=\"\" ng-click=\"vm.viewDetail(\'30day\',item,$event)\">\n<span class=\"red\">{{item.thirtyday}}%</span></a> </span><span ng-if=\"item.thirtycomment==1&&item.thirtyday!=null\"><a \nhref=\"\" ng-click=\"vm.viewDetail(\'30day\',item,$event)\">{{item.thirtyday}}%</a></span> <span \nng-if=\"item.thirtycomment==0&&item.thirtyday==null || item.thirtycomment==1&&item.thirtyday==null\">0%</span></td><td \nclass=\"text-center\"><span ng-if=\"!vm.admin&&item.sixtycomment==0&&item.sixtyday!=null\"><a href=\"\" \nng-click=\"vm.viewDetail(\'60day\',item,$event)\">Pending</a> </span><span \nng-if=\"vm.admin&&item.sixtycomment==0&&item.sixtyday!=null\"><a href=\"\" ng-click=\"vm.viewDetail(\'60day\',item,$event)\">\n<span class=\"red\">{{item.sixtyday}}%</span></a> </span><span ng-if=\"item.sixtycomment==1&&item.sixtyday!=null\"><a \nhref=\"\" ng-click=\"vm.viewDetail(\'60day\',item,$event)\">{{item.sixtyday}}%</a></span> <span \nng-if=\"item.sixtycomment==0&&item.sixtyday==null || item.sixtycomment==1&&item.sixtyday==null\">0%</span></td><td \nclass=\"text-center\" colspan=\"2\"><span ng-if=\"!vm.admin&&item.ninetycomment==0&&item.ninetyday!=null\"><a href=\"\" \nng-click=\"vm.viewDetail(\'90day\',item,$event)\">Pending</a> </span><span \nng-if=\"vm.admin&&item.ninetycomment==0&&item.ninetyday!=null\"><a href=\"\" ng-click=\"vm.viewDetail(\'90day\',item,$event)\">\n<span class=\"red\">{{item.ninetyday}}%</span></a> </span><span ng-if=\"item.ninetycomment==1&&item.ninetyday!=null\"><a \nhref=\"\" ng-click=\"vm.viewDetail(\'90day\',item,$event)\">{{item.ninetyday}}%</a></span> <span \nng-if=\"item.ninetycomment==0&&item.ninetyday==null || item.sixtycomment==1&&item.sixtyday==null\">0%</span></td><td \nclass=\"text-center\"><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm \nmd-colors=\"{background: \'blue\', color: \'grey-A100\'}\" type=\"button\" ng-click=\"vm.completeness(item.register_id)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.COMPLATENESS\">COMPLATENESS</span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-account-check\"></md-icon></md-button><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm md-colors=\"{background: \'grey\'}\" type=\"button\" \nng-if=\"!((item.thirtycomment==1&&item.thirtyday!=null) && (item.sixtycomment==1&&item.sixtyday!=null) && (item.ninetycomment==1&&item.ninetyday!=null))\">\n<md-tooltip md-direction=\"down\"><span translate=\"ACTION.REVIEW\">Review</span></md-tooltip><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon></md-button><md-button class=\"md-mini md-raised md-primary\" \nhide show-gt-sm md-colors=\"{background: \'blue\', color: \'grey-A100\'}\" type=\"button\" \nng-if=\"((item.thirtycomment==1&&item.thirtyday!=null) && (item.sixtycomment==1&&item.sixtyday!=null) && (item.ninetycomment==1&&item.ninetyday!=null))\" \nng-click=\"vm.review($event,item.register_id)\"><md-tooltip md-direction=\"down\"><span translate=\"ACTION.REVIEW\">Review\n</span></md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon></md-button><md-button \nng-if=\"vm.admin && ((item.thirtycomment==1&&item.thirtyday!=null)&&(item.sixtycomment==1&&item.sixtyday!=null)&&(item.ninetycomment==1&&item.ninetyday!=null)) && item.is_confirm==1\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm md-colors=\"{background: \'blue\', color: \'grey-A100\'}\" \ntype=\"button\" ng-click=\"vm.review($event,item.register_id)\">100%<md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>100%</span></md-tooltip></md-button><md-button \nng-if=\"vm.admin&&((item.thirtycomment==1&&item.thirtyday!=null)&&(item.sixtycomment==1&&item.sixtyday!=null)&&(item.ninetycomment==1&&item.ninetyday!=null)) && (item.is_confirm==0||item.is_confirm==null) && (item.isreview==1)\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm md-colors=\"{background: \'purple\', color: \'grey-A100\'}\" \ntype=\"button\" ng-click=\"vm.review($event,item.register_id)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"ACTION.CONFIRM\">Confirm</span></md-tooltip><md-icon md-menu-align-target \nmd-font-icon=\"icon-bookmark-check\"></md-icon></md-button><md-button ng-if=\"vm.admin\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" ng-click=\"vm.reviewer($event,item.register_id)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"ACTION.REVIEWER\">Reviewer</span>\n</md-tooltip><md-icon md-menu-align-target md-font-icon=\"icon-account\"></md-icon></md-button></td></tr></tbody></table>\n<div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/onboarding/onboarding-summary/view-learning.html","<md-dialog aria-label=\"View Detail\" md-theme=\"modal-theme\" flex-md=\"80\" flex-gt-md=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{vm.header}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><div layout=\"column\" layout-fill class=\"content padding\"><div class=\"content\" style=\"padding: 0px\"><div \nng-cloak><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><md-card>\n<md-card-title><md-card-title-text><span class=\"md-subhead\"><label><span>\nPlease complete the following fields based on what you have gone through in the month. no further changes can be made once Submit is clicked.\n</span></label><br><br><label><span><b>New Commers:</b> {{ vm.empName }}</span></label><br><label><span><b>\nSuperordinate:</b> {{ vm.superordinate }}</span></label><br><label><span><b>Peer:</b> {{ vm.spvName }}</span></label>\n<br><label><span><b>Subordinate:</b> {{ vm.subordinate }}</span></label></span></md-card-title-text></md-card-title>\n</md-card></div></md-content><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><th width=\"5%\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.ROLE\">Role</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.SKILL\">Skill Required</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.ACTIONPLAN\">Action Plan</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.RESULT\">Result</span></th></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.discussionList\"><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">\n{{item.roles}}</td><td class=\"text-center\">{{item.skill_required}}</td><td class=\"text-center\">{{item.action_plan}}\n</td><td class=\"text-center\">{{item.result}}</td></tr><tr ng-if=\"vm.discussionList.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"ONBOARDING.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table>\n</md-content><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><md-card>\n<md-card-title><md-card-title-text><div class=\"simple-table-container\" hide show-gt-sm><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"fullwidth-table simple with-toolbar upper-case-header\" \nms-responsive-table><tbody><tr><td colspan=\"3\" class=\"grey\"><span class=\"t-color\">1. {{vm.qs1}}</span></td></tr><tr \nclass=\"md-table-content-row\"><td><textarea rows=\"3\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.ans1\" \nng-disabled=\"true\"></textarea></td></tr></tbody></table></div><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar upper-case-header\" ms-responsive-table><tbody><tr><td colspan=\"3\" \nclass=\"grey\"><span class=\"t-color\">2. {{vm.qs2}}</span></td></tr><tr class=\"md-table-content-row\"><td><textarea \nrows=\"3\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.ans2\" ng-disabled=\"true\"></textarea></td></tr></tbody></table>\n</div><div class=\"ms-responsive-table-wrapper\"><table class=\"fullwidth-table simple with-toolbar upper-case-header\" \nms-responsive-table><tbody><tr><td colspan=\"3\" class=\"grey\"><span class=\"t-color\">3. {{vm.qs3}}</span></td></tr><tr \nclass=\"md-table-content-row\"><td><textarea rows=\"3\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.ans3\" \nng-disabled=\"true\"></textarea></td></tr></tbody></table></div><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar upper-case-header\" ms-responsive-table><tbody><tr><td colspan=\"3\" \nclass=\"grey\"><span class=\"t-color\">4. {{vm.qs4}}</span></td></tr><tr class=\"md-table-content-row\"><td><textarea \nrows=\"3\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.ans4\" ng-disabled=\"true\"></textarea></td></tr></tbody></table>\n</div><div class=\"ms-responsive-table-wrapper\"><table class=\"fullwidth-table simple with-toolbar upper-case-header\" \nms-responsive-table><tbody><tr><td colspan=\"3\" class=\"grey text-center\"><span class=\"t-color\">Superordinate Feedback\n</span></td></tr><tr class=\"md-table-content-row\"><td><textarea rows=\"3\" ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.spvComment\" ng-disabled=\"!vm.isSuperordinate\"></textarea></td></tr></tbody></table></div></div>\n</md-card-title-text></md-card-title></md-card><div class=\"container\"><md-button \nng-if=\"vm.isSuperordinate&&vm.status==\'0\'\" type=\"button\" ng-click=\"vm.processLearning($event,\'commentLearning\')\" \nclass=\"md-raised md-primary md-hue-2\" aria-label=\"save\" ng-disabled=\"vm.isComplete\"><span \ntranslate=\"ONBOARDING.ACTION.SAVEASDRAF\">Save</span></md-button><md-button ng-if=\"vm.isSuperordinate&&vm.status==\'0\'\" \ntype=\"button\" ng-click=\"vm.processLearning($event,\'submitComment\')\" class=\"md-raised md-primary md-hue-2\" \naria-label=\"submit\" ng-disabled=\"vm.isComplete\"><span translate=\"ACTION.APPROVE\">Approve</span></md-button><md-button \nng-if=\"vm.isSuperordinate&&vm.status==\'0\'\" type=\"button\" \nng-click=\"vm.processLearning($event,\'submitComment\',\'reject\')\" class=\"md-raised md-warn md-hue-2\" aria-label=\"submit\" \nng-disabled=\"vm.isComplete\"><span translate=\"ACTION.REJECT\">Reject</span></md-button></div></div></md-content></div>\n</div></div></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-tutorial/oboarding-tutorial-view.html","<md-dialog aria-label=\"Form Update Finger Data\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"75\"><form \nng-cloak class=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-content ng-if=\"vm.doc_type\" class=\"md-background-bg has-upload\" id=\"contentDialog\"><iframe \nsrc=\"{{vm.url}}\" style=\"width:100%; height:85vh\" frameborder=\"0\"></iframe></md-content><md-dialog-content \nng-if=\"vm.images\"><img style=\"display: block;margin-left: auto;margin-right: auto;width: 100%; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/onboardingdocument/{{vm.doc}}\"></md-dialog-content><video ng-show=\"vm.video_type\" \nwidth=\"100%\" controls autoplay><source src=\"{{vm.url}}\" type=\"video/mp4\"></video></form></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-tutorial/tutorial.html","<div id=\"page_talent\" class=\"page-layout simple fullwidth\"><div class=\"header header-talent md-accent-bg\"><span \nclass=\"md-display-1 font-weight-300\">Tutorial</span></div><div class=\"content\"><div layout-xs=\"column\" layout=\"row\">\n<md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"32\" layout=\"column\" \nng-repeat=\"tutorial in vm.tutorialList\"><md-card><img ng-src=\"{{\'assets/images/\'+tutorial.cover}}\" \nclass=\"md-card-image\" alt=\"Onboarding Images\"><md-card-title><md-card-title-text style=\"cursor: pointer; height:64px\">\n<span ng-click=\"vm.viewDetail($event,tutorial)\" class=\"md-headline blue-800-fg\" style=\"font-size: 17px !important\">\n{{tutorial.title}}</span></md-card-title-text></md-card-title><md-card-actions layout=\"row\" layout-align=\"end center\">\n<md-button class=\"blue-800-fg\" ng-click=\"vm.viewDetail($event,tutorial)\">View</md-button></md-card-actions></md-card>\n</div></md-content></div></div></div>");
$templateCache.put("app/main/onboarding/onboarding-tutorial/view-tutorial.html","<div id=\"page_talent\" class=\"page-layout simple fullwidth\"><div class=\"header header-talent md-accent-bg\"><span \nclass=\"md-display-1 font-weight-300\">Tutorial</span></div><div class=\"content\"><div layout-xs=\"column\" layout=\"row\">\n<div ng-if=\"vm.tutorial_type === \'video\'\" flex-xs flex-gt-xs=\"50\" layout=\"column\"><h3>Man Power Need Tutorial Video\n</h3><video class=\"tutorial\" controls=\"\" name=\"media\"><source src=\"{{vm.url}}\" type=\"video/mp4\">\nYour browser does not support the video tag.</video></div><div ng-if=\"vm.tutorial_type === \'ebook\'\" flex-xs \nflex-gt-xs=\"100\" layout=\"column\"><iframe src=\"{{vm.url}}\" style=\"width:100%; height:80vh\" frameborder=\"0\"></iframe>\n</div></div></div></div>");
$templateCache.put("app/main/onboarding/onboarding-upload-resource/onboarding-upload-resource-form.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Resource Form</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div \nlayout=\"row\"><md-input-container flex flex-gt-sm><label>Title</label><input type=\"text\" ng-model=\"vm.title\" \nname=\"title\" required><div ng-messages=\"frmBT.title.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HC_NEWS.ERROR.TITLE\">Title field is required.</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex flex-gt-sm><md-select ng-model=\"vm.type\" aria-label=\"type\" name=\"type\" \nng-change=\"vm.hide(vm.type)\" ng-disabled=\"vm.disabled\" ng-required=\"!vm.disabled\"><md-option \nng-repeat=\"ls in vm.listType\" placeholder=\"Type\" value=\"{{ls.slug}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmBT.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Type field is required.</span></div>\n</div></md-input-container></div><div ng-if=\"vm.isCategory\" layout=\"row\"><md-input-container flex flex-gt-sm><md-select\n ng-model=\"vm.category\" aria-label=\"category\" name=\"category\" required><md-option ng-repeat=\"ls in vm.listCategory\" \nplaceholder=\"Category\" value=\"{{ls.id}}\">{{ls.category_name}}</md-option></md-select><div \nng-messages=\"frmBT.category.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"HC_NEWS.ERROR.CATEGORY\">\nCategory field is required.</span></div></div></md-input-container></div><div ng-if=\"vm.show && vm.dashboard\" \nlayout=\"row\"><md-content layout=\"column\" class=\"_md layout-column\"><md-input-container class=\"\"><input \naccept=\"application/pdf\" name=\"uploadFile\" type=\"file\" nv-file-select=\"\" uploader=\"vm.uploader\" \noptions=\"{ formData: [{  \n                                        title:vm.title,\n                                        category:vm.category\n                                      }]}\" \nrequired><div class=\"md-errors-spacer\"></div><div ng-messages=\"frmBT.uploadFile.$error\" role=\"alert\"><div \nng-message=\"required\"><span>File field is required.</span></div></div></md-input-container><md-progress-linear \nmd-mode=\"determinate\" value=\"0\" class=\"md-accent hue-2 md-nabati1-theme\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" aria-valuenow=\"0\"><div class=\"md-container md-mode-determinate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\" style=\"transform: translateX(-50%) scale(0, 1)\"></div></div>\n</md-progress-linear></md-content></div><div ng-if=\"vm.show && vm.overview\" layout=\"row\"><md-input-container flex \nflex-gt-sm><div style=\"padding: 7px\"><label>Description</label><textarea rows=\"3\" ng-model=\"vm.description\" \nname=\"description\" ng-required=\"false\"></textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Description field is required.</span></div></div></md-input-container><input name=\"image\" \ntype=\"file\" id=\"upload\" style=\"display:none\" onchange=\"\"></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-upload-resource/onboarding-upload-resource.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-content \nclass=\"md-padding white-bg\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"><fieldset><legend><a \nui-sref=\"app.app_onboarding\"><span class=\"l-color\">On-Boarding Overview</span></a> > <a><span class=\"l-color\">Resource\n</span></a></legend><p>\nHello new employee, because we believe that learning is for everyone, in this section you can download all resources & materials that you may need to help you learn and adapt in our company. Happy download!\n</p></fieldset></div></md-content><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><select \nstyle=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;Entries</span><div ng-if=\"vm.admin\" class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button ng-if=\"vm.admin\" class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.addData($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New\n</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span>New</span></md-button><div ng-if=\"vm.admin\" class=\"divider-vertical\" hide show-gt-sm></div><md-button \nng-if=\"vm.admin\" class=\"md-warn md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} selected</span></md-button></div></md-toolbar><md-content style=\"background:white\" hide-gt-sm>\n<span flex=\"5\"></span><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th ng-if=\"vm.admin\" width=\"2%\"><span class=\"is-gear\"></span></th><th width=\"5%\"><span \nclass=\"column-title\" translate=\"HC_NEWS.TABLE.NO\">NO</span></th><th class=\"text-center\" width=\"15%\"><span \nclass=\"column-title\">Title</span></th><th class=\"text-center\"><span class=\"column-title\">Description</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Type</span></th><th class=\"text-center\" width=\"15%\"><span \nclass=\"column-title\">Created By</span></th><th class=\"text-center\"><span class=\"column-title\" width=\"5%\">Date</span>\n</th><th width=\"3%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody>\n<tr class=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td ng-if=\"vm.admin\"><md-checkbox \nng-if=\"item.type!=\'overview\' && item.type!=\'dashboard\'\" aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td>{{item.item_name}}</td><td>{{item.description}}</td><td \nclass=\"text-center\">{{item.type}}</td><td class=\"text-center\">{{item.name}}</td><td class=\"text-center\">\n{{item.uploaded_at}}</td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" \nclass=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"\"><md-button \naria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content><md-menu-item><md-button \nng-if=\"vm.nik==item.upload_by\" ng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div \nlayout=\"row\" flex><p flex>Edit</p></div></md-button><md-button ng-if=\"vm.nik==item.upload_by && item.file_path!=null\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewDetail($event, item)\"><div layout=\"row\" flex><p flex>View</p>\n</div></md-button><md-button ng-if=\"item.file_path!=null\" ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.download($event, item)\"><div layout=\"row\" flex><p flex>Download</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/onboarding/onboarding-upload-resource/onboarding-view-detail.html","<md-dialog aria-label=\"Form Update Finger Data\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"80\"><form \nng-cloak class=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>View Document</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-content ng-if=\"vm.doc_type\" class=\"md-background-bg has-upload\" id=\"contentDialog\"><iframe \nsrc=\"{{vm.url}}\" style=\"width:100%; height:90vh\" frameborder=\"0\"></iframe></md-content><md-dialog-actions \nng-if=\"vm.isOrientation\" layout=\"row\"><md-button type=\"button\" class=\"md-mini md-raised md-accent md-primary\" \nng-click=\"vm.processData()\" aria-label=\"Read\" ng-disabled=\"false\" translate=\"ONBOARDING.ACTION.READ\">Read</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-user-register/onboarding-user-register-form.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex=\"80\"><form class=\"md-inline-form popup-input-form\" \nname=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div\n class=\"md-toolbar-tools\"><h2>User Register Form</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\" ng-if=\"vm.isAdmin\">\n<div layout=\"column\" flex=\"50\"><fieldset style=\"min-height: 550px;overflow-y: scroll\"><legend>First Days List</legend>\n<div class=\"row\"><div class=\"col-lg-2\"><ul><li ng-repeat=\"item in vm.firstdayList\"><input type=\"checkbox\" \nng-model=\"item.selected\" ng-click=\"vm.clicker(item,\'firstday\')\"> {{item.name}}<ul><li ng-repeat=\"row in item.child\">\n<input type=\"checkbox\" ng-click=\"vm.clicker(row,\'firstday\')\" ng-model=\"row.selected\"> {{row.name}}</li></ul></li></ul>\n</div></div></fieldset></div><div layout=\"column\" flex=\"50\"><fieldset style=\"height: 550px;overflow-y: scroll\"><legend>\nOrientations List</legend><div class=\"row\"><div class=\"col-lg-2\"><ul><li ng-repeat=\"item in vm.orientationList\"><input \ntype=\"checkbox\" ng-model=\"item.selected\" ng-click=\"vm.clicker(item,\'orientation\')\"> {{item.name}}<ul><li \nng-repeat=\"row in item.child\"><input type=\"checkbox\" ng-click=\"vm.clicker(row,\'orientation\')\" ng-model=\"row.selected\">\n {{row.name}}</li></ul></li></ul></div></div></fieldset></div></div><div layout-gt-sm=\"row\" \nng-if=\"vm.isAdmin&& !vm.update\"><md-input-container flex><label translate=\"ONBOARDING.LABEL.STARTDATE\">Start Date\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.startDate\" md-min-date=\"vm.start\" \nmd-max-date=\"vm.end\" ng-change=\"vm.setEndDate()\" ng-disabled=\"vm.update\"></md-datepicker><div \nng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex><label translate=\"ONBOARDING.LABEL.ENDDATE\">End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.endDate\" md-min-date=\"vm.start\" \nmd-max-date=\"vm.end\" ng-disabled=\"vm.endDisabled  || vm.update\" ng-change=\"vm.setSearchBtn()\"></md-datepicker><div \nng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div>\n</div></md-input-container><md-button class=\"md-mini md-raised md-primary\" \nng-click=\"vm.changeEmpList(vm.startDate,vm.endDate)\" ng-disabled=\"vm.disSearch || vm.update\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div>\n<div layout=\"row\" ng-if=\"vm.isAdmin&& !vm.update\"><div layout=\"column\" flex=\"50\"><fieldset style=\"min-height: 550px\">\n<legend>List Employee</legend><table class=\"with-toolbar dataTable row-border hover simple\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th width=\"5%\" \nclass=\"text-center\"><md-checkbox class=\"no-label\" ng-click=\"vm.toggleSelectedAll()\" ng-model=\"vm.select\" \nng-checked=\"vm.selectAll\"></md-checkbox></th><th width=\"15%\" class=\"text-center\" translate=\"TABLE.NIK\">NIK</th><th \nclass=\"text-left\" translate=\"TABLE.NAME\">Name</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.items\" \nng-click=\"vm.toggleCheck(ls, $event)\" style=\"height: 24px !important\"><td width=\"5%\" class=\"text-center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" ng-disabled=\"vm.disable\"></md-checkbox></td><td width=\"15%\">\n{{ls.nik}}</td><td class=\"text-left\">{{ls.name}}</td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-right\">\n<md-button class=\"md-secondary\" ng-disabled=\"vm.disable && vm.listSelected.length <= 0\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.AddEmployeeList()\" class=\"md-button\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"blue-500-fg\"></md-icon><md-tooltip md-direction=\"top\">Add Employee</md-tooltip>\n</md-button></td></tr></tfoot></table></fieldset></div><div layout=\"column\" flex=\"50\"><fieldset \nstyle=\"height: 550px;overflow-y: scroll\"><legend>List Employee Selected</legend><div layout=\"column\" \nng-repeat=\"sel in vm.empSelected track by $index\"><md-list-item class=\"md-primary\" style=\"max-height:24px !important\">\n<div class=\"md-list-item-text\"><span>{{$index+1}}. {{sel.nik}}-{{sel.nama}}</span></div><md-button \nclass=\"md-secondary\" style=\"margin-top:-5px;padding: 0;height: 24px;width: 24px\" ng-click=\"vm.removeEmployee(sel)\" \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-minus\" class=\"red-500-fg\"></md-icon><md-tooltip \nmd-direction=\"top\">Remove Employee</md-tooltip></md-button></md-list-item></div></fieldset></div></div><div \nlayout=\"row\" ng-if=\"!vm.isAdmin || vm.update\"><p style=\"color:grey\">{{vm.employeeDisplay}}</p></div><div layout=\"row\" \nng-if=\"!vm.isAdmin || vm.update\"><md-input-container flex flex-gt-sm><md-select ng-model=\"vm.buddy\" \naria-label=\"Buddy/Peer\" name=\"buddy\" ng-change=\"vm.setSupportList(vm.buddy,\'subordinate\')\" required><md-option \nng-repeat=\"ls in vm.buddyList\" placeholder=\"Buddy/Peer\" value=\"{{ls.nik}}\">{{ls.nik}} - {{ls.name}}</md-option>\n</md-select><div ng-messages=\"frmBT.buddy.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBuddy field is required.</span></div></div></md-input-container></div><div layout=\"row\" \nng-if=\"!vm.isAdmin || vm.update\"><md-input-container flex flex-gt-sm><md-select ng-model=\"vm.subordinate\" \naria-label=\"Subordinate\" name=\"subordinate\" ng-change=\"vm.setSupportList(vm.subordinate,\'buddy\')\" \nng-required=\"vm.hasSubOrdinate\"><md-option ng-repeat=\"ls in vm.subordinateList\" placeholder=\"Subordinate\" \nvalue=\"{{ls.nik}}\">{{ls.nik}} - {{ls.name}}</md-option></md-select><div ng-messages=\"frmBT.subordinate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Subordinate field is required.</span></div></div></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmBT.$invalid || frmBT.$pristine || vm.empSelected.length==0\" translate=\"ACTION.SUBMIT\">Submit\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/onboarding/onboarding-user-register/onboarding-user-register.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-content \nclass=\"md-padding white-bg\" layout-xs=\"column\" layout=\"row\"><div flex layout=\"column\"></div></md-content><div \nclass=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">\n&nbsp;Entries</span><div ng-if=\"vm.admin\" class=\"divider-vertical\" hide show-gt-sm></div><md-button ng-if=\"vm.admin\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span>New</span></md-button><div\n ng-if=\"vm.admin\" class=\"divider-vertical\" hide show-gt-sm></div><md-button ng-if=\"vm.admin\" class=\"md-warn md-mini\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.selected.length == 0\" \nng-click=\" vm.deleteData($event)\"><md-icon ng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\">\n</md-icon><md-icon ng-if=\"vm.selected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> <span ng-if=\"vm.selected.length == 0\" \nclass=\"grey-700-fg\">Delete</span> <span ng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} selected</span>\n</md-button><div class=\"divider-vertical\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content style=\"background:white\" hide-gt-sm><span flex=\"5\"></span><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nng-if=\"vm.admin\" width=\"2%\"><span class=\"is-gear\"></span></th><th width=\"5%\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NO\">NO</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NIK\">NIK</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.NAME\">Name</span></th><th class=\"text-center\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.TABLE.JOINDATE\" width=\"5%\">Join Date</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.SUPERORDINATE\">Superordinate</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.PEER\">Peer</span></th><th class=\"text-center\"><span \nclass=\"column-title\" translate=\"ONBOARDING.TABLE.SUBORDINATE\">Subordinate</span></th><th width=\"3%\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td ng-if=\"vm.admin\"><md-checkbox \nng-if=\"item.is_on_progress==0&&item.is_completed==0\" aria-label=\"empLaborChecked\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\" width=\"5%\">{{item.nik}}</td><td>{{item.name}}</td><td \nclass=\"text-center\">{{item.join_date}}</td><td>{{item.superordinate}} / {{item.superordinate_name}}</td><td>\n{{item.buddy}} {{item.buddy ? \'/\': \'\'}} {{item.buddy_name}}</td><td>\n{{item.subordinate}} {{item.subordinate ? \'/\': \'\'}} {{item.subordinate_name}}</td><td class=\"text-center\"><section \nng-if=\"item.is_on_progress==0&&item.is_completed==0\" layout=\"row\" layout-sm=\"column\" class=\"no-padding text-center\" \nlayout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"\"><md-button aria-label=\"emplabortypemenu\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content><md-menu-item><md-button ng-disabled=\"vm.selected.length > 0\" \nng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><p flex>Edit</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"9\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/onboarding/onboarding-user-register/onboarding-view-detail.html","<md-dialog aria-label=\"Form Update Finger Data\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"80\"><form \nng-cloak class=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>View Document</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-content ng-if=\"vm.doc_type\" class=\"md-background-bg has-upload\" id=\"contentDialog\"><iframe \nsrc=\"{{vm.url}}\" style=\"width:100%; height:100vh\" frameborder=\"0\"></iframe></md-content></form></md-dialog>");
$templateCache.put("app/main/payroll-pma/payrollprocess/payrollprocess.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Payroll Process</md-subheader><div class=\"white-bg\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container flex><label>Period</label><md-select ng-model=\"vm.Form.objForm.period\" name=\"period\" required>\n<md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Company</label><md-select ng-model=\"vm.company\" \nname=\"companyid\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.companyid.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Area</label><md-select ng-model=\"vm.Form.objForm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\">Submit</md-button></form></div></div></md-content></div>");
$templateCache.put("app/main/payroll-pma/thrprocess/thrprocess.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">THR Process</md-subheader><div class=\"white-bg\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container flex><label>Period</label><md-select ng-model=\"vm.Form.objForm.period\" name=\"period\" required>\n<md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Company</label><md-select ng-model=\"vm.company\" \nname=\"companyid\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.companyid.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Area</label><md-select ng-model=\"vm.Form.objForm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Tanggal Hari Raya</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"hariraya\" ng-model=\"vm.Form.objForm.hariraya\" flex=\"30\"></md-datepicker>\n<div ng-messages=\"SalcomForm.hariraya.$error\" role=\"alert\"><div ng-message=\"required\"><span>hari raya Date is required.\n</span></div></div></md-input-container><md-input-container flex><label>Payment Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"paymentdate\" ng-model=\"vm.Form.objForm.paymentdate\" flex=\"30\"></md-datepicker><div \nng-messages=\"SalcomForm.paymentdate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Payment Date is required.\n</span></div></div></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\">Submit</md-button></form></div></div>\n</md-content></div>");
$templateCache.put("app/main/payroll/absentrate/absentrate.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nAbsent Rate</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputAbsentRate($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New Absent Rate</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeletAbsentRate()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Delete Absen Rate</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputAbsentRate($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Absen Rate</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteAbsentRate()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Absen Rate\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nEffective Date</span></th><th class=\"text-center\"><span class=\"column-title\">Company Code</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Attendance Code</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Position</span></th><th class=\"text-center\"><span class=\"column-title\">Payroll Code</span></th><th\n class=\"text-center\"><span class=\"column-title\">Formula</span></th><th class=\"text-center\"><span class=\"column-title\">\nFlag Prorate</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editAbsentRate($event,ls.id)\"><td><input type=\"checkbox\" checklist-model=\"vm.lisAbsentRateSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ls.effective_date}}</td><td class=\"text-center\">{{ls.companyname}}\n</td><td class=\"text-center\">{{ls.attendancecode}}</td><td class=\"text-center\">{{ls.position}}</td><td \nclass=\"text-center\">{{ls.payrollcode}}</td><td class=\"text-center\">{{ls.formula}}</td><td class=\"text-center\">\n{{ls.flag_prorate}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</div>");
$templateCache.put("app/main/payroll/absentrate/input-absentrate.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  /*width:800px;\n  height:100px;*/\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"AbsentForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,AbsentForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Absent Rate</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"AbsentForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date is required.</span></div></div></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container flex><label>Company Name</label><md-select \nng-model=\"vm.Form.objForm.companyname\" ng-change=\"vm.changeStatus(vm.Form.objForm.companyname)\" ng-required=\"true\" \nname=\"companyname\"><md-option ng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"AbsentForm.companyname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Attendance Code\n</label><md-select ng-model=\"vm.Form.objForm.code\" ng-change=\"vm.changeStatus(vm.Form.objForm.code)\" \nng-required=\"true\" name=\"code\"><md-option ng-repeat=\"s in vm.listattendancecode\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"AbsentForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAttendance Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Position</label><md-select ng-model=\"vm.Form.objForm.position\" \nng-change=\"vm.changeStatus(vm.Form.objForm.position)\" ng-required=\"true\" name=\"position\"><md-option \nng-repeat=\"s in vm.listposition\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"AbsentForm.position.$error\" role=\"alert\"><div ng-message=\"required\"><span>Position is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label>\n<md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changeStatus(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"AbsentForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox md-no-ink \naria-label=\"Checkbox No Ink\" ng-model=\"vm.Form.objForm.flag_prorate\" class=\"md-primary\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\">Flag Prorate</md-checkbox></div><div layout-gt-sm=\"row\"><md-input-container flex=\"77\"><label>\nFormula</label><input type=\"text\" name=\"formula\" ng-model=\"vm.Form.objForm.formula\" placeholder=\"Formula\" required> \n<span style=\"font-size: 10px\">\nPetunjuk Pengisian Formula: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span></md-input-container><md-input-container flex=\"22\"><a id=\"toggleMessage\" ng-click=\"toggle=!toggle\">\n{{toggle ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div id=\"box\" ng-show=\"toggle\"><fieldset \nclass=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend><div layout=\"row\" layout-wrap flex>\n<div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"AbsentForm.$invalid || AbsentForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/absentrate/view-salarycomponent.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"AbsentForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,AbsentForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>View Salary Component</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><fieldset class=\"demo-fieldset\"><legend \nclass=\"demo-legend\">view Salary Component</legend><div layout=\"row\" layout-wrap flex><div \nclass=\"demo-select-all-checkboxes\" flex=\"100\" ng-repeat=\"ls in vm.listpayrollcode\">{{ ls.name }}</div></div></fieldset>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/allowancefix/allowancefix.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nInput Allowance Fix</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper md-cyan-50-bg\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadDivisi(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" \nplaceholder=\"Department\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\"><md-option ng-repeat=\"ls in vm.listarea\" \nplaceholder=\"Area\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"><md-input-container \nclass=\"md-block\" flex=\"30\" md-no-float=\"\"><label>Shows :</label><md-select id=\"ss\" name=\"see\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\"><md-option ng-repeat=\"val in vm.listJum\" \nng-value=\"val\">{{val}} Entries</md-option></md-select></md-input-container><md-input-container flex><md-button \naria-label=\"Twitter\" class=\"md-icon-button md-mini\" hide show-gt-sm \nng-click=\"vm.downloadInputSalary(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Download File Allowance FIx</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-800-fg\"></md-icon></md-button></md-input-container></div></form></div></div>\n</md-content><div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputAllowanceFix($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nNew Allowance Fix</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\">\n</md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteAllowanceFix()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Allowance Fix</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nEffective Date</span></th><th class=\"text-center\"><span class=\"column-title\">Emp No</span></th><th class=\"text-center\">\n<span class=\"column-title\">Full Name</span></th><th class=\"text-center\"><span class=\"column-title\">Payroll Code</span>\n</th><th class=\"text-center\"><span class=\"column-title\">Payroll Description</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Amount</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editAllowanceFix($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisAllowanceFixSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td></tr></tbody>\n<tbody></tbody></table></md-toolbars></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/allowancefix/input-allowancefix.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"AllowanceFixForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,AllowanceFixForm)\"><md-toolbar class=\"md-cyan-600-bg\">\n<div class=\"md-toolbar-tools\"><h2>Form Input Allowance Fix</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"AllowanceFixForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete \nrequired flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"AllowanceFixForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span>\n</div></div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label>\n<md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"AllowanceFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Payroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Payroll Description</label><input type=\"text\" name=\"payrolldesc\" \nng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Payroll Description\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Amount</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div ng-messages=\"AllowanceFixForm.amount.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"AllowanceFixForm.$invalid || AllowanceFixForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll/allowancefix/upload-file.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload Allowance Fix</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" \nstyle=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll/attendance-sync/attendance-sync.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nProcess Sync Attendance To PMA</div><md-icon style=\"font-size:16px\" md-font-icon=\"icon-chevron-up\"></md-icon></div>\n</md-subheader><div class=\"white-bg\"><md-content layout=\"column\"><div layout=\"column\" flex><div id=\"filterForm\" flex \nclass=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmSync\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container><label>Payroll Period</label><md-select ng-model=\"vm.payroll_period\"><md-option value=\"\" \nselected=\"selected\">-- Period --</md-option><md-option ng-value=\"p\" ng-repeat=\"p in vm.payrollPeriod\">{{p}}</md-option>\n</md-select></md-input-container><md-input-container><label>Payroll Year</label><md-select ng-model=\"vm.payroll_year\">\n<md-option value=\"\" selected=\"selected\">-- Year --</md-option><md-option ng-value=\"y\" ng-repeat=\"y in vm.payrollYears\">\n{{y}}</md-option></md-select></md-input-container><md-input-container flex><label>Sub Area</label><md-select required \nname=\"field\" ng-model=\"vm.selectedSubArea\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header \nlayout=\"column\" class=\"demo-select-header\"><md-input-container><input ng-model=\"vm.searchText\" type=\"search\" \nng-model-options=\"{debounce: {\'default\': 500, \'blur\': 0}}\" placeholder=\"Search...\" \nclass=\"demo-header-searchbox md-text\"></md-input-container></md-select-header><md-optgroup><md-option ng-value=\"item\" \nng-repeat=\"item in vm.sub_areaLists | filter:vm.searchText\">{{item.description}}</md-option></md-optgroup></md-select>\n<div ng-messages=\"frmSync.sub_area.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Add Employee By Sub Area\" ng-click=\"vm.addEmployeeBySubArea(vm.selectedSubArea)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span>Add Employee By Sub Area</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-account-multiple-plus material-icons\">\n</md-icon><span>Add Employee By Sub Area</span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-warn md-mini\" aria-label=\"Delete\" \nng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete\n</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><div class=\"divider-vertical\">\n</div><md-button ng-disabled=\"vm.isLoading\" class=\"blue-500-fg md-mini\" aria-label=\"Synchronize\" \nng-click=\"vm.syncData($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nSynchronize</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" style=\"font-size:15px\" \nclass=\"md-font blue-500-fg icon-sync material-icons\"></md-icon><span>Synchronize</span></md-button><span flex></span>\n</div></md-toolbar><md-progress-linear ng-if=\"vm.isLoading\" md-mode=\"determinate\" value=\"{{vm.determinateValue}}\">\n</md-progress-linear><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><div \nid=\"tableMpp\"><table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr>\n<th style=\"min-width: 50px\"><md-checkbox class=\"no-label\" ng-model=\"vm.toggle_all\" ng-click=\"vm.toggleAll()\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\"></md-checkbox></th><th>No</th><th>NIK</th><th>EMPLOYEE NAME</th>\n<th>SUB AREA</th><th>#</th></tr></thead><tbody><tr ng-repeat=\"item in vm.employeeLists\"><td \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(item)\" ng-click=\"vm.toggle($event, item)\" ng-model=\"item.checked\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ $index + 1 }}</td>\n<td>{{ item.nik }}</td><td>{{ item.fullname }}</td><td class=\"text-center\">{{ item.sub_area_name }}</td><td \nclass=\"text-center\"><a href=\"javascript:void(0);\" ng-click=\"vm.edit($event, item)\" style=\"text-decoration: none\"><span \nclass=\"icon-pencil\"></span></a></td></tr></tbody></table></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll/carrate/carrate.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>Car Rate\n</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" \nlayout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\"><div \nid=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputCarRate($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New Car Rate</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeleteCarRate()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Delete Car Rate</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputCarRate($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Car Rate</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteCarRate()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Car Rate</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button><span flex \nhide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex><md-input-container md-no-float \nclass=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\" hide \nshow-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\">\n</md-input-container></form></div><table class=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th\n rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\">Effective Date</span></th><th class=\"text-center\"><span class=\"column-title\">Company</span></th>\n<th class=\"text-center\"><span class=\"column-title\">Car Type</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Amount</span></th><th class=\"text-center\"><span class=\"column-title\">Flag Prorate</span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editCarRate($event,ls.id)\"><td><input \ntype=\"checkbox\" checklist-model=\"vm.lisCarRateSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date}}</td><td class=\"text-center\">{{ls.companyname}}</td><td class=\"text-center\">{{ls.car_type}}</td>\n<td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td><td class=\"text-center\">{{ls.flag_prorate}}</td></tr>\n</tbody><tbody></tbody></table></md-toolbars></div><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</div>");
$templateCache.put("app/main/payroll/carrate/input-carrate.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"CarForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,CarForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Car Rate</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"CarForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date is required.</span></div></div></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container flex><label>Company Name</label><md-select \nng-model=\"vm.Form.objForm.companyname\" ng-change=\"vm.changeStatus(vm.Form.objForm.companyname)\" ng-required=\"true\" \nname=\"companyname\"><md-option ng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"CarForm.companyname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Car Type</label><input \ntype=\"text\" name=\"car_type\" ng-model=\"vm.Form.objForm.car_type\" placeholder=\"Car Type\"><div \nng-messages=\"CarForm.car_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Car Type is required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Amount</label><input \ntype=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div \nng-messages=\"CarForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nname=\"flag_prorate\" ng-model=\"vm.Form.objForm.flag_prorate\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">Flag Prorate\n</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"CarForm.$invalid || CarForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/cartransaction/cartransaction.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nCar Transaction</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper md-cyan-50-bg\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadDivisi(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" \nplaceholder=\"Department\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\"><md-option ng-repeat=\"ls in vm.listarea\" \nplaceholder=\"Area\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"><md-input-container \nclass=\"md-block\" flex=\"30\" md-no-float=\"\"><label>Shows :</label><md-select id=\"ss\" name=\"see\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\"><md-option ng-repeat=\"val in vm.listJum\" \nng-value=\"val\">{{val}} Entries</md-option></md-select></md-input-container></div></form></div></div></md-content><div \nid=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputCarTransaction($event,ls)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">New Car Transaction</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteCarTransaction()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nDelete Car Transaction</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputCarTransaction($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nNew Car Transaction</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\">\n</md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteCarTransaction()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Car Transaction</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-icon-button md-mini\" hide show-gt-sm ng-click=\"vm.openUploadCarTransaction($event)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Upload File Car Transaction</md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-800-fg\"></md-icon></md-button><span flex hide show-gt-sm></span></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">Period\n</span></th><th class=\"text-center\"><span class=\"column-title\">NIK</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Full Name</span></th><th class=\"text-center\"><span class=\"column-title\">Car Type</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Amount</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editCarTransaction($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisCarTransactionSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.period}}</td><td \nclass=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">{{ls.fullname}}</td><td class=\"text-center\">{{ls.type}}\n</td><td class=\"text-center\">{{ls.amount}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/cartransaction/input-cartransaction.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"CarForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,CarForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Input Car Transaction</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Period</label><md-select ng-model=\"vm.Form.objForm.period\" ng-required=\"true\" name=\"period\"><md-option \nng-repeat=\"s in vm.listperiod\" value=\"{{s}}\">{{s}}</md-option></md-select><div ng-messages=\"CarForm.status.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Car Type</label><md-select ng-model=\"vm.Form.objForm.car_type\" \nng-change=\"vm.changeCartype(vm.Form.objForm.car_type)\" ng-required=\"true\" name=\"car_type\"><md-option \nng-repeat=\"s in vm.listcartype\" value=\"{{s.id}}\">{{s.type}}</md-option></md-select><div \nng-messages=\"CarForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>Car Type is required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"CarForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span></div>\n</div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Amount</label><input \ntype=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div \nng-messages=\"CarForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span></div>\n</div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"CarForm.$invalid || CarForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/cartransaction/upload-file.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload Car Transaction\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" \nstyle=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadCarTransactionStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadCarTransactionStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll/closepayroll/closepayroll.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nClose Payroll</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputClosePayroll($event,ls)\"><md-tooltip\n md-direction=\"right\" md-visible=\"tooltipVisible\">New Close Payroll</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputClosePayroll($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Close Payroll</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th class=\"text-center\"><span \nclass=\"column-title\">Period</span></th><th class=\"text-center\"><span class=\"column-title\">Company</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Status</span></th><th class=\"text-center\"><span class=\"column-title\">\nRemarks</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editClosePayroll($event,ls.id)\"><td class=\"text-center\">{{ls.period}}</td><td class=\"text-center\">\n{{ls.companyname}}</td><td class=\"text-center\">{{ls.status}}</td><td class=\"text-center\">{{ls.remarks}}</td></tr>\n</tbody><tbody></tbody></table></md-toolbars></div><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</div>");
$templateCache.put("app/main/payroll/closepayroll/input-closepayroll.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"PayrollForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,PayrollForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Close Payroll</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Period</label><md-select ng-model=\"vm.Form.objForm.period\" ng-required=\"true\" name=\"period\"><md-option \nng-repeat=\"s in vm.listperiod\" value=\"{{s.period}}\">{{s.period}}</md-option></md-select><div \nng-messages=\"PayrollForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.Form.objForm.companyname\" ng-required=\"true\" name=\"companyname\"><md-option \nng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"PayrollForm.companyname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Status</label>\n<md-select ng-model=\"vm.Form.objForm.status\" ng-required=\"true\" name=\"status\"><md-option \nng-repeat=\"s in vm.liststatus\" value=\"{{s}}\">{{s}}</md-option></md-select><div ng-messages=\"PayrollForm.status.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Status is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Remarks</label><textarea name=\"remarks\" \nng-model=\"vm.Form.objForm.remarks\"></textarea><div ng-messages=\"PayrollForm.remarks.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Remarks is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"PayrollForm.$invalid || PayrollForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/cutoffparameter/cutoffperiodh.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nCut Off Parameter</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputCutOffParam($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New Cut Off Parameter</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteCutOffParam()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Delete Cut Off Parameter\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputCutOffParam($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Cut Off Parameter</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteCutOffParam()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Cut Off Parameter\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nCut Off Code</span></th><th class=\"text-center\"><span class=\"column-title\">Description</span></th></tr></thead><tbody>\n<tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editCutOffParam($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisCutOffParamSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.code}}</td><td>\n{{ls.deskripsi}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>\n</div>");
$templateCache.put("app/main/payroll/cutoffparameter/input-cutoffperiodh.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"CutOffForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,CutOffForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Cut Off Parameter</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Cut Off Code</label><input type=\"text\" name=\"code\" ng-model=\"vm.Form.objForm.code\" \nplaceholder=\"Cut Off Code\" required><div ng-messages=\"CutOffForm.code.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Cut Off Code is required.</span></div></div></md-input-container><md-input-container flex><label>Description\n</label><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" \nrequired><div ng-messages=\"CutOffForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"CutOffForm.$invalid || CutOffForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/deductionfix/deductionfix.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nInput Deduction Fix</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper md-cyan-50-bg\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadDivisi(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" \nplaceholder=\"Department\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\"><md-option ng-repeat=\"ls in vm.listarea\" \nplaceholder=\"Area\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"><md-input-container \nclass=\"md-block\" flex=\"30\" md-no-float=\"\"><label>Shows :</label><md-select id=\"ss\" name=\"see\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\"><md-option ng-repeat=\"val in vm.listJum\" \nng-value=\"val\">{{val}} Entries</md-option></md-select></md-input-container><md-input-container flex><md-button \naria-label=\"Twitter\" class=\"md-icon-button md-mini\" hide show-gt-sm \nng-click=\"vm.downloadDeductionFix(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Download File Deduction Fix</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-800-fg\"></md-icon></md-button></md-input-container></div></form></div></div>\n</md-content><div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputDeductionFix($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nNew Deduction Fix</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\">\n</md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteDeductionFix()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Deduction Fix</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nEffective Date</span></th><th class=\"text-center\"><span class=\"column-title\">Emp No</span></th><th class=\"text-center\">\n<span class=\"column-title\">Full Name</span></th><th class=\"text-center\"><span class=\"column-title\">Payroll Code</span>\n</th><th class=\"text-center\"><span class=\"column-title\">Payroll Description</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Amount</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editDeductionFix($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisDeductionFixSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td></tr></tbody>\n<tbody></tbody></table></md-toolbars></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/deductionfix/input-deductionfix.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"DeductionFixForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,DeductionFixForm)\"><md-toolbar class=\"md-cyan-600-bg\">\n<div class=\"md-toolbar-tools\"><h2>Form Input Deduction Fix</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"DeductionFixForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete \nrequired flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"DeductionFixForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span>\n</div></div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label>\n<md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"DeductionFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Payroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Payroll Description</label><input type=\"text\" name=\"payrolldesc\" \nng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Payroll Description\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Amount</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div ng-messages=\"DeductionFixForm.amount.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"DeductionFixForm.$invalid || DeductionFixForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll/deductionfix/upload-file.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload DeductionFix</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" \nstyle=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll/deductionnonfix/deductionnonfix.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nInput Deduction Non Fix</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div>\n<div layout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>\nFilter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nname=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" \nplaceholder=\"Department\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\"><md-option ng-repeat=\"ls in vm.listarea\" \nplaceholder=\"Area\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"><md-input-container \nclass=\"md-block\" flex=\"30\" md-no-float=\"\"><label>Shows :</label><md-select id=\"ss\" name=\"see\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\"><md-option ng-repeat=\"val in vm.listJum\" \nng-value=\"val\">{{val}} Entries</md-option></md-select></md-input-container><md-input-container flex><md-button \naria-label=\"Twitter\" class=\"md-icon-button md-mini\" hide show-gt-sm \nng-click=\"vm.downloadDeductionNonFix(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip\n md-direction=\"right\" md-visible=\"tooltipVisible\">Download File Deduction Non Fix</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-800-fg\"></md-icon></md-button></md-input-container></div></form></div></div>\n</md-content><div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputDeductionNonFix($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nNew Deduction Non Fix</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteDeductionNonFix()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nDelete Deduction Non Fix</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon>Delete</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide \nshow-gt-sm></span></div><table class=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th \nrowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">Start Date\n</span></th><th class=\"text-center\"><span class=\"column-title\">End Date</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Emp No</span></th><th class=\"text-center\"><span class=\"column-title\">Full Name</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Payroll Code</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Payroll Description</span></th><th class=\"text-center\"><span class=\"column-title\">Amount</span>\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editDeductionNonFix($event,ls.id)\">\n<td><input type=\"checkbox\" checklist-model=\"vm.lisDeductionNonFixSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ls.start_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">\n{{ls.end_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.code}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td></tr></tbody>\n<tbody></tbody></table></md-toolbars></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/deductionnonfix/edit-deductionnonfix.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"DeductionNonFixForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,DeductionNonFixForm)\"><md-toolbar \nclass=\"md-cyan-600-bg\"><div class=\"md-toolbar-tools\"><h2>Form Input Deduction Non Fix</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"DeductionNonFixForm.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart Date is required.</span></div></div></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\" required></md-datepicker>\n<div ng-messages=\"DeductionNonFixForm.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd Date is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div>\n<div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label><md-select \nng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" \nname=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select>\n<div ng-messages=\"DeductionNonFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Payroll Desc</label><input type=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" \nplaceholder=\"Payroll Desc\"><div ng-messages=\"DeductionNonFixForm.payrolldesc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Payroll Code is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Amount</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"DeductionNonFixForm.$invalid || DeductionNonFixForm.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/payroll/deductionnonfix/input-deductionnonfix.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"DeductionNonFixForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,DeductionNonFixForm)\"><md-toolbar \nclass=\"md-cyan-600-bg\"><div class=\"md-toolbar-tools\"><h2>Form Input Deduction Non Fix</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"DeductionFixForm.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div \nng-messages=\"DeductionFixForm.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete required flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"DeductionFixForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span>\n</div></div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label>\n<md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"DeductionNonFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Payroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Payroll Desc</label><input type=\"text\" name=\"payrolldesc\" \nng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Payroll Desc\"><div \nng-messages=\"DeductionNonFixForm.payrolldesc.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Amount</label><input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" \nrequired><div ng-messages=\"DeductionNonFixForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAmount is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"DeductionNonFixForm.$invalid || DeductionNonFixForm.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/payroll/deductionnonfix/upload-file.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload Deduction Non Fix\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" \nstyle=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll/employeegroup/employeegroup.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nEmployee Group</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputEmpGroup($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New Employee Group</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteEmpGroup()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Delete Employee Group\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputEmpGroup($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Employee Group</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteEmpGroup()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Employee Group\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nEmployee Group</span></th><th class=\"text-center\"><span class=\"column-title\">Description</span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editEmpGroup($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisEmployeeGroupSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.code}}</td><td \nclass=\"text-center\">{{ls.description}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/employeegroup/input-employeegroup.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"EmpGroupForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,EmpGroupForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Employee Group</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Employee Group</label><input type=\"text\" name=\"code\" ng-model=\"vm.Form.objForm.code\" \nplaceholder=\"Employee Group\" required><div ng-messages=\"EmpGroupForm.code.$error\" role=\"alert\"><div \nng-message=\"required\"><span>PTKP Code is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Description</label><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" \nplaceholder=\"Description\" required><div ng-messages=\"EmpGroupForm.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Description is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"EmpGroupForm.$invalid || EmpGroupForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/fixentry/fixentry.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nInput Salary</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper md-cyan-50-bg\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadArea(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" \nname=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.area\" name=\"area\" \nplaceholder=\"Area\"><md-option ng-repeat=\"ls in vm.listarea\" placeholder=\"Area\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"><md-input-container \nclass=\"md-block\" flex=\"30\" md-no-float=\"\"><label>Shows :</label><md-select id=\"ss\" name=\"see\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\"><md-option ng-repeat=\"val in vm.listJum\" \nng-value=\"val\">{{val}} Entries</md-option></md-select></md-input-container><md-input-container flex><md-button \naria-label=\"Twitter\" class=\"md-icon-button md-mini\" hide show-gt-sm \nng-click=\"vm.downloadInputSalary(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Download Input Salary</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-800-fg\"></md-icon></md-button></md-input-container></div></form></div></div>\n</md-content><div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputFixEntry($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New Fix Entry</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeleteFixEntry()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Delete Fix Entry</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputFixEntry($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Fix Entry</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteFixEntry()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Fix Entry\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span>\n</div><table class=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nEffective Date</span></th><th class=\"text-center\"><span class=\"column-title\">Emp No</span></th><th class=\"text-center\">\n<span class=\"column-title\">Full Name</span></th><th class=\"text-center\"><span class=\"column-title\">Payroll Code</span>\n</th><th class=\"text-center\"><span class=\"column-title\">Payroll Description</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Amount</span></th><th class=\"text-center\"><span class=\"column-title\">Flag Acting</span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editFixEntry($event,ls.id)\"><td><input \ntype=\"checkbox\" checklist-model=\"vm.lisFixEntrySelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td><td \nclass=\"text-center\">{{ls.flag_acting}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/fixentry/input-fixentry.html","<md-dialog aria-label=\"Form Input Salary\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"InputSalaryForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,InputSalaryForm)\"><md-toolbar class=\"md-cyan-600-bg\">\n<div class=\"md-toolbar-tools\"><h2>Form Input Salary</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"InputSalaryForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete \nrequired flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"InputSalaryForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span>\n</div></div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label>\n<md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\" \nselected=\"selected\">{{s.name}}</md-option></md-select><div ng-messages=\"InputSalaryForm.status.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Payroll Code is required.</span></div></div></md-input-container><md-input-container \nflex><label>Payroll Description</label><input type=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" \nplaceholder=\"Payroll Description\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>\nAmount</label><input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div \nng-messages=\"InputSalaryForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"vm.Form.objForm.flag_acting\" class=\"md-primary\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">Flag Acting\n</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"InputSalaryForm.$invalid || InputSalaryForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll/fixentry/upload-file.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload Input Salary</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" \nstyle=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll/graderate/graderate.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nGrade Rate</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputGradeRate($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New Grade Rate</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeleteGradeRate()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Delete Grade Rate</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputGradeRate($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Grade Rate</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteGradeRate()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Grade Rate\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nEffective Date</span></th><th class=\"text-center\"><span class=\"column-title\">Company Code</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Grade Code</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Payroll Code</span></th><th class=\"text-center\"><span class=\"column-title\">Payroll Desc</span>\n</th><th class=\"text-center\"><span class=\"column-title\">Amount</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Flag Prorate</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editGradeRate($event,ls.id)\"><td><input type=\"checkbox\" checklist-model=\"vm.lisGradeRateSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ls.effective_date}}</td><td class=\"text-center\">{{ls.companydesc}}\n</td><td class=\"text-center\">{{ls.gradecode}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td><td \nclass=\"text-center\">{{ls.flag_prorate}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/graderate/input-graderate.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"GradeForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,GradeForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Grade Rate</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"AbsentForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Company Code</label><md-select ng-model=\"vm.Form.objForm.companyid\" \nng-change=\"vm.changeStatus(vm.Form.objForm.companyid)\" ng-required=\"true\" name=\"companyid\"><md-option \nng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"GradeForm.companyid.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Grade Code</label><md-select \nng-model=\"vm.Form.objForm.gradecode\" ng-change=\"vm.changeStatus(vm.Form.objForm.gradecode)\" ng-required=\"true\" \nname=\"gradecode\"><md-option ng-repeat=\"s in vm.listgrade\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"GradeForm.gradecode.$error\" role=\"alert\"><div ng-message=\"required\"><span>Grade Code is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label>\n<md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"GradeForm.payrollcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code is required.</span></div></div></md-input-container><md-input-container flex><label>Payroll Desc</label>\n<input type=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Payroll Desc\">\n</md-input-container><md-input-container flex><label>Amount</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div ng-messages=\"GradeForm.amount.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"vm.Form.objForm.flag_prorate\" \nclass=\"md-primary\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">Flag Prorate</md-checkbox></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"GradeForm.$invalid || GradeForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/groupentry/groupentry.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nGroup Entry</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputGroupEntry($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New Group Entry</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeleteGroupEntry()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Delete Group Entry</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputGroupEntry($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Group Entry</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteGroupEntry()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Group Entry\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nEffective Date</span></th><th class=\"text-center\"><span class=\"column-title\">Group Code</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Group Desc</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Payroll Code</span></th><th class=\"text-center\"><span class=\"column-title\">Payroll Desc</span>\n</th><th class=\"text-center\"><span class=\"column-title\">Amount</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Flag Prorate</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editGroupEntry($event,ls.id)\"><td><input type=\"checkbox\" checklist-model=\"vm.lisGroupEntrySelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ls.effective_date}}</td><td class=\"text-center\">{{ls.groupcode}}\n</td><td class=\"text-center\">{{ls.groupdesc}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td><td \nclass=\"text-center\">{{ls.flag_prorate}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/groupentry/input-groupentry.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"GroupEntryForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,GroupEntryForm)\"><md-toolbar class=\"md-cyan-600-bg\">\n<div class=\"md-toolbar-tools\"><h2>Form Group Entry</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"GroupEntryForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date is required.</span></div></div></md-input-container><md-input-container flex><label>Group Code</label>\n<md-select ng-model=\"vm.Form.objForm.groupcode\" ng-change=\"vm.changeGroup(vm.Form.objForm.groupcode)\" \nng-required=\"true\" name=\"code\"><md-option ng-repeat=\"s in vm.listgroup\" value=\"{{s.id}}\">{{s.name}}</md-option>\n</md-select><div ng-messages=\"GroupEntryForm.groupcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nGroup Code is required.</span></div></div></md-input-container><md-input-container flex><label>Group Desc</label><input\n type=\"text\" name=\"groupdesc\" ng-model=\"vm.Form.objForm.groupdesc\" placeholder=\"Payroll Desc\"><div \nng-messages=\"GroupEntryForm.groupdesc.$error\" role=\"alert\"><div ng-message=\"required\"><span>Group Desc is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code\n</label><md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayroll\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"GroupEntryForm.payrollcode.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Payroll Code is required.</span></div></div></md-input-container><md-input-container flex><label>Payroll Desc\n</label><input type=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Payroll Desc\"><div \nng-messages=\"GroupEntryForm.payrolldesc.$error\" role=\"alert\"><div ng-message=\"required\"><span>Payroll Desc is required.\n</span></div></div></md-input-container><md-input-container flex><label>Amount</label><input type=\"number\" \nname=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div \nng-messages=\"GroupEntryForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"vm.Form.objForm.flag_prorate\" class=\"md-primary\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">Flag Prorate\n</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"GroupEntryForm.$invalid || GroupEntryForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll/jamsostek/input-jamsostek.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  /*width:800px;\n  height:100px;*/\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"JamsostekForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,JamsostekForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div\n class=\"md-toolbar-tools\"><h2>Form BPJS</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>BPJS Code</label><input type=\"text\" name=\"code\" ng-model=\"vm.Form.objForm.code\" placeholder=\"BPJS Code\" \nrequired><div ng-messages=\"JamsostekForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBPJS Code is required.</span></div></div></md-input-container><md-input-container flex><label>BPJS Description</label>\n<input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"BPJS Description\" required>\n<div ng-messages=\"JamsostekForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBPJS Description is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex=\"66\"><label>Rate BPJS</label><input type=\"text\" name=\"ratebpjs\" ng-model=\"vm.Form.objForm.ratebpjs\" \nplaceholder=\"Rate BPJS\" required> <span style=\"font-size: 10px\">\nPetunjuk Pengisian Rate BPJS: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"JamsostekForm.ratebpjs.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRate BPJS is required.</span></div></div></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" \nng-click=\"toggle=!toggle\">{{toggle ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div id=\"box\" ng-show=\"toggle\">\n<fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend><div layout=\"row\" \nlayout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>JKK Employee (%)</label><input type=\"number\" name=\"jkkemppct\" \nng-model=\"vm.Form.objForm.jkkemppct\" placeholder=\"JKK Employee\" required><div \nng-messages=\"JamsostekForm.jkkemppct.$error\" role=\"alert\"><div ng-message=\"required\"><span>JKK Employee is required.\n</span></div></div></md-input-container><md-input-container flex><label>Post to</label><md-select \nng-model=\"vm.Form.objForm.jkkemppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jkkemppostcode)\" ng-required=\"true\" \nname=\"jkkemppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div\n ng-messages=\"JamsostekForm.jkkemppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJKK Employee Post Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>JKK Employer (%)</label><input type=\"number\" name=\"jkkcomppct\" \nng-model=\"vm.Form.objForm.jkkcomppct\" placeholder=\"JKK Employer\" required><div \nng-messages=\"JamsostekForm.jkkcomppct.$error\" role=\"alert\"><div ng-message=\"required\"><span>JKK Employer is required.\n</span></div></div></md-input-container><md-input-container flex><label>Post to</label><md-select \nng-model=\"vm.Form.objForm.jkkcomppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jkkcomppostcode)\" \nng-required=\"true\" name=\"jkkcomppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.jkkcomppostcode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>JKK Employer Post Code is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>JKM Employee (%)</label><input type=\"number\" name=\"jkmemppct\" \nng-model=\"vm.Form.objForm.jkmemppct\" placeholder=\"JKM Employee\" required><div \nng-messages=\"JamsostekForm.jkmemppct.$error\" role=\"alert\"><div ng-message=\"required\"><span>JKM Employee is required.\n</span></div></div></md-input-container><md-input-container flex><label>Post to</label><md-select \nng-model=\"vm.Form.objForm.jkmemppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jkmemppostcode)\" ng-required=\"true\" \nname=\"jkmemppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div\n ng-messages=\"JamsostekForm.jkmemppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJKK Employer Post Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>JKM Employer (%)</label><input type=\"number\" name=\"jkmcomppct\" \nng-model=\"vm.Form.objForm.jkmcomppct\" placeholder=\"JKM Employer\" required><div \nng-messages=\"JamsostekForm.jkmcomppct.$error\" role=\"alert\"><div ng-message=\"required\"><span>JKM Employer is required.\n</span></div></div></md-input-container><md-input-container flex><label>Post to</label><md-select \nng-model=\"vm.Form.objForm.jkmcomppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jkmcomppostcode)\" \nng-required=\"true\" name=\"jkmcomppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.jkkcomppostcode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>JKM Employer Post Code is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>JHT Employee (%)</label><input type=\"number\" name=\"jhtemppct\" \nng-model=\"vm.Form.objForm.jhtemppct\" placeholder=\"JHT Employee\" required><div \nng-messages=\"JamsostekForm.jhtemppct.$error\" role=\"alert\"><div ng-message=\"required\"><span>JHT Employee is required.\n</span></div></div></md-input-container><md-input-container flex><label>Post to</label><md-select \nng-model=\"vm.Form.objForm.jhtemppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jhtemppostcode)\" ng-required=\"true\" \nname=\"jhtemppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div\n ng-messages=\"JamsostekForm.jhtemppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJHT Employer Post Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>JHT Employer (%)</label><input type=\"number\" name=\"jhtcomppct\" \nng-model=\"vm.Form.objForm.jhtcomppct\" placeholder=\"JHT Employer\" required><div \nng-messages=\"JamsostekForm.jhtcomppct.$error\" role=\"alert\"><div ng-message=\"required\"><span>JHT Employer is required.\n</span></div></div></md-input-container><md-input-container flex><label>Post to</label><md-select \nng-model=\"vm.Form.objForm.jhtcomppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jhtcomppostcode)\" \nng-required=\"true\" name=\"jhtcomppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.jhtcomppostcode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>JKM Employer Post Code is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex=\"66\"><label>Rate BPJSKes</label><input type=\"text\" name=\"ratebpjskes\" \nng-model=\"vm.Form.objForm.ratebpjskes\" placeholder=\"Rate BPJS Kes\" required> <span style=\"font-size: 10px\">\nPetunjuk Pengisian Rate BPJSKes: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"JamsostekForm.ratebpjskes.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRate BPJSKes is required.</span></div></div></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" \nng-click=\"ratebpjskes=!ratebpjskes\">{{ratebpjskes ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div id=\"box\" \nng-show=\"ratebpjskes\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend><div \nlayout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset>\n</div><div layout-gt-sm=\"row\"><md-input-container flex><label>BPJS Kes Employee (%)</label><input type=\"number\" \nname=\"bpjskesemppct\" ng-model=\"vm.Form.objForm.bpjskesemppct\" placeholder=\"BPJS Kes Employee\" required><div \nng-messages=\"JamsostekForm.bpjskesemppct.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBPJS Kes Employee is required.</span></div></div></md-input-container><md-input-container flex><label>Post to</label>\n<md-select ng-model=\"vm.Form.objForm.bpjskesemppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.bpjskesemppostcode)\" \nng-required=\"true\" name=\"bpjskesemppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.bpjskesemppostcode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>BPJS Kes Post Code is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>BPJS Kes Employer (%)</label><input type=\"number\" \nname=\"bpjskescomppct\" ng-model=\"vm.Form.objForm.bpjskescomppct\" placeholder=\"BPJS Kes Employer\" required><div \nng-messages=\"JamsostekForm.bpjskescomppct.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBPJS Kes Employer is required.</span></div></div></md-input-container><md-input-container flex><label>Post to</label>\n<md-select ng-model=\"vm.Form.objForm.bpjskescomppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.bpjscomppostcode)\" \nng-required=\"true\" name=\"bpjskescomppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.bpjskesemppostcode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>BPJS Kes Post Code is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Max BPJS Kes</label><input type=\"number\" name=\"bpjsmaxrate\" \nng-model=\"vm.Form.objForm.bpjsmaxrate\" placeholder=\"Max BPJS Kes\" required><div \nng-messages=\"JamsostekForm.bpjsmaxrate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Max BPJS Kes is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label>\nRate BPJS Pensiun</label><input type=\"text\" name=\"ratejp\" ng-model=\"vm.Form.objForm.ratejp\" \nplaceholder=\"Rate BPJS Pensiun\" required> <span style=\"font-size: 10px\">\nPetunjuk Pengisian Rate BPJS Pensiun: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"JamsostekForm.ratejp.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRate BPJS Pensiun is required.</span></div></div></md-input-container><md-input-container flex=\"33\"><a \nid=\"toggleMessage\" ng-click=\"ratejp=!ratejp\">{{ratejp ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div id=\"box\" \nng-show=\"ratejp\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend><div \nlayout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset>\n</div><div layout-gt-sm=\"row\"><md-input-container flex><label>BPJS JP Employee (%)</label><input type=\"number\" \nname=\"jpemppct\" ng-model=\"vm.Form.objForm.jpemppct\" placeholder=\"BPJS JP Employee\" required><div \nng-messages=\"JamsostekForm.jpemppct.$error\" role=\"alert\"><div ng-message=\"required\"><span>BPJS JP Employee is required.\n</span></div></div></md-input-container><md-input-container flex><label>Post to</label><md-select \nng-model=\"vm.Form.objForm.jpemppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jpemppostcode)\" ng-required=\"true\" \nname=\"jpemppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"JamsostekForm.jpemppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBPJS JP Employee is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>BPJS JP Employer (%)</label><input type=\"number\" name=\"jpcomppct\" ng-model=\"vm.Form.objForm.jpcomppct\" \nplaceholder=\"BPJS JP Employer\" required><div ng-messages=\"JamsostekForm.jpcomppct.$error\" role=\"alert\"><div \nng-message=\"required\"><span>BPJS JP Employer is required.</span></div></div></md-input-container><md-input-container \nflex><label>Post to</label><md-select ng-model=\"vm.Form.objForm.jpcomppostcode\" \nng-change=\"vm.changeThp(vm.Form.objForm.jpcomppostcode)\" ng-required=\"true\" name=\"jpcomppostcode\"><md-option \nng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"JamsostekForm.jpcomppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBPJS JP Employeer is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Max JP Rate</label><input type=\"number\" name=\"jpmaxrate\" ng-model=\"vm.Form.objForm.jpmaxrate\" \nplaceholder=\"Max JP\" required><div ng-messages=\"JamsostekForm.jpmaxrate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Max JP Rate is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"JamsostekForm.$invalid || JamsostekForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll/jamsostek/jamsostek.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nBPJS Parameter</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputJamsostek($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New Jamsostek Paramater</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteJamsostek()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Delete Jamsostek Paramater\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputJamsostek($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Jamsostek Parameter</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteJamsostek()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Jamsostek Parameter\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">Code</span>\n</th><th class=\"text-center\"><span class=\"column-title\">Description</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editJamsostek($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisJamsostekSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.code}}</td><td \nclass=\"text-center\">{{ls.description}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div><table border=\"1\"><tbody><tr><td rowspan=\"3\">Test1</td><td \nrowspan=\"3\">Test2</td></tr><tr><td>1</td></tr><tr><td>2</td></tr></tbody></table></div>");
$templateCache.put("app/main/payroll/laporanprosespayroll/laporanprosespayroll.html","<div class=\"page-layout simple fullwidth\" id=\"header-action\"><div class=\"header nabati1\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>Employee Payroll View</span></span>\n</div></div></div></div><div class=\"content\"><div class=\"simple-table-container md-whiteframe-4dp\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Period</label><md-select ng-model=\"vm.period\" name=\"period\">\n<md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required>\n<md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\"><md-option \nng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\" required><md-option\n ng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.area\" placeholder=\"Area\" name=\"area\"><md-option \nng-repeat=\"ls in vm.listarea\" placeholder=\"Area\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"><md-input-container \nclass=\"md-block\" flex=\"30\" md-no-float=\"\"><label>Shows :</label><md-select id=\"ss\" name=\"see\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\"><md-option ng-repeat=\"val in vm.listJum\" \nng-value=\"val\">{{val}} Entries</md-option></md-select></md-input-container></div></form></div></div></md-content><div \nid=\"attView\"><table class=\"simple stripped\" ms-responsive-table=\"\" style=\"margin-top:0\"><thead><tr><th><div \nclass=\"table-header\"></div></th><th width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">No</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title\">Period</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\">Employee Number</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">\nFull Name</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Group</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Position</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">THP</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">#</span></div></th>\n</tr></thead><tbody><tr ng-dblclick=\"vm.editData(ls.id)\" ng-repeat=\"ls in vm.DataTable.list\"><td></td><td>\n{{ $index + 1 }}</td><td>{{ ls.period }}</td><td>{{ ls.id_employee }}</td><td>\n{{ ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name | uppercase }}</td><td>{{ ls.group }}</td><td>\n{{ ls.position }}</td><td>{{ ls.amount | currency:\"Rp. \"}}</td><td><md-button aria-label=\"View Surveys\" \nclass=\"md-icon-button\" ng-click=\"vm.setView(ls.id_employee, ls.period)\" style=\"padding: 0;height: 24px;width: 24px\">\n<md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>View Surveys</span></md-tooltip>\n</md-button></td></tr></tbody></table></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nclass=\"{{nav.class}}\" ng-class=\"{disabled:(nav.disabled===1)}\" ng-repeat=\"nav in vm.DataTable.listNav\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/nonfixentry/edit-nonfixentry.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"NonFixForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,NonFixForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Input Allowance Non Fix</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div ng-messages=\"NonFixForm.start_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label>End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" \nng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div ng-messages=\"NonFixForm.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label><md-select \nng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" \nname=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select>\n<div ng-messages=\"NonFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>Payroll Code is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Desc\n</label><input type=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Payroll Desc\"><div \nng-messages=\"NonFixForm.payrolldesc.$error\" role=\"alert\"><div ng-message=\"required\"><span>Payroll Code is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Amount</label>\n<input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"NonFixForm.$invalid || NonFixForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/nonfixentry/input-nonfixentry.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"NonFixForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,NonFixForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Input Allowance Non Fix</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div ng-messages=\"DeductionFixForm.start_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label>End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" \nng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div ng-messages=\"DeductionFixForm.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"DeductionFixForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span>\n</div></div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label>\n<md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"NonFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Payroll Desc</label><input type=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" \nplaceholder=\"Payroll Desc\"><div ng-messages=\"NonFixForm.payrolldesc.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Payroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Amount</label><input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" \nplaceholder=\"Amount\" required></md-input-container><div ng-messages=\"NonFixForm.amount.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Amount is required.</span></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"NonFixForm.$invalid || NonFixForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/nonfixentry/nonfixentry.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nInput Allowance Non Fix</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div>\n<div layout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>\nFilter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nname=\"company\" ng-change=\"vm.LoadArea(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" \nname=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.area\" placeholder=\"Area\" \nname=\"area\"><md-option ng-repeat=\"ls in vm.listarea\" placeholder=\"Area\" value=\"{{ls.id}}\">{{ls.name}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"><md-input-container \nclass=\"md-block\" flex=\"30\" md-no-float=\"\"><label>Shows :</label><md-select id=\"ss\" name=\"see\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\"><md-option ng-repeat=\"val in vm.listJum\" \nng-value=\"val\">{{val}} Entries</md-option></md-select></md-input-container><md-input-container flex><md-button \naria-label=\"Twitter\" class=\"md-icon-button md-mini\" hide show-gt-sm \nng-click=\"vm.downloadAllowanceNonFix(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip\n md-direction=\"right\" md-visible=\"tooltipVisible\">Download File Allowance Non Fix</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-800-fg\"></md-icon></md-button></md-input-container></div></form></div></div>\n</md-content><div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputNonFixEntry($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nNew Allowance Non Fix</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteNonFixEntry()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Allowance Non Fix\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span>\n</div><table class=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">Start Date\n</span></th><th class=\"text-center\"><span class=\"column-title\">End Date</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Emp No</span></th><th class=\"text-center\"><span class=\"column-title\">Full Name</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Payroll Code</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Payroll Description</span></th><th class=\"text-center\"><span class=\"column-title\">Amount</span>\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editNonFixEntry($event,ls.id)\"><td>\n<input type=\"checkbox\" checklist-model=\"vm.lisNonFixEntrySelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.start_date | date : \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.end_date | date : \"dd-MM-yyyy\"}}</td><td \nclass=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.code}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td></tr></tbody>\n<tbody></tbody></table></md-toolbars></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/nonfixentry/upload-file.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload Allowance Non Fix\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" \nstyle=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll/otparameter/input-otparameter.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  /*width:800px;\n  height:100px;*/\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"OTParamForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,OTParamForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form OT Parameter</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Code</label><input type=\"text\" name=\"ot_code\" ng-model=\"vm.Form.objForm.ot_code\" placeholder=\"Code\" \nrequired><div ng-messages=\"OTParamForm.ot_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>Code is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Posting to\n</label><md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"GradeForm.payrollcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Description</label><input type=\"text\" name=\"ot_description\" ng-model=\"vm.Form.objForm.ot_description\" \nplaceholder=\"Description\"><div ng-messages=\"OTParamForm.ot_description.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Description is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container\n flex=\"66\"><label>Formula</label><input type=\"text\" name=\"formula\" ng-model=\"vm.Form.objForm.formula\" \nplaceholder=\"Formula\" required> <span style=\"font-size: 10px\">\nPetunjuk Pengisian Formula: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"OTParamForm.formula.$error\" role=\"alert\"><div ng-message=\"required\"><span>Formula is required.\n</span></div></div></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"toggle=!toggle\">\n{{toggle ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div id=\"box\" ng-show=\"toggle\"><fieldset \nclass=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend><div layout=\"row\" layout-wrap flex>\n<div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Multiple 1</label><input type=\"number\" name=\"multiple1\" \nng-model=\"vm.Form.objForm.multiple1\" placeholder=\"Multiple 1\" required><div ng-messages=\"OTParamForm.multiple1.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Multiple 1 is required.</span></div></div></md-input-container></div><div\n layout-gt-sm=\"row\"><md-input-container flex><label>Multiple 2</label><input type=\"number\" name=\"multiple2\" \nng-model=\"vm.Form.objForm.multiple2\" placeholder=\"Multiple 2\" required><div ng-messages=\"OTParamForm.multiple2.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Multiple 2 is required.</span></div></div></md-input-container></div><div\n layout-gt-sm=\"row\"><md-input-container flex><label>Multiple 3</label><input type=\"number\" name=\"multiple3\" \nng-model=\"vm.Form.objForm.multiple3\" placeholder=\"Multiple 3\" required><div ng-messages=\"OTParamForm.multiple3.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Multiple 3 is required.</span></div></div></md-input-container></div><div\n layout-gt-sm=\"row\"><md-input-container flex><label>Multiple 4</label><input type=\"number\" name=\"multiple4\" \nng-model=\"vm.Form.objForm.multiple4\" placeholder=\"Multiple 4\" required><div ng-messages=\"OTParamForm.multiple4.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Multiple 4 is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"OTParamForm.$invalid || OTParamForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/otparameter/otparameter.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nOT Parameter</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputOtParameter($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New OT Parameter</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteOtParameter()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Delete OT Parameter\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputOtParameter($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New OT Parameter</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteOtParameter()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete OT Parameter\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">OT Code\n</span></th><th class=\"text-center\"><span class=\"column-title\">Description</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editOtParameter($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisOtParameterSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.ot_code}}</td><td \nclass=\"text-center\">{{ls.ot_description}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/payrollemployee/input-payrollemployee.html","as<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"PayEmpForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,PayEmpForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Payroll Employee</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-autocomplete \nrequired flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"PayEmpForm.empno.$error\"><div ng-message=\"required\">This field is required</div></div></md-autocomplete>\n</div><div layout-gt-sm=\"row\"><md-input-container flex><label>Jamsostek Code</label><md-select \nng-model=\"vm.Form.objForm.jamsostekcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jamsostekcode)\" ng-required=\"true\" \nname=\"jamsostekcode\"><md-option ng-repeat=\"s in vm.listjamsostekcode\" value=\"{{s.id}}\">{{s.name}}</md-option>\n</md-select><div ng-messages=\"PayEmpForm.jamsostekcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJamsostek Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Tax Code</label><md-select ng-model=\"vm.Form.objForm.tax\" ng-change=\"vm.changeThp(vm.Form.objForm.taxode)\" \nng-required=\"true\" name=\"taxcode\"><md-option ng-repeat=\"s in vm.listtaxcode\" value=\"{{s.id}}\">{{s.name}}</md-option>\n</md-select><div ng-messages=\"PayEmpForm.taxcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTax Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label>OT Code</label><md-select ng-model=\"vm.Form.objForm.otcode\" ng-change=\"vm.changeThp(vm.Form.objForm.otcode)\" \nng-required=\"true\" name=\"OT Code\"><md-option ng-repeat=\"s in vm.listot\" value=\"{{s.id}}\">{{s.name}}</md-option>\n</md-select><div ng-messages=\"PayEmpForm.otcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nOT Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label>Tax Location</label><md-select ng-model=\"vm.Form.objForm.taxlocation\" \nng-change=\"vm.changeThp(vm.Form.objForm.taxlocation)\" ng-required=\"true\" name=\"Tax Location\"><md-option \nng-repeat=\"s in vm.listtaxlocation\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"PayEmpForm.taxlocation.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tax Location is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox md-no-ink \naria-label=\"Checkbox No Ink\" ng-model=\"vm.Form.objForm.flag_report\" class=\"md-primary\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\">Flag Report</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"PayEmpForm.$invalid || PayEmpForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/payrollemployee/payrollemployee.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nPayroll Employee</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper md-cyan-50-bg\"><form name=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>\nFilter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nname=\"company\" ng-change=\"vm.LoadArea(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" \nname=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.area\" name=\"area\" \nplaceholder=\"Area\"><md-option ng-repeat=\"ls in vm.listarea\" placeholder=\"Area\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"><md-input-container \nclass=\"md-block\" flex=\"30\" md-no-float=\"\"><label>Shows :</label><md-select id=\"ss\" name=\"see\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\"><md-option ng-repeat=\"val in vm.listJum\" \nng-value=\"val\">{{val}} Entries</md-option></md-select></md-input-container><md-input-container flex><md-button \naria-label=\"Twitter\" class=\"md-icon-button md-mini\" hide show-gt-sm \nng-click=\"vm.DownloadEmployee(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Download Payroll Employee</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-800-fg\"></md-icon></md-button></md-input-container></div></form></div></div>\n</md-content><div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputPayrollEmployee($event,ls)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">New Payroll Employee</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeletePayrollEmployee()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nDelete Payroll Employee</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputPayrollEmployee($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nNew Payroll Employee</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\">\n</md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeletePayrollEmployee()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nDelete Payroll Employee</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon>Delete</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \naria-label=\"Twitter\" class=\"md-icon-button md-mini\" hide show-gt-sm ng-click=\"vm.openUploadEmployee($event)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload File Employee</md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-800-fg\"></md-icon></md-button><span flex hide show-gt-sm></span></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">EMP No\n</span></th><th class=\"text-center\"><span class=\"column-title\">Full Name</span></th><th class=\"text-center\"><span \nclass=\"column-title\">BPJS Code</span></th><th class=\"text-center\"><span class=\"column-title\">Tax Code</span></th><th \nclass=\"text-center\"><span class=\"column-title\">OT Code</span></th><th class=\"text-center\"><span class=\"column-title\">\nTax Location</span></th><th class=\"text-center\"><span class=\"column-title\">Flag</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editPayrollEmployee($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisPayrollEmployeeSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.empno}}</td><td>\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.jamsostekcode}}</td><td \nclass=\"text-center\">{{ls.tax}}</td><td class=\"text-center\">{{ls.otcode}}</td><td class=\"text-center\">{{ls.taxlocation}}\n</td><td class=\"text-center\">{{ls.flag_report}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/payrollemployee/upload-file.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>\nUpload Update Payroll Employee</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" \nnv-file-select uploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll/payrollprocess/payrollprocess.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nPayroll Process</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container flex><label>Period</label><md-select ng-model=\"vm.Form.objForm.period\" name=\"period\" required>\n<md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls}}\">{{ls}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.Form.objForm.companyid\" name=\"companyid\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.companyid.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.Form.objForm.area\" name=\"area\"><md-option ng-repeat=\"ls in vm.listarea\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\">Submit</md-button></form></div></div>\n</div></div>");
$templateCache.put("app/main/payroll/prorateparameter/input-prorateparameter.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"ProrateForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,ProrateForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Prorate Parameter</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Company Name</label><md-select ng-model=\"vm.Form.objForm.companyname\" \nng-change=\"vm.changeStatus(vm.Form.objForm.companyname)\" ng-required=\"true\" name=\"companyname\"><md-option \nng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"ProrateForm.companyname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code Base\n</label><md-select ng-model=\"vm.Form.objForm.payrollcodebase\" \nng-change=\"vm.changePayrollBase(vm.Form.objForm.payrollcodebase)\" ng-required=\"true\" name=\"payrollcodebase\"><md-option \nng-repeat=\"s in vm.listallperiod\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"ProrateForm.payrollcodebase.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code Base is required.</span></div></div></md-input-container><md-input-container flex><label>\nPayroll Base Description</label><input type=\"text\" name=\"payrollbasedesc\" ng-model=\"vm.Form.objForm.payrollbasedesc\" \nplaceholder=\"Payroll Base Description\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label>Payroll Code Post</label><md-select ng-model=\"vm.Form.objForm.payrollcodepost\" \nng-change=\"vm.changePayrollPost(vm.Form.objForm.payrollcodepost)\" ng-required=\"true\" name=\"payrollcodepost\"><md-option \nng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"ProrateForm.payrollcodepost.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code Post is required.</span></div></div></md-input-container><md-input-container flex><label>\nPayroll Post Description</label><input type=\"text\" name=\"payrollpostdesc\" ng-model=\"vm.Form.objForm.payrollpostdesc\" \nplaceholder=\"Payroll Post Description\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label>Type</label><md-select ng-model=\"vm.Form.objForm.type\" ng-change=\"vm.changeType(vm.Form.objForm.type)\" \nng-required=\"true\" name=\"type\"><md-option ng-repeat=\"s in vm.listtype\" value=\"{{s}}\">{{s}}</md-option></md-select><div \nng-messages=\"ProrateForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Type is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Fix Days</label><input type=\"number\" name=\"fixdays\" \nid=\"fixdays\" ng-model=\"vm.Form.objForm.fixdays\" ng-required=\"vm.Form.objForm.type == \'Fix Days\'\" \nplaceholder=\"Fix Days\"></md-input-container></div><div layout-gt-sm=\"row\"></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"ProrateForm.$invalid || ProrateForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/prorateparameter/prorateparameter.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nProrate Parameter</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputProrateParameter($event,ls)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">New Prorate Paramater</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteProrateParameter()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nDelete Prorate Paramater</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputProrateParameter($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nNew Prorate Paramater</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteProrateParameter()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nDelete Prorate Paramater</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon>Delete</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">Company\n</span></th><th class=\"text-center\"><span class=\"column-title\">Payroll Code Base</span></th><th class=\"text-center\">\n<span class=\"column-title\">Payroll Base Desc</span></th><th class=\"text-center\"><span class=\"column-title\">\nPayroll Code Post</span></th><th class=\"text-center\"><span class=\"column-title\">Payroll Post Desc</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Type</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editProrateParameter($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisProrateParameterSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.companyname}}\n</td><td class=\"text-center\">{{ls.payrollcodebase}}</td><td class=\"text-center\">{{ls.payrollbasedesc}}</td><td \nclass=\"text-center\">{{ls.payrollcodepost}}</td><td class=\"text-center\">{{ls.payrollpostdesc}}</td><td \nclass=\"text-center\">{{ls.type}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/ptkp/input-ptkp.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"PtkpForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,PtkpForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form PTKP</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"PtkpForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Code</label><input type=\"text\" name=\"ptkpcode\" ng-model=\"vm.Form.objForm.ptkpcode\" \nplaceholder=\"PTKP Code\" required><div ng-messages=\"PtkpForm.ptkpcode.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>PTKP Code is required.</span></div></div></md-input-container><md-input-container flex><label>Amount</label>\n<input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div \nng-messages=\"PtkpForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"PtkpForm.$invalid || PtkpForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/ptkp/ptkp.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nPTKP Parameter</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputPtkp($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New PTKP Paramater</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeletePtkp()\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Delete PTKP Paramater</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputPtkp($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New PTKP Parameter</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeletePtkp()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete PTKP Parameter\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nEffective Date</span></th><th class=\"text-center\"><span class=\"column-title\">Code</span></th><th class=\"text-center\">\n<span class=\"column-title\">Amount</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editPtkp($event,ls.id)\"><td><input type=\"checkbox\" checklist-model=\"vm.lisPtkpSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ls.effective_date}}</td><td class=\"text-center\">{{ls.ptkpcode}}\n</td><td class=\"text-right\">{{ls.amount | currency:\"Rp\"}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div>\n<div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/salarycomponent/input-salarycomponent.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  /*width:800px;\n  height:100px;*/\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,SalcomForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Salary Component</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Code</label><input type=\"text\" name=\"code\" ng-model=\"vm.Form.objForm.code\" placeholder=\"Code\" required>\n<div ng-messages=\"SalcomForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>Code is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Description</label><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"SalcomForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Description is required.\n</span></div></div></md-input-container><md-input-container flex><label>Status</label><md-select \nng-model=\"vm.Form.objForm.status\" ng-change=\"vm.changeStatus(vm.Form.objForm.status)\" ng-required=\"true\" name=\"status\">\n<md-option ng-repeat=\"s in vm.liststatus\" value=\"{{s}}\">{{s}}</md-option></md-select><div \nng-messages=\"SalcomForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>Status is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Type</label><md-select ng-model=\"vm.Form.objForm.type\" \nng-change=\"vm.changeType(vm.Form.objForm.type)\" ng-required=\"true\" name=\"type\"><md-option ng-repeat=\"s in vm.listtype\" \nvalue=\"{{s}}\">{{s}}</md-option></md-select><div ng-messages=\"SalcomForm.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label>Formula</label><input type=\"text\" name=\"formula\" id=\"formula\" \nng-model=\"vm.Form.objForm.formula\" placeholder=\"Formula\" ng-required=\"vm.Form.objForm.type == \'Formula\'\"> <span \nstyle=\"font-size: 10px\">\nPetunjuk Pengisian Formula: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"toggle=!toggle\">\n{{toggle ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div id=\"box\" ng-show=\"toggle\"><fieldset \nclass=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend><div layout=\"row\" layout-wrap flex>\n<div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"33\"><label>THP</label><md-select ng-model=\"vm.Form.objForm.thp\" \nng-change=\"vm.changeThp(vm.Form.objForm.thp)\" ng-required=\"true\" name=\"thp\"><md-option ng-repeat=\"s in vm.listthp\" \nvalue=\"{{s}}\">{{s}}</md-option></md-select><div ng-messages=\"SalcomForm.thp.$error\" role=\"alert\"><div \nng-message=\"required\"><span>THP is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/salarycomponent/salarycomponent.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nSalary Component</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputSalaryComponent($event,ls)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">New Salary Component</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteSalaryComponent()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nDelete Salary Component</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputSalaryComponent($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nNew Salary Component</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\">\n</md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteSalaryComponent()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nDelete Salary Component</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon>Delete</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">Code</span>\n</th><th class=\"text-center\"><span class=\"column-title\">Description</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Status</span></th><th class=\"text-center\"><span class=\"column-title\">Type</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Formula</span></th><th class=\"text-center\"><span class=\"column-title\">\nTHP</span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editSalaryComponent($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisSalaryComponentSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.code}}</td><td>\n{{ls.description}}</td><td class=\"text-center\">{{ls.status}}</td><td class=\"text-center\">{{ls.type}}</td><td \nclass=\"text-center\">{{ls.formula}}</td><td class=\"text-center\">{{ls.thp}}</td></tr></tbody><tbody></tbody></table>\n</md-toolbars></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/positionrate/input-positionrate.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"PositionForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,PositionForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Position Rate</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"AbsentForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Company Name</label><md-select ng-model=\"vm.Form.objForm.companyid\" \nng-change=\"vm.changeStatus(vm.Form.objForm.companyid)\" ng-required=\"true\" name=\"companyid\"><md-option \nng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"AbsentForm.companyid.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Position Code\n</label><md-select ng-model=\"vm.Form.objForm.positioncode\" ng-change=\"vm.changePosition(vm.Form.objForm.positioncode)\" \nng-required=\"true\" name=\"positioncode\"><md-option ng-repeat=\"s in vm.listposition\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"PositionForm.positioncode.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Position Code is required.</span></div></div></md-input-container><md-input-container flex><label>Position Desc\n</label><input type=\"text\" name=\"positiondesc\" ng-model=\"vm.Form.objForm.positiondesc\" placeholder=\"Position Desc\">\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label><md-select \nng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" \nname=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select>\n<div ng-messages=\"PositionForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>Payroll Code is required.\n</span></div></div></md-input-container><md-input-container flex><label>Payroll Desc</label><input type=\"text\" \nname=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Position Desc\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex=\"66\"><label>Amount</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div ng-messages=\"PositionForm.amount.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"vm.Form.objForm.flag_prorate\" \nclass=\"md-primary\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">Flag Prorate</md-checkbox></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"PositionForm.$invalid || PositionForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/positionrate/positionrate.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nPosition Rate</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputPositionRate($event,ls)\"><md-tooltip\n md-direction=\"right\" md-visible=\"tooltipVisible\">New Position Rate</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeletePositionRate()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Delete Position Rate\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputPositionRate($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Position Rate</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeletePositionRate()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Position Rate\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nEffective Date</span></th><th class=\"text-center\"><span class=\"column-title\">Company Code</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Position Code</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Position Desc</span></th><th class=\"text-center\"><span class=\"column-title\">Payroll Code</span>\n</th><th class=\"text-center\"><span class=\"column-title\">Payroll Desc</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Amount</span></th><th class=\"text-center\"><span class=\"column-title\">Flag Prorate</span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editPositionRate($event,ls.id)\"><td><input \ntype=\"checkbox\" checklist-model=\"vm.lisPositionRateSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date}}</td><td class=\"text-center\">{{ls.companyname}}</td><td class=\"text-center\">{{ls.positioncode}}\n</td><td class=\"text-center\">{{ls.positiondesc}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td><td \nclass=\"text-center\">{{ls.flag_prorate}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/shiftrate/input-shiftrate.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  width:800px;\n  height:100px;\n}</style>\n<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"ShiftForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,ShiftForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Shift Rate</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"AbsentForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Company Name</label><md-select ng-model=\"vm.Form.objForm.companyname\" \nng-change=\"vm.changeStatus(vm.Form.objForm.companyname)\" ng-required=\"true\" name=\"companyname\"><md-option \nng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"AbsentForm.companyname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Position Code\n</label><md-select ng-model=\"vm.Form.objForm.poscode\" ng-change=\"vm.changePosition(vm.Form.objForm.poscode)\" \nng-required=\"true\" name=\"poscode\"><md-option ng-repeat=\"s in vm.listposition\" value=\"{{s.id}}\">{{s.name}}</md-option>\n</md-select><div ng-messages=\"ShiftForm.poscode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPosition Code is required.</span></div></div></md-input-container><md-input-container flex><label>Position Description\n</label><input type=\"text\" name=\"posdesc\" ng-model=\"vm.Form.objForm.posdesc\" placeholder=\"Position Description\" \nrequired></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Shift Code</label>\n<md-select ng-model=\"vm.Form.objForm.shiftcode\" ng-change=\"vm.changeShift(vm.Form.objForm.shiftcode)\" \nng-required=\"true\" name=\"shiftcode\"><md-option ng-repeat=\"s in vm.listshift\" value=\"{{s.id}}\">{{s.name}}</md-option>\n</md-select><div ng-messages=\"ShiftForm.shiftcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nShift Code is required.</span></div></div></md-input-container><md-input-container flex><label>Shift Description\n</label><input type=\"text\" name=\"shiftdesc\" ng-model=\"vm.Form.objForm.shiftdesc\" placeholder=\"Shift Description\" \nrequired></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label>\n<md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changeStatus(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"ShiftForm.payrollcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox md-no-ink \naria-label=\"Checkbox No Ink\" ng-model=\"vm.Form.objForm.flag_prorate\" class=\"md-primary\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\">Flag Prorate</md-checkbox></div><div layout-gt-sm=\"row\"><md-input-container flex=\"77\"><label>\nFormula</label><input type=\"text\" name=\"formula\" ng-model=\"vm.Form.objForm.formula\" placeholder=\"Formula\" required> \n<span style=\"font-size: 10px\">\nPetunjuk Pengisian Formula: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"toggle=!toggle\">\n{{toggle ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div id=\"box\" ng-show=\"toggle\" \nclass=\"check-element animate-show-hide\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">\nPayroll Component View</legend><div layout=\"row\" layout-wrap flex><div flex-xs flex=\"50\"></div><div \nclass=\"demo-select-all-checkboxes\" flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"ShiftForm.$invalid || ShiftForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/shiftrate/shiftrate.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nShift Rate</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputShiftRate($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New Shift Rate</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeleteShiftRate()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Delete Shift Rate</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputShiftRate($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Shift Rate</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteShiftRate()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Shift Rate\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nEffective Date</span></th><th class=\"text-center\"><span class=\"column-title\">Company Code</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Position Code</span></th><th class=\"text-center\"><span \nclass=\"column-title\">Position Description</span></th><th class=\"text-center\"><span class=\"column-title\">Shift Code\n</span></th><th class=\"text-center\"><span class=\"column-title\">Shift Description</span></th><th class=\"text-center\">\n<span class=\"column-title\">Payroll Code</span></th><th class=\"text-center\"><span class=\"column-title\">\nPayroll Description</span></th><th class=\"text-center\"><span class=\"column-title\">Formula</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Flag Prorate</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editShiftRate($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisShiftRateSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.effective_date}}</td>\n<td class=\"text-center\">{{ls.companyname}}</td><td class=\"text-center\">{{ls.positioncode}}</td><td class=\"text-center\">\n{{ls.positiondesc}}</td><td class=\"text-center\">{{ls.shiftcode}}</td><td class=\"text-center\">{{ls.shiftdesc}}</td><td \nclass=\"text-center\">{{ls.payrollcode}}</td><td class=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">\n{{ls.formula}}</td><td class=\"text-center\">{{ls.flag_prorate}}</td></tr></tbody><tbody></tbody></table></md-toolbars>\n</div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/sync-pma/sync-pma.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nProcess Sync To PMA</div><md-icon style=\"font-size:16px\" md-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader>\n<div class=\"white-bg\"><md-content layout=\"column\"><div layout=\"column\" flex><div id=\"filterForm\" flex \nclass=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmSync\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Sub Area</label><md-select required name=\"field\" ng-model=\"vm.selectedSubArea\" \ndata-md-container-class=\"selectdemoSelectHeader\"><md-select-header layout=\"column\" class=\"demo-select-header\">\n<md-input-container><input ng-model=\"vm.searchText\" type=\"search\" \nng-model-options=\"{debounce: {\'default\': 500, \'blur\': 0}}\" placeholder=\"Search...\" \nclass=\"demo-header-searchbox md-text\"></md-input-container></md-select-header><md-optgroup><md-option ng-value=\"item\" \nng-repeat=\"item in vm.sub_areaLists | filter:vm.searchText\">{{item.description}}</md-option></md-optgroup></md-select>\n<div ng-messages=\"frmSync.sub_area.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Add Employee By Sub Area\" ng-click=\"vm.addEmployeeBySubArea(vm.selectedSubArea)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span>Add Employee By Sub Area</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-account-multiple-plus material-icons\">\n</md-icon><span>Add Employee By Sub Area</span></md-button></div></form></div></div></md-content><md-toolbar \nclass=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-warn md-mini\" aria-label=\"Delete\" \nng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete\n</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><div class=\"divider-vertical\">\n</div><md-button ng-disabled=\"vm.isLoading\" class=\"blue-500-fg md-mini\" aria-label=\"Synchronize\" \nng-click=\"vm.syncData($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nSynchronize</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" style=\"font-size:15px\" \nclass=\"md-font blue-500-fg icon-sync material-icons\"></md-icon><span>Synchronize</span></md-button><span flex></span>\n</div></md-toolbar><md-progress-linear ng-if=\"vm.isLoading\" md-mode=\"determinate\" value=\"{{vm.determinateValue}}\">\n</md-progress-linear><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><div \nid=\"tableMpp\"><table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr>\n<th style=\"min-width: 50px\"><md-checkbox class=\"no-label\" ng-model=\"vm.toggle_all\" ng-click=\"vm.toggleAll()\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\"></md-checkbox></th><th>No</th><th>NIK</th><th>EMPLOYEE NAME</th>\n<th>SUB AREA</th><th>#</th></tr></thead><tbody><tr ng-repeat=\"item in vm.employeeLists\"><td \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(item)\" ng-click=\"vm.toggle($event, item)\" ng-model=\"item.checked\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ $index + 1 }}</td>\n<td>{{ item.nik }}</td><td>{{ item.fullname }}</td><td class=\"text-center\">{{ item.sub_area_name }}</td><td \nclass=\"text-center\"><a href=\"javascript:void(0);\" ng-click=\"vm.edit($event, item)\" style=\"text-decoration: none\"><span \nclass=\"icon-pencil\"></span></a></td></tr></tbody></table></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll/syncemployee/syncemployee.html","<div id=\"page_talent\" class=\"page-layout simple fullwidth\"><div class=\"header header-talent md-accent-bg\"><span \nclass=\"md-display-1 font-weight-300\">Process Sync Employee</span></div><div class=\"content\"><div layout-xs=\"column\" \nlayout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><button md-button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.ResyncEmployee()\"><i \nclass=\"icon icon-file-excel\"></i> Resync Employee</button> <button md-button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.UpdateEmployee()\"><i \nclass=\"icon icon-file-excel\"></i> Update Employee</button></div></div></div></div>");
$templateCache.put("app/main/payroll/taxparameter/input-taxparameter.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"TaxParamForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,TaxParamForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Tax Parameter</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Code</label><input type=\"text\" name=\"taxcode\" ng-model=\"vm.Form.objForm.taxcode\" placeholder=\"TaxCode\" \nrequired><div ng-messages=\"TaxParamForm.taxcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTax Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label>Description</label><input type=\"text\" name=\"taxdesc\" ng-model=\"vm.Form.objForm.taxdesc\" \nplaceholder=\"Tax Description\" required><div ng-messages=\"TaxParamForm.taxdesc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Tax Description is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>PPh Posting</label><md-select \nng-model=\"vm.Form.objForm.pphpostingcode\" ng-change=\"vm.changeStatus(vm.Form.objForm.pphpostingcode)\" \nng-required=\"true\" name=\"pphpostingcode\"><md-option ng-repeat=\"s in vm.listSalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"TaxParamForm.pphpostingcode.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Pph Posting required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex=\"66\"><label>Gaji / Pensiun</label><input type=\"text\" name=\"T01gross\" ng-model=\"vm.Form.objForm.T01gross\" \nplaceholder=\"Gaji / Pensiun\" required> <span style=\"font-size: 10px\">\nPetunjuk Pengisian Gaji/Pensiun: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"TaxParamForm.T01gross.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nGaji/Pensiun required.</span></div></div></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" \nng-click=\"T01gross=!T01gross\">{{T01gross ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div id=\"box\" \nng-show=\"T01gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend><div \nlayout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset>\n</div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label>Tunj Lainnya, Uang lembur, DSB</label><input \ntype=\"text\" name=\"T03gross\" ng-model=\"vm.Form.objForm.T03gross\" placeholder=\"Tunjangan\" required> <span \nstyle=\"font-size: 10px\">\nPetunjuk Pengisian Tunj Lainnya, Uang lembur, DSB: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"TaxParamForm.T03gross.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTunj Lainnya, Uang lembur, DSB required.</span></div></div></md-input-container><md-input-container flex=\"33\"><a \nid=\"toggleMessage\" ng-click=\"T03gross=!T03gross\">{{T03gross ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div \nid=\"box\" ng-show=\"T03gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend>\n<div layout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div>\n</fieldset></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label>Honorarium dan sejenisnya</label><input \ntype=\"text\" name=\"T04gross\" ng-model=\"vm.Form.objForm.T04gross\" placeholder=\"Honorarium\" required> <span \nstyle=\"font-size: 10px\">\nPetunjuk Pengisian Honorarium dan sejenisnya: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"TaxParamForm.T04gross.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nHonorarium dan sejenisnya required.</span></div></div></md-input-container><md-input-container flex=\"33\"><a \nid=\"toggleMessage\" ng-click=\"T04gross=!T04gross\">{{T04gross ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div \nid=\"box\" ng-show=\"T04gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend>\n<div layout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div>\n</fieldset></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label>Premi Asuransi dibayar perusahaan</label>\n<input type=\"text\" name=\"T05gross\" ng-model=\"vm.Form.objForm.T05gross\" placeholder=\"Premi Asuransi\" required> <span \nstyle=\"font-size: 10px\">\nPetunjuk Pengisian Premi Asuransi dibayar perusahaan: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"TaxParamForm.T05gross.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPremi Asuransi dibayar perusahaan required.</span></div></div></md-input-container><md-input-container flex=\"33\"><a \nid=\"toggleMessage\" ng-click=\"T05gross=!T05gross\">{{T05gross ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div \nid=\"box\" ng-show=\"T05gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend>\n<div layout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div>\n</fieldset></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label>Penerimaan Natura dan lainnya</label>\n<input type=\"text\" name=\"T06gross\" ng-model=\"vm.Form.objForm.T06gross\" placeholder=\"Penerimaan Natura\" required> <span \nstyle=\"font-size: 10px\">\nPetunjuk Pengisian Penerimaan Natura dan lainnya: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"TaxParamForm.T06gross.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPenerimaan Natura dan lainnya required.</span></div></div></md-input-container><md-input-container flex=\"33\"><a \nid=\"toggleMessage\" ng-click=\"T06gross=!T06gross\">{{T06gross ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div \nid=\"box\" ng-show=\"T06gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend>\n<div layout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div>\n</fieldset></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label>\nTantiem, Bonus, Gratifikasi, Jasa Produksi dan THR</label><input type=\"text\" name=\"T07gross\" \nng-model=\"vm.Form.objForm.T07gross\" placeholder=\"Tantiem, Bonus, Gratifikasi, Jasa Produksi, THR\" required> <span \nstyle=\"font-size: 10px\">\nPetunjuk Pengisian Tantiem, Bonus, Gratifikasi, Jasa Produksi dan THR: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"TaxParamForm.T07gross.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTantiem, Bonus, Gratifikasi, Jasa Produksi dan THR required.</span></div></div></md-input-container><md-input-container\n flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T07gross=!T07gross\">{{T07gross ? \'Hide\' : \'Show\'}}</a></md-input-container>\n</div><div id=\"box\" ng-show=\"T07gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">\nPayroll Component View</legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">\n{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\"><md-input-container flex><label>\nBiaya Jabatan Atas Peghasilan (%)</label><input type=\"number\" name=\"biayajabatan\" \nng-model=\"vm.Form.objForm.biayajabatan\" placeholder=\"Biaya Jabatan\"></md-input-container><md-input-container flex>\n<label>Nilai Max</label><input type=\"number\" name=\"biayajabatanmax\" ng-model=\"vm.Form.objForm.biayajabatanmax\" \nplaceholder=\"Biaya Jabatan Max\" required><div ng-messages=\"TaxParamForm.biayajabatanmax.$error\" role=\"alert\"><div \nng-message=\"required\">Nilai Max <span>Nilai MAX is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex=\"33\"><label>Iuran Pensiun, JHT</label><input type=\"text\" name=\"T10\" \nng-model=\"vm.Form.objForm.T10\" placeholder=\"Iuran Pensiun & JHT\" required> <span style=\"font-size: 10px\">\nPetunjuk Pengisian Iuran Pensiun, JHT: yang boleh di masukan adalah list komponen yang ada di tombol \'Show\' di kombinasi dengan simbol +,-,/,* dan angka-angka, selain itu tidak boleh dimasukan\n</span><div ng-messages=\"TaxParamForm.T10.$error\" role=\"alert\"><div ng-message=\"required\">Iuran Pensiun dll <span>\nIuran Pensiun is required.</span></div></div></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" \nng-click=\"T10gross=!T10gross\">{{T10gross ? \'Hide\' : \'Show\'}}</a></md-input-container></div><div id=\"box\" ng-show=\"T10\">\n<fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">Payroll Component View</legend><div layout=\"row\" \nlayout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div \nlayout-gt-sm=\"row\"><md-input-container><label>Non NPWP Pinalty</label><input type=\"number\" name=\"nonnpwp_pinalty\" \nng-model=\"vm.Form.objForm.nonnpwp_pinalty\" placeholder=\"Non NPWP Pinalty\" required><div \nng-messages=\"TaxParamForm.nonnpwp_pinalty.$error\" role=\"alert\"><div ng-message=\"required\">Nonnpwp <span>\nNon Npwp is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label>PKP 1</label><input type=\"number\" name=\"pkp1_limit=\" ng-model=\"vm.Form.objForm.pkp1_limit\" \nplaceholder=\"Limit Amount\" required><div ng-messages=\"TaxParamForm.pkp1_limit.$error\" role=\"alert\"><div \nng-message=\"required\">PKP 1 Limit <span>Limit PKP 1 is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"pkp1\" ng-model=\"vm.Form.objForm.pkp1\" placeholder=\"Percentage (%)\" \nrequired><div ng-messages=\"TaxParamForm.pkp1.$error\" role=\"alert\"><div ng-message=\"required\">PKP 1 Percentage <span>\nPercentage PKP 1 is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>PKP 2</label><input type=\"number\" name=\"pkp2_limit\" ng-model=\"vm.Form.objForm.pkp2_limit\" \nplaceholder=\"Limit Amount\" required><div ng-messages=\"TaxParamForm.pkp2_limit.$error\" role=\"alert\"><div \nng-message=\"required\">PKP 2 Limit <span>Limit PKP 2 is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"pkp2\" ng-model=\"vm.Form.objForm.pkp2\" placeholder=\"Percentage (%)\" \nrequired><div ng-messages=\"TaxParamForm.pkp2.$error\" role=\"alert\"><div ng-message=\"required\">PKP 2 Percentage <span>\nPercentage PKP 2 is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>PKP 3</label><input type=\"number\" name=\"pkp3_limit\" ng-model=\"vm.Form.objForm.pkp3_limit\" \nplaceholder=\"Limit Amount\" required><div ng-messages=\"TaxParamForm.pkp3_limit.$error\" role=\"alert\"><div \nng-message=\"required\">PKP 3 Limit <span>Limit PKP 3 is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"pkp3\" ng-model=\"vm.Form.objForm.pkp3\" placeholder=\"Percentage (%)\" \nrequired><div ng-messages=\"TaxParamForm.pkp3.$error\" role=\"alert\"><div ng-message=\"required\">PKP 3 Percentage <span>\nPercentage PKP 3 is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>PKP 4</label><input type=\"number\" name=\"pkp4_limit\" ng-model=\"vm.Form.objForm.pkp4_limit\" \nplaceholder=\"Limit Amount\" required><div ng-messages=\"TaxParamForm.pkp4_limit.$error\" role=\"alert\"><div \nng-message=\"required\">PKP 4 Limit <span>Limit PKP 4 is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"pkp4\" ng-model=\"vm.Form.objForm.pkp4\" placeholder=\"Percentage (%)\" \nrequired><div ng-messages=\"TaxParamForm.pkp4.$error\" role=\"alert\"><div ng-message=\"required\">PKP 4 Percentage <span>\nPercentage PKP 4 is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"TaxParamForm.$invalid || TaxParamForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll/taxparameter/taxparameter.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nTax Parameter</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputTaxParameter($event,ls)\"><md-tooltip\n md-direction=\"right\" md-visible=\"tooltipVisible\">New Tax Parameter</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteTaxParameter()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Delete Tax Parameter\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputTaxParameter($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Tax Parameter</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteTaxParameter()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Tax Parameter\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">Tax Code\n</span></th><th class=\"text-center\"><span class=\"column-title\">Tax Description</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editTaxParameter($event,ls.id)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.lisTaxParameterSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.taxcode}}</td><td \nclass=\"text-center\">{{ls.taxdesc}}</td></tr></tbody><tbody></tbody></table></md-toolbars></div><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll/uploadfixnonfix/upload-data.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page md-background-bg md-hue-1\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Upload Data\n</span></div><div class=\"title\">Upload Data Fix dan Non Fix Entry</div></div></div><div class=\"content\"><div \nlayout=\"row\" layout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset style=\"margin-top:150px\"><legend>Upload Data Fix Entry</legend><md-content \nlayout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><input \ntype=\"file\" id=\"uploadFileFixEntry\" nv-file-select uploader=\"vm.FileUploaderFixEntry\"></div><div flex><md-button \ntype=\"button\" ng-click=\"vm.FileUploaderFixEntry.uploadAll()\" class=\"md-raised md-black-500-bg white-fg\" \naria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" class=\"white-fg\"></md-icon>Upload</md-button></div></div>\n<md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderFixEntry.progress}}\" class=\"md-accent hue-2\">\n</md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadFixEntryStateError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.UploadFixEntryStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Success Upload data</span>\n</md-whiteframe></md-content></fieldset><fieldset style=\"margin-top:20px\"><legend>Upload Data Non Fix Entry</legend>\n<md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div \nflex><input type=\"file\" id=\"uploadFileNonFixEntry\" nv-file-select uploader=\"vm.FileUploaderNonFixEntry\"></div><div \nflex><md-button type=\"button\" ng-click=\"vm.FileUploaderNonFixEntry.uploadAll()\" \nclass=\"md-raised md-black-500-bg white-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" class=\"white-fg\">\n</md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderNonFixEntry.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadNonFixEntryStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadNonFixEntryStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-content>\n</fieldset><ms-widget flippable=\"true\" layout=\"column\" ng-show=\"basicForm.description.$valid\" class=\"fade\">\n<ms-widget-front class=\"p-16 {{vm.messageTheme}}-400-bg white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>test</p></ms-widget-front></ms-widget><div layout=\"column\" \nlayout-align=\"center center\"></div></form></div></div></div></div>");
$templateCache.put("app/main/pkwt/management-ir/management-ir.html","<div id=\"custom-wrapper\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg title-header\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex class=\"logo-text\">\nPKWT Management IR</div><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.isCollapse = !vm.isCollapse\" \nflex-gt-sm=\"5\" flex=\"10\"><md-icon ng-class=\"{\'rotate-up\' : vm.isCollapse, \'rotate-down\': !vm.isCollapse}\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></md-button></div></md-subheader><div class=\"white-bg\"><md-content \nclass=\"filter-content\" layout-padding ng-show=\"vm.isCollapse\"><form name=\"userForm\" flex-gt-sm \nlayout-align=\"center end\" layout-gt-xs=\"row\"><span hide show-gt-sm flex></span> <span hide show-gt-sm flex></span>\n<md-input-container class=\"md-block\" flex-gt-xs><label>Type</label><md-select ng-model=\"vm.pkwtType\"><md-option \nng-repeat=\"item in vm.pkwtTypeList\" ng-value=\"item.id\">{{item.description}}</md-option></md-select><div show \nhide-gt-sm class=\"md-errors-spacer\"></div></md-input-container><div class=\"filter-divider\" hide show-gt-sm></div><div \nflex-gt-sm=\"5\" class=\"md-block filter-action\"><md-button class=\"md-primary md-raised btn-block\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.loadData(1)\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button></div></form>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"total-data\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><md-button class=\"md-primary md-small\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.loadData(1)\"><md-icon md-font-icon=\"icon-refresh\">\n</md-icon><span>Reload</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nng-disabled=\"vm.selected.length == 0\" class=\"md-accent md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.printOut(false, null)\"><md-icon md-font-icon=\"icon-printer\"></md-icon><span>Print</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\"></ms-search-bar><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" \nng-click=\"vm.printPDF($event, false, null)\"><md-icon md-font-icon=\"icon-print\"></md-icon><span>PRINT</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\" ms-scroll><div id=\"table-addendum\" class=\"table-container-content\"><table \nclass=\"simple bordered stripped\" ms-responsive-table><thead><tr><th><div flex layout-align=\"center\" layout=\"row\"><input\n type=\"checkbox\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></div>\n</th><th>No</th><th>NIK</th><th>Name</th><th>No PKWT</th><th>Position</th><th>Start Contract</th><th>End Contract</th>\n<th>Release Date</th><th>Type</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTables.list\"><td>\n<div flex layout-align=\"center\" layout=\"row\"><input ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\" type=\"checkbox\"></div></td><td class=\"text-center\">{{ $index + 1}}</td><td \nclass=\"text-center\">{{ item.nik }}</td><td>{{ item.name }}</td><td class=\"text-center\"><a href=\"#\" \nng-click=\"$event.preventDefault(); vm.viewPkwt($event, item)\">{{ item.letter_number }}</a></td><td>{{ item.job_title }}\n</td><td class=\"text-center\">{{ item.start_contract }}</td><td class=\"text-center\">{{ item.end_contract }}</td><td \nclass=\"text-center\">{{ item.release_date }}</td><td class=\"text-center\">{{item.pkwt_type}}</td><td class=\"text-center\">\n<md-menu><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nwidth=\"4\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-primary\" type=\"button\" aria-label=\"edit\" \nng-click=\"vm.showCreateForm($event, true, item)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><span>Edit</span>\n</md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-warn\" type=\"button\" \naria-label=\"edit\" ng-click=\"vm.deletePkwt($event, item)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><span>Delete\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple blue-500-fg\" type=\"button\" \naria-label=\"edit\" ng-click=\"vm.viewAmandemen(ev, item, false)\"><md-icon class=\"blue-500-fg\" \nmd-font-icon=\"icon-calendar-plus\"></md-icon><span>Amandemen</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></div><div ng-if=\"vm.DataTables.list.length > 0\" class=\"mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pkwt/management-ta/management-ta.html","<div id=\"custom-wrapper\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg title-header\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex class=\"logo-text\">\nPKWT Management TA</div><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.isCollapse = !vm.isCollapse\" \nflex-gt-sm=\"5\" flex=\"10\"><md-icon ng-class=\"{\'rotate-up\' : vm.isCollapse, \'rotate-down\': !vm.isCollapse}\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></md-button></div></md-subheader><div class=\"white-bg\"><md-content \nclass=\"filter-content\" layout-padding ng-show=\"vm.isCollapse\"><form name=\"userForm\" flex-gt-sm \nlayout-align=\"center end\" layout-gt-xs=\"row\"><span hide show-gt-sm flex></span> <span hide show-gt-sm flex></span>\n<md-input-container class=\"md-block\" flex-gt-xs><label>Type</label><md-select ng-disabled=\"true\" \nng-model=\"vm.pkwtType\"><md-option ng-repeat=\"item in vm.pkwtTypeList\" ng-value=\"item.id\">{{item.description}}\n</md-option></md-select><div show hide-gt-sm class=\"md-errors-spacer\"></div></md-input-container><div \nclass=\"filter-divider\" hide show-gt-sm></div><div flex-gt-sm=\"5\" class=\"md-block filter-action\"><md-button \nclass=\"md-primary md-raised btn-block\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.loadData(1)\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon></md-button></div></form></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"total-data\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><md-button class=\"md-teal-bg md-raised white-fg custom-button\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.uploadPkwt($event)\"><span>UPLOAD</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button ng-disabled=\"vm.selected.length == 0\" \nclass=\"md-deep-purple-bg md-raised white-fg custom-button\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.printOut(false, null, false)\"><span>PRINT PKWT</span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button ng-disabled=\"vm.selected.length == 0\" \nclass=\"md-deep-orange-bg md-raised white-fg custom-button\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.printOut(false, null, true)\"><span>PRINT LOA</span></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"pink-bg md-raised white-fg custom-button\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.showRulesForm($event)\"><span>PKWT RULES</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\"></ms-search-bar><md-menu md-offset=\"0 -7\" \nhide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" \nng-click=\"vm.printPDF($event, false, null)\"><md-icon md-font-icon=\"icon-print\"></md-icon><span>PRINT</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\" ms-scroll><div id=\"table-ta\" class=\"table-container-content\"><table \nclass=\"simple bordered stripped\" ms-responsive-table><thead><tr><th><div flex layout-align=\"center\" layout=\"row\"><input\n type=\"checkbox\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></div>\n</th><th>No</th><th>NIK</th><th>Name</th><th>ID No</th><th>PKWT No</th><th>grade</th><th>Position</th><th>Division</th>\n<th>Start Contract</th><th>End Contract</th><th>Release Date</th><th>Area Code</th><th>Area Name</th><th>Adress</th>\n<th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTables.list\"><td><div flex layout-align=\"center\" \nlayout=\"row\"><input ng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\" type=\"checkbox\">\n</div></td><td class=\"text-center\">{{ $index + 1}}</td><td class=\"text-center\">{{ item.nik }}</td><td>{{ item.name }}\n</td><td>{{ item.no_ktp }}</td><td class=\"text-center\"><a href=\"#\" \nng-click=\"$event.preventDefault(); vm.viewPkwt($event, item)\">{{ item.letter_number }}</a></td><td class=\"text-center\">\n{{item.grade}}</td><td>{{ item.job_title }}</td><td class=\"text-center\">{{item.division}}</td><td class=\"text-center\">\n{{ item.start_contract }}</td><td class=\"text-center\">{{ item.end_contract }}</td><td class=\"text-center\">\n{{ item.release_date }}</td><td class=\"text-center\">{{item.code_area}}</td><td class=\"text-center\">{{item.area_name}}\n</td><td class=\"text-center\">{{item.address}}</td><td class=\"text-center\"><md-menu><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"4\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-primary\" type=\"button\" aria-label=\"edit\" \nng-click=\"vm.updatePkwtForm($event, item)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><span>Edit</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-disabled=\"item.has_child\" class=\"md-button md-ink-ripple md-warn\" \ntype=\"button\" aria-label=\"edit\" ng-click=\"vm.deletePkwt($event, item)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<span>Delete</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></div><div \nng-if=\"vm.DataTables.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pkwt/pkwt-form/pkwt-form.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" class=\"dialog-custom-wrapper\" ms-scroll flex=\"65\"><form \nng-cloak name=\"formPkwt\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><h4>{{vm.formTitle}}\n</h4><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"margin-top:0px\" \nlayout-padding><div class=\"overlay\" ng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill \nlayout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-accent\">\n</md-progress-circular><div class=\"padding-top-10\">Please wait ..</div></div></div><div flex layout=\"row\">\n<md-input-container flex-gt-sm=\"35\"><label>Pilih Jenis Surat</label><md-select name=\"pkwt_type\" \nng-disabled=\"vm.isEdit || vm.isFromDialog\" ng-change=\"vm.onChangePkwtType()\" ng-model=\"vm.pkwtType\"><md-option \nng-repeat=\"item in vm.pkwtTypeList\" ng-value=\"item.id\">{{item.description}}</md-option></md-select>\n</md-input-container><md-autocomplete ng-if=\"vm.pkwtType\" flex-gt-sm ng-readonly=\"vm.isEdit\" \nclass=\"custom-autocomplete\" md-delay=\"1000\" md-no-cache=\"true\" md-clear-button=\"!vm.isEdit\" \nmd-floating-label=\"{{vm.pkwtSubject.label}}\" md-selected-item=\"vm.pkwtSubject.value\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" ng-required=\"true\" md-search-text=\"vm.searchText\" \nmd-input-name=\"pkwt_subject\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"vm.getItemText(item)\" \nmd-min-length=\"2\"><md-item-template><span class=\"item-title\" md-highlight-text=\"vm.searchText\">\n{{ vm.getHighlight(item) | uppercase }}</span></md-item-template><div ng-messages=\"formPkwt.pkwt_subject.$error\" \nrole=\"alert\"><div ng-message=\"required\">{{vm.pkwtSubject.error}}</div></div><md-not-found>\nNo Record matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></div><div flex layout=\"row\" \nng-if=\"vm.pkwtSubject.value\"><fieldset flex=\"55\"><legend>Informasi Karyawan</legend><div flex layout=\"row\"><div \nflex=\"30\"><img class=\"form-image\" ng-src=\"api/empdocument/{{vm.pkwtSubject.value.employee.photo_address}}\" \non-error-src=\"assets/images/avatars/unprofile.jpg\" alt=\"\"></div><div flex layout=\"column\"><md-input-container \nclass=\"no-spacer\"><label>Nama Karyawan</label><input type=\"text\" ng-value=\"vm.pkwtSubject.value.employee.name\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"no-spacer\"><label>Jabatan</label><input \ntype=\"text\" ng-value=\"vm.pkwtSubject.value.employee.job_title\" readonly=\"readonly\"></md-input-container>\n<md-input-container class=\"no-spacer\"><label>Division</label><input type=\"text\" \nng-value=\"vm.pkwtSubject.value.employee.division\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"no-spacer\"><label>Code Area</label><input type=\"text\" ng-value=\"vm.pkwtSubject.value.employee.code_area\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"no-spacer\"><label>Area</label><input type=\"text\" \nng-value=\"vm.pkwtSubject.value.employee.sub_area_name\" readonly=\"readonly\"></md-input-container></div></div></fieldset>\n<span flex=\"5\"></span><div flex layout=\"column\"><md-input-container \nng-if=\"vm.pkwtType === \'PKWT_AMANDEMEN\' || vm.pkwtType === \'PKWT_PERPANJANGAN_AMANDEMEN\'\"><label>No Amandemen</label>\n<input only-numbers type=\"text\" ng-readonly=\"vm.isEdit\" required name=\"amandemen_order\" ng-model=\"vm.amandemenOrder\">\n<div ng-messages=\"formPkwt.amandemen_order.$error\" role=\"alert\"><div ng-message=\"required\">Nomor amandemen wajib diisi\n</div></div></md-input-container><md-input-container><label>Tgl. Terbit Surat</label><input required \nname=\"release_date\" ng-change=\"vm.renderPkwtNumber()\" ng-model=\"vm.tempRelease\" type=\"date\"><div \nng-messages=\"formPkwt.release_date.$error\" role=\"alert\"><div ng-message=\"required\">Tgl. terbit surat wajib diisi</div>\n</div></md-input-container><md-input-container><label>Tgl. Mulai Kontrak</label><input required name=\"start_contract\" \nng-model=\"vm.tempStart\" type=\"date\"><div ng-messages=\"formPkwt.start_contract.$error\" role=\"alert\"><div \nng-message=\"required\">Tgl. mulai kontrak wajib diisi</div></div></md-input-container><md-input-container><label>\nLama Kontrak (bulan)</label><input required name=\"contract_period\" ng-model=\"vm.contractPeriod\" only-numbers \ntype=\"text\"><div ng-messages=\"formPkwt.contract_period.$error\" role=\"alert\"><div ng-message=\"required\">\nLama Contract wajib diisi</div></div></md-input-container><md-input-container><label>No PKWT</label><input \nreadonly=\"readonly\" name=\"letter_number\" ng-model=\"vm.letterNumber\" type=\"text\"></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" flex><div layout-align=\"start center\" flex \nng-class=\"{success:vm.success, error:!vm.success}\" ng-show=\"vm.showMessage\" class=\"form-message fade\">{{ vm.message }}\n</div><div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button ng-if=\"!vm.isEdit\" \nclass=\"md-primary md-raised white-fg\" ng-click=\"vm.submit(formPkwt)\" \nng-disabled=\"formPkwt.$invalid || formPkwt.$pristine || vm.saveProccess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-if=\"vm.isEdit\" \nclass=\"md-warn md-raised white-fg\" ng-click=\"vm.update($event, formPkwt)\" \nng-disabled=\"formPkwt.$invalid || formPkwt.$pristine || vm.saveProccess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Update</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pkwt/pkwt-childs/pkwt-childs.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll class=\"dialog-custom-wrapper\" flex=\"80\">\n<md-toolbar><div class=\"md-toolbar-tools title\"><h4>PKWT Amandemen List</h4><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"margin-top:0px; min-height: 200px\"><div class=\"overlay\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-accent\"></md-progress-circular><div class=\"padding-top-10\">\nPlease wait ..</div></div></div><div layout=\"column\"><div flex layout-align=\"start center\" layout=\"row\"><div flex \nlayout=\"row\" class=\"padding-10 margin-bottom-10\" layout-align=\"space-betwen center\" \nng-class=\"{\'light-blue-200-bg\' : !vm.isDelete, \'deep-orange-200-bg\' : vm.isDelete}\"><div layout=\"column\"><div \nclass=\"title\">{{vm.info.title}}</div><div class=\"sub-title\">{{vm.info.message}}</div></div><div flex></div><div \nlayout=\"row\"><md-menu><md-button aria-label=\"Open demo menu\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus-circle\"></md-icon><md-tooltip>Create\n</md-tooltip></md-button><md-menu-content width=\"4\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" \ntype=\"button\" aria-label=\"edit\" ng-click=\"vm.menuAction($event,\'amandemen\')\"><span>Amandemen</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-disabled=\"vm.list.amandemen.length < 2\" class=\"md-button md-ink-ripple\" \ntype=\"button\" aria-label=\"perpanjangan\" ng-click=\"vm.menuAction($event, \'perpanjangan\')\"><span>Perpanjangan</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"vm.list.perpanjangan.length == 0\" \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"edit\" \nng-click=\"vm.menuAction($event, \'amandemenPerpanjangan\')\"><span>Amandemen Perpanjangan</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button ng-click=\"vm.printOut($event)\" \nclass=\"md-button md-icon-button md-raised md-primary\"><md-icon md-menu-origin md-font-icon=\"icon-printer\"></md-icon>\n<md-tooltip>Print</md-tooltip></md-button></div></div></div><div layout=\"column\" class=\"container-table\" \nng-repeat=\"(key, val) in vm.list\"><div layout=\"column\" ng-if=\"val.length > 0\"><div class=\"table-title\">\n{{vm.getTableTitle(key) }}</div><table class=\"simple bordered stripped\" ms-responsive-table><thead><tr><th>No</th><th>\nNo Surat</th><th>Mulai Kontrak</th><th>Berakhir Kontrak</th><th>Amandemen</th><th>Tanggal Terbit</th><th>Action</th>\n</tr></thead><tbody><tr ng-repeat=\"item in val\"><td class=\"text-center\">{{$index + 1}}</td><td class=\"text-center\"><a \nhref=\"#\" ng-click=\"$event.preventDefault(); vm.viewPkwt($event, item)\">{{ item.letter_number }}</a></td><td \nclass=\"text-center\">{{item.start_contract}}</td><td class=\"text-center\">{{item.end_contract}}</td><td \nclass=\"text-center\">{{item.amandemen_order == 0 ? \'-\' : item.amandemen_order}}</td><td class=\"text-center\">\n{{item.release_date}}</td><td class=\"text-center\" style=\"width: 15%\"><md-button class=\"md-icon-button md-primary\" \ntype=\"button\" aria-label=\"update\" ng-click=\"vm.showAction($event, true, item, false)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button ng-disabled=\"vm.checkDisabled(key, $index)\" \nclass=\"md-icon-button md-warn\" type=\"button\" aria-label=\"delete\" ng-click=\"vm.deleteAction($event, item)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-xs=\"column\" flex><span flex></span><div flex=\"10\" layout-align=\"end center\" \nlayout=\"row\"><md-button ng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon>close</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pkwt/pkwt-upload/pkwt-upload.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll flex=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools title\"><h4>Upload PKWT</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"margin-top:0px\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" layout-align=\"space-between center\" style=\"margin-bottom: 15px\"><div flex><input \ntype=\"file\" id=\"uploaderPhoto\" nv-file-select uploader=\"vm.uploadFile\"></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.uploadFile.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nng-show=\"vm.isUploaded\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>{{vm.messages}}</span></md-whiteframe></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-xs=\"column\" flex layout-align=\"end center\"><span hide \nshow-gt-sm flex></span> <span hide show-gt-sm flex></span> <span hide show-gt-sm flex></span> <span hide show-gt-sm \nflex></span><div flex><md-button type=\"button\" ng-click=\"vm.viewMore($event)\" \nclass=\"md-raised md-orange-500-bg white-fg\" aria-label=\"view-more\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-50-fg\"></md-icon>More</md-button></div><div flex><md-button type=\"button\" \nng-click=\"vm.uploadFile.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload</md-button></div><div flex><md-button \nng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon>close</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/pkwt/pkwt-upload/view-more.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll flex=\"70\"><md-toolbar><div \nclass=\"md-toolbar-tools title\"><h4>Upload Logs</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"margin-top:0px; min-height: 200px\"><form ng-cloack><div layout=\"row\" flex>\n<md-input-container flex><label>Search</label><input type=\"text\" ng-model=\"vm.search\"></md-input-container>\n<md-input-container flex><label>Status</label><md-select ng-model=\"vm.result\"><md-option ng-selected=\"true\" value=\"\">\nALL</md-option><md-option ng-value=\"true\">SUCCESS</md-option><md-option ng-value=\"false\">FAILED</md-option></md-select>\n</md-input-container></div></form><table class=\"simple bordered stripped\" id=\"more-table\" ms-responsive-table><thead>\n<tr><th>ROW</th><th>NIK</th><th>NAME</th><th>RESULT</th></tr></thead><tbody><tr ng-init=\"item.show_detail = false\" \nng-click=\"item.show_detail = !item.show_detail\" \ndir-paginate-start=\"item in vm.filtered | itemsPerPage: vm.numPerPage | filter:vm.search | filter:vm.result\" \ntotal-items=\"vm.totalItems\" current-page=\"vm.currentPage\"><td class=\"text-center\">{{$index + 2}}</td><td \nclass=\"text-center\">{{item.nik}}</td><td class=\"text-center\">{{item.nama}}</td><td class=\"text-center\"><div \nng-if=\"item.last_result\" layout=\"row\" layout-align=\"start center\"><div><md-icon class=\"green-400-fg\" \nmd-font-icon=\"icon-check\"></md-icon></div><div>SUCCESS</div></div><div ng-if=\"!item.last_result\" layout=\"row\" \nlayout-align=\"start center\"><div><md-icon class=\"red-400-fg\" md-font-icon=\"icon-close\"></md-icon></div><div>FAILED\n</div></div></td></tr><tr dir-paginate-end ng-show=\"item.show_detail\"><td colspan=\"4\"><div class=\"container-detail\">\n<table class=\"table-detail\"><thead><tr><th>Key</th><th>Data</th><th>Mesaage</th><th>Status</th></tr></thead><tbody><tr \nng-if=\"key !== \'states\'\" ng-repeat=\"(key, sub) in item.states\"><td class=\"text-start\">{{key | uppercase}}</td><td \nclass=\"text-start\">{{item[key] ? item[key] : \'-\' }}</td><td class=\"text-start\">{{sub.message}}</td><td \nclass=\"text-center\"><span class=\"detail-state\"><md-icon class=\"red-400-fg\" ng-if=\"!sub.state\" \nmd-font-icon=\"icon-close\"></md-icon><md-icon class=\"green-400-fg\" ng-if=\"sub.state\" md-font-icon=\"icon-check\">\n</md-icon></span></td></tr></tbody></table></div></td></tr></tbody></table><div class=\"p-24 mb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><dir-pagination-controls on-page-change=\"vm.pageChanged(newPageNumber)\">\n</dir-pagination-controls></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-xs=\"column\" flex><span flex>\n</span><div flex=\"10\" layout-align=\"end center\" layout=\"row\"><md-button ng-click=\"vm.hide()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon>close</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pkwt/pkwt-rules/pkwt-rules.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" class=\"dialog-custom-wrapper\" ms-scroll flex><md-toolbar><div\n class=\"md-toolbar-tools title\"><h4>PKWT LOA Rules</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"margin-top:0px; min-height: 200px\"><div class=\"overlay\" ng-show=\"vm.isLoading\">\n<div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\"><md-progress-circular \nmd-diameter=\"20px\" class=\"md-accent\"></md-progress-circular><div class=\"padding-top-10\">Please wait ..</div></div>\n</div><div layout=\"column\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button \nng-click=\"vm.showFormCreateDialog($event)\" class=\"md-icon-button md-accent md-hue-2 md-raised\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><span flex></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTables.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content flex><div \nclass=\"table-container-content\"><table class=\"simple bordered stripped\" ms-responsive-table><thead><tr><th>No</th><th>\nPosition ID</th><th>Grade</th><th>Jabatan</th><th>Action</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\">{{ $index + 1}}</td><td class=\"text-center\">\n{{item.positionID}}</td><td class=\"text-center\">{{item.grade}}</td><td class=\"text-center\">{{item.job_title}}</td><td \nclass=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button class=\"md-icon-button md-ink-ripple md-primary\" \naria-label=\"edit\" ng-click=\"vm.showFormDialog($event, item)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip>\nEdit</md-tooltip></md-button><md-button class=\"md-icon-button md-ink-ripple md-warn\" aria-label=\"edit\" \nng-click=\"vm.deleteRules($event, item)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Delete</md-tooltip>\n</md-button></div></td></tr></tbody></table></div></md-content><div ng-if=\"vm.DataTables.list.length > 0\" \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-xs=\"column\" flex><span flex></span><div flex=\"10\" layout-align=\"end center\" layout=\"row\"><md-button\n ng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon>close</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/pkwt/view-pkwt/view-pkwt.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" id=\"view-pkwt\" ms-scroll flex=\"60\"><md-toolbar><div \nclass=\"md-toolbar-tools title\"><h4>{{vm.data.pkwt_type}} - {{vm.data.letter_number}}</h4><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"margin-top:0px\"><div class=\"i-container\" flex layout=\"row\" \nlayout-fill><iframe ng-src=\"{{vm.getUrl()}}\" style=\"width: 100%; height: 100%\" frameborder=\"0\"></iframe></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-xs=\"column\" flex><span flex></span><div flex=\"10\" \nlayout-align=\"end center\" layout=\"row\"><md-button ng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\nclose</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/13salary-mgr/13salary.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.13THSALARY\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\"><md-option \nng-repeat=\"ls in vm.listcompany\" placeholder=\"{{ \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"{{ \'PAYROLL.MENU.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"{{ \'PAYROLL.MENU.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.country !=\'MYS\'\">\n<md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"{{ \'PAYROLL.MENU.SEARCH\' | translate}}\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country !=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-primary\" aria-label=\"search\"><md-icon style=\"font-size:15px\" \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.input($event,ls)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-warn md-mini\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.Delete()\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Add New\" \nng-click=\"vm.input($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New</span></md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span>New</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-disabled=\"vm.listSelected.length == 0\" \nng-click=\"vm.Delete($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete\n</span></md-tooltip><md-icon ng-if=\"vm.listSelected.length > 0\" md-font-icon=\"icon-delete red-700-fg\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><md-icon \nng-if=\"vm.listSelected.length == 0\" md-font-icon=\"icon-delete grey-700-fg\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span\n translate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.UPLOAD\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.YEAR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PAYDATE\"></span></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.edit($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">{{ls.fullname}}</td><td \nclass=\"text-center\">{{ls.amount | currency:\"\"}}</td><td class=\"text-center\">{{ls.year}}</td><td class=\"text-center\">\n{{ls.pay_date}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/13salary/13salary.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.13THSALARY\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\"><md-option \nng-repeat=\"ls in vm.listcompany\" placeholder=\"{{ \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"{{ \'PAYROLL.MENU.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"{{ \'PAYROLL.MENU.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.country !=\'MYS\'\">\n<md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"{{ \'PAYROLL.MENU.SEARCH\' | translate}}\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country !=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-primary\" aria-label=\"search\"><md-icon style=\"font-size:15px\" \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"true\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.input($event,ls)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-warn md-mini\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.Delete()\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Add New\" \nng-click=\"vm.input($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New</span></md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span>New</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-disabled=\"vm.listSelected.length == 0\" \nng-click=\"vm.Delete($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete\n</span></md-tooltip><md-icon ng-if=\"vm.listSelected.length > 0\" md-font-icon=\"icon-delete red-700-fg\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><md-icon \nng-if=\"vm.listSelected.length == 0\" md-font-icon=\"icon-delete grey-700-fg\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span\n translate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.UPLOAD\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.YEAR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PAYDATE\"></span></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.edit($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">{{ls.fullname}}</td><td \nclass=\"text-center\">{{ls.amount | currency:\"\"}}</td><td class=\"text-center\">{{ls.year}}</td><td class=\"text-center\">\n{{ls.pay_date}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/13salary/input-form.html","<md-dialog aria-label=\"Form Input Salary\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"InputSalaryForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,InputSalaryForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.13THSALARY\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"InputSalaryForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-autocomplete></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.YEAR\"></span></label><md-select \nng-model=\"vm.Form.objForm.year\" name=\"year\" required><md-option ng-repeat=\"ls in vm.years\" \nplaceholder=\"{{ \'PAYROLL.MENU.YEAR\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"InputSalaryForm.year.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 4 Character.</span>\n</div><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.YEAR\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.AMOUNT\"></span></label><input type=\"number\" \nname=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"{{ \'PAYROLL.MENU.AMOUNT\' | translate}}\" required><div \nng-messages=\"InputSalaryForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PAYDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"pay\" \nng-model=\"vm.Form.objForm.pay\" required></md-datepicker><div ng-messages=\"InputSalaryForm.pay.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"InputSalaryForm.$invalid || InputSalaryForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll-new/13salary/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend><span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)\n</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input \ntype=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\"><span \ntranslate=\"PAYROLL.MENU.CANCEL\"></span></md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/allowancefix-mgr/allowancefix.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.INPUTALLOWANCEFIX\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\"><md-option \nng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"vm.country !=\'MYS\'\"><md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country != \'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputAllowanceFix($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteAllowanceFix()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.UPLOAD\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadInputSalary(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editAllowanceFix($event,ls.id)\"><td class=\"text-center\">\n<input type=\"checkbox\" checklist-model=\"vm.lisAllowanceFixSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"\"}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/absentrate/absentrate.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.ABSENTRATE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select style=\"width:200px\" ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputAbsentRate($event,ls)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeletAbsentRate()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputAbsentRate($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteAbsentRate()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.COMPANYCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.ATTENDANCECODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.POSITION\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.FORMULA\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.FLAGPRORATE\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editAbsentRate($event,ls.id)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.lisAbsentRateSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date}}</td><td class=\"text-center\">{{ls.companyname}}</td><td class=\"text-center\">{{ls.attendancecode}}\n</td><td class=\"text-center\">{{ls.position}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.formula}}</td><td class=\"text-center\">{{ls.flag_prorate}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody><tbody></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" \nclass=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div>\n<nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/absentrate/input-absentrate.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  /*width:800px;\n  height:100px;*/\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"AbsentForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,AbsentForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.ABSENTRATEFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"AbsentForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.Form.objForm.country\" name=\"country\" ng-change=\"vm.changePayrollCode()\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COMPANYNAME\"></span></label><md-select ng-model=\"vm.Form.objForm.companyname\" \nng-change=\"vm.loadPosition(vm.Form.objForm.companyname)\" ng-required=\"true\" name=\"companyname\"><md-option \nng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"AbsentForm.companyname.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COMPANYNAME\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.ATTENDANCECODE\"></span></label><md-select ng-model=\"vm.Form.objForm.code\" \nng-change=\"vm.changeStatus(vm.Form.objForm.code)\" ng-required=\"true\" name=\"code\"><md-option \nng-repeat=\"s in vm.listattendancecode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"AbsentForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.ATTENDANCECODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.POSITION\"></span></label><md-select ng-model=\"vm.Form.objForm.position\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.changeStatus(vm.Form.objForm.position)\" ng-required=\"true\" \nname=\"position\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a position...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listposition | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"AbsentForm.position.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.POSITION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span></label><md-select ng-model=\"vm.Form.objForm.payrollcode\" \nng-change=\"vm.changeStatus(vm.Form.objForm.payrollcode)\" ng-required=\"true\" name=\"payrollcode\"><md-option \nng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"AbsentForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"vm.Form.objForm.flag_prorate\" class=\"md-primary\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"><span \ntranslate=\"PAYROLL.MENU.FLAGPRORATE\"></span></md-checkbox></div><div layout-gt-sm=\"row\"><md-input-container flex=\"77\">\n<label><span translate=\"PAYROLL.MENU.FORMULA\"></span></label><input type=\"text\" name=\"formula\" \nng-model=\"vm.Form.objForm.formula\" placeholder=\"Formula\" required> <span style=\"font-size: 10px\"><span \ntranslate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span></md-input-container><md-input-container flex=\"22\"><a \nid=\"toggleMessage\" ng-click=\"toggle=!toggle\"><span style=\"color:goldenrod\">{{toggle ? \'Hide\' : \'Show\'}}</span></a>\n</md-input-container></div><div id=\"box\" ng-show=\"toggle\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">\n<span translate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"AbsentForm.$invalid || AbsentForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/absentrate/view-salarycomponent.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"AbsentForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,AbsentForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>View Salary Component</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><fieldset class=\"demo-fieldset\"><legend \nclass=\"demo-legend\">view Salary Component</legend><div layout=\"row\" layout-wrap flex><div \nclass=\"demo-select-all-checkboxes\" flex=\"100\" ng-repeat=\"ls in vm.listpayrollcode\">{{ ls.name }}</div></div></fieldset>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/allowancefix/allowancefix.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.INPUTALLOWANCEFIX\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadDivisi(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex \nng-if=\"vm.country !=\'MYS\' && vm.company!=\'EN\' ||vm.country ==\'MYS\' && vm.company!=\'EN\'\"><md-select ng-model=\"vm.area\" \nname=\"area\" placeholder=\"Area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nng-if=\"vm.country !=\'MYS\' && vm.company!=\'EN\' ||vm.country ==\'MYS\' && vm.company!=\'EN\'\" layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option ng-value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><br>\n<br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div></form>\n</div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputAllowanceFix($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-button class=\"md-warn md-mini\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteAllowanceFix()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.UPLOAD\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadInputSalary(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editAllowanceFix($event,ls.id)\"><td class=\"text-center\">\n<input type=\"checkbox\" checklist-model=\"vm.lisAllowanceFixSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"\"}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/allowancefix/input-allowancefix.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"AllowanceFixForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,AllowanceFixForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAYROLL.MENU.INPUTALLOWANCEFIXFORM\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.Form.objForm.country\" \nname=\"country\" ng-change=\"vm.changePayrollCode()\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"AllowanceFixForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"AllowanceFixForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-autocomplete></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></label><md-select \nng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" \nname=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select>\n<div ng-messages=\"AllowanceFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PAYROLLDESC\"></span></label><input type=\"text\" name=\"payrolldesc\" \nng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Payroll Description\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.AMOUNT\"></span></label><input \ntype=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div \nng-messages=\"AllowanceFixForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.AMOUNTTYPE\"></span></label><br><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.Form.objForm.amount_type\" required><md-radio-button \nng-repeat=\"amount in vm.amountTypes\" ng-value=\"amount.value\">{{amount.label}}</md-radio-button></md-radio-group>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"AllowanceFixForm.$invalid || AllowanceFixForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll-new/allowancefix/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend><span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)\n</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input \ntype=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\"><span \ntranslate=\"PAYROLL.MENU.CANCEL\"></span></md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/bpjsmalaysiaeis/bpjsmalaysiaeisComponent.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">EIS</div>\n<md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.loadData(1)\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container><label>Start Salary</label><input type=\"text\" name=\"start_salary\" ng-model=\"vm.start_salary\">\n</md-input-container><md-input-container><label>End Salary</label><input type=\"text\" name=\"end_salary\" \nng-model=\"vm.end_salary\"></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputSalaryComponent($event,ls)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.ADD\"></span></md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteSalaryComponent()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRY\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.add($event,ls)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nstyle=\"font-size:15px\" md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-button class=\"md-warn md-mini\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.remove()\"><md-tooltip\n md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nstyle=\"font-size:15px\" md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span>No\n</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>Start Salary</span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span>End Salary</span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span>EE Value</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>ER Value\n</span></span></th><th>#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.edit($event,ls)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ls.no}}</td><td class=\"text-center\">{{ls.start_salary}}</td><td \nclass=\"text-center\">{{ls.end_salary}}</td><td class=\"text-center\">{{ls.ee_value}}</td><td class=\"text-center\">\n{{ls.er_value}}</td><td class=\"text-center\"><a href=\"javascript:void(0);\" ng-click=\"vm.edit($event, ls)\" \nstyle=\"text-decoration: none\"><span class=\"icon-pencil\"></span></a></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"PAYROLL.MENU.NODATA\"></span>\n</td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/bonus/bonus.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.BONUS\"></span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span></div><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"{{ \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"{{ \'PAYROLL.MENU.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"{{ \'PAYROLL.MENU.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.country !=\'MYS\'\">\n<md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"{{ \'PAYROLL.MENU.SEARCH\' | translate}}\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country !=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-primary\" aria-label=\"search\"><md-icon style=\"font-size:15px\" \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.input($event,ls)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-warn md-mini\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.Delete()\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Add New\" \nng-click=\"vm.input($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New</span></md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span>New</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-disabled=\"vm.listSelected.length == 0\" \nng-click=\"vm.Delete($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete\n</span></md-tooltip><md-icon ng-if=\"vm.listSelected.length > 0\" md-font-icon=\"icon-delete red-700-fg\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><md-icon \nng-if=\"vm.listSelected.length == 0\" md-font-icon=\"icon-delete grey-700-fg\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span\n translate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.UPLOAD\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.YEAR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PAYDATE\"></span></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.edit($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">{{ls.fullname}}</td><td \nclass=\"text-center\">{{ls.amount | currency:\"\"}}</td><td class=\"text-center\">{{ls.year}}</td><td class=\"text-center\">\n{{ls.pay_date}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/bonus/input-form.html","<md-dialog aria-label=\"Form Input Salary\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"InputSalaryForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,InputSalaryForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.BONUS\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"InputSalaryForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-autocomplete></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.YEAR\"></span></label><md-select \nng-model=\"vm.Form.objForm.year\" name=\"year\" required><md-option ng-repeat=\"ls in vm.years\" \nplaceholder=\"{{ \'PAYROLL.MENU.YEAR\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"InputSalaryForm.year.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 4 Character.</span>\n</div><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.YEAR\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.AMOUNT\"></span></label><input type=\"number\" \nname=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"{{ \'PAYROLL.MENU.AMOUNT\' | translate}}\" required><div \nng-messages=\"InputSalaryForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PAYDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"pay\" \nng-model=\"vm.Form.objForm.pay\" required></md-datepicker><div ng-messages=\"InputSalaryForm.pay.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"InputSalaryForm.$invalid || InputSalaryForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll-new/bonus/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend><span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)\n</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input \ntype=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\"><span \ntranslate=\"PAYROLL.MENU.CANCEL\"></span></md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/bonus-mgr/bonus.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.BONUS\"></span></md-subheader><div class=\"white-bg\"><md-content class=\"\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span></div><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"{{ \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"{{ \'PAYROLL.MENU.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"{{ \'PAYROLL.MENU.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.country !=\'MYS\'\">\n<md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"{{ \'PAYROLL.MENU.SEARCH\' | translate}}\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country !=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-primary\" aria-label=\"search\"><md-icon style=\"font-size:15px\" \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.input($event,ls)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-warn md-mini\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.Delete()\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Add New\" \nng-click=\"vm.input($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New</span></md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span>New</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-disabled=\"vm.listSelected.length == 0\" \nng-click=\"vm.Delete($event)\" type=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete\n</span></md-tooltip><md-icon ng-if=\"vm.listSelected.length > 0\" md-font-icon=\"icon-delete red-700-fg\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><md-icon \nng-if=\"vm.listSelected.length == 0\" md-font-icon=\"icon-delete grey-700-fg\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span ng-if=\"vm.listSelected.length > 0\" class=\"red-700-fg\"><span\n translate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.listSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.listSelected.length > 0\">\n{{ vm.listSelected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.UPLOAD\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.YEAR\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PAYDATE\"></span></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.edit($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">{{ls.fullname}}</td><td \nclass=\"text-center\">{{ls.amount | currency:\"\"}}</td><td class=\"text-center\">{{ls.year}}</td><td class=\"text-center\">\n{{ls.pay_date}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/bpjsmalaysiaepf/bpjsmalaysiaepfComponent.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">EPF</div>\n<md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.loadData(1)\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container><label>Start Salary</label><input type=\"text\" name=\"start_salary\" ng-model=\"vm.start_salary\">\n</md-input-container><md-input-container><label>End Salary</label><input type=\"text\" name=\"end_salary\" \nng-model=\"vm.end_salary\"></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRY\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.add($event,ls)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nstyle=\"font-size:15px\" md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-button class=\"md-warn md-mini\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.remove()\"><md-tooltip\n md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nstyle=\"font-size:15px\" md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span>No\n</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>Start Salary</span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span>End Salary</span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span>EE Value</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>ER Value\n</span></span></th><th>#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editSalaryComponent($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listDataSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.no}}</td><td \nclass=\"text-center\">{{ls.start_salary}}</td><td class=\"text-center\">{{ls.end_salary}}</td><td class=\"text-center\">\n{{ls.ee_value}}</td><td class=\"text-center\">{{ls.er_value}}</td><td class=\"text-center\"><a href=\"javascript:void(0);\" \nng-click=\"vm.edit($event, ls)\" style=\"text-decoration: none\"><span class=\"icon-pencil\"></span></a></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"PAYROLL.MENU.NODATA\"></span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/bpjsmalaysiasocso/bpjsmalaysiasocsoComponent.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\"><span \ntranslate=\"PAYROLL.MENU.SOCSO\"></span></div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.loadData(1)\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container><label><span translate=\"PAYROLL.MENU.STARTSALARY\"></span></label><input type=\"number\" \nname=\"start_salary\" ng-model=\"vm.start_salary\"></md-input-container><md-input-container><label><span \ntranslate=\"PAYROLL.MENU.ENDSALARY\"></span></label><input type=\"number\" name=\"end_salary\" ng-model=\"vm.end_salary\">\n</md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"submit\" aria-label=\"FilterCost\" \nng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRY\"></span>\n</md-input-container><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-mini md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Add New\" ng-click=\"vm.addData($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>New</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span>New</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" \nng-disabled=\"vm.selected.length == 0\" ng-click=\"vm.deleteData($event)\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Delete</span></md-tooltip><md-icon ng-if=\"vm.selected.length > 0\" \nmd-font-icon=\"icon-delete red-700-fg\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon>\n<md-icon ng-if=\"vm.selected.length == 0\" md-font-icon=\"icon-delete grey-700-fg\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" ng-if=\"vm.selected.length > 0\">\n{{ vm.selected.length }} <span translate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm>\n</span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" ng-click=\"vm.addDataNews(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-button></md-menu-item><md-menu-item><span><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"><span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></span></md-menu-item>\n</md-menu-content></md-menu><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.NO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.STARTSALARY\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.ENDSALARY\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.EEVALUE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.ERVALUE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.ER1VALUE\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData($event,ls)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.selected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.no}}</td><td \nclass=\"text-center\">{{ls.start_salary}}</td><td class=\"text-center\">{{ls.end_salary}}</td><td class=\"text-center\">\n{{ls.ee_value}}</td><td class=\"text-center\">{{ls.er_value}}</td><td class=\"text-center\">{{ls.er1_value}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"PAYROLL.MENU.NODATA\"></span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/bpjsmalaysiasocso/form-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.SOCSOFORM\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex flex-gt-sm><label \ntranslate=\"PAYROLL.MENU.STARTSALARY\"></label><input type=\"number\" ng-model=\"vm.Form.objForm.start_salary\" \nname=\"start_salary\" required><div ng-messages=\"frmBT.start_salary.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"PAYROLL.MENU.STARTSALARY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.ENDSALARY\"></label><input \ntype=\"number\" ng-model=\"vm.Form.objForm.end_salary\" name=\"end_salary\" required><div \nng-messages=\"frmBT.end_salary.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDSALARY\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.EEVALUE\"></label><input type=\"number\" \nng-model=\"vm.Form.objForm.ee_value\" name=\"ee_value\" required><div ng-messages=\"frmBT.ee_value.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"PAYROLL.MENU.EEVALUE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"PAYROLL.MENU.ERVALUE\">\n</label><input type=\"number\" ng-model=\"vm.Form.objForm.er_value\" name=\"er_value\" required><div \nng-messages=\"frmBT.er_value.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ERVALUE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex \nflex-gt-sm><label translate=\"PAYROLL.MENU.ER1VALUE\"></label><input type=\"number\" ng-model=\"vm.Form.objForm.er1_value\" \nname=\"er1_value\" required><div ng-messages=\"frmBT.er1_value.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.ER1VALUE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" ng-if=\"!vm.isChecked\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" translate=\"ACTION.SUBMIT\">Submit</md-button>\n</md-dialog-actions></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll-new/carrate/carrate.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.CARRATE\"></span></md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputCarRate($event,ls)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\n<span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeleteCarRate()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputCarRate($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteCarRate()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.COMPANY\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.CARTYPE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.FLAGPRORATE\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editCarRate($event,ls.id)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.lisCarRateSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date}}</td><td class=\"text-center\">{{ls.companyname}}</td><td class=\"text-center\">{{ls.car_type}}</td>\n<td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td><td class=\"text-center\">{{ls.flag_prorate}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/carrate/input-carrate.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"CarForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,CarForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.CARRATEFORM\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"CarForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.Form.objForm.companyname\" ng-change=\"vm.changeStatus(vm.Form.objForm.companyname)\" ng-required=\"true\" \nname=\"companyname\"><md-option ng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"CarForm.companyname.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.CARTYPE\"></span></label><input type=\"text\" name=\"car_type\" ng-model=\"vm.Form.objForm.car_type\" \nplaceholder=\"{{ \'PAYROLL.MENU.CARTYPE\' | translate }}\"><div ng-messages=\"CarForm.car_type.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.CARTYPE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span></label><md-select ng-model=\"vm.Form.objForm.payrollcode\" \nng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" name=\"payrollcode\"><md-option \nng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"GradeForm.payrollcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></label><input \ntype=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" \nplaceholder=\"{{ \'PAYROLL.MENU.PAYROLLDESC\' | translate}}\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.AMOUNT\"></span></label><input type=\"number\" \nname=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"{{ \'PAYROLL.MENU.AMOUNT\' | translate }}\" required><div \nng-messages=\"CarForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.AMOUNT\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" name=\"flag_prorate\" \nng-model=\"vm.Form.objForm.flag_prorate\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">Flag Prorate</md-checkbox></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"CarForm.$invalid || CarForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/cartransaction/cartransaction.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.CARTRANSACTION\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadDivisi(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><br>\n<br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div></form>\n</div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputCarTransaction($event,ls)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">New Car Transaction</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-warn md-mini\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteCarTransaction()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nDelete Car Transaction</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">\n</md-icon></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputCarTransaction($event,ls)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-button class=\"md-warn md-mini\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteCarTransaction()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUploadCarTransaction($event)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.UPLOAD\">\n</span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PERIOD\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.TYPE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editCarTransaction($event,ls.id)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.lisCarTransactionSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.period}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">{{ls.fullname}}</td><td \nclass=\"text-center\">{{ls.type}}</td><td class=\"text-center\">{{ls.amount}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/cartransaction/input-cartransaction.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"CarForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,CarForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.CARTRANSACTIONFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.Form.objForm.period\" ng-required=\"true\" \nname=\"period\"><md-option ng-repeat=\"s in vm.listperiod\" value=\"{{s}}\">{{s}}</md-option></md-select><div \nng-messages=\"CarForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.PERIOD\">\n</span><span> is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label><span translate=\"PAYROLL.MENU.TYPE\"></span></label><md-select ng-model=\"vm.Form.objForm.car_type\" \nng-change=\"vm.changeCartype(vm.Form.objForm.car_type)\" ng-required=\"true\" name=\"car_type\"><md-option \nng-repeat=\"s in vm.listcartype\" value=\"{{s.id}}\">{{s.type}}</md-option></md-select><div \nng-messages=\"CarForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.TYPE\"></span>\n<span> is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete required \nflex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"CarForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span></div>\n</div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></label><input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" \nplaceholder=\"Amount\" required><div ng-messages=\"CarForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span><span> is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"CarForm.$invalid || CarForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/cartransaction/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend><span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)\n</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input \ntype=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\"><span \ntranslate=\"PAYROLL.MENU.CANCEL\"></span></md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/closepayroll/closepayroll.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.CLOSEPAYROLL\"></span></md-subheader><div class=\"white-bg\"><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputClosePayroll($event,ls)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputClosePayroll($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PERIOD\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.COMPANY\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.STATUS\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.NOTE\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editClosePayroll($event,ls.id)\"><td class=\"text-center\">\n{{ls.period}}</td><td class=\"text-center\">{{ls.companyname}}</td><td class=\"text-center\">{{ls.status}}</td><td \nclass=\"text-center\">{{ls.remarks}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/closepayroll/input-closepayroll.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"PayrollForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,PayrollForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.CLOSEPAYROLLFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.Form.objForm.period\" ng-required=\"true\" \nname=\"period\"><md-option ng-repeat=\"s in vm.listperiod\" value=\"{{s.period}}\">{{s.period}}</md-option></md-select><div \nng-messages=\"PayrollForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select ng-model=\"vm.Form.objForm.companyname\" ng-required=\"true\" \nname=\"companyname\"><md-option ng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"PayrollForm.companyname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.STATUS\"></span></label><md-select ng-model=\"vm.Form.objForm.status\" ng-required=\"true\" \nname=\"status\"><md-option ng-repeat=\"s in vm.liststatus\" value=\"{{s}}\">{{s}}</md-option></md-select><div \nng-messages=\"PayrollForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>Status is required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.NOTE\"></span></label><textarea name=\"remarks\" ng-model=\"vm.Form.objForm.remarks\"></textarea>\n<div ng-messages=\"PayrollForm.remarks.$error\" role=\"alert\"><div ng-message=\"required\"><span>Note is required.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"PayrollForm.$invalid || PayrollForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/deductionfix/deductionfix.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.INPUTDEDUCTIONFIX\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\"><md-option \nng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"vm.country!=\'MYS\'\"><md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country!=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputDeductionFix($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteDeductionFix()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadDeductionFix(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editDeductionFix($event,ls.id)\"><td class=\"text-center\">\n<input type=\"checkbox\" checklist-model=\"vm.lisDeductionFixSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/deductionfix/input-deductionfix.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"DeductionFixForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,DeductionFixForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAYROLL.MENU.INPUTDEDUCTIONFIXFORM\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" \nname=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"DeductionFixForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"DeductionFixForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-autocomplete></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></label><md-select \nng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" \nname=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select>\n<div ng-messages=\"DeductionFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></label><input type=\"text\" \nname=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Payroll Description\"></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.AMOUNT\"></span></label><input \ntype=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div \nng-messages=\"DeductionFixForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"DeductionFixForm.$invalid || DeductionFixForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll-new/deductionfix/upload-file.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAYROLL.MENU.UPLOAD\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><input type=\"file\" \nid=\"uploadPhoto\" nv-file-select uploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-50-fg\"></md-icon><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-button>\n</div></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload File</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload File</span></md-whiteframe></md-content></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll-new/deductionfix-mgr/deductionfix.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.INPUTDEDUCTIONFIX\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\"><md-option \nng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"vm.country!=\'MYS\'\"><md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country!=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputDeductionFix($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteDeductionFix()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadDeductionFix(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editDeductionFix($event,ls.id)\"><td class=\"text-center\">\n<input type=\"checkbox\" checklist-model=\"vm.lisDeductionFixSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"Rp. \"}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/deductionnonfix/deductionnonfix.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.INPUTDEDUCTIONNONFIX\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadDivisi(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex \nng-if=\"(vm.country !=\'MYS\'&&vm.company!=\'EN\') || (vm.country ==\'MYS\'&&vm.company!=\'EN\')\"><md-select ng-model=\"vm.area\" \nname=\"area\" placeholder=\"Area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nng-if=\"(vm.country !=\'MYS\'&&vm.company!=\'EN\') || (vm.country ==\'MYS\'&&vm.company!=\'EN\')\" layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option ng-value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><br>\n<br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div></form>\n</div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputDeductionNonFix($event,ls)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-button class=\"md-warn md-mini\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteDeductionNonFix()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Upload Allowance Non Fix</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadDeductionNonFix(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip\n md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editDeductionNonFix($event,ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.lisDeductionNonFixSelected\" checklist-value=\"ls\"></td>\n<td class=\"text-center\">{{ls.start_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">\n{{ls.end_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.code}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"\"}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/deductionnonfix/edit-deductionnonfix.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"DeductionNonFixForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,DeductionNonFixForm)\"><md-toolbar \nclass=\"md-cyan-600-bg\"><div class=\"md-toolbar-tools\"><h2>Form Input Deduction Non Fix</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"DeductionNonFixForm.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart Date is required.</span></div></div></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\" required></md-datepicker>\n<div ng-messages=\"DeductionNonFixForm.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd Date is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div>\n<div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label><md-select \nng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" \nname=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select>\n<div ng-messages=\"DeductionNonFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Payroll Desc</label><input type=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" \nplaceholder=\"Payroll Desc\"><div ng-messages=\"DeductionNonFixForm.payrolldesc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Payroll Code is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Amount</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Amount Type</label><br><md-radio-group layout=\"row\" layout-align=\"start center\" \nng-model=\"vm.Form.objForm.amount_type\" required><md-radio-button ng-repeat=\"amount in vm.amountTypes\" \nng-value=\"amount.value\">{{amount.label}}</md-radio-button></md-radio-group></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Is Prorate</label><br><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.Form.objForm.isprorate\" required><md-radio-button \nng-repeat=\"amount in vm.isProrate\" ng-value=\"amount.value\">{{amount.label}}</md-radio-button></md-radio-group>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"DeductionNonFixForm.$invalid || DeductionNonFixForm.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/payroll-new/deductionnonfix/input-deductionnonfix.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"DeductionNonFixForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,DeductionNonFixForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAYROLL.MENU.INPUTDEDUCTIONNONFIXFORM\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.Form.objForm.country\" \nname=\"country\" ng-change=\"vm.changePayrollCode()\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.STARTDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div ng-messages=\"DeductionFixForm.start_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.ENDDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" \nng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div ng-messages=\"DeductionFixForm.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-autocomplete required flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"DeductionFixForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span>\n</div></div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span></label><md-select ng-model=\"vm.Form.objForm.payrollcode\" \nng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" name=\"payrollcode\"><md-option \nng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"DeductionNonFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PAYROLLDESC\"></span></label><input type=\"text\" name=\"payrolldesc\" \nng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Payroll Desc\"><div \nng-messages=\"DeductionNonFixForm.payrolldesc.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLDESC\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></label><input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" \nplaceholder=\"Amount\" required><div ng-messages=\"DeductionNonFixForm.amount.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Amount Type</label><br>\n<md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.Form.objForm.amount_type\" required>\n<md-radio-button ng-repeat=\"amount in vm.amountTypes\" ng-value=\"amount.value\">{{amount.label}}</md-radio-button>\n</md-radio-group></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Is Prorate</label>\n<br><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.Form.objForm.isprorate\" required>\n<md-radio-button ng-repeat=\"amount in vm.isProrate\" ng-value=\"amount.value\">{{amount.label}}</md-radio-button>\n</md-radio-group></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"DeductionNonFixForm.$invalid || DeductionNonFixForm.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/payroll-new/deductionnonfix/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/deductionnonfix-mgr/deductionnonfix.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.INPUTDEDUCTIONNONFIX\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\"><md-option \nng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"vm.country!=\'MYS\'\"><md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country!=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputDeductionNonFix($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteDeductionNonFix()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Upload Allowance Non Fix</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadDeductionNonFix(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip\n md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editDeductionNonFix($event,ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.lisDeductionNonFixSelected\" checklist-value=\"ls\"></td>\n<td class=\"text-center\">{{ls.start_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">\n{{ls.end_date | date: \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.code}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"\"}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/encashment-leave/encashment-leave.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ENCASHMENTLEAVE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><md-select ng-model=\"vm.company\" \nname=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex ng-if=\"vm.country !=\'MYS\'\"><md-select ng-model=\"vm.area\" \nplaceholder=\"Area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country !=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div ng-if=\"vm.country==\'MYS\'\" flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header\n class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div><div layout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\">\n</div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputEncashmentLeaveManagement($event,ls)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\">New</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.lisEncashmentLeaveManagementSelected.length == 0\" ng-click=\" vm.DeleteEncashmentLeaveManagement()\">\n<md-icon ng-if=\"vm.lisEncashmentLeaveManagementSelected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon>\n<md-icon ng-if=\"vm.lisEncashmentLeaveManagementSelected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon>\n<span ng-if=\"vm.lisEncashmentLeaveManagementSelected.length > 0\" class=\"red-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span ng-if=\"vm.lisEncashmentLeaveManagementSelected.length == 0\" \nclass=\"grey-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" \nng-if=\"vm.lisEncashmentLeaveManagementSelected.length > 0\">{{ vm.lisEncashmentLeaveManagementSelected.length }} <span \ntranslate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Upload</md-tooltip>\n<md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadData(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">Download</md-tooltip><md-icon md-font-icon=\"icon-download\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Download</md-button><span flex hide show-gt-sm></span></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th width=\"10%\" class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th width=\"10%\" class=\"text-center\">\n<span class=\"column-title\"><span translate=\"PAYROLL.MENU.STARTDATE\"></span></span></th><th width=\"10%\" \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.ENDDATE\"></span></span></th><th \nwidth=\"5%\" class=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.YEARPAYLEAVE\"></span></span>\n</th><th width=\"5%\" class=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.MONTHPAYLEAVE\"></span>\n</span></th><th width=\"5%\" class=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.TOTALPAYLEAVE\">\n</span></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editEncashmentLeaveManagement($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.lisEncashmentLeaveManagementSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.empno}}</td><td class=\"\">{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td \nclass=\"text-center\">{{ls.start_date | date : \"dd-MM-yyyy\"}}</td><td class=\"text-center\">\n{{ls.end_date | date : \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.year_payleave}}</td><td class=\"text-center\">\n{{ls.month_payleave}}</td><td class=\"text-center\">{{ls.amount}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/encashment-leave/input-encashment-leave.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"formData\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,formData)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.ENCASHMENTLEAVE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label>Start Usage</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required>\n</md-datepicker><div ng-messages=\"formData.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart Usage is required.</span></div></div></md-input-container><md-input-container flex><label>End Usage</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\" required></md-datepicker>\n<div ng-messages=\"formData.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Usage is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.YEARPAYLEAVE\"></span></label><md-select ng-model=\"vm.Form.objForm.year_payleave\" \nng-required=\"true\" name=\"year\"><md-option ng-repeat=\"ls in vm.listYear\" value=\"{{ls.id}}\">{{ls.name}}</md-option>\n</md-select><div ng-messages=\"formData.year.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.YEARPAYLEAVE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.MONTHPAYLEAVE\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.month_payleave\" ng-required=\"true\" name=\"month\"><md-option \nng-repeat=\"ls in vm.listMonth\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"formData.year.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.MONTHPAYLEAVE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><br><div layout-gt-sm=\"row\"><md-autocomplete required flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"DeductionFixForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span>\n</div></div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Total Payleave</label>\n<input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\" required><div \nng-messages=\"formData.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Total Payleave is required.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formData.$invalid || formData.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/encashment-leave/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/encashment-leave-paramenter/encashment-leave-paramenter.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ENCASHMENTLEAVEPARAMETER\"></span></md-subheader><div class=\"white-bg\">\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputEncashmentLeave($event,ls)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteEncashmentLeave()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputEncashmentLeave($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.lisEncashmentLeaveSelected.length == 0\" ng-click=\" vm.DeleteEncashmentLeave()\"><md-icon \nng-if=\"vm.lisEncashmentLeaveSelected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon \nng-if=\"vm.lisEncashmentLeaveSelected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.lisEncashmentLeaveSelected.length > 0\" class=\"red-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span>\n</span> <span ng-if=\"vm.lisEncashmentLeaveSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" \nng-if=\"vm.lisEncashmentLeaveSelected.length > 0\">{{ vm.lisEncashmentLeaveSelected.length }} <span \ntranslate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.CODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.DESCRIPTION\"></span></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editEncashmentLeave($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.lisEncashmentLeaveSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.code}}</td><td \nclass=\"text-center\">{{ls.description}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/encashment-leave-paramenter/input-encashment-leave-paramenter.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  /*width:800px;\n  height:100px;*/\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Encashment Leave Form\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack \nname=\"EncashmentLeaveForm\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,EncashmentLeaveForm)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.ENCASHMENTLEAVEPARAMETER\"></span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.CODE\"></span>\n</label><input type=\"text\" name=\"code\" ng-model=\"vm.Form.objForm.code\" \nplaceholder=\"{{ \'PAYROLL.MENU.CODE\' | translate}}\" required><div ng-messages=\"EncashmentLeaveForm.code.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" \nname=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select>\n<div ng-messages=\"GradeForm.payrollcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.POSTTO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DESCRIPTION\"></span></label><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"{{ \'PAYROLL.MENU.DESCRIPTION\' | translate}}\"><div \nng-messages=\"EncashmentLeaveForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label><span \ntranslate=\"PAYROLL.MENU.FORMULA\"></span></label><input type=\"text\" name=\"formula\" ng-model=\"vm.Form.objForm.formula\" \nplaceholder=\"{{ \'PAYROLL.MENU.FORMULA\' | translate}}\" required> <span style=\"font-size: 10px\"><span \ntranslate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div ng-messages=\"EncashmentLeaveForm.formula.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.FORMULA\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex=\"33\"><a \nid=\"toggleMessage\" ng-click=\"toggle=!toggle\"><span style=\"color:goldenrod\">{{toggle ? \'Hide\' : \'Show\'}}</span></a>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.TYPE\">\n</span></label><md-select ng-model=\"vm.Form.objForm.type\" ng-change=\"vm.changeType(vm.Form.objForm.type)\" \nng-required=\"true\" name=\"type\"><md-option ng-repeat=\"ls in vm.listTypes\" value=\"{{ls.id}}\">{{ls.name}}</md-option>\n</md-select><div ng-messages=\"ProrateForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.TYPE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.FIXDAY\"></span></label><input \ntype=\"number\" name=\"fixdays\" id=\"fixdays\" ng-model=\"vm.Form.objForm.fix_days\" ng-disabled=\"true\" \nng-required=\"vm.Form.objForm.type == 2\" placeholder=\"{{\'PAYROLL.MENU.FIXDAY\' | translate}}\"></md-input-container></div>\n<div id=\"box\" ng-show=\"toggle\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div ng-if=\"vm.country!=\'MYS\'\" \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.MULTIPLE1\"></span></label><input \ntype=\"number\" name=\"multiple1\" ng-model=\"vm.Form.objForm.multiple1\" \nplaceholder=\"{{ \'PAYROLL.MENU.MULTIPLE1\' | translate}}\" required><div \nng-messages=\"EncashmentLeaveForm.multiple1.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.MULTIPLE1\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div ng-if=\"vm.country!=\'MYS\'\" layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.MULTIPLE2\"></span></label><input type=\"number\" name=\"multiple2\" \nng-model=\"vm.Form.objForm.multiple2\" placeholder=\"{{ \'PAYROLL.MENU.MULTIPLE2\' | translate}}\" required><div \nng-messages=\"EncashmentLeaveForm.multiple2.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.MULTIPLE2\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div ng-if=\"vm.country!=\'MYS\'\" layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.MULTIPLE3\"></span></label><input type=\"number\" name=\"multiple3\" \nng-model=\"vm.Form.objForm.multiple3\" placeholder=\"{{ \'PAYROLL.MENU.MULTIPLE3\' | translate}}\" required><div \nng-messages=\"EncashmentLeaveForm.multiple3.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.MULTIPLE3\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div ng-if=\"vm.country!=\'MYS\'\" layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.MULTIPLE4\"></span></label><input type=\"number\" name=\"multiple4\" \nng-model=\"vm.Form.objForm.multiple4\" placeholder=\"{{ \'PAYROLL.MENU.MULTIPLE4\' | translate}}\" required><div \nng-messages=\"EncashmentLeaveForm.multiple4.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MENU.MULTIPLE4\"></span> is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"EncashmentLeaveForm.$invalid || EncashmentLeaveForm.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/payroll-new/fixentry/fixentry.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.INPUTSALARY\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadArea(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"{{ \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"{{ \'PAYROLL.MENU.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"{{ \'PAYROLL.MENU.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"vm.country !=\'MYS\' && vm.company!=\'EN\'\"><md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"{{ \'PAYROLL.MENU.SEARCH\' | translate}}\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container \nng-if=\"vm.country !=\'MYS\' && vm.company!=\'EN\' || vm.country ==\'MYS\' && vm.company!=\'EN\'\" layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\' && vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option ng-value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><br>\n<br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div></form>\n</div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputFixEntry($event,ls)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-warn md-mini\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteFixEntry()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputFixEntry($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteFixEntry()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.UPLOAD\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadInputSalary(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.CODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FLAGACTING\"></span></span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editFixEntry($event,ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.lisFixEntrySelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ls.effective_date}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"\"}}</td><td \nclass=\"text-center\">{{ls.flag_acting}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/fixentry/input-fixentry.html","<md-dialog aria-label=\"Form Input Salary\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"InputSalaryForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,InputSalaryForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.INPUTSALARYFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"InputSalaryForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-autocomplete required flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"InputSalaryForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-autocomplete></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.Form.objForm.country\" name=\"country\" ng-change=\"vm.changePayrollCode()\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.CODE\">\n</span></label><md-select ng-model=\"vm.Form.objForm.payrollcode\" \nng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" name=\"payrollcode\"><md-option \nng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\" selected=\"selected\">{{s.name}}</md-option></md-select><div \nng-messages=\"InputSalaryForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.CODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></label><input \ntype=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" \nplaceholder=\"{{ \'PAYROLL.MENU.DESCRIPTION\' | translate}}\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.AMOUNT\"></span></label><input type=\"number\" \nname=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"{{ \'PAYROLL.MENU.AMOUNT\' | translate}}\" required><div \nng-messages=\"InputSalaryForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.AMOUNTTYPE\"></span></label><br><md-radio-group layout=\"row\" layout-align=\"start center\" \nng-model=\"vm.Form.objForm.amount_type\"><md-radio-button ng-repeat=\"amount in vm.amountTypes\" ng-value=\"amount.value\">\n{{amount.label}}</md-radio-button></md-radio-group></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox \nmd-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"vm.Form.objForm.flag_acting\" class=\"md-primary\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\"><span translate=\"PAYROLL.MENU.FLAGACTING\"></span></md-checkbox></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"InputSalaryForm.$invalid || InputSalaryForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll-new/fixentry/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend><span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)\n</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input \ntype=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\"><span \ntranslate=\"PAYROLL.MENU.CANCEL\"></span></md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/fixentry-mgr/fixentry.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.INPUTSALARY\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\"><md-option \nng-repeat=\"ls in vm.listcompany\" placeholder=\"{{ \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"{{ \'PAYROLL.MENU.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"{{ \'PAYROLL.MENU.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.country !=\'MYS\'\">\n<md-select ng-model=\"vm.area\" name=\"area\" placeholder=\"Area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"{{ \'PAYROLL.MENU.SEARCH\' | translate}}\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country !=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\">\n<md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputFixEntry($event,ls)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-warn md-mini\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeleteFixEntry()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputFixEntry($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteFixEntry()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.UPLOAD\">\n</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadInputSalary(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.CODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FLAGACTING\"></span></span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editFixEntry($event,ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.lisFixEntrySelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ls.effective_date}}</td><td class=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.payrollcode}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"\"}}</td><td \nclass=\"text-center\">{{ls.flag_acting}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/graderate/graderate.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.GRADERATE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadArea(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"{{ \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.country==\'MYS\' && vm.company==\'EN\'\" flex><label \ntranslate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header\n class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container ng-if=\"vm.country==\'MYS\' && vm.company==\'EN\'\" flex><label \ntranslate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nng-if=\"vm.country==\'MYS\' && vm.company==\'EN\'\" flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-button type=\"button\" layout=\"row\" \nng-click=\"vm.loadData(1)\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputGradeRate($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteGradeRate()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputGradeRate($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteGradeRate()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.COMPANYCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.GRADECODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.FLAGPRORATE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.AREA\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editGradeRate($event,ls.id)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.lisGradeRateSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date}}</td><td class=\"text-center\">{{ls.companydesc}}</td><td class=\"text-center\">{{ls.gradecode}}</td>\n<td class=\"text-center\">{{ls.payrollcode}}</td><td class=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">\n{{ls.amount | currency:\"\"}}</td><td class=\"text-center\">{{ls.flag_prorate}}</td><td class=\"text-center\">{{ls.sub_area}}\n</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/graderate/input-graderate.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"GradeForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,GradeForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.GRADERATEFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"AbsentForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.Form.objForm.country\" name=\"country\" \nng-change=\"vm.changePayrollCode()\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANYCODE\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.companyid\" ng-change=\"vm.LoadGrade(vm.Form.objForm.companyid)\" ng-required=\"true\" \nname=\"companyid\"><md-option ng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"GradeForm.companyid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COMPANYCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.GRADECODE\"></span></label><md-select\n ng-model=\"vm.Form.objForm.gradecode\" ng-change=\"vm.changeStatus(vm.Form.objForm.gradecode)\" ng-required=\"true\" \nname=\"gradecode\"><md-option ng-repeat=\"s in vm.listgrade\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"GradeForm.gradecode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.GRADECODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span></label><md-select ng-model=\"vm.Form.objForm.payrollcode\" \nng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" name=\"payrollcode\"><md-option \nng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"GradeForm.payrollcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></label><input \ntype=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" \nplaceholder=\"{{ \'PAYROLL.MENU.PAYROLLDESC\' | translate}}\"></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></label><input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" \nplaceholder=\"{{ \'PAYROLL.MENU.AMOUNT\' | translate}}\" required><div ng-messages=\"GradeForm.amount.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label>\n<md-select ng-model=\"vm.Form.objForm.sub_area_id\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox \nmd-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"vm.Form.objForm.flag_prorate\" class=\"md-primary\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\"><span translate=\"PAYROLL.MENU.FLAGPRORATE\"></span></md-checkbox></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"GradeForm.$invalid || GradeForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/groupentry/groupentry.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.GROUPENTRY\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select style=\"width:200px\" ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputGroupEntry($event,ls)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-warn md-mini\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeleteGroupEntry()\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputGroupEntry($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteGroupEntry()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.GROUPCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.GROUPDESC\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.FLAGPRORATE\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editGroupEntry($event,ls.id)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.lisGroupEntrySelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.effective_date}}</td><td class=\"text-center\">{{ls.groupcode}}</td><td class=\"text-center\">{{ls.groupdesc}}</td><td\n class=\"text-center\">{{ls.payrollcode}}</td><td class=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">\n{{ls.amount | currency:\"\"}}</td><td class=\"text-center\">{{ls.flag_prorate}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/groupentry/input-groupentry.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"GroupEntryForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,GroupEntryForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.GROUPENTRYFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.Form.objForm.country\" name=\"country\" \nng-change=\"vm.changePayrollCode()\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" required>\n</md-datepicker><div ng-messages=\"GroupEntryForm.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.GROUPCODE\"></span></label><md-select\n ng-model=\"vm.Form.objForm.groupcode\" name=\"code\" ng-required=\"true\" \nng-change=\"vm.changeGroup(vm.Form.objForm.groupcode)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for code...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"code\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listgroup | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"GroupEntryForm.groupcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.GROUPCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.GROUPDESC\"></span></label><input \ntype=\"text\" name=\"groupdesc\" ng-model=\"vm.Form.objForm.groupdesc\" \nplaceholder=\"{{  \'PAYROLL.MENU.GROUPDESC\' | translate}}\"><div ng-messages=\"GroupEntryForm.groupdesc.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.GROUPDESC\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></label><md-select \nng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" \nname=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayroll\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"GroupEntryForm.payrollcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span>Desc</label>\n<input type=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" \nplaceholder=\"{{  \'PAYROLL.MENU.PAYROLLDESC\' | translate}}\"><div ng-messages=\"GroupEntryForm.payrolldesc.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></label><input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" \nplaceholder=\"{{  \'PAYROLL.MENU.AMOUNT\' | translate}}\" required><div ng-messages=\"GroupEntryForm.amount.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"vm.Form.objForm.flag_prorate\" class=\"md-primary\" \nng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"><span translate=\"PAYROLL.MENU.FLAGPRORATE\"></span></md-checkbox></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"GroupEntryForm.$invalid || GroupEntryForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll-new/jamsostek/input-jamsostek.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  /*width:800px;\n  height:100px;*/\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"JamsostekForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,JamsostekForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.BPJSPARAMETERFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.CODE\"></span></label><input type=\"text\" name=\"code\" ng-model=\"vm.Form.objForm.code\" \nplaceholder=\"{{ \'PAYROLL.MENU.CODE\' | translate}}\" required><div ng-messages=\"JamsostekForm.code.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.DESCRIPTION\">\n</span></label><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" \nplaceholder=\"{{ \'PAYROLL.MENU.DESCRIPTION\' | translate}}\" required><div ng-messages=\"JamsostekForm.description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.RATEBPJS\"></span></label><input type=\"text\" \nname=\"ratebpjs\" ng-model=\"vm.Form.objForm.ratebpjs\" placeholder=\"{{ \'PAYROLL.MENU.RATEBPJS\' | translate}}\" required> \n<span style=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"JamsostekForm.ratebpjs.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.RATEBPJS\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"toggle=!toggle\"><span \nstyle=\"color:goldenrod\">{{toggle ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"toggle\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.JKKEMPLOYEE\"></span> (%)</label><input type=\"number\" \nname=\"jkkemppct\" ng-model=\"vm.Form.objForm.jkkemppct\" placeholder=\"{{ \'PAYROLL.MENU.JKKEMPLOYEE\' | translate}}\" \nrequired><div ng-messages=\"JamsostekForm.jkkemppct.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.JKKEMPLOYEE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.jkkemppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jkkemppostcode)\" ng-required=\"true\" \nname=\"jkkemppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div\n ng-messages=\"JamsostekForm.jkkemppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.JKKEMPLOYEEPOST\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.JKKEMPLOYER\"></span> (%)</label><input type=\"number\" name=\"jkkcomppct\" \nng-model=\"vm.Form.objForm.jkkcomppct\" placeholder=\"{{ \'PAYROLL.MENU.JKKEMPLOYER\' | translate}}\" required><div \nng-messages=\"JamsostekForm.jkkcomppct.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.JKKEMPLOYER\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.jkkcomppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jkkcomppostcode)\" \nng-required=\"true\" name=\"jkkcomppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.jkkcomppostcode.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.JKKEMPLOYERPOST\"></span><span> Code is required.</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.JKMEMPLOYEE\"></span> (%)</label><input type=\"number\" name=\"jkmemppct\" \nng-model=\"vm.Form.objForm.jkmemppct\" placeholder=\"{{ \'PAYROLL.MENU.JKMEMPLOYEE\' | translate}}\" required><div \nng-messages=\"JamsostekForm.jkmemppct.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.JKMEMPLOYEE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.jkmemppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jkmemppostcode)\" ng-required=\"true\" \nname=\"jkmemppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div\n ng-messages=\"JamsostekForm.jkmemppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MENU.JKMEMPLOYEEPOST\"></span> is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.JKMEMPLOYER\"></span> (%)</label><input\n type=\"number\" name=\"jkmcomppct\" ng-model=\"vm.Form.objForm.jkmcomppct\" \nplaceholder=\"{{ \'PAYROLL.MENU.JKMEMPLOYER\' | translate}}\" required><div ng-messages=\"JamsostekForm.jkmcomppct.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span><span translate=\"PAYROLL.MENU.JKMEMPLOYER\"></span> is required.</span>\n</div></div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.jkmcomppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jkmcomppostcode)\" \nng-required=\"true\" name=\"jkmcomppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.jkkcomppostcode.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.JKMEMPLOYERPOST\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.JHTEMPLOYEE\"></span> (%)</label><input type=\"number\" \nname=\"jhtemppct\" ng-model=\"vm.Form.objForm.jhtemppct\" placeholder=\"{{ \'PAYROLL.MENU.JHTEMPLOYEE\' | translate}}\" \nrequired><div ng-messages=\"JamsostekForm.jhtemppct.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MENU.JHTEMPLOYEE\"></span> is required.</span></div></div></md-input-container><md-input-container \nflex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select ng-model=\"vm.Form.objForm.jhtemppostcode\" \nng-change=\"vm.changeThp(vm.Form.objForm.jhtemppostcode)\" ng-required=\"true\" name=\"jhtemppostcode\"><md-option \nng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"JamsostekForm.jhtemppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.JHTEMPLOYEEPOST\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.JHTEMPLOYER\"></span> (%)</label><input type=\"number\" name=\"jhtcomppct\" \nng-model=\"vm.Form.objForm.jhtcomppct\" placeholder=\"{{ \'PAYROLL.MENU.JHTEMPLOYER\' | translate}}\" required><div \nng-messages=\"JamsostekForm.jhtcomppct.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MENU.JHTEMPLOYER\"></span> is required.</span></div></div></md-input-container><md-input-container \nflex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select ng-model=\"vm.Form.objForm.jhtcomppostcode\" \nng-change=\"vm.changeThp(vm.Form.objForm.jhtcomppostcode)\" ng-required=\"true\" name=\"jhtcomppostcode\"><md-option \nng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"JamsostekForm.jhtcomppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.JHTEMPLOYERPOST\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label><span \ntranslate=\"PAYROLL.MENU.RATEBPJSKES\"></span></label><input type=\"text\" name=\"ratebpjskes\" \nng-model=\"vm.Form.objForm.ratebpjskes\" placeholder=\"{{ \'PAYROLL.MENU.RATEBPJSKES\' | translate}}\" required> <span \nstyle=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"JamsostekForm.ratebpjskes.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.RATEBPJSKES\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"ratebpjskes=!ratebpjskes\"><span \nstyle=\"color:goldenrod\">{{ratebpjskes ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"ratebpjskes\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.BPJSKESEMP\"></span> (%)</label><input type=\"number\" \nname=\"bpjskesemppct\" ng-model=\"vm.Form.objForm.bpjskesemppct\" placeholder=\"{{ \'PAYROLL.MENU.BPJSKESEMP\' | translate}}\" \nrequired><div ng-messages=\"JamsostekForm.bpjskesemppct.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.BPJSKESEMP\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.bpjskesemppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.bpjskesemppostcode)\" \nng-required=\"true\" name=\"bpjskesemppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.bpjskesemppostcode.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.BPJSKESPOST\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.BPJSKESEMPR\"></span> (%)</label><input type=\"number\" name=\"bpjskescomppct\" \nng-model=\"vm.Form.objForm.bpjskescomppct\" placeholder=\"{{ \'PAYROLL.MENU.BPJSKESEMPR\' | translate}}\" required><div \nng-messages=\"JamsostekForm.bpjskescomppct.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.BPJSKESEMPR\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.bpjskescomppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.bpjscomppostcode)\" \nng-required=\"true\" name=\"bpjskescomppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.bpjskesemppostcode.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.BPJSKESPOST\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.MAXBPJSKES\"></span></label><input type=\"number\" name=\"bpjsmaxrate\" \nng-model=\"vm.Form.objForm.bpjsmaxrate\" placeholder=\"{{ \'PAYROLL.MENU.MAXBPJSKES\' | translate}}\" required><div \nng-messages=\"JamsostekForm.bpjsmaxrate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.MAXBPJSKES\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label><span \ntranslate=\"PAYROLL.MENU.RATEBPJSPENSIUN\"></span></label><input type=\"text\" name=\"ratejp\" \nng-model=\"vm.Form.objForm.ratejp\" placeholder=\"{{ \'PAYROLL.MENU.RATEBPJSPENSIUN\' | translate}}\" required> <span \nstyle=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"JamsostekForm.ratejp.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.RATEBPJSPENSIUN\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"ratejp=!ratejp\"><span \nstyle=\"color:goldenrod\">{{ratejp ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"ratejp\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.BPJSJPEMPLOYEE\"></span> (%)</label><input type=\"number\" \nname=\"jpemppct\" ng-model=\"vm.Form.objForm.jpemppct\" placeholder=\"{{ \'PAYROLL.MENU.BPJSJPEMPLOYEE\' | translate}}\" \nrequired><div ng-messages=\"JamsostekForm.jpemppct.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.BPJSJPEMPLOYEE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.jpemppostcode\" ng-change=\"vm.changeThp(vm.Form.objForm.jpemppostcode)\" ng-required=\"true\" \nname=\"jpemppostcode\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"JamsostekForm.jpemppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MENU.BPJSJPEMPPOST\"></span> is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.BPJSJPEMPR\"></span> (%)</label><input \ntype=\"number\" name=\"jpcomppct\" ng-model=\"vm.Form.objForm.jpcomppct\" \nplaceholder=\"{{ \'PAYROLL.MENU.BPJSJPEMPR\' | translate}}\" required><div ng-messages=\"JamsostekForm.jpcomppct.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.BPJSJPEMPR\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select ng-model=\"vm.Form.objForm.jpcomppostcode\" \nng-change=\"vm.changeThp(vm.Form.objForm.jpcomppostcode)\" ng-required=\"true\" name=\"jpcomppostcode\"><md-option \nng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"JamsostekForm.jpcomppostcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.BPJSJPEMPRPOST\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.MAXJPRATE\"></span></label><input type=\"number\" name=\"jpmaxrate\" \nng-model=\"vm.Form.objForm.jpmaxrate\" placeholder=\"{{ \'PAYROLL.MENU.MAXJPRATE\' | translate}}\" required><div \nng-messages=\"JamsostekForm.jpmaxrate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.MAXJPRATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"JamsostekForm.$invalid || JamsostekForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll-new/jamsostek/input-jamsostekmys.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  /*width:800px;\n  height:100px;*/\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"JamsostekForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,JamsostekForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAYROLL.MENU.BPJSPARAMETERFORMMYS\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label><span translate=\"PAYROLL.MENU.CODE\"></span></label><input type=\"text\" name=\"code\" \nng-model=\"vm.Form.objForm.code\" placeholder=\"{{ \'PAYROLL.MENU.CODE\' | translate}}\" required><div \nng-messages=\"JamsostekForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></label><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"{{ \'PAYROLL.MENU.DESCRIPTION\' | translate}}\" required><div \nng-messages=\"JamsostekForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label><span \ntranslate=\"PAYROLL.MENU.RATESOCSO\"></span></label><input type=\"text\" name=\"ratebpjs\" \nng-model=\"vm.Form.objForm.rate_socso\" placeholder=\"{{ \'PAYROLL.MENU.RATESOCSO\' | translate}}\" required> <span \nstyle=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"JamsostekForm.rate_socso.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.RATESOCSO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"tSocso=!tSocso\"><span \nstyle=\"color:goldenrod\">{{tSocso ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"tSocso\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.RATEEIS\"></span></label><input type=\"text\" \nname=\"ratebpjs\" ng-model=\"vm.Form.objForm.rate_eis\" placeholder=\"{{ \'PAYROLL.MENU.RATEEIS\' | translate}}\" required> \n<span style=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"JamsostekForm.rate_eis.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.RATEEIS\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"tEis=!tEis\"><span \nstyle=\"color:goldenrod\">{{ tEis ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" ng-show=\"tEis\">\n<fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span translate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span>\n</legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div>\n</div></fieldset></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label><span \ntranslate=\"PAYROLL.MENU.RATEEPF\"></span></label><input type=\"text\" name=\"ratebpjs\" ng-model=\"vm.Form.objForm.rate_epf\" \nplaceholder=\"{{ \'PAYROLL.MENU.RATEEPF\' | translate}}\" required> <span style=\"font-size: 10px\"><span \ntranslate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div ng-messages=\"JamsostekForm.rate_epf.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.RATEEPF\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"toggle=!toggle\">\n<span style=\"color:goldenrod\">{{toggle ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"toggle\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.SOCSOEMPLOYEE\"></span> (%)</label><input type=\"number\" \nname=\"ee_socso\" ng-model=\"vm.Form.objForm.ee_socso\" placeholder=\"{{ \'PAYROLL.MENU.SOCSOEMPLOYEE\' | translate}}\" \nrequired><div ng-messages=\"JamsostekForm.ee_socso.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.SOCSOEMPLOYEE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.ee_socso_post_code\" ng-change=\"vm.changeThp(vm.Form.objForm.ee_socso_post_code)\" \nng-required=\"true\" name=\"ee_socso_post_code\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.ee_socso_post_code.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.SOCSOEMPLOYEEPOST\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.SOCSOEMPLOYER\"></span> (%)</label><input type=\"number\" \nname=\"er_socso\" ng-model=\"vm.Form.objForm.er_socso\" placeholder=\"{{ \'PAYROLL.MENU.SOCSOEMPLOYER\' | translate}}\" \nrequired><div ng-messages=\"JamsostekForm.er_socso.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.SOCSOEMPLOYER\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.er_socso_post_code\" ng-change=\"vm.changeThp(vm.Form.objForm.er_socso_post_code)\" \nng-required=\"true\" name=\"er_socso_post_code\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.er_socso_post_code.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.SOCSOEMPLOYERPOST\"></span><span> Code is required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.EPFEMPLOYEE\"></span> (%)</label><input type=\"number\" name=\"ee_epf\" \nng-model=\"vm.Form.objForm.ee_epf\" placeholder=\"{{ \'PAYROLL.MENU.EPFEMPLOYEE\' | translate}}\" required><div \nng-messages=\"JamsostekForm.ee_epf.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.EPFEMPLOYEE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.ee_epf_post_code\" ng-change=\"vm.changeThp(vm.Form.objForm.ee_epf_post_code)\" \nng-required=\"true\" name=\"ee_epf_post_code\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.ee_epf_post_code.$error\" role=\"alert\"><div \nng-message=\"required\"><span><span translate=\"PAYROLL.MENU.EPFEMPLOYEEPOST\"></span> is required.</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.EPFEMPLOYER\"></span> (%)</label><input type=\"number\" name=\"er_epf\" \nng-model=\"vm.Form.objForm.er_epf\" placeholder=\"{{ \'PAYROLL.MENU.EPFEMPLOYER\' | translate}}\" required><div \nng-messages=\"JamsostekForm.er_epf.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MENU.EPFEMPLOYER\"></span> is required.</span></div></div></md-input-container><md-input-container \nflex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.er_epf_post_code\" ng-change=\"vm.changeThp(vm.Form.objForm.er_epf_post_code)\" \nng-required=\"true\" name=\"er_epf_post_code\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.er_epf_post_code.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.EPFEMPLOYERPOST\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.EISEMPLOYEE\"></span> (%)</label><input type=\"number\" \nname=\"ee_eis\" ng-model=\"vm.Form.objForm.ee_eis\" placeholder=\"{{ \'PAYROLL.MENU.EISEMPLOYEE\' | translate}}\" required><div\n ng-messages=\"JamsostekForm.ee_eis.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MENU.EISEMPLOYEE\"></span> is required.</span></div></div></md-input-container><md-input-container \nflex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.ee_eis_post_code\" ng-change=\"vm.changeThp(vm.Form.objForm.ee_eis_post_code)\" \nng-required=\"true\" name=\"ee_eis_post_code\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.ee_eis_post_code.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.EISEMPLOYEEPOST\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.EISEMPLOYER\"></span> (%)</label><input type=\"number\" \nname=\"er_eis\" ng-model=\"vm.Form.objForm.er_eis\" placeholder=\"{{ \'PAYROLL.MENU.EISEMPLOYER\' | translate}}\" required><div\n ng-messages=\"JamsostekForm.er_eis.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MENU.EISEMPLOYER\"></span> is required.</span></div></div></md-input-container><md-input-container \nflex><label><span translate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select \nng-model=\"vm.Form.objForm.er_eis_post_code\" ng-change=\"vm.changeThp(vm.Form.objForm.er_eis_post_code)\" \nng-required=\"true\" name=\"er_eis_post_code\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"JamsostekForm.er_eis_post_code.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.EISEMPLOYERPOST\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"JamsostekForm.$invalid || JamsostekForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll-new/jamsostek/jamsostek.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"{{ vm.header | translate}}\"></span></md-subheader><div class=\"white-bg\"><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputJamsostek($event,ls)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteJamsostek()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputJamsostek($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteJamsostek()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.CODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editJamsostek($event,ls.id)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.lisJamsostekSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.code}}\n</td><td class=\"text-center\">{{ls.description}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\">\n<td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/laporanprosespayroll/laporanprosespayroll.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.EMPLOYEEPAYROLLVIEW\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadArea(vm.company)\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"{{  \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"{{  \'PAYROLL.MENU.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"{{  \'PAYROLL.MENU.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.country!=\'MYS\'\">\n<md-select ng-model=\"vm.area\" placeholder=\"{{  \'PAYROLL.MENU.AREA\' | translate}}\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"{{  \'PAYROLL.MENU.SEARCH\' | translate}}\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country !=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" \ntype=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><div ng-if=\"vm.country==\'MYS\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label>\n<md-select ng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" \nng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"wilayah\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select ng-model=\"vm.cabang\" name=\"cabang\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><br>\n<br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"></div></form></div></div>\n</md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple stripped bordered stripped\" ms-responsive-table=\"\" \nstyle=\"margin-top:0\"><thead><tr><th><div class=\"table-header\"></div></th><th width=\"5%\"><div class=\"table-header\"><span\n class=\"column-title\"><span translate=\"PAYROLL.MENU.NO\"></span></span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PERIOD\"></span></span></div></th><th><div class=\"table-header\"><span\n class=\"column-title\"><span translate=\"PAYROLL.MENU.EMPNO\"></span></span></div></th><th><div class=\"table-header\"><span\n class=\"column-title\"><span translate=\"PAYROLL.MENU.FULLNAME\"></span></span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"PAYROLL.MENU.GROUP\"></span></span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"PAYROLL.MENU.POSITION\"></span></span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.THP\"></span></span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">#</span></div></th></tr></thead><tbody><tr \nng-dblclick=\"vm.editData(ls.id)\" ng-repeat=\"ls in vm.DataTable.list\"><td></td><td>{{ $index + 1 }}</td><td \nclass=\"text-center\">{{ ls.period }}</td><td class=\"text-center\">{{ ls.id_employee }}</td><td>\n{{ ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name | uppercase }}</td><td>{{ ls.group }}</td><td>\n{{ ls.position }}</td><td>{{ ls.amount | currency:\"Rp. \"}}</td><td><md-button aria-label=\"View Surveys\" \nclass=\"md-icon-button\" ng-click=\"vm.setView(ls.id_employee, ls.period)\" style=\"padding: 0;height: 24px;width: 24px\">\n<md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span><span \ntranslate=\"PAYROLL.MENU.VIEWSURVEYS\"></span></span></md-tooltip></md-button></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/nonfixentry-mgr/nonfixentry.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Input Allowance Non Fix</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadDivisi(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex ng-if=\"vm.country !=\'MYS\'\"><md-select ng-model=\"vm.area\" \nplaceholder=\"Area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container ng-if=\"vm.country !=\'MYS\'\" \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div ng-if=\"vm.country==\'MYS\'\" flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header\n class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><br><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\">\n<md-item-template><span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template>\n</md-autocomplete></div><div layout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\">\n</div></form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputNonFixEntry($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Allowance Non Fix</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteNonFixEntry()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Allowance Non Fix\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Upload Allowance Non Fix</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadAllowanceNonFix(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip\n md-direction=\"right\" md-visible=\"tooltipVisible\">Download File Allowance Non FIx</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon>Download</md-button><span flex hide \nshow-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.STARTDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.ENDDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editNonFixEntry($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.lisNonFixEntrySelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.start_date | date : \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.end_date | date : \"dd-MM-yyyy\"}}</td><td \nclass=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.code}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"\"}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/nonfixentry/edit-nonfixentry.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"NonFixForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,NonFixForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Allowance Non Fix</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"NonFixForm.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div \nng-messages=\"NonFixForm.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label><md-select \nng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" \nname=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select>\n<div ng-messages=\"NonFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>Payroll Code is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Desc\n</label><input type=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" placeholder=\"Payroll Desc\"><div \nng-messages=\"NonFixForm.payrolldesc.$error\" role=\"alert\"><div ng-message=\"required\"><span>Payroll Code is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Amount</label>\n<input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"Amount\"></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container flex><label>Amount Type</label><br><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.Form.objForm.amount_type\"><md-radio-button \nng-repeat=\"amount in vm.amountTypes\" ng-value=\"amount.value\">{{amount.label}}</md-radio-button></md-radio-group>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Is Prorate</label><br>\n<md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.Form.objForm.isprorate\"><md-radio-button \nng-repeat=\"amount in vm.isProrate\" ng-value=\"amount.value\">{{amount.label}}</md-radio-button></md-radio-group>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"NonFixForm.$invalid || NonFixForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/nonfixentry/input-nonfixentry.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"NonFixForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,NonFixForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Allowance Non Fix</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\">\n</span></label><md-select ng-model=\"vm.Form.objForm.country\" name=\"country\" ng-change=\"vm.changePayrollCode()\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"DeductionFixForm.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.\n</span></div></div></md-input-container><md-input-container flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.Form.objForm.end_date\" required></md-datepicker><div \nng-messages=\"DeductionFixForm.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-autocomplete required flex \nng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"DeductionFixForm.empno.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span>\n</div></div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Payroll Code</label>\n<md-select ng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" \nng-required=\"true\" name=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"NonFixForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPayroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Payroll Desc</label><input type=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" \nplaceholder=\"Payroll Desc\"><div ng-messages=\"NonFixForm.payrolldesc.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Payroll Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Amount</label><input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" \nplaceholder=\"Amount\" required><div ng-messages=\"NonFixForm.amount.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Amount is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Amount Type</label><br><md-radio-group layout=\"row\" layout-align=\"start center\" \nng-model=\"vm.Form.objForm.amount_type\" required><md-radio-button ng-repeat=\"amount in vm.amountTypes\" \nng-value=\"amount.value\">{{amount.label}}</md-radio-button></md-radio-group></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Is Prorate</label><br><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.Form.objForm.isprorate\" required><md-radio-button \nng-repeat=\"amount in vm.isProrate\" ng-value=\"amount.value\">{{amount.label}}</md-radio-button></md-radio-group>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"NonFixForm.$invalid || NonFixForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/nonfixentry/nonfixentry.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Input Allowance Non Fix</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span>\n</label><md-select ng-model=\"vm.country\" name=\"country\" ng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadDivisi(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex \nng-if=\"(vm.country !=\'MYS\'&&vm.company!=\'EN\') || (vm.country ==\'MYS\'&&vm.company!=\'EN\')\"><md-select ng-model=\"vm.area\" \nplaceholder=\"Area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nng-if=\"(vm.country !=\'MYS\'&&vm.company!=\'EN\') || (vm.country ==\'MYS\'&&vm.company!=\'EN\')\" layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon>Search</md-button></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option ng-value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container layout=\"column\" \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\"></span></md-button></md-input-container></div><br>\n<br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"></div></form></div></div>\n</md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputNonFixEntry($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Allowance Non Fix</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteNonFixEntry()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Allowance Non Fix\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm ng-click=\"vm.openUpload($event)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Upload Allowance Non Fix</md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Upload</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.downloadAllowanceNonFix(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno)\"><md-tooltip\n md-direction=\"right\" md-visible=\"tooltipVisible\">Download File Allowance Non FIx</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon>Download</md-button><span flex hide \nshow-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.STARTDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.ENDDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editNonFixEntry($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.lisNonFixEntrySelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.start_date | date : \"dd-MM-yyyy\"}}</td><td class=\"text-center\">{{ls.end_date | date : \"dd-MM-yyyy\"}}</td><td \nclass=\"text-center\">{{ls.empno}}</td><td class=\"text-center\">\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.code}}</td><td \nclass=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"\"}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/nonfixentry/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlsx)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span>More Info</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/otparameter/input-otparameter.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  /*width:800px;\n  height:100px;*/\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"OTParamForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,OTParamForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.OTPARAMETERFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.CODE\"></span></label><input type=\"text\" name=\"ot_code\" ng-model=\"vm.Form.objForm.ot_code\" \nplaceholder=\"{{ \'PAYROLL.MENU.CODE\' | translate}}\" required><div ng-messages=\"OTParamForm.ot_code.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.POSTTO\"></span></label><md-select ng-model=\"vm.Form.objForm.payrollcode\" \nng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" name=\"payrollcode\"><md-option \nng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"GradeForm.payrollcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.POSTTO\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DESCRIPTION\"></span></label><input type=\"text\" name=\"ot_description\" \nng-model=\"vm.Form.objForm.ot_description\" placeholder=\"{{ \'PAYROLL.MENU.DESCRIPTION\' | translate}}\"><div \nng-messages=\"OTParamForm.ot_description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label><span \ntranslate=\"PAYROLL.MENU.FORMULA\"></span></label><input type=\"text\" name=\"formula\" ng-model=\"vm.Form.objForm.formula\" \nplaceholder=\"{{ \'PAYROLL.MENU.FORMULA\' | translate}}\" required> <span style=\"font-size: 10px\"><span \ntranslate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div ng-messages=\"OTParamForm.formula.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.FORMULA\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"toggle=!toggle\">\n<span style=\"color:goldenrod\">{{toggle ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"toggle\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div ng-if=\"vm.country!=\'MYS\'\" \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.MULTIPLE1\"></span></label><input \ntype=\"number\" name=\"multiple1\" ng-model=\"vm.Form.objForm.multiple1\" \nplaceholder=\"{{ \'PAYROLL.MENU.MULTIPLE1\' | translate}}\" required><div ng-messages=\"OTParamForm.multiple1.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.MULTIPLE1\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div ng-if=\"vm.country!=\'MYS\'\" \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.MULTIPLE2\"></span></label><input \ntype=\"number\" name=\"multiple2\" ng-model=\"vm.Form.objForm.multiple2\" \nplaceholder=\"{{ \'PAYROLL.MENU.MULTIPLE2\' | translate}}\" required><div ng-messages=\"OTParamForm.multiple2.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.MULTIPLE2\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div ng-if=\"vm.country!=\'MYS\'\" \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.MULTIPLE3\"></span></label><input \ntype=\"number\" name=\"multiple3\" ng-model=\"vm.Form.objForm.multiple3\" \nplaceholder=\"{{ \'PAYROLL.MENU.MULTIPLE3\' | translate}}\" required><div ng-messages=\"OTParamForm.multiple3.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.MULTIPLE3\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div ng-if=\"vm.country!=\'MYS\'\" \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.MULTIPLE4\"></span></label><input \ntype=\"number\" name=\"multiple4\" ng-model=\"vm.Form.objForm.multiple4\" \nplaceholder=\"{{ \'PAYROLL.MENU.MULTIPLE4\' | translate}}\" required><div ng-messages=\"OTParamForm.multiple4.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span><span translate=\"PAYROLL.MENU.MULTIPLE4\"></span> is required.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"OTParamForm.$invalid || OTParamForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/otparameter/otparameter.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.OTPARAMETER\"></span></md-subheader><div class=\"white-bg\"><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputOtParameter($event,ls)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteOtParameter()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputOtParameter($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteOtParameter()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.CODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editOtParameter($event,ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.lisOtParameterSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ls.ot_code}}</td><td class=\"text-center\">{{ls.ot_description}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/payrollemployee/input-payrollemployee.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"PayEmpForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,PayEmpForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAYROLL.MENU.PAYROLLEMPLOYEEFORM\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-autocomplete \nrequired flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-search-text=\"vm.Form.objForm.fullname\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" \nmd-min-length=\"3\" md-input-name=\"empno\" md-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template>\n<span md-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template><div \nng-messages=\"PayEmpForm.empno.$error\"><div ng-message=\"required\"><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-autocomplete></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.Form.objForm.country\" name=\"country\" \nng-change=\"vm.changePayrollCode()\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"{{ vm.lbpjscode | translate}}\"></span></label><md-select ng-model=\"vm.Form.objForm.jamsostekcode\" \nng-change=\"vm.changeThp(vm.Form.objForm.jamsostekcode)\" ng-required=\"true\" name=\"jamsostekcode\"><md-option \nng-repeat=\"s in vm.listjamsostekcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"PayEmpForm.jamsostekcode.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.TAXCODE\"></span></label><md-select \nng-model=\"vm.Form.objForm.tax\" ng-change=\"vm.changeThp(vm.Form.objForm.taxode)\" ng-required=\"true\" name=\"taxcode\">\n<md-option ng-repeat=\"s in vm.listtaxcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"PayEmpForm.taxcode.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.OTCODE\"></span></label><md-select \nng-model=\"vm.Form.objForm.otcode\" ng-change=\"vm.changeThp(vm.Form.objForm.otcode)\" ng-required=\"true\" name=\"OT Code\">\n<md-option ng-repeat=\"s in vm.listot\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"PayEmpForm.otcode.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.TAXLOCATION\"></span></label><md-select \nng-model=\"vm.Form.objForm.taxlocation\" ng-change=\"vm.changeThp(vm.Form.objForm.taxlocation)\" name=\"taxlocation\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-required=\"true\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a tax location...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"taxlocation\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listtaxlocation | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"PayEmpForm.taxlocation.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"MENU.MAIN.ENCASHMENTLEAVE\"></span></label><md-select \nng-model=\"vm.Form.objForm.payleave_code\" ng-required=\"vm.required\" name=\"EncashmentLeave\"><md-option \nng-repeat=\"s in vm.listEncashmentLeave\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"PayEmpForm.EncashmentLeave.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"MENU.MAIN.ENCASHMENTLEAVE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>.</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"vm.Form.objForm.flag_report\" class=\"md-primary\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"><span \ntranslate=\"PAYROLL.MENU.FLAG\"></span></md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"PayEmpForm.$invalid || PayEmpForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/payrollemployee/payrollemployee.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PAYROLLEMPLOYEE\"></span></md-subheader><div class=\"white-bg\"><md-content\n class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadArea(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"{{ \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"{{ \'PAYROLL.MENU.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"{{ \'PAYROLL.MENU.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"vm.country!=\'MYS\' && vm.company!=\'EN\'\" flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div ng-if=\"vm.country==\'MYS\' && vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label>\n<md-select ng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" \nng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"wilayah\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select ng-model=\"vm.cabang\" name=\"cabang\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option ng-value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><br><div layout=\"row\" layout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container layout=\"column\" style=\"margin-top:-10px\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputPayrollEmployee($event,ls)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-warn md-mini\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeletePayrollEmployee()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputPayrollEmployee($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" aria-label=\"Inert\" \nng-disabled=\"vm.lisPayrollEmployeeSelected.length == 0\" ng-click=\" vm.DeletePayrollEmployee()\"><md-icon \nng-if=\"vm.lisPayrollEmployeeSelected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon \nng-if=\"vm.lisPayrollEmployeeSelected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.lisPayrollEmployeeSelected.length > 0\" class=\"red-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span>\n</span> <span ng-if=\"vm.lisPayrollEmployeeSelected.length == 0\" class=\"grey-700-fg\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></span> <span style=\"color:red\" \nng-if=\"vm.lisPayrollEmployeeSelected.length > 0\">{{ vm.lisPayrollEmployeeSelected.length }} <span \ntranslate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button aria-label=\"Twitter\" class=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.openUploadEmployee($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.UPLOAD\"></span></md-tooltip><md-icon md-font-icon=\"icon-upload\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.UPLOAD\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button aria-label=\"Twitter\" \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm \nng-click=\"vm.DownloadEmployee(vm.company, vm.divisi, vm.department, vm.area, vm.Form.objForm.empno, vm.wilayah, vm.regional, vm.cabang)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DOWNLOAD\"></span>\n</md-tooltip><md-icon md-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"text-center\" \nwidth=\"5%\"><div class=\"table-header\"><md-checkbox style=\"margin-top: 5px;margin-bottom: 5px;margin-left: 10px\" \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"></md-checkbox></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.FULLNAME\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"{{ vm.lbpjscode | translate}}\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.TAXCODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.OTCODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.TAXLOCATION\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.ENCASHMENTLEAVE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.FLAG\"></span></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editPayrollEmployee($event,ls.id)\"><td class=\"text-center\"><md-checkbox \nstyle=\"margin-top: 5px;margin-bottom: 5px\" aria-label=\"dataChecked\" \nng-checked=\"vm.exists(ls, vm.lisPayrollEmployeeSelected)\" ng-click=\"vm.toggle(ls, vm.lisPayrollEmployeeSelected)\">\n</md-checkbox></td><td class=\"text-center\">{{ls.empno}}</td><td>\n{{ls.first_name + \' \' + ls.middle_name + \' \' + ls.last_name}}</td><td class=\"text-center\">{{ls.jamsostekcode}}</td><td \nclass=\"text-center\">{{ls.tax}}</td><td class=\"text-center\">{{ls.otcode}}</td><td class=\"text-center\">{{ls.taxlocation}}\n</td><td class=\"text-center\">{{ls.encashment_name}}</td><td class=\"text-center\">{{ls.flag_report}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/payrollemployee/upload-file.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend><span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)\n</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input \ntype=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\"><span \ntranslate=\"PAYROLL.MENU.CANCEL\"></span></md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/payrollprocess/payrollprocess.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PAYPROC\"></span></md-subheader><div class=\"white-bg\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" \nng-change=\"vm.disableProcess()\" ng-disabled=\"vm.disabledPeriod\" required><md-option ng-repeat=\"ls in vm.listperiod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.PERIOD\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label>\n<md-select ng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"companyid\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.companyid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select \nng-model=\"vm.area\" name=\"area\" ng-change=\"vm.disableProcess()\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-autocomplete flex ng-disabled=\"vm.stateEdit\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"{{ \'PAYROLL.MENU.NIKNAME\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div></form>\n</div><div class=\"white-bg\"><md-content id=\"attendance-completion\" layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><th width=\"15\" class=\"text-center\">NO</th><th class=\"\">Item</th><th width=\"80\" class=\"text-center\">Status</th><th \nwidth=\"200\" class=\"text-center\">Processed at</th><th width=\"40\" class=\"text-center\">#</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listData\"><td>{{ $index + 1 }}.</td><td>{{ls.name}}</td><td class=\"text-center\"><span \nng-if=\"ls.status==\'0\'\"></span> <span ng-if=\"ls.status==\'1\'\" class=\"success-flag\">Success</span> <span \nng-if=\"ls.status==\'2\'\" class=\"failed-flag\">Failed</span></td><td class=\"text-center\"><span ng-if=\"ls.status!=\'0\'\">\n{{ls.timestamp}}</span></td><td class=\"text-center\"><div flex><md-button type=\"button\" \nng-click=\"vm.saveData($event,ls.target,ls.is_last_process,ls.index)\" \nng-disabled=\"ls.is_current_process==\'0\' || vm.disableButton\" class=\"grey-700-fg md-raised md-primary white-fg\" \naria-label=\"Submit\"><md-icon md-font-icon=\"icon-arrow-right-bold-hexagon-outline\" class=\"teal-50-fg\"></md-icon><span>\nProcess</span></md-button></div></td></tr><tr class=\"text-center\" ng-if=\"vm.listReport.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/positionrate/input-positionrate.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"PositionForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,PositionForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.POSITIONRATEFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"AbsentForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COMPANYNAME\"></span></label><md-select ng-model=\"vm.Form.objForm.companyid\" \nng-change=\"vm.changeCompany(vm.Form.objForm.companyid)\" ng-required=\"true\" name=\"companyid\"><md-option \nng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"AbsentForm.companyid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COMPANYNAME\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.POSITIONCODE\"></span></label><md-select ng-model=\"vm.Form.objForm.positioncode\" \nng-change=\"vm.changePosition(vm.Form.objForm.positioncode)\" ng-required=\"true\" name=\"positioncode\"><md-option \nng-repeat=\"s in vm.listposition\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"PositionForm.positioncode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.POSITIONCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.POSITIONDESC\"></span></label><input \ntype=\"text\" name=\"positiondesc\" ng-model=\"vm.Form.objForm.positiondesc\" \nplaceholder=\"{{ \'PAYROLL.MENU.POSITIONDESC\' | translate}}\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></label><md-select \nng-model=\"vm.Form.objForm.payrollcode\" ng-change=\"vm.changePayroll(vm.Form.objForm.payrollcode)\" ng-required=\"true\" \nname=\"payrollcode\"><md-option ng-repeat=\"s in vm.listpayrollcode\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select>\n<div ng-messages=\"PositionForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></label><input \ntype=\"text\" name=\"payrolldesc\" ng-model=\"vm.Form.objForm.payrolldesc\" \nplaceholder=\"{{ \'PAYROLL.MENU.PAYROLLDESC\' | translate}}\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.AMOUNT\"></span></label><input type=\"number\" \nname=\"amount\" ng-model=\"vm.Form.objForm.amount\" placeholder=\"{{ \'PAYROLL.MENU.AMOUNT\' | translate}}\" required><div \nng-messages=\"PositionForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.AMOUNT\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"vm.Form.objForm.flag_prorate\" \nclass=\"md-primary\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"><span translate=\"PAYROLL.MENU.FLAGPRORATE\"></span>\n</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"PositionForm.$invalid || PositionForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/positionrate/positionrate.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.POSITIONRATE\"></span></md-subheader><div class=\"white-bg\"><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputPositionRate($event,ls)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeletePositionRate()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputPositionRate($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeletePositionRate()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.COMPANYCODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.POSITIONCODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.POSITIONDESC\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLDESC\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.FLAGPRORATE\"></span></span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editPositionRate($event,ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.lisPositionRateSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ls.effective_date}}</td><td class=\"text-center\">{{ls.companyname}}</td><td class=\"text-center\">\n{{ls.positioncode}}</td><td class=\"text-center\">{{ls.positiondesc}}</td><td class=\"text-center\">{{ls.payrollcode}}</td>\n<td class=\"text-center\">{{ls.payrolldesc}}</td><td class=\"text-center\">{{ls.amount | currency:\"\"}}</td><td \nclass=\"text-center\">{{ls.flag_prorate}}</td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td \ncolspan=\"9\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/ptkp/input-ptkp.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"PtkpForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,PtkpForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.PTKPPARAMETERFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"PtkpForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.CODE\"></span></label><input type=\"text\" name=\"ptkpcode\" ng-model=\"vm.Form.objForm.ptkpcode\" \nplaceholder=\"{{ \'PAYROLL.MENU.CODE\' | translate}}\" required><div ng-messages=\"PtkpForm.ptkpcode.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.AMOUNT\"></span>\n</label><input type=\"number\" name=\"amount\" ng-model=\"vm.Form.objForm.amount\" \nplaceholder=\"{{ \'PAYROLL.MENU.AMOUNT\' | translate}}\" required><div ng-messages=\"PtkpForm.description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.AMOUNT\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"PtkpForm.$invalid || PtkpForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/ptkp/ptkp.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PTKPPARAMETER\"></span></md-subheader><div class=\"white-bg\"><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputPtkp($event,ls)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\n<span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" ng-click=\"vm.DeletePtkp()\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputPtkp($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeletePtkp()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\n<span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\"></span></md-button><span \nflex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.CODE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.AMOUNT\"></span></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editPtkp($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.lisPtkpSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.effective_date}}</td><td \nclass=\"text-center\">{{ls.ptkpcode}}</td><td class=\"text-right\">{{ls.amount | currency:\"\"}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/publishpayslip/form-input.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Publish Payslip</md-subheader><div class=\"white-bg\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"companyid\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.companyid.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span>\n</div></div></md-input-container><div ng-if=\"vm.country==\'MYS\'\"><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header\n class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.Form.objForm.sub_area_id\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\" \nrequired><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\">Submit</md-button></form></div></div>\n</md-content></div>");
$templateCache.put("app/main/payroll-new/publishpayslip/log-fail.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Log</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"\">Area</th><th class=\"text-center\">Note</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.logFail\"><td class=\"text-left\">{{ls.area}}</td><td class=\"text-left\">{{ls.note}}</td></tr></tbody>\n</table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/payroll-new/publishpayslip/publishpayslip.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PUBLISHPAYSLIP\"></span></md-subheader><div class=\"white-bg\"><md-toolbar>\n<div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.publish($event)\"><span><span translate=\"PAYROLL.MENU.PUBLISHPAYSLIP\"></span></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\">\n<span translate=\"PAYROLL.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.STATUS\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PUBLISHEDBY\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.PUBLISHEDDATE\"></span></span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">\n{{item.period}}</td><td class=\"text-center\">{{item.company}}</td><td class=\"text-center\">\n{{(item.subarea==null ? \'All\' : item.subarea)}}</td><td class=\"text-center\"><span ng-if=\"item.status==\'Published\'\" \nclass=\"priority-low\">{{item.status}}</span> <span ng-if=\"item.status==\'Unpublish\'\" class=\"priority-middle\">\n{{item.status}}</span></td><td class=\"text-center\">{{item.publishedby}}</td><td class=\"text-center\">\n{{item.publishedat}}</td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" \nclass=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\">\n<md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-if=\"item.status==\'Published\'\" ng-click=\"vm.processData($event, item,\'unpublish\')\"><div layout=\"row\" flex>\n<p flex><span translate=\"PAYROLL.MENU.UNPUBLISH\"></span></p></div></md-button><md-button \nng-if=\"item.status==\'Unpublish\'\" ng-click=\"vm.processData($event, item,\'publish\')\"><div layout=\"row\" flex><p flex><span\n translate=\"PAYROLL.MENU.PUBLISH\"></span></p></div></md-button><md-button ng-click=\"vm.viewDetail($event, item)\"><div \nlayout=\"row\" flex><p flex><span translate=\"PAYROLL.MENU.DETAIL\"></span></p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/publishpayslip/view-detail.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"70\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2><span translate=\"PAYROLL.MENU.VIEWDETAIL\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span></div></md-toolbar><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nwidth=\"5%\" class=\"text-center\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.NIK\"><span \ntranslate=\"PAYROLL.MENU.EMPNO\"></span></span></th><th width=\"15%\" class=\"text-center\"><span class=\"column-title\" \ntranslate=\"HC_NEWS.TABLE.NAME\"><span translate=\"PAYROLL.MENU.NAME\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.items\"><td class=\"text-center\"><span>{{ls.nik}}</span></td><td class=\"\"><span>{{ls.name}}</span>\n</td></tr><tr ng-if=\"vm.items.length <= 0\"><td colspan=\"4\" class=\"text-center\"><span>No Data Available</span></td></tr>\n</tbody></table><div ng-if=\"vm.items.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll-new/publishthr/form-input.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Publish THR</md-subheader><div class=\"white-bg\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Tahun</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"companyid\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.companyid.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span>\n</div></div></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.Form.objForm.sub_area_id\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\">Submit</md-button></form></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/publishthr/publishthr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PUBLISHTHR\"></span></md-subheader><div class=\"white-bg\"><md-toolbar><div\n class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.publish($event)\"><span><span translate=\"PAYROLL.MENU.PUBLISHTHR\"></span></span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\"><span class=\"column-title\">\n<span translate=\"PAYROLL.MENU.NO\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.TAHUN\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"PAYROLL.MENU.AREA\"></span></span></th><th class=\"text-center\"><span class=\"column-title\">STATUS</span></th>\n<th class=\"text-center\"><span class=\"column-title\">PUBLISHEDBY</span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PUBLISHEDDATE\"></span></span></th><th width=\"5%\"><span \nclass=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th></tr></thead><tbody><tr \nclass=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td class=\"text-center\">{{($index + 1)}}</td><td \nclass=\"text-center\">{{item.period}}</td><td class=\"text-center\">{{item.company}}</td><td class=\"text-center\">\n{{(item.subarea==null ? \'All\' : item.subarea)}}</td><td class=\"text-center\"><span ng-if=\"item.status==\'Published\'\" \nclass=\"priority-low\">{{item.status}}</span> <span ng-if=\"item.status==\'Unpublish\'\" class=\"priority-middle\">\n{{item.status}}</span></td><td class=\"text-center\">{{item.publishedby}}</td><td class=\"text-center\">\n{{item.publishedat}}</td><td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" \nclass=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu md-position-mode=\"target-right target\">\n<md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-if=\"item.status==\'Published\'\" ng-click=\"vm.processData($event, item,\'unpublish\')\"><div layout=\"row\" flex>\n<p flex><span translate=\"PAYROLL.MENU.UNPUBLISH\"></span></p></div></md-button><md-button \nng-if=\"item.status==\'Unpublish\'\" ng-click=\"vm.processData($event, item,\'publish\')\"><div layout=\"row\" flex><p flex><span\n translate=\"PAYROLL.MENU.PUBLISH\"></span></p></div></md-button><md-button ng-click=\"vm.viewDetail($event, item)\"><div \nlayout=\"row\" flex><p flex><span translate=\"PAYROLL.MENU.DETAIL\"></span></p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTables.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/publishthr/view-detail.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"70\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2><span translate=\"PAYROLL.MENU.VIEWDETAIL\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\n<span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</span></div></md-toolbar><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nwidth=\"5%\" class=\"text-center\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.NIK\">NIK</span></th><th width=\"15%\" \nclass=\"text-center\"><span class=\"column-title\" translate=\"HC_NEWS.TABLE.NAME\">Name</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.items\"><td class=\"text-center\"><span>{{ls.nik}}</span></td><td class=\"\"><span>{{ls.name}}</span>\n</td></tr><tr ng-if=\"vm.items.length <= 0\"><td colspan=\"4\" class=\"text-center\"><span>No Data Available</span></td></tr>\n</tbody></table><div ng-if=\"vm.items.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/payroll-new/salarycomponent/input-salarycomponent.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  /*width:800px;\n  height:100px;*/\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,SalcomForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.FORMINPUT\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.CODE\"></span>\n</label><input type=\"text\" name=\"code\" ng-model=\"vm.Form.objForm.code\" \nplaceholder=\"{{\'PAYROLL.MENU.CODE\' | translate}}\" required><div ng-messages=\"SalcomForm.code.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.CODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span>\n</label><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" \nplaceholder=\"{{\'PAYROLL.MENU.DESCRIPTION\' | translate}}\" required><div ng-messages=\"SalcomForm.description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.STATUS\"></span></label><md-select ng-model=\"vm.Form.objForm.status\" \nng-change=\"vm.changeStatus(vm.Form.objForm.status)\" ng-required=\"true\" name=\"status\"><md-option \nng-repeat=\"s in vm.liststatus\" value=\"{{s}}\">{{s}}</md-option></md-select><div ng-messages=\"SalcomForm.status.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.STATUS\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.TYPE\"></span></label><md-select ng-model=\"vm.Form.objForm.type\" \nng-change=\"vm.changeType(vm.Form.objForm.type)\" ng-required=\"true\" name=\"type\"><md-option ng-repeat=\"s in vm.listtype\" \nvalue=\"{{s}}\">{{s}}</md-option></md-select><div ng-messages=\"SalcomForm.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.TYPE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label><span \ntranslate=\"PAYROLL.MENU.FORMULA\"></span></label><input type=\"text\" name=\"formula\" id=\"formula\" \nng-model=\"vm.Form.objForm.formula\" placeholder=\"{{\'PAYROLL.MENU.FORMULA\' | translate}}\" \nng-required=\"vm.Form.objForm.type == \'Formula\'\"> <span style=\"font-size: 10px\"><span \ntranslate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span></md-input-container><md-input-container flex=\"33\"><a \nid=\"toggleMessage\" ng-click=\"toggle=!toggle\"><span style=\"color:goldenrod\">{{toggle ? \'Hide\' : \'Show\'}}</span></a>\n</md-input-container></div><div id=\"box\" ng-show=\"toggle\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\">\n<span translate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.THP\"></span></label><br><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-change=\"vm.changeThp(vm.Form.objForm.thp)\" ng-model=\"vm.Form.objForm.thp\" required>\n<md-radio-button ng-repeat=\"item in vm.listthp\" ng-value=\"item\">{{item}}</md-radio-button></md-radio-group><div \nng-messages=\"SalcomForm.thp.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.THP\"></span>\n<span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.ISALLEMPLOYEE\"></span></label><br><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.Form.objForm.is_all_employee\" required><md-radio-button \nng-repeat=\"item in vm.isAllEmpList\" ng-value=\"item.value\">{{item.label}}</md-radio-button></md-radio-group>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/salarycomponent/salarycomponent.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.SALARYCOMP\"></span></md-subheader><div class=\"white-bg\"><md-toolbar><div\n class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputSalaryComponent($event,ls)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.ADD\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteSalaryComponent()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRY\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputSalaryComponent($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteSalaryComponent()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.CODE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.STATUS\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.TYPE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.FORMULA\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.THP\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.ISALLEMPLOYEE\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editSalaryComponent($event,ls.id)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.lisSalaryComponentSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.code}}</td><td>{{ls.description}}</td><td class=\"text-center\">{{ls.status}}</td><td class=\"text-center\">\n{{ls.type}}</td><td class=\"text-center\">{{ls.formula}}</td><td class=\"text-center\">{{ls.thp}}</td><td \nclass=\"text-center\"><span ng-if=\"ls.is_all_employee==\'1\'\" translate=\"UMUT.MENU.YES\"></span> <span \nng-if=\"ls.is_all_employee==\'0\'\" translate=\"UMUT.MENU.NOT\"></span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"PAYROLL.MENU.NODATA\"></span>\n</td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/taxlocation/input-taxlocation.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"TaxLocationForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,TaxLocationForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.TAXLOCATIONFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.TAXOFFICECODE\"></span></label><input type=\"text\" name=\"taxlocationcode\" \nng-model=\"vm.Form.objForm.taxlocationcode\" placeholder=\"{{ \'PAYROLL.MENU.TAXOFFICECODE\' | translate}}\" required><div \nng-messages=\"TaxLocationForm.taxlocationcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.TAXOFFICECODE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DESCRIPTION\"></span></label><input type=\"text\" name=\"taxofficename\" \nng-model=\"vm.Form.objForm.taxofficename\" placeholder=\"{{ \'PAYROLL.MENU.DESCRIPTION\' | translate}}\" required><div \nng-messages=\"TaxLocationForm.position.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.DESCRIPTION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"{{ vm.branch | translate}}\"></span></label><input type=\"text\" name=\"branchnpwpno\" \nng-model=\"vm.Form.objForm.branchnpwpno\" placeholder=\"{{ vm.branch | translate}}\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.TAXSIGNERNAME\"></span></label><input \ntype=\"text\" name=\"branchsignername\" ng-model=\"vm.Form.objForm.branchsignername\" \nplaceholder=\"{{ \'PAYROLL.MENU.TAXSIGNERNAME\' | translate}}\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"{{ vm.sigher | translate}}\"></span></label><input type=\"text\" \nname=\"branchsignernpwp\" ng-model=\"vm.Form.objForm.branchsignernpwp\" placeholder=\"{{ vm.sigher | translate}}\">\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.Form.objForm.country\" name=\"country\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.CITY\">\n</span></label><input type=\"text\" name=\"branchcity\" ng-model=\"vm.Form.objForm.branchcity\" \nplaceholder=\"{{ \'PAYROLL.MENU.CITY\' | translate}}\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.ADDRESS\"></span></label><input type=\"text\" \nname=\"branchaddress\" ng-model=\"vm.Form.objForm.branchaddress\" placeholder=\"{{ \'PAYROLL.MENU.ADDRESS\' | translate}}\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"TaxLocationForm.$invalid || TaxLocationForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll-new/taxlocation/taxlocation.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.TAXLOCATION\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select style=\"width:200px\" ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputTaxLocation($event,ls)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteTaxLocation()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputTaxLocation($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteTaxLocation()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.TAXOFFICECODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span></span></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editTaxLocation($event,ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.lisTaxLocationSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ls.taxlocationcode}}</td><td class=\"text-center\">{{ls.taxofficename}}</td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll/taxlocation/input-taxlocation.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"TaxLocationForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,TaxLocationForm)\"><md-toolbar class=\"md-cyan-600-bg\">\n<div class=\"md-toolbar-tools\"><h2>Form Tax Location</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Tax Office Code</label><input type=\"text\" name=\"taxlocationcode\" \nng-model=\"vm.Form.objForm.taxlocationcode\" placeholder=\"Tax Office Code\" required><div \nng-messages=\"TaxLocationForm.taxlocationcode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAttendance Code is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Description</label><input type=\"text\" name=\"taxofficename\" ng-model=\"vm.Form.objForm.taxofficename\" \nplaceholder=\"Tax Office Name\" required><div ng-messages=\"TaxLocationForm.position.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Position is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Branch NPWP</label><input type=\"text\" name=\"branchnpwpno\" \nng-model=\"vm.Form.objForm.branchnpwpno\" placeholder=\"Branch NPWP No\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Tax Signer Name</label><input type=\"text\" name=\"branchsignername\" \nng-model=\"vm.Form.objForm.branchsignername\" placeholder=\"Tax Signer Name\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Tax Signer NPWP</label><input type=\"text\" name=\"branchsignernpwp\" \nng-model=\"vm.Form.objForm.branchsignernpwp\" placeholder=\"Tax Signer NPWP\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Address</label><input type=\"text\" name=\"branchaddress\" \nng-model=\"vm.Form.objForm.branchaddress\" placeholder=\"Address\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>City</label><input type=\"text\" name=\"branchcity\" ng-model=\"vm.Form.objForm.branchcity\" \nplaceholder=\"City\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"TaxLocationForm.$invalid || TaxLocationForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/payroll/taxlocation/taxlocation.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nTax Location</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputTaxLocation($event,ls)\"><md-tooltip \nmd-direction=\"right\" md-visible=\"tooltipVisible\">New Tax Location</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteTaxLocation()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Delete Tax Location\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputTaxLocation($event,ls)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">New Tax Location</md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.DeleteTaxLocation()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete Tax Location\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div><table \nclass=\"simple with-toolbar\" ms-responsive-table id=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\">\nTax Office Code</span></th><th class=\"text-center\"><span class=\"column-title\">Description</span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editTaxLocation($event,ls.id)\"><td><input \ntype=\"checkbox\" checklist-model=\"vm.lisTaxLocationSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.taxlocationcode}}</td><td class=\"text-center\">{{ls.taxofficename}}</td></tr></tbody><tbody></tbody></table>\n</md-toolbars></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/payroll-new/taxmalaysia/taxmalaysiaComponent.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">Tax Malaysia\n</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.loadData(1)\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container><label>Start Salary</label><input type=\"text\" name=\"start_salary\" ng-model=\"vm.start_salary\">\n</md-input-container><md-input-container><label>End Salary</label><input type=\"text\" name=\"end_salary\" \nng-model=\"vm.end_salary\"></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRY\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.add($event,ls)\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nstyle=\"font-size:15px\" md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-button class=\"md-warn md-mini\" type=\"button\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.remove()\"><md-tooltip\n md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nstyle=\"font-size:15px\" md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span class=\"column-title\"><span>No\n</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>Start Salary</span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span>End Salary</span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span>Tax Status</span></span></th><th class=\"text-center\"><span class=\"column-title\"><span>Amount\n</span></span></th><th>#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editSalaryComponent($event,ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listDataSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ls.no}}</td><td \nclass=\"text-center\">{{ls.start_salary}}</td><td class=\"text-center\">{{ls.end_salary}}</td><td class=\"text-center\">\n{{ls.tax_status}}</td><td class=\"text-center\">{{ls.amount}}</td><td class=\"text-center\"><a href=\"javascript:void(0);\" \nng-click=\"vm.edit($event, ls)\" style=\"text-decoration: none\"><span class=\"icon-pencil\"></span></a></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span \ntranslate=\"PAYROLL.MENU.NODATA\"></span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/taxparameter/input-taxparameter-mys.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"TaxParamForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,TaxParamForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAYROLL.MENU.TAXPARAMETERFORMMYS\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.Form.objForm.country\" \nng-disabled=\"true\" name=\"country\" ng-change=\"vm.changePayrollCode()\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.TAXCODE\"></span></label><input type=\"text\" name=\"taxcode\" ng-model=\"vm.Form.objForm.taxcode\" \nplaceholder=\"{{ \'PAYROLL.MENU.TAXCODE\' | translate}}\" required><div ng-messages=\"TaxParamForm.taxcode.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.TAXCODE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.TAXDESC\"></span></label><input type=\"text\" \nname=\"taxdesc\" ng-model=\"vm.Form.objForm.taxdesc\" placeholder=\"{{ \'PAYROLL.MENU.TAXDESC\' | translate}}\" required><div \nng-messages=\"TaxParamForm.taxdesc.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.TAXDESC\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PPHPOSTING\"></span></label><md-select ng-model=\"vm.Form.objForm.pphpostingcode\" \nng-change=\"vm.changeStatus(vm.Form.objForm.pphpostingcode)\" ng-required=\"true\" name=\"pphpostingcode\"><md-option \nng-repeat=\"s in vm.listSalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"TaxParamForm.pphpostingcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PPHPOSTING\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label><span \ntranslate=\"PAYROLL.MENU.GAJIPENSIUN\"></span></label><input type=\"text\" name=\"T01gross\" \nng-model=\"vm.Form.objForm.T01gross\" placeholder=\"{{ \'PAYROLL.MENU.GAJIPENSIUN\' | translate}}\" required> <span \nstyle=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T01gross.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.GAJIPENSIUN\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T01gross=!T01gross\"><span \nstyle=\"color:goldenrod\">{{T01gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"T01gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.TUNJLAIN\"></span></label><input type=\"text\" \nname=\"T03gross\" ng-model=\"vm.Form.objForm.T03gross\" placeholder=\"{{ \'PAYROLL.MENU.TUNJLAIN\' | translate}}\" required> \n<span style=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T03gross.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.TUNJLAIN\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T03gross=!T03gross\"><span \nstyle=\"color:goldenrod\">{{T03gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"T03gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.COMMISSION\"></span></label><input type=\"text\" \nname=\"T04gross\" ng-model=\"vm.Form.objForm.T04gross\" placeholder=\"{{ \'PAYROLL.MENU.COMMISSION\' | translate}}\" required> \n<span style=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T04gross.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COMMISSION\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T04gross=!T04gross\"><span \nstyle=\"color:goldenrod\">{{T04gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"T04gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.UNPAIDLEAVE\"></span></label><input type=\"text\" \nname=\"unpaid_leave\" ng-model=\"vm.Form.objForm.unpaid_leave\" placeholder=\"{{ \'PAYROLL.MENU.UNPAIDLEAVE\' | translate}}\" \nrequired><div ng-messages=\"TaxParamForm.unpaid_leave.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.UNPAIDLEAVEMAX\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.UNPAIDLEAVEMAX\"></span></label>\n<input type=\"number\" name=\"unpaid_leave_max\" ng-model=\"vm.Form.objForm.unpaid_leave_max\" \nplaceholder=\"{{ \'PAYROLL.MENU.UNPAIDLEAVEMAX\' | translate}}\" required><div \nng-messages=\"TaxParamForm.unpaid_leave_max.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.UNPAIDLEAVEMAX\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.EPF\">\n</span></label><input type=\"text\" name=\"epf\" ng-model=\"vm.Form.objForm.epf\" \nplaceholder=\"{{ \'PAYROLL.MENU.EPF\' | translate}}\" required><div ng-messages=\"TaxParamForm.epf.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"PAYROLL.MENU.EPF\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.EPFMAX\"></span></label>\n<input type=\"number\" name=\"epf_max\" ng-model=\"vm.Form.objForm.epf_max\" \nplaceholder=\"{{ \'PAYROLL.MENU.EPFMAX\' | translate}}\" required><div ng-messages=\"TaxParamForm.epf_max.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.EPFMAX\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.SOCSO\"></span></label><input type=\"text\" name=\"socso\" \nng-model=\"vm.Form.objForm.socso\" placeholder=\"{{ \'PAYROLL.MENU.SOCSO\' | translate}}\" required><div \nng-messages=\"TaxParamForm.socso.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.SOCSO\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.SOCSOMAX\"></span></label><input type=\"number\" name=\"socso_max\" \nng-model=\"vm.Form.objForm.socso_max\" placeholder=\"{{ \'PAYROLL.MENU.SOCSOMAX\' | translate}}\" required><div \nng-messages=\"TaxParamForm.socso.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.SOCSOMAX\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.EIS\">\n</span></label><input type=\"text\" name=\"eis\" ng-model=\"vm.Form.objForm.eis\" \nplaceholder=\"{{ \'PAYROLL.MENU.EIS\' | translate}}\" required><div ng-messages=\"TaxParamForm.eis.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"PAYROLL.MENU.EIS\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.EISMAX\"></span></label>\n<input type=\"number\" name=\"eis_max\" ng-model=\"vm.Form.objForm.eis_max\" \nplaceholder=\"{{ \'PAYROLL.MENU.EISMAX\' | translate}}\" required><div ng-messages=\"TaxParamForm.eis.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PAYROLL.MENU.EISMAX\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label><span \ntranslate=\"PAYROLL.MENU.NATURA\"></span></label><input type=\"text\" name=\"T06gross\" ng-model=\"vm.Form.objForm.T06gross\" \nplaceholder=\"{{ \'PAYROLL.MENU.NATURA\' | translate}}\" required> <span style=\"font-size: 10px\"><span \ntranslate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div ng-messages=\"TaxParamForm.T06gross.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"PAYROLL.MENU.NATURA\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" \nng-click=\"T06gross=!T06gross\"><span style=\"color:goldenrod\">{{T06gross ? \'Hide\' : \'Show\'}}</span></a>\n</md-input-container></div><div id=\"box\" ng-show=\"T06gross\"><fieldset class=\"demo-fieldset\"><legend \nclass=\"demo-legend\"><span translate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex>\n<div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.TANTIEM\"></span></label><input type=\"text\" \nname=\"T07gross\" ng-model=\"vm.Form.objForm.T07gross\" placeholder=\"{{ \'PAYROLL.MENU.TANTIEM\' | translate}}\" required> \n<span style=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T07gross.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.TANTIEM\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T07gross=!T07gross\"><span \nstyle=\"color:goldenrod\">{{T07gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"T07gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.NONTAXABLE\"></span></label><input type=\"text\" \nname=\"biayajabatan\" ng-model=\"vm.Form.objForm.biayajabatan\" placeholder=\"{{ \'PAYROLL.MENU.NONTAXABLE\' | translate}}\">\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.NONTAXABLEMAX\"></span></label><input\n type=\"number\" name=\"biayajabatanmax\" ng-model=\"vm.Form.objForm.biayajabatanmax\" \nplaceholder=\"{{ \'PAYROLL.MENU.NONTAXABLEMAX\' | translate}}\" required><div \nng-messages=\"TaxParamForm.biayajabatanmax.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.NONTAXABLEMAX\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"33\"><label><span \ntranslate=\"PAYROLL.MENU.IURAN\"></span></label><input type=\"text\" name=\"T10\" ng-model=\"vm.Form.objForm.T10\" \nplaceholder=\"{{ \'PAYROLL.MENU.IURAN\' | translate}}\" required> <span style=\"font-size: 10px\"><span \ntranslate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div ng-messages=\"TaxParamForm.T10.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.IURAN\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T10=!T10\"><span \nstyle=\"color:goldenrod\">{{T10 ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" ng-show=\"T10\">\n<fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span translate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span>\n</legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div>\n</div></fieldset></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"TaxParamForm.$invalid || TaxParamForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/taxparameter/input-taxparameter.html","<style type=\"text/css\">\n#toggleMessage {\n  width:50px;\n  height:30px;\n  font-size:13px;\n}\n\n#box {\n  transition: all linear 0.5s;\n  /*background-color: lightblue;*/\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin-bottom:10px;\n}\n</style><md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"TaxParamForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,TaxParamForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAYROLL.MENU.TAXPARAMETERFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.TAXCODE\"></span></label><input type=\"text\" name=\"taxcode\" ng-model=\"vm.Form.objForm.taxcode\" \nplaceholder=\"{{ \'PAYROLL.MENU.TAXCODE\' | translate}}\" required><div ng-messages=\"TaxParamForm.taxcode.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.TAXCODE\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.TAXDESC\"></span></label><input type=\"text\" \nname=\"taxdesc\" ng-model=\"vm.Form.objForm.taxdesc\" placeholder=\"{{ \'PAYROLL.MENU.TAXDESC\' | translate}}\" required><div \nng-messages=\"TaxParamForm.taxdesc.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.TAXDESC\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PPHPOSTING\"></span></label><md-select ng-model=\"vm.Form.objForm.pphpostingcode\" \nng-change=\"vm.changeStatus(vm.Form.objForm.pphpostingcode)\" ng-required=\"true\" name=\"pphpostingcode\"><md-option \nng-repeat=\"s in vm.listSalcom\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"TaxParamForm.pphpostingcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PPHPOSTING\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"66\"><label><span \ntranslate=\"PAYROLL.MENU.GAJIPENSIUN\"></span></label><input type=\"text\" name=\"T01gross\" \nng-model=\"vm.Form.objForm.T01gross\" placeholder=\"{{ \'PAYROLL.MENU.GAJIPENSIUN\' | translate}}\" required> <span \nstyle=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T01gross.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.GAJIPENSIUN\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T01gross=!T01gross\"><span \nstyle=\"color:goldenrod\">{{T01gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"T01gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.TUNJLAIN\"></span></label><input type=\"text\" \nname=\"T03gross\" ng-model=\"vm.Form.objForm.T03gross\" placeholder=\"{{ \'PAYROLL.MENU.TUNJLAIN\' | translate}}\" required> \n<span style=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T03gross.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.TUNJLAIN\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T03gross=!T03gross\"><span \nstyle=\"color:goldenrod\">{{T03gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"T03gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.HONORARIUM\"></span></label><input type=\"text\" \nname=\"T04gross\" ng-model=\"vm.Form.objForm.T04gross\" placeholder=\"{{ \'PAYROLL.MENU.HONORARIUM\' | translate}}\" required> \n<span style=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T04gross.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.HONORARIUM\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T04gross=!T04gross\"><span \nstyle=\"color:goldenrod\">{{T04gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"T04gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.PREMI\"></span></label><input type=\"text\" \nname=\"T05gross\" ng-model=\"vm.Form.objForm.T05gross\" placeholder=\"{{ \'PAYROLL.MENU.PREMI\' | translate}}\" required> <span\n style=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T05gross.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PREMI\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T05gross=!T05gross\"><span \nstyle=\"color:goldenrod\">{{T05gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"T05gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.NATURA\"></span></label><input type=\"text\" \nname=\"T06gross\" ng-model=\"vm.Form.objForm.T06gross\" placeholder=\"{{ \'PAYROLL.MENU.NATURA\' | translate}}\" required> \n<span style=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T06gross.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.NATURA\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T06gross=!T06gross\"><span \nstyle=\"color:goldenrod\">{{T06gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"T06gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"66\"><label><span translate=\"PAYROLL.MENU.TANTIEM\"></span></label><input type=\"text\" \nname=\"T07gross\" ng-model=\"vm.Form.objForm.T07gross\" placeholder=\"{{ \'PAYROLL.MENU.TANTIEM\' | translate}}\" required> \n<span style=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T07gross.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.TANTIEM\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex=\"33\"><a id=\"toggleMessage\" ng-click=\"T07gross=!T07gross\"><span \nstyle=\"color:goldenrod\">{{T07gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" \nng-show=\"T07gross\"><fieldset class=\"demo-fieldset\"><legend class=\"demo-legend\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div layout=\"row\" layout-wrap flex><div flex=\"50\" \nng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.BIAYAJABATAN\"></span></label><input type=\"number\" \nname=\"biayajabatan\" ng-model=\"vm.Form.objForm.biayajabatan\" placeholder=\"{{ \'PAYROLL.MENU.BIAYAJABATAN\' | translate}}\">\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.NILAIMAX\"></span></label><input \ntype=\"number\" name=\"biayajabatanmax\" ng-model=\"vm.Form.objForm.biayajabatanmax\" \nplaceholder=\"{{ \'PAYROLL.MENU.NILAIMAX\' | translate}}\" required><div ng-messages=\"TaxParamForm.biayajabatanmax.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.NILAIMAX\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex=\"33\"><label><span translate=\"PAYROLL.MENU.IURAN\"></span></label><input type=\"text\" name=\"T10\" \nng-model=\"vm.Form.objForm.T10\" placeholder=\"{{ \'PAYROLL.MENU.IURAN\' | translate}}\" required> <span \nstyle=\"font-size: 10px\"><span translate=\"PAYROLL.MESSAGE.INSTRUCTION\"></span></span><div \nng-messages=\"TaxParamForm.T10.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.IURAN\">\n</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container \nflex=\"33\"><a id=\"toggleMessage\" ng-click=\"T10gross=!T10gross\"><span style=\"color:goldenrod\">\n{{T10gross ? \'Hide\' : \'Show\'}}</span></a></md-input-container></div><div id=\"box\" ng-show=\"T10\"><fieldset \nclass=\"demo-fieldset\"><legend class=\"demo-legend\"><span translate=\"PAYROLL.MENU.PAYROLLCOMPVIEW\"></span></legend><div \nlayout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"ls in vm.listallpayroll\">{{ ls.name }}</div></div></fieldset>\n</div><div layout-gt-sm=\"row\"><md-input-container><label><span translate=\"PAYROLL.MENU.NONNPWP\"></span></label><input \ntype=\"number\" name=\"nonnpwp_pinalty\" ng-model=\"vm.Form.objForm.nonnpwp_pinalty\" \nplaceholder=\"{{ \'PAYROLL.MENU.NONNPWP\' | translate}}\" required><div ng-messages=\"TaxParamForm.nonnpwp_pinalty.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.NONNPWP\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PKP1\"></span></label><input type=\"number\" \nname=\"pkp1_limit=\" ng-model=\"vm.Form.objForm.pkp1_limit\" placeholder=\"{{ \'PAYROLL.MENU.LIMITAMOUNT\' | translate}}\" \nrequired><div ng-messages=\"TaxParamForm.pkp1_limit.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PKP1\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"pkp1\" ng-model=\"vm.Form.objForm.pkp1\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" required><div ng-messages=\"TaxParamForm.pkp1.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.PKP1\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PKP2\"></span></label><input type=\"number\" \nname=\"pkp2_limit\" ng-model=\"vm.Form.objForm.pkp2_limit\" placeholder=\"{{ \'PAYROLL.MENU.LIMITAMOUNT\' | translate}}\" \nrequired><div ng-messages=\"TaxParamForm.pkp2_limit.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PKP2\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"pkp2\" ng-model=\"vm.Form.objForm.pkp2\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" required><div ng-messages=\"TaxParamForm.pkp2.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.PKP2\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PKP3\"></span></label><input type=\"number\" \nname=\"pkp3_limit\" ng-model=\"vm.Form.objForm.pkp3_limit\" placeholder=\"{{ \'PAYROLL.MENU.LIMITAMOUNT\' | translate}}\" \nrequired><div ng-messages=\"TaxParamForm.pkp3_limit.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PKP3\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"pkp3\" ng-model=\"vm.Form.objForm.pkp3\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" required><div ng-messages=\"TaxParamForm.pkp3.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.PKP3\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PKP4\"></span></label><input type=\"number\" \nname=\"pkp4_limit\" ng-model=\"vm.Form.objForm.pkp4_limit\" placeholder=\"{{ \'PAYROLL.MENU.LIMITAMOUNT\' | translate}}\" \nrequired><div ng-messages=\"TaxParamForm.pkp4_limit.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PKP4\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"pkp4\" ng-model=\"vm.Form.objForm.pkp4\" \nplaceholder=\"{{ \'PAYROLL.MENU.PERCENTAGE\' | translate}}\" required><div ng-messages=\"TaxParamForm.pkp4.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.PKP4\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"TaxParamForm.$invalid || TaxParamForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/taxparameter/taxparameter.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"{{vm.header | translate}}\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span>\n</div><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select style=\"width:200px\" ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container></div></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.inputTaxParameter($event,ls)\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteTaxParameter()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputTaxParameter($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteTaxParameter()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"inputTable\"><thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.TAXCODE\"></span></span></th><th \nclass=\"text-center\"><span class=\"column-title\"><span translate=\"PAYROLL.MENU.TAXDESC\"></span></span></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editTaxParameter($event,ls.id)\"><td class=\"text-center\">\n<input type=\"checkbox\" checklist-model=\"vm.lisTaxParameterSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.taxcode}}</td><td class=\"text-center\">{{ls.taxdesc}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/thrprocess/thrprocess.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.THRPROCESS\"></span></md-subheader><div class=\"white-bg\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Employee No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete>\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.TAHUN\"></span></label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tahun is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select ng-model=\"vm.company\" name=\"companyid\" \nng-change=\"vm.LoadArea(vm.company)\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\" required>\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.companyid.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.Form.objForm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.HOLIDAYDATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"hariraya\" \nng-model=\"vm.Form.objForm.hariraya\" flex=\"30\"></md-datepicker><div ng-messages=\"SalcomForm.hariraya.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>hari raya Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYMENTDATE\"></span></label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"paymentdate\" ng-model=\"vm.Form.objForm.paymentdate\" flex=\"30\"></md-datepicker><div \nng-messages=\"SalcomForm.paymentdate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Payment Date is required.\n</span></div></div></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\">Submit</md-button></form></div></div>\n</md-content></div>");
$templateCache.put("app/main/payroll-new/uploadfixnonfix/upload-data.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.UPLOADFIXNONFIX\"></span></md-subheader><div class=\"white-bg\"><md-content\n class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><fieldset><legend><span translate=\"PAYROLL.MENU.UPLOADDATAFIX\">\n</span> - <span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFileFixEntry\" nv-file-select \nuploader=\"vm.FileUploaderFixEntry\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div><div flex>\n<md-button type=\"submit\" ng-click=\"vm.FileUploaderFixEntry.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplateFix()\" class=\"md-primary md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfoFix\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoFix)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>\n<span translate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></div></div><span class=\"padding-5\"></span><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderFixEntry.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div></md-content>\n</fieldset><div flex><div ng-show=\"vm.uploadErrorFix\" flex layout layout-align=\"center center\" style=\"padding:3px\">\n<span style=\"color:red\">{{ vm.uploadNotifFix }}</span></div><div ng-show=\"vm.uploadSuccessFix\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotifFix }}</span></div></div><fieldset \nstyle=\"margin-top:20px\"><legend><span translate=\"PAYROLL.MENU.UPLOADDATANONFIX\"></span> - <span \ntranslate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFileNonFixEntry\" nv-file-select \nuploader=\"vm.FileUploaderNonFixEntry\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div><div flex>\n<md-button type=\"submit\" ng-click=\"vm.FileUploaderNonFixEntry.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplateNonFix()\" class=\"md-primary md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfoNonFix\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoNonFix)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>\n<span translate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></div></div><span class=\"padding-5\"></span><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderNonFixEntry.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div></md-content>\n</fieldset><div flex><div ng-show=\"vm.uploadErrorNonFix\" flex layout layout-align=\"center center\" style=\"padding:3px\">\n<span style=\"color:red\">{{ vm.uploadNotifNonFix }}</span></div><div ng-show=\"vm.uploadSuccessNonFix\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotifNonFix }}</span></div></div></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/uploadfixnonfix-mgr/upload-data.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.UPLOADFIXNONFIX\"></span></md-subheader><div class=\"white-bg\"><md-content\n class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><fieldset><legend><span translate=\"PAYROLL.MENU.UPLOADDATAFIX\">\n</span> - <span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFileFixEntry\" nv-file-select \nuploader=\"vm.FileUploaderFixEntry\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div><div flex>\n<md-button type=\"submit\" ng-click=\"vm.FileUploaderFixEntry.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplateFix()\" class=\"md-primary md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfoFix\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoFix)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>\n<span translate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></div></div><span class=\"padding-5\"></span><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderFixEntry.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div></md-content>\n</fieldset><div flex><div ng-show=\"vm.uploadErrorFix\" flex layout layout-align=\"center center\" style=\"padding:3px\">\n<span style=\"color:red\">{{ vm.uploadNotifFix }}</span></div><div ng-show=\"vm.uploadSuccessFix\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotifFix }}</span></div></div><fieldset \nstyle=\"margin-top:20px\"><legend><span translate=\"PAYROLL.MENU.UPLOADDATANONFIX\"></span> - <span \ntranslate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFileNonFixEntry\" nv-file-select \nuploader=\"vm.FileUploaderNonFixEntry\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div><div flex>\n<md-button type=\"submit\" ng-click=\"vm.FileUploaderNonFixEntry.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplateNonFix()\" class=\"md-primary md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfoNonFix\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoNonFix)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>\n<span translate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></div></div><span class=\"padding-5\"></span><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderNonFixEntry.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div></md-content>\n</fieldset><div flex><div ng-show=\"vm.uploadErrorNonFix\" flex layout layout-align=\"center center\" style=\"padding:3px\">\n<span style=\"color:red\">{{ vm.uploadNotifNonFix }}</span></div><div ng-show=\"vm.uploadSuccessNonFix\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotifNonFix }}</span></div></div></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/production-products/production/production-list-nonproduction-view.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">List MPP Standard</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInput\" class=\"md-inline-form\" \nng-submit=\"vm.loadDataProduct()\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.startDate\" md-placeholder=\"Start Date\" name=\"startDate\"></md-datepicker>\n</md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" layout-align=\"center end\"><md-icon \nmd-font-icon=\"icon-magnify\" \\></md-icon>Search</md-button></div></form></div></div></md-content><div layout=\"column\" \nflex><form name=\"frmCreate\" ng-cloack novalidate ng-submit=\"vm.create($event, formInput)\"><div layout=\"column\" flex>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">Entries</span></md-input-container>\n<md-button class=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.deleteMpp($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete</span></md-button><md-button \nclass=\"md-raised reference-button md-primary md-hue-2\" ui-sref=\"app.production_list_non_production\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span>Create Standard</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th>SKU</th><th>DESCRIPTION</th><th>EFFETIVE DATE</th><th>LINK IMAGE</th><th>QTY</th><th>CREATED BY</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td align=\"center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td align=\"center\">{{ ls.sku }}</td><td>\n{{ ls.description }}</td><td>{{ ls.effective_date }}</td><td>{{ ls.link_image }}</td><td align=\"right\">{{ ls.qty }}\n</td><td>{{ ls.created_by }}</td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></form></div></div></div></md-content></div>");
$templateCache.put("app/main/production-products/production/production-list-nonproduction.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Set MPP Standard</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInput\" class=\"md-inline-form\" \nng-submit=\"vm.loadDataProduct()\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.startDate\" md-placeholder=\"Start Date\" name=\"startDate\"></md-datepicker>\n</md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" \nng-disabled=\"formInput.$invalid || formInput.$pristine\" layout-align=\"center end\"><md-icon md-font-icon=\"icon-magnify\" \n\\></md-icon>Search</md-button></div></form></div></div></md-content><div layout=\"column\" flex><form name=\"frmCreate\" \nng-cloack novalidate ng-submit=\"vm.create($event, formInput)\"><div layout=\"column\" flex><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-button class=\"md-blue-grey-300-bg md-raised white-fg\" \nlayout-align=\"end center\" ng-show=\"!vm.statEdit\" ng-click=\"vm.editMpp($event)\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline\" \\></md-icon>Edit</md-button><md-button \nclass=\"md-blue-grey-300-bg md-raised white-fg\" layout-align=\"end center\" ng-show=\"vm.statEdit\" \nng-click=\"vm.cancel($event)\"><md-icon md-font-icon=\"icon-arrow-left-bold-hexagon-outline\" \\></md-icon>Cancel\n</md-button><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" \nng-disabled=\"frmCreate.$invalid || frmCreate.$pristine\" layout-align=\"center end\" ng-show=\"vm.statEdit\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-hexagon-outline\" \\></md-icon>Create</md-button></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><md-input-container class=\"md-block\" \nng-show=\"vm.statEdit\" flex=\"20\"><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.effectiveDate\" md-placeholder=\"Effective Date\" name=\"effectiveDate\" md-open-on-focus \nflex=\"20\" md-min-date=\"vm.minDate\" required></md-datepicker><div ng-messages=\"frmCreate.effectiveDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective date field is required.</span></div></div></md-input-container>\n<table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table \nng-show=\"!vm.statEdit\"><thead><tr><th>POSITION NAME</th><th>POSITION GROUP</th><th>MPP TYPE</th><th>GENDER</th><th>QTY\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.list\"><td>{{ ls.position_name }}</td><td>{{ ls.position_group }}</td>\n<td>{{ ls.mpp_type }}</td><td>{{ ls.gender }}</td><td>{{ ls.qty }}</td></tr></tbody></table><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table ng-show=\"vm.statEdit\">\n<thead><tr><th>POSITION NAME</th><th>POSITION GROUP</th><th>MPP TYPE</th><th>GENDER</th><th>QTY</th><th>ACTION</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.Form.objForm.standard\"><td><md-input-container class=\"md-block\"><input \nng-model=\"vm.Form.objForm.standard[$index].position_name\" placeholder=\"Position Name {{$index+1}}\" \nname=\"position_name{{$index}}\" required></md-input-container></td><td><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.Form.objForm.standard[$index].position_group\" name=\"position_group{{$index}}\" required><md-option \nng-repeat=\"ls in vm.listPosition\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container></td><td>\n<md-input-container class=\"md-block\"><md-select ng-model=\"vm.Form.objForm.standard[$index].mpp_type\" \nname=\"mpp_type{{$index}}\" required><md-option ng-repeat=\"ls in vm.listType\" value=\"{{ls}}\">{{ls}}</md-option>\n</md-select></md-input-container></td><td><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.Form.objForm.standard[$index].gender\" name=\"gender{{$index}}\" required><md-option \nng-repeat=\"ls in vm.listGender\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container></td><td>\n<md-input-container class=\"md-block\"><input ng-model=\"vm.Form.objForm.standard[$index].qty\" \nplaceholder=\"Qty {{$index+1}}\" name=\"qty{{$index}}\" required type=\"number\" ng-min=\"0\"></md-input-container></td><td>\n<md-button ng-click=\"vm.hapus($index)\" class=\"md-icon-button md-warn md-button md-default-theme md-ink-ripple\" \nng-if=\"!$last\"><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-close-circle material-icons\"></md-icon>\n</md-button><md-button ng-click=\"vm.tambah()\" \nclass=\"md-icon-button md-accent md-button md-default-theme md-ink-ripple\" ng-if=\"$last\"><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-plus-circle material-icons\"></md-icon></md-button></td></tr>\n</tbody></table></md-content></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></form></div></div>\n</div></md-content></div>");
$templateCache.put("app/main/production-products/production/production-list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Production List</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>Production Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.workingDate\" md-placeholder=\"Working Date\" name=\"workingDate\" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container flex><label>Building</label><md-select required \nng-model=\"vm.gedung\" name=\"gedung\" ng-change=\"vm.loadSector(vm.gedung)\"><md-option ng-repeat=\"ls in vm.listGedung\" \nvalue=\"{{ls.id}}\">{{ls.gedung_name}}</md-option></md-select></md-input-container><md-input-container flex><label>Sector\n</label><md-select ng-model=\"vm.sector\" name=\"sector\" ng-change=\"vm.loadLine(vm.sector)\"><md-option \nng-repeat=\"ls in vm.listSector\" value=\"{{ls.id}}\">{{ls.sector_name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Line</label><md-select ng-model=\"vm.line\" name=\"line\"><md-option \nng-repeat=\"ls in vm.listLine\" value=\"{{ls.id}}\">{{ls.line_number}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Product</label><md-select ng-model=\"vm.product\" name=\"product\"><md-option \nng-repeat=\"ls in vm.listProduct\" value=\"{{ls.id}}\">{{ls.sku}} - ({{ls.description}})</md-option></md-select>\n</md-input-container><md-input-container flex><label>Shift</label><md-select ng-model=\"vm.shift\" name=\"shift\">\n<md-option ng-repeat=\"ls in vm.shiftList\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-button class=\"md-mini md-raised md-primary\" type=\"submit\" layout-align=\"end center\"><md-icon \nmd-font-icon=\"icon-magnify\" \\></md-icon>Submit</md-button><md-button class=\"md-mini md-raised md-primary\" \nng-click=\"vm.downloadReport()\"><md-icon md-font-icon=\"icon-download\"></md-icon>Download Report</md-button></div></form>\n</div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select></md-input-container><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div><div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-mini md-raised md-primary\" \ntype=\"submit\" ng-click=\"vm.upload($event)\"><md-icon md-font-icon=\"icon-upload\" \\></md-icon>Upload Production\n</md-button><md-button class=\"md-mini md-raised md-info\" type=\"submit\" ng-click=\"vm.create($event)\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\" \\></md-icon>Create Production</md-button></div><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>\nPRODUCTION DATE</th><th>SKU</th><th>DESCRIPTION</th><th>CREAM TYPE</th><th>QTY</th><th>WORKING HOURS</th><th>\nSHIFT GROUP</th><th>GEDUNG</th><th>SECTOR</th><th>LINE</th><th>MPP STANDARD</th><th>CREATE BY</th><th>CREATE DATE</th>\n<th>ACTION</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td>{{ ls.production_date }}</td><td>\n{{ ls.sku }}</td><td>{{ ls.description }}</td><td>{{ ls.cream_type }}</td><td>{{ ls.product_qty }}</td><td>\n{{ ls.working_hours }}</td><td>{{ ls.shift_type }}</td><td>{{ ls.gedung_nama }}</td><td>{{ ls.sector_nama }}</td><td>\n{{ ls.line_nama }}</td><td>{{ ls.mpp_standard }}</td><td>{{ ls.nama }}</td><td>{{ ls.created_date }}</td><td><md-button\n aria-label=\"Edit Production\" class=\"md-icon-button\" ng-click=\"vm.edit($event, ls)\" \nstyle=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-pencil\" class=\"blue-500-fg\"></md-icon>\n<md-tooltip><span>Edit Production</span></md-tooltip></md-button></td></tr></tbody></table><div \nclass=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/behaviour-performance/behaviour-performance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\"><span translate=\"KPI.LABEL.PERIOD\"></span></div><md-menu id=\"projects-menu\" md-offset=\"0 48\">\n<md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"period in vm.listPeriod\"><md-button \naria-label=\"{{period.effectiveDate}}\" ng-click=\"vm.showBehivor(period.effectiveDate)\"><span class=\"secondary-text\">\n<span><md-icon ng-if=\"period.effectiveDate == vm.currentDate\" md-font-icon=\"icon-check\"></md-icon><md-icon \nng-if=\"!period.effectiveDate\"></md-icon>{{period.effectiveDate}}</span></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill><div \nclass=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\"><span translate=\"KPI.LABEL.TSTERATING\">\n</span> {{vm.currentDate}}</md-subheader><div class=\"white-bg\"><md-toolbar><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.addData($event)\" \nng-if=\"!vm.totalResult\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span><span translate=\"KPI.LABEL.ADDTSTE\">\n</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"md-toolbar-tools table-tools\">\n<md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\" ng-if=\"!vm.totalResult\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\n<span><span translate=\"KPI.LABEL.ADDTSTE\"></span></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span><span translate=\"KPI.LABEL.ADDTSTE\"></span></span>\n</md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\"><span \ntranslate=\"KPI.LABEL.NO\"></span></th><th rowspan=\"2\"><span translate=\"KPI.LABEL.RESULTDATE\"></span></th><th \ncolspan=\"2\"><span translate=\"KPI.LABEL.TRUSTWORTY\"></span></th><th colspan=\"2\"><span translate=\"KPI.LABEL.SUPERTEAM\">\n</span></th><th colspan=\"2\"><span translate=\"KPI.LABEL.TOTALLYCUSTOMER\"></span></th><th colspan=\"2\"><span \ntranslate=\"KPI.LABEL.EXCELLENCE\"></span></th><th rowspan=\"2\"><span translate=\"KPI.LABEL.ACTION\"></span></th></tr><tr>\n<th style=\"text-align:center\"><span translate=\"KPI.LABEL.KARYAWAN\"></span></th><th style=\"text-align:center\"><span \ntranslate=\"KPI.LABEL.ATASAN\"></span></th><th style=\"text-align:center\"><span translate=\"KPI.LABEL.KARYAWAN\"></span>\n</th><th style=\"text-align:center\"><span translate=\"KPI.LABEL.ATASAN\"></span></th><th style=\"text-align:center\"><span \ntranslate=\"KPI.LABEL.KARYAWAN\"></span></th><th style=\"text-align:center\"><span translate=\"KPI.LABEL.ATASAN\"></span>\n</th><th style=\"text-align:center\"><span translate=\"KPI.LABEL.KARYAWAN\"></span></th><th style=\"text-align:center\"><span\n translate=\"KPI.LABEL.ATASAN\"></span></th></tr></thead><tbody><tr ng-repeat=\"input in vm.listInput\"><td \nstyle=\"text-align: center\">{{($index + 1)}}</td><td style=\"text-align:center\">{{input.resultDateAlias}}</td><td \nstyle=\"text-align:center\">{{input.resultA}}</td><td style=\"text-align:center\">{{input.resultAtasA}}</td><td \nstyle=\"text-align:center\">{{input.resultB}}</td><td style=\"text-align:center\">{{input.resultAtasB}}</td><td \nstyle=\"text-align:center\">{{input.resultC}}</td><td style=\"text-align:center\">{{input.resultAtasC}}</td><td \nstyle=\"text-align:center\">{{input.resultD}}</td><td style=\"text-align:center\">{{input.resultAtasD}}</td><td \nstyle=\"text-align:center\"><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.editData(input,input.resultDate,input.id,input.resultA,input.resultB,input.resultC,input.resultD,input.resultDateAlias)\">\n<md-icon md-font-icon=\"icon-table-edit\" class=\"blue-500-fg\"></md-icon><md-tooltip><span><span \ntranslate=\"KPI.LABEL.CLICKFOREDIT\"></span></span></md-tooltip></md-button></td></tr></tbody></table></md-content></div>\n</div></md-content></div>");
$templateCache.put("app/main/pms/behaviour-performance-team/behaviour-performance-team.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.PERFORMANCETEAM\"></span></md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"1%\"></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></div></th><th class=\"secondary-text\" \nwidth=\"40%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NIKNAME\"></span></span>\n</div></th><th class=\"secondary-text\" width=\"20%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.JOINDATE\"></span></span></div></th><th class=\"secondary-text\" width=\"8%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.VIEW\"></span></span></div></th></tr></thead>\n<tbody><tr ng-init=\"mainIdx=$index;vm.visibleSubChild[mainIdx]=false\" \nng-repeat-start=\"team in ::vm.DataTable.list track by $index\" class=\"light-gray\"><td><md-button \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.toogleSubChild(mainIdx)\" class=\"md-icon-button\" \naria-label=\"More\" ng-if=\"team.listAnak.length>0\"><md-icon ng-show=\"!vm.visibleSubChild[mainIdx]\" \nmd-font-icon=\"icon-plus\"></md-icon><md-icon ng-show=\"vm.visibleSubChild[mainIdx]\" md-font-icon=\"icon-minus\"></md-icon>\n</md-button></td><td align=\"center\">{{ (mainIdx + 1)}}</td><td>{{ team.nik}} - {{ team.name}}</td><td \nclass=\"text-center\">{{ team.dateJoin}}</td><td class=\"text-center\"><md-button class=\"md-icon-button\" \naria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setView(team.nik)\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span translate=\"KPI.LABEL.CLICKFORVIEW\"></span>\n</md-tooltip></md-button></td></tr><tr ng-show=\"vm.visibleSubChild[mainIdx]\" \nng-repeat=\"lstSubTeam in ::team.listAnak track by $index\" style=\"background: rgba(0,0,0,0.08)\"><td></td><td \nalign=\"right\">{{ ($index + 1)}}</td><td style=\"padding-left:20px !important\">{{ lstSubTeam.nik}} - {{ lstSubTeam.name}}\n</td><td>{{ lstSubTeam.dateJoin}}</td><td><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setView(lstSubTeam.nik)\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span translate=\"KPI.LABEL.CLICKFORVIEW\"></span></md-tooltip></md-button>\n</td></tr><tr ng-repeat-end></tr></tbody></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/competency-review/competency-review.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Competency Review</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\" id=\"contentCompetencyReview\"><div id=\"inputView\"><div class=\"toolbar mb-10\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"md-headline\" ng-if=\"vm.remaining > 0 && vm.listInput.length > 0\" \nstyle=\"color:#FD7545\">{{vm.remaining}} Remaining</span> <span class=\"md-headline\" \nng-if=\"vm.remaining === 0 && vm.listInput.length > 0\" style=\"color:#06B433\">Completed</span></div><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\" colspan=\"3\">Competencies\n</th><th rowspan=\"2\">Required</th><th colspan=\"2\">Assessment</th><th rowspan=\"2\">Gap</th><th rowspan=\"2\">\nTop 3 of Strength and Area for Improvement</th><th rowspan=\"2\">Comments</th><th rowspan=\"2\">#</th></tr><tr><td \nstyle=\"text-align:center\">Self</td><td style=\"text-align:center\">N+1</td></tr></thead><tbody \nng-repeat=\"group in vm.listInput track by $index\" ng-if=\"group.details !== undefined\"><tr><td \nrowspan=\"{{group.details.length + 1}}\" style=\"text-align: center\">{{group.category_name}}</td></tr><tr \nng-repeat=\"input in group.details\"><td style=\"text-align:center\">{{input.competency_code}}</td><td>{{input.competency}}\n</td><td style=\"text-align:center\">{{input.req_level}}</td><td style=\"text-align:center\">{{input.self_level}}</td><td \nstyle=\"text-align:center\">{{input.mgr_level}}</td><td style=\"text-align:center\">{{input.gap}}</td><td \nstyle=\"text-align:center\">{{input.status_name}}</td><td><div>{{input.comments}}</div><div ng-if=\"input.mgr_comments\" \nstyle=\"border-top: 1px dotted #ccc\">{{input.mgr_comments}}</div></td><td style=\"text-align:center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.inputData($event, input)\"><md-icon md-font-icon=\"icon-table-edit\" class=\"blue-500-fg\"></md-icon>\n<md-tooltip><span>Update Self Level</span></md-tooltip></md-button></td></tr></tbody></table><form \nstyle=\"margin-top: 20px\" ng-cloak name=\"formCompetencyReviewAspiration\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveAspirationData($event,formCompetencyReviewAspiration)\"><div layout=\"column\"><div flex-gt-sm=\"50\" \nflex=\"50\"><div layout=\"row\"><md-input-container flex class=\"md-block md-input-has-value\"><label>Career Aspiration\n</label><textarea name=\"career_aspiration\" rows=\"3\" ng-model=\"vm.career_aspiration\" \nplaceholder=\"Please enter your career aspiration for future roles here...\">{{vm.career_aspiration}</textarea>\n</md-input-container></div></div><div flex-gt-sm=\"50\" flex=\"50\"><div layout=\"row\"><md-button \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Inert\" ng-disabled=\"formCompetencyReviewAspiration.$invalid\" \ntype=\"submit\"><span>Save</span></md-button><md-button class=\"md-blue-300-bg md-raised white-fg\" \nng-click=\"vm.setToken()\"><span>Reload Token</span></md-button></div></div></div></form></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/pms/competency/competency.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">Menu</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg csm-dropdown\"><md-button ng-click=\"vm.openUploadComeptency($event)\">Upload File</md-button>\n<md-button ui-sref=\"app.utility_modules_input-modules\">Add Competency</md-button><md-button \nng-click=\"vm.deleteModul($event)\">Delete Competency</md-button></md-menu-content></md-menu></div></div></div></div>\n<md-content class=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill>\n<md-subheader class=\"white-bg\">Competency</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"2%\"><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th width=\"5%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"MENU.PMS.COMPETENCY.INDEX.TABLE.NO\">No</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"MENU.PMS.COMPETENCY.INDEX.TABLE.CODE\">Code</span></div></th><th width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"MENU.PMS.COMPETENCY.INDEX.TABLE.COMPETENCY\">Competency\n</span></div></th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"MENU.PMS.COMPETENCY.INDEX.TABLE.DESCRIPTION\">Description</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls.id)\"><td><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.modulesAction(ls.id)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"MENU.PMS.COMPETENCY.INDEX.ACTION.VIEW_ACTION\">View Action</span></p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></td><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listModulSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ ls.no }}</td><td class=\"text-center\">{{ ls.code | uppercase }}\n</td><td style=\"white-space: nowrap\" class=\"text-center\">{{ ls.competency | uppercase }}</td><td>\n{{ ls.description | uppercase }}</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/competency/upload-competency.html","<md-dialog aria-label=\"Uplaod\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload Shift</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div class=\"text-right\" flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pms/competency-team/competency-team.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Competency Review</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\" width=\"1%\"></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"MENU.PMS.COMPETENCY.TEAM.INDEX.TABLE.NO\">No</span></div></th><th class=\"text-left\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"MENU.PMS.COMPETENCY.TEAM.INDEX.TABLE.NIK_NAME\">NIK/NAME\n</span></div></th><th class=\"secondary-text\" width=\"15%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"MENU.PMS.COMPETENCY.TEAM.INDEX.TABLE.DATE_JOIN\">DATE JOIN</span></div></th><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"MENU.PMS.COMPETENCY.TEAM.INDEX.TABLE.VIEW\">\nVIEW</span></div></th></tr></thead><tbody><tr ng-init=\"mainIdx=$index;vm.visibleSubChild[mainIdx]=false\" \nng-repeat-start=\"team in ::vm.DataTable.list track by $index\" class=\"light-gray\"><td><md-button \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.toogleSubChild(mainIdx)\" class=\"md-icon-button\" \naria-label=\"More\"><md-icon ng-show=\"!vm.visibleSubChild[mainIdx]\" md-font-icon=\"icon-plus\"></md-icon><md-icon \nng-show=\"vm.visibleSubChild[mainIdx]\" md-font-icon=\"icon-minus\"></md-icon></md-button></td><td align=\"center\">\n{{ (mainIdx + 1)}}</td><td>{{ team.nik}} - {{ team.name}}</td><td class=\"text-center\">{{ team.dateJoin}}</td><td \nclass=\"text-center\"><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setView(team.nik)\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>click for view</span></md-tooltip></md-button></td></tr><tr \nng-show=\"vm.visibleSubChild[mainIdx]\" ng-repeat=\"lstSubTeam in ::team.listAnak track by $index\" \nstyle=\"background: rgba(0,0,0,0.08)\"><td></td><td align=\"center\">{{ ($index + 1)}}</td><td \nstyle=\"padding-left:20px !important\">{{ lstSubTeam.nik}} - {{ lstSubTeam.name}}</td><td class=\"text-center\">\n{{ lstSubTeam.dateJoin}}</td><td class=\"text-center\"><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setViewD(lstSubTeam.nik)\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>click for view</span></md-tooltip></md-button></td></tr><tr \nng-repeat-end></tr></tbody></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/cr-progress/cr-progress.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Competency Review Progress Report</span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label><md-select \nng-disabled=\"vm.group === \'110\' || vm.group === \'116\'\" ng-change=\"vm.loadDataDivision(vm.bu)\" ng-model=\"vm.bu\">\n<md-option ng-value=\"\">All</md-option><md-option ng-repeat=\"bu in vm.listBu\" ng-value=\"bu.id\">{{bu.description}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Division</label>\n<md-select ng-change=\"vm.loadDataDepartment(vm.divisi)\" ng-model=\"vm.divisi\"><md-option ng-value=\"\">All</md-option>\n<md-option ng-repeat=\"divisi in vm.listDivisi\" ng-value=\"divisi.id\">{{divisi.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Department</label><md-select \nng-change=\"vm.loadData(1)\" ng-model=\"vm.department\"><md-option ng-value=\"\">All</md-option><md-option \nng-repeat=\"department  in vm.listDepartment\" ng-value=\"department.id\">{{department.description}}</md-option>\n</md-select></md-input-container></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" \nclass=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span translate=\"ACTION.ACTION\">Action</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.approveOT($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span translate=\"ACTION.APPROVE\">Approve\n</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-raised reference-button\" \nng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><span translate=\"ACTION.REJECT\">Reject\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-input-container hide show-gt-sm><select name=\"see\" \nid=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span class=\"secondary-text\" \ntranslate=\"TABLE.ENTRIES\">Entries</span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.ExporttoExcel()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions\n</span></md-tooltip><md-icon md-font-icon=\"icon-file-excel\"></md-icon><span>Export to Excel</span></md-button><span \nflex hide show-gt-sm></span><ms-search-bar query=\"vm.DataTable.searchParam\" on-search=\"vm.loadData(1)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nid=\"cr_progress_table\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\" \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header text-center\"><span class=\"column-title\">No</span></div></th>\n<th rowspan=\"2\" class=\"secondary-text\" width=\"10%\"><div class=\"table-header text-center\"><span class=\"column-title\">NIK\n</span></div></th><th rowspan=\"2\" class=\"secondary-text\" width=\"30%\"><div class=\"table-header text-center\"><span \nclass=\"column-title\">NAME</span></div></th><th colspan=\"3\" class=\"secondary-text\" width=\"30%\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">COMPETENCY REVIEW</span></div></th><th rowspan=\"2\" \nclass=\"secondary-text\" style=\"text-align:center\"><div class=\"table-header\"><span class=\"column-title\">POTENTIAL REVIEW\n</span></div></th><th rowspan=\"2\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nCOMPLETION STATUS</span></div></th></tr><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">SELF COMPETENCE</span></div></th><th style=\"text-align:center\"><span class=\"column-title\">\nCAREER ASPIRATION</span></th><th class=\"secondary-text\" style=\"text-align:center\"><div class=\"table-header\"><span \nclass=\"column-title\">TEAM DEVELOPMENT</span></div></th></tr></thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\">\n<td align=\"center\">{{ ($index + 1)}}</td><td>{{ team.nik}}</td><td>{{ team.name}}</td><td align=\"center\"><div \nng-if=\"team.remaining && team.remaining !== \'0\'\">{{ team.remaining }} remaining</div><div \nng-if=\"team.remaining === \'0\'\">Completed</div></td><td><div ng-if=\"team.career_aspiration\">{{ team.career_aspiration }}\n</div><div ng-if=\"!team.career_aspiration\" align=\"center\">-</div></td><td align=\"center\"><div \nng-if=\"team.member_remaining > 0 \">{{ team.member_remaining }} employee</div><div \nng-if=\"team.member_remaining === \'0\'\" align=\"center\">Completed</div><div ng-if=\"team.member_remaining === \'-\'\" \nalign=\"center\">-</div></td><td align=\"center\"><div \nng-if=\"team.potential_remaining && team.potential_remaining !== \'0\'\">{{ team.potential_remaining }} remaining</div><div\n ng-if=\"team.potential_remaining === \'0\'\">Completed</div></td><td align=\"center\"><div \nng-if=\"team.remaining === \'0\' && (team.member_remaining === \'0\' || team.member_remaining === \'-\') && team.potential_remaining === \'0\'\">\n<md-icon class=\"green-700-fg\" md-font-icon=\"icon-check\"></md-icon></div><div \nng-if=\"team.remaining !== \'0\' || (team.member_remaining !== \'0\' && team.member_remaining !== \'-\') || team.potential_remaining !== \'0\'\">\n<md-icon class=\"red-100-fg\" md-font-icon=\"icon-check\"></md-icon></div></td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li class=\"{{nav.class}}\" \nng-class=\"{disabled:(nav.disabled===1)}\" ng-repeat=\"nav in vm.DataTable.listNav\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/dashboard/dashboard.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" style=\"height: 150px\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Welcome to HC-Portal System!</span></div>\n<div class=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \nhide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div>\n</div></div><md-content class=\"content md-background-bg\" style=\"background: rgb(245,245,245)\"></md-content></div></div>");
$templateCache.put("app/main/pms/ebook/ebook-view.html","<div id=\"page_talent\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Ebook</span></md-subheader><div class=\"white-bg\"><div class=\"content\"><div layout-xs=\"column\" \nlayout=\"row\"><div ng-if=\"vm.url\" flex-xs flex-gt-xs=\"100\" layout=\"column\"><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:80vh\" frameborder=\"0\"></iframe></div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/pms/ebook/ebook.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\n<span>Ebook</span></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\" style=\"background-color: #ffffff\"><div \nflex-xs flex-gt-xs=\"30\" layout=\"column\" ng-repeat=\"ebook in vm.ebookLists\"><md-card \nmd-theme=\"{{ showDarkTheme ? \'dark-orange\' : \'default\' }}\" md-theme-watch><md-card-content layout=\"row\"><div class=\"\">\n<img ng-src=\"assets/ebook/{{ebook.cover}}\" alt=\"\"></div></md-card-content><md-card-title class=\"has-title-card\">\n<md-card-title-text style=\"cursor: pointer\"><a ui-sref=\"app.pms_ebook_view({url: ebook.url})\"><span \nclass=\"title h3 ng-binding ng-scope\">{{ebook.title}}</span></a> <span class=\"title h3 ng-binding ng-scope\">\n{{ebook.subtitle}}</span></md-card-title-text></md-card-title><md-card-actions layout=\"row\" layout-align=\"end center\">\n<md-button ui-sref=\"app.pms_ebook_view({url: ebook.url})\" class=\"md-green-300-bg md-raised md-primary white-fg\">Read\n</md-button></md-card-actions></md-card></div></md-content></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/prorateparameter/input-prorateparameter.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"ProrateForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,ProrateForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAYROLL.MENU.PRORATEPARAMETERFORM\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select ng-model=\"vm.Form.objForm.companyname\" \nng-change=\"vm.changeStatus(vm.Form.objForm.companyname)\" ng-required=\"true\" name=\"companyname\"><md-option \nng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"ProrateForm.companyname.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COMPANY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODEBASE\"></span></label><md-select ng-model=\"vm.Form.objForm.payrollcodebase\" \nng-change=\"vm.changePayrollBase(vm.Form.objForm.payrollcodebase)\" ng-required=\"true\" name=\"payrollcodebase\"><md-option \nng-repeat=\"s in vm.listallperiod\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select><div \nng-messages=\"ProrateForm.payrollcodebase.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.PAYROLLCODEBASE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLBASEDESC\"></span></label>\n<input type=\"text\" name=\"payrollbasedesc\" ng-model=\"vm.Form.objForm.payrollbasedesc\" \nplaceholder=\"{{\'PAYROLL.MENU.PAYROLLBASEDESC\' | translate}}\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLCODEPOST\"></span></label><md-select \nng-model=\"vm.Form.objForm.payrollcodepost\" ng-change=\"vm.changePayrollPost(vm.Form.objForm.payrollcodepost)\" \nng-required=\"true\" name=\"payrollcodepost\"><md-option ng-repeat=\"s in vm.listsalcom\" value=\"{{s.id}}\">{{s.name}}\n</md-option></md-select><div ng-messages=\"ProrateForm.payrollcodepost.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"PAYROLL.MENU.PAYROLLCODEPOST\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PAYROLLPOSTDESC\"></span></label>\n<input type=\"text\" name=\"payrollpostdesc\" ng-model=\"vm.Form.objForm.payrollpostdesc\" \nplaceholder=\"{{\'PAYROLL.MENU.PAYROLLPOSTDESC\' | translate}}\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.TYPE\"></span></label><md-select \nng-model=\"vm.Form.objForm.type\" ng-change=\"vm.changeType(vm.Form.objForm.type)\" ng-required=\"true\" name=\"type\">\n<md-option ng-repeat=\"s in vm.listtype\" value=\"{{s}}\">{{s}}</md-option></md-select><div \nng-messages=\"ProrateForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PAYROLL.MENU.TYPE\">\n</span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.FIXDAY\"></span></label><input type=\"number\" name=\"fixdays\" id=\"fixdays\" \nng-model=\"vm.Form.objForm.fixdays\" ng-required=\"vm.Form.objForm.type == \'Fix Days\'\" \nplaceholder=\"{{\'PAYROLL.MENU.FIXDAY\' | translate}}\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"PAYROLL.MENU.AMOUNTTYPE\"></span></label><br><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.Form.objForm.amount_type\"><md-radio-button \nng-repeat=\"amount in vm.amountTypes\" ng-value=\"amount.value\">{{amount.label}}</md-radio-button></md-radio-group>\n</md-input-container></div><div layout-gt-sm=\"row\"></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"ProrateForm.$invalid || ProrateForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/prorateparameter/prorateparameter.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PRORATEPARAMETER\"></span></md-subheader><div class=\"white-bg\">\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.inputProrateParameter($event,ls)\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.NEW\"></span></md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon></md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.DeleteProrateParameter()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"PAYROLL.MENU.ENTRI\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.inputProrateParameter($event,ls)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span \ntranslate=\"PAYROLL.MENU.NEW\"></span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.NEW\"></span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" type=\"button\" hide \nshow-gt-sm aria-label=\"Delete\" ng-click=\"vm.DeleteProrateParameter()\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"PAYROLL.MENU.DELETE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"PAYROLL.MENU.DELETE\">\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th rowspan=\"3\" class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.COMPANY\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODEBASE\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLBASEDESC\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLCODEPOST\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.PAYROLLPOSTDESC\"></span></span></th><th class=\"text-center\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.TYPE\"></span></span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editProrateParameter($event,ls.id)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.lisProrateParameterSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">\n{{ls.companyname}}</td><td class=\"text-center\">{{ls.payrollcodebase}}</td><td class=\"text-center\">\n{{ls.payrollbasedesc}}</td><td class=\"text-center\">{{ls.payrollcodepost}}</td><td class=\"text-center\">\n{{ls.payrollpostdesc}}</td><td class=\"text-center\">{{ls.type}}</td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">\nNo Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/emp-job-code/emp-job-code.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.HEADER.TITLE\">Employee Job Code</span></md-subheader><div\n class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"MENU.PMS.EMP_JOB_CODE.INDEX.FILTER.BUSINESS_UNIT\">Business Unit</label><md-select \nng-disabled=\"vm.group === \'110\' || vm.group === \'116\'\" ng-change=\"vm.loadDataDivision(vm.bu)\" ng-model=\"vm.bu\">\n<md-option ng-value=\"\">All</md-option><md-option ng-repeat=\"bu in vm.listBu\" ng-value=\"bu.id\">{{bu.description}}\n</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"MENU.PMS.EMP_JOB_CODE.INDEX.FILTER.DIVISION\">Division</label><md-select \nng-change=\"vm.loadDataDepartment(vm.divisi)\" ng-model=\"vm.divisi\"><md-option ng-value=\"\">All</md-option><md-option \nng-repeat=\"divisi in vm.listDivisi\" ng-value=\"{{divisi.id}}\">{{divisi.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.FILTER.DEPARTMENT\">\nDepartment</label><md-select ng-change=\"vm.loadData(1)\" ng-model=\"vm.department\"><md-option ng-value=\"\">All</md-option>\n<md-option ng-repeat=\"department  in vm.listDepartment\" ng-value=\"{{department.id}}\">{{department.description}}\n</md-option></md-select></md-input-container><md-input-container flex><input id=\"formSearch\" \nng-model=\"vm.DataTable.searchParam\" placeholder=\"Search..\" type=\"text\"></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" \nng-click=\"vm.openUploadEmpJobCode($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Upload File\n</md-tooltip><span translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.ACTION.UPLOAD\">Upload File</span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th><div \nclass=\"table-header\"></div></th><th width=\"2%\" class=\"text-center\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.TABLE.NO\">No</span></div></th><th width=\"12%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.TABLE.NIK\">NIK</span></div></th>\n<th width=\"12%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"MENU.PMS.EMP_JOB_CODE.INDEX.TABLE.NIK_ATASAN\">NIK ATASAN</span></div></th><th class=\"text-left\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.TABLE.EMPLOYEE_NAME\">\nEmployee Name</span></div></th><th width=\"12%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"MENU.PMS.EMP_JOB_CODE.INDEX.TABLE.JOB_CODE\">Job Code</span></div></th><th width=\"12%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"MENU.PMS.EMP_JOB_CODE.INDEX.TABLE.EFFECTIVE_DATE\">\nEFFECTIVE DATE</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">#</span></div></th></tr>\n</thead><tbody><tr ng-dblclick=\"vm.editData(ls.id)\" ng-repeat=\"ls in vm.DataTable.list\"><td></td><td \nclass=\"text-center\">{{ $index + 1 }}</td><td class=\"text-center\">{{ ls.nik }}</td><td class=\"text-center\">\n{{ ls.nik_atasan }}</td><td>{{ ls.emp_name | uppercase }}</td><td class=\"text-center\">{{ ls.job_code | uppercase }}\n</td><td class=\"text-center\">{{ ls.effective_date }}</td><td class=\"text-center\"><md-button aria-label=\"Set Job Code\" \nclass=\"md-icon-button\" ng-click=\"vm.setJobCode($event, ls)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nclass=\"blue-500-fg\" md-font-icon=\"icon-table-edit\"></md-icon><md-tooltip><span \ntranslate=\"MENU.PMS.EMP_JOB_CODE.INDEX.ACTION.SET_JOB_CODE\">Set Job Code</span></md-tooltip></md-button></td></tr>\n</tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nclass=\"{{nav.class}}\" ng-class=\"{disabled:(nav.disabled===1)}\" ng-repeat=\"nav in vm.DataTable.listNav\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/emp-job-code/upload-emp-job-code.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload Employee Job Code</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div class=\"text-right\" flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pms/emp-apraisal/download.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Download data employe apraisal type</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.groupLogin!=11\" layout=\"column\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div\n ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\">\n<md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Start Range Join</label><md-datepicker md-hide-icons=\"calendar\" name=\"startrange\" \nng-model=\"vm.startrange\"></md-datepicker></md-input-container><md-input-container flex><label>End Range Join</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"endrange\" ng-model=\"vm.endrange\"></md-datepicker></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.status\" name=\"status\"><md-option ng-repeat=\"ls in vm.listStatus\" \nplaceholder=\"Status\" value=\"{{ls}}\">{{ls | uppercase}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>status field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.contract\" name=\"contract\">\n<md-option ng-repeat=\"ls in vm.typeContract\" placeholder=\"contract\" value=\"{{ls}}\">{{ls | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.employeeType\" name=\"employeeType\"><md-option ng-repeat=\"ls in vm.typeEmp\" placeholder=\"Employee Type\" \nvalue=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option></md-select><div ng-messages=\"frmEmploye.employeeType.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Employee field is required.</span></div></div></md-input-container></div>\n<div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.empApraisalType\" name=\"empApraisalType\"><md-option placeholder=\"Employee Type\" value=\"Yearly\">Yearly\n</md-option><md-option placeholder=\"Employee Apraisal Type\" value=\"Quarter\">Quarter</md-option></md-select><div \nng-messages=\"frmEmploye.empApraisalType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee Apraisal Type field is required.</span></div></div></md-input-container></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button type=\"button\" layout=\"row\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\" ng-click=\"vm.download()\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Download</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/emp-apraisal/edit.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-md=\"60\" flex-gt-md=\"60\"><form ng-cloack name=\"formJD\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formJD)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Edit Employe Apraisal</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nclass=\"md-block\" style=\"padding-bottom:20px\" ng-show=\"vm.notif.success || vm.notif.error\"><ms-widget flippable=\"false\" \nlayout=\"column\" layout-align=\"center start \" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget>\n</md-input-container><md-input-container flex><label>NIK</label><input type=\"text\" name=\"nik\" \nng-model=\"vm.Form.objForm.data.nik\" placeholder=\"NIK\" required ng-disabled=\"true\"><div \nng-messages=\"formJD.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div></div>\n</md-input-container><md-input-container flex><label>Name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.Form.objForm.data.firstName\" placeholder=\"Name\" required ng-disabled=\"true\"><div \nng-messages=\"formJD.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>name is required.</span></div></div>\n</md-input-container><md-input-container flex><label>Efective Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"efective_date\" ng-model=\"vm.Form.objForm.data.efective_date\" required ng-disabled=\"vm.approval == 1\">\n</md-datepicker><div ng-messages=\"formJD.efective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEfective Date is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"formJD.$invalid || formJD.$pristine\">Update</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pms/emp-apraisal/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Employement Apraisal</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" \nng-disabled=\"vm.divdeptdisabled\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container\n flex><label>Sub Area</label><md-select ng-model=\"vm.subarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"Subarea\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.employeeType\" name=\"employeeType\"><md-option \nng-repeat=\"ls in vm.typeEmp\" placeholder=\"Employee Type\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><md-switch \nng-model=\"vm.viewEcheckin\" ng-if=\"vm.eCheckin\" name=\"eCheckinview\" ng-change=\"vm.eCheckinchange()\" \naria-label=\"Switch 1\">eCheckin</md-switch></md-input-container><md-input-container class=\"text-right\" flex><md-button \ntype=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\">Submit</md-button></md-input-container>\n</div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><div ng-if=\"vm.eCheckin\" \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button ng-if=\"vm.upload\" \nclass=\"md-raised md-primary btn-ui-serif\" show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.exportToExcel()\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Export To Excel</md-tooltip>Export To Excel</md-button>\n<span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"text-center\">NO</th><th class=\"text-center\">EMP. NIK</th><th \nclass=\"text-center\">EMP. NAME</th><th class=\"text-center\">JOIN DATE</th><th class=\"text-center\">PERIODE KPI</th><th \nclass=\"text-center\">EFECTIVE DATE</th><th class=\"text-center\">Action</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.detailEmployee(ls.id,ls.eCheckin)\"><td class=\"text-center\">\n{{(ls.no)}}</td><td class=\"text-center\">{{ls.nik}}</td><td class=\"text-center\">\n{{ls.title}} {{ls.firstName}} {{ls.middle_name}} {{ls.lastName}}</td><td class=\"text-center\">{{ls.dateJoin}}</td><td \nclass=\"text-center\">{{ls.periode_kpi}}</td><td class=\"text-center\">{{ls.effective_date}}</td><td class=\"text-center\">\n<md-menu ng-if=\"ls.periode_kpi == \'Yearly\'\"><md-button class=\"md-icon-button action-selector\" \nng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button>\n<md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item><md-button ng-click=\"vm.setQuarter($event,ls)\" \naria-label=\"Set Quarter\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-check\"></md-icon>Set Quarter</md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/edp/edp.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati3\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-check\"></md-icon></span><span class=\"logo-text\"><span>\nEmployee Development Program</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div>\n</div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"></div></div></div><md-content \nclass=\"content md-background-bg\" style=\"background: rgb(245,245,245)\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"white-bg md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table id=\"kpiTableTeam\"><thead><tr><th \nwidth=\"1%\"></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DASHBOARD.TEAMMEMBER.TABLETEAMMEMBER.HEADER.NO\">No</span></div></th><th class=\"secondary-text\" width=\"40%\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"DASHBOARD.TEAMMEMBER.TABLETEAMMEMBER.HEADER.NAME\">\nNIK/NAME</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DASHBOARD.TEAMMEMBER.TABLETEAMMEMBER.HEADER.DATE_JOIN\">DATE JOIN</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DASHBOARD.TEAMMEMBER.TABLETEAMMEMBER.HEADER.VIEW\">VIEW</span></div></th></tr></thead><tbody><tr \nng-init=\"mainIdx=$index;vm.visibleSubChild[mainIdx]=false\" \nng-repeat-start=\"team in ::vm.DataTable.list track by $index\" class=\"light-gray\"><td><md-button \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.toogleSubChild(mainIdx)\" class=\"md-icon-button\" \naria-label=\"More\" ng-if=\"team.listAnak.length>0\"><md-icon ng-show=\"!vm.visibleSubChild[mainIdx]\" \nmd-font-icon=\"icon-plus\"></md-icon><md-icon ng-show=\"vm.visibleSubChild[mainIdx]\" md-font-icon=\"icon-minus\"></md-icon>\n</md-button></td><td align=\"center\">{{ (mainIdx + 1)}}</td><td>{{ team.nik}} - {{ team.name}}</td><td>\n{{ team.dateJoin}}</td><td><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setView(team.nik)\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>click for view</span></md-tooltip></md-button></td></tr><tr \nng-show=\"vm.visibleSubChild[mainIdx]\" ng-repeat=\"lstSubTeam in ::team.listAnak track by $index\" \nstyle=\"background: rgba(0,0,0,0.08)\"><td></td><td align=\"right\">{{ ($index + 1)}}</td><td \nstyle=\"padding-left:20px !important\">{{ lstSubTeam.nik}} - {{ lstSubTeam.name}}</td><td>{{ lstSubTeam.dateJoin}}</td>\n<td><md-button class=\"md-icon-button\" aria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.setViewD(lstSubTeam.nik)\"><md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip>\n<span>click for view</span></md-tooltip></md-button></td></tr><tr ng-repeat-end></tr></tbody></table></div>\n</ms-widget-front></ms-widget></div></md-content></div>");
$templateCache.put("app/main/pms/kpi/kpi.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\" translate=\"ACTION.YEAR\">YEARS</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year.year}}\" \nng-click=\"vm.showKpi(year.year)\"><span class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill><div\n class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\"><span \ntranslate=\"KPI.LABEL.KPIYEAR\"></span></md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-button class=\"md-mini md-raised md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.addKPI()\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"KPI.LABEL.SETNEWKPI\"></span></md-button><md-menu\n md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.addKPI()\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"KPI.LABEL.SETNEWKPI\"></span></md-button></md-menu-item></md-menu-content></md-menu><span flex hide \nshow-gt-sm></span><div class=\"alert-info warning italic md-body-1\" style=\"margin-bottom: 0px\"><span \ntranslate=\"KPI.LABEL.TOTALWEIGHTREMAINING\"></span> : {{vm.totalweight}} %</div></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th width=\"1%\" style=\"text-align: center\"><span translate=\"KPI.LABEL.NO\"></span></th><th\n width=\"30%\"><span translate=\"KPI.LABEL.KEYPERFORM\"></span></th><th width=\"7%\"><span translate=\"KPI.LABEL.UOM\"></span>\n</th><th width=\"7%\" style=\"text-align: center\"><span translate=\"KPI.LABEL.WEIGHT\"></span></th><th width=\"7%\" \nstyle=\"text-align: center\"><span translate=\"KPI.LABEL.TARGET\"></span></th><th width=\"7%\" style=\"text-align: center\">\n<span translate=\"KPI.LABEL.EFFECTIVEDATE\"></span></th><th width=\"7%\" style=\"text-align: center\"><span \ntranslate=\"KPI.LABEL.EXPIREDDATE\"></span></th><th width=\"7%\" style=\"text-align: center\"><span \ntranslate=\"KPI.LABEL.VALUETYPE\"></span></th><th width=\"7%\" style=\"text-align: center\"><span \ntranslate=\"KPI.LABEL.APPROVAL\"></span></th><th width=\"10%\" style=\"text-align: center\"><span \ntranslate=\"KPI.LABEL.ACTION\"></span></th></tr></thead><tbody><tr ng-repeat=\"kpi in vm.listKpi\" \nng-class=\"{\'deep-purple italic\':kpi.isExpired}\"><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">\n{{kpi.kpi}}</td><td class=\"text-center\">{{kpi.uom}}</td><td class=\"text-center\">{{kpi.weight}} %</td><td \nclass=\"text-center\">{{kpi.target}}</td><td class=\"text-center\">{{kpi.start_date}}</td><td class=\"text-center\">\n{{kpi.expired_date}}</td><td class=\"text-center\">{{kpi.value_type}}</td><td class=\"text-center\">{{kpi.approval}}</td>\n<td class=\"text-center\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"start center\" layout-wrap><md-button \nclass=\"md-icon-button\" aria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.editKPI($event, kpi)\"><md-icon md-font-icon=\"icon-table-edit\" class=\"blue-500-fg\"></md-icon><md-tooltip>\n<span>{{ \'KPI.LABEL.CLICKFOREDIT\' | translate }}</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.deleteKPI($event, kpi.id)\" \nng-if=\"kpi.approval == \'Submitted\'\"><md-icon md-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip><span>\n{{ \'KPI.LABEL.CLICKFORDELETE\' | translate }}</span></md-tooltip></md-button></section></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/kpi-nabati/kpi-nabati-result.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\" \nstyle=\"overflow-y: scroll\"><div class=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" \nlayout-align=\"space-between\"><div class=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\"><div class=\"selected-action\" translate=\"ACTION.YEAR\">YEARS</div><md-menu id=\"projects-menu\" \nmd-offset=\"0 48\"><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Select project\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button \naria-label=\"{{year.year}}\" ng-click=\"vm.showKpi(year.year)\"><span class=\"secondary-text\"><span><md-icon \nng-if=\"year.selected\" md-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}\n</span></span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><md-content \nclass=\"content padding\"><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\"><span \ntranslate=\"MENU.MAIN.KPIRESULT\"></span></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr class=\"md-primary-bg md-primary-fg\"><th><span translate=\"KPI.LABEL.NO\"></span></th><th><span \ntranslate=\"KPI.LABEL.KPIID\"></span></th><th width=\"10%\"><span translate=\"KPI.LABEL.KEYPERFORM\"></span></th><th><span \ntranslate=\"KPI.LABEL.UOM\"></span></th><th><span translate=\"KPI.LABEL.WEIGHT\"></span></th><th width=\"10%\"><span \ntranslate=\"KPI.LABEL.TARGET\"></span></th><th class=\"text-left\"><span translate=\"KPI.LABEL.RESULTDESCRIPTION\"></span>\n</th><th><span translate=\"KPI.LABEL.RESULTVALUE\"></span></th><th width=\"8%\"><span translate=\"KPI.LABEL.RESULTDATE\">\n</span></th></tr></thead><tbody><tr ng-repeat=\"kpi in vm.listKpi\"><td class=\"text-center\">{{($index + 1) }}</td><td \nclass=\"text-center\">{{ kpi.kpi_scale_id }}</td><td class=\"text-center\"><a href=\"\" \nng-click=\"vm.viewScales($event,kpi.kpi_scale_id)\" style=\"text-decoration:underline\">{{ kpi.kpi}}</a></td><td \nclass=\"text-center\">{{kpi.uom}}</td><td class=\"text-center\">{{kpi.weight}} %</td><td class=\"text-center\">{{kpi.target}}\n</td><td>{{kpi.result}}</td><td class=\"text-center\">{{kpi.kpiValue}}</td><td class=\"text-center\">{{kpi.resultDate}}\n</td></tr></tbody></table></md-content></div></div></md-content><md-content class=\"content padding\"><div \nclass=\"md-whiteframe-4dp white-bg rounded\"><md-toolbar><div class=\"md-toolbar-tools\" style=\"padding-left:0px\">\n<md-subheader class=\"md-primary\" flex><i class=\"material-icons-new\">check</i>PA RESULT</md-subheader><span flex></span>\n <span ng-if=\"vm.info != 1\" class=\"alert-info warning italic md-body-1\" style=\"margin-bottom: 0px\">{{ vm.info }}</span>\n</div></md-toolbar><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"8%\"><span \ntranslate=\"KPI.LABEL.NO\"></span></th><th><span translate=\"KPI.LABEL.PERIOD\"></span></th><th><span \ntranslate=\"KPI.LABEL.KPI\"></span></th><th><span translate=\"KPI.LABEL.PROCESS\"></span></th><th><span \ntranslate=\"KPI.LABEL.IP\"></span></th><th><span translate=\"KPI.LABEL.MUTU1\"></span></th><th></th></tr></thead><tbody><tr\n ng-repeat=\"kpi in vm.listPA\"><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{kpi.periode}}</td>\n<td class=\"text-center\">{{kpi.kpiValue}}%</td><td class=\"text-center\">{{kpi.behavior_performance}}%</td><td \nclass=\"text-center\">{{kpi.ip}}%</td><td class=\"text-center\">{{kpi.nilai_mutu1}}</td><td class=\"text-center\"><span \nng-if=\"kpi.paApproval==0\" class=\"green-500-fg\"><span translate=\"KPI.LABEL.APPROVED\"></span></span></td></tr></tbody>\n</table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/kpi-nabati/kpi-nabati.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.KPINABATIGROUP\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"frmEmploye\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div \nclass=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span translate=\"KPI.LABEL.FILTERDATA\"></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span \ntranslate=\"KPI.LABEL.BU\"></span></label><md-select \nng-disabled=\"vm.group === \'110\' || vm.group === \'116\' || vm.group === \'118\'\" ng-change=\"vm.loadDataDivision(vm.bu)\" \nng-model=\"vm.bu\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"bu in vm.listBu\" value=\"{{bu.id}}\">\n{{bu.description}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\">\n<label><span translate=\"KPI.LABEL.DIVISION\"></span></label><md-select ng-change=\"vm.loadDataDepartment(vm.divisi)\" \nng-model=\"vm.divisi\"><md-option value=\"\">All</md-option><md-option ng-repeat=\"divisi in vm.listDivisi\" \nvalue=\"{{divisi.id}}\">{{divisi.description}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"KPI.LABEL.DEPARTMENT\"></span></label><md-select \nng-change=\"vm.loadData(1)\" ng-model=\"vm.department\"><md-option value=\"\">All</md-option><md-option \nng-repeat=\"department  in vm.listDepartment\" value=\"{{department.id}}\">{{department.description}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span \ntranslate=\"ACTION.YEAR\"></span></label><md-select ng-change=\"vm.loadData(1)\" ng-model=\"vm.year\"><md-option \nng-repeat=\"year  in vm.years\" value=\"{{year.year}}\">{{year.year}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"KPI.LABEL.PERIOD\"></span></label><md-select \nng-change=\"vm.loadData(1)\" ng-model=\"vm.periode\"><md-option ng-repeat=\"periode  in vm.listPeriode\" \nvalue=\"{{periode.id}}\">{{periode.value}}</md-option></md-select></md-input-container></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span \ntranslate=\"KPI.LABEL.ENTRIES\"></span></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button ng-disabled=\"vm.bu === \'\' || vm.periode === \'\' || vm.DataTable.list.length == 0\" \nclass=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.ExporttoExcel()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"KPI.LABEL.EXPORTTOEXCEL\"></span></md-tooltip><span translate=\"KPI.LABEL.EXPORTTOEXCEL\"></span></md-button>\n<span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"secondary-text\" width=\"5%\" rowspan=\"2\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NO\"></span></span></div></th><th class=\"secondary-text\" width=\"10%\" rowspan=\"2\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NIK\"></span></span></div></th><th \nclass=\"secondary-text\" width=\"30%\" rowspan=\"2\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NAME\"></span></span></div></th><th class=\"secondary-text\" width=\"30%\" rowspan=\"2\"><div \nclass=\"table-header\"><span class=\"column-title\">N+1 <span translate=\"KPI.LABEL.NAME\"></span></span></div></th><th \nclass=\"secondary-text\" colspan=\"8\" style=\"text-align: center\"><div class=\"table-header\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.KPI\"></span></span></div></th><th class=\"secondary-text\" colspan=\"4\" \nstyle=\"text-align: center\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.TSTE\">\n</span></span></div></th><th class=\"secondary-text\" rowspan=\"2\" style=\"text-align: center\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.PACOMPLETION\"></span></span></div></th><th \nclass=\"secondary-text\" rowspan=\"2\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.VIEW\"></span></span></div></th></tr><tr><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.YTD\"></span></span></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.ACTIVE\"></span></span></div></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.TSCOMPLETION\"></span></span></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.WEIGHT\"></span></span></div></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.UNAPPROVED\"></span></span></div></th><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.APPROVED\"></span></span>\n</div></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.RESULTSUBMITTED\"></span></span></div></th><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.STATUS\"></span></span></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.EMPSUBMITTED\"></span></span></div></th><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\">N+1 <span translate=\"KPI.LABEL.SUBMITTED\"></span></span></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.APPROVED\"></span></span></div></th><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.STATUS\"></span></span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"team in vm.DataTable.list\"><td align=\"center\">{{ ($index + 1)}}</td><td align=\"center\">\n{{ team.nik}}</td><td>{{ team.name}}</td><td>{{ team.atasan}}</td><td align=\"center\">{{team.jumAll}}</td><td \nalign=\"center\">{{team.jumKPIActive}}</td><td align=\"center\">{{team.jumTs}}</td><td align=\"center\">{{team.totalWeight}}\n</td><td align=\"center\">{{team.totalUnapproved}}</td><td align=\"center\">{{team.totalApproved}}</td><td align=\"center\">\n{{team.jumResult}}</td><td align=\"center\">{{team.kpiStatus}}</td><td align=\"center\"><div ng-if=\"team.tsteEmp==\'1\'\">\n<md-icon class=\"green-500-fg\" md-font-icon=\"icon-check\"></md-icon></div><div ng-if=\"team.tsteEmp!=\'1\'\"><md-icon \nclass=\"red-500-fg\" md-font-icon=\"icon-close\"></md-icon></div></td><td align=\"center\"><div ng-if=\"team.tsteN==\'1\'\">\n<md-icon class=\"green-500-fg\" md-font-icon=\"icon-check\"></md-icon></div><div ng-if=\"team.tsteN!=\'1\'\"><md-icon \nclass=\"red-500-fg\" md-font-icon=\"icon-close\"></md-icon></div></td><td align=\"center\"><div \nng-if=\"team.tsteApproval==\'1\'\"><md-icon class=\"green-500-fg\" md-font-icon=\"icon-check\"></md-icon></div><div \nng-if=\"team.tsteApproval!=\'1\'\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-close\"></md-icon></div></td><td \nalign=\"center\">{{team.tsteStatus}}</td><td align=\"center\"><div ng-if=\"team.paStatus==\'1\'\"><md-icon \nclass=\"green-500-fg\" md-font-icon=\"icon-check\"></md-icon></div><div ng-if=\"team.paStatus!=\'1\'\"><md-icon \nclass=\"red-500-fg\" md-font-icon=\"icon-close\"></md-icon></div></td><td align=\"center\"><md-button aria-label=\"Settings\" \nclass=\"md-icon-button\" ng-click=\"vm.setView(team.nik)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nclass=\"blue-500-fg\" md-font-icon=\"icon-eye\"></md-icon><md-tooltip><span><span translate=\"KPI.LABEL.CLICKFORVIEW\">\n</span></span></md-tooltip></md-button></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li class=\"{{nav.class}}\" ng-class=\"{disabled:(nav.disabled===1)}\" \nng-repeat=\"nav in vm.DataTable.listNav\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/kpi-result/kpi-result.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\" \nstyle=\"overflow-y: scroll\"><div class=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" \nlayout-align=\"space-between\"><div class=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\"><div class=\"selected-action\" translate=\"ACTION.YEAR\">YEARS</div><md-menu id=\"projects-menu\" \nmd-offset=\"0 48\"><md-button class=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Select project\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button \naria-label=\"{{year.year}}\" ng-click=\"vm.showKpi(year.year)\"><span class=\"secondary-text\"><span><md-icon \nng-if=\"year.selected\" md-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}\n</span></span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><md-content \nclass=\"content padding\"><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\"><span \ntranslate=\"MENU.MAIN.KPIRESULT\"></span></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr class=\"md-primary-bg md-primary-fg\"><th><span translate=\"KPI.LABEL.NO\"></span></th><th><span \ntranslate=\"KPI.LABEL.KPIID\"></span></th><th width=\"10%\"><span translate=\"KPI.LABEL.KEYPERFORM\"></span></th><th><span \ntranslate=\"KPI.LABEL.UOM\"></span></th><th><span translate=\"KPI.LABEL.WEIGHT\"></span></th><th width=\"10%\"><span \ntranslate=\"KPI.LABEL.TARGET\"></span></th><th class=\"text-left\"><span translate=\"KPI.LABEL.RESULTDESCRIPTION\"></span>\n</th><th><span translate=\"KPI.LABEL.RESULTVALUE\"></span></th><th width=\"8%\"><span translate=\"KPI.LABEL.RESULTDATE\">\n</span></th><th><span translate=\"KPI.LABEL.ACTION\"></span></th></tr></thead><tbody><tr ng-repeat=\"kpi in vm.listKpi\">\n<td class=\"text-center\">{{($index + 1) }}</td><td class=\"text-center\">{{ kpi.kpi_scale_id }}</td><td \nclass=\"text-center\">{{kpi.kpi}}</td><td class=\"text-center\">{{kpi.uom}}</td><td class=\"text-center\">{{kpi.weight}} %\n</td><td class=\"text-center\">{{kpi.target}}</td><td>{{kpi.result}}</td><td class=\"text-center\">{{kpi.kpiValue}}</td><td\n class=\"text-center\">{{kpi.resultDate}}</td><td width=\"8%\"><section layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" layout-wrap><md-button class=\"md-icon-button\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.addResult($event, kpi)\" ng-if=\"!kpi.isExpired\"><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span><span translate=\"KPI.LABEL.CLICKFORADD\"></span></span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.editKpiResult($event, kpi)\"><md-icon md-font-icon=\"icon-table-edit\" class=\"blue-500-fg\"></md-icon>\n<md-tooltip><span><span translate=\"KPI.LABEL.CLICKFOREDIT\"></span></span></md-tooltip></md-button></section></td></tr>\n</tbody></table></md-content></div></div></md-content><md-content class=\"content padding\"><div \nclass=\"md-whiteframe-4dp white-bg rounded\"><md-toolbar><div class=\"md-toolbar-tools\" style=\"padding-left:0px\">\n<md-subheader class=\"md-primary\" flex><i class=\"material-icons-new\">check</i>PA RESULT</md-subheader><span flex></span>\n <span ng-if=\"vm.info != 1\" class=\"alert-info warning italic md-body-1\" style=\"margin-bottom: 0px\">{{ vm.info }}</span>\n</div></md-toolbar><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"8%\"><span \ntranslate=\"KPI.LABEL.NO\"></span></th><th><span translate=\"KPI.LABEL.PERIOD\"></span></th><th><span \ntranslate=\"KPI.LABEL.KPI\"></span></th><th><span translate=\"KPI.LABEL.PROCESS\"></span></th><th><span \ntranslate=\"KPI.LABEL.IP\"></span></th><th><span translate=\"KPI.LABEL.MUTU1\"></span></th><th></th></tr></thead><tbody><tr\n ng-repeat=\"kpi in vm.listPA\"><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{kpi.periode}}</td>\n<td class=\"text-center\">{{kpi.kpiValue}}%</td><td class=\"text-center\">{{kpi.behavior_performance}}%</td><td \nclass=\"text-center\">{{kpi.ip}}%</td><td class=\"text-center\">{{kpi.nilai_mutu1}}</td><td class=\"text-center\"><span \nng-if=\"kpi.paApproval==0\" class=\"green-500-fg\"><span translate=\"KPI.LABEL.APPROVED\"></span></span></td></tr></tbody>\n</table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/kpi-scales/kpi-scales.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg hue-3\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">KPI Scales</span></div><div class=\"title\">KPI Scales</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised reference-button md-accent md-hue-3\" \nui-sref=\"app.pms_kpi_scales_input\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Add KPI Scales</span>\n</md-button><md-button class=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.deleteKS($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete KPI Scales</span></md-button></div></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><md-content class=\"md-cyan-100-bg\" layout=\"column\" layout-padding><div\n flex layout=\"column\"><h3><md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Area</h3></div><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex-gt-sm><label>Effective Date</label><md-select ng-model=\"vm.eff\" \nng-change=\"vm.loadData(1)\"><md-option value=\"all\">All</md-option><md-option ng-repeat=\"eff in vm.listEff\" \nvalue=\"{{eff.effectiveDate}}\">{{eff.effectiveDate}}</md-option></md-select></md-input-container></div></md-content>\n<table class=\"simple\" ms-responsive-table style=\"margin-top:0\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">No</span></div>\n</th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">KPI</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">BOBOT</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">TARGET</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">EFFECTIVE DATE</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"ks in vm.DataTable.list\" ng-dblclick=\"vm.editData(ks.id)\" style=\"hover\"><td><input \ntype=\"checkbox\" checklist-model=\"vm.listKSSelected\" checklist-value=\"ks\"></td><td>{{ ($index + 1)}}</td><td>{{ ks.id}}\n</td><td>{{ ks.kpi}}</td><td>{{ ks.bobot}}</td><td>{{ ks.target}}</td><td>{{ ks.effectiveDate}}</td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/pms/emp-potential/emp-potential.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Approval Potential</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" style=\"width: 200px\"><label>Period</label><md-select ng-change=\"vm.loadData(1)\" \nng-model=\"vm.period\"><md-option ng-repeat=\"period in vm.periodLists\" ng-value=\"period\">{{period}}</md-option>\n</md-select></md-input-container></div></form></div></div></md-content><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nwidth=\"1%\"></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">No</span>\n</div></th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">NIK/NAME</span></div></th><th \nclass=\"secondary-text\" width=\"20%\"><div class=\"table-header\"><span class=\"column-title\">DATE JOIN</span></div></th><th \nclass=\"secondary-text\" width=\"20%\"><div class=\"table-header\"><span class=\"column-title\">SUMARY</span></div></th><th \nclass=\"text-center\" width=\"8%\"><div class=\"table-header\"><span class=\"column-title\">VIEW</span></div></th></tr></thead>\n<tbody><tr ng-init=\"mainIdx=$index;vm.visibleSubChild[mainIdx]=false\" \nng-repeat-start=\"team in ::vm.DataTable.list track by $index\" class=\"light-gray\"><td><md-button \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.toogleSubChild(mainIdx)\" class=\"md-icon-button\" \naria-label=\"More\"><md-icon ng-show=\"!vm.visibleSubChild[mainIdx]\" md-font-icon=\"icon-plus\"></md-icon><md-icon \nng-show=\"vm.visibleSubChild[mainIdx]\" md-font-icon=\"icon-minus\"></md-icon></md-button></td><td align=\"center\">\n{{ (mainIdx + 1)}}</td><td>{{ team.nik}} - {{ team.name}}</td><td class=\"text-center\">{{ team.dateJoin}}</td><td \nclass=\"text-center\">\n{{(team.potential_score.engagement > 0 || team.potential_score.aspiration > 0 || team.potential_score.ability > 0)?team.potential_score.summary:\'\'}}\n</td><td class=\"text-center\"><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setView(team.nik)\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>click for view</span></md-tooltip></md-button></td></tr><tr \nng-show=\"vm.visibleSubChild[mainIdx]\" ng-repeat=\"lstSubTeam in ::team.listAnak track by $index\" \nstyle=\"background: rgba(0,0,0,0.08)\"><td></td><td align=\"right\">{{ ($index + 1)}}</td><td \nstyle=\"padding-left:20px !important\">{{ lstSubTeam.nik}} - {{ lstSubTeam.name}}</td><td>{{ lstSubTeam.dateJoin}}</td>\n<td></td><td class=\"text-center\"><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: auto\" ng-click=\"vm.setViewD(lstSubTeam.nik)\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>click for view</span></md-tooltip></md-button></td></tr><tr \nng-repeat-end></tr></tbody></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/idp/idp.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">Periode</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg csm-dropdown\"><md-button aria-label=\"{{period.effectiveDate}}\" \nng-click=\"vm.showBehivor(period.effectiveDate)\"><span class=\"secondary-text\"><span><md-icon md-font-icon=\"icon-check\" \nng-if=\"period.effectiveDate == vm.currentDate\"></md-icon><md-icon ng-if=\"!period.effectiveDate\"></md-icon>\n{{period.effectiveDate}}</span></span></md-button></md-menu-content></md-menu></div></div></div></div><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.LEAVE_UPLOAD.INDEX.HEADER.TITLE\">Individual Development Program</span>\n</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table id=\"tableTeam\" class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"1%\"></th>\n<th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DASHBOARD.TEAMMEMBER.TABLETEAMMEMBER.HEADER.NO\">No</span></div></th><th class=\"secondary-text\" width=\"40%\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"DASHBOARD.TEAMMEMBER.TABLETEAMMEMBER.HEADER.NAME\">\nNIK/NAME</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DASHBOARD.TEAMMEMBER.TABLETEAMMEMBER.HEADER.DATE_JOIN\">DATE JOIN</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DASHBOARD.TEAMMEMBER.TABLETEAMMEMBER.HEADER.VIEW\">VIEW</span></div></th></tr></thead><tbody><tr \nclass=\"light-gray\" ng-init=\"mainIdx=$index;vm.visibleSubChild[mainIdx]=false\" \nng-repeat-start=\"team in ::vm.DataTable.list track by $index\"><td class=\"text-center\"><md-button aria-label=\"More\" \nclass=\"md-icon-button\" ng-click=\"vm.toogleSubChild(mainIdx)\" ng-if=\"team.listAnak.length>0\" \nstyle=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-plus\" ng-show=\"!vm.visibleSubChild[mainIdx]\">\n</md-icon><md-icon md-font-icon=\"icon-minus\" ng-show=\"vm.visibleSubChild[mainIdx]\"></md-icon></md-button></td><td \nclass=\"text-center\">{{ (mainIdx + 1)}}</td><td class=\"text-center\">{{ team.nik}} - {{ team.name}}</td><td \nclass=\"text-center\">{{ team.dateJoin}}</td><td class=\"text-center\"><md-button aria-label=\"Settings\" \nclass=\"md-icon-button\" ng-click=\"vm.setView(team.nik)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nclass=\"blue-500-fg\" md-font-icon=\"icon-eye\"></md-icon><md-tooltip><span>Click for view</span></md-tooltip></md-button>\n</td></tr><tr ng-repeat=\"lstSubTeam in ::team.listAnak track by $index\" ng-show=\"vm.visibleSubChild[mainIdx]\" \nstyle=\"background: rgba(0,0,0,0.08)\"><td class=\"text-center\"></td><td class=\"text-center\">{{ ($index + 1)}}</td><td \nclass=\"text-center\" style=\"padding-left:20px !important\">{{ lstSubTeam.nik}} - {{ lstSubTeam.name}}</td><td \nclass=\"text-center\">{{ lstSubTeam.dateJoin}}</td><td class=\"text-center\"><md-button aria-label=\"Settings\" \nclass=\"md-icon-button\" ng-click=\"vm.setViewD(lstSubTeam.nik)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nclass=\"blue-500-fg\" md-font-icon=\"icon-eye\"></md-icon><md-tooltip><span>Click for view</span></md-tooltip></md-button>\n</td></tr><tr ng-repeat-end=\"\"></tr></tbody></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/kpi-team/kpi-team.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.KPITEAM\"></span></md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table style=\"width: 50%\"><thead><tr><th width=\"1%\"></th><th class=\"secondary-text\" width=\"3%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></div></th><th \nclass=\"secondary-text\" width=\"35%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NIKNAME\"></span></span></div></th><th class=\"secondary-text\" width=\"8%\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.JOINDATE\"></span></span></div></th><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.VIEW\"></span></span></div>\n</th></tr></thead><tbody><tr ng-init=\"mainIdx=$index;vm.visibleSubChild[mainIdx]=false\" \nng-repeat-start=\"team in ::vm.DataTable.list track by $index\" class=\"light-gray\"><td><md-button \nng-click=\"vm.toogleSubChild(mainIdx)\" class=\"md-icon-button\" aria-label=\"More\" ng-if=\"team.listAnak.length>0\"><md-icon \nng-show=\"!vm.visibleSubChild[mainIdx]\" md-font-icon=\"icon-menu-right\" class=\"blue-500-fg\" style=\"font-size:24px\">\n</md-icon><md-icon ng-show=\"vm.visibleSubChild[mainIdx]\" md-font-icon=\"icon-menu-down\" class=\"red-500-fg\"></md-icon>\n</md-button></td><td align=\"center\">{{ (mainIdx + 1)}}</td><td>{{ team.nik}} - {{ team.name}}</td><td>\n{{ team.dateJoin}}</td><td style=\"text-align: center !important\"><md-button class=\"md-icon-button\" \naria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setView(team.nik)\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span translate=\"KPI.LABEL.CLICKFORVIEW\"></span>\n</md-tooltip></md-button></td></tr><tr ng-show=\"vm.visibleSubChild[mainIdx]\" \nng-repeat=\"lstSubTeam in ::team.listAnak track by $index\" style=\"background: rgba(0,0,0,0.08)\"><td></td><td \nalign=\"right\">{{ ($index + 1)}}</td><td style=\"padding-left:20px !important\">{{ lstSubTeam.nik}} - {{ lstSubTeam.name}}\n</td><td>{{ lstSubTeam.dateJoin}}</td><td style=\"text-align: center !important\"><md-button class=\"md-icon-button\" \naria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.setViewD(lstSubTeam.nik)\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span translate=\"KPI.LABEL.CLICKFORVIEW\"></span>\n</md-tooltip></md-button></td></tr><tr ng-repeat-end></tr></tbody></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/job-code-profile/job-code-profile.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">Menu</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg csm-dropdown\"><md-button ng-click=\"vm.openUploadProfile($event)\">Upload File</md-button>\n<md-button ui-sref=\"app.pms_job_code_profile_input\"><span translate=\"MENU.PMS.JOB_CODE_PROFILE.INDEX.ACTION.ADD\">\nAdd Proficiency Level</span></md-button><md-button ng-click=\"vm.deleteModul($event)\"><span \ntranslate=\"MENU.PMS.JOB_CODE_PROFILE.INDEX.ACTION.DELETE\">Delete Proficiency Level</span></md-button></md-menu-content>\n</md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill><div \nclass=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\"><span \ntranslate=\"MENU.PMS.JOB_CODE_PROFILE.INDEX.HEADER.TITLE\">Job Code Profile</span></md-subheader><div class=\"white-bg\">\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\">\n<span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th width=\"5%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"MENU.PMS.JOB_CODE_PROFILE.INDEX.TABLE.NO\">No</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"MENU.PMS.JOB_CODE_PROFILE.INDEX.TABLE.JOB_CODE\">Job Code</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"MENU.PMS.JOB_CODE_PROFILE.INDEX.TABLE.COMPETENCY_CODE\">\nCompetency Code</span></div></th><th><div class=\"table-header text-left\"><span class=\"column-title\" \ntranslate=\"MENU.PMS.JOB_CODE_PROFILE.INDEX.TABLE.COMPETENCY\">Competency</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\" translate=\"MENU.PMS.JOB_CODE_PROFILE.INDEX.TABLE.REQ_LEVEL\">Req. Level</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls.id)\"><td><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.modulesAction(ls.id)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span \ntranslate=\"MENU.PMS.JOB_CODE_PROFILE.INDEX.ACTION.VIEW_ACTION\">View Action</span></p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></td><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listModulSelected\" \nchecklist-value=\"ls\"></td><td class=\"text-center\">{{ ls.no }}</td><td class=\"text-center\">{{ ls.job_code | uppercase }}\n</td><td class=\"text-center\">{{ ls.competency_code | uppercase }}</td><td>{{ ls.competency_name | uppercase }}</td><td \nclass=\"text-center\">{{ ls.req_level | uppercase }}</td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/job-code-profile/upload-job-code-profile.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>\nUpload Job Code Profile (Matrix)</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" \nnv-file-select uploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pms/master-kpi/master-kpi.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span><span translate=\"MENU.MAIN.MASTERKPI\"></span></span></md-subheader><div class=\"white-bg\">\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"><select style=\"font-size:14px\" hide show-gt-sm name=\"see\" \nid=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\">\n</select><span hide show-gt-sm style=\"font-size:14px\" class=\"secondary-text\">&nbsp;<span \ntranslate=\"PAYROLL.MENU.ENTRI\"></span></span><div class=\"divider-vertical\" hide show-gt-sm></div><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\"><span \ntranslate=\"ACTION.ACTION\">Action</span><md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span></span>\n</md-tooltip></md-button><md-menu-content width=\"3\" class=\"mat-blue-grey-100-bg\"><md-menu-item><md-button \nclass=\"md-raised reference-button\" ui-sref=\"app.pms_masterkpi_input\"><md-icon md-font-icon=\"icon-check\"></md-icon><span\n translate=\"KPI.LABEL.INPUT\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-raised reference-button\" ng-click=\"vm.Reject($event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<span translate=\"KPI.LABEL.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.pms_masterkpi_input\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span></span>\n</md-tooltip><md-icon md-font-icon=\"icon-border-color\"></md-icon><span translate=\"KPI.LABEL.INPUT\"></span></md-button>\n<div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" type=\"button\" ng-click=\"vm.Reject($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.REJECT\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span translate=\"KPI.LABEL.DELETE\"></span></md-button><span flex \nhide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\" ms-responsive-table><thead><tr><th><span class=\"is-gear\"><md-icon \nmd-font-icon=\"icon-cog\" \\></md-icon></span></th><th class=\"text-center\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\">\n</span></span></div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\"><span\n translate=\"KPI.LABEL.ID\"></span></span></div></th><th class=\"secondary-text\" width=\"30%\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.KPI\"></span></span></div></th><th class=\"text-left\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.DESCRIPTION\"></span></span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"kpi in ::vm.listKpi\"><td class=\"text-center\"><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.setScales($event,kpi)\"><div layout=\"row\" flex><md-icon\n md-menu-align-target md-font-icon=\"icon-poll\"></md-icon><p flex><span translate=\"KPI.LABEL.SETSCALE\"></span></p></div>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.viewKpiScales($event,kpi)\"><div layout=\"row\" flex>\n<md-icon md-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex><span translate=\"KPI.LABEL.VIEWSCALE\"></span>\n</p></div></md-button></md-menu-item></md-menu-content></md-menu></td><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listKpiSelected\" checklist-value=\"kpi\"></td><td class=\"text-center\">{{ ($index + 1)}}</td><td \nclass=\"text-center\">#{{ kpi.id}}</td><td class=\"text-center\">{{ kpi.kpi }}</td><td>{{ kpi.description}}</td></tr>\n</tbody></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/password/password.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div id=\"login\" \nclass=\"flex-scrollable is-login-form\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp white-bg\"><div class=\"logo\"><span><img \nsrc=\"assets/images/logos/nabati_green_bunga.png\" alt=\"\"></span></div><div class=\"title\">Set Password</div><b>\n{{vm.username}}</b><form name=\"loginForm\" novalidate ng-submit=\"vm.saveDataPass($event,loginForm)\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.Form.objForm.password\" \nplaceholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"confirm_password\" \nng-model=\"vm.Form.objForm.confirm_password\" placeholder=\"Confirm Password\" required \ncompare-to=\"vm.Form.objForm.password\"><div ng-messages=\"loginForm.confirm_password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Confirm Password field is required</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-primary btn-ui-serif submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\">LOG IN</md-button></form></div></div></div></div>");
$templateCache.put("app/main/pms/papeople/papeople.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\" translate=\"ACTION.YEAR\">YEARS</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year.year}}\" \nng-click=\"vm.showKpi(year.year)\"><span class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill><div\n class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\"><span \ntranslate=\"MENU.MAIN.PERFORMANCERATING\"></span></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th><span translate=\"KPI.LABEL.NO\"></span></th><th><span translate=\"KPI.LABEL.PERIOD\"></span></th><th><span \ntranslate=\"KPI.LABEL.KPI\"></span></th><th><span translate=\"KPI.LABEL.PROCESS\"></span></th><th><span \ntranslate=\"KPI.LABEL.IP\"></span></th><th><span translate=\"KPI.LABEL.MUTU1\"></span></th><th></th></tr></thead><tbody><tr\n ng-repeat=\"kpi in vm.listPA\"><td style=\"text-align: center\">{{($index + 1)}}</td><td style=\"text-align: center\">\n{{kpi.periode}}</td><td style=\"text-align: center\">{{kpi.kpiValue}}</td><td style=\"text-align: center\">\n{{kpi.behavior_performance}}</td><td style=\"text-align: center\">{{kpi.ip}}</td><td style=\"text-align: center\">\n{{kpi.nilai_mutu1}}</td><td style=\"text-align: center\"><span ng-if=\"kpi.paApproval==0\" class=\"green-500-fg\">Approved\n</span></td></tr></tbody></table><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.tampilPesan\" class=\"fade\"><ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front red-fg\"><p\n class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.pesan | translate}}</p>\n</ms-widget-front></ms-widget></md-content></div></div></md-content></div><style type=\"text/css\">\n.has-selected .selected-action {\n    padding: 8px 0;\n    height: 40px;\n    line-height: 24px;\n    font-size: 16px;\n  }\n\n  .header.nabati5.csm-header {\n    min-height: auto !important;\n  }\n</style>");
$templateCache.put("app/main/pms/permissionpms/permissionpms.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Permissions</md-subheader><div class=\"white-bg\"><div class=\"content\"><md-list ng-cloak><div \nng-repeat-start=\"ls in vm.listModul\"><div layout=\"column\" ng-if=\"ls.submenu.length > 0\" ng-repeat=\"sub in ls.submenu\">\n<md-subheader class=\"md-no-sticky md-success\"><md-list-item class=\"md-primary\"><p>{{sub.menu_name | uppercase}}</p>\n</md-list-item><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"start left\" layout-wrap>\n<md-list-item ng-repeat=\"act in sub.action\" flex=\"44\" class=\"p-16\"><p>{{act.action_label}}</p><md-switch \nclass=\"md-secondary\" ng-change=\"vm.changeaction(act,ls.groupID)\" ng-model=\"act.checked\"></md-switch></md-list-item>\n</div></md-subheader><md-divider></md-divider></div></div><div ng-repeat-end></div></md-list></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/pms/talent-review/talent-review.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Talent Review</md-subheader><div class=\"white-bg\"><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nui-sref=\"app.pms_talent_review_9box\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span>View 9-Box Table</span>\n</md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" \naria-label=\"set bu kpi\" ng-click=\"vm.ExportAllEmployeetoExcel()\"><i class=\"icon-download\"></i> <span>Download</span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-button\n class=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ui-sref=\"app.pms_talent_review_9box\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon \nmd-font-icon=\"icon-magnify\" class=\"md-font icon-archive material-icons\"></md-icon><span>View 9-Box Table</span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-500-bg md-raised md-primary btn-ui-serif\" hide show-gt-sm aria-label=\"Inert\" \nng-click=\"vm.ExportAllEmployeetoExcel()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nDownload All Employee</span></md-tooltip><md-icon md-font-icon=\"icon-download\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Download</span></md-button></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\">NO</span></th><th \nclass=\"text-center\" colspan=\"14\" layout-align=\"center\"><span class=\"column-title\">PERSONAL DATA</span></th><th \nclass=\"text-center\" colspan=\"2\" layout-align=\"center\"><span class=\"column-title\">PERFORMANCE</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\">POTENTIAL PROFILE</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\">TYPE OF TALENT</span></th><th class=\"text-center\" colspan=\"3\"><span \nclass=\"column-title\">COMPETENCY REVIEW</span></th><th class=\"text-center\" colspan=\"3\"><span class=\"column-title\">\nDEVELOPMENT</span></th><th class=\"text-center\" colspan=\"3\"><span class=\"column-title\">SUCCESSION</span></th><th \nclass=\"text-center\" colspan=\"2\"><span class=\"column-title\">RETENTION</span></th><th class=\"text-center\" rowspan=\"2\">\n<span class=\"column-title\">REMARKS</span></th></tr><tr><th class=\"text-center\"><span class=\"column-title\">ENTITY</span>\n</th><th class=\"text-center\"><span class=\"column-title\">EMPLOYEE NAME</span></th><th class=\"text-center\"><span \nclass=\"column-title\">PHOTO</span></th><th class=\"text-center\"><span class=\"column-title\">GENDER</span></th><th \nclass=\"text-center\"><span class=\"column-title\">BIRTHDATE</span></th><th class=\"text-center\"><span class=\"column-title\">\nAGE</span></th><th class=\"text-center\"><span class=\"column-title\">NATIONALITY</span></th><th class=\"text-center\"><span \nclass=\"column-title\">YEARS IN COMPANY</span></th><th class=\"text-center\"><span class=\"column-title\">\nSENIORTY IN POSITION</span></th><th class=\"text-center\"><span class=\"column-title\">LEVEL OF EDUCATION</span></th><th \nclass=\"text-center\"><span class=\"column-title\">CURRENT POSITION</span></th><th class=\"text-center\"><span \nclass=\"column-title\">ACTING STATUS</span></th><th class=\"text-center\"><span class=\"column-title\">DEPARTMENT</span></th>\n<th class=\"text-center\"><span class=\"column-title\">JOB FUNCTION</span></th><th class=\"text-center\"><span \nclass=\"column-title\">PA 2015</span></th><th class=\"text-center\"><span class=\"column-title\">PA 2016</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Strengths<br>Competencies and Values</span></th><th class=\"text-center\">\n<span class=\"column-title\">Areas for Improvement<br>Competencies and Values</span></th><th class=\"text-center\"><span \nclass=\"column-title\">MEET REQUIREMENT<br>(%)</span></th><th class=\"text-center\"><span class=\"column-title\">\nProjection for future roles<br>Role / Readiness</span></th><th class=\"text-center\"><span class=\"column-title\">\nDevelopment actions done<br>from beg. 2016 till now<br>(ie. training, on the job, …)</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Development plan for<br>next 12-18 months<br>\n(ie. training, on the job, …)</span></th><th class=\"text-center\"><span class=\"column-title\">Ready Now<br>\n(Ready within 1 year)</span></th><th class=\"text-center\"><span class=\"column-title\">Potential<br>(Ready in 1-2 years)\n</span></th><th class=\"text-center\"><span class=\"column-title\">Other Possible<br>(Ready =>3 years)</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Attrition Risk<br>Low / Medium / High</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Retention<br>Action(s)</span></th></tr></thead><tbody \nng-if=\"!vm.listTalentReview\"><tr><td colspan=\"27\">No record found</td></tr></tbody><tbody><tr \nng-dblclick=\"vm.setTalentReviewMember($event, ls)\" ng-repeat=\"ls in vm.listTalentReview\" \nstyle=\"cursor: pointer; {{(ls.type_of_talent === \'1A\' || ls.type_of_talent === \'2A\' || ls.type_of_talent === \'1B\')?\'background-color: #CEFED4\':\'\';}} {{(ls.type_of_talent === \'3C\')?\'background-color: #FEE4D1;\':\'\';}}\">\n<td class=\"text-center\">{{$index + 1}}</td><td class=\"text-center\"><span>{{ls.entity}}</span></td><td \nstyle=\"white-space: nowrap\"><span>{{ls.nik + \' / \' + ls.name}}</span></td><td class=\"text-center\"><span></span></td><td\n class=\"text-center\"><span>{{ls.gender}}</span></td><td class=\"text-center\"><span>{{ls.date_of_birth}}</span></td><td \nclass=\"text-center\"><span>{{ls.age}}</span></td><td class=\"text-center\"><span>{{ls.nationality}}</span></td><td \nclass=\"text-center\"><span>{{ls.yeas_in_company}}</span></td><td class=\"text-center\"><span></span></td><td \nclass=\"text-center\"><span>{{ls.level_of_edu}}</span></td><td class=\"text-center\"><span>{{ls.current_position}}</span>\n</td><td class=\"text-center\"><span></span></td><td class=\"text-center\"><span>{{ls.department}}</span></td><td \nclass=\"text-center\"><span>{{ls.job_code.substring(0, 1)}}</span></td><td class=\"text-center\"><span>{{ls.pa_2015}}\n</span></td><td class=\"text-center\"><span>{{ls.pa_2016}}</span></td><td class=\"text-center\"><span>\n{{(ls.potential_score.engagement > 0 && ls.potential_score.aspiration > 0 && ls.potential_score.ability > 0)?ls.potential_score.summary:\'\'}}\n</span></td><td class=\"text-center\"><span>{{ls.type_of_talent}}</span></td><td><div \nng-if=\"ls.competency_review && cr.status_id === \'1\'\" ng-repeat=\"cr in ls.competency_review\">- {{cr.competency}}</div>\n</td><td><div ng-if=\"ls.competency_review && cr.status_id === \'2\'\" ng-repeat=\"cr in ls.competency_review\">\n- {{cr.competency}}</div></td><td class=\"text-center\"><span></span></td><td \nng-click=\"vm.setProjectionwMember($event, ls)\"><span ng-if=\"ls.talent.projection\">{{ls.talent.projection}}</span><div \nng-if=\"!ls.talent.projection\" class=\"text-center\"><md-icon md-font-icon=\"icon-table-edit\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon></div></td><td class=\"text-center\"><span></span></td><td \nclass=\"text-center\"><span></span></td><td class=\"text-center\"><span></span></td><td class=\"text-center\"><span></span>\n</td><td class=\"text-center\"><span></span></td><td class=\"text-center\"><span></span></td><td class=\"text-center\"><span>\n</span></td><td class=\"text-center\"><span ng-repeat=\"abs in ls.infoAbsence\"><span class=\"red-500-fg\" \nng-if=\"abs.name==\'Truant\' || abs.name==\'Undisciplined\'\">{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span> \n</span><span ng-if=\"!(abs.name==\'Truant\' || abs.name==\'Undisciplined\')\">{{abs.name}} <span ng-if=\"abs.full==0\">\n:{{abs.total}}</span></span></span></td></tr></tbody></table></md-content></div></div></md-content></div><style \ntype=\"text/css\">.btn-ui-serif {\n    line-height: 3.8rem !important;\n}</style>");
$templateCache.put("app/main/pms/mpp/mpp.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">Years</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year.year}}\" \nng-click=\"vm.showMpp(year.year)\"><span class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill><div\n class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">Man Power Plan</md-subheader><div \nclass=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\">NO</th><th rowspan=\"2\">\nJOB CODE</th><th rowspan=\"2\">JOB TITLE</th><th rowspan=\"2\">TOTAL CURRENT EMP</th><th rowspan=\"2\">TOTAL FUTURE EMP</th>\n<th colspan=\"2\">TOTAL INCREASE EMP</th><th colspan=\"2\">TOTAL REDUCTION EMP</th><th colspan=\"12\">\nFULFILLMENT SCHEDULE (MONTH)</th><th rowspan=\"2\" width=\"15%\">NOTE</th></tr><tr><th>INTERNAL</th><th>\nEXTERNAL (NEW RECRUITE)</th><th>MUTATION/PROMOTION</th><th>TERMINATION</th><th>1</th><th>2</th><th>3</th><th>4</th><th>\n5</th><th>6</th><th>7</th><th>8</th><th>9</th><th>10</th><th>11</th><th>12</th></tr></thead><tbody><tr \nng-repeat=\"mpp in vm.dataMpp\"><td class=\"text-center\">{{($index+1)}}</td><td class=\"text-center\">{{mpp.positionID}}\n</td><td class=\"text-center\">{{mpp.description}}</td><td class=\"text-center\">{{mpp.total}}</td><td class=\"text-center\">\n{{mpp.total}}</td><td class=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"></td><td \nclass=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"></td><td \nclass=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"></td><td \nclass=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"></td><td \nclass=\"text-center\"></td><td class=\"text-center\"></td></tr></tbody></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/mpp/mppincreasedialog.html","<md-dialog aria-label=\"Mango (Fruit)\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Mango (Fruit)</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><h2>Using .md-dialog-content class that sets the padding as the spec\n</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p><img style=\"margin: auto; max-width: 100%\" alt=\"Lush mango tree\" src=\"img/mangues.jpg\"><p>\nThe highest concentration of Mangifera genus is in the western part of Malesia (Sumatra, Java and Borneo) and in Burma and India. While other Mangifera species (e.g. horse mango, M. foetida) are also grown on a more localized basis, Mangifera indica&mdash;the \"common mango\" or \"Indian mango\"&mdash;is the only mango tree commonly cultivated in many tropical and subtropical regions.\n</p><p>\nIt originated in Indian subcontinent (present day India and Pakistan) and Burma. It is the national fruit of India, Pakistan, and the Philippines, and the national tree of Bangladesh. In several cultures, its fruit and leaves are ritually used as floral decorations at weddings, public celebrations, and religious ceremonies.\n</p></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.cancel()\">close</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/talent-review-admin/talent-review-admin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Talent Review for Admin</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label><md-select \nng-disabled=\"vm.group === \'110\' || vm.group === \'116\'\" ng-change=\"vm.loadDataDivision(vm.bu)\" ng-model=\"vm.bu\">\n<md-option ng-value=\"\">All</md-option><md-option ng-repeat=\"bu in vm.listBu\" ng-value=\"bu.id\">{{bu.description}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Division</label>\n<md-select ng-change=\"vm.loadDataDepartment(vm.divisi)\" ng-model=\"vm.divisi\"><md-option ng-value=\"\">All</md-option>\n<md-option ng-repeat=\"divisi in vm.listDivisi\" ng-value=\"{{divisi.id}}\">{{divisi.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Department</label><md-select \nng-change=\"vm.loadDataAtasan()\" ng-model=\"vm.department\"><md-option ng-value=\"\">All</md-option><md-option \nng-repeat=\"department  in vm.listDepartment\" ng-value=\"{{department.id}}\">{{department.description}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Atasan</label><md-select \nng-change=\"vm.loadData(1)\" ng-model=\"vm.nik_atasan\" required><md-option ng-value=\"\">All</md-option><md-option \nng-repeat=\"atasan  in vm.listAtasan\" ng-value=\"{{atasan.nik}}\">{{atasan.nik}}, {{atasan.fullname}}</md-option>\n</md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div>\n</form></div></div></md-content><span class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ui-sref=\"app.pms_talent_review_admin_9box\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">View 9-Box Table</md-tooltip><md-icon \nmd-font-icon=\"icon-clipboard-text\" class=\"md-font icon-archive material-icons\"></md-icon><span>View 9-Box Table</span>\n</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" \nng-click=\"vm.ExportAllEmployeetoExcel()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Download\n</md-tooltip><md-icon md-font-icon=\"icon-download\" class=\"md-font icon-archive material-icons\"></md-icon><span>Download\n</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></span><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\">NO</span></th><th \nclass=\"text-center\" colspan=\"14\" layout-align=\"center\"><span class=\"column-title\">PERSONAL DATA</span></th><th \nclass=\"text-center\" colspan=\"2\" layout-align=\"center\"><span class=\"column-title\">PERFORMANCE</span></th><th \nclass=\"text-center\" rowspan=\"2\"><span class=\"column-title\">POTENTIAL PROFILE</span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\">TYPE OF TALENT</span></th><th class=\"text-center\" colspan=\"3\"><span \nclass=\"column-title\">COMPETENCY REVIEW</span></th><th class=\"text-center\" colspan=\"3\"><span class=\"column-title\">\nDEVELOPMENT</span></th><th class=\"text-center\" colspan=\"3\"><span class=\"column-title\">SUCCESSION</span></th><th \nclass=\"text-center\" colspan=\"2\"><span class=\"column-title\">RETENTION</span></th><th class=\"text-center\" rowspan=\"2\">\n<span class=\"column-title\">REMARKS</span></th></tr><tr><th class=\"text-center\"><span class=\"column-title\">ENTITY</span>\n</th><th class=\"text-center\"><span class=\"column-title\">EMPLOYEE NAME</span></th><th class=\"text-center\"><span \nclass=\"column-title\">PHOTO</span></th><th class=\"text-center\"><span class=\"column-title\">GENDER</span></th><th \nclass=\"text-center\"><span class=\"column-title\">BIRTHDATE</span></th><th class=\"text-center\"><span class=\"column-title\">\nAGE</span></th><th class=\"text-center\"><span class=\"column-title\">NATIONALITY</span></th><th class=\"text-center\"><span \nclass=\"column-title\">YEARS IN COMPANY</span></th><th class=\"text-center\"><span class=\"column-title\">\nSENIORTY IN POSITION</span></th><th class=\"text-center\"><span class=\"column-title\">LEVEL OF EDUCATION</span></th><th \nclass=\"text-center\"><span class=\"column-title\">CURRENT POSITION</span></th><th class=\"text-center\"><span \nclass=\"column-title\">ACTING STATUS</span></th><th class=\"text-center\"><span class=\"column-title\">DEPARTMENT</span></th>\n<th class=\"text-center\"><span class=\"column-title\">JOB FUNCTION</span></th><th class=\"text-center\"><span \nclass=\"column-title\">PA 2015</span></th><th class=\"text-center\"><span class=\"column-title\">PA 2016</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Strengths<br>Competencies and Values</span></th><th class=\"text-center\">\n<span class=\"column-title\">Areas for Improvement<br>Competencies and Values</span></th><th class=\"text-center\"><span \nclass=\"column-title\">MEET REQUIREMENT<br>(%)</span></th><th class=\"text-center\"><span class=\"column-title\">\nProjection for future roles<br>Role / Readiness</span></th><th class=\"text-center\"><span class=\"column-title\">\nDevelopment actions done<br>from beg. 2016 till now<br>(ie. training, on the job, …)</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Development plan for<br>next 12-18 months<br>\n(ie. training, on the job, …)</span></th><th class=\"text-center\"><span class=\"column-title\">Ready Now<br>\n(Ready within 1 year)</span></th><th class=\"text-center\"><span class=\"column-title\">Potential<br>(Ready in 1-2 years)\n</span></th><th class=\"text-center\"><span class=\"column-title\">Other Possible<br>(Ready =>3 years)</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Attrition Risk<br>Low / Medium / High</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Retention<br>Action(s)</span></th></tr></thead><tbody \nng-if=\"!vm.listTalentReview\"><tr><td colspan=\"27\">No record found</td></tr></tbody><tbody><tr \nng-dblclick=\"vm.setTalentReviewMember($event, ls)\" ng-repeat=\"ls in vm.listTalentReview\" \nstyle=\"cursor: pointer; {{(ls.type_of_talent === \'1A\' || ls.type_of_talent === \'2A\' || ls.type_of_talent === \'1B\')?\'background-color: #CEFED4\':\'\';}} {{(ls.type_of_talent === \'3C\')?\'background-color: #FEE4D1;\':\'\';}}\">\n<td class=\"text-center\">{{$index + 1}}</td><td class=\"text-center\"><span>{{ls.entity}}</span></td><td \nstyle=\"white-space: nowrap\"><span>{{ls.nik + \' / \' + ls.name}}</span></td><td class=\"text-center\"><span></span></td><td\n class=\"text-center\"><span>{{ls.gender}}</span></td><td class=\"text-center\"><span>{{ls.date_of_birth}}</span></td><td \nclass=\"text-center\"><span>{{ls.age}}</span></td><td class=\"text-center\"><span>{{ls.nationality}}</span></td><td \nclass=\"text-center\"><span>{{ls.yeas_in_company}}</span></td><td class=\"text-center\"><span></span></td><td \nclass=\"text-center\"><span>{{ls.level_of_edu}}</span></td><td class=\"text-center\"><span>{{ls.current_position}}</span>\n</td><td class=\"text-center\"><span></span></td><td class=\"text-center\"><span>{{ls.department}}</span></td><td \nclass=\"text-center\"><span>{{ls.job_code.substring(0, 1)}}</span></td><td class=\"text-center\"><span>{{ls.pa_2015}}\n</span></td><td class=\"text-center\"><span>{{ls.pa_2016}}</span></td><td class=\"text-center\"><span>\n{{(ls.potential_score.engagement > 0 && ls.potential_score.aspiration > 0 && ls.potential_score.ability > 0)?ls.potential_score.summary:\'\'}}\n</span></td><td class=\"text-center\"><span>{{ls.type_of_talent}}</span></td><td><div \nng-if=\"ls.competency_review && cr.status_id === \'1\'\" ng-repeat=\"cr in ls.competency_review\">- {{cr.competency}}</div>\n</td><td><div ng-if=\"ls.competency_review && cr.status_id === \'2\'\" ng-repeat=\"cr in ls.competency_review\">\n- {{cr.competency}}</div></td><td class=\"text-center\"><span></span></td><td \nng-click=\"vm.setProjectionwMember($event, ls)\"><span ng-if=\"ls.talent.projection\">{{ls.talent.projection}}</span><div \nng-if=\"!ls.talent.projection\" class=\"text-center\"><md-icon md-font-icon=\"icon-table-edit\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon></div></td><td class=\"text-center\"><span></span></td><td \nclass=\"text-center\"><span></span></td><td class=\"text-center\"><span></span></td><td class=\"text-center\"><span></span>\n</td><td class=\"text-center\"><span></span></td><td class=\"text-center\"><span></span></td><td class=\"text-center\"><span>\n</span></td><td class=\"text-center\"><span ng-repeat=\"abs in ls.infoAbsence\"><span class=\"red-500-fg\" \nng-if=\"abs.name==\'Truant\' || abs.name==\'Undisciplined\'\">{{abs.name}} <span ng-if=\"abs.full==0\">:{{abs.total}}</span> \n</span><span ng-if=\"!(abs.name==\'Truant\' || abs.name==\'Undisciplined\')\">{{abs.name}} <span ng-if=\"abs.full==0\">\n:{{abs.total}}</span></span></span></td></tr></tbody></table></md-content></div></div></div><style type=\"text/css\">\n.btn-ui-serif {\n    line-height: 3.8rem !important;\n}</style></div>");
$templateCache.put("app/main/pms/tutorial2/tutorial2-view.html","<div id=\"page_talent\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Tutorial</span></md-subheader><div class=\"white-bg\"><div class=\"content\"><div \nlayout-xs=\"column\" layout=\"row\"><div ng-if=\"vm.tutorial_type === \'video\'\" flex-xs flex-gt-xs=\"50\" layout=\"column\"><h3>\n{{ \'KPI.LABEL.PERFORMVIDEO\' | translate}}</h3><video class=\"tutorial\" controls=\"\" name=\"media\"><source \nsrc=\"{{vm.url}}\" type=\"video/mp4\">Your browser does not support the video tag.</video></div><div \nng-if=\"vm.tutorial_type === \'ebook\'\" flex-xs flex-gt-xs=\"100\" layout=\"column\"><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:80vh\" frameborder=\"0\"></iframe></div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/pms/tutorial2/tutorial2.html","<div id=\"simple-table\" class=\"page-layout simple is-simple fullwidth doc-page element-doc-page ng-scope\"><div \nclass=\"content\"><div layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"30\" layout=\"column\" \nng-repeat=\"tutorial in vm.tutorialList\"><md-card md-theme=\"{{ showDarkTheme ? \'dark-orange\' : \'default\' }}\" \nmd-theme-watch><md-card-content layout=\"row\"><div class=\"card-media\"><img \nui-sref=\"app.pms_tutorial2_view({tutorial_type: tutorial.type, url: tutorial.url})\" style=\"cursor: pointer\" \nng-src=\"{{\'assets/tutorial/\' + tutorial.cover}}\" alt=\"\"></div></md-card-content><md-card-title class=\"has-title-card\">\n<md-card-title-text style=\"cursor: pointer\"><a \nui-sref=\"app.pms_tutorial2_view({tutorial_type: tutorial.type, url: tutorial.url})\"><span \nclass=\"title h3 ng-binding ng-scope\">{{tutorial.title | translate}}</span></a></md-card-title-text></md-card-title>\n<md-card-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"btn-green\" \nui-sref=\"app.pms_tutorial2_view({tutorial_type: tutorial.type, url: tutorial.url})\">View</md-button></md-card-actions>\n</md-card></div></div></div></div>");
$templateCache.put("app/main/pms/upload-data/upload-data.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\nUpload Data</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><form name=\"basicForm\" class=\"md-inline-form has-upload\" novalidate><fieldset><legend>\nUpload Data KPI NON People</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\">\n<div flex><input type=\"file\" id=\"uploadFileNonPeople\" nv-file-select uploader=\"vm.FileUploaderNonPeople\"></div><div \nclass=\"text-right\" flex><md-button type=\"button\" ng-click=\"vm.FileUploaderNonPeople.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderNonPeople.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadKPINonPeopleStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadKPINonPeopleStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-content>\n</fieldset><fieldset style=\"margin-top:20px\"><legend>Upload Data KPI People</legend><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFilePeople\" nv-file-select \nuploader=\"vm.FileUploaderPeople\"></div><div class=\"text-right\" flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPeople.uploadAll()\" class=\"md-raised md-green-500-bg green-50-fg\" aria-label=\"Submit\"><md-icon\n md-font-icon=\"icon-download\" class=\"green-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPeople.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadKPIPeopleStateError\" style=\"margin-top:20px\" \nflex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadKPIPeopleStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-content></fieldset>\n<fieldset style=\"margin-top:20px\"><legend>Upload Data TSTE People</legend><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFileTSTE\" nv-file-select \nuploader=\"vm.FileUploaderTSTE\"></div><div class=\"text-right\" flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderTSTE.uploadAll()\" class=\"md-raised md-lime-500-bg lime-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-download\" class=\"lime-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderTSTE.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadKPITSTEStateError\" style=\"margin-top:20px\" \nflex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadKPITSTEStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-content></fieldset>\n<fieldset style=\"margin-top:20px\"><legend>Upload Data KPI Adjustment</legend><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFileAdjustment\" \nnv-file-select uploader=\"vm.FileUploaderAdjustment\"></div><div class=\"text-right\" flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderAdjustment.uploadAll()\" class=\"md-raised md-deep-orange-500-bg deep-orange-50-fg\" \naria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" class=\"deep-orange-50-fg\"></md-icon>Upload</md-button></div>\n</div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderAdjustment.progress}}\" class=\"md-accent hue-2\">\n</md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadKPIAdjustmentStateError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.UploadKPIAdjustmentStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Success Upload data</span>\n</md-whiteframe></md-content></fieldset><fieldset style=\"margin-top:20px\"><legend>Upload Data PA Report</legend>\n<md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" \nid=\"uploadFilepa\" nv-file-select uploader=\"vm.FileUploaderPa\"></div><div class=\"text-right\" flex><md-button \ntype=\"button\" ng-click=\"vm.FileUploaderPa.uploadAll()\" class=\"md-raised md-brown-500-bg brown-50-fg\" \naria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" class=\"brown-50-fg\"></md-icon>Upload</md-button></div></div>\n<md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPa.progress}}\" class=\"md-accent hue-2\">\n</md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadKPIPaStateError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.UploadKPIPaStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Success Upload data</span>\n</md-whiteframe></md-content></fieldset><fieldset style=\"margin-top:20px\"><legend>Upload Data Karyawan</legend>\n<md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" \nid=\"uploadFilekaryawan\" nv-file-select uploader=\"vm.FileUploaderKaryawan\"></div><div class=\"text-right\" flex><md-button\n type=\"button\" ng-click=\"vm.FileUploaderKaryawan.uploadAll()\" class=\"md-raised md-black-500-bg white-fg\" \naria-label=\"Submit\"><md-icon md-font-icon=\"icon-download\" class=\"white-fg\"></md-icon>Upload</md-button></div></div>\n<md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderKaryawan.progress}}\" class=\"md-accent hue-2\">\n</md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadKPIKaryawanStateError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.UploadKPIKaryawanStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Success Upload data</span>\n</md-whiteframe></md-content></fieldset><ms-widget flippable=\"true\" layout=\"column\" \nng-show=\"basicForm.description.$valid\" class=\"fade\"><ms-widget-front class=\"p-16 {{vm.messageTheme}}-400-bg white-fg\">\n<p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>test</p></ms-widget-front>\n</ms-widget></form></md-content></div></div></md-content></div>");
$templateCache.put("app/main/sfa/form-sfa-user/form-sfa-user.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div class=\"title\" translate=\"SFA.FORM.TITLE\">Form Input sfa user</div></md-subheader><div \nclass=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><form \nname=\"formInputSFA\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputSFA)\"><div layout=\"column\">\n<md-input-container flex><input type=\"text\" name=\"nik\" ng-model=\"vm.Form.objForm.nik\" placeholder=\"NIK\" \nng-change=\"vm.clearMeesage()\" required><div ng-messages=\"formInputSFA.nik.$error\" role=\"alert\"><div \nng-message=\"required\"><span>NIK is required.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"nama\" ng-model=\"vm.Form.objForm.nama\" placeholder=\"Name\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputSFA.nama.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"lokasi\" ng-model=\"vm.Form.objForm.lokasi\" \nplaceholder=\"Location\" ng-change=\"vm.clearMeesage()\" required><div ng-messages=\"formInputSFA.lokasi.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Location is required.</span></div></div></md-input-container></div>\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-md=\"column\" layout-align=\"center center\" flex><md-button type=\"button\" ui-sref=\"app.sfa_user\" \nclass=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Reload\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInputSFA.$invalid || basicForm.$pristine\">Submit</md-button></div></form></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/sfa/sfa-user/sfa-user.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">User SFA</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container md-no-float class=\"md-block\" flex=\"30\"><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries<md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ui-sref=\"app.input_sfa_user\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Add User</md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon><span translate=\"SFA.LIST.NEW\">\nAdd User</span></md-button><md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" \nng-click=\"vm.deleteUser($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Delete User</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"SFA.LIST.DELETE\">Delete User</span></md-button></md-input-container><span flex></span> <span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\" width=\"1%\"><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SFA.LIST.NIK\">NIK</span></div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SFA.LIST.NAME\">NAME</span></div></th><th class=\"text-center\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SFA.LIST.LOCATION\">LOCATION</span></div></th><th \nclass=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SFA.LIST.INPUT_USER\">\nINPUT USER</span></div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SFA.LIST.INPUT_DATE\">INPUT DATE</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editUser(ls.id)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listModulSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ ls.nik }}</td><td \nclass=\"text-center\">{{ ls.nama }}</td><td class=\"text-center\">{{ ls.lokasi }}</td><td class=\"text-center\">\n{{ ls.input_user }}</td><td class=\"text-center\">{{ ls.input_time }}</td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/report/correspondence/correspondence.html","<div id=\"print-helper\" class=\"blue-700-bg\" layout=\"row\" layout-align=\"start center\" flex><div flex=\"20\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\">Correspondence Printing System</span></div><div flex></div><div \nflex=\"30\" layout=\"row\" layout-align=\"end center\"><md-input-container flex><label>Set Page Size</label><md-select \nng-model=\"vm.pageSize\"><md-option value=\"A4\">A4</md-option><md-option value=\"letter\">Letter</md-option><md-option \nvalue=\"legal\">Legal</md-option></md-select></md-input-container><md-input-container flex><label>Set Orientation</label>\n<md-select ng-model=\"vm.pageOrientation\"><md-option value=\"potrait\">Potrait</md-option><md-option value=\"landscape\">\nLandscape</md-option></md-select></md-input-container><md-button class=\"md-icon-button md-small\" ng-click=\"vm.print()\">\n<md-icon style=\"color:#fff\" md-font-icon=\"icon-printer\"></md-icon></md-button></div></div><div \nid=\"correspondenceReport\" ui-view=\"correspondenceReport\"></div>");
$templateCache.put("app/main/report/jic/jic.html","<div id=\"jicReport\" ui-view=\"jicReport\"></div>");
$templateCache.put("app/main/short-leave-gw/short-leave-gw-list/gw-list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">GW List For Short Leave</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex><label>Working Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.workingDate\" ng-change=\"vm.getLine()\" md-placeholder=\"Working Date\" \nname=\"workingDate\"></md-datepicker></md-input-container><md-input-container flex-gt-sm=\"20\" flex><md-select \nng-model=\"vm.line\" name=\"line\"><md-option placeholder=\"Line & Group\" ng-repeat=\"ls in vm.listLine\" value=\"{{ls}}\">\nLine : {{ls.line_number}}, Group : {{ls.shift_group_name}}</md-option></md-select></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-magnify\" \\></md-icon>Submit</md-button></div></form></div></div>\n</md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm>\n<select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select><span class=\"secondary-text\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>NIK</th><th>\nNAME</th><th>LINE</th><th>OUT OF POSITION</th><th>BACK IN POSITION</th><th>ACTION</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td>{{ ls.nik }}</td><td>{{ ls.nama }}</td><td>\n{{ ls.line_number }}</td><td>{{ ls.break_out }}</td><td>{{ ls.break_in }}</td><td><md-button \nclass=\"md-mini md-raised md-warn\" ng-click=\"vm.breakout($event, ls.nik)\" ng-if=\"ls.lst_status == \'30\'\"><md-icon \nmd-font-icon=\"icon-logout\" \\></md-icon>Break Out</md-button><md-button class=\"md-mini md-raised md-primary\" \nng-click=\"vm.breakin($event, ls.nik)\" ng-if=\"ls.lst_status == \'20\' \"><md-icon md-font-icon=\"icon-login\" \\></md-icon>\nBreak In</md-button></td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/ta/echeckin-list/completion-data.html","<md-dialog aria-label=\"Form\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"formTA\" novalidate \nng-submit=\"vm.saveDataTA($event,formTA)\" ng-if=\"vm.group_ta == true\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Completion Echeckin Data</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nflex><label>Employee Group</label><md-select ng-model=\"vm.Form.objForm.empGroup\" name=\"empGroup\" ng-disabled=\"true\" \nrequired><md-option ng-repeat=\"ls in vm.empGroup\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"formTA.empGroup.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee Group is Required.</span>\n</div></div></md-input-container><md-input-container flex ng-if=\"vm.isMpnNumber\"><label>MPN Number</label><md-select \nng-model=\"vm.Form.objForm.mpnNumber\" name=\"mpnNumber\"><md-option ng-repeat=\"ls in vm.mpnNumber\" \nvalue=\"{{ls.mpn_number}}\">{{ls.mpn_number}} - {{ls.business_title_text}} - {{ls.app_date}}</md-option></md-select><div \nng-messages=\"formTA.mpnNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>MPN Number is required.</span>\n</div></div></md-input-container><md-input-container layout=\"row\" class=\"md-block\" flex><label>Join Date</label><input \nrequired name=\"date\" ng-model=\"vm.Form.objForm.join_date\" type=\"date\"></md-input-container><md-input-container flex>\n<label>Contract Status</label><md-select ng-model=\"vm.Form.objForm.contract\" name=\"contract\" required><md-option \nng-repeat=\"ls in vm.contractStatus\" value=\"{{ls}}\">{{ls}}</md-option></md-select><div \nng-messages=\"formTA.contract.$error\" role=\"alert\"><div ng-message=\"required\"><span>Contract Status is Required.</span>\n</div></div></md-input-container><md-input-container flex flex ng-if=\"vm.Form.objForm.contract == \'Contract\'\"><label>\nStart Contract</label><md-datepicker md-hide-icons=\"calendar\" name=\"startContract\" \nng-model=\"vm.Form.objForm.startContract\" required></md-datepicker><div ng-messages=\"formTA.startContract.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Contract is Required</span></div></div></md-input-container>\n<md-input-container flex ng-if=\"vm.Form.objForm.contract == \'Contract\'\"><label>End Contract</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"endContract\" ng-change=\"vm.getMonitoringOfTask(vm.endContract)\" \nng-model=\"vm.Form.objForm.endContract\" required></md-datepicker><div ng-messages=\"formTA.endContract.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Contract is Required</span></div></div></md-input-container>\n<md-input-container flex><label>Basic Salary</label><input type=\"number\" name=\"basicSalary\" \nng-model=\"vm.Form.objForm.basicSalary\"><div ng-messages=\"formTA.basicSalary.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Basic Salary is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Management Allowance</label><input type=\"number\" name=\"managementAllowance\" \nng-model=\"vm.Form.objForm.managementAllowance\"><div ng-messages=\"formTA.managementAllowance.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Management Allowance is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Meal Allowance</label><input type=\"number\" name=\"mealAllowance\" \nng-model=\"vm.Form.objForm.mealAllowance\"><div ng-messages=\"formTA.mealAllowance.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Meal Allowance is required.</span></div></div></md-input-container><md-input-container \nflex><label>Transport Allowance</label><input type=\"number\" name=\"transportAllowance\" \nng-model=\"vm.Form.objForm.transportAllowance\"><div ng-messages=\"formTA.transportAllowance.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Transport Allowance is required.</span></div></div></md-input-container><md-input-container\n flex><label>Communication Allowance</label><input type=\"number\" name=\"communicationAllowance\" \nng-model=\"vm.Form.objForm.communicationAllowance\"><div ng-messages=\"formTA.communicationAllowance.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Communication Allowance is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Functional Allowance</label><input type=\"number\" name=\"functionalAllowance\" \nng-model=\"vm.Form.objForm.functionalAllowance\"><div ng-messages=\"formTA.functionalAllowance.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Functional Allowance is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span><md-button \nng-if=\"vm.completionTA == 1\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formTA.$invalid || formTA.$pristine\">Update</md-button><md-button ng-if=\"vm.completionTA == 0\" \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"formTA.$invalid || formTA.$pristine\">Submit\n</md-button></md-dialog-actions></form><form ng-cloack name=\"formServices\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveDataService($event,formServices)\" ng-if=\"vm.group_pa == true\"><md-toolbar class=\"md-cyan-600-bg\"><div\n class=\"md-toolbar-tools\"><h2>Form Completion Services</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"row\"><md-input-container flex>\n<label>Work Schedule Rule</label><md-select ng-model=\"vm.Form.objForm.workSchedule\" name=\"workSchedule\" required>\n<md-option ng-repeat=\"ls in vm.workSchedule\" value=\"{{ls.id}}\"><span>{{ls.shift_name}}</span> <span>\n({{ls.start_time}}-{{ls.end_time}}), </span><span>Cycle Number : {{ls.cycle_number}}</span></md-option></md-select><div\n ng-messages=\"formService.workSchedule.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWork Schedule Rule is required.</span></div></div></md-input-container><md-input-container flex><label>Direct Report\n</label><input type=\"text\" ng-model=\"vm.Form.objForm.directreport\" name=\"directreport\"></md-input-container><div \nng-messages=\"formServices.directreport.$error\" role=\"alert\"><div ng-message=\"required\"><span>Direct Report is Required.\n</span></div></div></div><div layout=\"row\"><md-input-container flex><md-checkbox ng-model=\"vm.Form.objForm.isHalfday\" \naria-label=\"is half Day?\">Is Half Day Shift ?</md-checkbox></md-input-container><md-input-container flex \nng-if=\"vm.Form.objForm.isHalfday\"><label>Halfday Name</label><md-select ng-model=\"vm.Form.objForm.halfDayName\" \nname=\"halfDayName\" required><md-option ng-repeat=\"ls in vm.listDays\" value=\"{{ls.values}}\">{{ls.view}}</md-option>\n</md-select><div ng-messages=\"formService.halfDayName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWork Schedule Rule is required.</span></div></div></md-input-container><md-input-container flex><label>Offday Name\n</label><md-select ng-model=\"vm.Form.objForm.offDayName\" name=\"offDayName\" required multiple=\"multiple\"><md-option \nng-repeat=\"ls in vm.listDays\" value=\"{{ls.values}}\">{{ls.view}}</md-option></md-select><div \nng-messages=\"formService.offDayName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWork Schedule Rule is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front>\n</ms-widget><span flex></span><md-button ng-if=\"vm.completionPA == 1\" type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"formTA.$invalid || formTA.$pristine\">Update</md-button><md-button \nng-if=\"vm.completionPA == 0\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formTA.$invalid || formTA.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/echeckin-list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ECHECKINLIST\"></span></md-subheader><div class=\"white-bg\"><md-toolbar \nmd-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button aria-label=\"Twitter\" class=\"md-green-300-bg md-raised md-primary white-fg\" \nng-click=\"vm.ExportToExcel(\'completed\')\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ATTENDANCE.LABEL.DOWNLOADECHECKINCOMPLETED\"></span></md-tooltip><md-icon md-font-icon=\"icon-file-excel\">\n</md-icon><span translate=\"ATTENDANCE.LABEL.DOWNLOADECHECKINCOMPLETED\"></span></md-button></md-menu-item><md-menu-item>\n<md-button aria-label=\"Twitter\" class=\"md-green-300-bg md-raised md-primary white-fg\" \nng-click=\"vm.ExportToExcel(\'all\')\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ATTENDANCE.LABEL.DOWNLOADALLECHECKIN\"></span></md-tooltip><md-icon md-font-icon=\"icon-file-excel\"></md-icon>\n<span translate=\"ATTENDANCE.LABEL.DOWNLOADALLECHECKIN\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" type=\"button\" aria-label=\"Twitter\" \nng-click=\"vm.ExportFromViewToExcel()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ATTENDANCE.LABEL.DOWNLOADCOMPLETION\"></span></md-tooltip><md-icon md-font-icon=\"icon-file-excel\"></md-icon>\n<span translate=\"ATTENDANCE.LABEL.DOWNLOADCOMPLETION\"></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.ExportToExcel(\'completed\')\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ATTENDANCE.LABEL.DOWNLOADECHECKINCOMPLETED\"></span></md-tooltip><span \ntranslate=\"ATTENDANCE.LABEL.DOWNLOADECHECKINCOMPLETED\"></span></md-button><div ng-if=\"vm.eCheckin\" \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.ExportToExcel(\'all\')\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ATTENDANCE.LABEL.DOWNLOADALLECHECKIN\"></span></md-tooltip><span \ntranslate=\"ATTENDANCE.LABEL.DOWNLOADALLECHECKIN\"></span></md-button><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.ExportFromViewToExcel()\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ATTENDANCE.LABEL.DOWNLOADCOMPLETION\"></span></md-tooltip><span \ntranslate=\"ATTENDANCE.LABEL.DOWNLOADCOMPLETION\"></span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NO\"></span></span></th><th width=\"30%\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NAME\"></span></span></th><th><span class=\"column-title\"><span translate=\"PAYROLL.MENU.ADDRESS\">\n</span></span></th><th><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.PHONENUMBER\"></span></span></th><th>\n<span class=\"column-title\"><span translate=\"KPI.LABEL.JOINDATE\"></span></span></th><th><span class=\"column-title\"><span\n translate=\"MYPROFILE.MENU.GENDER\"></span></span></th><th><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\"></span></span></th><th><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.EXPERIENCE\"></span></span></th><th><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.DEPENDENT\"></span></span></th><th><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.BANK\"></span></span></th><th><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.TAX\">\n</span></span></th><th><span class=\"column-title\"><span translate=\"KPI.LABEL.EMERGENCY\"></span></span></th><th><span \nclass=\"column-title\"><span translate=\"MYPROFILE.MENU.LANGUAGE\"></span></span></th><th><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.TRAINING\"></span></span></th><th><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.CERTIFICATES\"></span></span></th><th><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.IDENTITY\"></span></span></th><th><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.JAMSOSTEK\"></span></span></th><th><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.STATUS\"></span></span></th><th></th></tr></thead><tbody><div></div><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls.noktp)\" \nng-class=\"{ \'grey-300-bg\' : ls.submit_ta == 1 && (ls.group_ta == true) }\"><td>{{ls.no}}</td><td>\n{{ls.title }} {{ls.firstName }} {{ls.middle_name}} {{ls.lastName }}</td><td>{{ls.address}}</td><td>{{ls.phone}}</td>\n<td>{{ls.date_join}}</td><td class=\"text-center\">{{ls.gender}}</td><td class=\"text-center\"><md-button \nng-if=\"ls.education > 0\" class=\"md-icon-button\" ng-click=\"vm.viewEducation($this, ls)\"><md-icon \nmd-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></md-button><md-icon ng-if=\"ls.education <= 0\" \nmd-font-icon=\"icon-close\" class=\"red-500-fg\"></md-icon></td><td class=\"text-center\"><md-button \nng-if=\"ls.experiences && ls.state_experiences == 1\" class=\"md-icon-button\" ng-click=\"vm.viewExperiences($this, ls)\">\n<md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></md-button><md-icon \nng-if=\"!ls.experiences && ls.state_experiences == 1\" md-font-icon=\"icon-close\" class=\"red-500-fg\"></md-icon></td><td \nclass=\"text-center\"><md-button ng-if=\"ls.dependents > 0\" class=\"md-icon-button\" ng-click=\"vm.viewDependent($this, ls)\">\n<md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></md-button><md-icon ng-if=\"ls.dependents <= 0\" \nmd-font-icon=\"icon-close\" class=\"red-500-fg\"></md-icon></td><td class=\"text-center\"><md-button \nng-if=\"ls.bank && ls.state_bank == 1\" class=\"md-icon-button\" ng-click=\"vm.viewBank($this, ls)\"><md-icon \nmd-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></md-button><md-icon ng-if=\"!ls.bank && ls.state_bank == 1\" \nmd-font-icon=\"icon-close\" class=\"red-500-fg\"></md-icon></td><td class=\"text-center\"><md-button ng-if=\"ls.tax > 0\" \nclass=\"md-icon-button\" ng-click=\"vm.viewTax($this, ls)\"><md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\">\n</md-icon></md-button><md-icon ng-if=\"ls.tax <= 0\" md-font-icon=\"icon-close\" class=\"red-500-fg\"></md-icon></td><td \nclass=\"text-center\"><md-button ng-if=\"ls.emergency > 0\" class=\"md-icon-button\" ng-click=\"vm.viewEmergency($this, ls)\">\n<md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></md-button><md-icon ng-if=\"ls.emergency <= 0\" \nmd-font-icon=\"icon-close\" class=\"red-500-fg\"></md-icon></td><td class=\"text-center\"><md-button ng-if=\"ls.language > 0\" \nclass=\"md-icon-button\" ng-click=\"vm.viewLanguage($this, ls)\"><md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\">\n</md-icon></md-button></td><td class=\"text-center\"><md-button ng-if=\"ls.training > 0\" class=\"md-icon-button\" \nng-click=\"vm.viewTraining($this, ls)\"><md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></md-button>\n</td><td class=\"text-center\"><md-button ng-if=\"ls.ijazah > 0\" class=\"md-icon-button\" \nng-click=\"vm.viewCertificate($this, ls)\"><md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></md-button>\n<md-icon ng-if=\"ls.ijazah <= 0\" md-font-icon=\"icon-close\" class=\"red-500-fg\"></md-icon></td><td class=\"text-center\">\n<md-button ng-if=\"ls.otherdocument > 0\" class=\"md-icon-button\" ng-click=\"vm.viewKtp($this, ls)\"><md-icon \nmd-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></md-button><md-icon ng-if=\"ls.otherdocument <= 0\" \nmd-font-icon=\"icon-close\" class=\"red-500-fg\"></md-icon></td><td class=\"text-center\"><md-button \nng-if=\"ls.jamsostek == 1 && ls.state_jamsostek == 1\" class=\"md-icon-button\" ng-click=\"vm.viewJamsostek($this, ls)\">\n<md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\"></md-icon></md-button><md-icon \nng-if=\"ls.jamsostek == 0 && ls.state_jamsostek == 1\" md-font-icon=\"icon-close\" class=\"red-500-fg\"></md-icon></td><td \nclass=\"text-center\"><span ng-if=\"ls.submit_ta == 1 && ls.submit_pa == 0\" style=\"color:green\">\nWaiting Employement Process</span> <span ng-if=\"ls.submit_candidate==0\" style=\"color:orange\">On Progress</span> <span \nng-if=\"ls.submit_ta == 0 && ls.submit_candidate == 1\" style=\"color:orange\">Waiting TA Completetion</span> <span \nng-if=\"ls.submit_ta == 1 && ls.submit_pa == 1\" style=\"color:green\">Completed</span></td><td><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-if=\"ls.submit_candidate==\'1\'\"><md-button ng-click=\"vm.CompletionData($event,ls)\" \nng-disabled=\"vm.disabledSubmitTa(ls)\" aria-label=\"Refresh widget\"><md-icon class=\"green-500-fg\" \nmd-font-icon=\"icon-check-all\"></md-icon>\n{{ (ls.completion_ta == 1 || ls.completion_pa == 1) ? \'Update Completion Data\' : \'Completion Data\' }}</md-button>\n</md-menu-item><md-menu-item ng-if=\"ls.submit_ta == 0 && ls.completion_ta == 1\"><md-button aria-label=\"Refresh widget\" \nng-disabled=\"vm.disabledSubmitTa(ls)\" ng-click=\"vm.updateSubmitTA($event,ls.user_id)\"><md-icon class=\"red-500-fg\" \nmd-font-icon=\"icon-send\"></md-icon>Submit Candidate</md-button></md-menu-item><md-menu-item \nng-if=\"ls.submit_pa == 0 && ls.completion_pa == 1 && (ls.group_pa == true)\"><md-button aria-label=\"Refresh widget\" \nng-disabled=\"vm.disabledSubmitTa(ls)\" ng-click=\"vm.updateSubmitPA($event,ls.user_id)\"><md-icon class=\"red-500-fg\" \nmd-font-icon=\"icon-send\"></md-icon>Submit Employement</md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled==1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/ta/echeckin-list/join-date.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"formJD\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formJD)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Add Join Date</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nflex><label>Join Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"dateJoin\" ng-model=\"vm.dateJoin\" required>\n</md-datepicker><div ng-messages=\"formJD.dateJoin.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDate Join Required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front>\n</ms-widget><span flex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formJD.$invalid || formJD.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/ta/handover-gw/handover-gw.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding content-wrapper\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex \nclass=\"logo-text\">Training Gw</div></div></md-subheader><div class=\"white-bg\"><md-content class=\"filter-form\" \nlayout-padding><form name=\"userForm\"><div layout-gt-xs=\"row\"><span flex></span><md-input-container class=\"md-block\" \nflex-gt-xs><label>Kehadiran</label><md-select ng-model=\"vm.status\"><md-option ng-repeat=\"item in vm.statusList\" \nng-value=\"item.id\">{{item.description}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-xs><label>Training Status</label><md-select ng-model=\"vm.isTraining\"><md-option \nng-repeat=\"item in vm.isTrainingList\" ng-value=\"item.id\">{{item.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Handover</label><md-select \nng-model=\"vm.isConfirm\"><md-option ng-repeat=\"item in vm.isConfirmList\" ng-value=\"item.id\">{{item.description}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Training Date\n</label><input type=\"date\" ng-model=\"vm.trainingDate\"></md-input-container><md-button ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-primary\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button ng-disabled=\"vm.selected.length == 0\" \nclass=\"md-primary md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.handover($event, vm.selected, false)\"><md-icon style=\"font-size:16px\" md-font-icon=\"icon-debug-step-over\">\n</md-icon><span>Handover</span><md-tooltip>Mass Handover</md-tooltip></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTables.searchParam\" debounce=\"300\"></ms-search-bar><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon md-font-icon=\"icon-print\"></md-icon><span>PRINT\n</span></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\" ms-scroll><div class=\"table-container-content\"><table \nclass=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th><div flex \nlayout-align=\"center\" layout=\"row\"><input type=\"checkbox\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></div></th><th>No</th><th>NIK/Name</th><th>\nHandover Date</th><th>Handover User</th><th>Schedule</th><th>Rescheduled</th><th>Status</th><th>Override</th><th \nclass=\"action-table\">Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTables.list\"><td><div flex \nlayout-align=\"center\" layout=\"row\"><input ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\" type=\"checkbox\"></div></td><td class=\"text-center\">{{ $index + 1}}</td><td \nclass=\"text-center\">{{ item.nik }} - {{ item.name | uppercase }}</td><td class=\"text-center\">{{ item.hand_over_date}}\n</td><td class=\"text-center\">{{ item.hand_over_user}}</td><td class=\"text-center\">{{ item.default_schedule }}</td><td \nclass=\"text-center\">{{ item.reschedule }}</td><td class=\"text-center\">{{ item.status }}</td><td class=\"text-center\">\n{{ item.override_join_date == 1 ? \'Yes\' : \'No\' }}</td><td class=\"action-table\"><div layout=\"row\" layout-align=\"center\">\n<md-icon ng-if=\"!item.new_emp_handover_id\" class=\"click-icon\" ng-click=\"vm.showForm($event, item)\" \nmd-font-icon=\"icon-calendar-clock orange-400-fg\"><md-tooltip>Rescheduled</md-tooltip></md-icon><md-icon \nclass=\"click-icon\" ng-click=\"vm.handover($event, item, true)\" md-font-icon=\"icon-debug-step-over green-400-fg\">\n<md-tooltip>{{ item.new_emp_handover_id ? \'Update Handover\' : \'Handover\' }}</md-tooltip></md-icon><md-icon \nng-if=\"item.new_emp_handover_id\" class=\"click-icon\" ng-click=\"vm.removeHandover($event, item)\" \nmd-font-icon=\"icon-backup-restore red-400-fg\"><md-tooltip>Remove Handover</md-tooltip></md-icon></div></td></tr>\n</tbody></table></div><div ng-if=\"vm.DataTables.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/ta/handover-gw/handover.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll flex=\"50\"><form ng-cloak name=\"formReschedule\" \nclass=\"md-inline-form\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><h4>Handover</h4><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"margin-top:0px\"><div \nlayout=\"column\" flex layout-padding><md-input-container layout=\"row\" class=\"md-block\" flex><label>Handover Date</label>\n<input required name=\"date\" ng-model=\"vm.tempDate\" type=\"date\"></md-input-container><md-autocomplete md-delay=\"1000\" \nmd-menu-container-class=\"parent-autocomplete\" md-floating-label=\"Hand Over To\" md-selected-item=\"vm.employee\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" ng-required=\"true\" md-search-text=\"vm.searchText\" \nmd-input-name=\"employee\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"vm.getItemText(item)\" \nmd-min-length=\"2\"><md-item-template><span class=\"item-title\" md-highlight-text=\"vm.searchText\">\n{{ item.nik }} | {{ item.name | uppercase }}</span></md-item-template><div ng-messages=\"recForm.nik.$error\" \nrole=\"alert\"><div ng-message=\"required\">Recommended by is required</div></div><md-not-found>\nNo Record matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete><md-checkbox \nng-model=\"vm.overrideJoinDate\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Checkbox 1\">\nOverride Join Date (Join date will be the same as training date)</md-checkbox></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" flex><div layout-align=\"start center\" flex class=\"form-message\" \nng-class=\"{success:vm.success, error:!vm.success}\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{ vm.Form.pesan }}</div>\n<div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.submit(formReschedule)\" ng-disabled=\"formReschedule.$invalid || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/ta/handover-gw/reschedule.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll flex=\"50\"><form ng-cloak name=\"formReschedule\" \nclass=\"md-inline-form\" novalidate ng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><h4>Reschedule</h4><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"margin-top:0px\"><div \nlayout=\"column\" flex layout-padding><md-input-container layout=\"row\" class=\"md-block\" flex><label>Reschedule Date\n</label><input required name=\"date\" ng-model=\"vm.tempDate\" type=\"date\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" flex><div layout-align=\"start center\" flex class=\"form-message\" \nng-class=\"{success:vm.success, error:!vm.success}\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{ vm.Form.pesan }}</div>\n<div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.submit(formReschedule)\" ng-disabled=\"formReschedule.$invalid || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/ta/helpdesk/edit.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-md=\"60\" flex-gt-md=\"60\"><form ng-cloack name=\"formJD\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formJD)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Edit Helpdesk</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nclass=\"md-block\" style=\"padding-bottom:20px\"><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.notif.success || vm.notif.error\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget>\n</md-input-container><md-input-container flex><label>Message</label><textarea ng-model=\"vm.Form.objForm.data.message\" \nrequired name=\"message\">{{ vm.Form.objForm.data.message }}</textarea><div ng-messages=\"formJD.message.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Message harus idisi.</span></div></div>\n</md-input-container><md-input-container flex><label>Status</label><md-select ng-model=\"vm.Form.objForm.data.status\" \nname=\"status\" required><md-option ng-value=\"0\">Open</md-option><md-option ng-value=\"1\">Pending</md-option><md-option \nng-value=\"2\">On Progress</md-option><md-option ng-value=\"3\">Close</md-option></md-select><div \nng-messages=\"formJD.status.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nStatus Harus diisi.</span></div></div></md-input-container><md-input-container flex ng-if=\"vm.url\" style=\"width:100%\">\n<iframe src=\"{{ vm.url }}\" frameborder=\"0\" style=\"width:100%\"></iframe></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"formJD.$invalid || formJD.$pristine\">Update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/ta/helpdesk/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Helpdesk Echeckin</span></md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th><span class=\"column-title\">No</span>\n</th><th><span class=\"column-title\">Name</span></th><th><span class=\"column-title\">Email</span></th><th><span \nclass=\"column-title\">Message</span></th><th><span class=\"column-title\">Status</span></th><th><span \nclass=\"column-title\">Tanggal</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editData(ls.id)\"><td>{{ls.no}}</td><td>{{ls.firstName }} {{ls.middle_name}} {{ls.lastName }}</td><td>\n{{ls.email}}</td><td>{{ls.message}}</td><td>{{ls.status}}</td><td>{{ls.created_at}}</td><td><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.delete($event,ls.id)\" aria-label=\"Delete\"><md-icon class=\"red-500-fg\" \nmd-font-icon=\"icon-trash\"></md-icon>Delete</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.edit($event,ls)\" aria-label=\"Edit\"><md-icon class=\"blue-500-fg\" md-font-icon=\"icon-pencil\"></md-icon>Edit\n</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li class=\"{{nav.class}}\" ng-class=\"{disabled:(nav.disabled===1)}\" \nng-repeat=\"nav in vm.DataTable.listNav\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/ta/passwordecheckin/passwordecheckin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">Menu</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg csm-dropdown\"><md-button ui-sref=\"app.ta_passwordecheckin_input-password-echeckin\"><span>Input\n</span></md-button></md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill>\n<div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\"><span>e-Checkin Registered\n</span></md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container \nhide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries\n</md-input-container><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th width=\"5%\"><span class=\"column-title\">No</span></th><th class=\"text-left\"><span class=\"text-left\">Nama\n</span></th><th width=\"20%\"><span class=\"column-title\">Username</span></th><th width=\"10%\"><span class=\"column-title\">\nJenis Kelamin</span></th><th width=\"20%\"><span class=\"column-title\">Password</span></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls.noktp)\"><td class=\"text-center\">{{ls.no}}</td><td>\n{{ls.title }} {{ls.firstName }} {{ls.middleName }} {{ls.lastName }}</td><td class=\"text-center\">{{ls.noktp}}</td><td \nclass=\"text-center\">{{ls.gender}}</td><td class=\"text-center\">{{ls.password}}</td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/structure-area/area-sales/area-sales-add.html","<md-dialog aria-label=\"Form Add Area Sales\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack name=\"frmAddAreaSales\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddAreaSales)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Add Area Sales</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><fieldset><legend ng-if=\"vm.parentData\">Parent Information:</legend><div \nlayout=\"row\"><md-input-container flex><md-label>Sales Type</md-label><md-select ng-model=\"vm.Form.objForm.sales_type\" \nng-change=\"vm.loadWilayah(vm.Form.objForm.sales_type)\" name=\"sales_type\" required ng-disabled=\"vm.parentData\" \nplaceholder=\"Sales Type\"><md-option ng-repeat=\"ls in vm.salesTypeLists\" value=\"{{ls.value}}\">{{ls.name}}</md-option>\n</md-select><div ng-messages=\"frmAddAreaSales.sales_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSales type field is required.</span></div></div></md-input-container><md-input-container flex><md-label>Wilayah Sales\n</md-label><md-select ng-model=\"vm.Form.objForm.wilayah_sales_id\" \nng-change=\"vm.loadRegional(vm.Form.objForm.wilayah_sales_id)\" name=\"wilayah_sales_id\" required \nng-disabled=\"vm.parentData\" placeholder=\"Wilayah Sales\"><md-option ng-repeat=\"ls in vm.wilayahSalesLists\" \nvalue=\"{{ls.id}}\">{{ls.code_wilayah}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"frmAddRegionalSales.wilayah_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWilayah sales field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container \nflex><md-label>Regional Sales</md-label><md-select ng-model=\"vm.Form.objForm.regional_sales_id\" \nng-change=\"vm.loadCabang(vm.Form.objForm.regional_sales_id)\" name=\"regional_sales_id\" required \nng-disabled=\"vm.parentData\" placeholder=\"Regional Sales\"><md-option ng-repeat=\"ls in vm.regionalSalesLists\" \nvalue=\"{{ls.id}}\">{{ls.code_region}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"frmAddAreaSales.regional_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRegional sales field is required.</span></div></div></md-input-container><md-input-container flex><md-label>\nCabang Sales</md-label><md-select ng-model=\"vm.Form.objForm.cabang_sales_id\" ng-change=\"vm.loadAreaSales()\" \nname=\"cabang_sales_id\" required ng-disabled=\"vm.parentData\" placeholder=\"Cabang Sales\"><md-option \nng-repeat=\"ls in vm.cabangSalesLists\" value=\"{{ls.id}}\">{{ls.code_cabang}} - {{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmAddAreaSales.cabang_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCabang sales field is required.</span></div></div></md-input-container></div><div layout=\"row\" ng-if=\"vm.parentData\" \nclass=\"mb-0 pb-0\"><md-input-container flex class=\"mb-0 pb-0\"><md-label>Code Area</md-label><input type=\"text\" \nvalue=\"{{vm.parentData.code_area}}\" readonly=\"readonly\"></md-input-container><md-input-container flex \nclass=\"mb-0 pb-0\"><md-label>Description</md-label><input type=\"text\" value=\"{{vm.parentData.description}}\" \nreadonly=\"readonly\"></md-input-container></div></fieldset><md-input-container flex class=\"mt-0 pt-0\" \nng-if=\"vm.Form.objForm.sales_type === \'MT\'\"><md-switch name=\"is_homebase\" ng-model=\"vm.Form.objForm.is_homebase\" \nng-change=\"vm.loadAreaSales()\" ng-init=\"vm.Form.objForm.is_homebase = true\" aria-label=\"Is home base?\">\nIs home base? {{ (vm.Form.objForm.is_homebase)?\'Yes\':\'No\' }}</md-switch><div \nng-messages=\"frmAddAreaSales.is_homebase.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIs home base is required.</span></div></div></md-input-container><md-input-container \nng-if=\"vm.Form.objForm.sales_type === \'MT\' && vm.Form.objForm.is_homebase === false\" flex><md-label>Parent Area Sales\n</md-label><md-select ng-model=\"vm.Form.objForm.parent_id\" md-on-close=\"vm.clearSearchAreaSales()\" \nng-change=\"vm.selectedAreaSales(vm.Form.objForm.parent_id)\" name=\"parent_id\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchAreaSales\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.areaSalesLists\"><md-option ng-repeat=\"ls in vm.areaSalesLists | filter:vm.searchAreaSales\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.code_area}} - {{ls.description}}<table style=\"font-size: x-small; color: #424242\"><tr><td>Home Base</td><td>:</td>\n<td>{{ls.sub_area_description}}</td></tr><tr><td>Sales Type</td><td>:</td><td>{{ls.sales_type}}</td></tr><tr><td>Cabang\n</td><td>:</td><td>{{ls.cabang_sales_description}}</td></tr><tr><td>Regional</td><td>:</td><td>\n{{ls.regional_sales_description}}</td></tr><tr><td>Wilayah</td><td>:</td><td>{{ls.wilayah_sales_description}}</td></tr>\n</table></md-option></md-optgroup></md-select><div ng-messages=\"frmAddAreaSales.parent_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Parent field is required.</span></div></div></md-input-container><md-input-container flex \nclass=\"mt-20 pt-0\"><md-label>Code Area</md-label><input type=\"text\" name=\"code_area\" \nng-model=\"vm.Form.objForm.code_area\" required><div ng-messages=\"frmAddAreaSales.code_area.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Code area is required.</span></div></div></md-input-container><md-input-container flex \nclass=\"mt-0 pt-0\"><md-label>Description</md-label><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" required><div ng-messages=\"frmAddAreaSales.description.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Description is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddAreaSales.$invalid || frmAddAreaSales.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/structure-area/area-sales/area-sales-edit.html","<md-dialog aria-label=\"Form Edit Area Sales\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack name=\"frmEditAreaSales\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmEditAreaSales)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Edit Area Sales</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><fieldset><legend ng-if=\"vm.parentData\">Parent Information:</legend><div \nlayout=\"row\"><md-input-container flex><md-label>Sales Type</md-label><md-select ng-model=\"vm.Form.objForm.sales_type\" \nng-change=\"vm.loadWilayah(vm.Form.objForm.sales_type)\" name=\"sales_type\" required ng-disabled=\"true\" \nplaceholder=\"Sales Type\"><md-option ng-repeat=\"ls in vm.salesTypeLists\" value=\"{{ls.value}}\">{{ls.name}}</md-option>\n</md-select><div ng-messages=\"frmEditAreaSales.sales_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSales type field is required.</span></div></div></md-input-container><md-input-container flex><md-label>Wilayah Sales\n</md-label><md-select ng-model=\"vm.Form.objForm.wilayah_sales_id\" \nng-change=\"vm.loadRegional(vm.Form.objForm.wilayah_sales_id)\" name=\"wilayah_sales_id\" required \nng-disabled=\"vm.parentData\" placeholder=\"Wilayah Sales\"><md-option ng-repeat=\"ls in vm.wilayahSalesLists\" \nvalue=\"{{ls.id}}\">{{ls.code_wilayah}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"frmAddRegionalSales.wilayah_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWilayah sales field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container \nflex><md-label>Regional Sales</md-label><md-select ng-model=\"vm.Form.objForm.regional_sales_id\" \nng-change=\"vm.loadCabang(vm.Form.objForm.regional_sales_id)\" name=\"regional_sales_id\" required \nng-disabled=\"vm.parentData\" placeholder=\"Regional Sales\"><md-option ng-repeat=\"ls in vm.regionalSalesLists\" \nvalue=\"{{ls.id}}\">{{ls.code_region}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"frmEditAreaSales.regional_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRegional sales field is required.</span></div></div></md-input-container><md-input-container flex><md-label>\nCabang Sales</md-label><md-select ng-model=\"vm.Form.objForm.cabang_sales_id\" ng-change=\"vm.loadAreaSales()\" \nname=\"cabang_sales_id\" required ng-disabled=\"vm.parentData\" placeholder=\"Cabang Sales\"><md-option \nng-repeat=\"ls in vm.cabangSalesLists\" value=\"{{ls.id}}\">{{ls.code_cabang}} - {{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEditAreaSales.cabang_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCabang sales field is required.</span></div></div></md-input-container></div><div layout=\"row\" ng-if=\"vm.parentData\" \nclass=\"mb-0 pb-0\"><md-input-container flex class=\"mb-0 pb-0\"><md-label>Code Area</md-label><input type=\"text\" \nvalue=\"{{vm.parentData.code_area}}\" readonly=\"readonly\"></md-input-container><md-input-container flex \nclass=\"mb-0 pb-0\"><md-label>Description</md-label><input type=\"text\" value=\"{{vm.parentData.description}}\" \nreadonly=\"readonly\"></md-input-container></div></fieldset><md-input-container flex class=\"mt-0 pt-0\" \nng-if=\"vm.Form.objForm.sales_type === \'MT\'\"><md-switch name=\"is_homebase\" ng-model=\"vm.Form.objForm.is_homebase\" \nng-change=\"vm.loadAreaSales()\" ng-init=\"vm.Form.objForm.is_homebase = true\" aria-label=\"Is home base?\">\nIs home base? {{ (vm.Form.objForm.is_homebase)?\'Yes\':\'No\' }}</md-switch><div \nng-messages=\"frmEditAreaSales.is_homebase.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIs home base is required.</span></div></div></md-input-container><md-input-container \nng-if=\"vm.Form.objForm.sales_type === \'MT\' && vm.Form.objForm.is_homebase === false\" flex><md-label>Parent Area Sales\n</md-label><md-select ng-model=\"vm.Form.objForm.parent_id\" md-on-close=\"vm.clearSearchAreaSales()\" \nng-change=\"vm.selectedAreaSales(vm.Form.objForm.parent_id)\" name=\"parent_id\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchAreaSales\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.areaSalesLists\"><md-option ng-repeat=\"ls in vm.areaSalesLists | filter:vm.searchAreaSales\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.code_area}} - {{ls.description}}<table style=\"font-size: x-small; color: #424242\"><tr><td>Home Base</td><td>:</td>\n<td>{{ls.sub_area_description}}</td></tr><tr><td>Sales Type</td><td>:</td><td>{{ls.sales_type}}</td></tr><tr><td>Cabang\n</td><td>:</td><td>{{ls.cabang_sales_description}}</td></tr><tr><td>Regional</td><td>:</td><td>\n{{ls.regional_sales_description}}</td></tr><tr><td>Wilayah</td><td>:</td><td>{{ls.wilayah_sales_description}}</td></tr>\n</table></md-option></md-optgroup></md-select><div ng-messages=\"frmEditAreaSales.parent_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Parent field is required.</span></div></div></md-input-container><md-input-container flex \nclass=\"mt-20 pt-0\"><md-label>Code Area</md-label><input type=\"text\" name=\"code_area\" \nng-model=\"vm.Form.objForm.code_area\" required><div ng-messages=\"frmEditAreaSales.code_area.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Code area is required.</span></div></div></md-input-container><md-input-container flex \nclass=\"mt-0 pt-0\"><md-label>Description</md-label><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" required><div ng-messages=\"frmEditAreaSales.description.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Description is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditAreaSales.$invalid || frmEditAreaSales.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/structure-area/area-sales/area-sales-edit_bak.html","<md-dialog aria-label=\"Form Edit Area Sales\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"frmEditAreaSales\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmEditAreaSales)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Edit Area Sales</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"code_area\" \nng-model=\"vm.Form.objForm.code_area\" placeholder=\"Code Area\" required><div \nng-messages=\"frmEditAreaSales.code_area.$error\" role=\"alert\"><div ng-message=\"required\"><span>Code area is required.\n</span></div></div></md-input-container><md-input-container flex><textarea name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" rows=\"3\" required></textarea><div \nng-messages=\"frmEditAreaSales.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.cabang_sales_id\" ng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.cabang_sales_id)\" \nname=\"cabang_sales_id\" required><md-option ng-repeat=\"ls in vm.cabangSalesLists\" placeholder=\"Cabang Sales\" \nvalue=\"{{ls.id}}\">{{ls.code_cabang}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"frmEditAreaSales.cabang_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCabang sales field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditAreaSales.$invalid || frmEditAreaSales.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/structure-area/area-sales/area-sales-table.html","<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th style=\"min-width: 50px\"></th>\n<th>CODE</th><th class=\"text-center\">SUB AREA ID</th><th class=\"text-center\">DESCRIPTION</th><th>CABANG SALES</th><th>\nREGIONAL SALES</th><th>WILAYAH SALES</th><th>SALES TYPE</th><th width=\"min-width: 100px;\">#</th></tr></thead><tbody><tr\n ng-repeat=\"ls in vm.DataTable.list\"><td \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ls.code_area}}</td>\n<td class=\"text-center\">{{ls.sub_area_id}}</td><td>{{ls.description}}</td><td class=\"text-center\">\n{{ls.cabang_sales_description}}</td><td class=\"text-center\">{{ls.regional_sales_description}}</td><td \nclass=\"text-center\">{{ls.wilayah_sales_description}}</td><td class=\"text-center\">{{ls.sales_type}}</td><td \nclass=\"text-center\" style=\"white-space: nowrap; min-width: 100px; max-width: 100px; width: 100px\"><a \nhref=\"javasccript:void(0);\" ng-click=\"vm.edit($event, ls)\" style=\"text-decoration: none\"><span class=\"icon-pencil\">\n</span></a></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"5\" class=\"text-center\">\n<span>No Data Available</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/structure-area/area-sales/area-sales-toolbar.html","<div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container flex><md-select \nng-model=\"vm.cabangSales\" ng-change=\"vm.loadData(1)\" name=\"cabang_sales\" aria-label=\"Cabang Sales\"><md-option value=\"\">\n-- Cabang Sales</md-option><md-option ng-repeat=\"ls in vm.cabangSalesLists\" value=\"{{ls.id}}\">\n{{ls.code_cabang + \' - \' + ls.description}}</md-option></md-select></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputBusinesstrip($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>New</span>\n</md-button></md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" \naria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i class=\"icon-delete\"></i> <span>Delete</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.add($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New\n</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span>New</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span>Delete</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>");
$templateCache.put("app/main/structure-area/area-sales/area-sales.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Struktur Area - Area Sales</span></md-subheader><div class=\"white-bg\"><md-toolbar \nng-include=\"\'app/main/structure-area/area-sales/area-sales-toolbar.html\'\"></md-toolbar><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\" \nng-include=\"\'app/main/structure-area/area-sales/area-sales-table.html\'\"></md-content></div></div></md-content></div>");
$templateCache.put("app/main/structure-area/area-sales-status/area-sales-status-add.html","<md-dialog aria-label=\"Form Add Area Sales Status\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack \nname=\"frmAddAreaSalesStatus\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmAddAreaSalesStatus)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Add Area Sales Status</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nflex><input type=\"text\" name=\"parent\" ng-model=\"vm.Form.objForm.parent\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.Form.objForm.area_status\" \nng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.area_status)\" name=\"area_status\" required><md-option \nng-repeat=\"ls in vm.areaStatusLists\" placeholder=\"Area Status\" value=\"{{ls.value}}\">{{ls.name}}</md-option></md-select>\n<div ng-messages=\"frmAddAreaSalesStatus.area_status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nArea status field is required.</span></div></div></md-input-container><md-input-container flex class=\"mt-20\">\n<md-datepicker name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" md-hide-icons=\"calendar\" \nplaceholder=\"Effective Date\" required></md-datepicker><div ng-messages=\"frmAddAreaSalesStatus.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.Form.objForm.area_sales_id\" name=\"area_sales_id\" required><md-option \nng-repeat=\"ls in vm.areaSalesLists\" placeholder=\"Area Sales\" value=\"{{ls.id}}\">{{ls.code_area}} - {{ls.description}}\n</md-option></md-select><div ng-messages=\"frmAddAreaSalesStatus.area_sales_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Area sales field is required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddAreaSalesStatus.$invalid || frmAddAreaSalesStatus.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/structure-area/area-sales-status/area-sales-status-edit.html","<md-dialog aria-label=\"Form Edit Area Sales Status\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack \nname=\"frmEditAreaSales\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmEditAreaSales)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Edit Area Sales Status</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><table><tr><td><b>\nArea Sales</b></td><td>:</td><td><b>{{vm.data.code_area}}, {{vm.data.description}}</b></td></tr><tr><td>Cabang Sales\n</td><td>:</td><td>{{vm.data.cabang_sales_description}}</td></tr><tr><td>Regional Sales</td><td>:</td><td>\n{{vm.data.regional_sales_description}}</td></tr><tr><td>Wilayah Sales</td><td>:</td><td>\n{{vm.data.wilayah_sales_description}}</td></tr></table><md-input-container flex class=\"mt-20\"><md-select \nng-model=\"vm.Form.objForm.area_status\" name=\"area_status\" required><md-option ng-repeat=\"ls in vm.areaStatusLists\" \nplaceholder=\"Area Status\" value=\"{{ls.value}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmEditAreaSalesStatus.area_status.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nArea status field is required.</span></div></div></md-input-container><md-input-container flex class=\"mt-20\">\n<md-datepicker name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" md-hide-icons=\"calendar\" \nplaceholder=\"Effective Date\" md-min-date=\"vm.data.minDate\" md-max-date=\"vm.data.maxDate\" required></md-datepicker><div \nng-messages=\"frmEditAreaSalesStatus.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditAreaSales.$invalid || frmEditAreaSales.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/structure-area/area-sales-status/area-sales-status-table.html","<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"3\" \nstyle=\"min-width: 50px\">NO</th><th rowspan=\"3\">GRBM</th><th rowspan=\"3\">RBM</th><th rowspan=\"3\">BM</th><th rowspan=\"3\">\nCODE</th><th rowspan=\"3\">AREA</th><th rowspan=\"3\">TYPE</th><th rowspan=\"3\">TGL LIVE</th><th colspan=\"25\">STATUS</th><th\n rowspan=\"3\" width=\"min-width: 50px;\">#</th></tr><tr><th colspan=\"1\">2018</th><th colspan=\"12\">2019</th><th \ncolspan=\"12\">2020</th></tr><tr><th>DEC</th><th>JAN</th><th>FEB</th><th>MAR</th><th>APR</th><th>MAY</th><th>JUN</th><th>\nJUL</th><th>AUG</th><th>SEP</th><th>OCT</th><th>NOV</th><th>DESC</th><th>JAN</th><th>FEB</th><th>MAR</th><th>APR</th>\n<th>MAY</th><th>JUN</th><th>JUL</th><th>AUG</th><th>SEP</th><th>OCT</th><th>NOV</th><th>DESC</th></tr></thead><tbody>\n<tr ng-repeat=\"ls in vm.DataTable.list\"><td \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\">{{($index + 1)}}</td>\n<td>{{ls.wilayah_sales_description}}</td><td>{{ls.regional_sales_description}}</td><td>{{ls.cabang_sales_description}}\n</td><td class=\"text-center\">{{ls.code_area}}</td><td>{{ls.description}}</td><td class=\"text-center\">{{ls.sales_type}}\n</td><td class=\"text-center\">{{ls.effective_date}}</td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2018\', \'12\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2018-12\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2018-12\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'01\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-01\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-01\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'02\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-02\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-02\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'03\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-03\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-03\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'04\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-04\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-04\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'05\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-05\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-05\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'06\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-06\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-06\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'07\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-07\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-07\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'08\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-08\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-08\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'09\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-09\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-09\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'10\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-10\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-10\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'11\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-11\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-11\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2019\', \'12\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2019-12\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2019-12\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'01\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-01\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-01\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'02\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-02\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-02\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'03\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-03\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-03\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'04\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-04\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-04\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'05\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-05\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-05\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'06\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-06\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-06\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'07\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-07\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-07\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'08\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-08\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-08\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'09\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-09\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-09\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'10\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-10\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-10\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'11\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-11\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-11\'][0].area_status}}</span></a></td><td class=\"text-center\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.setStatus($event, ls, \'2020\', \'12\')\" style=\"text-decoration: none\"><span \nng-if=\"!ls.status[\'2020-12\'][0].area_status\" class=\"icon-border-color\"></span> <span ng-if=\"ls.status\">\n{{ls.status[\'2020-12\'][0].area_status}}</span></a></td><td class=\"text-center\" \nstyle=\"white-space: nowrap; min-width: 50px; max-width: 50px; width: 50px\"></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"21\" class=\"text-center\"><span>No Data Available</span></td></tr>\n</tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/structure-area/area-sales-status/area-sales-status-toolbar.html","<div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container flex><md-select \nng-model=\"vm.wilayahSales\" ng-change=\"vm.changeWilayah(vm.wilayahSales)\" name=\"wilayah_sales\" \nplaceholder=\"Wilayah Sales\" aria-label=\"Wilayah Sales\"><md-option value=\"\" ng-selected=\"true\">-- Wilayah Sales\n</md-option><md-option ng-repeat=\"ls in vm.wilayahSalesLists\" value=\"{{ls.id}}\">\n{{ls.code_wilayah + \' - \' + ls.description}}</md-option></md-select></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container flex><md-select \nng-model=\"vm.regionalSales\" ng-change=\"vm.changeRegional(vm.regionalSales)\" name=\"regional_sales\" \nplaceholder=\"Regional Sales\" aria-label=\"Regional Sales\"><md-option value=\"\" ng-selected=\"true\">-- Regional Sales\n</md-option><md-option ng-repeat=\"ls in vm.regionalSalesLists\" value=\"{{ls.id}}\">\n{{ls.code_region + \' - \' + ls.description}}</md-option></md-select></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container flex><md-select \nng-model=\"vm.cabangSales\" ng-change=\"vm.loadData(1)\" name=\"regional_sales\" placeholder=\"Cabang Sales\" \naria-label=\"Cabang Sales\"><md-option value=\"\" ng-selected=\"true\">-- Cabang Sales</md-option><md-option \nng-repeat=\"ls in vm.cabangSalesLists\" value=\"{{ls.id}}\">{{ls.code_cabang + \' - \' + ls.description}}</md-option>\n</md-select></md-input-container><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>");
$templateCache.put("app/main/structure-area/area-sales-status/area-sales-status.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Struktur Area - Area Sales Status</span></md-subheader><div class=\"white-bg\"><md-toolbar \nng-include=\"\'app/main/structure-area/area-sales-status/area-sales-status-toolbar.html\'\"></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\" \nng-include=\"\'app/main/structure-area/area-sales-status/area-sales-status-table.html\'\"></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/structure-area/cabang-sales/cabang-sales-add.html","<md-dialog aria-label=\"Form Add Cabang Sales\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"frmAddCabangSales\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddCabangSales)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Add Cabang Sales</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"code_cabang\" \nng-model=\"vm.Form.objForm.code_cabang\" placeholder=\"Code Cabang\" required><div \nng-messages=\"frmAddCabangSales.code_cabang.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCode cabang is required.</span></div></div></md-input-container><md-input-container flex><textarea name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" rows=\"3\" required></textarea><div \nng-messages=\"frmAddCabangSales.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.regional_sales_id\" ng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.regional_sales_id)\" \nname=\"regional_sales_id\" required><md-option ng-repeat=\"ls in vm.regionalSalesLists\" placeholder=\"Regional Sales\" \nvalue=\"{{ls.id}}\">{{ls.code_region}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"frmAddCabangSales.regional_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRegional sales field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddCabangSales.$invalid || frmAddCabangSales.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/structure-area/cabang-sales/cabang-sales-edit.html","<md-dialog aria-label=\"Form Edit Cabang Sales\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"frmEditCabangSales\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmEditCabangSales)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Edit Cabang Sales</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"code_cabang\" \nng-model=\"vm.Form.objForm.code_cabang\" placeholder=\"Code Cabang\" required><div \nng-messages=\"frmEditCabangSales.code_cabang.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCode cabang is required.</span></div></div></md-input-container><md-input-container flex><textarea name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" rows=\"3\" required></textarea><div \nng-messages=\"frmEditCabangSales.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.regional_sales_id\" ng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.regional_sales_id)\" \nname=\"regional_sales_id\" required><md-option ng-repeat=\"ls in vm.regionalSalesLists\" placeholder=\"Regional Sales\" \nvalue=\"{{ls.id}}\">{{ls.code_region}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"frmEditCabangSales.regional_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRegional sales field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditCabangSales.$invalid || frmEditCabangSales.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/structure-area/cabang-sales/cabang-sales-table.html","<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th style=\"min-width: 50px\"></th>\n<th width=\"10%\">CODE</th><th width=\"50%\" class=\"text-center\">DESCRIPTION</th><th width=\"30%\">REGIONAL SALES</th><th \nwidth=\"min-width: 50px;\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ls.code_cabang}}</td>\n<td>{{ls.description}}</td><td class=\"text-center\">{{ls.regional_sales_description}}</td><td class=\"text-center\" \nstyle=\"white-space: nowrap; min-width: 50px; max-width: 50px; width: 50px\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.edit($event, ls)\" style=\"text-decoration: none\"><span class=\"icon-pencil\"></span></a></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"5\" class=\"text-center\"><span>No Data Available\n</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/structure-area/cabang-sales/cabang-sales-toolbar.html","<div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container flex><md-select \nng-model=\"vm.regionalSales\" ng-change=\"vm.loadData(1)\" name=\"regional_sales\" aria-label=\"Regional Sales\"><md-option \nvalue=\"\">-- Regional Sales</md-option><md-option ng-repeat=\"ls in vm.regionalSalesLists\" value=\"{{ls.id}}\">\n{{ls.code_region + \' - \' + ls.description}}</md-option></md-select></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputBusinesstrip($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.NEW\">New</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span translate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.DELETE\">Delete</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.add($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New\n</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span translate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.NEW\">New</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Delete</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>");
$templateCache.put("app/main/structure-area/cabang-sales/cabang-sales.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Struktur Area - Cabang Sales</span></md-subheader><div class=\"white-bg\"><md-toolbar \nng-include=\"\'app/main/structure-area/cabang-sales/cabang-sales-toolbar.html\'\"></md-toolbar><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\" \nng-include=\"\'app/main/structure-area/cabang-sales/cabang-sales-table.html\'\"></md-content></div></div></md-content>\n</div>");
$templateCache.put("app/main/structure-area/emp-area-sales/emp-area-sales-add.html","<md-dialog aria-label=\"Form Add Emp Area Sales\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"frmAddAreaSales\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddAreaSales)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"KPI.LABEL.AREASALESFORM\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><md-label><span translate=\"KPI.LABEL.KARYAWAN\"></span>\n</md-label><md-autocomplete class=\"mt-10\" style=\"border-bottom: 1px solid #ccc\" flex flex-gt-sm \nmd-selected-item=\"vm.selectedEmployee\" md-search-text=\"vm.keywordsEmployee\" \nmd-items=\"item in vm.lookupEmployees(vm.keywordsEmployee)\" md-item-text=\"item.nik + \', \' + item.fullname\" \nmd-input-name=\"vm.Form.objForm.nik\"><md-item-template><span md-highlight-text=\"vm.keywordsEmployee\">\n{{item.nik}}, ({{item.fullname}})</span></md-item-template><md-not-found>\nNo Employee matching \"{{vm.keywordsEmployee}}\" were found.</md-not-found></md-autocomplete>{{vm.Form.objForm.nik}}\n</md-input-container><md-input-container flex class=\"mt-20\"><md-label><span translate=\"KPI.LABEL.AREA\"></span>\n</md-label><md-select ng-model=\"vm.Form.objForm.area_sales_id\" md-on-close=\"vm.clearSearchAreaSales()\" \nng-change=\"vm.selectedAreaSales(vm.Form.objForm.area_sales_id)\" name=\"area_sales_id\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchAreaSales\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.areaSalesLists\"><md-option ng-repeat=\"ls in vm.areaSalesLists | filter:vm.searchAreaSales\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.code_area}} - {{ls.description}}<table style=\"font-size: x-small; color: #424242\"><tr><td><span \ntranslate=\"KPI.LABEL.HOMEBASE\"></span></td><td>:</td><td>{{ls.sub_area_description}}</td></tr><tr><td><span \ntranslate=\"KPI.LABEL.SALESTYPE\"></span></td><td>:</td><td>{{ls.sales_type}}</td></tr><tr><td><span \ntranslate=\"KPI.LABEL.BRANCH\"></span></td><td>:</td><td>{{ls.cabang_sales_description}}</td></tr><tr><td><span \ntranslate=\"KPI.LABEL.REGION\"></span></td><td>:</td><td>{{ls.regional_sales_description}}</td></tr><tr><td><span \ntranslate=\"KPI.LABEL.TERRITORY\"></span></td><td>:</td><td>{{ls.wilayah_sales_description}}</td></tr></table>\n</md-option></md-optgroup></md-select><div ng-messages=\"frmAddAreaSales.area_sales_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Cabang sales field is required.</span></div></div></md-input-container><md-input-container \nflex class=\"mt-20\"><md-label><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></md-label><md-datepicker \nname=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" md-hide-icons=\"calendar\" required></md-datepicker><div \nng-messages=\"frmAddAreaSales.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span> <span translate=\"PAYROLL.MENU.ISREQUIRED\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddAreaSales.$invalid || frmAddAreaSales.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/structure-area/emp-area-sales/emp-area-sales-edit.html","<md-dialog aria-label=\"Form Edit Emp Area Sales\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack \nname=\"frmEditEmpAreaSales\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmEditEmpAreaSales)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Edit Emp Area Sales</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nflex><input type=\"text\" name=\"nik\" ng-model=\"vm.Form.objForm.nik\" placeholder=\"Employee\" required><div \nng-messages=\"frmEditEmpAreaSales.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee is required.</span>\n</div></div></md-input-container><md-input-container flex class=\"mt-20\"><md-label>Area Sales</md-label><md-select \nng-model=\"vm.Form.objForm.sub_area_id\" md-on-close=\"vm.clearSearchAreaSales()\" \nng-change=\"vm.selectedAreaSales(vm.Form.objForm.sub_area_id)\" name=\"sub_area_id\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchAreaSales\" type=\"search\" class=\"md-text\"></md-select-header>\n<md-optgroup label=\"vm.areaSalesLists\"><md-option ng-repeat=\"ls in vm.areaSalesLists | filter:vm.searchAreaSales\" \nvalue=\"{{ls.sub_area_id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.code_area}} - {{ls.description}}<table style=\"font-size: x-small; color: #424242\"><tr><td>Home Base</td><td>:</td>\n<td>{{ls.sub_area_description}}</td></tr><tr><td>Sales Type</td><td>:</td><td>{{ls.sales_type}}</td></tr><tr><td>Cabang\n</td><td>:</td><td>{{ls.cabang_sales_description}}</td></tr><tr><td>Regional</td><td>:</td><td>\n{{ls.regional_sales_description}}</td></tr><tr><td>Wilayah</td><td>:</td><td>{{ls.wilayah_sales_description}}</td></tr>\n</table></md-option></md-optgroup></md-select><div ng-messages=\"frmEditEmpAreaSales.area_sales_id.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Cabang sales field is required.</span></div></div></md-input-container>\n<md-input-container flex class=\"mt-20\"><md-datepicker name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" \nmd-hide-icons=\"calendar\" placeholder=\"Effective Date\" required></md-datepicker><div \nng-messages=\"frmEditEmpAreaSales.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffectife Date is required.</span></div></div></md-input-container><div style=\"height: 20px\"></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditEmpAreaSales.$invalid || frmEditEmpAreaSales.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/structure-area/emp-area-sales/emp-area-sales-import.html","<md-dialog aria-label=\"Form Upload Excel File\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload Employee Area Sales</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div class=\"text-right\" flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload File</span></md-whiteframe></md-content><div \nclass=\"mt-10\"><a class=\"blue-700-fg\" href=\"{{vm.downloadTemplateURL}}\" download=\"template_import_emp_area_sales.xlsx\" \ntarget=\"_blank\">Download Template</a></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/structure-area/emp-area-sales/emp-area-sales-table.html","<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th style=\"min-width: 50px\"></th>\n<th>NIK</th><th>EMPLOYEE NAME</th><th>WILAYAH SALES</th><th>CABANG SALES</th><th>REGIONAL SALES</th><th>AREA SALES</th>\n<th>HOME BASE</th><th>TYPE</th><th class=\"text-center\">EFFECTIVE DATE</th><th width=\"min-width: 50px;\">#</th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ls.nik}}</td><td>\n{{ls.fullname}}</td><td class=\"text-center\">{{ls.wilayah_sales_description}}</td><td>{{ls.regional_sales_description}}\n</td><td>{{ls.cabang_sales_description}}</td><td>{{ls.area_sales_description}}</td><td>\n{{ls.emp_personal_sub_area[0].description}}</td><td class=\"text-center\">{{ls.sales_type}}</td><td class=\"text-center\">\n{{ls.effective_date | date:\'dd/MM/yyyy\'}}</td><td class=\"text-center\" \nstyle=\"white-space: nowrap; min-width: 50px; max-width: 50px; width: 50px\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.edit($event, ls)\" style=\"text-decoration: none\"><span class=\"icon-pencil\"></span></a></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"9\" class=\"text-center\"><span>No Data Available\n</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/structure-area/emp-area-sales/emp-area-sales-toolbar.html","<div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container flex>\n<md-select ng-model=\"vm.wilayahSales\" ng-change=\"vm.loadData(1)\" name=\"wilayah_sales\" aria-label=\"Wilayah Sales\">\n<md-option value=\"\" selected=\"selected\">-- <span translate=\"KPI.LABEL.TERRITORY\"></span></md-option><md-option \nng-repeat=\"ls in vm.wilayahSalesLists\" value=\"{{ls.id}}\">{{ls.code_wilayah + \' - \' + ls.description}}</md-option>\n</md-select></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-input-container flex><md-select ng-model=\"vm.regionalSales\" ng-change=\"vm.loadData(1)\" name=\"regional_sales\" \naria-label=\"Regional Sales\"><md-option value=\"\" selected=\"selected\">-- <span translate=\"KPI.LABEL.REGION\"></span>\n</md-option><md-option ng-repeat=\"ls in vm.regionalSalesLists\" value=\"{{ls.id}}\">\n{{ls.code_region + \' - \' + ls.description}}</md-option></md-select></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container flex><md-select \nng-model=\"vm.cabangSales\" ng-change=\"vm.loadData(1)\" name=\"cabang_sales\" aria-label=\"Cabang Sales\"><md-option value=\"\" \nselected=\"selected\">-- <span translate=\"KPI.LABEL.BRANCH\"></span></md-option><md-option \nng-repeat=\"ls in vm.cabangSalesLists\" value=\"{{ls.id}}\">{{ls.code_cabang + \' - \' + ls.description}}</md-option>\n</md-select></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div>\n<md-input-container flex><md-select ng-model=\"vm.areaSales\" ng-change=\"vm.loadData(1)\" name=\"area_sales\" \naria-label=\"Area Sales\"><md-option value=\"\" selected=\"selected\">-- <span translate=\"KPI.LABEL.AREA\"></span></md-option>\n<md-option ng-repeat=\"ls in vm.areaSalesLists\" value=\"{{ls.id}}\">{{ls.code_area + \' - \' + ls.description}}</md-option>\n</md-select></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.InputBusinesstrip($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"UMUT.MENU.NEW\">New</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span translate=\"KPI.LABEL.DELETE\">Delete</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.add($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"UMUT.MENU.NEW\">\nNew</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span translate=\"UMUT.MENU.NEW\">New</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-button class=\"md-warn md-mini\" hide show-gt-sm aria-label=\"Delete\" ng-click=\"vm.remove($event)\" \ntype=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.DELETE\">Delete\n</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon><span \ntranslate=\"KPI.LABEL.DELETE\">Delete</span></md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm>\n</div><md-button class=\"blue-600-fg md-mini\" hide show-gt-sm aria-label=\"Import\" ng-click=\"vm.importExcel($event)\" \ntype=\"button\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Import</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-import material-icons blue-600-fg\"></md-icon><span \ntranslate=\"KPI.LABEL.IMPORT\">Import</span></md-button><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>");
$templateCache.put("app/main/structure-area/emp-area-sales/emp-area-sales.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"KPI.LABEL.STRUCTUREAREASALES\">Struktur Area - Emp Area Sales</span></md-subheader>\n<div class=\"white-bg\"><md-toolbar ng-include=\"\'app/main/structure-area/emp-area-sales/emp-area-sales-toolbar.html\'\">\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" \nng-include=\"\'app/main/structure-area/emp-area-sales/emp-area-sales-table.html\'\"></md-content></div></div></md-content>\n</div>");
$templateCache.put("app/main/structure-area/regional-sales/regional-sales-add.html","<md-dialog aria-label=\"Form Add Regional Sales\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack \nname=\"frmAddRegionalSales\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmAddRegionalSales)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Add Regional Sales</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nflex><input type=\"text\" name=\"code_region\" ng-model=\"vm.Form.objForm.code_region\" placeholder=\"Code Regional\" required>\n<div ng-messages=\"frmAddRegionalSales.code_region.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCode region is required.</span></div></div></md-input-container><md-input-container flex><textarea name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" rows=\"3\" required></textarea><div \nng-messages=\"frmAddRegionalSales.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.wilayah_sales_id\" ng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.wilayah_sales_id)\" \nname=\"wilayah_sales_id\" required><md-option ng-repeat=\"ls in vm.wilayahSalesLists\" placeholder=\"Wilayah Sales\" \nvalue=\"{{ls.id}}\">{{ls.code_wilayah}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"frmAddRegionalSales.wilayah_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWilayah sales field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddRegionalSales.$invalid || frmAddRegionalSales.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/structure-area/regional-sales/regional-sales-edit.html","<md-dialog aria-label=\"Form Edit Regional Sales\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack \nname=\"frmEditRegionalSales\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmEditRegionalSales)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Edit Regional Sales</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nflex><input type=\"text\" name=\"code_region\" ng-model=\"vm.Form.objForm.code_region\" placeholder=\"Code Regional\" required>\n<div ng-messages=\"frmEditRegionalSales.code_region.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCode region is required.</span></div></div></md-input-container><md-input-container flex><textarea name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" rows=\"3\" required></textarea><div \nng-messages=\"frmEditRegionalSales.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.wilayah_sales_id\" ng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.wilayah_sales_id)\" \nname=\"wilayah_sales_id\" required><md-option ng-repeat=\"ls in vm.wilayahSalesLists\" placeholder=\"Wilayah Sales\" \nvalue=\"{{ls.id}}\">{{ls.code_wilayah}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"frmEditRegionalSales.wilayah_sales_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWilayah sales field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditRegionalSales.$invalid || frmEditRegionalSales.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/structure-area/regional-sales/regional-sales-table.html","<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th style=\"min-width: 50px\"></th>\n<th width=\"10%\">CODE</th><th width=\"50%\" class=\"text-center\">DESCRIPTION</th><th width=\"30%\">WILAYAH SALES</th><th \nwidth=\"min-width: 50px;\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nstyle=\"min-width: 50px; max-width: 50px; width: 50px; text-align: center; white-space: nowrap\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td class=\"text-center\">{{ls.code_region}}</td>\n<td>{{ls.description}}</td><td class=\"text-center\">{{ls.wilayah_sales_description}}</td><td class=\"text-center\" \nstyle=\"white-space: nowrap; min-width: 50px; max-width: 50px; width: 50px\"><a href=\"javasccript:void(0);\" \nng-click=\"vm.edit($event, ls)\" style=\"text-decoration: none\"><span class=\"icon-pencil\"></span></a></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"5\" class=\"text-center\"><span>No Data Available\n</span></td></tr></tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/structure-area/regional-sales/regional-sales-toolbar.html","<div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container flex><md-select \nng-model=\"vm.wilayahSales\" ng-change=\"vm.loadData(1)\" name=\"wilayah_sales\" aria-label=\"Wilayah Sales\"><md-option \nvalue=\"\">-- Wilayah Sales</md-option><md-option ng-repeat=\"ls in vm.wilayahSalesLists\" value=\"{{ls.id}}\">\n{{ls.code_wilayah + \' - \' + ls.description}}</md-option></md-select></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.InputBusinesstrip($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.NEW\">New</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span translate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.DELETE\">Delete</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.add($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New\n</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span translate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.NEW\">New</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Delete</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>");
$templateCache.put("app/main/structure-area/regional-sales/regional-sales.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Struktur Area - Regional Sales</span></md-subheader><div class=\"white-bg\"><md-toolbar \nng-include=\"\'app/main/structure-area/regional-sales/regional-sales-toolbar.html\'\"></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\" \nng-include=\"\'app/main/structure-area/regional-sales/regional-sales-table.html\'\"></md-content></div></div></md-content>\n</div>");
$templateCache.put("app/main/structure-area/wilayah-sales/wilayah-sales-add.html","<md-dialog aria-label=\"Form Add Wilayah Sales\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack name=\"frmAddWilayahSales\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddWilayahSales)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Add Wilayah Sales</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"code_wilayah\" \nng-model=\"vm.Form.objForm.code_wilayah\" placeholder=\"Code Wilayah\" required><div \nng-messages=\"frmAddWilayahSales.code_wilayah.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCode wilayah is required.</span></div></div></md-input-container><md-input-container flex><textarea name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" rows=\"3\" required></textarea><div \nng-messages=\"frmAddWilayahSales.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.group_wilayah\" ng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.group_wilayah)\" \nname=\"group_wilayah\" required><md-option ng-repeat=\"ls in vm.groupWilayahLists\" placeholder=\"Group Wilayah\" \nvalue=\"{{ls.value}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"frmAddWilayahSales.group_wilayah.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Group wilayah field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.Form.objForm.sales_type\" \nng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.sales_type)\" name=\"sales_type\" required><md-option \nng-repeat=\"ls in vm.salesTypeLists\" placeholder=\"Sales Type\" value=\"{{ls.value}}\">{{ls.name}}</md-option></md-select>\n<div ng-messages=\"frmAddWilayahSales.sales_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSales type field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddWilayahSales.$invalid || frmAddWilayahSales.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/structure-area/wilayah-sales/wilayah-sales-edit.html","<md-dialog aria-label=\"Form Edit Wilayah Sales\" flex-md=\"50\" flex-gt-md=\"30\"><form ng-cloack \nname=\"frmEditWilayahSales\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmEditWilayahSales)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Edit Wilayah Sales</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container \nflex><input type=\"text\" name=\"code_wilayah\" ng-model=\"vm.Form.objForm.code_wilayah\" placeholder=\"Code Wilayah\" \nrequired><div ng-messages=\"frmEditWilayahSales.code_wilayah.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCode wilayah is required.</span></div></div></md-input-container><md-input-container flex><textarea name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" rows=\"3\" required></textarea><div \nng-messages=\"frmEditWilayahSales.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.group_wilayah\" ng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.group_wilayah)\" \nname=\"group_wilayah\" required><md-option ng-repeat=\"ls in vm.groupWilayahLists\" placeholder=\"Group Wilayah\" \nvalue=\"{{ls.value}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"frmEditWilayahSales.group_wilayah.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Group wilayah field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.Form.objForm.sales_type\" \nng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.sales_type)\" name=\"sales_type\" required><md-option \nng-repeat=\"ls in vm.salesTypeLists\" placeholder=\"Sales Type\" value=\"{{ls.value}}\">{{ls.name}}</md-option></md-select>\n<div ng-messages=\"frmEditWilayahSales.sales_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSales type field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmEditWilayahSales.$invalid || frmEditWilayahSales.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/structure-area/wilayah-sales/wilayah-sales-table.html","<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th style=\"min-width: 50px\"></th>\n<th width=\"10%\">CODE</th><th width=\"40%\" class=\"text-center\">DESCRIPTION</th><th width=\"25%\">GROUP</th><th width=\"25%\">\nSALES TYPE</th><th ng-if=\"vm.isAdmin\" width=\"25%\">BUSINESS UNIT</th><th ng-if=\"vm.isAdmin\" width=\"25%\">COUNTRY</th><th \nwidth=\"min-width: 50px;\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nstyle=\"min-width: 50px; text-align: center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" \nng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\">\n</md-checkbox></td><td class=\"text-center\">{{ls.code_wilayah}}</td><td>{{ls.description}}</td><td class=\"text-center\">\n{{ls.group_wilayah}}</td><td class=\"text-center\">{{ls.sales_type}}</td><td ng-if=\"vm.isAdmin\" class=\"text-center\">\n{{ls.country_code}}</td><td ng-if=\"vm.isAdmin\" class=\"text-center\">{{ls.bu}}</td><td class=\"text-center\" \nstyle=\"white-space: nowrap\"><a href=\"javasccript:void(0);\" ng-click=\"vm.edit($event, ls)\" \nstyle=\"text-decoration: none\"><span class=\"icon-pencil\"></span></a></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"8\" class=\"text-center\"><span>No Data Available</span></td></tr>\n</tbody></table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/structure-area/wilayah-sales/wilayah-sales-toolbar.html","<div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-input-container ng-if=\"vm.isAdmin\" flex><md-select \nng-model=\"vm.country\" ng-change=\"vm.loadData(1)\" name=\"country\" aria-label=\"Country\"><md-option \nng-repeat=\"ls in vm.countryLists\" value=\"{{ls.value}}\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.bu\" ng-change=\"vm.loadData(1)\" name=\"business_unit\" \naria-label=\"Business Unit\"><md-option ng-repeat=\"ls in vm.businessUnitLists\" value=\"{{ls.value}}\">{{ls.name}}\n</md-option></md-select></md-input-container><md-input-container flex><md-select ng-model=\"vm.groupWilayah\" \nng-change=\"vm.loadData(1)\" name=\"group_wilayah\" aria-label=\"Group Wilayah\"><md-option \nng-repeat=\"ls in vm.groupWilayahLists\" value=\"{{ls.value}}\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.salesType\" ng-change=\"vm.loadData(1)\" name=\"sales_type\" \naria-label=\"Sales Type\"><md-option ng-repeat=\"ls in vm.salesTypeLists\" value=\"{{ls.value}}\">{{ls.name}}</md-option>\n</md-select></md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-mini\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.InputBusinesstrip($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.NEW\">New</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"set bu kpi\" ng-click=\"vm.deleteData()\"><i \nclass=\"icon-delete\"></i> <span translate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.DELETE\">Delete</span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.add($event)\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>New\n</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span translate=\"MENU.CB.BUSINESS_TRIP.INDEX.ACTION.NEW\">New</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.remove($event)\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Delete</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div>");
$templateCache.put("app/main/structure-area/wilayah-sales/wilayah-sales.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Struktur Area - Wilayah Sales</span></md-subheader><div class=\"white-bg\"><md-toolbar \nng-include=\"\'app/main/structure-area/wilayah-sales/wilayah-sales-toolbar.html\'\"></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\" \nng-include=\"\'app/main/structure-area/wilayah-sales/wilayah-sales-table.html\'\"></md-content></div></div></md-content>\n</div>");
$templateCache.put("app/main/tiket/tiket/tiket-input.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmBT\" ng-submit=\"vm.saveData($event, frmBT)\" novalidate flex><md-toolbar\n class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>E-Ticket Form</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div \nlayout=\"row\"><md-input-container flex><label>Target Department</label><md-select \nng-model=\"vm.Form.objForm.target_department_id\" \nng-change=\"vm.loadTiketDepartmentService(vm.Form.objForm.target_department_id)\" name=\"target_department_id\" required>\n<md-option ng-repeat=\"ls in vm.targetDepartmentList\" value=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div\n ng-messages=\"frmBT.target_department_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTarget department is required.</span></div></div></md-input-container><md-input-container flex><label>Services</label>\n<md-select ng-model=\"vm.Form.objForm.service_id\" name=\"service_id\" required><md-option \nng-repeat=\"ls in vm.targetDepartmentServiceList\" value=\"{{ls.id}}\" required>{{ls.name}}</md-option></md-select><div \nng-messages=\"frmBT.service_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Services is required.</span></div>\n</div></md-input-container></div><label class=\"text-grey\">Deliverable *</label><div layout=\"row\"><md-input-container \nflex flex-gt-sm><div style=\"padding: 7px\"><textarea rows=\"7\" ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.Form.objForm.deliverable\" ng-required=\"true\"></textarea></div><div ng-messages=\"frmBT.deliverable.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Deliverable field is required.</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"30\"><label>Request Finish</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"target_finish\" ng-model=\"vm.Form.objForm.target_finish\" required flex=\"30\">\n</md-datepicker><div ng-messages=\"SalcomForm.target_finish.$error\" role=\"alert\"><div ng-message=\"required\"><span>\ntarget_finish Date is required.</span></div></div></md-input-container><label \nstyle=\"margin-left: 20px;margin-top:15px\" class=\"text-grey\" flex=\"10\">Priority *</label><md-input-container flex=\"30\">\n<md-radio-group style=\"margin-top:5px\" ng-model=\"vm.Form.objForm.priority\" name=\"priority\" layout=\"row\" required>\n<md-radio-button ng-repeat=\"ls in vm.priority\" ng-value=\"ls.value\"><span class=\"{{ls.class}}\">{{ls.name}}</span>\n</md-radio-button></md-radio-group><div ng-messages=\"frmBT.priority.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Priority is required.</span></div></div></md-input-container></div><label class=\"text-grey\">Note <span \nstyle=\"font-style: italic\">(if required)</span></label><div layout=\"row\"><md-input-container flex flex-gt-sm><div \nstyle=\"padding: 7px\"><textarea rows=\"7\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.Form.objForm.description\">\n</textarea></div><div ng-messages=\"frmBT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmBT.$invalid || frmBT.$pristine\" \ntranslate=\"ACTION.SUBMIT\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/tiket/tiket/tiket.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">E-Ticket</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<select style=\"font-size:14px\" hide show-gt-sm name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTables.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span hide show-gt-sm \nstyle=\"font-size:14px\" class=\"secondary-text\">&nbsp;Entries</span><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.addData($event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span>Create new</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple md-accent md-mini\" \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.selected.length == 0\" ng-click=\" vm.deleteData($event)\"><md-icon \nng-if=\"vm.selected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon ng-if=\"vm.selected.length == 0\" \nmd-font-icon=\"icon-trash grey-700-fg\"></md-icon><span ng-if=\"vm.selected.length > 0\" class=\"red-700-fg\">Delete</span> \n<span ng-if=\"vm.selected.length == 0\" class=\"grey-700-fg\">Delete</span> <span style=\"color:red\" \nng-if=\"vm.selected.length > 0\">{{ vm.selected.length }} selected</span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"\" ng-click=\"vm.addDataNews(ev)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\nCreate New</md-button></md-menu-item><md-menu-item><span><md-checkbox aria-label=\"Select All\" \nng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" ng-model=\"vm.checkall\">\n<span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></span></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"2%\"><span class=\"is-gear\">\n<md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th width=\"5%\"><span class=\"column-title\">NO</span></th><th \nclass=\"text-center\"><span class=\"column-title\">Target Department</span></th><th class=\"text-center\" width=\"20%\"><span \nclass=\"column-title\">Service</span></th><th class=\"text-center\"><span class=\"column-title\">Target Finish</span></th><th\n class=\"text-center\"><span class=\"column-title\">Priority</span></th><th class=\"text-center\"><span class=\"column-title\">\nApproval Status</span></th><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span>\n</th></tr></thead><tbody><tr class=\"md-table-content-row\" ng-repeat=\"item in vm.DataTables.list\"><td><md-checkbox \nng-if=\"item.approval_status!=\'Approved\'\" aria-label=\"empLaborChecked\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\"></md-checkbox></td><td class=\"text-center\">{{($index + 1)}}</td><td class=\"\">\n{{item.target_department}}</td><td class=\"\">{{item.service}}</td><td class=\"text-center\">{{item.target_finish}}</td><td\n class=\"text-center\"><span ng-if=\"item.priority==\'high\'\" class=\"priority-high\">{{item.priority}}</span> <span \nng-if=\"item.priority==\'middle\'\" class=\"priority-middle\">{{item.priority}}</span> <span ng-if=\"item.priority==\'low\'\" \nclass=\"priority-low\">{{item.priority}}</span></td><td class=\"\"><span ng-if=\"item.approval_status==\'Waiting Approval\'\">\n{{item.approval_status}}</span> <span ng-if=\"item.approval_status!=\'Waiting Approval\'\"><a href=\"\" \nng-click=\"vm.viewComment($event,item)\">{{item.approval_status}}<md-icon md-font-icon=\"icon-message\"></md-icon></a>\n<md-tooltip md-direction=\"top\">View Comment</md-tooltip></span></td><td class=\"text-center\"><section layout=\"row\" \nlayout-sm=\"column\" class=\"no-padding text-center\" layout-align=\"start center\" layout-wrap><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"emplabortypemenu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-if=\"item.approval_status!=\'Approved\'\" \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.editData($event, item)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-border-color\"></md-icon><p flex>edit</p></div></md-button><md-button \nng-disabled=\"vm.selected.length > 0\" ng-click=\"vm.viewDetail($event, item)\"><div layout=\"row\" flex><md-icon \nmd-menu-align-target md-font-icon=\"icon-eye\"></md-icon><p flex>Detail</p></div></md-button></md-menu-item>\n</md-menu-content></md-menu></section></td></tr><tr class=\"text-center\" ng-if=\"vm.DataTables.list.length <= 0\"><td \ncolspan=\"8\" class=\"text-center\"><span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody>\n</table><div ng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/tiket/tiket/view-detail.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"70\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Ticket Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout-padding flex><div layout=\"row\"><md-input-container flex><label>Target Department</label><input type=\"text\" \nng-model=\"vm.targetDepartment\" name=\"title\" ng-disabled=\"true\"></md-input-container><md-input-container flex><label>\nService</label><input type=\"text\" ng-model=\"vm.service\" name=\"title\" ng-disabled=\"true\"></md-input-container></div>\n<label class=\"text-grey\">Deliverable</label><div layout=\"row\"><fieldset><div class=\"text-grey\" \nng-bind-html=\"vm.deliverable\" class=\"alert-information\"></div></fieldset></div><div layout=\"row\"><md-input-container \nflex><label>Ticket Status</label><input type=\"text\" ng-model=\"vm.ticketStatus\" name=\"title\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex><label>Target Finish</label><md-datepicker ng-disabled=\"true\" \nmd-hide-icons=\"calendar\" name=\"target_finish\" ng-model=\"vm.targetFinish\"></md-datepicker></md-input-container>\n<md-input-container flex><label>Submit Date</label><md-datepicker ng-disabled=\"true\" md-hide-icons=\"calendar\" \nname=\"target_finish\" ng-model=\"vm.submitDate\"></md-datepicker></md-input-container></div><div layout=\"row\">\n<md-input-container flex flex-gt-sm><label>Approval Status</label><input type=\"text\" ng-model=\"vm.approvalStatus\" \nname=\"title\" ng-disabled=\"true\"></md-input-container><md-input-container flex flex-gt-sm><label>Approved / Rejected By\n</label><input type=\"text\" ng-model=\"vm.approvalBy\" name=\"title\" ng-disabled=\"true\"></md-input-container>\n<md-input-container flex=\"30\"><label>Approval Date</label><input type=\"text\" ng-model=\"vm.approvalDate\" name=\"title\" \nng-disabled=\"true\"></md-input-container><md-input-container flex flex-gt-sm><label>Priority</label><input type=\"text\" \nng-model=\"vm.priority\" name=\"title\" ng-disabled=\"true\"></md-input-container></div><label class=\"text-grey\">Note</label>\n<div layout=\"row\"><div ng-if=\"vm.description!=\'<p>-</p>\'\"><fieldset><div class=\"text-grey\" \nng-bind-html=\"vm.description\" class=\"alert-information\"></div></fieldset></div><div ng-if=\"vm.description==\'<p>-</p>\'\">\n<div class=\"text-grey\" ng-bind-html=\"vm.description\" class=\"alert-information\"></div></div></div><label \nclass=\"text-grey\">Approval Comment</label><div ng-if=\"!vm.isRequested\" layout=\"row\"><md-input-container flex \nflex-gt-sm><div style=\"padding: 7px\"><textarea rows=\"7\" ui-tinymce=\"vm.tinymceOptions\" ng-disabled=\"vm.isRequested\" \nng-model=\"vm.approvalComment\"></textarea></div></md-input-container></div><div ng-if=\"vm.isRequested\" layout=\"row\"><div\n ng-if=\"vm.approvalComment==\'<p>-</p>\'\"><div class=\"text-grey\" ng-bind-html=\"vm.approvalComment\" \nclass=\"alert-information\"></div></div><div ng-if=\"vm.approvalComment!=\'<p>-</p>\'\"><fieldset><div class=\"text-grey\" \nng-bind-html=\"vm.approvalComment\" class=\"alert-information\"></div></fieldset></div></div><span ng-if=\"vm.showAlert\" \nstyle=\"color:red\">Approval comment field is required!</span><div ng-if=\"!vm.isRequested\" class=\"container\"><md-button \nng-if=\"vm.approvalStatus==\'Waiting Approval\'\" type=\"button\" ng-click=\"vm.approved($event)\" \nclass=\"md-raised md-primary md-hue-2\" aria-label=\"submit\" ng-disabled=\"vm.isComplete\"><span translate=\"ACTION.APPROVE\">\nApprove</span></md-button><md-button ng-if=\"vm.approvalStatus==\'Waiting Approval\'\" type=\"button\" \nng-click=\"vm.rejected($event)\" class=\"md-raised md-warn md-hue-2\" aria-label=\"submit\" ng-disabled=\"vm.isComplete\"><span\n translate=\"ACTION.REJECT\">Reject</span></md-button><md-button ng-if=\"vm.approvalStatus==\'Approved\'\" type=\"button\" \nng-click=\"vm.UnApproved($event)\" class=\"md-raised md-primary md-hue-2\" aria-label=\"submit\" ng-disabled=\"vm.isComplete\">\n<span translate=\"ACTION.UNAPPROVE\">Un-Approve</span></md-button><md-button ng-if=\"vm.approvalStatus==\'Rejected\'\" \ntype=\"button\" ng-click=\"vm.UnReject($event)\" class=\"md-raised md-warn md-hue-2\" aria-label=\"submit\" \nng-disabled=\"vm.isComplete\"><span translate=\"ACTION.UNREJECT\">Un-Reject</span></md-button></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/pms/tutorial/tutorial-view.html","<div id=\"page_talent\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Tutorial</span></md-subheader><div class=\"white-bg\"><div class=\"content\"><div \nlayout-xs=\"column\" layout=\"row\"><div ng-if=\"vm.tutorial_type === \'video\'\" flex-xs flex-gt-xs=\"50\" layout=\"column\"><h3>\nTalent Management: Competency Review Nabati Group</h3><video class=\"tutorial\" controls=\"\" name=\"media\"><source \nsrc=\"{{vm.url}}\" type=\"video/mp4\">Your browser does not support the video tag.</video></div><div \nng-if=\"vm.tutorial_type === \'ebook\'\" flex-xs flex-gt-xs=\"100\" layout=\"column\"><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:80vh\" frameborder=\"0\"></iframe></div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/pms/tutorial/tutorial.html","<div id=\"page_talent\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\n<span>Tutorial</span></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\" style=\"background-color: #ffffff\"><div \nflex-xs flex-gt-xs=\"30\" layout=\"column\" ng-repeat=\"tutorial in vm.tutorialList\"><md-card \nmd-theme=\"{{ showDarkTheme ? \'dark-orange\' : \'default\' }}\" md-theme-watch><md-card-content layout=\"row\"><div class=\"\">\n<img ui-sref=\"app.pms_tutorial_view({tutorial_type: tutorial.type, url: tutorial.url})\" style=\"cursor: pointer\" \nng-src=\"{{\'assets/tutorial/\' + tutorial.cover}}\" alt=\"\"></div></md-card-content><md-card-title class=\"has-title-card\">\n<md-card-title-text style=\"cursor: pointer\"><a \nui-sref=\"app.pms_tutorial_view({tutorial_type: tutorial.type, url: tutorial.url})\"><span \nclass=\"title h3 ng-binding ng-scope\">{{tutorial.title}}</span></a></md-card-title-text></md-card-title><md-card-actions\n layout=\"row\" layout-align=\"end center\"><md-button class=\"md-green-300-bg md-raised md-primary white-fg\" \nui-sref=\"app.pms_tutorial_view({tutorial_type: tutorial.type, url: tutorial.url})\">View</md-button></md-card-actions>\n</md-card></div></md-content></md-content></div></div></md-content></div>");
$templateCache.put("app/main/tiket/tiket-approval/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Comment</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\"><div layout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container \nflex><input type=\"text\" name=\"comment\" ng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-bind-html=\" vm.getHtml(vm.Form.objForm.data.rejected_comment)\" \nng-if=\"vm.stateView\" class=\"alert-information\"></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p>\n</ms-widget-front></ms-widget><span flex></span><md-button ng-if=\"!vm.stateView\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/tiket/tiket-approval/tiket-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Ticket Approval</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formTicket\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"30\"><md-select ng-model=\"vm.type\" name=\"type\" required ng-change=\"vm.loadData(1)\"><md-option \nng-repeat=\"val in vm.listType\" placeholder=\"{{ \'MENU.CB.APPROVAL_GHK.INDEX.FILTER.APPROVAL_TYPE\' | translate }}\" \nvalue=\"{{val}}\">{{val | uppercase}}</md-option></md-select><div ng-messages=\"formTicket.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type field is required.</span></div></div></md-input-container><md-button \nclass=\"md-mini md-raised md-primary\" type=\"submit\" ng-disabled=\"formTicket.$invalid || formTicket.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div>\n</form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container\n hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"formTicket.$invalid || formTicket.$pristine\"></select><span \nclass=\"secondary-text\" translate=\"MENU.CB.APPROVAL_GHK.INDEX.TABLE.ENTRIES\">Entries</span></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadData(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th class=\"text-center\">No</th><th>\nNik/Name</th><th>Target Department</th><th>Service</th><th>Request Finish</th><th>Approval Status</th><th>Priority</th>\n<th>Action</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\"><span>{{$index+1}}\n</span></td><td class=\"text-center\">{{ls.nik}}/{{ls.name}}</td><td class=\"\">{{ls.target_department}}</td><td class=\"\">\n{{ls.service}}</td><td class=\"text-center\">{{ls.target_finish}}</td><td class=\"\"><span>{{ls.status}}</span></td><td \nclass=\"text-center\"><span ng-if=\"ls.priority==\'high\'\" class=\"priority-high\">{{ls.priority}}</span> <span \nng-if=\"ls.priority==\'middle\'\" class=\"priority-middle\">{{ls.priority}}</span> <span ng-if=\"ls.priority==\'low\'\" \nclass=\"priority-low\">{{ls.priority}}</span></td><td class=\"text-center\"><md-menu><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item><md-button ng-click=\"vm.viewDetail($event,ls)\" aria-label=\"Flip widget\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-eye\"></md-icon><span>Detail</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n<tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"9\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/travel/travel-managment/demo.html","<md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-button class=\"md-button md-ink-ripple\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Create New Itenerary\n</md-tooltip><md-icon md-font-icon=\"icon-plus-box\" class=\"md-font icon-archive material-icons\"></md-icon>\nCreate Itenerary</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Delete Request List</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button><div class=\"divider-vertical hide show-gt-sm\" \nhide show-gt-sm></div></div></md-toolbars><table class=\"simple stripped condensed\" ms-responsive-table flex><thead><tr>\n<th rowspan=\"2\" width=\"5%\"></th><th rowspan=\"2\">edit</th><th colspan=\"3\" width=\"25%\">from</th><th colspan=\"3\" \nwidth=\"25%\">to</th><th rowspan=\"2\">distance<div>in km</div></th><th rowspan=\"2\">travel<div>category</div></th><th \nrowspan=\"2\">type of<div>transport</div></th><th rowspan=\"2\">request<div>hotel</div></th><th rowspan=\"2\">cost<div>center\n</div></th><th rowspan=\"2\">status</th><th rowspan=\"2\">purpose</th></tr><tr><th>country</th><th>city</th><th>date</th>\n<th>country</th><th>city</th><th>date</th></tr></thead><tbody><tr><td><input type=\"checkbox\" \nchecklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td><section layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\" layout-wrap><md-button class=\"md-icon-button\" aria-label=\"Favorite\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.editData(ls.id)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"orange-500-fg\"></md-icon><md-tooltip><span>Edit</span></md-tooltip></md-button></section></td><td>Indonesia</td>\n<td>Bandung</td><td>01-Apr-18</td><td>Indonesia</td><td>Jakarta</td><td>01-Apr-18</td><td>198</td><td>Out Town</td><td>\nOwn Car</td><td></td><td>3210011</td><td>Waiting Approval</td><td></td></tr><tr><td><input type=\"checkbox\" \nchecklist-model=\"vm.listSelected\" checklist-value=\"ls\"></td><td><section layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\" layout-wrap><md-button class=\"md-icon-button\" aria-label=\"Favorite\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.editData(ls.id)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"orange-500-fg\"></md-icon><md-tooltip><span>Edit</span></md-tooltip></md-button></section></td><td>Indonesia</td>\n<td>Jakarta</td><td>05-Apr-18</td><td>Malaysia</td><td>Kuala Lumpur</td><td>07-Apr-18</td><td></td><td>Oversea</td><td>\nAir Plan</td><td>Yes</td><td><span style=\"color: red\">3210011</span></td><td>Waiting Approval</td><td></td></tr>\n</tbody></table>");
$templateCache.put("app/main/travel/travel-managment/travel-managment.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati3\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-airplane\"></md-icon></span><span class=\"md-subhead\">TRAVEL MANAGMENT\n</span></div></div><div layout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper md-blue-grey-50-bg\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-account-box-outline\" \\>\n</md-icon>Apply For: My Self</div><div class=\"card md-whiteframe-6dp\" flex><div layout=\"row\" class=\"mb-20\"><div \nlayout=\"column\" layout-gt-md=\"column\" flex=\"25\"><div class=\"md-subhead\"><strong>Employe Name</strong></div><div \nclass=\"info\">Jhon Doe</div></div><div layout=\"column\" layout-gt-md=\"column\" flex=\"25\"><div class=\"md-subhead\"><strong>\nBusiness Title</strong></div><div class=\"info\">Sales Manager</div></div><div layout=\"column\" layout-gt-md=\"column\" \nflex=\"25\"><div class=\"md-subhead\"><strong>Cost Center</strong></div><div class=\"info\">3210011</div></div><div \nlayout=\"column\" layout-gt-md=\"column\" flex=\"25\"><div class=\"md-subhead\"><strong>Ticket No</strong></div><div \nclass=\"info\">TR3091</div></div></div><div layout=\"row\" class=\"mb-20\"><div layout=\"column\" layout-gt-md=\"column\" \nflex=\"15\"><div class=\"md-subhead\"><strong>Local ID</strong></div><div class=\"info\">81810092</div></div><div \nlayout=\"column\" layout-gt-md=\"column\" flex=\"10\"><div class=\"md-subhead\"><strong>Grade</strong></div><div class=\"info\">\n5A</div></div><div layout=\"column\" layout-gt-md=\"column\" flex=\"25\"><div class=\"md-subhead\"><strong>Department</strong>\n</div><div class=\"info\">Sales & Distribution</div></div><div layout=\"column\" layout-gt-md=\"column\" flex=\"25\"><div \nclass=\"md-subhead\"><strong>Origin City</strong></div><div class=\"info\">Bandung</div></div></div><div layout=\"row\"><div \nlayout=\"column\" layout-gt-md=\"column\" flex=\"25\"><div class=\"md-subhead\"><strong>Global ID</strong></div><div \nclass=\"info\">90002991</div></div><div layout=\"column\" layout-gt-md=\"column\" flex=\"25\"><div class=\"md-subhead\"><strong>\nBU/Comp</strong></div><div class=\"info\">Enerlife</div></div><div layout=\"column\" layout-gt-md=\"column\" flex=\"25\"><div \nclass=\"md-subhead\"><strong>Origin Country</strong></div><div class=\"info\">Indonesia</div></div></div></div></div></div>\n</md-content></div><md-tabs md-dynamic-height><md-tab label=\"Itinerary\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><div ng-include=\"\'app/main/travel/travel-managment/demo.html\'\"></div></div></md-tab><md-tab \nlabel=\"Detail Itinerary\"><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nng-include=\"\'app/main/travel/travel-managment/demox.html\'\"></div></div></md-tab><md-tab label=\"Cash Advance\"><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div ng-include=\"\'app/main/travel/travel-managment/demox.html\'\"></div>\n</div></md-tab><md-tab label=\"Reimbursment\"><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nng-include=\"\'app/main/travel/travel-managment/demox.html\'\"></div></div></md-tab><md-tab label=\"Approval History\"><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div ng-include=\"\'app/main/travel/travel-managment/demo.html\'\"></div>\n</div></md-tab><md-tab label=\"Travel Policy\"><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nng-include=\"\'app/main/travel/travel-managment/demo.html\'\"></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/travel/travel-list/travel-list.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati5\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-view-list\"></md-icon></span><span class=\"md-title\">BUSINESS TRIP</span>\n</div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" \nlayout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper md-cyan-50-bg\"><form name=\"frmInsurance\" \nclass=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-filter\" \\></md-icon>Filter Data</div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmInsurance.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div\n ng-messages=\"frmInsurance.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\" \nrequired><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmInsurance.department.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Department field is required.</span></div></div></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\">\n<md-input-container flex=\"20\"><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"frmInsurance.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><md-input-container \nflex=\"20\"><label>End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"end_date\" ng-model=\"vm.end_date\">\n</md-datepicker><div ng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd Date is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.status_klaim\" name=\"status_klaim\" required><md-option ng-repeat=\"ls in vm.listStatus\" \nplaceholder=\"Claim Status\" value=\"{{ls}}\">{{ls}}</md-option></md-select></md-input-container><md-input-container flex>\n<input type=\"text\" placeholder=\"NIK / Nama\" ng-model=\"vm.nik\" id=\"formSearch\"></md-input-container><md-input-container \nlayout=\"column\" layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadData(1)\" \nclass=\"md-raised md-primary\" aria-label=\"search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"search\"></md-icon>Search</md-button></md-input-container></div></form></div></div></md-content><div \nclass=\"attView\"><md-toolbars><div class=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select \nname=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-button md-ink-ripple\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\nCreate New Request</md-tooltip><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-archive material-icons\">\n</md-icon>Create Request</md-button><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple\" type=\"button\" hide show-gt-sm aria-label=\"Delete\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\">Delete Request List</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button></div></md-toolbars></div></div></div></div>");
$templateCache.put("app/main/jic/approval/approval.html","<div id=\"empjicAddPage\" class=\"page-layout simple fullwidth carded md-padding with-toolbar-content white-bg\">\n<md-content id=\"jicFormContent\" class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-progress-linear \nng-if=\"vm.isSubmit\" style=\"top: 0px; left: 0px; position: fixed\" flex md-mode=\"indeterminate\"></md-progress-linear>\n<md-subheader class=\"white-bg\"><b>Detail Pengajuan Promosi / Mutasi / Demosi</b><div \nng-if=\"!vm.isApprovedAll(vm.selectedEmployee) && vm.selectedEmployee.status\" style=\"float: right; font-weight: bold\" \nclass=\"orange-500-fg\">Waiting for approval {{vm.selectedEmployee.outstandingApproval.approval_type | capitalize}}</div>\n<div ng-if=\"vm.selectedEmployee.status === \'\' && !vm.selectedEmployee.is_rejected\" \nstyle=\"float: right; font-weight: bold\" class=\"green-500-fg\">Approved</div><div \nng-if=\"vm.selectedEmployee.is_rejected > 0\" style=\"float: right; font-weight: bold\" class=\"red-500-fg\">Rejected</div>\n</md-subheader><form name=\"frmJicAddPengajuan\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData($event,frmJicAddPengajuan)\"><table class=\"table simple\"><thead><tr><th>NO</th><th>APPROVAL</th>\n<th>STATUS</th><th>TYPE</th><th>ISSUED DATE</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.selectedEmployee.approval\">\n<td class=\"text-center\">{{ls.no}}</td><td>{{ls.fullname}} / {{ls.nik}}</td><td class=\"text-center\"><span \nng-if=\"ls.status === \'1\'\" style=\"color: orange\">Waiting</span> <span ng-if=\"ls.status === \'2\'\" style=\"color: green\">\nApproved</span> <span ng-if=\"ls.status === \'3\'\" style=\"color: purple\">Revised</span> <span ng-if=\"ls.status === \'4\'\" \nstyle=\"color: red\">Rejected</span></td><td>{{ls.approval_type | uppercase}}</td><td class=\"text-center\">\n{{ls.processed_at}}</td></tr></tbody></table><hr><md-list><md-list-item layout=\"row\" flex><div flex=\"25\" \nclass=\"grey-200-bg list-item-jic grey-200-bg\"><b>Nama</b></div><div flex=\"25\" class=\"list-item-jic\"><span>\n{{vm.selectedEmployee.fullname}}</span></div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>NIK</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.nik}}</div></md-list-item><md-list-item layout=\"row\" flex><div \nflex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Masa Kerja</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.masa_kerja}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Status</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.status_kerja}}</div></md-list-item><md-list-item layout=\"row\" \nflex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Diajukan Untuk</b></div><div flex=\"75\" class=\"list-item-jic\">\n{{vm.diAjukanUntuk}}</div></md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Diajukan Tanggal</b></div><div flex=\"75\" class=\"list-item-jic\"><span>\n{{vm.selectedEmployee.tgl_pengajuan.substr(0,10) | date:\'dd/MM/yyyy\'}}</span></div></md-list-item><md-list-item \nlayout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Business Unit</b></div><div flex=\"25\" \nclass=\"list-item-jic\">{{vm.selectedEmployee.entity_id}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>\nBusiness Unit Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" class=\"list-item-jic\"><md-select \nng-model=\"vm.Form.objForm.bu\" name=\"bu\" ng-disabled=\"!vm.isMutation\" \nng-change=\"vm.loadSubAreaData(vm.Form.objForm.bu);vm.loadDataDivision(vm.Form.objForm.bu);vm.selectedCange(\'comp\')\">\n<md-option ng-repeat=\"item in vm.buLists\" ng-value=\"item.id\">{{item.description}}</md-option></md-select></div>\n</md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Divisi</b></div><div\n flex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.division}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Divisi Baru</b></div><div flex=\"25\" class=\"list-item-jic\"><md-select \nng-model=\"vm.Form.objForm.division_id\" \nng-change=\"vm.loadDataDepartment(vm.Form.objForm.division_id,true);vm.selectedCange(\'div\')\" name=\"division_id\" \nng-disabled=\"!vm.isMutation\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" ng-if=\"ls.id!==\'all\'\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></div></md-list-item><md-list-item layout=\"row\" flex><div \nflex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Department</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.department}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Department Baru</b></div>\n<div flex=\"25\" class=\"list-item-jic\"><md-select ng-model=\"vm.Form.objForm.department_baru_id\" name=\"department\" \nng-change=\"vm.loadLayerData();vm.selectedCange(\'dept\')\" ng-disabled=\"!vm.isMutation\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" ng-if=\"ls.id!==\'all\'\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select></div></md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Atasan</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.nik_atasan}}-{{vm.selectedEmployee.nama_atasan}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Atasan Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" \nclass=\"list-item-jic\">{{vm.selectedEmployee.nik_atasan_baru}}-{{vm.selectedEmployee.nama_atasan_baru}}</div>\n</md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Jabatan</b></div>\n<div flex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.jabatan_lama}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Jabatan Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" \nclass=\"list-item-jic\">{{vm.Form.objForm.job_title.jobTitleName}} <a \nstyle=\"cursor: pointer; font-style: inherit; color: #0f82b4;float: right\" flex=\"10\"><i \nclass=\"icon icon-account-search blue-600-fg\" ng-click=\"vm.lookupJobTitle($event)\" \nng-if=\"vm.selectedEmployee.approval_type == \'tm\' && vm.selectedEmployee.approval_status == \'1\'\"></i></a></div>\n</md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Pangkat-Gol Lama</b>\n</div><div flex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.emp_grade}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Pangkat-Gol Baru</b></div><div flex=\"25\" class=\"list-item-jic\"><md-select \nng-model=\"vm.selectedEmployee.grade_baru\" name=\"gol_baru\" ng-if=\"vm.selectedEmployee.approval_type == \'tm\'\"><md-option \nng-repeat=\"item in vm.grades\" ng-value=\"item\">{{item}}</md-option></md-select><span \nng-if=\"vm.selectedEmployee.approval_type !== \'tm\'\">{{vm.selectedEmployee.grade_baru}}</span></div></md-list-item>\n<md-list-item layout=\"row\"><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Lokasi Kerja Lama</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.emp_subarea}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Lokasi Kerja Baru</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.sub_area_baru}}</div></md-list-item><div style=\"margin-top: 20px\"></div><md-list-item \nlayout=\"row\"><div flex=\"50\" class=\"list-item-jic grey-200-bg\" style=\"margin-right: 5px\"><b>Alasan Pengajuan</b></div>\n<div flex=\"50\" class=\"list-item-jic grey-200-bg\"><b>Konduite (Diisi oleh personalia)</b></div></md-list-item>\n<md-list-item layout=\"row\" layout-align=\"start start\"><div flex=\"50\" class=\"list-item-jic\" layout-align=\"start start\">\n<ol ng-if=\"vm.reasonsLists\" class=\"padding-right-30\"><li ng-repeat=\"reason in vm.reasonsLists\">{{reason.reason}}</li>\n</ol><fieldset ng-if=\"vm.selectedEmployee.reasonEmpChange\" class=\"mt-10\"><legend>Informasi Keluar/Mutasi/Promosi:\n</legend><table class=\"table\"><tr><td style=\"width: 120px\">Employee</td><td>:</td><td>\n{{vm.selectedEmployee.reasonEmpChange[0].fullname}}</td></tr><tr><td>Position</td><td>:</td><td>\n{{vm.selectedEmployee.reasonEmpChange[0].position_name}}</td></tr><tr><td>Reasons</td><td>:</td><td>\n{{vm.selectedEmployee.reasonEmpChange[0].reasons}}</td></tr><tr><td>Effective Date</td><td>:</td><td>\n{{vm.selectedEmployee.reasonEmpChange[0].effective_date}}</td></tr></table></fieldset></div><div flex=\"50\" \nclass=\"list-item-jic\" style=\"padding-left: 0px\"><md-list><md-list-item layout=\"row\" flex style=\"padding-left: 5px\"><div\n flex=\"50\" class=\"list-item-jic grey-200-bg\"><p>Catatan Kondute Periode</p></div><div flex=\"20\" class=\"list-item-jic\">\n{{vm.konduitePeriode.start | date:\"MMM-y\"}}</div><div flex=\"10\" class=\"list-item-jic\">s/d</div><div flex=\"20\" \nclass=\"list-item-jic\">{{vm.konduitePeriode.end | date:\"MMM-y\"}}</div></md-list-item><md-list-item layout=\"row\" \nlayout-align=\"center center\" flex style=\"padding-left: 5px\"><div flex=\"50\" class=\"list-item-jic grey-200-bg\"><p>Absensi\n</p></div><div flex=\"20\" style=\"padding-left: 10px\">S.&nbsp; <input type=\"number\" ng-disabled=\"!vm.isAdminPersonel()\" \nng-required=\"vm.isAdminPersonel()\" name=\"absensiSakit\" ng-model=\"vm.absensi.sakit\" \nstyle=\"width: 50px; line-height: 30px; text-align: center\"></div><div flex=\"20\">I.&nbsp; <input type=\"number\" \nng-disabled=\"!vm.isAdminPersonel()\" ng-required=\"vm.isAdminPersonel()\" name=\"absensiIjin\" ng-model=\"vm.absensi.ijin\" \nstyle=\"width: 50px; line-height: 30px; text-align: center\"></div><div flex=\"10\">A.&nbsp; <input type=\"number\" \nng-disabled=\"!vm.isAdminPersonel()\" ng-required=\"vm.isAdminPersonel()\" name=\"absensiAlpha\" ng-model=\"vm.absensi.alpha\" \nstyle=\"width: 50px; line-height: 30px; text-align: center\"></div></md-list-item><md-list-item layout=\"row\" flex \nstyle=\"padding-left: 5px\"><div flex=\"50\" class=\"list-item-jic grey-200-bg\"><p>Teguran</p><span class=\"red-700-fg\">*\n</span></div><md-input-container flex=\"50\" style=\"margin-left: 7px\"><input type=\"text\" \nng-required=\"vm.isAdminPersonel()\" name=\"absensiTeguran\" aria-label=\"Teguran\" ng-disabled=\"!vm.isAdminPersonel()\" \nng-model=\"vm.konduiteAddition.teguran\"></md-input-container></md-list-item><md-list-item layout=\"row\" flex \nstyle=\"padding-left: 5px\"><div flex=\"50\" class=\"list-item-jic grey-200-bg\"><p>Surat Peringatan</p><span \nclass=\"red-700-fg\">*</span></div><md-input-container flex=\"50\" style=\"margin-left: 7px\"><input type=\"text\" \nng-required=\"vm.isAdminPersonel()\" name=\"absensiSp\" aria-label=\"Surat Peringatan\" ng-disabled=\"!vm.isAdminPersonel()\" \nng-model=\"vm.konduiteAddition.surat_peringatan\"></md-input-container></md-list-item><md-list-item layout=\"row\" flex \nstyle=\"padding-left: 5px\"><div flex=\"50\" class=\"list-item-jic grey-200-bg\"><p>Berlaku mulai tanggal</p><span \nclass=\"red-700-fg\">*</span></div><div flex=\"50\" class=\"list-item-jic\"><span ng-if=\"!vm.isAdminPersonel()\">\n{{(vm.valid_date)?(vm.valid_date | date:\'dd/MM/yyyy\'):\'\'}}</span><md-datepicker ng-model=\"vm.valid_date\" \nmd-hide-icons=\"all\" aria-label=\"Tanggal Berlaku\" ng-if=\"vm.isAdminPersonel()\" md-open-on-focus \nng-required=\"vm.isAdminPersonel()\" ng-change=\"vm.setMasaActing()\"></md-datepicker></div></md-list-item><md-list-item \nng-if=\"vm.isPromosi\" layout=\"row\" flex style=\"padding-left: 5px\"><div flex=\"50\" class=\"list-item-jic grey-200-bg\"><p>\nLama masa acting</p><span class=\"red-700-fg\">*</span></div><div flex=\"50\" class=\"list-item-jic\"><md-select \nng-model=\"vm.lamaMasaActing\" ng-disabled=\"vm.selectedEmployee.approval_type !== \'tm\'\" ng-change=\"vm.setMasaActing()\">\n<md-option ng-value=\"3\">3 Bulan</md-option><md-option ng-value=\"6\">6 Bulan</md-option></md-select></div></md-list-item>\n<md-list-item ng-if=\"vm.isPromosi\" layout=\"row\" flex style=\"padding-left: 5px\"><div flex=\"50\" \nclass=\"list-item-jic grey-200-bg\"><p>Masa acting tanggal (Untuk Promosi)</p><span class=\"red-700-fg\">*</span></div><div\n flex=\"20\" class=\"list-item-jic\"><span ng-if=\"!vm.isAdminPersonel()\">{{vm.acting_start | date:\'dd/MM/yyyy\'}}</span>\n<md-datepicker ng-model=\"vm.acting_start\" md-hide-icons=\"all\" aria-label=\"Masa acting tanggal (Untuk Promosi)\" \nng-if=\"vm.isAdminPersonel()\" md-open-on-focus ng-required=\"vm.isAdminPersonel()\"></md-datepicker></div><div flex=\"10\" \nclass=\"list-item-jic\">s/d</div><div flex=\"20\" class=\"list-item-jic\"><span ng-if=\"!vm.isAdminPersonel()\">\n{{vm.acting_end | date:\'dd/MM/yyyy\'}}</span><md-datepicker ng-model=\"vm.acting_end\" md-hide-icons=\"all\" \naria-label=\"Masa acting tanggal (Untuk Promosi)\" ng-if=\"vm.isAdminPersonel()\" md-open-on-focus \nng-required=\"vm.isAdminPersonel()\"></md-datepicker></div></md-list-item><md-list-item layout=\"row\" flex \nstyle=\"padding-left: 5px\"><div flex=\"50\" class=\"list-item-jic grey-200-bg\"><p>Promotion Allowance (Rp)</p><span \nclass=\"red-700-fg\">*</span></div><div flex=\"50\" class=\"list-item-jic\"><input type=\"number\" name=\"promotionAllowance\" \naria-label=\"Promotion Allowance\" ng-model=\"vm.promotion_allowance\" ng-value=\"vm.selectedEmployee.allowance\" \nstyle=\"width: 100%; border: none; border-bottom: 1px dotted #ccc\" \nng-disabled=\"vm.selectedEmployee.approval_type !== \'hcs-officer\'\" \nng-required=\"vm.selectedEmployee.approval_type === \'hcs-officer\'\"></div></md-list-item><md-list-item \nng-if=\"vm.selectedEmployee.approval_type === \'tm\'\" layout=\"row\" flex style=\"padding-left: 5px\"><div flex=\"50\" \nclass=\"list-item-jic grey-200-bg\"><p>Required Assessment</p></div><div flex=\"50\" class=\"list-item-jic\"><md-radio-group \nng-model=\"vm.is_assessment_required\" ng-disabled=\"vm.selectedEmployee.approval_type !== \'tm\'\"><md-radio-button \nng-value=\"1\" ng-checked=\"vm.selectedEmployee.is_assessment_required === 1\" class=\"md-primary mr-20\">Yes\n</md-radio-button><md-radio-button ng-value=\"0\" ng-checked=\"vm.selectedEmployee.is_assessment_required === 0\" \nclass=\"md-primary\">No</md-radio-button></md-radio-group></div></md-list-item><md-list-item \nng-if=\"vm.selectedEmployee.approval_type === \'tm\'\" layout=\"row\" flex style=\"padding-left: 5px\"><div flex=\"50\" \nclass=\"list-item-jic grey-200-bg\"><p>Unbudgeted?</p></div><div flex=\"50\" class=\"list-item-jic\"><md-radio-group \nng-model=\"vm.is_unbudgeted\" ng-disabled=\"vm.selectedEmployee.approval_type !== \'hcs-officer\'\"><md-radio-button \nvalue=\"1\" ng-checked=\"vm.selectedEmployee.is_unbudgeted === 1\" class=\"md-primary mr-20\">Unbudgeted</md-radio-button>\n<md-radio-button value=\"0\" ng-checked=\"vm.selectedEmployee.is_unbudgeted === 0\" class=\"md-primary\">Budgeted\n</md-radio-button></md-radio-group></div></md-list-item></md-list></div></md-list-item><div \nstyle=\"border-bottom: 0.5px solid #ebebeb; margin-bottom: 5px\"></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"end start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-md=\"column\" layout-align=\"end start\" flex><p \nng-if=\"!vm.isAllowApproval &&\n                              vm.selectedEmployee.approval_status != 2 &&\n                              !vm.isApprovedAll(vm.selectedEmployee)\n                              && vm.selectedEmployee.status\" \nng-hide=\"vm.selectedEmployee.approval_status == 1 &&\n                                 vm.selectedEmployee.is_last_approval == 1\" \nclass=\"orange-500-fg mr-10\">Waiting for approval {{vm.selectedEmployee.outstandingApproval.approval_type | capitalize}}\n</p><md-button type=\"submit\" ng-click=\"vm.approve($event, 3)\" ng-click=\"null\" \nng-if=\"vm.selectedEmployee.approval_status == 4\" class=\"md-red-300-bg md-raised white-fg\" aria-label=\"Unreject\">\nUNREJECT</md-button><md-button type=\"submit\" ng-click=\"vm.approve($event, 4)\" \nng-if=\"vm.selectedEmployee.approval_status == 1 && vm.isAllowApproval\" class=\"md-red-300-bg md-raised white-fg\" \naria-label=\"Reject\" ng-disabled=\"vm.isSubmit\">REJECT</md-button><md-button type=\"submit\" \nng-click=\"vm.approve($event, 3)\" ng-if=\"vm.selectedEmployee.approval_status == 1 && vm.isAllowApproval\" \nclass=\"md-orange-300-bg md-raised white-fg\" aria-label=\"Reject\" ng-disabled=\"vm.isSubmit\">REVISED</md-button><md-button\n type=\"submit\" ng-click=\"vm.approve($event, 2)\" \nng-if=\"vm.selectedEmployee.approval_status == \'1\' && vm.isAllowApproval\" type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Approve\" \nng-disabled=\"frmJicAddPengajuan.$invalid || vm.selectedEmployee.approval_status != \'1\' || vm.isSubmit\">APPROVE\n</md-button><md-button type=\"submit\" ng-click=\"vm.approve($event, 1)\" \nng-if=\"vm.selectedEmployee.approval_status === 2\" type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Unapprove\">UNAPPROVE</md-button><md-button ng-if=\"vm.selectedEmployee.isAllowEdit\" type=\"button\" \nng-click=\"vm.showEdit($event, $index, vm.pengajuan_id)\" class=\"md-blue-600-bg md-raised white-fg\" aria-label=\"Edit\">\nEDIT</md-button><md-button ng-if=\"vm.selectedEmployee.approval_type === \'hc-spv\' && vm.selectedEmployee.konduite_id\" \ntype=\"button\" ng-click=\"vm.saveEffectiveDate($event)\" class=\"md-blue-300-bg md-raised white-fg\" \naria-label=\"Update Effective Date\" ng-disabled=\"vm.isSubmit\">UPDATE EFFECTIVE DATE</md-button><md-button type=\"button\" \nui-sref=\"app.emp_jic\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Back\">BACK</md-button></div></md-list>\n</form></md-content></div>");
$templateCache.put("app/main/jic/empjic/empjic.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><md-progress-linear ng-if=\"vm.isLoading\" \nstyle=\"top: 0px; left: 0px; position: fixed\" flex md-mode=\"indeterminate\"></md-progress-linear><div \nclass=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\">Job Information Changes\n</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div \nlayout=\"row\"><div flex=\"100\" style=\"margin: 1vh\" layout-gt-sm=\"column\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex style=\"margin: 0px; margin-bottom: 1vh\"><label>Start Date</label><input type=\"date\" \nname=\"start_date\" ng-model=\"vm.filter.start_date\"></md-input-container><md-input-container flex \nstyle=\"margin: 0px; margin-bottom: 1vh\"><label>End Date</label><input type=\"date\" name=\"end_date\" \nng-model=\"vm.filter.end_date\"></md-input-container><md-input-container flex style=\"margin: 0px; margin-bottom: 1vh\">\n<label>Action Type</label><md-select name=\"action_type\" ng-model=\"vm.filter.action_type\"><md-option value=\"All\">All\n</md-option><md-option ng-repeat=\"ls in vm.action_type_list\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex style=\"margin: 0px; margin-bottom: 1vh\"><label>Approval Status</label>\n<md-select name=\"approval_status\" ng-model=\"vm.filter.approval_status\"><md-option value=\"All\">All</md-option><md-option\n ng-repeat=\"ls in vm.approval_status_list\" value=\"{{ls.id}}\">{{ls.desc}}</md-option></md-select></md-input-container>\n</div></div></div><div layout=\"row\"><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\" \nstyle=\"margin-left: auto\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>\n<span translate=\"jic.label_search\">Search</span></md-button></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-menu md-offset=\"0 -7\" hide-gt-sm class=\"md-primary-bg\"><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Add New Submission\" class=\"md-green-300-bg md-raised md-primary white-fg\" ng-click=\"vm.showAdd($event)\">\n<md-icon md-font-icon=\"icon-plus\" class=\"teal-800-fg\"></md-icon>Add New Submission</md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container h ide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select></md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Add New Submission\" \nng-click=\"vm.showAdd($event)\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">Open Submission Form\n</md-tooltip>Add New Submission</md-button><span flex hide show-gt-sm></span><ms-search-bar ng-model=\"vm.search\" \non-search=\"vm.loadData(1)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th \nclass=\"text-center\">NO</th><th class=\"text-center\">ID</th><th class=\"text-center\">YANG MENGAJUKAN</th><th \nclass=\"text-center\">KARYAWAN</th><th class=\"text-center\">ACTION TYPE</th><th class=\"text-center\">JOB TITLE</th><th \nclass=\"text-center\">TGL. PENGAJUAN<div style=\"display: inline-flex; float: right\"><a ng-if=\"!vm.sort.tgl_pengajuan\" \nhref=\"javascript:void(0)\" ng-click=\"vm.setSortBy(\'tgl_pengajuan\', \'asc\')\"><span \nclass=\"icon icon-sort-variant white-500-fg\"></span> </a><a ng-if=\"vm.sort.tgl_pengajuan === \'asc\'\" \nhref=\"javascript:void(0)\" ng-click=\"vm.setSortBy(\'tgl_pengajuan\', \'asc\')\"><span \nclass=\"icon icon-sort-ascending white-500-fg\"></span> </a><a ng-if=\"vm.sort.tgl_pengajuan === \'desc\'\" \nhref=\"javascript:void(0)\" ng-click=\"vm.setSortBy(\'tgl_pengajuan\', \'desc\')\"><span \nclass=\"icon icon-sort-descending white-500-fg\"></span></a></div></th><th class=\"text-center\">APPROVAL STATUS<div \nstyle=\"display: inline-flex; float: right\"><a ng-if=\"!vm.sort.ready_to_print\" href=\"javascript:void(0)\" \nng-click=\"vm.setSortBy(\'ready_to_print\', \'asc\')\"><span class=\"icon icon-sort-variant white-500-fg\"></span> </a><a \nng-if=\"vm.sort.ready_to_print === \'asc\'\" href=\"javascript:void(0)\" ng-click=\"vm.setSortBy(\'ready_to_print\', \'asc\')\">\n<span class=\"icon icon-sort-ascending white-500-fg\"></span> </a><a ng-if=\"vm.sort.ready_to_print === \'desc\'\" \nhref=\"javascript:void(0)\" ng-click=\"vm.setSortBy(\'ready_to_print\', \'desc\')\"><span \nclass=\"icon icon-sort-descending white-500-fg\"></span></a></div></th><th class=\"text-center\">#</th></tr></thead><tbody>\n<tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{ls.id}}\n</td><td>{{ls.emp_name}}</td><td>{{ls.employee_staf_name}}</td><td class=\"text-left\"><div ng-if=\"ls.action_type\"><span \nng-repeat=\"at in ls.action_type\">{{at.action_name}}{{vm.addComma($index, ls.action_type)}}</span></div></td><td>\n{{ls.jabatan_baru}}</td><td class=\"text-center\">\n{{ls.tgl_pengajuan.substr(0, 10) | date:\'dd/MM/yyyy\'}} {{ls.created_at.substr(11, 5)}}</td><td class=\"text-center\" \nstyle=\"white-space: nowrap\"><span class=\"green-700-fg\" \nng-if=\"ls.ready_to_print === 1 && ls.status === \'\' && !ls.is_rejected && !ls.is_revisied\">Completed</span> <span \nclass=\"orange-700-fg\" ng-if=\"ls.status.status === \'1\'\">Waiting in {{ls.status.approval_type | capitalize}}</span> <span\n class=\"red-700-fg\" ng-if=\"ls.is_rejected && !ls.is_revisied\">Rejected</span> <span class=\"purple-700-fg\" \nng-if=\"!ls.is_rejected && ls.is_revisied\">Revisied {{ls.status.approval_type | capitalize}}<br>\n{{ls.status.notes | capitalize}}</span></td><td class=\"text-center\"><a href=\"javascript:void(0)\" \nng-click=\"vm.goToDetail($event, $index, ls)\" aria-label=\"Print\" \nstyle=\"padding: 0;height: 24px;width: 24px; text-decoration: none; font-size: small\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>View Detail</span></md-tooltip></a>&nbsp;&nbsp; <a \nhref=\"javascript:void(0)\" ng-click=\"vm.showRevisied($event, $index, ls.id)\" aria-label=\"Print\" \nstyle=\"padding: 0;height: 24px;width: 24px; text-decoration: none; font-size: small\" \nng-if=\"(ls.is_revisied > 0 || ls.is_allow_update > 0) && vm.user == ls.created_by\"><md-icon \nmd-font-icon=\"icon-table-edit\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>Revisied</span></md-tooltip></a>\n&nbsp;&nbsp; <a href=\"javascript:void(0)\" ng-click=\"vm.deleteJic($event, $index, ls)\" aria-label=\"Print\" \nstyle=\"padding: 0;height: 24px;width: 24px; text-decoration: none; font-size: small\" \nng-if=\"(ls.is_allow_update > 0) && vm.user == ls.created_by\"><md-icon md-font-icon=\"icon-delete\" class=\"red-500-fg\">\n</md-icon><md-tooltip><span>Delete</span></md-tooltip></a>&nbsp;&nbsp; <a ng-if=\"vm.isAdminPersonel()\" \nhref=\"javascript:void(0)\" ng-click=\"vm.showDelegasi($event, $index, ls)\" aria-label=\"Print\" \nstyle=\"padding: 0;height: 24px;width: 24px; text-decoration: none; font-size: small\"><md-icon \nmd-font-icon=\"icon-account-switch\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>Delegasi</span></md-tooltip></a>\n&nbsp;&nbsp; <a href=\"javascript:void(0)\" ng-disabled=\"!ls.ready_to_print\" ng-if=\"ls.is_allow_print > 0\" \nng-click=\"vm.showPrint($event, $index, ls)\" aria-label=\"Print\" \nstyle=\"padding: 0;height: 24px;width: 24px; text-decoration: none; font-size: small\"><md-icon \nmd-font-icon=\"icon-printer\" ng-class=\"{\'grey-300-fg\':!ls.ready_to_print, \'blue-500-fg\' :ls.ready_to_print}\"></md-icon>\n<md-tooltip><span>Print</span></md-tooltip></a></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/utility/grouppermission/grouppermission.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Group Permissions</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container md-no-float class=\"md-block\" flex=\"30\">Load Group :<select \nname=\"group\" id=\"ss\" ng-change=\"vm.loadData(group.id)\" ng-model=\"vm.group\" \nng-options=\"group.nama for group in vm.listGroupSelect\"></select></md-input-container><span flex hide show-gt-sm>\n</span></div></md-toolbar><div ng-init=\"mainIdx=$index;vm.visibleSubChild[mainIdx]=false\" \nng-repeat-start=\"ls in ::vm.listModul track by $index\"><div layout=\"column\"><md-list-item class=\"md-primary\"><md-button\n style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.toogleSubChild(mainIdx)\" class=\"md-icon-button\" \naria-label=\"More\" ng-if=\"ls.submenu.length>0\"><md-icon ng-show=\"!vm.visibleSubChild[mainIdx]\" md-font-icon=\"icon-plus\">\n</md-icon><md-icon ng-show=\"vm.visibleSubChild[mainIdx]\" md-font-icon=\"icon-minus\"></md-icon></md-button><div \nclass=\"md-list-item-text\"><span>{{ls.menu_name | uppercase}}</span></div><md-switch class=\"md-secondary\" \nng-change=\"vm.enableGroup(ls.checkedgroup,ls.id,vm.group.id)\" ng-model=\"ls.checkedgroup\"></md-switch></md-list-item>\n</div><div layout=\"column\" flex-offset=\"3\" ng-show=\"vm.visibleSubChild[mainIdx]\" class=\"menu_{{$index}}\" \nng-repeat=\"sub in ::ls.submenu track by $index\"><md-list-item class=\"md-primary md-grey-600-bg\"><div \nclass=\"md-list-item-text\"><span><md-icon md-font-icon=\"icon-chevron-double-right\"></md-icon></span>\n{{sub.menu_name | uppercase}}</div><md-switch ng-if=\"ls.checkedgroup\" class=\"md-secondary\" \nng-change=\"vm.enableGroup(sub.checkedgroup,sub.id,vm.group.id)\" ng-model=\"sub.checkedgroup\"></md-switch></md-list-item>\n<div ng-if=\"sub.hassub==\'0\'\" ng-show=\"sub.checkedgroup\"><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" \nlayout-align=\"start left\" layout-wrap><md-list-item ng-repeat=\"act in sub.action\" flex=\"44\" class=\"p-16\"><p>\n{{act.action_label}}</p><md-switch class=\"md-primary md-hue-3\" ng-change=\"vm.changeaction(act,vm.group.id)\" \nng-model=\"act.checked\"></md-switch></md-list-item></div></div><div ng-if=\"sub.hassub==\'1\'\" ng-show=\"sub.checkedgroup\">\n<div layout=\"column\" flex-offset=\"5\" ng-show=\"vm.visibleSubChild[mainIdx]\" class=\"menu_{{$index}}\" \nng-repeat=\"subsub in ::sub.subsubmenu track by $index\"><div layout=\"column\"><md-list-item><div \nclass=\"md-list-item-text\"><span class=\"green-800-fg\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon>\n{{subsub.menu_name | uppercase}}</span></div><md-switch ng-if=\"ls.checkedgroup\" class=\"md-secondary\" \nng-change=\"vm.enableGroup(subsub.checkedgroup,subsub.id,vm.group.id)\" ng-model=\"subsub.checkedgroup\"></md-switch>\n</md-list-item></div><div ng-if=\"subsub.hassub==\'0\'\" ng-show=\"sub.checkedgroup\"><div layout=\"row\" \nng-show=\"subsub.checkedgroup\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"start left\" layout-wrap><md-list-item\n ng-repeat=\"acts in subsub.action\" flex=\"44\" class=\"p-16\"><p>{{acts.action_label}}</p><md-switch \nclass=\"md-primary md-hue-3\" ng-change=\"vm.changeaction(acts,vm.group.id)\" ng-model=\"acts.checked\"></md-switch>\n</md-list-item></div></div><div ng-if=\"subsub.hassub==\'1\'\" class=\"subsubsub\" ng-show=\"sub.checkedgroup\"><div \nlayout=\"column\" flex-offset=\"9\" ng-show=\"vm.visibleSubChild[mainIdx]\" class=\"menu_{{$index}}\" \nng-repeat=\"subsubsub in ::subsub.subsubsubmenu track by $index\"><div layout=\"column\"><md-list-item><div \nclass=\"md-list-item-text\"><span class=\"blue-800-fg\"><md-icon md-font-icon=\"icon-playlist-minus green-800-fg\"></md-icon>\n{{subsubsub.menu_name | uppercase}}</span></div><md-switch ng-if=\"ls.checkedgroup\" class=\"md-secondary\" \nng-change=\"vm.enableGroup(subsubsub.checkedgroup,subsubsub.id,vm.group.id)\" ng-model=\"subsubsub.checkedgroup\">\n</md-switch></md-list-item><div layout=\"row\" ng-show=\"subsubsub.checkedgroup\" layout-sm=\"column\" layout-xs=\"column\" \nlayout-align=\"start left\" layout-wrap><md-list-item ng-repeat=\"acts in subsubsub.action\" flex=\"44\" class=\"p-16\"><p>\n{{acts.action_label}}</p><md-switch class=\"md-primary md-hue-1\" ng-change=\"vm.changeaction(acts,vm.group.id)\" \nng-model=\"acts.checked\"></md-switch></md-list-item></div></div></div><div ng-if=\"subsubsub.hassub==\'1\'\" \nclass=\"subsubsubsub\" ng-show=\"subsub.checkedgroup\"><div layout=\"column\" flex-offset=\"9\" \nng-show=\"vm.visibleSubChild[mainIdx]\" class=\"menu_{{$index}}\" \nng-repeat=\"subsubsubsub in ::subsubsub.subsubsubsubmenu track by $index\"><div layout=\"column\"><md-list-item><div \nclass=\"md-list-item-text\"><span class=\"blue-800-fg\"><md-icon md-font-icon=\"icon-playlist-minus green-800-fg\"></md-icon>\n{{subsubsubsub.menu_name | uppercase}}</span></div><md-switch ng-if=\"ls.checkedgroup\" class=\"md-secondary\" \nng-change=\"vm.enableGroup(subsubsubsub.checkedgroup,subsubsubsub.id,vm.group.id)\" ng-model=\"subsubsubsub.checkedgroup\">\n</md-switch></md-list-item><div layout=\"row\" ng-show=\"subsubsubsub.checkedgroup\" layout-sm=\"column\" layout-xs=\"column\" \nlayout-align=\"start left\" layout-wrap><md-list-item ng-repeat=\"acts in subsubsubsub.action\" flex=\"44\" class=\"p-16\"><p>\n{{acts.action_label}}</p><md-switch class=\"md-primary md-hue-1\" ng-change=\"vm.changeaction(acts,vm.group.id)\" \nng-model=\"acts.checked\"></md-switch></md-list-item></div></div></div></div></div></div></div></div></div><div \nng-repeat-end></div></div></div></md-content></div>");
$templateCache.put("app/main/utility/menu/menu.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Menu</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div\n class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-raised md-primary btn-ui-serif\" \nhide show-gt-sm type=\"button\" aria-label=\"Inert\" ui-sref=\"app.utility_menu_input-menu\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>click for view actions</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Add Employement</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.deleteModul($event)\"><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\"><span \ntranslate=\"ACTION.DOWNLOAD\">Download</span></md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon><span>\nDelete Module</span></md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th><div class=\"table-header\"><span class=\"column-title\">No\n</span></div></th><th class=\"text-left\"><div class=\"table-header\"><span class=\"column-title\">Menu Name</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title\">Link</span></div></th><th><div class=\"table-header\"><span\n class=\"column-title\">Sequence</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Link Parent\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.list\" ng-dblclick=\"vm.editData(ls.id)\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listModulSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ ls.no }}</td><td>{{ ls.title }}</td><td class=\"text-center\">{{ ls.level }}</td><td \nclass=\"text-center\">{{ ls.orderNo }}</td><td class=\"text-center\">{{ ls.parentname }}</td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/utility/modul/modul.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon ui-sref=\"{{vm.Breadhome}}\" md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><div ng-repeat-start=\"ls  in vm.Breadlist\"></div><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\" ui-sref=\"{{ls.link}}\">{{ls.name}}</span><div ng-repeat-end></div>\n</div><div class=\"title\">Module</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ui-sref=\"app.utility_modul_input-modul\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span>Add Employement</span></md-button><md-button \nclass=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.deleteModul($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete Module</span></md-button></div></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div layout=\"row\" layout-padding layout-align=\"space-between center\">\n<md-input-container md-no-float class=\"md-block\" flex=\"30\">Shows :<select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><span flex></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\"></md-icon><input type=\"text\" placeholder=\"Search..\" ng-model=\"vm.DataTable.searchParam\" \nid=\"formSearch\"></md-input-container></form></div><table class=\"simple\" ms-responsive-table style=\"margin-top:0\">\n<thead><tr><th><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th><div class=\"table-header\"><span class=\"column-title\">No\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Menu Name</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Link</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Has Sub</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Sequence</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Link Parent</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.list\" ng-dblclick=\"vm.editData(ls.menuId)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.listModulSelected\" checklist-value=\"ls\"></td><td>{{ ls.no }}</td><td>{{ ls.menu_name }}</td><td>\n{{ ls.link }}</td><td>{{ ls.hassub }}</td><td>{{ ls.urut }}</td><td>{{ ls.type }}</td><td>{{ ls.link_parent }}</td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/utility/modules/modules.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">Menu</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg csm-dropdown\"><md-button ui-sref=\"app.utility_modules_input-modules\"><span>Add Employement\n</span></md-button><md-button ng-click=\"vm.deleteModul($event)\"><span translate=\"ACTION.DELETE_SIC\">Delete Employement\n</span></md-button></md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill>\n<div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\"><span>Modules</span>\n</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><md-input-container hide \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><form ng-submit=\"vm.loadData(1)\" \nname=\"formSearch\" flex></form><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th width=\"5%\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></th><th \nwidth=\"5%\"><div class=\"table-header\"><span class=\"is-gear\"><md-icon md-font-icon=\"icon-cog\" \\></md-icon></span></div>\n</th><th width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Link</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Menu Name</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editData(ls.id)\"><td><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"Open kpi menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.modulesAction(ls.id)\"><div layout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-eye\">\n</md-icon><p flex>View Action</p></div></md-button></md-menu-item></md-menu-content></md-menu></td><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listModulSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ ls.no }}</td><td class=\"text-center\">{{ ls.module_name | uppercase }}</td><td \nclass=\"text-center\">{{ ls.menutitle | uppercase }}</td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/utility/permission/permission.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Utility</span></div><div \nclass=\"title\">Permissions</div></div><div layout=\"row\" layout-align=\"start center\"></div></div><div class=\"content\">\n<div class=\"simple-table-container md-whiteframe-4dp\"><div layout=\"row\" layout-padding \nlayout-align=\"space-between center\"><md-input-container md-no-float class=\"md-block\" flex=\"30\">Load Group :<select \nname=\"group\" id=\"ss\" ng-change=\"vm.loadData(group.id)\" ng-model=\"vm.group\" \nng-options=\"group.nama for group in vm.listGroupSelect\"></select></md-input-container><md-input-container md-no-float \nclass=\"md-block\"><md-button class=\"md-raised reference-button md-accent md-hue-3\" \nng-click=\"vm.AddPermission(vm.group)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span>Add Employement</span>\n</md-button></md-input-container><span flex></span></div></div><md-list ng-cloak><div \nng-repeat-start=\"ls in vm.listModul\"><md-toolbar><div class=\"md-toolbar-tools\">{{ls.menu_name | uppercase}}</div>\n</md-toolbar><div layout=\"column\" ng-if=\"ls.submenu.length > 0\" ng-repeat=\"sub in ls.submenu\"><md-subheader \nclass=\"md-no-sticky md-success\"><md-list-item class=\"md-primary\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-border-color\" ng-click=\"vm.inputaction(sub.menuId)\" aria-label=\"android\"></md-icon><p>\n{{sub.menu_name | uppercase}}</p></md-list-item><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" \nlayout-align=\"start left\" layout-wrap><md-list-item ng-repeat=\"act in sub.action\" flex=\"44\" class=\"p-16\"><p>\n{{act.action_label}}</p><md-switch class=\"md-primary md-hue-3\" ng-change=\"vm.changeaction(act,ls.groupID)\" \nng-model=\"act.checked\"></md-switch></md-list-item></div></md-subheader><md-divider></md-divider></div></div><div \nng-repeat-end></div></md-list></div></div>");
$templateCache.put("app/main/utility/user/user.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Master JFM</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container md-no-float class=\"md-block\" flex=\"30\"><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container>\n<span flex></span> <span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th class=\"text-center\" width=\"1%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\" width=\"1%\"><div class=\"table-header\">\n<span class=\"column-title\">No</span></div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\"><span \nclass=\"column-title\">Menu Name</span></div></th><th class=\"text-center\" width=\"10%\"><div class=\"table-header\"><span \nclass=\"column-title\">Link</span></div></th><th class=\"text-center\" width=\"5%\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editData(ls.userID)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listModulSelected\" checklist-value=\"ls\"></td><td class=\"text-center\">{{ ls.no }}</td><td \nclass=\"text-center\">{{ ls.nama }}</td><td class=\"text-center\">{{ ls.group }}</td><td class=\"text-center\"><md-button \nclass=\"md-warn\" aria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.resetPassword($event,ls.userID)\"><md-icon md-font-icon=\"icon-key-change\" class=\"red-300-fg\"></md-icon>\n<md-tooltip><span>click for reset password</span></md-tooltip></md-button></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/wfh/wfh-main/wfh-main.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nWork From Home</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" flex class=\"form-wrapper has-wrapper-coloum custom-filter\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container style=\"width:-webkit-fill-available\"><label>Date</label><input type=\"date\" name=\"start_date\" \nng-model=\"vm.start_date\"></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" ng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><div class=\"divider-vertical\" hide show-gt-sm>\n</div><md-button class=\"blue-500-fg md-mini\" hide show-gt-sm aria-label=\"Total Team\" type=\"button\" \nng-if=\"vm.countTeam != 0\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Total Team</span>\n</md-tooltip><span>Team Members: {{vm.countTeam}}</span></md-button></div></md-toolbar><md-tabs \nclass=\"list-candidate-process-tab\" md-selected=\"vm.selectedIndexTab\" \nmd-align-tabs=\"{{vm.data.bottom ? \'bottom\' : \'top\'}}\" md-dynamic-height md-border-bottom><md-tab \nmd-on-select=\"vm.tabChange(1)\"><md-tab-label style=\"color: rgb(235, 236, 240) !important\">Dependents</md-tab-label>\n<md-tab-body style=\"background: white\"><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Add New\" ng-click=\"vm.updateHealthStatus()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">\n<span>Update Dependent Health Status</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nstyle=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span>Update Dependent Health Status\n</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><span flex hide show-gt-sm></span><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"printcost\" ng-click=\"vm.updateHealthStatus()\"><md-icon md-font-icon=\"icon-border-color\" \nmd-font-icon=\"md-font icon-archive material-icons\"></md-icon><span>Update Dependent Health Status</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\" ms-scroll><div id=\"tableMpp\"><table class=\"simple bordered stripped\" cellpadding=\"0\" \ncellspacing=\"0\" ms-responsive-table><thead><tr><th style=\"width: 50px;font-size: 12px !important\" rowspan=\"2\">No</th>\n<th style=\"text-align: left !important;font-size: 12px !important\" rowspan=\"2\">Person</th><th \nstyle=\"font-size: 12px !important\" colspan=\"2\">Status</th></tr><tr><th style=\"font-size: 12px !important\">Morning</th>\n<th style=\"font-size: 12px !important\">Afternoon</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTableDependents.list\"><td class=\"text-center\" style=\"font-size: 12px !important\">\n{{ item.no }}</td><td style=\"font-size: 12px !important\">{{ item.name }}<br><small>{{item.type_of_family}}</small><br>\n<small ng-if=\"item.status.health_status_morning\">Morning Status : {{item.status.health_status_morning}}</small><br>\n<small ng-if=\"item.status.health_status_afternoon\">Afternoon Status : {{item.status.health_status_afternoon}}</small>\n</td><td style=\"font-size: 12px !important\" class=\"text-center\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span ng-if=\"item.status.morning == \'fix\'\">Fit</span> <span \nng-if=\"item.status.morning == \'unfix\'\">Un Fit</span> <span ng-if=\"item.status.morning == \'sick\'\">Sick</span>\n</md-tooltip><img ng-src=\"./assets/images/wfh/fix.png\" ng-if=\"item.status.morning == \'fix\'\"> <img \nng-src=\"./assets/images/wfh/unfix.png\" ng-if=\"item.status.morning == \'unfix\'\"> <img \nng-src=\"./assets/images/wfh/sick.png\" ng-if=\"item.status.morning == \'sick\'\"><br><small>{{item.status.morning_time}}\n</small></td><td style=\"font-size: 12px !important\" class=\"text-center\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span ng-if=\"item.status.afternoon == \'fix\'\">Fit</span> <span \nng-if=\"item.status.afternoon == \'unfix\'\">Un Fit</span> <span ng-if=\"item.status.afternoon == \'sick\'\">Sick</span>\n</md-tooltip><img ng-src=\"./assets/images/wfh/fix.png\" ng-if=\"item.status.afternoon == \'fix\'\" title=\"Fix\"> <img \nng-src=\"./assets/images/wfh/unfix.png\" ng-if=\"item.status.afternoon == \'unfix\'\" title=\"Un Fix\"> <img \nng-src=\"./assets/images/wfh/sick.png\" ng-if=\"item.status.afternoon == \'sick\'\" title=\"Sick\"><br><small>\n{{item.status.afternoon_time}}</small></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTableDependents.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTableDependents.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></md-content></md-tab-body></md-tab><md-tab \nmd-on-select=\"vm.tabChange(2)\"><md-tab-label style=\"color: rgb(235, 236, 240) !important\">Activity</md-tab-label>\n<md-tab-body style=\"background: white\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-mini md-primary\" hide show-gt-sm type=\"button\" \naria-label=\"Add New\" ng-click=\"vm.AddActivity()\"><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>\nAdd Activity</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" style=\"font-size:15px\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Add Activity</span></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><span flex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" \nng-click=\"vm.AddActivity()\"><md-icon md-font-icon=\"icon-border-color\" \nmd-font-icon=\"md-font icon-archive material-icons\"></md-icon><span>Add Activity</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-toolbar style=\"margin-top: 21px\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container style=\"width:-webkit-fill-available\"><input type=\"date\" \nname=\"start_date_activity\" ng-model=\"vm.start_date_activity\" placeholder=\"Start Date\"></md-input-container>\n<md-input-container style=\"width:-webkit-fill-available\"><input type=\"date\" name=\"end_date\" ng-model=\"vm.end_date\" \nplaceholder=\"End Date\"></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon>\n</md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll>\n<div id=\"tableMpp\"><table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead>\n<tr><th style=\"width: 50px;font-size: 12px !important\">No</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Activity</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Status</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Comment</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTableActivity.list\"><td class=\"text-center\" style=\"font-size: 12px !important\">{{ item.no }}\n</td><td style=\"font-size: 12px !important\">{{ item.activity_name }}<br><small>{{item.note}}</small><br><small \nng-if=\"item.start_hour\">Start End Time : {{ item.start_hour }} - {{ item.end_hour }}</small></td><td \nstyle=\"font-size: 12px !important\">{{ item.status }}</td><td style=\"font-size: 12px !important\">{{ item.comment }}</td>\n</tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTableActivity.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTableActivity.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a \nhref=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.tabChange(3)\" ng-if=\"vm.countTeam != 0\"><md-tab-label \nstyle=\"color: rgb(235, 236, 240) !important\">Team</md-tab-label><md-tab-body style=\"background: white\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Add New\" ng-click=\"vm.exportDataDependent()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Export Data</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-file-excel-box material-icons\"></md-icon>\n<span>Export Data</span></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><span flex hide show-gt-sm>\n</span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"printcost\" ng-click=\"vm.exportDataDependent()\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-file-excel-box material-icons\"></md-icon><span>Export Data</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><div id=\"tableMpp\"><table class=\"simple bordered stripped\" \ncellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th style=\"width: 50px;font-size: 12px !important\" \nrowspan=\"2\">No</th><th style=\"text-align: left !important;font-size: 12px !important\" rowspan=\"2\">Team</th><th \nstyle=\"font-size: 12px !important\" colspan=\"2\">Last Update</th></tr><tr><th \nstyle=\"width: 70px;font-size: 12px !important\">IN</th><th style=\"width: 70px;font-size: 12px !important\">OUT</th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.DataTableListTeam.list\" ng-click=\"vm.CheckDetailStatusTeam(item)\" \nstyle=\"cursor: pointer\"><td ng-if=\"item.nik\" class=\"text-center\" style=\"font-size: 12px !important\">{{ item.no }}</td>\n<td ng-if=\"item.nik\" style=\"font-size: 12px !important\"><span>{{ item.emp_name }} - {{item.nik}}</span><br><span>\n{{ item.activity_count }} Activity / {{ item.dependent_count }} Dependent</span></td><td \nstyle=\"font-size: 12px !important\" class=\"text-center\">{{ item.in }}</td><td style=\"font-size: 12px !important\" \nclass=\"text-center\">{{ item.out }}</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTableListTeam.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTableListTeam.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></md-content></md-tab-body></md-tab></md-tabs></div></div></md-content>\n</div>");
$templateCache.put("app/main/wfh/wfhadmin/upload-form.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"60\" flex-gt-md=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.UPLOADATTENDANCEWFH\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset><legend><span translate=\"MENU.MAIN.UPLOADATTENDANCEWFH\"></span> - \n<span translate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFile\" nv-file-select \nuploader=\"vm.FileUploader\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">\nCancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUploader.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-primary md-hue-1\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span><span \ntranslate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/wfh/wfhadmin/wfhadmin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Work From Home</span></md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\">\n<div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmEmploye\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span translate=\"PAYROLL.MENU.FILTERDATA\"></span></div><div layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadArea(vm.company)\"><md-option ng-repeat=\"ls in vm.listcompany\" \nplaceholder=\"{{ \'PAYROLL.MENU.COMPANY\' | translate}}\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"{{ \'PAYROLL.MENU.DIVISION\' | translate}}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" placeholder=\"{{ \'PAYROLL.MENU.DEPARTMENT\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option ng-value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.HEALTHSTATUS\"></label>\n<md-select multiple=\"true\" ng-model=\"vm.status\" name=\"status\" ng-change=\"vm.selectStatus(vm.status)\"><md-option \nng-repeat=\"ls in vm.listStatus\" placeholder=\"{{ \'PAYROLL.MENU.HEALTHSTATUS\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex flex-gt-sm><label \ntranslate=\"KPI.LABEL.STARTDATE\"></label><md-datepicker md-hide-icons=\"calendar\" md-max-date=\"vm.end_date\" \nname=\"start_date\" ng-model=\"vm.start_date\"></md-datepicker><div ng-messages=\"frmBT.start_date.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.ENDDATE\">\n</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\">\n</md-datepicker><div ng-messages=\"frmBT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.ENDDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label>NIK</label><md-chips ng-model=\"vm.selectedDatas\" \nmd-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"vm.autocompleteDemoRequireMatch\" \ninput-aria-label=\"\"><md-autocomplete \nstyle=\"background: transparent;\n                              border-bottom: 1px solid #e0e0e0\" md-no-cache=\"true\" \nmd-selected-item=\"vm.Form.objForm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.Form.objForm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.Form.objForm.nik)\"><md-item-template><span \nmd-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template></md-autocomplete><md-chip-template>\n<span>{{$chip.fullname}}</span></md-chip-template></md-chips><div ng-messages=\"frmBT.product.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.NIK\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div>\n</div></md-input-container><md-input-container layout=\"column\" layout-align=\"right right\"><md-button type=\"button\" \nlayout=\"row\" ng-click=\"vm.loadData(1)\" class=\"md-mini md-raised md-primary\" aria-label=\"search\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span translate=\"PAYROLL.MENU.SEARCH\">\n</span></md-button></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\"><md-input-container><md-button \nclass=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Add New\" ng-click=\"vm.updateHealthStatus()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span>Update Dependent Health Status</span></md-tooltip>\n<md-icon md-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon>\n<span>Update Dependent Health Status</span></md-button></md-input-container><md-input-container><md-button \nclass=\"md-mini md-primary\" hide show-gt-sm type=\"button\" aria-label=\"Add New\" ng-click=\"vm.AddActivity()\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span>Add Activity</span></md-tooltip><md-icon \nmd-font-icon=\"icon-border-color\" style=\"font-size:15px\" class=\"md-font icon-archive material-icons\"></md-icon><span>\nAdd Activity</span></md-button></md-input-container><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-input-container><md-button class=\"md-button md-ink-ripple md-primary md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.upload($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span><span \ntranslate=\"UMUT.MENU.UPLOAD\"></span></span></md-button></md-input-container></div></form></div></div></md-content>\n<md-toolbar><div class=\"md-toolbar-tools table-tools\"></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered\" ms-responsive-table><thead><tr>\n<th class=\"text-center\" rowspan=\"2\"><span class=\"column-title\"><span>NO</span></span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\"><span>NIK</span></span></th><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.NAME\"></span></span></th><th class=\"text-center\" rowspan=\"2\"><span \nclass=\"column-title\"><span translate=\"MENU.MAIN.RELATIONSHIP\"></span></span></th><th class=\"text-center\" rowspan=\"2\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.DATE\"></span></span></th><th class=\"text-center\" colspan=\"4\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.STATUS\"></span></span></th><th class=\"text-center\" rowspan=\"2\">\n<span class=\"column-title\"><span translate=\"MENU.MAIN.ISSAMEHOME\"></span></span></th><th class=\"text-center\" \nrowspan=\"2\"><span class=\"column-title\">Action</span></th></tr><tr><th class=\"text-center\"><span class=\"column-title\">\n<span translate=\"MENU.MAIN.MORNING\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NOTE\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"MENU.MAIN.AFTERNOON\"></span></span></th><th class=\"text-center\"><span class=\"column-title\"><span \ntranslate=\"UMUT.MENU.NOTE\"></span></span></th></tr></thead><tbody><tr ng-style=\"{\'background-color\':ls.color}\" \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editPayrollEmployee($event,ls.id)\"><td class=\"text-center\">\n{{$index+1}}</td><td class=\"text-center\">{{ls.nik}}</td><td>{{ls.emp_name}}</td><td class=\"\">{{ls.type_of_family}}</td>\n<td class=\"text-center\">{{ls.checking_date}}</td><td class=\"text-center\">{{ls.morning}}</td><td class=\"\">\n{{ls.health_status_morning}}</td><td class=\"text-center\">{{ls.afternoon}}</td><td class=\"\">\n{{ls.health_status_afternoon}}</td><td class=\"text-center\">{{ls.is_same_home==1 ? \'Yes\' : \'No\'}}</td><td \nclass=\"text-center\"><span ng-if=\"ls.color !=\'\'\"><md-button \nng-click=\"vm.viewActivity($event,ls.nik,ls.checking_date,ls.emp_name)\" aria-label=\"Refresh widget\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"teal-800-fg\"></md-icon><span>View Activity</span></md-button></span></td></tr><tr \nclass=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td colspan=\"10\" class=\"text-center\"><span \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><div \nng-if=\"vm.DataTable.list.length > 0\" class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\"></div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img src=\"assets/images/logos/kfc.png\" height=\"20\" alt=\"\" class=\"logo-image\"> \n<span class=\"logo-text\">HR LINK</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\" ng-class=\"vm.alert.bgClass\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target \nng-if=\"vm.photo==null || vm.photo==\'undefined\' || vm.photo==\'-\' || vm.photo==\'\'\" class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"> <span md-menu-align-target \nng-if=\"vm.photo!==null && vm.photo!==\'undefined\' && vm.photo!==\'-\' && vm.photo!==\'\'\" class=\"avatar\" \nstyle=\"display:block; background-size: cover; background-position: center; background-repeat: none\" \nng-style=\"{\'background-image\': \'url(api/empdocument/\' + vm.photo + \'), url(assets/images/avatars/unprofile.jpg)\'}\">\n</span><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide show-gt-sm>{{vm.username}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs style=\"color:0,0,0\"></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.Myprofiles()\">My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.changepassword\"><md-icon md-font-icon=\"icon-key\" class=\"icon\"></md-icon><md-button>Change Pasword\n</md-button></md-menu-item><md-menu-item ng-if=\"vm.employeeAlertList.length > 0\" class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-account-alert\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" \nclass=\"status\">Alert List</md-button><md-menu-content width=\"2\"><md-menu-item class=\"md-indent\" \nng-repeat=\"alert in vm.employeeAlertList\"><md-icon ng-class=\"alert.fg_class\" md-font-icon=\"icon-file-document-box\">\n</md-icon><md-button ng-click=\"vm.viewManufactureAlert($event, alert)\">{{alert.label}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-tooltip \nmd-direction=\"left\">Attendance waiting approval</md-tooltip><md-icon md-font-icon=\"icon-bell\" \nstyle=\"color:rgba(0,0,0,0.6)\" class=\"icon\"></md-icon><div class=\"md-deep-orange-500-bg unread-message-count\" \nng-if=\"vm.Approvalinfo.getInfoApproval.totalApproval>0\">{{vm.Approvalinfo.getInfoApproval.totalApproval}}</div>\n</md-button><md-button ng-if=\"vm.Contractalert.infoContract.length > 0\" id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.viewContractAlert($event)\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-tooltip md-direction=\"left\">Employe to finish contract\n</md-tooltip><md-icon md-font-icon=\"icon-bullhorn\" style=\"color:rgba(0,0,0,0.6)\" class=\"icon\"></md-icon><div \nclass=\"md-deep-orange-500-bg unread-message-count\">{{vm.Contractalert.infoContract.length}}</div></md-button></div>\n</div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><ms-shortcuts></ms-shortcuts>\n<div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\" ng-class=\"vm.alert.bgClass\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target \nng-if=\"vm.photo==null || vm.photo==\'undefined\' || vm.photo==\'-\' || vm.photo==\'\'\" class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"> <span md-menu-align-target \nng-if=\"vm.photo!==null && vm.photo!==\'undefined\' && vm.photo!==\'-\' && vm.photo!==\'\'\" class=\"avatar\" \nstyle=\"display:block; background-size: cover; background-position: center; background-repeat: none\" \nng-style=\"{\'background-image\': \'url(api/empdocument/\' + vm.photo + \'), url(assets/images/avatars/unprofile.jpg)\'}\">\n</span><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide show-gt-sm>{{vm.username}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs style=\"color:0,0,0\"></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.Myprofiles()\">My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.changepassword\"><md-icon md-font-icon=\"icon-key\" class=\"icon\"></md-icon><md-button>Change Pasword\n</md-button></md-menu-item><md-menu-item ng-if=\"vm.employeeAlertList.length > 0\" class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-account-alert\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" \nclass=\"status\">Alert List</md-button><md-menu-content width=\"2\"><md-menu-item class=\"md-indent\" \nng-repeat=\"alert in vm.employeeAlertList\"><md-icon ng-class=\"alert.fg_class\" md-font-icon=\"icon-file-document-box\">\n</md-icon><md-button ng-click=\"vm.viewManufactureAlert($event, alert)\">{{alert.label}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\" class=\"top-bar\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs \nstyle=\"color:rgb(0,0,0)\"></md-icon></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-tooltip \nmd-direction=\"left\">Attendance waiting approval</md-tooltip><md-icon md-font-icon=\"icon-bell\" \nstyle=\"color:rgba(0,0,0,0.6)\" class=\"icon\"></md-icon><div class=\"md-deep-orange-500-bg unread-message-count\" \nng-if=\"vm.Approvalinfo.getInfoApproval.totalApproval>0\">{{vm.Approvalinfo.getInfoApproval.totalApproval}}</div>\n</md-button><md-button ng-if=\"vm.Contractalert.infoContract.length > 0\" id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.viewContractAlert($event)\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-tooltip md-direction=\"left\">Employe to finish contract\n</md-tooltip><md-icon md-font-icon=\"icon-bullhorn\" style=\"color:rgba(0,0,0,0.6)\" class=\"icon\"></md-icon><div \nclass=\"md-deep-orange-500-bg unread-message-count\">{{vm.Contractalert.infoContract.length}}</div></md-button></div>\n</div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" ng-init=\"idx=$index\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\" >\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title  \" ng-class=\"{\'md-accent-fg md-hue-3\':node.parent==\'0\',\'grey-700-fg\':node.parent!=\'0\'}\" translate=\"{{node.translate}}\" flex ng-if=\"node.translate.indexOf(\'MENU.MAIN\') >= 0\">{{node.title}}</span>\n            <span class=\"title  \" ng-class=\"{\'md-accent-fg md-hue-3\':node.parent==\'0\',\'grey-700-fg\':node.parent!=\'0\'}\" flex ng-if=\"node.translate.indexOf(\'MENU.MAIN\') < 0\">{{node.title}} </span> <!-- top nav -->\n            <span class=\"badge md-accent-fg md-hue-3\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow no-padding\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a ng-disabled=\"vm.isSurvey==0\" class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title   \" ng-class=\"{\'md-accent-fg md-hue-3\':node.parent==\'0\',\'grey-700-fg\':node.parent!=\'0\'}\" translate=\"{{node.translate}}\"  ng-class=\"{\'md-accent-fg md-hue-3\':node.parent==\'0\',\'grey-700-fg\':node.parent!=\'0\'}\" flex ng-if=\"node.translate.indexOf(\'MENU.MAIN\') >= 0\">{{node.title}}</span>\n            <span class=\"title \" ng-class=\"{\'md-accent-fg md-hue-3\':node.parent==\'0\',\'grey-700-fg\':node.parent!=\'0\'}\" flex ng-if=\"node.translate.indexOf(\'MENU.MAIN\') < 0\">{{node.title}} </span>\n            <span class=\"badge grey-700-fg\"  style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow no-padding\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\" ng-init=\"idx1=$index\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-if=\"vm.isSurvey==1\" ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\" ng-class=\"{\'md-grey-200-bg  has-group\':(node.group && !node.uisref )}\">\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\" >\n            <i class=\"icon s18 {{node.icon}}  md-hue-3 \" ng-class=\"{\'s24\':node.group}\" ng-if=\"node.icon\"></i>\n\n            <span class=\"title grey-700-fg\" md-truncate translate=\"{{node.translate}}\" flex ng-if=\"node.translate.indexOf(\'MENU.MAIN\') >= 0\">{{node.title}}</span>\n            <span class=\"title grey-700-fg\" flex ng-if=\"node.translate.indexOf(\'MENU.MAIN\') < 0\" md-truncate>{{node.title}} </span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow grey-700-fg no-padding\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button grey-700-fg\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"md-warn-bg md-background-fg\"\n           ng-if=\"node.uisref && node.title && node.is_internal\">\n\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n\n            <span class=\"title\" translate=\"{{node.translate}}\" flex ng-if=\"node.translate.indexOf(\'MENU.MAIN\') >= 0\" md-truncate>{{node.title}}</span>\n            <span class=\"title\" flex ng-if=\"node.translate.indexOf(\'MENU.MAIN\') < 0 && (node.translate!=\'MENU.BPJS\' && node.translate!=\'MENU.TAXPARAMETER\')\" md-truncate>{{node.title}}</span>\n            <span class=\"title\" translate=\"PAYROLL.MENU.BPJSPARAMETERMYS\" flex ng-if=\"(node.translate==\'MENU.BPJS\' && vm.country==\'MYS\')\" md-truncate>{{node.title}}</span>\n            <span class=\"title\" translate=\"PAYROLL.MENU.BPJSPARAMETER\" flex ng-if=\"(node.translate==\'MENU.BPJS\' && vm.country!=\'MYS\')\" md-truncate>{{node.title}}</span>\n            <span class=\"title\" translate=\"PAYROLL.MENU.TAXPARAMETERMYS\" flex ng-if=\"(node.translate==\'MENU.TAXPARAMETER\' && vm.country==\'MYS\')\" md-truncate>{{node.title}}</span>\n            <span class=\"title\" translate=\"PAYROLL.MENU.TAXPARAMETER\" flex ng-if=\"(node.translate==\'MENU.TAXPARAMETER\' && vm.country!=\'MYS\')\" md-truncate>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow grey-700-fg no-padding\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n         <a class=\"ms-navigation-button grey-700-fg\" ng-click=\"vm.goToExternal($event, node.uisref)\" href=\"#\" ng-if=\"node.uisref && node.title && !node.is_internal\">\n\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n\n            <span class=\"title\" translate=\"{{node.translate}}\" flex ng-if=\"node.translate.indexOf(\'MENU.MAIN\') >= 0\" md-truncate>{{node.title}}</span>\n            <span class=\"title\" flex ng-if=\"node.translate.indexOf(\'MENU.MAIN\') < 0 && (node.translate!=\'MENU.BPJS\' && node.translate!=\'MENU.TAXPARAMETER\')\" md-truncate>{{node.title}}</span>\n            <span class=\"title\" translate=\"PAYROLL.MENU.BPJSPARAMETERMYS\" flex ng-if=\"(node.translate==\'MENU.BPJS\' && vm.country==\'MYS\')\" md-truncate>{{node.title}}</span>\n            <span class=\"title\" translate=\"PAYROLL.MENU.BPJSPARAMETER\" flex ng-if=\"(node.translate==\'MENU.BPJS\' && vm.country!=\'MYS\')\" md-truncate>{{node.title}}</span>\n            <span class=\"title\" translate=\"PAYROLL.MENU.TAXPARAMETERMYS\" flex ng-if=\"(node.translate==\'MENU.TAXPARAMETER\' && vm.country==\'MYS\')\" md-truncate>{{node.title}}</span>\n            <span class=\"title\" translate=\"PAYROLL.MENU.TAXPARAMETER\" flex ng-if=\"(node.translate==\'MENU.TAXPARAMETER\' && vm.country!=\'MYS\')\" md-truncate>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow grey-700-fg no-padding\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\">\n        </li>\n    </ul>\n</script>");
$templateCache.put("app/main/correspondence/assignment-letter/form/form.html","<md-dialog aria-label=\"Correspondence Assignment\" md-theme=\"modal-theme\" ms-scroll flex=\"40\" \nid=\"correspondence-dialog\"><form ng-cloak name=\"formCorrespondenceAssignment\" class=\"md-inline-form\" novalidate \nng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools title\"><h4>{{ vm.dialogType }} Assignment Letter</h4><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear ng-show=\"vm.loadingProgress\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-dialog-content flex \nng-class=\"{\'blurify\' : vm.loadingProgress, \'no-blurify\' : !vm.loadingProgress}\" layout=\"column\" layout-padding \nstyle=\"margin-top:0px\"><div layout=\"row\" layout=\"space-between center\" style=\"margin-top:20px\"><md-input-container \nflex style=\"margin-bottom:0\"><label>LOKASI PENUGASAN</label><md-select md-on-open=\"vm.getSubArea()\" \nng-disabled=\"vm.read\" required name=\"sub_area\" style=\"margin-bottom:20px !important\" \nng-model=\"vm.Form.objForm.location\"><md-option ng-repeat=\"item in vm.subArea\" \nng-selected=\"item.description == vm.Form.objForm.location\" ng-value=\"item.description\">{{item.description}}</md-option>\n</md-select></md-input-container><md-input-container flex style=\"margin-bottom:0\"><label>Start Date</label>\n<md-datepicker ng-disabled=\"vm.read\" md-hide-icons=\"all\" md-open-on-focus ng-model=\"vm.startDate\" \nmd-current-view=\"month\" name=\"startDate\" required></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-bottom:0\"><label>End Date</label><md-datepicker ng-disabled=\"vm.read\" md-hide-icons=\"all\" \nmd-open-on-focus ng-model=\"vm.endDate\" md-current-view=\"month\" name=\"endDate\" required></md-datepicker>\n</md-input-container></div><div layout=\"row\" ng-if=\"!vm.read\"><md-input-container flex class=\"md-block\"><label \nstyle=\"margin-bottom:5px\">Search Employee</label><md-autocomplete ng-readonly=\"vm.read\" \nmd-selected-item=\"vm.selectedEmployee\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-require-match \nmd-search-text=\"vm.searchText\" md-input-name=\"nik\" md-no-cache=\"true\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.name\" md-min-length=\"3\" ng-model-options=\"{ debounce: 500 }\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\">{{item.nik}} | {{item.name}}</span></md-item-template><md-not-found>\nNo Record matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><div \nlayout=\"row\" style=\"max-height:200px\"><table class=\"simple list-employee\" ms-responsive table><thead><tr><th>NIK</th>\n<th>NAME</th><th>GRADE</th><th>JOB TITLE</th><th ng-if=\"!vm.read\" style=\"text-align:center !important\">ACTION</th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.employeeLists\"><td>{{item.nik}}</td><td>{{item.name}}</td><td>{{item.grade}}\n</td><td>{{item.job_title}}</td><td ng-if=\"!vm.read\" style=\"text-align:center !important\"><md-icon \nng-click=\"vm.removeItem(item)\" class=\"md-warn\" style=\"font-size:12px; cursor: pointer\" md-font-icon=\"icon-close\">\n</md-icon></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" flex><div \nlayout-align=\"start center\" flex class=\"form-message\" ng-class=\"{success:vm.success, error:!vm.success}\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{ vm.Form.pesan }}</div><div flex=\"40\" layout-align=\"end center\" \nlayout=\"row\"><md-button ng-if=\"vm.create\" class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.storeRequest($event,formCorrespondenceAssignment)\" \nng-disabled=\"formCorrespondenceAssignment.$invalid || vm.saveProcess || vm.employeeLists.length == 0\" type=\"submit\">\n<md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-if=\"vm.update\" \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.updateRequest($event,formCorrespondenceAssignment)\" \nng-disabled=\"formCorrespondenceAssignment.$invalid || vm.updateProcess || formCorrespondenceAssignment.$pristine\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Update</md-button><md-button \nng-click=\"vm.setToken()\" ng-if=\"!vm.read\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/correspondence/decision-letter/form/form.html","<md-dialog aria-label=\"Correspondence Decision\" md-theme=\"modal-theme\" ms-scroll flex=\"50\" id=\"correspondence-dialog\">\n<form ng-cloak name=\"formCorrespondenceDecision\" class=\"md-inline-form\" novalidate ng-submit=\"\"><md-toolbar><div \nclass=\"md-toolbar-tools title\"><h4>{{ vm.dialogType }} Decision Letter</h4><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-progress-linear ng-show=\"vm.loadingProgress\" md-mode=\"indeterminate\">\n</md-progress-linear><md-dialog-content flex \nng-class=\"{\'blurify\' : vm.loadingProgress, \'no-blurify\' : !vm.loadingProgress}\" layout=\"column\" layout-padding \nstyle=\"margin-top:0px\"><div layout=\"row\" style=\"margin-top:5px; margin-bottom:5px\"><md-input-container flex \nclass=\"md-block\"><label>Decision Letter Type</label><md-select ng-disabled=\"vm.read\" required name=\"decision_type\" \nng-change=\"vm.switchAction(vm.Form.objForm.decision_type)\" ng-model=\"vm.Form.objForm.decision_type\"><md-option \nng-selected=\"vm.Form.objForm.decision_type.id == item.id\" ng-repeat=\"item in vm.decisionTypeList\" ng-value=\"item\">\n{{item.name}} ({{item.description}})</md-option></md-select></md-input-container></div><div layout=\"row\" \nstyle=\"margin-top:5px; margin-bottom:5px\"><md-input-container flex class=\"md-block\" \nstyle=\"padding-bottom: 0px; padding-top: 0px\"><label style=\"margin-bottom:5px\">Search Employee</label><md-autocomplete \nng-readonly=\"vm.read\" md-selected-item=\"vm.selectedEmployee\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-require-match md-search-text=\"vm.searchText\" md-input-name=\"nik\" md-no-cache=\"true\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" required md-min-length=\"3\"><md-item-template>\n<span md-highlight-text=\"vm.searchText\">{{item.nik}} | {{item.name}}</span></md-item-template><md-not-found>\nNo Record matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><div \nlayout=\"column\" ng-if=\"vm.selectedEmployee\" ng-if=\"vm.Form.objForm.decision_type\"><md-divider></md-divider><div \nlayout=\"row\" layout-align=\"center start\" style=\"margin-top:10px; margin-bottom:10px\"><div class=\"label-header\">\nRequested For {{vm.Form.objForm.decision_type.description}}</div></div><md-divider></md-divider><div layout=\"row\" \nstyle=\"margin-top:5px\"><div layout=\"row\" class=\"user_panel\" layout-align=\"space-between center\" flex=\"50\"><div \nlayout=\"row\" flex=\"35\" layout-align=\"center\"><img ng-src=\"{{ \'api/pasfoto/\' + item.photo_address }}\" \nonerror=\"this.src=\'assets/images/avatars/profile.jpg\'\" class=\"md-avatar\" alt=\"{{item.who}}\"></div><div layout=\"column\" \nflex><div class=\"user_info\" layout=\"row\" flex><span class=\"user_info_label\" flex=\"20\">NIK</span> <span class=\"spacer\">:\n</span> <span class=\"user_info_input\">{{vm.selectedEmployee.nik}}</span></div><div class=\"user_info\" layout=\"row\" flex>\n<span class=\"user_info_label\" flex=\"20\">Name</span> <span class=\"spacer\">:</span> <span class=\"user_info_input\">\n{{vm.selectedEmployee.name}}</span></div><div class=\"user_info\" layout=\"row\" flex><span class=\"user_info_label\" \nflex=\"20\">Org Unit</span> <span class=\"spacer\">:</span> <span class=\"user_info_input\">{{vm.selectedEmployee.org_unit}}\n</span></div><div class=\"user_info\" layout=\"row\" flex><span class=\"user_info_label\" flex=\"20\">Grade</span> <span \nclass=\"spacer\">:</span> <span class=\"user_info_input\">{{vm.selectedEmployee.grade}}</span></div><div class=\"user_info\" \nlayout=\"row\" flex><span class=\"user_info_label\" flex=\"20\">Position</span> <span class=\"spacer\">:</span> <span \nclass=\"user_info_input\">{{vm.selectedEmployee.job_title}}</span></div><div class=\"user_info\" layout=\"row\" flex><span \nclass=\"user_info_label\" flex=\"20\">Sub Area</span> <span class=\"spacer\">:</span> <span class=\"user_info_input\">\n{{vm.selectedEmployee.sub_area_name}}</span></div></div></div><div layout=\"column\" flex=\"45\"><div layout=\"row\" \nstyle=\"margin-top:20px; margin-bottom:20px\"><md-input-container class=\"md-block\" flex><label>GRADE NEW</label>\n<md-select ng-disabled=\"vm.read\" required name=\"grade_new\" ng-model=\"vm.Form.objForm.grade_new\"><md-option \nng-repeat=\"item in vm.grades\" ng-value=\"item\">{{item}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex ng-if=\"vm.allowGradeTarget\"><label>GRADE TARGET</label><md-select ng-disabled=\"vm.read\" required \nname=\"grade_target\" ng-model=\"vm.Form.objForm.grade_target\"><md-option ng-repeat=\"item in vm.grades\" ng-value=\"item\">\n{{item}}</md-option></md-select></md-input-container></div><md-input-container class=\"md-block\" \nng-if=\"vm.allowSubArea\"><label>LOCATION</label><md-select ng-disabled=\"vm.read\" required name=\"sub_area\" \nstyle=\"margin-bottom:20px !important\" ng-model=\"vm.Form.objForm.location\"><md-option ng-repeat=\"item in vm.subArea\" \nng-value=\"item.description\">{{item.description}}</md-option></md-select></md-input-container><md-input-container flex \nclass=\"md-block\" style=\"padding-top: 0px; margin-bottom: 10px\"><label style=\"margin-bottom:5px\">Search Position</label>\n<md-autocomplete ng-readonly=\"vm.read\" md-selected-item=\"vm.selectedPosition\" \nmd-selected-item-change=\"vm.selectedItemChangePosition(item)\" md-require-match md-search-text=\"vm.searchTextPosition\" \nmd-input-name=\"position\" md-no-cache=\"true\" md-items=\"item in vm.querySearchPosition(vm.searchTextPosition)\" \nmd-item-text=\"item.description\" required md-min-length=\"3\"><md-item-template><span \nmd-highlight-text=\"vm.searchTextPosition\">{{item.description}}</span></md-item-template><md-not-found>\nNo Record matching \"{{vm.searchTextPosition}}\" were found.</md-not-found></md-autocomplete></md-input-container><div \nlayout=\"row\" layout=\"space-between center\" style=\"margin-top:10px\" ng-if=\"vm.allowDate\"><md-input-container flex \nstyle=\"padding-bottom: 0px; padding-top: 0px; margin-bottom: 0px; margin-top: 0px\"><label>Start Date</label>\n<md-datepicker ng-disabled=\"vm.read\" md-hide-icons=\"all\" md-open-on-focus ng-model=\"vm.startDate\" \nmd-current-view=\"month\" name=\"startDate\" required></md-datepicker></md-input-container><md-input-container flex \nstyle=\"padding-bottom: 0px; padding-top: 0px; margin-bottom: 0px; margin-top: 0px\"><label>End Date</label>\n<md-datepicker ng-disabled=\"vm.read\" md-hide-icons=\"all\" md-open-on-focus ng-model=\"vm.endDate\" \nmd-current-view=\"month\" name=\"endDate\" required></md-datepicker></md-input-container></div><div layout=\"row\" \nlayout=\"space-between center\" style=\"margin-top:10px\" ng-if=\"vm.allowEffectiveDate\"><md-input-container flex \nstyle=\"padding-bottom: 0px; padding-top: 0px; margin-bottom: 0px; margin-top: 0px\"><label>Effective Date</label>\n<md-datepicker ng-disabled=\"vm.read\" md-hide-icons=\"all\" md-open-on-focus ng-model=\"vm.effectiveDate\" \nmd-current-view=\"month\" name=\"effectiveDate\" required></md-datepicker></md-input-container></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" flex><div layout-align=\"start center\" flex class=\"form-message\" \nng-class=\"{success:vm.success, error:!vm.success}\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{ vm.Form.pesan }}</div>\n<div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button ng-if=\"vm.create\" \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.storeRequest($event,formCorrespondenceDecision)\" \nng-disabled=\"formCorrespondenceDecision.$invalid || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-if=\"vm.update\" \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.updateRequest($event,formCorrespondenceDecision)\" \nng-disabled=\"formCorrespondenceDecision.$invalid || vm.updateProcess || formCorrespondenceDecision.$pristine\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Update</md-button><md-button \nng-click=\"vm.setToken()\" ng-if=\"!vm.read\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/correspondence/requestor/form/form.html","<md-dialog aria-label=\"Create Correspondence Request\" md-theme=\"modal-theme\" ms-scroll flex=\"50\" \nid=\"correspondence-dialog\"><form ng-cloak name=\"formCorrespondence\" class=\"md-inline-form\" novalidate ng-submit=\"\">\n<md-toolbar><div class=\"md-toolbar-tools title\"><h4>{{ vm.dialogType }} Correspondence Request</h4><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear ng-show=\"vm.loadingProgress\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-dialog-content \nng-class=\"{\'blurify\' : vm.loadingProgress, \'no-blurify\' : !vm.loadingProgress}\" layout-fill style=\"margin-top:0px\"><div\n layout=\"column\" flex layout-padding><div layout=\"column\" layout-align=\"start stretch\" flex><div layout=\"row\" \nclass=\"md-block\" style=\"margin-bottom:10px; padding-bottom: 10px\" flex ng-if=\"vm.dialogType == \'edit\' || vm.readOnly\">\n<div flex=\"20\" style=\"font-size : 12px; padding-left: 2px\">Requestor</div><span flex=\"5\">:</span><div flex \nstyle=\"font-size : 12px\">{{ vm.Form.objForm.requestor }} - {{ vm.Form.objForm.name }}</div></div><div layout=\"row\" \nclass=\"md-block\" style=\"margin-bottom:20px; padding-bottom: 10px\" flex ng-if=\"vm.dialogType == \'edit\' || vm.readOnly\">\n<div flex=\"20\" style=\"font-size : 12px; padding-left: 2px\">Status</div><span flex=\"5\">:</span><div flex \nstyle=\"font-size : 12px\">{{ vm.reffData.status }}</div></div><md-input-container layout=\"row\" class=\"md-block\" flex>\n<label>Request Letter Type</label><md-select \nng-disabled=\"vm.readOnly ||  vm.reffData.status == \'progress\' || vm.reffData.status == \'finished\'\" required \nname=\"request_type\" ng-model=\"vm.Form.objForm.request_type\"><md-option><em>None</em></md-option><md-option \nng-repeat=\"item in vm.requestType\" ng-value=\"item.id\">{{ item.name }}</md-option></md-select></md-input-container>\n</div><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.Form.objForm.request_type > 1\"><fieldset layout \nlayout-fill layout-align-xs=\"start\"><legend>Visa Requirement</legend><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align-xs=\"start stretch\" layout-align=\"start center\"><md-input-container class=\"small-space\" flex-gt-sm=\"33\">\n<label>Destination</label><md-select ng-disabled=\"vm.readOnly\" required name=\"travel_destination\" \nng-model=\"vm.Form.objForm.travel_destination\" md-on-close=\"vm.clearSearchTerm()\" \ndata-md-container-class=\"selectHeader\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search Country Destination\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup\n label=\"select Country\"><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.countryCodes |\n                                            filter:vm.searchTerm track by item.id\">\n{{item.nicename }}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"small-space\" \nflex-gt-sm=\"33\"><label>Start Date</label><md-datepicker ng-disabled=\"vm.readOnly\" name=\"start_date\" required \nstyle=\"padding-bottom:0px\" md-hide-icons=\"all\" md-open-on-focus ng-model=\"vm.tmpTravelStartDate\" \nmd-current-view=\"month\"></md-datepicker></md-input-container><md-input-container class=\"small-space\" flex-gt-sm=\"33\">\n<label>End Date</label><md-datepicker ng-disabled=\"vm.readOnly\" name=\"end_date\" required style=\"padding-bottom:0px\" \nmd-hide-icons=\"all\" md-open-on-focus ng-model=\"vm.tmpTravelEndDate\" md-min-date=\"vm.tmpTravelStartDate\" \nmd-current-view=\"month\"></md-datepicker></md-input-container><md-input-container class=\"small-space\" flex-gt-sm=\"33\">\n<label>Passport</label><input ng-disabled=\"vm.readOnly\" type=\"text\" required ng-model=\"vm.Form.objForm.passport\">\n</md-input-container></div></fieldset></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.Form.objForm.request_type == 1\"><md-input-container class=\"md-block\" flex><label>Requirement</label>\n<md-select ng-disabled=\"vm.readOnly\" required name=\"requirement\" ng-model=\"vm.Form.objForm.requirement\"><md-option><em>\nNone</em></md-option><md-option ng-repeat=\"item in vm.requirements\" ng-value=\"item.id\">{{ item.name }}</md-option>\n</md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" flex><div \nlayout-align=\"start center\" flex class=\"form-message\" ng-class=\"{success:vm.success, error:!vm.success}\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{ vm.Form.pesan }}</div><div flex=\"40\" layout-align=\"end center\" \nlayout=\"row\"><md-button ng-if=\"vm.create\" class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.storeRequest($event,formCorrespondence)\" ng-disabled=\"formCorrespondence.$invalid || vm.saveProcess\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button \nng-if=\"vm.update && !vm.readOnly\" class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.updateRequest($event,formCorrespondence)\" \nng-disabled=\"formCorrespondence.$invalid || vm.updateProcess || formCorrespondence.$pristine\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Update</md-button><md-button ng-if=\"!vm.readOnly\" \nng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button><md-button \nng-if=\"vm.readOnly\" ng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon>Close</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/correspondence/requirement/form/form.html","<md-dialog aria-label=\"Create Correspondence Request\" md-theme=\"modal-theme\" ms-scroll flex=\"50\" \nid=\"correspondence-dialog\"><form ng-cloak name=\"formCorrespondence\" class=\"md-inline-form\" novalidate ng-submit=\"\">\n<md-toolbar><div class=\"md-toolbar-tools title\"><h4>{{ vm.dialogType }} Correspondence Request</h4><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear ng-show=\"vm.loadingProgress\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-dialog-content \nng-class=\"{\'blurify\' : vm.loadingProgress, \'no-blurify\' : !vm.loadingProgress}\" layout-fill style=\"margin-top:0px\"><div\n layout=\"column\" flex layout-padding><md-input-container layout=\"row\" class=\"md-block\" flex><label>Requirement</label>\n<textarea required name=\"name\" ng-model=\"vm.Form.objForm.name\" cols=\"10\" rows=\"5\"></textarea></md-input-container>\n<md-input-container layout=\"row\" class=\"md-block\" flex><label>Status</label><md-select required name=\"status\" \nng-model=\"vm.Form.objForm.status\"><md-option><em>None</em></md-option><md-option value=\"active\">Active</md-option>\n<md-option value=\"inactive\">Inactive</md-option></md-select></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" flex><div layout-align=\"start center\" flex class=\"form-message\" \nng-class=\"{success:vm.success, error:!vm.success}\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{ vm.Form.pesan }}</div>\n<div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button ng-if=\"vm.create\" \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.storeRequest($event,formCorrespondence)\" \nng-disabled=\"formCorrespondence.$invalid || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-if=\"vm.update\" \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.updateRequest($event,formCorrespondence)\" \nng-disabled=\"formCorrespondence.$invalid || vm.updateProcess || formCorrespondence.$pristine\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Update</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/behivor/config/input-config/input-config.html","<md-dialog aria-label=\"{{vm.title}} Behaviour Config\" flex=\"45\" id=\"formBehivorConfig\"><form ng-cloak \nname=\"formConfig\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formConfig)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{vm.title}} Behaviour Config</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><md-input-container flex><label>Effective Date\n</label><md-datepicker ng-model=\"vm.Form.objForm.effectiveDate\" name=\"effectiveDate\" id=\"effectiveDate\" \naria-label=\"effective date\" required></md-datepicker><div ng-messages=\"formConfig.effectiveDate.$error\"><div \nng-message=\"valid\">The entered value is not a date!</div><div ng-message=\"required\">This date is required!</div></div>\n</md-input-container></div><div class=\"title\">Reference</div><div ng-repeat=\"ref in vm.listRef\"><md-checkbox \nng-model=\"vm.Form.objForm.refId[ref.id]\" checklist-model=\"vm.listSelected\" checklist-value=\"ref.id\">{{ref.initial}}\n</md-checkbox></div><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" ng-disabled=\"formConfig.$invalid\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button \nclass=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh white-fg\">\n</md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/behivor/ref/input-ref/input-ref.html","<md-dialog aria-label=\"New Behaviour Reference\" flex=\"45\" id=\"formBehivorRef\"><form ng-cloak name=\"formRef\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formRef)\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>New Behaviour Reference</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\"><md-input-container flex=\"33\"><input type=\"text\" name=\"initial\" \nng-model=\"vm.Form.objForm.initial\" placeholder=\"Initial\" required><div ng-messages=\"formRef.initial.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Reference Initial is required.</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex><textarea name=\"description\" ng-model=\"vm.Form.objForm.description\" \nplaceholder=\"Description\" required></textarea><div ng-messages=\"formRef.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Reference Description is required.</span></div></div></md-input-container></div><ms-widget \nflippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" ng-disabled=\"formRef.$invalid\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button \nclass=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh white-fg\">\n</md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/behivor/input/input-input/input-input.html","<md-dialog aria-label=\"{{vm.title}} Behaviour Performance\" flex=\"45\" id=\"formBehivorPerformance\"><form ng-cloak \nname=\"formPerformance\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formPerformance)\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>{{vm.title}} Behaviour Performance</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nng-repeat=\"ref in vm.listInput\"><md-input-container flex=\"10\"><div class=\"title\">{{ref.initial}}</div>\n</md-input-container><md-input-container flex=\"25\"><input type=\"number\" name=\"result{{$index}}\" \nng-model=\"vm.Form.objForm.result[$index]\" placeholder=\"Result\" ng-value=\"{{ref.result}}\" required><div \nng-messages=\"formPerformance[\'result\'+ref.id].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nResult {{ref.initial}} is required.</span></div></div></md-input-container></div><ms-widget flippable=\"false\" \nlayout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-disabled=\"formPerformance.$invalid\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save\n</md-button><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/echeckin/stepper-steps/horizontal/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.mpnRequest.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"horizontalStep1.firstname.$error\" ng-show=\"horizontalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.mpnRequest.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"horizontalStep1.lastname.$error\" ng-show=\"horizontalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/echeckin/stepper-steps/horizontal/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.mpnRequest.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/echeckin/stepper-steps/horizontal/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.mpnRequest.step3.ssn\" placeholder=\"Social Security Number\">\n</md-input-container></div></div>");
$templateCache.put("app/main/echeckin/stepper-steps/horizontal/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.mpnRequest.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"horizontalStep4.address.$error\" ng-show=\"horizontalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/echeckin/stepper-steps/horizontal/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.mpnRequest.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"horizontalStep5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.mpnRequest.step5.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"horizontalStep5.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.mpnRequest.step5.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required><div \nng-messages=\"horizontalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>CC2 field is required.\n</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"expirationDate\" \nng-model=\"vm.mpnRequest.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"horizontalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/echeckin/stepper-steps/vertical/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.verticalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"verticalStep1.firstname.$error\" ng-show=\"verticalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.verticalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"verticalStep1.lastname.$error\" ng-show=\"verticalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/echeckin/stepper-steps/vertical/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.verticalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/echeckin/stepper-steps/vertical/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.verticalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/echeckin/stepper-steps/vertical/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.verticalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"verticalStep4.address.$error\" ng-show=\"verticalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/echeckin/stepper-steps/vertical/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.verticalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"step5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>Card holder field is required.\n</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" \nflex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" ng-model=\"vm.verticalStepper.step5.cardnumber\" \nplaceholder=\"Card Number\" required><div ng-messages=\"verticalStep5.cardnumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Card number field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"CC2\" ng-model=\"vm.verticalStepper.step5.cc2\" placeholder=\"CC2\" \nmd-maxlength=\"3\" required><div ng-messages=\"verticalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\">\n<span>CC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.verticalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"verticalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/cb/admin-department/input/input.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"form\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.save($event,form)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nForm Input Type Admin Department</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear>\n<md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div class=\"layout-gt-sm-row border-horizontal\"></div>\n<div class=\"white-bg\"><div layout-gt-sm=\"row\"><md-input-container flex><label>Sub Area</label><md-select \nng-model=\"vm.Form.objForm.sub_area_id\" name=\"sub_area_id\" required \nng-change=\"vm.getListGedung(vm.Form.objForm.sub_area_id)\"><md-option ng-repeat=\"ls in vm.listSubArea\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"form.sub_area_id.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-input-container\n flex><label>Group Shift</label><md-select ng-model=\"vm.Form.objForm.group_shift_id\" name=\"group_shift_id\"><md-option \nng-repeat=\"ls in vm.listGroupShift\" placeholder=\"Group Shift\" value=\"{{ls.id}}\">{{ls.shift_group_name}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.group_shift_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSector field is required.</span></div></div></md-input-container><md-input-container flex><label>Effective Date</label>\n<md-datepicker md-hide-icons=\"calendar\" aria-label=\"effective_date\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" ng-required=\"vm.isSector\"></md-datepicker><div \nng-messages=\"frmEmploye.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date is required.</span></div></div></md-input-container><md-input-container flex><label>NIK</label><input \ntype=\"text\" name=\"nik\" ng-model=\"vm.Form.objForm.nik\" required=\"\"><div ng-messages=\"form.nik.$error\" role=\"alert\"><div \nng-message=\"required\"><span>NIK field is required.</span></div></div></md-input-container></div><div layout=\"row\" \nclass=\"toolbar-subarea\"><md-list><md-list-item class=\"md-offset\" ng-repeat=\"item in vm.listGedung\"><span>\n{{item.gedung_name}}</span><md-checkbox class=\"md-secondary\" ng-change=\"vm.getListSector(item.gedung_id)\">\n</md-checkbox><md-list><md-list-item class=\"md-no-proxy\" ng-repeat=\"sector in vm.listSector\"><span>{{}}</span>\n</md-list-item></md-list></md-list-item></md-list></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-if=\"vm.notif.success || vm.notif.error\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span ng-if=\"vm.notif.success\">{{vm.notif.success}}</span> <span \nng-if=\"vm.notif.error\">{{vm.notif.error}}</span></p></ms-widget-front></ms-widget><span flex></span><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"form.$invalid || form.$pristine\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/am-store-incharge/am-input-sic/am-input-sic.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Form Input SM</md-subheader><div class=\"white-bg\"><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputAMSic\" \nclass=\"md-inline-form custom-page\" novalidate ng-submit=\"vm.saveData(formInputAMSic)\"><div layout=\"column\">\n<md-autocomplete md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItem\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(ls)\" md-items=\"ls in vm.querySearch(vm.searchText)\" \nmd-item-text=\"ls.display\" md-min-length=\"0\" md-floating-label=\"{{\'MENU.CB.STORE_INCHARGE.FORM.SIC_NIK\' | translate}}\" \nmd-clear-button=\"true\" md-input-name=\"sic_nik\" class=\"drop-mod mt-15\" flex flex-gt-xs=\"70\" required><md-item-template>\n<span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{ls.display}}</span></md-item-template><md-not-found>\nNo NIK/Name matching \"{{vm.searchText}}\" were found.</md-not-found><div ng-messages=\"formInputAMSic.sic_nik.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"VALIDATION.NIK_REQUIRED\">SM NIK is required.</span></div>\n</div></md-autocomplete></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"drop-mod\" flex><label \ntranslate=\"MENU.CB.STORE_INCHARGE.FORM.SUB_AREA\">Sub area</label><md-select ng-model=\"vm.Form.objForm.sic_subarea\" \nname=\"sic_subarea\" md-on-close=\"vm.clearSearchTermSA()\" required ng-disabled=\"vm.checkItemEmpty()\"><md-select-header>\n<input ng-model=\"vm.searchTermSA\" type=\"search\" placeholder=\"Search for sub area\" class=\"md-text\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option ng-value=\"ls.subarea_id\" \nng-repeat=\"ls in vm.listSubArea | filter:vm.searchTermSA\">{{ls.description}}</md-option></md-select><div \nclass=\"hint text-bold\" ng-if=\"vm.checkItemEmpty()\">Please Select NIK/Name First</div><div \nng-messages=\"formInputAMSic.sic_subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSub Area field is required.</span></div></div></md-input-container><span flex-gt-xs=\"5\" hidden-xs></span>\n<md-input-container flex><label translate=\"MENU.CB.STORE_INCHARGE.FORM.EFFECTIVE_DATE\">Effective date</label>\n<md-datepicker ng-change=\"vm.clearMessage()\" md-hide-icons=\"calendar\" aria-label=\"sic_effective_date\" \nname=\"sic_effective_date\" ng-model=\"vm.Form.objForm.sic_effective_date\" md-open-on-focus required \nonkeydown=\"return false\"></md-datepicker><div ng-messages=\"formInputAMSic.sic_effective_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"VALIDATION.EFFECTIVE_DATE_REQUIRED\">SM Effective Date is required.</span></div>\n</div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\"><span translate=\"ACTION.RELOAD_TOKEN\">Reload Token</span></md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputAMSic.$invalid || formInputAMSic.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span>\n</md-button><md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\"><span \ntranslate=\"ACTION.BACK\">Back</span></md-button></div></form></div></div></div></div></md-content></div>");
$templateCache.put("app/main/cb/am-team-assignment/am-uploadfile/am-uploadfile.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Upload File</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" \nstyle=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\">\n</md-icon>Upload</md-button></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>{{vm.pesan}}</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>{{vm.pesan}}</span></md-whiteframe></md-content></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/cb/am-team-assignment/input-am-team-assignment/input-am-team-assignment.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout=\"column\"><md-subheader \nclass=\"white-bg\">Form Input Temporary Assignment</md-subheader><div class=\"white-bg\"><div class=\"scrollable\" \nlayout=\"column\" ms-scroll=\"{suppressScrollX: true}\"><form ng-cloack id=\"FormTeamAssignment\" name=\"FormTeamAssignment\" \nclass=\"popup-input-form\" novalidate ng-submit=\"vm.saveData($event,FormTeamAssignment)\" layout=\"column\" flex><div \nlayout=\"column\" flex md-theme=\"nabati1\" class=\"m-15\"><div layout=\"column\" flex class=\"m-15\"><div layout=\"column\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm=\"25\"><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"startDate\" ng-model=\"vm.Form.objForm.startDate\" required \nng-change=\"vm.reinitEndDate(vm.Form.objForm.startDate)\"></md-datepicker><span class=\"hint-text font-size-12\">\nTanggal Pindah Ke Sub Area Tujuan</span><div ng-messages=\"FormTeamAssignment.startDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date Required.</span></div></div></md-input-container><md-input-container flex \nflex-gt-sm=\"25\" flex-offset-gt-sm=\"5\"><label>End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"endDate\" \nmd-min-date=\"vm.initDate\" ng-model=\"vm.Form.objForm.endDate\" required></md-datepicker><span \nclass=\"hint-text font-size-12\">Tanggal Pulang Ke Sub Area Asal</span><div \nng-messages=\"FormTeamAssignment.endDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date Required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-sm=\"40\" flex-offset-gt-sm=\"5\"><label>Sub Area</label>\n<md-select ng-model=\"vm.Form.objForm.sub_area_id\" ng-change=\"vm.loadDirectName()\" name=\"sub_areaId\" required \nmd-on-close=\"vm.clearSearchTermSA()\"><md-select-header><input ng-model=\"vm.searchTermSA\" type=\"search\" \nplaceholder=\"Search for sub area\" class=\"md-text\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listSubArea | filter:vm.searchTermSA\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><span class=\"hint-text font-size-12\">Sub Area Tujuan</span><div \nng-messages=\"FormTeamAssignment.sub_areaId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSub Area field is required.</span></div></div></md-input-container></div></div></div><md-divider flex \nclass=\"mt-5 mb-30\"></md-divider><div layout=\"column\" layout-align=\"start start\" class=\"mb-10\" flex><md-button \nflex=\"nogrow\" class=\"md-mini md-raised md-accent\" type=\"button\" aria-label=\"Insert\" ng-click=\"vm.addEmployee($event)\">\n<md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-plus material-icons\"></md-icon><span>Add Employee</span>\n</md-button></div><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nclass=\"font-size-12\"><th width=\"60px\">No</th><th style=\"min-width: 100px\">NIK / Nama</th><th>Jarak</th><th \nwidth=\"200px\" ng-repeat=\"ls in vm.listBenefitsTitle\" style=\"word-wrap: break-word; white-space: normal\">\n{{ls.description}}</th><th width=\"40px\"></th></tr></thead><tbody><tr ng-if=\"vm.Form.objForm.employee.length == 0\"><td \ncolspan=\"{{vm.listBenefitsTitle.length + 4}}\" class=\"text-center font-size-12\"><span class=\"pv-15\">\nMinimal input karyawan 1.</span></td></tr><tr ng-if=\"vm.Form.objForm.employee.length > 0\" \nng-repeat=\"data in vm.Form.objForm.employee\" ng-init=\"parentIdx = $index\"><td class=\"text-center\">{{parentIdx + 1}}\n</td><td><md-input-container id=\"nik-inputer\" class=\"mt-20 nik-inputer\" layout=\"row\"><md-autocomplete \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItem[parentIdx]\" \nmd-search-text-change=\"vm.searchTextChange(parentIdx)\" md-search-text=\"vm.searchText[parentIdx]\" \nmd-selected-item-change=\"vm.selectedItemChange(ls, parentIdx)\" \nmd-items=\"ls in vm.querySearch(vm.searchText[parentIdx])\" md-item-text=\"ls.nik + \' - \' + ls.empName\" md-min-length=\"0\" \nmd-floating-label=\"NIK / Name\" md-input-name=\"autocomplete[{{parentIdx}}]\" md-menu-class=\"employee-choose\" \nmd-clear-button=\"true\" required flex><md-item-template><div layout=\"column\"><span md-highlight-flags=\"^i\">\n{{ls.nik}} - {{ls.empName}}</span> <span md-highlight-flags=\"^i\">{{ls.subAreaName}}</span></div></md-item-template>\n<md-not-found>No NIK/NAME matching \"{{vm.searchText[parentIdx]}}\" were found.</md-not-found><div \nng-if=\"vm.Form.objForm.employee[parentIdx].subAreaName\" class=\"hint\">\nOutlet Asal: {{vm.Form.objForm.employee[parentIdx].subAreaName}}</div><div \nng-messages=\"FormTeamAssignment[\'autocomplete\'][parentIdx].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNIK / Name Required.</span></div></div></md-autocomplete></md-input-container></td><td><md-input-container \nlayout=\"row\" class=\"mt-10\" layout-align=\"start center\"><label>Distance</label><md-select class=\"full-width\" \nng-model=\"vm.Form.objForm.employee[parentIdx].distance\" placeholder=\"{{ls.description}}\" \nng-disabled=\"vm.getEmptyDataNULL(vm.Form.objForm.employee[parentIdx].nik)\" required \nname=\"distance[{{parentIdx}}][{{$index}}]\" ng-change=\"vm.onChangeDistance(parentIdx)\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.listDistances\" arial-label=\"\">{{item.description}}</md-option></md-select><div \nng-messages=\"FormTeamAssignment[\'distance\'][parentIdx][$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDistance Required.</span></div></div></md-input-container></td><td \nng-if=\"vm.Form.objForm.employee[parentIdx].benefits.length > 0\" \nng-repeat=\"ls in vm.Form.objForm.employee[parentIdx].benefits\" custom-repeat-directive><md-input-container><md-select \nng-show=\"vm.Form.objForm.employee[parentIdx].benefits[$index].benefits.length > 1\" \nng-model=\"vm.Form.objForm.employee[parentIdx].benefit[$index]\" placeholder=\"{{ls.description}}\" \nng-disabled=\"vm.getEmptyDataNULL(vm.Form.objForm.employee[parentIdx].nik) || vm.getEmptyDataNULL(vm.Form.objForm.employee[parentIdx].distance) || vm.getDataAvail(ls.grouping)\" \nname=\"benefit_id[{{parentIdx}}][{{$index}}]\" ng-required=\"false\"><md-option class=\"list-option\" ng-value=\"item\" \nng-repeat=\"item in ls.benefits\" \nng-selected=\"item.grade === vm.Form.objForm.employee[$parent.parentIdx].emp_grade ? \'selected\' : \'\'\" \narial-label=\"{{item.grade + \' - \' + vm.Form.objForm.employee[$parent.parentIdx].benefit[parentIdx]}}\" \nstyle=\"height: auto\"><div ng-if=\"item.id != 0\" layout=\"column\" class=\"pv-10\"><div>Grade: {{item.grade}}</div><div>\n{{item.description}}</div><div>{{item.amount_formated}}</div></div><div ng-if=\"item.id == 0\" layout=\"column\" \nclass=\"pv-10\"><div>None</div></div></md-option></md-select><div \nng-show=\"vm.Form.objForm.employee[parentIdx].benefits[$index].benefits.length <= 1\" class=\"hint\">Tidak Ada Benefit\n</div><span class=\"font-size-12 hint-text\" ng-if=\"vm.Form.objForm.employee[parentIdx].new_employee\">\nNo Benefit Available</span></md-input-container></td><td \nng-if=\"vm.Form.objForm.employee[parentIdx].benefits.length == 0\" ng-repeat=\"ls in vm.listBenefitsTitle\" \ncustom-repeat-directive><span class=\"font-size-12 hint-text\">Silahkan pilih karyawan dan jarak.</span></td><td \naria-label=\"{{vm.Form.objForm.employee[parentIdx].benefits.length}}\"><md-button \nclass=\"md-icon-button md-warn-fg button-cancel\" ng-click=\"vm.cancelEmployee($event, parentIdx)\" flex><md-tooltip \nmd-direction=\"bottom\">Cancel Employee</md-tooltip><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr>\n</tbody></table></div><md-divider flex class=\"mh-15 mt-30\"></md-divider><div layout=\"column\" flex class=\"m-15\"><div \nlayout=\"column\" class=\"mh-15 pt-15 pb-25\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex \nflex-gt-sm=\"25\"><label>Company</label><md-select ng-model=\"vm.Form.objForm.company_id\" name=\"company_id\" \nng-change=\"vm.loadDataDivision(vm.Form.objForm.company_id)\" required ng-disabled=\"!vm.Form.objForm.employee[0].nik\">\n<md-option ng-repeat=\"ls in vm.listBU\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"FormTeamAssignment.company_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-sm=\"25\" \nflex-offset-gt-sm=\"5\"><label>Division</label><md-select ng-model=\"vm.Form.objForm.dvision_id\" \nng-disabled=\"!vm.Form.objForm.company_id\" name=\"dvision_id\" \nng-change=\"vm.loadDataDepartment(vm.Form.objForm.dvision_id)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><span class=\"font-size-12 hint-text\">Divisi Tujuan</span>\n<div ng-messages=\"FormTeamAssignment.dvision_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivision field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-sm=\"40\" \nflex-offset-gt-sm=\"5\"><label>Department</label><md-select ng-model=\"vm.Form.objForm.department_id\" \nng-change=\"vm.loadDirectName()\" ng-disabled=\"!vm.Form.objForm.dvision_id\" name=\"department_id\" required><md-option \nng-repeat=\"ls in vm.listDepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><span \nclass=\"font-size-12 hint-text\">Department Tujuan</span><div ng-messages=\"FormTeamAssignment.department_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm=\"45\"><label>Cost Center CNB</label>\n<md-select ng-model=\"vm.Form.objForm.cost_center_cnb\" name=\"cost_center_cnb\" required \nmd-on-close=\"vm.clearSearchTermCCC()\"><md-select-header><input ng-model=\"vm.searchTermCCC\" type=\"search\" \nplaceholder=\"Search for Cost Center CNB\" class=\"md-text\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listcnb | filter:vm.searchTermCCC\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><span class=\"font-size-12 hint-text\">Cost Center CNB yang akan berlaku</span>\n<div ng-messages=\"FormTeamAssignment.cost_center_cnb.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCost Center CNB Required.</span></div></div></md-input-container><md-input-container flex flex-gt-sm=\"45\" \nflex-offset-gt-sm=\"10\"><label>Cost Center Non CNB</label><md-select ng-model=\"vm.Form.objForm.cost_center_noncnb\" \nname=\"cost_center_noncnb\" required md-on-close=\"vm.clearSearchTermCCNC()\"><md-select-header><input \nng-model=\"vm.searchTermCCNC\" type=\"search\" placeholder=\"Search for Cost Center Non CNB\" class=\"md-text\" \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"ls in vm.listnoncnb | filter:vm.searchTermCCNC\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n<span class=\"font-size-12 hint-text\">Cost Center Non CNB yang akan berlaku</span><div \nng-messages=\"FormTeamAssignment.cost_center_noncnb.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCost Center Non CNB Required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Direct Report Name</label><md-select ng-model=\"vm.Form.objForm.directReport\" \nng-disabled=\"!vm.Form.objForm.sub_area_id\" name=\"directReport\" required \nng-change=\"vm.directReportNamChanged(vm.Form.objForm.directReport)\"><md-option ng-repeat=\"ls in vm.listDirectName\" \nvalue=\"{{ls.nik}}\">{{ls.nik}} - {{ls.fullname}} {{vm.getDetailDirectReport(ls)}}</md-option></md-select><span \nclass=\"font-size-12 hint-text\">Direct Report Incharge tujuan</span><div \nng-messages=\"FormTeamAssignment.directReport.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDirect Report field is required.</span></div></div></md-input-container></div><div layout=\"column\"><md-input-container \nflex><label>Description</label><input ng-model=\"vm.Form.objForm.description\" name=\"description\" required \nminlength=\"25\" ng-keyup=\"vm.getStrLength(vm.Form.objForm.description)\"><div style=\"display: inline-block\" \nclass=\"font-size-12\">Character: {{vm.getMinLength(vm.Form.objForm.description)}}</div><div \nng-messages=\"FormTeamAssignment.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription field is required.</span></div><div ng-message=\"minlength\"><span>\nDescription field is too short minimum 25 Characters.</span></div></div></md-input-container></div></div></div>\n<md-divider></md-divider><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" class=\"pv-15\"><md-button \ntype=\"button\" ng-click=\"vm.reloadToken()\" class=\"md-raised md-warn\" aria-label=\"Reload\"><span \ntranslate=\"ACTION.RELOAD_TOKEN\">Reload Token</span></md-button><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"FormTeamAssignment.$invalid\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n<md-button type=\"button\" ui-sref=\"app.cb_am_team_assignment\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\"><span\n translate=\"ACTION.BACK\">Back</span></md-button></div></form></div></div></div></md-content></div>");
$templateCache.put("app/main/cb/am-team-assignment/input-am-team-assignment/input-am-team-nso-assignment.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout=\"column\"><md-subheader \nclass=\"white-bg\">Form Input NSO Crew Temporary Assignment</md-subheader><div class=\"white-bg\"><div class=\"scrollable\" \nlayout=\"column\" ms-scroll=\"{suppressScrollX: true}\"><form ng-cloack id=\"FormTeamAssignment\" name=\"FormTeamAssignment\" \nclass=\"popup-input-form\" novalidate ng-submit=\"vm.saveData($event,FormTeamAssignment)\" layout=\"column\" flex><div \nlayout=\"column\" flex md-theme=\"nabati1\" class=\"m-15\"><div layout=\"column\" flex class=\"m-15\"><div layout=\"column\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm=\"25\"><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"startDate\" ng-model=\"vm.Form.objForm.startDate\" required \nng-change=\"vm.reinitEndDate(vm.Form.objForm.startDate)\"></md-datepicker><span class=\"hint-text font-size-12\">\nTanggal Pindah Ke Sub Area Tujuan</span><div ng-messages=\"FormTeamAssignment.startDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date Required.</span></div></div></md-input-container><md-input-container flex \nflex-gt-sm=\"25\" flex-offset-gt-sm=\"5\"><label>End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"endDate\" \nmd-min-date=\"vm.initDate\" ng-model=\"vm.Form.objForm.endDate\" required></md-datepicker><span \nclass=\"hint-text font-size-12\">Tanggal Pulang Ke Sub Area Asal</span><div \nng-messages=\"FormTeamAssignment.endDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date Required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-sm=\"40\" flex-offset-gt-sm=\"5\"><label>Sub Area</label>\n<md-select ng-model=\"vm.Form.objForm.sub_area_id\" ng-change=\"vm.loadDirectName()\" name=\"sub_areaId\" required \nmd-on-close=\"vm.clearSearchTermSA()\"><md-select-header><input ng-model=\"vm.searchTermSA\" type=\"search\" \nplaceholder=\"Search for sub area\" class=\"md-text\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"ls in vm.listSubArea | filter:vm.searchTermSA\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><span class=\"hint-text font-size-12\">Sub Area Tujuan</span><div \nng-messages=\"FormTeamAssignment.sub_areaId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSub Area field is required.</span></div></div></md-input-container></div></div></div><md-divider flex \nclass=\"mt-5 mb-30\"></md-divider><div layout=\"column\" layout-gt-xs=\"row\"><div layout=\"column\" flex flex-gt-xs=\"50\"><div \nlayout=\"column\" layout-align=\"start start\" class=\"mb-10\" flex=\"nogrow\"><md-button flex=\"nogrow\" \nclass=\"md-mini md-raised md-accent\" type=\"button\" aria-label=\"Insert\" ng-click=\"vm.addEmployee($event)\"><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-plus material-icons\"></md-icon><span>Add Employee</span>\n</md-button></div><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr \nclass=\"font-size-12\"><th width=\"60px\">No</th><th style=\"min-width: 100px\">NIK / Nama</th><th width=\"40px\"></th></tr>\n</thead><tbody><tr ng-if=\"vm.Form.objForm.employee.length == 0\"><td colspan=\"{{vm.listBenefitsTitle.length + 4}}\" \nclass=\"text-center font-size-12\"><span class=\"pv-15\">Minimal input karyawan 1.</span></td></tr><tr \nng-if=\"vm.Form.objForm.employee.length > 0\" ng-repeat=\"data in vm.Form.objForm.employee\" ng-init=\"parentIdx = $index\">\n<td class=\"text-center\">{{parentIdx + 1}}</td><td><md-input-container id=\"nik-inputer\" class=\"mt-20 nik-inputer\" \nlayout=\"row\"><md-autocomplete md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItem[parentIdx]\" \nmd-search-text-change=\"vm.searchTextChange(parentIdx)\" md-search-text=\"vm.searchText[parentIdx]\" \nmd-selected-item-change=\"vm.selectedItemChange(ls, parentIdx)\" \nmd-items=\"ls in vm.querySearch(vm.searchText[parentIdx])\" md-item-text=\"ls.nik + \' - \' + ls.empName\" md-min-length=\"0\" \nmd-floating-label=\"NIK / Name\" md-input-name=\"autocomplete[{{parentIdx}}]\" md-menu-class=\"employee-choose\" \nmd-clear-button=\"true\" required flex><md-item-template><div layout=\"column\"><span md-highlight-flags=\"^i\">\n{{ls.nik}} - {{ls.empName}}</span> <span md-highlight-flags=\"^i\">{{ls.subAreaName}}</span></div></md-item-template>\n<md-not-found>No NIK/NAME matching \"{{vm.searchText[parentIdx]}}\" were found.</md-not-found><div \nng-if=\"vm.Form.objForm.employee[parentIdx].subAreaName\" class=\"hint\">\nOutlet Asal: {{vm.Form.objForm.employee[parentIdx].subAreaName}}</div><div \nng-messages=\"FormTeamAssignment.autocomplete[parentIdx].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNIK / Name Required.</span></div></div></md-autocomplete></md-input-container></td><td \naria-label=\"{{vm.Form.objForm.employee[parentIdx].benefits.length}}\"><md-button \nclass=\"md-icon-button md-warn-fg button-cancel\" ng-click=\"vm.cancelEmployee($event, parentIdx)\" flex><md-tooltip \nmd-direction=\"bottom\">Cancel Employee</md-tooltip><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr>\n</tbody></table></div><div layout=\"column\" flex flex-offset-gt-xs=\"5\" class=\"m-15\"><div layout=\"column\" \nclass=\"mh-15 pt-15 pb-25\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"20\"><label>\nCompany</label><md-select ng-model=\"vm.Form.objForm.company_id\" name=\"company_id\" \nng-change=\"vm.loadDataDivision(vm.Form.objForm.company_id)\" required ng-disabled=\"!vm.Form.objForm.employee[0].nik\">\n<md-option ng-repeat=\"ls in vm.listBU\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"FormTeamAssignment.company_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"35\" \nflex-offset-gt-xs=\"5\"><label>Division</label><md-select ng-model=\"vm.Form.objForm.dvision_id\" \nng-disabled=\"!vm.Form.objForm.company_id\" name=\"dvision_id\" \nng-change=\"vm.loadDataDepartment(vm.Form.objForm.dvision_id)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><span class=\"hint-text\">Divisi Tujuan</span><div \nng-messages=\"FormTeamAssignment.dvision_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivision field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"35\" \nflex-offset-gt-xs=\"5\"><label>Department</label><md-select ng-model=\"vm.Form.objForm.department_id\" \nng-change=\"vm.loadDirectName()\" ng-disabled=\"!vm.Form.objForm.dvision_id\" name=\"department_id\" required><md-option \nng-repeat=\"ls in vm.listDepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><span \nclass=\"hint-text\">Department Tujuan</span><div ng-messages=\"FormTeamAssignment.department_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Department field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Direct Report Name</label><md-select \nng-model=\"vm.Form.objForm.directReport\" ng-disabled=\"!vm.Form.objForm.sub_area_id\" name=\"directReport\" required \nng-change=\"vm.directReportNamChanged(vm.Form.objForm.directReport)\"><md-option ng-repeat=\"ls in vm.listDirectName\" \nvalue=\"{{ls.nik}}\">{{ls.nik}} - {{ls.fullname}} {{vm.getDetailDirectReport(ls)}}</md-option></md-select><span \nclass=\"hint-text\">Direct Report Incharge tujuan</span><div ng-messages=\"FormTeamAssignment.directReport.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Direct Report field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\"><md-input-container flex><label>Description</label><input \nng-model=\"vm.Form.objForm.description\" name=\"description\" required minlength=\"25\" \nng-keyup=\"vm.getStrLength(vm.Form.objForm.description)\"><div style=\"display: inline-block\" class=\"font-size-12\">\nCharacter: {{vm.getMinLength(vm.Form.objForm.description)}}</div><div \nng-messages=\"FormTeamAssignment.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription field is required.</span></div><div ng-message=\"minlength\"><span>\nDescription field is too short minimum 25 Characters.</span></div></div></md-input-container></div></div></div></div>\n</div><md-divider></md-divider><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" class=\"pv-15\">\n<md-button type=\"button\" ng-click=\"vm.reloadToken()\" class=\"md-raised md-warn\" aria-label=\"Reload\"><span \ntranslate=\"ACTION.RELOAD_TOKEN\">Reload Token</span></md-button><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"FormTeamAssignment.$invalid\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n<md-button type=\"button\" ui-sref=\"app.cb_am_team_assignment\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\"><span\n translate=\"ACTION.BACK\">Back</span></md-button></div></form></div></div></div></md-content></div>");
$templateCache.put("app/main/cb/annual-leave-rules/create/create.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"form\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,form)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nForm Input Promotion</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div class=\"layout-gt-sm-row border-horizontal\"></div><div \nclass=\"white-bg\"><div layout-gt-sm=\"row\"><md-input-container class=\"drop-mod\" flex><label>Company</label><md-select \nng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"form.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Required.</span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label>Country</label><md-select \nng-model=\"vm.Form.objForm.country\" name=\"country\" required><md-option ng-repeat=\"ls in vm.listCountry\" \nplaceholder=\"Country\" value=\"{{ls.countrycode}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"form.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Country Required.</span></div></div>\n</md-input-container><md-input-container class=\"drop-mod\" flex><label>Employee Grade</label><md-select \nng-model=\"vm.Form.objForm.emp_grade\" name=\"emp_grade\" required><md-option ng-repeat=\"ls in vm.listEmpGrade\" \nplaceholder=\"Employee Grade\" value=\"{{ls.grade}}\">{{ls.grade}}</md-option></md-select><div \nng-messages=\"form.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee Grade Required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Service Month Start</label>\n<input type=\"number\" ng-model=\"vm.Form.objForm.service_month_start\" placeholder=\"Service Month Start\" \nname=\"service_month_start\" required><div ng-messages=\"form.service_month_start.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Service Month Start Required.</span></div></div></md-input-container><md-input-container \nflex><label>Service Month End</label><input type=\"number\" ng-model=\"vm.Form.objForm.service_month_end\" \nplaceholder=\"Service Month End\" name=\"service_month_end\" required><div ng-messages=\"form.service_month_end.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Service Month End Required.</span></div></div></md-input-container>\n<md-input-container flex><label>Step Anniversary</label><input type=\"number\" \nng-model=\"vm.Form.objForm.step_anniversary\" placeholder=\"Step Anniversary\" name=\"step_anniversary\" required><div \nng-messages=\"form.step_anniversary.$error\" role=\"alert\"><div ng-message=\"required\"><span>Step Anniversary Required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>\nAnnual Leave Total</label><input type=\"number\" ng-model=\"vm.Form.objForm.annual_leave_total\" \nplaceholder=\"Annual Leave Total\" name=\"annual_leave_total\" required><div ng-messages=\"form.annual_leave_total.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Annual Leave Required.</span></div></div></md-input-container>\n<md-input-container class=\"drop-mod\" flex><label>Is Pay leave Carry</label><md-select \nng-model=\"vm.Form.objForm.pay_leave_carry\" name=\"pay_leave_carry\" required><md-option value=\"1\">Yes</md-option>\n<md-option value=\"0\">No</md-option></md-select><div ng-messages=\"form.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee Grade Required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Max Carry</label><input type=\"number\" \nng-model=\"vm.Form.objForm.max_carry\" placeholder=\"Max Carry\" name=\"max_carry\" required><div \nng-messages=\"form.max_carry.$error\" role=\"alert\"><div ng-message=\"required\"><span>Annual Leave Required.</span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label>Rule Pay</label><md-select \nng-model=\"vm.Form.objForm.rule_pay\" name=\"rule_pay\" required><md-option value=\"as_it_is\">As Is</md-option><md-option \nvalue=\"lowest\">Lowest</md-option></md-select><div ng-messages=\"form.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Rule Pay Required.</span></div></div></md-input-container><md-input-container flex><label>\nEffective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"form.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date Required.</span></div><div ng-message=\"valid\"><span>\nEffective Date Not Valid.</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-if=\"vm.notif.success || vm.notif.error\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span ng-if=\"vm.notif.success\">{{vm.notif.success}}</span> <span \nng-if=\"vm.notif.error\">{{vm.notif.error}}</span></p></ms-widget-front></ms-widget><span flex></span><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"form.$invalid || form.$pristine\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/annual-leave-rules/edit/edit.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"form\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,form)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nForm Input Promotion</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div class=\"layout-gt-sm-row border-horizontal\"></div><div \nclass=\"white-bg\"><div layout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\">\n<md-input-container class=\"drop-mod\" flex><label>Company</label><md-select ng-model=\"vm.Form.objForm.company\" \nname=\"company\" required><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"form.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company Required.</span></div></div></md-input-container><md-input-container \nclass=\"drop-mod\" flex><label>Country</label><md-select ng-model=\"vm.Form.objForm.country\" name=\"country\" required>\n<md-option ng-repeat=\"ls in vm.listCountry\" placeholder=\"Country\" value=\"{{ls.countrycode}}\">{{ls.name}}</md-option>\n</md-select><div ng-messages=\"form.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Country Required.\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label>Employee Grade</label>\n<md-select ng-model=\"vm.Form.objForm.emp_grade\" name=\"emp_grade\" required><md-option ng-repeat=\"ls in vm.listEmpGrade\" \nplaceholder=\"Employee Grade\" value=\"{{ls.grade}}\">{{ls.grade}}</md-option></md-select><div \nng-messages=\"form.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee Grade Required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Service Month Start</label>\n<input type=\"number\" string-to-number ng-model=\"vm.Form.objForm.service_month_start\" placeholder=\"Service Month Start\" \nname=\"service_month_start\" required><div ng-messages=\"form.service_month_start.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Service Month Start Required.</span></div></div></md-input-container><md-input-container \nflex><label>Service Month End</label><input type=\"number\" string-to-number \nng-model=\"vm.Form.objForm.service_month_end\" placeholder=\"Service Month End\" name=\"service_month_end\" required><div \nng-messages=\"form.service_month_end.$error\" role=\"alert\"><div ng-message=\"required\"><span>Service Month End Required.\n</span></div></div></md-input-container><md-input-container flex><label>Step Anniversary</label><input type=\"number\" \nstring-to-number ng-model=\"vm.Form.objForm.step_anniversary\" placeholder=\"Service Month End\" name=\"step_anniversary\" \nrequired><div ng-messages=\"form.step_anniversary.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStep Anniversary Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Annual Leave Total</label><input type=\"number\" string-to-number \nng-model=\"vm.Form.objForm.annual_leave_total\" placeholder=\"Annual Leave Total\" name=\"annual_leave_total\" required><div \nng-messages=\"form.annual_leave_total.$error\" role=\"alert\"><div ng-message=\"required\"><span>Annual Leave Required.\n</span></div></div></md-input-container><md-input-container class=\"drop-mod\" flex><label>Is Pay leave Carry</label>\n<md-select ng-model=\"vm.Form.objForm.pay_leave_carry\" name=\"pay_leave_carry\" required><md-option value=\"1\">Yes\n</md-option><md-option value=\"0\">No</md-option></md-select><div ng-messages=\"form.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee Grade Required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Max Carry</label><input type=\"number\" string-to-number \nng-model=\"vm.Form.objForm.max_carry\" placeholder=\"Max Carry\" name=\"max_carry\" required><div \nng-messages=\"form.max_carry.$error\" role=\"alert\"><div ng-message=\"required\"><span>Annual Leave Required.</span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label>Rule Pay</label><md-select \nng-model=\"vm.Form.objForm.rule_pay\" name=\"rule_pay\" required><md-option value=\"as_it_is\">As Is</md-option><md-option \nvalue=\"lowest\">Lowest</md-option></md-select><div ng-messages=\"form.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Rule Pay Required.</span></div></div></md-input-container><md-input-container flex><label>\nEffective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"form.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date Required.</span></div><div ng-message=\"valid\"><span>\nEffective Date Not Valid.</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-if=\"vm.notif.success || vm.notif.error\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span ng-if=\"vm.notif.success\">{{vm.notif.success}}</span> <span \nng-if=\"vm.notif.error\">{{vm.notif.error}}</span></p></ms-widget-front></ms-widget><span flex></span><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"form.$invalid || form.$pristine\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/area-manager/detail/am-detail.html","<div layout=\"column\" layout-fill><md-toolbar class=\"md-menu-toolbar md-whiteframe-1dp\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"start center\"><h2>Menu</h2><md-menu flex id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg csm-dropdown\"><md-button ng-click=\"vm.InputAmDetail($event)\"><span>Add Sub Area</span>\n</md-button><md-button ng-click=\"vm.deleteData($event)\"><span>Delete Sub Area</span></md-button></md-menu-content>\n</md-menu></div></md-toolbar><md-content flex layout=\"column\" ms-scroll><div id=\"simple-table\" \nclass=\"simple fullwidth carded with-toolbar-content white-bg\"><md-content class=\"content padding\" layout-fill><div \nclass=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\"><span translate=\"\">\nArea Manager Detail</span></md-subheader><div class=\"white-bg\"><md-toolbar layout-align=\"center end\"><md-button \ntype=\"button\" ng-click=\"vm.back()\" class=\"md-mini md-ink-ripple md-blue-grey-300-bg md-raised white-fg\" \naria-label=\"back\">Back</md-button></md-toolbar><md-content layout=\"column\" ng-if=\"vm.info.length > 0\" \nclass=\"pv-5 ph-15 md-grey-200-bg green-800-fg\"><h4 class=\"mt-5 mb-0 text-bold\">\nArea Manager: {{ vm.info[0].nik }} - {{ vm.info[0].nama }}</h4><p class=\"mt-0 mb-5\">\nRegional Manager: {{ vm.info[0].nik_atasan }} - {{ vm.info[0].nama_atasan }}</p></md-content><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\">\n<thead><tr><th width=\"50px\"><div class=\"table-header\"></div></th><th width=\"70px\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Sub Area</span></div>\n</th><th width=\"150px\"><div class=\"table-header\"><span class=\"column-title\">Effective Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"ls in vm.list\" ng-dblclick=\"vm.editAmDetail($event,ls)\"><td class=\"text-center\"><span>\n<md-checkbox class=\"no-label\" ng-click=\"vm.toggle(ls, vm.listAMDetSelected)\"></md-checkbox></span></td><td \nclass=\"text-center\">{{ ls.no }}</td><td>{{ ls.description }}</td><td class=\"text-center\">{{ ls.effective_date }}</td>\n</tr></tbody></table></md-content></div></div></md-content></div></md-content></div>");
$templateCache.put("app/main/cb/area-manager/detail/input-am-detail.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"40\" md-theme=\"modal-theme\"><form ng-cloack name=\"AmDet\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,AmDet)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\">\n<div class=\"md-toolbar-tools\"><h2>Form Input Area Manager Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout=\"column\"><input type=\"hidden\" name=\"emp_area_manager_id\" ng-model=\"vm.Form.objForm.emp_area_manager_id\"> <input \ntype=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\"><md-input-container><label>Sub Area</label><md-select \nng-model=\"vm.Form.objForm.sub_area_id\" name=\"sub_area\" required md-on-close=\"vm.clearSearchTermSA()\"><md-select-header>\n<input ng-model=\"vm.searchTermSA\" type=\"search\" placeholder=\"Search for sub area\" class=\"md-text\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"sub_area in vm.subArea | filter:vm.searchTermSA\" value=\"{{sub_area.id}}\">{{sub_area.description}}\n</md-option></md-select><div ng-messages=\"AmDet.sub_area_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAM Effective Date is required.</span></div></div></md-input-container><md-input-container style=\"overflow: hidden\">\n<label>Effective date</label><md-datepicker ng-change=\"vm.clearMessage()\" md-hide-icons=\"calendar\" \naria-label=\"effective_date\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker>\n<div ng-messages=\"AmDet.effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"AmDet.$invalid\">Submit\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/area-manager/input-am/input-am.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Form Input Area Manager</md-subheader><div class=\"white-bg\"><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputAM\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.saveData(formInputAM)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" \nname=\"am_nik\" ng-readonly ng-model=\"vm.Form.objForm.nik\" placeholder=\"AM NIK\" ng-change=\"vm.clearMessage()\" required>\n<div ng-messages=\"formInputAM.am_nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>AM NIK is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Effective date</label><md-datepicker \nng-change=\"vm.clearMessage()\" md-hide-icons=\"calendar\" aria-label=\"am_effective_date\" name=\"am_effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div \nng-messages=\"formInputAM.am_effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAM Effective Date is required.</span></div></div></md-input-container></div><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInputAM.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"button\" \nng-click=\"vm.back()\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"back\">Back</md-button></div></form>\n</div></div></div></div></md-content></div>");
$templateCache.put("app/main/cb/attendancelist/input-attendancelist/input-attendancelist.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon ui-sref=\"{{vm.Breadhome}}\" md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><div ng-repeat-start=\"ls  in vm.Breadlist\"></div><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\" ui-sref=\"{{ls.link}}\">{{ls.name}}</span><div ng-repeat-end></div>\n</div><div class=\"title\" translate=\"MENU.CB.ATTENDANCE_REPORT.FORM.TITLE\">Form Input Modul</div></div></div><div \nclass=\"content\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputModul\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputModul)\"><div layout=\"column\"><md-input-container \nflex><input type=\"text\" name=\"menu_name\" ng-model=\"vm.Form.objForm.menu_name\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.FORM.MENU_NAME\' | translate }}\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputModul.menu_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>menu_name is required.\n</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.ATTENDANCE_REPORT.FORM.HAS_SUB\">Has Sub</label><md-select name=\"hassub\" \nng-model=\"vm.Form.objForm.hassub\" required><md-option value=\"1\">1</md-option><md-option value=\"0\">0</md-option>\n</md-select><div ng-messages=\"formInputModul.hassub.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nHassub is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"urut\" \nng-model=\"vm.Form.objForm.urut\" placeholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.FORM.SEQUENCE\' | translate }}\" required><div\n ng-messages=\"formInputModul.urut.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sequence is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Ajax</label><md-select name=\"ajax\" \nng-model=\"vm.Form.objForm.ajax\" required><md-option value=\"yes\"><span translate=\"MENU.CB.ATTENDANCE_REPORT.FORM.YES\">\nYes</span></md-option><md-option value=\"no\"><span translate=\"MENU.CB.ATTENDANCE_REPORT.FORM.NO\">No</span></md-option>\n</md-select><div ng-messages=\"formInputModul.ajax.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAjax is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"level\" \nng-model=\"vm.Form.objForm.level\" placeholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.FORM.LEVEL\' }}\" required><div \nng-messages=\"formInputModul.level.$error\" role=\"alert\"><div ng-message=\"required\"><span>level is required.</span></div>\n</div></md-input-container><md-input-container flex><md-select \nplaceholder=\"{{ \'MENU.CB.ATTENDANCE_REPORT.FORM.PARENT\' | translate }}\" name=\"parent\" \nng-model=\"vm.Form.objForm.parent\"><md-option ng-repeat=\"ls in vm.listParent\" ng-value=\"{{ls.id}}\">\n{{ls.nama | uppercase}}</md-option></md-select><div ng-messages=\"formInputModul.parent.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Parent is required.</span></div></div></md-input-container></div><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\"><span translate=\"ACTION.RELOAD_TOKEN\">Reload Token</span></md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputModul.$invalid || basicForm.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n<md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\"><span \ntranslate=\"ACTION.BACK\">Back</span></md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/cb/checklist-attendance-gw/input-checklist/change-shift.html","<md-dialog aria-label=\"Form Replace Shift\" flex-md=\"50\" flex-gt-md=\"40\"><form ng-cloack name=\"myForm\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>Replace Shift</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-content layout=\"column\"><label style=\"padding: 10px\">Selected Shift: <span class=\"radioValue\" \nng-if=\"vm.Form.objForm.changeShift\">Replace Shift To {{ vm.Form.objForm.changeShift }}</span></label><md-divider>\n</md-divider><md-radio-group ng-model=\"vm.Form.objForm.changeShift\" required><table \nclass=\"simple with-toolbar bordered fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th>#\n</th><th>Start Shift</th><th>End Shift</th><th>Shift</th></tr></thead><tbody><tr><td class=\"text-center\">\n<md-radio-button flex value=\"Default\" class=\"md-primary\"></md-radio-button></td><td class=\"text-center\">\n{{vm.data.shift_default.iStartShiftDT}}</td><td class=\"text-center\">{{vm.data.shift_default.iEndShiftDT}}</td><td \nclass=\"text-center\">Default Shift</td></tr><tr><td class=\"text-center\"><md-radio-button flex value=\"Checklist\" \nclass=\"md-primary\"></md-radio-button></td><td class=\"text-center\"><span ng-if=\"vm.data.checklist.start_shift\">\n{{ vm.data.checklist.start_shift * 1000 | date:\'dd/MMM HH:mm\'}} </span><span ng-if=\"!vm.data.checklist.start_shift\">-\n</span></td><td class=\"text-center\"><span ng-if=\"vm.data.checklist.end_shift\">\n{{ vm.data.checklist.end_shift * 1000 | date:\'dd/MMM HH:mm\'}} </span><span ng-if=\"!vm.data.checklist.end_shift\">-\n</span></td><td class=\"text-center\">Checklist</td></tr></tbody></table></md-radio-group><md-divider></md-divider><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"padding: 10px\"><md-input-container flex><label for=\"comment\">Comment</label>\n<textarea type=\"textarea\" name=\"comment\" id=\"comment\" ng-model=\"vm.Form.objForm.comment\" ng-required=\"true\"></textarea>\n<div ng-messages=\"myForm.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>Comment field is required.\n</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-click=\"vm.saveData(myForm)\" ng-disabled=\"myForm.$invalid || basicForm.$pristine\">Submit\n</md-button><md-button class=\"md-accent md-primary btn-ui-serif\" ng-click=\"vm.closeModal()\">Close</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/checklist-attendance-gw/input-checklist/input-checklist-selected.html","<md-dialog aria-label=\"Checklist Attendance GW - Selected Lists\" flex-md=\"60\" flex-gt-md=\"40\"><form ng-cloack \nname=\"frmSelectedLists\" class=\"md-inline-form\"><md-toolbar class=\"md-green-700-bg\"><div class=\"md-toolbar-tools\"><h2>\nSelected Lists</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\"><md-content layout=\"column\"><md-list ng-cloak><md-list-item \nng-repeat=\"list in vm.listSelected track by $index\"><p>{{($index + 1)}}. {{list.name}} ({{list.nik}})</p><md-checkbox \nclass=\"md-secondary\" ng-model=\"list.confirm\" ng-click=\"vm.checkList($index, list)\"></md-checkbox></md-list-item>\n<md-divider></md-divider></md-list></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-accent\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button>\n<md-button type=\"button\" class=\"md-raised md-green-700-bg\" aria-label=\"Save\" ng-click=\"vm.saveSelected($event)\">\n<md-icon style=\"color: #fff\" md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-raised md-deep-orange-700-bg\" aria-label=\"Remove\" ng-click=\"vm.removeSelected()\"><md-icon \nstyle=\"color: #fff\" md-font-icon=\"icon-delete\"></md-icon></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/checklist-attendance-gw/input-checklist/input-checklist.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\" layout=\"column\">\n<md-content class=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill>\n<md-subheader class=\"white-bg\"><span>Checklist Attendance GW</span></md-subheader><div layout=\"column\" flex><div \nclass=\"form-wrapper\" style=\"background: #F5F6F7\"><form name=\"formInputOT\" cslass=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><span translate=\"MENU.CB.LEAVE.INDEX.HEADER.FILTER_DATA\">Filter Data</span></div>\n<div layout=\"column\" class=\"form-inlinez\" layout-gt-xs=\"row\"><md-input-container flex-c><md-select \nng-model=\"vm.objGedung\" aria-label=\"Building\" name=\"gedung\" ng-change=\"vm.getSector(vm.objGedung)\" required><md-option \nng-repeat=\"ls in vm.listGedung\" ng-selected=\"ls.gedung_id == vm.filterData.gedung\" placeholder=\"Building\" \nvalue=\"{{ls}}\">{{ls.gedung_name}}</md-option></md-select><div ng-messages=\"formInputOT.gedung.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Gedung is required.</span></div></div></md-input-container><md-input-container flex>\n<md-select ng-model=\"vm.sector\" name=\"sector\" aria-label=\"Sector\" required><md-option ng-repeat=\"ls in vm.listSector\" \nng-selected=\"ls.sector_id == vm.filterData.sector\" placeholder=\"Sector\" value=\"{{ls.sector_id}}\">{{ls.sector_name}}\n</md-option></md-select><div ng-messages=\"formInputOT.sector.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSector is required.</span></div></div></md-input-container><md-input-container flex><label>Working Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"working_date\" ng-model=\"vm.working_date\" required></md-datepicker><div \nng-messages=\"formInputOT.working_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Working Date is required.\n</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.shift\" name=\"shift\" \naria-label=\"Shift\" ng-change=\"vm.setIsTime(vm.shift)\" required><md-option \nng-repeat=\"ls in vm.listShift track by $index\" ng-selected=\"ls.shift == vm.filterData.shift\" value=\"{{ls.shift}}\" \nplaceholder=\"Shift Time\">{{ls.shift}} {{ls.shift!=\'Non Group\' ? \'/\' : \'\'}} {{ls.shift_time}}</md-option></md-select>\n<div ng-messages=\"formInputOT.shift.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.shiftGroup\" name=\"shiftGroup\" \naria-label=\"shiftGroup\" required><md-option ng-repeat=\"ls in vm.listShiftGroup track by $index\" \nng-selected=\"ls.id == vm.filterData.shiftGroup\" value=\"{{ls.id}}\" placeholder=\"Shift Group\">{{ls.name}}</md-option>\n</md-select><div ng-messages=\"formInputOT.shift.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nShift Group is required.</span></div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.line\" \naria-label=\"line\" name=\"line\"><md-option ng-repeat=\"ls in vm.listLines track by $index\" placeholder=\"Line\" \nng-selected=\"ls.id == vm.filterData.line\" ng-value=\"ls.id\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.type\" name=\"type\" aria-label=\"type\" required><md-option \nng-repeat=\"ls in vm.listType track by $index\" value=\"{{ls.id}}\" placeholder=\"Type\">{{ls.name}}</md-option></md-select>\n<div ng-messages=\"formInputOT.shift.$error\" role=\"alert\"><div ng-message=\"required\"><span>Type is required.</span>\n</div></div></md-input-container><md-input-container ng-if=\"vm.isTime\" flex><label \ntranslate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.CHANGE_SHIFT.START_TIME\">Start Time</label><input type=\"text\" ng-max=\"24\" \nname=\"start_time\" ng-model=\"vm.startTime\" mask=\"99:99\" mask-placeholder=\"_\" ng-required=\"vm.isTime\" \nng-pattern=\"/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/\"><div ng-messages=\"formInputOT.start_time.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div><div ng-message=\"pattern\"><span>\nInvalid time format, max: 23:59</span></div></div></md-input-container><md-input-container ng-if=\"vm.isTime\" flex>\n<label translate=\"MENU.CB.MY_INFO.MY_ATTENDANCE.CHANGE_SHIFT.END_TIME\">End Time</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.endTime\" mask=\"99:99\" mask-placeholder=\"_\" ng-required=\"vm.isTime\" \nng-pattern=\"/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/\"><div ng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End time is required.</span></div><div ng-message=\"max\"><span>Max 24</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div><div ng-message=\"pattern\"><span>\nInvalid time format, max: 23:59</span></div></div></md-input-container><md-input-container layout=\"column\"><md-button \ntype=\"button\" ng-click=\"vm.loadData(1)\" class=\"md-raised md-primary\" aria-label=\"search\" \nng-disabled=\"formInputOT.$invalid || formInputOT.$pristine\" style=\"margin-top: 0px\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon>Search&nbsp;</md-button></md-input-container></div></form>\n</div></div><md-toolbars md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools\"><md-input-container \nshow-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span hide>\nEntries</span></md-input-container><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini btn-input-checklist-back\" show-gt-sm type=\"button\" \naria-label=\"Inert\" ui-sref=\"app.cb_checklist_attendance_gw\" style=\"padding-top: 4px\"><md-tooltip md-direction=\"right\" \nmd-visible=\"tooltipVisible\">Back</md-tooltip><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>Back</md-button>\n<div class=\"divider-vertical hide show-gt-sm\" show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.Checklist()\"><md-icon md-font-icon=\"icon-verified\"></md-icon><span>Save</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" show-gt-sm></div><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini btn-total-selected\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.showSelected($event)\">Selected: {{vm.listSelected.length}}</md-button><span flex></span> <span flex hide \nshow-gt-sm></span><form ng-submit=\"vm.loadData(1)\" name=\"formSearch\" flex><md-input-container md-no-float \nclass=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\" hide \nshow-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\">\n</md-input-container></form></div></md-toolbars><table hide show-gt-sm \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><td>#</td><th class=\"text-center\" width=\"10%\"><span translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.NIK\"></span>\n</th><th><span translate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.EMPLOYEE_NAME\"></span></th><th><span \ntranslate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.LINE\"></span></th><th><span \ntranslate=\"MENU.MAIN.CB.CHECKLIST_ATTENDANCE_GW.ACTION\">ACTION</span></th><th></th></tr></thead><tbody><tr \nng-repeat=\"team in vm.DataTable.list\" ng-if=\"!team.isChecked\"><td><i ng-if=\"team.checked\" \nclass=\"icon-checkbox-marked-circle green-A700-fg\"></i></td><td class=\"text-center\">{{team.nik}}</td><td>{{team.nama}}\n</td><td flex layout-wrap><md-input-container flex style=\"margin: 0px\"><div>Selected: {{team.linename}}</div><section \nclass=\"md-button-group\" layout=\"row\" style=\"height: 40px\"><md-button ng-model=\"team.line\" aria-label=\"Line\" \nng-repeat=\"ls in team.lines\" ng-click=\"vm.changeLine(ls, team)\" md-colors=\"ls.checked ? {background: \'grey\'}: {}\" \nng-disabled=\"ls.checked\" class=\"md-raised md-primary md-button-group-item\" style=\"min-width: 80px\"><md-tooltip \nmd-direction=\"top\">{{ls.name}}</md-tooltip>{{ls.name}}</md-button></section></md-input-container></td><td flex \nlayout-wrap><md-input-container flex style=\"margin: 0px\"><div>\nSelected: {{team.attCodes.code + \' - \' + team.attCodes.description}}</div><section class=\"md-button-group\" \nlayout=\"row\" style=\"height: 40px\"><md-button ng-disabled=\"!team.line\" ng-model=\"team.attCode\" \naria-label=\"Attedance Code\" ng-repeat=\"ls in team.listAttCode\" ng-click=\"vm.changeAttCode($parent.$index, ls, team)\" \nmd-colors=\"ls.checked&&team.line ? {background: \'grey\'}: {}\" ng-disabled=\"ls.checked&&team.line\" \nclass=\"md-raised md-primary md-button-group-item\" style=\"min-width: 60px\"><md-tooltip md-direction=\"top\">\n{{ls.description}}</md-tooltip>{{ls.code}}</md-button><md-button class=\"md-raised md-button-group-item\" \naria-label=\"Clear Attedance Code\" ng-click=\"vm.clearSelectedAttCode($event, $index, team)\"><i style=\"font-size: 12px\" \nclass=\"icon-refresh\"></i></md-button></section></md-input-container></td><td><md-input-container \nid=\"containerTotalDaysOT\" ng-if=\"team.isRequiredTotalDaysOT\" style=\"margin: 0px\" md-is-error=\"!team.totalDaysOT\"><input\n type=\"number\" name=\"totalDaysOT\" min=\"1\" ng-model=\"team.totalDaysOT\" ng-change=\"vm.setTotalDaysOT($index, team)\" \naria-label=\"Total days OT\" placeholder=\"Total days OT\" aria-invalid=\"true\" ng-required=\"true\"></md-input-container>\n</td></tr><tr ng-if=\"!vm.DataTable.list\"><td colspan=\"6\">Please click SEARCH button first</td></tr></tbody></table>\n<md-content id=\"mobileView\" flex layout-fill hide-gt-sm flex class=\"white-bg\"><md-progress-linear ng-if=\"vm.isLoading\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-list flex><md-list-item class=\"container-mobile slide-down\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\" ng-if=\"vm.DataTable.list.length == 0\" layout-fill>\nData Not Found</md-list-item><md-list-item class=\"container-mobile slide-down\" \nng-repeat-start=\"team in vm.DataTable.list track by $index\" layout=\"row\" ng-click=\"null\" \nlayout-align=\"space-between center\"><div flex=\"90\" layout=\"row\" layout-align=\"start\"><div flex=\"100\" layout=\"column\">\n<div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" \nlayout-align=\"start center\">NIK</div><span class=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" \nlayout-align=\"start center\"><span>{{team.nik}}</span><div style=\"padding-left: 10px\"><i ng-if=\"team.checked\" \nclass=\"icon-checkbox-marked-circle green-A700-fg\"></i></div></div></div><div layout=\"row\" class=\"item-mobile\" \nlayout-align=\"space-between end\"><div flex=\"30\" layout=\"row\" layout-align=\"start center\">Name</div><span \nclass=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" layout-align=\"start center\"><span>\n{{team.name}}</span></div></div><div layout=\"row\" class=\"item-mobile\" layout-align=\"space-between start\"><div \nflex=\"30\" layout=\"row\" layout-align=\"start start\">Line</div><span class=\"divider\" style=\"padding-right:10px\">:</span>\n<div flex layout=\"row\" layout-align=\"start start\"><section class=\"md-button-group\" layout=\"row\"><md-button \nng-model=\"team.line\" aria-label=\"Line\" ng-repeat=\"ls in team.lines\" ng-click=\"vm.changeLine(ls, team)\" \nmd-colors=\"ls.checked ? {background: \'grey\'}: {}\" ng-disabled=\"ls.checked\" \nclass=\"md-raised md-primary md-button-group-item\" style=\"min-width: 80px; margin-top: 0px\"><md-tooltip \nmd-direction=\"top\">{{ls.name}}</md-tooltip>{{ls.name}}</md-button></section></div></div><div layout=\"row\" \nclass=\"item-mobile\" layout-align=\"space-between start\"><div flex=\"30\" layout=\"row\" layout-align=\"start start\">Action\n</div><span class=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" layout-align=\"start start\">\n<md-input-container flex><div>Selected: {{team.attCodes.code + \' - \' + team.attCodes.description}}</div><section \nclass=\"md-button-group md-button-group-section\" layout=\"row\"><md-button ng-disabled=\"!team.line\" \nng-model=\"team.attCode\" ng-repeat=\"ls in team.listAttCode\" ng-click=\"vm.changeAttCode($parent.$index, ls, team)\" \nng-disabled=\"ls.checked&&team.line\" md-colors=\"ls.checked&&team.line ? {background: \'grey\'}: {}\" \nclass=\"md-raised md-primary md-button-group-item\" aria-label=\"Attedance Code\" style=\"min-width: 60px; margin-top: 0px\">\n<md-tooltip md-direction=\"top\">{{ls.description}}</md-tooltip>{{ls.code}}</md-button><md-button \nclass=\"md-raised md-button-group-item\" aria-label=\"Clear Attedance Code\" \nng-click=\"vm.clearSelectedAttCode($event, $index, team)\"><i style=\"font-size: 12px\" class=\"icon-refresh\"></i>\n</md-button></section></md-input-container></div></div><div layout=\"row\" ng-if=\"team.isRequiredTotalDaysOT\" \nclass=\"item-mobile\" layout-align=\"space-between start\"><div flex=\"30\" layout=\"row\" layout-align=\"start start\">\nTotal Days OT</div><span class=\"divider\" style=\"padding-right:10px\">:</span><div flex layout=\"row\" \nlayout-align=\"start start\"><md-input-container layout=\"column\" flex=\"80\" md-is-error=\"!team.totalDaysOT\"><input \ntype=\"number\" name=\"totalDaysOT\" min=\"1\" ng-model=\"team.totalDaysOT\" ng-change=\"vm.setTotalDaysOT($index, team)\" \naria-label=\"Total days OT\" placeholder=\"Total days OT\" ng-required=\"true\"><div \nng-messages=\"formInputOT.totalDaysOT.$error\" role=\"alert\"><div ng-message=\"required\"><span>Total days OT is required.\n</span></div></div></md-input-container></div></div></div></div></md-list-item><md-divider ng-repeat-end></md-divider>\n</md-list></md-content><div class=\"p-10 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></md-content></div>");
$templateCache.put("app/main/cb/checklist-attendance-gw/input-checklist/update-checklist.html","<md-dialog aria-label=\"Form Update Checklist Attendance GW\" flex-md=\"50\" flex-gt-md=\"40\"><form ng-cloack name=\"myForm\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>\nUpdate Checklist Attendance GW</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-content layout=\"column\"><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-if=\"vm.Form.objForm.id_in != null\" style=\"padding: 10px\"><md-input-container flex><label>\nAttendance Code IN</label><md-select ng-model=\"vm.Form.objForm.attendance_code_in\" name=\"attendance_code\"><md-option \nng-repeat=\"ls in vm.listAttCode\" value=\"{{ls.code}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container flex><label for=\"comment\">Comment</label><textarea type=\"textarea\" name=\"comment\" id=\"comment\" \nng-model=\"vm.Form.objForm.comment_in\" ng-required=\"true\"></textarea><div ng-messages=\"myForm.comment.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Comment field is required.</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.Form.objForm.id_out != null\" style=\"padding: 10px\">\n<md-input-container flex><label>Attendance Code Out</label><md-select ng-model=\"vm.Form.objForm.attendance_code_out\" \nname=\"attendance_code\"><md-option ng-repeat=\"ls in vm.listAttCode\" value=\"{{ls.code}}\">{{ls.description}}</md-option>\n</md-select></md-input-container><md-input-container flex><label for=\"comment\">Comment</label><textarea \ntype=\"textarea\" name=\"comment\" id=\"comment\" ng-model=\"vm.Form.objForm.comment_out\" ng-required=\"true\"></textarea><div \nng-messages=\"myForm.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>Comment field is required.</span>\n</div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-click=\"vm.saveData(myForm)\" ng-disabled=\"myForm.$invalid || basicForm.$pristine\">Submit\n</md-button><md-button class=\"md-accent md-primary btn-ui-serif\" ng-click=\"vm.closeModal()\">Close</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/checklist-attendance-gw/uploadfile/uploadfile-log-fail.html","<md-dialog aria-label=\"Form Upload File Checklist Attendance\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Log</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"\">NIK</th><th class=\"text-center\">Note</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.logFail\"><td class=\"text-left\">{{ls.nik}}</td><td class=\"text-left\">{{ls.note}}</td></tr></tbody>\n</table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/cb/checklist-attendance-gw/uploadfile/uploadfile.html","<md-dialog aria-label=\"Form Upload Checklist Attendance GW\" flex-md=\"60\" flex-gt-md=\"50\"><form ng-cloack \nname=\"uploadFile\" class=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2>\nUpload Checklist Attendance GW</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><input type=\"file\" id=\"uploadFile\" \nnv-file-select uploader=\"vm.FileUploader\"></div></div><md-progress-linear ng-if=\"vm.FileUploader.progress\" \nmd-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\"></md-progress-linear><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.uploadError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>{{vm.pesan}}</span></md-whiteframe><md-whiteframe \nng-show=\"vm.uploadSuccess\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>{{vm.pesan}}</span></md-whiteframe><div flex><div \nng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">\n{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span \nstyle=\"color:green\">{{ vm.uploadNotif }}</span></div></div></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-primary\" \naria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span>Download Template</span>\n</md-button><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary\" \naria-label=\"More Info\"><span>More Info</span></md-button><md-button class=\"md-accent\" ng-click=\"vm.closeModal()\">Cancel\n</md-button><md-button type=\"button\" ng-click=\"vm.FileUploader.uploadAll()\" \nclass=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\">\n</md-icon>Upload&nbsp;</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/cut-off-periode/edit-cut-off-periode/edit-cut-off-periode.html","<md-dialog aria-label=\"Input Data Leave Hold\" md-theme=\"modal-theme\"><form name=\"frmEmploye\" \nng-submit=\"vm.updateCutOffPeriode($event,frmEmploye)\" novalidate><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.CUT_OFF_PERIOD.FORM.TITLE_EDIT\">Input Data Cut Off Periode</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-padding><md-input-container flex><md-select disabled=\"disabled\" ng-model=\"vm.company\" \naria-label=\"company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'MENU.CB.CUT_OFF_PERIOD.FORM.COMPANY\' | translate }}\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-padding><md-input-container flex><label \ntranslate=\"MENU.CB.CUT_OFF_PERIOD.FORM.SUB_AREA\">Sub Area</label><md-select disabled=\"disabled\" \nng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" value=\"{{ls.sub_area_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-padding><md-input-container flex><label \ntranslate=\"MENU.CB.CUT_OFF_PERIOD.FORM.START_PERIOD\">Start Periode</label><input ng-model=\"vm.startPeriode\" \nname=\"startPeriode\" type=\"number\" required><div ng-messages=\"frmEmploye.startPeriode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Periode field is required.</span></div></div></md-input-container><md-input-container\n flex-5><label translate=\"MENU.CB.CUT_OFF_PERIOD.FORM.END_PERIOD\">End Periode</label><input ng-model=\"vm.endPeriode\" \nname=\"endPeriode\" type=\"number\" required><div ng-messages=\"frmEmploye.endPeriode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End Periode field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MENU.CB.CUT_OFF_PERIOD.FORM.EFFECTIVE_DATE\">Effective Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.effectiveDate\" name=\"effectiveDate\" required></md-datepicker><div \nng-messages=\"frmEmploye.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective date field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\"><span translate=\"ACTION.CANCEL\">Cancel</span></md-button><md-button\n type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/cut-off-periode/input-cut-off-periode/input-cut-off-periode.html","<md-dialog aria-label=\"Input Data Leave Hold\" md-theme=\"modal-theme\"><form name=\"frmEmploye\" \nng-submit=\"vm.saveCutOffPeriode($event,frmEmploye)\" novalidate><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.CUT_OFF_PERIOD.FORM.TITLE\">Input Data Cut Off Periode</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-padding><md-input-container flex><md-select ng-model=\"vm.company\" aria-label=\"company\" \nname=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.CUT_OFF_PERIOD.FORM.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-padding><md-input-container flex><label translate=\"MENU.CB.CUT_OFF_PERIOD.FORM.SUB_AREA\">Sub Area</label>\n<md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" \nvalue=\"{{ls.sub_area_id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" layout-padding><md-input-container flex><label \ntranslate=\"MENU.CB.CUT_OFF_PERIOD.FORM.START_PERIOD\">Start Periode</label><input ng-model=\"vm.startPeriode\" \nname=\"startPeriode\" type=\"number\" required><div ng-messages=\"frmEmploye.startPeriode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Periode field is required.</span></div></div></md-input-container><md-input-container\n flex-5><label translate=\"MENU.CB.CUT_OFF_PERIOD.FORM.END_PERIOD\">End Periode</label><input ng-model=\"vm.endPeriode\" \nname=\"endPeriode\" type=\"number\" required><div ng-messages=\"frmEmploye.endPeriode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End Periode field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MENU.CB.CUT_OFF_PERIOD.FORM.EFFECTIVE_DATE\">Effective Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.effectiveDate\" name=\"effectiveDate\" required></md-datepicker><div \nng-messages=\"frmEmploye.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective date field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\"><span translate=\"ACTION.CANCEL\">Cancel</span></md-button><md-button\n type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/cut-off-periode/upload-cut-off-periode/upload-cut-off-periode.html","<md-dialog aria-label=\"Upload Data Cut Off\" md-theme=\"modal-theme\" flex=\"40\"><form \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2 translate=\"MENU.CB.CUT_OFF_PERIOD.UPLOAD.TITLE\">Upload Data Cut Off Periode</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-padding>\n<form name=\"basicForm\" class=\"md-inline-form\" novalidate><fieldset style=\"width: 100%\"><legend>\nFormat file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadCutOff\" nv-file-select uploader=\"vm.FileUploaderCutOff\">\n</div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderCutOff.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset></form></div><div flex><div ng-show=\"vm.uploadCutOffStateError\" flex layout \nlayout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\" translate=\"NOTIF.ERROR_UPLOAD\">\nFailed Upload data</span></div><div ng-show=\"vm.uploadCutOffStateSuccess\" flex layout layout-align=\"center center\">\n<span style=\"color:green\" translate=\"NOTIF.SUCCESS_UPLOAD\">Success Upload data</span></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.FileUploaderCutOff.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/cb/emp-ghk/input-ghk/input-ghk.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.TITLE\">\nInput Employe GHK</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent grey-A100-fg\" translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.TITLE\">Input Employe GHK</span></div></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div></div><div \nclass=\"content\"><div id=\"header-actionView\" class=\"\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\">\n<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form \nname=\"formInputGhk\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputGhk)\"><div layout=\"column\"><div \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.SHIFT\">Shift</label>\n<md-select ng-model=\"vm.Form.objForm.locationid\" ng-change=\"vm.changeRefshift(vm.Form.objForm.locationid)\" \nng-required=\"true\" name=\"location\"><md-option ng-repeat=\"l in vm.listLocation\" value=\"{{l.locationid}}\">\n{{l.shift_name}}</md-option></md-select><div ng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Location harus di pilih.</span></div></div></md-input-container></div><md-input-container \nflex><h2 translate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.START_SHIFT\">Start Shift</h2><md-radio-group \nng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\"><div class=\"row\"><div flex layout=\"row\" layout-padding \nlayout-align=\"start center\"><md-radio-button ng-repeat=\"ls in vm.listLocationdetail\" flex ng-value=\"ls.dws_code\" \nclass=\"md-primary\" name=\"start_template\">Shift {{ls.cycle_number}}</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><div layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.EMPLOYEE_GHK.FORM_INPUT.WORKING_DAY\">Working Day</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"kerjadate\" ng-model=\"vm.Form.objForm.kerjadate\" required></md-datepicker><div \nng-messages=\"formInputGhk.kerjadate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Work Date Date is required.\n</span></div></div></md-input-container></div><md-input-container flex><input type=\"text\" name=\"reason\" \nng-model=\"vm.Form.objForm.reason\" placeholder=\"Reason\" required><div ng-messages=\"formInputGhk.reason.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div></div></md-input-container></div>\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\"><span translate=\"ACTION.RELOAD_TOKEN\">Reload Token</span></md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputGhk.$invalid || basicForm.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n<md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\"><span \ntranslate=\"ACTION.BACK\">Back</span></md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/cb/download-attendance/report-sap/cico.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"frmEmploye\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.DOWNLOAD_ATTENDANCE.DOWNLOAD_PAYLEAVE\">Download Payleave</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.groupLogin!=11\" \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\" \nclass=\"no-errors-spacer\"><label translate=\"FILTER.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"start_date\" ng-model=\"vm.start_date\" required></md-datepicker><div \nng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date is required.</span>\n</div></div></md-input-container><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" \nname=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker><div ng-messages=\"frmEmploye.end_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End Date is required.</span></div></div></md-input-container><span flex>\n</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\"><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company);vm.loadSubArea();\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"35\"><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'FILTER.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"35\"><md-select \nng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{\'FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>Department field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-select ng-model=\"vm.flag_app\" name=\"flag_app\" required><md-option ng-repeat=\"ls in vm.typeEmp\" \nplaceholder=\"{{ \'FILTER.EMPLOYEE_TYPE\' | translate }}\" value=\"{{ls.value}}\">{{ls.view | uppercase}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.flag_app.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" required><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container></div></div><div ng-if=\"vm.groupLogin==11\" layout=\"column\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\" class=\"no-errors-spacer\"><label \ntranslate=\"FILTER.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"start_date\" \nng-model=\"vm.start_date\" required></md-datepicker><div ng-messages=\"frmEmploye.start_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date is required.</span></div></div></md-input-container><md-input-container flex \nflex-gt-xs=\"30\" class=\"no-errors-spacer\"><label translate=\"FILTER.END_DATE\">End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" md-min-date=\"vm.start_date\" name=\"end_date\" ng-model=\"vm.end_date\" required></md-datepicker>\n<div ng-messages=\"frmEmploye.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date is required.\n</span></div></div></md-input-container><span flex></span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex flex-gt-xs=\"30\"><md-select ng-model=\"vm.company\" name=\"company\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'FILTER.COMPANY\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\" required><md-option ng-repeat=\"ls in vm.subArea\" \nplaceholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-input-container flex layout-align=\"right right\"><md-button type=\"button\" layout=\"row\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-click=\"vm.download()\" ng-disabled=\"frmEmploye.$invalid\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-download\" aria-label=\"android\"></md-icon><span translate=\"ACTION.DOWNLOAD\">Download</span>\n</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/emp-join-holiday/input-join-holiday/input-join-holiday.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span translate=\"MENU.CB.EMPLOYEE_JOIN_HOLIDAY.FORM.TITLE\">\nInput Employee Join Holiday</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div>\n</div><div layout=\"column\" layout-align=\"center start\"></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\"></div></div></div></div><div class=\"content\"><div id=\"header-actionView\" \nclass=\"\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" \nflex=\"80\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputOT\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputOT)\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'MENU.CB.EMPLOYEE_JOIN_HOLIDAY.FORM.COMPANY\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"formInputOT.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.EMPLOYEE_JOIN_HOLIDAY.FORM.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"formInputOT.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\" required><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.EMPLOYEE_JOIN_HOLIDAY.FORM.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"formInputOT.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container><md-input-container flex \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputOT.$invalid || formInputOT.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-loop\" \nng-click=\"SearchEmployee()\" aria-label=\"android\"></md-icon><span \ntranslate=\"MENU.CB.EMPLOYEE_JOIN_HOLIDAY.FORM.SEARCH_EMPLOYEE\">Search Employee</span></md-button></md-input-container>\n</div><table class=\"simple\" id=\"inputTable\"><thead><tr><th width=\"5%\"></th><th translate=\"TABLE.NIK\">NIK</th><th \ntranslate=\"TABLE.NAME\">Name</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listemploye\"><td class=\"text-center\">\n<md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{ls.nik}}</td><td>{{ls.nama}}</td></tr>\n</tbody></table><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" \nclass=\"fade\"><ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\"><span translate=\"ACTION.RELOAD_TOKEN\">Reload Token</span></md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputOT.$invalid || basicForm.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n<md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\"><span \ntranslate=\"ACTION.BACK\">Back</span></md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/cb/employe-absence/input-employe-absence/input-employe-absence.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.LEAVE.FORM_INPUT.TITLE\">Input Employe Absence</span></md-subheader><div \nclass=\"white-bg\"><md-content layout=\"column\" flex layout-fill class=\"white-bg\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputOT)\"><div layout=\"column\"><div layout-gt-sm=\"row\">\n<md-input-container flex><md-radio-group ng-click=\"vm.changeLeaveType()\" ng-model=\"vm.leaveType\"><md-radio-button \nvalue=\"normalleave\" name=\"leavetype\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.LEAVE.FORM_INPUT.CUTI_NORMAL\">\nCuti Normal</span></md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"specific\" name=\"leavetype\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.LEAVE.FORM_INPUT.CUTI_KHUSUS\">Cuti Khusus</span></md-radio-button>\n</md-radio-group></md-input-container></div><md-input-container flex><md-select ng-model=\"vm.Form.objForm.abs_code\" \nname=\"abs_code\" ng-change=\"vm.ChangeAbsenceType(vm.Form.objForm.abs_code)\" required><md-option \nng-repeat=\"ls in vm.listAbsenceType\" placeholder=\"{{ \'MENU.CB.LEAVE.FORM_INPUT.ABSENCE_TYPE\' | translate}}\" \nvalue=\"{{ls.abs_code}}-{{ls.limitday}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"formInputOT.abs_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MENU.CB.LEAVE.FORM_INPUT.ABSENCE_TYPE\' | translate}} is required.</span></div></div></md-input-container><div \nclass=\"alert-info warning italic md-body-1\" ng-if=\"vm.leavBalance>0\"><div layout-gt-sm=\"row\"><p class=\"form-messages\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon><span \ntranslate=\"MENU.CB.LEAVE.FORM_INPUT.NOTIF_INPUT_1\">Saldo cuti (annual leave) anda masih tersedia sejumlah </span>\n{{vm.leavBalance}} <span translate=\"MENU.CB.LEAVE.FORM_INPUT.NOTIF_INPUT_2\">\nhari, apakah anda akan menggunakan saldo cuti ?</span></p></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<md-radio-group><md-radio-button value=\"annualleave\" name=\"daytype\" ng-click=\"vm.viewLeaveBalance()\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.LEAVE.FORM_INPUT.GUNAKAN_SALDO_CUTI\">Gunakan saldo cuti</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"personalleave\" name=\"daytype\" ng-click=\"vm.personalleaveonly()\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.LEAVE.FORM_INPUT.TIDAK_GUNAKAN_SALDO_CUTI\">Tidak gunakan saldo cuti\n</span></md-radio-button></md-radio-group></md-input-container></div></div><div \nclass=\"alert-info warning italic md-body-1\" ng-if=\"vm.infoSpecificleave\"><div layout-gt-sm=\"row\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>\nCuti tersedia selama {{vm.limitDay}} hari.</p></div><div layout-gt-sm=\"row\" \nng-hide=\"(vm.excludeType == \'Z307\') || (vm.excludeType == \'Z308\')\"><md-input-container flex><md-radio-group \nng-model=\"vm.leaveused\" ng-change=\"vm.changeLeaveUsed(vm.leaveused)\"><md-radio-button value=\"useall\" name=\"useleave\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.LEAVE.FORM_INPUT.GUNAKAN_SEMUA_CUTI\">Gunakan semua cuti</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"notuseall\" name=\"useleave\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.LEAVE.FORM_INPUT.TIDAK_GUNAKAN_SEMUA_CUTI\">Tidak gunakan semua cuti</span></md-radio-button>\n</md-radio-group></md-input-container></div></div><div layout-gt-sm=\"row\"><md-input-container flex \nng-if=\"vm.selectday\"><md-select ng-model=\"vm.usedayleave\" name=\"usedayleave\" ng-change=\"vm.changeUsedayleave()\" \nrequired><md-option ng-repeat=\"val in vm.listjumday\" \nplaceholder=\"{{ \'MENU.CB.LEAVE.FORM_INPUT.JUMLAH_HARI\' | translate }}\" value=\"{{val}}\">{{val}} Hari</md-option>\n</md-select><div ng-messages=\"formInputOT.usedayleave.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nusedayleave field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE.FORM_INPUT.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-disabled=\"(vm.isdisabled && vm.leavBalance>0) || vm.Form.objForm.abs_code ==null || vm.startDateDisabled\" \nng-change=\"vm.changeStartDate()\" name=\"start_date\" ng-model=\"vm.Form.objForm.start_date\" required></md-datepicker><div \nng-messages=\"formInputOT.start_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MENU.CB.LEAVE.FORM_INPUT.START_DATE\' | translate}} is required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"!vm.hideEndDate\" flex><label translate=\"MENU.CB.LEAVE.FORM_INPUT.END_DATE\">End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" md-min-date=\"vm.Form.objForm.start_date\" \nng-disabled=\"(vm.isdisabled && vm.leavBalance>0) || vm.Form.objForm.abs_code ==null || vm.Form.objForm.daytype==\'halfday\' || vm.endDateDisabled\" \nname=\"end_date\" ng-model=\"vm.Form.objForm.end_date\" ng-required=\"vm.enddaterequire\"></md-datepicker><div \nng-messages=\"formInputOT.end_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MENU.CB.LEAVE.FORM_INPUT.END_DATE\' | translate}} is required.</span></div></div></md-input-container></div>\n<md-input-container flex><input type=\"text\" name=\"description\" ng-disabled=\"vm.isdisabled\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"{{ \'KPI.LABEL.DESCRIPTION\' | translate}}\" required><div \nng-messages=\"formInputOT.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'KPI.LABEL.DESCRIPTION\' | translate}} is required.</span></div></div></md-input-container><md-input-container \nng-if=\"vm.requestdocument==\'1\'\" md-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nrequired uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'upload\',abs_code:vm.Form.objForm.abs_code,daytype:vm.Form.objForm.daytype,start_date:vm.Form.objForm.start_date,end_date:vm.Form.objForm.end_date,start_time:vm.Form.objForm.start_time,\n                    end_time:vm.Form.objForm.end_time,description:vm.Form.objForm.description}] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></div>\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate }}</p></ms-widget-front></ms-widget><div \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\" translate=\"MENU.CB.LEAVE.FORM_INPUT.RELOAD_TOKEN\">\nReload Token</md-button><md-button ng-if=\"vm.requestdocument==\'0\'\" type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInputOT.$invalid || basicForm.$pristine && vm.isdisabled\" translate=\"MENU.CB.LEAVE.FORM_INPUT.SAVE\">\nSave</md-button><md-button ng-if=\"vm.requestdocument==\'1\'\" type=\"button\" ng-click=\"vm.upload(formInputOT)\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"(formInputOT.$invalid || formInputOT.$pristine) && vm.isdisabled\" \ntranslate=\"MENU.CB.LEAVE.FORM_INPUT.SAVE\">Save</md-button><md-button type=\"button\" ng-click=\"vm.back()\" \nclass=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"back\" translate=\"MENU.CB.LEAVE.FORM_INPUT.BACK\">Back\n</md-button></div></form></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employe-outlet-ot/input-emp-outlet-ot/input-emp-outlet-ot.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.CB.EMPLOYEE_OUTLET_OT.FORM.TITLE\">Input Employe Outlet Overtime</span>\n</md-subheader><div class=\"white-bg\"><div class=\"content\"><div id=\"header-actionView\" class=\"\" layout=\"column\"><div \nclass=\"form-wrapper\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputOT\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.saveData(formInputOT)\"><div layout=\"column\"><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.ot_type\" ng-disabled=\"vm.stateEdit\" ng-required=\"true\" name=\"ot_type\" \nng-click=\"vm.changeEmpType()\"><md-radio-button value=\"NORMAL\" name=\"ot_type\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OUTLET_OT.FORM.NORMAL\">NORMAL</span></md-radio-button>&nbsp;&nbsp;<md-radio-button \nvalue=\"KHL\" name=\"ot_type\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OUTLET_OT.FORM.KHL\">KHL</span>\n</md-radio-button></md-radio-group><div ng-messages=\"formInputOT.ot_type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Type is required.</span></div></div></md-input-container><div layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.EMPLOYEE_OUTLET_OT.FORM.OVERTIME_DATE\">Overtime Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-disabled=\"vm.stateEdit\" name=\"ot_date\" ng-model=\"vm.Form.objForm.ot_date\" \nng-change=\"vm.changeEmpType()\" required onkeydown=\"return false\"></md-datepicker><div \nng-messages=\"formInputOT.ot_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>OT Date is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Start Time (tanggal/bulan/tahun jam:menit)</label>\n<input type=\"text\" name=\"start_time\" ng-model=\"vm.Form.objForm.start_time\" ng-max=\"24\" ng-change=\"vm.setRestHour()\" \nmask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" required><div \nng-messages=\"formInputOT.start_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start time is required.\n</span></div><div ng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span>\n</div></div></md-input-container><md-input-container flex><label>End Time (tanggal/bulan/tahun jam:menit)</label><input\n type=\"text\" ng-max=\"24\" name=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" ng-change=\"vm.setRestHour()\" \nmask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" required><div \nng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>End time is required.</span>\n</div><div ng-message=\"max\"><span>Max 2.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container width=\"5px\"><label>Rest Hours</label>\n<input type=\"number\" name=\"rest_hour\" ng-model=\"vm.rest_hour\" min=\"0\" max=\"2\" mask-placeholder=\"_\" required><div \nng-messages=\"formInputOT.rest_hour.$error\" role=\"alert\"><div ng-message=\"required\"><span>Rest Hour is required.</span>\n</div><div ng-message=\"min\"><span>Min {{vm.minHour}}</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"reason\" ng-model=\"vm.Form.objForm.reason\" \nplaceholder=\"{{ \'MENU.CB.EMPLOYEE_OUTLET_OT.FORM.REASON\' \n                                   | translate }}\" required>\n<div ng-messages=\"formInputOT.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>reason is required.</span>\n</div></div></md-input-container></div><label ng-if=\"vm.Form.objForm.ot_type==\'NORMAL\'\" \ntranslate=\"MENU.CB.EMPLOYEE_OUTLET_OT.FORM.NOTIF_1\">Apakah overtime setelah atau sebelum jam kerja?</label>\n<md-input-container ng-if=\"vm.Form.objForm.ot_type==\'NORMAL\'\" flex><md-radio-group ng-model=\"vm.Form.objForm.isafter\" \nng-disabled=\"vm.stateEdit\" ng-change=\"vm.changeOTType()\" ng-required=\"true\" name=\"isafter\"><md-radio-button value=\"1\" \nname=\"isafter\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OUTLET_OT.FORM.AFTER_WORK\">\nsetelah jam kerja normal</span></md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"0\" name=\"isafter\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OUTLET_OT.FORM.BEFORE_WORK\">sebelum jam kerja normal</span>\n</md-radio-button><md-radio-button value=\"2\" name=\"isafter\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BEFORE_AND_AFTER_TIME\">sebelum dan setelah jam kerja normal</span>\n</md-radio-button></md-radio-group><div ng-messages=\"formInputOT.isafter.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Type is required.</span></div></div></md-input-container><md-input-container flex>\n<md-radio-group ng-model=\"vm.Form.objForm.empType\" ng-disabled=\"vm.stateEdit\" ng-change=\"vm.changeEmpType()\" \nng-required=\"true\" name=\"empType\"><md-radio-button value=\"crew\" name=\"empType\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OUTLET_OT.FORM.CREW\">Crew</span></md-radio-button>&nbsp;&nbsp;<md-radio-button \nvalue=\"noncrew\" name=\"empType\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OUTLET_OT.FORM.NON_CREW\">\nNon-Crew</span></md-radio-button></md-radio-group><div ng-messages=\"formInputOT.empType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee Type is required.</span></div></div></md-input-container></div><table \nid=\"inputTable\" class=\"simple with-toolbar bordered stripped mb-50\" ms-responsive-table><thead><tr><th width=\"60px\">\n</th><th width=\"250px\" translate=\"TABLE.NIK\">NIK</th><th translate=\"TABLE.NAME\">Name</th><th width=\"150px\">Parttime\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listemploye\"><td class=\"text-center\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\" ng-if=\"!vm.cekStatus(ls.status)\"></md-checkbox></td><td>{{ls.nik}}\n</td><td>{{ls.nama}}</td><td><span ng-if=\"vm.cekStatus(ls.status)\">Parttime</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.listemploye.length <= 0 || (vm.listemploye | typeOf) == \'undefined\'\"><td colspan=\"4\" class=\"text-center\">\n<span translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\"><span translate=\"ACTION.RELOAD_TOKEN\">Reload Token</span>\n</md-button><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInputOT.$invalid || basicForm.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n<md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"back\"><span \ntranslate=\"ACTION.BACK\">Back</span></md-button></div></form></div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/cb/employe-overtime/input-employe-ot/edit-employe-ot-backup.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"></span> <span class=\"logo-text\"><span>Edit Employe Overtime</span></span></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" layout-align=\"center start\"></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"></div></div></div></div><div \nclass=\"content\"><div id=\"header-actionView\" class=\"\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\">\n<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputOT)\"><div layout=\"column\"><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Overtime Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-change=\"vm.changeDate()\" name=\"ot_date\" ng-model=\"vm.Form.objForm.ot_date\" required></md-datepicker><div \nng-messages=\"formInputOT.ot_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>OT Date is required.</span>\n</div></div></md-input-container></div><md-input-container flex><md-radio-group ng-model=\"vm.Form.objForm.optgroup\" \nng-change=\"vm.ChangeGrouptype()\" ng-required=\"true\"><div class=\"row\"><div flex layout=\"column\" layout-padding \nlayout-align=\"start left\"><md-radio-button ng-repeat=\"ls in vm.listotdate\" flex ng-value=\"ls\" class=\"md-primary\" \nname=\"optgroup\">{{ls.ot_type}} | {{ls.start_time}} - {{ls.end_time}}</md-radio-button></div></div></md-radio-group><div\n ng-messages=\"formInputOT.optgroup.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><md-input-container ng-if=\"vm.listemployeOt.length > 0\" flex><input \ntype=\"text\" name=\"reason\" ng-disalbed=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.reason\" placeholder=\"Reason\" required>\n<div ng-messages=\"formInputOT.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>reason is required.</span>\n</div></div></md-input-container><table class=\"simple\" ng-if=\"vm.listemployeOt.length > 0\" id=\"inputTable\"><thead><tr>\n<th width=\"5%\"></th><th>NIK</th><th>Name</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listemployeOt\"><td \nclass=\"text-center\"><md-checkbox class=\"no-label\" ng-click=\"vm.toggleCheck(ls, $event)\" checklist-model=\"vm.empot\" \nchecklist-value=\"ls\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{ls.nik}}</td><td>\n{{ls.nama}}</td></tr></tbody></table><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"formInputOT.$invalid || basicForm.$pristine\">Submit\n</md-button><md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\">Back\n</md-button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/main/cb/employe-overtime/input-employe-ot/edit-employe-ot.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"ATTENDANCE.LABEL.INPUTEMPLOYEEOT\"></span></md-subheader><div class=\"white-bg\"><div \nclass=\"content\"><div id=\"header-actionView\" class=\"\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\">\n<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputOT)\"><div layout=\"column\"><md-input-container flex>\n<md-radio-group ng-model=\"vm.Form.objForm.ot_type\" ng-disabled=\"vm.stateEdit || vm.isHasApproved\" ng-required=\"true\" \nname=\"ot_type\"><md-radio-button value=\"NORMAL\" name=\"ot_type\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.NORMAL\">NORMAL</span></md-radio-button>&nbsp;&nbsp;<md-radio-button \nvalue=\"KHL\" name=\"ot_type\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.KHL\">KHL</span>\n</md-radio-button></md-radio-group><div ng-messages=\"formInputOT.ot_type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Type is required.</span></div></div></md-input-container><div layout=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.OVERTIME_DATE\">Overtime Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-disabled=\"vm.stateEdit || vm.isHasApproved\" name=\"ot_date\" \nng-model=\"vm.Form.objForm.ot_date\" required></md-datepicker><div ng-messages=\"formInputOT.ot_date.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>OT Date is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Start Time (tanggal/bulan/tahun jam:menit)</label><input type=\"text\" name=\"start_time\" \nng-model=\"vm.Form.objForm.start_time\" ng-max=\"24\" mask=\"99/99/9999 99:99\" ng-change=\"vm.getEmployelist()\" \nmask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" required><div ng-messages=\"formInputOT.start_time.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start time is required.</span></div><div ng-message=\"max\"><span>Max 24.\n</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container>\n<md-input-container flex><label>End Time (tanggal/bulan/tahun jam:menit)</label><input type=\"text\" ng-max=\"24\" \nname=\"end_time\" ng-model=\"vm.Form.objForm.end_time\" mask=\"99/99/9999 99:99\" ng-change=\"vm.getEmployelist()\" \nmask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" required><div ng-messages=\"formInputOT.end_time.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>End time is required.</span></div><div ng-message=\"max\"><span>Max 2.\n</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"20\"><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.REST_HOURS\">Rest Hours\n</label><input type=\"number\" name=\"resthour\" max=\"2\" min=\"{{vm.minHour}}\" ng-model=\"vm.Form.objForm.resthour\" \nng-disabled=\"vm.isHasApproved\" required><div ng-messages=\"formInputOT.resthour.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Rest Hour is required.</span></div><div ng-message=\"min\"><span>\nRest Hour minimum is {{vm.minHour}} hour</span></div></div></md-input-container><md-input-container flex=\"80\"><input \ntype=\"text\" name=\"reason\" ng-disabled=\"vm.isHasApproved\" ng-model=\"vm.Form.objForm.reason\" \nplaceholder=\"{{ \'MENU.CB.EMPLOYEE_OT.FORM_INPUT.REASON\' | translate }}\" required><div \nng-messages=\"formInputOT.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div>\n</div></md-input-container></div><label ng-if=\"vm.Form.objForm.ot_type==\'NORMAL\'\" \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.QUESTION\">Apakah overtime setelah atau sebelum jam kerja?</label>\n<md-input-container ng-if=\"vm.Form.objForm.ot_type==\'NORMAL\'\" flex><md-radio-group ng-model=\"vm.Form.objForm.is_after\" \nng-disabled=\"vm.isHasApproved\" ng-change=\"vm.changeOTType()\" ng-required=\"true\" name=\"isafter\"><md-radio-button \nvalue=\"1\" name=\"isafter\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.AFTER_TIME\">\nsetelah jam kerja normal</span></md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"0\" name=\"isafter\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BEFORE_TIME\">sebelum jam kerja normal</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"2\" name=\"isafter\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BEFORE_AND_AFTER_TIME\">sebelum dan setelah jam kerja normal</span>\n</md-radio-button></md-radio-group><div ng-messages=\"formInputOT.isafter.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Type is required.</span></div></div></md-input-container></div><table class=\"simple\" \nid=\"inputTable\"><thead><tr><th width=\"5%\"></th><th translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.NIK\">NIK</th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.NAME\">Name</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listemploye\"><td \nclass=\"text-center\"><md-checkbox class=\"no-label\" ng-click=\"vm.toggleCheck(ls, $event)\" checklist-model=\"vm.empot\" \nchecklist-value=\"ls\" ng-disabled=\"vm.isHasApproved\" aria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox>\n</td><td>{{ls.nik}}</td><td>{{ls.nama}}</td></tr></tbody></table><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.RELOAD_TOKEN\">\nReload Token</span></md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputOT.$invalid || basicForm.$pristine\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.SUBMIT\">\nSubmit</span></md-button><md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" \naria-label=\"back\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BACK\">Back</span></md-button></div></form></div>\n</div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/cb/employe-overtime/input-employe-ot/input-employe-ot.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"ATTENDANCE.LABEL.INPUTEMPLOYEEOT\"></span></md-subheader><div class=\"white-bg\">\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputOT)\"><div layout=\"column\"><md-input-container flex>\n<md-radio-group ng-model=\"vm.ot_type\" ng-disabled=\"vm.stateEdit\" ng-change=\"vm.changeOTType()\" ng-required=\"true\" \nname=\"ot_type\" ng-click=\"vm.getEmployelist()\"><md-radio-button value=\"NORMAL\" name=\"ot_type\" class=\"md-warn md-raised\">\n<span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.NORMAL\">NORMAL</span></md-radio-button>&nbsp;&nbsp;<md-radio-button \nvalue=\"KHL\" name=\"ot_type\" class=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.KHL\">KHL</span>\n</md-radio-button></md-radio-group><div ng-messages=\"formInputOT.ot_type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Type is required.</span></div></div></md-input-container><div layout=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.OVETIME_DATE\">Overtime Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-disabled=\"vm.stateEdit\" name=\"ot_date\" ng-model=\"vm.ot_date\" required \nng-change=\"vm.getEmployelist()\"></md-datepicker><div ng-messages=\"formInputOT.ot_date.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Date is required.</span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"TABLE.START_TIME\"></span> <span translate=\"ATTENDANCE.LABEL.DATENOTE\"></span></label><input \ntype=\"text\" name=\"start_time\" ng-model=\"vm.start_time\" ng-max=\"24\" mask=\"99/99/9999 99:99\" \nmask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" required><div ng-messages=\"formInputOT.start_time.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span><span translate=\"TABLE.START_TIME\"></span> is required.</span></div><div \nng-message=\"max\"><span>Max 24.</span></div><div ng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"TABLE.END_TIME\"></span> <span \ntranslate=\"ATTENDANCE.LABEL.DATENOTE\"></span></label><input type=\"text\" ng-max=\"24\" name=\"end_time\" \nng-model=\"vm.end_time\" mask=\"99/99/9999 99:99\" mask-placeholder=\"dd/mm/yyyy hh:ii\" autocomplete=\"off\" required><div \nng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"TABLE.END_TIME\"></span> is required.</span></div><div ng-message=\"max\"><span>Max 2.</span></div><div \nng-message=\"md-maxlength\"><span>Max Length 2.</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"20\"><label translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.REST_HOURS\">Rest Hours</label><input \ntype=\"number\" min=\"{{vm.minHour}}\" name=\"resthour\" ng-model=\"vm.resthour\" max=\"2\" required><div \nng-messages=\"formInputOT.resthour.$error\" role=\"alert\"><div ng-message=\"required\"><span>Rest Hour is required.</span>\n</div><div ng-message=\"min\"><span>Rest Hour minimum is {{vm.minHour}} hour</span></div></div></md-input-container>\n<md-input-container flex=\"80\"><input type=\"text\" name=\"reason\" ng-model=\"vm.reason\" \nplaceholder=\"{{ \'MENU.CB.EMPLOYEE_OT.FORM_INPUT.REASON\' | translate }}\" required><div \nng-messages=\"formInputOT.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>reason is required.</span></div>\n</div></md-input-container></div><label ng-if=\"vm.ot_type==\'NORMAL\'\" \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.QUESTION\">Apakah overtime setelah atau sebelum jam kerja?</label>\n<md-input-container ng-if=\"vm.ot_type==\'NORMAL\'\" flex><md-radio-group ng-model=\"vm.isafter\" ng-disabled=\"vm.stateEdit\" \nng-change=\"vm.changeOTType()\" ng-required=\"true\" name=\"isafter\"><md-radio-button value=\"1\" name=\"isafter\" \nclass=\"md-warn md-raised\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.AFTER_TIME\">setelah jam kerja normal</span>\n</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"0\" name=\"isafter\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BEFORE_TIME\">sebelum jam kerja normal</span></md-radio-button>&nbsp;&nbsp;\n<md-radio-button value=\"2\" name=\"isafter\" class=\"md-warn md-raised\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BEFORE_AND_AFTER_TIME\">sebelum dan setelah jam kerja normal</span>\n</md-radio-button></md-radio-group><div ng-messages=\"formInputOT.isafter.$error\" role=\"alert\"><div \nng-message=\"required\"><span>OT Type is required.</span></div></div></md-input-container></div><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"inputTable\"><thead><tr><th width=\"5%\"></th><th \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.NIK\">NIK</th><th translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.NAME\">Name</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.listemploye\"><td class=\"text-center\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isChecked(ls)\" ng-click=\"vm.toggleCheck(ls, $event)\" ng-model=\"isCovered\" \naria-label=\"{{vm.isChecked(ls)? \'Uncheck\':\'check\'}}\"></md-checkbox></td><td>{{ls.nik}}</td><td>{{ls.nama}}</td></tr>\n</tbody></table><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" \nclass=\"fade\"><ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front>\n</ms-widget><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" class=\"mt-20\"><md-button type=\"button\" \nng-click=\"vm.reloadToken()\" class=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\"><span \ntranslate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.RELOAD_TOKEN\">Reload Token</span></md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInputOT.$invalid || basicForm.$pristine\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.SUBMIT\">\nSubmit</span></md-button><md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-blue-grey-300-bg md-raised white-fg\" \naria-label=\"back\"><span translate=\"MENU.CB.EMPLOYEE_OT.FORM_INPUT.BACK\">Back</span></md-button></div></form></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/cb/employee-certificates/input-employee-certificates/input-employee-certificates-configurations.html","<md-dialog aria-label=\"Form Input Dependent\" flex flex-gt-md=\"60\"><form ng-cloack name=\"certificateconfigurationsForm\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form {{vm.state}} Certificate Class Rooms</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><div\n layout=\"column\" layout-gt-sm=\"row\" class=\"pt-10\"><md-input-container flex><label>Program</label><md-tooltip \nng-if=\"vm.textProgram\" md-direction=\"down\" md-visible=\"tooltipVisible\"><span>{{vm.textProgram}}</span></md-tooltip>\n<md-select ng-model=\"vm.Form.objForm.id_program\" name=\"id_program\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.lookUpProgram(vm.Form.objForm.id_program)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a Program ...\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"program\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listPrograms | filter:vm.searchTerm\">{{ls.groupProgram}}</md-option></md-optgroup></md-select><div \nng-messages=\"certificateconfigurationsForm.id_program.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nProgram harus di isi.</span></div></div></md-input-container><md-input-container flex flex-gt-sm=\"30\" \nflex-offset-gt-sm=\"5\"><label>Code Class</label><input ng-model=\"vm.Form.objForm.code_class\" name=\"code_class\" required \ndisabled=\"disabled\"><div ng-messages=\"certificateconfigurationsForm.code_class.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Code Class harus di isi.</span></div></div></md-input-container></div><md-divider>\n</md-divider><div layout=\"column\" class=\"mt-30\"><div layout=\"column\" layout-align=\"start start\" class=\"mb-10\" flex>\n<md-button flex=\"nogrow\" class=\"md-mini md-raised md-accent\" type=\"button\" aria-label=\"Insert\" \nng-click=\"vm.addComponent($event)\"><md-icon md-font-icon=\"icon-border-color\" class=\"md-font icon-plus material-icons\">\n</md-icon><span>Add Component</span></md-button></div><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr class=\"font-size-12\"><th width=\"60px\">No</th><th style=\"min-width: 100px\">Description\n</th><th width=\"150px\">Passing Grade Value</th><th width=\"40px\"></th></tr></thead><tbody><tr \nng-if=\"vm.Form.objForm.components.length == 0\"><td colspan=\"4\" class=\"text-center font-size-12\"><span class=\"pv-15\">\nMinimal input 1 Komponen.</span></td></tr><tr ng-if=\"vm.Form.objForm.components.length > 0\" \nng-repeat=\"data in vm.Form.objForm.components\" ng-init=\"parentIdx = $index\"><td \nclass=\"text-center align-vertical-top pd-10\">{{$index + 1}}</td><td class=\"pd-10\"><div layout=\"column\">\n<md-input-container flex><label>Description</label><input ng-model=\"vm.Form.objForm.components[$index].description\" \nname=\"description_{{$index}}\" required md-maxlength=\"100\"><div \nng-messages=\"certificateconfigurationsForm[\'description_\' + $index].$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Description harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.\n</span></div></div></md-input-container></div></td><td class=\"pd-10\"><div layout=\"column\"><md-input-container flex>\n<label>Passing Grade</label><input ng-model=\"vm.Form.objForm.components[$index].passing_grade\" \nname=\"passing_grade_{{$index}}\" required md-maxlength=\"5\"><div \nng-messages=\"certificateconfigurationsForm[\'passing_grade_\' + $index].$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Passing Grade harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 5 karakter.\n</span></div></div></md-input-container></div></td><td aria-label=\"cancel-component-{{$index}}\" \nclass=\"text-center align-vertical-top pd-10\"><md-button class=\"md-icon-button md-warn-fg button-cancel\" \nng-click=\"vm.cancelComponent($event, $index)\" flex><md-tooltip md-direction=\"bottom\">Cancel Component</md-tooltip>\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"ms-widget-front\"><p \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p>\n</ms-widget-front></ms-widget><span flex></span><md-button type=\"button\" \nng-click=\"vm.saveData($event,certificateconfigurationsForm)\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(!vm.Form.objForm.id && (certificateconfigurationsForm.$invalid || certificateconfigurationsForm.$pristine)) || vm.Form.objForm.components.length == 0\">\nSubmit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employee-certificates/input-employee-certificates/input-employee-certificates-programs.html","<md-dialog aria-label=\"Form Input Dependent\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack \nname=\"certificateprogramsForm\" class=\"md-inline-form popup-input-form\" novalidate><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form {{vm.state}} Certificate Programs</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"pt-10\">\n<md-input-container flex><label>Program Name</label><input ng-model=\"vm.Form.objForm.description\" name=\"description\" \nrequired md-maxlength=\"100\"><div ng-messages=\"certificateprogramsForm.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Program name harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 100 huruf.</span></div></div></md-input-container><md-input-container flex flex-gt-sm=\"20\" \nflex-offset-gt-sm=\"5\"><label>Code</label><input ng-model=\"vm.Form.objForm.short_code\" name=\"short_code\" required \nmd-maxlength=\"10\"><div ng-messages=\"certificateprogramsForm.short_code.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Code harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 10 huruf.</span></div>\n</div></md-input-container><md-input-container flex flex-gt-sm=\"40\" flex-offset-gt-sm=\"5\"><label>Country</label>\n<md-select ng-model=\"vm.Form.objForm.country\" name=\"country\" ng-change=\"vm.loadData(1)\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"certificateprogramsForm.country.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCountry harus di isi.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"ms-widget-front\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"button\" ng-click=\"vm.saveData($event,certificateprogramsForm)\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"!vm.Form.objForm.id && (certificateprogramsForm.$invalid || certificateprogramsForm.$pristine)\">Submit\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/employee-certificates/input-employee-certificates/input-employee-certificates.html","<md-dialog aria-label=\"Form Input Dependent\" flex flex-gt-md=\"60\"><form ng-cloack id=\"certificateForm\" \nname=\"certificateForm\" class=\"md-inline-form popup-input-form\" novalidate><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form {{vm.state}} Peserta</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><div layout=\"column\"><md-input-container id=\"nik-inputer\" \nclass=\"mt-20 nik-inputer\" layout=\"row\"><md-autocomplete md-no-cache=\"true\" md-selected-item=\"vm.selectedItem\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(ls)\" md-items=\"ls in vm.querySearch(vm.searchText)\" \nmd-item-text=\"ls.nik + \' - \' + ls.nama\" md-min-length=\"3\" md-floating-label=\"NIK / Name\" md-input-name=\"autocomplete\" \nmd-menu-class=\"employee-choose\" md-clear-button=\"true\" ng-disabled=\"vm.disableAll || vm.disableForEdit\" required flex>\n<md-item-template><div layout=\"column\"><span md-highlight-flags=\"^i\">{{ls.nik}} - {{ls.nama}}</span> <span \nmd-highlight-flags=\"^i\">{{ls.nama_sub_area}}</span></div></md-item-template><md-not-found><span>\nNo NIK/NAME matching \"{{vm.searchText}}\" were found.</span></md-not-found><div \nng-if=\"vm.Form.objForm.employee.nama_sub_area\" class=\"hint\">Sub Area Asal: {{vm.Form.objForm.employee.nama_sub_area}}\n</div><div ng-messages=\"certificateForm.autocomplete.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNIK / Name Required.</span></div></div></md-autocomplete></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"mt-30\"><md-input-container flex><label>Program</label><md-select ng-model=\"vm.Form.objForm.id_program\" \nname=\"id_program\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadClassrooms(vm.Form.objForm.id_program)\" \nng-disabled=\"vm.disableAll\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a Program ...\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header>\n<md-optgroup label=\"program\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listPrograms | filter:vm.searchTerm\">\n{{ls.groupProgram}}</md-option></md-optgroup></md-select><div ng-messages=\"certificateForm.id_program.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Program harus di isi.</span></div></div></md-input-container>\n<md-input-container flex flex-gt-sm=\"30\" flex-offset-gt-sm=\"5\"><label>Classroom</label><md-select \nng-model=\"vm.Form.objForm.configuration\" name=\"configuration\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.lookUpComponents(vm.Form.objForm.configuration)\" ng-disabled=\"vm.disableAll\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a Classroom ...\" \nautocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"classrooms\"><md-option \nvalue=\"{{ls}}\" ng-repeat=\"ls in vm.listClassrooms | filter:vm.searchTerm\">{{ls.code_class}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"certificateForm.configuration.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nClassroom harus di isi.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"mt-30\"><md-input-container flex><label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"startDate\" ng-model=\"vm.Form.objForm.start_date\" required \nng-change=\"vm.reinitEndDate(vm.Form.objForm.start_date)\"></md-datepicker><div \nng-messages=\"certificateconfigurationsForm.startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart Date Required.</span></div></div></md-input-container><md-input-container flex flex-offset-gt-sm=\"5\"><label>\nEnd Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"endDate\" ng-model=\"vm.Form.objForm.end_date\" required>\n</md-datepicker><div ng-messages=\"certificateconfigurationsForm.endDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End Date Required.</span></div></div></md-input-container></div><div layout=\"column\" \nclass=\"mt-30\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><td \nclass=\"text-left\" colspan=\"3\">Komponen</td></tr></thead><tbody><tr ng-if=\"vm.listComponents.length == 0\"><td \ncolspan=\"3\" class=\"text-center font-size-12\"><span class=\"pv-15\">Please select classroom.</span></td></tr><tr \nng-if=\"vm.listComponents.length > 0\" ng-repeat=\"ls in vm.listComponents\" ng-init=\"parentIdx = $index\"><td \nstyle=\"min-width: 100px; vertical-align: top\"><div layout=\"column\"><span class=\"ph-10 pv-5 mt-10\">{{ls.description}}\n</span></div></td><td class=\"pd-10\" width=\"90px\" style=\"vertical-align: top\"><div \nclass=\"md-green-600-bg p-5 mt-10 text-center\">{{ls.passing_grade}}</div></td><td class=\"pd-10\" width=\"300px\"><div \nlayout=\"column\"><md-input-container flex><label>Value</label><input ng-model=\"vm.Form.objForm.component_value[$index]\" \nname=\"component_value_{{$index}}\" required md-maxlength=\"5\" ng-disabled=\"vm.disableAll\"><div \nng-messages=\"certificateForm[\'component_value_\' + $index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassing Grade harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 5 karakter.</span>\n</div></div></md-input-container></div></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-if=\"vm.disableAll\" class=\"fade\"><ms-widget-front class=\"ms-widget-front\"><p class=\"form-messages p-5\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>Approved, Cannot Edit</p></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"ms-widget-front\"><p class=\"form-messages p-5\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\">\n</md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span flex></span><md-button type=\"button\" \nng-click=\"vm.saveData($event,certificateForm)\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"((!vm.Form.objForm.id && (certificateForm.$invalid || certificateForm.$pristine)) || vm.listComponents.length == 0) || vm.disableAll\">\nSubmit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/join-holiday/input-join-holiday/input-join-holiday.html","<md-dialog aria-label=\"Input Data Leave Hold\" md-theme=\"modal-theme\"><form class=\"md-inline-form popup-input-form\" \nname=\"frmEmploye\" ng-submit=\"vm.saveDataJoinHoliday($event,frmEmploye)\" novalidate><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.JOIN_HOLIDAY.FORM.TITLE\">\nInput Data Join Holiday</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" aria-label=\"company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required>\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'MENU.CB.JOIN_HOLIDAY.FORM.COMPANY\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.divisi\" aria-label=\"divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" \nrequired><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"{{ \'MENU.CB.JOIN_HOLIDAY.FORM.DIVISI\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivisi field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.JOIN_HOLIDAY.FORM.DEPARTMENT\">Department</label><md-select ng-model=\"vm.department\" \naria-label=\"department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.JOIN_HOLIDAY.FORM.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.JOIN_HOLIDAY.FORM.SUB_AREA\">Sub Area</label><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea\" value=\"{{ls.subarea_id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MENU.CB.JOIN_HOLIDAY.FORM.START_DATE\">Start Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.startdate\" name=\"startdate\" md-min-date=\"vm.HoldMinDate\" required></md-datepicker><div \nng-messages=\"frmEmploye.startdate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start date field is required.\n</span></div></div></md-input-container><md-input-container flex><label translate=\"MENU.CB.JOIN_HOLIDAY.FORM.END_DATE\">\nEnd Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.enddate\" name=\"enddate\" \nmd-min-date=\"vm.HoldMinDate\" required></md-datepicker><div ng-messages=\"frmEmploye.enddate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>End date field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"MENU.CB.JOIN_HOLIDAY.FORM.DESCRIPTION\">\nDescription</label><textarea ng-model=\"vm.description\" name=\"description\" md-maxlength=\"150\" rows=\"3\" required>\n</textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/leave-hold/detail-leave-hold/detail-leave-hold.html","<md-dialog aria-label=\"Input Data Leave Hold\" md-theme=\"modal-theme\" flex><md-toolbar flex><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.LEAVE_HOLD.DETAIL.TITLE\">Detail Data Leave Hold</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"simple-table-container\" hide show-gt-sm><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"fullwidth-table simple with-toolbar stripped upper-case-header\" ms-responsive-table><thead><tr><th width=\"5%\">\n<span class=\"column-title\" translate=\"TABLE.NO\">NO</span></th><th class=\"text-center\" width=\"5%\"><span \nclass=\"column-title\" translate=\"TABLE.NIK\">NIK</span></th><th class=\"text-center\" width=\"15%\"><span \nclass=\"column-title\" translate=\"TABLE.NAME\">Name</span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\" translate=\"TABLE.DESCRIPTION\">Description</span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\" translate=\"TABLE.START_DATE\">start date</span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\" translate=\"TABLE.END_DATE\">end date</span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\" translate=\"TABLE.START_PERIOD\">start periode</span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\" translate=\"TABLE.END_PERIOD\">end periode</span></th><th class=\"text-center\" width=\"10%\"><span \nclass=\"column-title\" translate=\"TABLE.HOLD_BY\">Hold By</span></th></tr></thead><tbody><tr class=\"md-table-content-row\" \nng-repeat=\"item in vm.DataTables.list\"><td>{{($index + 1)}}</td><td class=\"text-center\">{{item.nik}}</td><td \nclass=\"text-center\">{{item.name}}</td><td class=\"text-center\">{{item.description}}</td><td class=\"text-center\">\n{{item.start_date}}</td><td class=\"text-center\">{{item.end_date}}</td><td class=\"text-center\">{{item.start_periode}}\n</td><td class=\"text-center\">{{item.end_periode}}</td><td class=\"text-center\">{{item.hold_by}}</td></tr><md-tooltip \nmd-direction=\"left\">Double Click to edit</md-tooltip><tr ng-if=\"vm.DataTables.list.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span>No Data Available</span></td></tr></tbody></table></div></div><md-content \nstyle=\"background:white\" hide-gt-sm><span flex=\"5\"></span><md-list flex><md-list-item class=\"md-3-line\" \nng-repeat=\"item in vm.DataTables.list\" ng-click=\"null\"><div class=\"md-list-item-text\" layout=\"column\"><h4>\n{{ item.name }} | {{ item.nik }}</h4><p>Start Date : {{ item.start_date }}</p><p>End Date : {{item.end_date}}</p><p>\nStart Periode : {{item.start_periode}}</p><p>End Periode : {{item.start_periode}}</p><p>\nDescription : {{item.description}}</p></div><md-divider \nstyle=\"border-width:0.5px; border-color:whitesmoke; border-style: solid\"></md-divider></md-list-item></md-list>\n</md-content><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTables.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTables.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/cb/leave-hold/input-leave-hold/input-leave-hold.html","<md-dialog aria-label=\"Input Data Leave Hold\" md-theme=\"modal-theme\" flex flex-md=\"80\" flex-gt-md=\"60\"><form \nname=\"frmEmploye\" ng-submit=\"vm.saveLeaveHold($event,frmEmploye)\" novalidate flex><md-toolbar flex><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.LEAVE_HOLD.FORM.TITLE\">Input Data Leave Hold</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select \nng-model=\"vm.company\" aria-label=\"company\" name=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required>\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"{{ \'MENU.CB.LEAVE_HOLD.FORM.COMPANY\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.divisi\" aria-label=\"divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" \nrequired><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.LEAVE_HOLD.FORM.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MENU.CB.LEAVE_HOLD.FORM.DEPARTMENT\">Department</label><md-select ng-model=\"vm.department\" \naria-label=\"department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.LEAVE_HOLD.FORM.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"MENU.CB.LEAVE_HOLD.FORM.SUB_AREA\">Sub Area</label><md-select \nng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option ng-repeat=\"ls in vm.subArea | filter:{ subarea_id: \'!all\'}\" \nvalue=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.subarea.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MENU.CB.LEAVE_HOLD.FORM.START_DATE\">Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.startdate\" name=\"startdate\" md-min-date=\"vm.HoldMinDate\" required>\n</md-datepicker><div ng-messages=\"frmEmploye.startdate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart date field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE_HOLD.FORM.END_DATE\">End Date</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.enddate\" name=\"enddate\" md-min-date=\"vm.HoldMinDate\" required></md-datepicker><div \nng-messages=\"frmEmploye.enddate.$error\" role=\"alert\"><div ng-message=\"required\"><span>End date field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.LEAVE_HOLD.FORM.DESCRIPTION\">Description</label><textarea ng-model=\"vm.description\" \nname=\"description\" md-maxlength=\"150\" rows=\"3\" required></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\"><span translate=\"ACTION.CANCEL\">Cancel</span>\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/cb/leave-hold/update-leave-hold/update-leave-hold.html","<md-dialog aria-label=\"Input Data Leave Hold\" md-theme=\"modal-theme\" flex flex-md=\"80\" flex-gt-md=\"60\"><form \nname=\"frmEmploye\" ng-submit=\"vm.updateLeaveHold($event,frmEmploye)\" novalidate flex><md-toolbar flex><div \nclass=\"md-toolbar-tools\"><h2>Edit Data Leave Hold</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Sub Area</label><md-select ng-model=\"vm.selectedSubarea\" name=\"subarea\"><md-option \nng-repeat=\"ls in vm.subArea\" value=\"{{ls.subarea_id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.startdate\" name=\"startdate\" md-min-date=\"vm.HoldMinDate\" required>\n</md-datepicker><div ng-messages=\"frmEmploye.startdate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart date field is required.</span></div></div></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.enddate\" name=\"enddate\" md-min-date=\"vm.HoldMinDate\" required>\n</md-datepicker><div ng-messages=\"frmEmploye.enddate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd date field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Description</label><textarea ng-model=\"vm.description\" name=\"description\" \nmd-maxlength=\"150\" rows=\"3\" required></textarea></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\"></md-icon>Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/national-holiday/input-national-holiday/input-national-holiday.html","<md-dialog aria-label=\"Input holiday\" ng-style=\"vm.styleDialog\" md-theme=\"modal-theme\" flex flex-md=\"60\" \nflex-gt-md=\"40\"><form name=\"formDataHoliday\" class=\"md-inline-form popup-input-form\" ng-cloak><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.NATIONAL_HOLIDAY.FORM.TITLE\">\nInput data nationdal holiday</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\"><md-input-container flex=\"100\" class=\"md-block md-input-has-value\">\n<label translate=\"MENU.CB.NATIONAL_HOLIDAY.FORM.HOLIDAY\">Holiday</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.holidaydate\" name=\"holidaydate\" required></md-datepicker><div \nng-messages=\"formDataHoliday.holidaydate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nHoliday Date Date is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container \nflex=\"100\" class=\"md-block md-input-has-value\"><label translate=\"MENU.CB.NATIONAL_HOLIDAY.FORM.HOLIDAY_NAME\">\nHoliday Name</label><input type=\"text\" name=\"holidayname\" ng-model=\"vm.holidayname\" required><div \nng-messages=\"formDataHoliday.holidayname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nHoliday name is required.</span></div></div></md-input-container></div><h2 \ntranslate=\"MENU.CB.NATIONAL_HOLIDAY.FORM.CHOOSE_SUB_AREA\" style=\"margin-bottom: 0\">Choose Sub Area</h2><div>\n<md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" \nng-click=\"vm.toggleAll()\"><span ng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></div><div layout layout-wrap>\n<div flex-gt-sm=\"30\" ng-repeat=\"item in vm.items\"><md-checkbox ng-checked=\"vm.exists(item, vm.locationSelected)\" \nng-click=\"vm.toggle(item, vm.locationSelected)\">{{ item.description }}</md-checkbox></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-blue-grey-300-bg md-raised white-fg\" \nng-click=\"vm.dialogClose()\"><span translate=\"ACTION.CANCEL\">Cancel</span></md-button><md-button \nclass=\"md-raised md-primary btn-ui-serif\" ng-click=\"vm.saveDataHoliday($event,formDataHoliday)\" aria-label=\"Submit\" \nng-disabled=\"formDataHoliday.$invalid || basicForm.$pristine || vm.locationSelected.length == 0\"><span \ntranslate=\"ACTION.SUBMIT\">Submit</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/overtime/input-overtime/input-employeot.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"frmEmp\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-cyan-600-bg\"><div class=\"md-toolbar-tools\"><h2>\nForm Search Employe</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon>\nFilter Data</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" \nname=\"company\" ng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi)\" required><md-option ng-repeat=\"ls in vm.listDivision\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi field is required.</span>\n</div></div></md-input-container><md-input-container flex><md-select ng-model=\"vm.department\" name=\"department\" \nrequired><md-option ng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container><md-input-container flex \nlayout-align=\"right right\"><md-button type=\"button\" layout=\"row\" ng-click=\"vm.loadDataEmployee()\" \nclass=\"md-raised md-accent\" aria-label=\"Search\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" \naria-label=\"android\"></md-icon>Search</md-button></md-input-container></div><div id=\"attView\"><table \nclass=\"simple striped\" ms-responsive-table style=\"margin-top:0\"><thead><tr><th><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th>Employe NIK</th>\n<th>Employe Name</th></tr></thead><tbody><tr ng-repeat=\"emp in vm.listEmploye\" ng-click=\"vm.checkone(emp)\"><td><input \ntype=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"emp\"></td><td>{{emp.nik}}</td><td>\n{{emp.empname}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" ng-click=\"vm.AddemployeSelected()\" class=\"md-raised md-accent\" aria-label=\"Add employe\" \nng-disabled=\"frmEmp.$invalid || frmEmp.$pristine\">Add employe</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/overtime/input-overtime/input-overtime.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon ui-sref=\"{{vm.Breadhome}}\" md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><div ng-repeat-start=\"ls  in vm.Breadlist\"></div><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\" ui-sref=\"{{ls.link}}\">{{ls.name}}</span><div ng-repeat-end></div>\n</div><div class=\"title\" translate=\"MENU.CB.OVERTIME.FORM.TITLE\">Form Input Overtime</div></div></div><div \nclass=\"content\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"90\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputOT\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputOT)\"><div layout-gt-sm=\"row\"><md-input-container \nflex><label translate=\"MENU.CB.OVERTIME.FORM.OVERTIME_DATE\">Overtime Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"ot_date\" ng-model=\"vm.Form.objForm.ot_date\" required></md-datepicker>\n</md-input-container><md-input-container flex><label translate=\"MENU.CB.OVERTIME.FORM.START_TIME\">Start Time</label>\n<input type=\"text\" name=\"start_time\" ng-model=\"vm.Form.objForm.starttime\" required mask data-mask=\"99:99:99\"><div \nng-messages=\"formInputOT.start_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Time Required</span>\n</div></div></md-input-container><md-input-container flex><label translate=\"MENU.CB.OVERTIME.FORM.END_TIME\">End Time\n</label><input type=\"text\" name=\"end_time\" ng-model=\"vm.Form.objForm.starttime\" required><div \nng-messages=\"formInputOT.end_time.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Time Required</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-button md-no-ink type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputemployeOT($event)\" class=\"md-primary\"><span translate=\"ACTION.ADD_EMPLOYEE\">Add Employe</span>\n</md-button></div><div id=\"attView\"><table id=\"listOT\" class=\"simple striped\" ms-responsive-table style=\"margin-top:0\">\n<thead><tr><th translate=\"TABLE.NIK\">NIK</th><th translate=\"TABLE.NAME\">Employe Name</th><th translate=\"TABLE.REASON\">\nReason</th></tr></thead><tbody><tr ng-repeat=\"div in vm.listDataSelected\"><td>{{div.nik}}</td><td>{{div.empname}}</td>\n<td></td></tr></tbody></table></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"vm.reloadToken()\" class=\"md-raised md-warn\" aria-label=\"Reload\"><span \ntranslate=\"ACTION.RELOAD_TOKEN\">Reload Token</span></md-button><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"formInputOT.$invalid || basicForm.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit\n</span></md-button><md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\">\n<span translate=\"ACTION.BACK\">Back</span></md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/cb/replacement-holiday/upload/replacement-holiday-upload.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" \nng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cb/passwordecheckingw/input-password-echeckingw/input-password-echeckingw.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Password Echeckin GW</span>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\nInput Password Echeckin GW</span></div><div class=\"title\" translate=\"MENU.CB.PASSWORD_ECHECKIN_GW.FORM.TITLE\">\nForm Password Echeckin GW</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"80\" flex-sm=\"90\" flex-xs=\"100\" \nflex-md=\"80\"><form name=\"formInputProfiles\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputProfiles)\"><div layout-gt-sm=\"row\"></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label translate=\"MENU.CB.PASSWORD_ECHECKIN_GW.FORM.TITLE_NAME\">Title</label><md-select \nng-model=\"vm.Form.objForm.title\" required><md-option ng-repeat=\"t in vm.title\" ng-value=\"t\">{{t}}</md-option>\n</md-select><div ng-messages=\"formInputProfiles.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTitle is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"firstName\" \nng-model=\"vm.Form.objForm.firstName\" placeholder=\"{{ \'MENU.CB.PASSWORD_ECHECKIN_GW.FORM.FIRST_NAME\' | translate }}\" \nrequired><div ng-messages=\"formInputProfiles.firstName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nFirst Name is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"lastName\" ng-model=\"vm.Form.objForm.lastName\" \nplaceholder=\"{{ \'MENU.CB.PASSWORD_ECHECKIN_GW.FORM.LAST_NAME\' | translate }}\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"MENU.CB.PASSWORD_ECHECKIN_GW.FORM.NO_KTP\">No KTP</label>\n<input ng-model=\"vm.Form.objForm.noktp\"></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.PASSWORD_ECHECKIN_GW.FORM.GENDER\">GENDER</label><md-select ng-model=\"vm.Form.objForm.jenkel\" \nrequired><md-option ng-repeat=\"g in vm.jenkel\" ng-value=\"g\">{{g}}</md-option></md-select><div \nng-messages=\"formInputProfiles.jenkel.$error\" role=\"alert\"><div ng-message=\"required\"><span>Gender is required.</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MENU.CB.PASSWORD_ECHECKIN_GW.FORM.COMPANY_ID\">Company ID</label><input ng-model=\"vm.Form.objForm.companyid\" \nrequired><div ng-messages=\"formInputProfiles.companyid.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany ID is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MENU.CB.PASSWORD_ECHECKIN_GW.FORM.WORKLOCATION_ID\">Work Location ID</label><input \nng-model=\"vm.Form.objForm.worklocationid\" required><div ng-messages=\"formInputProfiles.worklocationid.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Work Location ID is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MENU.CB.PASSWORD_ECHECKIN_GW.FORM.INTERNAL_ID\">Internal ID</label><input \nng-model=\"vm.Form.objForm.internalid\" required><div ng-messages=\"formInputProfiles.internalid.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Internal ID is required.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"MENU.CB.PASSWORD_ECHECKIN_GW.FORM.NIK\">nik</label><input ng-model=\"vm.Form.objForm.nik\" required><div\n ng-messages=\"formInputProfiles.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK is required.</span></div>\n</div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputProfiles.$invalid || basicForm.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span>\n</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/cb/passwordecheckingw/uploadfile/uploadfile.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"MENU.CB.PASSWORD_ECHECKIN_GW.UPLOAD.TITLE\">Upload File</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-content \nlayout=\"column\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><input \ntype=\"file\" id=\"uploadPhoto\" nv-file-select uploader=\"vm.FileUploaderPhoto\"></div><div flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-download\" class=\"teal-50-fg\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button>\n</div></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span translate=\"NOTIF.ERROR_UPLOAD\">Failed Upload File</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span translate=\"NOTIF.SUCCESS_UPLOAD\">Success Upload File</span>\n</md-whiteframe></md-content></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/cb/store-incharge/input-sic/input-sic.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Form Input SM</md-subheader><div class=\"white-bg\"><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputSic\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formInputSic)\"><div layout=\"column\"><md-input-container\n flex><input type=\"text\" name=\"sic_nik\" ng-readonly ng-model=\"vm.Form.objForm.sic_nik\" \nplaceholder=\"{{ \'MENU.CB.STORE_INCHARGE.FORM.SIC_NIK\' | translate }}\" ng-change=\"vm.clearMessage()\" required><div \nng-messages=\"formInputSic.sic_nik.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"VALIDATION.NIK_REQUIRED\">SM NIK is required.</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MENU.CB.STORE_INCHARGE.FORM.EFFECTIVE_DATE\">Effective date</label><md-datepicker \nng-change=\"vm.clearMessage()\" md-hide-icons=\"calendar\" aria-label=\"sic_effective_date\" name=\"sic_effective_date\" \nng-model=\"vm.Form.objForm.sic_effective_date\" required></md-datepicker><div \nng-messages=\"formInputSic.sic_effective_date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"VALIDATION.EFFECTIVE_DATE_REQUIRED\">SM Effective Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MENU.CB.STORE_INCHARGE.FORM.SUB_AREA\">Sub area</label><md-select \nng-model=\"vm.Form.objForm.sic_subarea\" name=\"subarea\" aria-label=\"subarea\" ng-change=\"vm.clearMessage()\" required \nng-disabled=\"vm.edit\"><md-option ng-repeat=\"ls in vm.subArea\" placeholder=\"{{ \'FILTER.SUB_AREA\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\"><span translate=\"ACTION.RELOAD_TOKEN\">Reload Token</span></md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputSic.$invalid || formInputSic.$pristine\"><span translate=\"ACTION.SUBMIT\">Submit</span></md-button>\n<md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\"><span \ntranslate=\"ACTION.BACK\">Back</span></md-button></div></form></div></div></div></div></md-content></div>");
$templateCache.put("app/main/cb/type-shift-matrix/create/create.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"form\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,form)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Type Shift Matrix</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div class=\"layout-gt-sm-row border-horizontal\"></div><div class=\"white-bg\"><div layout-gt-sm=\"row\">\n<md-input-container flex><label>NIK</label><input type=\"text\" ng-model=\"vm.Form.objForm.nik\" placeholder=\"NIK\" \nname=\"nik\" required><div ng-messages=\"form.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK Required.\n</span></div></div></md-input-container><md-input-container flex><label>Date Off</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"date_off\" ng-model=\"vm.Form.objForm.date_off\" required></md-datepicker><div \nng-messages=\"form.date_off.$error\" role=\"alert\"><div ng-message=\"required\"><span>Date Off Required.</span></div><div \nng-message=\"valid\"><span>Date Off Not Valid.</span></div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-if=\"vm.notif.success || vm.notif.error\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span ng-if=\"vm.notif.success\">{{vm.notif.success}}</span> <span \nng-if=\"vm.notif.error\">{{vm.notif.error}}</span></p></ms-widget-front></ms-widget><span flex></span><md-button \ntype=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"form.$invalid || form.$pristine\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/type-shift-matrix/edit/edit.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"form\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,form)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nForm Edit Type Shift Matrix</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon\n md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div class=\"layout-gt-sm-row border-horizontal\"></div><div \nclass=\"white-bg\"><div layout-gt-sm=\"row\"><input type=\"hidden\" ng-model=\"vm.Form.objForm.id\" placeholder=\"id\" name=\"id\" \nrequired><md-input-container flex><label>NIK</label><input type=\"text\" ng-model=\"vm.Form.objForm.nik\" \nplaceholder=\"NIK\" name=\"nik\" required><div ng-messages=\"form.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNIK Required.</span></div></div></md-input-container><md-input-container flex><label>Date Off</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"date_off\" ng-model=\"vm.Form.objForm.date_off\" required></md-datepicker><div \nng-messages=\"form.date_off.$error\" role=\"alert\"><div ng-message=\"required\"><span>Date Off Required.</span></div><div \nng-message=\"valid\"><span>Date Off Not Valid.</span></div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-if=\"vm.notif.success || vm.notif.error\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span ng-if=\"vm.notif.success\">{{vm.notif.success}}</span> <span \nng-if=\"vm.notif.error\">{{vm.notif.error}}</span></p></ms-widget-front></ms-widget><span flex></span><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"form.$invalid || form.$pristine\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cb/type-shift-matrix/upload/upload.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"form\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Upload Type Shift Matrix</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\">\n</md-progress-linear><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><div \nclass=\"layout-gt-sm-row border-horizontal\"></div><div class=\"white-bg\"><div layout-gt-sm=\"row\"><md-input-container \nflex><input type=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUploaderMatrix\"></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderMatrix.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"false\" \nlayout=\"column\" layout-align=\"center start \" ng-if=\"vm.notif.success || vm.notif.error\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span ng-if=\"vm.notif.success\">{{vm.notif.success}}</span> <span \nng-if=\"vm.notif.error\">{{vm.notif.error}}</span></p></ms-widget-front></ms-widget><span flex></span><md-button \ntype=\"button\" class=\"md-green-300-bg md-raised md-primary white-fg\" ng-click=\"vm.ExportToExcel()\"><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button type=\"submit\" \nng-click=\"vm.FileUploaderMatrix.uploadAll()\" class=\"md-green-300-bg md-raised md-primary white-fg\"><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/uploadeditkaryawan/uploadeditkaryawan.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>\nUpload Edit Karyawan</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\"><md-input-container flex><md-select ng-model=\"vm.uploadType\" \nname=\"uploadType\" required><md-option ng-repeat=\"ls in vm.listUploadType\" placeholder=\"Upload Type\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nng-if=\"vm.uploadType == 1\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><fieldset>\n<legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUploadStatus\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploadStatus.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content><div ng-show=\"vm.uploadErrorStatus\" flex layout layout-align=\"center center\" style=\"padding:3px\"><span \nstyle=\"color:red\">{{ vm.uploadNotifStatus }}</span></div><div ng-show=\"vm.uploadSuccessStatus\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotifStatus }}</span></div></fieldset></div><div \nng-if=\"vm.uploadType == 2\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><fieldset>\n<legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUploadGrade\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploadGrade.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content><div ng-show=\"vm.uploadErrorGrade\" flex layout layout-align=\"center center\" style=\"padding:3px\"><span \nstyle=\"color:red\">{{ vm.uploadNotifGrade }}</span></div><div ng-show=\"vm.uploadSuccessGrade\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotifGrade }}</span></div></fieldset></div><div \nng-if=\"vm.uploadType == 3\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><fieldset>\n<legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUploadTermination\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploadTermination.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content><div ng-show=\"vm.uploadErrorTermination\" flex layout layout-align=\"center center\" style=\"padding:3px\">\n<span style=\"color:red\">{{ vm.uploadNotifTermination }}</span></div><div ng-show=\"vm.uploadSuccessTermination\" flex \nlayout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotifTermination }}</span></div></fieldset>\n</div><div ng-if=\"vm.uploadType == 4\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\">\n<fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUploadSubarea\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploadSubarea.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content><div ng-show=\"vm.uploadErrorSubarea\" flex layout layout-align=\"center center\" style=\"padding:3px\"><span \nstyle=\"color:red\">{{ vm.uploadNotifSubarea }}</span></div><div ng-show=\"vm.uploadSuccessSubarea\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotifSubarea }}</span></div></fieldset></div><div \nng-if=\"vm.uploadType == 5\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><fieldset>\n<legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileUploadRekening\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploadRekening.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content><div ng-show=\"vm.uploadErrorRekening\" flex layout layout-align=\"center center\" style=\"padding:3px\"><span \nstyle=\"color:red\">{{ vm.uploadNotifRekening }}</span></div><div ng-show=\"vm.uploadSuccessRekening\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotifRekening }}</span></div></fieldset></div><div \nng-if=\"vm.uploadType == 6\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><fieldset>\n<legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\"><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select uploader=\"vm.FileuploadDocument\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileuploadDocument.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content><div ng-show=\"vm.uploadErrorDocument\" flex layout layout-align=\"center center\" style=\"padding:3px\"><span \nstyle=\"color:red\">{{ vm.uploadNotifDocument }}</span></div><div ng-show=\"vm.uploadSuccessDocument\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotifDocument }}</span></div></fieldset></div>\n</form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel\n</md-button><div ng-if=\"vm.uploadType == 1\"><md-button type=\"submit\" ng-click=\"vm.FileUploadStatus.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate(\'status\')\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfoStatus\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoStatus)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>\nMore Info</span></md-button></div><div ng-if=\"vm.uploadType == 2\"><md-button type=\"submit\" \nng-click=\"vm.FileUploadGrade.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate(\'grade\')\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfoGrade\" type=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoGrade)\" \nclass=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span></md-button></div><div \nng-if=\"vm.uploadType == 3\"><md-button type=\"submit\" ng-click=\"vm.FileUploadTermination.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate(\'termination\')\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfoTermination\" type=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoTermination)\" \nclass=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span></md-button></div><div \nng-if=\"vm.uploadType == 4\"><md-button type=\"submit\" ng-click=\"vm.FileUploadSubarea.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate(\'subarea\')\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfoSubarea\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoSubarea)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\">\n<span>More Info</span></md-button></div><div ng-if=\"vm.uploadType == 5\"><md-button type=\"submit\" \nng-click=\"vm.FileUploadRekening.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate(\'rekening\')\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfoRekening\" type=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoRekening)\" \nclass=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span></md-button></div><div \nng-if=\"vm.uploadType == 6\"><md-button type=\"submit\" ng-click=\"vm.FileuploadDocument.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate(\'document\')\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfoDocument\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfoDocument)\" class=\"md-primary md-hue-1\" aria-label=\"More Info\">\n<span>More Info</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/edit-employe.html","<div id=\"mail\" class=\"page-layout carded left-sidenav with-toolbar-content\" layout=\"row\"><form ng-cloack \nname=\"jumpToNikForm\" class=\"md-inline-form popup-input-form\" ng-submit=\"vm.jumpToNik($event,jumpToNikForm)\"><div \nid=\"sub-header-employee\" class=\"header\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"search-wrapper md-whiteframe-4dp white-bg full-height\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"center none\" flex><div layout=\"row\" flex layout-align=\"center center\" flex-gt-xs=\"60\"><div \nid=\"title-search-wrapper\" layout=\"row\" class=\"mb-5\"><md-icon id=\"icon-search-employee\" \nmd-font-icon=\"icon-redo-variant\" class=\"icon\"></md-icon><span id=\"title-search-employee\" class=\"md-subhead text-right\">\nJump To Other</span></div><div id=\"title-search-input\" class=\"search\" flex layout=\"row\" layout-align=\"start center\" \nid=\"search-employee\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24 mb-5\"></md-icon><div \nid=\"autocomplete-employee-wrapper\" flex layout=\"column\" style=\"margin-bottom: -5px\"><md-autocomplete \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empsno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.searchString\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-min-length=\"3\" md-input-name=\"empsno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/NIK\" required><md-item-template layout=\"row\"><span\n md-highlight-text=\"vm.searchString\">{{item.fullname}}</span></md-item-template><md-not-found>\nNo Employee Name/NIK matching \"{{vm.searchString}}\" were found.</md-not-found></md-autocomplete></div></div></div><div \nlayout=\"row\" flex layout-align=\"center center\"><md-input-container flex class=\"mb-15\" flex-offset=\"5\"><label>Menus\n</label><md-select ng-model=\"vm.selectedMenu\" name=\"select_menu\" required><md-optgroup label=\"My Profile\"><md-option \nng-repeat=\"nav in vm.profileMenu\" ng-value=\"nav.link\">{{nav.label | translate}}</md-option></md-optgroup><md-optgroup \nlabel=\"Employement\"><md-option ng-repeat=\"nav in vm.employementMenu\" ng-value=\"nav.link\">{{nav.label | translate}}\n</md-option></md-optgroup></md-select><div ng-messages=\"jumpToNikForm.select_menu.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Menus is required.</span></div></div></md-input-container><md-button flex=\"nogrow\" \ntype=\"submit\" class=\"mb-15 md-primary\" flex-offset=\"5\">Go<md-icon md-font-icon=\"icon-arrow-right\" class=\"icon s24\">\n</md-icon></md-button></div></div></div></form><md-sidenav id=\"sidenav-wrapper\" class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-sidenav-helper ms-scroll><div class=\"header\" \nlayout=\"column\" layout-padding=\"50\" layout-align=\"space-between start-center\"><div class=\"center\" layout=\"row\">\n<md-card-avatar ng-if=\"vm.checkPhoto==null || vm.checkPhoto==\'undefined\' || vm.checkPhoto==\'-\'\"><img \nng-src=\"{{vm.PhotoProfile}}\" class=\"profile-image profile-avatar\"></md-card-avatar><md-card-avatar \nng-if=\"vm.checkPhoto!==null && vm.checkPhoto!==\'undefined\' && vm.checkPhoto!==\'-\'\"><span \nclass=\"profile-image profile-avatar\" \nstyle=\"display: block; background-size: cover; background-position: center; background-repeat: none\" \nng-style=\"{\'background-image\': \'url(\' + vm.PhotoProfile + \'), url(assets/images/avatars/unprofile.jpg)\'}\"></span>\n</md-card-avatar><div class=\"img-hover\" ng-click=\"vm.openUploadPhoto($event)\"><span class=\"img-text-hover\"><span \ntranslate=\"MYPROFILE.MENU.EDITAVATAR\">Edit Avatar</span></span></div></div></div><md-content layout-padding \nclass=\"content side-nav\" flex ms-scroll><div \nng-include=\"\'app/main/employee/employe/input-employe/sidenavs/main/main-sidenav.html\'\"></div></md-content></md-sidenav>\n<div id=\"content-card-wrapper-employee\" class=\"center profile-left-side\" layout=\"column\" flex><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" flex><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle left Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><div><h2>\n{{vm.Form.objForm.title}} {{vm.Form.objForm.firstName}} {{vm.Form.objForm.middleName}} {{vm.Form.objForm.lastName}}\n</h2></div></div><md-content class=\"content\" flex ms-scroll id=\"data-profiles\"><div><ui-view autoscroll=\"true\">\n</ui-view></div></md-content></div></div></div>");
$templateCache.put("app/main/employee/employe/input-employe/edit-myemploye.html","<div id=\"mail\" class=\"page-layout carded left-sidenav with-toolbar-content\" layout=\"row\"><div \nclass=\"top-bg md-teal-A700-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"sidenav\" ms-sidenav-helper ms-scroll><div class=\"header\" layout=\"column\" layout-padding=\"50\" \nlayout-align=\"space-between start-center\"><div class=\"center\" layout=\"row\"><md-card-avatar \nng-if=\"vm.checkPhoto==null || vm.checkPhoto==\'undefined\' || vm.checkPhoto==\'-\'\"><img ng-src=\"{{vm.PhotoProfile}}\" \nclass=\"profile-image profile-avatar\"></md-card-avatar><md-card-avatar \nng-if=\"vm.checkPhoto!==null && vm.checkPhoto!==\'undefined\' && vm.checkPhoto!==\'-\'\"><span \nclass=\"profile-image profile-avatar\" \nstyle=\"display: block; background-size: cover; background-position: center; background-repeat: none\" \nng-style=\"{\'background-image\': \'url(\' + vm.PhotoProfile + \'), url(assets/images/avatars/unprofile.jpg)\'}\"></span>\n</md-card-avatar><div class=\"img-hover\" ng-click=\"vm.openUploadPhoto($event)\"><span class=\"img-text-hover\"><span \ntranslate=\"MYPROFILE.MENU.EDITAVATAR\">Edit Avatar</span></span></div></div></div><md-content layout-padding \nclass=\"content side-nav\" flex ms-scroll><div \nng-include=\"\'app/main/employee/employe/input-employe/sidenavs/main/main-sidenav.html\'\"></div></md-content></md-sidenav>\n<div class=\"center profile-left-side\" layout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" flex><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle left Sidenav\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><div layout=\"row\" class=\"full-width\" layout-align=\"start center\"><div \nclass=\"label md-blue-grey-500-bg pv-5 ph-10 mr-10\" translate=\"MYPROFILE.HEADER\">My Profile</div><h2>\n{{vm.Form.objForm.title}} {{vm.Form.objForm.firstName}} {{vm.Form.objForm.middleName}} {{vm.Form.objForm.lastName}}\n</h2></div></div><md-content class=\"content\" flex ms-scroll><div><ui-view autoscroll=\"true\"></ui-view></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/employee/employe/input-employe/input-employe.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Employee</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Input Profile</span></div><div \nclass=\"title\">Form Input Profile</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" \nflex-md=\"80\"><form name=\"formInputProfiles\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputProfiles)\"><div layout=\"column\"><md-input-container flex><label>Title</label><md-select\n ng-model=\"vm.Form.objForm.title\" required><md-option ng-repeat=\"t in vm.title\" ng-value=\"t\">{{t}}</md-option>\n</md-select><div ng-messages=\"formInputProfiles.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTitle is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"firstName\" \nng-model=\"vm.Form.objForm.firstName\" placeholder=\"First Name\" required><div \nng-messages=\"formInputProfiles.firstName.$error\" role=\"alert\"><div ng-message=\"required\"><span>First Name is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"lastName\" \nng-model=\"vm.Form.objForm.lastName\" placeholder=\"Last Name\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Date Join</label><md-datepicker ng-model=\"vm.Form.objForm.dateJoin\" name=\"dateJoin\" \nid=\"dateJoin\" aria-label=\"date join\" required></md-datepicker><div ng-messages=\"formInputProfiles.dateJoin.$error\"><div\n ng-message=\"valid\">The entered value is not a date!</div><div ng-message=\"required\">This date is required!</div></div>\n</md-input-container><md-input-container flex><label>Jenis Kelamin</label><md-select ng-model=\"vm.Form.objForm.jenkel\" \nrequired><md-option ng-repeat=\"g in vm.jenkel\" ng-value=\"g\">{{g}}</md-option></md-select><div \nng-messages=\"formInputProfiles.jenkel.$error\" role=\"alert\"><div ng-message=\"required\"><span>Jenkel is required.</span>\n</div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputProfiles.$invalid || basicForm.$pristine\">Submit</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/employee/employe/uploadfile/uploadfile.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ACTION.UPLOAD\">Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input id=\"FileUpload\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" type=\"file\" \nid=\"upload\" nv-file-select uploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" ng-click=\"vm.DownloadTemplate(\'employee\')\" \nclass=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button><md-button ng-if=\"vm.isMoreInfo\" \ntype=\"button\" ng-click=\"vm.viewMoreInfo()\" class=\"md-primary md-hue-1\" aria-label=\"More Info\"><span>More Info</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/employe-admin/search-employe/search-employe.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>Search Employe\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\" ng-if=\"!vm.dataSales\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container\n flex><input type=\"text\" placeholder=\"Employee Name / NIK\" ng-model=\"vm.searchMember\" id=\"formSearch\">\n</md-input-container><md-input-container flex=\"nogrow\"><md-button class=\"md-mini md-raised md-primary\" \nng-click=\"vm.loadDataMember()\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\">\n</md-icon><span>Search</span></md-button></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-padding><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nclass=\"text-center\">No</th><th class=\"text-center\">NIK</th><th class=\"text-center\">Gedung</th><th class=\"text-center\">\nSector</th><th class=\"text-center\">Line</th><th class=\"text-center\">Group Shift</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listDataEmpSearch\"><td class=\"text-center\">{{$index + 1}}</td><td>{{ ls.nik}} - {{ls.name}}</td><td\n class=\"text-center\">{{ls.locationEmp.gedung_name | uppercase}}</td><td class=\"text-center\">\n{{ls.locationEmp.sector_name}}</td><td class=\"text-center\">{{ls.locationEmp.line_number}}</td><td class=\"text-center\">\n{{ls.shift_group_name}}</td></tr></tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/employee/employe-admin/upload-building/upload-building.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>\nUpload Building Employee</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate(\'tempbuildingadmin\')\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/employee/employe-admin/upload-edit-atasan/upload-edit-atasan.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>\nUpload Data Atasan Employee</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon\n md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate(\'tempeditatasanadmin\')\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/employe-admin/upload-edit-group-shift/upload-edit-group-shift.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>\nUpload Data Group Shift Employee</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"upload\" nv-file-select \nuploader=\"vm.FileUpload\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUpload.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear></div></md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" \nflex layout layout-align=\"center center\" style=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif }}</span></div>\n<div ng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}\n</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate(\'tempeditgroupshiftadmin\')\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.FileUpload.uploadAll()\" class=\"md-primary md-hue-1\" \naria-label=\"Upload\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/employee-labor-type/input-employee-labor-type/input-employee-labor-type.html","<md-dialog aria-label=\"Input Data Employee Labor Type\" md-theme=\"modal-theme\" layout layout-wrap><form \nname=\"frmEmploye\" ng-submit=\"vm.saveDataEmpLabor($event, frmEmploye)\" novalidate flex><md-toolbar flex><div \nclass=\"md-toolbar-tools\"><h2>Input Data Employee Labor Type</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nflex flex-gt-sm><md-select ng-model=\"vm.company\" aria-label=\"company\" name=\"company\" ng-change=\"vm.empList()\" required>\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><label>Type</label><md-select ng-model=\"vm.selectedLaborType\" name=\"labortype\"><md-option \nng-repeat=\"ls in vm.labortype\" value=\"{{ ls }}\">{{ ls }}</md-option></md-select><div \nng-messages=\"frmEmploye.labortype.$error\" role=\"alert\"><div ng-message=\"required\"><span>Labor Type field is required.\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label>\nEffective Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.effectiveDate\" name=\"effectiveDate\" \nrequired></md-datepicker><div ng-messages=\"frmEmploye.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Effective date field is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-autocomplete\n flex flex-gt-sm md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearchDeferred(vm.searchText)\" md-item-text=\"item.nik\" md-input-name=\"nik\" \nplaceholder=\"Search NIK Employee\"><md-item-template><span md-highlight-text=\"vm.searchText\">\n{{item.nik}} ({{item.name}})</span></md-item-template><md-not-found>No NIK matching \"{{vm.searchText}}\" were found.\n</md-not-found></md-autocomplete></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-download\" \naria-label=\"android\"></md-icon>Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employee-labor-type/update-employee-labor-type/update-employee-labor-type.html","<md-dialog aria-label=\"Input Data Employee Labor Type\" md-theme=\"modal-theme\" layout layout-wrap><form \nname=\"frmEmploye\" ng-submit=\"vm.updateEmpLabor($event, frmEmploye)\" novalidate flex><md-toolbar flex><div \nclass=\"md-toolbar-tools\"><h2>Update Data Employee Labor Type</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nflex flex-gt-sm><label>NIK</label><input type=\"text\" value=\"{{ vm.nik }}\" disabled=\"disabled\"></md-input-container>\n</div><div layout=\"row\"><md-input-container flex flex-gt-sm><label>Name</label><input type=\"text\" \nvalue=\"{{ vm.name }}\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container flex \nflex-gt-sm><label>Type</label><md-select ng-model=\"vm.selectedLaborType\" name=\"labortype\"><md-option \nng-repeat=\"ls in vm.labortype\" value=\"{{ ls }}\">{{ ls }}</md-option></md-select><div \nng-messages=\"frmEmploye.labortype.$error\" role=\"alert\"><div ng-message=\"required\"><span>Labor Type field is required.\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex flex-gt-sm><label>\nEffective Date</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.effectiveDate\" name=\"effectiveDate\" \nrequired></md-datepicker><div ng-messages=\"frmEmploye.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Effective date field is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\"></md-icon>Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employee-labor-type/upload-employee-labor-type/upload-employee-labor-type.html","<md-dialog aria-label=\"Upload Data Cut Off\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>\nUpload Data Employee Labor</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon\n md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadEmpLabor\" \nnv-file-select uploader=\"vm.FileUploaderEmpLabor\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderEmpLabor.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div></md-content>\n</fieldset><div flex><div ng-show=\"vm.uploadEmpLaborStateError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">Failed Upload data</span></div><div \nng-show=\"vm.uploadEmpLaborStateSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">\nSuccess Upload data</span></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"vm.FileUploaderEmpLabor.uploadAll()\" \nclass=\"md-primary md-hue-1\" aria-label=\"Submit\"><md-icon md-font-icon=\"icon-upload\"></md-icon>Submit</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/employement/input-employement/input-employement.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Master PROFILES</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Input PROFILES</span></div><div \nclass=\"title\">Form Input PROFILES</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" \nflex-md=\"80\"><form name=\"formInputEmployement\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputEmployement)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" \nname=\"nik\" ng-model=\"vm.Form.objForm.nik\" placeholder=\"NIK\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputEmployement.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>NIK is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"nik_atasan\" \nng-model=\"vm.Form.objForm.nik_atasan\" placeholder=\"NIK Atasan\" required><div \nng-messages=\"formInputEmployement.nik_atasan.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNIK Atasan is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"grade\" ng-model=\"vm.Form.objForm.grade\" placeholder=\"Grade\" required><div \nng-messages=\"formInputEmployement.grade.$error\" role=\"alert\"><div ng-message=\"required\"><span>Grade is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"positionid\" \nng-model=\"vm.Form.objForm.positionid\" placeholder=\"positionid\" required><div \nng-messages=\"formInputEmployement.positionid.$error\" role=\"alert\"><div ng-message=\"required\"><span>\npositionid is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"emp_profile_id\" ng-model=\"vm.Form.objForm.emp_profile_id\" placeholder=\"emp_profile_id\" required><div \nng-messages=\"formInputEmployement.emp_profile_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nemp_profile_id is required.</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputEmployement.$invalid || basicForm.$pristine\">Submit</md-button></div></form></div></div></div>\n</div>");
$templateCache.put("app/main/employee/hr-completion/completion-form/completion-form.html","<md-dialog aria-label=\"HR Completion\" md-theme=\"modal-theme\" layout-wrap flex-md=\"80\" flex-gt-md=\"60\"><form \nclass=\"md-inline-form popup-input-form\" name=\"frmHrCompletion\" ng-submit=\"vm.saveDataSubarea($event, frmHrCompletion)\" \nnovalidate layout-fill><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MENU.MAIN.HRCOMPLETION\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nflex><input ng-model=\"vm.nikAtasan\" type=\"text\" name=\"nikAtasan\" ng-disabled=\"true\" \nplaceholder=\"{{\'KPI.LABEL.DIRECTREPORT\' | translate}}\" required><div ng-messages=\"frmHrCompletion.nikAtasan.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.DIRECTREPORT\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">NIK Atasan field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.costCenterCB\" aria-label=\"costCenterCB\" name=\"costCenterCB\" required>\n<md-option ng-repeat=\"ls in vm.costCenterCBList\" placeholder=\"{{ \'KPI.LABEL.CNB\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.id}}. {{ls.description}}</md-option></md-select><div ng-messages=\"frmHrCompletion.costCenterCB.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.CNB\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\">Cost Center C&B field is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select ng-model=\"vm.costCenterNonCB\" aria-label=\"costCenterNonCB\" name=\"costCenterNonCB\" \nrequired><md-option ng-repeat=\"ls in vm.costCenterNonCBList\" placeholder=\"{{ \'KPI.LABEL.NONCNB\' | translate}}\" \nvalue=\"{{ls.id}}\">{{ls.id}}. {{ls.description}}</md-option></md-select><div \nng-messages=\"frmHrCompletion.costCenterNonCB.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.NONCNB\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nCost Center Non C&B field is required.</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"20\"><label><span translate=\"KPI.LABEL.ABBREVIATION\"></span></label><md-select \nng-model=\"vm.abbreviation\" aria-label=\"Abbreviation\" name=\"abbreviation\" \nng-change=\"vm.changedAbbreviation(vm.abbreviation)\" required><md-option ng-repeat=\"ls in vm.abbbreviationLists\" \nplaceholder=\"{{ \'KPI.LABEL.ABBREVIATION\' | translate}}\" value=\"{{ls.positionID}}\">{{ls.positionID}}. {{ls.description}}\n</md-option></md-select><div class=\"md-errors-spacer\"><div ng-messages=\"frmHrCompletion.abbreviation.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.ABBREVIATION\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></div></md-input-container><md-input-container flex><label>\n<span translate=\"UMUT.MENU.JOBTITLE\"></span></label><input type=\"text\" name=\"job_title\" ng-model=\"vm.job_title\" \nrequired><div ng-messages=\"frmHrCompletion.job_title.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"UMUT.MENU.JOBTITLE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.AREA\"></span>\n</label><md-select ng-model=\"vm.personalSubArea\" aria-label=\"personalSubArea\" name=\"personalSubArea\" \nng-change=\"vm.loadGedung(vm.personalSubArea)\" required><md-option ng-repeat=\"ls in vm.subAreaLists\" \nplaceholder=\"{{ \'KPI.LABEL.AREA\' | translate}}\" value=\"{{ls.id}}\">{{ls.id}}. {{ls.description}}</md-option></md-select>\n<div ng-messages=\"frmHrCompletion.personalSubArea.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.AREA\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Personal Sub Area field is required.\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.OT\"></span></label>\n<md-select ng-model=\"vm.Ot\" aria-label=\"Ot\" name=\"Ot\" required><md-option ng-repeat=\"ls in vm.otParamLists\" \nplaceholder=\"{{ \'KPI.LABEL.OT\' | translate}}\" value=\"{{ls.ot_code}}\">{{ls.ot_code}}. {{ls.ot_description}}</md-option>\n</md-select><div ng-messages=\"frmHrCompletion.Ot.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.OT\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">OT field is required.</span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.BUILDING\">\n</span></label><md-select ng-model=\"vm.gedung\" aria-label=\"Gedung\" name=\"gedung\" ng-disabled=\"true\" \nng-change=\"vm.loadSector(vm.gedung)\" required><md-option ng-repeat=\"ls in vm.gedungLists\" \nplaceholder=\"{{ \'KPI.LABEL.BUILDING\' | translate}}\" value=\"{{ls.id}}\">{{ls.id}}. {{ls.gedung_name}}</md-option>\n</md-select><div ng-messages=\"frmHrCompletion.gedung.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.BUILDING\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.SECTOR\"></span></label><md-select \nng-model=\"vm.sector\" ng-disabled=\"true\" aria-label=\"Sector\" name=\"sector\" ng-change=\"vm.loadLine(vm.sector)\" required>\n<md-option ng-repeat=\"ls in vm.sectorLists\" placeholder=\"{{ \'KPI.LABEL.SECTOR\' | translate}}\" value=\"{{ls.id}}\">\n{{ls.id}}. {{ls.sector_name}}</md-option></md-select><div ng-messages=\"frmHrCompletion.sector.$error\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"KPI.LABEL.SECTOR\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.TAXCODE\"></span></label><md-select ng-model=\"vm.tax_code\" aria-label=\"tax_code\" \nname=\"tax_code\" required><md-option ng-repeat=\"ls in vm.taxParamLists\" \nplaceholder=\"{{ \'PAYROLL.MENU.TAXCODE\' | translate}}\" value=\"{{ls.TaxCode}}\">{{ls.TaxCode}} - {{ls.TaxDesc}}\n</md-option></md-select><div ng-messages=\"frmHrCompletion.tax_code.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"PAYROLL.MENU.TAXCODE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">Tax Code field is required.\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.TAXLOCATION\">\n</span></label><md-select ng-model=\"vm.tax_location\" aria-label=\"tax_location\" name=\"tax_location\" required><md-option \nng-repeat=\"ls in vm.taxLocationLists\" placeholder=\"{{ \'PAYROLL.MENU.TAXLOCATION\' | translate}}\" \nvalue=\"{{ls.Taxlocationcode}}\">{{ls.Taxlocationcode}} - {{ls.TaxOfficename}}</md-option></md-select><div \nng-messages=\"frmHrCompletion.tax_location.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.TAXLOCATION\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nTax Location field is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"KPI.LABEL.LABOURCATEGORY\"></span></label><md-select ng-model=\"vm.dlidl_category\" \naria-label=\"dlidl_category\" name=\"dlidl_category\" required><md-option ng-repeat=\"ls in vm.laborCategoryLists\" \nplaceholder=\"OT\" value=\"{{ls.value}}\">{{ls.label}}</md-option></md-select><div \nng-messages=\"frmHrCompletion.dlidl_category.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.LABOURCATEGORY\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\nTax Location field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\"><span translate=\"ACTION.CANCEL\"></span></md-button><md-button \ntype=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmHrCompletion.$invalid || frmHrCompletion.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/employee/hr-completion/completion-upload/completion-upload.html","<md-dialog aria-label=\"Upload Data Cut Off\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>\nUpload Data HR Completion</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><fieldset><legend>Format file accepted (.xlxs)</legend><md-content layout=\"column\">\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadHrCompletion\" \nnv-file-select uploader=\"vm.FileUploaderHrCompletion\"></div></div><span class=\"padding-5\"></span><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.FileUploaderHrCompletion.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div></md-content>\n</fieldset><div class=\"m-10\"><a href=\"{{vm.downloadTemplateURL}}\" target=\"_blank\" \ndownload=\"template_upload_hr_completion.xlsx\">Download Template</a></div><div flex><div \nng-show=\"vm.uploadHrCompletionError\" flex layout layout-align=\"center center\" style=\"padding:3px\"><span \nstyle=\"color:red\">Failed Upload data</span></div><div ng-show=\"vm.uploadHrCompletionSuccess\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">Success Upload data</span></div></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\">Cancel</md-button><md-button\n type=\"submit\" ng-click=\"vm.FileUploaderHrCompletion.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Submit\">\n<md-icon md-font-icon=\"icon-upload\"></md-icon>Submit</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/profiles/input-profiles/input-profiles.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"KPI.LABEL.PROFILEFORM\"></span></md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><form name=\"formInputProfiles\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.saveData(formInputProfiles)\"><div layout-gt-sm=\"row\"></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"KPI.LABEL.TITLE\"></span></label><md-select \nng-model=\"vm.Form.objForm.title\" required><md-option ng-repeat=\"t in vm.title\" ng-value=\"t\">{{t}}</md-option>\n</md-select><div ng-messages=\"formInputProfiles.title.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.TITLE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"firstName\" ng-model=\"vm.Form.objForm.firstName\" \nplaceholder=\"{{ \'KPI.LABEL.FIRSTNAME\' | translate}}\" required><div ng-messages=\"formInputProfiles.firstName.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.FIRSTNAME\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"middleName\" ng-model=\"vm.Form.objForm.middleName\" \nplaceholder=\"{{ \'KPI.LABEL.MIDDLENAME\' | translate}}\"><div ng-messages=\"formInputProfiles.middleName.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"KPI.LABEL.MIDDLENAME\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"lastName\" ng-model=\"vm.Form.objForm.lastName\" placeholder=\"{{ \'KPI.LABEL.LASTNAME\' | translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"nickName\" ng-model=\"vm.Form.objForm.nickName\" \nplaceholder=\"{{ \'KPI.LABEL.NICKNAME\' | translate}}\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"MYPROFILE.MENU.DATEOFBIRTH\"></span></label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.dateOfBirth\" name=\"dateOfBirth\" id=\"dateOfBirth\" \naria-label=\"dateOfBirth\" required></md-datepicker><div ng-messages=\"formInputProfiles.dateOfBirth.$error\"><div \nng-message=\"valid\">The entered value is not a date!</div><div ng-message=\"required\">This date is required!</div></div>\n</md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.PLACEOFBIRTH\"></span></label>\n<input ng-model=\"vm.Form.objForm.placeOfBirth\"><div ng-messages=\"formInputProfiles.placeOfBirth.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.PLACEOFBIRTH\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"MYPROFILE.MENU.MARTIAL\"></span></label><md-select ng-model=\"vm.Form.objForm.maritalStatus\"><md-option \nng-repeat=\"status in vm.maritalStatuses\" ng-value=\"status\">{{status}}</md-option></md-select></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.HEIGHT\"></span></label>\n<input ng-model=\"vm.Form.objForm.height\"></md-input-container><md-input-container flex><label><span \ntranslate=\"MYPROFILE.MENU.GENDER\"></span></label><md-select ng-model=\"vm.Form.objForm.jenkel\" required><md-option \nng-repeat=\"g in vm.jenkel\" ng-value=\"g\">{{g}}</md-option></md-select><div \nng-messages=\"formInputProfiles.jenkel.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.GENDER\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.BLOODTYPE\"></span></label><input \nng-model=\"vm.Form.objForm.bloodType\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label><span translate=\"MYPROFILE.MENU.NATIONALITY\"></span></label><input ng-model=\"vm.Form.objForm.nationality\">\n</md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.ETHNIC\"></span></label><input \nng-model=\"vm.Form.objForm.sukuBangsa\"></md-input-container><md-input-container flex><label><span \ntranslate=\"MYPROFILE.MENU.RELIGION\"></span></label><input ng-model=\"vm.Form.objForm.religion\"></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"KPI.LABEL.JOINDATE\"></span></label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.dateJoin\" name=\"dateJoin\" id=\"dateJoin\" \naria-label=\"date join\" required></md-datepicker><div ng-messages=\"formInputProfiles.dateJoin.$error\"><div \nng-message=\"valid\">The entered value is not a date!</div><div ng-message=\"required\">This date is required!</div></div>\n</md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.PHONENUMBER\"></span></label><input\n ng-model=\"vm.Form.objForm.personalPhoneNumber\"></md-input-container><md-input-container flex><label><span \ntranslate=\"MYPROFILE.MENU.EMAIL\"></span></label><input type=\"email\" ng-model=\"vm.Form.objForm.empEmail\">\n</md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"formInputProfiles.$invalid || basicForm.$pristine\">Submit</md-button></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/employee/subarea/input-subarea/input-subarea.html","<md-dialog aria-label=\"Input Data Employee Labor Type\" md-theme=\"modal-theme\" flex><form \nclass=\"md-inline-form popup-input-form\" id=\"frmSubArea\" name=\"frmEmploye\" \nng-submit=\"vm.saveDataSubarea($event, frmEmploye)\" novalidate layout-fill><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Input Data Sub Area</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"column\" layout-gt-xs=\"row\"><div layout=\"column\" flex \nflex-gt-xs=\"40\"><md-input-container flex><md-select ng-model=\"vm.company\" aria-label=\"company\" name=\"company\" \nng-change=\"vm.empList()\" required><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Sub Area Name</label><input ng-model=\"vm.subarea\" type=\"text\" name=\"subarea\"><div \nng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.\n</span></div></div></md-input-container><div flex class=\"mb-40\"><h5 class=\"mt-0 mb-5\">Source</h5><md-radio-group \nng-model=\"vm.source\" name=\"source\"><div class=\"row\"><div layout=\"row\" layout-align=\"start strech\"><md-radio-button \nflex=\"nogrow\" ng-value=\"hris\" class=\"md-primary\" selected=\"selected\"><div class=\"mt-5\">HRIS</div></md-radio-button><div\n flex=\"15\" hide show-gt-xs></div><div flex layout=\"row\" layout-align=\"start center\"><md-radio-button flex=\"nogrow\" \nvalue=\"sap\" class=\"md-primary mr-10\"><div class=\"mt-5\">SAP</div></md-radio-button><md-input-container \nid=\"source-id-container\" class=\"m-0\" flex><label>Source ID</label><input ng-model=\"vm.source_id\" type=\"text\" \nname=\"source_id\"></md-input-container></div></div></div></md-radio-group><div ng-messages=\"frmEmploye.source.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Source choosen is required.</span></div></div></div><md-input-container \nflex><label>Country</label><md-select ng-model=\"vm.country\" name=\"country\" required \nmd-on-close=\"vm.clearSearchTermCountry()\" ng-change=\"vm.loadTownList(vm.country.id)\"><md-select-header><input \nng-model=\"vm.searchTermCountry\" type=\"search\" placeholder=\"Search for country\" class=\"md-text\" autocomplete=\"off\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"ls in vm.listCountry | filter:vm.searchTermCountry\" placeholder=\"Country\" ng-value=\"ls\">\n{{ls.nicename}} ({{ls.countrycode}})</md-option></md-select><div ng-messages=\"frmEmploye.country.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Country field is required.</span></div></div></md-input-container><md-input-container \nflex><label>Town</label><md-select ng-model=\"vm.town\" aria-label=\"town\" name=\"town\" ng-change=\"vm.empList()\" \nmd-on-close=\"vm.clearSearchTermTown()\"><md-select-header><input ng-model=\"vm.searchTermTown\" type=\"search\" \nplaceholder=\"Search for town\" class=\"md-text\" autocomplete=\"off\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"ls in vm.townList\" placeholder=\"town\" value=\"{{ls.id}}\">{{ls.town_name}}\n</md-option></md-select><div class=\"hint\">Town Note: Leave empty if not defined yet.</div><div \nng-messages=\"frmEmploye.town.$error\" role=\"alert\"><div ng-message=\"required\"><span>Town field is required.</span></div>\n</div></md-input-container></div><div flex flex-gt-xs=\"10\"></div><div layout=\"column\" flex flex-gt-xs=\"40\"><md-content \nclass=\"autocomplete\" layout=\"column\"><h5 class=\"md-title mt-0\">Sub Area Admin</h5><md-contact-chips \nng-model=\"vm.user_admins\" md-contacts=\"vm.delayedQuerySearch($query)\" md-contact-name=\"name\" md-contact-image=\"image\" \nmd-contact-email=\"email\" md-require-match=\"true\" md-highlight-flags=\"i\" placeholder=\"Type name to see matches\" \nsecondary-placeholder=\"Add another admin\" input-aria-label=\"Senders\"></md-contact-chips></md-content></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\">Cancel</md-button><md-button\n type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/subarea/update-subarea/update-subarea.html","<md-dialog aria-label=\"Input Data Employee Labor Type\" md-theme=\"modal-theme\" flex-md=\"60\" flex-gt-md=\"40\" layout-wrap>\n<form name=\"frmEmploye\" ng-submit=\"vm.updateSubArea($event, frmEmploye)\" novalidate layout-fill><md-toolbar flex><div \nclass=\"md-toolbar-tools\"><h2>Update Data Sub Area</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nflex><md-select ng-model=\"vm.company\" aria-label=\"company\" name=\"company\" ng-change=\"vm.empList()\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company field is required.</span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><md-select ng-model=\"vm.town\" \naria-label=\"town\" name=\"town\" ng-change=\"vm.empList()\" required><md-option ng-repeat=\"ls in vm.townList\" \nplaceholder=\"town\" value=\"{{ls.id}}\">{{ls.town_name}}</md-option></md-select><div ng-messages=\"frmEmploye.town.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Town field is required.</span></div></div></md-input-container></div><div\n layout=\"row\"><md-input-container flex><label>Sub Area Name</label><input ng-model=\"vm.subarea\" type=\"text\" \nname=\"subarea\"><div ng-messages=\"frmEmploye.subarea.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSub Area field is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.dialogClose()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-download\" aria-label=\"android\"></md-icon>Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/town/input-town/input-town.html","<md-dialog aria-label=\"Input Data Employee Labor Type\" md-theme=\"modal-theme\" layout-wrap flex-md=\"60\" flex-gt-md=\"40\">\n<form class=\"md-inline-form popup-input-form\" name=\"frmEmploye\" ng-submit=\"vm.saveData($event, frmEmploye)\" novalidate \nlayout-fill><md-toolbar class=\"md-cyan-600-bg has-toolbar\" flex><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"EMP.TOWN.ADD\"></span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\">\n<md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container flex><md-select \nng-model=\"vm.country\" aria-label=\"country\" name=\"country\" ng-change=\"vm.empList()\" required><md-option \nng-repeat=\"ls in vm.listCountry\" placeholder=\"country\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.country.$error\" role=\"alert\"><div ng-message=\"required\"><span>Country field is required.</span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"EMP.TOWN.TABLE.TOWN\"></span></label><input ng-model=\"vm.Form.objForm.town\" type=\"text\" name=\"town\"><div \nng-messages=\"frmEmploye.town.$error\" role=\"alert\"><div ng-message=\"required\"><span>Town Name field is required.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\"><span translate=\"EMP.TOWN.CANCEL\"></span></md-button><md-button type=\"submit\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" aria-label=\"Submit\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><span translate=\"EMP.TOWN.SAVE\"></span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/town/update-town/update-town.html","<md-dialog aria-label=\"Input Data Employee Labor Type\" md-theme=\"modal-theme\" flex-md=\"60\" flex-gt-md=\"40\" layout-wrap>\n<form class=\"md-inline-form popup-input-form\" name=\"frmEmploye\" ng-submit=\"vm.updateData($event, frmEmploye)\" \nnovalidate layout-fill><md-toolbar class=\"md-cyan-600-bg has-toolbar\" flex><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"EMP.TOWN.UPDATE\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogClose()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"row\"><md-input-container \nflex><md-select ng-model=\"vm.country\" aria-label=\"country\" name=\"country\" ng-change=\"vm.empList()\" required><md-option \nng-repeat=\"ls in vm.listCountry\" placeholder=\"country\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"frmEmploye.country.$error\" role=\"alert\"><div ng-message=\"required\"><span>Country field is required.</span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label><span \ntranslate=\"EMP.TOWN.TABLE.TOWN\"></span></label><input ng-model=\"vm.town\" type=\"text\" name=\"town\"><div \nng-messages=\"frmEmploye.town.$error\" role=\"alert\"><div ng-message=\"required\"><span>Town Name field is required.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\"><span translate=\"EMP.TOWN.CANCEL\"></span></md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Save\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"><span \ntranslate=\"EMP.TOWN.SAVE\"></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/town/uploadfile/uploadfile.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload File</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nuploader=\"vm.FileUploaderPhoto\"></div><div class=\"text-right\" flex><md-button type=\"button\" \nng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload</md-button></div></div><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear>\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>{{vm.pesan}}</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>{{vm.pesan}}</span></md-whiteframe></md-content></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/employee/team-assignment/downloadfile/downloadfile.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-md=\"30\" flex-gt-md=\"40\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex ng-submit=\"vm.downloadAll()\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"ACTION.DOWNLOAD_EXCEL\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><div layout=\"column\"><md-input-container flex><label><span \ntranslate=\"MENU.CB.LEAVE.INDEX.HEADER.START_DATE\"></span></label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.tglmulai\" placeholder=\"start date\" name=\"tglmulai\"></md-datepicker><div \nng-messages=\"basicForm.tglmulai.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'MENU.CB.LEAVE.INDEX.HEADER.START_DATE\' | translate}} {{\'MYPROFILE.MESSAGE.ISREQUIRED\' | translate}}.</span></div>\n</div></md-input-container><md-input-container flex><label>{{\'MENU.CB.LEAVE.INDEX.HEADER.END_DATE\' | translate}}\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.tglakhir\" placeholder=\"end date\" name=\"tglakhir\">\n</md-datepicker><div ng-messages=\"basicForm.tglakhir.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'MENU.CB.LEAVE.INDEX.HEADER.END_DATE\' | translate}} {{\'MYPROFILE.MESSAGE.ISREQUIRED\' | translate}}</span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.dialogClose()\" \ntranslate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" class=\"md-primary md-hue-1\" aria-label=\"Download\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><span>Download</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/employee/team-assignment/uploadfile/uploadfile.html","<md-dialog aria-label=\"Input Data News\" md-theme=\"modal-theme\" flex flex-gt-md=\"40\" flex-gt-xs=\"70\"><form \nname=\"basicForm\" class=\"md-inline-form popup-input-form\" novalidate flex><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"ATTENDANCE.LABEL.UPLOADFORM\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout-padding flex><fieldset><legend><span translate=\"ATTENDANCE.LABEL.UPLOADFORM\"></span> - <span \ntranslate=\"PAYROLL.MENU.FORMATFILEACCEPTED\"></span> (.xlsx)</legend><md-content layout=\"column\"><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><div flex><input type=\"file\" id=\"uploadFile\" nv-file-select \nuploader=\"vm.FileUploader\" \naccept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div></div><span \nclass=\"padding-5\"></span><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div>\n</md-content></fieldset><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" \nstyle=\"padding:3px\"><span style=\"color:red\">{{ vm.uploadNotif | translate }}</span></div><div \nng-show=\"vm.uploadSuccess\" flex layout layout-align=\"center center\"><span style=\"color:green\">\n{{ vm.uploadNotif | translate }}</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.dialogClose()\" translate=\"ACTION.CANCEL\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.FileUploader.uploadAll()\" class=\"md-primary md-hue-1\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><span translate=\"ACTION.UPLOAD\">Upload</span></md-button><md-button type=\"submit\" \nng-click=\"vm.DownloadTemplate()\" class=\"md-accent md-hue-1\" aria-label=\"Download Template\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"ACTION.DOWNLOAD_TEMPLATE\">Download Template</span></md-button>\n<md-button ng-if=\"vm.isMoreInfo\" type=\"button\" ng-click=\"vm.viewMoreInfo(vm.detailInfo)\" class=\"md-primary md-hue-1\" \naria-label=\"More Info\"><span><span translate=\"PAYROLL.MENU.MOREINFO\"></span></span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/hrbp/job-code-profile/input-job-code-profile/input-job-code-profile.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon ui-sref=\"{{vm.Breadhome}}\" md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><div ng-repeat-start=\"ls  in vm.Breadlist\"></div><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\" ui-sref=\"{{ls.link}}\">{{ls.name}}</span><div ng-repeat-end></div>\n</div><div class=\"title\">Form Input Competency Job</div></div></div><div class=\"content\" layout=\"column\"><div \nlayout=\"row\" layout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" \nflex-xs=\"100\" flex-md=\"80\"><form name=\"formInputModul\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputModul)\"><div layout=\"column\"><md-input-container flex><md-select \nplaceholder=\"Select Job Code\" name=\"job_code\" ng-model=\"vm.Form.objForm.job_code\" required><md-option \nng-repeat=\"ls in vm.listJobCode\" ng-value=\"{{ls.code}}\">{{ls.code + \' - \' + ls.description | uppercase}}</md-option>\n</md-select><div ng-messages=\"formInputModul.job_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJob Code is required.</span></div></div></md-input-container><md-input-container flex><md-select \nplaceholder=\"Select Competency\" name=\"competency_code\" ng-model=\"vm.Form.objForm.competency_code\" required><md-option \nng-repeat=\"ls in vm.listCompetency\" ng-value=\"{{ls.code}}\">{{ls.competency | uppercase}}</md-option></md-select><div \nng-messages=\"formInputModul.competency_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompetency is required.</span></div></div></md-input-container><md-input-container flex><md-select \nplaceholder=\"Select Required Level\" name=\"req_level\" ng-model=\"vm.Form.objForm.req_level\" required><md-option \nng-repeat=\"ls in vm.listProviciencyLevel\" ng-value=\"{{ls.level}}\">{{ls.level}}</md-option></md-select><div \nng-messages=\"formInputModul.req_level.$error\" role=\"alert\"><div ng-message=\"required\"><span>Required Level is required.\n</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"formInputModul.$invalid || basicForm.$pristine\">Submit\n</md-button><md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\">Back\n</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/hrbp/kpi-nabati/set-team-all/set-team-all-scale.html","<md-dialog aria-label=\"Set Kpi Scales\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloak name=\"formSetKpi\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>View KPI Scales</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeKpi()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><table \nwidth=\"100%\"><tr><td valign=\"top\">Key Performance Indicator</td><td valign=\"top\">UOM</td><td valign=\"top\">Weight</td>\n<td valign=\"top\">Target</td></tr><tr style=\"font-weight:bold\"><td valign=\"top\">{{vm.kpidesc}}</td><td valign=\"top\">\n{{vm.uom}}</td><td valign=\"top\">{{vm.bobot}}</td><td valign=\"top\">{{vm.target}}</td></tr></table><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" \nid=\"datatable\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">\nScale</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description\n</span></div></th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\">Min\n</span></div></th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\">Max\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"ks in vm.listkpiscale\"><td align=\"center\">{{ ks.no_urut}}</td><td>\n{{ ks.scale}}</td><td>{{ ks.start}}</td><td>{{ ks.finish}}</td></tr></tbody></table></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/hrbp/kpi-nabati/set-team-all/set-team-all.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">YEARS</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year.year}}\" \nng-click=\"vm.showKpi(year.year)\"><span class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill><div\n class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\">PA RESULT</md-subheader><div \nclass=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><form ng-cloak \nname=\"formSetKpi\" class=\"md-inline-form\" novalidate><div id=\"kpi\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th>No</th><th>KPI</th><th>WEIGHT</th><th>UOM</th><th>TARGET</th><th>START DATE</th><th>\nEND DATE</th><th>STATUS APPROVAL</th></tr></thead><tbody><tr ng-repeat=\"ks in vm.DataTable.list\" \nng-click=\"vm.select(ks)\"><td align=\"center\">{{ ($index + 1)}}</td><td align=\"left\"><a href=\"\" \nng-click=\"vm.viewScales($event,ks.idks)\" style=\"text-decoration:underline\">{{ ks.kpi}}</a></td><td align=\"center\">\n{{ ks.bobot}}</td><td>{{ ks.uom}}</td><td>{{ ks.target}}</td><td align=\"center\">{{ ks.effectiveDate}}</td><td \nalign=\"center\">{{ ks.expiredDate}}</td><td align=\"center\"><span>{{ ks.status}}</span></td></tr></tbody></table>\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front red-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.pesan}}</p></ms-widget-front></ms-widget></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/department-division/input-department-division/input-department-division.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">INPUT DEPARTMENT DIVISION</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><form name=\"formInputDepartment\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputDepartment)\"><div layout=\"row\"><div layout=\"column\" flex><md-input-container flex>\n<label>Country</label><md-select required ng-model=\"vm.Form.objForm.contry_id\" name=\"division\"><md-option \nng-repeat=\"ls in vm.listCountry\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"formInputDepartment.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivision field is required.</span></div></div></md-input-container><md-input-container flex><label>Business Unit\n</label><md-select ng-model=\"vm.Form.objForm.company_id\" name=\"department\" required><md-option \nng-repeat=\"ls in vm.listCompany\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"formInputDepartment.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout=\"column\" flex>\n<md-input-container flex><label>Division</label><md-select required ng-model=\"vm.Form.objForm.division_id\" \nname=\"division\" ng-change=\"vm.loadDataDepartment(vm.Form.objForm.division_id)\"><md-option \nng-repeat=\"ls in vm.listDivision\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"formInputDepartment.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivision field is required.</span></div></div></md-input-container><md-input-container flex><label>Department</label>\n<md-select ng-disabled=\"vm.rule.department\" ng-model=\"vm.Form.objForm.department_id\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listDepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"formInputDepartment.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div></div><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"formInputDepartment.$invalid || basicForm.$pristine\">Submit</md-button></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/department/input-department/input-department.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Input DEPARTMENT</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><form name=\"formInputDepartment\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputDepartment)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" \nname=\"id\" ng-model=\"vm.Form.objForm.id\" placeholder=\"ID\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputDepartment.id.$error\" role=\"alert\"><div ng-message=\"required\"><span>id is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"formInputDepartment.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\ndescription is required.</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"formInputDepartment.$invalid || basicForm.$pristine\">Submit</md-button></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/division/input-division/input-division.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Form Input DIVISION</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><form name=\"formInputDivision\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputDivision)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"id\" \nng-model=\"vm.Form.objForm.id\" placeholder=\"ID\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputDivision.id.$error\" role=\"alert\"><div ng-message=\"required\"><span>id is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"formInputDivision.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\ndescription is required.</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"formInputDivision.$invalid || basicForm.$pristine\">Submit</md-button></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/jfm/input-jfm/input-jfm.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Input JFM</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><form name=\"formInputJfm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputJfm)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"id\" \nng-model=\"vm.Form.objForm.id\" placeholder=\"ID\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputJfm.id.$error\" role=\"alert\"><div ng-message=\"required\"><span>id is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"formInputJfm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>description is required.\n</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"formInputJfm.$invalid || basicForm.$pristine\">Submit</md-button></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/job-title/input-jobtitle/input-jobtitle.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Input JOBTITLE</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><form name=\"formInputJobtitle\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputJobtitle)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"id\" \nng-model=\"vm.Form.objForm.positionid\" placeholder=\"ID\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputJobtitle.positionid.$error\" role=\"alert\"><div ng-message=\"required\"><span>id is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"formInputJobtitle.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\ndescription is required.</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"formInputJobtitle.$invalid || basicForm.$pristine\">Submit</md-button></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/level/input-level/input-level.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Form Input LEVEL</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><form name=\"formInputLevel\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputLevel)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"id\" \nng-model=\"vm.Form.objForm.id\" placeholder=\"ID\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputLevel.id.$error\" role=\"alert\"><div ng-message=\"required\"><span>id is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"description\" \nng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"formInputLevel.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>description is required.\n</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"formInputLevel.$invalid || basicForm.$pristine\">Submit</md-button></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/master-data/update-finger-reason/input/input.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span class=\"parent\" translate=\"MENU.MASTER_DATA.UPDATE_FINGER_REASON.FORM_INPUT.TITLE\">\nInput Finger Reason</span></md-subheader><div class=\"white-bg\"><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputBu\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.saveData(formInputBu)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" \nname=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Reason Description\" required><div \nng-messages=\"formInputBu.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>description is required.\n</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"formInputBu.$invalid || basicForm.$pristine\">Submit</md-button></div></form></div>\n</div></div></div></md-content></div>");
$templateCache.put("app/main/master-data/business-unit/input-bu/input-bu.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div class=\"title\" translate=\"MENU.MASTER_DATA.BU.INPUT_BU.TITLE\">Form Input BU</div></md-subheader>\n<div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><form \nname=\"formInputBu\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputBu)\"><div layout=\"column\">\n<md-input-container flex><input type=\"text\" name=\"id\" ng-model=\"vm.Form.objForm.id\" placeholder=\"ID\" \nng-change=\"vm.clearMeesage()\" required><div ng-messages=\"formInputBu.id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>id is required.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"formInputBu.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>description is required.\n</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"formInputBu.$invalid || basicForm.$pristine\">Submit</md-button></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/mpn/adminpms/views/detail.html","<div id=\"mpn\" class=\"content\"><div class=\"md-whiteframe-4dp\" id=\"inputView\" layout=\"column\"><md-toolbar \nmd-theme=\"table-toolbar-theme\" style=\"background-color:white\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button md-info md-hue-2\" ui-sref=\"app.mpn.adminpms\"><md-icon md-font-icon=\"icon-home\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised reference-button md-info md-hue-2\" \nng-click=\"vm.Pdf();\"><span>Print</span></md-button><md-button \nng-if=\"vm.parseInt(vm.request.business_title) > 0 || vm.parseInt(vm.request.is_need_approval_grade) > 0 || (vm.next_approval.app_type==\'Waiting Approval\' || vm.next_approval.app_type==\'None\')\" \nclass=\"md-raised reference-button md-primary md-hue-2\" ng-click=\"vm.approvedRequest();\"><md-icon \nmd-font-icon=\"icon-save\"></md-icon><span>Approve Request</span></md-button></div></md-toolbar><div layout=\"row\" \nng-init=\"total = 0\"><table class=\"simple approval\"><tr><td colspan=\"5\"><span class=\"text-bold\">\nApproval Status ({{vm.request.budget_type}} by MPP)</span></td></tr><tr><th style=\"width: 45px\">No</th><th>Section</th>\n<th>Status</th><th>Issued Date<br></th><th>Lead Time</th></tr><tr><td>1</td><td>\nRequestor ( {{ vm.request.created_by }} - {{ vm.request.creator }} )</td><td style=\"font-weight: bold\">Requested</td>\n<td style=\"text-align: center\">{{ vm.formatDate(vm.request.created_at) | date : \'dd MMMM yyyy, HH:mm\'}}</td><td>-</td>\n</tr><tr ng-repeat=\"a in vm.mpn_approval\"><td>{{$index + 2}}</td><td>{{a.group}} ( {{a.app_nik}} - {{a.approver}} )<div\n ng-if=\"a.app_nik_delegate != null\" style=\"font-size: 11px;font-style: italic;font-weight: bold\">\nDelegated to {{a.app_nik_delegate}} - {{a.delegated}}</div></td><td style=\"font-weight: bold\"><label \nng-class=\"a.app_type === \'Waiting Approval\'? \'waiting-approval\' : \'\'\">{{a.app_type}}</label></td><td \nstyle=\"text-align: center\">{{ vm.formatDate(a.app_date) | date : \'dd MMMM yyyy, HH:mm\' }}</td><td \nng-init=\"$parent.total = $parent.total + a.lead_time\">{{a.lead_time}} days</td></tr><tr><td \nstyle=\"font-weight: bold;text-align: right\" colspan=\"4\">Total Lead Time</td><td>{{vm.total_lead_time}} days</td></tr>\n<tr><td colspan=\"5\" style=\"font-size: 10px\"><span class=\"bold\" \nstyle=\"font-size: 13px;font-style: italic;font-weight: normal\">Things you need to know, Standard Lead time (in days)\n</span><table class=\"grade-info\" style=\"width: 100%;font-size: 11px;margin-bottom: 10px;margin-top: 10px\"><tbody><tr>\n<td style=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 1</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">21 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 2</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">35 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 3</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">56 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 4</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">70 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 5 above</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">112 days</td></tr></tbody></table><span \nclass=\"bold\" style=\"font-size: 13px;font-style: italic;font-weight: normal;margin-top: 8px\">\nThe process could be faster/longer depends on the users and candidates availability for interview schedule.</span></td>\n</tr></table></div><div layout=\"row\" style=\"margin-top:20px\"><table class=\"simple position-detail\" style=\"width: 100%\">\n<colgroup><col style=\"width: 150px\"><col style=\"width: 40%\"><col style=\"width: 10px\"><col style=\"width: 150px\"><col \nstyle=\"width: 27px\"><col style=\"width: 27px\"><col style=\"width: 27px\"><col style=\"width: 27px\"><col \nstyle=\"width: 27px\"><col style=\"width: 33px\"></colgroup><tr><th class=\"bold\" colspan=\"10\">POSITION DETAILS</th></tr>\n<tr><td class=\"bold\">Division / Department</td><td>{{vm.request.division}} / {{vm.request.department}}</td><td \nrowspan=\"10\"><br></td><td class=\"bold\" colspan=\"7\">Budget Type</td></tr><tr><td class=\"bold\">Business Title</td><td>\n{{vm.request.business_title_text}}<md-button aria-label=\"Approve Budget Type\" class=\"md-icon-button\" \nng-click=\"vm.showPrompt($event,\'BUSINESS_TITLE\', false)\" style=\"padding: 0;height: 35px;width: 35px\"><md-icon \nmd-font-icon=\"icon-check\" class=\"green-500-fg\" style=\"font-weight: bold;font-size: 35px\"></md-icon><md-tooltip><span>\nApprove Current Business Title</span></md-tooltip></md-button><md-button aria-label=\"Edit Business Title\" \nclass=\"md-icon-button\" ng-click=\"vm.showPrompt($event,\'BUSINESS_TITLE\',true)\" \nstyle=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-pencil\" class=\"blue-500-fg\"></md-icon>\n<md-tooltip><span>Edit Business Title</span></md-tooltip></md-button><div \nng-if=\"vm.parseInt(vm.request.business_title) < 1 \" style=\"font-style: italic;font-weight: bold;color: red\">\nNew Business Title</div></td><td>{{vm.request.budget_type}}</td><td colspan=\"6\">{{vm.request.replacement_type}}</td>\n</tr><tr><td class=\"bold\">Quantity</td><td>\n{{vm.request.quantity_replacement + vm.request.quantity_new_position }} ( Replacement = {{vm.request.quantity_replacement}}, New Position = {{vm.request.quantity_new_position}} )\n</td><td colspan=\"7\"></td></tr><tr><td rowspan=\"7\" colspan=\"2\" style=\"vertical-align: top;padding: 0px !important\">\n<table style=\"table-layout: fixed; width: 100%\"><colgroup><col style=\"width: 153px\"><col style=\"width: 73px\"><col \nstyle=\"width: 25px\"><col style=\"width: 25px\"><col style=\"width: 25px\"></colgroup><tr><td class=\"bold\" rowspan=\"2\">\nGeneral Worker</td><td style=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'1\' ? \'grade\' : \'\'\">Grade 1</td><td\n style=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'1A\' ? \'grade\' : \'\'\">A</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'1B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'1C\' ? \'grade\' : \'\'\">C</td></tr><tr><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2\' ? \'grade\' : \'\'\">Grade 2</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\">Staff</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'3\' ? \'grade\' : \'\'\">Grade 3</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'3A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'3B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'3C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\">Supervisory</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'4\' ? \'grade\' : \'\'\">Grade 4</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'4A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'4B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'4C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\" rowspan=\"2\">Managerial</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'5\' ? \'grade\' : \'\'\">Grade 5</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'5A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'5B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'5C\' ? \'grade\' : \'\'\">C</td></tr><tr><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6\' ? \'grade\' : \'\'\">Grade 6</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6C\' ? \'grade\' : \'\'\">C</td></tr></table></td><td class=\"bold\">Work Location</td><td \ncolspan=\"6\">{{vm.request.location}}</td></tr><tr><td class=\"bold\">Employee Status</td><td colspan=\"6\">\n{{vm.request.employment_status}}</td></tr><tr><td class=\"bold\">Preferrable Gender</td><td colspan=\"6\">\n{{vm.request.pref_gender}}</td></tr><tr><td class=\"bold\">Expected Join Date</td><td colspan=\"6\">\n{{ vm.formatDate(vm.request.expected_join_date) | date : \"dd MMMM yyyy\"}}</td></tr><tr><td colspan=\"7\" rowspan=\"3\" \nstyle=\"vertical-align: top\"><table style=\"width: 100%\"><colgroup><col style=\"width: 144px\"><col style=\"width: 147px\">\n<col style=\"width: 96px\"><col style=\"width: 180px\"></colgroup><tr><th class=\"tg-88nc bold\" colspan=\"2\">Experience</th>\n<th class=\"tg-88nc bold\" colspan=\"2\">Fresh Graduated</th></tr><tr><td class=\"tg-us36 bold\">Year of experience</td><td \nclass=\"tg-us36\"><div ng-if=\"vm.request.year_experience > 0\">{{vm.request.year_experience}} Years</div><div \nng-if=\"vm.request.exp != \'\'\">{{vm.request.exp}}</div></td><td class=\"tg-us36 bold\">Education</td><td class=\"tg-us36\">\n{{vm.request.education}}</td></tr><tr><td class=\"tg-us36 bold\">Age range</td><td class=\"tg-us36\"><div \nng-if=\"vm.request.age_min > 0 && vm.request.age_max > 0\">{{vm.request.age_min}} - {{vm.request.age_max}}</div></td><td \nclass=\"tg-us36 bold\">Major</td><td class=\"tg-us36 bold\">{{vm.request.major}}</td></tr><tr><td class=\"tg-us36 bold\">Note\n</td><td class=\"tg-us36\" colspan=\"3\"><div ng-bind-html=\"vm.request.qualification_note\"></div></td></tr></table></td>\n</tr><tr></tr><tr></tr><tr style=\"height: 20px\"></tr><tr><th class=\"bold\" colspan=\"10\">RESPONSIBILITIES</th></tr><tr>\n<td class=\"bold\">Job Code</td><td colspan=\"9\">{{vm.request.job_code_text}}</td></tr><tr><td colspan=\"10\" \nstyle=\"padding: 0px !important\"><div layout=\"row\" style=\"border-bottom: 1px solid #e0e0e0\"><div flex \nstyle=\"padding: 5px;background: #f8f8f8;text-align: center;font-weight: bold\">Short Job Description / Responsibilities\n</div><div flex \nstyle=\"padding: 5px;background: #f8f8f8;text-align: center;font-weight: bold;border-left: 1px solid #e0e0e0 ;padding-left: 8px\">\nFunctional Competencies</div></div><div layout=\"row\" style=\"margin-top:0px\"><div flex \nng-bind-html=\"vm.request.job_desc\" style=\"padding:10px\"></div><div flex ng-bind-html=\"vm.request.job_func\" \nstyle=\"padding:10px;border-left: 1px solid #e0e0e0 ;padding-left: 12px\"></div></div></td></tr><tr style=\"height: 20px\">\n</tr><tr><th class=\"bold\" colspan=\"10\">INCUMBENT DETAILS</th></tr><tr><td colspan=\"10\" style=\"padding: 0px !important\">\n<table class=\"simple\" style=\"width: 100%\"><tr><th style=\"background: #f8f8f8 !important\">NO</th><th \nstyle=\"background: #f8f8f8 !important\">NIK</th><th style=\"background: #f8f8f8 !important\">NAME</th><th \nstyle=\"background: #f8f8f8 !important\">POSITION</th><th style=\"background: #f8f8f8 !important\">REASON</th><th \nstyle=\"background: #f8f8f8 !important\">EFFECTIVE DATE</th></tr><tr ng-repeat=\"a in vm.replacement\"><td>{{$index + 1}}\n</td><td>{{a.employee.nik}}</td><td>{{a.employee.nama}}</td><td>{{a.employee.position}}</td><td>{{a.replacement_type}}\n</td><td>{{a.effective_date}}</td></tr></table></td></tr><tr style=\"height: 20px\"></tr><tr><td colspan=\"10\"><p><span \nclass=\"text-bold\">Notes</span></p><div class=\"note\" ng-repeat=\"item in vm.mpn_approval_history\"><div \nclass=\"note-title\">{{item.app_type}} at {{vm.formatDate(item.app_date) | date: \"dd MMMM yyyy, HH:mm\"}}</div><div \nclass=\"note-detail\"><p>{{item.notes}}</p></div><div class=\"note-footer\"><p>\nCreated By {{item.app_nik}} - {{item.approver}}</p></div></div></td></tr></table></div><br><br><hr></div></div>");
$templateCache.put("app/main/mpn/adminpms/views/form.html","");
$templateCache.put("app/main/mpn/adminpms/views/index.html","<div id=\"header-action\" class=\"page-layout simple fullwidth with-toolbar-content\" layout=\"column\"><div class=\"content\">\n<table class=\"with-toolbar dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\">NO</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">MPN NUMBER</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">BUSINESS TITLE</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">REQUEST DATE</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">APPROVAL STATUS</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">#</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listRequest\"><td>{{ ($index + 1) }}</td><td>{{ div.mpn_number }}</td><td>\n{{ div.business_title_text }}</td><td>{{ div.created_at }}</td><td>{{ div.current_status }}</td><td><md-button \naria-label=\"View Request\" class=\"md-icon-button\" ng-click=\"vm.viewDetail(div.id)\" \nstyle=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip>\n<span>View Request</span></md-tooltip></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/mpn/admin/views/detail.html","<div id=\"mpn\" class=\"content\"><div class=\"md-whiteframe-4dp\" id=\"inputView\" layout=\"column\"><md-toolbar \nmd-theme=\"table-toolbar-theme\" style=\"background-color:white\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button md-info md-hue-2\" ui-sref=\"app.mpn.admin\"><md-icon md-font-icon=\"icon-home\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised reference-button md-info md-hue-2\" \nng-click=\"vm.Pdf();\"><span>Print</span></md-button></div></md-toolbar><div layout=\"row\" ng-init=\"total = 0\"><table \nclass=\"simple approval\"><tr><td colspan=\"5\"><span class=\"text-bold\">Approval Status ({{vm.request.budget_type}} by MPP)\n</span></td></tr><tr><th style=\"width: 45px\">No</th><th>Section</th><th>Status</th><th>Issued Date<br></th><th>\nLead Time</th></tr><tr><td>1</td><td>Requestor ( {{ vm.request.created_by }} - {{ vm.request.creator }} )</td><td \nstyle=\"font-weight: bold\">Requested</td><td style=\"text-align: center\">\n{{ vm.formatDate(vm.request.created_at) | date : \'dd MMMM yyyy, HH:mm\'}}</td><td>-</td></tr><tr \nng-repeat=\"a in vm.mpn_approval\"><td>{{$index + 2}}</td><td>{{a.group}} ( {{a.app_nik}} - {{a.approver}} )<div \nng-if=\"a.app_nik_delegate != null\" style=\"font-size: 11px;font-style: italic;font-weight: bold\">\nDelegated to {{a.app_nik_delegate}} - {{a.delegated}}</div></td><td style=\"font-weight: bold\"><label \nng-class=\"a.app_type === \'Waiting Approval\'? \'waiting-approval\' : \'\'\">{{a.app_type}}</label></td><td \nstyle=\"text-align: center\">{{ vm.formatDate(a.app_date) | date : \'dd MMMM yyyy, HH:mm\' }}</td><td \nng-init=\"$parent.total = $parent.total + a.lead_time\">{{a.lead_time}} days</td></tr><tr><td \nstyle=\"font-weight: bold;text-align: right\" colspan=\"4\">Total Lead Time</td><td>{{vm.total_lead_time}} days</td></tr>\n<tr><td colspan=\"5\" style=\"font-size: 10px\"><span class=\"bold\" \nstyle=\"font-size: 13px;font-style: italic;font-weight: normal\">Things you need to know, Standard Lead time (in days)\n</span><table class=\"grade-info\" style=\"width: 100%;font-size: 11px;margin-bottom: 10px;margin-top: 10px\"><tbody><tr>\n<td style=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 1</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">21 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 2</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">35 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 3</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">56 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 4</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">70 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 5 above</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">112 days</td></tr></tbody></table><span \nclass=\"bold\" style=\"font-size: 13px;font-style: italic;font-weight: normal;margin-top: 8px\">\nThe process could be faster/longer depends on the users and candidates availability for interview schedule.</span></td>\n</tr></table></div><div layout=\"row\" style=\"margin-top:20px\"><table class=\"simple position-detail\" style=\"width: 100%\">\n<colgroup><col style=\"width: 150px\"><col style=\"width: 40%\"><col style=\"width: 10px\"><col style=\"width: 150px\"><col \nstyle=\"width: 27px\"><col style=\"width: 27px\"><col style=\"width: 27px\"><col style=\"width: 27px\"><col \nstyle=\"width: 27px\"><col style=\"width: 33px\"></colgroup><tr><th class=\"bold\" colspan=\"10\">POSITION DETAILS</th></tr>\n<tr><td class=\"bold\">Division / Department</td><td>{{vm.request.division}} / {{vm.request.department}}</td><td \nrowspan=\"10\"><br></td><td class=\"bold\" colspan=\"7\">Budget Type</td></tr><tr><td class=\"bold\">Business Title</td><td>\n{{vm.request.business_title_text}}</td><td>{{vm.request.budget_type}}</td><td colspan=\"6\"><md-button \nng-if=\"vm.current_approval.app_type == \'Waiting Approval\' || vm.next_approval.app_type == \'Waiting Approval\'\" \naria-label=\"Approve Budget Type\" class=\"md-icon-button\" ng-click=\"vm.showPrompt(\'BUDGET_TYPE\', false)\" \nstyle=\"padding: 0;height: 35px;width: 35px\"><md-icon md-font-icon=\"icon-check\" class=\"green-500-fg\" \nstyle=\"font-weight: bold;font-size: 35px\"></md-icon><md-tooltip><span>Approve Current Budget Type</span></md-tooltip>\n</md-button><md-button \nng-if=\"vm.current_approval.app_type == \'Waiting Approval\' || vm.next_approval.app_type == \'Waiting Approval\'\" \naria-label=\"Edit Business Title\" class=\"md-icon-button\" ng-click=\"vm.showPrompt(\'BUDGET_TYPE\', true)\" \nstyle=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-pencil\" class=\"blue-500-fg\"></md-icon>\n<md-tooltip><span>Edit Budget Type</span></md-tooltip></md-button><md-button \nng-if=\"vm.current_approval.app_type == \'Waiting Approval\' || vm.next_approval.app_type == \'Waiting Approval\'\" \naria-label=\"Delegate\" class=\"md-icon-button\" ng-click=\"vm.showPrompt(\'DELEGATION\', false)\" \nstyle=\"padding: 0;top:-2px;height: 25px;width: 24px;min-height: 20px\"><md-icon md-font-icon=\"icon-account-switch\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>Delegate</span></md-tooltip></md-button></td></tr><tr><td class=\"bold\">\nQuantity</td><td>\n{{vm.request.quantity_replacement + vm.request.quantity_new_position }} ( Replacement = {{vm.request.quantity_replacement}}, New Position = {{vm.request.quantity_new_position}} )\n</td><td colspan=\"7\"></td></tr><tr><td rowspan=\"7\" colspan=\"2\" style=\"vertical-align: top;padding: 0px !important\">\n<table style=\"table-layout: fixed; width: 100%\"><colgroup><col style=\"width: 153px\"><col style=\"width: 73px\"><col \nstyle=\"width: 25px\"><col style=\"width: 25px\"><col style=\"width: 25px\"></colgroup><tr><td class=\"bold\" rowspan=\"2\">\nGeneral Worker</td><td>Grade 1</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'1A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'1B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'1C\' ? \'grade\' : \'\'\">C</td></tr><tr><td>Grade 2</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\">Staff</td><td>Grade 3</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'3A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'3B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'3C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\">Supervisory</td><td>Grade 4</td>\n<td style=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'4A\' ? \'grade\' : \'\'\">A</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'4B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'4C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\" rowspan=\"2\">Managerial</td><td>\nGrade 5</td><td style=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'5A\' ? \'grade\' : \'\'\">A</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'5B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'5C\' ? \'grade\' : \'\'\">C</td></tr><tr><td>Grade 6</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6C\' ? \'grade\' : \'\'\">C</td></tr></table></td><td class=\"bold\">Work Location</td><td \ncolspan=\"6\">{{vm.request.location}}</td></tr><tr><td class=\"bold\">Employee Status</td><td colspan=\"6\">\n{{vm.request.employment_status}}</td></tr><tr><td class=\"bold\">Preferrable Gender</td><td colspan=\"6\">\n{{vm.request.pref_gender}}</td></tr><tr><td class=\"bold\">Expected Join Date</td><td colspan=\"6\">\n{{ vm.formatDate(vm.request.expected_join_date) | date : \"dd MMMM yyyy\"}}</td></tr><tr><td colspan=\"7\" rowspan=\"3\" \nstyle=\"vertical-align: top\"><table style=\"width: 100%\"><colgroup><col style=\"width: 144px\"><col style=\"width: 147px\">\n<col style=\"width: 96px\"><col style=\"width: 180px\"></colgroup><tr><th class=\"tg-88nc bold\" colspan=\"2\">Experience</th>\n<th class=\"tg-88nc bold\" colspan=\"2\">Fresh Graduated</th></tr><tr><td class=\"tg-us36 bold\">Year of experience</td><td \nclass=\"tg-us36\"><div ng-if=\"vm.request.year_experience > 0\">{{vm.request.year_experience}} Years</div><div \nng-if=\"vm.request.exp != \'\'\">{{vm.request.exp}}</div></td><td class=\"tg-us36 bold\">Education</td><td class=\"tg-us36\">\n{{vm.request.education}}</td></tr><tr><td class=\"tg-us36 bold\">Age range</td><td class=\"tg-us36\"><div \nng-if=\"vm.request.age_min > 0 && vm.request.age_max > 0\">{{vm.request.age_min}} - {{vm.request.age_max}}</div></td><td \nclass=\"tg-us36 bold\">Major</td><td class=\"tg-us36 bold\">{{vm.request.major}}</td></tr><tr><td class=\"tg-us36 bold\">Note\n</td><td class=\"tg-us36\" colspan=\"3\"><div ng-bind-html=\"vm.request.qualification_note\"></div></td></tr></table></td>\n</tr><tr></tr><tr></tr><tr style=\"height: 20px\"></tr><tr><th class=\"bold\" colspan=\"10\">RESPONSIBILITIES</th></tr><tr>\n<td class=\"bold\">Job Code</td><td colspan=\"9\">{{vm.request.job_code_text}}</td></tr><tr><td colspan=\"10\" \nstyle=\"padding: 0px !important\"><div layout=\"row\" style=\"border-bottom: 1px solid #e0e0e0\"><div flex \nstyle=\"padding: 5px;background: #f8f8f8;text-align: center;font-weight: bold\">Short Job Description / Responsibilities\n</div><div flex \nstyle=\"padding: 5px;background: #f8f8f8;text-align: center;font-weight: bold;border-left: 1px solid #e0e0e0 ;padding-left: 8px\">\nFunctional Competencies</div></div><div layout=\"row\" style=\"margin-top:0px\"><div flex \nng-bind-html=\"vm.request.job_desc\" style=\"padding:10px\"></div><div flex ng-bind-html=\"vm.request.job_func\" \nstyle=\"padding:10px;border-left: 1px solid #e0e0e0 ;padding-left: 12px\"></div></div></td></tr><tr style=\"height: 20px\">\n</tr><tr><th class=\"bold\" colspan=\"10\">INCUMBENT DETAILS</th></tr><tr><td colspan=\"10\" style=\"padding: 0px !important\">\n<table class=\"simple\" style=\"width: 100%\"><tr><th style=\"background: #f8f8f8 !important\">NO</th><th \nstyle=\"background: #f8f8f8 !important\">NIK</th><th style=\"background: #f8f8f8 !important\">NAME</th><th \nstyle=\"background: #f8f8f8 !important\">POSITION</th><th style=\"background: #f8f8f8 !important\">REASON</th><th \nstyle=\"background: #f8f8f8 !important\">EFFECTIVE DATE</th></tr><tr ng-repeat=\"a in vm.replacement\"><td>{{$index + 1}}\n</td><td>{{a.employee.nik}}</td><td>{{a.employee.nama}}</td><td>{{a.employee.position}}</td><td>{{a.replacement_type}}\n</td><td>{{a.effective_date}}</td></tr></table></td></tr><tr style=\"height: 20px\"></tr><tr><td colspan=\"10\"><p><span \nclass=\"text-bold\">Notes</span></p><div class=\"note\" ng-repeat=\"item in vm.mpn_approval_history\"><div \nclass=\"note-title\">{{item.app_type}} at {{vm.formatDate(item.app_date) | date: \"dd MMMM yyyy, HH:mm\"}}</div><div \nclass=\"note-detail\"><p>{{item.notes}}</p></div><div class=\"note-footer\"><p>\nCreated By {{item.app_nik}} - {{item.approver}}</p></div></div></td></tr></table></div><br><br><hr></div></div>");
$templateCache.put("app/main/mpn/admin/views/index.html","<div id=\"header-action\" class=\"page-layout simple fullwidth with-toolbar-content\" layout=\"column\"><div class=\"content\">\n<div flex=\"\" layout-padding=\"1\" layout=\"column\"><h3><md-icon md-font-icon=\"icon-filter\"></md-icon>Filter Area</h3>\n</div><div flex=\"30\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"\"><label>MPN Status</label><md-select ng-model=\"vm.mpn_status\" ng-change=\"vm.viewData();\">\n<md-option value=\"ALL\">All</md-option><md-option value=\"Approved\">Approved</md-option><md-option ng-selected=\"true\" \nvalue=\"Waiting Approval\">Waiting Approval</md-option></md-select></md-input-container></div><table \nclass=\"with-toolbar dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\">NO</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">MPN NUMBER</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">BUSINESS TITLE</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">BUDGET TYPE</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">REQUEST DATE</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">APPROVAL STATUS</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">TA APPROVAL DATE</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">#</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listRequest\"><td>{{ ($index + 1) }}</td><td>{{ div.mpn_number }}</td><td>\n{{ div.business_title_text }}</td><td>{{ div.budget_type }}</td><td>\n{{ vm.formatDate(div.created_at) | date : \'dd MMMM yyyy, HH:mm\' }}</td><td>{{ div.current_status }}</td><td>\n{{ vm.formatDate(div.app_date_ta) | date : \'dd MMMM yyyy, HH:mm\' }}</td><td><md-button aria-label=\"View Request\" \nclass=\"md-icon-button\" ng-click=\"vm.viewDetail(div.id)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>View Request</span></md-tooltip></md-button>\n</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/mpp/activity-foreman/add/activity-foreman-add.html","<md-dialog aria-label=\"Form Add Activity Foreman\" flex-md=\"75\" flex-gt-md=\"75\"><form ng-cloack \nname=\"frmAddActivityForeman\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmAddActivityForeman)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Add Activity Foreman</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout=\"column\"><md-input-container>\n<label>Effective Date</label><input type=\"date\" name=\"effective_date\" ng-model=\"vm.Form.objForm.effective_date\" \nng-change=\"vm.selectedEffectiveDate()\" required><div ng-messages=\"frmAddActivityForeman.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Effective Date is required.</span></div></div></md-input-container>\n<md-input-container flex ng-if=\"vm.listDataSector.length > 0\"><label>Sector</label><md-select \nng-model=\"vm.Form.objForm.sector\" ng-change=\"vm.selectedSector(vm.Form.objForm.sector)\" name=\"sector\" required>\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchSector\" type=\"search\" class=\"md-text\">\n</md-select-header><md-optgroup><md-option ng-repeat=\"ls in vm.listDataSector | filter:vm.searchSector\" \nvalue=\"{{ls.id}}\" style=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">\n{{ls.gedung_name}}, {{ls.sector_name}}</md-option></md-optgroup></md-select><div \nng-messages=\"frmAddActivityForeman.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container flex><label>Line Position</label>\n<md-select ng-model=\"vm.Form.objForm.line_position\" name=\"line_position\" \nng-change=\"vm.selectedLine(vm.Form.objForm.line_position)\" required><md-select-header class=\"demo-select-header\"><input\n ng-model=\"vm.searchLine\" type=\"search\" class=\"md-text\"></md-select-header><md-optgroup label=\"vm.productLists\">\n<md-option ng-repeat=\"ls in vm.listLineForeman | filter:vm.searchLine\" value=\"{{ls.id}}\" \nstyle=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">{{ls.description}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"frmAddActivityForeman.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container flex><label>Product</label>\n<md-autocomplete \nstyle=\"margin-top: 15px; background: transparent;\n                        border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.Form.objForm.product\" md-search-text=\"searchTextProduct\" \nmd-items=\"item in vm.loadProduct(searchTextProduct)\" md-item-text=\"item.sku + \', \' + item.description\" \nng-model=\"vm.Form.objForm.product\" md-selected-item-change=\"vm.loadMppStandard(vm.Form.objForm.product)\" required \nng-disabled=\"vm.Form.objForm.pp_id != \'\'\"><md-item-template><span md-highlight-text=\"searchTextProduct\">\n{{item.sku + \', \' + item.description}}</span></md-item-template></md-autocomplete><div \nng-messages=\"frmAddActivityForeman.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container flex><label>Qty Product</label>\n<input type=\"number\" step=\"0.01\" min=\"0\" ng-model=\"vm.Form.objForm.product_qty\" required><div \nng-messages=\"frmAddActivityForeman.product_qty.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><md-input-container flex><label>Working Hours</label>\n<input type=\"number\" step=\"0.01\" min=\"0\" max=\"{{vm.maxWorking}}\" ng-model=\"vm.Form.objForm.working_hours\" required><div\n ng-messages=\"frmAddActivityForeman.working_hours.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nParent field is required.</span></div></div></md-input-container><div flex ng-if=\"vm.mppStandardLists.length > 0\">\n<md-label>MPP Standard</md-label><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\" \nlayout-align=\"space-between center\"><h2 style=\"color: #000000bd\">TEAM MEMBERS</h2><div \nclass=\"text-boxed green-bg white-fg m-0 clickable\" hide show-gt-sm>\nAvailable : {{vm.jumEmployee.count}} / {{vm.jumEmployee.jumTemp}}</div><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><div class=\"text-boxed green-bg white-fg m-0 clickable\" style=\"margin: 10px\">\nAvailable : {{vm.jumEmployee.count}} / {{vm.jumEmployee.jumTemp}}</div></md-menu-item></md-menu-content></md-menu>\n</div></md-toolbar><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nng-repeat=\"mpp in vm.mppStandardLists\" ng-init=\"mppIndex = $index\"><thead><tr><th style=\"text-transform: uppercase\" \ncolspan=\"23\">{{mpp.position_group}}</th></tr><tr><th style=\"text-transform: uppercase\">No</th><th \nstyle=\"text-transform: uppercase; width: 40%\">Position</th><th style=\"text-transform: uppercase; width: 10%\">\nSymbol Location</th><th style=\"text-transform: uppercase; width: 40%\">Employee</th><th \nstyle=\"text-transform: uppercase\">Portion</th><th style=\"text-transform: uppercase\">Request</th></tr></thead><tbody><tr\n ng-repeat=\"mpp_standar in mpp.mpp_standar\" ng-init=\"mppStandarIndex = $index\"><td class=\"text-center\">\n{{mppStandarIndex+1}}</td><td>{{mpp_standar.position_name}}</td><td class=\"text-center\">{{mpp_standar.symbol_location}}\n</td><td><md-autocomplete ng-focus=\"mpp_standar.is_focus\" class=\"md-autocomplete-atasan-baru\" \nstyle=\"margin-top: 15px; background: transparent;border-bottom: 2px dotted {{(mpp_standar.is_focus)?\'blue\':\'#d9d9d9\'}}\" \nmd-no-cache=\"true\" md-input-minlength=\"3\" md-selected-item=\"mpp_standar.nik\" \nmd-selected-item-change=\"vm.changeNik(mpp_standar,\'mpp\',mppStandarIndex,mppIndex)\" md-search-text=\"searchText\" \nmd-items=\"item in vm.lookupEmployee(searchText)\" md-item-text=\"item.nik + \', \' + item.fullname\" \nng-model=\"mpp_standar.nik\"><md-item-template><span md-highlight-text=\"searchText\">{{item.nik + \', \' + item.fullname}}\n</span></md-item-template></md-autocomplete></td><td class=\"text-center\"><md-radio-group layout=\"row\" \nng-change=\"vm.changePortion(mpp_standar,\'mpp\',mppStandarIndex,mppIndex)\" ng-disabled=\"mpp_standar.disabled\" \nlayout-align=\"start center\" ng-model=\"mpp_standar.portion\" ng-if=\"mpp_standar.nik\"><md-radio-button \nng-repeat=\"item in vm.portionList\" ng-value=\"item.value\" ng-if=\"item.value <= mpp_standar.portion_mpp\">{{item.label}}\n</md-radio-button></md-radio-group></td><td class=\"text-center\"><md-checkbox class=\"no-label\" \nng-model=\"mpp_standar.request\" aria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\" \nng-if=\"!mpp_standar.nik && vm.jumEmployee.countKur == 0\"></md-checkbox></td></tr></tbody></table><br><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th style=\"text-transform: uppercase\" \ncolspan=\"23\">Support Activity</th></tr><tr><th style=\"text-transform: uppercase\">No</th><th \nstyle=\"text-transform: uppercase; width: 40%\">Activity</th><th style=\"text-transform: uppercase; width: 40%\">Employee\n</th><th style=\"text-transform: uppercase\">Portion</th><th style=\"text-transform: uppercase\">Request</th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"lsItem in vm.supportActivities\"><td class=\"text-center\">{{$index+1}}</td><td><md-select \nng-model=\"lsItem.activity_id\" name=\"activity_id\"><md-option ng-repeat=\"ls in vm.supportActivityList\" value=\"{{ls.id}}\" \nstyle=\"padding-top: 5px; height: auto; border-bottom: 1px dotted #ccc\">{{ls.name}}</md-option></md-select></td><td>\n<md-autocomplete ng-focus=\"lsItem.is_focus\" class=\"md-autocomplete-atasan-baru\" \nstyle=\"background: transparent;border-bottom: 2px dotted {{(lsItem.is_focus)?\'blue\':\'#d9d9d9\'}}\" md-no-cache=\"true\" \nmd-input-minlength=\"3\" md-selected-item-change=\"vm.changeNik(lsItem,\'support\',$index)\" md-selected-item=\"lsItem.nik\" \nmd-search-text=\"searchTextSupport\" md-items=\"item in vm.lookupEmployee(searchTextSupport)\" \nmd-item-text=\"item.nik + \', \' + item.fullname\" ng-model=\"lsItem.nik\"><md-item-template><span \nmd-highlight-text=\"searchTextSupport\">{{item.nik + \', \' + item.fullname}}</span></md-item-template></md-autocomplete>\n</td><td class=\"text-center\"><md-radio-group layout=\"row\" ng-change=\"vm.changePortion(lsItem,\'support\',$index)\" \nng-disabled=\"lsItem.disabled\" layout-align=\"start center\" ng-model=\"lsItem.portion\"><md-radio-button \nng-repeat=\"item in vm.portionList\" ng-value=\"item.value\">{{item.label}}</md-radio-button></md-radio-group></td><td \nclass=\"text-center\"><md-checkbox class=\"no-label\" ng-model=\"lsItem.request\" \naria-label=\"{{vm.isChecked(item)? \'Uncheck\':\'check\'}}\" ng-if=\"!lsItem.nik && vm.jumEmployee.countKur == 0\">\n</md-checkbox></td><td class=\"text-center\"><md-button type=\"button\" class=\"md-mini md-warn\" aria-label=\"Remove\" \nng-click=\"vm.removeRow(lsItem,$index)\">Remove</md-button></td></tr></tbody></table><div><md-button type=\"button\" \nclass=\"md-mini md-primary\" aria-label=\"Add\" ng-click=\"vm.addRow()\">Add row</md-button></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddActivityForeman.$invalid || frmAddActivityForeman.$pristine || vm.mppStandardLists.length == 0\">\nSubmit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpn/approval/views/approval_form.html","<md-dialog aria-label=\"Approval MPN Request\" flex=\"50\" id=\"formCompetencyReview\"><div ng-cloak \nname=\"formCompetencyReview\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Approval MPN Request</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container class=\"md-block\"><label>Approval Type</label><md-select name=\"reason\" \nplacholder=\"Approval Type\" ng-model=\"vm.current_approval.app_type\" required md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\"><md-optgroup label=\"Reason\"><md-option value=\"Approved\">Approved\n</md-option><md-option value=\"Rejected\">Rejected</md-option><md-option value=\"Revision\">Revision</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.current_approval.app_type == \'Rejected\' || vm.current_approval.app_type == \'Revision\' \"><label>Notes</label>\n<input required type=\"text\" ng-model=\"vm.current_approval.notes\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.publishRequest()\">\n<md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-content-close white-fg\">\n</md-icon>Close</md-button></md-dialog-actions></div></md-dialog>");
$templateCache.put("app/main/mpn/approval/views/detail.html","<style>\n@media print {\n        body * {\n            visibility: hidden;\n        }\n        #print-area,\n        #print-area * {\n            visibility: visible;\n        }\n        #print-area {\n            position: absolute;\n            left: 0;\n            top: 0;\n        }\n    }\n</style><div id=\"mpn\" class=\"content\"><div class=\"md-whiteframe-4dp\" id=\"inputView\" layout=\"column\"><md-toolbar \nmd-theme=\"table-toolbar-theme\" style=\"background-color:white\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button md-info md-hue-2\" ui-sref=\"app.mpn.approval\"><span>Back</span></md-button><md-button \nng-if=\"vm.current_approval != null && vm.current_approval.is_budget_type === \'0\' && vm.current_approval.approval_status == \'1\' || \n                            vm.current_approval.can_approve_all == true\" \nclass=\"md-primary md-raised\" ng-click=\"vm.showPrompt(\'Approved\',$event,null)\">Approve</md-button><md-button \nng-if=\"vm.current_approval != null && vm.current_approval.approval_status == \'1\' || \n                            vm.current_approval.can_approve_all == true\" \nclass=\"md-primary md-raised md-warn\" ng-click=\"vm.showPrompt(\'Rejected\',$event,null)\">Reject</md-button><md-button \nng-if=\"vm.current_approval != null && vm.current_approval.approval_status == \'2\' && \n                            vm.current_approval.group == \'Talent Acquisition Manager\' == true\" \nclass=\"md-primary md-raised md-warn\" ng-click=\"vm.showPrompt(\'Rejected\',$event,null)\">Reject</md-button><md-button \nng-if=\"vm.current_approval != null && vm.current_approval.is_budget_type === \'0\' && vm.current_approval.approval_status == \'1\' || \n                            vm.current_approval.can_approve_all == true\" \nclass=\"md-primary md-raised md-hue-3\" ng-click=\"vm.showPrompt(\'Revision\',$event,null)\">Revision</md-button><md-button \nng-if=\"vm.request.current_status == \'Approved\' && vm.is_allow_to_reset\" class=\"md-primary md-raised md-hue-3\" \nng-click=\"vm.resetSLT(vm.request, \'Revision\', $event)\">Reset SLT</md-button><md-button \nclass=\"md-raised reference-button md-info md-hue-2\" ng-click=\"vm.Pdf();\"><span>Print</span></md-button></div>\n</md-toolbar><div id=\"print-area\"><div layout=\"row\" ng-init=\"total = 0\"><table class=\"simple approval\"><tr><td \ncolspan=\"5\"><span class=\"text-bold\">Approval Status ({{vm.request.budget_type}} by MPP)</span><md-button \nng-if=\"vm.canApproveBudgetType()\" aria-label=\"Approve Budget Type\" class=\"md-icon-button\" \nng-click=\"vm.showPrompt(\'Budgeting\',$event,false)\" style=\"padding: 0;height: 35px;width: 35px\"><md-icon \nmd-font-icon=\"icon-check\" class=\"green-500-fg\" style=\"font-weight: bold;font-size: 35px\"></md-icon><md-tooltip><span>\nApprove Current Budget Type</span></md-tooltip></md-button><md-button ng-if=\"vm.canApproveBudgetType()\" \naria-label=\"Edit Business Title\" class=\"md-icon-button\" ng-click=\"vm.showPrompt(\'Budgeting\', $event,true)\" \nstyle=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-pencil\" class=\"blue-500-fg\"></md-icon>\n<md-tooltip><span>Edit Budget Type</span></md-tooltip></md-button></td></tr><tr><th style=\"width: 45px\">No</th><th>\nSection</th><th>Status</th><th>Issued Date<br></th><th>Lead Time</th></tr><tr><td>1</td><td>\nREQUESTOR ( {{ vm.request.created_by }} - {{ vm.request.creator }} )</td><td style=\"font-weight: bold\">Requested</td>\n<td style=\"text-align: center\">{{ vm.formatDate(vm.request.created_at) | date : \'dd MMMM yyyy, HH:mm\'}}</td><td>-</td>\n</tr><tr ng-repeat=\"a in vm.mpn_approval\"><td>{{$index + 2}}</td><td>\n{{a.group | uppercase}} ( {{a.approved_by | uppercase }} - {{a.approver | uppercase}} )<md-button \nng-if=\"vm.current_approval.can_approve_all == true && (a.approval_status == \'1\' || a.approval_status == \'0\')\" \naria-label=\"Delegate\" class=\"md-icon-button\" ng-click=\"vm.showPrompt(\'Delegate\',$event, a)\" \nstyle=\"padding: 0;top:-2px;height: 25px;width: 24px;min-height: 20px\"><md-icon md-font-icon=\"icon-account-switch\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>Delegate</span></md-tooltip></md-button><div \nng-if=\"a.app_nik_delegate != null\" style=\"font-size: 11px;font-style: italic;font-weight: bold\">\nDelegated to {{a.delegated}} - {{a.delegated}}</div></td><td style=\"font-weight: bold\"><label \nng-class=\"a.approval_status === \'1\'? \'waiting-approval\' : \'\'\" \nng-if=\"a.approval_status === \'1\' && vm.request.current_status == \'Waiting Approval\' \">Waiting Approval</label><label \nng-if=\"a.approval_status === \'2\'\">Approved</label><label ng-if=\"a.approval_status === \'3\'\">Reviced</label><label \nng-if=\"a.approval_status === \'4\'\">Rejected</label></td><td style=\"text-align: center\">\n{{ vm.formatDate(a.approval_date) | date : \'dd MMMM yyyy, HH:mm\' }}</td><td \nng-init=\"$parent.total = $parent.total + a.lead_time\">{{a.lead_time}} days</td></tr><tr><td \nstyle=\"font-weight: bold;text-align: right\" colspan=\"4\">Total Lead Time</td><td>{{vm.total_lead_time}} days</td></tr>\n<tr ng-if=\"vm.request.is_slt_reset > 0\"><td colspan=\"5\"><table class=\"simple approval\" \nng-repeat=\"item in vm.mpn_reset_slt\"><tr><th colspan=\"5\"><span class=\"text-bold\">\nApproval Status (Reset SLT {{$index+1}})</span></th></tr><tr><th style=\"width: 45px\">No</th><th>Section</th><th>Status\n</th><th>Issued Date</th><th>Lead Time</th></tr><tr><td>1</td><td>Requestor ( {{ item.request_by }} - {{ item.nama }} )\n</td><td style=\"font-weight: bold\">Requested</td><td style=\"text-align: center\">{{ item.timestamp}}</td><td>-</td></tr>\n<tr ng-repeat=\"itemApproval in item.approval\"><td>{{$index+2}}</td><td>\n{{itemApproval.POSITION}} ( {{ itemApproval.approved_by }} - {{ itemApproval.nama }} )</td><td \nstyle=\"font-weight: bold\"><div ng-switch=\"itemApproval.approval_status\"><div ng-switch-when=\"0\"><div class=\"info\">None\n</div></div><div ng-switch-when=\"1\"><div class=\"info\">Waiting Approval</div></div><div ng-switch-when=\"2\"><div \nclass=\"info\">Approved</div></div><div ng-switch-when=\"3\"><div class=\"info\">Revert</div></div><div ng-switch-when=\"4\">\n<div class=\"info\">Rejected</div></div></div></td><td style=\"text-align: center\">{{ itemApproval.approval_date}}</td>\n<td>{{itemApproval.lt}}</td></tr><tr><td style=\"font-weight: bold;text-align: right\" colspan=\"4\">Total Lead Time</td>\n<td>{{item.lt}}</td></tr></table></td></tr><tr><td colspan=\"5\">&nbsp;</td></tr><tr><td colspan=\"5\" \nstyle=\"font-size: 10px\"><span class=\"bold\" style=\"font-size: 13px;font-style: italic;font-weight: normal\">\nThings you need to know, Standard Lead time (in days)</span><table class=\"grade-info\" \nstyle=\"width: 100%;font-size: 11px;margin-bottom: 10px;margin-top: 10px\"><tbody><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 1</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">21 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 2</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">35 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 3</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">56 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 4</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">70 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 5 above</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">112 days</td></tr></tbody></table><span \nclass=\"bold\" style=\"font-size: 13px;font-style: italic;font-weight: normal;margin-top: 8px\">\nThe process could be faster/longer depends on the users and candidates availability for interview schedule.</span></td>\n</tr></table></div><div style=\"page-break-after: always\"></div><div layout=\"row\" style=\"margin-top:20px\"><table \nclass=\"simple position-detail\" style=\"width: 100%\"><colgroup><col style=\"width: 150px\"><col style=\"width: 40%\"><col \nstyle=\"width: 10px\"><col style=\"width: 150px\"><col style=\"width: 27px\"><col style=\"width: 27px\"><col \nstyle=\"width: 27px\"><col style=\"width: 27px\"><col style=\"width: 27px\"><col style=\"width: 33px\"></colgroup><tr><th \nclass=\"bold\" colspan=\"10\">POSITION DETAILS</th></tr><tr><td class=\"bold\">Division / Department</td><td>\n{{vm.request.division}} / {{vm.request.department}}</td><td rowspan=\"10\"><br></td><td class=\"bold\" colspan=\"7\">\nBudget Type</td></tr><tr><td class=\"bold\">Business Title</td><td>{{vm.request.business_title_text}}</td><td>\n{{vm.request.budget_type}}</td><td colspan=\"6\">{{vm.request.replacement_type}}</td></tr><tr><td class=\"bold\">Quantity\n</td><td>\n{{vm.request.quantity_replacement + vm.request.quantity_new_position }} ( Replacement = {{vm.request.quantity_replacement}}, New Position = {{vm.request.quantity_new_position}} )\n</td><td colspan=\"7\"></td></tr><tr><td rowspan=\"7\" colspan=\"2\" style=\"vertical-align: top;padding: 0px !important\">\n<table style=\"table-layout: fixed; width: 100%\"><colgroup><col style=\"width: 153px\"><col style=\"width: 73px\"><col \nstyle=\"width: 25px\"><col style=\"width: 25px\"><col style=\"width: 25px\"></colgroup><tr><td class=\"bold\" rowspan=\"2\">\nGeneral Worker</td><td>Grade 1</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'1A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'1B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'1C\' ? \'grade\' : \'\'\">C</td></tr><tr><td>Grade 2</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\">Staff</td><td>Grade 3</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'3A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'3B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'3C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\">Supervisory</td><td>Grade 4</td>\n<td style=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'4A\' ? \'grade\' : \'\'\">A</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'4B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'4C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\" rowspan=\"2\">Managerial</td><td>\nGrade 5</td><td style=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'5A\' ? \'grade\' : \'\'\">A</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'5B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'5C\' ? \'grade\' : \'\'\">C</td></tr><tr><td>Grade 6</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6C\' ? \'grade\' : \'\'\">C</td></tr></table></td><td class=\"bold\">Work Location</td><td \ncolspan=\"6\">{{vm.request.location}}</td></tr><tr><td class=\"bold\">Employee Status</td><td colspan=\"6\">\n{{vm.request.employment_status}}</td></tr><tr><td class=\"bold\">Preferrable Gender</td><td colspan=\"6\">\n{{vm.request.pref_gender}}</td></tr><tr><td class=\"bold\">Expected Join Date</td><td colspan=\"6\">\n{{ vm.formatDate(vm.request.expected_join_date) | date : \"dd MMMM yyyy\"}}</td></tr><tr><td colspan=\"7\" rowspan=\"3\" \nstyle=\"vertical-align: top\"><table style=\"width: 100%\"><colgroup><col style=\"width: 144px\"><col style=\"width: 147px\">\n<col style=\"width: 96px\"><col style=\"width: 180px\"></colgroup><tr><th class=\"tg-88nc bold\" colspan=\"2\">Experience</th>\n<th class=\"tg-88nc bold\" colspan=\"2\">Fresh Graduated</th></tr><tr><td class=\"tg-us36 bold\">Year of experience</td><td \nclass=\"tg-us36\"><div ng-if=\"vm.request.year_experience > 0\">{{vm.request.year_experience}} Years</div><div \nng-if=\"vm.request.exp != \'\'\">{{vm.request.exp}}</div></td><td class=\"tg-us36 bold\">Education</td><td class=\"tg-us36\">\n{{vm.request.education}}</td></tr><tr><td class=\"tg-us36 bold\">Age range</td><td class=\"tg-us36\"><div \nng-if=\"vm.request.age_min > 0 && vm.request.age_max > 0\">{{vm.request.age_min}} - {{vm.request.age_max}}</div></td><td \nclass=\"tg-us36 bold\">Major</td><td class=\"tg-us36 bold\">{{vm.request.major}}</td></tr><tr><td class=\"tg-us36 bold\">Note\n</td><td class=\"tg-us36\" colspan=\"3\"><div ng-bind-html=\"vm.request.qualification_note\"></div></td></tr></table></td>\n</tr><tr></tr><tr></tr><tr style=\"height: 20px;page-break-before: always\"></tr><tr><th class=\"bold\" colspan=\"10\">\nRESPONSIBILITIES</th></tr><tr><td class=\"bold\">Job Code</td><td colspan=\"9\">{{vm.request.job_code_text}}</td></tr><tr>\n<td colspan=\"10\" style=\"padding: 0px !important\"><div layout=\"row\" style=\"border-bottom: 1px solid #e0e0e0\"><div flex \nstyle=\"padding: 5px;background: #f8f8f8;text-align: center;font-weight: bold\">Short Job Description / Responsibilities\n</div><div flex \nstyle=\"padding: 5px;background: #f8f8f8;text-align: center;font-weight: bold;border-left: 1px solid #e0e0e0 ;padding-left: 8px\">\nFunctional Competencies</div></div><div layout=\"row\" style=\"margin-top:0px\"><div flex \nng-bind-html=\"vm.request.job_desc\" style=\"padding:10px\"></div><div flex ng-bind-html=\"vm.request.job_func\" \nstyle=\"padding:10px;border-left: 1px solid #e0e0e0 ;padding-left: 12px\"></div></div></td></tr><tr style=\"height: 20px\">\n</tr><tr><th class=\"bold\" colspan=\"10\">INCUMBENT DETAILS</th></tr><tr><td colspan=\"10\" style=\"padding: 0px !important\">\n<table class=\"simple\" style=\"width: 100%\"><tr><th style=\"background: #f8f8f8 !important\">NO</th><th \nstyle=\"background: #f8f8f8 !important\">NIK</th><th style=\"background: #f8f8f8 !important\">NAME</th><th \nstyle=\"background: #f8f8f8 !important\">POSITION</th><th style=\"background: #f8f8f8 !important\">REASON</th><th \nstyle=\"background: #f8f8f8 !important\">EFFECTIVE DATE</th></tr><tr ng-repeat=\"a in vm.replacement\"><td>{{$index + 1}}\n</td><td>{{a.employee.nik}}</td><td>{{a.employee.nama}}</td><td>{{a.employee.position}}</td><td>{{a.replacement_type}}\n</td><td>{{a.effective_date}}</td></tr></table></td></tr><tr style=\"height: 20px\"></tr><tr><td colspan=\"10\"><p><span \nclass=\"text-bold\">Notes</span></p><div class=\"note\" ng-repeat=\"item in vm.mpn_approval_history\"><div \nclass=\"note-title\">{{item.app_type}} at {{vm.formatDate(item.app_date) | date: \"dd MMMM yyyy, HH:mm\"}}</div><div \nclass=\"note-detail\"><p>{{item.notes}}</p></div><div class=\"note-footer\"><p>\nCreated By {{item.app_nik}} - {{item.approver}}</p></div></div></td></tr></table></div><br><br><hr></div></div></div>");
$templateCache.put("app/main/mpn/approval/views/index.html","<div class=\"page-layout simple fullwidth\" id=\"header-action\"><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div flex=\"\" layout-padding=\"1\" layout=\"column\"><h3><md-icon \nmd-font-icon=\"icon-filter\"></md-icon>Filter Area</h3></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label>\n<md-select ng-disabled=\"vm.group === \'110\' || vm.group === \'116\'\" ng-change=\"vm.loadDataDivision(vm.bu)\" \nng-model=\"vm.bu\"><md-option ng-selected=\"true\" ng-value=\"vm.defaultval\">{{vm.defaulttext}}</md-option><md-option \nng-repeat=\"bu in vm.listBu\" ng-value=\"bu.id\">{{bu.description}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Division</label><md-select \nng-change=\"vm.loadDataDepartment(vm.divisi)\" ng-model=\"vm.divisi\"><md-option ng-selected=\"true\" ng-value=\"0\">All\n</md-option><md-option ng-repeat=\"divisi in vm.listDivisi\" ng-value=\"{{divisi.id}}\">{{divisi.description}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Department</label><md-select\n ng-model=\"vm.department\"><md-option ng-selected=\"true\" ng-value=\"0\">All</md-option><md-option \nng-repeat=\"department  in vm.listDepartment\" ng-value=\"{{department.id}}\">{{department.description}}</md-option>\n</md-select></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Grade</label><md-select \nng-model=\"vm.emp_grade\"><md-option ng-selected=\"true\" ng-value=\"0\">All</md-option><md-option \nng-repeat=\"g in vm.grades\" ng-value=\"g\">{{g}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"\"><label>Work Location</label><md-select ng-model=\"vm.work_location\"><md-option \nng-selected=\"true\" ng-value=\"0\">All</md-option><md-option ng-repeat=\"l in vm.listLocation\" ng-value=\"{{l.id}}\">\n{{l.description}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><input\n name=\"nik \" ng-model=\"vm.created_by\" placeholder=\"NIK / Name Requester\" type=\"text\"></md-input-container></div><div \nflex=\"\" ng-show=\"vm.employee_info != null && (vm.employee_info.group == \'Talent Acquisition Manager\')\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"\"><label>Business Title</label><md-select ng-model=\"vm.business_title\"><md-option ng-selected=\"true\" \nng-value=\"0\">All</md-option><md-option ng-repeat=\"l in vm.business_titles\" ng-value=\"{{l.id}}\">{{l.description}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>PIC</label>\n<md-select ng-model=\"vm.pic\"><md-option ng-selected=\"true\" value=\"ALL\">All</md-option><md-option \nng-repeat=\"l in vm.pic_list\" value=\"{{l.nik}}\">{{l.description}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Reason</label><md-select name=\"reason\" placholder=\"Reason\" \nng-model=\"vm.reason\" md-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\"><md-optgroup \nlabel=\"Reason\"><md-option ng-selected=\"true\" value=\"ALL\">All</md-option><md-option value=\"New\">New Position</md-option>\n<md-option value=\"Resign\">Resign</md-option><md-option value=\"Transfer\">Transfer</md-option><md-option \nvalue=\"Promotion\">Promotion</md-option><md-option value=\"Demotion\">Demotion</md-option><md-option \nvalue=\"Finish Contract\">Finish Contract</md-option></md-optgroup></md-select></md-input-container></div><div \nlayout=\"row\" layout-padding=\"1\" layout-align=\"space-between center\" layout-padding=\"\"><md-input-container \nclass=\"md-block\" flex-gt-xs=\"\"><label>Shows :</label><md-select id=\"ss\" name=\"see\" ng-change=\"vm.loadData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\"><md-option ng-repeat=\"val in vm.listJum\" ng-value=\"val\">{{val}} Entries\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Approval Status\n</label><md-select ng-model=\"vm.mpn_status\" ng-change=\"vm.load_mpn_number()\"><md-option value=\"\">All</md-option>\n<md-option value=\"2\">Approved</md-option><md-option ng-selected=\"true\" value=\"1\">Waiting Approval</md-option><md-option\n ng-if=\"vm.employee_info.group == \'Talent Acquisition Manager\'\" value=\"PROGRESS\">On Progress</md-option><md-option \nvalue=\"4\">Rejected</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\" \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\"><label>MPN Status</label><md-select \nng-model=\"vm.ta_mpn_status\"><md-option value=\"ALL\" ng-selected=\"true\">All</md-option><md-option value=\"OPEN\">OPEN\n</md-option><md-option value=\"CLOSED\">CLOSED</md-option><md-option value=\"HOLD\">HOLD</md-option><md-option \nvalue=\"CANCEL\">CANCEL</md-option><md-option value=\"INTERNAL\">INTERNAL</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs=\"\" \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\"><label>TA Status</label><md-select \nng-model=\"vm.ta_status\"><md-option value=\"ALL\" ng-selected=\"true\">All</md-option><md-option value=\"SOURCING\">SOURCING\n</md-option><md-option value=\"INTERVIEW\">INTERVIEW</md-option><md-option value=\"OFFERING\">OFFERING</md-option>\n<md-option value=\"MEDICAL CHECK\">MEDICAL CHECK</md-option><md-option value=\"ONBOARDING\">ONBOARDING</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>MPN Number</label><md-select\n id=\"mpn_number\" name=\"mpn_number\" ng-model=\"vm.mpn_number\" md-on-close=\"vm.clearMpnSearch()\" \ndata-md-container-class=\"selectdemoSelectHeader\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchMpnNumber\" type=\"search\" placeholder=\"Search for a MPN Number\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=\"MPN Numbers\"><md-option \nng-selected=\"true\" value=\"ALL\">All</md-option><md-option ng-value=\"val.mpn_number\" \nng-repeat=\"val in vm.mpn_numbers |\n                        filter:vm.searchMpnNumber\">{{val.mpn_number}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.all_mpn\">\nAll MPN.</md-checkbox></md-input-container><span flex=\" \"><md-button class=\"md-raised\" ng-click=\"vm.loadData(1)\" \nstyle=\"width: 150px; height: 39px\">Search</md-button><md-button \nng-show=\"vm.employee_info != null && (vm.employee_info.group == \'Talent Acquisition Manager\' || vm.employee_info.group == \'HR. Business Partner\' || vm.is_pic)\" \nclass=\"md-raised\" ng-click=\"vm.exportToExcel($event) \" style=\"width: 150px; height: 39px\">Download</md-button></span>\n</div><table class=\"simple stripped\" ms-responsive-table=\" \" style=\"margin-top:0\"><thead><tr><th><div \nclass=\"table-header\"></div></th><th width=\"5% \"><div class=\"table-header\"><span class=\"column-title\">No</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title\">MPN NUMBER</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">REQUEST STATUS</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">DIVISION</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">DEPARTMENT\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">BUSINESS TITLE</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">EMPLOYEE</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">GRADE</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">REASON</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">LOCATION</span></div></th><th \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\"><div class=\"table-header\"><span \nclass=\"column-title\">PIC</span></div></th><th \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\"><div class=\"table-header\"><span \nclass=\"column-title\">MPN STATUS</span></div></th><th \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\"><div class=\"table-header\"><span \nclass=\"column-title\">TA STATUS</span></div></th><th \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\"><div class=\"table-header\"><span \nclass=\"column-title\">VACANCY CLOSED DATE</span></div></th><th \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\"><div class=\"table-header\"><span \nclass=\"column-title\">JOINED EMPLOYEE</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">#</span>\n</div></th></tr></thead><tbody><tr ng-dblclick=\"vm.viewDetail(ls.mpn_mpn_id) \" ng-repeat=\"ls in vm.DataTable.list \">\n<td></td><td>{{ $index + 1 }}</td><td>{{ ls.mpn_number }}</td><td>{{ ls.approval_status }} <b>{{ ls.waiting_name }}</b>\n</td><td>{{ ls.division }}</td><td>{{ ls.department }}</td><td>{{ ls.business_title_text }}</td><td>\n{{ ls.nik }} {{ ls.emp_name | uppercase }}</td><td>{{ls.emp_grade}}</td><td>\n{{ ls.reason }} {{ (ls.replacement_type == \'\' ? \'\' : \'(\' ) + ls.replacement_type + (ls.replacement_type == \'\' ? \'\' : \')\' ) | uppercase }}\n<md-button ng-if=\"vm.employee_info.group == \'Talent Acquisition Manager\' && ls.ta_app_type== \'Approved\'\" \naria-label=\"Cancel MPN\" class=\"md-icon-button\" ng-click=\"vm.showPrompt(\'CANCEL_MPN\',ls, $event)\" \nstyle=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-trash \" class=\"red-500-fg\"></md-icon>\n<md-tooltip><span>Cancel MPN</span></md-tooltip></md-button></td><td>{{ ls.location }}</td><td \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\">{{ ls.pic }}</td><td \nng-if=\" vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\">{{ ls.mpn_status }}<br><md-button \naria-label=\"Edit MPN STATUS \" class=\"md-icon-button\" ng-click=\"vm.showPrompt(\'MPN_STATUS\',ls, $event)\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-if=\"vm.nik == ls.nik_pic\"><md-icon md-font-icon=\"icon-pencil \" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>Edit MPN STATUS</span></md-tooltip></md-button></td><td \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\">{{ ls.ta_status }}<br><md-button \naria-label=\"Edit TA STATUS \" class=\"md-icon-button\" ng-click=\"vm.showPrompt(\'TA_STATUS\',ls, $event)\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-if=\"vm.nik == ls.nik_pic\"><md-icon md-font-icon=\"icon-pencil \" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>Edit TA STATUS</span></md-tooltip></md-button></td><td \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\">{{ ls.vacancy_closed | date:\'dd-MM-yyyy\'}}\n<br><md-button aria-label=\"Edit VACANCY CLOSED DATE \" class=\"md-icon-button\" \nng-click=\"vm.showPrompt(\'VACANCY_DATE\',ls, $event)\" style=\"padding: 0;height: 24px;width: 24px\" \nng-if=\"vm.nik == ls.nik_pic\"><md-icon md-font-icon=\"icon-pencil \" class=\"blue-500-fg\"></md-icon><md-tooltip><span>\nEdit VACANCY CLOSED DATE</span></md-tooltip></md-button></td><td \nng-if=\"vm.is_pic || vm.employee_info.group == \'Talent Acquisition Manager\'\">{{ls.joined_emp_name}}</td><td><md-button \naria-label=\"View Request \" class=\"md-icon-button\" ng-click=\"vm.viewDetail(ls.mpn_mpn_id) \" \nstyle=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-eye \" class=\"blue-500-fg\"></md-icon>\n<md-tooltip><span>View Request</span></md-tooltip></md-button></td></tr></tbody></table><div class=\"p-24 mb-8\" \nlayout=\"row \" layout-align=\"space-between center \"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation \"><ul class=\"pagination\"><li class=\"{{nav.class}}\" \nng-class=\"{disabled:(nav.disabled===1)} \" ng-repeat=\"nav in vm.DataTable.listNav \"><a href=\"#\" \nng-click=\"vm.loadData(nav.noPage) \">{{nav.label}}</a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/main/mpp/orgtable/create-layer-mpp/create-layer-mpp.html","<div id=\"mppDialog\" flex-gt-sm=\"50\" flex=\"100\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-dialog \naria-label=\"Create Layer Mpp\" flex><form ng-cloak name=\"formCreateLayerMpp\" class=\"md-inline-form\" novalidate \nng-submit=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h4>Create Layer MPP</h4><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout-padding><div layout=\"column\" flex layout-padding><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-bottom:0px\"><md-input-container flex style=\"margin-bottom:0px\"><label>\nDescription</label><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" required>\n</md-input-container></div><div layout=\"row\" flex layout-align=\"start center\" style=\"padding-top:0px\">\n<md-input-container flex><label>Layer Type</label><md-select required name=\"type\" ng-model=\"vm.Form.objForm.type\">\n<md-option><em>None</em></md-option><md-option value=\"division\">DIVISION</md-option><md-option value=\"department\">\nDEPARTMENT</md-option><md-option value=\"function\">FUNCTION</md-option></md-select></md-input-container>\n<md-input-container flex><label>Classification Code</label><md-select required name=\"classification_code\" \nng-model=\"vm.Form.objForm.clasification_code\"><md-option><em>None</em></md-option><md-option \nng-repeat=\"ls in vm.classificationCode\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex><label>\nCost Center</label><md-select required name=\"costCenter\" ng-model=\"vm.Form.objForm.cost_center_id\"><md-option><em>None\n</em></md-option><md-option ng-repeat=\"ls1 in vm.costCenter\" value=\"{{ls1.id}}\">{{ls1.description}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Scope</label><md-select required name=\"scope\" \nng-model=\"vm.Form.objForm.org_level_id\"><md-option ng-repeat=\"ls2 in vm.orgLevel\" value=\"{{ls2.id}}\">\n{{ls2.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Job Level</label>\n<md-select required name=\"jobLevel\" ng-model=\"vm.Form.objForm.job_level\"><md-option><em>None</em></md-option><md-option\n value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option>\n</md-select></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex>\n<label>Business Title</label><md-select required name=\"businessTitle\" ng-model=\"vm.Form.objForm.business_title_id\">\n<md-option><em>None</em></md-option><md-option ng-repeat=\"ls3 in vm.businessTitle\" value=\"{{ls3.id}}\">\n{{ls3.description}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex><label>Location</label><md-select required name=\"location\" \nng-model=\"vm.Form.objForm.sub_area_id\"><md-option><em>None</em></md-option><md-option ng-repeat=\"ls4 in vm.location\" \nvalue=\"{{ls4.id}}\">{{ls4.description}}</md-option></md-select></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div flex class=\"form-message\" ng-class=\"{success:vm.success,error:!vm.success}\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\">{{vm.Form.pesan}}</div><div flex=\"40\" layout-align=\"end center\" \nlayout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.saveData(formCreateLayerMpp)\" \nng-disabled=\"formCreateLayerMpp.$invalid || vm.saveProcess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/main/mpp/orgtable/merge-mpp/merge-mpp.html","<div id=\"mergeMpp\" flex-gt-sm=\"50\" flex=\"100\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-dialog \naria-label=\"Input\" flex><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>MAN POWER PLANNING MERGER</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogCancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-list flex layout=\"column\" style=\"background-color: #fff\"><md-subheader class=\"md-primary\" flex>\n<md-list-item flex class=\"mpp-header-list\" layout=\"row\" layout-align=\"start center\"><div flex=\"30\" \nclass=\"capitalize header-fonts\" layout=\"row\">NIK</div><div flex=\"20\" layout=\"row\" class=\"normal header-fonts\" \nlayout=\"column\">JOIN DATE</div><div flex=\"30\" class=\"capitalize header-fonts\" layout=\"column\">NAME</div><div flex=\"20\" \nclass=\"capitalize header-fonts\" layout-align=\"center center\" layout=\"row\">MERGE</div></md-list-item></md-subheader>\n<md-list-item flex layout=\"row\" layout-align=\"start center\" ng-repeat=\"item in vm.data\"><div flex=\"30\" \nclass=\"capitalize body-fonts\" layout=\"row\">{{item.nik}}</div><div flex=\"20\" layout=\"row\" class=\"normal body-fonts\" \nlayout=\"row\">{{item.joinDate}}</div><div flex=\"30\" class=\"capitalize body-fonts\" layout=\"row\">{{item.name}}</div><div \nflex=\"20\" class=\"capitalize body-fonts\" layout-align=\"center center\" layout=\"row\">{{item.transactionType}}</div>\n</md-list-item><md-divider></md-divider></md-list></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" class=\"mpp-bg-blue\" ng-click=\"vm.mergeMpp()\" aria-label=\"Submit\" ng-disabled=\"vm.disableMerge\"><md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span>\n</md-button></md-dialog-actions></md-dialog></div>");
$templateCache.put("app/main/mpp/orgtable/transaction-mpp/transaction-mpp.html","<div id=\"mppDialog\" flex-gt-sm=\"30\" flex=\"100\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-dialog \naria-label=\"Input\" flex><form name=\"formTransaction\" ng-submit=\"vm.saveData(formTransaction)\" novalidate flex>\n<md-toolbar \nng-class=\"{\'blue\' : vm.selectedType != \'termination\' || vm.selectedType == null, \'red\' : vm.selectedType == \'termination\'}\" \nflex><div class=\"md-toolbar-tools\"><h2>Form MPP Transaction</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.dialogCancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><b class=\"mpp-color-orange\">{{vm.name}} | {{vm.nik}}</b></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex style=\"padding-bottom: 0px\"><md-input-container flex><md-select ng-model=\"vm.selectedType\" \naria-label=\"transaction type\" name=\"transactionType\" required><md-option ng-repeat=\"ls in vm.transactionType\" \nplaceholder=\"Transaction Type\" value=\"{{ls}}\">{{ls.toUpperCase()}}</md-option></md-select></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex style=\"padding-top: 0px\" ng-if=\"vm.type !== 1\">\n<md-select ng-model=\"vm.selectedOrgLayer\" aria-label=\"Organization Layer\" name=\"orgLayer\" required><md-option \nng-repeat=\"ls in vm.organizationLayer\" placeholder=\"Organization Layer\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select></md-input-container><md-input-container flex style=\"padding-top: 0px\" ng-if=\"vm.type === 1\">\n<md-select ng-model=\"vm.selectedOrgLayer\" aria-label=\"Organization Layer\" name=\"orgLayer\" required><md-option \nng-repeat=\"ls in vm.organizationLayer\" placeholder=\"Organization Layer\" ng-value=\"ls\">{{ls.description}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex \nstyle=\"padding-top: 0px\" ng-if=\"vm.type === 1\"><md-select ng-model=\"vm.selectedParentTo\" aria-label=\"Parent To\" \nname=\"parentTo\" required><md-option ng-repeat=\"ls in vm.parentLayer\" placeholder=\"Parent To\" ng-value=\"ls\">\n{{ls.nik}} | {{ ls.name ? ls.name : \'TBD\' }}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex style=\"padding-bottom: 0px; padding-top: 0px\" \nng-if=\"vm.selectedType === \'new hire\' || vm.selectedType === \'transfer in\' || vm.selectedType === \'new-hire-null\'\">\n<md-input-container flex style=\"padding-bottom: 0px; padding-top: 0px; margin-bottom: 0px\"><label>Head Count</label>\n<input type=\"number\" name=\"quantity\" required ng-model=\"vm.quantity\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-if=\"vm.selectedType != \'stay\'\" flex \nng-style=\"{\'padding-top\' : (vm.actionType == \'add\' && vm.selectedType == \'stay\') ? \'8px\' : \'0\'}\" \nstyle=\"padding-bottom: 0px; padding-top: 0px\"><md-input-container flex \nstyle=\"padding-bottom: 0px; padding-top: 0px; margin-bottom: 0px; margin-top: 0px\"><label>Date Fulfil</label>\n<md-datepicker md-hide-icons=\"all\" md-open-on-focus ng-model=\"vm.dateFulfil\" md-current-view=\"month\" name=\"dateFulfil\" \nrequired></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex \nng-if=\"vm.actionType == \'add\' && vm.selectedType == \'stay\'\"><md-input-container \nng-style=\"{\'border-bottom\' : \'1px solid #ccc\'}\" flex \nstyle=\"padding-bottom: 0px; padding-top: 0px; margin-bottom: 0px; margin-top: 0px\"><label>Search Employee</label>\n<md-autocomplete md-selected-item=\"vm.selectedEmployee\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-require-match md-search-text=\"vm.searchText\" md-input-name=\"nik\" md-no-cache=\"true\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" required md-min-length=\"3\"><md-item-template>\n<span md-highlight-text=\"vm.searchText\">{{item.nik}} | {{item.name}}</span></md-item-template><md-not-found>\nNo Record matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><div \nlayout=\"column\" layout-align=\"start center\" layout-gt-xs=\"row\" ng-if=\"vm.selectedType == \'new hire\'\"><md-checkbox \nname=\"isDuplicate\" class=\"md-checkbox-sm\" ng-model=\"vm.isDuplicate\" aria-label=\"duplicate\">Create Duplicate Layer\n</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" class=\"mpp-bg-blue\" \naria-label=\"Submit\" ng-disabled=\"formTransaction.$invalid || formTransaction.$pristine\"><md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span>\n</md-button></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/main/mpp/orgtable/upload-mpp/upload-mpp.html","<div id=\"mppDialog\" flex-gt-sm=\"30\" flex=\"100\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-dialog \naria-label=\"Input\" flex><form name=\"formTransaction\" ng-submit=\"vm.saveData(formTransaction)\" novalidate flex>\n<md-toolbar flex><div class=\"md-toolbar-tools\"><h2>Form MPP Transaction</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.dialogCancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding flex><fieldset>\n<legend>Upload MPP</legend><label>Format Accepted (.xlxs)</label><input type=\"file\" name=\"name\" \nng-model=\"fieldSetHasValue\" ng-change=\"fieldSetHasValue = true\"></fieldset></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" class=\"mpp-bg-blue\" aria-label=\"Submit\" \nng-disabled=\"formTransaction.$invalid || formTransaction.$pristine\"><md-icon md-font-icon=\"icon-check-circle\" \naria-label=\"android\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span></md-button></md-dialog-actions></form>\n</md-dialog></div>");
$templateCache.put("app/main/mpp/report/cost/cost.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\"><span \ntranslate=\"MENU.MAIN.MPPREPORTCOST\"></span></div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"frmCost\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label><span \ntranslate=\"ACTION.YEAR\"></span></label><md-select ng-model=\"vm.year\" aria-label=\"years\" name=\"years\" \nng-change=\"vm.getDataCostCenter()\"><md-option ng-repeat=\"ls in vm.years\" placeholder=\"{{\'ACTION.YEAR\' | translate}}\" \nng-value=\"ls\">{{ ls }}</md-option></md-select><div ng-messages=\"frmCost.years.$error\" role=\"alert\"><div \nng-message=\"required\"><span><span translate=\"ACTION.YEAR\"></span> field is required.</span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" ng-disabled=\"vm.disabledCompany\" aria-label=\"company\" name=\"company\"><md-option \nng-repeat=\"ls in vm.companies\" ng-selected=\"vm.company.id == ls.id\" placeholder=\"COMPANY\" ng-value=\"ls\">\n{{ ls.description }}</md-option></md-select><div ng-messages=\"frmCost.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span><span translate=\"KPI.LABEL.COMPANY\"></span> is required.</span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"KPI.LABEL.COSTCENTRE\"></span></label><md-select \nng-model=\"vm.costCenter\" required ng-disabled=\"vm.listCostCenter.length === 0\" aria-label=\"costCenter\" \nng-change=\"vm.getDataLayers()\" name=\"costCenter\"><md-option ng-repeat=\"ls in vm.listCostCenter\" \nplaceholder=\"COST CENTER\" ng-value=\"ls\">{{ ls.description }}</md-option></md-select><div \nng-messages=\"frmCost.costCenter.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"KPI.LABEL.COSTCENTRE\"></span> is required.</span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"KPI.LABEL.LAYERS\"></span></label><md-select ng-model=\"vm.layer\" required \ndata-md-container-class=\"selectHeader\" md-on-close=\"vm.clearSearch()\" ng-disabled=\"vm.layers.length === 0\" \naria-label=\"layer\" name=\"layer\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for layer\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=\"select Layers\">\n<md-option ng-repeat=\"ls in vm.layers | filter:vm.searchTerm\" placeholder=\"Layers\" ng-value=\"ls\">{{ls.description}}\n</md-option></md-optgroup></md-select><div ng-messages=\"frmCost.layer.$error\" role=\"alert\"><div ng-message=\"required\">\n<span><span translate=\"KPI.LABEL.LAYERS\"></span> is required.</span></div></div></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.getDataReport()\" \nng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-button ng-disabled=\"vm.listReport.length == 0\" \nclass=\"md-primary md-icon-button md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printPDF()\">\n<md-icon style=\"font-size:14px\" md-font-icon=\"icon-printer\"></md-icon></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-primary md-icon-button md-small\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.showDetail()\"><md-icon style=\"font-size:14px\" \nmd-font-icon=\"icon-eye\"></md-icon></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button \nng-disabled=\"vm.listReport.length == 0\" class=\"md-primary md-icon-button md-small\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.printExcel()\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-file-excel-box\">\n</md-icon></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><span flex hide show-gt-sm></span><md-menu \nmd-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-disabled=\"vm.listReport.length == 0\" \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon \nmd-font-icon=\"icon-print\"></md-icon><span><span translate=\"KPI.LABEL.PRINT\"></span></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content id=\"costReport\" layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\" ms-scroll><table ng-repeat=\"item in vm.listReport\" \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><tr><th class=\"title-header-top\">\n{{ item.description }} <span translate=\"KPI.LABEL.COSTELEMENT\"></span></th><td class=\"month-title\">Jan</td><td \nclass=\"month-title\">Feb</td><td class=\"month-title\">Mar</td><td class=\"month-title\">Apr</td><td class=\"month-title\">May\n</td><td class=\"month-title\">Jun</td><td class=\"month-title\">Jul</td><td class=\"month-title\">Aug</td><td \nclass=\"month-title\">Sep</td><td class=\"month-title\">Oct</td><td class=\"month-title\">Nov</td><td class=\"month-title\">Dec\n</td><td class=\"month-title\">Total</td></tr><tr><th class=\"title-header\"><span translate=\"KPI.LABEL.BEBANGAJIDANUPAH\">\n</span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.gajiPokok | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.gaji_pokok | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\"><span translate=\"KPI.LABEL.BEBANUPAHHARIAN\"></span></th><td class=\"text-right\" \nng-repeat=\"val in item.cost.list\">0</td><td class=\"title-header-right\" style=\"font-weight: bold\">0</td></tr><tr><th \nclass=\"title-header\"><span translate=\"KPI.LABEL.TUNJANGANKARYAWAN\"></span></th><td class=\"text-right\" \nng-repeat=\"val in item.cost.list\">{{ val.tunjangan | roundedMoney }}</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">{{ item.cost.tunjangan | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.THR\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.thr | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.thr | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span translate=\"KPI.LABEL.BONUS\"></span></th>\n<td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.bonus | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.bonus | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\"><span translate=\"KPI.LABEL.OT\"></span></th><td class=\"text-right\" \nng-repeat=\"val in item.cost.list\">{{ val.lembur | roundedMoney }}</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">{{ item.cost.lembur | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.PESANGONKARYAWAN\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">0</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">0</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.TUNJANGANLAINNYA\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.tunjanganLain | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.tunjangan_lain | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.BEBANPENGOBATAN\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.bpjsKesehatan | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.bpjs_kesehatan | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.BEBANJAMSOSTEK\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.jamsostek | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.jamsostek | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.TUNJANGANKENDARAAN\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.tunjanganCop | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.tunjangan_cop | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span translate=\"KPI.LABEL.PAJAK\">\n</span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.pajak | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.pajak | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\"><span translate=\"KPI.LABEL.TOTAL\"></span></th><td class=\"text-right\" style=\"font-weight: bold\" \nng-repeat=\"val in item.cost.list\">{{ val.totalCost | roundedMoney }}</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">{{ item.cost.totalCost | roundedMoney }}</td></tr></table></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/mpp/report/hc/hc.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill ms-scroll><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader\n class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nHeadcount Report</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\"><div layout=\"column\" flex><div \nid=\"filterForm\" class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmCost\" class=\"md-inline-form\" \nlayout-align=\"start center\" ng-submit=\"vm.getDataReport()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Years</label><md-select ng-model=\"vm.year\" ng-change=\"vm.getDataLayers()\" \naria-label=\"years\" name=\"years\"><md-option ng-repeat=\"ls in vm.years\" placeholder=\"YEARS\" ng-value=\"ls\">{{ls}}\n</md-option></md-select><div ng-messages=\"frmCost.years.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nYears field is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" ng-disabled=\"vm.disabledCompany\" aria-label=\"company\" name=\"company\"><md-option \nng-repeat=\"ls in vm.companies\" ng-selected=\"vm.company.id == ls.id\" placeholder=\"COMPANY\" ng-value=\"ls\">\n{{ ls.description }}</md-option></md-select><div ng-messages=\"frmCost.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Layers</label><md-select ng-model=\"vm.layer\" required aria-label=\"layer\" name=\"layer\"><md-option \nng-repeat=\"ls in vm.layers\" placeholder=\"Layers\" ng-value=\"ls\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmCost.layer.$error\" role=\"alert\"><div ng-message=\"required\"><span>Layer field is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Employee Type</label><md-select \nng-model=\"vm.selectedEmpType\" required aria-label=\"employee type\" name=\"empType\"><md-option \nng-repeat=\"ls in vm.empType\" placeholder=\"Employee Type\" ng-value=\"ls.value\">{{ ls.name }}</md-option></md-select><div \nng-messages=\"frmCost.empType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee Type field is required.\n</span></div></div></md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" \naria-label=\"FilterCost\" ng-click=\"vm.getDataReport()\" ng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon \nstyle=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div></form></div></div></md-content>\n<md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-button ng-disabled=\"vm.listReport.length == 0\" \nclass=\"md-primary md-icon-button md-small\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printPDF()\">\n<md-icon style=\"font-size:14px\" md-font-icon=\"icon-printer\"></md-icon></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-primary md-icon-button md-small\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.printExcel()\"><md-icon style=\"font-size:14px\" \nmd-font-icon=\"icon-file-excel-box\"></md-icon></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><span \nflex hide show-gt-sm></span><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu icon\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon \nmd-font-icon=\"icon-print\"></md-icon><span>PRINT</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><div id=\"tableMpp\">\n<table class=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th rowspan=\"2\">\nNo</th><th rowspan=\"2\">BT Code</th><th rowspan=\"2\">Level</th><th style=\"width: 20%\" rowspan=\"2\">Jabatan</th><th \nstyle=\"width: 5%\" rowspan=\"2\">Jumlah Karyawan Saat Ini</th><th style=\"width: 5%\" rowspan=\"2\">\nJumlah Karyawan yang akan datang</th><th colspan=\"2\">Karyawan</th><th colspan=\"2\">Karyawan</th><th colspan=\"12\">\nJadwal Pemenuhan</th><th rowspan=\"2\">Total</th></tr><tr><th style=\"width: 5%\">Internal</th><th style=\"width: 5%\">\nExternal</th><th style=\"width: 5%\">Mutasi</th><th style=\"width: 5%\">Terminasi</th><th>Jan</th><th>Feb</th><th>Mar</th>\n<th>Apr</th><th>Mei</th><th>Jun</th><th>Jul</th><th>Aug</th><th>Sep</th><th>Oct</th><th>Nov</th><th>Des</th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.listReport\"><td>{{$index + 1}}</td><td>{{ item.bt_code }}</td><td>\n{{ item.job_level }}</td><td>{{item.description}}</td><td>{{ item.curr.total }}</td><td>{{ item.next.total }}</td><td>\n{{ item.next.internal }}</td><td>{{ item.next.external }}</td><td>{{ item.next.mutation }}</td><td>\n{{ item.next.termination }}</td><td ng-repeat=\"i in item.next.listPerMonth track by $index\">{{ i }}</td><td>\n{{ item.totalRightPerRow }}</td></tr><tr ng-if=\"vm.listReport.length > 0\"><td class=\"total-hc\" colspan=\"4\">TOTAL</td>\n<td>{{ vm.totalCurrEmp }}</td><td>{{ vm.totalNextEmp }}</td><td>{{ vm.totalNextEmpInternal }}</td><td>\n{{ vm.totalNextEmpExternal }}</td><td>{{ vm.totalNextEmpMutation }}</td><td>{{ vm.totalNextEmpTermination }}</td><td \nng-repeat=\"j in vm.totalPerMonth track by $index\">{{ j }}</td><td>{{ vm.totalRightBottom }}</td></tr></tbody></table>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mtx/dashboard/dashboard/dashboard.html","<div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><div id=\"mppToolbarArea\" hide show-gt-sm><div \nclass=\"mpp-main-subheader\"><div class=\"md-whiteframe-3dp\" layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\" ng-style=\"{\'height\' : \'35px\'}\"><div flex=\"15\" layout=\"row\" class=\"md-primary\" \nlayout-align=\"start center\"><md-button class=\"md-primary md-mini\">Matrix Skill Dashboard</md-button></div><div flex \nlayout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"space-between center\" class=\"group-action\"><span\n class=\"label\">Business Unit</span><md-select name=\"bu\" ng-model=\"vm.bu\" ng-change=\"vm.loadDropdownSubArea(vm.bu);\" \nclass=\"md-no-underline\"><md-option ng-repeat=\"ls in vm.listBu\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></div><div class=\"divider-vertical\"></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"group-action\"><span class=\"label\">Sub Area</span><md-select name=\"sub_area_id\" ng-model=\"vm.sub_area_id\" \nclass=\"md-no-underline\"><md-option ng-repeat=\"ls in vm.listSubArea\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select></div><div class=\"divider-vertical\"></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"group-action\"><span class=\"label\">Effective Date</span> <input type=\"date\" name=\"effective_date\" \nng-model=\"vm.effective_date\" class=\"md-no-underline\" style=\"border: 0;background: transparent\"></div><div \nclass=\"divider-vertical\"></div><div layout=\"row\" layout-align=\"space-between center\" class=\"group-action\"><span \nclass=\"label\">Level</span><md-select name=\"level\" ng-model=\"vm.level\" class=\"md-no-underline\"><md-option \nng-repeat=\"ls in vm.listLevel\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></div><div \nclass=\"divider-vertical\"></div><div><md-button ng-click=\"vm.loadData()\" class=\"md-primary md-mini\" \nng-dasibled=\"!vm.bu || !vm.sub_area_id || !vm.level\">Load Dashboard<md-tooltip md-direction=\"bottom\">Load Dashboard\n</md-tooltip></md-button></div></div></div></div></div></div><div class=\"white-bg\"><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"100\" layout-wrap><div \nclass=\"p-10 detail-status-proses\" layout=\"column\" flex-gt-sm=\"20\" flex-sm=\"20\" flex-gt-xs=\"100\" flex-xs=\"100\" \nlayout-align=\"center\" ng-repeat=\"(name, widget) in vm.listDataCategory\" ng-click=\"vm.selectedCategoryId(widget.id)\">\n<div layout=\"column\" ng-style=\"widget.style\" class=\"blue-bg white-fg p-5\"><div \nclass=\"pb-16 ng-scope layout-align-space-between-center layout-row white-fg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><md-icon class=\"m-0 mr-8 white-fg md-font material-icons icon-scale\" \nmd-font-icon=\"icon-scale\" role=\"img\" aria-label=\"icon-scale\"></md-icon><div class=\"h3 ng-binding\">\n{{widget.category_name}}</div></div></div><div class=\"pb-16 ng-scope layout-align-start-center layout-row white-fg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"h2 ng-binding\">{{widget.totalEmpAssestment}}</div><div \nclass=\"h2 secondary-text pl-8 ng-binding\">/ {{widget.totalEmpInSubArea}}</div></div><div \nclass=\"pb-16 ng-scope layout-align-start-center layout-row white-fg\" layout=\"row\" layout-align=\"start center\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{widget.progress}}\" class=\"ng-scope white-fg\"></md-progress-linear>\n{{widget.progress | number : 2}}%</div><div class=\"pt-12 ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><table border=\"0\" class=\"white-fg\"><tr><td><div class=\"bullet-kpi-result b-green-bullet\">\n</div></td><td><span class=\"label-white\">{{widget.green}}</span></td><td><div \nclass=\"bullet-kpi-result b-orange-bullet\"></div></td><td><span class=\"label-white\">{{widget.yellow}}</span></td><td>\n<div class=\"bullet-kpi-result b-red-bullet\"></div></td><td><span class=\"label-white\">{{widget.red}}</span></td><td><div\n class=\"bullet-kpi-result b-black-bullet\"></div></td><td><span class=\"label-white\">{{widget.black}}</span></td></tr>\n</table></div></div></div></div></div><br><div id=\"chartdiv\" style=\"height: 60vh\" ng-if=\"!vm.chartHide\"></div><br>\n<table class=\"p-16 simple with-toolbar stripped\" ms-responsive-table id=\"tb-kpi-setting\" style=\"font-size: 12px\" \nng-if=\"vm.listDataSector.length > 0\" ng-if=\"!vm.chartHide\"><thead><tr><th class=\"text-center\">Gedung</th><th \nclass=\"text-center\">Sector</th><th class=\"text-center\">Green</th><th class=\"text-center\">Yellow</th><th \nclass=\"text-center\">Red</th><th class=\"text-center\">Black</th><th class=\"text-center\">Trainer</th><th \nclass=\"text-center\">Index</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listDataSector\"><td><span \nstyle=\"font-weight: bold\">{{ls.gedung_name}}</span></td><td><span style=\"font-weight: bold\">{{ls.sector_name}}</span>\n</td><td class=\"text-center\"><span style=\"font-weight: bold\"><a ng-click=\"vm.infoSector(ls,\'3\',\'green\',\'#1B5E20\')\">\n{{ls.green}}</a> ({{ls.greenPersen}}%)</span></td><td class=\"text-center\"><span style=\"font-weight: bold\"><a \nng-click=\"vm.infoSector(ls,\'2\',\'yellow\',\'#F57F17\')\">{{ls.yellow}}</a> ({{ls.yellowPersen}}%)</span></td><td \nclass=\"text-center\"><span style=\"font-weight: bold\"><a ng-click=\"vm.infoSector(ls,\'1\',\'red\',\'#b71c1c\')\">{{ls.red}}</a>\n ({{ls.redPersen}}%)</span></td><td class=\"text-center\"><span style=\"font-weight: bold\"><a \nng-click=\"vm.infoSector(ls,\'0\',\'black\',\'#212121\')\">{{ls.black}}</a> ({{ls.blackPersen}}%)</span></td><td \nclass=\"text-center\"><span style=\"font-weight: bold\">{{ls.trainer}}</span></td><td class=\"text-center\"><span \nstyle=\"font-weight: bold\">{{ls.green+ls.yellow+ls.red+ls.black}}/{{ls.totalEmp}} ({{ls.totalEmpAssestmentPersen}}%)\n</span></td></tr></tbody></table><table class=\"p-16 simple with-toolbar stripped\" ms-responsive-table \nid=\"tb-kpi-setting\" style=\"font-size: 12px\" ng-if=\"vm.listDataInfoSector.length > 0\"><thead><tr><td colspan=\"4\" \nclass=\"text-left\" style=\"background-color: {{vm.bg}} !important\">{{vm.informationSector}}</td></tr><tr><th \nclass=\"text-center\" width=\"50\">No</th><th class=\"text-left\">NIK</th><th class=\"text-left\">Nama</th><th \nclass=\"text-left\">Category Product</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listDataInfoSector\"><td \nclass=\"text-center\"><span style=\"font-weight: bold\">{{$index+1}}</span></td><td class=\"text-left\"><span \nstyle=\"font-weight: bold\">{{ls.employement_nik}}</span></td><td class=\"text-left\"><span style=\"font-weight: bold\">\n{{ls.emp_name}}</span></td><td class=\"text-left\"><span style=\"font-weight: bold\">{{ls.category_name}}</span></td></tr>\n</tbody></table></div></div>");
$templateCache.put("app/main/mtx/master/mtx-activity/mtx-activity.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Master Matrix Activity</md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"manageMasterForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Activity Name</label><input type=\"text\" \nname=\"activity_name\" ng-model=\"vm.Form.objForm.activity_name\" required><div \nng-messages=\"manageMasterForm.activity_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nActivity Name field is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"\"><label>Matrix Main Activity</label><md-select name=\"mtx_main_activity_id\" \nng-model=\"vm.Form.objForm.mtx_main_activity_id\" required><md-option ng-repeat=\"ls in vm.listMainActivity\" \nvalue=\"{{ls.id}}\">{{ls.label}}</md-option></md-select><div ng-messages=\"manageMasterForm.mtx_main_activity_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Matrix Category field is required.</span></div></div>\n</md-input-container></div><br><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\" style=\"font-size: 12px\" ng-hide=\"vm.tableActivityScoreAktif\"><thead><tr><th colspan=\"4\">\nMatrix Activity Score</th></tr><tr><th class=\"text-center\" width=\"50px\"><a ng-click=\"vm.addScore()\"><md-icon \nmd-font-icon=\"icon-plus\" style=\"font-size: 12px\"></md-icon></a></th><th class=\"text-center\">Level</th><th \nclass=\"text-center\">Weight</th><th class=\"text-center\" width=\"50px\">#</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.Form.objForm.activity_score\"><td class=\"text-center\"><span style=\"font-weight: bold\">{{$index+1}}\n</span></td><td><input type=\"number\" name=\"level\" ng-model=\"ls.level\" class=\"input-table-dot\" required></td><td><input \ntype=\"number\" name=\"weight\" ng-model=\"ls.weight\" class=\"input-table-dot\" min=\"0\" step=\"0.1\" required></td><td>\n<md-button class=\"md-warn md-mini\" type=\"button\" ng-click=\"vm.deletListScore($index)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table><md-button class=\"md-raised md-warn\" \naria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.reset()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listDataSelected.length > 0\">Save\n</md-button><md-button type=\"submit\" class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" \nng-if=\"vm.listDataSelected.length > 0\">Delete</md-button></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><md-button class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-click=\"vm.setActivityScore()\">Matrix Skill Score ({{vm.Form.objForm.activity_score.length}})</md-button><md-button \nclass=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.showFilterChecked()\">Filter\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"50px\" rowspan=\"{{vm.showFilter?2:1}}\">NO</th><th \nclass=\"text-center\">Activity Name</th><th class=\"text-center\">Group</th><th class=\"text-center\">Main Category</th><th \nclass=\"text-center\">Category Name</th><th class=\"text-center\">Main Activity Name</th><th class=\"text-center\" \nwidth=\"50px\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th></tr><tr ng-show=\"vm.showFilter\" \nclass=\"check-element animate-show-hide\"><th class=\"text-center\"><input type=\"text\" name=\"activity_name\" \nng-model=\"vm.search.activity_name\" class=\"input-table-dot-head\"></th><th class=\"text-center\"><md-select name=\"group\" \nng-model=\"vm.search.group\" class=\"input-table-dot-head\"><md-option ng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\">\n{{ls.label}}</md-option></md-select></th><th class=\"text-center\"><md-select name=\"main_category\" \nng-model=\"vm.search.main_category\" class=\"input-table-dot-head\"><md-option ng-repeat=\"ls in vm.listMainCategory\" \nvalue=\"{{ls.id}}\">{{ls.label}}</md-option></md-select></th><th class=\"text-center\"><md-select name=\"category\" \nng-model=\"vm.search.category\" class=\"input-table-dot-head\"><md-option \nng-repeat=\"ls in vm.listCategory | filter:{filter:vm.search.main_category}\" value=\"{{ls.id}}\">{{ls.label}}</md-option>\n</md-select></th><th class=\"text-center\"><md-select name=\"main_activity\" ng-model=\"vm.search.main_activity\" \nclass=\"input-table-dot-head\"><md-option ng-repeat=\"ls in vm.listMainActivity | filter:{filter:vm.search.category}\" \nvalue=\"{{ls.id}}\">{{ls.label}}</md-option></md-select></th><th class=\"text-center\"><md-button class=\"md-mini\" \ntype=\"button\" ng-click=\"vm.loadData(1)\"><md-icon md-font-icon=\"icon-file-find\"></md-icon></md-button></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls)\"><td class=\"text-center\"><span \nstyle=\"font-weight: bold\">{{$index+1}}</span></td><td>{{ls.activity_name}}</td><td>{{ls.group_name}}</td><td>\n{{ls.main_category_name}}</td><td>{{ls.category_name}}</td><td>{{ls.main_activity_name}}</td><td class=\"text-center\">\n<input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"ls\"></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mtx/master/mtx-category/mtx-category.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Master Matrix Category</md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"manageMasterForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Category Name</label><input type=\"text\" \nname=\"category_name\" ng-model=\"vm.Form.objForm.category_name\" required><div \nng-messages=\"manageMasterForm.category_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCategory Name field is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"\"><label>Business Unit</label><md-select name=\"bu\" ng-model=\"vm.Form.objForm.bu\" required \nng-change=\"vm.loadDropdownSubArea(vm.Form.objForm.bu);\"><md-option ng-repeat=\"ls in vm.listBu\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"manageMasterForm.bu.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Business Unit field is required.</span></div></div></md-input-container><md-input-container\n class=\"md-block\" flex-gt-sm=\"\"><label>Sub Area</label><md-select name=\"sub_area_id\" \nng-model=\"vm.Form.objForm.sub_area_id\" required \nng-change=\"vm.viewDataEmployementBySubArea(vm.Form.objForm.sub_area_id);\"><md-option ng-repeat=\"ls in vm.listSubArea\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"manageMasterForm.bu.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-input-container\n class=\"md-block\" flex-gt-sm=\"\"><label>Matrix Main Category</label><md-select name=\"bu\" \nng-model=\"vm.Form.objForm.mtx_main_category_id\" required><md-option ng-repeat=\"ls in vm.listMainCategory\" \nvalue=\"{{ls.id}}\">{{ls.group_name}}/{{ls.main_category_name}}</md-option></md-select><div \nng-messages=\"manageMasterForm.mtx_main_category_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMatrix Main Category field is required.</span></div></div></md-input-container></div><br><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\" style=\"font-size: 12px\" \nng-hide=\"vm.tableEmpAktif\"><thead><tr><th ng-if=\"vm.edit\"><md-button \nclass=\"md-button md-ink-ripple md-primary md-mini\" show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.uploadData($event)\" style=\"color: white\"><md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\">\nUpload Employee</md-tooltip><md-icon md-font-icon=\"icon-upload\" style=\"color: white\"></md-icon>Upload</md-button></th>\n<th colspan=\"5\" ng-if=\"vm.edit\">Employement</th><th colspan=\"6\" ng-if=\"!vm.edit\">Employement</th></tr><tr><th \nclass=\"text-center\" width=\"50px\"><a ng-click=\"vm.addEmployement()\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"font-size: 12px\"></md-icon></a></th><th class=\"text-center\">NIK</th><th class=\"text-center\">Name</th><th \nclass=\"text-center\">Assign Date</th><th class=\"text-center\">Assign By</th><th class=\"text-center\" width=\"50px\">#</th>\n</tr></thead><tbody><tr ng-repeat=\"ls in vm.Form.objForm.EmpHasCategory\"><td class=\"text-center\"><span \nstyle=\"font-weight: bold\">{{$index+1}}</span></td><td><md-autocomplete class=\"md-autocomplete-atasan-baru\" \nstyle=\"margin-top: 15px; background: transparent;border-bottom: 2px dotted {{(mpp_standar.is_focus)?\'blue\':\'#d9d9d9\'}}\" \nmd-no-cache=\"true\" md-input-minlength=\"3\" md-selected-item=\"ls.emp\" md-selected-item-change=\"vm.changeNik($index,ls)\" \nmd-search-text=\"searchText\" md-items=\"item in vm.lookupEmployee(searchText)\" md-item-text=\"item.nik\" ng-model=\"ls.emp\" \nng-if=\"!ls.id\" style=\"margin-top: 0 !important\"><md-item-template><span md-highlight-text=\"searchText\">\n{{item.nik + \', \' + item.emp_name}}</span></md-item-template></md-autocomplete><span ng-if=\"ls.id\">\n{{ls.employement_nik}}</span></td><td>{{ls.nama}}</td><td><span ng-if=\"ls.id\">{{ls.assign_date}}</span></td><td><span \nng-if=\"ls.id\">{{ls.assign_by}} - {{ls.nama_assign}}</span></td><td><md-button class=\"md-warn md-mini\" type=\"button\" \nng-click=\"vm.deleteEmpHasCategory($index,ls,manageMasterForm)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></td></tr></tbody></table><md-button class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" \nng-click=\"vm.reset()\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nstyle=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listDataSelected.length > 0\">Save\n</md-button><md-button type=\"submit\" class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" \nng-if=\"vm.listDataSelected.length > 0\">Delete</md-button></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><md-button class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-click=\"vm.setEmployement()\">Employement ({{vm.totalEmp}}/{{vm.totalEmpHasCategory}})</md-button><md-button \nclass=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.showFilterChecked()\">Filter\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"50px\" rowspan=\"{{vm.showFilter?2:1}}\">NO</th><th \nclass=\"text-center\">Category Name</th><th class=\"text-center\">Group</th><th class=\"text-center\">Main Category Name</th>\n<th class=\"text-center\">Business Unit</th><th class=\"text-center\">Sub Area</th><th class=\"text-center\" width=\"50px\">\n<div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th></tr><tr ng-show=\"vm.showFilter\" class=\"check-element animate-show-hide\"><th class=\"text-center\"><input \ntype=\"text\" name=\"category_name\" ng-model=\"vm.search.category_name\" class=\"input-table-dot-head\"></th><th \nclass=\"text-center\"><md-select name=\"group\" ng-model=\"vm.search.group\" class=\"input-table-dot-head\"><md-option \nng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\">{{ls.label}}</md-option></md-select></th><th class=\"text-center\">\n<md-select name=\"main_category\" ng-model=\"vm.search.main_category\" class=\"input-table-dot-head\"><md-option \nng-repeat=\"ls in vm.listMainCategory\" value=\"{{ls.id}}\">{{ls.label}}</md-option></md-select></th><th \nclass=\"text-center\"><md-select name=\"bu\" ng-model=\"vm.search.bu\" class=\"input-table-dot-head\"><md-option \nng-repeat=\"ls in vm.listBu\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></th><th class=\"text-center\">\n<md-select name=\"sub_area\" ng-model=\"vm.search.sub_area\" class=\"input-table-dot-head\"><md-option \nng-repeat=\"ls in vm.listSubArea\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></th><th \nclass=\"text-center\"><md-button class=\"md-mini\" type=\"button\" ng-click=\"vm.loadData(1)\"><md-icon \nmd-font-icon=\"icon-file-find\"></md-icon></md-button></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editData(ls)\"><td class=\"text-center\"><span style=\"font-weight: bold\">{{$index+1}}</span></td><td>\n{{ls.category_name}}</td><td>{{ls.group_name}}</td><td>{{ls.main_category_name}}</td><td>{{ls.company_name}}</td><td>\n{{ls.sub_area_name}}</td><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" \nchecklist-value=\"ls\"></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/mtx/master/mtx-import-emp-assestment/mtx-import-emp-assestment.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Matrix Import Assestment</md-subheader><div class=\"white-bg\"><form \nname=\"manageMasterForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><md-content \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label><md-select name=\"bu\" \nng-model=\"vm.Form.objForm.bu\" required ng-change=\"vm.loadDropdownSubArea(vm.Form.objForm.bu);\"><md-option \nng-repeat=\"ls in vm.listBu\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"manageMasterForm.bu.$error\" role=\"alert\"><div ng-message=\"required\"><span>Business Unit field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sub Area</label>\n<md-select name=\"sub_area_id\" ng-model=\"vm.Form.objForm.sub_area_id\" required \nng-change=\"vm.viewDataEmployementBySubArea(vm.Form.objForm.sub_area_id);\"><md-option ng-repeat=\"ls in vm.listSubArea\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"manageMasterForm.bu.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-input-container\n class=\"md-block\" flex-gt-sm=\"\"><label>Group</label><md-select name=\"group_id\" ng-model=\"vm.Form.objForm.group_id\" \nrequired ng-change=\"vm.loadDropdownMainCategory(vm.Form.objForm.bu,vm.Form.objForm.group_id);\"><md-option \nng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\">{{ls.group_name}}</md-option></md-select><div \nng-messages=\"manageMasterForm.group_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Group field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Matrix Main Category\n</label><md-select name=\"bu\" ng-model=\"vm.Form.objForm.mtx_main_category_id\" required \nng-change=\"vm.loadDropdownCategoryByMainCategory(vm.Form.objForm.mtx_main_category_id);\"><md-option \nng-repeat=\"ls in vm.listMainCategory\" value=\"{{ls.id}}\">{{ls.group_name}}/{{ls.main_category_name}}</md-option>\n</md-select><div ng-messages=\"manageMasterForm.mtx_main_category_id.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Matrix Main Category field is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"\"><label>Matrix Category</label><md-select name=\"mtx_category_id\" \nng-model=\"vm.Form.objForm.mtx_category_id\" required \nng-change=\"vm.loadDropdownEmp(vm.Form.objForm.sub_area_id,vm.Form.objForm.mtx_category_id);\"><md-option \nng-repeat=\"ls in vm.listCategory\" value=\"{{ls.id}}\">{{ls.group_name}}/{{ls.main_category_name}}/{{ls.category_name}}\n</md-option></md-select><div ng-messages=\"manageMasterForm.mtx_category_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Matrix Category field is required.</span></div></div></md-input-container></div><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.uploadData($event)\">\nImport Data</md-button><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listData.aDataSelected.length > 0\" \nng-click=\"vm.exportData()\">Export Data Master</md-button></div></div></md-content></form></div></div></md-content>\n</div>");
$templateCache.put("app/main/mtx/master/mtx-main-activity/mtx-main-activity.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Master Matrix Main Activity</md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"manageMasterForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Main Activity Name</label><input \ntype=\"text\" name=\"main_activity_name\" ng-model=\"vm.Form.objForm.main_activity_name\" required><div \nng-messages=\"manageMasterForm.main_activity_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMain Activity Name field is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"\"><label>Matrix Category</label><md-select name=\"mtx_category_id\" \nng-model=\"vm.Form.objForm.mtx_category_id\" required><md-option ng-repeat=\"ls in vm.listCategory\" value=\"{{ls.id}}\">\n{{ls.label}}</md-option></md-select><div ng-messages=\"manageMasterForm.mtx_category_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Matrix Category field is required.</span></div></div></md-input-container></div><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\" style=\"font-size: 12px\" \nng-hide=\"vm.tableActivityScoreAktif\"><thead><tr><th colspan=\"4\">Matrix Activity Score</th></tr><tr><th \nclass=\"text-center\" width=\"50px\"><a ng-click=\"vm.addScore()\"><md-icon md-font-icon=\"icon-plus\" style=\"font-size: 12px\">\n</md-icon></a></th><th class=\"text-center\">Level</th><th class=\"text-center\">Weight</th><th class=\"text-center\" \nwidth=\"50px\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.Form.objForm.activity_score\"><td class=\"text-center\">\n<span style=\"font-weight: bold\">{{$index+1}}</span></td><td><input type=\"number\" name=\"level\" ng-model=\"ls.level\" \nclass=\"input-table-dot\" required></td><td><input type=\"number\" name=\"weight\" ng-model=\"ls.weight\" \nclass=\"input-table-dot\" min=\"0\" step=\"0.1\" required></td><td><md-button class=\"md-warn md-mini\" type=\"button\" \nng-click=\"vm.deletListScore($index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table><br><md-button class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.reset()\">Cancel\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listDataSelected.length > 0\">Save\n</md-button><md-button type=\"submit\" class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" \nng-if=\"vm.listDataSelected.length > 0\">Delete</md-button></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><md-button class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-click=\"vm.setActivityScore()\">Matrix Skill Score ({{vm.Form.objForm.activity_score.length}})</md-button><md-button \nclass=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.showFilterChecked()\">Filter\n</md-button><span flex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"50px\" rowspan=\"{{vm.showFilter?2:1}}\">NO</th><th \nclass=\"text-center\">Main Activity Name</th><th class=\"text-center\">Group</th><th class=\"text-center\">Main Category</th>\n<th class=\"text-center\">Category Name</th><th class=\"text-center\" width=\"50px\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th></tr><tr \nng-show=\"vm.showFilter\" class=\"check-element animate-show-hide\"><th class=\"text-center\"><input type=\"text\" \nname=\"main_activity_name\" ng-model=\"vm.search.main_activity_name\" class=\"input-table-dot-head\"></th><th \nclass=\"text-center\"><md-select name=\"group\" ng-model=\"vm.search.group\" class=\"input-table-dot-head\"><md-option \nng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\">{{ls.label}}</md-option></md-select></th><th class=\"text-center\">\n<md-select name=\"main_category\" ng-model=\"vm.search.main_category\" class=\"input-table-dot-head\"><md-option \nng-repeat=\"ls in vm.listMainCategory\" value=\"{{ls.id}}\">{{ls.label}}</md-option></md-select></th><th \nclass=\"text-center\"><md-select name=\"category\" ng-model=\"vm.search.category\" class=\"input-table-dot-head\"><md-option \nng-repeat=\"ls in vm.listCategory | filter:{filter:vm.search.main_category}\" value=\"{{ls.id}}\">{{ls.label}}</md-option>\n</md-select></th><th class=\"text-center\"><md-button class=\"md-mini\" type=\"button\" ng-click=\"vm.loadData(1)\"><md-icon \nmd-font-icon=\"icon-file-find\"></md-icon></md-button></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" \nng-dblclick=\"vm.editData(ls)\"><td class=\"text-center\"><span style=\"font-weight: bold\">{{$index+1}}</span></td><td>\n{{ls.main_activity_name}}</td><td>{{ls.group_name}}</td><td>{{ls.main_category_name}}</td><td>{{ls.category_name}}</td>\n<td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"ls\"></td></tr>\n</tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mtx/master/mtx-main-category/mtx-main-category.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Master Matrix Main Category</md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"manageMasterForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Main Category Name</label><input \ntype=\"text\" name=\"main_category_name\" ng-model=\"vm.Form.objForm.main_category_name\" required><div \nng-messages=\"manageMasterForm.main_category_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMain Category Name field is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"\"><label>Description</label><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label><md-select \nname=\"bu\" ng-model=\"vm.Form.objForm.bu\" required><md-option ng-repeat=\"ls in vm.listBu\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"manageMasterForm.bu.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Business Unit field is required.</span></div></div></md-input-container><md-input-container\n class=\"md-block\" flex-gt-sm=\"\"><label>Country</label><md-select name=\"bu\" ng-model=\"vm.Form.objForm.country_id\" \nrequired><md-option ng-repeat=\"ls in vm.listCountry\" value=\"{{ls.countrycode}}\">{{ls.name}}</md-option></md-select><div\n ng-messages=\"manageMasterForm.country_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCountry field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex=\"30\"><label>Group</label><md-select name=\"bu\" \nng-model=\"vm.Form.objForm.group_id\" required><md-option ng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\">\n{{ls.group_name}}</md-option></md-select><div ng-messages=\"manageMasterForm.group_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Group field is required.</span></div></div></md-input-container></div><md-button \nclass=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.reset()\">Cancel</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listDataSelected.length > 0\">Save\n</md-button><md-button type=\"submit\" class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" \nng-if=\"vm.listDataSelected.length > 0\">Delete</md-button></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><md-input-container class=\"md-block hide-validation-error\" flex-gt-sm=\"\"><input \ntype=\"text\" name=\"search\" ng-model=\"vm.search\" placeholder=\"Search Main Category Name \"></md-input-container><span \nflex hide show-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><th class=\"text-center\" width=\"50px\">NO</th><th class=\"text-center\" width=\"50px\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\">Main Category Name</th><th class=\"text-center\">Description</th><th class=\"text-center\">\nBusiness Unit</th><th class=\"text-center\">Country</th><th class=\"text-center\">Group</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls)\"><td class=\"text-center\"><span \nstyle=\"font-weight: bold\">{{$index+1}}</span></td><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listDataSelected\" checklist-value=\"ls\"></td><td>{{ls.main_category_name}}</td><td>\n{{ls.description}}</td><td>{{ls.bu_name}}</td><td>{{ls.country_name}}</td><td>{{ls.group_name}}</td></tr></tbody>\n</table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mtx/master/mtx-ref-group/mtx-ref-group.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Master Matrix Ref Group</md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"manageMasterForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Group Name</label><input type=\"text\" \nname=\"group_name\" ng-model=\"vm.Form.objForm.group_name\" required><div ng-messages=\"manageMasterForm.group_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Group Name field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label><md-select name=\"bu\" \nng-model=\"vm.Form.objForm.bu\" required><md-option ng-repeat=\"ls in vm.listBu\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"manageMasterForm.bu.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBusiness Unit field is required.</span></div></div></md-input-container></div><md-button class=\"md-raised md-warn\" \naria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.reset()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listDataSelected.length > 0\">Save\n</md-button><md-button type=\"submit\" class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" \nng-if=\"vm.listDataSelected.length > 0\">Delete</md-button></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><md-input-container class=\"md-block hide-validation-error\" flex-gt-sm=\"\"><input \ntype=\"text\" name=\"search\" ng-model=\"vm.search\" placeholder=\"Search Group Name\"></md-input-container><span flex hide \nshow-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th \nclass=\"text-center\" width=\"50px\">NO</th><th class=\"text-center\" width=\"50px\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"text-center\">Group Name</th><th class=\"text-center\">Business Unit</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls)\"><td class=\"text-center\"><span \nstyle=\"font-weight: bold\">{{$index+1}}</span></td><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listDataSelected\" checklist-value=\"ls\"></td><td>{{ls.group_name}}</td><td>{{ls.bu_name}}</td></tr>\n</tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mtx/master/mtx-skill-activity/detail-description.html","<md-dialog aria-label=\"Detail Travel\" md-theme=\"modal-theme\" flex=\"80\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDetail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" style=\"font-size: 12px\"><textarea rows=\"5\" \nui-tinymce=\"tinymceOptions\" ng-model=\"description\"></textarea></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button atribute=\"1\" ng-click=\"closeDialog()\" class=\"md-button md-ink-ripple md-mini\" \nstyle=\"background-color:rgb(60, 192, 60);color:#FFFFFF\">Submit</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mtx/master/mtx-skill-activity/mtx-skill-activity.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Master Matrix Skill Activity</md-subheader><div class=\"white-bg\"><md-content\n layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"manageMasterForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Skill Name</label><input type=\"text\" \nname=\"skill_name\" ng-model=\"vm.Form.objForm.skill_name\" required><div ng-messages=\"manageMasterForm.skill_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Skill Name field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Matrix Activity</label><md-select name=\"mtx_activity_id\" \nng-model=\"vm.Form.objForm.mtx_activity_id\" required><md-option ng-repeat=\"ls in vm.listActivity\" value=\"{{ls.id}}\">\n{{ls.group_name}}/{{ls.main_category_name}}/{{ls.category_name}}/{{ls.main_activity_name}}/{{ls.activity_name}}\n</md-option></md-select><div ng-messages=\"manageMasterForm.mtx_activity_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Matrix Activity field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Order Nomor</label><input type=\"number\" name=\"order_no\" \nng-model=\"vm.Form.objForm.order_no\" required><div ng-messages=\"manageMasterForm.order_no.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Order Nomor field is required.</span></div></div></md-input-container></div><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\" style=\"font-size: 12px\" \nng-hide=\"vm.tableActivityScoreAktif\"><thead><tr><th colspan=\"4\">Matrix Activity Score</th></tr><tr><th \nclass=\"text-center\" width=\"50px\"><a ng-click=\"vm.addScore()\"><md-icon md-font-icon=\"icon-plus\" style=\"font-size: 12px\">\n</md-icon></a></th><th class=\"text-center\">Level</th><th class=\"text-center\">Weight</th><th class=\"text-center\" \nwidth=\"50px\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.Form.objForm.activity_score\"><td class=\"text-center\">\n<span style=\"font-weight: bold\">{{$index+1}}</span></td><td><input type=\"number\" name=\"level\" ng-model=\"ls.level\" \nclass=\"input-table-dot\" required></td><td><input type=\"number\" name=\"weight\" ng-model=\"ls.weight\" \nclass=\"input-table-dot\" min=\"0\" step=\"0.1\" required></td><td><md-button class=\"md-warn md-mini\" type=\"button\" \nng-click=\"vm.deletListScore($index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table><br><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\" \nstyle=\"font-size: 12px\" ng-hide=\"vm.tableSkillIndikatorAktif\"><thead><tr><th colspan=\"6\">Matrix Skill Indikator</th>\n</tr><tr><th class=\"text-center\" width=\"50px\"><a ng-click=\"vm.addSkillIndikator()\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"font-size: 12px\"></md-icon></a></th><th class=\"text-center\">Description</th><th class=\"text-center\">\nInstruction Number</th><th class=\"text-center\">Succession Criteria</th><th class=\"text-center\" width=\"75px\">Order No\n</th><th class=\"text-center\" width=\"50px\">#</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.Form.objForm.skill_indikator\"><td class=\"text-center\"><span style=\"font-weight: bold\">{{$index+1}}\n</span></td><td ng-bind-html=\"ls.description\" ng-click=\"vm.showDetail($event,ls.description,\'description\',ls)\"></td>\n<td><input type=\"number\" name=\"instruction_number\" ng-model=\"ls.instruction_number\" class=\"input-table-dot\"></td><td \nng-bind-html=\"ls.succession_criteria\" ng-click=\"vm.showDetail($event,ls.succession_criteria,\'succession_criteria\',ls)\">\n</td><td width=\"75px\"><input type=\"number\" name=\"order_no\" ng-model=\"ls.order_no\" class=\"input-table-dot\" required>\n</td><td><md-button class=\"md-warn md-mini\" type=\"button\" ng-click=\"vm.deletListSkillIndikator($index)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table><md-button class=\"md-raised md-warn\" \naria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.reset()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listDataSelected.length > 0\">Save\n</md-button><md-button type=\"submit\" class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" \nng-if=\"vm.listDataSelected.length > 0\">Delete</md-button></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><md-button class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-click=\"vm.setActivityScore()\">Matrix Skill Score ({{vm.Form.objForm.activity_score.length}})</md-button><md-button \nclass=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.setSkillIndikator()\">\nMatrix Skill Indikator ({{vm.Form.objForm.skill_indikator.length}})</md-button><md-button class=\"md-raised md-accent\" \naria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.showFilterChecked()\">Filter</md-button><span flex hide \nshow-gt-sm></span></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\">\n<table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th \nclass=\"text-center\" width=\"50px\" rowspan=\"{{vm.showFilter?2:1}}\">NO</th><th class=\"text-center\">Skill Name</th><th \nclass=\"text-center\">Group</th><th class=\"text-center\">Main Category</th><th class=\"text-center\">Category Name</th><th \nclass=\"text-center\">Main Activity Name</th><th class=\"text-center\">Activity Name</th><th class=\"text-center\" \nwidth=\"50px\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th></tr><tr ng-show=\"vm.showFilter\" \nclass=\"check-element animate-show-hide\"><th class=\"text-center\"><input type=\"text\" name=\"skill_name\" \nng-model=\"vm.search.skill_name\" class=\"input-table-dot-head\"></th><th class=\"text-center\"><md-select name=\"group\" \nng-model=\"vm.search.group\" class=\"input-table-dot-head\"><md-option ng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\">\n{{ls.label}}</md-option></md-select></th><th class=\"text-center\"><md-select name=\"main_category\" \nng-model=\"vm.search.main_category\" class=\"input-table-dot-head\"><md-option ng-repeat=\"ls in vm.listMainCategory\" \nvalue=\"{{ls.id}}\">{{ls.label}}</md-option></md-select></th><th class=\"text-center\"><md-select name=\"category\" \nng-model=\"vm.search.category\" class=\"input-table-dot-head\"><md-option \nng-repeat=\"ls in vm.listCategory | filter:{filter:vm.search.main_category}\" value=\"{{ls.id}}\">{{ls.label}}</md-option>\n</md-select></th><th class=\"text-center\"><md-select name=\"main_activity\" ng-model=\"vm.search.main_activity\" \nclass=\"input-table-dot-head\"><md-option ng-repeat=\"ls in vm.listMainActivity | filter:{filter:vm.search.category}\" \nvalue=\"{{ls.id}}\">{{ls.label}}</md-option></md-select></th><th class=\"text-center\"><md-select name=\"activity\" \nng-model=\"vm.search.activity\" class=\"input-table-dot-head\"><md-option \nng-repeat=\"ls in vm.listActivity | filter:{mtx_main_activity_id:vm.search.main_activity}\" value=\"{{ls.id}}\">\n{{ls.main_activity_name}} / {{ls.activity_name}}</md-option></md-select></th><th class=\"text-center\"><md-button \nclass=\"md-mini\" type=\"button\" ng-click=\"vm.loadData(1)\"><md-icon md-font-icon=\"icon-file-find\"></md-icon></md-button>\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls)\"><td class=\"text-center\">\n<span style=\"font-weight: bold\">{{$index+1}}</span></td><td>{{ls.skill_name}}</td><td>{{ls.group_name}}</td><td>\n{{ls.main_category_name}}</td><td>{{ls.category_name}}</td><td>{{ls.main_activity_name}}</td><td>{{ls.activity_name}}\n</td><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"ls\"></td>\n</tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mtx/master/mtx-sub-area-has-category/mtx-sub-area-has-category.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Master Matrix Subarea Has Category</md-subheader><div class=\"white-bg\">\n<md-content layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nname=\"manageMasterForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label>\n<md-select name=\"bu\" ng-model=\"vm.Form.objForm.bu\" required ng-change=\"vm.loadDropdownSubArea(vm.Form.objForm.bu);\">\n<md-option ng-repeat=\"ls in vm.listBu\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"manageMasterForm.bu.$error\" role=\"alert\"><div ng-message=\"required\"><span>Business Unit field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sub Area</label>\n<md-select name=\"sub_area_id\" ng-model=\"vm.Form.objForm.sub_area_id\" required \nng-change=\"vm.loadData(1,vm.Form.objForm.sub_area_id)\"><md-option ng-repeat=\"ls in vm.listSubArea\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"manageMasterForm.bu.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"\"><label>Matrix Category</label><md-select name=\"mtx_category_id\" \nng-model=\"vm.Form.objForm.mtx_category_id\" required multiple=\"multiple\"><md-option ng-repeat=\"ls in vm.listCategory\" \nvalue=\"{{ls.id}}\">{{ls.category_name}}</md-option></md-select><div \nng-messages=\"manageMasterForm.mtx_category_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMatrix Category field is required.</span></div></div></md-input-container></div><md-button class=\"md-raised md-warn\" \naria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.reset()\">Cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listDataSelected.length > 0\">Save\n</md-button><md-button type=\"submit\" class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" \nng-if=\"vm.listDataSelected.length > 0\">Delete</md-button></form></div></div></md-content><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1,vm.Form.objForm.sub_area_id)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><md-input-container \nclass=\"md-block hide-validation-error\" flex-gt-sm=\"\"><input type=\"text\" name=\"search\" ng-model=\"vm.search\" \nplaceholder=\"Search Skill Name \"></md-input-container><span flex hide show-gt-sm></span></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"50px\">NO</th><th class=\"text-center\" \nwidth=\"50px\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"text-center\">Business Unit</th><th \nclass=\"text-center\">Sub Area</th><th class=\"text-center\">Category</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\" ng-dblclick=\"vm.editData(ls)\"><td class=\"text-center\"><span \nstyle=\"font-weight: bold\">{{$index+1}}</span></td><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listDataSelected\" checklist-value=\"ls\"></td><td>{{ls.bu_name}}</td><td>{{ls.sub_area_name}}</td>\n<td>{{ls.category_name}}</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage,vm.Form.objForm.sub_area_id)\">{{nav.label}}</a></li>\n</ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mtx/transaksi/mtx-assesment/mtx-assesment.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Matrix Assesment Score</md-subheader><div class=\"white-bg\"><form \nname=\"manageMasterForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><md-content \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: 2vh\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Employee</label>\n<input type=\"text\" name=\"emp_name\" ng-model=\"vm.Form.objForm.emp_name\" required ng-disabled=\"true\">\n</md-input-container></div><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nstyle=\"float: right\" ng-click=\"vm.loadData()\">Load Data</md-button></div></div></md-content><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ng-if=\"vm.listData.length > 0\"><div \nclass=\"md-whiteframe-4dp white-bg rounded\" layout-fill ng-repeat=\"activity in vm.listData\" style=\"margin-bottom: 5px\">\n<md-subheader class=\"md-no-sticky\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex \nclass=\"logo-text\">\n{{activity.group_name}}/{{activity.main_category_name}}/{{activity.category_name}}/{{activity.main_activity_name}}/{{activity.activity_name}}\n</div><span flex></span></div></md-subheader><md-list ng-cloak ng-repeat=\"ls in activity.skill\"><md-subheader \nclass=\"md-no-sticky\" style=\"background-color: white !important\">\n{{ls.skill_name}} ({{vm.countCekIndikator(activity,$index)}}/{{ls.skill_indikator.length}})</md-subheader><md-list-item\n ng-repeat-start=\"value in ls.skill_indikator\" style=\"font-size: 12px\"><div><p ng-bind-html=\"value.description\"></p>\n<small ng-bind-html=\"value.succession_criteria\"></small></div><md-checkbox class=\"md-secondary\" \nng-model=\"value.validasi\"></md-checkbox></md-list-item><md-divider ng-repeat-end></md-divider></md-list></div><div \nclass=\"form-wrapper has-wrapper-coloum\"><md-button class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" \nng-click=\"vm.reset()\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nstyle=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listDataSelected.length > 0\">Save\n</md-button></div></md-content></form></div></div></md-content></div>");
$templateCache.put("app/main/mtx/transaksi/mtx-assesment-approval/mtx-assesment-approval-detail.html","<md-dialog aria-label=\"Detail Score\" md-theme=\"modal-theme\" flex=\"50\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDetail Score</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" layout=\"column\" style=\"font-size: 12px\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"50px\">No</th><th>Activity Name\n</th><th>Score</th><th>Weight</th><th>Score By</th></tr><tbody><tr ng-if=\"items.activity_process.length == 0\"><td \nstyle=\"text-align: center\">-</td><td style=\"text-align: center\">-</td><td style=\"text-align: center\">-</td><td \nstyle=\"text-align: center\">-</td><td style=\"text-align: center\">-</td></tr><tr \nng-repeat=\"(key, val) in items.activity_process\"><td style=\"text-align: center\">{{ $index + 1 }}</td><td>\n{{ val.activity_name }}</td><td class=\"text-center\"><div \nng-class=\"{\'bullet-kpi-result b-green-bullet\': val.level_score >= \'3\' &&  val.level_score < \'4\', \'bullet-kpi-result b-orange-bullet\': val.level_score >= \'2\' &&  val.level_score < \'3\' , \'bullet-kpi-result b-red-bullet\': val.level_score >= \'1\' &&  val.level_score < \'2\', \'bullet-kpi-result b-black-bullet\': val.level_score < 1 }\">\n</div></td><td class=\"text-center\">{{ val.weight*100 }}</td><td>{{ val.score_by }} - {{ val.emp_name_score_by }}</td>\n</tr></tbody></thead></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"closeDialog()\">Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mtx/transaksi/mtx-assesment-approval/mtx-assesment-approval.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Matrix Assesment List Employee</md-subheader><div class=\"white-bg\">\n<md-content layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 2vh\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>\nSearch</label><md-autocomplete class=\"md-autocomplete\" md-no-cache=\"true\" md-input-minlength=\"3\" \nmd-selected-item=\"vm.search\" md-search-text=\"searchText\" md-items=\"item in vm.lookupEmployee(searchText)\" \nmd-item-text=\"item.nik + \', \' + item.emp_name\" ng-model=\"vm.search\"><md-item-template><span \nmd-highlight-text=\"searchText\">{{item.nik + \', \' + item.emp_name}}</span></md-item-template></md-autocomplete>\n</md-input-container></div><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nstyle=\"float: right\" ng-click=\"vm.loadData()\">Search</md-button></div></div></md-content><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"50px\">NO</th><th class=\"text-center\">\nName</th><th class=\"text-center\" width=\"100px\">Category Name</th><th class=\"text-center\" width=\"100px\">Detail Score\n</th><th class=\"text-center\" width=\"200px\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\"><td \nclass=\"text-center\"><span style=\"font-weight: bold\">{{$index+1}}</span></td><td>{{ls.nik}} - {{ls.emp_name}}</td><td>\n{{ls.category_name}}</td><td width=\"100px\"><md-button class=\"md-mini md-raised md-primary\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.viewDataDetailScore($event,ls)\"><span>Detail Score</span></md-button></td><td \nwidth=\"200px\" class=\"text-center\"><span ng-if=\"ls.app_status !== null\"><b ng-if=\"ls.app_status == \'1\'\">Approved By</b> \n<b ng-if=\"ls.app_status == \'0\'\">Rejected By</b><br><span>{{ls.emp_name_approve_by}}</span><br ng-if=\"ls.note !== \'-\'\">\n<span ng-if=\"ls.note !== \'-\'\">({{ls.note}})</span></span><section layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\" layout-wrap style=\"justify-content:center\" ng-if=\"ls.app_status == null\"><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.approve($event,ls,1)\" \nng-disabled=\"ls.is_approve_action == 0 || ls.activity_process.length == 0\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><span>Approve</span></md-button><md-button class=\"md-mini md-raised md-warn\" type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.approve($event,ls,0)\" \nng-disabled=\"ls.is_approve_action == 0 || ls.activity_process.length == 0\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><span>Reject</span></md-button></section></td></tr></tbody></table></md-content></div></div></md-content>\n</div>");
$templateCache.put("app/main/mtx/transaksi/mtx-assesment-list/mtx-assesment-list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Matrix Assesment List Employee</md-subheader><div class=\"white-bg\">\n<md-content layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 2vh\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>\nSearch</label><md-autocomplete class=\"md-autocomplete\" md-no-cache=\"true\" md-input-minlength=\"3\" \nmd-selected-item=\"vm.search\" md-search-text=\"searchText\" md-items=\"item in vm.lookupEmployee(searchText)\" \nmd-item-text=\"item.nik + \', \' + item.emp_name\" ng-model=\"vm.search\"><md-item-template><span \nmd-highlight-text=\"searchText\">{{item.nik + \', \' + item.emp_name}}</span></md-item-template></md-autocomplete>\n</md-input-container></div><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nstyle=\"float: right\" ng-click=\"vm.loadData()\">Search</md-button></div></div></md-content><md-content layout=\"column\" \nflex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"50px\">NO</th><th class=\"text-center\">\nName</th><th class=\"text-center\" width=\"100px\">Join Date</th><th class=\"text-center\" width=\"50px\">#</th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.listData\" ng-dblclick=\"vm.editData(ls)\"><td class=\"text-center\"><span \nstyle=\"font-weight: bold\">{{$index+1}}</span></td><td>{{ls.employemeny_nik}} - {{ls.emp_name}}</td><td>{{ls.join_date}}\n</td><td width=\"50px\"><md-button class=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.viewDataAssesment(ls)\"><span>Detail</span></md-button></td></tr></tbody></table></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/mtx/transaksi/mtx-assesment-list-category/mtx-assesment-list-category.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Matrix Assesment List</md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div layout=\"row\" class=\"grid-view\"><div \nclass=\"widget-group layout-wrap layout-row flex-100\" layout=\"row\" flex=\"100\"><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"20\" ng-repeat=\"ls in vm.listAssesmentCategory\">\n<md-input-container flex style=\"margin: 2px\"><md-card class=\"green-50-bg\"><md-card-header class=\"green-300-bg\" \nstyle=\"padding: 8px\"><md-card-header-text><span class=\"md-title\">{{ls.mtx__main_name_category}}</span>\n</md-card-header-text></md-card-header><md-divider></md-divider><md-card-content style=\"text-align: center\"><span \nclass=\"label-process-mtx\">{{ls.count_assesment}}</span><br><span class=\"md-subhead\">{{ls.mtx_name_category}}</span>\n</md-card-content><md-divider></md-divider><span class=\"card-lastupdate-ls\">{{ls.timestamp}}</span><md-card-actions \nlayout=\"column\" layout-align=\"start\" style=\"text-align: center\"><span class=\"card-action-ls\"><md-button \nclass=\"md-mini md-raised md-primary\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.viewDataAssesment(ls)\"><span>Detail\n</span></md-button></span></md-card-actions></md-card></md-input-container></ms-widget></div></div></md-content></div>\n</div></md-content></div>");
$templateCache.put("app/main/mtx/transaksi/mtx-assesment-list-monitoring/detail-assesment.html","<md-dialog aria-label=\"Detail Travel\" md-theme=\"modal-theme\" flex=\"80\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDetail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" style=\"font-size: 12px\" ng-if=\"listDataDetail.length > 0\"><div \nclass=\"md-whiteframe-4dp white-bg rounded\" layout-fill ng-repeat=\"activity in listDataDetail\" \nstyle=\"margin-bottom: 5px\"><md-subheader class=\"md-no-sticky\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\">\n<div flex class=\"logo-text\">\n{{activity.group_name}}/{{activity.main_category_name}}/{{activity.category_name}}/{{activity.main_activity_name}}/{{activity.activity_name}}\n</div><span flex></span></div></md-subheader><md-list ng-cloak ng-repeat=\"ls in activity.skill\"><md-subheader \nclass=\"md-no-sticky\" style=\"background-color: white !important\">\n{{ls.skill_name}} ({{countCekIndikator(activity,$index)}}/{{ls.skill_indikator.length}})</md-subheader><md-list-item \nng-repeat-start=\"value in ls.skill_indikator\" style=\"font-size: 12px\"><div><p ng-bind-html=\"value.description\"></p>\n<small ng-bind-html=\"value.succession_criteria\"></small></div><md-checkbox class=\"md-secondary\" \nng-model=\"value.validasi\" ng-disabled=\"true\"></md-checkbox></md-list-item><md-divider ng-repeat-end></md-divider>\n</md-list></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mtx/transaksi/mtx-assesment-list-monitoring/mtx-assesment-list-monitoring.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Matrix Assesment List Employee Monitoring</md-subheader><div \nclass=\"white-bg\"><md-content layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\">\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label>\n<md-select name=\"bu\" ng-model=\"vm.search.bu\" required ng-change=\"vm.loadDropdownSubArea(vm.search.bu);\"><md-option \nng-repeat=\"ls in vm.listBu\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"manageMasterForm.bu.$error\" role=\"alert\"><div ng-message=\"required\"><span>Business Unit field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sub Area</label>\n<md-select name=\"sub_area_id\" ng-model=\"vm.search.sub_area_id\" required \nng-change=\"vm.viewDataEmployementBySubArea(vm.search.sub_area_id);\"><md-option ng-repeat=\"ls in vm.listSubArea\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"manageMasterForm.sub_area_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Group</label><md-select name=\"group_id\" \nng-model=\"vm.search.group_id\" required ng-change=\"vm.loadDropdownMainCategory(vm.search.bu,vm.search.group_id);\">\n<md-option ng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\">{{ls.group_name}}</md-option></md-select><div \nng-messages=\"manageMasterForm.group_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Group field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Matrix Main Category\n</label><md-select name=\"bu\" ng-model=\"vm.search.mtx_main_category_id\" required \nng-change=\"vm.loadDropdownCategoryByMainCategory(vm.search.mtx_main_category_id);\"><md-option \nng-repeat=\"ls in vm.listMainCategory\" value=\"{{ls.id}}\">{{ls.group_name}}/{{ls.main_category_name}}</md-option>\n</md-select><div ng-messages=\"manageMasterForm.mtx_main_category_id.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Matrix Main Category field is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"\"><label>Matrix Category</label><md-select name=\"mtx_category_id\" \nng-model=\"vm.search.mtx_category_id\" required \nng-change=\"vm.loadDropdownEmp(vm.search.sub_area_id,vm.search.mtx_category_id);\"><md-option \nng-repeat=\"ls in vm.listCategory\" value=\"{{ls.id}}\">{{ls.group_name}}/{{ls.main_category_name}}/{{ls.category_name}}\n</md-option></md-select><div ng-messages=\"manageMasterForm.mtx_category_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Matrix Category field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 2vh\"><md-input-container class=\"md-block\" flex-gt-xs><label>\nEmployee</label><md-select class=\"no-padding\" name=\"nik\" ng-model=\"vm.search.nik\" required multiple=\"multiple\">\n<md-option ng-repeat=\"ls in vm.listEmployee\" value=\"{{ls.nik}}\">{{ls.employement_nik}} - {{ls.emp_name}}</md-option>\n</md-select><md-icon><i class=\"glyphicon glyphicon-remove\"></i></md-icon><div \nng-messages=\"manageMasterForm.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Matrix Main Activity\n</label><md-select name=\"mtx_main_activity_id\" ng-model=\"vm.search.mtx_main_activity_id\" required \nng-change=\"vm.loadDropdownActivity(vm.search.mtx_main_activity_id);\"><md-option ng-repeat=\"ls in vm.listMainActivity\" \nvalue=\"{{ls.id}}\">{{ls.group_name}}/{{ls.main_category_name}}/{{ls.category_name}}/{{ls.main_activity_name}}\n</md-option></md-select><div ng-messages=\"manageMasterForm.mtx_main_activity_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Matrix Category field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Matrix Activity</label><md-select name=\"mtx_activity_id\" \nng-model=\"vm.search.mtx_activity_id\" required><md-option ng-repeat=\"ls in vm.listActivity\" value=\"{{ls.id}}\">\n{{ls.group_name}}/{{ls.main_category_name}}/{{ls.category_name}}/{{ls.main_activity_name}}/{{ls.activity_name}}\n</md-option></md-select><div ng-messages=\"manageMasterForm.mtx_activity_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Matrix Activity field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Score By</label><md-autocomplete class=\"md-autocomplete\" \nmd-no-cache=\"true\" md-input-minlength=\"3\" md-selected-item=\"vm.search.score_by\" md-search-text=\"searchText\" \nmd-items=\"item in vm.lookupEmployee(searchText)\" md-item-text=\"item.nik + \', \' + item.emp_name\" \nng-model=\"vm.search.score_by\" required><md-item-template><span md-highlight-text=\"searchText\">\n{{item.nik + \', \' + item.emp_name}}</span></md-item-template></md-autocomplete><div \nng-messages=\"manageMasterForm.score_by.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nScore By field is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\">\n<label>Status</label><md-select name=\"status\" ng-model=\"vm.search.status\"><md-option value=\"All\">All</md-option>\n<md-option value=\"1\">Finished</md-option><md-option value=\"0\">UnFinished</md-option></md-select></md-input-container>\n</div><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-click=\"vm.loadData()\">Load Data</md-button></div></div></md-content><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"50px\">NO</th><th class=\"text-center\">Name</th><th \nclass=\"text-center\">Category Name</th><th class=\"text-center\">Activity Name</th><th class=\"text-center\">\nJumlah Indikator</th><th class=\"text-center\">Score By</th><th class=\"text-center\" width=\"50px\">Status</th><th \nclass=\"text-center\" width=\"50px\">#</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listData\" \nng-dblclick=\"vm.editData(ls)\"><td class=\"text-center\"><span style=\"font-weight: bold\">{{$index+1}}</span></td><td>\n{{ls.emp_name}} ({{ls.employemeny_nik}})</td><td>{{ls.category_name}}</td><td>{{ls.activity_name}}</td><td \nclass=\"text-center\">{{ls.total_assesment}}</td><td>{{ls.score_by_name}} ({{ls.score_by}})</td><td class=\"text-center\" \ncolspan=\"2\"><md-button class=\"md-mini md-raised md-primary md-green-400-bg\" type=\"button\" aria-label=\"Inert\" \nng-if=\"ls.total_assesment == ls.total_indikator_test\" ng-click=\"vm.showDetail($event,ls)\"><span>{{ls.confirm_date}}\n</span></md-button><md-button class=\"md-mini md-raised md-primary md-red-400-bg\" type=\"button\" aria-label=\"Inert\" \nng-if=\"ls.total_assesment != ls.total_indikator_test\" ng-click=\"vm.showDetail($event,ls)\"><span>UNFINISHED</span>\n</md-button></td></tr></tbody></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/mtx/transaksi/mtx-assesment-setting/mtx-assesment-setting.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Matrix Assesment Score Setting</md-subheader><div class=\"white-bg\"><form \nname=\"manageMasterForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><md-content \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label><md-select name=\"bu\" \nng-model=\"vm.Form.objForm.bu\" required ng-change=\"vm.loadDropdownSubArea(vm.Form.objForm.bu);\"><md-option \nng-repeat=\"ls in vm.listBu\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"manageMasterForm.bu.$error\" role=\"alert\"><div ng-message=\"required\"><span>Business Unit field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sub Area</label>\n<md-select name=\"sub_area_id\" ng-model=\"vm.Form.objForm.sub_area_id\" required \nng-change=\"vm.viewDataEmployementBySubArea(vm.Form.objForm.sub_area_id);\"><md-option ng-repeat=\"ls in vm.listSubArea\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"manageMasterForm.sub_area_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Group</label><md-select name=\"group_id\" \nng-model=\"vm.Form.objForm.group_id\" required \nng-change=\"vm.loadDropdownMainCategory(vm.Form.objForm.bu,vm.Form.objForm.group_id);\"><md-option \nng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\">{{ls.group_name}}</md-option></md-select><div \nng-messages=\"manageMasterForm.group_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Group field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Matrix Main Category\n</label><md-select name=\"bu\" ng-model=\"vm.Form.objForm.mtx_main_category_id\" required \nng-change=\"vm.loadDropdownCategoryByMainCategory(vm.Form.objForm.mtx_main_category_id);\"><md-option \nng-repeat=\"ls in vm.listMainCategory\" value=\"{{ls.id}}\">{{ls.group_name}}/{{ls.main_category_name}}</md-option>\n</md-select><div ng-messages=\"manageMasterForm.mtx_main_category_id.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Matrix Main Category field is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"\"><label>Matrix Category</label><md-select name=\"mtx_category_id\" \nng-model=\"vm.Form.objForm.mtx_category_id\" required \nng-change=\"vm.loadDropdownEmp(vm.Form.objForm.sub_area_id,vm.Form.objForm.mtx_category_id);\"><md-option \nng-repeat=\"ls in vm.listCategory\" value=\"{{ls.id}}\">{{ls.group_name}}/{{ls.main_category_name}}/{{ls.category_name}}\n</md-option></md-select><div ng-messages=\"manageMasterForm.mtx_category_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Matrix Category field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 2vh\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" \nstyle=\"max-width: 25%\"><label>Employee</label><md-select name=\"nik\" ng-model=\"vm.Form.objForm.nik\" required \nmultiple=\"multiple\"><md-button layout-fill value=\"all\" ng-click=\"vm.selectAllEmployee()\"><span \nng-if=\"!vm.selectAllEmp\">Select all</span> <span ng-if=\"vm.selectAllEmp\">UnSelect all</span></md-button><md-option \nng-repeat=\"ls in vm.listEmployee\" value=\"{{ls.nik}}\">{{ls.employement_nik}} - {{ls.emp_name}}</md-option></md-select>\n<div ng-messages=\"manageMasterForm.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee field is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\">\n<label>Matrix Main Activity</label><md-select name=\"mtx_main_activity_id\" \nng-model=\"vm.Form.objForm.mtx_main_activity_id\" required \nng-change=\"vm.loadDropdownActivity(vm.Form.objForm.mtx_main_activity_id);\"><md-option \nng-repeat=\"ls in vm.listMainActivity\" value=\"{{ls.id}}\">\n{{ls.group_name}}/{{ls.main_category_name}}/{{ls.category_name}}/{{ls.main_activity_name}}</md-option></md-select><div \nng-messages=\"manageMasterForm.mtx_main_activity_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMatrix Category field is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"\"><label>Matrix Activity</label><md-select name=\"mtx_activity_id\" \nng-model=\"vm.Form.objForm.mtx_activity_id\" required><md-option ng-repeat=\"ls in vm.listActivity\" value=\"{{ls}}\">\n{{ls.group_name}}/{{ls.main_category_name}}/{{ls.category_name}}/{{ls.main_activity_name}}/{{ls.activity_name}}\n</md-option></md-select><div ng-messages=\"manageMasterForm.mtx_activity_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Matrix Activity field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Score By</label><md-autocomplete class=\"md-autocomplete\" \nmd-no-cache=\"true\" md-input-minlength=\"3\" md-selected-item=\"vm.Form.objForm.score_by\" md-search-text=\"searchText\" \nmd-items=\"item in vm.lookupEmployee(searchText)\" md-item-text=\"item.nik + \', \' + item.emp_name\" \nng-model=\"vm.Form.objForm.score_by\" required><md-item-template><span md-highlight-text=\"searchText\">\n{{item.nik + \', \' + item.emp_name}}</span></md-item-template></md-autocomplete><div \nng-messages=\"manageMasterForm.score_by.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nScore By field is required.</span></div></div></md-input-container></div><md-button type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listDataSelected.length > 0\" \nng-click=\"vm.loadData()\">Load Data</md-button></div></div></md-content><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\" ng-if=\"vm.listData.length > 0\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\" style=\"font-size: 12px\"><thead><tr><th colspan=\"6\">\n{{vm.activity.activity_name}}</th><th rowspan=\"2\">Score By</th></tr><tr><th class=\"text-center\" width=\"50px\">NO</th><th\n class=\"text-center\" width=\"200px\">Skill</th><th class=\"text-center\" colspan=\"2\" width=\"200px\">Key Indicator</th><th \nclass=\"text-center\">Succession Criteria</th><th class=\"text-center\" width=\"50px\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th></tr></thead><tbody>\n<tr ng-repeat-start=\"(key, ls) in vm.listData\"><td rowspan=\"{{ls.skill_indikator.length+1}}\" class=\"text-center\"><span \nstyle=\"font-weight: bold\">{{$index+1}}</span></td><td rowspan=\"{{ls.skill_indikator.length+1}}\">{{ls.skill_name}}</td>\n</tr><tr ng-repeat-end ng-repeat=\"value in ls.skill_indikator\"><td width=\"5px\" class=\"text-center\">{{($index + 1)}}\n</td><td ng-bind-html=\"value.description\"></td><td ng-bind-html=\"value.succession_criteria\"></td><td \nclass=\"text-center\"><input type=\"checkbox\" ng-model=\"value.validasi\"></td><td>\n{{value.score_by}}/{{value.score_by_name}}</td></tr></tbody></table><div class=\"form-wrapper has-wrapper-coloum\">\n<md-button class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" ng-click=\"vm.reset()\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listDataSelected.length > 0\">Save\n</md-button></div></md-content></form></div></div></md-content></div>");
$templateCache.put("app/main/mtx/transaksi/mtx-monitoring-score/mtx-monitoring-score.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill style=\"font-size: 12px\"><div class=\"md-whiteframe-4dp white-bg rounded\" \nlayout-fill><md-subheader class=\"white-bg\">Matrix Score Monitoring</md-subheader><div class=\"white-bg\"><form \nname=\"manageMasterForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,manageMasterForm)\"><md-content \nlayout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label><md-select name=\"bu\" \nng-model=\"vm.Form.objForm.bu\" required ng-change=\"vm.loadDropdownSubArea(vm.Form.objForm.bu);\"><md-option \nng-repeat=\"ls in vm.listBu\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"manageMasterForm.bu.$error\" role=\"alert\"><div ng-message=\"required\"><span>Business Unit field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Sub Area</label>\n<md-select name=\"sub_area_id\" ng-model=\"vm.Form.objForm.sub_area_id\" required \nng-change=\"vm.viewDataEmployementBySubArea(vm.Form.objForm.sub_area_id);\"><md-option ng-repeat=\"ls in vm.listSubArea\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"manageMasterForm.bu.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Sub Area field is required.</span></div></div></md-input-container><md-input-container\n class=\"md-block\" flex-gt-sm=\"\"><label>Group</label><md-select name=\"group_id\" ng-model=\"vm.Form.objForm.group_id\" \nrequired ng-change=\"vm.loadDropdownMainCategory(vm.Form.objForm.bu,vm.Form.objForm.group_id);\"><md-option \nng-repeat=\"ls in vm.listGroup\" value=\"{{ls.id}}\">{{ls.group_name}}</md-option></md-select><div \nng-messages=\"manageMasterForm.group_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Group field is required.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Matrix Main Category\n</label><md-select name=\"bu\" ng-model=\"vm.Form.objForm.mtx_main_category_id\" required \nng-change=\"vm.loadDropdownCategoryByMainCategory(vm.Form.objForm.mtx_main_category_id);\"><md-option \nng-repeat=\"ls in vm.listMainCategory\" value=\"{{ls.id}}\">{{ls.group_name}}/{{ls.main_category_name}}</md-option>\n</md-select><div ng-messages=\"manageMasterForm.mtx_main_category_id.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Matrix Main Category field is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"\"><label>Matrix Category</label><md-select name=\"mtx_category_id\" \nng-model=\"vm.Form.objForm.mtx_category_id\" required \nng-change=\"vm.loadDropdownEmp(vm.Form.objForm.sub_area_id,vm.Form.objForm.mtx_category_id);\"><md-option \nng-repeat=\"ls in vm.listCategory\" value=\"{{ls.id}}\">{{ls.group_name}}/{{ls.main_category_name}}/{{ls.category_name}}\n</md-option></md-select><div ng-messages=\"manageMasterForm.mtx_category_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Matrix Category field is required.</span></div></div></md-input-container></div><md-button \ntype=\"button\" class=\"md-raised md-accent\" aria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listData.aDataSelected.length > 0\" \nng-click=\"vm.loadData(0,null,null)\">Load Data</md-button><md-button type=\"button\" class=\"md-raised md-accent\" \naria-label=\"Submit\" style=\"float: right\" \nng-disabled=\"manageMasterForm.$invalid || manageMasterForm.$pristine || vm.listData.aDataSelected.length > 0\" \nng-click=\"vm.exportData()\">Export Data</md-button></div></div></md-content><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\" ng-if=\"vm.listData.skill_activity.length > 0\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\" style=\"font-size: 12px\"><tr><th \nrowspan=\"3\" colspan=\"1\" width=\"50px\">No</th><th rowspan=\"3\" colspan=\"1\" width=\"100%\">Nama Karyawan</th><th \ncolspan=\"{{vm.listData.colspan+1}}\">Nama Skill / Process {{vm.process}}</th><th \nstyle=\"max-width: 50px;width: 50px;height: 50px;line-height: 14px;padding-bottom: 20px !important\" rowspan=\"3\"><div \nclass=\"vertical\">Jumlah Skill</div></th></tr><tr><th \nstyle=\"max-width: 50px;width: 50px;height: 50px;line-height: 14px;padding-bottom: 20px !important\"><div \nclass=\"vertical\">No</div></th><th width=\"50px\" ng-repeat=\"ls in vm.listData.skill_activity\" \nng-if=\"ls.skill_name != \'Skill Flag\'\">{{ls.no}}</th></tr><tr><th \nstyle=\"max-width: 50px;width: 50px;height: 250px;line-height: 14px;padding-bottom: 20px !important\"><div \nclass=\"vertical\">Nama Skill/ Process</div></th><td ng-repeat=\"ls in vm.listData.skill_activity\" \nstyle=\"max-width: 50px;height: 250px;line-height: 14px;padding-bottom: 20px !important;background-color: {{ls.background}}\">\n<div class=\"vertical\"><a ng-click=\"vm.loadData(1,ls.mtx_activity_id, ls);\" ng-if=\"vm.type == \'0\' && ls.no != \'#\'\">\n{{ls.skill_name}}</a> <span ng-if=\"vm.type == \'1\' || ls.no == \'#\'\">{{ls.skill_name}}</span></div></td></tr><tr><th \ncolspan=\"3\" width=\"450px\">Standar</th><td width=\"50px\" ng-repeat=\"ls in vm.listData.skill_activity\" \nclass=\"text-center\"></td><td width=\"50px\" class=\"text-center\">{{vm.listData.skillCount}}</td></tr><tr \nng-repeat=\"ls in vm.listData.aDataEmp\"><td width=\"50px\" class=\"text-center\">{{$index+1}}</td><td colspan=\"2\">\n{{ls.employemeny_nik}} - {{ls.emp_name}}</td><td width=\"50px\" ng-repeat=\"lev in ls.detail\" class=\"text-center\" \nstyle=\"background-color: {{lev.background}}\"><div ng-if=\"lev.indikator_total_nilai > 0\" \nng-class=\"{\'bullet-kpi-result b-green-bullet\': lev.level >= 3 &&  lev.level < 4, \'bullet-kpi-result b-orange-bullet\': lev.level >= 2 &&  lev.level < 3 , \'bullet-kpi-result b-red-bullet\': lev.level >= 1 &&  lev.level < 2, \'bullet-kpi-result b-black-bullet\': lev.level < 1 }\">\n</div></td><td width=\"50px\" class=\"text-center\">{{ls.countSkill}}</td></tr></table><div \nclass=\"form-wrapper has-wrapper-coloum\"><md-button class=\"md-raised md-warn\" aria-label=\"Submit\" style=\"float: right\" \nng-click=\"vm.reset()\">Cancel</md-button></div></md-content></form></div></div></md-content></div>");
$templateCache.put("app/main/offboarding/approval-group/form-approval-group/form-approval-group.html","<md-dialog aria-label=\"Uplaod\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"FormInput\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,FormInput)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\"><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.bu\" aria-label=\"approval_type\" name=\"bu\" ng-change=\"vm.getSubArea()\" required><md-option \nng-repeat=\"ls in vm.bu\" placeholder=\"Business Unit\" value=\"{{ls.description}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"FormInput.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBusiness unit is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.sub_area_id\" aria-label=\"approval_type\" name=\"sub_area_id\"><md-option \nng-repeat=\"ls in vm.subareaList\" placeholder=\"Sub Area\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"nik\" ng-model=\"vm.Form.objForm.nik\" \nplaceholder=\"NIK\" required><div ng-messages=\"FormInput.description.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>NIK is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.Form.objForm.approvalType\" aria-label=\"approval_type\" name=\"approval_type\" required><md-option \nng-repeat=\"ls in vm.approvalType\" placeholder=\"Approval Type\" value=\"{{ls.description}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"FormInput.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nApproval type is required.</span></div></div></md-input-container><md-input-container flex><md-switch \nclass=\"md-secondary\" ng-model=\"vm.Form.objForm.status\"><span>Status</span></md-switch></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"FormInput.$invalid || FormInput.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/offboarding/exit-interview/admin/exinadmin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"95\" class=\"logo-text\">\nExit Interview Report</div><md-icon ng-click=\"vm.showFilter = !vm.showFilter\" \nng-class=\"{\'rotate-up-animate\' : vm.showFilter, \'rotate-down-animate\' : !vm.showFilter}\" style=\"font-size:16px\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></div></md-subheader><div class=\"white-bg\"><md-content \nng-class=\"{\'show-fade-in\' : vm.showFilter, \'show-fade-out\' : !vm.showFilter}\" layout=\"column\" ng-hide=\"!vm.showFilter\">\n<div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"frmCost\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"20\"><label>Years</label><md-select ng-model=\"vm.year\" aria-label=\"years\" name=\"years\">\n<md-option ng-repeat=\"ls in vm.years\" placeholder=\"YEARS\" ng-value=\"ls\">{{ ls }}</md-option></md-select><div \nng-messages=\"frmCost.years.$error\" role=\"alert\"><div ng-message=\"required\"><span>Years field is required.</span></div>\n</div></md-input-container><md-input-container flex=\"30\"><label>Employee Type</label><md-select \nng-model=\"vm.selectedEmpType\" required aria-label=\"employee type\" name=\"empType\"><md-option \nng-selected=\"ls.value === vm.selectedEmpType.value\" ng-repeat=\"ls in vm.empType\" placeholder=\"Employee Type\" \nng-value=\"ls\">{{ ls.name }}</md-option></md-select><div ng-messages=\"frmCost.empType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Employee Type field is required.</span></div></div></md-input-container><md-button \nclass=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" ng-click=\"vm.loadData(1)\" \nng-disabled=\"frmCost.$invalid || frmCost.$pristine\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\">\n</md-icon></md-button></div></form></div></div></md-content><md-toolbar class=\"mt-10\"><div \nclass=\"md-toolbar-tools table-tools\"><md-button class=\"md-primary md-icon-button md-small\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.showFormExport($event)\"><md-icon md-font-icon=\"icon-file-excel-box\">\n</md-icon></md-button><span flex hide show-gt-sm></span><ms-search-bar style=\"padding:0px\" on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\" class=\"bouncy-slide-left\"><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-disabled=\"vm.listReport.length == 0\" class=\"md-button md-ink-ripple md-mini\" type=\"button\" \naria-label=\"printcost\" ng-click=\"vm.printPDF()\"><md-icon md-font-icon=\"icon-print\"></md-icon><span>PRINT</span>\n</md-button></md-menu-item></md-menu-content></md-menu></ms-search-bar></div></md-toolbar><md-content id=\"costReport\" \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\" ms-scroll><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th>No</th><th>NIK</th><th>Name</th><th>\nExit Date</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTable.list\" \nng-click=\"vm.exitInterview(item.nik)\"><td>{{$index + 1}}</td><td>{{item.nik}}</td><td>{{item.fullname}}</td><td>\n{{item.exit_date}}</td><td>{{item.status}}</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/offboarding/exit-interview/admin/export.html","<md-dialog aria-label=\"Create Correspondence Request\" md-theme=\"modal-theme\" ms-scroll flex=\"60\" \nid=\"correspondence-pma-dialog\"><form ng-cloak name=\"formCorrespondence\" novalidate ng-submit=\"\"><md-toolbar><div \nclass=\"md-toolbar-tools title\"><h4>Exit Interview Export Data</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-padding><md-input-container flex><label>Start Date</label>\n<md-datepicker name=\"start_date\" required md-hide-icons=\"calendar\" md-open-on-focus ng-model=\"vm.tempStartDate\" \nmd-current-view=\"month\"></md-datepicker></md-input-container><md-input-container flex><label>End Date</label>\n<md-datepicker ng-disabled=\"vm.readOnly\" name=\"end_date\" required md-hide-icons=\"calendar\" md-open-on-focus \nng-model=\"vm.tempEndDate\" md-current-view=\"month\"></md-datepicker></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" flex><div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.exportExcel()\" ng-disabled=\"formCorrespondence.$invalid\" \ntype=\"submit\"><md-icon md-font-icon=\"icon-file-excel-box white-fg\"></md-icon>Export</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/offboarding/exit-interview/user/exinuser.html","<div id=\"exitInterview\" layout-fill class=\"page-layout scrollable\" ms-scroll><div layout=\"column\" flex \nlayout-align=\"space-around center\" layout-padding class=\"content-card\" ng-if=\"vm.isLoading\"><md-progress-circular \nmd-diameter=\"50\" md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"column\" flex \nlayout-align=\"space-beetwen center\" layout-padding class=\"content-card\"><form name=\"formExit\" \nng-submit=\"vm.saveData(formExit, $event)\" novalidate ng-style=\"{\'width\' : \'80%\'}\"><md-card class=\"white-bg\">\n<md-card-content layout=\"column\" layout-align=\"center start\" flex><table flex class=\"simple bordered\" \nstyle=\"width:100%\"><tbody><tr><th><span translate=\"UMUT.MENU.NAME\"></span></th><td><span class=\"zoomIn\">\n{{vm.empInfo.name}}</span></td><th><span translate=\"KPI.LABEL.JOINDATE\"></span></th><td><span class=\"zoomIn\">\n{{vm.empInfo.enter_date}}</span></td></tr><tr><th><span translate=\"UMUT.MENU.NIK\"></span></th><td class=\"zoomIn\"><span>\n{{vm.empInfo.nik}}</span></td><th><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.RESIGNDATE\"></span></th><td><span \nclass=\"zoomIn\">{{vm.empInfo.exit_date}}</span></td></tr><tr><th><span translate=\"UMUT.MENU.JOBTITLE\"></span></th><td \ncolspan=\"3\"><span class=\"zoomIn\">{{vm.empInfo.job_title}}</span></td></tr><tr><th><span \ntranslate=\"KPI.LABEL.DEPARTMENT\"></span></th><td colspan=\"3\"><span class=\"zoomIn\">{{vm.empInfo.department}}</span></td>\n</tr></tbody></table></md-card-content></md-card><md-card class=\"white-bg\" ng-style=\"{\'min-width\' : \'85%\'}\">\n<md-card-content layout=\"column\" layout-align=\"center start\" flex><table flex class=\"simple bordered\" \nstyle=\"width:100%\"><thead><tr><th colspan=\"3\"><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.HISTORYINCOMPANY\"></span>\n</th></tr><tr><th><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.POSITION\"></span></th><th><span \ntranslate=\"KPI.LABEL.DEPARTMENT\"></span></th><th><span translate=\"ACTION.YEAR\"></span></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.empHistory\"><td>{{item.job_title}}</td><td>{{item.department}}</td><td>{{item.years}}</td></tr>\n</tbody></table></md-card-content></md-card><md-card class=\"white-bg component-animate\" \nng-style=\"{\'min-width\' : \'85%\'}\" ng-repeat=\"item in vm.questions\"><md-card-title ng-style=\"{\'padding-bottom\' : \'5px\'}\">\n<md-card-title-text><strong>{{ item.question }}</strong><p ng-if=\"item.additional_info\">{{item.additional_info}}</p>\n</md-card-title-text></md-card-title><md-card-content><div layout=\"column\" layout-align=\"start start\" layout \nclass=\"is-multiple\" ng-if=\"item.variety === \'multiple\'\"><md-checkbox flex ng-model=\"detail.selected\" \nng-change=\"vm.onlyOneChecked(item, $index)\" ng-repeat-start=\"detail in item.detail\">{{ detail.detail }}</md-checkbox>\n<span ng-repeat-end ng-if=\"detail.detail === \'other\'\" flex class=\"other-input\"><textarea ng-required=\"detail.selected\" \nname=\"other-{{item.id}}\" ng-disabled=\"!detail.selected\" type=\"text\" ng-model=\"detail.other\">\n                            </textarea></span><div class=\"comment-wrapper\" layout=\"row\" layout-fill flex \nng-if=\"item.is_have_comment === \'1\'\"><md-input-container flex=\"100\"><label><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span> :</label><textarea minlength=\"50\" required \nname=\"comment-{{item.id}}\" ng-model=\"item.comment\" rows=\"5\"></textarea><div \nng-messages=\"formExit[\'comment-\' + item.id].$error\"><div ng-message=\"required\">This is required.</div><div \nng-message=\"minlength\"><span translate=\"ATTENDANCE.OFFBOARDING.MESSAGE.MORETHAN50CHAR\"></span></div></div>\n</md-input-container></div></div><div layout=\"column\" layout-align=\"start start\" layout class=\"is-multiple\" \nng-if=\"item.variety === \'single-w-other\'\"><md-checkbox \nng-change=\"vm.changeCheckSingleOther(item.detail, $index, this.detail.selected)\" flex ng-model=\"detail.selected\" \nng-repeat-start=\"detail in item.detail\">{{ detail.detail }}</md-checkbox><span ng-repeat-end \nng-if=\"detail.detail === \'other\'\" flex class=\"other-input\"><textarea ng-required=\"detail.selected\" \nname=\"other-{{item.id}}\" ng-disabled=\"!detail.selected\" type=\"text\" ng-model=\"detail.other\">\n                            </textarea></span><div class=\"comment-wrapper\" layout=\"row\" layout-fill flex \nng-if=\"item.is_have_comment === \'1\'\"><md-input-container flex=\"100\"><label><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span> :</label><textarea minlength=\"50\" required \nname=\"comment-{{item.id}}\" ng-model=\"item.comment\" rows=\"5\"></textarea><div \nng-messages=\"formExit[\'comment-\' + item.id].$error\"><div ng-message=\"required\">This is required.</div><div \nng-message=\"minlength\"><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.MORETHAN50CHAR\"></span></div></div>\n</md-input-container></div></div><div layout=\"column\" layout-align=\"space-around start\" layout \nng-if=\"item.variety === \'single\'\"><table style=\"min-width:100%\" class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><tr><th style=\"background-color:#fff !important; border: 2px solid #fff !important\"></th><th \ncolspan=\"4\"><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.DOYOUAGREE\"></span></th><th colspan=\"4\" class=\"bg-blue\" \nstyle=\"border-left: 5px solid #c7c7c7\"><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.ISTHATIMPORTANT\"></span></th></tr>\n<tr><th>{{item.question}}</th><th>STS<md-tooltip><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.VERYDISAGREE\"></span>\n</md-tooltip></th><th>TS<md-tooltip><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.DISAGREE\"></span></md-tooltip></th>\n<th>S<md-tooltip><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.AGREE\"></span></md-tooltip></th><th>SS<md-tooltip><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.STRONGLYAGREE\"></span></md-tooltip></th><th class=\"bg-blue\" \nstyle=\"border-left: 5px solid #c7c7c7\">STP<md-tooltip><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.VERYUNIMPORTANT\">\n</span></md-tooltip></th><th class=\"bg-blue\">TP<md-tooltip><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.NOTIMPORTANT\">\n</span></md-tooltip></th><th class=\"bg-blue\">P<md-tooltip><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.IMPORTANT\">\n</span></md-tooltip></th><th class=\"bg-blue\">SP<md-tooltip><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.VERYIMPORTANT\"></span></md-tooltip></th></tr><tr \nng-style=\"{\'background-color\' : detail.isNotValid ? \'rgba(238,190,190,0.5)\' : \'\' }\" ng-repeat=\"detail in item.detail\">\n<td style=\"width:50% !important\">{{detail.detail}}</td><td ng-repeat=\"answer in detail.answer[\'type1\']\" \nstyle=\"vertical-align:middle; text-align: center\"><md-checkbox class=\"md-primary\" \nng-change=\"vm.changeCheck(detail, $index, this.answer.val, \'type1\')\" ng-model=\"answer.val\"></md-checkbox></td><td \nng-style=\"{\'border-left\' : $index == 0 ? \'5px solid #c7c7c7\' : \'1px solid #d9d9d9\'}\" \nng-repeat=\"answer in detail.answer[\'type2\']\" style=\"vertical-align:middle; text-align: center\"><md-checkbox \nclass=\"md-accent\" ng-change=\"vm.changeCheck(detail, $index, this.answer.val, \'type2\')\" ng-model=\"answer.val\">\n</md-checkbox></td></tr></table><div class=\"comment-wrapper\" layout=\"row\" layout-fill flex \nng-if=\"item.is_have_comment === \'1\'\"><md-input-container flex=\"100\"><label><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENTSRELATEDTO\"></span> {{item.question}} :</label><textarea minlength=\"50\" \nrequired name=\"comment-{{item.id}}\" ng-model=\"item.comment\" rows=\"5\">\n                                </textarea><div \nng-messages=\"formExit[\'comment-\' + item.id].$error\"><div ng-message=\"required\">This is required.</div><div \nng-message=\"minlength\"><span translate=\"ATTENDANCE.OFFBOARDING.MESSAGE.MORETHAN50CHAR\"></span></div></div>\n</md-input-container></div></div><div layout=\"column\" layout-align=\"space-around start\" layout \nng-if=\"item.variety === \'custom\'\"><div class=\"custom-selection\" ng-repeat=\"option in item.detail\" layout=\"column\" flex>\n<div>{{ option.question }}</div><md-input-container class=\"md-block\"><md-radio-group layout=\"row\" \nng-model=\"option.selected\"><md-radio-button value=\"Y\" class=\"md-primary\"><span translate=\"UMUT.MENU.YES\"></span>\n</md-radio-button><md-radio-button value=\"N\"><span translate=\"ATTENDANCE.OFFBOARDING.MESSAGE.UMUT.MENU.NO\"></span>\n</md-radio-button></md-radio-group></md-input-container><div class=\"custom-choice\" ng-if=\"option.selected === \'Y\'\">\n<table class=\"simple bordered with-toolbar\"><tr ng-repeat=\"row in option.formData.field\"><th style=\"width:20%\">\n{{ row.header }}</th><td style=\"width:80%\"><input ng-if=\"row.type === \'number\'\" format=\"currency\" type=\"text\" required \nname=\"detail-{{option.id}}-number-{{$index}}\" ng-model=\"row.content\"> <input ng-if=\"row.type === \'text\'\" type=\"text\" \nrequired name=\"detail-{{option.id}}-text-{{$index}}\" ng-model=\"row.content\"></td></tr></table><div \nclass=\"comment-wrapper\" ng-if=\"option.formData.isComment\" layout=\"row\" layout-fill flex><md-input-container flex=\"100\">\n<label><span translate=\"ATTENDANCE.OFFBOARDING.LABEL.COMMENT\"></span></label><textarea name=\"comment-{{item.id}}\" \nrequired ng-model=\"option.formData.comment\" rows=\"5\"></textarea><div \nng-messages=\"formExit[\'comment-\' + item.id].$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container></div></div></div></div><div layout=\"column\" layout-align=\"space-around start\" layout \nng-if=\"item.variety === \'essay\'\"><div class=\"comment-wrapper\" layout=\"row\" layout-fill flex><md-input-container \nflex=\"100\"><textarea name=\"essay\" required ng-model=\"item.answer\" rows=\"5\"></textarea><div \nng-messages=\"formExit.essay.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div>\n</div></md-card-content></md-card><div layout=\"row\" layout-align=\"end start\" ng-if=\"!vm.isReadOnly && vm.empInfo\">\n<md-button ng-if=\"!vm.isUpdate\" type=\"submit\" class=\"md-primary md-raised\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-check-circle\"></md-icon><span translate=\"ACTION.SUBMIT\">Submit</span></md-button><md-button \nng-if=\"vm.isUpdate\" type=\"button\" class=\"md-primary md-raised\" aria-label=\"Submit\" \nng-click=\"vm.updateData(formExit, $event)\"><md-icon md-font-icon=\"icon-check-circle\"></md-icon><span \ntranslate=\"ACTION.UPDATE\">Update</span></md-button></div></form><div layout=\"row\" layout-align=\"end start\" \nng-if=\"vm.empInfo.checker\"><md-button class=\"md-primary md-raised\" aria-label=\"Submit\" \nng-click=\"vm.approval(\'1\', vm.empInfo.checker)\"><md-icon md-font-icon=\"icon-check-circle\"></md-icon><span \ntranslate=\"KPI.LABEL.APROVE\"></span></md-button><md-button class=\"md-red-300-bg md-raised white-fg\" \naria-label=\"Submit\" ng-click=\"vm.approval(\'2\', vm.empInfo.checker)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon><span translate=\"ACTION.REJECT\"></span></md-button></div></div></div>");
$templateCache.put("app/main/offboarding/exit-interview/user/question.html","");
$templateCache.put("app/main/offboarding/handover/form-handover/form-handover.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"60\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Job Handover</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\">\n<form name=\"formInput\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event, formInput)\"><div \nlayout-xs=\"column\" layout=\"row\" class=\"form-wrapper md-whiteframe-1dp m-4\" layout-align=\"center center\">\n<md-input-container flex-gt-sm=\"100\"><md-select ng-model=\"vm.receiver\" name=\"reason\" \nng-change=\"vm.selectedItemChange()\" required><md-option ng-repeat=\"ls in vm.listReceiver\" placeholder=\"Receiver\" \nvalue=\"{{ls.emp_profile_id}}\">{{ls.NAME}}</md-option></md-select><div ng-messages=\"formInput.reason.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Reason is required.</span></div></div></md-input-container></div><div \nlayout-xs=\"column\" layout=\"row\" class=\"form-wrapper md-whiteframe-1dp m-4\" layout-align=\"start center\"><div \nlayout=\"column\" flex=\"15\"><md-input-container flex><input ng-model=\"vm.Form.objForm.nik\" placeholder=\"NIK\" \nng-readonly=\"true\"></md-input-container></div><div layout=\"column\" flex=\"45\"><md-input-container flex><input \nng-model=\"vm.job_title\" placeholder=\"Job Title\" ng-readonly=\"true\"></md-input-container></div></div><div \nlayout-xs=\"column\" layout=\"row\" class=\"form-wrapper md-whiteframe-1dp m-4\" layout-align=\"center center\" \nng-repeat=\"info in vm.informations\"><div layout=\"column\" flex=\"95\"><md-input-container flex><input \nng-model=\"vm.Form.objForm.item[$index]\" placeholder=\"Item {{$index+1}}\"></md-input-container></div><div \nlayout=\"column\" flex=\"5\"><md-button ng-click=\"vm.hapus()\" \nclass=\"md-icon-button md-warn md-button md-default-theme md-ink-ripple\" ng-if=\"!$last\"><md-icon \nmd-font-icon=\"icon-border-color\" class=\"md-font icon-close-circle material-icons\"></md-icon></md-button><md-button \nng-click=\"vm.tambah()\" class=\"md-icon-button md-accent md-button md-default-theme md-ink-ripple\" ng-if=\"$last\"><md-icon\n md-font-icon=\"icon-border-color\" class=\"md-font icon-plus-circle material-icons\"></md-icon></md-button></div></div>\n<div layout=\"row\" layout-md=\"column\" layout-align=\"center center\" flex><md-button type=\"button\" \nng-click=\"vm.reloadToken()\" class=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button>\n<md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInput.$invalid || basicForm.$pristine\">Submit</md-button></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/offboarding/reff-checklist/form-ref-check/form-ref-check.html","<md-dialog aria-label=\"Uplaod\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"FormInput\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,FormInput)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\"><md-input-container flex \nclass=\"input-height test\"><md-select ng-model=\"vm.Form.objForm.bu\" aria-label=\"approval_type\" name=\"bu\" required>\n<md-option ng-repeat=\"ls in vm.bu\" placeholder=\"Business Unit\" value=\"{{ls.description}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"FormInput.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBusiness unit is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"FormInput.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Description is required.\n</span></div></div></md-input-container><md-input-container flex class=\"input-height test\"><md-select \nng-model=\"vm.Form.objForm.approvalType\" aria-label=\"approval_type\" name=\"approval_type\" required><md-option \nng-repeat=\"ls in vm.approvalType\" placeholder=\"Approval Type\" value=\"{{ls.description}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"FormInput.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nApproval type is required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"FormInput.$invalid || FormInput.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/offboarding/reff-checklist/form-approval_type/form-approval-type.html","<md-dialog aria-label=\"Uplaod\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"FormInput\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,FormInput)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>{{vm.title}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout-gt-sm=\"row\"><input type=\"hidden\" name=\"id\" ng-model=\"vm.Form.objForm.id\"><md-input-container flex><input \ntype=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required><div \nng-messages=\"FormInput.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Description is required.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"FormInput.$invalid || FormInput.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/offboarding/registration/form-registration/form-employee-registration.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Submit Offboarding</md-subheader><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-16 light-blue-bg\" layout=\"row\" flex layout-align=\"center center\"><div class=\"pt-8 pb-8\" layout=\"row\" \nlayout-align=\"space-between center\" flex><div><md-icon md-font-icon=\"icon-alert\" class=\"s48 hint-text\"></md-icon></div>\n<div class=\"pl-8\" layout=\"column\" layout-align=\"center center\"><span class=\"font-weight-500 secondary-text\" \ntranslate=\"ATTENDANCE.OFFBOARDING.MESSAGE.MESSHEADER\">\nIf your submission is less than one month. You will not get the paklaring</span></div></div></ms-widget-front>\n</ms-widget><form name=\"formInput\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event, formInput)\"><div \nlayout-xs=\"column\" layout=\"row\" class=\"m-10\" layout-align=\"center center\"><div layout=\"column\" flex-gt-sm=\"90\" \nclass=\"form-wrapper md-whiteframe-1dp\"><div layout-xs=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \nng-model=\"vm.Form.objForm.nik\" required placeholder=\"{{ \'KPI.LABEL.NIK\' | translate}}\"><div \nng-messages=\"formInput.receipt_date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'KPI.LABEL.NIK\' | translate}} {{ \'MYPROFILE.MESSAGE.ISREQUIRED\' | translate}}</span></div></div>\n</md-input-container><md-input-container flex><input ng-model=\"vm.nama\" \nplaceholder=\"{{ \'KPI.LABEL.NAME\' | translate}}\"></md-input-container><md-input-container flex><input \nng-model=\"vm.job_title\" placeholder=\"{{ \'UMUT.MENU.JOBTITLE\' | translate}}\"></md-input-container></div><div \nlayout-xs=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input ng-model=\"vm.emp_category\" \nplaceholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.EMPCATEGORY\' | translate}}\"></md-input-container><md-input-container \nflex><input ng-model=\"vm.Form.objForm.grade\" placeholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.EMPGRADE\' | translate}}\">\n</md-input-container><md-input-container flex><input ng-model=\"vm.Form.objForm.direct_report\" \nplaceholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.DIRECTREPORT\' | translate}}\"></md-input-container><md-input-container \nflex><input ng-model=\"vm.effectiveDate\" placeholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.DATEJOIN\' | translate}}\">\n</md-input-container></div><div layout-xs=\"column\" layout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"30\"><md-select \nng-model=\"vm.Form.objForm.reason\" name=\"reason\" required><md-option ng-repeat=\"ls in vm.reason\" \nplaceholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.REASON\' | translate}}\" value=\"{{ls}}\">{{ls}}</md-option></md-select>\n</md-input-container><md-input-container flex-gt-sm=\"30\"><label>\n{{ \'ATTENDANCE.OFFBOARDING.LABEL.EFFECTIVEDATE\' | translate}}</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.effectiveDate\" name=\"effectiveDate\" required \nplaceholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.EFFECTIVEDATE\' | translate}}\" md-open-on-focus></md-datepicker>\n</md-input-container></div><md-input-container class=\"row\"><label>\n{{ \'ATTENDANCE.OFFBOARDING.LABEL.REASONDESCRIPTION\' | translate}}</label><br><br><textarea \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.Form.objForm.reasonDescription\" max-rows=\"5\" required></textarea><div \nng-messages=\"formInput.reasonDescription.$error\" role=\"alert\"><div ng-message=\"required\"><span>Effective Date</span>\n</div></div></md-input-container><md-input-container md-no-float class=\"md-block\"><label>\n{{ \'ATTENDANCE.OFFBOARDING.LABEL.REGISTRATIONLETTER\' | translate}}</label><div><input \naccept=\"image/png, image/jpg, image/jpeg, image/jpg, application/pdf\" type=\"file\" ng-model=\"vm.Form.objForm.file\" \nnv-file-select=\"\" uploader=\"vm.uploader\" placeholder=\"Resignation Letter\" \noptions=\"{ formData: [{\n                                                            nik:vm.Form.objForm.nik, \n                                                            effectiveDate:(vm.Form.objForm.effectiveDate|date:\'yyyy-MM-dd\')\n                                                         }]}\" \nng-upload-change=\"vm.changeFile($event)\"><div ng-messages=\"certForm.uploadPhoto.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-if=\"vm.sizefile>2097152\"><span>\n{{ \'ATTENDANCE.OFFBOARDING.MESSAGE.MAXUPLOAD2MB\' | translate}}</span></div></div><span \nstyle=\"color:red;font-style: italic\">Resignation Letter Is Required</span></div></md-input-container><div layout=\"row\" \nlayout-md=\"column\" layout-align=\"center center\" flex><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"!vm.canUpdate || formInput.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"button\" \nui-sref=\"app.input_ofb_employee_registration\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Reload\">\n{{ \'ATTENDANCE.OFFBOARDING.LABEL.BACK\' | translate}}</md-button></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget></div>\n</div></form></div></md-content></div>");
$templateCache.put("app/main/offboarding/registration/form-registration/form-registration.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Submit Team Offboarding</md-subheader><div layout-xs=\"column\" layout=\"row\" class=\"m-10\" \nlayout-align=\"center center\" ng-if=\"vm.type == \'admin\'\"><div layout=\"column\" flex-gt-sm=\"90\" \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadEmployee(1)\" \nnovalidate layout-align=\"center center\"><md-subheader class=\"white-bg\"><span \ntranslate=\"OFB.REGISTRATION_LIST.SELECT_EMPLOYEE\">Select Employee</span></md-subheader><div class=\"form-title\"><md-icon\n md-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data {{vm.type}}</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.loadDataDivision(vm.company)\" required><md-option ng-repeat=\"ls in vm.listBU\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.COMPANY\' | translate }}\" value=\"{{ls.company}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany field is required.</span></div></div></md-input-container><md-input-container flex><md-select \nng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DIVISI\' | translate }}\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div ng-messages=\"frmEmploye.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi field is required.</span></div></div></md-input-container><md-input-container \nflex><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listDepartment\" \nplaceholder=\"{{ \'MENU.CB.ATTENDANCES.INDEX.FILTER.DEPARTMENT\' | translate }}\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select><div ng-messages=\"frmEmploye.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment field is required.</span></div></div></md-input-container></div><div layout-gt-xs=\"row\" class=\"mt-40\">\n<md-input-container class=\"md-block\" layout-align=\"center and\"><md-button class=\"md-mini md-raised md-primary\" \ntype=\"submit\" ng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\">Submit</md-button></md-input-container></div>\n</form></div></div><div layout-xs=\"column\" layout=\"row\" class=\"m-10\" layout-align=\"center center\"><div layout=\"column\" \nflex-gt-sm=\"90\" class=\"form-wrapper md-whiteframe-1dp\"><form name=\"formInput\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData($event, formInput)\"><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadEmployee(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><span flex hide show-gt-sm></span><ms-search-bar \non-search=\"vm.loadEmployee(1)\" query=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th><span><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></span></th><th \ntranslate=\"OFB.REGISTRATION_LIST.NIK\">NIK</th><th translate=\"OFB.REGISTRATION_LIST.NAME\">NAME</th><th \ntranslate=\"OFB.REGISTRATION_LIST.JOB_TITLE\">JOB TITLE</th><th translate=\"OFB.REGISTRATION_LIST.EMP_CATEGORY\">\nEMP CATEGORY</th><th translate=\"OFB.REGISTRATION_LIST.GRADE\">GRADE</th><th \ntranslate=\"OFB.REGISTRATION_LIST.DIRECT_REPORT\">DIRECT REPORT</th><th translate=\"OFB.REGISTRATION_LIST.DATE_JOIN\">\nDATE JOIN</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td><span><input type=\"checkbox\" \nchecklist-model=\"vm.listEmployee\" checklist-value=\"ls\"></span></td><td class=\"text-center\">{{ls.nik}}</td><td>\n{{ls.nama}}</td><td>{{ls.job_title}}</td><td>{{ls.emp_category}}</td><td class=\"text-center\">{{ls.grade}}</td><td \nclass=\"text-center\">{{ls.direct_report}}</td><td>{{ls.join_date}}</td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}\n</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div><div layout=\"column\" flex \nclass=\"form-wrapper md-whiteframe-1dp\"><div layout-xs=\"column\" layout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"30\">\n<md-select ng-model=\"vm.Form.objForm.reason\" name=\"reason\" required><md-option ng-repeat=\"ls in vm.reason\" \nplaceholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.REASON\' | translate}}\" value=\"{{ls}}\">{{ls}}</md-option></md-select>\n</md-input-container><md-input-container flex-gt-sm=\"30\"><label>\n{{ \'ATTENDANCE.OFFBOARDING.LABEL.EFFECTIVETERMINATEDATE\' | translate}}</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.effectiveDate\" name=\"effectiveDate\" required \nplaceholder=\"{{ \'ATTENDANCE.OFFBOARDING.LABEL.EFFECTIVETERMINATEDATE\' | translate}}\" md-open-on-focus></md-datepicker>\n</md-input-container><md-input-container flex-offset-gt-sm=\"5\" flex-gt-sm=\"30\"><label>Chronology Letter</label><div>\n<input accept=\"image/png, image/jpg, image/jpeg, image/jpg, application/pdf\" type=\"file\" nv-file-select=\"\" \nuploader=\"vm.uploader\" placeholder=\"Resignation Letter\" \noptions=\"{ formData: [{\n                                        nik:vm.listNik, \n                                        effectiveDate:(vm.Form.objForm.effectiveDate|date:\'yyyy-MM-dd\')\n                                      }]}\" \nrequired><div ng-messages=\"certForm.uploadPhoto.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-if=\"vm.sizefile>2097152\"><span>{{ \'ATTENDANCE.OFFBOARDING.LABEL.MAXUPLOAD2MB\' | translate}}</span></div></div></div>\n</md-input-container></div><div layout-xs=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\n{{ \'ATTENDANCE.OFFBOARDING.LABEL.REASONDESCRIPTION\' | translate}}</label><br><br><textarea \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.Form.objForm.reasonDescription\" max-rows=\"5\" required></textarea><div \nng-messages=\"formInput.reasonDescription.$error\" role=\"alert\"><div ng-message=\"required\"><span>Effective Date</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-md=\"column\" layout-align=\"center center\" flex>\n<md-button type=\"button\" ng-click=\"vm.reloadToken()\" class=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">\nReload Token</md-button><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInput.$invalid || basicForm.$pristine\">Submit</md-button></div><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}</p></ms-widget-front></ms-widget></div>\n</form></div></div></div></md-content></div>");
$templateCache.put("app/main/payroll-pma/report/banktransferthr/banktransferthr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Bank Transfer THR</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExportBankTransfertoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Year</label>\n<md-select ng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Year is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadSBU(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Area</label><md-select ng-model=\"vm.Form.objForm.SBU\" \nng-required=\"true\" name=\"SBU\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSBU | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i>\nDownload Bank Transfer THR</md-button></div></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-pma/report/banktransfer/banktransfer.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Bank Transfer</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExportBankTransfertoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label>\n<md-select ng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadSBU(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Area</label><md-select ng-model=\"vm.Form.objForm.SBU\" \nng-required=\"true\" name=\"SBU\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listSBU | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i>\nDownload Bank Transfer</md-button></div></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-pma/report/estimasigaji/estimasigaji.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Estimasi Gaji</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExportEstimasiGajitoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container><label>Filter By</label>\n<md-select ng-model=\"vm.filterType\" name=\"filterType\" ng-change=\"vm.setFilter()\" required><md-option \nng-repeat=\"ls in vm.listfilterType\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.filterType.$error\" role=\"alert\"><div ng-message=\"required\"><span>filterType is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container ng-if=\"vm.filterType==\'by_date\'\" flex><label>Date</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.date\" placeholder=\"date\" required name=\"date\"></md-datepicker><div \nng-messages=\"SalcomForm.date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal Harus Diisi.</span></div>\n</div></md-input-container><md-input-container ng-if=\"vm.filterType==\'by_period\'\" flex><label>Period</label><md-select \nng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listPeriod\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPeriod is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadSpecificArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nng-model=\"vm.area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\" ng-required=\"vm.reqArea\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download</md-button>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-pma/report/jurnalgaji/jurnalgaji.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Jurnal Gaji</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExportJurnalGajitoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Area</label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Jurnal Gaji</md-button></form></div></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/payroll-pma/report/laporangaji/laporangaji.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Laporan Gaji</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Divisi</label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label>\nDepartment</label><md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label>Area\n</label><md-select ng-model=\"vm.area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download Laporan Gaji\n</md-button></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-pma/report/laporangajidetail/laporangajidetail.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Laporan Gaji Detail</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Area</label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Laporan Gaji</md-button></form></div></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/payroll-pma/report/laporanthr/laporanthr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Laporan THR</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanThrtoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Tahun</label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Area</label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Laporan THR</md-button></form></div></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/payroll-pma/report/rekapgaji/rekapgaji.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Rekap Gaji</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExportRekapGajitoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Area</label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Rekap Gaji</md-button></form></div></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/payroll-pma/report/reportcost/reportcost.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Report Cost</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExportReportCosttoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Start Period\n</label><md-select ng-model=\"vm.startPeriod\" name=\"startPeriod\" required><md-option ng-repeat=\"ls in vm.listperiod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.startPeriod.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Start Period Start is required.</span></div></div></md-input-container><md-input-container\n flex><label>End Period</label><md-select ng-model=\"vm.endPeriod\" name=\"endPeriod\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.endPeriod.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Period is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Company</label><md-select ng-model=\"vm.company\" \nname=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Division</label><md-select ng-model=\"vm.division\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a sub division...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"division\">\n<md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDivision is required.</span></div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" \nname=\"wilayah\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nmultiple=\"{{true}}\" ng-model=\"vm.area\" name=\"area\" ng-change=\"vm.selectArea(vm.area)\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option ng-value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container></div><md-button type=\"button\" \nng-click=\"vm.viewReportCosttoExcel($event,SalcomForm)\" class=\"md-mini md-raised md-primary\" aria-label=\"Button\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> View Report Cost\n</md-button><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download Report Cost\n</md-button><md-checkbox class=\"md-secondary\" ng-model=\"vm.cost\">Include Offline Cost</md-checkbox></form></div></div>\n<div class=\"form-wrapper has-wrapper-coloum\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><tbody><tr \nng-repeat=\"row in vm.listData\"><td class=\"{{ $index==0 ? \'text-left\' : \'text-right\' }}\" \nng-repeat=\"col in row.cols track by $index\">{{col.data}}</td></tr></tbody></table></div></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/payroll-pma/report/reportcostarea/reportcostarea.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Report Cost Per Area</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack name=\"SalcomForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.ExportReportCosttoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Division</label><md-select ng-model=\"vm.division\" \nname=\"area\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub division...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"division\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listDivision | filter:vm.searchTerm\">{{ls.description}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.division.$error\" role=\"alert\"><div ng-message=\"required\"><span>Division is required.</span>\n</div></div></md-input-container></div><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\">\n</md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Regional</label><md-select ng-model=\"vm.regional\" name=\"regional\" \nmd-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\">\n<input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label>Area</label><md-select \nmultiple=\"{{true}}\" ng-model=\"vm.area\" ng-change=\"vm.selectArea(vm.area)\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"subarea\"><md-option ng-value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container></div><md-button type=\"button\" \nng-click=\"vm.viewReportCosttoExcel($event,SalcomForm)\" class=\"md-mini md-raised md-primary\" aria-label=\"Button\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\">View</md-button><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download</md-button><md-checkbox class=\"md-secondary\" ng-model=\"vm.cost\">\nInclude Offline Cost</md-checkbox></form></div></div><div class=\"form-wrapper has-wrapper-coloum\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><tbody><tr ng-repeat=\"row in vm.listData\"><td \nclass=\"{{ $index==0 ? \'text-left\' : \'text-right\' }} {{col.isHead==\'1\' ? \'head-color\' : \'\'}}\" \nng-repeat=\"col in row.cols track by $index\">{{col.data}}</td></tr></tbody></table></div></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/payroll/laporanprosespayroll/payrolldetails/payrolldetails.html","<div class=\"page-layout simple fullwidth\" id=\"input\" layout=\"column\"><div class=\"header header-talent\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-cog\"></md-icon></span><span class=\"logo-text\"><span>\nPayroll Component Detail</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div>\n<div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"></div></div></div><div class=\"content\" \nid=\"contentSetPotentialMember\"><div class=\"md-whiteframe-4dp\" id=\"inputView\" layout=\"column\"><div layout=\"row\"><div \nflex layout=\"column\" style=\"padding: 7px\"><div layout=\"row\"><div flex=\"20\"><b>NIK</b></div><div flex=\"50\"><b>\n: {{vm.payrollview[0][0].id_employee}}</b></div></div><div layout=\"row\"><div flex=\"20\"><b>NAME</b></div><div flex=\"50\">\n<b>\n: {{vm.payrollview[0][0].first_name + \' \' + vm.payrollview[0][0].middle_name + \' \' + vm.payrollview[0][0].last_name}}\n</b></div></div><div layout=\"row\"><div flex=\"20\"><b>AREA</b></div><div flex=\"50\"><b>\n: {{vm.payrollview[0][0].BenefitCode}}</b></div></div></div><div flex layout=\"row\" style=\"text-align: right\"><md-button\n class=\"md-raised\" ui-sref=\"app.payroll_payrollv\" style=\"width: 200px; height: 39px\">Back</md-button></div></div>\n<ms-widget class=\"fade\" flippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nclass=\"s16\" md-font-icon=\"icon-alert\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><table \nclass=\"simple\" id=\"inputTable\" ms-responsive-table=\"\"><thead><tr><th>No</th><th>Code</th><th>Description</th><th>Amount\n</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.payrollview[0]\"><td align=\"center\">{{($index + 1)}}</td><td \nalign=\"center\">{{ls.code}}</td><td align=\"center\">{{ls.description}}</td><td align=\"center\">\n{{ls.amount | currency:\"Rp. \"}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/mpn/request/views/edit-mpn-request.html","<style type=\"text/css\">\n.ms-stepper .ms-stepper-horizontal .ms-stepper-navigation-wrapper .ms-stepper-navigation .ms-stepper-navigation-item {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        position: relative;\n        height: 50px;\n        min-height: 50px;\n        max-height: 72px;\n        line-height: 24px;\n        margin: 0;\n        padding: 0px;\n        border-radius: 0;\n        cursor: pointer;\n        font-size: 14px;\n        text-transform: none;\n    }\n    \n    .ms-stepper .ms-stepper-horizontal .ms-stepper-navigation-wrapper .ms-stepper-navigation {\n        height: 50px;\n        min-height: 50px;\n    }\n    \n    .ms-stepper .ms-stepper-horizontal .ms-stepper-navigation-wrapper .ms-stepper-navigation .ms-stepper-navigation-item::before,\n    .ms-stepper .ms-stepper-horizontal .ms-stepper-navigation-wrapper .ms-stepper-navigation .ms-stepper-navigation-item::after {\n        content: \'\';\n        display: block;\n        position: absolute;\n        top: 50%;\n        width: 0px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    }\n    \n    .ms-stepper-steps {\n        margin-top: 20px;\n    }\n    \n    md-toolbar {\n        max-height: 60px;\n        min-height: 60px;\n        background: #ffffff !important;\n    }\n</style><div id=\"header-action\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" \nlayout=\"column\" style=\"margin: 10px\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"border-bottom: 1px solid #b6b6b680\"><md-toolbar md-theme=\"table-toolbar-theme\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"margin: 5px\"><md-button class=\"md-raised reference-button\" ui-sref=\"app.mpn\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><span>Cancel</span></md-button></div></md-toolbar></div><form \nname=\"horizontalStepper\" ms-horizontal-stepper ng-submit=\"vm.saveData()\" ng-model=\"vm.mpnRequest\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"1\" step-title=\"\'Position Title\'\"><div \nng-include=\"\'app/main/mpn/request/views/steps/step-position-title.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"2\" step-title=\"\'Budget Type\'\"><div \nng-include=\"\'app/main/mpn/request/views/steps/step-budget-type.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep1\" step=\"3\" step-title=\"\'Reason\'\"><div \nng-include=\"\'app/main/mpn/request/views/steps/step-reason.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep5\" step=\"4\" step-title=\"\'Grade & Work Location\'\"><div \nng-include=\"\'app/main/mpn/request/views/steps/step-grade-work-location.edit.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep3\" \nhide-step=\"vm.hide_grade() || (horizontalStep1.quantity_replacement.$touched && vm.mpnRequest.quantity_replacement <= 0)\" \nstep=\"5\" step-title=\"\'Incumbent Details\'\"><div ng-include=\"\'app/main/mpn/request/views/steps/step-quantity.html\'\">\n</div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"horizontalStep6\" step=\"6\" \nstep-title=\"\'Responsibilities\'\"><div ng-include=\"\'app/main/mpn/request/views/steps/step-responsibilities.html\'\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"horizontalStep7\" step=\"7\" \nstep-title=\"\'Qualification\'\"><div ng-include=\"\'app/main/mpn/request/views/steps/step-qualification.html\'\"></div>\n</ms-horizontal-stepper-step></form></div></div>");
$templateCache.put("app/main/mpn/request/views/index.html","<style>\n.with-toolbar-content md-toolbar {\n        max-height: 60px;\n        min-height: 60px;\n        background: #ffffff !important;\n    }\n    \n    .mpn-completed {\n        font-style: italic;\n        background: #e9ffe7 !important;\n    }\n</style><div id=\"header-action\" class=\"page-layout simple fullwidth with-toolbar-content\" layout=\"column\"><div \nclass=\"content\"><div layout=\"row\" layout-align=\"start center\"><md-toolbar md-theme=\"table-toolbar-theme\"><div \nlayout=\"row\" layout-align=\"start center\" style=\"margin: 5px\"><md-input-container hide show-gt-sm><select name=\"see\" \nid=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\">\n</select><span class=\"secondary-text\">Entries</span></md-input-container><md-button \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-click=\"vm.createMPN($event);\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span>Create MPN</span></md-button><md-button \nclass=\"md-raised reference-button md-warn md-hue-2\" ng-click=\"vm.deleteRequest($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span>Delete MPN</span></md-button></div></md-toolbar></div><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"model.allItemsSelected\" ng-change=\"selectAll()\"></div></th><th>\nMPN NUMBER</th><th>BUSINESS TITLE</th><th>BUDGET TYPE</th><th>APPROVAL STATUS</th><th>REQUEST DATE</th><th>\nAPPROVAL DATE</th><th>LEAD TIME (Days)</th><th>REQUEST QTY</th><th>TOTAL JOIN</th><th>#</th></tr></thead><tbody><tr \nng-repeat=\"div in vm.DataTable.list\" ng-class=\"div.mpn_class\"><td><input type=\"checkbox\" \nng-if=\"div.current_status == \'Draft\'\" ng-model=\"div.isChecked\" ng-change=\"selectEntity()\"></td><td>{{ div.mpn_number }}\n</td><td>{{ div.business_title_text }}</td><td>{{ div.budget_type}}</td><td>{{ div.approval_status}}</td><td>\n{{ formatDate(div.created_at) | date:\'dd-MM-yyyy\' }}</td><td>{{ formatDate(div.app_date) | date:\'dd-MM-yyyy\' }}</td>\n<td>{{ div.lead_time}}</td><td>{{ parseInt(div.quantity_replacement) + parseInt(div.quantity_new_position) }}</td><td>\n<md-button ng-if=\"div.total_join > 0\" aria-label=\"Total Employee Joined\" class=\"md-icon-button blue-500-fg\" \nng-click=\"vm.showJoinedDetail(div.mpn_number, $event)\">{{ div.total_join }}<md-tooltip><span>Total Employee Joined\n</span></md-tooltip></md-button></td><td><md-button aria-label=\"View Request\" class=\"md-icon-button\" \nng-click=\"vm.viewDetail(div.id)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>View Request</span></md-tooltip></md-button><md-button \nng-if=\"div.current_status == \'Draft\' || div.current_status == \'Revision\'\" aria-label=\"Edit Request\" \nclass=\"md-icon-button\" ng-click=\"vm.editData(div.id)\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>Edit Request</span></md-tooltip></md-button>\n</td></tr></tbody></table><div class=\"p-24 table-paging-area\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div>");
$templateCache.put("app/main/mpn/request/views/input-mpn-request.html","<style type=\"text/css\">\n.ms-stepper .ms-stepper-horizontal .ms-stepper-navigation-wrapper .ms-stepper-navigation .ms-stepper-navigation-item {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        position: relative;\n        height: 50px;\n        min-height: 50px;\n        max-height: 72px;\n        line-height: 24px;\n        margin: 0;\n        padding: 0px;\n        border-radius: 0;\n        cursor: pointer;\n        font-size: 14px;\n        text-transform: none;\n    }\n    \n    .ms-stepper .ms-stepper-horizontal .ms-stepper-navigation-wrapper .ms-stepper-navigation {\n        height: 50px;\n        min-height: 50px;\n    }\n    \n    .ms-stepper .ms-stepper-horizontal .ms-stepper-navigation-wrapper .ms-stepper-navigation .ms-stepper-navigation-item::before,\n    .ms-stepper .ms-stepper-horizontal .ms-stepper-navigation-wrapper .ms-stepper-navigation .ms-stepper-navigation-item::after {\n        content: \'\';\n        display: block;\n        position: absolute;\n        top: 50%;\n        width: 0px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    }\n    \n    .ms-stepper-steps {\n        margin-top: 20px;\n    }\n    \n    md-toolbar {\n        max-height: 60px;\n        min-height: 60px;\n        background: #ffffff !important;\n    }\n</style><div id=\"header-action\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" \nlayout=\"column\" style=\"margin: 10px\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"border-bottom: 1px solid #b6b6b680\"><md-toolbar md-theme=\"table-toolbar-theme\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"margin: 5px\"><md-button class=\"md-raised reference-button\" ui-sref=\"app.mpn\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><span>Cancel</span></md-button></div></md-toolbar></div><form \nname=\"horizontalStepper\" ms-horizontal-stepper ng-submit=\"vm.saveData()\" ng-model=\"vm.mpnRequest\" novalidate>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"1\" step-title=\"\'Position Title\'\"><div \nng-include=\"\'app/main/mpn/request/views/steps/step-position-title.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"2\" step-title=\"\'Budget Type\'\"><div \nng-include=\"\'app/main/mpn/request/views/steps/step-budget-type.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep1\" step=\"3\" step-title=\"\'Reason\'\"><div \nng-include=\"\'app/main/mpn/request/views/steps/step-reason.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep5\" step=\"4\" step-title=\"\'Grade & Work Location\'\"><div \nng-include=\"\'app/main/mpn/request/views/steps/step-grade-work-location.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep3\" \nhide-step=\"vm.hide_grade() || (horizontalStep1.quantity_replacement.$touched && vm.mpnRequest.quantity_replacement <= 0)\" \nstep=\"5\" step-title=\"\'Incumbent Details\'\"><div ng-include=\"\'app/main/mpn/request/views/steps/step-quantity.html\'\">\n</div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"horizontalStep6\" step=\"6\" \nstep-title=\"\'Responsibilities\'\"><div ng-include=\"\'app/main/mpn/request/views/steps/step-responsibilities.html\'\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"horizontalStep7\" step=\"7\" \nstep-title=\"\'Qualification\'\"><div ng-include=\"\'app/main/mpn/request/views/steps/step-qualification.html\'\"></div>\n</ms-horizontal-stepper-step></form></div></div>");
$templateCache.put("app/main/mpn/request/views/join-detail.html","<md-dialog aria-label=\"List Joined Employee\" style=\"width: 70%\"><form ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>List Joined Employee</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><table \nclass=\"with-toolbar dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">NIK</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">JOIN DATE</span></div></th></tr></thead><tbody><tr \nng-repeat=\"e in vm.listEmployee\"><td>{{ ($index + 1) }}</td><td>{{ e.nik }}</td><td>{{ e.full_name }}</td><td>\n{{ e.date_join }}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.cancel()\">close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mpn/request/views/view-mpn-request.html","<div id=\"mpn\" class=\"content\"><div class=\"md-whiteframe-4dp\" id=\"inputView\" layout=\"column\"><md-toolbar \nmd-theme=\"table-toolbar-theme\" style=\"background-color:white\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"vm.request.id == null || vm.request.current_status == \'Draft\' || vm.request.current_status == \'Revision\' \" \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-click=\"vm.publishRequest();\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><span>Submit for Approval</span></md-button><md-button \nng-if=\"vm.request.id != null && vm.request.current_status == \'Revision\'\" \nclass=\"md-raised reference-button md-accent md-hue-3\" ng-click=\"vm.editRequest();\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span>Edit Request</span></md-button><md-button ng-if=\"vm.reset_approval\" \nclass=\"md-raised reference-button md-primary\" ng-click=\"vm.approveResetSLT($event);\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve Reset SLT</span></md-button><md-button ng-if=\"vm.reset_approval\" \nclass=\"md-raised reference-button md-accent md-warn\" ng-click=\"vm.rejectResetSLT($event);\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><span>Reject Reset SLT</span></md-button><md-button \nclass=\"md-raised reference-button md-info md-hue-2\" ui-sref=\"app.mpn\"><md-icon md-font-icon=\"icon-home\"></md-icon>\n<span>Back</span></md-button><md-button ng-if=\"vm.request.id != null\" \nclass=\"md-raised reference-button md-info md-hue-2\" ng-click=\"vm.Pdf();\"><span>Print</span></md-button></div>\n</md-toolbar><div layout=\"row\" ng-init=\"total = 0\"><table class=\"simple approval\"><tr><td colspan=\"5\"><span \nclass=\"text-bold\">Approval Status ({{vm.request.budget_type}} by MPP)</span></td></tr><tr><th style=\"width: 45px\">No\n</th><th>Section</th><th>Status</th><th>Issued Date<br></th><th>Lead Time</th></tr><tr><td>1</td><td>\nREQUESTOR ( {{ vm.request.created_by | uppercase }} - {{ vm.request.creator | uppercase }} )</td><td \nstyle=\"font-weight: bold\">Requested &nbsp;<label ng-class=\"waiting-approval\" \nng-if=\"vm.request.current_status == \'Draft\' \">Waiting For Submit</label></td><td style=\"text-align: center\">\n{{ formatDate(vm.request.created_at) | date : \'dd MMMM yyyy, HH:mm\'}}</td><td>-</td></tr><tr \nng-repeat=\"a in vm.mpn_approval\"><td>{{$index + 2}}</td><td>\n{{a.group | uppercase }} ( {{a.approved_by | uppercase }} - {{a.approver | uppercase }} )<div \nng-if=\"a.delegate != null\" style=\"font-size: 11px;font-style: italic;font-weight: bold\">\nDelegated to {{a.delegate}} - {{a.delegated}}</div></td><td style=\"font-weight: bold\"><label \nng-if=\"a.approval_status === \'1\' && vm.request.current_status == \'Waiting Approval\' \" \nng-class=\"a.approval_status === \'1\'? \'waiting-approval\' : \'\'\">Waiting Approval</label><label \nng-if=\"a.approval_status === \'2\'\">Approved</label><label ng-if=\"a.approval_status === \'3\'\">Revised</label><label \nng-if=\"a.approval_status === \'4\'\">Rejected</label></td><td style=\"text-align: center\">\n{{ formatDate(a.approved_date) | date : \'dd MMMM yyyy, HH:mm\' }}</td><td \nng-init=\"$parent.total = $parent.total + a.lead_time\">{{a.lead_time}} days</td></tr><tr><td \nstyle=\"font-weight: bold;text-align: right\" colspan=\"4\">Total Lead Time</td><td>{{vm.total_lead_time}} days</td></tr>\n<tr ng-if=\"vm.request.is_slt_reset > 0\"><td colspan=\"5\"><table class=\"simple approval\" \nng-repeat=\"item in vm.mpn_reset_slt\"><tr><th colspan=\"5\"><span class=\"text-bold\">\nApproval Status (Reset SLT {{$index+1}})</span></th></tr><tr><th style=\"width: 45px\">No</th><th>Section</th><th>Status\n</th><th>Issued Date</th><th>Lead Time</th></tr><tr><td>1</td><td>Requestor ( {{ item.request_by }} - {{ item.nama }} )\n</td><td style=\"font-weight: bold\">Requested</td><td style=\"text-align: center\">{{ item.timestamp }}</td><td>-</td>\n</tr><tr ng-repeat=\"itemApproval in item.approval\"><td>{{$index+2}}</td><td>\n{{itemApproval.POSITION}} ( {{ itemApproval.approved_by }} - {{ itemApproval.nama }} )</td><td \nstyle=\"font-weight: bold\"><div ng-switch=\"itemApproval.approval_status\"><div ng-switch-when=\"0\"><div class=\"info\">None\n</div></div><div ng-switch-when=\"1\"><div class=\"info\">Waiting Approval</div></div><div ng-switch-when=\"2\"><div \nclass=\"info\">Approved</div></div><div ng-switch-when=\"3\"><div class=\"info\">Revert</div></div><div ng-switch-when=\"4\">\n<div class=\"info\">Rejected</div></div></div></td><td style=\"text-align: center\">{{ itemApproval.approval_date }}</td>\n<td>{{itemApproval.lt}}</td></tr><tr><td style=\"font-weight: bold;text-align: right\" colspan=\"4\">Total Lead Time</td>\n<td>{{item.lt}}</td></tr></table></td></tr><tr><td colspan=\"5\">&nbsp;</td></tr><tr><td colspan=\"5\" \nstyle=\"font-size: 10px\"><span class=\"bold\" style=\"font-size: 13px;font-style: italic;font-weight: normal\">\nThings you need to know, Standard Lead time (in days)</span><table class=\"grade-info\" \nstyle=\"width: 100%;font-size: 11px;margin-bottom: 10px;margin-top: 10px\"><tbody><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 1</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">21 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 2</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">35 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 3</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">56 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 4</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">70 days</td></tr><tr><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">Grade 5 above</td><td \nstyle=\"padding: 0px 7px !important;border-bottom: 1px solid #cfd8dc\">112 days</td></tr></tbody></table><span \nclass=\"bold\" style=\"font-size: 13px;font-style: italic;font-weight: normal;margin-top: 8px\">\nThe process could be faster/longer depends on the users and candidates availability for interview schedule.</span></td>\n</tr></table></div><div layout=\"row\" style=\"margin-top:20px\"><table class=\"simple position-detail\" style=\"width: 100%\">\n<colgroup><col style=\"width: 150px\"><col style=\"width: 233px\"><col style=\"width: 10px\"><col style=\"width: 150px\"><col \nstyle=\"width: 27px\"><col style=\"width: 27px\"><col style=\"width: 27px\"><col style=\"width: 27px\"><col \nstyle=\"width: 27px\"><col style=\"width: 33px\"></colgroup><tr><th class=\"bold\" colspan=\"10\">POSITION DETAILS</th></tr>\n<tr><td class=\"bold\">Division / Department</td><td>{{vm.request.division}} / {{vm.request.department}}</td><td \nrowspan=\"10\"><br></td><td class=\"bold\" colspan=\"7\">Budget Type</td></tr><tr><td class=\"bold\">Business Title</td><td>\n{{vm.request.business_title_text}}</td><td>{{vm.request.budget_type}}</td><td colspan=\"6\">\n{{vm.request.replacement_type}}</td></tr><tr><td class=\"bold\">Quantity</td><td>\n{{vm.request.quantity_replacement + vm.request.quantity_new_position }} ( Replacement = {{vm.request.quantity_replacement}}, New Position = {{vm.request.quantity_new_position}} )\n</td><td colspan=\"7\"></td></tr><tr><td rowspan=\"7\" colspan=\"2\" style=\"vertical-align: top;padding: 0px !important\">\n<table style=\"table-layout: fixed; width: 100%\"><colgroup><col style=\"width: 153px\"><col style=\"width: 73px\"><col \nstyle=\"width: 25px\"><col style=\"width: 25px\"><col style=\"width: 25px\"></colgroup><tr><td class=\"bold\" rowspan=\"2\">\nGeneral Worker</td><td>Grade 1</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'1A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'1B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'1C\' ? \'grade\' : \'\'\">C</td></tr><tr><td>Grade 2</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'2C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\">Staff</td><td>Grade 3</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'3A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'3B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'3C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\">Supervisory</td><td>Grade 4</td>\n<td style=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'4A\' ? \'grade\' : \'\'\">A</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'4B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'4C\' ? \'grade\' : \'\'\">C</td></tr><tr><td class=\"bold\" rowspan=\"2\">Managerial</td><td>\nGrade 5</td><td style=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'5A\' ? \'grade\' : \'\'\">A</td><td \nstyle=\"text-align: center\" ng-class=\"vm.request.emp_grade == \'5B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'5C\' ? \'grade\' : \'\'\">C</td></tr><tr><td>Grade 6</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6A\' ? \'grade\' : \'\'\">A</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6B\' ? \'grade\' : \'\'\">B</td><td style=\"text-align: center\" \nng-class=\"vm.request.emp_grade == \'6C\' ? \'grade\' : \'\'\">C</td></tr></table></td><td class=\"bold\">Work Location</td><td \ncolspan=\"6\">{{vm.request.location}}</td></tr><tr><td class=\"bold\">Employee Status</td><td colspan=\"6\">\n{{vm.request.employment_status}}</td></tr><tr><td class=\"bold\">Preferrable Gender</td><td colspan=\"6\">\n{{vm.request.pref_gender}}</td></tr><tr><td class=\"bold\">Expected Join Date</td><td colspan=\"6\">\n{{ formatDate(vm.request.expected_join_date) | date : \"dd MMMM yyyy\"}}</td></tr><tr><td colspan=\"7\" rowspan=\"3\" \nstyle=\"vertical-align: top\"><table style=\"width: 100%\"><colgroup><col style=\"width: 144px\"><col style=\"width: 147px\">\n<col style=\"width: 96px\"><col style=\"width: 180px\"></colgroup><tr><th class=\"tg-88nc bold\" colspan=\"2\">Experience</th>\n<th class=\"tg-88nc bold\" colspan=\"2\">Fresh Graduated</th></tr><tr><td class=\"tg-us36 bold\">Year of experience</td><td \nclass=\"tg-us36\"><div ng-if=\"vm.request.year_experience > 0\">{{vm.request.year_experience}} Years</div><div \nng-if=\"vm.request.exp != \'\'\">{{vm.request.exp}}</div></td><td class=\"tg-us36 bold\">Education</td><td class=\"tg-us36\">\n{{vm.request.education}}</td></tr><tr><td class=\"tg-us36 bold\">Age range</td><td class=\"tg-us36\"><div \nng-if=\"vm.request.age_min > 0 && vm.request.age_max > 0\">{{vm.request.age_min}} - {{vm.request.age_max}}</div></td><td \nclass=\"tg-us36 bold\">Major</td><td class=\"tg-us36 bold\">{{vm.request.major}}</td></tr><tr><td class=\"tg-us36 bold\">Note\n</td><td class=\"tg-us36\" colspan=\"3\"><div ng-bind-html=\"vm.request.qualification_note\"></div></td></tr></table></td>\n</tr><tr></tr><div class=\"page-break\"></div><tr></tr><tr style=\"height: 20px\"></tr><tr><th class=\"bold\" colspan=\"10\">\nRESPONSIBILITIES</th></tr><tr><td class=\"bold\">Job Code</td><td colspan=\"9\">{{vm.request.job_code_text}}</td></tr><tr>\n<td colspan=\"10\" style=\"padding: 0px !important\"><div layout=\"row\" style=\"border-bottom: 1px solid #e0e0e0\"><div flex \nstyle=\"padding: 5px;background: #f8f8f8;text-align: center;font-weight: bold\">Short Job Description / Responsibilities\n</div><div flex \nstyle=\"padding: 5px;background: #f8f8f8;text-align: center;font-weight: bold;border-left: 1px solid #e0e0e0 ;padding-left: 8px\">\nFunctional Competencies</div></div><div layout=\"row\" style=\"margin-top:0px\"><div flex \nng-bind-html=\"vm.request.job_desc\" style=\"padding:10px\"></div><div flex ng-bind-html=\"vm.request.job_func\" \nstyle=\"padding:10px;border-left: 1px solid #e0e0e0 ;padding-left: 12px\"></div></div></td></tr><tr style=\"height: 20px\">\n</tr><tr><th class=\"bold\" colspan=\"10\">INCUMBENT DETAILS</th></tr><tr><td colspan=\"10\" style=\"padding: 0px !important\">\n<table class=\"simple\" style=\"width: 100%\"><tr><th style=\"background: #f8f8f8 !important\">NO</th><th \nstyle=\"background: #f8f8f8 !important\">NIK</th><th style=\"background: #f8f8f8 !important\">NAME</th><th \nstyle=\"background: #f8f8f8 !important\">POSITION</th><th style=\"background: #f8f8f8 !important\">REASON</th><th \nstyle=\"background: #f8f8f8 !important\">EFFECTIVE DATE</th></tr><tr ng-repeat=\"a in vm.replacement\"><td>{{$index + 1}}\n</td><td>{{a.employee.nik}}</td><td>{{a.employee.nama}}</td><td>{{a.employee.position}}</td><td>{{a.replacement_type}}\n</td><td>{{a.effective_date}}</td></tr></table></td></tr><tr style=\"height: 20px\"></tr><tr><td colspan=\"10\"><p><span \nclass=\"text-bold\">Notes</span></p><div class=\"note\" ng-repeat=\"item in vm.mpn_approval_history\"><div \nclass=\"note-title\">{{item.approval_status}} at {{vm.formatDate(item.approved_date) | date: \"dd MMMM yyyy, HH:mm\"}}\n</div><div class=\"note-detail\"><p>{{item.notes}}</p></div><div class=\"note-footer\"><p>\nCreated By {{item.app_nik}} - {{item.approver}}</p></div></div></td></tr></table></div><br><br><hr></div></div>");
$templateCache.put("app/main/payroll/report/banktransfer/banktransfer.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nBank Transfer</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportBankTransfertoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Area</label><md-select\n ng-model=\"vm.Form.objForm.SBU\" ng-required=\"true\" name=\"SBU\" required><md-option ng-repeat=\"s in vm.listSBU\" \nvalue=\"{{s.id}}\">{{s.name}}</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\"><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i>Download Bank Transfer\n</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/analisacostcentre/analisacostcentre.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nAnalisa Cost Centre</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExporttoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Period</label><md-select ng-model=\"vm.Form.objForm.period\" \nname=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n<div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i>\nDownload Analisa Cost Centre</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/daftarmutasi/daftarmutasi.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nDaftar dan Mutasi</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportDaftarMutasitoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Daftar & Mutasi</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/espttax/espttax.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>Espttax\n</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" \nlayout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\"><div \nid=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportEsptTaxtoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Period</label><md-select ng-model=\"vm.Form.objForm.period\" \nname=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n<div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">\n{{s.description}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i>Download ESPT Tax\n</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/formulirbpjs/formulirbpjs.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nFormulir BPJS</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportFormulirBPJStoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Formulir BPJS</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/gajicostcentre/gajicostcentre.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nGaji Per Cost Centre</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExporttoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Period</label><md-select ng-model=\"vm.Form.objForm.period\" \nname=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n<div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i>\nDownload Gaji Per Cost Centre</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/keluarbpjs/keluarbpjs.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nKeluar BPJS</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportKeluarBPJStoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Keluar BPJS</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/laporanbpjstk/laporanbpjstk.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nLaporan Detail BPJS</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportLaporanDetailBPJStoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Laporan Detail BPJS</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/laporangaji/laporangaji.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nLaporan Gaji</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.Form.objForm.company)\" \nrequired><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Divisi</label><md-select ng-model=\"vm.Form.objForm.divisi\" \nname=\"divisi\" ng-change=\"vm.LoadDepartment(vm.Form.objForm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" \nplaceholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container \nflex><label>Department</label><md-select ng-model=\"vm.Form.objForm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Area</label><md-select ng-model=\"vm.Form.objForm.area\" name=\"area\" required><md-option \nng-repeat=\"ls in vm.listarea\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container></div>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download Laporan Gaji\n</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/laporanlembur/laporanlembur.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nLaporan Lembur</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportLaporantoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Period</label><md-select ng-model=\"vm.Form.objForm.period\" \nname=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n<div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Laporan Lembur</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/laporanpajaka1/laporanpajaka1.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nLaporan Pajak 1721 A1</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div\n layout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container\"><div id=\"attView\"><form ng-cloack name=\"LaporanForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportLaporantoExcel($event,LaporanForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"LaporanForm.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"LaporanForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span>\n</div></div></md-input-container><md-input-container flex><label>KPP</label><md-select ng-model=\"vm.Form.objForm.kpp\" \nname=\"kpp\"><md-option ng-repeat=\"ls in vm.listkpp\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"LaporanForm.$invalid || LaporanForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download Laporan Pajak\n</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/laporanpajak/laporanpajak.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nLaporan Pajak 1721</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"LaporanForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportLaporantoExcel($event,LaporanForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"LaporanForm.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\nCompany</label><md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"LaporanForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span>\n</div></div></md-input-container><md-input-container flex><label>KPP</label><md-select ng-model=\"vm.Form.objForm.kpp\" \nname=\"kpp\"><md-option ng-repeat=\"ls in vm.listtaxloc\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"LaporanForm.$invalid || LaporanForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download Laporan Pajak\n</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/nonaktif/nonaktif.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>Non Aktif\n</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" \nlayout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\"><div \nid=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportNonAktiftoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Non Aktif</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/payslip/payslip.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>Payslip\n</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div layout=\"column\" \nlayout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\"><div \nid=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportPaysliptoPdf(SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label>Period</label><md-select ng-model=\"vm.Form.objForm.period\" \nname=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select>\n<div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.Form.objForm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.Form.objForm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Department</label><md-select \nng-model=\"vm.Form.objForm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container><md-input-container flex><label>Area</label>\n<md-select ng-model=\"vm.Form.objForm.area\" name=\"area\" required><md-option ng-repeat=\"ls in vm.listarea\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container></div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\">View Payslip</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/pendaftaranbpjs/pendaftaranbpjs.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nPendaftaran BPJS</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportPendaftaranBpjstoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Pendaftaran BPJS</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/perubahangaji/perubahangaji.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nPerubahan Gaji</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportPerubahanGajitoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Perubahan Gaji</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/perubahanupah/perubahanupah.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nPerubahan Upah</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportLaporanDetailBPJStoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> Download Perubahan Upah</md-button></form></div></div></div></div>");
$templateCache.put("app/main/payroll/report/sapreport/sapreport.html","<div id=\"header-action\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header nabati6\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\"><span>\nSAP Report</span></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"></div></div><div \nlayout=\"column\" layout-align=\"center start\"></div></div></div><div class=\"content\"><div class=\"simple-table-container\">\n<div id=\"attView\"><form ng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportSAPReporttoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>Period</label><md-select \nng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>Company</label>\n<md-select ng-model=\"vm.Form.objForm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Divisi</label><md-select ng-model=\"vm.Form.objForm.divisi\" name=\"divisi\"><md-option \nng-repeat=\"ls in vm.listdivisi\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container></div>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> Download SAP Report\n</md-button></form></div></div></div></div>");
$templateCache.put("app/main/pkwt/pkwt-rules/pkwt-rules-create/pkwt-rules-create.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll class=\"dialog-custom-wrapper\" flex=\"{{vm.flex}}\">\n<md-toolbar><div class=\"md-toolbar-tools title\"><h4>PKWT LOA Rules List</h4><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"margin-top:0px; min-height: 200px\"><div class=\"overlay\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-accent\"></md-progress-circular><div class=\"padding-top-10\">\nPlease wait ..</div></div></div><div layout=\"column\"><div layout=\"row\"><md-autocomplete flex-gt-sm \nclass=\"custom-autocomplete\" md-delay=\"1000\" md-no-cache=\"true\" md-clear-button=\"true\" md-floating-label=\"Position\" \nmd-selected-item=\"vm.tempPositionID\" md-selected-item-change=\"vm.selectedItemChange(item)\" ng-required=\"true\" \nmd-search-text=\"vm.searchText\" md-input-name=\"positionID\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"vm.getItemText(item)\" md-min-length=\"2\"><md-item-template><span class=\"item-title\" \nmd-highlight-text=\"vm.searchText\">{{item.positionID}} - {{item.description}}</span></md-item-template><md-not-found>\nNo Record matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete><md-input-container flex=\"20\">\n<label>Grade</label><md-select ng-change=\"vm.onChangeMain()\" ng-model=\"vm.grade\" name=\"grade\"><md-option \nng-repeat=\"item in vm.listGrade\" ng-value=\"item\">{{item}}</md-option></md-select></md-input-container><md-button \nng-click=\"vm.loadLoaBuilder()\" ng-disabled=\"!vm.positionID || !vm.grade\" class=\"md-accent md-raised\">Create Scheme\n</md-button></div><div class=\"table-container-content\" ng-if=\"vm.list.length > 0\"><table \nclass=\"simple bordered stripped\" ms-responsive-table><thead><tr><th>STATE</th><th>name</th><th>Type</th><th>\nMarital Status</th><th>Gender</th><th>Scale</th><th>Notes</th><th>LOA BINDING</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.list\"><td class=\"text-center\"><div flex layout=\"row\" layout-align=\"center\"><md-checkbox \nng-model=\"item.is_having\" aria-label=\"Checkbox\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox></div></td><td \nclass=\"text-center w-200\">{{item.cnb_name}}</td><td class=\"text-center\">{{item.value_type}}</td><td \nclass=\"text-center\"><select class=\"input-table\" ng-model=\"item.marital_status\" name=\"marital_status\"><option \nng-selected=\"item.marital_status == m\" ng-repeat=\"m in [\'required\', \'none\']\" ng-value=\"m\">{{m}}</option></select></td>\n<td class=\"text-center\"><select class=\"input-table\" ng-model=\"item.gender\" name=\"gender\"><option \nng-selected=\"item.gender == m\" ng-repeat=\"m in [\'P\', \'L\', \'B\']\" ng-value=\"m\">{{m}}</option></select></td><td \nclass=\"text-center\"><input class=\"input-table\" type=\"text\" name=\"besaran_value\" ng-model=\"item.besaran_value\"></td><td \nclass=\"text-center\"><input class=\"input-table\" type=\"text\" name=\"note\" ng-model=\"item.note\"></td><td \nclass=\"text-center\"><select class=\"input-table\" ng-model=\"item.loa_column_key\" name=\"loa_column_key\"><option \nng-selected=\"item.loa_column_key == m\" ng-repeat=\"m in vm.loaBindingList\" ng-value=\"m\">{{m}}</option></select></td>\n</tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-xs=\"column\" flex><div flex \nng-show=\"vm.isError\" class=\"form-message error\">{{vm.message}}</div><span flex></span><div flex=\"10\" \nlayout-align=\"end center\" layout=\"row\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.save($event)\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon>Save</md-button><md-button ng-click=\"vm.hide()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon>close</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pkwt/management-ta/update-form/update-form.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" class=\"dialog-custom-wrapper\" ms-scroll flex=\"80\"><form \nng-cloak name=\"formPkwt\" novalidate><md-toolbar><div class=\"md-toolbar-tools title\"><h4>\nUPDATE PKWT {{vm.data.nik}} - {{vm.data.name}}</h4><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"margin-top:0px\" layout-padding><div class=\"overlay\" ng-show=\"vm.isLoading\"><div \nflex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\"><md-progress-circular \nmd-diameter=\"20px\" class=\"md-accent\"></md-progress-circular><div class=\"padding-top-10\">Please wait ..</div></div>\n</div><div layout=\"column\"><div layout=\"row\"><fieldset flex><legend>Basic Information</legend><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex-gt-sm><label>NIK</label><input type=\"text\" name=\"nik\" readonly=\"readonly\" \nng-model=\"vm.data.nik\"><div ng-messages=\"formPkwt.nik.$error\" role=\"alert\"><div ng-message=\"required\">NIK wajib diisi\n</div></div></md-input-container><md-input-container flex-gt-sm><label>Nama Karyawan</label><input type=\"text\" \nname=\"name\" ng-model=\"vm.data.name\"><div ng-messages=\"formPkwt.name.$error\" role=\"alert\"><div ng-message=\"required\">\nNama karyawan wajib diisi</div></div></md-input-container><md-autocomplete flex-gt-sm class=\"custom-autocomplete\" \nmd-delay=\"1000\" md-no-cache=\"true\" md-clear-button=\"true\" md-floating-label=\"Position ID\" \nmd-selected-item=\"vm.selectedPositionId\" md-selected-item-change=\"vm.selectedItemChangePositionId(item)\" \nng-required=\"true\" md-search-text=\"vm.searchTextPositionId\" md-input-name=\"positionId\" \nmd-items=\"item in vm.querySearchPositionId(vm.searchTextPositionId)\" md-item-text=\"vm.getItemTextPositionId(item)\" \nmd-min-length=\"2\"><md-item-template><span class=\"item-title\" md-highlight-text=\"vm.searchTextPositionId\">\n{{item.positionID}} - {{item.description}}</span></md-item-template><md-not-found>\nNo Record matching \"{{vm.searchTextPositionId}}\" were found.</md-not-found></md-autocomplete></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex-gt-sm><label>Jabatan</label><input type=\"text\" \nname=\"job_title\" ng-model=\"vm.data.job_title\"><div ng-messages=\"formPkwt.job_title.$error\" role=\"alert\"><div \nng-message=\"required\">Job title wajib diisi</div></div></md-input-container><md-input-container flex-gt-sm><label>\nDivision</label><input type=\"text\" name=\"division\" ng-model=\"vm.data.division\"><div \nng-messages=\"formPkwt.division.$error\" role=\"alert\"><div ng-message=\"required\">Division wajib diisi</div></div>\n</md-input-container><md-autocomplete flex-gt-sm class=\"custom-autocomplete\" md-delay=\"1000\" md-no-cache=\"true\" \nmd-clear-button=\"true\" md-floating-label=\"Area\" md-selected-item=\"vm.selectedArea\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" ng-required=\"true\" md-search-text=\"vm.searchText\" \nmd-input-name=\"code_area\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"vm.getItemText(item)\" \nmd-min-length=\"2\"><md-item-template><span class=\"item-title\" md-highlight-text=\"vm.searchText\">\n{{item.code_area}} - {{item.area_name}}</span></md-item-template><div ng-messages=\"formPkwt.code_area.$error\" \nrole=\"alert\"><div ng-message=\"required\">Kode area wajib diisi</div></div><md-not-found>\nNo Record matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex-gt-sm><label>Tgl. Terbit Surat</label><input required name=\"release_date\" \nng-change=\"vm.renderPkwtNumber()\" ng-model=\"vm.tempRelease\" type=\"date\"><div \nng-messages=\"formPkwt.release_date.$error\" role=\"alert\"><div ng-message=\"required\">Tgl. terbit surat wajib diisi</div>\n</div></md-input-container><md-input-container flex-gt-sm><label>Tgl. Mulai Kontrak</label><input required \nname=\"start_contract\" ng-model=\"vm.tempStart\" type=\"date\"><div ng-messages=\"formPkwt.start_contract.$error\" \nrole=\"alert\"><div ng-message=\"required\">Tgl. mulai kontrak wajib diisi</div></div></md-input-container>\n<md-input-container flex-gt-sm><label>Lama Kontrak (bulan)</label><input required \nng-change=\"vm.onChangeContractPeriod()\" name=\"contract_period\" ng-model=\"vm.data.contract_duration\" only-numbers \ntype=\"text\"><div ng-messages=\"formPkwt.contract_period.$error\" role=\"alert\"><div ng-message=\"required\">\nLama Contract wajib diisi</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex-gt-sm>\n<label>No PKWT</label><input readonly=\"readonly\" name=\"letter_number\" ng-model=\"vm.letterNumber\" type=\"text\">\n</md-input-container><md-input-container flex-gt-sm><label>Tgl. Berakhir Kontrak</label><input required \nname=\"end_contract\" ng-model=\"vm.tempEnd\" type=\"date\"><div ng-messages=\"formPkwt.end_contract.$error\" role=\"alert\"><div\n ng-message=\"required\">Tgl. berakhir kontrak wajib diisi</div></div></md-input-container><md-input-container \nflex-gt-sm><label>No KTP</label><input required only-numbers name=\"no_ktp\" ng-model=\"vm.data.no_ktp\" type=\"text\"><div \nng-messages=\"formPkwt.no_ktp.$error\" role=\"alert\"><div ng-message=\"required\">No KTP wajib diisi</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex-gt-sm=\"33\"><label>Tempat Lahir</label><input \nrequired name=\"birth_place\" ng-model=\"vm.data.birth_place\" type=\"text\"><div ng-messages=\"formPkwt.birth_place.$error\" \nrole=\"alert\"><div ng-message=\"required\">Tempat lahir wajib diisi</div></div></md-input-container><md-input-container \nflex-gt-sm><label>Tgl. Lahir</label><input required name=\"birth_date\" ng-model=\"vm.birthDate\" type=\"date\"><div \nng-messages=\"formPkwt.birth_date.$error\" role=\"alert\"><div ng-message=\"required\">Tgl. lahir wajib diisi</div></div>\n</md-input-container><md-input-container flex-gt-sm><label>Alamat</label><input required name=\"address\" \nng-model=\"vm.data.address\"><div ng-messages=\"formPkwt.address.$error\" role=\"alert\"><div ng-message=\"required\">\nAlamat wajib diisi</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex-gt-sm=\"33\"><label>\nGrade</label><input required name=\"grade\" ng-model=\"vm.data.grade\" type=\"text\"><div \nng-messages=\"formPkwt.grade.$error\" role=\"alert\"><div ng-message=\"required\">Grade wajib diisi</div></div>\n</md-input-container></div></fieldset></div><div layout=\"row\" class=\"padding-10\"></div><div layout=\"row\"><fieldset \nflex><legend>LOA</legend><div layout=\"row\" ng-if=\"vm.isLoadingLoa\" layout-align=\"center\" flex><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-wrap><div layout=\"row\" \nng-if=\"vm.isFillable(key)\" flex-gt-sm=\"33\" ng-repeat=\"(key, val) in vm.loa\"><md-input-container \nng-init=\"inputType = vm.inputType(key)\" flex><label>{{vm.parseLabel(key) | titleCase }}</label><input \nng-if=\"inputType.type === \'normal\'\" name=\"{{key}}\" ng-model=\"vm.loa[key]\" type=\"text\"><md-select \nng-if=\"inputType.type === \'select\'\" ng-model=\"vm.loa[key]\"><md-option ng-selected=\"opt.id == vm.loa[key]\" \nng-value=\"opt.id\" ng-repeat=\"opt in inputType.opt\">{{ opt.desc }}</md-option></md-select></md-input-container></div>\n</div></fieldset></div></div></md-dialog-content><md-dialog-actions layout=\"row\" flex><div layout-align=\"start center\" \nflex ng-class=\"{success:vm.success, error:!vm.success}\" ng-show=\"vm.showMessage\" class=\"form-message fade\">\n{{ vm.message }}</div><div flex=\"40\" layout-align=\"end center\" layout=\"row\"><md-button \nclass=\"md-warn md-raised white-fg\" ng-click=\"vm.update($event, formPkwt)\" \nng-disabled=\"formPkwt.$invalid || formPkwt.$pristine || vm.saveProccess\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Update</md-button><md-button ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pkwt/pkwt-rules/pkwt-rules-form/pkwt-rules-form.html","<md-dialog aria-label=\"Reschedule\" md-theme=\"modal-theme\" ms-scroll class=\"dialog-custom-wrapper\" flex=\"90\">\n<md-toolbar><div class=\"md-toolbar-tools title\"><h4>PKWT LOA Rules List</h4><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon ng-style=\"{\'color\' : \'#fff\'}\" md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"margin-top:0px; min-height: 200px\"><div class=\"overlay\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-accent\"></md-progress-circular><div class=\"padding-top-10\">\nPlease wait ..</div></div></div><div layout=\"column\"><md-toolbar><div class=\"md-toolbar-tools\"><span class=\"h2\">\n{{vm.data.job_title}} | {{vm.data.grade}}</span> <span flex></span><md-button ng-if=\"!vm.isEditMode\" \nng-click=\"vm.isEditMode = !vm.isEditMode\" class=\"md-icon-button md-raised md-accent md-hue-1\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button ng-if=\"vm.isEditMode\" ng-click=\"vm.save()\" \nclass=\"md-icon-button md-raised md-accent md-hue-1\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button>\n</div></md-toolbar><div class=\"table-container-content\"><table class=\"simple bordered stripped\" ms-responsive-table>\n<thead><tr><th>STATE</th><th>name</th><th>Type</th><th>Marital Status</th><th>Gender</th><th>Scale</th><th>Notes</th>\n<th>LOA BINDING</th></tr></thead><tbody><tr ng-repeat=\"item in vm.list\"><td class=\"text-center\"><div flex layout=\"row\" \nlayout-align=\"center\"><md-checkbox ng-disabled=\"!vm.isEditMode\" ng-model=\"item.is_having\" aria-label=\"Checkbox\" \nng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox></div></td><td ng-class=\"{\'w-200\' : vm.isEditMode}\" \nclass=\"text-center\">{{item.cnb_name}}</td><td class=\"text-center\">{{item.value_type}}</td><td class=\"text-center\"><span\n ng-if=\"!vm.isEditMode\">{{item.marital_status}}</span><select class=\"input-table\" ng-if=\"vm.isEditMode\" \nng-model=\"item.marital_status\" name=\"marital_status\"><option ng-selected=\"item.marital_status == m\" \nng-repeat=\"m in [\'required\', \'none\']\" ng-value=\"m\">{{m}}</option></select></td><td class=\"text-center\"><span \nng-if=\"!vm.isEditMode\">{{item.gender}}</span><select class=\"input-table\" ng-if=\"vm.isEditMode\" ng-model=\"item.gender\" \nname=\"gender\"><option ng-selected=\"item.gender == m\" ng-repeat=\"m in [\'P\', \'L\', \'B\']\" ng-value=\"m\">{{m}}</option>\n</select></td><td class=\"text-center\"><span ng-if=\"!vm.isEditMode\">{{item.besaran_value}}</span> <input \nclass=\"input-table\" ng-if=\"vm.isEditMode\" type=\"text\" name=\"besaran_value\" ng-model=\"item.besaran_value\"></td><td \nclass=\"text-center\"><span ng-if=\"!vm.isEditMode\">{{item.note}}</span> <input class=\"input-table\" ng-if=\"vm.isEditMode\" \ntype=\"text\" name=\"note\" ng-model=\"item.note\"></td><td class=\"text-center\"><span ng-if=\"!vm.isEditMode\">\n{{item.loa_column_key}}</span><select class=\"input-table\" ng-if=\"vm.isEditMode\" ng-model=\"item.loa_column_key\" \nname=\"loa_column_key\"><option ng-selected=\"item.loa_column_key == m\" ng-repeat=\"m in vm.loaBindingList\" ng-value=\"m\">\n{{m}}</option></select></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-xs=\"column\" flex><div flex class=\"form-message\"><span ng-class=\"{\'error\': vm.isError, \'success\' : !vm.isError}\">\n{{vm.message}}</span></div><span flex></span><div flex=\"10\" layout-align=\"end center\" layout=\"row\"><md-button \nng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon>close</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/payroll-new/bpjsmalaysiaeis/manage/manage-eis.html","<md-dialog aria-label=\"Form {{vm.label}} Emp Line Position\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack \nname=\"frmAddEis\" class=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddEis)\">\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Add BPJS Malaysia EIS</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container><label>Start Salary</label><input type=\"number\" \nstep=\"0.01\" ng-model=\"vm.Form.objForm.start_salary\" required><div ng-messages=\"frmAddEis.start_salary.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Salary is required.</span></div></div></md-input-container>\n<md-input-container><label>End Salary</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.Form.objForm.end_salary\" \nrequired><div ng-messages=\"frmAddEis.start_salary.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd Salary is required.</span></div></div></md-input-container><md-input-container><label>EE Value</label><input \ntype=\"number\" step=\"0.01\" ng-model=\"vm.Form.objForm.ee_value\" required><div \nng-messages=\"frmAddEis.start_salary.$error\" role=\"alert\"><div ng-message=\"required\"><span>EE Value is required.</span>\n</div></div></md-input-container><md-input-container><label>ER Value</label><input type=\"number\" step=\"0.01\" \nng-model=\"vm.Form.objForm.er_value\" required><div ng-messages=\"frmAddEis.start_salary.$error\" role=\"alert\"><div \nng-message=\"required\"><span>ER Value is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddEis.$invalid || frmAddEis.$pristine || vm.mppStandardLists.length == 0\">{{vm.label}}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/bpjsmalaysiaepf/manage/manage-epf.html","<md-dialog aria-label=\"Form {{vm.label}} Emp Line Position\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack \nname=\"frmAddEis\" class=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddEis)\">\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form {{vm.label}} BPJS Malaysia EPF\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container><label>Start Salary</label><input type=\"number\" \nstep=\"0.01\" ng-model=\"vm.Form.objForm.start_salary\" required><div ng-messages=\"frmAddEis.start_salary.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Salary is required.</span></div></div></md-input-container>\n<md-input-container><label>End Salary</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.Form.objForm.end_salary\" \nrequired><div ng-messages=\"frmAddEis.start_salary.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd Salary is required.</span></div></div></md-input-container><md-input-container><label>EE Value</label><input \ntype=\"number\" step=\"0.01\" ng-model=\"vm.Form.objForm.ee_value\" required><div \nng-messages=\"frmAddEis.start_salary.$error\" role=\"alert\"><div ng-message=\"required\"><span>EE Value is required.</span>\n</div></div></md-input-container><md-input-container><label>ER Value</label><input type=\"number\" step=\"0.01\" \nng-model=\"vm.Form.objForm.er_value\" required><div ng-messages=\"frmAddEis.start_salary.$error\" role=\"alert\"><div \nng-message=\"required\"><span>ER Value is required.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddEis.$invalid || frmAddEis.$pristine || vm.mppStandardLists.length == 0\">{{vm.label}}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/payroll-new/laporanprosespayroll/payrolldetails/payrolldetails.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PAYROLLCOMPONENTDETAIL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><div \nlayout=\"row\"><div flex layout=\"column\" style=\"padding: 7px\"><div layout=\"row\"><div flex=\"20\"><b><span \ntranslate=\"PAYROLL.MENU.EMPNO\"></span></b></div><div flex=\"50\"><b>: {{vm.payrollview[0][0].id_employee}}</b></div>\n</div><div layout=\"row\"><div flex=\"20\"><b><span translate=\"PAYROLL.MENU.NAME\"></span></b></div><div flex=\"50\"><b>\n: {{vm.payrollview[0][0].first_name + \' \' + vm.payrollview[0][0].middle_name + \' \' + vm.payrollview[0][0].last_name}}\n</b></div></div><div layout=\"row\"><div flex=\"20\"><b><span translate=\"PAYROLL.MENU.AREA\"></span></b></div><div \nflex=\"50\"><b>: {{vm.payrollview[0][0].BenefitCode}}</b></div></div></div></div><ms-widget class=\"fade\" \nflippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-alert\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table=\"\"><thead><tr><th><span translate=\"PAYROLL.MENU.NO\">\n</span></th><th><span translate=\"PAYROLL.MENU.CODE\"></span></th><th><span translate=\"PAYROLL.MENU.DESCRIPTION\"></span>\n</th><th><span translate=\"PAYROLL.MENU.AMOUNT\"></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.payrollview[0]\">\n<td align=\"center\">{{($index + 1)}}</td><td align=\"center\">{{ls.code}}</td><td align=\"center\">{{ls.description}}</td>\n<td align=\"center\">{{ls.amount | currency:\"Rp. \"}}</td></tr></tbody></table></div></div></md-content></div></div>\n</md-content></div>");
$templateCache.put("app/main/payroll-new/payrollprocess/data-status-payroll/data-status-payroll.html","<md-dialog aria-label=\"Data Status Payroll\" style=\"max-width: 90% !important;width: 60%\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Data Status Payroll</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\"><thead><tr><th>NO</th><th>NIK</th><th>Status</th></tr></thead><tbody><tr \nng-repeat=\"status in vm.DataStatusPayroll\"><td class=\"text-center\">{{$index+1}}</td><td class=\"text-center\">\n{{status.nik}}</td><td class=\"text-center\">{{status.log}}</td></tr></tbody></table></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"answer(\'cancel\')\">Cancel</md-button><md-button \nng-click=\"answer(\'proceed\')\">Proceed</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/payroll-new/report/allowance-report/allowancereport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ALLOWANCEREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"area\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div ng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header\n class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"area\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-input-container><md-button ng-click=\"vm.ExportData(\'0\')\" type=\"button\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/allowance-report-mgr/allowancereportmgr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.ALLOWANCEREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/analisacostcentre/analisacostcentre.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.ANALISACOSTCENTER\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExporttoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></div></form></div></div></md-content></div></div></md-content>\n</div>");
$templateCache.put("app/main/payroll-new/report/banktransfer/banktransfer.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.BANKTRANSFER\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportBankTransfertoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.loadData(1)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span>\n</label><md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadSBU(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.SBU\" ng-required=\"true\" name=\"SBU\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listSBU | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout-gt-sm=\"row\"><md-button \ntype=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></div></form></div></div></md-content></div></div></md-content>\n</div>");
$templateCache.put("app/main/payroll-new/report/bonus-report/bonusreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.BONUSREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/bonus-report-mgr/bonusreportmgr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.BONUSREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/daftarmutasi/daftarmutasi.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.DAFTARMUTASI\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportDaftarMutasitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/deduction-report/deductionreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.DEDUCTIONREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/deduction-report-mgr/deductionreportmgr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.DEDUCTIONREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/eis-report/eisreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EISREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 15px\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></md-input-container></div>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/eis-report-mgr/eisreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EISREPORTMGR\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 15px\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></md-input-container></div>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/epf-report/epfreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EPFREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 15px\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></md-input-container></div>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/epf-report-mgr/epfreport.html","download id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.EPFREPORTMGR\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 15px\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></md-input-container></div>\n</form></div></div></md-content></div></div></md-content>");
$templateCache.put("app/main/payroll-new/report/espttax/espttax.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.ESPTTAX\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportEsptTaxtoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"s in vm.listcompany\" value=\"{{s.id}}\">\n{{s.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Company is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-button \ntype=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></div></form></div></div></md-content></div></div></md-content>\n</div>");
$templateCache.put("app/main/payroll-new/report/formulirbpjs/formulirbpjs.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.FORMULIRBPJS\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportFormulirBPJStoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/gajicostcentre/gajicostcentre.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.GAJICOSTCENTRE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExporttoExcel($event,SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i><span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></div></form></div></div></md-content></div></div></md-content>\n</div>");
$templateCache.put("app/main/payroll-new/report/individual-summary-report/individualsummaryreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.PAYROLLINDIVIDUAL\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/individual-summary-report-mgr/individualsummaryreportmgr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.PAYROLLINDIVIDUAL\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/keluarbpjs/keluarbpjs.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.KELUARBPJS\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportKeluarBPJStoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/laporanbpjstk/laporanbpjstk.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.LAPORANDETAILBPJS\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportLaporanDetailBPJStoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span>\n</label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\n<span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select ng-model=\"vm.company\" name=\"company\" required>\n<md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/laporangaji/laporangaji.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.SALARYREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.DIVISION\"></span></label>\n<md-select ng-model=\"vm.divisi\" name=\"divisi\" ng-change=\"vm.LoadDepartment(vm.divisi)\"><md-option \nng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.DEPARTMENT\"></span></label>\n<md-select ng-model=\"vm.department\" name=\"department\"><md-option ng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.country!=\'MYS\'\" flex>\n<label><span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div ng-if=\"vm.country==\'MYS\'\" flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select ng-model=\"vm.wilayah\" name=\"wilayah\" \nmd-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" ng-required=\"vm.reqWil\"><md-select-header\n class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label><md-select \nng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadCabang(vm.regional)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label><md-select \nng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" ng-change=\"vm.LoadArea(vm.company,vm.cabang)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"cabang\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.AREA\">Area</label><md-select \nng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/laporangajidetail/laporangajidetail.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.SALARYREPORTDETAIL\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nng-cloack name=\"SalcomForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div flex=\"\" layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span>\n</label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\n<span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select ng-model=\"vm.company\" name=\"company\" \nng-change=\"vm.LoadArea(vm.company)\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}\n</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/laporanlembur/laporanlembur.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.LAPORANLEMBUR\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporantoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/laporanpajak/laporanpajak.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.LAPORANPAJAK1721\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nng-cloack name=\"LaporanForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporantoExcel($event,LaporanForm)\">\n<div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>\n<span translate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"LaporanForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"LaporanForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.KPP\"></span></label><md-select ng-model=\"vm.kpp\" name=\"kpp\" required><md-option \nng-repeat=\"ls in vm.listtaxloc\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container></div>\n<md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"LaporanForm.$invalid || LaporanForm.$pristine\"><i class=\"icon icon-file-excel\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/laporanpajaka1/laporanpajaka1.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.LAPORANPAJAK1721A1\"></span></md-subheader><div class=\"white-bg\">\n<md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form \nng-cloack name=\"LaporanForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporantoExcel($event,LaporanForm)\">\n<div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>\n<span translate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"LaporanForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"LaporanForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"PAYROLL.MENU.KPP\"></span></label><md-select ng-model=\"vm.kpp\" name=\"kpp\" required><md-option \nng-repeat=\"ls in vm.listkpp\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select></md-input-container></div><md-button\n type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"LaporanForm.$invalid || LaporanForm.$pristine\"><i class=\"icon icon-file-excel\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/laporanthr/laporanthr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.LAPORANTHR\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanThrtoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.YEAR\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.AREA\"></span></label>\n<md-select ng-model=\"vm.area\" name=\"area\" md-on-close=\"vm.clearSearchTerm()\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-file-excel\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/nonaktif/nonaktif.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.NONAKTIF\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportNonAktiftoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/overtime-report/overtimereport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.OVERTIMEREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/overtime-report-mgr/overtimereportmgr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.OVERTIMEREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/payroll-costcentre-report/payrollcostcentrereport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.PAYROLLCOSTCENTRE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/payroll-costcentre-report-mgr/payrollcostcentrereportmgr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.PAYROLLCOSTCENTRE\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/payslip/payslip.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PAYSLIP\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportPaysliptoPdf(SalcomForm)\"><div flex=\"\" \nlayout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select ng-model=\"vm.country\" name=\"country\" \nng-change=\"vm.LoadArea(vm.Form.objForm.company)\" md-on-close=\"vm.clearSearchTerm()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a country...\" \nautocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option value=\"{{ls.id}}\" \nng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup></md-select><div \nng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.Form.objForm.company\" name=\"company\" ng-change=\"vm.LoadArea(vm.Form.objForm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.Form.objForm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" \nvalue=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Period is required.</span></div></div></md-input-container><md-input-container flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.Form.objForm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div flex=\"\" layout-padding=\"1\" \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-autocomplete flex ng-disabled=\"vm.stateEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.empno\" md-search-text-change=\"vm.searchTextChange(vm.searchString)\" \nmd-search-text=\"vm.Form.objForm.fullname\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getEmployee(vm.Form.objForm.fullname)\" md-min-length=\"3\" md-input-name=\"empno\" \nmd-item-text=\"item.fullname\" md-floating-label=\"Search Employee Name/No\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.fullname\">{{item.fullname}}</span></md-item-template></md-autocomplete></div><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PASSWORDFORMPDF\"></span></label><input type=\"password\" name=\"positiondesc\" \nng-model=\"vm.Form.objForm.password\" required placeholder=\"Password\"></md-input-container></div><md-button \ntype=\"submit\" class=\"md-mini md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><span translate=\"PAYROLL.MENU.VIEWPAYSLIP\"></span>\n</md-button></form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/pcb-report/pcbreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.PCBREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 15px\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></md-input-container></div>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/pcb-report-mgr/pcbreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.PCBREPORTMGR\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 15px\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></md-input-container></div>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/pendaftaranbpjs/pendaftaranbpjs.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PENDAFTARANBPJS\"></span></md-subheader><div class=\"white-bg\"><md-content\n class=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportPendaftaranBpjstoExcel($event,SalcomForm)\"><div\n flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/perubahangaji/perubahangaji.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PERUBAHANGAJI\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportPerubahanGajitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/perubahanupah/perubahanupah.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.PERUBAHANUPAH\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanDetailBPJStoExcel($event,SalcomForm)\">\n<div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label>\n<span translate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required><md-option ng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company is required.</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/sapreport/sapreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"PAYROLL.MENU.SAPREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportSAPReporttoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label>\n<md-select ng-model=\"vm.company\" name=\"company\" required ng-change=\"vm.LoadDivisi(vm.company)\"><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.DIVISION\"></span></label>\n<md-select ng-model=\"vm.divisi\" name=\"divisi\"><md-option ng-repeat=\"ls in vm.listdivisi\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select></md-input-container></div><md-button type=\"submit\" \nclass=\"md-mini md-raised md-primary\" aria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i \nclass=\"icon icon-file-excel\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></form></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/socso-report/socsoreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SOCSOREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 15px\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></md-input-container></div>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/socso-report-mgr/socsoreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.SOCSOREPORTMGR\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ExportLaporanGajitoExcel($event,SalcomForm)\"><div \nflex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container><label><span \ntranslate=\"PAYROLL.MENU.PERIOD\"></span></label><md-select ng-model=\"vm.period\" name=\"period\" required><md-option \nng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\"><span>Period is required.</span></div>\n</div></md-input-container><md-input-container><md-button type=\"submit\" class=\"md-mini md-raised md-primary\" \naria-label=\"Submit\" ng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 15px\"></i> <span translate=\"PAYROLL.MENU.DOWNLOAD\"></span></md-button></md-input-container></div>\n</form></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/staff-and-salary-report/staffandsalaryreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.STAFFSALARYREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/staff-and-salary-report-mgr/staffandsalaryreportmgr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.STAFFSALARYREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/staff-report/staffreport.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.STAFFREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/report/staff-report-mgr/staffreportmgr.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.STAFFREPORT\"></span></md-subheader><div class=\"white-bg\"><md-content \nclass=\"\" layout=\"column\"><div layout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form ng-cloack \nname=\"SalcomForm\" class=\"md-inline-form\" novalidate><div flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label><span translate=\"PAYROLL.MENU.COUNTRY\"></span></label><md-select \nng-model=\"vm.country\" name=\"country\" ng-change=\"vm.LoadDefaultArea(vm.company)\" md-on-close=\"vm.clearSearchTerm()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search for a country...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"country\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listcountry | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"SalcomForm.countryid.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYROLL.MENU.COUNTRY\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.COMPANY\"></span></label><md-select \nng-model=\"vm.company\" name=\"company\" ng-change=\"vm.LoadDivisi(vm.company)\" required><md-option \nng-repeat=\"ls in vm.listcompany\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"SalcomForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company is required.</span></div>\n</div></md-input-container><md-input-container flex><label><span translate=\"PAYROLL.MENU.PERIOD\"></span></label>\n<md-select ng-model=\"vm.period\" name=\"period\" required><md-option ng-repeat=\"ls in vm.listperiod\" value=\"{{ls.id}}\">\n{{ls.name}}</md-option></md-select><div ng-messages=\"SalcomForm.period.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Period is required.</span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DIVISION\"></span></label><md-select ng-model=\"vm.divisi\" name=\"divisi\" \nng-change=\"vm.LoadDepartment(vm.company,vm.divisi)\"><md-option ng-repeat=\"ls in vm.listdivisi\" placeholder=\"Divisi\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"PAYROLL.MENU.DEPARTMENT\"></span></label><md-select ng-model=\"vm.department\" name=\"department\"><md-option \nng-repeat=\"ls in vm.listdepartment\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"(vm.country!=\'MYS\'&&vm.company!=\'EN\') || (vm.country==\'MYS\'&&vm.company!=\'EN\')\" flex><label>\n<span translate=\"PAYROLL.MENU.AREA\"></span></label><md-select ng-model=\"vm.area\" name=\"area\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.country==\'MYS\'&&vm.company==\'EN\'\" flex=\"\" layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"PAYROLL.MENU.WILAYAH\">Wilayah</label><md-select \nng-model=\"vm.wilayah\" name=\"wilayah\" md-on-close=\"vm.clearSearchTermWil()\" ng-change=\"vm.LoadRegional(vm.wilayah)\" \nng-required=\"vm.reqWil\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTermWil\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"wilayah\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listWilayah | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.REGIONAL\">Regional</label>\n<md-select ng-model=\"vm.regional\" name=\"regional\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadCabang(vm.regional)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"regional\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.listRegional | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex><label translate=\"PAYROLL.MENU.CABANG\">Cabang</label>\n<md-select ng-model=\"vm.cabang\" name=\"cabang\" md-on-close=\"vm.clearSearchTerm()\" \nng-change=\"vm.LoadArea(vm.company,vm.cabang)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup \nlabel=\"cabang\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listCabang | filter:vm.searchTerm\">{{ls.name}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"PAYROLL.MENU.AREA\">Area</label><md-select ng-model=\"vm.area\" name=\"area\" ng-required=\"vm.reqArea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listarea | filter:vm.searchTerm\">\n{{ls.name}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container><md-button \nng-click=\"vm.ExportData(\'0\')\" type=\"button\" class=\"md-mini md-raised md-primary\" aria-label=\"Export to Excel\" \nng-disabled=\"SalcomForm.$invalid || SalcomForm.$pristine\"><i class=\"icon icon-download\" \nstyle=\"font-size: 18px;position: absolute;margin-top: 5px;margin-left: -5px;color: white\"></i> <span \ntranslate=\"PAYROLL.MENU.DOWNLOADEXCEL\" style=\"margin-left: 15px\"></span></md-button></md-input-container></form></div>\n</div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/payroll-new/taxmalaysia/manage/manage-tax-malaysia.html","<md-dialog aria-label=\"Form {{vm.label}} Emp Line Position\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack \nname=\"frmAddEis\" class=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddEis)\">\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form {{vm.label}} Tax Malaysia</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout=\"column\"><md-input-container><label>Start Salary</label><input type=\"number\" \nstep=\"0.01\" ng-model=\"vm.Form.objForm.start_salary\" required><div ng-messages=\"frmAddEis.start_salary.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Salary is required.</span></div></div></md-input-container>\n<md-input-container><label>End Salary</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.Form.objForm.end_salary\" \nrequired><div ng-messages=\"frmAddEis.start_salary.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd Salary is required.</span></div></div></md-input-container><md-input-container><label>Tax Status</label><input \ntype=\"text\" ng-model=\"vm.Form.objForm.tax_status\" required><div ng-messages=\"frmAddEis.tax_status.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Tax Status is required.</span></div></div></md-input-container><md-input-container>\n<label>Amount</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.Form.objForm.amount\" required><div \nng-messages=\"frmAddEis.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span></div>\n</div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"frmAddEis.$invalid || frmAddEis.$pristine || vm.mppStandardLists.length == 0\">{{vm.label}}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/production-products/production/production-create/production-create-popup.html","<md-dialog aria-label=\"Form Update Finger Data\" flex-gt-md=\"70\" flex md-theme=\"modal-theme\"><form name=\"frmRequest\" \nng-cloack novalidate ng-submit=\"vm.saveData(frmRequest)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Create Production</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><md-contente layout=\"column\">\n<md-content layout=\"row\"><md-input-container flex><label>Building</label><md-select required \nng-model=\"vm.Form.objForm.gedung\" name=\"gedung\" ng-disabled=\"vm.edit\" \nng-change=\"vm.loadSector(vm.Form.objForm.gedung)\"><md-option ng-repeat=\"ls in vm.listGedung\" value=\"{{ls.id}}\">\n{{ls.gedung_name}}</md-option></md-select><div ng-messages=\"frmRequest.gedung.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Building field is required.</span></div></div></md-input-container><md-input-container \nflex><label>Sector</label><md-select ng-model=\"vm.Form.objForm.sector\" name=\"sector\" ng-disabled=\"vm.edit\" \nng-change=\"vm.loadLine(vm.Form.objForm.sector)\" required><md-option ng-repeat=\"ls in vm.listSector\" value=\"{{ls.id}}\">\n{{ls.sector_name}}</md-option></md-select><div ng-messages=\"frmRequest.sector.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Sector field is required.</span></div></div></md-input-container><md-input-container \nflex=\"10\"><label>Line</label><md-select ng-model=\"vm.Form.objForm.line\" name=\"line\" ng-disabled=\"vm.edit\" required>\n<md-option ng-repeat=\"ls in vm.listLine\" value=\"{{ls.id}}\">{{ls.line_number}}</md-option></md-select><div \nng-messages=\"frmRequest.line.$error\" role=\"alert\"><div ng-message=\"required\"><span>Line field is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Product</label><md-select \nng-model=\"vm.Form.objForm.product\" name=\"product\" ng-disabled=\"vm.edit\" required><md-option \nng-repeat=\"ls in vm.listProduct\" value=\"{{ls.id}}\">{{ls.sku}} - ({{ls.description}})</md-option></md-select><div \nng-messages=\"frmRequest.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>Product field is required.</span>\n</div></div></md-input-container></md-content><md-content layout=\"row\"><md-input-container flex=\"25\"><label>\nProduction Date</label><md-datepicker md-hide-icons=\"calendar\" md-open-on-focus \nng-model=\"vm.Form.objForm.production_date\" md-current-view=\"month\" name=\"productionDate\" ng-disabled=\"vm.edit\" \nrequired></md-datepicker><div ng-messages=\"frmRequest.productionDate.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Production date field is required.</span></div></div></md-input-container><md-input-container flex=\"25\"><label>\nShift</label><md-select ng-model=\"vm.Form.objForm.shift\" name=\"shift\" ng-disabled=\"vm.edit\" required><md-option \nng-repeat=\"ls in vm.shiftList\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmRequest.shift.$error\" role=\"alert\"><div ng-message=\"required\"><span>Shift field is required.</span>\n</div></div></md-input-container><md-input-container flex=\"8\"><label>Working Hour</label><input type=\"number\" required \nnumber ng-model=\"vm.Form.objForm.workingHour\" name=\"workingHour\" ng-max=\"8\"><div \nng-messages=\"frmRequest.workingHour.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking hour field is required.</span></div><div ng-message=\"number\"><span>Working hour field should be number.</span>\n</div></div></md-input-container><md-input-container flex=\"8\"><label>Working Hour Tolerance</label><input \ntype=\"number\" required number ng-model=\"vm.Form.objForm.tolerance\" name=\"tolerance\" ng-max=\"100\"><div \nng-messages=\"frmRequest.tolerance.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking hour tolerance field is required.</span></div><div ng-message=\"number\"><span>\nWorking hour tolerance field should be number.</span></div></div></md-input-container></md-content></md-contente>\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" \nflex><ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon\n md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget>\n</md-dialog-content><md-dialog-actions class=\"md-background-bg\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" ng-disabled=\"frmRequest.$invalid || basicForm.$pristine\">\nSubmit</md-button><md-button type=\"button\" ng-click=\"vm.closeModal()\" class=\"md-blue-grey-300-bg md-raised white-fg\" \naria-label=\"Reload\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/production-products/production/production-create/production-create.html","<div id=\"mpn-gw-request\" layout-fill class=\"page-layout scrollable fullwidth carded white-bg\" ms-scroll><md-content \nclass=\"white-bg\" layout-margin><div class=\"md-whiteframe-4dp content rounded\" layout-padding><md-subheader \nclass=\"subheader-sm\"><div layout=\"row\" flex=\"100\" layout-align=\"center\"><span>PRODUCTION FORM</span></div>\n</md-subheader><form name=\"frmRequest\" ng-cloack novalidate ng-submit=\"vm.saveData(frmRequest)\"><div \nng-init=\"vm.initForm(frmRequest)\"></div><fieldset layout=\"column\" class=\"form-fieldset\" layout-align=\"start\" \nlayout-padding><legend>Production</legend><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><md-input-container \nflex><label>Building</label><md-select required ng-model=\"vm.Form.objForm.gedung\" name=\"gedung\" ng-disabled=\"vm.edit\" \nng-change=\"vm.loadSector(vm.Form.objForm.gedung)\"><md-option ng-repeat=\"ls in vm.listGedung\" value=\"{{ls.id}}\">\n{{ls.gedung_name}}</md-option></md-select><div ng-messages=\"frmRequest.gedung.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Building field is required.</span></div></div></md-input-container><md-input-container \nflex><label>Sector</label><md-select ng-model=\"vm.Form.objForm.sector\" name=\"sector\" \nng-change=\"vm.loadLine(vm.Form.objForm.sector)\" ng-disabled=\"vm.edit\" required><md-option \nng-repeat=\"ls in vm.listSector\" value=\"{{ls.id}}\">{{ls.sector_name}}</md-option></md-select><div \nng-messages=\"frmRequest.sector.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sector field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Line</label><md-select \nng-model=\"vm.Form.objForm.line\" name=\"line\" ng-disabled=\"vm.edit\" required><md-option ng-repeat=\"ls in vm.listLine\" \nvalue=\"{{ls.id}}\">{{ls.line_number}}</md-option></md-select><div ng-messages=\"frmRequest.line.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Line field is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Product</label><md-select ng-model=\"vm.Form.objForm.product\" name=\"product\" ng-disabled=\"vm.edit\" required>\n<md-option ng-repeat=\"ls in vm.listProduct\" value=\"{{ls.id}}\">{{ls.sku}} - ({{ls.description}})</md-option></md-select>\n<div ng-messages=\"frmRequest.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>Product field is required.\n</span></div></div></md-input-container><md-input-container><label>Production Date</label><md-datepicker \nmd-hide-icons=\"calendar\" md-open-on-focus ng-disabled=\"vm.edit\" ng-model=\"vm.Form.objForm.production_date\" \nmd-current-view=\"month\" name=\"productionDate\" required></md-datepicker><div \nng-messages=\"frmRequest.productionDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nProduction date field is required.</span></div></div></md-input-container><md-input-container flex><label>Shift</label>\n<md-select ng-model=\"vm.Form.objForm.shift\" name=\"shift\" ng-disabled=\"vm.edit\" required><md-option \nng-repeat=\"ls in vm.shiftList\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"frmRequest.shift.$error\" role=\"alert\"><div ng-message=\"required\"><span>Shift field is required.</span>\n</div></div></md-input-container><md-input-container flex=\"8\"><label>Working Hour</label><input type=\"number\" required \nnumber ng-model=\"vm.Form.objForm.workingHour\" name=\"workingHour\" ng-max=\"8\"><div \nng-messages=\"frmRequest.workingHour.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking hour field is required.</span></div><div ng-message=\"number\"><span>Working hour field should be number.</span>\n</div></div></md-input-container><md-input-container flex=\"8\"><label>Working Hour Tolerance</label><input \ntype=\"number\" required number ng-model=\"vm.Form.objForm.tolerance\" name=\"tolerance\" ng-max=\"100\"><div \nng-messages=\"frmRequest.tolerance.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nWorking hour tolerance field is required.</span></div><div ng-message=\"number\"><span>\nWorking hour tolerance field should be number.</span></div></div></md-input-container></div></fieldset><div \nlayout=\"row\" layout-md=\"column\" layout-align=\"center center\" flex><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" ng-disabled=\"frmRequest.$invalid || basicForm.$pristine\">\nSubmit</md-button><md-button type=\"button\" ui-sref=\"app.mpn_gw_list\" class=\"md-blue-grey-300-bg md-raised white-fg\" \naria-label=\"Reload\">Back</md-button></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></form></div>\n</md-content></div>");
$templateCache.put("app/main/production-products/production/production-create/production-upload.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"70\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Upload Production</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\">\n<md-content layout=\"column\"><div layout-gt-sm=\"column\"><md-input-container><input type=\"file\" id=\"uploadPhoto\" \nname=\"shifttemplate\" nv-file-select uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadtemplate\',\n                                                        subarea: vm.subarea}]}\">\n</md-input-container></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" \nclass=\"md-accent hue-2\"></md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" \nng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding>\n<span>Failed Upload File</span></md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload File</span></md-whiteframe></md-content></md-dialog-content><md-dialog-actions \nclass=\"md-background-bg\"><md-button ng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-primary\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon>Upload</md-button><md-button class=\"md-primary\" ng-click=\"vm.downloadFormat()\">\n<md-icon md-font-icon=\"icon-download\"></md-icon>Download Format</md-button><md-button ng-click=\"vm.selesai()\" \nclass=\"md-primary\">Done</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pms/behaviour-performance/input-behaviour/input-behaviour.html","<md-dialog aria-label=\"{{vm.title}} Behaviour Performance\" flex=\"70\" id=\"formBehivorPerformance\" \nmd-theme=\"modal-theme\"><form ng-cloak name=\"formPerformance\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,formPerformance)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>{{vm.title}} TSTE {{vm.resultDateAlias}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content scroll-glue-right><div flex=\"20\" \nid=\"input_button_toggle\" layout=\"row\"><md-input-container class=\"md-block md-input-has-value\">\n<md-buttons-toggle-potential items=\"vm.languageList\" ng-model=\"vm.language\" selected-class=\"md-accent\">\n</md-buttons-toggle-potential></md-input-container></div><div layout=\"row\" flex=\"100\" layout-padding \nlayout-xs=\"column\"><div flex=\"45\" flex-xs=\"100\"><div layout=\"column\" ng-repeat=\"ref in vm.listInput\"><div layout=\"row\">\n<md-input-container flex=\"90\"><div ng-if=\"vm.language==\'ID\'\" class=\"title\"><b>{{ref.initial}}</b> ({{ref.description}})\n</div><div ng-if=\"vm.language!=\'ID\'\" class=\"title\"><b>{{ref.initial}}</b> ({{ref.description_en}})</div>\n</md-input-container><md-input-container flex=\"10\"><md-select ng-model=\"vm.Form.objForm.result[$index+1]\" \nng-change=\"vm.showLevelDetail(ref.id, vm.Form.objForm.result[$index+1])\" \nng-click=\"vm.showLevelDetail(ref.id, vm.Form.objForm.result[$index+1])\" ng-required><md-option ng-value=\"l.level\" \nng-repeat=\"l in vm.listInputLevel\" ng-if=\"l.ref_behivor_performance_id === ref.id\">{{l.level}}</md-option></md-select>\n<div ng-messages=\"formPerformance[\'result\'+ref.id].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nResult {{ref.initial}} is required.</span></div></div></md-input-container></div></div><ms-widget flippable=\"false\" \nlayout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><div \nlayout=\"row\" ng-if=\"vm.inputOn==1\"><md-input-container flex><label><span translate=\"KPI.LABEL.RESULTDATE\"></span>\n</label><md-select ng-model=\"vm.Form.objForm.resultDate\" required><md-optgroup label=\"ResultDate\"><md-option \nng-value=\"item.id\" ng-repeat=\"item in vm.items\">{{item.value}}</md-option></md-optgroup></md-select><div \nng-messages=\"formPerformance.resultDate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.RESULTDATE\"></span><span> is required</span></div></div></md-input-container></div></div><span \nflex></span><div flex=\"50\" flex-xs=\"100\"><div layout=\"column\"><table class=\"simple\"><thead><tr><th><span \ntranslate=\"KPI.LABEL.BEHAVIOUR\"></span></th><th><span translate=\"KPI.LABEL.LEVEL\"></span></th><th><span \ntranslate=\"KPI.LABEL.DESCRIPTION\"></span></th></tr></thead><tbody style=\"height: 200px; overflow-y: scroll\"><tr \nng-repeat=\"ld in vm.listInputLevel\"><td \nclass=\"text-center lists-level-details lists-level-details-{{ld.ref_behivor_performance_id + \'\' + ld.level}}\">\n{{ld.initial}}</td><td \nclass=\"text-center lists-level-details lists-level-details-{{ld.ref_behivor_performance_id + \'\' + ld.level}}\">\n{{ld.level}}</td><td ng-if=\"vm.language==\'ID\'\" \nclass=\"lists-level-details lists-level-details-{{ld.ref_behivor_performance_id + \'\' + ld.level}}\">{{ld.description}}\n</td><td ng-if=\"vm.language!=\'ID\'\" \nclass=\"lists-level-details lists-level-details-{{ld.ref_behivor_performance_id + \'\' + ld.level}}\">{{ld.description_en}}\n</td></tr></tbody></table></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"is-md-accent md-accent md-button\" type=\"submit\" ng-disabled=\"formSetKpi.$invalid || vm.saveProcess\" \ntype=\"submit\"><span translate=\"KPI.LABEL.SAVE\"></span></md-button><md-button class=\"is-md-accent md-refresh md-button\" \nng-click=\"vm.setToken()\">Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/behaviour-performance-team/set-behaviour/set-behaviour.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">Periode</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"period in vm.listPeriod\"><md-button \naria-label=\"{{period.effectiveDate}}\" ng-click=\"vm.showBehivor(period.effectiveDate)\"><span class=\"secondary-text\">\n<span><md-icon ng-if=\"period.effectiveDate == vm.currentDate\" md-font-icon=\"icon-check\"></md-icon><md-icon \nng-if=\"!period.effectiveDate\"></md-icon>{{period.effectiveDate}}</span></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill><div \nclass=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\"><span>T S T E Team / {{vm.nik}}\n</span></md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\">\nNo.</th><th rowspan=\"2\">Result Date</th><th colspan=\"2\">Trustworthy</th><th colspan=\"2\">Superteam</th><th colspan=\"2\">\nTotally Customer</th><th colspan=\"2\">Excellence</th><th rowspan=\"2\">Action</th></tr><tr><td style=\"text-align:center\">\nKaryawan</td><td style=\"text-align:center\">Atasan</td><td style=\"text-align:center\">Karyawan</td><td \nstyle=\"text-align:center\">Atasan</td><td style=\"text-align:center\">Karyawan</td><td style=\"text-align:center\">Atasan\n</td><td style=\"text-align:center\">Karyawan</td><td style=\"text-align:center\">Atasan</td></tr></thead><tbody><tr \nng-repeat=\"input in vm.listInput\"><td style=\"text-align: center\">{{($index + 1)}}</td><td style=\"text-align: center\">\n{{input.resultDateAlias}}</td><td style=\"text-align:center\">{{input.resultA}}</td><td style=\"text-align:center\">\n{{input.resultAtasA}}</td><td style=\"text-align:center\">{{input.resultB}}</td><td style=\"text-align:center\">\n{{input.resultAtasB}}</td><td style=\"text-align:center\">{{input.resultC}}</td><td style=\"text-align:center\">\n{{input.resultAtasC}}</td><td style=\"text-align:center\">{{input.resultD}}</td><td style=\"text-align:center\">\n{{input.resultAtasD}}</td><td style=\"text-align:center\"><div ng-if=\"!input.resultAtasA\"><md-button \nclass=\"md-icon-button\" aria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.addData($event,input.resultDate,input.id,input.resultDateAlias)\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>click for add</span></md-tooltip></md-button></div><div \nng-if=\"!!input.resultAtasA\"><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nstyle=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.editData(input,input.resultDate,input.id,input.resultAtasA,input.resultAtasB,input.resultAtasC,input.resultAtasD,input.resultDateAlias)\">\n<md-icon md-font-icon=\"icon-table-edit\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>click for edit</span>\n</md-tooltip></md-button></div></td></tr></tbody></table><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front red-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.pesan}}</p></ms-widget-front></ms-widget></md-content></div></div>\n</md-content></div><style type=\"text/css\">\n.has-selected .selected-action {\n    padding: 8px 0;\n    height: 40px;\n    line-height: 24px;\n    font-size: 16px;\n  }\n\n  .header.nabati5.csm-header {\n    min-height: auto !important;\n  }\n</style>");
$templateCache.put("app/main/pms/competency-review/input-competency-review/input-competency-review.html","<md-dialog aria-label=\"{{vm.title}} Competency Review\" flex=\"75\" id=\"formCompetencyReview\"><form ng-cloak \nname=\"formCompetencyReview\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,formCompetencyReview)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>{{vm.title}} Input Competency Review {{vm.resultDateAlias}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><input type=\"hidden\" \nng-model=\"vm.Form.objForm.job_code\"> <input type=\"hidden\" ng-model=\"vm.Form.objForm.job_code_profile_id\"><div \nlayout=\"row\" class=\"ng-scope layout-row\"><div flex-gt-sm=\"40\" flex=\"40\"><div layout=\"row\"><md-input-container \nflex=\"100\" class=\"md-block md-input-has-value change-language\"><p>Change Language</p><md-buttons-toggle-2 \nng-model=\"vm.language\" items=\"vm.languageList\" selected-class=\"md-accent\"></md-buttons-toggle-2></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"100\" class=\"md-block md-input-has-value\"><label>Competency</label>\n<input type=\"text\" value=\"{{vm.competencyCode + \' - \' + vm.competency}}\" style=\"color: #616462\" disabled=\"disabled\"><p \nstyle=\"padding-top: 20px; color: #616462\">\n{{(vm.language === \'ID\')?vm.competencyDescription:vm.competencyDescriptionEn}}</p></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"100\" class=\"md-block md-input-has-value\"><label>Required Level</label><input \ntype=\"text\" value=\"{{vm.req_level}}\" style=\"color: #616462\" disabled=\"disabled\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"100\" class=\"md-block md-input-has-value\"><label>Self Level</label><md-select \nng-model=\"vm.Form.objForm.self_level\" ng-change=\"vm.showLevelDetail(vm.Form.objForm.self_level)\" required><md-option \nng-value=\"0\">0</md-option><md-option ng-value=\"l.level\" ng-repeat=\"l in vm.listLevel\">{{l.level}}</md-option>\n</md-select><div ng-messages=\"formCompetencyReview[\'self_level\'].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSelf Level is required.</span></div></div></md-input-container></div><div layout=\"row\" style=\"display: none\">\n<md-input-container class=\"md-block md-input-has-value\"><label>Top 3 of Strength and Area for Improvemente</label>\n<md-select ng-model=\"vm.Form.objForm.status\"><md-option ng-value=\"1\">Strength</md-option><md-option ng-value=\"2\">\nArea for Improvement</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nflex=\"100\" class=\"md-block md-input-has-value\"><label>Comments</label><textarea name=\"comments\" rows=\"3\" \nng-model=\"vm.Form.objForm.comments\" placeholder=\"Comments\">{{vm.comments}</textarea></md-input-container></div>\n<ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div><div \nflex-offset=\"5\" flex=\"60\"><div layout=\"row\"><md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"\">\n<label>Profeciency</label><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nstyle=\"text-align: center\">Level</th><th style=\"text-align: center\">Key Behaviour</th><th style=\"text-align: center\">\nMateri Training</th><th style=\"text-align: center\">Target Behaviour</th></tr></thead><tbody><tr><td \nstyle=\"text-align: center; border-right: 1px solid rgba(0, 0, 0, 0.12)\" \nclass=\"lists-level-details lists-level-details-0\">0</td><td class=\"lists-level-details lists-level-details-0\" \nstyle=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12)\">Not Available</td><td \nclass=\"lists-level-details lists-level-details-0\" style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12)\">-</td><td \nclass=\"lists-level-details lists-level-details-0\" style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12)\">-</td></tr>\n</tbody><tbody ng-repeat=\"l in vm.listLevel\"><tr><td rowspan=\"{{l.total_key_behaviour + 1}}\" \nstyle=\"text-align: center; border-right: 1px solid rgba(0, 0, 0, 0.12)\" \nclass=\"lists-level-details lists-level-details-{{l.level}}\">{{l.level}}</td></tr><tr ng-repeat=\"d in l.details\"><td \nclass=\"lists-level-details lists-level-details-{{d.level}}\" style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12)\">\n{{(vm.language === \'ID\')?d.key_behaviour:d.key_behaviour_en}}</td><td rowspan=\"{{l.total_key_behaviour + 1}}\" \nng-if=\"$index == 0\" style=\"vertical-align: top; border-right: 1px solid rgba(0, 0, 0, 0.12); white-space: pre-line\" \nclass=\"lists-level-details lists-level-details-{{l.level}}\">{{l.materi_training}}</td><td \nrowspan=\"{{l.total_key_behaviour + 1}}\" ng-if=\"$index == 0\" \nstyle=\"vertical-align: top; border-right: 1px solid rgba(0, 0, 0, 0.12); white-space: pre-line\" \nclass=\"lists-level-details lists-level-details-{{l.level}}\">\n{{(vm.language === \'ID\')?l.target_behaviour:l.target_behaviour_en}}</td></tr></tbody></table></md-input-container>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-raised md-primary btn-ui-serif\" ng-disabled=\"formCompetencyReview.$invalid\" type=\"submit\">Save</md-button>\n<md-button class=\"md-blue-300-bg md-raised white-fg\" ng-click=\"vm.setToken()\">Reload Token</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/competency-team/set-competency-review-member/set-competency-review-member.html","<div id=\"simple-table\" class=\"page-layout simple is-simple fullwidth doc-page element-doc-page ng-scope\"><div \nid=\"contentCompetencyReview\" class=\"content\"><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\">Set Competency Review Member</div><div \nlayout=\"row\" class=\"table-title no-border\"><div flex=\"40\" class=\"review-member\"><div layout=\"row\"><div flex=\"20\">Nik\n</div><div flex=\"100\">: {{vm.profile[0].nik}}</div></div><div layout=\"row\"><div flex=\"20\">Name</div><div flex=\"100\">\n: {{vm.profile[0].title + \'. \' + vm.profile[0].first_name + \' \' + vm.profile[0].last_name}}</div></div><div \nlayout=\"row\"><div flex=\"20\">Period</div><div flex=\"20\"><md-select ng-model=\"vm.Form.period\" ng-change=\"vm.loadData()\" \nclass=\"mt-0\"><md-option ng-repeat=\"y in vm.years\" value=\"{{y.year}}\" ng-selected=\"y.year == vm.currentYear\">{{y.year}}\n</md-option></md-select></div></div></div><div flex=\"30\" layout=\"row\" layout-align=\"left center\"><span \nclass=\"md-subhead\" \nng-if=\"vm.remaining > 0 && vm.listInput.length > 0 && vm.listInput[1].details[0].bypass_cr_self === 0\" \nstyle=\"color:#FD7545\">{{vm.remaining}} Remaining from your staff</span> <span class=\"md-subhead\" \nng-if=\"vm.showRemaining\" style=\"color:#FD7545\">{{vm.mgr_remaining}} Remaining</span> <span \nclass=\"md-subhead completed\" ng-if=\"vm.mgr_remaining === 0 && vm.listInput.length > 0\"><md-icon \nmd-font-icon=\"icon-check-circle\"></md-icon>Completed</span></div><div flex=\"30\" style=\"text-align: right\"><md-button \nstyle=\"width: 200px\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Back\" \nui-sref=\"app.pms_competency_team\">Back</md-button></div></div><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div id=\"attView\" \nclass=\"table-2 is-table-simple mt-10\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead>\n<tr><th rowspan=\"2\" colspan=\"3\">Competencies</th><th rowspan=\"2\">Required</th><th colspan=\"2\">Assessment</th><th \nrowspan=\"2\">Gap</th><th rowspan=\"2\" style=\"width: 150px\">Top 3<br>of Strength and<br>Area for Improvement</th><th \nrowspan=\"2\">Comments</th><th rowspan=\"2\">#</th></tr><tr><td style=\"text-align:center\">Self</td><td \nstyle=\"text-align:center\">N+1</td></tr></thead><tbody ng-repeat=\"group in vm.listInput track by $index\" \nng-if=\"group.details !== undefined\"><tr><td rowspan=\"{{group.details.length + 1}}\" style=\"text-align: center\">\n{{group.category_name}}</td></tr><tr ng-repeat=\"input in group.details\"><td style=\"text-align:center\">\n{{input.competency_code}}</td><td>{{input.competency}}</td><td style=\"text-align:center\">{{input.req_level}}</td><td \nstyle=\"text-align:center\">{{input.self_level}}</td><td style=\"text-align:center\">{{input.mgr_level}}</td><td \nstyle=\"text-align:center\">{{input.gap}}</td><td style=\"text-align:center\"><form action=\"javascript:void(0);\" \nname=\"formCompetencyReviewMember[{{input.id}}]\" id=\"formCompetencyReviewMember_{{input.id}}\" novalidate \nng-submit=\"vm.saveDataStrength($event, formCompetencyReviewMember[input.id])\"><md-select ng-model=\"input.status_id\" \nng-change=\"vm.setStrength(input)\" placeholder=\"-\" ng-disabled=\"!input.mgr_level\"><md-option \nng-repeat=\"s in vm.strengthLists\" value=\"{{s.id}}\">{{s.name}}</md-option></md-select></form></td><td><div \nng-if=\"input.comments\" style=\"border-bottom: 1px dotted #ccc\">{{input.comments}}</div><div>{{input.mgr_comments}}</div>\n</td><td style=\"text-align:center\"><md-button ng-if=\"input.bypass_cr_self || input.mgr_level\" class=\"md-icon-button\" \naria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.inputData($event, input)\"><md-icon \nmd-font-icon=\"icon-table-edit\" class=\"blue-500-fg\"></md-icon><md-tooltip><span>Update Self Level</span></md-tooltip>\n</md-button><md-button ng-if=\"input.bypass_cr_self === 0 && !input.mgr_level\" class=\"md-icon-button\" \naria-label=\"Settings\" style=\"padding: 0;height: 24px;width: 24px\"><md-icon md-font-icon=\"icon-table-edit\" \nclass=\"red-100-fg\"></md-icon></md-button></td></tr></tbody></table><form style=\"margin: 20px 15px\" ng-cloak \nname=\"formCompetencyReviewAspiration\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveAspirationData($event,formCompetencyReviewAspiration)\"><div layout=\"column\"><div flex-gt-sm=\"50\" \nflex=\"50\"><div layout=\"row\"><md-input-container flex class=\"md-block md-input-has-value\"><label>Career Aspiration\n</label><textarea name=\"career_aspiration\" rows=\"3\" ng-model=\"vm.career_aspiration\" placeholder=\"Career aspiration...\" \ndisabled=\"disabled\" style=\"color: #000\">{{vm.career_aspiration}</textarea></md-input-container></div></div></div>\n</form></div></div></div></div></div>");
$templateCache.put("app/main/pms/competency-team/set-competency-review-member/set-input-competency-review-member.html","<md-dialog aria-label=\"{{vm.title}} Competency Review\" flex=\"75\" id=\"formCompetencyReview\" class=\"simple-popup\"><form \nng-cloak name=\"formCompetencyReview\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,formCompetencyReview)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>{{vm.title}} Input Competency Review {{vm.resultDateAlias}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><input type=\"hidden\" \nng-model=\"vm.Form.objForm.job_code\"> <input type=\"hidden\" ng-model=\"vm.Form.objForm.job_code_profile_id\"> <input \ntype=\"hidden\" ng-model=\"vm.Form.objForm.emp_nik\"><div layout=\"row\" class=\"ng-scope layout-row\"><div flex-gt-sm=\"40\" \nflex=\"40\"><div layout=\"row\"><md-input-container flex=\"100\" class=\"md-block md-input-has-value change-language\"><label>\nChange Language</label><md-buttons-toggle ng-model=\"vm.language\" items=\"vm.languageList\" selected-class=\"md-accent\" \nclass=\"mt-10\"></md-buttons-toggle></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" \nclass=\"md-block md-input-has-value\"><label>Competency</label><input type=\"text\" \nvalue=\"{{vm.competencyCode + \' - \' + vm.competency}}\" style=\"color: #616462\" disabled=\"disabled\"><p \nstyle=\"padding-top: 20px; color: #616462\">\n{{(vm.language === \'ID\')?vm.competencyDescription:vm.competencyDescriptionEn}}</p></md-input-container></div><div \nlayout=\"row\"><div layout=\"column\" flex=\"50\"><md-input-container flex=\"100\" class=\"md-block md-input-has-value\"><label>\nRequired Level</label><input type=\"text\" value=\"{{vm.req_level}}\" style=\"color: #616462\" disabled=\"disabled\">\n</md-input-container></div><div layout=\"column\" flex=\"50\"><md-input-container flex=\"100\" \nclass=\"md-block md-input-has-value\"><label>Staff Level</label><input type=\"text\" value=\"{{vm.self_level}}\" \nstyle=\"color: #616462\" disabled=\"disabled\"></md-input-container></div></div><div layout=\"row\"><md-input-container \nflex=\"100\" class=\"md-block md-input-has-value\"><label>Mgr. Level</label><md-select \nng-model=\"vm.Form.objForm.mgr_level\" ng-change=\"vm.showLevelDetail(vm.Form.objForm.mgr_level)\" required><md-option \nng-value=\"0\">0</md-option><md-option ng-value=\"l.level\" ng-repeat=\"l in vm.listLevel\">{{l.level}}</md-option>\n</md-select><div ng-messages=\"formCompetencyReview[\'mgr_level\'].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMgr. Level is required.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" \nclass=\"md-block md-input-has-value\"><label>Comments</label><textarea name=\"comments\" rows=\"3\" \nng-model=\"vm.Form.objForm.mgr_comments\" placeholder=\"Comments\">{{vm.mgr_comments}</textarea></md-input-container></div>\n<ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div><div \nflex-offset=\"5\" flex=\"60\"><div layout=\"row\"><md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"\">\n<label>Profeciency</label><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th \nstyle=\"text-align: center\">Level</th><th style=\"text-align: center\">Key Behaviour</th><th style=\"text-align: center\">\nMateri Training</th><th style=\"text-align: center\">Target Behaviour</th></tr></thead><tbody><tr><td \nstyle=\"text-align: center; border-right: 1px solid rgba(0, 0, 0, 0.12)\" \nclass=\"lists-level-details lists-level-details-0\">0</td><td class=\"lists-level-details lists-level-details-0\" \nstyle=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12)\">Not Available</td><td \nclass=\"lists-level-details lists-level-details-0\" style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12)\">-</td><td \nclass=\"lists-level-details lists-level-details-0\" style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12)\">-</td></tr>\n</tbody><tbody ng-repeat=\"l in vm.listLevel\"><tr><td rowspan=\"{{l.total_key_behaviour + 1}}\" \nstyle=\"text-align: center; border-right: 1px solid rgba(0, 0, 0, 0.12)\" \nclass=\"lists-level-details lists-level-details-{{l.level}}\">{{l.level}}</td></tr><tr ng-repeat=\"d in l.details\"><td \nclass=\"lists-level-details lists-level-details-{{d.level}}\" style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12)\">\n{{(vm.language === \'ID\')?d.key_behaviour:d.key_behaviour_en}}</td><td rowspan=\"{{l.total_key_behaviour + 1}}\" \nng-if=\"$index == 0\" style=\"vertical-align: top; border-right: 1px solid rgba(0, 0, 0, 0.12); white-space: pre-line\" \nclass=\"lists-level-details lists-level-details-{{l.level}}\">{{l.materi_training}}</td><td \nrowspan=\"{{l.total_key_behaviour + 1}}\" ng-if=\"$index == 0\" \nstyle=\"vertical-align: top; border-right: 1px solid rgba(0, 0, 0, 0.12); white-space: pre-line\" \nclass=\"lists-level-details lists-level-details-{{l.level}}\">\n{{(vm.language === \'ID\')?l.target_behaviour:l.target_behaviour_en}}</td></tr></tbody></table></md-input-container>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-raised md-primary btn-ui-serif\" ng-disabled=\"formCompetencyReview.$invalid\" type=\"submit\">Save</md-button>\n<md-button class=\"md-blue-300-bg md-raised white-fg\" ng-click=\"vm.setToken()\">Reload Token</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/cr-progress/set-team-all/set-team-all-scale.html","<md-dialog aria-label=\"Set Kpi Scales\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloak name=\"formSetKpi\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent hue-3\"><div class=\"md-toolbar-tools\"><h2><md-icon \nmd-font-icon=\"icon-poll\"></md-icon>View KPI Scales</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeKpi()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialogSetKPI\"><table width=\"100%\"><tr><td \nvalign=\"top\">Key Performance Indicator</td><td valign=\"top\">UOM</td><td valign=\"top\">Weight</td><td valign=\"top\">Target\n</td></tr><tr style=\"font-weight:bold\"><td valign=\"top\">{{vm.kpidesc}}</td><td valign=\"top\">{{vm.uom}}</td><td \nvalign=\"top\">{{vm.bobot}}</td><td valign=\"top\">{{vm.target}}</td></tr></table><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" \nid=\"datatable\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">\nScale</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description\n</span></div></th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\">Min\n</span></div></th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\">Max\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"ks in vm.listkpiscale\"><td align=\"center\">{{ ks.no_urut}}</td><td>\n{{ ks.scale}}</td><td>{{ ks.start}}</td><td>{{ ks.finish}}</td></tr></tbody></table></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/pms/cr-progress/set-team-all/set-team-all.html","<form ng-cloak name=\"formSetKpi\" class=\"md-inline-form\" novalidate><div id=\"kpi\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header Oct\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-account-check\"></md-icon></span><span class=\"logo-text\"><span>\nVIEW KPI YEAR {{vm.yearSelected}} / {{vm.nik}}</span></span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\"><div class=\"selected-action\">YEARS</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year.year}}\" \nng-click=\"vm.showKpi(year.year)\"><span class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><div class=\"content\"><div id=\"kpiView\" \nclass=\"md-whiteframe-4dp\" layout=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-menu \nmd-offset=\"18 48\"><md-button aria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-raised reference-button md-warn md-hue-2\" \nng-disabled=\"formSetKpi.$invalid || formSetKpi.$pristine\" ng-click=\"vm.approveKS($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n<table class=\"simple\" ms-responsive-table id=\"kpiTable\"><thead><tr><th></th><th>No</th><th>KPI</th><th>WEIGHT</th><th>\nUOM</th><th>TARGET</th><th>START DATE</th><th>END DATE</th><th>STATUS APPROVAL</th></tr></thead><tbody><tr \nng-repeat=\"ks in vm.DataTable.list\" ng-click=\"vm.select(ks)\"><td><div ng-if=\"ks.status===\'Submitted\'\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(ks)\" ng-click=\"vm.toggleCheck(ks, $event)\" ng-model=\"isCovered\" \nng-change=\"formSetKpi.$setValidity(\'required\', vm.listKSSelected.length > 0)\" \naria-label=\"{{vm.isChecked(ks)? \'Uncheck\':\'check\'}}\"></md-checkbox></div><div ng-else></div></td><td align=\"center\">\n{{ ($index + 1)}}</td><td align=\"left\"><a href=\"\" ng-click=\"vm.viewScales($event,ks.idks)\" \nstyle=\"text-decoration:underline\">{{ ks.kpi}}</a></td><td align=\"center\">{{ ks.bobot}}</td><td>{{ ks.uom}}</td><td>\n{{ ks.target}}</td><td align=\"center\">{{ ks.effectiveDate}}</td><td align=\"center\">{{ ks.expiredDate}}</td><td \nalign=\"center\"><span>{{ ks.status}}</span><md-button ng-if=\"ks.status==\'Approved\'\" class=\"md-icon-button\" \nng-click=\"vm.removeApproval(ks.id,ks.kpi,$event)\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s16 red-500-fg\"></md-icon></md-button></td></tr></tbody></table><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front red-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.pesan}}</p></ms-widget-front></ms-widget><span flex></span></div>\n</div></div></form>");
$templateCache.put("app/main/pms/emp-job-code/input-emp-job-code/input-emp-job-code.html","<md-dialog aria-label=\"{{vm.title}} Competency Review\" flex=\"80\" id=\"formEmpJobCode\"><form ng-cloak \nname=\"formEmpJobCode\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,formEmpJobCode)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>{{vm.title}} Input Employee Job Code {{vm.resultDateAlias}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><input type=\"hidden\" \nng-model=\"vm.Form.objForm.nik\"><div layout=\"row\"><md-input-container flex=\"100\" class=\"md-block md-input-has-value\">\n<label>Emplopyee</label><input type=\"text\" value=\"{{vm.data.nik + \' / \' + vm.data.emp_name}}\" style=\"color: #000\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" \nclass=\"md-block md-input-has-value\"><label>Effective Date</label><input type=\"text\" value=\"{{vm.data.effective_date}}\" \nstyle=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" \nclass=\"md-block md-input-has-value\"><label>Job Code</label><md-select ng-model=\"vm.Form.objForm.job_code\" required>\n<md-option ng-value=\"l.code\" ng-repeat=\"l in vm.listJobCode\">{{l.code + \' - \' + l.description}}</md-option></md-select>\n<div ng-messages=\"formEmpJobCode[\'job_code\'].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJob Code is required.</span></div></div></md-input-container></div><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-primary btn-ui-serif\" \nng-disabled=\"formEmpJobCode.$invalid\" type=\"submit\">Save</md-button><md-button \nclass=\"md-blue-300-bg md-raised white-fg\" ng-click=\"vm.setToken()\">Reload Token</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pms/edp/set-edp-member/set-edp-member.html","<div class=\"page-layout simple fullwidth\" id=\"input\" layout=\"column\"><div class=\"header Oct\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-cog\"></md-icon></span><span class=\"logo-text\"><span>\nEmployee Individual Development Program</span></span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\"><div class=\"selected-action\">Periode</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \naria-label=\"Select project\" class=\"md-icon-button action-selector\" md-menu-align-target=\"\" md-menu-origin=\"\" \nng-click=\"$mdOpenMenu()\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content \nclass=\"md-background-bg\" width=\"3\"><md-menu-item ng-repeat=\"period in vm.listPeriod\"><md-button \naria-label=\"{{period.effectiveDate}}\" ng-click=\"vm.showBehivor(period.effectiveDate)\"><span class=\"secondary-text\">\n<span><md-icon md-font-icon=\"icon-check\" ng-if=\"period.effectiveDate == vm.currentDate\"></md-icon><md-icon \nng-if=\"!period.effectiveDate\"></md-icon>{{period.effectiveDate}}</span></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div><div class=\"content\"><div class=\"md-whiteframe-4dp\" id=\"inputView\" \nlayout=\"column\"><form name=\"formEmpIdp\" class=\"md-inline-form\" novalidate><div class=\"form-title\" \nstyle=\"margin-bottom: 10px\">A. Aspiration for future roles (Role / Readiness)</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"aspiration\" ng-model=\"vm.formEmpIdp.aspiration\" \nplaceholder=\"Aspiration\" required><div ng-messages=\"formEmpIdp.aspiration.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Aspiration field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><div class=\"form-title\">\nB. Development actions done from beg. {{vm.development_year}} till now&nbsp;&nbsp; <a href=\"javascript:void(0);\" \nng-click=\"vm.addDevelopment()\"><md-icon md-font-icon=\"icon-plus-circle\" style=\"color: #009933\"></md-icon></a></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-repeat=\"de in vm.developmentLists\">\n<md-input-container flex><label>Development Activities</label><input type=\"text\" name=\"activities\" \nng-model=\"de.activities\"></md-input-container><md-input-container flex><label>Time</label><input type=\"text\" \nname=\"time\" ng-model=\"de.time\"></md-input-container><md-input-container flex><label>Institution</label><input \ntype=\"text\" name=\"institution\" ng-model=\"de.institution\"></md-input-container><md-input-container flex \nstyle=\"max-width: 50px\"><a ng-if=\"$index !== 0\" href=\"javascript:void(0);\" ng-click=\"vm.removeDevelopment(de)\"><md-icon\n md-font-icon=\"icon-cancel\" style=\"color: #DD4B00\"></md-icon></a></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><div class=\"form-title\">\nC. Development plan for next 12-18 months&nbsp;&nbsp; <a href=\"javascript:void(0);\" ng-click=\"vm.addImprovement()\">\n<md-icon md-font-icon=\"icon-plus-circle\" style=\"color: #009933\"></md-icon></a></div></md-input-container></div><div \nng-repeat=\"im in vm.improvementLists\" class=\"{{(($index % 2) !== 0)?\'green-50-bg\':\'\'}}\" \nstyle=\"padding: 10px; border-radius: 5px\"><div layout=\"column\" flex layout-gt-xs=\"row\"><md-input-container flex><label>\nArea for Improvement</label><md-select ng-model=\"im.area_for_improvement\" \nng-change=\"vm.setReq(im.area_for_improvement, im)\"><md-option ng-repeat=\"competency in vm.jobCodeProfileLists\" \nvalue=\"{{competency.id}}\">{{competency.competency}}</md-option></md-select></md-input-container><md-input-container \nflex><label>Req</label><input type=\"text\" name=\"req\" ng-model=\"im.req\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex><label>Act</label><md-select ng-model=\"im.act\" ng-change=\"vm.setGap(im)\"><md-option \nng-repeat=\"act in vm.improvementLevelList\" value=\"{{act.level}}\">{{act.level}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Gap</label><input type=\"text\" name=\"gap\" ng-model=\"im.gap\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"column\" flex layout-gt-xs=\"row\"><md-input-container flex>\n<label>Development Category</label><md-select ng-model=\"im.idp_development_category_id\"><md-option \nng-repeat=\"dc in vm.developmentCategoryList\" value=\"{{dc.id}}\">{{dc.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Development Plan</label><input type=\"text\" name=\"development_plan\" \nng-model=\"im.development_plan\"></md-input-container><md-input-container flex><label>Estimated Time</label><input \ntype=\"text\" name=\"estimated_time\" ng-model=\"im.estimated_time\"></md-input-container><md-input-container flex><label>\nActial Development</label><input type=\"text\" name=\"actual_development\" ng-model=\"im.actual_development\">\n</md-input-container><md-input-container flex=\"1\"><a ng-if=\"$index !== 0\" href=\"javascript:void(0);\" \nng-click=\"vm.removeImprovement(im)\"><md-icon md-font-icon=\"icon-cancel\" style=\"color: #DD4B00\"></md-icon></a>\n</md-input-container></div></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formEmpIdp.$invalid || formEmpIdp.$pristine\">Submit</md-button></form></div></div></div>");
$templateCache.put("app/main/pms/kpi/inputkpi/inputkpi.html","<md-dialog aria-label=\"New KPI {{vm.year}}\" flex=\"45\" id=\"formKpiPeople\" md-theme=\"modal-theme\"><form ng-cloak \nname=\"formSetKpi\" class=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveKpiPeople($event,formSetKpi)\">\n<md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"title\"><span \ntranslate=\"KPI.LABEL.NEWKPI\"></span> {{vm.year}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nlayout=\"row\" layout-xs=\"column\"><md-autocomplete flex ng-disabled=\"vm.stateEdit&&!vm.ableToEdit\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.kpiId\" md-search-text=\"vm.Form.objForm.kpi\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-selected-item-change=\"vm.selectedItemChanged(item)\" \nmd-items=\"item in vm.getKpi(vm.Form.objForm.kpi)\" md-min-length=\"3\" md-input-name=\"kpiId\" md-item-text=\"item.kpi\" \nrequired md-floating-label=\"{{\'KPI.LABEL.KEYPERFORM\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.kpi\">{{item.kpi}}</span></md-item-template></md-autocomplete><md-input-container \nclass=\"md-block\" flex><input type=\"text\" name=\"description\" ng-model=\"vm.Form.objForm.description\" \nplaceholder=\"{{\'KPI.LABEL.DESCRIPTION\' | translate}}\" \nng-disabled=\"vm.isDisabled || (vm.stateEdit && vm.Approved==\'Approved\')\" required></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container flex flex-xs=\"100\" class=\"test input-height\"><input type=\"text\" \nname=\"uom\" ng-model=\"vm.Form.objForm.uom\" placeholder=\"{{\'KPI.LABEL.UOM\' | translate}}\" required \nng-disabled=\"vm.stateEdit && vm.Approved==\'Approved\'\"><div ng-messages=\"formSetKpi.uom.$error\" role=\"alert\" \nclass=\"is-active\"><div ng-message=\"required\"><span>Unit Of Measurement is required.</span></div></div>\n</md-input-container><md-input-container flex flex-xs=\"100\" class=\"test input-height\"><input type=\"number\" \nname=\"bobot\" ng-model=\"vm.Form.objForm.bobot\" placeholder=\"{{\'KPI.LABEL.WEIGHT\' | translate}} (%)\" \nmax=\"{{vm.maxweight}}\" min=\"0\" step=\"0.1\" required ng-disabled=\"vm.stateEdit && vm.Approved==\'Approved\'\"><div \nng-messages=\"formSetKpi.bobot.$error\" role=\"alert\" class=\"is-active\"><div ng-message=\"required\"><span>\n{{\'KPI.LABEL.WEIGHT\' | translate}} is required.</span></div><div ng-message=\"max\"><span>\n{{\'KPI.LABEL.WEIGHT\' | translate}} is required. & Max:{{vm.maxweight}}</span></div></div></md-input-container></div>\n<div layout=\"row\" layout-xs=\"column\"><md-input-container flex flex-xs=\"100\" class=\"input-height test\"><label>\n{{\'KPI.LABEL.STARTDATE\' | translate}} ({{\'KPI.LABEL.SELECTMONTH\' | translate}})</label><md-select \nng-model=\"vm.Form.objForm.effectiveDate\" ng-change=\"vm.setExpiredMonths(vm.Form.objForm.effectiveDate)\" \naria-label=\"effectiveDate\" name=\"effectiveDate\" required><md-option ng-repeat=\"ls in vm.months\" placeholder=\"Month\" \nvalue=\"{{ls.value}}\">{{ls.view}}</md-option></md-select><div ng-messages=\"formSetKpi.effectiveDate.$error\" \nrole=\"alert\" class=\"is-active\"><div ng-message=\"valid\">The entered value is not a date!</div><div \nng-message=\"required\">{{\'KPI.LABEL.STARTDATE\' | translate}} is required!</div></div></md-input-container>\n<md-input-container flex flex-xs=\"100\" class=\"input-height test\"><label>\n{{\'KPI.LABEL.ENDDATE\' | translate}} ({{\'KPI.LABEL.SELECTMONTH\' | translate}})</label><md-select \nng-model=\"vm.Form.objForm.expiredDate\" aria-label=\"expiredDate\" name=\"expiredDate\" required><md-option \nng-repeat=\"ls in vm.expiredMonths\" placeholder=\"Month\" value=\"{{ls.value}}\">{{ls.view}}</md-option></md-select><div \nng-messages=\"formSetKpi.expiredDate.$error\" role=\"alert\" class=\"is-active\"><div ng-message=\"valid\">\nThe entered value is not a date!</div><div ng-message=\"required\">{{\'KPI.LABEL.ENDDATE\' | translate}} is required!</div>\n</div></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex layout=\"column\" \nclass=\"csm-margin-radio\"><md-radio-group ng-model=\"vm.Form.objForm.valueType\" \nng-disabled=\"vm.stateEdit && vm.Approved==\'Approved\'\" name=\"valueType\" ng-required=\"true\" \nclass=\"radio-component md-accent\"><div class=\"row is-radio\"><div layout=\"row\" layout-align=\"start center\"><div flex \nclass=\"radio-space\"><span>Value Type * :</span></div><md-radio-button flex value=\"average\" style=\"max-width:120px\">\nAverage</md-radio-button><md-radio-button flex value=\"last-value\">Last Value</md-radio-button></div><div \nng-messages=\"formSetKpi.valueType.$error\" role=\"alert\" class=\"is-active\"><div ng-message=\"required\">This is required!\n</div></div></div></md-radio-group></md-input-container><md-input-container flex layout=\"column\" \nclass=\"csm-margin-radio\"><md-radio-group ng-change=\"vm.resetFieldScales()\" ng-model=\"vm.Form.objForm.valueCategory\" \nng-disabled=\"vm.stateEdit && vm.Approved==\'Approved\'\" name=\"valueCategory\" ng-required=\"true\" \nclass=\"radio-component md-accent\"><div class=\"row is-radio\"><div layout=\"row\" layout-align=\"start center\"><div flex \nclass=\"radio-space\"><span>Value Category * :</span></div><md-radio-button flex value=\"increase\" \nstyle=\"max-width:120px\">Increase</md-radio-button><md-radio-button flex value=\"decrease\">Decrease</md-radio-button>\n</div><div ng-messages=\"formSetKpi.valueCategory.$error\"><div ng-message=\"required\">This is required!</div></div></div>\n</md-radio-group></md-input-container></div><fieldset class=\"csm-fieldset\"><legend>\n{{\'KPI.LABEL.TARGETSETTING\' | translate}} <span ng-if=\"vm.isFalseSetting\" style=\"font-style: italic;color:red\">(<span \ntranslate=\"MENU.MAIN.TARGETNOTMATCH\"></span>)</span></legend><div layout=\"column\"><md-radio-group \nng-model=\"vm.Form.objForm.targetID\" required class=\"md-warn\" ng-disabled=\"vm.stateEdit && vm.Approved==\'Approved\'\"><div\n layout=\"row\" layout-align=\"center center\" ng-repeat=\"scale in vm.Form.objForm.listScale\"><div flex=\"5\" \nclass=\"has-target\" style=\"vertical-align: middle\"><span class=\"is-target\">{{($index + 1)}}</span></div>\n<md-input-container flex><input name=\"description{{$index}}\" ng-model=\"vm.Form.objForm.listScale[$index].description\" \nplaceholder=\"{{\'KPI.LABEL.DESCRIPTION\' | translate}}\" required><div \nng-messages=\"formSetKpiScale[\'description\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'KPI.LABEL.DESCRIPTION\' | translate}} is required.</span></div></div></md-input-container><md-input-container \nflex=\"15\"><input name=\"min{{$index}}\" check-target-setting-value-min=\"vm.Form.objForm.listScale[$index].max\" \nvalue-category=\"vm.Form.objForm.valueCategory\" ng-model=\"vm.Form.objForm.listScale[$index].min\" \nng-change=\"vm.checkValue(vm.Form.objForm.listScale[$index].min,vm.Form.objForm.listScale[$index].max)\" \nplaceholder=\"min\" required type=\"number\"><div ng-messages=\"formSetKpiScale[\'min\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\"><span>Min is required.</span></div><div ng-message=\"target-setting-min\"><span>\nMin value not valid.</span></div></div></md-input-container><md-input-container flex=\"15\"><input name=\"max{{$index}}\" \nng-model=\"vm.Form.objForm.listScale[$index].max\" placeholder=\"max\" \nng-change=\"vm.checkValue(vm.Form.objForm.listScale[$index].min,vm.Form.objForm.listScale[$index].max)\" required \ntype=\"number\"><div ng-messages=\"formSetKpiScale[\'max\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMax is required.</span></div></div></md-input-container></div></md-radio-group></div></fieldset></md-dialog-content>\n<md-dialog-actions layout=\"row\"><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget>\n<md-button class=\"is-md-accent md-refresh md-button\" ng-click=\"vm.setToken()\">{{\'KPI.LABEL.REFRESHFORM\' | translate}}\n</md-button><md-button class=\"is-md-accent md-accent md-button\" ng-disabled=\"formSetKpi.$invalid || vm.saveProcess\" \ntype=\"submit\">{{\'KPI.LABEL.SAVE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/kpi/inputscale/inputscale.html","<md-dialog aria-label=\"New KPI {{vm.year}}\" flex=\"70\" id=\"formKpiPeople\"><form ng-cloak name=\"formSetKpiScale\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveKpiScale($event,formSetKpiScale)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Set Scale KPI</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"background: #ffffff\"><div layout=\"row\"><md-input-container \nflex=\"70\"><textarea disabled=\"disabled\" ng-model=\"vm.kpi.kpi\" placeholder=\"Key Performance Indicator\" required> \n</textarea></md-input-container><md-input-container flex=\"10\"><input type=\"text\" disabled=\"disabled\" \nng-model=\"vm.kpi.uom\" placeholder=\"UOM\" required></md-input-container><md-input-container flex=\"10\"><input type=\"text\" \ndisabled=\"disabled\" ng-model=\"vm.kpi.weight\" placeholder=\"Weight\" required></md-input-container><md-input-container \nflex=\"10\"><input type=\"text\" disabled=\"disabled\" ng-model=\"vm.kpi.target\" placeholder=\"Target (%)\" required>\n</md-input-container></div><table class=\"simple\" ms-responsive-table id=\"kpiTable\" style=\"margin-top:10px\"><thead><tr>\n<th>Scale</th><th>Description</th><th>Min</th><th>Max</th><th></th></tr></thead><tbody><tr \nng-repeat=\"scale in vm.Form.objForm.listScale\"><td>{{($index + 1)}}</td><td><md-input-container flex><input \nname=\"description{{$index}}\" ng-model=\"vm.Form.objForm.listScale[$index].description\" placeholder=\"Description\" \nrequired><div ng-messages=\"formSetKpiScale[\'description\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required.</span></div></div></md-input-container></td><td><md-input-container flex><input \nname=\"min{{$index}}\" ng-model=\"vm.Form.objForm.listScale[$index].min\" placeholder=\"min\" required><div \nng-messages=\"formSetKpiScale[\'min\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>Min is required.\n</span></div></div></md-input-container></td><td><md-input-container flex><input name=\"max{{$index}}\" \nng-model=\"vm.Form.objForm.listScale[$index].max\" placeholder=\"max\" required><div \nng-messages=\"formSetKpiScale[\'max\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>Max is required.\n</span></div></div></md-input-container></td><td></td></tr></tbody></table><ms-widget flippable=\"false\" \nlayout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" type=\"submit\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button \nclass=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh white-fg\">\n</md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/kpi-nabati/set-team-all/set-team-all-scale.html","<md-dialog aria-label=\"Set Kpi Scales\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloak name=\"formSetKpi\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-primary hue-3\"><div class=\"md-toolbar-tools\"><h2><md-icon \nmd-font-icon=\"icon-poll\"></md-icon><span translate=\"KPI.LABEL.VIEWKPISCALE\"></span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeKpi()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialogSetKPI\"><table \nwidth=\"100%\"><tr><td valign=\"top\"><span translate=\"KPI.LABEL.KEYPERFORM\"></span></td><td valign=\"top\"><span \ntranslate=\"KPI.LABEL.UOM\"></span></td><td valign=\"top\"><span translate=\"KPI.LABEL.WEIGHT\"></span></td><td valign=\"top\">\n<span translate=\"KPI.LABEL.TARGET\"></span></td></tr><tr style=\"font-weight:bold\"><td valign=\"top\">{{vm.kpidesc}}</td>\n<td valign=\"top\">{{vm.uom}}</td><td valign=\"top\">{{vm.bobot}}</td><td valign=\"top\">{{vm.target}}</td></tr></table>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" \nid=\"datatable\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.SCALE\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.DESCRIPTION\"></span></span></div></th><th class=\"secondary-text\" \nwidth=\"10%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.MIN\"></span></span></div>\n</th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.MAX\"></span></span></div></th></tr></thead><tbody><tr ng-repeat=\"ks in vm.listkpiscale\"><td \nalign=\"center\">{{ ks.no_urut}}</td><td>{{ ks.scale}}</td><td>{{ ks.start}}</td><td>{{ ks.finish}}</td></tr></tbody>\n</table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pms/kpi-nabati/set-team-all/set-team-all.html","<form ng-cloak name=\"formSetKpi\" class=\"md-inline-form\" novalidate><div id=\"kpi\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header Oct\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-account-check\"></md-icon></span><span class=\"logo-text\"><span>\nVIEW KPI YEAR {{vm.yearSelected}} / {{vm.nik}}</span></span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\"><div class=\"selected-action\">YEARS</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year.year}}\" \nng-click=\"vm.showKpi(year.year)\"><span class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><div class=\"content\"><div id=\"kpiView\" \nclass=\"md-whiteframe-4dp\" layout=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-menu \nmd-offset=\"18 48\"><md-button aria-label=\"Open demo menu \" class=\"md-raised\" ng-click=\"$mdOpenMenu()\">Action<md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>click for view actions</span></md-tooltip></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button class=\"md-raised reference-button md-warn md-hue-2\" \nng-disabled=\"formSetKpi.$invalid || formSetKpi.$pristine\" ng-click=\"vm.approveKS($event)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span>Approve</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n<table class=\"simple\" ms-responsive-table id=\"kpiTable\"><thead><tr><th></th><th>No</th><th>KPI</th><th>WEIGHT</th><th>\nUOM</th><th>TARGET</th><th>START DATE</th><th>END DATE</th><th>STATUS APPROVAL</th></tr></thead><tbody><tr \nng-repeat=\"ks in vm.listkpi\" ng-click=\"vm.select(ks)\"><td><div ng-if=\"ks.status===\'Submitted\'\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(ks)\" ng-click=\"vm.toggleCheck(ks, $event)\" ng-model=\"isCovered\" \nng-change=\"formSetKpi.$setValidity(\'required\', vm.listKSSelected.length > 0)\" \naria-label=\"{{vm.isChecked(ks)? \'Uncheck\':\'check\'}}\"></md-checkbox></div><div ng-else></div></td><td align=\"center\">\n{{ ($index + 1)}}</td><td align=\"left\"><a href=\"\" ng-click=\"vm.viewScales($event,ks.idks)\" \nstyle=\"text-decoration:underline\">{{ ks.kpi}}</a></td><td align=\"center\">{{ ks.bobot}}</td><td>{{ ks.uom}}</td><td>\n{{ ks.target}}</td><td align=\"center\">{{ ks.effectiveDate}}</td><td align=\"center\">{{ ks.expiredDate}}</td><td \nalign=\"center\"><span>{{ ks.status}}</span><md-button ng-if=\"ks.status==\'Approved\'\" class=\"md-icon-button\" \nng-click=\"vm.removeApproval(ks.id,ks.kpi,$event)\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s16 red-500-fg\"></md-icon></md-button></td></tr></tbody></table><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front red-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.pesan}}</p></ms-widget-front></ms-widget><span flex></span></div>\n</div></div></form>");
$templateCache.put("app/main/pms/kpi-result/inputresult/editresult.html","<md-dialog aria-label=\"New KPI {{vm.year}}\" flex=\"55\" md-theme=\"modal-theme\"><form ng-cloak name=\"formSetKpiResult\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveKpiResult($event,formSetKpiResult)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"KPI.LABEL.EDITKPIRESULT\"></span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content style=\"background: #ffffff;overflow: auto\"><div class=\"md-dialog-content table-2 is-table-simple\" \nlayout=\"column\"><div layout=\"row\"><md-input-container flex=\"50\"><textarea disabled=\"disabled\" ng-model=\"vm.kpi.kpi\" \nplaceholder=\"{{ \'KPI.LABEL.KEYPERFORM\' | translate }}\" required> </textarea></md-input-container><md-input-container \nflex=\"10\"><input type=\"text\" disabled=\"disabled\" ng-model=\"vm.kpi.uom\" placeholder=\"{{ \'KPI.LABEL.UOM\' | translate }}\">\n</md-input-container><md-input-container flex=\"10\"><input type=\"text\" disabled=\"disabled\" ng-model=\"vm.kpi.weight\" \nplaceholder=\"{{ \'KPI.LABEL.WEIGHT\' | translate }}\" required></md-input-container><md-input-container flex=\"20\"><input \ntype=\"text\" disabled=\"disabled\" ng-model=\"vm.kpi.target\" placeholder=\"{{ \'KPI.LABEL.TARGET\' | translate }} (%)\" \nrequired></md-input-container></div><div layout=\"column\" layout-align=\"center start \"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header mb-10\" ms-responsive-table><thead><tr><td \ncolspan=\"4\" class=\"text-boxed\">Table : <span translate=\"KPI.LABEL.KPISCALEREF\"></span></td></tr><tr><th width=\"5%\" \nstyle=\"text-align: center\"><span translate=\"KPI.LABEL.NO\"></span></th><th width=\"30%\" style=\"text-align: center\"><span \ntranslate=\"KPI.LABEL.DESCRIPTION\"></span></th><th width=\"10%\" style=\"text-align: center\">Min</th><th width=\"10%\" \nstyle=\"text-align: center\">Max</th></tr></thead><tbody><tr ng-repeat=\"item in vm.kpiScaleDetail\"><td \nstyle=\"text-align: center\">{{item.no_urut}}</td><td style=\"text-align: center\">{{item.description}}</td><td \nstyle=\"text-align: center\">{{item.min | number:2}}</td><td style=\"text-align: center\">{{item.max | number:2}}</td></tr>\n</tbody></table></div><div class=\"padding-5\"></div><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table><thead><tr><th><span \ntranslate=\"KPI.LABEL.NO\"></span></th><th style=\"text-align: left\"><span translate=\"KPI.LABEL.RESULTDESCRIPTION\"></span>\n</th><th style=\"text-align: left\"><span translate=\"KPI.LABEL.RESULTVALUE\"></span></th><th style=\"text-align: left\">\n<span translate=\"KPI.LABEL.RESULTDATE\"></span></th><th></th></tr></thead><tbody><tr \nng-repeat=\"kpi in vm.listKpiResult\"><form name=\"frmEditResult{{$index}}\" flex><td style=\"text-align: center\">\n{{($index + 1)}}</td><td style=\"text-align: left\"><span ng-show=\"!vm.listKpiResult[$index].stateEdit\">{{kpi.result}}\n</span> <input ng-show=\"vm.listKpiResult[$index].stateEdit\" type=\"text\" ng-model=\"vm.listKpiResult[$index].result\">\n</td><td style=\"text-align: left\"><span ng-show=\"!vm.listKpiResult[$index].stateEdit\">{{kpi.kpiValue}}</span> <input \nng-show=\"vm.listKpiResult[$index].stateEdit\" type=\"text\" style=\"width:80%\" \nng-model=\"vm.listKpiResult[$index].kpiValue\"></td><td style=\"text-align: left\"><span \nng-show=\"!vm.listKpiResult[$index].stateEdit\">{{kpi.resultDate}}</span><md-select \nng-show=\"vm.listKpiResult[$index].stateEdit\" ng-model=\"vm.listKpiResult[$index].bulan\" required><md-optgroup \nlabel=\"ResultDate\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.items\">{{item.value}}</md-option></md-optgroup>\n</md-select></td><td><div layout=\"row\"><md-button ng-show=\"vm.listKpiResult[$index].stateEdit\" \nng-click=\"vm.UpdateResult($index)\"><span translate=\"KPI.LABEL.EDIT\"></span></md-button><md-button \nng-show=\"vm.listKpiResult[$index].stateEdit\" ng-click=\"vm.cancelUpdateResult($index)\"><span \ntranslate=\"KPI.LABEL.CANCEL\"></span></md-button></div><md-button ng-if=\"vm.listKpiResult[$index].Allowedit\" \nng-show=\"!vm.listKpiResult[$index].stateEdit\" ng-click=\"vm.editResult($index)\"><span translate=\"KPI.LABEL.EDIT\"></span>\n</md-button><md-button ng-if=\"vm.listKpiResult[$index].Allowedit\" ng-show=\"!vm.listKpiResult[$index].stateEdit\" \nng-click=\"vm.deleteResult($index)\"><span translate=\"KPI.LABEL.DELETE\"></span></md-button></td></form></tr></tbody>\n</table><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" \nclass=\"fade\"><ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front>\n</ms-widget></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pms/kpi-result/inputresult/inputresult.html","<md-dialog aria-label=\"New KPI {{vm.year}}\" flex=\"50\" id=\"formKpiPeople\" md-theme=\"modal-theme\"><form ng-cloak \nname=\"formSetKpiResult\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveKpiResult($event,formSetKpiResult)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Input KPI Result</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"background: #ffffff\"><div layout=\"row\"><md-input-container \nflex=\"50\"><textarea disabled=\"disabled\" ng-model=\"vm.kpi.kpi\" placeholder=\"Key Performance Indicator\" required> \n</textarea></md-input-container><md-input-container flex=\"10\"><input type=\"text\" disabled=\"disabled\" \nng-model=\"vm.kpi.uom\" placeholder=\"UOM\"></md-input-container><md-input-container flex=\"10\"><input type=\"text\" \ndisabled=\"disabled\" ng-model=\"vm.kpi.weight\" placeholder=\"Weight\" required></md-input-container><md-input-container \nflex=\"20\"><input type=\"text\" disabled=\"disabled\" ng-model=\"vm.kpi.target\" placeholder=\"Target (%)\" required>\n</md-input-container></div><div layout=\"row\" layout-align=\"center start \"><table \nclass=\"simple with-toolbar fullwidth-table upper-case-header\" ms-responsive-table><thead><tr><th width=\"5%\" \nstyle=\"text-align: center\">No.</th><th width=\"30%\" style=\"text-align: center\">Description</th><th width=\"10%\" \nstyle=\"text-align: center\">Min</th><th width=\"10%\" style=\"text-align: center\">Max</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.kpiScaleDetail\"><td style=\"text-align: center\">{{item.no_urut}}</td><td \nstyle=\"text-align: center\">{{item.description}}</td><td style=\"text-align: center\">{{item.min | number:2}}</td><td \nstyle=\"text-align: center\">{{item.max | number:2}}</td></tr><tr><td colspan=\"4\" class=\"text-boxed\">\nTable : KPI Scale Detail References</td></tr></tbody></table></div><div class=\"padding-5\"></div><div layout=\"column\">\n<md-input-container class=\"md-block\" flex><input type=\"text\" name=\"result\" ng-model=\"vm.Form.objForm.result\" \nplaceholder=\"Result Description\" required><div ng-messages=\"formSetKpiResult.result.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Result Description is required</span></div></div></md-input-container><div layout=\"row\">\n<md-input-container flex><input type=\"number\" name=\"kpiValue\" ng-model=\"vm.Form.objForm.kpiValue\" min=\"{{vm.min}}\" \nmax=\"{{vm.max}}\" placeholder=\"Results Value\" required><div ng-messages=\"formSetKpiResult.kpiValue.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Result Value is required min :{{vm.min}} , max : {{vm.max}}</span></div></div>\n</md-input-container><md-input-container flex><label>Result Date</label><md-select \nng-model=\"vm.Form.objForm.resultDate\" required><md-optgroup label=\"ResultDate\"><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.items\">{{item.value}}</md-option></md-optgroup></md-select><div \nng-messages=\"formSetKpiResult.resultDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nResult Date Value is required</span></div></div></md-input-container></div></div><ms-widget flippable=\"false\" \nlayout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" type=\"submit\" \nng-disabled=\"formSetKpiResult.$invalid || formSetKpiResult.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button \nclass=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh white-fg\">\n</md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/kpi-scales/input-kpi-scales/input-kpi-scales.html","<form ng-cloak name=\"formSetKpi\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveKpiScales($event,formSetKpi)\"><div\n class=\"content\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"80\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><md-toolbar \nclass=\"md-accent hue-3\"><div class=\"md-toolbar-tools\"><h2><md-icon md-font-icon=\"icon-poll\"></md-icon>KPI Scales</h2>\n<span flex></span></div></md-toolbar><div layout-gt-xs=\"row\"><md-autocomplete flex ng-disabled=\"vm.isDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedContact\" md-search-text=\"vm.searchString\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchString)\" md-selected-item-change=\"vm.selectedItemChanged()\" \nmd-items=\"item in vm.getContactsByFullName(vm.searchString)\" md-min-length=\"3\" md-item-text=\"item.kpi\" \nmd-floating-label=\"Key Performance Indicator\"><md-item-template><span md-highlight-text=\"vm.searchString\">{{item.kpi}}\n</span></md-item-template></md-autocomplete><md-input-container class=\"md-block\" flex><input type=\"text\" \nname=\"description\" ng-model=\"vm.Form.objForm.description\" placeholder=\"Description\" required></md-input-container>\n</div><md-input-container flex><input type=\"number\" name=\"bobot\" ng-model=\"vm.Form.objForm.bobot\" placeholder=\"Bobot\" \nmax=\"100\" min=\"0\" step=\"0.1\" required><div ng-messages=\"formSetKpi.bobot.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Bobot is required. & Max:100</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" name=\"uom\" ng-model=\"vm.Form.objForm.uom\" placeholder=\"Unit Of Measurement\" required><div \nng-messages=\"formSetKpi.uom.$error\" role=\"alert\"><div ng-message=\"required\"><span>Unit Of Measurement is required.\n</span></div></div></md-input-container><div layout-gt-xs=\"row\"><md-input-container flex><label>Scale 1</label><input \ntype=\"text\" name=\"scale1\" ng-model=\"vm.Form.objForm.scale1\" placeholder=\"Description\" required></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"start1\" ng-model=\"vm.Form.objForm.start1\" placeholder=\"start\" \nstep=\"0.1\" max=\"100\"></md-input-container><md-input-container flex><input type=\"number\" name=\"finish1\" \nng-model=\"vm.Form.objForm.finish1\" placeholder=\"finish\" step=\"0.1\" max=\"100\"></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container flex><label>Scale 2</label><input type=\"text\" name=\"scale2\" \nng-model=\"vm.Form.objForm.scale2\" placeholder=\"Description\" required></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"start2\" ng-model=\"vm.Form.objForm.start2\" placeholder=\"start\" step=\"0.1\" max=\"100\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"finish2\" ng-model=\"vm.Form.objForm.finish2\" \nplaceholder=\"finish\" step=\"0.1\" max=\"100\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex>\n<label>Scale 3</label><input type=\"text\" name=\"scale3\" ng-model=\"vm.Form.objForm.scale3\" placeholder=\"Description\" \nrequired></md-input-container><md-input-container flex><input type=\"text\" name=\"start3\" \nng-model=\"vm.Form.objForm.start3\" placeholder=\"start\" step=\"0.1\" max=\"100\"></md-input-container><md-input-container \nflex><input type=\"text\" name=\"finish3\" ng-model=\"vm.Form.objForm.finish3\" placeholder=\"finish\" step=\"0.1\" max=\"100\">\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex><label>Scale 4</label><input type=\"text\" \nname=\"scale4\" ng-model=\"vm.Form.objForm.scale4\" placeholder=\"Description\" required></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"start4\" ng-model=\"vm.Form.objForm.start4\" placeholder=\"start\" \nstep=\"0.1\" max=\"100\"></md-input-container><md-input-container flex><input type=\"text\" name=\"finish4\" \nng-model=\"vm.Form.objForm.finish4\" placeholder=\"finish\" step=\"0.1\" max=\"100\"></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container flex><label>Scale 5</label><input type=\"text\" name=\"scale5\" \nng-model=\"vm.Form.objForm.scale5\" placeholder=\"Description\" required></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"start5\" ng-model=\"vm.Form.objForm.start5\" placeholder=\"start\" step=\"0.1\" max=\"100\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"finish5\" ng-model=\"vm.Form.objForm.finish5\" \nplaceholder=\"finish\" step=\"0.1\" max=\"100\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex>\n<input type=\"text\" name=\"target\" ng-model=\"vm.Form.objForm.target\" placeholder=\"Target\" required><div \nng-messages=\"formSetKpi.target.$error\" role=\"alert\"><div ng-message=\"required\"><span>target is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Effective Date</label><md-datepicker \nng-model=\"vm.Form.objForm.effectiveDate\" name=\"effectiveDate\" id=\"effectiveDate\" aria-label=\"effective date\" required>\n</md-datepicker><div ng-messages=\"formSetKpi.effectiveDate.$error\"><div ng-message=\"valid\">\nThe entered value is not a date!</div><div ng-message=\"required\">This date is required!</div></div>\n</md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div flex \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" class=\"md-raised md-default\" aria-label=\"Submit\" \nng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh\" aria-label=\"save\"></md-icon>Refresh Token</md-button>\n<md-button type=\"submit\" class=\"md-raised md-warn hue-3\" aria-label=\"Submit\" \nng-disabled=\"formSetKpi.$invalid || formSetKpi.$pristine\"><md-icon md-font-icon=\"icon-cloud-upload\" aria-label=\"save\">\n</md-icon>SAVE</md-button></div></div></div></div></form>");
$templateCache.put("app/main/pms/emp-potential/set-potential-member/set-input-potential-member.html","<md-dialog aria-label=\"{{vm.title}} Competency Review\" flex=\"50\" id=\"formEmpPotential\"><form ng-cloak \nname=\"formEmpPotential\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formEmpPotential)\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>{{vm.title}} Input High Potential Talent Review {{vm.resultDateAlias}}</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><input type=\"hidden\" ng-model=\"vm.Form.objForm.questioner_category_id\"> <input type=\"hidden\" \nng-model=\"vm.Form.objForm.nik\"> <input type=\"hidden\" ng-model=\"vm.Form.objForm.rating_label\"><div layout=\"row\" \nclass=\"ng-scope layout-row\"><div flex-gt-sm=\"100\" flex=\"100\"><div layout=\"row\"><md-input-container flex=\"100\" \nclass=\"md-block md-input-has-value\"><label>Potential</label><input type=\"text\" \nvalue=\"{{vm.input.questioner_category_name}}\" style=\"color: #000\" disabled=\"disabled\"><p style=\"padding-top: 20px\"><i \nstyle=\"font-size: small\">\"{{vm.input.questioner_category_description}}\"</i></p></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"100\" class=\"md-block md-input-has-value\"><label>Questioner</label><input \ntype=\"text\" value=\"{{\'Q\' + vm.input.questioner_id + \' - \' + vm.input.questioner}}\" style=\"color: #000\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" \nclass=\"md-block md-input-has-value\"><label>Rating</label><md-select ng-model=\"vm.Form.objForm.rating\" \nng-change=\"vm.setRatingLabel(vm.Form.objForm.rating)\" required><md-option ng-value=\"l.rate_value\" \nng-repeat=\"l in vm.listRating\">{{l.rate_label}}</md-option></md-select><div \nng-messages=\"formEmpPotential[\'rating\'].$error\" role=\"alert\"><div ng-message=\"required\"><span>Rating is required.\n</span></div></div></md-input-container></div><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-disabled=\"formEmpPotential.$invalid\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save\n</md-button><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/emp-potential/set-potential-member/set-potential-member.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\"><div\n layout=\"row\"><div ng-class=\"vm.setSummaryClass(vm.score.summary_id)\" \nng-if=\"vm.remaining === 0 && (vm.score.engagement > 0 || vm.score.aspiration > 0 || vm.score.ability > 0)\">\n{{(vm.score.engagement > 0 || vm.score.aspiration > 0 || vm.score.ability > 0)?vm.score.summary:\'\'}}</div><div \nclass=\"md-subhead orange-A700-fg\" ng-if=\"vm.remaining > 0\">{{vm.remaining}} Remaining</div></div></md-subheader><div \nclass=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\"><div flex layout=\"row\" id=\"input_button_toggle\">\n<md-input-container class=\"md-block md-input-has-value\"><md-buttons-toggle-potential items=\"vm.languageList\" \nng-model=\"vm.language\" selected-class=\"md-accent\"></md-buttons-toggle-potential></md-input-container></div><span flex \nhide show-gt-sm></span><div><md-button class=\"md-blue-grey-300-bg md-raised white-fg\" ui-sref=\"app.pms_emp_potential\">\nBack</md-button></div></div></md-toolbar><md-content layout=\"column\" layout-padding layout-fill class=\"white-bg\"><div \nlayout=\"row\"><div flex layout=\"column\" style=\"padding: 7px\"><div layout=\"row\"><div flex=\"20\">Nik</div><div flex=\"100\">\n: {{vm.profile[0].nik}}</div></div><div layout=\"row\"><div flex=\"20\">Name</div><div flex=\"100\">\n: {{vm.profile[0].title + \'. \' + vm.profile[0].first_name + \' \' + vm.profile[0].last_name}}</div></div><div \nlayout=\"row\"><div flex=\"20\">Period</div><div flex=\"20\"><md-select ng-model=\"vm.Form.period\" ng-change=\"vm.loadData()\" \nclass=\"mt-0\"><md-option ng-repeat=\"y in vm.years\" value=\"{{y.year}}\" ng-selected=\"y.year == vm.currentYear\">{{y.year}}\n</md-option></md-select></div></div></div><div flex layout=\"row\"><div layout=\"row\"><table style=\"border: none\"><tr><td>\nEngagement</td><td>:</td><td>{{vm.score.engagement}}</td></tr><tr><td>Aspiration</td><td>:</td><td>\n{{vm.score.aspiration}}</td></tr><tr><td>Ability</td><td>:</td><td>{{vm.score.ability}}</td></tr></table></div></div>\n</div><ms-widget class=\"fade\" flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\"><ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p \nclass=\"form-messages\"><md-icon class=\"s16\" md-font-icon=\"icon-alert\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front>\n</ms-widget><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header mb-10 mt-10\" \nms-responsive-table><thead><tr><th>Potential</th><th>Questioner</th><th>Rating</th></tr></thead><tbody \nng-if=\"group.details !== undefined\" ng-repeat=\"group in vm.listInput\"><tr><td rowspan=\"{{group.details.length + 2}}\" \nstyle=\"text-align: center\"><div ng-if=\"vm.language !== \'ID\'\" style=\"font-weight: bold\">{{group.category_name_en}}:\n</div><div ng-if=\"vm.language !== \'ID\'\"><i style=\"font-size: small\">\"{{group.category_description_en}}\"</i></div><div \nng-if=\"vm.language === \'ID\'\" style=\"font-weight: bold\">{{group.category_name}}:</div><div ng-if=\"vm.language === \'ID\'\">\n<i style=\"font-size: small\">\"{{group.category_description}}\"</i></div></td></tr><tr><td class=\"potential-instruction\" \ncolspan=\"3\">{{(vm.language === \'ID\')?group.category_instruction:group.category_instruction_en}}</td></tr><tr \nng-repeat=\"input in group.details\"><td><div ng-if=\"vm.language !== \'ID\'\">\nQ{{input.questioner_id + \' - \' + input.questioner_en}}</div><div ng-if=\"vm.language === \'ID\'\">\nQ{{input.questioner_id + \' - \' + input.questioner}}</div></td><td style=\"text-align:center; white-space: nowrap\"><form \naction=\"javascript:void(0);\" id=\"frmEmployeePotential_{{input.questioner_id}}\" \nname=\"frmEmployeePotential[{{input.questioner_id}}]\" \nng-submit=\"vm.saveData($event, frmEmployeePotential[input.questioner_id])\" novalidate=\"\"><md-select \nng-change=\"vm.setRating(input)\" ng-model=\"input.rating\" placeholder=\"-- Rate\"><md-option \nng-if=\"group.category_id === r.potential_category_id\" ng-repeat=\"r in vm.ratingLists\" value=\"{{r.rate_value}}\">\n{{r.rate_label}}</md-option></md-select></form></td></tr></tbody></table></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/idp/set-idp-member/set-idp-member.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">Periode</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg csm-dropdown\"><md-button ria-label=\"{{period.effectiveDate}}\" \nng-click=\"vm.showBehivor(period.effectiveDate)\"><span class=\"secondary-text\"><span><md-icon md-font-icon=\"icon-check\" \nng-if=\"period.effectiveDate == vm.currentDate\"></md-icon><md-icon ng-if=\"!period.effectiveDate\"></md-icon>\n{{period.effectiveDate}}</span></span></md-button></md-menu-content></md-menu></div></div></div></div><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>Employee Individual Development Program</span></md-subheader><div class=\"white-bg\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div class=\"\" id=\"inputView\" layout=\"column\"><form \nname=\"formEmpIdp\" id=\"formEmpIdp\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event, formEmpIdp)\"><div \nng-if=\"vm.last_update\" style=\"float: right\"><small><em>\nLast update: {{vm.last_update.substr(0, vm.last_update.length - 3)}}</em></small></div><div class=\"form-title\">\nEmployee Profile:</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><div layout=\"row\"><div \nflex=\"10\">Nik</div><div flex=\"25\">: {{vm.profile[0].nik}}</div></div><div layout=\"row\"><div flex=\"10\">Name</div><div \nflex=\"50\">: {{vm.profile[0].title + \'. \' + vm.profile[0].first_name + \' \' + vm.profile[0].last_name}}</div></div>\n</md-input-container></div><div class=\"form-title\" style=\"margin-top: 10px; margin-bottom: 10px\">\nA. Aspiration for future roles (Role / Readiness)</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><input type=\"text\" name=\"aspiration\" ng-model=\"vm.aspiration\" placeholder=\"Aspiration\" required><div \nng-messages=\"formEmpIdp.aspiration.$error\" role=\"alert\"><div ng-message=\"required\"><span>Aspiration field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><div \nclass=\"form-title\">B. Development actions done from beg. {{vm.development_year}} till now&nbsp;&nbsp; <a \nhref=\"javascript:void(0);\" ng-click=\"vm.addDevelopment()\"><md-icon md-font-icon=\"icon-plus-circle green-500-fg\">\n</md-icon></a></div></md-input-container></div><div ng-repeat=\"de in vm.developmentLists\" \nclass=\"{{(($index % 2) !== 0)?\'green-50-bg\':\'blue-50-bg\'}}\" \nstyle=\"margin-bottom: 7px; padding: 10px; border-radius: 5px\"><a \nng-if=\"(vm.developmentLists.length <= 2)?($index !== 0):true\" href=\"javascript:void(0);\" \nng-click=\"vm.removeDevelopment(de)\" style=\"float: right\"><md-icon md-font-icon=\"icon-cancel red-500-fg\"></md-icon></a>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Development Activities</label><input \ntype=\"text\" name=\"activities\" ng-model=\"de.activities\" required></md-input-container><md-input-container flex><label>\nTime</label><input type=\"text\" name=\"activity_time\" ng-model=\"de.activity_time\"></md-input-container>\n<md-input-container flex><label>Institution</label><input type=\"text\" name=\"institution\" ng-model=\"de.institution\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><div \nclass=\"form-title\">C. Development plan for next 12-18 months&nbsp;&nbsp; <a href=\"javascript:void(0);\" \nng-click=\"vm.addImprovement()\"><md-icon md-font-icon=\"icon-plus-circle green-500-fg\"></md-icon></a></div>\n</md-input-container></div><div ng-repeat=\"im in vm.improvementLists\" \nclass=\"{{(($index % 2) !== 0)?\'green-50-bg\':\'blue-50-bg\'}}\" \nstyle=\"margin-bottom: 7px; padding: 10px; border-radius: 5px\"><a style=\"float: right\" \nng-if=\"(vm.improvementLists.length <= 2)?($index !== 0):true\" href=\"javascript:void(0);\" \nng-click=\"vm.removeImprovement(im)\"><md-icon md-font-icon=\"icon-cancel red-500-fg\"></md-icon></a><div layout=\"column\" \nflex layout-gt-xs=\"row\"><md-input-container flex><label>Area for Improvement</label><md-select \nng-model=\"im.area_for_improvement\" ng-change=\"vm.setReq(im.area_for_improvement, im)\" required><md-option \nng-repeat=\"competency in vm.jobCodeProfileLists\" value=\"{{competency.id}}\">{{competency.competency}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Req</label><input type=\"text\" name=\"req\" \nng-model=\"im.req\" disabled=\"disabled\"></md-input-container><md-input-container flex><label>Act</label><md-select \nng-model=\"im.act\" ng-change=\"vm.setGap(im)\"><md-option ng-value=\"0\">0</md-option><md-option \nng-repeat=\"act in vm.improvementLevelList\" ng-value=\"{{act.level}}\">{{act.level}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Gap</label><input type=\"text\" name=\"gap\" ng-model=\"im.gap\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"column\" flex layout-gt-xs=\"row\"><md-input-container flex>\n<label>Development Category</label><md-select ng-model=\"im.development_category_id\"><md-option \nng-repeat=\"dc in vm.developmentCategoryList\" value=\"{{dc.id}}\">{{dc.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Development Plan</label><input type=\"text\" name=\"development_plan\" \nng-model=\"im.development_plan\" required></md-input-container><md-input-container flex><label>Estimated Time</label>\n<input type=\"text\" name=\"estimated_time\" ng-model=\"im.estimated_time\"></md-input-container><md-input-container flex>\n<label>Actial Development</label><input type=\"text\" name=\"actual_development\" ng-model=\"im.actual_development\">\n</md-input-container></div></div><md-button class=\"md-blue-grey-300-bg md-raised white-fg\" type=\"button\" \nui-sref=\"app.pms_idp\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"formEmpIdp.$invalid || formEmpIdp.$pristine\">Submit</md-button></form></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/kpi-team/set-team-member/set-team-member-result.html","<md-dialog aria-label=\"New KPI {{vm.year}}\" flex=\"50\" id=\"formKpiPeople\"><form ng-cloak name=\"formSetKpiResult\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveKpiResult($event,formSetKpiResult)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MENU.MAIN.KPIRESULT\"></span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content style=\"background: #ffffff\"><div layout=\"row\"><md-input-container flex=\"50\"><textarea \ndisabled=\"disabled\" ng-model=\"vm.kpi.kpi\" placeholder=\"{{ \'KPI.LABEL.KEYPERFORM\' | translate }}\" required> </textarea>\n</md-input-container><md-input-container flex=\"10\"><input type=\"text\" disabled=\"disabled\" ng-model=\"vm.kpi.uom\" \nplaceholder=\"{{ \'KPI.LABEL.UOM\' | translate }}\"></md-input-container><md-input-container flex=\"10\"><input type=\"text\" \ndisabled=\"disabled\" ng-model=\"vm.kpi.bobot\" placeholder=\"{{ \'KPI.LABEL.WEIGHT\' | translate }}\" required>\n</md-input-container><md-input-container flex=\"20\"><input type=\"text\" disabled=\"disabled\" ng-model=\"vm.kpi.target\" \nplaceholder=\"{{ \'KPI.LABEL.TARGET\' | translate }} (%)\" required></md-input-container></div><div layout=\"column\" \nlayout-align=\"center start \"><table class=\"simple with-toolbar fullwidth-table upper-case-header\" ms-responsive-table>\n<thead><tr><td colspan=\"4\" class=\"text-boxed\">Table : <span translate=\"KPI.LABEL.KPISCALEREF\"></span></td></tr><tr><th \nwidth=\"5%\" style=\"text-align: center\"><span translate=\"KPI.LABEL.NO\"></span></th><th width=\"30%\" \nstyle=\"text-align: center\"><span translate=\"KPI.LABEL.DESCRIPTION\"></span></th><th width=\"10%\" \nstyle=\"text-align: center\">Min</th><th width=\"10%\" style=\"text-align: center\">Max</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.kpiScaleDetail\"><td style=\"text-align: center\">{{item.no_urut}}</td><td \nstyle=\"text-align: center\">{{item.description}}</td><td style=\"text-align: center\">{{item.min | number:2}}</td><td \nstyle=\"text-align: center\">{{item.max | number:2}}</td></tr></tbody></table></div><div class=\"padding-5\"></div><table \nclass=\"simple\" ms-responsive-table id=\"kpiTable\"><thead><tr><th><span translate=\"KPI.LABEL.RESULTDESCRIPTION\"></span>\n</th><th><span translate=\"KPI.LABEL.RESULTDESCRIPTION\"></span></th><th style=\"text-align: center\"><span \ntranslate=\"KPI.LABEL.RESULTVALUE\"></span></th><th><span translate=\"KPI.LABEL.RESULTDATE\"></span></th></tr></thead>\n<tbody><tr ng-repeat=\"kpi in vm.listKpiResult\"><td style=\"text-align: center\">{{($index + 1)}}</td><td>{{kpi.result}}\n</td><td align=\"center\">{{kpi.kpiValue}}</td><td>{{kpi.resultDate}}</td></tr></tbody></table><ms-widget \nflippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pms/kpi-team/set-team-member/set-team-member-scale.html","<md-dialog aria-label=\"Set Kpi Scales\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloak name=\"formSetKpi\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"KPI.LABEL.VIEWKPISCALE\"></span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeKpi()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialogSetKPI\"><table \nwidth=\"100%\"><tr><td valign=\"top\"><span translate=\"KPI.LABEL.KEYPERFORM\"></span></td><td valign=\"top\"><span \ntranslate=\"KPI.LABEL.UOM\"></span></td><td valign=\"top\"><span translate=\"KPI.LABEL.WEIGHT\"></span></td><td valign=\"top\">\n<span translate=\"KPI.LABEL.TARGET\"></span></td></tr><tr style=\"font-weight:bold\"><td valign=\"top\">{{vm.kpidesc}}</td>\n<td valign=\"top\">{{vm.uom}}</td><td valign=\"top\">{{vm.bobot}}</td><td valign=\"top\">{{vm.target}}</td></tr></table>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" \nid=\"datatable\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.SCALE\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.DESCRIPTION\"></span></span></div></th><th class=\"secondary-text\" \nwidth=\"10%\"><div class=\"table-header\"><span class=\"column-title\">Min</span></div></th><th class=\"secondary-text\" \nwidth=\"10%\"><div class=\"table-header\"><span class=\"column-title\">Max</span></div></th></tr></thead><tbody><tr \nng-repeat=\"ks in vm.listkpiscale\"><td align=\"center\">{{ ks.no_urut}}</td><td>{{ ks.scale}}</td><td>{{ ks.start}}</td>\n<td>{{ ks.finish}}</td></tr></tbody></table></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pms/kpi-team/set-team-member/set-team-member.html","<form ng-cloak name=\"formSetKpi\" novalidate><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div class=\"header nabati5 csm-header\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-bottom has-selected\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div class=\"selected-action\" translate=\"ACTION.YEAR\">YEARS\n</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button class=\"md-icon-button action-selector\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin md-menu-align-target><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year.year}}\" ng-click=\"vm.showKpi(year.year)\"><span\n class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" md-font-icon=\"icon-check\"></md-icon><md-icon \nng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div></div></div><md-content class=\"content padding\" layout-fill><div \nclass=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-check\"></md-icon></span><span \nclass=\"logo-text\"><span><span translate=\"KPI.LABEL.VIEW\"></span> <span translate=\"KPI.LABEL.KPI\"></span> <span \ntranslate=\"ACTION.YEAR\"></span> {{vm.yearSelected}} / {{vm.nik}}</span></span></div></md-subheader><div \nclass=\"white-bg\"><md-toolbar><div class=\"toolbar\"><md-button md-offset=\"18 48\" \nclass=\"md-raised md-primary btn-ui-serif\" ng-disabled=\"formSetKpi.$invalid || formSetKpi.$pristine\" \nng-click=\"vm.approveKS($event)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span><span translate=\"KPI.LABEL.APPROVE\">\n</span></span></md-button></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"kpiTable\"><thead><tr><th>\n</th><th><span translate=\"KPI.LABEL.NO\"></span></th><th><span translate=\"KPI.LABEL.KPI\"></span></th><th><span \ntranslate=\"KPI.LABEL.WEIGHT\"></span></th><th><span translate=\"KPI.LABEL.UOM\"></span></th><th><span \ntranslate=\"KPI.LABEL.TARGET\"></span></th><th><span translate=\"KPI.LABEL.STARTDATE\"></span></th><th><span \ntranslate=\"KPI.LABEL.ENDDATE\"></span></th><th><span translate=\"KPI.LABEL.RESULTVALUE\"></span></th><th><span \ntranslate=\"KPI.LABEL.RESULTDATE\"></span></th><th><span translate=\"KPI.LABEL.STATUSAPPROVAL\"></span></th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"ks in vm.DataTable.list\" \nng-dblclick=\"ks.status==\'Submitted\' ? vm.editKPI($event, ks) : \'\'\" ng-click=\"vm.select(ks)\"><td><div \nng-if=\"ks.status===\'Submitted\'\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(ks)\" \nng-click=\"vm.toggleCheck(ks, $event)\" ng-model=\"isCovered\" \nng-change=\"formSetKpi.$setValidity(\'required\', vm.listKSSelected.length > 0)\" \naria-label=\"{{vm.isChecked(ks)? \'Uncheck\':\'check\'}}\"></md-checkbox></div><div ng-else></div></td><td><md-tooltip \nng-if=\"ks.status===\'Submitted\'\"><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{ ($index + 1)}}</td><td \nalign=\"left\"><md-tooltip ng-if=\"ks.status===\'Submitted\'\"><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n<button ng-click=\"vm.viewScales($event,ks.idks)\" style=\"text-decoration:underline;text-align:left !important\" \nalign=\"left\">{{ ks.kpi}}</button></td><td><md-tooltip ng-if=\"ks.status===\'Submitted\'\"><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{ ks.bobot}} %</td><td><md-tooltip \nng-if=\"ks.status===\'Submitted\'\"><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{ ks.uom}}</td><td>\n<md-tooltip ng-if=\"ks.status===\'Submitted\'\"><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{ ks.target}}\n</td><td><md-tooltip ng-if=\"ks.status===\'Submitted\'\"><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>\n{{ ks.effectiveDate}}</td><td><md-tooltip ng-if=\"ks.status===\'Submitted\'\"><span translate=\"MENU.MAIN.DBLFOREDIT\">\n</span></md-tooltip>{{ ks.expiredDate}}</td><td align=\"center\"><md-tooltip ng-if=\"ks.status===\'Submitted\'\"><span \ntranslate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip>{{ ks.kpiValue}}</td><td><md-tooltip \nng-if=\"ks.status===\'Submitted\'\"><span translate=\"MENU.MAIN.DBLFOREDIT\"></span></md-tooltip><button \nng-click=\"vm.viewResult($event,ks)\" style=\"text-decoration:underline;text-align:left !important\" align=\"left\">\n{{ ks.resultDate}}</button></td><td align=\"center\"><md-tooltip><span translate=\"MENU.MAIN.DBLFOREDIT\"></span>\n</md-tooltip>{{ ks.status}}</td><td><section layout=\"row\" layout-sm=\"column\" layout-align=\"start center\" layout-wrap>\n<md-button class=\"md-icon-button\" aria-label=\"Settings\" ng-if=\"ks.status==\'Submitted\'\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.editKPI($event, ks)\"><md-icon md-font-icon=\"icon-table-edit\" \nclass=\"blue-500-fg\"></md-icon><md-tooltip><span>{{ \'MENU.MAIN.DBLFOREDIT\' | translate }}</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.UnApproved($event, ks.id)\" ng-if=\"ks.status ==\'Approved\'\"><md-icon md-font-icon=\"icon-format-underline\" \nclass=\"red-500-fg\"></md-icon><md-tooltip><span translate=\"KPI.LABEL.UNAPPROVE\"></span></md-tooltip></md-button>\n</section></td></tr></tbody></table><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"kpiTable\"><caption><span translate=\"KPI.LABEL.PARESULT\"></span></caption><thead><tr><th><span \ntranslate=\"KPI.LABEL.NO\"></span></th><th><span translate=\"KPI.LABEL.PERIOD\"></span></th><th><span \ntranslate=\"KPI.LABEL.KPI\"></span></th><th><span translate=\"KPI.LABEL.PROCESS\"></span></th><th><span \ntranslate=\"KPI.LABEL.IP\"></span></th><th><span translate=\"KPI.LABEL.MUTU1\"></span></th><th></th></tr></thead><tbody><tr\n ng-repeat=\"kpi in vm.listPA\"><td style=\"text-align: center\">{{($index + 1)}}</td><td style=\"text-align: center\">\n{{kpi.periode}}</td><td style=\"text-align: center\">{{kpi.kpiValue}}</td><td style=\"text-align: center\">\n{{kpi.behavior_performance}}</td><td style=\"text-align: center\">{{kpi.ip}}</td><td style=\"text-align: center\">\n{{kpi.nilai_mutu1}}</td><td><md-button class=\"md-raised green-500-bg\" ng-if=\"kpi.paApproval==0\"><span \nstyle=\"color:white\" translate=\"KPI.LABEL.APPROVED\"></span></md-button><md-button class=\"md-raised green-500-bg\" \nng-click=\"vm.approvedPA(kpi.periode)\" ng-if=\"kpi.paApproval>0\"><span style=\"color:white\" translate=\"KPI.LABEL.APPROVE\">\n</span></md-button></td></tr></tbody></table></md-content></div></div></md-content></div></form><style type=\"text/css\">\n.has-selected .selected-action {\n    padding: 8px 0;\n    height: 40px;\n    line-height: 24px;\n    font-size: 16px;\n  }\n\n  .header.nabati5.csm-header {\n    min-height: auto !important;\n  }\n</style>");
$templateCache.put("app/main/pms/kpi-team/set-team-member/set-team-memberD.html","<form ng-cloak name=\"formSetKpi\" class=\"md-inline-form\" novalidate><div id=\"kpi\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header Oct\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-account-check\"></md-icon></span><span class=\"logo-text\"><span>\nVIEW KPI YEAR {{vm.yearSelected}} / {{vm.nik}}</span></span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\"><div class=\"selected-action\">YEARS</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year.year}}\" \nng-click=\"vm.showKpi(year.year)\"><span class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><div class=\"content\"><div id=\"kpiView\" \nclass=\"md-whiteframe-4dp\" layout=\"column\"><table class=\"simple\" ms-responsive-table id=\"kpiTable\"><thead><tr><th>No\n</th><th>KPI</th><th>WEIGHT</th><th>UOM</th><th>TARGET</th><th>EFFECTIVE DATE</th><th>STATUS APPROVE</th></tr></thead>\n<tbody><tr ng-repeat=\"ks in vm.DataTable.list\" ng-click=\"vm.select(ks)\"><td>{{ ($index + 1)}}</td><td><button \nng-click=\"vm.viewScales($event,ks.idks)\" style=\"text-decoration:underline\">{{ ks.kpi}}</button></td><td>{{ ks.bobot}}\n</td><td>{{ ks.uom}}</td><td>{{ ks.target}}</td><td>{{ ks.effectiveDate}}</td><td>{{ ks.status}}</td></tr></tbody>\n</table><table class=\"simple\" ms-responsive-table id=\"kpiTable\"><caption>PA Result</caption><thead><tr><th>No.</th><th>\nPeriode</th><th>KPI</th><th>Process</th><th>IP</th><th>Mutu 1</th><th></th></tr></thead><tbody><tr \nng-repeat=\"kpi in vm.listPA\"><td style=\"text-align: center\">{{($index + 1)}}</td><td style=\"text-align: center\">\n{{kpi.periode}}</td><td style=\"text-align: center\">{{kpi.kpiValue}}</td><td style=\"text-align: center\">\n{{kpi.behavior_performance}}</td><td style=\"text-align: center\">{{kpi.ip}}</td><td style=\"text-align: center\">\n{{kpi.nilai_mutu1}}</td><td><span ng-if=\"kpi.paApproval==0\" class=\"green-500-fg\">Approved</span><md-button \nclass=\"md-raised green-500-bg\" ng-click=\"vm.approvedPA(kpi.periode)\" ng-if=\"kpi.paApproval>0\">Approved</md-button></td>\n</tr></tbody></table><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.tampilPesan\" \nclass=\"fade\"><ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front red-fg\"><p class=\"form-messages\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.pesan}}</p></ms-widget-front></ms-widget><span flex>\n</span></div></div></div></form>");
$templateCache.put("app/main/pms/job-code-profile/input-job-code-profile/input-job-code-profile.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon ui-sref=\"{{vm.Breadhome}}\" md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><div ng-repeat-start=\"ls  in vm.Breadlist\"></div><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\" ui-sref=\"{{ls.link}}\">{{ls.name}}</span><div ng-repeat-end></div>\n</div><div class=\"title\">Form Input Competency Job</div></div></div><div class=\"content\" layout=\"column\"><div \nlayout=\"row\" layout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" \nflex-xs=\"100\" flex-md=\"80\"><form name=\"formInputModul\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputModul)\"><div layout=\"column\"><md-input-container flex><md-select \nplaceholder=\"Select Job Code\" name=\"job_code\" ng-model=\"vm.Form.objForm.job_code\" required><md-option \nng-repeat=\"ls in vm.listJobCode\" ng-value=\"{{ls.code}}\">{{ls.code + \' - \' + ls.description | uppercase}}</md-option>\n</md-select><div ng-messages=\"formInputModul.job_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJob Code is required.</span></div></div></md-input-container><md-input-container flex><md-select \nplaceholder=\"Select Competency\" name=\"competency_code\" ng-model=\"vm.Form.objForm.competency_code\" required><md-option \nng-repeat=\"ls in vm.listCompetency\" ng-value=\"{{ls.code}}\">{{ls.competency | uppercase}}</md-option></md-select><div \nng-messages=\"formInputModul.competency_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompetency is required.</span></div></div></md-input-container><md-input-container flex><md-select \nplaceholder=\"Select Required Level\" name=\"req_level\" ng-model=\"vm.Form.objForm.req_level\" required><md-option \nng-repeat=\"ls in vm.listProviciencyLevel\" ng-value=\"{{ls.level}}\">{{ls.level}}</md-option></md-select><div \nng-messages=\"formInputModul.req_level.$error\" role=\"alert\"><div ng-message=\"required\"><span>Required Level is required.\n</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"formInputModul.$invalid || basicForm.$pristine\">Submit\n</md-button><md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\">Back\n</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/pms/master-kpi/input-kpi/input-kpi.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Master KPI</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Input KPI</span></div><div \nclass=\"title\">Form Input KPI</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" \nflex-md=\"80\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\"><md-input-container flex>\n<input type=\"text\" name=\"KPI\" ng-model=\"vm.basicForm.KPI\" placeholder=\"KPI\" required><div \nng-messages=\"basicForm.KPI.$error\" role=\"alert\"><div ng-message=\"required\"><span>KPI is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"description\" \nng-model=\"vm.basicForm.description\" placeholder=\"description\" required><div ng-messages=\"basicForm.description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Description is required.</span></div></div></md-input-container></div>\n<ms-widget flippable=\"true\" layout=\"column\" ng-show=\"basicForm.description.$valid\" class=\"fade\"><ms-widget-front \nclass=\"p-16 {{vm.messageTheme}}-400-bg white-fg\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16\"></md-icon>test</p></ms-widget-front></ms-widget><div layout=\"column\" layout-align=\"center center\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/pms/master-kpi/manage-kpi-scales/manage-kpi-scales.html","<md-dialog aria-label=\"Set Kpi Scales\" flex-md=\"90\" flex-gt-md=\"80\"><form ng-cloak name=\"formSetKpi\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveKpiScales($event,formSetKpi)\"><md-toolbar class=\"md-accent hue-3\">\n<div class=\"md-toolbar-tools\"><h2><md-icon md-font-icon=\"icon-eye\" ng-if=\"vm.viewScaleState==true\"></md-icon><md-icon \nmd-font-icon=\"icon-pencil\" ng-if=\"vm.viewScaleState==false\"></md-icon>{{vm.judulForm}}</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeKpiScalesModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialogviewKPI\"><table width=\"100%\"><tr><td valign=\"top\">KPI</td><td valign=\"top\">:</td><td>{{vm.kpi.kpi}}\n</td></tr><tr><td valign=\"top\">DESCRIPTION</td><td valign=\"top\">:</td><td>{{vm.kpi.description}}</td></tr></table><div \nng-show=\"vm.viewScaleState\" class=\"slide-left\"><table class=\"simple\" ms-responsive-table><thead><tr><th width=\"1%\">No\n</th><th>Scale 1</th><th>Scale 2</th><th>Scale 3</th><th>Scale 4</th><th>Scale 5</th><th>Target</th><th>Effective Date\n</th><th></th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-repeat=\"scale in vm.scales track by $index\">\n<td>{{($index + 1)}}</td><td>{{scale.scale_1}}</td><td>{{scale.scale_2}}</td><td>{{scale.scale_3}}</td><td>\n{{scale.scale_4}}</td><td>{{scale.scale_5}}</td><td>{{scale.target}}</td><td>{{scale.effective_date}}</td><td><md-menu \nmd-position-mode=\"target-right target\"><md-button aria-label=\"Open kpi menu\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-align-target md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"\"><div layout=\"row\" flex><md-icon md-menu-align-target \nmd-font-icon=\"icon-delete\"></md-icon><p flex>Delete Scales</p></div></md-button></md-menu-item><md-menu-item><md-button\n ng-click=\"vm.EditScale()\"><div layout=\"row\" flex><md-icon md-menu-align-target md-font-icon=\"icon-pencil\"></md-icon><p\n flex>Edit Scales</p></div></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></div><div \nng-show=\"!vm.viewScaleState\" class=\"slide-right\"><md-button style=\"float:right\" class=\"md-fab md-cyan-500-bg md-mini\" \naria-label=\"Use Android\" ng-click=\"vm.ViewScaleState()\"><md-icon md-font-icon=\"icon-arrow-right-bold\"></md-icon>\n</md-button><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"scale_1\" \nng-model=\"vm.Form.objForm.scale_1\" placeholder=\"Scale 1\" required><div ng-messages=\"formSetKpi.scale_1.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>scale 1 is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"scale_2\" ng-model=\"vm.Form.objForm.scale_2\" placeholder=\"Scale 2\" \nrequired><div ng-messages=\"formSetKpi.scale_2.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nscale 2 is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"scale_3\" \nng-model=\"vm.Form.objForm.scale_3\" placeholder=\"Scale 3\" required><div ng-messages=\"formSetKpi.scale_3.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>scale 3 is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"scale_4\" ng-model=\"vm.Form.objForm.scale_4\" placeholder=\"Scale 4\" \nrequired><div ng-messages=\"formSetKpi.scale_4.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nscale 4 is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"scale_5\" \nng-model=\"vm.Form.objForm.scale_5\" placeholder=\"Scale 5\" required><div ng-messages=\"formSetKpi.scale_5.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>scale 5 is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"target\" ng-model=\"vm.Form.objForm.target\" placeholder=\"Target\" \nrequired><div ng-messages=\"formSetKpi.target.$error\" role=\"alert\"><div ng-message=\"required\"><span>target is required.\n</span></div></div></md-input-container><md-input-container flex><label>Effective Date</label><md-datepicker \nng-model=\"vm.Form.objForm.effectiveDate\" name=\"effectiveDate\" id=\"effectiveDate\" aria-label=\"effective date\" required>\n</md-datepicker><div ng-messages=\"formSetKpi.effectiveDate.$error\"><div ng-message=\"valid\">\nThe entered value is not a date!</div><div ng-message=\"required\">This date is required!</div></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\" \nng-if=\"!vm.viewScaleState\"><span flex></span><div><md-button type=\"button\" class=\"md-raised md-default\" \naria-label=\"Submit\" ng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh\" aria-label=\"save\"></md-icon>\nRefresh Token</md-button><md-button type=\"submit\" class=\"md-raised md-warn hue-3\" aria-label=\"Submit\" \nng-disabled=\"formSetKpi.$invalid || formSetKpi.$pristine\"><md-icon md-font-icon=\"icon-cloud-upload\" aria-label=\"save\">\n</md-icon>SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/master-kpi/set-kpi-scales/set-kpi-scales.html","<md-dialog aria-label=\"Set Kpi Scales\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloak name=\"formSetKpi\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveKpiScales($event,formSetKpi)\"><md-toolbar class=\"md-accent hue-3\">\n<div class=\"md-toolbar-tools\"><h2><md-icon md-font-icon=\"icon-poll\"></md-icon>Set KPI Scales</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeKpiScalesModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialogSetKPI\"><table width=\"100%\"><tr><td valign=\"top\">KPI</td><td valign=\"top\">:</td><td>{{vm.kpi.kpi}}\n</td></tr><tr><td valign=\"top\">DESCRIPTION</td><td valign=\"top\">:</td><td>{{vm.kpi.description}}</td></tr></table><div \nlayout=\"column\"><md-input-container flex><input type=\"text\" name=\"scale_1\" ng-model=\"vm.Form.objForm.scale_1\" \nplaceholder=\"Scale 1\" required><div ng-messages=\"formSetKpi.scale_1.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>scale 1 is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"scale_2\" ng-model=\"vm.Form.objForm.scale_2\" placeholder=\"Scale 2\" required><div \nng-messages=\"formSetKpi.scale_2.$error\" role=\"alert\"><div ng-message=\"required\"><span>scale 2 is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"scale_3\" \nng-model=\"vm.Form.objForm.scale_3\" placeholder=\"Scale 3\" required><div ng-messages=\"formSetKpi.scale_3.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>scale 3 is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"scale_4\" ng-model=\"vm.Form.objForm.scale_4\" placeholder=\"Scale 4\" \nrequired><div ng-messages=\"formSetKpi.scale_4.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nscale 4 is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"scale_5\" \nng-model=\"vm.Form.objForm.scale_5\" placeholder=\"Scale 5\" required><div ng-messages=\"formSetKpi.scale_5.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>scale 5 is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"target\" ng-model=\"vm.Form.objForm.target\" placeholder=\"Target\" \nrequired><div ng-messages=\"formSetKpi.target.$error\" role=\"alert\"><div ng-message=\"required\"><span>target is required.\n</span></div></div></md-input-container><md-input-container flex><label>Effective Date</label><md-datepicker \nng-model=\"vm.Form.objForm.effectiveDate\" name=\"effectiveDate\" id=\"effectiveDate\" aria-label=\"effective date\" required>\n</md-datepicker><div ng-messages=\"formSetKpi.effectiveDate.$error\"><div ng-message=\"valid\">\nThe entered value is not a date!</div><div ng-message=\"required\">This date is required!</div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-default\" aria-label=\"Submit\" ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh\" aria-label=\"save\"></md-icon>Refresh Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-warn hue-3\" aria-label=\"Submit\" ng-disabled=\"formSetKpi.$invalid || formSetKpi.$pristine\"><md-icon \nmd-font-icon=\"icon-cloud-upload\" aria-label=\"save\"></md-icon>SAVE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/reports/kpi/chart.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\nChart</md-subheader><div id=\"dashboard-server\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nid=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap id=\"allChart\"><ms-widget layout=\"row\" \nflex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">Performance Chart Nabati Group</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" \nng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataMutu\" chart-options=\"vm.optionsBadj\" id=\"chart1\"></div></div><div class=\"p-16\" \nlayout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1\" chart-options=\"vm.optionsAadj1\" \nid=\"chart2\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div \nui-chart=\"vm.dataAdj2\" chart-options=\"vm.optionsAadj2\" id=\"chart3\"></div></div></div></ms-widget-front></ms-widget>\n</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap id=\"chartPaByDIvision\"><ms-widget layout=\"row\" \nflex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">Performance Chart By Divisi {{vm.DivisionName}}\n</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item \nng-repeat=\"oDivision in vm.listDivision\"><md-button ng-click=\"vm.viewDataDivision(oDivision.id,oDivision.description)\" \naria-label=\"{{oDivision.description}} widget\">{{oDivision.description}}</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataMutuDiv\" chart-options=\"vm.optionsBadjDiv\" id=\"chart4\"></div></div><div \nclass=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1Div\" \nchart-options=\"vm.optionsAadj1Div\" id=\"chart5\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataAdj2Div\" chart-options=\"vm.optionsAadj2Div\" id=\"chart6\"></div></div></div></div>\n</ms-widget-front></ms-widget></div></div></div></div></md-content></div>");
$templateCache.put("app/main/pms/reports/kpi/chartbu.html","<div id=\"dashboard-server\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><md-subheader \nclass=\"white-bg\">Employement Apraisal</md-subheader><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap id=\"chartByBu\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Chart {{vm.namaBu}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item ng-repeat=\"oBu  in vm.listBu\"><md-button ng-click=\"vm.viewDataBu(oBu.id,oBu.description)\" \naria-label=\"{{oBu.description}} widget\">{{oBu.description}}</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" layout-wrap><div \nclass=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataMutuBu\" \nchart-options=\"vm.optionsBadjBu\" id=\"chart7\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataAdj1Bu\" chart-options=\"vm.optionsAadj1Bu\" id=\"chart8\"></div></div><div \nclass=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj2Bu\" \nchart-options=\"vm.optionsAadj2Bu\" id=\"chart9\"></div></div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap id=\"chartByDivisi\"><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Chart Business Unit {{vm.namaBu}} Divisi {{vm.nameDivisi}}</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item ng-repeat=\"oDivisi in vm.listDivisi\"><md-button \nng-click=\"vm.viewDataDivisi(oDivisi.id,oDivisi.description)\" aria-label=\"{{oDivisi.description}} widget\">\n{{oDivisi.description}}</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" \nflex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataMutudiv\" chart-options=\"vm.optionsBadjdiv\" id=\"chart10\"></div></div>\n<div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj1div\" \nchart-options=\"vm.optionsAadj1div\" id=\"chart11\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataAdj2div\" chart-options=\"vm.optionsAadj2div\" id=\"chart12\"></div></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap id=\"chartByDept\">\n<ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPerformance Chart Business Unit {{vm.namaBu}} Department {{vm.nameDepartment}}</div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item ng-repeat=\"oDepartment in vm.listDepartment\"><md-button \nng-click=\"vm.viewDataDepartment(oDepartment.id,oDepartment.description)\" \naria-label=\"{{oDepartment.description}} widget\">{{oDepartment.description}}</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"start center\" \nlayout-wrap><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataMutuDept\" \nchart-options=\"vm.optionsBadjDept\" id=\"chart13\"></div></div><div class=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" \nflex-xs=\"100\"><div ui-chart=\"vm.dataAdj1Dept\" chart-options=\"vm.optionsAadj1Dept\" id=\"chart14\"></div></div><div \nclass=\"p-16\" layout=\"row\" flex=\"33\" flex-sm=\"100\" flex-xs=\"100\"><div ui-chart=\"vm.dataAdj2Dept\" \nchart-options=\"vm.optionsAadj2Dept\" id=\"chart15\"></div></div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/pms/reports/kpi/kpi.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span translate=\"MENU.MAIN.KPIREPORTS\"></span></md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select><span translate=\"KPI.LABEL.ENTRIES\"></span>\n</md-input-container><div class=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><div ng-if=\"vm.eCheckin\" \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button ng-if=\"vm.upload\" \nclass=\"md-raised md-primary btn-ui-serif\" show-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.exportToExcel()\">\n<md-tooltip md-direction=\"right\" md-visible=\"tooltipVisible\"><span translate=\"KPI.LABEL.EXPORTTOEXCEL\"></span>\n</md-tooltip><span translate=\"KPI.LABEL.EXPORTTOEXCEL\"></span></md-button><span flex hide show-gt-sm></span>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th><span translate=\"KPI.LABEL.NO\"></span>\n</th><th><span translate=\"KPI.LABEL.NIKJOBTITLE\"></span></th><th><span translate=\"KPI.LABEL.NAME\"></span></th><th><span\n translate=\"KPI.LABEL.KPIID\"></span></th><th><span translate=\"KPI.LABEL.KPI\"></span></th><th><span \ntranslate=\"KPI.LABEL.DESCRIPTION\"></span></th><th><span translate=\"KPI.LABEL.TARGET\"></span></th><th><span \ntranslate=\"KPI.LABEL.VALUE\"></span></th><th><span translate=\"KPI.LABEL.RESULT\"></span></th><th><span \ntranslate=\"KPI.LABEL.RESULTDATE\"></span></th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td \nclass=\"text-center\">{{($index + 1)}}</td><td class=\"text-center\">{{ls.id}}</td><td class=\"text-center\">{{ls.id_name}}\n</td><td class=\"text-center\">#{{ls.kpiID}}</td><td class=\"text-center\">{{ls.kpi}}</td><td>{{ls.description}}</td><td \nclass=\"text-center\">{{ls.target}}</td><td class=\"text-center\">{{ls.kpi_value}}</td><td class=\"text-center\">\n{{ls.result}}</td><td class=\"text-center\">{{ls.result_date}}</td></tr></tbody></table><div \nclass=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/reports/kpi/kpinonpeople.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">KPI Reports Non People</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th>NO</th><th>POSITIONID</th><th>JOB TITLE</th><th>KPI ID</th><th>KPI</th><th>\nDESCRIPTION</th><th>TARGET</th><th>VALUE</th><th>RESULT</th><th>RESULT DATE</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td>{{($index + 1)}}</td><td>{{ls.id}}</td><td>{{ls.id_name}}</td><td>#{{ls.kpiID}}\n</td><td>{{ls.kpi}}</td><td>{{ls.description}}</td><td>{{ls.target}}</td><td>{{ls.kpi_value}}</td><td>{{ls.result}}\n</td><td>{{ls.result_date}}</td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/reports/kpi/kpipeople.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\"><span>KPI Reports People</span></md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select>\nEntries</md-input-container><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th>NO</th><th>NIK</th><th>EMP NAME</th><th>KPI ID</th><th>KPI</th><th>DESCRIPTION</th>\n<th>TARGET</th><th>VALUE</th><th>RESULT</th><th>RESULT DATE</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.DataTable.list\"><td>{{($index + 1)}}</td><td>{{ls.id}}</td><td>{{ls.id_name}}</td><td>#{{ls.kpiID}}\n</td><td>{{ls.kpi}}</td><td>{{ls.description}}</td><td>{{ls.target}}</td><td>{{ls.kpi_value}}</td><td>{{ls.result}}\n</td><td>{{ls.result_date}}</td></tr></tbody></table><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTables.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTables.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/reports/kpi/pa.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><div \nclass=\"header nabati5 csm-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom has-selected\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><div \nclass=\"selected-action\">YEARS</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button action-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"year in vm.years\"><md-button aria-label=\"{{year.year}}\" \nng-click=\"vm.showMpp(year.year)\"><span class=\"secondary-text\"><span><md-icon ng-if=\"year.selected\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!year.selected\"></md-icon>{{year.year}}</span></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><md-content class=\"content padding\" layout-fill><div\n class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\">Perfornamce Value</md-subheader>\n<div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" ng-submit=\"vm.loadData(1)\" \nnovalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon md-font-icon=\"icon-filter\" \\></md-icon><span>\nFilter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>\nPeriode</label><md-select ng-model=\"vm.periodeSelected\"><md-option value=\"yearly\">Yearly</md-option><md-option \nng-repeat=\"periode in vm.periode\" value=\"{{periode.periode}}\">{{periode.periode}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Business Unit</label><md-select \nng-disabled=\"vm.group === \'110\' || vm.group === \'116\'\" ng-model=\"vm.bu\" ng-change=\"vm.loadDataDivision(vm.bu)\">\n<md-option value=\"all\">All</md-option><md-option ng-repeat=\"bu in vm.listBu\" value=\"{{bu.id}}\">{{bu.description}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Division</label>\n<md-select ng-model=\"vm.divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\"><md-option value=\"all\">All</md-option>\n<md-option ng-repeat=\"divisi in vm.listDivisi\" value=\"{{divisi.id}}\">{{divisi.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Department</label><md-select \nng-model=\"vm.department\" ng-change=\"vm.loadData(1)\"><md-option value=\"all\">All</md-option><md-option \nng-repeat=\"department  in vm.listDepartment\" value=\"{{department.id}}\">{{department.description}}</md-option>\n</md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div>\n</form></div></div></md-content><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><md-input-container\n hide show-gt-sm><select name=\"see\" id=\"ss\" ng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" \nng-options=\"val for val in vm.listJum\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button \nclass=\"md-mini md-raised md-primary btn-ui-serif\" hide show-gt-sm type=\"button\" ng-click=\"vm.ExportToExcel()\">\n<md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\">Export to Excel</md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"md-font icon-archive material-icons\"></md-icon><span>Export to Excel</span>\n</md-button><span flex hide show-gt-sm></span><ms-search-bar on-search=\"vm.loadData(1)\" \nquery=\"vm.DataTable.searchParam\" debounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table>\n<thead><tr><th>NO</th><th>Comp</th><th>NIK</th><th>NAME</th><th>DIV</th><th>DEPT</th><th>JOB TITLE</th><th>JOB LEVEL\n</th><th>ATASAN</th><th>GRADE</th><th>SERVICE YEAR</th><th>KPI</th><th>PROCESS</th><th>IP</th><th>MUTU 1</th><th>\nDEPT. PERFORMANCE</th><th>DIV. PERFORMANCE</th><th>NABATI GROUP</th><th>MUTU 2</th><th>ADJ 1</th><th>ADJ 2</th><th>T\n</th><th>S</th><th>T</th><th>E</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.DataTable.list\"><td class=\"text-center\">\n<span>{{($index + 1)}}<md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Row number</md-tooltip></span></td>\n<td class=\"text-center\"><span>{{ls.company}}<md-tooltip md-direction=\"bottom\">Company</md-tooltip></span></td><td \nclass=\"text-center\"><span>{{ls.nik}}<md-tooltip md-direction=\"bottom\">nik</md-tooltip></span></td><td \nclass=\"text-center\">{{ls.title}} {{ls.first_name}} {{ls.last_name}}</td><td class=\"text-center\">{{ls.division}}</td><td\n class=\"text-center\">{{ls.department}}</td><td class=\"text-center\">{{ls.jobtitle}}</td><td class=\"text-center\">\n{{ls.level}}</td><td class=\"text-center\">{{ls.namaAtasan}}</td><td class=\"text-center\">{{ls.grade}}</td><td \nclass=\"text-center\">{{ls.serviceYear}}</td><td class=\"text-center\">{{ls.kpiValue}}</td><td class=\"text-center\">\n{{ls.behavior_performance}}</td><td class=\"text-center\">{{ls.ip}}</td><td class=\"text-center\">{{ls.nilai_mutu1}}</td>\n<td class=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"></td><td\n class=\"text-center\">{{ls.adj1}}</td><td class=\"text-center\">{{ls.adj2}}</td><td class=\"text-center\">{{ls.t}}</td><td \nclass=\"text-center\">{{ls.s}}</td><td class=\"text-center\">{{ls.t1}}</td><td class=\"text-center\">{{ls.e}}</td></tr>\n</tbody></table></md-content><div class=\"p-24 mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></md-content></div>");
$templateCache.put("app/main/pms/talent-review/input-talent-review-member/input-talent-review-member.html","<md-dialog aria-label=\"{{vm.title}} Talent Review\" flex=\"75\" id=\"formTalentReview\"><form ng-cloak \nname=\"formTalentReview\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formTalentReview)\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>{{vm.title}} Input Talent Review {{vm.resultDateAlias}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><input type=\"hidden\" \nng-model=\"vm.Form.objForm.job_code\"> <input type=\"hidden\" ng-model=\"vm.Form.objForm.job_code_profile_id\"> <input \ntype=\"hidden\" ng-model=\"vm.Form.objForm.emp_nik\"><div layout=\"row\" class=\"ng-scope layout-row\"><div flex-gt-sm=\"40\" \nflex=\"40\"><div layout=\"row\"><md-input-container flex=\"100\"><label>Entity</label><input type=\"text\" \nvalue=\"{{vm.data.entity}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>Employee Name</label><input type=\"text\" \nvalue=\"{{vm.data.nik + \' / \' + vm.data.name}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"100\"><label>Gender</label><input type=\"text\" \nvalue=\"{{(vm.data.gender === \'P\')?\'Female\':\'Male\'}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"100\"><label>Birthdate</label><input type=\"text\" \nvalue=\"{{vm.data.date_of_birth}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>Age</label><input type=\"text\" value=\"{{vm.data.age}}\" style=\"color: #000\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>Nationality\n</label><input type=\"text\" value=\"{{vm.data.nationality}}\" style=\"color: #000\" disabled=\"disabled\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>Years In Company</label><input \ntype=\"text\" value=\"{{vm.data.years_in_company}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div>\n<div layout=\"row\"><md-input-container flex=\"100\"><label>Level of Education</label><input type=\"text\" \nvalue=\"{{vm.data.level_of_edu}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>Current Position</label><input type=\"text\" value=\"{{vm.data.current_position}}\" \nstyle=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\">\n<label>Department</label><input type=\"text\" value=\"{{vm.data.department}}\" style=\"color: #000\" disabled=\"disabled\">\n</md-input-container></div><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div><div \nflex-offset=\"5\" flex=\"60\"><h5>DEVELOPMENT</h5><div layout=\"row\"><md-input-container flex=\"100\"><label>\nProjection for future roles Role / Readiness</label><textarea rows=\"3\">{{vm.data.development.projection}}</textarea>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>\nDevelopment actions done from beg. 2013 till now (ie. training, on the job, …)</label><input type=\"text\" \nvalue=\"{{vm.data.development.action_done}}\" disabled=\"\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>Development plan for next 12-18 months (ie. training, on the job, …)</label>\n<input type=\"text\" value=\"{{vm.data.development.plan}}\" disabled=\"\"></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-disabled=\"formTalentReview.$invalid\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save\n</md-button><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/talent-review/set-projection-member/set-projection-member.html","<md-dialog aria-label=\"{{vm.title}} Talent Review\" flex=\"50\" id=\"formTalentReview\"><form ng-cloak \nname=\"formTalentReview\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formTalentReview)\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>Set Projection Member</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" class=\"ng-scope layout-row\"><div flex><div \nlayout=\"row\"><md-input-container flex=\"100\"><label>Employee Name</label><input type=\"text\" \nvalue=\"{{vm.data.nik + \' / \' + vm.data.name}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"100\"><label>Projection for future roles</label><textarea \nng-model=\"vm.projection\">{{vm.data.talent.projection}}</textarea></md-input-container></div><ms-widget \nflippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-disabled=\"formTalentReview.$invalid\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save\n</md-button><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/talent-review/talent-review-9box/talent-review-9box.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\nTalent Review 9-Box Table</md-subheader><div class=\"white-bg\"><md-toolbar><div class=\"md-toolbar-tools table-tools\">\n<form action=\"javascript:void(0);\" name=\"frmSaveNineBox\" id=\"frmSaveNineBox\" novalidate \nng-submit=\"vm.saveData($event, frmSaveNineBox)\"><div id=\"layoutControlTop\" layout-align=\"right\"><md-menu \nng-if=\"vm.status !== \'release\'\" md-offset=\"0 -7\"><md-button aria-label=\"Open demo menu \" class=\"md-raised\" \nng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"reference-button md-hue-2\" ng-click=\"vm.saveNineBoxToDraft($event)\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><span>Save to Draft</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"reference-button md-hue-2\" ng-click=\"vm.resetNineBox($event)\"><md-icon md-font-icon=\"icon-undo-variant\">\n</md-icon><span>Reset</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-if=\"vm.status !== \'release\'\" class=\"md-accent md-raised md-button md-default-theme md-ink-ripple\" \nng-click=\"vm.saveSubmitNineBox($event)\"><span>Submit</span></md-button><p ng-if=\"vm.status === \'release\'\" \nclass=\"green-800-fg\">9-Box has been released</p></div></form></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><div id=\"contentTalent9Box\" class=\"content layout-column\" layout=\"column\">\n<div class=\"pr-50 pl-50\"><table id=\"table9box\"><tr class=\"row-performance\"><td>Performance</td></tr><tr><td><div \nid=\"monitorOptionEventsDragDrop\" data-drop=\"true\" data-jqyoui-options=\"vm.optionsEvents\" \njqyoui-droppable=\"{multiple:true}\"></div><div id=\"ninebox_row_1\" layout-xs=\"column\" layout=\"row\" \nstyle=\"min-height: {{vm.heightninebox}}px; height: auto\"><div layout=\"column\" class=\"nine-box-area\" \nstyle=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #f1c40f;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #f39c12;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">3A - \"High Professional\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox3AList\" data-jqyoui-options=\"{accept:\'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox3AList\" ng-repeat=\"item in vm.ninebox3AList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox3AList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #2ecc71;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #27ae60;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">2A - \"Current Star\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox2AList\" data-jqyoui-options=\"{accept:\'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox2AList\" ng-repeat=\"item in vm.ninebox2AList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox2AList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #3498db;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #2980b9;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">1A - \"Consistent Star\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox1AList\" data-jqyoui-options=\"{accept:\'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox1AList\" ng-repeat=\"item in vm.ninebox1AList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\" \nstyle=\"cursor: move\"><md-icon md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>\n{{item.name}}</div><div ng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox1AList\"><md-icon \nmd-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div>\n</div><div id=\"ninebox_row_2\" layout-xs=\"column\" layout=\"row\" style=\"min-height: {{vm.heightninebox}}px; height: auto\">\n<div layout=\"column\" class=\"nine-box-area\" \nstyle=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #27ae60;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #239253;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">3B - \"Solid Professional\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox3BList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox3BList\" ng-repeat=\"item in vm.ninebox3BList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox3BList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #f1c40f;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #f39c12;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">2B - \"Key Player\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox2BList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox2BList\" ng-repeat=\"item in vm.ninebox2BList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox2BList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #2ecc71;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #27ae60;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">1B - \"Future Star\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox1BList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox1BList\" ng-repeat=\"item in vm.ninebox1BList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox1BList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div></div><div id=\"ninebox_row_3\" \nlayout-xs=\"column\" layout=\"row\" style=\"min-height: {{vm.heightninebox}}px; height: auto\"><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #e74c3c;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #c0392b;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">3C - \"Talent Risk\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox3CList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox3CList\" ng-repeat=\"item in vm.ninebox3CList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox3CList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #27ae60;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #239253;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">2C - \"Incosistent Player\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox2CList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox2CList\" ng-repeat=\"item in vm.ninebox2CList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox2CList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #f1c40f;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #f39c12;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">1C - \"Rough Diamond\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox1CList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox1CList\" ng-repeat=\"item in vm.ninebox1CList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox1CList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div></div></td></tr><tr><td \nstyle=\"text-align: center; font-weight: bold; font-size: 27px; height: 70px\">Potential</td></tr></table></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/talent-review-admin/input-talent-review-member/input-talent-review-member.html","<md-dialog aria-label=\"{{vm.title}} Talent Review\" flex=\"75\" id=\"formTalentReview\"><form ng-cloak \nname=\"formTalentReview\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formTalentReview)\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>{{vm.title}} Input Talent Review {{vm.resultDateAlias}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><input type=\"hidden\" \nng-model=\"vm.Form.objForm.job_code\"> <input type=\"hidden\" ng-model=\"vm.Form.objForm.job_code_profile_id\"> <input \ntype=\"hidden\" ng-model=\"vm.Form.objForm.emp_nik\"><div layout=\"row\" class=\"ng-scope layout-row\"><div flex-gt-sm=\"40\" \nflex=\"40\"><div layout=\"row\"><md-input-container flex=\"100\"><label>Entity</label><input type=\"text\" \nvalue=\"{{vm.data.entity}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>Employee Name</label><input type=\"text\" \nvalue=\"{{vm.data.nik + \' / \' + vm.data.name}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"100\"><label>Gender</label><input type=\"text\" \nvalue=\"{{(vm.data.gender === \'P\')?\'Female\':\'Male\'}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"100\"><label>Birthdate</label><input type=\"text\" \nvalue=\"{{vm.data.date_of_birth}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>Age</label><input type=\"text\" value=\"{{vm.data.age}}\" style=\"color: #000\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>Nationality\n</label><input type=\"text\" value=\"{{vm.data.nationality}}\" style=\"color: #000\" disabled=\"disabled\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>Years In Company</label><input \ntype=\"text\" value=\"{{vm.data.years_in_company}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div>\n<div layout=\"row\"><md-input-container flex=\"100\"><label>Level of Education</label><input type=\"text\" \nvalue=\"{{vm.data.level_of_edu}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>Current Position</label><input type=\"text\" value=\"{{vm.data.current_position}}\" \nstyle=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\">\n<label>Department</label><input type=\"text\" value=\"{{vm.data.department}}\" style=\"color: #000\" disabled=\"disabled\">\n</md-input-container></div><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div><div \nflex-offset=\"5\" flex=\"60\"><h5>DEVELOPMENT</h5><div layout=\"row\"><md-input-container flex=\"100\"><label>\nProjection for future roles Role / Readiness</label><textarea rows=\"3\">{{vm.data.development.projection}}</textarea>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>\nDevelopment actions done from beg. 2013 till now (ie. training, on the job, …)</label><input type=\"text\" \nvalue=\"{{vm.data.development.action_done}}\" disabled=\"\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>Development plan for next 12-18 months (ie. training, on the job, …)</label>\n<input type=\"text\" value=\"{{vm.data.development.plan}}\" disabled=\"\"></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-disabled=\"formTalentReview.$invalid\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save\n</md-button><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pms/talent-review-admin/talent-review-9box/talent-review-9box.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\nTalent Review 9-Box Table</md-subheader><div class=\"white-bg\"><md-content class=\"\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"form-wrapper has-wrapper-coloum\"><form name=\"formInputOT\" class=\"md-inline-form\" \nng-submit=\"vm.loadData(1)\" novalidate layout-align=\"center center\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-filter\" \\></md-icon><span>Filter Data</span></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Business Unit</label><md-select \nng-disabled=\"vm.group === \'110\' || vm.group === \'116\'\" ng-change=\"vm.loadDataDivision(vm.bu)\" ng-model=\"vm.bu\">\n<md-option ng-value=\"\">All</md-option><md-option ng-repeat=\"bu in vm.listBu\" ng-value=\"bu.id\">{{bu.description}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Division</label>\n<md-select ng-change=\"vm.loadDataDepartment(vm.divisi)\" ng-model=\"vm.divisi\"><md-option ng-value=\"\">All</md-option>\n<md-option ng-repeat=\"divisi in vm.listDivisi\" ng-value=\"{{divisi.id}}\">{{divisi.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Department</label><md-select \nng-change=\"vm.loadDataAtasan()\" ng-model=\"vm.department\"><md-option ng-value=\"\">All</md-option><md-option \nng-repeat=\"department  in vm.listDepartment\" ng-value=\"{{department.id}}\">{{department.description}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>Atasan</label><md-select \nng-change=\"vm.loadData(1)\" ng-model=\"vm.nik_atasan\" requireds><md-option ng-value=\"\">All</md-option><md-option \nng-repeat=\"atasan  in vm.listAtasan\" ng-value=\"{{atasan.nik}}\">{{atasan.nik}}, {{atasan.fullname}}</md-option>\n</md-select></md-input-container><md-button class=\"md-mini md-raised md-primary\" ng-click=\"vm.loadData(1)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-magnify\" aria-label=\"search\"></md-icon><span>Search</span></md-button></div>\n</form></div></div></md-content><md-toolbar><div class=\"md-toolbar-tools table-tools\"><form \naction=\"javascript:void(0);\" name=\"frmSaveNineBox\" id=\"frmSaveNineBox\" novalidate \nng-submit=\"vm.saveData($event, frmSaveNineBox)\"><div id=\"layoutControlTop\" layout-align=\"right\"><md-menu \nng-if=\"vm.status !== \'release\'\" md-offset=\"0 -7\"><md-button aria-label=\"Open demo menu \" class=\"md-raised\" \nng-click=\"$mdOpenMenu()\">Action<md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip><span>\nclick for view actions</span></md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nclass=\"reference-button md-hue-2\" ng-click=\"vm.saveNineBoxToDraft($event)\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><span>Save to Draft</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"reference-button md-hue-2\" ng-click=\"vm.resetNineBox($event)\"><md-icon md-font-icon=\"icon-undo-variant\">\n</md-icon><span>Reset</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-if=\"vm.status !== \'release\'\" class=\"md-accent md-raised md-button md-default-theme md-ink-ripple\" \nng-click=\"vm.saveSubmitNineBox($event)\"><span>Submit</span></md-button><p ng-if=\"vm.status === \'release\'\" \nclass=\"green-800-fg\">9-Box has been released</p></div></form></div></md-toolbar><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><div id=\"contentTalent9Box\" class=\"content layout-column\" layout=\"column\">\n<div class=\"pr-50 pl-50\"><table id=\"table9box\"><tr class=\"row-performance\"><td>Performance</td></tr><tr><td><div \nid=\"monitorOptionEventsDragDrop\" data-drop=\"true\" data-jqyoui-options=\"vm.optionsEvents\" \njqyoui-droppable=\"{multiple:true}\"></div><div id=\"ninebox_row_1\" layout-xs=\"column\" layout=\"row\" \nstyle=\"min-height: {{vm.heightninebox}}px; height: auto\"><div layout=\"column\" class=\"nine-box-area\" \nstyle=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #f1c40f;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #f39c12;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">3A - \"High Professional\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox3AList\" data-jqyoui-options=\"{accept:\'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox3AList\" ng-repeat=\"item in vm.ninebox3AList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox3AList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #2ecc71;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #27ae60;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">2A - \"Current Star\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox2AList\" data-jqyoui-options=\"{accept:\'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox2AList\" ng-repeat=\"item in vm.ninebox2AList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox2AList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #3498db;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #2980b9;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">1A - \"Consistent Star\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox1AList\" data-jqyoui-options=\"{accept:\'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox1AList\" ng-repeat=\"item in vm.ninebox1AList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\" \nstyle=\"cursor: move\"><md-icon md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>\n{{item.name}}</div><div ng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox1AList\"><md-icon \nmd-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div>\n</div><div id=\"ninebox_row_2\" layout-xs=\"column\" layout=\"row\" style=\"min-height: {{vm.heightninebox}}px; height: auto\">\n<div layout=\"column\" class=\"nine-box-area\" \nstyle=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #27ae60;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #239253;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">3B - \"Solid Professional\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox3BList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox3BList\" ng-repeat=\"item in vm.ninebox3BList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox3BList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #f1c40f;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #f39c12;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">2B - \"Key Player\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox2BList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox2BList\" ng-repeat=\"item in vm.ninebox2BList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox2BList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #2ecc71;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #27ae60;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">1B - \"Future Star\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox1BList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox1BList\" ng-repeat=\"item in vm.ninebox1BList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox1BList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div></div><div id=\"ninebox_row_3\" \nlayout-xs=\"column\" layout=\"row\" style=\"min-height: {{vm.heightninebox}}px; height: auto\"><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #e74c3c;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #c0392b;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">3C - \"Talent Risk\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox3CList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox3CList\" ng-repeat=\"item in vm.ninebox3CList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox3CList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #27ae60;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #239253;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">2C - \"Incosistent Player\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox2CList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox2CList\" ng-repeat=\"item in vm.ninebox2CList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox2CList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div><div layout=\"column\" \nclass=\"nine-box-area\" style=\"border: 1px solid #ccc; {{(vm.is_color)?\'background-color: #f1c40f;\':\'\';}}\" flex=\"\"><div \nstyle=\"max-height: 40px; padding: 10px; {{(vm.is_color)?\'color: #fff; background-color: #f39c12;\':\'\';}}\" flex=\"\"><div \nstyle=\"font-size: large; font-weight: bold\">1C - \"Rough Diamond\"</div></div><div flex=\"\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"padding: 10px\"><div class=\"thumbnail\" data-drop=\"true\" \nng-model=\"vm.ninebox1CList\" data-jqyoui-options=\"{accept: \'.btn-draggable\'}\" jqyoui-droppable=\"{multiple:true}\" \nstyle=\"width: 100%; height: 100%\"><div ng-if=\"vm.status !== \'release\'\" class=\"btn btn-info btn-draggable ninebox-item\" \nng-model=\"vm.ninebox1CList\" ng-repeat=\"item in vm.ninebox1CList\" ng-show=\"item.name\" data-drag=\"true\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true,animate:true}\" data-jqyoui-options=\"{revert: \'invalid\'}\"><md-icon\n md-font-icon=\"icon-account\" style=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div><div \nng-if=\"vm.status === \'release\'\" ng-repeat=\"item in vm.ninebox1CList\"><md-icon md-font-icon=\"icon-account\" \nstyle=\"font-size: 17px; margin-top: -1px\"></md-icon>{{item.name}}</div></div></div></div></div></td></tr><tr><td \nstyle=\"text-align: center; font-weight: bold; font-size: 27px; height: 70px\">Potential</td></tr></table></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/pms/talent-review-admin/set-projection-member/set-projection-member.html","<md-dialog aria-label=\"{{vm.title}} Talent Review\" flex=\"50\" id=\"formTalentReview\"><form ng-cloak \nname=\"formTalentReview\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formTalentReview)\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>Set Projection Member</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" class=\"ng-scope layout-row\"><div flex><div \nlayout=\"row\"><md-input-container flex=\"100\"><label>Employee Name</label><input type=\"text\" \nvalue=\"{{vm.data.nik + \' / \' + vm.data.name}}\" style=\"color: #000\" disabled=\"disabled\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"100\"><label>Projection for future roles</label><textarea \nng-model=\"vm.projection\">{{vm.data.talent.projection}}</textarea></md-input-container></div><ms-widget \nflippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-disabled=\"formTalentReview.$invalid\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save\n</md-button><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/report/correspondence/company-certificate/company-certificate.html","<section class=\"letter-container-correspondence sheet padding-25mm\"><section class=\"letter-header\"><h2>\nSURAT KETERANGAN PERUSAHAAN</h2><h3>\nNO : {{ vm.getNumberID(vm.item.id) }}/KSNI_HRD/SKP/{{ vm.getMonth(vm.item.finished_at) }}/{{ vm.getYear(vm.item.finished_at)}}\n</h3></section><section class=\"letter-preface\">Dengan Hormat,<p>Yang bertanda tangan di bawah ini,</p></section>\n<section class=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Nama\n</span></div><div class=\"spacer\"></div><div class=\"content-point\"><div class=\"text-point\"><strong>ZAENAL ARIFIN\n</strong></div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Bagian\n</span></div><div class=\"spacer\"></div><div class=\"content-point\"><div class=\"text-point\">Human Capital</div></div>\n</div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Jabatan</span></div><div \nclass=\"spacer\"></div><div class=\"content-point\"><div class=\"text-point\">Human Capital Operation Manager</div></div>\n</div></section><section class=\"letter-preface\"><p style=\"margin-bottom:1em\">Dengan ini menerangkan bahwa,</p>\n</section><section class=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span \nclass=\"text-label\">Nama</span></div><div class=\"spacer\"></div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.name }}</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">\nJabatan</span></div><div class=\"spacer\"></div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.job_title }}</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span \nclass=\"text-label\">Tanggal masuk kerja</span></div><div class=\"spacer\"></div><div class=\"content-point\"><div \nclass=\"text-point\">{{ vm.getFinishedDate(vm.item.effective_date) }}</div></div></div><div class=\"letter-content-item\" \nng-if=\"vm.item.emp_type === \'Permanent\'\"><div class=\"label-point\"><span class=\"text-label\">Status</span></div><div \nclass=\"spacer\"></div><div class=\"content-point\"><div class=\"text-point\">{{ vm.item.emp_type }}</div></div></div>\n</section><section class=\"letter-content-statement\">Adalah benar karyawan di <strong>PT. Kaldu Sari Nabati Indonesia\n</strong> penempatan di {{vm.item.sub_area}}<p>\nDemikian surat keterangan perusahaan ini dibuat dan dipergunakan untuk keperluan {{ vm.item.requirement_name }}</p>\n</section><section class=\"letter-footer\"><div class=\"location\">Bandung, {{ vm.getFinishedDate(vm.item.finished_at) }}\n</div><div class=\"spacer\"></div><div class=\"signature\"><p style=\"text-decoration: underline; margin-block-end: 0\">\nZaenal Arifin</p><i>HC Operation Manager</i></div></section></section>");
$templateCache.put("app/main/report/correspondence/correspondence-pma/correspondence-pma.html","<div style=\"display: grid\" ng-repeat=\"item in vm.items\"><section class=\"pma-letter sheet padding-fill-kop\" \nng-if=\"item.letter_code === \'SURAT_SKORSING\'\"><div class=\"header-container\"><section class=\"header-kop\"><img \nclass=\"kop-left\" src=\"assets/letter/pma-kop-left.png\" alt=\"\"> <img class=\"kop-right\" \nsrc=\"assets/letter/pma-kop-right.png\" alt=\"\"></section><section class=\"header-title\"><u>Surat Skorsing</u><p>\nNomor : {{item.letter_number}}</p></section><section class=\"header-content\">Kepada Yth<br><b class=\"toUpper\">\n{{item.name}}</b><br>NIK {{item.nik}}<br>PT. PAS LINK<br>{{item.sub_area}}<br><br><br>Dengan hormat,</section></div>\n<div class=\"content-container\"><section class=\"main-content\">\nSehubungan dengan kondisi/ tindakan/ perilaku Saudara/i yakni <b>{{ item.reason }} </b>\nOleh sebab itu, untuk menindaklanjuti hal tersebut di atas maka dengan ini Saudara/i Kami skorsing selama {{item.skorsing_duration}} bulan terhitung sejak {{ vm.formatDate(item.skorsing_start_date) }} sampai dengan {{vm.getScorsingDate(item.skorsing_start_date, item.skorsing_duration)}}\n</section><section class=\"sub-content\">\nSelama periode Skorsing, Saudara/i tidak diperkenankan untuk memasuki lingkungan perusahaan dan seluruh fasilitas / inventaris milik Perusahaan segera dikembalikan.\n</section><section class=\"closing-content\">Demikian Kami sampaikan, untuk dapat dilaksanakan.<br>Terima Kasih.\n</section></div><div class=\"footer-container\"><section class=\"one-rows-grid\" style=\"padding-bottom: 1pt\"><div \nclass=\"col-grid\">{{item.sub_area}}, {{item.printed_at}}</div><div class=\"col-grid\" style=\"padding-bottom: 0\">\nHormat Kami,</div><div class=\"col-grid\">PT. PAS LINK</div></section><section class=\"one-rows-grid\"><div \nclass=\"col-grid\"><section class=\"footer-signature-place\"></section><section class=\"footer-signature-info\"><div \nclass=\"name\"><b>{{item.author.name | titleCase}}</b></div><div class=\"position\">{{item.author.job_title}}</div>\n</section></div></section><section class=\"one-rows-grid\"><div class=\"col-grid\"><section class=\"footer-title\" \nstyle=\"padding-top: 25px\">Diterima Oleh,</section><section class=\"footer-signature-place\"></section><section \nclass=\"footer-signature-info\"><div class=\"name\"><b class=\"toUpper\">{{item.name | titleCase }}</b></div><div \nclass=\"position\">{{item.position}}</div></section></div></section><section class=\"footer-address\">\nJl. Soedirman No 1 Jakarta, Telp +621111111</section></div></section><section \nclass=\"pma-letter sheet padding-fill-kop\" ng-if=\"vm.warningLetterState(\'PM\', item.letter_code)\"><div \nclass=\"header-container\"><section class=\"header-kop\"><img class=\"kop-left\" src=\"assets/letter/pma-kop-left.png\" alt=\"\">\n <img class=\"kop-right\" src=\"assets/letter/pma-kop-right.png\" alt=\"\"></section><section class=\"header-title\"><u>\n{{item.letter_name}}</u><p>Nomor : {{item.letter_number}}</p></section><section class=\"header-content\"><div \nclass=\"two-rows-grid-header\"><div class=\"col-grid\">Surat ini kami tujukan kepada :</div></div><div \nclass=\"three-rows-grid-header\"><div class=\"col-grid\">Nama</div><div class=\"col-grid\">:</div><div \nclass=\"col-grid toUpper\">{{ item.name | titleCase }}</div></div><div class=\"three-rows-grid-header\"><div \nclass=\"col-grid\">NIK</div><div class=\"col-grid\">:</div><div class=\"col-grid\">{{item.nik}}</div></div><div \nclass=\"three-rows-grid-header\"><div class=\"col-grid\">Jabatan</div><div class=\"col-grid\">:</div><div class=\"col-grid\">\n{{item.position}}</div></div><div class=\"three-rows-grid-header\"><div class=\"col-grid\">Penempatan</div><div \nclass=\"col-grid\">:</div><div class=\"col-grid\">{{item.sub_area}}</div></div><br><div class=\"one-rows-grid\"><div \nclass=\"col-grid\">\nSehubungan dengan pelanggaran yang Saudara/i lakukan, yaitu dalam bentuk tindakan atau perilaku sebagai berikut :<br>\n<br><b><u>{{item.reason}}</u></b><br></div></div></section></div><div class=\"content-container\"><section \nclass=\"main-content\">\nBerkenaan dengan hal tersebut di atas maka sesuai dengan aturan yang berlaku, Saudara/i diberikan Pembinaan berupa <b>\n{{ item.letter_name.toUpperCase() }}</b>\n yang berlaku selama {{item.validity_period}} {{vm.toIndonesianName(item.validity_period)}} BULAN sejak {{vm.formatDate(item.valid_from )}} sampai dengan {{ vm.formatDate(item.valid_to) }}\n</section><section class=\"sub-content\" style=\"padding-bottom:0\">\nSetelah menerima Pembinaan ini, diharapkan Saudara/i dapat merubah sikap dan bekerja dengan lebih baik serta mentaati seluruh aturan. Apabila ternyata Saudara/i kembali berbuat suatu kesalahan atau pelanggaran lagi, maka kepada Saudara/i akan diberikan Pembinaan sesuai aturan yang berlaku.\n</section><section class=\"closing-content\" style=\"max-height: 20px\">\nDemikian surat ini kami sampaikan untuk menjadi perhatian.<br><br></section></div><div class=\"footer-container\">\n<section class=\"one-rows-grid\" style=\"padding-bottom: 1pt\"><div class=\"col-grid\">{{item.sub_area}}, {{item.printed_at}}\n</div><div class=\"col-grid\" style=\"padding-bottom: 0\">Hormat Kami,</div><div class=\"col-grid\">PT. PAS LINK</div>\n</section><section class=\"one-rows-grid\"><div class=\"col-grid\"><section class=\"footer-signature-place\"></section>\n<section class=\"footer-signature-info\"><div class=\"name\"><b>{{item.author.name | titleCase}}</b></div><div \nclass=\"position\">{{item.author.job_title}}</div></section></div></section><section class=\"one-rows-grid\"><div \nclass=\"col-grid\"><section class=\"footer-title\" style=\"padding-top: 25px\">Diterima Oleh,</section><section \nclass=\"footer-signature-place\"></section><section class=\"footer-signature-info\"><div class=\"name\"><b class=\"toUpper\">\n{{item.name | titleCase }}</b></div><div class=\"position\">{{item.position}}</div></section></div></section><section \nclass=\"footer-address\">Jl. Soedirman No 1 Jakarta, Telp +621111111</section></div></section><section \nclass=\"pma-letter sheet padding-fill-kop\" ng-if=\"vm.warningLetterState(\'KS\', item.letter_code)\"><div \nclass=\"header-container\"><section class=\"header-kop vertical no-border\"><img class=\"kop-center\" \nsrc=\"assets/letter/kop-sp-ks.png\" alt=\"\"><div class=\"kop-sub\">Snack Food Industry</div></section><section \nclass=\"header-title\"><u>{{item.letter_name}}</u><p>Nomor : {{item.letter_number}}</p><p>TINGKAT: {{item.tingkat}}</p>\n</section><section class=\"header-content\"><div class=\"two-rows-grid-header\"><div class=\"col-grid\">Diberikan kepada :\n</div></div><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">Nama</div><div class=\"col-grid\">:</div><div\n class=\"col-grid toUpper\">{{ item.name | titleCase }}</div></div><div class=\"three-rows-grid-header inc-5\"><div \nclass=\"col-grid\">Divisi / Department</div><div class=\"col-grid\">:</div><div class=\"col-grid\">\n{{item.division}} / {{item.department}}</div></div><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">\nJabatan</div><div class=\"col-grid\">:</div><div class=\"col-grid\">{{item.position}}</div></div><div \nclass=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">Lokasi Kerja</div><div class=\"col-grid\">:</div><div \nclass=\"col-grid\">{{item.sub_area}}</div></div><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">\nTanggal diperingatkan</div><div class=\"col-grid\">:</div><div class=\"col-grid\">{{vm.formatDate(item.valid_from)}}</div>\n</div><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">Masa Berlaku</div><div class=\"col-grid\">:</div>\n<div class=\"col-grid\">{{item.validity_period}} {{vm.toIndonesianName(item.validity_period)}} Bulan</div></div><br><div \nclass=\"one-rows-grid\"><div class=\"col-grid\">\nBahwa Saudara sebagai karyawan telah melanggar tata tertib Disiplin Kerja yang berlaku di perusahaan, yaitu :<br><br>\n<b><u>{{item.reason}}</u></b><br></div></div></section></div><div class=\"content-container\"><section \nclass=\"main-content\">\nDengan surat ini kami peringatkan agar Saudara lebih mentaati kewajiban sebagai karyawan PT. PAS LINK. Harap peringatan ini Saudara perhatikan sebaik-baiknya.\n</section><section class=\"sub-content\" style=\"padding-bottom:0\">\nPeringatan ini telah kami mengerti dengan sejelas-jelasnya dan kami berjanji untuk memperbaikinya.</section><section \nclass=\"closing-content\" style=\"max-height: 20px\"><br><br></section></div><div class=\"footer-container\"><section \nclass=\"two-rows-grid\"><div class=\"col-grid\"><section class=\"footer-title\">{{item.sub_area}}, {{item.printed_at}}\n</section><section class=\"footer-signature-place\"></section><section class=\"footer-signature-info\"><div class=\"name\">\n<b>{{item.author.name}}</b></div><div class=\"position\">{{item.author.job_title}}</div></section></div><div \nclass=\"col-grid\"><section class=\"footer-title center\">Yang diperingatkan</section><section \nclass=\"footer-signature-place\"></section><section class=\"footer-signature-info\"><div class=\"name center\"><b>\n{{item.name}}</b></div><div class=\"position center\">{{item.position}}</div></section></div></section><section \nclass=\"one-rows-grid center-col\"><div class=\"col-grid\"><section class=\"footer-title center\">Mengetahui</section>\n<section class=\"footer-signature-place\"></section><section class=\"footer-signature-info\"><div class=\"name center\"><b>\n{{item.approval.name}}</b></div><div class=\"position center\">{{item.approval.job_title}}</div></section></div>\n</section><section class=\"footer-address\">Jl. Soedirman No 1 Jakarta</section></div></section><section \nclass=\"pma-letter sheet padding-fill-kop\" ng-if=\"vm.warningLetterState(\'RK\', item.letter_code)\"><div \nclass=\"header-container\"><section class=\"header-kop vertical no-margin-bottom no-border\"><div class=\"multi-kop\"><img \nsrc=\"assets/letter/kop-rk-left.png\" alt=\"\"><div class=\"title\"></div><img src=\"assets/letter/kop-rk-right.png\" alt=\"\">\n</div></section><section class=\"header-title\"><u>{{item.letter_name}}</u><p>Nomor : {{item.letter_number}}</p>\n</section><section class=\"header-content\"><div class=\"two-rows-grid-header\"><div class=\"col-grid\">Diberikan kepada :\n</div></div><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">Nama</div><div class=\"col-grid\">:</div><div\n class=\"col-grid toUpper\">{{ item.name | titleCase }}</div></div><div class=\"three-rows-grid-header inc-5\"><div \nclass=\"col-grid\">Divisi / Department</div><div class=\"col-grid\">:</div><div class=\"col-grid\">\n{{item.division}} / {{item.department}}</div></div><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">\nJabatan</div><div class=\"col-grid\">:</div><div class=\"col-grid\">{{item.position}}</div></div><div \nclass=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">Lokasi Kerja</div><div class=\"col-grid\">:</div><div \nclass=\"col-grid\">{{item.sub_area}}</div></div><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">\nTanggal diperingatkan</div><div class=\"col-grid\">:</div><div class=\"col-grid\">{{vm.formatDate(item.valid_from)}}</div>\n</div><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">Masa Berlaku</div><div class=\"col-grid\">:</div>\n<div class=\"col-grid\">{{item.validity_period}} {{vm.toIndonesianName(item.validity_period)}} Bulan</div></div><br><div \nclass=\"one-rows-grid\"><div class=\"col-grid\">\nBahwa Saudara sebagai karyawan telah melanggar tata tertib Disiplin Kerja yang berlaku di perusahaan, yaitu :<br><br>\n<b><u>{{item.reason}}</u></b><br></div></div></section></div><div class=\"content-container\"><section \nclass=\"main-content\">\nDengan surat ini kami peringatkan agar Saudara lebih mentaati kewajiban sebagai karyawan PT. PAS LINK . Harap peringatan ini Saudara perhatikan sebaik-baiknya.\n</section><section class=\"sub-content\" style=\"padding-bottom:0\">\nPeringatan ini telah kami mengerti dengan sejelas-jelasnya dan kami berjanji untuk memperbaikinya.</section><section \nclass=\"closing-content\" style=\"max-height: 20px\"><br><br></section></div><div class=\"footer-container rki-footer\">\n<section class=\"two-rows-grid\"><div class=\"col-grid\"><section class=\"footer-title center\">karyawan Ybs,</section>\n<section class=\"footer-signature-place\"></section><section class=\"footer-signature-info\"><div class=\"name center\"><b>\n{{item.name}}</b></div><div class=\"position center\">{{item.position}}</div></section></div><div class=\"col-grid\">\n<section class=\"footer-title\">Atasan langsung</section><section class=\"footer-signature-place\"></section><section \nclass=\"footer-signature-info\"><div class=\"name\"><b>{{item.author.name}}</b></div><div class=\"position\">\n{{item.author.job_title}}</div></section></div></section><section class=\"two-rows-grid\"><div class=\"col-grid\"><section \nclass=\"footer-title\">Atasan Tidak langsung</section><section class=\"footer-signature-place\"></section><section \nclass=\"footer-signature-info\"><div class=\"name\"><b>{{item.approval_first.name}}</b></div><div class=\"position\">\n{{item.approval_first.job_title}}</div></section></div><div class=\"col-grid\"><section class=\"footer-title center\">\nHR Manager</section><section class=\"footer-signature-place\"></section><section class=\"footer-signature-info\"><div \nclass=\"name center\"><b>{{item.approval.name}}</b></div><div class=\"position center\">{{item.approval.job_title}}</div>\n</section></div></section><section class=\"footer-address\">Jl. Soedirman No 1 Jakarta</section></div></section><section \nclass=\"pma-letter sheet padding-fill-kop\" ng-if=\"vm.employeeCallingLetterState(\'KS\', item.letter_code)\"><div \nclass=\"header-container\"><section class=\"header-kop vertical border-single padding-top-10\"><div class=\"kop-sub normal\">\nPT PAS LINK</div><div class=\"secondary-kop-sub\"><i>Snack Food Industry</i></div><div class=\"address-kop-sub\">\nJl. Soedirman No 1 Jakarta</div></section><section class=\"header-title\" style=\"height: 30px\"><div \nclass=\"three-rows-grid-header inc-5\"><div class=\"col-grid\"><span style=\"text-transform: capitalize\">No. Surat</span>\n</div><div class=\"col-grid\">:</div><div class=\"col-grid\">{{ item.letter_number }}</div></div><div \nclass=\"three-rows-grid-header inc-5\"><div class=\"col-grid\"><span style=\"text-transform: capitalize\">Hal</span></div>\n<div class=\"col-grid\">:</div><div class=\"col-grid\">{{ item.letter_name }}</div></div></section><section \nclass=\"header-content\" style=\"height:50px\"><div class=\"one-rows-grid\"><div class=\"col-grid\">Kepada YTH<br><b>\n{{item.name | titleCase}}</b><br><b>{{item.nik}}</b><br><br>Dengan Hormat,<br><br></div></div></section></div><div \nclass=\"content-container\"><section class=\"main-content\" style=\"padding-bottom: 0pt; margin:auto\">\nSehubungan dengan ketidakhadiran saudara di perusahaan untuk bekerja tanpa pemberitahuan, maka dengan surat ini kami meminta kehadiran Saudara/i untuk masuk kembali bekerja pada :\n<div class=\"center-content\"><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\"><span \nstyle=\"text-transform: capitalize\">Hari/Tanggal</span></div><div class=\"col-grid center-align\">:</div><div \nclass=\"col-grid\">{{ item.calling_date }}</div></div><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\">\n<span style=\"text-transform: capitalize\">Tempat</span></div><div class=\"col-grid center-align\">:</div><div \nclass=\"col-grid\">{{ item.place }}</div></div><div class=\"three-rows-grid-header inc-5\"><div class=\"col-grid\"><span \nstyle=\"text-transform: capitalize\">Waktu</span></div><div class=\"col-grid center-align\">:</div><div class=\"col-grid\">\n{{ item.calling_time }}</div></div></div><div class=\"note-content\" ng-if=\"item.closing-content\">{{item.closing_text}}\n</div></section><section class=\"closing-content\" style=\"max-height: 20px\">\nDemikian surat pemberitahuan ini kami sampaikan, atas perhatiannya kami ucapkan terima kasih.</section></div><div \nclass=\"footer-container\"><section class=\"footer-title\">{{item.sub_area}}, {{item.printed_at}}</section><section \nclass=\"three-rows-grid\"><div class=\"col-grid\"><section class=\"footer-title\">Dibuat Oleh</section><section \nclass=\"footer-signature-place\"></section><section class=\"footer-signature-info\"><div class=\"name\"><b>\n{{item.author.name}}</b></div><div class=\"position\">{{item.author.job_title}}</div></section></div><div \nclass=\"col-grid\"><section class=\"footer-title center\">Mengetahui</section><section class=\"footer-signature-place\">\n</section><section class=\"footer-signature-info\"><div class=\"name center\"><b>{{item.approval.name}}</b></div><div \nclass=\"position center\">{{item.approval.job_title}}</div></section></div><div class=\"col-grid\"><section \nclass=\"footer-title center\">Yang Menerima</section><section class=\"footer-signature-place\"></section><section \nclass=\"footer-signature-info\"><div class=\"name center\"><b>{{item.name}}</b></div><div class=\"position center\">\n{{item.position}}</div></section></div></section><section class=\"footer-space\"></section></div></section><section \nclass=\"pma-letter sheet padding-fill-kop\" ng-if=\"item.letter_code === \'SURAT_TEGURAN\'\"><div class=\"header-container\">\n<section class=\"header-kop\"><img class=\"kop-left\" src=\"assets/letter/pma-kop-left.png\" alt=\"\"> <img class=\"kop-right\" \nsrc=\"assets/letter/pma-kop-right.png\" alt=\"\"></section><section class=\"header-title\"><u>Surat Teguran</u><p>\nNomor : {{item.letter_number}}</p></section><section class=\"header-content\"><div class=\"two-rows-grid-header\"><div \nclass=\"col-grid\">Surat ini kami tujukan kepada :</div></div><div class=\"three-rows-grid-header\"><div class=\"col-grid\">\nNama</div><div class=\"col-grid\">:</div><div class=\"col-grid toUpper\">{{item.name}}</div></div><div \nclass=\"three-rows-grid-header\"><div class=\"col-grid\">NIK</div><div class=\"col-grid\">:</div><div class=\"col-grid\">\n{{item.nik}}</div></div><div class=\"three-rows-grid-header\"><div class=\"col-grid\">Jabatan</div><div class=\"col-grid\">:\n</div><div class=\"col-grid\">{{item.position}}</div></div><div class=\"three-rows-grid-header\"><div class=\"col-grid\">\nPenempatan</div><div class=\"col-grid\">:</div><div class=\"col-grid\">{{item.sub_area}}</div></div><br><div \nclass=\"one-rows-grid\"><div class=\"col-grid\">\nSehubungan dengan pelanggaran yang Saudara/i lakukan, yaitu dalam bentuk tindakan atau perilaku sbb :<br><br><b><u>\n{{item.reason}}</u></b><br></div></div></section></div><div class=\"content-container\"><section class=\"main-content\">\nBerkenaan dengan hal tersebut di atas maka sesuai dengan aturan yang berlaku, Saudara/i diberikan Pembinaan berupa <b>\nSURAT TEGURAN</b>\n yang berlaku selama {{item.validity_period}} {{vm.toIndonesianName(item.validity_period)}} BULAN sejak {{vm.formatDate(item.valid_from)}} sampai dengan {{ vm.formatDate(item.valid_to) }}\n</section><section class=\"sub-content\">\nSetelah menerima Pembinaan ini, diharapkan Saudara/i dapat merubah sikap dan bekerja dengan lebih baik serta mentaati seluruh aturan. Apabila ternyata Saudara/i kembali berbuat suatu kesalahan atau pelanggaran lagi, maka kepada Saudara/i akan diberikan Pembinaan sesuai aturan yang berlaku.\n</section><section class=\"closing-content\">Demikian surat ini kami sampaikan untuk menjadi perhatian.<br>Terima kasih.\n</section></div><div class=\"footer-container\"><section class=\"one-rows-grid\" style=\"padding-bottom: 1pt\"><div \nclass=\"col-grid\">{{item.sub_area}}, {{item.printed_at}}</div><div class=\"col-grid\" style=\"padding-bottom: 0\">\nHormat Kami,</div><div class=\"col-grid\">PT. PAS LINK</div></section><section class=\"one-rows-grid\"><div \nclass=\"col-grid\"><section class=\"footer-signature-place\"></section><section class=\"footer-signature-info\"><div \nclass=\"name\"><b>{{item.author.name | titleCase}}</b></div><div class=\"position\">{{item.author.job_title}}</div>\n</section></div></section><section class=\"one-rows-grid\"><div class=\"col-grid\"><section class=\"footer-title\" \nstyle=\"padding-top: 25px\">Diterima Oleh,</section><section class=\"footer-signature-place\"></section><section \nclass=\"footer-signature-info\"><div class=\"name\"><b class=\"toUpper\">{{item.name | titleCase }}</b></div><div \nclass=\"position\">{{item.position}}</div></section></div></section><section class=\"footer-address\">\nJl. Soedirman No 1 Jakarta, Telp +621111111</section></div></section></div>");
$templateCache.put("app/main/report/correspondence/sk-penugasan-multiple/sk-penugasan-multiple.html","<div id=\"sk\" class=\"sheet letter-container-sk\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>\nSURAT KEPUTUSAN</h2><h3>\nNO :{{ vm.getNumberID(vm.item.id) }}/KSNI_HRD/SK-PGS/{{vm.getMonth(vm.item.start_date)}}/{{vm.getYear(vm.item.end_date)}}\n</h3></div><div class=\"preface-letter-header\"><h3>TENTANG</h3><h3>PENUGASAN KARYAWAN</h3></div></div><div \nclass=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentukanya unit usaha baru\n</li><li>Adanya posisi kosong yang perlu segera diisi</li><li>\nPerluasan pekerjaan untuk peningakatan kompetensi karyawan dengan penugasan yang baru baik dari pekerjaan dan/atau lokasi kerja.\n</li><li>Bahwa sebagai kesatuan program tersebut, perlu dibuatkan suatu Surat Keputusan resmi.</li></ol></div></div>\n<div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi yang dilakukan dalam proses pengembangan organisasi dan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PENUGASAN</b></div></div></div><div \nclass=\"letter-content-item table\"><table cellpadding=\"6\" class=\"normal-tbl\"><tr><th>NIK</th><th>Nama</th><th>Grade</th>\n<th>Job Title</th><th>Location</th></tr><tr ng-repeat=\"item in vm.item.employeeLists\"><td>{{item.nik}}</td><td>\n{{item.name}}</td><td>{{item.grade}}</td><td>{{item.job_title}}</td><td>{{vm.item.location}}</td></tr></table></div>\n<div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kedua</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nUraian tugas dan tanggung jawab diatur terpisah dalam Job Description.</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nJabatan tersebut masih tetap melekat pada karyawan ybs</div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">Keempat</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini berlaku efektif sejak tanggal {{ vm.getFinishedDate(vm.item.start_date) }} sampai dengan tanggal {{ vm.getFinishedDate(vm.item.end_date) }}\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{ vm.getFinishedDate(vm.item.start_date) }}</div><div class=\"company\">PT. Kaldu Sari Nabati Indonesia\n</div><div class=\"signature\"><p style=\"text-decoration: underline; margin-block-end: 0\">Indah Permata Rizki</p><i>\nHuman Capital Services Head</i></div></div></div>");
$templateCache.put("app/main/report/correspondence/sk-penugasan-single/sk-penugasan-single.html","<div id=\"sk\" class=\"sheet letter-container-sk\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>\nSURAT KEPUTUSAN</h2><h3>\nNO :{{ vm.getNumberID(vm.item.id) }}/KSNI_HRD/SK-PGS/{{vm.getMonth(vm.item.start_date)}}/{{vm.getYear(vm.item.end_date)}}\n</h3></div><div class=\"preface-letter-header\"><h3>TENTANG</h3><h3>PENUGASAN KARYAWAN</h3></div></div><div \nclass=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentukanya unit usaha baru\n</li><li>Adanya posisi kosong yang perlu segera diisi</li><li>\nPerluasan pekerjaan untuk peningakatan kompetensi karyawan dengan penugasan yang baru baik dari pekerjaan dan/atau lokasi kerja.\n</li><li>Bahwa sebagai kesatuan program tersebut, perlu dibuatkan suatu Surat Keputusan resmi.</li></ol></div></div>\n<div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi yang dilakukan dalam proses pengembangan organisasi dan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PENUGASAN</b></div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nNIK / NAMA</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{vm.item.employeeLists[0].nik}} / {{vm.item.employeeLists[0].name}}</div></div></div><div class=\"letter-content-item\" \nstyle=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">GRADE</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">{{vm.item.employeeLists[0].grade}}</div></div>\n</div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span \nclass=\"text-label normal\">JABATAN</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div \nclass=\"text-point\">{{vm.item.employeeLists[0].job_title}}</div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">LOKASI</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{vm.item.location}}</div></div></div><div class=\"letter-content-item\">\n<div class=\"label-point\"><span class=\"text-label normal\">Kedua</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">Uraian tugas dan tanggung jawab diatur terpisah dalam Job Description.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nJabatan {{vm.item.employeeLists[0].job_title}} masih tetap melekat pada karyawan ybs</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Keempat</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{vm.getFinishedDate(vm.item.start_date)}}</div></div></div>\n<div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui Pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{vm.getFinishedDate(vm.item.start_date)}}</div><div class=\"company\">PT. Kaldu Sari Nabati Indonesia\n</div><div class=\"signature\"><p style=\"text-decoration: underline; margin-block-end: 0\">Indah Permata Rizki</p><i>\nHuman Capital Services Head</i></div></div></div>");
$templateCache.put("app/main/report/correspondence/sk-promosi-extend/sk-promosi-extend.html","<div id=\"sk\" class=\"sheet letter-container-sk\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>\nSURAT KEPUTUSAN</h2><h3>\nNO :{{ vm.getNumberID(vm.item.id) }}/KSNI_HRD/SK-PMS/{{vm.getMonth(vm.item.start_date)}}/{{vm.getYear(vm.item.start_date)}}\n</h3></div><div class=\"preface-letter-header\"><h3>TENTANG</h3><h3>PROMOSI KARYAWAN (EXTEND)</h3></div></div><div \nclass=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di lingkungan perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentuknya unit usaha baru.\n</li><li>\nAdanya peningkatan mutu dan kompetensi yang berkait dengan jenjang karir karyawan, sehingga dilaksanakan program mutasi jabatan maupun rotasi lokasi kerja dan juga promosi grade karyawan.\n</li><li>Bahwa sebagai kesatuan program tersebut pada butir 2 di atas, perlu dibuatkan suatu Surat Keputusan resmi.\n</li></ol></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi kinerja dalam masa percobaan dan rekomendasi atasan sebagai bagian dalam pengelolaan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PROMOSI</b></div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nNAMA / NIK</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{vm.item.name}} / {{vm.item.nik}}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div\n class=\"label-point\"><span class=\"text-label normal\">JABATAN BARU</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{vm.item.position_new}}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nORG. UNIT</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{vm.item.org_unit}}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div \nclass=\"label-point\"><span class=\"text-label normal\">GRADE LAMA</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{vm.item.grade_old}}</div></div></div><div class=\"letter-content-item\" \nstyle=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">GRADE DITUJU</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">{{vm.item.grade_target}}</div></div></div><div\n class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">GRADE AKHIR</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">{{vm.item.grade_last}}</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kedua</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nUraian tugas dan tanggung jawab diatur terpisah dalam Job Description.</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nKompensasi &amp; Benefit mengacu pada SK Promosi sebelumnya.</div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">Keempat</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{ vm.getFinishedDate(vm.item.start_date) }} – {{ vm.getFinishedDate(vm.item.end_date) }}\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{ vm.getFinishedDate(vm.item.start_date) }}</div><div class=\"company\">PT. Kaldu Sari Nabati Indonesia\n</div><div class=\"signature\"><p style=\"text-decoration: underline; margin-block-end: 0\">Indah Permata Rizki</p><i>\nHuman Capital Services Head</i></div></div></div>");
$templateCache.put("app/main/report/correspondence/sk-promosi-lanjutan/sk-promosi-lanjutan.html","<div id=\"sk\" class=\"sheet letter-container-sk\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>\nSURAT KEPUTUSAN</h2><h3>\nNO: {{ vm.getNumberID(vm.item.id) }}/KSNI_HRD/SK-PMS/{{vm.getMonth(vm.item.start_date)}}/{{vm.getYear(vm.item.start_date)}}\n</h3></div><div class=\"preface-letter-header\"><h3>TENTANG</h3><h3>PROMOSI KARYAWAN (ACTING)</h3></div></div><div \nclass=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di lingkungan perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentuknya unit usaha baru.\n</li><li>\nAdanya peningkatan mutu dan kompetensi yang berkait dengan jenjang karir karyawan, sehingga dilaksanakan program mutasi jabatan maupun rotasi lokasi kerja dan juga promosi grade karyawan.\n</li><li>Bahwa sebagai kesatuan program tersebut pada butir 2 di atas, perlu dibuatkan suatu Surat Keputusan resmi.\n</li></ol></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi kinerja dalam masa percobaan dan rekomendasi atasan sebagai bagian dalam pengelolaan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PROMOSI</b></div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nNAMA / NIK</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{vm.item.name}} / {{vm.item.nik}}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div\n class=\"label-point\"><span class=\"text-label normal\">JABATAN BARU</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{vm.item.position_new}}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nORG. UNIT</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{vm.item.org_unit}}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div \nclass=\"label-point\"><span class=\"text-label normal\">GRADE BARU</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{vm.item.grade_new}}</div></div></div><div class=\"letter-content-item\" \nstyle=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">GRADE DITUJU</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">{{vm.item.grade_target}}</div></div></div><div\n class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">GRADE AKHIR</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">{{vm.item.grade_last}}</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kedua</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nUraian tugas dan tanggung jawab diatur terpisah dalam Job Description.</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nKompensasi & Benefit mengacu pada SK Promosi sebelumnya, dengan nominal Promotion Allowance sebagian sudah dilebur kepada komponen gaji lainnya.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Keempat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{ vm.getFinishedDate(vm.item.start_date) }} – {{ vm.getFinishedDate(vm.item.end_date) }}\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{ vm.getFinishedDate(vm.item.start_date) }}</div><div class=\"company\">PT. Kaldu Sari Nabati Indonesia\n</div><div class=\"signature\"><p style=\"text-decoration: underline; margin-block-end: 0\">Indah Permata Rizki</p><i>\nHuman Capital Services Head</i></div></div></div>");
$templateCache.put("app/main/report/correspondence/sk-promosi-lulus/sk-promosi-lulus.html","<div id=\"sk\" class=\"sheet letter-container-sk\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>\nSURAT KEPUTUSAN</h2><h3>\nNO: {{ vm.getNumberID(vm.item.id) }}/KSNI_HRD/SK-PMS/{{vm.getMonth(vm.item.effective_date)}}/{{vm.getYear(vm.item.effective_date)}}\n</h3></div><div class=\"preface-letter-header\"><h3>TENTANG</h3><h3>PROMOSI KARYAWAN</h3></div></div><div \nclass=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di lingkungan perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentuknya unit usaha baru.\n</li><li>\nAdanya peningkatan mutu dan kompetensi yang berkait dengan jenjang karir karyawan, sehingga dilaksanakan program mutasi jabatan maupun rotasi lokasi kerja dan juga promosi grade karyawan.\n</li><li>Bahwa sebagai kesatuan program tersebut pada butir 2 di atas, perlu dibuatkan suatu Surat Keputusan resmi.\n</li></ol></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi kinerja dalam masa percobaan dan rekomendasi atasan sebagai bagian dalam pengelolaan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PROMOSI</b></div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nNAMA / NIK</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{vm.item.name}} / {{vm.item.nik}}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div\n class=\"label-point\"><span class=\"text-label normal\">JABATAN BARU</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{vm.item.position_new}}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nORG. UNIT</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{vm.item.org_unit}}</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span \nclass=\"text-label normal\">GRADE BARU</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div \nclass=\"text-point\">{{vm.item.grade_new}}</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\">\n<span class=\"text-label normal\">Kedua</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div \nclass=\"text-point\">Uraian tugas dan tanggung jawab diatur terpisah dalam Job Description.</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nPromotion Allowance yang diperoleh saat mulai menjalani masa promosi, dilebur ke Basic Salary, Management Allowance, dan Premi Attendance.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Keempat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{vm.getFinishedDate(vm.item.effective_date)}}</div></div>\n</div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima</span></div><div\n class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{ vm.getFinishedDate(vm.item.effective_date) }}</div><div class=\"company\">\nPT. Kaldu Sari Nabati Indonesia</div><div class=\"signature\"><p style=\"text-decoration: underline; margin-block-end: 0\">\nIndah Permata Rizki</p><i>Human Capital Services Head</i></div></div></div>");
$templateCache.put("app/main/report/correspondence/sk-promosi-tetap/sk-promosi-tetap.html","<section id=\"sk\" class=\"sheet letter-container-sk padding-25mm\"><div class=\"letter-header\"><div \nclass=\"top-letter-header\"><h2>SURAT KEPUTUSAN</h2><h3>\nNO: {{ vm.getNumberID(vm.item.id) }}/KSNI_HRD/SK-TTP/{{vm.getMonth(vm.item.effective_date)}}/{{vm.getYear(vm.item.effective_date)}}\n</h3></div><div class=\"preface-letter-header\"><h3>TENTANG</h3><h3>PENGANGKATAN KARYAWAN TETAP</h3></div></div><div \nclass=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di lingkungan perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentuknya unit usaha baru.\n</li><li>\nDiperlukannya tenaga kerja yang berkualifikasi sesuai dengan standar dan proses recruitment di lingkungan perusahaan.\n</li><li>Bahwa sebagai kesatuan program tersebut pada butir 2 di atas, perlu dibuatkan suatu Surat Keputusan resmi.\n</li></ol></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi kinerja dalam masa percobaan dan rekomendasi atasan sebagai bagian dalam pengelolaan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PENGANGKATAN KARYAWAN TETAP</b><br>\nPT. Kaldu Sari Nabati Indonesia</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div \nclass=\"label-point\"><span class=\"text-label normal\">NAMA / NIK</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{vm.item.name}} / {{vm.item.nik}}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nJABATAN</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{vm.item.position_new}}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div \nclass=\"label-point\"><span class=\"text-label normal\">GRADE</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{vm.item.grade_new}}</div></div></div><div class=\"letter-content-item\">\n<div class=\"label-point\"><span class=\"text-label normal\">LOKASI</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{vm.item.location}}</div></div></div><div class=\"letter-content-item\">\n<div class=\"label-point\"><span class=\"text-label normal\">Kedua</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">Uraian tugas dan tanggung jawab diatur terpisah dalam Job Description.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nPromotion Allowance yang diperoleh saat mulai menjalani masa promosi, dilebur ke Basic Salary, Management Allowance, dan Premi Attendance.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Keempat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{vm.getFinishedDate(vm.item.effective_date)}}</div></div>\n</div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban termasuk Compensation & Benefit berlaku sesuai dengan Surat Keputusan yang diatur tersendiri.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{vm.getFinishedDate(vm.item.effective_date)}}</div><div class=\"company\">PT. Kaldu Sari Nabati Indonesia\n</div><div class=\"signature\"><p style=\"text-decoration: underline; margin-block-end: 0\">Indah Permata Rizki</p><i>\nHuman Capital Services Head</i></div></div></section>");
$templateCache.put("app/main/report/correspondence/visa/visa.html","<section class=\"letter-container-correspondence sheet padding-25mm\"><section class=\"letter-header visa\">\nBandung, {{ vm.getFinishedDate(vm.item.finished_at) }}</section><section class=\"letter-preface visa\"><p \nstyle=\"margin-block-end:2em\"><strong>EMBASSY of {{ vm.item.travel_destination_name.toUpperCase() }},</strong></p><p \nstyle=\"margin-block-end:3em\">Re <span style=\"padding-left:3em\">:</span> Visa Application</p><p>Dear Sir/Madam,</p><p>\nI, the undersign,</p></section><section class=\"letter-content visa\"><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label\">Name</span></div><div class=\"spacer\"></div><div class=\"content-point\"><div\n class=\"text-point\"><strong>INDAH PERMATA RIZKI</strong></div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label\">Title</span></div><div class=\"spacer\"></div><div class=\"content-point\">\n<div class=\"text-point\">Human Capital Services Head of PT. Kaldu Sari Nabati Indonesia</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Address</span></div><div class=\"spacer\">\n</div><div class=\"content-point\"><div class=\"text-point\">\nJl. Soekarno Hatta No. 112 Bandung Jl. Raya Cicalengka – Majalaya KM 1,6 Desa Cikuya, Kab. Bandung Gedung 18 Office Park, Lt. 16 Jl. TB Simatupang No. 18, Pasar Minggu Jakarta Selatan 12520\n</div></div></div></section><section class=\"letter-preface visa\"><p>Herewith certify that,</p></section><section \nclass=\"letter-content visa\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Name\n</span></div><div class=\"spacer\"></div><div class=\"content-point\"><div class=\"text-point\">{{ vm.item.name }}</div>\n</div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Nationality</span></div>\n<div class=\"spacer\"></div><div class=\"content-point\"><div class=\"text-point\">{{ vm.item.nationality }}</div></div>\n</div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Title</span></div><div \nclass=\"spacer\"></div><div class=\"content-point\"><div class=\"text-point\">{{ vm.item.job_title }}</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Passport No</span></div><div \nclass=\"spacer\"></div><div class=\"content-point\"><div class=\"text-point\">{{ vm.item.passport }}</div></div></div>\n</section><section class=\"letter-content-statement visa\" ng-if=\"vm.item.request_type == 2\"><p \nstyle=\"text-align:justify; margin-bottom: 1em\">\nWill be travelling to {{ vm.item.travel_destination_name }} for business purposes on {{ vm.getFinishedDate(vm.item.travel_start_date) }} until {{ vm.getFinishedDate(vm.item.travel_end_date) }}, I guarantee that {{ vm.item.gender == \'L\' ? \'he\' : \'she\' }} will not seek any kind of permanent residence or employment in {{ vm.item.travel_destination_name }} and promise to obey every regulation in your country. All kind of expenses for the trip will be paid by PT. Kaldu Sari Nabati Indonesia.\n</p><p style=\"text-align:justify\">\nI would really appreciate if you could issued Business Visa for {{ vm.item.gender == \'L\' ? \'him\' : \'her\' }}. Your kind assistance and cooperation will be highly appreciated.\n</p></section><section class=\"letter-content-statement visa\" ng-if=\"vm.item.request_type == 3\"><p \nstyle=\"text-align:justify; margin-bottom: 1em\">\nWill be travelling to {{ vm.item.travel_destination_name }}, I guarantee that {{ vm.item.gender == \'L\' ? \'he\' : \'she\' }} will not seek any kind of permanent residence or employment in {{ vm.item.travel_destination_name }} and promise to obey every regulation in your country.\n</p><p style=\"text-align:justify\">\nI would really appreciate if you could issued Tourist Visa for {{ vm.item.gender == \'L\' ? \'him\' : \'her\' }}. Your kind assistance and cooperation will be highly appreciated.\n</p></section><section class=\"letter-footer visa\"><div class=\"location visa\">Your sincerely,</div><div \nclass=\"spacer visa\"></div><div class=\"signature visa\"><p style=\"text-decoration: underline; margin-block-end: 0\">\nIndah Permata Rizki</p><i>Human Capital Services Head</i></div></section></section>");
$templateCache.put("app/main/report/jic/sk-demosi/sk-demosi.html","<div class=\"sheet letter-container\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>SURAT KEPUTUSAN</h2>\n<h3>NO : {{vm.item.no_sk}}</h3></div><div class=\"preface-letter-header\"><h3>TENTANG</h3><h3>DEMOSI KARYAWAN</h3></div>\n</div><div class=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">\nMenimbang</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nAdanya pelanggaran yang dilakukan karyawan mengacu pada Peraturan Perusahaan sehingga dilaksanakan program demosi jabatan.\n</li><li>\nPekerja yang dinilai tidak mampu dan tidak terampil melaksanakan tugasnya dan telah diberikan kesempatan untuk memperbaiki kinerja tetapi tetap tidak menunjukan hasil yang memuaskan\n</li><li>Bahwa sebagai kesatuan program tersebut, perlu dibuatkan suatu Surat Keputusan resmi</li></ol></div></div><div\n class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi kinerja dalam masa kerja dan rekomendasi atasan sebagai bagian dalam pengelolaan sumber daya manusia dilingkungan perusahaan\n</div></div></div><div class=\"preface-letter-header\" style=\"text-align: center; margin-bottom: 15px\"><span \nclass=\"text-label\" style=\"text-align: center\"><b>Memutuskan</b></span></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label\">Menetapkan</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\"></div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\"><b>DEMOSI</b></div></div></div><div class=\"letter-content-item\" \nstyle=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">NAMA / NIK</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">{{ vm.item.fullname }} / {{ vm.item.nik }}\n</div></div></div><div style=\"padding: 0px 10px 0px; width: 100%; margin-top: 5px; margin-bottom: 15px\"><table \nstyle=\"width: 100%; border-spacing: 0px\"><thead><tr><th colspan=\"3\" \nstyle=\"background-color: #bdbdbd; text-align: center; border-top: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nLAMA</th><th colspan=\"3\" \nstyle=\"background-color: #bdbdbd; text-align: center; border-top: 1px solid #000; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nBARU</th></tr><tr><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000\">\nORG.UNIT</th><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nJABATAN</th><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nGRADE</th><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nORG.UNIT</th><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nJABATAN</th><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nGRADE</th></tr></thead><tbody><tr><td \nstyle=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000\">\n{{ vm.item.org_unit_lama }}</td><td \nstyle=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">{{ vm.item.jabatan_lama }}</td>\n<td style=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">{{ vm.item.grade_lama }}\n</td><td style=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">{{ vm.item.org_unit }}\n</td><td style=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\n{{ vm.item.jabatan_baru }}</td><td \nstyle=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">{{ vm.item.grade_baru }}</td>\n</tr></tbody></table></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">\nKedua</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nUraian tugas dan tanggung jawab diatur terpisah dalam Job Description.</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nKompensasi dan Benefit yang di terima akan di sesuaikan dengan golongan/jabatan baru sesuai dengan yang diatur dalam Lampiran SK ini.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Keempat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{ vm.item.effective_date | date:\'dd/MM/yyyy\' }}</div></div>\n</div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima</span></div><div\n class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui Pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di {{vm.item.print.location_name}}</div><div \nclass=\"date\">Pada tanggal, {{ vm.item.effective_date | date: \'dd/MM/yyyy\' }}</div><div class=\"company\">\nPT. Kaldu Sari Nabati Indonesia</div><div class=\"signature\">{{ vm.item.print.fullname }}</div><div class=\"signature\">\n{{ vm.item.print.job_title }}</div></div></div>");
$templateCache.put("app/main/report/jic/sk-mutasi/sk-mutasi.html","<div class=\"sheet letter-container\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>SURAT KEPUTUSAN</h2>\n<h3>NO : {{vm.item.no_sk}}</h3></div><div class=\"preface-letter-header\"><h3>TENTANG</h3><h3>MUTASI KARYAWAN</h3></div>\n</div><div class=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">\nMenimbang</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentuknya unit usaha baru.\n</li><li>\nPerlunya peningakatan kompetensi karyawan dengan penugasan yang baru baik dari pekerjaan dan/atau lokasi kerja.</li>\n<li>Bahwa sebagai kesatuan program tersebut pada butir 2 di atas, perlu dibuatkan suatu Surat Keputusan resmi.</li>\n</ol></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi yang dilakukan dalam proses pengembangan organisasi dan sumber daya manusia di lingkungan perusahaan\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>MUTASI</b></div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nNAMA / NIK</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.fullname }} / {{ vm.item.nik }}</div></div></div><div class=\"letter-content-item\" \nstyle=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">ORG. UNIT LAMA</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">{{ vm.item.org_unit }}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nORG. UNIT BARU</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.new_org_unit }}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div \nclass=\"label-point\"><span class=\"text-label normal\">JABATAN LAMA</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.jabatan_lama }}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nJABATAN BARU</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.jabatan_baru }}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div \nclass=\"label-point\"><span class=\"text-label normal\">LOKASI LAMA</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.original_place }}</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">LOKASI BARU</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">{{ vm.item.new_place }}</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kedua</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nUraian tugas dan tanggung jawab diatur terpisah dalam Job Description.</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nTidak ada perubahan kompensasi dan benefit terkait SK ini.</div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">Keempat</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{ vm.item.effective_date }}</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui Pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini,maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di {{vm.item.print.location_name}}</div><div \nclass=\"date\">Pada tanggal, {{ vm.item.effective_date | date:\'yyyy/MM/dd\' }}</div><div class=\"company\">\nPT. Kaldu Sari Nabati Indonesia</div><div class=\"signature\">{{ vm.item.print.fullname }}</div></div></div>");
$templateCache.put("app/main/report/jic/sk-penugasan/sk-penugasan.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><meta name=\"viewport\" \ncontent=\"width=device-width,initial-scale=1\"><meta http-equiv=\"X-UA-Compatible\" content=\"ie=edge\"><link \nrel=\"stylesheet\" href=\"style.css\"><title>SURAT KEPUTUSAN PENUGASAN KARYAWAN</title></head><body class=\"A4\"><div \nclass=\"sheet letter-container\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>SURAT KEPUTUSAN</h2><h3>\nNO : {{ vm.item.id }}/KSNI_HRD/SK-DMS/{{ vm.item.month }}/{{ vm.item.year }}</h3></div><div \nclass=\"preface-letter-header\"><h3>TENTANG</h3><h3>PENUGASAN KARYAWAN</h3></div></div><div class=\"letter-content\"><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentukanya unit usaha baru\n</li><li>Adanya posisi kosong yang perlu segera diisi</li><li>\nPerluasan pekerjaan untuk peningakatan kompetensi karyawan dengan penugasan yang baru baik dari pekerjaan dan/atau lokasi kerja.\n</li><li>Bahwa sebagai kesatuan program tersebut, perlu dibuatkan suatu Surat Keputusan resmi.</li></ol></div></div>\n<div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi yang dilakukan dalam proses pengembangan organisasi dan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PENUGASAN</b></div></div></div><div \nclass=\"letter-content-item table\" ng-if=\"vm.item.employee.length > 1\"><table cellpadding=\"6\"><tr><th>NIK</th><th>Nama\n</th><th>Employee Grade</th><th>Job Title</th></tr><tr ng-repeat=\"item in vm.item.employee\"><td>{{ item.nik }}</td><td>\n{{ item.name }}</td><td>{{ item.grade }}</td><td>{{ item.job_position }}</td></tr></table></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\" ng-if=\"vm.item.employee.length === 1\"><div \nclass=\"label-point\"><span class=\"text-label normal\">NAMA / NIK</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.employee[0].nama }} / {{ vm.item.employee[0].nik }}</div>\n</div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\" ng-if=\"vm.item.employee.length === 1\"><div \nclass=\"label-point\"><span class=\"text-label normal\">GRADE</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.employee[0].grade }}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\" ng-if=\"vm.item.employee.length === 1\"><div \nclass=\"label-point\"><span class=\"text-label normal\">JABATAN</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.employee[0].job_position }}</div></div></div><div \nclass=\"letter-content-item\" ng-if=\"vm.item.employee.length === 1\"><div class=\"label-point\"><span \nclass=\"text-label normal\">LOKASI</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div \nclass=\"text-point\">{{ vm.item.employee[0].location }}</div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">Kedua</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">Uraian tugas dan tanggung jawab diatur terpisah dalam Job Description.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nJabatan {{ vm.item.job_position }} masih tetap melekat pada karyawan ybs</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Keempat</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{ vm.item.effective_date }} sampai dengan tanggal {{ vm.item.end_date }}\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui Pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{ vm.item.effective_date }}</div><div class=\"company\">PT. Kaldu Sari Nabati Indonesia</div><div \nclass=\"signature\">{{ vm.item.approved_by }}</div></div></div></body></html>");
$templateCache.put("app/main/report/jic/sk-promosi-extend/sk-promosi-extend.html","<div class=\"sheet letter-container\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>SURAT KEPUTUSAN</h2>\n<h3>NO : {{ vm.item.id }}/KSNI_HRD/SK-PMS/{{ vm.item.month }}/{{ vm.item.year }}</h3></div><div \nclass=\"preface-letter-header\"><h3>TENTANG</h3><h3>PROMOSI KARYAWAN (EXTEND)</h3></div></div><div \nclass=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di lingkungan perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentuknya unit usaha baru.\n</li><li>\nAdanya peningkatan mutu dan kompetensi yang berkait dengan jenjang karir karyawan, sehingga dilaksanakan program mutasi jabatan maupun rotasi lokasi kerja dan juga promosi grade karyawan.\n</li><li>Bahwa sebagai kesatuan program tersebut pada butir 2 di atas, perlu dibuatkan suatu Surat Keputusan resmi.\n</li></ol></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi kinerja dalam masa percobaan dan rekomendasi atasan sebagai bagian dalam pengelolaan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PROMOSI</b></div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nNAMA / NIK</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.name }} / {{ vm.item.nik }}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\">\n<div class=\"label-point\"><span class=\"text-label normal\">JABATAN BARU</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.new_position }}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nORG. UNIT</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.original_org_unit }}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div \nclass=\"label-point\"><span class=\"text-label normal\">GRADE LAMA</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.old_grade }}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nGRADE DITUJU</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.target_grade }}</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span \nclass=\"text-label normal\">GRADE AKHIR</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div \nclass=\"text-point\">{{ vm.item.final_grade }}</div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">Kedua</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">Uraian tugas dan tanggung jawab diatur terpisah dalam Job Description.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nKompensasi &amp; Benefit mengacu pada SK Promosi sebelumnya.</div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">Keempat</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{ vm.item.effective.date }} – {{ vm.item.end_date }}</div>\n</div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{ vm.item.effective_date }}</div><div class=\"company\">PT. Kaldu Sari Nabati Indonesia</div><div \nclass=\"signature\">{{ vm.item.approved_by }}</div></div></div>");
$templateCache.put("app/main/report/jic/sk-promosi-awal/sk-promosi-awal.html","<div class=\"sheet letter-container\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>SURAT KEPUTUSAN</h2>\n<h3>NO : {{vm.item.no_sk}}</h3></div><div class=\"preface-letter-header\"><h3>TENTANG</h3><h3>PROMOSI KARYAWAN (ACTING)\n</h3></div></div><div class=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span \nclass=\"text-label\">Menimbang</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol \nstyle=\"margin-left: 12px\"><li>\nPengembangan organisasi yang terjadi di lingkungan perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentuknya unit usaha baru.\n</li><li>\nAdanya peningkatan mutu dan kompetensi yang berkait dengan jenjang karir karyawan, sehingga dilaksanakan program mutasi jabatan maupun rotasi lokasi kerja dan juga promosi grade karyawan.\n</li><li>Bahwa sebagai kesatuan program tersebut pada butir 2 di atas, perlu dibuatkan suatu Surat Keputusan resmi.\n</li></ol></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi kinerja dalam masa percobaan dan rekomendasi atasan sebagai bagian dalam pengelolaan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"preface-letter-header\" style=\"text-align: center; margin-bottom: 15px\"><span \nclass=\"text-label\" style=\"text-align: center\"><b>Memutuskan</b></span></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label\">Menetapkan</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\"></div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\"><b>PROMOSI</b></div></div></div><div class=\"letter-content-item\" \nstyle=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">NAMA / NIK</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">{{ vm.item.fullname }} / {{ vm.item.nik }}\n</div></div></div><div style=\"padding: 0px 10px 0px; width: 100%; margin-top: 5px; margin-bottom: 15px\"><table \nstyle=\"width: 100%; border-spacing: 0px\"><thead><tr><th colspan=\"3\" \nstyle=\"background-color: #bdbdbd; text-align: center; border-top: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nLAMA</th><th colspan=\"3\" \nstyle=\"background-color: #bdbdbd; text-align: center; border-top: 1px solid #000; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nBARU</th></tr><tr><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000\">\nORG.UNIT</th><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nJABATAN</th><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nGRADE</th><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nORG.UNIT</th><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nJABATAN</th><th \nstyle=\"background-color: #bdbdbd; text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\nGRADE</th></tr></thead><tbody><tr><td \nstyle=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000\">\n{{ vm.item.org_unit_lama }}</td><td \nstyle=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">{{ vm.item.jabatan_lama }}</td>\n<td style=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">{{ vm.item.grade_lama }}\n</td><td style=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">{{ vm.item.org_unit }}\n</td><td style=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">\n{{ vm.item.jabatan_baru }}</td><td \nstyle=\"text-align: center; border-right: 1px solid #000; border-bottom: 1px solid #000\">{{ vm.item.grade_baru }}</td>\n</tr></tbody></table></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">\nKedua</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nUraian tugas dan tanggung jawab diatur terpisah dalam Job Description.</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nKompensasi dan Benefit diatur dalam Lampiran SK ini.</div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">Keempat</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{ vm.item.masa_acting_awal | date:\'dd/MM/yyyy\' }} - {{vm.item.masa_acting_akhir | date:\'dd/MM/yyyy\'}}\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini. Demikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.\n</p></div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di {{vm.item.print.location_name}}</div>\n<div class=\"date\">Pada tanggal, {{ vm.item.effective_date | date:\'dd/MM/yyyy\' }}</div><div class=\"company\">\nPT. Kaldu Sari Nabati Indonesia</div><div class=\"signature\">{{ vm.item.print.fullname }}</div><div class=\"signature\">\n{{ vm.item.print.job_title }}</div></div></div>");
$templateCache.put("app/main/report/jic/sk-promosi-lanjutan/sk-promosi-lanjutan.html","<div class=\"sheet letter-container\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>SURAT KEPUTUSAN</h2>\n<h3>NO : {{ vm.item.id }}/KSNI_HRD/SK-PMS/{{ vm.item.month }}/{{ vm.item.year }}</h3></div><div \nclass=\"preface-letter-header\"><h3>TENTANG</h3><h3>PROMOSI KARYAWAN (ACTING)</h3></div></div><div \nclass=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di lingkungan perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentuknya unit usaha baru.\n</li><li>\nAdanya peningkatan mutu dan kompetensi yang berkait dengan jenjang karir karyawan, sehingga dilaksanakan program mutasi jabatan maupun rotasi lokasi kerja dan juga promosi grade karyawan.\n</li><li>Bahwa sebagai kesatuan program tersebut pada butir 2 di atas, perlu dibuatkan suatu Surat Keputusan resmi.\n</li></ol></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi kinerja dalam masa percobaan dan rekomendasi atasan sebagai bagian dalam pengelolaan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PROMOSI</b></div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nNAMA / NIK</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.name }} / {{ vm.item.nik }}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\">\n<div class=\"label-point\"><span class=\"text-label normal\">JABATAN BARU</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.new_position }}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nORG. UNIT</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.original_org_unit }}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div \nclass=\"label-point\"><span class=\"text-label normal\">GRADE BARU</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.new_grade }}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nGRADE DITUJU</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.target_grade }}</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span \nclass=\"text-label normal\">GRADE AKHIR</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div \nclass=\"text-point\">{{ vm.item.final_grade }}</div></div></div><div class=\"letter-content-item\"><div \nclass=\"label-point\"><span class=\"text-label normal\">Kedua</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">Uraian tugas dan tanggung jawab diatur terpisah dalam Job Description.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nKompensasi & Benefit mengacu pada SK Promosi sebelumnya, dengan nominal Promotion Allowance sebagian sudah dilebur kepada komponen gaji lainnya.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Keempat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{ vm.item.effective.date }} – {{ vm.item.end_date }}</div>\n</div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{ vm.item.effective_date }}</div><div class=\"company\">PT. Kaldu Sari Nabati Indonesia</div><div \nclass=\"signature\">{{ vm.item.approved_by }}</div></div></div>");
$templateCache.put("app/main/report/jic/sk-promosi-lulus/sk-promosi-lulus.html","<div class=\"sheet letter-container\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>SURAT KEPUTUSAN</h2>\n<h3>NO : {{ vm.item.id }}/KSNI_HRD/SK-PMS/{{ vm.item.month }}/{{ vm.item.year }}</h3></div><div \nclass=\"preface-letter-header\"><h3>TENTANG</h3><h3>PROMOSI KARYAWAN</h3></div></div><div class=\"letter-content\"><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di lingkungan perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentuknya unit usaha baru.\n</li><li>\nAdanya peningkatan mutu dan kompetensi yang berkait dengan jenjang karir karyawan, sehingga dilaksanakan program mutasi jabatan maupun rotasi lokasi kerja dan juga promosi grade karyawan.\n</li><li>Bahwa sebagai kesatuan program tersebut pada butir 2 di atas, perlu dibuatkan suatu Surat Keputusan resmi.\n</li></ol></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi kinerja dalam masa percobaan dan rekomendasi atasan sebagai bagian dalam pengelolaan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PROMOSI</b></div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nNAMA / NIK</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.name }} / {{ vm.item.nik }}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\">\n<div class=\"label-point\"><span class=\"text-label normal\">JABATAN BARU</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.new_position }}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nORG. UNIT</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.original_org_unit }}</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span \nclass=\"text-label normal\">GRADE BARU</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div \nclass=\"text-point\">{{ vm.item.new_grade }}</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\">\n<span class=\"text-label normal\">Kedua</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div \nclass=\"text-point\">Uraian tugas dan tanggung jawab diatur terpisah dalam Job Description.</div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nPromotion Allowance yang diperoleh saat mulai menjalani masa promosi, dilebur ke Basic Salary, Management Allowance, dan Premi Attendance.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Keempat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{ vm.item.effective.date }} – {{ vm.item.end_date }}</div>\n</div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Kelima</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini bisa ditinjau kembali sewaktu-waktu apabila diperlukan, melalui pertimbangan dan mekanisme yang berlaku.\n</div></div></div><div class=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban berlaku sesuai dengan Surat Keputusan ini.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{ vm.item.effective_date }}</div><div class=\"company\">PT. Kaldu Sari Nabati Indonesia</div><div \nclass=\"signature\">{{ vm.item.approved_by }}</div></div></div>");
$templateCache.put("app/main/report/jic/sk-tetap/sk-tetap.html","<div class=\"sheet letter-container\"><div class=\"letter-header\"><div class=\"top-letter-header\"><h2>SURAT KEPUTUSAN</h2>\n<h3>NO : {{ vm.item.id }}/KSNI_HRD/SK-TTP/{{ vm.item.month }}/{{ vm.item.year }}</h3></div><div \nclass=\"preface-letter-header\"><h3>TENTANG</h3><h3>PENGANGKATAN KARYAWAN TETAP</h3></div></div><div \nclass=\"letter-content\"><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menimbang\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><ol><li>\nPengembangan organisasi yang terjadi di lingkungan perusahaan, baik pada unit usaha yang sudah ada, maupun dengan dibentuknya unit usaha baru.\n</li><li>\nDiperlukannya tenaga kerja yang berkualifikasi sesuai dengan standar dan proses recruitment di lingkungan perusahaan.\n</li><li>Bahwa sebagai kesatuan program tersebut pada butir 2 di atas, perlu dibuatkan suatu Surat Keputusan resmi.\n</li></ol></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Mengingat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nHasil evaluasi kinerja dalam masa percobaan dan rekomendasi atasan sebagai bagian dalam pengelolaan sumber daya manusia di lingkungan perusahaan.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label\">Menetapkan</span>\n</div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"></div></div></div><div \nclass=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Pertama</span></div><div \nclass=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\"><b>PENGANGKATAN KARYAWAN TETAP</b><br>\nPT. Kaldu Sari Nabati Indonesia</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div \nclass=\"label-point\"><span class=\"text-label normal\">NAMA / NIK</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.name }} / {{ vm.item.nik }}</div></div></div><div \nclass=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div class=\"label-point\"><span class=\"text-label normal\">\nJABATAN</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\n{{ vm.item.position }}</div></div></div><div class=\"letter-content-item\" style=\"padding: 0px 10px 0px\"><div \nclass=\"label-point\"><span class=\"text-label normal\">GRADE</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.grade }}</div></div></div><div class=\"letter-content-item\">\n<div class=\"label-point\"><span class=\"text-label normal\">LOKASI</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">{{ vm.item.location }}</div></div></div><div class=\"letter-content-item\">\n<div class=\"label-point\"><span class=\"text-label normal\">Kedua</span></div><div class=\"spacer\">:</div><div \nclass=\"content-point\"><div class=\"text-point\">Uraian tugas dan tanggung jawab diatur terpisah dalam Job Description.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Ketiga\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nPromotion Allowance yang diperoleh saat mulai menjalani masa promosi, dilebur ke Basic Salary, Management Allowance, dan Premi Attendance.\n</div></div></div><div class=\"letter-content-item\"><div class=\"label-point\"><span class=\"text-label normal\">Keempat\n</span></div><div class=\"spacer\">:</div><div class=\"content-point\"><div class=\"text-point\">\nSurat Keputusan ini adalah berlaku efektif sejak tanggal {{ vm.item.effective_date }}</div></div></div><div \nclass=\"letter-content-closing\"><p>\nSesuai dengan posisi pemegang jabatan yang telah ditetapkan dalam Surat Keputusan ini, maka segala hak dan kewajiban termasuk Compensation & Benefit berlaku sesuai dengan Surat Keputusan yang diatur tersendiri.\n</p><p>\nDemikian keputusan ini disampaikan kepada yang bersangkutan untuk diketahui dan dilaksanakan sebagaimana mestinya.</p>\n</div></div><div class=\"letter-footer\"><div class=\"location\">Ditetapkan di Bandung</div><div class=\"date\">\nPada tanggal, {{ vm.item.effective_date }}</div><div class=\"company\">PT. Kaldu Sari Nabati Indonesia</div><div \nclass=\"signature\">{{ vm.item.approved_by }}</div></div></div>");
$templateCache.put("app/main/report/mpp/cost/costreport.html","<div id=\"costReport\"><table ng-repeat=\"item in vm.listReport\" class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><tr><th class=\"title-header-top\">{{ item.description }} <span translate=\"KPI.LABEL.COSTELEMENT\">\n</span></th><td class=\"month-title\">Jan</td><td class=\"month-title\">Feb</td><td class=\"month-title\">Mar</td><td \nclass=\"month-title\">Apr</td><td class=\"month-title\">May</td><td class=\"month-title\">Jun</td><td class=\"month-title\">Jul\n</td><td class=\"month-title\">Aug</td><td class=\"month-title\">Sep</td><td class=\"month-title\">Oct</td><td \nclass=\"month-title\">Nov</td><td class=\"month-title\">Dec</td><td class=\"month-title\">Total</td></tr><tr><th \nclass=\"title-header\"><span translate=\"KPI.LABEL.BEBANGAJIDANUPAH\"></span></th><td class=\"text-right\" \nng-repeat=\"val in item.cost.list\">{{ val.gajiPokok | roundedMoney }}</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">{{ item.cost.gaji_pokok | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.BEBANUPAHHARIAN\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">0</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">0</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.TUNJANGANKARYAWAN\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.tunjangan | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.tunjangan | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span translate=\"KPI.LABEL.THR\"></span>\n</th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.thr | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.thr | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\"><span translate=\"KPI.LABEL.BONUS\"></span></th><td class=\"text-right\" \nng-repeat=\"val in item.cost.list\">{{ val.bonus | roundedMoney }}</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">{{ item.cost.bonus | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.OT\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.lembur | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.lembur | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.PESANGONKARYAWAN\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">0</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">0</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.TUNJANGANLAINNYA\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.tunjanganLain | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.tunjangan_lain | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.BEBANPENGOBATAN\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.bpjsKesehatan | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.bpjs_kesehatan | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.BEBANJAMSOSTEK\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.jamsostek | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.jamsostek | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span \ntranslate=\"KPI.LABEL.TUNJANGANKENDARAAN\"></span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">\n{{ val.tunjanganCop | roundedMoney }}</td><td class=\"title-header-right\" style=\"font-weight: bold\">\n{{ item.cost.tunjangan_cop | roundedMoney }}</td></tr><tr><th class=\"title-header\"><span translate=\"KPI.LABEL.PAJAK\">\n</span></th><td class=\"text-right\" ng-repeat=\"val in item.cost.list\">{{ val.pajak | roundedMoney }}</td><td \nclass=\"title-header-right\" style=\"font-weight: bold\">{{ item.cost.pajak | roundedMoney }}</td></tr><tr><th \nclass=\"title-header\"><span translate=\"KPI.LABEL.TOTAL\"></span></th><td class=\"text-right\" style=\"font-weight: bold\" \nng-repeat=\"val in item.cost.list\">{{ val.totalCost | roundedMoney }}</td><td class=\"title-header-right\" \nstyle=\"font-weight: bold\">{{ item.cost.totalCost | roundedMoney }}</td></tr></table></div>");
$templateCache.put("app/main/report/mpp/headcount/hc.html","<div id=\"tableMpp\"><div layout=\"row\" layout-align=\"start center\" class=\"top-logo-place\"><img \nsrc=\"assets/images/logos/new_logo.png\"><div layout=\"column\"><div class=\"logo-name\">Nabati</div><span class=\"title\">\nMan Power Planning Headcount Report</span></div></div><table class=\"simple bordered stripped\" cellpadding=\"0\" \nms-responsive-table><thead><tr><th rowspan=\"2\">No</th><th rowspan=\"2\">BT Code</th><th rowspan=\"2\">Level</th><th \nstyle=\"width: 20%\" rowspan=\"2\">Jabatan</th><th style=\"width: 5%\" rowspan=\"2\">Jumlah Karyawan Saat Ini</th><th \nstyle=\"width: 5%\" rowspan=\"2\">Jumlah Karyawan yang akan datang</th><th colspan=\"2\">Karyawan</th><th colspan=\"2\">\nKaryawan</th><th colspan=\"12\">Jadwal Pemenuhan</th><th rowspan=\"2\">Total</th></tr><tr><th style=\"width: 5%\">Internal\n</th><th style=\"width: 5%\">External</th><th style=\"width: 5%\">Mutasi</th><th style=\"width: 5%\">Terminasi</th><th>Jan\n</th><th>Feb</th><th>Mar</th><th>Apr</th><th>Mei</th><th>Jun</th><th>Jul</th><th>Aug</th><th>Sep</th><th>Oct</th><th>\nNov</th><th>Des</th></tr></thead><tbody><tr ng-repeat=\"item in vm.listReport\"><td>{{$index + 1}}</td><td>\n{{ item.bt_code }}</td><td>{{ item.job_level }}</td><td>{{item.description}}</td><td>{{ item.curr.total }}</td><td>\n{{ item.next.total }}</td><td>{{ item.next.internal }}</td><td>{{ item.next.external }}</td><td>\n{{ item.next.mutation }}</td><td>{{ item.next.termination }}</td><td \nng-repeat=\"i in item.next.listPerMonth track by $index\">{{ i }}</td><td>{{ vm.getTotalRight(item) }}</td></tr><tr \nng-if=\"vm.listReport.length > 0\"><td class=\"total-hc\" colspan=\"4\">TOTAL</td><td>{{ vm.totalCurrEmp }}</td><td>\n{{ vm.totalNextEmp }}</td><td>{{ vm.totalNextEmpInternal }}</td><td>{{ vm.totalNextEmpExternal }}</td><td>\n{{ vm.totalNextEmpMutation }}</td><td>{{ vm.totalNextEmpTermination }}</td><td \nng-repeat=\"j in vm.totalPerMonth track by $index\">{{ j }}</td><td>{{ vm.totalRightBottom }}</td></tr></tbody></table>\n</div>");
$templateCache.put("app/main/ta/echeckin-list/details/Otherdocument-detail.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\nOther Document - {{vm.name}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div class=\"white-bg md-whiteframe-1dp\"><table \nclass=\"simple\" ms-responsive-table><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Tipe Dokumen</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">No Dokumen</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Masa Berlaku</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Keterangan</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">View</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listData\"><td>{{ ($index + 1)}}\n</td><td>{{ div.typename}}</td><td>{{ div.documentNo}}</td><td>{{ div.expired_date}}</td><td>{{ div.description}}</td>\n<td><md-button class=\"md-icon-button launch\" ng-click=\"vm.viewDokumen($event,div.link)\" title=\"View Dokumen\" \naria-label=\"view dokumen\"><md-icon class=\"icon-eye\"></md-icon></md-button></td></tr></tbody></table></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/bank-detail.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\n<span translate=\"KPI.LABEL.BANKDETAIL\"></span> - {{vm.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div class=\"white-bg\" \nstyle=\"margin-top:30px; min-width: 500px\"><form name=\"bankForm\" class=\"md-inline-form\" novalidate><md-input-container \nclass=\"md-block\"><label><span translate=\"MYPROFILE.MENU.BANK\"></span></label><input \nng-model=\"vm.Form.objForm.bankName\" readonly=\"readonly\"></md-input-container><md-input-container md-no-float \nclass=\"md-block\"><label><span translate=\"PAYROLL.MENU.CABANG\"></span></label><input \nng-model=\"vm.Form.objForm.branchName\" readonly=\"readonly\"></md-input-container><md-input-container md-no-float \nclass=\"md-block\"><label><span translate=\"KPI.LABEL.ACCOUNTNUMBER\"></span></label><input \nng-model=\"vm.Form.objForm.accountNumber\" readonly=\"readonly\"></md-input-container><md-input-container \nng-if=\"vm.stateview\" style=\"width: 100%\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\"><span translate=\"KPI,LABEL.DOWNLOADTHISIMAGE\"></span></md-tooltip></md-button><iframe \nsrc=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-input-container></form>\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/certificate-detail.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\nCertificate Detail - {{vm.name}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content>\n<md-dialog-content ng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><img \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/empdocument/{{vm.ijazah}}\">\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/dependent-detail.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\n<span translate=\"KPI.LABEL.DEPENDENTDETAIL\"></span> - {{vm.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-toolbar \nmd-theme=\"table-toolbar-theme\" class=\"md-white-bg\"><div class=\"md-toolbar-tools\" ng-if=\"vm.status == \'Menikah\'\">\n<md-button ng-click=\"vm.viewDokumen($event)\" class=\"md-button md-ink-ripple {{vm.doc?\'md-accent\':\'md-warn\'}} md-mini\" \nhide show-gt-sm type=\"button\" aria-label=\"Upload\" ng-click=\"vm.uploadKK($event)\"><md-icon \nmd-font-icon=\"icon-border-color {{vm.doc?\'icon-check\':\'icon-close\'}}\"></md-icon>{{vm.doc?\'KK Uploaded\':\'KK not found\'}}\n</md-button></div></md-toolbar><div class=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.NO\"></span></span></div></th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"MYPROFILE.MENU.FAMILITYPE\">Type Of Family</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"KPI.LABEL.FIRSTNAME\">First Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"KPI.LABEL.LASTNAME\">Last Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"MYPROFILE.MENU.PLACEOFBIRTH\">Birth Place</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"MYPROFILE.MENU.DATEOFBIRTH\">Date Of Birth</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"MYPROFILE.MENU.GENDER\">\nGender</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listData\"><td>{{ ($index + 1)}}</td><td>\n{{ div.type_of_family}}</td><td>{{ div.first_name}}</td><td>{{ div.last_name}}</td><td>{{ div.birth_place}}</td><td>\n{{ div.date_of_birth}}</td><td translate=\"EMP.FORM.PROFILE.{{div.gender}}\">{{ div.gender}}</td></tr></tbody></table>\n<md-input-container ng-if=\"vm.stateview\" style=\"width: 100%\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"KPI,LABEL.DOWNLOADTHISIMAGE\"></span></md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-input-container></div><div \nclass=\"white-bg\" style=\"margin-top:30px; min-width: 500px\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/education-detail.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\n<span translate=\"KPI.LABEL.EDUCATIONDETAIL\"></span> - {{vm.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-toolbar \nmd-theme=\"table-toolbar-theme\" class=\"md-white-bg\"><div class=\"md-toolbar-tools\"><md-button \nng-click=\"vm.viewDokumen($event, vm.ijazah)\" \nclass=\"md-button md-ink-ripple {{vm.ijazah?\'md-accent\':\'md-warn\'}} md-mini\" hide show-gt-sm ng-readonly=\"true\" \ntype=\"button\" aria-label=\"Inert\"><md-icon md-font-icon=\"icon-border-color {{vm.ijazah?\'icon-check\':\'icon-close\'}}\">\n</md-icon>{{vm.ijazah?\'Ijazah Uploaded\':\'Ijazah not found\'}}</md-button></div></md-toolbar><div \nclass=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></div>\n</th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.SCHOLLNAME\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"MYPROFILE.MENU.MAJORS\"></span></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.LEVELEDUCATION\"></span></span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.TITLE\">\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.CERTIFICATES\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"MYPROFILE.MENU.YEARENTRY\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.GRAYEAR\">\n</span></span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listData\"><td>{{ ($index + 1)}}</td><td>\n{{ div.school_name}}</td><td>{{ div.majority}}</td><td>{{ div.final_grade}}</td><td>{{ div.title}}</td><td><span \nng-if=\"div.certificate\"><span translate=\"KPI.LABEL.THEREISACERTIFICATE\"></span></span> <span ng-if=\"!div.certificate\">\n<span translate=\"KPI.LABEL.NOCERTIFICATE\"></span></span></td><td>{{ div.start_study}}</td><td>{{ div.finish_study}}\n</td></tr></tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/emergency-detail.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\n<span translate=\"KPI.LABEL.EMERGENCYDETAIL\"></span> - {{vm.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nclass=\"white-bg md-whiteframe-1dp\" style=\"min-width: 500px\"><table class=\"simple\" ms-responsive-table><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"KPI.LABEL.NAME\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"MYPROFILE.MENU.ADDRESS\">Address</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"MYPROFILE.MENU.PHONENUMBER\">Phone Number</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"MYPROFILE.MENU.FAMILITYPE\">Type Of Family</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"div in vm.listData\"><td>{{ div.first_name}} {{ div.last_name}}</td><td>\n{{ div.address}}</td><td>{{ div.phone_number}}</td><td>{{ div.type_of_family}}</td></tr></tbody></table></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/experience-detail.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\n<span translate=\"KPI.LABEL.EXPERIENCEDETAIL\"></span> - {{vm.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nclass=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></div>\n</th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"MYPROFILE.MENU.COMPANYNAME\">Company Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"KPI.LABEL.DEPARTMENT\">Department Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"MYPROFILE.MENU.SECTIONNAME\">\nSection Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ONBOARDING.JOBDES\">Job Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"KPI.LABEL.STARTDATE\">Start</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"KPI.LABEL.ENDDATE\">Finish</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"div in vm.listData\"><td>{{ ($index + 1)}}</td><td>{{ div.company_name}}</td><td>\n{{ div.department_name}}</td><td>{{ div.section_name}}</td><td>{{ div.job_description}}</td><td>{{ div.start_date}}\n</td><td>{{ div.finish_date}}</td></tr></tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/language-detail.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\n<span translate=\"KPI.LABEL.LANGUAGEDETAIL\"></span> - {{vm.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nclass=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></div>\n</th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.LANGUAGE\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\"><span translate=\"KPI.LABEL.LEVEL\"></span></span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listData\"><td>{{ ($index + 1)}}</td><td>{{ div.language_code}}</td><td>{{ div.level}}</td></tr>\n</tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/tax-detail.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\nTax Detail - {{vm.name}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><div class=\"white-bg\" style=\"min-width: 500px\"><form name=\"taxForm\" \nclass=\"md-inline-form\" novalidate><div class=\"form-title\">Pajak</div><md-input-container style=\"margin-bottom: 20px\" \nflex><md-radio-group ng-model=\"vm.optionNpwp\" name=\"optionNpwp\" disabled=\"disabled\"><md-radio-button value=\"1\" \nclass=\"md-primary md-raised\">Punya NPWP</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"0\" \nclass=\"md-warn md-raised\">Tidak Punya NPWP</md-radio-button>&nbsp;&nbsp;</md-radio-group></md-input-container>\n<md-input-container ng-if=\"vm.optionNpwp==\'1\'\" class=\"md-block\"><label>No Pajak</label><input \nng-model=\"vm.Form.objForm.taxNumber\" name=\"taxNumber\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Status Pajak</label><input ng-model=\"vm.Form.objForm.taxStatus\" name=\"taxStatus\" \nreadonly=\"readonly\"></md-input-container><md-input-container ng-if=\"vm.optionNpwp == 1 && vm.stateview\" \nstyle=\"width: 100%\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" \nframeborder=\"0\"></iframe></md-input-container></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/training-detail.html","<md-dialog aria-label=\"Form Update Finger Data\"><md-toolbar class=\"md-green-600-bg\"><div class=\"md-toolbar-tools\"><h2>\n<span translate=\"KPI.LABEL.TRAININGDETAIL\"></span> - {{vm.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div \nclass=\"white-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\"></span></span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.TRAININGTYPE\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"MYPROFILE.MENU.CERTIFICATION\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.SPECIFICATION\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"KPI.LABEL.STARTDATE\"></span></span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.ENDDATE\"></span></span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"div in vm.listData\"><td>{{ ($index + 1)}}</td><td>{{ div.type_of_training}}</td><td><span\n ng-if=\"div.is_certificate==1\"><span translate=\"KPI.LABEL.CERTIFICATED\"></span></span><span \nng-if=\"div.is_certificate==0\"><span translate=\"KPI.LABEL.NOTCERTIFICATED\"></span></span></td><td>\n{{ div.specification_of_training}}</td><td>{{ div.start_date}}</td><td>{{ div.finish_date}}</td></tr></tbody></table>\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/view-document.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View Document</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/view-jamsostek.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View JAMSOSTEK</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/view-ktp.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View KTP</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/view-npwp.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View NPWP</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/ta/echeckin-list/details/view-photo.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View Photo</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/ta/passwordecheckin/input-password-echeckin/input-password-echeckin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Form Password Echeckin</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"80\" flex-sm=\"90\" \nflex-xs=\"100\" flex-md=\"80\"><form name=\"formInputProfiles\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputProfiles)\"><div layout-gt-sm=\"row\"></div><div layout-gt-sm=\"row\"><md-input-container \nflex><label>Title</label><md-select ng-model=\"vm.Form.objForm.title\" required><md-option ng-repeat=\"t in vm.title\" \nng-value=\"t\">{{t}}</md-option></md-select><div ng-messages=\"formInputProfiles.title.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Title is required.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"fullname\" ng-model=\"vm.fullname\" placeholder=\"Nama Lengkap\" required md-maxlength=\"200\"><div \nng-messages=\"profilForm.fullname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Nama Lengkap harus di isi.\n</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 200 huruf.</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>No KTP</label><input type=\"text\" \nname=\"noktp\" ng-model=\"vm.Form.objForm.noktp\" ng-pattern=\"/[\\u0030-\\u0039]+/g\" md-maxlength=\"16\" minlength=\"16\"><div \nng-messages=\"formInputProfiles.noktp.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Input hanya angka!.</span>\n</div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 16 huruf!.</span></div><div ng-message=\"minlength\">\n<span>Tidak boleh kurang dari 16 huruf!.</span></div></div></md-input-container><md-input-container flex><label>\nJenis Kelamin</label><md-select ng-model=\"vm.Form.objForm.jenkel\" required><md-option ng-repeat=\"g in vm.jenkel\" \nng-value=\"g\">{{g}}</md-option></md-select><div ng-messages=\"formInputProfiles.jenkel.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Gender is required.</span></div></div></md-input-container><md-input-container \nng-if=\"vm.stat\" flex><label>Password</label><input ng-model=\"vm.Form.objForm.password\"></md-input-container></div>\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"formInputProfiles.$invalid || basicForm.$pristine\">Submit</md-button></div></form></div></md-content>\n</div></div></md-content></div>");
$templateCache.put("app/main/jic/empjic/add/empjic-add.html","<div id=\"empjicAddPage\" class=\"page-layout simple fullwidth carded md-padding with-toolbar-content white-bg\">\n<md-content id=\"jicFormContent\" class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-progress-linear \nng-if=\"vm.isSubmit\" style=\"top: 0px; left: 0px; position: fixed\" flex md-mode=\"indeterminate\"></md-progress-linear>\n<md-subheader class=\"white-bg\">Form Pengajuan Promosi / Transfer / Demosi</md-subheader><form \nname=\"frmJicAddPengajuan\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,frmJicAddPengajuan)\">\n<md-list><md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Diajukan Untuk</b></div>\n<div flex=\"75\" class=\"list-item-jic\"><div layout=\"row\" flex><md-checkbox flex=\"20\" ng-model=\"item.checked\" \nng-repeat=\"item in vm.actionLists\" ng-change=\"vm.setAction($event, $index)\" class=\"padding-right-30\">{{ item.name }}\n</md-checkbox></div></div></md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" \nclass=\"grey-200-bg list-item-jic grey-200-bg\"><b>Nama</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" \nclass=\"list-item-jic\"><span>{{vm.selectedEmployee.fullname}}</span>&nbsp; <a \nstyle=\"cursor: pointer; font-style: inherit; color: #0f82b4\"><i class=\"icon icon-account-search blue-600-fg\" \nng-click=\"vm.lookupStafEmployee($event)\"></i></a> <input type=\"hidden\" ng-model=\"vm.selectedEmployee.nik\" required>\n</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>NIK</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.nik}}</div></md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Masa Kerja</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.masa_kerja}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Status</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.status_kerja}}</div></md-list-item><md-list-item layout=\"row\" \nflex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Diajukan Tanggal</b></div><div flex=\"75\" \nclass=\"list-item-jic\"><span>{{vm.tgl_pengajuan | date:\'dd/MM/yyyy\'}}</span></div></md-list-item><md-list-item \nlayout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Business Unit</b></div><div flex=\"25\" \nclass=\"list-item-jic\">{{vm.selectedEmployee.entity_id}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>\nBusiness Unit Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" class=\"list-item-jic\"><md-select \nng-model=\"vm.Form.objForm.bu\" name=\"bu\" ng-disabled=\"!vm.isMutation\" \nng-change=\"vm.loadSubAreaData(vm.Form.objForm.bu);vm.loadDataDivision(vm.Form.objForm.bu);vm.selectedCange(\'comp\')\">\n<md-option ng-repeat=\"item in vm.buLists\" ng-value=\"item.id\">{{item.description}}</md-option></md-select></div>\n</md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Divisi</b></div><div\n flex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.division}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Divisi Baru</b></div><div flex=\"25\" class=\"list-item-jic\"><md-select \nng-model=\"vm.Form.objForm.division_id\" \nng-change=\"vm.loadDataDepartment(vm.Form.objForm.division_id,true);vm.selectedCange(\'div\')\" name=\"division_id\" \nng-disabled=\"!vm.isMutation\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" ng-if=\"ls.id!==\'all\'\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></div></md-list-item><md-list-item layout=\"row\" flex><div \nflex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Department</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.department}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Department Baru</b></div>\n<div flex=\"25\" class=\"list-item-jic\"><md-select ng-model=\"vm.Form.objForm.department_baru_id\" name=\"department\" \nng-change=\"vm.loadLayerData();vm.selectedCange(\'dept\')\" ng-disabled=\"!vm.isMutation\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" ng-if=\"ls.id!==\'all\'\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select></div></md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Atasan</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.nik_atasan}}-{{vm.selectedEmployee.nama_atasan}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Atasan Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" \nclass=\"list-item-jic\">{{vm.selectedEmployee.nik_atasan_baru}}-{{vm.selectedEmployee.nama_atasan_baru}} <a \nstyle=\"cursor: pointer; font-style: inherit; color: #0f82b4;float: right\"><i \nclass=\"icon icon-account-search blue-600-fg\" ng-click=\"vm.lookupEmployee($event)\"></i></a></div></md-list-item>\n<md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Jabatan</b></div><div flex=\"25\" \nclass=\"list-item-jic\">{{vm.selectedEmployee.jabatan_lama}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>\nJabatan Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.Form.objForm.job_title.jobTitleName}} <a \nstyle=\"cursor: pointer; font-style: inherit; color: #0f82b4;float: right\" flex=\"10\"><i \nclass=\"icon icon-account-search blue-600-fg\" ng-click=\"vm.lookupJobTitle($event)\"></i></a></div></md-list-item>\n<md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Pangkat-Gol</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.emp_grade}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Pangkat-Gol Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" \nclass=\"list-item-jic\"><md-select \nng-if=\"(vm.isMutation && (vm.allowJabatanBaru == true || vm.allowGolonganBaru == true)) || (vm.allowJabatanBaru == true || vm.allowGolonganBaru == true)\" \nng-model=\"vm.Form.objForm.gol_baru\" name=\"gol_baru\"><md-option ng-repeat=\"item in vm.grades\" ng-value=\"item\">{{item}}\n</md-option></md-select><span ng-if=\"vm.isMutation && (vm.allowJabatanBaru == false && vm.allowGolonganBaru == false)\">\n{{vm.selectedEmployee.emp_grade}}</span> <input type=\"hidden\" ng-model=\"vm.Form.objForm.gol_baru\" required></div>\n</md-list-item><md-list-item layout=\"row\"><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Lokasi Kerja</b></div>\n<div flex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.emp_subarea}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Lokasi Kerja Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" \nclass=\"list-item-jic\">{{(!vm.isMutation)?vm.selectedEmployee.emp_subarea:\'\'}}<md-select ng-show=\"vm.isMutation\" \nng-required=\"vm.isMutation\" aria-label=\"Lokasi Kerja Baru\" name=\"field\" ng-model=\"vm.selectedSubArea\" \ndata-md-container-class=\"selectdemoSelectHeader\" md-on-close=\"vm.clearSearchSubAreaTerm()\"><md-select-header \nlayout=\"column\" class=\"demo-select-header\"><md-input-container><input ng-click=\"vm.searchSubAreaClicked($event)\" \nng-model=\"vm.searchSubAreaTerm\" type=\"search\" ng-model-options=\"{debounce: {\'default\': 200, \'blur\': 0}}\" \nplaceholder=\"Lokasi Kerja Baru\" class=\"demo-header-searchbox md-text\"></md-input-container></md-select-header>\n<md-optgroup label=\"Lokasi Lerja Baru\"><md-option ng-value=\"suba\" \nng-repeat=\"suba in vm.subAreaLists | filter:vm.searchSubAreaTerm\">{{suba.description}}</md-option></md-optgroup>\n</md-select></div></md-list-item><div style=\"margin-top: 20px\"></div><md-list-item layout=\"row\"><div flex=\"50\" \nclass=\"list-item-jic grey-200-bg\" style=\"margin-right: 5px\"><b>Alasan Pengajuan</b><span class=\"red-700-fg\">*</span>\n</div><div flex=\"50\" class=\"list-item-jic\"></div></md-list-item><md-list-item layout=\"row\"><div flex=\"50\" \nclass=\"list-item-jic\"><md-checkbox ng-model=\"item.checked\" flex ng-repeat=\"item in vm.reasonsLists\" \nng-click=\"vm.setSelectedReasons(item)\" ng-change=\"vm.setSelectedReasons(item)\" \nstyle=\"margin-top: 0px; margin-bottom: 10px; display: block\">{{ item.name }} <a ng-if=\"item.isAdditional\" \nhref=\"javascript:void(0);\" ng-click=\"vm.removeAdditionalReason($index, item)\" class=\"color-danger\"><i \nclass=\"icon-close\" style=\"font-size: small\"></i></a></md-checkbox><md-input-container md-no-float class=\"md-block\">\n<input ng-model=\"vm.additionalReason\" type=\"text\" placeholder=\"Add new reason...\" flex=\"90\" style=\"float: left\">\n<md-button flex=\"10\" style=\"float: right; display: contents\" ng-click=\"vm.addNewReason(vm.additionalReason)\"><i \nclass=\"icon-plus\"></i></md-button></md-input-container><fieldset ng-if=\"vm.alasanPergantianKaryawan\" class=\"mt-10\">\n<legend>Informasi Keluar/Mutasi/Promosi:</legend><table class=\"table\"><tr><td style=\"width: 120px\">Employee <span \nclass=\"red-700-fg\">*</span></td><td>:</td><td><md-autocomplete id=\"inputReasonEmployee\" \nmd-selected-item=\"vm.selectedReasonEmployee\" md-selected-item-change=\"vm.selectedIReasonEmployeeChanged(item)\" \nmd-require-match md-search-text=\"vm.searchReasonEmployeeText\" md-input-name=\"job_title\" md-no-cache=\"true\" \nmd-items=\"item in vm.queryReasonEmployeeSearch(vm.searchReasonEmployeeText)\" \nmd-item-text=\"item.nik + \' / \' + item.fullname\" md-min-length=\"3\" aria-label=\"Employee\" placeholder=\"... ... ...\" \nrequired><md-item-template><span md-highlight-text=\"vm.searchReasonEmployeeText\">{{item.nik + \' / \' + item.fullname}}\n</span></md-item-template><md-not-found>No Record matching \"{{vm.searchReasonEmployeeText}}\" were found.</md-not-found>\n</md-autocomplete></td></tr><tr><td>Position</td><td>:</td><td>{{vm.reasonsEmployeeChanges.position.description}}</td>\n</tr><tr><td>Reasons <span class=\"red-700-fg\">*</span></td><td>:</td><td><input type=\"text\" \nng-model=\"vm.reasonsEmployeeChanges.reason\" placeholder=\"... ... ...\" aria-label=\"Reasons\" style=\"font-size: 14px\" \nrequired></td></tr><tr><td>Effective Date <span class=\"red-700-fg\">*</span></td><td>:</td><td><md-datepicker \nng-model=\"vm.reasonsEmployeeChanges.effective_date\" md-hide-icons=\"all\" md-open-on-focus aria-label=\"Effective Date\" \nrequired></md-datepicker></td></tr></table></fieldset></div><div flex=\"50\" class=\"list-item-jic\" \nlayout-align=\"start start\" style=\"padding-left: 0px\"></div></md-list-item><div \nstyle=\"border-bottom: 0.5px solid #ebebeb; margin-bottom: 5px\"></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"end start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-md=\"column\" layout-align=\"end center\" flex class=\"padding-right-10\"><md-button type=\"button\" \nng-click=\"vm.reloadToken()\" class=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\" ng-disabled=\"vm.isSubmit\">\nReload Token</md-button><md-button type=\"submit\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"vm.isSubmit || !vm.isReasonsInformationCompleted() || !vm.checkValidasiForm()\">Submit</md-button>\n<md-button type=\"button\" ui-sref=\"app.emp_jic\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Reload\" \nng-disabled=\"vm.isSubmit\">Back</md-button></div></md-list></form></md-content></div>");
$templateCache.put("app/main/jic/empjic/delegasi/delegasi.html","<md-dialog id=\"empjicDelegasiPage\" aria-label=\"Delegasi\" flex=\"50\"><form name=\"frmDelegasi\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.saveData($event, frmDelegasi)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Delegasi</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-progress-linear ng-if=\"vm.isSubmit\" style=\"top: 45px; left: 0px; position: fixed; z-index: 9\" \nflex md-mode=\"indeterminate\"></md-progress-linear><div layout=\"row\" class=\"ng-scope layout-row\"><div flex-gt-sm=\"100\" \nflex=\"100\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-list flex><md-list-item layout=\"row\" \nclass=\"jic-add-list-item-employee\" style=\"border-bottom: 1px solid #ccc\"><div flex=\"30\"><b>Approval Type</b></div><div \nflex=\"35\"><b>Current</b></div><div flex=\"35\"><b>Switch To</b></div></md-list-item><md-list-item \nng-if=\"item.type != \'mengajukan\'\" layout=\"row\" style=\"margin-top: 10px\" class=\"jic-add-list-item-employee\" \nng-repeat=\"item in vm.approvalLists\"><div flex=\"30\"><span style=\"text-transform: uppercase\">{{item.type}}</span></div>\n<div flex=\"35\">{{item.fullname}}</div><div flex=\"35\"><div ng-if=\"item.status > 0\">Has been processed</div>\n<md-autocomplete ng-if=\"item.status == 0\" class=\"autocomplete-delegasi\" md-selected-item=\"item.selected\" \nmd-selected-item-change=\"vm.selectedItem(list, item)\" md-require-match md-search-text=\"item.search\" \nmd-input-name=\"list.selectedNik\" md-no-cache=\"true\" md-items=\"list in vm.querySearch(item.search)\" \nmd-item-text=\"list.fullname\" required md-min-length=\"3\"><md-item-template><span md-highlight-text=\"item.fullname\">\n{{list.fullname}}</span></md-item-template><md-not-found>No Record matching \"{{item.search}}\" were found.\n</md-not-found></md-autocomplete></div></md-list-item></md-list></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" class=\"md-teal-500-bg md-raised white-fg\" \nng-disabled=\"vm.isSubmit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jic/empjic/edit/empjic-edit.html","<div id=\"empjicEditPage\" class=\"page-layout simple fullwidth carded md-padding with-toolbar-content white-bg\">\n<md-content id=\"jicFormContent\" class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\">\n<b>Detail Pengajuan Promosi / Mutasi / Demosi</b><div style=\"float: right; font-weight: bold\" class=\"orange-500-fg\" \nng-if=\"vm.selectedEmployee.approval_status == 0\">Waiting</div><div style=\"float: right; font-weight: bold\" \nclass=\"green-500-fg\" ng-if=\"vm.selectedEmployee.approval_status == 1\">Approved</div><div \nstyle=\"float: right; font-weight: bold\" class=\"red-500-fg\" ng-if=\"vm.selectedEmployee.approval_status == 2\">Rejected\n</div></md-subheader><form name=\"frmJicEditPengajuan\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData($event,frmJicEditPengajuan)\"><md-list><md-list-item layout=\"row\" flex><div flex=\"25\" \nclass=\"grey-200-bg list-item-jic grey-200-bg\"><b>Nama</b></div><div flex=\"25\" class=\"list-item-jic\"><span>\n{{vm.selectedEmployee.fullname}}</span></div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>NIK</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.nik}}</div></md-list-item><md-list-item layout=\"row\" flex><div \nflex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Masa Kerja</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.masa_kerja}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Status</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.status_kerja}}</div></md-list-item><md-list-item layout=\"row\" \nflex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Diajukan Untuk</b></div><div flex=\"75\" class=\"list-item-jic\">\n<div layout=\"row\" flex><md-checkbox flex=\"20\" ng-model=\"item.checked\" \nng-repeat=\"item in vm.actionsLists track by $index\" ng-click=\"vm.setAction($event, $index)\" \nng-change=\"vm.setAction($event, $index)\" class=\"padding-right-30\">{{ item.name }}</md-checkbox></div></div>\n</md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Diajukan Tanggal</b>\n</div><div flex=\"75\" class=\"list-item-jic\"><span>{{vm.selectedEmployee.tgl_pengajuan.substr(0,10) | date:\'dd/MM/yyyy\'}}\n</span></div></md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>\nJabatan Lama</b></div><div flex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.jabatan_lama}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Jabatan Baru</b></div><div flex=\"25\" class=\"list-item-jic\"><md-autocomplete \nid=\"inputJobTitle\" md-selected-item=\"vm.selectedJobTitle\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-require-match md-search-text=\"vm.searchText\" md-input-name=\"job_title\" md-no-cache=\"true\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.description\" md-min-length=\"3\"><md-item-template>\n<span md-highlight-text=\"vm.searchText\">{{item.description}}</span></md-item-template><md-not-found>\nNo Record matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></div></md-list-item><md-list-item \nlayout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Pangkat-Gol Lama</b></div><div flex=\"25\" \nclass=\"list-item-jic\">{{vm.selectedEmployee.grade_lama}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>\nPangkat-Gol Baru</b></div><div flex=\"25\" class=\"list-item-jic\"><md-select \nng-if=\"(vm.isMutation == 1 && (vm.allowJabatanBaru == true || vm.allowGolonganBaru == true)) || (vm.allowJabatanBaru == true || vm.allowGolonganBaru == true)\" \nng-model=\"vm.Form.objForm.gol_baru\" name=\"gol_baru\"><md-option ng-repeat=\"item in vm.grades\" \nng-selected=\"vm.selectedGradeBaru == item\" ng-value=\"item\">{{item}}</md-option></md-select><span \nng-if=\"vm.isMutation == 1 && (vm.allowJabatanBaru == false && vm.allowGolonganBaru == false)\">\n{{vm.selectedEmployee.emp_grade}}</span></div></md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Divisi/Dept./Section</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.department}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Divisi/Dept./Section</b>\n</div><div flex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.department_name_baru}}</div></md-list-item>\n<md-list-item layout=\"row\"><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Lokasi Lerja Lama</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.emp_subarea}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Lokasi Lerja Baru</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{(!vm.isMutation)?vm.selectedEmployee.emp_subarea:\'\'}}<md-select ng-if=\"vm.isMutation\" \nng-model=\"vm.Form.objForm.subarea_baru_id\" placeholder=\"Lokasi Kerja baru\"><md-option ng-value=\"suba.subarea_id\" \nng-repeat=\"suba in vm.subAreaLists\">{{suba.description}}</md-option></md-select></div></md-list-item><div \nstyle=\"margin-top: 20px\"></div><md-list-item layout=\"row\"><div flex=\"50\" class=\"list-item-jic grey-200-bg\" \nstyle=\"margin-right: 5px\"><b>Alasan Pengajuan</b></div><div flex=\"50\" class=\"list-item-jic\"></div></md-list-item>\n<md-list-item layout=\"row\" layout-align=\"start start\"><div flex=\"50\" class=\"list-item-jic\" layout-align=\"start start\">\n<md-checkbox ng-model=\"item.checked\" flex ng-repeat=\"item in vm.reasonsLists track by $index\" \nng-click=\"vm.setSelectedReasons(item)\" ng-change=\"vm.setSelectedReasons(item)\" \nstyle=\"margin-top: 0px; margin-bottom: 10px; display: block\">{{ item.name }} <a ng-if=\"item.isAdditional\" \nhref=\"javascript:void(0);\" ng-click=\"vm.removeAdditionalReason($index, item)\" class=\"color-danger\"><i \nclass=\"icon-close\" style=\"font-size: small\"></i></a></md-checkbox><md-input-container md-no-float class=\"md-block\">\n<input ng-model=\"vm.additionalReason\" type=\"text\" placeholder=\"Add new reason...\" flex=\"90\" style=\"float: left\">\n<md-button flex=\"10\" style=\"float: right; display: contents\" ng-click=\"vm.addNewReason(vm.additionalReason)\"><i \nclass=\"icon-plus\"></i></md-button></md-input-container><fieldset ng-if=\"vm.selectedEmployee.reasonEmpChange\" \nclass=\"mt-10\"><legend>Informasi Keluar/Mutasi/Promosi:</legend><table class=\"table\"><tr><td style=\"width: 120px\">\nEmployee</td><td>:</td><td>{{vm.selectedEmployee.reasonEmpChange[0].fullname}}</td></tr><tr><td>Position</td><td>:</td>\n<td>{{vm.selectedEmployee.reasonEmpChange[0].position_name}}</td></tr><tr><td>Reasons</td><td>:</td><td>\n{{vm.selectedEmployee.reasonEmpChange[0].reasons}}</td></tr><tr><td>Effective Date</td><td>:</td><td>\n{{vm.selectedEmployee.reasonEmpChange[0].effective_date}}</td></tr></table></fieldset></div><div flex=\"50\" \nclass=\"list-item-jic\" style=\"padding-left: 0px\"></div></md-list-item><div \nstyle=\"border-bottom: 0.5px solid #ebebeb; margin-bottom: 5px\"></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"end start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-md=\"column\" layout-align=\"end start\" flex><md-button type=\"submit\" type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmJicEditPengajuan.$invalid || basicForm.$pristine\" ng-if=\"vm.selectedEmployee.approval_status == \'0\'\">\nUPDATE</md-button><md-button type=\"button\" ui-sref=\"app.emp_jic\" class=\"md-blue-grey-300-bg md-raised white-fg\" \naria-label=\"Reload\">BACK</md-button></div></md-list></form></md-content></div>");
$templateCache.put("app/main/jic/empjic/print-sk/print-sk.html","<md-dialog aria-label=\"Print SK\" flex=\"50\"><form ng-cloak name=\"frmPrintSK\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Print SK</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" class=\"ng-scope layout-row\"><div flex-gt-sm=\"100\" \nflex=\"100\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-list flex><md-list-item \nclass=\"md-3-line jic-add-list-item-employee\" style=\"border-bottom: 1px solid #ccc\"><div class=\"md-list-item-text\" \nlayout=\"column\"><b>Employee</b></div><div class=\"md-secondary\"><b>Print</b></div></md-list-item><md-list-item \nclass=\"md-3-line jic-add-list-item-employee\" ng-repeat=\"item in vm.employeeLists\" ng-click=\"vm.selectEmployee(item)\">\n<div class=\"md-list-item-text\" layout=\"column\">{{ item.nik }}, {{item.fullname}}</div><div class=\"md-secondary\">\n<md-button ng-disabled=\"!item.isCompleted\" ng-repeat=\"act in vm.actionsLists\" class=\"md-green-300-bg\" \nng-click=\"vm.printPDF($event, act.module_name, act.already_print, item)\"><div style=\"padding: 5px\"><i \nclass=\"icon icon-printer\"></i></div><div style=\"margin-top: -20px\">{{act.action_name}}</div><div \nstyle=\"font-size: x-small; margin-top: -20px\">{{act.type_name}}</div></md-button></div></md-list-item></md-list></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-teal-500-bg md-raised white-fg\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-refresh white-fg\"></md-icon>Cancel</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/jic/empjic/revisied/empjic-revisied.html","<div id=\"empjicRevisiedPage\" class=\"page-layout simple fullwidth carded md-padding with-toolbar-content white-bg\">\n<md-content id=\"jicFormContent\" class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader class=\"white-bg\">\n<b>Detail Pengajuan Promosi / Mutasi / Demosi</b><div style=\"float: right; font-weight: bold\" class=\"orange-500-fg\" \nng-if=\"vm.selectedEmployee.approval_status == 0\">Waiting</div><div style=\"float: right; font-weight: bold\" \nclass=\"green-500-fg\" ng-if=\"vm.selectedEmployee.approval_status == 1\">Approved</div><div \nstyle=\"float: right; font-weight: bold\" class=\"red-500-fg\" ng-if=\"vm.selectedEmployee.approval_status == 2\">Rejected\n</div></md-subheader><form name=\"frmJicRevisiedPengajuan\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData($event,frmJicRevisiedPengajuan)\"><md-list><md-list-item layout=\"row\" flex><div flex=\"25\" \nclass=\"grey-200-bg list-item-jic grey-200-bg\"><b>Nama</b></div><div flex=\"25\" class=\"list-item-jic\"><span>\n{{vm.selectedEmployee.fullname}}</span></div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>NIK</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.nik}}</div></md-list-item><md-list-item layout=\"row\" flex><div \nflex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Masa Kerja</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.masa_kerja}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Status</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.status_kerja}}</div></md-list-item><md-list-item layout=\"row\" \nflex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Diajukan Untuk</b></div><div flex=\"75\" class=\"list-item-jic\">\n<div layout=\"row\" flex><md-checkbox flex=\"20\" ng-model=\"item.checked\" \nng-repeat=\"item in vm.actionsLists track by $index\" ng-click=\"vm.setAction($event, $index)\" \nng-change=\"vm.setAction($event, $index)\" class=\"padding-right-30\" disabled=\"disabled\">{{ item.name }}</md-checkbox>\n</div></div></md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>\nDiajukan Tanggal</b></div><div flex=\"75\" class=\"list-item-jic\"><span>\n{{vm.selectedEmployee.tgl_pengajuan.substr(0,10) | date:\'dd/MM/yyyy\'}}</span></div></md-list-item><md-list-item \nlayout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Business Unit</b></div><div flex=\"25\" \nclass=\"list-item-jic\">{{vm.selectedEmployee.entity_id}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>\nBusiness Unit Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" class=\"list-item-jic\"><md-select \nng-model=\"vm.Form.objForm.bu\" name=\"bu\" ng-disabled=\"!vm.isMutation\" \nng-change=\"vm.loadSubAreaData(vm.Form.objForm.bu);vm.loadDataDivision(vm.Form.objForm.bu);vm.selectedCange(\'comp\')\">\n<md-option ng-repeat=\"item in vm.buLists\" ng-value=\"item.id\">{{item.description}}</md-option></md-select></div>\n</md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Divisi</b></div><div\n flex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.division}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Divisi Baru</b></div><div flex=\"25\" class=\"list-item-jic\"><md-select \nng-model=\"vm.Form.objForm.division_id\" \nng-change=\"vm.loadDataDepartment(vm.Form.objForm.division_id,true);vm.selectedCange(\'div\')\" name=\"division_id\" \nng-disabled=\"!vm.isMutation\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" ng-if=\"ls.id!==\'all\'\" \nvalue=\"{{ls.id}}\">{{ls.description}}</md-option></md-select></div></md-list-item><md-list-item layout=\"row\" flex><div \nflex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Department</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.department}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Department Baru</b></div>\n<div flex=\"25\" class=\"list-item-jic\"><md-select ng-model=\"vm.Form.objForm.department_baru_id\" name=\"department\" \nng-change=\"vm.loadLayerData();vm.selectedCange(\'dept\')\" ng-disabled=\"!vm.isMutation\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" ng-if=\"ls.id!==\'all\'\" value=\"{{ls.id}}\">{{ls.description}}\n</md-option></md-select></div></md-list-item><md-list-item layout=\"row\" flex><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Atasan</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.nik_atasan}}-{{vm.selectedEmployee.nama_atasan}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Atasan Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" \nclass=\"list-item-jic\">{{vm.selectedEmployee.nik_atasan_baru}}-{{vm.selectedEmployee.nama_atasan_baru}} <a \nstyle=\"cursor: pointer; font-style: inherit; color: #0f82b4;float: right\"><i \nclass=\"icon icon-account-search blue-600-fg\" ng-click=\"vm.lookupEmployee($event)\"></i></a></div></md-list-item>\n<md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Jabatan</b></div><div flex=\"25\" \nclass=\"list-item-jic\">{{vm.selectedEmployee.jabatan_lama}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>\nJabatan Baru</b> <span class=\"red-700-fg\">*</span></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.Form.objForm.job_title.jobTitleName}} <a \nstyle=\"cursor: pointer; font-style: inherit; color: #0f82b4;float: right\" flex=\"10\"><i \nclass=\"icon icon-account-search blue-600-fg\" ng-click=\"vm.lookupJobTitle($event)\"></i></a></div></md-list-item>\n<md-list-item layout=\"row\" flex><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Pangkat-Gol Lama</b></div><div \nflex=\"25\" class=\"list-item-jic\">{{vm.selectedEmployee.grade_lama}}</div><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Pangkat-Gol Baru</b></div><div flex=\"25\" class=\"list-item-jic\"><md-select \nng-if=\"(vm.isMutation == 1 && (vm.allowJabatanBaru == true || vm.allowGolonganBaru == true)) || (vm.allowJabatanBaru == true || vm.allowGolonganBaru == true)\" \nng-model=\"vm.Form.objForm.gol_baru\" name=\"gol_baru\"><md-option ng-repeat=\"item in vm.grades\" \nng-selected=\"vm.selectedGradeBaru == item\" ng-value=\"item\">{{item}}</md-option></md-select><span \nng-if=\"vm.isMutation == 1 && (vm.allowJabatanBaru == false && vm.allowGolonganBaru == false)\">\n{{vm.selectedEmployee.emp_grade}}</span></div></md-list-item><md-list-item layout=\"row\"><div flex=\"25\" \nclass=\"list-item-jic grey-200-bg\"><b>Lokasi Lerja Lama</b></div><div flex=\"25\" class=\"list-item-jic\">\n{{vm.selectedEmployee.emp_subarea}}</div><div flex=\"25\" class=\"list-item-jic grey-200-bg\"><b>Lokasi Lerja Baru</b>\n</div><div flex=\"25\" class=\"list-item-jic\">{{(!vm.isMutation)?vm.selectedEmployee.emp_subarea:\'\'}}<md-select \nng-if=\"vm.isMutation\" ng-model=\"vm.Form.objForm.subarea_baru_id\" placeholder=\"Lokasi Kerja baru\"><md-option \nng-value=\"suba.subarea_id\" ng-repeat=\"suba in vm.subAreaLists\">{{suba.description}}</md-option></md-select></div>\n</md-list-item><div style=\"margin-top: 20px\"></div><md-list-item layout=\"row\"><div flex=\"50\" \nclass=\"list-item-jic grey-200-bg\" style=\"margin-right: 5px\"><b>Alasan Pengajuan</b></div><div flex=\"50\" \nclass=\"list-item-jic\"></div></md-list-item><md-list-item layout=\"row\" layout-align=\"start start\"><div flex=\"50\" \nclass=\"list-item-jic\" layout-align=\"start start\"><md-checkbox ng-model=\"item.checked\" flex \nng-repeat=\"item in vm.reasonsLists track by $index\" ng-click=\"vm.setSelectedReasons(item)\" \nng-change=\"vm.setSelectedReasons(item)\" style=\"margin-top: 0px; margin-bottom: 10px; display: block\">{{ item.name }} <a\n ng-if=\"item.isAdditional\" href=\"javascript:void(0);\" ng-click=\"vm.removeAdditionalReason($index, item)\" \nclass=\"color-danger\"><i class=\"icon-close\" style=\"font-size: small\"></i></a></md-checkbox><md-input-container \nmd-no-float class=\"md-block\"><input ng-model=\"vm.additionalReason\" type=\"text\" placeholder=\"Add new reason...\" \nflex=\"90\" style=\"float: left\"><md-button flex=\"10\" style=\"float: right; display: contents\" \nng-click=\"vm.addNewReason(vm.additionalReason)\"><i class=\"icon-plus\"></i></md-button></md-input-container><fieldset \nng-if=\"vm.selectedEmployee.reasonEmpChange\" class=\"mt-10\"><legend>Informasi Keluar/Mutasi/Promosi:</legend><table \nclass=\"table\"><tr><td style=\"width: 120px\">Employee</td><td>:</td><td>\n{{vm.selectedEmployee.reasonEmpChange[0].fullname}}</td></tr><tr><td>Position</td><td>:</td><td>\n{{vm.selectedEmployee.reasonEmpChange[0].position_name}}</td></tr><tr><td>Reasons</td><td>:</td><td>\n{{vm.selectedEmployee.reasonEmpChange[0].reasons}}</td></tr><tr><td>Effective Date</td><td>:</td><td>\n{{vm.selectedEmployee.reasonEmpChange[0].effective_date}}</td></tr></table></fieldset></div><div flex=\"50\" \nclass=\"list-item-jic\" style=\"padding-left: 0px\"></div></md-list-item><div \nstyle=\"border-bottom: 0.5px solid #ebebeb; margin-bottom: 5px\"></div><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"end start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\" flex><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-md=\"column\" layout-align=\"end start\" flex><md-button type=\"submit\" type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"frmJicRevisiedPengajuan.$invalid || basicForm.$pristine\">REVISIED</md-button><md-button type=\"button\" \nui-sref=\"app.emp_jic\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"Reload\">BACK</md-button></div>\n</md-list></form></md-content></div>");
$templateCache.put("app/main/utility/menu/input-menu/input-menu.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\"><md-subheader class=\"white-bg\">\nForm Input Menu</md-subheader><div class=\"white-bg\"><div class=\"content\" layout=\"column\"><div class=\"form-wrapper\" \nflex=\"70\" flex-sm=\"90\" flex-xs=\"100\" flex-md=\"80\"><form name=\"formInputModul\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputModul)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"title\" \nng-model=\"vm.Form.objForm.title\" placeholder=\"Menu Title\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputModul.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>title is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Has Sub</label><md-switch ng-model=\"vm.Form.objForm.hassub\" \naria-label=\"Has Sub\"><span ng-if=\"vm.Form.objForm.hassub\">YES</span> <span ng-if=\"!vm.Form.objForm.hassub\">NO</span>\n</md-switch></md-input-container><md-input-container flex><input type=\"text\" name=\"orderNo\" \nng-model=\"vm.Form.objForm.orderNo\" placeholder=\"Sequence\" required><div ng-messages=\"formInputModul.orderNo.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sequence is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Level</label><md-select name=\"level\" ng-model=\"vm.Form.objForm.level\" required>\n<md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option></md-select><div \nng-messages=\"formInputModul.level.$error\" role=\"alert\"><div ng-message=\"required\"><span>level is required.</span></div>\n</div></md-input-container><md-input-container ng-if=\"vm.Form.objForm.level > 1\" flex><md-select placeholder=\"Parent\" \nname=\"parent\" ng-model=\"vm.Form.objForm.parent\" required><md-option ng-repeat=\"ls in vm.listParent\" \nng-value=\"{{ls.id}}\">{{ls.nama | uppercase}}</md-option></md-select><div ng-messages=\"formInputModul.parent.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Parent is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"icon\" ng-model=\"vm.Form.objForm.icon\" placeholder=\"Icon\"><div \nng-messages=\"formInputModul.icon.$error\" role=\"alert\"><div ng-message=\"required\"><span>Icon is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"state\" ng-model=\"vm.Form.objForm.state\" \nplaceholder=\"State\" required><div ng-messages=\"formInputModul.state.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>state is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"stateParams\" ng-model=\"vm.Form.objForm.stateParams\" placeholder=\"State Params\"><div \nng-messages=\"formInputModul.stateParams.$error\" role=\"alert\"><div ng-message=\"required\"><span>stateParams is required.\n</span></div></div></md-input-container><md-input-container flex><label>Group</label><md-switch \nng-model=\"vm.Form.objForm.group\" aria-label=\"Has Sub\"><span ng-if=\"vm.Form.objForm.group\">Group </span><span \nng-if=\"!vm.Form.objForm.group\">No Group</span></md-switch></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"translate\" ng-model=\"vm.Form.objForm.translate\" placeholder=\"Translate\"><div \nng-messages=\"formInputModul.translate.$error\" role=\"alert\"><div ng-message=\"required\"><span>translate is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"menu_name\" \nng-model=\"vm.Form.objForm.menu_name\" placeholder=\"Menu Name\" ng-change=\"vm.clearMeesage()\"><div \nng-messages=\"formInputModul.menu_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>menu name is required.\n</span></div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInputModul.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"button\" \nng-click=\"vm.back()\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"back\">Back</md-button></div></form>\n</div></div></div></div></md-content></div>");
$templateCache.put("app/main/utility/modul/input-modul/input-modul.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon ui-sref=\"{{vm.Breadhome}}\" md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><div ng-repeat-start=\"ls  in vm.Breadlist\"></div><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\" ui-sref=\"{{ls.link}}\">{{ls.name}}</span><div ng-repeat-end></div>\n</div><div class=\"title\">Form Input Modul</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" \nflex-md=\"80\"><form name=\"formInputModul\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputModul)\"><div\n layout=\"column\"><md-input-container flex><input type=\"text\" name=\"menu_name\" ng-model=\"vm.Form.objForm.menu_name\" \nplaceholder=\"Menu Name\" ng-change=\"vm.clearMeesage()\" required><div ng-messages=\"formInputModul.menu_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>menu_name is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Has Sub</label><md-select name=\"hassub\" ng-model=\"vm.Form.objForm.hassub\" required>\n<md-option value=\"1\">1</md-option><md-option value=\"0\">0</md-option></md-select><div \nng-messages=\"formInputModul.hassub.$error\" role=\"alert\"><div ng-message=\"required\"><span>Hassub is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"urut\" \nng-model=\"vm.Form.objForm.urut\" placeholder=\"Sequence\" required><div ng-messages=\"formInputModul.urut.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Sequence is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Ajax</label><md-select name=\"ajax\" ng-model=\"vm.Form.objForm.ajax\" required><md-option \nvalue=\"yes\">Yes</md-option><md-option value=\"no\">No</md-option></md-select><div \nng-messages=\"formInputModul.ajax.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ajax is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"level\" ng-model=\"vm.Form.objForm.level\" \nplaceholder=\"Level\" required><div ng-messages=\"formInputModul.level.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>level is required.</span></div></div></md-input-container><md-input-container flex><md-select \nplaceholder=\"Parent\" name=\"parent\" ng-model=\"vm.Form.objForm.parent\"><md-option ng-repeat=\"ls in vm.listParent\" \nng-value=\"{{ls.id}}\">{{ls.nama | uppercase}}</md-option></md-select><div ng-messages=\"formInputModul.parent.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Parent is required.</span></div></div></md-input-container></div>\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"formInputModul.$invalid || basicForm.$pristine\">Submit\n</md-button><md-button type=\"button\" ng-click=\"vm.back()\" class=\"md-raised md-warn md-hue-2\" aria-label=\"back\">Back\n</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/utility/modules/input-modules/input-modules-action.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"50\" flex-gt-md=\"60\"><form ng-cloack name=\"eduForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,eduForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Modules Action</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><input type=\"hidden\" name=\"modules_id\" ng-model=\"vm.Form.objForm.modules_id\"><md-input-container \nclass=\"md-block\"><label>Action Name</label><input ng-model=\"vm.Form.objForm.action_name\" required \nplaceholder=\"Action Name\" required></md-input-container><md-input-container md-no-float class=\"md-block\"><label>\nAction Label</label><input ng-model=\"vm.Form.objForm.action_label\" required placeholder=\"Action Label\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"eduForm.$invalid || eduForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/utility/modules/input-modules/input-modules.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Form Input Modules</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><form name=\"formInputModul\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputModul)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" \nname=\"module_name\" ng-model=\"vm.Form.objForm.module_name\" placeholder=\"Module Name\" ng-change=\"vm.clearMeesage()\" \nrequired><div ng-messages=\"formInputModul.module_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nmodule_name is required.</span></div></div></md-input-container><md-input-container flex><md-select \nplaceholder=\"Select Menu\" name=\"menus_id\" ng-model=\"vm.Form.objForm.menus_id\" required><md-option \nng-repeat=\"ls in vm.listMenu\" ng-value=\"{{ls.id}}\">{{ls.title | uppercase}}</md-option></md-select><div \nng-messages=\"formInputModul.menus_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Menu is required.</span>\n</div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInputModul.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"button\" \nng-click=\"vm.back()\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"back\">Back</md-button></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/utility/modules/input-modules/modules-action.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Modules Action</md-subheader><div class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container hide show-gt-sm><select name=\"see\" id=\"ss\" \nng-change=\"vm.loadData(1)\" ng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\" \nng-disabled=\"frmEmploye.$invalid || frmEmploye.$pristine\"></select>Entries</md-input-container><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-mini md-raised md-primary\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.InputAction($event)\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Add Employement</span></md-tooltip><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Add Employement</span></md-button><div \nclass=\"divider-vertical hide show-gt-sm\" hide show-gt-sm></div><md-button class=\"md-warn md-mini\" hide show-gt-sm \naria-label=\"Delete\" ng-click=\"vm.deleteModul($event)\" type=\"button\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span>Delete</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span>Delete Employement</span></md-button><span flex hide \nshow-gt-sm></span><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-content layout=\"column\" flex layout-padding layout-fill \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th width=\"5%\">\n<div class=\"table-header\"></div></th><th width=\"5%\" class=\"text-center\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"text-center\"><div class=\"table-header\"><span class=\"column-title\">\nLink</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Menu Name</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.list\" ng-dblclick=\"vm.editAction($event,ls)\" class=\"text-center\"><td \nclass=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listModulSelected\" checklist-value=\"ls\"></td><td \nclass=\"text-center\">{{ ls.no }}</td><td class=\"text-center\">{{ ls.action_name }}</td><td class=\"text-center\">\n{{ ls.action_label | uppercase }}</td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\">\n<ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" \nclass=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/utility/permission/add-permission/add-permission.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Utility</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Permission</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Add Permission</span></div><div \nclass=\"title\">Form Add Permission</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" \nflex-md=\"80\"><form name=\"formInputAction\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputAction)\">\n<div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"action_permission\" \nng-model=\"vm.Form.objForm.action_permission\" placeholder=\"Action\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputAction.action_permission.$error\" role=\"alert\"><div ng-message=\"required\"><span>\naction_permission is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"action_label\" ng-model=\"vm.Form.objForm.action_label\" placeholder=\"Action Label\" required><div \nng-messages=\"formInputAction.action_label.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nactionlabel is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"module\" ng-model=\"vm.Form.objForm.module\" placeholder=\"Module\" required><div \nng-messages=\"formInputAction.module.$error\" role=\"alert\"><div ng-message=\"required\"><span>module is required.</span>\n</div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"formInputAction.$invalid || basicForm.$pristine\">Submit\n</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/utility/permission/input-action/input-action.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Utility</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Permission</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Input Action</span></div><div \nclass=\"title\">Form Input Action</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"70\" flex-sm=\"90\" flex-xs=\"100\" \nflex-md=\"80\"><form name=\"formInputAction\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(formInputAction)\">\n<div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"action_permission\" \nng-model=\"vm.Form.objForm.action_permission\" placeholder=\"Action\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputAction.action_permission.$error\" role=\"alert\"><div ng-message=\"required\"><span>\naction_permission is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"action_label\" ng-model=\"vm.Form.objForm.action_label\" placeholder=\"Action Label\" required><div \nng-messages=\"formInputAction.action_label.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nactionlabel is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"module\" ng-model=\"vm.Form.objForm.module\" placeholder=\"Module\" required><div \nng-messages=\"formInputAction.module.$error\" role=\"alert\"><div ng-message=\"required\"><span>module is required.</span>\n</div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-raised md-warn\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"formInputAction.$invalid || basicForm.$pristine\">Submit\n</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/utility/user/input-user/input-user.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth carded with-toolbar-content white-bg\"><md-content \nclass=\"content padding\" layout-fill><div class=\"md-whiteframe-4dp white-bg rounded\" layout-fill><md-subheader \nclass=\"white-bg\">Form Input User</md-subheader><div class=\"white-bg\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><form name=\"formInputUser\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveData(formInputUser)\"><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"nama\" \nng-model=\"vm.Form.objForm.nama\" placeholder=\"Name\" ng-change=\"vm.clearMeesage()\" required><div \nng-messages=\"formInputUser.nama.$error\" role=\"alert\"><div ng-message=\"required\"><span>nama is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"username\" \nng-model=\"vm.Form.objForm.username\" placeholder=\"Username\" required><div ng-messages=\"formInputUser.username.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Username is required.</span></div></div></md-input-container>\n<md-input-container flex><md-select placeholder=\"Group\" name=\"group\" ng-model=\"vm.Form.objForm.group\" required>\n<md-option ng-repeat=\"ls in vm.listGroupSelect\" ng-value=\"{{ls.id}}\">{{ls.nama | uppercase}}</md-option></md-select>\n<div ng-messages=\"formInputUser.group.$error\" role=\"alert\"><div ng-message=\"required\"><span>Group is required.</span>\n</div></div></md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"vm.reloadToken()\" \nclass=\"md-blue-300-bg md-raised white-fg\" aria-label=\"Reload\">Reload Token</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\" \nng-disabled=\"formInputUser.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"button\" \nng-click=\"vm.back()\" class=\"md-blue-grey-300-bg md-raised white-fg\" aria-label=\"back\">Back</md-button></div></form>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/wfh/wfh-main/dialog-add-activity/dialog-add-activity.html","<md-dialog aria-label=\"Form Add Activity\" flex-md=\"70\" flex-gt-md=\"70\"><form ng-cloack name=\"frmAddActivity\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddActivity)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Add Activity</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\"><div id=\"tableMpp\"><table \nclass=\"simple bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th \nstyle=\"text-transform: uppercase;font-size: 12px !important\" rowspan=\"{{ vm.is_setTime ? \'2\':\'1\' }}\">No</th><th \nstyle=\"text-transform: uppercase; width: 40%;font-size: 12px !important\" rowspan=\"{{ vm.is_setTime ? \'2\':\'1\' }}\">\nActivity</th><th style=\"text-transform: uppercase; width: 40%;font-size: 12px !important\" \nrowspan=\"{{ vm.is_setTime ? \'2\':\'1\' }}\">Note</th><th style=\"text-transform: uppercase;font-size: 12px !important\" \ncolspan=\"2\" ng-if=\"vm.is_setTime\">Start End Time</th><th style=\"text-transform: uppercase;font-size: 12px !important\" \nrowspan=\"{{ vm.is_setTime ? \'2\':\'1\' }}\">Status</th><th rowspan=\"{{ vm.is_setTime ? \'2\':\'1\' }}\"></th></tr><tr \nng-if=\"vm.is_setTime\"><th style=\"text-transform: uppercase;font-size: 12px !important\">Start</th><th \nstyle=\"text-transform: uppercase;font-size: 12px !important\">End</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.listActivity\"><td class=\"text-center\" style=\"font-size: 12px !important\">{{$index+1}}</td><td \nstyle=\"font-size: 12px !important\"><input type=\"text\" name=\"activity_name\" ng-model=\"item.activity_name\" \nclass=\"input-text-wfh\" placeholder=\"Activity Name\"></td><td style=\"font-size: 12px !important\"><textarea \nng-model=\"item.note\" class=\"text-area-comment-wfh\" placeholder=\"Note\" rows=\"2\"></textarea></td><td \nng-if=\"vm.is_setTime\"><input type=\"time\" name=\"start\" ng-model=\"item.start_time\" class=\"input-time-wfh\"></td><td \nng-if=\"vm.is_setTime\"><input type=\"time\" name=\"end\" ng-model=\"item.end_time\" class=\"input-time-wfh\"></td><td \nstyle=\"font-size: 12px !important\"><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"item.status\">\n<md-radio-button ng-repeat=\"ls in vm.statusProgress\" ng-value=\"ls.value\">{{ls.label}}</md-radio-button>\n</md-radio-group></td><td class=\"text-center\" style=\"font-size: 12px !important\"><md-button type=\"button\" \nclass=\"md-mini md-warn\" aria-label=\"Remove\" ng-click=\"vm.removeRow(item,$index)\">Remove</md-button></td></tr></tbody>\n</table><div><md-button type=\"button\" class=\"md-mini md-primary\" aria-label=\"Add\" ng-click=\"vm.addRow()\">Add row\n</md-button></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/wfh/wfh-main/dialog-export-data/dialog-export-data.html","<md-dialog aria-label=\"Export Data\" style=\"max-width: 90% !important;width: 50%\"><form ng-cloack name=\"frmAddActivity\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.exportData($event,frmAddActivity)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Export Data</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\"><div layout=\"row\"><form name=\"exportForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.exportData($event,exportForm)\"><div class=\"widget-group layout-wrap layout-row flex-100\" layout=\"row\" \nflex=\"100\"><div flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\" layout-gt-sm=\"column\"><div layout=\"row\" layout-wrap flex>\n<div flex-xs flex=\"50\"><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" style=\"margin: 5px;margin-left: 0;margin-right: 0\">\n<span ng-if=\"vm.isChecked()\">Un-</span>Export Data All</md-checkbox></div><div class=\"demo-select-all-checkboxes\" \nflex=\"100\" style=\"padding-left: 20px\" ng-repeat=\"item in vm.items\"><md-checkbox \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\" \nstyle=\"margin: 5px;margin-left: 0;margin-right: 0\">{{ item }}</md-checkbox></div></div></div><div flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\" layout-gt-sm=\"column\" style=\"margin-top: 2vh\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex style=\"margin: 0px; margin-bottom: 1vh\"><label>Start Date</label><input \ntype=\"date\" name=\"start_date\" ng-model=\"vm.exportForm.start_date\"></md-input-container><md-input-container flex \nstyle=\"margin: 0px; margin-bottom: 1vh\"><label>End Date</label><input type=\"date\" name=\"end_date\" \nng-model=\"vm.exportForm.end_date\"></md-input-container></div></div></div></form></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"button\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"vm.selected.length == 0 || !vm.exportForm.start_date || !vm.exportForm.end_date || vm.exportForm.start_date == \'\' || vm.exportForm.end_date == \'\'\" \nng-click=\"vm.exportData()\">Export Data</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/wfh/wfh-main/dialog-health-status/dialog-health-status.html","<md-dialog aria-label=\"Update Health Status\" style=\"max-width: 90% !important;width: 80%\"><form ng-cloack \nname=\"frmAddActivity\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmAddActivity)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Update Health Status</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><md-tabs \nclass=\"list-candidate-process-tab\" md-selected=\"vm.selectedIndexTab\" \nmd-align-tabs=\"{{vm.data.bottom ? \'bottom\' : \'top\'}}\" md-dynamic-height md-border-bottom><md-tab \nmd-on-select=\"vm.tabChange(1)\"><md-tab-label style=\"color: rgb(235, 236, 240) !important\">Morning</md-tab-label>\n<md-tab-body style=\"background: white\"><div id=\"tableMpp\"><table class=\"simple stripped\" cellpadding=\"0\" \ncellspacing=\"0\" ms-responsive-table><thead><tr><th style=\"width: 50px;font-size: 12px !important\">No</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Person</th><th \nstyle=\"text-align: left !important;font-size: 12px !important;border: 0px\">Morning Status</th><th \nstyle=\"text-align: left !important;font-size: 12px !important;border: 0px\">Note</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTableDependents.list\"><td class=\"text-center\" style=\"font-size: 12px !important\">\n{{ item.no }}</td><td style=\"font-size: 12px !important\">{{ item.name }}<br><small>{{item.type_of_family}}</small></td>\n<td style=\"font-size: 12px !important\" class=\"text-center\"><md-radio-group layout=\"row\" layout-align=\"start center\" \nng-model=\"item.status.morning\"><md-radio-button ng-repeat=\"ls in vm.statusHealth\" ng-value=\"ls.value\" \nstyle=\"width: max-content\"><img ng-src=\"./assets/images/wfh/fix.png\" \nng-if=\"ls.label == \'fix\' && item.status.morning == \'fix\'\"> <img ng-src=\"./assets/images/wfh/fix_dis.png\" \nng-if=\"ls.label == \'fix\' && item.status.morning != \'fix\'\"> <img ng-src=\"./assets/images/wfh/unfix.png\" \nng-if=\"ls.label == \'unfix\' && item.status.morning == \'unfix\'\"> <img ng-src=\"./assets/images/wfh/unfix_dis.png\" \nng-if=\"ls.label == \'unfix\' && item.status.morning != \'unfix\'\"> <img ng-src=\"./assets/images/wfh/sick.png\" \nng-if=\"ls.label == \'sick\' && item.status.morning == \'sick\'\"> <img ng-src=\"./assets/images/wfh/sick_dis.png\" \nng-if=\"ls.label == \'sick\' && item.status.morning != \'sick\'\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span ng-if=\"ls.label == \'fix\'\">Fit</span> <span ng-if=\"ls.label == \'unfix\'\">Un Fit</span> \n<span ng-if=\"ls.label == \'sick\'\">Sick</span></md-tooltip></md-radio-button></md-radio-group></td><td \nstyle=\"font-size: 12px !important\"><textarea ng-model=\"item.status.health_status_morning\" \nclass=\"text-area-comment-wfh\" placeholder=\"Note\" rows=\"2\"></textarea></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTableDependents.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTableDependents.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a \nhref=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></md-tab-body></md-tab><md-tab \nmd-on-select=\"vm.tabChange(2)\"><md-tab-label style=\"color: rgb(235, 236, 240) !important\">Afternoon</md-tab-label>\n<md-tab-body style=\"background: white\"><div id=\"tableMpp\"><table class=\"simple stripped\" cellpadding=\"0\" \ncellspacing=\"0\" ms-responsive-table><thead><tr><th style=\"width: 50px;font-size: 12px !important\">No</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Person</th><th \nstyle=\"text-align: left !important;font-size: 12px !important;border: 0px\">Afternoon Status</th><th \nstyle=\"text-align: left !important;font-size: 12px !important;border: 0px\">Note</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTableDependents.list\"><td class=\"text-center\" style=\"font-size: 12px !important\">\n{{ item.no }}</td><td style=\"font-size: 12px !important\">{{ item.name }}<br><small>{{item.type_of_family}}</small></td>\n<td style=\"font-size: 12px !important\" class=\"text-center\"><md-radio-group layout=\"row\" layout-align=\"start center\" \nng-model=\"item.status.afternoon\"><md-radio-button ng-repeat=\"ls in vm.statusHealth\" ng-value=\"ls.value\" \nstyle=\"width: max-content\"><img ng-src=\"./assets/images/wfh/fix.png\" \nng-if=\"ls.label == \'fix\' && item.status.afternoon == \'fix\'\"> <img ng-src=\"./assets/images/wfh/fix_dis.png\" \nng-if=\"ls.label == \'fix\' && item.status.afternoon != \'fix\'\"> <img ng-src=\"./assets/images/wfh/unfix.png\" \nng-if=\"ls.label == \'unfix\' && item.status.afternoon == \'unfix\'\"> <img ng-src=\"./assets/images/wfh/unfix_dis.png\" \nng-if=\"ls.label == \'unfix\' && item.status.afternoon != \'unfix\'\"> <img ng-src=\"./assets/images/wfh/sick.png\" \nng-if=\"ls.label == \'sick\' && item.status.afternoon == \'sick\'\"> <img ng-src=\"./assets/images/wfh/sick_dis.png\" \nng-if=\"ls.label == \'sick\' && item.status.afternoon != \'sick\'\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span ng-if=\"ls.label == \'fix\'\">Fit</span> <span ng-if=\"ls.label == \'unfix\'\">Un Fit</span> \n<span ng-if=\"ls.label == \'sick\'\">Sick</span></md-tooltip></md-radio-button></md-radio-group></td><td \nstyle=\"font-size: 12px !important\"><textarea ng-model=\"item.status.health_status_afternoon\" \nclass=\"text-area-comment-wfh\" placeholder=\"Note\" rows=\"2\"></textarea></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTableDependents.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTableDependents.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a \nhref=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></md-tab-body></md-tab>\n</md-tabs></md-content></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"(vm.tabIndex == 1 && vm.countCheckedStatus().totalMorning != vm.DataTableDependents.list.length) || (vm.tabIndex == 2 && vm.countCheckedStatus().totalAfternoon != vm.DataTableDependents.list.length)\">\nSubmit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/wfh/wfh-main/dialog-status-team/dialog-status-team.html","<md-dialog aria-label=\"Team Status\" style=\"max-width: 90% !important;width: 80%\"><form ng-cloack name=\"frmAddActivity\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddActivity)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Team Status</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 0px !important\"><md-content \nlayout=\"column\" flex layout-padding layout-fill class=\"white-bg\" style=\"padding: 0px !important\"><md-tabs \nclass=\"list-candidate-process-tab\" md-selected=\"vm.selectedIndexTab\" \nmd-align-tabs=\"{{vm.data.bottom ? \'bottom\' : \'top\'}}\" md-dynamic-height md-border-bottom><md-tab \nmd-on-select=\"vm.tabChange(1)\"><md-tab-label style=\"color: rgb(235, 236, 240) !important\">Health Status</md-tab-label>\n<md-tab-body style=\"background: white\"><div id=\"tableMpp\"><table class=\"simple stripped\" cellpadding=\"0\" \ncellspacing=\"0\" ms-responsive-table><thead><tr><th style=\"width: 50px;font-size: 12px !important\" rowspan=\"2\">No</th>\n<th style=\"text-align: left !important;font-size: 12px !important\" rowspan=\"2\">Person</th><th \nstyle=\"font-size: 12px !important;border: 0px\" colspan=\"2\">Status</th></tr><tr><th \nstyle=\"font-size: 12px !important;border: 0px\">Morning</th><th style=\"font-size: 12px !important;border: 0px\">Afternoon\n</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTeam.dependent_list\"><td class=\"text-center\" \nstyle=\"font-size: 12px !important\">{{ item.no }}</td><td style=\"font-size: 12px !important\">{{ item.name }}<br><small>\n{{item.type_of_family}}</small><br><small ng-if=\"item.status.health_status_morning\">\nMorning Status : {{item.status.health_status_morning}}</small><br><small ng-if=\"item.status.health_status_afternoon\">\nAfternoon Status : {{item.status.health_status_afternoon}}</small></td><td style=\"font-size: 12px !important\" \nclass=\"text-center\"><img ng-src=\"./assets/images/wfh/fix.png\" ng-if=\"item.status.morning == \'fix\'\"> <img \nng-src=\"./assets/images/wfh/unfix.png\" ng-if=\"item.status.morning == \'unfix\'\"> <img \nng-src=\"./assets/images/wfh/sick.png\" ng-if=\"item.status.morning == \'sick\'\"><br><small>{{item.status.morning_time}}\n</small><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span ng-if=\"item.status.morning == \'fix\'\">Fit\n</span> <span ng-if=\"item.status.morning == \'unfix\'\">Un Fit</span> <span ng-if=\"item.status.morning == \'sick\'\">Sick\n</span></md-tooltip></td><td style=\"font-size: 12px !important\" class=\"text-center\"><img \nng-src=\"./assets/images/wfh/fix.png\" ng-if=\"item.status.afternoon == \'fix\'\"> <img \nng-src=\"./assets/images/wfh/unfix.png\" ng-if=\"item.status.afternoon == \'unfix\'\"> <img \nng-src=\"./assets/images/wfh/sick.png\" ng-if=\"item.status.afternoon == \'sick\'\"><br><small>{{item.status.afternoon_time}}\n</small><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span ng-if=\"item.status.afternoon == \'fix\'\">Fit\n</span> <span ng-if=\"item.status.afternoon == \'unfix\'\">Un Fit</span> <span ng-if=\"item.status.afternoon == \'sick\'\">Sick\n</span></md-tooltip></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTableDependents.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTableDependents.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabChange(2)\">\n<md-tab-label style=\"color: rgb(235, 236, 240) !important\">Activity</md-tab-label><md-tab-body \nstyle=\"background: white\"><div id=\"tableMpp\"><md-toolbar style=\"margin-top: 25px\"><div \nclass=\"md-toolbar-tools table-tools\"><md-input-container style=\"width:-webkit-fill-available\"><input type=\"date\" \nname=\"start_date\" ng-model=\"vm.start_date\" placeholder=\"Start Date\"></md-input-container><md-input-container \nstyle=\"width:-webkit-fill-available\"><input type=\"date\" name=\"end_date\" ng-model=\"vm.end_date\" placeholder=\"End Date\">\n</md-input-container><md-button class=\"md-primary md-icon-button md-small\" type=\"button\" aria-label=\"FilterCost\" \nng-click=\"vm.loadData(1)\"><md-icon style=\"font-size:14px\" md-font-icon=\"icon-filter\"></md-icon></md-button></div>\n</md-toolbar><table class=\"simple stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th \nstyle=\"width: 50px;font-size: 12px !important\">No</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Activity</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Activity Date</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Status</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Comment</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTableActivity.list\"><td class=\"text-center\" style=\"font-size: 12px !important\">{{ item.no }}\n</td><td style=\"font-size: 12px !important\">{{ item.activity_name }}<br><small>{{item.note}}</small><br><small \nng-if=\"item.start_hour\">Start End Time : {{ item.start_hour }} - {{ item.end_hour }}</small></td><td \nstyle=\"font-size: 12px !important\">{{ item.activity_date }}</td><td style=\"font-size: 12px !important\">\n{{ item.status }}</td><td style=\"font-size: 12px !important\"><textarea ng-model=\"item.comment\" \nclass=\"text-area-comment-wfh\" placeholder=\"Comment Activity\"></textarea></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTableActivity.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTableActivity.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a \nhref=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div><form ng-cloack \nname=\"frmAddActivity\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmAddActivity)\"><span flex></span><md-button type=\"submit\" class=\"md-raised md-primary\" \naria-label=\"Submit\" style=\"float: right\">Submit</md-button></form></md-tab-body></md-tab></md-tabs></md-content>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/wfh/wfhadmin/dialog-add-activity/dialog-add-activity.html","<md-dialog aria-label=\"Form Add Activity\" flex-md=\"70\" flex-gt-md=\"70\"><form ng-cloack name=\"frmAddActivity\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddActivity)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Add Activity</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\"><md-content layout=\"column\" flex \nlayout-padding layout-fill class=\"white-bg\"><div layout=\"column\" flex><div layout-padding=\"1\" layout=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\"><md-input-container flex flex-gt-sm><label>NIK</label><md-chips \nng-model=\"vm.selectedDatas\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" \nmd-require-match=\"vm.autocompleteDemoRequireMatch\" input-aria-label=\"\"><md-autocomplete \nstyle=\"background: transparent;\n                                      border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.nik)\"><md-item-template><span md-highlight-text=\"vm.searchString\">\n{{item.fullname}}</span></md-item-template></md-autocomplete><md-chip-template><span>{{$chip.fullname}}</span>\n</md-chip-template></md-chips><div ng-messages=\"frmAddActivity.product.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.NIK\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.STARTDATE\"></label><md-datepicker \nmd-hide-icons=\"calendar\" md-max-date=\"vm.date\" name=\"date\" ng-change=\"vm.getActivity()\" ng-model=\"vm.date\">\n</md-datepicker><div ng-messages=\"frmAddActivity.date.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div></div></md-content><div id=\"tableMpp\"><table class=\"simple bordered stripped\" \ncellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th \nstyle=\"text-transform: uppercase;font-size: 12px !important\" rowspan=\"{{ vm.is_setTime ? \'2\':\'1\' }}\">No</th><th \nstyle=\"text-transform: uppercase; width: 40%;font-size: 12px !important\" rowspan=\"{{ vm.is_setTime ? \'2\':\'1\' }}\">\nActivity</th><th style=\"text-transform: uppercase; width: 40%;font-size: 12px !important\" \nrowspan=\"{{ vm.is_setTime ? \'2\':\'1\' }}\">Note</th><th style=\"text-transform: uppercase;font-size: 12px !important\" \ncolspan=\"2\" ng-if=\"vm.is_setTime\">Start End Time</th><th style=\"text-transform: uppercase;font-size: 12px !important\" \nrowspan=\"{{ vm.is_setTime ? \'2\':\'1\' }}\">Status</th><th rowspan=\"{{ vm.is_setTime ? \'2\':\'1\' }}\"></th></tr><tr \nng-if=\"vm.is_setTime\"><th style=\"text-transform: uppercase;font-size: 12px !important\">Start</th><th \nstyle=\"text-transform: uppercase;font-size: 12px !important\">End</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.listActivity\"><td class=\"text-center\" style=\"font-size: 12px !important\">{{$index+1}}</td><td \nstyle=\"font-size: 12px !important\"><input type=\"text\" name=\"activity_name\" ng-model=\"item.activity_name\" \nclass=\"input-text-wfh\" placeholder=\"Activity Name\"></td><td style=\"font-size: 12px !important\"><textarea \nng-model=\"item.note\" class=\"text-area-comment-wfh\" placeholder=\"Note\" rows=\"2\"></textarea></td><td \nng-if=\"vm.is_setTime\"><input type=\"time\" name=\"start\" ng-model=\"item.start_time\" class=\"input-time-wfh\"></td><td \nng-if=\"vm.is_setTime\"><input type=\"time\" name=\"end\" ng-model=\"item.end_time\" class=\"input-time-wfh\"></td><td \nstyle=\"font-size: 12px !important\"><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"item.status\">\n<md-radio-button ng-repeat=\"ls in vm.statusProgress\" ng-value=\"ls.value\">{{ls.label}}</md-radio-button>\n</md-radio-group></td><td class=\"text-center\" style=\"font-size: 12px !important\"><md-button type=\"button\" \nclass=\"md-mini md-warn\" aria-label=\"Remove\" ng-click=\"vm.removeRow(item,$index)\">Remove</md-button></td></tr></tbody>\n</table><div><md-button type=\"button\" class=\"md-mini md-primary\" aria-label=\"Add\" ng-click=\"vm.addRow()\">Add row\n</md-button></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/wfh/wfhadmin/dialog-health-status/dialog-health-status.html","<md-dialog aria-label=\"Update Health Status\" style=\"max-width: 90% !important;width: 80%\"><form ng-cloack \nname=\"frmAddActivity\" class=\"md-inline-form popup-input-form\" novalidate \nng-submit=\"vm.saveData($event,frmAddActivity)\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Update Health Status</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div \nlayout=\"column\" flex><div layout-padding=\"1\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-input-container \nflex flex-gt-sm><label>NIK</label><md-chips ng-model=\"vm.selectedDatas\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"vm.autocompleteDemoRequireMatch\" input-aria-label=\"\">\n<md-autocomplete \nstyle=\"background: transparent;\n                                      border-bottom: 1px solid #e0e0e0\" \nmd-no-cache=\"true\" md-selected-item=\"vm.nik\" md-search-text=\"vm.searchString\" \nmd-items=\"item in vm.getEmployee(vm.searchString)\" md-item-text=\"item.fullname\" ng-model=\"vm.nik\" \nmd-selected-item-change=\"vm.selectedItemChanged(vm.nik)\"><md-item-template><span md-highlight-text=\"vm.searchString\">\n{{item.fullname}}</span></md-item-template></md-autocomplete><md-chip-template><span>{{$chip.fullname}}</span>\n</md-chip-template></md-chips><div ng-messages=\"frmAddActivity.product.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.NIK\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex flex-gt-sm><label translate=\"KPI.LABEL.STARTDATE\"></label><md-datepicker \nmd-hide-icons=\"calendar\" md-max-date=\"vm.date\" name=\"date\" ng-change=\"vm.loadData(1);vm.getActivity()\" \nng-model=\"vm.date\"></md-datepicker><div ng-messages=\"frmAddActivity.date.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"KPI.LABEL.STARTDATE\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div></div></md-input-container></div></div><div id=\"tableMpp\"><table class=\"simple stripped\" cellpadding=\"0\" \ncellspacing=\"0\" ms-responsive-table><thead><tr><th style=\"width: 50px;font-size: 12px !important\">No</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Person</th><th \nstyle=\"text-align: left !important;font-size: 12px !important;border: 0px\">Morning Status</th><th \nstyle=\"text-align: left !important;font-size: 12px !important;border: 0px\">Note</th><th \nstyle=\"text-align: left !important;font-size: 12px !important;border: 0px\">Aternoon Status</th><th \nstyle=\"text-align: left !important;font-size: 12px !important;border: 0px\">Note</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTableDependents.list\"><td class=\"text-center\" style=\"font-size: 12px !important\">\n{{ item.no }}</td><td style=\"font-size: 12px !important\">{{ item.name }}<br><small>{{item.type_of_family}}</small></td>\n<td style=\"font-size: 12px !important\" class=\"text-center\"><md-radio-group layout=\"row\" layout-align=\"start center\" \nng-model=\"item.status.morning\"><md-radio-button ng-repeat=\"ls in vm.statusHealth\" ng-value=\"ls.value\" \nstyle=\"width: max-content\"><img ng-src=\"./assets/images/wfh/fix.png\" \nng-if=\"ls.label == \'fix\' && item.status.morning == \'fix\'\"> <img ng-src=\"./assets/images/wfh/fix_dis.png\" \nng-if=\"ls.label == \'fix\' && item.status.morning != \'fix\'\"> <img ng-src=\"./assets/images/wfh/unfix.png\" \nng-if=\"ls.label == \'unfix\' && item.status.morning == \'unfix\'\"> <img ng-src=\"./assets/images/wfh/unfix_dis.png\" \nng-if=\"ls.label == \'unfix\' && item.status.morning != \'unfix\'\"> <img ng-src=\"./assets/images/wfh/sick.png\" \nng-if=\"ls.label == \'sick\' && item.status.morning == \'sick\'\"> <img ng-src=\"./assets/images/wfh/sick_dis.png\" \nng-if=\"ls.label == \'sick\' && item.status.morning != \'sick\'\"><md-tooltip md-direction=\"down\" \nmd-visible=\"tooltipVisible\"><span ng-if=\"ls.label == \'fix\'\">Fit</span> <span ng-if=\"ls.label == \'unfix\'\">Un Fit</span> \n<span ng-if=\"ls.label == \'sick\'\">Sick</span></md-tooltip></md-radio-button></md-radio-group></td><td \nstyle=\"font-size: 12px !important\"><textarea ng-model=\"item.status.health_status_morning\" \nclass=\"text-area-comment-wfh\" placeholder=\"Note\" rows=\"2\"></textarea></td><td style=\"font-size: 12px !important\" \nclass=\"text-center\"><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"item.status.afternoon\">\n<md-radio-button ng-repeat=\"ls in vm.statusHealth\" ng-value=\"ls.value\" style=\"width: max-content\"><img \nng-src=\"./assets/images/wfh/fix.png\" ng-if=\"ls.label == \'fix\' && item.status.afternoon == \'fix\'\"> <img \nng-src=\"./assets/images/wfh/fix_dis.png\" ng-if=\"ls.label == \'fix\' && item.status.afternoon != \'fix\'\"> <img \nng-src=\"./assets/images/wfh/unfix.png\" ng-if=\"ls.label == \'unfix\' && item.status.afternoon == \'unfix\'\"> <img \nng-src=\"./assets/images/wfh/unfix_dis.png\" ng-if=\"ls.label == \'unfix\' && item.status.afternoon != \'unfix\'\"> <img \nng-src=\"./assets/images/wfh/sick.png\" ng-if=\"ls.label == \'sick\' && item.status.afternoon == \'sick\'\"> <img \nng-src=\"./assets/images/wfh/sick_dis.png\" ng-if=\"ls.label == \'sick\' && item.status.afternoon != \'sick\'\"><md-tooltip \nmd-direction=\"down\" md-visible=\"tooltipVisible\"><span ng-if=\"ls.label == \'fix\'\">Fit</span> <span \nng-if=\"ls.label == \'unfix\'\">Un Fit</span> <span ng-if=\"ls.label == \'sick\'\">Sick</span></md-tooltip></md-radio-button>\n</md-radio-group></td><td style=\"font-size: 12px !important\"><textarea ng-model=\"item.status.health_status_afternoon\" \nclass=\"text-area-comment-wfh\" placeholder=\"Note\" rows=\"2\"></textarea></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTableDependents.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTableDependents.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a \nhref=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7{{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Submit\" \nng-disabled=\"(vm.tabIndex == 1 && vm.countCheckedStatus().totalMorning != vm.DataTableDependents.list.length) || (vm.tabIndex == 2 && vm.countCheckedStatus().totalAfternoon != vm.DataTableDependents.list.length)\">\nSubmit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/wfh/wfhadmin/dialog-status-team/dialog-status-team.html","<md-dialog aria-label=\"Team Status\" style=\"max-width: 90% !important;width: 80%\"><form ng-cloack name=\"frmAddActivity\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,frmAddActivity)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>\nWFH ACTIVITY {{vm.DataTeam.name}}/{{vm.DataTeam.date}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"padding: 0px !important\"><md-content layout=\"column\" flex layout-padding \nlayout-fill class=\"white-bg\" style=\"padding: 0px !important\"><md-tabs class=\"list-candidate-process-tab\" \nmd-selected=\"vm.selectedIndexTab\" md-align-tabs=\"{{vm.data.bottom ? \'bottom\' : \'top\'}}\" md-dynamic-height \nmd-border-bottom><md-tab md-on-select=\"vm.tabChange(1)\"><md-tab-label style=\"color: rgb(235, 236, 240) !important\">\nHealth Status</md-tab-label><md-tab-body style=\"background: white\"><div id=\"tableMpp\"><table class=\"simple stripped\" \ncellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><thead><tr><th style=\"width: 50px;font-size: 12px !important\" \nrowspan=\"2\">No</th><th style=\"text-align: left !important;font-size: 12px !important\" rowspan=\"2\">Person</th><th \nstyle=\"font-size: 12px !important;border: 0px\" colspan=\"2\">Status</th></tr><tr><th \nstyle=\"font-size: 12px !important;border: 0px\">Morning</th><th style=\"font-size: 12px !important;border: 0px\">Afternoon\n</th></tr></thead><tbody><tr ng-repeat=\"item in vm.DataTableDependents\"><td class=\"text-center\" \nstyle=\"font-size: 12px !important\">{{ item.no }}</td><td style=\"font-size: 12px !important\">{{ item.name }}<br><small>\n{{item.type_of_family}}</small><br><small ng-if=\"item.status.health_status_morning\">\nMorning Status : {{item.status.health_status_morning}}</small><br><small ng-if=\"item.status.health_status_afternoon\">\nAfternoon Status : {{item.status.health_status_afternoon}}</small></td><td style=\"font-size: 12px !important\" \nclass=\"text-center\"><img ng-src=\"./assets/images/wfh/fix.png\" ng-if=\"item.status.morning == \'fix\'\"> <img \nng-src=\"./assets/images/wfh/unfix.png\" ng-if=\"item.status.morning == \'unfix\'\"> <img \nng-src=\"./assets/images/wfh/sick.png\" ng-if=\"item.status.morning == \'sick\'\"><br><small>{{item.status.morning_time}}\n</small><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span ng-if=\"item.status.morning == \'fix\'\">Fit\n</span> <span ng-if=\"item.status.morning == \'unfix\'\">Un Fit</span> <span ng-if=\"item.status.morning == \'sick\'\">Sick\n</span></md-tooltip></td><td style=\"font-size: 12px !important\" class=\"text-center\"><img \nng-src=\"./assets/images/wfh/fix.png\" ng-if=\"item.status.afternoon == \'fix\'\"> <img \nng-src=\"./assets/images/wfh/unfix.png\" ng-if=\"item.status.afternoon == \'unfix\'\"> <img \nng-src=\"./assets/images/wfh/sick.png\" ng-if=\"item.status.afternoon == \'sick\'\"><br><small>{{item.status.afternoon_time}}\n</small><md-tooltip md-direction=\"down\" md-visible=\"tooltipVisible\"><span ng-if=\"item.status.afternoon == \'fix\'\">Fit\n</span> <span ng-if=\"item.status.afternoon == \'unfix\'\">Un Fit</span> <span ng-if=\"item.status.afternoon == \'sick\'\">Sick\n</span></md-tooltip></td></tr></tbody></table><div class=\"mb-8 is-bottom-nav\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTableDependents.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTableDependents.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.loadData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div></div></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabChange(2)\">\n<md-tab-label style=\"color: rgb(235, 236, 240) !important\">Activity</md-tab-label><md-tab-body \nstyle=\"background: white\"><div id=\"tableMpp\"><table class=\"simple stripped\" cellpadding=\"0\" cellspacing=\"0\" \nms-responsive-table><thead><tr><th style=\"width: 50px;font-size: 12px !important\">No</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Activity</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Activity Date</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Status</th><th \nstyle=\"text-align: left !important;font-size: 12px !important\">Comment</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.DataTableActivity.list\"><td class=\"text-center\" style=\"font-size: 12px !important\">{{ item.no }}\n</td><td style=\"font-size: 12px !important\">{{ item.activity_name }}<br><small>{{item.note}}</small><br><small \nng-if=\"item.start_hour\">Start End Time : {{ item.start_hour }} - {{ item.end_hour }}</small></td><td \nstyle=\"font-size: 12px !important\">{{ item.activity_date }}</td><td style=\"font-size: 12px !important\">\n{{ item.status }}</td><td style=\"font-size: 12px !important\"><textarea ng-model=\"item.comment\" \nclass=\"text-area-comment-wfh\" placeholder=\"Comment Activity\"></textarea></td></tr></tbody></table><div \nclass=\"mb-8 is-bottom-nav\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTableActivity.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTableActivity.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a \nhref=\"\" ng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></md-tab-body></md-tab>\n</md-tabs></md-content></md-dialog-content></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/employee/employe/input-employe/bank/input-bank.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Certificate</span>\n</p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><form name=\"bankForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(bankForm)\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"!vm.stateEdit\" ng-disabled=\"vm.canEdit\" ng-click=\"vm.ChangeState()\" \ntype=\"button\" class=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\">Edit</md-button><md-button \nng-if=\"vm.stateEdit\" ng-click=\"vm.ChangeState()\" type=\"button\" class=\"md-raised md-yellow-500-bg white-fg\" \naria-label=\"Submit\">Cancel Edit</md-button><md-button \nng-if=\"!vm.check.doc_mandiri && !hasUpload && vm.Form.objForm.accountNumber!=null\" \nng-click=\"vm.uploadAccMandiri($event)\" type=\"button\" \nclass=\"md-raised md-grey-500-bg white-fg mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect\" \naria-label=\"Submit\" ng-disabled=\"vm.Form.objForm.accountNumber==null\">Upload Account</md-button><md-button \nng-if=\"vm.check.doc_mandiri\" ng-click=\"vm.viewDokumen($event,vm.Form.objForm)\" type=\"button\" \nclass=\"md-raised md-green-300-bg white-fg\" aria-label=\"View Account\">View Account</md-button></div><md-input-container \nng-if=\"vm.country==\'IDN\'\" flex><md-radio-group ng-model=\"vm.check.doc_mandiri\" name=\"acc_mandiri\" \nng-change=\"vm.changeNpwp()\" ng-disabled=\"true\"><md-radio-button value=\"1\" class=\"md-warn md-raised\"><span \ntranslate=\"MYPROFILE.MENU.HAVEACCOUNT\">Memiliki Account Mandiri</span></md-radio-button>&nbsp;&nbsp;<md-radio-button \nvalue=\"0\" class=\"md-warn md-raised\"><span translate=\"MYPROFILE.MENU.DONTHAVEACCOUNT\">Tidak Memiliki Account Mandiri\n</span></md-radio-button>&nbsp;&nbsp;</md-radio-group></md-input-container><md-input-container \nng-if=\"vm.country==\'MYS\'\" md-no-float class=\"md-block\" style=\"padding-bottom:20px\"><label \ntranslate=\"KPI.LABEL.BANKCODE\"></label><md-select name=\"bank_code\" ng-model=\"vm.Form.objForm.bank_code\" required \nng-disabled=\"!vm.stateEdit\"><md-option ng-repeat=\"ls in vm.listBankCode\" ng-value=\"ls.bank_code\">{{ls.bank_name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"KPI.LABEL.BANKNAME\">Bank Name</label><input ng-model=\"vm.Form.objForm.bankName\" md-maxlength=\"45\" required \nplaceholder=\"{{ \'KPI.LABEL.BANKNAME\' | translate}}\" name=\"bankName\" ng-disabled=\"vm.country==\'IDN\' || !vm.stateEdit\">\n<div ng-messages=\"bankForm.bankName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.BANKNAME\"></span> <span></span></div><div ng-message=\"md-maxlength\"><span>Max 45 Character.</span>\n</div></div></md-input-container><md-input-container md-no-float class=\"md-block\" style=\"padding-bottom:20px\"><label \ntranslate=\"KPI.LABEL.CURRENCY\"></label><md-select name=\"currency\" ng-model=\"vm.Form.objForm.currency\" required \nng-disabled=\"!vm.stateEdit\"><md-option ng-repeat=\"doc in vm.listCurrency\" ng-value=\"doc.currency\">{{doc.currency}}\n</md-option></md-select></md-input-container><md-input-container md-no-float class=\"md-block\"><label \ntranslate=\"KPI.LABEL.BRANCHNAME\"></label><input ng-model=\"vm.Form.objForm.branchName\" required \nplaceholder=\"{{ \'KPI.LABEL.BRANCHNAME\' | translate}}\" md-maxlength=\"45\" name=\"branchName\" ng-disabled=\"!vm.stateEdit\">\n<div ng-messages=\"bankForm.branchName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"KPI.LABEL.BRANCHNAME\"></span> <span></span></div><div ng-message=\"md-maxlength\"><span>Max 45 Character.\n</span></div></div></md-input-container><md-input-container md-no-float class=\"md-block\"><label \ntranslate=\"KPI.LABEL.ACCOUNTNUMBER\"></label><input ng-model=\"vm.Form.objForm.accountNumber\" required \nplaceholder=\"{{ \'KPI.LABEL.ACCOUNTNUMBER\' | translate}}\" md-maxlength=\"45\" name=\"accountNumber\" \nng-disabled=\"!vm.stateEdit\"><div ng-messages=\"bankForm.accountNumber.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"KPI.LABEL.ACCOUNTNUMBER\"></span> <span></span></div><div ng-message=\"md-maxlength\"><span>\nMax 45 Character.</span></div></div></md-input-container><md-input-container md-no-float class=\"md-block\"><label>\nSwift Code</label><input ng-model=\"vm.Form.objForm.swiftCode\" required placeholder=\"Swift Code\" md-maxlength=\"30\" \nname=\"swiftCode\" ng-disabled=\"!vm.stateEdit\"><div ng-messages=\"bankForm.accountNumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Swift Code</span> <span></span></div><div ng-message=\"md-maxlength\"><span>Max 30 Character.\n</span></div></div></md-input-container><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><div \nlayout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.stateEdit\" type=\"submit\" \nng-disabled=\"bankForm.$invalid || bankForm.$pristine\" class=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\">\nUpdate</md-button></div></form>");
$templateCache.put("app/main/employee/employe/input-employe/bank/upload.html","<md-dialog aria-label=\"Form Upload Pajak\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadAccMandiri\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload Account</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-input-container flex><label>Tanggal Dikeluarkan</label><md-datepicker name=\"issuedDate\" \nng-change=\"vm.ChangeDate()\" md-hide-icons=\"calendar\" ng-model=\"vm.issuedDate\" required></md-datepicker><div \nng-messages=\"uploadAccMandiri.issuedDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal harus di isi.\n</span></div></div></md-input-container><md-input-container md-no-float class=\"md-block\"><input type=\"file\" \nid=\"uploadAccMandiri\" nv-file-select required uploader=\"vm.FileUploaderAccMandiri\" \noptions=\"{ formData: [{\n            action: \'uploadijazah\',\n            documentNo: vm.documentNo,\n            empID:vm.empID,\n            typeOfDocument: \'9\',\n            docSeumurhidup:true,\n            expiredDate: \'9999-12-31\',\n            issuedDate: vm.issuedDate,\n            description: \'Akun Bank\'\n          }]}\">\n <small>Max file upload 2Mb</small><md-whiteframe ng-show=\"vm.uploadAccMandiriStateError\" \nclass=\"md-whiteframe-1dp md-red-500-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe ng-show=\"vm.uploadAccMandiriStateSucces\" \nclass=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout layout-align=\"center center\" \nlayout-padding><span>Success Upload data</span></md-whiteframe></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadAccMandiri.$invalid\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/bank/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>View Document</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.dialogClose()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-if=\"vm.doc_type\" class=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\"><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><img style=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" \nsrc=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/address/input-address.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Certificate</span>\n</p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><form name=\"alamatForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveAddress(alamatForm)\"><div \nlayout=\"row\" layout-align=\"end center\"><md-button ng-if=\"!vm.stateEdit\" ng-click=\"vm.ChangeState()\" type=\"button\" \nclass=\"md-raised md-primary btn-ui-serif\" aria-label=\"Submit\"><span translate=\"MYPROFILE.MENU.EDIT\">Edit</span>\n</md-button><md-button ng-if=\"vm.stateEdit\" ng-click=\"vm.ChangeState()\" type=\"button\" \nclass=\"md-raised md-yellow-500-bg white-fg\" aria-label=\"Submit\"><span translate=\"MYPROFILE.MENU.CANCELEDIT\">Cancel Edit\n</span></md-button></div><div layout=\"row\" layout-align=\"space-between center\"><div><md-checkbox \nng-checked=\"vm.checkKTP\" data-ng-readonly=\"true\" ng-true-value=\"\'Sudah Upload KTP\'\" \nng-flase-value=\"\'Belum Upload KTP\'\" ng-disabled=\"!vm.checkKTP\" aria-label=\"Checkbox 1\" readonly=\"readonly\" \nname=\"checkKTP\" ng-required=\"true\"><span ng-if=\"!vm.checkKTP\" style=\"color:#D32F2F; cursor:default\"><span \ntranslate=\"MYPROFILE.MENU.NOTUPLOAD\">Edit</span> *</span> <span ng-if=\"vm.checkKTP\" \nstyle=\"color:#00C853; cursor:default\"><span translate=\"MYPROFILE.MENU.HASUPLOAD\">Edit</span></span></md-checkbox></div>\n<div ng-if=\"vm.stateEdit\"><md-button ng-if=\"!vm.checkKTP\" ng-click=\"vm.Uploadktp($event)\" type=\"button\" \nclass=\"md-raised md-grey-500-bg white-fg\" aria-label=\"Submit\">Upload ID</md-button><md-button ng-if=\"vm.checkKTP\" \nng-click=\"vm.viewDoc($event)\" type=\"button\" class=\"md-raised md-green-300-bg white-fg\" aria-label=\"Submit\">View ID\n</md-button></div></div><div class=\"form-title\"><span translate=\"MYPROFILE.MENU.IDENTITYCARDADDRESS\">\nIdentity Card Address</span></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"MYPROFILE.MENU.IDENTITYCARDADDRESS\">Identity Card Address</span></label><textarea \nng-model=\"vm.Form.objForm.addressKtp\" name=\"addressKtp\" md-maxlength=\"150\" max-rows=\"5\" \nng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required></textarea><div ng-messages=\"alamatForm.addressKtp.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span></span><span translate=\"MYPROFILE.MENU.ADDRESS\">\nAddress</span> <span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\">is Required</span></div><div ng-message=\"md-maxlength\">\n<span>Tidak boleh lebih dari 150 huruf.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.PHONENUMBER\">Phone Number</span>\n</label><input ng-model=\"vm.Form.objForm.phoneKtp\" name=\"phoneKtp\" ng-disabled=\"!vm.stateEdit  || !vm.checkKTP\">\n</md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.POSCODE\">Poscode</span></label>\n<input ng-model=\"vm.Form.objForm.kodePosKtp\" name=\"kodePosKtp\" required ng-disabled=\"!vm.stateEdit  || !vm.checkKTP\">\n<div ng-messages=\"alamatForm.kodePosKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nKode Pos Harus Diisi.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container ng-if=\"vm.country==\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.STATE\">State</span></label>\n<md-select ng-model=\"vm.Form.objForm.provinsiKtp\" ng-change=\"vm.loadKabKtp(vm.Form.objForm.provinsiKtp)\" \nname=\"provinsiKtp\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option ng-repeat=\"prov in vm.listProvince\" \nng-value=\"prov.lokasi_kode\">{{prov.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.provinsiKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.STATE\">State</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.country==\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.CITY\">City</span></label>\n<input ng-model=\"vm.Form.objForm.kabKotaKtp\" name=\"kabKotaKtp\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\"><div \nng-messages=\"alamatForm.kabKotaKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.CITY\">City</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.country!=\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.PROVINCE\">Province</span>\n</label><md-select ng-model=\"vm.Form.objForm.provinsiKtp\" ng-change=\"vm.loadKabKtp(vm.Form.objForm.provinsiKtp)\" \nname=\"provinsiKtp\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option ng-repeat=\"prov in vm.listProvince\" \nng-value=\"prov.lokasi_kode\">{{prov.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.provinsiKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.PROVINCE\">Province</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.country!=\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.CITY\">City</span></label>\n<md-select ng-model=\"vm.Form.objForm.kabKotaKtp\" name=\"kabKotaKtp\" \nng-change=\"vm.loadKecKtp(vm.Form.objForm.kabKotaKtp)\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option \nng-repeat=\"kab in vm.listKabKtp\" ng-value=\"kab.lokasi_kode\">{{kab.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.kabKotaKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.CITY\">City</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.country!=\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.SUBDISTRICT\">SUBDISTRICT\n</span></label><md-select ng-model=\"vm.Form.objForm.kecKtp\" name=\"kecKtp\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" \nrequired><md-option ng-repeat=\"kec in vm.listKecKtp\" ng-value=\"kec.lokasi_kode\">{{kec.lokasi_nama}}</md-option>\n</md-select><div ng-messages=\"alamatForm.kecKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span translate=\"MYPROFILE.MENU.SUBDISTRICT\">Sub-District</span><span> is Required.</span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.country!=\'MYS\'\" flex><label><span \ntranslate=\"MYPROFILE.MENU.VILLAGE\">Village</span></label><input ng-model=\"vm.Form.objForm.kelurahanKtp\" \nname=\"kelurahanKtp\" required ng-disabled=\"!vm.stateEdit || !vm.checkKTP\"><div \nng-messages=\"alamatForm.kelurahanKtp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.VILLAGE\">Village</span><span> is Required.</span></div></div></md-input-container></div><div \nclass=\"form-title\"><span translate=\"MYPROFILE.MENU.CURRENTADDRESS\">Currrent Address</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><md-radio-group ng-model=\"vm.Form.objForm.alamatsekarangdigunakan\" \nng-change=\"vm.alamatsekarang()\" ng-required=\"true\" name=\"alamatsekarangdigunakan\" \nng-disabled=\"!vm.stateEdit || !vm.checkKTP\"><md-radio-button value=\"noktp\" class=\"md-warn md-raised\"><span \ntranslate=\"MYPROFILE.MENU.NOTSAMEWITH\">NOT SAME WITH</span></md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"ktp\" \nclass=\"md-warn md-raised\"><span translate=\"MYPROFILE.MENU.SAMEWITH\">SAME WITH</span></md-radio-button>&nbsp;&nbsp;\n</md-radio-group><div ng-messages=\"alamatForm.alamatsekarangdigunakan.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"MYPROFILE.MENU.SELECTONE\">SELECT ONE</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label><span translate=\"MYPROFILE.MENU.CURRENTADDRESS\">Current Address</span></label><textarea \nng-model=\"vm.Form.objForm.addressCurrent\" name=\"addressCurrent\" md-maxlength=\"150\" max-rows=\"5\" required \nng-disabled=\"!vm.stateEdit || !vm.checkKTP\"></textarea><div ng-messages=\"alamatForm.addressCurrent.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.CURRENTADDRESS\">\nCurrent Address</span><span> is Required.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 150 huruf.</span></div></div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"MYPROFILE.MENU.PHONENUMBER\">Phone Number</span></label><input \nng-model=\"vm.Form.objForm.phoneCurrent\" name=\"phoneCurrent\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\">\n</md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.POSCODE\">Poscode</span></label>\n<input ng-model=\"vm.Form.objForm.kodePosCurrent\" name=\"kodePosCurrent\" required \nng-disabled=\"!vm.stateEdit || !vm.checkKTP\"><div ng-messages=\"alamatForm.kodePosCurrent.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.POSCOODE\">Poscode</span><span>\n is Required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nng-if=\"vm.country==\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.STATE\">State</span></label><md-select \nng-model=\"vm.Form.objForm.provinsiCurrent\" ng-change=\"vm.loadKab(vm.Form.objForm.provinsiCurrent)\" \nname=\"provinsiCurrent\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option \nng-repeat=\"prov in vm.listProvince\" ng-value=\"prov.lokasi_kode\">{{prov.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.provinsiCurrent.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.STATE\">State</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.country==\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.CITY\">City</span></label>\n<input ng-model=\"vm.Form.objForm.kabKotaCurrent\" name=\"kabKotaCurrent\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\"><div\n ng-messages=\"alamatForm.kabKotaCurrent.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.CITY\">City</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.country!=\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.PROVINCE\">Province</span>\n</label><md-select ng-model=\"vm.Form.objForm.provinsiCurrent\" ng-change=\"vm.loadKab(vm.Form.objForm.provinsiCurrent)\" \nname=\"provinsiCurrent\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option \nng-repeat=\"prov in vm.listProvince\" ng-value=\"prov.lokasi_kode\">{{prov.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.provinsiCurrent.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.PROVINCE\">Province</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.country!=\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.CITY\">City</span></label>\n<md-select ng-model=\"vm.Form.objForm.kabKotaCurrent\" name=\"kabKotaCurrent\" \nng-change=\"vm.loadKec(vm.Form.objForm.kabKotaCurrent)\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option \nng-repeat=\"kab in vm.listKab\" ng-value=\"kab.lokasi_kode\">{{kab.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.kabKotaCurrent.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.CITY\">City</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.country!=\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.SUBDISTRICT\">Sub District\n</span></label><md-select ng-model=\"vm.Form.objForm.kecCurrent\" name=\"kecCurrent\" \nng-change=\"vm.loadKel(vm.Form.objForm.kecCurrent)\" ng-disabled=\"!vm.stateEdit || !vm.checkKTP\" required><md-option \nng-repeat=\"kec in vm.listKec\" ng-value=\"kec.lokasi_kode\">{{kec.lokasi_nama}}</md-option></md-select><div \nng-messages=\"alamatForm.kecCurrent.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.SUBDISTRICT\">Sub District</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.country!=\'MYS\'\" flex><label><span translate=\"MYPROFILE.MENU.VILLAGE\">Village</span>\n</label><input ng-model=\"vm.Form.objForm.kelurahanCurrent\" name=\"kelurahanCurrent\" required \nng-disabled=\"!vm.stateEdit || !vm.checkKTP\"><div ng-messages=\"alamatForm.kelurahanCurrent.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.VILLAGE\">Village</span><span>\n is Required.</span></div></div></md-input-container></div><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{ vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><div \nlayout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.stateEdit\" type=\"submit\" \nclass=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\" \nng-disabled=\"alamatForm.$invalid || alamatForm.$pristine\"><span translate=\"MYPROFILE.MENU.UPDATE\">Update</span>\n</md-button></div></form>");
$templateCache.put("app/main/employee/employe/input-employe/address/upload-ktp.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload ID</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>ID No\n</label><input ng-model=\"vm.documentNo\" name=\"documentNo\" required md-maxlength=\"100\"><div \nng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.IDNO\">ID No</span><span> is Required.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 100 huruf.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-inpur-container flex><md-checkbox ng-model=\"vm.seumurhidupChecked\" ng-change=\"vm.isChecked()\" \naria-label=\"Checkbox 1\"></md-checkbox><label><span translate=\"MYPROFILE.MENU.VALIDFORLIFE\">Valid For Life</span>\n</label></md-inpur-container><md-input-container ng-if=\"!vm.seumurhidupChecked\" flex><label><span \ntranslate=\"MYPROFILE.MENU.VALIDFROM\">Valid From</span></label><md-datepicker name=\"issuedDate\" \nmd-hide-icons=\"calendar\" ng-model=\"vm.issuedDate\" required></md-datepicker><div \nng-messages=\"uploadPhoto.issuedDate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DATE\">Date</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"!vm.seumurhidupChecked\" flex><label><span translate=\"MYPROFILE.MENU.VALIDUNTIL\">Valid Until\n</span></label><md-datepicker name=\"expiredDate\" md-hide-icons=\"calendar\" ng-model=\"vm.expiredDate\"></md-datepicker>\n<div ng-messages=\"uploadPhoto.expiredDate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DATE\">Date</span><span> is Required.</span></div></div></md-input-container>\n<md-input-container ng-if=\"vm.seumurhidupChecked\" flex><label><span translate=\"MYPROFILE.MENU.DATEISSUED\">\nDate Issued Identity Card</span></label><md-datepicker name=\"issuedDate\" md-hide-icons=\"calendar\" \nng-model=\"vm.issuedDate\" required></md-datepicker><div ng-messages=\"uploadPhoto.issuedDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MYPROFILE.MENU.DATE\">Date</span><span> is Required.</span></div></div>\n</md-input-container></div><md-input-container md-no-float class=\"md-block\"><label><span \ntranslate=\"MYPROFILE.MENU.DESCRIPTION\">DESCRIPTION</span></label><input ng-model=\"vm.description\" name=\"description\">\n</md-input-container><div class=\"md-block\"><label for=\"uploadPhoto\">Max size 2 MB</label><input type=\"file\" \nid=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadktp\',typeOfDocument:vm.typeOfDocument,documentNo:vm.documentNo,description:vm.description,issuedDate:vm.issuedDate,expiredDate:vm.expiredDate,empID:vm.empID,ktpSeumurHidup:vm.ktpSeumurHidup}] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.fileSizeError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>File size is too large, your file has size {{ vm.itemSize }}</span>\n</md-whiteframe><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Success Upload data</span>\n</md-whiteframe></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span>\n<md-button type=\"button\" ng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid || uploadPhoto.$pristine || vm.sizefile>2097152\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/address/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2><span translate=\"MYPROFILE.MENU.VIEWKTP\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" id=\"contentDialog\" style=\"width: 800px\">\n<md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\">\n<md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip>\n</md-button><iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe>\n</md-dialog-content><md-dialog-content ng-if=\"!vm.doc_type\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<img style=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\">\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/certification/input-certification.html","<md-dialog aria-label=\"Form Input Certification\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"certForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,certForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Certification</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><md-input-container class=\"md-block\"><label><span translate=\"EMP.FORM.CERT.INSTITUTION\"></span>\n</label><input ng-model=\"vm.Form.objForm.institutionName\" required \nplaceholder=\"{{\'EMP.FORM.CERT.INSTITUTION\' | translate}}\"></md-input-container><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"EMP.FORM.CERT.MAJORITY\"></span></label><input \nng-model=\"vm.Form.objForm.majority\" required placeholder=\"{{\'EMP.FORM.CERT.MAJORITY\' | translate}}\">\n</md-input-container><md-input-container flex><label><span translate=\"EMP.FORM.CERT.CERT_NUMBER\"></span></label><input \nng-model=\"vm.Form.objForm.certificationNumber\" required placeholder=\"{{\'EMP.FORM.CERT.CERT_NUMBER\' | translate}}\">\n</md-input-container></div><md-input-container class=\"md-block\"><label><span translate=\"EMP.FORM.CERT.TYPE_OF_CERT\">\n</span></label><input ng-model=\"vm.Form.objForm.typeOfCertification\" required \nplaceholder=\"{{\'EMP.FORM.CERT.TYPE_OF_CERT\' | translate}}\"></md-input-container><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"EMP.FORM.CERT.CERT_DATE\"></span></label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.certificationDate\" required \nplaceholder=\"{{\'EMP.FORM.CERT.CERT_DATE\' | translate}}\"></md-datepicker></md-input-container><md-input-container flex>\n<label><span translate=\"MYPROFILE.MENU.START\"></span></label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.startDate\" name=\"startDate\" required placeholder=\"{{\'MYPROFILE.MENU.START\' | translate}}\">\n</md-datepicker></md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.FINISH\"></span>\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.finishDate\" name=\"finishDate\" required \nplaceholder=\"{{\'MYPROFILE.MENU.END\' | translate}}\"></md-datepicker></md-input-container></div><md-input-container \nmd-no-float class=\"md-block\"><div><input type=\"file\" id=\"uploadPhoto\" name=\"uploadPhoto\" \nng-model=\"vm.Form.objForm.image\" nv-file-select uploader=\"vm.FileUploaderPhoto\" ng-change=\"vm.setUpload($event)\"> <img \nng-src=\"{{imageSrc}}\"> <small>file Size : {{vm.sizefile/1024/1024 | number:2 }} MB of Max file upload 2Mb.</small><div \nng-messages=\"certForm.uploadPhoto.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.sizefile>2097152\"><span>\nMaximum file size 2 MB</span></div></div></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nng-disabled=\"certForm.$invalid || certForm.$pristine || vm.sizefile>2097152\" class=\"md-raised md-accent\" \naria-label=\"Submit\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/certification/list-certification.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Education Certificate\n</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><div class=\"white-bg\"><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputCertification($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button><md-button class=\"md-button md-ink-ripple md-accent md-mini\" \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.listDataSelected.length == 0\" ng-click=\" vm.deleteData($event)\">\n<md-icon ng-if=\"vm.listDataSelected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon \nng-if=\"vm.listDataSelected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.listDataSelected.length > 0\" class=\"red-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span \nng-if=\"vm.listDataSelected.length == 0\" class=\"grey-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span \nstyle=\"color:red\" ng-if=\"vm.listDataSelected.length > 0\">{{ vm.listDataSelected.length }} <span \ntranslate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-green-300-bg md-raised md-primary white-fg\" type=\"button\" \naria-label=\"inputCertification\" ng-click=\"vm.openInputCertification($event)\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon><span translate=\"MYPROFILE.MENU.ADD\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"deleteData\" ng-click=\"vm.deleteData($event)\"><md-icon\n md-font-icon=\"icon-delete\"></md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\">\n<input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EMP.FORM.CERT.INSTITUTION\">Institution</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"EMP.FORM.CERT.MAJORITY\">Majority</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"EMP.FORM.CERT.CERT_NUMBER\">\nCertification Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EMP.FORM.CERT.TYPE_OF_CERT\">Type Of Certification</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"EMP.FORM.CERT.CERT_DATE\">Certification Date</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"EMP.FORM.CERT.DATE\">\nDate</span></div></th><th class=\"text-center\" rowspan=\"2\" width=\"30px\"></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listData\" ng-dblclick=\"vm.editInputCertification($event,div)\" ng-click=\"vm.checkone(div)\"><td \nclass=\"text-center\"><input ng-if=\"!div.source_id\" type=\"checkbox\" checklist-model=\"vm.listDataSelected\" \nchecklist-value=\"div\"></td><td>{{ div.institution_name}}</td><td>{{ div.majority}}</td><td>\n{{ div.certification_number}}</td><td>{{ div.type_of_certification}}</td><td class=\"text-center\">\n{{ div.certification_date}}</td><td class=\"text-center\">{{ div.start_date}}<br>{{ div.finish_date}}</td><td \nclass=\"text-center\"><md-button ng-if=\"div.source_id\" class=\"md-icon-button\" layout=\"row\" aria-label=\"More\" \nng-click=\"vm.viewDetailComponents($event, div)\" style=\"padding: 0; height: 24px\"><md-icon md-font-icon=\"icon-eye\">\n</md-icon><md-tooltip md-direction=\"bottom\">View Detail</md-tooltip></md-button></td></tr><tr class=\"text-center\" \nng-if=\"(vm.listData | typeOf) == \'undefined\'\"><td colspan=\"7\" class=\"text-center\"><span class=\"font-size-12\">\nPlease Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.listData.length <= 0\"><td colspan=\"7\" \nclass=\"text-center\"><span class=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr>\n</tbody></table></div>");
$templateCache.put("app/main/employee/employe/input-employe/dependent/comment-reject.html","<md-dialog aria-label=\"Form Update Finger Data\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"formAbsence\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formAbsence)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.HEADER.TITLE\">Comment Rejected</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout-gt-sm=\"row\" ng-if=\"!vm.stateView\"><md-input-container flex><input type=\"text\" name=\"comment\" \nng-disabled=\"vm.isdisabled\" ng-model=\"vm.Form.objForm.comment\" \nplaceholder=\"{{ \'MENU.CB.APPROVAL_GHK.COMMENT_REJECT.COMMENT\' | translate }}\" required><div \nng-messages=\"formAbsence.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>comment is required.</span>\n</div></div></md-input-container></div><div ng-if=\"vm.stateView\" class=\"alert-info warning italic md-body-1\"><div \nlayout-gt-sm=\"row\"><span>{{vm.Form.objForm.data.reject_comment}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"{{vm.messageTheme}}-400-fg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span><md-button \nng-if=\"!vm.stateView\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"(formAbsence.$invalid || upnormalForm.$pristine) || vm.request\"><span \ntranslate=\"MENU.CB.APPROVAL_GHK.COMMENT_REJECT.ACTION.REJECT\">Reject</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/dependent/edit-dependents.html","<md-dialog aria-label=\"Form Input Dependent\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"keluargaForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,keluargaForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Edit Dependent</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" id=\"contentDialog\"><input type=\"hidden\" name=\"empId\" \nng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" name=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" \nng-if=\"vm.Form.objForm.oldId\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"pt-10\"><md-input-container flex \nflex-gt-sm=\"30\"><label><span translate=\"MYPROFILE.MENU.FAMILITYPE\"></span></label><md-select \nng-model=\"vm.Form.objForm.typeOfFamily\" ng-change=\"vm.familyCheck(vm.Form.objForm.typeOfFamily)\" ng-required=\"true\" \nname=\"typeOfFamily\"><md-option ng-repeat=\"p in vm.keluarga\" ng-value=\"p.id\">{{p.value}}</md-option></md-select><div \nng-messages=\"keluargaForm.typeOfFamily.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.FAMILITYPE\"></span><span> Required.</span></div></div></md-input-container>\n<md-input-container flex flex-offset-gt-sm=\"5\"><label><span translate=\"MYPROFILE.MENU.FULLNAME\"></span></label><input \nng-model=\"vm.Form.objForm.fullname\" name=\"fullname\" required md-maxlength=\"45\"><div \nng-messages=\"keluargaForm.fullname.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.FULLNAME\"></span><span> harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 45 huruf.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex flex-gt-sm=\"20\"><label><span translate=\"MYPROFILE.MENU.GENDER\"></span></label><md-select \nng-model=\"vm.Form.objForm.gender\" name=\"gender\" required><md-option ng-repeat=\"g in vm.gender\" ng-value=\"g.id\"><span \ntranslate=\"EMP.FORM.PROFILE.{{g.name}}\"></span></md-option></md-select><div ng-messages=\"keluargaForm.gender.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.GENDER\"></span><span> Required.</span></div>\n</div></md-input-container><md-input-container flex flex-gt-sm=\"30\" flex-offset-gt-sm=\"5\"><label><span \ntranslate=\"MYPROFILE.MENU.DATEOFBIRTH\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"dateOfBirth\" \nng-model=\"vm.Form.objForm.dateOfBirth\" ng-required=\"vm.isLaw\"></md-datepicker><div \nng-messages=\"keluargaForm.dateOfBirth.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DATEOFBIRTH\"></span><span> Required.</span></div></div></md-input-container>\n<md-input-container flex flex-offset-gt-sm=\"5\"><label><span translate=\"MYPROFILE.MENU.PLACEOFBIRTH\"></span></label>\n<input ng-model=\"vm.Form.objForm.birthPlace\" md-maxlength=\"100\" name=\"birthPlace\"><div \nng-messages=\"keluargaForm.birthPlace.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 100 Character.\n</span></div></div></md-input-container></div><div \nng-if=\"(vm.Form.objForm.typeOfFamily==\'anak\' || vm.Form.objForm.typeOfFamily==\'istri\' || vm.Form.objForm.typeOfFamily==\'suami\') && vm.country==\'IDN\'\" \nlayout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><div layout=\"column\" flex flex-gt-sm=\"40\"><md-input-container \nflex><label>No. {{(vm.Form.objForm.typeOfFamily==\'anak\') ? \'Dokumen SKL\' : \'KTP\'}}</label><input \nng-model=\"vm.Form.objForm.docnumber\" md-maxlength=\"100\" name=\"docnumber\" required><div \nng-messages=\"keluargaForm.docnumber.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 100 Character.</span>\n</div><div ng-message=\"required\"><span>No. {{(vm.Form.objForm.typeOfFamily==\'anak\') ? \'Dokumen SKL\' : \'KTP\'}}</span>\n<span> Required.</span></div></div></md-input-container><md-input-container flex class=\"mt-35\"><label><span>\nTanggal Terbit/Tanggal Tanda Tangan</span></label><md-datepicker md-hide-icons=\"calendar\" name=\"issuedDate\" \nng-model=\"vm.Form.objForm.issuedDate\" required></md-datepicker><div ng-messages=\"keluargaForm.issuedDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tanggal Terbit/Tanggal Tanda Tangan Required.</span></div></div>\n</md-input-container><md-input-container flex \nng-if=\"(vm.Form.objForm.typeOfFamily==\'istri\' || vm.Form.objForm.typeOfFamily==\'suami\') && vm.country==\'IDN\'\"><label>\n<span>Tanggal Expired</span></label><md-datepicker md-hide-icons=\"calendar\" name=\"expiredDate\" \nng-model=\"vm.Form.objForm.expiredDate\" ng-required=\"!vm.ktpSeumurHidup\" ng-disabled=\"vm.ktpSeumurHidup\">\n</md-datepicker><div ng-messages=\"keluargaForm.expiredDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Expired Required.</span></div></div></md-input-container></div><div layout=\"column\" flex-offset-gt-sm=\"5\" \nclass=\"full-width\" layout-align=\"space-between stretch\"><div layout=\"column\"><label for=\"uploadPhoto\">\nDokumen {{(vm.Form.objForm.typeOfFamily==\'anak\') ? \'SKL\' : \'KTP\'}}</label><div layout=\"row\" \nlayout-align=\"center start\"><md-button class=\"md-fab md-mini blue-900-bg\" \nng-click=\"vm.viewDokumen($event,vm.Form.objForm.link)\" title=\"View Dokumen\" aria-label=\"view dokumen\" \nlayout-align=\"center start\" style=\"margin-top: 10px\" ng-disabled=\"!vm.Form.objForm.link\"><md-icon \nclass=\"icon-eye font-size-18 md-background-fg\" style=\"padding-top: 3px\"></md-icon></md-button><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start\" id=\"upload-dependent-wrapper\" flex-offset-gt-sm=\"5\"><label for=\"uploadPhoto\" \nclass=\"mt-15\" flex-gt-sm=\"25\"><small>Max size 2 MB</small></label><div flex layout=\"column\" flex-offset-gt-sm=\"5\">\n<md-input-container flex layout=\"column\" id=\"upload-dependent\"><input \nng-if=\"(vm.Form.objForm.typeOfFamily==\'istri\' || vm.Form.objForm.typeOfFamily==\'suami\') && vm.country==\'IDN\'\" \ntype=\"file\" id=\"uploadPhoto\" name=\"ktp\" nv-file-select uploader=\"vm.FileUpload\" \noptions=\"{ formData: [{\n                          action:\'fileUpload\',\n                          fullname:vm.Form.objForm.fullname,\n                          empId:vm.Form.objForm.empId,\n                          photoAddress:vm.Form.objForm.photoAddress,\n                          typeOfFamily:vm.Form.objForm.typeOfFamily,\n                          issuedDateData:vm.Form.objForm.issuedDate,\n                          expiredDateData:vm.Form.objForm.expiredDate,\n                          dateOfBirth:vm.Form.objForm.dateOfBirth,\n                          birthPlace:vm.Form.objForm.birthPlace,\n                          gender:vm.Form.objForm.gender,\n                          documentNo:vm.Form.objForm.docnumber,\n                          descriptionData:vm.Form.objForm.description,\n                          ktpSeumurHidup:vm.Form.objForm.ktpSeumurHidup\n                        }] }\" \nrequired aria-label=\"upload-ktp\"> <input ng-if=\"vm.Form.objForm.typeOfFamily==\'anak\' && vm.country==\'IDN\'\" type=\"file\" \nid=\"uploadPhoto2\" name=\"skl\" nv-file-select uploader=\"vm.FileUpload\" \noptions=\"{ formData: [{\n                          action:\'fileUpload\',\n                          fullname:vm.Form.objForm.fullname,\n                          empId:vm.Form.objForm.empId,\n                          photoAddress:vm.Form.objForm.photoAddress,\n                          typeOfFamily:vm.Form.objForm.typeOfFamily,\n                          issuedDateData:vm.Form.objForm.issuedDate,\n                          dateOfBirth:vm.Form.objForm.dateOfBirth,\n                          birthPlace:vm.Form.objForm.birthPlace,\n                          gender:vm.Form.objForm.gender,\n                          documentNo:vm.Form.objForm.docnumber,\n                          description:vm.Form.objForm.description\n                        }] }\" \nrequired aria-label=\"upload-skl\"></md-input-container><div class=\"red-500-fg pl-5\" flex layout layout-align=\"start\">\n<span><small>Choose Dokumen {{(vm.Form.objForm.typeOfFamily==\'anak\') ? \'SKL\' : \'KTP\'}}, If want to update it.</small>\n</span></div><div class=\"red-500-fg pl-5\" ng-if=\"vm.uploadError\" flex layout layout-align=\"start\"><span>\n{{ vm.uploadNotif }}</span></div><div class=\"green-600-fg pl-5\" ng-if=\"vm.uploadSuccess\" flex layout \nlayout-align=\"start\"><span>{{ vm.uploadNotif }}</span></div></div></div></div></div><div layout=\"column\">\n<md-input-container flex class=\"mt-0\"><label>Deskripsi</label><input ng-model=\"vm.Form.objForm.description\" \nname=\"description\" placeholder=\"Deskripsi\"></md-input-container><md-input-container class=\"mb-25\" flex \nng-if=\"(vm.Form.objForm.typeOfFamily==\'istri\' || vm.Form.objForm.typeOfFamily==\'suami\') && vm.country==\'IDN\'\">\n<md-checkbox ng-model=\"vm.Form.objForm.ktpSeumurHidup\" ng-change=\"vm.berlakuSeumurHidup()\" style=\"margin-top: 0\">\nBerlaku Seumur Hidup</md-checkbox></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"ms-widget-front\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"keluargaForm.$invalid || keluargaForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/dependent/input-dependent.html","<md-dialog aria-label=\"Form Input Dependent\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"keluargaForm\" \nclass=\"md-inline-form popup-input-form\" novalidate><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Form Input Dependent</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg has-upload\" id=\"contentDialog\"><input type=\"hidden\" \nname=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" name=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" \nng-if=\"vm.Form.objForm.oldId\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"pt-10\"><md-input-container flex \nflex-gt-sm=\"30\"><label><span translate=\"MYPROFILE.MENU.FAMILITYPE\"></span></label><md-select \nng-model=\"vm.Form.objForm.typeOfFamily\" ng-change=\"vm.familyCheck(vm.Form.objForm.typeOfFamily)\" ng-required=\"true\" \nname=\"typeOfFamily\"><md-option ng-repeat=\"p in vm.keluarga\" ng-value=\"p.id\">{{p.value}}</md-option></md-select><div \nng-messages=\"keluargaForm.typeOfFamily.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.FAMILITYPE\"></span><span> Required.</span></div></div></md-input-container>\n<md-input-container flex flex-offset-gt-sm=\"5\"><label><span translate=\"MYPROFILE.MENU.FULLNAME\"></span></label><input \nng-model=\"vm.Form.objForm.fullname\" name=\"fullname\" required md-maxlength=\"45\"><div \nng-messages=\"keluargaForm.fullname.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.FULLNAME\"></span><span> harus di isi.</span></div><div ng-message=\"md-maxlength\"><span>\nTidak boleh lebih dari 45 huruf.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex flex-gt-sm=\"20\"><label><span translate=\"MYPROFILE.MENU.GENDER\"></span></label><md-select \nng-model=\"vm.Form.objForm.gender\" name=\"gender\" required><md-option ng-repeat=\"g in vm.gender\" ng-value=\"g.id\"><span \ntranslate=\"EMP.FORM.PROFILE.{{g.name}}\"></span></md-option></md-select><div ng-messages=\"keluargaForm.gender.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.GENDER\"></span><span> Required.</span></div>\n</div></md-input-container><md-input-container flex flex-gt-sm=\"30\" flex-offset-gt-sm=\"5\"><label><span \ntranslate=\"MYPROFILE.MENU.DATEOFBIRTH\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"dateOfBirth\" \nng-model=\"vm.Form.objForm.dateOfBirth\" ng-required=\"vm.isLaw\"></md-datepicker><div \nng-messages=\"keluargaForm.dateOfBirth.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DATEOFBIRTH\"></span><span> Required.</span></div></div></md-input-container>\n<md-input-container flex flex-offset-gt-sm=\"5\"><label><span translate=\"MYPROFILE.MENU.PLACEOFBIRTH\"></span></label>\n<input ng-model=\"vm.Form.objForm.birthPlace\" md-maxlength=\"100\" name=\"birthPlace\"><div \nng-messages=\"keluargaForm.birthPlace.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 100 Character.\n</span></div></div></md-input-container></div><div \nng-if=\"(vm.Form.objForm.typeOfFamily==\'anak\' || vm.Form.objForm.typeOfFamily==\'istri\' || vm.Form.objForm.typeOfFamily==\'suami\') && vm.country==\'IDN\'\" \nlayout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><div layout=\"column\" flex flex-gt-sm=\"40\"><md-input-container \nflex><label>No. {{(vm.Form.objForm.typeOfFamily==\'anak\') ? \'Dokumen SKL\' : \'KTP\'}}</label><input \nng-model=\"vm.Form.objForm.docnumber\" md-maxlength=\"100\" name=\"docnumber\" required><div \nng-messages=\"keluargaForm.docnumber.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 100 Character.</span>\n</div><div ng-message=\"required\"><span>No. {{(vm.Form.objForm.typeOfFamily==\'anak\') ? \'Dokumen SKL\' : \'KTP\'}}</span>\n<span> Required.</span></div></div></md-input-container><md-input-container flex class=\"mt-35\"><label><span>\nTanggal Terbit/Tanggal Tanda Tangan</span></label><md-datepicker md-hide-icons=\"calendar\" name=\"issuedDate\" \nng-model=\"vm.Form.objForm.issuedDate\" required></md-datepicker><div ng-messages=\"keluargaForm.issuedDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tanggal Terbit/Tanggal Tanda Tangan Required.</span></div></div>\n</md-input-container><md-input-container flex \nng-if=\"(vm.Form.objForm.typeOfFamily==\'istri\' || vm.Form.objForm.typeOfFamily==\'suami\') && vm.country==\'IDN\'\"><label>\n<span>Tanggal Expired</span></label><md-datepicker md-hide-icons=\"calendar\" name=\"expiredDate\" \nng-model=\"vm.Form.objForm.expiredDate\" ng-required=\"!vm.ktpSeumurHidup\" ng-disabled=\"vm.ktpSeumurHidup\">\n</md-datepicker><div ng-messages=\"keluargaForm.expiredDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTanggal Expired Required.</span></div></div></md-input-container></div><div layout=\"column\" flex-offset-gt-sm=\"5\" \nclass=\"full-width\" layout-align=\"space-between stretch\"><div layout=\"column\"><label for=\"uploadPhoto\">\nDokumen {{(vm.Form.objForm.typeOfFamily==\'anak\') ? \'SKL\' : \'KTP\'}}</label><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start\" id=\"upload-dependent-wrapper\"><label for=\"uploadPhoto\" class=\"mt-15\" flex-gt-sm=\"25\"><small>\nMax size 2 MB</small></label><div flex layout=\"column\" flex-offset-gt-sm=\"5\"><md-input-container flex layout=\"column\" \nid=\"upload-dependent\"><input \nng-if=\"(vm.Form.objForm.typeOfFamily==\'istri\' || vm.Form.objForm.typeOfFamily==\'suami\') && vm.country==\'IDN\'\" \nvalidfile type=\"file\" id=\"uploadPhoto\" name=\"ktp\" nv-file-select uploader=\"vm.FileUpload\" \noptions=\"{ formData: [{\n                        action:\'fileUpload\',\n                        fullname:vm.Form.objForm.fullname,\n                        empId:vm.Form.objForm.empId,\n                        photoAddress:vm.Form.objForm.photoAddress,\n                        typeOfFamily:vm.Form.objForm.typeOfFamily,\n                        issuedDateData:vm.Form.objForm.issuedDate,\n                        expiredDateData:vm.Form.objForm.expiredDate,\n                        dateOfBirth:vm.Form.objForm.dateOfBirth,\n                        birthPlace:vm.Form.objForm.birthPlace,\n                        gender:vm.Form.objForm.gender,\n                        documentNo:vm.Form.objForm.docnumber,\n                        descriptionData:vm.Form.objForm.description,\n                        ktpSeumurHidup:vm.Form.objForm.ktpSeumurHidup\n                      }] }\" \nrequired aria-label=\"upload-ktp\"> <input ng-if=\"vm.Form.objForm.typeOfFamily==\'anak\' && vm.country==\'IDN\'\" validfile \ntype=\"file\" id=\"uploadPhoto2\" name=\"skl\" nv-file-select uploader=\"vm.FileUpload\" \noptions=\"{ formData: [{\n                        action:\'fileUpload\',\n                        fullname:vm.Form.objForm.fullname,\n                        empId:vm.Form.objForm.empId,\n                        photoAddress:vm.Form.objForm.photoAddress,\n                        typeOfFamily:vm.Form.objForm.typeOfFamily,\n                        issuedDateData:vm.Form.objForm.issuedDate,\n                        dateOfBirth:vm.Form.objForm.dateOfBirth,\n                        birthPlace:vm.Form.objForm.birthPlace,\n                        gender:vm.Form.objForm.gender,\n                        documentNo:vm.Form.objForm.docnumber,\n                        description:vm.Form.objForm.description\n                      }] }\" \nrequired aria-label=\"upload-skl\"></md-input-container><div class=\"red-500-fg pl-5\" ng-if=\"vm.uploadError\" flex layout \nlayout-align=\"start\"><span>{{ vm.uploadNotif }}</span></div><div class=\"green-600-fg pl-5\" ng-if=\"vm.uploadSuccess\" \nflex layout layout-align=\"start\"><span>{{ vm.uploadNotif }}</span></div><div class=\"red-500-fg pl-5\" \nng-if=\"!keluargaForm.docfile.$valid\" flex layout layout-align=\"start\"><span><small>\n{{(vm.Form.objForm.typeOfFamily==\'anak\') ? \'Scan SKL\' : \'Scan KTP\'}} Required</small></span></div></div></div></div>\n<div layout=\"column\"><md-input-container flex class=\"mt-0\"><label>Deskripsi</label><input \nng-model=\"vm.Form.objForm.description\" name=\"description\" placeholder=\"Deskripsi\"></md-input-container>\n<md-input-container class=\"mb-25\" flex \nng-if=\"(vm.Form.objForm.typeOfFamily==\'istri\' || vm.Form.objForm.typeOfFamily==\'suami\') && vm.country==\'IDN\'\">\n<md-checkbox ng-model=\"vm.Form.objForm.ktpSeumurHidup\" ng-change=\"vm.berlakuSeumurHidup()\" style=\"margin-top: 0\">\nBerlaku Seumur Hidup</md-checkbox></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"ms-widget-front\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"button\" ng-click=\"vm.saveData($event,keluargaForm)\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"keluargaForm.$invalid || keluargaForm.$pristine\">Submit</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/dependent/list-dependent.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Education Certificate\n</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"start-align\"><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputDependent($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADDDEP\"></span></md-button><md-button class=\"md-button md-ink-ripple md-warn md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"MYPROFILE.MENU.DELDEP\"></span></md-button><md-menu \nng-if=\"vm.country==\'IDN\' && vm.status == \'Menikah\'\" class=\"md-white\"><md-button \naria-label=\"Open menu with custom trigger\" class=\"md-button md-ink-ripple md-accent md-mini\" \nng-mouseenter=\"$mdMenu.open()\"><md-icon id=\"icon-ijazah\" md-font-icon=\"icon-file-document\" \nclass=\"md-font icon-archive material-icons\"></md-icon><span ng-mouseenter=\"$mdMenu.open()\">\n{{\'MYPROFILE.MENU.KK\' | translate}}</span></md-button><md-menu-content width=\"4\" ng-mouseleave=\"$mdMenu.close()\">\n<md-menu-item ng-if=\"!vm.doc\"><md-button class=\"md-button md-ink-ripple md-primary md-hue-2\" \nng-click=\"vm.uploadKK($event)\"><md-icon md-font-icon=\"icon-upload\" class=\"md-font icon-archive material-icons\">\n</md-icon>{{ \'ACTION.UPLOAD\' | translate}}</md-button></md-menu-item><md-menu-item ng-if=\"vm.doc\"><md-button \nclass=\"md-button md-ink-ripple md-primary\" ng-click=\"vm.uploadKK($event)\"><md-icon md-font-icon=\"icon-edit\" \nclass=\"md-font icon-archive material-icons\"></md-icon>{{ \'ACTION.EDIT\' | translate}}</md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.doc\"><md-button class=\"md-button md-ink-ripple md-accent\" ng-click=\"vm.viewKK($event)\"><md-icon\n md-font-icon=\"icon-eye\" class=\"md-font icon-archive material-icons\"></md-icon>{{ \'ACTION.VIEW\' | translate}}\n</md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-raised md-primary btn-ui-serif\" type=\"button\" aria-label=\"inputEducation\" \nng-click=\"vm.openInputDependent($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"deleteData\" ng-click=\"vm.deleteData($event)\"><md-icon\n md-font-icon=\"icon-delete\"></md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.country==\'IDN\' && vm.status == \'Menikah\'\"><md-button class=\"md-button md-ink-ripple md-mini\" \ntype=\"button\" aria-label=\"uploadData\" ng-click=\"vm.uploadKK($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon>\nUpload KK</md-button></md-menu-item><md-menu-item ng-if=\"vm.country==\'IDN\' && vm.status == \'Menikah\'\"><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"uploadData\" ng-click=\"vm.viewKK($event)\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon>View KK</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><div class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" \nng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.FAMILITYPE\"></span></span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.NAME\">\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.PLACEOFBIRTH\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"MYPROFILE.MENU.DATEOFBIRTH\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.GENDER\">\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.STATUS\"></span></span></div></th><th class=\"secondary-text\" style=\"width: 100px\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.AKSI\"></span></span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"div in vm.listData\" ng-click=\"vm.checkone(div)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td class=\"text-center\">\n{{ ($index + 1)}}</td><td class=\"text-center text-uppercase\">{{ div.type_of_family}}</td><td>\n{{ div.first_name | uppercase}} {{ div.last_name | uppercase}}</td><td>{{ div.birth_place | uppercase}}</td><td \nclass=\"text-center\">{{ div.date_of_birth}}</td><td class=\"text-center\" translate=\"EMP.FORM.PROFILE.{{div.gender}}\">\n{{ div.gender}}</td><td class=\"text-center\"><span ng-if=\"div.status_approval!==\'Rejected\'\">\n{{div.status_approval | uppercase}}</span> <span ng-if=\"div.status_approval==\'Rejected\'\"><a href=\"\" \nng-click=\"vm.viewComment($event,div)\">{{div.status_approval | uppercase}}</a><md-tooltip md-direction=\"top\"><span \ntranslate=\"MYPROFILE.MENU.COMMENT\"></span></md-tooltip></span></td><td class=\"text-center\"><section layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\" layout-wrap><md-button class=\"md-icon-button\" aria-label=\"Favorite\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.editInputDependent($event,div)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"blue-900-fg\"></md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.viewSkl($event,div)\" ng-disabled=\"!div.link_skl\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip>\n<span>View Document</span></md-tooltip></md-button></section></td></tr><tr class=\"text-center\" \nng-if=\"(vm.listData | typeOf) == \'undefined\'\"><td colspan=\"9\" class=\"text-center\"><span class=\"font-size-12\">\nPlease Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.listData.length <= 0\"><td colspan=\"9\" \nclass=\"text-center\"><span class=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr>\n</tbody></table></div>");
$templateCache.put("app/main/employee/employe/input-employe/dependent/upload-kk.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload Kartu Keluarga</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\"><md-input-container md-no-float class=\"md-block\"><label>No Kartu Keluarga</label>\n<input ng-model=\"vm.Form.objForm.documentNo\" name=\"documentNo\" required md-maxlength=\"100\"><div \nng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Dokumen No harus di isi.\n</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div></div>\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Tanggal Dikeluarkan\n</label><md-datepicker name=\"issuedDate\" ng-change=\"vm.ChangeDate()\" md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.issuedDate\" required></md-datepicker><div ng-messages=\"uploadPhoto.issuedDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tanggal harus di isi.</span></div></div></md-input-container></div><div \nclass=\"md-block\"><label for=\"uploadPhoto\">Max size 2 MB</label><input type=\"file\" id=\"uploadPhoto\" nv-file-select \nrequired uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadkk\',typeOfDocument:vm.Form.objForm.typeOfDocument,documentNo:vm.Form.objForm.documentNo,description:vm.Form.objForm.description,issuedDate:vm.issuedDate,expiredDate:vm.expiredDate,empID:vm.Form.objForm.empID}] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.fileSizeError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>File size is too large, your file has size {{ vm.itemSize }}</span>\n</md-whiteframe><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Success Upload data</span>\n</md-whiteframe></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span>\n<md-button type=\"button\" ng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg md-mini\" \naria-label=\"Submit\" ng-disabled=\"uploadPhoto.$invalid || uploadPhoto.$pristine || vm.sizefile>2097152\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/dependent/upload-surat-keterangan-lahir.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2><span translate=\"ACTION.UPLOAD\"></span> <span translate=\"MYPROFILE.MENU.BIRTHCER\"></span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\"><div class=\"md-block\"><label for=\"uploadPhoto\">Max size 2 MB</label><input \ntype=\"file\" id=\"uploadPhoto\" nv-file-select required uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n            action:\'uploadskl\',\n            empID:vm.Form.objForm.empID,\n            firstName:vm.firstName,\n            lastName:vm.lastName }]\n          }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.fileSizeError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>File size is too large, your file has size {{ vm.itemSize }}</span>\n</md-whiteframe><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Success Upload data</span>\n</md-whiteframe></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span>\n<md-button type=\"button\" ng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"vm.fileSizeError\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon><span \ntranslate=\"ACTION.UPLOAD\"></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/dependent/view-kk.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2><span translate=\"ACTION.VIEW\"></span> <span translate=\"MYPROFILE.MENU.KK\"></span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg has-upload\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/dependent/view-skl.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2><span translate=\"MYPROFILE.MENU.BIRTHCER\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg has-upload\" id=\"contentDialog\" \nstyle=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" \nframeborder=\"0\"></iframe></md-dialog-content><md-dialog-content ng-if=\"!vm.doc_type\"><md-button \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<img style=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\">\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/education/input-education.html","<md-dialog aria-label=\"Form Input Education\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"eduForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,eduForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MYPROFILE.MENU.EDUCATIONFORM\">\nEDUCATION FORM</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input \ntype=\"hidden\" name=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout-gt-sm=\"row\">\n<md-autocomplete flex md-no-cache=\"vm.noCache\" md-selected-item=\"vm.schoolID\" \nmd-search-text=\"vm.Form.objForm.schoolName\" md-search-text-change=\"vm.searchTextChange(vm.schoolID)\" \nmd-selected-item-change=\"vm.selectedItemChanged(item)\" md-items=\"item in vm.getUniversity(vm.Form.objForm.schoolName)\" \nmd-min-length=\"3\" md-input-name=\"schoolID\" md-item-text=\"item.schoolName\" required \nmd-floating-label=\"{{ \'MYPROFILE.MENU.SCHOOLNAME\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"vm.Form.objForm.schoolName\">{{item.schoolName}}</span></md-item-template></md-autocomplete>\n<md-input-container flex><label><span translate=\"MYPROFILE.MENU.MAJORS\">MAJORS</span></label><md-select \nname=\"majority\" ng-model=\"vm.Form.objForm.majority\" required><md-option ng-repeat=\"p in vm.jurusan\" \nng-value=\"p.description\">{{p.description}}</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"MYPROFILE.MENU.LEVELEDUCATION\">LEVEL EDUCATION</span></label>\n<md-select ng-model=\"vm.Form.objForm.pendidikan\" name=\"pendidikan\" \nng-change=\"vm.changeRequired(vm.Form.objForm.pendidikan)\" required><md-option ng-repeat=\"p in vm.pendidikan\" \nng-value=\"p\">{{p}}</md-option></md-select><div ng-messages=\"eduForm.pendidikan.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MYPROFILE.MENU.LEVELEDUCATION\">LEVEL EDUCATION</span><span \ntranslate=\"MYPROFILE.MESSAGE.ISREQUIRED\"> is Required</span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"MYPROFILE.MENU.YEARENTRY\">YEAR ENTRY</span></label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.startStudy\" required></md-datepicker><div ng-messages=\"eduForm.startStudy.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.YEARENTRY\">YEAR ENTRY</span><span \ntranslate=\"MYPROFILE.MESSAGE.ISREQUIRED\"> is Required</span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"MYPROFILE.MENU.GRAYEAR\">YEAR ENTRY</span></label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.finishStudy\" required></md-datepicker><div ng-messages=\"eduForm.finishStudy.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.GRAYEAR\">YEAR ENTRY</span><span \ntranslate=\"MYPROFILE.MESSAGE.ISREQUIRED\"> is Required</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.FINALSCORE\">FINALSCORE</span>\n</label><input type=\"number\" name=\"finalGrade\" ng-model=\"vm.Form.objForm.finalGrade\" required><div \nng-messages=\"eduForm.finalGrade.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.FINALSCORE\">FINALSCORE</span><span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"> is Required\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.MAJOR\">MAJOR\n</span></label><input ng-model=\"vm.Form.objForm.eduTitle\" name=\"eduTitle\" ng-required=\"vm.required\"><div \nng-messages=\"eduForm.eduTitle.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.MAJOR\">\nMAJOR</span><span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"> is Required</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"false\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{ vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"eduForm.$invalid || eduForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/education/list-education.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Certificate</span>\n</p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputEducation($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button><md-button class=\"md-button md-ink-ripple md-warn md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button><md-button ng-if=\"vm.doc==\'\'\" \nclass=\"md-button md-ink-ripple md-primary md-hue-2 md-mini\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.uploadIjazah($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.UPCERTIFICATE\">Upload Certificate</span></md-button><md-button \nclass=\"md-button md-ink-ripple md-accent md-mini\" type=\"button\" hide show-gt-sm aria-label=\"Inert\" \nng-click=\"vm.viewIjazah($event)\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.DWCERTIFICATE\">Download Certificate</span></md-button><md-menu md-offset=\"0 -7\" hide-gt-sm>\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"inputEducation\" \nng-click=\"vm.openInputEducation($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"deleteData\" ng-click=\"vm.deleteData($event)\"><md-icon\n md-font-icon=\"icon-delete\"></md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"uploadData\" \nng-click=\"vm.uploadIjazah($event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon>Upload Ijazah</md-button>\n</md-menu-item><md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"uploadData\" \nng-click=\"vm.uploadIjazah($event)\"><md-icon md-font-icon=\"icon-download\"></md-icon>Download Ijazah</md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-toolbar><div class=\"white-bg\"><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.NO\"></span></span></div></th><th \nclass=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.SCHOOLNAME\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"MYPROFILE.MENU.DEPARTMENT\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.MAJORITY\">\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.FINALSCORE\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Title</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"MYPROFILE.MENU.STARTSTUDY\"></span></span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.FINISHSTUDY\"></span></span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.STATUS\"></span></span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listData\" \nng-dblclick=\"vm.editInputEducation($event,div)\" ng-click=\"vm.checkone(div)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td>{{ ($index + 1)}}</td><td>\n{{ div.school_name}}</td><td>{{ div.department}}</td><td>{{ div.majority}}</td><td>{{ div.final_grade}}</td><td>\n{{ div.title}}</td><td>{{ div.start_study}}</td><td>{{ div.finish_study}}</td><td><span \nng-if=\"div.status_approval!==\'Rejected\'\">{{div.status_approval | uppercase}}</span> <span \nng-if=\"div.status_approval==\'Rejected\'\"><a href=\"\" ng-click=\"vm.viewComment($event,div)\">\n{{div.status_approval | uppercase}}</a><md-tooltip md-direction=\"top\"><span translate=\"MYPROFILE.MENU.COMMENT\"></span>\n</md-tooltip></span></td></tr><tr class=\"text-center\" ng-if=\"(vm.listData | typeOf) == \'undefined\'\"><td colspan=\"10\" \nclass=\"text-center\"><span class=\"font-size-12\">Please Wait</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.listData.length <= 0\"><td colspan=\"10\" class=\"text-center\"><span class=\"font-size-12\" \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></div>");
$templateCache.put("app/main/employee/employe/input-employe/education/upload-ijazah.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2><span translate=\"MYPROFILE.MENU.UPCERTIFICATE\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-input-container md-no-float class=\"md-block\"><label><span translate=\"MYPROFILE.MENU.CERTNUMBER\"></span></label>\n<input ng-model=\"vm.Form.objForm.documentNo\" name=\"documentNo\" required placeholder=\"ID No\" md-maxlength=\"100\"><div \nng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.CERTNUMBER\"></span><span translate=\"MYPROFILE.MESSAGE.ISREQUIRED\"> is Required</span></div>\n<div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div></div></md-input-container><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.DATEISSUEDD\"></span>\n</label><md-datepicker name=\"issuedDate\" ng-change=\"vm.ChangeDate()\" md-hide-icons=\"calendar\" \nng-model=\"vm.Form.objForm.issuedDate\" required></md-datepicker><div ng-messages=\"uploadPhoto.issuedDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.DATEISSUEDD\"></span><span \ntranslate=\"MYPROFILE.MESSAGE.ISREQUIRED\"> is Required</span></div></div></md-input-container></div><md-input-container \nmd-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select required \nuploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadijazah\',typeOfDocument:vm.Form.objForm.typeOfDocument,documentNo:vm.Form.objForm.documentNo,description:vm.Form.objForm.description,issuedDate:vm.issuedDate,empID:vm.Form.objForm.empID}] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex \nlayout layout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span><md-button \ntype=\"button\" ng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid || uploadPhoto.$pristine\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\">\n</md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/education/view-ijazah.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View Ijazah</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><img style=\"margin: auto; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\"></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/document/edit-document.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"editDocuments\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Edit Dokumen</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nid=\"contentDialog\"><div layout=\"column\" style=\"margin-top:20px !important\" layout-padding layout-gt-sm=\"row\">\n<md-input-container flex class=\"md-block\"><label><span translate=\"MYPROFILE.MENU.DOCTYPE\"></span></label><input \nreadonly=\"readonly\" name=\"typeOfDocument\" type=\"text\" ng-model=\"vm.payload.typeOfDocuments|translate\"><div \nng-messages=\"editDocuments.typeOfDocuments.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DOCTYPE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex md-no-float class=\"md-block\"><label><span \ntranslate=\"MYPROFILE.MENU.DOCNO\"></span></label><input ng-model=\"vm.payload.documentNo\" name=\"documentNo\" \nplaceholder=\"Dokumen No\" md-maxlength=\"100\"><div ng-messages=\"editDocuments.documentNo.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MYPROFILE.MENU.DOCNO\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div></div>\n</md-input-container><md-input-container md-no-float flex class=\"md-block\" ng-if=\"!vm.hideExpiredDate\"><label><span \ntranslate=\"MYPROFILE.MENU.VALIDPERIOD\"></span></label><md-datepicker ng-disabled=\"true\" name=\"expiredDate\" \nmd-hide-icons=\"calendar\" ng-model=\"vm.expiredDate\"></md-datepicker><div ng-messages=\"editDocuments.expiredDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.VALIDPERIOD\"></span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex md-no-float \nclass=\"md-block\"><label><span translate=\"MYPROFILE.MENU.NOTE\"></span></label><input ng-disabled=\"true\" \nng-model=\"vm.payload.description\" name=\"description\" placeholder=\"Description\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><md-button type=\"button\" \nng-click=\"vm.updateData($event, editDocuments)\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"editDocuments.$invalid || editDocuments.$pristine\">Update</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/document/input-document.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MYPROFILE.MENU.INPUTDOC\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg has-upload\"><div layout=\"column\" layout-padding><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float class=\"md-block\" flex><label><span \ntranslate=\"MYPROFILE.MENU.DOCTYPE\"></span></label><md-select placeholder=\"{{\'MYPROFILE.MENU.DOCTYPE\' | translate}}\" \nname=\"typeOfDocument\" ng-model=\"vm.Form.objForm.typeOfDocument\" ng-change=\"vm.changeTypeDoc()\" required><md-option \nng-repeat=\"doc in vm.listDoc\" ng-if=\"doc.id !=3 && doc.id !=4\" ng-value=\"doc.id\">{{doc.typename}}</md-option>\n</md-select><div ng-messages=\"uploadPhoto.typeOfDocument.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DOCTYPE\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.reqno\"><md-input-container md-no-float \nclass=\"md-block\" flex><label><span translate=\"MYPROFILE.MENU.DOCNO\"></span></label><input \nplaceholder=\"{{ \'MYPROFILE.MENU.DOCNO\' | translate}}\" ng-model=\"vm.Form.objForm.documentNo\" name=\"documentNo\" required \nmd-maxlength=\"100\"><div ng-messages=\"uploadPhoto.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.DOCNO\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div><div \nng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"!vm.docSeumurhidup\"><md-input-container md-no-float class=\"md-block\" flex>\n<label><span translate=\"MYPROFILE.MENU.VALIDPERIOD\"></span></label><md-datepicker name=\"expiredDate\" \nmd-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.expiredDate\" md-min-date=\"vm.minDate\" \nplaceholder=\"{{ \'MYPROFILE.MENU.VALIDPERIOD\' | translate}}\" required></md-datepicker><div \nng-messages=\"uploadPhoto.expiredDate.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.VALIDPERIOD\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float class=\"md-block\" \nflex><label><span translate=\"MYPROFILE.MENU.NOTE\"></span></label><input ng-model=\"vm.Form.objForm.description\" \nname=\"description\" required placeholder=\"{{ \'MYPROFILE.MENU.NOTE\' | translate}}\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.Form.objForm.typeOfDocument == 14\"><md-input-container md-no-float \nclass=\"md-block\" flex><label><span translate=\"MYPROFILE.MENU.CHILD\"></span></label><md-select \nplaceholder=\"{{ \'MYPROFILE.MENU.CHILD\' | translate}}\" name=\"childs\" ng-model=\"vm.Form.objForm.child\" required>\n<md-option ng-repeat=\"ch in vm.dependents\" ng-value=\"ch.id\">{{ch.first_name}} {{ch.last_name}}</md-option></md-select>\n<div ng-messages=\"uploadPhoto.childs.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.CHILD\"></span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div>\n</md-input-container></div><div class=\"md-block\"><label for=\"uploadPhoto\">Max size 2 MB</label><input type=\"file\" \nid=\"uploadPhoto\" nv-file-select uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadijazah\',typeOfDocument:vm.Form.objForm.typeOfDocument,documentNo:vm.Form.objForm.documentNo,description:vm.Form.objForm.description,expiredDate:vm.Form.objForm.expiredDate,empID:vm.Form.objForm.empId, docSeumurhidup:vm.docSeumurhidup,issuedDate:vm.Form.objForm.issuedDate}] }\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.fileSizeError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>File size is too large, your file has size {{ vm.itemSize }}</span>\n</md-whiteframe><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Success Upload data</span>\n</md-whiteframe></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex>\n</span><md-button type=\"button\" ng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadPhoto.$invalid || uploadPhoto.$pristine || vm.fileSizeError\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"teal-50-fg\"></md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/document/list-document.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Certificate</span>\n</p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><div class=\"white-bg\"><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputEducation($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button><md-button class=\"md-button md-ink-ripple md-warn md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"inputDocument\" \nng-click=\"vm.openInputEducation($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"deleteData\" ng-click=\"vm.deleteData($event)\"><md-icon\n md-font-icon=\"icon-delete\"></md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\">\n<input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.NO\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"MYPROFILE.MENU.DOCTYPE\"></span></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.DOCNO\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.VALIDPERIOD\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"MYPROFILE.MENU.NOTE\"></span></span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">View</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listData\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" \nchecklist-value=\"div\"></td><td class=\"text-center\">{{ ($index + 1)}}</td><td>{{ div.typenames | translate}}</td><td>\n{{ div.documentNo}}</td><td><span ng-if=\"div.expired_date ==\'9999-12-31\'\" translate=\"MYPROFILE.MENU.LIFETIME\"></span> \n<span ng-if=\"div.expired_date !==\'9999-12-31\'\">{{ div.expired_date}}</span></td><td>{{ div.description}}</td><td>\n<section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap><md-button class=\"md-icon-button\" \nng-if=\"div.allowEdit\" aria-label=\"Favorite\" style=\"padding: 0;height: 24px;width: 24px\" \nng-click=\"vm.editDocumen($event,div)\"><md-icon md-font-icon=\"icon-pencil\" class=\"blue-900-fg\"></md-icon><md-tooltip>\nEdit</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-if=\"div.typename != \'JAMSOSTEK\' && div.typename != \'BPJS\'\" aria-label=\"Favorite\" \nstyle=\"padding: 0;height: 24px;width: 24px\" ng-click=\"vm.viewDokumen($event,div.link)\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><md-tooltip><span>View Document</span></md-tooltip></md-button></section></td></tr>\n<tr class=\"text-center\" ng-if=\"(vm.listData | typeOf) == \'undefined\'\"><td colspan=\"7\" class=\"text-center\"><span \nclass=\"font-size-12\">Please Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.listData.length <= 0\"><td \ncolspan=\"7\" class=\"text-center\"><span class=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span>\n</td></tr></tbody></table></div>");
$templateCache.put("app/main/employee/employe/input-employe/document/view-document.html","<md-dialog aria-label=\"view data document\" flex=\"50\" class=\"md-inline-form popup-input-form\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>View Documents</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\"><md-button ng-if=\"vm.trusted && !vm.loading\" class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\" style=\"margin-top: 8px\"><md-icon \nclass=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">Download this image</md-tooltip></md-button>\n<iframe ng-if=\"vm.trusted && !vm.loading\" src=\"{{vm.url}}\" style=\"width:100%; height:70vh; display:block\" \nframeborder=\"0\"></iframe><img ng-if=\"!vm.trusted && !vm.loading\" style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/document-not-found.png\"> <img ng-if=\"!vm.trusted && vm.loading\" \nstyle=\"margin: auto; display:block; max-width: 100%\" alt=\"Lush mango tree\" src=\"api/empdocument/document-loading.png\">\n</md-dialog-content><md-dialog-content ng-if=\"!vm.doc_type\"><md-button \nng-if=\"vm.doc != \'/document-not-found.png\' && vm.trusted && !vm.loading\" \nclass=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\" \nstyle=\"margin-top: 8px\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\" on-error-src=\"api/empdocument/document-not-found.png\">\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/emergency/input-emergency.html","<md-dialog aria-label=\"Form Input Emergency Contact\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"infoForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,infoForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2><span translate=\"MYPROFILE.MENU.EMERGENCYCONTACT\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" id=\"contentDialog\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input \ntype=\"hidden\" name=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"MYPROFILE.MENU.FULLNAME\"></span></label><input ng-model=\"vm.fullname\" \nname=\"fullname\" required md-maxlength=\"45\"><div ng-messages=\"infoForm.fullname.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MYPROFILE.MENU.FULLNAME\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\">\n</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 45 huruf.</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"MYPROFILE.MENU.PHONENUMBER\"></span></label><input ng-model=\"vm.Form.objForm.phoneNumber\" name=\"phoneNumber\" \nrequired placeholder=\"{{\'MYPROFILE.MENU.PHONENUMBER\' | translate }}\"><div ng-messages=\"infoForm.phoneNumber.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.PHONENUMBER\"></span><span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"MYPROFILE.MENU.FAMILITYPE\"></span></label><input ng-model=\"vm.Form.objForm.typeOfFamily\" \nname=\"typeOfFamily\" required placeholder=\"{{\'MYPROFILE.MENU.FAMILITYPE\' | translate}}\"><div \nng-messages=\"infoForm.typeOfFamily.$error\" role=\"alert\"><div ng-message=\"required\"><span><span \ntranslate=\"MYPROFILE.MENU.FAMILITYPE\"></span></span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label><span translate=\"MYPROFILE.MENU.ADDRESS\"></span></label><textarea \nng-model=\"vm.Form.objForm.address\" md-maxlength=\"250\" max-rows=\"5\" required></textarea><div \nng-messages=\"infoForm.address.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.ADDRESS\"></span><span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div><div \nng-message=\"md-maxlength\"><span>Max 250 Character.</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"infoForm.$invalid || infoForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/emergency/list-emergency.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Certificate</span>\n</p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><div class=\"white-bg\"><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputEmergency($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button><md-button class=\"md-button md-ink-ripple md-warn md-mini\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"inputEducation\" \nng-click=\"vm.openInputEmergency($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"deleteData\" ng-click=\"vm.deleteData($event)\"><md-icon\n md-font-icon=\"icon-delete\"></md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"text-center\" width=\"5%\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.NAME\">\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.ADDRESS\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"MYPROFILE.MENU.PHONENUMBER\"></span></span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.FAMILITYPE\"></span></span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"div in vm.listData\" ng-dblclick=\"vm.editInputEmergency($event,div)\" \nng-click=\"vm.checkone(div)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" \nchecklist-value=\"div\"></td><td>{{ div.first_name | uppercase}} {{ div.last_name | uppercase}}</td><td>{{ div.address}}\n</td><td class=\"text-center\">{{ div.phone_number}}</td><td>{{ div.type_of_family}}</td></tr><tr class=\"text-center\" \nng-if=\"(vm.listData | typeOf) == \'undefined\'\"><td colspan=\"5\" class=\"text-center\"><span class=\"font-size-12\">\nPlease Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.listData.length <= 0\"><td colspan=\"5\" \nclass=\"text-center\"><span class=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr>\n</tbody></table></div>");
$templateCache.put("app/main/employee/employe/input-employe/experience/input-experience.html","<md-dialog aria-label=\"Form Input Experience\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"expForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,expForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Experience</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" \nname=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><md-input-container class=\"md-block\">\n<label><span translate=\"MYPROFILE.MENU.COMPANYNAME\"></span></label><input ng-model=\"vm.Form.objForm.companyName\" \nname=\"companyName\" required placeholder=\"Company Name\" md-maxlength=\"150\"><div \nng-messages=\"expForm.companyName.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Name Required.</span>\n</div><div ng-message=\"md-maxlength\"><span>Max 150 huruf.</span></div></div></md-input-container><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.DEPARTMENTNAME\"></span></label>\n<input ng-model=\"vm.Form.objForm.departmentName\" name=\"departmentName\" required placeholder=\"Department\" \nmd-maxlength=\"150\"><div ng-messages=\"expForm.departmentName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment Required.</span></div><div ng-message=\"md-maxlength\"><span>Max 150 huruf.</span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.SECTIONNAME\"></span></label><input\n ng-model=\"vm.Form.objForm.sectionName\" name=\"sectionName\" required placeholder=\"Section\" md-maxlength=\"150\"><div \nng-messages=\"expForm.sectionName.$error\" role=\"alert\"><div ng-message=\"required\"><span>Section Required.</span></div>\n<div ng-message=\"md-maxlength\"><span>Max 150 huruf.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label><span translate=\"MYPROFILE.MENU.JOBDESC\"></span></label><textarea \nng-model=\"vm.Form.objForm.jobDescription\" required placeholder=\"Job Description\" md-maxlength=\"250\" max-rows=\"5\">\n</textarea><div ng-messages=\"expForm.jobDescription.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Job Descrption Required.</span></div><div ng-message=\"md-maxlength\"><span>Max 250 huruf.\n</span></div></div></md-input-container><div layout-gt-sm=\"row\"><md-input-container flex><label><span \ntranslate=\"MYPROFILE.MENU.START\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"startDate\" \nng-model=\"vm.Form.objForm.startDate\" required></md-datepicker></md-input-container><md-input-container flex><label>\n<span translate=\"MYPROFILE.MENU.FINISH\"></span></label><md-datepicker md-hide-icons=\"calendar\" name=\"finishDate\" \nng-model=\"vm.Form.objForm.finishDate\" required></md-datepicker></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"expForm.$invalid || expForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/experience/list-experience.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Certificate</span>\n</p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><div class=\"white-bg\"><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputExperience($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button><md-button class=\"md-button md-ink-ripple md-accent md-mini\" \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.listDataSelected.length == 0\" ng-click=\" vm.deleteData($event)\">\n<md-icon ng-if=\"vm.listDataSelected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon \nng-if=\"vm.listDataSelected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.listDataSelected.length > 0\" class=\"red-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span \nng-if=\"vm.listDataSelected.length == 0\" class=\"grey-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span \nstyle=\"color:red\" ng-if=\"vm.listDataSelected.length > 0\">{{ vm.listDataSelected.length }} <span \ntranslate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"inputExperience\" \nng-click=\"vm.openInputExperience($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"deleteData\" ng-click=\"vm.deleteData($event)\"><md-icon\n md-font-icon=\"icon-delete\"></md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\">\n<input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.NO\"></span></span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.COMPANYNAME\"></span></span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.DEPARTMENTNAME\"></span></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.SECTIONNAME\"></span></span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.JOBDESC\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"MYPROFILE.MENU.START\"></span></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.FINISH\"></span></span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"div in vm.listData\" ng-dblclick=\"vm.editInputExperience($event,div)\" \nng-click=\"vm.checkone(div)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" \nchecklist-value=\"div\"></td><td class=\"text-center\">{{ ($index + 1)}}</td><td>{{ div.company_name}}</td><td>\n{{ div.department_name}}</td><td>{{ div.section_name}}</td><td>{{ div.job_description}}</td><td class=\"text-center\">\n{{ div.start_date}}</td><td class=\"text-center\">{{ div.finish_date}}</td></tr><tr class=\"text-center\" \nng-if=\"(vm.listData | typeOf) == \'undefined\'\"><td colspan=\"8\" class=\"text-center\"><span class=\"font-size-12\">\nPlease Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.listData.length <= 0\"><td colspan=\"8\" \nclass=\"text-center\"><span class=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr>\n</tbody></table></div>");
$templateCache.put("app/main/employee/employe/input-employe/employement/change-nik.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"employementForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,employementForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Form Change NIK</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\">\n</md-progress-linear><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><input type=\"hidden\" name=\"empId\" \nng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" name=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" \nng-if=\"vm.Form.objForm.oldId\"><div layout-gt-sm=\"row\"><md-input-container flex><label>Old NIK</label><input \nng-model=\"vm.Form.objForm.oldNik\" ng-disabled=\"vm.nik\" md-maxlength=\"8\" name=\"nik\" required><div \nng-messages=\"employementForm.oldNik.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 8 Character.</span>\n</div><div ng-message=\"required\"><span>Employee NIK Required.</span></div></div></md-input-container>\n<md-input-container flex><label>New NIK</label><input ng-model=\"vm.Form.objForm.newNik\" md-maxlength=\"8\" name=\"newNik\" \nrequired><div ng-messages=\"employementForm.newNik.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>\nMax 8 Character.</span></div><div ng-message=\"required\"><span>Direct Report Required.</span></div></div>\n</md-input-container><md-input-container flex><label>Effective Date New Nik</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"effectiveDate\" ng-model=\"vm.Form.objForm.effectiveDate\" required></md-datepicker><div \nng-messages=\"employementForm.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex>\n<label>Employee Type</label><md-select ng-model=\"vm.Form.objForm.type\" name=\"empType\" required><md-option \nng-repeat=\"g in vm.employeType\" ng-value=\"g\">{{g | uppercase}}</md-option></md-select><div \nng-messages=\"employementForm.empType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employe Type Required.\n</span></div></div></md-input-container><md-input-container flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"startDate\" ng-model=\"vm.Form.objForm.startDate\" required></md-datepicker><div \nng-messages=\"employementForm.startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Date Required.\n</span></div></div></md-input-container><md-input-container flex ng-if=\"vm.Form.objForm.type==\'permanent\'\"><label>\nNo. SK</label><input ng-model=\"vm.Form.objForm.noSK\" name=\"noSK\" required><div \nng-messages=\"employementForm.noSK.$error\" role=\"alert\"><div ng-message=\"required\"><span>No. SK Date Required.</span>\n</div></div></md-input-container><md-input-container flex ng-if=\"vm.Form.objForm.type==\'contract\'\"><label>End Date\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"endDate\" ng-model=\"vm.Form.objForm.endDate\" required>\n</md-datepicker><div ng-messages=\"employementForm.endDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnd Date Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex \nng-if=\"vm.gw\"><md-checkbox class=\"no-label\" ng-model=\"vm.Form.objForm.isStaff\">Update to Staff</md-checkbox>\n</md-input-container></div><div ng-if=\"vm.Form.objForm.isStaff\"><div layout-gt-sm=\"row\"><md-input-container flex>\n<label>Employee Grade</label><md-select ng-model=\"vm.Form.objForm.empGrade\" \nng-change=\"vm.getLevelCategory(vm.Form.objForm.empGrade)\" name=\"empGrade\" required><md-option \nng-repeat=\"g in vm.grade\" ng-value=\"g\">{{g}}</md-option></md-select><div ng-messages=\"employementForm.empGrade.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Employee Grade Required.</span></div></div></md-input-container>\n<md-input-container class=\"md-icon-float\" flex flex-offset-gt-xs=\"5\"><label>Direct Report</label><input type=\"text\" \nng-model=\"vm.Form.objForm.directReportName\" name=\"directReport\" ng-disabled=\"true\"> <input type=\"hidden\" \nng-model=\"vm.Form.objForm.directReport\" name=\"directReport\" required><md-icon class=\"name\" \nng-click=\"vm.lookupEmployee($event)\"><i class=\"icon icon-account-search blue-600-fg\"></i></md-icon><div \nng-messages=\"employementForm.directReport.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 8 Character.\n</span></div><div ng-message=\"required\"><span>Direct Report Required.</span></div></div></md-input-container></div><div\n layout-gt-sm=\"row\"><md-input-container class=\"md-icon-float\" flex><label>Job Title</label><input type=\"text\" \nng-model=\"vm.Form.objForm.jobTitleName\" ng-disabled=\"true\" name=\"jobTitle\"> <input type=\"hidden\" \nng-model=\"vm.Form.objForm.jobTitle\" name=\"jobTitle\" required><md-icon class=\"jobTitle\" \nng-click=\"vm.lookupJobTitle($event)\"><i class=\"icon icon-account-search blue-600-fg\"></i></md-icon><div \nng-messages=\"employementForm.jobTitle.$error\" role=\"alert\"><div ng-message=\"required\"><span>Job Title Required.</span>\n</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.isLayerOverlap\" class=\"fade\"><ms-widget-front \nclass=\"p-7 amber-400-bg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\">\n</md-icon>Employee setup more than manpower target, org layer will be overlapping</p></ms-widget-front></ms-widget>\n<span flex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"employementForm.$invalid || employementForm.$pristine\">Save</md-button><md-button \nng-click=\"vm.setToken()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Refresh Form</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/employement/input-employement.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\"><form ng-cloack name=\"employementForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,employementForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Job</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\" \nstyle=\"overflow-x: hidden\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" \nname=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Employee NIK</label><input ng-model=\"vm.Form.objForm.nik\" ng-disabled=\"vm.nik\" \nmd-maxlength=\"8\" name=\"nik\" required><div ng-messages=\"employementForm.nik.$error\" role=\"alert\"><div \nng-message=\"md-maxlength\"><span>Max 8 Character.</span></div><div ng-message=\"required\"><span>Employee NIK Required.\n</span></div></div></md-input-container><md-input-container flex flex-offset-gt-xs=\"5\"><label>Hire Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"hiredate\" ng-disabled=\"vm.hiredate\" ng-model=\"vm.Form.objForm.hiredate\" \nrequired></md-datepicker><div ng-messages=\"employementForm.hiredate.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Hire Date Date Required.</span></div></div></md-input-container><md-input-container flex flex-offset-gt-xs=\"5\">\n<label>Effective Join Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"Joint Date\" ng-disabled=\"vm.jointdate\" \nng-model=\"vm.Form.objForm.jointdate\" required></md-datepicker><div ng-messages=\"employementForm.jointdate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Joint Date Required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><div layout=\"row\" flex flex-gt-xs=\"35\"><md-input-container flex><label>\nEffective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effectiveDate\" \nng-model=\"vm.Form.objForm.effectiveDate\" required></md-datepicker><div \nng-messages=\"employementForm.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date Required.</span></div></div></md-input-container></div><md-input-container class=\"md-icon-float\" flex \nflex-offset-gt-xs=\"5\"><label>Direct Report</label><input type=\"text\" ng-model=\"vm.Form.objForm.directReportName\" \nname=\"directReport\" ng-disabled=\"true\"> <input type=\"hidden\" ng-model=\"vm.Form.objForm.directReport\" \nname=\"directReport\" required><md-icon class=\"name\" ng-click=\"vm.lookupEmployee($event)\"><i \nclass=\"icon icon-account-search blue-600-fg\"></i></md-icon><div ng-messages=\"employementForm.directReport.$error\" \nrole=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 8 Character.</span></div><div ng-message=\"required\"><span>\nDirect Report Required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-icon-float\" flex><label>Job Title</label><input type=\"text\" \nng-model=\"vm.Form.objForm.jobTitleName\" ng-disabled=\"true\" name=\"jobTitle\"> <input type=\"hidden\" \nng-model=\"vm.Form.objForm.jobTitle\" name=\"jobTitle\" required><md-icon class=\"jobTitle\" \nng-click=\"vm.lookupJobTitle($event)\"><i class=\"icon icon-account-search blue-600-fg\"></i></md-icon><div \nng-messages=\"employementForm.jobTitle.$error\" role=\"alert\"><div ng-message=\"required\"><span>Job Title Required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nEmployee Grade</label><md-select ng-model=\"vm.Form.objForm.empGrade\" \nng-change=\"vm.getLevelCategory(vm.Form.objForm.empGrade)\" name=\"empGrade\" required><md-option \nng-repeat=\"g in vm.grade\" ng-value=\"g\">{{g}}</md-option></md-select><div ng-messages=\"employementForm.empGrade.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Employee Grade Required.</span></div></div></md-input-container>\n<md-input-container flex><label>Action Type</label><md-select ng-model=\"vm.Form.objForm.actionType\" name=\"subarea\" \nrequired><md-optgroup label=\"actionType\"><md-option ng-repeat=\"act in vm.listActionType\" value=\"{{act.id}}\">\n{{act.value}}</md-option></md-optgroup></md-select></md-input-container><md-input-container><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked\" ng-click=\"vm.checkIsNeddFile()\" ng-model=\"vm.isNeddUploadFile\" \naria-label=\"\"><span translate=\"MYPROFILE.LABEL.DECREE_UPLOAD\"></span></md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><md-input-container ng-if=\"vm.isChecked\" md-no-float class=\"md-block\" \nflex><label>Letter Number</label><input type=\"text\" name=\"letterNumber\" ng-model=\"vm.Form.objForm.letterNumber\" \nrequired></md-input-container><md-input-container ng-if=\"vm.isChecked\" md-no-float class=\"md-block\" flex><label>\nIssued Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"issuedDate\" ng-model=\"vm.Form.objForm.issuedDate\" \nrequired></md-datepicker><div ng-messages=\"employementForm.issuedDate.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Issued Date Required.</span></div></div></md-input-container><md-input-container ng-if=\"vm.isChecked\" \nmd-no-float class=\"md-block\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select required \nuploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{\n            action:\'uploadJob\',\n            nik:vm.Form.objForm.nik,\n            effectiveDate:vm.Form.objForm.effectiveDate,\n            empGrade:vm.Form.objForm.empGrade,\n            jobTitle:vm.Form.objForm.job_title,\n            mppDetailId:vm.Form.objForm.mppDetailId,\n            orgLayerID:vm.Form.objForm.orgLayerId,\n            abreviation:vm.Form.objForm.abreviation, \n            jointdate:vm.Form.objForm.jointdate,\n            actionType:vm.Form.objForm.actionType,\n            directReport:vm.Form.objForm.directReport,\n            letterNumber:vm.Form.objForm.letterNumber,\n            empId:vm.Form.objForm.empId,\n            hiredate:vm.Form.objForm.hired_date,\n            jobGrade:vm.Form.objForm.jobGrade,\n            empCategory:vm.Form.objForm.empCategory,\n            issuedDate:vm.Form.objForm.issuedDate,\n            id:vm.Form.objForm.id}] }\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.isLayerOverlap\" class=\"fade\"><ms-widget-front \nclass=\"p-7 amber-400-bg ms-widget-front\"><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\">\n</md-icon>Employee setup more than manpower target, org layer will be overlapping</p></ms-widget-front></ms-widget>\n<span flex></span><md-button type=\"submit\" class=\"md-raised md-accent\" ng-if=\"!vm.isChecked\" aria-label=\"Submit\" \nng-disabled=\"employementForm.$invalid || employementForm.$pristine\">Save</md-button><md-button type=\"button\" \nclass=\"md-raised md-accent\" ng-if=\"vm.isChecked\" aria-label=\"Submit\" ng-click=\"vm.upload(employementForm)\" \nng-disabled=\"employementForm.$invalid || employementForm.$pristine\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/employement/list-employement.html","<md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools white\"><md-menu md-offset=\"0 -7\" \nhide-gt-sm ng-if=\"vm.EmployeeService.status\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputEmployement($event)\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Add</md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-warn\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button></md-menu-item>\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-accent\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.changeNik($event)\"><md-icon md-font-icon=\"icon-account-switch\" \nclass=\"md-font icon-archive material-icons\"></md-icon>New NIK</md-button></md-menu-item></md-menu-content></md-menu>\n<md-input-container><select class=\"black-fg\" name=\"see\" id=\"ss\" ng-change=\"vm.viewData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"black-fg\">Entries\n</span></md-input-container><md-button ng-if=\"vm.EmployeeService.status\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputEmployement($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>Add</md-button>\n<md-button ng-if=\"vm.EmployeeService.status\" class=\"md-button md-ink-ripple md-warn md-mini\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Delete\n</md-button><md-button ng-if=\"vm.EmployeeService.status\" class=\"md-green-300-bg md-raised md-primary white-fg\" hide \nshow-gt-sm type=\"button\" aria-label=\"Inert\" ng-click=\"vm.changeNik($event)\"><md-icon \nmd-font-icon=\"icon-account-switch\"></md-icon>New NIK</md-button><span flex hide show-gt-sm></span><form \nng-submit=\"vm.viewData(1)\" name=\"formSearch\" flex><md-input-container md-no-float class=\"md-block form-search-input\" \nflex=\"100\"><md-icon md-font-icon=\"icon-magnify\" style=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input \ntype=\"text\" placeholder=\"Search..\" ng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form>\n</div></md-toolbar><div class=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table \nid=\"tb-kpi-setting\"><thead><tr><th class=\"secondary-text\" width=\"5%\" ng-if=\"vm.EmployeeService.status\"><div \nclass=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\">\n</div></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\" layout=\"column\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.NO\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"PAYROLL.MENU.EFFECTIVEDATE\"></span></span></div></th><th class=\"secondary-text\" \nwidth=\"10%\"><div class=\"table-header full-width\"><span class=\"column-title full-width\"><span translate=\"KPI.LABEL.NIK\">\n</span></span></div></th><th class=\"secondary-text\" width=\"90px\"><div class=\"table-header full-width\"><span \nclass=\"column-title text-normal-wrap full-width\"><span translate=\"KPI.LABEL.JOBGRADE\"></span></span></div></th><th \nclass=\"secondary-text\" width=\"90px\"><div class=\"table-header full-width\"><span \nclass=\"column-title text-normal-wrap full-width\"><span translate=\"TABLE.GRADE\"></span></span></div></th><th \nclass=\"secondary-text\" width=\"90px\"><div class=\"table-header full-width\"><span \nclass=\"column-title text-normal-wrap full-width\"><span translate=\"KPI.LABEL.JOBLEVEL\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"UMUT.MENU.JOBTITLE\">\n</span></span></div></th><th class=\"secondary-text\" width=\"120px\"><div class=\"table-header full-width\" layout=\"column\">\n<span class=\"column-title text-normal-wrap full-width\" layout=\"column\"><span translate=\"MENU.MAIN.EMPCATEGORY\" flex>\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"ATTENDANCE.OFFBOARDING.LABEL.DIRECTREPORT\"></span></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"TABLE.JOB_ACTING\"></span></span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"div in vm.DataTable.list\" ng-if=\"vm.EmployeeService.status\" \nng-dblclick=\"vm.editInputEmployement($event,div)\" ng-click=\"vm.checkone(div)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td class=\"text-center font-size-11\">\n{{ (vm.DataTable.offset + $index + 1)}}</td><td class=\"text-center font-size-11\">{{ div.effective_date}}</td><td \nclass=\"text-center font-size-11\">{{ div.nik}}</td><td class=\"text-center font-size-11\">{{ div.job_grade}}</td><td \nclass=\"text-center font-size-11\">{{ div.emp_grade}}</td><td class=\"text-center font-size-11\">{{ div.job_level}}</td><td\n class=\"font-size-11\">{{ div.job_title}}</td><td class=\"font-size-11\">{{ div.emp_category}}</td><td \nclass=\"font-size-11\">{{ div.direct_report + \' - \' + div.direct_report_name}}</td><td class=\"font-size-11\"><md-menu \nng-if=\"div.isActing==\'1\'\"><md-button class=\"md-raised md-primary md-icon\" ng-click=\"$mdMenu.open()\" aria-label=\"more\">\n<md-icon class=\"white-500-fg\" md-font-icon=\"icon-check\"></md-icon>YES</md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item><md-button ng-click=\"vm.ActingProcess($event,div,\'pass\')\" \naria-label=\"Refresh widget\"><md-icon class=\"green-500-fg\" md-font-icon=\"icon-check-all\"></md-icon><span>ACTING PASS\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.ActingProcess($event,div,\'failed\')\" \naria-label=\"Refresh widget\"><md-icon class=\"orange-500-fg\" md-font-icon=\"icon-account-remove\"></md-icon><span>\nACTING FAILED</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr><tr \nng-repeat=\"div in vm.DataTable.list\" ng-if=\"!vm.EmployeeService.status\"><td class=\"text-center font-size-11\">\n{{ (vm.DataTable.offset + $index + 1)}}</td><td class=\"text-center font-size-11\">{{ div.effective_date}}</td><td \nclass=\"text-center font-size-11\">{{ div.nik}}</td><td class=\"text-center font-size-11\">{{ div.job_grade}}</td><td \nclass=\"text-center font-size-11\">{{ div.emp_grade}}</td><td class=\"text-center font-size-11\">{{ div.job_level}}</td><td\n class=\"font-size-11\">{{ div.job_title}}</td><td class=\"font-size-11\">{{ div.emp_category}}</td><td \nclass=\"font-size-11\">{{ div.direct_report + \' - \' + div.direct_report_name}}</td><td class=\"font-size-11\"><md-menu \nng-if=\"div.isActing==\'1\'\"><md-button class=\"md-raised md-primary md-icon\" ng-click=\"vm.viewPromotion(div)\" \naria-label=\"more\"><md-icon class=\"white-500-fg\" md-font-icon=\"icon-check\"></md-icon>YES</md-button></md-menu></td></tr>\n<tr class=\"text-center\" ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td ng-if=\"vm.EmployeeService.status\" \ncolspan=\"10\" class=\"text-center\"><span class=\"font-size-11\">Please Wait</span></td><td \nng-if=\"!vm.EmployeeService.status\" colspan=\"10\" class=\"text-center\"><span class=\"font-size-11\">Please Wait</span></td>\n</tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td ng-if=\"vm.EmployeeService.status\" colspan=\"10\" \nclass=\"text-center\"><span class=\"font-size-11\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td><td \nng-if=\"!vm.EmployeeService.status\" colspan=\"10\" class=\"text-center\"><span class=\"font-size-11\" \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></div><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.viewData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/employee/employe/input-employe/employement/lookupLayer.html","<md-dialog aria-label=\"Lookup Staf Employee\" flex=\"50\"><form ng-cloak name=\"frmApproval\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.submitApproval($event, frmApproval)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nLookup Job Title</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.company\" ng-change=\"vm.loadDataDivision(vm.Form.objForm.company);vm.selectedCange(\'comp\')\" name=\"company\">\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"employementForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany Required.</span></div></div></md-input-container><md-input-container flex flex-offset-gt-xs=\"5\"><label>Divisi\n</label><md-select ng-model=\"vm.divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi,true);vm.selectedCange(\'div\')\" \nname=\"divisi\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" ng-if=\"ls.id!==\'all\'\" \nvalue=\"{{ls.id}}\">{{ls.id}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"employementForm.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi Required.</span></div>\n</div></md-input-container><md-input-container flex flex-offset-gt-xs=\"5\"><label>Department</label><md-select \nng-model=\"vm.department\" name=\"department\" ng-change=\"vm.loadLayerData();vm.selectedCange(\'dept\')\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" ng-if=\"ls.id!==\'all\'\" value=\"{{ls.id}}\">\n{{ls.id}} - {{ls.description}}</md-option></md-select><div ng-messages=\"employementForm.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department Required.</span></div></div></md-input-container>\n<md-input-container><label>Direct Report</label><input ng-model=\"vm.directReport\" ng-keyup=\"vm.loadLayerData(1)\">\n</md-input-container></div><div layout=\"column\"><div flex-gt-sm=\"100\" flex=\"100\" layout=\"column\"><md-subheader \nclass=\"searchForm\"><md-input-container style=\"width: 100%\"><label>Search</label><input ng-model=\"vm.searchParam\" \nng-keyup=\"vm.loadLayerData(1)\"></md-input-container></md-subheader><md-content layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"max-height:400px\"><md-list flex><md-list-item ng-if=\"vm.isLoadingLoadEmployee\"><md-progress-circular \nclass=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular></md-list-item><md-list-item \nclass=\"md-3-line jic-add-list-item-employee\" ng-repeat-start=\"item in vm.empList\" ng-click=\"vm.selectEmployee(item)\">\n<div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.jobTitleName }}</h3><p>\nManpower Target: {{item.fullfilmentType}}</p></div><md-button type=\"submit\" class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.chooseEmployee(item)\"><md-icon md-font-icon=\"icon-check white-fg\"></md-icon>CHOOSE</md-button>\n</md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content><div style=\"padding: 0em 1em\"><div \nclass=\"is-bottom-nav margin-top-5\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\" class=\"white-bg\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>CANCEL</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/employement/lookupemployement.html","<md-dialog aria-label=\"Lookup Staf Employee\" flex=\"50\"><form ng-cloak name=\"frmApproval\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.submitApproval($event, frmApproval)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nLookup Employee</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.company\" ng-change=\"vm.loadDataDivision(vm.Form.objForm.company);vm.selectedCange(\'comp\')\" name=\"company\">\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"employementForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany Required.</span></div></div></md-input-container><md-input-container flex flex-offset-gt-xs=\"5\"><label>Divisi\n</label><md-select ng-model=\"vm.divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi,true);vm.selectedCange(\'div\')\" \nname=\"divisi\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" ng-if=\"ls.id!==\'all\'\" \nvalue=\"{{ls.id}}\">{{ls.id}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"employementForm.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi Required.</span></div>\n</div></md-input-container><md-input-container flex flex-offset-gt-xs=\"5\"><label>Department</label><md-select \nng-model=\"vm.department\" name=\"department\" ng-change=\"vm.loadEmployeeData();vm.selectedCange(\'dept\')\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" ng-if=\"ls.id!==\'all\'\" value=\"{{ls.id}}\">\n{{ls.id}} - {{ls.description}}</md-option></md-select><div ng-messages=\"employementForm.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department Required.</span></div></div></md-input-container></div><div \nlayout=\"column\"><div flex-gt-sm=\"100\" flex=\"100\" layout=\"column\"><md-subheader class=\"searchForm\"><md-input-container \nstyle=\"width: 100%\"><label>Search</label><input ng-model=\"vm.searchParam\" ng-keyup=\"vm.loadEmployeeData(1)\">\n</md-input-container></md-subheader><md-content layout=\"column\" layout-gt-xs=\"row\" style=\"max-height:400px\"><md-list \nflex><md-list-item ng-if=\"vm.isLoadingLoadEmployee\"><md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\">\n</md-progress-circular></md-list-item><md-list-item class=\"md-3-line jic-add-list-item-employee\" \nng-repeat-start=\"item in vm.empList\" ng-click=\"vm.selectEmployee(item)\"><div class=\"md-list-item-text\" layout=\"column\">\n<h3>{{ item.nama }} ({{item.nik}})</h3></div><md-button type=\"submit\" class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.chooseEmployee(item)\"><md-icon md-font-icon=\"icon-check white-fg\"></md-icon>CHOOSE</md-button>\n</md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content><div style=\"padding: 0em 1em\"><div \nclass=\"is-bottom-nav margin-top-5\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\" class=\"white-bg\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>CANCEL</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/imigration/input-imigration.html","<md-dialog aria-label=\"Form Input Imigration\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"imgForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,imgForm)\"><md-toolbar class=\"md-accent hue-3\"><div \nclass=\"md-toolbar-tools\"><h2>Form Input Imigration</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Type Of Document</label><input ng-model=\"vm.Form.objForm.typeOfDoc\" required \nplaceholder=\"Type Of Document\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>\nDocument Number</label><input ng-model=\"vm.Form.objForm.docNumber\" required placeholder=\"Document Number\">\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Expire Date</label><md-datepicker \nng-model=\"vm.Form.objForm.expDate\" required></md-datepicker></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"imgForm.$invalid || imgForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/imigration/list-imigration.html","<div class=\"toolbar layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\" class=\"layout-align-start-center layout-row\"><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputImigration($event)\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\">Insert</md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">Delete\n</md-button></div></div><div class=\"white-bg\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\" width=\"5%\"><div \nclass=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\">Type Of Document</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Document Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Expire Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"div in vm.listData\" ng-dblclick=\"vm.editInputImigration($event,div)\" ng-click=\"vm.checkone(div)\"><td><input \ntype=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td>{{ ($index + 1)}}</td><td>\n{{ div.typeOfDoc}}</td><td>{{ div.docNumber}}</td><td>{{ div.expDate}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/employee/employe/input-employe/join-date/join-date-edit.html","<md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools white\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-disabled=\"vm.stateEdit\" ng-click=\"vm.ChangeState()\" type=\"button\" \nclass=\"md-raised md-primary md-green-300-bg\" aria-label=\"Submit\"><span translate=\"MYPROFILE.MENU.EDIT\">Edit</span>\n</md-button><md-button ng-if=\"vm.stateEdit\" ng-click=\"vm.ChangeState()\" type=\"button\" \nclass=\"md-raised md-yellow-500-bg white-fg\" aria-label=\"Submit\"><span translate=\"MYPROFILE.MENU.CANCELEDIT\">Cancel Edit\n</span></md-button></div></div></md-toolbar><form name=\"joinDateForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.ChangeJoinDate(joinDateForm)\"><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\">\n<div flex hide show-gt-xs></div><div layout=\"column\" flex flex-gt-xs=\"40\"><md-subheader class=\"md-no-sticky\">Join Date\n</md-subheader><span class=\"font-size-12 mv-10 ph-15\">{{vm.Form.objForm.join_date | date:shortDate}}</span> <span \nclass=\"font-size-12 ph-15\">&nbsp;</span><md-input-container class=\"ph-15\"><md-datepicker \nng-model=\"vm.Form.objForm.join_date\" md-hide-icons=\"calendar\" md-placeholder=\"Enter date\" name=\"join_date\" \nng-disabled=\"!vm.stateEdit\" required></md-datepicker></md-input-container></div><div flex></div><div layout=\"column\" \nflex flex-gt-xs=\"40\"><md-subheader class=\"md-no-sticky\">Emloyee ID/NIK Effective Date</md-subheader><span \nclass=\"font-size-12 mv-10 ph-15\">{{vm.Form.objForm.nikeffective | date:shortDate}}</span> <span \nclass=\"font-size-12 ph-15\" translate=\"MYPROFILE.NOTE.NIKEFFCTIVE\">*Ket : digunakan sebagai dasar perhitungan cuti\n</span><md-input-container class=\"ph-15\"><md-datepicker ng-model=\"vm.Form.objForm.nikeffective\" \nmd-hide-icons=\"calendar\" md-placeholder=\"Enter date\" name=\"nikeffective\" ng-disabled=\"!vm.stateEdit\" required>\n</md-datepicker></md-input-container></div><div flex></div><div layout=\"column\" flex flex-gt-xs=\"40\"><md-subheader \nclass=\"md-no-sticky\">Effective Date</md-subheader><span class=\"font-size-12 mv-10 ph-15\">\n{{vm.Form.objForm.effective_date | date:shortDate}}</span> <span class=\"font-size-12 ph-15\" \ntranslate=\"MYPROFILE.NOTE.ANNUALLEAVEEVVECTIVE\">*Ket : digunakan sebagai dasar perhitungan cuti</span>\n<md-input-container class=\"ph-15\"><md-datepicker ng-model=\"vm.Form.objForm.effective_date\" md-hide-icons=\"calendar\" \nmd-placeholder=\"Enter date\" name=\"effective_date\" ng-disabled=\"!vm.stateEdit\" required></md-datepicker>\n</md-input-container></div><div flex hide show-gt-xs></div></div><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade mt-15\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{ vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><div \nlayout=\"row\" layout-align=\"center end\"><md-button ng-if=\"vm.stateEdit\" type=\"submit\" \nclass=\"md-raised md-blue-500-bg white-fg fade mt-15\" aria-label=\"Submit\" \nng-disabled=\"joinDateForm.$invalid || joinDateForm.$pristine\"><span translate=\"MYPROFILE.MENU.UPDATE\">Update</span>\n</md-button></div></div></form>");
$templateCache.put("app/main/employee/employe/input-employe/join-date/join-date.html","<form name=\"joinDateForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.ChangeJoinDate(joinDateForm)\"><div \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\" class=\"mt-30\"><div flex hide show-gt-xs></div><div \nlayout=\"column\" flex flex-gt-xs=\"40\"><md-subheader class=\"md-no-sticky\">Join Date</md-subheader><h3 \nclass=\"text-bold mt-10 ph-15 mb-5\">{{vm.Form.objForm.join_date | date:shortDate}}</h3><span class=\"font-size-12 ph-15\">\n&nbsp;</span></div><div flex></div><div layout=\"column\" flex flex-gt-xs=\"40\"><md-subheader class=\"md-no-sticky\">\nEmployee ID Effective Date</md-subheader><h3 class=\"text-bold mt-10 ph-15 mb-5\">\n{{vm.Form.objForm.nikeffective | date:shortDate}}</h3><span class=\"font-size-12 ph-15\" \ntranslate=\"MYPROFILE.NOTE.NIKEFFCTIVE\">*Ket : digunakan sebagai dasar perhitungan cuti</span></div><div flex></div><div\n layout=\"column\" flex flex-gt-xs=\"40\"><md-subheader class=\"md-no-sticky\">Effective Date</md-subheader><h3 \nclass=\"text-bold mt-10 ph-15 mb-5\">{{vm.Form.objForm.effective_date | date:shortDate}}</h3><span \nclass=\"font-size-12 ph-15\" translate=\"MYPROFILE.NOTE.ANNUALLEAVEEVVECTIVE\">\n*Ket : digunakan sebagai dasar perhitungan cuti</span></div><div flex hide show-gt-xs></div></div></div></form>");
$templateCache.put("app/main/employee/employe/input-employe/language/input-language.html","<md-dialog aria-label=\"Form Input Language\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"langForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,langForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Language</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.LANGUAGE\">\n</span></label><md-select ng-model=\"vm.Form.objForm.languageCode\" ng-required=\"true\" name=\"language\"><md-option \nng-repeat=\"lang in vm.listLang\" ng-value=\"lang.languagename\">{{lang.languagename}}</md-option></md-select><div \nng-messages=\"profilForm.language.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.LANGUAGE\"></span><span> harus di pilih.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.LEVEL\"></span></label><md-select \nng-model=\"vm.Form.objForm.level\" ng-required=\"true\" name=\"level\"><md-option value=\"beginner\">Beginner</md-option>\n<md-option value=\"intermediate\">Intermediate</md-option><md-option value=\"advanced\">Advanced</md-option></md-select>\n<div ng-messages=\"profilForm.level.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MENU.LEVEL\"></span><span> Required.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"langForm.$invalid || langForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/language/list-language.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Certificate</span>\n</p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><div class=\"white-bg\"><md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputLanguage($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button><md-button class=\"md-button md-ink-ripple md-accent md-mini\" \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.listDataSelected.length == 0\" ng-click=\" vm.deleteData($event)\">\n<md-icon ng-if=\"vm.listDataSelected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon \nng-if=\"vm.listDataSelected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.listDataSelected.length > 0\" class=\"red-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span \nng-if=\"vm.listDataSelected.length == 0\" class=\"grey-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span \nstyle=\"color:red\" ng-if=\"vm.listDataSelected.length > 0\">{{ vm.listDataSelected.length }} <span \ntranslate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"inputLanguange\" \nng-click=\"vm.openInputLanguage($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"deleteData\" ng-click=\"vm.deleteData($event)\"><md-icon\n md-font-icon=\"icon-delete\"></md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\">\n<input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.NO\"></span></span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.LANGUAGECODE\"></span></span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.LEVEL\">\n</span></span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listData\" \nng-dblclick=\"vm.editInputLanguage($event,div)\" ng-click=\"vm.checkone(div)\"><td class=\"text-center\"><input \ntype=\"checkbox\" checklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td>{{ ($index + 1)}}</td><td>\n{{ div.language_code}}</td><td>{{ div.level | uppercase}}</td></tr><tr class=\"text-center\" \nng-if=\"(vm.listData | typeOf) == \'undefined\'\"><td colspan=\"4\" class=\"text-center\"><span class=\"font-size-12\">\nPlease Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.listData.length <= 0\"><td colspan=\"4\" \nclass=\"text-center\"><span class=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr>\n</tbody></table></div>");
$templateCache.put("app/main/employee/employe/input-employe/promotion/edit-promotion.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"promotionForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.updateData($event,promotionForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Form Input Promotion</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\">\n</md-progress-linear><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><th colspan=\"6\" style=\"text-align:center\">Old Job</th></tr><tr><th style=\"text-align:center\">Job Grade</th><th \nstyle=\"text-align:center\">Emp Grade</th><th style=\"text-align:center\">Job Level</th><th style=\"text-align:center\">\nJob Title</th><th style=\"text-align:center\">Direct Report</th><th style=\"text-align:center\">Abreviation</th></tr>\n</thead><tbody><tr><td style=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_grade}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.emp_grade}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_level}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_title}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.direct_report}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.abreviation}}</td></tr></tbody></table></div><div \nclass=\"layout-gt-sm-row border-horizontal\"></div><div class=\"white-bg\"><input type=\"hidden\" name=\"empId\" \nng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" name=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" \nng-if=\"vm.Form.objForm.oldId\"><div layout-gt-sm=\"row\"><md-input-container flex><label>Employee NIK</label><input \nng-model=\"vm.Form.objForm.nik\" ng-readonly=\"vm.nik\" md-maxlength=\"8\" name=\"nik\" required><div \nng-messages=\"promotionForm.nik.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 8 Character.</span></div>\n<div ng-message=\"required\"><span>Employee NIK Required.</span></div></div></md-input-container><md-input-container \nflex><label>No SK</label><input ng-model=\"vm.Form.objForm.skNo\" md-maxlength=\"8\" name=\"skNo\" required><div \nng-messages=\"promotionForm.hiredate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Hire Date Date Required.\n</span></div></div></md-input-container><md-autocomplete flex flex-gt-sm md-selected-item=\"vm.selectedItem\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearchDeferred(vm.searchText)\" md-item-text=\"item.nik\" \nmd-input-name=\"nik\" placeholder=\"Search NIK Direct Report\"><label>Direct Report</label><md-item-template><span \nmd-highlight-text=\"vm.searchText\">{{item.nik}} ({{item.name}})</span></md-item-template><md-not-found>\nNo NIK matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"drop-mod\" flex><label>Company</label><md-select ng-model=\"vm.company\" \nng-change=\"vm.loadDataDivision(vm.Form.objForm.company)\" name=\"company\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"promotionForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Required.</span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label>Divisi</label><md-select \nng-model=\"vm.divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" name=\"divisi\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div\n ng-messages=\"promotionForm.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi Required.</span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label>Department</label><md-select \nng-model=\"vm.department\" name=\"department\" ng-change=\"vm.getJobTitle()\" required><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"promotionForm.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex=\"70\"><label>Job Title</label><md-select ng-model=\"vm.Form.objForm.jobTitle\" ng-change=\"vm.getJfm()\" \nng-disabled=\"vm.department==null\" name=\"jobTitle\" required><md-option ng-repeat=\"jt in vm.listJobTitle\" \nng-value=\"jt.dsc\">{{jt.dsc}}</md-option></md-select><div ng-messages=\"promotionForm.jobTitle.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Job Title Required.</span></div></div></md-input-container><md-input-container flex><label>\nEffective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effectiveDate\" \nng-model=\"vm.Form.objForm.effectiveDate\" required></md-datepicker><div \nng-messages=\"promotionForm.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Effective Date Required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Job Grade</label>\n<md-select ng-model=\"vm.Form.objForm.jobGrade\" name=\"jobGrade\" required><md-option ng-repeat=\"g in vm.grade\" \nng-value=\"g\">{{g}}</md-option></md-select><div ng-messages=\"promotionForm.jobGrade.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Job Grade Required.</span></div></div></md-input-container><md-input-container flex><label>\nEmployee Grade</label><md-select ng-model=\"vm.Form.objForm.empGrade\" \nng-change=\"vm.getLevelCategory(vm.Form.objForm.empGrade)\" name=\"empGrade\" required><md-option \nng-repeat=\"g in vm.grade\" ng-value=\"g\">{{g}}</md-option></md-select><div ng-messages=\"promotionForm.empGrade.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Employee Grade Required.</span></div></div></md-input-container>\n<md-input-container class=\"drop-mod\" flex><label>Sub Area</label><md-select ng-model=\"vm.Form.objForm.subArea\" \nname=\"subArea\" ng-change=\"vm.loadGedung(vm.Form.objForm.subArea)\" required><md-option ng-repeat=\"jt in vm.listSubArea\" \nng-value=\"jt.subarea_id\">{{jt.description | uppercase}}</md-option></md-select><div \nng-messages=\"promotionForm.subArea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area Required.</span>\n</div></div></md-input-container><md-input-container flex><label>Gedung</label><md-select \nng-model=\"vm.Form.objForm.gedung\" name=\"gedung\" required><md-option ng-repeat=\"jt in vm.listGedung\" ng-value=\"jt.id\">\n{{jt.gedung_name | uppercase}}</md-option></md-select><div ng-messages=\"promotionForm.gedung.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Gedung Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Employee Category</label><input ng-model=\"vm.Form.objForm.empCategory\" \nng-readonly=\"true\" placeholder=\"Employee category\" name=\"empCategory\" required><div \nng-messages=\"promotionForm.empCategory.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee Category Required.</span></div></div></md-input-container><md-input-container flex><label>Job Level</label>\n<input ng-model=\"vm.Form.objForm.jobLevel\" ng-readonly=\"true\" placeholder=\"Job Level\" name=\"jobLevel\" required><div \nng-messages=\"promotionForm.jobLevel.$error\" role=\"alert\"><div ng-message=\"required\"><span>Job Level Required.</span>\n</div></div></md-input-container><md-input-container flex><label>JFM</label><md-select ng-model=\"vm.Form.objForm.jfm\" \nname=\"jfm\" disabled=\"disabled\"><md-option ng-repeat=\"jt in vm.listJfm\" ng-value=\"jt.id\">{{jt.description}}</md-option>\n</md-select><div ng-messages=\"promotionForm.jfm.$error\" role=\"alert\"><div ng-message=\"required\"><span>JFM Required.\n</span></div></div></md-input-container><md-input-container flex><label>Sub JFM</label><input \nng-model=\"vm.Form.objForm.jfmSub\" name=\"jfmSub\" ng-readonly=\"true\" required><div \nng-messages=\"promotionForm.jfmSub.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub JFM Required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"10\"><md-checkbox \nng-model=\"vm.Form.objForm.acting\" name=\"acting\" aria-label=\"Acting\" style=\"margin-top:5px\">Acting</md-checkbox><div \nng-messages=\"promotionForm.acting.$error\" class=\"md-primary\" role=\"alert\"><div ng-message=\"required\"><span>\nActing Required.</span></div></div></md-input-container><md-input-container flex><label>Description</label><input \nng-model=\"vm.Form.objForm.description\" name=\"description\" required><div ng-messages=\"promotionForm.description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Description Required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.Form.objForm.acting\"><md-input-container flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"act_startDate\" ng-model=\"vm.Form.objForm.act_startDate\" \nng-required=\"vm.Form.objForm.acting\"></md-datepicker><div ng-messages=\"promotionForm.act_startDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date Required.</span></div></div></md-input-container>\n<md-input-container flex><label>End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"act_endDate\" \nng-model=\"vm.Form.objForm.act_endDate\" ng-required=\"vm.Form.objForm.acting\"></md-datepicker><div \nng-messages=\"promotionForm.act_endDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date Required.</span>\n</div></div></md-input-container><md-input-container flex><label>Acting Result</label><md-select \nng-model=\"vm.Form.objForm.act_result\" name=\"act_result\" ng-required=\"vm.Form.objForm.acting\"><md-option \nng-repeat=\"r in vm.actResult\" ng-value=\"r.id\">{{r.description | uppercase}}</md-option></md-select><div \nng-messages=\"promotionForm.act_result.$error\" role=\"alert\"><div ng-message=\"required\"><span>Acting Result Required.\n</span></div></div></md-input-container></div></div><div class=\"layout-gt-sm-row border-horizontal\" \nng-if=\"vm.Form.objForm.effectiveDate\"></div><div class=\"white-bg\" ng-if=\"vm.listAllowance.length > 0\" \nstyle=\"margin-bottom:20px\"><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th colspan=\"6\" style=\"text-align:center\">Allowance Lists</th></tr>\n<tr><th>No.</th><th style=\"text-align:center\">Employee Nik</th><th style=\"text-align:center\">Amount</th><th \nstyle=\"text-align:center\">Salary Component</th><th style=\"text-align:center\">Effective Date</th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"l in vm.listAllowance\"><td>{{ $index + 1}}</td><td style=\"text-align:center\">{{ l.ID_employee}}\n</td><td style=\"text-align:center\">{{ l.Amount}}</td><td style=\"text-align:center\">{{ l.ID_SalaryComponent}}</td><td \nstyle=\"text-align:center\">{{ l.effective_date | date: \"M/dd/yyyy\"}}</td><td style=\"\"><md-button \nng-click=\"vm.delListAllowance($index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Delete</md-button></td></tr>\n</tbody></table></div><div layout-gt-sm=\"row\" ng-if=\"vm.Form.objForm.effectiveDate\"><md-input-container flex><label>\nEmployee NIK</label><input ng-model=\"vm.Form.objForm.nik\" ng-readonly=\"true\" name=\"nik\"><div \nng-messages=\"promotionForm.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>Job Level Required.</span></div>\n</div></md-input-container><md-input-container flex><label>Amount</label><input type=\"number\" ng-model=\"vm.Amount\" \nname=\"Amount\"><div ng-messages=\"promotionForm.Amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJob Level Required.</span></div></div></md-input-container><md-input-container flex><label>Salary Component</label>\n<md-select ng-model=\"vm.ID_SalaryComponent\" name=\"ID_SalaryComponent\" required><md-option \nng-repeat=\"r in vm.listSalaryComponent\" ng-value=\"r.ID\">{{r.Description}}</md-option></md-select><div \nng-messages=\"promotionForm.ID_SalaryComponent.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nActing Result Required.</span></div></div></md-input-container><md-input-container flex><label>Effective Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"act_startDate\" ng-model=\"vm.Form.objForm.effectiveDate\" \ndisabled=\"disabled\"></md-datepicker><div ng-messages=\"promotionForm.act_startDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date Required.</span></div></div></md-input-container><md-button \nng-click=\"vm.addAllowance()\" class=\"md-raised md-primary\" style=\"height:20px\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>Add</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"promotionForm.$invalid || promotionForm.$pristine\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/promotion/input-promotion.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"70\" md-theme=\"modal-theme\"><form ng-cloack name=\"promotionForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,promotionForm)\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Form Input Promotion</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" ng-show=\"vm.saveProcess\">\n</md-progress-linear><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div class=\"white-bg\"><table \nclass=\"simple with-toolbar fullwidth-table stripped upper-case-header\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><th colspan=\"6\" style=\"text-align:center\">Old Job</th></tr><tr><th style=\"text-align:center\">Job Grade</th><th \nstyle=\"text-align:center\">Emp Grade</th><th style=\"text-align:center\">Job Level</th><th style=\"text-align:center\">\nJob Title</th><th style=\"text-align:center\">Direct Report</th><th style=\"text-align:center\">Abreviation</th></tr>\n</thead><tbody><tr><td style=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_grade}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.emp_grade}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_level}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.job_title}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.direct_report}}</td><td \nstyle=\"text-align:center;background:#dbf7f4\">{{ vm.listOldJob.abreviation}}</td></tr></tbody></table></div><div \nclass=\"layout-gt-sm-row border-horizontal\"></div><div class=\"white-bg\"><input type=\"hidden\" name=\"empId\" \nng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" name=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" \nng-if=\"vm.Form.objForm.oldId\"><div layout-gt-sm=\"row\"><md-input-container flex><label>Employee NIK</label><input \nng-model=\"vm.Form.objForm.nik\" ng-readonly=\"vm.nik\" md-maxlength=\"8\" name=\"nik\" required><div \nng-messages=\"promotionForm.nik.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 8 Character.</span></div>\n<div ng-message=\"required\"><span>Employee NIK Required.</span></div></div></md-input-container><md-input-container \nflex><label>No SK</label><input ng-model=\"vm.Form.objForm.skNo\" md-maxlength=\"8\" name=\"skNo\" required><div \nng-messages=\"promotionForm.hiredate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Hire Date Date Required.\n</span></div></div></md-input-container><md-autocomplete flex flex-gt-sm md-selected-item=\"vm.selectedItem\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearchDeferred(vm.searchText)\" md-item-text=\"item.nik\" \nmd-input-name=\"nik\" placeholder=\"Search NIK Direct Report\"><label>Direct Report</label><md-item-template><span \nmd-highlight-text=\"vm.searchText\">{{item.nik}} ({{item.name}})</span></md-item-template><md-not-found>\nNo NIK matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"drop-mod\" flex><label>Company</label><md-select ng-model=\"vm.company\" \nng-change=\"vm.loadDataDivision(vm.Form.objForm.company)\" name=\"company\" required><md-option \nng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div \nng-messages=\"promotionForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>Company Required.</span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label>Divisi</label><md-select \nng-model=\"vm.divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi)\" name=\"divisi\" required><md-option \nng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" value=\"{{ls.id}}\">{{ls.description}}</md-option></md-select><div\n ng-messages=\"promotionForm.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi Required.</span></div>\n</div></md-input-container><md-input-container class=\"drop-mod\" flex><label>Department</label><md-select \nng-model=\"vm.department\" name=\"department\" ng-change=\"vm.getJobTitle()\" required><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"promotionForm.department.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDepartment Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nflex=\"70\"><label>Job Title</label><md-select ng-model=\"vm.Form.objForm.jobTitle\" ng-change=\"vm.getJfm()\" \nng-disabled=\"vm.department==null\" name=\"jobTitle\" required><md-option ng-repeat=\"jt in vm.listJobTitle\" \nng-value=\"jt.dsc\">{{jt.dsc}}</md-option></md-select><div ng-messages=\"promotionForm.jobTitle.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Job Title Required.</span></div></div></md-input-container><md-input-container flex><label>\nEffective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effectiveDate\" \nng-model=\"vm.Form.objForm.effectiveDate\" required></md-datepicker><div \nng-messages=\"promotionForm.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Effective Date Required.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex><label>Job Grade</label>\n<md-select ng-model=\"vm.Form.objForm.jobGrade\" name=\"jobGrade\" required><md-option ng-repeat=\"g in vm.grade\" \nng-value=\"g\">{{g}}</md-option></md-select><div ng-messages=\"promotionForm.jobGrade.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Job Grade Required.</span></div></div></md-input-container><md-input-container flex><label>\nEmployee Grade</label><md-select ng-model=\"vm.Form.objForm.empGrade\" \nng-change=\"vm.getLevelCategory(vm.Form.objForm.empGrade)\" name=\"empGrade\" required><md-option \nng-repeat=\"g in vm.grade\" ng-value=\"g\">{{g}}</md-option></md-select><div ng-messages=\"promotionForm.empGrade.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Employee Grade Required.</span></div></div></md-input-container>\n<md-input-container class=\"drop-mod\" flex><label>Sub Area</label><md-select ng-model=\"vm.Form.objForm.subArea\" \nname=\"subArea\" ng-change=\"vm.loadGedung(vm.Form.objForm.subArea)\" required><md-option ng-repeat=\"jt in vm.listSubArea\" \nng-value=\"jt.subarea_id\">{{jt.description | uppercase}}</md-option></md-select><div \nng-messages=\"promotionForm.subArea.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub Area Required.</span>\n</div></div></md-input-container><md-input-container flex><label>Gedung</label><md-select \nng-model=\"vm.Form.objForm.gedung\" name=\"gedung\" required><md-option ng-repeat=\"jt in vm.listGedung\" ng-value=\"jt.id\">\n{{jt.gedung_name | uppercase}}</md-option></md-select><div ng-messages=\"promotionForm.gedung.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Gedung Required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Employee Category</label><input ng-model=\"vm.Form.objForm.empCategory\" \nng-readonly=\"true\" placeholder=\"Employee category\" name=\"empCategory\" required><div \nng-messages=\"promotionForm.empCategory.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmployee Category Required.</span></div></div></md-input-container><md-input-container flex><label>Job Level</label>\n<input ng-model=\"vm.Form.objForm.jobLevel\" ng-readonly=\"true\" placeholder=\"Job Level\" name=\"jobLevel\" required><div \nng-messages=\"promotionForm.jobLevel.$error\" role=\"alert\"><div ng-message=\"required\"><span>Job Level Required.</span>\n</div></div></md-input-container><md-input-container flex><label>JFM</label><md-select ng-model=\"vm.Form.objForm.jfm\" \nname=\"jfm\" disabled=\"disabled\"><md-option ng-repeat=\"jt in vm.listJfm\" ng-value=\"jt.id\">{{jt.description}}</md-option>\n</md-select><div ng-messages=\"promotionForm.jfm.$error\" role=\"alert\"><div ng-message=\"required\"><span>JFM Required.\n</span></div></div></md-input-container><md-input-container flex><label>Sub JFM</label><input \nng-model=\"vm.Form.objForm.jfmSub\" name=\"jfmSub\" ng-readonly=\"true\" required><div \nng-messages=\"promotionForm.jfmSub.$error\" role=\"alert\"><div ng-message=\"required\"><span>Sub JFM Required.</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container flex=\"10\"><md-checkbox \nng-model=\"vm.Form.objForm.acting\" name=\"acting\" aria-label=\"Acting\" style=\"margin-top:5px\">Acting</md-checkbox><div \nng-messages=\"promotionForm.acting.$error\" class=\"md-primary\" role=\"alert\"><div ng-message=\"required\"><span>\nActing Required.</span></div></div></md-input-container><md-input-container flex><label>Description</label><input \nng-model=\"vm.Form.objForm.description\" name=\"description\" required><div ng-messages=\"promotionForm.description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Description Required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-if=\"vm.Form.objForm.acting\"><md-input-container flex><label>Start Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"act_startDate\" ng-model=\"vm.Form.objForm.act_startDate\" \nng-required=\"vm.Form.objForm.acting\"></md-datepicker><div ng-messages=\"promotionForm.act_startDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Start Date Required.</span></div></div></md-input-container>\n<md-input-container flex><label>End Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"act_endDate\" \nng-model=\"vm.Form.objForm.act_endDate\" ng-required=\"vm.Form.objForm.acting\"></md-datepicker><div \nng-messages=\"promotionForm.act_endDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date Required.</span>\n</div></div></md-input-container><md-input-container flex><label>Acting Result</label><md-select \nng-model=\"vm.Form.objForm.act_result\" name=\"act_result\" ng-required=\"vm.Form.objForm.acting\"><md-option \nng-repeat=\"r in vm.actResult\" ng-value=\"r.id\">{{r.description | uppercase}}</md-option></md-select><div \nng-messages=\"promotionForm.act_result.$error\" role=\"alert\"><div ng-message=\"required\"><span>Acting Result Required.\n</span></div></div></md-input-container></div></div><div class=\"layout-gt-sm-row border-horizontal\" \nng-if=\"vm.Form.objForm.effectiveDate\"></div><div class=\"white-bg\" ng-if=\"vm.listAllowance.length > 0\" \nstyle=\"margin-bottom:20px\"><table class=\"simple with-toolbar fullwidth-table stripped upper-case-header\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th colspan=\"6\" style=\"text-align:center\">Allowance Lists</th></tr>\n<tr><th>No.</th><th style=\"text-align:center\">Employee Nik</th><th style=\"text-align:center\">Amount</th><th \nstyle=\"text-align:center\">Salary Component</th><th style=\"text-align:center\">Effective Date</th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"l in vm.listAllowance\"><td>{{ $index + 1}}</td><td style=\"text-align:center\">{{ l.ID_employee}}\n</td><td style=\"text-align:center\">{{ l.Amount}}</td><td style=\"text-align:center\">{{ l.ID_SalaryComponent}}</td><td \nstyle=\"text-align:center\">{{ l.effective_date | date: \"M/dd/yyyy\"}}</td><td style=\"\"><md-button \nng-click=\"vm.delListAllowance($index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Delete</md-button></td></tr>\n</tbody></table></div><div layout-gt-sm=\"row\" ng-if=\"vm.Form.objForm.effectiveDate\"><md-input-container flex><label>\nEmployee NIK</label><input ng-model=\"vm.Form.objForm.nik\" ng-readonly=\"true\" name=\"nik\"><div \nng-messages=\"promotionForm.nik.$error\" role=\"alert\"><div ng-message=\"required\"><span>Job Level Required.</span></div>\n</div></md-input-container><md-input-container flex><label>Amount</label><input type=\"number\" ng-model=\"vm.Amount\" \nname=\"Amount\"><div ng-messages=\"promotionForm.Amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJob Level Required.</span></div></div></md-input-container><md-input-container flex><label>Salary Component</label>\n<md-select ng-model=\"vm.ID_SalaryComponent\" name=\"ID_SalaryComponent\" required><md-option \nng-repeat=\"r in vm.listSalaryComponent\" ng-value=\"r.ID\">{{r.Description}}</md-option></md-select><div \nng-messages=\"promotionForm.ID_SalaryComponent.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nActing Result Required.</span></div></div></md-input-container><md-input-container flex><label>Effective Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"act_startDate\" ng-model=\"vm.Form.objForm.effectiveDate\" \ndisabled=\"disabled\"></md-datepicker><div ng-messages=\"promotionForm.act_startDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Start Date Required.</span></div></div></md-input-container><md-button \nng-click=\"vm.addAllowance()\" class=\"md-raised md-primary\" style=\"height:20px\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>Add</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"promotionForm.$invalid || promotionForm.$pristine\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/promotion/list-promotion.html","<md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools white\"><md-menu md-offset=\"0 -7\" \nhide-gt-sm ng-if=\"vm.EmployeeService.status\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputPromotion($event)\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Add</md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-warn\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container><select class=\"black-fg\" name=\"see\" id=\"ss\" ng-change=\"vm.viewData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"black-fg\">Entries\n</span></md-input-container><md-button ng-if=\"vm.EmployeeService.status\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputPromotion($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>Add</md-button><md-button \nng-if=\"vm.EmployeeService.status\" class=\"md-button md-ink-ripple md-warn md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Delete</md-button>\n<span flex hide show-gt-sm></span><form ng-submit=\"vm.viewData(1)\" name=\"formSearch\" flex><md-input-container \nmd-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div></md-toolbar><div \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><th class=\"secondary-text\" width=\"5%\" ng-if=\"vm.EmployeeService.status\"><div class=\"table-header\"><md-checkbox \naria-label=\"Select All\" ng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\" \nng-model=\"vm.checkall\"></md-checkbox></div></th><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">NIK</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">No SK</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">effective date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">direct report</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">to job grade</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">to emp grade</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">to company</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">to division</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">to department</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">to sub area</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">to gedung</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">jfm</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">sub jfm</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">acting</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.DataTable.list\" \nng-if=\"vm.EmployeeService.status\" ng-dblclick=\"vm.editInputPromotion($event,div)\" ng-click=\"vm.checkone(div)\"><td>\n<md-checkbox class=\"md-secondary\" aria-label=\"CutOffChecked\" ng-checked=\"vm.exists(div, vm.selected)\" \nng-click=\"vm.toggle(div, vm.selected)\"></md-checkbox></td><td>{{ ($index + 1)}}</td><td>{{ div.nik}}</td><td>\n{{ div.skNo}}</td><td>{{ div.effectiveDate}}</td><td>{{ div.directReport}}</td><td>{{ div.jobGrade}}</td><td>\n{{ div.empGrade}}</td><td>{{ div.company}}</td><td>{{ div.division}}</td><td>{{ div.department}}</td><td>\n{{ div.subArea}}</td><td>{{ div.gedung}}</td><td>{{ div.jfm}}</td><td>{{ div.jfmSub}}</td><td>{{ div.description}}</td>\n<td>{{ div.acting == \'1\'? \'YES\':\'NO\' }}</td></tr><tr ng-repeat=\"div in vm.DataTable.list\" \nng-if=\"!vm.EmployeeService.status\"><td>{{ ($index + 1)}}</td><td>{{ div.nik}}</td><td>{{ div.skNo}}</td><td>\n{{ div.effectiveDate}}</td><td>{{ div.directReport}}</td><td>{{ div.jobGrade}}</td><td>{{ div.empGrade}}</td><td>\n{{ div.company}}</td><td>{{ div.division}}</td><td>{{ div.department}}</td><td>{{ div.subArea}}</td><td>{{ div.gedung}}\n</td><td>{{ div.jfm}}</td><td>{{ div.jfmSub}}</td><td>{{ div.description}}</td><td>{{ div.acting == \'1\'? \'YES\':\'NO\' }}\n</td></tr></tbody></table></div><div class=\"p-24 mb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.viewData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/employee/employe/input-employe/profile/input-profile.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Certificate</span>\n</p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><form name=\"profilForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveProfile(profilForm)\"><div \nlayout=\"row\" layout-align=\"end center\"><p class=\"italic\" ng-show=\"vm.Form.objForm.status_approval==\'Waiting Approval\'\">\n<span translate=\"MYPROFILE.MENU.WAITING\">Waiting Approval</span></p><span ng-if=\"vm.Form.objForm.app_status==\'0\'\"><a \nhref=\"\" ng-click=\"vm.viewComment($event,vm.Form.objForm)\"><span translate=\"MYPROFILE.MENU.REJECTED\">Rejected</span></a>\n<md-tooltip md-direction=\"top\"><span translate=\"MYPROFILE.MENU.COMMENT\">View Comments</span></md-tooltip></span>\n<md-button ng-if=\"!vm.stateEdit\" ng-click=\"vm.ChangeState()\" type=\"button\" class=\"md-raised md-primary btn-ui-serif\" \naria-label=\"Submit\" ng-disabled=\"vm.Form.objForm.status_approval==\'Waiting Approval\'\"><span \ntranslate=\"MYPROFILE.MENU.EDIT\">Edit</span></md-button><md-button ng-if=\"vm.stateEdit\" ng-click=\"vm.ChangeState()\" \ntype=\"button\" class=\"md-raised md-yellow-500-bg black-fg\" aria-label=\"Submit\"><span \ntranslate=\"MYPROFILE.MENU.CANCELEDIT\">Cancel Edit</span></md-button></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><md-radio-group ng-model=\"vm.Form.objForm.title\" ng-disabled=\"!vm.stateEdit\" \nng-required=\"true\" name=\"title\" layout=\"row\" style=\"margin-top:0\" layout-align=\"start center\"><md-radio-button \nflex=\"nogrow\" value=\"Mr\" class=\"md-warn md-raised\"><div class=\"mt-5\">Mr</div></md-radio-button><md-radio-button \nflex=\"nogrow\" value=\"Mrs\" class=\"md-warn md-raised\" flex-offset=\"5\"><div class=\"mt-5\">Mrs</div></md-radio-button>\n<md-radio-button flex=\"nogrow\" value=\"Miss\" class=\"md-warn md-raised\" flex-offset=\"5\"><div class=\"mt-5\">Miss</div>\n</md-radio-button></md-radio-group><div ng-messages=\"profilForm.title.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Fields Required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"fullname\" ng-model=\"vm.fullname\" \nplaceholder=\"{{ \'MYPROFILE.MENU.FULLNAME\' | translate}}\" required md-maxlength=\"200\" ng-disabled=\"!vm.stateEdit\"><div \nng-messages=\"profilForm.fullname.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MYPROFILE.MESSAGE.FULLNAME\">Fullname is required</span> <span translate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span>\n</div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 200 huruf.</span></div></div></md-input-container>\n</div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex><input type=\"text\" \nname=\"nickname\" ng-model=\"vm.Form.objForm.nickName\" placeholder=\"{{ \'MYPROFILE.MENU.NICKNAME\' | translate}}\" \nmd-maxlength=\"45\" ng-disabled=\"!vm.stateEdit\"><div ng-messages=\"profilForm.nickname.$error\" role=\"alert\"><div \nng-message=\"md-maxlength\"><span>Max 45 Characters.</span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"MYPROFILE.MENU.GENDER\">Gender</span></label><md-select ng-model=\"vm.Form.objForm.jenkel\" \nng-required=\"true\" name=\"jenkel\" ng-disabled=\"!vm.stateEdit\"><md-option value=\"L\"><span \ntranslate=\"MYPROFILE.MENU.MALE\">MALE</span></md-option><md-option value=\"P\"><span translate=\"MYPROFILE.MENU.FEMALE\">\nFEMALE</span></md-option></md-select><div ng-messages=\"profilForm.jenkel.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MYPROFILE.MENU.GENDER\">Gender</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container><md-input-container flex><label><span \ntranslate=\"MYPROFILE.MENU.RELIGION\">Relogion</span></label><md-select ng-model=\"vm.Form.objForm.religion\" \nname=\"religion\" ng-disabled=\"!vm.stateEdit\"><md-option value=\"Islam\"><span translate=\"MYPROFILE.ITEM.ISLAM\">ISLAM\n</span></md-option><md-option value=\"Christian\"><span translate=\"MYPROFILE.ITEM.PROTESTAN\">KRISTEN PROTESTAN</span>\n</md-option><md-option value=\"Catholic\"><span translate=\"MYPROFILE.ITEM.KATOLIK\">KATOLIK</span></md-option><md-option \nvalue=\"Hindu\"><span translate=\"MYPROFILE.ITEM.HINDU\">HINDU</span></md-option><md-option value=\"Buddha\"><span \ntranslate=\"MYPROFILE.ITEM.BUDHA\">BUDHA</span></md-option><md-option value=\"KHONG HU CHU\"><span \ntranslate=\"MYPROFILE.ITEM.KONGHUCU\">KONG HU CU</span></md-option><md-option value=\"none\"><span \ntranslate=\"MYPROFILE.ITEM.NONE\">NONE</span></md-option></md-select><div ng-messages=\"profilForm.religion.$error\" \nrole=\"aSlert\"><div ng-message=\"required\"><span translate=\"MYPROFILE.MENU.RELIGION\">Relogion</span> <span \ntranslate=\"PAYROLL.MESSAGE.ISREQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.DATEOFBIRTH\">\nDate Of Birth</span></label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.Form.objForm.dateOfBirth\" \nmd-placeholder=\"Date Of Birth\" name=\"dateOfBirth\" ng-disabled=\"!vm.stateEdit\"></md-datepicker></md-input-container>\n<md-input-container flex><label><span translate=\"MYPROFILE.MENU.PLACEOFBIRTH\">Place Of Birth</span></label><input \nng-model=\"vm.Form.objForm.placeOfBirth\" md-maxlength=\"100\" name=\"placeOfBirth\" ng-disabled=\"!vm.stateEdit\"><div \nng-messages=\"profilForm.placeOfBirth.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 100 Character.\n</span></div></div></md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.MARTIAL\">\nMartial Status</span></label><md-select ng-model=\"vm.Form.objForm.maritalStatus\" ng-disabled=\"!vm.stateEdit\" \nng-change=\"vm.setShowUpload()\"><md-option ng-repeat=\"status in vm.maritalStatuses\" ng-value=\"status.id\">\n{{status.value | uppercase}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.showUpload\" \nclass=\"md-nabati1-theme\"><input accept=\"image/png, image/jpg, image/jpeg, image/jpg,application/pdf\" type=\"file\" \nid=\"uploadData\" nv-file-select=\"\" uploader=\"vm.uploader\" \noptions=\"{ formData: [{  \n                            profileId:vm.profileId,\n                            country:vm.country,\n                            title:vm.Form.objForm.title,\n                            martialStatus:vm.Form.objForm.maritalStatus\n                        }]}\" \nng-upload-change=\"vm.changeFile($event)\"><div class=\"md-errors-spacer\"></div><span \nstyle=\"color:red;font-style: italic\" ng-if=\"vm.Form.objForm.maritalStatus==\'Menikah\'\" \ntranslate=\"MYPROFILE.MESSAGE.MARRIAGE\"></span> <span style=\"color:red;font-style: italic\" \nng-if=\"vm.Form.objForm.maritalStatus==\'Janda\' || vm.Form.objForm.maritalStatus==\'Duda\'\" \ntranslate=\"MYPROFILE.MESSAGE.DIVORCED\"></span></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.COUNTRYBIRTH\">Country of Place Birth\n</span></label><md-select ng-model=\"vm.Form.objForm.countrycode_of_birth\" name=\"countrycode_of_birth\" \nng-disabled=\"!vm.stateEdit\"><md-option ng-repeat=\"country in vm.listCountry\" ng-value=\"country.countrycode\">\n{{country.name}}</md-option></md-select><div ng-messages=\"profilForm.countrycode_of_birth.$error\" role=\"alert\"><div \nng-message=\"required\"><span><span translate=\"MYPROFILE.MENU.COUNTRYBIRTH\"></span> is requered.</span></div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex><label>\n<span translate=\"MYPROFILE.MENU.HEIGHT\">Height</span></label><input ng-model=\"vm.Form.objForm.height\" type=\"number\" \nname=\"height\" min=\"100\" max=\"200\" ng-disabled=\"!vm.stateEdit\"><div ng-messages=\"profilForm.height.$error\" role=\"alert\">\n<div ng-message=\"min\"><span>Minimum 100 cm.</span></div><div ng-message=\"max\"><span>maximum 200 cm.</span></div></div>\n</md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.BLOODTYPE\">Blood Type</span>\n</label><input ng-model=\"vm.Form.objForm.bloodType\" name=\"bloodType\" md-maxlength=\"3\" ng-disabled=\"!vm.stateEdit\"><div \nng-messages=\"profilForm.bloodType.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 3 Character.</span>\n</div></div></md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.NATIONALITY\">\nNationality</span></label><md-select ng-model=\"vm.Form.objForm.nationality\" name=\"nationality\" \nng-disabled=\"!vm.stateEdit\"><md-option ng-repeat=\"country in vm.listCountry\" ng-value=\"country.countrycode\">\n{{country.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.ETHNIC\">Ethnic</span></label><input \nng-model=\"vm.Form.objForm.sukuBangsa\" name=\"sukuBangsa\" md-maxlength=\"45\" ng-disabled=\"!vm.stateEdit\"><div \nng-messages=\"profilForm.sukuBangsa.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span>Max 45 Character.</span>\n</div></div></md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.PHONENUMBER\">\nPhone Number</span></label><input ng-model=\"vm.Form.objForm.personalPhoneNumber\" name=\"personalPhoneNumber\" \nmd-maxlength=\"30\" ng-disabled=\"!vm.stateEdit\"><div ng-messages=\"profilForm.personalPhoneNumber.$error\" role=\"alert\">\n<div ng-message=\"md-maxlength\"><span>Max 30 Character.</span></div></div></md-input-container><md-input-container flex>\n<label><span translate=\"MYPROFILE.MENU.EMAIL\">Email</span></label><input type=\"email\" \nng-model=\"vm.Form.objForm.empEmail\" placeholder=\"Email\" name=\"email\" ng-disabled=\"!vm.stateEdit\"><div \nng-messages=\"profilForm.email.$error\" role=\"alert\"><div ng-message=\"email\"><span>Wrong Email Format.</span></div></div>\n</md-input-container></div><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front class=\"red-400-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 yellow-900-fg\"></md-icon>{{ vm.Form.pesan | translate}}</p></ms-widget-front>\n</ms-widget><div layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.stateEdit\" type=\"submit\" \nng-disabled=\"!vm.canUpdate || profilForm.$invalid || profilForm.$pristine\" class=\"md-raised md-blue-500-bg white-fg\" \naria-label=\"Submit\"><span translate=\"MYPROFILE.MENU.UPDATE\">Update</span></md-button></div></form>");
$templateCache.put("app/main/employee/employe/input-employe/profile/upload-photo.html","<md-dialog aria-label=\"Form Upload Photo\" flex-md=\"50\" flex-gt-md=\"50\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\">\n<h2>Upload Photo</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg has-upload\" layout=\"column\" layout-align=\"center\" layout-padding id=\"contentDialog\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><div layout=\"column\" flex><div ng-repeat=\"item in vm.FileUploaderPhoto.queue\" \nclass=\"mv-10\"><div ng-thumb=\"{ file: item._file, height: 200 }\" class=\"text-center\"></div></div><div flex \nclass=\"text-center\" style=\"margin-top:1em\" hide show-gt-sm><md-button \nng-disabled=\"vm.checkPhoto==null || vm.checkPhoto==\'undefined\' || vm.checkPhoto==\'-\' || vm.failPhoto\" type=\"button\" \nng-click=\"vm.downloadImage()\" class=\"md-raised md-button\" aria-label=\"{{vm.failPhoto}}\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon>Download</md-button></div></div><div layout=\"column\" flex class=\"p-5\"><div \nstyle=\"margin-top:1em\"><input type=\"file\" id=\"uploadPhoto\" nv-file-select uploader=\"vm.FileUploaderPhoto\" \noptions=\"{ formData: [{action:\'uploadPhoto\',empID:vm.Form.objForm.id}] }\"></div><div layout=\"row\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.FileUploaderPhoto.progress}}\" class=\"md-accent hue-2\"></md-progress-linear></div><div\n layout=\"row\" style=\"margin-top:1em\"><div flex layout=\"row\" layout-align=\"end center\" hide-gt-sm><md-button \nng-disabled=\"vm.checkPhoto==null || vm.checkPhoto==\'undefined\' || vm.checkPhoto==\'-\' || vm.failPhoto\" type=\"button\" \nng-click=\"vm.downloadImage()\" class=\"md-raised md-button\" aria-label=\"{{vm.failPhoto}}\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon>Download</md-button></div><div flex layout=\"row\" layout-align=\"end center\">\n<md-button type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" class=\"md-raised md-primary mh-0\" \naria-label=\"Submit\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload</md-button></div></div>\n</div></div><div layout=\"row\" ng-show=\"vm.UploadPhotoStateError || vm.UploadPhotoStateSucces\"><md-whiteframe \nclass=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.UploadPhotoStateError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Failed Upload data</span></md-whiteframe><md-whiteframe \nng-show=\"vm.UploadPhotoStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>Success Upload data</span></md-whiteframe></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/shiftsetting/input-shiftsetting.html","<md-dialog aria-label=\"Form Input Employe Shift\" flex-md=\"70\" flex-gt-md=\"50\"><form ng-cloack name=\"eduForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,eduForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Input Employe Shift</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><div layout-gt-sm=\"row\"><md-input-container\n flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"ShiftForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>effective_date Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Shift</label><md-select ng-model=\"vm.Form.objForm.location\" \nng-change=\"vm.changeRefshift(vm.Form.objForm.location)\" ng-required=\"true\" name=\"location\"><md-option \nng-repeat=\"l in vm.listLocation\" value=\"{{l.location}}\">{{l.shift_name}}</md-option></md-select><div \nng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>Location harus di pilih.</span>\n</div></div></md-input-container></div><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\"><div class=\"row\"><div flex layout=\"row\" layout-padding \nlayout-align=\"start center\"><md-radio-button ng-if=\"vm.shift1\" flex ng-value=\"1\" class=\"md-primary\" \nname=\"start_template\">Shift 1</md-radio-button><md-radio-button ng-if=\"vm.shift2\" flex ng-value=\"2\" class=\"md-primary\" \nname=\"start_template\">Shift 2</md-radio-button><md-radio-button ng-if=\"vm.shift3\" flex ng-value=\"3\" class=\"md-primary\" \nname=\"start_template\">Shift 3</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"submit\" ng-disabled=\"ShiftForm.$invalid || ShiftForm.$pristine\" \nclass=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\">Save</md-button></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"eduForm.$invalid || eduForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/shiftsetting/list-shiftsetting.html","<div class=\"toolbar layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.EmployeeService.status\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><md-button class=\"md-green-300-bg md-raised md-primary white-fg\" \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.openInputEducation($event)\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\">Insert</md-button><div class=\"divider-vertical hide show-gt-sm\" hide \nshow-gt-sm></div><md-button class=\"md-button md-ink-ripple\" type=\"button\" aria-label=\"Delete\" \nng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\">Delete\n</md-button></div></div><div class=\"white-bg\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" id=\"datatable\"><thead><tr><th class=\"secondary-text\" \nwidth=\"5%\"><div class=\"table-header\"><input type=\"checkbox\" ng-model=\"vm.selectAll\" \nng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Shift Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Effecttive Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Start Shift</span></div></th></tr></thead><tbody><tr ng-repeat=\"div in vm.listData\" \nng-dblclick=\"vm.editInputEducation($event,div)\" ng-click=\"vm.checkone(div)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td>{{div.shift_name}}</td><td>{{div.effective_date}}\n</td><td>{{div.start_template}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/employee/employe/input-employe/shiftsetting/shiftsetting.html","<form name=\"ShiftForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(ShiftForm)\"><div layout-gt-sm=\"row\">\n<md-input-container flex><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"effective_date\" \nng-model=\"vm.Form.objForm.effective_date\" required></md-datepicker><div ng-messages=\"ShiftForm.effective_date.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>effective_date Date is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Location</label><md-select ng-model=\"vm.Form.objForm.location\" \nng-change=\"vm.changeRefshift(vm.Form.objForm.location)\" ng-required=\"true\" name=\"location\"><md-option \nng-repeat=\"l in vm.listLocation\" value=\"{{l}}\">{{l.shift_name}}</md-option></md-select><div \nng-messages=\"ShiftForm.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>Location harus di pilih.</span>\n</div></div></md-input-container></div><md-input-container flex><h2>Start Template</h2><md-divider></md-divider>\n<md-radio-group ng-model=\"vm.Form.objForm.start_template\" ng-required=\"true\"><div class=\"row\"><div flex layout=\"row\" \nlayout-padding layout-align=\"start center\"><md-radio-button ng-if=\"vm.shift1\" flex ng-value=\"1\" class=\"md-primary\" \nname=\"start_template\">Shift 1</md-radio-button><md-radio-button ng-if=\"vm.shift2\" flex ng-value=\"2\" class=\"md-primary\" \nname=\"start_template\">Shift 2</md-radio-button><md-radio-button ng-if=\"vm.shift3\" flex ng-value=\"3\" class=\"md-primary\" \nname=\"start_template\">Shift 3</md-radio-button></div></div></md-radio-group><div \nng-messages=\"ShiftForm.start_template.$error\" role=\"alert\"><div ng-message=\"required\"><span>Start Template is required.\n</span></div></div></md-input-container><ms-widget flippable=\"false\" layout=\"column\" layout-align=\"center start \" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"submit\" ng-disabled=\"ShiftForm.$invalid || ShiftForm.$pristine\" \nclass=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\">Save</md-button></div></form>");
$templateCache.put("app/main/employee/employe/input-employe/skjic/input-skjic.html","<md-dialog aria-label=\"Form Input SK JIC\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"skjicForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,skjicForm)\"><md-toolbar class=\"md-cyan-600-bg\"><div \nclass=\"md-toolbar-tools\"><h2>Form Input SK JIC</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><input type=\"hidden\" name=\"empId\" \nng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" name=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" \nng-if=\"vm.Form.objForm.oldId\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container><label>SK Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"skDate\" ng-model=\"vm.Form.objForm.skDate\" required></md-datepicker><div \nng-messages=\"skjicForm.skDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>SK Date Required.</span></div>\n</div></md-input-container><md-input-container flex><label>No SK</label><input ng-model=\"vm.Form.objForm.noSk\" \nname=\"noSk\" required><div ng-messages=\"skjicForm.noSk.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNo SK Required.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"skjicForm.$invalid || skjicForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/skjic/list-skjic.html","<md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools white\"><md-menu md-offset=\"0 -7\" \nhide-gt-sm ng-if=\"vm.EmployeeService.status\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputSkjic($event)\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Insert</md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-warn\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container><select class=\"black-fg\" name=\"see\" id=\"ss\" ng-change=\"vm.viewData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"black-fg\">Entries\n</span></md-input-container><md-button ng-if=\"vm.EmployeeService.status\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputSkjic($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>Add</md-button><md-button \nng-if=\"vm.EmployeeService.status\" class=\"md-button md-ink-ripple md-warn md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Delete</md-button>\n<span flex hide show-gt-sm></span><form ng-submit=\"vm.viewData(1)\" name=\"formSearch\" flex><md-input-container \nmd-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div></md-toolbar><div \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><th class=\"secondary-text\" width=\"5%\" ng-if=\"vm.EmployeeService.status\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th \nclass=\"secondary-text\" width=\"15%\"><div class=\"table-header\"><span class=\"column-title\">SK Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">No SK</span></div></th></tr></thead><tbody>\n<tr ng-if=\"vm.EmployeeService.status\" ng-repeat=\"div in vm.DataTable.list\" \nng-dblclick=\"vm.editInputEmployement($event,div)\" ng-click=\"vm.checkone(div)\"><td><input type=\"checkbox\" \nchecklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td>{{ ($index + 1)}}</td><td>{{ div.sk_date}}</td>\n<td>{{ div.sk_no}}</td></tr><tr ng-if=\"!vm.EmployeeService.status\" ng-repeat=\"div in vm.DataTable.list\"><td>\n{{ ($index + 1)}}</td><td>{{ div.sk_date}}</td><td>{{ div.sk_no}}</td></tr><tr class=\"text-center\" \nng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td ng-if=\"vm.EmployeeService.status\" colspan=\"4\" \nclass=\"text-center\"><span class=\"font-size-12\">Please Wait</span></td><td ng-if=\"!vm.EmployeeService.status\" \ncolspan=\"3\" class=\"text-center\"><span class=\"font-size-12\">Please Wait</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td ng-if=\"vm.EmployeeService.status\" colspan=\"4\" class=\"text-center\"><span \nclass=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td><td \nng-if=\"!vm.EmployeeService.status\" colspan=\"3\" class=\"text-center\"><span class=\"font-size-12\" \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></div><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.viewData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/employee/employe/input-employe/status/input-status.html","<md-dialog aria-label=\"Form Input Status\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"statusForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,statusForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Status</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><input \ntype=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" name=\"oldId\" \nng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><div class=\"alert-info warning italic md-body-1\" ng-if=\"vm.stateEdit\"><div layout=\"row\" \nclass=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s24 mr-15 yellow-900-fg md-font material-icons md-nabati1-theme icon-alert\" aria-hidden=\"true\" flex=\"nogrow\">\n</md-icon><span layout=\"column\" flex><span class=\"font-size-12\">Radio buttons to change the employee type are disabled\n</span> <span class=\"font-size-12\">To change this employee type you can delete this data and re-input with new data.\n</span></span></div></div><md-radio-group ng-model=\"vm.Form.objForm.status\" layout=\"column\" layout-gt-xs=\"row\" \nng-switch on=\"vm.Form.objForm.status\" ng-disabled=\"vm.stateEdit\" ng-required=\"true\" name=\"status\"><div layout=\"row\">\n<md-radio-button value=\"Permanent\" class=\"md-warn md-raised\"><span class=\"pt-5\" style=\"display: block\">Permanent</span>\n</md-radio-button><md-radio-button value=\"Contract\" class=\"md-warn md-raised\"><span class=\"pt-5\" \nstyle=\"display: block\">Contract</span></md-radio-button><md-radio-button value=\"Probation\" class=\"md-warn md-raised\">\n<span class=\"pt-5\" style=\"display: block\">Probation</span></md-radio-button></div><div layout=\"row\" flex \nflex-offset=\"10\"><md-radio-button value=\"Parttime\" class=\"md-warn md-raised\"><span class=\"pt-5\" style=\"display: block\">\nParttime</span></md-radio-button><md-radio-button value=\"Pelatihan\" class=\"md-warn md-raised\"><span class=\"pt-5\" \nstyle=\"display: block\">Pelatihan</span></md-radio-button><md-radio-button value=\"Borongan\" class=\"md-warn md-raised\">\n<span class=\"pt-5\" style=\"display: block\">Borongan</span></md-radio-button></div></md-radio-group><div \nng-messages=\"statusForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span>Fields Required.</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"overflow-x: hidden\"><md-input-container\n flex ng-if=\"!vm.stateEdit\"><label>NIK</label><md-select ng-model=\"vm.Form.objForm.nik\" name=\"nik\" \nng-model-options=\"{trackBy: \'$value\'}\"><md-option ng-repeat=\"nik in vm.arrayNik\" ng-value=\"nik\">{{nik}}</md-option>\n</md-select></md-input-container><md-input-container flex ng-if=\"vm.stateEdit\"><label>NIK</label><input \nng-model=\"vm.Form.objForm.nik\" ng-disabled=\"true\"></md-input-container><md-input-container flex flex-offset-gt-xs=\"5\">\n<label>Start Date</label><md-datepicker md-hide-icons=\"calendar\" name=\"startDate\" ng-model=\"vm.Form.objForm.startDate\" \nrequired></md-datepicker><div ng-messages=\"statusForm.startDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nStart Date Required.</span></div></div></md-input-container><div ng-switch=\"vm.Form.objForm.status\" flex \nlayout=\"column\" flex-offset-gt-xs=\"5\"><div ng-switch-when=\"Pelatihan|Probation|Contract|Parttime|Borongan\" \nng-switch-when-separator=\"|\" flex layout=\"column\"><md-input-container flex><label>End Date</label><md-datepicker \nmd-hide-icons=\"calendar\" name=\"endDate\" ng-model=\"vm.Form.objForm.endDate\" required></md-datepicker><div \nng-messages=\"statusForm.endDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>End Date Required.</span></div>\n</div></md-input-container></div><div ng-switch-when=\"Permanent\" flex layout=\"column\" flex-offset-gt-xs=\"5\">\n<md-input-container flex><label>No SK</label><input ng-model=\"vm.Form.objForm.noSk\" name=\"noSk\" required><div \nng-messages=\"statusForm.noSk.$error\" role=\"alert\"><div ng-message=\"required\"><span>No SK Required.</span></div></div>\n</md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\">\n<ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"statusForm.$invalid || statusForm.$pristine\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/status/list-status.html","<md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools white\"><md-menu md-offset=\"0 -7\" \nhide-gt-sm ng-if=\"vm.EmployeeService.status\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputStatus($event)\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Insert</md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-warn\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button></md-menu-item>\n</md-menu-content></md-menu><md-button ng-if=\"vm.EmployeeService.status\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputStatus($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>Add</md-button><md-button \nng-if=\"vm.EmployeeService.status\" class=\"md-button md-ink-ripple md-warn md-mini\" hide show-gt-sm type=\"button\" \naria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Delete</md-button>\n<span flex hide show-gt-sm></span><form ng-submit=\"vm.viewData(1)\" name=\"formSearch\" flex><md-input-container \nmd-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div></md-toolbar><div \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><th class=\"secondary-text\" width=\"5%\" ng-if=\"vm.EmployeeService.status\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\">\n</span></span></div></th><th class=\"secondary-text\" width=\"15%\"><div class=\"table-header\"><span class=\"column-title\">\n<span translate=\"KPI.LABEL.NIK\"></span></span></div></th><th class=\"secondary-text\" width=\"15%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.STATUS\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.STARTDATE\">\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"KPI.LABEL.ENDDATE\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><span translate=\"KPI.LABEL.SKNUMBER\"></span></span></div></th></tr></thead><tbody><tr \nng-if=\"vm.EmployeeService.status\" ng-repeat=\"div in vm.DataTable.list\" ng-dblclick=\"vm.editInputStatus($event,div)\" \nng-click=\"vm.checkone(div)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" \nchecklist-value=\"div\"></td><td class=\"text-center\">{{ (vm.DataTable.offset + $index + 1)}}</td><td class=\"text-center\">\n{{ div.nik}}</td><td class=\"text-center\">{{ div.status}}</td><td class=\"text-center\">{{ div.start_date}}</td><td \nclass=\"text-center\" ng-if=\"div.status != \'Permanent\'\">{{ div.end_date}}</td><td class=\"text-center\" \nng-if=\"div.status == \'Permanent\'\"></td><td class=\"text-center\">{{ div.no_sk}}</td></tr><tr \nng-if=\"!vm.EmployeeService.status\" ng-repeat=\"div in vm.DataTable.list\"><td class=\"text-center\">\n{{ (vm.DataTable.offset + $index + 1)}}</td><td class=\"text-center\">{{ div.nik}}</td><td class=\"text-center\">\n{{ div.status}}</td><td class=\"text-center\">{{ div.start_date}}</td><td class=\"text-center\" \nng-if=\"div.status != \'Permanent\'\">{{ div.end_date}}</td><td class=\"text-center\" ng-if=\"div.status == \'Permanent\'\"></td>\n<td class=\"text-center\">{{ div.no_sk}}</td></tr><tr class=\"text-center\" \nng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td ng-if=\"vm.EmployeeService.status\" colspan=\"8\" \nclass=\"text-center\"><span class=\"font-size-12\">Please Wait</span></td><td ng-if=\"!vm.EmployeeService.status\" \ncolspan=\"7\" class=\"text-center\"><span class=\"font-size-12\">Please Wait</span></td></tr><tr class=\"text-center\" \nng-if=\"vm.DataTable.list.length <= 0\"><td ng-if=\"vm.EmployeeService.status\" colspan=\"8\" class=\"text-center\"><span \nclass=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td><td \nng-if=\"!vm.EmployeeService.status\" colspan=\"7\" class=\"text-center\"><span class=\"font-size-12\" \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></div><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div></div>");
$templateCache.put("app/main/employee/employe/input-employe/tax/input-tax.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\">Hide Detail</span></md-button></span></div>\n</div><div layout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item \nng-click=\"vm.viewMenus(\'profile\')\"><p><span translate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p><span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'dependent\')\"><p><span>Dependent Or Family Card Document</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Certificate</span>\n</p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">\nDriver\'s License</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EDUCATION\">Education</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.education\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'experience\')\"><p><span translate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.experience\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p><span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p>\n<md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span translate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div>\n</div><form name=\"bankForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(bankForm)\"><div layout=\"row\" \nlayout-align=\"end center\"><p class=\"italic\" ng-show=\"vm.Form.objForm.statusApproval==\'Waiting Approval\'\"><span \ntranslate=\"MYPROFILE.MENU.WAITING\"></span></p><span ng-if=\"vm.Form.objForm.statusApproval==\'Rejected\'\"><a href=\"\" \nng-click=\"vm.viewComment($event,vm.Form.objForm)\"><span translate=\"MYPROFILE.MENU.REJECTED\"></span></a><md-tooltip \nmd-direction=\"top\"><span translate=\"MYPROFILE.MENU.COMENT\"></span></md-tooltip></span><md-button ng-if=\"!vm.stateEdit\" \nng-click=\"vm.ChangeState()\" type=\"button\" class=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\" \nng-disabled=\"vm.Form.objForm.statusApproval==\'Waiting Approval\'\"><span translate=\"MYPROFILE.MENU.EDIT\"></span>\n</md-button><md-button ng-if=\"vm.stateEdit\" ng-click=\"vm.ChangeState()\" type=\"button\" \nclass=\"md-raised md-yellow-500-bg white-fg\" aria-label=\"Submit\"><span translate=\"MYPROFILE.MENU.CANCELEDIT\"></span>\n</md-button><div ng-if=\"vm.country==\'IDN\' && vm.stateEdit\"><md-button ng-if=\"!vm.stateview\" \nng-click=\"vm.uploadNpwp($event)\" type=\"button\" class=\"md-raised md-grey-500-bg white-fg\" aria-label=\"Submit\">\nUpload NPWP</md-button><md-button ng-if=\"vm.stateview\" ng-click=\"vm.viewNpwp($event)\" type=\"button\" \nclass=\"md-raised md-green-300-bg white-fg\" aria-label=\"Submit\">View NPWP</md-button></div></div><md-input-container \nclass=\"md-block\"><label><span translate=\"MYPROFILE.MENU.TAXNUMBER\"></span></label><input \nng-model=\"vm.Form.objForm.taxNumber\" md-maxlength=\"50\" required placeholder=\"Tax Number\" name=\"taxNumber\" \nng-disabled=\"!vm.stateEdit\"><div ng-messages=\"bankForm.taxNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTax Number Required.</span></div><div ng-message=\"md-maxlength\"><span>Max 50 Character.</span></div></div>\n</md-input-container><md-input-container md-no-float class=\"md-block\"><label><span translate=\"MYPROFILE.MENU.STATUS\">\n</span></label><md-select ng-model=\"vm.Form.objForm.taxStatus\" required name=\"taxStatus\" ng-disabled=\"true\"><md-option \nng-repeat=\"ls in vm.taxStatusList\" value=\"{{ls.id}}\">{{ls.name}}</md-option></md-select><div \nng-messages=\"bankForm.taxStatus.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tax Status Required.</span></div>\n<div ng-message=\"md-maxlength\"><span>Max 45 Character.</span></div></div></md-input-container><ms-widget \nflippable=\"false\" layout=\"column\" layout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\">\n<ms-widget-front class=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div layout=\"row\" \nlayout-align=\"center center\"><md-button ng-if=\"vm.stateEdit\" type=\"submit\" \nng-disabled=\"bankForm.$invalid || bankForm.$pristine\" class=\"md-raised md-blue-500-bg white-fg\" aria-label=\"Submit\">\n<span translate=\"MYPROFILE.MENU.UPDATE\"></span></md-button></div></form>");
$templateCache.put("app/main/employee/employe/input-employe/tax/tax-upload.html","<md-dialog aria-label=\"Form Upload Pajak\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadNpwp\" \nclass=\"md-inline-form popup-input-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div ng-if=\"vm.country==\'IDN\'\" \nclass=\"md-toolbar-tools\"><h2>Upload NPWP</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg has-upload\"><md-input-container md-no-float class=\"md-block\">\n<label>ID No</label><input ng-model=\"vm.documentNo\" name=\"documentNo\" required md-maxlength=\"100\"><div \nng-messages=\"uploadNpwp.documentNo.$error\" role=\"alert\"><div ng-message=\"required\"><span>Dokumen No harus di isi.\n</span></div><div ng-message=\"md-maxlength\"><span>Tidak boleh lebih dari 100 huruf.</span></div></div>\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Tanggal NPWP Diterbitkan\n</label><md-datepicker name=\"issuedDate\" md-hide-icons=\"calendar\" ng-model=\"vm.issuedDate\" required></md-datepicker>\n<div ng-messages=\"uploadNpwp.issuedDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tanggal harus di isi.\n</span></div></div></md-input-container></div><md-input-container md-no-float class=\"md-block\"><label>Description\n</label><input ng-model=\"vm.description\" name=\"description\"></md-input-container><div class=\"md-block\"><label \nfor=\"uploadNpwp\">Max Size 2 MB</label><input type=\"file\" id=\"uploadNpwp\" nv-file-select required \nuploader=\"vm.FileUploaderNpwp\" \noptions=\"{ formData: [{\n          action: \'uploadnpwp\',\n          documentNo: vm.documentNo,\n          empID:vm.empID,\n          typeOfDocument: \'npwp\',\n          expiredDate: \'9999-12-31\',\n          issuedDate: vm.issuedDate,\n          description: vm.description\n        }]}\">\n<md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.fileSizeError\" style=\"margin-top:20px\" flex layout \nlayout-align=\"center center\" layout-padding><span>File size is too large, your file has size {{ vm.itemSize }}</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.UploadNpwpStateError\" class=\"md-whiteframe-1dp md-red-500-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Failed Upload data</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.uploadNpwpStateSucces\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>Success Upload data</span>\n</md-whiteframe></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><span flex></span>\n<md-button type=\"button\" ng-click=\"vm.upload()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\" \nng-disabled=\"uploadNpwp.$invalid || uploadNpwp.$pristine\"><md-icon md-font-icon=\"icon-upload\" class=\"teal-50-fg\">\n</md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/tax/view-doc.html","<md-dialog aria-label=\"Form Upload Photo\" flex=\"50\" md-theme=\"modal-theme\"><form ng-cloack name=\"uploadPhoto\" \nclass=\"md-inline-form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>View NPWP</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.doc_type\" class=\"md-background-bg\" \nid=\"contentDialog\" style=\"width: 800px\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" \nng-click=\"vm.downloadDoc($this)\" aria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip\n md-direction=\"right\">Download this image</md-tooltip></md-button><iframe src=\"{{vm.url}}\" \nstyle=\"width:100%; height:70vh; display:block\" frameborder=\"0\"></iframe></md-dialog-content><md-dialog-content \nng-if=\"!vm.doc_type\"><md-button class=\"md-fab down-custom md-light-green-800-bg\" ng-click=\"vm.downloadDoc($this)\" \naria-label=\"Use Android\"><md-icon class=\"icon-download white-fg\"></md-icon><md-tooltip md-direction=\"right\">\nDownload this image</md-tooltip></md-button><img style=\"margin: auto; display:block; max-width: 100%\" \nalt=\"Lush mango tree\" src=\"api/empdocument/{{vm.doc}}\"></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/training/input-training.html","<md-dialog aria-label=\"Form Input Training\" flex-md=\"80\" flex-gt-md=\"60\"><form ng-cloack name=\"trainForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,trainForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Training</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" \nname=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout=\"column\"><md-input-container \nflex><label><span translate=\"MYPROFILE.MENU.TRAININGTYPE\"></span></label><input \nng-model=\"vm.Form.objForm.typeOfTraining\" name=\"typeOfTraining\" required></md-input-container><md-input-container \nmd-no-float class=\"md-block\" flex><label><span translate=\"MYPROFILE.MENU.SPECIFICATION\"></span></label><textarea \nng-model=\"vm.Form.objForm.specificationOfTraining\" required \nplaceholder=\"{{ \'MYPROFILE.MENU.SPECIFICATION\' | translate}}\"></textarea></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex><label><span translate=\"MYPROFILE.MENU.START\"></span></label><md-datepicker\n md-hide-icons=\"calendar\" name=\"startDate\" ng-model=\"vm.Form.objForm.startDate\" required></md-datepicker>\n</md-input-container><md-input-container flex><label><span translate=\"MYPROFILE.MENU.FINISH\"></span></label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"finishDate\" ng-model=\"vm.Form.objForm.finishDate\" required>\n</md-datepicker></md-input-container></div><md-input-container flex><md-radio-group \nng-model=\"vm.Form.objForm.isCertificate\" ng-required=\"true\" name=\"isCertificate\" ng-change=\"vm.changeCertificate()\">\n<md-radio-button value=\"1\" class=\"md-warn md-raised\">Certified</md-radio-button>&nbsp;&nbsp;<md-radio-button value=\"0\" \nclass=\"md-warn md-raised\">No Certified</md-radio-button></md-radio-group></md-input-container><md-input-container \nmd-no-float class=\"md-block\"><div ng-if=\"vm.cert\"><input type=\"file\" id=\"uploadPhoto\" name=\"uploadPhoto\" \nng-model=\"vm.Form.objForm.image\" nv-file-select uploader=\"vm.FileUploaderPhoto\" ng-change=\"vm.setUpload($event)\"> <img \nng-src=\"{{imageSrc}}\"> <small>file Size : {{vm.sizefile/1024/1024 | number:2 }} MB of Max file upload 2Mb.</small><div \nng-messages=\"trainForm.uploadPhoto.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.sizefile>2097152\"><span>\nMaximum file size 2 MB</span></div></div></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" layout=\"column\" layout-align=\"center start\" \nng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan | translate}}</p></ms-widget-front></ms-widget><span \nflex></span><md-button ng-if=\"vm.cert\" type=\"button\" ng-click=\"vm.FileUploaderPhoto.uploadAll()\" \nng-disabled=\"form.$invalid || form.$pristine || vm.sizefile>2097152\" class=\"md-raised md-blue-500-bg white-fg\" \naria-label=\"Submit\">Submit</md-button><md-button class=\"md-raised md-blue-500-bg white-fg\" ng-if=\"!vm.cert\" \ntype=\"submit\" aria-label=\"Submit\" ng-disabled=\"form.$invalid || form.$pristine\">Submit</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/training/list-training.html","<div class=\"alert-info warning italic md-body-1\" ng-if=\"!vm.completion\"><div layout-gt-sm=\"row\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"90\"><span><p class=\"form-messages\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16 yellow-900-fg\"></md-icon><span translate=\"MYPROFILE.MESSAGE.INCOMPLITE\">\nYour profiles uncompleted, please update your profiles</span></p></span></div><div layout=\"row\" \nlayout-align=\"end start\"><span ng-if=\"!vm.Completed\"><md-button ng-click=\"vm.viewCompletion()\"><span \ntranslate=\"MYPROFILE.MENU.SHOWDETAIL\">Show Detail</span></md-button></span><span ng-if=\"vm.Completed\"><md-button \nng-click=\"vm.viewCompletion()\"><span translate=\"MYPROFILE.MENU.HIDEDETAIL\"></span></md-button></span></div></div><div \nlayout-gt-sm=\"column\" ng-if=\"vm.Completed\"><md-list ng-cloak><md-list-item ng-click=\"vm.viewMenus(\'profile\')\"><p><span \ntranslate=\"MYPROFILE.MENU.PROFILES\">Profiles</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.profiles\"></md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'address\')\"><p>\n<span translate=\"MYPROFILE.MENU.ADDRESS\">Address</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.address\"></md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'dependent\')\">\n<p><span>Dependent Or Family Card Document</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.dependents\"></md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'document\')\">\n<p><span translate=\"MYPROFILE.MENU.IDENTITY\">Identity Card</span></p><md-checkbox class=\"md-secondary\" \nng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ktp\"></md-checkbox></md-list-item><md-list-item \nng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.CERTIFICATE\">Certificate</span></p><md-checkbox \nclass=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_ijazah\"></md-checkbox></md-list-item>\n<md-list-item ng-click=\"vm.viewMenus(\'document\')\"><p><span translate=\"MYPROFILE.MENU.DRIVER\">Driver\'s License</span>\n</p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.doc_sim\"></md-checkbox>\n</md-list-item><md-list-item ng-click=\"vm.viewMenus(\'education\')\"><p><span translate=\"MYPROFILE.MENU.EDUCATION\">\nEducation</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" ng-model=\"vm.listCompletion.education\">\n</md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'experience\')\"><p><span \ntranslate=\"MYPROFILE.MENU.EXPERIENCE\">Work Experience</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.experience\"></md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'bank\')\"><p>\n<span translate=\"MYPROFILE.MENU.BANK\">Bank</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.bank\"></md-checkbox></md-list-item><md-list-item ng-click=\"vm.viewMenus(\'tax\')\"><p><span \ntranslate=\"MYPROFILE.MENU.TAX\">TAX</span></p><md-checkbox class=\"md-secondary\" ng-disabled=\"true\" \nng-model=\"vm.listCompletion.tax\"></md-checkbox></md-list-item></md-list></div></div><div class=\"white-bg\"><md-toolbar \nmd-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputTraining($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button><md-button class=\"md-button md-ink-ripple md-accent md-mini\" \ntype=\"button\" aria-label=\"Inert\" ng-disabled=\"vm.listDataSelected.length == 0\" ng-click=\" vm.deleteData($event)\">\n<md-icon ng-if=\"vm.listDataSelected.length > 0\" md-font-icon=\"icon-trash red-700-fg\"></md-icon><md-icon \nng-if=\"vm.listDataSelected.length == 0\" md-font-icon=\"icon-trash grey-700-fg\"></md-icon><span \nng-if=\"vm.listDataSelected.length > 0\" class=\"red-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span \nng-if=\"vm.listDataSelected.length == 0\" class=\"grey-700-fg\"><span translate=\"PAYROLL.MENU.DELETE\"></span></span> <span \nstyle=\"color:red\" ng-if=\"vm.listDataSelected.length > 0\">{{ vm.listDataSelected.length }} <span \ntranslate=\"HCTICKET.MENU.SELECTED\"></span></span></md-button><md-menu md-offset=\"0 -7\" hide-gt-sm><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-menu icon\" style=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button class=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"inputTraining\" \nng-click=\"vm.openInputTraining($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon><span \ntranslate=\"MYPROFILE.MENU.ADD\"></span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-mini\" type=\"button\" aria-label=\"deleteData\" ng-click=\"vm.deleteData($event)\"><md-icon\n md-font-icon=\"icon-delete\"></md-icon><span translate=\"MYPROFILE.MENU.DELETE\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table id=\"tb-kpi-setting\"><thead><tr><th class=\"secondary-text\" width=\"5%\"><div class=\"table-header\">\n<input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"secondary-text\" width=\"5%\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.NO\"></span></span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.TRAININGTYPE\"></span></span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"MYPROFILE.MENU.SPECIFICATION\"></span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><span translate=\"MYPROFILE.MENU.START\"></span></span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\"><span translate=\"MYPROFILE.MENU.FINISH\"></span></span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"div in vm.listData\" ng-dblclick=\"vm.editInputTraining($event,div)\" \nng-click=\"vm.checkone(div)\"><td class=\"text-center\"><input type=\"checkbox\" checklist-model=\"vm.listDataSelected\" \nchecklist-value=\"div\"></td><td class=\"text-center\">{{ ($index + 1)}}</td><td>{{ div.type_of_training | uppercase}}</td>\n<td>{{ div.specification_of_training | uppercase}}</td><td class=\"text-center\">{{ div.start_date}}</td><td \nclass=\"text-center\">{{ div.finish_date}}</td></tr><tr class=\"text-center\" \nng-if=\"(vm.listData | typeOf) == \'undefined\'\"><td colspan=\"6\" class=\"text-center\"><span class=\"font-size-12\">\nPlease Wait</span></td></tr><tr class=\"text-center\" ng-if=\"vm.listData.length <= 0\"><td colspan=\"6\" \nclass=\"text-center\"><span class=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr>\n</tbody></table></div>");
$templateCache.put("app/main/employee/employe/input-employe/termination/termination.html","<form layout=\"column\" name=\"terminateForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData(terminateForm)\">\n<md-toolbar md-theme=\"table-toolbar-theme\" layout=\"column\"><div class=\"md-toolbar-tools table-tools white\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button type=\"submit\" \nng-disabled=\"terminateForm.$invalid || terminateForm.$pristine\" class=\"md-raised md-primary\" aria-label=\"Submit\">\nSave Termination</md-button><md-button ng-disabled=\"!vm.terminated()\" ng-click=\"vm.CancelTerminate()\" type=\"button\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\">Cancel Termination</md-button><div layout=\"column\" \nlayout-align=\"start end\" flex><div ng-if=\"vm.terminated()\" \nclass=\"label md-orange-800-bg ml-20 pv-5 ph-10 font-size-12 font-bold\" flex=\"nogrow\">Terminated</div><div \nng-if=\"!vm.terminated()\" class=\"label md-green-600-bg ml-20 pv-5 ph-10 font-size-12 font-bold\" flex=\"nogrow\">\nEmployee Active</div></div></div></div></md-toolbar><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start \" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><div \nlayout=\"column\" layout-gt-xs=\"row\" class=\"mh-20 mt-40\"><md-input-container flex flex-gt-xs=\"35\"><label>Inactive Date\n</label><md-datepicker md-hide-icons=\"calendar\" name=\"inactive_date\" ng-model=\"vm.Form.objForm.inactive_date\" required>\n</md-datepicker></md-input-container><md-input-container flex flex-offset-gt-xs=\"5\"><label>Termination Type</label>\n<md-select ng-model=\"vm.Form.objForm.terminationType\" name=\"terminationType\" md-on-close=\"vm.clearSearchTerm()\" \nrequired><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"Search...\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"terminationType\"><md-option \nvalue=\"{{ls.id}}\" ng-repeat=\"ls in vm.terminationTypeList | filter:vm.searchTerm\">{{ls.name}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"terminateForm.terminationType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTermination Type is Required.</span></div></div></md-input-container></div><md-input-container class=\"mt-15 mh-20\">\n<label>Reason</label><input ng-model=\"vm.Form.objForm.reason\" required placeholder=\"Reason\" md-maxlength=\"45\" \nname=\"reason\"><div ng-messages=\"terminateForm.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nReason Is Required.</span></div><div ng-message=\"md-maxlength\"><span>Max 45 Character.</span></div></div>\n</md-input-container></form>");
$templateCache.put("app/main/employee/employe/input-employe/user-manual/user-manual.html","<div class=\"white-bg\"><div layout-xs=\"column\" layout=\"row\"><div ng-if=\"vm.tutorial_type === \'ebook\'\" flex-xs \nflex-gt-xs=\"100\" layout=\"column\"><iframe src=\"{{vm.url}}\" style=\"width:100%; height:80vh\" frameborder=\"0\"></iframe>\n</div></div></div>");
$templateCache.put("app/main/employee/employe/input-employe/worklocation/input-worklocation.html","<md-dialog aria-label=\"Form Input Work Location\" flex-md=\"50\" flex-gt-md=\"50\"><form ng-cloack name=\"worklocationForm\" \nclass=\"md-inline-form popup-input-form\" novalidate ng-submit=\"vm.saveData($event,worklocationForm)\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Form Input Work Location</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nid=\"contentDialog\"><input type=\"hidden\" name=\"empId\" ng-model=\"vm.Form.objForm.empId\"> <input type=\"hidden\" \nname=\"oldId\" ng-model=\"vm.Form.objForm.oldId\" ng-if=\"vm.Form.objForm.oldId\"><div layout=\"column\"><md-input-container \nflex><label>Location</label><md-select ng-model=\"vm.Form.objForm.location_id\" name=\"subarea\" \nmd-on-close=\"vm.clearSearchTerm()\" required><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Search for a sub area...\" autocomplete=\"off\"></md-select-header>\n<md-optgroup label=\"subarea\"><md-option value=\"{{ls.id}}\" ng-repeat=\"ls in vm.listMenu | filter:vm.searchTerm\">\n{{ls.description}}</md-option></md-optgroup></md-select><div ng-messages=\"worklocationForm.location_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Location is required.</span></div></div></md-input-container><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"35\" class=\"mt-30\"><label>Effective Date</label>\n<md-datepicker md-hide-icons=\"calendar\" name=\"effectiveDate\" ng-model=\"vm.Form.objForm.effectiveDate\" required>\n</md-datepicker><div ng-messages=\"worklocationForm.effectiveDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEffective Date Required.</span></div></div></md-input-container><md-input-container flex flex-gt-xs=\"60\" \nflex-offset-gt-xs=\"5\" layout=\"column\" ng-show=\"vm.showStateMove\"><label class=\"mb-10\">State</label><md-radio-group \nng-model=\"vm.Form.objForm.is_temporary\" name=\"is_temporary\" layout=\"row\" required><md-radio-button value=\"0\"><span \nclass=\"font-size-12\">Permanently Moved</span></md-radio-button><md-radio-button value=\"1\"><span class=\"font-size-12\">\nTemporarily Moved</span></md-radio-button></md-radio-group><div ng-messages=\"worklocationForm.is_temporary.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>State Required.</span></div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-background-bg\"><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-400-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"worklocationForm.$invalid || worklocationForm.$pristine\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/employee/employe/input-employe/worklocation/list-worklocation.html","<md-toolbar md-theme=\"table-toolbar-theme\"><div class=\"md-toolbar-tools table-tools white\"><md-menu md-offset=\"0 -7\" \nhide-gt-sm ng-if=\"vm.EmployeeService.status\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-menu\"></md-icon></md-button><md-menu-content\n width=\"2\"><md-menu-item><md-button class=\"md-button md-ink-ripple md-primary\" type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputWorklocation($event)\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"md-font icon-archive material-icons\"></md-icon>Insert</md-button></md-menu-item><md-menu-item><md-button \nclass=\"md-button md-ink-ripple md-warn\" type=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-font icon-archive material-icons\"></md-icon>Delete</md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container><select class=\"black-fg\" name=\"see\" id=\"ss\" ng-change=\"vm.viewData(1)\" \nng-model=\"vm.DataTable.jumDataPerPage\" ng-options=\"val for val in vm.listJum\"></select><span class=\"black-fg\" \ntranslate=\"KPI.LABEL.ENTRIES\">Entries</span></md-input-container><md-button ng-if=\"vm.EmployeeService.status\" \nclass=\"md-green-300-bg md-raised md-primary white-fg\" hide show-gt-sm type=\"button\" aria-label=\"Inert\" \nng-click=\"vm.openInputWorklocation($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>Add</md-button>\n<md-button ng-if=\"vm.EmployeeService.status\" class=\"md-button md-ink-ripple md-warn md-mini\" hide show-gt-sm \ntype=\"button\" aria-label=\"Inert\" ng-click=\"vm.deleteData($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Delete\n</md-button><span flex hide show-gt-sm></span><form ng-submit=\"vm.viewData(1)\" name=\"formSearch\" flex>\n<md-input-container md-no-float class=\"md-block form-search-input\" flex=\"100\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgb(60,66,82)\" hide show-gt-sm></md-icon><input type=\"text\" placeholder=\"Search..\" \nng-model=\"vm.DataTable.searchParam\" id=\"formSearch\"></md-input-container></form></div></md-toolbar><div \nclass=\"white-bg\"><table class=\"simple with-toolbar bordered stripped\" ms-responsive-table id=\"tb-kpi-setting\"><thead>\n<tr><th class=\"secondary-text\" width=\"5%\" ng-if=\"vm.EmployeeService.status\"><div class=\"table-header\"><input \ntype=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.toggleSelectedAll(vm.selectAll)\"></div></th><th \nclass=\"secondary-text\" width=\"3%\"><div class=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.NO\">\n</span></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PAYROLL.MENU.EFFECTIVEDATE\">Effective Date</span></div></th><th class=\"secondary-text\" width=\"30%\"><div \nclass=\"table-header\"><span class=\"column-title\"><span translate=\"KPI.LABEL.LOCATION\"></span></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">State</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description Changed</span></div></th></tr>\n</thead><tbody><tr ng-if=\"vm.EmployeeService.status\" ng-repeat=\"div in vm.DataTable.list\" \nng-dblclick=\"vm.editInputWorklocation($event,div)\"><td class=\"text-center\"><input type=\"checkbox\" \nchecklist-model=\"vm.listDataSelected\" checklist-value=\"div\"></td><td>{{ (vm.DataTable.offset + $index + 1)}}</td><td \nclass=\"text-center\">{{ div.effectiveDate}}</td><td>{{ div.description}}</td><td class=\"text-center\">\n{{ vm.translateTemporary(div.is_temporary, div.placement)}}</td><td><div layout=\"column\" layout-align=\"start start\">\n<span flex=\"nogrow\" ng-if=\"div.description_changed == \'Temporary Assignment\'\" \nclass=\"label font-size-10 md-blue-500-bg ph-5 mb-5\">{{ div.description_changed}}</span> <span flex=\"nogrow\" \nng-if=\"div.description_changed == \'Temporary Assignment Return\'\" class=\"label font-size-10 md-orange-800-bg ph-5 mb-5\">\n{{ div.description_changed}}</span> <span flex=\"nogrow\" ng-if=\"div.description_changed == \'Mapping\'\" \nclass=\"label font-size-10 md-green-600-bg ph-5 mb-5\">{{ div.description_changed}}</span><div class=\"font-size-10\" \nng-if=\"div.date_changed\">{{div.date_changed}}</div><div class=\"font-size-10\" ng-if=\"div.by_changed\">{{div.by_changed}}\n</div></div></td></tr><tr ng-if=\"!vm.EmployeeService.status\" ng-repeat=\"div in vm.DataTable.list\"><td \nclass=\"text-center\">{{ (vm.DataTable.offset + $index + 1)}}</td><td class=\"text-center\">{{ div.effectiveDate}}</td><td>\n{{ div.description}}</td><td class=\"text-center\">{{ vm.translateTemporary(div.is_temporary, div.placement)}}</td><td>\n<div layout=\"column\" layout-align=\"start start\" ng-if=\"div.description_changed\"><span flex=\"nogrow\" \nng-if=\"div.description_changed == \'Temporary Assignment\'\" class=\"label font-size-10 md-blue-500-bg ph-5 mb-5\">\n{{ div.description_changed}}</span> <span flex=\"nogrow\" \nng-if=\"div.description_changed == \'Temporary Assignment Return\'\" class=\"label font-size-10 md-orange-800-bg ph-5 mb-5\">\n{{ div.description_changed}}</span> <span flex=\"nogrow\" ng-if=\"div.description_changed == \'Mapping\'\" \nclass=\"label font-size-10 md-green-600-bg ph-5 mb-5\">{{ div.description_changed}}</span><div class=\"font-size-10\" \nng-if=\"div.date_changed\">{{div.date_changed}}</div><div class=\"font-size-10\" ng-if=\"div.by_changed\">{{div.by_changed}}\n</div></div></td></tr><tr class=\"text-center\" ng-if=\"(vm.DataTable.list | typeOf) == \'undefined\'\"><td \nng-if=\"vm.EmployeeService.status\" colspan=\"6\" class=\"text-center\"><span class=\"font-size-12\">Please Wait</span></td><td\n ng-if=\"!vm.EmployeeService.status\" colspan=\"5\" class=\"text-center\"><span class=\"font-size-12\">Please Wait</span></td>\n</tr><tr class=\"text-center\" ng-if=\"vm.DataTable.list.length <= 0\"><td ng-if=\"vm.EmployeeService.status\" colspan=\"6\" \nclass=\"text-center\"><span class=\"font-size-12\" translate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td><td \nng-if=\"!vm.EmployeeService.status\" colspan=\"5\" class=\"text-center\"><span class=\"font-size-12\" \ntranslate=\"HC_NEWS.TABLE.NO_DATA\">No Data Available</span></td></tr></tbody></table></div><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">{{vm.DataTable.info}}</div><nav \naria-label=\"Page navigation\"><ul class=\"pagination\"><li ng-repeat=\"nav in vm.DataTable.listNav\" \nng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" ng-click=\"vm.viewData(nav.noPage)\">\n{{nav.label}}</a></li></ul></nav></div>");
$templateCache.put("app/main/employee/employe-admin/upload-building/hasil-check-data/hasil-check-data.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>\nCheck Data Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\" class=\"text-center\">No\n</th><th rowspan=\"2\" class=\"text-center\"><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></md-checkbox></span></th><th rowspan=\"2\" \nclass=\"text-center\">NIK</th><th colspan=\"4\" class=\"text-center\">Update</th><th colspan=\"4\" class=\"text-center\">\nLast Update</th><th class=\"text-center\" rowspan=\"2\">Action</th><th class=\"text-center\" rowspan=\"2\">Keterangan</th></tr>\n<tr><th class=\"text-center\">Gedung</th><th class=\"text-center\">Sector</th><th class=\"text-center\">Line</th><th \nclass=\"text-center\">Effective Date</th><th class=\"text-center\">Gedung</th><th class=\"text-center\">Sector</th><th \nclass=\"text-center\">Line</th><th class=\"text-center\">Effective Date</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.listDataUpload\"><td class=\"text-center\">{{$index + 1}}</td><td><md-checkbox class=\"md-secondary\" \nng-model=\"ls.check\" ng-checked=\"vm.exists(ls, vm.selected)\" ng-click=\"vm.toggle(ls, vm.selected)\" \nstyle=\"margin: 0 !important\" ng-disabled=\"ls.line == ls.data_sebelumnya.line_id || ls.isCover != 1\"></md-checkbox></td>\n<td>{{ls.nik}}</td><td>{{ls.dataUpdate.gedung_name}}</td><td>{{ls.dataUpdate.sector_name}}</td><td>\n{{ls.dataUpdate.line_number}}</td><td>{{ls.effective}}</td><td>{{ls.data_sebelumnya.gedung_name}}</td><td>\n{{ls.data_sebelumnya.sector_name}}</td><td>{{ls.data_sebelumnya.line_number}}</td><td>\n{{ls.data_sebelumnya.effective_date}}</td><td class=\"text-center\">{{ls.action}}</td><td class=\"text-center\"><span \nng-if=\"ls.isCover != 1\">Employee is not coverage</span></td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.updateAll()\" class=\"md-primary md-hue-1\" ng-disabled=\"vm.selected.length==0\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-content-save-all\"></md-icon><span>Update</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/employe-admin/upload-edit-atasan/hasil-check-data-atasan/hasil-check-data-atasan.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>\nCheck Data Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\" class=\"text-center\">No\n</th><th rowspan=\"2\" class=\"text-center\"><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></md-checkbox></span></th><th rowspan=\"2\" \nclass=\"text-center\">NIK</th><th colspan=\"3\" class=\"text-center\">Update</th><th colspan=\"3\" class=\"text-center\">\nLast Update</th><th class=\"text-center\" rowspan=\"2\">Action</th><th class=\"text-center\" rowspan=\"2\">Keterangan</th></tr>\n<tr><th class=\"text-center\">NIK</th><th class=\"text-center\">NAMA</th><th class=\"text-center\">Effective Date</th><th \nclass=\"text-center\">NIK</th><th class=\"text-center\">NAMA</th><th class=\"text-center\">Effective Date</th></tr></thead>\n<tbody><tr ng-repeat=\"ls in vm.listDataUpload\"><td class=\"text-center\">{{$index + 1}}</td><td><md-checkbox \nclass=\"md-secondary\" ng-checked=\"vm.exists(ls, vm.selected)\" ng-click=\"vm.toggle(ls, vm.selected)\" \nstyle=\"margin: 0 !important\" ng-disabled=\"ls.atasan == ls.data_sebelumnya.direct_report || ls.isCover != 1\">\n</md-checkbox></td><td>{{ls.nik}}</td><td>{{ls.dataUpdate.nik}}</td><td>{{ls.dataUpdate.nama_atasan}}</td><td>\n{{ls.effective}}</td><td>{{ls.data_sebelumnya.direct_report}}</td><td>{{ls.data_sebelumnya.nama_atasan}}</td><td>\n{{ls.data_sebelumnya.effective_date}}</td><td class=\"text-center\">{{ls.action}}</td><td class=\"text-center\"><span \nng-if=\"ls.isCover != 1\">Employee is not coverage</span></td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.updateAll()\" class=\"md-primary md-hue-1\" ng-disabled=\"vm.selected.length==0\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-content-save-all\"></md-icon><span>Update</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employee/employe-admin/upload-edit-group-shift/hasil-check-data-group-shift/hasil-check-data-group-shift.html","<md-dialog aria-label=\"Upload\" md-theme=\"modal-theme\"><md-toolbar flex><div class=\"md-toolbar-tools\"><h2>\nCheck Data Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div layout=\"column\" layout-gt-xs=\"row\" layout-padding><table \nclass=\"simple with-toolbar bordered stripped\" ms-responsive-table><thead><tr><th rowspan=\"2\" class=\"text-center\">No\n</th><th rowspan=\"2\" class=\"text-center\"><span><md-checkbox aria-label=\"Select All\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></md-checkbox></span></th><th rowspan=\"2\" \nclass=\"text-center\">NIK</th><th colspan=\"2\" class=\"text-center\">Update</th><th colspan=\"2\" class=\"text-center\">\nLast Update</th><th class=\"text-center\" rowspan=\"2\">Action</th><th class=\"text-center\" rowspan=\"2\">Keterangan</th></tr>\n<tr><th class=\"text-center\">GROUP SHIFT</th><th class=\"text-center\">Effective Date</th><th class=\"text-center\">\nGROUP SHIFT</th><th class=\"text-center\">Effective Date</th></tr></thead><tbody><tr ng-repeat=\"ls in vm.listDataUpload\">\n<td class=\"text-center\">{{$index + 1}}</td><td><md-checkbox class=\"md-secondary\" ng-model=\"ls.check\" \nng-checked=\"vm.exists(ls, vm.selected)\" ng-click=\"vm.toggle(ls, vm.selected)\" style=\"margin: 0 !important\" \nng-disabled=\"ls.group == ls.data_sebelumnya.group_shift_id || ls.isCover != 1\"></md-checkbox></td><td>{{ls.nik}}</td>\n<td>{{ls.dataUpdate.shift_group_name}}</td><td>{{ls.effective}}</td><td>{{ls.data_sebelumnya.shift_group_name}}</td>\n<td>{{ls.data_sebelumnya.effective_date}}</td><td class=\"text-center\">{{ls.action}}</td><td class=\"text-center\"><span \nng-if=\"ls.isCover != 1\">Employee is not coverage</span></td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.updateAll()\" class=\"md-primary md-hue-1\" ng-disabled=\"vm.selected.length==0\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-content-save-all\"></md-icon><span>Update</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mpp/report/cost/detail/detail.html","<div id=\"mppReportCostDetail\" flex-gt-sm=\"90\" flex=\"100\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\">\n<md-dialog aria-label=\"Input\" flex><md-toolbar flex><div class=\"md-toolbar-tools\"><h4>Cost Details</h4><span flex>\n</span><ms-search-bar style=\"padding:0px\" query=\"vm.search\" debounce=\"300\"></ms-search-bar><md-button \nclass=\"md-icon-button\" style=\"margin-left:0px\" ng-click=\"vm.openNewTab()\"><md-icon md-font-icon=\"icon-open-in-new\" \nstyle=\"color: rgba(0,0,0,0.54) !important\" aria-label=\"open new tab\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" style=\"margin-left:0px\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \nstyle=\"color: rgba(0,0,0,0.54) !important\" aria-label=\"Close dialog\"></md-icon></md-button></div><md-divider>\n</md-divider></md-toolbar><md-progress-linear class=\"costWait\" ng-show=\"vm.isWaiting\" md-mode=\"indeterminate\">\n</md-progress-linear><md-dialog-content style=\"padding-top:0px\" \nng-style=\"{\'min-height\' : \'400px\', \'padding-top\' : \'0px\'}\" layout-padding flex><md-content \nng-style=\"{\'max-height\' : \'400px\', \'padding-top\' : \'0px\'}\" ms-scroll><section ng-show=\"!vm.showMessage\" \nng-class=\"{\'blurify\' : vm.isWaiting, \'no-blurify\' : !vm.isWaiting}\"><table \nclass=\"simple with-toolbar bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table><tr><th \nclass=\"title-header-top\" rowspan=\"2\" style=\"width: 10%\">NIK</th><th class=\"title-header-top\" rowspan=\"2\" \nstyle=\"width: 20%\">NAME</th><th colspan=\"13\" class=\"title-header-top\">COST ELEMENT PER MONTH {{ vm.years - 1 }}</th><th\n colspan=\"13\" class=\"title-header-top\">TOTAL COST PER MONTH {{ vm.years }}</th><th colspan=\"13\">TOTAL COST PER MONTH\n</th><th class=\"title-header-top\" colspan=\"14\">TOTAL COST PER YEAR</th></tr><tr><th class=\"title-header-top\">\nBeban Gaji & Upah</th><th class=\"title-header-top\">Beban Upah Harian</th><th class=\"title-header-top\">\nTunjangan Karyawan</th><th class=\"title-header-top\">Tunjangan Hari Raya</th><th class=\"title-header-top\">Bonus</th><th \nclass=\"title-header-top\">Lembur</th><th class=\"title-header-top\">Pesangon Karyawan</th><th class=\"title-header-top\">\nTunjangan Lainnya</th><th class=\"title-header-top\">Beban Pengobatan</th><th class=\"title-header-top\">Beban Jamsostek\n</th><th class=\"title-header-top\">Beban Sewa Kendaraan</th><th class=\"title-header-top\">Pajak</th><th \nclass=\"title-header-top\">General Increament</th><th class=\"title-header-top\">Beban Gaji & Upah</th><th \nclass=\"title-header-top\">Beban Upah Harian</th><th class=\"title-header-top\">Tunjangan Karyawan</th><th \nclass=\"title-header-top\">Tunjangan Hari Raya</th><th class=\"title-header-top\">Bonus</th><th class=\"title-header-top\">\nLembur</th><th class=\"title-header-top\">Pesangon Karyawan</th><th class=\"title-header-top\">Tunjangan Lainnya</th><th \nclass=\"title-header-top\">Beban Pengobatan</th><th class=\"title-header-top\">Beban Jamsostek</th><th \nclass=\"title-header-top\">Beban Sewa Kendaraan</th><th class=\"title-header-top\">Pajak</th><th class=\"title-header-top\">\nGeneral Increament</th><th class=\"month-title\">Dec {{ vm.years - 1 }}</th><th class=\"month-title\">Jan</th><th \nclass=\"month-title\">Feb</th><th class=\"month-title\">Mar</th><th class=\"month-title\">Apr</th><th class=\"month-title\">May\n</th><th class=\"month-title\">Jun</th><th class=\"month-title\">Jul</th><th class=\"month-title\">Aug</th><th \nclass=\"month-title\">Sep</th><th class=\"month-title\">Oct</th><th class=\"month-title\">Nov</th><th class=\"month-title\">Dec\n</th><th class=\"title-header-top\">Beban Gaji & Upah</th><th class=\"title-header-top\">Beban Upah Harian</th><th \nclass=\"title-header-top\">Tunjangan Karyawan</th><th class=\"title-header-top\">Tunjangan Hari Raya</th><th \nclass=\"title-header-top\">Bonus</th><th class=\"title-header-top\">Lembur</th><th class=\"title-header-top\">\nPesangon Karyawan</th><th class=\"title-header-top\">Tunjangan Lainnya</th><th class=\"title-header-top\">Beban Pengobatan\n</th><th class=\"title-header-top\">Beban Jamsostek</th><th class=\"title-header-top\">Beban Sewa Kendaraan</th><th \nclass=\"title-header-top\">Pajak</th><th class=\"title-header-top\">Total</th><th class=\"title-header-top\">\nGeneral Increament</th></tr><tr ng-repeat=\"item in vm.listReport | filter:vm.search\"><td class=\"text-left\">\n{{ item.nik }}</td><td class=\"text-left\">{{ item.fullname }}</td><td class=\"text-right\">\n{{ item.gaji_pokok_base | roundedMoney }}</td><td class=\"text-right\">0</td><td class=\"text-right\">\n{{ item.tunjangan_base | roundedMoney }}</td><td class=\"text-right\">{{ item.thr_base | roundedMoney }}</td><td \nclass=\"text-right\">{{ item.bonus_base | roundedMoney }}</td><td class=\"text-right\">\n{{ item.lembur_base | roundedMoney }}</td><td class=\"text-right\">0</td><td class=\"text-right\">\n{{ item.tunjangan_lain_base | roundedMoney }}</td><td class=\"text-right\">{{ item.bpjs_kesehatan_base | roundedMoney }}\n</td><td class=\"text-right\">{{ item.jamsostek_base | roundedMoney }}</td><td class=\"text-right\">\n{{ item.tunjangan_cop_base | roundedMoney }}</td><td class=\"text-right\">{{ item.pajak_base | roundedMoney }}</td><td \nclass=\"text-right\">{{ item.general_increament_base | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'gajiPokok\') | roundedMoney }}</td><td class=\"text-right\">0</td><td \nclass=\"text-right\">{{ vm.getDataFromObj(item.listCost, \'tunjangan\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'thr\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'bonus\') | roundedMoney }}</td><td class=\"text-right\">0</td><td class=\"text-right\">\n0</td><td class=\"text-right\">{{ vm.getDataFromObj(item.listCost, \'tunjanganLain\') | roundedMoney }}</td><td \nclass=\"text-right\">{{ vm.getDataFromObj(item.listCost, \'bpjsKesehatan\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'jamsostek\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'tunjanganCop\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'pajak\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'generalIncreament\') | roundedMoney }}</td><td class=\"text-right\">\n{{ item.total_base | roundedMoney }}</td><td class=\"text-right\" ng-repeat=\"val in item.listCost\">\n{{ val.totalCost | roundedMoney }}</td><td class=\"text-right\">{{ item.gaji_pokok | roundedMoney }}</td><td \nclass=\"text-right\">0</td><td class=\"text-right\">{{ item.tunjangan | roundedMoney }}</td><td class=\"text-right\">\n{{ item.thr | roundedMoney }}</td><td class=\"text-right\">{{ item.bonus | roundedMoney }}</td><td class=\"text-right\">\n{{ item.lembur | roundedMoney }}</td><td class=\"text-right\">0</td><td class=\"text-right\">\n{{ item.tunjangan_lain | roundedMoney }}</td><td class=\"text-right\">{{ item.bpjs_kesehatan | roundedMoney }}</td><td \nclass=\"text-right\">{{ item.jamsostek | roundedMoney }}</td><td class=\"text-right\">\n{{ item.tunjangan_cop | roundedMoney }}</td><td class=\"text-right\">{{ item.pajak | roundedMoney }}</td><td \nclass=\"text-right\">{{ item.totalCost | roundedMoney }}</td><td class=\"text-right\">\n{{ item.general_increament | roundedMoney }}</td></tr></table></section><section class=\"animate\" \nng-if=\"vm.showMessage\"><h4>Failed Load Content</h4></section></md-content><md-divider></md-divider></md-dialog-content>\n</md-dialog></div>");
$templateCache.put("app/main/mtx/master/mtx-category/uploadfile/uploadfile-log-fail.html","<md-dialog aria-label=\"Form Upload File Checklist Attendance\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Log</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"\">NIK</th><th class=\"text-center\">Note</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.logFail\"><td class=\"text-left\">{{ls.nik}}</td><td class=\"text-left\">{{ls.note}}</td></tr></tbody>\n</table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mtx/master/mtx-category/uploadfile/uploadfile.html","<md-dialog aria-label=\"Form Upload Employee Map Category\" flex-md=\"60\" flex-gt-md=\"50\" md-theme=\"modal-theme\"><form \nng-cloack name=\"uploadFile\" class=\"md-inline-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Upload Employee Map Category</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><input type=\"file\" \nid=\"uploadFile\" nv-file-select uploader=\"vm.FileUploader\"></div></div><md-progress-linear \nng-if=\"vm.FileUploader.progress\" md-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\">\n</md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.uploadError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>{{vm.pesan}}</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.uploadSuccess\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>{{vm.pesan}}</span>\n</md-whiteframe><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" style=\"padding:3px\">\n<span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" \nng-click=\"vm.viewMoreInfo()\" class=\"md-primary\" aria-label=\"More Info\"><span>More Info</span></md-button><md-button \nclass=\"md-accent\" ng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"button\" \nng-click=\"vm.FileUploader.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload&nbsp;</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mtx/master/mtx-import-emp-assestment/export-data/export-data.html","<md-dialog aria-label=\"Import Data Source\" style=\"max-width: 30% !important\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>Import Data Source</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div flex=\"100\" flex-gt-xs=\"100\" \nflex-gt-md=\"100\" style=\"margin: 1vh\" layout-gt-sm=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex style=\"margin: 0px; margin-bottom: 1vh;display: flex\" \nclass=\"md-input-has-placeholder\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nstyle=\"float: right;margin-left: auto\" ng-click=\"vm.ExportDataExcel()\">Export</md-button></md-input-container></div>\n</md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mtx/master/mtx-import-emp-assestment/uploadfile/uploadfile-log-fail.html","<md-dialog aria-label=\"Form Upload File Checklist Attendance\" flex=\"80\" md-theme=\"modal-theme\"><md-toolbar \nclass=\"md-cyan-600-bg has-toolbar\"><div class=\"md-toolbar-tools\"><h2>Log</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" \nng-show=\"vm.saveProcess\"></md-progress-linear><md-dialog-content><table class=\"simple with-toolbar bordered stripped\" \nms-responsive-table><thead><tr><th class=\"\">NIK</th><th class=\"text-center\">Note</th></tr></thead><tbody><tr \nng-repeat=\"ls in vm.logFail\"><td class=\"text-left\">{{ls.nik}}</td><td class=\"text-left\">{{ls.note}}</td></tr></tbody>\n</table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mtx/master/mtx-import-emp-assestment/uploadfile/uploadfile.html","<md-dialog aria-label=\"Form Upload Employee Map Category\" flex-md=\"60\" flex-gt-md=\"50\" md-theme=\"modal-theme\"><form \nng-cloack name=\"uploadFile\" class=\"md-inline-form\"><md-toolbar class=\"md-cyan-600-bg has-toolbar\"><div \nclass=\"md-toolbar-tools\"><h2>Upload Employee Assesment</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-background-bg\" id=\"contentDialog\"><md-content layout=\"column\"><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"margin-bottom: 15px\"><div flex><input type=\"file\" \nid=\"uploadFile\" nv-file-select uploader=\"vm.FileUploader\"></div></div><md-progress-linear \nng-if=\"vm.FileUploader.progress\" md-mode=\"determinate\" value=\"{{vm.FileUploader.progress}}\" class=\"md-accent hue-2\">\n</md-progress-linear><md-whiteframe class=\"md-whiteframe-1dp md-red-500-bg\" ng-show=\"vm.uploadError\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>{{vm.pesan}}</span>\n</md-whiteframe><md-whiteframe ng-show=\"vm.uploadSuccess\" class=\"md-whiteframe-1dp md-green-600-bg\" \nstyle=\"margin-top:20px\" flex layout layout-align=\"center center\" layout-padding><span>{{vm.pesan}}</span>\n</md-whiteframe><div flex><div ng-show=\"vm.uploadError\" flex layout layout-align=\"center center\" style=\"padding:3px\">\n<span style=\"color:red\">{{ vm.uploadNotif }}</span></div><div ng-show=\"vm.uploadSuccess\" flex layout \nlayout-align=\"center center\"><span style=\"color:green\">{{ vm.uploadNotif }}</span></div></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"vm.isMoreInfo\" type=\"button\" \nng-click=\"vm.viewMoreInfo()\" class=\"md-primary\" aria-label=\"More Info\"><span>More Info</span></md-button><md-button \nclass=\"md-accent\" ng-click=\"vm.closeModal()\">Cancel</md-button><md-button type=\"button\" \nng-click=\"vm.FileUploader.uploadAll()\" class=\"md-raised md-teal-500-bg teal-50-fg\" aria-label=\"Submit\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"teal-50-fg\"></md-icon>Upload&nbsp;</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mtx/transaksi/mtx-monitoring-score/export-data/export-data.html","<md-dialog aria-label=\"Import Data Source\" style=\"max-width: 30% !important\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>Import Data Source</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-content layout=\"column\" flex layout-padding layout-fill class=\"white-bg\"><div flex=\"100\" flex-gt-xs=\"100\" \nflex-gt-md=\"100\" style=\"margin: 1vh\" layout-gt-sm=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex style=\"margin: 0px; margin-bottom: 1vh;display: flex\" \nclass=\"md-input-has-placeholder\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nstyle=\"float: right;margin-left: auto\" ng-click=\"vm.ExportDataExcel()\">Export</md-button></md-input-container></div>\n</md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mpn/request/views/steps/step-budget-type.html","<div class=\"md-horizontal-form\"><p>Please <span class=\"text-bold\">ensure</span> with your sign MPP budgeting type</p>\n<div layout=\"column\" layout-gt-xs=\"row\" flex><div flex=\"1\"><md-radio-group ng-model=\"vm.mpnRequest.budget_type\" \nng-change=\"vm.mpnRequest.request_type = null\" required aria-required=\"true\" ng-disabled=\"vm.isDisableBt\">\n<md-radio-button value=\"Budgeted\">Budgeted ( Man Power Planning has signed by CEO / Replacement )</md-radio-button>\n<md-radio-button value=\"Unbudgeted\">Unbudgeted ( Man Power Planning has not signed by CEO )</md-radio-button>\n</md-radio-group></div></div></div>");
$templateCache.put("app/main/mpn/request/views/steps/step-grade-work-location.edit.html","<div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex-gt-xs=\"50\">\n<label>Grade Category</label><md-select ng-model=\"vm.mpnRequest.grade_category\" \nng-change=\"vm.mpnRequest.is_need_approval_grade = false;vm.is_grade_visible = false; vm.mpnRequest.is_manufacturing = false; vm.mpnRequest.is_production = false;vm.getGrade();\" \nname=\"grade_category\" placeholder=\"Grade Category\"><md-optgroup label=\"{{key}}\" \nng-repeat=\"(key, value) in vm.grade_category | groupBy: \'group\'\"><md-option ng-value=\"item\" ng-repeat=\"item in value\">\n{{item.description}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex class=\"pt-20\"><md-input-container class=\"md-block\" flex-gt-xs=\"50\"><label>\n{{ vm.mpnRequest.grade_category.is_need_experience ? \'Experience\' : \'Grade\' }}</label><md-select \nng-model=\"vm.mpnRequest.grade\" name=\"emp_grade\" \nplaceholder=\"{{ vm.mpnRequest.grade_category.is_need_experience ? \'Experience\' : \'Grade\' }}\"><md-option \nng-value=\"item\" ng-repeat=\"item in vm.grades\">\n{{ vm.mpnRequest.grade_category.is_need_experience ? item.range : item.grade}}</md-option></md-select>\n</md-input-container><label style=\"margin-top: 20px;margin-left: 10px\" class=\"md-block\" \nng-if=\"vm.mpnRequest.grade.note != null\" ng-bind-html=\"vm.mpnRequest.grade.note\"></label></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex class=\"pt-20\"><md-input-container class=\"md-block\" flex-gt-xs=\"50\"><label>Business Unit</label>\n<md-select ng-model=\"vm.mpnRequest.bu\" aria-label=\"approval_type\" name=\"bu\" required ng-change=\"vm.getWorkLocations()\">\n<md-option ng-repeat=\"ls in vm.bu\" placeholder=\"Business Unit\" value=\"{{ls.description}}\">{{ls.description}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex class=\"pt-20\">\n<md-input-container class=\"md-block\" flex=\"50\"><label>Work Location</label><md-select \nng-model=\"vm.mpnRequest.work_location\" required md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\"><md-option ng-repeat=\"loc in vm.listLocations\" value=\"{{loc.id}}\">\n{{loc.description}}</md-option></md-select></md-input-container><br><md-input-container class=\"md-block\" flex=\"50\">\n<label>Employment Status</label><md-select ng-model=\"vm.mpnRequest.employment_status\" required \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\"><md-option \nng-repeat=\"e in vm.EmploymentStatus\" value=\"{{e}}\">{{e}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><label style=\"margin-top: 12px;font-size: 16px;font-weight: bold\">\nGrade {{vm.mpnRequest.emp_grade}}</label><label ng-if=\"vm.mpnRequest.is_need_approval_grade\" \nstyle=\"margin-top: 12px;margin-left: 10px;font-size: 16px;font-weight: bold\">\nwill be verified by TM admin for their scope of work</label></div></div>");
$templateCache.put("app/main/mpn/request/views/steps/step-grade-work-location.html","<div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex-gt-xs=\"50\">\n<label>Grade Category</label><md-select ng-model=\"vm.mpnRequest.grade_category\" \nng-change=\"vm.mpnRequest.is_need_approval_grade = false;vm.is_grade_visible = false; vm.mpnRequest.is_manufacturing = false; vm.mpnRequest.is_production = false;vm.getGrade();\" \nname=\"grade_category\" placeholder=\"Grade Category\"><md-optgroup label=\"{{key}}\" \nng-repeat=\"(key, value) in vm.grade_category | groupBy: \'group\'\"><md-option ng-value=\"item\" ng-repeat=\"item in value\">\n{{item.description}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex class=\"pt-20\"><md-input-container class=\"md-block\" flex-gt-xs=\"50\"><label>\n{{ vm.mpnRequest.grade_category.is_need_experience ? \'Experience\' : \'Grade\' }}</label><md-select \nng-model=\"vm.mpnRequest.grade\" name=\"emp_grade\" \nplaceholder=\"{{ vm.mpnRequest.grade_category.is_need_experience ? \'Experience\' : \'Grade\' }}\"><md-option \nng-value=\"item\" ng-repeat=\"item in vm.grades\">\n{{ vm.mpnRequest.grade_category.is_need_experience ? item.range : item.grade}}</md-option></md-select>\n</md-input-container><label style=\"margin-top: 20px;margin-left: 10px\" class=\"md-block\" \nng-if=\"vm.mpnRequest.grade.note != null\" ng-bind-html=\"vm.mpnRequest.grade.note\"></label></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex class=\"pt-20\"><md-input-container class=\"md-block\" flex-gt-xs=\"50\" flex><label>Business Unit\n</label><md-select ng-model=\"vm.mpnRequest.bu\" aria-label=\"approval_type\" name=\"bu\" required \nng-change=\"vm.getWorkLocations()\"><md-option ng-repeat=\"ls in vm.bu\" placeholder=\"Business Unit\" \nvalue=\"{{ls.description}}\">{{ls.description}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex class=\"pt-23\"><md-input-container class=\"md-block\" flex-gt-xs=\"50\" flex><label>Work Location\n</label><md-select ng-model=\"vm.mpnRequest.work_location\" required md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\"><md-option ng-repeat=\"loc in vm.listLocations\" value=\"{{loc.id}}\">\n{{loc.description}}</md-option></md-select></md-input-container><br><md-input-container class=\"md-block\" flex=\"50\" \nclass=\"pt-20\"><label>Employment Status</label><md-select ng-model=\"vm.mpnRequest.employment_status\" required \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\"><md-option \nng-repeat=\"e in vm.EmploymentStatus\" value=\"{{e}}\">{{e}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><label style=\"margin-top: 12px;font-size: 16px;font-weight: bold\">\nGrade {{vm.mpnRequest.emp_grade}}</label><label ng-if=\"vm.mpnRequest.is_need_approval_grade\" \nstyle=\"margin-top: 12px;margin-left: 10px;font-size: 16px;font-weight: bold\">\nwill be verified by TM admin for their scope of work</label></div></div>");
$templateCache.put("app/main/mpn/request/views/steps/step-position-title.html","<div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container class=\"md-block\" flex=\"90\"><label>Division</label>\n<md-select required ng-readonly=\"true\" data-ng-disabled=\"vm.allow_edit_division();\" ng-change=\"vm.loadDept();\" \nng-model=\"vm.mpnRequest.division_id\" md-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\">\n<md-option ng-repeat=\"o in vm.listDivision\" value=\"{{o.id}}\">{{o.description}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"90\"><label>Department</label><md-select required \nng-readonly=\"true\" ng-change=\"vm.loadBu(vm.mpnRequest.department_id)\" ng-model=\"vm.mpnRequest.department_id\" \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\"><md-option \nng-repeat=\"o in vm.listDepartment\" value=\"{{o.id}}\">{{o.description}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"90\"><label>Business Title</label><md-select required \nng-change=\"vm.loadCompetency(vm.mpnRequest.business_title)\" ng-model=\"vm.mpnRequest.business_title\" \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\"><md-option ng-repeat=\"o in vm.listBu\" \nvalue=\"{{o.id}}\">{{o.description}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex ng-if=\"(vm.mpnRequest.business_title == 0)\"><md-input-container class=\"md-block\" flex=\"50\">\n<label>Name of a new Business Title</label><input required type=\"text\" step=\"any\" name=\"business_title_new_text\" \nng-model=\"vm.mpnRequest.business_title_new_text\"></md-input-container></div>");
$templateCache.put("app/main/mpn/request/views/steps/step-qualification.html","<div class=\"md-horizontal-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><div class=\"md-inline-form\"><label>\nPreferrable Gender ?</label><md-radio-group ng-model=\"vm.mpnRequest.is_preferrable_gender\" \nng-change=\"vm.mpnRequest.pref_gender = null\" required aria-required=\"true\"><md-radio-button \nstyle=\"margin-right: 25px;margin-left: 25px\" value=\"1\">Yes</md-radio-button><md-radio-button value=\"2\">No\n</md-radio-button></md-radio-group><md-input-container ng-if=\"(vm.mpnRequest.is_preferrable_gender == 1)\" \nclass=\"md-block\" flex=\"50\"><md-radio-group ng-model=\"vm.mpnRequest.pref_gender\" required aria-required=\"true\">\n<md-radio-button value=\"Male\">Male</md-radio-button><md-radio-button value=\"Female\">Female</md-radio-button>\n</md-radio-group></md-input-container></div></div><br><div layout=\"column\" layout-gt-xs=\"row\" flex><div \nclass=\"md-inline-form\"><label>Other Qualification ?</label><md-radio-group ng-model=\"vm.mpnRequest.qualification_type\" \nng-change=\"vm.resetQualification()\" required aria-required=\"true\"><md-radio-button \nstyle=\"margin-right: 25px;margin-left: 25px\" value=\"Experienced\">Yes</md-radio-button><md-radio-button \nvalue=\"Fresh Graduated\">No</md-radio-button></md-radio-group></div></div><div class=\"md-horizontal-form\" \nng-if=\"(vm.mpnRequest.qualification_type == \'Experienced\')\"><p><span class=\"text-bold\">Experience</span></p><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"25\"><input type=\"number\" required \nname=\"age_min\" min=\"17\" max=\"{{vm.mpnRequest.age_max}}\" ng-model=\"vm.mpnRequest.age_min\" placeholder=\"Min Age\"><div \nrole=\"alert\"><span class=\"error\" ng-show=\"horizontalStep7.age_min.$touched && horizontalStep7.age_min.$error.required\">\nRequired!</span> <span class=\"error\" \nng-show=\"horizontalStep7.age_min.$touched && horizontalStep7.age_min.$error.number\">Not valid number!</span> <span \nclass=\"error\" ng-show=\"horizontalStep7.age_min.$touched && horizontalStep7.age_min.$error.min\">\nMinimun age is 17 Years Old!</span> <span class=\"error\" \nng-show=\"horizontalStep7.age_min.$touched && horizontalStep7.age_min.$error.max\">Maximun age is 60 Years Old!</span>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"25\"><input type=\"number\" \nng-disabled=\"!horizontalStep7.age_min.$valid\" required name=\"age_max\" min=\"{{vm.mpnRequest.age_min}}\" max=\"60\" \nng-model=\"vm.mpnRequest.age_max\" placeholder=\"Max Age\"><div role=\"alert\"><span class=\"error\" \nng-show=\"horizontalStep7.age_max.$touched && horizontalStep7.age_max.$error.required\">Required!</span> <span \nclass=\"error\" ng-show=\"horizontalStep7.age_max.$touched && horizontalStep7.age_max.$error.number\">Not valid number!\n</span> <span class=\"error\" ng-show=\"horizontalStep7.age_max.$touched && horizontalStep7.age_max.$error.min\">\nMinimun age is {{vm.mpnRequest.age_min}} Years Old!</span> <span class=\"error\" \nng-show=\"horizontalStep7.age_max.$touched && horizontalStep7.age_max.$error.max\">Maximun age is 60 Years Old!</span>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-select \nng-model=\"vm.mpnRequest.education\" name=\"education\" required placeholder=\"Education\"><md-option \nng-repeat=\"ed in vm.educations\" value=\"{{ed}}\">{{ed}}</md-option></md-select></md-input-container></div>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\"><input type=\"text\" name=\"majority\" \nng-model=\"vm.mpnRequest.major\" placeholder=\"Major\"></md-input-container></div><div class=\"md-horizontal-form\" \nng-if=\"(vm.mpnRequest.qualification_type == \'Fresh Graduated\')\"><p><span class=\"text-bold\">Fresh Graduated</span></p>\n<div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-select \nng-model=\"vm.mpnRequest.education\" name=\"education\" required placeholder=\"Education\"><md-option \nng-repeat=\"ed in vm.educations\" value=\"{{ed}}\">{{ed}}</md-option></md-select></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" required name=\"majority\" ng-model=\"vm.mpnRequest.major\" \nplaceholder=\"Major\"></md-input-container></div></div><md-input-container class=\"md-block\"><label>Notes (if any)</label>\n<br><br><textarea name=\"qualification_note\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.mpnRequest.qualification_note\" \nmd-maxlength=\"200\" max-rows=\"5\"></textarea><div ng-messages=\"horizontalStep7.qualification_note.$error\" \nng-show=\"horizontalStep7.qualification_note.$touched\" role=\"alert\"></div></md-input-container></div>");
$templateCache.put("app/main/mpn/request/views/steps/step-quantity.html","<style>\n.md-input-container {\n        margin-top: 0px;\n        margin-bottom: 10px;\n    }\n    \n    #item {\n        margin-top: 20px;\n    }\n</style><div class=\"md-inline-form\"><fieldset id=\"fieldset\"><legend>Please Input the name of Incumbent (to be replaced)\n</legend><div ng-if=\"!vm.hide_grade()\" id=\"item\" layout=\"column\" layout-gt-xs=\"row\" flex \nng-repeat=\"n in [] | range:vm.mpnRequest.quantity_replacement track by $index\"><p><b>{{n + 1}})</b></p>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Replacement Type</label><md-select name=\"reason\" \nplacholder=\"Replacement Type\" ng-model=\"vm.mpnRequest.mpn_replacement[$index].replacement_type\" required \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\"><md-optgroup label=\"Reason\"><md-option\n value=\"Resign\">Resign</md-option><md-option value=\"End of Contract (Voluntary)\">End of Contract (Voluntary)\n</md-option><md-option value=\"End of Contract (Non Voluntary)\">End of Contract (Non Voluntary)</md-option><md-option \nvalue=\"Dismissal / Head Count Reduction\">Dismissal / Head Count Reduction</md-option><md-option \nvalue=\"Low Performance\">Low Performance</md-option><md-option value=\"Transfer / Demotion / Promotion\">\nTransfer / Demotion / Promotion</md-option><md-option value=\"Termination\">Termination</md-option><md-option \nvalue=\"Pass Away\">Pass Away</md-option><md-option value=\"Exit Without Notice\">Exit Without Notice</md-option><md-option\n value=\"Retire\">Retire</md-option><md-option value=\"Long Personal Leave\">Long Personal Leave</md-option><md-option \nvalue=\"Divesture\">Divesture</md-option></md-optgroup></md-select></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><md-autocomplete md-no-cache=\"true\" \nmd-search-text-change=\"vm.replacement_type = vm.mpnRequest.mpn_replacement[$index].replacement_type\" \nng-disabled=\"vm.mpnRequest.mpn_replacement[$index].replacement_type == null || vm.mpnRequest.mpn_replacement[$index].replacement_type == \'\'\" \nrequired md-selected-item=\"vm.mpnRequest.mpn_replacement[$index].employee\" \nmd-search-text=\"vm.mpnRequest.mpn_replacement[$index].searchText\" \nmd-items=\"item in vm.querySearch(vm.mpnRequest.mpn_replacement[$index].searchText, $index)\" \nmd-item-text=\"item.description\" md-delay=\"300\" md-floating-label=\"Search Employee\"><div layout=\"row\" class=\"item\"><span\n md-highlight-text=\"vm.mpnRequest.mpn_replacement[$index].searchText\">{{item.description}}</span></div>\n</md-autocomplete><div style=\"opacity: 1; margin-top: -34px;font-size: 11px\">\nType 3 character to search employee, example: jon</div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Current Position</label><input type=\"text\" required name=\"position\" \nng-model=\"vm.mpnRequest.mpn_replacement[$index].employee.position\" ng-readonly=\"true\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Effective Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"effective_date\" ng-model=\"vm.mpnRequest.mpn_replacement[$index].effective_date\" required></md-datepicker>\n</md-input-container></div></fieldset></div>");
$templateCache.put("app/main/mpn/request/views/steps/step-reason.html","<div class=\"md-horizontal-form\"><p>Please <span class=\"text-bold\">ensure</span> with your sign MPP</p><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><div layout=\"column\" flex=\"40\" style=\"max-width: 315px\"><label><b>Replacement\n</b></label><br><label>(Mandatory to fill incumbent name details)</label><br><label style=\"margin-top: 50px\"><b>\nNew Position</b></label></div><div layout=\"column\" flex=\"20\" style=\"max-width: 200px\"><md-input-container><label>\nQuantity of replacement</label><input ng-change=\"vm.hide_grade()\" required type=\"number\" value=\"0\" step=\"any\" \nname=\"quantity_replacement\" ng-model=\"vm.mpnRequest.quantity_replacement\" ng-min=\"0\" max=\"1000\"> Put \"0\" if not needed\n</md-input-container><md-input-container><label>Quantity of new position</label><input required type=\"number\" \nvalue=\"\n                0\" step=\"any\" name=\"quantity_new_position\" ng-model=\"vm.mpnRequest.quantity_new_position\" \nng-min=\"(vm.mpnRequest.quantity_replacement + vm.mpnRequest.quantity_new_position) <= 0 ? 1 : 0\" max=\"1000\">\n Put \"0\" if not needed</md-input-container></div></div></div>");
$templateCache.put("app/main/mpn/request/views/steps/step-responsibilities.html","<div class=\"md-inline-form\"><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex=\"50\" ng-if=\"(vm.mpnRequest.job_code != 0)\"><label>Job Code</label><input required type=\"text\" \nng-readonly=\"true\" name=\"job_code_text\" ng-model=\"vm.mpnRequest.job_code_text\"></md-input-container><md-input-container\n class=\"md-block\" flex=\"50\"><label>Expected Join Date</label><md-datepicker md-hide-icons=\"calendar\" \nname=\"expected_join_date\" ng-model=\"vm.mpnRequest.expected_join_date\" required></md-datepicker></md-input-container>\n</div><br><md-input-container class=\"row\"><div ng-if=\"(vm.mpnRequest.job_code == 0)\"><label>\nShort Job Description / Responsibilities</label><br><br><textarea ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.mpnRequest.mpn_new_jobcode.job_desc\" required max-rows=\"5\"></textarea><div \nng-messages=\"horizontalStep4.mpn_new_jobcode.job_desc.$error\" ng-show=\"horizontalStep4.job_desc.$touched\" role=\"alert\">\n</div></div><div class=\"md-block\" flex=\"100\" ng-if=\"(vm.mpnRequest.job_code > 0)\" style=\"font-size: 12px\"><label>\nShort Job Description / Responsibilities</label><br><br><div ng-bind-html=\"vm.mpnRequest.mpn_new_jobcode.job_desc\">\n</div></div></md-input-container><md-input-container class=\"row\" ng-if=\"(vm.mpnRequest.job_code > 0)\"><label>\nAdditional Job Description / Responsibilities</label><br><br><textarea ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.mpnRequest.job_desc\" max-rows=\"5\"></textarea><div ng-messages=\"horizontalStep4.job_desc.$error\" \nng-show=\"horizontalStep4.job_desc.$touched\" role=\"alert\"></div></md-input-container><md-input-container class=\"row\">\n<div ng-if=\"(vm.mpnRequest.job_code == 0)\"><label>Functional Competencies</label><br><br><textarea \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.mpnRequest.mpn_new_jobcode.job_func\" required max-rows=\"5\"></textarea><div \nng-messages=\"horizontalStep4.mpn_new_jobcode.job_func.$error\" ng-show=\"horizontalStep4.job_func.$touched\" role=\"alert\">\n</div></div><div ng-if=\"(vm.mpnRequest.job_code > 0)\" style=\"font-size: 12px\"><label>Functional Competencies</label>\n<br><br><div class=\"md-block\" flex=\"100\" ng-bind-html=\"vm.mpnRequest.mpn_new_jobcode.job_func\"></div></div>\n</md-input-container><md-input-container class=\"row\"><label>KPI 3 Months Probation</label><br><br><textarea \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.mpnRequest.job_func\" max-rows=\"5\" name=\"job_func\" required></textarea><div \nng-messages=\"horizontalStep4.job_func.$error\" ng-show=\"horizontalStep4.job_func.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/pms/behaviour-performance-team/set-behaviour/input-behaviour/input-behaviour.html","<md-dialog aria-label=\"{{vm.title}} Behaviour Performance\" flex=\"80\" id=\"formBehivorPerformance\"><form ng-cloak \nname=\"formPerformance\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveData($event,formPerformance)\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>{{vm.title}} Behaviour Performance / {{vm.resultDateAlias}} / {{vm.nik}}</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content scroll-glue-right><div layout=\"row\" flex=\"100\" layout-padding layout-xs=\"column\"><div flex=\"50\" \nflex-xs=\"100\"><div layout=\"column\" ng-repeat=\"ref in vm.Form.objForm.list\"><div layout=\"row\"><md-input-container \nflex=\"70\"><div class=\"title\"><b>{{ref.initial}}</b> ({{ref.description}})</div></md-input-container><md-input-container\n flex=\"20\"><md-select ng-model=\"vm.Form.objForm.list[$index].resultN1\" \nng-change=\"vm.showLevelDetail(ref.id, vm.Form.objForm.list[$index].resultN1)\" \nng-click=\"vm.showLevelDetail(ref.id, vm.Form.objForm.list[$index].resultN1)\" ng-required><md-option ng-value=\"l.level\" \nng-repeat=\"l in vm.listInputLevel\" ng-if=\"l.ref_behivor_performance_id === ref.id\">{{l.level}}</md-option></md-select>\n<div ng-messages=\"formPerformance[\'result\'+ref.id].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nResult {{ref.initial}} is required.</span></div></div></md-input-container><md-input-container flex=\"20\"><input \ntype=\"number\" name=\"resultEmp{{$index}}\" ng-disabled=\" true\" ng-model=\"vm.Form.objForm.list[$index].result\" \nplaceholder=\"Result N-1\" required></md-input-container></div><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></div></div><span \nflex></span><div flex=\"50\" flex-xs=\"100\"><div layout=\"column\"><table class=\"simple\"><thead><tr><th>Behavior</th><th>\nLevel</th><th>Description</th></tr></thead><tbody style=\"height: 200px; overflow-y: scroll\"><tr \nng-repeat=\"ld in vm.listInputLevel\"><td \nclass=\"text-center lists-level-details lists-level-details-{{ld.ref_behivor_performance_id + \'\' + ld.level}}\">\n{{ld.initial}}</td><td \nclass=\"text-center lists-level-details lists-level-details-{{ld.ref_behivor_performance_id + \'\' + ld.level}}\">\n{{ld.level}}</td><td class=\"lists-level-details lists-level-details-{{ld.ref_behivor_performance_id + \'\' + ld.level}}\">\n{{ld.description}}</td></tr></tbody></table></div></div></div><ms-widget flippable=\"false\" layout=\"column\" \nlayout-align=\"center start\" ng-show=\"vm.Form.tampilPesan\" class=\"fade\"><ms-widget-front \nclass=\"p-7 {{vm.messageTheme}}-500-bg ms-widget-front white-fg\"><p class=\"form-messages\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon>{{vm.Form.pesan}}</p></ms-widget-front></ms-widget></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"blue-500-bg md-raised white-fg\" \nng-disabled=\"formPerformance.$invalid\" type=\"submit\"><md-icon md-font-icon=\"icon-content-save white-fg\"></md-icon>Save\n</md-button><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.setToken()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>Reload Token</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/report/mpp/cost/detail/detail.html","<div id=\"costReportDetail\"><md-toolbar class=\"mt-10\"><div class=\"md-toolbar-tools table-tools\"><span flex hide \nshow-gt-sm></span><ms-search-bar style=\"padding:0px\" query=\"vm.search\" debounce=\"300\"></ms-search-bar></div>\n</md-toolbar><table class=\"simple with-toolbar bordered stripped\" cellpadding=\"0\" cellspacing=\"0\" ms-responsive-table>\n<tr><th class=\"title-header-top\" rowspan=\"2\" style=\"width: 10%\">NIK</th><th class=\"title-header-top\" rowspan=\"2\" \nstyle=\"width: 20%\">NAME</th><th colspan=\"13\" class=\"title-header-top\">COST ELEMENT PER MONTH {{ vm.years - 1 }}</th><th\n colspan=\"13\" class=\"title-header-top\">TOTAL COST PER MONTH {{ vm.years }}</th><th colspan=\"13\">TOTAL COST PER MONTH\n</th><th class=\"title-header-top\" colspan=\"14\">TOTAL COST PER YEAR</th></tr><tr><th class=\"title-header-top\">\nBeban Gaji & Upah</th><th class=\"title-header-top\">Beban Upah Harian</th><th class=\"title-header-top\">\nTunjangan Karyawan</th><th class=\"title-header-top\">Tunjangan Hari Raya</th><th class=\"title-header-top\">Bonus</th><th \nclass=\"title-header-top\">Lembur</th><th class=\"title-header-top\">Pesangon Karyawan</th><th class=\"title-header-top\">\nTunjangan Lainnya</th><th class=\"title-header-top\">Beban Pengobatan</th><th class=\"title-header-top\">Beban Jamsostek\n</th><th class=\"title-header-top\">Beban Sewa Kendaraan</th><th class=\"title-header-top\">Pajak</th><th \nclass=\"title-header-top\">General Increament</th><th class=\"title-header-top\">Beban Gaji & Upah</th><th \nclass=\"title-header-top\">Beban Upah Harian</th><th class=\"title-header-top\">Tunjangan Karyawan</th><th \nclass=\"title-header-top\">Tunjangan Hari Raya</th><th class=\"title-header-top\">Bonus</th><th class=\"title-header-top\">\nLembur</th><th class=\"title-header-top\">Pesangon Karyawan</th><th class=\"title-header-top\">Tunjangan Lainnya</th><th \nclass=\"title-header-top\">Beban Pengobatan</th><th class=\"title-header-top\">Beban Jamsostek</th><th \nclass=\"title-header-top\">Beban Sewa Kendaraan</th><th class=\"title-header-top\">Pajak</th><th class=\"title-header-top\">\nGeneral Increament</th><th class=\"month-title\">Dec {{ vm.years - 1 }}</th><th class=\"month-title\">Jan</th><th \nclass=\"month-title\">Feb</th><th class=\"month-title\">Mar</th><th class=\"month-title\">Apr</th><th class=\"month-title\">May\n</th><th class=\"month-title\">Jun</th><th class=\"month-title\">Jul</th><th class=\"month-title\">Aug</th><th \nclass=\"month-title\">Sep</th><th class=\"month-title\">Oct</th><th class=\"month-title\">Nov</th><th class=\"month-title\">Dec\n</th><th class=\"title-header-top\">Beban Gaji & Upah</th><th class=\"title-header-top\">Beban Upah Harian</th><th \nclass=\"title-header-top\">Tunjangan Karyawan</th><th class=\"title-header-top\">Tunjangan Hari Raya</th><th \nclass=\"title-header-top\">Bonus</th><th class=\"title-header-top\">Lembur</th><th class=\"title-header-top\">\nPesangon Karyawan</th><th class=\"title-header-top\">Tunjangan Lainnya</th><th class=\"title-header-top\">Beban Pengobatan\n</th><th class=\"title-header-top\">Beban Jamsostek</th><th class=\"title-header-top\">Beban Sewa Kendaraan</th><th \nclass=\"title-header-top\">Pajak</th><th class=\"title-header-top\">Total</th><th class=\"title-header-top\">\nGeneral Increament</th></tr><tr ng-repeat=\"item in vm.listReport | filter:vm.search\"><td class=\"text-left\">\n{{ item.nik }}</td><td class=\"text-left\">{{ item.fullname }}</td><td class=\"text-right\">\n{{ item.gaji_pokok_base | roundedMoney }}</td><td class=\"text-right\">0</td><td class=\"text-right\">\n{{ item.tunjangan_base | roundedMoney }}</td><td class=\"text-right\">{{ item.thr_base | roundedMoney }}</td><td \nclass=\"text-right\">{{ item.bonus_base | roundedMoney }}</td><td class=\"text-right\">\n{{ item.lembur_base | roundedMoney }}</td><td class=\"text-right\">0</td><td class=\"text-right\">\n{{ item.tunjangan_lain_base | roundedMoney }}</td><td class=\"text-right\">{{ item.bpjs_kesehatan_base | roundedMoney }}\n</td><td class=\"text-right\">{{ item.jamsostek_base | roundedMoney }}</td><td class=\"text-right\">\n{{ item.tunjangan_cop_base | roundedMoney }}</td><td class=\"text-right\">{{ item.pajak_base | roundedMoney }}</td><td \nclass=\"text-right\">{{ item.general_increament_base | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'gajiPokok\') | roundedMoney }}</td><td class=\"text-right\">0</td><td \nclass=\"text-right\">{{ vm.getDataFromObj(item.listCost, \'tunjangan\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'thr\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'bonus\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'lembur\') | roundedMoney }}</td><td class=\"text-right\">0</td><td \nclass=\"text-right\">{{ vm.getDataFromObj(item.listCost, \'tunjanganLain\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'bpjsKesehatan\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'jamsostek\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'tunjanganCop\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'pajak\') | roundedMoney }}</td><td class=\"text-right\">\n{{ vm.getDataFromObj(item.listCost, \'generalIncreament\') | roundedMoney }}</td><td class=\"text-right\">\n{{ item.total_base | roundedMoney }}</td><td class=\"text-right\" ng-repeat=\"val in item.listCost\">\n{{ val.totalCost | roundedMoney }}</td><td class=\"text-right\">{{ item.gaji_pokok | roundedMoney }}</td><td \nclass=\"text-right\">0</td><td class=\"text-right\">{{ item.tunjangan | roundedMoney }}</td><td class=\"text-right\">\n{{ item.thr | roundedMoney }}</td><td class=\"text-right\">{{ item.bonus | roundedMoney }}</td><td class=\"text-right\">\n{{ item.bonus | roundedMoney }}</td><td class=\"text-right\">0</td><td class=\"text-right\">\n{{ item.tunjangan_lain | roundedMoney }}</td><td class=\"text-right\">{{ item.bpjs_kesehatan | roundedMoney }}</td><td \nclass=\"text-right\">{{ item.jamsostek | roundedMoney }}</td><td class=\"text-right\">\n{{ item.tunjangan_cop | roundedMoney }}</td><td class=\"text-right\">{{ item.pajak | roundedMoney }}</td><td \nclass=\"text-right\">{{ item.totalCost | roundedMoney }}</td><td class=\"text-right\">\n{{ item.general_increament | roundedMoney }}</td></tr></table></div>");
$templateCache.put("app/main/jic/empjic/add/lookup-atasan/lookup-atasan.html","<md-dialog aria-label=\"Lookup Staf Employee\" flex=\"50\"><form ng-cloak name=\"frmApproval\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.submitApproval($event, frmApproval)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nLookup Employee</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.company\" ng-change=\"vm.loadDataDivision(vm.Form.objForm.company);vm.selectedCange(\'comp\')\" name=\"company\">\n<md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">{{ls.description}}</md-option>\n</md-select><div ng-messages=\"employementForm.company.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany Required.</span></div></div></md-input-container><md-input-container flex flex-offset-gt-xs=\"5\"><label>Divisi\n</label><md-select ng-model=\"vm.divisi\" ng-change=\"vm.loadDataDepartment(vm.divisi,true);vm.selectedCange(\'div\')\" \nname=\"divisi\"><md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" ng-if=\"ls.id!==\'all\'\" \nvalue=\"{{ls.id}}\">{{ls.id}} - {{ls.description}}</md-option></md-select><div \nng-messages=\"employementForm.divisi.$error\" role=\"alert\"><div ng-message=\"required\"><span>Divisi Required.</span></div>\n</div></md-input-container><md-input-container flex flex-offset-gt-xs=\"5\"><label>Department</label><md-select \nng-model=\"vm.department\" name=\"department\" ng-change=\"vm.loadEmployeeData();vm.selectedCange(\'dept\')\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" ng-if=\"ls.id!==\'all\'\" value=\"{{ls.id}}\">\n{{ls.id}} - {{ls.description}}</md-option></md-select><div ng-messages=\"employementForm.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department Required.</span></div></div></md-input-container></div><div \nlayout=\"column\"><div flex-gt-sm=\"100\" flex=\"100\" layout=\"column\"><md-subheader class=\"searchForm\"><md-input-container \nstyle=\"width: 100%\"><label>Search</label><input ng-model=\"vm.searchParam\" ng-keyup=\"vm.loadEmployeeData(1)\">\n</md-input-container></md-subheader><md-content layout=\"column\" layout-gt-xs=\"row\" style=\"max-height:400px\"><md-list \nflex><md-list-item ng-if=\"vm.isLoadingLoadEmployee\"><md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\">\n</md-progress-circular></md-list-item><md-list-item class=\"md-3-line jic-add-list-item-employee\" \nng-repeat-start=\"item in vm.empList\" ng-click=\"vm.selectEmployee(item)\"><div class=\"md-list-item-text\" layout=\"column\">\n<h3>{{ item.nama }} ({{item.nik}})</h3></div><md-button type=\"submit\" class=\"blue-500-bg md-raised white-fg\" \nng-click=\"vm.chooseEmployee(item)\"><md-icon md-font-icon=\"icon-check white-fg\"></md-icon>CHOOSE</md-button>\n</md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content><div style=\"padding: 0em 1em\"><div \nclass=\"is-bottom-nav margin-top-5\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tbl-info\">\n{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\" class=\"white-bg\"><ul class=\"pagination\"><li \nng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>CANCEL</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jic/empjic/add/lookup-employee/lookup-employee.html","<md-dialog aria-label=\"Lookup Staf Employee\" flex=\"50\"><form ng-cloak name=\"frmApproval\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.submitApproval($event, frmApproval)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nLookup Staf Employee</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\"><div flex-gt-sm=\"100\" flex=\"100\" layout=\"column\"><md-subheader \nclass=\"searchForm\"><md-input-container style=\"width: 100%\"><label>Search</label><input \nng-model=\"vm.DataTable.searchParam\" ng-keyup=\"vm.loadEmployeeData(1)\"></md-input-container></md-subheader><md-content \nlayout=\"column\" layout-gt-xs=\"row\" style=\"max-height:400px\"><md-list flex><md-list-item \nng-if=\"vm.isLoadingLoadEmployee\"><md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n</md-list-item><md-list-item class=\"md-3-line jic-add-list-item-employee\" \nng-class=\"{\'md-accent-bg\' : item.nik == vm.nik}\" ng-repeat-start=\"item in vm.DataTable.list\" \nng-click=\"vm.selectEmployee(item)\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ item.fullname }} ({{item.nik}})</h3><h4>{{ item.jabatan_lama }}</h4><p>{{ item.division }}, {{item.emp_subarea}}</p>\n<p>{{ item.emp_grade }}, {{ item.masa_kerja }} - <span>{{ item.status_kerja}}</span></p></div><md-button type=\"submit\" \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.chooseEmployee(item)\"><md-icon md-font-icon=\"icon-check white-fg\">\n</md-icon>CHOOSE</md-button></md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content><div \nstyle=\"padding: 0em 1em\"><div class=\"is-bottom-nav margin-top-5\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\" class=\"white-bg\"><ul class=\"pagination\">\n<li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>CANCEL</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/jic/empjic/add/lookup-layer/lookup-layer.html","<md-dialog aria-label=\"Lookup Staf Employee\" flex=\"50\"><form ng-cloak name=\"frmApproval\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.submitApproval($event, frmApproval)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nLookup Job Title</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Company</label><md-select \nng-model=\"vm.company\" ng-change=\"vm.loadDataDivision(vm.Form.objForm.company);vm.selectedCange(\'comp\')\" name=\"company\" \nng-disabled=\"vm.disable\"><md-option ng-repeat=\"ls in vm.listBU\" placeholder=\"Company\" value=\"{{ls.id}}\">\n{{ls.description}}</md-option></md-select><div ng-messages=\"employementForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Company Required.</span></div></div></md-input-container><md-input-container flex \nflex-offset-gt-xs=\"5\"><label>Divisi</label><md-select ng-model=\"vm.divisi\" \nng-change=\"vm.loadDataDepartment(vm.divisi,true);vm.selectedCange(\'div\')\" name=\"divisi\" ng-disabled=\"vm.disable\">\n<md-option ng-repeat=\"ls in vm.listDivision\" placeholder=\"Divisi\" ng-if=\"ls.id!==\'all\'\" value=\"{{ls.id}}\">\n{{ls.id}} - {{ls.description}}</md-option></md-select><div ng-messages=\"employementForm.divisi.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Divisi Required.</span></div></div></md-input-container><md-input-container flex \nflex-offset-gt-xs=\"5\"><label>Department</label><md-select ng-model=\"vm.department\" name=\"department\" \nng-change=\"vm.loadLayerData();vm.selectedCange(\'dept\')\" ng-disabled=\"vm.disable\"><md-option \nng-repeat=\"ls in vm.listDepartment\" placeholder=\"Department\" ng-if=\"ls.id!==\'all\'\" value=\"{{ls.id}}\">\n{{ls.id}} - {{ls.description}}</md-option></md-select><div ng-messages=\"employementForm.department.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Department Required.</span></div></div></md-input-container>\n<md-input-container><label>Direct Report</label><input ng-model=\"vm.directReport\" ng-keyup=\"vm.loadLayerData(1)\" \nng-disabled=\"vm.disable\"></md-input-container></div><div layout=\"column\"><div flex-gt-sm=\"100\" flex=\"100\" \nlayout=\"column\"><md-subheader class=\"searchForm\"><md-input-container style=\"width: 100%\"><label>Search</label><input \nng-model=\"vm.searchParam\" ng-keyup=\"vm.loadLayerData(1)\"></md-input-container></md-subheader><md-content \nlayout=\"column\" layout-gt-xs=\"row\" style=\"max-height:400px\"><md-list flex><md-list-item \nng-if=\"vm.isLoadingLoadEmployee\"><md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n</md-list-item><md-list-item class=\"md-3-line jic-add-list-item-employee\" ng-repeat-start=\"item in vm.empList\" \nng-click=\"vm.selectEmployee(item)\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.jobTitleName }}</h3><p>\nManpower Target: {{item.fullfilmentType}}</p><p>employee: {{item.employee}}</p></div><md-button type=\"submit\" \nclass=\"blue-500-bg md-raised white-fg\" ng-click=\"vm.chooseEmployee(item)\"><md-icon md-font-icon=\"icon-check white-fg\">\n</md-icon>CHOOSE</md-button></md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content><div \nstyle=\"padding: 0em 1em\"><div class=\"is-bottom-nav margin-top-5\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"tbl-info\">{{vm.DataTable.info}}</div><nav aria-label=\"Page navigation\" class=\"white-bg\"><ul class=\"pagination\">\n<li ng-repeat=\"nav in vm.DataTable.listNav\" ng-class=\"{disabled:(nav.disabled===1)}\" class=\"{{nav.class}}\"><a href=\"\" \nng-click=\"vm.loadData(nav.noPage)\">{{nav.label}}</a></li></ul></nav></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-teal-500-bg md-raised white-fg\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-refresh white-fg\"></md-icon>CANCEL</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-primary-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-primary-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/employee/employe/input-employe/sidenavs/main/main-sidenav.html","<div class=\"ms-navigation\"><div class=\"ms-navigation-node\"><div layout=\"row\" class=\"ms-navigation-item\"><div \nclass=\"md-grey-300-bg\" layout=\"column\"><span class=\"title text-bold p-10\" translate=\"MYPROFILE.HEADER\" flex>My Profile\n</span></div><div class=\"navigation-simple\" layout=\"column\" ng-repeat=\"nav in vm.profileMenu\"><md-button class=\"item\" \nng-class=\"{\'active md-warn-bg\' : nav.link == vm.activeItem}\" ng-click=\"vm.goNav(nav.link)\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"title secondary-text\">{{nav.label | translate}}</span></div></md-button></div>\n</div><div layout=\"row\" class=\"ms-navigation-item mt-15\"><div class=\"md-grey-300-bg\" layout=\"column\"><span \nclass=\"title text-bold p-10\" translate=\"ATTENDANCE.LABEL.EMPLOYEMENT\" flex>EMPLOYEMENT</span></div><div \nclass=\"navigation-simple\" layout=\"column\" ng-repeat=\"nav in vm.employementMenu\"><md-button class=\"item\" \nng-class=\"{\'active md-warn-bg\' : nav.link == vm.activeItem}\" ng-click=\"vm.goNav(nav.link)\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"title secondary-text\">{{nav.label | translate}}</span></div></md-button></div>\n</div></div></div>");
$templateCache.put("app/main/employee/employe/input-employe/sidenavs/main/myprofile-main-sidenav.html","<span><span class=\"title\" translate=\"MYPROFILE.HEADER\"></span><div class=\"navigation-simple\" layout=\"column\" \nng-repeat=\"nav in vm.profileMenu\"><md-button class=\"item\" ng-class=\"{\'active md-warn-bg\' : nav.link == vm.activeItem}\" \nng-click=\"vm.goNav(nav.link)\"><div layout=\"row\" layout-align=\"start center\"><span class=\"title\">\n{{nav.label | translate}}</span></div></md-button></div></span><br><span><span class=\"title\">EMPLOYEMENT</span><div \nclass=\"navigation-simple\" layout=\"column\" ng-repeat=\"nav in vm.employementMenu\"><md-button class=\"item\" \nng-class=\"{\'active md-warn-bg\' : nav.link == vm.activeItem}\" ng-click=\"vm.goNav(nav.link)\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\">{{nav.label | translate}}</span></div></md-button></div></span>");}]);